/**
 * Original data set derived, preconversion, from SimpleMaps {@link https://simplemaps.com/data/us-zips}
 */

import ZipCode from '../models/ZipCode';

export const zipCodes: ZipCode[] = [
  {
    city: 'Adjuntas',
    county_fips: 72001,
    county_fips_all: '72001|72141',
    county: 'Adjuntas',
    county_names_all: 'Adjuntas|Utuado',
    county_weights: '{"72001": 98.74, "72141": 1.26}',
    density: 99.9,
    imprecise: false,
    latitude: 18.18027,
    longitude: -66.75266,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 16669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00601',
  },
  {
    city: 'Aguada',
    county_fips: 72003,
    county_fips_all: '72003',
    county: 'Aguada',
    county_names_all: 'Aguada',
    county_weights: '{"72003": 100}',
    density: 474,
    imprecise: false,
    latitude: 18.36075,
    longitude: -67.17541,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 37233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00602',
  },
  {
    city: 'Aguadilla',
    county_fips: 72005,
    county_fips_all: '72005|72099',
    county: 'Aguadilla',
    county_names_all: 'Aguadilla|Moca',
    county_weights: '{"72005": 99.76, "72099": 0.24}',
    density: 544.6,
    imprecise: false,
    latitude: 18.45744,
    longitude: -67.12225,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 48448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00603',
  },
  {
    city: 'Maricao',
    county_fips: 72093,
    county_fips_all: '72093|72153|72121',
    county: 'Maricao',
    county_names_all: 'Maricao|Yauco|Sabana Grande',
    county_weights: '{"72093": 82.26, "72153": 11.67, "72121": 6.06}',
    density: 45,
    imprecise: false,
    latitude: 18.16585,
    longitude: -66.93716,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 5163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00606',
  },
  {
    city: 'Anasco',
    county_fips: 72011,
    county_fips_all: '72011|72099|72083',
    county: 'Añasco',
    county_names_all: 'Añasco|Moca|Las Marías',
    county_weights: '{"72011": 96.8, "72099": 2.83, "72083": 0.37}',
    density: 263.8,
    imprecise: false,
    latitude: 18.2911,
    longitude: -67.12243,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 25357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00610',
  },
  {
    city: 'Angeles',
    county_fips: 72141,
    county_fips_all: '72141',
    county: 'Utuado',
    county_names_all: 'Utuado',
    county_weights: '{"72141": 100}',
    density: 50.2,
    imprecise: false,
    latitude: 18.27698,
    longitude: -66.80688,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 1383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00611',
  },
  {
    city: 'Arecibo',
    county_fips: 72013,
    county_fips_all: '72013|72065|72017',
    county: 'Arecibo',
    county_names_all: 'Arecibo|Hatillo|Barceloneta',
    county_weights: '{"72013": 98.94, "72065": 0.96, "72017": 0.1}',
    density: 319,
    imprecise: false,
    latitude: 18.41283,
    longitude: -66.7051,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 62908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00612',
  },
  {
    city: 'Bajadero',
    county_fips: 72013,
    county_fips_all: '72013',
    county: 'Arecibo',
    county_names_all: 'Arecibo',
    county_weights: '{"72013": 100}',
    density: 344.7,
    imprecise: false,
    latitude: 18.41878,
    longitude: -66.6679,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 9717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00616',
  },
  {
    city: 'Barceloneta',
    county_fips: 72017,
    county_fips_all: '72017|72054|72013',
    county: 'Barceloneta',
    county_names_all: 'Barceloneta|Florida|Arecibo',
    county_weights: '{"72017": 99.47, "72054": 0.43, "72013": 0.1}',
    density: 475.1,
    imprecise: false,
    latitude: 18.44598,
    longitude: -66.56006,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 22584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00617',
  },
  {
    city: 'Boqueron',
    county_fips: 72023,
    county_fips_all: '72023',
    county: 'Cabo Rojo',
    county_names_all: 'Cabo Rojo',
    county_weights: '{"72023": 100}',
    density: 94.9,
    imprecise: false,
    latitude: 17.98892,
    longitude: -67.1566,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 7664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00622',
  },
  {
    city: 'Cabo Rojo',
    county_fips: 72023,
    county_fips_all: '72023',
    county: 'Cabo Rojo',
    county_names_all: 'Cabo Rojo',
    county_weights: '{"72023": 100}',
    density: 386.2,
    imprecise: false,
    latitude: 18.08429,
    longitude: -67.15336,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 39212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00623',
  },
  {
    city: 'Penuelas',
    county_fips: 72111,
    county_fips_all: '72111|72113',
    county: 'Peñuelas',
    county_names_all: 'Peñuelas|Ponce',
    county_weights: '{"72111": 94.94, "72113": 5.06}',
    density: 173.9,
    imprecise: false,
    latitude: 18.05905,
    longitude: -66.71932,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 21148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00624',
  },
  {
    city: 'Camuy',
    county_fips: 72027,
    county_fips_all: '72027',
    county: 'Camuy',
    county_names_all: 'Camuy',
    county_weights: '{"72027": 100}',
    density: 272.6,
    imprecise: false,
    latitude: 18.41905,
    longitude: -66.86037,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 32734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00627',
  },
  {
    city: 'Castaner',
    county_fips: 72081,
    county_fips_all: '72081|72001',
    county: 'Lares',
    county_names_all: 'Lares|Adjuntas',
    county_weights: '{"72081": 50.63, "72001": 49.37}',
    density: 163.2,
    imprecise: false,
    latitude: 18.1852,
    longitude: -66.83169,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 1321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00631',
  },
  {
    city: 'Sabana Grande',
    county_fips: 72121,
    county_fips_all: '72121|72125|72079',
    county: 'Sabana Grande',
    county_names_all: 'Sabana Grande|San Germán|Lajas',
    county_weights: '{"72121": 94.02, "72125": 4.18, "72079": 1.8}',
    density: 251.5,
    imprecise: false,
    latitude: 18.081,
    longitude: -66.94659,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 22909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00637',
  },
  {
    city: 'Ciales',
    county_fips: 72039,
    county_fips_all: '72039|72107|72091',
    county: 'Ciales',
    county_names_all: 'Ciales|Orocovis|Manatí',
    county_weights: '{"72039": 91.88, "72107": 7.48, "72091": 0.64}',
    density: 93.7,
    imprecise: false,
    latitude: 18.28462,
    longitude: -66.5137,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 17319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00638',
  },
  {
    city: 'Utuado',
    county_fips: 72141,
    county_fips_all: '72141',
    county: 'Utuado',
    county_names_all: 'Utuado',
    county_weights: '{"72141": 100}',
    density: 109.4,
    imprecise: false,
    latitude: 18.26742,
    longitude: -66.70212,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 23831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00641',
  },
  {
    city: 'Dorado',
    county_fips: 72051,
    county_fips_all: '72051|72143',
    county: 'Dorado',
    county_names_all: 'Dorado|Vega Alta',
    county_weights: '{"72051": 97.18, "72143": 2.82}',
    density: 660.2,
    imprecise: false,
    latitude: 18.43251,
    longitude: -66.28429,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 35998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00646',
  },
  {
    city: 'Ensenada',
    county_fips: 72055,
    county_fips_all: '72055|72079',
    county: 'Guánica',
    county_names_all: 'Guánica|Lajas',
    county_weights: '{"72055": 98.2, "72079": 1.8}',
    density: 106.7,
    imprecise: false,
    latitude: 17.96667,
    longitude: -66.94266,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 4369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00647',
  },
  {
    city: 'Florida',
    county_fips: 72054,
    county_fips_all: '72054|72141|72091|72039|72013|72017',
    county: 'Florida',
    county_names_all: 'Florida|Utuado|Manatí|Ciales|Arecibo|Barceloneta',
    county_weights:
      '{"72054": 47.39, "72141": 41.9, "72091": 4.27, "72039": 2.87, "72013": 2.5, "72017": 1.07}',
    density: 160.7,
    imprecise: false,
    latitude: 18.34487,
    longitude: -66.58347,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 13200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00650',
  },
  {
    city: 'Garrochales',
    county_fips: 72013,
    county_fips_all: '72013',
    county: 'Arecibo',
    county_names_all: 'Arecibo',
    county_weights: '{"72013": 100}',
    density: 269.9,
    imprecise: false,
    latitude: 18.45614,
    longitude: -66.60194,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 4504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00652',
  },
  {
    city: 'Guanica',
    county_fips: 72055,
    county_fips_all: '72055|72121',
    county: 'Guánica',
    county_names_all: 'Guánica|Sabana Grande',
    county_weights: '{"72055": 97.5, "72121": 2.5}',
    density: 148.5,
    imprecise: false,
    latitude: 17.99413,
    longitude: -66.90266,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 8495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00653',
  },
  {
    city: 'Guayanilla',
    county_fips: 72059,
    county_fips_all: '72059|72153|72111',
    county: 'Guayanilla',
    county_names_all: 'Guayanilla|Yauco|Peñuelas',
    county_weights: '{"72059": 96.77, "72153": 3.1, "72111": 0.12}',
    density: 159.4,
    imprecise: false,
    latitude: 18.04186,
    longitude: -66.79123,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 17398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00656',
  },
  {
    city: 'Hatillo',
    county_fips: 72065,
    county_fips_all: '72065',
    county: 'Hatillo',
    county_names_all: 'Hatillo',
    county_weights: '{"72065": 100}',
    density: 351,
    imprecise: false,
    latitude: 18.41036,
    longitude: -66.79691,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 37327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00659',
  },
  {
    city: 'Hormigueros',
    county_fips: 72067,
    county_fips_all: '72067',
    county: 'Hormigueros',
    county_names_all: 'Hormigueros',
    county_weights: '{"72067": 100}',
    density: 525.5,
    imprecise: false,
    latitude: 18.13412,
    longitude: -67.11399,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 15405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00660',
  },
  {
    city: 'Isabela',
    county_fips: 72071,
    county_fips_all: '72071',
    county: 'Isabela',
    county_names_all: 'Isabela',
    county_weights: '{"72071": 100}',
    density: 384.4,
    imprecise: false,
    latitude: 18.46622,
    longitude: -67.01508,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 41090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00662',
  },
  {
    city: 'Jayuya',
    county_fips: 72073,
    county_fips_all: '72073|72141',
    county: 'Jayuya',
    county_names_all: 'Jayuya|Utuado',
    county_weights: '{"72073": 94.96, "72141": 5.04}',
    density: 121.9,
    imprecise: false,
    latitude: 18.21064,
    longitude: -66.59066,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 14807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00664',
  },
  {
    city: 'Lajas',
    county_fips: 72079,
    county_fips_all: '72079|72125',
    county: 'Lajas',
    county_names_all: 'Lajas|San Germán',
    county_weights: '{"72079": 98.04, "72125": 1.96}',
    density: 146.2,
    imprecise: false,
    latitude: 18.01246,
    longitude: -67.0417,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 22792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00667',
  },
  {
    city: 'Lares',
    county_fips: 72081,
    county_fips_all: '72081|72141|72083|72131',
    county: 'Lares',
    county_names_all: 'Lares|Utuado|Las Marías|San Sebastián',
    county_weights:
      '{"72081": 93.38, "72141": 3.8, "72083": 2.7, "72131": 0.12}',
    density: 165.1,
    imprecise: false,
    latitude: 18.27019,
    longitude: -66.86727,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 27417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00669',
  },
  {
    city: 'Las Marias',
    county_fips: 72083,
    county_fips_all: '72083|72011|72097|72093',
    county: 'Las Marías',
    county_names_all: 'Las Marías|Añasco|Mayagüez|Maricao',
    county_weights:
      '{"72083": 95.64, "72011": 3.6, "72097": 0.45, "72093": 0.31}',
    density: 70.7,
    imprecise: false,
    latitude: 18.23782,
    longitude: -66.98852,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 8512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00670',
  },
  {
    city: 'Manati',
    county_fips: 72091,
    county_fips_all: '72091|72145',
    county: 'Manatí',
    county_names_all: 'Manatí|Vega Baja',
    county_weights: '{"72091": 99.45, "72145": 0.55}',
    density: 347.4,
    imprecise: false,
    latitude: 18.42229,
    longitude: -66.4891,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 39093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00674',
  },
  {
    city: 'Moca',
    county_fips: 72099,
    county_fips_all: '72099|72003',
    county: 'Moca',
    county_names_all: 'Moca|Aguada',
    county_weights: '{"72099": 99.19, "72003": 0.81}',
    density: 292.2,
    imprecise: false,
    latitude: 18.37897,
    longitude: -67.08098,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 36972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00676',
  },
  {
    city: 'Rincon',
    county_fips: 72117,
    county_fips_all: '72117|72011|72003',
    county: 'Rincón',
    county_names_all: 'Rincón|Añasco|Aguada',
    county_weights: '{"72117": 97.98, "72011": 1.2, "72003": 0.82}',
    density: 410.3,
    imprecise: false,
    latitude: 18.33535,
    longitude: -67.23155,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 15483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00677',
  },
  {
    city: 'Quebradillas',
    county_fips: 72115,
    county_fips_all: '72115|72071|72131',
    county: 'Quebradillas',
    county_names_all: 'Quebradillas|Isabela|San Sebastián',
    county_weights: '{"72115": 77.04, "72071": 17.18, "72131": 5.79}',
    density: 325.9,
    imprecise: false,
    latitude: 18.42949,
    longitude: -66.93016,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 24595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00678',
  },
  {
    city: 'Mayaguez',
    county_fips: 72097,
    county_fips_all: '72097|72125|72011',
    county: 'Mayagüez',
    county_names_all: 'Mayagüez|San Germán|Añasco',
    county_weights: '{"72097": 94.1, "72125": 3.46, "72011": 2.44}',
    density: 256.3,
    imprecise: false,
    latitude: 18.16307,
    longitude: -67.36122,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 42689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00680',
  },
  {
    city: 'Mayaguez',
    county_fips: 72097,
    county_fips_all: '72097|72067',
    county: 'Mayagüez',
    county_names_all: 'Mayagüez|Hormigueros',
    county_weights: '{"72097": 99.83, "72067": 0.17}',
    density: 686,
    imprecise: false,
    latitude: 18.22415,
    longitude: -67.15309,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 28977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00682',
  },
  {
    city: 'San German',
    county_fips: 72125,
    county_fips_all: '72125',
    county: 'San Germán',
    county_names_all: 'San Germán',
    county_weights: '{"72125": 100}',
    density: 231,
    imprecise: false,
    latitude: 18.10926,
    longitude: -67.03803,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 29490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00683',
  },
  {
    city: 'San Sebastian',
    county_fips: 72131,
    county_fips_all: '72131|72071|72099',
    county: 'San Sebastián',
    county_names_all: 'San Sebastián|Isabela|Moca',
    county_weights: '{"72131": 87.74, "72071": 11.31, "72099": 0.95}',
    density: 196.2,
    imprecise: false,
    latitude: 18.33656,
    longitude: -66.97518,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 39988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00685',
  },
  {
    city: 'Morovis',
    county_fips: 72101,
    county_fips_all: '72101',
    county: 'Morovis',
    county_names_all: 'Morovis',
    county_weights: '{"72101": 100}',
    density: 282.1,
    imprecise: false,
    latitude: 18.31707,
    longitude: -66.42029,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 28397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00687',
  },
  {
    city: 'Sabana Hoyos',
    county_fips: 72013,
    county_fips_all: '72013',
    county: 'Arecibo',
    county_names_all: 'Arecibo',
    county_weights: '{"72013": 100}',
    density: 119.1,
    imprecise: false,
    latitude: 18.3807,
    longitude: -66.62496,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 10028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00688',
  },
  {
    city: 'San Antonio',
    county_fips: 72005,
    county_fips_all: '72005',
    county: 'Aguadilla',
    county_names_all: 'Aguadilla',
    county_weights: '{"72005": 100}',
    density: 1002.4,
    imprecise: false,
    latitude: 18.49363,
    longitude: -67.09734,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 5870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00690',
  },
  {
    city: 'Vega Alta',
    county_fips: 72143,
    county_fips_all: '72143|72145',
    county: 'Vega Alta',
    county_names_all: 'Vega Alta|Vega Baja',
    county_weights: '{"72143": 99.87, "72145": 0.13}',
    density: 477.4,
    imprecise: false,
    latitude: 18.40905,
    longitude: -66.33768,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 32802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00692',
  },
  {
    city: 'Vega Baja',
    county_fips: 72145,
    county_fips_all: '72145|72143|72091',
    county: 'Vega Baja',
    county_names_all: 'Vega Baja|Vega Alta|Manatí',
    county_weights: '{"72145": 98.29, "72143": 1.43, "72091": 0.28}',
    density: 481.5,
    imprecise: false,
    latitude: 18.42633,
    longitude: -66.39811,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 55387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00693',
  },
  {
    city: 'Vega Baja',
    county_fips: 72145,
    county_fips_all: '72145',
    county: 'Vega Baja',
    county_names_all: 'Vega Baja',
    county_weights: '{"72145": 100}',
    density: 60.4,
    imprecise: false,
    latitude: 18.48327,
    longitude: -66.39269,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00694',
  },
  {
    city: 'Yauco',
    county_fips: 72153,
    county_fips_all: '72153|72059',
    county: 'Yauco',
    county_names_all: 'Yauco|Guayanilla',
    county_weights: '{"72153": 97.77, "72059": 2.23}',
    density: 200.5,
    imprecise: false,
    latitude: 18.07274,
    longitude: -66.85519,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 32535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00698',
  },
  {
    city: 'Aguas Buenas',
    county_fips: 72007,
    county_fips_all: '72007|72041|72045',
    county: 'Aguas Buenas',
    county_names_all: 'Aguas Buenas|Cidra|Comerío',
    county_weights: '{"72007": 93.06, "72041": 3.61, "72045": 3.33}',
    density: 302,
    imprecise: false,
    latitude: 18.24739,
    longitude: -66.13143,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 24263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00703',
  },
  {
    city: 'Aguirre',
    county_fips: 72123,
    county_fips_all: '72123|72057',
    county: 'Salinas',
    county_names_all: 'Salinas|Guayama',
    county_weights: '{"72123": 97.38, "72057": 2.62}',
    density: 268.5,
    imprecise: false,
    latitude: 17.97442,
    longitude: -66.22888,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 6256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00704',
  },
  {
    city: 'Aibonito',
    county_fips: 72009,
    county_fips_all: '72009|72043',
    county: 'Aibonito',
    county_names_all: 'Aibonito|Coamo',
    county_weights: '{"72009": 97.19, "72043": 2.81}',
    density: 310.8,
    imprecise: false,
    latitude: 18.1294,
    longitude: -66.26653,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 24471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00705',
  },
  {
    city: 'Maunabo',
    county_fips: 72095,
    county_fips_all: '72095',
    county: 'Maunabo',
    county_names_all: 'Maunabo',
    county_weights: '{"72095": 100}',
    density: 190.4,
    imprecise: false,
    latitude: 18.01752,
    longitude: -65.92127,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 10319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00707',
  },
  {
    city: 'Arroyo',
    county_fips: 72015,
    county_fips_all: '72015',
    county: 'Arroyo',
    county_names_all: 'Arroyo',
    county_weights: '{"72015": 100}',
    density: 394.8,
    imprecise: false,
    latitude: 17.9981,
    longitude: -66.05635,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 15341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00714',
  },
  {
    city: 'Mercedita',
    county_fips: 72113,
    county_fips_all: '72113|72075',
    county: 'Ponce',
    county_names_all: 'Ponce|Juana Díaz',
    county_weights: '{"72113": 99.05, "72075": 0.95}',
    density: 63.3,
    imprecise: false,
    latitude: 17.99738,
    longitude: -66.56104,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 2082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00715',
  },
  {
    city: 'Ponce',
    county_fips: 72113,
    county_fips_all: '72113',
    county: 'Ponce',
    county_names_all: 'Ponce',
    county_weights: '{"72113": 100}',
    density: 1244.8,
    imprecise: false,
    latitude: 17.99942,
    longitude: -66.59868,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 27945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00716',
  },
  {
    city: 'Ponce',
    county_fips: 72113,
    county_fips_all: '72113',
    county: 'Ponce',
    county_names_all: 'Ponce',
    county_weights: '{"72113": 100}',
    density: 2372,
    imprecise: false,
    latitude: 18.00272,
    longitude: -66.61146,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 14577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00717',
  },
  {
    city: 'Naguabo',
    county_fips: 72103,
    county_fips_all: '72103|72037',
    county: 'Naguabo',
    county_names_all: 'Naguabo|Ceiba',
    county_weights: '{"72103": 99.88, "72037": 0.12}',
    density: 188.3,
    imprecise: false,
    latitude: 18.23145,
    longitude: -65.76067,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 23026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00718',
  },
  {
    city: 'Naranjito',
    county_fips: 72105,
    county_fips_all: '72105|72047|72045|72135',
    county: 'Naranjito',
    county_names_all: 'Naranjito|Corozal|Comerío|Toa Alta',
    county_weights:
      '{"72105": 96.91, "72047": 2.23, "72045": 0.46, "72135": 0.4}',
    density: 409.7,
    imprecise: false,
    latitude: 18.28879,
    longitude: -66.25316,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 29932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00719',
  },
  {
    city: 'Orocovis',
    county_fips: 72107,
    county_fips_all: '72107|72043',
    county: 'Orocovis',
    county_names_all: 'Orocovis|Coamo',
    county_weights: '{"72107": 99.28, "72043": 0.72}',
    density: 144.7,
    imprecise: false,
    latitude: 18.21559,
    longitude: -66.42421,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 21037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00720',
  },
  {
    city: 'Patillas',
    county_fips: 72109,
    county_fips_all: '72109|72095',
    county: 'Patillas',
    county_names_all: 'Patillas|Maunabo',
    county_weights: '{"72109": 99.5, "72095": 0.5}',
    density: 131.3,
    imprecise: false,
    latitude: 18.03139,
    longitude: -66.01122,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 15643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00723',
  },
  {
    city: 'Caguas',
    county_fips: 72025,
    county_fips_all: '72025|72061|72129|72127|72139|72007',
    county: 'Caguas',
    county_names_all:
      'Caguas|Guaynabo|San Lorenzo|San Juan|Trujillo Alto|Aguas Buenas',
    county_weights:
      '{"72025": 86.58, "72061": 4.45, "72129": 2.77, "72127": 2.23, "72139": 2.07, "72007": 1.9}',
    density: 685.7,
    imprecise: false,
    latitude: 18.22052,
    longitude: -66.03962,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 73462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00725',
  },
  {
    city: 'Caguas',
    county_fips: 72025,
    county_fips_all: '72025',
    county: 'Caguas',
    county_names_all: 'Caguas',
    county_weights: '{"72025": 100}',
    density: 944.4,
    imprecise: false,
    latitude: 18.21142,
    longitude: -66.07374,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 55191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00727',
  },
  {
    city: 'Ponce',
    county_fips: 72113,
    county_fips_all: '72113',
    county: 'Ponce',
    county_names_all: 'Ponce',
    county_weights: '{"72113": 100}',
    density: 916.1,
    imprecise: false,
    latitude: 18.00697,
    longitude: -66.65995,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 36532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00728',
  },
  {
    city: 'Canovanas',
    county_fips: 72029,
    county_fips_all: '72029|72087',
    county: 'Canóvanas',
    county_names_all: 'Canóvanas|Loíza',
    county_weights: '{"72029": 91.45, "72087": 8.55}',
    density: 508.3,
    imprecise: false,
    latitude: 18.33524,
    longitude: -65.88677,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 47067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00729',
  },
  {
    city: 'Ponce',
    county_fips: 72113,
    county_fips_all: '72113',
    county: 'Ponce',
    county_names_all: 'Ponce',
    county_weights: '{"72113": 100}',
    density: 1808,
    imprecise: false,
    latitude: 18.03256,
    longitude: -66.61384,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 31081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00730',
  },
  {
    city: 'Ponce',
    county_fips: 72113,
    county_fips_all: '72113|72001',
    county: 'Ponce',
    county_names_all: 'Ponce|Adjuntas',
    county_weights: '{"72113": 97.11, "72001": 2.89}',
    density: 76.7,
    imprecise: false,
    latitude: 18.09914,
    longitude: -66.63279,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 9724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00731',
  },
  {
    city: 'Ceiba',
    county_fips: 72037,
    county_fips_all: '72037|72103',
    county: 'Ceiba',
    county_names_all: 'Ceiba|Naguabo',
    county_weights: '{"72037": 94.58, "72103": 5.42}',
    density: 154.4,
    imprecise: false,
    latitude: 18.2525,
    longitude: -65.67534,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 10949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00735',
  },
  {
    city: 'Cayey',
    county_fips: 72035,
    county_fips_all: '72035|72041',
    county: 'Cayey',
    county_names_all: 'Cayey|Cidra',
    county_weights: '{"72035": 92.47, "72041": 7.53}',
    density: 318.6,
    imprecise: false,
    latitude: 18.10736,
    longitude: -66.14994,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 45306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00736',
  },
  {
    city: 'Fajardo',
    county_fips: 72053,
    county_fips_all: '72053|72037',
    county: 'Fajardo',
    county_names_all: 'Fajardo|Ceiba',
    county_weights: '{"72053": 99.58, "72037": 0.42}',
    density: 390.8,
    imprecise: false,
    latitude: 18.31793,
    longitude: -65.66793,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 29980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00738',
  },
  {
    city: 'Cidra',
    county_fips: 72041,
    county_fips_all: '72041',
    county: 'Cidra',
    county_names_all: 'Cidra',
    county_weights: '{"72041": 100}',
    density: 433.8,
    imprecise: false,
    latitude: 18.17543,
    longitude: -66.16198,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 34578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00739',
  },
  {
    city: 'Puerto Real',
    county_fips: 72053,
    county_fips_all: '72053',
    county: 'Fajardo',
    county_names_all: 'Fajardo',
    county_weights: '{"72053": 100}',
    density: 1463.9,
    imprecise: false,
    latitude: 18.33251,
    longitude: -65.63419,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 1583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00740',
  },
  {
    city: 'Punta Santiago',
    county_fips: 72069,
    county_fips_all: '72069',
    county: 'Humacao',
    county_names_all: 'Humacao',
    county_weights: '{"72069": 100}',
    density: 630.2,
    imprecise: false,
    latitude: 18.16569,
    longitude: -65.75506,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 3716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00741',
  },
  {
    city: 'Rio Grande',
    county_fips: 72119,
    county_fips_all: '72119|72029',
    county: 'Río Grande',
    county_names_all: 'Río Grande|Canóvanas',
    county_weights: '{"72119": 99.78, "72029": 0.22}',
    density: 297.1,
    imprecise: false,
    latitude: 18.3466,
    longitude: -65.81382,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 46739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00745',
  },
  {
    city: 'Salinas',
    county_fips: 72123,
    county_fips_all: '72123|72035',
    county: 'Salinas',
    county_names_all: 'Salinas|Cayey',
    county_weights: '{"72123": 99.82, "72035": 0.18}',
    density: 123,
    imprecise: false,
    latitude: 18.01205,
    longitude: -66.25871,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 19343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00751',
  },
  {
    city: 'San Lorenzo',
    county_fips: 72129,
    county_fips_all: '72129',
    county: 'San Lorenzo',
    county_names_all: 'San Lorenzo',
    county_weights: '{"72129": 100}',
    density: 283.7,
    imprecise: false,
    latitude: 18.1447,
    longitude: -65.97565,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 36728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00754',
  },
  {
    city: 'Santa Isabel',
    county_fips: 72133,
    county_fips_all: '72133',
    county: 'Santa Isabel',
    county_names_all: 'Santa Isabel',
    county_weights: '{"72133": 100}',
    density: 236.3,
    imprecise: false,
    latitude: 17.9933,
    longitude: -66.39056,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 19853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00757',
  },
  {
    city: 'Vieques',
    county_fips: 72147,
    county_fips_all: '72147',
    county: 'Vieques',
    county_names_all: 'Vieques',
    county_weights: '{"72147": 100}',
    density: 66,
    imprecise: false,
    latitude: 18.12365,
    longitude: -65.43013,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 8078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00765',
  },
  {
    city: 'Villalba',
    county_fips: 72149,
    county_fips_all: '72149|72107|72075',
    county: 'Villalba',
    county_names_all: 'Villalba|Orocovis|Juana Díaz',
    county_weights: '{"72149": 93.28, "72107": 6.49, "72075": 0.23}',
    density: 218.2,
    imprecise: false,
    latitude: 18.13039,
    longitude: -66.4757,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 21572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00766',
  },
  {
    city: 'Yabucoa',
    county_fips: 72151,
    county_fips_all: '72151|72069',
    county: 'Yabucoa',
    county_names_all: 'Yabucoa|Humacao',
    county_weights: '{"72151": 99.33, "72069": 0.67}',
    density: 209.7,
    imprecise: false,
    latitude: 18.07033,
    longitude: -65.89618,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 29962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00767',
  },
  {
    city: 'Coamo',
    county_fips: 72043,
    county_fips_all: '72043|72133',
    county: 'Coamo',
    county_names_all: 'Coamo|Santa Isabel',
    county_weights: '{"72043": 98.05, "72133": 1.95}',
    density: 168.3,
    imprecise: false,
    latitude: 18.09459,
    longitude: -66.3607,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 33602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00769',
  },
  {
    city: 'Las Piedras',
    county_fips: 72085,
    county_fips_all: '72085|72069',
    county: 'Las Piedras',
    county_names_all: 'Las Piedras|Humacao',
    county_weights: '{"72085": 99.0, "72069": 1.0}',
    density: 403.3,
    imprecise: false,
    latitude: 18.18797,
    longitude: -65.86916,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 35094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00771',
  },
  {
    city: 'Loiza',
    county_fips: 72087,
    county_fips_all: '72087',
    county: 'Loíza',
    county_names_all: 'Loíza',
    county_weights: '{"72087": 100}',
    density: 397.6,
    imprecise: false,
    latitude: 18.43048,
    longitude: -65.90377,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 16829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00772',
  },
  {
    city: 'Luquillo',
    county_fips: 72089,
    county_fips_all: '72089',
    county: 'Luquillo',
    county_names_all: 'Luquillo',
    county_weights: '{"72089": 100}',
    density: 280.9,
    imprecise: false,
    latitude: 18.34073,
    longitude: -65.72756,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 17532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00773',
  },
  {
    city: 'Culebra',
    county_fips: 72049,
    county_fips_all: '72049',
    county: 'Culebra',
    county_names_all: 'Culebra',
    county_weights: '{"72049": 100}',
    density: 46,
    imprecise: false,
    latitude: 18.31387,
    longitude: -65.28618,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 1387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00775',
  },
  {
    city: 'Juncos',
    county_fips: 72077,
    county_fips_all: '72077|72129|72085|72029|72063',
    county: 'Juncos',
    county_names_all: 'Juncos|San Lorenzo|Las Piedras|Canóvanas|Gurabo',
    county_weights:
      '{"72077": 98.5, "72129": 0.81, "72085": 0.43, "72029": 0.14, "72063": 0.12}',
    density: 538.4,
    imprecise: false,
    latitude: 18.22365,
    longitude: -65.90904,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 37446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00777',
  },
  {
    city: 'Gurabo',
    county_fips: 72063,
    county_fips_all: '72063|72129',
    county: 'Gurabo',
    county_names_all: 'Gurabo|San Lorenzo',
    county_weights: '{"72063": 94.08, "72129": 5.92}',
    density: 525.8,
    imprecise: false,
    latitude: 18.26319,
    longitude: -65.97938,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 40203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00778',
  },
  {
    city: 'Coto Laurel',
    county_fips: 72113,
    county_fips_all: '72113|72075',
    county: 'Ponce',
    county_names_all: 'Ponce|Juana Díaz',
    county_weights: '{"72113": 97.93, "72075": 2.07}',
    density: 271.3,
    imprecise: false,
    latitude: 18.09998,
    longitude: -66.57032,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 13446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00780',
  },
  {
    city: 'Comerio',
    county_fips: 72045,
    county_fips_all: '72045|72019',
    county: 'Comerío',
    county_names_all: 'Comerío|Barranquitas',
    county_weights: '{"72045": 97.39, "72019": 2.61}',
    density: 250.2,
    imprecise: false,
    latitude: 18.22501,
    longitude: -66.22452,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 18128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00782',
  },
  {
    city: 'Corozal',
    county_fips: 72047,
    county_fips_all: '72047|72019',
    county: 'Corozal',
    county_names_all: 'Corozal|Barranquitas',
    county_weights: '{"72047": 99.06, "72019": 0.94}',
    density: 314.1,
    imprecise: false,
    latitude: 18.30348,
    longitude: -66.32851,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 34259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00783',
  },
  {
    city: 'Guayama',
    county_fips: 72057,
    county_fips_all: '72057|72035|72109',
    county: 'Guayama',
    county_names_all: 'Guayama|Cayey|Patillas',
    county_weights: '{"72057": 97.13, "72035": 1.63, "72109": 1.24}',
    density: 202.4,
    imprecise: false,
    latitude: 18.00558,
    longitude: -66.13651,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 34981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00784',
  },
  {
    city: 'La Plata',
    county_fips: 72009,
    county_fips_all: '72009',
    county: 'Aibonito',
    county_names_all: 'Aibonito',
    county_weights: '{"72009": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 18.1357,
    longitude: -66.22881,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00786',
  },
  {
    city: 'Humacao',
    county_fips: 72069,
    county_fips_all: '72069|72085|72151',
    county: 'Humacao',
    county_names_all: 'Humacao|Las Piedras|Yabucoa',
    county_weights: '{"72069": 97.87, "72085": 1.16, "72151": 0.96}',
    density: 411.6,
    imprecise: false,
    latitude: 18.14391,
    longitude: -65.81398,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 45455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00791',
  },
  {
    city: 'Barranquitas',
    county_fips: 72019,
    county_fips_all: '72019|72043',
    county: 'Barranquitas',
    county_names_all: 'Barranquitas|Coamo',
    county_weights: '{"72019": 96.51, "72043": 3.49}',
    density: 322.5,
    imprecise: false,
    latitude: 18.19934,
    longitude: -66.31179,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 28668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00794',
  },
  {
    city: 'Juana Diaz',
    county_fips: 72075,
    county_fips_all: '72075',
    county: 'Juana Díaz',
    county_names_all: 'Juana Díaz',
    county_weights: '{"72075": 100}',
    density: 280.3,
    imprecise: false,
    latitude: 18.05128,
    longitude: -66.49485,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 43367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00795',
  },
  {
    city: 'St Thomas',
    county_fips: 78030,
    county_fips_all: '78030',
    county: 'St. Thomas',
    county_names_all: 'St. Thomas',
    county_weights: '{"78030": 100}',
    density: null,
    imprecise: false,
    latitude: 18.34349,
    longitude: -64.9287,
    militaryZip: false,
    timezone: 'America/St_Thomas',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VI',
    stateName: 'Virgin Islands',
    zip: '00802',
  },
  {
    city: 'Christiansted',
    county_fips: 78010,
    county_fips_all: '78010',
    county: 'St. Croix',
    county_names_all: 'St. Croix',
    county_weights: '{"78010": 100}',
    density: null,
    imprecise: false,
    latitude: 17.7388,
    longitude: -64.70695,
    militaryZip: false,
    timezone: 'America/St_Thomas',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VI',
    stateName: 'Virgin Islands',
    zip: '00820',
  },
  {
    city: 'St John',
    county_fips: 78020,
    county_fips_all: '78020',
    county: 'St. John',
    county_names_all: 'St. John',
    county_weights: '{"78020": 100}',
    density: null,
    imprecise: false,
    latitude: 18.33857,
    longitude: -64.73802,
    militaryZip: false,
    timezone: 'America/St_Thomas',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VI',
    stateName: 'Virgin Islands',
    zip: '00830',
  },
  {
    city: 'Frederiksted',
    county_fips: 78010,
    county_fips_all: '78010',
    county: 'St. Croix',
    county_names_all: 'St. Croix',
    county_weights: '{"78010": 100}',
    density: null,
    imprecise: false,
    latitude: 17.72649,
    longitude: -64.84717,
    militaryZip: false,
    timezone: 'America/St_Thomas',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VI',
    stateName: 'Virgin Islands',
    zip: '00840',
  },
  {
    city: 'Kingshill',
    county_fips: 78010,
    county_fips_all: '78010',
    county: 'St. Croix',
    county_names_all: 'St. Croix',
    county_weights: '{"78010": 100}',
    density: null,
    imprecise: false,
    latitude: 17.72763,
    longitude: -64.79122,
    militaryZip: false,
    timezone: 'America/St_Thomas',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VI',
    stateName: 'Virgin Islands',
    zip: '00850',
  },
  {
    city: 'Kingshill',
    county_fips: 78010,
    county_fips_all: '78010',
    county: 'St. Croix',
    county_names_all: 'St. Croix',
    county_weights: '{"78010": 100}',
    density: null,
    imprecise: false,
    latitude: 17.74757,
    longitude: -64.78737,
    militaryZip: false,
    timezone: 'America/St_Thomas',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VI',
    stateName: 'Virgin Islands',
    zip: '00851',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"72127": 100}',
    density: 2434.5,
    imprecise: false,
    latitude: 18.46478,
    longitude: -66.10277,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 6398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00901',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"72127": 100}',
    density: 2989,
    imprecise: false,
    latitude: 18.45287,
    longitude: -66.08381,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 15817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00907',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"72127": 100}',
    density: 3331.3,
    imprecise: false,
    latitude: 18.44131,
    longitude: -66.06866,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 5633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00909',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"72127": 100}',
    density: 5920.5,
    imprecise: false,
    latitude: 18.45133,
    longitude: -66.05636,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 7297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00911',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"72127": 100}',
    density: 6085.5,
    imprecise: false,
    latitude: 18.44503,
    longitude: -66.05995,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 5845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00912',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"72127": 100}',
    density: 8274.4,
    imprecise: false,
    latitude: 18.45024,
    longitude: -66.04275,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 6943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00913',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"72127": 100}',
    density: 6777.8,
    imprecise: false,
    latitude: 18.43673,
    longitude: -66.04576,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 24607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00915',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"72127": 100}',
    density: 4840.4,
    imprecise: false,
    latitude: 18.4208,
    longitude: -66.04989,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 17116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00917',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"72127": 100}',
    density: 2314.5,
    imprecise: false,
    latitude: 18.42139,
    longitude: -66.06774,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 16172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00918',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"72127": 100}',
    density: 1700.7,
    imprecise: false,
    latitude: 18.41904,
    longitude: -66.09023,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 15900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00920',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127|72061',
    county: 'San Juan',
    county_names_all: 'San Juan|Guaynabo',
    county_weights: '{"72127": 99.88, "72061": 0.12}',
    density: 4166.8,
    imprecise: false,
    latitude: 18.39206,
    longitude: -66.0871,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 33119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00921',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"72127": 100}',
    density: 4716,
    imprecise: false,
    latitude: 18.41146,
    longitude: -66.03715,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 24551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00923',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127|72031',
    county: 'San Juan',
    county_names_all: 'San Juan|Carolina',
    county_weights: '{"72127": 96.5, "72031": 3.5}',
    density: 4133.4,
    imprecise: false,
    latitude: 18.39987,
    longitude: -66.01344,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 49922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00924',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"72127": 100}',
    density: 4229.1,
    imprecise: false,
    latitude: 18.40028,
    longitude: -66.05058,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 4882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00925',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127|72139|72061',
    county: 'San Juan',
    county_names_all: 'San Juan|Trujillo Alto|Guaynabo',
    county_weights: '{"72127": 83.48, "72139": 15.69, "72061": 0.83}',
    density: 1535,
    imprecise: false,
    latitude: 18.34691,
    longitude: -66.05434,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 92284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00926',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"72127": 100}',
    density: 2210,
    imprecise: false,
    latitude: 18.38884,
    longitude: -66.07149,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 13868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00927',
  },
  {
    city: 'Fort Buchanan',
    county_fips: 72061,
    county_fips_all: '72061|72021',
    county: 'Guaynabo',
    county_names_all: 'Guaynabo|Bayamón',
    county_weights: '{"72061": 69.04, "72021": 30.96}',
    density: 10.3,
    imprecise: false,
    latitude: 18.41372,
    longitude: -66.11998,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00934',
  },
  {
    city: 'Toa Baja',
    county_fips: 72137,
    county_fips_all: '72137|72033|72135',
    county: 'Toa Baja',
    county_names_all: 'Toa Baja|Cataño|Toa Alta',
    county_weights: '{"72137": 96.11, "72033": 2.93, "72135": 0.96}',
    density: 1235.7,
    imprecise: false,
    latitude: 18.43166,
    longitude: -66.21349,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 65867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00949',
  },
  {
    city: 'Toa Baja',
    county_fips: 72051,
    county_fips_all: '72051|72137',
    county: 'Dorado',
    county_names_all: 'Dorado|Toa Baja',
    county_weights: '{"72051": 99.69, "72137": 0.31}',
    density: 0,
    imprecise: false,
    latitude: 18.46201,
    longitude: -66.23917,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00950',
  },
  {
    city: 'Toa Baja',
    county_fips: 72137,
    county_fips_all: '72137',
    county: 'Toa Baja',
    county_names_all: 'Toa Baja',
    county_weights: '{"72137": 100}',
    density: 140.2,
    imprecise: false,
    latitude: 18.43175,
    longitude: -66.25628,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00951',
  },
  {
    city: 'Sabana Seca',
    county_fips: 72137,
    county_fips_all: '72137',
    county: 'Toa Baja',
    county_names_all: 'Toa Baja',
    county_weights: '{"72137": 100}',
    density: 1421.8,
    imprecise: false,
    latitude: 18.42874,
    longitude: -66.18897,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 8165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00952',
  },
  {
    city: 'Toa Alta',
    county_fips: 72135,
    county_fips_all: '72135|72047|72137',
    county: 'Toa Alta',
    county_names_all: 'Toa Alta|Corozal|Toa Baja',
    county_weights: '{"72135": 98.42, "72047": 0.81, "72137": 0.77}',
    density: 957.1,
    imprecise: false,
    latitude: 18.36319,
    longitude: -66.24764,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 66156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00953',
  },
  {
    city: 'Bayamon',
    county_fips: 72021,
    county_fips_all: '72021|72007|72135',
    county: 'Bayamón',
    county_names_all: 'Bayamón|Aguas Buenas|Toa Alta',
    county_weights: '{"72021": 97.91, "72007": 1.4, "72135": 0.69}',
    density: 939.7,
    imprecise: false,
    latitude: 18.32121,
    longitude: -66.17185,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 66734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00956',
  },
  {
    city: 'Bayamon',
    county_fips: 72021,
    county_fips_all: '72021|72135',
    county: 'Bayamón',
    county_names_all: 'Bayamón|Toa Alta',
    county_weights: '{"72021": 93.14, "72135": 6.86}',
    density: 3575,
    imprecise: false,
    latitude: 18.36696,
    longitude: -66.18857,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 40194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00957',
  },
  {
    city: 'Bayamon',
    county_fips: 72021,
    county_fips_all: '72021|72061|72137|72135',
    county: 'Bayamón',
    county_names_all: 'Bayamón|Guaynabo|Toa Baja|Toa Alta',
    county_weights:
      '{"72021": 98.7, "72061": 0.83, "72137": 0.31, "72135": 0.16}',
    density: 2931.4,
    imprecise: false,
    latitude: 18.3852,
    longitude: -66.15583,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 46260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00959',
  },
  {
    city: 'Bayamon',
    county_fips: 72021,
    county_fips_all: '72021',
    county: 'Bayamón',
    county_names_all: 'Bayamón',
    county_weights: '{"72021": 100}',
    density: 832.8,
    imprecise: false,
    latitude: 18.41674,
    longitude: -66.14365,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 3025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00960',
  },
  {
    city: 'Bayamon',
    county_fips: 72021,
    county_fips_all: '72021|72033',
    county: 'Bayamón',
    county_names_all: 'Bayamón|Cataño',
    county_weights: '{"72021": 99.0, "72033": 1.0}',
    density: 2091.4,
    imprecise: false,
    latitude: 18.40987,
    longitude: -66.16415,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 28888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00961',
  },
  {
    city: 'Catano',
    county_fips: 72033,
    county_fips_all: '72033|72061|72021|72137',
    county: 'Cataño',
    county_names_all: 'Cataño|Guaynabo|Bayamón|Toa Baja',
    county_weights:
      '{"72033": 85.97, "72061": 13.72, "72021": 0.2, "72137": 0.11}',
    density: 1519,
    imprecise: false,
    latitude: 18.43514,
    longitude: -66.13949,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 18947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00962',
  },
  {
    city: 'Guaynabo',
    county_fips: 72061,
    county_fips_all: '72061',
    county: 'Guaynabo',
    county_names_all: 'Guaynabo',
    county_weights: '{"72061": 100}',
    density: 2494.4,
    imprecise: false,
    latitude: 18.42853,
    longitude: -66.11175,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 5848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00965',
  },
  {
    city: 'Guaynabo',
    county_fips: 72061,
    county_fips_all: '72061|72127|72021',
    county: 'Guaynabo',
    county_names_all: 'Guaynabo|San Juan|Bayamón',
    county_weights: '{"72061": 85.34, "72127": 8.07, "72021": 6.59}',
    density: 2879,
    imprecise: false,
    latitude: 18.39784,
    longitude: -66.11394,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 18791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00966',
  },
  {
    city: 'Guaynabo',
    county_fips: 72061,
    county_fips_all: '72061|72127',
    county: 'Guaynabo',
    county_names_all: 'Guaynabo|San Juan',
    county_weights: '{"72061": 99.73, "72127": 0.27}',
    density: 3076.8,
    imprecise: false,
    latitude: 18.40609,
    longitude: -66.10123,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 3633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00968',
  },
  {
    city: 'Guaynabo',
    county_fips: 72061,
    county_fips_all: '72061|72127|72021',
    county: 'Guaynabo',
    county_names_all: 'Guaynabo|San Juan|Bayamón',
    county_weights: '{"72061": 85.12, "72127": 11.05, "72021": 3.83}',
    density: 3236.4,
    imprecise: false,
    latitude: 18.36696,
    longitude: -66.11,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 42231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00969',
  },
  {
    city: 'Guaynabo',
    county_fips: 72061,
    county_fips_all: '72061',
    county: 'Guaynabo',
    county_names_all: 'Guaynabo',
    county_weights: '{"72061": 100}',
    density: 587.1,
    imprecise: false,
    latitude: 18.32067,
    longitude: -66.11751,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 24367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00971',
  },
  {
    city: 'Trujillo Alto',
    county_fips: 72139,
    county_fips_all: '72139|72031|72127|72063',
    county: 'Trujillo Alto',
    county_names_all: 'Trujillo Alto|Carolina|San Juan|Gurabo',
    county_weights:
      '{"72139": 94.65, "72031": 2.57, "72127": 2.08, "72063": 0.7}',
    density: 1342.4,
    imprecise: false,
    latitude: 18.33903,
    longitude: -65.99286,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 60620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00976',
  },
  {
    city: 'Carolina',
    county_fips: 72031,
    county_fips_all: '72031',
    county: 'Carolina',
    county_names_all: 'Carolina',
    county_weights: '{"72031": 100}',
    density: 1467.1,
    imprecise: false,
    latitude: 18.43734,
    longitude: -66.0089,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 14776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00979',
  },
  {
    city: 'Carolina',
    county_fips: 72031,
    county_fips_all: '72031',
    county: 'Carolina',
    county_names_all: 'Carolina',
    county_weights: '{"72031": 100}',
    density: 3760.2,
    imprecise: false,
    latitude: 18.40961,
    longitude: -65.99143,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 14050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00982',
  },
  {
    city: 'Carolina',
    county_fips: 72031,
    county_fips_all: '72031|72127',
    county: 'Carolina',
    county_names_all: 'Carolina|San Juan',
    county_weights: '{"72031": 99.88, "72127": 0.12}',
    density: 2812,
    imprecise: false,
    latitude: 18.41788,
    longitude: -65.98104,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 31472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00983',
  },
  {
    city: 'Carolina',
    county_fips: 72031,
    county_fips_all: '72031',
    county: 'Carolina',
    county_names_all: 'Carolina',
    county_weights: '{"72031": 100}',
    density: 1275.1,
    imprecise: false,
    latitude: 18.40628,
    longitude: -65.94767,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 30497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00985',
  },
  {
    city: 'Carolina',
    county_fips: 72031,
    county_fips_all: '72031|72139',
    county: 'Carolina',
    county_names_all: 'Carolina|Trujillo Alto',
    county_weights: '{"72031": 99.83, "72139": 0.17}',
    density: 830.1,
    imprecise: false,
    latitude: 18.34115,
    longitude: -65.94257,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 55747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00987',
  },
  {
    city: 'Agawam',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 555.1,
    imprecise: false,
    latitude: 42.06262,
    longitude: -72.62521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01001',
  },
  {
    city: 'Amherst',
    county_fips: 25015,
    county_fips_all: '25015|25011',
    county: 'Hampshire',
    county_names_all: 'Hampshire|Franklin',
    county_weights: '{"25015": 93.26, "25011": 6.74}',
    density: 191.2,
    imprecise: false,
    latitude: 42.37633,
    longitude: -72.46462,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01002',
  },
  {
    city: 'Barre',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 46.5,
    imprecise: false,
    latitude: 42.42117,
    longitude: -72.10655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01005',
  },
  {
    city: 'Belchertown',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 108.5,
    imprecise: false,
    latitude: 42.28163,
    longitude: -72.40009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01007',
  },
  {
    city: 'Blandford',
    county_fips: 25013,
    county_fips_all: '25013|25003',
    county: 'Hampden',
    county_names_all: 'Hampden|Berkshire',
    county_weights: '{"25013": 94.36, "25003": 5.64}',
    density: 8.4,
    imprecise: false,
    latitude: 42.18234,
    longitude: -72.95819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01008',
  },
  {
    city: 'Bondsville',
    county_fips: 25013,
    county_fips_all: '25013|25015',
    county: 'Hampden',
    county_names_all: 'Hampden|Hampshire',
    county_weights: '{"25013": 99.06, "25015": 0.94}',
    density: 445.1,
    imprecise: false,
    latitude: 42.21133,
    longitude: -72.34189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01009',
  },
  {
    city: 'Brimfield',
    county_fips: 25013,
    county_fips_all: '25013|25027',
    county: 'Hampden',
    county_names_all: 'Hampden|Worcester',
    county_weights: '{"25013": 98.73, "25027": 1.27}',
    density: 40.6,
    imprecise: false,
    latitude: 42.12904,
    longitude: -72.20597,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01010',
  },
  {
    city: 'Chester',
    county_fips: 25013,
    county_fips_all: '25013|25015',
    county: 'Hampden',
    county_names_all: 'Hampden|Hampshire',
    county_weights: '{"25013": 77.54, "25015": 22.46}',
    density: 13.8,
    imprecise: false,
    latitude: 42.30233,
    longitude: -72.96448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01011',
  },
  {
    city: 'Chesterfield',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 42.38495,
    longitude: -72.84675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01012',
  },
  {
    city: 'Chicopee',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 1588.4,
    imprecise: false,
    latitude: 42.16059,
    longitude: -72.60788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01013',
  },
  {
    city: 'Chicopee',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 934.7,
    imprecise: false,
    latitude: 42.17618,
    longitude: -72.56538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01020',
  },
  {
    city: 'Chicopee',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 147.9,
    imprecise: false,
    latitude: 42.19721,
    longitude: -72.54249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01022',
  },
  {
    city: 'Cummington',
    county_fips: 25015,
    county_fips_all: '25015|25003',
    county: 'Hampshire',
    county_names_all: 'Hampshire|Berkshire',
    county_weights: '{"25015": 90.46, "25003": 9.54}',
    density: 14,
    imprecise: false,
    latitude: 42.46858,
    longitude: -72.92296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01026',
  },
  {
    city: 'Easthampton',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 168.5,
    imprecise: false,
    latitude: 42.29506,
    longitude: -72.74303,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01027',
  },
  {
    city: 'East Longmeadow',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 487.7,
    imprecise: false,
    latitude: 42.05967,
    longitude: -72.49899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01028',
  },
  {
    city: 'East Otis',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 42.19402,
    longitude: -73.05067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01029',
  },
  {
    city: 'Feeding Hills',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 394.9,
    imprecise: false,
    latitude: 42.06869,
    longitude: -72.67967,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01030',
  },
  {
    city: 'Gilbertville',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 96.1,
    imprecise: false,
    latitude: 42.32782,
    longitude: -72.19191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01031',
  },
  {
    city: 'Goshen',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 42.45313,
    longitude: -72.81965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01032',
  },
  {
    city: 'Granby',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 84.4,
    imprecise: false,
    latitude: 42.26082,
    longitude: -72.50361,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01033',
  },
  {
    city: 'Granville',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 42.0826,
    longitude: -72.95611,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01034',
  },
  {
    city: 'Hadley',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 88.7,
    imprecise: false,
    latitude: 42.35563,
    longitude: -72.5692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01035',
  },
  {
    city: 'Hampden',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 97.4,
    imprecise: false,
    latitude: 42.0638,
    longitude: -72.4157,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01036',
  },
  {
    city: 'Hardwick',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 42.37063,
    longitude: -72.19466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01037',
  },
  {
    city: 'Hatfield',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 104.3,
    imprecise: false,
    latitude: 42.38466,
    longitude: -72.60559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01038',
  },
  {
    city: 'Haydenville',
    county_fips: 25015,
    county_fips_all: '25015|25011',
    county: 'Hampshire',
    county_names_all: 'Hampshire|Franklin',
    county_weights: '{"25015": 58.67, "25011": 41.33}',
    density: 35.3,
    imprecise: false,
    latitude: 42.41049,
    longitude: -72.69188,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01039',
  },
  {
    city: 'Holyoke',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 689.8,
    imprecise: false,
    latitude: 42.21251,
    longitude: -72.64109,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01040',
  },
  {
    city: 'Huntington',
    county_fips: 25015,
    county_fips_all: '25015|25013',
    county: 'Hampshire',
    county_names_all: 'Hampshire|Hampden',
    county_weights: '{"25015": 68.98, "25013": 31.02}',
    density: 23.6,
    imprecise: false,
    latitude: 42.29092,
    longitude: -72.87526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01050',
  },
  {
    city: 'Leeds',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 154.7,
    imprecise: false,
    latitude: 42.35205,
    longitude: -72.71032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01053',
  },
  {
    city: 'Leverett',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 27.1,
    imprecise: false,
    latitude: 42.47381,
    longitude: -72.48768,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01054',
  },
  {
    city: 'Ludlow',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 296.8,
    imprecise: false,
    latitude: 42.19211,
    longitude: -72.45805,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01056',
  },
  {
    city: 'Monson',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 70.9,
    imprecise: false,
    latitude: 42.09118,
    longitude: -72.32392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01057',
  },
  {
    city: 'Northampton',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 585.9,
    imprecise: false,
    latitude: 42.32218,
    longitude: -72.63126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01060',
  },
  {
    city: 'Florence',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 217.2,
    imprecise: false,
    latitude: 42.32146,
    longitude: -72.69244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01062',
  },
  {
    city: 'North Hatfield',
    county_fips: 25015,
    county_fips_all: '25015|25011',
    county: 'Hampshire',
    county_names_all: 'Hampshire|Franklin',
    county_weights: '{"25015": 99.4, "25011": 0.6}',
    density: 35.2,
    imprecise: false,
    latitude: 42.40742,
    longitude: -72.64032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01066',
  },
  {
    city: 'Oakham',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 29.1,
    imprecise: false,
    latitude: 42.35125,
    longitude: -72.04776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01068',
  },
  {
    city: 'Palmer',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 121.4,
    imprecise: false,
    latitude: 42.18798,
    longitude: -72.30578,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01069',
  },
  {
    city: 'Plainfield',
    county_fips: 25015,
    county_fips_all: '25015|25003',
    county: 'Hampshire',
    county_names_all: 'Hampshire|Berkshire',
    county_weights: '{"25015": 99.4, "25003": 0.6}',
    density: 11.2,
    imprecise: false,
    latitude: 42.51958,
    longitude: -72.92504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01070',
  },
  {
    city: 'Russell',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 25.9,
    imprecise: false,
    latitude: 42.16029,
    longitude: -72.8598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01071',
  },
  {
    city: 'Shutesbury',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 30.8,
    imprecise: false,
    latitude: 42.46327,
    longitude: -72.41893,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01072',
  },
  {
    city: 'Southampton',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 85.4,
    imprecise: false,
    latitude: 42.23084,
    longitude: -72.73856,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01073',
  },
  {
    city: 'South Barre',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 547.9,
    imprecise: false,
    latitude: 42.3837,
    longitude: -72.10021,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01074',
  },
  {
    city: 'South Hadley',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 386.8,
    imprecise: false,
    latitude: 42.25672,
    longitude: -72.57928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01075',
  },
  {
    city: 'Southwick',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 115.3,
    imprecise: false,
    latitude: 42.05441,
    longitude: -72.77851,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01077',
  },
  {
    city: 'Thorndike',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 105.2,
    imprecise: false,
    latitude: 42.18508,
    longitude: -72.33406,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01079',
  },
  {
    city: 'Three Rivers',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 569,
    imprecise: false,
    latitude: 42.18228,
    longitude: -72.36515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01080',
  },
  {
    city: 'Wales',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 46.6,
    imprecise: false,
    latitude: 42.06232,
    longitude: -72.23085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01081',
  },
  {
    city: 'Ware',
    county_fips: 25015,
    county_fips_all: '25015|25027|25013',
    county: 'Hampshire',
    county_names_all: 'Hampshire|Worcester|Hampden',
    county_weights: '{"25015": 73.12, "25027": 26.75, "25013": 0.13}',
    density: 85.4,
    imprecise: false,
    latitude: 42.29816,
    longitude: -72.27676,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01082',
  },
  {
    city: 'Warren',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 86.5,
    imprecise: false,
    latitude: 42.20652,
    longitude: -72.19906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01083',
  },
  {
    city: 'West Chesterfield',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 42.38589,
    longitude: -72.88165,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01084',
  },
  {
    city: 'Westfield',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 265.7,
    imprecise: false,
    latitude: 42.15375,
    longitude: -72.76961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01085',
  },
  {
    city: 'West Springfield',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 664,
    imprecise: false,
    latitude: 42.12532,
    longitude: -72.65025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01089',
  },
  {
    city: 'West Warren',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 68.9,
    imprecise: false,
    latitude: 42.20008,
    longitude: -72.23715,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01092',
  },
  {
    city: 'Whately',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 20.1,
    imprecise: false,
    latitude: 42.44335,
    longitude: -72.65099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01093',
  },
  {
    city: 'Wheelwright',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 27.9,
    imprecise: false,
    latitude: 42.36481,
    longitude: -72.13548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01094',
  },
  {
    city: 'Wilbraham',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 251,
    imprecise: false,
    latitude: 42.12763,
    longitude: -72.42994,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01095',
  },
  {
    city: 'Williamsburg',
    county_fips: 25015,
    county_fips_all: '25015|25011',
    county: 'Hampshire',
    county_names_all: 'Hampshire|Franklin',
    county_weights: '{"25015": 92.01, "25011": 7.99}',
    density: 27.8,
    imprecise: false,
    latitude: 42.40968,
    longitude: -72.77213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01096',
  },
  {
    city: 'Woronoco',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 31.7,
    imprecise: false,
    latitude: 42.17722,
    longitude: -72.83175,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01097',
  },
  {
    city: 'Worthington',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 42.39551,
    longitude: -72.94315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01098',
  },
  {
    city: 'Springfield',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 2199.6,
    imprecise: false,
    latitude: 42.10443,
    longitude: -72.58997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01103',
  },
  {
    city: 'Springfield',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 1712.7,
    imprecise: false,
    latitude: 42.13326,
    longitude: -72.56733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01104',
  },
  {
    city: 'Springfield',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 3791.9,
    imprecise: false,
    latitude: 42.09911,
    longitude: -72.57865,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01105',
  },
  {
    city: 'Longmeadow',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 638.6,
    imprecise: false,
    latitude: 42.04877,
    longitude: -72.57163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01106',
  },
  {
    city: 'Springfield',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 3006.3,
    imprecise: false,
    latitude: 42.12116,
    longitude: -72.60642,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01107',
  },
  {
    city: 'Springfield',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 3074.9,
    imprecise: false,
    latitude: 42.0814,
    longitude: -72.55866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01108',
  },
  {
    city: 'Springfield',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 2208.5,
    imprecise: false,
    latitude: 42.11839,
    longitude: -72.54876,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01109',
  },
  {
    city: 'Springfield',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 1593.4,
    imprecise: false,
    latitude: 42.09476,
    longitude: -72.5253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01118',
  },
  {
    city: 'Springfield',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 1489,
    imprecise: false,
    latitude: 42.12452,
    longitude: -72.51126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01119',
  },
  {
    city: 'Springfield',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 1008.3,
    imprecise: false,
    latitude: 42.09497,
    longitude: -72.48806,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01128',
  },
  {
    city: 'Springfield',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 637.3,
    imprecise: false,
    latitude: 42.1211,
    longitude: -72.4877,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01129',
  },
  {
    city: 'Indian Orchard',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 1565.8,
    imprecise: false,
    latitude: 42.15294,
    longitude: -72.50883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01151',
  },
  {
    city: 'Pittsfield',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 286.8,
    imprecise: false,
    latitude: 42.45614,
    longitude: -73.28114,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01201',
  },
  {
    city: 'Adams',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 136.2,
    imprecise: false,
    latitude: 42.62686,
    longitude: -73.11873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01220',
  },
  {
    city: 'Ashley Falls',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 55.8,
    imprecise: false,
    latitude: 42.06242,
    longitude: -73.32146,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01222',
  },
  {
    city: 'Becket',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 42.31118,
    longitude: -73.09835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01223',
  },
  {
    city: 'Berkshire',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 189.2,
    imprecise: false,
    latitude: 42.50622,
    longitude: -73.19841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01224',
  },
  {
    city: 'Cheshire',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 46.3,
    imprecise: false,
    latitude: 42.56385,
    longitude: -73.1512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01225',
  },
  {
    city: 'Dalton',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 111,
    imprecise: false,
    latitude: 42.47954,
    longitude: -73.15329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01226',
  },
  {
    city: 'Glendale',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 40.9,
    imprecise: false,
    latitude: 42.29411,
    longitude: -73.35227,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01229',
  },
  {
    city: 'Great Barrington',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 42.18197,
    longitude: -73.34244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01230',
  },
  {
    city: 'Hinsdale',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 20.6,
    imprecise: false,
    latitude: 42.43181,
    longitude: -73.07336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01235',
  },
  {
    city: 'Housatonic',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 85.1,
    imprecise: false,
    latitude: 42.26923,
    longitude: -73.37999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01236',
  },
  {
    city: 'Lanesborough',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 18,
    imprecise: false,
    latitude: 42.5529,
    longitude: -73.25373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01237',
  },
  {
    city: 'Lee',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 83.1,
    imprecise: false,
    latitude: 42.30072,
    longitude: -73.22553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01238',
  },
  {
    city: 'Lenox',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 82.5,
    imprecise: false,
    latitude: 42.37567,
    longitude: -73.26466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01240',
  },
  {
    city: 'Lenox Dale',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 24.4,
    imprecise: false,
    latitude: 42.3334,
    longitude: -73.24967,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01242',
  },
  {
    city: 'Middlefield',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 42.34752,
    longitude: -73.03467,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01243',
  },
  {
    city: 'Mill River',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 42.10924,
    longitude: -73.27475,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01244',
  },
  {
    city: 'Monterey',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 42.19043,
    longitude: -73.21579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01245',
  },
  {
    city: 'North Adams',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 124.4,
    imprecise: false,
    latitude: 42.69813,
    longitude: -73.09264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01247',
  },
  {
    city: 'Otis',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 17,
    imprecise: false,
    latitude: 42.20751,
    longitude: -73.1118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01253',
  },
  {
    city: 'Richmond',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 42.37972,
    longitude: -73.36608,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01254',
  },
  {
    city: 'Sandisfield',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 42.1068,
    longitude: -73.12213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01255',
  },
  {
    city: 'Sheffield',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 26.7,
    imprecise: false,
    latitude: 42.0976,
    longitude: -73.37241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01257',
  },
  {
    city: 'South Egremont',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 42.09396,
    longitude: -73.46616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01258',
  },
  {
    city: 'Southfield',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 42.07316,
    longitude: -73.23282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01259',
  },
  {
    city: 'South Lee',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 3,
    imprecise: false,
    latitude: 42.26663,
    longitude: -73.2712,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01260',
  },
  {
    city: 'Stockbridge',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 34.8,
    imprecise: false,
    latitude: 42.30433,
    longitude: -73.32013,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01262',
  },
  {
    city: 'Tyringham',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 5,
    imprecise: false,
    latitude: 42.23997,
    longitude: -73.19686,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01264',
  },
  {
    city: 'West Stockbridge',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 42.30264,
    longitude: -73.39846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01266',
  },
  {
    city: 'Williamstown',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 62.7,
    imprecise: false,
    latitude: 42.66593,
    longitude: -73.24209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01267',
  },
  {
    city: 'Windsor',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 42.51297,
    longitude: -73.04859,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01270',
  },
  {
    city: 'Greenfield',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 272.3,
    imprecise: false,
    latitude: 42.62375,
    longitude: -72.60379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01301',
  },
  {
    city: 'Ashfield',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 42.51772,
    longitude: -72.81556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01330',
  },
  {
    city: 'Athol',
    county_fips: 25027,
    county_fips_all: '25027|25011',
    county: 'Worcester',
    county_names_all: 'Worcester|Franklin',
    county_weights: '{"25027": 99.71, "25011": 0.29}',
    density: 99.2,
    imprecise: false,
    latitude: 42.56793,
    longitude: -72.18324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01331',
  },
  {
    city: 'Bernardston',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 26.7,
    imprecise: false,
    latitude: 42.69512,
    longitude: -72.57731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01337',
  },
  {
    city: 'Buckland',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 28,
    imprecise: false,
    latitude: 42.5814,
    longitude: -72.80309,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 95,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01338',
  },
  {
    city: 'Charlemont',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 42.61099,
    longitude: -72.88846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01339',
  },
  {
    city: 'Colrain',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 42.68805,
    longitude: -72.73205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01340',
  },
  {
    city: 'Conway',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 42.50734,
    longitude: -72.70221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01341',
  },
  {
    city: 'Deerfield',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 26.6,
    imprecise: false,
    latitude: 42.54384,
    longitude: -72.6058,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01342',
  },
  {
    city: 'Erving',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 47.7,
    imprecise: false,
    latitude: 42.60756,
    longitude: -72.42916,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01344',
  },
  {
    city: 'Heath',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 42.6706,
    longitude: -72.81323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01346',
  },
  {
    city: 'Lake Pleasant',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 178.3,
    imprecise: false,
    latitude: 42.56027,
    longitude: -72.51321,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01347',
  },
  {
    city: 'Millers Falls',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 29,
    imprecise: false,
    latitude: 42.56656,
    longitude: -72.47045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01349',
  },
  {
    city: 'Montague',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 51.9,
    imprecise: false,
    latitude: 42.54162,
    longitude: -72.52069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01351',
  },
  {
    city: 'Gill',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 48.9,
    imprecise: false,
    latitude: 42.63282,
    longitude: -72.51136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01354',
  },
  {
    city: 'New Salem',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 42.45101,
    longitude: -72.33141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01355',
  },
  {
    city: 'Northfield',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 32.3,
    imprecise: false,
    latitude: 42.67575,
    longitude: -72.446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01360',
  },
  {
    city: 'Orange',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 82.1,
    imprecise: false,
    latitude: 42.60449,
    longitude: -72.29263,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01364',
  },
  {
    city: 'Petersham',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 42.48858,
    longitude: -72.18564,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01366',
  },
  {
    city: 'Rowe',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 42.69674,
    longitude: -72.91387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01367',
  },
  {
    city: 'Royalston',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 42.67815,
    longitude: -72.18557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01368',
  },
  {
    city: 'Shelburne Falls',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 31.1,
    imprecise: false,
    latitude: 42.59607,
    longitude: -72.72915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01370',
  },
  {
    city: 'South Deerfield',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 81.4,
    imprecise: false,
    latitude: 42.47292,
    longitude: -72.61516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01373',
  },
  {
    city: 'Sunderland',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 99.8,
    imprecise: false,
    latitude: 42.46475,
    longitude: -72.55489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01375',
  },
  {
    city: 'Turners Falls',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 471,
    imprecise: false,
    latitude: 42.59273,
    longitude: -72.54591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01376',
  },
  {
    city: 'Wendell',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 42.54149,
    longitude: -72.3989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01379',
  },
  {
    city: 'Fitchburg',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 537.4,
    imprecise: false,
    latitude: 42.58559,
    longitude: -71.81693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01420',
  },
  {
    city: 'Ashburnham',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 68.1,
    imprecise: false,
    latitude: 42.66069,
    longitude: -71.9232,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01430',
  },
  {
    city: 'Ashby',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 52.4,
    imprecise: false,
    latitude: 42.67652,
    longitude: -71.82322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01431',
  },
  {
    city: 'Ayer',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 386.2,
    imprecise: false,
    latitude: 42.56351,
    longitude: -71.57059,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01432',
  },
  {
    city: 'Devens',
    county_fips: 25027,
    county_fips_all: '25027|25017',
    county: 'Worcester',
    county_names_all: 'Worcester|Middlesex',
    county_weights: '{"25027": 82.26, "25017": 17.74}',
    density: 92.7,
    imprecise: false,
    latitude: 42.53149,
    longitude: -71.61663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01434',
  },
  {
    city: 'Baldwinville',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 159.7,
    imprecise: false,
    latitude: 42.60579,
    longitude: -72.08958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01436',
  },
  {
    city: 'East Templeton',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 392.4,
    imprecise: false,
    latitude: 42.56028,
    longitude: -72.03583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01438',
  },
  {
    city: 'Gardner',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 335.2,
    imprecise: false,
    latitude: 42.58797,
    longitude: -71.98649,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01440',
  },
  {
    city: 'Groton',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 133.8,
    imprecise: false,
    latitude: 42.61368,
    longitude: -71.56139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01450',
  },
  {
    city: 'Harvard',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 100.7,
    imprecise: false,
    latitude: 42.50005,
    longitude: -71.57754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01451',
  },
  {
    city: 'Hubbardston',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 41.1,
    imprecise: false,
    latitude: 42.48378,
    longitude: -72.00514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01452',
  },
  {
    city: 'Leominster',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 642.3,
    imprecise: false,
    latitude: 42.51961,
    longitude: -71.76583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01453',
  },
  {
    city: 'Littleton',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 240.3,
    imprecise: false,
    latitude: 42.53503,
    longitude: -71.4891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01460',
  },
  {
    city: 'Lunenburg',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 172.9,
    imprecise: false,
    latitude: 42.58994,
    longitude: -71.72036,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01462',
  },
  {
    city: 'Pepperell',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 200,
    imprecise: false,
    latitude: 42.67126,
    longitude: -71.60429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01463',
  },
  {
    city: 'Shirley',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 178,
    imprecise: false,
    latitude: 42.57411,
    longitude: -71.6475,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01464',
  },
  {
    city: 'Templeton',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 73.5,
    imprecise: false,
    latitude: 42.55324,
    longitude: -72.06879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01468',
  },
  {
    city: 'Townsend',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 121.8,
    imprecise: false,
    latitude: 42.66514,
    longitude: -71.69161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01469',
  },
  {
    city: 'Westminster',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 91.2,
    imprecise: false,
    latitude: 42.55122,
    longitude: -71.90266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01473',
  },
  {
    city: 'West Townsend',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 79.4,
    imprecise: false,
    latitude: 42.67088,
    longitude: -71.7508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01474',
  },
  {
    city: 'Winchendon',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 92.7,
    imprecise: false,
    latitude: 42.66675,
    longitude: -72.04902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01475',
  },
  {
    city: 'Auburn',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 427.1,
    imprecise: false,
    latitude: 42.19689,
    longitude: -71.84549,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01501',
  },
  {
    city: 'Berlin',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 100.5,
    imprecise: false,
    latitude: 42.38378,
    longitude: -71.63552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01503',
  },
  {
    city: 'Blackstone',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 321.6,
    imprecise: false,
    latitude: 42.0399,
    longitude: -71.53125,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01504',
  },
  {
    city: 'Boylston',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 119,
    imprecise: false,
    latitude: 42.35633,
    longitude: -71.72123,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01505',
  },
  {
    city: 'Brookfield',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 86,
    imprecise: false,
    latitude: 42.19364,
    longitude: -72.10441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01506',
  },
  {
    city: 'Charlton',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 123,
    imprecise: false,
    latitude: 42.13509,
    longitude: -71.96803,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01507',
  },
  {
    city: 'Clinton',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 1063,
    imprecise: false,
    latitude: 42.4119,
    longitude: -71.68883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01510',
  },
  {
    city: 'East Brookfield',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 84.8,
    imprecise: false,
    latitude: 42.20328,
    longitude: -72.04669,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01515',
  },
  {
    city: 'Douglas',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 98.8,
    imprecise: false,
    latitude: 42.0528,
    longitude: -71.75106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01516',
  },
  {
    city: 'Fiskdale',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 82,
    imprecise: false,
    latitude: 42.11342,
    longitude: -72.11632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01518',
  },
  {
    city: 'Grafton',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 291.3,
    imprecise: false,
    latitude: 42.20077,
    longitude: -71.67892,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01519',
  },
  {
    city: 'Holden',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 346.9,
    imprecise: false,
    latitude: 42.33685,
    longitude: -71.85181,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01520',
  },
  {
    city: 'Holland',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 81.2,
    imprecise: false,
    latitude: 42.06012,
    longitude: -72.16592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01521',
  },
  {
    city: 'Jefferson',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 77.6,
    imprecise: false,
    latitude: 42.38142,
    longitude: -71.87111,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01522',
  },
  {
    city: 'Lancaster',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 121.1,
    imprecise: false,
    latitude: 42.48176,
    longitude: -71.68079,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01523',
  },
  {
    city: 'Leicester',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 153.7,
    imprecise: false,
    latitude: 42.24919,
    longitude: -71.91989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01524',
  },
  {
    city: 'Linwood',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.09899,
    longitude: -71.64296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01525',
  },
  {
    city: 'Millbury',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 346,
    imprecise: false,
    latitude: 42.19228,
    longitude: -71.77397,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01527',
  },
  {
    city: 'Millville',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 250.9,
    imprecise: false,
    latitude: 42.03906,
    longitude: -71.57767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01529',
  },
  {
    city: 'New Braintree',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 42.31929,
    longitude: -72.12794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01531',
  },
  {
    city: 'Northborough',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 329.1,
    imprecise: false,
    latitude: 42.32314,
    longitude: -71.64621,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01532',
  },
  {
    city: 'Northbridge',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 252.8,
    imprecise: false,
    latitude: 42.13991,
    longitude: -71.64433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01534',
  },
  {
    city: 'North Brookfield',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 86.4,
    imprecise: false,
    latitude: 42.2695,
    longitude: -72.07794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01535',
  },
  {
    city: 'North Grafton',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 309.4,
    imprecise: false,
    latitude: 42.23189,
    longitude: -71.69219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01536',
  },
  {
    city: 'North Oxford',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 129.2,
    imprecise: false,
    latitude: 42.16177,
    longitude: -71.89217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01537',
  },
  {
    city: 'Oxford',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 221.9,
    imprecise: false,
    latitude: 42.11649,
    longitude: -71.85819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01540',
  },
  {
    city: 'Princeton',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 38.5,
    imprecise: false,
    latitude: 42.45649,
    longitude: -71.88128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01541',
  },
  {
    city: 'Rochdale',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 239.7,
    imprecise: false,
    latitude: 42.20241,
    longitude: -71.90995,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01542',
  },
  {
    city: 'Rutland',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 102.8,
    imprecise: false,
    latitude: 42.38482,
    longitude: -71.96726,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01543',
  },
  {
    city: 'Shrewsbury',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 723.3,
    imprecise: false,
    latitude: 42.28419,
    longitude: -71.71558,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01545',
  },
  {
    city: 'Southbridge',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 342,
    imprecise: false,
    latitude: 42.06039,
    longitude: -72.03377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01550',
  },
  {
    city: 'South Grafton',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 540.2,
    imprecise: false,
    latitude: 42.17496,
    longitude: -71.67762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01560',
  },
  {
    city: 'South Lancaster',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.44581,
    longitude: -71.68845,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01561',
  },
  {
    city: 'Spencer',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 141.1,
    imprecise: false,
    latitude: 42.24715,
    longitude: -71.99189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01562',
  },
  {
    city: 'Sterling',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 103.2,
    imprecise: false,
    latitude: 42.44124,
    longitude: -71.77297,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01564',
  },
  {
    city: 'Sturbridge',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 113.7,
    imprecise: false,
    latitude: 42.1047,
    longitude: -72.07745,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01566',
  },
  {
    city: 'Upton',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 145.8,
    imprecise: false,
    latitude: 42.17694,
    longitude: -71.60516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01568',
  },
  {
    city: 'Uxbridge',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 188,
    imprecise: false,
    latitude: 42.05895,
    longitude: -71.63741,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01569',
  },
  {
    city: 'Webster',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 554.5,
    imprecise: false,
    latitude: 42.05206,
    longitude: -71.8485,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01570',
  },
  {
    city: 'Dudley',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 221.1,
    imprecise: false,
    latitude: 42.05501,
    longitude: -71.93519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01571',
  },
  {
    city: 'Westborough',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 411.2,
    imprecise: false,
    latitude: 42.26815,
    longitude: -71.61402,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01581',
  },
  {
    city: 'West Boylston',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 233.5,
    imprecise: false,
    latitude: 42.37034,
    longitude: -71.78502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01583',
  },
  {
    city: 'West Brookfield',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 66.1,
    imprecise: false,
    latitude: 42.23762,
    longitude: -72.16311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01585',
  },
  {
    city: 'Whitinsville',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 489.3,
    imprecise: false,
    latitude: 42.11837,
    longitude: -71.66836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01588',
  },
  {
    city: 'Sutton',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 112,
    imprecise: false,
    latitude: 42.13387,
    longitude: -71.75179,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01590',
  },
  {
    city: 'Worcester',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 1794.6,
    imprecise: false,
    latitude: 42.27219,
    longitude: -71.84946,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01602',
  },
  {
    city: 'Worcester',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 1778.7,
    imprecise: false,
    latitude: 42.24373,
    longitude: -71.84429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01603',
  },
  {
    city: 'Worcester',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 2317.2,
    imprecise: false,
    latitude: 42.25085,
    longitude: -71.7683,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01604',
  },
  {
    city: 'Worcester',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 2088.2,
    imprecise: false,
    latitude: 42.28979,
    longitude: -71.78802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01605',
  },
  {
    city: 'Worcester',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 1472.9,
    imprecise: false,
    latitude: 42.31367,
    longitude: -71.79614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01606',
  },
  {
    city: 'Worcester',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 1110.7,
    imprecise: false,
    latitude: 42.22684,
    longitude: -71.79037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01607',
  },
  {
    city: 'Worcester',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 3954.7,
    imprecise: false,
    latitude: 42.2621,
    longitude: -71.80145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01608',
  },
  {
    city: 'Worcester',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 2279.8,
    imprecise: false,
    latitude: 42.28592,
    longitude: -71.82853,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01609',
  },
  {
    city: 'Worcester',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 5512.3,
    imprecise: false,
    latitude: 42.24645,
    longitude: -71.80968,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01610',
  },
  {
    city: 'Cherry Valley',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 259.8,
    imprecise: false,
    latitude: 42.23945,
    longitude: -71.87702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01611',
  },
  {
    city: 'Paxton',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 126.5,
    imprecise: false,
    latitude: 42.31037,
    longitude: -71.93095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01612',
  },
  {
    city: 'Framingham',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 745.7,
    imprecise: false,
    latitude: 42.32195,
    longitude: -71.43796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01701',
  },
  {
    city: 'Framingham',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 1871,
    imprecise: false,
    latitude: 42.28242,
    longitude: -71.43428,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01702',
  },
  {
    city: 'Acton',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 1131.6,
    imprecise: false,
    latitude: 42.52165,
    longitude: -71.42983,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01718',
  },
  {
    city: 'Boxborough',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 206.3,
    imprecise: false,
    latitude: 42.48837,
    longitude: -71.51779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01719',
  },
  {
    city: 'Acton',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 462.9,
    imprecise: false,
    latitude: 42.48397,
    longitude: -71.43809,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01720',
  },
  {
    city: 'Ashland',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 590.6,
    imprecise: false,
    latitude: 42.25726,
    longitude: -71.46867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01721',
  },
  {
    city: 'Bedford',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 456.3,
    imprecise: false,
    latitude: 42.4995,
    longitude: -71.27799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01730',
  },
  {
    city: 'Hanscom Afb',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 348.6,
    imprecise: false,
    latitude: 42.46422,
    longitude: -71.28202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01731',
  },
  {
    city: 'Bolton',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 111.1,
    imprecise: false,
    latitude: 42.43616,
    longitude: -71.60728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01740',
  },
  {
    city: 'Carlisle',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 132.4,
    imprecise: false,
    latitude: 42.53001,
    longitude: -71.35128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01741',
  },
  {
    city: 'Concord',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 295.2,
    imprecise: false,
    latitude: 42.46221,
    longitude: -71.36504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01742',
  },
  {
    city: 'Fayville',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 580.3,
    imprecise: false,
    latitude: 42.29155,
    longitude: -71.50101,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01745',
  },
  {
    city: 'Holliston',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 312.4,
    imprecise: false,
    latitude: 42.19775,
    longitude: -71.44499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01746',
  },
  {
    city: 'Hopedale',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 449.7,
    imprecise: false,
    latitude: 42.12477,
    longitude: -71.535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01747',
  },
  {
    city: 'Hopkinton',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 285,
    imprecise: false,
    latitude: 42.2255,
    longitude: -71.53781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01748',
  },
  {
    city: 'Hudson',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 672.5,
    imprecise: false,
    latitude: 42.38868,
    longitude: -71.54648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01749',
  },
  {
    city: 'Marlborough',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 770.9,
    imprecise: false,
    latitude: 42.3494,
    longitude: -71.54681,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01752',
  },
  {
    city: 'Maynard',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 795.8,
    imprecise: false,
    latitude: 42.4264,
    longitude: -71.45607,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01754',
  },
  {
    city: 'Mendon',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 137.4,
    imprecise: false,
    latitude: 42.09301,
    longitude: -71.55146,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01756',
  },
  {
    city: 'Milford',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 780.9,
    imprecise: false,
    latitude: 42.15723,
    longitude: -71.51978,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01757',
  },
  {
    city: 'Natick',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 960.8,
    imprecise: false,
    latitude: 42.28436,
    longitude: -71.34966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01760',
  },
  {
    city: 'Sherborn',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 108.3,
    imprecise: false,
    latitude: 42.23416,
    longitude: -71.37532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01770',
  },
  {
    city: 'Southborough',
    county_fips: 25027,
    county_fips_all: '25027',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"25027": 100}',
    density: 281,
    imprecise: false,
    latitude: 42.30144,
    longitude: -71.5304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01772',
  },
  {
    city: 'Lincoln',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 136.2,
    imprecise: false,
    latitude: 42.42572,
    longitude: -71.31013,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01773',
  },
  {
    city: 'Stow',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 159.6,
    imprecise: false,
    latitude: 42.42983,
    longitude: -71.51146,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01775',
  },
  {
    city: 'Sudbury',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 304.8,
    imprecise: false,
    latitude: 42.38456,
    longitude: -71.42316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01776',
  },
  {
    city: 'Wayland',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 360.5,
    imprecise: false,
    latitude: 42.3583,
    longitude: -71.35895,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01778',
  },
  {
    city: 'Woburn',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 1274.5,
    imprecise: false,
    latitude: 42.48694,
    longitude: -71.15415,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01801',
  },
  {
    city: 'Burlington',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 900,
    imprecise: false,
    latitude: 42.5028,
    longitude: -71.20147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01803',
  },
  {
    city: 'Andover',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 451,
    imprecise: false,
    latitude: 42.64669,
    longitude: -71.16517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01810',
  },
  {
    city: 'Billerica',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 701.4,
    imprecise: false,
    latitude: 42.54999,
    longitude: -71.25206,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01821',
  },
  {
    city: 'Chelmsford',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 569.7,
    imprecise: false,
    latitude: 42.59156,
    longitude: -71.35553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01824',
  },
  {
    city: 'Dracut',
    county_fips: 25017,
    county_fips_all: '25017|25009',
    county: 'Middlesex',
    county_names_all: 'Middlesex|Essex',
    county_weights: '{"25017": 99.44, "25009": 0.56}',
    density: 606.1,
    imprecise: false,
    latitude: 42.68323,
    longitude: -71.30063,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01826',
  },
  {
    city: 'Dunstable',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 80,
    imprecise: false,
    latitude: 42.67643,
    longitude: -71.50052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01827',
  },
  {
    city: 'Haverhill',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 738.6,
    imprecise: false,
    latitude: 42.7959,
    longitude: -71.05323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01830',
  },
  {
    city: 'Haverhill',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 897.1,
    imprecise: false,
    latitude: 42.79099,
    longitude: -71.13133,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01832',
  },
  {
    city: 'Georgetown',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 253.9,
    imprecise: false,
    latitude: 42.72409,
    longitude: -70.9821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01833',
  },
  {
    city: 'Groveland',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 294.7,
    imprecise: false,
    latitude: 42.75198,
    longitude: -71.01486,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01834',
  },
  {
    city: 'Haverhill',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 730.7,
    imprecise: false,
    latitude: 42.75292,
    longitude: -71.08602,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01835',
  },
  {
    city: 'Lawrence',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 6445.5,
    imprecise: false,
    latitude: 42.70695,
    longitude: -71.16014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01840',
  },
  {
    city: 'Lawrence',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 6694.4,
    imprecise: false,
    latitude: 42.71077,
    longitude: -71.16494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01841',
  },
  {
    city: 'Lawrence',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 3140.3,
    imprecise: false,
    latitude: 42.68985,
    longitude: -71.16095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01843',
  },
  {
    city: 'Methuen',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 933.3,
    imprecise: false,
    latitude: 42.73426,
    longitude: -71.18858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01844',
  },
  {
    city: 'North Andover',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 475.1,
    imprecise: false,
    latitude: 42.67132,
    longitude: -71.08669,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01845',
  },
  {
    city: 'Lowell',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 5033.1,
    imprecise: false,
    latitude: 42.65569,
    longitude: -71.30292,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01850',
  },
  {
    city: 'Lowell',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 3994.5,
    imprecise: false,
    latitude: 42.62915,
    longitude: -71.33674,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01851',
  },
  {
    city: 'Lowell',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 2884,
    imprecise: false,
    latitude: 42.63231,
    longitude: -71.29538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01852',
  },
  {
    city: 'Lowell',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 2932.7,
    imprecise: false,
    latitude: 42.64939,
    longitude: -71.34827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01854',
  },
  {
    city: 'Merrimac',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 306.6,
    imprecise: false,
    latitude: 42.83858,
    longitude: -71.01194,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01860',
  },
  {
    city: 'North Billerica',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 514.3,
    imprecise: false,
    latitude: 42.57427,
    longitude: -71.29437,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01862',
  },
  {
    city: 'North Chelmsford',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 848.9,
    imprecise: false,
    latitude: 42.63274,
    longitude: -71.39132,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01863',
  },
  {
    city: 'North Reading',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 462.6,
    imprecise: false,
    latitude: 42.58156,
    longitude: -71.08759,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01864',
  },
  {
    city: 'Reading',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 992.4,
    imprecise: false,
    latitude: 42.53505,
    longitude: -71.1055,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01867',
  },
  {
    city: 'Tewksbury',
    county_fips: 25017,
    county_fips_all: '25017|25009',
    county: 'Middlesex',
    county_names_all: 'Middlesex|Essex',
    county_weights: '{"25017": 99.19, "25009": 0.81}',
    density: 574.6,
    imprecise: false,
    latitude: 42.61206,
    longitude: -71.22733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01876',
  },
  {
    city: 'Tyngsboro',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 289.1,
    imprecise: false,
    latitude: 42.66626,
    longitude: -71.42911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01879',
  },
  {
    city: 'Wakefield',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 1453,
    imprecise: false,
    latitude: 42.50348,
    longitude: -71.06559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01880',
  },
  {
    city: 'Westford',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 315.2,
    imprecise: false,
    latitude: 42.58642,
    longitude: -71.44008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01886',
  },
  {
    city: 'Wilmington',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 530.8,
    imprecise: false,
    latitude: 42.56091,
    longitude: -71.16541,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01887',
  },
  {
    city: 'Winchester',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 1498.3,
    imprecise: false,
    latitude: 42.45177,
    longitude: -71.14628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01890',
  },
  {
    city: 'Lynn',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 3443.2,
    imprecise: false,
    latitude: 42.46125,
    longitude: -70.94639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01901',
  },
  {
    city: 'Lynn',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 8157.1,
    imprecise: false,
    latitude: 42.4712,
    longitude: -70.93983,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01902',
  },
  {
    city: 'Lynn',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 1909.9,
    imprecise: false,
    latitude: 42.49151,
    longitude: -70.97166,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01904',
  },
  {
    city: 'Lynn',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 3572.4,
    imprecise: false,
    latitude: 42.46355,
    longitude: -70.9733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01905',
  },
  {
    city: 'Saugus',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 959.5,
    imprecise: false,
    latitude: 42.46922,
    longitude: -71.01299,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01906',
  },
  {
    city: 'Swampscott',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 1951.3,
    imprecise: false,
    latitude: 42.47572,
    longitude: -70.90684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01907',
  },
  {
    city: 'Nahant',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 1193.3,
    imprecise: false,
    latitude: 42.42856,
    longitude: -70.92614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01908',
  },
  {
    city: 'Amesbury',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 546.6,
    imprecise: false,
    latitude: 42.85297,
    longitude: -70.94459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01913',
  },
  {
    city: 'Beverly',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 1141.1,
    imprecise: false,
    latitude: 42.56841,
    longitude: -70.8647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01915',
  },
  {
    city: 'Boxford',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 135,
    imprecise: false,
    latitude: 42.6815,
    longitude: -71.01887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01921',
  },
  {
    city: 'Byfield',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 146.9,
    imprecise: false,
    latitude: 42.75862,
    longitude: -70.91758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01922',
  },
  {
    city: 'Danvers',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 818.4,
    imprecise: false,
    latitude: 42.57398,
    longitude: -70.94923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01923',
  },
  {
    city: 'Essex',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 100.3,
    imprecise: false,
    latitude: 42.63478,
    longitude: -70.77684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01929',
  },
  {
    city: 'Gloucester',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 443.2,
    imprecise: false,
    latitude: 42.62605,
    longitude: -70.68966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01930',
  },
  {
    city: 'Hathorne',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 565.5,
    imprecise: false,
    latitude: 42.58579,
    longitude: -70.98406,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01937',
  },
  {
    city: 'Ipswich',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 167.5,
    imprecise: false,
    latitude: 42.68568,
    longitude: -70.83989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01938',
  },
  {
    city: 'Lynnfield',
    county_fips: 25009,
    county_fips_all: '25009|25017',
    county: 'Essex',
    county_names_all: 'Essex|Middlesex',
    county_weights: '{"25009": 99.87, "25017": 0.13}',
    density: 509,
    imprecise: false,
    latitude: 42.53523,
    longitude: -71.03695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01940',
  },
  {
    city: 'Manchester',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 226,
    imprecise: false,
    latitude: 42.58154,
    longitude: -70.76825,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01944',
  },
  {
    city: 'Marblehead',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 1784.1,
    imprecise: false,
    latitude: 42.49924,
    longitude: -70.86348,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01945',
  },
  {
    city: 'Middleton',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 281.8,
    imprecise: false,
    latitude: 42.6043,
    longitude: -71.01641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01949',
  },
  {
    city: 'Newburyport',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 862.4,
    imprecise: false,
    latitude: 42.81237,
    longitude: -70.88785,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01950',
  },
  {
    city: 'Newbury',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 89.8,
    imprecise: false,
    latitude: 42.77742,
    longitude: -70.85022,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01951',
  },
  {
    city: 'Salisbury',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 233.1,
    imprecise: false,
    latitude: 42.84655,
    longitude: -70.86163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01952',
  },
  {
    city: 'Peabody',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 1313.3,
    imprecise: false,
    latitude: 42.53374,
    longitude: -70.97222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01960',
  },
  {
    city: 'Prides Crossing',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 294.7,
    imprecise: false,
    latitude: 42.56294,
    longitude: -70.82996,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01965',
  },
  {
    city: 'Rockport',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 387.3,
    imprecise: false,
    latitude: 42.65432,
    longitude: -70.62227,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01966',
  },
  {
    city: 'Rowley',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 132.6,
    imprecise: false,
    latitude: 42.72235,
    longitude: -70.88832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01969',
  },
  {
    city: 'Salem',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 2095.7,
    imprecise: false,
    latitude: 42.51298,
    longitude: -70.90266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01970',
  },
  {
    city: 'South Hamilton',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 208.8,
    imprecise: false,
    latitude: 42.62669,
    longitude: -70.85789,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01982',
  },
  {
    city: 'Topsfield',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 213,
    imprecise: false,
    latitude: 42.63728,
    longitude: -70.94251,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01983',
  },
  {
    city: 'Wenham',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 248.5,
    imprecise: false,
    latitude: 42.60078,
    longitude: -70.8826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01984',
  },
  {
    city: 'West Newbury',
    county_fips: 25009,
    county_fips_all: '25009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"25009": 100}',
    density: 131.8,
    imprecise: false,
    latitude: 42.7939,
    longitude: -70.96906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01985',
  },
  {
    city: 'Bellingham',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 366.5,
    imprecise: false,
    latitude: 42.0777,
    longitude: -71.47407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02019',
  },
  {
    city: 'Canton',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 509.7,
    imprecise: false,
    latitude: 42.17504,
    longitude: -71.12645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02021',
  },
  {
    city: 'Cohasset',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 332.9,
    imprecise: false,
    latitude: 42.23603,
    longitude: -70.81906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02025',
  },
  {
    city: 'Dedham',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 948.7,
    imprecise: false,
    latitude: 42.24665,
    longitude: -71.1777,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02026',
  },
  {
    city: 'Dover',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 151.7,
    imprecise: false,
    latitude: 42.2366,
    longitude: -71.28421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02030',
  },
  {
    city: 'East Walpole',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 824.3,
    imprecise: false,
    latitude: 42.15489,
    longitude: -71.2155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02032',
  },
  {
    city: 'Foxboro',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 362,
    imprecise: false,
    latitude: 42.06266,
    longitude: -71.24613,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02035',
  },
  {
    city: 'Franklin',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 480.5,
    imprecise: false,
    latitude: 42.08622,
    longitude: -71.41126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02038',
  },
  {
    city: 'Hingham',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 422.7,
    imprecise: false,
    latitude: 42.21678,
    longitude: -70.88494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02043',
  },
  {
    city: 'Hull',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 1464,
    imprecise: false,
    latitude: 42.28437,
    longitude: -70.88266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02045',
  },
  {
    city: 'Humarock',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 121.8,
    imprecise: false,
    latitude: 42.14582,
    longitude: -70.69603,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02047',
  },
  {
    city: 'Mansfield',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 459.6,
    imprecise: false,
    latitude: 42.01626,
    longitude: -71.21868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02048',
  },
  {
    city: 'Marshfield',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 348.5,
    imprecise: false,
    latitude: 42.11443,
    longitude: -70.71487,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02050',
  },
  {
    city: 'Medfield',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 350.2,
    imprecise: false,
    latitude: 42.1848,
    longitude: -71.30501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02052',
  },
  {
    city: 'Medway',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 449.7,
    imprecise: false,
    latitude: 42.15352,
    longitude: -71.42906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02053',
  },
  {
    city: 'Millis',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 285.2,
    imprecise: false,
    latitude: 42.1693,
    longitude: -71.36261,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02054',
  },
  {
    city: 'Norfolk',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 302.5,
    imprecise: false,
    latitude: 42.11632,
    longitude: -71.32952,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02056',
  },
  {
    city: 'Norwell',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 209.6,
    imprecise: false,
    latitude: 42.16075,
    longitude: -70.81772,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02061',
  },
  {
    city: 'Norwood',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 1154.4,
    imprecise: false,
    latitude: 42.18563,
    longitude: -71.19464,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02062',
  },
  {
    city: 'Scituate',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 447,
    imprecise: false,
    latitude: 42.20129,
    longitude: -70.76155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02066',
  },
  {
    city: 'Sharon',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 315.5,
    imprecise: false,
    latitude: 42.10778,
    longitude: -71.18183,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02067',
  },
  {
    city: 'South Walpole',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 838.5,
    imprecise: false,
    latitude: 42.10392,
    longitude: -71.27002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02071',
  },
  {
    city: 'Stoughton',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 701.5,
    imprecise: false,
    latitude: 42.1192,
    longitude: -71.10189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02072',
  },
  {
    city: 'Walpole',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 421.3,
    imprecise: false,
    latitude: 42.14689,
    longitude: -71.25916,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02081',
  },
  {
    city: 'Westwood',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 578.6,
    imprecise: false,
    latitude: 42.22024,
    longitude: -71.21057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02090',
  },
  {
    city: 'Wrentham',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 218.7,
    imprecise: false,
    latitude: 42.05129,
    longitude: -71.35522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02093',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 5348.8,
    imprecise: false,
    latitude: 42.35657,
    longitude: -71.06516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02108',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 8224,
    imprecise: false,
    latitude: 42.36498,
    longitude: -71.05277,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02109',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 5055,
    imprecise: false,
    latitude: 42.35797,
    longitude: -71.05189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02110',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 16560.5,
    imprecise: false,
    latitude: 42.35067,
    longitude: -71.06054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02111',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 25330.8,
    imprecise: false,
    latitude: 42.36526,
    longitude: -71.05524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02113',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 12554.5,
    imprecise: false,
    latitude: 42.36337,
    longitude: -71.06686,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02114',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 16137.8,
    imprecise: false,
    latitude: 42.34046,
    longitude: -71.09481,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02115',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 13067.1,
    imprecise: false,
    latitude: 42.35105,
    longitude: -71.07638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02116',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 10275.2,
    imprecise: false,
    latitude: 42.33806,
    longitude: -71.07057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02118',
  },
  {
    city: 'Roxbury',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 6544.4,
    imprecise: false,
    latitude: 42.32405,
    longitude: -71.08522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02119',
  },
  {
    city: 'Roxbury Crossing',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 9532.5,
    imprecise: false,
    latitude: 42.33212,
    longitude: -71.09654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02120',
  },
  {
    city: 'Dorchester',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 5946.1,
    imprecise: false,
    latitude: 42.3057,
    longitude: -71.08693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02121',
  },
  {
    city: 'Dorchester',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 5340.8,
    imprecise: false,
    latitude: 42.29427,
    longitude: -71.05185,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02122',
  },
  {
    city: 'Dorchester Center',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 7313.5,
    imprecise: false,
    latitude: 42.28583,
    longitude: -71.07114,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02124',
  },
  {
    city: 'Dorchester',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 5995.1,
    imprecise: false,
    latitude: 42.31578,
    longitude: -71.0562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02125',
  },
  {
    city: 'Mattapan',
    county_fips: 25025,
    county_fips_all: '25025|25021',
    county: 'Suffolk',
    county_names_all: 'Suffolk|Norfolk',
    county_weights: '{"25025": 99.47, "25021": 0.53}',
    density: 5613.8,
    imprecise: false,
    latitude: 42.27588,
    longitude: -71.0918,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02126',
  },
  {
    city: 'South Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 6899.3,
    imprecise: false,
    latitude: 42.33455,
    longitude: -71.03875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02127',
  },
  {
    city: 'East Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 3330.6,
    imprecise: false,
    latitude: 42.37324,
    longitude: -71.01616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02128',
  },
  {
    city: 'Charlestown',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 5713.7,
    imprecise: false,
    latitude: 42.37975,
    longitude: -71.06167,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02129',
  },
  {
    city: 'Jamaica Plain',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 4368.3,
    imprecise: false,
    latitude: 42.30823,
    longitude: -71.11515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02130',
  },
  {
    city: 'Roslindale',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 4314.6,
    imprecise: false,
    latitude: 42.28392,
    longitude: -71.12468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02131',
  },
  {
    city: 'West Roxbury',
    county_fips: 25025,
    county_fips_all: '25025|25021',
    county: 'Suffolk',
    county_names_all: 'Suffolk|Norfolk',
    county_weights: '{"25025": 99.84, "25021": 0.16}',
    density: 2099.1,
    imprecise: false,
    latitude: 42.27931,
    longitude: -71.16072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02132',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 1842.2,
    imprecise: false,
    latitude: 42.35838,
    longitude: -71.06383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02133',
  },
  {
    city: 'Allston',
    county_fips: 25025,
    county_fips_all: '25025|25017',
    county: 'Suffolk',
    county_names_all: 'Suffolk|Middlesex',
    county_weights: '{"25025": 99.6, "25017": 0.4}',
    density: 5526.3,
    imprecise: false,
    latitude: 42.35855,
    longitude: -71.12931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02134',
  },
  {
    city: 'Brighton',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 6408.4,
    imprecise: false,
    latitude: 42.34989,
    longitude: -71.15417,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02135',
  },
  {
    city: 'Hyde Park',
    county_fips: 25025,
    county_fips_all: '25025|25021',
    county: 'Suffolk',
    county_names_all: 'Suffolk|Norfolk',
    county_weights: '{"25025": 99.9, "25021": 0.1}',
    density: 3128.9,
    imprecise: false,
    latitude: 42.25505,
    longitude: -71.12662,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02136',
  },
  {
    city: 'Cambridge',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 5429.9,
    imprecise: false,
    latitude: 42.37997,
    longitude: -71.13446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02138',
  },
  {
    city: 'Cambridge',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 9960.4,
    imprecise: false,
    latitude: 42.36224,
    longitude: -71.10253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02139',
  },
  {
    city: 'Cambridge',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 7067.6,
    imprecise: false,
    latitude: 42.39332,
    longitude: -71.13342,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02140',
  },
  {
    city: 'Cambridge',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 9207.2,
    imprecise: false,
    latitude: 42.37041,
    longitude: -71.08218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02141',
  },
  {
    city: 'Cambridge',
    county_fips: 25017,
    county_fips_all: '25017|25025',
    county: 'Middlesex',
    county_names_all: 'Middlesex|Suffolk',
    county_weights: '{"25017": 99.84, "25025": 0.16}',
    density: 5830.2,
    imprecise: false,
    latitude: 42.36295,
    longitude: -71.08189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02142',
  },
  {
    city: 'Somerville',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 6377.6,
    imprecise: false,
    latitude: 42.38142,
    longitude: -71.09677,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02143',
  },
  {
    city: 'Somerville',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 8998.7,
    imprecise: false,
    latitude: 42.40088,
    longitude: -71.122,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02144',
  },
  {
    city: 'Somerville',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 7633.5,
    imprecise: false,
    latitude: 42.39206,
    longitude: -71.0895,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02145',
  },
  {
    city: 'Malden',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 5042.9,
    imprecise: false,
    latitude: 42.43048,
    longitude: -71.05762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02148',
  },
  {
    city: 'Everett',
    county_fips: 25017,
    county_fips_all: '25017|25025',
    county: 'Middlesex',
    county_names_all: 'Middlesex|Suffolk',
    county_weights: '{"25017": 99.86, "25025": 0.14}',
    density: 5651.4,
    imprecise: false,
    latitude: 42.40643,
    longitude: -71.05446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02149',
  },
  {
    city: 'Chelsea',
    county_fips: 25025,
    county_fips_all: '25025|25017',
    county: 'Suffolk',
    county_names_all: 'Suffolk|Middlesex',
    county_weights: '{"25025": 99.81, "25017": 0.19}',
    density: 6959,
    imprecise: false,
    latitude: 42.39587,
    longitude: -71.03251,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02150',
  },
  {
    city: 'Revere',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 4061.3,
    imprecise: false,
    latitude: 42.41887,
    longitude: -71.004,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02151',
  },
  {
    city: 'Winthrop',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 4370.4,
    imprecise: false,
    latitude: 42.37724,
    longitude: -70.98115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02152',
  },
  {
    city: 'Medford',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 2910.2,
    imprecise: false,
    latitude: 42.42324,
    longitude: -71.10878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 61730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02155',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 3823.9,
    imprecise: false,
    latitude: 42.36717,
    longitude: -71.12509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02163',
  },
  {
    city: 'Quincy',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 2010.8,
    imprecise: false,
    latitude: 42.23971,
    longitude: -71.01802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02169',
  },
  {
    city: 'Quincy',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 3483.2,
    imprecise: false,
    latitude: 42.26644,
    longitude: -71.01621,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02170',
  },
  {
    city: 'Quincy',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 3174.3,
    imprecise: false,
    latitude: 42.28709,
    longitude: -71.02604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02171',
  },
  {
    city: 'Melrose',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 2444.4,
    imprecise: false,
    latitude: 42.45561,
    longitude: -71.05901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02176',
  },
  {
    city: 'Stoneham',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 1508.4,
    imprecise: false,
    latitude: 42.47396,
    longitude: -71.09705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02180',
  },
  {
    city: 'Braintree',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 1091.3,
    imprecise: false,
    latitude: 42.20386,
    longitude: -71.0022,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02184',
  },
  {
    city: 'Milton',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 810.1,
    imprecise: false,
    latitude: 42.23854,
    longitude: -71.08464,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02186',
  },
  {
    city: 'Weymouth',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 1617.6,
    imprecise: false,
    latitude: 42.20724,
    longitude: -70.95764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02188',
  },
  {
    city: 'East Weymouth',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 1391.3,
    imprecise: false,
    latitude: 42.2111,
    longitude: -70.93135,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02189',
  },
  {
    city: 'South Weymouth',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 1087,
    imprecise: false,
    latitude: 42.16625,
    longitude: -70.95253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02190',
  },
  {
    city: 'North Weymouth',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 1761.4,
    imprecise: false,
    latitude: 42.24434,
    longitude: -70.94378,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02191',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 8710.8,
    imprecise: false,
    latitude: 42.34748,
    longitude: -71.08199,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02199',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.36144,
    longitude: -71.05945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02203',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.34935,
    longitude: -71.05564,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02205',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"25025": 100}',
    density: 2916.9,
    imprecise: false,
    latitude: 42.34815,
    longitude: -71.03942,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02210',
  },
  {
    city: 'Boston',
    county_fips: 25025,
    county_fips_all: '25025|25021',
    county: 'Suffolk',
    county_names_all: 'Suffolk|Norfolk',
    county_weights: '{"25025": 95.72, "25021": 4.28}',
    density: 10732.5,
    imprecise: false,
    latitude: 42.34741,
    longitude: -71.10276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02215',
  },
  {
    city: 'Brockton',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 2139.4,
    imprecise: false,
    latitude: 42.07791,
    longitude: -71.04223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02301',
  },
  {
    city: 'Brockton',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 1583.1,
    imprecise: false,
    latitude: 42.08792,
    longitude: -70.99864,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02302',
  },
  {
    city: 'Avon',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 429.5,
    imprecise: false,
    latitude: 42.12666,
    longitude: -71.04922,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02322',
  },
  {
    city: 'Bridgewater',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 367.8,
    imprecise: false,
    latitude: 41.97272,
    longitude: -70.97498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02324',
  },
  {
    city: 'Carver',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 121.2,
    imprecise: false,
    latitude: 41.87388,
    longitude: -70.7563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02330',
  },
  {
    city: 'Duxbury',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 263.7,
    imprecise: false,
    latitude: 42.04651,
    longitude: -70.71388,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02332',
  },
  {
    city: 'East Bridgewater',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 323.4,
    imprecise: false,
    latitude: 42.03521,
    longitude: -70.94235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02333',
  },
  {
    city: 'Halifax',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 187.3,
    imprecise: false,
    latitude: 41.99138,
    longitude: -70.86326,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02338',
  },
  {
    city: 'Hanover',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 368.9,
    imprecise: false,
    latitude: 42.12241,
    longitude: -70.85665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02339',
  },
  {
    city: 'Hanson',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 273.1,
    imprecise: false,
    latitude: 42.05604,
    longitude: -70.87251,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02341',
  },
  {
    city: 'Holbrook',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 624.9,
    imprecise: false,
    latitude: 42.14733,
    longitude: -71.00484,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02343',
  },
  {
    city: 'Middleboro',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 137,
    imprecise: false,
    latitude: 41.88034,
    longitude: -70.87446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02346',
  },
  {
    city: 'Lakeville',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 155.8,
    imprecise: false,
    latitude: 41.83101,
    longitude: -70.9594,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02347',
  },
  {
    city: 'Monponsett',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 399.9,
    imprecise: false,
    latitude: 42.02043,
    longitude: -70.84562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02350',
  },
  {
    city: 'Abington',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 660.8,
    imprecise: false,
    latitude: 42.11805,
    longitude: -70.95905,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02351',
  },
  {
    city: 'North Easton',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 354,
    imprecise: false,
    latitude: 42.05519,
    longitude: -71.12071,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02356',
  },
  {
    city: 'Pembroke',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 325.7,
    imprecise: false,
    latitude: 42.06547,
    longitude: -70.8014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02359',
  },
  {
    city: 'Plymouth',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 255.1,
    imprecise: false,
    latitude: 41.87817,
    longitude: -70.63089,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02360',
  },
  {
    city: 'Kingston',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 290.5,
    imprecise: false,
    latitude: 41.98616,
    longitude: -70.74823,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02364',
  },
  {
    city: 'South Carver',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 2276.6,
    imprecise: false,
    latitude: 41.84868,
    longitude: -70.6613,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02366',
  },
  {
    city: 'Plympton',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 77.2,
    imprecise: false,
    latitude: 41.96345,
    longitude: -70.80975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02367',
  },
  {
    city: 'Randolph',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 1445.8,
    imprecise: false,
    latitude: 42.17506,
    longitude: -71.05011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02368',
  },
  {
    city: 'Rockland',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 681.5,
    imprecise: false,
    latitude: 42.1295,
    longitude: -70.91002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02370',
  },
  {
    city: 'South Easton',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 315.9,
    imprecise: false,
    latitude: 42.01954,
    longitude: -71.10381,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02375',
  },
  {
    city: 'West Bridgewater',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 194.2,
    imprecise: false,
    latitude: 42.02139,
    longitude: -71.0267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02379',
  },
  {
    city: 'Whitman',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 851.4,
    imprecise: false,
    latitude: 42.08,
    longitude: -70.93993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02382',
  },
  {
    city: 'Lexington',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 889.6,
    imprecise: false,
    latitude: 42.45821,
    longitude: -71.21762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02420',
  },
  {
    city: 'Lexington',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 729.5,
    imprecise: false,
    latitude: 42.438,
    longitude: -71.23922,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02421',
  },
  {
    city: 'Brookline',
    county_fips: 25021,
    county_fips_all: '25021|25025',
    county: 'Norfolk',
    county_names_all: 'Norfolk|Suffolk',
    county_weights: '{"25021": 97.46, "25025": 2.54}',
    density: 3335.9,
    imprecise: false,
    latitude: 42.32581,
    longitude: -71.13319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02445',
  },
  {
    city: 'Brookline',
    county_fips: 25021,
    county_fips_all: '25021|25025',
    county: 'Norfolk',
    county_names_all: 'Norfolk|Suffolk',
    county_weights: '{"25021": 99.75, "25025": 0.25}',
    density: 9413,
    imprecise: false,
    latitude: 42.3435,
    longitude: -71.12179,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02446',
  },
  {
    city: 'Waltham',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 1262.3,
    imprecise: false,
    latitude: 42.39859,
    longitude: -71.2573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02451',
  },
  {
    city: 'Waltham',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 1600.6,
    imprecise: false,
    latitude: 42.39365,
    longitude: -71.2202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02452',
  },
  {
    city: 'Waltham',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 3395.8,
    imprecise: false,
    latitude: 42.36918,
    longitude: -71.24101,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02453',
  },
  {
    city: 'Babson Park',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 3586.2,
    imprecise: false,
    latitude: 42.29777,
    longitude: -71.26887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02457',
  },
  {
    city: 'Newton',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 2563.4,
    imprecise: false,
    latitude: 42.35294,
    longitude: -71.18763,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02458',
  },
  {
    city: 'Newton Center',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 1415.1,
    imprecise: false,
    latitude: 42.31515,
    longitude: -71.19174,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02459',
  },
  {
    city: 'Newtonville',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 2892.9,
    imprecise: false,
    latitude: 42.35206,
    longitude: -71.20835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02460',
  },
  {
    city: 'Newton Highlands',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 1754.3,
    imprecise: false,
    latitude: 42.31693,
    longitude: -71.20875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02461',
  },
  {
    city: 'Newton Lower Falls',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 812.7,
    imprecise: false,
    latitude: 42.33102,
    longitude: -71.25599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02462',
  },
  {
    city: 'Newton Upper Falls',
    county_fips: 25017,
    county_fips_all: '25017|25021',
    county: 'Middlesex',
    county_names_all: 'Middlesex|Norfolk',
    county_weights: '{"25017": 99.58, "25021": 0.42}',
    density: 2688,
    imprecise: false,
    latitude: 42.31274,
    longitude: -71.21981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02464',
  },
  {
    city: 'West Newton',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 2099.5,
    imprecise: false,
    latitude: 42.34969,
    longitude: -71.22646,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02465',
  },
  {
    city: 'Auburndale',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 2111.1,
    imprecise: false,
    latitude: 42.34541,
    longitude: -71.24759,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02466',
  },
  {
    city: 'Chestnut Hill',
    county_fips: 25021,
    county_fips_all: '25021|25017|25025',
    county: 'Norfolk',
    county_names_all: 'Norfolk|Middlesex|Suffolk',
    county_weights: '{"25021": 57.05, "25017": 28.64, "25025": 14.31}',
    density: 1810.3,
    imprecise: false,
    latitude: 42.31725,
    longitude: -71.16096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02467',
  },
  {
    city: 'Waban',
    county_fips: 25017,
    county_fips_all: '25017|25021',
    county: 'Middlesex',
    county_names_all: 'Middlesex|Norfolk',
    county_weights: '{"25017": 99.9, "25021": 0.1}',
    density: 1451.1,
    imprecise: false,
    latitude: 42.32777,
    longitude: -71.23142,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02468',
  },
  {
    city: 'Watertown',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 3412.5,
    imprecise: false,
    latitude: 42.37,
    longitude: -71.17713,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02472',
  },
  {
    city: 'Arlington',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 3615.8,
    imprecise: false,
    latitude: 42.42053,
    longitude: -71.15666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02474',
  },
  {
    city: 'Arlington',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 3280.1,
    imprecise: false,
    latitude: 42.41597,
    longitude: -71.17437,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02476',
  },
  {
    city: 'Belmont',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 2258.7,
    imprecise: false,
    latitude: 42.39602,
    longitude: -71.17955,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02478',
  },
  {
    city: 'Wellesley Hills',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 1104.2,
    imprecise: false,
    latitude: 42.31064,
    longitude: -71.27779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02481',
  },
  {
    city: 'Wellesley',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 1146.7,
    imprecise: false,
    latitude: 42.29455,
    longitude: -71.29859,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02482',
  },
  {
    city: 'Needham',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 870.2,
    imprecise: false,
    latitude: 42.27615,
    longitude: -71.24387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02492',
  },
  {
    city: 'Weston',
    county_fips: 25017,
    county_fips_all: '25017',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"25017": 100}',
    density: 265.8,
    imprecise: false,
    latitude: 42.35893,
    longitude: -71.30009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02493',
  },
  {
    city: 'Needham Heights',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 1521.4,
    imprecise: false,
    latitude: 42.29959,
    longitude: -71.2317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02494',
  },
  {
    city: 'Buzzards Bay',
    county_fips: 25001,
    county_fips_all: '25001|25023',
    county: 'Barnstable',
    county_names_all: 'Barnstable|Plymouth',
    county_weights: '{"25001": 89.94, "25023": 10.06}',
    density: 371.5,
    imprecise: false,
    latitude: 41.75111,
    longitude: -70.59713,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02532',
  },
  {
    city: 'Cataumet',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 193,
    imprecise: false,
    latitude: 41.66626,
    longitude: -70.61628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02534',
  },
  {
    city: 'Chilmark',
    county_fips: 25007,
    county_fips_all: '25007',
    county: 'Dukes',
    county_names_all: 'Dukes',
    county_weights: '{"25007": 100}',
    density: 35.6,
    imprecise: false,
    latitude: 41.34896,
    longitude: -70.74629,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02535',
  },
  {
    city: 'East Falmouth',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 300.9,
    imprecise: false,
    latitude: 41.59706,
    longitude: -70.56677,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02536',
  },
  {
    city: 'East Sandwich',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 179.6,
    imprecise: false,
    latitude: 41.72882,
    longitude: -70.44317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02537',
  },
  {
    city: 'East Wareham',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 251.1,
    imprecise: false,
    latitude: 41.77872,
    longitude: -70.65077,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02538',
  },
  {
    city: 'Edgartown',
    county_fips: 25007,
    county_fips_all: '25007',
    county: 'Dukes',
    county_names_all: 'Dukes',
    county_weights: '{"25007": 100}',
    density: 76,
    imprecise: false,
    latitude: 41.37994,
    longitude: -70.53227,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02539',
  },
  {
    city: 'Falmouth',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 284.3,
    imprecise: false,
    latitude: 41.57128,
    longitude: -70.62807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02540',
  },
  {
    city: 'Buzzards Bay',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 41.70194,
    longitude: -70.54824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02542',
  },
  {
    city: 'Woods Hole',
    county_fips: 25007,
    county_fips_all: '25007|25001',
    county: 'Dukes',
    county_names_all: 'Dukes|Barnstable',
    county_weights: '{"25007": 83.01, "25001": 16.99}',
    density: 25.5,
    imprecise: false,
    latitude: 41.48731,
    longitude: -70.74525,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02543',
  },
  {
    city: 'Monument Beach',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 58.6,
    imprecise: false,
    latitude: 41.71297,
    longitude: -70.62011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02553',
  },
  {
    city: 'Nantucket',
    county_fips: 25019,
    county_fips_all: '25019',
    county: 'Nantucket',
    county_names_all: 'Nantucket',
    county_weights: '{"25019": 100}',
    density: 137.2,
    imprecise: false,
    latitude: 41.28555,
    longitude: -70.08043,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02554',
  },
  {
    city: 'North Falmouth',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 280.6,
    imprecise: false,
    latitude: 41.63903,
    longitude: -70.62521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02556',
  },
  {
    city: 'Oak Bluffs',
    county_fips: 25007,
    county_fips_all: '25007',
    county: 'Dukes',
    county_names_all: 'Dukes',
    county_weights: '{"25007": 100}',
    density: 149,
    imprecise: false,
    latitude: 41.44218,
    longitude: -70.56648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02557',
  },
  {
    city: 'Onset',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 599.5,
    imprecise: false,
    latitude: 41.74453,
    longitude: -70.65377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02558',
  },
  {
    city: 'Pocasset',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 202.9,
    imprecise: false,
    latitude: 41.69237,
    longitude: -70.61374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02559',
  },
  {
    city: 'Sagamore',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 312,
    imprecise: false,
    latitude: 41.76782,
    longitude: -70.53281,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02561',
  },
  {
    city: 'Sagamore Beach',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 389,
    imprecise: false,
    latitude: 41.78753,
    longitude: -70.52746,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02562',
  },
  {
    city: 'Sandwich',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 304.9,
    imprecise: false,
    latitude: 41.71995,
    longitude: -70.4818,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02563',
  },
  {
    city: 'Siasconset',
    county_fips: 25019,
    county_fips_all: '25019',
    county: 'Nantucket',
    county_names_all: 'Nantucket',
    county_weights: '{"25019": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 41.26552,
    longitude: -69.98608,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02564',
  },
  {
    city: 'Vineyard Haven',
    county_fips: 25007,
    county_fips_all: '25007',
    county: 'Dukes',
    county_names_all: 'Dukes',
    county_weights: '{"25007": 100}',
    density: 282.8,
    imprecise: false,
    latitude: 41.44341,
    longitude: -70.61534,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02568',
  },
  {
    city: 'Wareham',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 232.4,
    imprecise: false,
    latitude: 41.76184,
    longitude: -70.70138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02571',
  },
  {
    city: 'West Tisbury',
    county_fips: 25007,
    county_fips_all: '25007',
    county: 'Dukes',
    county_names_all: 'Dukes',
    county_weights: '{"25007": 100}',
    density: 46.1,
    imprecise: false,
    latitude: 41.39651,
    longitude: -70.65496,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02575',
  },
  {
    city: 'West Wareham',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 171.1,
    imprecise: false,
    latitude: 41.77807,
    longitude: -70.76338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02576',
  },
  {
    city: 'Nantucket',
    county_fips: 25019,
    county_fips_all: '25019',
    county: 'Nantucket',
    county_names_all: 'Nantucket',
    county_weights: '{"25019": 100}',
    density: 45.3,
    imprecise: false,
    latitude: 41.25753,
    longitude: -70.00522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02584',
  },
  {
    city: 'Hyannis',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 707.6,
    imprecise: false,
    latitude: 41.66,
    longitude: -70.29327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02601',
  },
  {
    city: 'Barnstable',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 187.6,
    imprecise: false,
    latitude: 41.69674,
    longitude: -70.3052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02630',
  },
  {
    city: 'Brewster',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 175,
    imprecise: false,
    latitude: 41.74673,
    longitude: -70.06894,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02631',
  },
  {
    city: 'Centerville',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 604.7,
    imprecise: false,
    latitude: 41.66074,
    longitude: -70.34826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02632',
  },
  {
    city: 'Chatham',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 201.8,
    imprecise: false,
    latitude: 41.68949,
    longitude: -69.97397,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02633',
  },
  {
    city: 'Cotuit',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 251.6,
    imprecise: false,
    latitude: 41.62348,
    longitude: -70.44051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02635',
  },
  {
    city: 'Cummaquid',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 113.5,
    imprecise: false,
    latitude: 41.70493,
    longitude: -70.27245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02637',
  },
  {
    city: 'Dennis',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 222.8,
    imprecise: false,
    latitude: 41.73225,
    longitude: -70.19459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02638',
  },
  {
    city: 'Dennis Port',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 525.7,
    imprecise: false,
    latitude: 41.66639,
    longitude: -70.13535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02639',
  },
  {
    city: 'East Dennis',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 73.6,
    imprecise: false,
    latitude: 41.75221,
    longitude: -70.15176,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02641',
  },
  {
    city: 'Eastham',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 160.6,
    imprecise: false,
    latitude: 41.83976,
    longitude: -69.97711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02642',
  },
  {
    city: 'East Orleans',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.75534,
    longitude: -69.94002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02643',
  },
  {
    city: 'Forestdale',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 423.4,
    imprecise: false,
    latitude: 41.68361,
    longitude: -70.51202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02644',
  },
  {
    city: 'Harwich',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 257.5,
    imprecise: false,
    latitude: 41.70352,
    longitude: -70.06215,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02645',
  },
  {
    city: 'Harwich Port',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 245.5,
    imprecise: false,
    latitude: 41.67103,
    longitude: -70.07144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02646',
  },
  {
    city: 'Hyannis Port',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 187.1,
    imprecise: false,
    latitude: 41.63127,
    longitude: -70.30909,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02647',
  },
  {
    city: 'Marstons Mills',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 308.2,
    imprecise: false,
    latitude: 41.67237,
    longitude: -70.41545,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02648',
  },
  {
    city: 'Mashpee',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 253.9,
    imprecise: false,
    latitude: 41.61778,
    longitude: -70.49077,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02649',
  },
  {
    city: 'North Chatham',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 292.1,
    imprecise: false,
    latitude: 41.7036,
    longitude: -69.96589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02650',
  },
  {
    city: 'North Truro',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 38.8,
    imprecise: false,
    latitude: 42.0428,
    longitude: -70.09276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02652',
  },
  {
    city: 'Orleans',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 206.4,
    imprecise: false,
    latitude: 41.76901,
    longitude: -69.9737,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02653',
  },
  {
    city: 'Osterville',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 240.1,
    imprecise: false,
    latitude: 41.62972,
    longitude: -70.39263,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02655',
  },
  {
    city: 'Provincetown',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 147.8,
    imprecise: false,
    latitude: 42.06139,
    longitude: -70.19813,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02657',
  },
  {
    city: 'South Chatham',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 221.5,
    imprecise: false,
    latitude: 41.68258,
    longitude: -70.02234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02659',
  },
  {
    city: 'South Dennis',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 294.2,
    imprecise: false,
    latitude: 41.70828,
    longitude: -70.15517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02660',
  },
  {
    city: 'South Wellfleet',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 59.9,
    imprecise: false,
    latitude: 41.90576,
    longitude: -69.989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02663',
  },
  {
    city: 'South Yarmouth',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 550,
    imprecise: false,
    latitude: 41.67486,
    longitude: -70.19446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02664',
  },
  {
    city: 'Truro',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 41.98817,
    longitude: -70.04603,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02666',
  },
  {
    city: 'Wellfleet',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 90.3,
    imprecise: false,
    latitude: 41.92937,
    longitude: -70.02074,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02667',
  },
  {
    city: 'West Barnstable',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 76.1,
    imprecise: false,
    latitude: 41.70713,
    longitude: -70.36246,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02668',
  },
  {
    city: 'West Dennis',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 197.6,
    imprecise: false,
    latitude: 41.66,
    longitude: -70.17098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02670',
  },
  {
    city: 'West Harwich',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 182.1,
    imprecise: false,
    latitude: 41.66938,
    longitude: -70.11087,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02671',
  },
  {
    city: 'West Hyannisport',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.6357,
    longitude: -70.31878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02672',
  },
  {
    city: 'West Yarmouth',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 357.9,
    imprecise: false,
    latitude: 41.6557,
    longitude: -70.24447,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02673',
  },
  {
    city: 'Yarmouth Port',
    county_fips: 25001,
    county_fips_all: '25001',
    county: 'Barnstable',
    county_names_all: 'Barnstable',
    county_weights: '{"25001": 100}',
    density: 321.5,
    imprecise: false,
    latitude: 41.70401,
    longitude: -70.22883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02675',
  },
  {
    city: 'Assonet',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 103.1,
    imprecise: false,
    latitude: 41.78452,
    longitude: -71.06112,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02702',
  },
  {
    city: 'Attleboro',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 673.9,
    imprecise: false,
    latitude: 41.93108,
    longitude: -71.29499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02703',
  },
  {
    city: 'Cuttyhunk',
    county_fips: 25007,
    county_fips_all: '25007',
    county: 'Dukes',
    county_names_all: 'Dukes',
    county_weights: '{"25007": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 41.42818,
    longitude: -70.89102,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02713',
  },
  {
    city: 'Dighton',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 129.8,
    imprecise: false,
    latitude: 41.81681,
    longitude: -71.15064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02715',
  },
  {
    city: 'East Freetown',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 83.5,
    imprecise: false,
    latitude: 41.75405,
    longitude: -70.98312,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02717',
  },
  {
    city: 'East Taunton',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 258.1,
    imprecise: false,
    latitude: 41.86902,
    longitude: -71.01128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02718',
  },
  {
    city: 'Fairhaven',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 495.9,
    imprecise: false,
    latitude: 41.63945,
    longitude: -70.87322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02719',
  },
  {
    city: 'Fall River',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 906.2,
    imprecise: false,
    latitude: 41.73095,
    longitude: -71.10932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02720',
  },
  {
    city: 'Fall River',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 2545.3,
    imprecise: false,
    latitude: 41.67451,
    longitude: -71.14869,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02721',
  },
  {
    city: 'Fall River',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 4132.2,
    imprecise: false,
    latitude: 41.69237,
    longitude: -71.1309,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02723',
  },
  {
    city: 'Fall River',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 3967.1,
    imprecise: false,
    latitude: 41.68372,
    longitude: -71.17949,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02724',
  },
  {
    city: 'Somerset',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 367.2,
    imprecise: false,
    latitude: 41.71253,
    longitude: -71.18426,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02725',
  },
  {
    city: 'Somerset',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 1120.7,
    imprecise: false,
    latitude: 41.76073,
    longitude: -71.14444,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02726',
  },
  {
    city: 'Marion',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 145.2,
    imprecise: false,
    latitude: 41.7092,
    longitude: -70.76362,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02738',
  },
  {
    city: 'Mattapoisett',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 147.8,
    imprecise: false,
    latitude: 41.6687,
    longitude: -70.81705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02739',
  },
  {
    city: 'New Bedford',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 3109.1,
    imprecise: false,
    latitude: 41.63802,
    longitude: -70.93839,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02740',
  },
  {
    city: 'Acushnet',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 224.9,
    imprecise: false,
    latitude: 41.71323,
    longitude: -70.90054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02743',
  },
  {
    city: 'New Bedford',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 3773.9,
    imprecise: false,
    latitude: 41.60789,
    longitude: -70.91286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02744',
  },
  {
    city: 'New Bedford',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 964.1,
    imprecise: false,
    latitude: 41.70284,
    longitude: -70.94695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02745',
  },
  {
    city: 'New Bedford',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 2375.8,
    imprecise: false,
    latitude: 41.66474,
    longitude: -70.945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02746',
  },
  {
    city: 'North Dartmouth',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 211.4,
    imprecise: false,
    latitude: 41.6577,
    longitude: -71.01202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02747',
  },
  {
    city: 'South Dartmouth',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 187.7,
    imprecise: false,
    latitude: 41.56096,
    longitude: -70.97963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02748',
  },
  {
    city: 'North Attleboro',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 627.3,
    imprecise: false,
    latitude: 41.97004,
    longitude: -71.33586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02760',
  },
  {
    city: 'Plainville',
    county_fips: 25021,
    county_fips_all: '25021',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"25021": 100}',
    density: 349.4,
    imprecise: false,
    latitude: 42.01409,
    longitude: -71.33642,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02762',
  },
  {
    city: 'Attleboro Falls',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 777.8,
    imprecise: false,
    latitude: 41.96666,
    longitude: -71.30743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02763',
  },
  {
    city: 'North Dighton',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 157.1,
    imprecise: false,
    latitude: 41.8562,
    longitude: -71.16022,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02764',
  },
  {
    city: 'Norton',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 266.9,
    imprecise: false,
    latitude: 41.96402,
    longitude: -71.18418,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02766',
  },
  {
    city: 'Raynham',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 243.3,
    imprecise: false,
    latitude: 41.93939,
    longitude: -71.05191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02767',
  },
  {
    city: 'Rehoboth',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 107.1,
    imprecise: false,
    latitude: 41.84394,
    longitude: -71.24559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02769',
  },
  {
    city: 'Rochester',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 69.3,
    imprecise: false,
    latitude: 41.75875,
    longitude: -70.84048,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02770',
  },
  {
    city: 'Seekonk',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 329.5,
    imprecise: false,
    latitude: 41.83787,
    longitude: -71.31736,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02771',
  },
  {
    city: 'Swansea',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 296.1,
    imprecise: false,
    latitude: 41.75699,
    longitude: -71.21208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02777',
  },
  {
    city: 'Berkley',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 159.7,
    imprecise: false,
    latitude: 41.83492,
    longitude: -71.07543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02779',
  },
  {
    city: 'Taunton',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 623.1,
    imprecise: false,
    latitude: 41.90743,
    longitude: -71.11939,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02780',
  },
  {
    city: 'Westport',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 121.1,
    imprecise: false,
    latitude: 41.59967,
    longitude: -71.08266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02790',
  },
  {
    city: 'Westport Point',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 85.9,
    imprecise: false,
    latitude: 41.52262,
    longitude: -71.08266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02791',
  },
  {
    city: 'Albion',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 1351.7,
    imprecise: false,
    latitude: 41.95221,
    longitude: -71.4559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02802',
  },
  {
    city: 'Ashaway',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 85.4,
    imprecise: false,
    latitude: 41.43546,
    longitude: -71.77196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02804',
  },
  {
    city: 'Barrington',
    county_fips: 44001,
    county_fips_all: '44001',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"44001": 100}',
    density: 807.9,
    imprecise: false,
    latitude: 41.7443,
    longitude: -71.31453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02806',
  },
  {
    city: 'Block Island',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 33,
    imprecise: false,
    latitude: 41.17762,
    longitude: -71.57854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02807',
  },
  {
    city: 'Bradford',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 135.2,
    imprecise: false,
    latitude: 41.40606,
    longitude: -71.74802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02808',
  },
  {
    city: 'Bristol',
    county_fips: 44001,
    county_fips_all: '44001',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"44001": 100}',
    density: 876.4,
    imprecise: false,
    latitude: 41.68266,
    longitude: -71.26938,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02809',
  },
  {
    city: 'Carolina',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 143,
    imprecise: false,
    latitude: 41.47625,
    longitude: -71.66094,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02812',
  },
  {
    city: 'Charlestown',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 84.7,
    imprecise: false,
    latitude: 41.3971,
    longitude: -71.67003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02813',
  },
  {
    city: 'Chepachet',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 67.5,
    imprecise: false,
    latitude: 41.89959,
    longitude: -71.69888,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02814',
  },
  {
    city: 'Coventry',
    county_fips: 44003,
    county_fips_all: '44003',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"44003": 100}',
    density: 348,
    imprecise: false,
    latitude: 41.69035,
    longitude: -71.61954,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02816',
  },
  {
    city: 'West Greenwich',
    county_fips: 44003,
    county_fips_all: '44003|44009',
    county: 'Kent',
    county_names_all: 'Kent|Washington',
    county_weights: '{"44003": 99.69, "44009": 0.31}',
    density: 51,
    imprecise: false,
    latitude: 41.6291,
    longitude: -71.66711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02817',
  },
  {
    city: 'East Greenwich',
    county_fips: 44003,
    county_fips_all: '44003',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"44003": 100}',
    density: 359.9,
    imprecise: false,
    latitude: 41.64214,
    longitude: -71.49307,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02818',
  },
  {
    city: 'Exeter',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 46.5,
    imprecise: false,
    latitude: 41.56736,
    longitude: -71.63348,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02822',
  },
  {
    city: 'Fiskeville',
    county_fips: 44007,
    county_fips_all: '44007|44003',
    county: 'Providence',
    county_names_all: 'Providence|Kent',
    county_weights: '{"44007": 99.83, "44003": 0.17}',
    density: 106.7,
    imprecise: false,
    latitude: 41.73328,
    longitude: -71.54479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02823',
  },
  {
    city: 'Forestdale',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 919.9,
    imprecise: false,
    latitude: 41.99934,
    longitude: -71.56322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02824',
  },
  {
    city: 'Foster',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 42.8,
    imprecise: false,
    latitude: 41.78212,
    longitude: -71.72596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02825',
  },
  {
    city: 'Glendale',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 131.7,
    imprecise: false,
    latitude: 41.98248,
    longitude: -71.64539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02826',
  },
  {
    city: 'Greene',
    county_fips: 44003,
    county_fips_all: '44003',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"44003": 100}',
    density: 44.5,
    imprecise: false,
    latitude: 41.69792,
    longitude: -71.73847,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02827',
  },
  {
    city: 'Greenville',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 623.9,
    imprecise: false,
    latitude: 41.87672,
    longitude: -71.56065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02828',
  },
  {
    city: 'Harmony',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 41.89377,
    longitude: -71.59129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02829',
  },
  {
    city: 'Harrisville',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 125.6,
    imprecise: false,
    latitude: 41.98016,
    longitude: -71.6484,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02830',
  },
  {
    city: 'Hope',
    county_fips: 44007,
    county_fips_all: '44007|44003',
    county: 'Providence',
    county_names_all: 'Providence|Kent',
    county_weights: '{"44007": 93.75, "44003": 6.25}',
    density: 125.1,
    imprecise: false,
    latitude: 41.74461,
    longitude: -71.58442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02831',
  },
  {
    city: 'Hope Valley',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 77.8,
    imprecise: false,
    latitude: 41.50469,
    longitude: -71.72807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02832',
  },
  {
    city: 'Hopkinton',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 55.1,
    imprecise: false,
    latitude: 41.48117,
    longitude: -71.77787,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02833',
  },
  {
    city: 'Jamestown',
    county_fips: 44005,
    county_fips_all: '44005',
    county: 'Newport',
    county_names_all: 'Newport',
    county_weights: '{"44005": 100}',
    density: 228.1,
    imprecise: false,
    latitude: 41.51479,
    longitude: -71.37742,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02835',
  },
  {
    city: 'Little Compton',
    county_fips: 44005,
    county_fips_all: '44005',
    county: 'Newport',
    county_names_all: 'Newport',
    county_weights: '{"44005": 100}',
    density: 67.4,
    imprecise: false,
    latitude: 41.51524,
    longitude: -71.16455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02837',
  },
  {
    city: 'Manville',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 1033.8,
    imprecise: false,
    latitude: 41.96552,
    longitude: -71.47628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02838',
  },
  {
    city: 'Mapleville',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 136.6,
    imprecise: false,
    latitude: 41.9433,
    longitude: -71.64581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02839',
  },
  {
    city: 'Newport',
    county_fips: 44005,
    county_fips_all: '44005',
    county: 'Newport',
    county_names_all: 'Newport',
    county_weights: '{"44005": 100}',
    density: 1243.9,
    imprecise: false,
    latitude: 41.47838,
    longitude: -71.31993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02840',
  },
  {
    city: 'Newport',
    county_fips: 44005,
    county_fips_all: '44005',
    county: 'Newport',
    county_names_all: 'Newport',
    county_weights: '{"44005": 100}',
    density: 1598.1,
    imprecise: false,
    latitude: 41.51261,
    longitude: -71.32522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02841',
  },
  {
    city: 'Middletown',
    county_fips: 44005,
    county_fips_all: '44005',
    county: 'Newport',
    county_names_all: 'Newport',
    county_weights: '{"44005": 100}',
    density: 518.4,
    imprecise: false,
    latitude: 41.51739,
    longitude: -71.27667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02842',
  },
  {
    city: 'North Kingstown',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 293.2,
    imprecise: false,
    latitude: 41.58809,
    longitude: -71.46094,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02852',
  },
  {
    city: 'North Scituate',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 73.9,
    imprecise: false,
    latitude: 41.82705,
    longitude: -71.63083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02857',
  },
  {
    city: 'Pascoag',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 98,
    imprecise: false,
    latitude: 41.9665,
    longitude: -71.7464,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02859',
  },
  {
    city: 'Pawtucket',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 3459,
    imprecise: false,
    latitude: 41.87036,
    longitude: -71.38855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02860',
  },
  {
    city: 'Pawtucket',
    county_fips: 44007,
    county_fips_all: '44007|25005',
    county: 'Providence',
    county_names_all: 'Providence|Bristol',
    county_weights: '{"44007": 99.45, "25005": 0.55}',
    density: 3040.3,
    imprecise: false,
    latitude: 41.87863,
    longitude: -71.35228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02861',
  },
  {
    city: 'Central Falls',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 7341.4,
    imprecise: false,
    latitude: 41.89005,
    longitude: -71.39336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02863',
  },
  {
    city: 'Cumberland',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 537.1,
    imprecise: false,
    latitude: 41.97025,
    longitude: -71.41978,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02864',
  },
  {
    city: 'Lincoln',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 432.3,
    imprecise: false,
    latitude: 41.91251,
    longitude: -71.44822,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02865',
  },
  {
    city: 'Portsmouth',
    county_fips: 44005,
    county_fips_all: '44005',
    county: 'Newport',
    county_names_all: 'Newport',
    county_weights: '{"44005": 100}',
    density: 395.6,
    imprecise: false,
    latitude: 41.58384,
    longitude: -71.2564,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02871',
  },
  {
    city: 'Prudence Island',
    county_fips: 44005,
    county_fips_all: '44005',
    county: 'Newport',
    county_names_all: 'Newport',
    county_weights: '{"44005": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 41.61718,
    longitude: -71.32886,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02872',
  },
  {
    city: 'Rockville',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 41.5257,
    longitude: -71.77734,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02873',
  },
  {
    city: 'Saunderstown',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 158.2,
    imprecise: false,
    latitude: 41.51543,
    longitude: -71.46985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02874',
  },
  {
    city: 'Shannock',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 41.46052,
    longitude: -71.63848,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02875',
  },
  {
    city: 'Slatersville',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 688,
    imprecise: false,
    latitude: 41.99801,
    longitude: -71.58301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02876',
  },
  {
    city: 'Tiverton',
    county_fips: 44005,
    county_fips_all: '44005',
    county: 'Newport',
    county_names_all: 'Newport',
    county_weights: '{"44005": 100}',
    density: 215.1,
    imprecise: false,
    latitude: 41.60905,
    longitude: -71.17413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02878',
  },
  {
    city: 'Wakefield',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 213.1,
    imprecise: false,
    latitude: 41.42865,
    longitude: -71.53837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02879',
  },
  {
    city: 'Kingston',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 881.1,
    imprecise: false,
    latitude: 41.4825,
    longitude: -71.52694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02881',
  },
  {
    city: 'Narragansett',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 393.7,
    imprecise: false,
    latitude: 41.4253,
    longitude: -71.46816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02882',
  },
  {
    city: 'Warren',
    county_fips: 44001,
    county_fips_all: '44001',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"44001": 100}',
    density: 698.7,
    imprecise: false,
    latitude: 41.72821,
    longitude: -71.26287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02885',
  },
  {
    city: 'Warwick',
    county_fips: 44003,
    county_fips_all: '44003',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"44003": 100}',
    density: 764.9,
    imprecise: false,
    latitude: 41.70493,
    longitude: -71.45892,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02886',
  },
  {
    city: 'Warwick',
    county_fips: 44003,
    county_fips_all: '44003',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"44003": 100}',
    density: 1252.8,
    imprecise: false,
    latitude: 41.74909,
    longitude: -71.41123,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02888',
  },
  {
    city: 'Warwick',
    county_fips: 44003,
    county_fips_all: '44003',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"44003": 100}',
    density: 1256.4,
    imprecise: false,
    latitude: 41.70602,
    longitude: -71.39106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02889',
  },
  {
    city: 'Westerly',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 317.1,
    imprecise: false,
    latitude: 41.36043,
    longitude: -71.79429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02891',
  },
  {
    city: 'West Kingston',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 81.8,
    imprecise: false,
    latitude: 41.50226,
    longitude: -71.60174,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02892',
  },
  {
    city: 'West Warwick',
    county_fips: 44003,
    county_fips_all: '44003',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"44003": 100}',
    density: 1536.7,
    imprecise: false,
    latitude: 41.69856,
    longitude: -71.51566,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02893',
  },
  {
    city: 'Wood River Junction',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 76.3,
    imprecise: false,
    latitude: 41.44761,
    longitude: -71.69759,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02894',
  },
  {
    city: 'Woonsocket',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 2164.3,
    imprecise: false,
    latitude: 42.00103,
    longitude: -71.49923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02895',
  },
  {
    city: 'North Smithfield',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 194.2,
    imprecise: false,
    latitude: 41.97285,
    longitude: -71.55027,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02896',
  },
  {
    city: 'Wyoming',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 62.1,
    imprecise: false,
    latitude: 41.52184,
    longitude: -71.67166,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02898',
  },
  {
    city: 'Providence',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 2723.3,
    imprecise: false,
    latitude: 41.81902,
    longitude: -71.41003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02903',
  },
  {
    city: 'Providence',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 2426.5,
    imprecise: false,
    latitude: 41.86058,
    longitude: -71.43539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02904',
  },
  {
    city: 'Providence',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 2579.1,
    imprecise: false,
    latitude: 41.78769,
    longitude: -71.39886,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02905',
  },
  {
    city: 'Providence',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 3286.4,
    imprecise: false,
    latitude: 41.83964,
    longitude: -71.38963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02906',
  },
  {
    city: 'Providence',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 5502.2,
    imprecise: false,
    latitude: 41.79867,
    longitude: -71.42581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02907',
  },
  {
    city: 'Providence',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 4482.8,
    imprecise: false,
    latitude: 41.83877,
    longitude: -71.43926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02908',
  },
  {
    city: 'Providence',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 5675.6,
    imprecise: false,
    latitude: 41.81825,
    longitude: -71.45078,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02909',
  },
  {
    city: 'Cranston',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 2642.8,
    imprecise: false,
    latitude: 41.77552,
    longitude: -71.43564,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02910',
  },
  {
    city: 'North Providence',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 2417.8,
    imprecise: false,
    latitude: 41.85467,
    longitude: -71.47325,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02911',
  },
  {
    city: 'East Providence',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 1718,
    imprecise: false,
    latitude: 41.81326,
    longitude: -71.36608,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02914',
  },
  {
    city: 'Riverside',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 1173.5,
    imprecise: false,
    latitude: 41.77725,
    longitude: -71.34906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02915',
  },
  {
    city: 'Rumford',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 1265.3,
    imprecise: false,
    latitude: 41.84438,
    longitude: -71.35258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02916',
  },
  {
    city: 'Smithfield',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 275.4,
    imprecise: false,
    latitude: 41.90615,
    longitude: -71.52365,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02917',
  },
  {
    city: 'Johnston',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 489.5,
    imprecise: false,
    latitude: 41.82733,
    longitude: -71.52002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02919',
  },
  {
    city: 'Cranston',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 1603.2,
    imprecise: false,
    latitude: 41.76719,
    longitude: -71.4655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02920',
  },
  {
    city: 'Cranston',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 360.1,
    imprecise: false,
    latitude: 41.76292,
    longitude: -71.51571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02921',
  },
  {
    city: 'Amherst',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 134.9,
    imprecise: false,
    latitude: 42.87056,
    longitude: -71.60683,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03031',
  },
  {
    city: 'Auburn',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 93.2,
    imprecise: false,
    latitude: 42.99063,
    longitude: -71.34383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03032',
  },
  {
    city: 'Brookline',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 111.7,
    imprecise: false,
    latitude: 42.74643,
    longitude: -71.67054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03033',
  },
  {
    city: 'Candia',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 51.8,
    imprecise: false,
    latitude: 43.06269,
    longitude: -71.31106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03034',
  },
  {
    city: 'Chester',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 78.7,
    imprecise: false,
    latitude: 42.96719,
    longitude: -71.25083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03036',
  },
  {
    city: 'Deerfield',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 37.4,
    imprecise: false,
    latitude: 43.1395,
    longitude: -71.2535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03037',
  },
  {
    city: 'Derry',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 371.3,
    imprecise: false,
    latitude: 42.88867,
    longitude: -71.27932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03038',
  },
  {
    city: 'Epping',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 110.2,
    imprecise: false,
    latitude: 43.05009,
    longitude: -71.07467,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03042',
  },
  {
    city: 'Francestown',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 42.99581,
    longitude: -71.81514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03043',
  },
  {
    city: 'Fremont',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 108.6,
    imprecise: false,
    latitude: 42.98899,
    longitude: -71.12494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03044',
  },
  {
    city: 'Goffstown',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 151.4,
    imprecise: false,
    latitude: 43.01994,
    longitude: -71.57035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03045',
  },
  {
    city: 'Dunbarton',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 38.7,
    imprecise: false,
    latitude: 43.10178,
    longitude: -71.60548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03046',
  },
  {
    city: 'Greenfield',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 25.3,
    imprecise: false,
    latitude: 42.94029,
    longitude: -71.87053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03047',
  },
  {
    city: 'Greenville',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 44.1,
    imprecise: false,
    latitude: 42.74668,
    longitude: -71.76268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03048',
  },
  {
    city: 'Hollis',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 104.7,
    imprecise: false,
    latitude: 42.7494,
    longitude: -71.58338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03049',
  },
  {
    city: 'Hudson',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 348.9,
    imprecise: false,
    latitude: 42.76394,
    longitude: -71.40716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03051',
  },
  {
    city: 'Litchfield',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 219.9,
    imprecise: false,
    latitude: 42.84302,
    longitude: -71.455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03052',
  },
  {
    city: 'Londonderry',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 243.9,
    imprecise: false,
    latitude: 42.87927,
    longitude: -71.38702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03053',
  },
  {
    city: 'Merrimack',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 334,
    imprecise: false,
    latitude: 42.85471,
    longitude: -71.51878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03054',
  },
  {
    city: 'Milford',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 248.3,
    imprecise: false,
    latitude: 42.81783,
    longitude: -71.67361,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03055',
  },
  {
    city: 'Mont Vernon',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 58.4,
    imprecise: false,
    latitude: 42.90265,
    longitude: -71.6861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03057',
  },
  {
    city: 'Nashua',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 1863.6,
    imprecise: false,
    latitude: 42.74135,
    longitude: -71.45936,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03060',
  },
  {
    city: 'Nashua',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 945,
    imprecise: false,
    latitude: 42.72212,
    longitude: -71.49556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03062',
  },
  {
    city: 'Nashua',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 752.4,
    imprecise: false,
    latitude: 42.7795,
    longitude: -71.51939,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03063',
  },
  {
    city: 'Nashua',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 1343.9,
    imprecise: false,
    latitude: 42.77886,
    longitude: -71.47466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03064',
  },
  {
    city: 'New Boston',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 55.4,
    imprecise: false,
    latitude: 42.97702,
    longitude: -71.68664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03070',
  },
  {
    city: 'New Ipswich',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 62.7,
    imprecise: false,
    latitude: 42.74892,
    longitude: -71.8747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03071',
  },
  {
    city: 'Pelham',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 211.8,
    imprecise: false,
    latitude: 42.73354,
    longitude: -71.324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03076',
  },
  {
    city: 'Raymond',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 146,
    imprecise: false,
    latitude: 43.03219,
    longitude: -71.19945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03077',
  },
  {
    city: 'Salem',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 481.2,
    imprecise: false,
    latitude: 42.79023,
    longitude: -71.22024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03079',
  },
  {
    city: 'Lyndeborough',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 42.90197,
    longitude: -71.77545,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03082',
  },
  {
    city: 'Temple',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 42.82856,
    longitude: -71.85495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03084',
  },
  {
    city: 'Wilton',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 58.5,
    imprecise: false,
    latitude: 42.82741,
    longitude: -71.76967,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03086',
  },
  {
    city: 'Windham',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 231.5,
    imprecise: false,
    latitude: 42.80758,
    longitude: -71.29945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03087',
  },
  {
    city: 'Manchester',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 1615,
    imprecise: false,
    latitude: 42.98881,
    longitude: -71.4659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03101',
  },
  {
    city: 'Manchester',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 1446.4,
    imprecise: false,
    latitude: 43.00797,
    longitude: -71.49134,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03102',
  },
  {
    city: 'Manchester',
    county_fips: 33011,
    county_fips_all: '33011|33015',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough|Rockingham',
    county_weights: '{"33011": 97.28, "33015": 2.72}',
    density: 1587.6,
    imprecise: false,
    latitude: 42.95536,
    longitude: -71.44463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03103',
  },
  {
    city: 'Manchester',
    county_fips: 33011,
    county_fips_all: '33011|33013',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough|Merrimack',
    county_weights: '{"33011": 99.58, "33013": 0.42}',
    density: 1632.3,
    imprecise: false,
    latitude: 43.00926,
    longitude: -71.4411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03104',
  },
  {
    city: 'Hooksett',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 161.1,
    imprecise: false,
    latitude: 43.07097,
    longitude: -71.43651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03106',
  },
  {
    city: 'Manchester',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 529,
    imprecise: false,
    latitude: 42.96594,
    longitude: -71.40167,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03109',
  },
  {
    city: 'Bedford',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 279.7,
    imprecise: false,
    latitude: 42.94065,
    longitude: -71.53023,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03110',
  },
  {
    city: 'Waterville Valley',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 44.03605,
    longitude: -71.48109,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03215',
  },
  {
    city: 'Andover',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 43.44656,
    longitude: -71.79374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03216',
  },
  {
    city: 'Ashland',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 75.1,
    imprecise: false,
    latitude: 43.71492,
    longitude: -71.63033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03217',
  },
  {
    city: 'Barnstead',
    county_fips: 33001,
    county_fips_all: '33001',
    county: 'Belknap',
    county_names_all: 'Belknap',
    county_weights: '{"33001": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 43.33465,
    longitude: -71.28803,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03218',
  },
  {
    city: 'Belmont',
    county_fips: 33001,
    county_fips_all: '33001|33013',
    county: 'Belknap',
    county_names_all: 'Belknap|Merrimack',
    county_weights: '{"33001": 98.91, "33013": 1.09}',
    density: 94.3,
    imprecise: false,
    latitude: 43.46793,
    longitude: -71.4758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03220',
  },
  {
    city: 'Bradford',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 43.25482,
    longitude: -71.96122,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03221',
  },
  {
    city: 'Bristol',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 33,
    imprecise: false,
    latitude: 43.62895,
    longitude: -71.78234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03222',
  },
  {
    city: 'Campton',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 19,
    imprecise: false,
    latitude: 43.84784,
    longitude: -71.67597,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03223',
  },
  {
    city: 'Canterbury',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 43.35171,
    longitude: -71.54691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03224',
  },
  {
    city: 'Center Barnstead',
    county_fips: 33001,
    county_fips_all: '33001',
    county: 'Belknap',
    county_names_all: 'Belknap',
    county_weights: '{"33001": 100}',
    density: 53.3,
    imprecise: false,
    latitude: 43.36001,
    longitude: -71.23828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03225',
  },
  {
    city: 'Center Harbor',
    county_fips: 33001,
    county_fips_all: '33001',
    county: 'Belknap',
    county_names_all: 'Belknap',
    county_weights: '{"33001": 100}',
    density: 28.3,
    imprecise: false,
    latitude: 43.70259,
    longitude: -71.51086,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03226',
  },
  {
    city: 'Center Sandwich',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 43.81419,
    longitude: -71.45712,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03227',
  },
  {
    city: 'Contoocook',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 53.9,
    imprecise: false,
    latitude: 43.19792,
    longitude: -71.69677,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03229',
  },
  {
    city: 'Danbury',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 43.52685,
    longitude: -71.8622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03230',
  },
  {
    city: 'East Andover',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 120.1,
    imprecise: false,
    latitude: 43.45555,
    longitude: -71.75551,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03231',
  },
  {
    city: 'Elkins',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 135.6,
    imprecise: false,
    latitude: 43.42325,
    longitude: -71.93322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03233',
  },
  {
    city: 'Epsom',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 55.4,
    imprecise: false,
    latitude: 43.21484,
    longitude: -71.33914,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03234',
  },
  {
    city: 'Franklin',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 115.2,
    imprecise: false,
    latitude: 43.44831,
    longitude: -71.67208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03235',
  },
  {
    city: 'Gilmanton',
    county_fips: 33001,
    county_fips_all: '33001',
    county: 'Belknap',
    county_names_all: 'Belknap',
    county_weights: '{"33001": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 43.42997,
    longitude: -71.38233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03237',
  },
  {
    city: 'Glencliff',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 24.7,
    imprecise: false,
    latitude: 43.98168,
    longitude: -71.88701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03238',
  },
  {
    city: 'Grafton',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 43.57599,
    longitude: -71.97221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03240',
  },
  {
    city: 'Hebron',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 12,
    imprecise: false,
    latitude: 43.71149,
    longitude: -71.81915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03241',
  },
  {
    city: 'Henniker',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 54.2,
    imprecise: false,
    latitude: 43.17365,
    longitude: -71.8224,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03242',
  },
  {
    city: 'Hill',
    county_fips: 33013,
    county_fips_all: '33013|33009',
    county: 'Merrimack',
    county_names_all: 'Merrimack|Grafton',
    county_weights: '{"33013": 93.83, "33009": 6.17}',
    density: 14.4,
    imprecise: false,
    latitude: 43.5276,
    longitude: -71.7644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03243',
  },
  {
    city: 'Hillsborough',
    county_fips: 33011,
    county_fips_all: '33011|33019',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough|Sullivan',
    county_weights: '{"33011": 99.37, "33019": 0.63}',
    density: 38.2,
    imprecise: false,
    latitude: 43.11822,
    longitude: -71.9192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03244',
  },
  {
    city: 'Holderness',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 24.3,
    imprecise: false,
    latitude: 43.75026,
    longitude: -71.58852,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03245',
  },
  {
    city: 'Laconia',
    county_fips: 33001,
    county_fips_all: '33001',
    county: 'Belknap',
    county_names_all: 'Belknap',
    county_weights: '{"33001": 100}',
    density: 332.3,
    imprecise: false,
    latitude: 43.57239,
    longitude: -71.4775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03246',
  },
  {
    city: 'Gilford',
    county_fips: 33001,
    county_fips_all: '33001',
    county: 'Belknap',
    county_names_all: 'Belknap',
    county_weights: '{"33001": 100}',
    density: 78,
    imprecise: false,
    latitude: 43.55806,
    longitude: -71.38505,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03249',
  },
  {
    city: 'Lincoln',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 44.0796,
    longitude: -71.65276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03251',
  },
  {
    city: 'Meredith',
    county_fips: 33001,
    county_fips_all: '33001',
    county: 'Belknap',
    county_names_all: 'Belknap',
    county_weights: '{"33001": 100}',
    density: 69.1,
    imprecise: false,
    latitude: 43.63193,
    longitude: -71.49749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03253',
  },
  {
    city: 'Moultonborough',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 33.1,
    imprecise: false,
    latitude: 43.72505,
    longitude: -71.37782,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03254',
  },
  {
    city: 'Newbury',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 21.7,
    imprecise: false,
    latitude: 43.3149,
    longitude: -72.02795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03255',
  },
  {
    city: 'New Hampton',
    county_fips: 33001,
    county_fips_all: '33001',
    county: 'Belknap',
    county_names_all: 'Belknap',
    county_weights: '{"33001": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 43.62425,
    longitude: -71.63514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03256',
  },
  {
    city: 'New London',
    county_fips: 33013,
    county_fips_all: '33013|33019',
    county: 'Merrimack',
    county_names_all: 'Merrimack|Sullivan',
    county_weights: '{"33013": 97.1, "33019": 2.9}',
    density: 73.5,
    imprecise: false,
    latitude: 43.41768,
    longitude: -71.99101,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03257',
  },
  {
    city: 'Chichester',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 49.6,
    imprecise: false,
    latitude: 43.25744,
    longitude: -71.39956,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03258',
  },
  {
    city: 'North Sandwich',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 43.87921,
    longitude: -71.44527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03259',
  },
  {
    city: 'North Sutton',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 43.36016,
    longitude: -71.92457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03260',
  },
  {
    city: 'Northwood',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 64.2,
    imprecise: false,
    latitude: 43.21322,
    longitude: -71.20966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03261',
  },
  {
    city: 'North Woodstock',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 43.99885,
    longitude: -71.73813,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03262',
  },
  {
    city: 'Pittsfield',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 64.7,
    imprecise: false,
    latitude: 43.29483,
    longitude: -71.31133,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03263',
  },
  {
    city: 'Plymouth',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 72.8,
    imprecise: false,
    latitude: 43.72967,
    longitude: -71.71159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03264',
  },
  {
    city: 'Rumney',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 43.79407,
    longitude: -71.89035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03266',
  },
  {
    city: 'Salisbury',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 43.38505,
    longitude: -71.7574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03268',
  },
  {
    city: 'Sanbornton',
    county_fips: 33001,
    county_fips_all: '33001',
    county: 'Belknap',
    county_names_all: 'Belknap',
    county_weights: '{"33001": 100}',
    density: 23.9,
    imprecise: false,
    latitude: 43.53,
    longitude: -71.60219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03269',
  },
  {
    city: 'South Sutton',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 43.30337,
    longitude: -71.92413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03273',
  },
  {
    city: 'Suncook',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 109.5,
    imprecise: false,
    latitude: 43.15999,
    longitude: -71.41794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03275',
  },
  {
    city: 'Tilton',
    county_fips: 33013,
    county_fips_all: '33013|33001',
    county: 'Merrimack',
    county_names_all: 'Merrimack|Belknap',
    county_weights: '{"33013": 70.39, "33001": 29.61}',
    density: 88.6,
    imprecise: false,
    latitude: 43.42783,
    longitude: -71.57514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03276',
  },
  {
    city: 'Warner',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 43.29313,
    longitude: -71.82934,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03278',
  },
  {
    city: 'Warren',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 43.94468,
    longitude: -71.88231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03279',
  },
  {
    city: 'Washington',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 43.18339,
    longitude: -72.08979,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03280',
  },
  {
    city: 'Weare',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 59.9,
    imprecise: false,
    latitude: 43.08126,
    longitude: -71.72189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03281',
  },
  {
    city: 'Wentworth',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 43.86006,
    longitude: -71.9295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03282',
  },
  {
    city: 'Springfield',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 9,
    imprecise: false,
    latitude: 43.49361,
    longitude: -72.03057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03284',
  },
  {
    city: 'Thornton',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 43.92408,
    longitude: -71.64359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03285',
  },
  {
    city: 'Wilmot',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 43.45168,
    longitude: -71.91795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03287',
  },
  {
    city: 'Nottingham',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 44.7,
    imprecise: false,
    latitude: 43.12391,
    longitude: -71.12089,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03290',
  },
  {
    city: 'West Nottingham',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.17976,
    longitude: -71.14205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03291',
  },
  {
    city: 'Woodstock',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 43.97696,
    longitude: -71.67721,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03293',
  },
  {
    city: 'Concord',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 266.6,
    imprecise: false,
    latitude: 43.22423,
    longitude: -71.54342,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03301',
  },
  {
    city: 'Concord',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 94.4,
    imprecise: false,
    latitude: 43.29819,
    longitude: -71.67186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03303',
  },
  {
    city: 'Bow',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 114.2,
    imprecise: false,
    latitude: 43.13078,
    longitude: -71.53066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03304',
  },
  {
    city: 'Loudon',
    county_fips: 33013,
    county_fips_all: '33013',
    county: 'Merrimack',
    county_names_all: 'Merrimack',
    county_weights: '{"33013": 100}',
    density: 47.1,
    imprecise: false,
    latitude: 43.32257,
    longitude: -71.44265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03307',
  },
  {
    city: 'Keene',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 161.4,
    imprecise: false,
    latitude: 42.96785,
    longitude: -72.29862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03431',
  },
  {
    city: 'Antrim',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 32.8,
    imprecise: false,
    latitude: 43.06023,
    longitude: -71.97446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03440',
  },
  {
    city: 'Ashuelot',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 53.1,
    imprecise: false,
    latitude: 42.77737,
    longitude: -72.44263,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03441',
  },
  {
    city: 'Bennington',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 53.8,
    imprecise: false,
    latitude: 43.01268,
    longitude: -71.90781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03442',
  },
  {
    city: 'Chesterfield',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 42.8767,
    longitude: -72.46148,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03443',
  },
  {
    city: 'Dublin',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 23.3,
    imprecise: false,
    latitude: 42.89403,
    longitude: -72.07178,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03444',
  },
  {
    city: 'Sullivan',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 43.01555,
    longitude: -72.2137,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03445',
  },
  {
    city: 'Swanzey',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 57.4,
    imprecise: false,
    latitude: 42.86163,
    longitude: -72.29639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03446',
  },
  {
    city: 'Fitzwilliam',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 42.7592,
    longitude: -72.14794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03447',
  },
  {
    city: 'Gilsum',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 43.03996,
    longitude: -72.26448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03448',
  },
  {
    city: 'Hancock',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 20.3,
    imprecise: false,
    latitude: 42.98222,
    longitude: -72.00037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03449',
  },
  {
    city: 'Harrisville',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 42.94157,
    longitude: -72.09107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03450',
  },
  {
    city: 'Hinsdale',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 75.2,
    imprecise: false,
    latitude: 42.80907,
    longitude: -72.50029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03451',
  },
  {
    city: 'Jaffrey',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 54.8,
    imprecise: false,
    latitude: 42.82922,
    longitude: -72.05962,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03452',
  },
  {
    city: 'Marlborough',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 36.4,
    imprecise: false,
    latitude: 42.89816,
    longitude: -72.18308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03455',
  },
  {
    city: 'Marlow',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 43.13092,
    longitude: -72.21505,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03456',
  },
  {
    city: 'Nelson',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 43.00282,
    longitude: -72.12933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03457',
  },
  {
    city: 'Peterborough',
    county_fips: 33011,
    county_fips_all: '33011',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"33011": 100}',
    density: 49.4,
    imprecise: false,
    latitude: 42.86906,
    longitude: -71.93797,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03458',
  },
  {
    city: 'Rindge',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 67.6,
    imprecise: false,
    latitude: 42.75234,
    longitude: -72.01071,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03461',
  },
  {
    city: 'Spofford',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 34.4,
    imprecise: false,
    latitude: 42.8949,
    longitude: -72.40507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03462',
  },
  {
    city: 'Stoddard',
    county_fips: 33005,
    county_fips_all: '33005|33019',
    county: 'Cheshire',
    county_names_all: 'Cheshire|Sullivan',
    county_weights: '{"33005": 99.77, "33019": 0.23}',
    density: 7.8,
    imprecise: false,
    latitude: 43.08256,
    longitude: -72.11085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03464',
  },
  {
    city: 'Troy',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 44.3,
    imprecise: false,
    latitude: 42.82677,
    longitude: -72.18988,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03465',
  },
  {
    city: 'West Chesterfield',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 32.8,
    imprecise: false,
    latitude: 42.89525,
    longitude: -72.50964,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03466',
  },
  {
    city: 'Westmoreland',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 24.1,
    imprecise: false,
    latitude: 42.96894,
    longitude: -72.43203,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03467',
  },
  {
    city: 'Winchester',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 42.77869,
    longitude: -72.34413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03470',
  },
  {
    city: 'Littleton',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 46.7,
    imprecise: false,
    latitude: 44.33222,
    longitude: -71.80973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03561',
  },
  {
    city: 'Berlin',
    county_fips: 33007,
    county_fips_all: '33007',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"33007": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 44.49953,
    longitude: -71.20396,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03570',
  },
  {
    city: 'Bethlehem',
    county_fips: 33009,
    county_fips_all: '33009|33007',
    county: 'Grafton',
    county_names_all: 'Grafton|Coos',
    county_weights: '{"33009": 99.51, "33007": 0.49}',
    density: 10.9,
    imprecise: false,
    latitude: 44.25386,
    longitude: -71.59924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03574',
  },
  {
    city: 'Colebrook',
    county_fips: 33007,
    county_fips_all: '33007',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"33007": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 44.89839,
    longitude: -71.37178,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03576',
  },
  {
    city: 'Errol',
    county_fips: 23017,
    county_fips_all: '23017|33007',
    county: 'Oxford',
    county_names_all: 'Oxford|Coos',
    county_weights: '{"23017": 58.53, "33007": 41.47}',
    density: 0.3,
    imprecise: false,
    latitude: 44.95234,
    longitude: -71.04182,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03579',
  },
  {
    city: 'Franconia',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 44.17347,
    longitude: -71.69519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03580',
  },
  {
    city: 'Gorham',
    county_fips: 33007,
    county_fips_all: '33007',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"33007": 100}',
    density: 8,
    imprecise: false,
    latitude: 44.34227,
    longitude: -71.13413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03581',
  },
  {
    city: 'Groveton',
    county_fips: 33007,
    county_fips_all: '33007',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"33007": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 44.59777,
    longitude: -71.43703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03582',
  },
  {
    city: 'Jefferson',
    county_fips: 33007,
    county_fips_all: '33007',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"33007": 100}',
    density: 7,
    imprecise: false,
    latitude: 44.40148,
    longitude: -71.4583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03583',
  },
  {
    city: 'Lancaster',
    county_fips: 33007,
    county_fips_all: '33007',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"33007": 100}',
    density: 21.8,
    imprecise: false,
    latitude: 44.48696,
    longitude: -71.54278,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03584',
  },
  {
    city: 'Lisbon',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 44.22538,
    longitude: -71.89703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03585',
  },
  {
    city: 'Sugar Hill',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 44.22058,
    longitude: -71.7963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03586',
  },
  {
    city: 'Milan',
    county_fips: 33007,
    county_fips_all: '33007',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"33007": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 44.60545,
    longitude: -71.23204,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03588',
  },
  {
    city: 'North Stratford',
    county_fips: 33007,
    county_fips_all: '33007',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"33007": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 44.74195,
    longitude: -71.51485,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03590',
  },
  {
    city: 'Pittsburg',
    county_fips: 33007,
    county_fips_all: '33007',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"33007": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 45.1128,
    longitude: -71.25493,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03592',
  },
  {
    city: 'Randolph',
    county_fips: 33007,
    county_fips_all: '33007',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"33007": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 44.29816,
    longitude: -71.31774,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03593',
  },
  {
    city: 'Twin Mountain',
    county_fips: 33007,
    county_fips_all: '33007',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"33007": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 44.30616,
    longitude: -71.527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03595',
  },
  {
    city: 'West Stewartstown',
    county_fips: 33007,
    county_fips_all: '33007',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"33007": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 44.73439,
    longitude: -71.38243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03597',
  },
  {
    city: 'Whitefield',
    county_fips: 33007,
    county_fips_all: '33007',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"33007": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 44.37998,
    longitude: -71.63179,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03598',
  },
  {
    city: 'Acworth',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 43.23933,
    longitude: -72.29855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03601',
  },
  {
    city: 'Alstead',
    county_fips: 33005,
    county_fips_all: '33005|33019',
    county: 'Cheshire',
    county_names_all: 'Cheshire|Sullivan',
    county_weights: '{"33005": 63.49, "33019": 36.51}',
    density: 15,
    imprecise: false,
    latitude: 43.13751,
    longitude: -72.32938,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03602',
  },
  {
    city: 'Charlestown',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 45.7,
    imprecise: false,
    latitude: 43.25339,
    longitude: -72.38059,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03603',
  },
  {
    city: 'Drewsville',
    county_fips: 33005,
    county_fips_all: '33005|33019',
    county: 'Cheshire',
    county_names_all: 'Cheshire|Sullivan',
    county_weights: '{"33005": 98.78, "33019": 1.22}',
    density: 0,
    imprecise: false,
    latitude: 43.13232,
    longitude: -72.38984,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03604',
  },
  {
    city: 'Lempster',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 43.22815,
    longitude: -72.18032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03605',
  },
  {
    city: 'South Acworth',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 43.19698,
    longitude: -72.26084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03607',
  },
  {
    city: 'Walpole',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 35.7,
    imprecise: false,
    latitude: 43.07128,
    longitude: -72.40604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03608',
  },
  {
    city: 'Bath',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 44.18025,
    longitude: -71.98626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03740',
  },
  {
    city: 'Canaan',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 43.67134,
    longitude: -72.01559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03741',
  },
  {
    city: 'Claremont',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 89.5,
    imprecise: false,
    latitude: 43.36026,
    longitude: -72.32489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03743',
  },
  {
    city: 'Cornish',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 43.47407,
    longitude: -72.32001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03745',
  },
  {
    city: 'Enfield',
    county_fips: 33009,
    county_fips_all: '33009|33019',
    county: 'Grafton',
    county_names_all: 'Grafton|Sullivan',
    county_weights: '{"33009": 95.14, "33019": 4.86}',
    density: 37.6,
    imprecise: false,
    latitude: 43.60207,
    longitude: -72.11713,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03748',
  },
  {
    city: 'Etna',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 27.3,
    imprecise: false,
    latitude: 43.70681,
    longitude: -72.19308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03750',
  },
  {
    city: 'Georges Mills',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 76.7,
    imprecise: false,
    latitude: 43.44363,
    longitude: -72.08394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03751',
  },
  {
    city: 'Goshen',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 43.28909,
    longitude: -72.11489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03752',
  },
  {
    city: 'Grantham',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 48,
    imprecise: false,
    latitude: 43.51534,
    longitude: -72.14798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03753',
  },
  {
    city: 'Hanover',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 139.8,
    imprecise: false,
    latitude: 43.72377,
    longitude: -72.19563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03755',
  },
  {
    city: 'Haverhill',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 43.1,
    imprecise: false,
    latitude: 44.03452,
    longitude: -72.05231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03765',
  },
  {
    city: 'Lebanon',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 135.2,
    imprecise: false,
    latitude: 43.63491,
    longitude: -72.23819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03766',
  },
  {
    city: 'Lyme',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 43.80529,
    longitude: -72.11573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03768',
  },
  {
    city: 'Meriden',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 53,
    imprecise: false,
    latitude: 43.5336,
    longitude: -72.26469,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03770',
  },
  {
    city: 'Monroe',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 44.28443,
    longitude: -72.0098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03771',
  },
  {
    city: 'Newport',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 31.5,
    imprecise: false,
    latitude: 43.38484,
    longitude: -72.19898,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03773',
  },
  {
    city: 'North Haverhill',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 44.09097,
    longitude: -71.9947,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03774',
  },
  {
    city: 'Orford',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 43.89548,
    longitude: -72.06672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03777',
  },
  {
    city: 'Piermont',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 43.97477,
    longitude: -72.03089,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03779',
  },
  {
    city: 'Pike',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 44.03169,
    longitude: -71.97142,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03780',
  },
  {
    city: 'Plainfield',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 43.5526,
    longitude: -72.28399,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03781',
  },
  {
    city: 'Sunapee',
    county_fips: 33019,
    county_fips_all: '33019',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"33019": 100}',
    density: 59.4,
    imprecise: false,
    latitude: 43.38962,
    longitude: -72.09149,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03782',
  },
  {
    city: 'West Lebanon',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 176.4,
    imprecise: false,
    latitude: 43.63675,
    longitude: -72.30608,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03784',
  },
  {
    city: 'Woodsville',
    county_fips: 33009,
    county_fips_all: '33009',
    county: 'Grafton',
    county_names_all: 'Grafton',
    county_weights: '{"33009": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 44.06525,
    longitude: -71.87017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03785',
  },
  {
    city: 'Portsmouth',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 381.5,
    imprecise: false,
    latitude: 43.07293,
    longitude: -70.8052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03801',
  },
  {
    city: 'Alton',
    county_fips: 33001,
    county_fips_all: '33001',
    county: 'Belknap',
    county_names_all: 'Belknap',
    county_weights: '{"33001": 100}',
    density: 35.4,
    imprecise: false,
    latitude: 43.45321,
    longitude: -71.21184,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03809',
  },
  {
    city: 'Alton Bay',
    county_fips: 33001,
    county_fips_all: '33001',
    county: 'Belknap',
    county_names_all: 'Belknap',
    county_weights: '{"33001": 100}',
    density: 37.9,
    imprecise: false,
    latitude: 43.52692,
    longitude: -71.27941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03810',
  },
  {
    city: 'Atkinson',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 252.3,
    imprecise: false,
    latitude: 42.83693,
    longitude: -71.16042,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03811',
  },
  {
    city: 'Bartlett',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 44.08148,
    longitude: -71.29643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03812',
  },
  {
    city: 'Center Conway',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 44.09408,
    longitude: -71.04573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03813',
  },
  {
    city: 'Center Ossipee',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 27,
    imprecise: false,
    latitude: 43.77341,
    longitude: -71.18717,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03814',
  },
  {
    city: 'Center Tuftonboro',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 43.69753,
    longitude: -71.24218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03816',
  },
  {
    city: 'Chocorua',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 51.2,
    imprecise: false,
    latitude: 43.8885,
    longitude: -71.23358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03817',
  },
  {
    city: 'Conway',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 43.97302,
    longitude: -71.25261,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03818',
  },
  {
    city: 'Danville',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 157.1,
    imprecise: false,
    latitude: 42.93012,
    longitude: -71.12197,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03819',
  },
  {
    city: 'Dover',
    county_fips: 33017,
    county_fips_all: '33017',
    county: 'Strafford',
    county_names_all: 'Strafford',
    county_weights: '{"33017": 100}',
    density: 473.2,
    imprecise: false,
    latitude: 43.18933,
    longitude: -70.88428,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03820',
  },
  {
    city: 'Madbury',
    county_fips: 33017,
    county_fips_all: '33017',
    county: 'Strafford',
    county_names_all: 'Strafford',
    county_weights: '{"33017": 100}',
    density: 73,
    imprecise: false,
    latitude: 43.17488,
    longitude: -70.94089,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03823',
  },
  {
    city: 'Durham',
    county_fips: 33017,
    county_fips_all: '33017',
    county: 'Strafford',
    county_names_all: 'Strafford',
    county_weights: '{"33017": 100}',
    density: 259.7,
    imprecise: false,
    latitude: 43.11744,
    longitude: -70.91937,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03824',
  },
  {
    city: 'Barrington',
    county_fips: 33017,
    county_fips_all: '33017',
    county: 'Strafford',
    county_names_all: 'Strafford',
    county_weights: '{"33017": 100}',
    density: 78.1,
    imprecise: false,
    latitude: 43.21366,
    longitude: -71.04227,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03825',
  },
  {
    city: 'East Hampstead',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 299.1,
    imprecise: false,
    latitude: 42.88878,
    longitude: -71.12881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03826',
  },
  {
    city: 'East Kingston',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 70.9,
    imprecise: false,
    latitude: 42.90691,
    longitude: -70.98774,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03827',
  },
  {
    city: 'East Wakefield',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 56.4,
    imprecise: false,
    latitude: 43.63549,
    longitude: -70.99568,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03830',
  },
  {
    city: 'Eaton Center',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 43.90249,
    longitude: -71.04859,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03832',
  },
  {
    city: 'Exeter',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 181.7,
    imprecise: false,
    latitude: 42.97464,
    longitude: -70.98885,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03833',
  },
  {
    city: 'Farmington',
    county_fips: 33017,
    county_fips_all: '33017',
    county: 'Strafford',
    county_names_all: 'Strafford',
    county_weights: '{"33017": 100}',
    density: 71.4,
    imprecise: false,
    latitude: 43.36319,
    longitude: -71.07605,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03835',
  },
  {
    city: 'Freedom',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 43.82608,
    longitude: -71.07118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03836',
  },
  {
    city: 'Gilmanton Iron Works',
    county_fips: 33001,
    county_fips_all: '33001',
    county: 'Belknap',
    county_names_all: 'Belknap',
    county_weights: '{"33001": 100}',
    density: 28.1,
    imprecise: false,
    latitude: 43.42271,
    longitude: -71.32766,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03837',
  },
  {
    city: 'Glen',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 44.11257,
    longitude: -71.24036,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03838',
  },
  {
    city: 'Rochester',
    county_fips: 33017,
    county_fips_all: '33017',
    county: 'Strafford',
    county_names_all: 'Strafford',
    county_weights: '{"33017": 100}',
    density: 210,
    imprecise: false,
    latitude: 43.26256,
    longitude: -70.98254,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03839',
  },
  {
    city: 'Greenland',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 151.2,
    imprecise: false,
    latitude: 43.03853,
    longitude: -70.84803,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03840',
  },
  {
    city: 'Hampstead',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 242.1,
    imprecise: false,
    latitude: 42.88148,
    longitude: -71.17856,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03841',
  },
  {
    city: 'Hampton',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 493.2,
    imprecise: false,
    latitude: 42.93941,
    longitude: -70.83697,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03842',
  },
  {
    city: 'Hampton Falls',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 73.9,
    imprecise: false,
    latitude: 42.92693,
    longitude: -70.88603,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03844',
  },
  {
    city: 'Intervale',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 38.5,
    imprecise: false,
    latitude: 44.10317,
    longitude: -71.1271,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03845',
  },
  {
    city: 'Jackson',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 44.18445,
    longitude: -71.18899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03846',
  },
  {
    city: 'Kearsarge',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 40.9,
    imprecise: false,
    latitude: 44.06875,
    longitude: -71.12162,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03847',
  },
  {
    city: 'Kingston',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 122.4,
    imprecise: false,
    latitude: 42.91562,
    longitude: -71.06647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03848',
  },
  {
    city: 'Madison',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 43.89454,
    longitude: -71.13101,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03849',
  },
  {
    city: 'Melvin Village',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 43.4,
    imprecise: false,
    latitude: 43.69739,
    longitude: -71.29983,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03850',
  },
  {
    city: 'Milton',
    county_fips: 33017,
    county_fips_all: '33017',
    county: 'Strafford',
    county_names_all: 'Strafford',
    county_weights: '{"33017": 100}',
    density: 63.6,
    imprecise: false,
    latitude: 43.43606,
    longitude: -71.01633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03851',
  },
  {
    city: 'Milton Mills',
    county_fips: 33017,
    county_fips_all: '33017',
    county: 'Strafford',
    county_names_all: 'Strafford',
    county_weights: '{"33017": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 43.4982,
    longitude: -70.97547,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03852',
  },
  {
    city: 'Mirror Lake',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 29.4,
    imprecise: false,
    latitude: 43.63818,
    longitude: -71.29371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03853',
  },
  {
    city: 'New Castle',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 394.9,
    imprecise: false,
    latitude: 43.06558,
    longitude: -70.72003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03854',
  },
  {
    city: 'New Durham',
    county_fips: 33017,
    county_fips_all: '33017',
    county: 'Strafford',
    county_names_all: 'Strafford',
    county_weights: '{"33017": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 43.46343,
    longitude: -71.14172,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03855',
  },
  {
    city: 'Newfields',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 110.2,
    imprecise: false,
    latitude: 43.03916,
    longitude: -70.96627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03856',
  },
  {
    city: 'Newmarket',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 290.1,
    imprecise: false,
    latitude: 43.0691,
    longitude: -70.95164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03857',
  },
  {
    city: 'Newton',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 190.3,
    imprecise: false,
    latitude: 42.86839,
    longitude: -71.04357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03858',
  },
  {
    city: 'North Conway',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 61.4,
    imprecise: false,
    latitude: 44.0427,
    longitude: -71.12422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03860',
  },
  {
    city: 'Lee',
    county_fips: 33017,
    county_fips_all: '33017',
    county: 'Strafford',
    county_names_all: 'Strafford',
    county_weights: '{"33017": 100}',
    density: 89.5,
    imprecise: false,
    latitude: 43.11931,
    longitude: -71.0068,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03861',
  },
  {
    city: 'North Hampton',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 127.9,
    imprecise: false,
    latitude: 42.97914,
    longitude: -70.83025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03862',
  },
  {
    city: 'Ossipee',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 43.69044,
    longitude: -71.10631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03864',
  },
  {
    city: 'Plaistow',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 286.6,
    imprecise: false,
    latitude: 42.84032,
    longitude: -71.09603,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03865',
  },
  {
    city: 'Rochester',
    county_fips: 33017,
    county_fips_all: '33017',
    county: 'Strafford',
    county_names_all: 'Strafford',
    county_weights: '{"33017": 100}',
    density: 309,
    imprecise: false,
    latitude: 43.3031,
    longitude: -70.98891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03867',
  },
  {
    city: 'Rochester',
    county_fips: 33017,
    county_fips_all: '33017',
    county: 'Strafford',
    county_names_all: 'Strafford',
    county_weights: '{"33017": 100}',
    density: 270.7,
    imprecise: false,
    latitude: 43.31879,
    longitude: -70.9415,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03868',
  },
  {
    city: 'Rollinsford',
    county_fips: 33017,
    county_fips_all: '33017',
    county: 'Strafford',
    county_names_all: 'Strafford',
    county_weights: '{"33017": 100}',
    density: 141.7,
    imprecise: false,
    latitude: 43.22092,
    longitude: -70.83995,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03869',
  },
  {
    city: 'Rye',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 166.2,
    imprecise: false,
    latitude: 43.0157,
    longitude: -70.76052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03870',
  },
  {
    city: 'Rye Beach',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 247.5,
    imprecise: false,
    latitude: 42.9807,
    longitude: -70.77358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03871',
  },
  {
    city: 'Sanbornville',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 32.9,
    imprecise: false,
    latitude: 43.57225,
    longitude: -71.04249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03872',
  },
  {
    city: 'Sandown',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 183.6,
    imprecise: false,
    latitude: 42.93321,
    longitude: -71.1833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03873',
  },
  {
    city: 'Seabrook',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 366.2,
    imprecise: false,
    latitude: 42.88689,
    longitude: -70.8607,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03874',
  },
  {
    city: 'Silver Lake',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 43.89944,
    longitude: -71.18636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03875',
  },
  {
    city: 'Somersworth',
    county_fips: 33017,
    county_fips_all: '33017',
    county: 'Strafford',
    county_names_all: 'Strafford',
    county_weights: '{"33017": 100}',
    density: 480.1,
    imprecise: false,
    latitude: 43.25335,
    longitude: -70.88555,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03878',
  },
  {
    city: 'Effingham',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 43.74727,
    longitude: -71.04254,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03882',
  },
  {
    city: 'South Tamworth',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 43.81252,
    longitude: -71.30789,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03883',
  },
  {
    city: 'Strafford',
    county_fips: 33017,
    county_fips_all: '33017|33015',
    county: 'Strafford',
    county_names_all: 'Strafford|Rockingham',
    county_weights: '{"33017": 99.9, "33015": 0.1}',
    density: 33.9,
    imprecise: false,
    latitude: 43.28018,
    longitude: -71.14885,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03884',
  },
  {
    city: 'Stratham',
    county_fips: 33015,
    county_fips_all: '33015',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"33015": 100}',
    density: 197.9,
    imprecise: false,
    latitude: 43.01579,
    longitude: -70.90051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03885',
  },
  {
    city: 'Tamworth',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 43.86399,
    longitude: -71.28783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03886',
  },
  {
    city: 'Union',
    county_fips: 33017,
    county_fips_all: '33017|33003',
    county: 'Strafford',
    county_names_all: 'Strafford|Carroll',
    county_weights: '{"33017": 95.11, "33003": 4.89}',
    density: 35.7,
    imprecise: false,
    latitude: 43.48485,
    longitude: -71.0662,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03887',
  },
  {
    city: 'West Ossipee',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 38.6,
    imprecise: false,
    latitude: 43.81528,
    longitude: -71.20581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03890',
  },
  {
    city: 'Wolfeboro',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 53.5,
    imprecise: false,
    latitude: 43.61109,
    longitude: -71.17788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03894',
  },
  {
    city: 'Wonalancet',
    county_fips: 33003,
    county_fips_all: '33003',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"33003": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 43.90841,
    longitude: -71.32453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03897',
  },
  {
    city: 'Berwick',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 84.2,
    imprecise: false,
    latitude: 43.30063,
    longitude: -70.84397,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '03901',
  },
  {
    city: 'Cape Neddick',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 54,
    imprecise: false,
    latitude: 43.22246,
    longitude: -70.63788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '03902',
  },
  {
    city: 'Eliot',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 139.5,
    imprecise: false,
    latitude: 43.14885,
    longitude: -70.786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '03903',
  },
  {
    city: 'Kittery',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 296.7,
    imprecise: false,
    latitude: 43.11025,
    longitude: -70.73201,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '03904',
  },
  {
    city: 'Kittery Point',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 116.8,
    imprecise: false,
    latitude: 43.08481,
    longitude: -70.68449,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '03905',
  },
  {
    city: 'North Berwick',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 54.2,
    imprecise: false,
    latitude: 43.3447,
    longitude: -70.77759,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '03906',
  },
  {
    city: 'Ogunquit',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 130.4,
    imprecise: false,
    latitude: 43.25474,
    longitude: -70.611,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '03907',
  },
  {
    city: 'South Berwick',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 89.9,
    imprecise: false,
    latitude: 43.23838,
    longitude: -70.74795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '03908',
  },
  {
    city: 'York',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 119.9,
    imprecise: false,
    latitude: 43.16786,
    longitude: -70.68105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '03909',
  },
  {
    city: 'York Beach',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 117.1,
    imprecise: false,
    latitude: 43.17374,
    longitude: -70.60842,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '03910',
  },
  {
    city: 'York Harbor',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 395.3,
    imprecise: false,
    latitude: 43.13424,
    longitude: -70.63695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '03911',
  },
  {
    city: 'Acton',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 27.8,
    imprecise: false,
    latitude: 43.52991,
    longitude: -70.92078,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04001',
  },
  {
    city: 'Alfred',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 45.1,
    imprecise: false,
    latitude: 43.49572,
    longitude: -70.67922,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04002',
  },
  {
    city: 'Bailey Island',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 68.1,
    imprecise: false,
    latitude: 43.73362,
    longitude: -69.98724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04003',
  },
  {
    city: 'Biddeford',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 199.6,
    imprecise: false,
    latitude: 43.49591,
    longitude: -70.49537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04005',
  },
  {
    city: 'Biddeford Pool',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 238.4,
    imprecise: false,
    latitude: 43.44397,
    longitude: -70.34272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04006',
  },
  {
    city: 'Bowdoinham',
    county_fips: 23023,
    county_fips_all: '23023',
    county: 'Sagadahoc',
    county_names_all: 'Sagadahoc',
    county_weights: '{"23023": 100}',
    density: 33,
    imprecise: false,
    latitude: 44.03664,
    longitude: -69.86337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04008',
  },
  {
    city: 'Bridgton',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 37.4,
    imprecise: false,
    latitude: 44.04791,
    longitude: -70.73632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04009',
  },
  {
    city: 'Brownfield',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 16,
    imprecise: false,
    latitude: 43.93341,
    longitude: -70.91718,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04010',
  },
  {
    city: 'Brunswick',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 184.4,
    imprecise: false,
    latitude: 43.90068,
    longitude: -69.97607,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04011',
  },
  {
    city: 'Casco',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 45.6,
    imprecise: false,
    latitude: 43.96503,
    longitude: -70.5205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04015',
  },
  {
    city: 'Chebeague Island',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 59.9,
    imprecise: false,
    latitude: 43.72974,
    longitude: -70.11317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04017',
  },
  {
    city: 'Cliff Island',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 43.1,
    imprecise: false,
    latitude: 43.69149,
    longitude: -70.0999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04019',
  },
  {
    city: 'Cornish',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 31.4,
    imprecise: false,
    latitude: 43.76811,
    longitude: -70.81028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04020',
  },
  {
    city: 'Cumberland Center',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 131.3,
    imprecise: false,
    latitude: 43.79756,
    longitude: -70.26519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04021',
  },
  {
    city: 'Denmark',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 43.98055,
    longitude: -70.80718,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04022',
  },
  {
    city: 'East Baldwin',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 43.83556,
    longitude: -70.67701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04024',
  },
  {
    city: 'Lebanon',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 46.5,
    imprecise: false,
    latitude: 43.40333,
    longitude: -70.91155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04027',
  },
  {
    city: 'Sebago',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 24.5,
    imprecise: false,
    latitude: 43.89479,
    longitude: -70.66007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04029',
  },
  {
    city: 'East Waterboro',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 68.6,
    imprecise: false,
    latitude: 43.59301,
    longitude: -70.69553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04030',
  },
  {
    city: 'Freeport',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 97.8,
    imprecise: false,
    latitude: 43.85561,
    longitude: -70.10085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04032',
  },
  {
    city: 'Fryeburg',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 19,
    imprecise: false,
    latitude: 44.09129,
    longitude: -70.94942,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04037',
  },
  {
    city: 'Gorham',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 139.7,
    imprecise: false,
    latitude: 43.70343,
    longitude: -70.4581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04038',
  },
  {
    city: 'Gray',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 76.5,
    imprecise: false,
    latitude: 43.88744,
    longitude: -70.34532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04039',
  },
  {
    city: 'Harrison',
    county_fips: 23005,
    county_fips_all: '23005|23017',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Oxford',
    county_weights: '{"23005": 55.29, "23017": 44.71}',
    density: 19,
    imprecise: false,
    latitude: 44.10922,
    longitude: -70.71784,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04040',
  },
  {
    city: 'Hiram',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 43.86416,
    longitude: -70.82631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04041',
  },
  {
    city: 'Hollis Center',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 58.7,
    imprecise: false,
    latitude: 43.62953,
    longitude: -70.62453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04042',
  },
  {
    city: 'Kennebunk',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 130,
    imprecise: false,
    latitude: 43.39721,
    longitude: -70.57071,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04043',
  },
  {
    city: 'Kennebunkport',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 70.4,
    imprecise: false,
    latitude: 43.42027,
    longitude: -70.4921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04046',
  },
  {
    city: 'Parsonsfield',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 43.73552,
    longitude: -70.91152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04047',
  },
  {
    city: 'Limerick',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 48.4,
    imprecise: false,
    latitude: 43.68862,
    longitude: -70.78642,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04048',
  },
  {
    city: 'Limington',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 36.9,
    imprecise: false,
    latitude: 43.7356,
    longitude: -70.70263,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04049',
  },
  {
    city: 'Long Island',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 67,
    imprecise: false,
    latitude: 43.69148,
    longitude: -70.15714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04050',
  },
  {
    city: 'Lovell',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 44.18945,
    longitude: -70.88477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04051',
  },
  {
    city: 'Naples',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 48.3,
    imprecise: false,
    latitude: 43.97065,
    longitude: -70.61444,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04055',
  },
  {
    city: 'Newfield',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 43.66066,
    longitude: -70.85875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04056',
  },
  {
    city: 'North Bridgton',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 192.6,
    imprecise: false,
    latitude: 44.09563,
    longitude: -70.70177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04057',
  },
  {
    city: 'North Waterboro',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 59.1,
    imprecise: false,
    latitude: 43.63409,
    longitude: -70.74312,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04061',
  },
  {
    city: 'Windham',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 158.8,
    imprecise: false,
    latitude: 43.79798,
    longitude: -70.40547,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04062',
  },
  {
    city: 'Ocean Park',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 321.9,
    imprecise: false,
    latitude: 43.50145,
    longitude: -70.39551,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04063',
  },
  {
    city: 'Old Orchard Beach',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 497.4,
    imprecise: false,
    latitude: 43.52635,
    longitude: -70.38985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04064',
  },
  {
    city: 'Orrs Island',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 179.2,
    imprecise: false,
    latitude: 43.77332,
    longitude: -69.96808,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04066',
  },
  {
    city: 'Porter',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 43.84009,
    longitude: -70.9409,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04068',
  },
  {
    city: 'Pownal',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 28.6,
    imprecise: false,
    latitude: 43.89918,
    longitude: -70.18191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04069',
  },
  {
    city: 'Raymond',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 51.9,
    imprecise: false,
    latitude: 43.89598,
    longitude: -70.48133,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04071',
  },
  {
    city: 'Saco',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 208.3,
    imprecise: false,
    latitude: 43.53898,
    longitude: -70.46236,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04072',
  },
  {
    city: 'Sanford',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 178.1,
    imprecise: false,
    latitude: 43.41301,
    longitude: -70.74237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04073',
  },
  {
    city: 'Scarborough',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 187,
    imprecise: false,
    latitude: 43.59103,
    longitude: -70.3683,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04074',
  },
  {
    city: 'Shapleigh',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 29.7,
    imprecise: false,
    latitude: 43.55248,
    longitude: -70.83793,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04076',
  },
  {
    city: 'Harpswell',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 73.1,
    imprecise: false,
    latitude: 43.80343,
    longitude: -69.94972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04079',
  },
  {
    city: 'Springvale',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 185.7,
    imprecise: false,
    latitude: 43.46728,
    longitude: -70.81359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04083',
  },
  {
    city: 'Standish',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 69.6,
    imprecise: false,
    latitude: 43.76637,
    longitude: -70.55893,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04084',
  },
  {
    city: 'Steep Falls',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 70.3,
    imprecise: false,
    latitude: 43.7809,
    longitude: -70.62553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04085',
  },
  {
    city: 'Topsham',
    county_fips: 23023,
    county_fips_all: '23023',
    county: 'Sagadahoc',
    county_names_all: 'Sagadahoc',
    county_weights: '{"23023": 100}',
    density: 116.5,
    imprecise: false,
    latitude: 43.96145,
    longitude: -69.95872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04086',
  },
  {
    city: 'Waterboro',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 43.7,
    imprecise: false,
    latitude: 43.56234,
    longitude: -70.74529,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04087',
  },
  {
    city: 'Waterford',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 44.19352,
    longitude: -70.71906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04088',
  },
  {
    city: 'Wells',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 78.4,
    imprecise: false,
    latitude: 43.32669,
    longitude: -70.63356,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04090',
  },
  {
    city: 'West Baldwin',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 43.83035,
    longitude: -70.74858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04091',
  },
  {
    city: 'Westbrook',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 466.7,
    imprecise: false,
    latitude: 43.69542,
    longitude: -70.35389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04092',
  },
  {
    city: 'Buxton',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 81.1,
    imprecise: false,
    latitude: 43.64282,
    longitude: -70.53765,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04093',
  },
  {
    city: 'West Newfield',
    county_fips: 23031,
    county_fips_all: '23031',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"23031": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 43.63925,
    longitude: -70.90749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04095',
  },
  {
    city: 'Yarmouth',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 260.8,
    imprecise: false,
    latitude: 43.7978,
    longitude: -70.1719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04096',
  },
  {
    city: 'North Yarmouth',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 77.1,
    imprecise: false,
    latitude: 43.85123,
    longitude: -70.23636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04097',
  },
  {
    city: 'Portland',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 3506.3,
    imprecise: false,
    latitude: 43.6624,
    longitude: -70.2586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04101',
  },
  {
    city: 'Portland',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 1112.5,
    imprecise: false,
    latitude: 43.65877,
    longitude: -70.30622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04102',
  },
  {
    city: 'Portland',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 1208.5,
    imprecise: false,
    latitude: 43.69392,
    longitude: -70.2909,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04103',
  },
  {
    city: 'Falmouth',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 168.1,
    imprecise: false,
    latitude: 43.74753,
    longitude: -70.2825,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04105',
  },
  {
    city: 'South Portland',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 857.2,
    imprecise: false,
    latitude: 43.63081,
    longitude: -70.28972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04106',
  },
  {
    city: 'Cape Elizabeth',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 250.9,
    imprecise: false,
    latitude: 43.5891,
    longitude: -70.23801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04107',
  },
  {
    city: 'Peaks Island',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 262.3,
    imprecise: false,
    latitude: 43.66057,
    longitude: -70.18901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04108',
  },
  {
    city: 'Cumberland Foreside',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 274.5,
    imprecise: false,
    latitude: 43.75834,
    longitude: -70.19905,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04110',
  },
  {
    city: 'Auburn',
    county_fips: 23001,
    county_fips_all: '23001',
    county: 'Androscoggin',
    county_names_all: 'Androscoggin',
    county_weights: '{"23001": 100}',
    density: 160.1,
    imprecise: false,
    latitude: 44.08505,
    longitude: -70.24923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04210',
  },
  {
    city: 'Andover',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 44.70046,
    longitude: -70.8142,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04216',
  },
  {
    city: 'Bethel',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 44.36726,
    longitude: -70.83364,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04217',
  },
  {
    city: 'Bryant Pond',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 44.40924,
    longitude: -70.59285,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04219',
  },
  {
    city: 'Buckfield',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 44.33511,
    longitude: -70.35286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04220',
  },
  {
    city: 'Canton',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 44.47242,
    longitude: -70.29857,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04221',
  },
  {
    city: 'Durham',
    county_fips: 23001,
    county_fips_all: '23001',
    county: 'Androscoggin',
    county_names_all: 'Androscoggin',
    county_weights: '{"23001": 100}',
    density: 43,
    imprecise: false,
    latitude: 43.9644,
    longitude: -70.12954,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04222',
  },
  {
    city: 'Dixfield',
    county_fips: 23017,
    county_fips_all: '23017|23007',
    county: 'Oxford',
    county_names_all: 'Oxford|Franklin',
    county_weights: '{"23017": 55.17, "23007": 44.83}',
    density: 16.1,
    imprecise: false,
    latitude: 44.58001,
    longitude: -70.40058,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04224',
  },
  {
    city: 'East Andover',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 44.62555,
    longitude: -70.70823,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04226',
  },
  {
    city: 'East Dixfield',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 92.9,
    imprecise: false,
    latitude: 44.56866,
    longitude: -70.29471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04227',
  },
  {
    city: 'Stoneham',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 44.26438,
    longitude: -70.88777,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04231',
  },
  {
    city: 'East Wilton',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.61624,
    longitude: -70.19359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04234',
  },
  {
    city: 'Greene',
    county_fips: 23001,
    county_fips_all: '23001',
    county: 'Androscoggin',
    county_names_all: 'Androscoggin',
    county_weights: '{"23001": 100}',
    density: 52.8,
    imprecise: false,
    latitude: 44.19036,
    longitude: -70.14461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04236',
  },
  {
    city: 'Hanover',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 44.49665,
    longitude: -70.7256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04237',
  },
  {
    city: 'Hebron',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 20.8,
    imprecise: false,
    latitude: 44.20785,
    longitude: -70.37937,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04238',
  },
  {
    city: 'Jay',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 37.2,
    imprecise: false,
    latitude: 44.53062,
    longitude: -70.20935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04239',
  },
  {
    city: 'Lewiston',
    county_fips: 23001,
    county_fips_all: '23001',
    county: 'Androscoggin',
    county_names_all: 'Androscoggin',
    county_weights: '{"23001": 100}',
    density: 433.3,
    imprecise: false,
    latitude: 44.09147,
    longitude: -70.16808,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04240',
  },
  {
    city: 'Lisbon',
    county_fips: 23001,
    county_fips_all: '23001',
    county: 'Androscoggin',
    county_names_all: 'Androscoggin',
    county_weights: '{"23001": 100}',
    density: 157.5,
    imprecise: false,
    latitude: 44.02582,
    longitude: -70.11706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04250',
  },
  {
    city: 'Lisbon Falls',
    county_fips: 23001,
    county_fips_all: '23001',
    county: 'Androscoggin',
    county_names_all: 'Androscoggin',
    county_weights: '{"23001": 100}',
    density: 172.8,
    imprecise: false,
    latitude: 44.02719,
    longitude: -70.06011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04252',
  },
  {
    city: 'Livermore',
    county_fips: 23001,
    county_fips_all: '23001',
    county: 'Androscoggin',
    county_names_all: 'Androscoggin',
    county_weights: '{"23001": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 44.4079,
    longitude: -70.21503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04253',
  },
  {
    city: 'Livermore Falls',
    county_fips: 23001,
    county_fips_all: '23001',
    county: 'Androscoggin',
    county_names_all: 'Androscoggin',
    county_weights: '{"23001": 100}',
    density: 60.9,
    imprecise: false,
    latitude: 44.43249,
    longitude: -70.14265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04254',
  },
  {
    city: 'Greenwood',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 44.33505,
    longitude: -70.66863,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04255',
  },
  {
    city: 'Mechanic Falls',
    county_fips: 23001,
    county_fips_all: '23001',
    county: 'Androscoggin',
    county_names_all: 'Androscoggin',
    county_weights: '{"23001": 100}',
    density: 110,
    imprecise: false,
    latitude: 44.10294,
    longitude: -70.40733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04256',
  },
  {
    city: 'Mexico',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 46,
    imprecise: false,
    latitude: 44.57347,
    longitude: -70.51358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04257',
  },
  {
    city: 'Minot',
    county_fips: 23001,
    county_fips_all: '23001',
    county: 'Androscoggin',
    county_names_all: 'Androscoggin',
    county_weights: '{"23001": 100}',
    density: 36.5,
    imprecise: false,
    latitude: 44.14829,
    longitude: -70.33794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04258',
  },
  {
    city: 'Monmouth',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 48.1,
    imprecise: false,
    latitude: 44.22762,
    longitude: -70.00868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04259',
  },
  {
    city: 'New Gloucester',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 47.2,
    imprecise: false,
    latitude: 43.96409,
    longitude: -70.29589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04260',
  },
  {
    city: 'Newry',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 44.5631,
    longitude: -70.91907,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04261',
  },
  {
    city: 'Leeds',
    county_fips: 23001,
    county_fips_all: '23001',
    county: 'Androscoggin',
    county_names_all: 'Androscoggin',
    county_weights: '{"23001": 100}',
    density: 22,
    imprecise: false,
    latitude: 44.29476,
    longitude: -70.13061,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04263',
  },
  {
    city: 'North Monmouth',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 36.4,
    imprecise: false,
    latitude: 44.27542,
    longitude: -70.04276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04265',
  },
  {
    city: 'North Waterford',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 44.22478,
    longitude: -70.77084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04267',
  },
  {
    city: 'Norway',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 44.8,
    imprecise: false,
    latitude: 44.22842,
    longitude: -70.60651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04268',
  },
  {
    city: 'Oxford',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 30.9,
    imprecise: false,
    latitude: 44.11241,
    longitude: -70.51559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04270',
  },
  {
    city: 'Paris',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.26099,
    longitude: -70.49871,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04271',
  },
  {
    city: 'Poland',
    county_fips: 23001,
    county_fips_all: '23001',
    county: 'Androscoggin',
    county_names_all: 'Androscoggin',
    county_weights: '{"23001": 100}',
    density: 54.4,
    imprecise: false,
    latitude: 44.04634,
    longitude: -70.38999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04274',
  },
  {
    city: 'Roxbury',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 44.68966,
    longitude: -70.63729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04275',
  },
  {
    city: 'Rumford',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 33.5,
    imprecise: false,
    latitude: 44.53469,
    longitude: -70.61541,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04276',
  },
  {
    city: 'Sabattus',
    county_fips: 23001,
    county_fips_all: '23001',
    county: 'Androscoggin',
    county_names_all: 'Androscoggin',
    county_weights: '{"23001": 100}',
    density: 65.2,
    imprecise: false,
    latitude: 44.1215,
    longitude: -70.06152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04280',
  },
  {
    city: 'South Paris',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 50.4,
    imprecise: false,
    latitude: 44.2445,
    longitude: -70.48832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04281',
  },
  {
    city: 'Turner',
    county_fips: 23001,
    county_fips_all: '23001',
    county: 'Androscoggin',
    county_names_all: 'Androscoggin',
    county_weights: '{"23001": 100}',
    density: 38.4,
    imprecise: false,
    latitude: 44.26709,
    longitude: -70.24291,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04282',
  },
  {
    city: 'Wayne',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 44.34757,
    longitude: -70.0651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04284',
  },
  {
    city: 'Weld',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 3,
    imprecise: false,
    latitude: 44.70625,
    longitude: -70.4523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04285',
  },
  {
    city: 'West Bethel',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.4032,
    longitude: -70.86019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04286',
  },
  {
    city: 'Bowdoin',
    county_fips: 23023,
    county_fips_all: '23023',
    county: 'Sagadahoc',
    county_names_all: 'Sagadahoc',
    county_weights: '{"23023": 100}',
    density: 28.3,
    imprecise: false,
    latitude: 44.05812,
    longitude: -69.9694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04287',
  },
  {
    city: 'West Paris',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 28.2,
    imprecise: false,
    latitude: 44.32108,
    longitude: -70.53248,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04289',
  },
  {
    city: 'Peru',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 44.47354,
    longitude: -70.45058,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04290',
  },
  {
    city: 'Sumner',
    county_fips: 23017,
    county_fips_all: '23017',
    county: 'Oxford',
    county_names_all: 'Oxford',
    county_weights: '{"23017": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 44.37461,
    longitude: -70.44674,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04292',
  },
  {
    city: 'Wilton',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 28.8,
    imprecise: false,
    latitude: 44.62346,
    longitude: -70.27075,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04294',
  },
  {
    city: 'Augusta',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 88.1,
    imprecise: false,
    latitude: 44.36387,
    longitude: -69.73729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04330',
  },
  {
    city: 'Coopers Mills',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 498.7,
    imprecise: false,
    latitude: 44.25997,
    longitude: -69.55485,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04341',
  },
  {
    city: 'Dresden',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 44.07942,
    longitude: -69.73939,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04342',
  },
  {
    city: 'Farmingdale',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 103.6,
    imprecise: false,
    latitude: 44.2588,
    longitude: -69.82125,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04344',
  },
  {
    city: 'Gardiner',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 67.7,
    imprecise: false,
    latitude: 44.19816,
    longitude: -69.7841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04345',
  },
  {
    city: 'Randolph',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 291.1,
    imprecise: false,
    latitude: 44.23469,
    longitude: -69.75068,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04346',
  },
  {
    city: 'Hallowell',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 170.7,
    imprecise: false,
    latitude: 44.29047,
    longitude: -69.81399,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04347',
  },
  {
    city: 'Jefferson',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 44.21521,
    longitude: -69.49922,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04348',
  },
  {
    city: 'Kents Hill',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 44.43734,
    longitude: -70.07014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04349',
  },
  {
    city: 'Litchfield',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 38,
    imprecise: false,
    latitude: 44.16266,
    longitude: -69.93942,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04350',
  },
  {
    city: 'Manchester',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 43.6,
    imprecise: false,
    latitude: 44.33174,
    longitude: -69.86082,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04351',
  },
  {
    city: 'Mount Vernon',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 44.46478,
    longitude: -69.96225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04352',
  },
  {
    city: 'Whitefield',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 44.2052,
    longitude: -69.6126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04353',
  },
  {
    city: 'Palermo',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 14,
    imprecise: false,
    latitude: 44.39602,
    longitude: -69.42709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04354',
  },
  {
    city: 'Readfield',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 35.2,
    imprecise: false,
    latitude: 44.38227,
    longitude: -69.94915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04355',
  },
  {
    city: 'Richmond',
    county_fips: 23023,
    county_fips_all: '23023',
    county: 'Sagadahoc',
    county_names_all: 'Sagadahoc',
    county_weights: '{"23023": 100}',
    density: 45.2,
    imprecise: false,
    latitude: 44.12366,
    longitude: -69.82883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04357',
  },
  {
    city: 'South China',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 44.41821,
    longitude: -69.53286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04358',
  },
  {
    city: 'South Gardiner',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 156.1,
    imprecise: false,
    latitude: 44.17947,
    longitude: -69.76134,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04359',
  },
  {
    city: 'Vienna',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 44.54741,
    longitude: -70.00299,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04360',
  },
  {
    city: 'Windsor',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 30,
    imprecise: false,
    latitude: 44.31101,
    longitude: -69.57807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04363',
  },
  {
    city: 'Winthrop',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 76.8,
    imprecise: false,
    latitude: 44.31158,
    longitude: -69.96153,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04364',
  },
  {
    city: 'Bangor',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 173.1,
    imprecise: false,
    latitude: 44.84711,
    longitude: -68.84654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04401',
  },
  {
    city: 'Abbot',
    county_fips: 23021,
    county_fips_all: '23021',
    county: 'Piscataquis',
    county_names_all: 'Piscataquis',
    county_weights: '{"23021": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 45.2186,
    longitude: -69.57816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04406',
  },
  {
    city: 'Aurora',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 44.9877,
    longitude: -68.23246,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04408',
  },
  {
    city: 'Bradford',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 45.08821,
    longitude: -68.90696,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04410',
  },
  {
    city: 'Bradley',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 44.88634,
    longitude: -68.56672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04411',
  },
  {
    city: 'Brewer',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 244.6,
    imprecise: false,
    latitude: 44.78354,
    longitude: -68.73517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04412',
  },
  {
    city: 'Brookton',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 45.55647,
    longitude: -67.8274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04413',
  },
  {
    city: 'Brownville',
    county_fips: 23021,
    county_fips_all: '23021',
    county: 'Piscataquis',
    county_names_all: 'Piscataquis',
    county_weights: '{"23021": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 45.40654,
    longitude: -69.08568,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04414',
  },
  {
    city: 'Brownville Junction',
    county_fips: 23021,
    county_fips_all: '23021',
    county: 'Piscataquis',
    county_names_all: 'Piscataquis',
    county_weights: '{"23021": 100}',
    density: 511.7,
    imprecise: false,
    latitude: 45.35308,
    longitude: -69.05832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04415',
  },
  {
    city: 'Bucksport',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 36.7,
    imprecise: false,
    latitude: 44.62725,
    longitude: -68.75286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04416',
  },
  {
    city: 'Burlington',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 45.19923,
    longitude: -68.36728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04417',
  },
  {
    city: 'Greenbush',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 45.07572,
    longitude: -68.50689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04418',
  },
  {
    city: 'Carmel',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 31,
    imprecise: false,
    latitude: 44.7969,
    longitude: -69.03154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04419',
  },
  {
    city: 'Castine',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 67.6,
    imprecise: false,
    latitude: 44.4111,
    longitude: -68.79524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04421',
  },
  {
    city: 'Charleston',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 45.07097,
    longitude: -69.03408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04422',
  },
  {
    city: 'Danforth',
    county_fips: 23029,
    county_fips_all: '23029|23003',
    county: 'Washington',
    county_names_all: 'Washington|Aroostook',
    county_weights: '{"23029": 52.22, "23003": 47.78}',
    density: 3.8,
    imprecise: false,
    latitude: 45.67003,
    longitude: -67.86144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04424',
  },
  {
    city: 'Dover Foxcroft',
    county_fips: 23021,
    county_fips_all: '23021',
    county: 'Piscataquis',
    county_names_all: 'Piscataquis',
    county_weights: '{"23021": 100}',
    density: 16.1,
    imprecise: false,
    latitude: 45.1849,
    longitude: -69.15827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04426',
  },
  {
    city: 'Corinth',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 28.7,
    imprecise: false,
    latitude: 44.9805,
    longitude: -69.01063,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04427',
  },
  {
    city: 'Eddington',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 44.80643,
    longitude: -68.55584,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04428',
  },
  {
    city: 'Holden',
    county_fips: 23009,
    county_fips_all: '23009|23019',
    county: 'Hancock',
    county_names_all: 'Hancock|Penobscot',
    county_weights: '{"23009": 57.64, "23019": 42.36}',
    density: 27.4,
    imprecise: false,
    latitude: 44.72039,
    longitude: -68.6171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04429',
  },
  {
    city: 'East Millinocket',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 81.7,
    imprecise: false,
    latitude: 45.64662,
    longitude: -68.58646,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04430',
  },
  {
    city: 'East Orland',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 302.3,
    imprecise: false,
    latitude: 44.56453,
    longitude: -68.6678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04431',
  },
  {
    city: 'Etna',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 19.6,
    imprecise: false,
    latitude: 44.78529,
    longitude: -69.13385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04434',
  },
  {
    city: 'Exeter',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 44.96435,
    longitude: -69.13539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04435',
  },
  {
    city: 'Frankfort',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 44.59856,
    longitude: -68.91904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04438',
  },
  {
    city: 'Greenville',
    county_fips: 23021,
    county_fips_all: '23021',
    county: 'Piscataquis',
    county_names_all: 'Piscataquis',
    county_weights: '{"23021": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 45.68984,
    longitude: -69.32252,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04441',
  },
  {
    city: 'Greenville Junction',
    county_fips: 23021,
    county_fips_all: '23021',
    county: 'Piscataquis',
    county_names_all: 'Piscataquis',
    county_weights: '{"23021": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 45.47446,
    longitude: -69.69538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04442',
  },
  {
    city: 'Guilford',
    county_fips: 23021,
    county_fips_all: '23021',
    county: 'Piscataquis',
    county_names_all: 'Piscataquis',
    county_weights: '{"23021": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 45.24412,
    longitude: -69.40572,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04443',
  },
  {
    city: 'Hampden',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 52.4,
    imprecise: false,
    latitude: 44.72591,
    longitude: -68.94585,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04444',
  },
  {
    city: 'Howland',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 45.31208,
    longitude: -68.71977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04448',
  },
  {
    city: 'Hudson',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 44.99761,
    longitude: -68.88357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04449',
  },
  {
    city: 'Kenduskeag',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 44.91593,
    longitude: -68.92797,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04450',
  },
  {
    city: 'Kingman',
    county_fips: 23003,
    county_fips_all: '23003|23019',
    county: 'Aroostook',
    county_names_all: 'Aroostook|Penobscot',
    county_weights: '{"23003": 51.56, "23019": 48.44}',
    density: 1.5,
    imprecise: false,
    latitude: 45.6035,
    longitude: -68.21915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04451',
  },
  {
    city: 'Lagrange',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 4,
    imprecise: false,
    latitude: 45.18229,
    longitude: -68.78244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04453',
  },
  {
    city: 'Lee',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 45.3223,
    longitude: -68.27511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04455',
  },
  {
    city: 'Levant',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 39.4,
    imprecise: false,
    latitude: 44.88645,
    longitude: -68.9977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04456',
  },
  {
    city: 'Lincoln',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 45.43432,
    longitude: -68.52821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04457',
  },
  {
    city: 'Mattawamkeag',
    county_fips: 23003,
    county_fips_all: '23003|23019',
    county: 'Aroostook',
    county_names_all: 'Aroostook|Penobscot',
    county_weights: '{"23003": 51.94, "23019": 48.06}',
    density: 3.8,
    imprecise: false,
    latitude: 45.58898,
    longitude: -68.33948,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04459',
  },
  {
    city: 'Medway',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 45.64134,
    longitude: -68.52638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04460',
  },
  {
    city: 'Milford',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 44.98057,
    longitude: -68.57243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04461',
  },
  {
    city: 'Millinocket',
    county_fips: 23021,
    county_fips_all: '23021|23019',
    county: 'Piscataquis',
    county_names_all: 'Piscataquis|Penobscot',
    county_weights: '{"23021": 70.34, "23019": 29.66}',
    density: 2.5,
    imprecise: false,
    latitude: 45.86541,
    longitude: -68.93072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04462',
  },
  {
    city: 'Milo',
    county_fips: 23021,
    county_fips_all: '23021',
    county: 'Piscataquis',
    county_names_all: 'Piscataquis',
    county_weights: '{"23021": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 45.28117,
    longitude: -68.90569,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04463',
  },
  {
    city: 'Monson',
    county_fips: 23021,
    county_fips_all: '23021',
    county: 'Piscataquis',
    county_names_all: 'Piscataquis',
    county_weights: '{"23021": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 45.29104,
    longitude: -69.50202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04464',
  },
  {
    city: 'Old Town',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 29.2,
    imprecise: false,
    latitude: 45.0263,
    longitude: -68.72323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04468',
  },
  {
    city: 'Orient',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 45.8912,
    longitude: -67.8471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04471',
  },
  {
    city: 'Orland',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 44.57334,
    longitude: -68.67736,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04472',
  },
  {
    city: 'Orono',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 186.6,
    imprecise: false,
    latitude: 44.88594,
    longitude: -68.71888,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04473',
  },
  {
    city: 'Orrington',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 59.5,
    imprecise: false,
    latitude: 44.71501,
    longitude: -68.77901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04474',
  },
  {
    city: 'Passadumkeag',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 45.1845,
    longitude: -68.58681,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04475',
  },
  {
    city: 'Penobscot',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 44.47474,
    longitude: -68.70521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04476',
  },
  {
    city: 'Rockwood',
    county_fips: 23025,
    county_fips_all: '23025|23021',
    county: 'Somerset',
    county_names_all: 'Somerset|Piscataquis',
    county_weights: '{"23025": 62.37, "23021": 37.63}',
    density: 0.5,
    imprecise: false,
    latitude: 45.7299,
    longitude: -69.76857,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04478',
  },
  {
    city: 'Sangerville',
    county_fips: 23021,
    county_fips_all: '23021',
    county: 'Piscataquis',
    county_names_all: 'Piscataquis',
    county_weights: '{"23021": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 45.12755,
    longitude: -69.30688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04479',
  },
  {
    city: 'Sebec',
    county_fips: 23021,
    county_fips_all: '23021',
    county: 'Piscataquis',
    county_names_all: 'Piscataquis',
    county_weights: '{"23021": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 45.24298,
    longitude: -69.10423,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04481',
  },
  {
    city: 'Springfield',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 45.39371,
    longitude: -68.1006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04487',
  },
  {
    city: 'Stetson',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 44.87586,
    longitude: -69.11143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04488',
  },
  {
    city: 'Stillwater',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 331.8,
    imprecise: false,
    latitude: 44.91074,
    longitude: -68.69119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04489',
  },
  {
    city: 'Topsfield',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 45.39527,
    longitude: -67.82458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04490',
  },
  {
    city: 'Vanceboro',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 45.56705,
    longitude: -67.51353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04491',
  },
  {
    city: 'Waite',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 45.34738,
    longitude: -67.6658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04492',
  },
  {
    city: 'West Enfield',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 45.23853,
    longitude: -68.53301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04493',
  },
  {
    city: 'Winn',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 45.45464,
    longitude: -68.32985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04495',
  },
  {
    city: 'Winterport',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 41.8,
    imprecise: false,
    latitude: 44.65839,
    longitude: -68.91189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04496',
  },
  {
    city: 'Wytopitlock',
    county_fips: 23003,
    county_fips_all: '23003|23019',
    county: 'Aroostook',
    county_names_all: 'Aroostook|Penobscot',
    county_weights: '{"23003": 82.9, "23019": 17.1}',
    density: 0.6,
    imprecise: false,
    latitude: 45.7249,
    longitude: -68.06619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04497',
  },
  {
    city: 'Bath',
    county_fips: 23023,
    county_fips_all: '23023',
    county: 'Sagadahoc',
    county_names_all: 'Sagadahoc',
    county_weights: '{"23023": 100}',
    density: 151.3,
    imprecise: false,
    latitude: 43.89156,
    longitude: -69.8306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04530',
  },
  {
    city: 'Alna',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 44.08778,
    longitude: -69.63436,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04535',
  },
  {
    city: 'Boothbay',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 40.4,
    imprecise: false,
    latitude: 43.90241,
    longitude: -69.62498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04537',
  },
  {
    city: 'Boothbay Harbor',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 154.4,
    imprecise: false,
    latitude: 43.85632,
    longitude: -69.62807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04538',
  },
  {
    city: 'Bristol',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 34.1,
    imprecise: false,
    latitude: 43.96429,
    longitude: -69.50513,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04539',
  },
  {
    city: 'Chamberlain',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 50,
    imprecise: false,
    latitude: 43.88671,
    longitude: -69.48411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04541',
  },
  {
    city: 'Damariscotta',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 68.1,
    imprecise: false,
    latitude: 44.03446,
    longitude: -69.49211,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04543',
  },
  {
    city: 'East Boothbay',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 100.5,
    imprecise: false,
    latitude: 43.83316,
    longitude: -69.58997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04544',
  },
  {
    city: 'Friendship',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 33.2,
    imprecise: false,
    latitude: 43.99388,
    longitude: -69.32779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04547',
  },
  {
    city: 'Georgetown',
    county_fips: 23023,
    county_fips_all: '23023',
    county: 'Sagadahoc',
    county_names_all: 'Sagadahoc',
    county_weights: '{"23023": 100}',
    density: 21,
    imprecise: false,
    latitude: 43.81499,
    longitude: -69.74804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04548',
  },
  {
    city: 'Bremen',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 21.5,
    imprecise: false,
    latitude: 44.00648,
    longitude: -69.42701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04551',
  },
  {
    city: 'Newcastle',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 44.04787,
    longitude: -69.57145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04553',
  },
  {
    city: 'New Harbor',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 48.7,
    imprecise: false,
    latitude: 43.86348,
    longitude: -69.50481,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04554',
  },
  {
    city: 'Nobleboro',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 38.9,
    imprecise: false,
    latitude: 44.10597,
    longitude: -69.47687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04555',
  },
  {
    city: 'Edgecomb',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 26.7,
    imprecise: false,
    latitude: 43.96867,
    longitude: -69.62311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04556',
  },
  {
    city: 'Pemaquid',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 43.89974,
    longitude: -69.51499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04558',
  },
  {
    city: 'Phippsburg',
    county_fips: 23023,
    county_fips_all: '23023',
    county: 'Sagadahoc',
    county_names_all: 'Sagadahoc',
    county_weights: '{"23023": 100}',
    density: 30,
    imprecise: false,
    latitude: 43.78758,
    longitude: -69.82764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04562',
  },
  {
    city: 'Cushing',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 44.0151,
    longitude: -69.25655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04563',
  },
  {
    city: 'Round Pond',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 26.7,
    imprecise: false,
    latitude: 43.93089,
    longitude: -69.46761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04564',
  },
  {
    city: 'South Bristol',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 38,
    imprecise: false,
    latitude: 43.89652,
    longitude: -69.56153,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04568',
  },
  {
    city: 'Trevett',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 81.5,
    imprecise: false,
    latitude: 43.89949,
    longitude: -69.67516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04571',
  },
  {
    city: 'Waldoboro',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 44.10984,
    longitude: -69.36956,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04572',
  },
  {
    city: 'Walpole',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 43.95063,
    longitude: -69.55025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04573',
  },
  {
    city: 'Washington',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 44.2734,
    longitude: -69.39105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04574',
  },
  {
    city: 'West Boothbay Harbor',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 94.3,
    imprecise: false,
    latitude: 43.85383,
    longitude: -69.66016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04575',
  },
  {
    city: 'Southport',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 41.4,
    imprecise: false,
    latitude: 43.82244,
    longitude: -69.6671,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04576',
  },
  {
    city: 'Wiscasset',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 54.4,
    imprecise: false,
    latitude: 43.98136,
    longitude: -69.6926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04578',
  },
  {
    city: 'Woolwich',
    county_fips: 23023,
    county_fips_all: '23023',
    county: 'Sagadahoc',
    county_names_all: 'Sagadahoc',
    county_weights: '{"23023": 100}',
    density: 34.8,
    imprecise: false,
    latitude: 43.96216,
    longitude: -69.76872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04579',
  },
  {
    city: 'Ellsworth',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 44.66038,
    longitude: -68.41623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04605',
  },
  {
    city: 'Addison',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 44.57697,
    longitude: -67.70281,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04606',
  },
  {
    city: 'Gouldsboro',
    county_fips: 23009,
    county_fips_all: '23009|23029',
    county: 'Hancock',
    county_names_all: 'Hancock|Washington',
    county_weights: '{"23009": 99.9, "23029": 0.1}',
    density: 9.6,
    imprecise: false,
    latitude: 44.47689,
    longitude: -68.05228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04607',
  },
  {
    city: 'Bar Harbor',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 47.9,
    imprecise: false,
    latitude: 44.38518,
    longitude: -68.27108,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04609',
  },
  {
    city: 'Beals',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 34.2,
    imprecise: false,
    latitude: 44.48771,
    longitude: -67.59633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04611',
  },
  {
    city: 'Bernard',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 46.4,
    imprecise: false,
    latitude: 44.25954,
    longitude: -68.37722,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04612',
  },
  {
    city: 'Birch Harbor',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 44.37498,
    longitude: -68.03593,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04613',
  },
  {
    city: 'Blue Hill',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 44.41819,
    longitude: -68.58223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04614',
  },
  {
    city: 'Brooklin',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 44.28346,
    longitude: -68.57069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04616',
  },
  {
    city: 'Brooksville',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 44.36929,
    longitude: -68.73081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04617',
  },
  {
    city: 'Calais',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 34.8,
    imprecise: false,
    latitude: 45.13397,
    longitude: -67.22401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04619',
  },
  {
    city: 'Cherryfield',
    county_fips: 23029,
    county_fips_all: '23029|23009',
    county: 'Washington',
    county_names_all: 'Washington|Hancock',
    county_weights: '{"23029": 76.24, "23009": 23.76}',
    density: 1.3,
    imprecise: false,
    latitude: 44.75555,
    longitude: -67.95143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04622',
  },
  {
    city: 'Columbia Falls',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 44.70786,
    longitude: -67.70824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04623',
  },
  {
    city: 'Corea',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 44.42438,
    longitude: -67.9877,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04624',
  },
  {
    city: 'Cranberry Isles',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 10,
    imprecise: false,
    latitude: 44.25041,
    longitude: -68.25503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04625',
  },
  {
    city: 'Cutler',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 44.68494,
    longitude: -67.22169,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04626',
  },
  {
    city: 'Deer Isle',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 31.8,
    imprecise: false,
    latitude: 44.22275,
    longitude: -68.66581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04627',
  },
  {
    city: 'Dennysville',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 44.87275,
    longitude: -67.28238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04628',
  },
  {
    city: 'East Machias',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 44.8471,
    longitude: -67.47287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04630',
  },
  {
    city: 'Eastport',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 134.2,
    imprecise: false,
    latitude: 44.91373,
    longitude: -67.01834,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04631',
  },
  {
    city: 'Franklin',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 44.63457,
    longitude: -68.22253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04634',
  },
  {
    city: 'Frenchboro',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 44.11376,
    longitude: -68.35479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04635',
  },
  {
    city: 'Hancock',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 32.3,
    imprecise: false,
    latitude: 44.53803,
    longitude: -68.30573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04640',
  },
  {
    city: 'Harrington',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 44.57876,
    longitude: -67.80562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04643',
  },
  {
    city: 'Isle Au Haut',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 44.05408,
    longitude: -68.6282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04645',
  },
  {
    city: 'Islesford',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 65.6,
    imprecise: false,
    latitude: 44.26007,
    longitude: -68.22812,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04646',
  },
  {
    city: 'Jonesboro',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 44.65899,
    longitude: -67.59585,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04648',
  },
  {
    city: 'Jonesport',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 44.56606,
    longitude: -67.5817,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04649',
  },
  {
    city: 'Little Deer Isle',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 37.9,
    imprecise: false,
    latitude: 44.28924,
    longitude: -68.71412,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04650',
  },
  {
    city: 'Lubec',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 44.82234,
    longitude: -67.07457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04652',
  },
  {
    city: 'Bass Harbor',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 78.1,
    imprecise: false,
    latitude: 44.23705,
    longitude: -68.3431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04653',
  },
  {
    city: 'Machias',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 44.78128,
    longitude: -67.57716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04654',
  },
  {
    city: 'Machiasport',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 44.66467,
    longitude: -67.39318,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04655',
  },
  {
    city: 'Meddybemps',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 44.97624,
    longitude: -67.41965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04657',
  },
  {
    city: 'Milbridge',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 44.53873,
    longitude: -67.87257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04658',
  },
  {
    city: 'Mount Desert',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 14,
    imprecise: false,
    latitude: 44.34026,
    longitude: -68.33231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04660',
  },
  {
    city: 'Northeast Harbor',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 42.6,
    imprecise: false,
    latitude: 44.30766,
    longitude: -68.28735,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04662',
  },
  {
    city: 'Sullivan',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 12,
    imprecise: false,
    latitude: 44.53906,
    longitude: -68.12797,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04664',
  },
  {
    city: 'Pembroke',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 44.97646,
    longitude: -67.22204,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04666',
  },
  {
    city: 'Perry',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 44.97853,
    longitude: -67.10413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04667',
  },
  {
    city: 'Princeton',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 45.19846,
    longitude: -67.70543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04668',
  },
  {
    city: 'Prospect Harbor',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 37.9,
    imprecise: false,
    latitude: 44.40014,
    longitude: -68.01841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04669',
  },
  {
    city: 'Robbinston',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 45.06618,
    longitude: -67.16247,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04671',
  },
  {
    city: 'Sargentville',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 44.30484,
    longitude: -68.67028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04673',
  },
  {
    city: 'Seal Cove',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 44.29347,
    longitude: -68.40883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04674',
  },
  {
    city: 'Seal Harbor',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 44.30083,
    longitude: -68.24223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04675',
  },
  {
    city: 'Sedgwick',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 18,
    imprecise: false,
    latitude: 44.34741,
    longitude: -68.64238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04676',
  },
  {
    city: 'Sorrento',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 33.3,
    imprecise: false,
    latitude: 44.49016,
    longitude: -68.17945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04677',
  },
  {
    city: 'Southwest Harbor',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 44.4,
    imprecise: false,
    latitude: 44.27843,
    longitude: -68.33247,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04679',
  },
  {
    city: 'Steuben',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 44.50699,
    longitude: -67.94485,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04680',
  },
  {
    city: 'Stonington',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 33.1,
    imprecise: false,
    latitude: 44.16655,
    longitude: -68.65646,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04681',
  },
  {
    city: 'Sunset',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.23596,
    longitude: -68.82368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04683',
  },
  {
    city: 'Surry',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 44.49335,
    longitude: -68.52796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04684',
  },
  {
    city: 'Swans Island',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 44.15869,
    longitude: -68.44015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04685',
  },
  {
    city: 'Whiting',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 44.76178,
    longitude: -67.25217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04691',
  },
  {
    city: 'Winter Harbor',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 44.38479,
    longitude: -68.07828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04693',
  },
  {
    city: 'Baileyville',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 45.09987,
    longitude: -67.46518,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04694',
  },
  {
    city: 'Houlton',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 16,
    imprecise: false,
    latitude: 46.12574,
    longitude: -67.91471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04730',
  },
  {
    city: 'Ashland',
    county_fips: 23003,
    county_fips_all: '23003|23021',
    county: 'Aroostook',
    county_names_all: 'Aroostook|Piscataquis',
    county_weights: '{"23003": 91.43, "23021": 8.57}',
    density: 2.1,
    imprecise: false,
    latitude: 46.56679,
    longitude: -68.49326,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04732',
  },
  {
    city: 'Benedicta',
    county_fips: 23003,
    county_fips_all: '23003|23019',
    county: 'Aroostook',
    county_names_all: 'Aroostook|Penobscot',
    county_weights: '{"23003": 76.42, "23019": 23.58}',
    density: 2.8,
    imprecise: false,
    latitude: 45.74275,
    longitude: -68.40311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04733',
  },
  {
    city: 'Blaine',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 46.48479,
    longitude: -67.91955,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04734',
  },
  {
    city: 'Bridgewater',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 46.38072,
    longitude: -68.02865,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04735',
  },
  {
    city: 'Caribou',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 46.90661,
    longitude: -68.01998,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04736',
  },
  {
    city: 'Eagle Lake',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 46.97137,
    longitude: -68.61049,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04739',
  },
  {
    city: 'Easton',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 46.64325,
    longitude: -67.85487,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04740',
  },
  {
    city: 'Fort Fairfield',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 46.77766,
    longitude: -67.85526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04742',
  },
  {
    city: 'Fort Kent',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 47.15427,
    longitude: -68.72512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04743',
  },
  {
    city: 'Frenchville',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 47.27371,
    longitude: -68.39936,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04745',
  },
  {
    city: 'Grand Isle',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 47.24885,
    longitude: -68.12472,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04746',
  },
  {
    city: 'Island Falls',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 45.94854,
    longitude: -68.19649,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04747',
  },
  {
    city: 'Limestone',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 46.9582,
    longitude: -67.85718,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04750',
  },
  {
    city: 'Madawaska',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 78.5,
    imprecise: false,
    latitude: 47.33054,
    longitude: -68.30176,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04756',
  },
  {
    city: 'Mapleton',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 46.6141,
    longitude: -68.18278,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04757',
  },
  {
    city: 'Mars Hill',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 46.55426,
    longitude: -67.84732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04758',
  },
  {
    city: 'Monticello',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 46.32354,
    longitude: -67.90928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04760',
  },
  {
    city: 'New Limerick',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 46.11857,
    longitude: -67.97183,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04761',
  },
  {
    city: 'New Sweden',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 46.97574,
    longitude: -68.12094,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04762',
  },
  {
    city: 'Oakfield',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 46.08068,
    longitude: -68.10371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04763',
  },
  {
    city: 'Patten',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 46.06884,
    longitude: -68.64477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04765',
  },
  {
    city: 'Perham',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 46.88162,
    longitude: -68.23911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04766',
  },
  {
    city: 'Portage',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 46.7878,
    longitude: -68.82875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04768',
  },
  {
    city: 'Presque Isle',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 44.5,
    imprecise: false,
    latitude: 46.68676,
    longitude: -67.98737,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04769',
  },
  {
    city: 'Saint Agatha',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 11,
    imprecise: false,
    latitude: 47.23375,
    longitude: -68.32732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04772',
  },
  {
    city: 'Saint David',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 47.27426,
    longitude: -68.22649,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04773',
  },
  {
    city: 'Saint Francis',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 47.10285,
    longitude: -69.05048,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04774',
  },
  {
    city: 'Sherman',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 4,
    imprecise: false,
    latitude: 45.8105,
    longitude: -68.31818,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04776',
  },
  {
    city: 'Stacyville',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 45.83515,
    longitude: -68.48952,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04777',
  },
  {
    city: 'Sinclair',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 47.11615,
    longitude: -68.31162,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04779',
  },
  {
    city: 'Smyrna Mills',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 46.1677,
    longitude: -68.26924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04780',
  },
  {
    city: 'Wallagrass',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 47.14634,
    longitude: -68.61883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04781',
  },
  {
    city: 'Stockholm',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 47.03586,
    longitude: -68.18907,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04783',
  },
  {
    city: 'Van Buren',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 47.12678,
    longitude: -68.00368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04785',
  },
  {
    city: 'Washburn',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 46.79207,
    longitude: -68.17878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04786',
  },
  {
    city: 'Westfield',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 46.55166,
    longitude: -67.97685,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04787',
  },
  {
    city: 'Rockland',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 211.5,
    imprecise: false,
    latitude: 44.12739,
    longitude: -69.13686,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04841',
  },
  {
    city: 'Camden',
    county_fips: 23013,
    county_fips_all: '23013|23027',
    county: 'Knox',
    county_names_all: 'Knox|Waldo',
    county_weights: '{"23013": 98.5, "23027": 1.5}',
    density: 109.5,
    imprecise: false,
    latitude: 44.22929,
    longitude: -69.08924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04843',
  },
  {
    city: 'Hope',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 44.25104,
    longitude: -69.18962,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04847',
  },
  {
    city: 'Islesboro',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 44.31083,
    longitude: -68.90896,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04848',
  },
  {
    city: 'Lincolnville',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 44.3179,
    longitude: -69.04753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04849',
  },
  {
    city: 'Matinicus',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 43.85227,
    longitude: -68.8916,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04851',
  },
  {
    city: 'Monhegan',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 54.5,
    imprecise: false,
    latitude: 43.76561,
    longitude: -69.31235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04852',
  },
  {
    city: 'North Haven',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 44.15172,
    longitude: -68.86311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04853',
  },
  {
    city: 'Owls Head',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 54.2,
    imprecise: false,
    latitude: 44.04344,
    longitude: -69.08504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04854',
  },
  {
    city: 'Port Clyde',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 103.3,
    imprecise: false,
    latitude: 43.93797,
    longitude: -69.26958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04855',
  },
  {
    city: 'Rockport',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 65.6,
    imprecise: false,
    latitude: 44.17798,
    longitude: -69.12007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04856',
  },
  {
    city: 'South Thomaston',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 46.6,
    imprecise: false,
    latitude: 44.04638,
    longitude: -69.1452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04858',
  },
  {
    city: 'Spruce Head',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 65.5,
    imprecise: false,
    latitude: 44.00068,
    longitude: -69.16112,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04859',
  },
  {
    city: 'Tenants Harbor',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 43.968,
    longitude: -69.22817,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04860',
  },
  {
    city: 'Thomaston',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 97.7,
    imprecise: false,
    latitude: 44.09302,
    longitude: -69.17483,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04861',
  },
  {
    city: 'Union',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 23.9,
    imprecise: false,
    latitude: 44.26186,
    longitude: -69.27703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04862',
  },
  {
    city: 'Vinalhaven',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 20.1,
    imprecise: false,
    latitude: 44.07898,
    longitude: -68.84384,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04863',
  },
  {
    city: 'Warren',
    county_fips: 23013,
    county_fips_all: '23013',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"23013": 100}',
    density: 41,
    imprecise: false,
    latitude: 44.12946,
    longitude: -69.24481,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04864',
  },
  {
    city: 'Waterville',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 136.6,
    imprecise: false,
    latitude: 44.55449,
    longitude: -69.57037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04901',
  },
  {
    city: 'Albion',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 44.517,
    longitude: -69.44123,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04910',
  },
  {
    city: 'Anson',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 44.78039,
    longitude: -69.96112,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04911',
  },
  {
    city: 'Athens',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 44.97286,
    longitude: -69.68045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04912',
  },
  {
    city: 'Belfast',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 48.1,
    imprecise: false,
    latitude: 44.46643,
    longitude: -69.04156,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04915',
  },
  {
    city: 'Belgrade',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 30.3,
    imprecise: false,
    latitude: 44.48959,
    longitude: -69.84167,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04917',
  },
  {
    city: 'Belgrade Lakes',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.55027,
    longitude: -69.86651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04918',
  },
  {
    city: 'Bingham',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 45.11323,
    longitude: -69.83863,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04920',
  },
  {
    city: 'Brooks',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 44.57256,
    longitude: -69.13326,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04921',
  },
  {
    city: 'Burnham',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 44.68739,
    longitude: -69.38255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04922',
  },
  {
    city: 'Cambridge',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 11,
    imprecise: false,
    latitude: 45.03722,
    longitude: -69.44533,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04923',
  },
  {
    city: 'Canaan',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 44.77922,
    longitude: -69.54967,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04924',
  },
  {
    city: 'Caratunk',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 45.21477,
    longitude: -69.90509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04925',
  },
  {
    city: 'China Village',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.48035,
    longitude: -69.51521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04926',
  },
  {
    city: 'Clinton',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 29.8,
    imprecise: false,
    latitude: 44.67021,
    longitude: -69.53589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04927',
  },
  {
    city: 'Corinna',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 44.94973,
    longitude: -69.25695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04928',
  },
  {
    city: 'Detroit',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 44.76238,
    longitude: -69.31131,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04929',
  },
  {
    city: 'Dexter',
    county_fips: 23019,
    county_fips_all: '23019|23025',
    county: 'Penobscot',
    county_names_all: 'Penobscot|Somerset',
    county_weights: '{"23019": 59.21, "23025": 40.79}',
    density: 27.2,
    imprecise: false,
    latitude: 45.02656,
    longitude: -69.32835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04930',
  },
  {
    city: 'Dixmont',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 44.6957,
    longitude: -69.13335,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04932',
  },
  {
    city: 'Eustis',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.32923,
    longitude: -70.62715,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04936',
  },
  {
    city: 'Fairfield',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 47.3,
    imprecise: false,
    latitude: 44.63546,
    longitude: -69.67635,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04937',
  },
  {
    city: 'Farmington',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 33.2,
    imprecise: false,
    latitude: 44.65881,
    longitude: -70.10329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04938',
  },
  {
    city: 'Garland',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 45.05436,
    longitude: -69.15859,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04939',
  },
  {
    city: 'Freedom',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 44.4654,
    longitude: -69.3017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04941',
  },
  {
    city: 'Harmony',
    county_fips: 23025,
    county_fips_all: '23025|23021',
    county: 'Somerset',
    county_names_all: 'Somerset|Piscataquis',
    county_weights: '{"23025": 56.48, "23021": 43.52}',
    density: 3.9,
    imprecise: false,
    latitude: 45.04148,
    longitude: -69.59241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04942',
  },
  {
    city: 'Hartland',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 44.87994,
    longitude: -69.52054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04943',
  },
  {
    city: 'Hinckley',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 31.3,
    imprecise: false,
    latitude: 44.68737,
    longitude: -69.64237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04944',
  },
  {
    city: 'Jackman',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 45.57669,
    longitude: -70.27974,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04945',
  },
  {
    city: 'Kingfield',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 45.03319,
    longitude: -70.2391,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04947',
  },
  {
    city: 'Liberty',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 44.36712,
    longitude: -69.34029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04949',
  },
  {
    city: 'Madison',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 35.6,
    imprecise: false,
    latitude: 44.83241,
    longitude: -69.80556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04950',
  },
  {
    city: 'Monroe',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 44.60716,
    longitude: -69.04575,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04951',
  },
  {
    city: 'Morrill',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 44.40934,
    longitude: -69.14261,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04952',
  },
  {
    city: 'Newport',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 41.1,
    imprecise: false,
    latitude: 44.86017,
    longitude: -69.23297,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04953',
  },
  {
    city: 'New Sharon',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 44.63998,
    longitude: -70.00799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04955',
  },
  {
    city: 'New Vineyard',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 44.80533,
    longitude: -70.11215,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04956',
  },
  {
    city: 'Norridgewock',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 44.70419,
    longitude: -69.8471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04957',
  },
  {
    city: 'North Anson',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 44.90561,
    longitude: -69.92494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04958',
  },
  {
    city: 'New Portland',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 45.16024,
    longitude: -70.1665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04961',
  },
  {
    city: 'Oakland',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 56.9,
    imprecise: false,
    latitude: 44.56621,
    longitude: -69.81463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04963',
  },
  {
    city: 'Oquossoc',
    county_fips: 23017,
    county_fips_all: '23017|23007',
    county: 'Oxford',
    county_names_all: 'Oxford|Franklin',
    county_weights: '{"23017": 74.12, "23007": 25.88}',
    density: 0.5,
    imprecise: false,
    latitude: 44.9355,
    longitude: -70.83584,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04964',
  },
  {
    city: 'Palmyra',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 44.84563,
    longitude: -69.36272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04965',
  },
  {
    city: 'Phillips',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 44.82476,
    longitude: -70.47877,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04966',
  },
  {
    city: 'Pittsfield',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 31.5,
    imprecise: false,
    latitude: 44.77138,
    longitude: -69.43866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04967',
  },
  {
    city: 'Plymouth',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 44.77019,
    longitude: -69.22461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04969',
  },
  {
    city: 'Rangeley',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 45.00032,
    longitude: -70.63519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04970',
  },
  {
    city: 'Saint Albans',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 44.93191,
    longitude: -69.39225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04971',
  },
  {
    city: 'Searsmont',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 44.36229,
    longitude: -69.19303,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04973',
  },
  {
    city: 'Searsport',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 35.8,
    imprecise: false,
    latitude: 44.4893,
    longitude: -68.92996,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04974',
  },
  {
    city: 'Shawmut',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 148.5,
    imprecise: false,
    latitude: 44.62549,
    longitude: -69.58837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04975',
  },
  {
    city: 'Skowhegan',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 39.1,
    imprecise: false,
    latitude: 44.79873,
    longitude: -69.66951,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04976',
  },
  {
    city: 'Smithfield',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 44.63466,
    longitude: -69.80789,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04978',
  },
  {
    city: 'Solon',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 44.94105,
    longitude: -69.79731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04979',
  },
  {
    city: 'Stockton Springs',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 44.53228,
    longitude: -68.85941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04981',
  },
  {
    city: 'Stratton',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 45.11443,
    longitude: -70.40494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04982',
  },
  {
    city: 'Strong',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 44.92171,
    longitude: -70.30599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04983',
  },
  {
    city: 'Temple',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 9,
    imprecise: false,
    latitude: 44.69648,
    longitude: -70.28054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04984',
  },
  {
    city: 'West Forks',
    county_fips: 23025,
    county_fips_all: '23025',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"23025": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 45.3751,
    longitude: -69.8746,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04985',
  },
  {
    city: 'Thorndike',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 44.55286,
    longitude: -69.22354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04986',
  },
  {
    city: 'Troy',
    county_fips: 23027,
    county_fips_all: '23027',
    county: 'Waldo',
    county_names_all: 'Waldo',
    county_weights: '{"23027": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 44.67915,
    longitude: -69.25361,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04987',
  },
  {
    city: 'Unity',
    county_fips: 23027,
    county_fips_all: '23027|23011',
    county: 'Waldo',
    county_names_all: 'Waldo|Kennebec',
    county_weights: '{"23027": 79.89, "23011": 20.11}',
    density: 14.7,
    imprecise: false,
    latitude: 44.59588,
    longitude: -69.35959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04988',
  },
  {
    city: 'Vassalboro',
    county_fips: 23011,
    county_fips_all: '23011',
    county: 'Kennebec',
    county_names_all: 'Kennebec',
    county_weights: '{"23011": 100}',
    density: 40.1,
    imprecise: false,
    latitude: 44.4299,
    longitude: -69.64784,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04989',
  },
  {
    city: 'West Farmington',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.65983,
    longitude: -70.15584,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04992',
  },
  {
    city: 'White River Junction',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 88.1,
    imprecise: false,
    latitude: 43.67309,
    longitude: -72.37943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05001',
  },
  {
    city: 'Ascutney',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 82,
    imprecise: false,
    latitude: 43.39989,
    longitude: -72.40981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05030',
  },
  {
    city: 'Barnard',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 43.72361,
    longitude: -72.5872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05031',
  },
  {
    city: 'Bethel',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 43.80193,
    longitude: -72.65708,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05032',
  },
  {
    city: 'Bradford',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 32.3,
    imprecise: false,
    latitude: 44.00229,
    longitude: -72.16412,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05033',
  },
  {
    city: 'Bridgewater',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 19.7,
    imprecise: false,
    latitude: 43.58921,
    longitude: -72.62178,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05034',
  },
  {
    city: 'Bridgewater Corners',
    county_fips: 50027,
    county_fips_all: '50027|50021',
    county: 'Windsor',
    county_names_all: 'Windsor|Rutland',
    county_weights: '{"50027": 99.41, "50021": 0.59}',
    density: 7.3,
    imprecise: false,
    latitude: 43.61723,
    longitude: -72.67998,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05035',
  },
  {
    city: 'Brookfield',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 44.026,
    longitude: -72.57843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05036',
  },
  {
    city: 'Brownsville',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 28.6,
    imprecise: false,
    latitude: 43.46033,
    longitude: -72.48371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05037',
  },
  {
    city: 'Chelsea',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 43.99313,
    longitude: -72.45859,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05038',
  },
  {
    city: 'Corinth',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 44.03407,
    longitude: -72.2975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05039',
  },
  {
    city: 'East Corinth',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 44.06796,
    longitude: -72.20438,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05040',
  },
  {
    city: 'East Randolph',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 43.96702,
    longitude: -72.54264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05041',
  },
  {
    city: 'East Ryegate',
    county_fips: 50005,
    county_fips_all: '50005',
    county: 'Caledonia',
    county_names_all: 'Caledonia',
    county_weights: '{"50005": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 44.24013,
    longitude: -72.1053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05042',
  },
  {
    city: 'East Thetford',
    county_fips: 50017,
    county_fips_all: '50017|50027',
    county: 'Orange',
    county_names_all: 'Orange|Windsor',
    county_weights: '{"50017": 99.84, "50027": 0.16}',
    density: 38.6,
    imprecise: false,
    latitude: 43.80658,
    longitude: -72.21194,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05043',
  },
  {
    city: 'Fairlee',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 43.9144,
    longitude: -72.19881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05045',
  },
  {
    city: 'Groton',
    county_fips: 50005,
    county_fips_all: '50005',
    county: 'Caledonia',
    county_names_all: 'Caledonia',
    county_weights: '{"50005": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 44.23864,
    longitude: -72.25024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05046',
  },
  {
    city: 'Hartland',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 32.7,
    imprecise: false,
    latitude: 43.5798,
    longitude: -72.42692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05048',
  },
  {
    city: 'McIndoe Falls',
    county_fips: 50005,
    county_fips_all: '50005',
    county: 'Caledonia',
    county_names_all: 'Caledonia',
    county_weights: '{"50005": 100}',
    density: 242.8,
    imprecise: false,
    latitude: 44.26442,
    longitude: -72.06414,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05050',
  },
  {
    city: 'Newbury',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 44.08525,
    longitude: -72.11753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05051',
  },
  {
    city: 'North Hartland',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 57.5,
    imprecise: false,
    latitude: 43.6008,
    longitude: -72.35698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05052',
  },
  {
    city: 'North Pomfret',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 43.71799,
    longitude: -72.48362,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05053',
  },
  {
    city: 'Norwich',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 33.3,
    imprecise: false,
    latitude: 43.75481,
    longitude: -72.31145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05055',
  },
  {
    city: 'Plymouth',
    county_fips: 50027,
    county_fips_all: '50027|50021',
    county: 'Windsor',
    county_names_all: 'Windsor|Rutland',
    county_weights: '{"50027": 99.01, "50021": 0.99}',
    density: 3.4,
    imprecise: false,
    latitude: 43.52895,
    longitude: -72.72397,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05056',
  },
  {
    city: 'Post Mills',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 43.87917,
    longitude: -72.26999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05058',
  },
  {
    city: 'Quechee',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 43.64233,
    longitude: -72.43061,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05059',
  },
  {
    city: 'Randolph',
    county_fips: 50017,
    county_fips_all: '50017|50027|50023',
    county: 'Orange',
    county_names_all: 'Orange|Windsor|Washington',
    county_weights: '{"50017": 81.87, "50027": 11.95, "50023": 6.18}',
    density: 21.6,
    imprecise: false,
    latitude: 43.96199,
    longitude: -72.68594,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05060',
  },
  {
    city: 'Randolph Center',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 24.7,
    imprecise: false,
    latitude: 43.93023,
    longitude: -72.58087,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05061',
  },
  {
    city: 'Reading',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 43.5012,
    longitude: -72.58358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05062',
  },
  {
    city: 'Sharon',
    county_fips: 50027,
    county_fips_all: '50027|50017',
    county: 'Windsor',
    county_names_all: 'Windsor|Orange',
    county_weights: '{"50027": 94.26, "50017": 5.74}',
    density: 16.6,
    imprecise: false,
    latitude: 43.79079,
    longitude: -72.41617,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05065',
  },
  {
    city: 'South Pomfret',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 43.69162,
    longitude: -72.53944,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05067',
  },
  {
    city: 'South Royalton',
    county_fips: 50027,
    county_fips_all: '50027|50017',
    county: 'Windsor',
    county_names_all: 'Windsor|Orange',
    county_weights: '{"50027": 99.69, "50017": 0.31}',
    density: 19.4,
    imprecise: false,
    latitude: 43.79188,
    longitude: -72.52931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2987,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05068',
  },
  {
    city: 'South Ryegate',
    county_fips: 50017,
    county_fips_all: '50017|50005',
    county: 'Orange',
    county_names_all: 'Orange|Caledonia',
    county_weights: '{"50017": 60.45, "50005": 39.55}',
    density: 17.2,
    imprecise: false,
    latitude: 44.17366,
    longitude: -72.14317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05069',
  },
  {
    city: 'South Strafford',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 43.84225,
    longitude: -72.35099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05070',
  },
  {
    city: 'South Woodstock',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 43.56461,
    longitude: -72.56842,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05071',
  },
  {
    city: 'Strafford',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 43.88132,
    longitude: -72.38545,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05072',
  },
  {
    city: 'Taftsville',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 307.3,
    imprecise: false,
    latitude: 43.62901,
    longitude: -72.46108,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05073',
  },
  {
    city: 'Thetford Center',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 43.84356,
    longitude: -72.28255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05075',
  },
  {
    city: 'Topsham',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 7,
    imprecise: false,
    latitude: 44.14503,
    longitude: -72.22659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05076',
  },
  {
    city: 'Tunbridge',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 43.89961,
    longitude: -72.47789,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05077',
  },
  {
    city: 'Vershire',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 43.95622,
    longitude: -72.32214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05079',
  },
  {
    city: 'Wells River',
    county_fips: 50017,
    county_fips_all: '50017|50005',
    county: 'Orange',
    county_names_all: 'Orange|Caledonia',
    county_weights: '{"50017": 83.52, "50005": 16.48}',
    density: 16.7,
    imprecise: false,
    latitude: 44.14292,
    longitude: -72.08451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05081',
  },
  {
    city: 'West Fairlee',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 94.3,
    imprecise: false,
    latitude: 43.9184,
    longitude: -72.26782,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05083',
  },
  {
    city: 'West Hartford',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 31.5,
    imprecise: false,
    latitude: 43.72791,
    longitude: -72.45177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05084',
  },
  {
    city: 'West Topsham',
    county_fips: 50017,
    county_fips_all: '50017|50005',
    county: 'Orange',
    county_names_all: 'Orange|Caledonia',
    county_weights: '{"50017": 99.89, "50005": 0.11}',
    density: 8.5,
    imprecise: false,
    latitude: 44.1182,
    longitude: -72.30249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05086',
  },
  {
    city: 'Wilder',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 523.9,
    imprecise: false,
    latitude: 43.67332,
    longitude: -72.30726,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05088',
  },
  {
    city: 'Windsor',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 39.4,
    imprecise: false,
    latitude: 43.49686,
    longitude: -72.4515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05089',
  },
  {
    city: 'Woodstock',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 19.7,
    imprecise: false,
    latitude: 43.64707,
    longitude: -72.55165,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05091',
  },
  {
    city: 'Bellows Falls',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 57.7,
    imprecise: false,
    latitude: 43.1783,
    longitude: -72.48333,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05101',
  },
  {
    city: 'Cambridgeport',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 65.2,
    imprecise: false,
    latitude: 43.15615,
    longitude: -72.55929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05141',
  },
  {
    city: 'Cavendish',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 43.40454,
    longitude: -72.58457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05142',
  },
  {
    city: 'Chester',
    county_fips: 50027,
    county_fips_all: '50027|50025',
    county: 'Windsor',
    county_names_all: 'Windsor|Windham',
    county_weights: '{"50027": 77.14, "50025": 22.86}',
    density: 16.1,
    imprecise: false,
    latitude: 43.26267,
    longitude: -72.63095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05143',
  },
  {
    city: 'Grafton',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 43.17867,
    longitude: -72.62307,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05146',
  },
  {
    city: 'Londonderry',
    county_fips: 50025,
    county_fips_all: '50025|50003|50027',
    county: 'Windham',
    county_names_all: 'Windham|Bennington|Windsor',
    county_weights: '{"50025": 63.82, "50003": 34.85, "50027": 1.32}',
    density: 20.1,
    imprecise: false,
    latitude: 43.24503,
    longitude: -72.81224,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05148',
  },
  {
    city: 'Ludlow',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 43.40368,
    longitude: -72.7029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05149',
  },
  {
    city: 'North Springfield',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 79.8,
    imprecise: false,
    latitude: 43.33653,
    longitude: -72.52727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05150',
  },
  {
    city: 'Perkinsville',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 43.39374,
    longitude: -72.49566,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05151',
  },
  {
    city: 'Peru',
    county_fips: 50003,
    county_fips_all: '50003',
    county: 'Bennington',
    county_names_all: 'Bennington',
    county_weights: '{"50003": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 43.251,
    longitude: -72.92008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05152',
  },
  {
    city: 'Proctorsville',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 16.1,
    imprecise: false,
    latitude: 43.42885,
    longitude: -72.63487,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05153',
  },
  {
    city: 'Saxtons River',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 75.4,
    imprecise: false,
    latitude: 43.13558,
    longitude: -72.53424,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05154',
  },
  {
    city: 'South Londonderry',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 43.17717,
    longitude: -72.8228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05155',
  },
  {
    city: 'Springfield',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 57.6,
    imprecise: false,
    latitude: 43.30719,
    longitude: -72.46928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05156',
  },
  {
    city: 'Westminster',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 43.2,
    imprecise: false,
    latitude: 43.10299,
    longitude: -72.47296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05158',
  },
  {
    city: 'Weston',
    county_fips: 50027,
    county_fips_all: '50027|50021',
    county: 'Windsor',
    county_names_all: 'Windsor|Rutland',
    county_weights: '{"50027": 99.88, "50021": 0.12}',
    density: 7.4,
    imprecise: false,
    latitude: 43.3166,
    longitude: -72.8067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05161',
  },
  {
    city: 'Bennington',
    county_fips: 50003,
    county_fips_all: '50003',
    county: 'Bennington',
    county_names_all: 'Bennington',
    county_weights: '{"50003": 100}',
    density: 58.4,
    imprecise: false,
    latitude: 42.87652,
    longitude: -73.1426,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05201',
  },
  {
    city: 'Arlington',
    county_fips: 50003,
    county_fips_all: '50003',
    county: 'Bennington',
    county_names_all: 'Bennington',
    county_weights: '{"50003": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 43.12048,
    longitude: -73.19337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05250',
  },
  {
    city: 'Dorset',
    county_fips: 50003,
    county_fips_all: '50003|50021',
    county: 'Bennington',
    county_names_all: 'Bennington|Rutland',
    county_weights: '{"50003": 99.76, "50021": 0.24}',
    density: 15.5,
    imprecise: false,
    latitude: 43.26189,
    longitude: -73.08269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05251',
  },
  {
    city: 'East Arlington',
    county_fips: 50003,
    county_fips_all: '50003|50025',
    county: 'Bennington',
    county_names_all: 'Bennington|Windham',
    county_weights: '{"50003": 99.33, "50025": 0.67}',
    density: 4.5,
    imprecise: false,
    latitude: 43.06642,
    longitude: -73.06132,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05252',
  },
  {
    city: 'East Dorset',
    county_fips: 50003,
    county_fips_all: '50003|50021',
    county: 'Bennington',
    county_names_all: 'Bennington|Rutland',
    county_weights: '{"50003": 94.83, "50021": 5.17}',
    density: 15,
    imprecise: false,
    latitude: 43.25235,
    longitude: -72.99913,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05253',
  },
  {
    city: 'Manchester',
    county_fips: 50003,
    county_fips_all: '50003',
    county: 'Bennington',
    county_names_all: 'Bennington',
    county_weights: '{"50003": 100}',
    density: 67.6,
    imprecise: false,
    latitude: 43.15937,
    longitude: -73.06911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05254',
  },
  {
    city: 'Manchester Center',
    county_fips: 50003,
    county_fips_all: '50003',
    county: 'Bennington',
    county_names_all: 'Bennington',
    county_weights: '{"50003": 100}',
    density: 41.2,
    imprecise: false,
    latitude: 43.16696,
    longitude: -73.06685,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05255',
  },
  {
    city: 'North Bennington',
    county_fips: 50003,
    county_fips_all: '50003',
    county: 'Bennington',
    county_names_all: 'Bennington',
    county_weights: '{"50003": 100}',
    density: 61.7,
    imprecise: false,
    latitude: 42.96538,
    longitude: -73.25156,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05257',
  },
  {
    city: 'North Pownal',
    county_fips: 50003,
    county_fips_all: '50003',
    county: 'Bennington',
    county_names_all: 'Bennington',
    county_weights: '{"50003": 100}',
    density: 25.6,
    imprecise: false,
    latitude: 42.81594,
    longitude: -73.26173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05260',
  },
  {
    city: 'Pownal',
    county_fips: 50003,
    county_fips_all: '50003',
    county: 'Bennington',
    county_names_all: 'Bennington',
    county_weights: '{"50003": 100}',
    density: 28.9,
    imprecise: false,
    latitude: 42.77516,
    longitude: -73.21273,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05261',
  },
  {
    city: 'Shaftsbury',
    county_fips: 50003,
    county_fips_all: '50003',
    county: 'Bennington',
    county_names_all: 'Bennington',
    county_weights: '{"50003": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 42.97935,
    longitude: -73.12066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05262',
  },
  {
    city: 'Brattleboro',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 45.4,
    imprecise: false,
    latitude: 42.84346,
    longitude: -72.65901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05301',
  },
  {
    city: 'Bondville',
    county_fips: 50003,
    county_fips_all: '50003',
    county: 'Bennington',
    county_names_all: 'Bennington',
    county_weights: '{"50003": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 43.16215,
    longitude: -72.93486,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05340',
  },
  {
    city: 'East Dover',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 21.3,
    imprecise: false,
    latitude: 42.96407,
    longitude: -72.7972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05341',
  },
  {
    city: 'Jacksonville',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 42.77468,
    longitude: -72.80015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05342',
  },
  {
    city: 'Jamaica',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 43.09744,
    longitude: -72.80105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05343',
  },
  {
    city: 'Marlboro',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 1585.6,
    imprecise: false,
    latitude: 42.83896,
    longitude: -72.73257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05344',
  },
  {
    city: 'Newfane',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 42.99516,
    longitude: -72.66747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05345',
  },
  {
    city: 'Putney',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 28.5,
    imprecise: false,
    latitude: 43.02337,
    longitude: -72.53043,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05346',
  },
  {
    city: 'Readsboro',
    county_fips: 50003,
    county_fips_all: '50003|50025',
    county: 'Bennington',
    county_names_all: 'Bennington|Windham',
    county_weights: '{"50003": 99.51, "50025": 0.49}',
    density: 9,
    imprecise: false,
    latitude: 42.79879,
    longitude: -72.97187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05350',
  },
  {
    city: 'South Newfane',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 42.92867,
    longitude: -72.73728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05351',
  },
  {
    city: 'Stamford',
    county_fips: 50003,
    county_fips_all: '50003',
    county: 'Bennington',
    county_names_all: 'Bennington',
    county_weights: '{"50003": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 42.78796,
    longitude: -73.07862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05352',
  },
  {
    city: 'Townshend',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 43.06501,
    longitude: -72.66484,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05353',
  },
  {
    city: 'Vernon',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 54.4,
    imprecise: false,
    latitude: 42.76211,
    longitude: -72.52553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05354',
  },
  {
    city: 'Wardsboro',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 43.02079,
    longitude: -72.80645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05355',
  },
  {
    city: 'West Dover',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 42.95423,
    longitude: -72.86952,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05356',
  },
  {
    city: 'West Halifax',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 42.77396,
    longitude: -72.73164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05358',
  },
  {
    city: 'West Townshend',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 43.15184,
    longitude: -72.72121,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05359',
  },
  {
    city: 'West Wardsboro',
    county_fips: 50025,
    county_fips_all: '50025|50003',
    county: 'Windham',
    county_names_all: 'Windham|Bennington',
    county_weights: '{"50025": 99.67, "50003": 0.33}',
    density: 2.8,
    imprecise: false,
    latitude: 43.02778,
    longitude: -72.94378,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05360',
  },
  {
    city: 'Whitingham',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 42.78021,
    longitude: -72.87935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05361',
  },
  {
    city: 'Williamsville',
    county_fips: 50025,
    county_fips_all: '50025',
    county: 'Windham',
    county_names_all: 'Windham',
    county_weights: '{"50025": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 42.94609,
    longitude: -72.6816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05362',
  },
  {
    city: 'Wilmington',
    county_fips: 50025,
    county_fips_all: '50025|50003',
    county: 'Windham',
    county_names_all: 'Windham|Bennington',
    county_weights: '{"50025": 67.2, "50003": 32.8}',
    density: 11.6,
    imprecise: false,
    latitude: 42.88301,
    longitude: -72.89554,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05363',
  },
  {
    city: 'Burlington',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 2003.1,
    imprecise: false,
    latitude: 44.47484,
    longitude: -73.21758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05401',
  },
  {
    city: 'South Burlington',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 486.1,
    imprecise: false,
    latitude: 44.447,
    longitude: -73.17229,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05403',
  },
  {
    city: 'Winooski',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 2292.2,
    imprecise: false,
    latitude: 44.49483,
    longitude: -73.18467,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05404',
  },
  {
    city: 'Burlington',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 958,
    imprecise: false,
    latitude: 44.48969,
    longitude: -73.27139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05408',
  },
  {
    city: 'Alburgh',
    county_fips: 50013,
    county_fips_all: '50013',
    county: 'Grand Isle',
    county_names_all: 'Grand Isle',
    county_weights: '{"50013": 100}',
    density: 24.3,
    imprecise: false,
    latitude: 44.95214,
    longitude: -73.2848,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05440',
  },
  {
    city: 'Bakersfield',
    county_fips: 50011,
    county_fips_all: '50011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"50011": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 44.7686,
    longitude: -72.78669,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05441',
  },
  {
    city: 'Belvidere Center',
    county_fips: 50015,
    county_fips_all: '50015',
    county: 'Lamoille',
    county_names_all: 'Lamoille',
    county_weights: '{"50015": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 44.76164,
    longitude: -72.68043,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05442',
  },
  {
    city: 'Bristol',
    county_fips: 50001,
    county_fips_all: '50001',
    county: 'Addison',
    county_names_all: 'Addison',
    county_weights: '{"50001": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 44.12976,
    longitude: -73.03347,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05443',
  },
  {
    city: 'Cambridge',
    county_fips: 50015,
    county_fips_all: '50015|50011|50007',
    county: 'Lamoille',
    county_names_all: 'Lamoille|Franklin|Chittenden',
    county_weights: '{"50015": 60.09, "50011": 39.07, "50007": 0.84}',
    density: 24.1,
    imprecise: false,
    latitude: 44.62628,
    longitude: -72.88242,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05444',
  },
  {
    city: 'Charlotte',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 36.6,
    imprecise: false,
    latitude: 44.30896,
    longitude: -73.23593,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05445',
  },
  {
    city: 'Colchester',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 173.7,
    imprecise: false,
    latitude: 44.5541,
    longitude: -73.21647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05446',
  },
  {
    city: 'East Berkshire',
    county_fips: 50011,
    county_fips_all: '50011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"50011": 100}',
    density: 46.9,
    imprecise: false,
    latitude: 44.93615,
    longitude: -72.70447,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05447',
  },
  {
    city: 'East Fairfield',
    county_fips: 50011,
    county_fips_all: '50011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"50011": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 44.75374,
    longitude: -72.8872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05448',
  },
  {
    city: 'Enosburg Falls',
    county_fips: 50011,
    county_fips_all: '50011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"50011": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 44.89075,
    longitude: -72.79074,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05450',
  },
  {
    city: 'Essex Junction',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 216.5,
    imprecise: false,
    latitude: 44.5238,
    longitude: -73.06479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05452',
  },
  {
    city: 'Fairfax',
    county_fips: 50011,
    county_fips_all: '50011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"50011": 100}',
    density: 43.1,
    imprecise: false,
    latitude: 44.7056,
    longitude: -73.02294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05454',
  },
  {
    city: 'Fairfield',
    county_fips: 50011,
    county_fips_all: '50011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"50011": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 44.80352,
    longitude: -72.96568,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05455',
  },
  {
    city: 'Ferrisburgh',
    county_fips: 50001,
    county_fips_all: '50001',
    county: 'Addison',
    county_names_all: 'Addison',
    county_weights: '{"50001": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 44.20776,
    longitude: -73.25796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05456',
  },
  {
    city: 'Franklin',
    county_fips: 50011,
    county_fips_all: '50011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"50011": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 44.97294,
    longitude: -72.91832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05457',
  },
  {
    city: 'Grand Isle',
    county_fips: 50013,
    county_fips_all: '50013|50011',
    county: 'Grand Isle',
    county_names_all: 'Grand Isle|Franklin',
    county_weights: '{"50013": 99.39, "50011": 0.61}',
    density: 52.3,
    imprecise: false,
    latitude: 44.71838,
    longitude: -73.29837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05458',
  },
  {
    city: 'Highgate Center',
    county_fips: 50011,
    county_fips_all: '50011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"50011": 100}',
    density: 33.1,
    imprecise: false,
    latitude: 44.95568,
    longitude: -73.01861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05459',
  },
  {
    city: 'Hinesburg',
    county_fips: 50007,
    county_fips_all: '50007|50001',
    county: 'Chittenden',
    county_names_all: 'Chittenden|Addison',
    county_weights: '{"50007": 93.75, "50001": 6.25}',
    density: 45.1,
    imprecise: false,
    latitude: 44.32094,
    longitude: -73.09176,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05461',
  },
  {
    city: 'Huntington',
    county_fips: 50007,
    county_fips_all: '50007|50023|50001',
    county: 'Chittenden',
    county_names_all: 'Chittenden|Washington|Addison',
    county_weights: '{"50007": 99.71, "50023": 0.17, "50001": 0.12}',
    density: 18.5,
    imprecise: false,
    latitude: 44.29909,
    longitude: -72.95228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05462',
  },
  {
    city: 'Isle La Motte',
    county_fips: 50013,
    county_fips_all: '50013',
    county: 'Grand Isle',
    county_names_all: 'Grand Isle',
    county_weights: '{"50013": 100}',
    density: 28.3,
    imprecise: false,
    latitude: 44.86297,
    longitude: -73.34254,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05463',
  },
  {
    city: 'Jeffersonville',
    county_fips: 50015,
    county_fips_all: '50015|50011',
    county: 'Lamoille',
    county_names_all: 'Lamoille|Franklin',
    county_weights: '{"50015": 75.39, "50011": 24.61}',
    density: 20.5,
    imprecise: false,
    latitude: 44.65469,
    longitude: -72.81897,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05464',
  },
  {
    city: 'Jericho',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 37.8,
    imprecise: false,
    latitude: 44.45882,
    longitude: -72.93058,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05465',
  },
  {
    city: 'Milton',
    county_fips: 50007,
    county_fips_all: '50007|50011|50013',
    county: 'Chittenden',
    county_names_all: 'Chittenden|Franklin|Grand Isle',
    county_weights: '{"50007": 84.07, "50011": 15.81, "50013": 0.12}',
    density: 82.3,
    imprecise: false,
    latitude: 44.65378,
    longitude: -73.15343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05468',
  },
  {
    city: 'Montgomery Center',
    county_fips: 50011,
    county_fips_all: '50011|50019',
    county: 'Franklin',
    county_names_all: 'Franklin|Orleans',
    county_weights: '{"50011": 92.3, "50019": 7.7}',
    density: 5.7,
    imprecise: false,
    latitude: 44.85739,
    longitude: -72.58942,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05471',
  },
  {
    city: 'New Haven',
    county_fips: 50001,
    county_fips_all: '50001',
    county: 'Addison',
    county_names_all: 'Addison',
    county_weights: '{"50001": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 44.11377,
    longitude: -73.1611,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05472',
  },
  {
    city: 'North Ferrisburgh',
    county_fips: 50001,
    county_fips_all: '50001',
    county: 'Addison',
    county_names_all: 'Addison',
    county_weights: '{"50001": 100}',
    density: 28,
    imprecise: false,
    latitude: 44.24119,
    longitude: -73.19346,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05473',
  },
  {
    city: 'North Hero',
    county_fips: 50013,
    county_fips_all: '50013',
    county: 'Grand Isle',
    county_names_all: 'Grand Isle',
    county_weights: '{"50013": 100}',
    density: 36.2,
    imprecise: false,
    latitude: 44.83445,
    longitude: -73.26687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05474',
  },
  {
    city: 'Richford',
    county_fips: 50011,
    county_fips_all: '50011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"50011": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 44.96055,
    longitude: -72.6457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05476',
  },
  {
    city: 'Richmond',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 51.5,
    imprecise: false,
    latitude: 44.3936,
    longitude: -72.99152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05477',
  },
  {
    city: 'Saint Albans',
    county_fips: 50011,
    county_fips_all: '50011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"50011": 100}',
    density: 101.5,
    imprecise: false,
    latitude: 44.7941,
    longitude: -73.11714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05478',
  },
  {
    city: 'Saint Albans Bay',
    county_fips: 50011,
    county_fips_all: '50011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"50011": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.80833,
    longitude: -73.1396,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05481',
  },
  {
    city: 'Shelburne',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 126.5,
    imprecise: false,
    latitude: 44.39057,
    longitude: -73.24134,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05482',
  },
  {
    city: 'Sheldon',
    county_fips: 50011,
    county_fips_all: '50011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"50011": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 44.88322,
    longitude: -72.98484,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05483',
  },
  {
    city: 'Sheldon Springs',
    county_fips: 50011,
    county_fips_all: '50011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"50011": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.90405,
    longitude: -72.97567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05485',
  },
  {
    city: 'South Hero',
    county_fips: 50013,
    county_fips_all: '50013|50007',
    county: 'Grand Isle',
    county_names_all: 'Grand Isle|Chittenden',
    county_weights: '{"50013": 97.58, "50007": 2.42}',
    density: 39.9,
    imprecise: false,
    latitude: 44.62958,
    longitude: -73.31444,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05486',
  },
  {
    city: 'Starksboro',
    county_fips: 50001,
    county_fips_all: '50001|50007',
    county: 'Addison',
    county_names_all: 'Addison|Chittenden',
    county_weights: '{"50001": 89.4, "50007": 10.6}',
    density: 13.3,
    imprecise: false,
    latitude: 44.23082,
    longitude: -73.01096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05487',
  },
  {
    city: 'Swanton',
    county_fips: 50011,
    county_fips_all: '50011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"50011": 100}',
    density: 48.9,
    imprecise: false,
    latitude: 44.92214,
    longitude: -73.14286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05488',
  },
  {
    city: 'Underhill',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 44.5458,
    longitude: -72.89471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05489',
  },
  {
    city: 'Vergennes',
    county_fips: 50001,
    county_fips_all: '50001',
    county: 'Addison',
    county_names_all: 'Addison',
    county_weights: '{"50001": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 44.12101,
    longitude: -73.32111,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05491',
  },
  {
    city: 'Waterville',
    county_fips: 50015,
    county_fips_all: '50015|50011',
    county: 'Lamoille',
    county_names_all: 'Lamoille|Franklin',
    county_weights: '{"50015": 97.68, "50011": 2.32}',
    density: 15.9,
    imprecise: false,
    latitude: 44.71324,
    longitude: -72.75853,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05492',
  },
  {
    city: 'Westford',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 44.60472,
    longitude: -73.01523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05494',
  },
  {
    city: 'Williston',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 123.5,
    imprecise: false,
    latitude: 44.42901,
    longitude: -73.09197,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05495',
  },
  {
    city: 'Montpelier',
    county_fips: 50023,
    county_fips_all: '50023',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"50023": 100}',
    density: 53.8,
    imprecise: false,
    latitude: 44.2848,
    longitude: -72.61498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05602',
  },
  {
    city: 'Adamant',
    county_fips: 50023,
    county_fips_all: '50023',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"50023": 100}',
    density: 41.2,
    imprecise: false,
    latitude: 44.34734,
    longitude: -72.49675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05640',
  },
  {
    city: 'Barre',
    county_fips: 50023,
    county_fips_all: '50023|50017|50005',
    county: 'Washington',
    county_names_all: 'Washington|Orange|Caledonia',
    county_weights: '{"50023": 61.55, "50017": 38.34, "50005": 0.11}',
    density: 97.4,
    imprecise: false,
    latitude: 44.18602,
    longitude: -72.45108,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05641',
  },
  {
    city: 'Cabot',
    county_fips: 50023,
    county_fips_all: '50023|50005',
    county: 'Washington',
    county_names_all: 'Washington|Caledonia',
    county_weights: '{"50023": 99.89, "50005": 0.11}',
    density: 15.9,
    imprecise: false,
    latitude: 44.41001,
    longitude: -72.29126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05647',
  },
  {
    city: 'Calais',
    county_fips: 50023,
    county_fips_all: '50023',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"50023": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 44.38372,
    longitude: -72.49355,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05648',
  },
  {
    city: 'East Barre',
    county_fips: 50017,
    county_fips_all: '50017|50023',
    county: 'Orange',
    county_names_all: 'Orange|Washington',
    county_weights: '{"50017": 91.16, "50023": 8.84}',
    density: 32.6,
    imprecise: false,
    latitude: 44.14004,
    longitude: -72.36589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05649',
  },
  {
    city: 'East Calais',
    county_fips: 50023,
    county_fips_all: '50023',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"50023": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 44.4002,
    longitude: -72.44235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05650',
  },
  {
    city: 'East Montpelier',
    county_fips: 50023,
    county_fips_all: '50023',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"50023": 100}',
    density: 34.7,
    imprecise: false,
    latitude: 44.27777,
    longitude: -72.49246,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05651',
  },
  {
    city: 'Eden',
    county_fips: 50015,
    county_fips_all: '50015|50019|50011',
    county: 'Lamoille',
    county_names_all: 'Lamoille|Orleans|Franklin',
    county_weights: '{"50015": 99.62, "50019": 0.28, "50011": 0.1}',
    density: 10,
    imprecise: false,
    latitude: 44.72824,
    longitude: -72.58674,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05652',
  },
  {
    city: 'Eden Mills',
    county_fips: 50015,
    county_fips_all: '50015|50019',
    county: 'Lamoille',
    county_names_all: 'Lamoille|Orleans',
    county_weights: '{"50015": 99.76, "50019": 0.24}',
    density: 6.5,
    imprecise: false,
    latitude: 44.70141,
    longitude: -72.49275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05653',
  },
  {
    city: 'Graniteville',
    county_fips: 50017,
    county_fips_all: '50017|50023',
    county: 'Orange',
    county_names_all: 'Orange|Washington',
    county_weights: '{"50017": 51.41, "50023": 48.59}',
    density: 76.7,
    imprecise: false,
    latitude: 44.14053,
    longitude: -72.48092,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05654',
  },
  {
    city: 'Hyde Park',
    county_fips: 50015,
    county_fips_all: '50015',
    county: 'Lamoille',
    county_names_all: 'Lamoille',
    county_weights: '{"50015": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 44.62461,
    longitude: -72.56462,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05655',
  },
  {
    city: 'Johnson',
    county_fips: 50015,
    county_fips_all: '50015',
    county: 'Lamoille',
    county_names_all: 'Lamoille',
    county_weights: '{"50015": 100}',
    density: 28.2,
    imprecise: false,
    latitude: 44.64898,
    longitude: -72.68825,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05656',
  },
  {
    city: 'Marshfield',
    county_fips: 50023,
    county_fips_all: '50023',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"50023": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 44.35921,
    longitude: -72.35399,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05658',
  },
  {
    city: 'Moretown',
    county_fips: 50023,
    county_fips_all: '50023',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"50023": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 44.24733,
    longitude: -72.76808,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05660',
  },
  {
    city: 'Morrisville',
    county_fips: 50015,
    county_fips_all: '50015',
    county: 'Lamoille',
    county_names_all: 'Lamoille',
    county_weights: '{"50015": 100}',
    density: 36.8,
    imprecise: false,
    latitude: 44.53743,
    longitude: -72.61724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05661',
  },
  {
    city: 'Northfield',
    county_fips: 50023,
    county_fips_all: '50023|50017',
    county: 'Washington',
    county_names_all: 'Washington|Orange',
    county_weights: '{"50023": 97.22, "50017": 2.78}',
    density: 43.5,
    imprecise: false,
    latitude: 44.14946,
    longitude: -72.67239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05663',
  },
  {
    city: 'Northfield Falls',
    county_fips: 50023,
    county_fips_all: '50023',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"50023": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.16718,
    longitude: -72.65316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05664',
  },
  {
    city: 'North Montpelier',
    county_fips: 50023,
    county_fips_all: '50023',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"50023": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 44.34125,
    longitude: -72.43873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05666',
  },
  {
    city: 'Plainfield',
    county_fips: 50023,
    county_fips_all: '50023|50005',
    county: 'Washington',
    county_names_all: 'Washington|Caledonia',
    county_weights: '{"50023": 99.87, "50005": 0.13}',
    density: 18.8,
    imprecise: false,
    latitude: 44.28122,
    longitude: -72.3986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05667',
  },
  {
    city: 'Roxbury',
    county_fips: 50023,
    county_fips_all: '50023|50001|50017',
    county: 'Washington',
    county_names_all: 'Washington|Addison|Orange',
    county_weights: '{"50023": 69.75, "50001": 22.83, "50017": 7.42}',
    density: 6.1,
    imprecise: false,
    latitude: 44.05325,
    longitude: -72.75155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05669',
  },
  {
    city: 'South Barre',
    county_fips: 50023,
    county_fips_all: '50023',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"50023": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.17799,
    longitude: -72.50558,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05670',
  },
  {
    city: 'Stowe',
    county_fips: 50015,
    county_fips_all: '50015|50023',
    county: 'Lamoille',
    county_names_all: 'Lamoille|Washington',
    county_weights: '{"50015": 99.87, "50023": 0.13}',
    density: 28,
    imprecise: false,
    latitude: 44.48151,
    longitude: -72.72174,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05672',
  },
  {
    city: 'Waitsfield',
    county_fips: 50023,
    county_fips_all: '50023',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"50023": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 44.19371,
    longitude: -72.84356,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05673',
  },
  {
    city: 'Warren',
    county_fips: 50023,
    county_fips_all: '50023|50001',
    county: 'Washington',
    county_names_all: 'Washington|Addison',
    county_weights: '{"50023": 99.22, "50001": 0.78}',
    density: 15.3,
    imprecise: false,
    latitude: 44.11112,
    longitude: -72.86081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05674',
  },
  {
    city: 'Washington',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 44.07386,
    longitude: -72.41821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05675',
  },
  {
    city: 'Waterbury',
    county_fips: 50023,
    county_fips_all: '50023|50007',
    county: 'Washington',
    county_names_all: 'Washington|Chittenden',
    county_weights: '{"50023": 79.51, "50007": 20.49}',
    density: 20.7,
    imprecise: false,
    latitude: 44.34825,
    longitude: -72.80984,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05676',
  },
  {
    city: 'Waterbury Center',
    county_fips: 50023,
    county_fips_all: '50023',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"50023": 100}',
    density: 56.3,
    imprecise: false,
    latitude: 44.39194,
    longitude: -72.70841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05677',
  },
  {
    city: 'Websterville',
    county_fips: 50023,
    county_fips_all: '50023',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"50023": 100}',
    density: 108.3,
    imprecise: false,
    latitude: 44.15577,
    longitude: -72.47445,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05678',
  },
  {
    city: 'Williamstown',
    county_fips: 50017,
    county_fips_all: '50017',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"50017": 100}',
    density: 31.6,
    imprecise: false,
    latitude: 44.10677,
    longitude: -72.54052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05679',
  },
  {
    city: 'Wolcott',
    county_fips: 50015,
    county_fips_all: '50015|50023',
    county: 'Lamoille',
    county_names_all: 'Lamoille|Washington',
    county_weights: '{"50015": 97.13, "50023": 2.87}',
    density: 11.9,
    imprecise: false,
    latitude: 44.53785,
    longitude: -72.46838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05680',
  },
  {
    city: 'Woodbury',
    county_fips: 50023,
    county_fips_all: '50023',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"50023": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 44.45377,
    longitude: -72.38016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05681',
  },
  {
    city: 'Worcester',
    county_fips: 50023,
    county_fips_all: '50023|50015',
    county: 'Washington',
    county_names_all: 'Washington|Lamoille',
    county_weights: '{"50023": 99.9, "50015": 0.1}',
    density: 9.7,
    imprecise: false,
    latitude: 44.40354,
    longitude: -72.57219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05682',
  },
  {
    city: 'Rutland',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 116.2,
    imprecise: false,
    latitude: 43.63365,
    longitude: -72.91368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05701',
  },
  {
    city: 'Belmont',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 43.40262,
    longitude: -72.81508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05730',
  },
  {
    city: 'Benson',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 43.7532,
    longitude: -73.28857,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05731',
  },
  {
    city: 'Bomoseen',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 41.9,
    imprecise: false,
    latitude: 43.67998,
    longitude: -73.18648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05732',
  },
  {
    city: 'Brandon',
    county_fips: 50021,
    county_fips_all: '50021|50001',
    county: 'Rutland',
    county_names_all: 'Rutland|Addison',
    county_weights: '{"50021": 60.45, "50001": 39.55}',
    density: 21.5,
    imprecise: false,
    latitude: 43.81746,
    longitude: -73.09216,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05733',
  },
  {
    city: 'Bridport',
    county_fips: 50001,
    county_fips_all: '50001',
    county: 'Addison',
    county_names_all: 'Addison',
    county_weights: '{"50001": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 43.98243,
    longitude: -73.33286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05734',
  },
  {
    city: 'Castleton',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 31.8,
    imprecise: false,
    latitude: 43.64475,
    longitude: -73.15456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05735',
  },
  {
    city: 'Center Rutland',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 46.6,
    imprecise: false,
    latitude: 43.60483,
    longitude: -73.01273,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05736',
  },
  {
    city: 'Chittenden',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 43.76778,
    longitude: -72.90434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05737',
  },
  {
    city: 'Cuttingsville',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 43.52895,
    longitude: -72.85637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05738',
  },
  {
    city: 'Danby',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 43.34488,
    longitude: -73.0295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05739',
  },
  {
    city: 'East Wallingford',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 43.43685,
    longitude: -72.9045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05742',
  },
  {
    city: 'Fair Haven',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 43.67118,
    longitude: -73.30726,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05743',
  },
  {
    city: 'Florence',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 43.69034,
    longitude: -73.08272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05744',
  },
  {
    city: 'Gaysville',
    county_fips: 50027,
    county_fips_all: '50027|50021',
    county: 'Windsor',
    county_names_all: 'Windsor|Rutland',
    county_weights: '{"50027": 98.51, "50021": 1.49}',
    density: 0,
    imprecise: false,
    latitude: 43.72098,
    longitude: -72.78836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05746',
  },
  {
    city: 'Granville',
    county_fips: 50001,
    county_fips_all: '50001',
    county: 'Addison',
    county_names_all: 'Addison',
    county_weights: '{"50001": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 44.00354,
    longitude: -72.85494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05747',
  },
  {
    city: 'Hancock',
    county_fips: 50001,
    county_fips_all: '50001',
    county: 'Addison',
    county_names_all: 'Addison',
    county_weights: '{"50001": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 43.92004,
    longitude: -72.91064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05748',
  },
  {
    city: 'Killington',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 43.6542,
    longitude: -72.78941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05751',
  },
  {
    city: 'Middlebury',
    county_fips: 50001,
    county_fips_all: '50001',
    county: 'Addison',
    county_names_all: 'Addison',
    county_weights: '{"50001": 100}',
    density: 51.1,
    imprecise: false,
    latitude: 43.9991,
    longitude: -73.17403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05753',
  },
  {
    city: 'Middletown Springs',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 43.48279,
    longitude: -73.12325,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05757',
  },
  {
    city: 'Mount Holly',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 11,
    imprecise: false,
    latitude: 43.44797,
    longitude: -72.78386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05758',
  },
  {
    city: 'North Clarendon',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 37.3,
    imprecise: false,
    latitude: 43.53926,
    longitude: -72.96483,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05759',
  },
  {
    city: 'Orwell',
    county_fips: 50001,
    county_fips_all: '50001|50021',
    county: 'Addison',
    county_names_all: 'Addison|Rutland',
    county_weights: '{"50001": 99.43, "50021": 0.57}',
    density: 10.7,
    imprecise: false,
    latitude: 43.80359,
    longitude: -73.29517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05760',
  },
  {
    city: 'Pawlet',
    county_fips: 50021,
    county_fips_all: '50021|50003',
    county: 'Rutland',
    county_names_all: 'Rutland|Bennington',
    county_weights: '{"50021": 78.83, "50003": 21.17}',
    density: 10.2,
    imprecise: false,
    latitude: 43.34786,
    longitude: -73.14855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05761',
  },
  {
    city: 'Pittsfield',
    county_fips: 50021,
    county_fips_all: '50021|50027',
    county: 'Rutland',
    county_names_all: 'Rutland|Windsor',
    county_weights: '{"50021": 99.78, "50027": 0.22}',
    density: 7.4,
    imprecise: false,
    latitude: 43.79246,
    longitude: -72.8291,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05762',
  },
  {
    city: 'Pittsford',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 43.73678,
    longitude: -72.98946,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05763',
  },
  {
    city: 'Poultney',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 26.9,
    imprecise: false,
    latitude: 43.52854,
    longitude: -73.19401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05764',
  },
  {
    city: 'Proctor',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 97,
    imprecise: false,
    latitude: 43.65068,
    longitude: -73.03648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05765',
  },
  {
    city: 'Ripton',
    county_fips: 50001,
    county_fips_all: '50001',
    county: 'Addison',
    county_names_all: 'Addison',
    county_weights: '{"50001": 100}',
    density: 4,
    imprecise: false,
    latitude: 43.98833,
    longitude: -72.99072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05766',
  },
  {
    city: 'Rochester',
    county_fips: 50027,
    county_fips_all: '50027|50021|50001',
    county: 'Windsor',
    county_names_all: 'Windsor|Rutland|Addison',
    county_weights: '{"50027": 99.16, "50021": 0.72, "50001": 0.12}',
    density: 9.4,
    imprecise: false,
    latitude: 43.87513,
    longitude: -72.82878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05767',
  },
  {
    city: 'Rupert',
    county_fips: 50003,
    county_fips_all: '50003',
    county: 'Bennington',
    county_names_all: 'Bennington',
    county_weights: '{"50003": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 43.29846,
    longitude: -73.22168,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05768',
  },
  {
    city: 'Salisbury',
    county_fips: 50001,
    county_fips_all: '50001',
    county: 'Addison',
    county_names_all: 'Addison',
    county_weights: '{"50001": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 43.91948,
    longitude: -73.11651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05769',
  },
  {
    city: 'Shoreham',
    county_fips: 50001,
    county_fips_all: '50001',
    county: 'Addison',
    county_names_all: 'Addison',
    county_weights: '{"50001": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 43.88662,
    longitude: -73.32771,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05770',
  },
  {
    city: 'Stockbridge',
    county_fips: 50027,
    county_fips_all: '50027|50021',
    county: 'Windsor',
    county_names_all: 'Windsor|Rutland',
    county_weights: '{"50027": 99.16, "50021": 0.84}',
    density: 7.4,
    imprecise: false,
    latitude: 43.75989,
    longitude: -72.74003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05772',
  },
  {
    city: 'Wallingford',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 43.40902,
    longitude: -72.96858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05773',
  },
  {
    city: 'Wells',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 43.42708,
    longitude: -73.17435,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05774',
  },
  {
    city: 'West Pawlet',
    county_fips: 50021,
    county_fips_all: '50021|50003',
    county: 'Rutland',
    county_names_all: 'Rutland|Bennington',
    county_weights: '{"50021": 92.37, "50003": 7.63}',
    density: 15.3,
    imprecise: false,
    latitude: 43.35437,
    longitude: -73.22804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05775',
  },
  {
    city: 'West Rupert',
    county_fips: 50003,
    county_fips_all: '50003',
    county: 'Bennington',
    county_names_all: 'Bennington',
    county_weights: '{"50003": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 43.24494,
    longitude: -73.20392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05776',
  },
  {
    city: 'West Rutland',
    county_fips: 50021,
    county_fips_all: '50021',
    county: 'Rutland',
    county_names_all: 'Rutland',
    county_weights: '{"50021": 100}',
    density: 28,
    imprecise: false,
    latitude: 43.5552,
    longitude: -73.05504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05777',
  },
  {
    city: 'Whiting',
    county_fips: 50001,
    county_fips_all: '50001|50021',
    county: 'Addison',
    county_names_all: 'Addison|Rutland',
    county_weights: '{"50001": 92.42, "50021": 7.58}',
    density: 14.5,
    imprecise: false,
    latitude: 43.87279,
    longitude: -73.21228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05778',
  },
  {
    city: 'Saint Johnsbury',
    county_fips: 50005,
    county_fips_all: '50005',
    county: 'Caledonia',
    county_names_all: 'Caledonia',
    county_weights: '{"50005": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 44.40397,
    longitude: -71.98837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05819',
  },
  {
    city: 'Albany',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 44.74862,
    longitude: -72.37351,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05820',
  },
  {
    city: 'Barnet',
    county_fips: 50005,
    county_fips_all: '50005',
    county: 'Caledonia',
    county_names_all: 'Caledonia',
    county_weights: '{"50005": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 44.3175,
    longitude: -72.10866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05821',
  },
  {
    city: 'Barton',
    county_fips: 50019,
    county_fips_all: '50019|50005',
    county: 'Orleans',
    county_names_all: 'Orleans|Caledonia',
    county_weights: '{"50019": 99.31, "50005": 0.69}',
    density: 19.1,
    imprecise: false,
    latitude: 44.75555,
    longitude: -72.15478,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05822',
  },
  {
    city: 'Concord',
    county_fips: 50009,
    county_fips_all: '50009|50005',
    county: 'Essex',
    county_names_all: 'Essex|Caledonia',
    county_weights: '{"50009": 68.98, "50005": 31.02}',
    density: 8.7,
    imprecise: false,
    latitude: 44.43741,
    longitude: -71.86449,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05824',
  },
  {
    city: 'Coventry',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 49.5,
    imprecise: false,
    latitude: 44.86019,
    longitude: -72.25664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05825',
  },
  {
    city: 'Craftsbury',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 44.6444,
    longitude: -72.40404,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05826',
  },
  {
    city: 'Craftsbury Common',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 44.68135,
    longitude: -72.36198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05827',
  },
  {
    city: 'Danville',
    county_fips: 50005,
    county_fips_all: '50005',
    county: 'Caledonia',
    county_names_all: 'Caledonia',
    county_weights: '{"50005": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 44.43748,
    longitude: -72.12334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05828',
  },
  {
    city: 'Derby',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 27.3,
    imprecise: false,
    latitude: 44.95349,
    longitude: -72.0759,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05829',
  },
  {
    city: 'Derby Line',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 44.97717,
    longitude: -71.98278,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05830',
  },
  {
    city: 'East Burke',
    county_fips: 50005,
    county_fips_all: '50005|50009',
    county: 'Caledonia',
    county_names_all: 'Caledonia|Essex',
    county_weights: '{"50005": 99.7, "50009": 0.3}',
    density: 14.9,
    imprecise: false,
    latitude: 44.59546,
    longitude: -71.91027,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05832',
  },
  {
    city: 'East Charleston',
    county_fips: 50019,
    county_fips_all: '50019|50009',
    county: 'Orleans',
    county_names_all: 'Orleans|Essex',
    county_weights: '{"50019": 99.89, "50009": 0.11}',
    density: 9.5,
    imprecise: false,
    latitude: 44.83182,
    longitude: -71.96965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05833',
  },
  {
    city: 'East Hardwick',
    county_fips: 50005,
    county_fips_all: '50005',
    county: 'Caledonia',
    county_names_all: 'Caledonia',
    county_weights: '{"50005": 100}',
    density: 18,
    imprecise: false,
    latitude: 44.5196,
    longitude: -72.25173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05836',
  },
  {
    city: 'East Haven',
    county_fips: 50009,
    county_fips_all: '50009|50005',
    county: 'Essex',
    county_names_all: 'Essex|Caledonia',
    county_weights: '{"50009": 75.03, "50005": 24.97}',
    density: 2.3,
    imprecise: false,
    latitude: 44.66868,
    longitude: -71.8386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05837',
  },
  {
    city: 'Glover',
    county_fips: 50019,
    county_fips_all: '50019|50005',
    county: 'Orleans',
    county_names_all: 'Orleans|Caledonia',
    county_weights: '{"50019": 98.68, "50005": 1.32}',
    density: 10.8,
    imprecise: false,
    latitude: 44.67342,
    longitude: -72.21171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05839',
  },
  {
    city: 'Granby',
    county_fips: 50009,
    county_fips_all: '50009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"50009": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 44.61297,
    longitude: -71.73129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05840',
  },
  {
    city: 'Greensboro',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 44.60794,
    longitude: -72.30232,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05841',
  },
  {
    city: 'Greensboro Bend',
    county_fips: 50019,
    county_fips_all: '50019|50005',
    county: 'Orleans',
    county_names_all: 'Orleans|Caledonia',
    county_weights: '{"50019": 65.37, "50005": 34.63}',
    density: 9.8,
    imprecise: false,
    latitude: 44.57966,
    longitude: -72.24453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05842',
  },
  {
    city: 'Hardwick',
    county_fips: 50005,
    county_fips_all: '50005|50023',
    county: 'Caledonia',
    county_names_all: 'Caledonia|Washington',
    county_weights: '{"50005": 87.71, "50023": 12.29}',
    density: 18.2,
    imprecise: false,
    latitude: 44.50355,
    longitude: -72.33366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05843',
  },
  {
    city: 'Irasburg',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 44.79146,
    longitude: -72.30699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05845',
  },
  {
    city: 'Island Pond',
    county_fips: 50009,
    county_fips_all: '50009|50019',
    county: 'Essex',
    county_names_all: 'Essex|Orleans',
    county_weights: '{"50009": 93.51, "50019": 6.49}',
    density: 5,
    imprecise: false,
    latitude: 44.82671,
    longitude: -71.82795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05846',
  },
  {
    city: 'Lowell',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 44.79165,
    longitude: -72.45679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05847',
  },
  {
    city: 'Lyndon Center',
    county_fips: 50005,
    county_fips_all: '50005',
    county: 'Caledonia',
    county_names_all: 'Caledonia',
    county_weights: '{"50005": 100}',
    density: 84.8,
    imprecise: false,
    latitude: 44.55955,
    longitude: -72.03417,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05850',
  },
  {
    city: 'Lyndonville',
    county_fips: 50005,
    county_fips_all: '50005',
    county: 'Caledonia',
    county_names_all: 'Caledonia',
    county_weights: '{"50005": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 44.55297,
    longitude: -72.05732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05851',
  },
  {
    city: 'Morgan',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 44.89499,
    longitude: -71.96167,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05853',
  },
  {
    city: 'Newport',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 48.4,
    imprecise: false,
    latitude: 44.92829,
    longitude: -72.1943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05855',
  },
  {
    city: 'Newport Center',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 44.93381,
    longitude: -72.3092,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05857',
  },
  {
    city: 'North Concord',
    county_fips: 50009,
    county_fips_all: '50009|50005',
    county: 'Essex',
    county_names_all: 'Essex|Caledonia',
    county_weights: '{"50009": 99.9, "50005": 0.1}',
    density: 2,
    imprecise: false,
    latitude: 44.53587,
    longitude: -71.8046,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05858',
  },
  {
    city: 'North Troy',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 44.95987,
    longitude: -72.43833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05859',
  },
  {
    city: 'Orleans',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 44.80018,
    longitude: -72.10353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05860',
  },
  {
    city: 'Peacham',
    county_fips: 50005,
    county_fips_all: '50005|50023',
    county: 'Caledonia',
    county_names_all: 'Caledonia|Washington',
    county_weights: '{"50005": 99.81, "50023": 0.19}',
    density: 5.8,
    imprecise: false,
    latitude: 44.31971,
    longitude: -72.23133,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05862',
  },
  {
    city: 'Sheffield',
    county_fips: 50005,
    county_fips_all: '50005|50019',
    county: 'Caledonia',
    county_names_all: 'Caledonia|Orleans',
    county_weights: '{"50005": 99.76, "50019": 0.24}',
    density: 7.7,
    imprecise: false,
    latitude: 44.63863,
    longitude: -72.12699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05866',
  },
  {
    city: 'Sutton',
    county_fips: 50005,
    county_fips_all: '50005',
    county: 'Caledonia',
    county_names_all: 'Caledonia',
    county_weights: '{"50005": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 44.66505,
    longitude: -72.04366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05867',
  },
  {
    city: 'Troy',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 44.91881,
    longitude: -72.3675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05868',
  },
  {
    city: 'West Burke',
    county_fips: 50005,
    county_fips_all: '50005',
    county: 'Caledonia',
    county_names_all: 'Caledonia',
    county_weights: '{"50005": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 44.68367,
    longitude: -71.95193,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05871',
  },
  {
    city: 'West Charleston',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 44.86059,
    longitude: -72.03473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05872',
  },
  {
    city: 'West Danville',
    county_fips: 50005,
    county_fips_all: '50005|50023',
    county: 'Caledonia',
    county_names_all: 'Caledonia|Washington',
    county_weights: '{"50005": 94.67, "50023": 5.33}',
    density: 12.9,
    imprecise: false,
    latitude: 44.40619,
    longitude: -72.21841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05873',
  },
  {
    city: 'Westfield',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 44.87546,
    longitude: -72.46172,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05874',
  },
  {
    city: 'Barton',
    county_fips: 50019,
    county_fips_all: '50019',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"50019": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 44.70947,
    longitude: -72.26753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05875',
  },
  {
    city: 'Averill',
    county_fips: 50009,
    county_fips_all: '50009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"50009": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 44.94197,
    longitude: -71.68079,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05901',
  },
  {
    city: 'Beecher Falls',
    county_fips: 50009,
    county_fips_all: '50009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"50009": 100}',
    density: 30.8,
    imprecise: false,
    latitude: 45.00881,
    longitude: -71.49472,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05902',
  },
  {
    city: 'Canaan',
    county_fips: 50009,
    county_fips_all: '50009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"50009": 100}',
    density: 5,
    imprecise: false,
    latitude: 44.9379,
    longitude: -71.58286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05903',
  },
  {
    city: 'Gilman',
    county_fips: 50009,
    county_fips_all: '50009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"50009": 100}',
    density: 131.3,
    imprecise: false,
    latitude: 44.41597,
    longitude: -71.70762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05904',
  },
  {
    city: 'Guildhall',
    county_fips: 50009,
    county_fips_all: '50009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"50009": 100}',
    density: 2,
    imprecise: false,
    latitude: 44.70151,
    longitude: -71.66672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05905',
  },
  {
    city: 'Lunenburg',
    county_fips: 50009,
    county_fips_all: '50009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"50009": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 44.47431,
    longitude: -71.71538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05906',
  },
  {
    city: 'Norton',
    county_fips: 50009,
    county_fips_all: '50009',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"50009": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 44.9502,
    longitude: -71.82577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05907',
  },
  {
    city: 'Avon',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 302.5,
    imprecise: false,
    latitude: 41.79185,
    longitude: -72.85107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06001',
  },
  {
    city: 'Bloomfield',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 328.6,
    imprecise: false,
    latitude: 41.84286,
    longitude: -72.73714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06002',
  },
  {
    city: 'Bristol',
    county_fips: 9140,
    county_fips_all: '09140|09110',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley|Capitol',
    county_weights: '{"09140": 99.57, "09110": 0.43}',
    density: 898.9,
    imprecise: false,
    latitude: 41.681,
    longitude: -72.94065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 61684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06010',
  },
  {
    city: 'Burlington',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 125.8,
    imprecise: false,
    latitude: 41.7598,
    longitude: -72.95895,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06013',
  },
  {
    city: 'Broad Brook',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 179.1,
    imprecise: false,
    latitude: 41.90417,
    longitude: -72.54438,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06016',
  },
  {
    city: 'Canaan',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 75.3,
    imprecise: false,
    latitude: 42.02872,
    longitude: -73.29807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06018',
  },
  {
    city: 'Canton',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 166.9,
    imprecise: false,
    latitude: 41.8592,
    longitude: -72.90717,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06019',
  },
  {
    city: 'Canton Center',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.86283,
    longitude: -72.90991,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06020',
  },
  {
    city: 'Colebrook',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 42.00152,
    longitude: -73.08078,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06021',
  },
  {
    city: 'Collinsville',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 41.86595,
    longitude: -72.92749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06022',
  },
  {
    city: 'East Berlin',
    county_fips: 9110,
    county_fips_all: '09110|09130',
    county: 'Capitol',
    county_names_all: 'Capitol|Lower Connecticut River Valley',
    county_weights: '{"09110": 99.77, "09130": 0.23}',
    density: 464.1,
    imprecise: false,
    latitude: 41.61355,
    longitude: -72.72072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06023',
  },
  {
    city: 'East Canaan',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 40.1,
    imprecise: false,
    latitude: 42.00812,
    longitude: -73.28374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06024',
  },
  {
    city: 'East Granby',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 114.2,
    imprecise: false,
    latitude: 41.94242,
    longitude: -72.74093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06026',
  },
  {
    city: 'East Hartland',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 29.2,
    imprecise: false,
    latitude: 42.00403,
    longitude: -72.91112,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06027',
  },
  {
    city: 'Ellington',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 191.6,
    imprecise: false,
    latitude: 41.91439,
    longitude: -72.4535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06029',
  },
  {
    city: 'Falls Village',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 41.95788,
    longitude: -73.31733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06031',
  },
  {
    city: 'Farmington',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 320,
    imprecise: false,
    latitude: 41.72528,
    longitude: -72.83147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06032',
  },
  {
    city: 'Glastonbury',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 314.4,
    imprecise: false,
    latitude: 41.70593,
    longitude: -72.53915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06033',
  },
  {
    city: 'Granby',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 190.8,
    imprecise: false,
    latitude: 41.9608,
    longitude: -72.80179,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06035',
  },
  {
    city: 'Berlin',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 290.7,
    imprecise: false,
    latitude: 41.61148,
    longitude: -72.7775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06037',
  },
  {
    city: 'Lakeville',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 34.2,
    imprecise: false,
    latitude: 41.95001,
    longitude: -73.44379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06039',
  },
  {
    city: 'Manchester',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 816.9,
    imprecise: false,
    latitude: 41.7616,
    longitude: -72.52247,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06040',
  },
  {
    city: 'Manchester',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 877.9,
    imprecise: false,
    latitude: 41.79743,
    longitude: -72.52704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06042',
  },
  {
    city: 'Bolton',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 130,
    imprecise: false,
    latitude: 41.76647,
    longitude: -72.43903,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06043',
  },
  {
    city: 'New Britain',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 2780,
    imprecise: false,
    latitude: 41.66519,
    longitude: -72.76983,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06051',
  },
  {
    city: 'New Britain',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 1178.7,
    imprecise: false,
    latitude: 41.65736,
    longitude: -72.80506,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06052',
  },
  {
    city: 'New Britain',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 1786.4,
    imprecise: false,
    latitude: 41.68874,
    longitude: -72.7941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06053',
  },
  {
    city: 'New Hartford',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 66.8,
    imprecise: false,
    latitude: 41.84417,
    longitude: -73.00552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06057',
  },
  {
    city: 'Norfolk',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 41.97186,
    longitude: -73.1958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06058',
  },
  {
    city: 'North Canton',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 443.3,
    imprecise: false,
    latitude: 41.89054,
    longitude: -72.88833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06059',
  },
  {
    city: 'North Granby',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 75.4,
    imprecise: false,
    latitude: 42.00687,
    longitude: -72.84594,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06060',
  },
  {
    city: 'Pine Meadow',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 732.6,
    imprecise: false,
    latitude: 41.87524,
    longitude: -72.96716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06061',
  },
  {
    city: 'Plainville',
    county_fips: 9110,
    county_fips_all: '09110|09140',
    county: 'Capitol',
    county_names_all: 'Capitol|Naugatuck Valley',
    county_weights: '{"09110": 99.88, "09140": 0.12}',
    density: 774.3,
    imprecise: false,
    latitude: 41.67338,
    longitude: -72.86079,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06062',
  },
  {
    city: 'Barkhamsted',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 37.4,
    imprecise: false,
    latitude: 41.93053,
    longitude: -72.97096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06063',
  },
  {
    city: 'Riverton',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 34.4,
    imprecise: false,
    latitude: 41.97795,
    longitude: -73.00054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06065',
  },
  {
    city: 'Vernon Rockville',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 666.9,
    imprecise: false,
    latitude: 41.83641,
    longitude: -72.46063,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06066',
  },
  {
    city: 'Rocky Hill',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 606.3,
    imprecise: false,
    latitude: 41.6574,
    longitude: -72.66259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06067',
  },
  {
    city: 'Salisbury',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 26.6,
    imprecise: false,
    latitude: 42.01404,
    longitude: -73.42121,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06068',
  },
  {
    city: 'Sharon',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 41.85392,
    longitude: -73.4448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06069',
  },
  {
    city: 'Simsbury',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 258.3,
    imprecise: false,
    latitude: 41.87674,
    longitude: -72.81626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06070',
  },
  {
    city: 'Somers',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 143.3,
    imprecise: false,
    latitude: 41.99489,
    longitude: -72.45213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06071',
  },
  {
    city: 'Somersville',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.98465,
    longitude: -72.4876,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06072',
  },
  {
    city: 'South Glastonbury',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 142.9,
    imprecise: false,
    latitude: 41.65753,
    longitude: -72.56742,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06073',
  },
  {
    city: 'South Windsor',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 370.3,
    imprecise: false,
    latitude: 41.83528,
    longitude: -72.57332,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06074',
  },
  {
    city: 'Stafford Springs',
    county_fips: 9110,
    county_fips_all: '09110|09150',
    county: 'Capitol',
    county_names_all: 'Capitol|Northeastern Connecticut',
    county_weights: '{"09110": 67.06, "09150": 32.94}',
    density: 53.3,
    imprecise: false,
    latitude: 41.98906,
    longitude: -72.26224,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06076',
  },
  {
    city: 'Suffield',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 165.4,
    imprecise: false,
    latitude: 41.98903,
    longitude: -72.64875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06078',
  },
  {
    city: 'Taconic',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 42.04174,
    longitude: -73.39755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06079',
  },
  {
    city: 'Tariffville',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 850.1,
    imprecise: false,
    latitude: 41.90708,
    longitude: -72.76839,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06081',
  },
  {
    city: 'Enfield',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 476.2,
    imprecise: false,
    latitude: 41.98393,
    longitude: -72.55475,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06082',
  },
  {
    city: 'Tolland',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 142.8,
    imprecise: false,
    latitude: 41.87917,
    longitude: -72.36443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06084',
  },
  {
    city: 'Unionville',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 653.2,
    imprecise: false,
    latitude: 41.74717,
    longitude: -72.88883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06085',
  },
  {
    city: 'East Windsor',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 146,
    imprecise: false,
    latitude: 41.9058,
    longitude: -72.59646,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06088',
  },
  {
    city: 'Weatogue',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 496.2,
    imprecise: false,
    latitude: 41.83801,
    longitude: -72.82343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06089',
  },
  {
    city: 'West Granby',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 33.1,
    imprecise: false,
    latitude: 41.94685,
    longitude: -72.86403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06090',
  },
  {
    city: 'West Simsbury',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 242.6,
    imprecise: false,
    latitude: 41.87266,
    longitude: -72.86101,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06092',
  },
  {
    city: 'West Suffield',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 77.8,
    imprecise: false,
    latitude: 42.00265,
    longitude: -72.72285,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06093',
  },
  {
    city: 'Windsor',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 396.4,
    imprecise: false,
    latitude: 41.87229,
    longitude: -72.67348,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06095',
  },
  {
    city: 'Windsor Locks',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 538.2,
    imprecise: false,
    latitude: 41.92671,
    longitude: -72.65443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06096',
  },
  {
    city: 'Winsted',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 129,
    imprecise: false,
    latitude: 41.92379,
    longitude: -73.10003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06098',
  },
  {
    city: 'Hartford',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 1962.9,
    imprecise: false,
    latitude: 41.76477,
    longitude: -72.67012,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06103',
  },
  {
    city: 'Hartford',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 3266.4,
    imprecise: false,
    latitude: 41.77322,
    longitude: -72.70442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06105',
  },
  {
    city: 'Hartford',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 3366.1,
    imprecise: false,
    latitude: 41.74818,
    longitude: -72.69683,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06106',
  },
  {
    city: 'West Hartford',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 1154.2,
    imprecise: false,
    latitude: 41.75375,
    longitude: -72.75966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06107',
  },
  {
    city: 'East Hartford',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 1114.1,
    imprecise: false,
    latitude: 41.78078,
    longitude: -72.62165,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06108',
  },
  {
    city: 'Wethersfield',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 855.2,
    imprecise: false,
    latitude: 41.70131,
    longitude: -72.67035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06109',
  },
  {
    city: 'West Hartford',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 1499.6,
    imprecise: false,
    latitude: 41.73247,
    longitude: -72.73378,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06110',
  },
  {
    city: 'Newington',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 915.5,
    imprecise: false,
    latitude: 41.68677,
    longitude: -72.73057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06111',
  },
  {
    city: 'Hartford',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 2904.2,
    imprecise: false,
    latitude: 41.79317,
    longitude: -72.69741,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06112',
  },
  {
    city: 'Hartford',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 2525.7,
    imprecise: false,
    latitude: 41.7394,
    longitude: -72.66949,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06114',
  },
  {
    city: 'West Hartford',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 640.3,
    imprecise: false,
    latitude: 41.7875,
    longitude: -72.76203,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06117',
  },
  {
    city: 'East Hartford',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 1073.3,
    imprecise: false,
    latitude: 41.74871,
    longitude: -72.60976,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06118',
  },
  {
    city: 'West Hartford',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 2742.3,
    imprecise: false,
    latitude: 41.76351,
    longitude: -72.72711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06119',
  },
  {
    city: 'Hartford',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 1522.8,
    imprecise: false,
    latitude: 41.78944,
    longitude: -72.66523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06120',
  },
  {
    city: 'Willimantic',
    county_fips: 9180,
    county_fips_all: '09180|09110',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut|Capitol',
    county_weights: '{"09180": 97.81, "09110": 2.19}',
    density: 1041.9,
    imprecise: false,
    latitude: 41.70816,
    longitude: -72.20731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06226',
  },
  {
    city: 'Amston',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 90,
    imprecise: false,
    latitude: 41.62512,
    longitude: -72.37055,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06231',
  },
  {
    city: 'Andover',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 78.8,
    imprecise: false,
    latitude: 41.73309,
    longitude: -72.37603,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06232',
  },
  {
    city: 'Brooklyn',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 107.3,
    imprecise: false,
    latitude: 41.78938,
    longitude: -71.95266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06234',
  },
  {
    city: 'Chaplin',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 40.4,
    imprecise: false,
    latitude: 41.79292,
    longitude: -72.1275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06235',
  },
  {
    city: 'Columbia',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 95.7,
    imprecise: false,
    latitude: 41.69387,
    longitude: -72.30722,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06237',
  },
  {
    city: 'Coventry',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 126.7,
    imprecise: false,
    latitude: 41.78281,
    longitude: -72.33941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06238',
  },
  {
    city: 'Danielson',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 186.7,
    imprecise: false,
    latitude: 41.79116,
    longitude: -71.85711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06239',
  },
  {
    city: 'Dayville',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 94.5,
    imprecise: false,
    latitude: 41.85635,
    longitude: -71.84904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06241',
  },
  {
    city: 'Eastford',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 20,
    imprecise: false,
    latitude: 41.89326,
    longitude: -72.09706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06242',
  },
  {
    city: 'East Killingly',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 44.1,
    imprecise: false,
    latitude: 41.84743,
    longitude: -71.80701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06243',
  },
  {
    city: 'Hampton',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 27.9,
    imprecise: false,
    latitude: 41.76829,
    longitude: -72.06548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06247',
  },
  {
    city: 'Hebron',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 100.2,
    imprecise: false,
    latitude: 41.68468,
    longitude: -72.40523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06248',
  },
  {
    city: 'Lebanon',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 50.8,
    imprecise: false,
    latitude: 41.63128,
    longitude: -72.24019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06249',
  },
  {
    city: 'Mansfield Center',
    county_fips: 9110,
    county_fips_all: '09110|09150',
    county: 'Capitol',
    county_names_all: 'Capitol|Northeastern Connecticut',
    county_weights: '{"09110": 99.37, "09150": 0.63}',
    density: 125.6,
    imprecise: false,
    latitude: 41.77434,
    longitude: -72.19669,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06250',
  },
  {
    city: 'North Franklin',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 39.3,
    imprecise: false,
    latitude: 41.61585,
    longitude: -72.14313,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06254',
  },
  {
    city: 'North Grosvenordale',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 75.2,
    imprecise: false,
    latitude: 41.98791,
    longitude: -71.90299,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06255',
  },
  {
    city: 'North Windham',
    county_fips: 9180,
    county_fips_all: '09180|09150|09110',
    county: 'Southeastern Connecticut',
    county_names_all:
      'Southeastern Connecticut|Northeastern Connecticut|Capitol',
    county_weights: '{"09180": 99.47, "09150": 0.41, "09110": 0.12}',
    density: 87.1,
    imprecise: false,
    latitude: 41.73699,
    longitude: -72.15723,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06256',
  },
  {
    city: 'Pomfret',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 1002.6,
    imprecise: false,
    latitude: 41.88554,
    longitude: -71.96353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06258',
  },
  {
    city: 'Pomfret Center',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 41.3,
    imprecise: false,
    latitude: 41.8703,
    longitude: -71.99248,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06259',
  },
  {
    city: 'Putnam',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 178.3,
    imprecise: false,
    latitude: 41.90898,
    longitude: -71.87181,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06260',
  },
  {
    city: 'Quinebaug',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 271.7,
    imprecise: false,
    latitude: 42.01871,
    longitude: -71.94959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06262',
  },
  {
    city: 'Rogers',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 1251.9,
    imprecise: false,
    latitude: 41.83738,
    longitude: -71.90444,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06263',
  },
  {
    city: 'Scotland',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 35.4,
    imprecise: false,
    latitude: 41.69869,
    longitude: -72.10487,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06264',
  },
  {
    city: 'South Windham',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 92.7,
    imprecise: false,
    latitude: 41.67136,
    longitude: -72.17048,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06266',
  },
  {
    city: 'Storrs Mansfield',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 170.7,
    imprecise: false,
    latitude: 41.79852,
    longitude: -72.24843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06268',
  },
  {
    city: 'Thompson',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 67.4,
    imprecise: false,
    latitude: 41.96895,
    longitude: -71.83927,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06277',
  },
  {
    city: 'Ashford',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 42.3,
    imprecise: false,
    latitude: 41.89126,
    longitude: -72.17003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06278',
  },
  {
    city: 'Willington',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 64.7,
    imprecise: false,
    latitude: 41.88959,
    longitude: -72.25933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06279',
  },
  {
    city: 'Windham',
    county_fips: 9180,
    county_fips_all: '09180|09150',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut|Northeastern Connecticut',
    county_weights: '{"09180": 76.04, "09150": 23.96}',
    density: 79.7,
    imprecise: false,
    latitude: 41.69237,
    longitude: -72.13829,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06280',
  },
  {
    city: 'Woodstock',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 51.8,
    imprecise: false,
    latitude: 41.97253,
    longitude: -72.01458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06281',
  },
  {
    city: 'Woodstock Valley',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 63.7,
    imprecise: false,
    latitude: 41.94556,
    longitude: -72.07928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06282',
  },
  {
    city: 'New London',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 1895.5,
    imprecise: false,
    latitude: 41.35026,
    longitude: -72.10225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06320',
  },
  {
    city: 'Baltic',
    county_fips: 9180,
    county_fips_all: '09180|09150',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut|Northeastern Connecticut',
    county_weights: '{"09180": 75.63, "09150": 24.37}',
    density: 74.8,
    imprecise: false,
    latitude: 41.64199,
    longitude: -72.07541,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06330',
  },
  {
    city: 'Canterbury',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 48.7,
    imprecise: false,
    latitude: 41.69717,
    longitude: -72.00109,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06331',
  },
  {
    city: 'Central Village',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 315.5,
    imprecise: false,
    latitude: 41.72845,
    longitude: -71.91008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06332',
  },
  {
    city: 'East Lyme',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 121.8,
    imprecise: false,
    latitude: 41.38602,
    longitude: -72.24527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06333',
  },
  {
    city: 'Bozrah',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 44.9,
    imprecise: false,
    latitude: 41.54431,
    longitude: -72.17424,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06334',
  },
  {
    city: 'Gales Ferry',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 222.2,
    imprecise: false,
    latitude: 41.42943,
    longitude: -72.06247,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06335',
  },
  {
    city: 'Gilman',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 41.57934,
    longitude: -72.19505,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06336',
  },
  {
    city: 'Mashantucket',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 41.46473,
    longitude: -71.97281,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06338',
  },
  {
    city: 'Ledyard',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 137.4,
    imprecise: false,
    latitude: 41.44408,
    longitude: -71.99851,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06339',
  },
  {
    city: 'Groton',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 511.5,
    imprecise: false,
    latitude: 41.35643,
    longitude: -72.04477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06340',
  },
  {
    city: 'Hanover',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 121.4,
    imprecise: false,
    latitude: 41.64829,
    longitude: -72.0693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06350',
  },
  {
    city: 'Jewett City',
    county_fips: 9180,
    county_fips_all: '09180|09150',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut|Northeastern Connecticut',
    county_weights: '{"09180": 97.27, "09150": 2.73}',
    density: 115.9,
    imprecise: false,
    latitude: 41.58873,
    longitude: -71.94854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06351',
  },
  {
    city: 'Montville',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 639.8,
    imprecise: false,
    latitude: 41.45612,
    longitude: -72.13928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06353',
  },
  {
    city: 'Moosup',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 105.9,
    imprecise: false,
    latitude: 41.69836,
    longitude: -71.85016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06354',
  },
  {
    city: 'Mystic',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 331.1,
    imprecise: false,
    latitude: 41.36857,
    longitude: -71.97426,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06355',
  },
  {
    city: 'Niantic',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 413.2,
    imprecise: false,
    latitude: 41.32711,
    longitude: -72.21478,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06357',
  },
  {
    city: 'North Stonington',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 36.7,
    imprecise: false,
    latitude: 41.46966,
    longitude: -71.87546,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06359',
  },
  {
    city: 'Norwich',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 535.8,
    imprecise: false,
    latitude: 41.54883,
    longitude: -72.08914,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06360',
  },
  {
    city: 'Preston',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 61.1,
    imprecise: false,
    latitude: 41.52281,
    longitude: -72.00072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06365',
  },
  {
    city: 'Oakdale',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 117.9,
    imprecise: false,
    latitude: 41.46541,
    longitude: -72.18659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06370',
  },
  {
    city: 'Old Lyme',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 70.3,
    imprecise: false,
    latitude: 41.36361,
    longitude: -72.32582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06371',
  },
  {
    city: 'Oneco',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 45.6,
    imprecise: false,
    latitude: 41.68394,
    longitude: -71.79881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06373',
  },
  {
    city: 'Plainfield',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 118.3,
    imprecise: false,
    latitude: 41.6798,
    longitude: -71.91441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06374',
  },
  {
    city: 'Quaker Hill',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 179.4,
    imprecise: false,
    latitude: 41.40544,
    longitude: -72.12554,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06375',
  },
  {
    city: 'South Lyme',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 1272.8,
    imprecise: false,
    latitude: 41.29461,
    longitude: -72.2528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06376',
  },
  {
    city: 'Sterling',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 69.8,
    imprecise: false,
    latitude: 41.72708,
    longitude: -71.81679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06377',
  },
  {
    city: 'Stonington',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 102.6,
    imprecise: false,
    latitude: 41.38039,
    longitude: -71.91376,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06378',
  },
  {
    city: 'Pawcatuck',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 284.8,
    imprecise: false,
    latitude: 41.36685,
    longitude: -71.85826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06379',
  },
  {
    city: 'Taftville',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 1104.8,
    imprecise: false,
    latitude: 41.56533,
    longitude: -72.05308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06380',
  },
  {
    city: 'Uncasville',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 222,
    imprecise: false,
    latitude: 41.46137,
    longitude: -72.11762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06382',
  },
  {
    city: 'Voluntown',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 27.4,
    imprecise: false,
    latitude: 41.58188,
    longitude: -71.83139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06384',
  },
  {
    city: 'Waterford',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 248.2,
    imprecise: false,
    latitude: 41.35735,
    longitude: -72.15581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06385',
  },
  {
    city: 'Wauregan',
    county_fips: 9150,
    county_fips_all: '09150',
    county: 'Northeastern Connecticut',
    county_names_all: 'Northeastern Connecticut',
    county_weights: '{"09150": 100}',
    density: 1186,
    imprecise: false,
    latitude: 41.74418,
    longitude: -71.90981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06387',
  },
  {
    city: 'Yantic',
    county_fips: 9180,
    county_fips_all: '09180',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut',
    county_weights: '{"09180": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.56036,
    longitude: -72.12338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06389',
  },
  {
    city: 'Fishers Island',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 41.27027,
    longitude: -71.98886,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '06390',
  },
  {
    city: 'Ansonia',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 1237.6,
    imprecise: false,
    latitude: 41.34424,
    longitude: -73.06896,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06401',
  },
  {
    city: 'Beacon Falls',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 245.4,
    imprecise: false,
    latitude: 41.43902,
    longitude: -73.05679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06403',
  },
  {
    city: 'Branford',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 503.9,
    imprecise: false,
    latitude: 41.28405,
    longitude: -72.79809,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06405',
  },
  {
    city: 'Centerbrook',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 232.1,
    imprecise: false,
    latitude: 41.35169,
    longitude: -72.42056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06409',
  },
  {
    city: 'Cheshire',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 346.1,
    imprecise: false,
    latitude: 41.51183,
    longitude: -72.90441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06410',
  },
  {
    city: 'Chester',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 92,
    imprecise: false,
    latitude: 41.40594,
    longitude: -72.48319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06412',
  },
  {
    city: 'Clinton',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 318.9,
    imprecise: false,
    latitude: 41.29801,
    longitude: -72.53003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06413',
  },
  {
    city: 'Cobalt',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 109.9,
    imprecise: false,
    latitude: 41.57702,
    longitude: -72.55231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06414',
  },
  {
    city: 'Colchester',
    county_fips: 9180,
    county_fips_all: '09180|09130',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut|Lower Connecticut River Valley',
    county_weights: '{"09180": 87.23, "09130": 12.77}',
    density: 110.6,
    imprecise: false,
    latitude: 41.55563,
    longitude: -72.34694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06415',
  },
  {
    city: 'Cromwell',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 444.4,
    imprecise: false,
    latitude: 41.61218,
    longitude: -72.66382,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06416',
  },
  {
    city: 'Deep River',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 127.4,
    imprecise: false,
    latitude: 41.36894,
    longitude: -72.46227,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06417',
  },
  {
    city: 'Derby',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 933.4,
    imprecise: false,
    latitude: 41.32647,
    longitude: -73.08324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06418',
  },
  {
    city: 'Killingworth',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 68.2,
    imprecise: false,
    latitude: 41.37923,
    longitude: -72.57847,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06419',
  },
  {
    city: 'Salem',
    county_fips: 9180,
    county_fips_all: '09180|09130',
    county: 'Southeastern Connecticut',
    county_names_all: 'Southeastern Connecticut|Lower Connecticut River Valley',
    county_weights: '{"09180": 97.94, "09130": 2.06}',
    density: 57.1,
    imprecise: false,
    latitude: 41.48492,
    longitude: -72.26733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06420',
  },
  {
    city: 'Durham',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 117.6,
    imprecise: false,
    latitude: 41.46221,
    longitude: -72.68285,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06422',
  },
  {
    city: 'East Haddam',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 54.7,
    imprecise: false,
    latitude: 41.46654,
    longitude: -72.39054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06423',
  },
  {
    city: 'East Hampton',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 125.6,
    imprecise: false,
    latitude: 41.5588,
    longitude: -72.50452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06424',
  },
  {
    city: 'Essex',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 224.1,
    imprecise: false,
    latitude: 41.35346,
    longitude: -72.39791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06426',
  },
  {
    city: 'Guilford',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 180.8,
    imprecise: false,
    latitude: 41.33444,
    longitude: -72.70051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06437',
  },
  {
    city: 'Haddam',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 79.9,
    imprecise: false,
    latitude: 41.45516,
    longitude: -72.50701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06438',
  },
  {
    city: 'Hadlyme',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 32,
    imprecise: false,
    latitude: 41.41573,
    longitude: -72.39964,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06439',
  },
  {
    city: 'Higganum',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 85.3,
    imprecise: false,
    latitude: 41.46674,
    longitude: -72.58038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06441',
  },
  {
    city: 'Ivoryton',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 302.5,
    imprecise: false,
    latitude: 41.34261,
    longitude: -72.44429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06442',
  },
  {
    city: 'Madison',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 188.5,
    imprecise: false,
    latitude: 41.33976,
    longitude: -72.62783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06443',
  },
  {
    city: 'Marion',
    county_fips: 9110,
    county_fips_all: '09110|09140',
    county: 'Capitol',
    county_names_all: 'Capitol|Naugatuck Valley',
    county_weights: '{"09110": 99.74, "09140": 0.26}',
    density: 68.3,
    imprecise: false,
    latitude: 41.5634,
    longitude: -72.93038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06444',
  },
  {
    city: 'Marlborough',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 101.4,
    imprecise: false,
    latitude: 41.63309,
    longitude: -72.45472,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06447',
  },
  {
    city: 'Meriden',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 989.9,
    imprecise: false,
    latitude: 41.53332,
    longitude: -72.77399,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06450',
  },
  {
    city: 'Meriden',
    county_fips: 9170,
    county_fips_all: '09170|09110',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut|Capitol',
    county_weights: '{"09170": 99.81, "09110": 0.19}',
    density: 976.3,
    imprecise: false,
    latitude: 41.54203,
    longitude: -72.82364,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06451',
  },
  {
    city: 'Middlefield',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 89.2,
    imprecise: false,
    latitude: 41.51468,
    longitude: -72.71732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06455',
  },
  {
    city: 'Middle Haddam',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 81.7,
    imprecise: false,
    latitude: 41.541,
    longitude: -72.5483,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06456',
  },
  {
    city: 'Middletown',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 443.4,
    imprecise: false,
    latitude: 41.54759,
    longitude: -72.65484,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06457',
  },
  {
    city: 'Milford',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 1169.4,
    imprecise: false,
    latitude: 41.21505,
    longitude: -73.05129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06460',
  },
  {
    city: 'Milford',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 596.9,
    imprecise: false,
    latitude: 41.23937,
    longitude: -73.0752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06461',
  },
  {
    city: 'Milldale',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 666.9,
    imprecise: false,
    latitude: 41.56548,
    longitude: -72.90022,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06467',
  },
  {
    city: 'Monroe',
    county_fips: 9120,
    county_fips_all: '09120',
    county: 'Greater Bridgeport',
    county_names_all: 'Greater Bridgeport',
    county_weights: '{"09120": 100}',
    density: 280.6,
    imprecise: false,
    latitude: 41.33791,
    longitude: -73.22499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06468',
  },
  {
    city: 'Moodus',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 127.3,
    imprecise: false,
    latitude: 41.50757,
    longitude: -72.44924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06469',
  },
  {
    city: 'Newtown',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 161.8,
    imprecise: false,
    latitude: 41.3943,
    longitude: -73.31918,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06470',
  },
  {
    city: 'North Branford',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 311,
    imprecise: false,
    latitude: 41.33454,
    longitude: -72.77372,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06471',
  },
  {
    city: 'Northford',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 153,
    imprecise: false,
    latitude: 41.38416,
    longitude: -72.77911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06472',
  },
  {
    city: 'North Haven',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 441.3,
    imprecise: false,
    latitude: 41.38069,
    longitude: -72.85598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06473',
  },
  {
    city: 'Old Saybrook',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 271.1,
    imprecise: false,
    latitude: 41.30174,
    longitude: -72.38569,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06475',
  },
  {
    city: 'Orange',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 321.7,
    imprecise: false,
    latitude: 41.2827,
    longitude: -73.0272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06477',
  },
  {
    city: 'Oxford',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 153.3,
    imprecise: false,
    latitude: 41.43133,
    longitude: -73.13499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06478',
  },
  {
    city: 'Plantsville',
    county_fips: 9110,
    county_fips_all: '09110|09140',
    county: 'Capitol',
    county_names_all: 'Capitol|Naugatuck Valley',
    county_weights: '{"09110": 99.9, "09140": 0.1}',
    density: 585.3,
    imprecise: false,
    latitude: 41.57799,
    longitude: -72.90398,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06479',
  },
  {
    city: 'Portland',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 157.1,
    imprecise: false,
    latitude: 41.59885,
    longitude: -72.5893,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06480',
  },
  {
    city: 'Rockfall',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 356.3,
    imprecise: false,
    latitude: 41.53435,
    longitude: -72.70067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06481',
  },
  {
    city: 'Sandy Hook',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 228.9,
    imprecise: false,
    latitude: 41.4067,
    longitude: -73.24474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06482',
  },
  {
    city: 'Seymour',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 449.2,
    imprecise: false,
    latitude: 41.381,
    longitude: -73.08726,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06483',
  },
  {
    city: 'Shelton',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 528,
    imprecise: false,
    latitude: 41.30601,
    longitude: -73.13828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06484',
  },
  {
    city: 'Southbury',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 198.6,
    imprecise: false,
    latitude: 41.47451,
    longitude: -73.23288,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06488',
  },
  {
    city: 'Southington',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 455.6,
    imprecise: false,
    latitude: 41.61312,
    longitude: -72.87233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06489',
  },
  {
    city: 'Wallingford',
    county_fips: 9170,
    county_fips_all: '09170|09140',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut|Naugatuck Valley',
    county_weights: '{"09170": 98.47, "09140": 1.53}',
    density: 431.9,
    imprecise: false,
    latitude: 41.45927,
    longitude: -72.80473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06492',
  },
  {
    city: 'Westbrook',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 167.8,
    imprecise: false,
    latitude: 41.30688,
    longitude: -72.46652,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06498',
  },
  {
    city: 'New Haven',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 6573.9,
    imprecise: false,
    latitude: 41.3062,
    longitude: -72.92652,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06510',
  },
  {
    city: 'New Haven',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 3635.4,
    imprecise: false,
    latitude: 41.31663,
    longitude: -72.92587,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06511',
  },
  {
    city: 'East Haven',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 1054.7,
    imprecise: false,
    latitude: 41.28111,
    longitude: -72.8719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06512',
  },
  {
    city: 'New Haven',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 2079.1,
    imprecise: false,
    latitude: 41.31953,
    longitude: -72.86856,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06513',
  },
  {
    city: 'Hamden',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 931.2,
    imprecise: false,
    latitude: 41.3729,
    longitude: -72.94159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06514',
  },
  {
    city: 'New Haven',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 1609.9,
    imprecise: false,
    latitude: 41.32794,
    longitude: -72.96954,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06515',
  },
  {
    city: 'West Haven',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 1988,
    imprecise: false,
    latitude: 41.27393,
    longitude: -72.96718,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06516',
  },
  {
    city: 'Hamden',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 1097.5,
    imprecise: false,
    latitude: 41.34834,
    longitude: -72.90494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06517',
  },
  {
    city: 'Hamden',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 471,
    imprecise: false,
    latitude: 41.42744,
    longitude: -72.91339,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06518',
  },
  {
    city: 'New Haven',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 3405.4,
    imprecise: false,
    latitude: 41.29597,
    longitude: -72.93764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06519',
  },
  {
    city: 'Bethany',
    county_fips: 9170,
    county_fips_all: '09170|09140',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut|Naugatuck Valley',
    county_weights: '{"09170": 99.81, "09140": 0.19}',
    density: 96.7,
    imprecise: false,
    latitude: 41.42606,
    longitude: -72.99308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06524',
  },
  {
    city: 'Woodbridge',
    county_fips: 9170,
    county_fips_all: '09170',
    county: 'South Central Connecticut',
    county_names_all: 'South Central Connecticut',
    county_weights: '{"09170": 100}',
    density: 186.2,
    imprecise: false,
    latitude: 41.35662,
    longitude: -73.01017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06525',
  },
  {
    city: 'Bridgeport',
    county_fips: 9120,
    county_fips_all: '09120',
    county: 'Greater Bridgeport',
    county_names_all: 'Greater Bridgeport',
    county_weights: '{"09120": 100}',
    density: 3888,
    imprecise: false,
    latitude: 41.17684,
    longitude: -73.20027,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06604',
  },
  {
    city: 'Bridgeport',
    county_fips: 9120,
    county_fips_all: '09120',
    county: 'Greater Bridgeport',
    county_names_all: 'Greater Bridgeport',
    county_weights: '{"09120": 100}',
    density: 4379.3,
    imprecise: false,
    latitude: 41.16348,
    longitude: -73.21763,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06605',
  },
  {
    city: 'Bridgeport',
    county_fips: 9120,
    county_fips_all: '09120',
    county: 'Greater Bridgeport',
    county_names_all: 'Greater Bridgeport',
    county_weights: '{"09120": 100}',
    density: 3604.1,
    imprecise: false,
    latitude: 41.21218,
    longitude: -73.20829,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06606',
  },
  {
    city: 'Bridgeport',
    county_fips: 9120,
    county_fips_all: '09120',
    county: 'Greater Bridgeport',
    county_names_all: 'Greater Bridgeport',
    county_weights: '{"09120": 100}',
    density: 2663.9,
    imprecise: false,
    latitude: 41.1736,
    longitude: -73.16696,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06607',
  },
  {
    city: 'Bridgeport',
    county_fips: 9120,
    county_fips_all: '09120',
    county: 'Greater Bridgeport',
    county_names_all: 'Greater Bridgeport',
    county_weights: '{"09120": 100}',
    density: 4562.2,
    imprecise: false,
    latitude: 41.18675,
    longitude: -73.1809,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06608',
  },
  {
    city: 'Bridgeport',
    county_fips: 9120,
    county_fips_all: '09120',
    county: 'Greater Bridgeport',
    county_names_all: 'Greater Bridgeport',
    county_weights: '{"09120": 100}',
    density: 2761.6,
    imprecise: false,
    latitude: 41.20457,
    longitude: -73.16933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06610',
  },
  {
    city: 'Trumbull',
    county_fips: 9120,
    county_fips_all: '09120',
    county: 'Greater Bridgeport',
    county_names_all: 'Greater Bridgeport',
    county_weights: '{"09120": 100}',
    density: 616.9,
    imprecise: false,
    latitude: 41.26009,
    longitude: -73.20823,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06611',
  },
  {
    city: 'Easton',
    county_fips: 9120,
    county_fips_all: '09120',
    county: 'Greater Bridgeport',
    county_names_all: 'Greater Bridgeport',
    county_weights: '{"09120": 100}',
    density: 108,
    imprecise: false,
    latitude: 41.26493,
    longitude: -73.30006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06612',
  },
  {
    city: 'Stratford',
    county_fips: 9120,
    county_fips_all: '09120',
    county: 'Greater Bridgeport',
    county_names_all: 'Greater Bridgeport',
    county_weights: '{"09120": 100}',
    density: 1242.9,
    imprecise: false,
    latitude: 41.22989,
    longitude: -73.12785,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06614',
  },
  {
    city: 'Stratford',
    county_fips: 9120,
    county_fips_all: '09120',
    county: 'Greater Bridgeport',
    county_names_all: 'Greater Bridgeport',
    county_weights: '{"09120": 100}',
    density: 1035.9,
    imprecise: false,
    latitude: 41.17082,
    longitude: -73.13477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06615',
  },
  {
    city: 'Waterbury',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 1701.1,
    imprecise: false,
    latitude: 41.55713,
    longitude: -73.04539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06702',
  },
  {
    city: 'Waterbury',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 1516.2,
    imprecise: false,
    latitude: 41.58601,
    longitude: -73.03296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06704',
  },
  {
    city: 'Waterbury',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 1727.4,
    imprecise: false,
    latitude: 41.549,
    longitude: -72.992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06705',
  },
  {
    city: 'Waterbury',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 1565.1,
    imprecise: false,
    latitude: 41.53285,
    longitude: -73.02389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06706',
  },
  {
    city: 'Waterbury',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 1209.4,
    imprecise: false,
    latitude: 41.54939,
    longitude: -73.06738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06708',
  },
  {
    city: 'Waterbury',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 3961.6,
    imprecise: false,
    latitude: 41.56958,
    longitude: -73.04598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06710',
  },
  {
    city: 'Prospect',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 256.8,
    imprecise: false,
    latitude: 41.49927,
    longitude: -72.97609,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06712',
  },
  {
    city: 'Wolcott',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 307.5,
    imprecise: false,
    latitude: 41.60102,
    longitude: -72.97325,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06716',
  },
  {
    city: 'Bantam',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 69.1,
    imprecise: false,
    latitude: 41.72327,
    longitude: -73.2624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06750',
  },
  {
    city: 'Bethlehem',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 69.6,
    imprecise: false,
    latitude: 41.63792,
    longitude: -73.2122,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06751',
  },
  {
    city: 'Bridgewater',
    county_fips: 9190,
    county_fips_all: '09190|09160',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut|Northwest Hills',
    county_weights: '{"09190": 98.33, "09160": 1.67}',
    density: 38.3,
    imprecise: false,
    latitude: 41.52082,
    longitude: -73.35965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06752',
  },
  {
    city: 'Cornwall',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 41.82514,
    longitude: -73.34471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06753',
  },
  {
    city: 'Cornwall Bridge',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 41.76841,
    longitude: -73.36127,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06754',
  },
  {
    city: 'Gaylordsville',
    county_fips: 9190,
    county_fips_all: '09190|09160',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut|Northwest Hills',
    county_weights: '{"09190": 99.87, "09160": 0.13}',
    density: 95.3,
    imprecise: false,
    latitude: 41.64915,
    longitude: -73.48143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06755',
  },
  {
    city: 'Goshen',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 32,
    imprecise: false,
    latitude: 41.84714,
    longitude: -73.23715,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06756',
  },
  {
    city: 'Kent',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 27.1,
    imprecise: false,
    latitude: 41.73951,
    longitude: -73.46637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06757',
  },
  {
    city: 'Lakeside',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 8,
    imprecise: false,
    latitude: 41.67672,
    longitude: -73.2286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06758',
  },
  {
    city: 'Litchfield',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 39.1,
    imprecise: false,
    latitude: 41.75757,
    longitude: -73.21544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06759',
  },
  {
    city: 'Middlebury',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 169.7,
    imprecise: false,
    latitude: 41.5271,
    longitude: -73.1228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06762',
  },
  {
    city: 'Morris',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 49.6,
    imprecise: false,
    latitude: 41.69027,
    longitude: -73.20714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06763',
  },
  {
    city: 'Naugatuck',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 750.2,
    imprecise: false,
    latitude: 41.48913,
    longitude: -73.05181,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06770',
  },
  {
    city: 'New Milford',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 185.5,
    imprecise: false,
    latitude: 41.60011,
    longitude: -73.4162,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06776',
  },
  {
    city: 'New Preston Marble Dale',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 40.2,
    imprecise: false,
    latitude: 41.69412,
    longitude: -73.33931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06777',
  },
  {
    city: 'Northfield',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 109.6,
    imprecise: false,
    latitude: 41.71469,
    longitude: -73.10459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06778',
  },
  {
    city: 'Oakville',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 927.6,
    imprecise: false,
    latitude: 41.59562,
    longitude: -73.08058,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06779',
  },
  {
    city: 'Plymouth',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 102.3,
    imprecise: false,
    latitude: 41.65448,
    longitude: -73.04731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06782',
  },
  {
    city: 'Roxbury',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 32.5,
    imprecise: false,
    latitude: 41.55424,
    longitude: -73.29998,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06783',
  },
  {
    city: 'Sherman',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 62.9,
    imprecise: false,
    latitude: 41.58018,
    longitude: -73.49853,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06784',
  },
  {
    city: 'South Kent',
    county_fips: 9160,
    county_fips_all: '09160|09190',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills|Western Connecticut',
    county_weights: '{"09160": 99.82, "09190": 0.18}',
    density: 20.2,
    imprecise: false,
    latitude: 41.70491,
    longitude: -73.43815,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06785',
  },
  {
    city: 'Terryville',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 263.1,
    imprecise: false,
    latitude: 41.66912,
    longitude: -73.01502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06786',
  },
  {
    city: 'Thomaston',
    county_fips: 9140,
    county_fips_all: '09140|09160',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley|Northwest Hills',
    county_weights: '{"09140": 98.11, "09160": 1.89}',
    density: 235.8,
    imprecise: false,
    latitude: 41.67033,
    longitude: -73.08568,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06787',
  },
  {
    city: 'Torrington',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 330.9,
    imprecise: false,
    latitude: 41.83747,
    longitude: -73.12874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06790',
  },
  {
    city: 'Harwinton',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 70.1,
    imprecise: false,
    latitude: 41.75509,
    longitude: -73.05838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06791',
  },
  {
    city: 'Washington',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 41.63089,
    longitude: -73.28835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06793',
  },
  {
    city: 'Washington Depot',
    county_fips: 9160,
    county_fips_all: '09160|09190',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills|Western Connecticut',
    county_weights: '{"09160": 97.85, "09190": 2.15}',
    density: 38.1,
    imprecise: false,
    latitude: 41.64932,
    longitude: -73.32511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06794',
  },
  {
    city: 'Watertown',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 206.9,
    imprecise: false,
    latitude: 41.61873,
    longitude: -73.12336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06795',
  },
  {
    city: 'West Cornwall',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 41.87595,
    longitude: -73.33255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06796',
  },
  {
    city: 'Woodbury',
    county_fips: 9140,
    county_fips_all: '09140',
    county: 'Naugatuck Valley',
    county_names_all: 'Naugatuck Valley',
    county_weights: '{"09140": 100}',
    density: 104.4,
    imprecise: false,
    latitude: 41.56149,
    longitude: -73.20703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06798',
  },
  {
    city: 'Bethel',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 474.7,
    imprecise: false,
    latitude: 41.37468,
    longitude: -73.39275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06801',
  },
  {
    city: 'Brookfield',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 346.4,
    imprecise: false,
    latitude: 41.46731,
    longitude: -73.39232,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06804',
  },
  {
    city: 'Cos Cob',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 902,
    imprecise: false,
    latitude: 41.0611,
    longitude: -73.59215,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06807',
  },
  {
    city: 'Danbury',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 1030.8,
    imprecise: false,
    latitude: 41.37627,
    longitude: -73.45904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06810',
  },
  {
    city: 'Danbury',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 574.1,
    imprecise: false,
    latitude: 41.42427,
    longitude: -73.4821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06811',
  },
  {
    city: 'New Fairfield',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 256.8,
    imprecise: false,
    latitude: 41.48796,
    longitude: -73.48827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06812',
  },
  {
    city: 'Darien',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 669.3,
    imprecise: false,
    latitude: 41.07983,
    longitude: -73.48242,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06820',
  },
  {
    city: 'Fairfield',
    county_fips: 9120,
    county_fips_all: '09120',
    county: 'Greater Bridgeport',
    county_names_all: 'Greater Bridgeport',
    county_weights: '{"09120": 100}',
    density: 705.8,
    imprecise: false,
    latitude: 41.17571,
    longitude: -73.28111,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06824',
  },
  {
    city: 'Fairfield',
    county_fips: 9120,
    county_fips_all: '09120',
    county: 'Greater Bridgeport',
    county_names_all: 'Greater Bridgeport',
    county_weights: '{"09120": 100}',
    density: 1248.9,
    imprecise: false,
    latitude: 41.19685,
    longitude: -73.24221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06825',
  },
  {
    city: 'Greenwich',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 709.6,
    imprecise: false,
    latitude: 41.048,
    longitude: -73.624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06830',
  },
  {
    city: 'Greenwich',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 213.1,
    imprecise: false,
    latitude: 41.08782,
    longitude: -73.66078,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06831',
  },
  {
    city: 'New Canaan',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 363.2,
    imprecise: false,
    latitude: 41.15925,
    longitude: -73.49916,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06840',
  },
  {
    city: 'Norwalk',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 1121.2,
    imprecise: false,
    latitude: 41.1263,
    longitude: -73.44316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06850',
  },
  {
    city: 'Norwalk',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 1399.7,
    imprecise: false,
    latitude: 41.13948,
    longitude: -73.40387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06851',
  },
  {
    city: 'Norwalk',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 1015,
    imprecise: false,
    latitude: 41.06962,
    longitude: -73.43775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06853',
  },
  {
    city: 'Norwalk',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 2578.7,
    imprecise: false,
    latitude: 41.09148,
    longitude: -73.42972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06854',
  },
  {
    city: 'Norwalk',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 1461.8,
    imprecise: false,
    latitude: 41.08922,
    longitude: -73.39615,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06855',
  },
  {
    city: 'Old Greenwich',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 1339.1,
    imprecise: false,
    latitude: 41.02881,
    longitude: -73.56964,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06870',
  },
  {
    city: 'Ridgefield',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 280.3,
    imprecise: false,
    latitude: 41.30642,
    longitude: -73.50216,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06877',
  },
  {
    city: 'Riverside',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 1329.9,
    imprecise: false,
    latitude: 41.03191,
    longitude: -73.58283,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06878',
  },
  {
    city: 'Westport',
    county_fips: 9190,
    county_fips_all: '09190|09120',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut|Greater Bridgeport',
    county_weights: '{"09190": 99.5, "09120": 0.5}',
    density: 532.1,
    imprecise: false,
    latitude: 41.14379,
    longitude: -73.34698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06880',
  },
  {
    city: 'Weston',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 203,
    imprecise: false,
    latitude: 41.22842,
    longitude: -73.37256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06883',
  },
  {
    city: 'Southport',
    county_fips: 9120,
    county_fips_all: '09120',
    county: 'Greater Bridgeport',
    county_names_all: 'Greater Bridgeport',
    county_weights: '{"09120": 100}',
    density: 620.5,
    imprecise: false,
    latitude: 41.14639,
    longitude: -73.28944,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06890',
  },
  {
    city: 'Redding',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 108,
    imprecise: false,
    latitude: 41.3051,
    longitude: -73.39139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06896',
  },
  {
    city: 'Wilton',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 270.6,
    imprecise: false,
    latitude: 41.20705,
    longitude: -73.44009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06897',
  },
  {
    city: 'Stamford',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 8377.4,
    imprecise: false,
    latitude: 41.05349,
    longitude: -73.53845,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06901',
  },
  {
    city: 'Stamford',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 2828,
    imprecise: false,
    latitude: 41.05949,
    longitude: -73.54751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 73392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06902',
  },
  {
    city: 'Stamford',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 311,
    imprecise: false,
    latitude: 41.13571,
    longitude: -73.57207,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06903',
  },
  {
    city: 'Stamford',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 1577.9,
    imprecise: false,
    latitude: 41.08792,
    longitude: -73.54351,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06905',
  },
  {
    city: 'Stamford',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 2632.3,
    imprecise: false,
    latitude: 41.07244,
    longitude: -73.52217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06906',
  },
  {
    city: 'Stamford',
    county_fips: 9190,
    county_fips_all: '09190',
    county: 'Western Connecticut',
    county_names_all: 'Western Connecticut',
    county_weights: '{"09190": 100}',
    density: 1717.1,
    imprecise: false,
    latitude: 41.1021,
    longitude: -73.52033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06907',
  },
  {
    city: 'Avenel',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1770.8,
    imprecise: false,
    latitude: 40.58342,
    longitude: -74.26992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07001',
  },
  {
    city: 'Bayonne',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 4744.4,
    imprecise: false,
    latitude: 40.66681,
    longitude: -74.11582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07002',
  },
  {
    city: 'Bloomfield',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 3903.2,
    imprecise: false,
    latitude: 40.80976,
    longitude: -74.18683,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07003',
  },
  {
    city: 'Fairfield',
    county_fips: 34013,
    county_fips_all: '34013|34027',
    county: 'Essex',
    county_names_all: 'Essex|Morris',
    county_weights: '{"34013": 99.45, "34027": 0.55}',
    density: 298.3,
    imprecise: false,
    latitude: 40.88282,
    longitude: -74.30413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07004',
  },
  {
    city: 'Boonton',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 322.9,
    imprecise: false,
    latitude: 40.92738,
    longitude: -74.41706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07005',
  },
  {
    city: 'Caldwell',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 1101.5,
    imprecise: false,
    latitude: 40.85221,
    longitude: -74.2817,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07006',
  },
  {
    city: 'Carteret',
    county_fips: 34023,
    county_fips_all: '34023|34039',
    county: 'Middlesex',
    county_names_all: 'Middlesex|Union',
    county_weights: '{"34023": 99.86, "34039": 0.14}',
    density: 2241.4,
    imprecise: false,
    latitude: 40.58489,
    longitude: -74.2284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07008',
  },
  {
    city: 'Cedar Grove',
    county_fips: 34013,
    county_fips_all: '34013|34031',
    county: 'Essex',
    county_names_all: 'Essex|Passaic',
    county_weights: '{"34013": 99.71, "34031": 0.29}',
    density: 1229.8,
    imprecise: false,
    latitude: 40.85651,
    longitude: -74.22871,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07009',
  },
  {
    city: 'Cliffside Park',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 10407.5,
    imprecise: false,
    latitude: 40.82217,
    longitude: -73.98792,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07010',
  },
  {
    city: 'Clifton',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 4786.6,
    imprecise: false,
    latitude: 40.8801,
    longitude: -74.14449,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07011',
  },
  {
    city: 'Clifton',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 2580,
    imprecise: false,
    latitude: 40.84694,
    longitude: -74.1596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07012',
  },
  {
    city: 'Clifton',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 2686.4,
    imprecise: false,
    latitude: 40.86935,
    longitude: -74.17267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07013',
  },
  {
    city: 'Clifton',
    county_fips: 34031,
    county_fips_all: '34031|34003',
    county: 'Passaic',
    county_names_all: 'Passaic|Bergen',
    county_weights: '{"34031": 99.77, "34003": 0.23}',
    density: 1338.4,
    imprecise: false,
    latitude: 40.83162,
    longitude: -74.13532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07014',
  },
  {
    city: 'Cranford',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 1958.7,
    imprecise: false,
    latitude: 40.65678,
    longitude: -74.30354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07016',
  },
  {
    city: 'East Orange',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 6983.6,
    imprecise: false,
    latitude: 40.77192,
    longitude: -74.20712,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07017',
  },
  {
    city: 'East Orange',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 6718.2,
    imprecise: false,
    latitude: 40.75572,
    longitude: -74.21793,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07018',
  },
  {
    city: 'Edgewater',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 5868.3,
    imprecise: false,
    latitude: 40.82374,
    longitude: -73.97401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07020',
  },
  {
    city: 'Essex Fells',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 647.3,
    imprecise: false,
    latitude: 40.82708,
    longitude: -74.27981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07021',
  },
  {
    city: 'Fairview',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 6910.1,
    imprecise: false,
    latitude: 40.81821,
    longitude: -74.0022,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07022',
  },
  {
    city: 'Fanwood',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 2247.8,
    imprecise: false,
    latitude: 40.64171,
    longitude: -74.38575,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07023',
  },
  {
    city: 'Fort Lee',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 6150.2,
    imprecise: false,
    latitude: 40.85088,
    longitude: -73.97128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07024',
  },
  {
    city: 'Garfield',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 5995.9,
    imprecise: false,
    latitude: 40.87914,
    longitude: -74.1085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07026',
  },
  {
    city: 'Garwood',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 2900,
    imprecise: false,
    latitude: 40.65132,
    longitude: -74.32313,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07027',
  },
  {
    city: 'Glen Ridge',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 2366.9,
    imprecise: false,
    latitude: 40.80421,
    longitude: -74.20428,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07028',
  },
  {
    city: 'Harrison',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 6720.5,
    imprecise: false,
    latitude: 40.74377,
    longitude: -74.15389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07029',
  },
  {
    city: 'Hoboken',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 18131.4,
    imprecise: false,
    latitude: 40.7451,
    longitude: -74.02815,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07030',
  },
  {
    city: 'North Arlington',
    county_fips: 34003,
    county_fips_all: '34003|34013',
    county: 'Bergen',
    county_names_all: 'Bergen|Essex',
    county_weights: '{"34003": 99.83, "34013": 0.17}',
    density: 2558.3,
    imprecise: false,
    latitude: 40.78745,
    longitude: -74.12731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07031',
  },
  {
    city: 'Kearny',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 1773,
    imprecise: false,
    latitude: 40.75281,
    longitude: -74.12016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07032',
  },
  {
    city: 'Kenilworth',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 1511,
    imprecise: false,
    latitude: 40.67812,
    longitude: -74.28898,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07033',
  },
  {
    city: 'Lake Hiawatha',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 3348.7,
    imprecise: false,
    latitude: 40.87953,
    longitude: -74.37965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07034',
  },
  {
    city: 'Lincoln Park',
    county_fips: 34027,
    county_fips_all: '34027|34013',
    county: 'Morris',
    county_names_all: 'Morris|Essex',
    county_weights: '{"34027": 99.8, "34013": 0.2}',
    density: 644.8,
    imprecise: false,
    latitude: 40.925,
    longitude: -74.30462,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07035',
  },
  {
    city: 'Linden',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 1622.4,
    imprecise: false,
    latitude: 40.62526,
    longitude: -74.23917,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07036',
  },
  {
    city: 'Livingston',
    county_fips: 34013,
    county_fips_all: '34013|34027',
    county: 'Essex',
    county_names_all: 'Essex|Morris',
    county_weights: '{"34013": 99.84, "34027": 0.16}',
    density: 882.8,
    imprecise: false,
    latitude: 40.78554,
    longitude: -74.32909,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07039',
  },
  {
    city: 'Maplewood',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 2552.7,
    imprecise: false,
    latitude: 40.73302,
    longitude: -74.27117,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07040',
  },
  {
    city: 'Millburn',
    county_fips: 34013,
    county_fips_all: '34013|34039',
    county: 'Essex',
    county_names_all: 'Essex|Union',
    county_weights: '{"34013": 99.47, "34039": 0.53}',
    density: 2167.3,
    imprecise: false,
    latitude: 40.72301,
    longitude: -74.30065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07041',
  },
  {
    city: 'Montclair',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 2795.1,
    imprecise: false,
    latitude: 40.81382,
    longitude: -74.21775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07042',
  },
  {
    city: 'Montclair',
    county_fips: 34013,
    county_fips_all: '34013|34031',
    county: 'Essex',
    county_names_all: 'Essex|Passaic',
    county_weights: '{"34013": 96.19, "34031": 3.81}',
    density: 2008.3,
    imprecise: false,
    latitude: 40.84411,
    longitude: -74.20041,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07043',
  },
  {
    city: 'Verona',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 2009.8,
    imprecise: false,
    latitude: 40.83228,
    longitude: -74.24308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07044',
  },
  {
    city: 'Montville',
    county_fips: 34027,
    county_fips_all: '34027|34013',
    county: 'Morris',
    county_names_all: 'Morris|Essex',
    county_weights: '{"34027": 99.87, "34013": 0.13}',
    density: 620.8,
    imprecise: false,
    latitude: 40.90736,
    longitude: -74.3671,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07045',
  },
  {
    city: 'Mountain Lakes',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 665.7,
    imprecise: false,
    latitude: 40.89067,
    longitude: -74.44072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07046',
  },
  {
    city: 'North Bergen',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 4604.7,
    imprecise: false,
    latitude: 40.79376,
    longitude: -74.02416,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 61250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07047',
  },
  {
    city: 'Orange',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 5981.3,
    imprecise: false,
    latitude: 40.76817,
    longitude: -74.2348,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07050',
  },
  {
    city: 'West Orange',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 1562.2,
    imprecise: false,
    latitude: 40.78928,
    longitude: -74.26281,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07052',
  },
  {
    city: 'Parsippany',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 823,
    imprecise: false,
    latitude: 40.85527,
    longitude: -74.40239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07054',
  },
  {
    city: 'Passaic',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 8638.4,
    imprecise: false,
    latitude: 40.85746,
    longitude: -74.12821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 70002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07055',
  },
  {
    city: 'Wallington',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 4617.7,
    imprecise: false,
    latitude: 40.85355,
    longitude: -74.10691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07057',
  },
  {
    city: 'Pine Brook',
    county_fips: 34027,
    county_fips_all: '34027|34013',
    county: 'Morris',
    county_names_all: 'Morris|Essex',
    county_weights: '{"34027": 99.77, "34013": 0.23}',
    density: 776.7,
    imprecise: false,
    latitude: 40.86701,
    longitude: -74.34283,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07058',
  },
  {
    city: 'Warren',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 329.4,
    imprecise: false,
    latitude: 40.63199,
    longitude: -74.51463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07059',
  },
  {
    city: 'Plainfield',
    county_fips: 34039,
    county_fips_all: '34039|34035',
    county: 'Union',
    county_names_all: 'Union|Somerset',
    county_weights: '{"34039": 62.49, "34035": 37.51}',
    density: 3735.5,
    imprecise: false,
    latitude: 40.61606,
    longitude: -74.42164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07060',
  },
  {
    city: 'Plainfield',
    county_fips: 34039,
    county_fips_all: '34039|34035',
    county: 'Union',
    county_names_all: 'Union|Somerset',
    county_weights: '{"34039": 87.73, "34035": 12.27}',
    density: 3092.2,
    imprecise: false,
    latitude: 40.63174,
    longitude: -74.40391,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07062',
  },
  {
    city: 'Plainfield',
    county_fips: 34039,
    county_fips_all: '34039|34035',
    county: 'Union',
    county_names_all: 'Union|Somerset',
    county_weights: '{"34039": 61.1, "34035": 38.9}',
    density: 3078.3,
    imprecise: false,
    latitude: 40.60524,
    longitude: -74.44615,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07063',
  },
  {
    city: 'Port Reading',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1019.1,
    imprecise: false,
    latitude: 40.56865,
    longitude: -74.2464,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07064',
  },
  {
    city: 'Rahway',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 2983.7,
    imprecise: false,
    latitude: 40.60765,
    longitude: -74.28066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07065',
  },
  {
    city: 'Clark',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 1377.9,
    imprecise: false,
    latitude: 40.62061,
    longitude: -74.31335,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07066',
  },
  {
    city: 'Colonia',
    county_fips: 34023,
    county_fips_all: '34023|34039',
    county: 'Middlesex',
    county_names_all: 'Middlesex|Union',
    county_weights: '{"34023": 99.9, "34039": 0.1}',
    density: 1781.2,
    imprecise: false,
    latitude: 40.59255,
    longitude: -74.31479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07067',
  },
  {
    city: 'Roseland',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 668.9,
    imprecise: false,
    latitude: 40.82077,
    longitude: -74.30862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07068',
  },
  {
    city: 'Watchung',
    county_fips: 34035,
    county_fips_all: '34035|34039',
    county: 'Somerset',
    county_names_all: 'Somerset|Union',
    county_weights: '{"34035": 99.8, "34039": 0.2}',
    density: 403.9,
    imprecise: false,
    latitude: 40.64249,
    longitude: -74.4396,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07069',
  },
  {
    city: 'Rutherford',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 2623.1,
    imprecise: false,
    latitude: 40.82034,
    longitude: -74.10574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07070',
  },
  {
    city: 'Lyndhurst',
    county_fips: 34003,
    county_fips_all: '34003|34013',
    county: 'Bergen',
    county_names_all: 'Bergen|Essex',
    county_weights: '{"34003": 99.87, "34013": 0.13}',
    density: 1891.8,
    imprecise: false,
    latitude: 40.79646,
    longitude: -74.1099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07071',
  },
  {
    city: 'Carlstadt',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 623.8,
    imprecise: false,
    latitude: 40.82472,
    longitude: -74.06126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07072',
  },
  {
    city: 'East Rutherford',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1073.1,
    imprecise: false,
    latitude: 40.81792,
    longitude: -74.08539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07073',
  },
  {
    city: 'Moonachie',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1102.7,
    imprecise: false,
    latitude: 40.83877,
    longitude: -74.05705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07074',
  },
  {
    city: 'Wood Ridge',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 3542.9,
    imprecise: false,
    latitude: 40.85076,
    longitude: -74.08779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07075',
  },
  {
    city: 'Scotch Plains',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 1066.3,
    imprecise: false,
    latitude: 40.63308,
    longitude: -74.37387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07076',
  },
  {
    city: 'Sewaren',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 813.1,
    imprecise: false,
    latitude: 40.55415,
    longitude: -74.25489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07077',
  },
  {
    city: 'Short Hills',
    county_fips: 34013,
    county_fips_all: '34013|34027',
    county: 'Essex',
    county_names_all: 'Essex|Morris',
    county_weights: '{"34013": 99.89, "34027": 0.11}',
    density: 706,
    imprecise: false,
    latitude: 40.74196,
    longitude: -74.3277,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07078',
  },
  {
    city: 'South Orange',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 2510.3,
    imprecise: false,
    latitude: 40.74908,
    longitude: -74.26022,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07079',
  },
  {
    city: 'South Plainfield',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1146.4,
    imprecise: false,
    latitude: 40.57483,
    longitude: -74.41542,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07080',
  },
  {
    city: 'Springfield',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 1280.7,
    imprecise: false,
    latitude: 40.69949,
    longitude: -74.32542,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07081',
  },
  {
    city: 'Towaco',
    county_fips: 34027,
    county_fips_all: '34027|34013',
    county: 'Morris',
    county_names_all: 'Morris|Essex',
    county_weights: '{"34027": 99.82, "34013": 0.18}',
    density: 364,
    imprecise: false,
    latitude: 40.92643,
    longitude: -74.34524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07082',
  },
  {
    city: 'Union',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 2573.8,
    imprecise: false,
    latitude: 40.69443,
    longitude: -74.2692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07083',
  },
  {
    city: 'Weehawken',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 8408.2,
    imprecise: false,
    latitude: 40.76761,
    longitude: -74.01693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07086',
  },
  {
    city: 'Union City',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 19665.5,
    imprecise: false,
    latitude: 40.76723,
    longitude: -74.03243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07087',
  },
  {
    city: 'Vauxhall',
    county_fips: 34039,
    county_fips_all: '34039|34013',
    county: 'Union',
    county_names_all: 'Union|Essex',
    county_weights: '{"34039": 99.61, "34013": 0.39}',
    density: 3454.4,
    imprecise: false,
    latitude: 40.71832,
    longitude: -74.28375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07088',
  },
  {
    city: 'Westfield',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 1782.7,
    imprecise: false,
    latitude: 40.65172,
    longitude: -74.34328,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07090',
  },
  {
    city: 'Mountainside',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 681.6,
    imprecise: false,
    latitude: 40.68106,
    longitude: -74.36038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07092',
  },
  {
    city: 'West New York',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 20733.9,
    imprecise: false,
    latitude: 40.78675,
    longitude: -74.00871,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07093',
  },
  {
    city: 'Secaucus',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 1449.7,
    imprecise: false,
    latitude: 40.78109,
    longitude: -74.06588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07094',
  },
  {
    city: 'Woodbridge',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1739.2,
    imprecise: false,
    latitude: 40.55358,
    longitude: -74.28743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07095',
  },
  {
    city: 'Newark',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 4219.7,
    imprecise: false,
    latitude: 40.73576,
    longitude: -74.17343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07102',
  },
  {
    city: 'Newark',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 6691.3,
    imprecise: false,
    latitude: 40.73886,
    longitude: -74.19529,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07103',
  },
  {
    city: 'Newark',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 7972,
    imprecise: false,
    latitude: 40.76735,
    longitude: -74.16831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07104',
  },
  {
    city: 'Newark',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 4751.9,
    imprecise: false,
    latitude: 40.72266,
    longitude: -74.13874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07105',
  },
  {
    city: 'Newark',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 9915.7,
    imprecise: false,
    latitude: 40.74177,
    longitude: -74.23047,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07106',
  },
  {
    city: 'Newark',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 10139.3,
    imprecise: false,
    latitude: 40.76181,
    longitude: -74.18653,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07107',
  },
  {
    city: 'Newark',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 8059,
    imprecise: false,
    latitude: 40.72306,
    longitude: -74.20039,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07108',
  },
  {
    city: 'Belleville',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 4441.3,
    imprecise: false,
    latitude: 40.79502,
    longitude: -74.16161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07109',
  },
  {
    city: 'Nutley',
    county_fips: 34013,
    county_fips_all: '34013|34031',
    county: 'Essex',
    county_names_all: 'Essex|Passaic',
    county_weights: '{"34013": 99.78, "34031": 0.22}',
    density: 3430.8,
    imprecise: false,
    latitude: 40.81926,
    longitude: -74.15715,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07110',
  },
  {
    city: 'Irvington',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 8064.2,
    imprecise: false,
    latitude: 40.72426,
    longitude: -74.23173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07111',
  },
  {
    city: 'Newark',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 8369.1,
    imprecise: false,
    latitude: 40.71137,
    longitude: -74.21164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07112',
  },
  {
    city: 'Newark',
    county_fips: 34013,
    county_fips_all: '34013',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"34013": 100}',
    density: 668.6,
    imprecise: false,
    latitude: 40.70018,
    longitude: -74.16618,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07114',
  },
  {
    city: 'Elizabeth',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 1707.4,
    imprecise: false,
    latitude: 40.67237,
    longitude: -74.17643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07201',
  },
  {
    city: 'Elizabeth',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 7505.2,
    imprecise: false,
    latitude: 40.6531,
    longitude: -74.21677,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07202',
  },
  {
    city: 'Roselle',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 3317.7,
    imprecise: false,
    latitude: 40.65269,
    longitude: -74.2599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07203',
  },
  {
    city: 'Roselle Park',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 4441.9,
    imprecise: false,
    latitude: 40.66532,
    longitude: -74.2666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07204',
  },
  {
    city: 'Hillside',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 3120.2,
    imprecise: false,
    latitude: 40.69612,
    longitude: -74.22857,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07205',
  },
  {
    city: 'Elizabethport',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 6936.7,
    imprecise: false,
    latitude: 40.65238,
    longitude: -74.18385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07206',
  },
  {
    city: 'Elizabeth',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 6881.1,
    imprecise: false,
    latitude: 40.67434,
    longitude: -74.22498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07208',
  },
  {
    city: 'Jersey City',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 15148.6,
    imprecise: false,
    latitude: 40.71894,
    longitude: -74.04462,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07302',
  },
  {
    city: 'Jersey City',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 9638.5,
    imprecise: false,
    latitude: 40.71741,
    longitude: -74.07637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07304',
  },
  {
    city: 'Jersey City',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 4887.9,
    imprecise: false,
    latitude: 40.69839,
    longitude: -74.08158,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 72161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07305',
  },
  {
    city: 'Jersey City',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 6982.9,
    imprecise: false,
    latitude: 40.73674,
    longitude: -74.07132,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07306',
  },
  {
    city: 'Jersey City',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 8662.6,
    imprecise: false,
    latitude: 40.75192,
    longitude: -74.05429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07307',
  },
  {
    city: 'Jersey City',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 10117.1,
    imprecise: false,
    latitude: 40.72893,
    longitude: -74.03391,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07310',
  },
  {
    city: 'Jersey City',
    county_fips: 34017,
    county_fips_all: '34017',
    county: 'Hudson',
    county_names_all: 'Hudson',
    county_weights: '{"34017": 100}',
    density: 12330.3,
    imprecise: false,
    latitude: 40.71878,
    longitude: -74.02933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07311',
  },
  {
    city: 'Allendale',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 857.4,
    imprecise: false,
    latitude: 41.03321,
    longitude: -74.13328,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07401',
  },
  {
    city: 'Bloomingdale',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 486.5,
    imprecise: false,
    latitude: 41.02059,
    longitude: -74.33239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07403',
  },
  {
    city: 'Butler',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 350.6,
    imprecise: false,
    latitude: 40.98646,
    longitude: -74.38302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07405',
  },
  {
    city: 'Elmwood Park',
    county_fips: 34003,
    county_fips_all: '34003|34031',
    county: 'Bergen',
    county_names_all: 'Bergen|Passaic',
    county_weights: '{"34003": 99.89, "34031": 0.11}',
    density: 3128.1,
    imprecise: false,
    latitude: 40.90493,
    longitude: -74.12007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07407',
  },
  {
    city: 'Fair Lawn',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 2677.5,
    imprecise: false,
    latitude: 40.93587,
    longitude: -74.11771,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07410',
  },
  {
    city: 'Franklin',
    county_fips: 34037,
    county_fips_all: '34037',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"34037": 100}',
    density: 185.8,
    imprecise: false,
    latitude: 41.10892,
    longitude: -74.58891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07416',
  },
  {
    city: 'Franklin Lakes',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 455.4,
    imprecise: false,
    latitude: 41.00859,
    longitude: -74.20836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07417',
  },
  {
    city: 'Glenwood',
    county_fips: 34037,
    county_fips_all: '34037',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"34037": 100}',
    density: 214.3,
    imprecise: false,
    latitude: 41.2387,
    longitude: -74.4873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07418',
  },
  {
    city: 'Hamburg',
    county_fips: 34037,
    county_fips_all: '34037',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"34037": 100}',
    density: 219.4,
    imprecise: false,
    latitude: 41.15394,
    longitude: -74.57106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07419',
  },
  {
    city: 'Haskell',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 853.2,
    imprecise: false,
    latitude: 41.02926,
    longitude: -74.30281,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07420',
  },
  {
    city: 'Hewitt',
    county_fips: 34031,
    county_fips_all: '34031|34037',
    county: 'Passaic',
    county_names_all: 'Passaic|Sussex',
    county_weights: '{"34031": 92.08, "34037": 7.92}',
    density: 119.3,
    imprecise: false,
    latitude: 41.1624,
    longitude: -74.35586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07421',
  },
  {
    city: 'Highland Lakes',
    county_fips: 34037,
    county_fips_all: '34037',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"34037": 100}',
    density: 116.5,
    imprecise: false,
    latitude: 41.17984,
    longitude: -74.44177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07422',
  },
  {
    city: 'Ho Ho Kus',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 947.8,
    imprecise: false,
    latitude: 41.00007,
    longitude: -74.09718,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07423',
  },
  {
    city: 'Little Falls',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 1896.1,
    imprecise: false,
    latitude: 40.88361,
    longitude: -74.2059,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07424',
  },
  {
    city: 'Mahwah',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 387.5,
    imprecise: false,
    latitude: 41.08157,
    longitude: -74.18562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07430',
  },
  {
    city: 'Midland Park',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1735.7,
    imprecise: false,
    latitude: 40.99516,
    longitude: -74.14109,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07432',
  },
  {
    city: 'Newfoundland',
    county_fips: 34031,
    county_fips_all: '34031|34027',
    county: 'Passaic',
    county_names_all: 'Passaic|Morris',
    county_weights: '{"34031": 60.48, "34027": 39.52}',
    density: 82.9,
    imprecise: false,
    latitude: 41.0425,
    longitude: -74.44159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07435',
  },
  {
    city: 'Oakland',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 578.8,
    imprecise: false,
    latitude: 41.03135,
    longitude: -74.24081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07436',
  },
  {
    city: 'Oak Ridge',
    county_fips: 34027,
    county_fips_all: '34027|34031',
    county: 'Morris',
    county_names_all: 'Morris|Passaic',
    county_weights: '{"34027": 84.87, "34031": 15.13}',
    density: 143.5,
    imprecise: false,
    latitude: 41.0287,
    longitude: -74.52038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07438',
  },
  {
    city: 'Ogdensburg',
    county_fips: 34037,
    county_fips_all: '34037',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"34037": 100}',
    density: 378.5,
    imprecise: false,
    latitude: 41.0769,
    longitude: -74.59734,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07439',
  },
  {
    city: 'Pequannock',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 1164.9,
    imprecise: false,
    latitude: 40.94668,
    longitude: -74.29421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07440',
  },
  {
    city: 'Pompton Lakes',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 1479.5,
    imprecise: false,
    latitude: 41.0024,
    longitude: -74.28589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07442',
  },
  {
    city: 'Pompton Plains',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 809.3,
    imprecise: false,
    latitude: 40.96782,
    longitude: -74.30724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07444',
  },
  {
    city: 'Ramsey',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1039.5,
    imprecise: false,
    latitude: 41.05944,
    longitude: -74.14532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07446',
  },
  {
    city: 'Ridgewood',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1766.2,
    imprecise: false,
    latitude: 40.98219,
    longitude: -74.11275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07450',
  },
  {
    city: 'Glen Rock',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1735.8,
    imprecise: false,
    latitude: 40.96008,
    longitude: -74.12498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07452',
  },
  {
    city: 'Ringwood',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 175.9,
    imprecise: false,
    latitude: 41.10647,
    longitude: -74.27487,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07456',
  },
  {
    city: 'Riverdale',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 783.6,
    imprecise: false,
    latitude: 40.99212,
    longitude: -74.3125,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07457',
  },
  {
    city: 'Saddle River',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 449.1,
    imprecise: false,
    latitude: 41.04583,
    longitude: -74.0971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07458',
  },
  {
    city: 'Stockholm',
    county_fips: 34037,
    county_fips_all: '34037|34031|34027',
    county: 'Sussex',
    county_names_all: 'Sussex|Passaic|Morris',
    county_weights: '{"34037": 65.21, "34031": 34.69, "34027": 0.1}',
    density: 43,
    imprecise: false,
    latitude: 41.11341,
    longitude: -74.49006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07460',
  },
  {
    city: 'Sussex',
    county_fips: 34037,
    county_fips_all: '34037',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"34037": 100}',
    density: 87.2,
    imprecise: false,
    latitude: 41.24213,
    longitude: -74.60648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07461',
  },
  {
    city: 'Vernon',
    county_fips: 34037,
    county_fips_all: '34037',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"34037": 100}',
    density: 163.3,
    imprecise: false,
    latitude: 41.19873,
    longitude: -74.48911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07462',
  },
  {
    city: 'Waldwick',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1917.8,
    imprecise: false,
    latitude: 41.01334,
    longitude: -74.12585,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07463',
  },
  {
    city: 'Wanaque',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 273.4,
    imprecise: false,
    latitude: 41.05015,
    longitude: -74.29849,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07465',
  },
  {
    city: 'Wayne',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 875.1,
    imprecise: false,
    latitude: 40.94805,
    longitude: -74.24504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07470',
  },
  {
    city: 'West Milford',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 174.8,
    imprecise: false,
    latitude: 41.08713,
    longitude: -74.3779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07480',
  },
  {
    city: 'Wyckoff',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 998.6,
    imprecise: false,
    latitude: 40.99891,
    longitude: -74.16757,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07481',
  },
  {
    city: 'Paterson',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 7610.3,
    imprecise: false,
    latitude: 40.9125,
    longitude: -74.17099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07501',
  },
  {
    city: 'Paterson',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 7710.3,
    imprecise: false,
    latitude: 40.91903,
    longitude: -74.19461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07502',
  },
  {
    city: 'Paterson',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 4786.2,
    imprecise: false,
    latitude: 40.89768,
    longitude: -74.15353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07503',
  },
  {
    city: 'Paterson',
    county_fips: 34031,
    county_fips_all: '34031|34003',
    county: 'Passaic',
    county_names_all: 'Passaic|Bergen',
    county_weights: '{"34031": 99.57, "34003": 0.43}',
    density: 6089.3,
    imprecise: false,
    latitude: 40.912,
    longitude: -74.14121,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07504',
  },
  {
    city: 'Paterson',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 7399.7,
    imprecise: false,
    latitude: 40.91694,
    longitude: -74.17222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07505',
  },
  {
    city: 'Hawthorne',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 2283.7,
    imprecise: false,
    latitude: 40.95794,
    longitude: -74.15815,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07506',
  },
  {
    city: 'Haledon',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 1823.4,
    imprecise: false,
    latitude: 40.95448,
    longitude: -74.18423,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07508',
  },
  {
    city: 'Totowa',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 1068.6,
    imprecise: false,
    latitude: 40.90385,
    longitude: -74.22118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07512',
  },
  {
    city: 'Paterson',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 7873.9,
    imprecise: false,
    latitude: 40.90565,
    longitude: -74.14869,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07513',
  },
  {
    city: 'Paterson',
    county_fips: 34031,
    county_fips_all: '34031|34003',
    county: 'Passaic',
    county_names_all: 'Passaic|Bergen',
    county_weights: '{"34031": 99.76, "34003": 0.24}',
    density: 8594.2,
    imprecise: false,
    latitude: 40.92596,
    longitude: -74.14452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07514',
  },
  {
    city: 'Paterson',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 10149.7,
    imprecise: false,
    latitude: 40.92413,
    longitude: -74.17928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07522',
  },
  {
    city: 'Paterson',
    county_fips: 34031,
    county_fips_all: '34031',
    county: 'Passaic',
    county_names_all: 'Passaic',
    county_weights: '{"34031": 100}',
    density: 7030.9,
    imprecise: false,
    latitude: 40.93226,
    longitude: -74.15674,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07524',
  },
  {
    city: 'Hackensack',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 4236.1,
    imprecise: false,
    latitude: 40.8891,
    longitude: -74.04614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07601',
  },
  {
    city: 'Bogota',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 4789,
    imprecise: false,
    latitude: 40.87507,
    longitude: -74.02934,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07603',
  },
  {
    city: 'Hasbrouck Heights',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 3039.6,
    imprecise: false,
    latitude: 40.86166,
    longitude: -74.07413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07604',
  },
  {
    city: 'Leonia',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 2402.3,
    imprecise: false,
    latitude: 40.86362,
    longitude: -73.9899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07605',
  },
  {
    city: 'South Hackensack',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1459.4,
    imprecise: false,
    latitude: 40.85783,
    longitude: -74.05177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07606',
  },
  {
    city: 'Maywood',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 3028.6,
    imprecise: false,
    latitude: 40.90249,
    longitude: -74.06337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07607',
  },
  {
    city: 'Teterboro',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 40.85297,
    longitude: -74.06045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07608',
  },
  {
    city: 'Alpine',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 95.8,
    imprecise: false,
    latitude: 40.96165,
    longitude: -73.91983,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07620',
  },
  {
    city: 'Bergenfield',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 3779.4,
    imprecise: false,
    latitude: 40.92357,
    longitude: -73.99824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07621',
  },
  {
    city: 'Closter',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1051.4,
    imprecise: false,
    latitude: 40.97329,
    longitude: -73.96044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07624',
  },
  {
    city: 'Cresskill',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1715.6,
    imprecise: false,
    latitude: 40.94054,
    longitude: -73.9596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07626',
  },
  {
    city: 'Demarest',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 914.9,
    imprecise: false,
    latitude: 40.95504,
    longitude: -73.95678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07627',
  },
  {
    city: 'Dumont',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 3624.6,
    imprecise: false,
    latitude: 40.94524,
    longitude: -73.99227,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07628',
  },
  {
    city: 'Emerson',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1264.3,
    imprecise: false,
    latitude: 40.97484,
    longitude: -74.024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07630',
  },
  {
    city: 'Englewood',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 2313.6,
    imprecise: false,
    latitude: 40.89161,
    longitude: -73.97368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07631',
  },
  {
    city: 'Englewood Cliffs',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 973.7,
    imprecise: false,
    latitude: 40.88227,
    longitude: -73.94672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07632',
  },
  {
    city: 'Harrington Park',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1036.4,
    imprecise: false,
    latitude: 40.9899,
    longitude: -73.98037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07640',
  },
  {
    city: 'Haworth',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 670.3,
    imprecise: false,
    latitude: 40.96224,
    longitude: -73.9976,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07641',
  },
  {
    city: 'Hillsdale',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1349.8,
    imprecise: false,
    latitude: 41.00742,
    longitude: -74.04402,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07642',
  },
  {
    city: 'Little Ferry',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 2874.3,
    imprecise: false,
    latitude: 40.84635,
    longitude: -74.03879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07643',
  },
  {
    city: 'Lodi',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 4431.9,
    imprecise: false,
    latitude: 40.87836,
    longitude: -74.08145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07644',
  },
  {
    city: 'Montvale',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 854.2,
    imprecise: false,
    latitude: 41.05293,
    longitude: -74.04985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07645',
  },
  {
    city: 'New Milford',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 2874.3,
    imprecise: false,
    latitude: 40.93368,
    longitude: -74.01956,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07646',
  },
  {
    city: 'Northvale',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 900.3,
    imprecise: false,
    latitude: 41.00674,
    longitude: -73.94255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07647',
  },
  {
    city: 'Norwood',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 793.5,
    imprecise: false,
    latitude: 40.99335,
    longitude: -73.95103,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07648',
  },
  {
    city: 'Oradell',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1318.5,
    imprecise: false,
    latitude: 40.95622,
    longitude: -74.03141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07649',
  },
  {
    city: 'Palisades Park',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 6323.1,
    imprecise: false,
    latitude: 40.84716,
    longitude: -73.99664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07650',
  },
  {
    city: 'Paramus',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 982.1,
    imprecise: false,
    latitude: 40.94553,
    longitude: -74.07122,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07652',
  },
  {
    city: 'Park Ridge',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1393,
    imprecise: false,
    latitude: 41.03524,
    longitude: -74.04232,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07656',
  },
  {
    city: 'Ridgefield',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1746,
    imprecise: false,
    latitude: 40.83127,
    longitude: -74.01471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07657',
  },
  {
    city: 'Ridgefield Park',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 2997.6,
    imprecise: false,
    latitude: 40.85434,
    longitude: -74.02013,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07660',
  },
  {
    city: 'River Edge',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 2556.6,
    imprecise: false,
    latitude: 40.92697,
    longitude: -74.03874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07661',
  },
  {
    city: 'Rochelle Park',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 2287.5,
    imprecise: false,
    latitude: 40.90698,
    longitude: -74.07911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07662',
  },
  {
    city: 'Saddle Brook',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 2068.1,
    imprecise: false,
    latitude: 40.90328,
    longitude: -74.09545,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07663',
  },
  {
    city: 'Teaneck',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 2676.6,
    imprecise: false,
    latitude: 40.88998,
    longitude: -74.01067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07666',
  },
  {
    city: 'Tenafly',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1289.6,
    imprecise: false,
    latitude: 40.91758,
    longitude: -73.95323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07670',
  },
  {
    city: 'Westwood',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1094.9,
    imprecise: false,
    latitude: 41.00918,
    longitude: -74.00428,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07675',
  },
  {
    city: 'Township Of Washington',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 1218.8,
    imprecise: false,
    latitude: 40.98843,
    longitude: -74.06359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07676',
  },
  {
    city: 'Woodcliff Lake',
    county_fips: 34003,
    county_fips_all: '34003',
    county: 'Bergen',
    county_names_all: 'Bergen',
    county_weights: '{"34003": 100}',
    density: 703.6,
    imprecise: false,
    latitude: 41.0253,
    longitude: -74.06038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07677',
  },
  {
    city: 'Red Bank',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 1028.1,
    imprecise: false,
    latitude: 40.36046,
    longitude: -74.07866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07701',
  },
  {
    city: 'Shrewsbury',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 746.8,
    imprecise: false,
    latitude: 40.32489,
    longitude: -74.06002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07702',
  },
  {
    city: 'Fair Haven',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 1484.9,
    imprecise: false,
    latitude: 40.36176,
    longitude: -74.03926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07704',
  },
  {
    city: 'Allenhurst',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 979.4,
    imprecise: false,
    latitude: 40.2379,
    longitude: -74.0076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07711',
  },
  {
    city: 'Asbury Park',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 1269.2,
    imprecise: false,
    latitude: 40.24805,
    longitude: -74.05531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07712',
  },
  {
    city: 'Atlantic Highlands',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 779.4,
    imprecise: false,
    latitude: 40.40237,
    longitude: -74.03533,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07716',
  },
  {
    city: 'Avon By The Sea',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 1841.8,
    imprecise: false,
    latitude: 40.19129,
    longitude: -74.01657,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07717',
  },
  {
    city: 'Belford',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 1241.6,
    imprecise: false,
    latitude: 40.42045,
    longitude: -74.08488,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07718',
  },
  {
    city: 'Belmar',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 673.6,
    imprecise: false,
    latitude: 40.16864,
    longitude: -74.07271,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07719',
  },
  {
    city: 'Bradley Beach',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 2638.8,
    imprecise: false,
    latitude: 40.20176,
    longitude: -74.01276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07720',
  },
  {
    city: 'Cliffwood',
    county_fips: 34025,
    county_fips_all: '34025|34023',
    county: 'Monmouth',
    county_names_all: 'Monmouth|Middlesex',
    county_weights: '{"34025": 88.98, "34023": 11.02}',
    density: 1810.9,
    imprecise: false,
    latitude: 40.43556,
    longitude: -74.23555,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07721',
  },
  {
    city: 'Colts Neck',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 111.7,
    imprecise: false,
    latitude: 40.28765,
    longitude: -74.16745,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07722',
  },
  {
    city: 'Deal',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 207.7,
    imprecise: false,
    latitude: 40.25016,
    longitude: -74.00081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07723',
  },
  {
    city: 'Eatontown',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 764.7,
    imprecise: false,
    latitude: 40.29801,
    longitude: -74.07517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07724',
  },
  {
    city: 'Englishtown',
    county_fips: 34025,
    county_fips_all: '34025|34023',
    county: 'Monmouth',
    county_names_all: 'Monmouth|Middlesex',
    county_weights: '{"34025": 98.67, "34023": 1.33}',
    density: 522.5,
    imprecise: false,
    latitude: 40.28318,
    longitude: -74.34232,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07726',
  },
  {
    city: 'Farmingdale',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 117.9,
    imprecise: false,
    latitude: 40.20352,
    longitude: -74.15863,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07727',
  },
  {
    city: 'Freehold',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 435.7,
    imprecise: false,
    latitude: 40.22522,
    longitude: -74.28447,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07728',
  },
  {
    city: 'Hazlet',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 1302.8,
    imprecise: false,
    latitude: 40.42611,
    longitude: -74.17422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07730',
  },
  {
    city: 'Howell',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 489.9,
    imprecise: false,
    latitude: 40.15014,
    longitude: -74.20316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07731',
  },
  {
    city: 'Highlands',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 463.3,
    imprecise: false,
    latitude: 40.43115,
    longitude: -73.99192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07732',
  },
  {
    city: 'Holmdel',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 372.9,
    imprecise: false,
    latitude: 40.37683,
    longitude: -74.17259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07733',
  },
  {
    city: 'Keansburg',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 2939.2,
    imprecise: false,
    latitude: 40.44309,
    longitude: -74.13517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07734',
  },
  {
    city: 'Keyport',
    county_fips: 34025,
    county_fips_all: '34025|34023',
    county: 'Monmouth',
    county_names_all: 'Monmouth|Middlesex',
    county_weights: '{"34025": 84.42, "34023": 15.58}',
    density: 1523.7,
    imprecise: false,
    latitude: 40.44108,
    longitude: -74.2028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07735',
  },
  {
    city: 'Leonardo',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 580.5,
    imprecise: false,
    latitude: 40.40953,
    longitude: -74.06444,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07737',
  },
  {
    city: 'Lincroft',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 475.9,
    imprecise: false,
    latitude: 40.33918,
    longitude: -74.12841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07738',
  },
  {
    city: 'Little Silver',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 872.6,
    imprecise: false,
    latitude: 40.33569,
    longitude: -74.03452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07739',
  },
  {
    city: 'Long Branch',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 2408.6,
    imprecise: false,
    latitude: 40.29581,
    longitude: -73.9919,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07740',
  },
  {
    city: 'Marlboro',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 576.4,
    imprecise: false,
    latitude: 40.31675,
    longitude: -74.25029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07746',
  },
  {
    city: 'Matawan',
    county_fips: 34023,
    county_fips_all: '34023|34025',
    county: 'Middlesex',
    county_names_all: 'Middlesex|Monmouth',
    county_weights: '{"34023": 53.76, "34025": 46.24}',
    density: 975.9,
    imprecise: false,
    latitude: 40.41312,
    longitude: -74.2521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07747',
  },
  {
    city: 'Middletown',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 850.4,
    imprecise: false,
    latitude: 40.39524,
    longitude: -74.11573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07748',
  },
  {
    city: 'Monmouth Beach',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 1188.3,
    imprecise: false,
    latitude: 40.33639,
    longitude: -73.98632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07750',
  },
  {
    city: 'Morganville',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 489.8,
    imprecise: false,
    latitude: 40.36191,
    longitude: -74.25821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07751',
  },
  {
    city: 'Neptune',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 902.5,
    imprecise: false,
    latitude: 40.21184,
    longitude: -74.07421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07753',
  },
  {
    city: 'Oakhurst',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 738.8,
    imprecise: false,
    latitude: 40.26351,
    longitude: -74.02344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07755',
  },
  {
    city: 'Ocean Grove',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 3192.9,
    imprecise: false,
    latitude: 40.21184,
    longitude: -74.00832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07756',
  },
  {
    city: 'Oceanport',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 839.3,
    imprecise: false,
    latitude: 40.31583,
    longitude: -74.01855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07757',
  },
  {
    city: 'Port Monmouth',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 983.3,
    imprecise: false,
    latitude: 40.431,
    longitude: -74.103,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07758',
  },
  {
    city: 'Rumson',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 442,
    imprecise: false,
    latitude: 40.37053,
    longitude: -74.00495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07760',
  },
  {
    city: 'Spring Lake',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 1130.7,
    imprecise: false,
    latitude: 40.15294,
    longitude: -74.0359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07762',
  },
  {
    city: 'West Long Branch',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 1160.7,
    imprecise: false,
    latitude: 40.28832,
    longitude: -74.01854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07764',
  },
  {
    city: 'Dover',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 808.7,
    imprecise: false,
    latitude: 40.93167,
    longitude: -74.54643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07801',
  },
  {
    city: 'Mine Hill',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 531.8,
    imprecise: false,
    latitude: 40.87819,
    longitude: -74.60003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07803',
  },
  {
    city: 'Allamuchy',
    county_fips: 34041,
    county_fips_all: '34041',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"34041": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.93104,
    longitude: -74.80424,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07820',
  },
  {
    city: 'Andover',
    county_fips: 34037,
    county_fips_all: '34037|34041',
    county: 'Sussex',
    county_names_all: 'Sussex|Warren',
    county_weights: '{"34037": 83.89, "34041": 16.11}',
    density: 87.2,
    imprecise: false,
    latitude: 40.96461,
    longitude: -74.74807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07821',
  },
  {
    city: 'Augusta',
    county_fips: 34037,
    county_fips_all: '34037',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"34037": 100}',
    density: 43.3,
    imprecise: false,
    latitude: 41.1409,
    longitude: -74.70373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07822',
  },
  {
    city: 'Belvidere',
    county_fips: 34041,
    county_fips_all: '34041',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"34041": 100}',
    density: 114.7,
    imprecise: false,
    latitude: 40.82589,
    longitude: -75.03781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07823',
  },
  {
    city: 'Blairstown',
    county_fips: 34041,
    county_fips_all: '34041|34037',
    county: 'Warren',
    county_names_all: 'Warren|Sussex',
    county_weights: '{"34041": 97.83, "34037": 2.17}',
    density: 41.9,
    imprecise: false,
    latitude: 40.98308,
    longitude: -74.9623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07825',
  },
  {
    city: 'Branchville',
    county_fips: 34037,
    county_fips_all: '34037',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"34037": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 41.17633,
    longitude: -74.79042,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07826',
  },
  {
    city: 'Montague',
    county_fips: 34037,
    county_fips_all: '34037',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"34037": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 41.28918,
    longitude: -74.74351,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07827',
  },
  {
    city: 'Budd Lake',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 421.4,
    imprecise: false,
    latitude: 40.88559,
    longitude: -74.75237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07828',
  },
  {
    city: 'Califon',
    county_fips: 34019,
    county_fips_all: '34019|34027',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon|Morris',
    county_weights: '{"34019": 81.91, "34027": 18.09}',
    density: 109.5,
    imprecise: false,
    latitude: 40.72099,
    longitude: -74.80033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07830',
  },
  {
    city: 'Changewater',
    county_fips: 34041,
    county_fips_all: '34041|34019',
    county: 'Warren',
    county_names_all: 'Warren|Hunterdon',
    county_weights: '{"34041": 98.19, "34019": 1.81}',
    density: 113.6,
    imprecise: false,
    latitude: 40.73909,
    longitude: -74.94678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07831',
  },
  {
    city: 'Columbia',
    county_fips: 34041,
    county_fips_all: '34041',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"34041": 100}',
    density: 33,
    imprecise: false,
    latitude: 40.94755,
    longitude: -75.06385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07832',
  },
  {
    city: 'Delaware',
    county_fips: 34041,
    county_fips_all: '34041',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"34041": 100}',
    density: 87.7,
    imprecise: false,
    latitude: 40.89422,
    longitude: -75.06979,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07833',
  },
  {
    city: 'Denville',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 611.3,
    imprecise: false,
    latitude: 40.88752,
    longitude: -74.48689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07834',
  },
  {
    city: 'Flanders',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 311.9,
    imprecise: false,
    latitude: 40.84767,
    longitude: -74.70163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07836',
  },
  {
    city: 'Great Meadows',
    county_fips: 34041,
    county_fips_all: '34041',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"34041": 100}',
    density: 55.6,
    imprecise: false,
    latitude: 40.88925,
    longitude: -74.91042,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07838',
  },
  {
    city: 'Hackettstown',
    county_fips: 34041,
    county_fips_all: '34041|34027',
    county: 'Warren',
    county_names_all: 'Warren|Morris',
    county_weights: '{"34041": 76.38, "34027": 23.62}',
    density: 332.1,
    imprecise: false,
    latitude: 40.86034,
    longitude: -74.83192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07840',
  },
  {
    city: 'Hibernia',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 85.9,
    imprecise: false,
    latitude: 40.94477,
    longitude: -74.50065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07842',
  },
  {
    city: 'Hopatcong',
    county_fips: 34037,
    county_fips_all: '34037|34027',
    county: 'Sussex',
    county_names_all: 'Sussex|Morris',
    county_weights: '{"34037": 99.65, "34027": 0.35}',
    density: 1102.1,
    imprecise: false,
    latitude: 40.93989,
    longitude: -74.65928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07843',
  },
  {
    city: 'Hope',
    county_fips: 34041,
    county_fips_all: '34041',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"34041": 100}',
    density: 189.4,
    imprecise: false,
    latitude: 40.90861,
    longitude: -74.96961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07844',
  },
  {
    city: 'Johnsonburg',
    county_fips: 34041,
    county_fips_all: '34041',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"34041": 100}',
    density: 212.1,
    imprecise: false,
    latitude: 40.96694,
    longitude: -74.87671,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07846',
  },
  {
    city: 'Kenvil',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 283.3,
    imprecise: false,
    latitude: 40.8856,
    longitude: -74.6237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07847',
  },
  {
    city: 'Lafayette',
    county_fips: 34037,
    county_fips_all: '34037',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"34037": 100}',
    density: 71.7,
    imprecise: false,
    latitude: 41.10339,
    longitude: -74.68312,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07848',
  },
  {
    city: 'Lake Hopatcong',
    county_fips: 34027,
    county_fips_all: '34027|34037',
    county: 'Morris',
    county_names_all: 'Morris|Sussex',
    county_weights: '{"34027": 99.16, "34037": 0.84}',
    density: 483.2,
    imprecise: false,
    latitude: 40.96861,
    longitude: -74.61066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07849',
  },
  {
    city: 'Landing',
    county_fips: 34027,
    county_fips_all: '34027|34037',
    county: 'Morris',
    county_names_all: 'Morris|Sussex',
    county_weights: '{"34027": 98.84, "34037": 1.16}',
    density: 947.1,
    imprecise: false,
    latitude: 40.90716,
    longitude: -74.66158,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07850',
  },
  {
    city: 'Layton',
    county_fips: 34037,
    county_fips_all: '34037',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"34037": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 41.19883,
    longitude: -74.85923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07851',
  },
  {
    city: 'Ledgewood',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 452.2,
    imprecise: false,
    latitude: 40.88374,
    longitude: -74.66531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07852',
  },
  {
    city: 'Long Valley',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 146.5,
    imprecise: false,
    latitude: 40.78785,
    longitude: -74.78315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07853',
  },
  {
    city: 'Mount Arlington',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 536.9,
    imprecise: false,
    latitude: 40.9189,
    longitude: -74.6336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07856',
  },
  {
    city: 'Netcong',
    county_fips: 34027,
    county_fips_all: '34027|34037',
    county: 'Morris',
    county_names_all: 'Morris|Sussex',
    county_weights: '{"34027": 99.5, "34037": 0.5}',
    density: 1378.2,
    imprecise: false,
    latitude: 40.89733,
    longitude: -74.69998,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07857',
  },
  {
    city: 'Newton',
    county_fips: 34037,
    county_fips_all: '34037|34041',
    county: 'Sussex',
    county_names_all: 'Sussex|Warren',
    county_weights: '{"34037": 94.11, "34041": 5.89}',
    density: 100.4,
    imprecise: false,
    latitude: 41.0595,
    longitude: -74.81159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07860',
  },
  {
    city: 'Oxford',
    county_fips: 34041,
    county_fips_all: '34041',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"34041": 100}',
    density: 74.1,
    imprecise: false,
    latitude: 40.81515,
    longitude: -74.96562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07863',
  },
  {
    city: 'Port Murray',
    county_fips: 34041,
    county_fips_all: '34041|34019|34027',
    county: 'Warren',
    county_names_all: 'Warren|Hunterdon|Morris',
    county_weights: '{"34041": 64.47, "34019": 21.24, "34027": 14.29}',
    density: 66,
    imprecise: false,
    latitude: 40.78722,
    longitude: -74.89845,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07865',
  },
  {
    city: 'Rockaway',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 380.3,
    imprecise: false,
    latitude: 40.9531,
    longitude: -74.48639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07866',
  },
  {
    city: 'Randolph',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 500.7,
    imprecise: false,
    latitude: 40.84528,
    longitude: -74.5807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07869',
  },
  {
    city: 'Schooleys Mountain',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 40.80535,
    longitude: -74.82303,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07870',
  },
  {
    city: 'Sparta',
    county_fips: 34037,
    county_fips_all: '34037|34027',
    county: 'Sussex',
    county_names_all: 'Sussex|Morris',
    county_weights: '{"34037": 99.85, "34027": 0.15}',
    density: 216.9,
    imprecise: false,
    latitude: 41.04666,
    longitude: -74.62793,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07871',
  },
  {
    city: 'Stanhope',
    county_fips: 34037,
    county_fips_all: '34037|34041',
    county: 'Sussex',
    county_names_all: 'Sussex|Warren',
    county_weights: '{"34037": 96.89, "34041": 3.11}',
    density: 399.4,
    imprecise: false,
    latitude: 40.9285,
    longitude: -74.70994,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07874',
  },
  {
    city: 'Succasunna',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 648.9,
    imprecise: false,
    latitude: 40.85302,
    longitude: -74.65627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07876',
  },
  {
    city: 'Mount Tabor',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 3240.5,
    imprecise: false,
    latitude: 40.87152,
    longitude: -74.47826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07878',
  },
  {
    city: 'Vienna',
    county_fips: 34041,
    county_fips_all: '34041',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"34041": 100}',
    density: 60.7,
    imprecise: false,
    latitude: 40.874,
    longitude: -74.88503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07880',
  },
  {
    city: 'Washington',
    county_fips: 34041,
    county_fips_all: '34041|34019',
    county: 'Warren',
    county_names_all: 'Warren|Hunterdon',
    county_weights: '{"34041": 94.91, "34019": 5.09}',
    density: 184.9,
    imprecise: false,
    latitude: 40.75327,
    longitude: -75.00748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07882',
  },
  {
    city: 'Wharton',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 310.4,
    imprecise: false,
    latitude: 40.93172,
    longitude: -74.57688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07885',
  },
  {
    city: 'Summit',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 1482.4,
    imprecise: false,
    latitude: 40.71462,
    longitude: -74.36604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07901',
  },
  {
    city: 'Basking Ridge',
    county_fips: 34035,
    county_fips_all: '34035|34027',
    county: 'Somerset',
    county_names_all: 'Somerset|Morris',
    county_weights: '{"34035": 80.63, "34027": 19.37}',
    density: 408.6,
    imprecise: false,
    latitude: 40.68374,
    longitude: -74.55444,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07920',
  },
  {
    city: 'Bedminster',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 161.7,
    imprecise: false,
    latitude: 40.65599,
    longitude: -74.6771,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07921',
  },
  {
    city: 'Berkeley Heights',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 843.6,
    imprecise: false,
    latitude: 40.67525,
    longitude: -74.42806,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07922',
  },
  {
    city: 'Bernardsville',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 248.8,
    imprecise: false,
    latitude: 40.727,
    longitude: -74.58941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07924',
  },
  {
    city: 'Brookside',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 175.4,
    imprecise: false,
    latitude: 40.80029,
    longitude: -74.56879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07926',
  },
  {
    city: 'Cedar Knolls',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 879.2,
    imprecise: false,
    latitude: 40.82085,
    longitude: -74.45479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07927',
  },
  {
    city: 'Chatham',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 832.7,
    imprecise: false,
    latitude: 40.7262,
    longitude: -74.41381,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07928',
  },
  {
    city: 'Chester',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 131.2,
    imprecise: false,
    latitude: 40.78222,
    longitude: -74.68642,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07930',
  },
  {
    city: 'Far Hills',
    county_fips: 34035,
    county_fips_all: '34035|34027',
    county: 'Somerset',
    county_names_all: 'Somerset|Morris',
    county_weights: '{"34035": 75.06, "34027": 24.94}',
    density: 52.5,
    imprecise: false,
    latitude: 40.70791,
    longitude: -74.65732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07931',
  },
  {
    city: 'Florham Park',
    county_fips: 34027,
    county_fips_all: '34027|34013',
    county: 'Morris',
    county_names_all: 'Morris|Essex',
    county_weights: '{"34027": 99.74, "34013": 0.26}',
    density: 686.7,
    imprecise: false,
    latitude: 40.77717,
    longitude: -74.39246,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07932',
  },
  {
    city: 'Gillette',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 218.3,
    imprecise: false,
    latitude: 40.69198,
    longitude: -74.46658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07933',
  },
  {
    city: 'Gladstone',
    county_fips: 34035,
    county_fips_all: '34035|34027',
    county: 'Somerset',
    county_names_all: 'Somerset|Morris',
    county_weights: '{"34035": 98.44, "34027": 1.56}',
    density: 160.7,
    imprecise: false,
    latitude: 40.72044,
    longitude: -74.68159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07934',
  },
  {
    city: 'Green Village',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 86.4,
    imprecise: false,
    latitude: 40.7371,
    longitude: -74.45296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07935',
  },
  {
    city: 'East Hanover',
    county_fips: 34027,
    county_fips_all: '34027|34013',
    county: 'Morris',
    county_names_all: 'Morris|Essex',
    county_weights: '{"34027": 99.86, "34013": 0.14}',
    density: 546.8,
    imprecise: false,
    latitude: 40.81918,
    longitude: -74.36382,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07936',
  },
  {
    city: 'Lyons',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 921.5,
    imprecise: false,
    latitude: 40.66723,
    longitude: -74.55215,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07939',
  },
  {
    city: 'Madison',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 1384,
    imprecise: false,
    latitude: 40.76006,
    longitude: -74.41889,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07940',
  },
  {
    city: 'Mendham',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 192.1,
    imprecise: false,
    latitude: 40.78065,
    longitude: -74.59928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07945',
  },
  {
    city: 'Millington',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 282.4,
    imprecise: false,
    latitude: 40.67698,
    longitude: -74.51143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07946',
  },
  {
    city: 'Morris Plains',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 917.5,
    imprecise: false,
    latitude: 40.84569,
    longitude: -74.48271,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07950',
  },
  {
    city: 'Morristown',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 520.9,
    imprecise: false,
    latitude: 40.78452,
    longitude: -74.49813,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07960',
  },
  {
    city: 'Convent Station',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 758.2,
    imprecise: false,
    latitude: 40.78105,
    longitude: -74.43517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07961',
  },
  {
    city: 'Mount Freedom',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 312.7,
    imprecise: false,
    latitude: 40.80831,
    longitude: -74.5727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07970',
  },
  {
    city: 'New Providence',
    county_fips: 34039,
    county_fips_all: '34039',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"34039": 100}',
    density: 1298.7,
    imprecise: false,
    latitude: 40.69732,
    longitude: -74.40321,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07974',
  },
  {
    city: 'New Vernon',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 43.3,
    imprecise: false,
    latitude: 40.72747,
    longitude: -74.47704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07976',
  },
  {
    city: 'Peapack',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 179.5,
    imprecise: false,
    latitude: 40.70969,
    longitude: -74.64786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07977',
  },
  {
    city: 'Pottersville',
    county_fips: 34019,
    county_fips_all: '34019|34035',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon|Somerset',
    county_weights: '{"34019": 81.44, "34035": 18.56}',
    density: 93.3,
    imprecise: false,
    latitude: 40.71225,
    longitude: -74.72581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07979',
  },
  {
    city: 'Stirling',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 436.5,
    imprecise: false,
    latitude: 40.6765,
    longitude: -74.49465,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07980',
  },
  {
    city: 'Whippany',
    county_fips: 34027,
    county_fips_all: '34027',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"34027": 100}',
    density: 578.4,
    imprecise: false,
    latitude: 40.82375,
    longitude: -74.42029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07981',
  },
  {
    city: 'Alloway',
    county_fips: 34033,
    county_fips_all: '34033',
    county: 'Salem',
    county_names_all: 'Salem',
    county_weights: '{"34033": 100}',
    density: 99.2,
    imprecise: false,
    latitude: 39.55423,
    longitude: -75.35683,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08001',
  },
  {
    city: 'Cherry Hill',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1286.2,
    imprecise: false,
    latitude: 39.93142,
    longitude: -75.02515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08002',
  },
  {
    city: 'Cherry Hill',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1117.5,
    imprecise: false,
    latitude: 39.88334,
    longitude: -74.97191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08003',
  },
  {
    city: 'Atco',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 171.3,
    imprecise: false,
    latitude: 39.75494,
    longitude: -74.83007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08004',
  },
  {
    city: 'Barnegat',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 193.8,
    imprecise: false,
    latitude: 39.75503,
    longitude: -74.30626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08005',
  },
  {
    city: 'Barnegat Light',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 232.4,
    imprecise: false,
    latitude: 39.75299,
    longitude: -74.10953,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08006',
  },
  {
    city: 'Barrington',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1556.2,
    imprecise: false,
    latitude: 39.86509,
    longitude: -75.05379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08007',
  },
  {
    city: 'Beach Haven',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 244.2,
    imprecise: false,
    latitude: 39.62188,
    longitude: -74.22421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08008',
  },
  {
    city: 'Berlin',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 335,
    imprecise: false,
    latitude: 39.76154,
    longitude: -74.93279,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08009',
  },
  {
    city: 'Beverly',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 1262,
    imprecise: false,
    latitude: 40.05484,
    longitude: -74.91407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08010',
  },
  {
    city: 'Birmingham',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 92.8,
    imprecise: false,
    latitude: 39.97504,
    longitude: -74.71371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08011',
  },
  {
    city: 'Blackwood',
    county_fips: 34007,
    county_fips_all: '34007|34015',
    county: 'Camden',
    county_names_all: 'Camden|Gloucester',
    county_weights: '{"34007": 60.13, "34015": 39.87}',
    density: 1076.3,
    imprecise: false,
    latitude: 39.78409,
    longitude: -75.05586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08012',
  },
  {
    city: 'Bridgeport',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 31.8,
    imprecise: false,
    latitude: 39.81186,
    longitude: -75.36286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08014',
  },
  {
    city: 'Browns Mills',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 134.3,
    imprecise: false,
    latitude: 39.92981,
    longitude: -74.53966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08015',
  },
  {
    city: 'Burlington',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 623.4,
    imprecise: false,
    latitude: 40.06926,
    longitude: -74.83198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08016',
  },
  {
    city: 'Chatsworth',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 39.76733,
    longitude: -74.52781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08019',
  },
  {
    city: 'Clarksboro',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 210.4,
    imprecise: false,
    latitude: 39.79674,
    longitude: -75.22271,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08020',
  },
  {
    city: 'Clementon',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1468.3,
    imprecise: false,
    latitude: 39.80604,
    longitude: -75.00025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08021',
  },
  {
    city: 'Columbus',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 166.6,
    imprecise: false,
    latitude: 40.06516,
    longitude: -74.70905,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08022',
  },
  {
    city: 'Deepwater',
    county_fips: 34033,
    county_fips_all: '34033',
    county: 'Salem',
    county_names_all: 'Salem',
    county_weights: '{"34033": 100}',
    density: 171.4,
    imprecise: false,
    latitude: 39.68825,
    longitude: -75.49761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08023',
  },
  {
    city: 'Gibbsboro',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 436.9,
    imprecise: false,
    latitude: 39.83329,
    longitude: -74.9657,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08026',
  },
  {
    city: 'Gibbstown',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 257,
    imprecise: false,
    latitude: 39.82883,
    longitude: -75.29345,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08027',
  },
  {
    city: 'Glassboro',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 668.2,
    imprecise: false,
    latitude: 39.69336,
    longitude: -75.11949,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08028',
  },
  {
    city: 'Glendora',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1960.6,
    imprecise: false,
    latitude: 39.84097,
    longitude: -75.06717,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08029',
  },
  {
    city: 'Gloucester City',
    county_fips: 34007,
    county_fips_all: '34007|34015',
    county: 'Camden',
    county_names_all: 'Camden|Gloucester',
    county_weights: '{"34007": 99.69, "34015": 0.31}',
    density: 1823,
    imprecise: false,
    latitude: 39.89023,
    longitude: -75.1178,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08030',
  },
  {
    city: 'Bellmawr',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1518.8,
    imprecise: false,
    latitude: 39.86655,
    longitude: -75.09408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08031',
  },
  {
    city: 'Grenloch',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 456.3,
    imprecise: false,
    latitude: 39.78048,
    longitude: -75.05952,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08032',
  },
  {
    city: 'Haddonfield',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1739.7,
    imprecise: false,
    latitude: 39.89332,
    longitude: -75.03723,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08033',
  },
  {
    city: 'Cherry Hill',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1366,
    imprecise: false,
    latitude: 39.90593,
    longitude: -74.99935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08034',
  },
  {
    city: 'Haddon Heights',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1849.6,
    imprecise: false,
    latitude: 39.87914,
    longitude: -75.06435,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08035',
  },
  {
    city: 'Hainesport',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 363.7,
    imprecise: false,
    latitude: 39.97669,
    longitude: -74.83708,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08036',
  },
  {
    city: 'Hammonton',
    county_fips: 34001,
    county_fips_all: '34001|34007',
    county: 'Atlantic',
    county_names_all: 'Atlantic|Camden',
    county_weights: '{"34001": 79.9, "34007": 20.1}',
    density: 74.1,
    imprecise: false,
    latitude: 39.63272,
    longitude: -74.77226,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08037',
  },
  {
    city: 'Hancocks Bridge',
    county_fips: 34033,
    county_fips_all: '34033',
    county: 'Salem',
    county_names_all: 'Salem',
    county_weights: '{"34033": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 39.47391,
    longitude: -75.48852,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08038',
  },
  {
    city: 'Harrisonville',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 39.68662,
    longitude: -75.27661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08039',
  },
  {
    city: 'Jobstown',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 22,
    imprecise: false,
    latitude: 40.03852,
    longitude: -74.68263,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08041',
  },
  {
    city: 'Juliustown',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 59.2,
    imprecise: false,
    latitude: 40.01363,
    longitude: -74.662,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08042',
  },
  {
    city: 'Voorhees',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1049.9,
    imprecise: false,
    latitude: 39.84502,
    longitude: -74.95492,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08043',
  },
  {
    city: 'Lawnside',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 885.5,
    imprecise: false,
    latitude: 39.86722,
    longitude: -75.02912,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08045',
  },
  {
    city: 'Willingboro',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 1625.1,
    imprecise: false,
    latitude: 40.02787,
    longitude: -74.88709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08046',
  },
  {
    city: 'Lumberton',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 410.1,
    imprecise: false,
    latitude: 39.95644,
    longitude: -74.80627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08048',
  },
  {
    city: 'Magnolia',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1663.8,
    imprecise: false,
    latitude: 39.85463,
    longitude: -75.03816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08049',
  },
  {
    city: 'Manahawkin',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 350.5,
    imprecise: false,
    latitude: 39.70291,
    longitude: -74.24576,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08050',
  },
  {
    city: 'Mantua',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 1251.8,
    imprecise: false,
    latitude: 39.78583,
    longitude: -75.17903,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08051',
  },
  {
    city: 'Maple Shade',
    county_fips: 34005,
    county_fips_all: '34005|34007',
    county: 'Burlington',
    county_names_all: 'Burlington|Camden',
    county_weights: '{"34005": 99.81, "34007": 0.19}',
    density: 2029,
    imprecise: false,
    latitude: 39.952,
    longitude: -74.99502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08052',
  },
  {
    city: 'Marlton',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 638,
    imprecise: false,
    latitude: 39.86051,
    longitude: -74.89469,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08053',
  },
  {
    city: 'Mount Laurel',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 818,
    imprecise: false,
    latitude: 39.94835,
    longitude: -74.90472,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08054',
  },
  {
    city: 'Medford',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 281.2,
    imprecise: false,
    latitude: 39.86373,
    longitude: -74.82249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08055',
  },
  {
    city: 'Mickleton',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 230.5,
    imprecise: false,
    latitude: 39.78355,
    longitude: -75.25155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08056',
  },
  {
    city: 'Moorestown',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 543.3,
    imprecise: false,
    latitude: 39.97948,
    longitude: -74.94105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08057',
  },
  {
    city: 'Mount Ephraim',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1823.9,
    imprecise: false,
    latitude: 39.88462,
    longitude: -75.09309,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08059',
  },
  {
    city: 'Mount Holly',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 460.9,
    imprecise: false,
    latitude: 40.00983,
    longitude: -74.79105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08060',
  },
  {
    city: 'Mount Royal',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 1312.8,
    imprecise: false,
    latitude: 39.80459,
    longitude: -75.207,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08061',
  },
  {
    city: 'Mullica Hill',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 215.2,
    imprecise: false,
    latitude: 39.71465,
    longitude: -75.22124,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08062',
  },
  {
    city: 'National Park',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 1144.5,
    imprecise: false,
    latitude: 39.86758,
    longitude: -75.18509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08063',
  },
  {
    city: 'New Lisbon',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 39.93657,
    longitude: -74.61095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08064',
  },
  {
    city: 'Palmyra',
    county_fips: 34005,
    county_fips_all: '34005|34007',
    county: 'Burlington',
    county_names_all: 'Burlington|Camden',
    county_weights: '{"34005": 99.87, "34007": 0.13}',
    density: 1562.7,
    imprecise: false,
    latitude: 40.00234,
    longitude: -75.03589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08065',
  },
  {
    city: 'Paulsboro',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 437.6,
    imprecise: false,
    latitude: 39.83475,
    longitude: -75.23017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08066',
  },
  {
    city: 'Pedricktown',
    county_fips: 34033,
    county_fips_all: '34033',
    county: 'Salem',
    county_names_all: 'Salem',
    county_weights: '{"34033": 100}',
    density: 34.7,
    imprecise: false,
    latitude: 39.7388,
    longitude: -75.41281,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08067',
  },
  {
    city: 'Pemberton',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 109.6,
    imprecise: false,
    latitude: 39.9617,
    longitude: -74.667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08068',
  },
  {
    city: 'Penns Grove',
    county_fips: 34033,
    county_fips_all: '34033',
    county: 'Salem',
    county_names_all: 'Salem',
    county_weights: '{"34033": 100}',
    density: 324.9,
    imprecise: false,
    latitude: 39.70209,
    longitude: -75.4501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08069',
  },
  {
    city: 'Pennsville',
    county_fips: 34033,
    county_fips_all: '34033',
    county: 'Salem',
    county_names_all: 'Salem',
    county_weights: '{"34033": 100}',
    density: 233.4,
    imprecise: false,
    latitude: 39.62494,
    longitude: -75.50902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08070',
  },
  {
    city: 'Pitman',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 1102,
    imprecise: false,
    latitude: 39.73227,
    longitude: -75.13457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08071',
  },
  {
    city: 'Quinton',
    county_fips: 34033,
    county_fips_all: '34033',
    county: 'Salem',
    county_names_all: 'Salem',
    county_weights: '{"34033": 100}',
    density: 178.4,
    imprecise: false,
    latitude: 39.54495,
    longitude: -75.41258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08072',
  },
  {
    city: 'Rancocas',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 89.2,
    imprecise: false,
    latitude: 40.00952,
    longitude: -74.86698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08073',
  },
  {
    city: 'Richwood',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 111.1,
    imprecise: false,
    latitude: 39.71289,
    longitude: -75.16379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08074',
  },
  {
    city: 'Riverside',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 1196.7,
    imprecise: false,
    latitude: 40.02937,
    longitude: -74.94999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08075',
  },
  {
    city: 'Riverton',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 982.1,
    imprecise: false,
    latitude: 40.00193,
    longitude: -74.99515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08077',
  },
  {
    city: 'Runnemede',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1616.7,
    imprecise: false,
    latitude: 39.85202,
    longitude: -75.07542,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08078',
  },
  {
    city: 'Salem',
    county_fips: 34033,
    county_fips_all: '34033',
    county: 'Salem',
    county_names_all: 'Salem',
    county_weights: '{"34033": 100}',
    density: 46.9,
    imprecise: false,
    latitude: 39.54284,
    longitude: -75.43184,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08079',
  },
  {
    city: 'Sewell',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 503.9,
    imprecise: false,
    latitude: 39.75714,
    longitude: -75.11801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08080',
  },
  {
    city: 'Sicklerville',
    county_fips: 34007,
    county_fips_all: '34007|34015',
    county: 'Camden',
    county_names_all: 'Camden|Gloucester',
    county_weights: '{"34007": 96.15, "34015": 3.85}',
    density: 768.8,
    imprecise: false,
    latitude: 39.73421,
    longitude: -74.97564,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08081',
  },
  {
    city: 'Somerdale',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1479.5,
    imprecise: false,
    latitude: 39.84138,
    longitude: -75.02867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08083',
  },
  {
    city: 'Stratford',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1725.5,
    imprecise: false,
    latitude: 39.82905,
    longitude: -75.01557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08084',
  },
  {
    city: 'Swedesboro',
    county_fips: 34015,
    county_fips_all: '34015|34033',
    county: 'Gloucester',
    county_names_all: 'Gloucester|Salem',
    county_weights: '{"34015": 98.85, "34033": 1.15}',
    density: 193.8,
    imprecise: false,
    latitude: 39.75579,
    longitude: -75.33017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08085',
  },
  {
    city: 'Thorofare',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 496.2,
    imprecise: false,
    latitude: 39.85136,
    longitude: -75.18582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08086',
  },
  {
    city: 'Tuckerton',
    county_fips: 34029,
    county_fips_all: '34029|34005',
    county: 'Ocean',
    county_names_all: 'Ocean|Burlington',
    county_weights: '{"34029": 59.31, "34005": 40.69}',
    density: 139.7,
    imprecise: false,
    latitude: 39.60751,
    longitude: -74.37994,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08087',
  },
  {
    city: 'Vincentown',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 62.1,
    imprecise: false,
    latitude: 39.84196,
    longitude: -74.69075,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08088',
  },
  {
    city: 'Waterford Works',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 101.2,
    imprecise: false,
    latitude: 39.71591,
    longitude: -74.82686,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08089',
  },
  {
    city: 'Wenonah',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 1296.9,
    imprecise: false,
    latitude: 39.79777,
    longitude: -75.14849,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08090',
  },
  {
    city: 'West Berlin',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 691.4,
    imprecise: false,
    latitude: 39.80545,
    longitude: -74.92558,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08091',
  },
  {
    city: 'West Creek',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 52.6,
    imprecise: false,
    latitude: 39.65438,
    longitude: -74.28428,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08092',
  },
  {
    city: 'Westville',
    county_fips: 34015,
    county_fips_all: '34015|34007',
    county: 'Gloucester',
    county_names_all: 'Gloucester|Camden',
    county_weights: '{"34015": 99.9, "34007": 0.1}',
    density: 900.4,
    imprecise: false,
    latitude: 39.86098,
    longitude: -75.13265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08093',
  },
  {
    city: 'Williamstown',
    county_fips: 34015,
    county_fips_all: '34015|34001',
    county: 'Gloucester',
    county_names_all: 'Gloucester|Atlantic',
    county_weights: '{"34015": 89.23, "34001": 10.77}',
    density: 293.2,
    imprecise: false,
    latitude: 39.65096,
    longitude: -74.96529,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08094',
  },
  {
    city: 'Winslow',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.64514,
    longitude: -74.85576,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08095',
  },
  {
    city: 'Woodbury',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 982.3,
    imprecise: false,
    latitude: 39.82921,
    longitude: -75.12871,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08096',
  },
  {
    city: 'Woodbury Heights',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 898.3,
    imprecise: false,
    latitude: 39.81571,
    longitude: -75.15117,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08097',
  },
  {
    city: 'Woodstown',
    county_fips: 34033,
    county_fips_all: '34033',
    county: 'Salem',
    county_names_all: 'Salem',
    county_weights: '{"34033": 100}',
    density: 64.6,
    imprecise: false,
    latitude: 39.63934,
    longitude: -75.3316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08098',
  },
  {
    city: 'Camden',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 3208.8,
    imprecise: false,
    latitude: 39.95203,
    longitude: -75.12134,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08102',
  },
  {
    city: 'Camden',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 2269.3,
    imprecise: false,
    latitude: 39.93533,
    longitude: -75.11275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08103',
  },
  {
    city: 'Camden',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 2853.4,
    imprecise: false,
    latitude: 39.91672,
    longitude: -75.11203,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08104',
  },
  {
    city: 'Camden',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 3941.8,
    imprecise: false,
    latitude: 39.95174,
    longitude: -75.09107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08105',
  },
  {
    city: 'Audubon',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 2309.3,
    imprecise: false,
    latitude: 39.89119,
    longitude: -75.07388,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08106',
  },
  {
    city: 'Oaklyn',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 2926.9,
    imprecise: false,
    latitude: 39.90767,
    longitude: -75.08344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08107',
  },
  {
    city: 'Collingswood',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 2675.9,
    imprecise: false,
    latitude: 39.91453,
    longitude: -75.06192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08108',
  },
  {
    city: 'Merchantville',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1923.4,
    imprecise: false,
    latitude: 39.95006,
    longitude: -75.05094,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08109',
  },
  {
    city: 'Pennsauken',
    county_fips: 34007,
    county_fips_all: '34007',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"34007": 100}',
    density: 1144.6,
    imprecise: false,
    latitude: 39.97243,
    longitude: -75.06021,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08110',
  },
  {
    city: 'Absecon',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 703.9,
    imprecise: false,
    latitude: 39.42257,
    longitude: -74.49511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08201',
  },
  {
    city: 'Avalon',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 90,
    imprecise: false,
    latitude: 39.09659,
    longitude: -74.74806,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08202',
  },
  {
    city: 'Brigantine',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 450.8,
    imprecise: false,
    latitude: 39.41281,
    longitude: -74.38006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08203',
  },
  {
    city: 'Cape May',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 312.8,
    imprecise: false,
    latitude: 38.97131,
    longitude: -74.92054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08204',
  },
  {
    city: 'Absecon',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 264.9,
    imprecise: false,
    latitude: 39.47455,
    longitude: -74.45698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08205',
  },
  {
    city: 'Cape May Court House',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 96.6,
    imprecise: false,
    latitude: 39.11974,
    longitude: -74.82248,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08210',
  },
  {
    city: 'Cape May Point',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 180.6,
    imprecise: false,
    latitude: 38.93721,
    longitude: -74.96509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08212',
  },
  {
    city: 'Egg Harbor City',
    county_fips: 34001,
    county_fips_all: '34001|34005',
    county: 'Atlantic',
    county_names_all: 'Atlantic|Burlington',
    county_weights: '{"34001": 53.96, "34005": 46.04}',
    density: 42.1,
    imprecise: false,
    latitude: 39.58962,
    longitude: -74.58716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08215',
  },
  {
    city: 'Elwood',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 736.2,
    imprecise: false,
    latitude: 39.57702,
    longitude: -74.71879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08217',
  },
  {
    city: 'Linwood',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 574.3,
    imprecise: false,
    latitude: 39.33879,
    longitude: -74.5652,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08221',
  },
  {
    city: 'Marmora',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 120.7,
    imprecise: false,
    latitude: 39.27021,
    longitude: -74.6571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08223',
  },
  {
    city: 'New Gretna',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 59.5,
    imprecise: false,
    latitude: 39.59548,
    longitude: -74.46352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08224',
  },
  {
    city: 'Northfield',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 539.5,
    imprecise: false,
    latitude: 39.36167,
    longitude: -74.53963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08225',
  },
  {
    city: 'Ocean City',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 643.9,
    imprecise: false,
    latitude: 39.26812,
    longitude: -74.60196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08226',
  },
  {
    city: 'Ocean View',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 112.7,
    imprecise: false,
    latitude: 39.20381,
    longitude: -74.70342,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08230',
  },
  {
    city: 'Pleasantville',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 1309.1,
    imprecise: false,
    latitude: 39.38771,
    longitude: -74.51489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08232',
  },
  {
    city: 'Egg Harbor Township',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 301.2,
    imprecise: false,
    latitude: 39.38662,
    longitude: -74.62369,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08234',
  },
  {
    city: 'Pomona',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 465.1,
    imprecise: false,
    latitude: 39.48676,
    longitude: -74.53633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08240',
  },
  {
    city: 'Port Republic',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 55.7,
    imprecise: false,
    latitude: 39.53278,
    longitude: -74.48523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08241',
  },
  {
    city: 'Rio Grande',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 335.9,
    imprecise: false,
    latitude: 39.01786,
    longitude: -74.88627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08242',
  },
  {
    city: 'Sea Isle City',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 350.3,
    imprecise: false,
    latitude: 39.15235,
    longitude: -74.69758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08243',
  },
  {
    city: 'Somers Point',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 835.9,
    imprecise: false,
    latitude: 39.31503,
    longitude: -74.59808,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08244',
  },
  {
    city: 'South Dennis',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 183.9,
    imprecise: false,
    latitude: 39.1765,
    longitude: -74.81902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08245',
  },
  {
    city: 'South Seaville',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 67.9,
    imprecise: false,
    latitude: 39.18098,
    longitude: -74.76583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08246',
  },
  {
    city: 'Stone Harbor',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 71.3,
    imprecise: false,
    latitude: 39.05279,
    longitude: -74.78508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08247',
  },
  {
    city: 'Strathmere',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 195.1,
    imprecise: false,
    latitude: 39.1944,
    longitude: -74.66175,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08248',
  },
  {
    city: 'Villas',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 576.6,
    imprecise: false,
    latitude: 39.02766,
    longitude: -74.92573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08251',
  },
  {
    city: 'Wildwood',
    county_fips: 34009,
    county_fips_all: '34009',
    county: 'Cape May',
    county_names_all: 'Cape May',
    county_weights: '{"34009": 100}',
    density: 313.8,
    imprecise: false,
    latitude: 38.99555,
    longitude: -74.84088,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08260',
  },
  {
    city: 'Woodbine',
    county_fips: 34009,
    county_fips_all: '34009|34001',
    county: 'Cape May',
    county_names_all: 'Cape May|Atlantic',
    county_weights: '{"34009": 77.99, "34001": 22.01}',
    density: 31.4,
    imprecise: false,
    latitude: 39.26437,
    longitude: -74.80861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08270',
  },
  {
    city: 'Bridgeton',
    county_fips: 34011,
    county_fips_all: '34011|34033',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Salem',
    county_weights: '{"34011": 90.88, "34033": 9.12}',
    density: 128,
    imprecise: false,
    latitude: 39.4397,
    longitude: -75.2616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08302',
  },
  {
    city: 'Buena',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 30.6,
    imprecise: false,
    latitude: 39.52723,
    longitude: -74.89769,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08310',
  },
  {
    city: 'Cedarville',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 24.2,
    imprecise: false,
    latitude: 39.32685,
    longitude: -75.20804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08311',
  },
  {
    city: 'Clayton',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 599.8,
    imprecise: false,
    latitude: 39.66143,
    longitude: -75.08375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08312',
  },
  {
    city: 'Delmont',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 39.21683,
    longitude: -74.94113,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08314',
  },
  {
    city: 'Dorchester',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 39.28009,
    longitude: -74.93186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08316',
  },
  {
    city: 'Dorothy',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 65.4,
    imprecise: false,
    latitude: 39.40398,
    longitude: -74.82696,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08317',
  },
  {
    city: 'Elmer',
    county_fips: 34033,
    county_fips_all: '34033|34011',
    county: 'Salem',
    county_names_all: 'Salem|Cumberland',
    county_weights: '{"34033": 94.92, "34011": 5.08}',
    density: 57.4,
    imprecise: false,
    latitude: 39.55657,
    longitude: -75.17776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08318',
  },
  {
    city: 'Estell Manor',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 30.9,
    imprecise: false,
    latitude: 39.3645,
    longitude: -74.81753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08319',
  },
  {
    city: 'Fairton',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 933.5,
    imprecise: false,
    latitude: 39.3851,
    longitude: -75.16059,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08320',
  },
  {
    city: 'Fortescue',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 39.21961,
    longitude: -75.14107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08321',
  },
  {
    city: 'Franklinville',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 135.3,
    imprecise: false,
    latitude: 39.61463,
    longitude: -75.03385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08322',
  },
  {
    city: 'Greenwich',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 39.39557,
    longitude: -75.36605,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08323',
  },
  {
    city: 'Heislerville',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 39.21859,
    longitude: -74.99999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08324',
  },
  {
    city: 'Landisville',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 174,
    imprecise: false,
    latitude: 39.53847,
    longitude: -74.92761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08326',
  },
  {
    city: 'Leesburg',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 137.3,
    imprecise: false,
    latitude: 39.25458,
    longitude: -74.94657,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08327',
  },
  {
    city: 'Malaga',
    county_fips: 34015,
    county_fips_all: '34015',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"34015": 100}',
    density: 299.4,
    imprecise: false,
    latitude: 39.5797,
    longitude: -75.06015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08328',
  },
  {
    city: 'Mauricetown',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 124.1,
    imprecise: false,
    latitude: 39.2857,
    longitude: -75.00338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08329',
  },
  {
    city: 'Mays Landing',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 90.8,
    imprecise: false,
    latitude: 39.4566,
    longitude: -74.73814,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08330',
  },
  {
    city: 'Millville',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 130.1,
    imprecise: false,
    latitude: 39.3705,
    longitude: -75.0293,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08332',
  },
  {
    city: 'Milmay',
    county_fips: 34011,
    county_fips_all: '34011|34001',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Atlantic',
    county_weights: '{"34011": 81.14, "34001": 18.86}',
    density: 10.1,
    imprecise: false,
    latitude: 39.40087,
    longitude: -74.88407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08340',
  },
  {
    city: 'Minotola',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 808.8,
    imprecise: false,
    latitude: 39.52002,
    longitude: -74.9524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08341',
  },
  {
    city: 'Monroeville',
    county_fips: 34033,
    county_fips_all: '34033|34015',
    county: 'Salem',
    county_names_all: 'Salem|Gloucester',
    county_weights: '{"34033": 51.41, "34015": 48.59}',
    density: 56.6,
    imprecise: false,
    latitude: 39.64057,
    longitude: -75.1699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08343',
  },
  {
    city: 'Newfield',
    county_fips: 34015,
    county_fips_all: '34015|34011|34001|34033',
    county: 'Gloucester',
    county_names_all: 'Gloucester|Cumberland|Atlantic|Salem',
    county_weights:
      '{"34015": 75.23, "34011": 11.74, "34001": 9.01, "34033": 4.02}',
    density: 90.4,
    imprecise: false,
    latitude: 39.56707,
    longitude: -74.99185,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08344',
  },
  {
    city: 'Newport',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 39.28816,
    longitude: -75.14668,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08345',
  },
  {
    city: 'Newtonville',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 44.8,
    imprecise: false,
    latitude: 39.56926,
    longitude: -74.85827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08346',
  },
  {
    city: 'Port Elizabeth',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 32.5,
    imprecise: false,
    latitude: 39.31381,
    longitude: -74.96594,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08348',
  },
  {
    city: 'Port Norris',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 27.3,
    imprecise: false,
    latitude: 39.266,
    longitude: -75.06337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08349',
  },
  {
    city: 'Richland',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 76.1,
    imprecise: false,
    latitude: 39.49134,
    longitude: -74.87413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08350',
  },
  {
    city: 'Rosenhayn',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 158.3,
    imprecise: false,
    latitude: 39.47545,
    longitude: -75.12724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08352',
  },
  {
    city: 'Shiloh',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 73.2,
    imprecise: false,
    latitude: 39.45954,
    longitude: -75.29695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08353',
  },
  {
    city: 'Vineland',
    county_fips: 34011,
    county_fips_all: '34011|34001|34015',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Atlantic|Gloucester',
    county_weights: '{"34011": 64.79, "34001": 25.77, "34015": 9.44}',
    density: 392.2,
    imprecise: false,
    latitude: 39.49374,
    longitude: -75.00352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08360',
  },
  {
    city: 'Vineland',
    county_fips: 34011,
    county_fips_all: '34011',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"34011": 100}',
    density: 231.8,
    imprecise: false,
    latitude: 39.44843,
    longitude: -74.95943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08361',
  },
  {
    city: 'Atlantic City',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 1407.7,
    imprecise: false,
    latitude: 39.37964,
    longitude: -74.45284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08401',
  },
  {
    city: 'Margate City',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 1430.1,
    imprecise: false,
    latitude: 39.33069,
    longitude: -74.50706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08402',
  },
  {
    city: 'Longport',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 191.6,
    imprecise: false,
    latitude: 39.31915,
    longitude: -74.53535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08403',
  },
  {
    city: 'Ventnor City',
    county_fips: 34001,
    county_fips_all: '34001',
    county: 'Atlantic',
    county_names_all: 'Atlantic',
    county_weights: '{"34001": 100}',
    density: 1753.8,
    imprecise: false,
    latitude: 39.34565,
    longitude: -74.48603,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08406',
  },
  {
    city: 'Allentown',
    county_fips: 34025,
    county_fips_all: '34025|34005|34021',
    county: 'Monmouth',
    county_names_all: 'Monmouth|Burlington|Mercer',
    county_weights: '{"34025": 86.92, "34005": 10.21, "34021": 2.87}',
    density: 90.4,
    imprecise: false,
    latitude: 40.16022,
    longitude: -74.55237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08501',
  },
  {
    city: 'Belle Mead',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 345.7,
    imprecise: false,
    latitude: 40.44815,
    longitude: -74.65763,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08502',
  },
  {
    city: 'Bordentown',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 328.7,
    imprecise: false,
    latitude: 40.10413,
    longitude: -74.73959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08505',
  },
  {
    city: 'Millstone Township',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 117.2,
    imprecise: false,
    latitude: 40.18798,
    longitude: -74.42351,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08510',
  },
  {
    city: 'Cookstown',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 157.9,
    imprecise: false,
    latitude: 40.04441,
    longitude: -74.55384,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08511',
  },
  {
    city: 'Cranbury',
    county_fips: 34023,
    county_fips_all: '34023|34021',
    county: 'Middlesex',
    county_names_all: 'Middlesex|Mercer',
    county_weights: '{"34023": 93.37, "34021": 6.63}',
    density: 218.9,
    imprecise: false,
    latitude: 40.32166,
    longitude: -74.52586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08512',
  },
  {
    city: 'Cream Ridge',
    county_fips: 34025,
    county_fips_all: '34025|34029',
    county: 'Monmouth',
    county_names_all: 'Monmouth|Ocean',
    county_weights: '{"34025": 75.37, "34029": 24.63}',
    density: 69.4,
    imprecise: false,
    latitude: 40.13269,
    longitude: -74.49811,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08514',
  },
  {
    city: 'Chesterfield',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 152.7,
    imprecise: false,
    latitude: 40.1163,
    longitude: -74.64568,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08515',
  },
  {
    city: 'Florence',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 1309.6,
    imprecise: false,
    latitude: 40.11541,
    longitude: -74.80357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08518',
  },
  {
    city: 'Hightstown',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 631.5,
    imprecise: false,
    latitude: 40.25555,
    longitude: -74.53269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08520',
  },
  {
    city: 'Hopewell',
    county_fips: 34021,
    county_fips_all: '34021|34019',
    county: 'Mercer',
    county_names_all: 'Mercer|Hunterdon',
    county_weights: '{"34021": 69.69, "34019": 30.31}',
    density: 78,
    imprecise: false,
    latitude: 40.39641,
    longitude: -74.78185,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08525',
  },
  {
    city: 'Jackson',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 266.6,
    imprecise: false,
    latitude: 40.10478,
    longitude: -74.35035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08527',
  },
  {
    city: 'Kingston',
    county_fips: 34035,
    county_fips_all: '34035|34023',
    county: 'Somerset',
    county_names_all: 'Somerset|Middlesex',
    county_weights: '{"34035": 94.84, "34023": 5.16}',
    density: 131.1,
    imprecise: false,
    latitude: 40.38791,
    longitude: -74.61744,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08528',
  },
  {
    city: 'Lambertville',
    county_fips: 34019,
    county_fips_all: '34019|34021',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon|Mercer',
    county_weights: '{"34019": 80.78, "34021": 19.22}',
    density: 115.6,
    imprecise: false,
    latitude: 40.37288,
    longitude: -74.89747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08530',
  },
  {
    city: 'New Egypt',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 53.2,
    imprecise: false,
    latitude: 40.01293,
    longitude: -74.47138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08533',
  },
  {
    city: 'Pennington',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 235.2,
    imprecise: false,
    latitude: 40.33026,
    longitude: -74.79422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08534',
  },
  {
    city: 'Millstone Township',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 103.2,
    imprecise: false,
    latitude: 40.23506,
    longitude: -74.437,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08535',
  },
  {
    city: 'Plainsboro',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1070.9,
    imprecise: false,
    latitude: 40.33392,
    longitude: -74.58488,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08536',
  },
  {
    city: 'Princeton',
    county_fips: 34021,
    county_fips_all: '34021|34035|34023',
    county: 'Mercer',
    county_names_all: 'Mercer|Somerset|Middlesex',
    county_weights: '{"34021": 62.73, "34035": 26.26, "34023": 11.01}',
    density: 376.2,
    imprecise: false,
    latitude: 40.36423,
    longitude: -74.65661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08540',
  },
  {
    city: 'Princeton',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 2538.1,
    imprecise: false,
    latitude: 40.35452,
    longitude: -74.66064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08542',
  },
  {
    city: 'Princeton Junction',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 425.1,
    imprecise: false,
    latitude: 40.28125,
    longitude: -74.61926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08550',
  },
  {
    city: 'Ringoes',
    county_fips: 34019,
    county_fips_all: '34019',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon',
    county_weights: '{"34019": 100}',
    density: 86.5,
    imprecise: false,
    latitude: 40.44425,
    longitude: -74.83907,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08551',
  },
  {
    city: 'Rocky Hill',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 517.7,
    imprecise: false,
    latitude: 40.40011,
    longitude: -74.64051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08553',
  },
  {
    city: 'Roebling',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 1134,
    imprecise: false,
    latitude: 40.11556,
    longitude: -74.77966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08554',
  },
  {
    city: 'Roosevelt',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 198.2,
    imprecise: false,
    latitude: 40.22116,
    longitude: -74.473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08555',
  },
  {
    city: 'Skillman',
    county_fips: 34035,
    county_fips_all: '34035|34021',
    county: 'Somerset',
    county_names_all: 'Somerset|Mercer',
    county_weights: '{"34035": 95.45, "34021": 4.55}',
    density: 189.4,
    imprecise: false,
    latitude: 40.41382,
    longitude: -74.70236,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08558',
  },
  {
    city: 'Stockton',
    county_fips: 34019,
    county_fips_all: '34019',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon',
    county_weights: '{"34019": 100}',
    density: 46.9,
    imprecise: false,
    latitude: 40.4387,
    longitude: -74.9716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08559',
  },
  {
    city: 'Titusville',
    county_fips: 34021,
    county_fips_all: '34021|34019',
    county: 'Mercer',
    county_names_all: 'Mercer|Hunterdon',
    county_weights: '{"34021": 98.79, "34019": 1.21}',
    density: 94,
    imprecise: false,
    latitude: 40.31453,
    longitude: -74.85946,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08560',
  },
  {
    city: 'Windsor',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 110.3,
    imprecise: false,
    latitude: 40.24659,
    longitude: -74.58138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08561',
  },
  {
    city: 'Wrightstown',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 97,
    imprecise: false,
    latitude: 40.06812,
    longitude: -74.59401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08562',
  },
  {
    city: 'Trenton',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 1527.3,
    imprecise: false,
    latitude: 40.21947,
    longitude: -74.76693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08608',
  },
  {
    city: 'Trenton',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 4674.3,
    imprecise: false,
    latitude: 40.22594,
    longitude: -74.74109,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08609',
  },
  {
    city: 'Trenton',
    county_fips: 34021,
    county_fips_all: '34021|34005',
    county: 'Mercer',
    county_names_all: 'Mercer|Burlington',
    county_weights: '{"34021": 94.37, "34005": 5.63}',
    density: 1737,
    imprecise: false,
    latitude: 40.19377,
    longitude: -74.71565,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08610',
  },
  {
    city: 'Trenton',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 4201.9,
    imprecise: false,
    latitude: 40.19107,
    longitude: -74.74299,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08611',
  },
  {
    city: 'Trenton',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 2324,
    imprecise: false,
    latitude: 40.24878,
    longitude: -74.78734,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08618',
  },
  {
    city: 'Trenton',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 932,
    imprecise: false,
    latitude: 40.2414,
    longitude: -74.69669,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08619',
  },
  {
    city: 'Trenton',
    county_fips: 34021,
    county_fips_all: '34021|34005',
    county: 'Mercer',
    county_names_all: 'Mercer|Burlington',
    county_weights: '{"34021": 87.2, "34005": 12.8}',
    density: 498,
    imprecise: false,
    latitude: 40.16825,
    longitude: -74.64956,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08620',
  },
  {
    city: 'Trenton',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 492.8,
    imprecise: false,
    latitude: 40.26705,
    longitude: -74.82235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08628',
  },
  {
    city: 'Trenton',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 6353.9,
    imprecise: false,
    latitude: 40.22066,
    longitude: -74.73127,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08629',
  },
  {
    city: 'Trenton',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 1623.2,
    imprecise: false,
    latitude: 40.25531,
    longitude: -74.76222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08638',
  },
  {
    city: 'Joint Base Mdl',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 166.5,
    imprecise: false,
    latitude: 40.0093,
    longitude: -74.58424,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08640',
  },
  {
    city: 'Joint Base Mdl',
    county_fips: 34005,
    county_fips_all: '34005',
    county: 'Burlington',
    county_names_all: 'Burlington',
    county_weights: '{"34005": 100}',
    density: 334,
    imprecise: false,
    latitude: 40.02819,
    longitude: -74.58715,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08641',
  },
  {
    city: 'Lawrence Township',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 724.8,
    imprecise: false,
    latitude: 40.28488,
    longitude: -74.72201,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08648',
  },
  {
    city: 'Trenton',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 1034.7,
    imprecise: false,
    latitude: 40.22512,
    longitude: -74.66081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08690',
  },
  {
    city: 'Robbinsville',
    county_fips: 34021,
    county_fips_all: '34021|34025',
    county: 'Mercer',
    county_names_all: 'Mercer|Monmouth',
    county_weights: '{"34021": 88.55, "34025": 11.45}',
    density: 264.6,
    imprecise: false,
    latitude: 40.20953,
    longitude: -74.59919,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08691',
  },
  {
    city: 'Lakewood',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 2172,
    imprecise: false,
    latitude: 40.07635,
    longitude: -74.20311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 139149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08701',
  },
  {
    city: 'Allenwood',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 107.6,
    imprecise: false,
    latitude: 40.14073,
    longitude: -74.11431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08720',
  },
  {
    city: 'Bayville',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 370.4,
    imprecise: false,
    latitude: 39.9071,
    longitude: -74.1846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08721',
  },
  {
    city: 'Beachwood',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 1549.4,
    imprecise: false,
    latitude: 39.92863,
    longitude: -74.20224,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08722',
  },
  {
    city: 'Brick',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 1037.6,
    imprecise: false,
    latitude: 40.03896,
    longitude: -74.11091,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08723',
  },
  {
    city: 'Brick',
    county_fips: 34029,
    county_fips_all: '34029|34025',
    county: 'Ocean',
    county_names_all: 'Ocean|Monmouth',
    county_weights: '{"34029": 93.64, "34025": 6.36}',
    density: 1184.3,
    imprecise: false,
    latitude: 40.09034,
    longitude: -74.115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08724',
  },
  {
    city: 'Brielle',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 1090,
    imprecise: false,
    latitude: 40.10483,
    longitude: -74.06366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08730',
  },
  {
    city: 'Forked River',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 106.9,
    imprecise: false,
    latitude: 39.85946,
    longitude: -74.29363,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08731',
  },
  {
    city: 'Island Heights',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 1113.9,
    imprecise: false,
    latitude: 39.94177,
    longitude: -74.14497,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08732',
  },
  {
    city: 'Lakehurst',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 88.5,
    imprecise: false,
    latitude: 40.0262,
    longitude: -74.3713,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08733',
  },
  {
    city: 'Lanoka Harbor',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 594.2,
    imprecise: false,
    latitude: 39.86331,
    longitude: -74.16608,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08734',
  },
  {
    city: 'Lavallette',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 767.7,
    imprecise: false,
    latitude: 39.98288,
    longitude: -74.08121,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08735',
  },
  {
    city: 'Manasquan',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 1082.7,
    imprecise: false,
    latitude: 40.12028,
    longitude: -74.06862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08736',
  },
  {
    city: 'Mantoloking',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 547.1,
    imprecise: false,
    latitude: 40.02101,
    longitude: -74.06282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08738',
  },
  {
    city: 'Ocean Gate',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 1372.2,
    imprecise: false,
    latitude: 39.93006,
    longitude: -74.12811,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08740',
  },
  {
    city: 'Pine Beach',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 1109.3,
    imprecise: false,
    latitude: 39.93632,
    longitude: -74.16779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08741',
  },
  {
    city: 'Point Pleasant Beach',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 1770.6,
    imprecise: false,
    latitude: 40.08076,
    longitude: -74.06213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08742',
  },
  {
    city: 'Sea Girt',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 707.8,
    imprecise: false,
    latitude: 40.13389,
    longitude: -74.0444,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08750',
  },
  {
    city: 'Seaside Heights',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 1233.5,
    imprecise: false,
    latitude: 39.95012,
    longitude: -74.08147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08751',
  },
  {
    city: 'Seaside Park',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 189.4,
    imprecise: false,
    latitude: 39.85233,
    longitude: -74.0963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08752',
  },
  {
    city: 'Toms River',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 1096.3,
    imprecise: false,
    latitude: 39.98091,
    longitude: -74.15055,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08753',
  },
  {
    city: 'Toms River',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 715.5,
    imprecise: false,
    latitude: 40.00968,
    longitude: -74.22457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08755',
  },
  {
    city: 'Toms River',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 783.5,
    imprecise: false,
    latitude: 39.96061,
    longitude: -74.25884,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08757',
  },
  {
    city: 'Waretown',
    county_fips: 34029,
    county_fips_all: '34029',
    county: 'Ocean',
    county_names_all: 'Ocean',
    county_weights: '{"34029": 100}',
    density: 168.2,
    imprecise: false,
    latitude: 39.79529,
    longitude: -74.25296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08758',
  },
  {
    city: 'Manchester Township',
    county_fips: 34029,
    county_fips_all: '34029|34005',
    county: 'Ocean',
    county_names_all: 'Ocean|Burlington',
    county_weights: '{"34029": 97.76, "34005": 2.24}',
    density: 215.5,
    imprecise: false,
    latitude: 39.96239,
    longitude: -74.35902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08759',
  },
  {
    city: 'Annandale',
    county_fips: 34019,
    county_fips_all: '34019',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon',
    county_weights: '{"34019": 100}',
    density: 186.8,
    imprecise: false,
    latitude: 40.62774,
    longitude: -74.88655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08801',
  },
  {
    city: 'Asbury',
    county_fips: 34019,
    county_fips_all: '34019|34041',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon|Warren',
    county_weights: '{"34019": 57.93, "34041": 42.07}',
    density: 71.8,
    imprecise: false,
    latitude: 40.6783,
    longitude: -75.02515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08802',
  },
  {
    city: 'Bloomsbury',
    county_fips: 34019,
    county_fips_all: '34019|34041',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon|Warren',
    county_weights: '{"34019": 60.14, "34041": 39.86}',
    density: 95.1,
    imprecise: false,
    latitude: 40.64412,
    longitude: -75.09936,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08804',
  },
  {
    city: 'Bound Brook',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 1847.5,
    imprecise: false,
    latitude: 40.57165,
    longitude: -74.53783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08805',
  },
  {
    city: 'Bridgewater',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 599.4,
    imprecise: false,
    latitude: 40.59241,
    longitude: -74.6202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08807',
  },
  {
    city: 'Clinton',
    county_fips: 34019,
    county_fips_all: '34019',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon',
    county_weights: '{"34019": 100}',
    density: 373.7,
    imprecise: false,
    latitude: 40.64973,
    longitude: -74.92503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08809',
  },
  {
    city: 'Dayton',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 556.6,
    imprecise: false,
    latitude: 40.37073,
    longitude: -74.49641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08810',
  },
  {
    city: 'Dunellen',
    county_fips: 34035,
    county_fips_all: '34035|34023|34039',
    county: 'Somerset',
    county_names_all: 'Somerset|Middlesex|Union',
    county_weights: '{"34035": 77.76, "34023": 21.1, "34039": 1.14}',
    density: 1081.4,
    imprecise: false,
    latitude: 40.5999,
    longitude: -74.47979,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08812',
  },
  {
    city: 'East Brunswick',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 941.8,
    imprecise: false,
    latitude: 40.42943,
    longitude: -74.41602,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08816',
  },
  {
    city: 'Edison',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1783,
    imprecise: false,
    latitude: 40.51559,
    longitude: -74.3939,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08817',
  },
  {
    city: 'Edison',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1479.8,
    imprecise: false,
    latitude: 40.57725,
    longitude: -74.36599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08820',
  },
  {
    city: 'Flagtown',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 459.6,
    imprecise: false,
    latitude: 40.52074,
    longitude: -74.68835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08821',
  },
  {
    city: 'Flemington',
    county_fips: 34019,
    county_fips_all: '34019',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon',
    county_weights: '{"34019": 100}',
    density: 194.2,
    imprecise: false,
    latitude: 40.52281,
    longitude: -74.86576,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08822',
  },
  {
    city: 'Franklin Park',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 993.7,
    imprecise: false,
    latitude: 40.44218,
    longitude: -74.56318,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08823',
  },
  {
    city: 'Kendall Park',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1190.3,
    imprecise: false,
    latitude: 40.42058,
    longitude: -74.5538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08824',
  },
  {
    city: 'Frenchtown',
    county_fips: 34019,
    county_fips_all: '34019',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon',
    county_weights: '{"34019": 100}',
    density: 63.1,
    imprecise: false,
    latitude: 40.51353,
    longitude: -75.02341,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08825',
  },
  {
    city: 'Glen Gardner',
    county_fips: 34019,
    county_fips_all: '34019',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon',
    county_weights: '{"34019": 100}',
    density: 98.7,
    imprecise: false,
    latitude: 40.71912,
    longitude: -74.90527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08826',
  },
  {
    city: 'Hampton',
    county_fips: 34019,
    county_fips_all: '34019|34041',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon|Warren',
    county_weights: '{"34019": 90.27, "34041": 9.73}',
    density: 92.7,
    imprecise: false,
    latitude: 40.66775,
    longitude: -74.97351,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08827',
  },
  {
    city: 'Helmetta',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1146.2,
    imprecise: false,
    latitude: 40.37767,
    longitude: -74.42383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08828',
  },
  {
    city: 'High Bridge',
    county_fips: 34019,
    county_fips_all: '34019',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon',
    county_weights: '{"34019": 100}',
    density: 573.6,
    imprecise: false,
    latitude: 40.66828,
    longitude: -74.89414,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08829',
  },
  {
    city: 'Iselin',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 2387.4,
    imprecise: false,
    latitude: 40.56964,
    longitude: -74.31719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08830',
  },
  {
    city: 'Monroe Township',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 418.9,
    imprecise: false,
    latitude: 40.32908,
    longitude: -74.43066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08831',
  },
  {
    city: 'Keasbey',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 400.1,
    imprecise: false,
    latitude: 40.51138,
    longitude: -74.31387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08832',
  },
  {
    city: 'Lebanon',
    county_fips: 34019,
    county_fips_all: '34019',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon',
    county_weights: '{"34019": 100}',
    density: 101.7,
    imprecise: false,
    latitude: 40.645,
    longitude: -74.81989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08833',
  },
  {
    city: 'Manville',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 1871.3,
    imprecise: false,
    latitude: 40.54147,
    longitude: -74.58876,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08835',
  },
  {
    city: 'Martinsville',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 331,
    imprecise: false,
    latitude: 40.59705,
    longitude: -74.55446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08836',
  },
  {
    city: 'Edison',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 821.4,
    imprecise: false,
    latitude: 40.51432,
    longitude: -74.34477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08837',
  },
  {
    city: 'Metuchen',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 2191.5,
    imprecise: false,
    latitude: 40.54361,
    longitude: -74.35856,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08840',
  },
  {
    city: 'Hillsborough',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 311.2,
    imprecise: false,
    latitude: 40.49858,
    longitude: -74.67274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08844',
  },
  {
    city: 'Middlesex',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1621,
    imprecise: false,
    latitude: 40.57439,
    longitude: -74.5011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08846',
  },
  {
    city: 'Milford',
    county_fips: 34019,
    county_fips_all: '34019',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon',
    county_weights: '{"34019": 100}',
    density: 96,
    imprecise: false,
    latitude: 40.59386,
    longitude: -75.09569,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08848',
  },
  {
    city: 'Milltown',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1430.1,
    imprecise: false,
    latitude: 40.44826,
    longitude: -74.43994,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08850',
  },
  {
    city: 'Monmouth Junction',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 523.2,
    imprecise: false,
    latitude: 40.38978,
    longitude: -74.54461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08852',
  },
  {
    city: 'Neshanic Station',
    county_fips: 34035,
    county_fips_all: '34035|34019',
    county: 'Somerset',
    county_names_all: 'Somerset|Hunterdon',
    county_weights: '{"34035": 76.07, "34019": 23.93}',
    density: 191.1,
    imprecise: false,
    latitude: 40.52879,
    longitude: -74.74246,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08853',
  },
  {
    city: 'Piscataway',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1246.1,
    imprecise: false,
    latitude: 40.54648,
    longitude: -74.46342,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 61088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08854',
  },
  {
    city: 'Old Bridge',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 656.5,
    imprecise: false,
    latitude: 40.39188,
    longitude: -74.33059,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08857',
  },
  {
    city: 'Oldwick',
    county_fips: 34019,
    county_fips_all: '34019',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon',
    county_weights: '{"34019": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 40.67903,
    longitude: -74.73748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08858',
  },
  {
    city: 'Parlin',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 2066,
    imprecise: false,
    latitude: 40.45897,
    longitude: -74.30401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08859',
  },
  {
    city: 'Perth Amboy',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 4494.1,
    imprecise: false,
    latitude: 40.52087,
    longitude: -74.27397,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08861',
  },
  {
    city: 'Fords',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 2880.3,
    imprecise: false,
    latitude: 40.53733,
    longitude: -74.31216,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08863',
  },
  {
    city: 'Phillipsburg',
    county_fips: 34041,
    county_fips_all: '34041',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"34041": 100}',
    density: 292.6,
    imprecise: false,
    latitude: 40.7094,
    longitude: -75.15109,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08865',
  },
  {
    city: 'Pittstown',
    county_fips: 34019,
    county_fips_all: '34019',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon',
    county_weights: '{"34019": 100}',
    density: 70.9,
    imprecise: false,
    latitude: 40.57513,
    longitude: -74.96777,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08867',
  },
  {
    city: 'Raritan',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 1622.1,
    imprecise: false,
    latitude: 40.57316,
    longitude: -74.64305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08869',
  },
  {
    city: 'Sayreville',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 824.5,
    imprecise: false,
    latitude: 40.46482,
    longitude: -74.34002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08872',
  },
  {
    city: 'Somerset',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 676.8,
    imprecise: false,
    latitude: 40.49865,
    longitude: -74.53284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08873',
  },
  {
    city: 'Somerville',
    county_fips: 34035,
    county_fips_all: '34035|34019',
    county: 'Somerset',
    county_names_all: 'Somerset|Hunterdon',
    county_weights: '{"34035": 85.92, "34019": 14.08}',
    density: 564.2,
    imprecise: false,
    latitude: 40.58925,
    longitude: -74.68871,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08876',
  },
  {
    city: 'South Amboy',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1284.3,
    imprecise: false,
    latitude: 40.46532,
    longitude: -74.27691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08879',
  },
  {
    city: 'South Bound Brook',
    county_fips: 34035,
    county_fips_all: '34035|34023',
    county: 'Somerset',
    county_names_all: 'Somerset|Middlesex',
    county_weights: '{"34035": 99.84, "34023": 0.16}',
    density: 2909.8,
    imprecise: false,
    latitude: 40.55354,
    longitude: -74.52771,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08880',
  },
  {
    city: 'South River',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 2223.3,
    imprecise: false,
    latitude: 40.44556,
    longitude: -74.37842,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08882',
  },
  {
    city: 'Spotswood',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1368.2,
    imprecise: false,
    latitude: 40.39493,
    longitude: -74.39196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08884',
  },
  {
    city: 'Stewartsville',
    county_fips: 34041,
    county_fips_all: '34041',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"34041": 100}',
    density: 160.7,
    imprecise: false,
    latitude: 40.69302,
    longitude: -75.10565,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08886',
  },
  {
    city: 'Three Bridges',
    county_fips: 34019,
    county_fips_all: '34019',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon',
    county_weights: '{"34019": 100}',
    density: 657.3,
    imprecise: false,
    latitude: 40.52219,
    longitude: -74.79428,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08887',
  },
  {
    city: 'Whitehouse Station',
    county_fips: 34019,
    county_fips_all: '34019',
    county: 'Hunterdon',
    county_names_all: 'Hunterdon',
    county_weights: '{"34019": 100}',
    density: 170.7,
    imprecise: false,
    latitude: 40.60744,
    longitude: -74.75936,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08889',
  },
  {
    city: 'Zarephath',
    county_fips: 34035,
    county_fips_all: '34035',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"34035": 100}',
    density: 37.6,
    imprecise: false,
    latitude: 40.53877,
    longitude: -74.57531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08890',
  },
  {
    city: 'New Brunswick',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 3528.1,
    imprecise: false,
    latitude: 40.48426,
    longitude: -74.44275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08901',
  },
  {
    city: 'North Brunswick',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 1287.9,
    imprecise: false,
    latitude: 40.44236,
    longitude: -74.48579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08902',
  },
  {
    city: 'Highland Park',
    county_fips: 34023,
    county_fips_all: '34023',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"34023": 100}',
    density: 3205.9,
    imprecise: false,
    latitude: 40.50057,
    longitude: -74.42832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08904',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 18884.2,
    imprecise: false,
    latitude: 40.75064,
    longitude: -73.99728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10001',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 36095.2,
    imprecise: false,
    latitude: 40.71597,
    longitude: -73.98692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 76873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10002',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 36178.3,
    imprecise: false,
    latitude: 40.73184,
    longitude: -73.98915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10003',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 3145.1,
    imprecise: false,
    latitude: 40.69431,
    longitude: -74.01835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10004',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 50014,
    imprecise: false,
    latitude: 40.70614,
    longitude: -74.00862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10005',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 16342.8,
    imprecise: false,
    latitude: 40.70949,
    longitude: -74.01306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10006',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 17883.3,
    imprecise: false,
    latitude: 40.71387,
    longitude: -74.00792,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10007',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 37694.1,
    imprecise: false,
    latitude: 40.72639,
    longitude: -73.97865,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10009',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 32146,
    imprecise: false,
    latitude: 40.73899,
    longitude: -73.98243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10010',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 28785,
    imprecise: false,
    latitude: 40.74173,
    longitude: -74.00037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10011',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 25536.6,
    imprecise: false,
    latitude: 40.7256,
    longitude: -73.99794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10012',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 19305.4,
    imprecise: false,
    latitude: 40.72001,
    longitude: -74.00472,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10013',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 23275.1,
    imprecise: false,
    latitude: 40.73407,
    longitude: -74.00601,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10014',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 37200.4,
    imprecise: false,
    latitude: 40.74515,
    longitude: -73.97807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10016',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 19826.4,
    imprecise: false,
    latitude: 40.75235,
    longitude: -73.9726,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10017',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 9605.6,
    imprecise: false,
    latitude: 40.75536,
    longitude: -73.99265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10018',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 26335.7,
    imprecise: false,
    latitude: 40.76586,
    longitude: -73.9853,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10019',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75917,
    longitude: -73.98071,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10020',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 43171.3,
    imprecise: false,
    latitude: 40.76963,
    longitude: -73.95899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10021',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 29648.5,
    imprecise: false,
    latitude: 40.75856,
    longitude: -73.96787,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10022',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 27666.6,
    imprecise: false,
    latitude: 40.77464,
    longitude: -73.97836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10023',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 27530.1,
    imprecise: false,
    latitude: 40.78534,
    longitude: -73.97138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10024',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 40425.6,
    imprecise: false,
    latitude: 40.79825,
    longitude: -73.96831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 93065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10025',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 37395,
    imprecise: false,
    latitude: 40.80302,
    longitude: -73.95348,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10026',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 26172.6,
    imprecise: false,
    latitude: 40.81187,
    longitude: -73.95459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10027',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 59855.6,
    imprecise: false,
    latitude: 40.77643,
    longitude: -73.95339,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10028',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 25927,
    imprecise: false,
    latitude: 40.79265,
    longitude: -73.94788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 77447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10029',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 40797.3,
    imprecise: false,
    latitude: 40.81826,
    longitude: -73.94283,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10030',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 35231.2,
    imprecise: false,
    latitude: 40.82485,
    longitude: -73.95023,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 61058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10031',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 31920.5,
    imprecise: false,
    latitude: 40.839,
    longitude: -73.94282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10032',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 35498.4,
    imprecise: false,
    latitude: 40.84744,
    longitude: -73.93549,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10033',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 14258.2,
    imprecise: false,
    latitude: 40.86749,
    longitude: -73.92358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10034',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 10682.1,
    imprecise: false,
    latitude: 40.79538,
    longitude: -73.92965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10035',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 26793.5,
    imprecise: false,
    latitude: 40.75976,
    longitude: -73.99064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10036',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 31561.4,
    imprecise: false,
    latitude: 40.81302,
    longitude: -73.93776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10037',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 29743,
    imprecise: false,
    latitude: 40.70914,
    longitude: -74.00298,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10038',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 41932.6,
    imprecise: false,
    latitude: 40.82631,
    longitude: -73.93752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10039',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 27303.6,
    imprecise: false,
    latitude: 40.85807,
    longitude: -73.9296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10040',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 19332.8,
    imprecise: false,
    latitude: 40.76209,
    longitude: -73.94981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10044',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 28383.5,
    imprecise: false,
    latitude: 40.76472,
    longitude: -73.96332,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10065',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 61291.8,
    imprecise: false,
    latitude: 40.77752,
    longitude: -73.98875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10069',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 44727.5,
    imprecise: false,
    latitude: 40.77342,
    longitude: -73.95642,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10075',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75953,
    longitude: -73.97858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10111',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75891,
    longitude: -73.97904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10112',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75064,
    longitude: -73.99273,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10119',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 49419.5,
    imprecise: false,
    latitude: 40.78151,
    longitude: -73.95018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10128',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.76362,
    longitude: -73.97244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10153',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 48361.8,
    imprecise: false,
    latitude: 40.76936,
    longitude: -73.94986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10162',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75213,
    longitude: -73.97872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10165',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75145,
    longitude: -73.9771,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10168',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75467,
    longitude: -73.97643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10169',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75263,
    longitude: -73.97588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10170',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75144,
    longitude: -73.975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10174',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 32303.7,
    imprecise: false,
    latitude: 40.70985,
    longitude: -74.01651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10280',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 33101.5,
    imprecise: false,
    latitude: 40.71655,
    longitude: -74.01495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10282',
  },
  {
    city: 'Staten Island',
    county_fips: 36085,
    county_fips_all: '36085',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"36085": 100}',
    density: 4218.1,
    imprecise: false,
    latitude: 40.62803,
    longitude: -74.09564,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10301',
  },
  {
    city: 'Staten Island',
    county_fips: 36085,
    county_fips_all: '36085',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"36085": 100}',
    density: 6157.7,
    imprecise: false,
    latitude: 40.63055,
    longitude: -74.13776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10302',
  },
  {
    city: 'Staten Island',
    county_fips: 36085,
    county_fips_all: '36085',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"36085": 100}',
    density: 3228.1,
    imprecise: false,
    latitude: 40.63223,
    longitude: -74.16903,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10303',
  },
  {
    city: 'Staten Island',
    county_fips: 36085,
    county_fips_all: '36085',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"36085": 100}',
    density: 5050.1,
    imprecise: false,
    latitude: 40.60671,
    longitude: -74.0931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10304',
  },
  {
    city: 'Staten Island',
    county_fips: 36085,
    county_fips_all: '36085',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"36085": 100}',
    density: 3964,
    imprecise: false,
    latitude: 40.59592,
    longitude: -74.07539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10305',
  },
  {
    city: 'Staten Island',
    county_fips: 36085,
    county_fips_all: '36085',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"36085": 100}',
    density: 3067.3,
    imprecise: false,
    latitude: 40.57149,
    longitude: -74.1243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10306',
  },
  {
    city: 'Staten Island',
    county_fips: 36085,
    county_fips_all: '36085',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"36085": 100}',
    density: 3711.7,
    imprecise: false,
    latitude: 40.50817,
    longitude: -74.24254,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10307',
  },
  {
    city: 'Staten Island',
    county_fips: 36085,
    county_fips_all: '36085',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"36085": 100}',
    density: 5400.7,
    imprecise: false,
    latitude: 40.55213,
    longitude: -74.15029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10308',
  },
  {
    city: 'Staten Island',
    county_fips: 36085,
    county_fips_all: '36085',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"36085": 100}',
    density: 1856.8,
    imprecise: false,
    latitude: 40.53001,
    longitude: -74.21912,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10309',
  },
  {
    city: 'Staten Island',
    county_fips: 36085,
    county_fips_all: '36085',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"36085": 100}',
    density: 5499.3,
    imprecise: false,
    latitude: 40.63243,
    longitude: -74.11653,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10310',
  },
  {
    city: 'Staten Island',
    county_fips: 36085,
    county_fips_all: '36085',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"36085": 100}',
    density: 3566.2,
    imprecise: false,
    latitude: 40.54489,
    longitude: -74.18084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10312',
  },
  {
    city: 'Staten Island',
    county_fips: 36085,
    county_fips_all: '36085',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"36085": 100}',
    density: 2790,
    imprecise: false,
    latitude: 40.60086,
    longitude: -74.16306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 93915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10314',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 18622.3,
    imprecise: false,
    latitude: 40.82097,
    longitude: -73.92383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10451',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005|36061',
    county: 'Bronx',
    county_names_all: 'Bronx|New York',
    county_weights: '{"36005": 99.79, "36061": 0.21}',
    density: 29750.1,
    imprecise: false,
    latitude: 40.8378,
    longitude: -73.92333,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 75682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10452',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 32680,
    imprecise: false,
    latitude: 40.85248,
    longitude: -73.9133,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 76282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10453',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 14412.4,
    imprecise: false,
    latitude: 40.8056,
    longitude: -73.91664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10454',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 24665.1,
    imprecise: false,
    latitude: 40.8148,
    longitude: -73.90862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10455',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 31397.9,
    imprecise: false,
    latitude: 40.83064,
    longitude: -73.90812,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 87533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10456',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 23289.4,
    imprecise: false,
    latitude: 40.84571,
    longitude: -73.89794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 79543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10457',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 23685,
    imprecise: false,
    latitude: 40.86249,
    longitude: -73.88643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 74898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10458',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 22408.7,
    imprecise: false,
    latitude: 40.82572,
    longitude: -73.89295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10459',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 15302.3,
    imprecise: false,
    latitude: 40.84273,
    longitude: -73.87891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10460',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 8408.9,
    imprecise: false,
    latitude: 40.84671,
    longitude: -73.84079,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10461',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 19677.7,
    imprecise: false,
    latitude: 40.84297,
    longitude: -73.85873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 76320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10462',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005|36061',
    county: 'Bronx',
    county_names_all: 'Bronx|New York',
    county_weights: '{"36005": 96.0, "36061": 4.0}',
    density: 9743.6,
    imprecise: false,
    latitude: 40.88841,
    longitude: -73.89905,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10463',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 484,
    imprecise: false,
    latitude: 40.86821,
    longitude: -73.80044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10464',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 4471.6,
    imprecise: false,
    latitude: 40.8286,
    longitude: -73.82179,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10465',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 13626.4,
    imprecise: false,
    latitude: 40.89104,
    longitude: -73.8461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10466',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 15974.1,
    imprecise: false,
    latitude: 40.87522,
    longitude: -73.872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 96421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10467',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 27885.2,
    imprecise: false,
    latitude: 40.8681,
    longitude: -73.89985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 75557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10468',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 10906.4,
    imprecise: false,
    latitude: 40.86851,
    longitude: -73.84666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10469',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005|36119',
    county: 'Bronx',
    county_names_all: 'Bronx|Westchester',
    county_weights: '{"36005": 98.47, "36119": 1.53}',
    density: 4303.7,
    imprecise: false,
    latitude: 40.89598,
    longitude: -73.86805,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10470',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 5363.7,
    imprecise: false,
    latitude: 40.90002,
    longitude: -73.9067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10471',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 22935.4,
    imprecise: false,
    latitude: 40.82968,
    longitude: -73.86942,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10472',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 10629.1,
    imprecise: false,
    latitude: 40.81817,
    longitude: -73.85889,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10473',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 2836.6,
    imprecise: false,
    latitude: 40.81061,
    longitude: -73.8846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10474',
  },
  {
    city: 'Bronx',
    county_fips: 36005,
    county_fips_all: '36005',
    county: 'Bronx',
    county_names_all: 'Bronx',
    county_weights: '{"36005": 100}',
    density: 13229.1,
    imprecise: false,
    latitude: 40.87528,
    longitude: -73.82702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10475',
  },
  {
    city: 'Amawalk',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 418.8,
    imprecise: false,
    latitude: 41.2954,
    longitude: -73.76006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10501',
  },
  {
    city: 'Ardsley',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 1148.2,
    imprecise: false,
    latitude: 41.01126,
    longitude: -73.8409,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10502',
  },
  {
    city: 'Ardsley On Hudson',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 3428.8,
    imprecise: false,
    latitude: 41.02654,
    longitude: -73.8753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10503',
  },
  {
    city: 'Armonk',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 183.5,
    imprecise: false,
    latitude: 41.13065,
    longitude: -73.70629,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10504',
  },
  {
    city: 'Baldwin Place',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 557.5,
    imprecise: false,
    latitude: 41.34207,
    longitude: -73.74791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10505',
  },
  {
    city: 'Bedford',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 144.9,
    imprecise: false,
    latitude: 41.1889,
    longitude: -73.63411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10506',
  },
  {
    city: 'Bedford Hills',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 317.5,
    imprecise: false,
    latitude: 41.22879,
    longitude: -73.6878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10507',
  },
  {
    city: 'Brewster',
    county_fips: 36079,
    county_fips_all: '36079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"36079": 100}',
    density: 214.5,
    imprecise: false,
    latitude: 41.41205,
    longitude: -73.5937,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10509',
  },
  {
    city: 'Briarcliff Manor',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 390.8,
    imprecise: false,
    latitude: 41.14152,
    longitude: -73.83411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10510',
  },
  {
    city: 'Buchanan',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 615.6,
    imprecise: false,
    latitude: 41.26302,
    longitude: -73.94391,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10511',
  },
  {
    city: 'Carmel',
    county_fips: 36079,
    county_fips_all: '36079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"36079": 100}',
    density: 179.3,
    imprecise: false,
    latitude: 41.4483,
    longitude: -73.71054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10512',
  },
  {
    city: 'Chappaqua',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 357.8,
    imprecise: false,
    latitude: 41.17331,
    longitude: -73.77071,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10514',
  },
  {
    city: 'Cold Spring',
    county_fips: 36079,
    county_fips_all: '36079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"36079": 100}',
    density: 65.8,
    imprecise: false,
    latitude: 41.45342,
    longitude: -73.90233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10516',
  },
  {
    city: 'Crompond',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 640.9,
    imprecise: false,
    latitude: 41.29837,
    longitude: -73.86013,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10517',
  },
  {
    city: 'Cross River',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 100.5,
    imprecise: false,
    latitude: 41.26787,
    longitude: -73.60073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10518',
  },
  {
    city: 'Croton Falls',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 153,
    imprecise: false,
    latitude: 41.34701,
    longitude: -73.66196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10519',
  },
  {
    city: 'Croton On Hudson',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 330.5,
    imprecise: false,
    latitude: 41.22183,
    longitude: -73.87348,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10520',
  },
  {
    city: 'Dobbs Ferry',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 1817.4,
    imprecise: false,
    latitude: 41.01221,
    longitude: -73.8646,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10522',
  },
  {
    city: 'Elmsford',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 1000.8,
    imprecise: false,
    latitude: 41.06005,
    longitude: -73.81859,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10523',
  },
  {
    city: 'Garrison',
    county_fips: 36079,
    county_fips_all: '36079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"36079": 100}',
    density: 84.8,
    imprecise: false,
    latitude: 41.37076,
    longitude: -73.92201,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10524',
  },
  {
    city: 'Goldens Bridge',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 231.6,
    imprecise: false,
    latitude: 41.29388,
    longitude: -73.66171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10526',
  },
  {
    city: 'Granite Springs',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 72.2,
    imprecise: false,
    latitude: 41.3195,
    longitude: -73.76502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10527',
  },
  {
    city: 'Harrison',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 1439.7,
    imprecise: false,
    latitude: 40.97819,
    longitude: -73.72306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10528',
  },
  {
    city: 'Hartsdale',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 1370.3,
    imprecise: false,
    latitude: 41.02304,
    longitude: -73.80764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10530',
  },
  {
    city: 'Hawthorne',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 882.4,
    imprecise: false,
    latitude: 41.09873,
    longitude: -73.80066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10532',
  },
  {
    city: 'Irvington',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 799.4,
    imprecise: false,
    latitude: 41.03826,
    longitude: -73.8556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10533',
  },
  {
    city: 'Jefferson Valley',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 332.7,
    imprecise: false,
    latitude: 41.33536,
    longitude: -73.79965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10535',
  },
  {
    city: 'Katonah',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 154.8,
    imprecise: false,
    latitude: 41.26971,
    longitude: -73.68943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10536',
  },
  {
    city: 'Lake Peekskill',
    county_fips: 36079,
    county_fips_all: '36079|36119',
    county: 'Putnam',
    county_names_all: 'Putnam|Westchester',
    county_weights: '{"36079": 81.63, "36119": 18.37}',
    density: 877.8,
    imprecise: false,
    latitude: 41.33784,
    longitude: -73.88528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10537',
  },
  {
    city: 'Larchmont',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 1951.4,
    imprecise: false,
    latitude: 40.9376,
    longitude: -73.75707,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10538',
  },
  {
    city: 'Lincolndale',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 77.4,
    imprecise: false,
    latitude: 41.32575,
    longitude: -73.72745,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10540',
  },
  {
    city: 'Mahopac',
    county_fips: 36079,
    county_fips_all: '36079|36119',
    county: 'Putnam',
    county_names_all: 'Putnam|Westchester',
    county_weights: '{"36079": 96.16, "36119": 3.84}',
    density: 411,
    imprecise: false,
    latitude: 41.37855,
    longitude: -73.75122,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10541',
  },
  {
    city: 'Mahopac Falls',
    county_fips: 36079,
    county_fips_all: '36079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"36079": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.37115,
    longitude: -73.76436,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10542',
  },
  {
    city: 'Mamaroneck',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 1892,
    imprecise: false,
    latitude: 40.95274,
    longitude: -73.73645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10543',
  },
  {
    city: 'Maryknoll',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 571.2,
    imprecise: false,
    latitude: 41.17861,
    longitude: -73.83547,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10545',
  },
  {
    city: 'Millwood',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 445.7,
    imprecise: false,
    latitude: 41.19472,
    longitude: -73.8002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10546',
  },
  {
    city: 'Mohegan Lake',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 567.9,
    imprecise: false,
    latitude: 41.31178,
    longitude: -73.84637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10547',
  },
  {
    city: 'Montrose',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 796.6,
    imprecise: false,
    latitude: 41.24599,
    longitude: -73.93643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10548',
  },
  {
    city: 'Mount Kisco',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 326.3,
    imprecise: false,
    latitude: 41.19981,
    longitude: -73.72028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10549',
  },
  {
    city: 'Mount Vernon',
    county_fips: 36119,
    county_fips_all: '36119|36005',
    county: 'Westchester',
    county_names_all: 'Westchester|Bronx',
    county_weights: '{"36119": 99.49, "36005": 0.51}',
    density: 7568.2,
    imprecise: false,
    latitude: 40.90627,
    longitude: -73.8351,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10550',
  },
  {
    city: 'Mount Vernon',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 5226.7,
    imprecise: false,
    latitude: 40.92376,
    longitude: -73.82497,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10552',
  },
  {
    city: 'Mount Vernon',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 6090.4,
    imprecise: false,
    latitude: 40.90858,
    longitude: -73.82161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10553',
  },
  {
    city: 'North Salem',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 90.8,
    imprecise: false,
    latitude: 41.33303,
    longitude: -73.60264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10560',
  },
  {
    city: 'Ossining',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 965.5,
    imprecise: false,
    latitude: 41.19295,
    longitude: -73.8305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10562',
  },
  {
    city: 'Peekskill',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 2278.7,
    imprecise: false,
    latitude: 41.28924,
    longitude: -73.91837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10566',
  },
  {
    city: 'Cortlandt Manor',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 342.5,
    imprecise: false,
    latitude: 41.28922,
    longitude: -73.89633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10567',
  },
  {
    city: 'Pleasantville',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 720.6,
    imprecise: false,
    latitude: 41.12854,
    longitude: -73.78917,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10570',
  },
  {
    city: 'Port Chester',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 2879.9,
    imprecise: false,
    latitude: 41.01676,
    longitude: -73.67735,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10573',
  },
  {
    city: 'Pound Ridge',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 84.3,
    imprecise: false,
    latitude: 41.21323,
    longitude: -73.57289,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10576',
  },
  {
    city: 'Purchase',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 346.2,
    imprecise: false,
    latitude: 41.03755,
    longitude: -73.71349,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10577',
  },
  {
    city: 'Purdys',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 390.6,
    imprecise: false,
    latitude: 41.31815,
    longitude: -73.673,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10578',
  },
  {
    city: 'Putnam Valley',
    county_fips: 36079,
    county_fips_all: '36079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"36079": 100}',
    density: 100.3,
    imprecise: false,
    latitude: 41.39651,
    longitude: -73.83384,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10579',
  },
  {
    city: 'Rye',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 850.1,
    imprecise: false,
    latitude: 40.97854,
    longitude: -73.69258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10580',
  },
  {
    city: 'Scarsdale',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 1249.2,
    imprecise: false,
    latitude: 40.98916,
    longitude: -73.79443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10583',
  },
  {
    city: 'Shrub Oak',
    county_fips: 36119,
    county_fips_all: '36119|36079',
    county: 'Westchester',
    county_names_all: 'Westchester|Putnam',
    county_weights: '{"36119": 97.2, "36079": 2.8}',
    density: 661,
    imprecise: false,
    latitude: 41.33222,
    longitude: -73.82624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10588',
  },
  {
    city: 'Somers',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 426.6,
    imprecise: false,
    latitude: 41.33178,
    longitude: -73.6933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10589',
  },
  {
    city: 'South Salem',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 202.5,
    imprecise: false,
    latitude: 41.25421,
    longitude: -73.53719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10590',
  },
  {
    city: 'Tarrytown',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 982.2,
    imprecise: false,
    latitude: 41.08436,
    longitude: -73.84653,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10591',
  },
  {
    city: 'Thornwood',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 764.9,
    imprecise: false,
    latitude: 41.11579,
    longitude: -73.771,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10594',
  },
  {
    city: 'Valhalla',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 525.7,
    imprecise: false,
    latitude: 41.08626,
    longitude: -73.78097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10595',
  },
  {
    city: 'Verplanck',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 421.4,
    imprecise: false,
    latitude: 41.25552,
    longitude: -73.95854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10596',
  },
  {
    city: 'Waccabuc',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 79.9,
    imprecise: false,
    latitude: 41.29423,
    longitude: -73.59703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10597',
  },
  {
    city: 'Yorktown Heights',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 440.5,
    imprecise: false,
    latitude: 41.28309,
    longitude: -73.79516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10598',
  },
  {
    city: 'White Plains',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 7133.9,
    imprecise: false,
    latitude: 41.03288,
    longitude: -73.7648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10601',
  },
  {
    city: 'White Plains',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 2167.3,
    imprecise: false,
    latitude: 41.05364,
    longitude: -73.78014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10603',
  },
  {
    city: 'West Harrison',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 715.8,
    imprecise: false,
    latitude: 41.06013,
    longitude: -73.73955,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10604',
  },
  {
    city: 'White Plains',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 1401.3,
    imprecise: false,
    latitude: 41.0095,
    longitude: -73.74518,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10605',
  },
  {
    city: 'White Plains',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 4511.6,
    imprecise: false,
    latitude: 41.02065,
    longitude: -73.77588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10606',
  },
  {
    city: 'White Plains',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 1166.1,
    imprecise: false,
    latitude: 41.03949,
    longitude: -73.81214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10607',
  },
  {
    city: 'Yonkers',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 6231.4,
    imprecise: false,
    latitude: 40.94702,
    longitude: -73.88034,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 70676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10701',
  },
  {
    city: 'Yonkers',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 5548.7,
    imprecise: false,
    latitude: 40.95765,
    longitude: -73.88114,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10703',
  },
  {
    city: 'Yonkers',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 4617,
    imprecise: false,
    latitude: 40.91911,
    longitude: -73.86187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10704',
  },
  {
    city: 'Yonkers',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 6783,
    imprecise: false,
    latitude: 40.91929,
    longitude: -73.88928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10705',
  },
  {
    city: 'Hastings On Hudson',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 1331.3,
    imprecise: false,
    latitude: 40.99047,
    longitude: -73.86951,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10706',
  },
  {
    city: 'Tuckahoe',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 2946,
    imprecise: false,
    latitude: 40.95961,
    longitude: -73.82291,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10707',
  },
  {
    city: 'Bronxville',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 2959.3,
    imprecise: false,
    latitude: 40.9379,
    longitude: -73.83167,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10708',
  },
  {
    city: 'Eastchester',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 2570,
    imprecise: false,
    latitude: 40.95337,
    longitude: -73.80885,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10709',
  },
  {
    city: 'Yonkers',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 2168.8,
    imprecise: false,
    latitude: 40.96732,
    longitude: -73.84739,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10710',
  },
  {
    city: 'New Rochelle',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 4819.7,
    imprecise: false,
    latitude: 40.91751,
    longitude: -73.78396,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10801',
  },
  {
    city: 'Pelham',
    county_fips: 36119,
    county_fips_all: '36119|36005',
    county: 'Westchester',
    county_names_all: 'Westchester|Bronx',
    county_weights: '{"36119": 99.09, "36005": 0.91}',
    density: 2281.3,
    imprecise: false,
    latitude: 40.89978,
    longitude: -73.80619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10803',
  },
  {
    city: 'New Rochelle',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 1453.9,
    imprecise: false,
    latitude: 40.94914,
    longitude: -73.78629,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10804',
  },
  {
    city: 'New Rochelle',
    county_fips: 36119,
    county_fips_all: '36119',
    county: 'Westchester',
    county_names_all: 'Westchester',
    county_weights: '{"36119": 100}',
    density: 4717.2,
    imprecise: false,
    latitude: 40.89593,
    longitude: -73.78028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10805',
  },
  {
    city: 'Suffern',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 444.4,
    imprecise: false,
    latitude: 41.14554,
    longitude: -74.12504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10901',
  },
  {
    city: 'Arden',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.2773,
    longitude: -74.13625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10910',
  },
  {
    city: 'Bear Mountain',
    county_fips: 36087,
    county_fips_all: '36087|36071',
    county: 'Rockland',
    county_names_all: 'Rockland|Orange',
    county_weights: '{"36087": 99.89, "36071": 0.11}',
    density: 0,
    imprecise: false,
    latitude: 41.30798,
    longitude: -73.99243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10911',
  },
  {
    city: 'Blauvelt',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 497.3,
    imprecise: false,
    latitude: 41.06845,
    longitude: -73.95574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10913',
  },
  {
    city: 'Blooming Grove',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 187.8,
    imprecise: false,
    latitude: 41.41671,
    longitude: -74.20087,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10914',
  },
  {
    city: 'Bullville',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.54022,
    longitude: -74.35714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10915',
  },
  {
    city: 'Campbell Hall',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 69.7,
    imprecise: false,
    latitude: 41.44881,
    longitude: -74.24311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10916',
  },
  {
    city: 'Central Valley',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 154.1,
    imprecise: false,
    latitude: 41.31851,
    longitude: -74.11094,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10917',
  },
  {
    city: 'Chester',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 142.7,
    imprecise: false,
    latitude: 41.34816,
    longitude: -74.25828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10918',
  },
  {
    city: 'Circleville',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 158.8,
    imprecise: false,
    latitude: 41.52836,
    longitude: -74.38327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10919',
  },
  {
    city: 'Congers',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 731.3,
    imprecise: false,
    latitude: 41.15477,
    longitude: -73.9393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10920',
  },
  {
    city: 'Florida',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 197.9,
    imprecise: false,
    latitude: 41.3292,
    longitude: -74.3651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10921',
  },
  {
    city: 'Fort Montgomery',
    county_fips: 36071,
    county_fips_all: '36071|36087',
    county: 'Orange',
    county_names_all: 'Orange|Rockland',
    county_weights: '{"36071": 99.7, "36087": 0.3}',
    density: 261.5,
    imprecise: false,
    latitude: 41.32794,
    longitude: -73.99604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10922',
  },
  {
    city: 'Garnerville',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 1744.2,
    imprecise: false,
    latitude: 41.20265,
    longitude: -74.00031,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10923',
  },
  {
    city: 'Goshen',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 132.2,
    imprecise: false,
    latitude: 41.3788,
    longitude: -74.3512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10924',
  },
  {
    city: 'Greenwood Lake',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 181.6,
    imprecise: false,
    latitude: 41.20076,
    longitude: -74.29535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10925',
  },
  {
    city: 'Harriman',
    county_fips: 36071,
    county_fips_all: '36071|36087',
    county: 'Orange',
    county_names_all: 'Orange|Rockland',
    county_weights: '{"36071": 99.08, "36087": 0.92}',
    density: 75.9,
    imprecise: false,
    latitude: 41.25856,
    longitude: -74.1307,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10926',
  },
  {
    city: 'Haverstraw',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 2399.8,
    imprecise: false,
    latitude: 41.19263,
    longitude: -73.96735,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10927',
  },
  {
    city: 'Highland Falls',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 234.2,
    imprecise: false,
    latitude: 41.3457,
    longitude: -74.00265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10928',
  },
  {
    city: 'Highland Mills',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 230.4,
    imprecise: false,
    latitude: 41.3667,
    longitude: -74.11035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10930',
  },
  {
    city: 'Hillburn',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 205.5,
    imprecise: false,
    latitude: 41.12769,
    longitude: -74.17012,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10931',
  },
  {
    city: 'Howells',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 41.482,
    longitude: -74.46352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10932',
  },
  {
    city: 'Johnson',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 38,
    imprecise: false,
    latitude: 41.36527,
    longitude: -74.51106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10933',
  },
  {
    city: 'Middletown',
    county_fips: 36071,
    county_fips_all: '36071|36105',
    county: 'Orange',
    county_names_all: 'Orange|Sullivan',
    county_weights: '{"36071": 96.02, "36105": 3.98}',
    density: 327.8,
    imprecise: false,
    latitude: 41.45149,
    longitude: -74.46997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10940',
  },
  {
    city: 'Middletown',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 173.8,
    imprecise: false,
    latitude: 41.48923,
    longitude: -74.34556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10941',
  },
  {
    city: 'Monroe',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 714.9,
    imprecise: false,
    latitude: 41.31919,
    longitude: -74.19825,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10950',
  },
  {
    city: 'Monsey',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 2072.5,
    imprecise: false,
    latitude: 41.11385,
    longitude: -74.07975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10952',
  },
  {
    city: 'Mountainville',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 95.8,
    imprecise: false,
    latitude: 41.40581,
    longitude: -74.07783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10953',
  },
  {
    city: 'Nanuet',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 1484.8,
    imprecise: false,
    latitude: 41.09969,
    longitude: -74.01269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10954',
  },
  {
    city: 'New City',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 798.7,
    imprecise: false,
    latitude: 41.15562,
    longitude: -73.99314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10956',
  },
  {
    city: 'New Hampton',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 55.5,
    imprecise: false,
    latitude: 41.3764,
    longitude: -74.42881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10958',
  },
  {
    city: 'Nyack',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 1247.9,
    imprecise: false,
    latitude: 41.08892,
    longitude: -73.92642,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10960',
  },
  {
    city: 'Orangeburg',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 353.2,
    imprecise: false,
    latitude: 41.04857,
    longitude: -73.96057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10962',
  },
  {
    city: 'Otisville',
    county_fips: 36071,
    county_fips_all: '36071|36105',
    county: 'Orange',
    county_names_all: 'Orange|Sullivan',
    county_weights: '{"36071": 95.05, "36105": 4.95}',
    density: 112.4,
    imprecise: false,
    latitude: 41.4669,
    longitude: -74.54121,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10963',
  },
  {
    city: 'Palisades',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 211.5,
    imprecise: false,
    latitude: 41.01642,
    longitude: -73.91431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10964',
  },
  {
    city: 'Pearl River',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 1121.9,
    imprecise: false,
    latitude: 41.06176,
    longitude: -74.01286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10965',
  },
  {
    city: 'Piermont',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 1524.3,
    imprecise: false,
    latitude: 41.03976,
    longitude: -73.91804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10968',
  },
  {
    city: 'Pine Island',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 40.6,
    imprecise: false,
    latitude: 41.292,
    longitude: -74.48879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10969',
  },
  {
    city: 'Pomona',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 395.8,
    imprecise: false,
    latitude: 41.1852,
    longitude: -74.06568,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10970',
  },
  {
    city: 'Slate Hill',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 110.2,
    imprecise: false,
    latitude: 41.38442,
    longitude: -74.47566,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10973',
  },
  {
    city: 'Sloatsburg',
    county_fips: 36087,
    county_fips_all: '36087|36071',
    county: 'Rockland',
    county_names_all: 'Rockland|Orange',
    county_weights: '{"36087": 99.4, "36071": 0.6}',
    density: 176.2,
    imprecise: false,
    latitude: 41.15826,
    longitude: -74.18993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10974',
  },
  {
    city: 'Southfields',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 41.25951,
    longitude: -74.17042,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10975',
  },
  {
    city: 'Sparkill',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 677.6,
    imprecise: false,
    latitude: 41.02871,
    longitude: -73.92594,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10976',
  },
  {
    city: 'Spring Valley',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 2454.2,
    imprecise: false,
    latitude: 41.11749,
    longitude: -74.04825,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10977',
  },
  {
    city: 'Sterling Forest',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 2570.7,
    imprecise: false,
    latitude: 41.18237,
    longitude: -74.31877,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10979',
  },
  {
    city: 'Stony Point',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 189,
    imprecise: false,
    latitude: 41.23157,
    longitude: -74.05709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10980',
  },
  {
    city: 'Tappan',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 1100.3,
    imprecise: false,
    latitude: 41.02747,
    longitude: -73.94826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10983',
  },
  {
    city: 'Thiells',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 576.1,
    imprecise: false,
    latitude: 41.20928,
    longitude: -74.02008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10984',
  },
  {
    city: 'Thompson Ridge',
    county_fips: 36071,
    county_fips_all: '36071|36105',
    county: 'Orange',
    county_names_all: 'Orange|Sullivan',
    county_weights: '{"36071": 99.39, "36105": 0.61}',
    density: 10.4,
    imprecise: false,
    latitude: 41.57697,
    longitude: -74.35782,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10985',
  },
  {
    city: 'Tomkins Cove',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 70.5,
    imprecise: false,
    latitude: 41.27917,
    longitude: -73.99445,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10986',
  },
  {
    city: 'Tuxedo Park',
    county_fips: 36071,
    county_fips_all: '36071|36087',
    county: 'Orange',
    county_names_all: 'Orange|Rockland',
    county_weights: '{"36071": 99.75, "36087": 0.25}',
    density: 51.1,
    imprecise: false,
    latitude: 41.20737,
    longitude: -74.22284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10987',
  },
  {
    city: 'Unionville',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 826,
    imprecise: false,
    latitude: 41.30133,
    longitude: -74.56218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10988',
  },
  {
    city: 'Valley Cottage',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 733.5,
    imprecise: false,
    latitude: 41.12479,
    longitude: -73.93632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10989',
  },
  {
    city: 'Warwick',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 128,
    imprecise: false,
    latitude: 41.2651,
    longitude: -74.3663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10990',
  },
  {
    city: 'Washingtonville',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 336.2,
    imprecise: false,
    latitude: 41.42648,
    longitude: -74.16567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10992',
  },
  {
    city: 'West Haverstraw',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 1610.3,
    imprecise: false,
    latitude: 41.21011,
    longitude: -73.97565,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10993',
  },
  {
    city: 'West Nyack',
    county_fips: 36087,
    county_fips_all: '36087',
    county: 'Rockland',
    county_names_all: 'Rockland',
    county_weights: '{"36087": 100}',
    density: 397.4,
    imprecise: false,
    latitude: 41.09702,
    longitude: -73.97322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10994',
  },
  {
    city: 'West Point',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 768.5,
    imprecise: false,
    latitude: 41.38996,
    longitude: -73.97257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10996',
  },
  {
    city: 'Westtown',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 69.5,
    imprecise: false,
    latitude: 41.33118,
    longitude: -74.53989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10998',
  },
  {
    city: 'Floral Park',
    county_fips: 36059,
    county_fips_all: '36059|36081',
    county: 'Nassau',
    county_names_all: 'Nassau|Queens',
    county_weights: '{"36059": 88.41, "36081": 11.59}',
    density: 4463.3,
    imprecise: false,
    latitude: 40.72356,
    longitude: -73.70451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11001',
  },
  {
    city: 'Elmont',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 4227.5,
    imprecise: false,
    latitude: 40.70143,
    longitude: -73.7078,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11003',
  },
  {
    city: 'Glen Oaks',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 5527.2,
    imprecise: false,
    latitude: 40.74621,
    longitude: -73.71147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11004',
  },
  {
    city: 'Floral Park',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 4575.4,
    imprecise: false,
    latitude: 40.75661,
    longitude: -73.71424,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11005',
  },
  {
    city: 'Franklin Square',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 4110.3,
    imprecise: false,
    latitude: 40.70066,
    longitude: -73.67514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11010',
  },
  {
    city: 'Great Neck',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1135.4,
    imprecise: false,
    latitude: 40.77098,
    longitude: -73.71293,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11020',
  },
  {
    city: 'Great Neck',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 3210.8,
    imprecise: false,
    latitude: 40.78644,
    longitude: -73.7289,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11021',
  },
  {
    city: 'Great Neck',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2226.7,
    imprecise: false,
    latitude: 40.7994,
    longitude: -73.73282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11023',
  },
  {
    city: 'Great Neck',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1009.6,
    imprecise: false,
    latitude: 40.81642,
    longitude: -73.74205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11024',
  },
  {
    city: 'Manhasset',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1060.9,
    imprecise: false,
    latitude: 40.79293,
    longitude: -73.68868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11030',
  },
  {
    city: 'New Hyde Park',
    county_fips: 36059,
    county_fips_all: '36059|36081',
    county: 'Nassau',
    county_names_all: 'Nassau|Queens',
    county_weights: '{"36059": 96.61, "36081": 3.39}',
    density: 3371,
    imprecise: false,
    latitude: 40.74572,
    longitude: -73.67979,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11040',
  },
  {
    city: 'New Hyde Park',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 90.9,
    imprecise: false,
    latitude: 40.75854,
    longitude: -73.6975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11042',
  },
  {
    city: 'Port Washington',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1249.5,
    imprecise: false,
    latitude: 40.83815,
    longitude: -73.69113,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11050',
  },
  {
    city: 'Inwood',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 3261.5,
    imprecise: false,
    latitude: 40.62143,
    longitude: -73.75292,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11096',
  },
  {
    city: 'Long Island City',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 6300.7,
    imprecise: false,
    latitude: 40.74679,
    longitude: -73.93916,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11101',
  },
  {
    city: 'Astoria',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 15700.3,
    imprecise: false,
    latitude: 40.77161,
    longitude: -73.92619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11102',
  },
  {
    city: 'Astoria',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 19615.8,
    imprecise: false,
    latitude: 40.76261,
    longitude: -73.91334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11103',
  },
  {
    city: 'Sunnyside',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 23076.7,
    imprecise: false,
    latitude: 40.74484,
    longitude: -73.92049,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11104',
  },
  {
    city: 'Astoria',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 8965.6,
    imprecise: false,
    latitude: 40.779,
    longitude: -73.90652,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11105',
  },
  {
    city: 'Astoria',
    county_fips: 36081,
    county_fips_all: '36081|36061',
    county: 'Queens',
    county_names_all: 'Queens|New York',
    county_weights: '{"36081": 99.82, "36061": 0.18}',
    density: 18444.6,
    imprecise: false,
    latitude: 40.76191,
    longitude: -73.93169,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11106',
  },
  {
    city: 'Long Island City',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 66465.4,
    imprecise: false,
    latitude: 40.7463,
    longitude: -73.95699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11109',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047|36061',
    county: 'Kings',
    county_names_all: 'Kings|New York',
    county_weights: '{"36047": 99.21, "36061": 0.79}',
    density: 20154.2,
    imprecise: false,
    latitude: 40.69477,
    longitude: -73.99031,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 70674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11201',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 13505,
    imprecise: false,
    latitude: 40.64958,
    longitude: -73.93431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 74817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11203',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 19323.1,
    imprecise: false,
    latitude: 40.61883,
    longitude: -73.98496,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 79800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11204',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 17033.6,
    imprecise: false,
    latitude: 40.69654,
    longitude: -73.96807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11205',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 25635.6,
    imprecise: false,
    latitude: 40.7019,
    longitude: -73.94254,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 93020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11206',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 13229.6,
    imprecise: false,
    latitude: 40.67016,
    longitude: -73.89383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 93198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11207',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047|36081',
    county: 'Kings',
    county_names_all: 'Kings|Queens',
    county_weights: '{"36047": 99.66, "36081": 0.34}',
    density: 15209.1,
    imprecise: false,
    latitude: 40.67481,
    longitude: -73.87243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 105428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11208',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 12972.4,
    imprecise: false,
    latitude: 40.62175,
    longitude: -74.03013,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11209',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 13562.2,
    imprecise: false,
    latitude: 40.62801,
    longitude: -73.94631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11210',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 17331.3,
    imprecise: false,
    latitude: 40.71428,
    longitude: -73.94602,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11211',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 22241.1,
    imprecise: false,
    latitude: 40.6629,
    longitude: -73.91308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 89020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11212',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 24661.1,
    imprecise: false,
    latitude: 40.67117,
    longitude: -73.93632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11213',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 17051.3,
    imprecise: false,
    latitude: 40.59928,
    longitude: -73.99644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 89397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11214',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 12426.9,
    imprecise: false,
    latitude: 40.66255,
    longitude: -73.98687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 70441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11215',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 24403.6,
    imprecise: false,
    latitude: 40.68085,
    longitude: -73.94929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11216',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 22785.2,
    imprecise: false,
    latitude: 40.68242,
    longitude: -73.97943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11217',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 20423.5,
    imprecise: false,
    latitude: 40.64315,
    longitude: -73.97645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 72042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11218',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 24369.4,
    imprecise: false,
    latitude: 40.63267,
    longitude: -73.99672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 94196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11219',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 20255.9,
    imprecise: false,
    latitude: 40.64142,
    longitude: -74.01741,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 90652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11220',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 25607.8,
    imprecise: false,
    latitude: 40.6914,
    longitude: -73.92764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 91588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11221',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 10868.3,
    imprecise: false,
    latitude: 40.72862,
    longitude: -73.94764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11222',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 14566.4,
    imprecise: false,
    latitude: 40.59711,
    longitude: -73.97344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 78093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11223',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 12650.8,
    imprecise: false,
    latitude: 40.57652,
    longitude: -73.9891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11224',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 25667.5,
    imprecise: false,
    latitude: 40.6631,
    longitude: -73.95392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11225',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 28201.1,
    imprecise: false,
    latitude: 40.64636,
    longitude: -73.95666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 95144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11226',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 10893.1,
    imprecise: false,
    latitude: 40.61678,
    longitude: -74.01337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11228',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 15074.7,
    imprecise: false,
    latitude: 40.60047,
    longitude: -73.94453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 78377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11229',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 18222.4,
    imprecise: false,
    latitude: 40.6221,
    longitude: -73.96525,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 86978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11230',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 10371.3,
    imprecise: false,
    latitude: 40.67603,
    longitude: -74.00644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11231',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 8651.1,
    imprecise: false,
    latitude: 40.65692,
    longitude: -74.00727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11232',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 23419.6,
    imprecise: false,
    latitude: 40.67827,
    longitude: -73.91994,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 81822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11233',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 4349.7,
    imprecise: false,
    latitude: 40.6072,
    longitude: -73.91107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 83187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11234',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 12344.3,
    imprecise: false,
    latitude: 40.58411,
    longitude: -73.94331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 78558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11235',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 9538.2,
    imprecise: false,
    latitude: 40.63951,
    longitude: -73.90098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 88051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11236',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 17566.7,
    imprecise: false,
    latitude: 40.70427,
    longitude: -73.92108,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11237',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 12183,
    imprecise: false,
    latitude: 40.67105,
    longitude: -73.96636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11238',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 3689.2,
    imprecise: false,
    latitude: 40.64733,
    longitude: -73.87136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11239',
  },
  {
    city: 'Brooklyn',
    county_fips: 36047,
    county_fips_all: '36047',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"36047": 100}',
    density: 25783.8,
    imprecise: false,
    latitude: 40.71121,
    longitude: -73.96318,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11249',
  },
  {
    city: 'Flushing',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 9515.6,
    imprecise: false,
    latitude: 40.7686,
    longitude: -73.82743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11354',
  },
  {
    city: 'Flushing',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 18173.7,
    imprecise: false,
    latitude: 40.75143,
    longitude: -73.82125,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 80801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11355',
  },
  {
    city: 'College Point',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 6304.6,
    imprecise: false,
    latitude: 40.78492,
    longitude: -73.84149,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11356',
  },
  {
    city: 'Whitestone',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 5904.3,
    imprecise: false,
    latitude: 40.78636,
    longitude: -73.81094,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11357',
  },
  {
    city: 'Flushing',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 7432.3,
    imprecise: false,
    latitude: 40.76038,
    longitude: -73.79648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11358',
  },
  {
    city: 'Bayside',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 5463.9,
    imprecise: false,
    latitude: 40.7805,
    longitude: -73.78159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11360',
  },
  {
    city: 'Bayside',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 6788.4,
    imprecise: false,
    latitude: 40.76393,
    longitude: -73.77294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11361',
  },
  {
    city: 'Little Neck',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 3437.8,
    imprecise: false,
    latitude: 40.75899,
    longitude: -73.73583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11362',
  },
  {
    city: 'Little Neck',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 3225.7,
    imprecise: false,
    latitude: 40.77251,
    longitude: -73.74708,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11363',
  },
  {
    city: 'Oakland Gardens',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 5428.5,
    imprecise: false,
    latitude: 40.74625,
    longitude: -73.75598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11364',
  },
  {
    city: 'Fresh Meadows',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 6572.4,
    imprecise: false,
    latitude: 40.73983,
    longitude: -73.79499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11365',
  },
  {
    city: 'Fresh Meadows',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 3411.5,
    imprecise: false,
    latitude: 40.73112,
    longitude: -73.7804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11366',
  },
  {
    city: 'Flushing',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 8262.9,
    imprecise: false,
    latitude: 40.73044,
    longitude: -73.82274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11367',
  },
  {
    city: 'Corona',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 15498.5,
    imprecise: false,
    latitude: 40.74962,
    longitude: -73.85264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 105716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11368',
  },
  {
    city: 'East Elmhurst',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 12514.7,
    imprecise: false,
    latitude: 40.76345,
    longitude: -73.87222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11369',
  },
  {
    city: 'East Elmhurst',
    county_fips: 36081,
    county_fips_all: '36081|36005',
    county: 'Queens',
    county_names_all: 'Queens|Bronx',
    county_weights: '{"36081": 58.22, "36005": 41.78}',
    density: 7571.5,
    imprecise: false,
    latitude: 40.77554,
    longitude: -73.88766,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11370',
  },
  {
    city: 'Flushing',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.77445,
    longitude: -73.87316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11371',
  },
  {
    city: 'Jackson Heights',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 33850,
    imprecise: false,
    latitude: 40.75172,
    longitude: -73.88367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11372',
  },
  {
    city: 'Elmhurst',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 25131.7,
    imprecise: false,
    latitude: 40.73892,
    longitude: -73.87854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 98403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11373',
  },
  {
    city: 'Rego Park',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 19217.7,
    imprecise: false,
    latitude: 40.72647,
    longitude: -73.86144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11374',
  },
  {
    city: 'Forest Hills',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 12255.9,
    imprecise: false,
    latitude: 40.72315,
    longitude: -73.84373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 76839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11375',
  },
  {
    city: 'Woodside',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 12457.4,
    imprecise: false,
    latitude: 40.74483,
    longitude: -73.90516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 81690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11377',
  },
  {
    city: 'Maspeth',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 5770.9,
    imprecise: false,
    latitude: 40.72493,
    longitude: -73.91034,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11378',
  },
  {
    city: 'Middle Village',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 6408.2,
    imprecise: false,
    latitude: 40.71709,
    longitude: -73.88056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11379',
  },
  {
    city: 'Ridgewood',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 10862.2,
    imprecise: false,
    latitude: 40.70103,
    longitude: -73.89011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 101704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11385',
  },
  {
    city: 'Cambria Heights',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 6724.7,
    imprecise: false,
    latitude: 40.69406,
    longitude: -73.73623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11411',
  },
  {
    city: 'Saint Albans',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 9348.2,
    imprecise: false,
    latitude: 40.69804,
    longitude: -73.759,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11412',
  },
  {
    city: 'Springfield Gardens',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 5883.4,
    imprecise: false,
    latitude: 40.67002,
    longitude: -73.75116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11413',
  },
  {
    city: 'Howard Beach',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 5236.2,
    imprecise: false,
    latitude: 40.65818,
    longitude: -73.8448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11414',
  },
  {
    city: 'Kew Gardens',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 14581.9,
    imprecise: false,
    latitude: 40.70808,
    longitude: -73.82801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11415',
  },
  {
    city: 'Ozone Park',
    county_fips: 36081,
    county_fips_all: '36081|36047',
    county: 'Queens',
    county_names_all: 'Queens|Kings',
    county_weights: '{"36081": 99.69, "36047": 0.31}',
    density: 15171.2,
    imprecise: false,
    latitude: 40.68458,
    longitude: -73.84967,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11416',
  },
  {
    city: 'Ozone Park',
    county_fips: 36081,
    county_fips_all: '36081|36047',
    county: 'Queens',
    county_names_all: 'Queens|Kings',
    county_weights: '{"36081": 99.8, "36047": 0.2}',
    density: 10602.9,
    imprecise: false,
    latitude: 40.67641,
    longitude: -73.84455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11417',
  },
  {
    city: 'Richmond Hill',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 8254.8,
    imprecise: false,
    latitude: 40.70032,
    longitude: -73.83603,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11418',
  },
  {
    city: 'South Richmond Hill',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 16259.4,
    imprecise: false,
    latitude: 40.68863,
    longitude: -73.82302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11419',
  },
  {
    city: 'South Ozone Park',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 9051.9,
    imprecise: false,
    latitude: 40.67352,
    longitude: -73.8177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11420',
  },
  {
    city: 'Woodhaven',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 12203.7,
    imprecise: false,
    latitude: 40.69403,
    longitude: -73.85865,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11421',
  },
  {
    city: 'Rosedale',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 6209.7,
    imprecise: false,
    latitude: 40.66053,
    longitude: -73.73658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11422',
  },
  {
    city: 'Hollis',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 7828,
    imprecise: false,
    latitude: 40.71564,
    longitude: -73.76826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11423',
  },
  {
    city: 'Jamaica',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.71397,
    longitude: -73.82809,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11424',
  },
  {
    city: 'Bellerose',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 5459.9,
    imprecise: false,
    latitude: 40.73641,
    longitude: -73.7223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11426',
  },
  {
    city: 'Queens Village',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 6056.5,
    imprecise: false,
    latitude: 40.73094,
    longitude: -73.74569,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11427',
  },
  {
    city: 'Queens Village',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 8833.5,
    imprecise: false,
    latitude: 40.72099,
    longitude: -73.74222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11428',
  },
  {
    city: 'Queens Village',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 7844.7,
    imprecise: false,
    latitude: 40.70958,
    longitude: -73.73843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11429',
  },
  {
    city: 'Jamaica',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 31.9,
    imprecise: false,
    latitude: 40.64703,
    longitude: -73.78717,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11430',
  },
  {
    city: 'Jamaica',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 12000.8,
    imprecise: false,
    latitude: 40.71491,
    longitude: -73.79295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11432',
  },
  {
    city: 'Jamaica',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 9554.7,
    imprecise: false,
    latitude: 40.69805,
    longitude: -73.78675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11433',
  },
  {
    city: 'Jamaica',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 8121.3,
    imprecise: false,
    latitude: 40.67683,
    longitude: -73.77623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11434',
  },
  {
    city: 'Jamaica',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 14524,
    imprecise: false,
    latitude: 40.70111,
    longitude: -73.80968,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11435',
  },
  {
    city: 'Jamaica',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 10905.6,
    imprecise: false,
    latitude: 40.67587,
    longitude: -73.79664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11436',
  },
  {
    city: 'Mineola',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 4106.7,
    imprecise: false,
    latitude: 40.74629,
    longitude: -73.63921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11501',
  },
  {
    city: 'Albertson',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2462,
    imprecise: false,
    latitude: 40.77082,
    longitude: -73.6521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11507',
  },
  {
    city: 'Atlantic Beach',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 822.2,
    imprecise: false,
    latitude: 40.58872,
    longitude: -73.7286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11509',
  },
  {
    city: 'Baldwin',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 3319.9,
    imprecise: false,
    latitude: 40.65027,
    longitude: -73.60809,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11510',
  },
  {
    city: 'Carle Place',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1937.7,
    imprecise: false,
    latitude: 40.74979,
    longitude: -73.61298,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11514',
  },
  {
    city: 'Cedarhurst',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 3824.9,
    imprecise: false,
    latitude: 40.6258,
    longitude: -73.7263,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11516',
  },
  {
    city: 'East Rockaway',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2806.1,
    imprecise: false,
    latitude: 40.63772,
    longitude: -73.66691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11518',
  },
  {
    city: 'Freeport',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 3426.7,
    imprecise: false,
    latitude: 40.65007,
    longitude: -73.58305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11520',
  },
  {
    city: 'Garden City',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1490.9,
    imprecise: false,
    latitude: 40.72716,
    longitude: -73.63654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11530',
  },
  {
    city: 'Glen Cove',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1664.1,
    imprecise: false,
    latitude: 40.87073,
    longitude: -73.62879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11542',
  },
  {
    city: 'Glen Head',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 410.3,
    imprecise: false,
    latitude: 40.82685,
    longitude: -73.58853,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11545',
  },
  {
    city: 'Glenwood Landing',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 593,
    imprecise: false,
    latitude: 40.82881,
    longitude: -73.64505,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11547',
  },
  {
    city: 'Greenvale',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 904.6,
    imprecise: false,
    latitude: 40.81414,
    longitude: -73.6097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11548',
  },
  {
    city: 'Hempstead',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 5592.1,
    imprecise: false,
    latitude: 40.70158,
    longitude: -73.62039,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11550',
  },
  {
    city: 'West Hempstead',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2781.6,
    imprecise: false,
    latitude: 40.6916,
    longitude: -73.65073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11552',
  },
  {
    city: 'Uniondale',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 3323.7,
    imprecise: false,
    latitude: 40.70529,
    longitude: -73.5923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11553',
  },
  {
    city: 'East Meadow',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2255.6,
    imprecise: false,
    latitude: 40.71974,
    longitude: -73.56044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11554',
  },
  {
    city: 'Hewlett',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1610,
    imprecise: false,
    latitude: 40.63723,
    longitude: -73.6921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11557',
  },
  {
    city: 'Island Park',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2198.6,
    imprecise: false,
    latitude: 40.60539,
    longitude: -73.64952,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11558',
  },
  {
    city: 'Lawrence',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 824.3,
    imprecise: false,
    latitude: 40.60615,
    longitude: -73.71688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11559',
  },
  {
    city: 'Locust Valley',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 398,
    imprecise: false,
    latitude: 40.88068,
    longitude: -73.59057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11560',
  },
  {
    city: 'Long Beach',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 3725.2,
    imprecise: false,
    latitude: 40.58969,
    longitude: -73.64455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11561',
  },
  {
    city: 'Lynbrook',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 3803.9,
    imprecise: false,
    latitude: 40.65746,
    longitude: -73.67408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11563',
  },
  {
    city: 'Malverne',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 3082.1,
    imprecise: false,
    latitude: 40.67505,
    longitude: -73.67177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11565',
  },
  {
    city: 'Merrick',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2468.9,
    imprecise: false,
    latitude: 40.66307,
    longitude: -73.55407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11566',
  },
  {
    city: 'Old Westbury',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 184.6,
    imprecise: false,
    latitude: 40.78659,
    longitude: -73.59719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11568',
  },
  {
    city: 'Point Lookout',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1305.1,
    imprecise: false,
    latitude: 40.5903,
    longitude: -73.58046,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11569',
  },
  {
    city: 'Rockville Centre',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 3110.5,
    imprecise: false,
    latitude: 40.66504,
    longitude: -73.63882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11570',
  },
  {
    city: 'Oceanside',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2464.6,
    imprecise: false,
    latitude: 40.63231,
    longitude: -73.63686,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11572',
  },
  {
    city: 'Roosevelt',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 4059.1,
    imprecise: false,
    latitude: 40.68044,
    longitude: -73.58525,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11575',
  },
  {
    city: 'Roslyn',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1029.3,
    imprecise: false,
    latitude: 40.79791,
    longitude: -73.64711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11576',
  },
  {
    city: 'Roslyn Heights',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1710.1,
    imprecise: false,
    latitude: 40.78288,
    longitude: -73.6391,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11577',
  },
  {
    city: 'Sea Cliff',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1745.7,
    imprecise: false,
    latitude: 40.84406,
    longitude: -73.64426,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11579',
  },
  {
    city: 'Valley Stream',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 4280,
    imprecise: false,
    latitude: 40.67491,
    longitude: -73.70374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11580',
  },
  {
    city: 'Valley Stream',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 3234.8,
    imprecise: false,
    latitude: 40.65153,
    longitude: -73.71653,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11581',
  },
  {
    city: 'Westbury',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2741.2,
    imprecise: false,
    latitude: 40.75541,
    longitude: -73.57463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11590',
  },
  {
    city: 'Williston Park',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 3068,
    imprecise: false,
    latitude: 40.75968,
    longitude: -73.6422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11596',
  },
  {
    city: 'Woodmere',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2711.6,
    imprecise: false,
    latitude: 40.63109,
    longitude: -73.71188,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11598',
  },
  {
    city: 'Far Rockaway',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 9979.8,
    imprecise: false,
    latitude: 40.60152,
    longitude: -73.76173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11691',
  },
  {
    city: 'Arverne',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 8640.7,
    imprecise: false,
    latitude: 40.59373,
    longitude: -73.79201,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11692',
  },
  {
    city: 'Far Rockaway',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 5172,
    imprecise: false,
    latitude: 40.59649,
    longitude: -73.81663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11693',
  },
  {
    city: 'Rockaway Park',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 4748.4,
    imprecise: false,
    latitude: 40.57532,
    longitude: -73.85099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11694',
  },
  {
    city: 'Breezy Point',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 835.2,
    imprecise: false,
    latitude: 40.55749,
    longitude: -73.91361,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11697',
  },
  {
    city: 'Amityville',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 2455.9,
    imprecise: false,
    latitude: 40.6817,
    longitude: -73.41289,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11701',
  },
  {
    city: 'Babylon',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 466.7,
    imprecise: false,
    latitude: 40.65155,
    longitude: -73.33824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11702',
  },
  {
    city: 'North Babylon',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 2177.6,
    imprecise: false,
    latitude: 40.73325,
    longitude: -73.32533,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11703',
  },
  {
    city: 'West Babylon',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1991.9,
    imprecise: false,
    latitude: 40.71623,
    longitude: -73.35908,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11704',
  },
  {
    city: 'Bayport',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 943.6,
    imprecise: false,
    latitude: 40.74514,
    longitude: -73.05461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11705',
  },
  {
    city: 'Bay Shore',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1573,
    imprecise: false,
    latitude: 40.706,
    longitude: -73.24208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11706',
  },
  {
    city: 'Bayville',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1753.8,
    imprecise: false,
    latitude: 40.90665,
    longitude: -73.56005,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11709',
  },
  {
    city: 'Bellmore',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2765,
    imprecise: false,
    latitude: 40.67217,
    longitude: -73.53293,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11710',
  },
  {
    city: 'Bellport',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 637.5,
    imprecise: false,
    latitude: 40.77774,
    longitude: -72.94253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11713',
  },
  {
    city: 'Bethpage',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2073.9,
    imprecise: false,
    latitude: 40.74267,
    longitude: -73.48615,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11714',
  },
  {
    city: 'Blue Point',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 894.8,
    imprecise: false,
    latitude: 40.75005,
    longitude: -73.03531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11715',
  },
  {
    city: 'Bohemia',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 431.6,
    imprecise: false,
    latitude: 40.77131,
    longitude: -73.12729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11716',
  },
  {
    city: 'Brentwood',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: null,
    imprecise: false,
    latitude: 40.78405,
    longitude: -73.25223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11717',
  },
  {
    city: 'Brightwaters',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1309.6,
    imprecise: false,
    latitude: 40.71891,
    longitude: -73.26391,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11718',
  },
  {
    city: 'Brookhaven',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 233.9,
    imprecise: false,
    latitude: 40.77935,
    longitude: -72.91175,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11719',
  },
  {
    city: 'Centereach',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1374.5,
    imprecise: false,
    latitude: 40.87025,
    longitude: -73.08202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11720',
  },
  {
    city: 'Centerport',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 989,
    imprecise: false,
    latitude: 40.89362,
    longitude: -73.37009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11721',
  },
  {
    city: 'Central Islip',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 2162.9,
    imprecise: false,
    latitude: 40.78358,
    longitude: -73.19657,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11722',
  },
  {
    city: 'Cold Spring Harbor',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 307.3,
    imprecise: false,
    latitude: 40.86522,
    longitude: -73.45288,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11724',
  },
  {
    city: 'Commack',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1156.1,
    imprecise: false,
    latitude: 40.84056,
    longitude: -73.28085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11725',
  },
  {
    city: 'Copiague',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 3271.8,
    imprecise: false,
    latitude: 40.67891,
    longitude: -73.39564,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11726',
  },
  {
    city: 'Coram',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1171.2,
    imprecise: false,
    latitude: 40.88019,
    longitude: -73.00368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11727',
  },
  {
    city: 'Deer Park',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1697,
    imprecise: false,
    latitude: 40.76249,
    longitude: -73.32161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11729',
  },
  {
    city: 'East Islip',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1223.5,
    imprecise: false,
    latitude: 40.72701,
    longitude: -73.18456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11730',
  },
  {
    city: 'East Northport',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1392,
    imprecise: false,
    latitude: 40.86262,
    longitude: -73.31703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11731',
  },
  {
    city: 'East Norwich',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 576.6,
    imprecise: false,
    latitude: 40.84245,
    longitude: -73.53916,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11732',
  },
  {
    city: 'East Setauket',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 583.8,
    imprecise: false,
    latitude: 40.93742,
    longitude: -73.10544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11733',
  },
  {
    city: 'Farmingdale',
    county_fips: 36103,
    county_fips_all: '36103|36059',
    county: 'Suffolk',
    county_names_all: 'Suffolk|Nassau',
    county_weights: '{"36103": 53.97, "36059": 46.03}',
    density: 1151.8,
    imprecise: false,
    latitude: 40.73177,
    longitude: -73.43284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11735',
  },
  {
    city: 'Farmingville',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1456.1,
    imprecise: false,
    latitude: 40.83779,
    longitude: -73.03761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11738',
  },
  {
    city: 'Great River',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 133.1,
    imprecise: false,
    latitude: 40.71058,
    longitude: -73.16275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11739',
  },
  {
    city: 'Greenlawn',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1067.5,
    imprecise: false,
    latitude: 40.86536,
    longitude: -73.36118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11740',
  },
  {
    city: 'Holbrook',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1371.5,
    imprecise: false,
    latitude: 40.79473,
    longitude: -73.07043,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11741',
  },
  {
    city: 'Holtsville',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 989.9,
    imprecise: false,
    latitude: 40.81034,
    longitude: -73.0419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11742',
  },
  {
    city: 'Huntington',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 654.2,
    imprecise: false,
    latitude: 40.88018,
    longitude: -73.4266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11743',
  },
  {
    city: 'Huntington Station',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1052.7,
    imprecise: false,
    latitude: 40.81421,
    longitude: -73.3608,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11746',
  },
  {
    city: 'Melville',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 628.8,
    imprecise: false,
    latitude: 40.78372,
    longitude: -73.40931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11747',
  },
  {
    city: 'Islandia',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 635.7,
    imprecise: false,
    latitude: 40.80674,
    longitude: -73.1708,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11749',
  },
  {
    city: 'Islip',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1337,
    imprecise: false,
    latitude: 40.72999,
    longitude: -73.21424,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11751',
  },
  {
    city: 'Islip Terrace',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 879.8,
    imprecise: false,
    latitude: 40.75791,
    longitude: -73.17359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11752',
  },
  {
    city: 'Jericho',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1211.1,
    imprecise: false,
    latitude: 40.78976,
    longitude: -73.5411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11753',
  },
  {
    city: 'Kings Park',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 921.1,
    imprecise: false,
    latitude: 40.88771,
    longitude: -73.24738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11754',
  },
  {
    city: 'Lake Grove',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1430.3,
    imprecise: false,
    latitude: 40.8583,
    longitude: -73.11748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11755',
  },
  {
    city: 'Levittown',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2979.3,
    imprecise: false,
    latitude: 40.72545,
    longitude: -73.51656,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11756',
  },
  {
    city: 'Lindenhurst',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 2518.2,
    imprecise: false,
    latitude: 40.68892,
    longitude: -73.37356,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11757',
  },
  {
    city: 'Massapequa',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1750.9,
    imprecise: false,
    latitude: 40.65361,
    longitude: -73.45626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11758',
  },
  {
    city: 'Massapequa Park',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2696.3,
    imprecise: false,
    latitude: 40.68283,
    longitude: -73.44707,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11762',
  },
  {
    city: 'Medford',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 841.3,
    imprecise: false,
    latitude: 40.82529,
    longitude: -72.98245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11763',
  },
  {
    city: 'Miller Place',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 527.9,
    imprecise: false,
    latitude: 40.93585,
    longitude: -72.97544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11764',
  },
  {
    city: 'Mill Neck',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 116.8,
    imprecise: false,
    latitude: 40.88249,
    longitude: -73.55862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11765',
  },
  {
    city: 'Mount Sinai',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 688.6,
    imprecise: false,
    latitude: 40.93602,
    longitude: -73.01645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11766',
  },
  {
    city: 'Nesconset',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1333.5,
    imprecise: false,
    latitude: 40.84438,
    longitude: -73.14535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11767',
  },
  {
    city: 'Northport',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 563.4,
    imprecise: false,
    latitude: 40.91052,
    longitude: -73.32611,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11768',
  },
  {
    city: 'Oakdale',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 791.7,
    imprecise: false,
    latitude: 40.73703,
    longitude: -73.12929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11769',
  },
  {
    city: 'Ocean Beach',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 49.2,
    imprecise: false,
    latitude: 40.64945,
    longitude: -73.14123,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11770',
  },
  {
    city: 'Oyster Bay',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 388.5,
    imprecise: false,
    latitude: 40.8674,
    longitude: -73.52651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11771',
  },
  {
    city: 'Patchogue',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1077.6,
    imprecise: false,
    latitude: 40.76118,
    longitude: -72.9875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11772',
  },
  {
    city: 'Port Jefferson Station',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1232,
    imprecise: false,
    latitude: 40.91345,
    longitude: -73.04567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11776',
  },
  {
    city: 'Port Jefferson',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 826,
    imprecise: false,
    latitude: 40.95171,
    longitude: -73.0645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11777',
  },
  {
    city: 'Rocky Point',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 709.7,
    imprecise: false,
    latitude: 40.94312,
    longitude: -72.93073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11778',
  },
  {
    city: 'Ronkonkoma',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1182.9,
    imprecise: false,
    latitude: 40.8127,
    longitude: -73.1156,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11779',
  },
  {
    city: 'Saint James',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 504.1,
    imprecise: false,
    latitude: 40.89249,
    longitude: -73.16973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11780',
  },
  {
    city: 'Sayville',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1001.3,
    imprecise: false,
    latitude: 40.73727,
    longitude: -73.08024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11782',
  },
  {
    city: 'Seaford',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2303.1,
    imprecise: false,
    latitude: 40.67766,
    longitude: -73.49068,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11783',
  },
  {
    city: 'Selden',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1849.3,
    imprecise: false,
    latitude: 40.86855,
    longitude: -73.0422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11784',
  },
  {
    city: 'Shoreham',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 514.5,
    imprecise: false,
    latitude: 40.94711,
    longitude: -72.88939,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11786',
  },
  {
    city: 'Smithtown',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 894,
    imprecise: false,
    latitude: 40.85338,
    longitude: -73.21089,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11787',
  },
  {
    city: 'Hauppauge',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 779.7,
    imprecise: false,
    latitude: 40.81808,
    longitude: -73.21318,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11788',
  },
  {
    city: 'Sound Beach',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1681.1,
    imprecise: false,
    latitude: 40.95759,
    longitude: -72.97214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11789',
  },
  {
    city: 'Stony Brook',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1115.6,
    imprecise: false,
    latitude: 40.90719,
    longitude: -73.12777,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11790',
  },
  {
    city: 'Syosset',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 787.4,
    imprecise: false,
    latitude: 40.82819,
    longitude: -73.50282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11791',
  },
  {
    city: 'Wading River',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 347.6,
    imprecise: false,
    latitude: 40.94832,
    longitude: -72.8302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11792',
  },
  {
    city: 'Wantagh',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1267.1,
    imprecise: false,
    latitude: 40.6462,
    longitude: -73.51024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11793',
  },
  {
    city: 'West Islip',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1721.7,
    imprecise: false,
    latitude: 40.70803,
    longitude: -73.29827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11795',
  },
  {
    city: 'West Sayville',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1101.4,
    imprecise: false,
    latitude: 40.72958,
    longitude: -73.09986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11796',
  },
  {
    city: 'Woodbury',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 712.4,
    imprecise: false,
    latitude: 40.81739,
    longitude: -73.47004,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11797',
  },
  {
    city: 'Wyandanch',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: null,
    imprecise: false,
    latitude: 40.752,
    longitude: -73.37497,
    militaryZip: false,
    timezone: 'America/New_York',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11798',
  },
  {
    city: 'Hicksville',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 2405.4,
    imprecise: false,
    latitude: 40.76256,
    longitude: -73.52383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11801',
  },
  {
    city: 'Plainview',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 1862.5,
    imprecise: false,
    latitude: 40.78177,
    longitude: -73.4733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11803',
  },
  {
    city: 'Old Bethpage',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 661.8,
    imprecise: false,
    latitude: 40.75829,
    longitude: -73.45706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11804',
  },
  {
    city: 'Riverhead',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 225.3,
    imprecise: false,
    latitude: 40.92424,
    longitude: -72.64697,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11901',
  },
  {
    city: 'Amagansett',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 37.8,
    imprecise: false,
    latitude: 40.98877,
    longitude: -72.10482,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11930',
  },
  {
    city: 'Aquebogue',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 47.1,
    imprecise: false,
    latitude: 40.93347,
    longitude: -72.62195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11931',
  },
  {
    city: 'Bridgehampton',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 38.7,
    imprecise: false,
    latitude: 40.93322,
    longitude: -72.30603,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11932',
  },
  {
    city: 'Calverton',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 101.8,
    imprecise: false,
    latitude: 40.92449,
    longitude: -72.75453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11933',
  },
  {
    city: 'Center Moriches',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 656.8,
    imprecise: false,
    latitude: 40.80201,
    longitude: -72.79428,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11934',
  },
  {
    city: 'Cutchogue',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 107.1,
    imprecise: false,
    latitude: 41.01795,
    longitude: -72.48933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11935',
  },
  {
    city: 'East Hampton',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 227.9,
    imprecise: false,
    latitude: 40.99714,
    longitude: -72.20253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11937',
  },
  {
    city: 'East Marion',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 229.6,
    imprecise: false,
    latitude: 41.12627,
    longitude: -72.34223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11939',
  },
  {
    city: 'East Moriches',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 448.4,
    imprecise: false,
    latitude: 40.80819,
    longitude: -72.75664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11940',
  },
  {
    city: 'Eastport',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 264.8,
    imprecise: false,
    latitude: 40.83311,
    longitude: -72.72315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11941',
  },
  {
    city: 'East Quogue',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 245.9,
    imprecise: false,
    latitude: 40.84901,
    longitude: -72.57764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11942',
  },
  {
    city: 'Greenport',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 477.9,
    imprecise: false,
    latitude: 41.09888,
    longitude: -72.37223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11944',
  },
  {
    city: 'Hampton Bays',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 452.4,
    imprecise: false,
    latitude: 40.87033,
    longitude: -72.52294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11946',
  },
  {
    city: 'Jamesport',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1702.8,
    imprecise: false,
    latitude: 40.94302,
    longitude: -72.58189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11947',
  },
  {
    city: 'Laurel',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 127.2,
    imprecise: false,
    latitude: 40.9662,
    longitude: -72.55797,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11948',
  },
  {
    city: 'Manorville',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 153.5,
    imprecise: false,
    latitude: 40.86496,
    longitude: -72.80097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11949',
  },
  {
    city: 'Mastic',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1837.5,
    imprecise: false,
    latitude: 40.80627,
    longitude: -72.84734,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11950',
  },
  {
    city: 'Mastic Beach',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1282.3,
    imprecise: false,
    latitude: 40.76624,
    longitude: -72.83655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11951',
  },
  {
    city: 'Mattituck',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 209.6,
    imprecise: false,
    latitude: 40.99716,
    longitude: -72.54369,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11952',
  },
  {
    city: 'Middle Island',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 480.9,
    imprecise: false,
    latitude: 40.88585,
    longitude: -72.95054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11953',
  },
  {
    city: 'Montauk',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 88,
    imprecise: false,
    latitude: 41.04458,
    longitude: -71.9518,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11954',
  },
  {
    city: 'Moriches',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 425.2,
    imprecise: false,
    latitude: 40.80777,
    longitude: -72.82289,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11955',
  },
  {
    city: 'New Suffolk',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 90.7,
    imprecise: false,
    latitude: 40.98067,
    longitude: -72.46868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11956',
  },
  {
    city: 'Orient',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 66.9,
    imprecise: false,
    latitude: 41.1492,
    longitude: -72.26181,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11957',
  },
  {
    city: 'Peconic',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 116.5,
    imprecise: false,
    latitude: 41.03688,
    longitude: -72.4613,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11958',
  },
  {
    city: 'Quogue',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 46.3,
    imprecise: false,
    latitude: 40.82903,
    longitude: -72.60977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11959',
  },
  {
    city: 'Remsenburg',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 161.3,
    imprecise: false,
    latitude: 40.80894,
    longitude: -72.70615,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11960',
  },
  {
    city: 'Ridge',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 316.3,
    imprecise: false,
    latitude: 40.90458,
    longitude: -72.88488,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11961',
  },
  {
    city: 'Sagaponack',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 46.8,
    imprecise: false,
    latitude: 40.93715,
    longitude: -72.27379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11962',
  },
  {
    city: 'Sag Harbor',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 222.1,
    imprecise: false,
    latitude: 40.99921,
    longitude: -72.32271,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11963',
  },
  {
    city: 'Shelter Island',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 119.6,
    imprecise: false,
    latitude: 41.05743,
    longitude: -72.31492,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11964',
  },
  {
    city: 'Shelter Island Heights',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 56.9,
    imprecise: false,
    latitude: 41.07727,
    longitude: -72.34244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11965',
  },
  {
    city: 'Shirley',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 817.5,
    imprecise: false,
    latitude: 40.80092,
    longitude: -72.87611,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11967',
  },
  {
    city: 'Southampton',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 219.7,
    imprecise: false,
    latitude: 40.90035,
    longitude: -72.42081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11968',
  },
  {
    city: 'South Jamesport',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 407.8,
    imprecise: false,
    latitude: 40.94029,
    longitude: -72.57403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11970',
  },
  {
    city: 'Southold',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 224.1,
    imprecise: false,
    latitude: 41.05949,
    longitude: -72.42617,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11971',
  },
  {
    city: 'Speonk',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 160.3,
    imprecise: false,
    latitude: 40.82362,
    longitude: -72.70045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11972',
  },
  {
    city: 'Upton',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 40.86583,
    longitude: -72.88718,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11973',
  },
  {
    city: 'Wainscott',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 42.9,
    imprecise: false,
    latitude: 40.95146,
    longitude: -72.25093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11975',
  },
  {
    city: 'Water Mill',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 87.9,
    imprecise: false,
    latitude: 40.92986,
    longitude: -72.34721,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11976',
  },
  {
    city: 'Westhampton',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 191.1,
    imprecise: false,
    latitude: 40.82769,
    longitude: -72.67947,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11977',
  },
  {
    city: 'Westhampton Beach',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 178.6,
    imprecise: false,
    latitude: 40.82878,
    longitude: -72.64669,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11978',
  },
  {
    city: 'Yaphank',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 187.9,
    imprecise: false,
    latitude: 40.8321,
    longitude: -72.92198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11980',
  },
  {
    city: 'Alcove',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 25.5,
    imprecise: false,
    latitude: 42.48889,
    longitude: -73.93159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12007',
  },
  {
    city: 'Alplaus',
    county_fips: 36093,
    county_fips_all: '36093',
    county: 'Schenectady',
    county_names_all: 'Schenectady',
    county_weights: '{"36093": 100}',
    density: 243.5,
    imprecise: false,
    latitude: 42.85367,
    longitude: -73.9063,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12008',
  },
  {
    city: 'Altamont',
    county_fips: 36001,
    county_fips_all: '36001|36093',
    county: 'Albany',
    county_names_all: 'Albany|Schenectady',
    county_weights: '{"36001": 99.62, "36093": 0.38}',
    density: 58.2,
    imprecise: false,
    latitude: 42.69824,
    longitude: -74.03398,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12009',
  },
  {
    city: 'Amsterdam',
    county_fips: 36057,
    county_fips_all: '36057|36035|36091|36093',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Fulton|Saratoga|Schenectady',
    county_weights:
      '{"36057": 64.3, "36035": 18.26, "36091": 11.56, "36093": 5.88}',
    density: 83.5,
    imprecise: false,
    latitude: 42.93752,
    longitude: -74.17287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12010',
  },
  {
    city: 'Athens',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 98.4,
    imprecise: false,
    latitude: 42.28315,
    longitude: -73.82543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12015',
  },
  {
    city: 'Austerlitz',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 42.31453,
    longitude: -73.45682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12017',
  },
  {
    city: 'Averill Park',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 62,
    imprecise: false,
    latitude: 42.62926,
    longitude: -73.52662,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12018',
  },
  {
    city: 'Ballston Lake',
    county_fips: 36091,
    county_fips_all: '36091|36093',
    county: 'Saratoga',
    county_names_all: 'Saratoga|Schenectady',
    county_weights: '{"36091": 97.82, "36093": 2.18}',
    density: 211,
    imprecise: false,
    latitude: 42.92993,
    longitude: -73.88245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12019',
  },
  {
    city: 'Ballston Spa',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 178.5,
    imprecise: false,
    latitude: 43.00208,
    longitude: -73.87401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12020',
  },
  {
    city: 'Berlin',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 42.66653,
    longitude: -73.33401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12022',
  },
  {
    city: 'Berne',
    county_fips: 36001,
    county_fips_all: '36001|36095',
    county: 'Albany',
    county_names_all: 'Albany|Schoharie',
    county_weights: '{"36001": 75.79, "36095": 24.21}',
    density: 11.7,
    imprecise: false,
    latitude: 42.60656,
    longitude: -74.16573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12023',
  },
  {
    city: 'Brainard',
    county_fips: 36021,
    county_fips_all: '36021|36083',
    county: 'Columbia',
    county_names_all: 'Columbia|Rensselaer',
    county_weights: '{"36021": 99.36, "36083": 0.64}',
    density: 10.6,
    imprecise: false,
    latitude: 42.48134,
    longitude: -73.53419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 78,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12024',
  },
  {
    city: 'Broadalbin',
    county_fips: 36035,
    county_fips_all: '36035|36091',
    county: 'Fulton',
    county_names_all: 'Fulton|Saratoga',
    county_weights: '{"36035": 61.44, "36091": 38.56}',
    density: 48.3,
    imprecise: false,
    latitude: 43.09142,
    longitude: -74.11924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12025',
  },
  {
    city: 'Burnt Hills',
    county_fips: 36091,
    county_fips_all: '36091|36093',
    county: 'Saratoga',
    county_names_all: 'Saratoga|Schenectady',
    county_weights: '{"36091": 88.0, "36093": 12.0}',
    density: 242.9,
    imprecise: false,
    latitude: 42.92122,
    longitude: -73.90872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12027',
  },
  {
    city: 'Buskirk',
    county_fips: 36115,
    county_fips_all: '36115|36083',
    county: 'Washington',
    county_names_all: 'Washington|Rensselaer',
    county_weights: '{"36115": 52.78, "36083": 47.22}',
    density: 25.4,
    imprecise: false,
    latitude: 42.94545,
    longitude: -73.44213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12028',
  },
  {
    city: 'Canaan',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 42.40397,
    longitude: -73.42466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12029',
  },
  {
    city: 'Carlisle',
    county_fips: 36095,
    county_fips_all: '36095',
    county: 'Schoharie',
    county_names_all: 'Schoharie',
    county_weights: '{"36095": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 42.76579,
    longitude: -74.46617,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12031',
  },
  {
    city: 'Caroga Lake',
    county_fips: 36041,
    county_fips_all: '36041|36035',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Fulton',
    county_weights: '{"36041": 56.48, "36035": 43.52}',
    density: 2.7,
    imprecise: false,
    latitude: 43.24042,
    longitude: -74.55666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12032',
  },
  {
    city: 'Castleton On Hudson',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 107.5,
    imprecise: false,
    latitude: 42.53665,
    longitude: -73.70558,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12033',
  },
  {
    city: 'Central Bridge',
    county_fips: 36095,
    county_fips_all: '36095',
    county: 'Schoharie',
    county_names_all: 'Schoharie',
    county_weights: '{"36095": 100}',
    density: 22.7,
    imprecise: false,
    latitude: 42.73453,
    longitude: -74.37534,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12035',
  },
  {
    city: 'Charlotteville',
    county_fips: 36095,
    county_fips_all: '36095|36077',
    county: 'Schoharie',
    county_names_all: 'Schoharie|Otsego',
    county_weights: '{"36095": 78.2, "36077": 21.8}',
    density: 12.2,
    imprecise: false,
    latitude: 42.53564,
    longitude: -74.68468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12036',
  },
  {
    city: 'Chatham',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 41.9,
    imprecise: false,
    latitude: 42.33506,
    longitude: -73.55714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12037',
  },
  {
    city: 'Cherry Plain',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 174.5,
    imprecise: false,
    latitude: 42.63047,
    longitude: -73.35916,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12040',
  },
  {
    city: 'Clarksville',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 92.1,
    imprecise: false,
    latitude: 42.55893,
    longitude: -73.97028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12041',
  },
  {
    city: 'Climax',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 21.7,
    imprecise: false,
    latitude: 42.38185,
    longitude: -73.89162,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12042',
  },
  {
    city: 'Cobleskill',
    county_fips: 36095,
    county_fips_all: '36095|36077',
    county: 'Schoharie',
    county_names_all: 'Schoharie|Otsego',
    county_weights: '{"36095": 97.2, "36077": 2.8}',
    density: 50.3,
    imprecise: false,
    latitude: 42.70357,
    longitude: -74.5267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12043',
  },
  {
    city: 'Coeymans',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 64.7,
    imprecise: false,
    latitude: 42.47974,
    longitude: -73.79682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12045',
  },
  {
    city: 'Coeymans Hollow',
    county_fips: 36001,
    county_fips_all: '36001|36039',
    county: 'Albany',
    county_names_all: 'Albany|Greene',
    county_weights: '{"36001": 96.75, "36039": 3.25}',
    density: 9.3,
    imprecise: false,
    latitude: 42.48864,
    longitude: -73.92119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12046',
  },
  {
    city: 'Cohoes',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 1027.6,
    imprecise: false,
    latitude: 42.78396,
    longitude: -73.72655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12047',
  },
  {
    city: 'Coxsackie',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 126.6,
    imprecise: false,
    latitude: 42.34493,
    longitude: -73.83938,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12051',
  },
  {
    city: 'Cropseyville',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 24.5,
    imprecise: false,
    latitude: 42.75767,
    longitude: -73.47847,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12052',
  },
  {
    city: 'Delanson',
    county_fips: 36093,
    county_fips_all: '36093|36001|36095|36057',
    county: 'Schenectady',
    county_names_all: 'Schenectady|Albany|Schoharie|Montgomery',
    county_weights:
      '{"36093": 68.36, "36001": 16.77, "36095": 12.56, "36057": 2.31}',
    density: 31.1,
    imprecise: false,
    latitude: 42.75283,
    longitude: -74.18791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12053',
  },
  {
    city: 'Delmar',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 435.6,
    imprecise: false,
    latitude: 42.60764,
    longitude: -73.86864,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12054',
  },
  {
    city: 'Duanesburg',
    county_fips: 36093,
    county_fips_all: '36093',
    county: 'Schenectady',
    county_names_all: 'Schenectady',
    county_weights: '{"36093": 100}',
    density: 34.8,
    imprecise: false,
    latitude: 42.76761,
    longitude: -74.0905,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12056',
  },
  {
    city: 'Eagle Bridge',
    county_fips: 36115,
    county_fips_all: '36115|36083',
    county: 'Washington',
    county_names_all: 'Washington|Rensselaer',
    county_weights: '{"36115": 81.74, "36083": 18.26}',
    density: 18.1,
    imprecise: false,
    latitude: 42.97316,
    longitude: -73.34335,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12057',
  },
  {
    city: 'Earlton',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 42.3498,
    longitude: -73.923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12058',
  },
  {
    city: 'East Berne',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 25.9,
    imprecise: false,
    latitude: 42.61403,
    longitude: -74.05811,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12059',
  },
  {
    city: 'East Chatham',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 42.41325,
    longitude: -73.49284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12060',
  },
  {
    city: 'East Greenbush',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 189.4,
    imprecise: false,
    latitude: 42.59915,
    longitude: -73.65658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12061',
  },
  {
    city: 'East Nassau',
    county_fips: 36083,
    county_fips_all: '36083|36021',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer|Columbia',
    county_weights: '{"36083": 90.47, "36021": 9.53}',
    density: 19.1,
    imprecise: false,
    latitude: 42.52871,
    longitude: -73.501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12062',
  },
  {
    city: 'East Schodack',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 200.7,
    imprecise: false,
    latitude: 42.56442,
    longitude: -73.63826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12063',
  },
  {
    city: 'East Worcester',
    county_fips: 36077,
    county_fips_all: '36077|36095',
    county: 'Otsego',
    county_names_all: 'Otsego|Schoharie',
    county_weights: '{"36077": 62.24, "36095": 37.76}',
    density: 14.6,
    imprecise: false,
    latitude: 42.60711,
    longitude: -74.65887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12064',
  },
  {
    city: 'Clifton Park',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 496,
    imprecise: false,
    latitude: 42.85402,
    longitude: -73.78654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12065',
  },
  {
    city: 'Esperance',
    county_fips: 36057,
    county_fips_all: '36057|36095|36093',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Schoharie|Schenectady',
    county_weights: '{"36057": 46.85, "36095": 30.31, "36093": 22.84}',
    density: 22,
    imprecise: false,
    latitude: 42.78011,
    longitude: -74.30291,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12066',
  },
  {
    city: 'Feura Bush',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 23,
    imprecise: false,
    latitude: 42.56083,
    longitude: -73.91663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12067',
  },
  {
    city: 'Fonda',
    county_fips: 36057,
    county_fips_all: '36057|36035',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Fulton',
    county_weights: '{"36057": 95.16, "36035": 4.84}',
    density: 33,
    imprecise: false,
    latitude: 42.95701,
    longitude: -74.40467,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12068',
  },
  {
    city: 'Fort Hunter',
    county_fips: 36057,
    county_fips_all: '36057',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"36057": 100}',
    density: 440.3,
    imprecise: false,
    latitude: 42.94336,
    longitude: -74.28193,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12069',
  },
  {
    city: 'Fort Johnson',
    county_fips: 36057,
    county_fips_all: '36057|36035',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Fulton',
    county_weights: '{"36057": 50.8, "36035": 49.2}',
    density: 61.7,
    imprecise: false,
    latitude: 42.98513,
    longitude: -74.25441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12070',
  },
  {
    city: 'Fultonham',
    county_fips: 36095,
    county_fips_all: '36095',
    county: 'Schoharie',
    county_names_all: 'Schoharie',
    county_weights: '{"36095": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 42.56971,
    longitude: -74.41521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12071',
  },
  {
    city: 'Fultonville',
    county_fips: 36057,
    county_fips_all: '36057',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"36057": 100}',
    density: 21.3,
    imprecise: false,
    latitude: 42.88102,
    longitude: -74.36164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12072',
  },
  {
    city: 'Galway',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 32,
    imprecise: false,
    latitude: 43.05219,
    longitude: -74.04709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12074',
  },
  {
    city: 'Ghent',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 34.6,
    imprecise: false,
    latitude: 42.30145,
    longitude: -73.64046,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12075',
  },
  {
    city: 'Gilboa',
    county_fips: 36095,
    county_fips_all: '36095',
    county: 'Schoharie',
    county_names_all: 'Schoharie',
    county_weights: '{"36095": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 42.40868,
    longitude: -74.38506,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12076',
  },
  {
    city: 'Glenmont',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 267.8,
    imprecise: false,
    latitude: 42.59426,
    longitude: -73.7841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12077',
  },
  {
    city: 'Gloversville',
    county_fips: 36035,
    county_fips_all: '36035',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"36035": 100}',
    density: 78.7,
    imprecise: false,
    latitude: 43.12338,
    longitude: -74.36255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12078',
  },
  {
    city: 'Grafton',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 40.8,
    imprecise: false,
    latitude: 42.76998,
    longitude: -73.44672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12082',
  },
  {
    city: 'Greenville',
    county_fips: 36039,
    county_fips_all: '36039|36001',
    county: 'Greene',
    county_names_all: 'Greene|Albany',
    county_weights: '{"36039": 51.88, "36001": 48.12}',
    density: 33.9,
    imprecise: false,
    latitude: 42.43151,
    longitude: -74.03155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12083',
  },
  {
    city: 'Guilderland',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 539.9,
    imprecise: false,
    latitude: 42.70411,
    longitude: -73.90182,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12084',
  },
  {
    city: 'Guilderland Center',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 205.9,
    imprecise: false,
    latitude: 42.70043,
    longitude: -73.96659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12085',
  },
  {
    city: 'Hagaman',
    county_fips: 36091,
    county_fips_all: '36091|36057|36035',
    county: 'Saratoga',
    county_names_all: 'Saratoga|Montgomery|Fulton',
    county_weights: '{"36091": 57.52, "36057": 25.39, "36035": 17.09}',
    density: 100.4,
    imprecise: false,
    latitude: 42.99684,
    longitude: -74.10508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12086',
  },
  {
    city: 'Hannacroix',
    county_fips: 36039,
    county_fips_all: '36039|36001',
    county: 'Greene',
    county_names_all: 'Greene|Albany',
    county_weights: '{"36039": 91.96, "36001": 8.04}',
    density: 30.5,
    imprecise: false,
    latitude: 42.42794,
    longitude: -73.8931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12087',
  },
  {
    city: 'Hoosick Falls',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 36.6,
    imprecise: false,
    latitude: 42.88073,
    longitude: -73.35624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12090',
  },
  {
    city: 'Howes Cave',
    county_fips: 36095,
    county_fips_all: '36095',
    county: 'Schoharie',
    county_names_all: 'Schoharie',
    county_weights: '{"36095": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 42.70396,
    longitude: -74.38456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12092',
  },
  {
    city: 'Jefferson',
    county_fips: 36095,
    county_fips_all: '36095|36025',
    county: 'Schoharie',
    county_names_all: 'Schoharie|Delaware',
    county_weights: '{"36095": 73.95, "36025": 26.05}',
    density: 7.5,
    imprecise: false,
    latitude: 42.49599,
    longitude: -74.6262,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12093',
  },
  {
    city: 'Johnsonville',
    county_fips: 36083,
    county_fips_all: '36083|36115',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer|Washington',
    county_weights: '{"36083": 85.42, "36115": 14.58}',
    density: 32.3,
    imprecise: false,
    latitude: 42.89091,
    longitude: -73.48737,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12094',
  },
  {
    city: 'Johnstown',
    county_fips: 36035,
    county_fips_all: '36035|36057',
    county: 'Fulton',
    county_names_all: 'Fulton|Montgomery',
    county_weights: '{"36035": 91.64, "36057": 8.36}',
    density: 73.4,
    imprecise: false,
    latitude: 43.03151,
    longitude: -74.41553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12095',
  },
  {
    city: 'Kinderhook',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 50.2,
    imprecise: false,
    latitude: 42.38871,
    longitude: -73.71228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12106',
  },
  {
    city: 'Lake Pleasant',
    county_fips: 36041,
    county_fips_all: '36041',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"36041": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 43.47045,
    longitude: -74.42768,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12108',
  },
  {
    city: 'Latham',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 540.5,
    imprecise: false,
    latitude: 42.75349,
    longitude: -73.77671,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12110',
  },
  {
    city: 'Malden Bridge',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 42.46747,
    longitude: -73.59338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12115',
  },
  {
    city: 'Maryland',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 42.53849,
    longitude: -74.91278,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12116',
  },
  {
    city: 'Mayfield',
    county_fips: 36035,
    county_fips_all: '36035',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"36035": 100}',
    density: 25.3,
    imprecise: false,
    latitude: 43.16894,
    longitude: -74.25557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12117',
  },
  {
    city: 'Mechanicville',
    county_fips: 36091,
    county_fips_all: '36091|36083',
    county: 'Saratoga',
    county_names_all: 'Saratoga|Rensselaer',
    county_weights: '{"36091": 96.6, "36083": 3.4}',
    density: 186.5,
    imprecise: false,
    latitude: 42.92096,
    longitude: -73.72049,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12118',
  },
  {
    city: 'Medusa',
    county_fips: 36001,
    county_fips_all: '36001|36039',
    county: 'Albany',
    county_names_all: 'Albany|Greene',
    county_weights: '{"36001": 94.6, "36039": 5.4}',
    density: 15.7,
    imprecise: false,
    latitude: 42.45781,
    longitude: -74.1409,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12120',
  },
  {
    city: 'Melrose',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 45.6,
    imprecise: false,
    latitude: 42.84368,
    longitude: -73.60398,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12121',
  },
  {
    city: 'Middleburgh',
    county_fips: 36095,
    county_fips_all: '36095|36001',
    county: 'Schoharie',
    county_names_all: 'Schoharie|Albany',
    county_weights: '{"36095": 91.47, "36001": 8.53}',
    density: 13.6,
    imprecise: false,
    latitude: 42.54341,
    longitude: -74.31138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12122',
  },
  {
    city: 'Nassau',
    county_fips: 36083,
    county_fips_all: '36083|36021',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer|Columbia',
    county_weights: '{"36083": 97.96, "36021": 2.04}',
    density: 54.2,
    imprecise: false,
    latitude: 42.52239,
    longitude: -73.60636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12123',
  },
  {
    city: 'New Baltimore',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 73.9,
    imprecise: false,
    latitude: 42.44652,
    longitude: -73.78494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12124',
  },
  {
    city: 'New Lebanon',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 42.47633,
    longitude: -73.40394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12125',
  },
  {
    city: 'Niverville',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 164.9,
    imprecise: false,
    latitude: 42.44156,
    longitude: -73.65835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12130',
  },
  {
    city: 'North Blenheim',
    county_fips: 36095,
    county_fips_all: '36095',
    county: 'Schoharie',
    county_names_all: 'Schoharie',
    county_weights: '{"36095": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 42.46573,
    longitude: -74.46249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12131',
  },
  {
    city: 'North Chatham',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 85.3,
    imprecise: false,
    latitude: 42.47102,
    longitude: -73.63362,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12132',
  },
  {
    city: 'Northville',
    county_fips: 36041,
    county_fips_all: '36041|36091|36035',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Saratoga|Fulton',
    county_weights: '{"36041": 64.11, "36091": 27.83, "36035": 8.06}',
    density: 7.9,
    imprecise: false,
    latitude: 43.26533,
    longitude: -74.23059,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12134',
  },
  {
    city: 'Old Chatham',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 19.7,
    imprecise: false,
    latitude: 42.43249,
    longitude: -73.56016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12136',
  },
  {
    city: 'Pattersonville',
    county_fips: 36093,
    county_fips_all: '36093|36057',
    county: 'Schenectady',
    county_names_all: 'Schenectady|Montgomery',
    county_weights: '{"36093": 82.07, "36057": 17.93}',
    density: 34.4,
    imprecise: false,
    latitude: 42.85727,
    longitude: -74.12922,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12137',
  },
  {
    city: 'Petersburg',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 42.73735,
    longitude: -73.37128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12138',
  },
  {
    city: 'Piseco',
    county_fips: 36041,
    county_fips_all: '36041',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"36041": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 43.52096,
    longitude: -74.56552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12139',
  },
  {
    city: 'Poestenkill',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 81.6,
    imprecise: false,
    latitude: 42.689,
    longitude: -73.56689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12140',
  },
  {
    city: 'Ravena',
    county_fips: 36001,
    county_fips_all: '36001|36039',
    county: 'Albany',
    county_names_all: 'Albany|Greene',
    county_weights: '{"36001": 88.42, "36039": 11.58}',
    density: 114.6,
    imprecise: false,
    latitude: 42.48525,
    longitude: -73.85218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12143',
  },
  {
    city: 'Rensselaer',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 466.1,
    imprecise: false,
    latitude: 42.63106,
    longitude: -73.71801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12144',
  },
  {
    city: 'Rensselaerville',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 42.51365,
    longitude: -74.15147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12147',
  },
  {
    city: 'Rexford',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 99.4,
    imprecise: false,
    latitude: 42.83361,
    longitude: -73.84652,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12148',
  },
  {
    city: 'Richmondville',
    county_fips: 36095,
    county_fips_all: '36095|36077',
    county: 'Schoharie',
    county_names_all: 'Schoharie|Otsego',
    county_weights: '{"36095": 94.82, "36077": 5.18}',
    density: 17.7,
    imprecise: false,
    latitude: 42.62011,
    longitude: -74.56692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12149',
  },
  {
    city: 'Rotterdam Junction',
    county_fips: 36093,
    county_fips_all: '36093',
    county: 'Schenectady',
    county_names_all: 'Schenectady',
    county_weights: '{"36093": 100}',
    density: 230.4,
    imprecise: false,
    latitude: 42.87613,
    longitude: -74.04923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12150',
  },
  {
    city: 'Round Lake',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 143.3,
    imprecise: false,
    latitude: 42.92553,
    longitude: -73.78874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12151',
  },
  {
    city: 'Sand Lake',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 42.63606,
    longitude: -73.46692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12153',
  },
  {
    city: 'Schaghticoke',
    county_fips: 36083,
    county_fips_all: '36083|36115',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer|Washington',
    county_weights: '{"36083": 55.53, "36115": 44.47}',
    density: 25.1,
    imprecise: false,
    latitude: 42.93713,
    longitude: -73.60124,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12154',
  },
  {
    city: 'Schenevus',
    county_fips: 36077,
    county_fips_all: '36077|36025',
    county: 'Otsego',
    county_names_all: 'Otsego|Delaware',
    county_weights: '{"36077": 92.81, "36025": 7.19}',
    density: 12.4,
    imprecise: false,
    latitude: 42.59229,
    longitude: -74.82337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12155',
  },
  {
    city: 'Schodack Landing',
    county_fips: 36083,
    county_fips_all: '36083|36021',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer|Columbia',
    county_weights: '{"36083": 72.48, "36021": 27.52}',
    density: 21.5,
    imprecise: false,
    latitude: 42.47764,
    longitude: -73.74354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12156',
  },
  {
    city: 'Schoharie',
    county_fips: 36095,
    county_fips_all: '36095|36093|36001',
    county: 'Schoharie',
    county_names_all: 'Schoharie|Schenectady|Albany',
    county_weights: '{"36095": 98.53, "36093": 0.83, "36001": 0.64}',
    density: 36.3,
    imprecise: false,
    latitude: 42.66742,
    longitude: -74.29892,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12157',
  },
  {
    city: 'Selkirk',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 77.3,
    imprecise: false,
    latitude: 42.53927,
    longitude: -73.81903,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12158',
  },
  {
    city: 'Slingerlands',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 208.6,
    imprecise: false,
    latitude: 42.64328,
    longitude: -73.88503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12159',
  },
  {
    city: 'Sloansville',
    county_fips: 36095,
    county_fips_all: '36095|36057',
    county: 'Schoharie',
    county_names_all: 'Schoharie|Montgomery',
    county_weights: '{"36095": 91.02, "36057": 8.98}',
    density: 17.9,
    imprecise: false,
    latitude: 42.76325,
    longitude: -74.36619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12160',
  },
  {
    city: 'South Bethlehem',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 387.4,
    imprecise: false,
    latitude: 42.53369,
    longitude: -73.84606,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12161',
  },
  {
    city: 'Speculator',
    county_fips: 36041,
    county_fips_all: '36041',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"36041": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 43.62883,
    longitude: -74.42717,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12164',
  },
  {
    city: 'Spencertown',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 50.2,
    imprecise: false,
    latitude: 42.31518,
    longitude: -73.50756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12165',
  },
  {
    city: 'Sprakers',
    county_fips: 36057,
    county_fips_all: '36057|36095',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Schoharie',
    county_weights: '{"36057": 97.86, "36095": 2.14}',
    density: 14.5,
    imprecise: false,
    latitude: 42.83846,
    longitude: -74.45644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12166',
  },
  {
    city: 'Stamford',
    county_fips: 36095,
    county_fips_all: '36095|36025',
    county: 'Schoharie',
    county_names_all: 'Schoharie|Delaware',
    county_weights: '{"36095": 54.35, "36025": 45.65}',
    density: 16.5,
    imprecise: false,
    latitude: 42.42101,
    longitude: -74.59011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12167',
  },
  {
    city: 'Stephentown',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 22,
    imprecise: false,
    latitude: 42.5614,
    longitude: -73.3751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12168',
  },
  {
    city: 'Stephentown',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 42.58249,
    longitude: -73.43559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12169',
  },
  {
    city: 'Stillwater',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 65.4,
    imprecise: false,
    latitude: 42.99936,
    longitude: -73.66234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12170',
  },
  {
    city: 'Stottville',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 127.1,
    imprecise: false,
    latitude: 42.28915,
    longitude: -73.73895,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12172',
  },
  {
    city: 'Stuyvesant',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 49.7,
    imprecise: false,
    latitude: 42.39042,
    longitude: -73.76196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12173',
  },
  {
    city: 'Stuyvesant Falls',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 150.4,
    imprecise: false,
    latitude: 42.35314,
    longitude: -73.72802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12174',
  },
  {
    city: 'Summit',
    county_fips: 36095,
    county_fips_all: '36095',
    county: 'Schoharie',
    county_names_all: 'Schoharie',
    county_weights: '{"36095": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 42.55489,
    longitude: -74.56161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12175',
  },
  {
    city: 'Surprise',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 29.4,
    imprecise: false,
    latitude: 42.38839,
    longitude: -73.96787,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12176',
  },
  {
    city: 'Tribes Hill',
    county_fips: 36057,
    county_fips_all: '36057',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"36057": 100}',
    density: 311.1,
    imprecise: false,
    latitude: 42.95184,
    longitude: -74.28459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12177',
  },
  {
    city: 'Troy',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 367.2,
    imprecise: false,
    latitude: 42.7516,
    longitude: -73.59997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12180',
  },
  {
    city: 'Troy',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 420.3,
    imprecise: false,
    latitude: 42.80044,
    longitude: -73.63519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12182',
  },
  {
    city: 'Troy',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 1530,
    imprecise: false,
    latitude: 42.74742,
    longitude: -73.69259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12183',
  },
  {
    city: 'Valatie',
    county_fips: 36021,
    county_fips_all: '36021|36083',
    county: 'Columbia',
    county_names_all: 'Columbia|Rensselaer',
    county_weights: '{"36021": 98.36, "36083": 1.64}',
    density: 76.4,
    imprecise: false,
    latitude: 42.42272,
    longitude: -73.65387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12184',
  },
  {
    city: 'Valley Falls',
    county_fips: 36083,
    county_fips_all: '36083|36115',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer|Washington',
    county_weights: '{"36083": 75.86, "36115": 24.14}',
    density: 29,
    imprecise: false,
    latitude: 42.90102,
    longitude: -73.53507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12185',
  },
  {
    city: 'Voorheesville',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 75.9,
    imprecise: false,
    latitude: 42.62502,
    longitude: -73.9737,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12186',
  },
  {
    city: 'Warnerville',
    county_fips: 36095,
    county_fips_all: '36095',
    county: 'Schoharie',
    county_names_all: 'Schoharie',
    county_weights: '{"36095": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 42.62632,
    longitude: -74.46537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12187',
  },
  {
    city: 'Waterford',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 326.5,
    imprecise: false,
    latitude: 42.8199,
    longitude: -73.69589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12188',
  },
  {
    city: 'Watervliet',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 1158.1,
    imprecise: false,
    latitude: 42.73618,
    longitude: -73.71688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12189',
  },
  {
    city: 'Wells',
    county_fips: 36041,
    county_fips_all: '36041',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"36041": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 43.47359,
    longitude: -74.2733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12190',
  },
  {
    city: 'West Coxsackie',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 42.40428,
    longitude: -73.82136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12192',
  },
  {
    city: 'Westerlo',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 42.51713,
    longitude: -74.04327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12193',
  },
  {
    city: 'West Fulton',
    county_fips: 36095,
    county_fips_all: '36095',
    county: 'Schoharie',
    county_names_all: 'Schoharie',
    county_weights: '{"36095": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 42.53839,
    longitude: -74.45431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12194',
  },
  {
    city: 'West Lebanon',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 79.8,
    imprecise: false,
    latitude: 42.47876,
    longitude: -73.46505,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12195',
  },
  {
    city: 'West Sand Lake',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 167.3,
    imprecise: false,
    latitude: 42.63149,
    longitude: -73.61708,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12196',
  },
  {
    city: 'Worcester',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 42.6094,
    longitude: -74.72587,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12197',
  },
  {
    city: 'Wynantskill',
    county_fips: 36083,
    county_fips_all: '36083',
    county: 'Rensselaer',
    county_names_all: 'Rensselaer',
    county_weights: '{"36083": 100}',
    density: 198.1,
    imprecise: false,
    latitude: 42.67819,
    longitude: -73.63285,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12198',
  },
  {
    city: 'Albany',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 1956.1,
    imprecise: false,
    latitude: 42.63355,
    longitude: -73.763,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12202',
  },
  {
    city: 'Albany',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 1138.7,
    imprecise: false,
    latitude: 42.68138,
    longitude: -73.85099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12203',
  },
  {
    city: 'Albany',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 728.9,
    imprecise: false,
    latitude: 42.68723,
    longitude: -73.72869,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12204',
  },
  {
    city: 'Albany',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 649.2,
    imprecise: false,
    latitude: 42.71719,
    longitude: -73.83006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12205',
  },
  {
    city: 'Albany',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 2714.4,
    imprecise: false,
    latitude: 42.67415,
    longitude: -73.78196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12206',
  },
  {
    city: 'Albany',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 778.6,
    imprecise: false,
    latitude: 42.65657,
    longitude: -73.74749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12207',
  },
  {
    city: 'Albany',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 2042.1,
    imprecise: false,
    latitude: 42.65293,
    longitude: -73.80835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12208',
  },
  {
    city: 'Albany',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 1853,
    imprecise: false,
    latitude: 42.6382,
    longitude: -73.78976,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12209',
  },
  {
    city: 'Albany',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 3513.2,
    imprecise: false,
    latitude: 42.66399,
    longitude: -73.75985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12210',
  },
  {
    city: 'Albany',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 684.2,
    imprecise: false,
    latitude: 42.7083,
    longitude: -73.76393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12211',
  },
  {
    city: 'Schenectady',
    county_fips: 36093,
    county_fips_all: '36093|36091',
    county: 'Schenectady',
    county_names_all: 'Schenectady|Saratoga',
    county_weights: '{"36093": 91.26, "36091": 8.74}',
    density: 249.7,
    imprecise: false,
    latitude: 42.88188,
    longitude: -73.98323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12302',
  },
  {
    city: 'Schenectady',
    county_fips: 36001,
    county_fips_all: '36001|36093',
    county: 'Albany',
    county_names_all: 'Albany|Schenectady',
    county_weights: '{"36001": 71.05, "36093": 28.95}',
    density: 728.1,
    imprecise: false,
    latitude: 42.74938,
    longitude: -73.92562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12303',
  },
  {
    city: 'Schenectady',
    county_fips: 36093,
    county_fips_all: '36093|36001',
    county: 'Schenectady',
    county_names_all: 'Schenectady|Albany',
    county_weights: '{"36093": 66.22, "36001": 33.78}',
    density: 1297.9,
    imprecise: false,
    latitude: 42.77375,
    longitude: -73.89742,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12304',
  },
  {
    city: 'Schenectady',
    county_fips: 36093,
    county_fips_all: '36093',
    county: 'Schenectady',
    county_names_all: 'Schenectady',
    county_weights: '{"36093": 100}',
    density: 1895.2,
    imprecise: false,
    latitude: 42.81219,
    longitude: -73.95036,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12305',
  },
  {
    city: 'Schenectady',
    county_fips: 36093,
    county_fips_all: '36093|36001',
    county: 'Schenectady',
    county_names_all: 'Schenectady|Albany',
    county_weights: '{"36093": 95.72, "36001": 4.28}',
    density: 245,
    imprecise: false,
    latitude: 42.80686,
    longitude: -74.03344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12306',
  },
  {
    city: 'Schenectady',
    county_fips: 36093,
    county_fips_all: '36093',
    county: 'Schenectady',
    county_names_all: 'Schenectady',
    county_weights: '{"36093": 100}',
    density: 3817.4,
    imprecise: false,
    latitude: 42.80507,
    longitude: -73.93341,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12307',
  },
  {
    city: 'Schenectady',
    county_fips: 36093,
    county_fips_all: '36093',
    county: 'Schenectady',
    county_names_all: 'Schenectady',
    county_weights: '{"36093": 100}',
    density: 2621.8,
    imprecise: false,
    latitude: 42.82152,
    longitude: -73.92006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12308',
  },
  {
    city: 'Schenectady',
    county_fips: 36093,
    county_fips_all: '36093|36001',
    county: 'Schenectady',
    county_names_all: 'Schenectady|Albany',
    county_weights: '{"36093": 82.34, "36001": 17.66}',
    density: 730.8,
    imprecise: false,
    latitude: 42.79693,
    longitude: -73.86785,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12309',
  },
  {
    city: 'Kingston',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 230.3,
    imprecise: false,
    latitude: 41.93504,
    longitude: -74.05446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12401',
  },
  {
    city: 'Accord',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 41.1,
    imprecise: false,
    latitude: 41.81602,
    longitude: -74.23632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12404',
  },
  {
    city: 'Acra',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 42.31585,
    longitude: -74.0989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12405',
  },
  {
    city: 'Arkville',
    county_fips: 36111,
    county_fips_all: '36111|36025',
    county: 'Ulster',
    county_names_all: 'Ulster|Delaware',
    county_weights: '{"36111": 69.16, "36025": 30.84}',
    density: 5.1,
    imprecise: false,
    latitude: 42.09647,
    longitude: -74.56502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12406',
  },
  {
    city: 'Ashland',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 94.9,
    imprecise: false,
    latitude: 42.30075,
    longitude: -74.35343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12407',
  },
  {
    city: 'Bearsville',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 42.05662,
    longitude: -74.16655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12409',
  },
  {
    city: 'Big Indian',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 42.0706,
    longitude: -74.45212,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12410',
  },
  {
    city: 'Bloomington',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 187.6,
    imprecise: false,
    latitude: 41.87975,
    longitude: -74.04094,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12411',
  },
  {
    city: 'Boiceville',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 27.8,
    imprecise: false,
    latitude: 42.01218,
    longitude: -74.27698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12412',
  },
  {
    city: 'Cairo',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 78.1,
    imprecise: false,
    latitude: 42.31338,
    longitude: -74.02628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12413',
  },
  {
    city: 'Catskill',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 63.2,
    imprecise: false,
    latitude: 42.2211,
    longitude: -73.92356,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12414',
  },
  {
    city: 'Chichester',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 42.09554,
    longitude: -74.28592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12416',
  },
  {
    city: 'Connelly',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 916.7,
    imprecise: false,
    latitude: 41.9073,
    longitude: -73.98943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12417',
  },
  {
    city: 'Cornwallville',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 42.35863,
    longitude: -74.1609,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12418',
  },
  {
    city: 'Cottekill',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 173.7,
    imprecise: false,
    latitude: 41.85948,
    longitude: -74.10265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12419',
  },
  {
    city: 'Cragsmoor',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 55.2,
    imprecise: false,
    latitude: 41.6743,
    longitude: -74.37769,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12420',
  },
  {
    city: 'Denver',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 42.2512,
    longitude: -74.5336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12421',
  },
  {
    city: 'Durham',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 42.39205,
    longitude: -74.20232,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12422',
  },
  {
    city: 'East Durham',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 35,
    imprecise: false,
    latitude: 42.37968,
    longitude: -74.11136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12423',
  },
  {
    city: 'East Jewett',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 42.24689,
    longitude: -74.14358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12424',
  },
  {
    city: 'Elka Park',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 42.14771,
    longitude: -74.11921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12427',
  },
  {
    city: 'Ellenville',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 49,
    imprecise: false,
    latitude: 41.73817,
    longitude: -74.44615,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12428',
  },
  {
    city: 'Esopus',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 102.2,
    imprecise: false,
    latitude: 41.83323,
    longitude: -73.961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12429',
  },
  {
    city: 'Fleischmanns',
    county_fips: 36039,
    county_fips_all: '36039|36025',
    county: 'Greene',
    county_names_all: 'Greene|Delaware',
    county_weights: '{"36039": 58.57, "36025": 41.43}',
    density: 12.1,
    imprecise: false,
    latitude: 42.20306,
    longitude: -74.49933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12430',
  },
  {
    city: 'Freehold',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 42.1,
    imprecise: false,
    latitude: 42.35877,
    longitude: -74.01843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12431',
  },
  {
    city: 'Glasco',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 577.2,
    imprecise: false,
    latitude: 42.04702,
    longitude: -73.94403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12432',
  },
  {
    city: 'Glenford',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 52.2,
    imprecise: false,
    latitude: 42.00533,
    longitude: -74.15526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12433',
  },
  {
    city: 'Grand Gorge',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 33.6,
    imprecise: false,
    latitude: 42.36491,
    longitude: -74.50793,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12434',
  },
  {
    city: 'Greenfield Park',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 41.72715,
    longitude: -74.51148,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12435',
  },
  {
    city: 'Haines Falls',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 42.20447,
    longitude: -74.0746,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12436',
  },
  {
    city: 'Halcottsville',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 451.8,
    imprecise: false,
    latitude: 42.21251,
    longitude: -74.59667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12438',
  },
  {
    city: 'Hensonville',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 42.29674,
    longitude: -74.18789,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12439',
  },
  {
    city: 'High Falls',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 35.2,
    imprecise: false,
    latitude: 41.78665,
    longitude: -74.16338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12440',
  },
  {
    city: 'Highmount',
    county_fips: 36025,
    county_fips_all: '36025|36111',
    county: 'Delaware',
    county_names_all: 'Delaware|Ulster',
    county_weights: '{"36025": 70.95, "36111": 29.05}',
    density: 13.7,
    imprecise: false,
    latitude: 42.1502,
    longitude: -74.50625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12441',
  },
  {
    city: 'Hunter',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 42.22275,
    longitude: -74.23545,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12442',
  },
  {
    city: 'Hurley',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 83.2,
    imprecise: false,
    latitude: 41.93388,
    longitude: -74.08536,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12443',
  },
  {
    city: 'Jewett',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 42.24942,
    longitude: -74.28993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12444',
  },
  {
    city: 'Kerhonkson',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 31,
    imprecise: false,
    latitude: 41.79063,
    longitude: -74.31655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12446',
  },
  {
    city: 'Lake Hill',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 42.07955,
    longitude: -74.20067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12448',
  },
  {
    city: 'Lake Katrine',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 312.3,
    imprecise: false,
    latitude: 41.99377,
    longitude: -73.99338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12449',
  },
  {
    city: 'Lanesville',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 42.13804,
    longitude: -74.22176,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12450',
  },
  {
    city: 'Leeds',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 31.5,
    imprecise: false,
    latitude: 42.30337,
    longitude: -73.94802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12451',
  },
  {
    city: 'Lexington',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 38.7,
    imprecise: false,
    latitude: 42.23891,
    longitude: -74.34986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12452',
  },
  {
    city: 'Malden On Hudson',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 218.2,
    imprecise: false,
    latitude: 42.0929,
    longitude: -73.93629,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12453',
  },
  {
    city: 'Maplecrest',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 42.2869,
    longitude: -74.15038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12454',
  },
  {
    city: 'Margaretville',
    county_fips: 36025,
    county_fips_all: '36025|36111',
    county: 'Delaware',
    county_names_all: 'Delaware|Ulster',
    county_weights: '{"36025": 94.64, "36111": 5.36}',
    density: 9.1,
    imprecise: false,
    latitude: 42.14871,
    longitude: -74.66334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12455',
  },
  {
    city: 'Mount Marion',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 278.7,
    imprecise: false,
    latitude: 42.03308,
    longitude: -73.99703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12456',
  },
  {
    city: 'Mount Tremper',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 42.03997,
    longitude: -74.24659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12457',
  },
  {
    city: 'Napanoch',
    county_fips: 36111,
    county_fips_all: '36111|36105',
    county: 'Ulster',
    county_names_all: 'Ulster|Sullivan',
    county_weights: '{"36111": 93.66, "36105": 6.34}',
    density: 30,
    imprecise: false,
    latitude: 41.82273,
    longitude: -74.41666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12458',
  },
  {
    city: 'New Kingston',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 42.23976,
    longitude: -74.6805,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12459',
  },
  {
    city: 'Oak Hill',
    county_fips: 36001,
    county_fips_all: '36001|36039',
    county: 'Albany',
    county_names_all: 'Albany|Greene',
    county_weights: '{"36001": 64.49, "36039": 35.51}',
    density: 9.8,
    imprecise: false,
    latitude: 42.42357,
    longitude: -74.16676,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12460',
  },
  {
    city: 'Olivebridge',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 33.6,
    imprecise: false,
    latitude: 41.90531,
    longitude: -74.25246,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12461',
  },
  {
    city: 'Palenville',
    county_fips: 36039,
    county_fips_all: '36039|36111',
    county: 'Greene',
    county_names_all: 'Greene|Ulster',
    county_weights: '{"36039": 99.88, "36111": 0.12}',
    density: 71.1,
    imprecise: false,
    latitude: 42.1895,
    longitude: -74.01573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12463',
  },
  {
    city: 'Phoenicia',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 42.04071,
    longitude: -74.34452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12464',
  },
  {
    city: 'Pine Hill',
    county_fips: 36111,
    county_fips_all: '36111|36025',
    county: 'Ulster',
    county_names_all: 'Ulster|Delaware',
    county_weights: '{"36111": 77.74, "36025": 22.26}',
    density: 33.9,
    imprecise: false,
    latitude: 42.15278,
    longitude: -74.46725,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12465',
  },
  {
    city: 'Port Ewen',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 742.7,
    imprecise: false,
    latitude: 41.90671,
    longitude: -73.97826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12466',
  },
  {
    city: 'Prattsville',
    county_fips: 36039,
    county_fips_all: '36039|36025',
    county: 'Greene',
    county_names_all: 'Greene|Delaware',
    county_weights: '{"36039": 83.75, "36025": 16.25}',
    density: 8.8,
    imprecise: false,
    latitude: 42.29998,
    longitude: -74.41375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12468',
  },
  {
    city: 'Preston Hollow',
    county_fips: 36001,
    county_fips_all: '36001|36095|36039',
    county: 'Albany',
    county_names_all: 'Albany|Schoharie|Greene',
    county_weights: '{"36001": 59.7, "36095": 35.38, "36039": 4.92}',
    density: 9.3,
    imprecise: false,
    latitude: 42.44521,
    longitude: -74.2421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12469',
  },
  {
    city: 'Purling',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 42.26932,
    longitude: -74.05515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12470',
  },
  {
    city: 'Rifton',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 300,
    imprecise: false,
    latitude: 41.83799,
    longitude: -74.04195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12471',
  },
  {
    city: 'Rosendale',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 132.7,
    imprecise: false,
    latitude: 41.84732,
    longitude: -74.07447,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12472',
  },
  {
    city: 'Round Top',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 36.5,
    imprecise: false,
    latitude: 42.26157,
    longitude: -74.02827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12473',
  },
  {
    city: 'Roxbury',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 7,
    imprecise: false,
    latitude: 42.29378,
    longitude: -74.58117,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12474',
  },
  {
    city: 'Ruby',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 184.2,
    imprecise: false,
    latitude: 42.01397,
    longitude: -74.01332,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12475',
  },
  {
    city: 'Saugerties',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 110.4,
    imprecise: false,
    latitude: 42.08528,
    longitude: -74.00028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12477',
  },
  {
    city: 'Shandaken',
    county_fips: 36039,
    county_fips_all: '36039|36111',
    county: 'Greene',
    county_names_all: 'Greene|Ulster',
    county_weights: '{"36039": 52.6, "36111": 47.4}',
    density: 6.3,
    imprecise: false,
    latitude: 42.13803,
    longitude: -74.37683,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12480',
  },
  {
    city: 'Shokan',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 37.7,
    imprecise: false,
    latitude: 41.97519,
    longitude: -74.22718,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12481',
  },
  {
    city: 'South Cairo',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 103,
    imprecise: false,
    latitude: 42.26841,
    longitude: -73.95587,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12482',
  },
  {
    city: 'Spring Glen',
    county_fips: 36105,
    county_fips_all: '36105|36111',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Ulster',
    county_weights: '{"36105": 75.54, "36111": 24.46}',
    density: 14.1,
    imprecise: false,
    latitude: 41.66796,
    longitude: -74.44184,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12483',
  },
  {
    city: 'Stone Ridge',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 51.3,
    imprecise: false,
    latitude: 41.87024,
    longitude: -74.17338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12484',
  },
  {
    city: 'Tannersville',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 42.4,
    imprecise: false,
    latitude: 42.20507,
    longitude: -74.15288,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12485',
  },
  {
    city: 'Tillson',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 171.5,
    imprecise: false,
    latitude: 41.83438,
    longitude: -74.06235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12486',
  },
  {
    city: 'Ulster Park',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 95.4,
    imprecise: false,
    latitude: 41.86095,
    longitude: -73.99555,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12487',
  },
  {
    city: 'Wawarsing',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 10,
    imprecise: false,
    latitude: 41.75597,
    longitude: -74.35462,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12489',
  },
  {
    city: 'West Camp',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.12355,
    longitude: -73.9251,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12490',
  },
  {
    city: 'West Hurley',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 77.2,
    imprecise: false,
    latitude: 41.96957,
    longitude: -74.13311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12491',
  },
  {
    city: 'West Kill',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 42.18758,
    longitude: -74.33453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12492',
  },
  {
    city: 'West Park',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 39.3,
    imprecise: false,
    latitude: 41.79316,
    longitude: -73.97283,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12493',
  },
  {
    city: 'West Shokan',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 41.94857,
    longitude: -74.30169,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12494',
  },
  {
    city: 'Willow',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 42.08264,
    longitude: -74.24563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12495',
  },
  {
    city: 'Windham',
    county_fips: 36039,
    county_fips_all: '36039',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"36039": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 42.32669,
    longitude: -74.27256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12496',
  },
  {
    city: 'Woodstock',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 79.7,
    imprecise: false,
    latitude: 42.04772,
    longitude: -74.11007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12498',
  },
  {
    city: 'Amenia',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 29.5,
    imprecise: false,
    latitude: 41.85664,
    longitude: -73.55953,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12501',
  },
  {
    city: 'Ancram',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 42.08324,
    longitude: -73.65409,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12502',
  },
  {
    city: 'Ancramdale',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 42.03615,
    longitude: -73.58139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12503',
  },
  {
    city: 'Barrytown',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 59.4,
    imprecise: false,
    latitude: 42.00735,
    longitude: -73.92126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12507',
  },
  {
    city: 'Beacon',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 523.6,
    imprecise: false,
    latitude: 41.49637,
    longitude: -73.95351,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12508',
  },
  {
    city: 'Chelsea',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 281.9,
    imprecise: false,
    latitude: 41.5542,
    longitude: -73.96471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12512',
  },
  {
    city: 'Claverack',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 30.3,
    imprecise: false,
    latitude: 42.21661,
    longitude: -73.71639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12513',
  },
  {
    city: 'Clinton Corners',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 44,
    imprecise: false,
    latitude: 41.87137,
    longitude: -73.76274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12514',
  },
  {
    city: 'Clintondale',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 132.8,
    imprecise: false,
    latitude: 41.68008,
    longitude: -74.06451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12515',
  },
  {
    city: 'Copake',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 36.3,
    imprecise: false,
    latitude: 42.10722,
    longitude: -73.55343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12516',
  },
  {
    city: 'Copake Falls',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 42.13392,
    longitude: -73.51103,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12517',
  },
  {
    city: 'Cornwall',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 296.6,
    imprecise: false,
    latitude: 41.41847,
    longitude: -74.03571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12518',
  },
  {
    city: 'Cornwall On Hudson',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 287.6,
    imprecise: false,
    latitude: 41.43362,
    longitude: -74.00693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12520',
  },
  {
    city: 'Craryville',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 24.7,
    imprecise: false,
    latitude: 42.17071,
    longitude: -73.65164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12521',
  },
  {
    city: 'Dover Plains',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 51.1,
    imprecise: false,
    latitude: 41.72693,
    longitude: -73.58893,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12522',
  },
  {
    city: 'Elizaville',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 33,
    imprecise: false,
    latitude: 42.08627,
    longitude: -73.75311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12523',
  },
  {
    city: 'Fishkill',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 346.2,
    imprecise: false,
    latitude: 41.53092,
    longitude: -73.89245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12524',
  },
  {
    city: 'Gardiner',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 45,
    imprecise: false,
    latitude: 41.68115,
    longitude: -74.17751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12525',
  },
  {
    city: 'Germantown',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 42.3,
    imprecise: false,
    latitude: 42.12236,
    longitude: -73.85938,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12526',
  },
  {
    city: 'Glenham',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 88.6,
    imprecise: false,
    latitude: 41.51931,
    longitude: -73.93703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12527',
  },
  {
    city: 'Highland',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 119,
    imprecise: false,
    latitude: 41.72273,
    longitude: -74.00477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12528',
  },
  {
    city: 'Hillsdale',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 42.21335,
    longitude: -73.53802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12529',
  },
  {
    city: 'Hollowville',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 586,
    imprecise: false,
    latitude: 42.20692,
    longitude: -73.68413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12530',
  },
  {
    city: 'Holmes',
    county_fips: 36027,
    county_fips_all: '36027|36079',
    county: 'Dutchess',
    county_names_all: 'Dutchess|Putnam',
    county_weights: '{"36027": 83.98, "36079": 16.02}',
    density: 51.8,
    imprecise: false,
    latitude: 41.53689,
    longitude: -73.66917,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12531',
  },
  {
    city: 'Hopewell Junction',
    county_fips: 36027,
    county_fips_all: '36027|36079',
    county: 'Dutchess',
    county_names_all: 'Dutchess|Putnam',
    county_weights: '{"36027": 92.1, "36079": 7.9}',
    density: 215.9,
    imprecise: false,
    latitude: 41.55925,
    longitude: -73.79401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12533',
  },
  {
    city: 'Hudson',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 74.9,
    imprecise: false,
    latitude: 42.22434,
    longitude: -73.75427,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12534',
  },
  {
    city: 'Hyde Park',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 218,
    imprecise: false,
    latitude: 41.79246,
    longitude: -73.89336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12538',
  },
  {
    city: 'Lagrangeville',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 96.9,
    imprecise: false,
    latitude: 41.67073,
    longitude: -73.72524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12540',
  },
  {
    city: 'Marlboro',
    county_fips: 36111,
    county_fips_all: '36111|36071',
    county: 'Ulster',
    county_names_all: 'Ulster|Orange',
    county_weights: '{"36111": 91.03, "36071": 8.97}',
    density: 150.6,
    imprecise: false,
    latitude: 41.60772,
    longitude: -73.99666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12542',
  },
  {
    city: 'Maybrook',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 803.3,
    imprecise: false,
    latitude: 41.48602,
    longitude: -74.22354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12543',
  },
  {
    city: 'Mellenville',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 85.4,
    imprecise: false,
    latitude: 42.26129,
    longitude: -73.66822,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12544',
  },
  {
    city: 'Millbrook',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 29.6,
    imprecise: false,
    latitude: 41.7914,
    longitude: -73.67251,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12545',
  },
  {
    city: 'Millerton',
    county_fips: 36027,
    county_fips_all: '36027|36021',
    county: 'Dutchess',
    county_names_all: 'Dutchess|Columbia',
    county_weights: '{"36027": 79.05, "36021": 20.95}',
    density: 23,
    imprecise: false,
    latitude: 41.96627,
    longitude: -73.53313,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12546',
  },
  {
    city: 'Milton',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 131.4,
    imprecise: false,
    latitude: 41.65463,
    longitude: -73.98322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12547',
  },
  {
    city: 'Modena',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 105.6,
    imprecise: false,
    latitude: 41.66307,
    longitude: -74.10157,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12548',
  },
  {
    city: 'Montgomery',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 107.1,
    imprecise: false,
    latitude: 41.52957,
    longitude: -74.25843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12549',
  },
  {
    city: 'Newburgh',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 614.1,
    imprecise: false,
    latitude: 41.53671,
    longitude: -74.05196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12550',
  },
  {
    city: 'New Windsor',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 437.5,
    imprecise: false,
    latitude: 41.46146,
    longitude: -74.07311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12553',
  },
  {
    city: 'New Paltz',
    county_fips: 36111,
    county_fips_all: '36111',
    county: 'Ulster',
    county_names_all: 'Ulster',
    county_weights: '{"36111": 100}',
    density: 127.1,
    imprecise: false,
    latitude: 41.75602,
    longitude: -74.0958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12561',
  },
  {
    city: 'Patterson',
    county_fips: 36079,
    county_fips_all: '36079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"36079": 100}',
    density: 120.1,
    imprecise: false,
    latitude: 41.49417,
    longitude: -73.5891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12563',
  },
  {
    city: 'Pawling',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 72.2,
    imprecise: false,
    latitude: 41.57827,
    longitude: -73.5862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12564',
  },
  {
    city: 'Philmont',
    county_fips: 36021,
    county_fips_all: '36021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"36021": 100}',
    density: 392.4,
    imprecise: false,
    latitude: 42.24849,
    longitude: -73.64584,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12565',
  },
  {
    city: 'Pine Bush',
    county_fips: 36111,
    county_fips_all: '36111|36071|36105',
    county: 'Ulster',
    county_names_all: 'Ulster|Orange|Sullivan',
    county_weights: '{"36111": 56.52, "36071": 33.4, "36105": 10.08}',
    density: 71.1,
    imprecise: false,
    latitude: 41.62223,
    longitude: -74.33256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12566',
  },
  {
    city: 'Pine Plains',
    county_fips: 36027,
    county_fips_all: '36027|36021',
    county: 'Dutchess',
    county_names_all: 'Dutchess|Columbia',
    county_weights: '{"36027": 68.51, "36021": 31.49}',
    density: 22.6,
    imprecise: false,
    latitude: 41.98206,
    longitude: -73.65211,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12567',
  },
  {
    city: 'Pleasant Valley',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 114,
    imprecise: false,
    latitude: 41.7346,
    longitude: -73.79731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12569',
  },
  {
    city: 'Poughquag',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 130.2,
    imprecise: false,
    latitude: 41.62377,
    longitude: -73.66983,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12570',
  },
  {
    city: 'Red Hook',
    county_fips: 36027,
    county_fips_all: '36027|36021',
    county: 'Dutchess',
    county_names_all: 'Dutchess|Columbia',
    county_weights: '{"36027": 85.59, "36021": 14.41}',
    density: 67.1,
    imprecise: false,
    latitude: 42.00663,
    longitude: -73.81152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12571',
  },
  {
    city: 'Rhinebeck',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 67.1,
    imprecise: false,
    latitude: 41.92548,
    longitude: -73.8717,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12572',
  },
  {
    city: 'Rhinecliff',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 466.8,
    imprecise: false,
    latitude: 41.91764,
    longitude: -73.94566,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12574',
  },
  {
    city: 'Rock Tavern',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 38.5,
    imprecise: false,
    latitude: 41.48514,
    longitude: -74.15714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12575',
  },
  {
    city: 'Salisbury Mills',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 97.1,
    imprecise: false,
    latitude: 41.42048,
    longitude: -74.11678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12577',
  },
  {
    city: 'Salt Point',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 60.2,
    imprecise: false,
    latitude: 41.80629,
    longitude: -73.79673,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12578',
  },
  {
    city: 'Staatsburg',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 79.1,
    imprecise: false,
    latitude: 41.85348,
    longitude: -73.87302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12580',
  },
  {
    city: 'Stanfordville',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 19,
    imprecise: false,
    latitude: 41.90625,
    longitude: -73.69374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12581',
  },
  {
    city: 'Stormville',
    county_fips: 36027,
    county_fips_all: '36027|36079',
    county: 'Dutchess',
    county_names_all: 'Dutchess|Putnam',
    county_weights: '{"36027": 98.19, "36079": 1.81}',
    density: 157.8,
    imprecise: false,
    latitude: 41.54693,
    longitude: -73.72919,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12582',
  },
  {
    city: 'Tivoli',
    county_fips: 36027,
    county_fips_all: '36027|36021',
    county: 'Dutchess',
    county_names_all: 'Dutchess|Columbia',
    county_weights: '{"36027": 67.81, "36021": 32.19}',
    density: 66,
    imprecise: false,
    latitude: 42.05625,
    longitude: -73.88014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12583',
  },
  {
    city: 'Verbank',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 94.4,
    imprecise: false,
    latitude: 41.72396,
    longitude: -73.7025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12585',
  },
  {
    city: 'Walden',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 210.8,
    imprecise: false,
    latitude: 41.5657,
    longitude: -74.17289,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12586',
  },
  {
    city: 'Wallkill',
    county_fips: 36111,
    county_fips_all: '36111|36071',
    county: 'Ulster',
    county_names_all: 'Ulster|Orange',
    county_weights: '{"36111": 84.68, "36071": 15.32}',
    density: 121,
    imprecise: false,
    latitude: 41.6278,
    longitude: -74.15875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12589',
  },
  {
    city: 'Wappingers Falls',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 396,
    imprecise: false,
    latitude: 41.59559,
    longitude: -73.88774,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12590',
  },
  {
    city: 'Wassaic',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 31.9,
    imprecise: false,
    latitude: 41.78601,
    longitude: -73.5528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12592',
  },
  {
    city: 'Wingdale',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 70.7,
    imprecise: false,
    latitude: 41.66049,
    longitude: -73.56004,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12594',
  },
  {
    city: 'Poughkeepsie',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 933.1,
    imprecise: false,
    latitude: 41.70602,
    longitude: -73.91119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12601',
  },
  {
    city: 'Poughkeepsie',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 512.4,
    imprecise: false,
    latitude: 41.67816,
    longitude: -73.86744,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12603',
  },
  {
    city: 'Monticello',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 77.2,
    imprecise: false,
    latitude: 41.65125,
    longitude: -74.6982,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12701',
  },
  {
    city: 'Barryville',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 30.5,
    imprecise: false,
    latitude: 41.48431,
    longitude: -74.90543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12719',
  },
  {
    city: 'Bethel',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 41.65794,
    longitude: -74.90029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12720',
  },
  {
    city: 'Bloomingburg',
    county_fips: 36105,
    county_fips_all: '36105|36071',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Orange',
    county_weights: '{"36105": 69.27, "36071": 30.73}',
    density: 115.2,
    imprecise: false,
    latitude: 41.56741,
    longitude: -74.42832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12721',
  },
  {
    city: 'Burlingham',
    county_fips: 36105,
    county_fips_all: '36105|36071',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Orange',
    county_weights: '{"36105": 99.66, "36071": 0.34}',
    density: 0,
    imprecise: false,
    latitude: 41.59042,
    longitude: -74.3748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12722',
  },
  {
    city: 'Callicoon',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 22.2,
    imprecise: false,
    latitude: 41.77809,
    longitude: -75.02751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12723',
  },
  {
    city: 'Callicoon Center',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 41.85195,
    longitude: -74.93535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12724',
  },
  {
    city: 'Claryville',
    county_fips: 36111,
    county_fips_all: '36111|36105',
    county: 'Ulster',
    county_names_all: 'Ulster|Sullivan',
    county_weights: '{"36111": 78.72, "36105": 21.28}',
    density: 2.2,
    imprecise: false,
    latitude: 41.95679,
    longitude: -74.54794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12725',
  },
  {
    city: 'Cochecton',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 41.69269,
    longitude: -74.96902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12726',
  },
  {
    city: 'Cuddebackville',
    county_fips: 36071,
    county_fips_all: '36071|36105',
    county: 'Orange',
    county_names_all: 'Orange|Sullivan',
    county_weights: '{"36071": 54.02, "36105": 45.98}',
    density: 21,
    imprecise: false,
    latitude: 41.49411,
    longitude: -74.61582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12729',
  },
  {
    city: 'Eldred',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 41.56075,
    longitude: -74.87353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12732',
  },
  {
    city: 'Fallsburg',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 194.1,
    imprecise: false,
    latitude: 41.73378,
    longitude: -74.6102,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12733',
  },
  {
    city: 'Ferndale',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 26.1,
    imprecise: false,
    latitude: 41.7354,
    longitude: -74.7531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12734',
  },
  {
    city: 'Fremont Center',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 18.5,
    imprecise: false,
    latitude: 41.85327,
    longitude: -75.01917,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12736',
  },
  {
    city: 'Glen Spey',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 41.50529,
    longitude: -74.79941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12737',
  },
  {
    city: 'Glen Wild',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 79.3,
    imprecise: false,
    latitude: 41.66009,
    longitude: -74.59119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12738',
  },
  {
    city: 'Grahamsville',
    county_fips: 36111,
    county_fips_all: '36111|36105',
    county: 'Ulster',
    county_names_all: 'Ulster|Sullivan',
    county_weights: '{"36111": 62.56, "36105": 37.44}',
    density: 9.3,
    imprecise: false,
    latitude: 41.89499,
    longitude: -74.46616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12740',
  },
  {
    city: 'Hankins',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 41.84368,
    longitude: -75.07816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12741',
  },
  {
    city: 'Harris',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 43,
    imprecise: false,
    latitude: 41.71796,
    longitude: -74.72108,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12742',
  },
  {
    city: 'Highland Lake',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 41.54065,
    longitude: -74.84687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12743',
  },
  {
    city: 'Hortonville',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 41.78503,
    longitude: -75.02633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12745',
  },
  {
    city: 'Huguenot',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 41.44929,
    longitude: -74.65582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12746',
  },
  {
    city: 'Hurleyville',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 50.3,
    imprecise: false,
    latitude: 41.76596,
    longitude: -74.65934,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12747',
  },
  {
    city: 'Jeffersonville',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 41.77604,
    longitude: -74.91845,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12748',
  },
  {
    city: 'Kauneonga Lake',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 74.7,
    imprecise: false,
    latitude: 41.69149,
    longitude: -74.82768,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12749',
  },
  {
    city: 'Kenoza Lake',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 41.73595,
    longitude: -74.96382,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12750',
  },
  {
    city: 'Kiamesha Lake',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 209.4,
    imprecise: false,
    latitude: 41.69209,
    longitude: -74.66119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12751',
  },
  {
    city: 'Lake Huntington',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 77.3,
    imprecise: false,
    latitude: 41.68278,
    longitude: -74.9905,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12752',
  },
  {
    city: 'Liberty',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 113.2,
    imprecise: false,
    latitude: 41.80004,
    longitude: -74.73643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12754',
  },
  {
    city: 'Livingston Manor',
    county_fips: 36105,
    county_fips_all: '36105|36111|36025',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Ulster|Delaware',
    county_weights: '{"36105": 71.34, "36111": 27.81, "36025": 0.85}',
    density: 10.1,
    imprecise: false,
    latitude: 41.9428,
    longitude: -74.74942,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12758',
  },
  {
    city: 'Loch Sheldrake',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 158.5,
    imprecise: false,
    latitude: 41.78399,
    longitude: -74.65758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12759',
  },
  {
    city: 'Long Eddy',
    county_fips: 36025,
    county_fips_all: '36025|36105',
    county: 'Delaware',
    county_names_all: 'Delaware|Sullivan',
    county_weights: '{"36025": 78.52, "36105": 21.48}',
    density: 3.1,
    imprecise: false,
    latitude: 41.90063,
    longitude: -75.10559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12760',
  },
  {
    city: 'Mongaup Valley',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 41.65582,
    longitude: -74.79462,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12762',
  },
  {
    city: 'Mountain Dale',
    county_fips: 36105,
    county_fips_all: '36105|36111',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Ulster',
    county_weights: '{"36105": 96.65, "36111": 3.35}',
    density: 24.4,
    imprecise: false,
    latitude: 41.68221,
    longitude: -74.52205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12763',
  },
  {
    city: 'Narrowsburg',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 41.59639,
    longitude: -74.98515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12764',
  },
  {
    city: 'Neversink',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 41.85265,
    longitude: -74.6281,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12765',
  },
  {
    city: 'North Branch',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 41.81408,
    longitude: -74.97923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12766',
  },
  {
    city: 'Obernburg',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 29.5,
    imprecise: false,
    latitude: 41.83504,
    longitude: -75.00284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12767',
  },
  {
    city: 'Parksville',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 10,
    imprecise: false,
    latitude: 41.87157,
    longitude: -74.71507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12768',
  },
  {
    city: 'Phillipsport',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 29.7,
    imprecise: false,
    latitude: 41.65925,
    longitude: -74.47071,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12769',
  },
  {
    city: 'Pond Eddy',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 16,
    imprecise: false,
    latitude: 41.44681,
    longitude: -74.85028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12770',
  },
  {
    city: 'Port Jervis',
    county_fips: 36071,
    county_fips_all: '36071',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"36071": 100}',
    density: 156.9,
    imprecise: false,
    latitude: 41.37394,
    longitude: -74.62429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12771',
  },
  {
    city: 'Rock Hill',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 74.4,
    imprecise: false,
    latitude: 41.62266,
    longitude: -74.58232,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12775',
  },
  {
    city: 'Roscoe',
    county_fips: 36025,
    county_fips_all: '36025|36105',
    county: 'Delaware',
    county_names_all: 'Delaware|Sullivan',
    county_weights: '{"36025": 61.69, "36105": 38.31}',
    density: 6.9,
    imprecise: false,
    latitude: 41.96486,
    longitude: -74.93197,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12776',
  },
  {
    city: 'Forestburgh',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 6,
    imprecise: false,
    latitude: 41.55172,
    longitude: -74.71067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12777',
  },
  {
    city: 'Smallwood',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 158.5,
    imprecise: false,
    latitude: 41.66174,
    longitude: -74.8138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12778',
  },
  {
    city: 'South Fallsburg',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 126.7,
    imprecise: false,
    latitude: 41.69804,
    longitude: -74.62703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12779',
  },
  {
    city: 'Sparrow Bush',
    county_fips: 36071,
    county_fips_all: '36071|36105',
    county: 'Orange',
    county_names_all: 'Orange|Sullivan',
    county_weights: '{"36071": 93.28, "36105": 6.72}',
    density: 36.7,
    imprecise: false,
    latitude: 41.44514,
    longitude: -74.71989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12780',
  },
  {
    city: 'Summitville',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 41.61448,
    longitude: -74.47208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12781',
  },
  {
    city: 'Swan Lake',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 41.74026,
    longitude: -74.83502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12783',
  },
  {
    city: 'Thompsonville',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.66907,
    longitude: -74.61485,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12784',
  },
  {
    city: 'Westbrookville',
    county_fips: 36105,
    county_fips_all: '36105|36071',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Orange',
    county_weights: '{"36105": 77.87, "36071": 22.13}',
    density: 26.1,
    imprecise: false,
    latitude: 41.52429,
    longitude: -74.58051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12785',
  },
  {
    city: 'White Lake',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 41.64306,
    longitude: -74.85393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12786',
  },
  {
    city: 'White Sulphur Springs',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 29.2,
    imprecise: false,
    latitude: 41.7931,
    longitude: -74.8365,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12787',
  },
  {
    city: 'Woodbourne',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 52.9,
    imprecise: false,
    latitude: 41.79552,
    longitude: -74.58846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12788',
  },
  {
    city: 'Woodridge',
    county_fips: 36105,
    county_fips_all: '36105|36111',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Ulster',
    county_weights: '{"36105": 88.87, "36111": 11.13}',
    density: 63,
    imprecise: false,
    latitude: 41.71374,
    longitude: -74.57233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12789',
  },
  {
    city: 'Wurtsboro',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 34,
    imprecise: false,
    latitude: 41.5863,
    longitude: -74.51705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12790',
  },
  {
    city: 'Youngsville',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 81.4,
    imprecise: false,
    latitude: 41.81126,
    longitude: -74.88692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12791',
  },
  {
    city: 'Yulan',
    county_fips: 36105,
    county_fips_all: '36105',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"36105": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 41.51447,
    longitude: -74.95172,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12792',
  },
  {
    city: 'Glens Falls',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 1490.3,
    imprecise: false,
    latitude: 43.31097,
    longitude: -73.64545,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12801',
  },
  {
    city: 'South Glens Falls',
    county_fips: 36091,
    county_fips_all: '36091|36113',
    county: 'Saratoga',
    county_names_all: 'Saratoga|Warren',
    county_weights: '{"36091": 98.0, "36113": 2.0}',
    density: 618.6,
    imprecise: false,
    latitude: 43.28891,
    longitude: -73.63024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12803',
  },
  {
    city: 'Queensbury',
    county_fips: 36113,
    county_fips_all: '36113|36115|36091',
    county: 'Warren',
    county_names_all: 'Warren|Washington|Saratoga',
    county_weights: '{"36113": 96.37, "36115": 3.47, "36091": 0.16}',
    density: 199.2,
    imprecise: false,
    latitude: 43.3375,
    longitude: -73.68307,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12804',
  },
  {
    city: 'Adirondack',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 43.74782,
    longitude: -73.75393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12808',
  },
  {
    city: 'Argyle',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 27.1,
    imprecise: false,
    latitude: 43.24097,
    longitude: -73.4624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12809',
  },
  {
    city: 'Athol',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 43.49862,
    longitude: -73.95217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12810',
  },
  {
    city: 'Bakers Mills',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 43.57502,
    longitude: -74.07508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12811',
  },
  {
    city: 'Blue Mountain Lake',
    county_fips: 36041,
    county_fips_all: '36041',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"36041": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 43.85731,
    longitude: -74.41213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12812',
  },
  {
    city: 'Bolton Landing',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 10,
    imprecise: false,
    latitude: 43.6004,
    longitude: -73.63678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12814',
  },
  {
    city: 'Brant Lake',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 43.70161,
    longitude: -73.69459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12815',
  },
  {
    city: 'Cambridge',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 31.1,
    imprecise: false,
    latitude: 43.05085,
    longitude: -73.37829,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12816',
  },
  {
    city: 'Chestertown',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 43.63697,
    longitude: -73.82614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12817',
  },
  {
    city: 'Clemons',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 43.61144,
    longitude: -73.46315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12819',
  },
  {
    city: 'Cleverdale',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 30.1,
    imprecise: false,
    latitude: 43.46022,
    longitude: -73.64067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12820',
  },
  {
    city: 'Comstock',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 146.9,
    imprecise: false,
    latitude: 43.45866,
    longitude: -73.41332,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12821',
  },
  {
    city: 'Corinth',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 35.8,
    imprecise: false,
    latitude: 43.2407,
    longitude: -73.88959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12822',
  },
  {
    city: 'Cossayuna',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 59.6,
    imprecise: false,
    latitude: 43.17945,
    longitude: -73.40628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12823',
  },
  {
    city: 'Diamond Point',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 43.5279,
    longitude: -73.71386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12824',
  },
  {
    city: 'Fort Ann',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 43.44917,
    longitude: -73.51241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12827',
  },
  {
    city: 'Fort Edward',
    county_fips: 36115,
    county_fips_all: '36115|36091',
    county: 'Washington',
    county_names_all: 'Washington|Saratoga',
    county_weights: '{"36115": 73.81, "36091": 26.19}',
    density: 79,
    imprecise: false,
    latitude: 43.25534,
    longitude: -73.56841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12828',
  },
  {
    city: 'Gansevoort',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 106.7,
    imprecise: false,
    latitude: 43.19533,
    longitude: -73.68791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12831',
  },
  {
    city: 'Granville',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 30.1,
    imprecise: false,
    latitude: 43.36813,
    longitude: -73.31716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12832',
  },
  {
    city: 'Greenfield Center',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 55,
    imprecise: false,
    latitude: 43.13866,
    longitude: -73.84355,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12833',
  },
  {
    city: 'Greenwich',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 27.6,
    imprecise: false,
    latitude: 43.09706,
    longitude: -73.50423,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12834',
  },
  {
    city: 'Hadley',
    county_fips: 36091,
    county_fips_all: '36091|36113',
    county: 'Saratoga',
    county_names_all: 'Saratoga|Warren',
    county_weights: '{"36091": 99.1, "36113": 0.9}',
    density: 10.3,
    imprecise: false,
    latitude: 43.32496,
    longitude: -74.00589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12835',
  },
  {
    city: 'Hague',
    county_fips: 36113,
    county_fips_all: '36113|36031',
    county: 'Warren',
    county_names_all: 'Warren|Essex',
    county_weights: '{"36113": 97.59, "36031": 2.41}',
    density: 4.4,
    imprecise: false,
    latitude: 43.74994,
    longitude: -73.56816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12836',
  },
  {
    city: 'Hampton',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 43.50842,
    longitude: -73.26651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12837',
  },
  {
    city: 'Hartford',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 52.1,
    imprecise: false,
    latitude: 43.34354,
    longitude: -73.40756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12838',
  },
  {
    city: 'Hudson Falls',
    county_fips: 36115,
    county_fips_all: '36115|36113',
    county: 'Washington',
    county_names_all: 'Washington|Warren',
    county_weights: '{"36115": 99.71, "36113": 0.29}',
    density: 168.5,
    imprecise: false,
    latitude: 43.34496,
    longitude: -73.55058,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12839',
  },
  {
    city: 'Huletts Landing',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 43.59919,
    longitude: -73.5165,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12841',
  },
  {
    city: 'Indian Lake',
    county_fips: 36041,
    county_fips_all: '36041',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"36041": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 43.75058,
    longitude: -74.2746,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12842',
  },
  {
    city: 'Johnsburg',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 43.5849,
    longitude: -73.97771,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12843',
  },
  {
    city: 'Kattskill Bay',
    county_fips: 36113,
    county_fips_all: '36113|36115',
    county: 'Warren',
    county_names_all: 'Warren|Washington',
    county_weights: '{"36113": 64.4, "36115": 35.6}',
    density: 22,
    imprecise: false,
    latitude: 43.49423,
    longitude: -73.64081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12844',
  },
  {
    city: 'Lake George',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 37.5,
    imprecise: false,
    latitude: 43.42757,
    longitude: -73.70703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12845',
  },
  {
    city: 'Lake Luzerne',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 43.34022,
    longitude: -73.80592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12846',
  },
  {
    city: 'Long Lake',
    county_fips: 36041,
    county_fips_all: '36041|36089',
    county: 'Hamilton',
    county_names_all: 'Hamilton|St. Lawrence',
    county_weights: '{"36041": 91.52, "36089": 8.48}',
    density: 0.6,
    imprecise: false,
    latitude: 43.98698,
    longitude: -74.59024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12847',
  },
  {
    city: 'Middle Granville',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 55,
    imprecise: false,
    latitude: 43.44812,
    longitude: -73.2985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12849',
  },
  {
    city: 'Middle Grove',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 24.1,
    imprecise: false,
    latitude: 43.09886,
    longitude: -73.97941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12850',
  },
  {
    city: 'Minerva',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 43.85171,
    longitude: -74.06211,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12851',
  },
  {
    city: 'Newcomb',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 1,
    imprecise: false,
    latitude: 43.99293,
    longitude: -74.13598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12852',
  },
  {
    city: 'North Creek',
    county_fips: 36113,
    county_fips_all: '36113|36031',
    county: 'Warren',
    county_names_all: 'Warren|Essex',
    county_weights: '{"36113": 99.05, "36031": 0.95}',
    density: 6,
    imprecise: false,
    latitude: 43.68816,
    longitude: -73.99804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12853',
  },
  {
    city: 'North Granville',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 319.3,
    imprecise: false,
    latitude: 43.45019,
    longitude: -73.32767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 86,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12854',
  },
  {
    city: 'North Hudson',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 44.00121,
    longitude: -73.79762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12855',
  },
  {
    city: 'North River',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 43.65531,
    longitude: -74.14625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12856',
  },
  {
    city: 'Olmstedville',
    county_fips: 36031,
    county_fips_all: '36031|36113',
    county: 'Essex',
    county_names_all: 'Essex|Warren',
    county_weights: '{"36031": 98.26, "36113": 1.74}',
    density: 3.4,
    imprecise: false,
    latitude: 43.84033,
    longitude: -73.93354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12857',
  },
  {
    city: 'Paradox',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 43.88899,
    longitude: -73.6703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12858',
  },
  {
    city: 'Porter Corners',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 31.5,
    imprecise: false,
    latitude: 43.16587,
    longitude: -73.90569,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12859',
  },
  {
    city: 'Pottersville',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 43.72843,
    longitude: -73.80942,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12860',
  },
  {
    city: 'Putnam Station',
    county_fips: 36115,
    county_fips_all: '36115|36031',
    county: 'Washington',
    county_names_all: 'Washington|Essex',
    county_weights: '{"36115": 99.04, "36031": 0.96}',
    density: 6,
    imprecise: false,
    latitude: 43.74982,
    longitude: -73.41502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12861',
  },
  {
    city: 'Riparius',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 43.67419,
    longitude: -73.91878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12862',
  },
  {
    city: 'Rock City Falls',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 92.4,
    imprecise: false,
    latitude: 43.06031,
    longitude: -73.93162,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12863',
  },
  {
    city: 'Sabael',
    county_fips: 36041,
    county_fips_all: '36041',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"36041": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 43.72733,
    longitude: -74.3054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12864',
  },
  {
    city: 'Salem',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 43.21225,
    longitude: -73.34191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12865',
  },
  {
    city: 'Saratoga Springs',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 240.5,
    imprecise: false,
    latitude: 43.07537,
    longitude: -73.7401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12866',
  },
  {
    city: 'Schroon Lake',
    county_fips: 36031,
    county_fips_all: '36031|36113',
    county: 'Essex',
    county_names_all: 'Essex|Warren',
    county_weights: '{"36031": 98.11, "36113": 1.89}',
    density: 6.9,
    imprecise: false,
    latitude: 43.83931,
    longitude: -73.7625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12870',
  },
  {
    city: 'Schuylerville',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 52.7,
    imprecise: false,
    latitude: 43.09249,
    longitude: -73.61196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12871',
  },
  {
    city: 'Severance',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 43.8839,
    longitude: -73.72309,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12872',
  },
  {
    city: 'Shushan',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 43.1185,
    longitude: -73.30682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12873',
  },
  {
    city: 'Silver Bay',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 43.69035,
    longitude: -73.54836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12874',
  },
  {
    city: 'Stony Creek',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 43.44217,
    longitude: -74.0479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12878',
  },
  {
    city: 'Ticonderoga',
    county_fips: 36031,
    county_fips_all: '36031|36115',
    county: 'Essex',
    county_names_all: 'Essex|Washington',
    county_weights: '{"36031": 98.8, "36115": 1.2}',
    density: 21.7,
    imprecise: false,
    latitude: 43.85291,
    longitude: -73.50786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12883',
  },
  {
    city: 'Victory Mills',
    county_fips: 36091,
    county_fips_all: '36091',
    county: 'Saratoga',
    county_names_all: 'Saratoga',
    county_weights: '{"36091": 100}',
    density: 468.6,
    imprecise: false,
    latitude: 43.08855,
    longitude: -73.5921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12884',
  },
  {
    city: 'Warrensburg',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 43.52929,
    longitude: -73.83161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12885',
  },
  {
    city: 'Wevertown',
    county_fips: 36113,
    county_fips_all: '36113',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"36113": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 43.63689,
    longitude: -73.92654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12886',
  },
  {
    city: 'Whitehall',
    county_fips: 36115,
    county_fips_all: '36115',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"36115": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 43.54504,
    longitude: -73.37471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12887',
  },
  {
    city: 'Plattsburgh',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 172,
    imprecise: false,
    latitude: 44.70842,
    longitude: -73.47465,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12901',
  },
  {
    city: 'Plattsburgh',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 166.2,
    imprecise: false,
    latitude: 44.65698,
    longitude: -73.46306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12903',
  },
  {
    city: 'Altona',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 44.8546,
    longitude: -73.64593,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12910',
  },
  {
    city: 'Keeseville',
    county_fips: 36019,
    county_fips_all: '36019|36031',
    county: 'Clinton',
    county_names_all: 'Clinton|Essex',
    county_weights: '{"36019": 80.99, "36031": 19.01}',
    density: 10.1,
    imprecise: false,
    latitude: 44.53464,
    longitude: -73.46687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12911',
  },
  {
    city: 'Au Sable Forks',
    county_fips: 36019,
    county_fips_all: '36019|36031',
    county: 'Clinton',
    county_names_all: 'Clinton|Essex',
    county_weights: '{"36019": 77.09, "36031": 22.91}',
    density: 6.8,
    imprecise: false,
    latitude: 44.46233,
    longitude: -73.74201,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12912',
  },
  {
    city: 'Bloomingdale',
    county_fips: 36033,
    county_fips_all: '36033|36031',
    county: 'Franklin',
    county_names_all: 'Franklin|Essex',
    county_weights: '{"36033": 58.74, "36031": 41.26}',
    density: 12.5,
    imprecise: false,
    latitude: 44.42627,
    longitude: -74.01562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12913',
  },
  {
    city: 'Bombay',
    county_fips: 36033,
    county_fips_all: '36033|36089',
    county: 'Franklin',
    county_names_all: 'Franklin|St. Lawrence',
    county_weights: '{"36033": 83.54, "36089": 16.46}',
    density: 9.1,
    imprecise: false,
    latitude: 44.93289,
    longitude: -74.6018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12914',
  },
  {
    city: 'Brainardsville',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 128,
    imprecise: false,
    latitude: 44.8535,
    longitude: -74.035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12915',
  },
  {
    city: 'Brushton',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 44.83572,
    longitude: -74.5145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12916',
  },
  {
    city: 'Burke',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 44.92468,
    longitude: -74.17387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12917',
  },
  {
    city: 'Cadyville',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 44.68975,
    longitude: -73.67863,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12918',
  },
  {
    city: 'Champlain',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 30.6,
    imprecise: false,
    latitude: 44.96793,
    longitude: -73.45072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12919',
  },
  {
    city: 'Chateaugay',
    county_fips: 36033,
    county_fips_all: '36033|36019',
    county: 'Franklin',
    county_names_all: 'Franklin|Clinton',
    county_weights: '{"36033": 92.69, "36019": 7.31}',
    density: 12.7,
    imprecise: false,
    latitude: 44.89332,
    longitude: -74.06016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12920',
  },
  {
    city: 'Chazy',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 28,
    imprecise: false,
    latitude: 44.89188,
    longitude: -73.43574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12921',
  },
  {
    city: 'Childwold',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 44.33381,
    longitude: -74.7827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12922',
  },
  {
    city: 'Churubusco',
    county_fips: 36019,
    county_fips_all: '36019|36033',
    county: 'Clinton',
    county_names_all: 'Clinton|Franklin',
    county_weights: '{"36019": 99.85, "36033": 0.15}',
    density: 4.8,
    imprecise: false,
    latitude: 44.94546,
    longitude: -73.95802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12923',
  },
  {
    city: 'Keeseville',
    county_fips: 36019,
    county_fips_all: '36019|36031',
    county: 'Clinton',
    county_names_all: 'Clinton|Essex',
    county_weights: '{"36019": 99.86, "36031": 0.14}',
    density: 45.3,
    imprecise: false,
    latitude: 44.47589,
    longitude: -73.58751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12924',
  },
  {
    city: 'Constable',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 44.95223,
    longitude: -74.32214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12926',
  },
  {
    city: 'Cranberry Lake',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 44.2005,
    longitude: -74.81818,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12927',
  },
  {
    city: 'Crown Point',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 43.9539,
    longitude: -73.52898,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12928',
  },
  {
    city: 'Dannemora',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 831.6,
    imprecise: false,
    latitude: 44.71971,
    longitude: -73.71909,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12929',
  },
  {
    city: 'Dickinson Center',
    county_fips: 36033,
    county_fips_all: '36033|36089',
    county: 'Franklin',
    county_names_all: 'Franklin|St. Lawrence',
    county_weights: '{"36033": 95.8, "36089": 4.2}',
    density: 9.7,
    imprecise: false,
    latitude: 44.72349,
    longitude: -74.5437,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12930',
  },
  {
    city: 'Elizabethtown',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 7,
    imprecise: false,
    latitude: 44.21222,
    longitude: -73.6082,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12932',
  },
  {
    city: 'Ellenburg',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 98.8,
    imprecise: false,
    latitude: 44.89118,
    longitude: -73.84512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12933',
  },
  {
    city: 'Ellenburg Center',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 44.84603,
    longitude: -73.87659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12934',
  },
  {
    city: 'Ellenburg Depot',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 44.85709,
    longitude: -73.79461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12935',
  },
  {
    city: 'Essex',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 44.26869,
    longitude: -73.4029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12936',
  },
  {
    city: 'Fort Covington',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 44.96176,
    longitude: -74.47807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12937',
  },
  {
    city: 'Gabriels',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 44.43859,
    longitude: -74.16541,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12939',
  },
  {
    city: 'Jay',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 44.35147,
    longitude: -73.7126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12941',
  },
  {
    city: 'Keene',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 44.26023,
    longitude: -73.79523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12942',
  },
  {
    city: 'Keene Valley',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 1,
    imprecise: false,
    latitude: 44.13934,
    longitude: -73.82075,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12943',
  },
  {
    city: 'Keeseville',
    county_fips: 36031,
    county_fips_all: '36031|36019',
    county: 'Essex',
    county_names_all: 'Essex|Clinton',
    county_weights: '{"36031": 87.81, "36019": 12.19}',
    density: 16.6,
    imprecise: false,
    latitude: 44.44585,
    longitude: -73.51193,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12944',
  },
  {
    city: 'Lake Clear',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 44.33451,
    longitude: -74.23829,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12945',
  },
  {
    city: 'Lake Placid',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 44.23162,
    longitude: -73.98903,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12946',
  },
  {
    city: 'Lewis',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 44.32685,
    longitude: -73.57675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12950',
  },
  {
    city: 'Lyon Mountain',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 44.71181,
    longitude: -73.91362,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12952',
  },
  {
    city: 'Malone',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 44.74198,
    longitude: -74.26347,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12953',
  },
  {
    city: 'Lyon Mountain',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 44.78934,
    longitude: -73.95855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12955',
  },
  {
    city: 'Mineville',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 52,
    imprecise: false,
    latitude: 44.09301,
    longitude: -73.49628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12956',
  },
  {
    city: 'Moira',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 44.85353,
    longitude: -74.57706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12957',
  },
  {
    city: 'Mooers',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 44.95661,
    longitude: -73.57419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12958',
  },
  {
    city: 'Mooers Forks',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 44.96073,
    longitude: -73.7014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12959',
  },
  {
    city: 'Moriah',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 18,
    imprecise: false,
    latitude: 44.02226,
    longitude: -73.54123,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12960',
  },
  {
    city: 'Moriah Center',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 44.06103,
    longitude: -73.57972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12961',
  },
  {
    city: 'Morrisonville',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 57,
    imprecise: false,
    latitude: 44.70642,
    longitude: -73.60141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12962',
  },
  {
    city: 'New Russia',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 44.13224,
    longitude: -73.63625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12964',
  },
  {
    city: 'Nicholville',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 15,
    imprecise: false,
    latitude: 44.70587,
    longitude: -74.684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12965',
  },
  {
    city: 'North Bangor',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 44.79226,
    longitude: -74.41915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12966',
  },
  {
    city: 'North Lawrence',
    county_fips: 36089,
    county_fips_all: '36089|36033',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence|Franklin',
    county_weights: '{"36089": 97.65, "36033": 2.35}',
    density: 14.6,
    imprecise: false,
    latitude: 44.76864,
    longitude: -74.65897,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12967',
  },
  {
    city: 'Owls Head',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 1,
    imprecise: false,
    latitude: 44.71102,
    longitude: -74.0812,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12969',
  },
  {
    city: 'Paul Smiths',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 44.44949,
    longitude: -74.33222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12970',
  },
  {
    city: 'Peru',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 34.9,
    imprecise: false,
    latitude: 44.559,
    longitude: -73.56516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12972',
  },
  {
    city: 'Piercefield',
    county_fips: 36089,
    county_fips_all: '36089|36033',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence|Franklin',
    county_weights: '{"36089": 99.76, "36033": 0.24}',
    density: 2,
    imprecise: false,
    latitude: 44.30279,
    longitude: -74.59187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12973',
  },
  {
    city: 'Port Henry',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 91.8,
    imprecise: false,
    latitude: 44.05582,
    longitude: -73.46931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12974',
  },
  {
    city: 'Port Kent',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 44.52977,
    longitude: -73.431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 78,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12975',
  },
  {
    city: 'Rainbow Lake',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 44.50469,
    longitude: -74.20498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12976',
  },
  {
    city: 'Ray Brook',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 376.6,
    imprecise: false,
    latitude: 44.29484,
    longitude: -74.09673,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12977',
  },
  {
    city: 'Redford',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 119.8,
    imprecise: false,
    latitude: 44.6181,
    longitude: -73.79589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12978',
  },
  {
    city: 'Rouses Point',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 229,
    imprecise: false,
    latitude: 44.98926,
    longitude: -73.37213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12979',
  },
  {
    city: 'Saint Regis Falls',
    county_fips: 36033,
    county_fips_all: '36033|36089',
    county: 'Franklin',
    county_names_all: 'Franklin|St. Lawrence',
    county_weights: '{"36033": 81.41, "36089": 18.59}',
    density: 1.7,
    imprecise: false,
    latitude: 44.57254,
    longitude: -74.50875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12980',
  },
  {
    city: 'Saranac',
    county_fips: 36019,
    county_fips_all: '36019|36033',
    county: 'Clinton',
    county_names_all: 'Clinton|Franklin',
    county_weights: '{"36019": 94.53, "36033": 5.47}',
    density: 7.5,
    imprecise: false,
    latitude: 44.62235,
    longitude: -73.84035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12981',
  },
  {
    city: 'Saranac Lake',
    county_fips: 36033,
    county_fips_all: '36033|36031',
    county: 'Franklin',
    county_names_all: 'Franklin|Essex',
    county_weights: '{"36033": 55.65, "36031": 44.35}',
    density: 24.3,
    imprecise: false,
    latitude: 44.34627,
    longitude: -74.14243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12983',
  },
  {
    city: 'Schuyler Falls',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 44.56413,
    longitude: -73.73395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12985',
  },
  {
    city: 'Tupper Lake',
    county_fips: 36033,
    county_fips_all: '36033|36089',
    county: 'Franklin',
    county_names_all: 'Franklin|St. Lawrence',
    county_weights: '{"36033": 75.43, "36089": 24.57}',
    density: 7.2,
    imprecise: false,
    latitude: 44.22279,
    longitude: -74.44056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12986',
  },
  {
    city: 'Upper Jay',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 44.33948,
    longitude: -73.76386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12987',
  },
  {
    city: 'Vermontville',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 3,
    imprecise: false,
    latitude: 44.53935,
    longitude: -74.06439,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12989',
  },
  {
    city: 'West Chazy',
    county_fips: 36019,
    county_fips_all: '36019',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"36019": 100}',
    density: 27.1,
    imprecise: false,
    latitude: 44.81822,
    longitude: -73.51582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12992',
  },
  {
    city: 'Westport',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 44.19711,
    longitude: -73.48097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12993',
  },
  {
    city: 'Willsboro',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 44.36129,
    longitude: -73.42129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12996',
  },
  {
    city: 'Wilmington',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 44.3755,
    longitude: -73.84314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12997',
  },
  {
    city: 'Witherbee',
    county_fips: 36031,
    county_fips_all: '36031',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"36031": 100}',
    density: 20.7,
    imprecise: false,
    latitude: 44.0879,
    longitude: -73.57584,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12998',
  },
  {
    city: 'Apulia Station',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 71,
    imprecise: false,
    latitude: 42.81646,
    longitude: -76.07458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 86,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13020',
  },
  {
    city: 'Auburn',
    county_fips: 36011,
    county_fips_all: '36011|36067',
    county: 'Cayuga',
    county_names_all: 'Cayuga|Onondaga',
    county_weights: '{"36011": 99.67, "36067": 0.33}',
    density: 120.7,
    imprecise: false,
    latitude: 42.91713,
    longitude: -76.5542,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13021',
  },
  {
    city: 'Aurora',
    county_fips: 36011,
    county_fips_all: '36011',
    county: 'Cayuga',
    county_names_all: 'Cayuga',
    county_weights: '{"36011": 100}',
    density: 23.8,
    imprecise: false,
    latitude: 42.75044,
    longitude: -76.65968,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13026',
  },
  {
    city: 'Baldwinsville',
    county_fips: 36067,
    county_fips_all: '36067|36011',
    county: 'Onondaga',
    county_names_all: 'Onondaga|Cayuga',
    county_weights: '{"36067": 99.3, "36011": 0.7}',
    density: 202.3,
    imprecise: false,
    latitude: 43.16741,
    longitude: -76.36258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13027',
  },
  {
    city: 'Bernhards Bay',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 43.29226,
    longitude: -75.93107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13028',
  },
  {
    city: 'Brewerton',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 169.1,
    imprecise: false,
    latitude: 43.2236,
    longitude: -76.14993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13029',
  },
  {
    city: 'Bridgeport',
    county_fips: 36053,
    county_fips_all: '36053|36067',
    county: 'Madison',
    county_names_all: 'Madison|Onondaga',
    county_weights: '{"36053": 64.19, "36067": 35.81}',
    density: 124.4,
    imprecise: false,
    latitude: 43.15962,
    longitude: -75.96052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13030',
  },
  {
    city: 'Camillus',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 258.7,
    imprecise: false,
    latitude: 43.0448,
    longitude: -76.30775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13031',
  },
  {
    city: 'Canastota',
    county_fips: 36053,
    county_fips_all: '36053|36065',
    county: 'Madison',
    county_names_all: 'Madison|Oneida',
    county_weights: '{"36053": 99.67, "36065": 0.33}',
    density: 60.1,
    imprecise: false,
    latitude: 43.07793,
    longitude: -75.76275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13032',
  },
  {
    city: 'Cato',
    county_fips: 36011,
    county_fips_all: '36011',
    county: 'Cayuga',
    county_names_all: 'Cayuga',
    county_weights: '{"36011": 100}',
    density: 23.5,
    imprecise: false,
    latitude: 43.1852,
    longitude: -76.57044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13033',
  },
  {
    city: 'Cayuga',
    county_fips: 36011,
    county_fips_all: '36011',
    county: 'Cayuga',
    county_names_all: 'Cayuga',
    county_weights: '{"36011": 100}',
    density: 32,
    imprecise: false,
    latitude: 42.91366,
    longitude: -76.69502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13034',
  },
  {
    city: 'Cazenovia',
    county_fips: 36053,
    county_fips_all: '36053|36067',
    county: 'Madison',
    county_names_all: 'Madison|Onondaga',
    county_weights: '{"36053": 96.96, "36067": 3.04}',
    density: 43.3,
    imprecise: false,
    latitude: 42.93828,
    longitude: -75.82551,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13035',
  },
  {
    city: 'Central Square',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 72.2,
    imprecise: false,
    latitude: 43.32268,
    longitude: -76.17402,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13036',
  },
  {
    city: 'Chittenango',
    county_fips: 36053,
    county_fips_all: '36053|36067',
    county: 'Madison',
    county_names_all: 'Madison|Onondaga',
    county_weights: '{"36053": 95.56, "36067": 4.44}',
    density: 87.2,
    imprecise: false,
    latitude: 43.06046,
    longitude: -75.86521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13037',
  },
  {
    city: 'Cicero',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 277.8,
    imprecise: false,
    latitude: 43.16678,
    longitude: -76.0654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13039',
  },
  {
    city: 'Cincinnatus',
    county_fips: 36023,
    county_fips_all: '36023|36017',
    county: 'Cortland',
    county_names_all: 'Cortland|Chenango',
    county_weights: '{"36023": 84.53, "36017": 15.47}',
    density: 10,
    imprecise: false,
    latitude: 42.56033,
    longitude: -75.93029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13040',
  },
  {
    city: 'Clay',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 263.4,
    imprecise: false,
    latitude: 43.19079,
    longitude: -76.19711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13041',
  },
  {
    city: 'Cleveland',
    county_fips: 36065,
    county_fips_all: '36065|36075',
    county: 'Oneida',
    county_names_all: 'Oneida|Oswego',
    county_weights: '{"36065": 63.3, "36075": 36.7}',
    density: 22,
    imprecise: false,
    latitude: 43.26565,
    longitude: -75.85154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13042',
  },
  {
    city: 'Constantia',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 33.9,
    imprecise: false,
    latitude: 43.2977,
    longitude: -75.99595,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13044',
  },
  {
    city: 'Cortland',
    county_fips: 36023,
    county_fips_all: '36023|36011|36109',
    county: 'Cortland',
    county_names_all: 'Cortland|Cayuga|Tompkins',
    county_weights: '{"36023": 84.99, "36011": 8.92, "36109": 6.09}',
    density: 101.5,
    imprecise: false,
    latitude: 42.58692,
    longitude: -76.19029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13045',
  },
  {
    city: 'Delphi Falls',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 49.4,
    imprecise: false,
    latitude: 42.88339,
    longitude: -75.91021,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13051',
  },
  {
    city: 'De Ruyter',
    county_fips: 36053,
    county_fips_all: '36053|36017|36023|36067',
    county: 'Madison',
    county_names_all: 'Madison|Chenango|Cortland|Onondaga',
    county_weights:
      '{"36053": 38.2, "36017": 32.41, "36023": 25.17, "36067": 4.22}',
    density: 11.4,
    imprecise: false,
    latitude: 42.72838,
    longitude: -75.86957,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13052',
  },
  {
    city: 'Dryden',
    county_fips: 36109,
    county_fips_all: '36109|36023',
    county: 'Tompkins',
    county_names_all: 'Tompkins|Cortland',
    county_weights: '{"36109": 57.89, "36023": 42.11}',
    density: 53.2,
    imprecise: false,
    latitude: 42.47513,
    longitude: -76.26471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13053',
  },
  {
    city: 'Durhamville',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 22.2,
    imprecise: false,
    latitude: 43.16947,
    longitude: -75.66923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13054',
  },
  {
    city: 'East Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 198.7,
    imprecise: false,
    latitude: 43.09543,
    longitude: -76.04014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13057',
  },
  {
    city: 'Elbridge',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 65.1,
    imprecise: false,
    latitude: 43.02381,
    longitude: -76.41926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13060',
  },
  {
    city: 'Erieville',
    county_fips: 36053,
    county_fips_all: '36053',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"36053": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 42.86493,
    longitude: -75.75173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13061',
  },
  {
    city: 'Etna',
    county_fips: 36109,
    county_fips_all: '36109',
    county: 'Tompkins',
    county_names_all: 'Tompkins',
    county_weights: '{"36109": 100}',
    density: 110.6,
    imprecise: false,
    latitude: 42.48121,
    longitude: -76.38694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13062',
  },
  {
    city: 'Fabius',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 42.84429,
    longitude: -75.98023,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13063',
  },
  {
    city: 'Fayette',
    county_fips: 36099,
    county_fips_all: '36099',
    county: 'Seneca',
    county_names_all: 'Seneca',
    county_weights: '{"36099": 100}',
    density: 35,
    imprecise: false,
    latitude: 42.81884,
    longitude: -76.81577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13065',
  },
  {
    city: 'Fayetteville',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 326.4,
    imprecise: false,
    latitude: 43.03297,
    longitude: -76.00259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13066',
  },
  {
    city: 'Freeville',
    county_fips: 36109,
    county_fips_all: '36109',
    county: 'Tompkins',
    county_names_all: 'Tompkins',
    county_weights: '{"36109": 100}',
    density: 35,
    imprecise: false,
    latitude: 42.49905,
    longitude: -76.35555,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13068',
  },
  {
    city: 'Fulton',
    county_fips: 36075,
    county_fips_all: '36075|36067',
    county: 'Oswego',
    county_names_all: 'Oswego|Onondaga',
    county_weights: '{"36075": 98.98, "36067": 1.02}',
    density: 80.2,
    imprecise: false,
    latitude: 43.33081,
    longitude: -76.37867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13069',
  },
  {
    city: 'Genoa',
    county_fips: 36011,
    county_fips_all: '36011',
    county: 'Cayuga',
    county_names_all: 'Cayuga',
    county_weights: '{"36011": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 42.67584,
    longitude: -76.54252,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13071',
  },
  {
    city: 'Georgetown',
    county_fips: 36053,
    county_fips_all: '36053|36017',
    county: 'Madison',
    county_names_all: 'Madison|Chenango',
    county_weights: '{"36053": 77.59, "36017": 22.41}',
    density: 7,
    imprecise: false,
    latitude: 42.76243,
    longitude: -75.76296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13072',
  },
  {
    city: 'Groton',
    county_fips: 36109,
    county_fips_all: '36109|36011',
    county: 'Tompkins',
    county_names_all: 'Tompkins|Cayuga',
    county_weights: '{"36109": 97.58, "36011": 2.42}',
    density: 42.4,
    imprecise: false,
    latitude: 42.58514,
    longitude: -76.39832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13073',
  },
  {
    city: 'Hannibal',
    county_fips: 36075,
    county_fips_all: '36075|36011',
    county: 'Oswego',
    county_names_all: 'Oswego|Cayuga',
    county_weights: '{"36075": 94.69, "36011": 5.31}',
    density: 41,
    imprecise: false,
    latitude: 43.31035,
    longitude: -76.54786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13074',
  },
  {
    city: 'Hastings',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 71.9,
    imprecise: false,
    latitude: 43.35364,
    longitude: -76.15182,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13076',
  },
  {
    city: 'Homer',
    county_fips: 36023,
    county_fips_all: '36023|36067|36011',
    county: 'Cortland',
    county_names_all: 'Cortland|Onondaga|Cayuga',
    county_weights: '{"36023": 83.9, "36067": 13.65, "36011": 2.45}',
    density: 36,
    imprecise: false,
    latitude: 42.71557,
    longitude: -76.20089,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13077',
  },
  {
    city: 'Jamesville',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 101.4,
    imprecise: false,
    latitude: 42.96206,
    longitude: -76.06171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13078',
  },
  {
    city: 'Jordan',
    county_fips: 36067,
    county_fips_all: '36067|36011',
    county: 'Onondaga',
    county_names_all: 'Onondaga|Cayuga',
    county_weights: '{"36067": 59.74, "36011": 40.26}',
    density: 45.4,
    imprecise: false,
    latitude: 43.08338,
    longitude: -76.47776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13080',
  },
  {
    city: 'King Ferry',
    county_fips: 36011,
    county_fips_all: '36011',
    county: 'Cayuga',
    county_names_all: 'Cayuga',
    county_weights: '{"36011": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 42.67364,
    longitude: -76.62527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13081',
  },
  {
    city: 'Kirkville',
    county_fips: 36053,
    county_fips_all: '36053|36067',
    county: 'Madison',
    county_names_all: 'Madison|Onondaga',
    county_weights: '{"36053": 52.55, "36067": 47.45}',
    density: 68.4,
    imprecise: false,
    latitude: 43.10148,
    longitude: -75.95253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13082',
  },
  {
    city: 'Lacona',
    county_fips: 36075,
    county_fips_all: '36075|36045',
    county: 'Oswego',
    county_names_all: 'Oswego|Jefferson',
    county_weights: '{"36075": 98.5, "36045": 1.5}',
    density: 11.9,
    imprecise: false,
    latitude: 43.64853,
    longitude: -75.98091,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13083',
  },
  {
    city: 'La Fayette',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 37.7,
    imprecise: false,
    latitude: 42.88938,
    longitude: -76.11314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13084',
  },
  {
    city: 'Little York',
    county_fips: 36023,
    county_fips_all: '36023',
    county: 'Cortland',
    county_names_all: 'Cortland',
    county_weights: '{"36023": 100}',
    density: 47.2,
    imprecise: false,
    latitude: 42.69634,
    longitude: -76.16493,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13087',
  },
  {
    city: 'Liverpool',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 1022.9,
    imprecise: false,
    latitude: 43.10787,
    longitude: -76.19096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13088',
  },
  {
    city: 'Liverpool',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 766.3,
    imprecise: false,
    latitude: 43.15162,
    longitude: -76.21344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13090',
  },
  {
    city: 'Locke',
    county_fips: 36011,
    county_fips_all: '36011|36109',
    county: 'Cayuga',
    county_names_all: 'Cayuga|Tompkins',
    county_weights: '{"36011": 90.85, "36109": 9.15}',
    density: 20.8,
    imprecise: false,
    latitude: 42.65145,
    longitude: -76.42502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13092',
  },
  {
    city: 'McGraw',
    county_fips: 36023,
    county_fips_all: '36023',
    county: 'Cortland',
    county_names_all: 'Cortland',
    county_weights: '{"36023": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 42.60211,
    longitude: -76.06665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13101',
  },
  {
    city: 'McLean',
    county_fips: 36109,
    county_fips_all: '36109',
    county: 'Tompkins',
    county_names_all: 'Tompkins',
    county_weights: '{"36109": 100}',
    density: 238.8,
    imprecise: false,
    latitude: 42.55276,
    longitude: -76.29253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13102',
  },
  {
    city: 'Mallory',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 222.1,
    imprecise: false,
    latitude: 43.32652,
    longitude: -76.10507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13103',
  },
  {
    city: 'Manlius',
    county_fips: 36067,
    county_fips_all: '36067|36053',
    county: 'Onondaga',
    county_names_all: 'Onondaga|Madison',
    county_weights: '{"36067": 96.17, "36053": 3.83}',
    density: 130.9,
    imprecise: false,
    latitude: 42.96378,
    longitude: -75.95523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13104',
  },
  {
    city: 'Marcellus',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 79.1,
    imprecise: false,
    latitude: 42.97349,
    longitude: -76.33069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13108',
  },
  {
    city: 'Marietta',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 39.9,
    imprecise: false,
    latitude: 42.89019,
    longitude: -76.28507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13110',
  },
  {
    city: 'Martville',
    county_fips: 36011,
    county_fips_all: '36011|36075',
    county: 'Cayuga',
    county_names_all: 'Cayuga|Oswego',
    county_weights: '{"36011": 82.46, "36075": 17.54}',
    density: 20.6,
    imprecise: false,
    latitude: 43.25988,
    longitude: -76.61858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13111',
  },
  {
    city: 'Memphis',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 40.6,
    imprecise: false,
    latitude: 43.10306,
    longitude: -76.41926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13112',
  },
  {
    city: 'Meridian',
    county_fips: 36011,
    county_fips_all: '36011',
    county: 'Cayuga',
    county_names_all: 'Cayuga',
    county_weights: '{"36011": 100}',
    density: 620.3,
    imprecise: false,
    latitude: 43.16425,
    longitude: -76.53488,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13113',
  },
  {
    city: 'Mexico',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 44.2,
    imprecise: false,
    latitude: 43.46386,
    longitude: -76.24328,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13114',
  },
  {
    city: 'Minetto',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 192.1,
    imprecise: false,
    latitude: 43.3937,
    longitude: -76.47462,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13115',
  },
  {
    city: 'Minoa',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 1083.6,
    imprecise: false,
    latitude: 43.07449,
    longitude: -76.00796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13116',
  },
  {
    city: 'Montezuma',
    county_fips: 36011,
    county_fips_all: '36011|36099',
    county: 'Cayuga',
    county_names_all: 'Cayuga|Seneca',
    county_weights: '{"36011": 99.34, "36099": 0.66}',
    density: 52.7,
    imprecise: false,
    latitude: 43.01007,
    longitude: -76.70838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13117',
  },
  {
    city: 'Moravia',
    county_fips: 36011,
    county_fips_all: '36011',
    county: 'Cayuga',
    county_names_all: 'Cayuga',
    county_weights: '{"36011": 100}',
    density: 21,
    imprecise: false,
    latitude: 42.75226,
    longitude: -76.39522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13118',
  },
  {
    city: 'Mottville',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.97655,
    longitude: -76.44488,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13119',
  },
  {
    city: 'Nedrow',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 42.94233,
    longitude: -76.1695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13120',
  },
  {
    city: 'New Haven',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.48491,
    longitude: -76.30966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13121',
  },
  {
    city: 'New Woodstock',
    county_fips: 36053,
    county_fips_all: '36053|36067',
    county: 'Madison',
    county_names_all: 'Madison|Onondaga',
    county_weights: '{"36053": 81.54, "36067": 18.46}',
    density: 25.2,
    imprecise: false,
    latitude: 42.83857,
    longitude: -75.85919,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13122',
  },
  {
    city: 'North Bay',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 121.1,
    imprecise: false,
    latitude: 43.22796,
    longitude: -75.75325,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 90,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13123',
  },
  {
    city: 'North Pitcher',
    county_fips: 36017,
    county_fips_all: '36017',
    county: 'Chenango',
    county_names_all: 'Chenango',
    county_weights: '{"36017": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 42.64578,
    longitude: -75.81718,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 88,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13124',
  },
  {
    city: 'Oswego',
    county_fips: 36075,
    county_fips_all: '36075|36011',
    county: 'Oswego',
    county_names_all: 'Oswego|Cayuga',
    county_weights: '{"36075": 99.09, "36011": 0.91}',
    density: 140,
    imprecise: false,
    latitude: 43.43469,
    longitude: -76.46331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13126',
  },
  {
    city: 'Parish',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 43.41964,
    longitude: -76.09539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13131',
  },
  {
    city: 'Pennellville',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 60.5,
    imprecise: false,
    latitude: 43.26547,
    longitude: -76.24446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13132',
  },
  {
    city: 'Peterboro',
    county_fips: 36053,
    county_fips_all: '36053',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"36053": 100}',
    density: 528.6,
    imprecise: false,
    latitude: 42.96731,
    longitude: -75.68476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13134',
  },
  {
    city: 'Phoenix',
    county_fips: 36075,
    county_fips_all: '36075|36067',
    county: 'Oswego',
    county_names_all: 'Oswego|Onondaga',
    county_weights: '{"36075": 73.96, "36067": 26.04}',
    density: 78.6,
    imprecise: false,
    latitude: 43.25801,
    longitude: -76.31676,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13135',
  },
  {
    city: 'Pitcher',
    county_fips: 36017,
    county_fips_all: '36017',
    county: 'Chenango',
    county_names_all: 'Chenango',
    county_weights: '{"36017": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 42.60368,
    longitude: -75.84582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13136',
  },
  {
    city: 'Pompey',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 1476.3,
    imprecise: false,
    latitude: 42.89915,
    longitude: -76.01461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13138',
  },
  {
    city: 'Port Byron',
    county_fips: 36011,
    county_fips_all: '36011',
    county: 'Cayuga',
    county_names_all: 'Cayuga',
    county_weights: '{"36011": 100}',
    density: 28.8,
    imprecise: false,
    latitude: 43.05891,
    longitude: -76.65841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13140',
  },
  {
    city: 'Preble',
    county_fips: 36023,
    county_fips_all: '36023|36067',
    county: 'Cortland',
    county_names_all: 'Cortland|Onondaga',
    county_weights: '{"36023": 63.65, "36067": 36.35}',
    density: 17.5,
    imprecise: false,
    latitude: 42.76684,
    longitude: -76.18616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13141',
  },
  {
    city: 'Pulaski',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 34,
    imprecise: false,
    latitude: 43.55189,
    longitude: -76.12959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13142',
  },
  {
    city: 'Red Creek',
    county_fips: 36117,
    county_fips_all: '36117|36011',
    county: 'Wayne',
    county_names_all: 'Wayne|Cayuga',
    county_weights: '{"36117": 55.58, "36011": 44.42}',
    density: 21.6,
    imprecise: false,
    latitude: 43.23325,
    longitude: -76.71545,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13143',
  },
  {
    city: 'Richland',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 43.57034,
    longitude: -75.97464,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13144',
  },
  {
    city: 'Sandy Creek',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 50.3,
    imprecise: false,
    latitude: 43.65188,
    longitude: -76.1232,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13145',
  },
  {
    city: 'Savannah',
    county_fips: 36117,
    county_fips_all: '36117|36099',
    county: 'Wayne',
    county_names_all: 'Wayne|Seneca',
    county_weights: '{"36117": 96.47, "36099": 3.53}',
    density: 15.3,
    imprecise: false,
    latitude: 43.09711,
    longitude: -76.76031,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13146',
  },
  {
    city: 'Scipio Center',
    county_fips: 36011,
    county_fips_all: '36011',
    county: 'Cayuga',
    county_names_all: 'Cayuga',
    county_weights: '{"36011": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 42.77336,
    longitude: -76.56603,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13147',
  },
  {
    city: 'Seneca Falls',
    county_fips: 36099,
    county_fips_all: '36099',
    county: 'Seneca',
    county_names_all: 'Seneca',
    county_weights: '{"36099": 100}',
    density: 66.7,
    imprecise: false,
    latitude: 42.9208,
    longitude: -76.78106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13148',
  },
  {
    city: 'Skaneateles',
    county_fips: 36067,
    county_fips_all: '36067|36011',
    county: 'Onondaga',
    county_names_all: 'Onondaga|Cayuga',
    county_weights: '{"36067": 85.77, "36011": 14.23}',
    density: 46.9,
    imprecise: false,
    latitude: 42.89323,
    longitude: -76.38518,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13152',
  },
  {
    city: 'Skaneateles Falls',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 270.4,
    imprecise: false,
    latitude: 42.9945,
    longitude: -76.45476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13153',
  },
  {
    city: 'South Butler',
    county_fips: 36117,
    county_fips_all: '36117',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"36117": 100}',
    density: 80.3,
    imprecise: false,
    latitude: 43.13378,
    longitude: -76.76192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13154',
  },
  {
    city: 'South Otselic',
    county_fips: 36017,
    county_fips_all: '36017',
    county: 'Chenango',
    county_names_all: 'Chenango',
    county_weights: '{"36017": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 42.65945,
    longitude: -75.77136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13155',
  },
  {
    city: 'Sterling',
    county_fips: 36011,
    county_fips_all: '36011|36117',
    county: 'Cayuga',
    county_names_all: 'Cayuga|Wayne',
    county_weights: '{"36011": 99.1, "36117": 0.9}',
    density: 28.3,
    imprecise: false,
    latitude: 43.33355,
    longitude: -76.66249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13156',
  },
  {
    city: 'Sylvan Beach',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 488.1,
    imprecise: false,
    latitude: 43.20288,
    longitude: -75.7254,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13157',
  },
  {
    city: 'Truxton',
    county_fips: 36023,
    county_fips_all: '36023|36067',
    county: 'Cortland',
    county_names_all: 'Cortland|Onondaga',
    county_weights: '{"36023": 94.15, "36067": 5.85}',
    density: 8,
    imprecise: false,
    latitude: 42.71603,
    longitude: -75.97626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13158',
  },
  {
    city: 'Tully',
    county_fips: 36067,
    county_fips_all: '36067|36023',
    county: 'Onondaga',
    county_names_all: 'Onondaga|Cortland',
    county_weights: '{"36067": 67.88, "36023": 32.12}',
    density: 26,
    imprecise: false,
    latitude: 42.80321,
    longitude: -76.11545,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13159',
  },
  {
    city: 'Union Springs',
    county_fips: 36011,
    county_fips_all: '36011',
    county: 'Cayuga',
    county_names_all: 'Cayuga',
    county_weights: '{"36011": 100}',
    density: 41.7,
    imprecise: false,
    latitude: 42.82613,
    longitude: -76.65157,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13160',
  },
  {
    city: 'Verona Beach',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 42.1,
    imprecise: false,
    latitude: 43.18833,
    longitude: -75.71823,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13162',
  },
  {
    city: 'Wampsville',
    county_fips: 36053,
    county_fips_all: '36053',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"36053": 100}',
    density: 302.9,
    imprecise: false,
    latitude: 43.08194,
    longitude: -75.70841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13163',
  },
  {
    city: 'Warners',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 100.7,
    imprecise: false,
    latitude: 43.09377,
    longitude: -76.31626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13164',
  },
  {
    city: 'Waterloo',
    county_fips: 36099,
    county_fips_all: '36099',
    county: 'Seneca',
    county_names_all: 'Seneca',
    county_weights: '{"36099": 100}',
    density: 53.5,
    imprecise: false,
    latitude: 42.91185,
    longitude: -76.87601,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13165',
  },
  {
    city: 'Weedsport',
    county_fips: 36011,
    county_fips_all: '36011|36067',
    county: 'Cayuga',
    county_names_all: 'Cayuga|Onondaga',
    county_weights: '{"36011": 98.23, "36067": 1.77}',
    density: 53.1,
    imprecise: false,
    latitude: 43.07219,
    longitude: -76.5568,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13166',
  },
  {
    city: 'West Monroe',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 33.8,
    imprecise: false,
    latitude: 43.3171,
    longitude: -76.0571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13167',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 2727.1,
    imprecise: false,
    latitude: 43.04356,
    longitude: -76.15065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13202',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 3674.9,
    imprecise: false,
    latitude: 43.061,
    longitude: -76.13486,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13203',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 1763.5,
    imprecise: false,
    latitude: 43.05204,
    longitude: -76.17666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13204',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 2039.2,
    imprecise: false,
    latitude: 43.00474,
    longitude: -76.14163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13205',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 1543.5,
    imprecise: false,
    latitude: 43.07354,
    longitude: -76.10584,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13206',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 1471.3,
    imprecise: false,
    latitude: 43.01221,
    longitude: -76.16354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13207',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 2170.4,
    imprecise: false,
    latitude: 43.07878,
    longitude: -76.14521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13208',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 375.4,
    imprecise: false,
    latitude: 43.08581,
    longitude: -76.24355,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13209',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 2030.2,
    imprecise: false,
    latitude: 43.03186,
    longitude: -76.12653,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13210',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 516.7,
    imprecise: false,
    latitude: 43.10333,
    longitude: -76.11954,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13211',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 692.5,
    imprecise: false,
    latitude: 43.12839,
    longitude: -76.12889,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13212',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 957.1,
    imprecise: false,
    latitude: 43.03865,
    longitude: -76.0741,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13214',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 169.9,
    imprecise: false,
    latitude: 42.97852,
    longitude: -76.22979,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13215',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 1133.9,
    imprecise: false,
    latitude: 43.03969,
    longitude: -76.22277,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13219',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 1165.5,
    imprecise: false,
    latitude: 43.03892,
    longitude: -76.10264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13224',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.07132,
    longitude: -76.17368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13290',
  },
  {
    city: 'Alder Creek',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 23,
    imprecise: false,
    latitude: 43.42225,
    longitude: -75.21546,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13301',
  },
  {
    city: 'Altmar',
    county_fips: 36075,
    county_fips_all: '36075',
    county: 'Oswego',
    county_names_all: 'Oswego',
    county_weights: '{"36075": 100}',
    density: 11,
    imprecise: false,
    latitude: 43.50261,
    longitude: -75.95044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13302',
  },
  {
    city: 'Ava',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 43.36992,
    longitude: -75.46636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13303',
  },
  {
    city: 'Barneveld',
    county_fips: 36065,
    county_fips_all: '36065|36043',
    county: 'Oneida',
    county_names_all: 'Oneida|Herkimer',
    county_weights: '{"36065": 89.32, "36043": 10.68}',
    density: 36.2,
    imprecise: false,
    latitude: 43.23954,
    longitude: -75.1589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13304',
  },
  {
    city: 'Beaver Falls',
    county_fips: 36049,
    county_fips_all: '36049',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"36049": 100}',
    density: 134.9,
    imprecise: false,
    latitude: 43.89329,
    longitude: -75.43144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13305',
  },
  {
    city: 'Blossvale',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 39.4,
    imprecise: false,
    latitude: 43.24865,
    longitude: -75.66686,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13308',
  },
  {
    city: 'Boonville',
    county_fips: 36065,
    county_fips_all: '36065|36049',
    county: 'Oneida',
    county_names_all: 'Oneida|Lewis',
    county_weights: '{"36065": 73.65, "36049": 26.35}',
    density: 15.5,
    imprecise: false,
    latitude: 43.47398,
    longitude: -75.34103,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13309',
  },
  {
    city: 'Bouckville',
    county_fips: 36053,
    county_fips_all: '36053',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"36053": 100}',
    density: 30,
    imprecise: false,
    latitude: 42.89055,
    longitude: -75.57065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13310',
  },
  {
    city: 'Brantingham',
    county_fips: 36049,
    county_fips_all: '36049|36043',
    county: 'Lewis',
    county_names_all: 'Lewis|Herkimer',
    county_weights: '{"36049": 99.88, "36043": 0.12}',
    density: 1.3,
    imprecise: false,
    latitude: 43.70247,
    longitude: -75.20758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13312',
  },
  {
    city: 'Bridgewater',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 68.5,
    imprecise: false,
    latitude: 42.88715,
    longitude: -75.26228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13313',
  },
  {
    city: 'Brookfield',
    county_fips: 36053,
    county_fips_all: '36053',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"36053": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 42.82476,
    longitude: -75.31568,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13314',
  },
  {
    city: 'Burlington Flats',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 42.7438,
    longitude: -75.1385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13315',
  },
  {
    city: 'Camden',
    county_fips: 36065,
    county_fips_all: '36065|36049|36075',
    county: 'Oneida',
    county_names_all: 'Oneida|Lewis|Oswego',
    county_weights: '{"36065": 68.18, "36049": 28.99, "36075": 2.83}',
    density: 13.8,
    imprecise: false,
    latitude: 43.41492,
    longitude: -75.73963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13316',
  },
  {
    city: 'Canajoharie',
    county_fips: 36057,
    county_fips_all: '36057|36077',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Otsego',
    county_weights: '{"36057": 94.3, "36077": 5.7}',
    density: 32.2,
    imprecise: false,
    latitude: 42.85638,
    longitude: -74.58844,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13317',
  },
  {
    city: 'Cassville',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 14,
    imprecise: false,
    latitude: 42.92366,
    longitude: -75.25958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13318',
  },
  {
    city: 'Chadwicks',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 135,
    imprecise: false,
    latitude: 43.02705,
    longitude: -75.26593,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13319',
  },
  {
    city: 'Cherry Valley',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 42.77353,
    longitude: -74.74325,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13320',
  },
  {
    city: 'Clark Mills',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 451.7,
    imprecise: false,
    latitude: 43.08901,
    longitude: -75.37259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13321',
  },
  {
    city: 'Clayville',
    county_fips: 36043,
    county_fips_all: '36043|36065',
    county: 'Herkimer',
    county_names_all: 'Herkimer|Oneida',
    county_weights: '{"36043": 60.06, "36065": 39.94}',
    density: 34,
    imprecise: false,
    latitude: 42.96661,
    longitude: -75.20445,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13322',
  },
  {
    city: 'Clinton',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 110,
    imprecise: false,
    latitude: 43.04198,
    longitude: -75.38144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13323',
  },
  {
    city: 'Cold Brook',
    county_fips: 36043,
    county_fips_all: '36043',
    county: 'Herkimer',
    county_names_all: 'Herkimer',
    county_weights: '{"36043": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 43.3165,
    longitude: -74.93325,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13324',
  },
  {
    city: 'Constableville',
    county_fips: 36049,
    county_fips_all: '36049',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"36049": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 43.58398,
    longitude: -75.54091,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13325',
  },
  {
    city: 'Cooperstown',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 42.71865,
    longitude: -74.90374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13326',
  },
  {
    city: 'Croghan',
    county_fips: 36049,
    county_fips_all: '36049',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"36049": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 43.96047,
    longitude: -75.28474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13327',
  },
  {
    city: 'Deansboro',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 42.98247,
    longitude: -75.42836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13328',
  },
  {
    city: 'Dolgeville',
    county_fips: 36035,
    county_fips_all: '36035|36043',
    county: 'Fulton',
    county_names_all: 'Fulton|Herkimer',
    county_weights: '{"36035": 71.24, "36043": 28.76}',
    density: 22.7,
    imprecise: false,
    latitude: 43.11094,
    longitude: -74.70017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13329',
  },
  {
    city: 'Eagle Bay',
    county_fips: 36043,
    county_fips_all: '36043|36041|36049',
    county: 'Herkimer',
    county_names_all: 'Herkimer|Hamilton|Lewis',
    county_weights: '{"36043": 98.52, "36041": 1.38, "36049": 0.1}',
    density: 0.5,
    imprecise: false,
    latitude: 43.81706,
    longitude: -74.97284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13331',
  },
  {
    city: 'Earlville',
    county_fips: 36053,
    county_fips_all: '36053|36017',
    county: 'Madison',
    county_names_all: 'Madison|Chenango',
    county_weights: '{"36053": 80.74, "36017": 19.26}',
    density: 17.8,
    imprecise: false,
    latitude: 42.75831,
    longitude: -75.57452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13332',
  },
  {
    city: 'East Springfield',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 11,
    imprecise: false,
    latitude: 42.83091,
    longitude: -74.82207,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13333',
  },
  {
    city: 'Eaton',
    county_fips: 36053,
    county_fips_all: '36053',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"36053": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 42.83445,
    longitude: -75.65986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13334',
  },
  {
    city: 'Edmeston',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 42.70193,
    longitude: -75.24847,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13335',
  },
  {
    city: 'Fly Creek',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 14,
    imprecise: false,
    latitude: 42.75114,
    longitude: -74.9816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13337',
  },
  {
    city: 'Forestport',
    county_fips: 36043,
    county_fips_all: '36043|36065',
    county: 'Herkimer',
    county_names_all: 'Herkimer|Oneida',
    county_weights: '{"36043": 76.74, "36065": 23.26}',
    density: 2.2,
    imprecise: false,
    latitude: 43.49706,
    longitude: -74.97833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13338',
  },
  {
    city: 'Fort Plain',
    county_fips: 36057,
    county_fips_all: '36057|36043|36035',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Herkimer|Fulton',
    county_weights: '{"36057": 75.34, "36043": 18.38, "36035": 6.28}',
    density: 22.1,
    imprecise: false,
    latitude: 42.93995,
    longitude: -74.66631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13339',
  },
  {
    city: 'Frankfort',
    county_fips: 36043,
    county_fips_all: '36043',
    county: 'Herkimer',
    county_names_all: 'Herkimer',
    county_weights: '{"36043": 100}',
    density: 47.4,
    imprecise: false,
    latitude: 43.04814,
    longitude: -75.11502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13340',
  },
  {
    city: 'Garrattsville',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 42.64766,
    longitude: -75.18918,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13342',
  },
  {
    city: 'Glenfield',
    county_fips: 36049,
    county_fips_all: '36049',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"36049": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 43.75271,
    longitude: -75.31062,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13343',
  },
  {
    city: 'Greig',
    county_fips: 36049,
    county_fips_all: '36049',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"36049": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 43.6889,
    longitude: -75.33153,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13345',
  },
  {
    city: 'Hamilton',
    county_fips: 36053,
    county_fips_all: '36053',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"36053": 100}',
    density: 69.9,
    imprecise: false,
    latitude: 42.82093,
    longitude: -75.54453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13346',
  },
  {
    city: 'Hartwick',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 42.70202,
    longitude: -75.06398,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13348',
  },
  {
    city: 'Herkimer',
    county_fips: 36043,
    county_fips_all: '36043',
    county: 'Herkimer',
    county_names_all: 'Herkimer',
    county_weights: '{"36043": 100}',
    density: 116.2,
    imprecise: false,
    latitude: 43.06352,
    longitude: -74.98817,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13350',
  },
  {
    city: 'Hinckley',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 34.8,
    imprecise: false,
    latitude: 43.31122,
    longitude: -75.12058,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13352',
  },
  {
    city: 'Hoffmeister',
    county_fips: 36041,
    county_fips_all: '36041',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"36041": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 43.47123,
    longitude: -74.72732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13353',
  },
  {
    city: 'Holland Patent',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 43.26612,
    longitude: -75.27199,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13354',
  },
  {
    city: 'Hubbardsville',
    county_fips: 36053,
    county_fips_all: '36053',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"36053": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 42.80971,
    longitude: -75.42401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13355',
  },
  {
    city: 'Ilion',
    county_fips: 36043,
    county_fips_all: '36043',
    county: 'Herkimer',
    county_names_all: 'Herkimer',
    county_weights: '{"36043": 100}',
    density: 132.8,
    imprecise: false,
    latitude: 42.96952,
    longitude: -75.08037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13357',
  },
  {
    city: 'Inlet',
    county_fips: 36041,
    county_fips_all: '36041',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"36041": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 43.72457,
    longitude: -74.73577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13360',
  },
  {
    city: 'Jordanville',
    county_fips: 36043,
    county_fips_all: '36043|36077',
    county: 'Herkimer',
    county_names_all: 'Herkimer|Otsego',
    county_weights: '{"36043": 76.91, "36077": 23.09}',
    density: 9.8,
    imprecise: false,
    latitude: 42.89807,
    longitude: -74.86256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13361',
  },
  {
    city: 'Lee Center',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 32.6,
    imprecise: false,
    latitude: 43.33127,
    longitude: -75.50984,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13363',
  },
  {
    city: 'Leonardsville',
    county_fips: 36053,
    county_fips_all: '36053|36077',
    county: 'Madison',
    county_names_all: 'Madison|Otsego',
    county_weights: '{"36053": 99.7, "36077": 0.3}',
    density: 43.6,
    imprecise: false,
    latitude: 42.80501,
    longitude: -75.26105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13364',
  },
  {
    city: 'Little Falls',
    county_fips: 36043,
    county_fips_all: '36043',
    county: 'Herkimer',
    county_names_all: 'Herkimer',
    county_weights: '{"36043": 100}',
    density: 26.8,
    imprecise: false,
    latitude: 43.09804,
    longitude: -74.84937,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13365',
  },
  {
    city: 'Lowville',
    county_fips: 36049,
    county_fips_all: '36049|36043',
    county: 'Lewis',
    county_names_all: 'Lewis|Herkimer',
    county_weights: '{"36049": 62.15, "36043": 37.85}',
    density: 7.2,
    imprecise: false,
    latitude: 43.85563,
    longitude: -75.31772,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13367',
  },
  {
    city: 'Lyons Falls',
    county_fips: 36049,
    county_fips_all: '36049',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"36049": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 43.6446,
    longitude: -75.33209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13368',
  },
  {
    city: 'Madison',
    county_fips: 36053,
    county_fips_all: '36053|36065',
    county: 'Madison',
    county_names_all: 'Madison|Oneida',
    county_weights: '{"36053": 93.12, "36065": 6.88}',
    density: 18.3,
    imprecise: false,
    latitude: 42.90209,
    longitude: -75.50728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13402',
  },
  {
    city: 'Marcy',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 102.4,
    imprecise: false,
    latitude: 43.17041,
    longitude: -75.27188,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13403',
  },
  {
    city: 'Martinsburg',
    county_fips: 36049,
    county_fips_all: '36049',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"36049": 100}',
    density: 37.2,
    imprecise: false,
    latitude: 43.73842,
    longitude: -75.48089,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13404',
  },
  {
    city: 'Middleville',
    county_fips: 36043,
    county_fips_all: '36043',
    county: 'Herkimer',
    county_names_all: 'Herkimer',
    county_weights: '{"36043": 100}',
    density: 40.6,
    imprecise: false,
    latitude: 43.14326,
    longitude: -74.92257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13406',
  },
  {
    city: 'Mohawk',
    county_fips: 36043,
    county_fips_all: '36043',
    county: 'Herkimer',
    county_names_all: 'Herkimer',
    county_weights: '{"36043": 100}',
    density: 34.5,
    imprecise: false,
    latitude: 42.9677,
    longitude: -74.94087,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13407',
  },
  {
    city: 'Morrisville',
    county_fips: 36053,
    county_fips_all: '36053',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"36053": 100}',
    density: 38.5,
    imprecise: false,
    latitude: 42.92205,
    longitude: -75.66722,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13408',
  },
  {
    city: 'Munnsville',
    county_fips: 36053,
    county_fips_all: '36053|36065',
    county: 'Madison',
    county_names_all: 'Madison|Oneida',
    county_weights: '{"36053": 94.2, "36065": 5.8}',
    density: 23,
    imprecise: false,
    latitude: 42.97602,
    longitude: -75.59131,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13409',
  },
  {
    city: 'Nelliston',
    county_fips: 36057,
    county_fips_all: '36057',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"36057": 100}',
    density: 397.4,
    imprecise: false,
    latitude: 42.92908,
    longitude: -74.60922,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13410',
  },
  {
    city: 'New Berlin',
    county_fips: 36077,
    county_fips_all: '36077|36017',
    county: 'Otsego',
    county_names_all: 'Otsego|Chenango',
    county_weights: '{"36077": 53.65, "36017": 46.35}',
    density: 16.4,
    imprecise: false,
    latitude: 42.63723,
    longitude: -75.30981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13411',
  },
  {
    city: 'New Hartford',
    county_fips: 36065,
    county_fips_all: '36065|36043',
    county: 'Oneida',
    county_names_all: 'Oneida|Herkimer',
    county_weights: '{"36065": 88.73, "36043": 11.27}',
    density: 335.2,
    imprecise: false,
    latitude: 43.0576,
    longitude: -75.27495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13413',
  },
  {
    city: 'New Lisbon',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 42.59714,
    longitude: -75.19729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13415',
  },
  {
    city: 'Newport',
    county_fips: 36043,
    county_fips_all: '36043',
    county: 'Herkimer',
    county_names_all: 'Herkimer',
    county_weights: '{"36043": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 43.18768,
    longitude: -74.9571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13416',
  },
  {
    city: 'New York Mills',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 1055.6,
    imprecise: false,
    latitude: 43.10002,
    longitude: -75.29399,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13417',
  },
  {
    city: 'North Brookfield',
    county_fips: 36053,
    county_fips_all: '36053',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"36053": 100}',
    density: 7,
    imprecise: false,
    latitude: 42.84519,
    longitude: -75.38213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13418',
  },
  {
    city: 'Old Forge',
    county_fips: 36043,
    county_fips_all: '36043',
    county: 'Herkimer',
    county_names_all: 'Herkimer',
    county_weights: '{"36043": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 43.65069,
    longitude: -74.9619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13420',
  },
  {
    city: 'Oneida',
    county_fips: 36053,
    county_fips_all: '36053|36065',
    county: 'Madison',
    county_names_all: 'Madison|Oneida',
    county_weights: '{"36053": 75.93, "36065": 24.07}',
    density: 122.9,
    imprecise: false,
    latitude: 43.06293,
    longitude: -75.64654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13421',
  },
  {
    city: 'Oriskany',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 74.1,
    imprecise: false,
    latitude: 43.15228,
    longitude: -75.36291,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13424',
  },
  {
    city: 'Oriskany Falls',
    county_fips: 36065,
    county_fips_all: '36065|36053',
    county: 'Oneida',
    county_names_all: 'Oneida|Madison',
    county_weights: '{"36065": 86.02, "36053": 13.98}',
    density: 30.1,
    imprecise: false,
    latitude: 42.9635,
    longitude: -75.48675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13425',
  },
  {
    city: 'Palatine Bridge',
    county_fips: 36057,
    county_fips_all: '36057',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"36057": 100}',
    density: 39.1,
    imprecise: false,
    latitude: 42.92096,
    longitude: -74.53311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13428',
  },
  {
    city: 'Poland',
    county_fips: 36043,
    county_fips_all: '36043|36065',
    county: 'Herkimer',
    county_names_all: 'Herkimer|Oneida',
    county_weights: '{"36043": 87.98, "36065": 12.02}',
    density: 19.7,
    imprecise: false,
    latitude: 43.20691,
    longitude: -75.07608,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13431',
  },
  {
    city: 'Port Leyden',
    county_fips: 36049,
    county_fips_all: '36049|36043',
    county: 'Lewis',
    county_names_all: 'Lewis|Herkimer',
    county_weights: '{"36049": 99.85, "36043": 0.15}',
    density: 11.4,
    imprecise: false,
    latitude: 43.59914,
    longitude: -75.24765,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13433',
  },
  {
    city: 'Prospect',
    county_fips: 36065,
    county_fips_all: '36065|36043',
    county: 'Oneida',
    county_names_all: 'Oneida|Herkimer',
    county_weights: '{"36065": 98.91, "36043": 1.09}',
    density: 195.6,
    imprecise: false,
    latitude: 43.30255,
    longitude: -75.15134,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13435',
  },
  {
    city: 'Raquette Lake',
    county_fips: 36041,
    county_fips_all: '36041',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"36041": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 43.80501,
    longitude: -74.67034,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13436',
  },
  {
    city: 'Redfield',
    county_fips: 36075,
    county_fips_all: '36075|36049',
    county: 'Oswego',
    county_names_all: 'Oswego|Lewis',
    county_weights: '{"36075": 75.58, "36049": 24.42}',
    density: 1,
    imprecise: false,
    latitude: 43.59677,
    longitude: -75.80383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13437',
  },
  {
    city: 'Remsen',
    county_fips: 36065,
    county_fips_all: '36065|36043',
    county: 'Oneida',
    county_names_all: 'Oneida|Herkimer',
    county_weights: '{"36065": 75.68, "36043": 24.32}',
    density: 12.4,
    imprecise: false,
    latitude: 43.35171,
    longitude: -75.15527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13438',
  },
  {
    city: 'Richfield Springs',
    county_fips: 36077,
    county_fips_all: '36077|36043',
    county: 'Otsego',
    county_names_all: 'Otsego|Herkimer',
    county_weights: '{"36077": 61.14, "36043": 38.86}',
    density: 16.2,
    imprecise: false,
    latitude: 42.85491,
    longitude: -74.99724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13439',
  },
  {
    city: 'Rome',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 137.7,
    imprecise: false,
    latitude: 43.21807,
    longitude: -75.45941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13440',
  },
  {
    city: 'Rome',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 43.22711,
    longitude: -75.40758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13441',
  },
  {
    city: 'Roseboom',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 42.7026,
    longitude: -74.81263,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13450',
  },
  {
    city: 'Saint Johnsville',
    county_fips: 36035,
    county_fips_all: '36035|36057',
    county: 'Fulton',
    county_names_all: 'Fulton|Montgomery',
    county_weights: '{"36035": 75.5, "36057": 24.5}',
    density: 24.4,
    imprecise: false,
    latitude: 43.03718,
    longitude: -74.63001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13452',
  },
  {
    city: 'Salisbury Center',
    county_fips: 36043,
    county_fips_all: '36043',
    county: 'Herkimer',
    county_names_all: 'Herkimer',
    county_weights: '{"36043": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 43.16885,
    longitude: -74.75719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13454',
  },
  {
    city: 'Sangerfield',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 168.1,
    imprecise: false,
    latitude: 42.91791,
    longitude: -75.37655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13455',
  },
  {
    city: 'Sauquoit',
    county_fips: 36065,
    county_fips_all: '36065|36043',
    county: 'Oneida',
    county_names_all: 'Oneida|Herkimer',
    county_weights: '{"36065": 85.95, "36043": 14.05}',
    density: 58.2,
    imprecise: false,
    latitude: 43.00145,
    longitude: -75.25855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13456',
  },
  {
    city: 'Schuyler Lake',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 42.77527,
    longitude: -75.03691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13457',
  },
  {
    city: 'Sharon Springs',
    county_fips: 36095,
    county_fips_all: '36095|36057|36077',
    county: 'Schoharie',
    county_names_all: 'Schoharie|Montgomery|Otsego',
    county_weights: '{"36095": 89.58, "36057": 7.53, "36077": 2.89}',
    density: 14.5,
    imprecise: false,
    latitude: 42.77721,
    longitude: -74.59315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13459',
  },
  {
    city: 'Sherburne',
    county_fips: 36017,
    county_fips_all: '36017|36053',
    county: 'Chenango',
    county_names_all: 'Chenango|Madison',
    county_weights: '{"36017": 95.98, "36053": 4.02}',
    density: 24.2,
    imprecise: false,
    latitude: 42.68492,
    longitude: -75.45572,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13460',
  },
  {
    city: 'Sherrill',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 477.9,
    imprecise: false,
    latitude: 43.07115,
    longitude: -75.59866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13461',
  },
  {
    city: 'Smyrna',
    county_fips: 36017,
    county_fips_all: '36017|36053',
    county: 'Chenango',
    county_names_all: 'Chenango|Madison',
    county_weights: '{"36017": 98.27, "36053": 1.73}',
    density: 11.7,
    imprecise: false,
    latitude: 42.68632,
    longitude: -75.61998,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13464',
  },
  {
    city: 'Springfield Center',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 42.84696,
    longitude: -74.86448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13468',
  },
  {
    city: 'Stittville',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 106.6,
    imprecise: false,
    latitude: 43.22028,
    longitude: -75.29853,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13469',
  },
  {
    city: 'Stratford',
    county_fips: 36035,
    county_fips_all: '36035|36043',
    county: 'Fulton',
    county_names_all: 'Fulton|Herkimer',
    county_weights: '{"36035": 70.43, "36043": 29.57}',
    density: 3.8,
    imprecise: false,
    latitude: 43.21075,
    longitude: -74.66825,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13470',
  },
  {
    city: 'Taberg',
    county_fips: 36065,
    county_fips_all: '36065|36049',
    county: 'Oneida',
    county_names_all: 'Oneida|Lewis',
    county_weights: '{"36065": 81.41, "36049": 18.59}',
    density: 13.7,
    imprecise: false,
    latitude: 43.37606,
    longitude: -75.6122,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13471',
  },
  {
    city: 'Thendara',
    county_fips: 36043,
    county_fips_all: '36043',
    county: 'Herkimer',
    county_names_all: 'Herkimer',
    county_weights: '{"36043": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 43.69491,
    longitude: -75.06072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13472',
  },
  {
    city: 'Turin',
    county_fips: 36049,
    county_fips_all: '36049',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"36049": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 43.64414,
    longitude: -75.44517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13473',
  },
  {
    city: 'Van Hornesville',
    county_fips: 36043,
    county_fips_all: '36043',
    county: 'Herkimer',
    county_names_all: 'Herkimer',
    county_weights: '{"36043": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 42.88789,
    longitude: -74.81196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13475',
  },
  {
    city: 'Vernon',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 43.3,
    imprecise: false,
    latitude: 43.08728,
    longitude: -75.51219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13476',
  },
  {
    city: 'Vernon Center',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 43.03633,
    longitude: -75.51441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13477',
  },
  {
    city: 'Verona',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 34,
    imprecise: false,
    latitude: 43.14916,
    longitude: -75.58009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13478',
  },
  {
    city: 'Waterville',
    county_fips: 36065,
    county_fips_all: '36065|36053',
    county: 'Oneida',
    county_names_all: 'Oneida|Madison',
    county_weights: '{"36065": 91.0, "36053": 9.0}',
    density: 23.4,
    imprecise: false,
    latitude: 42.91424,
    longitude: -75.36699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13480',
  },
  {
    city: 'West Burlington',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 42.69661,
    longitude: -75.17695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13482',
  },
  {
    city: 'Westdale',
    county_fips: 36065,
    county_fips_all: '36065|36075',
    county: 'Oneida',
    county_names_all: 'Oneida|Oswego',
    county_weights: '{"36065": 98.16, "36075": 1.84}',
    density: 16.2,
    imprecise: false,
    latitude: 43.40075,
    longitude: -75.81995,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13483',
  },
  {
    city: 'West Eaton',
    county_fips: 36053,
    county_fips_all: '36053',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"36053": 100}',
    density: 1400.3,
    imprecise: false,
    latitude: 42.85426,
    longitude: -75.65549,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13484',
  },
  {
    city: 'West Edmeston',
    county_fips: 36053,
    county_fips_all: '36053|36077|36017',
    county: 'Madison',
    county_names_all: 'Madison|Otsego|Chenango',
    county_weights: '{"36053": 80.42, "36077": 12.01, "36017": 7.57}',
    density: 16.1,
    imprecise: false,
    latitude: 42.7865,
    longitude: -75.3165,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13485',
  },
  {
    city: 'Westernville',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 43.35707,
    longitude: -75.34088,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13486',
  },
  {
    city: 'Westford',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 42.67447,
    longitude: -74.76796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13488',
  },
  {
    city: 'West Leyden',
    county_fips: 36049,
    county_fips_all: '36049|36065',
    county: 'Lewis',
    county_names_all: 'Lewis|Oneida',
    county_weights: '{"36049": 99.9, "36065": 0.1}',
    density: 7.1,
    imprecise: false,
    latitude: 43.46698,
    longitude: -75.52928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13489',
  },
  {
    city: 'Westmoreland',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 40.4,
    imprecise: false,
    latitude: 43.10612,
    longitude: -75.42991,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13490',
  },
  {
    city: 'West Winfield',
    county_fips: 36077,
    county_fips_all: '36077|36043|36053',
    county: 'Otsego',
    county_names_all: 'Otsego|Herkimer|Madison',
    county_weights: '{"36077": 51.82, "36043": 38.08, "36053": 10.11}',
    density: 17.6,
    imprecise: false,
    latitude: 42.85957,
    longitude: -75.17698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13491',
  },
  {
    city: 'Whitesboro',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 283.8,
    imprecise: false,
    latitude: 43.1172,
    longitude: -75.33023,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13492',
  },
  {
    city: 'Williamstown',
    county_fips: 36075,
    county_fips_all: '36075|36065',
    county: 'Oswego',
    county_names_all: 'Oswego|Oneida',
    county_weights: '{"36075": 99.5, "36065": 0.5}',
    density: 13.3,
    imprecise: false,
    latitude: 43.43162,
    longitude: -75.90102,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13493',
  },
  {
    city: 'Woodgate',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 43.53136,
    longitude: -75.14198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13494',
  },
  {
    city: 'Yorkville',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 821.1,
    imprecise: false,
    latitude: 43.11087,
    longitude: -75.27744,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13495',
  },
  {
    city: 'Utica',
    county_fips: 36065,
    county_fips_all: '36065',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"36065": 100}',
    density: 1699.8,
    imprecise: false,
    latitude: 43.08138,
    longitude: -75.22611,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13501',
  },
  {
    city: 'Utica',
    county_fips: 36065,
    county_fips_all: '36065|36043',
    county: 'Oneida',
    county_names_all: 'Oneida|Herkimer',
    county_weights: '{"36065": 70.27, "36043": 29.73}',
    density: 255.6,
    imprecise: false,
    latitude: 43.14121,
    longitude: -75.16584,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13502',
  },
  {
    city: 'Watertown',
    county_fips: 36045,
    county_fips_all: '36045|36049',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Lewis',
    county_weights: '{"36045": 94.31, "36049": 5.69}',
    density: 101.1,
    imprecise: false,
    latitude: 43.96949,
    longitude: -75.90965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13601',
  },
  {
    city: 'Fort Drum',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 82.1,
    imprecise: false,
    latitude: 44.04877,
    longitude: -75.75747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13602',
  },
  {
    city: 'Watertown',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 985.8,
    imprecise: false,
    latitude: 44.03826,
    longitude: -75.79765,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13603',
  },
  {
    city: 'Adams',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 26,
    imprecise: false,
    latitude: 43.80641,
    longitude: -76.05195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13605',
  },
  {
    city: 'Adams Center',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 43.87007,
    longitude: -76.01601,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13606',
  },
  {
    city: 'Alexandria Bay',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 47.7,
    imprecise: false,
    latitude: 44.33233,
    longitude: -75.91187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13607',
  },
  {
    city: 'Antwerp',
    county_fips: 36045,
    county_fips_all: '36045|36089',
    county: 'Jefferson',
    county_names_all: 'Jefferson|St. Lawrence',
    county_weights: '{"36045": 88.34, "36089": 11.66}',
    density: 15.9,
    imprecise: false,
    latitude: 44.23879,
    longitude: -75.62508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13608',
  },
  {
    city: 'Belleville',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 31.5,
    imprecise: false,
    latitude: 43.77726,
    longitude: -76.12374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13611',
  },
  {
    city: 'Black River',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 58.4,
    imprecise: false,
    latitude: 43.98571,
    longitude: -75.76911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13612',
  },
  {
    city: 'Brasher Falls',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 44.85884,
    longitude: -74.73879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13613',
  },
  {
    city: 'Brier Hill',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 44.53081,
    longitude: -75.69194,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13614',
  },
  {
    city: 'Brownville',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 423.3,
    imprecise: false,
    latitude: 44.00569,
    longitude: -75.98328,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13615',
  },
  {
    city: 'Calcium',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 99.3,
    imprecise: false,
    latitude: 44.02538,
    longitude: -75.85896,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13616',
  },
  {
    city: 'Canton',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 36.2,
    imprecise: false,
    latitude: 44.5789,
    longitude: -75.14668,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13617',
  },
  {
    city: 'Cape Vincent',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 44.11641,
    longitude: -76.27851,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13618',
  },
  {
    city: 'Carthage',
    county_fips: 36045,
    county_fips_all: '36045|36049',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Lewis',
    county_weights: '{"36045": 54.49, "36049": 45.51}',
    density: 36.2,
    imprecise: false,
    latitude: 43.97705,
    longitude: -75.59432,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13619',
  },
  {
    city: 'Castorland',
    county_fips: 36049,
    county_fips_all: '36049',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"36049": 100}',
    density: 23.8,
    imprecise: false,
    latitude: 43.89989,
    longitude: -75.45265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13620',
  },
  {
    city: 'Chase Mills',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 8,
    imprecise: false,
    latitude: 44.8452,
    longitude: -75.06596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13621',
  },
  {
    city: 'Chaumont',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 44.09654,
    longitude: -76.115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13622',
  },
  {
    city: 'Chippewa Bay',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 58.9,
    imprecise: false,
    latitude: 44.44877,
    longitude: -75.75299,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13623',
  },
  {
    city: 'Clayton',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 44.22284,
    longitude: -76.09736,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13624',
  },
  {
    city: 'Colton',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 44.5384,
    longitude: -74.92135,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13625',
  },
  {
    city: 'Copenhagen',
    county_fips: 36049,
    county_fips_all: '36049|36045',
    county: 'Lewis',
    county_names_all: 'Lewis|Jefferson',
    county_weights: '{"36049": 86.46, "36045": 13.54}',
    density: 9.7,
    imprecise: false,
    latitude: 43.85143,
    longitude: -75.7202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13626',
  },
  {
    city: 'Deferiet',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 638.7,
    imprecise: false,
    latitude: 44.03764,
    longitude: -75.68307,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13628',
  },
  {
    city: 'De Kalb Junction',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 10,
    imprecise: false,
    latitude: 44.49742,
    longitude: -75.31756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13630',
  },
  {
    city: 'Depauville',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 27.3,
    imprecise: false,
    latitude: 44.12698,
    longitude: -76.06826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13632',
  },
  {
    city: 'De Peyster',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 44.48259,
    longitude: -75.48825,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13633',
  },
  {
    city: 'Dexter',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 28.5,
    imprecise: false,
    latitude: 44.01197,
    longitude: -76.07034,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13634',
  },
  {
    city: 'Edwards',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 44.29915,
    longitude: -75.26188,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13635',
  },
  {
    city: 'Ellisburg',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 16.1,
    imprecise: false,
    latitude: 43.74107,
    longitude: -76.12762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13636',
  },
  {
    city: 'Evans Mills',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 57.2,
    imprecise: false,
    latitude: 44.09751,
    longitude: -75.83346,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13637',
  },
  {
    city: 'Felts Mills',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 75.1,
    imprecise: false,
    latitude: 44.02077,
    longitude: -75.75443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13638',
  },
  {
    city: 'Fine',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 44.2594,
    longitude: -75.14324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13639',
  },
  {
    city: 'Wellesley Island',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 10,
    imprecise: false,
    latitude: 44.3198,
    longitude: -75.99937,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13640',
  },
  {
    city: 'Fishers Landing',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 85.8,
    imprecise: false,
    latitude: 44.27341,
    longitude: -76.00573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13641',
  },
  {
    city: 'Gouverneur',
    county_fips: 36089,
    county_fips_all: '36089|36045',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence|Jefferson',
    county_weights: '{"36089": 91.85, "36045": 8.15}',
    density: 18.5,
    imprecise: false,
    latitude: 44.3263,
    longitude: -75.46742,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13642',
  },
  {
    city: 'Great Bend',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 1719.9,
    imprecise: false,
    latitude: 44.03207,
    longitude: -75.71738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13643',
  },
  {
    city: 'Hailesboro',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.30878,
    longitude: -75.44655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13645',
  },
  {
    city: 'Hammond',
    county_fips: 36089,
    county_fips_all: '36089|36045',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence|Jefferson',
    county_weights: '{"36089": 99.08, "36045": 0.92}',
    density: 9.4,
    imprecise: false,
    latitude: 44.44144,
    longitude: -75.69379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13646',
  },
  {
    city: 'Hannawa Falls',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 7,
    imprecise: false,
    latitude: 44.6017,
    longitude: -74.99264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13647',
  },
  {
    city: 'Harrisville',
    county_fips: 36049,
    county_fips_all: '36049|36089',
    county: 'Lewis',
    county_names_all: 'Lewis|St. Lawrence',
    county_weights: '{"36049": 57.74, "36089": 42.26}',
    density: 5,
    imprecise: false,
    latitude: 44.14977,
    longitude: -75.29908,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13648',
  },
  {
    city: 'Helena',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 44.91246,
    longitude: -74.69983,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13649',
  },
  {
    city: 'Henderson',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 43.80742,
    longitude: -76.20629,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13650',
  },
  {
    city: 'Henderson Harbor',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 26.7,
    imprecise: false,
    latitude: 43.86513,
    longitude: -76.18125,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13651',
  },
  {
    city: 'Hermon',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 44.43579,
    longitude: -75.21338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13652',
  },
  {
    city: 'Heuvelton',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 44.56654,
    longitude: -75.46067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13654',
  },
  {
    city: 'Hogansburg',
    county_fips: 36033,
    county_fips_all: '36033',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"36033": 100}',
    density: 73.1,
    imprecise: false,
    latitude: 44.97865,
    longitude: -74.64781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13655',
  },
  {
    city: 'La Fargeville',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 13,
    imprecise: false,
    latitude: 44.19141,
    longitude: -75.95058,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13656',
  },
  {
    city: 'Lisbon',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 44.73979,
    longitude: -75.27756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13658',
  },
  {
    city: 'Lorraine',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 43.73783,
    longitude: -75.8707,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13659',
  },
  {
    city: 'Madrid',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 44.77727,
    longitude: -75.15764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13660',
  },
  {
    city: 'Mannsville',
    county_fips: 36045,
    county_fips_all: '36045|36075',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Oswego',
    county_weights: '{"36045": 89.5, "36075": 10.5}',
    density: 16.3,
    imprecise: false,
    latitude: 43.70924,
    longitude: -76.1054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13661',
  },
  {
    city: 'Massena',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 67.3,
    imprecise: false,
    latitude: 44.9378,
    longitude: -74.89383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13662',
  },
  {
    city: 'Morristown',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 152.1,
    imprecise: false,
    latitude: 44.58423,
    longitude: -75.64537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13664',
  },
  {
    city: 'Natural Bridge',
    county_fips: 36049,
    county_fips_all: '36049|36045',
    county: 'Lewis',
    county_names_all: 'Lewis|Jefferson',
    county_weights: '{"36049": 81.28, "36045": 18.72}',
    density: 5,
    imprecise: false,
    latitude: 44.05227,
    longitude: -75.44933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13665',
  },
  {
    city: 'Newton Falls',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 44.21404,
    longitude: -74.95557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13666',
  },
  {
    city: 'Norfolk',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 28.6,
    imprecise: false,
    latitude: 44.83768,
    longitude: -74.96149,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13667',
  },
  {
    city: 'Norwood',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 37.4,
    imprecise: false,
    latitude: 44.75432,
    longitude: -74.98764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13668',
  },
  {
    city: 'Ogdensburg',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 59.1,
    imprecise: false,
    latitude: 44.65004,
    longitude: -75.49861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13669',
  },
  {
    city: 'Oswegatchie',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 44.18264,
    longitude: -75.11635,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13670',
  },
  {
    city: 'Parishville',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 44.48166,
    longitude: -74.67987,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13672',
  },
  {
    city: 'Philadelphia',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 44.17105,
    longitude: -75.72133,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13673',
  },
  {
    city: 'Pierrepont Manor',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 1311.9,
    imprecise: false,
    latitude: 43.73763,
    longitude: -76.05192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13674',
  },
  {
    city: 'Plessis',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 44.28227,
    longitude: -75.83872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13675',
  },
  {
    city: 'Potsdam',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 31.1,
    imprecise: false,
    latitude: 44.65178,
    longitude: -74.91377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13676',
  },
  {
    city: 'Raymondville',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 44.83165,
    longitude: -74.96775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13678',
  },
  {
    city: 'Redwood',
    county_fips: 36045,
    county_fips_all: '36045|36089',
    county: 'Jefferson',
    county_names_all: 'Jefferson|St. Lawrence',
    county_weights: '{"36045": 76.09, "36089": 23.91}',
    density: 7.6,
    imprecise: false,
    latitude: 44.32664,
    longitude: -75.76554,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13679',
  },
  {
    city: 'Rensselaer Falls',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 44.59416,
    longitude: -75.32814,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13680',
  },
  {
    city: 'Richville',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 44.42933,
    longitude: -75.37142,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13681',
  },
  {
    city: 'Rodman',
    county_fips: 36045,
    county_fips_all: '36045|36049',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Lewis',
    county_weights: '{"36045": 92.46, "36049": 7.54}',
    density: 9.6,
    imprecise: false,
    latitude: 43.84024,
    longitude: -75.88924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13682',
  },
  {
    city: 'Rooseveltown',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 96.1,
    imprecise: false,
    latitude: 44.97395,
    longitude: -74.73543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13683',
  },
  {
    city: 'Russell',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 44.36577,
    longitude: -75.0464,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13684',
  },
  {
    city: 'Sackets Harbor',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 63.7,
    imprecise: false,
    latitude: 43.93343,
    longitude: -76.09399,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13685',
  },
  {
    city: 'South Colton',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 44.44744,
    longitude: -74.82516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13687',
  },
  {
    city: 'Star Lake',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 44.12612,
    longitude: -75.02319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13690',
  },
  {
    city: 'Theresa',
    county_fips: 36045,
    county_fips_all: '36045|36089',
    county: 'Jefferson',
    county_names_all: 'Jefferson|St. Lawrence',
    county_weights: '{"36045": 98.51, "36089": 1.49}',
    density: 16.3,
    imprecise: false,
    latitude: 44.22747,
    longitude: -75.78208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13691',
  },
  {
    city: 'Thousand Island Park',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 292.6,
    imprecise: false,
    latitude: 44.28861,
    longitude: -76.0258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13692',
  },
  {
    city: 'Three Mile Bay',
    county_fips: 36045,
    county_fips_all: '36045',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"36045": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 44.03237,
    longitude: -76.24824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13693',
  },
  {
    city: 'Waddington',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 30.8,
    imprecise: false,
    latitude: 44.8575,
    longitude: -75.1645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13694',
  },
  {
    city: 'Wanakena',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 44.10505,
    longitude: -74.92872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13695',
  },
  {
    city: 'West Stockholm',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 24.7,
    imprecise: false,
    latitude: 44.70425,
    longitude: -74.88971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13696',
  },
  {
    city: 'Winthrop',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 44.74841,
    longitude: -74.80656,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13697',
  },
  {
    city: 'Afton',
    county_fips: 36017,
    county_fips_all: '36017|36007',
    county: 'Chenango',
    county_names_all: 'Chenango|Broome',
    county_weights: '{"36017": 87.21, "36007": 12.79}',
    density: 20.2,
    imprecise: false,
    latitude: 42.23201,
    longitude: -75.53127,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13730',
  },
  {
    city: 'Andes',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 42.13059,
    longitude: -74.7882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13731',
  },
  {
    city: 'Apalachin',
    county_fips: 36107,
    county_fips_all: '36107',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"36107": 100}',
    density: 86.6,
    imprecise: false,
    latitude: 42.04396,
    longitude: -76.16772,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13732',
  },
  {
    city: 'Bainbridge',
    county_fips: 36017,
    county_fips_all: '36017|36025|36077',
    county: 'Chenango',
    county_names_all: 'Chenango|Delaware|Otsego',
    county_weights: '{"36017": 88.53, "36025": 9.23, "36077": 2.24}',
    density: 22.2,
    imprecise: false,
    latitude: 42.30459,
    longitude: -75.4793,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13733',
  },
  {
    city: 'Barton',
    county_fips: 36107,
    county_fips_all: '36107',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"36107": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 42.07752,
    longitude: -76.40864,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13734',
  },
  {
    city: 'Berkshire',
    county_fips: 36107,
    county_fips_all: '36107|36109|36007',
    county: 'Tioga',
    county_names_all: 'Tioga|Tompkins|Broome',
    county_weights: '{"36107": 75.4, "36109": 20.18, "36007": 4.42}',
    density: 12.2,
    imprecise: false,
    latitude: 42.31722,
    longitude: -76.19389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13736',
  },
  {
    city: 'Blodgett Mills',
    county_fips: 36023,
    county_fips_all: '36023',
    county: 'Cortland',
    county_names_all: 'Cortland',
    county_weights: '{"36023": 100}',
    density: 41.3,
    imprecise: false,
    latitude: 42.56236,
    longitude: -76.11986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13738',
  },
  {
    city: 'Bloomville',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 42.36614,
    longitude: -74.78982,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13739',
  },
  {
    city: 'Bovina Center',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 42.27535,
    longitude: -74.74498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13740',
  },
  {
    city: 'Candor',
    county_fips: 36107,
    county_fips_all: '36107',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"36107": 100}',
    density: 19.7,
    imprecise: false,
    latitude: 42.21706,
    longitude: -76.33898,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13743',
  },
  {
    city: 'Castle Creek',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 42.8,
    imprecise: false,
    latitude: 42.24078,
    longitude: -75.90629,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13744',
  },
  {
    city: 'Chenango Forks',
    county_fips: 36007,
    county_fips_all: '36007|36017',
    county: 'Broome',
    county_names_all: 'Broome|Chenango',
    county_weights: '{"36007": 60.84, "36017": 39.16}',
    density: 29.2,
    imprecise: false,
    latitude: 42.26868,
    longitude: -75.82085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13746',
  },
  {
    city: 'Colliersville',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.49003,
    longitude: -74.98209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13747',
  },
  {
    city: 'Conklin',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 106.9,
    imprecise: false,
    latitude: 42.03428,
    longitude: -75.81727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13748',
  },
  {
    city: 'Davenport',
    county_fips: 36025,
    county_fips_all: '36025|36077',
    county: 'Delaware',
    county_names_all: 'Delaware|Otsego',
    county_weights: '{"36025": 90.69, "36077": 9.31}',
    density: 14.5,
    imprecise: false,
    latitude: 42.47739,
    longitude: -74.83904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13750',
  },
  {
    city: 'Davenport Center',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 42.45745,
    longitude: -74.88363,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13751',
  },
  {
    city: 'Delancey',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 42.17257,
    longitude: -74.90379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13752',
  },
  {
    city: 'Delhi',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 22.5,
    imprecise: false,
    latitude: 42.30873,
    longitude: -74.92538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13753',
  },
  {
    city: 'Deposit',
    county_fips: 36007,
    county_fips_all: '36007|36025',
    county: 'Broome',
    county_names_all: 'Broome|Delaware',
    county_weights: '{"36007": 64.65, "36025": 35.35}',
    density: 13.7,
    imprecise: false,
    latitude: 42.09387,
    longitude: -75.43625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13754',
  },
  {
    city: 'Downsville',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 42.05976,
    longitude: -75.01524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13755',
  },
  {
    city: 'East Branch',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 6,
    imprecise: false,
    latitude: 42.01025,
    longitude: -75.10394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13756',
  },
  {
    city: 'East Meredith',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 42.40915,
    longitude: -74.89321,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13757',
  },
  {
    city: 'Endicott',
    county_fips: 36007,
    county_fips_all: '36007|36107',
    county: 'Broome',
    county_names_all: 'Broome|Tioga',
    county_weights: '{"36007": 71.75, "36107": 28.25}',
    density: 336,
    imprecise: false,
    latitude: 42.13425,
    longitude: -76.08354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13760',
  },
  {
    city: 'Fishs Eddy',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 20.6,
    imprecise: false,
    latitude: 41.96192,
    longitude: -75.17283,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13774',
  },
  {
    city: 'Franklin',
    county_fips: 36025,
    county_fips_all: '36025|36077',
    county: 'Delaware',
    county_names_all: 'Delaware|Otsego',
    county_weights: '{"36025": 98.26, "36077": 1.74}',
    density: 13.9,
    imprecise: false,
    latitude: 42.33706,
    longitude: -75.14728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13775',
  },
  {
    city: 'Gilbertsville',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 23.3,
    imprecise: false,
    latitude: 42.47023,
    longitude: -75.33458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13776',
  },
  {
    city: 'Glen Aubrey',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 33.4,
    imprecise: false,
    latitude: 42.25894,
    longitude: -75.9866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13777',
  },
  {
    city: 'Greene',
    county_fips: 36017,
    county_fips_all: '36017|36007',
    county: 'Chenango',
    county_names_all: 'Chenango|Broome',
    county_weights: '{"36017": 93.32, "36007": 6.68}',
    density: 21.6,
    imprecise: false,
    latitude: 42.34795,
    longitude: -75.75977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13778',
  },
  {
    city: 'Guilford',
    county_fips: 36017,
    county_fips_all: '36017',
    county: 'Chenango',
    county_names_all: 'Chenango',
    county_weights: '{"36017": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 42.42496,
    longitude: -75.48128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13780',
  },
  {
    city: 'Hamden',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 42.17304,
    longitude: -74.9836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13782',
  },
  {
    city: 'Hancock',
    county_fips: 36025,
    county_fips_all: '36025|36007',
    county: 'Delaware',
    county_names_all: 'Delaware|Broome',
    county_weights: '{"36025": 99.51, "36007": 0.49}',
    density: 7,
    imprecise: false,
    latitude: 41.99037,
    longitude: -75.26764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13783',
  },
  {
    city: 'Harford',
    county_fips: 36023,
    county_fips_all: '36023',
    county: 'Cortland',
    county_names_all: 'Cortland',
    county_weights: '{"36023": 100}',
    density: 143.2,
    imprecise: false,
    latitude: 42.43542,
    longitude: -76.2177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13784',
  },
  {
    city: 'Harpersfield',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 42.4485,
    longitude: -74.69563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13786',
  },
  {
    city: 'Harpursville',
    county_fips: 36007,
    county_fips_all: '36007|36017',
    county: 'Broome',
    county_names_all: 'Broome|Chenango',
    county_weights: '{"36007": 66.79, "36017": 33.21}',
    density: 15.4,
    imprecise: false,
    latitude: 42.20606,
    longitude: -75.66334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13787',
  },
  {
    city: 'Hobart',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 42.34914,
    longitude: -74.65658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13788',
  },
  {
    city: 'Johnson City',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 266.1,
    imprecise: false,
    latitude: 42.16937,
    longitude: -75.99796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13790',
  },
  {
    city: 'Kirkwood',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 59.5,
    imprecise: false,
    latitude: 42.05844,
    longitude: -75.77419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13795',
  },
  {
    city: 'Laurens',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 42.5513,
    longitude: -75.13644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13796',
  },
  {
    city: 'Lisle',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 24.3,
    imprecise: false,
    latitude: 42.32765,
    longitude: -76.04389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13797',
  },
  {
    city: 'McDonough',
    county_fips: 36017,
    county_fips_all: '36017',
    county: 'Chenango',
    county_names_all: 'Chenango',
    county_weights: '{"36017": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 42.50327,
    longitude: -75.78028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13801',
  },
  {
    city: 'Maine',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 42.25164,
    longitude: -76.04207,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13802',
  },
  {
    city: 'Marathon',
    county_fips: 36023,
    county_fips_all: '36023|36007',
    county: 'Cortland',
    county_names_all: 'Cortland|Broome',
    county_weights: '{"36023": 90.07, "36007": 9.93}',
    density: 17.6,
    imprecise: false,
    latitude: 42.45787,
    longitude: -76.06028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13803',
  },
  {
    city: 'Masonville',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 9,
    imprecise: false,
    latitude: 42.20708,
    longitude: -75.37562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13804',
  },
  {
    city: 'Meridale',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 14,
    imprecise: false,
    latitude: 42.37894,
    longitude: -74.97315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13806',
  },
  {
    city: 'Milford',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 42.61718,
    longitude: -74.98612,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13807',
  },
  {
    city: 'Morris',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 42.52797,
    longitude: -75.25657,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13808',
  },
  {
    city: 'Mount Upton',
    county_fips: 36077,
    county_fips_all: '36077|36017',
    county: 'Otsego',
    county_names_all: 'Otsego|Chenango',
    county_weights: '{"36077": 53.04, "36017": 46.96}',
    density: 16.2,
    imprecise: false,
    latitude: 42.40849,
    longitude: -75.3914,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13809',
  },
  {
    city: 'Mount Vision',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 42.61188,
    longitude: -75.11157,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13810',
  },
  {
    city: 'Newark Valley',
    county_fips: 36107,
    county_fips_all: '36107|36007',
    county: 'Tioga',
    county_names_all: 'Tioga|Broome',
    county_weights: '{"36107": 91.0, "36007": 9.0}',
    density: 25.6,
    imprecise: false,
    latitude: 42.23099,
    longitude: -76.17481,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13811',
  },
  {
    city: 'Nichols',
    county_fips: 36107,
    county_fips_all: '36107',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"36107": 100}',
    density: 31.7,
    imprecise: false,
    latitude: 42.02993,
    longitude: -76.35461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13812',
  },
  {
    city: 'Nineveh',
    county_fips: 36007,
    county_fips_all: '36007|36017',
    county: 'Broome',
    county_names_all: 'Broome|Chenango',
    county_weights: '{"36007": 90.08, "36017": 9.92}',
    density: 13.3,
    imprecise: false,
    latitude: 42.16808,
    longitude: -75.54266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13813',
  },
  {
    city: 'North Norwich',
    county_fips: 36017,
    county_fips_all: '36017',
    county: 'Chenango',
    county_names_all: 'Chenango',
    county_weights: '{"36017": 100}',
    density: 345.2,
    imprecise: false,
    latitude: 42.61655,
    longitude: -75.52584,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13814',
  },
  {
    city: 'Norwich',
    county_fips: 36017,
    county_fips_all: '36017',
    county: 'Chenango',
    county_names_all: 'Chenango',
    county_weights: '{"36017": 100}',
    density: 45.1,
    imprecise: false,
    latitude: 42.54712,
    longitude: -75.53413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13815',
  },
  {
    city: 'Oneonta',
    county_fips: 36077,
    county_fips_all: '36077|36025',
    county: 'Otsego',
    county_names_all: 'Otsego|Delaware',
    county_weights: '{"36077": 70.43, "36025": 29.57}',
    density: 82.9,
    imprecise: false,
    latitude: 42.47204,
    longitude: -75.03893,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13820',
  },
  {
    city: 'Otego',
    county_fips: 36077,
    county_fips_all: '36077|36025',
    county: 'Otsego',
    county_names_all: 'Otsego|Delaware',
    county_weights: '{"36077": 98.3, "36025": 1.7}',
    density: 19.8,
    imprecise: false,
    latitude: 42.44329,
    longitude: -75.20154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13825',
  },
  {
    city: 'Ouaquaga',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 31.8,
    imprecise: false,
    latitude: 42.10517,
    longitude: -75.63701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13826',
  },
  {
    city: 'Owego',
    county_fips: 36107,
    county_fips_all: '36107',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"36107": 100}',
    density: 50.4,
    imprecise: false,
    latitude: 42.11178,
    longitude: -76.25216,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13827',
  },
  {
    city: 'Oxford',
    county_fips: 36017,
    county_fips_all: '36017',
    county: 'Chenango',
    county_names_all: 'Chenango',
    county_weights: '{"36017": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 42.43868,
    longitude: -75.6295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13830',
  },
  {
    city: 'Plymouth',
    county_fips: 36017,
    county_fips_all: '36017',
    county: 'Chenango',
    county_names_all: 'Chenango',
    county_weights: '{"36017": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 42.6531,
    longitude: -75.66286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13832',
  },
  {
    city: 'Port Crane',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 43.9,
    imprecise: false,
    latitude: 42.19829,
    longitude: -75.76432,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13833',
  },
  {
    city: 'Portlandville',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 42.54903,
    longitude: -74.96727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13834',
  },
  {
    city: 'Richford',
    county_fips: 36107,
    county_fips_all: '36107|36007|36023',
    county: 'Tioga',
    county_names_all: 'Tioga|Broome|Cortland',
    county_weights: '{"36107": 59.08, "36007": 25.85, "36023": 15.07}',
    density: 10.4,
    imprecise: false,
    latitude: 42.38906,
    longitude: -76.16939,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13835',
  },
  {
    city: 'Sidney',
    county_fips: 36025,
    county_fips_all: '36025|36077',
    county: 'Delaware',
    county_names_all: 'Delaware|Otsego',
    county_weights: '{"36025": 95.63, "36077": 4.37}',
    density: 190.3,
    imprecise: false,
    latitude: 42.28423,
    longitude: -75.39595,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13838',
  },
  {
    city: 'Sidney Center',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 42.24824,
    longitude: -75.26007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13839',
  },
  {
    city: 'Smithville Flats',
    county_fips: 36017,
    county_fips_all: '36017|36023|36007',
    county: 'Chenango',
    county_names_all: 'Chenango|Cortland|Broome',
    county_weights: '{"36017": 80.48, "36023": 15.49, "36007": 4.03}',
    density: 16.2,
    imprecise: false,
    latitude: 42.41408,
    longitude: -75.84171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13841',
  },
  {
    city: 'South Kortright',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 42.37922,
    longitude: -74.72302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13842',
  },
  {
    city: 'South New Berlin',
    county_fips: 36077,
    county_fips_all: '36077|36017',
    county: 'Otsego',
    county_names_all: 'Otsego|Chenango',
    county_weights: '{"36077": 50.38, "36017": 49.62}',
    density: 15.1,
    imprecise: false,
    latitude: 42.53468,
    longitude: -75.37584,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13843',
  },
  {
    city: 'South Plymouth',
    county_fips: 36017,
    county_fips_all: '36017',
    county: 'Chenango',
    county_names_all: 'Chenango',
    county_weights: '{"36017": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 42.60927,
    longitude: -75.68083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13844',
  },
  {
    city: 'Treadwell',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 42.36037,
    longitude: -75.05465,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13846',
  },
  {
    city: 'Trout Creek',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 176.3,
    imprecise: false,
    latitude: 42.20443,
    longitude: -75.27777,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13847',
  },
  {
    city: 'Unadilla',
    county_fips: 36077,
    county_fips_all: '36077|36025',
    county: 'Otsego',
    county_names_all: 'Otsego|Delaware',
    county_weights: '{"36077": 53.99, "36025": 46.01}',
    density: 23.7,
    imprecise: false,
    latitude: 42.33785,
    longitude: -75.31392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13849',
  },
  {
    city: 'Vestal',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 179.1,
    imprecise: false,
    latitude: 42.04873,
    longitude: -76.02663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13850',
  },
  {
    city: 'Walton',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 42.16666,
    longitude: -75.16633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13856',
  },
  {
    city: 'Wells Bridge',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 43.8,
    imprecise: false,
    latitude: 42.37123,
    longitude: -75.24916,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13859',
  },
  {
    city: 'West Davenport',
    county_fips: 36025,
    county_fips_all: '36025',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"36025": 100}',
    density: 28.8,
    imprecise: false,
    latitude: 42.45573,
    longitude: -74.94989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13860',
  },
  {
    city: 'West Oneonta',
    county_fips: 36077,
    county_fips_all: '36077',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"36077": 100}',
    density: 47.1,
    imprecise: false,
    latitude: 42.5048,
    longitude: -75.14156,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13861',
  },
  {
    city: 'Whitney Point',
    county_fips: 36007,
    county_fips_all: '36007|36023',
    county: 'Broome',
    county_names_all: 'Broome|Cortland',
    county_weights: '{"36007": 98.8, "36023": 1.2}',
    density: 25.8,
    imprecise: false,
    latitude: 42.3369,
    longitude: -75.9372,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13862',
  },
  {
    city: 'Willet',
    county_fips: 36023,
    county_fips_all: '36023|36007',
    county: 'Cortland',
    county_names_all: 'Cortland|Broome',
    county_weights: '{"36023": 98.75, "36007": 1.25}',
    density: 12,
    imprecise: false,
    latitude: 42.44164,
    longitude: -75.904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13863',
  },
  {
    city: 'Willseyville',
    county_fips: 36107,
    county_fips_all: '36107|36109',
    county: 'Tioga',
    county_names_all: 'Tioga|Tompkins',
    county_weights: '{"36107": 75.71, "36109": 24.29}',
    density: 16.5,
    imprecise: false,
    latitude: 42.29095,
    longitude: -76.39225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13864',
  },
  {
    city: 'Windsor',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 42.06282,
    longitude: -75.62879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13865',
  },
  {
    city: 'Binghamton',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 329.3,
    imprecise: false,
    latitude: 42.18253,
    longitude: -75.88048,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13901',
  },
  {
    city: 'Binghamton',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 4039,
    imprecise: false,
    latitude: 42.08895,
    longitude: -75.96891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13902',
  },
  {
    city: 'Binghamton',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 171.9,
    imprecise: false,
    latitude: 42.04749,
    longitude: -75.89573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13903',
  },
  {
    city: 'Binghamton',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 149.9,
    imprecise: false,
    latitude: 42.13072,
    longitude: -75.81587,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13904',
  },
  {
    city: 'Binghamton',
    county_fips: 36007,
    county_fips_all: '36007',
    county: 'Broome',
    county_names_all: 'Broome',
    county_weights: '{"36007": 100}',
    density: 382.6,
    imprecise: false,
    latitude: 42.18086,
    longitude: -75.94476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13905',
  },
  {
    city: 'Akron',
    county_fips: 36029,
    county_fips_all: '36029|36063|36037',
    county: 'Erie',
    county_names_all: 'Erie|Niagara|Genesee',
    county_weights: '{"36029": 78.7, "36063": 13.03, "36037": 8.27}',
    density: 53.5,
    imprecise: false,
    latitude: 43.03149,
    longitude: -78.51154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14001',
  },
  {
    city: 'Alden',
    county_fips: 36029,
    county_fips_all: '36029|36121|36037',
    county: 'Erie',
    county_names_all: 'Erie|Wyoming|Genesee',
    county_weights: '{"36029": 82.32, "36121": 12.55, "36037": 5.13}',
    density: 90.5,
    imprecise: false,
    latitude: 42.89487,
    longitude: -78.51008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14004',
  },
  {
    city: 'Alexander',
    county_fips: 36037,
    county_fips_all: '36037',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"36037": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 42.91788,
    longitude: -78.24703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14005',
  },
  {
    city: 'Angola',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 127.1,
    imprecise: false,
    latitude: 42.63366,
    longitude: -79.02056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14006',
  },
  {
    city: 'Appleton',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 43.30792,
    longitude: -78.62728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14008',
  },
  {
    city: 'Arcade',
    county_fips: 36121,
    county_fips_all: '36121|36009',
    county: 'Wyoming',
    county_names_all: 'Wyoming|Cattaraugus',
    county_weights: '{"36121": 89.73, "36009": 10.27}',
    density: 30.3,
    imprecise: false,
    latitude: 42.57542,
    longitude: -78.39241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14009',
  },
  {
    city: 'Attica',
    county_fips: 36121,
    county_fips_all: '36121|36037',
    county: 'Wyoming',
    county_names_all: 'Wyoming|Genesee',
    county_weights: '{"36121": 89.85, "36037": 10.15}',
    density: 46,
    imprecise: false,
    latitude: 42.83158,
    longitude: -78.29784,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14011',
  },
  {
    city: 'Barker',
    county_fips: 36063,
    county_fips_all: '36063|36073',
    county: 'Niagara',
    county_names_all: 'Niagara|Orleans',
    county_weights: '{"36063": 95.58, "36073": 4.42}',
    density: 33.5,
    imprecise: false,
    latitude: 43.33431,
    longitude: -78.52572,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14012',
  },
  {
    city: 'Basom',
    county_fips: 36037,
    county_fips_all: '36037|36029',
    county: 'Genesee',
    county_names_all: 'Genesee|Erie',
    county_weights: '{"36037": 97.9, "36029": 2.1}',
    density: 15.9,
    imprecise: false,
    latitude: 43.07639,
    longitude: -78.39704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14013',
  },
  {
    city: 'Batavia',
    county_fips: 36037,
    county_fips_all: '36037',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"36037": 100}',
    density: 128.1,
    imprecise: false,
    latitude: 42.99513,
    longitude: -78.21508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14020',
  },
  {
    city: 'Bliss',
    county_fips: 36121,
    county_fips_all: '36121|36003',
    county: 'Wyoming',
    county_names_all: 'Wyoming|Allegany',
    county_weights: '{"36121": 94.94, "36003": 5.06}',
    density: 10.9,
    imprecise: false,
    latitude: 42.58111,
    longitude: -78.24431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14024',
  },
  {
    city: 'Boston',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 59.6,
    imprecise: false,
    latitude: 42.6232,
    longitude: -78.72609,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14025',
  },
  {
    city: 'Bowmansville',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 273.8,
    imprecise: false,
    latitude: 42.94212,
    longitude: -78.68794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14026',
  },
  {
    city: 'Brant',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 54.7,
    imprecise: false,
    latitude: 42.59408,
    longitude: -79.02067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14027',
  },
  {
    city: 'Burt',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 35,
    imprecise: false,
    latitude: 43.31498,
    longitude: -78.71664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14028',
  },
  {
    city: 'Centerville',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 42.47293,
    longitude: -78.26346,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14029',
  },
  {
    city: 'Chaffee',
    county_fips: 36029,
    county_fips_all: '36029|36009|36121',
    county: 'Erie',
    county_names_all: 'Erie|Cattaraugus|Wyoming',
    county_weights: '{"36029": 87.0, "36009": 9.68, "36121": 3.32}',
    density: 37.7,
    imprecise: false,
    latitude: 42.56518,
    longitude: -78.50052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14030',
  },
  {
    city: 'Clarence',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 197.2,
    imprecise: false,
    latitude: 42.98661,
    longitude: -78.60908,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14031',
  },
  {
    city: 'Clarence Center',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 165,
    imprecise: false,
    latitude: 43.04587,
    longitude: -78.63189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14032',
  },
  {
    city: 'Colden',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 34.2,
    imprecise: false,
    latitude: 42.65865,
    longitude: -78.68436,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14033',
  },
  {
    city: 'Collins',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 33.4,
    imprecise: false,
    latitude: 42.4985,
    longitude: -78.86238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14034',
  },
  {
    city: 'Collins Center',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 85.4,
    imprecise: false,
    latitude: 42.49099,
    longitude: -78.85936,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14035',
  },
  {
    city: 'Corfu',
    county_fips: 36037,
    county_fips_all: '36037',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"36037": 100}',
    density: 41.6,
    imprecise: false,
    latitude: 42.97447,
    longitude: -78.38712,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14036',
  },
  {
    city: 'Cowlesville',
    county_fips: 36121,
    county_fips_all: '36121|36029',
    county: 'Wyoming',
    county_names_all: 'Wyoming|Erie',
    county_weights: '{"36121": 88.84, "36029": 11.16}',
    density: 19.6,
    imprecise: false,
    latitude: 42.80637,
    longitude: -78.45448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14037',
  },
  {
    city: 'Dale',
    county_fips: 36121,
    county_fips_all: '36121',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"36121": 100}',
    density: 22.5,
    imprecise: false,
    latitude: 42.83593,
    longitude: -78.17101,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14039',
  },
  {
    city: 'Darien Center',
    county_fips: 36037,
    county_fips_all: '36037|36121',
    county: 'Genesee',
    county_names_all: 'Genesee|Wyoming',
    county_weights: '{"36037": 81.31, "36121": 18.69}',
    density: 25.4,
    imprecise: false,
    latitude: 42.88809,
    longitude: -78.37847,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14040',
  },
  {
    city: 'Dayton',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 93.5,
    imprecise: false,
    latitude: 42.4059,
    longitude: -78.97699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14041',
  },
  {
    city: 'Delevan',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 32.8,
    imprecise: false,
    latitude: 42.46882,
    longitude: -78.48377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14042',
  },
  {
    city: 'Depew',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 1066.5,
    imprecise: false,
    latitude: 42.90142,
    longitude: -78.70431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14043',
  },
  {
    city: 'Derby',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 176.6,
    imprecise: false,
    latitude: 42.68579,
    longitude: -78.99328,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14047',
  },
  {
    city: 'Dunkirk',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 247.7,
    imprecise: false,
    latitude: 42.48087,
    longitude: -79.31128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14048',
  },
  {
    city: 'East Amherst',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 491.8,
    imprecise: false,
    latitude: 43.04168,
    longitude: -78.69927,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14051',
  },
  {
    city: 'East Aurora',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 110.4,
    imprecise: false,
    latitude: 42.77054,
    longitude: -78.58084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14052',
  },
  {
    city: 'East Bethany',
    county_fips: 36037,
    county_fips_all: '36037|36121',
    county: 'Genesee',
    county_names_all: 'Genesee|Wyoming',
    county_weights: '{"36037": 86.82, "36121": 13.18}',
    density: 19,
    imprecise: false,
    latitude: 42.90606,
    longitude: -78.1312,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14054',
  },
  {
    city: 'East Concord',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 42.5536,
    longitude: -78.60121,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14055',
  },
  {
    city: 'East Pembroke',
    county_fips: 36037,
    county_fips_all: '36037',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"36037": 100}',
    density: 232.7,
    imprecise: false,
    latitude: 42.99183,
    longitude: -78.30663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14056',
  },
  {
    city: 'Eden',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 66.6,
    imprecise: false,
    latitude: 42.64587,
    longitude: -78.87542,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14057',
  },
  {
    city: 'Elba',
    county_fips: 36037,
    county_fips_all: '36037|36073',
    county: 'Genesee',
    county_names_all: 'Genesee|Orleans',
    county_weights: '{"36037": 82.25, "36073": 17.75}',
    density: 22.4,
    imprecise: false,
    latitude: 43.10167,
    longitude: -78.16211,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14058',
  },
  {
    city: 'Elma',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 130.9,
    imprecise: false,
    latitude: 42.83241,
    longitude: -78.63678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14059',
  },
  {
    city: 'Farmersville Station',
    county_fips: 36003,
    county_fips_all: '36003|36009',
    county: 'Allegany',
    county_names_all: 'Allegany|Cattaraugus',
    county_weights: '{"36003": 54.97, "36009": 45.03}',
    density: 7.2,
    imprecise: false,
    latitude: 42.43986,
    longitude: -78.30884,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14060',
  },
  {
    city: 'Farnham',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 344.4,
    imprecise: false,
    latitude: 42.59111,
    longitude: -79.08949,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14061',
  },
  {
    city: 'Forestville',
    county_fips: 36013,
    county_fips_all: '36013|36009',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua|Cattaraugus',
    county_weights: '{"36013": 99.71, "36009": 0.29}',
    density: 17.9,
    imprecise: false,
    latitude: 42.44364,
    longitude: -79.14897,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14062',
  },
  {
    city: 'Fredonia',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 95.5,
    imprecise: false,
    latitude: 42.41451,
    longitude: -79.32518,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14063',
  },
  {
    city: 'Freedom',
    county_fips: 36009,
    county_fips_all: '36009|36003',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus|Allegany',
    county_weights: '{"36009": 57.01, "36003": 42.99}',
    density: 16.9,
    imprecise: false,
    latitude: 42.48741,
    longitude: -78.31158,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14065',
  },
  {
    city: 'Gainesville',
    county_fips: 36121,
    county_fips_all: '36121',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"36121": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 42.62381,
    longitude: -78.18051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14066',
  },
  {
    city: 'Gasport',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 31.1,
    imprecise: false,
    latitude: 43.21565,
    longitude: -78.56644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14067',
  },
  {
    city: 'Getzville',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 903.4,
    imprecise: false,
    latitude: 43.02696,
    longitude: -78.75808,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14068',
  },
  {
    city: 'Glenwood',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 22.6,
    imprecise: false,
    latitude: 42.59984,
    longitude: -78.62984,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14069',
  },
  {
    city: 'Gowanda',
    county_fips: 36009,
    county_fips_all: '36009|36029',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus|Erie',
    county_weights: '{"36009": 57.85, "36029": 42.15}',
    density: 38,
    imprecise: false,
    latitude: 42.43673,
    longitude: -78.92798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14070',
  },
  {
    city: 'Grand Island',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 294.7,
    imprecise: false,
    latitude: 43.01673,
    longitude: -78.96308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14072',
  },
  {
    city: 'Hamburg',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 435.9,
    imprecise: false,
    latitude: 42.71297,
    longitude: -78.82985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14075',
  },
  {
    city: 'Holland',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 32.7,
    imprecise: false,
    latitude: 42.64289,
    longitude: -78.54886,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14080',
  },
  {
    city: 'Irving',
    county_fips: 36029,
    county_fips_all: '36029|36013|36009',
    county: 'Erie',
    county_names_all: 'Erie|Chautauqua|Cattaraugus',
    county_weights: '{"36029": 76.34, "36013": 21.43, "36009": 2.23}',
    density: 33,
    imprecise: false,
    latitude: 42.56332,
    longitude: -79.06528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14081',
  },
  {
    city: 'Java Center',
    county_fips: 36121,
    county_fips_all: '36121',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"36121": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 42.65689,
    longitude: -78.38435,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14082',
  },
  {
    city: 'Java Village',
    county_fips: 36121,
    county_fips_all: '36121',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"36121": 100}',
    density: 46.8,
    imprecise: false,
    latitude: 42.67921,
    longitude: -78.43446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 75,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14083',
  },
  {
    city: 'Lake View',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 426.7,
    imprecise: false,
    latitude: 42.71494,
    longitude: -78.92691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14085',
  },
  {
    city: 'Lancaster',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 412.6,
    imprecise: false,
    latitude: 42.90661,
    longitude: -78.6291,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14086',
  },
  {
    city: 'Lawtons',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 42.54224,
    longitude: -78.88868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14091',
  },
  {
    city: 'Lewiston',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 186.5,
    imprecise: false,
    latitude: 43.17314,
    longitude: -78.99521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14092',
  },
  {
    city: 'Lockport',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 159.2,
    imprecise: false,
    latitude: 43.15989,
    longitude: -78.70032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14094',
  },
  {
    city: 'Lyndonville',
    county_fips: 36073,
    county_fips_all: '36073|36063',
    county: 'Orleans',
    county_names_all: 'Orleans|Niagara',
    county_weights: '{"36073": 98.11, "36063": 1.89}',
    density: 22.5,
    imprecise: false,
    latitude: 43.33464,
    longitude: -78.37827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14098',
  },
  {
    city: 'Machias',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 42.3863,
    longitude: -78.54292,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14101',
  },
  {
    city: 'Marilla',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 213,
    imprecise: false,
    latitude: 42.84272,
    longitude: -78.55481,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14102',
  },
  {
    city: 'Medina',
    county_fips: 36073,
    county_fips_all: '36073',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"36073": 100}',
    density: 52.9,
    imprecise: false,
    latitude: 43.2125,
    longitude: -78.37696,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14103',
  },
  {
    city: 'Middleport',
    county_fips: 36063,
    county_fips_all: '36063|36073|36037',
    county: 'Niagara',
    county_names_all: 'Niagara|Orleans|Genesee',
    county_weights: '{"36063": 72.46, "36073": 18.95, "36037": 8.59}',
    density: 39.7,
    imprecise: false,
    latitude: 43.19043,
    longitude: -78.4813,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14105',
  },
  {
    city: 'Newfane',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 88.9,
    imprecise: false,
    latitude: 43.26365,
    longitude: -78.7274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14108',
  },
  {
    city: 'Niagara University',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 2463.1,
    imprecise: false,
    latitude: 43.13718,
    longitude: -79.03516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14109',
  },
  {
    city: 'North Collins',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 34.6,
    imprecise: false,
    latitude: 42.58206,
    longitude: -78.89803,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14111',
  },
  {
    city: 'North Evans',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.6981,
    longitude: -78.9395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14112',
  },
  {
    city: 'North Java',
    county_fips: 36121,
    county_fips_all: '36121',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"36121": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 42.66813,
    longitude: -78.33624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14113',
  },
  {
    city: 'North Tonawanda',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 523.7,
    imprecise: false,
    latitude: 43.07337,
    longitude: -78.83585,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14120',
  },
  {
    city: 'Oakfield',
    county_fips: 36037,
    county_fips_all: '36037|36073',
    county: 'Genesee',
    county_names_all: 'Genesee|Orleans',
    county_weights: '{"36037": 98.64, "36073": 1.36}',
    density: 35.9,
    imprecise: false,
    latitude: 43.08773,
    longitude: -78.28207,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14125',
  },
  {
    city: 'Olcott',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 63.4,
    imprecise: false,
    latitude: 43.33529,
    longitude: -78.72335,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14126',
  },
  {
    city: 'Orchard Park',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 299.1,
    imprecise: false,
    latitude: 42.75204,
    longitude: -78.74402,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14127',
  },
  {
    city: 'Perrysburg',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 42.4805,
    longitude: -79.0092,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14129',
  },
  {
    city: 'Pike',
    county_fips: 36121,
    county_fips_all: '36121',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"36121": 100}',
    density: 88.9,
    imprecise: false,
    latitude: 42.55318,
    longitude: -78.14959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14130',
  },
  {
    city: 'Ransomville',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 48.5,
    imprecise: false,
    latitude: 43.23556,
    longitude: -78.89935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14131',
  },
  {
    city: 'Sanborn',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 86.8,
    imprecise: false,
    latitude: 43.14787,
    longitude: -78.87856,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14132',
  },
  {
    city: 'Sardinia',
    county_fips: 36029,
    county_fips_all: '36029|36009',
    county: 'Erie',
    county_names_all: 'Erie|Cattaraugus',
    county_weights: '{"36029": 99.1, "36009": 0.9}',
    density: 17.6,
    imprecise: false,
    latitude: 42.53057,
    longitude: -78.51738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14134',
  },
  {
    city: 'Sheridan',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 45.7,
    imprecise: false,
    latitude: 42.48489,
    longitude: -79.2437,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 90,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14135',
  },
  {
    city: 'Silver Creek',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 86.6,
    imprecise: false,
    latitude: 42.52387,
    longitude: -79.16935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14136',
  },
  {
    city: 'South Dayton',
    county_fips: 36009,
    county_fips_all: '36009|36013',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus|Chautauqua',
    county_weights: '{"36009": 64.1, "36013": 35.9}',
    density: 16.9,
    imprecise: false,
    latitude: 42.37497,
    longitude: -79.05376,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14138',
  },
  {
    city: 'South Wales',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 32.8,
    imprecise: false,
    latitude: 42.71723,
    longitude: -78.53606,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14139',
  },
  {
    city: 'Springville',
    county_fips: 36029,
    county_fips_all: '36029|36009',
    county: 'Erie',
    county_names_all: 'Erie|Cattaraugus',
    county_weights: '{"36029": 83.06, "36009": 16.94}',
    density: 40.6,
    imprecise: false,
    latitude: 42.52366,
    longitude: -78.7109,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14141',
  },
  {
    city: 'Stafford',
    county_fips: 36037,
    county_fips_all: '36037',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"36037": 100}',
    density: 30.4,
    imprecise: false,
    latitude: 42.97547,
    longitude: -78.0759,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14143',
  },
  {
    city: 'Strykersville',
    county_fips: 36121,
    county_fips_all: '36121|36029',
    county: 'Wyoming',
    county_names_all: 'Wyoming|Erie',
    county_weights: '{"36121": 91.43, "36029": 8.57}',
    density: 17.4,
    imprecise: false,
    latitude: 42.73154,
    longitude: -78.43205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14145',
  },
  {
    city: 'Tonawanda',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 1071.6,
    imprecise: false,
    latitude: 42.99794,
    longitude: -78.87815,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14150',
  },
  {
    city: 'Van Buren Point',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 676.4,
    imprecise: false,
    latitude: 42.45088,
    longitude: -79.41592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14166',
  },
  {
    city: 'Varysburg',
    county_fips: 36121,
    county_fips_all: '36121',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"36121": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 42.74327,
    longitude: -78.32629,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14167',
  },
  {
    city: 'Versailles',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 60.4,
    imprecise: false,
    latitude: 42.51187,
    longitude: -78.98745,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14168',
  },
  {
    city: 'Wales Center',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 209.3,
    imprecise: false,
    latitude: 42.76446,
    longitude: -78.52938,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14169',
  },
  {
    city: 'West Falls',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 66,
    imprecise: false,
    latitude: 42.70115,
    longitude: -78.67294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14170',
  },
  {
    city: 'West Valley',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 42.42491,
    longitude: -78.64286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14171',
  },
  {
    city: 'Wilson',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 45.3,
    imprecise: false,
    latitude: 43.28201,
    longitude: -78.81757,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14172',
  },
  {
    city: 'Yorkshire',
    county_fips: 36009,
    county_fips_all: '36009|36121',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus|Wyoming',
    county_weights: '{"36009": 99.71, "36121": 0.29}',
    density: 178.1,
    imprecise: false,
    latitude: 42.52594,
    longitude: -78.47306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14173',
  },
  {
    city: 'Youngstown',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 94.2,
    imprecise: false,
    latitude: 43.24178,
    longitude: -79.00548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14174',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 4335.8,
    imprecise: false,
    latitude: 42.89706,
    longitude: -78.88752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14201',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 1713.1,
    imprecise: false,
    latitude: 42.88798,
    longitude: -78.88358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14202',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 334.2,
    imprecise: false,
    latitude: 42.86244,
    longitude: -78.86507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14203',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 1710,
    imprecise: false,
    latitude: 42.882,
    longitude: -78.8614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14204',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 1684.8,
    imprecise: false,
    latitude: 42.88078,
    longitude: -78.81018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14206',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 2602.6,
    imprecise: false,
    latitude: 42.95201,
    longitude: -78.89824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14207',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 4181.1,
    imprecise: false,
    latitude: 42.9146,
    longitude: -78.85146,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14208',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 3371.6,
    imprecise: false,
    latitude: 42.91365,
    longitude: -78.86622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14209',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 1910,
    imprecise: false,
    latitude: 42.86407,
    longitude: -78.82811,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14210',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 2418.2,
    imprecise: false,
    latitude: 42.90813,
    longitude: -78.81883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14211',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 2435.6,
    imprecise: false,
    latitude: 42.89438,
    longitude: -78.81957,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14212',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 4858.1,
    imprecise: false,
    latitude: 42.91762,
    longitude: -78.89099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14213',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 2472.3,
    imprecise: false,
    latitude: 42.93936,
    longitude: -78.84101,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14214',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 3446.8,
    imprecise: false,
    latitude: 42.93451,
    longitude: -78.81023,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14215',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 3196,
    imprecise: false,
    latitude: 42.94855,
    longitude: -78.862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14216',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 2708.7,
    imprecise: false,
    latitude: 42.97189,
    longitude: -78.87674,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14217',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 967.9,
    imprecise: false,
    latitude: 42.81921,
    longitude: -78.82772,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14218',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 592.1,
    imprecise: false,
    latitude: 42.78903,
    longitude: -78.82694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14219',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 2460.4,
    imprecise: false,
    latitude: 42.84571,
    longitude: -78.82264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14220',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 912.1,
    imprecise: false,
    latitude: 42.97918,
    longitude: -78.72158,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14221',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 4735.4,
    imprecise: false,
    latitude: 42.92002,
    longitude: -78.8771,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14222',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 2524.8,
    imprecise: false,
    latitude: 42.97348,
    longitude: -78.84612,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14223',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 786.1,
    imprecise: false,
    latitude: 42.83767,
    longitude: -78.74771,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14224',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 1130.3,
    imprecise: false,
    latitude: 42.92879,
    longitude: -78.752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14225',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 1633.8,
    imprecise: false,
    latitude: 42.97078,
    longitude: -78.79844,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14226',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 972.2,
    imprecise: false,
    latitude: 42.88402,
    longitude: -78.74665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14227',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 614.5,
    imprecise: false,
    latitude: 43.04214,
    longitude: -78.7798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14228',
  },
  {
    city: 'Niagara Falls',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 2039.7,
    imprecise: false,
    latitude: 43.09701,
    longitude: -79.03726,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14301',
  },
  {
    city: 'Niagara Falls',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 5251.2,
    imprecise: false,
    latitude: 43.0939,
    longitude: -79.04919,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14302',
  },
  {
    city: 'Niagara Falls',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 876,
    imprecise: false,
    latitude: 43.08428,
    longitude: -79.03908,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14303',
  },
  {
    city: 'Niagara Falls',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 523.5,
    imprecise: false,
    latitude: 43.10197,
    longitude: -78.95282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14304',
  },
  {
    city: 'Niagara Falls',
    county_fips: 36063,
    county_fips_all: '36063',
    county: 'Niagara',
    county_names_all: 'Niagara',
    county_weights: '{"36063": 100}',
    density: 822.7,
    imprecise: false,
    latitude: 43.1199,
    longitude: -79.02265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14305',
  },
  {
    city: 'Albion',
    county_fips: 36073,
    county_fips_all: '36073',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"36073": 100}',
    density: 42.6,
    imprecise: false,
    latitude: 43.23456,
    longitude: -78.21349,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14411',
  },
  {
    city: 'Alton',
    county_fips: 36117,
    county_fips_all: '36117',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"36117": 100}',
    density: 23,
    imprecise: false,
    latitude: 43.2229,
    longitude: -76.97067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14413',
  },
  {
    city: 'Avon',
    county_fips: 36051,
    county_fips_all: '36051|36055',
    county: 'Livingston',
    county_names_all: 'Livingston|Monroe',
    county_weights: '{"36051": 98.95, "36055": 1.05}',
    density: 64.7,
    imprecise: false,
    latitude: 42.89358,
    longitude: -77.73501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14414',
  },
  {
    city: 'Bellona',
    county_fips: 36123,
    county_fips_all: '36123',
    county: 'Yates',
    county_names_all: 'Yates',
    county_weights: '{"36123": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 42.7559,
    longitude: -77.01643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14415',
  },
  {
    city: 'Bergen',
    county_fips: 36037,
    county_fips_all: '36037|36055',
    county: 'Genesee',
    county_names_all: 'Genesee|Monroe',
    county_weights: '{"36037": 87.2, "36055": 12.8}',
    density: 37.9,
    imprecise: false,
    latitude: 43.08003,
    longitude: -77.97849,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14416',
  },
  {
    city: 'Branchport',
    county_fips: 36123,
    county_fips_all: '36123|36101',
    county: 'Yates',
    county_names_all: 'Yates|Steuben',
    county_weights: '{"36123": 89.39, "36101": 10.61}',
    density: 11.8,
    imprecise: false,
    latitude: 42.60717,
    longitude: -77.21681,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14418',
  },
  {
    city: 'Brockport',
    county_fips: 36055,
    county_fips_all: '36055|36073',
    county: 'Monroe',
    county_names_all: 'Monroe|Orleans',
    county_weights: '{"36055": 99.5, "36073": 0.5}',
    density: 133.3,
    imprecise: false,
    latitude: 43.21385,
    longitude: -77.93305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14420',
  },
  {
    city: 'Byron',
    county_fips: 36037,
    county_fips_all: '36037|36073',
    county: 'Genesee',
    county_names_all: 'Genesee|Orleans',
    county_weights: '{"36037": 94.31, "36073": 5.69}',
    density: 21.1,
    imprecise: false,
    latitude: 43.08357,
    longitude: -78.06704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14422',
  },
  {
    city: 'Caledonia',
    county_fips: 36051,
    county_fips_all: '36051',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"36051": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 42.94382,
    longitude: -77.82788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14423',
  },
  {
    city: 'Canandaigua',
    county_fips: 36069,
    county_fips_all: '36069',
    county: 'Ontario',
    county_names_all: 'Ontario',
    county_weights: '{"36069": 100}',
    density: 85.8,
    imprecise: false,
    latitude: 42.84649,
    longitude: -77.3104,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14424',
  },
  {
    city: 'Farmington',
    county_fips: 36069,
    county_fips_all: '36069',
    county: 'Ontario',
    county_names_all: 'Ontario',
    county_weights: '{"36069": 100}',
    density: 273.2,
    imprecise: false,
    latitude: 42.98962,
    longitude: -77.33734,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14425',
  },
  {
    city: 'Castile',
    county_fips: 36121,
    county_fips_all: '36121|36051',
    county: 'Wyoming',
    county_names_all: 'Wyoming|Livingston',
    county_weights: '{"36121": 99.71, "36051": 0.29}',
    density: 19.7,
    imprecise: false,
    latitude: 42.61828,
    longitude: -78.05442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14427',
  },
  {
    city: 'Churchville',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 67.6,
    imprecise: false,
    latitude: 43.08029,
    longitude: -77.85963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14428',
  },
  {
    city: 'Clifton Springs',
    county_fips: 36069,
    county_fips_all: '36069',
    county: 'Ontario',
    county_names_all: 'Ontario',
    county_weights: '{"36069": 100}',
    density: 54.2,
    imprecise: false,
    latitude: 42.95696,
    longitude: -77.14333,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14432',
  },
  {
    city: 'Clyde',
    county_fips: 36117,
    county_fips_all: '36117|36099',
    county: 'Wayne',
    county_names_all: 'Wayne|Seneca',
    county_weights: '{"36117": 92.87, "36099": 7.13}',
    density: 25.5,
    imprecise: false,
    latitude: 43.07939,
    longitude: -76.87779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14433',
  },
  {
    city: 'Conesus',
    county_fips: 36051,
    county_fips_all: '36051',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"36051": 100}',
    density: 26.6,
    imprecise: false,
    latitude: 42.71496,
    longitude: -77.66721,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14435',
  },
  {
    city: 'Dansville',
    county_fips: 36051,
    county_fips_all: '36051|36101|36003',
    county: 'Livingston',
    county_names_all: 'Livingston|Steuben|Allegany',
    county_weights: '{"36051": 83.83, "36101": 15.99, "36003": 0.18}',
    density: 29.4,
    imprecise: false,
    latitude: 42.57072,
    longitude: -77.73435,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14437',
  },
  {
    city: 'Dresden',
    county_fips: 36123,
    county_fips_all: '36123',
    county: 'Yates',
    county_names_all: 'Yates',
    county_weights: '{"36123": 100}',
    density: 302.7,
    imprecise: false,
    latitude: 42.68608,
    longitude: -76.95756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14441',
  },
  {
    city: 'East Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 1489.9,
    imprecise: false,
    latitude: 43.11312,
    longitude: -77.48978,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14445',
  },
  {
    city: 'Fairport',
    county_fips: 36055,
    county_fips_all: '36055|36117',
    county: 'Monroe',
    county_names_all: 'Monroe|Wayne',
    county_weights: '{"36055": 97.83, "36117": 2.17}',
    density: 515.2,
    imprecise: false,
    latitude: 43.0921,
    longitude: -77.41623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14450',
  },
  {
    city: 'Fishers',
    county_fips: 36069,
    county_fips_all: '36069',
    county: 'Ontario',
    county_names_all: 'Ontario',
    county_weights: '{"36069": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.01602,
    longitude: -77.47338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14453',
  },
  {
    city: 'Geneseo',
    county_fips: 36051,
    county_fips_all: '36051',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"36051": 100}',
    density: 90.2,
    imprecise: false,
    latitude: 42.79731,
    longitude: -77.76879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14454',
  },
  {
    city: 'Geneva',
    county_fips: 36069,
    county_fips_all: '36069|36099|36123',
    county: 'Ontario',
    county_names_all: 'Ontario|Seneca|Yates',
    county_weights: '{"36069": 76.85, "36099": 21.96, "36123": 1.19}',
    density: 98.7,
    imprecise: false,
    latitude: 42.84584,
    longitude: -77.00012,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14456',
  },
  {
    city: 'Groveland',
    county_fips: 36051,
    county_fips_all: '36051',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"36051": 100}',
    density: 28.2,
    imprecise: false,
    latitude: 42.68652,
    longitude: -77.75112,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14462',
  },
  {
    city: 'Hall',
    county_fips: 36069,
    county_fips_all: '36069',
    county: 'Ontario',
    county_names_all: 'Ontario',
    county_weights: '{"36069": 100}',
    density: 121.9,
    imprecise: false,
    latitude: 42.79539,
    longitude: -77.0689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14463',
  },
  {
    city: 'Hamlin',
    county_fips: 36055,
    county_fips_all: '36055|36073',
    county: 'Monroe',
    county_names_all: 'Monroe|Orleans',
    county_weights: '{"36055": 95.61, "36073": 4.39}',
    density: 86.8,
    imprecise: false,
    latitude: 43.32659,
    longitude: -77.9374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14464',
  },
  {
    city: 'Hemlock',
    county_fips: 36069,
    county_fips_all: '36069|36051',
    county: 'Ontario',
    county_names_all: 'Ontario|Livingston',
    county_weights: '{"36069": 57.13, "36051": 42.87}',
    density: 38.6,
    imprecise: false,
    latitude: 42.77773,
    longitude: -77.5842,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14466',
  },
  {
    city: 'Henrietta',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 382,
    imprecise: false,
    latitude: 43.04119,
    longitude: -77.60996,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14467',
  },
  {
    city: 'Hilton',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 135.9,
    imprecise: false,
    latitude: 43.29242,
    longitude: -77.80542,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14468',
  },
  {
    city: 'Bloomfield',
    county_fips: 36069,
    county_fips_all: '36069',
    county: 'Ontario',
    county_names_all: 'Ontario',
    county_weights: '{"36069": 100}',
    density: 35.2,
    imprecise: false,
    latitude: 42.87778,
    longitude: -77.46735,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14469',
  },
  {
    city: 'Holley',
    county_fips: 36073,
    county_fips_all: '36073|36055',
    county: 'Orleans',
    county_names_all: 'Orleans|Monroe',
    county_weights: '{"36073": 96.39, "36055": 3.61}',
    density: 46,
    imprecise: false,
    latitude: 43.21099,
    longitude: -78.05456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14470',
  },
  {
    city: 'Honeoye',
    county_fips: 36069,
    county_fips_all: '36069|36051',
    county: 'Ontario',
    county_names_all: 'Ontario|Livingston',
    county_weights: '{"36069": 99.66, "36051": 0.34}',
    density: 40.3,
    imprecise: false,
    latitude: 42.75308,
    longitude: -77.49425,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14471',
  },
  {
    city: 'Honeoye Falls',
    county_fips: 36055,
    county_fips_all: '36055|36051|36069',
    county: 'Monroe',
    county_names_all: 'Monroe|Livingston|Ontario',
    county_weights: '{"36055": 81.55, "36051": 15.48, "36069": 2.97}',
    density: 79.1,
    imprecise: false,
    latitude: 42.96589,
    longitude: -77.58173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14472',
  },
  {
    city: 'Ionia',
    county_fips: 36069,
    county_fips_all: '36069',
    county: 'Ontario',
    county_names_all: 'Ontario',
    county_weights: '{"36069": 100}',
    density: 48,
    imprecise: false,
    latitude: 42.93683,
    longitude: -77.49787,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14475',
  },
  {
    city: 'Kendall',
    county_fips: 36073,
    county_fips_all: '36073|36055',
    county: 'Orleans',
    county_names_all: 'Orleans|Monroe',
    county_weights: '{"36073": 95.43, "36055": 4.57}',
    density: 39.4,
    imprecise: false,
    latitude: 43.32946,
    longitude: -78.04226,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14476',
  },
  {
    city: 'Kent',
    county_fips: 36073,
    county_fips_all: '36073',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"36073": 100}',
    density: 24.2,
    imprecise: false,
    latitude: 43.33353,
    longitude: -78.13415,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14477',
  },
  {
    city: 'Keuka Park',
    county_fips: 36123,
    county_fips_all: '36123',
    county: 'Yates',
    county_names_all: 'Yates',
    county_weights: '{"36123": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 42.58011,
    longitude: -77.12791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14478',
  },
  {
    city: 'Knowlesville',
    county_fips: 36073,
    county_fips_all: '36073',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"36073": 100}',
    density: 53.9,
    imprecise: false,
    latitude: 43.23768,
    longitude: -78.31008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14479',
  },
  {
    city: 'Lakeville',
    county_fips: 36051,
    county_fips_all: '36051',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"36051": 100}',
    density: 157.1,
    imprecise: false,
    latitude: 42.83809,
    longitude: -77.70736,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14480',
  },
  {
    city: 'Leicester',
    county_fips: 36051,
    county_fips_all: '36051|36121',
    county: 'Livingston',
    county_names_all: 'Livingston|Wyoming',
    county_weights: '{"36051": 99.9, "36121": 0.1}',
    density: 28.3,
    imprecise: false,
    latitude: 42.77173,
    longitude: -77.91643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14481',
  },
  {
    city: 'Le Roy',
    county_fips: 36037,
    county_fips_all: '36037|36051|36055',
    county: 'Genesee',
    county_names_all: 'Genesee|Livingston|Monroe',
    county_weights: '{"36037": 90.78, "36051": 7.47, "36055": 1.75}',
    density: 52.8,
    imprecise: false,
    latitude: 42.97457,
    longitude: -77.97014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14482',
  },
  {
    city: 'Lima',
    county_fips: 36051,
    county_fips_all: '36051|36069',
    county: 'Livingston',
    county_names_all: 'Livingston|Ontario',
    county_weights: '{"36051": 88.34, "36069": 11.66}',
    density: 47.5,
    imprecise: false,
    latitude: 42.88016,
    longitude: -77.60131,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14485',
  },
  {
    city: 'Linwood',
    county_fips: 36051,
    county_fips_all: '36051',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"36051": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 42.89293,
    longitude: -77.92295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14486',
  },
  {
    city: 'Livonia',
    county_fips: 36051,
    county_fips_all: '36051|36069',
    county: 'Livingston',
    county_names_all: 'Livingston|Ontario',
    county_weights: '{"36051": 78.32, "36069": 21.68}',
    density: 64.4,
    imprecise: false,
    latitude: 42.81174,
    longitude: -77.63873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14487',
  },
  {
    city: 'Lyons',
    county_fips: 36117,
    county_fips_all: '36117|36069|36099',
    county: 'Wayne',
    county_names_all: 'Wayne|Ontario|Seneca',
    county_weights: '{"36117": 92.64, "36069": 3.94, "36099": 3.42}',
    density: 38.2,
    imprecise: false,
    latitude: 43.09008,
    longitude: -76.99238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14489',
  },
  {
    city: 'Macedon',
    county_fips: 36117,
    county_fips_all: '36117|36055',
    county: 'Wayne',
    county_names_all: 'Wayne|Monroe',
    county_weights: '{"36117": 96.24, "36055": 3.76}',
    density: 116.8,
    imprecise: false,
    latitude: 43.09532,
    longitude: -77.33598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14502',
  },
  {
    city: 'Manchester',
    county_fips: 36069,
    county_fips_all: '36069',
    county: 'Ontario',
    county_names_all: 'Ontario',
    county_weights: '{"36069": 100}',
    density: 532.8,
    imprecise: false,
    latitude: 42.96839,
    longitude: -77.2327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14504',
  },
  {
    city: 'Marion',
    county_fips: 36117,
    county_fips_all: '36117',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"36117": 100}',
    density: 50.1,
    imprecise: false,
    latitude: 43.15846,
    longitude: -77.17503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14505',
  },
  {
    city: 'Mendon',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 115,
    imprecise: false,
    latitude: 43.0012,
    longitude: -77.50508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14506',
  },
  {
    city: 'Middlesex',
    county_fips: 36123,
    county_fips_all: '36123',
    county: 'Yates',
    county_names_all: 'Yates',
    county_weights: '{"36123": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 42.69635,
    longitude: -77.27373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14507',
  },
  {
    city: 'Mount Morris',
    county_fips: 36051,
    county_fips_all: '36051',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"36051": 100}',
    density: 24.4,
    imprecise: false,
    latitude: 42.69485,
    longitude: -77.87167,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14510',
  },
  {
    city: 'Mumford',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 76.1,
    imprecise: false,
    latitude: 42.99603,
    longitude: -77.87762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14511',
  },
  {
    city: 'Naples',
    county_fips: 36069,
    county_fips_all: '36069|36123|36101|36051',
    county: 'Ontario',
    county_names_all: 'Ontario|Yates|Steuben|Livingston',
    county_weights:
      '{"36069": 65.73, "36123": 27.27, "36101": 5.53, "36051": 1.47}',
    density: 18.1,
    imprecise: false,
    latitude: 42.64411,
    longitude: -77.39296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14512',
  },
  {
    city: 'Newark',
    county_fips: 36117,
    county_fips_all: '36117|36069',
    county: 'Wayne',
    county_names_all: 'Wayne|Ontario',
    county_weights: '{"36117": 93.92, "36069": 6.08}',
    density: 114.2,
    imprecise: false,
    latitude: 43.07204,
    longitude: -77.0961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14513',
  },
  {
    city: 'North Chili',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 449.9,
    imprecise: false,
    latitude: 43.08597,
    longitude: -77.80303,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14514',
  },
  {
    city: 'North Greece',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 4716,
    imprecise: false,
    latitude: 43.25287,
    longitude: -77.73175,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14515',
  },
  {
    city: 'North Rose',
    county_fips: 36117,
    county_fips_all: '36117',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"36117": 100}',
    density: 29.1,
    imprecise: false,
    latitude: 43.19855,
    longitude: -76.91153,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14516',
  },
  {
    city: 'Nunda',
    county_fips: 36051,
    county_fips_all: '36051',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"36051": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 42.59217,
    longitude: -77.8971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14517',
  },
  {
    city: 'Ontario',
    county_fips: 36117,
    county_fips_all: '36117|36055',
    county: 'Wayne',
    county_names_all: 'Wayne|Monroe',
    county_weights: '{"36117": 97.54, "36055": 2.46}',
    density: 116.2,
    imprecise: false,
    latitude: 43.23184,
    longitude: -77.31389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14519',
  },
  {
    city: 'Ovid',
    county_fips: 36099,
    county_fips_all: '36099',
    county: 'Seneca',
    county_names_all: 'Seneca',
    county_weights: '{"36099": 100}',
    density: 26.1,
    imprecise: false,
    latitude: 42.67639,
    longitude: -76.80876,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14521',
  },
  {
    city: 'Palmyra',
    county_fips: 36117,
    county_fips_all: '36117|36069',
    county: 'Wayne',
    county_names_all: 'Wayne|Ontario',
    county_weights: '{"36117": 72.56, "36069": 27.44}',
    density: 77.3,
    imprecise: false,
    latitude: 43.05911,
    longitude: -77.22152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14522',
  },
  {
    city: 'Pavilion',
    county_fips: 36037,
    county_fips_all: '36037|36121|36051',
    county: 'Genesee',
    county_names_all: 'Genesee|Wyoming|Livingston',
    county_weights: '{"36037": 56.89, "36121": 34.44, "36051": 8.67}',
    density: 21.3,
    imprecise: false,
    latitude: 42.87242,
    longitude: -78.01471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14525',
  },
  {
    city: 'Penfield',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 462.8,
    imprecise: false,
    latitude: 43.15129,
    longitude: -77.44806,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14526',
  },
  {
    city: 'Penn Yan',
    county_fips: 36123,
    county_fips_all: '36123',
    county: 'Yates',
    county_names_all: 'Yates',
    county_weights: '{"36123": 100}',
    density: 36.3,
    imprecise: false,
    latitude: 42.66764,
    longitude: -77.06473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14527',
  },
  {
    city: 'Perkinsville',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 42.53748,
    longitude: -77.64418,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14529',
  },
  {
    city: 'Perry',
    county_fips: 36121,
    county_fips_all: '36121|36051',
    county: 'Wyoming',
    county_names_all: 'Wyoming|Livingston',
    county_weights: '{"36121": 95.24, "36051": 4.76}',
    density: 42.4,
    imprecise: false,
    latitude: 42.73446,
    longitude: -78.00276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14530',
  },
  {
    city: 'Phelps',
    county_fips: 36069,
    county_fips_all: '36069|36099',
    county: 'Ontario',
    county_names_all: 'Ontario|Seneca',
    county_weights: '{"36069": 87.33, "36099": 12.67}',
    density: 39,
    imprecise: false,
    latitude: 42.96462,
    longitude: -77.02601,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14532',
  },
  {
    city: 'Piffard',
    county_fips: 36051,
    county_fips_all: '36051|36121',
    county: 'Livingston',
    county_names_all: 'Livingston|Wyoming',
    county_weights: '{"36051": 99.17, "36121": 0.83}',
    density: 20.5,
    imprecise: false,
    latitude: 42.84632,
    longitude: -77.88468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14533',
  },
  {
    city: 'Pittsford',
    county_fips: 36055,
    county_fips_all: '36055|36069',
    county: 'Monroe',
    county_names_all: 'Monroe|Ontario',
    county_weights: '{"36055": 96.35, "36069": 3.65}',
    density: 396.7,
    imprecise: false,
    latitude: 43.0564,
    longitude: -77.52083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14534',
  },
  {
    city: 'Portageville',
    county_fips: 36121,
    county_fips_all: '36121|36003|36051',
    county: 'Wyoming',
    county_names_all: 'Wyoming|Allegany|Livingston',
    county_weights: '{"36121": 78.44, "36003": 20.96, "36051": 0.6}',
    density: 13.9,
    imprecise: false,
    latitude: 42.53958,
    longitude: -78.08358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14536',
  },
  {
    city: 'Port Gibson',
    county_fips: 36069,
    county_fips_all: '36069',
    county: 'Ontario',
    county_names_all: 'Ontario',
    county_weights: '{"36069": 100}',
    density: 116.8,
    imprecise: false,
    latitude: 43.03539,
    longitude: -77.15604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14537',
  },
  {
    city: 'Retsof',
    county_fips: 36051,
    county_fips_all: '36051',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"36051": 100}',
    density: 157,
    imprecise: false,
    latitude: 42.83418,
    longitude: -77.87521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14539',
  },
  {
    city: 'Romulus',
    county_fips: 36099,
    county_fips_all: '36099',
    county: 'Seneca',
    county_names_all: 'Seneca',
    county_weights: '{"36099": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 42.75704,
    longitude: -76.84403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14541',
  },
  {
    city: 'Rose',
    county_fips: 36117,
    county_fips_all: '36117',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"36117": 100}',
    density: 239.3,
    imprecise: false,
    latitude: 43.15306,
    longitude: -76.87595,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14542',
  },
  {
    city: 'Rush',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 57.1,
    imprecise: false,
    latitude: 42.98777,
    longitude: -77.67747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14543',
  },
  {
    city: 'Rushville',
    county_fips: 36123,
    county_fips_all: '36123|36069',
    county: 'Yates',
    county_names_all: 'Yates|Ontario',
    county_weights: '{"36123": 64.12, "36069": 35.88}',
    density: 30.4,
    imprecise: false,
    latitude: 42.75562,
    longitude: -77.23958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14544',
  },
  {
    city: 'Scottsburg',
    county_fips: 36051,
    county_fips_all: '36051',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"36051": 100}',
    density: 118.4,
    imprecise: false,
    latitude: 42.66166,
    longitude: -77.71056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14545',
  },
  {
    city: 'Scottsville',
    county_fips: 36055,
    county_fips_all: '36055|36051',
    county: 'Monroe',
    county_names_all: 'Monroe|Livingston',
    county_weights: '{"36055": 96.59, "36051": 3.41}',
    density: 47.6,
    imprecise: false,
    latitude: 43.0296,
    longitude: -77.77372,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14546',
  },
  {
    city: 'Shortsville',
    county_fips: 36069,
    county_fips_all: '36069',
    county: 'Ontario',
    county_names_all: 'Ontario',
    county_weights: '{"36069": 100}',
    density: 51.5,
    imprecise: false,
    latitude: 42.97538,
    longitude: -77.24341,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14548',
  },
  {
    city: 'Silver Lake',
    county_fips: 36121,
    county_fips_all: '36121',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"36121": 100}',
    density: 848.3,
    imprecise: false,
    latitude: 42.69667,
    longitude: -78.02212,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14549',
  },
  {
    city: 'Silver Springs',
    county_fips: 36121,
    county_fips_all: '36121',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"36121": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 42.67757,
    longitude: -78.09166,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14550',
  },
  {
    city: 'Sodus',
    county_fips: 36117,
    county_fips_all: '36117',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"36117": 100}',
    density: 44.8,
    imprecise: false,
    latitude: 43.21886,
    longitude: -77.04596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14551',
  },
  {
    city: 'Sodus Point',
    county_fips: 36117,
    county_fips_all: '36117',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"36117": 100}',
    density: 155.6,
    imprecise: false,
    latitude: 43.25946,
    longitude: -76.98665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14555',
  },
  {
    city: 'Sonyea',
    county_fips: 36051,
    county_fips_all: '36051',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"36051": 100}',
    density: 151.7,
    imprecise: false,
    latitude: 42.67906,
    longitude: -77.83222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14556',
  },
  {
    city: 'South Byron',
    county_fips: 36037,
    county_fips_all: '36037',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"36037": 100}',
    density: 66.4,
    imprecise: false,
    latitude: 43.04807,
    longitude: -78.06126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14557',
  },
  {
    city: 'Spencerport',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 151.9,
    imprecise: false,
    latitude: 43.18823,
    longitude: -77.81778,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14559',
  },
  {
    city: 'Springwater',
    county_fips: 36069,
    county_fips_all: '36069|36051',
    county: 'Ontario',
    county_names_all: 'Ontario|Livingston',
    county_weights: '{"36069": 58.19, "36051": 41.81}',
    density: 23.9,
    imprecise: false,
    latitude: 42.68716,
    longitude: -77.57691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14560',
  },
  {
    city: 'Stanley',
    county_fips: 36069,
    county_fips_all: '36069|36123',
    county: 'Ontario',
    county_names_all: 'Ontario|Yates',
    county_weights: '{"36069": 98.53, "36123": 1.47}',
    density: 16.1,
    imprecise: false,
    latitude: 42.82218,
    longitude: -77.13131,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14561',
  },
  {
    city: 'Victor',
    county_fips: 36069,
    county_fips_all: '36069|36055',
    county: 'Ontario',
    county_names_all: 'Ontario|Monroe',
    county_weights: '{"36069": 96.16, "36055": 3.84}',
    density: 149.5,
    imprecise: false,
    latitude: 42.98329,
    longitude: -77.42417,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14564',
  },
  {
    city: 'Walworth',
    county_fips: 36117,
    county_fips_all: '36117',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"36117": 100}',
    density: 87.5,
    imprecise: false,
    latitude: 43.14657,
    longitude: -77.28365,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14568',
  },
  {
    city: 'Warsaw',
    county_fips: 36121,
    county_fips_all: '36121',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"36121": 100}',
    density: 33.2,
    imprecise: false,
    latitude: 42.74012,
    longitude: -78.17269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14569',
  },
  {
    city: 'Waterport',
    county_fips: 36073,
    county_fips_all: '36073',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"36073": 100}',
    density: 27,
    imprecise: false,
    latitude: 43.34397,
    longitude: -78.24894,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14571',
  },
  {
    city: 'Wayland',
    county_fips: 36101,
    county_fips_all: '36101|36051',
    county: 'Steuben',
    county_names_all: 'Steuben|Livingston',
    county_weights: '{"36101": 56.0, "36051": 44.0}',
    density: 24.8,
    imprecise: false,
    latitude: 42.5669,
    longitude: -77.57017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14572',
  },
  {
    city: 'Webster',
    county_fips: 36055,
    county_fips_all: '36055|36117',
    county: 'Monroe',
    county_names_all: 'Monroe|Wayne',
    county_weights: '{"36055": 99.23, "36117": 0.77}',
    density: 490.5,
    imprecise: false,
    latitude: 43.21883,
    longitude: -77.44561,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14580',
  },
  {
    city: 'West Bloomfield',
    county_fips: 36069,
    county_fips_all: '36069',
    county: 'Ontario',
    county_names_all: 'Ontario',
    county_weights: '{"36069": 100}',
    density: 598.6,
    imprecise: false,
    latitude: 42.90587,
    longitude: -77.55301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14585',
  },
  {
    city: 'West Henrietta',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 465.3,
    imprecise: false,
    latitude: 43.04151,
    longitude: -77.68693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14586',
  },
  {
    city: 'Willard',
    county_fips: 36099,
    county_fips_all: '36099',
    county: 'Seneca',
    county_names_all: 'Seneca',
    county_weights: '{"36099": 100}',
    density: 347.8,
    imprecise: false,
    latitude: 42.67973,
    longitude: -76.87047,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14588',
  },
  {
    city: 'Williamson',
    county_fips: 36117,
    county_fips_all: '36117',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"36117": 100}',
    density: 70,
    imprecise: false,
    latitude: 43.23997,
    longitude: -77.17224,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14589',
  },
  {
    city: 'Wolcott',
    county_fips: 36117,
    county_fips_all: '36117',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"36117": 100}',
    density: 31.1,
    imprecise: false,
    latitude: 43.24533,
    longitude: -76.83099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14590',
  },
  {
    city: 'Wyoming',
    county_fips: 36121,
    county_fips_all: '36121|36037',
    county: 'Wyoming',
    county_names_all: 'Wyoming|Genesee',
    county_weights: '{"36121": 95.63, "36037": 4.37}',
    density: 16.5,
    imprecise: false,
    latitude: 42.82865,
    longitude: -78.09364,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14591',
  },
  {
    city: 'York',
    county_fips: 36051,
    county_fips_all: '36051',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"36051": 100}',
    density: 98.1,
    imprecise: false,
    latitude: 42.86875,
    longitude: -77.89066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14592',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 3675.3,
    imprecise: false,
    latitude: 43.1569,
    longitude: -77.60536,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14604',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 2549.3,
    imprecise: false,
    latitude: 43.16838,
    longitude: -77.60177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14605',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 1046.4,
    imprecise: false,
    latitude: 43.17069,
    longitude: -77.69933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14606',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 4028.9,
    imprecise: false,
    latitude: 43.15099,
    longitude: -77.58682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14607',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 2810,
    imprecise: false,
    latitude: 43.15335,
    longitude: -77.62362,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14608',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 2102.2,
    imprecise: false,
    latitude: 43.17731,
    longitude: -77.55234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14609',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 1314.5,
    imprecise: false,
    latitude: 43.14196,
    longitude: -77.5463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14610',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 2259.1,
    imprecise: false,
    latitude: 43.14756,
    longitude: -77.64731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14611',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 788.2,
    imprecise: false,
    latitude: 43.26513,
    longitude: -77.67654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14612',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 3065.3,
    imprecise: false,
    latitude: 43.1822,
    longitude: -77.64068,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14613',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 2020,
    imprecise: false,
    latitude: 43.1574,
    longitude: -77.61473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14614',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 1160.8,
    imprecise: false,
    latitude: 43.20337,
    longitude: -77.65637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14615',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 1766.4,
    imprecise: false,
    latitude: 43.23431,
    longitude: -77.65822,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14616',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 1062.7,
    imprecise: false,
    latitude: 43.22488,
    longitude: -77.59323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14617',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 1025.4,
    imprecise: false,
    latitude: 43.11305,
    longitude: -77.55547,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14618',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 3627,
    imprecise: false,
    latitude: 43.1361,
    longitude: -77.649,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14619',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 2068.9,
    imprecise: false,
    latitude: 43.12878,
    longitude: -77.60463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14620',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 3079.6,
    imprecise: false,
    latitude: 43.18911,
    longitude: -77.60408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14621',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 1094.1,
    imprecise: false,
    latitude: 43.21389,
    longitude: -77.55359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14622',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 514.7,
    imprecise: false,
    latitude: 43.08798,
    longitude: -77.64314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14623',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 545.3,
    imprecise: false,
    latitude: 43.12765,
    longitude: -77.7317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14624',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 542.2,
    imprecise: false,
    latitude: 43.14891,
    longitude: -77.50551,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14625',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 845,
    imprecise: false,
    latitude: 43.21348,
    longitude: -77.71272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14626',
  },
  {
    city: 'Jamestown',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 160.4,
    imprecise: false,
    latitude: 42.08091,
    longitude: -79.25502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14701',
  },
  {
    city: 'Allegany',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 28.3,
    imprecise: false,
    latitude: 42.10663,
    longitude: -78.52795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14706',
  },
  {
    city: 'Allentown',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 56.9,
    imprecise: false,
    latitude: 42.08256,
    longitude: -78.06196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14707',
  },
  {
    city: 'Alma',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 42.01424,
    longitude: -78.06988,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14708',
  },
  {
    city: 'Angelica',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 42.35279,
    longitude: -77.98267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14709',
  },
  {
    city: 'Ashville',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 42.08957,
    longitude: -79.42306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14710',
  },
  {
    city: 'Belfast',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 42.32088,
    longitude: -78.12625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14711',
  },
  {
    city: 'Bemus Point',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 48.9,
    imprecise: false,
    latitude: 42.18163,
    longitude: -79.36812,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14712',
  },
  {
    city: 'Black Creek',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 42.28368,
    longitude: -78.23493,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14714',
  },
  {
    city: 'Bolivar',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 21,
    imprecise: false,
    latitude: 42.07323,
    longitude: -78.14832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14715',
  },
  {
    city: 'Brocton',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 80,
    imprecise: false,
    latitude: 42.38056,
    longitude: -79.43406,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14716',
  },
  {
    city: 'Caneadea',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 42.36258,
    longitude: -78.18235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14717',
  },
  {
    city: 'Cassadaga',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 42.34417,
    longitude: -79.28813,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14718',
  },
  {
    city: 'Cattaraugus',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 42.34323,
    longitude: -78.87198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14719',
  },
  {
    city: 'Celoron',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 1249.5,
    imprecise: false,
    latitude: 42.10857,
    longitude: -79.27997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14720',
  },
  {
    city: 'Ceres',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 26,
    imprecise: false,
    latitude: 42.01645,
    longitude: -78.26801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14721',
  },
  {
    city: 'Chautauqua',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 259.8,
    imprecise: false,
    latitude: 42.20961,
    longitude: -79.46882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14722',
  },
  {
    city: 'Cherry Creek',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 42.3101,
    longitude: -79.13489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14723',
  },
  {
    city: 'Clymer',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 42.05272,
    longitude: -79.67031,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14724',
  },
  {
    city: 'Conewango Valley',
    county_fips: 36009,
    county_fips_all: '36009|36013',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus|Chautauqua',
    county_weights: '{"36009": 88.31, "36013": 11.69}',
    density: 23,
    imprecise: false,
    latitude: 42.25255,
    longitude: -79.02221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14726',
  },
  {
    city: 'Cuba',
    county_fips: 36003,
    county_fips_all: '36003|36009',
    county: 'Allegany',
    county_names_all: 'Allegany|Cattaraugus',
    county_weights: '{"36003": 64.05, "36009": 35.95}',
    density: 17.8,
    imprecise: false,
    latitude: 42.2129,
    longitude: -78.29358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14727',
  },
  {
    city: 'Dewittville',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 42.2648,
    longitude: -79.41689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14728',
  },
  {
    city: 'East Otto',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 42.40404,
    longitude: -78.73628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14729',
  },
  {
    city: 'Ellicottville',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 42.30063,
    longitude: -78.65092,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14731',
  },
  {
    city: 'Ellington',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 240.9,
    imprecise: false,
    latitude: 42.2188,
    longitude: -79.10696,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14732',
  },
  {
    city: 'Falconer',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 48.7,
    imprecise: false,
    latitude: 42.14996,
    longitude: -79.17499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14733',
  },
  {
    city: 'Fillmore',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 42.45027,
    longitude: -78.09681,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14735',
  },
  {
    city: 'Findley Lake',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 42.13715,
    longitude: -79.74644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14736',
  },
  {
    city: 'Franklinville',
    county_fips: 36009,
    county_fips_all: '36009|36003',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus|Allegany',
    county_weights: '{"36009": 98.97, "36003": 1.03}',
    density: 15.9,
    imprecise: false,
    latitude: 42.33524,
    longitude: -78.42926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14737',
  },
  {
    city: 'Frewsburg',
    county_fips: 36013,
    county_fips_all: '36013|36009',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua|Cattaraugus',
    county_weights: '{"36013": 50.72, "36009": 49.28}',
    density: 21.3,
    imprecise: false,
    latitude: 42.04539,
    longitude: -79.05926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14738',
  },
  {
    city: 'Friendship',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 13,
    imprecise: false,
    latitude: 42.1925,
    longitude: -78.14932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14739',
  },
  {
    city: 'Gerry',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 42.21962,
    longitude: -79.18053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14740',
  },
  {
    city: 'Great Valley',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 42.21868,
    longitude: -78.5963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14741',
  },
  {
    city: 'Greenhurst',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 220.7,
    imprecise: false,
    latitude: 42.11934,
    longitude: -79.30878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14742',
  },
  {
    city: 'Hinsdale',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 42.20532,
    longitude: -78.40631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14743',
  },
  {
    city: 'Houghton',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 42.5,
    imprecise: false,
    latitude: 42.4219,
    longitude: -78.21516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14744',
  },
  {
    city: 'Kennedy',
    county_fips: 36013,
    county_fips_all: '36013|36009',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua|Cattaraugus',
    county_weights: '{"36013": 81.55, "36009": 18.45}',
    density: 17.4,
    imprecise: false,
    latitude: 42.15346,
    longitude: -79.09061,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14747',
  },
  {
    city: 'Kill Buck',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 42.1392,
    longitude: -78.63636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14748',
  },
  {
    city: 'Lakewood',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 154.5,
    imprecise: false,
    latitude: 42.07939,
    longitude: -79.32752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14750',
  },
  {
    city: 'Lily Dale',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 95.9,
    imprecise: false,
    latitude: 42.3517,
    longitude: -79.31965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14752',
  },
  {
    city: 'Limestone',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 42.03899,
    longitude: -78.63516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14753',
  },
  {
    city: 'Little Genesee',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 42.02385,
    longitude: -78.19799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14754',
  },
  {
    city: 'Little Valley',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 42.23477,
    longitude: -78.81398,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14755',
  },
  {
    city: 'Maple Springs',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 428.1,
    imprecise: false,
    latitude: 42.19708,
    longitude: -79.42373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14756',
  },
  {
    city: 'Mayville',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 42.23944,
    longitude: -79.50457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14757',
  },
  {
    city: 'Olean',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 103.7,
    imprecise: false,
    latitude: 42.07098,
    longitude: -78.41421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14760',
  },
  {
    city: 'Panama',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 42.05344,
    longitude: -79.51583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14767',
  },
  {
    city: 'Portland',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 32.5,
    imprecise: false,
    latitude: 42.36885,
    longitude: -79.47413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14769',
  },
  {
    city: 'Portville',
    county_fips: 36003,
    county_fips_all: '36003|36009',
    county: 'Allegany',
    county_names_all: 'Allegany|Cattaraugus',
    county_weights: '{"36003": 52.1, "36009": 47.9}',
    density: 34.7,
    imprecise: false,
    latitude: 42.0468,
    longitude: -78.29963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14770',
  },
  {
    city: 'Randolph',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 42.15383,
    longitude: -78.95086,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14772',
  },
  {
    city: 'Richburg',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 486.3,
    imprecise: false,
    latitude: 42.08875,
    longitude: -78.14658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14774',
  },
  {
    city: 'Ripley',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 42.23198,
    longitude: -79.69532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14775',
  },
  {
    city: 'Rushford',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 23,
    imprecise: false,
    latitude: 42.38999,
    longitude: -78.26167,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14777',
  },
  {
    city: 'Saint Bonaventure',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 1292.9,
    imprecise: false,
    latitude: 42.07759,
    longitude: -78.4827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14778',
  },
  {
    city: 'Salamanca',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 42.10703,
    longitude: -78.76977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14779',
  },
  {
    city: 'Sherman',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 42.16402,
    longitude: -79.604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14781',
  },
  {
    city: 'Sinclairville',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 42.2665,
    longitude: -79.2559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14782',
  },
  {
    city: 'Steamburg',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 42.06014,
    longitude: -78.91816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14783',
  },
  {
    city: 'Stockton',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 42.31445,
    longitude: -79.38028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14784',
  },
  {
    city: 'Stow',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.15572,
    longitude: -79.40337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14785',
  },
  {
    city: 'Westfield',
    county_fips: 36013,
    county_fips_all: '36013',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"36013": 100}',
    density: 43.2,
    imprecise: false,
    latitude: 42.31342,
    longitude: -79.5675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14787',
  },
  {
    city: 'Westons Mills',
    county_fips: 36009,
    county_fips_all: '36009',
    county: 'Cattaraugus',
    county_names_all: 'Cattaraugus',
    county_weights: '{"36009": 100}',
    density: 127.3,
    imprecise: false,
    latitude: 42.06012,
    longitude: -78.37661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14788',
  },
  {
    city: 'Addison',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 42.09718,
    longitude: -77.28461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14801',
  },
  {
    city: 'Alfred',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 1634,
    imprecise: false,
    latitude: 42.2537,
    longitude: -77.78989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14802',
  },
  {
    city: 'Alfred Station',
    county_fips: 36003,
    county_fips_all: '36003|36101',
    county: 'Allegany',
    county_names_all: 'Allegany|Steuben',
    county_weights: '{"36003": 90.84, "36101": 9.16}',
    density: 20.8,
    imprecise: false,
    latitude: 42.25135,
    longitude: -77.78808,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14803',
  },
  {
    city: 'Almond',
    county_fips: 36003,
    county_fips_all: '36003|36101',
    county: 'Allegany',
    county_names_all: 'Allegany|Steuben',
    county_weights: '{"36003": 99.87, "36101": 0.13}',
    density: 9.7,
    imprecise: false,
    latitude: 42.31587,
    longitude: -77.8476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14804',
  },
  {
    city: 'Alpine',
    county_fips: 36097,
    county_fips_all: '36097|36015',
    county: 'Schuyler',
    county_names_all: 'Schuyler|Chemung',
    county_weights: '{"36097": 95.24, "36015": 4.76}',
    density: 10.5,
    imprecise: false,
    latitude: 42.3563,
    longitude: -76.72618,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14805',
  },
  {
    city: 'Andover',
    county_fips: 36003,
    county_fips_all: '36003|36101',
    county: 'Allegany',
    county_names_all: 'Allegany|Steuben',
    county_weights: '{"36003": 85.2, "36101": 14.8}',
    density: 12.1,
    imprecise: false,
    latitude: 42.15543,
    longitude: -77.78662,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14806',
  },
  {
    city: 'Arkport',
    county_fips: 36101,
    county_fips_all: '36101|36003',
    county: 'Steuben',
    county_names_all: 'Steuben|Allegany',
    county_weights: '{"36101": 54.87, "36003": 45.13}',
    density: 14.2,
    imprecise: false,
    latitude: 42.41821,
    longitude: -77.71949,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14807',
  },
  {
    city: 'Atlanta',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 71.4,
    imprecise: false,
    latitude: 42.55817,
    longitude: -77.46882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14808',
  },
  {
    city: 'Avoca',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 19.6,
    imprecise: false,
    latitude: 42.41961,
    longitude: -77.44355,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14809',
  },
  {
    city: 'Bath',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 36.9,
    imprecise: false,
    latitude: 42.34678,
    longitude: -77.34599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14810',
  },
  {
    city: 'Beaver Dams',
    county_fips: 36097,
    county_fips_all: '36097|36101|36015',
    county: 'Schuyler',
    county_names_all: 'Schuyler|Steuben|Chemung',
    county_weights: '{"36097": 57.18, "36101": 24.46, "36015": 18.36}',
    density: 14.9,
    imprecise: false,
    latitude: 42.29199,
    longitude: -76.99413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14812',
  },
  {
    city: 'Belmont',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 42.24638,
    longitude: -77.99209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14813',
  },
  {
    city: 'Big Flats',
    county_fips: 36015,
    county_fips_all: '36015|36101',
    county: 'Chemung',
    county_names_all: 'Chemung|Steuben',
    county_weights: '{"36015": 91.23, "36101": 8.77}',
    density: 100.4,
    imprecise: false,
    latitude: 42.15525,
    longitude: -76.95148,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14814',
  },
  {
    city: 'Bradford',
    county_fips: 36097,
    county_fips_all: '36097|36101',
    county: 'Schuyler',
    county_names_all: 'Schuyler|Steuben',
    county_weights: '{"36097": 68.4, "36101": 31.6}',
    density: 14.4,
    imprecise: false,
    latitude: 42.37335,
    longitude: -77.09463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14815',
  },
  {
    city: 'Breesport',
    county_fips: 36015,
    county_fips_all: '36015',
    county: 'Chemung',
    county_names_all: 'Chemung',
    county_weights: '{"36015": 100}',
    density: 54.8,
    imprecise: false,
    latitude: 42.19728,
    longitude: -76.73161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14816',
  },
  {
    city: 'Brooktondale',
    county_fips: 36109,
    county_fips_all: '36109|36107',
    county: 'Tompkins',
    county_names_all: 'Tompkins|Tioga',
    county_weights: '{"36109": 95.15, "36107": 4.85}',
    density: 23.5,
    imprecise: false,
    latitude: 42.36295,
    longitude: -76.34548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14817',
  },
  {
    city: 'Burdett',
    county_fips: 36097,
    county_fips_all: '36097',
    county: 'Schuyler',
    county_names_all: 'Schuyler',
    county_weights: '{"36097": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 42.44878,
    longitude: -76.81688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14818',
  },
  {
    city: 'Cameron',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 42.21924,
    longitude: -77.43466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14819',
  },
  {
    city: 'Cameron Mills',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 42.18629,
    longitude: -77.36258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14820',
  },
  {
    city: 'Campbell',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 42.23541,
    longitude: -77.21623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14821',
  },
  {
    city: 'Canaseraga',
    county_fips: 36003,
    county_fips_all: '36003|36051',
    county: 'Allegany',
    county_names_all: 'Allegany|Livingston',
    county_weights: '{"36003": 87.47, "36051": 12.53}',
    density: 8.2,
    imprecise: false,
    latitude: 42.43522,
    longitude: -77.84702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14822',
  },
  {
    city: 'Canisteo',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 42.23984,
    longitude: -77.5722,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14823',
  },
  {
    city: 'Cayuta',
    county_fips: 36097,
    county_fips_all: '36097|36015',
    county: 'Schuyler',
    county_names_all: 'Schuyler|Chemung',
    county_weights: '{"36097": 66.7, "36015": 33.3}',
    density: 13,
    imprecise: false,
    latitude: 42.26875,
    longitude: -76.70881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14824',
  },
  {
    city: 'Chemung',
    county_fips: 36015,
    county_fips_all: '36015',
    county: 'Chemung',
    county_names_all: 'Chemung',
    county_weights: '{"36015": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 42.05564,
    longitude: -76.62116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14825',
  },
  {
    city: 'Cohocton',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 42.49354,
    longitude: -77.49335,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14826',
  },
  {
    city: 'Coopers Plains',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 94.4,
    imprecise: false,
    latitude: 42.18069,
    longitude: -77.14292,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14827',
  },
  {
    city: 'Corning',
    county_fips: 36101,
    county_fips_all: '36101|36015',
    county: 'Steuben',
    county_names_all: 'Steuben|Chemung',
    county_weights: '{"36101": 93.28, "36015": 6.72}',
    density: 81,
    imprecise: false,
    latitude: 42.12927,
    longitude: -77.02783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14830',
  },
  {
    city: 'Dalton',
    county_fips: 36051,
    county_fips_all: '36051|36003',
    county: 'Livingston',
    county_names_all: 'Livingston|Allegany',
    county_weights: '{"36051": 59.03, "36003": 40.97}',
    density: 13.4,
    imprecise: false,
    latitude: 42.51526,
    longitude: -77.91526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14836',
  },
  {
    city: 'Dundee',
    county_fips: 36123,
    county_fips_all: '36123|36097|36101',
    county: 'Yates',
    county_names_all: 'Yates|Schuyler|Steuben',
    county_weights: '{"36123": 67.12, "36097": 31.43, "36101": 1.45}',
    density: 28.4,
    imprecise: false,
    latitude: 42.49919,
    longitude: -77.01668,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14837',
  },
  {
    city: 'Erin',
    county_fips: 36015,
    county_fips_all: '36015|36097',
    county: 'Chemung',
    county_names_all: 'Chemung|Schuyler',
    county_weights: '{"36015": 93.83, "36097": 6.17}',
    density: 18.3,
    imprecise: false,
    latitude: 42.18951,
    longitude: -76.66635,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14838',
  },
  {
    city: 'Greenwood',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 42.13961,
    longitude: -77.64331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14839',
  },
  {
    city: 'Hammondsport',
    county_fips: 36101,
    county_fips_all: '36101|36097',
    county: 'Steuben',
    county_names_all: 'Steuben|Schuyler',
    county_weights: '{"36101": 99.43, "36097": 0.57}',
    density: 16,
    imprecise: false,
    latitude: 42.44119,
    longitude: -77.18758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14840',
  },
  {
    city: 'Hector',
    county_fips: 36097,
    county_fips_all: '36097|36099',
    county: 'Schuyler',
    county_names_all: 'Schuyler|Seneca',
    county_weights: '{"36097": 73.32, "36099": 26.68}',
    density: 13.4,
    imprecise: false,
    latitude: 42.52699,
    longitude: -76.84249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14841',
  },
  {
    city: 'Himrod',
    county_fips: 36123,
    county_fips_all: '36123',
    county: 'Yates',
    county_names_all: 'Yates',
    county_weights: '{"36123": 100}',
    density: 19.7,
    imprecise: false,
    latitude: 42.59666,
    longitude: -76.963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14842',
  },
  {
    city: 'Hornell',
    county_fips: 36101,
    county_fips_all: '36101|36003',
    county: 'Steuben',
    county_names_all: 'Steuben|Allegany',
    county_weights: '{"36101": 96.34, "36003": 3.66}',
    density: 49.9,
    imprecise: false,
    latitude: 42.32819,
    longitude: -77.64371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14843',
  },
  {
    city: 'Horseheads',
    county_fips: 36015,
    county_fips_all: '36015',
    county: 'Chemung',
    county_names_all: 'Chemung',
    county_weights: '{"36015": 100}',
    density: 100.4,
    imprecise: false,
    latitude: 42.20225,
    longitude: -76.8334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14845',
  },
  {
    city: 'Hunt',
    county_fips: 36051,
    county_fips_all: '36051|36003|36121',
    county: 'Livingston',
    county_names_all: 'Livingston|Allegany|Wyoming',
    county_weights: '{"36051": 59.66, "36003": 40.09, "36121": 0.25}',
    density: 10.4,
    imprecise: false,
    latitude: 42.5301,
    longitude: -78.00319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14846',
  },
  {
    city: 'Interlaken',
    county_fips: 36099,
    county_fips_all: '36099|36097',
    county: 'Seneca',
    county_names_all: 'Seneca|Schuyler',
    county_weights: '{"36099": 97.05, "36097": 2.95}',
    density: 22,
    imprecise: false,
    latitude: 42.6031,
    longitude: -76.74047,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14847',
  },
  {
    city: 'Ithaca',
    county_fips: 36109,
    county_fips_all: '36109',
    county: 'Tompkins',
    county_names_all: 'Tompkins',
    county_weights: '{"36109": 100}',
    density: 212.2,
    imprecise: false,
    latitude: 42.43249,
    longitude: -76.49891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14850',
  },
  {
    city: 'Jacksonville',
    county_fips: 36109,
    county_fips_all: '36109',
    county: 'Tompkins',
    county_names_all: 'Tompkins',
    county_weights: '{"36109": 100}',
    density: 67.2,
    imprecise: false,
    latitude: 42.51138,
    longitude: -76.60874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14854',
  },
  {
    city: 'Jasper',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 42.13978,
    longitude: -77.50112,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14855',
  },
  {
    city: 'Kanona',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.37737,
    longitude: -77.36944,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14856',
  },
  {
    city: 'Lindley',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 42.02909,
    longitude: -77.13315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14858',
  },
  {
    city: 'Lockwood',
    county_fips: 36107,
    county_fips_all: '36107|36015',
    county: 'Tioga',
    county_names_all: 'Tioga|Chemung',
    county_weights: '{"36107": 59.51, "36015": 40.49}',
    density: 12.1,
    imprecise: false,
    latitude: 42.12118,
    longitude: -76.53985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14859',
  },
  {
    city: 'Lodi',
    county_fips: 36099,
    county_fips_all: '36099',
    county: 'Seneca',
    county_names_all: 'Seneca',
    county_weights: '{"36099": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 42.59099,
    longitude: -76.84201,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14860',
  },
  {
    city: 'Lowman',
    county_fips: 36015,
    county_fips_all: '36015',
    county: 'Chemung',
    county_names_all: 'Chemung',
    county_weights: '{"36015": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 42.0914,
    longitude: -76.6888,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14861',
  },
  {
    city: 'Millport',
    county_fips: 36015,
    county_fips_all: '36015|36097',
    county: 'Chemung',
    county_names_all: 'Chemung|Schuyler',
    county_weights: '{"36015": 70.75, "36097": 29.25}',
    density: 38.1,
    imprecise: false,
    latitude: 42.2804,
    longitude: -76.84205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14864',
  },
  {
    city: 'Montour Falls',
    county_fips: 36097,
    county_fips_all: '36097',
    county: 'Schuyler',
    county_names_all: 'Schuyler',
    county_weights: '{"36097": 100}',
    density: 42.2,
    imprecise: false,
    latitude: 42.35091,
    longitude: -76.83178,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14865',
  },
  {
    city: 'Newfield',
    county_fips: 36109,
    county_fips_all: '36109|36015',
    county: 'Tompkins',
    county_names_all: 'Tompkins|Chemung',
    county_weights: '{"36109": 97.64, "36015": 2.36}',
    density: 29.4,
    imprecise: false,
    latitude: 42.34243,
    longitude: -76.61461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14867',
  },
  {
    city: 'Odessa',
    county_fips: 36097,
    county_fips_all: '36097',
    county: 'Schuyler',
    county_names_all: 'Schuyler',
    county_weights: '{"36097": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 42.36403,
    longitude: -76.77052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14869',
  },
  {
    city: 'Painted Post',
    county_fips: 36101,
    county_fips_all: '36101|36097',
    county: 'Steuben',
    county_names_all: 'Steuben|Schuyler',
    county_weights: '{"36101": 94.87, "36097": 5.13}',
    density: 58.7,
    imprecise: false,
    latitude: 42.16816,
    longitude: -77.13234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14870',
  },
  {
    city: 'Pine City',
    county_fips: 36015,
    county_fips_all: '36015|36101',
    county: 'Chemung',
    county_names_all: 'Chemung|Steuben',
    county_weights: '{"36015": 80.92, "36101": 19.08}',
    density: 30.7,
    imprecise: false,
    latitude: 42.03838,
    longitude: -76.91093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14871',
  },
  {
    city: 'Pine Valley',
    county_fips: 36015,
    county_fips_all: '36015',
    county: 'Chemung',
    county_names_all: 'Chemung',
    county_weights: '{"36015": 100}',
    density: 39.2,
    imprecise: false,
    latitude: 42.24141,
    longitude: -76.86473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14872',
  },
  {
    city: 'Prattsburgh',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 42.52181,
    longitude: -77.29814,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14873',
  },
  {
    city: 'Pulteney',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 51,
    imprecise: false,
    latitude: 42.53231,
    longitude: -77.17234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14874',
  },
  {
    city: 'Rexville',
    county_fips: 36101,
    county_fips_all: '36101|36003',
    county: 'Steuben',
    county_names_all: 'Steuben|Allegany',
    county_weights: '{"36101": 99.9, "36003": 0.1}',
    density: 5.5,
    imprecise: false,
    latitude: 42.06181,
    longitude: -77.68384,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14877',
  },
  {
    city: 'Rock Stream',
    county_fips: 36097,
    county_fips_all: '36097|36123',
    county: 'Schuyler',
    county_names_all: 'Schuyler|Yates',
    county_weights: '{"36097": 75.15, "36123": 24.85}',
    density: 14.5,
    imprecise: false,
    latitude: 42.44946,
    longitude: -76.94401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14878',
  },
  {
    city: 'Savona',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 19,
    imprecise: false,
    latitude: 42.31521,
    longitude: -77.19323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14879',
  },
  {
    city: 'Scio',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 42.17363,
    longitude: -77.97334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14880',
  },
  {
    city: 'Slaterville Springs',
    county_fips: 36109,
    county_fips_all: '36109',
    county: 'Tompkins',
    county_names_all: 'Tompkins',
    county_weights: '{"36109": 100}',
    density: 29.5,
    imprecise: false,
    latitude: 42.4017,
    longitude: -76.35795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14881',
  },
  {
    city: 'Lansing',
    county_fips: 36109,
    county_fips_all: '36109',
    county: 'Tompkins',
    county_names_all: 'Tompkins',
    county_weights: '{"36109": 100}',
    density: 49.8,
    imprecise: false,
    latitude: 42.5801,
    longitude: -76.56576,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14882',
  },
  {
    city: 'Spencer',
    county_fips: 36107,
    county_fips_all: '36107|36109',
    county: 'Tioga',
    county_names_all: 'Tioga|Tompkins',
    county_weights: '{"36107": 69.85, "36109": 30.15}',
    density: 22.3,
    imprecise: false,
    latitude: 42.24056,
    longitude: -76.482,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14883',
  },
  {
    city: 'Swain',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 42.47613,
    longitude: -77.88724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14884',
  },
  {
    city: 'Troupsburg',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 42.048,
    longitude: -77.57117,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14885',
  },
  {
    city: 'Trumansburg',
    county_fips: 36109,
    county_fips_all: '36109|36097|36099',
    county: 'Tompkins',
    county_names_all: 'Tompkins|Schuyler|Seneca',
    county_weights: '{"36109": 44.59, "36097": 42.38, "36099": 13.03}',
    density: 34.2,
    imprecise: false,
    latitude: 42.50408,
    longitude: -76.68836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14886',
  },
  {
    city: 'Van Etten',
    county_fips: 36015,
    county_fips_all: '36015|36097|36107',
    county: 'Chemung',
    county_names_all: 'Chemung|Schuyler|Tioga',
    county_weights: '{"36015": 87.3, "36097": 8.62, "36107": 4.08}',
    density: 12.3,
    imprecise: false,
    latitude: 42.21605,
    longitude: -76.58138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14889',
  },
  {
    city: 'Watkins Glen',
    county_fips: 36097,
    county_fips_all: '36097',
    county: 'Schuyler',
    county_names_all: 'Schuyler',
    county_weights: '{"36097": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 42.37823,
    longitude: -76.95035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14891',
  },
  {
    city: 'Waverly',
    county_fips: 36107,
    county_fips_all: '36107|36015',
    county: 'Tioga',
    county_names_all: 'Tioga|Chemung',
    county_weights: '{"36107": 67.2, "36015": 32.8}',
    density: 70.4,
    imprecise: false,
    latitude: 42.0478,
    longitude: -76.52804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14892',
  },
  {
    city: 'Wayne',
    county_fips: 36101,
    county_fips_all: '36101|36097',
    county: 'Steuben',
    county_names_all: 'Steuben|Schuyler',
    county_weights: '{"36101": 97.94, "36097": 2.06}',
    density: 184.1,
    imprecise: false,
    latitude: 42.46952,
    longitude: -77.11182,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14893',
  },
  {
    city: 'Wellsburg',
    county_fips: 36015,
    county_fips_all: '36015',
    county: 'Chemung',
    county_names_all: 'Chemung',
    county_weights: '{"36015": 100}',
    density: 39.4,
    imprecise: false,
    latitude: 42.02442,
    longitude: -76.77185,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14894',
  },
  {
    city: 'Wellsville',
    county_fips: 36003,
    county_fips_all: '36003',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"36003": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 42.07772,
    longitude: -77.93387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14895',
  },
  {
    city: 'Whitesville',
    county_fips: 36003,
    county_fips_all: '36003|36101',
    county: 'Allegany',
    county_names_all: 'Allegany|Steuben',
    county_weights: '{"36003": 92.01, "36101": 7.99}',
    density: 10.5,
    imprecise: false,
    latitude: 42.02949,
    longitude: -77.79076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14897',
  },
  {
    city: 'Woodhull',
    county_fips: 36101,
    county_fips_all: '36101',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"36101": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 42.05729,
    longitude: -77.43482,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14898',
  },
  {
    city: 'Elmira',
    county_fips: 36015,
    county_fips_all: '36015',
    county: 'Chemung',
    county_names_all: 'Chemung',
    county_weights: '{"36015": 100}',
    density: 162.5,
    imprecise: false,
    latitude: 42.07363,
    longitude: -76.74137,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14901',
  },
  {
    city: 'Elmira',
    county_fips: 36015,
    county_fips_all: '36015',
    county: 'Chemung',
    county_names_all: 'Chemung',
    county_weights: '{"36015": 100}',
    density: 126.2,
    imprecise: false,
    latitude: 42.12372,
    longitude: -76.87771,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14903',
  },
  {
    city: 'Elmira',
    county_fips: 36015,
    county_fips_all: '36015',
    county: 'Chemung',
    county_names_all: 'Chemung',
    county_weights: '{"36015": 100}',
    density: 889.7,
    imprecise: false,
    latitude: 42.07007,
    longitude: -76.80798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14904',
  },
  {
    city: 'Elmira',
    county_fips: 36015,
    county_fips_all: '36015',
    county: 'Chemung',
    county_names_all: 'Chemung',
    county_weights: '{"36015": 100}',
    density: 910.6,
    imprecise: false,
    latitude: 42.08692,
    longitude: -76.84284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14905',
  },
  {
    city: 'Aliquippa',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 204.6,
    imprecise: false,
    latitude: 40.59161,
    longitude: -80.32078,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15001',
  },
  {
    city: 'Ambridge',
    county_fips: 42007,
    county_fips_all: '42007|42003',
    county: 'Beaver',
    county_names_all: 'Beaver|Allegheny',
    county_weights: '{"42007": 95.08, "42003": 4.92}',
    density: 734.9,
    imprecise: false,
    latitude: 40.60153,
    longitude: -80.21415,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15003',
  },
  {
    city: 'Atlasburg',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 738.3,
    imprecise: false,
    latitude: 40.34216,
    longitude: -80.38289,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15004',
  },
  {
    city: 'Baden',
    county_fips: 42007,
    county_fips_all: '42007|42003',
    county: 'Beaver',
    county_names_all: 'Beaver|Allegheny',
    county_weights: '{"42007": 74.04, "42003": 25.96}',
    density: 229.2,
    imprecise: false,
    latitude: 40.64431,
    longitude: -80.17607,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15005',
  },
  {
    city: 'Bairdford',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 287.8,
    imprecise: false,
    latitude: 40.63351,
    longitude: -79.87678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15006',
  },
  {
    city: 'Bakerstown',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 246.7,
    imprecise: false,
    latitude: 40.65128,
    longitude: -79.93173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15007',
  },
  {
    city: 'Beaver',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 257.8,
    imprecise: false,
    latitude: 40.69933,
    longitude: -80.36464,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15009',
  },
  {
    city: 'Beaver Falls',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 215.9,
    imprecise: false,
    latitude: 40.76829,
    longitude: -80.35873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15010',
  },
  {
    city: 'Belle Vernon',
    county_fips: 42129,
    county_fips_all: '42129|42051|42125',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Fayette|Washington',
    county_weights: '{"42129": 84.62, "42051": 14.87, "42125": 0.51}',
    density: 174.4,
    imprecise: false,
    latitude: 40.15871,
    longitude: -79.81188,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15012',
  },
  {
    city: 'Brackenridge',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 2449.9,
    imprecise: false,
    latitude: 40.60859,
    longitude: -79.74149,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15014',
  },
  {
    city: 'Bradfordwoods',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 534.3,
    imprecise: false,
    latitude: 40.63622,
    longitude: -80.08164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15015',
  },
  {
    city: 'Bridgeville',
    county_fips: 42003,
    county_fips_all: '42003|42125',
    county: 'Allegheny',
    county_names_all: 'Allegheny|Washington',
    county_weights: '{"42003": 86.7, "42125": 13.3}',
    density: 562.7,
    imprecise: false,
    latitude: 40.34348,
    longitude: -80.12865,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15017',
  },
  {
    city: 'Buena Vista',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 335.8,
    imprecise: false,
    latitude: 40.26924,
    longitude: -79.79805,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15018',
  },
  {
    city: 'Bulger',
    county_fips: 42125,
    county_fips_all: '42125|42003',
    county: 'Washington',
    county_names_all: 'Washington|Allegheny',
    county_weights: '{"42125": 99.88, "42003": 0.12}',
    density: 17.6,
    imprecise: false,
    latitude: 40.40805,
    longitude: -80.33053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15019',
  },
  {
    city: 'Bunola',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 77.5,
    imprecise: false,
    latitude: 40.2283,
    longitude: -79.9479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15020',
  },
  {
    city: 'Burgettstown',
    county_fips: 42125,
    county_fips_all: '42125|42007',
    county: 'Washington',
    county_names_all: 'Washington|Beaver',
    county_weights: '{"42125": 99.49, "42007": 0.51}',
    density: 29.8,
    imprecise: false,
    latitude: 40.39373,
    longitude: -80.43583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15021',
  },
  {
    city: 'Charleroi',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 208.5,
    imprecise: false,
    latitude: 40.13329,
    longitude: -79.93661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15022',
  },
  {
    city: 'Cheswick',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 205.2,
    imprecise: false,
    latitude: 40.57649,
    longitude: -79.84649,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15024',
  },
  {
    city: 'Clairton',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 392.8,
    imprecise: false,
    latitude: 40.29887,
    longitude: -79.9213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15025',
  },
  {
    city: 'Clinton',
    county_fips: 42007,
    county_fips_all: '42007|42003|42125',
    county: 'Beaver',
    county_names_all: 'Beaver|Allegheny|Washington',
    county_weights: '{"42007": 72.01, "42003": 23.38, "42125": 4.61}',
    density: 46.6,
    imprecise: false,
    latitude: 40.51043,
    longitude: -80.35662,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15026',
  },
  {
    city: 'Conway',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 629.6,
    imprecise: false,
    latitude: 40.66706,
    longitude: -80.23988,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15027',
  },
  {
    city: 'Coulters',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 246.4,
    imprecise: false,
    latitude: 40.30194,
    longitude: -79.79891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15028',
  },
  {
    city: 'Creighton',
    county_fips: 42003,
    county_fips_all: '42003|42129',
    county: 'Allegheny',
    county_names_all: 'Allegheny|Westmoreland',
    county_weights: '{"42003": 99.83, "42129": 0.17}',
    density: 261.7,
    imprecise: false,
    latitude: 40.58492,
    longitude: -79.78074,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15030',
  },
  {
    city: 'Cuddy',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 468.4,
    imprecise: false,
    latitude: 40.34802,
    longitude: -80.16235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15031',
  },
  {
    city: 'Donora',
    county_fips: 42125,
    county_fips_all: '42125|42129',
    county: 'Washington',
    county_names_all: 'Washington|Westmoreland',
    county_weights: '{"42125": 99.87, "42129": 0.13}',
    density: 742.8,
    imprecise: false,
    latitude: 40.18011,
    longitude: -79.86501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15033',
  },
  {
    city: 'Dravosburg',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 656.4,
    imprecise: false,
    latitude: 40.35083,
    longitude: -79.89067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15034',
  },
  {
    city: 'East McKeesport',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1835.1,
    imprecise: false,
    latitude: 40.38488,
    longitude: -79.80726,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15035',
  },
  {
    city: 'Elizabeth',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 154.7,
    imprecise: false,
    latitude: 40.25649,
    longitude: -79.85017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15037',
  },
  {
    city: 'Elrama',
    county_fips: 42125,
    county_fips_all: '42125|42003',
    county: 'Washington',
    county_names_all: 'Washington|Allegheny',
    county_weights: '{"42125": 99.27, "42003": 0.73}',
    density: 366.9,
    imprecise: false,
    latitude: 40.2499,
    longitude: -79.92379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15038',
  },
  {
    city: 'Freedom',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 176.7,
    imprecise: false,
    latitude: 40.68786,
    longitude: -80.20411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15042',
  },
  {
    city: 'Georgetown',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 27.4,
    imprecise: false,
    latitude: 40.55585,
    longitude: -80.48994,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15043',
  },
  {
    city: 'Gibsonia',
    county_fips: 42003,
    county_fips_all: '42003|42019',
    county: 'Allegheny',
    county_names_all: 'Allegheny|Butler',
    county_weights: '{"42003": 96.7, "42019": 3.3}',
    density: 270.6,
    imprecise: false,
    latitude: 40.64009,
    longitude: -79.9492,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15044',
  },
  {
    city: 'Glassport',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1066.3,
    imprecise: false,
    latitude: 40.32613,
    longitude: -79.88614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15045',
  },
  {
    city: 'Crescent',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 395.2,
    imprecise: false,
    latitude: 40.55618,
    longitude: -80.22868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15046',
  },
  {
    city: 'Greenock',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 449.6,
    imprecise: false,
    latitude: 40.3123,
    longitude: -79.79513,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15047',
  },
  {
    city: 'Harwick',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 670.7,
    imprecise: false,
    latitude: 40.55545,
    longitude: -79.80366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15049',
  },
  {
    city: 'Hookstown',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 35.3,
    imprecise: false,
    latitude: 40.5617,
    longitude: -80.44038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15050',
  },
  {
    city: 'Indianola',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 267,
    imprecise: false,
    latitude: 40.56812,
    longitude: -79.86076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15051',
  },
  {
    city: 'Industry',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 58.2,
    imprecise: false,
    latitude: 40.6669,
    longitude: -80.43318,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15052',
  },
  {
    city: 'Joffre',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 433.1,
    imprecise: false,
    latitude: 40.38056,
    longitude: -80.35975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15053',
  },
  {
    city: 'Langeloth',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 164.4,
    imprecise: false,
    latitude: 40.36353,
    longitude: -80.4008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15054',
  },
  {
    city: 'Lawrence',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 812.7,
    imprecise: false,
    latitude: 40.30642,
    longitude: -80.12296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15055',
  },
  {
    city: 'Leetsdale',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 424.1,
    imprecise: false,
    latitude: 40.56512,
    longitude: -80.21407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15056',
  },
  {
    city: 'McDonald',
    county_fips: 42125,
    county_fips_all: '42125|42003',
    county: 'Washington',
    county_names_all: 'Washington|Allegheny',
    county_weights: '{"42125": 65.43, "42003": 34.57}',
    density: 118.4,
    imprecise: false,
    latitude: 40.35571,
    longitude: -80.24713,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15057',
  },
  {
    city: 'Midland',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 107.3,
    imprecise: false,
    latitude: 40.68056,
    longitude: -80.49182,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15059',
  },
  {
    city: 'Midway',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 411,
    imprecise: false,
    latitude: 40.37695,
    longitude: -80.29113,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15060',
  },
  {
    city: 'Monaca',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 277.2,
    imprecise: false,
    latitude: 40.66013,
    longitude: -80.31082,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15061',
  },
  {
    city: 'Monessen',
    county_fips: 42129,
    county_fips_all: '42129|42125',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Washington',
    county_weights: '{"42129": 99.88, "42125": 0.12}',
    density: 904.8,
    imprecise: false,
    latitude: 40.15184,
    longitude: -79.88277,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15062',
  },
  {
    city: 'Monongahela',
    county_fips: 42125,
    county_fips_all: '42125|42003',
    county: 'Washington',
    county_names_all: 'Washington|Allegheny',
    county_weights: '{"42125": 60.86, "42003": 39.14}',
    density: 148.1,
    imprecise: false,
    latitude: 40.19487,
    longitude: -79.92228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15063',
  },
  {
    city: 'Morgan',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 216.1,
    imprecise: false,
    latitude: 40.35538,
    longitude: -80.14849,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15064',
  },
  {
    city: 'Natrona Heights',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 337.6,
    imprecise: false,
    latitude: 40.64192,
    longitude: -79.72766,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15065',
  },
  {
    city: 'New Brighton',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 215,
    imprecise: false,
    latitude: 40.75119,
    longitude: -80.25269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15066',
  },
  {
    city: 'New Eagle',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 477.6,
    imprecise: false,
    latitude: 40.20823,
    longitude: -79.96106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15067',
  },
  {
    city: 'New Kensington',
    county_fips: 42129,
    county_fips_all: '42129|42003',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Allegheny',
    county_weights: '{"42129": 77.83, "42003": 22.17}',
    density: 307.6,
    imprecise: false,
    latitude: 40.56241,
    longitude: -79.7124,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15068',
  },
  {
    city: 'Oakdale',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 266.4,
    imprecise: false,
    latitude: 40.41486,
    longitude: -80.18981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15071',
  },
  {
    city: 'Pricedale',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 275,
    imprecise: false,
    latitude: 40.13922,
    longitude: -79.85605,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15072',
  },
  {
    city: 'Rochester',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 222,
    imprecise: false,
    latitude: 40.72837,
    longitude: -80.21937,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15074',
  },
  {
    city: 'Rural Ridge',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 309.3,
    imprecise: false,
    latitude: 40.58665,
    longitude: -79.82693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15075',
  },
  {
    city: 'Russellton',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 312.1,
    imprecise: false,
    latitude: 40.60949,
    longitude: -79.8374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15076',
  },
  {
    city: 'Shippingport',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 71,
    imprecise: false,
    latitude: 40.62517,
    longitude: -80.4173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15077',
  },
  {
    city: 'Slovan',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 466.9,
    imprecise: false,
    latitude: 40.35949,
    longitude: -80.38501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15078',
  },
  {
    city: 'South Heights',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 503.3,
    imprecise: false,
    latitude: 40.57471,
    longitude: -80.23614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15081',
  },
  {
    city: 'Sturgeon',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 405.9,
    imprecise: false,
    latitude: 40.38031,
    longitude: -80.21061,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15082',
  },
  {
    city: 'Sutersville',
    county_fips: 42129,
    county_fips_all: '42129|42003',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Allegheny',
    county_weights: '{"42129": 86.86, "42003": 13.14}',
    density: 92.4,
    imprecise: false,
    latitude: 40.24802,
    longitude: -79.79041,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15083',
  },
  {
    city: 'Tarentum',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 130,
    imprecise: false,
    latitude: 40.6282,
    longitude: -79.8028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15084',
  },
  {
    city: 'Trafford',
    county_fips: 42129,
    county_fips_all: '42129|42003',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Allegheny',
    county_weights: '{"42129": 97.59, "42003": 2.41}',
    density: 336.9,
    imprecise: false,
    latitude: 40.38497,
    longitude: -79.72539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15085',
  },
  {
    city: 'Warrendale',
    county_fips: 42003,
    county_fips_all: '42003|42019',
    county: 'Allegheny',
    county_names_all: 'Allegheny|Butler',
    county_weights: '{"42003": 75.35, "42019": 24.65}',
    density: 163.3,
    imprecise: false,
    latitude: 40.664,
    longitude: -80.09593,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15086',
  },
  {
    city: 'Webster',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 26.1,
    imprecise: false,
    latitude: 40.19504,
    longitude: -79.84948,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 85,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15087',
  },
  {
    city: 'West Elizabeth',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 805.8,
    imprecise: false,
    latitude: 40.27159,
    longitude: -79.89607,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15088',
  },
  {
    city: 'West Newton',
    county_fips: 42129,
    county_fips_all: '42129|42003',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Allegheny',
    county_weights: '{"42129": 98.57, "42003": 1.43}',
    density: 146,
    imprecise: false,
    latitude: 40.22063,
    longitude: -79.73719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15089',
  },
  {
    city: 'Wexford',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 454.9,
    imprecise: false,
    latitude: 40.62587,
    longitude: -80.06766,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15090',
  },
  {
    city: 'Allison Park',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 468.2,
    imprecise: false,
    latitude: 40.58139,
    longitude: -79.95531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15101',
  },
  {
    city: 'Bethel Park',
    county_fips: 42003,
    county_fips_all: '42003|42125',
    county: 'Allegheny',
    county_names_all: 'Allegheny|Washington',
    county_weights: '{"42003": 99.12, "42125": 0.88}',
    density: 1102.8,
    imprecise: false,
    latitude: 40.32125,
    longitude: -80.03707,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15102',
  },
  {
    city: 'Braddock',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1257.3,
    imprecise: false,
    latitude: 40.40379,
    longitude: -79.86249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15104',
  },
  {
    city: 'Carnegie',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 745.7,
    imprecise: false,
    latitude: 40.40882,
    longitude: -80.10863,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15106',
  },
  {
    city: 'Coraopolis',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 418.1,
    imprecise: false,
    latitude: 40.50006,
    longitude: -80.20031,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15108',
  },
  {
    city: 'Duquesne',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1094.7,
    imprecise: false,
    latitude: 40.37321,
    longitude: -79.85024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15110',
  },
  {
    city: 'East Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1683,
    imprecise: false,
    latitude: 40.40453,
    longitude: -79.83734,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15112',
  },
  {
    city: 'Glenshaw',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 724.3,
    imprecise: false,
    latitude: 40.5384,
    longitude: -79.95211,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15116',
  },
  {
    city: 'Homestead',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1484.8,
    imprecise: false,
    latitude: 40.39597,
    longitude: -79.90689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15120',
  },
  {
    city: 'West Mifflin',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 561.9,
    imprecise: false,
    latitude: 40.35976,
    longitude: -79.90628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15122',
  },
  {
    city: 'Imperial',
    county_fips: 42003,
    county_fips_all: '42003|42125',
    county: 'Allegheny',
    county_names_all: 'Allegheny|Washington',
    county_weights: '{"42003": 99.27, "42125": 0.73}',
    density: 142.3,
    imprecise: false,
    latitude: 40.46019,
    longitude: -80.28727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15126',
  },
  {
    city: 'South Park',
    county_fips: 42003,
    county_fips_all: '42003|42125',
    county: 'Allegheny',
    county_names_all: 'Allegheny|Washington',
    county_weights: '{"42003": 98.09, "42125": 1.91}',
    density: 537.9,
    imprecise: false,
    latitude: 40.29348,
    longitude: -79.99515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15129',
  },
  {
    city: 'Mckeesport',
    county_fips: 42003,
    county_fips_all: '42003|42129',
    county: 'Allegheny',
    county_names_all: 'Allegheny|Westmoreland',
    county_weights: '{"42003": 94.83, "42129": 5.17}',
    density: 479.9,
    imprecise: false,
    latitude: 40.33477,
    longitude: -79.80132,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15131',
  },
  {
    city: 'Mckeesport',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1295.6,
    imprecise: false,
    latitude: 40.33982,
    longitude: -79.84299,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15132',
  },
  {
    city: 'Mckeesport',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 700.4,
    imprecise: false,
    latitude: 40.3257,
    longitude: -79.86127,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15133',
  },
  {
    city: 'Mckeesport',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 371.9,
    imprecise: false,
    latitude: 40.29959,
    longitude: -79.81153,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15135',
  },
  {
    city: 'McKees Rocks',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 812.7,
    imprecise: false,
    latitude: 40.46872,
    longitude: -80.10233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15136',
  },
  {
    city: 'North Versailles',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 493,
    imprecise: false,
    latitude: 40.37762,
    longitude: -79.80902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15137',
  },
  {
    city: 'Oakmont',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1346,
    imprecise: false,
    latitude: 40.52192,
    longitude: -79.83479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15139',
  },
  {
    city: 'Pitcairn',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1906.9,
    imprecise: false,
    latitude: 40.4073,
    longitude: -79.7783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15140',
  },
  {
    city: 'Presto',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 259.4,
    imprecise: false,
    latitude: 40.38474,
    longitude: -80.12231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15142',
  },
  {
    city: 'Sewickley',
    county_fips: 42003,
    county_fips_all: '42003|42007',
    county: 'Allegheny',
    county_names_all: 'Allegheny|Beaver',
    county_weights: '{"42003": 90.26, "42007": 9.74}',
    density: 228.6,
    imprecise: false,
    latitude: 40.57298,
    longitude: -80.14725,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15143',
  },
  {
    city: 'Springdale',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 700.5,
    imprecise: false,
    latitude: 40.54759,
    longitude: -79.78317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15144',
  },
  {
    city: 'Turtle Creek',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1348.6,
    imprecise: false,
    latitude: 40.41451,
    longitude: -79.82352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15145',
  },
  {
    city: 'Monroeville',
    county_fips: 42003,
    county_fips_all: '42003|42129',
    county: 'Allegheny',
    county_names_all: 'Allegheny|Westmoreland',
    county_weights: '{"42003": 99.66, "42129": 0.34}',
    density: 557.5,
    imprecise: false,
    latitude: 40.4264,
    longitude: -79.76005,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15146',
  },
  {
    city: 'Verona',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 609.3,
    imprecise: false,
    latitude: 40.49704,
    longitude: -79.82858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15147',
  },
  {
    city: 'Wilmerding',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 814.6,
    imprecise: false,
    latitude: 40.39351,
    longitude: -79.79525,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15148',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 2674,
    imprecise: false,
    latitude: 40.47565,
    longitude: -79.95389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15201',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1686.7,
    imprecise: false,
    latitude: 40.50566,
    longitude: -80.06902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15202',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 2698.5,
    imprecise: false,
    latitude: 40.4257,
    longitude: -79.97491,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15203',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1738.6,
    imprecise: false,
    latitude: 40.45597,
    longitude: -80.06051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15204',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 795.2,
    imprecise: false,
    latitude: 40.4381,
    longitude: -80.10552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15205',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 2354.9,
    imprecise: false,
    latitude: 40.47244,
    longitude: -79.91324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15206',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 932.2,
    imprecise: false,
    latitude: 40.39813,
    longitude: -79.9334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15207',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 2601.4,
    imprecise: false,
    latitude: 40.45387,
    longitude: -79.89883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15208',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 987.8,
    imprecise: false,
    latitude: 40.50007,
    longitude: -79.97463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15209',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 2069.8,
    imprecise: false,
    latitude: 40.40679,
    longitude: -79.98411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15210',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 2614.9,
    imprecise: false,
    latitude: 40.4302,
    longitude: -80.01533,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15211',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1841.6,
    imprecise: false,
    latitude: 40.47106,
    longitude: -80.00844,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15212',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 4820.8,
    imprecise: false,
    latitude: 40.44293,
    longitude: -79.95345,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15213',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1178.3,
    imprecise: false,
    latitude: 40.48541,
    longitude: -80.01455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15214',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 742.9,
    imprecise: false,
    latitude: 40.50457,
    longitude: -79.91338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15215',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 2412.2,
    imprecise: false,
    latitude: 40.40268,
    longitude: -80.0348,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15216',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 2574.6,
    imprecise: false,
    latitude: 40.43083,
    longitude: -79.91999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15217',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 2253.8,
    imprecise: false,
    latitude: 40.42366,
    longitude: -79.88924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15218',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1995.9,
    imprecise: false,
    latitude: 40.44304,
    longitude: -79.98443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15219',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1440.7,
    imprecise: false,
    latitude: 40.41875,
    longitude: -80.04894,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15220',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1826.2,
    imprecise: false,
    latitude: 40.43457,
    longitude: -79.86631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15221',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 2495.5,
    imprecise: false,
    latitude: 40.44998,
    longitude: -79.9912,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15222',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1296.5,
    imprecise: false,
    latitude: 40.50431,
    longitude: -79.95199,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15223',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 2698.3,
    imprecise: false,
    latitude: 40.46737,
    longitude: -79.94623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15224',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 273.6,
    imprecise: false,
    latitude: 40.50636,
    longitude: -80.1116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15225',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 2167.9,
    imprecise: false,
    latitude: 40.39527,
    longitude: -80.01374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15226',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1797.4,
    imprecise: false,
    latitude: 40.375,
    longitude: -79.97077,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15227',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 2210.4,
    imprecise: false,
    latitude: 40.37075,
    longitude: -80.04395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15228',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1449.5,
    imprecise: false,
    latitude: 40.51995,
    longitude: -80.03866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15229',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 5355.9,
    imprecise: false,
    latitude: 40.45246,
    longitude: -79.93193,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15232',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 767.2,
    imprecise: false,
    latitude: 40.45985,
    longitude: -80.03387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15233',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1738.1,
    imprecise: false,
    latitude: 40.36808,
    longitude: -80.01782,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15234',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 884.9,
    imprecise: false,
    latitude: 40.45968,
    longitude: -79.82194,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15235',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1128.8,
    imprecise: false,
    latitude: 40.34756,
    longitude: -79.97652,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15236',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 699.8,
    imprecise: false,
    latitude: 40.54834,
    longitude: -80.04682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15237',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 314.8,
    imprecise: false,
    latitude: 40.53405,
    longitude: -79.88115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15238',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 505.8,
    imprecise: false,
    latitude: 40.48437,
    longitude: -79.73753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15239',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003|42125',
    county: 'Allegheny',
    county_names_all: 'Allegheny|Washington',
    county_weights: '{"42003": 98.99, "42125": 1.01}',
    density: 842.2,
    imprecise: false,
    latitude: 40.33293,
    longitude: -80.08291,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15241',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 1723.3,
    imprecise: false,
    latitude: 40.37474,
    longitude: -80.07305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15243',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 95.9,
    imprecise: false,
    latitude: 40.45246,
    longitude: -80.18405,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 86,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15275',
  },
  {
    city: 'Washington',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 159.4,
    imprecise: false,
    latitude: 40.16411,
    longitude: -80.25304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15301',
  },
  {
    city: 'Aleppo',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 39.79255,
    longitude: -80.48108,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15310',
  },
  {
    city: 'Amity',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 40.04608,
    longitude: -80.18592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15311',
  },
  {
    city: 'Avella',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 40.25404,
    longitude: -80.43757,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15312',
  },
  {
    city: 'Beallsville',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 83.7,
    imprecise: false,
    latitude: 40.06318,
    longitude: -80.02937,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15313',
  },
  {
    city: 'Bentleyville',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 80.4,
    imprecise: false,
    latitude: 40.14555,
    longitude: -80.01775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15314',
  },
  {
    city: 'Bobtown',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 463.5,
    imprecise: false,
    latitude: 39.75741,
    longitude: -79.98319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15315',
  },
  {
    city: 'Brave',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 39.76514,
    longitude: -80.26185,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15316',
  },
  {
    city: 'Canonsburg',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 376,
    imprecise: false,
    latitude: 40.27105,
    longitude: -80.16535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15317',
  },
  {
    city: 'Carmichaels',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 47.3,
    imprecise: false,
    latitude: 39.87386,
    longitude: -79.99768,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15320',
  },
  {
    city: 'Cecil',
    county_fips: 42125,
    county_fips_all: '42125|42003',
    county: 'Washington',
    county_names_all: 'Washington|Allegheny',
    county_weights: '{"42125": 86.12, "42003": 13.88}',
    density: 409.8,
    imprecise: false,
    latitude: 40.32167,
    longitude: -80.18716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15321',
  },
  {
    city: 'Clarksville',
    county_fips: 42059,
    county_fips_all: '42059|42125',
    county: 'Greene',
    county_names_all: 'Greene|Washington',
    county_weights: '{"42059": 80.47, "42125": 19.53}',
    density: 48.7,
    imprecise: false,
    latitude: 39.97655,
    longitude: -80.0488,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15322',
  },
  {
    city: 'Claysville',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 20.8,
    imprecise: false,
    latitude: 40.10845,
    longitude: -80.40926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15323',
  },
  {
    city: 'Cokeburg',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 895,
    imprecise: false,
    latitude: 40.10074,
    longitude: -80.0654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15324',
  },
  {
    city: 'Crucible',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 400.3,
    imprecise: false,
    latitude: 39.94893,
    longitude: -79.96331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15325',
  },
  {
    city: 'Dilliner',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 21,
    imprecise: false,
    latitude: 39.75088,
    longitude: -79.96293,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15327',
  },
  {
    city: 'Prosperity',
    county_fips: 42125,
    county_fips_all: '42125|42059',
    county: 'Washington',
    county_names_all: 'Washington|Greene',
    county_weights: '{"42125": 71.94, "42059": 28.06}',
    density: 12.5,
    imprecise: false,
    latitude: 40.02813,
    longitude: -80.27205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15329',
  },
  {
    city: 'Eighty Four',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 52.6,
    imprecise: false,
    latitude: 40.18227,
    longitude: -80.09492,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15330',
  },
  {
    city: 'Ellsworth',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 443.9,
    imprecise: false,
    latitude: 40.10754,
    longitude: -80.02214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15331',
  },
  {
    city: 'Finleyville',
    county_fips: 42125,
    county_fips_all: '42125|42003',
    county: 'Washington',
    county_names_all: 'Washington|Allegheny',
    county_weights: '{"42125": 87.03, "42003": 12.97}',
    density: 111.1,
    imprecise: false,
    latitude: 40.24226,
    longitude: -79.99134,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15332',
  },
  {
    city: 'Fredericktown',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 50.7,
    imprecise: false,
    latitude: 40.02693,
    longitude: -80.01429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15333',
  },
  {
    city: 'Garards Fort',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 47,
    imprecise: false,
    latitude: 39.81292,
    longitude: -79.9673,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15334',
  },
  {
    city: 'Graysville',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 39.9505,
    longitude: -80.37521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15337',
  },
  {
    city: 'Greensboro',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 33.9,
    imprecise: false,
    latitude: 39.81654,
    longitude: -79.96206,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15338',
  },
  {
    city: 'Hickory',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 39.1,
    imprecise: false,
    latitude: 40.28654,
    longitude: -80.32258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15340',
  },
  {
    city: 'Holbrook',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 39.82381,
    longitude: -80.34728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15341',
  },
  {
    city: 'Houston',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 613.9,
    imprecise: false,
    latitude: 40.24533,
    longitude: -80.22061,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15342',
  },
  {
    city: 'Jefferson',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 39.4,
    imprecise: false,
    latitude: 39.92289,
    longitude: -80.05068,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15344',
  },
  {
    city: 'Marianna',
    county_fips: 42125,
    county_fips_all: '42125|42059',
    county: 'Washington',
    county_names_all: 'Washington|Greene',
    county_weights: '{"42125": 96.32, "42059": 3.68}',
    density: 28.2,
    imprecise: false,
    latitude: 40.02173,
    longitude: -80.10743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15345',
  },
  {
    city: 'Mather',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 215.4,
    imprecise: false,
    latitude: 39.93545,
    longitude: -80.07536,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15346',
  },
  {
    city: 'Meadow Lands',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 283,
    imprecise: false,
    latitude: 40.21807,
    longitude: -80.22469,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15347',
  },
  {
    city: 'Millsboro',
    county_fips: 42125,
    county_fips_all: '42125|42051',
    county: 'Washington',
    county_names_all: 'Washington|Fayette',
    county_weights: '{"42125": 99.64, "42051": 0.36}',
    density: 111.9,
    imprecise: false,
    latitude: 39.98748,
    longitude: -79.99624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15348',
  },
  {
    city: 'Mount Morris',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 39.75885,
    longitude: -80.07795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15349',
  },
  {
    city: 'Muse',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 1775.9,
    imprecise: false,
    latitude: 40.29377,
    longitude: -80.20056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15350',
  },
  {
    city: 'Nemacolin',
    county_fips: 42059,
    county_fips_all: '42059|42051',
    county: 'Greene',
    county_names_all: 'Greene|Fayette',
    county_weights: '{"42059": 99.86, "42051": 0.14}',
    density: 311.9,
    imprecise: false,
    latitude: 39.87827,
    longitude: -79.93068,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15351',
  },
  {
    city: 'New Freeport',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 39.75418,
    longitude: -80.40253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15352',
  },
  {
    city: 'Nineveh',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 457.1,
    imprecise: false,
    latitude: 39.96223,
    longitude: -80.31107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 67,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15353',
  },
  {
    city: 'Rices Landing',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 76.8,
    imprecise: false,
    latitude: 39.93721,
    longitude: -79.98153,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15357',
  },
  {
    city: 'Richeyville',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 503.6,
    imprecise: false,
    latitude: 40.055,
    longitude: -80.00309,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15358',
  },
  {
    city: 'Rogersville',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 861.9,
    imprecise: false,
    latitude: 39.87667,
    longitude: -80.27555,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15359',
  },
  {
    city: 'Scenery Hill',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 40.08846,
    longitude: -80.08144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15360',
  },
  {
    city: 'Southview',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 110.7,
    imprecise: false,
    latitude: 40.33277,
    longitude: -80.2623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15361',
  },
  {
    city: 'Spraggs',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 39.75821,
    longitude: -80.21301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15362',
  },
  {
    city: 'Strabane',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 1027.3,
    imprecise: false,
    latitude: 40.25159,
    longitude: -80.19761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15363',
  },
  {
    city: 'Sycamore',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 39.94557,
    longitude: -80.2849,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15364',
  },
  {
    city: 'Taylorstown',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 71.3,
    imprecise: false,
    latitude: 40.15564,
    longitude: -80.38548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15365',
  },
  {
    city: 'Van Voorhis',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 582.6,
    imprecise: false,
    latitude: 40.1598,
    longitude: -79.974,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15366',
  },
  {
    city: 'Venetia',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 374.2,
    imprecise: false,
    latitude: 40.26321,
    longitude: -80.05474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15367',
  },
  {
    city: 'Vestaburg',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 715.4,
    imprecise: false,
    latitude: 40.0145,
    longitude: -79.9892,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15368',
  },
  {
    city: 'Waynesburg',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 39.8734,
    longitude: -80.17991,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15370',
  },
  {
    city: 'West Alexander',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 40.10493,
    longitude: -80.48744,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15376',
  },
  {
    city: 'West Finley',
    county_fips: 42125,
    county_fips_all: '42125|42059',
    county: 'Washington',
    county_names_all: 'Washington|Greene',
    county_weights: '{"42125": 69.27, "42059": 30.73}',
    density: 5.7,
    imprecise: false,
    latitude: 39.97973,
    longitude: -80.45083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15377',
  },
  {
    city: 'Westland',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.27771,
    longitude: -80.27433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15378',
  },
  {
    city: 'West Middletown',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 61.8,
    imprecise: false,
    latitude: 40.2432,
    longitude: -80.42519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15379',
  },
  {
    city: 'Wind Ridge',
    county_fips: 42059,
    county_fips_all: '42059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"42059": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 39.8725,
    longitude: -80.4692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15380',
  },
  {
    city: 'Uniontown',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 208.7,
    imprecise: false,
    latitude: 39.89914,
    longitude: -79.74965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15401',
  },
  {
    city: 'Adah',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 30.4,
    imprecise: false,
    latitude: 39.91246,
    longitude: -79.90352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15410',
  },
  {
    city: 'Addison',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 39.74724,
    longitude: -79.34344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15411',
  },
  {
    city: 'Allenport',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 51.6,
    imprecise: false,
    latitude: 40.09496,
    longitude: -79.85218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15412',
  },
  {
    city: 'Allison',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 361.5,
    imprecise: false,
    latitude: 39.98493,
    longitude: -79.87141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15413',
  },
  {
    city: 'Brownfield',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 208,
    imprecise: false,
    latitude: 39.85903,
    longitude: -79.72286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15416',
  },
  {
    city: 'Brownsville',
    county_fips: 42125,
    county_fips_all: '42125|42051',
    county: 'Washington',
    county_names_all: 'Washington|Fayette',
    county_weights: '{"42125": 50.57, "42051": 49.43}',
    density: 139.5,
    imprecise: false,
    latitude: 40.01466,
    longitude: -79.91464,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15417',
  },
  {
    city: 'California',
    county_fips: 42125,
    county_fips_all: '42125|42051',
    county: 'Washington',
    county_names_all: 'Washington|Fayette',
    county_weights: '{"42125": 99.42, "42051": 0.58}',
    density: 1026.1,
    imprecise: false,
    latitude: 40.05861,
    longitude: -79.89408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15419',
  },
  {
    city: 'Cardale',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 103.7,
    imprecise: false,
    latitude: 39.95981,
    longitude: -79.86537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15420',
  },
  {
    city: 'Chalk Hill',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 298.2,
    imprecise: false,
    latitude: 39.84527,
    longitude: -79.59743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15421',
  },
  {
    city: 'Chestnut Ridge',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 357.7,
    imprecise: false,
    latitude: 39.9781,
    longitude: -79.80927,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15422',
  },
  {
    city: 'Coal Center',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 41.6,
    imprecise: false,
    latitude: 40.08804,
    longitude: -79.92538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15423',
  },
  {
    city: 'Confluence',
    county_fips: 42111,
    county_fips_all: '42111|42051',
    county: 'Somerset',
    county_names_all: 'Somerset|Fayette',
    county_weights: '{"42111": 73.92, "42051": 26.08}',
    density: 10.9,
    imprecise: false,
    latitude: 39.829,
    longitude: -79.35377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15424',
  },
  {
    city: 'Connellsville',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 117.3,
    imprecise: false,
    latitude: 40.02702,
    longitude: -79.55411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15425',
  },
  {
    city: 'Daisytown',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 33.1,
    imprecise: false,
    latitude: 40.06742,
    longitude: -79.97065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15427',
  },
  {
    city: 'Dawson',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 33.2,
    imprecise: false,
    latitude: 40.0811,
    longitude: -79.68184,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15428',
  },
  {
    city: 'Denbo',
    county_fips: 42125,
    county_fips_all: '42125|42051',
    county: 'Washington',
    county_names_all: 'Washington|Fayette',
    county_weights: '{"42125": 99.73, "42051": 0.27}',
    density: 162.4,
    imprecise: false,
    latitude: 40.00678,
    longitude: -79.94021,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15429',
  },
  {
    city: 'Dickerson Run',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 244.9,
    imprecise: false,
    latitude: 40.04025,
    longitude: -79.65534,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15430',
  },
  {
    city: 'Dunbar',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 31.1,
    imprecise: false,
    latitude: 39.94066,
    longitude: -79.58075,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15431',
  },
  {
    city: 'Dunlevy',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 236.6,
    imprecise: false,
    latitude: 40.11301,
    longitude: -79.85913,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15432',
  },
  {
    city: 'East Millsboro',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 39.97413,
    longitude: -79.95799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15433',
  },
  {
    city: 'Elco',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 618.3,
    imprecise: false,
    latitude: 40.08013,
    longitude: -79.88037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15434',
  },
  {
    city: 'Fairbank',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 173.3,
    imprecise: false,
    latitude: 39.94314,
    longitude: -79.84731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 85,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15435',
  },
  {
    city: 'Fairchance',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 100.7,
    imprecise: false,
    latitude: 39.81844,
    longitude: -79.72543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15436',
  },
  {
    city: 'Farmington',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 39.79202,
    longitude: -79.59846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15437',
  },
  {
    city: 'Fayette City',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 66,
    imprecise: false,
    latitude: 40.07485,
    longitude: -79.84431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15438',
  },
  {
    city: 'Gibbon Glade',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 6,
    imprecise: false,
    latitude: 39.73775,
    longitude: -79.64347,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15440',
  },
  {
    city: 'Grindstone',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 61.6,
    imprecise: false,
    latitude: 40.01542,
    longitude: -79.84019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15442',
  },
  {
    city: 'Hibbs',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 39.91924,
    longitude: -79.88448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15443',
  },
  {
    city: 'Hiller',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 883.9,
    imprecise: false,
    latitude: 40.0134,
    longitude: -79.90836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15444',
  },
  {
    city: 'Hopwood',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 42,
    imprecise: false,
    latitude: 39.87343,
    longitude: -79.65766,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15445',
  },
  {
    city: 'Indian Head',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 40.03172,
    longitude: -79.39433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15446',
  },
  {
    city: 'Isabella',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 39.9445,
    longitude: -79.93257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15447',
  },
  {
    city: 'Jacobs Creek',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 60.7,
    imprecise: false,
    latitude: 40.13572,
    longitude: -79.73394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15448',
  },
  {
    city: 'Keisterville',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 89.9,
    imprecise: false,
    latitude: 39.97267,
    longitude: -79.78055,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15449',
  },
  {
    city: 'La Belle',
    county_fips: 42051,
    county_fips_all: '42051|42125',
    county: 'Fayette',
    county_names_all: 'Fayette|Washington',
    county_weights: '{"42051": 99.54, "42125": 0.46}',
    density: 793.5,
    imprecise: false,
    latitude: 40.00289,
    longitude: -79.97616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15450',
  },
  {
    city: 'Lake Lynn',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 39.74018,
    longitude: -79.84005,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15451',
  },
  {
    city: 'Leckrone',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 98.4,
    imprecise: false,
    latitude: 39.86386,
    longitude: -79.87286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15454',
  },
  {
    city: 'Leisenring',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 99.9,
    imprecise: false,
    latitude: 40.00614,
    longitude: -79.64609,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15455',
  },
  {
    city: 'Lemont Furnace',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 126,
    imprecise: false,
    latitude: 39.92919,
    longitude: -79.6532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15456',
  },
  {
    city: 'McClellandtown',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 68.8,
    imprecise: false,
    latitude: 39.88715,
    longitude: -79.85099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15458',
  },
  {
    city: 'Markleysburg',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 22,
    imprecise: false,
    latitude: 39.76483,
    longitude: -79.4648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15459',
  },
  {
    city: 'Martin',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 96.1,
    imprecise: false,
    latitude: 39.80712,
    longitude: -79.90756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15460',
  },
  {
    city: 'Masontown',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 134.4,
    imprecise: false,
    latitude: 39.83978,
    longitude: -79.89843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15461',
  },
  {
    city: 'Melcroft',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 23,
    imprecise: false,
    latitude: 40.06136,
    longitude: -79.38113,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15462',
  },
  {
    city: 'Merrittstown',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 34.1,
    imprecise: false,
    latitude: 39.9629,
    longitude: -79.89916,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15463',
  },
  {
    city: 'Mill Run',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 39.92463,
    longitude: -79.43695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15464',
  },
  {
    city: 'Mount Braddock',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 176.4,
    imprecise: false,
    latitude: 39.93883,
    longitude: -79.64126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15465',
  },
  {
    city: 'Newell',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 601.9,
    imprecise: false,
    latitude: 40.07562,
    longitude: -79.89199,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15466',
  },
  {
    city: 'New Geneva',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 32.2,
    imprecise: false,
    latitude: 39.78931,
    longitude: -79.90526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15467',
  },
  {
    city: 'New Salem',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 71.5,
    imprecise: false,
    latitude: 39.94872,
    longitude: -79.83761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15468',
  },
  {
    city: 'Normalville',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 27.8,
    imprecise: false,
    latitude: 40.01366,
    longitude: -79.41861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15469',
  },
  {
    city: 'Ohiopyle',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 8,
    imprecise: false,
    latitude: 39.85321,
    longitude: -79.53078,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15470',
  },
  {
    city: 'Oliver',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 266.8,
    imprecise: false,
    latitude: 39.91933,
    longitude: -79.71679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15472',
  },
  {
    city: 'Perryopolis',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 60.4,
    imprecise: false,
    latitude: 40.07256,
    longitude: -79.77352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15473',
  },
  {
    city: 'Point Marion',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 118.5,
    imprecise: false,
    latitude: 39.75201,
    longitude: -79.90145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15474',
  },
  {
    city: 'Republic',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 310.7,
    imprecise: false,
    latitude: 39.95812,
    longitude: -79.88057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15475',
  },
  {
    city: 'Ronco',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 39.86888,
    longitude: -79.92228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15476',
  },
  {
    city: 'Roscoe',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 1207.2,
    imprecise: false,
    latitude: 40.07856,
    longitude: -79.86243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15477',
  },
  {
    city: 'Smithfield',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 34.5,
    imprecise: false,
    latitude: 39.78601,
    longitude: -79.80099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15478',
  },
  {
    city: 'Smithton',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 40.15224,
    longitude: -79.71329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15479',
  },
  {
    city: 'Smock',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 43.8,
    imprecise: false,
    latitude: 39.98644,
    longitude: -79.76962,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15480',
  },
  {
    city: 'Star Junction',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 163.8,
    imprecise: false,
    latitude: 40.06073,
    longitude: -79.76645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15482',
  },
  {
    city: 'Stockdale',
    county_fips: 42125,
    county_fips_all: '42125',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"42125": 100}',
    density: 436,
    imprecise: false,
    latitude: 40.08352,
    longitude: -79.85036,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15483',
  },
  {
    city: 'Uledi',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 282,
    imprecise: false,
    latitude: 39.89242,
    longitude: -79.77842,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15484',
  },
  {
    city: 'Vanderbilt',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 35.9,
    imprecise: false,
    latitude: 40.02762,
    longitude: -79.70981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15486',
  },
  {
    city: 'Waltersburg',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 70.7,
    imprecise: false,
    latitude: 39.97749,
    longitude: -79.75974,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15488',
  },
  {
    city: 'West Leisenring',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 45.6,
    imprecise: false,
    latitude: 39.96323,
    longitude: -79.69531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15489',
  },
  {
    city: 'White',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 27,
    imprecise: false,
    latitude: 40.06782,
    longitude: -79.45327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15490',
  },
  {
    city: 'Wickhaven',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 110.8,
    imprecise: false,
    latitude: 40.11974,
    longitude: -79.76306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15492',
  },
  {
    city: 'Somerset',
    county_fips: 42111,
    county_fips_all: '42111|42129',
    county: 'Somerset',
    county_names_all: 'Somerset|Westmoreland',
    county_weights: '{"42111": 95.39, "42129": 4.61}',
    density: 47.5,
    imprecise: false,
    latitude: 40.03582,
    longitude: -79.13024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15501',
  },
  {
    city: 'Hidden Valley',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 40.03641,
    longitude: -79.25176,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15502',
  },
  {
    city: 'Acosta',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 176,
    imprecise: false,
    latitude: 40.10626,
    longitude: -79.06017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15520',
  },
  {
    city: 'Alum Bank',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 40.19972,
    longitude: -78.63176,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15521',
  },
  {
    city: 'Bedford',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 39.94931,
    longitude: -78.55173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15522',
  },
  {
    city: 'Berlin',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 39.94531,
    longitude: -78.91253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15530',
  },
  {
    city: 'Boswell',
    county_fips: 42111,
    county_fips_all: '42111|42129',
    county: 'Somerset',
    county_names_all: 'Somerset|Westmoreland',
    county_weights: '{"42111": 87.48, "42129": 12.52}',
    density: 22.8,
    imprecise: false,
    latitude: 40.18537,
    longitude: -79.0794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15531',
  },
  {
    city: 'Boynton',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 59.1,
    imprecise: false,
    latitude: 39.76232,
    longitude: -79.06084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15532',
  },
  {
    city: 'Breezewood',
    county_fips: 42009,
    county_fips_all: '42009|42057',
    county: 'Bedford',
    county_names_all: 'Bedford|Fulton',
    county_weights: '{"42009": 93.87, "42057": 6.13}',
    density: 15.1,
    imprecise: false,
    latitude: 39.98585,
    longitude: -78.24566,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15533',
  },
  {
    city: 'Buffalo Mills',
    county_fips: 42009,
    county_fips_all: '42009|42111',
    county: 'Bedford',
    county_names_all: 'Bedford|Somerset',
    county_weights: '{"42009": 99.12, "42111": 0.88}',
    density: 6.5,
    imprecise: false,
    latitude: 39.89712,
    longitude: -78.69589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15534',
  },
  {
    city: 'Clearville',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 5,
    imprecise: false,
    latitude: 39.826,
    longitude: -78.45001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15535',
  },
  {
    city: 'Crystal Spring',
    county_fips: 42057,
    county_fips_all: '42057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"42057": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 39.94956,
    longitude: -78.2109,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15536',
  },
  {
    city: 'Everett',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 39.9981,
    longitude: -78.36506,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15537',
  },
  {
    city: 'Fairhope',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 39.86644,
    longitude: -78.83233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15538',
  },
  {
    city: 'Fishertown',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 50.9,
    imprecise: false,
    latitude: 40.12835,
    longitude: -78.59341,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15539',
  },
  {
    city: 'Fort Hill',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 39.79549,
    longitude: -79.23712,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15540',
  },
  {
    city: 'Friedens',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 32,
    imprecise: false,
    latitude: 40.04905,
    longitude: -78.98076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15541',
  },
  {
    city: 'Garrett',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 39.86742,
    longitude: -79.07851,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15542',
  },
  {
    city: 'Gray',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 204.1,
    imprecise: false,
    latitude: 40.13254,
    longitude: -79.09656,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15544',
  },
  {
    city: 'Hyndman',
    county_fips: 42009,
    county_fips_all: '42009|42111',
    county: 'Bedford',
    county_names_all: 'Bedford|Somerset',
    county_weights: '{"42009": 58.31, "42111": 41.69}',
    density: 20.6,
    imprecise: false,
    latitude: 39.77943,
    longitude: -78.776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15545',
  },
  {
    city: 'Jennerstown',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 486.3,
    imprecise: false,
    latitude: 40.1629,
    longitude: -79.07019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15547',
  },
  {
    city: 'Manns Choice',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 12,
    imprecise: false,
    latitude: 39.99025,
    longitude: -78.64493,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15550',
  },
  {
    city: 'Markleton',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 39.88413,
    longitude: -79.26761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15551',
  },
  {
    city: 'Meyersdale',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 39.79629,
    longitude: -78.98232,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15552',
  },
  {
    city: 'New Paris',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 30.4,
    imprecise: false,
    latitude: 40.12525,
    longitude: -78.61575,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15554',
  },
  {
    city: 'Quecreek',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 68.7,
    imprecise: false,
    latitude: 40.09758,
    longitude: -79.08132,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15555',
  },
  {
    city: 'Rockwood',
    county_fips: 42111,
    county_fips_all: '42111|42051',
    county: 'Somerset',
    county_names_all: 'Somerset|Fayette',
    county_weights: '{"42111": 99.24, "42051": 0.76}',
    density: 14.3,
    imprecise: false,
    latitude: 39.92757,
    longitude: -79.20945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15557',
  },
  {
    city: 'Salisbury',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 22.7,
    imprecise: false,
    latitude: 39.7494,
    longitude: -79.09755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15558',
  },
  {
    city: 'Schellsburg',
    county_fips: 42009,
    county_fips_all: '42009|42111',
    county: 'Bedford',
    county_names_all: 'Bedford|Somerset',
    county_weights: '{"42009": 99.88, "42111": 0.12}',
    density: 17.3,
    imprecise: false,
    latitude: 40.05914,
    longitude: -78.68241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15559',
  },
  {
    city: 'Shanksville',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 325.7,
    imprecise: false,
    latitude: 40.01687,
    longitude: -78.90664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15560',
  },
  {
    city: 'Sipesville',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 200.8,
    imprecise: false,
    latitude: 40.09379,
    longitude: -79.0907,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15561',
  },
  {
    city: 'Springs',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 39,
    imprecise: false,
    latitude: 39.74165,
    longitude: -79.1219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15562',
  },
  {
    city: 'Stoystown',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 40.0962,
    longitude: -78.93618,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15563',
  },
  {
    city: 'Greensburg',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 270.1,
    imprecise: false,
    latitude: 40.31397,
    longitude: -79.53643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15601',
  },
  {
    city: 'Acme',
    county_fips: 42129,
    county_fips_all: '42129|42051',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Fayette',
    county_weights: '{"42129": 67.37, "42051": 32.63}',
    density: 38.8,
    imprecise: false,
    latitude: 40.13699,
    longitude: -79.41613,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15610',
  },
  {
    city: 'Adamsburg',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 133.6,
    imprecise: false,
    latitude: 40.30656,
    longitude: -79.65266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15611',
  },
  {
    city: 'Alverton',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 79.4,
    imprecise: false,
    latitude: 40.13793,
    longitude: -79.59938,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15612',
  },
  {
    city: 'Apollo',
    county_fips: 42129,
    county_fips_all: '42129|42005',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Armstrong',
    county_weights: '{"42129": 62.03, "42005": 37.97}',
    density: 85.7,
    imprecise: false,
    latitude: 40.55355,
    longitude: -79.56577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15613',
  },
  {
    city: 'Ardara',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 110.2,
    imprecise: false,
    latitude: 40.36133,
    longitude: -79.73397,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15615',
  },
  {
    city: 'Armbrust',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 110.6,
    imprecise: false,
    latitude: 40.23502,
    longitude: -79.55093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15616',
  },
  {
    city: 'Arona',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 204.3,
    imprecise: false,
    latitude: 40.26856,
    longitude: -79.65805,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15617',
  },
  {
    city: 'Avonmore',
    county_fips: 42005,
    county_fips_all: '42005|42129|42063',
    county: 'Armstrong',
    county_names_all: 'Armstrong|Westmoreland|Indiana',
    county_weights: '{"42005": 62.89, "42129": 29.47, "42063": 7.64}',
    density: 31.6,
    imprecise: false,
    latitude: 40.56229,
    longitude: -79.44628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15618',
  },
  {
    city: 'Bovard',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 278.7,
    imprecise: false,
    latitude: 40.32051,
    longitude: -79.49719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15619',
  },
  {
    city: 'Bradenville',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 339,
    imprecise: false,
    latitude: 40.32336,
    longitude: -79.33882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15620',
  },
  {
    city: 'Champion',
    county_fips: 42051,
    county_fips_all: '42051|42111|42129',
    county: 'Fayette',
    county_names_all: 'Fayette|Somerset|Westmoreland',
    county_weights: '{"42051": 36.86, "42111": 34.82, "42129": 28.32}',
    density: 7.4,
    imprecise: false,
    latitude: 40.0356,
    longitude: -79.31724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15622',
  },
  {
    city: 'Claridge',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 368,
    imprecise: false,
    latitude: 40.3689,
    longitude: -79.62263,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15623',
  },
  {
    city: 'Crabtree',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 173.3,
    imprecise: false,
    latitude: 40.36638,
    longitude: -79.47124,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15624',
  },
  {
    city: 'Darragh',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 37.3,
    imprecise: false,
    latitude: 40.27048,
    longitude: -79.67925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15625',
  },
  {
    city: 'Delmont',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 461,
    imprecise: false,
    latitude: 40.40868,
    longitude: -79.57592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15626',
  },
  {
    city: 'Derry',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 75.1,
    imprecise: false,
    latitude: 40.35064,
    longitude: -79.30667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15627',
  },
  {
    city: 'Donegal',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 97.7,
    imprecise: false,
    latitude: 40.10009,
    longitude: -79.37008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15628',
  },
  {
    city: 'East Vandergrift',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 1931.2,
    imprecise: false,
    latitude: 40.59731,
    longitude: -79.56304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15629',
  },
  {
    city: 'Everson',
    county_fips: 42051,
    county_fips_all: '42051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"42051": 100}',
    density: 460.8,
    imprecise: false,
    latitude: 40.08968,
    longitude: -79.58527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15631',
  },
  {
    city: 'Export',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 108.7,
    imprecise: false,
    latitude: 40.43803,
    longitude: -79.60668,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15632',
  },
  {
    city: 'Forbes Road',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 93.2,
    imprecise: false,
    latitude: 40.35941,
    longitude: -79.51699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15633',
  },
  {
    city: 'Grapeville',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 1284.9,
    imprecise: false,
    latitude: 40.32533,
    longitude: -79.60596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15634',
  },
  {
    city: 'Hannastown',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 310.5,
    imprecise: false,
    latitude: 40.34891,
    longitude: -79.49877,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15635',
  },
  {
    city: 'Harrison City',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 569.5,
    imprecise: false,
    latitude: 40.36459,
    longitude: -79.65619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15636',
  },
  {
    city: 'Herminie',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 145.4,
    imprecise: false,
    latitude: 40.26125,
    longitude: -79.71203,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15637',
  },
  {
    city: 'Hostetter',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 260.3,
    imprecise: false,
    latitude: 40.26466,
    longitude: -79.4017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15638',
  },
  {
    city: 'Hunker',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 76.4,
    imprecise: false,
    latitude: 40.20927,
    longitude: -79.59379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15639',
  },
  {
    city: 'Hutchinson',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 341.2,
    imprecise: false,
    latitude: 40.22315,
    longitude: -79.73243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15640',
  },
  {
    city: 'Hyde Park',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 745.2,
    imprecise: false,
    latitude: 40.63151,
    longitude: -79.58909,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15641',
  },
  {
    city: 'Irwin',
    county_fips: 42129,
    county_fips_all: '42129|42003',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Allegheny',
    county_weights: '{"42129": 98.1, "42003": 1.9}',
    density: 388.5,
    imprecise: false,
    latitude: 40.32045,
    longitude: -79.72119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15642',
  },
  {
    city: 'Jeannette',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 322.8,
    imprecise: false,
    latitude: 40.34681,
    longitude: -79.61278,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15644',
  },
  {
    city: 'Jones Mills',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 56.3,
    imprecise: false,
    latitude: 40.09517,
    longitude: -79.34448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15646',
  },
  {
    city: 'Larimer',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 234.7,
    imprecise: false,
    latitude: 40.34262,
    longitude: -79.72009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15647',
  },
  {
    city: 'Latrobe',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 137,
    imprecise: false,
    latitude: 40.27527,
    longitude: -79.39213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15650',
  },
  {
    city: 'Laughlintown',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 40.19739,
    longitude: -79.18141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15655',
  },
  {
    city: 'Leechburg',
    county_fips: 42129,
    county_fips_all: '42129|42005',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Armstrong',
    county_weights: '{"42129": 57.11, "42005": 42.89}',
    density: 115.2,
    imprecise: false,
    latitude: 40.64114,
    longitude: -79.61981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15656',
  },
  {
    city: 'Ligonier',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 34,
    imprecise: false,
    latitude: 40.25467,
    longitude: -79.22217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15658',
  },
  {
    city: 'Lowber',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 444.6,
    imprecise: false,
    latitude: 40.24669,
    longitude: -79.77293,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15660',
  },
  {
    city: 'Loyalhanna',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 847.2,
    imprecise: false,
    latitude: 40.32192,
    longitude: -79.36007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15661',
  },
  {
    city: 'Luxor',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 249.6,
    imprecise: false,
    latitude: 40.33892,
    longitude: -79.47972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15662',
  },
  {
    city: 'Madison',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 152.6,
    imprecise: false,
    latitude: 40.25233,
    longitude: -79.67958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15663',
  },
  {
    city: 'Manor',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 580.3,
    imprecise: false,
    latitude: 40.33925,
    longitude: -79.66338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15665',
  },
  {
    city: 'Mount Pleasant',
    county_fips: 42129,
    county_fips_all: '42129|42051',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Fayette',
    county_weights: '{"42129": 75.98, "42051": 24.02}',
    density: 115.7,
    imprecise: false,
    latitude: 40.15858,
    longitude: -79.51398,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15666',
  },
  {
    city: 'Murrysville',
    county_fips: 42129,
    county_fips_all: '42129|42003',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Allegheny',
    county_weights: '{"42129": 99.77, "42003": 0.23}',
    density: 251.5,
    imprecise: false,
    latitude: 40.46352,
    longitude: -79.67168,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15668',
  },
  {
    city: 'New Alexandria',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 34.8,
    imprecise: false,
    latitude: 40.40783,
    longitude: -79.4321,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15670',
  },
  {
    city: 'New Derry',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 112.3,
    imprecise: false,
    latitude: 40.36038,
    longitude: -79.32146,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15671',
  },
  {
    city: 'New Stanton',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 114.8,
    imprecise: false,
    latitude: 40.24428,
    longitude: -79.63069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15672',
  },
  {
    city: 'North Apollo',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 826,
    imprecise: false,
    latitude: 40.59383,
    longitude: -79.55634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15673',
  },
  {
    city: 'Norvelt',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 217,
    imprecise: false,
    latitude: 40.20672,
    longitude: -79.49636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15674',
  },
  {
    city: 'Penn',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 473.4,
    imprecise: false,
    latitude: 40.33363,
    longitude: -79.63867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15675',
  },
  {
    city: 'Pleasant Unity',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 180.9,
    imprecise: false,
    latitude: 40.24303,
    longitude: -79.45913,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15676',
  },
  {
    city: 'Rector',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 8,
    imprecise: false,
    latitude: 40.15048,
    longitude: -79.23113,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15677',
  },
  {
    city: 'Rillton',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 138,
    imprecise: false,
    latitude: 40.28447,
    longitude: -79.72579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15678',
  },
  {
    city: 'Ruffs Dale',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 48.8,
    imprecise: false,
    latitude: 40.18126,
    longitude: -79.64982,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15679',
  },
  {
    city: 'Salina',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 644.4,
    imprecise: false,
    latitude: 40.52104,
    longitude: -79.49638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15680',
  },
  {
    city: 'Saltsburg',
    county_fips: 42063,
    county_fips_all: '42063|42129',
    county: 'Indiana',
    county_names_all: 'Indiana|Westmoreland',
    county_weights: '{"42063": 54.07, "42129": 45.93}',
    density: 34.1,
    imprecise: false,
    latitude: 40.5023,
    longitude: -79.43873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15681',
  },
  {
    city: 'Schenley',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 33.5,
    imprecise: false,
    latitude: 40.68301,
    longitude: -79.63696,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15682',
  },
  {
    city: 'Scottdale',
    county_fips: 42129,
    county_fips_all: '42129|42051',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Fayette',
    county_weights: '{"42129": 81.06, "42051": 18.94}',
    density: 157,
    imprecise: false,
    latitude: 40.10926,
    longitude: -79.60492,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15683',
  },
  {
    city: 'Slickville',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 30.4,
    imprecise: false,
    latitude: 40.4629,
    longitude: -79.50629,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15684',
  },
  {
    city: 'Spring Church',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 38.6,
    imprecise: false,
    latitude: 40.61802,
    longitude: -79.43635,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15686',
  },
  {
    city: 'Stahlstown',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 16,
    imprecise: false,
    latitude: 40.13149,
    longitude: -79.31977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15687',
  },
  {
    city: 'Tarrs',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 113.4,
    imprecise: false,
    latitude: 40.1734,
    longitude: -79.58602,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15688',
  },
  {
    city: 'United',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 98,
    imprecise: false,
    latitude: 40.2253,
    longitude: -79.49164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15689',
  },
  {
    city: 'Vandergrift',
    county_fips: 42005,
    county_fips_all: '42005|42129',
    county: 'Armstrong',
    county_names_all: 'Armstrong|Westmoreland',
    county_weights: '{"42005": 90.5, "42129": 9.5}',
    density: 131.7,
    imprecise: false,
    latitude: 40.6455,
    longitude: -79.54243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15690',
  },
  {
    city: 'Wendel',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 1334.1,
    imprecise: false,
    latitude: 40.29668,
    longitude: -79.68411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15691',
  },
  {
    city: 'Westmoreland City',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 1206.4,
    imprecise: false,
    latitude: 40.33086,
    longitude: -79.67861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15692',
  },
  {
    city: 'Whitney',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 218.6,
    imprecise: false,
    latitude: 40.24939,
    longitude: -79.40592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15693',
  },
  {
    city: 'Wyano',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 139.3,
    imprecise: false,
    latitude: 40.19707,
    longitude: -79.69284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15695',
  },
  {
    city: 'Youngstown',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 756,
    imprecise: false,
    latitude: 40.2798,
    longitude: -79.36587,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15696',
  },
  {
    city: 'Youngwood',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 621.4,
    imprecise: false,
    latitude: 40.24054,
    longitude: -79.5803,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15697',
  },
  {
    city: 'Yukon',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 212.3,
    imprecise: false,
    latitude: 40.2167,
    longitude: -79.68894,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15698',
  },
  {
    city: 'Indiana',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 107.6,
    imprecise: false,
    latitude: 40.62935,
    longitude: -79.15056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15701',
  },
  {
    city: 'Alverda',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 40.1,
    imprecise: false,
    latitude: 40.64019,
    longitude: -78.87193,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15710',
  },
  {
    city: 'Anita',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 112.7,
    imprecise: false,
    latitude: 41.00926,
    longitude: -78.96235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15711',
  },
  {
    city: 'Arcadia',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 40.79323,
    longitude: -78.84692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15712',
  },
  {
    city: 'Aultman',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 39.2,
    imprecise: false,
    latitude: 40.5698,
    longitude: -79.26184,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15713',
  },
  {
    city: 'Northern Cambria',
    county_fips: 42021,
    county_fips_all: '42021|42063',
    county: 'Cambria',
    county_names_all: 'Cambria|Indiana',
    county_weights: '{"42021": 55.61, "42063": 44.39}',
    density: 60.2,
    imprecise: false,
    latitude: 40.63962,
    longitude: -78.82978,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15714',
  },
  {
    city: 'Big Run',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 282,
    imprecise: false,
    latitude: 40.97017,
    longitude: -78.87655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15715',
  },
  {
    city: 'Black Lick',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 325.6,
    imprecise: false,
    latitude: 40.47025,
    longitude: -79.19031,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15716',
  },
  {
    city: 'Blairsville',
    county_fips: 42063,
    county_fips_all: '42063|42129',
    county: 'Indiana',
    county_names_all: 'Indiana|Westmoreland',
    county_weights: '{"42063": 69.62, "42129": 30.38}',
    density: 37.8,
    imprecise: false,
    latitude: 40.45354,
    longitude: -79.23896,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15717',
  },
  {
    city: 'Brush Valley',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 88.9,
    imprecise: false,
    latitude: 40.53896,
    longitude: -79.06625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15720',
  },
  {
    city: 'Burnside',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 27,
    imprecise: false,
    latitude: 40.82029,
    longitude: -78.78739,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15721',
  },
  {
    city: 'Carrolltown',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 40.3,
    imprecise: false,
    latitude: 40.59833,
    longitude: -78.72532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15722',
  },
  {
    city: 'Chambersville',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 40.70066,
    longitude: -79.1582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15723',
  },
  {
    city: 'Cherry Tree',
    county_fips: 42063,
    county_fips_all: '42063|42033|42021',
    county: 'Indiana',
    county_names_all: 'Indiana|Clearfield|Cambria',
    county_weights: '{"42063": 59.7, "42033": 29.07, "42021": 11.23}',
    density: 19.2,
    imprecise: false,
    latitude: 40.73545,
    longitude: -78.81746,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15724',
  },
  {
    city: 'Clarksburg',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 40.51751,
    longitude: -79.33954,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15725',
  },
  {
    city: 'Clune',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 41.8,
    imprecise: false,
    latitude: 40.56498,
    longitude: -79.31496,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15727',
  },
  {
    city: 'Clymer',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 30.5,
    imprecise: false,
    latitude: 40.6757,
    longitude: -78.96644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15728',
  },
  {
    city: 'Commodore',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 40.70583,
    longitude: -78.92049,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15729',
  },
  {
    city: 'Coolspring',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 41.02749,
    longitude: -79.07921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15730',
  },
  {
    city: 'Coral',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 385.8,
    imprecise: false,
    latitude: 40.50383,
    longitude: -79.1767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15731',
  },
  {
    city: 'Creekside',
    county_fips: 42063,
    county_fips_all: '42063|42005',
    county: 'Indiana',
    county_names_all: 'Indiana|Armstrong',
    county_weights: '{"42063": 89.53, "42005": 10.47}',
    density: 20.9,
    imprecise: false,
    latitude: 40.72829,
    longitude: -79.21336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15732',
  },
  {
    city: 'De Lancey',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 68.5,
    imprecise: false,
    latitude: 40.9869,
    longitude: -78.96072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15733',
  },
  {
    city: 'Dixonville',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 139.4,
    imprecise: false,
    latitude: 40.72046,
    longitude: -79.00836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15734',
  },
  {
    city: 'Elderton',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 75.8,
    imprecise: false,
    latitude: 40.69945,
    longitude: -79.36946,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15736',
  },
  {
    city: 'Elmora',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 46.5,
    imprecise: false,
    latitude: 40.59871,
    longitude: -78.75356,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15737',
  },
  {
    city: 'Emeigh',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 28.2,
    imprecise: false,
    latitude: 40.69039,
    longitude: -78.78174,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15738',
  },
  {
    city: 'Ernest',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 749.3,
    imprecise: false,
    latitude: 40.67875,
    longitude: -79.16454,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15739',
  },
  {
    city: 'Gipsy',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 40.80601,
    longitude: -78.88924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15741',
  },
  {
    city: 'Glen Campbell',
    county_fips: 42063,
    county_fips_all: '42063|42033',
    county: 'Indiana',
    county_names_all: 'Indiana|Clearfield',
    county_weights: '{"42063": 93.32, "42033": 6.68}',
    density: 12.5,
    imprecise: false,
    latitude: 40.81042,
    longitude: -78.8688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15742',
  },
  {
    city: 'Hamilton',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 40.91722,
    longitude: -79.07119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15744',
  },
  {
    city: 'Heilwood',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 72.7,
    imprecise: false,
    latitude: 40.62264,
    longitude: -78.91347,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15745',
  },
  {
    city: 'Hillsdale',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 40.75285,
    longitude: -78.87455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15746',
  },
  {
    city: 'Home',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 20.1,
    imprecise: false,
    latitude: 40.76533,
    longitude: -79.14562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15747',
  },
  {
    city: 'Homer City',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 39,
    imprecise: false,
    latitude: 40.52489,
    longitude: -79.087,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15748',
  },
  {
    city: 'Kent',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 770.5,
    imprecise: false,
    latitude: 40.5408,
    longitude: -79.28177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15752',
  },
  {
    city: 'La Jose',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 40.78681,
    longitude: -78.64728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15753',
  },
  {
    city: 'Lucernemines',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 237.9,
    imprecise: false,
    latitude: 40.55667,
    longitude: -79.15152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15754',
  },
  {
    city: 'McIntyre',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 60.7,
    imprecise: false,
    latitude: 40.57134,
    longitude: -79.30096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15756',
  },
  {
    city: 'Mahaffey',
    county_fips: 42033,
    county_fips_all: '42033|42063',
    county: 'Clearfield',
    county_names_all: 'Clearfield|Indiana',
    county_weights: '{"42033": 94.63, "42063": 5.37}',
    density: 5.8,
    imprecise: false,
    latitude: 40.8902,
    longitude: -78.73733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15757',
  },
  {
    city: 'Marion Center',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 40.7721,
    longitude: -79.03045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15759',
  },
  {
    city: 'Marsteller',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 34.7,
    imprecise: false,
    latitude: 40.64583,
    longitude: -78.80509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15760',
  },
  {
    city: 'Mentcle',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 146.4,
    imprecise: false,
    latitude: 40.63399,
    longitude: -78.89019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15761',
  },
  {
    city: 'Nicktown',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 26.7,
    imprecise: false,
    latitude: 40.6001,
    longitude: -78.83309,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15762',
  },
  {
    city: 'Northpoint',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 40.90718,
    longitude: -79.12795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15763',
  },
  {
    city: 'Oliveburg',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 37.3,
    imprecise: false,
    latitude: 40.99423,
    longitude: -79.02773,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15764',
  },
  {
    city: 'Penn Run',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 14,
    imprecise: false,
    latitude: 40.59661,
    longitude: -78.99574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15765',
  },
  {
    city: 'Punxsutawney',
    county_fips: 42065,
    county_fips_all: '42065|42063|42033',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Indiana|Clearfield',
    county_weights: '{"42065": 83.66, "42063": 9.11, "42033": 7.23}',
    density: 33.6,
    imprecise: false,
    latitude: 40.95859,
    longitude: -78.96974,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15767',
  },
  {
    city: 'Ringgold',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 40.99528,
    longitude: -79.15747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15770',
  },
  {
    city: 'Rochester Mills',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 40.83309,
    longitude: -78.99009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15771',
  },
  {
    city: 'Rossiter',
    county_fips: 42063,
    county_fips_all: '42063|42065',
    county: 'Indiana',
    county_names_all: 'Indiana|Jefferson',
    county_weights: '{"42063": 96.53, "42065": 3.47}',
    density: 18.4,
    imprecise: false,
    latitude: 40.87392,
    longitude: -78.89984,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15772',
  },
  {
    city: 'Saint Benedict',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 112.9,
    imprecise: false,
    latitude: 40.63075,
    longitude: -78.73041,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15773',
  },
  {
    city: 'Shelocta',
    county_fips: 42005,
    county_fips_all: '42005|42063',
    county: 'Armstrong',
    county_names_all: 'Armstrong|Indiana',
    county_weights: '{"42005": 53.77, "42063": 46.23}',
    density: 18.4,
    imprecise: false,
    latitude: 40.65729,
    longitude: -79.32508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15774',
  },
  {
    city: 'Sprankle Mills',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 5,
    imprecise: false,
    latitude: 41.01348,
    longitude: -79.11442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15776',
  },
  {
    city: 'Starford',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 40.69749,
    longitude: -78.96255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15777',
  },
  {
    city: 'Timblin',
    county_fips: 42065,
    county_fips_all: '42065|42005',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Armstrong',
    county_weights: '{"42065": 99.75, "42005": 0.25}',
    density: 202.4,
    imprecise: false,
    latitude: 40.96728,
    longitude: -79.19901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15778',
  },
  {
    city: 'Torrance',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 24.7,
    imprecise: false,
    latitude: 40.40008,
    longitude: -79.21846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15779',
  },
  {
    city: 'Valier',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 37.5,
    imprecise: false,
    latitude: 40.91628,
    longitude: -79.05606,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15780',
  },
  {
    city: 'Walston',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 32.6,
    imprecise: false,
    latitude: 40.96375,
    longitude: -78.98679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15781',
  },
  {
    city: 'West Lebanon',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 32.6,
    imprecise: false,
    latitude: 40.60297,
    longitude: -79.34495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15783',
  },
  {
    city: 'Worthville',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 110.4,
    imprecise: false,
    latitude: 41.02449,
    longitude: -79.13937,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15784',
  },
  {
    city: 'Du Bois',
    county_fips: 42033,
    county_fips_all: '42033|42065',
    county: 'Clearfield',
    county_names_all: 'Clearfield|Jefferson',
    county_weights: '{"42033": 99.15, "42065": 0.85}',
    density: 111,
    imprecise: false,
    latitude: 41.12867,
    longitude: -78.72352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15801',
  },
  {
    city: 'Benezett',
    county_fips: 42047,
    county_fips_all: '42047',
    county: 'Elk',
    county_names_all: 'Elk',
    county_weights: '{"42047": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 41.35868,
    longitude: -78.36453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15821',
  },
  {
    city: 'Brockport',
    county_fips: 42047,
    county_fips_all: '42047|42065',
    county: 'Elk',
    county_names_all: 'Elk|Jefferson',
    county_weights: '{"42047": 84.92, "42065": 15.08}',
    density: 13.6,
    imprecise: false,
    latitude: 41.25888,
    longitude: -78.71001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15823',
  },
  {
    city: 'Brockway',
    county_fips: 42065,
    county_fips_all: '42065|42033',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Clearfield',
    county_weights: '{"42065": 94.25, "42033": 5.75}',
    density: 29.7,
    imprecise: false,
    latitude: 41.24831,
    longitude: -78.83828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15824',
  },
  {
    city: 'Brookville',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 23.5,
    imprecise: false,
    latitude: 41.17005,
    longitude: -79.03885,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15825',
  },
  {
    city: 'Byrnedale',
    county_fips: 42047,
    county_fips_all: '42047',
    county: 'Elk',
    county_names_all: 'Elk',
    county_weights: '{"42047": 100}',
    density: 328.1,
    imprecise: false,
    latitude: 41.29479,
    longitude: -78.50582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15827',
  },
  {
    city: 'Clarington',
    county_fips: 42053,
    county_fips_all: '42053|42065',
    county: 'Forest',
    county_names_all: 'Forest|Jefferson',
    county_weights: '{"42053": 56.28, "42065": 43.72}',
    density: 4.5,
    imprecise: false,
    latitude: 41.35104,
    longitude: -79.13906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15828',
  },
  {
    city: 'Corsica',
    county_fips: 42065,
    county_fips_all: '42065|42031',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Clarion',
    county_weights: '{"42065": 68.97, "42031": 31.03}',
    density: 14.9,
    imprecise: false,
    latitude: 41.17337,
    longitude: -79.19324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15829',
  },
  {
    city: 'Dagus Mines',
    county_fips: 42047,
    county_fips_all: '42047',
    county: 'Elk',
    county_names_all: 'Elk',
    county_weights: '{"42047": 100}',
    density: 148,
    imprecise: false,
    latitude: 41.35305,
    longitude: -78.604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15831',
  },
  {
    city: 'Driftwood',
    county_fips: 42023,
    county_fips_all: '42023|42047',
    county: 'Cameron',
    county_names_all: 'Cameron|Elk',
    county_weights: '{"42023": 89.31, "42047": 10.69}',
    density: 1,
    imprecise: false,
    latitude: 41.35301,
    longitude: -78.19053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15832',
  },
  {
    city: 'Emporium',
    county_fips: 42023,
    county_fips_all: '42023',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"42023": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 41.51228,
    longitude: -78.27811,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15834',
  },
  {
    city: 'Falls Creek',
    county_fips: 42065,
    county_fips_all: '42065|42033',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Clearfield',
    county_weights: '{"42065": 96.93, "42033": 3.07}',
    density: 43.1,
    imprecise: false,
    latitude: 41.16927,
    longitude: -78.82708,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15840',
  },
  {
    city: 'Force',
    county_fips: 42047,
    county_fips_all: '42047',
    county: 'Elk',
    county_names_all: 'Elk',
    county_weights: '{"42047": 100}',
    density: 552.2,
    imprecise: false,
    latitude: 41.25798,
    longitude: -78.50441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15841',
  },
  {
    city: 'Johnsonburg',
    county_fips: 42047,
    county_fips_all: '42047',
    county: 'Elk',
    county_names_all: 'Elk',
    county_weights: '{"42047": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 41.50714,
    longitude: -78.69066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15845',
  },
  {
    city: 'Kersey',
    county_fips: 42047,
    county_fips_all: '42047',
    county: 'Elk',
    county_names_all: 'Elk',
    county_weights: '{"42047": 100}',
    density: 22.7,
    imprecise: false,
    latitude: 41.33375,
    longitude: -78.6147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15846',
  },
  {
    city: 'Knox Dale',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 1034,
    imprecise: false,
    latitude: 41.08614,
    longitude: -79.02948,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15847',
  },
  {
    city: 'Luthersburg',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 41.03137,
    longitude: -78.71908,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15848',
  },
  {
    city: 'Penfield',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 41.17838,
    longitude: -78.55592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15849',
  },
  {
    city: 'Reynoldsville',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 28.1,
    imprecise: false,
    latitude: 41.10115,
    longitude: -78.90316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15851',
  },
  {
    city: 'Ridgway',
    county_fips: 42047,
    county_fips_all: '42047|42065',
    county: 'Elk',
    county_names_all: 'Elk|Jefferson',
    county_weights: '{"42047": 93.64, "42065": 6.36}',
    density: 16.5,
    imprecise: false,
    latitude: 41.39253,
    longitude: -78.79357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15853',
  },
  {
    city: 'Rockton',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 41.08906,
    longitude: -78.6154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15856',
  },
  {
    city: 'Saint Marys',
    county_fips: 42047,
    county_fips_all: '42047',
    county: 'Elk',
    county_names_all: 'Elk',
    county_weights: '{"42047": 100}',
    density: 48.9,
    imprecise: false,
    latitude: 41.45671,
    longitude: -78.53439,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15857',
  },
  {
    city: 'Sigel',
    county_fips: 42065,
    county_fips_all: '42065|42047|42031',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Elk|Clarion',
    county_weights: '{"42065": 52.55, "42047": 45.17, "42031": 2.28}',
    density: 3.3,
    imprecise: false,
    latitude: 41.3435,
    longitude: -79.04697,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15860',
  },
  {
    city: 'Sinnamahoning',
    county_fips: 42023,
    county_fips_all: '42023',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"42023": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 41.3221,
    longitude: -78.07246,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15861',
  },
  {
    city: 'Stump Creek',
    county_fips: 42065,
    county_fips_all: '42065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"42065": 100}',
    density: 121.4,
    imprecise: false,
    latitude: 41.0157,
    longitude: -78.83847,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15863',
  },
  {
    city: 'Summerville',
    county_fips: 42065,
    county_fips_all: '42065|42031',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Clarion',
    county_weights: '{"42065": 56.21, "42031": 43.79}',
    density: 17.8,
    imprecise: false,
    latitude: 41.09911,
    longitude: -79.19532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15864',
  },
  {
    city: 'Sykesville',
    county_fips: 42065,
    county_fips_all: '42065|42033',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Clearfield',
    county_weights: '{"42065": 78.55, "42033": 21.45}',
    density: 147.1,
    imprecise: false,
    latitude: 41.0508,
    longitude: -78.81418,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15865',
  },
  {
    city: 'Troutville',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 100.7,
    imprecise: false,
    latitude: 41.02587,
    longitude: -78.78628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15866',
  },
  {
    city: 'Weedville',
    county_fips: 42047,
    county_fips_all: '42047',
    county: 'Elk',
    county_names_all: 'Elk',
    county_weights: '{"42047": 100}',
    density: 4,
    imprecise: false,
    latitude: 41.29885,
    longitude: -78.41799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15868',
  },
  {
    city: 'Wilcox',
    county_fips: 42047,
    county_fips_all: '42047|42083',
    county: 'Elk',
    county_names_all: 'Elk|McKean',
    county_weights: '{"42047": 94.13, "42083": 5.87}',
    density: 3.7,
    imprecise: false,
    latitude: 41.58116,
    longitude: -78.57935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15870',
  },
  {
    city: 'Johnstown',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 859.6,
    imprecise: false,
    latitude: 40.32845,
    longitude: -78.9146,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15901',
  },
  {
    city: 'Johnstown',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 470.4,
    imprecise: false,
    latitude: 40.32,
    longitude: -78.87911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15902',
  },
  {
    city: 'Johnstown',
    county_fips: 42021,
    county_fips_all: '42021|42111',
    county: 'Cambria',
    county_names_all: 'Cambria|Somerset',
    county_weights: '{"42021": 99.9, "42111": 0.1}',
    density: 214.2,
    imprecise: false,
    latitude: 40.3056,
    longitude: -78.84382,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15904',
  },
  {
    city: 'Johnstown',
    county_fips: 42021,
    county_fips_all: '42021|42111',
    county: 'Cambria',
    county_names_all: 'Cambria|Somerset',
    county_weights: '{"42021": 58.69, "42111": 41.31}',
    density: 179.7,
    imprecise: false,
    latitude: 40.29423,
    longitude: -78.98035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15905',
  },
  {
    city: 'Johnstown',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 134.6,
    imprecise: false,
    latitude: 40.37806,
    longitude: -78.93356,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15906',
  },
  {
    city: 'Johnstown',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 99.3,
    imprecise: false,
    latitude: 40.40783,
    longitude: -78.87047,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15909',
  },
  {
    city: 'Armagh',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 33.4,
    imprecise: false,
    latitude: 40.46705,
    longitude: -79.05006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15920',
  },
  {
    city: 'Beaverdale',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 400.2,
    imprecise: false,
    latitude: 40.31642,
    longitude: -78.69786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15921',
  },
  {
    city: 'Belsano',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 141,
    imprecise: false,
    latitude: 40.51853,
    longitude: -78.87794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 82,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15922',
  },
  {
    city: 'Bolivar',
    county_fips: 42129,
    county_fips_all: '42129',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"42129": 100}',
    density: 23.8,
    imprecise: false,
    latitude: 40.35518,
    longitude: -79.16447,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15923',
  },
  {
    city: 'Cairnbrook',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 40.10684,
    longitude: -78.77527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15924',
  },
  {
    city: 'Cassandra',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 486.3,
    imprecise: false,
    latitude: 40.40851,
    longitude: -78.6407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15925',
  },
  {
    city: 'Central City',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 31.7,
    imprecise: false,
    latitude: 40.04783,
    longitude: -78.81934,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15926',
  },
  {
    city: 'Colver',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 63.3,
    imprecise: false,
    latitude: 40.54148,
    longitude: -78.78019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15927',
  },
  {
    city: 'Davidsville',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 133.2,
    imprecise: false,
    latitude: 40.23943,
    longitude: -78.91591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15928',
  },
  {
    city: 'Dilltown',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 42.5,
    imprecise: false,
    latitude: 40.47683,
    longitude: -79.0042,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15929',
  },
  {
    city: 'Dunlo',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 377.2,
    imprecise: false,
    latitude: 40.29468,
    longitude: -78.71732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15930',
  },
  {
    city: 'Ebensburg',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 42.3,
    imprecise: false,
    latitude: 40.51612,
    longitude: -78.76225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15931',
  },
  {
    city: 'Elton',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 109,
    imprecise: false,
    latitude: 40.28107,
    longitude: -78.79589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15934',
  },
  {
    city: 'Hollsopple',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 42.5,
    imprecise: false,
    latitude: 40.20112,
    longitude: -78.96755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15935',
  },
  {
    city: 'Hooversville',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 21.8,
    imprecise: false,
    latitude: 40.16221,
    longitude: -78.89584,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15936',
  },
  {
    city: 'Jerome',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 87.6,
    imprecise: false,
    latitude: 40.21463,
    longitude: -78.98105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15937',
  },
  {
    city: 'Lilly',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 37.1,
    imprecise: false,
    latitude: 40.42215,
    longitude: -78.6057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15938',
  },
  {
    city: 'Loretto',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 60.7,
    imprecise: false,
    latitude: 40.52128,
    longitude: -78.63218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15940',
  },
  {
    city: 'Mineral Point',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 48.9,
    imprecise: false,
    latitude: 40.40584,
    longitude: -78.81215,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15942',
  },
  {
    city: 'Nanty Glo',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 72,
    imprecise: false,
    latitude: 40.47437,
    longitude: -78.83513,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15943',
  },
  {
    city: 'New Florence',
    county_fips: 42129,
    county_fips_all: '42129|42063',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Indiana',
    county_weights: '{"42129": 63.8, "42063": 36.2}',
    density: 18.2,
    imprecise: false,
    latitude: 40.36295,
    longitude: -79.0816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15944',
  },
  {
    city: 'Parkhill',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 431.2,
    imprecise: false,
    latitude: 40.35909,
    longitude: -78.86867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15945',
  },
  {
    city: 'Portage',
    county_fips: 42021,
    county_fips_all: '42021|42013|42009',
    county: 'Cambria',
    county_names_all: 'Cambria|Blair|Bedford',
    county_weights: '{"42021": 69.93, "42013": 20.64, "42009": 9.43}',
    density: 51.9,
    imprecise: false,
    latitude: 40.37248,
    longitude: -78.63573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15946',
  },
  {
    city: 'Revloc',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 245,
    imprecise: false,
    latitude: 40.48986,
    longitude: -78.76699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15948',
  },
  {
    city: 'Robinson',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 218.5,
    imprecise: false,
    latitude: 40.4055,
    longitude: -79.13442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15949',
  },
  {
    city: 'Saint Michael',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 165.9,
    imprecise: false,
    latitude: 40.3307,
    longitude: -78.77209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15951',
  },
  {
    city: 'Salix',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 118.2,
    imprecise: false,
    latitude: 40.30348,
    longitude: -78.77614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15952',
  },
  {
    city: 'Seward',
    county_fips: 42063,
    county_fips_all: '42063|42129|42021',
    county: 'Indiana',
    county_names_all: 'Indiana|Westmoreland|Cambria',
    county_weights: '{"42063": 60.16, "42129": 39.7, "42021": 0.14}',
    density: 43.4,
    imprecise: false,
    latitude: 40.41837,
    longitude: -79.00051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15954',
  },
  {
    city: 'Sidman',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 40.30878,
    longitude: -78.69285,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15955',
  },
  {
    city: 'South Fork',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 106.7,
    imprecise: false,
    latitude: 40.35022,
    longitude: -78.78819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15956',
  },
  {
    city: 'Strongstown',
    county_fips: 42063,
    county_fips_all: '42063|42021',
    county: 'Indiana',
    county_names_all: 'Indiana|Cambria',
    county_weights: '{"42063": 53.83, "42021": 46.17}',
    density: 17.8,
    imprecise: false,
    latitude: 40.53953,
    longitude: -78.89744,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15957',
  },
  {
    city: 'Summerhill',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 47.2,
    imprecise: false,
    latitude: 40.3891,
    longitude: -78.73284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15958',
  },
  {
    city: 'Twin Rocks',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 60,
    imprecise: false,
    latitude: 40.49848,
    longitude: -78.85184,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15960',
  },
  {
    city: 'Vintondale',
    county_fips: 42063,
    county_fips_all: '42063|42021',
    county: 'Indiana',
    county_names_all: 'Indiana|Cambria',
    county_weights: '{"42063": 57.21, "42021": 42.79}',
    density: 20,
    imprecise: false,
    latitude: 40.46187,
    longitude: -78.9382,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15961',
  },
  {
    city: 'Wilmore',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 619.2,
    imprecise: false,
    latitude: 40.38942,
    longitude: -78.71644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15962',
  },
  {
    city: 'Windber',
    county_fips: 42111,
    county_fips_all: '42111|42021',
    county: 'Somerset',
    county_names_all: 'Somerset|Cambria',
    county_weights: '{"42111": 74.28, "42021": 25.72}',
    density: 43.3,
    imprecise: false,
    latitude: 40.21676,
    longitude: -78.77234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15963',
  },
  {
    city: 'Butler',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 199.8,
    imprecise: false,
    latitude: 40.91049,
    longitude: -79.94376,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16001',
  },
  {
    city: 'Butler',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 82.1,
    imprecise: false,
    latitude: 40.81568,
    longitude: -79.85638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16002',
  },
  {
    city: 'Boyers',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 41.11651,
    longitude: -79.89648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16020',
  },
  {
    city: 'Bruin',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 112.4,
    imprecise: false,
    latitude: 41.05461,
    longitude: -79.7333,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16022',
  },
  {
    city: 'Cabot',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 60.3,
    imprecise: false,
    latitude: 40.78495,
    longitude: -79.74921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16023',
  },
  {
    city: 'Callery',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 244.3,
    imprecise: false,
    latitude: 40.73961,
    longitude: -80.03719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16024',
  },
  {
    city: 'Chicora',
    county_fips: 42019,
    county_fips_all: '42019|42005',
    county: 'Butler',
    county_names_all: 'Butler|Armstrong',
    county_weights: '{"42019": 88.2, "42005": 11.8}',
    density: 33.9,
    imprecise: false,
    latitude: 40.94464,
    longitude: -79.75841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16025',
  },
  {
    city: 'Connoquenessing',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 202.7,
    imprecise: false,
    latitude: 40.81822,
    longitude: -80.01531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16027',
  },
  {
    city: 'East Brady',
    county_fips: 42005,
    county_fips_all: '42005|42031',
    county: 'Armstrong',
    county_names_all: 'Armstrong|Clarion',
    county_weights: '{"42005": 92.98, "42031": 7.02}',
    density: 49.4,
    imprecise: false,
    latitude: 40.95684,
    longitude: -79.63985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16028',
  },
  {
    city: 'East Butler',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 455.9,
    imprecise: false,
    latitude: 40.87996,
    longitude: -79.84602,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16029',
  },
  {
    city: 'Eau Claire',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 99,
    imprecise: false,
    latitude: 41.13619,
    longitude: -79.79699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16030',
  },
  {
    city: 'Evans City',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 102.8,
    imprecise: false,
    latitude: 40.79355,
    longitude: -80.04618,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16033',
  },
  {
    city: 'Fenelton',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 36,
    imprecise: false,
    latitude: 40.86051,
    longitude: -79.7288,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16034',
  },
  {
    city: 'Forestville',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 111.6,
    imprecise: false,
    latitude: 41.10779,
    longitude: -80.01659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16035',
  },
  {
    city: 'Foxburg',
    county_fips: 42031,
    county_fips_all: '42031|42005',
    county: 'Clarion',
    county_names_all: 'Clarion|Armstrong',
    county_weights: '{"42031": 99.74, "42005": 0.26}',
    density: 53.8,
    imprecise: false,
    latitude: 41.13519,
    longitude: -79.66948,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16036',
  },
  {
    city: 'Harmony',
    county_fips: 42019,
    county_fips_all: '42019|42073|42007',
    county: 'Butler',
    county_names_all: 'Butler|Lawrence|Beaver',
    county_weights: '{"42019": 86.1, "42073": 7.78, "42007": 6.12}',
    density: 59.3,
    imprecise: false,
    latitude: 40.85103,
    longitude: -80.12592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16037',
  },
  {
    city: 'Harrisville',
    county_fips: 42019,
    county_fips_all: '42019|42121',
    county: 'Butler',
    county_names_all: 'Butler|Venango',
    county_weights: '{"42019": 62.4, "42121": 37.6}',
    density: 27.7,
    imprecise: false,
    latitude: 41.15967,
    longitude: -79.95042,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16038',
  },
  {
    city: 'Hilliards',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 20.3,
    imprecise: false,
    latitude: 41.09399,
    longitude: -79.84537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16040',
  },
  {
    city: 'Karns City',
    county_fips: 42019,
    county_fips_all: '42019|42005',
    county: 'Butler',
    county_names_all: 'Butler|Armstrong',
    county_weights: '{"42019": 61.31, "42005": 38.69}',
    density: 23.2,
    imprecise: false,
    latitude: 41.00693,
    longitude: -79.71395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16041',
  },
  {
    city: 'Lyndora',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 725.1,
    imprecise: false,
    latitude: 40.85277,
    longitude: -79.91626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16045',
  },
  {
    city: 'Mars',
    county_fips: 42019,
    county_fips_all: '42019|42003',
    county: 'Butler',
    county_names_all: 'Butler|Allegheny',
    county_weights: '{"42019": 80.48, "42003": 19.52}',
    density: 334.2,
    imprecise: false,
    latitude: 40.70192,
    longitude: -80.02866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16046',
  },
  {
    city: 'North Washington',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 34.9,
    imprecise: false,
    latitude: 41.05217,
    longitude: -79.80349,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16048',
  },
  {
    city: 'Parker',
    county_fips: 42031,
    county_fips_all: '42031|42019|42005',
    county: 'Clarion',
    county_names_all: 'Clarion|Butler|Armstrong',
    county_weights: '{"42031": 47.3, "42019": 41.91, "42005": 10.79}',
    density: 12.6,
    imprecise: false,
    latitude: 41.09622,
    longitude: -79.67258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16049',
  },
  {
    city: 'Petrolia',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 41.04362,
    longitude: -79.77379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16050',
  },
  {
    city: 'Portersville',
    county_fips: 42019,
    county_fips_all: '42019|42073',
    county: 'Butler',
    county_names_all: 'Butler|Lawrence',
    county_weights: '{"42019": 61.95, "42073": 38.05}',
    density: 30.2,
    imprecise: false,
    latitude: 40.94459,
    longitude: -80.14152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16051',
  },
  {
    city: 'Prospect',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 47.4,
    imprecise: false,
    latitude: 40.90579,
    longitude: -80.06154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16052',
  },
  {
    city: 'Renfrew',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 61.8,
    imprecise: false,
    latitude: 40.81194,
    longitude: -79.9826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16053',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 42031,
    county_fips_all: '42031',
    county: 'Clarion',
    county_names_all: 'Clarion',
    county_weights: '{"42031": 100}',
    density: 78.4,
    imprecise: false,
    latitude: 41.15651,
    longitude: -79.65711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16054',
  },
  {
    city: 'Sarver',
    county_fips: 42019,
    county_fips_all: '42019|42005',
    county: 'Butler',
    county_names_all: 'Butler|Armstrong',
    county_weights: '{"42019": 88.42, "42005": 11.58}',
    density: 90.2,
    imprecise: false,
    latitude: 40.7157,
    longitude: -79.74753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16055',
  },
  {
    city: 'Saxonburg',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 77.7,
    imprecise: false,
    latitude: 40.72301,
    longitude: -79.83911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16056',
  },
  {
    city: 'Slippery Rock',
    county_fips: 42019,
    county_fips_all: '42019|42073|42085',
    county: 'Butler',
    county_names_all: 'Butler|Lawrence|Mercer',
    county_weights: '{"42019": 86.19, "42073": 12.69, "42085": 1.12}',
    density: 68.4,
    imprecise: false,
    latitude: 41.03427,
    longitude: -80.0579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16057',
  },
  {
    city: 'Valencia',
    county_fips: 42019,
    county_fips_all: '42019|42003',
    county: 'Butler',
    county_names_all: 'Butler|Allegheny',
    county_weights: '{"42019": 96.64, "42003": 3.36}',
    density: 148.4,
    imprecise: false,
    latitude: 40.70425,
    longitude: -79.92812,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16059',
  },
  {
    city: 'West Sunbury',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 41.00866,
    longitude: -79.88687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16061',
  },
  {
    city: 'Zelienople',
    county_fips: 42019,
    county_fips_all: '42019|42007',
    county: 'Butler',
    county_names_all: 'Butler|Beaver',
    county_weights: '{"42019": 77.88, "42007": 22.12}',
    density: 188,
    imprecise: false,
    latitude: 40.76352,
    longitude: -80.12773,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16063',
  },
  {
    city: 'Cranberry Township',
    county_fips: 42019,
    county_fips_all: '42019',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"42019": 100}',
    density: 584.8,
    imprecise: false,
    latitude: 40.71114,
    longitude: -80.10606,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16066',
  },
  {
    city: 'New Castle',
    county_fips: 42073,
    county_fips_all: '42073',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"42073": 100}',
    density: 171.6,
    imprecise: false,
    latitude: 40.98776,
    longitude: -80.28814,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16101',
  },
  {
    city: 'New Castle',
    county_fips: 42073,
    county_fips_all: '42073',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"42073": 100}',
    density: 78.2,
    imprecise: false,
    latitude: 40.96173,
    longitude: -80.41616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16102',
  },
  {
    city: 'New Castle',
    county_fips: 42073,
    county_fips_all: '42073',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"42073": 100}',
    density: 232.8,
    imprecise: false,
    latitude: 41.05285,
    longitude: -80.33918,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16105',
  },
  {
    city: 'Adamsville',
    county_fips: 42039,
    county_fips_all: '42039|42085',
    county: 'Crawford',
    county_names_all: 'Crawford|Mercer',
    county_weights: '{"42039": 75.97, "42085": 24.03}',
    density: 14.5,
    imprecise: false,
    latitude: 41.49757,
    longitude: -80.38591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16110',
  },
  {
    city: 'Atlantic',
    county_fips: 42039,
    county_fips_all: '42039',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"42039": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 41.51936,
    longitude: -80.28463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16111',
  },
  {
    city: 'Bessemer',
    county_fips: 42073,
    county_fips_all: '42073',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"42073": 100}',
    density: 72.9,
    imprecise: false,
    latitude: 40.96812,
    longitude: -80.50099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16112',
  },
  {
    city: 'Clark',
    county_fips: 42085,
    county_fips_all: '42085',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"42085": 100}',
    density: 259.9,
    imprecise: false,
    latitude: 41.2828,
    longitude: -80.42569,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16113',
  },
  {
    city: 'Clarks Mills',
    county_fips: 42085,
    county_fips_all: '42085',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"42085": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 41.40432,
    longitude: -80.18766,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16114',
  },
  {
    city: 'Darlington',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 33.7,
    imprecise: false,
    latitude: 40.79433,
    longitude: -80.46289,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16115',
  },
  {
    city: 'Edinburg',
    county_fips: 42073,
    county_fips_all: '42073',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"42073": 100}',
    density: 41.5,
    imprecise: false,
    latitude: 41.03744,
    longitude: -80.45212,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16116',
  },
  {
    city: 'Ellwood City',
    county_fips: 42073,
    county_fips_all: '42073|42007',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Beaver',
    county_weights: '{"42073": 65.47, "42007": 34.53}',
    density: 167.5,
    imprecise: false,
    latitude: 40.8743,
    longitude: -80.2568,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16117',
  },
  {
    city: 'Enon Valley',
    county_fips: 42073,
    county_fips_all: '42073|42007',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Beaver',
    county_weights: '{"42073": 89.6, "42007": 10.4}',
    density: 25.7,
    imprecise: false,
    latitude: 40.892,
    longitude: -80.47344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16120',
  },
  {
    city: 'Farrell',
    county_fips: 42085,
    county_fips_all: '42085',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"42085": 100}',
    density: 712.2,
    imprecise: false,
    latitude: 41.21121,
    longitude: -80.49696,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16121',
  },
  {
    city: 'Fombell',
    county_fips: 42007,
    county_fips_all: '42007|42073',
    county: 'Beaver',
    county_names_all: 'Beaver|Lawrence',
    county_weights: '{"42007": 82.1, "42073": 17.9}',
    density: 41.1,
    imprecise: false,
    latitude: 40.82389,
    longitude: -80.19844,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16123',
  },
  {
    city: 'Fredonia',
    county_fips: 42085,
    county_fips_all: '42085',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"42085": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 41.33336,
    longitude: -80.26486,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16124',
  },
  {
    city: 'Greenville',
    county_fips: 42085,
    county_fips_all: '42085|42039',
    county: 'Mercer',
    county_names_all: 'Mercer|Crawford',
    county_weights: '{"42085": 98.41, "42039": 1.59}',
    density: 63.1,
    imprecise: false,
    latitude: 41.40565,
    longitude: -80.37135,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16125',
  },
  {
    city: 'Grove City',
    county_fips: 42085,
    county_fips_all: '42085|42121|42073|42019',
    county: 'Mercer',
    county_names_all: 'Mercer|Venango|Lawrence|Butler',
    county_weights:
      '{"42085": 89.98, "42121": 7.99, "42073": 1.69, "42019": 0.34}',
    density: 79.7,
    imprecise: false,
    latitude: 41.17433,
    longitude: -80.07002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16127',
  },
  {
    city: 'Hadley',
    county_fips: 42085,
    county_fips_all: '42085',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"42085": 100}',
    density: 22.7,
    imprecise: false,
    latitude: 41.44315,
    longitude: -80.21668,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16130',
  },
  {
    city: 'Hartstown',
    county_fips: 42039,
    county_fips_all: '42039',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"42039": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 41.54908,
    longitude: -80.37617,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16131',
  },
  {
    city: 'Hillsville',
    county_fips: 42073,
    county_fips_all: '42073',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"42073": 100}',
    density: 57.8,
    imprecise: false,
    latitude: 41.00603,
    longitude: -80.50449,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16132',
  },
  {
    city: 'Jackson Center',
    county_fips: 42085,
    county_fips_all: '42085',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"42085": 100}',
    density: 20.1,
    imprecise: false,
    latitude: 41.27101,
    longitude: -80.11562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16133',
  },
  {
    city: 'Jamestown',
    county_fips: 42039,
    county_fips_all: '42039|42085',
    county: 'Crawford',
    county_names_all: 'Crawford|Mercer',
    county_weights: '{"42039": 58.85, "42085": 41.15}',
    density: 32.5,
    imprecise: false,
    latitude: 41.50315,
    longitude: -80.46571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16134',
  },
  {
    city: 'Koppel',
    county_fips: 42007,
    county_fips_all: '42007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"42007": 100}',
    density: 424.6,
    imprecise: false,
    latitude: 40.83425,
    longitude: -80.32369,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16136',
  },
  {
    city: 'Mercer',
    county_fips: 42085,
    county_fips_all: '42085',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"42085": 100}',
    density: 44.4,
    imprecise: false,
    latitude: 41.23219,
    longitude: -80.2397,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16137',
  },
  {
    city: 'New Bedford',
    county_fips: 42073,
    county_fips_all: '42073',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"42073": 100}',
    density: 271,
    imprecise: false,
    latitude: 41.09355,
    longitude: -80.51078,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16140',
  },
  {
    city: 'New Galilee',
    county_fips: 42073,
    county_fips_all: '42073|42007',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Beaver',
    county_weights: '{"42073": 69.71, "42007": 30.29}',
    density: 36.7,
    imprecise: false,
    latitude: 40.87237,
    longitude: -80.3968,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16141',
  },
  {
    city: 'New Wilmington',
    county_fips: 42085,
    county_fips_all: '42085|42073',
    county: 'Mercer',
    county_names_all: 'Mercer|Lawrence',
    county_weights: '{"42085": 62.26, "42073": 37.74}',
    density: 48.7,
    imprecise: false,
    latitude: 41.13908,
    longitude: -80.34084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16142',
  },
  {
    city: 'Pulaski',
    county_fips: 42073,
    county_fips_all: '42073|42085',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Mercer',
    county_weights: '{"42073": 70.7, "42085": 29.3}',
    density: 33.1,
    imprecise: false,
    latitude: 41.10528,
    longitude: -80.45434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16143',
  },
  {
    city: 'Sandy Lake',
    county_fips: 42085,
    county_fips_all: '42085',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"42085": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 41.38574,
    longitude: -80.07422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16145',
  },
  {
    city: 'Sharon',
    county_fips: 42085,
    county_fips_all: '42085',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"42085": 100}',
    density: 1253.2,
    imprecise: false,
    latitude: 41.23478,
    longitude: -80.49932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16146',
  },
  {
    city: 'Hermitage',
    county_fips: 42085,
    county_fips_all: '42085',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"42085": 100}',
    density: 202.6,
    imprecise: false,
    latitude: 41.23147,
    longitude: -80.43199,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16148',
  },
  {
    city: 'Sharpsville',
    county_fips: 42085,
    county_fips_all: '42085',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"42085": 100}',
    density: 114.2,
    imprecise: false,
    latitude: 41.28687,
    longitude: -80.44509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16150',
  },
  {
    city: 'Sheakleyville',
    county_fips: 42085,
    county_fips_all: '42085',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"42085": 100}',
    density: 263.3,
    imprecise: false,
    latitude: 41.4428,
    longitude: -80.2056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16151',
  },
  {
    city: 'Stoneboro',
    county_fips: 42085,
    county_fips_all: '42085|42121',
    county: 'Mercer',
    county_names_all: 'Mercer|Venango',
    county_weights: '{"42085": 86.59, "42121": 13.41}',
    density: 20,
    imprecise: false,
    latitude: 41.31845,
    longitude: -80.08122,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16153',
  },
  {
    city: 'Transfer',
    county_fips: 42085,
    county_fips_all: '42085',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"42085": 100}',
    density: 36.3,
    imprecise: false,
    latitude: 41.32539,
    longitude: -80.42111,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16154',
  },
  {
    city: 'Villa Maria',
    county_fips: 42073,
    county_fips_all: '42073',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"42073": 100}',
    density: 55.9,
    imprecise: false,
    latitude: 41.06771,
    longitude: -80.51073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 98,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16155',
  },
  {
    city: 'Volant',
    county_fips: 42073,
    county_fips_all: '42073|42085',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Mercer',
    county_weights: '{"42073": 78.71, "42085": 21.29}',
    density: 25.8,
    imprecise: false,
    latitude: 41.09702,
    longitude: -80.21943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16156',
  },
  {
    city: 'Wampum',
    county_fips: 42073,
    county_fips_all: '42073|42007',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Beaver',
    county_weights: '{"42073": 82.0, "42007": 18.0}',
    density: 43.8,
    imprecise: false,
    latitude: 40.88902,
    longitude: -80.33509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16157',
  },
  {
    city: 'West Middlesex',
    county_fips: 42085,
    county_fips_all: '42085|42073',
    county: 'Mercer',
    county_names_all: 'Mercer|Lawrence',
    county_weights: '{"42085": 89.54, "42073": 10.46}',
    density: 61.3,
    imprecise: false,
    latitude: 41.15967,
    longitude: -80.46858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16159',
  },
  {
    city: 'West Pittsburg',
    county_fips: 42073,
    county_fips_all: '42073',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"42073": 100}',
    density: 299.1,
    imprecise: false,
    latitude: 40.9283,
    longitude: -80.36235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16160',
  },
  {
    city: 'Wheatland',
    county_fips: 42085,
    county_fips_all: '42085',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"42085": 100}',
    density: 1010.8,
    imprecise: false,
    latitude: 41.20232,
    longitude: -80.49282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16161',
  },
  {
    city: 'Kittanning',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 58.6,
    imprecise: false,
    latitude: 40.80984,
    longitude: -79.47204,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16201',
  },
  {
    city: 'Adrian',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 40.89697,
    longitude: -79.519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16210',
  },
  {
    city: 'Beyer',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 81.7,
    imprecise: false,
    latitude: 40.79436,
    longitude: -79.2023,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16211',
  },
  {
    city: 'Cadogan',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 230.2,
    imprecise: false,
    latitude: 40.75239,
    longitude: -79.57795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16212',
  },
  {
    city: 'Callensburg',
    county_fips: 42031,
    county_fips_all: '42031',
    county: 'Clarion',
    county_names_all: 'Clarion',
    county_weights: '{"42031": 100}',
    density: 345.5,
    imprecise: false,
    latitude: 41.12556,
    longitude: -79.55831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16213',
  },
  {
    city: 'Clarion',
    county_fips: 42031,
    county_fips_all: '42031',
    county: 'Clarion',
    county_names_all: 'Clarion',
    county_weights: '{"42031": 100}',
    density: 68.4,
    imprecise: false,
    latitude: 41.2008,
    longitude: -79.36046,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16214',
  },
  {
    city: 'Cooksburg',
    county_fips: 42053,
    county_fips_all: '42053|42031|42065',
    county: 'Forest',
    county_names_all: 'Forest|Clarion|Jefferson',
    county_weights: '{"42053": 75.56, "42031": 24.32, "42065": 0.12}',
    density: 4,
    imprecise: false,
    latitude: 41.34908,
    longitude: -79.18095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16217',
  },
  {
    city: 'Cowansville',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 40.92705,
    longitude: -79.59325,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16218',
  },
  {
    city: 'Crown',
    county_fips: 42031,
    county_fips_all: '42031|42053',
    county: 'Clarion',
    county_names_all: 'Clarion|Forest',
    county_weights: '{"42031": 99.88, "42053": 0.12}',
    density: 1.5,
    imprecise: false,
    latitude: 41.41817,
    longitude: -79.26659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16220',
  },
  {
    city: 'Dayton',
    county_fips: 42005,
    county_fips_all: '42005|42063|42065',
    county: 'Armstrong',
    county_names_all: 'Armstrong|Indiana|Jefferson',
    county_weights: '{"42005": 82.9, "42063": 8.99, "42065": 8.11}',
    density: 20.9,
    imprecise: false,
    latitude: 40.87171,
    longitude: -79.25719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16222',
  },
  {
    city: 'Distant',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 40.98701,
    longitude: -79.35381,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16223',
  },
  {
    city: 'Fairmount City',
    county_fips: 42031,
    county_fips_all: '42031|42005',
    county: 'Clarion',
    county_names_all: 'Clarion|Armstrong',
    county_weights: '{"42031": 95.12, "42005": 4.88}',
    density: 15.1,
    imprecise: false,
    latitude: 41.06314,
    longitude: -79.29245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16224',
  },
  {
    city: 'Ford City',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 50.7,
    imprecise: false,
    latitude: 40.71139,
    longitude: -79.48608,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16226',
  },
  {
    city: 'Ford Cliff',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 2077.9,
    imprecise: false,
    latitude: 40.76076,
    longitude: -79.5358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16228',
  },
  {
    city: 'Freeport',
    county_fips: 42005,
    county_fips_all: '42005|42019|42129',
    county: 'Armstrong',
    county_names_all: 'Armstrong|Butler|Westmoreland',
    county_weights: '{"42005": 87.16, "42019": 6.76, "42129": 6.08}',
    density: 69,
    imprecise: false,
    latitude: 40.71624,
    longitude: -79.64567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16229',
  },
  {
    city: 'Hawthorn',
    county_fips: 42031,
    county_fips_all: '42031|42005',
    county: 'Clarion',
    county_names_all: 'Clarion|Armstrong',
    county_weights: '{"42031": 99.56, "42005": 0.44}',
    density: 188.8,
    imprecise: false,
    latitude: 41.02099,
    longitude: -79.27817,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16230',
  },
  {
    city: 'Knox',
    county_fips: 42031,
    county_fips_all: '42031|42121',
    county: 'Clarion',
    county_names_all: 'Clarion|Venango',
    county_weights: '{"42031": 98.73, "42121": 1.27}',
    density: 26.1,
    imprecise: false,
    latitude: 41.22197,
    longitude: -79.54923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16232',
  },
  {
    city: 'Leeper',
    county_fips: 42031,
    county_fips_all: '42031',
    county: 'Clarion',
    county_names_all: 'Clarion',
    county_weights: '{"42031": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 41.36162,
    longitude: -79.27588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16233',
  },
  {
    city: 'Lucinda',
    county_fips: 42031,
    county_fips_all: '42031',
    county: 'Clarion',
    county_names_all: 'Clarion',
    county_weights: '{"42031": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 41.31759,
    longitude: -79.34943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16235',
  },
  {
    city: 'McGrann',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 2379.6,
    imprecise: false,
    latitude: 40.78119,
    longitude: -79.52376,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16236',
  },
  {
    city: 'Manorville',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 1540.6,
    imprecise: false,
    latitude: 40.78778,
    longitude: -79.52036,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16238',
  },
  {
    city: 'Marienville',
    county_fips: 42053,
    county_fips_all: '42053',
    county: 'Forest',
    county_names_all: 'Forest',
    county_weights: '{"42053": 100}',
    density: 8,
    imprecise: false,
    latitude: 41.49507,
    longitude: -79.1297,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16239',
  },
  {
    city: 'Mayport',
    county_fips: 42065,
    county_fips_all: '42065|42005|42031',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Armstrong|Clarion',
    county_weights: '{"42065": 36.93, "42005": 35.66, "42031": 27.41}',
    density: 9.6,
    imprecise: false,
    latitude: 41.03316,
    longitude: -79.22432,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16240',
  },
  {
    city: 'New Bethlehem',
    county_fips: 42031,
    county_fips_all: '42031|42005',
    county: 'Clarion',
    county_names_all: 'Clarion|Armstrong',
    county_weights: '{"42031": 50.22, "42005": 49.78}',
    density: 18.6,
    imprecise: false,
    latitude: 41.0031,
    longitude: -79.35479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16242',
  },
  {
    city: 'Nu Mine',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 70.3,
    imprecise: false,
    latitude: 40.80499,
    longitude: -79.27905,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16244',
  },
  {
    city: 'Oak Ridge',
    county_fips: 42005,
    county_fips_all: '42005|42031',
    county: 'Armstrong',
    county_names_all: 'Armstrong|Clarion',
    county_weights: '{"42005": 99.85, "42031": 0.15}',
    density: 57.9,
    imprecise: false,
    latitude: 41.00153,
    longitude: -79.29311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16245',
  },
  {
    city: 'Plumville',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 173.2,
    imprecise: false,
    latitude: 40.79167,
    longitude: -79.18215,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16246',
  },
  {
    city: 'Rimersburg',
    county_fips: 42031,
    county_fips_all: '42031',
    county: 'Clarion',
    county_names_all: 'Clarion',
    county_weights: '{"42031": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 41.03412,
    longitude: -79.50348,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16248',
  },
  {
    city: 'Rural Valley',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 26.7,
    imprecise: false,
    latitude: 40.76209,
    longitude: -79.32163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16249',
  },
  {
    city: 'Sagamore',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 20.7,
    imprecise: false,
    latitude: 40.77566,
    longitude: -79.23782,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16250',
  },
  {
    city: 'Seminole',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 88.5,
    imprecise: false,
    latitude: 40.954,
    longitude: -79.34106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16253',
  },
  {
    city: 'Shippenville',
    county_fips: 42031,
    county_fips_all: '42031',
    county: 'Clarion',
    county_names_all: 'Clarion',
    county_weights: '{"42031": 100}',
    density: 28.8,
    imprecise: false,
    latitude: 41.26557,
    longitude: -79.45259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16254',
  },
  {
    city: 'Sligo',
    county_fips: 42031,
    county_fips_all: '42031',
    county: 'Clarion',
    county_names_all: 'Clarion',
    county_weights: '{"42031": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 41.1267,
    longitude: -79.46809,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16255',
  },
  {
    city: 'Smicksburg',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 21.7,
    imprecise: false,
    latitude: 40.8661,
    longitude: -79.13611,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16256',
  },
  {
    city: 'Strattanville',
    county_fips: 42031,
    county_fips_all: '42031',
    county: 'Clarion',
    county_names_all: 'Clarion',
    county_weights: '{"42031": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 41.2307,
    longitude: -79.27217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16258',
  },
  {
    city: 'Templeton',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 40.92699,
    longitude: -79.45692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16259',
  },
  {
    city: 'Vowinckel',
    county_fips: 42031,
    county_fips_all: '42031|42053',
    county: 'Clarion',
    county_names_all: 'Clarion|Forest',
    county_weights: '{"42031": 60.65, "42053": 39.35}',
    density: 8.8,
    imprecise: false,
    latitude: 41.41102,
    longitude: -79.23092,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16260',
  },
  {
    city: 'Worthington',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 31.6,
    imprecise: false,
    latitude: 40.8377,
    longitude: -79.65266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16262',
  },
  {
    city: 'Yatesboro',
    county_fips: 42005,
    county_fips_all: '42005',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"42005": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 40.80118,
    longitude: -79.34108,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16263',
  },
  {
    city: 'Oil City',
    county_fips: 42121,
    county_fips_all: '42121',
    county: 'Venango',
    county_names_all: 'Venango',
    county_weights: '{"42121": 100}',
    density: 62.1,
    imprecise: false,
    latitude: 41.45596,
    longitude: -79.64946,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16301',
  },
  {
    city: 'Carlton',
    county_fips: 42085,
    county_fips_all: '42085|42121',
    county: 'Mercer',
    county_names_all: 'Mercer|Venango',
    county_weights: '{"42085": 95.28, "42121": 4.72}',
    density: 11.1,
    imprecise: false,
    latitude: 41.45706,
    longitude: -80.03477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16311',
  },
  {
    city: 'Chandlers Valley',
    county_fips: 42123,
    county_fips_all: '42123',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"42123": 100}',
    density: 428.8,
    imprecise: false,
    latitude: 41.93218,
    longitude: -79.30324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16312',
  },
  {
    city: 'Clarendon',
    county_fips: 42123,
    county_fips_all: '42123',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"42123": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 41.72294,
    longitude: -79.13884,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16313',
  },
  {
    city: 'Cochranton',
    county_fips: 42039,
    county_fips_all: '42039|42085|42121',
    county: 'Crawford',
    county_names_all: 'Crawford|Mercer|Venango',
    county_weights: '{"42039": 80.61, "42085": 11.4, "42121": 7.99}',
    density: 21.8,
    imprecise: false,
    latitude: 41.51895,
    longitude: -80.06782,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16314',
  },
  {
    city: 'Conneaut Lake',
    county_fips: 42039,
    county_fips_all: '42039',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"42039": 100}',
    density: 38.7,
    imprecise: false,
    latitude: 41.6012,
    longitude: -80.29958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16316',
  },
  {
    city: 'Cooperstown',
    county_fips: 42121,
    county_fips_all: '42121|42039',
    county: 'Venango',
    county_names_all: 'Venango|Crawford',
    county_weights: '{"42121": 95.29, "42039": 4.71}',
    density: 15.5,
    imprecise: false,
    latitude: 41.53232,
    longitude: -79.85258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16317',
  },
  {
    city: 'Cranberry',
    county_fips: 42121,
    county_fips_all: '42121|42031',
    county: 'Venango',
    county_names_all: 'Venango|Clarion',
    county_weights: '{"42121": 75.21, "42031": 24.79}',
    density: 10.3,
    imprecise: false,
    latitude: 41.3216,
    longitude: -79.62942,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16319',
  },
  {
    city: 'East Hickory',
    county_fips: 42053,
    county_fips_all: '42053',
    county: 'Forest',
    county_names_all: 'Forest',
    county_weights: '{"42053": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 41.56835,
    longitude: -79.40084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16321',
  },
  {
    city: 'Endeavor',
    county_fips: 42053,
    county_fips_all: '42053|42123',
    county: 'Forest',
    county_names_all: 'Forest|Warren',
    county_weights: '{"42053": 99.42, "42123": 0.58}',
    density: 16.8,
    imprecise: false,
    latitude: 41.60567,
    longitude: -79.38428,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16322',
  },
  {
    city: 'Franklin',
    county_fips: 42121,
    county_fips_all: '42121',
    county: 'Venango',
    county_names_all: 'Venango',
    county_weights: '{"42121": 100}',
    density: 55.4,
    imprecise: false,
    latitude: 41.41286,
    longitude: -79.83047,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16323',
  },
  {
    city: 'Fryburg',
    county_fips: 42031,
    county_fips_all: '42031',
    county: 'Clarion',
    county_names_all: 'Clarion',
    county_weights: '{"42031": 100}',
    density: 16,
    imprecise: false,
    latitude: 41.36733,
    longitude: -79.43182,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16326',
  },
  {
    city: 'Guys Mills',
    county_fips: 42039,
    county_fips_all: '42039|42121',
    county: 'Crawford',
    county_names_all: 'Crawford|Venango',
    county_weights: '{"42039": 99.6, "42121": 0.4}',
    density: 16.4,
    imprecise: false,
    latitude: 41.6323,
    longitude: -79.95878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16327',
  },
  {
    city: 'Hydetown',
    county_fips: 42039,
    county_fips_all: '42039',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"42039": 100}',
    density: 183.6,
    imprecise: false,
    latitude: 41.651,
    longitude: -79.72716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16328',
  },
  {
    city: 'Irvine',
    county_fips: 42123,
    county_fips_all: '42123',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"42123": 100}',
    density: 38,
    imprecise: false,
    latitude: 41.80642,
    longitude: -79.27684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16329',
  },
  {
    city: 'Kossuth',
    county_fips: 42031,
    county_fips_all: '42031',
    county: 'Clarion',
    county_names_all: 'Clarion',
    county_weights: '{"42031": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 41.29047,
    longitude: -79.56435,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16331',
  },
  {
    city: 'Lickingville',
    county_fips: 42031,
    county_fips_all: '42031',
    county: 'Clarion',
    county_names_all: 'Clarion',
    county_weights: '{"42031": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 41.36096,
    longitude: -79.36873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16332',
  },
  {
    city: 'Ludlow',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 41.74922,
    longitude: -78.9323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16333',
  },
  {
    city: 'Marble',
    county_fips: 42031,
    county_fips_all: '42031',
    county: 'Clarion',
    county_names_all: 'Clarion',
    county_weights: '{"42031": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 41.29749,
    longitude: -79.44968,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16334',
  },
  {
    city: 'Meadville',
    county_fips: 42039,
    county_fips_all: '42039',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"42039": 100}',
    density: 91.6,
    imprecise: false,
    latitude: 41.63143,
    longitude: -80.15378,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16335',
  },
  {
    city: 'Pittsfield',
    county_fips: 42123,
    county_fips_all: '42123',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"42123": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 41.79864,
    longitude: -79.41749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16340',
  },
  {
    city: 'Pleasantville',
    county_fips: 42121,
    county_fips_all: '42121|42053',
    county: 'Venango',
    county_names_all: 'Venango|Forest',
    county_weights: '{"42121": 68.26, "42053": 31.74}',
    density: 9.2,
    imprecise: false,
    latitude: 41.56288,
    longitude: -79.54703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16341',
  },
  {
    city: 'Polk',
    county_fips: 42121,
    county_fips_all: '42121|42085',
    county: 'Venango',
    county_names_all: 'Venango|Mercer',
    county_weights: '{"42121": 96.68, "42085": 3.32}',
    density: 12.4,
    imprecise: false,
    latitude: 41.31995,
    longitude: -79.9294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16342',
  },
  {
    city: 'Reno',
    county_fips: 42121,
    county_fips_all: '42121',
    county: 'Venango',
    county_names_all: 'Venango',
    county_weights: '{"42121": 100}',
    density: 54.4,
    imprecise: false,
    latitude: 41.42204,
    longitude: -79.75233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16343',
  },
  {
    city: 'Rouseville',
    county_fips: 42121,
    county_fips_all: '42121',
    county: 'Venango',
    county_names_all: 'Venango',
    county_weights: '{"42121": 100}',
    density: 212.5,
    imprecise: false,
    latitude: 41.47045,
    longitude: -79.684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16344',
  },
  {
    city: 'Russell',
    county_fips: 42123,
    county_fips_all: '42123',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"42123": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 41.95085,
    longitude: -79.07548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16345',
  },
  {
    city: 'Seneca',
    county_fips: 42121,
    county_fips_all: '42121',
    county: 'Venango',
    county_names_all: 'Venango',
    county_weights: '{"42121": 100}',
    density: 79.4,
    imprecise: false,
    latitude: 41.37845,
    longitude: -79.6727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16346',
  },
  {
    city: 'Sheffield',
    county_fips: 42123,
    county_fips_all: '42123|42053',
    county: 'Warren',
    county_names_all: 'Warren|Forest',
    county_weights: '{"42123": 57.2, "42053": 42.8}',
    density: 5.9,
    imprecise: false,
    latitude: 41.64671,
    longitude: -79.06481,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16347',
  },
  {
    city: 'Sugar Grove',
    county_fips: 42123,
    county_fips_all: '42123',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"42123": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 41.96323,
    longitude: -79.3322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16350',
  },
  {
    city: 'Tidioute',
    county_fips: 42123,
    county_fips_all: '42123|42053',
    county: 'Warren',
    county_names_all: 'Warren|Forest',
    county_weights: '{"42123": 86.42, "42053": 13.58}',
    density: 6.6,
    imprecise: false,
    latitude: 41.67583,
    longitude: -79.37285,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16351',
  },
  {
    city: 'Tiona',
    county_fips: 42123,
    county_fips_all: '42123',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"42123": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 41.76615,
    longitude: -79.03644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16352',
  },
  {
    city: 'Tionesta',
    county_fips: 42053,
    county_fips_all: '42053|42031|42121',
    county: 'Forest',
    county_names_all: 'Forest|Clarion|Venango',
    county_weights: '{"42053": 80.59, "42031": 10.01, "42121": 9.4}',
    density: 6.4,
    imprecise: false,
    latitude: 41.49359,
    longitude: -79.38839,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16353',
  },
  {
    city: 'Titusville',
    county_fips: 42121,
    county_fips_all: '42121|42039|42123',
    county: 'Venango',
    county_names_all: 'Venango|Crawford|Warren',
    county_weights: '{"42121": 51.58, "42039": 40.7, "42123": 7.72}',
    density: 31.1,
    imprecise: false,
    latitude: 41.61476,
    longitude: -79.70637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16354',
  },
  {
    city: 'Townville',
    county_fips: 42039,
    county_fips_all: '42039',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"42039": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 41.68167,
    longitude: -79.89028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16360',
  },
  {
    city: 'Tylersburg',
    county_fips: 42031,
    county_fips_all: '42031',
    county: 'Clarion',
    county_names_all: 'Clarion',
    county_weights: '{"42031": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 41.38597,
    longitude: -79.3422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16361',
  },
  {
    city: 'Utica',
    county_fips: 42121,
    county_fips_all: '42121|42085',
    county: 'Venango',
    county_names_all: 'Venango|Mercer',
    county_weights: '{"42121": 88.86, "42085": 11.14}',
    density: 14.7,
    imprecise: false,
    latitude: 41.45032,
    longitude: -79.96284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16362',
  },
  {
    city: 'Venus',
    county_fips: 42121,
    county_fips_all: '42121|42031',
    county: 'Venango',
    county_names_all: 'Venango|Clarion',
    county_weights: '{"42121": 79.87, "42031": 20.13}',
    density: 14.9,
    imprecise: false,
    latitude: 41.36379,
    longitude: -79.51517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16364',
  },
  {
    city: 'Warren',
    county_fips: 42123,
    county_fips_all: '42123',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"42123": 100}',
    density: 47.9,
    imprecise: false,
    latitude: 41.83943,
    longitude: -79.15324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16365',
  },
  {
    city: 'West Hickory',
    county_fips: 42053,
    county_fips_all: '42053',
    county: 'Forest',
    county_names_all: 'Forest',
    county_weights: '{"42053": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 41.56586,
    longitude: -79.44796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16370',
  },
  {
    city: 'Youngsville',
    county_fips: 42123,
    county_fips_all: '42123',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"42123": 100}',
    density: 39.2,
    imprecise: false,
    latitude: 41.86751,
    longitude: -79.3187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16371',
  },
  {
    city: 'Clintonville',
    county_fips: 42121,
    county_fips_all: '42121',
    county: 'Venango',
    county_names_all: 'Venango',
    county_weights: '{"42121": 100}',
    density: 202.4,
    imprecise: false,
    latitude: 41.20121,
    longitude: -79.87406,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16372',
  },
  {
    city: 'Emlenton',
    county_fips: 42121,
    county_fips_all: '42121|42031|42019',
    county: 'Venango',
    county_names_all: 'Venango|Clarion|Butler',
    county_weights: '{"42121": 64.44, "42031": 28.53, "42019": 7.03}',
    density: 15.5,
    imprecise: false,
    latitude: 41.20786,
    longitude: -79.69796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16373',
  },
  {
    city: 'Kennerdell',
    county_fips: 42121,
    county_fips_all: '42121',
    county: 'Venango',
    county_names_all: 'Venango',
    county_weights: '{"42121": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 41.26136,
    longitude: -79.81066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16374',
  },
  {
    city: 'Albion',
    county_fips: 42049,
    county_fips_all: '42049|42039',
    county: 'Erie',
    county_names_all: 'Erie|Crawford',
    county_weights: '{"42049": 95.78, "42039": 4.22}',
    density: 26,
    imprecise: false,
    latitude: 41.88044,
    longitude: -80.40395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16401',
  },
  {
    city: 'Bear Lake',
    county_fips: 42123,
    county_fips_all: '42123',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"42123": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 41.96459,
    longitude: -79.48076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16402',
  },
  {
    city: 'Cambridge Springs',
    county_fips: 42039,
    county_fips_all: '42039|42049',
    county: 'Crawford',
    county_names_all: 'Crawford|Erie',
    county_weights: '{"42039": 93.09, "42049": 6.91}',
    density: 29.6,
    imprecise: false,
    latitude: 41.7912,
    longitude: -80.02017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16403',
  },
  {
    city: 'Centerville',
    county_fips: 42039,
    county_fips_all: '42039',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"42039": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 41.72483,
    longitude: -79.79018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16404',
  },
  {
    city: 'Columbus',
    county_fips: 42123,
    county_fips_all: '42123',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"42123": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 41.938,
    longitude: -79.5335,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16405',
  },
  {
    city: 'Conneautville',
    county_fips: 42039,
    county_fips_all: '42039',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"42039": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 41.75047,
    longitude: -80.36273,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16406',
  },
  {
    city: 'Corry',
    county_fips: 42049,
    county_fips_all: '42049|42123|42039',
    county: 'Erie',
    county_names_all: 'Erie|Warren|Crawford',
    county_weights: '{"42049": 72.3, "42123": 23.92, "42039": 3.78}',
    density: 35.9,
    imprecise: false,
    latitude: 41.91743,
    longitude: -79.66374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16407',
  },
  {
    city: 'Cranesville',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 32.8,
    imprecise: false,
    latitude: 41.92012,
    longitude: -80.30482,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16410',
  },
  {
    city: 'East Springfield',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 33.4,
    imprecise: false,
    latitude: 41.97781,
    longitude: -80.45037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16411',
  },
  {
    city: 'Edinboro',
    county_fips: 42049,
    county_fips_all: '42049|42039',
    county: 'Erie',
    county_names_all: 'Erie|Crawford',
    county_weights: '{"42049": 79.27, "42039": 20.73}',
    density: 46,
    imprecise: false,
    latitude: 41.88212,
    longitude: -80.16392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16412',
  },
  {
    city: 'Fairview',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 167.2,
    imprecise: false,
    latitude: 42.03122,
    longitude: -80.22873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16415',
  },
  {
    city: 'Garland',
    county_fips: 42123,
    county_fips_all: '42123',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"42123": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 41.82606,
    longitude: -79.47311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16416',
  },
  {
    city: 'Girard',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 69.2,
    imprecise: false,
    latitude: 41.97107,
    longitude: -80.31039,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16417',
  },
  {
    city: 'Grand Valley',
    county_fips: 42123,
    county_fips_all: '42123',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"42123": 100}',
    density: 4,
    imprecise: false,
    latitude: 41.69481,
    longitude: -79.54544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16420',
  },
  {
    city: 'Harborcreek',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 83.8,
    imprecise: false,
    latitude: 42.17036,
    longitude: -79.9351,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16421',
  },
  {
    city: 'Harmonsburg',
    county_fips: 42039,
    county_fips_all: '42039',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"42039": 100}',
    density: 26.6,
    imprecise: false,
    latitude: 41.66555,
    longitude: -80.31447,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 95,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16422',
  },
  {
    city: 'Lake City',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 162.6,
    imprecise: false,
    latitude: 42.01881,
    longitude: -80.34253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16423',
  },
  {
    city: 'Linesville',
    county_fips: 42039,
    county_fips_all: '42039',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"42039": 100}',
    density: 24.7,
    imprecise: false,
    latitude: 41.65887,
    longitude: -80.44175,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16424',
  },
  {
    city: 'McKean',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 44,
    imprecise: false,
    latitude: 41.98121,
    longitude: -80.13937,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16426',
  },
  {
    city: 'Mill Village',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 313.9,
    imprecise: false,
    latitude: 41.87466,
    longitude: -79.97132,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16427',
  },
  {
    city: 'North East',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 66.1,
    imprecise: false,
    latitude: 42.17109,
    longitude: -79.82907,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16428',
  },
  {
    city: 'North Springfield',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 23.5,
    imprecise: false,
    latitude: 42.00413,
    longitude: -80.41823,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16430',
  },
  {
    city: 'Saegertown',
    county_fips: 42039,
    county_fips_all: '42039',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"42039": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 41.73553,
    longitude: -80.14316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16433',
  },
  {
    city: 'Spartansburg',
    county_fips: 42039,
    county_fips_all: '42039|42123',
    county: 'Crawford',
    county_names_all: 'Crawford|Warren',
    county_weights: '{"42039": 82.96, "42123": 17.04}',
    density: 19.2,
    imprecise: false,
    latitude: 41.79442,
    longitude: -79.66765,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16434',
  },
  {
    city: 'Springboro',
    county_fips: 42039,
    county_fips_all: '42039|42049',
    county: 'Crawford',
    county_names_all: 'Crawford|Erie',
    county_weights: '{"42039": 99.53, "42049": 0.47}',
    density: 12.2,
    imprecise: false,
    latitude: 41.81937,
    longitude: -80.38356,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16435',
  },
  {
    city: 'Spring Creek',
    county_fips: 42123,
    county_fips_all: '42123',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"42123": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 41.85563,
    longitude: -79.49889,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16436',
  },
  {
    city: 'Union City',
    county_fips: 42049,
    county_fips_all: '42049|42039',
    county: 'Erie',
    county_names_all: 'Erie|Crawford',
    county_weights: '{"42049": 68.95, "42039": 31.05}',
    density: 28,
    imprecise: false,
    latitude: 41.89084,
    longitude: -79.84709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16438',
  },
  {
    city: 'Venango',
    county_fips: 42039,
    county_fips_all: '42039',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"42039": 100}',
    density: 29.1,
    imprecise: false,
    latitude: 41.78673,
    longitude: -80.13088,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16440',
  },
  {
    city: 'Waterford',
    county_fips: 42049,
    county_fips_all: '42049|42039',
    county: 'Erie',
    county_names_all: 'Erie|Crawford',
    county_weights: '{"42049": 97.11, "42039": 2.89}',
    density: 32,
    imprecise: false,
    latitude: 41.9554,
    longitude: -79.98552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16441',
  },
  {
    city: 'Wattsburg',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 42.04094,
    longitude: -79.82631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16442',
  },
  {
    city: 'West Springfield',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 36.3,
    imprecise: false,
    latitude: 41.93745,
    longitude: -80.47831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16443',
  },
  {
    city: 'Erie',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 1090.7,
    imprecise: false,
    latitude: 42.12096,
    longitude: -80.08958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16501',
  },
  {
    city: 'Erie',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 2491,
    imprecise: false,
    latitude: 42.11073,
    longitude: -80.10123,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16502',
  },
  {
    city: 'Erie',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 2497.6,
    imprecise: false,
    latitude: 42.12718,
    longitude: -80.06103,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16503',
  },
  {
    city: 'Erie',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 2230.6,
    imprecise: false,
    latitude: 42.10942,
    longitude: -80.0489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16504',
  },
  {
    city: 'Erie',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 505.7,
    imprecise: false,
    latitude: 42.11789,
    longitude: -80.14304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16505',
  },
  {
    city: 'Erie',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 684.3,
    imprecise: false,
    latitude: 42.06449,
    longitude: -80.15472,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16506',
  },
  {
    city: 'Erie',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 1587.3,
    imprecise: false,
    latitude: 42.13575,
    longitude: -80.08743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16507',
  },
  {
    city: 'Erie',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 2059.8,
    imprecise: false,
    latitude: 42.09719,
    longitude: -80.09249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16508',
  },
  {
    city: 'Erie',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 289,
    imprecise: false,
    latitude: 42.05861,
    longitude: -80.04419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16509',
  },
  {
    city: 'Erie',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 283.4,
    imprecise: false,
    latitude: 42.11184,
    longitude: -79.95395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16510',
  },
  {
    city: 'Erie',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 615.4,
    imprecise: false,
    latitude: 42.16529,
    longitude: -79.99667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16511',
  },
  {
    city: 'Altoona',
    county_fips: 42013,
    county_fips_all: '42013',
    county: 'Blair',
    county_names_all: 'Blair',
    county_weights: '{"42013": 100}',
    density: 152.5,
    imprecise: false,
    latitude: 40.55338,
    longitude: -78.37283,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16601',
  },
  {
    city: 'Altoona',
    county_fips: 42013,
    county_fips_all: '42013',
    county: 'Blair',
    county_names_all: 'Blair',
    county_weights: '{"42013": 100}',
    density: 693,
    imprecise: false,
    latitude: 40.51491,
    longitude: -78.37052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16602',
  },
  {
    city: 'Alexandria',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 40.56719,
    longitude: -78.10214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16611',
  },
  {
    city: 'Ashville',
    county_fips: 42021,
    county_fips_all: '42021|42013',
    county: 'Cambria',
    county_names_all: 'Cambria|Blair',
    county_weights: '{"42021": 68.09, "42013": 31.91}',
    density: 20.3,
    imprecise: false,
    latitude: 40.53723,
    longitude: -78.53214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16613',
  },
  {
    city: 'Beccaria',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 23.9,
    imprecise: false,
    latitude: 40.76832,
    longitude: -78.45128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16616',
  },
  {
    city: 'Bellwood',
    county_fips: 42013,
    county_fips_all: '42013',
    county: 'Blair',
    county_names_all: 'Blair',
    county_weights: '{"42013": 100}',
    density: 624.2,
    imprecise: false,
    latitude: 40.6036,
    longitude: -78.32995,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16617',
  },
  {
    city: 'Blandburg',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 313.5,
    imprecise: false,
    latitude: 40.68367,
    longitude: -78.41591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16619',
  },
  {
    city: 'Brisbin',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 177.2,
    imprecise: false,
    latitude: 40.83947,
    longitude: -78.35259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16620',
  },
  {
    city: 'Broad Top',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 40.22888,
    longitude: -78.12298,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16621',
  },
  {
    city: 'Calvin',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 40.32853,
    longitude: -78.0692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 82,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16622',
  },
  {
    city: 'Cassville',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 17,
    imprecise: false,
    latitude: 40.27618,
    longitude: -78.04556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16623',
  },
  {
    city: 'Chest Springs',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 33.6,
    imprecise: false,
    latitude: 40.5651,
    longitude: -78.60664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16624',
  },
  {
    city: 'Claysburg',
    county_fips: 42013,
    county_fips_all: '42013|42009',
    county: 'Blair',
    county_names_all: 'Blair|Bedford',
    county_weights: '{"42013": 58.16, "42009": 41.84}',
    density: 37.9,
    imprecise: false,
    latitude: 40.28482,
    longitude: -78.50855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16625',
  },
  {
    city: 'Coalport',
    county_fips: 42033,
    county_fips_all: '42033|42021',
    county: 'Clearfield',
    county_names_all: 'Clearfield|Cambria',
    county_weights: '{"42033": 87.38, "42021": 12.62}',
    density: 23,
    imprecise: false,
    latitude: 40.75272,
    longitude: -78.50036,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16627',
  },
  {
    city: 'Cresson',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 320.1,
    imprecise: false,
    latitude: 40.46231,
    longitude: -78.58003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16630',
  },
  {
    city: 'Curryville',
    county_fips: 42013,
    county_fips_all: '42013',
    county: 'Blair',
    county_names_all: 'Blair',
    county_weights: '{"42013": 100}',
    density: 42.2,
    imprecise: false,
    latitude: 40.27141,
    longitude: -78.34754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16631',
  },
  {
    city: 'Defiance',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 819.5,
    imprecise: false,
    latitude: 40.15969,
    longitude: -78.23259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16633',
  },
  {
    city: 'Dudley',
    county_fips: 42061,
    county_fips_all: '42061|42009',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon|Bedford',
    county_weights: '{"42061": 99.5, "42009": 0.5}',
    density: 30.8,
    imprecise: false,
    latitude: 40.2105,
    longitude: -78.17308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16634',
  },
  {
    city: 'Duncansville',
    county_fips: 42013,
    county_fips_all: '42013',
    county: 'Blair',
    county_names_all: 'Blair',
    county_weights: '{"42013": 100}',
    density: 81.6,
    imprecise: false,
    latitude: 40.41621,
    longitude: -78.48743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16635',
  },
  {
    city: 'Dysart',
    county_fips: 42021,
    county_fips_all: '42021|42013',
    county: 'Cambria',
    county_names_all: 'Cambria|Blair',
    county_weights: '{"42021": 95.03, "42013": 4.97}',
    density: 11.1,
    imprecise: false,
    latitude: 40.60214,
    longitude: -78.50161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16636',
  },
  {
    city: 'East Freedom',
    county_fips: 42013,
    county_fips_all: '42013',
    county: 'Blair',
    county_names_all: 'Blair',
    county_weights: '{"42013": 100}',
    density: 46.2,
    imprecise: false,
    latitude: 40.34214,
    longitude: -78.47079,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16637',
  },
  {
    city: 'Fallentimber',
    county_fips: 42021,
    county_fips_all: '42021|42033',
    county: 'Cambria',
    county_names_all: 'Cambria|Clearfield',
    county_weights: '{"42021": 88.66, "42033": 11.34}',
    density: 11.4,
    imprecise: false,
    latitude: 40.68566,
    longitude: -78.44912,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16639',
  },
  {
    city: 'Flinton',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 40.70657,
    longitude: -78.5702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16640',
  },
  {
    city: 'Gallitzin',
    county_fips: 42021,
    county_fips_all: '42021|42013',
    county: 'Cambria',
    county_names_all: 'Cambria|Blair',
    county_weights: '{"42021": 93.21, "42013": 6.79}',
    density: 69.7,
    imprecise: false,
    latitude: 40.50774,
    longitude: -78.57146,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16641',
  },
  {
    city: 'Glen Hope',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 41.4,
    imprecise: false,
    latitude: 40.80204,
    longitude: -78.49932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16645',
  },
  {
    city: 'Hastings',
    county_fips: 42021,
    county_fips_all: '42021|42033',
    county: 'Cambria',
    county_names_all: 'Cambria|Clearfield',
    county_weights: '{"42021": 98.64, "42033": 1.36}',
    density: 46.5,
    imprecise: false,
    latitude: 40.68291,
    longitude: -78.71579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16646',
  },
  {
    city: 'Hesston',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 40.39514,
    longitude: -78.09798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16647',
  },
  {
    city: 'Hollidaysburg',
    county_fips: 42013,
    county_fips_all: '42013',
    county: 'Blair',
    county_names_all: 'Blair',
    county_weights: '{"42013": 100}',
    density: 95.8,
    imprecise: false,
    latitude: 40.44231,
    longitude: -78.33242,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16648',
  },
  {
    city: 'Hopewell',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 40.11592,
    longitude: -78.29237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16650',
  },
  {
    city: 'Houtzdale',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 53.6,
    imprecise: false,
    latitude: 40.8505,
    longitude: -78.37945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16651',
  },
  {
    city: 'Huntingdon',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 35.3,
    imprecise: false,
    latitude: 40.51692,
    longitude: -77.95302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16652',
  },
  {
    city: 'Imler',
    county_fips: 42009,
    county_fips_all: '42009|42013|42021',
    county: 'Bedford',
    county_names_all: 'Bedford|Blair|Cambria',
    county_weights: '{"42009": 97.12, "42013": 2.1, "42021": 0.78}',
    density: 17,
    imprecise: false,
    latitude: 40.24898,
    longitude: -78.55092,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16655',
  },
  {
    city: 'Irvona',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 40.8066,
    longitude: -78.56353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16656',
  },
  {
    city: 'James Creek',
    county_fips: 42061,
    county_fips_all: '42061|42009',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon|Bedford',
    county_weights: '{"42061": 98.09, "42009": 1.91}',
    density: 9.1,
    imprecise: false,
    latitude: 40.32486,
    longitude: -78.17757,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16657',
  },
  {
    city: 'Loysburg',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 60,
    imprecise: false,
    latitude: 40.16063,
    longitude: -78.39138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16659',
  },
  {
    city: 'Madera',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 16,
    imprecise: false,
    latitude: 40.83058,
    longitude: -78.45026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16661',
  },
  {
    city: 'Martinsburg',
    county_fips: 42013,
    county_fips_all: '42013|42009',
    county: 'Blair',
    county_names_all: 'Blair|Bedford',
    county_weights: '{"42013": 84.95, "42009": 15.05}',
    density: 43.5,
    imprecise: false,
    latitude: 40.30635,
    longitude: -78.29961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16662',
  },
  {
    city: 'New Enterprise',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 40.17822,
    longitude: -78.42437,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16664',
  },
  {
    city: 'Newry',
    county_fips: 42013,
    county_fips_all: '42013',
    county: 'Blair',
    county_names_all: 'Blair',
    county_weights: '{"42013": 100}',
    density: 209.3,
    imprecise: false,
    latitude: 40.38898,
    longitude: -78.43491,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16665',
  },
  {
    city: 'Osceola Mills',
    county_fips: 42033,
    county_fips_all: '42033|42027',
    county: 'Clearfield',
    county_names_all: 'Clearfield|Centre',
    county_weights: '{"42033": 89.31, "42027": 10.69}',
    density: 49.4,
    imprecise: false,
    latitude: 40.87056,
    longitude: -78.31286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16666',
  },
  {
    city: 'Osterburg',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 40.18213,
    longitude: -78.52546,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16667',
  },
  {
    city: 'Patton',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 25.5,
    imprecise: false,
    latitude: 40.65072,
    longitude: -78.61974,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16668',
  },
  {
    city: 'Petersburg',
    county_fips: 42061,
    county_fips_all: '42061|42027',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon|Centre',
    county_weights: '{"42061": 99.9, "42027": 0.1}',
    density: 7.7,
    imprecise: false,
    latitude: 40.65737,
    longitude: -77.90675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16669',
  },
  {
    city: 'Ramey',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 65,
    imprecise: false,
    latitude: 40.79414,
    longitude: -78.40203,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16671',
  },
  {
    city: 'Riddlesburg',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 40.16935,
    longitude: -78.24324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16672',
  },
  {
    city: 'Roaring Spring',
    county_fips: 42013,
    county_fips_all: '42013|42009',
    county: 'Blair',
    county_names_all: 'Blair|Bedford',
    county_weights: '{"42013": 62.14, "42009": 37.86}',
    density: 58.4,
    imprecise: false,
    latitude: 40.30671,
    longitude: -78.39026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16673',
  },
  {
    city: 'Robertsdale',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 40.1865,
    longitude: -78.07926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16674',
  },
  {
    city: 'Saint Boniface',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 40.68796,
    longitude: -78.67905,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 88,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16675',
  },
  {
    city: 'Sandy Ridge',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 30.6,
    imprecise: false,
    latitude: 40.81507,
    longitude: -78.2457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16677',
  },
  {
    city: 'Saxton',
    county_fips: 42009,
    county_fips_all: '42009|42061',
    county: 'Bedford',
    county_names_all: 'Bedford|Huntingdon',
    county_weights: '{"42009": 54.56, "42061": 45.44}',
    density: 19.5,
    imprecise: false,
    latitude: 40.2252,
    longitude: -78.23421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16678',
  },
  {
    city: 'Six Mile Run',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 40.15659,
    longitude: -78.195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16679',
  },
  {
    city: 'Smithmill',
    county_fips: 42033,
    county_fips_all: '42033|42027',
    county: 'Clearfield',
    county_names_all: 'Clearfield|Centre',
    county_weights: '{"42033": 99.18, "42027": 0.82}',
    density: 18.8,
    imprecise: false,
    latitude: 40.75149,
    longitude: -78.40254,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16680',
  },
  {
    city: 'Sproul',
    county_fips: 42013,
    county_fips_all: '42013',
    county: 'Blair',
    county_names_all: 'Blair',
    county_weights: '{"42013": 100}',
    density: 2013.2,
    imprecise: false,
    latitude: 40.27206,
    longitude: -78.4565,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16682',
  },
  {
    city: 'Spruce Creek',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 7,
    imprecise: false,
    latitude: 40.65595,
    longitude: -78.07313,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16683',
  },
  {
    city: 'Tipton',
    county_fips: 42013,
    county_fips_all: '42013',
    county: 'Blair',
    county_names_all: 'Blair',
    county_weights: '{"42013": 100}',
    density: 951,
    imprecise: false,
    latitude: 40.63541,
    longitude: -78.29685,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16684',
  },
  {
    city: 'Todd',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 40.28019,
    longitude: -78.08063,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16685',
  },
  {
    city: 'Tyrone',
    county_fips: 42013,
    county_fips_all: '42013|42061|42027',
    county: 'Blair',
    county_names_all: 'Blair|Huntingdon|Centre',
    county_weights: '{"42013": 68.5, "42061": 24.72, "42027": 6.78}',
    density: 35.3,
    imprecise: false,
    latitude: 40.67056,
    longitude: -78.24102,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16686',
  },
  {
    city: 'Waterfall',
    county_fips: 42057,
    county_fips_all: '42057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"42057": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 40.10737,
    longitude: -78.10028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16689',
  },
  {
    city: 'Wells Tannery',
    county_fips: 42057,
    county_fips_all: '42057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"42057": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 40.07744,
    longitude: -78.1473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16691',
  },
  {
    city: 'Westover',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 18,
    imprecise: false,
    latitude: 40.75935,
    longitude: -78.72053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16692',
  },
  {
    city: 'Williamsburg',
    county_fips: 42013,
    county_fips_all: '42013',
    county: 'Blair',
    county_names_all: 'Blair',
    county_weights: '{"42013": 100}',
    density: 19,
    imprecise: false,
    latitude: 40.46519,
    longitude: -78.21593,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16693',
  },
  {
    city: 'Wood',
    county_fips: 42061,
    county_fips_all: '42061|42009|42057',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon|Bedford|Fulton',
    county_weights: '{"42061": 84.23, "42009": 14.16, "42057": 1.61}',
    density: 33,
    imprecise: false,
    latitude: 40.17259,
    longitude: -78.12852,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16694',
  },
  {
    city: 'Woodbury',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 40.20327,
    longitude: -78.35943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16695',
  },
  {
    city: 'Bradford',
    county_fips: 42083,
    county_fips_all: '42083|42123',
    county: 'McKean',
    county_names_all: 'McKean|Warren',
    county_weights: '{"42083": 92.18, "42123": 7.82}',
    density: 29.1,
    imprecise: false,
    latitude: 41.91105,
    longitude: -78.77385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16701',
  },
  {
    city: 'Austin',
    county_fips: 42105,
    county_fips_all: '42105|42023|42083',
    county: 'Potter',
    county_names_all: 'Potter|Cameron|McKean',
    county_weights: '{"42105": 85.26, "42023": 10.55, "42083": 4.19}',
    density: 1.8,
    imprecise: false,
    latitude: 41.5793,
    longitude: -78.02599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16720',
  },
  {
    city: 'Crosby',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 71.5,
    imprecise: false,
    latitude: 41.74674,
    longitude: -78.39022,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16724',
  },
  {
    city: 'Custer City',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 56.5,
    imprecise: false,
    latitude: 41.89881,
    longitude: -78.66328,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16725',
  },
  {
    city: 'Cyclone',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 41.80456,
    longitude: -78.57787,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16726',
  },
  {
    city: 'Derrick City',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 41.98501,
    longitude: -78.5338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16727',
  },
  {
    city: 'Duke Center',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 41.96501,
    longitude: -78.4788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16729',
  },
  {
    city: 'East Smethport',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 41.81339,
    longitude: -78.42309,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16730',
  },
  {
    city: 'Eldred',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 41.94625,
    longitude: -78.37126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16731',
  },
  {
    city: 'Gifford',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 41.85921,
    longitude: -78.60843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16732',
  },
  {
    city: 'Hazel Hurst',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 41.70303,
    longitude: -78.59514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16733',
  },
  {
    city: 'James City',
    county_fips: 42047,
    county_fips_all: '42047',
    county: 'Elk',
    county_names_all: 'Elk',
    county_weights: '{"42047": 100}',
    density: 95.9,
    imprecise: false,
    latitude: 41.61806,
    longitude: -78.84418,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16734',
  },
  {
    city: 'Kane',
    county_fips: 42083,
    county_fips_all: '42083|42047',
    county: 'McKean',
    county_names_all: 'McKean|Elk',
    county_weights: '{"42083": 60.69, "42047": 39.31}',
    density: 9,
    imprecise: false,
    latitude: 41.63045,
    longitude: -78.81,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16735',
  },
  {
    city: 'Lewis Run',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 41.80511,
    longitude: -78.73929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16738',
  },
  {
    city: 'Mount Jewett',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 41.69255,
    longitude: -78.54998,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16740',
  },
  {
    city: 'Port Allegany',
    county_fips: 42083,
    county_fips_all: '42083|42105',
    county: 'McKean',
    county_names_all: 'McKean|Potter',
    county_weights: '{"42083": 88.47, "42105": 11.53}',
    density: 15.5,
    imprecise: false,
    latitude: 41.7888,
    longitude: -78.26016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16743',
  },
  {
    city: 'Rew',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 41.87567,
    longitude: -78.56941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16744',
  },
  {
    city: 'Rixford',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 41.92578,
    longitude: -78.49042,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16745',
  },
  {
    city: 'Roulette',
    county_fips: 42105,
    county_fips_all: '42105',
    county: 'Potter',
    county_names_all: 'Potter',
    county_weights: '{"42105": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 41.79064,
    longitude: -78.13858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16746',
  },
  {
    city: 'Shinglehouse',
    county_fips: 42105,
    county_fips_all: '42105|42083',
    county: 'Potter',
    county_names_all: 'Potter|McKean',
    county_weights: '{"42105": 76.62, "42083": 23.38}',
    density: 10.3,
    imprecise: false,
    latitude: 41.9427,
    longitude: -78.14425,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16748',
  },
  {
    city: 'Smethport',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 41.75578,
    longitude: -78.4214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16749',
  },
  {
    city: 'Turtlepoint',
    county_fips: 42083,
    county_fips_all: '42083',
    county: 'McKean',
    county_names_all: 'McKean',
    county_weights: '{"42083": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 41.88796,
    longitude: -78.29682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16750',
  },
  {
    city: 'State College',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 506.6,
    imprecise: false,
    latitude: 40.78538,
    longitude: -77.84214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16801',
  },
  {
    city: 'University Park',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 7448.5,
    imprecise: false,
    latitude: 40.79867,
    longitude: -77.86481,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16802',
  },
  {
    city: 'State College',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 402.7,
    imprecise: false,
    latitude: 40.80849,
    longitude: -77.89449,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16803',
  },
  {
    city: 'Aaronsburg',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 35,
    imprecise: false,
    latitude: 40.91995,
    longitude: -77.38702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16820',
  },
  {
    city: 'Allport',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 26.1,
    imprecise: false,
    latitude: 40.95888,
    longitude: -78.19875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16821',
  },
  {
    city: 'Beech Creek',
    county_fips: 42035,
    county_fips_all: '42035|42027',
    county: 'Clinton',
    county_names_all: 'Clinton|Centre',
    county_weights: '{"42035": 95.72, "42027": 4.28}',
    density: 6.8,
    imprecise: false,
    latitude: 41.15813,
    longitude: -77.71441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16822',
  },
  {
    city: 'Bellefonte',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 90.5,
    imprecise: false,
    latitude: 40.92734,
    longitude: -77.76685,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16823',
  },
  {
    city: 'Bigler',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 114.6,
    imprecise: false,
    latitude: 40.98803,
    longitude: -78.31208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16825',
  },
  {
    city: 'Blanchard',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 96.7,
    imprecise: false,
    latitude: 41.06199,
    longitude: -77.58598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16826',
  },
  {
    city: 'Boalsburg',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 109,
    imprecise: false,
    latitude: 40.76607,
    longitude: -77.77739,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16827',
  },
  {
    city: 'Centre Hall',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 34.7,
    imprecise: false,
    latitude: 40.80704,
    longitude: -77.69097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16828',
  },
  {
    city: 'Clarence',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 41.08223,
    longitude: -77.89386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16829',
  },
  {
    city: 'Clearfield',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 41.08569,
    longitude: -78.43317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16830',
  },
  {
    city: 'Coburn',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 4,
    imprecise: false,
    latitude: 40.84711,
    longitude: -77.4347,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16832',
  },
  {
    city: 'Curwensville',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 27.8,
    imprecise: false,
    latitude: 40.94158,
    longitude: -78.57862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16833',
  },
  {
    city: 'Drifting',
    county_fips: 42033,
    county_fips_all: '42033|42027',
    county: 'Clearfield',
    county_names_all: 'Clearfield|Centre',
    county_weights: '{"42033": 99.25, "42027": 0.75}',
    density: 15.5,
    imprecise: false,
    latitude: 41.0391,
    longitude: -78.10389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16834',
  },
  {
    city: 'Fleming',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 381.8,
    imprecise: false,
    latitude: 40.90668,
    longitude: -77.87731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16835',
  },
  {
    city: 'Frenchville',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 41.14633,
    longitude: -78.26454,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16836',
  },
  {
    city: 'Glen Richey',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 37,
    imprecise: false,
    latitude: 40.94576,
    longitude: -78.47494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16837',
  },
  {
    city: 'Grampian',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 40.98923,
    longitude: -78.64292,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16838',
  },
  {
    city: 'Grassflat',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 136.2,
    imprecise: false,
    latitude: 41.00319,
    longitude: -78.11113,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16839',
  },
  {
    city: 'Hawk Run',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 532.5,
    imprecise: false,
    latitude: 40.92555,
    longitude: -78.20214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16840',
  },
  {
    city: 'Howard',
    county_fips: 42027,
    county_fips_all: '42027|42035',
    county: 'Centre',
    county_names_all: 'Centre|Clinton',
    county_weights: '{"42027": 98.65, "42035": 1.35}',
    density: 20.6,
    imprecise: false,
    latitude: 41.03399,
    longitude: -77.69011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16841',
  },
  {
    city: 'Hyde',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 87.9,
    imprecise: false,
    latitude: 41.00849,
    longitude: -78.46269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16843',
  },
  {
    city: 'Julian',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 40.91285,
    longitude: -77.93261,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16844',
  },
  {
    city: 'Karthaus',
    county_fips: 42027,
    county_fips_all: '42027|42033|42035',
    county: 'Centre',
    county_names_all: 'Centre|Clearfield|Clinton',
    county_weights: '{"42027": 63.45, "42033": 35.92, "42035": 0.63}',
    density: 3.9,
    imprecise: false,
    latitude: 41.15641,
    longitude: -78.02422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16845',
  },
  {
    city: 'Kylertown',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 69.5,
    imprecise: false,
    latitude: 40.99941,
    longitude: -78.16439,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16847',
  },
  {
    city: 'Lamar',
    county_fips: 42035,
    county_fips_all: '42035',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"42035": 100}',
    density: 335.6,
    imprecise: false,
    latitude: 41.01247,
    longitude: -77.53455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16848',
  },
  {
    city: 'Lanse',
    county_fips: 42033,
    county_fips_all: '42033|42027',
    county: 'Clearfield',
    county_names_all: 'Clearfield|Centre',
    county_weights: '{"42033": 98.25, "42027": 1.75}',
    density: 14.6,
    imprecise: false,
    latitude: 40.95978,
    longitude: -78.11431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16849',
  },
  {
    city: 'Lemont',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 201.8,
    imprecise: false,
    latitude: 40.81229,
    longitude: -77.80132,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16851',
  },
  {
    city: 'Madisonburg',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 20.3,
    imprecise: false,
    latitude: 40.93639,
    longitude: -77.5386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16852',
  },
  {
    city: 'Milesburg',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 452.4,
    imprecise: false,
    latitude: 40.94045,
    longitude: -77.78638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16853',
  },
  {
    city: 'Millheim',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 133.2,
    imprecise: false,
    latitude: 40.89697,
    longitude: -77.47228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16854',
  },
  {
    city: 'Mineral Springs',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 35.5,
    imprecise: false,
    latitude: 40.99902,
    longitude: -78.36046,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16855',
  },
  {
    city: 'Mingoville',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 204.5,
    imprecise: false,
    latitude: 40.92871,
    longitude: -77.65005,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16856',
  },
  {
    city: 'Morrisdale',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 28.1,
    imprecise: false,
    latitude: 41.00056,
    longitude: -78.20033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16858',
  },
  {
    city: 'Moshannon',
    county_fips: 42027,
    county_fips_all: '42027|42033',
    county: 'Centre',
    county_names_all: 'Centre|Clearfield',
    county_weights: '{"42027": 99.84, "42033": 0.16}',
    density: 6.4,
    imprecise: false,
    latitude: 41.04903,
    longitude: -78.03519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16859',
  },
  {
    city: 'Munson',
    county_fips: 42033,
    county_fips_all: '42033|42027',
    county: 'Clearfield',
    county_names_all: 'Clearfield|Centre',
    county_weights: '{"42033": 76.82, "42027": 23.18}',
    density: 27.2,
    imprecise: false,
    latitude: 40.94673,
    longitude: -78.17219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16860',
  },
  {
    city: 'New Millport',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 9,
    imprecise: false,
    latitude: 40.86764,
    longitude: -78.51991,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16861',
  },
  {
    city: 'Olanta',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 40.91162,
    longitude: -78.47204,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16863',
  },
  {
    city: 'Orviston',
    county_fips: 42027,
    county_fips_all: '42027|42035',
    county: 'Centre',
    county_names_all: 'Centre|Clinton',
    county_weights: '{"42027": 87.05, "42035": 12.95}',
    density: 4,
    imprecise: false,
    latitude: 41.15428,
    longitude: -77.79857,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16864',
  },
  {
    city: 'Pennsylvania Furnace',
    county_fips: 42027,
    county_fips_all: '42027|42061',
    county: 'Centre',
    county_names_all: 'Centre|Huntingdon',
    county_weights: '{"42027": 84.25, "42061": 15.75}',
    density: 30.6,
    imprecise: false,
    latitude: 40.72086,
    longitude: -77.96396,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16865',
  },
  {
    city: 'Philipsburg',
    county_fips: 42027,
    county_fips_all: '42027|42033',
    county: 'Centre',
    county_names_all: 'Centre|Clearfield',
    county_weights: '{"42027": 90.42, "42033": 9.58}',
    density: 22.5,
    imprecise: false,
    latitude: 40.86684,
    longitude: -78.17163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16866',
  },
  {
    city: 'Pine Grove Mills',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 267.2,
    imprecise: false,
    latitude: 40.72725,
    longitude: -77.89066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16868',
  },
  {
    city: 'Port Matilda',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 40.1,
    imprecise: false,
    latitude: 40.80149,
    longitude: -78.04969,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16870',
  },
  {
    city: 'Pottersdale',
    county_fips: 42035,
    county_fips_all: '42035|42033',
    county: 'Clinton',
    county_names_all: 'Clinton|Clearfield',
    county_weights: '{"42035": 74.49, "42033": 25.51}',
    density: 0.5,
    imprecise: false,
    latitude: 41.1879,
    longitude: -78.03705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16871',
  },
  {
    city: 'Rebersburg',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 40.96715,
    longitude: -77.35939,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16872',
  },
  {
    city: 'Snow Shoe',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 41.01141,
    longitude: -77.94077,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16874',
  },
  {
    city: 'Spring Mills',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 40.84536,
    longitude: -77.56882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16875',
  },
  {
    city: 'Wallaceton',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 100.8,
    imprecise: false,
    latitude: 40.96648,
    longitude: -78.29087,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16876',
  },
  {
    city: 'Warriors Mark',
    county_fips: 42027,
    county_fips_all: '42027|42061',
    county: 'Centre',
    county_names_all: 'Centre|Huntingdon',
    county_weights: '{"42027": 58.55, "42061": 41.45}',
    density: 20.8,
    imprecise: false,
    latitude: 40.73291,
    longitude: -78.06846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16877',
  },
  {
    city: 'West Decatur',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 24,
    imprecise: false,
    latitude: 40.94325,
    longitude: -78.33609,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16878',
  },
  {
    city: 'Winburne',
    county_fips: 42033,
    county_fips_all: '42033|42027',
    county: 'Clearfield',
    county_names_all: 'Clearfield|Centre',
    county_weights: '{"42033": 99.55, "42027": 0.45}',
    density: 91.7,
    imprecise: false,
    latitude: 40.97116,
    longitude: -78.15162,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16879',
  },
  {
    city: 'Woodland',
    county_fips: 42033,
    county_fips_all: '42033',
    county: 'Clearfield',
    county_names_all: 'Clearfield',
    county_weights: '{"42033": 100}',
    density: 30.4,
    imprecise: false,
    latitude: 41.02743,
    longitude: -78.31119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16881',
  },
  {
    city: 'Woodward',
    county_fips: 42027,
    county_fips_all: '42027',
    county: 'Centre',
    county_names_all: 'Centre',
    county_weights: '{"42027": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 40.90707,
    longitude: -77.33841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16882',
  },
  {
    city: 'Wellsboro',
    county_fips: 42117,
    county_fips_all: '42117',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"42117": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 41.73038,
    longitude: -77.31841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16901',
  },
  {
    city: 'Alba',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 201.1,
    imprecise: false,
    latitude: 41.70477,
    longitude: -76.83124,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16910',
  },
  {
    city: 'Arnot',
    county_fips: 42117,
    county_fips_all: '42117',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"42117": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 41.67787,
    longitude: -77.10392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16911',
  },
  {
    city: 'Blossburg',
    county_fips: 42117,
    county_fips_all: '42117',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"42117": 100}',
    density: 43.5,
    imprecise: false,
    latitude: 41.66803,
    longitude: -77.05845,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16912',
  },
  {
    city: 'Columbia Cross Roads',
    county_fips: 42015,
    county_fips_all: '42015|42117',
    county: 'Bradford',
    county_names_all: 'Bradford|Tioga',
    county_weights: '{"42015": 93.19, "42117": 6.81}',
    density: 11.7,
    imprecise: false,
    latitude: 41.8618,
    longitude: -76.77687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16914',
  },
  {
    city: 'Coudersport',
    county_fips: 42105,
    county_fips_all: '42105',
    county: 'Potter',
    county_names_all: 'Potter',
    county_weights: '{"42105": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 41.77481,
    longitude: -77.96104,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16915',
  },
  {
    city: 'Covington',
    county_fips: 42117,
    county_fips_all: '42117',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"42117": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 41.723,
    longitude: -77.05519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16917',
  },
  {
    city: 'Elkland',
    county_fips: 42117,
    county_fips_all: '42117',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"42117": 100}',
    density: 71.5,
    imprecise: false,
    latitude: 41.98218,
    longitude: -77.28851,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16920',
  },
  {
    city: 'Gaines',
    county_fips: 42117,
    county_fips_all: '42117|42105',
    county: 'Tioga',
    county_names_all: 'Tioga|Potter',
    county_weights: '{"42117": 98.67, "42105": 1.33}',
    density: 2.8,
    imprecise: false,
    latitude: 41.69614,
    longitude: -77.54654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16921',
  },
  {
    city: 'Galeton',
    county_fips: 42105,
    county_fips_all: '42105',
    county: 'Potter',
    county_names_all: 'Potter',
    county_weights: '{"42105": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 41.67191,
    longitude: -77.70064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16922',
  },
  {
    city: 'Genesee',
    county_fips: 42105,
    county_fips_all: '42105',
    county: 'Potter',
    county_names_all: 'Potter',
    county_weights: '{"42105": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 41.94103,
    longitude: -77.8761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16923',
  },
  {
    city: 'Gillett',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 41.95319,
    longitude: -76.78997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16925',
  },
  {
    city: 'Granville Summit',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 41.71506,
    longitude: -76.70485,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16926',
  },
  {
    city: 'Harrison Valley',
    county_fips: 42105,
    county_fips_all: '42105',
    county: 'Potter',
    county_names_all: 'Potter',
    county_weights: '{"42105": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 41.9655,
    longitude: -77.65941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16927',
  },
  {
    city: 'Knoxville',
    county_fips: 42117,
    county_fips_all: '42117',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"42117": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 41.95203,
    longitude: -77.43371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16928',
  },
  {
    city: 'Lawrenceville',
    county_fips: 42117,
    county_fips_all: '42117',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"42117": 100}',
    density: 24.1,
    imprecise: false,
    latitude: 41.97352,
    longitude: -77.15028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16929',
  },
  {
    city: 'Liberty',
    county_fips: 42117,
    county_fips_all: '42117|42081',
    county: 'Tioga',
    county_names_all: 'Tioga|Lycoming',
    county_weights: '{"42117": 74.47, "42081": 25.53}',
    density: 6.8,
    imprecise: false,
    latitude: 41.57693,
    longitude: -77.14021,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16930',
  },
  {
    city: 'Mainesburg',
    county_fips: 42117,
    county_fips_all: '42117',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"42117": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 41.77574,
    longitude: -76.94017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16932',
  },
  {
    city: 'Mansfield',
    county_fips: 42117,
    county_fips_all: '42117',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"42117": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 41.81904,
    longitude: -77.06716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16933',
  },
  {
    city: 'Middlebury Center',
    county_fips: 42117,
    county_fips_all: '42117',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"42117": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 41.87032,
    longitude: -77.32404,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16935',
  },
  {
    city: 'Millerton',
    county_fips: 42117,
    county_fips_all: '42117|42015',
    county: 'Tioga',
    county_names_all: 'Tioga|Bradford',
    county_weights: '{"42117": 82.91, "42015": 17.09}',
    density: 15.7,
    imprecise: false,
    latitude: 41.94318,
    longitude: -76.95837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16936',
  },
  {
    city: 'Mills',
    county_fips: 42105,
    county_fips_all: '42105',
    county: 'Potter',
    county_names_all: 'Potter',
    county_weights: '{"42105": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 41.96421,
    longitude: -77.71004,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16937',
  },
  {
    city: 'Morris',
    county_fips: 42117,
    county_fips_all: '42117|42081',
    county: 'Tioga',
    county_names_all: 'Tioga|Lycoming',
    county_weights: '{"42117": 72.74, "42081": 27.26}',
    density: 3,
    imprecise: false,
    latitude: 41.56935,
    longitude: -77.34487,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16938',
  },
  {
    city: 'Morris Run',
    county_fips: 42117,
    county_fips_all: '42117',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"42117": 100}',
    density: 160.6,
    imprecise: false,
    latitude: 41.68097,
    longitude: -77.0141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16939',
  },
  {
    city: 'Nelson',
    county_fips: 42117,
    county_fips_all: '42117',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"42117": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 41.97752,
    longitude: -77.23373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16940',
  },
  {
    city: 'Genesee',
    county_fips: 42105,
    county_fips_all: '42105',
    county: 'Potter',
    county_names_all: 'Potter',
    county_weights: '{"42105": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 41.98841,
    longitude: -77.75796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16941',
  },
  {
    city: 'Osceola',
    county_fips: 42117,
    county_fips_all: '42117',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"42117": 100}',
    density: 16.1,
    imprecise: false,
    latitude: 41.9654,
    longitude: -77.35414,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16942',
  },
  {
    city: 'Sabinsville',
    county_fips: 42105,
    county_fips_all: '42105|42117',
    county: 'Potter',
    county_names_all: 'Potter|Tioga',
    county_weights: '{"42105": 58.61, "42117": 41.39}',
    density: 4.5,
    imprecise: false,
    latitude: 41.8406,
    longitude: -77.61915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16943',
  },
  {
    city: 'Tioga',
    county_fips: 42117,
    county_fips_all: '42117',
    county: 'Tioga',
    county_names_all: 'Tioga',
    county_weights: '{"42117": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 41.91422,
    longitude: -77.13999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16946',
  },
  {
    city: 'Troy',
    county_fips: 42015,
    county_fips_all: '42015|42117',
    county: 'Bradford',
    county_names_all: 'Bradford|Tioga',
    county_weights: '{"42015": 87.18, "42117": 12.82}',
    density: 16.5,
    imprecise: false,
    latitude: 41.76969,
    longitude: -76.79519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16947',
  },
  {
    city: 'Ulysses',
    county_fips: 42105,
    county_fips_all: '42105',
    county: 'Potter',
    county_names_all: 'Potter',
    county_weights: '{"42105": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 41.85369,
    longitude: -77.75683,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16948',
  },
  {
    city: 'Westfield',
    county_fips: 42117,
    county_fips_all: '42117|42105',
    county: 'Tioga',
    county_names_all: 'Tioga|Potter',
    county_weights: '{"42117": 83.29, "42105": 16.71}',
    density: 11.1,
    imprecise: false,
    latitude: 41.89816,
    longitude: -77.53429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16950',
  },
  {
    city: 'Allensville',
    county_fips: 42061,
    county_fips_all: '42061|42087',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon|Mifflin',
    county_weights: '{"42061": 82.31, "42087": 17.69}',
    density: 11.8,
    imprecise: false,
    latitude: 40.46463,
    longitude: -77.86761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17002',
  },
  {
    city: 'Annville',
    county_fips: 42075,
    county_fips_all: '42075',
    county: 'Lebanon',
    county_names_all: 'Lebanon',
    county_weights: '{"42075": 100}',
    density: 113.4,
    imprecise: false,
    latitude: 40.35735,
    longitude: -76.55528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17003',
  },
  {
    city: 'Belleville',
    county_fips: 42087,
    county_fips_all: '42087',
    county: 'Mifflin',
    county_names_all: 'Mifflin',
    county_weights: '{"42087": 100}',
    density: 42.1,
    imprecise: false,
    latitude: 40.59966,
    longitude: -77.73278,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17004',
  },
  {
    city: 'Berrysburg',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 198.2,
    imprecise: false,
    latitude: 40.60304,
    longitude: -76.81065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17005',
  },
  {
    city: 'Blain',
    county_fips: 42099,
    county_fips_all: '42099',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"42099": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 40.28495,
    longitude: -77.54364,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17006',
  },
  {
    city: 'Boiling Springs',
    county_fips: 42041,
    county_fips_all: '42041',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"42041": 100}',
    density: 126.5,
    imprecise: false,
    latitude: 40.13428,
    longitude: -77.11801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17007',
  },
  {
    city: 'Burnham',
    county_fips: 42087,
    county_fips_all: '42087',
    county: 'Mifflin',
    county_names_all: 'Mifflin',
    county_weights: '{"42087": 100}',
    density: 453.8,
    imprecise: false,
    latitude: 40.6359,
    longitude: -77.56609,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17009',
  },
  {
    city: 'Campbelltown',
    county_fips: 42075,
    county_fips_all: '42075',
    county: 'Lebanon',
    county_names_all: 'Lebanon',
    county_weights: '{"42075": 100}',
    density: 2955,
    imprecise: false,
    latitude: 40.27809,
    longitude: -76.58335,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17010',
  },
  {
    city: 'Camp Hill',
    county_fips: 42041,
    county_fips_all: '42041|42133',
    county: 'Cumberland',
    county_names_all: 'Cumberland|York',
    county_weights: '{"42041": 93.96, "42133": 6.04}',
    density: 1170.7,
    imprecise: false,
    latitude: 40.23508,
    longitude: -76.92931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17011',
  },
  {
    city: 'Carlisle',
    county_fips: 42041,
    county_fips_all: '42041',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"42041": 100}',
    density: 379.4,
    imprecise: false,
    latitude: 40.241,
    longitude: -77.19286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17013',
  },
  {
    city: 'Cocolamus',
    county_fips: 42067,
    county_fips_all: '42067',
    county: 'Juniata',
    county_names_all: 'Juniata',
    county_weights: '{"42067": 100}',
    density: 38.5,
    imprecise: false,
    latitude: 40.6596,
    longitude: -77.19358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17014',
  },
  {
    city: 'Carlisle',
    county_fips: 42041,
    county_fips_all: '42041',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"42041": 100}',
    density: 85,
    imprecise: false,
    latitude: 40.18392,
    longitude: -77.23234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17015',
  },
  {
    city: 'Cornwall',
    county_fips: 42075,
    county_fips_all: '42075',
    county: 'Lebanon',
    county_names_all: 'Lebanon',
    county_weights: '{"42075": 100}',
    density: 1480.8,
    imprecise: false,
    latitude: 40.27322,
    longitude: -76.40705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17016',
  },
  {
    city: 'Dalmatia',
    county_fips: 42097,
    county_fips_all: '42097|42043',
    county: 'Northumberland',
    county_names_all: 'Northumberland|Dauphin',
    county_weights: '{"42097": 68.64, "42043": 31.36}',
    density: 23.1,
    imprecise: false,
    latitude: 40.6275,
    longitude: -76.89854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17017',
  },
  {
    city: 'Dauphin',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 37.8,
    imprecise: false,
    latitude: 40.40246,
    longitude: -76.88117,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17018',
  },
  {
    city: 'Dillsburg',
    county_fips: 42133,
    county_fips_all: '42133|42041|42001',
    county: 'York',
    county_names_all: 'York|Cumberland|Adams',
    county_weights: '{"42133": 92.33, "42041": 6.24, "42001": 1.43}',
    density: 118.6,
    imprecise: false,
    latitude: 40.09078,
    longitude: -77.02462,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17019',
  },
  {
    city: 'Duncannon',
    county_fips: 42099,
    county_fips_all: '42099|42043',
    county: 'Perry',
    county_names_all: 'Perry|Dauphin',
    county_weights: '{"42099": 93.68, "42043": 6.32}',
    density: 59,
    imprecise: false,
    latitude: 40.41014,
    longitude: -77.04367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17020',
  },
  {
    city: 'East Waterford',
    county_fips: 42067,
    county_fips_all: '42067|42099|42055|42061',
    county: 'Juniata',
    county_names_all: 'Juniata|Perry|Franklin|Huntingdon',
    county_weights:
      '{"42067": 77.21, "42099": 15.83, "42055": 5.42, "42061": 1.54}',
    density: 6.4,
    imprecise: false,
    latitude: 40.33758,
    longitude: -77.66093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17021',
  },
  {
    city: 'Elizabethtown',
    county_fips: 42071,
    county_fips_all: '42071|42043',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Dauphin',
    county_weights: '{"42071": 70.87, "42043": 29.13}',
    density: 224.2,
    imprecise: false,
    latitude: 40.16677,
    longitude: -76.60823,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17022',
  },
  {
    city: 'Elizabethville',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 65.7,
    imprecise: false,
    latitude: 40.5813,
    longitude: -76.81169,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17023',
  },
  {
    city: 'Elliottsburg',
    county_fips: 42099,
    county_fips_all: '42099',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"42099": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 40.40992,
    longitude: -77.30854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17024',
  },
  {
    city: 'Enola',
    county_fips: 42041,
    county_fips_all: '42041',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"42041": 100}',
    density: 454.8,
    imprecise: false,
    latitude: 40.29506,
    longitude: -76.97731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17025',
  },
  {
    city: 'Fredericksburg',
    county_fips: 42075,
    county_fips_all: '42075|42011',
    county: 'Lebanon',
    county_names_all: 'Lebanon|Berks',
    county_weights: '{"42075": 91.14, "42011": 8.86}',
    density: 49.6,
    imprecise: false,
    latitude: 40.46734,
    longitude: -76.43626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17026',
  },
  {
    city: 'Grantham',
    county_fips: 42041,
    county_fips_all: '42041|42133',
    county: 'Cumberland',
    county_names_all: 'Cumberland|York',
    county_weights: '{"42041": 99.56, "42133": 0.44}',
    density: 1944.5,
    imprecise: false,
    latitude: 40.15653,
    longitude: -76.99316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17027',
  },
  {
    city: 'Grantville',
    county_fips: 42075,
    county_fips_all: '42075|42043',
    county: 'Lebanon',
    county_names_all: 'Lebanon|Dauphin',
    county_weights: '{"42075": 54.18, "42043": 45.82}',
    density: 50.2,
    imprecise: false,
    latitude: 40.4033,
    longitude: -76.65073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17028',
  },
  {
    city: 'Granville',
    county_fips: 42087,
    county_fips_all: '42087',
    county: 'Mifflin',
    county_names_all: 'Mifflin',
    county_weights: '{"42087": 100}',
    density: 106.9,
    imprecise: false,
    latitude: 40.55416,
    longitude: -77.62196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17029',
  },
  {
    city: 'Gratz',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 66.2,
    imprecise: false,
    latitude: 40.60833,
    longitude: -76.74417,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17030',
  },
  {
    city: 'Halifax',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 40.49448,
    longitude: -76.81788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17032',
  },
  {
    city: 'Hershey',
    county_fips: 42043,
    county_fips_all: '42043|42075',
    county: 'Dauphin',
    county_names_all: 'Dauphin|Lebanon',
    county_weights: '{"42043": 87.72, "42075": 12.28}',
    density: 232.4,
    imprecise: false,
    latitude: 40.26829,
    longitude: -76.62754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17033',
  },
  {
    city: 'Highspire',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 1462.3,
    imprecise: false,
    latitude: 40.20831,
    longitude: -76.78489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17034',
  },
  {
    city: 'Honey Grove',
    county_fips: 42067,
    county_fips_all: '42067|42099',
    county: 'Juniata',
    county_names_all: 'Juniata|Perry',
    county_weights: '{"42067": 93.91, "42099": 6.09}',
    density: 9.6,
    imprecise: false,
    latitude: 40.41638,
    longitude: -77.57443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17035',
  },
  {
    city: 'Hummelstown',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 323.7,
    imprecise: false,
    latitude: 40.28579,
    longitude: -76.69611,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17036',
  },
  {
    city: 'Ickesburg',
    county_fips: 42099,
    county_fips_all: '42099',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"42099": 100}',
    density: 20.3,
    imprecise: false,
    latitude: 40.43329,
    longitude: -77.42872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17037',
  },
  {
    city: 'Jonestown',
    county_fips: 42075,
    county_fips_all: '42075',
    county: 'Lebanon',
    county_names_all: 'Lebanon',
    county_weights: '{"42075": 100}',
    density: 48.9,
    imprecise: false,
    latitude: 40.46787,
    longitude: -76.54895,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17038',
  },
  {
    city: 'Kleinfeltersville',
    county_fips: 42075,
    county_fips_all: '42075',
    county: 'Lebanon',
    county_names_all: 'Lebanon',
    county_weights: '{"42075": 100}',
    density: 40.5,
    imprecise: false,
    latitude: 40.2928,
    longitude: -76.24077,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17039',
  },
  {
    city: 'Landisburg',
    county_fips: 42099,
    county_fips_all: '42099',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"42099": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 40.31558,
    longitude: -77.32571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17040',
  },
  {
    city: 'Lawn',
    county_fips: 42075,
    county_fips_all: '42075',
    county: 'Lebanon',
    county_names_all: 'Lebanon',
    county_weights: '{"42075": 100}',
    density: 130.3,
    imprecise: false,
    latitude: 40.21667,
    longitude: -76.5395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17041',
  },
  {
    city: 'Lebanon',
    county_fips: 42075,
    county_fips_all: '42075',
    county: 'Lebanon',
    county_names_all: 'Lebanon',
    county_weights: '{"42075": 100}',
    density: 229,
    imprecise: false,
    latitude: 40.29488,
    longitude: -76.42271,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17042',
  },
  {
    city: 'Lemoyne',
    county_fips: 42041,
    county_fips_all: '42041',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"42041": 100}',
    density: 1094.9,
    imprecise: false,
    latitude: 40.24679,
    longitude: -76.90033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17043',
  },
  {
    city: 'Lewistown',
    county_fips: 42087,
    county_fips_all: '42087',
    county: 'Mifflin',
    county_names_all: 'Mifflin',
    county_weights: '{"42087": 100}',
    density: 81.9,
    imprecise: false,
    latitude: 40.58236,
    longitude: -77.59013,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17044',
  },
  {
    city: 'Liverpool',
    county_fips: 42099,
    county_fips_all: '42099|42067|42109',
    county: 'Perry',
    county_names_all: 'Perry|Juniata|Snyder',
    county_weights: '{"42099": 67.11, "42067": 25.52, "42109": 7.37}',
    density: 38.6,
    imprecise: false,
    latitude: 40.58841,
    longitude: -77.00389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17045',
  },
  {
    city: 'Lebanon',
    county_fips: 42075,
    county_fips_all: '42075',
    county: 'Lebanon',
    county_names_all: 'Lebanon',
    county_weights: '{"42075": 100}',
    density: 316.1,
    imprecise: false,
    latitude: 40.38242,
    longitude: -76.4306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17046',
  },
  {
    city: 'Loysville',
    county_fips: 42099,
    county_fips_all: '42099',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"42099": 100}',
    density: 28,
    imprecise: false,
    latitude: 40.37098,
    longitude: -77.41426,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17047',
  },
  {
    city: 'Lykens',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 44.3,
    imprecise: false,
    latitude: 40.60554,
    longitude: -76.72669,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17048',
  },
  {
    city: 'McAlisterville',
    county_fips: 42067,
    county_fips_all: '42067',
    county: 'Juniata',
    county_names_all: 'Juniata',
    county_weights: '{"42067": 100}',
    density: 29.6,
    imprecise: false,
    latitude: 40.65172,
    longitude: -77.25948,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17049',
  },
  {
    city: 'Mechanicsburg',
    county_fips: 42041,
    county_fips_all: '42041',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"42041": 100}',
    density: 480.8,
    imprecise: false,
    latitude: 40.24907,
    longitude: -77.03005,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17050',
  },
  {
    city: 'McVeytown',
    county_fips: 42087,
    county_fips_all: '42087',
    county: 'Mifflin',
    county_names_all: 'Mifflin',
    county_weights: '{"42087": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 40.45881,
    longitude: -77.77306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17051',
  },
  {
    city: 'Mapleton Depot',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 40.31577,
    longitude: -77.98195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17052',
  },
  {
    city: 'Marysville',
    county_fips: 42099,
    county_fips_all: '42099|42041',
    county: 'Perry',
    county_names_all: 'Perry|Cumberland',
    county_weights: '{"42099": 99.29, "42041": 0.71}',
    density: 67.3,
    imprecise: false,
    latitude: 40.3255,
    longitude: -77.03256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17053',
  },
  {
    city: 'Mattawana',
    county_fips: 42087,
    county_fips_all: '42087',
    county: 'Mifflin',
    county_names_all: 'Mifflin',
    county_weights: '{"42087": 100}',
    density: 164.8,
    imprecise: false,
    latitude: 40.49746,
    longitude: -77.72764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17054',
  },
  {
    city: 'Mechanicsburg',
    county_fips: 42041,
    county_fips_all: '42041|42133',
    county: 'Cumberland',
    county_names_all: 'Cumberland|York',
    county_weights: '{"42041": 87.64, "42133": 12.36}',
    density: 413.5,
    imprecise: false,
    latitude: 40.17756,
    longitude: -76.99789,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17055',
  },
  {
    city: 'Mexico',
    county_fips: 42067,
    county_fips_all: '42067',
    county: 'Juniata',
    county_names_all: 'Juniata',
    county_weights: '{"42067": 100}',
    density: 173.5,
    imprecise: false,
    latitude: 40.53349,
    longitude: -77.35585,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17056',
  },
  {
    city: 'Middletown',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 292.3,
    imprecise: false,
    latitude: 40.19437,
    longitude: -76.72659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17057',
  },
  {
    city: 'Mifflin',
    county_fips: 42067,
    county_fips_all: '42067',
    county: 'Juniata',
    county_names_all: 'Juniata',
    county_weights: '{"42067": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 40.50111,
    longitude: -77.54792,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17058',
  },
  {
    city: 'Mifflintown',
    county_fips: 42067,
    county_fips_all: '42067',
    county: 'Juniata',
    county_names_all: 'Juniata',
    county_weights: '{"42067": 100}',
    density: 39,
    imprecise: false,
    latitude: 40.59241,
    longitude: -77.38165,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17059',
  },
  {
    city: 'Mill Creek',
    county_fips: 42061,
    county_fips_all: '42061|42087',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon|Mifflin',
    county_weights: '{"42061": 92.87, "42087": 7.13}',
    density: 23.9,
    imprecise: false,
    latitude: 40.49144,
    longitude: -77.88158,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17060',
  },
  {
    city: 'Millersburg',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 81.2,
    imprecise: false,
    latitude: 40.56542,
    longitude: -76.90046,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17061',
  },
  {
    city: 'Millerstown',
    county_fips: 42099,
    county_fips_all: '42099|42067',
    county: 'Perry',
    county_names_all: 'Perry|Juniata',
    county_weights: '{"42099": 76.06, "42067": 23.94}',
    density: 18.3,
    imprecise: false,
    latitude: 40.55153,
    longitude: -77.16813,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17062',
  },
  {
    city: 'Milroy',
    county_fips: 42087,
    county_fips_all: '42087|42109',
    county: 'Mifflin',
    county_names_all: 'Mifflin|Snyder',
    county_weights: '{"42087": 94.1, "42109": 5.9}',
    density: 13.3,
    imprecise: false,
    latitude: 40.76274,
    longitude: -77.47343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17063',
  },
  {
    city: 'Mount Gretna',
    county_fips: 42075,
    county_fips_all: '42075',
    county: 'Lebanon',
    county_names_all: 'Lebanon',
    county_weights: '{"42075": 100}',
    density: 169.5,
    imprecise: false,
    latitude: 40.24135,
    longitude: -76.47553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17064',
  },
  {
    city: 'Mount Holly Springs',
    county_fips: 42041,
    county_fips_all: '42041',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"42041": 100}',
    density: 112.8,
    imprecise: false,
    latitude: 40.09837,
    longitude: -77.20527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17065',
  },
  {
    city: 'Mount Union',
    county_fips: 42061,
    county_fips_all: '42061|42087',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon|Mifflin',
    county_weights: '{"42061": 81.49, "42087": 18.51}',
    density: 67,
    imprecise: false,
    latitude: 40.35885,
    longitude: -77.85892,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17066',
  },
  {
    city: 'Myerstown',
    county_fips: 42075,
    county_fips_all: '42075|42011',
    county: 'Lebanon',
    county_names_all: 'Lebanon|Berks',
    county_weights: '{"42075": 73.4, "42011": 26.6}',
    density: 129.6,
    imprecise: false,
    latitude: 40.38848,
    longitude: -76.31583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17067',
  },
  {
    city: 'New Bloomfield',
    county_fips: 42099,
    county_fips_all: '42099',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"42099": 100}',
    density: 50,
    imprecise: false,
    latitude: 40.40685,
    longitude: -77.17795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17068',
  },
  {
    city: 'New Buffalo',
    county_fips: 42099,
    county_fips_all: '42099',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"42099": 100}',
    density: 132.7,
    imprecise: false,
    latitude: 40.45722,
    longitude: -76.97921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17069',
  },
  {
    city: 'New Cumberland',
    county_fips: 42133,
    county_fips_all: '42133|42041',
    county: 'York',
    county_names_all: 'York|Cumberland',
    county_weights: '{"42133": 86.42, "42041": 13.58}',
    density: 445.2,
    imprecise: false,
    latitude: 40.20217,
    longitude: -76.86377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17070',
  },
  {
    city: 'Newmanstown',
    county_fips: 42075,
    county_fips_all: '42075|42071',
    county: 'Lebanon',
    county_names_all: 'Lebanon|Lancaster',
    county_weights: '{"42075": 90.46, "42071": 9.54}',
    density: 85.7,
    imprecise: false,
    latitude: 40.30047,
    longitude: -76.25924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17073',
  },
  {
    city: 'Newport',
    county_fips: 42099,
    county_fips_all: '42099',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"42099": 100}',
    density: 43.7,
    imprecise: false,
    latitude: 40.47983,
    longitude: -77.14456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17074',
  },
  {
    city: 'Newton Hamilton',
    county_fips: 42087,
    county_fips_all: '42087',
    county: 'Mifflin',
    county_names_all: 'Mifflin',
    county_weights: '{"42087": 100}',
    density: 479.9,
    imprecise: false,
    latitude: 40.39372,
    longitude: -77.83429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17075',
  },
  {
    city: 'Oakland Mills',
    county_fips: 42067,
    county_fips_all: '42067',
    county: 'Juniata',
    county_names_all: 'Juniata',
    county_weights: '{"42067": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.62084,
    longitude: -77.30758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17076',
  },
  {
    city: 'Ono',
    county_fips: 42075,
    county_fips_all: '42075',
    county: 'Lebanon',
    county_names_all: 'Lebanon',
    county_weights: '{"42075": 100}',
    density: 1038.4,
    imprecise: false,
    latitude: 40.40232,
    longitude: -76.53651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17077',
  },
  {
    city: 'Palmyra',
    county_fips: 42075,
    county_fips_all: '42075|42043',
    county: 'Lebanon',
    county_names_all: 'Lebanon|Dauphin',
    county_weights: '{"42075": 83.41, "42043": 16.59}',
    density: 306,
    imprecise: false,
    latitude: 40.28952,
    longitude: -76.58484,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17078',
  },
  {
    city: 'Pillow',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 206.6,
    imprecise: false,
    latitude: 40.64057,
    longitude: -76.80299,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17080',
  },
  {
    city: 'Plainfield',
    county_fips: 42041,
    county_fips_all: '42041',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"42041": 100}',
    density: 148.2,
    imprecise: false,
    latitude: 40.20121,
    longitude: -77.28322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17081',
  },
  {
    city: 'Port Royal',
    county_fips: 42067,
    county_fips_all: '42067',
    county: 'Juniata',
    county_names_all: 'Juniata',
    county_weights: '{"42067": 100}',
    density: 20.7,
    imprecise: false,
    latitude: 40.49762,
    longitude: -77.42579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17082',
  },
  {
    city: 'Reedsville',
    county_fips: 42087,
    county_fips_all: '42087',
    county: 'Mifflin',
    county_names_all: 'Mifflin',
    county_weights: '{"42087": 100}',
    density: 54.4,
    imprecise: false,
    latitude: 40.68705,
    longitude: -77.62692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17084',
  },
  {
    city: 'Richfield',
    county_fips: 42109,
    county_fips_all: '42109|42067',
    county: 'Snyder',
    county_names_all: 'Snyder|Juniata',
    county_weights: '{"42109": 64.13, "42067": 35.87}',
    density: 20.8,
    imprecise: false,
    latitude: 40.69067,
    longitude: -77.12502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17086',
  },
  {
    city: 'Richland',
    county_fips: 42011,
    county_fips_all: '42011|42075',
    county: 'Berks',
    county_names_all: 'Berks|Lebanon',
    county_weights: '{"42011": 67.79, "42075": 32.21}',
    density: 71.8,
    imprecise: false,
    latitude: 40.40523,
    longitude: -76.26356,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17087',
  },
  {
    city: 'Schaefferstown',
    county_fips: 42075,
    county_fips_all: '42075',
    county: 'Lebanon',
    county_names_all: 'Lebanon',
    county_weights: '{"42075": 100}',
    density: 107.2,
    imprecise: false,
    latitude: 40.30046,
    longitude: -76.295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17088',
  },
  {
    city: 'Shermans Dale',
    county_fips: 42099,
    county_fips_all: '42099',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"42099": 100}',
    density: 62.2,
    imprecise: false,
    latitude: 40.32953,
    longitude: -77.18302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17090',
  },
  {
    city: 'Thompsontown',
    county_fips: 42067,
    county_fips_all: '42067',
    county: 'Juniata',
    county_names_all: 'Juniata',
    county_weights: '{"42067": 100}',
    density: 32.3,
    imprecise: false,
    latitude: 40.58414,
    longitude: -77.2168,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17094',
  },
  {
    city: 'Wiconisco',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 252.9,
    imprecise: false,
    latitude: 40.57414,
    longitude: -76.67704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17097',
  },
  {
    city: 'Williamstown',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 108.5,
    imprecise: false,
    latitude: 40.58998,
    longitude: -76.63071,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17098',
  },
  {
    city: 'Yeagertown',
    county_fips: 42087,
    county_fips_all: '42087',
    county: 'Mifflin',
    county_names_all: 'Mifflin',
    county_weights: '{"42087": 100}',
    density: 318.4,
    imprecise: false,
    latitude: 40.64535,
    longitude: -77.57639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17099',
  },
  {
    city: 'Harrisburg',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 2017.2,
    imprecise: false,
    latitude: 40.2595,
    longitude: -76.88705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17101',
  },
  {
    city: 'Harrisburg',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 4138,
    imprecise: false,
    latitude: 40.27119,
    longitude: -76.89686,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17102',
  },
  {
    city: 'Harrisburg',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 2681.4,
    imprecise: false,
    latitude: 40.27499,
    longitude: -76.86326,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17103',
  },
  {
    city: 'Harrisburg',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 2132.8,
    imprecise: false,
    latitude: 40.23901,
    longitude: -76.84985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17104',
  },
  {
    city: 'Harrisburg',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 1521.4,
    imprecise: false,
    latitude: 40.28986,
    longitude: -76.82414,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17109',
  },
  {
    city: 'Harrisburg',
    county_fips: 42043,
    county_fips_all: '42043|42041',
    county: 'Dauphin',
    county_names_all: 'Dauphin|Cumberland',
    county_weights: '{"42043": 99.69, "42041": 0.31}',
    density: 706.7,
    imprecise: false,
    latitude: 40.31776,
    longitude: -76.88354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17110',
  },
  {
    city: 'Harrisburg',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 772.5,
    imprecise: false,
    latitude: 40.27041,
    longitude: -76.78265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17111',
  },
  {
    city: 'Harrisburg',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 213.6,
    imprecise: false,
    latitude: 40.37497,
    longitude: -76.77163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17112',
  },
  {
    city: 'Harrisburg',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 1085.7,
    imprecise: false,
    latitude: 40.23032,
    longitude: -76.82083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17113',
  },
  {
    city: 'Chambersburg',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 556.3,
    imprecise: false,
    latitude: 39.96229,
    longitude: -77.65677,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17201',
  },
  {
    city: 'Chambersburg',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 109.7,
    imprecise: false,
    latitude: 39.92133,
    longitude: -77.67442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17202',
  },
  {
    city: 'Amberson',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 6,
    imprecise: false,
    latitude: 40.18989,
    longitude: -77.661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17210',
  },
  {
    city: 'Artemas',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 39.75191,
    longitude: -78.41457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17211',
  },
  {
    city: 'Big Cove Tannery',
    county_fips: 42057,
    county_fips_all: '42057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"42057": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 39.81,
    longitude: -78.07073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17212',
  },
  {
    city: 'Blairs Mills',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 40.25381,
    longitude: -77.77249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17213',
  },
  {
    city: 'Blue Ridge Summit',
    county_fips: 42055,
    county_fips_all: '42055|42001',
    county: 'Franklin',
    county_names_all: 'Franklin|Adams',
    county_weights: '{"42055": 99.48, "42001": 0.52}',
    density: 115.8,
    imprecise: false,
    latitude: 39.74811,
    longitude: -77.47025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17214',
  },
  {
    city: 'Burnt Cabins',
    county_fips: 42061,
    county_fips_all: '42061|42057',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon|Fulton',
    county_weights: '{"42061": 58.96, "42057": 41.04}',
    density: 11.8,
    imprecise: false,
    latitude: 40.09234,
    longitude: -77.89008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17215',
  },
  {
    city: 'Concord',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 40.23822,
    longitude: -77.72235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17217',
  },
  {
    city: 'Doylesburg',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 14,
    imprecise: false,
    latitude: 40.22367,
    longitude: -77.69318,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17219',
  },
  {
    city: 'Dry Run',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 40.17807,
    longitude: -77.74108,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17220',
  },
  {
    city: 'Fannettsburg',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 40.05796,
    longitude: -77.82019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17221',
  },
  {
    city: 'Fayetteville',
    county_fips: 42055,
    county_fips_all: '42055|42001',
    county: 'Franklin',
    county_names_all: 'Franklin|Adams',
    county_weights: '{"42055": 68.78, "42001": 31.22}',
    density: 62.7,
    imprecise: false,
    latitude: 39.89983,
    longitude: -77.49242,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17222',
  },
  {
    city: 'Fort Littleton',
    county_fips: 42057,
    county_fips_all: '42057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"42057": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 40.06521,
    longitude: -77.9389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17223',
  },
  {
    city: 'Fort Loudon',
    county_fips: 42055,
    county_fips_all: '42055|42057',
    county: 'Franklin',
    county_names_all: 'Franklin|Fulton',
    county_weights: '{"42055": 94.99, "42057": 5.01}',
    density: 15.6,
    imprecise: false,
    latitude: 39.9723,
    longitude: -77.89195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17224',
  },
  {
    city: 'Greencastle',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 96.1,
    imprecise: false,
    latitude: 39.78706,
    longitude: -77.75709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17225',
  },
  {
    city: 'Harrisonville',
    county_fips: 42057,
    county_fips_all: '42057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"42057": 100}',
    density: 12,
    imprecise: false,
    latitude: 39.99512,
    longitude: -78.09831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17228',
  },
  {
    city: 'Hustontown',
    county_fips: 42057,
    county_fips_all: '42057|42061',
    county: 'Fulton',
    county_names_all: 'Fulton|Huntingdon',
    county_weights: '{"42057": 90.36, "42061": 9.64}',
    density: 16.8,
    imprecise: false,
    latitude: 40.07853,
    longitude: -78.01144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17229',
  },
  {
    city: 'Lurgan',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 448.1,
    imprecise: false,
    latitude: 40.09462,
    longitude: -77.63341,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17232',
  },
  {
    city: 'McConnellsburg',
    county_fips: 42057,
    county_fips_all: '42057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"42057": 100}',
    density: 24.3,
    imprecise: false,
    latitude: 39.95118,
    longitude: -78.00406,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17233',
  },
  {
    city: 'Marion',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 425,
    imprecise: false,
    latitude: 39.85699,
    longitude: -77.69743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17235',
  },
  {
    city: 'Mercersburg',
    county_fips: 42055,
    county_fips_all: '42055|42057',
    county: 'Franklin',
    county_names_all: 'Franklin|Fulton',
    county_weights: '{"42055": 95.32, "42057": 4.68}',
    density: 27.2,
    imprecise: false,
    latitude: 39.79997,
    longitude: -77.94305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17236',
  },
  {
    city: 'Mont Alto',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 276.4,
    imprecise: false,
    latitude: 39.83705,
    longitude: -77.54091,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17237',
  },
  {
    city: 'Needmore',
    county_fips: 42057,
    county_fips_all: '42057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"42057": 100}',
    density: 13,
    imprecise: false,
    latitude: 39.8612,
    longitude: -78.13003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17238',
  },
  {
    city: 'Neelyton',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 40.13973,
    longitude: -77.83009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17239',
  },
  {
    city: 'Newburg',
    county_fips: 42041,
    county_fips_all: '42041|42055',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Franklin',
    county_weights: '{"42041": 60.96, "42055": 39.04}',
    density: 25.7,
    imprecise: false,
    latitude: 40.15411,
    longitude: -77.58227,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17240',
  },
  {
    city: 'Newville',
    county_fips: 42041,
    county_fips_all: '42041',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"42041": 100}',
    density: 38.6,
    imprecise: false,
    latitude: 40.17793,
    longitude: -77.40326,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17241',
  },
  {
    city: 'Orbisonia',
    county_fips: 42061,
    county_fips_all: '42061|42067',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon|Juniata',
    county_weights: '{"42061": 71.59, "42067": 28.41}',
    density: 8.1,
    imprecise: false,
    latitude: 40.28368,
    longitude: -77.81484,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17243',
  },
  {
    city: 'Orrstown',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 32.6,
    imprecise: false,
    latitude: 40.08595,
    longitude: -77.66562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17244',
  },
  {
    city: 'Pleasant Hall',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 96,
    imprecise: false,
    latitude: 40.0629,
    longitude: -77.68255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17246',
  },
  {
    city: 'Quincy',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 1669.9,
    imprecise: false,
    latitude: 39.79883,
    longitude: -77.57933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17247',
  },
  {
    city: 'Rockhill Furnace',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 647,
    imprecise: false,
    latitude: 40.24186,
    longitude: -77.9002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17249',
  },
  {
    city: 'Rouzerville',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.73668,
    longitude: -77.52338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17250',
  },
  {
    city: 'Roxbury',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 40.12159,
    longitude: -77.66695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17251',
  },
  {
    city: 'Saint Thomas',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 51.1,
    imprecise: false,
    latitude: 39.91317,
    longitude: -77.81695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17252',
  },
  {
    city: 'Saltillo',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 605.2,
    imprecise: false,
    latitude: 40.21241,
    longitude: -78.00628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17253',
  },
  {
    city: 'Scotland',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 321.5,
    imprecise: false,
    latitude: 39.96853,
    longitude: -77.58917,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17254',
  },
  {
    city: 'Shade Gap',
    county_fips: 42061,
    county_fips_all: '42061|42057',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon|Fulton',
    county_weights: '{"42061": 94.52, "42057": 5.48}',
    density: 12.1,
    imprecise: false,
    latitude: 40.15426,
    longitude: -77.86756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17255',
  },
  {
    city: 'Shippensburg',
    county_fips: 42041,
    county_fips_all: '42041|42055',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Franklin',
    county_weights: '{"42041": 63.7, "42055": 36.3}',
    density: 97.9,
    imprecise: false,
    latitude: 40.0508,
    longitude: -77.49027,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17257',
  },
  {
    city: 'Shirleysburg',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 40.2977,
    longitude: -77.89489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17260',
  },
  {
    city: 'South Mountain',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.85981,
    longitude: -77.51164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17261',
  },
  {
    city: 'Spring Run',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 40.14489,
    longitude: -77.74174,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17262',
  },
  {
    city: 'State Line',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 1261.1,
    imprecise: false,
    latitude: 39.72409,
    longitude: -77.71727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17263',
  },
  {
    city: 'Three Springs',
    county_fips: 42061,
    county_fips_all: '42061|42057',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon|Fulton',
    county_weights: '{"42061": 91.61, "42057": 8.39}',
    density: 15.2,
    imprecise: false,
    latitude: 40.17993,
    longitude: -77.99331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17264',
  },
  {
    city: 'Upperstrasburg',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 40.03846,
    longitude: -77.77297,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17265',
  },
  {
    city: 'Walnut Bottom',
    county_fips: 42041,
    county_fips_all: '42041',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"42041": 100}',
    density: 130.6,
    imprecise: false,
    latitude: 40.08745,
    longitude: -77.412,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17266',
  },
  {
    city: 'Warfordsburg',
    county_fips: 42057,
    county_fips_all: '42057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"42057": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 39.80389,
    longitude: -78.23958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17267',
  },
  {
    city: 'Waynesboro',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 145.8,
    imprecise: false,
    latitude: 39.77421,
    longitude: -77.57354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17268',
  },
  {
    city: 'Willow Hill',
    county_fips: 42055,
    county_fips_all: '42055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"42055": 100}',
    density: 16,
    imprecise: false,
    latitude: 40.10183,
    longitude: -77.80367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17271',
  },
  {
    city: 'Abbottstown',
    county_fips: 42001,
    county_fips_all: '42001|42133',
    county: 'Adams',
    county_names_all: 'Adams|York',
    county_weights: '{"42001": 60.55, "42133": 39.45}',
    density: 134.4,
    imprecise: false,
    latitude: 39.89119,
    longitude: -76.9815,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17301',
  },
  {
    city: 'Airville',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 39.81659,
    longitude: -76.41069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17302',
  },
  {
    city: 'Arendtsville',
    county_fips: 42001,
    county_fips_all: '42001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"42001": 100}',
    density: 888.8,
    imprecise: false,
    latitude: 39.92615,
    longitude: -77.29755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17303',
  },
  {
    city: 'Aspers',
    county_fips: 42001,
    county_fips_all: '42001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"42001": 100}',
    density: 50.3,
    imprecise: false,
    latitude: 39.97696,
    longitude: -77.23099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17304',
  },
  {
    city: 'Bendersville',
    county_fips: 42001,
    county_fips_all: '42001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"42001": 100}',
    density: 849.9,
    imprecise: false,
    latitude: 39.98383,
    longitude: -77.24966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17306',
  },
  {
    city: 'Biglerville',
    county_fips: 42001,
    county_fips_all: '42001|42041',
    county: 'Adams',
    county_names_all: 'Adams|Cumberland',
    county_weights: '{"42001": 90.63, "42041": 9.37}',
    density: 35.6,
    imprecise: false,
    latitude: 39.94853,
    longitude: -77.314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17307',
  },
  {
    city: 'Brogue',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 39.87351,
    longitude: -76.44894,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17309',
  },
  {
    city: 'Codorus',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 971.7,
    imprecise: false,
    latitude: 39.81709,
    longitude: -76.84191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17311',
  },
  {
    city: 'Dallastown',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 451.6,
    imprecise: false,
    latitude: 39.88472,
    longitude: -76.65719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17313',
  },
  {
    city: 'Delta',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 73.2,
    imprecise: false,
    latitude: 39.75469,
    longitude: -76.32852,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17314',
  },
  {
    city: 'Dover',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 171.1,
    imprecise: false,
    latitude: 40.01859,
    longitude: -76.8685,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17315',
  },
  {
    city: 'East Berlin',
    county_fips: 42001,
    county_fips_all: '42001|42133',
    county: 'Adams',
    county_names_all: 'Adams|York',
    county_weights: '{"42001": 58.27, "42133": 41.73}',
    density: 80,
    imprecise: false,
    latitude: 39.96721,
    longitude: -77.00226,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17316',
  },
  {
    city: 'East Prospect',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 933.1,
    imprecise: false,
    latitude: 39.97136,
    longitude: -76.52267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17317',
  },
  {
    city: 'Emigsville',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 83.2,
    imprecise: false,
    latitude: 40.01847,
    longitude: -76.7265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17318',
  },
  {
    city: 'Etters',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 259.6,
    imprecise: false,
    latitude: 40.1585,
    longitude: -76.79468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17319',
  },
  {
    city: 'Fairfield',
    county_fips: 42001,
    county_fips_all: '42001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"42001": 100}',
    density: 55,
    imprecise: false,
    latitude: 39.7695,
    longitude: -77.38749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17320',
  },
  {
    city: 'Fawn Grove',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 55.1,
    imprecise: false,
    latitude: 39.75406,
    longitude: -76.44742,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17321',
  },
  {
    city: 'Felton',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 63.3,
    imprecise: false,
    latitude: 39.85548,
    longitude: -76.53513,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17322',
  },
  {
    city: 'Franklintown',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 485.4,
    imprecise: false,
    latitude: 40.07523,
    longitude: -77.02669,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17323',
  },
  {
    city: 'Gardners',
    county_fips: 42041,
    county_fips_all: '42041|42001',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Adams',
    county_weights: '{"42041": 65.18, "42001": 34.82}',
    density: 32.1,
    imprecise: false,
    latitude: 40.03616,
    longitude: -77.22772,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17324',
  },
  {
    city: 'Gettysburg',
    county_fips: 42001,
    county_fips_all: '42001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"42001": 100}',
    density: 93.1,
    imprecise: false,
    latitude: 39.82762,
    longitude: -77.22641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17325',
  },
  {
    city: 'Glen Rock',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 65.5,
    imprecise: false,
    latitude: 39.77934,
    longitude: -76.75373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17327',
  },
  {
    city: 'Glenville',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 65.8,
    imprecise: false,
    latitude: 39.76295,
    longitude: -76.85374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17329',
  },
  {
    city: 'Hanover',
    county_fips: 42133,
    county_fips_all: '42133|42001',
    county: 'York',
    county_names_all: 'York|Adams',
    county_weights: '{"42133": 60.52, "42001": 39.48}',
    density: 292.8,
    imprecise: false,
    latitude: 39.79085,
    longitude: -76.98028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17331',
  },
  {
    city: 'Lewisberry',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 90.4,
    imprecise: false,
    latitude: 40.13438,
    longitude: -76.88188,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17339',
  },
  {
    city: 'Littlestown',
    county_fips: 42001,
    county_fips_all: '42001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"42001": 100}',
    density: 111.8,
    imprecise: false,
    latitude: 39.75566,
    longitude: -77.11183,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17340',
  },
  {
    city: 'Loganville',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 856,
    imprecise: false,
    latitude: 39.85275,
    longitude: -76.70756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17342',
  },
  {
    city: 'McKnightstown',
    county_fips: 42001,
    county_fips_all: '42001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"42001": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 39.86863,
    longitude: -77.32948,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17343',
  },
  {
    city: 'McSherrystown',
    county_fips: 42001,
    county_fips_all: '42001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"42001": 100}',
    density: 1921,
    imprecise: false,
    latitude: 39.80535,
    longitude: -77.01887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17344',
  },
  {
    city: 'Manchester',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 248.1,
    imprecise: false,
    latitude: 40.07929,
    longitude: -76.72812,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17345',
  },
  {
    city: 'Mount Wolf',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 194.5,
    imprecise: false,
    latitude: 40.04927,
    longitude: -76.68247,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17347',
  },
  {
    city: 'New Freedom',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 151.1,
    imprecise: false,
    latitude: 39.75536,
    longitude: -76.68003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17349',
  },
  {
    city: 'New Oxford',
    county_fips: 42001,
    county_fips_all: '42001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"42001": 100}',
    density: 114.9,
    imprecise: false,
    latitude: 39.88918,
    longitude: -77.07896,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17350',
  },
  {
    city: 'New Park',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 37.2,
    imprecise: false,
    latitude: 39.76199,
    longitude: -76.50008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17352',
  },
  {
    city: 'Orrtanna',
    county_fips: 42001,
    county_fips_all: '42001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"42001": 100}',
    density: 28.1,
    imprecise: false,
    latitude: 39.88741,
    longitude: -77.38714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17353',
  },
  {
    city: 'Railroad',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 201.8,
    imprecise: false,
    latitude: 39.75978,
    longitude: -76.696,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17355',
  },
  {
    city: 'Red Lion',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 264.1,
    imprecise: false,
    latitude: 39.89834,
    longitude: -76.58366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17356',
  },
  {
    city: 'Seven Valleys',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 88.4,
    imprecise: false,
    latitude: 39.85196,
    longitude: -76.75377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17360',
  },
  {
    city: 'Shrewsbury',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 779.6,
    imprecise: false,
    latitude: 39.76617,
    longitude: -76.67702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17361',
  },
  {
    city: 'Spring Grove',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 115.9,
    imprecise: false,
    latitude: 39.85088,
    longitude: -76.86872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17362',
  },
  {
    city: 'Stewartstown',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 89.5,
    imprecise: false,
    latitude: 39.76736,
    longitude: -76.58504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17363',
  },
  {
    city: 'Thomasville',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 93.5,
    imprecise: false,
    latitude: 39.92985,
    longitude: -76.90049,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17364',
  },
  {
    city: 'Wellsville',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 53.8,
    imprecise: false,
    latitude: 40.05696,
    longitude: -76.9392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17365',
  },
  {
    city: 'Windsor',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 218.1,
    imprecise: false,
    latitude: 39.93184,
    longitude: -76.55585,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17366',
  },
  {
    city: 'Wrightsville',
    county_fips: 42133,
    county_fips_all: '42133|42071',
    county: 'York',
    county_names_all: 'York|Lancaster',
    county_weights: '{"42133": 99.9, "42071": 0.1}',
    density: 144.5,
    imprecise: false,
    latitude: 39.98463,
    longitude: -76.51966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17368',
  },
  {
    city: 'York Haven',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 206.8,
    imprecise: false,
    latitude: 40.1174,
    longitude: -76.78124,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17370',
  },
  {
    city: 'York New Salem',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 710.4,
    imprecise: false,
    latitude: 39.90258,
    longitude: -76.78797,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17371',
  },
  {
    city: 'York Springs',
    county_fips: 42001,
    county_fips_all: '42001|42133',
    county: 'Adams',
    county_names_all: 'Adams|York',
    county_weights: '{"42001": 98.72, "42133": 1.28}',
    density: 46.3,
    imprecise: false,
    latitude: 40.00037,
    longitude: -77.10633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17372',
  },
  {
    city: 'York',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 4823.6,
    imprecise: false,
    latitude: 39.95893,
    longitude: -76.73359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17401',
  },
  {
    city: 'York',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 773.1,
    imprecise: false,
    latitude: 39.95799,
    longitude: -76.66045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17402',
  },
  {
    city: 'York',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 755.7,
    imprecise: false,
    latitude: 39.92142,
    longitude: -76.71277,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17403',
  },
  {
    city: 'York',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 705.7,
    imprecise: false,
    latitude: 40.00496,
    longitude: -76.77217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17404',
  },
  {
    city: 'York',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 186.6,
    imprecise: false,
    latitude: 40.01224,
    longitude: -76.64249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17406',
  },
  {
    city: 'York',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 698.1,
    imprecise: false,
    latitude: 39.8855,
    longitude: -76.71244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17407',
  },
  {
    city: 'York',
    county_fips: 42133,
    county_fips_all: '42133',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"42133": 100}',
    density: 366.6,
    imprecise: false,
    latitude: 39.93451,
    longitude: -76.80203,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17408',
  },
  {
    city: 'Akron',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 1158.8,
    imprecise: false,
    latitude: 40.15697,
    longitude: -76.20532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17501',
  },
  {
    city: 'Bainbridge',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 89.9,
    imprecise: false,
    latitude: 40.10081,
    longitude: -76.66732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17502',
  },
  {
    city: 'Bausman',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 2116.9,
    imprecise: false,
    latitude: 40.02448,
    longitude: -76.32855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17504',
  },
  {
    city: 'Bird In Hand',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 122.9,
    imprecise: false,
    latitude: 40.05915,
    longitude: -76.18999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17505',
  },
  {
    city: 'Blue Ball',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 2349,
    imprecise: false,
    latitude: 40.11718,
    longitude: -76.0527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17506',
  },
  {
    city: 'Bowmansville',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 1161,
    imprecise: false,
    latitude: 40.19806,
    longitude: -76.01624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17507',
  },
  {
    city: 'Brownstown',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 1528.3,
    imprecise: false,
    latitude: 40.12455,
    longitude: -76.21394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17508',
  },
  {
    city: 'Christiana',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 76,
    imprecise: false,
    latitude: 39.90923,
    longitude: -76.03073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17509',
  },
  {
    city: 'Columbia',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 437.7,
    imprecise: false,
    latitude: 40.04,
    longitude: -76.48558,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17512',
  },
  {
    city: 'Conestoga',
    county_fips: 42071,
    county_fips_all: '42071|42133',
    county: 'Lancaster',
    county_names_all: 'Lancaster|York',
    county_weights: '{"42071": 99.9, "42133": 0.1}',
    density: 97.4,
    imprecise: false,
    latitude: 39.93773,
    longitude: -76.38703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17516',
  },
  {
    city: 'Denver',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 159.5,
    imprecise: false,
    latitude: 40.24402,
    longitude: -76.13151,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17517',
  },
  {
    city: 'Drumore',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 38,
    imprecise: false,
    latitude: 39.80519,
    longitude: -76.25932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17518',
  },
  {
    city: 'East Earl',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 127.7,
    imprecise: false,
    latitude: 40.14278,
    longitude: -76.02145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17519',
  },
  {
    city: 'East Petersburg',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 1061,
    imprecise: false,
    latitude: 40.09813,
    longitude: -76.34897,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17520',
  },
  {
    city: 'Ephrata',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 303.9,
    imprecise: false,
    latitude: 40.17499,
    longitude: -76.17009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17522',
  },
  {
    city: 'Gap',
    county_fips: 42071,
    county_fips_all: '42071|42029',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Chester',
    county_weights: '{"42071": 94.12, "42029": 5.88}',
    density: 111.9,
    imprecise: false,
    latitude: 40.01495,
    longitude: -75.99333,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17527',
  },
  {
    city: 'Gordonville',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 127,
    imprecise: false,
    latitude: 40.04036,
    longitude: -76.10008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17529',
  },
  {
    city: 'Holtwood',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 60.1,
    imprecise: false,
    latitude: 39.85731,
    longitude: -76.2923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17532',
  },
  {
    city: 'Intercourse',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.03665,
    longitude: -76.11214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17534',
  },
  {
    city: 'Kinzers',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 92.7,
    imprecise: false,
    latitude: 40.01224,
    longitude: -76.03813,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17535',
  },
  {
    city: 'Kirkwood',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 63.7,
    imprecise: false,
    latitude: 39.84345,
    longitude: -76.07316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17536',
  },
  {
    city: 'Landisville',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 683.4,
    imprecise: false,
    latitude: 40.08804,
    longitude: -76.41528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17538',
  },
  {
    city: 'Leola',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 197.9,
    imprecise: false,
    latitude: 40.09877,
    longitude: -76.1888,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17540',
  },
  {
    city: 'Lititz',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 268.8,
    imprecise: false,
    latitude: 40.18217,
    longitude: -76.30038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17543',
  },
  {
    city: 'Manheim',
    county_fips: 42071,
    county_fips_all: '42071|42075',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Lebanon',
    county_weights: '{"42071": 94.12, "42075": 5.88}',
    density: 130.3,
    imprecise: false,
    latitude: 40.17307,
    longitude: -76.42792,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17545',
  },
  {
    city: 'Marietta',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 297.3,
    imprecise: false,
    latitude: 40.07056,
    longitude: -76.58436,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17547',
  },
  {
    city: 'Maytown',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 773,
    imprecise: false,
    latitude: 40.07492,
    longitude: -76.58339,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17550',
  },
  {
    city: 'Millersville',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 427.6,
    imprecise: false,
    latitude: 39.97911,
    longitude: -76.37608,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17551',
  },
  {
    city: 'Mount Joy',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 233.9,
    imprecise: false,
    latitude: 40.10935,
    longitude: -76.51174,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17552',
  },
  {
    city: 'Mountville',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 922.9,
    imprecise: false,
    latitude: 40.03923,
    longitude: -76.42584,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17554',
  },
  {
    city: 'Narvon',
    county_fips: 42071,
    county_fips_all: '42071|42029',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Chester',
    county_weights: '{"42071": 99.09, "42029": 0.91}',
    density: 84.6,
    imprecise: false,
    latitude: 40.12075,
    longitude: -75.96514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17555',
  },
  {
    city: 'New Holland',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 181.4,
    imprecise: false,
    latitude: 40.10328,
    longitude: -76.07543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17557',
  },
  {
    city: 'New Providence',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 133.4,
    imprecise: false,
    latitude: 39.91117,
    longitude: -76.22712,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17560',
  },
  {
    city: 'Paradise',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 98.2,
    imprecise: false,
    latitude: 39.97636,
    longitude: -76.09264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17562',
  },
  {
    city: 'Peach Bottom',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 47.2,
    imprecise: false,
    latitude: 39.76404,
    longitude: -76.18649,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17563',
  },
  {
    city: 'Pequea',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 73.4,
    imprecise: false,
    latitude: 39.89191,
    longitude: -76.32994,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17565',
  },
  {
    city: 'Quarryville',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 81.6,
    imprecise: false,
    latitude: 39.86924,
    longitude: -76.1476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17566',
  },
  {
    city: 'Refton',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.94806,
    longitude: -76.23416,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17568',
  },
  {
    city: 'Reinholds',
    county_fips: 42071,
    county_fips_all: '42071|42011',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Berks',
    county_weights: '{"42071": 73.81, "42011": 26.19}',
    density: 170.7,
    imprecise: false,
    latitude: 40.27043,
    longitude: -76.09652,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17569',
  },
  {
    city: 'Rheems',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 283.5,
    imprecise: false,
    latitude: 40.12574,
    longitude: -76.57035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17570',
  },
  {
    city: 'Ronks',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 86.6,
    imprecise: false,
    latitude: 40.00937,
    longitude: -76.15105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17572',
  },
  {
    city: 'Smoketown',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 419.2,
    imprecise: false,
    latitude: 40.03561,
    longitude: -76.19782,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17576',
  },
  {
    city: 'Stevens',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 207.3,
    imprecise: false,
    latitude: 40.22397,
    longitude: -76.16405,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17578',
  },
  {
    city: 'Strasburg',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 181.3,
    imprecise: false,
    latitude: 39.95938,
    longitude: -76.18032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17579',
  },
  {
    city: 'Terre Hill',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 184.6,
    imprecise: false,
    latitude: 40.15617,
    longitude: -76.05535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17581',
  },
  {
    city: 'Washington Boro',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 71.7,
    imprecise: false,
    latitude: 39.98928,
    longitude: -76.44756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17582',
  },
  {
    city: 'Willow Street',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 303.5,
    imprecise: false,
    latitude: 39.95981,
    longitude: -76.26463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17584',
  },
  {
    city: 'Lancaster',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 649.5,
    imprecise: false,
    latitude: 40.07296,
    longitude: -76.31457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17601',
  },
  {
    city: 'Lancaster',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 820.8,
    imprecise: false,
    latitude: 40.01486,
    longitude: -76.24632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17602',
  },
  {
    city: 'Lancaster',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 870,
    imprecise: false,
    latitude: 40.0127,
    longitude: -76.35287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 67571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17603',
  },
  {
    city: 'Lancaster',
    county_fips: 42071,
    county_fips_all: '42071',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"42071": 100}',
    density: 3597.7,
    imprecise: false,
    latitude: 40.11174,
    longitude: -76.30401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17606',
  },
  {
    city: 'Williamsport',
    county_fips: 42081,
    county_fips_all: '42081|42113',
    county: 'Lycoming',
    county_names_all: 'Lycoming|Sullivan',
    county_weights: '{"42081": 89.98, "42113": 10.02}',
    density: 169.8,
    imprecise: false,
    latitude: 41.34206,
    longitude: -76.88821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17701',
  },
  {
    city: 'Williamsport',
    county_fips: 42081,
    county_fips_all: '42081',
    county: 'Lycoming',
    county_names_all: 'Lycoming',
    county_weights: '{"42081": 100}',
    density: 66.1,
    imprecise: false,
    latitude: 41.18215,
    longitude: -77.07728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17702',
  },
  {
    city: 'Antes Fort',
    county_fips: 42081,
    county_fips_all: '42081',
    county: 'Lycoming',
    county_names_all: 'Lycoming',
    county_weights: '{"42081": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 41.18046,
    longitude: -77.20503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17720',
  },
  {
    city: 'Avis',
    county_fips: 42035,
    county_fips_all: '42035',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"42035": 100}',
    density: 462.8,
    imprecise: false,
    latitude: 41.18155,
    longitude: -77.31927,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17721',
  },
  {
    city: 'Cammal',
    county_fips: 42081,
    county_fips_all: '42081',
    county: 'Lycoming',
    county_names_all: 'Lycoming',
    county_weights: '{"42081": 100}',
    density: 1,
    imprecise: false,
    latitude: 41.43125,
    longitude: -77.45629,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17723',
  },
  {
    city: 'Canton',
    county_fips: 42015,
    county_fips_all: '42015|42117|42081',
    county: 'Bradford',
    county_names_all: 'Bradford|Tioga|Lycoming',
    county_weights: '{"42015": 75.17, "42117": 16.72, "42081": 8.11}',
    density: 16.6,
    imprecise: false,
    latitude: 41.63827,
    longitude: -76.80034,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17724',
  },
  {
    city: 'Cedar Run',
    county_fips: 42117,
    county_fips_all: '42117|42081',
    county: 'Tioga',
    county_names_all: 'Tioga|Lycoming',
    county_weights: '{"42117": 58.81, "42081": 41.19}',
    density: 0.3,
    imprecise: false,
    latitude: 41.53904,
    longitude: -77.47914,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17727',
  },
  {
    city: 'Cogan Station',
    county_fips: 42081,
    county_fips_all: '42081',
    county: 'Lycoming',
    county_names_all: 'Lycoming',
    county_weights: '{"42081": 100}',
    density: 39.8,
    imprecise: false,
    latitude: 41.32546,
    longitude: -77.08215,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17728',
  },
  {
    city: 'Cross Fork',
    county_fips: 42105,
    county_fips_all: '42105|42035',
    county: 'Potter',
    county_names_all: 'Potter|Clinton',
    county_weights: '{"42105": 71.38, "42035": 28.62}',
    density: 0.5,
    imprecise: false,
    latitude: 41.49798,
    longitude: -77.74106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17729',
  },
  {
    city: 'Dewart',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 22,
    imprecise: false,
    latitude: 41.10677,
    longitude: -76.87591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17730',
  },
  {
    city: 'Eagles Mere',
    county_fips: 42113,
    county_fips_all: '42113',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"42113": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 41.42713,
    longitude: -76.57293,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17731',
  },
  {
    city: 'Hughesville',
    county_fips: 42081,
    county_fips_all: '42081|42113',
    county: 'Lycoming',
    county_names_all: 'Lycoming|Sullivan',
    county_weights: '{"42081": 98.35, "42113": 1.65}',
    density: 38.2,
    imprecise: false,
    latitude: 41.28673,
    longitude: -76.68149,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17737',
  },
  {
    city: 'Jersey Mills',
    county_fips: 42081,
    county_fips_all: '42081',
    county: 'Lycoming',
    county_names_all: 'Lycoming',
    county_weights: '{"42081": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 41.41289,
    longitude: -77.40156,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17739',
  },
  {
    city: 'Jersey Shore',
    county_fips: 42081,
    county_fips_all: '42081|42035',
    county: 'Lycoming',
    county_names_all: 'Lycoming|Clinton',
    county_weights: '{"42081": 82.92, "42035": 17.08}',
    density: 34.1,
    imprecise: false,
    latitude: 41.2342,
    longitude: -77.26171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17740',
  },
  {
    city: 'Lairdsville',
    county_fips: 42081,
    county_fips_all: '42081',
    county: 'Lycoming',
    county_names_all: 'Lycoming',
    county_weights: '{"42081": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 41.23919,
    longitude: -76.5829,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17742',
  },
  {
    city: 'Linden',
    county_fips: 42081,
    county_fips_all: '42081',
    county: 'Lycoming',
    county_names_all: 'Lycoming',
    county_weights: '{"42081": 100}',
    density: 48.1,
    imprecise: false,
    latitude: 41.24397,
    longitude: -77.16139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17744',
  },
  {
    city: 'Lock Haven',
    county_fips: 42035,
    county_fips_all: '42035|42081',
    county: 'Clinton',
    county_names_all: 'Clinton|Lycoming',
    county_weights: '{"42035": 71.7, "42081": 28.3}',
    density: 29.8,
    imprecise: false,
    latitude: 41.28589,
    longitude: -77.48097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17745',
  },
  {
    city: 'Loganton',
    county_fips: 42035,
    county_fips_all: '42035',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"42035": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 41.03847,
    longitude: -77.31497,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17747',
  },
  {
    city: 'McElhattan',
    county_fips: 42035,
    county_fips_all: '42035',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"42035": 100}',
    density: 72.7,
    imprecise: false,
    latitude: 41.15147,
    longitude: -77.35043,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17748',
  },
  {
    city: 'McEwensville',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 270.7,
    imprecise: false,
    latitude: 41.07232,
    longitude: -76.81352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17749',
  },
  {
    city: 'Mackeyville',
    county_fips: 42035,
    county_fips_all: '42035',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"42035": 100}',
    density: 49.6,
    imprecise: false,
    latitude: 41.05517,
    longitude: -77.47805,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17750',
  },
  {
    city: 'Mill Hall',
    county_fips: 42035,
    county_fips_all: '42035',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"42035": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 41.13086,
    longitude: -77.53201,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17751',
  },
  {
    city: 'Montgomery',
    county_fips: 42081,
    county_fips_all: '42081',
    county: 'Lycoming',
    county_names_all: 'Lycoming',
    county_weights: '{"42081": 100}',
    density: 47.2,
    imprecise: false,
    latitude: 41.18244,
    longitude: -76.92144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17752',
  },
  {
    city: 'Montoursville',
    county_fips: 42081,
    county_fips_all: '42081',
    county: 'Lycoming',
    county_names_all: 'Lycoming',
    county_weights: '{"42081": 100}',
    density: 77.5,
    imprecise: false,
    latitude: 41.31108,
    longitude: -76.88421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17754',
  },
  {
    city: 'Muncy',
    county_fips: 42081,
    county_fips_all: '42081|42097|42093|42037',
    county: 'Lycoming',
    county_names_all: 'Lycoming|Northumberland|Montour|Columbia',
    county_weights:
      '{"42081": 81.92, "42097": 13.29, "42093": 2.8, "42037": 1.99}',
    density: 46.1,
    imprecise: false,
    latitude: 41.20841,
    longitude: -76.73325,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17756',
  },
  {
    city: 'Muncy Valley',
    county_fips: 42113,
    county_fips_all: '42113|42081',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Lycoming',
    county_weights: '{"42113": 94.93, "42081": 5.07}',
    density: 4,
    imprecise: false,
    latitude: 41.35234,
    longitude: -76.55155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17758',
  },
  {
    city: 'North Bend',
    county_fips: 42035,
    county_fips_all: '42035',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"42035": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 41.3966,
    longitude: -77.66602,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17760',
  },
  {
    city: 'Picture Rocks',
    county_fips: 42081,
    county_fips_all: '42081',
    county: 'Lycoming',
    county_names_all: 'Lycoming',
    county_weights: '{"42081": 100}',
    density: 386.8,
    imprecise: false,
    latitude: 41.28326,
    longitude: -76.70751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17762',
  },
  {
    city: 'Ralston',
    county_fips: 42081,
    county_fips_all: '42081',
    county: 'Lycoming',
    county_names_all: 'Lycoming',
    county_weights: '{"42081": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 41.50999,
    longitude: -76.91388,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17763',
  },
  {
    city: 'Renovo',
    county_fips: 42035,
    county_fips_all: '42035',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"42035": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 41.34316,
    longitude: -77.82735,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17764',
  },
  {
    city: 'Roaring Branch',
    county_fips: 42117,
    county_fips_all: '42117|42081|42015',
    county: 'Tioga',
    county_names_all: 'Tioga|Lycoming|Bradford',
    county_weights: '{"42117": 56.58, "42081": 42.69, "42015": 0.73}',
    density: 5.4,
    imprecise: false,
    latitude: 41.57591,
    longitude: -76.97168,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17765',
  },
  {
    city: 'Shunk',
    county_fips: 42113,
    county_fips_all: '42113',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"42113": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 41.54632,
    longitude: -76.7477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17768',
  },
  {
    city: 'Slate Run',
    county_fips: 42081,
    county_fips_all: '42081',
    county: 'Lycoming',
    county_names_all: 'Lycoming',
    county_weights: '{"42081": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 41.49939,
    longitude: -77.50073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17769',
  },
  {
    city: 'Trout Run',
    county_fips: 42081,
    county_fips_all: '42081',
    county: 'Lycoming',
    county_names_all: 'Lycoming',
    county_weights: '{"42081": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 41.43137,
    longitude: -77.04524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17771',
  },
  {
    city: 'Turbotville',
    county_fips: 42093,
    county_fips_all: '42093|42097',
    county: 'Montour',
    county_names_all: 'Montour|Northumberland',
    county_weights: '{"42093": 68.64, "42097": 31.36}',
    density: 44.8,
    imprecise: false,
    latitude: 41.11832,
    longitude: -76.71756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17772',
  },
  {
    city: 'Unityville',
    county_fips: 42081,
    county_fips_all: '42081|42037',
    county: 'Lycoming',
    county_names_all: 'Lycoming|Columbia',
    county_weights: '{"42081": 99.19, "42037": 0.81}',
    density: 13.2,
    imprecise: false,
    latitude: 41.24782,
    longitude: -76.5416,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17774',
  },
  {
    city: 'Waterville',
    county_fips: 42081,
    county_fips_all: '42081',
    county: 'Lycoming',
    county_names_all: 'Lycoming',
    county_weights: '{"42081": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 41.41704,
    longitude: -77.31257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17776',
  },
  {
    city: 'Watsontown',
    county_fips: 42097,
    county_fips_all: '42097|42093',
    county: 'Northumberland',
    county_names_all: 'Northumberland|Montour',
    county_weights: '{"42097": 97.04, "42093": 2.96}',
    density: 73.6,
    imprecise: false,
    latitude: 41.10332,
    longitude: -76.82678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17777',
  },
  {
    city: 'Westport',
    county_fips: 42035,
    county_fips_all: '42035',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"42035": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 41.28532,
    longitude: -77.96477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17778',
  },
  {
    city: 'Woolrich',
    county_fips: 42035,
    county_fips_all: '42035',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"42035": 100}',
    density: 50.9,
    imprecise: false,
    latitude: 41.20551,
    longitude: -77.38019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17779',
  },
  {
    city: 'Sunbury',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 95.9,
    imprecise: false,
    latitude: 40.83669,
    longitude: -76.75762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17801',
  },
  {
    city: 'Allenwood',
    county_fips: 42081,
    county_fips_all: '42081|42119',
    county: 'Lycoming',
    county_names_all: 'Lycoming|Union',
    county_weights: '{"42081": 73.46, "42119": 26.54}',
    density: 37.2,
    imprecise: false,
    latitude: 41.1123,
    longitude: -77.02543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17810',
  },
  {
    city: 'Beaver Springs',
    county_fips: 42109,
    county_fips_all: '42109',
    county: 'Snyder',
    county_names_all: 'Snyder',
    county_weights: '{"42109": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 40.73626,
    longitude: -77.23641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17812',
  },
  {
    city: 'Beavertown',
    county_fips: 42109,
    county_fips_all: '42109',
    county: 'Snyder',
    county_names_all: 'Snyder',
    county_weights: '{"42109": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 40.78505,
    longitude: -77.1772,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17813',
  },
  {
    city: 'Benton',
    county_fips: 42037,
    county_fips_all: '42037|42113|42079|42081',
    county: 'Columbia',
    county_names_all: 'Columbia|Sullivan|Luzerne|Lycoming',
    county_weights:
      '{"42037": 55.69, "42113": 25.51, "42079": 16.79, "42081": 2.01}',
    density: 14.1,
    imprecise: false,
    latitude: 41.26885,
    longitude: -76.3751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17814',
  },
  {
    city: 'Bloomsburg',
    county_fips: 42037,
    county_fips_all: '42037|42079|42093',
    county: 'Columbia',
    county_names_all: 'Columbia|Luzerne|Montour',
    county_weights: '{"42037": 97.38, "42079": 2.31, "42093": 0.31}',
    density: 91.5,
    imprecise: false,
    latitude: 41.02216,
    longitude: -76.43061,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17815',
  },
  {
    city: 'Catawissa',
    county_fips: 42037,
    county_fips_all: '42037|42093',
    county: 'Columbia',
    county_names_all: 'Columbia|Montour',
    county_weights: '{"42037": 93.97, "42093": 6.03}',
    density: 24.5,
    imprecise: false,
    latitude: 40.9011,
    longitude: -76.40783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17820',
  },
  {
    city: 'Danville',
    county_fips: 42093,
    county_fips_all: '42093|42097|42037',
    county: 'Montour',
    county_names_all: 'Montour|Northumberland|Columbia',
    county_weights: '{"42093": 70.35, "42097": 23.73, "42037": 5.92}',
    density: 53.5,
    imprecise: false,
    latitude: 40.9917,
    longitude: -76.63959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17821',
  },
  {
    city: 'Dornsife',
    county_fips: 42097,
    county_fips_all: '42097|42107',
    county: 'Northumberland',
    county_names_all: 'Northumberland|Schuylkill',
    county_weights: '{"42097": 99.83, "42107": 0.17}',
    density: 14.2,
    imprecise: false,
    latitude: 40.72099,
    longitude: -76.72541,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17823',
  },
  {
    city: 'Elysburg',
    county_fips: 42037,
    county_fips_all: '42037|42097|42093',
    county: 'Columbia',
    county_names_all: 'Columbia|Northumberland|Montour',
    county_weights: '{"42037": 54.74, "42097": 43.75, "42093": 1.51}',
    density: 54.3,
    imprecise: false,
    latitude: 40.85652,
    longitude: -76.49848,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17824',
  },
  {
    city: 'Freeburg',
    county_fips: 42109,
    county_fips_all: '42109',
    county: 'Snyder',
    county_names_all: 'Snyder',
    county_weights: '{"42109": 100}',
    density: 167.2,
    imprecise: false,
    latitude: 40.75482,
    longitude: -76.96133,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17827',
  },
  {
    city: 'Hartleton',
    county_fips: 42119,
    county_fips_all: '42119',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"42119": 100}',
    density: 113.1,
    imprecise: false,
    latitude: 40.90057,
    longitude: -77.15546,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17829',
  },
  {
    city: 'Herndon',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 24.3,
    imprecise: false,
    latitude: 40.68791,
    longitude: -76.79449,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17830',
  },
  {
    city: 'Marion Heights',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 285,
    imprecise: false,
    latitude: 40.80554,
    longitude: -76.45499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17832',
  },
  {
    city: 'Kulpmont',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 238.6,
    imprecise: false,
    latitude: 40.77982,
    longitude: -76.46701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17834',
  },
  {
    city: 'Laurelton',
    county_fips: 42119,
    county_fips_all: '42119',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"42119": 100}',
    density: 492,
    imprecise: false,
    latitude: 40.88365,
    longitude: -77.19795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17835',
  },
  {
    city: 'Leck Kill',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 21,
    imprecise: false,
    latitude: 40.71446,
    longitude: -76.60136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17836',
  },
  {
    city: 'Lewisburg',
    county_fips: 42119,
    county_fips_all: '42119',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"42119": 100}',
    density: 126.5,
    imprecise: false,
    latitude: 40.97485,
    longitude: -76.94247,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17837',
  },
  {
    city: 'Locust Gap',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 36.6,
    imprecise: false,
    latitude: 40.77537,
    longitude: -76.43291,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17840',
  },
  {
    city: 'McClure',
    county_fips: 42087,
    county_fips_all: '42087|42109',
    county: 'Mifflin',
    county_names_all: 'Mifflin|Snyder',
    county_weights: '{"42087": 53.82, "42109": 46.18}',
    density: 25.8,
    imprecise: false,
    latitude: 40.72455,
    longitude: -77.35888,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17841',
  },
  {
    city: 'Middleburg',
    county_fips: 42109,
    county_fips_all: '42109',
    county: 'Snyder',
    county_names_all: 'Snyder',
    county_weights: '{"42109": 100}',
    density: 40.2,
    imprecise: false,
    latitude: 40.80389,
    longitude: -77.04329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17842',
  },
  {
    city: 'Mifflinburg',
    county_fips: 42119,
    county_fips_all: '42119',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"42119": 100}',
    density: 37.3,
    imprecise: false,
    latitude: 40.95904,
    longitude: -77.08747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17844',
  },
  {
    city: 'Millmont',
    county_fips: 42119,
    county_fips_all: '42119',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"42119": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 40.88308,
    longitude: -77.21628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17845',
  },
  {
    city: 'Millville',
    county_fips: 42037,
    county_fips_all: '42037|42081',
    county: 'Columbia',
    county_names_all: 'Columbia|Lycoming',
    county_weights: '{"42037": 96.45, "42081": 3.55}',
    density: 29.8,
    imprecise: false,
    latitude: 41.14647,
    longitude: -76.51681,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17846',
  },
  {
    city: 'Milton',
    county_fips: 42097,
    county_fips_all: '42097|42093',
    county: 'Northumberland',
    county_names_all: 'Northumberland|Montour',
    county_weights: '{"42097": 80.52, "42093": 19.48}',
    density: 93.9,
    imprecise: false,
    latitude: 41.00609,
    longitude: -76.80612,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17847',
  },
  {
    city: 'Montandon',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 493.8,
    imprecise: false,
    latitude: 40.9671,
    longitude: -76.85847,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17850',
  },
  {
    city: 'Mount Carmel',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 186.4,
    imprecise: false,
    latitude: 40.80255,
    longitude: -76.433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17851',
  },
  {
    city: 'Mount Pleasant Mills',
    county_fips: 42109,
    county_fips_all: '42109|42067',
    county: 'Snyder',
    county_names_all: 'Snyder|Juniata',
    county_weights: '{"42109": 81.88, "42067": 18.12}',
    density: 26.6,
    imprecise: false,
    latitude: 40.69212,
    longitude: -77.01254,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17853',
  },
  {
    city: 'New Berlin',
    county_fips: 42119,
    county_fips_all: '42119',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"42119": 100}',
    density: 202,
    imprecise: false,
    latitude: 40.88735,
    longitude: -76.97217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17855',
  },
  {
    city: 'New Columbia',
    county_fips: 42119,
    county_fips_all: '42119',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"42119": 100}',
    density: 25.1,
    imprecise: false,
    latitude: 41.05636,
    longitude: -76.9722,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17856',
  },
  {
    city: 'Northumberland',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 111.1,
    imprecise: false,
    latitude: 40.92789,
    longitude: -76.76712,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17857',
  },
  {
    city: 'Numidia',
    county_fips: 42037,
    county_fips_all: '42037',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"42037": 100}',
    density: 135.1,
    imprecise: false,
    latitude: 40.84238,
    longitude: -76.42314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17858',
  },
  {
    city: 'Orangeville',
    county_fips: 42037,
    county_fips_all: '42037',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"42037": 100}',
    density: 27.6,
    imprecise: false,
    latitude: 41.11821,
    longitude: -76.39498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17859',
  },
  {
    city: 'Paxinos',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 32,
    imprecise: false,
    latitude: 40.82685,
    longitude: -76.63402,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17860',
  },
  {
    city: 'Paxtonville',
    county_fips: 42109,
    county_fips_all: '42109',
    county: 'Snyder',
    county_names_all: 'Snyder',
    county_weights: '{"42109": 100}',
    density: 121.7,
    imprecise: false,
    latitude: 40.77361,
    longitude: -77.0788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17861',
  },
  {
    city: 'Penns Creek',
    county_fips: 42109,
    county_fips_all: '42109',
    county: 'Snyder',
    county_names_all: 'Snyder',
    county_weights: '{"42109": 100}',
    density: 548,
    imprecise: false,
    latitude: 40.86069,
    longitude: -77.05661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17862',
  },
  {
    city: 'Port Trevorton',
    county_fips: 42109,
    county_fips_all: '42109',
    county: 'Snyder',
    county_names_all: 'Snyder',
    county_weights: '{"42109": 100}',
    density: 45.8,
    imprecise: false,
    latitude: 40.70294,
    longitude: -76.90687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17864',
  },
  {
    city: 'Potts Grove',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 21,
    imprecise: false,
    latitude: 40.98688,
    longitude: -76.78979,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17865',
  },
  {
    city: 'Coal Township',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 154.7,
    imprecise: false,
    latitude: 40.78866,
    longitude: -76.55035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17866',
  },
  {
    city: 'Rebuck',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 31.4,
    imprecise: false,
    latitude: 40.71464,
    longitude: -76.69025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17867',
  },
  {
    city: 'Riverside',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 801.6,
    imprecise: false,
    latitude: 40.95536,
    longitude: -76.63098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17868',
  },
  {
    city: 'Selinsgrove',
    county_fips: 42109,
    county_fips_all: '42109|42119',
    county: 'Snyder',
    county_names_all: 'Snyder|Union',
    county_weights: '{"42109": 97.97, "42119": 2.03}',
    density: 122.1,
    imprecise: false,
    latitude: 40.80992,
    longitude: -76.8897,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17870',
  },
  {
    city: 'Shamokin',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 79.8,
    imprecise: false,
    latitude: 40.7677,
    longitude: -76.61317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17872',
  },
  {
    city: 'Shamokin Dam',
    county_fips: 42109,
    county_fips_all: '42109',
    county: 'Snyder',
    county_names_all: 'Snyder',
    county_weights: '{"42109": 100}',
    density: 385.8,
    imprecise: false,
    latitude: 40.85571,
    longitude: -76.82319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17876',
  },
  {
    city: 'Stillwater',
    county_fips: 42037,
    county_fips_all: '42037|42079',
    county: 'Columbia',
    county_names_all: 'Columbia|Luzerne',
    county_weights: '{"42037": 70.95, "42079": 29.05}',
    density: 26.1,
    imprecise: false,
    latitude: 41.1721,
    longitude: -76.32364,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17878',
  },
  {
    city: 'Swengel',
    county_fips: 42119,
    county_fips_all: '42119',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"42119": 100}',
    density: 257.8,
    imprecise: false,
    latitude: 40.89109,
    longitude: -77.12383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17880',
  },
  {
    city: 'Trevorton',
    county_fips: 42097,
    county_fips_all: '42097',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"42097": 100}',
    density: 206.6,
    imprecise: false,
    latitude: 40.78098,
    longitude: -76.68632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17881',
  },
  {
    city: 'Washingtonville',
    county_fips: 42093,
    county_fips_all: '42093',
    county: 'Montour',
    county_names_all: 'Montour',
    county_weights: '{"42093": 100}',
    density: 1641.8,
    imprecise: false,
    latitude: 41.05201,
    longitude: -76.67509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17884',
  },
  {
    city: 'Weikert',
    county_fips: 42119,
    county_fips_all: '42119',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"42119": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 40.87042,
    longitude: -77.28941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17885',
  },
  {
    city: 'West Milton',
    county_fips: 42119,
    county_fips_all: '42119',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"42119": 100}',
    density: 395.2,
    imprecise: false,
    latitude: 41.01847,
    longitude: -76.87598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17886',
  },
  {
    city: 'White Deer',
    county_fips: 42119,
    county_fips_all: '42119',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"42119": 100}',
    density: 1395.4,
    imprecise: false,
    latitude: 41.07508,
    longitude: -76.8849,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17887',
  },
  {
    city: 'Wilburton',
    county_fips: 42037,
    county_fips_all: '42037',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"42037": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 40.81931,
    longitude: -76.37306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17888',
  },
  {
    city: 'Winfield',
    county_fips: 42109,
    county_fips_all: '42109|42119',
    county: 'Snyder',
    county_names_all: 'Snyder|Union',
    county_weights: '{"42109": 58.96, "42119": 41.04}',
    density: 47.7,
    imprecise: false,
    latitude: 40.88228,
    longitude: -76.9143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17889',
  },
  {
    city: 'Pottsville',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 108.8,
    imprecise: false,
    latitude: 40.69364,
    longitude: -76.25526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17901',
  },
  {
    city: 'Aristes',
    county_fips: 42037,
    county_fips_all: '42037',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"42037": 100}',
    density: 42.2,
    imprecise: false,
    latitude: 40.81328,
    longitude: -76.32989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17920',
  },
  {
    city: 'Ashland',
    county_fips: 42107,
    county_fips_all: '42107|42037',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill|Columbia',
    county_weights: '{"42107": 91.46, "42037": 8.54}',
    density: 76.4,
    imprecise: false,
    latitude: 40.75422,
    longitude: -76.35732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17921',
  },
  {
    city: 'Auburn',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 60,
    imprecise: false,
    latitude: 40.592,
    longitude: -76.11212,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17922',
  },
  {
    city: 'Branchdale',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 53.8,
    imprecise: false,
    latitude: 40.66136,
    longitude: -76.31871,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17923',
  },
  {
    city: 'Brockton',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 121.8,
    imprecise: false,
    latitude: 40.75609,
    longitude: -76.07047,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17925',
  },
  {
    city: 'Cressona',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 486.7,
    imprecise: false,
    latitude: 40.63104,
    longitude: -76.19273,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17929',
  },
  {
    city: 'Cumbola',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 32.6,
    imprecise: false,
    latitude: 40.70867,
    longitude: -76.11529,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17930',
  },
  {
    city: 'Frackville',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 648.8,
    imprecise: false,
    latitude: 40.78378,
    longitude: -76.21638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17931',
  },
  {
    city: 'Friedensburg',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 395.1,
    imprecise: false,
    latitude: 40.60357,
    longitude: -76.24244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17933',
  },
  {
    city: 'Gilberton',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 215.5,
    imprecise: false,
    latitude: 40.79786,
    longitude: -76.21205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17934',
  },
  {
    city: 'Girardville',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 93.7,
    imprecise: false,
    latitude: 40.79417,
    longitude: -76.28,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17935',
  },
  {
    city: 'Gordon',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 595.7,
    imprecise: false,
    latitude: 40.75048,
    longitude: -76.33997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17936',
  },
  {
    city: 'Hegins',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 23.3,
    imprecise: false,
    latitude: 40.65558,
    longitude: -76.50198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17938',
  },
  {
    city: 'Klingerstown',
    county_fips: 42107,
    county_fips_all: '42107|42097',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill|Northumberland',
    county_weights: '{"42107": 63.82, "42097": 36.18}',
    density: 11.1,
    imprecise: false,
    latitude: 40.68614,
    longitude: -76.61472,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17941',
  },
  {
    city: 'Lavelle',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 121.9,
    imprecise: false,
    latitude: 40.76161,
    longitude: -76.37949,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17943',
  },
  {
    city: 'Llewellyn',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 80.9,
    imprecise: false,
    latitude: 40.6605,
    longitude: -76.28903,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17944',
  },
  {
    city: 'Locustdale',
    county_fips: 42037,
    county_fips_all: '42037|42107',
    county: 'Columbia',
    county_names_all: 'Columbia|Schuylkill',
    county_weights: '{"42037": 97.46, "42107": 2.54}',
    density: 49,
    imprecise: false,
    latitude: 40.78458,
    longitude: -76.37523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17945',
  },
  {
    city: 'Lost Creek',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 41.6,
    imprecise: false,
    latitude: 40.8123,
    longitude: -76.2449,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17946',
  },
  {
    city: 'Mahanoy City',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 84.3,
    imprecise: false,
    latitude: 40.82485,
    longitude: -76.14223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17948',
  },
  {
    city: 'Mahanoy Plane',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 289.8,
    imprecise: false,
    latitude: 40.79624,
    longitude: -76.23547,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17949',
  },
  {
    city: 'Mar Lin',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 897.6,
    imprecise: false,
    latitude: 40.67919,
    longitude: -76.24425,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17951',
  },
  {
    city: 'Mary D',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 38.6,
    imprecise: false,
    latitude: 40.76434,
    longitude: -76.05997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17952',
  },
  {
    city: 'Middleport',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 40.74728,
    longitude: -76.09969,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17953',
  },
  {
    city: 'Minersville',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 2526.6,
    imprecise: false,
    latitude: 40.69047,
    longitude: -76.25985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17954',
  },
  {
    city: 'Muir',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 576.6,
    imprecise: false,
    latitude: 40.59359,
    longitude: -76.51651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17957',
  },
  {
    city: 'New Philadelphia',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 39.9,
    imprecise: false,
    latitude: 40.74224,
    longitude: -76.15141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17959',
  },
  {
    city: 'New Ringgold',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 31.4,
    imprecise: false,
    latitude: 40.69932,
    longitude: -75.94656,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17960',
  },
  {
    city: 'Orwigsburg',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 101.6,
    imprecise: false,
    latitude: 40.64713,
    longitude: -76.05988,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17961',
  },
  {
    city: 'Pine Grove',
    county_fips: 42107,
    county_fips_all: '42107|42075',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill|Lebanon',
    county_weights: '{"42107": 96.37, "42075": 3.63}',
    density: 43,
    imprecise: false,
    latitude: 40.56133,
    longitude: -76.39548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17963',
  },
  {
    city: 'Pitman',
    county_fips: 42107,
    county_fips_all: '42107|42097',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill|Northumberland',
    county_weights: '{"42107": 89.77, "42097": 10.23}',
    density: 15.9,
    imprecise: false,
    latitude: 40.71415,
    longitude: -76.49785,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17964',
  },
  {
    city: 'Port Carbon',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 666.1,
    imprecise: false,
    latitude: 40.69919,
    longitude: -76.16536,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17965',
  },
  {
    city: 'Ringtown',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 24.6,
    imprecise: false,
    latitude: 40.86047,
    longitude: -76.20945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17967',
  },
  {
    city: 'Sacramento',
    county_fips: 42107,
    county_fips_all: '42107|42043',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill|Dauphin',
    county_weights: '{"42107": 99.71, "42043": 0.29}',
    density: 22.2,
    imprecise: false,
    latitude: 40.6417,
    longitude: -76.62625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17968',
  },
  {
    city: 'Saint Clair',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 961.8,
    imprecise: false,
    latitude: 40.72072,
    longitude: -76.19056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17970',
  },
  {
    city: 'Schuylkill Haven',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 93.9,
    imprecise: false,
    latitude: 40.58199,
    longitude: -76.21367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17972',
  },
  {
    city: 'Seltzer',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 1586,
    imprecise: false,
    latitude: 40.69592,
    longitude: -76.23606,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17974',
  },
  {
    city: 'Shenandoah',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 300.1,
    imprecise: false,
    latitude: 40.8204,
    longitude: -76.21131,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17976',
  },
  {
    city: 'Spring Glen',
    county_fips: 42043,
    county_fips_all: '42043|42107',
    county: 'Dauphin',
    county_names_all: 'Dauphin|Schuylkill',
    county_weights: '{"42043": 60.44, "42107": 39.56}',
    density: 39.2,
    imprecise: false,
    latitude: 40.6165,
    longitude: -76.65219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17978',
  },
  {
    city: 'Summit Station',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 162.5,
    imprecise: false,
    latitude: 40.56729,
    longitude: -76.20207,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17979',
  },
  {
    city: 'Tower City',
    county_fips: 42043,
    county_fips_all: '42043|42107',
    county: 'Dauphin',
    county_names_all: 'Dauphin|Schuylkill',
    county_weights: '{"42043": 68.44, "42107": 31.56}',
    density: 37.1,
    imprecise: false,
    latitude: 40.531,
    longitude: -76.62065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17980',
  },
  {
    city: 'Tremont',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 25,
    imprecise: false,
    latitude: 40.63077,
    longitude: -76.39523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17981',
  },
  {
    city: 'Tuscarora',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 695.4,
    imprecise: false,
    latitude: 40.76798,
    longitude: -76.03827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17982',
  },
  {
    city: 'Valley View',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 218,
    imprecise: false,
    latitude: 40.64403,
    longitude: -76.55027,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17983',
  },
  {
    city: 'Zion Grove',
    county_fips: 42107,
    county_fips_all: '42107|42037',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill|Columbia',
    county_weights: '{"42107": 57.6, "42037": 42.4}',
    density: 13.1,
    imprecise: false,
    latitude: 40.91935,
    longitude: -76.23729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17985',
  },
  {
    city: 'Alburtis',
    county_fips: 42011,
    county_fips_all: '42011|42077',
    county: 'Berks',
    county_names_all: 'Berks|Lehigh',
    county_weights: '{"42011": 76.83, "42077": 23.17}',
    density: 120.4,
    imprecise: false,
    latitude: 40.47288,
    longitude: -75.64395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18011',
  },
  {
    city: 'Aquashicola',
    county_fips: 42025,
    county_fips_all: '42025',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"42025": 100}',
    density: 1086.9,
    imprecise: false,
    latitude: 40.81135,
    longitude: -75.59158,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18012',
  },
  {
    city: 'Bangor',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 107.8,
    imprecise: false,
    latitude: 40.85511,
    longitude: -75.17114,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18013',
  },
  {
    city: 'Bath',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 142.6,
    imprecise: false,
    latitude: 40.7654,
    longitude: -75.40923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18014',
  },
  {
    city: 'Bethlehem',
    county_fips: 42095,
    county_fips_all: '42095|42077',
    county: 'Northampton',
    county_names_all: 'Northampton|Lehigh',
    county_weights: '{"42095": 65.21, "42077": 34.79}',
    density: 580.3,
    imprecise: false,
    latitude: 40.5887,
    longitude: -75.36786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18015',
  },
  {
    city: 'Bethlehem',
    county_fips: 42095,
    county_fips_all: '42095|42077',
    county: 'Northampton',
    county_names_all: 'Northampton|Lehigh',
    county_weights: '{"42095": 94.84, "42077": 5.16}',
    density: 936.3,
    imprecise: false,
    latitude: 40.66069,
    longitude: -75.38739,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18017',
  },
  {
    city: 'Bethlehem',
    county_fips: 42077,
    county_fips_all: '42077|42095',
    county: 'Lehigh',
    county_names_all: 'Lehigh|Northampton',
    county_weights: '{"42077": 66.51, "42095": 33.49}',
    density: 2460.9,
    imprecise: false,
    latitude: 40.62766,
    longitude: -75.39538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18018',
  },
  {
    city: 'Bethlehem',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 628.9,
    imprecise: false,
    latitude: 40.67267,
    longitude: -75.32692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18020',
  },
  {
    city: 'Bowmanstown',
    county_fips: 42025,
    county_fips_all: '42025',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"42025": 100}',
    density: 626.6,
    imprecise: false,
    latitude: 40.80408,
    longitude: -75.66336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18030',
  },
  {
    city: 'Breinigsville',
    county_fips: 42077,
    county_fips_all: '42077|42011',
    county: 'Lehigh',
    county_names_all: 'Lehigh|Berks',
    county_weights: '{"42077": 98.72, "42011": 1.28}',
    density: 320.8,
    imprecise: false,
    latitude: 40.554,
    longitude: -75.65361,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18031',
  },
  {
    city: 'Catasauqua',
    county_fips: 42077,
    county_fips_all: '42077|42095',
    county: 'Lehigh',
    county_names_all: 'Lehigh|Northampton',
    county_weights: '{"42077": 64.61, "42095": 35.39}',
    density: 1835.8,
    imprecise: false,
    latitude: 40.65694,
    longitude: -75.46776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18032',
  },
  {
    city: 'Center Valley',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 323,
    imprecise: false,
    latitude: 40.54182,
    longitude: -75.41654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18034',
  },
  {
    city: 'Cherryville',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 71.3,
    imprecise: false,
    latitude: 40.75053,
    longitude: -75.54148,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18035',
  },
  {
    city: 'Coopersburg',
    county_fips: 42077,
    county_fips_all: '42077|42017',
    county: 'Lehigh',
    county_names_all: 'Lehigh|Bucks',
    county_weights: '{"42077": 62.32, "42017": 37.68}',
    density: 206.2,
    imprecise: false,
    latitude: 40.50925,
    longitude: -75.38891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18036',
  },
  {
    city: 'Coplay',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 379.1,
    imprecise: false,
    latitude: 40.68203,
    longitude: -75.54638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18037',
  },
  {
    city: 'Danielsville',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 101.8,
    imprecise: false,
    latitude: 40.79574,
    longitude: -75.48246,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18038',
  },
  {
    city: 'Easton',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 385.6,
    imprecise: false,
    latitude: 40.7459,
    longitude: -75.22172,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18040',
  },
  {
    city: 'East Greenville',
    county_fips: 42091,
    county_fips_all: '42091|42077|42017|42011',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Lehigh|Bucks|Berks',
    county_weights:
      '{"42091": 64.27, "42077": 27.92, "42017": 4.88, "42011": 2.93}',
    density: 175.2,
    imprecise: false,
    latitude: 40.41742,
    longitude: -75.51306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18041',
  },
  {
    city: 'Easton',
    county_fips: 42095,
    county_fips_all: '42095|42017',
    county: 'Northampton',
    county_names_all: 'Northampton|Bucks',
    county_weights: '{"42095": 99.3, "42017": 0.7}',
    density: 795,
    imprecise: false,
    latitude: 40.6497,
    longitude: -75.22376,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18042',
  },
  {
    city: 'Easton',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 610,
    imprecise: false,
    latitude: 40.6919,
    longitude: -75.27494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18045',
  },
  {
    city: 'East Texas',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 4253,
    imprecise: false,
    latitude: 40.54803,
    longitude: -75.56029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18046',
  },
  {
    city: 'Emmaus',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 487.6,
    imprecise: false,
    latitude: 40.51912,
    longitude: -75.50018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18049',
  },
  {
    city: 'Fogelsville',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 175.1,
    imprecise: false,
    latitude: 40.59409,
    longitude: -75.66415,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18051',
  },
  {
    city: 'Whitehall',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 891.6,
    imprecise: false,
    latitude: 40.65668,
    longitude: -75.50443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18052',
  },
  {
    city: 'Germansville',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 49.5,
    imprecise: false,
    latitude: 40.71802,
    longitude: -75.70999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18053',
  },
  {
    city: 'Green Lane',
    county_fips: 42091,
    county_fips_all: '42091|42017',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Bucks',
    county_weights: '{"42091": 80.27, "42017": 19.73}',
    density: 112.4,
    imprecise: false,
    latitude: 40.35321,
    longitude: -75.43824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18054',
  },
  {
    city: 'Hellertown',
    county_fips: 42095,
    county_fips_all: '42095|42017',
    county: 'Northampton',
    county_names_all: 'Northampton|Bucks',
    county_weights: '{"42095": 94.35, "42017": 5.65}',
    density: 234.1,
    imprecise: false,
    latitude: 40.58794,
    longitude: -75.29929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18055',
  },
  {
    city: 'Hereford',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 502.4,
    imprecise: false,
    latitude: 40.44798,
    longitude: -75.54911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18056',
  },
  {
    city: 'Kunkletown',
    county_fips: 42089,
    county_fips_all: '42089|42025',
    county: 'Monroe',
    county_names_all: 'Monroe|Carbon',
    county_weights: '{"42089": 84.15, "42025": 15.85}',
    density: 70.2,
    imprecise: false,
    latitude: 40.8922,
    longitude: -75.49094,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18058',
  },
  {
    city: 'Laurys Station',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 178.3,
    imprecise: false,
    latitude: 40.7233,
    longitude: -75.53644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18059',
  },
  {
    city: 'Macungie',
    county_fips: 42077,
    county_fips_all: '42077|42011',
    county: 'Lehigh',
    county_names_all: 'Lehigh|Berks',
    county_weights: '{"42077": 69.72, "42011": 30.28}',
    density: 498.8,
    imprecise: false,
    latitude: 40.5035,
    longitude: -75.57886,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18062',
  },
  {
    city: 'Martins Creek',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 550.2,
    imprecise: false,
    latitude: 40.78229,
    longitude: -75.18164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18063',
  },
  {
    city: 'Nazareth',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 270.4,
    imprecise: false,
    latitude: 40.75755,
    longitude: -75.31927,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18064',
  },
  {
    city: 'Neffs',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 1337,
    imprecise: false,
    latitude: 40.69814,
    longitude: -75.61086,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18065',
  },
  {
    city: 'New Tripoli',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 53.4,
    imprecise: false,
    latitude: 40.6635,
    longitude: -75.74492,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18066',
  },
  {
    city: 'Northampton',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 296.5,
    imprecise: false,
    latitude: 40.71792,
    longitude: -75.47937,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18067',
  },
  {
    city: 'Orefield',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 232.5,
    imprecise: false,
    latitude: 40.626,
    longitude: -75.616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18069',
  },
  {
    city: 'Palm',
    county_fips: 42091,
    county_fips_all: '42091|42011',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Berks',
    county_weights: '{"42091": 60.85, "42011": 39.15}',
    density: 27.2,
    imprecise: false,
    latitude: 40.4317,
    longitude: -75.53884,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18070',
  },
  {
    city: 'Palmerton',
    county_fips: 42025,
    county_fips_all: '42025|42089',
    county: 'Carbon',
    county_names_all: 'Carbon|Monroe',
    county_weights: '{"42025": 96.89, "42089": 3.11}',
    density: 140.4,
    imprecise: false,
    latitude: 40.83098,
    longitude: -75.57843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18071',
  },
  {
    city: 'Pen Argyl',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 180,
    imprecise: false,
    latitude: 40.84548,
    longitude: -75.25842,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18072',
  },
  {
    city: 'Pennsburg',
    county_fips: 42091,
    county_fips_all: '42091|42017',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Bucks',
    county_weights: '{"42091": 85.48, "42017": 14.52}',
    density: 251.8,
    imprecise: false,
    latitude: 40.38378,
    longitude: -75.47702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18073',
  },
  {
    city: 'Perkiomenville',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 119.4,
    imprecise: false,
    latitude: 40.31971,
    longitude: -75.51424,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18074',
  },
  {
    city: 'Red Hill',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 896,
    imprecise: false,
    latitude: 40.37382,
    longitude: -75.48154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18076',
  },
  {
    city: 'Riegelsville',
    county_fips: 42017,
    county_fips_all: '42017|42095',
    county: 'Bucks',
    county_names_all: 'Bucks|Northampton',
    county_weights: '{"42017": 93.1, "42095": 6.9}',
    density: 63.4,
    imprecise: false,
    latitude: 40.56603,
    longitude: -75.24115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18077',
  },
  {
    city: 'Schnecksville',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 195.1,
    imprecise: false,
    latitude: 40.67181,
    longitude: -75.62096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18078',
  },
  {
    city: 'Slatedale',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 471.2,
    imprecise: false,
    latitude: 40.74415,
    longitude: -75.65754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18079',
  },
  {
    city: 'Slatington',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 143.5,
    imprecise: false,
    latitude: 40.73618,
    longitude: -75.63227,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18080',
  },
  {
    city: 'Springtown',
    county_fips: 42017,
    county_fips_all: '42017|42095',
    county: 'Bucks',
    county_names_all: 'Bucks|Northampton',
    county_weights: '{"42017": 99.58, "42095": 0.42}',
    density: 64.1,
    imprecise: false,
    latitude: 40.56236,
    longitude: -75.28396,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 85,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18081',
  },
  {
    city: 'Stockertown',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 273.8,
    imprecise: false,
    latitude: 40.75494,
    longitude: -75.2637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18083',
  },
  {
    city: 'Tatamy',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 1217.8,
    imprecise: false,
    latitude: 40.74174,
    longitude: -75.25434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18085',
  },
  {
    city: 'Treichlers',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 618.3,
    imprecise: false,
    latitude: 40.73867,
    longitude: -75.54757,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18086',
  },
  {
    city: 'Trexlertown',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 215.2,
    imprecise: false,
    latitude: 40.55398,
    longitude: -75.59588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18087',
  },
  {
    city: 'Walnutport',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 172,
    imprecise: false,
    latitude: 40.76578,
    longitude: -75.5576,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18088',
  },
  {
    city: 'Wind Gap',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 170.3,
    imprecise: false,
    latitude: 40.82656,
    longitude: -75.32068,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18091',
  },
  {
    city: 'Zionsville',
    county_fips: 42077,
    county_fips_all: '42077|42011',
    county: 'Lehigh',
    county_names_all: 'Lehigh|Berks',
    county_weights: '{"42077": 92.44, "42011": 7.56}',
    density: 83,
    imprecise: false,
    latitude: 40.46844,
    longitude: -75.51372,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18092',
  },
  {
    city: 'Allentown',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 7694.6,
    imprecise: false,
    latitude: 40.60301,
    longitude: -75.4698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18101',
  },
  {
    city: 'Allentown',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 6606.4,
    imprecise: false,
    latitude: 40.60792,
    longitude: -75.47613,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18102',
  },
  {
    city: 'Allentown',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 1096.9,
    imprecise: false,
    latitude: 40.57223,
    longitude: -75.48138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18103',
  },
  {
    city: 'Allentown',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 819,
    imprecise: false,
    latitude: 40.61122,
    longitude: -75.54699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18104',
  },
  {
    city: 'Allentown',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 302.1,
    imprecise: false,
    latitude: 40.57472,
    longitude: -75.59542,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18106',
  },
  {
    city: 'Allentown',
    county_fips: 42077,
    county_fips_all: '42077|42095',
    county: 'Lehigh',
    county_names_all: 'Lehigh|Northampton',
    county_weights: '{"42077": 94.98, "42095": 5.02}',
    density: 863.5,
    imprecise: false,
    latitude: 40.63673,
    longitude: -75.44043,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18109',
  },
  {
    city: 'Allentown',
    county_fips: 42077,
    county_fips_all: '42077',
    county: 'Lehigh',
    county_names_all: 'Lehigh',
    county_weights: '{"42077": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.58427,
    longitude: -75.62479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18195',
  },
  {
    city: 'Hazleton',
    county_fips: 42079,
    county_fips_all: '42079|42025',
    county: 'Luzerne',
    county_names_all: 'Luzerne|Carbon',
    county_weights: '{"42079": 97.59, "42025": 2.41}',
    density: 708.7,
    imprecise: false,
    latitude: 40.95198,
    longitude: -75.95395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18201',
  },
  {
    city: 'Hazleton',
    county_fips: 42079,
    county_fips_all: '42079|42107',
    county: 'Luzerne',
    county_names_all: 'Luzerne|Schuylkill',
    county_weights: '{"42079": 88.76, "42107": 11.24}',
    density: 151.6,
    imprecise: false,
    latitude: 40.94874,
    longitude: -76.0483,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18202',
  },
  {
    city: 'Albrightsville',
    county_fips: 42025,
    county_fips_all: '42025|42089',
    county: 'Carbon',
    county_names_all: 'Carbon|Monroe',
    county_weights: '{"42025": 93.47, "42089": 6.53}',
    density: 81.8,
    imprecise: false,
    latitude: 41.00057,
    longitude: -75.59146,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18210',
  },
  {
    city: 'Andreas',
    county_fips: 42107,
    county_fips_all: '42107|42025',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill|Carbon',
    county_weights: '{"42107": 96.27, "42025": 3.73}',
    density: 23.1,
    imprecise: false,
    latitude: 40.74315,
    longitude: -75.82314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18211',
  },
  {
    city: 'Ashfield',
    county_fips: 42025,
    county_fips_all: '42025',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"42025": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 40.77292,
    longitude: -75.71883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18212',
  },
  {
    city: 'Barnesville',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 40.80667,
    longitude: -76.08093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18214',
  },
  {
    city: 'Beaver Meadows',
    county_fips: 42025,
    county_fips_all: '42025|42079',
    county: 'Carbon',
    county_names_all: 'Carbon|Luzerne',
    county_weights: '{"42025": 71.92, "42079": 28.08}',
    density: 49.3,
    imprecise: false,
    latitude: 40.94212,
    longitude: -75.90517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18216',
  },
  {
    city: 'Coaldale',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 446.2,
    imprecise: false,
    latitude: 40.81974,
    longitude: -75.91611,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18218',
  },
  {
    city: 'Conyngham',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 500,
    imprecise: false,
    latitude: 40.99105,
    longitude: -76.05824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18219',
  },
  {
    city: 'Delano',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 51.8,
    imprecise: false,
    latitude: 40.83958,
    longitude: -76.07509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18220',
  },
  {
    city: 'Drifton',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 78.8,
    imprecise: false,
    latitude: 41.00152,
    longitude: -75.919,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18221',
  },
  {
    city: 'Drums',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 102.6,
    imprecise: false,
    latitude: 41.03569,
    longitude: -76.00097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18222',
  },
  {
    city: 'Ebervale',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.98221,
    longitude: -75.95011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18223',
  },
  {
    city: 'Freeland',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 163.2,
    imprecise: false,
    latitude: 41.02499,
    longitude: -75.88728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18224',
  },
  {
    city: 'Harleigh',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.98137,
    longitude: -75.97111,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18225',
  },
  {
    city: 'Jim Thorpe',
    county_fips: 42025,
    county_fips_all: '42025',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"42025": 100}',
    density: 64.6,
    imprecise: false,
    latitude: 40.93245,
    longitude: -75.68247,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18229',
  },
  {
    city: 'Junedale',
    county_fips: 42025,
    county_fips_all: '42025',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"42025": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 40.9201,
    longitude: -75.93077,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18230',
  },
  {
    city: 'Kelayres',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 1392.5,
    imprecise: false,
    latitude: 40.90068,
    longitude: -76.00446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18231',
  },
  {
    city: 'Lansford',
    county_fips: 42025,
    county_fips_all: '42025',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"42025": 100}',
    density: 774.3,
    imprecise: false,
    latitude: 40.83515,
    longitude: -75.87939,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18232',
  },
  {
    city: 'Lattimer Mines',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 939.5,
    imprecise: false,
    latitude: 40.99259,
    longitude: -75.96468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18234',
  },
  {
    city: 'Lehighton',
    county_fips: 42025,
    county_fips_all: '42025',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"42025": 100}',
    density: 85.1,
    imprecise: false,
    latitude: 40.83603,
    longitude: -75.692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18235',
  },
  {
    city: 'Mcadoo',
    county_fips: 42107,
    county_fips_all: '42107|42025',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill|Carbon',
    county_weights: '{"42107": 94.25, "42025": 5.75}',
    density: 81.2,
    imprecise: false,
    latitude: 40.88591,
    longitude: -76.02582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18237',
  },
  {
    city: 'Milnesville',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.98962,
    longitude: -75.98154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18239',
  },
  {
    city: 'Nesquehoning',
    county_fips: 42025,
    county_fips_all: '42025|42107',
    county: 'Carbon',
    county_names_all: 'Carbon|Schuylkill',
    county_weights: '{"42025": 86.19, "42107": 13.81}',
    density: 62.3,
    imprecise: false,
    latitude: 40.86279,
    longitude: -75.84727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18240',
  },
  {
    city: 'Nuremberg',
    county_fips: 42079,
    county_fips_all: '42079|42107',
    county: 'Luzerne',
    county_names_all: 'Luzerne|Schuylkill',
    county_weights: '{"42079": 96.99, "42107": 3.01}',
    density: 91.1,
    imprecise: false,
    latitude: 40.94439,
    longitude: -76.16492,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18241',
  },
  {
    city: 'Oneida',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 648,
    imprecise: false,
    latitude: 40.90606,
    longitude: -76.12349,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18242',
  },
  {
    city: 'Parryville',
    county_fips: 42025,
    county_fips_all: '42025',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"42025": 100}',
    density: 134.6,
    imprecise: false,
    latitude: 40.82361,
    longitude: -75.66879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18244',
  },
  {
    city: 'Quakake',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 34.9,
    imprecise: false,
    latitude: 40.8528,
    longitude: -76.03011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18245',
  },
  {
    city: 'Rock Glen',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 40.95743,
    longitude: -76.195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18246',
  },
  {
    city: 'Sheppton',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 52.1,
    imprecise: false,
    latitude: 40.90089,
    longitude: -76.09448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18248',
  },
  {
    city: 'Sugarloaf',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 49,
    imprecise: false,
    latitude: 40.98457,
    longitude: -76.1206,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18249',
  },
  {
    city: 'Summit Hill',
    county_fips: 42025,
    county_fips_all: '42025|42107',
    county: 'Carbon',
    county_names_all: 'Carbon|Schuylkill',
    county_weights: '{"42025": 77.5, "42107": 22.5}',
    density: 115.6,
    imprecise: false,
    latitude: 40.81744,
    longitude: -75.86145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18250',
  },
  {
    city: 'Tamaqua',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 62.6,
    imprecise: false,
    latitude: 40.77857,
    longitude: -75.97893,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18252',
  },
  {
    city: 'Tresckow',
    county_fips: 42025,
    county_fips_all: '42025',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"42025": 100}',
    density: 152.2,
    imprecise: false,
    latitude: 40.91594,
    longitude: -75.96563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18254',
  },
  {
    city: 'Weatherly',
    county_fips: 42025,
    county_fips_all: '42025|42079',
    county: 'Carbon',
    county_names_all: 'Carbon|Luzerne',
    county_weights: '{"42025": 88.75, "42079": 11.25}',
    density: 22.6,
    imprecise: false,
    latitude: 40.93308,
    longitude: -75.82996,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18255',
  },
  {
    city: 'Weston',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 183.3,
    imprecise: false,
    latitude: 40.94044,
    longitude: -76.14752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18256',
  },
  {
    city: 'East Stroudsburg',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 293.7,
    imprecise: false,
    latitude: 41.03141,
    longitude: -75.18316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18301',
  },
  {
    city: 'East Stroudsburg',
    county_fips: 42089,
    county_fips_all: '42089|42103',
    county: 'Monroe',
    county_names_all: 'Monroe|Pike',
    county_weights: '{"42089": 99.19, "42103": 0.81}',
    density: 109.8,
    imprecise: false,
    latitude: 41.09243,
    longitude: -75.11783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18302',
  },
  {
    city: 'Bartonsville',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 235.1,
    imprecise: false,
    latitude: 41.01734,
    longitude: -75.28754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18321',
  },
  {
    city: 'Brodheadsville',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 151.9,
    imprecise: false,
    latitude: 40.9221,
    longitude: -75.39714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18322',
  },
  {
    city: 'Buck Hill Falls',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 43.3,
    imprecise: false,
    latitude: 41.19558,
    longitude: -75.27264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18323',
  },
  {
    city: 'Bushkill',
    county_fips: 42103,
    county_fips_all: '42103|42089',
    county: 'Pike',
    county_names_all: 'Pike|Monroe',
    county_weights: '{"42103": 99.45, "42089": 0.55}',
    density: 120.4,
    imprecise: false,
    latitude: 41.14712,
    longitude: -75.0001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18324',
  },
  {
    city: 'Canadensis',
    county_fips: 42089,
    county_fips_all: '42089|42103',
    county: 'Monroe',
    county_names_all: 'Monroe|Pike',
    county_weights: '{"42089": 72.53, "42103": 27.47}',
    density: 24.2,
    imprecise: false,
    latitude: 41.22545,
    longitude: -75.22268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18325',
  },
  {
    city: 'Cresco',
    county_fips: 42089,
    county_fips_all: '42089|42103',
    county: 'Monroe',
    county_names_all: 'Monroe|Pike',
    county_weights: '{"42089": 97.18, "42103": 2.82}',
    density: 41.1,
    imprecise: false,
    latitude: 41.15617,
    longitude: -75.25186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18326',
  },
  {
    city: 'Delaware Water Gap',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 498.7,
    imprecise: false,
    latitude: 40.98341,
    longitude: -75.14665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18327',
  },
  {
    city: 'Dingmans Ferry',
    county_fips: 42103,
    county_fips_all: '42103',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"42103": 100}',
    density: 28.2,
    imprecise: false,
    latitude: 41.22531,
    longitude: -75.00633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18328',
  },
  {
    city: 'Effort',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 219.4,
    imprecise: false,
    latitude: 40.96505,
    longitude: -75.45285,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18330',
  },
  {
    city: 'Gilbert',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 96.3,
    imprecise: false,
    latitude: 40.90878,
    longitude: -75.44076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18331',
  },
  {
    city: 'Henryville',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 94,
    imprecise: false,
    latitude: 41.0922,
    longitude: -75.25968,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18332',
  },
  {
    city: 'Kresgeville',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 33.9,
    imprecise: false,
    latitude: 40.89833,
    longitude: -75.49104,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18333',
  },
  {
    city: 'Long Pond',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 73.2,
    imprecise: false,
    latitude: 41.07208,
    longitude: -75.44298,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18334',
  },
  {
    city: 'Marshalls Creek',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 256.2,
    imprecise: false,
    latitude: 41.06413,
    longitude: -75.10455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18335',
  },
  {
    city: 'Matamoras',
    county_fips: 42103,
    county_fips_all: '42103',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"42103": 100}',
    density: 138,
    imprecise: false,
    latitude: 41.37566,
    longitude: -74.73674,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18336',
  },
  {
    city: 'Milford',
    county_fips: 42103,
    county_fips_all: '42103',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"42103": 100}',
    density: 85,
    imprecise: false,
    latitude: 41.33406,
    longitude: -74.87342,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18337',
  },
  {
    city: 'Millrift',
    county_fips: 42103,
    county_fips_all: '42103',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"42103": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 41.42027,
    longitude: -74.77503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18340',
  },
  {
    city: 'Mountainhome',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 41.17045,
    longitude: -75.30485,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18342',
  },
  {
    city: 'Mount Bethel',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 69,
    imprecise: false,
    latitude: 40.89043,
    longitude: -75.1058,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18343',
  },
  {
    city: 'Mount Pocono',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 166.8,
    imprecise: false,
    latitude: 41.11735,
    longitude: -75.34442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18344',
  },
  {
    city: 'Pocono Summit',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 45.7,
    imprecise: false,
    latitude: 41.14643,
    longitude: -75.42752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18346',
  },
  {
    city: 'Pocono Lake',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 28.8,
    imprecise: false,
    latitude: 41.15116,
    longitude: -75.53664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18347',
  },
  {
    city: 'Pocono Manor',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 38.1,
    imprecise: false,
    latitude: 41.0995,
    longitude: -75.3682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 85,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18349',
  },
  {
    city: 'Pocono Pines',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 59.7,
    imprecise: false,
    latitude: 41.11339,
    longitude: -75.45633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18350',
  },
  {
    city: 'Portland',
    county_fips: 42095,
    county_fips_all: '42095',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"42095": 100}',
    density: 634.2,
    imprecise: false,
    latitude: 40.92321,
    longitude: -75.10063,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18351',
  },
  {
    city: 'Saylorsburg',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 95.3,
    imprecise: false,
    latitude: 40.89848,
    longitude: -75.36953,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18353',
  },
  {
    city: 'Sciota',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 131.7,
    imprecise: false,
    latitude: 40.92561,
    longitude: -75.32831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18354',
  },
  {
    city: 'Scotrun',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 59.4,
    imprecise: false,
    latitude: 41.07301,
    longitude: -75.35553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18355',
  },
  {
    city: 'Shawnee On Delaware',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.01574,
    longitude: -75.11192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18356',
  },
  {
    city: 'Skytop',
    county_fips: 42089,
    county_fips_all: '42089|42103',
    county: 'Monroe',
    county_names_all: 'Monroe|Pike',
    county_weights: '{"42089": 99.74, "42103": 0.26}',
    density: 11.2,
    imprecise: false,
    latitude: 41.22956,
    longitude: -75.2191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18357',
  },
  {
    city: 'Stroudsburg',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 134.3,
    imprecise: false,
    latitude: 40.97254,
    longitude: -75.28562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18360',
  },
  {
    city: 'Swiftwater',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 117.9,
    imprecise: false,
    latitude: 41.08926,
    longitude: -75.33771,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18370',
  },
  {
    city: 'Tamiment',
    county_fips: 42103,
    county_fips_all: '42103',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"42103": 100}',
    density: 36.7,
    imprecise: false,
    latitude: 41.15837,
    longitude: -75.03658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18371',
  },
  {
    city: 'Tannersville',
    county_fips: 42089,
    county_fips_all: '42089',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"42089": 100}',
    density: 130.4,
    imprecise: false,
    latitude: 41.04777,
    longitude: -75.32512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18372',
  },
  {
    city: 'Archbald',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 137.5,
    imprecise: false,
    latitude: 41.50495,
    longitude: -75.53529,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18403',
  },
  {
    city: 'Beach Lake',
    county_fips: 42127,
    county_fips_all: '42127|42103',
    county: 'Wayne',
    county_names_all: 'Wayne|Pike',
    county_weights: '{"42127": 76.05, "42103": 23.95}',
    density: 27.2,
    imprecise: false,
    latitude: 41.59792,
    longitude: -75.09509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18405',
  },
  {
    city: 'Carbondale',
    county_fips: 42069,
    county_fips_all: '42069|42115',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna|Susquehanna',
    county_weights: '{"42069": 92.53, "42115": 7.47}',
    density: 134.4,
    imprecise: false,
    latitude: 41.59971,
    longitude: -75.53026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18407',
  },
  {
    city: 'Clarks Summit',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 159.1,
    imprecise: false,
    latitude: 41.45655,
    longitude: -75.74295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18411',
  },
  {
    city: 'Clifford',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 59.9,
    imprecise: false,
    latitude: 41.64767,
    longitude: -75.53258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18413',
  },
  {
    city: 'Dalton',
    county_fips: 42069,
    county_fips_all: '42069|42131',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna|Wyoming',
    county_weights: '{"42069": 70.2, "42131": 29.8}',
    density: 51.6,
    imprecise: false,
    latitude: 41.53893,
    longitude: -75.7427,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18414',
  },
  {
    city: 'Damascus',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 41.74821,
    longitude: -75.11315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18415',
  },
  {
    city: 'Equinunk',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 41.80705,
    longitude: -75.20122,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18417',
  },
  {
    city: 'Factoryville',
    county_fips: 42131,
    county_fips_all: '42131|42069|42115',
    county: 'Wyoming',
    county_names_all: 'Wyoming|Lackawanna|Susquehanna',
    county_weights: '{"42131": 63.89, "42069": 33.02, "42115": 3.09}',
    density: 47.7,
    imprecise: false,
    latitude: 41.57858,
    longitude: -75.7994,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18419',
  },
  {
    city: 'Fleetville',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 41.60333,
    longitude: -75.70589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18420',
  },
  {
    city: 'Forest City',
    county_fips: 42115,
    county_fips_all: '42115|42127|42069',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna|Wayne|Lackawanna',
    county_weights: '{"42115": 46.86, "42127": 45.27, "42069": 7.87}',
    density: 47.7,
    imprecise: false,
    latitude: 41.66337,
    longitude: -75.4691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18421',
  },
  {
    city: 'Gouldsboro',
    county_fips: 42069,
    county_fips_all: '42069|42127|42089|42079',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna|Wayne|Monroe|Luzerne',
    county_weights:
      '{"42069": 68.5, "42127": 19.75, "42089": 10.02, "42079": 1.73}',
    density: 24.8,
    imprecise: false,
    latitude: 41.24267,
    longitude: -75.52234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18424',
  },
  {
    city: 'Greeley',
    county_fips: 42103,
    county_fips_all: '42103',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"42103": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 41.42263,
    longitude: -75.02206,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18425',
  },
  {
    city: 'Greentown',
    county_fips: 42103,
    county_fips_all: '42103|42127',
    county: 'Pike',
    county_names_all: 'Pike|Wayne',
    county_weights: '{"42103": 99.6, "42127": 0.4}',
    density: 27.4,
    imprecise: false,
    latitude: 41.32774,
    longitude: -75.23577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18426',
  },
  {
    city: 'Hawley',
    county_fips: 42103,
    county_fips_all: '42103|42127',
    county: 'Pike',
    county_names_all: 'Pike|Wayne',
    county_weights: '{"42103": 75.43, "42127": 24.57}',
    density: 32.3,
    imprecise: false,
    latitude: 41.42946,
    longitude: -75.1253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18428',
  },
  {
    city: 'Herrick Center',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 41.7428,
    longitude: -75.47779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18430',
  },
  {
    city: 'Honesdale',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 36.6,
    imprecise: false,
    latitude: 41.62214,
    longitude: -75.25531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18431',
  },
  {
    city: 'Jermyn',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 101.5,
    imprecise: false,
    latitude: 41.57107,
    longitude: -75.58452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18433',
  },
  {
    city: 'Jessup',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 255,
    imprecise: false,
    latitude: 41.46014,
    longitude: -75.54823,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18434',
  },
  {
    city: 'Lackawaxen',
    county_fips: 42103,
    county_fips_all: '42103',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"42103": 100}',
    density: 28,
    imprecise: false,
    latitude: 41.49221,
    longitude: -75.00661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18435',
  },
  {
    city: 'Lake Ariel',
    county_fips: 42127,
    county_fips_all: '42127|42069',
    county: 'Wayne',
    county_names_all: 'Wayne|Lackawanna',
    county_weights: '{"42127": 73.56, "42069": 26.44}',
    density: 53,
    imprecise: false,
    latitude: 41.43867,
    longitude: -75.3959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18436',
  },
  {
    city: 'Lake Como',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 41.86859,
    longitude: -75.30345,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18437',
  },
  {
    city: 'Lakeville',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 53.4,
    imprecise: false,
    latitude: 41.43591,
    longitude: -75.24499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18438',
  },
  {
    city: 'Lakewood',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 41.82674,
    longitude: -75.34735,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18439',
  },
  {
    city: 'La Plume',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 41.55931,
    longitude: -75.76505,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18440',
  },
  {
    city: 'Lenoxville',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 55.3,
    imprecise: false,
    latitude: 41.65833,
    longitude: -75.62565,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18441',
  },
  {
    city: 'Milanville',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 41.66262,
    longitude: -75.11059,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18443',
  },
  {
    city: 'Moscow',
    county_fips: 42069,
    county_fips_all: '42069|42127',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna|Wayne',
    county_weights: '{"42069": 86.18, "42127": 13.82}',
    density: 50,
    imprecise: false,
    latitude: 41.33912,
    longitude: -75.54667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18444',
  },
  {
    city: 'Newfoundland',
    county_fips: 42127,
    county_fips_all: '42127|42103',
    county: 'Wayne',
    county_names_all: 'Wayne|Pike',
    county_weights: '{"42127": 67.49, "42103": 32.51}',
    density: 27.6,
    imprecise: false,
    latitude: 41.2948,
    longitude: -75.34751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18445',
  },
  {
    city: 'Nicholson',
    county_fips: 42115,
    county_fips_all: '42115|42131|42069',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna|Wyoming|Lackawanna',
    county_weights: '{"42115": 56.3, "42131": 35.64, "42069": 8.06}',
    density: 22.2,
    imprecise: false,
    latitude: 41.64513,
    longitude: -75.76044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18446',
  },
  {
    city: 'Olyphant',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 183.7,
    imprecise: false,
    latitude: 41.5132,
    longitude: -75.61684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18447',
  },
  {
    city: 'Paupack',
    county_fips: 42103,
    county_fips_all: '42103',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"42103": 100}',
    density: 37,
    imprecise: false,
    latitude: 41.39849,
    longitude: -75.22023,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18451',
  },
  {
    city: 'Peckville',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 1068.7,
    imprecise: false,
    latitude: 41.48387,
    longitude: -75.58951,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18452',
  },
  {
    city: 'Pleasant Mount',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 41.74971,
    longitude: -75.361,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18453',
  },
  {
    city: 'Poyntelle',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 9,
    imprecise: false,
    latitude: 41.81963,
    longitude: -75.42731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18454',
  },
  {
    city: 'Preston Park',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 41.88467,
    longitude: -75.35541,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18455',
  },
  {
    city: 'Prompton',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 26.8,
    imprecise: false,
    latitude: 41.61843,
    longitude: -75.3404,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18456',
  },
  {
    city: 'Rowland',
    county_fips: 42103,
    county_fips_all: '42103',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"42103": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 41.4696,
    longitude: -75.05084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18457',
  },
  {
    city: 'Shohola',
    county_fips: 42103,
    county_fips_all: '42103',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"42103": 100}',
    density: 26.6,
    imprecise: false,
    latitude: 41.40916,
    longitude: -74.91757,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18458',
  },
  {
    city: 'South Sterling',
    county_fips: 42127,
    county_fips_all: '42127|42103',
    county: 'Wayne',
    county_names_all: 'Wayne|Pike',
    county_weights: '{"42127": 99.87, "42103": 0.13}',
    density: 29.9,
    imprecise: false,
    latitude: 41.26719,
    longitude: -75.34744,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18460',
  },
  {
    city: 'Starlight',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 4,
    imprecise: false,
    latitude: 41.92774,
    longitude: -75.32434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18461',
  },
  {
    city: 'Starrucca',
    county_fips: 42127,
    county_fips_all: '42127|42115',
    county: 'Wayne',
    county_names_all: 'Wayne|Susquehanna',
    county_weights: '{"42127": 85.15, "42115": 14.85}',
    density: 6.3,
    imprecise: false,
    latitude: 41.9049,
    longitude: -75.42988,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18462',
  },
  {
    city: 'Sterling',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 41.1,
    imprecise: false,
    latitude: 41.34825,
    longitude: -75.37964,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18463',
  },
  {
    city: 'Tafton',
    county_fips: 42103,
    county_fips_all: '42103',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"42103": 100}',
    density: 64.2,
    imprecise: false,
    latitude: 41.40181,
    longitude: -75.17824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18464',
  },
  {
    city: 'Thompson',
    county_fips: 42115,
    county_fips_all: '42115|42127',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna|Wayne',
    county_weights: '{"42115": 84.52, "42127": 15.48}',
    density: 10.3,
    imprecise: false,
    latitude: 41.83654,
    longitude: -75.51811,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18465',
  },
  {
    city: 'Tobyhanna',
    county_fips: 42089,
    county_fips_all: '42089|42127',
    county: 'Monroe',
    county_names_all: 'Monroe|Wayne',
    county_weights: '{"42089": 97.74, "42127": 2.26}',
    density: 196.1,
    imprecise: false,
    latitude: 41.19709,
    longitude: -75.37796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18466',
  },
  {
    city: 'Tyler Hill',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 41.70352,
    longitude: -75.14597,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18469',
  },
  {
    city: 'Union Dale',
    county_fips: 42115,
    county_fips_all: '42115|42127',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna|Wayne',
    county_weights: '{"42115": 81.49, "42127": 18.51}',
    density: 12.7,
    imprecise: false,
    latitude: 41.732,
    longitude: -75.53502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18470',
  },
  {
    city: 'Waverly',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 127.9,
    imprecise: false,
    latitude: 41.5291,
    longitude: -75.69807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18471',
  },
  {
    city: 'Waymart',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 41.1,
    imprecise: false,
    latitude: 41.58738,
    longitude: -75.40002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18472',
  },
  {
    city: 'White Mills',
    county_fips: 42127,
    county_fips_all: '42127',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"42127": 100}',
    density: 253.7,
    imprecise: false,
    latitude: 41.52828,
    longitude: -75.20821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18473',
  },
  {
    city: 'Scranton',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 1327.2,
    imprecise: false,
    latitude: 41.41007,
    longitude: -75.66767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18503',
  },
  {
    city: 'Scranton',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 794.5,
    imprecise: false,
    latitude: 41.42375,
    longitude: -75.70581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18504',
  },
  {
    city: 'Scranton',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 910.3,
    imprecise: false,
    latitude: 41.38874,
    longitude: -75.65109,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18505',
  },
  {
    city: 'Moosic',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 218,
    imprecise: false,
    latitude: 41.35541,
    longitude: -75.68016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18507',
  },
  {
    city: 'Scranton',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 659.6,
    imprecise: false,
    latitude: 41.45503,
    longitude: -75.65827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18508',
  },
  {
    city: 'Scranton',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 1704.4,
    imprecise: false,
    latitude: 41.43062,
    longitude: -75.64321,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18509',
  },
  {
    city: 'Scranton',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 3070.1,
    imprecise: false,
    latitude: 41.40735,
    longitude: -75.64376,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18510',
  },
  {
    city: 'Scranton',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 444.3,
    imprecise: false,
    latitude: 41.42648,
    longitude: -75.5912,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18512',
  },
  {
    city: 'Taylor',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 492.7,
    imprecise: false,
    latitude: 41.39524,
    longitude: -75.71461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18517',
  },
  {
    city: 'Old Forge',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 818.1,
    imprecise: false,
    latitude: 41.37495,
    longitude: -75.73963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18518',
  },
  {
    city: 'Scranton',
    county_fips: 42069,
    county_fips_all: '42069',
    county: 'Lackawanna',
    county_names_all: 'Lackawanna',
    county_weights: '{"42069": 100}',
    density: 839.4,
    imprecise: false,
    latitude: 41.46207,
    longitude: -75.63062,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18519',
  },
  {
    city: 'Bear Creek',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 127.9,
    imprecise: false,
    latitude: 41.18749,
    longitude: -75.75526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18602',
  },
  {
    city: 'Berwick',
    county_fips: 42037,
    county_fips_all: '42037|42079',
    county: 'Columbia',
    county_names_all: 'Columbia|Luzerne',
    county_weights: '{"42037": 57.34, "42079": 42.66}',
    density: 136.1,
    imprecise: false,
    latitude: 41.08506,
    longitude: -76.24591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18603',
  },
  {
    city: 'Blakeslee',
    county_fips: 42089,
    county_fips_all: '42089|42079',
    county: 'Monroe',
    county_names_all: 'Monroe|Luzerne',
    county_weights: '{"42089": 95.54, "42079": 4.46}',
    density: 59.2,
    imprecise: false,
    latitude: 41.05959,
    longitude: -75.53226,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18610',
  },
  {
    city: 'Dallas',
    county_fips: 42079,
    county_fips_all: '42079|42131',
    county: 'Luzerne',
    county_names_all: 'Luzerne|Wyoming',
    county_weights: '{"42079": 89.28, "42131": 10.72}',
    density: 125.7,
    imprecise: false,
    latitude: 41.35025,
    longitude: -75.98207,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18612',
  },
  {
    city: 'Dushore',
    county_fips: 42113,
    county_fips_all: '42113|42131|42015|42079',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Wyoming|Bradford|Luzerne',
    county_weights:
      '{"42113": 75.94, "42131": 22.4, "42015": 1.56, "42079": 0.1}',
    density: 5,
    imprecise: false,
    latitude: 41.48373,
    longitude: -76.35768,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18614',
  },
  {
    city: 'Falls',
    county_fips: 42131,
    county_fips_all: '42131|42079',
    county: 'Wyoming',
    county_names_all: 'Wyoming|Luzerne',
    county_weights: '{"42131": 92.65, "42079": 7.35}',
    density: 35.9,
    imprecise: false,
    latitude: 41.45968,
    longitude: -75.85752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18615',
  },
  {
    city: 'Forksville',
    county_fips: 42113,
    county_fips_all: '42113|42015',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Bradford',
    county_weights: '{"42113": 87.22, "42015": 12.78}',
    density: 4.2,
    imprecise: false,
    latitude: 41.51907,
    longitude: -76.63954,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18616',
  },
  {
    city: 'Glen Lyon',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 119,
    imprecise: false,
    latitude: 41.17149,
    longitude: -76.07707,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18617',
  },
  {
    city: 'Harveys Lake',
    county_fips: 42079,
    county_fips_all: '42079|42131',
    county: 'Luzerne',
    county_names_all: 'Luzerne|Wyoming',
    county_weights: '{"42079": 62.73, "42131": 37.27}',
    density: 65.1,
    imprecise: false,
    latitude: 41.37883,
    longitude: -76.0313,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18618',
  },
  {
    city: 'Hillsgrove',
    county_fips: 42113,
    county_fips_all: '42113|42081',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Lycoming',
    county_weights: '{"42113": 81.58, "42081": 18.42}',
    density: 2.5,
    imprecise: false,
    latitude: 41.43574,
    longitude: -76.7195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18619',
  },
  {
    city: 'Hunlock Creek',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 40.7,
    imprecise: false,
    latitude: 41.25441,
    longitude: -76.09129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18621',
  },
  {
    city: 'Huntington Mills',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 28.7,
    imprecise: false,
    latitude: 41.20228,
    longitude: -76.27348,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18622',
  },
  {
    city: 'Laceyville',
    county_fips: 42015,
    county_fips_all: '42015|42131|42115',
    county: 'Bradford',
    county_names_all: 'Bradford|Wyoming|Susquehanna',
    county_weights: '{"42015": 44.81, "42131": 36.75, "42115": 18.44}',
    density: 15.4,
    imprecise: false,
    latitude: 41.67297,
    longitude: -76.14768,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18623',
  },
  {
    city: 'Lake Harmony',
    county_fips: 42025,
    county_fips_all: '42025',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"42025": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 41.05529,
    longitude: -75.62088,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18624',
  },
  {
    city: 'Lake Winola',
    county_fips: 42131,
    county_fips_all: '42131',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"42131": 100}',
    density: 185.7,
    imprecise: false,
    latitude: 41.51311,
    longitude: -75.85027,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18625',
  },
  {
    city: 'Laporte',
    county_fips: 42113,
    county_fips_all: '42113',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"42113": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 41.41136,
    longitude: -76.4635,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18626',
  },
  {
    city: 'Lehman',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.31559,
    longitude: -76.02235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18627',
  },
  {
    city: 'Lopez',
    county_fips: 42113,
    county_fips_all: '42113',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"42113": 100}',
    density: 3,
    imprecise: false,
    latitude: 41.41474,
    longitude: -76.32047,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18628',
  },
  {
    city: 'Mehoopany',
    county_fips: 42131,
    county_fips_all: '42131',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"42131": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 41.52393,
    longitude: -76.13365,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18629',
  },
  {
    city: 'Meshoppen',
    county_fips: 42115,
    county_fips_all: '42115|42131',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna|Wyoming',
    county_weights: '{"42115": 63.75, "42131": 36.25}',
    density: 17.6,
    imprecise: false,
    latitude: 41.66361,
    longitude: -76.02698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18630',
  },
  {
    city: 'Mifflinville',
    county_fips: 42037,
    county_fips_all: '42037',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"42037": 100}',
    density: 298.6,
    imprecise: false,
    latitude: 41.03079,
    longitude: -76.30233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18631',
  },
  {
    city: 'Mildred',
    county_fips: 42113,
    county_fips_all: '42113',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"42113": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 41.46769,
    longitude: -76.3764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18632',
  },
  {
    city: 'Nanticoke',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 372,
    imprecise: false,
    latitude: 41.18984,
    longitude: -76.0218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18634',
  },
  {
    city: 'Nescopeck',
    county_fips: 42079,
    county_fips_all: '42079|42037',
    county: 'Luzerne',
    county_names_all: 'Luzerne|Columbia',
    county_weights: '{"42079": 59.77, "42037": 40.23}',
    density: 38.2,
    imprecise: false,
    latitude: 41.02961,
    longitude: -76.20598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18635',
  },
  {
    city: 'Noxen',
    county_fips: 42131,
    county_fips_all: '42131|42079',
    county: 'Wyoming',
    county_names_all: 'Wyoming|Luzerne',
    county_weights: '{"42131": 88.29, "42079": 11.71}',
    density: 16.5,
    imprecise: false,
    latitude: 41.41215,
    longitude: -76.08859,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18636',
  },
  {
    city: 'Pittston',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 229.3,
    imprecise: false,
    latitude: 41.29724,
    longitude: -75.74024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18640',
  },
  {
    city: 'Pittston',
    county_fips: 42079,
    county_fips_all: '42079|42069',
    county: 'Luzerne',
    county_names_all: 'Luzerne|Lackawanna',
    county_weights: '{"42079": 79.8, "42069": 20.2}',
    density: 535.4,
    imprecise: false,
    latitude: 41.33644,
    longitude: -75.73007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18641',
  },
  {
    city: 'Duryea',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 326.3,
    imprecise: false,
    latitude: 41.35359,
    longitude: -75.77681,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18642',
  },
  {
    city: 'Pittston',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 271.5,
    imprecise: false,
    latitude: 41.36456,
    longitude: -75.8344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18643',
  },
  {
    city: 'Wyoming',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 185.1,
    imprecise: false,
    latitude: 41.33192,
    longitude: -75.87753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18644',
  },
  {
    city: 'Plymouth',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 278.9,
    imprecise: false,
    latitude: 41.24748,
    longitude: -75.962,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18651',
  },
  {
    city: 'Shickshinny',
    county_fips: 42079,
    county_fips_all: '42079|42037',
    county: 'Luzerne',
    county_names_all: 'Luzerne|Columbia',
    county_weights: '{"42079": 90.42, "42037": 9.58}',
    density: 32.5,
    imprecise: false,
    latitude: 41.18327,
    longitude: -76.19619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18655',
  },
  {
    city: 'Sweet Valley',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 41.32703,
    longitude: -76.20442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18656',
  },
  {
    city: 'Tunkhannock',
    county_fips: 42131,
    county_fips_all: '42131',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"42131": 100}',
    density: 35.5,
    imprecise: false,
    latitude: 41.52712,
    longitude: -75.95601,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18657',
  },
  {
    city: 'Wapwallopen',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 41.10195,
    longitude: -76.06196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18660',
  },
  {
    city: 'White Haven',
    county_fips: 42079,
    county_fips_all: '42079|42025',
    county: 'Luzerne',
    county_names_all: 'Luzerne|Carbon',
    county_weights: '{"42079": 67.27, "42025": 32.73}',
    density: 18.3,
    imprecise: false,
    latitude: 41.08435,
    longitude: -75.75666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18661',
  },
  {
    city: 'Wilkes Barre',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 3305.9,
    imprecise: false,
    latitude: 41.2433,
    longitude: -75.88523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18701',
  },
  {
    city: 'Wilkes Barre',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 207.5,
    imprecise: false,
    latitude: 41.21406,
    longitude: -75.76925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18702',
  },
  {
    city: 'Kingston',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 1188.9,
    imprecise: false,
    latitude: 41.27676,
    longitude: -75.89474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18704',
  },
  {
    city: 'Wilkes Barre',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 1217.4,
    imprecise: false,
    latitude: 41.27156,
    longitude: -75.84241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18705',
  },
  {
    city: 'Wilkes Barre',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 240.9,
    imprecise: false,
    latitude: 41.20432,
    longitude: -75.91231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18706',
  },
  {
    city: 'Mountain Top',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 126.2,
    imprecise: false,
    latitude: 41.13325,
    longitude: -75.9228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18707',
  },
  {
    city: 'Shavertown',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 214,
    imprecise: false,
    latitude: 41.297,
    longitude: -75.95927,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18708',
  },
  {
    city: 'Luzerne',
    county_fips: 42079,
    county_fips_all: '42079',
    county: 'Luzerne',
    county_names_all: 'Luzerne',
    county_weights: '{"42079": 100}',
    density: 1478.2,
    imprecise: false,
    latitude: 41.28635,
    longitude: -75.89674,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18709',
  },
  {
    city: 'Montrose',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 41.82861,
    longitude: -75.9437,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18801',
  },
  {
    city: 'Athens',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 47,
    imprecise: false,
    latitude: 41.93738,
    longitude: -76.50181,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18810',
  },
  {
    city: 'Brackney',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 41.97203,
    longitude: -75.96822,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18812',
  },
  {
    city: 'Burlington',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 99.5,
    imprecise: false,
    latitude: 41.78151,
    longitude: -76.60121,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18814',
  },
  {
    city: 'Dimock',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 42.3,
    imprecise: false,
    latitude: 41.73977,
    longitude: -75.90966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18816',
  },
  {
    city: 'East Smithfield',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 38,
    imprecise: false,
    latitude: 41.87431,
    longitude: -76.62075,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18817',
  },
  {
    city: 'Friendsville',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 41.91343,
    longitude: -76.04843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18818',
  },
  {
    city: 'Great Bend',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 106.6,
    imprecise: false,
    latitude: 41.98588,
    longitude: -75.73466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18821',
  },
  {
    city: 'Hallstead',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 27.4,
    imprecise: false,
    latitude: 41.9482,
    longitude: -75.80116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18822',
  },
  {
    city: 'Harford',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 41.7,
    imprecise: false,
    latitude: 41.77415,
    longitude: -75.69168,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18823',
  },
  {
    city: 'Hop Bottom',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 41.70422,
    longitude: -75.786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18824',
  },
  {
    city: 'Jackson',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 41.82276,
    longitude: -75.599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18825',
  },
  {
    city: 'Kingsley',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 41.7495,
    longitude: -75.74276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18826',
  },
  {
    city: 'Lawton',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 41.79672,
    longitude: -76.11245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18828',
  },
  {
    city: 'Le Raysville',
    county_fips: 42015,
    county_fips_all: '42015|42115',
    county: 'Bradford',
    county_names_all: 'Bradford|Susquehanna',
    county_weights: '{"42015": 98.58, "42115": 1.42}',
    density: 11.9,
    imprecise: false,
    latitude: 41.8395,
    longitude: -76.17088,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18829',
  },
  {
    city: 'Little Meadows',
    county_fips: 42115,
    county_fips_all: '42115|42015',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna|Bradford',
    county_weights: '{"42115": 93.7, "42015": 6.3}',
    density: 9.8,
    imprecise: false,
    latitude: 41.95049,
    longitude: -76.10904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18830',
  },
  {
    city: 'Milan',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 41.89356,
    longitude: -76.60832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18831',
  },
  {
    city: 'Monroeton',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 41.67625,
    longitude: -76.55639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18832',
  },
  {
    city: 'New Albany',
    county_fips: 42015,
    county_fips_all: '42015|42113',
    county: 'Bradford',
    county_names_all: 'Bradford|Sullivan',
    county_weights: '{"42015": 92.24, "42113": 7.76}',
    density: 8.4,
    imprecise: false,
    latitude: 41.59433,
    longitude: -76.46515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18833',
  },
  {
    city: 'New Milford',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 41.84185,
    longitude: -75.71189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18834',
  },
  {
    city: 'Rome',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 13,
    imprecise: false,
    latitude: 41.91928,
    longitude: -76.29122,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18837',
  },
  {
    city: 'Sayre',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 102.8,
    imprecise: false,
    latitude: 41.97433,
    longitude: -76.52968,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18840',
  },
  {
    city: 'South Gibson',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 41.75594,
    longitude: -75.61652,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18842',
  },
  {
    city: 'South Montrose',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 95.3,
    imprecise: false,
    latitude: 41.80446,
    longitude: -75.89416,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18843',
  },
  {
    city: 'Springville',
    county_fips: 42115,
    county_fips_all: '42115|42131',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna|Wyoming',
    county_weights: '{"42115": 98.91, "42131": 1.09}',
    density: 17.3,
    imprecise: false,
    latitude: 41.69247,
    longitude: -75.91351,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18844',
  },
  {
    city: 'Stevensville',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 41.78994,
    longitude: -76.18454,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18845',
  },
  {
    city: 'Sugar Run',
    county_fips: 42015,
    county_fips_all: '42015|42131',
    county: 'Bradford',
    county_names_all: 'Bradford|Wyoming',
    county_weights: '{"42015": 99.58, "42131": 0.42}',
    density: 12.9,
    imprecise: false,
    latitude: 41.60494,
    longitude: -76.23929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18846',
  },
  {
    city: 'Susquehanna',
    county_fips: 42115,
    county_fips_all: '42115|42127',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna|Wayne',
    county_weights: '{"42115": 79.93, "42127": 20.07}',
    density: 15.2,
    imprecise: false,
    latitude: 41.93539,
    longitude: -75.56893,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18847',
  },
  {
    city: 'Towanda',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 28.5,
    imprecise: false,
    latitude: 41.75358,
    longitude: -76.45615,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18848',
  },
  {
    city: 'Ulster',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 41.85916,
    longitude: -76.49126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18850',
  },
  {
    city: 'Warren Center',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 41.93677,
    longitude: -76.17992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18851',
  },
  {
    city: 'Wyalusing',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 41.71654,
    longitude: -76.27534,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18853',
  },
  {
    city: 'Wysox',
    county_fips: 42015,
    county_fips_all: '42015',
    county: 'Bradford',
    county_names_all: 'Bradford',
    county_weights: '{"42015": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 41.79532,
    longitude: -76.35472,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18854',
  },
  {
    city: 'Doylestown',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 524.9,
    imprecise: false,
    latitude: 40.30529,
    longitude: -75.15026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18901',
  },
  {
    city: 'Doylestown',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 326.5,
    imprecise: false,
    latitude: 40.35474,
    longitude: -75.09855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18902',
  },
  {
    city: 'Buckingham',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 67.6,
    imprecise: false,
    latitude: 40.32134,
    longitude: -75.05852,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18912',
  },
  {
    city: 'Carversville',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 64.9,
    imprecise: false,
    latitude: 40.37727,
    longitude: -75.0545,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18913',
  },
  {
    city: 'Chalfont',
    county_fips: 42017,
    county_fips_all: '42017|42091',
    county: 'Bucks',
    county_names_all: 'Bucks|Montgomery',
    county_weights: '{"42017": 98.61, "42091": 1.39}',
    density: 473.8,
    imprecise: false,
    latitude: 40.28908,
    longitude: -75.21046,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18914',
  },
  {
    city: 'Colmar',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 530.3,
    imprecise: false,
    latitude: 40.27255,
    longitude: -75.25628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18915',
  },
  {
    city: 'Dublin',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 1141.6,
    imprecise: false,
    latitude: 40.37088,
    longitude: -75.202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18917',
  },
  {
    city: 'Erwinna',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 39.3,
    imprecise: false,
    latitude: 40.49264,
    longitude: -75.09067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18920',
  },
  {
    city: 'Ferndale',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 167.7,
    imprecise: false,
    latitude: 40.52946,
    longitude: -75.1738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18921',
  },
  {
    city: 'Fountainville',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 210.6,
    imprecise: false,
    latitude: 40.3532,
    longitude: -75.16798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18923',
  },
  {
    city: 'Furlong',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 243.8,
    imprecise: false,
    latitude: 40.2851,
    longitude: -75.05934,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18925',
  },
  {
    city: 'Hilltown',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 232.3,
    imprecise: false,
    latitude: 40.31952,
    longitude: -75.24514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18927',
  },
  {
    city: 'Jamison',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 513.1,
    imprecise: false,
    latitude: 40.25674,
    longitude: -75.07885,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18929',
  },
  {
    city: 'Kintnersville',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 39.3,
    imprecise: false,
    latitude: 40.52926,
    longitude: -75.2142,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18930',
  },
  {
    city: 'Line Lexington',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 129.3,
    imprecise: false,
    latitude: 40.29457,
    longitude: -75.25581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18932',
  },
  {
    city: 'Lumberville',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 64.9,
    imprecise: false,
    latitude: 40.40265,
    longitude: -75.042,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18933',
  },
  {
    city: 'Milford Square',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 500.5,
    imprecise: false,
    latitude: 40.43444,
    longitude: -75.39714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18935',
  },
  {
    city: 'Montgomeryville',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 94.8,
    imprecise: false,
    latitude: 40.22993,
    longitude: -75.23154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18936',
  },
  {
    city: 'New Hope',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 128.9,
    imprecise: false,
    latitude: 40.35126,
    longitude: -74.99779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18938',
  },
  {
    city: 'Newtown',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 330.8,
    imprecise: false,
    latitude: 40.26349,
    longitude: -74.9483,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18940',
  },
  {
    city: 'Ottsville',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 45.3,
    imprecise: false,
    latitude: 40.47167,
    longitude: -75.16261,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18942',
  },
  {
    city: 'Perkasie',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 234.3,
    imprecise: false,
    latitude: 40.39252,
    longitude: -75.23381,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18944',
  },
  {
    city: 'Pineville',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 213,
    imprecise: false,
    latitude: 40.28923,
    longitude: -75.01009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18946',
  },
  {
    city: 'Pipersville',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 99.3,
    imprecise: false,
    latitude: 40.42677,
    longitude: -75.1138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18947',
  },
  {
    city: 'Point Pleasant',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 191.1,
    imprecise: false,
    latitude: 40.44709,
    longitude: -75.06544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18950',
  },
  {
    city: 'Quakertown',
    county_fips: 42017,
    county_fips_all: '42017|42077',
    county: 'Bucks',
    county_names_all: 'Bucks|Lehigh',
    county_weights: '{"42017": 99.57, "42077": 0.43}',
    density: 197,
    imprecise: false,
    latitude: 40.45294,
    longitude: -75.33833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18951',
  },
  {
    city: 'Richboro',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 623.2,
    imprecise: false,
    latitude: 40.2224,
    longitude: -75.00032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18954',
  },
  {
    city: 'Richlandtown',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 210.9,
    imprecise: false,
    latitude: 40.48469,
    longitude: -75.3141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18955',
  },
  {
    city: 'Sellersville',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 275.6,
    imprecise: false,
    latitude: 40.36376,
    longitude: -75.32366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18960',
  },
  {
    city: 'Silverdale',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 1398.4,
    imprecise: false,
    latitude: 40.34462,
    longitude: -75.27033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18962',
  },
  {
    city: 'Souderton',
    county_fips: 42091,
    county_fips_all: '42091|42017',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Bucks',
    county_weights: '{"42091": 88.52, "42017": 11.48}',
    density: 594.2,
    imprecise: false,
    latitude: 40.29759,
    longitude: -75.33327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18964',
  },
  {
    city: 'Southampton',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 861.3,
    imprecise: false,
    latitude: 40.1879,
    longitude: -75.00557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18966',
  },
  {
    city: 'Telford',
    county_fips: 42091,
    county_fips_all: '42091|42017',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Bucks',
    county_weights: '{"42091": 80.92, "42017": 19.08}',
    density: 359.1,
    imprecise: false,
    latitude: 40.32644,
    longitude: -75.37239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18969',
  },
  {
    city: 'Trumbauersville',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 519.2,
    imprecise: false,
    latitude: 40.41212,
    longitude: -75.38129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18970',
  },
  {
    city: 'Upper Black Eddy',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 51.8,
    imprecise: false,
    latitude: 40.53395,
    longitude: -75.11997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18972',
  },
  {
    city: 'Warminster',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 845,
    imprecise: false,
    latitude: 40.21675,
    longitude: -75.07321,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18974',
  },
  {
    city: 'Warrington',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 803.7,
    imprecise: false,
    latitude: 40.24676,
    longitude: -75.14321,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18976',
  },
  {
    city: 'Washington Crossing',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 401.8,
    imprecise: false,
    latitude: 40.28655,
    longitude: -74.87865,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18977',
  },
  {
    city: 'Wycombe',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 143.6,
    imprecise: false,
    latitude: 40.27276,
    longitude: -75.01105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18980',
  },
  {
    city: 'Abington',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 2156,
    imprecise: false,
    latitude: 40.12624,
    longitude: -75.12652,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19001',
  },
  {
    city: 'Ambler',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 613.6,
    imprecise: false,
    latitude: 40.18386,
    longitude: -75.21104,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19002',
  },
  {
    city: 'Ardmore',
    county_fips: 42045,
    county_fips_all: '42045|42091',
    county: 'Delaware',
    county_names_all: 'Delaware|Montgomery',
    county_weights: '{"42045": 53.91, "42091": 46.09}',
    density: 2731.4,
    imprecise: false,
    latitude: 40.00217,
    longitude: -75.29841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19003',
  },
  {
    city: 'Bala Cynwyd',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 1613.3,
    imprecise: false,
    latitude: 40.01362,
    longitude: -75.22979,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19004',
  },
  {
    city: 'Huntingdon Valley',
    county_fips: 42091,
    county_fips_all: '42091|42017',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Bucks',
    county_weights: '{"42091": 91.01, "42017": 8.99}',
    density: 681.6,
    imprecise: false,
    latitude: 40.13323,
    longitude: -75.06222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19006',
  },
  {
    city: 'Bristol',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 1126.1,
    imprecise: false,
    latitude: 40.11483,
    longitude: -74.85474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19007',
  },
  {
    city: 'Broomall',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 1222.4,
    imprecise: false,
    latitude: 39.97425,
    longitude: -75.36107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19008',
  },
  {
    city: 'Bryn Athyn',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 331.9,
    imprecise: false,
    latitude: 40.13775,
    longitude: -75.06308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19009',
  },
  {
    city: 'Bryn Mawr',
    county_fips: 42045,
    county_fips_all: '42045|42091',
    county: 'Delaware',
    county_names_all: 'Delaware|Montgomery',
    county_weights: '{"42045": 55.13, "42091": 44.87}',
    density: 997,
    imprecise: false,
    latitude: 40.02362,
    longitude: -75.3298,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19010',
  },
  {
    city: 'Cheltenham',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 1525.8,
    imprecise: false,
    latitude: 40.05966,
    longitude: -75.10586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19012',
  },
  {
    city: 'Chester',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 2397.8,
    imprecise: false,
    latitude: 39.84529,
    longitude: -75.37474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19013',
  },
  {
    city: 'Aston',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 893.9,
    imprecise: false,
    latitude: 39.8637,
    longitude: -75.4338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19014',
  },
  {
    city: 'Brookhaven',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 2194.8,
    imprecise: false,
    latitude: 39.86811,
    longitude: -75.39164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19015',
  },
  {
    city: 'Chester Heights',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 275.4,
    imprecise: false,
    latitude: 39.89078,
    longitude: -75.46295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19017',
  },
  {
    city: 'Clifton Heights',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 3329.4,
    imprecise: false,
    latitude: 39.92312,
    longitude: -75.29834,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19018',
  },
  {
    city: 'Bensalem',
    county_fips: 42017,
    county_fips_all: '42017|42101',
    county: 'Bucks',
    county_names_all: 'Bucks|Philadelphia',
    county_weights: '{"42017": 99.9, "42101": 0.1}',
    density: 1270.2,
    imprecise: false,
    latitude: 40.10453,
    longitude: -74.93853,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19020',
  },
  {
    city: 'Croydon',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 1199.4,
    imprecise: false,
    latitude: 40.08874,
    longitude: -74.89385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19021',
  },
  {
    city: 'Crum Lynne',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 1324.5,
    imprecise: false,
    latitude: 39.85862,
    longitude: -75.33507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19022',
  },
  {
    city: 'Darby',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 4368.5,
    imprecise: false,
    latitude: 39.91724,
    longitude: -75.26708,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19023',
  },
  {
    city: 'Dresher',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 888.5,
    imprecise: false,
    latitude: 40.14556,
    longitude: -75.1632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19025',
  },
  {
    city: 'Drexel Hill',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 3472.8,
    imprecise: false,
    latitude: 39.95035,
    longitude: -75.304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19026',
  },
  {
    city: 'Elkins Park',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 2004.6,
    imprecise: false,
    latitude: 40.07347,
    longitude: -75.12453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19027',
  },
  {
    city: 'Essington',
    county_fips: 42045,
    county_fips_all: '42045|42101',
    county: 'Delaware',
    county_names_all: 'Delaware|Philadelphia',
    county_weights: '{"42045": 99.78, "42101": 0.22}',
    density: 707.3,
    imprecise: false,
    latitude: 39.86345,
    longitude: -75.29271,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19029',
  },
  {
    city: 'Fairless Hills',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 940.3,
    imprecise: false,
    latitude: 40.1812,
    longitude: -74.83269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19030',
  },
  {
    city: 'Flourtown',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 621,
    imprecise: false,
    latitude: 40.1083,
    longitude: -75.21747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19031',
  },
  {
    city: 'Folcroft',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 2099.7,
    imprecise: false,
    latitude: 39.88907,
    longitude: -75.277,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19032',
  },
  {
    city: 'Folsom',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 2685.7,
    imprecise: false,
    latitude: 39.89077,
    longitude: -75.32892,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19033',
  },
  {
    city: 'Fort Washington',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 406,
    imprecise: false,
    latitude: 40.13353,
    longitude: -75.20953,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19034',
  },
  {
    city: 'Gladwyne',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 322.7,
    imprecise: false,
    latitude: 40.04851,
    longitude: -75.28126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19035',
  },
  {
    city: 'Glenolden',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 3385.2,
    imprecise: false,
    latitude: 39.90368,
    longitude: -75.29323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19036',
  },
  {
    city: 'Glenside',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 1520.7,
    imprecise: false,
    latitude: 40.10197,
    longitude: -75.17214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19038',
  },
  {
    city: 'Hatboro',
    county_fips: 42091,
    county_fips_all: '42091|42017',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Bucks',
    county_weights: '{"42091": 98.78, "42017": 1.22}',
    density: 1433.3,
    imprecise: false,
    latitude: 40.17732,
    longitude: -75.10624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19040',
  },
  {
    city: 'Haverford',
    county_fips: 42045,
    county_fips_all: '42045|42091',
    county: 'Delaware',
    county_names_all: 'Delaware|Montgomery',
    county_weights: '{"42045": 67.53, "42091": 32.47}',
    density: 742.5,
    imprecise: false,
    latitude: 40.00663,
    longitude: -75.31747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19041',
  },
  {
    city: 'Holmes',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 3203.3,
    imprecise: false,
    latitude: 39.90042,
    longitude: -75.30891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19043',
  },
  {
    city: 'Horsham',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 741,
    imprecise: false,
    latitude: 40.18901,
    longitude: -75.15253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19044',
  },
  {
    city: 'Jenkintown',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 1134.8,
    imprecise: false,
    latitude: 40.10133,
    longitude: -75.10558,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19046',
  },
  {
    city: 'Langhorne',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 773.7,
    imprecise: false,
    latitude: 40.18207,
    longitude: -74.91062,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19047',
  },
  {
    city: 'Lansdowne',
    county_fips: 42045,
    county_fips_all: '42045|42101',
    county: 'Delaware',
    county_names_all: 'Delaware|Philadelphia',
    county_weights: '{"42045": 99.73, "42101": 0.27}',
    density: 3098.2,
    imprecise: false,
    latitude: 39.93764,
    longitude: -75.26355,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19050',
  },
  {
    city: 'Lenni',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 919.7,
    imprecise: false,
    latitude: 39.89721,
    longitude: -75.44532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19052',
  },
  {
    city: 'Feasterville Trevose',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 1044.8,
    imprecise: false,
    latitude: 40.15475,
    longitude: -74.97918,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19053',
  },
  {
    city: 'Levittown',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 1637.1,
    imprecise: false,
    latitude: 40.17055,
    longitude: -74.82016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19054',
  },
  {
    city: 'Levittown',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 1895,
    imprecise: false,
    latitude: 40.14984,
    longitude: -74.83881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19055',
  },
  {
    city: 'Levittown',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 1599.9,
    imprecise: false,
    latitude: 40.15044,
    longitude: -74.88534,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19056',
  },
  {
    city: 'Levittown',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 1559.6,
    imprecise: false,
    latitude: 40.14013,
    longitude: -74.85718,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19057',
  },
  {
    city: 'Garnet Valley',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 575.4,
    imprecise: false,
    latitude: 39.85048,
    longitude: -75.4921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19060',
  },
  {
    city: 'Marcus Hook',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 1097.4,
    imprecise: false,
    latitude: 39.82741,
    longitude: -75.432,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19061',
  },
  {
    city: 'Media',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 587.2,
    imprecise: false,
    latitude: 39.92248,
    longitude: -75.41419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19063',
  },
  {
    city: 'Springfield',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 1365.5,
    imprecise: false,
    latitude: 39.93214,
    longitude: -75.33873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19064',
  },
  {
    city: 'Merion Station',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 1691.4,
    imprecise: false,
    latitude: 40.0022,
    longitude: -75.2489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19066',
  },
  {
    city: 'Morrisville',
    county_fips: 42017,
    county_fips_all: '42017',
    county: 'Bucks',
    county_names_all: 'Bucks',
    county_weights: '{"42017": 100}',
    density: 660.2,
    imprecise: false,
    latitude: 40.19595,
    longitude: -74.80976,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19067',
  },
  {
    city: 'Morton',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 2316.3,
    imprecise: false,
    latitude: 39.90628,
    longitude: -75.32452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19070',
  },
  {
    city: 'Narberth',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 1230.8,
    imprecise: false,
    latitude: 40.02419,
    longitude: -75.25697,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19072',
  },
  {
    city: 'Newtown Square',
    county_fips: 42045,
    county_fips_all: '42045|42029',
    county: 'Delaware',
    county_names_all: 'Delaware|Chester',
    county_weights: '{"42045": 78.46, "42029": 21.54}',
    density: 412.2,
    imprecise: false,
    latitude: 39.98093,
    longitude: -75.4346,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19073',
  },
  {
    city: 'Norwood',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 2945.6,
    imprecise: false,
    latitude: 39.88642,
    longitude: -75.29643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19074',
  },
  {
    city: 'Oreland',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 1525.7,
    imprecise: false,
    latitude: 40.1136,
    longitude: -75.18852,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19075',
  },
  {
    city: 'Prospect Park',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 3324.7,
    imprecise: false,
    latitude: 39.88586,
    longitude: -75.30763,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19076',
  },
  {
    city: 'Ridley Park',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 2219.7,
    imprecise: false,
    latitude: 39.87328,
    longitude: -75.32159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19078',
  },
  {
    city: 'Sharon Hill',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 2087.6,
    imprecise: false,
    latitude: 39.90238,
    longitude: -75.26591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19079',
  },
  {
    city: 'Swarthmore',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 1801.7,
    imprecise: false,
    latitude: 39.89864,
    longitude: -75.34751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19081',
  },
  {
    city: 'Upper Darby',
    county_fips: 42045,
    county_fips_all: '42045|42101',
    county: 'Delaware',
    county_names_all: 'Delaware|Philadelphia',
    county_weights: '{"42045": 99.6, "42101": 0.4}',
    density: 6227.7,
    imprecise: false,
    latitude: 39.96043,
    longitude: -75.27032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19082',
  },
  {
    city: 'Havertown',
    county_fips: 42045,
    county_fips_all: '42045|42091',
    county: 'Delaware',
    county_names_all: 'Delaware|Montgomery',
    county_weights: '{"42045": 99.62, "42091": 0.38}',
    density: 2595,
    imprecise: false,
    latitude: 39.97715,
    longitude: -75.31192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19083',
  },
  {
    city: 'Villanova',
    county_fips: 42045,
    county_fips_all: '42045|42091',
    county: 'Delaware',
    county_names_all: 'Delaware|Montgomery',
    county_weights: '{"42045": 56.79, "42091": 43.21}',
    density: 696.1,
    imprecise: false,
    latitude: 40.03759,
    longitude: -75.34969,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19085',
  },
  {
    city: 'Wallingford',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 1247.1,
    imprecise: false,
    latitude: 39.89094,
    longitude: -75.37014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19086',
  },
  {
    city: 'Wayne',
    county_fips: 42029,
    county_fips_all: '42029|42045|42091',
    county: 'Chester',
    county_names_all: 'Chester|Delaware|Montgomery',
    county_weights: '{"42029": 50.02, "42045": 34.74, "42091": 15.24}',
    density: 828.8,
    imprecise: false,
    latitude: 40.06172,
    longitude: -75.40004,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19087',
  },
  {
    city: 'Willow Grove',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 1649,
    imprecise: false,
    latitude: 40.1484,
    longitude: -75.12378,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19090',
  },
  {
    city: 'Woodlyn',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 1847.6,
    imprecise: false,
    latitude: 39.87499,
    longitude: -75.3467,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19094',
  },
  {
    city: 'Wyncote',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 1498,
    imprecise: false,
    latitude: 40.08588,
    longitude: -75.15137,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19095',
  },
  {
    city: 'Wynnewood',
    county_fips: 42091,
    county_fips_all: '42091|42045',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Delaware',
    county_weights: '{"42091": 95.24, "42045": 4.76}',
    density: 1687,
    imprecise: false,
    latitude: 39.99813,
    longitude: -75.27388,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19096',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 12814.4,
    imprecise: false,
    latitude: 39.95301,
    longitude: -75.16544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19102',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 15492.2,
    imprecise: false,
    latitude: 39.95303,
    longitude: -75.17386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19103',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 6959.8,
    imprecise: false,
    latitude: 39.95891,
    longitude: -75.19836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19104',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 6630.1,
    imprecise: false,
    latitude: 39.94589,
    longitude: -75.14224,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19106',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 10521.7,
    imprecise: false,
    latitude: 39.9518,
    longitude: -75.15864,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19107',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101|42091',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia|Montgomery',
    county_weights: '{"42101": 99.9, "42091": 0.1}',
    density: 5281.5,
    imprecise: false,
    latitude: 40.06065,
    longitude: -75.08019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19111',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.88999,
    longitude: -75.16985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19112',
  },
  {
    city: 'Philadelphia',
    county_fips: 42045,
    county_fips_all: '42045',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"42045": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.86679,
    longitude: -75.27911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19113',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 2086.5,
    imprecise: false,
    latitude: 40.06743,
    longitude: -75.00361,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19114',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 2638.8,
    imprecise: false,
    latitude: 40.09094,
    longitude: -75.04595,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19115',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101|42017',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia|Bucks',
    county_weights: '{"42101": 99.53, "42017": 0.47}',
    density: 2488.7,
    imprecise: false,
    latitude: 40.11655,
    longitude: -75.01399,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19116',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101|42091',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia|Montgomery',
    county_weights: '{"42101": 98.14, "42091": 1.86}',
    density: 1202,
    imprecise: false,
    latitude: 40.07233,
    longitude: -75.21247,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19118',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 3217.2,
    imprecise: false,
    latitude: 40.05303,
    longitude: -75.19223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19119',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 7935.3,
    imprecise: false,
    latitude: 40.03417,
    longitude: -75.11986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19120',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 6781,
    imprecise: false,
    latitude: 39.98231,
    longitude: -75.17995,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19121',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 7595.1,
    imprecise: false,
    latitude: 39.97767,
    longitude: -75.14571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19122',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 6025,
    imprecise: false,
    latitude: 39.96399,
    longitude: -75.14568,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19123',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 5328.9,
    imprecise: false,
    latitude: 40.01728,
    longitude: -75.09387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19124',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 7178.6,
    imprecise: false,
    latitude: 39.97611,
    longitude: -75.12472,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19125',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 5673.7,
    imprecise: false,
    latitude: 40.05516,
    longitude: -75.13728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19126',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101|42091',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia|Montgomery',
    county_weights: '{"42101": 98.4, "42091": 1.6}',
    density: 3831.6,
    imprecise: false,
    latitude: 40.02854,
    longitude: -75.22746,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19127',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101|42091',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia|Montgomery',
    county_weights: '{"42101": 97.66, "42091": 2.34}',
    density: 2102.7,
    imprecise: false,
    latitude: 40.05003,
    longitude: -75.23003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19128',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 2246.8,
    imprecise: false,
    latitude: 40.01338,
    longitude: -75.18454,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19129',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 9396.4,
    imprecise: false,
    latitude: 39.9676,
    longitude: -75.17495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19130',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 3206.4,
    imprecise: false,
    latitude: 39.98865,
    longitude: -75.21835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19131',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 5915.9,
    imprecise: false,
    latitude: 39.99649,
    longitude: -75.17102,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19132',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 7481.7,
    imprecise: false,
    latitude: 39.99238,
    longitude: -75.14149,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19133',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 6004.8,
    imprecise: false,
    latitude: 39.98953,
    longitude: -75.10838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19134',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 5761,
    imprecise: false,
    latitude: 40.02192,
    longitude: -75.04966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19135',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 2918,
    imprecise: false,
    latitude: 40.03973,
    longitude: -75.01932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19136',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 1279.5,
    imprecise: false,
    latitude: 39.99455,
    longitude: -75.074,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19137',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 6745.4,
    imprecise: false,
    latitude: 40.05594,
    longitude: -75.15947,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19138',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 9407.2,
    imprecise: false,
    latitude: 39.96144,
    longitude: -75.22964,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19139',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 6538.7,
    imprecise: false,
    latitude: 40.01224,
    longitude: -75.14512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19140',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 7164,
    imprecise: false,
    latitude: 40.03788,
    longitude: -75.14541,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19141',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101|42045',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia|Delaware',
    county_weights: '{"42101": 99.37, "42045": 0.63}',
    density: 6375.1,
    imprecise: false,
    latitude: 39.92278,
    longitude: -75.23375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19142',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101|42045',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia|Delaware',
    county_weights: '{"42101": 99.57, "42045": 0.43}',
    density: 7754.3,
    imprecise: false,
    latitude: 39.94315,
    longitude: -75.22664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19143',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 5442.3,
    imprecise: false,
    latitude: 40.03278,
    longitude: -75.17523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19144',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 3497.3,
    imprecise: false,
    latitude: 39.91469,
    longitude: -75.19194,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19145',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 9195.5,
    imprecise: false,
    latitude: 39.93917,
    longitude: -75.18398,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19146',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 11459.1,
    imprecise: false,
    latitude: 39.93645,
    longitude: -75.15468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19147',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 4596.9,
    imprecise: false,
    latitude: 39.91175,
    longitude: -75.1514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19148',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 9205.1,
    imprecise: false,
    latitude: 40.03781,
    longitude: -75.06544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19149',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 6345.6,
    imprecise: false,
    latitude: 40.07251,
    longitude: -75.17165,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19150',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101|42045',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia|Delaware',
    county_weights: '{"42101": 99.82, "42045": 0.18}',
    density: 5355,
    imprecise: false,
    latitude: 39.97562,
    longitude: -75.25616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19151',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 4817.1,
    imprecise: false,
    latitude: 40.06158,
    longitude: -75.04663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19152',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101|42045',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia|Delaware',
    county_weights: '{"42101": 66.75, "42045": 33.25}',
    density: 497,
    imprecise: false,
    latitude: 39.88391,
    longitude: -75.2343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19153',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101|42017',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia|Bucks',
    county_weights: '{"42101": 99.18, "42017": 0.82}',
    density: 2039.5,
    imprecise: false,
    latitude: 40.0951,
    longitude: -74.98159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19154',
  },
  {
    city: 'Paoli',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 840.1,
    imprecise: false,
    latitude: 40.0414,
    longitude: -75.4809,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19301',
  },
  {
    city: 'Atglen',
    county_fips: 42029,
    county_fips_all: '42029|42071',
    county: 'Chester',
    county_names_all: 'Chester|Lancaster',
    county_weights: '{"42029": 92.47, "42071": 7.53}',
    density: 85.1,
    imprecise: false,
    latitude: 39.93478,
    longitude: -75.97038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19310',
  },
  {
    city: 'Avondale',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 359.8,
    imprecise: false,
    latitude: 39.82163,
    longitude: -75.76887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19311',
  },
  {
    city: 'Berwyn',
    county_fips: 42029,
    county_fips_all: '42029|42045',
    county: 'Chester',
    county_names_all: 'Chester|Delaware',
    county_weights: '{"42029": 95.92, "42045": 4.08}',
    density: 495.8,
    imprecise: false,
    latitude: 40.0309,
    longitude: -75.45083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19312',
  },
  {
    city: 'Brandamore',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 188.6,
    imprecise: false,
    latitude: 40.05597,
    longitude: -75.83804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19316',
  },
  {
    city: 'Chadds Ford',
    county_fips: 42029,
    county_fips_all: '42029|42045',
    county: 'Chester',
    county_names_all: 'Chester|Delaware',
    county_weights: '{"42029": 56.81, "42045": 43.19}',
    density: 192.1,
    imprecise: false,
    latitude: 39.85722,
    longitude: -75.60244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19317',
  },
  {
    city: 'Cheyney',
    county_fips: 42045,
    county_fips_all: '42045|42029',
    county: 'Delaware',
    county_names_all: 'Delaware|Chester',
    county_weights: '{"42045": 75.86, "42029": 24.14}',
    density: 471.7,
    imprecise: false,
    latitude: 39.92723,
    longitude: -75.52319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19319',
  },
  {
    city: 'Coatesville',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 264.7,
    imprecise: false,
    latitude: 39.97046,
    longitude: -75.83069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19320',
  },
  {
    city: 'Cochranville',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 68.8,
    imprecise: false,
    latitude: 39.87359,
    longitude: -75.91695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19330',
  },
  {
    city: 'Devon',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 780.6,
    imprecise: false,
    latitude: 40.04208,
    longitude: -75.42331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19333',
  },
  {
    city: 'Downingtown',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 478.2,
    imprecise: false,
    latitude: 40.02271,
    longitude: -75.72045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19335',
  },
  {
    city: 'Exton',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 612.4,
    imprecise: false,
    latitude: 40.04213,
    longitude: -75.63814,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19341',
  },
  {
    city: 'Glen Mills',
    county_fips: 42045,
    county_fips_all: '42045|42029',
    county: 'Delaware',
    county_names_all: 'Delaware|Chester',
    county_weights: '{"42045": 96.7, "42029": 3.3}',
    density: 405.6,
    imprecise: false,
    latitude: 39.90458,
    longitude: -75.50243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19342',
  },
  {
    city: 'Glenmoore',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 118.3,
    imprecise: false,
    latitude: 40.10203,
    longitude: -75.75461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19343',
  },
  {
    city: 'Honey Brook',
    county_fips: 42029,
    county_fips_all: '42029|42071',
    county: 'Chester',
    county_names_all: 'Chester|Lancaster',
    county_weights: '{"42029": 97.43, "42071": 2.57}',
    density: 149.5,
    imprecise: false,
    latitude: 40.08279,
    longitude: -75.88338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19344',
  },
  {
    city: 'Kennett Square',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 247.7,
    imprecise: false,
    latitude: 39.86706,
    longitude: -75.71763,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19348',
  },
  {
    city: 'Landenberg',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 151,
    imprecise: false,
    latitude: 39.76244,
    longitude: -75.79528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19350',
  },
  {
    city: 'Lincoln University',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 252.5,
    imprecise: false,
    latitude: 39.78036,
    longitude: -75.89054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19352',
  },
  {
    city: 'Malvern',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 296.7,
    imprecise: false,
    latitude: 40.0466,
    longitude: -75.5302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19355',
  },
  {
    city: 'Modena',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 527.3,
    imprecise: false,
    latitude: 39.96362,
    longitude: -75.80659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19358',
  },
  {
    city: 'Nottingham',
    county_fips: 42029,
    county_fips_all: '42029|42071',
    county: 'Chester',
    county_names_all: 'Chester|Lancaster',
    county_weights: '{"42029": 61.42, "42071": 38.58}',
    density: 79.9,
    imprecise: false,
    latitude: 39.75175,
    longitude: -76.06576,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19362',
  },
  {
    city: 'Oxford',
    county_fips: 42029,
    county_fips_all: '42029|42071',
    county: 'Chester',
    county_names_all: 'Chester|Lancaster',
    county_weights: '{"42029": 96.11, "42071": 3.89}',
    density: 139.2,
    imprecise: false,
    latitude: 39.7864,
    longitude: -75.97279,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19363',
  },
  {
    city: 'Parkesburg',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 187.5,
    imprecise: false,
    latitude: 39.9655,
    longitude: -75.92766,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19365',
  },
  {
    city: 'Pomeroy',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 49.8,
    imprecise: false,
    latitude: 39.96285,
    longitude: -75.88395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19367',
  },
  {
    city: 'Sadsburyville',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 772.9,
    imprecise: false,
    latitude: 39.98082,
    longitude: -75.89496,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19369',
  },
  {
    city: 'Thorndale',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 765.6,
    imprecise: false,
    latitude: 39.99941,
    longitude: -75.75972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19372',
  },
  {
    city: 'Thornton',
    county_fips: 42045,
    county_fips_all: '42045|42029',
    county: 'Delaware',
    county_names_all: 'Delaware|Chester',
    county_weights: '{"42045": 95.82, "42029": 4.18}',
    density: 283,
    imprecise: false,
    latitude: 39.90674,
    longitude: -75.53255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19373',
  },
  {
    city: 'Toughkenamon',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 107.8,
    imprecise: false,
    latitude: 39.83333,
    longitude: -75.75267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19374',
  },
  {
    city: 'Unionville',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 195.3,
    imprecise: false,
    latitude: 39.8996,
    longitude: -75.73993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19375',
  },
  {
    city: 'West Chester',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 631.8,
    imprecise: false,
    latitude: 39.98594,
    longitude: -75.60358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19380',
  },
  {
    city: 'West Chester',
    county_fips: 42029,
    county_fips_all: '42029|42045',
    county: 'Chester',
    county_names_all: 'Chester|Delaware',
    county_weights: '{"42029": 97.45, "42045": 2.55}',
    density: 453,
    imprecise: false,
    latitude: 39.92766,
    longitude: -75.61475,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19382',
  },
  {
    city: 'West Grove',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 165.3,
    imprecise: false,
    latitude: 39.83683,
    longitude: -75.83962,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19390',
  },
  {
    city: 'Norristown',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 2721.7,
    imprecise: false,
    latitude: 40.13042,
    longitude: -75.33143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19401',
  },
  {
    city: 'Norristown',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 759.8,
    imprecise: false,
    latitude: 40.14898,
    longitude: -75.38034,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19403',
  },
  {
    city: 'Bridgeport',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 1929.5,
    imprecise: false,
    latitude: 40.09949,
    longitude: -75.33497,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19405',
  },
  {
    city: 'King Of Prussia',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 872,
    imprecise: false,
    latitude: 40.09467,
    longitude: -75.38402,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19406',
  },
  {
    city: 'Blue Bell',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 642.5,
    imprecise: false,
    latitude: 40.15835,
    longitude: -75.27858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19422',
  },
  {
    city: 'Chester Springs',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 248.1,
    imprecise: false,
    latitude: 40.10383,
    longitude: -75.64476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19425',
  },
  {
    city: 'Collegeville',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 493.1,
    imprecise: false,
    latitude: 40.18972,
    longitude: -75.43734,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19426',
  },
  {
    city: 'Conshohocken',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 1078.7,
    imprecise: false,
    latitude: 40.08011,
    longitude: -75.30317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19428',
  },
  {
    city: 'Frederick',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 24.3,
    imprecise: false,
    latitude: 40.32788,
    longitude: -75.56518,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 75,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19435',
  },
  {
    city: 'Gwynedd',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 792.4,
    imprecise: false,
    latitude: 40.20253,
    longitude: -75.24842,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19436',
  },
  {
    city: 'Gwynedd Valley',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 177.4,
    imprecise: false,
    latitude: 40.18706,
    longitude: -75.25274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19437',
  },
  {
    city: 'Harleysville',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 442.3,
    imprecise: false,
    latitude: 40.27018,
    longitude: -75.39554,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19438',
  },
  {
    city: 'Hatfield',
    county_fips: 42091,
    county_fips_all: '42091|42017',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Bucks',
    county_weights: '{"42091": 75.31, "42017": 24.69}',
    density: 661.7,
    imprecise: false,
    latitude: 40.285,
    longitude: -75.29102,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19440',
  },
  {
    city: 'Kimberton',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.13233,
    longitude: -75.57863,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19442',
  },
  {
    city: 'Lafayette Hill',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 884.6,
    imprecise: false,
    latitude: 40.08686,
    longitude: -75.25427,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19444',
  },
  {
    city: 'Lansdale',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 1058.5,
    imprecise: false,
    latitude: 40.23068,
    longitude: -75.30369,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 61848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19446',
  },
  {
    city: 'Mont Clare',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 678.8,
    imprecise: false,
    latitude: 40.13886,
    longitude: -75.50141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19453',
  },
  {
    city: 'North Wales',
    county_fips: 42091,
    county_fips_all: '42091|42017',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Bucks',
    county_weights: '{"42091": 99.11, "42017": 0.89}',
    density: 867.9,
    imprecise: false,
    latitude: 40.22303,
    longitude: -75.24365,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19454',
  },
  {
    city: 'Oaks',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 586,
    imprecise: false,
    latitude: 40.1367,
    longitude: -75.45962,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19456',
  },
  {
    city: 'Parker Ford',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 221.2,
    imprecise: false,
    latitude: 40.20512,
    longitude: -75.58758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19457',
  },
  {
    city: 'Phoenixville',
    county_fips: 42029,
    county_fips_all: '42029|42091',
    county: 'Chester',
    county_names_all: 'Chester|Montgomery',
    county_weights: '{"42029": 81.17, "42091": 18.83}',
    density: 507.9,
    imprecise: false,
    latitude: 40.12674,
    longitude: -75.5294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19460',
  },
  {
    city: 'Plymouth Meeting',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 759.6,
    imprecise: false,
    latitude: 40.11542,
    longitude: -75.28453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19462',
  },
  {
    city: 'Pottstown',
    county_fips: 42091,
    county_fips_all: '42091|42011',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Berks',
    county_weights: '{"42091": 99.23, "42011": 0.77}',
    density: 739.4,
    imprecise: false,
    latitude: 40.25882,
    longitude: -75.616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19464',
  },
  {
    city: 'Pottstown',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 201.7,
    imprecise: false,
    latitude: 40.19981,
    longitude: -75.6727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19465',
  },
  {
    city: 'Royersford',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 643.3,
    imprecise: false,
    latitude: 40.20776,
    longitude: -75.53137,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19468',
  },
  {
    city: 'Sassamansville',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 40.34036,
    longitude: -75.58189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19472',
  },
  {
    city: 'Schwenksville',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 274.1,
    imprecise: false,
    latitude: 40.25842,
    longitude: -75.47363,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19473',
  },
  {
    city: 'Skippack',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 582.6,
    imprecise: false,
    latitude: 40.22427,
    longitude: -75.40507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19474',
  },
  {
    city: 'Spring City',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 288.6,
    imprecise: false,
    latitude: 40.17028,
    longitude: -75.60042,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19475',
  },
  {
    city: 'Spring House',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 737,
    imprecise: false,
    latitude: 40.18447,
    longitude: -75.23583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19477',
  },
  {
    city: 'Worcester',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 269.2,
    imprecise: false,
    latitude: 40.19673,
    longitude: -75.35401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19490',
  },
  {
    city: 'Zieglerville',
    county_fips: 42091,
    county_fips_all: '42091',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"42091": 100}',
    density: 188.3,
    imprecise: false,
    latitude: 40.28817,
    longitude: -75.50623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19492',
  },
  {
    city: 'Adamstown',
    county_fips: 42071,
    county_fips_all: '42071|42011',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Berks',
    county_weights: '{"42071": 97.94, "42011": 2.06}',
    density: 325.1,
    imprecise: false,
    latitude: 40.24314,
    longitude: -76.05822,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19501',
  },
  {
    city: 'Bally',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 275.4,
    imprecise: false,
    latitude: 40.40808,
    longitude: -75.5755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19503',
  },
  {
    city: 'Barto',
    county_fips: 42011,
    county_fips_all: '42011|42091',
    county: 'Berks',
    county_names_all: 'Berks|Montgomery',
    county_weights: '{"42011": 71.61, "42091": 28.39}',
    density: 88.8,
    imprecise: false,
    latitude: 40.40699,
    longitude: -75.58965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19504',
  },
  {
    city: 'Bechtelsville',
    county_fips: 42011,
    county_fips_all: '42011|42091',
    county: 'Berks',
    county_names_all: 'Berks|Montgomery',
    county_weights: '{"42011": 92.82, "42091": 7.18}',
    density: 153.4,
    imprecise: false,
    latitude: 40.3795,
    longitude: -75.62331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19505',
  },
  {
    city: 'Bernville',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 43.3,
    imprecise: false,
    latitude: 40.45873,
    longitude: -76.12379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19506',
  },
  {
    city: 'Bethel',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 33.9,
    imprecise: false,
    latitude: 40.49268,
    longitude: -76.28235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19507',
  },
  {
    city: 'Birdsboro',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 141.2,
    imprecise: false,
    latitude: 40.25913,
    longitude: -75.83984,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19508',
  },
  {
    city: 'Blandon',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 600.6,
    imprecise: false,
    latitude: 40.44551,
    longitude: -75.88179,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19510',
  },
  {
    city: 'Bowers',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 41.7,
    imprecise: false,
    latitude: 40.48473,
    longitude: -75.74381,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19511',
  },
  {
    city: 'Boyertown',
    county_fips: 42011,
    county_fips_all: '42011|42091',
    county: 'Berks',
    county_names_all: 'Berks|Montgomery',
    county_weights: '{"42011": 98.5, "42091": 1.5}',
    density: 140.9,
    imprecise: false,
    latitude: 40.35,
    longitude: -75.67937,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19512',
  },
  {
    city: 'Centerport',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 756.5,
    imprecise: false,
    latitude: 40.48686,
    longitude: -76.00526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19516',
  },
  {
    city: 'Douglassville',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 181.2,
    imprecise: false,
    latitude: 40.27187,
    longitude: -75.74981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19518',
  },
  {
    city: 'Elverson',
    county_fips: 42029,
    county_fips_all: '42029|42011',
    county: 'Chester',
    county_names_all: 'Chester|Berks',
    county_weights: '{"42029": 76.88, "42011": 23.12}',
    density: 64.6,
    imprecise: false,
    latitude: 40.15968,
    longitude: -75.79959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19520',
  },
  {
    city: 'Fleetwood',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 117.1,
    imprecise: false,
    latitude: 40.44948,
    longitude: -75.81676,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19522',
  },
  {
    city: 'Geigertown',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 40.20116,
    longitude: -75.84974,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19523',
  },
  {
    city: 'Gilbertsville',
    county_fips: 42091,
    county_fips_all: '42091|42011',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Berks',
    county_weights: '{"42091": 99.82, "42011": 0.18}',
    density: 400.3,
    imprecise: false,
    latitude: 40.30784,
    longitude: -75.58591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19525',
  },
  {
    city: 'Hamburg',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 77.8,
    imprecise: false,
    latitude: 40.5465,
    longitude: -75.99802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19526',
  },
  {
    city: 'Kempton',
    county_fips: 42011,
    county_fips_all: '42011|42077',
    county: 'Berks',
    county_names_all: 'Berks|Lehigh',
    county_weights: '{"42011": 65.94, "42077": 34.06}',
    density: 22.4,
    imprecise: false,
    latitude: 40.63387,
    longitude: -75.86158,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19529',
  },
  {
    city: 'Kutztown',
    county_fips: 42011,
    county_fips_all: '42011|42077',
    county: 'Berks',
    county_names_all: 'Berks|Lehigh',
    county_weights: '{"42011": 90.38, "42077": 9.62}',
    density: 110.1,
    imprecise: false,
    latitude: 40.54012,
    longitude: -75.77675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19530',
  },
  {
    city: 'Leesport',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 193.5,
    imprecise: false,
    latitude: 40.42245,
    longitude: -75.99021,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19533',
  },
  {
    city: 'Lenhartsville',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 30.4,
    imprecise: false,
    latitude: 40.57813,
    longitude: -75.88111,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19534',
  },
  {
    city: 'Limekiln',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 40.3394,
    longitude: -75.79537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19535',
  },
  {
    city: 'Lyon Station',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 484.3,
    imprecise: false,
    latitude: 40.48069,
    longitude: -75.75891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19536',
  },
  {
    city: 'Maxatawny',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 52.9,
    imprecise: false,
    latitude: 40.54655,
    longitude: -75.70023,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19538',
  },
  {
    city: 'Mertztown',
    county_fips: 42011,
    county_fips_all: '42011|42077',
    county: 'Berks',
    county_names_all: 'Berks|Lehigh',
    county_weights: '{"42011": 94.84, "42077": 5.16}',
    density: 68.2,
    imprecise: false,
    latitude: 40.49071,
    longitude: -75.68823,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19539',
  },
  {
    city: 'Mohnton',
    county_fips: 42011,
    county_fips_all: '42011|42071',
    county: 'Berks',
    county_names_all: 'Berks|Lancaster',
    county_weights: '{"42011": 90.08, "42071": 9.92}',
    density: 131.1,
    imprecise: false,
    latitude: 40.23714,
    longitude: -75.9658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19540',
  },
  {
    city: 'Mohrsville',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 77.8,
    imprecise: false,
    latitude: 40.47821,
    longitude: -76.02597,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19541',
  },
  {
    city: 'Morgantown',
    county_fips: 42011,
    county_fips_all: '42011|42071|42029',
    county: 'Berks',
    county_names_all: 'Berks|Lancaster|Chester',
    county_weights: '{"42011": 68.73, "42071": 28.95, "42029": 2.32}',
    density: 115.4,
    imprecise: false,
    latitude: 40.1697,
    longitude: -75.89635,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19543',
  },
  {
    city: 'Mount Aetna',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 439.9,
    imprecise: false,
    latitude: 40.41669,
    longitude: -76.29619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19544',
  },
  {
    city: 'New Berlinville',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 15344.6,
    imprecise: false,
    latitude: 40.3411,
    longitude: -75.62977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19545',
  },
  {
    city: 'Oley',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 62,
    imprecise: false,
    latitude: 40.38315,
    longitude: -75.76644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19547',
  },
  {
    city: 'Port Clinton',
    county_fips: 42107,
    county_fips_all: '42107',
    county: 'Schuylkill',
    county_names_all: 'Schuylkill',
    county_weights: '{"42107": 100}',
    density: 137.4,
    imprecise: false,
    latitude: 40.58176,
    longitude: -76.02672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19549',
  },
  {
    city: 'Rehrersburg',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 121.4,
    imprecise: false,
    latitude: 40.45593,
    longitude: -76.25055,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19550',
  },
  {
    city: 'Robesonia',
    county_fips: 42011,
    county_fips_all: '42011|42075|42071',
    county: 'Berks',
    county_names_all: 'Berks|Lebanon|Lancaster',
    county_weights: '{"42011": 82.14, "42075": 17.02, "42071": 0.84}',
    density: 72.8,
    imprecise: false,
    latitude: 40.35951,
    longitude: -76.14213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19551',
  },
  {
    city: 'Shartlesville',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 291.5,
    imprecise: false,
    latitude: 40.51288,
    longitude: -76.10377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19554',
  },
  {
    city: 'Shoemakersville',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 92.5,
    imprecise: false,
    latitude: 40.49335,
    longitude: -75.94993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19555',
  },
  {
    city: 'Strausstown',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 201.6,
    imprecise: false,
    latitude: 40.49234,
    longitude: -76.18661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19559',
  },
  {
    city: 'Temple',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 377.9,
    imprecise: false,
    latitude: 40.40053,
    longitude: -75.88993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19560',
  },
  {
    city: 'Topton',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 996.9,
    imprecise: false,
    latitude: 40.50316,
    longitude: -75.70135,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19562',
  },
  {
    city: 'Virginville',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 312.3,
    imprecise: false,
    latitude: 40.51926,
    longitude: -75.87403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19564',
  },
  {
    city: 'Wernersville',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 199.4,
    imprecise: false,
    latitude: 40.34231,
    longitude: -76.08873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19565',
  },
  {
    city: 'Womelsdorf',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 103.1,
    imprecise: false,
    latitude: 40.3957,
    longitude: -76.20989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19567',
  },
  {
    city: 'Reading',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 3744,
    imprecise: false,
    latitude: 40.3526,
    longitude: -75.9408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19601',
  },
  {
    city: 'Reading',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 3499,
    imprecise: false,
    latitude: 40.32695,
    longitude: -75.91701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19602',
  },
  {
    city: 'Reading',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 4662.8,
    imprecise: false,
    latitude: 40.35791,
    longitude: -75.90954,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19604',
  },
  {
    city: 'Reading',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 470.2,
    imprecise: false,
    latitude: 40.39917,
    longitude: -75.94596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19605',
  },
  {
    city: 'Reading',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 519.4,
    imprecise: false,
    latitude: 40.3357,
    longitude: -75.85755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19606',
  },
  {
    city: 'Reading',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 827.5,
    imprecise: false,
    latitude: 40.29147,
    longitude: -75.94521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19607',
  },
  {
    city: 'Reading',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 354.9,
    imprecise: false,
    latitude: 40.31401,
    longitude: -76.03574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19608',
  },
  {
    city: 'Reading',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 1660.3,
    imprecise: false,
    latitude: 40.32774,
    longitude: -75.99622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19609',
  },
  {
    city: 'Reading',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 903.3,
    imprecise: false,
    latitude: 40.34015,
    longitude: -75.97612,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19610',
  },
  {
    city: 'Reading',
    county_fips: 42011,
    county_fips_all: '42011',
    county: 'Berks',
    county_names_all: 'Berks',
    county_weights: '{"42011": 100}',
    density: 2085.3,
    imprecise: false,
    latitude: 40.32473,
    longitude: -75.9411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19611',
  },
  {
    city: 'Bear',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 624.6,
    imprecise: false,
    latitude: 39.58427,
    longitude: -75.69914,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19701',
  },
  {
    city: 'Newark',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 765.4,
    imprecise: false,
    latitude: 39.62199,
    longitude: -75.72803,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19702',
  },
  {
    city: 'Claymont',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 1503.3,
    imprecise: false,
    latitude: 39.8043,
    longitude: -75.45794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19703',
  },
  {
    city: 'Delaware City',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 310.9,
    imprecise: false,
    latitude: 39.5715,
    longitude: -75.5905,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19706',
  },
  {
    city: 'Hockessin',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 508.9,
    imprecise: false,
    latitude: 39.78512,
    longitude: -75.68147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19707',
  },
  {
    city: 'Middletown',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 264.7,
    imprecise: false,
    latitude: 39.48923,
    longitude: -75.68314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19709',
  },
  {
    city: 'Montchanin',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.78964,
    longitude: -75.58458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19710',
  },
  {
    city: 'Newark',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 696.4,
    imprecise: false,
    latitude: 39.71379,
    longitude: -75.74033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19711',
  },
  {
    city: 'Newark',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 913.1,
    imprecise: false,
    latitude: 39.67097,
    longitude: -75.70972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19713',
  },
  {
    city: 'Newark',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 9030.9,
    imprecise: false,
    latitude: 39.68121,
    longitude: -75.75343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19717',
  },
  {
    city: 'New Castle',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 628.9,
    imprecise: false,
    latitude: 39.645,
    longitude: -75.60678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19720',
  },
  {
    city: 'Odessa',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 243.2,
    imprecise: false,
    latitude: 39.45443,
    longitude: -75.66077,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19730',
  },
  {
    city: 'Port Penn',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 100.1,
    imprecise: false,
    latitude: 39.5102,
    longitude: -75.59616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19731',
  },
  {
    city: 'Rockland',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 19.6,
    imprecise: false,
    latitude: 39.80033,
    longitude: -75.57455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19732',
  },
  {
    city: 'Saint Georges',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 653.8,
    imprecise: false,
    latitude: 39.55928,
    longitude: -75.65143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19733',
  },
  {
    city: 'Townsend',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 68.7,
    imprecise: false,
    latitude: 39.38377,
    longitude: -75.65026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19734',
  },
  {
    city: 'Yorklyn',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 323.9,
    imprecise: false,
    latitude: 39.78031,
    longitude: -75.64274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19736',
  },
  {
    city: 'Wilmington',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 1433.8,
    imprecise: false,
    latitude: 39.72782,
    longitude: -75.54615,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19801',
  },
  {
    city: 'Wilmington',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 2887.1,
    imprecise: false,
    latitude: 39.75715,
    longitude: -75.52873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19802',
  },
  {
    city: 'Wilmington',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 679.5,
    imprecise: false,
    latitude: 39.79912,
    longitude: -75.5422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19803',
  },
  {
    city: 'Wilmington',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 1010.4,
    imprecise: false,
    latitude: 39.7166,
    longitude: -75.62094,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19804',
  },
  {
    city: 'Wilmington',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 2897,
    imprecise: false,
    latitude: 39.74523,
    longitude: -75.59373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19805',
  },
  {
    city: 'Wilmington',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 2214.6,
    imprecise: false,
    latitude: 39.762,
    longitude: -75.56336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19806',
  },
  {
    city: 'Wilmington',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 166.1,
    imprecise: false,
    latitude: 39.79767,
    longitude: -75.61284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19807',
  },
  {
    city: 'Wilmington',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 1097.4,
    imprecise: false,
    latitude: 39.73777,
    longitude: -75.66596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19808',
  },
  {
    city: 'Wilmington',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 817.8,
    imprecise: false,
    latitude: 39.75801,
    longitude: -75.50218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19809',
  },
  {
    city: 'Wilmington',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 1297.1,
    imprecise: false,
    latitude: 39.81855,
    longitude: -75.50628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19810',
  },
  {
    city: 'Dover',
    county_fips: 10001,
    county_fips_all: '10001',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"10001": 100}',
    density: 192.4,
    imprecise: false,
    latitude: 39.17335,
    longitude: -75.47758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19901',
  },
  {
    city: 'Dover Afb',
    county_fips: 10001,
    county_fips_all: '10001',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"10001": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 39.12765,
    longitude: -75.46694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19902',
  },
  {
    city: 'Dover',
    county_fips: 10001,
    county_fips_all: '10001',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"10001": 100}',
    density: 347,
    imprecise: false,
    latitude: 39.17289,
    longitude: -75.59517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19904',
  },
  {
    city: 'Bethany Beach',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 198.7,
    imprecise: false,
    latitude: 38.56311,
    longitude: -75.07085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19930',
  },
  {
    city: 'Bethel',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 121.3,
    imprecise: false,
    latitude: 38.56928,
    longitude: -75.61029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19931',
  },
  {
    city: 'Bridgeville',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 60.8,
    imprecise: false,
    latitude: 38.73699,
    longitude: -75.60586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19933',
  },
  {
    city: 'Camden Wyoming',
    county_fips: 10001,
    county_fips_all: '10001',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"10001": 100}',
    density: 116.5,
    imprecise: false,
    latitude: 39.08135,
    longitude: -75.63113,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19934',
  },
  {
    city: 'Cheswold',
    county_fips: 10001,
    county_fips_all: '10001',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"10001": 100}',
    density: 285.3,
    imprecise: false,
    latitude: 39.21846,
    longitude: -75.58498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19936',
  },
  {
    city: 'Clayton',
    county_fips: 10001,
    county_fips_all: '10001|10003',
    county: 'Kent',
    county_names_all: 'Kent|New Castle',
    county_weights: '{"10001": 85.08, "10003": 14.92}',
    density: 76.6,
    imprecise: false,
    latitude: 39.25646,
    longitude: -75.69884,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19938',
  },
  {
    city: 'Dagsboro',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 111.4,
    imprecise: false,
    latitude: 38.56575,
    longitude: -75.2022,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19939',
  },
  {
    city: 'Delmar',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 70.5,
    imprecise: false,
    latitude: 38.47723,
    longitude: -75.56828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19940',
  },
  {
    city: 'Ellendale',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 43.8,
    imprecise: false,
    latitude: 38.7949,
    longitude: -75.42476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19941',
  },
  {
    city: 'Felton',
    county_fips: 10001,
    county_fips_all: '10001',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"10001": 100}',
    density: 82.9,
    imprecise: false,
    latitude: 39.00562,
    longitude: -75.60756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19943',
  },
  {
    city: 'Fenwick Island',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 197.6,
    imprecise: false,
    latitude: 38.47542,
    longitude: -75.05559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19944',
  },
  {
    city: 'Frankford',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 59.7,
    imprecise: false,
    latitude: 38.50336,
    longitude: -75.22855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19945',
  },
  {
    city: 'Frederica',
    county_fips: 10001,
    county_fips_all: '10001',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"10001": 100}',
    density: 93.8,
    imprecise: false,
    latitude: 39.03224,
    longitude: -75.45297,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19946',
  },
  {
    city: 'Georgetown',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 67.2,
    imprecise: false,
    latitude: 38.67421,
    longitude: -75.39864,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19947',
  },
  {
    city: 'Greenwood',
    county_fips: 10005,
    county_fips_all: '10005|10001',
    county: 'Sussex',
    county_names_all: 'Sussex|Kent',
    county_weights: '{"10005": 75.78, "10001": 24.22}',
    density: 42.2,
    imprecise: false,
    latitude: 38.82007,
    longitude: -75.59691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19950',
  },
  {
    city: 'Harbeson',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 97,
    imprecise: false,
    latitude: 38.68763,
    longitude: -75.25124,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19951',
  },
  {
    city: 'Harrington',
    county_fips: 10001,
    county_fips_all: '10001|10005',
    county: 'Kent',
    county_names_all: 'Kent|Sussex',
    county_weights: '{"10001": 98.41, "10005": 1.59}',
    density: 46.3,
    imprecise: false,
    latitude: 38.91654,
    longitude: -75.62531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19952',
  },
  {
    city: 'Hartly',
    county_fips: 10001,
    county_fips_all: '10001',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"10001": 100}',
    density: 67.9,
    imprecise: false,
    latitude: 39.15145,
    longitude: -75.69695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19953',
  },
  {
    city: 'Houston',
    county_fips: 10001,
    county_fips_all: '10001',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"10001": 100}',
    density: 56.4,
    imprecise: false,
    latitude: 38.89891,
    longitude: -75.52092,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19954',
  },
  {
    city: 'Kenton',
    county_fips: 10001,
    county_fips_all: '10001',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"10001": 100}',
    density: 1373,
    imprecise: false,
    latitude: 39.22652,
    longitude: -75.6654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19955',
  },
  {
    city: 'Laurel',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 62.8,
    imprecise: false,
    latitude: 38.5465,
    longitude: -75.53961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19956',
  },
  {
    city: 'Lewes',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 260.9,
    imprecise: false,
    latitude: 38.72737,
    longitude: -75.16632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19958',
  },
  {
    city: 'Lincoln',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 86.4,
    imprecise: false,
    latitude: 38.85082,
    longitude: -75.41363,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19960',
  },
  {
    city: 'Magnolia',
    county_fips: 10001,
    county_fips_all: '10001',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"10001": 100}',
    density: 363.8,
    imprecise: false,
    latitude: 39.07005,
    longitude: -75.49753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19962',
  },
  {
    city: 'Milford',
    county_fips: 10005,
    county_fips_all: '10005|10001',
    county: 'Sussex',
    county_names_all: 'Sussex|Kent',
    county_weights: '{"10005": 50.26, "10001": 49.74}',
    density: 86.3,
    imprecise: false,
    latitude: 38.93347,
    longitude: -75.37799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19963',
  },
  {
    city: 'Marydel',
    county_fips: 10001,
    county_fips_all: '10001',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"10001": 100}',
    density: 67.5,
    imprecise: false,
    latitude: 39.09436,
    longitude: -75.72439,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19964',
  },
  {
    city: 'Millsboro',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 155.5,
    imprecise: false,
    latitude: 38.58118,
    longitude: -75.28274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19966',
  },
  {
    city: 'Millville',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 563.6,
    imprecise: false,
    latitude: 38.53978,
    longitude: -75.1209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19967',
  },
  {
    city: 'Milton',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 93.6,
    imprecise: false,
    latitude: 38.77553,
    longitude: -75.28466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19968',
  },
  {
    city: 'Ocean View',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 352.9,
    imprecise: false,
    latitude: 38.55504,
    longitude: -75.09901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19970',
  },
  {
    city: 'Rehoboth Beach',
    county_fips: 10005,
    county_fips_all: '10005',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"10005": 100}',
    density: 320,
    imprecise: false,
    latitude: 38.69113,
    longitude: -75.10132,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19971',
  },
  {
    city: 'Seaford',
    county_fips: 10005,
    county_fips_all: '10005|24019',
    county: 'Sussex',
    county_names_all: 'Sussex|Dorchester',
    county_weights: '{"10005": 92.75, "24019": 7.25}',
    density: 123.3,
    imprecise: false,
    latitude: 38.63404,
    longitude: -75.62454,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19973',
  },
  {
    city: 'Selbyville',
    county_fips: 10005,
    county_fips_all: '10005|24047',
    county: 'Sussex',
    county_names_all: 'Sussex|Worcester',
    county_weights: '{"10005": 99.82, "24047": 0.18}',
    density: 164.2,
    imprecise: false,
    latitude: 38.46862,
    longitude: -75.17462,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19975',
  },
  {
    city: 'Smyrna',
    county_fips: 10001,
    county_fips_all: '10001|10003',
    county: 'Kent',
    county_names_all: 'Kent|New Castle',
    county_weights: '{"10001": 78.87, "10003": 21.13}',
    density: 128.7,
    imprecise: false,
    latitude: 39.29653,
    longitude: -75.55132,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19977',
  },
  {
    city: 'Viola',
    county_fips: 10001,
    county_fips_all: '10001',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"10001": 100}',
    density: 72.8,
    imprecise: false,
    latitude: 39.05041,
    longitude: -75.57642,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19979',
  },
  {
    city: 'Woodside',
    county_fips: 10001,
    county_fips_all: '10001',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"10001": 100}',
    density: 444.8,
    imprecise: false,
    latitude: 39.07349,
    longitude: -75.57008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19980',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 8414.4,
    imprecise: false,
    latitude: 38.91002,
    longitude: -77.018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20001',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 5441.7,
    imprecise: false,
    latitude: 38.90511,
    longitude: -76.98431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 72397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20002',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 6367.9,
    imprecise: false,
    latitude: 38.88193,
    longitude: -76.99033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20003',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 3644.4,
    imprecise: false,
    latitude: 38.89504,
    longitude: -77.02661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20004',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 11695.4,
    imprecise: false,
    latitude: 38.90443,
    longitude: -77.0316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20005',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 1490.9,
    imprecise: false,
    latitude: 38.89847,
    longitude: -77.04119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20006',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 3074.3,
    imprecise: false,
    latitude: 38.91259,
    longitude: -77.07756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20007',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 3678.8,
    imprecise: false,
    latitude: 38.93539,
    longitude: -77.05935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20008',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 14690.5,
    imprecise: false,
    latitude: 38.91986,
    longitude: -77.03749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20009',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 12343.1,
    imprecise: false,
    latitude: 38.93255,
    longitude: -77.03128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20010',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 4854.8,
    imprecise: false,
    latitude: 38.95295,
    longitude: -77.02323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 67434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20011',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 3279.2,
    imprecise: false,
    latitude: 38.97863,
    longitude: -77.03076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20012',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 1738.8,
    imprecise: false,
    latitude: 38.96661,
    longitude: -77.05837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20015',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 2851.8,
    imprecise: false,
    latitude: 38.93822,
    longitude: -77.09139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20016',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 3685.7,
    imprecise: false,
    latitude: 38.93813,
    longitude: -76.99294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20017',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 2502.5,
    imprecise: false,
    latitude: 38.92596,
    longitude: -76.97281,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20018',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 3988.1,
    imprecise: false,
    latitude: 38.89214,
    longitude: -76.94195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20019',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 4450.2,
    imprecise: false,
    latitude: 38.86234,
    longitude: -76.97446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20020',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 2796.3,
    imprecise: false,
    latitude: 38.87517,
    longitude: -77.0295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20024',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 3010.8,
    imprecise: false,
    latitude: 38.83142,
    longitude: -77.01514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20032',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 5476.7,
    imprecise: false,
    latitude: 38.90705,
    longitude: -77.04155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20036',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 6938.1,
    imprecise: false,
    latitude: 38.89213,
    longitude: -77.0535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20037',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.89673,
    longitude: -77.0308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20045',
  },
  {
    city: 'Aldie',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 407.5,
    imprecise: false,
    latitude: 38.95949,
    longitude: -77.60829,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20105',
  },
  {
    city: 'Amissville',
    county_fips: 51157,
    county_fips_all: '51157|51047|51061',
    county: 'Rappahannock',
    county_names_all: 'Rappahannock|Culpeper|Fauquier',
    county_weights: '{"51157": 71.66, "51047": 21.06, "51061": 7.28}',
    density: 31,
    imprecise: false,
    latitude: 38.6871,
    longitude: -78.0133,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20106',
  },
  {
    city: 'Manassas',
    county_fips: 51153,
    county_fips_all: '51153',
    county: 'Prince William',
    county_names_all: 'Prince William',
    county_weights: '{"51153": 100}',
    density: 736.4,
    imprecise: false,
    latitude: 38.79472,
    longitude: -77.53105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20109',
  },
  {
    city: 'Manassas',
    county_fips: 51683,
    county_fips_all: '51683|51153',
    county: 'Manassas',
    county_names_all: 'Manassas|Prince William',
    county_weights: '{"51683": 76.72, "51153": 23.28}',
    density: 1500.6,
    imprecise: false,
    latitude: 38.7464,
    longitude: -77.48699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20110',
  },
  {
    city: 'Manassas',
    county_fips: 51153,
    county_fips_all: '51153|51685',
    county: 'Prince William',
    county_names_all: 'Prince William|Manassas Park',
    county_weights: '{"51153": 81.96, "51685": 18.04}',
    density: 897.3,
    imprecise: false,
    latitude: 38.74907,
    longitude: -77.43039,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20111',
  },
  {
    city: 'Manassas',
    county_fips: 51153,
    county_fips_all: '51153',
    county: 'Prince William',
    county_names_all: 'Prince William',
    county_weights: '{"51153": 100}',
    density: 347.5,
    imprecise: false,
    latitude: 38.67274,
    longitude: -77.42901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20112',
  },
  {
    city: 'Marshall',
    county_fips: 51061,
    county_fips_all: '51061',
    county: 'Fauquier',
    county_names_all: 'Fauquier',
    county_weights: '{"51061": 100}',
    density: 32,
    imprecise: false,
    latitude: 38.82138,
    longitude: -77.89764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20115',
  },
  {
    city: 'Middleburg',
    county_fips: 51107,
    county_fips_all: '51107|51061',
    county: 'Loudoun',
    county_names_all: 'Loudoun|Fauquier',
    county_weights: '{"51107": 89.41, "51061": 10.59}',
    density: 22.2,
    imprecise: false,
    latitude: 38.99473,
    longitude: -77.73851,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20117',
  },
  {
    city: 'Catlett',
    county_fips: 51061,
    county_fips_all: '51061|51153',
    county: 'Fauquier',
    county_names_all: 'Fauquier|Prince William',
    county_weights: '{"51061": 99.02, "51153": 0.98}',
    density: 20.3,
    imprecise: false,
    latitude: 38.62159,
    longitude: -77.62819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20119',
  },
  {
    city: 'Centreville',
    county_fips: 51059,
    county_fips_all: '51059|51107',
    county: 'Fairfax',
    county_names_all: 'Fairfax|Loudoun',
    county_weights: '{"51059": 89.89, "51107": 10.11}',
    density: 921.1,
    imprecise: false,
    latitude: 38.85576,
    longitude: -77.47987,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20120',
  },
  {
    city: 'Centreville',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1238.8,
    imprecise: false,
    latitude: 38.8175,
    longitude: -77.46015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20121',
  },
  {
    city: 'Clifton',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 255.9,
    imprecise: false,
    latitude: 38.78059,
    longitude: -77.39085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20124',
  },
  {
    city: 'Paeonian Springs',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 48.5,
    imprecise: false,
    latitude: 39.16673,
    longitude: -77.59404,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20129',
  },
  {
    city: 'Paris',
    county_fips: 51043,
    county_fips_all: '51043|51061|51107',
    county: 'Clarke',
    county_names_all: 'Clarke|Fauquier|Loudoun',
    county_weights: '{"51043": 53.94, "51061": 23.48, "51107": 22.58}',
    density: 9.5,
    imprecise: false,
    latitude: 39.02756,
    longitude: -77.94243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20130',
  },
  {
    city: 'Purcellville',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 90.5,
    imprecise: false,
    latitude: 39.16648,
    longitude: -77.72748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20132',
  },
  {
    city: 'Bluemont',
    county_fips: 51043,
    county_fips_all: '51043|51107|54037',
    county: 'Clarke',
    county_names_all: 'Clarke|Loudoun|Jefferson',
    county_weights: '{"51043": 61.09, "51107": 38.18, "54037": 0.73}',
    density: 35.8,
    imprecise: false,
    latitude: 39.08602,
    longitude: -77.87659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20135',
  },
  {
    city: 'Bristow',
    county_fips: 51153,
    county_fips_all: '51153',
    county: 'Prince William',
    county_names_all: 'Prince William',
    county_weights: '{"51153": 100}',
    density: 902.1,
    imprecise: false,
    latitude: 38.7374,
    longitude: -77.55473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20136',
  },
  {
    city: 'Broad Run',
    county_fips: 51061,
    county_fips_all: '51061|51153',
    county: 'Fauquier',
    county_names_all: 'Fauquier|Prince William',
    county_weights: '{"51061": 81.67, "51153": 18.33}',
    density: 40.5,
    imprecise: false,
    latitude: 38.80682,
    longitude: -77.72992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20137',
  },
  {
    city: 'Round Hill',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 124.1,
    imprecise: false,
    latitude: 39.11675,
    longitude: -77.79159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20141',
  },
  {
    city: 'Catharpin',
    county_fips: 51153,
    county_fips_all: '51153',
    county: 'Prince William',
    county_names_all: 'Prince William',
    county_weights: '{"51153": 100}',
    density: 64.8,
    imprecise: false,
    latitude: 38.86421,
    longitude: -77.56792,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20143',
  },
  {
    city: 'Delaplane',
    county_fips: 51061,
    county_fips_all: '51061',
    county: 'Fauquier',
    county_names_all: 'Fauquier',
    county_weights: '{"51061": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 38.92117,
    longitude: -77.93759,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20144',
  },
  {
    city: 'Ashburn',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 1317,
    imprecise: false,
    latitude: 39.04151,
    longitude: -77.47958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 67692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20147',
  },
  {
    city: 'Ashburn',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 1274.7,
    imprecise: false,
    latitude: 38.99062,
    longitude: -77.53284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20148',
  },
  {
    city: 'Chantilly',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 550.5,
    imprecise: false,
    latitude: 38.89583,
    longitude: -77.44453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20151',
  },
  {
    city: 'Chantilly',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 1062.8,
    imprecise: false,
    latitude: 38.8998,
    longitude: -77.51917,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20152',
  },
  {
    city: 'Gainesville',
    county_fips: 51153,
    county_fips_all: '51153',
    county: 'Prince William',
    county_names_all: 'Prince William',
    county_weights: '{"51153": 100}',
    density: 568.1,
    imprecise: false,
    latitude: 38.80646,
    longitude: -77.62145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20155',
  },
  {
    city: 'Hamilton',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 145.1,
    imprecise: false,
    latitude: 39.14126,
    longitude: -77.65514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20158',
  },
  {
    city: 'Sterling',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 2204.8,
    imprecise: false,
    latitude: 39.01244,
    longitude: -77.39586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20164',
  },
  {
    city: 'Sterling',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 1336.5,
    imprecise: false,
    latitude: 39.05058,
    longitude: -77.38854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20165',
  },
  {
    city: 'Sterling',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 212.3,
    imprecise: false,
    latitude: 38.97146,
    longitude: -77.4637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20166',
  },
  {
    city: 'Haymarket',
    county_fips: 51153,
    county_fips_all: '51153|51061',
    county: 'Prince William',
    county_names_all: 'Prince William|Fauquier',
    county_weights: '{"51153": 96.98, "51061": 3.02}',
    density: 289.8,
    imprecise: false,
    latitude: 38.87172,
    longitude: -77.64627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20169',
  },
  {
    city: 'Herndon',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1934.5,
    imprecise: false,
    latitude: 38.98075,
    longitude: -77.38042,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20170',
  },
  {
    city: 'Herndon',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1704.5,
    imprecise: false,
    latitude: 38.9246,
    longitude: -77.39824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20171',
  },
  {
    city: 'Leesburg',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 227.3,
    imprecise: false,
    latitude: 39.0641,
    longitude: -77.59939,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20175',
  },
  {
    city: 'Leesburg',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 362,
    imprecise: false,
    latitude: 39.18147,
    longitude: -77.5345,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20176',
  },
  {
    city: 'Lovettsville',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 67.6,
    imprecise: false,
    latitude: 39.26775,
    longitude: -77.63804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20180',
  },
  {
    city: 'Nokesville',
    county_fips: 51153,
    county_fips_all: '51153|51061',
    county: 'Prince William',
    county_names_all: 'Prince William|Fauquier',
    county_weights: '{"51153": 93.57, "51061": 6.43}',
    density: 53.4,
    imprecise: false,
    latitude: 38.66687,
    longitude: -77.55374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20181',
  },
  {
    city: 'Upperville',
    county_fips: 51107,
    county_fips_all: '51107|51061',
    county: 'Loudoun',
    county_names_all: 'Loudoun|Fauquier',
    county_weights: '{"51107": 56.25, "51061": 43.75}',
    density: 6.8,
    imprecise: false,
    latitude: 39.00143,
    longitude: -77.87874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20184',
  },
  {
    city: 'Warrenton',
    county_fips: 51061,
    county_fips_all: '51061|51047',
    county: 'Fauquier',
    county_names_all: 'Fauquier|Culpeper',
    county_weights: '{"51061": 98.32, "51047": 1.68}',
    density: 103.3,
    imprecise: false,
    latitude: 38.69045,
    longitude: -77.843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20186',
  },
  {
    city: 'Warrenton',
    county_fips: 51061,
    county_fips_all: '51061',
    county: 'Fauquier',
    county_names_all: 'Fauquier',
    county_weights: '{"51061": 100}',
    density: 143.5,
    imprecise: false,
    latitude: 38.71846,
    longitude: -77.74275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20187',
  },
  {
    city: 'Reston',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1947.9,
    imprecise: false,
    latitude: 38.95968,
    longitude: -77.33806,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20190',
  },
  {
    city: 'Reston',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1543.7,
    imprecise: false,
    latitude: 38.93438,
    longitude: -77.35184,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20191',
  },
  {
    city: 'Reston',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1520.2,
    imprecise: false,
    latitude: 38.97998,
    longitude: -77.34354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20194',
  },
  {
    city: 'Waterford',
    county_fips: 51107,
    county_fips_all: '51107',
    county: 'Loudoun',
    county_names_all: 'Loudoun',
    county_weights: '{"51107": 100}',
    density: 48,
    imprecise: false,
    latitude: 39.19379,
    longitude: -77.62252,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20197',
  },
  {
    city: 'The Plains',
    county_fips: 51061,
    county_fips_all: '51061',
    county: 'Fauquier',
    county_names_all: 'Fauquier',
    county_weights: '{"51061": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 38.87523,
    longitude: -77.76128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '20198',
  },
  {
    city: 'Waldorf',
    county_fips: 24017,
    county_fips_all: '24017|24033',
    county: 'Charles',
    county_names_all: "Charles|Prince George's",
    county_weights: '{"24017": 83.94, "24033": 16.06}',
    density: 217.5,
    imprecise: false,
    latitude: 38.61863,
    longitude: -76.85715,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20601',
  },
  {
    city: 'Waldorf',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 755.6,
    imprecise: false,
    latitude: 38.58335,
    longitude: -76.89466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20602',
  },
  {
    city: 'Waldorf',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 759.1,
    imprecise: false,
    latitude: 38.62972,
    longitude: -76.97473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20603',
  },
  {
    city: 'Abell',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 123.5,
    imprecise: false,
    latitude: 38.25412,
    longitude: -76.73878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20606',
  },
  {
    city: 'Accokeek',
    county_fips: 24033,
    county_fips_all: '24033|24017',
    county: "Prince George's",
    county_names_all: "Prince George's|Charles",
    county_weights: '{"24033": 96.36, "24017": 3.64}',
    density: 270.3,
    imprecise: false,
    latitude: 38.67161,
    longitude: -77.02478,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20607',
  },
  {
    city: 'Aquasco',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 38.58638,
    longitude: -76.70702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20608',
  },
  {
    city: 'Avenue',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 38.27191,
    longitude: -76.74625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20609',
  },
  {
    city: 'Bel Alton',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 56.6,
    imprecise: false,
    latitude: 38.46251,
    longitude: -76.98538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20611',
  },
  {
    city: 'Benedict',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 244.7,
    imprecise: false,
    latitude: 38.50708,
    longitude: -76.67789,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20612',
  },
  {
    city: 'Brandywine',
    county_fips: 24033,
    county_fips_all: '24033|24017',
    county: "Prince George's",
    county_names_all: "Prince George's|Charles",
    county_weights: '{"24033": 91.87, "24017": 8.13}',
    density: 93.8,
    imprecise: false,
    latitude: 38.67179,
    longitude: -76.80576,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20613',
  },
  {
    city: 'Broomes Island',
    county_fips: 24009,
    county_fips_all: '24009',
    county: 'Calvert',
    county_names_all: 'Calvert',
    county_weights: '{"24009": 100}',
    density: 244.3,
    imprecise: false,
    latitude: 38.4204,
    longitude: -76.54772,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20615',
  },
  {
    city: 'Bryans Road',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 321,
    imprecise: false,
    latitude: 38.65443,
    longitude: -77.08848,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20616',
  },
  {
    city: 'Bryantown',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 21.5,
    imprecise: false,
    latitude: 38.54351,
    longitude: -76.854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20617',
  },
  {
    city: 'Bushwood',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 86.8,
    imprecise: false,
    latitude: 38.28152,
    longitude: -76.78891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20618',
  },
  {
    city: 'California',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 341.6,
    imprecise: false,
    latitude: 38.2919,
    longitude: -76.52714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20619',
  },
  {
    city: 'Callaway',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 100.4,
    imprecise: false,
    latitude: 38.23288,
    longitude: -76.52196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20620',
  },
  {
    city: 'Chaptico',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 26.7,
    imprecise: false,
    latitude: 38.33062,
    longitude: -76.79438,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20621',
  },
  {
    city: 'Charlotte Hall',
    county_fips: 24017,
    county_fips_all: '24017|24037',
    county: 'Charles',
    county_names_all: "Charles|St. Mary's",
    county_weights: '{"24017": 83.11, "24037": 16.89}',
    density: 54.8,
    imprecise: false,
    latitude: 38.45281,
    longitude: -76.84504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20622',
  },
  {
    city: 'Cheltenham',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 555.6,
    imprecise: false,
    latitude: 38.7423,
    longitude: -76.83747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20623',
  },
  {
    city: 'Clements',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 29.6,
    imprecise: false,
    latitude: 38.33523,
    longitude: -76.73451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20624',
  },
  {
    city: 'Cobb Island',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 669.8,
    imprecise: false,
    latitude: 38.26212,
    longitude: -76.84877,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20625',
  },
  {
    city: 'Coltons Point',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 71.7,
    imprecise: false,
    latitude: 38.23256,
    longitude: -76.76404,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20626',
  },
  {
    city: 'Dameron',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 38.1459,
    longitude: -76.35027,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20628',
  },
  {
    city: 'Drayden',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 31.1,
    imprecise: false,
    latitude: 38.16653,
    longitude: -76.47087,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20630',
  },
  {
    city: 'Faulkner',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 28.5,
    imprecise: false,
    latitude: 38.42591,
    longitude: -76.95682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20632',
  },
  {
    city: 'Great Mills',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 391.4,
    imprecise: false,
    latitude: 38.24582,
    longitude: -76.49412,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20634',
  },
  {
    city: 'Hollywood',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 117.8,
    imprecise: false,
    latitude: 38.35582,
    longitude: -76.57212,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20636',
  },
  {
    city: 'Hughesville',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 72.4,
    imprecise: false,
    latitude: 38.52577,
    longitude: -76.77897,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20637',
  },
  {
    city: 'Huntingtown',
    county_fips: 24009,
    county_fips_all: '24009',
    county: 'Calvert',
    county_names_all: 'Calvert',
    county_weights: '{"24009": 100}',
    density: 144.3,
    imprecise: false,
    latitude: 38.60823,
    longitude: -76.6086,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20639',
  },
  {
    city: 'Indian Head',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 98.9,
    imprecise: false,
    latitude: 38.55408,
    longitude: -77.1657,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20640',
  },
  {
    city: 'Issue',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 228.3,
    imprecise: false,
    latitude: 38.29838,
    longitude: -76.91413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20645',
  },
  {
    city: 'La Plata',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 103.6,
    imprecise: false,
    latitude: 38.52114,
    longitude: -76.99989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20646',
  },
  {
    city: 'Leonardtown',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 101.2,
    imprecise: false,
    latitude: 38.27186,
    longitude: -76.63276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20650',
  },
  {
    city: 'Lexington Park',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 312.4,
    imprecise: false,
    latitude: 38.22795,
    longitude: -76.43139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20653',
  },
  {
    city: 'Loveville',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 58.3,
    imprecise: false,
    latitude: 38.33914,
    longitude: -76.6787,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20656',
  },
  {
    city: 'Lusby',
    county_fips: 24009,
    county_fips_all: '24009',
    county: 'Calvert',
    county_names_all: 'Calvert',
    county_weights: '{"24009": 100}',
    density: 267.6,
    imprecise: false,
    latitude: 38.38358,
    longitude: -76.44537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20657',
  },
  {
    city: 'Marbury',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 76.6,
    imprecise: false,
    latitude: 38.56973,
    longitude: -77.15958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20658',
  },
  {
    city: 'Mechanicsville',
    county_fips: 24037,
    county_fips_all: '24037|24017',
    county: "St. Mary's",
    county_names_all: "St. Mary's|Charles",
    county_weights: '{"24037": 96.01, "24017": 3.99}',
    density: 96.8,
    imprecise: false,
    latitude: 38.41886,
    longitude: -76.73238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20659',
  },
  {
    city: 'Morganza',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 6,
    imprecise: false,
    latitude: 38.36928,
    longitude: -76.70741,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20660',
  },
  {
    city: 'Mount Victoria',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.26474,
    longitude: -76.84473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20661',
  },
  {
    city: 'Nanjemoy',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 38.43359,
    longitude: -77.19972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20662',
  },
  {
    city: 'Newburg',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 29.6,
    imprecise: false,
    latitude: 38.35062,
    longitude: -76.91631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20664',
  },
  {
    city: 'Park Hall',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 24.3,
    imprecise: false,
    latitude: 38.21782,
    longitude: -76.44537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20667',
  },
  {
    city: 'Patuxent River',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 84.5,
    imprecise: false,
    latitude: 38.2824,
    longitude: -76.42031,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20670',
  },
  {
    city: 'Piney Point',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 159.9,
    imprecise: false,
    latitude: 38.13307,
    longitude: -76.50019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20674',
  },
  {
    city: 'Pomfret',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 97.3,
    imprecise: false,
    latitude: 38.58349,
    longitude: -77.01522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20675',
  },
  {
    city: 'Port Republic',
    county_fips: 24009,
    county_fips_all: '24009',
    county: 'Calvert',
    county_names_all: 'Calvert',
    county_weights: '{"24009": 100}',
    density: 86.1,
    imprecise: false,
    latitude: 38.4869,
    longitude: -76.54788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20676',
  },
  {
    city: 'Port Tobacco',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 51.5,
    imprecise: false,
    latitude: 38.49992,
    longitude: -77.04016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20677',
  },
  {
    city: 'Prince Frederick',
    county_fips: 24009,
    county_fips_all: '24009',
    county: 'Calvert',
    county_names_all: 'Calvert',
    county_weights: '{"24009": 100}',
    density: 109.7,
    imprecise: false,
    latitude: 38.52164,
    longitude: -76.60072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20678',
  },
  {
    city: 'Ridge',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 32.5,
    imprecise: false,
    latitude: 38.11071,
    longitude: -76.37353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20680',
  },
  {
    city: 'Saint Inigoes',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 37.1,
    imprecise: false,
    latitude: 38.14308,
    longitude: -76.41027,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20684',
  },
  {
    city: 'Saint Leonard',
    county_fips: 24009,
    county_fips_all: '24009',
    county: 'Calvert',
    county_names_all: 'Calvert',
    county_weights: '{"24009": 100}',
    density: 115.7,
    imprecise: false,
    latitude: 38.43465,
    longitude: -76.52904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20685',
  },
  {
    city: 'Saint Marys City',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 1383.2,
    imprecise: false,
    latitude: 38.18557,
    longitude: -76.43898,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20686',
  },
  {
    city: 'Scotland',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 38.07578,
    longitude: -76.34382,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20687',
  },
  {
    city: 'Solomons',
    county_fips: 24009,
    county_fips_all: '24009|24037',
    county: 'Calvert',
    county_names_all: "Calvert|St. Mary's",
    county_weights: '{"24009": 99.89, "24037": 0.11}',
    density: 432.5,
    imprecise: false,
    latitude: 38.33475,
    longitude: -76.46965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20688',
  },
  {
    city: 'Sunderland',
    county_fips: 24009,
    county_fips_all: '24009',
    county: 'Calvert',
    county_names_all: 'Calvert',
    county_weights: '{"24009": 100}',
    density: 90.6,
    imprecise: false,
    latitude: 38.66963,
    longitude: -76.58591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20689',
  },
  {
    city: 'Tall Timbers',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 249.3,
    imprecise: false,
    latitude: 38.15916,
    longitude: -76.52631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20690',
  },
  {
    city: 'Valley Lee',
    county_fips: 24037,
    county_fips_all: '24037',
    county: "St. Mary's",
    county_names_all: "St. Mary's",
    county_weights: '{"24037": 100}',
    density: 27.1,
    imprecise: false,
    latitude: 38.18352,
    longitude: -76.50682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20692',
  },
  {
    city: 'Welcome',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 28.6,
    imprecise: false,
    latitude: 38.45924,
    longitude: -77.08931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20693',
  },
  {
    city: 'White Plains',
    county_fips: 24017,
    county_fips_all: '24017',
    county: 'Charles',
    county_names_all: 'Charles',
    county_weights: '{"24017": 100}',
    density: 440.3,
    imprecise: false,
    latitude: 38.58885,
    longitude: -76.97269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20695',
  },
  {
    city: 'Annapolis Junction',
    county_fips: 24027,
    county_fips_all: '24027|24003',
    county: 'Howard',
    county_names_all: 'Howard|Anne Arundel',
    county_weights: '{"24027": 54.05, "24003": 45.95}',
    density: 90,
    imprecise: false,
    latitude: 39.12877,
    longitude: -76.78803,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20701',
  },
  {
    city: 'Beltsville',
    county_fips: 24033,
    county_fips_all: '24033|24031',
    county: "Prince George's",
    county_names_all: "Prince George's|Montgomery",
    county_weights: '{"24033": 98.86, "24031": 1.14}',
    density: 767.2,
    imprecise: false,
    latitude: 39.04503,
    longitude: -76.90009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20705',
  },
  {
    city: 'Lanham',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 1637.1,
    imprecise: false,
    latitude: 38.96548,
    longitude: -76.85091,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20706',
  },
  {
    city: 'Laurel',
    county_fips: 24033,
    county_fips_all: '24033|24031',
    county: "Prince George's",
    county_names_all: "Prince George's|Montgomery",
    county_weights: '{"24033": 93.5, "24031": 6.5}',
    density: 1137.9,
    imprecise: false,
    latitude: 39.09563,
    longitude: -76.8842,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20707',
  },
  {
    city: 'Laurel',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 876.3,
    imprecise: false,
    latitude: 39.04546,
    longitude: -76.83462,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20708',
  },
  {
    city: 'Bladensburg',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 3388.6,
    imprecise: false,
    latitude: 38.94204,
    longitude: -76.92623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20710',
  },
  {
    city: 'Lothian',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 88.3,
    imprecise: false,
    latitude: 38.80485,
    longitude: -76.65245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20711',
  },
  {
    city: 'Mount Rainier',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 5058.9,
    imprecise: false,
    latitude: 38.94306,
    longitude: -76.96517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20712',
  },
  {
    city: 'North Beach',
    county_fips: 24003,
    county_fips_all: '24003|24009',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel|Calvert',
    county_weights: '{"24003": 64.4, "24009": 35.6}',
    density: 1228,
    imprecise: false,
    latitude: 38.71813,
    longitude: -76.53987,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20714',
  },
  {
    city: 'Bowie',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 739.7,
    imprecise: false,
    latitude: 38.98643,
    longitude: -76.73967,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20715',
  },
  {
    city: 'Bowie',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 751.1,
    imprecise: false,
    latitude: 38.92734,
    longitude: -76.71494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20716',
  },
  {
    city: 'Bowie',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 655.4,
    imprecise: false,
    latitude: 38.9971,
    longitude: -76.78588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20720',
  },
  {
    city: 'Bowie',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 711.8,
    imprecise: false,
    latitude: 38.92106,
    longitude: -76.78881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20721',
  },
  {
    city: 'Brentwood',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 1643.9,
    imprecise: false,
    latitude: 38.9351,
    longitude: -76.94944,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20722',
  },
  {
    city: 'Laurel',
    county_fips: 24027,
    county_fips_all: '24027',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"24027": 100}',
    density: 1093.4,
    imprecise: false,
    latitude: 39.13664,
    longitude: -76.86647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20723',
  },
  {
    city: 'Laurel',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 397.3,
    imprecise: false,
    latitude: 39.08028,
    longitude: -76.79054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20724',
  },
  {
    city: 'Chesapeake Beach',
    county_fips: 24009,
    county_fips_all: '24009',
    county: 'Calvert',
    county_names_all: 'Calvert',
    county_weights: '{"24009": 100}',
    density: 371.3,
    imprecise: false,
    latitude: 38.65573,
    longitude: -76.54292,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20732',
  },
  {
    city: 'Churchton',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 286.2,
    imprecise: false,
    latitude: 38.80628,
    longitude: -76.53139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20733',
  },
  {
    city: 'Clinton',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 557.9,
    imprecise: false,
    latitude: 38.75034,
    longitude: -76.90566,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20735',
  },
  {
    city: 'Owings',
    county_fips: 24009,
    county_fips_all: '24009|24003',
    county: 'Calvert',
    county_names_all: 'Calvert|Anne Arundel',
    county_weights: '{"24009": 97.12, "24003": 2.88}',
    density: 155.5,
    imprecise: false,
    latitude: 38.6913,
    longitude: -76.62855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20736',
  },
  {
    city: 'Riverdale',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 2987.2,
    imprecise: false,
    latitude: 38.96247,
    longitude: -76.91571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20737',
  },
  {
    city: 'College Park',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 1619.9,
    imprecise: false,
    latitude: 39.00193,
    longitude: -76.93096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20740',
  },
  {
    city: 'Capitol Heights',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 1646.1,
    imprecise: false,
    latitude: 38.88372,
    longitude: -76.89362,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20743',
  },
  {
    city: 'Fort Washington',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 805.6,
    imprecise: false,
    latitude: 38.75362,
    longitude: -76.98393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20744',
  },
  {
    city: 'Oxon Hill',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 1697.3,
    imprecise: false,
    latitude: 38.80552,
    longitude: -76.99495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20745',
  },
  {
    city: 'Suitland',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 1385.8,
    imprecise: false,
    latitude: 38.83664,
    longitude: -76.91936,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20746',
  },
  {
    city: 'District Heights',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 1871.6,
    imprecise: false,
    latitude: 38.85348,
    longitude: -76.88377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20747',
  },
  {
    city: 'Temple Hills',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 1674.6,
    imprecise: false,
    latitude: 38.81692,
    longitude: -76.94124,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20748',
  },
  {
    city: 'Deale',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 212.2,
    imprecise: false,
    latitude: 38.79552,
    longitude: -76.56221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20751',
  },
  {
    city: 'Dunkirk',
    county_fips: 24009,
    county_fips_all: '24009|24003',
    county: 'Calvert',
    county_names_all: 'Calvert|Anne Arundel',
    county_weights: '{"24009": 83.86, "24003": 16.14}',
    density: 181.7,
    imprecise: false,
    latitude: 38.736,
    longitude: -76.65493,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20754',
  },
  {
    city: 'Fort George G Meade',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 411,
    imprecise: false,
    latitude: 39.09892,
    longitude: -76.74479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20755',
  },
  {
    city: 'Friendship',
    county_fips: 24003,
    county_fips_all: '24003|24009',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel|Calvert',
    county_weights: '{"24003": 97.47, "24009": 2.53}',
    density: 56.8,
    imprecise: false,
    latitude: 38.73399,
    longitude: -76.58961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20758',
  },
  {
    city: 'Fulton',
    county_fips: 24027,
    county_fips_all: '24027',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"24027": 100}',
    density: 407,
    imprecise: false,
    latitude: 39.15419,
    longitude: -76.92877,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20759',
  },
  {
    city: 'Andrews Air Force Base',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 207.4,
    imprecise: false,
    latitude: 38.80748,
    longitude: -76.87457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20762',
  },
  {
    city: 'Savage',
    county_fips: 24027,
    county_fips_all: '24027',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"24027": 100}',
    density: 941.7,
    imprecise: false,
    latitude: 39.13786,
    longitude: -76.82134,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20763',
  },
  {
    city: 'Shady Side',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 290.7,
    imprecise: false,
    latitude: 38.83374,
    longitude: -76.51146,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20764',
  },
  {
    city: 'Galesville',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 547.3,
    imprecise: false,
    latitude: 38.84533,
    longitude: -76.54654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20765',
  },
  {
    city: 'Glenn Dale',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 413,
    imprecise: false,
    latitude: 38.98818,
    longitude: -76.81635,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20769',
  },
  {
    city: 'Greenbelt',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 1500.4,
    imprecise: false,
    latitude: 38.99981,
    longitude: -76.88567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20770',
  },
  {
    city: 'Upper Marlboro',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 289.4,
    imprecise: false,
    latitude: 38.7785,
    longitude: -76.76911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20772',
  },
  {
    city: 'Upper Marlboro',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 573.6,
    imprecise: false,
    latitude: 38.87589,
    longitude: -76.76925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20774',
  },
  {
    city: 'Harwood',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 59.2,
    imprecise: false,
    latitude: 38.86913,
    longitude: -76.6067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20776',
  },
  {
    city: 'Highland',
    county_fips: 24027,
    county_fips_all: '24027|24031',
    county: 'Howard',
    county_names_all: 'Howard|Montgomery',
    county_weights: '{"24027": 98.2, "24031": 1.8}',
    density: 164.9,
    imprecise: false,
    latitude: 39.17487,
    longitude: -76.96783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20777',
  },
  {
    city: 'West River',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 111.7,
    imprecise: false,
    latitude: 38.83733,
    longitude: -76.56647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20778',
  },
  {
    city: 'Tracys Landing',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 50,
    imprecise: false,
    latitude: 38.76388,
    longitude: -76.57665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20779',
  },
  {
    city: 'Hyattsville',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 2096,
    imprecise: false,
    latitude: 38.94229,
    longitude: -76.93655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20781',
  },
  {
    city: 'Hyattsville',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 3113.8,
    imprecise: false,
    latitude: 38.96469,
    longitude: -76.9649,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20782',
  },
  {
    city: 'Hyattsville',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 3328.5,
    imprecise: false,
    latitude: 38.99988,
    longitude: -76.96886,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20783',
  },
  {
    city: 'Hyattsville',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 3155.5,
    imprecise: false,
    latitude: 38.95145,
    longitude: -76.89025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20784',
  },
  {
    city: 'Hyattsville',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 1528.6,
    imprecise: false,
    latitude: 38.91849,
    longitude: -76.88237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20785',
  },
  {
    city: 'Jessup',
    county_fips: 24027,
    county_fips_all: '24027|24003',
    county: 'Howard',
    county_names_all: 'Howard|Anne Arundel',
    county_weights: '{"24027": 66.54, "24003": 33.46}',
    density: 673.1,
    imprecise: false,
    latitude: 39.15107,
    longitude: -76.78882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20794',
  },
  {
    city: 'Glen Echo',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 602.4,
    imprecise: false,
    latitude: 38.96677,
    longitude: -77.14357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20812',
  },
  {
    city: 'Bethesda',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 2839.7,
    imprecise: false,
    latitude: 39.00506,
    longitude: -77.10295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20814',
  },
  {
    city: 'Chevy Chase',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 2187.4,
    imprecise: false,
    latitude: 38.98369,
    longitude: -77.07845,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20815',
  },
  {
    city: 'Bethesda',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 1965.1,
    imprecise: false,
    latitude: 38.95612,
    longitude: -77.11873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20816',
  },
  {
    city: 'Bethesda',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 1030.1,
    imprecise: false,
    latitude: 38.99809,
    longitude: -77.14919,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20817',
  },
  {
    city: 'Cabin John',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 640.2,
    imprecise: false,
    latitude: 38.97347,
    longitude: -77.16188,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20818',
  },
  {
    city: 'Olney',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 1026.7,
    imprecise: false,
    latitude: 39.15134,
    longitude: -77.07331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20832',
  },
  {
    city: 'Brookeville',
    county_fips: 24031,
    county_fips_all: '24031|24027',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Howard',
    county_weights: '{"24031": 90.43, "24027": 9.57}',
    density: 158.8,
    imprecise: false,
    latitude: 39.20595,
    longitude: -77.05552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20833',
  },
  {
    city: 'Poolesville',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 64.2,
    imprecise: false,
    latitude: 39.11208,
    longitude: -77.40823,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20837',
  },
  {
    city: 'Barnesville',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 126.3,
    imprecise: false,
    latitude: 39.22341,
    longitude: -77.37223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20838',
  },
  {
    city: 'Bealsville',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 20,
    imprecise: false,
    latitude: 39.17909,
    longitude: -77.41438,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20839',
  },
  {
    city: 'Boyds',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 141.8,
    imprecise: false,
    latitude: 39.1858,
    longitude: -77.32581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20841',
  },
  {
    city: 'Dickerson',
    county_fips: 24031,
    county_fips_all: '24031|24021',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Frederick',
    county_weights: '{"24031": 77.46, "24021": 22.54}',
    density: 16.4,
    imprecise: false,
    latitude: 39.20831,
    longitude: -77.42473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20842',
  },
  {
    city: 'Rockville',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 1377.1,
    imprecise: false,
    latitude: 39.0908,
    longitude: -77.1809,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20850',
  },
  {
    city: 'Rockville',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 2276.1,
    imprecise: false,
    latitude: 39.07767,
    longitude: -77.12089,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20851',
  },
  {
    city: 'Rockville',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 2303.9,
    imprecise: false,
    latitude: 39.05134,
    longitude: -77.12507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20852',
  },
  {
    city: 'Rockville',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 1361.8,
    imprecise: false,
    latitude: 39.10237,
    longitude: -77.09462,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20853',
  },
  {
    city: 'Potomac',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 576.7,
    imprecise: false,
    latitude: 39.03413,
    longitude: -77.22149,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20854',
  },
  {
    city: 'Derwood',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 510.3,
    imprecise: false,
    latitude: 39.13702,
    longitude: -77.13197,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20855',
  },
  {
    city: 'Sandy Spring',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 217.8,
    imprecise: false,
    latitude: 39.15072,
    longitude: -77.03069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20860',
  },
  {
    city: 'Ashton',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 215.6,
    imprecise: false,
    latitude: 39.14653,
    longitude: -76.99886,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20861',
  },
  {
    city: 'Brinklow',
    county_fips: 24031,
    county_fips_all: '24031|24027',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Howard',
    county_weights: '{"24031": 99.6, "24027": 0.4}',
    density: 105.3,
    imprecise: false,
    latitude: 39.18039,
    longitude: -77.01879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20862',
  },
  {
    city: 'Burtonsville',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 878.3,
    imprecise: false,
    latitude: 39.10969,
    longitude: -76.93411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20866',
  },
  {
    city: 'Spencerville',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 47,
    imprecise: false,
    latitude: 39.12534,
    longitude: -76.96834,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20868',
  },
  {
    city: 'Clarksburg',
    county_fips: 24031,
    county_fips_all: '24031|24021',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Frederick',
    county_weights: '{"24031": 94.34, "24021": 5.66}',
    density: 509.2,
    imprecise: false,
    latitude: 39.2592,
    longitude: -77.28187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20871',
  },
  {
    city: 'Damascus',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 271.5,
    imprecise: false,
    latitude: 39.29142,
    longitude: -77.21619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20872',
  },
  {
    city: 'Germantown',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 1068.3,
    imprecise: false,
    latitude: 39.1291,
    longitude: -77.29721,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20874',
  },
  {
    city: 'Germantown',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 939.5,
    imprecise: false,
    latitude: 39.20706,
    longitude: -77.23284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20876',
  },
  {
    city: 'Gaithersburg',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 2638.4,
    imprecise: false,
    latitude: 39.14068,
    longitude: -77.18865,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20877',
  },
  {
    city: 'Gaithersburg',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 1248.3,
    imprecise: false,
    latitude: 39.11376,
    longitude: -77.24781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20878',
  },
  {
    city: 'Gaithersburg',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 1132.2,
    imprecise: false,
    latitude: 39.16992,
    longitude: -77.17416,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20879',
  },
  {
    city: 'Washington Grove',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 667.8,
    imprecise: false,
    latitude: 39.14077,
    longitude: -77.17456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20880',
  },
  {
    city: 'Gaithersburg',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 140.6,
    imprecise: false,
    latitude: 39.23182,
    longitude: -77.14514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20882',
  },
  {
    city: 'Montgomery Village',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 3268.6,
    imprecise: false,
    latitude: 39.17952,
    longitude: -77.197,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20886',
  },
  {
    city: 'Kensington',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 1818.1,
    imprecise: false,
    latitude: 39.02696,
    longitude: -77.07781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20895',
  },
  {
    city: 'Garrett Park',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 1053.6,
    imprecise: false,
    latitude: 39.03521,
    longitude: -77.09494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20896',
  },
  {
    city: 'Silver Spring',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 2630.3,
    imprecise: false,
    latitude: 39.02155,
    longitude: -77.00919,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20901',
  },
  {
    city: 'Silver Spring',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 2769.9,
    imprecise: false,
    latitude: 39.04381,
    longitude: -77.0421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20902',
  },
  {
    city: 'Silver Spring',
    county_fips: 24031,
    county_fips_all: '24031|24033',
    county: 'Montgomery',
    county_names_all: "Montgomery|Prince George's",
    county_weights: '{"24031": 94.94, "24033": 5.06}',
    density: 2809.6,
    imprecise: false,
    latitude: 39.02128,
    longitude: -76.9821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20903',
  },
  {
    city: 'Silver Spring',
    county_fips: 24031,
    county_fips_all: '24031|24033',
    county: 'Montgomery',
    county_names_all: "Montgomery|Prince George's",
    county_weights: '{"24031": 97.42, "24033": 2.58}',
    density: 1649.4,
    imprecise: false,
    latitude: 39.06608,
    longitude: -76.97918,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20904',
  },
  {
    city: 'Silver Spring',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 622.6,
    imprecise: false,
    latitude: 39.11052,
    longitude: -76.99036,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20905',
  },
  {
    city: 'Silver Spring',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 2140.5,
    imprecise: false,
    latitude: 39.08858,
    longitude: -77.05522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 70595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20906',
  },
  {
    city: 'Silver Spring',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 3859.6,
    imprecise: false,
    latitude: 39.00227,
    longitude: -77.03634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20910',
  },
  {
    city: 'Takoma Park',
    county_fips: 24031,
    county_fips_all: '24031|24033',
    county: 'Montgomery',
    county_names_all: "Montgomery|Prince George's",
    county_weights: '{"24031": 89.99, "24033": 10.01}',
    density: 3710.9,
    imprecise: false,
    latitude: 38.98182,
    longitude: -77.00106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20912',
  },
  {
    city: 'Aberdeen',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 350.1,
    imprecise: false,
    latitude: 39.51077,
    longitude: -76.20274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21001',
  },
  {
    city: 'Aberdeen Proving Ground',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 25.5,
    imprecise: false,
    latitude: 39.44101,
    longitude: -76.16509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21005',
  },
  {
    city: 'Abingdon',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 1140.5,
    imprecise: false,
    latitude: 39.47032,
    longitude: -76.29378,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21009',
  },
  {
    city: 'Gunpowder',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 39.38953,
    longitude: -76.29851,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21010',
  },
  {
    city: 'Arnold',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 891.1,
    imprecise: false,
    latitude: 39.04529,
    longitude: -76.49716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21012',
  },
  {
    city: 'Baldwin',
    county_fips: 24005,
    county_fips_all: '24005|24025',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Harford',
    county_weights: '{"24005": 71.01, "24025": 28.99}',
    density: 144.4,
    imprecise: false,
    latitude: 39.51123,
    longitude: -76.49124,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21013',
  },
  {
    city: 'Bel Air',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 1074,
    imprecise: false,
    latitude: 39.53606,
    longitude: -76.35164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21014',
  },
  {
    city: 'Bel Air',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 370.8,
    imprecise: false,
    latitude: 39.54691,
    longitude: -76.29619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21015',
  },
  {
    city: 'Belcamp',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 959,
    imprecise: false,
    latitude: 39.47498,
    longitude: -76.23667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21017',
  },
  {
    city: 'Butler',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 23.8,
    imprecise: false,
    latitude: 39.52368,
    longitude: -76.73984,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21023',
  },
  {
    city: 'Churchville',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 93.1,
    imprecise: false,
    latitude: 39.56832,
    longitude: -76.24162,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21028',
  },
  {
    city: 'Clarksville',
    county_fips: 24027,
    county_fips_all: '24027',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"24027": 100}',
    density: 310.6,
    imprecise: false,
    latitude: 39.20633,
    longitude: -76.95206,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21029',
  },
  {
    city: 'Cockeysville',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 414.6,
    imprecise: false,
    latitude: 39.49002,
    longitude: -76.6659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21030',
  },
  {
    city: 'Hunt Valley',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 39.4874,
    longitude: -76.65792,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21031',
  },
  {
    city: 'Crownsville',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 197.6,
    imprecise: false,
    latitude: 39.03376,
    longitude: -76.60401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21032',
  },
  {
    city: 'Darlington',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 41.2,
    imprecise: false,
    latitude: 39.64905,
    longitude: -76.22261,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21034',
  },
  {
    city: 'Davidsonville',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 98,
    imprecise: false,
    latitude: 38.93637,
    longitude: -76.63875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21035',
  },
  {
    city: 'Dayton',
    county_fips: 24027,
    county_fips_all: '24027',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"24027": 100}',
    density: 158.6,
    imprecise: false,
    latitude: 39.23416,
    longitude: -77.00223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21036',
  },
  {
    city: 'Edgewater',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 479.3,
    imprecise: false,
    latitude: 38.91476,
    longitude: -76.54361,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21037',
  },
  {
    city: 'Edgewood',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 982,
    imprecise: false,
    latitude: 39.42953,
    longitude: -76.28947,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21040',
  },
  {
    city: 'Ellicott City',
    county_fips: 24027,
    county_fips_all: '24027',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"24027": 100}',
    density: 452.1,
    imprecise: false,
    latitude: 39.27105,
    longitude: -76.8924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21042',
  },
  {
    city: 'Ellicott City',
    county_fips: 24027,
    county_fips_all: '24027|24005',
    county: 'Howard',
    county_names_all: 'Howard|Baltimore',
    county_weights: '{"24027": 96.5, "24005": 3.5}',
    density: 1095.9,
    imprecise: false,
    latitude: 39.25759,
    longitude: -76.79773,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21043',
  },
  {
    city: 'Columbia',
    county_fips: 24027,
    county_fips_all: '24027',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"24027": 100}',
    density: 1432.9,
    imprecise: false,
    latitude: 39.21047,
    longitude: -76.88353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21044',
  },
  {
    city: 'Columbia',
    county_fips: 24027,
    county_fips_all: '24027',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"24027": 100}',
    density: 1593.9,
    imprecise: false,
    latitude: 39.20622,
    longitude: -76.82747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21045',
  },
  {
    city: 'Columbia',
    county_fips: 24027,
    county_fips_all: '24027',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"24027": 100}',
    density: 771.6,
    imprecise: false,
    latitude: 39.17357,
    longitude: -76.84183,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21046',
  },
  {
    city: 'Fallston',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 237.2,
    imprecise: false,
    latitude: 39.52818,
    longitude: -76.43781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21047',
  },
  {
    city: 'Finksburg',
    county_fips: 24013,
    county_fips_all: '24013',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"24013": 100}',
    density: 148.5,
    imprecise: false,
    latitude: 39.49568,
    longitude: -76.91057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21048',
  },
  {
    city: 'Forest Hill',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 232.6,
    imprecise: false,
    latitude: 39.58569,
    longitude: -76.39228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21050',
  },
  {
    city: 'Fork',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 167.1,
    imprecise: false,
    latitude: 39.4721,
    longitude: -76.45388,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21051',
  },
  {
    city: 'Fort Howard',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 392.9,
    imprecise: false,
    latitude: 39.20238,
    longitude: -76.44379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21052',
  },
  {
    city: 'Freeland',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 52.1,
    imprecise: false,
    latitude: 39.69296,
    longitude: -76.71567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21053',
  },
  {
    city: 'Gambrills',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 397.5,
    imprecise: false,
    latitude: 39.02624,
    longitude: -76.67083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21054',
  },
  {
    city: 'Gibson Island',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 81.6,
    imprecise: false,
    latitude: 39.07805,
    longitude: -76.4338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21056',
  },
  {
    city: 'Glen Arm',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 106.6,
    imprecise: false,
    latitude: 39.45111,
    longitude: -76.50606,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21057',
  },
  {
    city: 'Glen Burnie',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 1182.2,
    imprecise: false,
    latitude: 39.16893,
    longitude: -76.58346,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21060',
  },
  {
    city: 'Glen Burnie',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 1812.6,
    imprecise: false,
    latitude: 39.16116,
    longitude: -76.63226,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21061',
  },
  {
    city: 'Glyndon',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 103.9,
    imprecise: false,
    latitude: 39.48516,
    longitude: -76.8081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21071',
  },
  {
    city: 'Hampstead',
    county_fips: 24013,
    county_fips_all: '24013|24005',
    county: 'Carroll',
    county_names_all: 'Carroll|Baltimore',
    county_weights: '{"24013": 70.65, "24005": 29.35}',
    density: 151.4,
    imprecise: false,
    latitude: 39.61746,
    longitude: -76.84351,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21074',
  },
  {
    city: 'Elkridge',
    county_fips: 24027,
    county_fips_all: '24027',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"24027": 100}',
    density: 1035.5,
    imprecise: false,
    latitude: 39.20414,
    longitude: -76.75301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21075',
  },
  {
    city: 'Hanover',
    county_fips: 24003,
    county_fips_all: '24003|24027',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel|Howard',
    county_weights: '{"24003": 89.75, "24027": 10.25}',
    density: 712.9,
    imprecise: false,
    latitude: 39.16856,
    longitude: -76.72239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21076',
  },
  {
    city: 'Harmans',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 55.5,
    imprecise: false,
    latitude: 39.1583,
    longitude: -76.69953,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21077',
  },
  {
    city: 'Havre De Grace',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 256.9,
    imprecise: false,
    latitude: 39.56911,
    longitude: -76.14776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21078',
  },
  {
    city: 'Hydes',
    county_fips: 24005,
    county_fips_all: '24005|24025',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Harford',
    county_weights: '{"24005": 97.37, "24025": 2.63}',
    density: 40.2,
    imprecise: false,
    latitude: 39.48284,
    longitude: -76.46735,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21082',
  },
  {
    city: 'Jarrettsville',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 114.9,
    imprecise: false,
    latitude: 39.61659,
    longitude: -76.46317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21084',
  },
  {
    city: 'Joppa',
    county_fips: 24025,
    county_fips_all: '24025|24005',
    county: 'Harford',
    county_names_all: 'Harford|Baltimore',
    county_weights: '{"24025": 93.74, "24005": 6.26}',
    density: 352.2,
    imprecise: false,
    latitude: 39.44462,
    longitude: -76.35601,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21085',
  },
  {
    city: 'Kingsville',
    county_fips: 24005,
    county_fips_all: '24005|24025',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Harford',
    county_weights: '{"24005": 90.04, "24025": 9.96}',
    density: 146.1,
    imprecise: false,
    latitude: 39.44728,
    longitude: -76.41583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21087',
  },
  {
    city: 'Linthicum Heights',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 619.3,
    imprecise: false,
    latitude: 39.20919,
    longitude: -76.66796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21090',
  },
  {
    city: 'Lutherville Timonium',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 746.3,
    imprecise: false,
    latitude: 39.43773,
    longitude: -76.64318,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21093',
  },
  {
    city: 'Manchester',
    county_fips: 24013,
    county_fips_all: '24013|24005',
    county: 'Carroll',
    county_names_all: 'Carroll|Baltimore',
    county_weights: '{"24013": 75.65, "24005": 24.35}',
    density: 115.6,
    imprecise: false,
    latitude: 39.68732,
    longitude: -76.84564,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21102',
  },
  {
    city: 'Marriottsville',
    county_fips: 24027,
    county_fips_all: '24027|24013|24005',
    county: 'Howard',
    county_names_all: 'Howard|Carroll|Baltimore',
    county_weights: '{"24027": 51.06, "24013": 33.87, "24005": 15.07}',
    density: 137,
    imprecise: false,
    latitude: 39.35044,
    longitude: -76.90654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21104',
  },
  {
    city: 'Maryland Line',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 161.4,
    imprecise: false,
    latitude: 39.71512,
    longitude: -76.65225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21105',
  },
  {
    city: 'Millersville',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 557.4,
    imprecise: false,
    latitude: 39.08932,
    longitude: -76.62139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21108',
  },
  {
    city: 'Monkton',
    county_fips: 24005,
    county_fips_all: '24005|24025',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Harford',
    county_weights: '{"24005": 76.78, "24025": 23.22}',
    density: 51.5,
    imprecise: false,
    latitude: 39.57568,
    longitude: -76.58089,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21111',
  },
  {
    city: 'Odenton',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 947.9,
    imprecise: false,
    latitude: 39.05448,
    longitude: -76.71519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21113',
  },
  {
    city: 'Crofton',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 1709.7,
    imprecise: false,
    latitude: 39.00967,
    longitude: -76.6839,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21114',
  },
  {
    city: 'Owings Mills',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 816.1,
    imprecise: false,
    latitude: 39.42719,
    longitude: -76.77795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21117',
  },
  {
    city: 'Parkton',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 68.4,
    imprecise: false,
    latitude: 39.64723,
    longitude: -76.67703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21120',
  },
  {
    city: 'Pasadena',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 757.6,
    imprecise: false,
    latitude: 39.11631,
    longitude: -76.49941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 61566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21122',
  },
  {
    city: 'Perry Hall',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 879.3,
    imprecise: false,
    latitude: 39.40526,
    longitude: -76.44628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21128',
  },
  {
    city: 'Perryman',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 78.9,
    imprecise: false,
    latitude: 39.47495,
    longitude: -76.18921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21130',
  },
  {
    city: 'Phoenix',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 131.1,
    imprecise: false,
    latitude: 39.50338,
    longitude: -76.57486,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21131',
  },
  {
    city: 'Pylesville',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 54.6,
    imprecise: false,
    latitude: 39.69601,
    longitude: -76.42577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21132',
  },
  {
    city: 'Randallstown',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 1352.9,
    imprecise: false,
    latitude: 39.37705,
    longitude: -76.81174,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21133',
  },
  {
    city: 'Reisterstown',
    county_fips: 24005,
    county_fips_all: '24005|24013',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Carroll',
    county_weights: '{"24005": 96.26, "24013": 3.74}',
    density: 220.5,
    imprecise: false,
    latitude: 39.48851,
    longitude: -76.80888,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21136',
  },
  {
    city: 'Riva',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 1203.9,
    imprecise: false,
    latitude: 38.95062,
    longitude: -76.58569,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21140',
  },
  {
    city: 'Severn',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 868.1,
    imprecise: false,
    latitude: 39.12058,
    longitude: -76.67767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21144',
  },
  {
    city: 'Severna Park',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 1089.2,
    imprecise: false,
    latitude: 39.07737,
    longitude: -76.55613,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21146',
  },
  {
    city: 'Sparks Glencoe',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 103.1,
    imprecise: false,
    latitude: 39.54905,
    longitude: -76.68107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21152',
  },
  {
    city: 'Stevenson',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 61.4,
    imprecise: false,
    latitude: 39.41649,
    longitude: -76.707,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21153',
  },
  {
    city: 'Street',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 64.2,
    imprecise: false,
    latitude: 39.65314,
    longitude: -76.36087,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21154',
  },
  {
    city: 'Upperco',
    county_fips: 24005,
    county_fips_all: '24005|24013',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Carroll',
    county_weights: '{"24005": 89.0, "24013": 11.0}',
    density: 57.8,
    imprecise: false,
    latitude: 39.57183,
    longitude: -76.80597,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21155',
  },
  {
    city: 'Upper Falls',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 75,
    imprecise: false,
    latitude: 39.43752,
    longitude: -76.397,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21156',
  },
  {
    city: 'Westminster',
    county_fips: 24013,
    county_fips_all: '24013',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"24013": 100}',
    density: 193.7,
    imprecise: false,
    latitude: 39.54889,
    longitude: -76.98162,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21157',
  },
  {
    city: 'Westminster',
    county_fips: 24013,
    county_fips_all: '24013',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"24013": 100}',
    density: 116.3,
    imprecise: false,
    latitude: 39.6466,
    longitude: -77.03217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21158',
  },
  {
    city: 'Whiteford',
    county_fips: 24025,
    county_fips_all: '24025',
    county: 'Harford',
    county_names_all: 'Harford',
    county_weights: '{"24025": 100}',
    density: 60.8,
    imprecise: false,
    latitude: 39.70728,
    longitude: -76.30754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21160',
  },
  {
    city: 'White Hall',
    county_fips: 24025,
    county_fips_all: '24025|24005',
    county: 'Harford',
    county_names_all: 'Harford|Baltimore',
    county_weights: '{"24025": 53.29, "24005": 46.71}',
    density: 41.5,
    imprecise: false,
    latitude: 39.65983,
    longitude: -76.56475,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21161',
  },
  {
    city: 'White Marsh',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 251.3,
    imprecise: false,
    latitude: 39.39084,
    longitude: -76.40164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21162',
  },
  {
    city: 'Woodstock',
    county_fips: 24005,
    county_fips_all: '24005|24027',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Howard',
    county_weights: '{"24005": 73.47, "24027": 26.53}',
    density: 213.4,
    imprecise: false,
    latitude: 39.34024,
    longitude: -76.85706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21163',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 5567.8,
    imprecise: false,
    latitude: 39.29487,
    longitude: -76.62237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21201',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 4942.8,
    imprecise: false,
    latitude: 39.29705,
    longitude: -76.60747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21202',
  },
  {
    city: 'Towson',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 1223.6,
    imprecise: false,
    latitude: 39.40353,
    longitude: -76.63024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21204',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 2449.3,
    imprecise: false,
    latitude: 39.30227,
    longitude: -76.56413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21205',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510|24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24510": 68.79, "24005": 31.21}',
    density: 2603.4,
    imprecise: false,
    latitude: 39.33932,
    longitude: -76.53706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21206',
  },
  {
    city: 'Gwynn Oak',
    county_fips: 24005,
    county_fips_all: '24005|24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24005": 71.87, "24510": 28.13}',
    density: 1757.8,
    imprecise: false,
    latitude: 39.32417,
    longitude: -76.72017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21207',
  },
  {
    city: 'Pikesville',
    county_fips: 24005,
    county_fips_all: '24005|24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24005": 98.62, "24510": 1.38}',
    density: 1146.1,
    imprecise: false,
    latitude: 39.38401,
    longitude: -76.72547,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21208',
  },
  {
    city: 'Baltimore',
    county_fips: 24005,
    county_fips_all: '24005|24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24005": 55.45, "24510": 44.55}',
    density: 1801.1,
    imprecise: false,
    latitude: 39.37261,
    longitude: -76.66802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21209',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510|24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24510": 83.24, "24005": 16.76}',
    density: 1583,
    imprecise: false,
    latitude: 39.35878,
    longitude: -76.63521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21210',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 2015.8,
    imprecise: false,
    latitude: 39.32857,
    longitude: -76.6389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21211',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510|24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24510": 56.56, "24005": 43.44}',
    density: 2860.4,
    imprecise: false,
    latitude: 39.3678,
    longitude: -76.61456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21212',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 3156.8,
    imprecise: false,
    latitude: 39.31501,
    longitude: -76.57723,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21213',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 2914.4,
    imprecise: false,
    latitude: 39.35217,
    longitude: -76.5644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21214',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510|24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24510": 96.53, "24005": 3.47}',
    density: 2960.5,
    imprecise: false,
    latitude: 39.34578,
    longitude: -76.68367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21215',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 3440.4,
    imprecise: false,
    latitude: 39.3108,
    longitude: -76.67145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21216',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 5607.5,
    imprecise: false,
    latitude: 39.30701,
    longitude: -76.63833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21217',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 3925.3,
    imprecise: false,
    latitude: 39.33031,
    longitude: -76.60235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21218',
  },
  {
    city: 'Sparrows Point',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 304.6,
    imprecise: false,
    latitude: 39.23097,
    longitude: -76.44383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21219',
  },
  {
    city: 'Middle River',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 780.7,
    imprecise: false,
    latitude: 39.345,
    longitude: -76.3966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21220',
  },
  {
    city: 'Essex',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 1117,
    imprecise: false,
    latitude: 39.29462,
    longitude: -76.44034,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21221',
  },
  {
    city: 'Dundalk',
    county_fips: 24005,
    county_fips_all: '24005|24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24005": 93.59, "24510": 6.41}',
    density: 1994,
    imprecise: false,
    latitude: 39.26424,
    longitude: -76.49537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21222',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 2877.9,
    imprecise: false,
    latitude: 39.28421,
    longitude: -76.65323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21223',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510|24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24510": 71.03, "24005": 28.97}',
    density: 1965,
    imprecise: false,
    latitude: 39.28309,
    longitude: -76.54088,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21224',
  },
  {
    city: 'Brooklyn',
    county_fips: 24003,
    county_fips_all: '24003|24510',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel|Baltimore',
    county_weights: '{"24003": 63.01, "24510": 36.99}',
    density: 2035.4,
    imprecise: false,
    latitude: 39.22597,
    longitude: -76.61508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21225',
  },
  {
    city: 'Curtis Bay',
    county_fips: 24510,
    county_fips_all: '24510|24003',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Anne Arundel',
    county_weights: '{"24510": 56.81, "24003": 43.19}',
    density: 263.6,
    imprecise: false,
    latitude: 39.2078,
    longitude: -76.5627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21226',
  },
  {
    city: 'Halethorpe',
    county_fips: 24005,
    county_fips_all: '24005|24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24005": 96.71, "24510": 3.29}',
    density: 1189.3,
    imprecise: false,
    latitude: 39.24024,
    longitude: -76.67913,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21227',
  },
  {
    city: 'Catonsville',
    county_fips: 24005,
    county_fips_all: '24005|24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24005": 99.87, "24510": 0.13}',
    density: 1251.5,
    imprecise: false,
    latitude: 39.27272,
    longitude: -76.74687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21228',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510|24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24510": 85.49, "24005": 14.51}',
    density: 3036.1,
    imprecise: false,
    latitude: 39.28509,
    longitude: -76.69083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21229',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 2015.3,
    imprecise: false,
    latitude: 39.26651,
    longitude: -76.62213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21230',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 6662.9,
    imprecise: false,
    latitude: 39.28775,
    longitude: -76.592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21231',
  },
  {
    city: 'Parkville',
    county_fips: 24005,
    county_fips_all: '24005|24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24005": 92.63, "24510": 7.37}',
    density: 1917.9,
    imprecise: false,
    latitude: 39.395,
    longitude: -76.53252,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21234',
  },
  {
    city: 'Nottingham',
    county_fips: 24005,
    county_fips_all: '24005|24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24005": 98.11, "24510": 1.89}',
    density: 1710.5,
    imprecise: false,
    latitude: 39.38789,
    longitude: -76.48552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21236',
  },
  {
    city: 'Rosedale',
    county_fips: 24005,
    county_fips_all: '24005|24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24005": 93.92, "24510": 6.08}',
    density: 1078.2,
    imprecise: false,
    latitude: 39.33938,
    longitude: -76.49456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21237',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510|24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore|Baltimore',
    county_weights: '{"24510": 73.27, "24005": 26.73}',
    density: 3602.7,
    imprecise: false,
    latitude: 39.36517,
    longitude: -76.58709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21239',
  },
  {
    city: 'Baltimore',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.17483,
    longitude: -76.67181,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21240',
  },
  {
    city: 'Windsor Mill',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 1043.6,
    imprecise: false,
    latitude: 39.3342,
    longitude: -76.78217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21244',
  },
  {
    city: 'Towson',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 39.3875,
    longitude: -76.61702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21285',
  },
  {
    city: 'Towson',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 981.8,
    imprecise: false,
    latitude: 39.41374,
    longitude: -76.57375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21286',
  },
  {
    city: 'Annapolis',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 748.3,
    imprecise: false,
    latitude: 38.98967,
    longitude: -76.5505,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21401',
  },
  {
    city: 'Annapolis',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 887,
    imprecise: false,
    latitude: 38.98816,
    longitude: -76.47202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21402',
  },
  {
    city: 'Annapolis',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 1359.8,
    imprecise: false,
    latitude: 38.94433,
    longitude: -76.49296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21403',
  },
  {
    city: 'Annapolis',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 559.4,
    imprecise: false,
    latitude: 39.01968,
    longitude: -76.44738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21409',
  },
  {
    city: 'Cumberland',
    county_fips: 24001,
    county_fips_all: '24001',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"24001": 100}',
    density: 172,
    imprecise: false,
    latitude: 39.64143,
    longitude: -78.75609,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21502',
  },
  {
    city: 'Accident',
    county_fips: 24023,
    county_fips_all: '24023',
    county: 'Garrett',
    county_names_all: 'Garrett',
    county_weights: '{"24023": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 39.63661,
    longitude: -79.30786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21520',
  },
  {
    city: 'Barton',
    county_fips: 24023,
    county_fips_all: '24023|24001',
    county: 'Garrett',
    county_names_all: 'Garrett|Allegany',
    county_weights: '{"24023": 62.21, "24001": 37.79}',
    density: 22.7,
    imprecise: false,
    latitude: 39.55042,
    longitude: -79.04836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21521',
  },
  {
    city: 'Bloomington',
    county_fips: 24023,
    county_fips_all: '24023',
    county: 'Garrett',
    county_names_all: 'Garrett',
    county_weights: '{"24023": 100}',
    density: 77.7,
    imprecise: false,
    latitude: 39.47956,
    longitude: -79.07925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21523',
  },
  {
    city: 'Corriganville',
    county_fips: 24001,
    county_fips_all: '24001',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"24001": 100}',
    density: 76.4,
    imprecise: false,
    latitude: 39.70666,
    longitude: -78.80203,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21524',
  },
  {
    city: 'Ellerslie',
    county_fips: 24001,
    county_fips_all: '24001',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"24001": 100}',
    density: 215,
    imprecise: false,
    latitude: 39.71692,
    longitude: -78.77474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21529',
  },
  {
    city: 'Flintstone',
    county_fips: 24001,
    county_fips_all: '24001',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"24001": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 39.68878,
    longitude: -78.54138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21530',
  },
  {
    city: 'Friendsville',
    county_fips: 24023,
    county_fips_all: '24023',
    county: 'Garrett',
    county_names_all: 'Garrett',
    county_weights: '{"24023": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 39.64862,
    longitude: -79.42221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21531',
  },
  {
    city: 'Frostburg',
    county_fips: 24001,
    county_fips_all: '24001|24023',
    county: 'Allegany',
    county_names_all: 'Allegany|Garrett',
    county_weights: '{"24001": 54.4, "24023": 45.6}',
    density: 71.1,
    imprecise: false,
    latitude: 39.65559,
    longitude: -78.96025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21532',
  },
  {
    city: 'Grantsville',
    county_fips: 24023,
    county_fips_all: '24023',
    county: 'Garrett',
    county_names_all: 'Garrett',
    county_weights: '{"24023": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 39.65619,
    longitude: -79.16924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21536',
  },
  {
    city: 'Kitzmiller',
    county_fips: 24023,
    county_fips_all: '24023',
    county: 'Garrett',
    county_names_all: 'Garrett',
    county_weights: '{"24023": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 39.40133,
    longitude: -79.22109,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21538',
  },
  {
    city: 'Lonaconing',
    county_fips: 24023,
    county_fips_all: '24023|24001',
    county: 'Garrett',
    county_names_all: 'Garrett|Allegany',
    county_weights: '{"24023": 57.43, "24001": 42.57}',
    density: 20.6,
    imprecise: false,
    latitude: 39.59828,
    longitude: -79.01074,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21539',
  },
  {
    city: 'Luke',
    county_fips: 24001,
    county_fips_all: '24001',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"24001": 100}',
    density: 128.9,
    imprecise: false,
    latitude: 39.47659,
    longitude: -79.05929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21540',
  },
  {
    city: 'McHenry',
    county_fips: 24023,
    county_fips_all: '24023',
    county: 'Garrett',
    county_names_all: 'Garrett',
    county_weights: '{"24023": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 39.55727,
    longitude: -79.36732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21541',
  },
  {
    city: 'Midlothian',
    county_fips: 24001,
    county_fips_all: '24001',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"24001": 100}',
    density: 29,
    imprecise: false,
    latitude: 39.64157,
    longitude: -78.96231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21543',
  },
  {
    city: 'Mount Savage',
    county_fips: 24001,
    county_fips_all: '24001',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"24001": 100}',
    density: 41.1,
    imprecise: false,
    latitude: 39.6991,
    longitude: -78.86513,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21545',
  },
  {
    city: 'Oakland',
    county_fips: 24023,
    county_fips_all: '24023',
    county: 'Garrett',
    county_names_all: 'Garrett',
    county_weights: '{"24023": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 39.39107,
    longitude: -79.39085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21550',
  },
  {
    city: 'Oldtown',
    county_fips: 24001,
    county_fips_all: '24001',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"24001": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 39.58777,
    longitude: -78.55685,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21555',
  },
  {
    city: 'Rawlings',
    county_fips: 24001,
    county_fips_all: '24001',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"24001": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 39.5191,
    longitude: -78.92353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21557',
  },
  {
    city: 'Spring Gap',
    county_fips: 24001,
    county_fips_all: '24001',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"24001": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 39.56508,
    longitude: -78.70632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21560',
  },
  {
    city: 'Swanton',
    county_fips: 24023,
    county_fips_all: '24023',
    county: 'Garrett',
    county_names_all: 'Garrett',
    county_weights: '{"24023": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 39.49976,
    longitude: -79.20482,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21561',
  },
  {
    city: 'Westernport',
    county_fips: 24001,
    county_fips_all: '24001|24023',
    county: 'Allegany',
    county_names_all: 'Allegany|Garrett',
    county_weights: '{"24001": 50.01, "24023": 49.99}',
    density: 40.5,
    imprecise: false,
    latitude: 39.50326,
    longitude: -79.05046,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21562',
  },
  {
    city: 'Easton',
    county_fips: 24041,
    county_fips_all: '24041',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"24041": 100}',
    density: 89,
    imprecise: false,
    latitude: 38.79275,
    longitude: -76.08242,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21601',
  },
  {
    city: 'Barclay',
    county_fips: 24035,
    county_fips_all: '24035',
    county: "Queen Anne's",
    county_names_all: "Queen Anne's",
    county_weights: '{"24035": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 39.13398,
    longitude: -75.85644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21607',
  },
  {
    city: 'Betterton',
    county_fips: 24029,
    county_fips_all: '24029',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"24029": 100}',
    density: 141.9,
    imprecise: false,
    latitude: 39.3652,
    longitude: -76.06845,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21610',
  },
  {
    city: 'Bozman',
    county_fips: 24041,
    county_fips_all: '24041',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"24041": 100}',
    density: 32.8,
    imprecise: false,
    latitude: 38.74928,
    longitude: -76.27695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21612',
  },
  {
    city: 'Cambridge',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 45,
    imprecise: false,
    latitude: 38.49537,
    longitude: -76.07169,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21613',
  },
  {
    city: 'Centreville',
    county_fips: 24035,
    county_fips_all: '24035',
    county: "Queen Anne's",
    county_names_all: "Queen Anne's",
    county_weights: '{"24035": 100}',
    density: 37.1,
    imprecise: false,
    latitude: 39.04985,
    longitude: -76.03819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21617',
  },
  {
    city: 'Chester',
    county_fips: 24035,
    county_fips_all: '24035',
    county: "Queen Anne's",
    county_names_all: "Queen Anne's",
    county_weights: '{"24035": 100}',
    density: 255.8,
    imprecise: false,
    latitude: 38.95285,
    longitude: -76.27939,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21619',
  },
  {
    city: 'Chestertown',
    county_fips: 24029,
    county_fips_all: '24029|24035',
    county: 'Kent',
    county_names_all: "Kent|Queen Anne's",
    county_weights: '{"24029": 74.99, "24035": 25.01}',
    density: 44.9,
    imprecise: false,
    latitude: 39.20667,
    longitude: -76.08739,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21620',
  },
  {
    city: 'Church Creek',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 38.40821,
    longitude: -76.17381,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21622',
  },
  {
    city: 'Church Hill',
    county_fips: 24035,
    county_fips_all: '24035',
    county: "Queen Anne's",
    county_names_all: "Queen Anne's",
    county_weights: '{"24035": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 39.11915,
    longitude: -75.96268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21623',
  },
  {
    city: 'Claiborne',
    county_fips: 24041,
    county_fips_all: '24041',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"24041": 100}',
    density: 26.9,
    imprecise: false,
    latitude: 38.83407,
    longitude: -76.27212,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21624',
  },
  {
    city: 'Cordova',
    county_fips: 24041,
    county_fips_all: '24041',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"24041": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 38.86925,
    longitude: -75.99216,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21625',
  },
  {
    city: 'Crapo',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 38.33902,
    longitude: -76.08398,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21626',
  },
  {
    city: 'Crocheron',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 6,
    imprecise: false,
    latitude: 38.23528,
    longitude: -76.04967,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21627',
  },
  {
    city: 'Crumpton',
    county_fips: 24035,
    county_fips_all: '24035',
    county: "Queen Anne's",
    county_names_all: "Queen Anne's",
    county_weights: '{"24035": 100}',
    density: 102,
    imprecise: false,
    latitude: 39.23577,
    longitude: -75.92238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21628',
  },
  {
    city: 'Denton',
    county_fips: 24011,
    county_fips_all: '24011',
    county: 'Caroline',
    county_names_all: 'Caroline',
    county_weights: '{"24011": 100}',
    density: 47.3,
    imprecise: false,
    latitude: 38.86111,
    longitude: -75.82753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21629',
  },
  {
    city: 'East New Market',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 38.8,
    imprecise: false,
    latitude: 38.58784,
    longitude: -75.94598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21631',
  },
  {
    city: 'Federalsburg',
    county_fips: 24011,
    county_fips_all: '24011|24019',
    county: 'Caroline',
    county_names_all: 'Caroline|Dorchester',
    county_weights: '{"24011": 79.6, "24019": 20.4}',
    density: 31.9,
    imprecise: false,
    latitude: 38.72287,
    longitude: -75.77478,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21632',
  },
  {
    city: 'Fishing Creek',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 39.7,
    imprecise: false,
    latitude: 38.27995,
    longitude: -76.185,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21634',
  },
  {
    city: 'Galena',
    county_fips: 24029,
    county_fips_all: '24029',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"24029": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 39.34006,
    longitude: -75.83826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21635',
  },
  {
    city: 'Goldsboro',
    county_fips: 24011,
    county_fips_all: '24011',
    county: 'Caroline',
    county_names_all: 'Caroline',
    county_weights: '{"24011": 100}',
    density: 18,
    imprecise: false,
    latitude: 39.0261,
    longitude: -75.79839,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21636',
  },
  {
    city: 'Grasonville',
    county_fips: 24035,
    county_fips_all: '24035',
    county: "Queen Anne's",
    county_names_all: "Queen Anne's",
    county_weights: '{"24035": 100}',
    density: 211.4,
    imprecise: false,
    latitude: 38.94513,
    longitude: -76.20263,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21638',
  },
  {
    city: 'Greensboro',
    county_fips: 24011,
    county_fips_all: '24011',
    county: 'Caroline',
    county_names_all: 'Caroline',
    county_weights: '{"24011": 100}',
    density: 54.6,
    imprecise: false,
    latitude: 38.96533,
    longitude: -75.7928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21639',
  },
  {
    city: 'Henderson',
    county_fips: 24011,
    county_fips_all: '24011|24035',
    county: 'Caroline',
    county_names_all: "Caroline|Queen Anne's",
    county_weights: '{"24011": 80.18, "24035": 19.82}',
    density: 17.5,
    imprecise: false,
    latitude: 39.07036,
    longitude: -75.82533,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21640',
  },
  {
    city: 'Hillsboro',
    county_fips: 24011,
    county_fips_all: '24011',
    county: 'Caroline',
    county_names_all: 'Caroline',
    county_weights: '{"24011": 100}',
    density: 362.4,
    imprecise: false,
    latitude: 38.91696,
    longitude: -75.94161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21641',
  },
  {
    city: 'Hurlock',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 45.1,
    imprecise: false,
    latitude: 38.6442,
    longitude: -75.87124,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21643',
  },
  {
    city: 'Ingleside',
    county_fips: 24035,
    county_fips_all: '24035',
    county: "Queen Anne's",
    county_names_all: "Queen Anne's",
    county_weights: '{"24035": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 39.11728,
    longitude: -75.87441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21644',
  },
  {
    city: 'Kennedyville',
    county_fips: 24029,
    county_fips_all: '24029',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"24029": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 39.31979,
    longitude: -75.96216,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21645',
  },
  {
    city: 'Mcdaniel',
    county_fips: 24041,
    county_fips_all: '24041',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"24041": 100}',
    density: 36.8,
    imprecise: false,
    latitude: 38.80114,
    longitude: -76.2831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21647',
  },
  {
    city: 'Madison',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 38.4966,
    longitude: -76.23386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21648',
  },
  {
    city: 'Marydel',
    county_fips: 24035,
    county_fips_all: '24035|24011',
    county: "Queen Anne's",
    county_names_all: "Queen Anne's|Caroline",
    county_weights: '{"24035": 52.3, "24011": 47.7}',
    density: 34.7,
    imprecise: false,
    latitude: 39.1366,
    longitude: -75.77453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21649',
  },
  {
    city: 'Massey',
    county_fips: 24029,
    county_fips_all: '24029',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"24029": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 39.31286,
    longitude: -75.80795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21650',
  },
  {
    city: 'Millington',
    county_fips: 24029,
    county_fips_all: '24029|24035',
    county: 'Kent',
    county_names_all: "Kent|Queen Anne's",
    county_weights: '{"24029": 70.32, "24035": 29.68}',
    density: 21.8,
    imprecise: false,
    latitude: 39.25821,
    longitude: -75.85802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21651',
  },
  {
    city: 'Neavitt',
    county_fips: 24041,
    county_fips_all: '24041',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"24041": 100}',
    density: 114.4,
    imprecise: false,
    latitude: 38.72028,
    longitude: -76.28108,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21652',
  },
  {
    city: 'Newcomb',
    county_fips: 24041,
    county_fips_all: '24041',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"24041": 100}',
    density: 175.5,
    imprecise: false,
    latitude: 38.74704,
    longitude: -76.17744,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21653',
  },
  {
    city: 'Oxford',
    county_fips: 24041,
    county_fips_all: '24041',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"24041": 100}',
    density: 41,
    imprecise: false,
    latitude: 38.6908,
    longitude: -76.12518,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21654',
  },
  {
    city: 'Preston',
    county_fips: 24011,
    county_fips_all: '24011',
    county: 'Caroline',
    county_names_all: 'Caroline',
    county_weights: '{"24011": 100}',
    density: 37,
    imprecise: false,
    latitude: 38.74601,
    longitude: -75.92103,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21655',
  },
  {
    city: 'Queen Anne',
    county_fips: 24035,
    county_fips_all: '24035|24041|24011',
    county: "Queen Anne's",
    county_names_all: "Queen Anne's|Talbot|Caroline",
    county_weights: '{"24035": 76.72, "24041": 19.85, "24011": 3.43}',
    density: 17.2,
    imprecise: false,
    latitude: 38.9534,
    longitude: -75.99042,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21657',
  },
  {
    city: 'Queenstown',
    county_fips: 24035,
    county_fips_all: '24035|24041',
    county: "Queen Anne's",
    county_names_all: "Queen Anne's|Talbot",
    county_weights: '{"24035": 97.15, "24041": 2.85}',
    density: 36,
    imprecise: false,
    latitude: 38.94071,
    longitude: -76.13819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21658',
  },
  {
    city: 'Rhodesdale',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 38.57442,
    longitude: -75.79985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21659',
  },
  {
    city: 'Ridgely',
    county_fips: 24011,
    county_fips_all: '24011',
    county: 'Caroline',
    county_names_all: 'Caroline',
    county_weights: '{"24011": 100}',
    density: 48.8,
    imprecise: false,
    latitude: 38.95534,
    longitude: -75.88839,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21660',
  },
  {
    city: 'Rock Hall',
    county_fips: 24029,
    county_fips_all: '24029',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"24029": 100}',
    density: 30.5,
    imprecise: false,
    latitude: 39.12905,
    longitude: -76.21967,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21661',
  },
  {
    city: 'Royal Oak',
    county_fips: 24041,
    county_fips_all: '24041',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"24041": 100}',
    density: 25.2,
    imprecise: false,
    latitude: 38.7136,
    longitude: -76.20209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21662',
  },
  {
    city: 'Saint Michaels',
    county_fips: 24041,
    county_fips_all: '24041',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"24041": 100}',
    density: 119.2,
    imprecise: false,
    latitude: 38.78333,
    longitude: -76.23303,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21663',
  },
  {
    city: 'Secretary',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 841.8,
    imprecise: false,
    latitude: 38.6081,
    longitude: -75.94732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21664',
  },
  {
    city: 'Sherwood',
    county_fips: 24041,
    county_fips_all: '24041',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"24041": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 38.75158,
    longitude: -76.34469,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21665',
  },
  {
    city: 'Stevensville',
    county_fips: 24035,
    county_fips_all: '24035',
    county: "Queen Anne's",
    county_names_all: "Queen Anne's",
    county_weights: '{"24035": 100}',
    density: 254.1,
    imprecise: false,
    latitude: 38.93956,
    longitude: -76.33272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21666',
  },
  {
    city: 'Still Pond',
    county_fips: 24029,
    county_fips_all: '24029',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"24029": 100}',
    density: 16.1,
    imprecise: false,
    latitude: 39.34377,
    longitude: -76.05188,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21667',
  },
  {
    city: 'Sudlersville',
    county_fips: 24035,
    county_fips_all: '24035',
    county: "Queen Anne's",
    county_names_all: "Queen Anne's",
    county_weights: '{"24035": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 39.18967,
    longitude: -75.85139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21668',
  },
  {
    city: 'Taylors Island',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 38.45897,
    longitude: -76.28509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21669',
  },
  {
    city: 'Tilghman',
    county_fips: 24041,
    county_fips_all: '24041',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"24041": 100}',
    density: 132.8,
    imprecise: false,
    latitude: 38.69658,
    longitude: -76.33562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21671',
  },
  {
    city: 'Toddville',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 38.27707,
    longitude: -76.06148,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21672',
  },
  {
    city: 'Trappe',
    county_fips: 24041,
    county_fips_all: '24041',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"24041": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 38.65235,
    longitude: -76.04163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21673',
  },
  {
    city: 'Wingate',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 38.29011,
    longitude: -76.0884,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21675',
  },
  {
    city: 'Wittman',
    county_fips: 24041,
    county_fips_all: '24041',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"24041": 100}',
    density: 42.5,
    imprecise: false,
    latitude: 38.78628,
    longitude: -76.30548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21676',
  },
  {
    city: 'Woolford',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 38.48454,
    longitude: -76.18544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21677',
  },
  {
    city: 'Worton',
    county_fips: 24029,
    county_fips_all: '24029',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"24029": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 39.30889,
    longitude: -76.10336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21678',
  },
  {
    city: 'Wye Mills',
    county_fips: 24041,
    county_fips_all: '24041|24035',
    county: 'Talbot',
    county_names_all: "Talbot|Queen Anne's",
    county_weights: '{"24041": 96.98, "24035": 3.02}',
    density: 15.1,
    imprecise: false,
    latitude: 38.91722,
    longitude: -76.08875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21679',
  },
  {
    city: 'Frederick',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 418.6,
    imprecise: false,
    latitude: 39.44729,
    longitude: -77.33512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21701',
  },
  {
    city: 'Frederick',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 459.1,
    imprecise: false,
    latitude: 39.48019,
    longitude: -77.4578,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21702',
  },
  {
    city: 'Frederick',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 505.8,
    imprecise: false,
    latitude: 39.36961,
    longitude: -77.47088,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21703',
  },
  {
    city: 'Frederick',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 290,
    imprecise: false,
    latitude: 39.3506,
    longitude: -77.3735,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21704',
  },
  {
    city: 'Frederick',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 97.9,
    imprecise: false,
    latitude: 39.40887,
    longitude: -77.41002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21705',
  },
  {
    city: 'Adamstown',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 61.3,
    imprecise: false,
    latitude: 39.29652,
    longitude: -77.44941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21710',
  },
  {
    city: 'Big Pool',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 39.66808,
    longitude: -78.01247,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21711',
  },
  {
    city: 'Boonsboro',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 96.1,
    imprecise: false,
    latitude: 39.52618,
    longitude: -77.66933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21713',
  },
  {
    city: 'Braddock Heights',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 82.4,
    imprecise: false,
    latitude: 39.41059,
    longitude: -77.51003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 95,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21714',
  },
  {
    city: 'Brownsville',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 31.4,
    imprecise: false,
    latitude: 39.37879,
    longitude: -77.66063,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21715',
  },
  {
    city: 'Brunswick',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 1018.1,
    imprecise: false,
    latitude: 39.31798,
    longitude: -77.6262,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21716',
  },
  {
    city: 'Buckeystown',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 156.2,
    imprecise: false,
    latitude: 39.33865,
    longitude: -77.43147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21717',
  },
  {
    city: 'Burkittsville',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 155.9,
    imprecise: false,
    latitude: 39.39343,
    longitude: -77.62734,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21718',
  },
  {
    city: 'Cascade',
    county_fips: 24043,
    county_fips_all: '24043|24021',
    county: 'Washington',
    county_names_all: 'Washington|Frederick',
    county_weights: '{"24043": 97.27, "24021": 2.73}',
    density: 110,
    imprecise: false,
    latitude: 39.70501,
    longitude: -77.49977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21719',
  },
  {
    city: 'Clear Spring',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 45.6,
    imprecise: false,
    latitude: 39.66575,
    longitude: -77.91457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21722',
  },
  {
    city: 'Cooksville',
    county_fips: 24027,
    county_fips_all: '24027',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"24027": 100}',
    density: 71.6,
    imprecise: false,
    latitude: 39.32825,
    longitude: -77.01056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21723',
  },
  {
    city: 'Emmitsburg',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 74.5,
    imprecise: false,
    latitude: 39.68865,
    longitude: -77.33096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21727',
  },
  {
    city: 'Fairplay',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 84.3,
    imprecise: false,
    latitude: 39.55004,
    longitude: -77.75838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21733',
  },
  {
    city: 'Funkstown',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 859.8,
    imprecise: false,
    latitude: 39.60583,
    longitude: -77.70382,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21734',
  },
  {
    city: 'Glenelg',
    county_fips: 24027,
    county_fips_all: '24027',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"24027": 100}',
    density: 186.5,
    imprecise: false,
    latitude: 39.2543,
    longitude: -77.01959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21737',
  },
  {
    city: 'Glenwood',
    county_fips: 24027,
    county_fips_all: '24027',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"24027": 100}',
    density: 204.5,
    imprecise: false,
    latitude: 39.27973,
    longitude: -77.02554,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21738',
  },
  {
    city: 'Hagerstown',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 352.9,
    imprecise: false,
    latitude: 39.63233,
    longitude: -77.73902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21740',
  },
  {
    city: 'Hagerstown',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 282.9,
    imprecise: false,
    latitude: 39.67363,
    longitude: -77.65928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21742',
  },
  {
    city: 'Hancock',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 39.68698,
    longitude: -78.2129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21750',
  },
  {
    city: 'Ijamsville',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 144.2,
    imprecise: false,
    latitude: 39.33684,
    longitude: -77.31131,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21754',
  },
  {
    city: 'Jefferson',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 66.5,
    imprecise: false,
    latitude: 39.36101,
    longitude: -77.56887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21755',
  },
  {
    city: 'Keedysville',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 60.3,
    imprecise: false,
    latitude: 39.45758,
    longitude: -77.70118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21756',
  },
  {
    city: 'Keymar',
    county_fips: 24013,
    county_fips_all: '24013|24021',
    county: 'Carroll',
    county_names_all: 'Carroll|Frederick',
    county_weights: '{"24013": 52.42, "24021": 47.58}',
    density: 29.3,
    imprecise: false,
    latitude: 39.59902,
    longitude: -77.25906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21757',
  },
  {
    city: 'Knoxville',
    county_fips: 24043,
    county_fips_all: '24043|24021',
    county: 'Washington',
    county_names_all: 'Washington|Frederick',
    county_weights: '{"24043": 50.58, "24021": 49.42}',
    density: 53.2,
    imprecise: false,
    latitude: 39.34567,
    longitude: -77.66265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21758',
  },
  {
    city: 'Libertytown',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 120,
    imprecise: false,
    latitude: 39.48058,
    longitude: -77.24842,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21762',
  },
  {
    city: 'Little Orleans',
    county_fips: 24001,
    county_fips_all: '24001',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"24001": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 39.65928,
    longitude: -78.39859,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21766',
  },
  {
    city: 'Maugansville',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 1156.6,
    imprecise: false,
    latitude: 39.69773,
    longitude: -77.74638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21767',
  },
  {
    city: 'Middletown',
    county_fips: 24021,
    county_fips_all: '24021|24043',
    county: 'Frederick',
    county_names_all: 'Frederick|Washington',
    county_weights: '{"24021": 99.34, "24043": 0.66}',
    density: 115.1,
    imprecise: false,
    latitude: 39.44582,
    longitude: -77.56489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21769',
  },
  {
    city: 'Monrovia',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 295.1,
    imprecise: false,
    latitude: 39.35245,
    longitude: -77.25791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21770',
  },
  {
    city: 'Mount Airy',
    county_fips: 24021,
    county_fips_all: '24021|24013|24027|24031',
    county: 'Frederick',
    county_names_all: 'Frederick|Carroll|Howard|Montgomery',
    county_weights:
      '{"24021": 51.35, "24013": 26.26, "24027": 18.21, "24031": 4.18}',
    density: 142.5,
    imprecise: false,
    latitude: 39.3955,
    longitude: -77.15869,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21771',
  },
  {
    city: 'Myersville',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 62,
    imprecise: false,
    latitude: 39.53725,
    longitude: -77.55301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21773',
  },
  {
    city: 'New Market',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 467.2,
    imprecise: false,
    latitude: 39.4088,
    longitude: -77.27844,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21774',
  },
  {
    city: 'New Windsor',
    county_fips: 24013,
    county_fips_all: '24013|24021',
    county: 'Carroll',
    county_names_all: 'Carroll|Frederick',
    county_weights: '{"24013": 79.17, "24021": 20.83}',
    density: 68.2,
    imprecise: false,
    latitude: 39.51861,
    longitude: -77.10376,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21776',
  },
  {
    city: 'Point Of Rocks',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 861.5,
    imprecise: false,
    latitude: 39.27918,
    longitude: -77.5287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21777',
  },
  {
    city: 'Rocky Ridge',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 39.61576,
    longitude: -77.33754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21778',
  },
  {
    city: 'Rohrersville',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 52,
    imprecise: false,
    latitude: 39.42447,
    longitude: -77.65398,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21779',
  },
  {
    city: 'Sabillasville',
    county_fips: 24021,
    county_fips_all: '24021|24043',
    county: 'Frederick',
    county_names_all: 'Frederick|Washington',
    county_weights: '{"24021": 95.78, "24043": 4.22}',
    density: 37.8,
    imprecise: false,
    latitude: 39.67676,
    longitude: -77.46777,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21780',
  },
  {
    city: 'Sharpsburg',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 48.8,
    imprecise: false,
    latitude: 39.4552,
    longitude: -77.75995,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21782',
  },
  {
    city: 'Smithsburg',
    county_fips: 24043,
    county_fips_all: '24043|24021',
    county: 'Washington',
    county_names_all: 'Washington|Frederick',
    county_weights: '{"24043": 72.83, "24021": 27.17}',
    density: 80.4,
    imprecise: false,
    latitude: 39.64885,
    longitude: -77.55903,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21783',
  },
  {
    city: 'Sykesville',
    county_fips: 24013,
    county_fips_all: '24013|24027',
    county: 'Carroll',
    county_names_all: 'Carroll|Howard',
    county_weights: '{"24013": 82.5, "24027": 17.5}',
    density: 270,
    imprecise: false,
    latitude: 39.40087,
    longitude: -76.9726,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21784',
  },
  {
    city: 'Taneytown',
    county_fips: 24013,
    county_fips_all: '24013|24021',
    county: 'Carroll',
    county_names_all: 'Carroll|Frederick',
    county_weights: '{"24013": 86.98, "24021": 13.02}',
    density: 73.6,
    imprecise: false,
    latitude: 39.67169,
    longitude: -77.17317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21787',
  },
  {
    city: 'Thurmont',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 68.8,
    imprecise: false,
    latitude: 39.59429,
    longitude: -77.41958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21788',
  },
  {
    city: 'Tuscarora',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 39.25908,
    longitude: -77.49559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21790',
  },
  {
    city: 'Union Bridge',
    county_fips: 24021,
    county_fips_all: '24021|24013',
    county: 'Frederick',
    county_names_all: 'Frederick|Carroll',
    county_weights: '{"24021": 60.67, "24013": 39.33}',
    density: 44.8,
    imprecise: false,
    latitude: 39.54267,
    longitude: -77.18713,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21791',
  },
  {
    city: 'Walkersville',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 193.8,
    imprecise: false,
    latitude: 39.48963,
    longitude: -77.34357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21793',
  },
  {
    city: 'West Friendship',
    county_fips: 24027,
    county_fips_all: '24027',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"24027": 100}',
    density: 103.7,
    imprecise: false,
    latitude: 39.29705,
    longitude: -76.97388,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21794',
  },
  {
    city: 'Williamsport',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 121.9,
    imprecise: false,
    latitude: 39.582,
    longitude: -77.82733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21795',
  },
  {
    city: 'Woodbine',
    county_fips: 24027,
    county_fips_all: '24027|24013|24031',
    county: 'Howard',
    county_names_all: 'Howard|Carroll|Montgomery',
    county_weights: '{"24027": 66.96, "24013": 31.72, "24031": 1.32}',
    density: 76.4,
    imprecise: false,
    latitude: 39.33284,
    longitude: -77.07002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21797',
  },
  {
    city: 'Woodsboro',
    county_fips: 24021,
    county_fips_all: '24021',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"24021": 100}',
    density: 69.4,
    imprecise: false,
    latitude: 39.53858,
    longitude: -77.29985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21798',
  },
  {
    city: 'Salisbury',
    county_fips: 24045,
    county_fips_all: '24045',
    county: 'Wicomico',
    county_names_all: 'Wicomico',
    county_weights: '{"24045": 100}',
    density: 289.6,
    imprecise: false,
    latitude: 38.38106,
    longitude: -75.64073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21801',
  },
  {
    city: 'Salisbury',
    county_fips: 24045,
    county_fips_all: '24045|24047',
    county: 'Wicomico',
    county_names_all: 'Wicomico|Worcester',
    county_weights: '{"24045": 77.67, "24047": 22.33}',
    density: 227.6,
    imprecise: false,
    latitude: 38.31726,
    longitude: -75.53673,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21804',
  },
  {
    city: 'Allen',
    county_fips: 24045,
    county_fips_all: '24045|24039',
    county: 'Wicomico',
    county_names_all: 'Wicomico|Somerset',
    county_weights: '{"24045": 97.55, "24039": 2.45}',
    density: 44.7,
    imprecise: false,
    latitude: 38.29005,
    longitude: -75.68887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21810',
  },
  {
    city: 'Berlin',
    county_fips: 24047,
    county_fips_all: '24047',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"24047": 100}',
    density: 92.7,
    imprecise: false,
    latitude: 38.31977,
    longitude: -75.22024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21811',
  },
  {
    city: 'Bishopville',
    county_fips: 24047,
    county_fips_all: '24047',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"24047": 100}',
    density: 42.2,
    imprecise: false,
    latitude: 38.42658,
    longitude: -75.17293,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21813',
  },
  {
    city: 'Bivalve',
    county_fips: 24045,
    county_fips_all: '24045',
    county: 'Wicomico',
    county_names_all: 'Wicomico',
    county_weights: '{"24045": 100}',
    density: 23.5,
    imprecise: false,
    latitude: 38.29176,
    longitude: -75.88669,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21814',
  },
  {
    city: 'Crisfield',
    county_fips: 24039,
    county_fips_all: '24039',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"24039": 100}',
    density: 117.9,
    imprecise: false,
    latitude: 37.98081,
    longitude: -75.83537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21817',
  },
  {
    city: 'Deal Island',
    county_fips: 24039,
    county_fips_all: '24039',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"24039": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 38.16664,
    longitude: -75.90611,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21821',
  },
  {
    city: 'Eden',
    county_fips: 24045,
    county_fips_all: '24045|24047|24039',
    county: 'Wicomico',
    county_names_all: 'Wicomico|Worcester|Somerset',
    county_weights: '{"24045": 50.94, "24047": 25.92, "24039": 23.14}',
    density: 29.5,
    imprecise: false,
    latitude: 38.28129,
    longitude: -75.65566,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21822',
  },
  {
    city: 'Ewell',
    county_fips: 24039,
    county_fips_all: '24039',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"24039": 100}',
    density: 44.7,
    imprecise: false,
    latitude: 37.97982,
    longitude: -76.02871,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21824',
  },
  {
    city: 'Fruitland',
    county_fips: 24045,
    county_fips_all: '24045',
    county: 'Wicomico',
    county_names_all: 'Wicomico',
    county_weights: '{"24045": 100}',
    density: 520.9,
    imprecise: false,
    latitude: 38.32077,
    longitude: -75.62353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21826',
  },
  {
    city: 'Girdletree',
    county_fips: 24047,
    county_fips_all: '24047',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"24047": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 38.09892,
    longitude: -75.38324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21829',
  },
  {
    city: 'Hebron',
    county_fips: 24045,
    county_fips_all: '24045',
    county: 'Wicomico',
    county_names_all: 'Wicomico',
    county_weights: '{"24045": 100}',
    density: 61.1,
    imprecise: false,
    latitude: 38.40202,
    longitude: -75.72841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21830',
  },
  {
    city: 'Linkwood',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 38.53355,
    longitude: -75.93758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21835',
  },
  {
    city: 'Mardela Springs',
    county_fips: 24045,
    county_fips_all: '24045',
    county: 'Wicomico',
    county_names_all: 'Wicomico',
    county_weights: '{"24045": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 38.4594,
    longitude: -75.76731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21837',
  },
  {
    city: 'Marion Station',
    county_fips: 24039,
    county_fips_all: '24039',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"24039": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 38.01452,
    longitude: -75.73098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21838',
  },
  {
    city: 'Nanticoke',
    county_fips: 24045,
    county_fips_all: '24045',
    county: 'Wicomico',
    county_names_all: 'Wicomico',
    county_weights: '{"24045": 100}',
    density: 42.2,
    imprecise: false,
    latitude: 38.25814,
    longitude: -75.89276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21840',
  },
  {
    city: 'Newark',
    county_fips: 24047,
    county_fips_all: '24047',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"24047": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 38.24385,
    longitude: -75.29588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21841',
  },
  {
    city: 'Ocean City',
    county_fips: 24047,
    county_fips_all: '24047',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"24047": 100}',
    density: 473.2,
    imprecise: false,
    latitude: 38.3778,
    longitude: -75.09084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21842',
  },
  {
    city: 'Parsonsburg',
    county_fips: 24045,
    county_fips_all: '24045',
    county: 'Wicomico',
    county_names_all: 'Wicomico',
    county_weights: '{"24045": 100}',
    density: 35.5,
    imprecise: false,
    latitude: 38.37006,
    longitude: -75.46064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21849',
  },
  {
    city: 'Pittsville',
    county_fips: 24045,
    county_fips_all: '24045',
    county: 'Wicomico',
    county_names_all: 'Wicomico',
    county_weights: '{"24045": 100}',
    density: 52.9,
    imprecise: false,
    latitude: 38.36171,
    longitude: -75.39867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21850',
  },
  {
    city: 'Pocomoke City',
    county_fips: 24047,
    county_fips_all: '24047|24039',
    county: 'Worcester',
    county_names_all: 'Worcester|Somerset',
    county_weights: '{"24047": 80.33, "24039": 19.67}',
    density: 27.2,
    imprecise: false,
    latitude: 38.07825,
    longitude: -75.54375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21851',
  },
  {
    city: 'Princess Anne',
    county_fips: 24039,
    county_fips_all: '24039',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"24039": 100}',
    density: 35.4,
    imprecise: false,
    latitude: 38.20453,
    longitude: -75.7102,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21853',
  },
  {
    city: 'Quantico',
    county_fips: 24045,
    county_fips_all: '24045',
    county: 'Wicomico',
    county_names_all: 'Wicomico',
    county_weights: '{"24045": 100}',
    density: 12,
    imprecise: false,
    latitude: 38.33807,
    longitude: -75.79224,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21856',
  },
  {
    city: 'Sharptown',
    county_fips: 24045,
    county_fips_all: '24045',
    county: 'Wicomico',
    county_names_all: 'Wicomico',
    county_weights: '{"24045": 100}',
    density: 136.4,
    imprecise: false,
    latitude: 38.53525,
    longitude: -75.72834,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21861',
  },
  {
    city: 'Showell',
    county_fips: 24047,
    county_fips_all: '24047',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"24047": 100}',
    density: 11,
    imprecise: false,
    latitude: 38.39716,
    longitude: -75.21514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21862',
  },
  {
    city: 'Snow Hill',
    county_fips: 24047,
    county_fips_all: '24047',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"24047": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 38.19167,
    longitude: -75.40327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21863',
  },
  {
    city: 'Stockton',
    county_fips: 24047,
    county_fips_all: '24047',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"24047": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 38.04355,
    longitude: -75.40532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21864',
  },
  {
    city: 'Tyaskin',
    county_fips: 24045,
    county_fips_all: '24045',
    county: 'Wicomico',
    county_names_all: 'Wicomico',
    county_weights: '{"24045": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 38.28605,
    longitude: -75.83296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21865',
  },
  {
    city: 'Tylerton',
    county_fips: 24039,
    county_fips_all: '24039',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"24039": 100}',
    density: 254.4,
    imprecise: false,
    latitude: 37.9672,
    longitude: -76.02137,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21866',
  },
  {
    city: 'Upper Fairmount',
    county_fips: 24039,
    county_fips_all: '24039',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"24039": 100}',
    density: 98.5,
    imprecise: false,
    latitude: 38.11025,
    longitude: -75.79399,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21867',
  },
  {
    city: 'Vienna',
    county_fips: 24019,
    county_fips_all: '24019',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"24019": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 38.43246,
    longitude: -75.89012,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21869',
  },
  {
    city: 'Westover',
    county_fips: 24039,
    county_fips_all: '24039',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"24039": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 38.10489,
    longitude: -75.73127,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21871',
  },
  {
    city: 'Whaleyville',
    county_fips: 24047,
    county_fips_all: '24047',
    county: 'Worcester',
    county_names_all: 'Worcester',
    county_weights: '{"24047": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 38.4163,
    longitude: -75.29399,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21872',
  },
  {
    city: 'Willards',
    county_fips: 24045,
    county_fips_all: '24045|10005',
    county: 'Wicomico',
    county_names_all: 'Wicomico|Sussex',
    county_weights: '{"24045": 99.48, "10005": 0.52}',
    density: 23.1,
    imprecise: false,
    latitude: 38.39266,
    longitude: -75.35417,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21874',
  },
  {
    city: 'Delmar',
    county_fips: 24045,
    county_fips_all: '24045',
    county: 'Wicomico',
    county_names_all: 'Wicomico',
    county_weights: '{"24045": 100}',
    density: 121.2,
    imprecise: false,
    latitude: 38.44038,
    longitude: -75.54559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21875',
  },
  {
    city: 'North East',
    county_fips: 24015,
    county_fips_all: '24015',
    county: 'Cecil',
    county_names_all: 'Cecil',
    county_weights: '{"24015": 100}',
    density: 155.2,
    imprecise: false,
    latitude: 39.58593,
    longitude: -75.95821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21901',
  },
  {
    city: 'Perry Point',
    county_fips: 24015,
    county_fips_all: '24015',
    county: 'Cecil',
    county_names_all: 'Cecil',
    county_weights: '{"24015": 100}',
    density: 151.5,
    imprecise: false,
    latitude: 39.55229,
    longitude: -76.06157,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21902',
  },
  {
    city: 'Perryville',
    county_fips: 24015,
    county_fips_all: '24015',
    county: 'Cecil',
    county_names_all: 'Cecil',
    county_weights: '{"24015": 100}',
    density: 172.8,
    imprecise: false,
    latitude: 39.57274,
    longitude: -76.04378,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21903',
  },
  {
    city: 'Port Deposit',
    county_fips: 24015,
    county_fips_all: '24015',
    county: 'Cecil',
    county_names_all: 'Cecil',
    county_weights: '{"24015": 100}',
    density: 102,
    imprecise: false,
    latitude: 39.62303,
    longitude: -76.07812,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21904',
  },
  {
    city: 'Rising Sun',
    county_fips: 24015,
    county_fips_all: '24015',
    county: 'Cecil',
    county_names_all: 'Cecil',
    county_weights: '{"24015": 100}',
    density: 108.8,
    imprecise: false,
    latitude: 39.68931,
    longitude: -76.03886,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21911',
  },
  {
    city: 'Warwick',
    county_fips: 24015,
    county_fips_all: '24015|10003',
    county: 'Cecil',
    county_names_all: 'Cecil|New Castle',
    county_weights: '{"24015": 99.75, "10003": 0.25}',
    density: 17.5,
    imprecise: false,
    latitude: 39.42486,
    longitude: -75.81607,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21912',
  },
  {
    city: 'Cecilton',
    county_fips: 24015,
    county_fips_all: '24015',
    county: 'Cecil',
    county_names_all: 'Cecil',
    county_weights: '{"24015": 100}',
    density: 261.9,
    imprecise: false,
    latitude: 39.40973,
    longitude: -75.87073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21913',
  },
  {
    city: 'Charlestown',
    county_fips: 24015,
    county_fips_all: '24015',
    county: 'Cecil',
    county_names_all: 'Cecil',
    county_weights: '{"24015": 100}',
    density: 427.9,
    imprecise: false,
    latitude: 39.57256,
    longitude: -75.98158,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21914',
  },
  {
    city: 'Chesapeake City',
    county_fips: 24015,
    county_fips_all: '24015',
    county: 'Cecil',
    county_names_all: 'Cecil',
    county_weights: '{"24015": 100}',
    density: 41.9,
    imprecise: false,
    latitude: 39.50095,
    longitude: -75.84764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21915',
  },
  {
    city: 'Colora',
    county_fips: 24015,
    county_fips_all: '24015',
    county: 'Cecil',
    county_names_all: 'Cecil',
    county_weights: '{"24015": 100}',
    density: 110.2,
    imprecise: false,
    latitude: 39.67106,
    longitude: -76.09823,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21917',
  },
  {
    city: 'Conowingo',
    county_fips: 24015,
    county_fips_all: '24015',
    county: 'Cecil',
    county_names_all: 'Cecil',
    county_weights: '{"24015": 100}',
    density: 91.6,
    imprecise: false,
    latitude: 39.68327,
    longitude: -76.16662,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21918',
  },
  {
    city: 'Earleville',
    county_fips: 24015,
    county_fips_all: '24015',
    county: 'Cecil',
    county_names_all: 'Cecil',
    county_weights: '{"24015": 100}',
    density: 32.7,
    imprecise: false,
    latitude: 39.42047,
    longitude: -75.93372,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21919',
  },
  {
    city: 'Elk Mills',
    county_fips: 24015,
    county_fips_all: '24015',
    county: 'Cecil',
    county_names_all: 'Cecil',
    county_weights: '{"24015": 100}',
    density: 551.5,
    imprecise: false,
    latitude: 39.65675,
    longitude: -75.83449,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21920',
  },
  {
    city: 'Elkton',
    county_fips: 24015,
    county_fips_all: '24015',
    county: 'Cecil',
    county_names_all: 'Cecil',
    county_weights: '{"24015": 100}',
    density: 185.6,
    imprecise: false,
    latitude: 39.62568,
    longitude: -75.85904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21921',
  },
  {
    city: 'Georgetown',
    county_fips: 24015,
    county_fips_all: '24015',
    county: 'Cecil',
    county_names_all: 'Cecil',
    county_weights: '{"24015": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 39.37198,
    longitude: -75.89115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21930',
  },
  {
    city: 'Annandale',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1765,
    imprecise: false,
    latitude: 38.8308,
    longitude: -77.21402,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22003',
  },
  {
    city: 'Burke',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 2031.2,
    imprecise: false,
    latitude: 38.78784,
    longitude: -77.28136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22015',
  },
  {
    city: 'Dumfries',
    county_fips: 51153,
    county_fips_all: '51153',
    county: 'Prince William',
    county_names_all: 'Prince William',
    county_weights: '{"51153": 100}',
    density: 775.9,
    imprecise: false,
    latitude: 38.59874,
    longitude: -77.3491,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22025',
  },
  {
    city: 'Dumfries',
    county_fips: 51153,
    county_fips_all: '51153',
    county: 'Prince William',
    county_names_all: 'Prince William',
    county_weights: '{"51153": 100}',
    density: 1053.4,
    imprecise: false,
    latitude: 38.56717,
    longitude: -77.29476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22026',
  },
  {
    city: 'Dunn Loring',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1175,
    imprecise: false,
    latitude: 38.89411,
    longitude: -77.22159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22027',
  },
  {
    city: 'Fairfax',
    county_fips: 51059,
    county_fips_all: '51059|51600',
    county: 'Fairfax',
    county_names_all: 'Fairfax|Fairfax',
    county_weights: '{"51059": 76.08, "51600": 23.92}',
    density: 1217.8,
    imprecise: false,
    latitude: 38.83891,
    longitude: -77.34188,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 61332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22030',
  },
  {
    city: 'Fairfax',
    county_fips: 51059,
    county_fips_all: '51059|51600',
    county: 'Fairfax',
    county_names_all: 'Fairfax|Fairfax',
    county_weights: '{"51059": 82.4, "51600": 17.6}',
    density: 2019.4,
    imprecise: false,
    latitude: 38.85954,
    longitude: -77.2599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22031',
  },
  {
    city: 'Fairfax',
    county_fips: 51059,
    county_fips_all: '51059|51600',
    county: 'Fairfax',
    county_names_all: 'Fairfax|Fairfax',
    county_weights: '{"51059": 95.4, "51600": 4.6}',
    density: 1562.6,
    imprecise: false,
    latitude: 38.82012,
    longitude: -77.29032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22032',
  },
  {
    city: 'Fairfax',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1951.4,
    imprecise: false,
    latitude: 38.87564,
    longitude: -77.38419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22033',
  },
  {
    city: 'Fairfax',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.85628,
    longitude: -77.36269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22035',
  },
  {
    city: 'Fairfax Station',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 320.9,
    imprecise: false,
    latitude: 38.74992,
    longitude: -77.31536,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22039',
  },
  {
    city: 'Falls Church',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 4060.6,
    imprecise: false,
    latitude: 38.8485,
    longitude: -77.14212,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22041',
  },
  {
    city: 'Falls Church',
    county_fips: 51059,
    county_fips_all: '51059|51610',
    county: 'Fairfax',
    county_names_all: 'Fairfax|Falls Church',
    county_weights: '{"51059": 99.14, "51610": 0.86}',
    density: 2133.6,
    imprecise: false,
    latitude: 38.86463,
    longitude: -77.19406,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22042',
  },
  {
    city: 'Falls Church',
    county_fips: 51059,
    county_fips_all: '51059|51610',
    county: 'Fairfax',
    county_names_all: 'Fairfax|Falls Church',
    county_weights: '{"51059": 98.86, "51610": 1.14}',
    density: 2127.8,
    imprecise: false,
    latitude: 38.90076,
    longitude: -77.19746,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22043',
  },
  {
    city: 'Falls Church',
    county_fips: 51059,
    county_fips_all: '51059|51610',
    county: 'Fairfax',
    county_names_all: 'Fairfax|Falls Church',
    county_weights: '{"51059": 94.24, "51610": 5.76}',
    density: 2522.8,
    imprecise: false,
    latitude: 38.85957,
    longitude: -77.15627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22044',
  },
  {
    city: 'Falls Church',
    county_fips: 51610,
    county_fips_all: '51610|51059',
    county: 'Falls Church',
    county_names_all: 'Falls Church|Fairfax',
    county_weights: '{"51610": 66.34, "51059": 33.66}',
    density: 2575.4,
    imprecise: false,
    latitude: 38.88696,
    longitude: -77.18025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22046',
  },
  {
    city: 'Fort Belvoir',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 312.8,
    imprecise: false,
    latitude: 38.70525,
    longitude: -77.15636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22060',
  },
  {
    city: 'Great Falls',
    county_fips: 51059,
    county_fips_all: '51059|51107',
    county: 'Fairfax',
    county_names_all: 'Fairfax|Loudoun',
    county_weights: '{"51059": 99.12, "51107": 0.88}',
    density: 259.4,
    imprecise: false,
    latitude: 39.01032,
    longitude: -77.30258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22066',
  },
  {
    city: 'Lorton',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 479.3,
    imprecise: false,
    latitude: 38.67998,
    longitude: -77.2055,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22079',
  },
  {
    city: 'McLean',
    county_fips: 51059,
    county_fips_all: '51059|51013',
    county: 'Fairfax',
    county_names_all: 'Fairfax|Arlington',
    county_weights: '{"51059": 99.46, "51013": 0.54}',
    density: 912.1,
    imprecise: false,
    latitude: 38.9386,
    longitude: -77.16513,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22101',
  },
  {
    city: 'McLean',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 915.6,
    imprecise: false,
    latitude: 38.95199,
    longitude: -77.22901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22102',
  },
  {
    city: 'Oakton',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 676.4,
    imprecise: false,
    latitude: 38.8909,
    longitude: -77.33025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22124',
  },
  {
    city: 'Occoquan',
    county_fips: 51153,
    county_fips_all: '51153',
    county: 'Prince William',
    county_names_all: 'Prince William',
    county_weights: '{"51153": 100}',
    density: 1734.9,
    imprecise: false,
    latitude: 38.68217,
    longitude: -77.26073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22125',
  },
  {
    city: 'Quantico',
    county_fips: 51179,
    county_fips_all: '51179|51153',
    county: 'Stafford',
    county_names_all: 'Stafford|Prince William',
    county_weights: '{"51179": 76.56, "51153": 23.44}',
    density: 68.1,
    imprecise: false,
    latitude: 38.53186,
    longitude: -77.409,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22134',
  },
  {
    city: 'Springfield',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1415.9,
    imprecise: false,
    latitude: 38.77198,
    longitude: -77.18605,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22150',
  },
  {
    city: 'Springfield',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1291.5,
    imprecise: false,
    latitude: 38.80283,
    longitude: -77.2096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22151',
  },
  {
    city: 'Springfield',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1845.2,
    imprecise: false,
    latitude: 38.77564,
    longitude: -77.23149,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22152',
  },
  {
    city: 'Springfield',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1423.7,
    imprecise: false,
    latitude: 38.74443,
    longitude: -77.23451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22153',
  },
  {
    city: 'Triangle',
    county_fips: 51153,
    county_fips_all: '51153',
    county: 'Prince William',
    county_names_all: 'Prince William',
    county_weights: '{"51153": 100}',
    density: 215.4,
    imprecise: false,
    latitude: 38.5742,
    longitude: -77.3895,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22172',
  },
  {
    city: 'Vienna',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1741,
    imprecise: false,
    latitude: 38.89619,
    longitude: -77.25426,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22180',
  },
  {
    city: 'Vienna',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1090.2,
    imprecise: false,
    latitude: 38.9053,
    longitude: -77.29466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22181',
  },
  {
    city: 'Vienna',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 858.6,
    imprecise: false,
    latitude: 38.93611,
    longitude: -77.2736,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22182',
  },
  {
    city: 'Woodbridge',
    county_fips: 51153,
    county_fips_all: '51153',
    county: 'Prince William',
    county_names_all: 'Prince William',
    county_weights: '{"51153": 100}',
    density: 1842.6,
    imprecise: false,
    latitude: 38.6249,
    longitude: -77.26849,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 73623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22191',
  },
  {
    city: 'Woodbridge',
    county_fips: 51153,
    county_fips_all: '51153',
    county: 'Prince William',
    county_names_all: 'Prince William',
    county_weights: '{"51153": 100}',
    density: 1202.2,
    imprecise: false,
    latitude: 38.68358,
    longitude: -77.31821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22192',
  },
  {
    city: 'Woodbridge',
    county_fips: 51153,
    county_fips_all: '51153',
    county: 'Prince William',
    county_names_all: 'Prince William',
    county_weights: '{"51153": 100}',
    density: 1723.1,
    imprecise: false,
    latitude: 38.64233,
    longitude: -77.34881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 81588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22193',
  },
  {
    city: 'Arlington',
    county_fips: 51013,
    county_fips_all: '51013',
    county: 'Arlington',
    county_names_all: 'Arlington',
    county_weights: '{"51013": 100}',
    density: 6304.7,
    imprecise: false,
    latitude: 38.88684,
    longitude: -77.09501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22201',
  },
  {
    city: 'Arlington',
    county_fips: 51013,
    county_fips_all: '51013',
    county: 'Arlington',
    county_names_all: 'Arlington',
    county_weights: '{"51013": 100}',
    density: 2728.7,
    imprecise: false,
    latitude: 38.8569,
    longitude: -77.05175,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22202',
  },
  {
    city: 'Arlington',
    county_fips: 51013,
    county_fips_all: '51013|51059',
    county: 'Arlington',
    county_names_all: 'Arlington|Fairfax',
    county_weights: '{"51013": 99.07, "51059": 0.93}',
    density: 6541.6,
    imprecise: false,
    latitude: 38.87377,
    longitude: -77.1164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22203',
  },
  {
    city: 'Arlington',
    county_fips: 51013,
    county_fips_all: '51013',
    county: 'Arlington',
    county_names_all: 'Arlington',
    county_weights: '{"51013": 100}',
    density: 4867.5,
    imprecise: false,
    latitude: 38.86076,
    longitude: -77.09894,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22204',
  },
  {
    city: 'Arlington',
    county_fips: 51013,
    county_fips_all: '51013',
    county: 'Arlington',
    county_names_all: 'Arlington',
    county_weights: '{"51013": 100}',
    density: 2510.5,
    imprecise: false,
    latitude: 38.88337,
    longitude: -77.13948,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22205',
  },
  {
    city: 'Arlington',
    county_fips: 51013,
    county_fips_all: '51013|51510',
    county: 'Arlington',
    county_names_all: 'Arlington|Alexandria',
    county_weights: '{"51013": 97.0, "51510": 3.0}',
    density: 3878.3,
    imprecise: false,
    latitude: 38.8442,
    longitude: -77.0886,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22206',
  },
  {
    city: 'Arlington',
    county_fips: 51013,
    county_fips_all: '51013|51059',
    county: 'Arlington',
    county_names_all: 'Arlington|Fairfax',
    county_weights: '{"51013": 99.37, "51059": 0.63}',
    density: 2122.8,
    imprecise: false,
    latitude: 38.90665,
    longitude: -77.12384,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22207',
  },
  {
    city: 'Arlington',
    county_fips: 51013,
    county_fips_all: '51013',
    county: 'Arlington',
    county_names_all: 'Arlington',
    county_weights: '{"51013": 100}',
    density: 7298.9,
    imprecise: false,
    latitude: 38.89413,
    longitude: -77.07309,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22209',
  },
  {
    city: 'Fort Myer',
    county_fips: 51013,
    county_fips_all: '51013',
    county: 'Arlington',
    county_names_all: 'Arlington',
    county_weights: '{"51013": 100}',
    density: 339.7,
    imprecise: false,
    latitude: 38.88011,
    longitude: -77.07482,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22211',
  },
  {
    city: 'Arlington',
    county_fips: 51013,
    county_fips_all: '51013',
    county: 'Arlington',
    county_names_all: 'Arlington',
    county_weights: '{"51013": 100}',
    density: 2624.1,
    imprecise: false,
    latitude: 38.89459,
    longitude: -77.16239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22213',
  },
  {
    city: 'Alexandria',
    county_fips: 51510,
    county_fips_all: '51510',
    county: 'Alexandria',
    county_names_all: 'Alexandria',
    county_weights: '{"51510": 100}',
    density: 3801.3,
    imprecise: false,
    latitude: 38.81995,
    longitude: -77.05934,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22301',
  },
  {
    city: 'Alexandria',
    county_fips: 51510,
    county_fips_all: '51510|51059',
    county: 'Alexandria',
    county_names_all: 'Alexandria|Fairfax',
    county_weights: '{"51510": 95.58, "51059": 4.42}',
    density: 3069.4,
    imprecise: false,
    latitude: 38.82799,
    longitude: -77.08432,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22302',
  },
  {
    city: 'Alexandria',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 3399,
    imprecise: false,
    latitude: 38.794,
    longitude: -77.08175,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22303',
  },
  {
    city: 'Alexandria',
    county_fips: 51510,
    county_fips_all: '51510|51059',
    county: 'Alexandria',
    county_names_all: 'Alexandria|Fairfax',
    county_weights: '{"51510": 96.55, "51059": 3.45}',
    density: 3873,
    imprecise: false,
    latitude: 38.81361,
    longitude: -77.11498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22304',
  },
  {
    city: 'Alexandria',
    county_fips: 51510,
    county_fips_all: '51510',
    county: 'Alexandria',
    county_names_all: 'Alexandria',
    county_weights: '{"51510": 100}',
    density: 4991.2,
    imprecise: false,
    latitude: 38.83655,
    longitude: -77.06234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22305',
  },
  {
    city: 'Alexandria',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1741.1,
    imprecise: false,
    latitude: 38.75655,
    longitude: -77.09254,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22306',
  },
  {
    city: 'Alexandria',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1282.4,
    imprecise: false,
    latitude: 38.7708,
    longitude: -77.05694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22307',
  },
  {
    city: 'Alexandria',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1226.6,
    imprecise: false,
    latitude: 38.72957,
    longitude: -77.05876,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22308',
  },
  {
    city: 'Alexandria',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1760.3,
    imprecise: false,
    latitude: 38.71931,
    longitude: -77.10724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22309',
  },
  {
    city: 'Alexandria',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 1611.1,
    imprecise: false,
    latitude: 38.78447,
    longitude: -77.12231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22310',
  },
  {
    city: 'Alexandria',
    county_fips: 51510,
    county_fips_all: '51510|51059',
    county: 'Alexandria',
    county_names_all: 'Alexandria|Fairfax',
    county_weights: '{"51510": 76.32, "51059": 23.68}',
    density: 4824.2,
    imprecise: false,
    latitude: 38.83442,
    longitude: -77.12313,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22311',
  },
  {
    city: 'Alexandria',
    county_fips: 51059,
    county_fips_all: '51059|51510',
    county: 'Fairfax',
    county_names_all: 'Fairfax|Alexandria',
    county_weights: '{"51059": 91.52, "51510": 8.48}',
    density: 2016.3,
    imprecise: false,
    latitude: 38.81685,
    longitude: -77.15372,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22312',
  },
  {
    city: 'Alexandria',
    county_fips: 51510,
    county_fips_all: '51510',
    county: 'Alexandria',
    county_names_all: 'Alexandria',
    county_weights: '{"51510": 100}',
    density: 3819,
    imprecise: false,
    latitude: 38.80732,
    longitude: -77.0563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22314',
  },
  {
    city: 'Alexandria',
    county_fips: 51059,
    county_fips_all: '51059',
    county: 'Fairfax',
    county_names_all: 'Fairfax',
    county_weights: '{"51059": 100}',
    density: 2131.7,
    imprecise: false,
    latitude: 38.75735,
    longitude: -77.14803,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22315',
  },
  {
    city: 'Fredericksburg',
    county_fips: 51630,
    county_fips_all: '51630|51177',
    county: 'Fredericksburg',
    county_names_all: 'Fredericksburg|Spotsylvania',
    county_weights: '{"51630": 99.83, "51177": 0.17}',
    density: 1070.2,
    imprecise: false,
    latitude: 38.29928,
    longitude: -77.48704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22401',
  },
  {
    city: 'Fredericksburg',
    county_fips: 51179,
    county_fips_all: '51179',
    county: 'Stafford',
    county_names_all: 'Stafford',
    county_weights: '{"51179": 100}',
    density: 267.2,
    imprecise: false,
    latitude: 38.31568,
    longitude: -77.40377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22405',
  },
  {
    city: 'Fredericksburg',
    county_fips: 51179,
    county_fips_all: '51179|51061',
    county: 'Stafford',
    county_names_all: 'Stafford|Fauquier',
    county_weights: '{"51179": 95.39, "51061": 4.61}',
    density: 145.3,
    imprecise: false,
    latitude: 38.39964,
    longitude: -77.55596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22406',
  },
  {
    city: 'Fredericksburg',
    county_fips: 51177,
    county_fips_all: '51177|51047|51630',
    county: 'Spotsylvania',
    county_names_all: 'Spotsylvania|Culpeper|Fredericksburg',
    county_weights: '{"51177": 97.26, "51047": 2.63, "51630": 0.11}',
    density: 414.1,
    imprecise: false,
    latitude: 38.28581,
    longitude: -77.58055,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22407',
  },
  {
    city: 'Fredericksburg',
    county_fips: 51177,
    county_fips_all: '51177|51033',
    county: 'Spotsylvania',
    county_names_all: 'Spotsylvania|Caroline',
    county_weights: '{"51177": 82.83, "51033": 17.17}',
    density: 257.6,
    imprecise: false,
    latitude: 38.21916,
    longitude: -77.44013,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22408',
  },
  {
    city: 'Bowling Green',
    county_fips: 51033,
    county_fips_all: '51033',
    county: 'Caroline',
    county_names_all: 'Caroline',
    county_weights: '{"51033": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 38.07177,
    longitude: -77.28624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22427',
  },
  {
    city: 'Burgess',
    county_fips: 51133,
    county_fips_all: '51133',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"51133": 100}',
    density: 31.3,
    imprecise: false,
    latitude: 37.8637,
    longitude: -76.35043,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22432',
  },
  {
    city: 'Burr Hill',
    county_fips: 51137,
    county_fips_all: '51137',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"51137": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 38.35875,
    longitude: -77.86093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22433',
  },
  {
    city: 'Callao',
    county_fips: 51133,
    county_fips_all: '51133|51159|51193',
    county: 'Northumberland',
    county_names_all: 'Northumberland|Richmond|Westmoreland',
    county_weights: '{"51133": 93.43, "51159": 5.25, "51193": 1.32}',
    density: 33.6,
    imprecise: false,
    latitude: 37.97216,
    longitude: -76.57288,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22435',
  },
  {
    city: 'Caret',
    county_fips: 51057,
    county_fips_all: '51057',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"51057": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 38.04698,
    longitude: -77.07471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22436',
  },
  {
    city: 'Center Cross',
    county_fips: 51097,
    county_fips_all: '51097|51057',
    county: 'King and Queen',
    county_names_all: 'King and Queen|Essex',
    county_weights: '{"51097": 66.05, "51057": 33.95}',
    density: 6,
    imprecise: false,
    latitude: 37.7764,
    longitude: -76.8156,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22437',
  },
  {
    city: 'Champlain',
    county_fips: 51057,
    county_fips_all: '51057|51033',
    county: 'Essex',
    county_names_all: 'Essex|Caroline',
    county_weights: '{"51057": 90.13, "51033": 9.87}',
    density: 2.4,
    imprecise: false,
    latitude: 38.03788,
    longitude: -76.99971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22438',
  },
  {
    city: 'Colonial Beach',
    county_fips: 51193,
    county_fips_all: '51193|51099',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|King George',
    county_weights: '{"51193": 99.69, "51099": 0.31}',
    density: 65.2,
    imprecise: false,
    latitude: 38.18078,
    longitude: -76.99776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22443',
  },
  {
    city: 'Dahlgren',
    county_fips: 51099,
    county_fips_all: '51099',
    county: 'King George',
    county_names_all: 'King George',
    county_weights: '{"51099": 100}',
    density: 72.1,
    imprecise: false,
    latitude: 38.33996,
    longitude: -77.03238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22448',
  },
  {
    city: 'Dunnsville',
    county_fips: 51057,
    county_fips_all: '51057',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"51057": 100}',
    density: 19.7,
    imprecise: false,
    latitude: 37.83599,
    longitude: -76.85032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22454',
  },
  {
    city: 'Farnham',
    county_fips: 51159,
    county_fips_all: '51159',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"51159": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 37.87612,
    longitude: -76.60692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22460',
  },
  {
    city: 'Hague',
    county_fips: 51193,
    county_fips_all: '51193',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"51193": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 38.0667,
    longitude: -76.64749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22469',
  },
  {
    city: 'Haynesville',
    county_fips: 51159,
    county_fips_all: '51159',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"51159": 100}',
    density: 1446.5,
    imprecise: false,
    latitude: 37.95897,
    longitude: -76.67257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22472',
  },
  {
    city: 'Heathsville',
    county_fips: 51133,
    county_fips_all: '51133|51103',
    county: 'Northumberland',
    county_names_all: 'Northumberland|Lancaster',
    county_weights: '{"51133": 96.92, "51103": 3.08}',
    density: 18.6,
    imprecise: false,
    latitude: 37.88316,
    longitude: -76.41386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22473',
  },
  {
    city: 'Hustle',
    county_fips: 51057,
    county_fips_all: '51057',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"51057": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 38.03807,
    longitude: -77.06872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22476',
  },
  {
    city: 'Irvington',
    county_fips: 51103,
    county_fips_all: '51103',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"51103": 100}',
    density: 140.2,
    imprecise: false,
    latitude: 37.66631,
    longitude: -76.41498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22480',
  },
  {
    city: 'Kilmarnock',
    county_fips: 51133,
    county_fips_all: '51133|51103',
    county: 'Northumberland',
    county_names_all: 'Northumberland|Lancaster',
    county_weights: '{"51133": 65.09, "51103": 34.91}',
    density: 39.1,
    imprecise: false,
    latitude: 37.73723,
    longitude: -76.35245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22482',
  },
  {
    city: 'King George',
    county_fips: 51099,
    county_fips_all: '51099|51193',
    county: 'King George',
    county_names_all: 'King George|Westmoreland',
    county_weights: '{"51099": 99.77, "51193": 0.23}',
    density: 59.6,
    imprecise: false,
    latitude: 38.2717,
    longitude: -77.15996,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22485',
  },
  {
    city: 'Kinsale',
    county_fips: 51193,
    county_fips_all: '51193',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"51193": 100}',
    density: 21,
    imprecise: false,
    latitude: 38.04986,
    longitude: -76.58796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22488',
  },
  {
    city: 'Lancaster',
    county_fips: 51103,
    county_fips_all: '51103|51133',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Northumberland',
    county_weights: '{"51103": 98.07, "51133": 1.93}',
    density: 19.1,
    imprecise: false,
    latitude: 37.7624,
    longitude: -76.50432,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22503',
  },
  {
    city: 'Laneview',
    county_fips: 51057,
    county_fips_all: '51057|51119',
    county: 'Essex',
    county_names_all: 'Essex|Middlesex',
    county_weights: '{"51057": 81.31, "51119": 18.69}',
    density: 7,
    imprecise: false,
    latitude: 37.76346,
    longitude: -76.72675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22504',
  },
  {
    city: 'Locust Grove',
    county_fips: 51137,
    county_fips_all: '51137|51177',
    county: 'Orange',
    county_names_all: 'Orange|Spotsylvania',
    county_weights: '{"51137": 89.35, "51177": 10.65}',
    density: 104.4,
    imprecise: false,
    latitude: 38.31732,
    longitude: -77.7913,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22508',
  },
  {
    city: 'Loretto',
    county_fips: 51057,
    county_fips_all: '51057',
    county: 'Essex',
    county_names_all: 'Essex',
    county_weights: '{"51057": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 38.10642,
    longitude: -77.06669,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22509',
  },
  {
    city: 'Lottsburg',
    county_fips: 51133,
    county_fips_all: '51133',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"51133": 100}',
    density: 30.1,
    imprecise: false,
    latitude: 37.98352,
    longitude: -76.50323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22511',
  },
  {
    city: 'Milford',
    county_fips: 51033,
    county_fips_all: '51033|51097',
    county: 'Caroline',
    county_names_all: 'Caroline|King and Queen',
    county_weights: '{"51033": 97.63, "51097": 2.37}',
    density: 11.5,
    imprecise: false,
    latitude: 37.9724,
    longitude: -77.24471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22514',
  },
  {
    city: 'Montross',
    county_fips: 51193,
    county_fips_all: '51193|51159',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland|Richmond',
    county_weights: '{"51193": 97.56, "51159": 2.44}',
    density: 19,
    imprecise: false,
    latitude: 38.11651,
    longitude: -76.80634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22520',
  },
  {
    city: 'Oldhams',
    county_fips: 51193,
    county_fips_all: '51193',
    county: 'Westmoreland',
    county_names_all: 'Westmoreland',
    county_weights: '{"51193": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 38.01036,
    longitude: -76.67942,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22529',
  },
  {
    city: 'Partlow',
    county_fips: 51177,
    county_fips_all: '51177',
    county: 'Spotsylvania',
    county_names_all: 'Spotsylvania',
    county_weights: '{"51177": 100}',
    density: 38.3,
    imprecise: false,
    latitude: 38.08473,
    longitude: -77.67062,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22534',
  },
  {
    city: 'Port Royal',
    county_fips: 51033,
    county_fips_all: '51033',
    county: 'Caroline',
    county_names_all: 'Caroline',
    county_weights: '{"51033": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 38.12314,
    longitude: -77.19619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22535',
  },
  {
    city: 'Rappahannock Academy',
    county_fips: 51033,
    county_fips_all: '51033',
    county: 'Caroline',
    county_names_all: 'Caroline',
    county_weights: '{"51033": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 38.18941,
    longitude: -77.27334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22538',
  },
  {
    city: 'Reedville',
    county_fips: 51133,
    county_fips_all: '51133',
    county: 'Northumberland',
    county_names_all: 'Northumberland',
    county_weights: '{"51133": 100}',
    density: 47.3,
    imprecise: false,
    latitude: 37.85865,
    longitude: -76.28731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22539',
  },
  {
    city: 'Rhoadesville',
    county_fips: 51137,
    county_fips_all: '51137',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"51137": 100}',
    density: 54.7,
    imprecise: false,
    latitude: 38.29348,
    longitude: -77.88837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22542',
  },
  {
    city: 'Ruther Glen',
    county_fips: 51033,
    county_fips_all: '51033|51085|51177',
    county: 'Caroline',
    county_names_all: 'Caroline|Hanover|Spotsylvania',
    county_weights: '{"51033": 93.91, "51085": 4.58, "51177": 1.51}',
    density: 43.3,
    imprecise: false,
    latitude: 37.94342,
    longitude: -77.44565,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22546',
  },
  {
    city: 'Sharps',
    county_fips: 51159,
    county_fips_all: '51159',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"51159": 100}',
    density: 44.7,
    imprecise: false,
    latitude: 37.82929,
    longitude: -76.69256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22548',
  },
  {
    city: 'Spotsylvania',
    county_fips: 51177,
    county_fips_all: '51177|51137',
    county: 'Spotsylvania',
    county_names_all: 'Spotsylvania|Orange',
    county_weights: '{"51177": 99.22, "51137": 0.78}',
    density: 55.4,
    imprecise: false,
    latitude: 38.17273,
    longitude: -77.70575,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22551',
  },
  {
    city: 'Spotsylvania',
    county_fips: 51177,
    county_fips_all: '51177',
    county: 'Spotsylvania',
    county_names_all: 'Spotsylvania',
    county_weights: '{"51177": 100}',
    density: 152.5,
    imprecise: false,
    latitude: 38.26594,
    longitude: -77.6397,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22553',
  },
  {
    city: 'Stafford',
    county_fips: 51179,
    county_fips_all: '51179',
    county: 'Stafford',
    county_names_all: 'Stafford',
    county_weights: '{"51179": 100}',
    density: 394.4,
    imprecise: false,
    latitude: 38.42285,
    longitude: -77.3835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22554',
  },
  {
    city: 'Stafford',
    county_fips: 51179,
    county_fips_all: '51179|51061',
    county: 'Stafford',
    county_names_all: 'Stafford|Fauquier',
    county_weights: '{"51179": 99.18, "51061": 0.82}',
    density: 264.8,
    imprecise: false,
    latitude: 38.48624,
    longitude: -77.513,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22556',
  },
  {
    city: 'Tappahannock',
    county_fips: 51057,
    county_fips_all: '51057|51097',
    county: 'Essex',
    county_names_all: 'Essex|King and Queen',
    county_weights: '{"51057": 88.72, "51097": 11.28}',
    density: 25.8,
    imprecise: false,
    latitude: 37.91289,
    longitude: -76.96196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22560',
  },
  {
    city: 'Unionville',
    county_fips: 51137,
    county_fips_all: '51137|51177',
    county: 'Orange',
    county_names_all: 'Orange|Spotsylvania',
    county_weights: '{"51137": 98.85, "51177": 1.15}',
    density: 23.2,
    imprecise: false,
    latitude: 38.23395,
    longitude: -77.92401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22567',
  },
  {
    city: 'Warsaw',
    county_fips: 51159,
    county_fips_all: '51159|51193',
    county: 'Richmond',
    county_names_all: 'Richmond|Westmoreland',
    county_weights: '{"51159": 91.47, "51193": 8.53}',
    density: 18.1,
    imprecise: false,
    latitude: 37.97552,
    longitude: -76.77495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22572',
  },
  {
    city: 'Weems',
    county_fips: 51103,
    county_fips_all: '51103',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"51103": 100}',
    density: 44.6,
    imprecise: false,
    latitude: 37.69398,
    longitude: -76.43277,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22576',
  },
  {
    city: 'White Stone',
    county_fips: 51103,
    county_fips_all: '51103',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"51103": 100}',
    density: 48.6,
    imprecise: false,
    latitude: 37.65063,
    longitude: -76.36268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22578',
  },
  {
    city: 'Woodford',
    county_fips: 51033,
    county_fips_all: '51033|51177',
    county: 'Caroline',
    county_names_all: 'Caroline|Spotsylvania',
    county_weights: '{"51033": 89.92, "51177": 10.08}',
    density: 20.8,
    imprecise: false,
    latitude: 38.10941,
    longitude: -77.44419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22580',
  },
  {
    city: 'Winchester',
    county_fips: 51840,
    county_fips_all: '51840|51069',
    county: 'Winchester',
    county_names_all: 'Winchester|Frederick',
    county_weights: '{"51840": 93.99, "51069": 6.01}',
    density: 1154.6,
    imprecise: false,
    latitude: 39.1743,
    longitude: -78.1743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22601',
  },
  {
    city: 'Winchester',
    county_fips: 51069,
    county_fips_all: '51069',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"51069": 100}',
    density: 111.8,
    imprecise: false,
    latitude: 39.1508,
    longitude: -78.26555,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22602',
  },
  {
    city: 'Winchester',
    county_fips: 51069,
    county_fips_all: '51069',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"51069": 100}',
    density: 67.1,
    imprecise: false,
    latitude: 39.28153,
    longitude: -78.2056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22603',
  },
  {
    city: 'Bentonville',
    county_fips: 51187,
    county_fips_all: '51187',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"51187": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 38.81803,
    longitude: -78.28102,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22610',
  },
  {
    city: 'Berryville',
    county_fips: 51043,
    county_fips_all: '51043',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"51043": 100}',
    density: 43.2,
    imprecise: false,
    latitude: 39.16374,
    longitude: -77.98512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22611',
  },
  {
    city: 'Boyce',
    county_fips: 51043,
    county_fips_all: '51043',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"51043": 100}',
    density: 23.9,
    imprecise: false,
    latitude: 39.06417,
    longitude: -78.03317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22620',
  },
  {
    city: 'Chester Gap',
    county_fips: 51157,
    county_fips_all: '51157',
    county: 'Rappahannock',
    county_names_all: 'Rappahannock',
    county_weights: '{"51157": 100}',
    density: 206.4,
    imprecise: false,
    latitude: 38.85158,
    longitude: -78.13734,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22623',
  },
  {
    city: 'Clear Brook',
    county_fips: 51069,
    county_fips_all: '51069',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"51069": 100}',
    density: 64.3,
    imprecise: false,
    latitude: 39.26535,
    longitude: -78.09507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22624',
  },
  {
    city: 'Cross Junction',
    county_fips: 51069,
    county_fips_all: '51069',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"51069": 100}',
    density: 30.9,
    imprecise: false,
    latitude: 39.37397,
    longitude: -78.31172,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22625',
  },
  {
    city: 'Flint Hill',
    county_fips: 51157,
    county_fips_all: '51157',
    county: 'Rappahannock',
    county_names_all: 'Rappahannock',
    county_weights: '{"51157": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 38.76554,
    longitude: -78.11371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22627',
  },
  {
    city: 'Front Royal',
    county_fips: 51187,
    county_fips_all: '51187|51069|51043|51061',
    county: 'Warren',
    county_names_all: 'Warren|Frederick|Clarke|Fauquier',
    county_weights:
      '{"51187": 97.55, "51069": 1.63, "51043": 0.63, "51061": 0.19}',
    density: 112.8,
    imprecise: false,
    latitude: 38.92909,
    longitude: -78.18052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22630',
  },
  {
    city: 'Gore',
    county_fips: 51069,
    county_fips_all: '51069',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"51069": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 39.25057,
    longitude: -78.3605,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22637',
  },
  {
    city: 'Hume',
    county_fips: 51061,
    county_fips_all: '51061',
    county: 'Fauquier',
    county_names_all: 'Fauquier',
    county_weights: '{"51061": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 38.82625,
    longitude: -78.0321,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22639',
  },
  {
    city: 'Huntly',
    county_fips: 51157,
    county_fips_all: '51157',
    county: 'Rappahannock',
    county_names_all: 'Rappahannock',
    county_weights: '{"51157": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 38.80737,
    longitude: -78.13302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22640',
  },
  {
    city: 'Strasburg',
    county_fips: 51171,
    county_fips_all: '51171|51069',
    county: 'Shenandoah',
    county_names_all: 'Shenandoah|Frederick',
    county_weights: '{"51171": 99.85, "51069": 0.15}',
    density: 13.2,
    imprecise: false,
    latitude: 39.07795,
    longitude: -78.38588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22641',
  },
  {
    city: 'Linden',
    county_fips: 51187,
    county_fips_all: '51187|51061',
    county: 'Warren',
    county_names_all: 'Warren|Fauquier',
    county_weights: '{"51187": 52.12, "51061": 47.88}',
    density: 53.5,
    imprecise: false,
    latitude: 38.91532,
    longitude: -78.06538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22642',
  },
  {
    city: 'Markham',
    county_fips: 51061,
    county_fips_all: '51061',
    county: 'Fauquier',
    county_names_all: 'Fauquier',
    county_weights: '{"51061": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 38.9034,
    longitude: -78.00801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22643',
  },
  {
    city: 'Maurertown',
    county_fips: 51171,
    county_fips_all: '51171',
    county: 'Shenandoah',
    county_names_all: 'Shenandoah',
    county_weights: '{"51171": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 38.96362,
    longitude: -78.5314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22644',
  },
  {
    city: 'Middletown',
    county_fips: 51069,
    county_fips_all: '51069|51187',
    county: 'Frederick',
    county_names_all: 'Frederick|Warren',
    county_weights: '{"51069": 56.83, "51187": 43.17}',
    density: 49.2,
    imprecise: false,
    latitude: 39.02152,
    longitude: -78.27457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22645',
  },
  {
    city: 'Millwood',
    county_fips: 51043,
    county_fips_all: '51043',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"51043": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.07019,
    longitude: -78.04803,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22646',
  },
  {
    city: 'Rileyville',
    county_fips: 51139,
    county_fips_all: '51139',
    county: 'Page',
    county_names_all: 'Page',
    county_weights: '{"51139": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 38.75893,
    longitude: -78.35817,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22650',
  },
  {
    city: 'Fort Valley',
    county_fips: 51171,
    county_fips_all: '51171',
    county: 'Shenandoah',
    county_names_all: 'Shenandoah',
    county_weights: '{"51171": 100}',
    density: 9,
    imprecise: false,
    latitude: 38.83921,
    longitude: -78.42894,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22652',
  },
  {
    city: 'Star Tannery',
    county_fips: 51069,
    county_fips_all: '51069|51171',
    county: 'Frederick',
    county_names_all: 'Frederick|Shenandoah',
    county_weights: '{"51069": 68.19, "51171": 31.81}',
    density: 9.7,
    imprecise: false,
    latitude: 39.06863,
    longitude: -78.4586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22654',
  },
  {
    city: 'Stephens City',
    county_fips: 51069,
    county_fips_all: '51069|51187',
    county: 'Frederick',
    county_names_all: 'Frederick|Warren',
    county_weights: '{"51069": 91.59, "51187": 8.41}',
    density: 247.2,
    imprecise: false,
    latitude: 39.06443,
    longitude: -78.21425,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22655',
  },
  {
    city: 'Stephenson',
    county_fips: 51069,
    county_fips_all: '51069',
    county: 'Frederick',
    county_names_all: 'Frederick',
    county_weights: '{"51069": 100}',
    density: 235.5,
    imprecise: false,
    latitude: 39.21723,
    longitude: -78.08901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22656',
  },
  {
    city: 'Strasburg',
    county_fips: 51171,
    county_fips_all: '51171|51187',
    county: 'Shenandoah',
    county_names_all: 'Shenandoah|Warren',
    county_weights: '{"51171": 85.87, "51187": 14.13}',
    density: 80.7,
    imprecise: false,
    latitude: 39.00155,
    longitude: -78.36755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22657',
  },
  {
    city: 'Toms Brook',
    county_fips: 51171,
    county_fips_all: '51171',
    county: 'Shenandoah',
    county_names_all: 'Shenandoah',
    county_weights: '{"51171": 100}',
    density: 47.4,
    imprecise: false,
    latitude: 38.95628,
    longitude: -78.4383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22660',
  },
  {
    city: 'White Post',
    county_fips: 51043,
    county_fips_all: '51043|51069|51187',
    county: 'Clarke',
    county_names_all: 'Clarke|Frederick|Warren',
    county_weights: '{"51043": 75.31, "51069": 16.11, "51187": 8.58}',
    density: 30.6,
    imprecise: false,
    latitude: 39.05,
    longitude: -78.11716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22663',
  },
  {
    city: 'Woodstock',
    county_fips: 51171,
    county_fips_all: '51171',
    county: 'Shenandoah',
    county_names_all: 'Shenandoah',
    county_weights: '{"51171": 100}',
    density: 79.1,
    imprecise: false,
    latitude: 38.8944,
    longitude: -78.53119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22664',
  },
  {
    city: 'Culpeper',
    county_fips: 51047,
    county_fips_all: '51047|51137|51113',
    county: 'Culpeper',
    county_names_all: 'Culpeper|Orange|Madison',
    county_weights: '{"51047": 78.54, "51137": 14.26, "51113": 7.2}',
    density: 86.3,
    imprecise: false,
    latitude: 38.44038,
    longitude: -77.99633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22701',
  },
  {
    city: 'Aroda',
    county_fips: 51113,
    county_fips_all: '51113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"51113": 100}',
    density: 30.3,
    imprecise: false,
    latitude: 38.32769,
    longitude: -78.21732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22709',
  },
  {
    city: 'Banco',
    county_fips: 51113,
    county_fips_all: '51113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"51113": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 38.46239,
    longitude: -78.27634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22711',
  },
  {
    city: 'Bealeton',
    county_fips: 51061,
    county_fips_all: '51061',
    county: 'Fauquier',
    county_names_all: 'Fauquier',
    county_weights: '{"51061": 100}',
    density: 101.1,
    imprecise: false,
    latitude: 38.55632,
    longitude: -77.75884,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22712',
  },
  {
    city: 'Boston',
    county_fips: 51047,
    county_fips_all: '51047|51157',
    county: 'Culpeper',
    county_names_all: 'Culpeper|Rappahannock',
    county_weights: '{"51047": 67.95, "51157": 32.05}',
    density: 25.8,
    imprecise: false,
    latitude: 38.54123,
    longitude: -78.13204,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22713',
  },
  {
    city: 'Brandy Station',
    county_fips: 51047,
    county_fips_all: '51047',
    county: 'Culpeper',
    county_names_all: 'Culpeper',
    county_weights: '{"51047": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 38.52068,
    longitude: -77.89363,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22714',
  },
  {
    city: 'Brightwood',
    county_fips: 51113,
    county_fips_all: '51113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"51113": 100}',
    density: 83,
    imprecise: false,
    latitude: 38.41032,
    longitude: -78.18541,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22715',
  },
  {
    city: 'Castleton',
    county_fips: 51157,
    county_fips_all: '51157|51047',
    county: 'Rappahannock',
    county_names_all: 'Rappahannock|Culpeper',
    county_weights: '{"51157": 97.1, "51047": 2.9}',
    density: 18.3,
    imprecise: false,
    latitude: 38.62596,
    longitude: -78.10794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22716',
  },
  {
    city: 'Elkwood',
    county_fips: 51047,
    county_fips_all: '51047',
    county: 'Culpeper',
    county_names_all: 'Culpeper',
    county_weights: '{"51047": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 38.47076,
    longitude: -77.82026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22718',
  },
  {
    city: 'Etlan',
    county_fips: 51113,
    county_fips_all: '51113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"51113": 100}',
    density: 7,
    imprecise: false,
    latitude: 38.52888,
    longitude: -78.28337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22719',
  },
  {
    city: 'Goldvein',
    county_fips: 51061,
    county_fips_all: '51061',
    county: 'Fauquier',
    county_names_all: 'Fauquier',
    county_weights: '{"51061": 100}',
    density: 41.8,
    imprecise: false,
    latitude: 38.48044,
    longitude: -77.6468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22720',
  },
  {
    city: 'Haywood',
    county_fips: 51113,
    county_fips_all: '51113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"51113": 100}',
    density: 66.1,
    imprecise: false,
    latitude: 38.46304,
    longitude: -78.22645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22722',
  },
  {
    city: 'Hood',
    county_fips: 51113,
    county_fips_all: '51113|51079',
    county: 'Madison',
    county_names_all: 'Madison|Greene',
    county_weights: '{"51113": 99.86, "51079": 0.14}',
    density: 5.3,
    imprecise: false,
    latitude: 38.33789,
    longitude: -78.38821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22723',
  },
  {
    city: 'Jeffersonton',
    county_fips: 51047,
    county_fips_all: '51047',
    county: 'Culpeper',
    county_names_all: 'Culpeper',
    county_weights: '{"51047": 100}',
    density: 59.1,
    imprecise: false,
    latitude: 38.63286,
    longitude: -77.90752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22724',
  },
  {
    city: 'Leon',
    county_fips: 51113,
    county_fips_all: '51113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"51113": 100}',
    density: 52.8,
    imprecise: false,
    latitude: 38.44029,
    longitude: -78.1527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22725',
  },
  {
    city: 'Lignum',
    county_fips: 51047,
    county_fips_all: '51047',
    county: 'Culpeper',
    county_names_all: 'Culpeper',
    county_weights: '{"51047": 100}',
    density: 15,
    imprecise: false,
    latitude: 38.40179,
    longitude: -77.81796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22726',
  },
  {
    city: 'Madison',
    county_fips: 51113,
    county_fips_all: '51113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"51113": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 38.39626,
    longitude: -78.30058,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22727',
  },
  {
    city: 'Midland',
    county_fips: 51061,
    county_fips_all: '51061',
    county: 'Fauquier',
    county_names_all: 'Fauquier',
    county_weights: '{"51061": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 38.57773,
    longitude: -77.68639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22728',
  },
  {
    city: 'Mitchells',
    county_fips: 51047,
    county_fips_all: '51047',
    county: 'Culpeper',
    county_names_all: 'Culpeper',
    county_weights: '{"51047": 100}',
    density: 43.3,
    imprecise: false,
    latitude: 38.35658,
    longitude: -78.01596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22729',
  },
  {
    city: 'Oakpark',
    county_fips: 51113,
    county_fips_all: '51113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"51113": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 38.36782,
    longitude: -78.16635,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22730',
  },
  {
    city: 'Pratts',
    county_fips: 51113,
    county_fips_all: '51113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"51113": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 38.34413,
    longitude: -78.26151,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22731',
  },
  {
    city: 'Radiant',
    county_fips: 51113,
    county_fips_all: '51113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"51113": 100}',
    density: 25.3,
    imprecise: false,
    latitude: 38.30886,
    longitude: -78.19153,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22732',
  },
  {
    city: 'Rapidan',
    county_fips: 51047,
    county_fips_all: '51047|51137|51113',
    county: 'Culpeper',
    county_names_all: 'Culpeper|Orange|Madison',
    county_weights: '{"51047": 50.35, "51137": 47.53, "51113": 2.12}',
    density: 14.8,
    imprecise: false,
    latitude: 38.33191,
    longitude: -78.0467,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22733',
  },
  {
    city: 'Remington',
    county_fips: 51061,
    county_fips_all: '51061|51047',
    county: 'Fauquier',
    county_names_all: 'Fauquier|Culpeper',
    county_weights: '{"51061": 65.31, "51047": 34.69}',
    density: 42.3,
    imprecise: false,
    latitude: 38.52757,
    longitude: -77.81119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22734',
  },
  {
    city: 'Reva',
    county_fips: 51113,
    county_fips_all: '51113|51047',
    county: 'Madison',
    county_names_all: 'Madison|Culpeper',
    county_weights: '{"51113": 62.84, "51047": 37.16}',
    density: 19.7,
    imprecise: false,
    latitude: 38.47941,
    longitude: -78.18336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22735',
  },
  {
    city: 'Richardsville',
    county_fips: 51047,
    county_fips_all: '51047',
    county: 'Culpeper',
    county_names_all: 'Culpeper',
    county_weights: '{"51047": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 38.39633,
    longitude: -77.69673,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22736',
  },
  {
    city: 'Rixeyville',
    county_fips: 51047,
    county_fips_all: '51047',
    county: 'Culpeper',
    county_names_all: 'Culpeper',
    county_weights: '{"51047": 100}',
    density: 32.3,
    imprecise: false,
    latitude: 38.59024,
    longitude: -78.00205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22737',
  },
  {
    city: 'Rochelle',
    county_fips: 51113,
    county_fips_all: '51113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"51113": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 38.28692,
    longitude: -78.27685,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22738',
  },
  {
    city: 'Sperryville',
    county_fips: 51157,
    county_fips_all: '51157|51047|51113',
    county: 'Rappahannock',
    county_names_all: 'Rappahannock|Culpeper|Madison',
    county_weights: '{"51157": 93.77, "51047": 4.28, "51113": 1.95}',
    density: 6.2,
    imprecise: false,
    latitude: 38.63805,
    longitude: -78.26163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22740',
  },
  {
    city: 'Stevensburg',
    county_fips: 51047,
    county_fips_all: '51047',
    county: 'Culpeper',
    county_names_all: 'Culpeper',
    county_weights: '{"51047": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 38.44541,
    longitude: -77.86819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22741',
  },
  {
    city: 'Sumerduck',
    county_fips: 51061,
    county_fips_all: '51061',
    county: 'Fauquier',
    county_names_all: 'Fauquier',
    county_weights: '{"51061": 100}',
    density: 30.9,
    imprecise: false,
    latitude: 38.4589,
    longitude: -77.71179,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22742',
  },
  {
    city: 'Syria',
    county_fips: 51113,
    county_fips_all: '51113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"51113": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 38.52477,
    longitude: -78.37132,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22743',
  },
  {
    city: 'Washington',
    county_fips: 51157,
    county_fips_all: '51157',
    county: 'Rappahannock',
    county_names_all: 'Rappahannock',
    county_weights: '{"51157": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 38.7122,
    longitude: -78.16768,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22747',
  },
  {
    city: 'Woodville',
    county_fips: 51157,
    county_fips_all: '51157',
    county: 'Rappahannock',
    county_names_all: 'Rappahannock',
    county_weights: '{"51157": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 38.61945,
    longitude: -78.18394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22749',
  },
  {
    city: 'Harrisonburg',
    county_fips: 51165,
    county_fips_all: '51165|51660',
    county: 'Rockingham',
    county_names_all: 'Rockingham|Harrisonburg',
    county_weights: '{"51165": 68.84, "51660": 31.16}',
    density: 455.1,
    imprecise: false,
    latitude: 38.40519,
    longitude: -78.87931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22801',
  },
  {
    city: 'Harrisonburg',
    county_fips: 51165,
    county_fips_all: '51165|51660',
    county: 'Rockingham',
    county_names_all: 'Rockingham|Harrisonburg',
    county_weights: '{"51165": 93.3, "51660": 6.7}',
    density: 128.9,
    imprecise: false,
    latitude: 38.50016,
    longitude: -78.8585,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22802',
  },
  {
    city: 'Basye',
    county_fips: 51171,
    county_fips_all: '51171',
    county: 'Shenandoah',
    county_names_all: 'Shenandoah',
    county_weights: '{"51171": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 38.84466,
    longitude: -78.78554,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22810',
  },
  {
    city: 'Bergton',
    county_fips: 51165,
    county_fips_all: '51165',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"51165": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 38.79264,
    longitude: -78.9757,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22811',
  },
  {
    city: 'Bridgewater',
    county_fips: 51165,
    county_fips_all: '51165|51015',
    county: 'Rockingham',
    county_names_all: 'Rockingham|Augusta',
    county_weights: '{"51165": 59.26, "51015": 40.74}',
    density: 82.7,
    imprecise: false,
    latitude: 38.37934,
    longitude: -79.03836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22812',
  },
  {
    city: 'Broadway',
    county_fips: 51165,
    county_fips_all: '51165|51171',
    county: 'Rockingham',
    county_names_all: 'Rockingham|Shenandoah',
    county_weights: '{"51165": 96.96, "51171": 3.04}',
    density: 46.1,
    imprecise: false,
    latitude: 38.63469,
    longitude: -78.80939,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22815',
  },
  {
    city: 'Criders',
    county_fips: 51165,
    county_fips_all: '51165',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"51165": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 38.74387,
    longitude: -79.00948,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22820',
  },
  {
    city: 'Dayton',
    county_fips: 51165,
    county_fips_all: '51165',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"51165": 100}',
    density: 32.6,
    imprecise: false,
    latitude: 38.46349,
    longitude: -79.0743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22821',
  },
  {
    city: 'Edinburg',
    county_fips: 51171,
    county_fips_all: '51171',
    county: 'Shenandoah',
    county_names_all: 'Shenandoah',
    county_weights: '{"51171": 100}',
    density: 29.8,
    imprecise: false,
    latitude: 38.84743,
    longitude: -78.6278,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22824',
  },
  {
    city: 'Elkton',
    county_fips: 51165,
    county_fips_all: '51165|51139',
    county: 'Rockingham',
    county_names_all: 'Rockingham|Page',
    county_weights: '{"51165": 77.75, "51139": 22.25}',
    density: 25.6,
    imprecise: false,
    latitude: 38.3903,
    longitude: -78.6131,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22827',
  },
  {
    city: 'Fulks Run',
    county_fips: 51165,
    county_fips_all: '51165',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"51165": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 38.65789,
    longitude: -78.97902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22830',
  },
  {
    city: 'Hinton',
    county_fips: 51165,
    county_fips_all: '51165',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"51165": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 38.56395,
    longitude: -79.10005,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22831',
  },
  {
    city: 'Keezletown',
    county_fips: 51165,
    county_fips_all: '51165',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"51165": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 38.45778,
    longitude: -78.75692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22832',
  },
  {
    city: 'Linville',
    county_fips: 51165,
    county_fips_all: '51165',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"51165": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 38.55709,
    longitude: -78.85769,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22834',
  },
  {
    city: 'Luray',
    county_fips: 51139,
    county_fips_all: '51139',
    county: 'Page',
    county_names_all: 'Page',
    county_weights: '{"51139": 100}',
    density: 29.2,
    imprecise: false,
    latitude: 38.67199,
    longitude: -78.4548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22835',
  },
  {
    city: 'McGaheysville',
    county_fips: 51165,
    county_fips_all: '51165',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"51165": 100}',
    density: 64.4,
    imprecise: false,
    latitude: 38.38642,
    longitude: -78.73845,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22840',
  },
  {
    city: 'Mount Crawford',
    county_fips: 51165,
    county_fips_all: '51165|51015',
    county: 'Rockingham',
    county_names_all: 'Rockingham|Augusta',
    county_weights: '{"51165": 98.12, "51015": 1.88}',
    density: 39.7,
    imprecise: false,
    latitude: 38.33887,
    longitude: -78.89417,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22841',
  },
  {
    city: 'Mount Jackson',
    county_fips: 51171,
    county_fips_all: '51171',
    county: 'Shenandoah',
    county_names_all: 'Shenandoah',
    county_weights: '{"51171": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 38.77191,
    longitude: -78.6992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22842',
  },
  {
    city: 'Mount Solon',
    county_fips: 51015,
    county_fips_all: '51015',
    county: 'Augusta',
    county_names_all: 'Augusta',
    county_weights: '{"51015": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 38.36703,
    longitude: -79.16053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22843',
  },
  {
    city: 'New Market',
    county_fips: 51171,
    county_fips_all: '51171|51165',
    county: 'Shenandoah',
    county_names_all: 'Shenandoah|Rockingham',
    county_weights: '{"51171": 80.82, "51165": 19.18}',
    density: 36.4,
    imprecise: false,
    latitude: 38.65886,
    longitude: -78.66038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22844',
  },
  {
    city: 'Orkney Springs',
    county_fips: 51171,
    county_fips_all: '51171|51165',
    county: 'Shenandoah',
    county_names_all: 'Shenandoah|Rockingham',
    county_weights: '{"51171": 99.65, "51165": 0.35}',
    density: 2.8,
    imprecise: false,
    latitude: 38.77991,
    longitude: -78.8375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22845',
  },
  {
    city: 'Penn Laird',
    county_fips: 51165,
    county_fips_all: '51165',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"51165": 100}',
    density: 51.9,
    imprecise: false,
    latitude: 38.38791,
    longitude: -78.79239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22846',
  },
  {
    city: 'Quicksburg',
    county_fips: 51171,
    county_fips_all: '51171',
    county: 'Shenandoah',
    county_names_all: 'Shenandoah',
    county_weights: '{"51171": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 38.71792,
    longitude: -78.70972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22847',
  },
  {
    city: 'Shenandoah',
    county_fips: 51139,
    county_fips_all: '51139|51165',
    county: 'Page',
    county_names_all: 'Page|Rockingham',
    county_weights: '{"51139": 87.96, "51165": 12.04}',
    density: 43.3,
    imprecise: false,
    latitude: 38.5256,
    longitude: -78.6253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22849',
  },
  {
    city: 'Singers Glen',
    county_fips: 51165,
    county_fips_all: '51165',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"51165": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 38.56668,
    longitude: -78.92048,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22850',
  },
  {
    city: 'Stanley',
    county_fips: 51139,
    county_fips_all: '51139',
    county: 'Page',
    county_names_all: 'Page',
    county_weights: '{"51139": 100}',
    density: 41.4,
    imprecise: false,
    latitude: 38.56061,
    longitude: -78.51061,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22851',
  },
  {
    city: 'Timberville',
    county_fips: 51165,
    county_fips_all: '51165|51171',
    county: 'Rockingham',
    county_names_all: 'Rockingham|Shenandoah',
    county_weights: '{"51165": 91.5, "51171": 8.5}',
    density: 51.6,
    imprecise: false,
    latitude: 38.65156,
    longitude: -78.76406,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22853',
  },
  {
    city: 'Charlottesville',
    county_fips: 51003,
    county_fips_all: '51003|51540',
    county: 'Albemarle',
    county_names_all: 'Albemarle|Charlottesville',
    county_weights: '{"51003": 94.72, "51540": 5.28}',
    density: 275.6,
    imprecise: false,
    latitude: 38.08874,
    longitude: -78.55569,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22901',
  },
  {
    city: 'Charlottesville',
    county_fips: 51003,
    county_fips_all: '51003|51540|51065',
    county: 'Albemarle',
    county_names_all: 'Albemarle|Charlottesville|Fluvanna',
    county_weights: '{"51003": 94.39, "51540": 4.26, "51065": 1.35}',
    density: 141,
    imprecise: false,
    latitude: 37.95566,
    longitude: -78.46883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22902',
  },
  {
    city: 'Charlottesville',
    county_fips: 51003,
    county_fips_all: '51003|51540',
    county: 'Albemarle',
    county_names_all: 'Albemarle|Charlottesville',
    county_weights: '{"51003": 93.31, "51540": 6.69}',
    density: 225.9,
    imprecise: false,
    latitude: 38.01239,
    longitude: -78.60159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22903',
  },
  {
    city: 'Charlottesville',
    county_fips: 51003,
    county_fips_all: '51003',
    county: 'Albemarle',
    county_names_all: 'Albemarle',
    county_weights: '{"51003": 100}',
    density: 143.6,
    imprecise: false,
    latitude: 38.09522,
    longitude: -78.4078,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22911',
  },
  {
    city: 'Afton',
    county_fips: 51125,
    county_fips_all: '51125|51003|51015',
    county: 'Nelson',
    county_names_all: 'Nelson|Albemarle|Augusta',
    county_weights: '{"51125": 58.21, "51003": 37.02, "51015": 4.77}',
    density: 18,
    imprecise: false,
    latitude: 37.97294,
    longitude: -78.81276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22920',
  },
  {
    city: 'Arrington',
    county_fips: 51125,
    county_fips_all: '51125|51009',
    county: 'Nelson',
    county_names_all: 'Nelson|Amherst',
    county_weights: '{"51125": 94.7, "51009": 5.3}',
    density: 18.5,
    imprecise: false,
    latitude: 37.68621,
    longitude: -78.92511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22922',
  },
  {
    city: 'Barboursville',
    county_fips: 51003,
    county_fips_all: '51003|51137|51079',
    county: 'Albemarle',
    county_names_all: 'Albemarle|Orange|Greene',
    county_weights: '{"51003": 43.13, "51137": 41.95, "51079": 14.91}',
    density: 52.4,
    imprecise: false,
    latitude: 38.18671,
    longitude: -78.32405,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22923',
  },
  {
    city: 'Covesville',
    county_fips: 51003,
    county_fips_all: '51003',
    county: 'Albemarle',
    county_names_all: 'Albemarle',
    county_weights: '{"51003": 100}',
    density: 4,
    imprecise: false,
    latitude: 37.90374,
    longitude: -78.71696,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22931',
  },
  {
    city: 'Crozet',
    county_fips: 51003,
    county_fips_all: '51003',
    county: 'Albemarle',
    county_names_all: 'Albemarle',
    county_weights: '{"51003": 100}',
    density: 34.8,
    imprecise: false,
    latitude: 38.15037,
    longitude: -78.69743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22932',
  },
  {
    city: 'Dyke',
    county_fips: 51079,
    county_fips_all: '51079|51003',
    county: 'Greene',
    county_names_all: 'Greene|Albemarle',
    county_weights: '{"51079": 62.49, "51003": 37.51}',
    density: 10,
    imprecise: false,
    latitude: 38.25785,
    longitude: -78.55474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22935',
  },
  {
    city: 'Earlysville',
    county_fips: 51003,
    county_fips_all: '51003',
    county: 'Albemarle',
    county_names_all: 'Albemarle',
    county_weights: '{"51003": 100}',
    density: 72.2,
    imprecise: false,
    latitude: 38.1671,
    longitude: -78.49974,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22936',
  },
  {
    city: 'Esmont',
    county_fips: 51003,
    county_fips_all: '51003',
    county: 'Albemarle',
    county_names_all: 'Albemarle',
    county_weights: '{"51003": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 37.81297,
    longitude: -78.60891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22937',
  },
  {
    city: 'Faber',
    county_fips: 51125,
    county_fips_all: '51125|51003',
    county: 'Nelson',
    county_names_all: 'Nelson|Albemarle',
    county_weights: '{"51125": 90.96, "51003": 9.04}',
    density: 9.4,
    imprecise: false,
    latitude: 37.86256,
    longitude: -78.78248,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22938',
  },
  {
    city: 'Fishersville',
    county_fips: 51015,
    county_fips_all: '51015',
    county: 'Augusta',
    county_names_all: 'Augusta',
    county_weights: '{"51015": 100}',
    density: 150.9,
    imprecise: false,
    latitude: 38.10575,
    longitude: -78.97288,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22939',
  },
  {
    city: 'Free Union',
    county_fips: 51003,
    county_fips_all: '51003|51079',
    county: 'Albemarle',
    county_names_all: 'Albemarle|Greene',
    county_weights: '{"51003": 75.55, "51079": 24.45}',
    density: 11.8,
    imprecise: false,
    latitude: 38.20559,
    longitude: -78.59705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22940',
  },
  {
    city: 'Gordonsville',
    county_fips: 51109,
    county_fips_all: '51109|51137|51003',
    county: 'Louisa',
    county_names_all: 'Louisa|Orange|Albemarle',
    county_weights: '{"51109": 52.08, "51137": 34.55, "51003": 13.37}',
    density: 34.6,
    imprecise: false,
    latitude: 38.10397,
    longitude: -78.19684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22942',
  },
  {
    city: 'Greenwood',
    county_fips: 51003,
    county_fips_all: '51003',
    county: 'Albemarle',
    county_names_all: 'Albemarle',
    county_weights: '{"51003": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 38.04508,
    longitude: -78.78369,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22943',
  },
  {
    city: 'Keene',
    county_fips: 51003,
    county_fips_all: '51003',
    county: 'Albemarle',
    county_names_all: 'Albemarle',
    county_weights: '{"51003": 100}',
    density: 40.1,
    imprecise: false,
    latitude: 37.84789,
    longitude: -78.56053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22946',
  },
  {
    city: 'Keswick',
    county_fips: 51003,
    county_fips_all: '51003|51109|51065',
    county: 'Albemarle',
    county_names_all: 'Albemarle|Louisa|Fluvanna',
    county_weights: '{"51003": 88.16, "51109": 6.57, "51065": 5.27}',
    density: 42,
    imprecise: false,
    latitude: 38.04326,
    longitude: -78.32624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22947',
  },
  {
    city: 'Locust Dale',
    county_fips: 51113,
    county_fips_all: '51113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"51113": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 38.35154,
    longitude: -78.12264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22948',
  },
  {
    city: 'Lovingston',
    county_fips: 51125,
    county_fips_all: '51125',
    county: 'Nelson',
    county_names_all: 'Nelson',
    county_weights: '{"51125": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 37.788,
    longitude: -78.88257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22949',
  },
  {
    city: 'Lyndhurst',
    county_fips: 51015,
    county_fips_all: '51015|51125',
    county: 'Augusta',
    county_names_all: 'Augusta|Nelson',
    county_weights: '{"51015": 98.83, "51125": 1.17}',
    density: 14.2,
    imprecise: false,
    latitude: 37.95836,
    longitude: -78.97136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22952',
  },
  {
    city: 'Montpelier Station',
    county_fips: 51137,
    county_fips_all: '51137',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"51137": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.22998,
    longitude: -78.1918,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22957',
  },
  {
    city: 'Nellysford',
    county_fips: 51125,
    county_fips_all: '51125|51015',
    county: 'Nelson',
    county_names_all: 'Nelson|Augusta',
    county_weights: '{"51125": 97.3, "51015": 2.7}',
    density: 31,
    imprecise: false,
    latitude: 37.8983,
    longitude: -78.89611,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22958',
  },
  {
    city: 'North Garden',
    county_fips: 51003,
    county_fips_all: '51003',
    county: 'Albemarle',
    county_names_all: 'Albemarle',
    county_weights: '{"51003": 100}',
    density: 16,
    imprecise: false,
    latitude: 37.93758,
    longitude: -78.64794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22959',
  },
  {
    city: 'Orange',
    county_fips: 51137,
    county_fips_all: '51137|51113|51177',
    county: 'Orange',
    county_names_all: 'Orange|Madison|Spotsylvania',
    county_weights: '{"51137": 79.84, "51113": 16.22, "51177": 3.94}',
    density: 36.9,
    imprecise: false,
    latitude: 38.21992,
    longitude: -78.06624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22960',
  },
  {
    city: 'Palmyra',
    county_fips: 51065,
    county_fips_all: '51065',
    county: 'Fluvanna',
    county_names_all: 'Fluvanna',
    county_weights: '{"51065": 100}',
    density: 52.3,
    imprecise: false,
    latitude: 37.84793,
    longitude: -78.28524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22963',
  },
  {
    city: 'Piney River',
    county_fips: 51125,
    county_fips_all: '51125',
    county: 'Nelson',
    county_names_all: 'Nelson',
    county_weights: '{"51125": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 37.71722,
    longitude: -78.98861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22964',
  },
  {
    city: 'Roseland',
    county_fips: 51125,
    county_fips_all: '51125|51009',
    county: 'Nelson',
    county_names_all: 'Nelson|Amherst',
    county_weights: '{"51125": 80.32, "51009": 19.68}',
    density: 9.6,
    imprecise: false,
    latitude: 37.79945,
    longitude: -79.0192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22967',
  },
  {
    city: 'Ruckersville',
    county_fips: 51079,
    county_fips_all: '51079|51003|51137',
    county: 'Greene',
    county_names_all: 'Greene|Albemarle|Orange',
    county_weights: '{"51079": 91.06, "51003": 7.29, "51137": 1.65}',
    density: 117,
    imprecise: false,
    latitude: 38.24111,
    longitude: -78.39407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22968',
  },
  {
    city: 'Schuyler',
    county_fips: 51125,
    county_fips_all: '51125|51003',
    county: 'Nelson',
    county_names_all: 'Nelson|Albemarle',
    county_weights: '{"51125": 53.39, "51003": 46.61}',
    density: 12.2,
    imprecise: false,
    latitude: 37.79699,
    longitude: -78.69367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22969',
  },
  {
    city: 'Shipman',
    county_fips: 51125,
    county_fips_all: '51125',
    county: 'Nelson',
    county_names_all: 'Nelson',
    county_weights: '{"51125": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 37.75019,
    longitude: -78.80299,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22971',
  },
  {
    city: 'Somerset',
    county_fips: 51137,
    county_fips_all: '51137|51113',
    county: 'Orange',
    county_names_all: 'Orange|Madison',
    county_weights: '{"51137": 95.24, "51113": 4.76}',
    density: 6.8,
    imprecise: false,
    latitude: 38.21746,
    longitude: -78.23451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22972',
  },
  {
    city: 'Stanardsville',
    county_fips: 51079,
    county_fips_all: '51079|51113',
    county: 'Greene',
    county_names_all: 'Greene|Madison',
    county_weights: '{"51079": 89.63, "51113": 10.37}',
    density: 23.5,
    imprecise: false,
    latitude: 38.33588,
    longitude: -78.46915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22973',
  },
  {
    city: 'Troy',
    county_fips: 51065,
    county_fips_all: '51065|51109|51003',
    county: 'Fluvanna',
    county_names_all: 'Fluvanna|Louisa|Albemarle',
    county_weights: '{"51065": 76.74, "51109": 14.8, "51003": 8.46}',
    density: 56.8,
    imprecise: false,
    latitude: 37.96207,
    longitude: -78.2753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22974',
  },
  {
    city: 'Tyro',
    county_fips: 51125,
    county_fips_all: '51125',
    county: 'Nelson',
    county_names_all: 'Nelson',
    county_weights: '{"51125": 100}',
    density: 3,
    imprecise: false,
    latitude: 37.84555,
    longitude: -79.04036,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22976',
  },
  {
    city: 'Waynesboro',
    county_fips: 51015,
    county_fips_all: '51015|51820',
    county: 'Augusta',
    county_names_all: 'Augusta|Waynesboro',
    county_weights: '{"51015": 79.86, "51820": 20.14}',
    density: 170.8,
    imprecise: false,
    latitude: 38.09588,
    longitude: -78.88585,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22980',
  },
  {
    city: 'Amelia Court House',
    county_fips: 51007,
    county_fips_all: '51007|51135',
    county: 'Amelia',
    county_names_all: 'Amelia|Nottoway',
    county_weights: '{"51007": 99.2, "51135": 0.8}',
    density: 16.4,
    imprecise: false,
    latitude: 37.34917,
    longitude: -77.96357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23002',
  },
  {
    city: 'Arvonia',
    county_fips: 51029,
    county_fips_all: '51029',
    county: 'Buckingham',
    county_names_all: 'Buckingham',
    county_weights: '{"51029": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 37.68307,
    longitude: -78.40567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23004',
  },
  {
    city: 'Ashland',
    county_fips: 51085,
    county_fips_all: '51085',
    county: 'Hanover',
    county_names_all: 'Hanover',
    county_weights: '{"51085": 100}',
    density: 111.4,
    imprecise: false,
    latitude: 37.75982,
    longitude: -77.4826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19987,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23005',
  },
  {
    city: 'Aylett',
    county_fips: 51101,
    county_fips_all: '51101',
    county: 'King William',
    county_names_all: 'King William',
    county_weights: '{"51101": 100}',
    density: 39.3,
    imprecise: false,
    latitude: 37.81038,
    longitude: -77.18717,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23009',
  },
  {
    city: 'Barhamsville',
    county_fips: 51127,
    county_fips_all: '51127|51095',
    county: 'New Kent',
    county_names_all: 'New Kent|James City',
    county_weights: '{"51127": 99.9, "51095": 0.1}',
    density: 31.3,
    imprecise: false,
    latitude: 37.47562,
    longitude: -76.80691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23011',
  },
  {
    city: 'Beaverdam',
    county_fips: 51085,
    county_fips_all: '51085|51177|51033|51109',
    county: 'Hanover',
    county_names_all: 'Hanover|Spotsylvania|Caroline|Louisa',
    county_weights:
      '{"51085": 76.89, "51177": 14.5, "51033": 7.68, "51109": 0.93}',
    density: 20.4,
    imprecise: false,
    latitude: 37.93127,
    longitude: -77.63124,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23015',
  },
  {
    city: 'Bohannon',
    county_fips: 51115,
    county_fips_all: '51115',
    county: 'Mathews',
    county_names_all: 'Mathews',
    county_weights: '{"51115": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 37.40102,
    longitude: -76.37187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23021',
  },
  {
    city: 'Bremo Bluff',
    county_fips: 51065,
    county_fips_all: '51065',
    county: 'Fluvanna',
    county_names_all: 'Fluvanna',
    county_weights: '{"51065": 100}',
    density: 15,
    imprecise: false,
    latitude: 37.7353,
    longitude: -78.26432,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23022',
  },
  {
    city: 'Bruington',
    county_fips: 51097,
    county_fips_all: '51097',
    county: 'King and Queen',
    county_names_all: 'King and Queen',
    county_weights: '{"51097": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 37.78293,
    longitude: -76.96586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23023',
  },
  {
    city: 'Bumpass',
    county_fips: 51109,
    county_fips_all: '51109|51177|51085',
    county: 'Louisa',
    county_names_all: 'Louisa|Spotsylvania|Hanover',
    county_weights: '{"51109": 80.4, "51177": 15.16, "51085": 4.44}',
    density: 40.2,
    imprecise: false,
    latitude: 37.92448,
    longitude: -77.77554,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23024',
  },
  {
    city: 'Cardinal',
    county_fips: 51115,
    county_fips_all: '51115',
    county: 'Mathews',
    county_names_all: 'Mathews',
    county_weights: '{"51115": 100}',
    density: 60.3,
    imprecise: false,
    latitude: 37.41447,
    longitude: -76.36204,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23025',
  },
  {
    city: 'Cartersville',
    county_fips: 51049,
    county_fips_all: '51049',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"51049": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 37.64551,
    longitude: -78.13183,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23027',
  },
  {
    city: 'Charles City',
    county_fips: 51036,
    county_fips_all: '51036|51087',
    county: 'Charles City',
    county_names_all: 'Charles City|Henrico',
    county_weights: '{"51036": 99.36, "51087": 0.64}',
    density: 11.6,
    imprecise: false,
    latitude: 37.34652,
    longitude: -77.05962,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23030',
  },
  {
    city: 'Church View',
    county_fips: 51119,
    county_fips_all: '51119',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"51119": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 37.65552,
    longitude: -76.68199,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23032',
  },
  {
    city: 'Cobbs Creek',
    county_fips: 51115,
    county_fips_all: '51115',
    county: 'Mathews',
    county_names_all: 'Mathews',
    county_weights: '{"51115": 100}',
    density: 53.2,
    imprecise: false,
    latitude: 37.49809,
    longitude: -76.37679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23035',
  },
  {
    city: 'Columbia',
    county_fips: 51075,
    county_fips_all: '51075|51049|51065',
    county: 'Goochland',
    county_names_all: 'Goochland|Cumberland|Fluvanna',
    county_weights: '{"51075": 40.87, "51049": 39.3, "51065": 19.83}',
    density: 7.6,
    imprecise: false,
    latitude: 37.75627,
    longitude: -78.14552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23038',
  },
  {
    city: 'Crozier',
    county_fips: 51075,
    county_fips_all: '51075',
    county: 'Goochland',
    county_names_all: 'Goochland',
    county_weights: '{"51075": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 37.65503,
    longitude: -77.80596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23039',
  },
  {
    city: 'Cumberland',
    county_fips: 51049,
    county_fips_all: '51049|51029',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Buckingham',
    county_weights: '{"51049": 90.52, "51029": 9.48}',
    density: 12.1,
    imprecise: false,
    latitude: 37.51017,
    longitude: -78.24919,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23040',
  },
  {
    city: 'Deltaville',
    county_fips: 51119,
    county_fips_all: '51119',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"51119": 100}',
    density: 92.3,
    imprecise: false,
    latitude: 37.55519,
    longitude: -76.34357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23043',
  },
  {
    city: 'Diggs',
    county_fips: 51115,
    county_fips_all: '51115',
    county: 'Mathews',
    county_names_all: 'Mathews',
    county_weights: '{"51115": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 37.42937,
    longitude: -76.27069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23045',
  },
  {
    city: 'Doswell',
    county_fips: 51085,
    county_fips_all: '51085|51033',
    county: 'Hanover',
    county_names_all: 'Hanover|Caroline',
    county_weights: '{"51085": 88.39, "51033": 11.61}',
    density: 12.4,
    imprecise: false,
    latitude: 37.84765,
    longitude: -77.48973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23047',
  },
  {
    city: 'Dutton',
    county_fips: 51115,
    county_fips_all: '51115|51073',
    county: 'Mathews',
    county_names_all: 'Mathews|Gloucester',
    county_weights: '{"51115": 93.23, "51073": 6.77}',
    density: 21.8,
    imprecise: false,
    latitude: 37.48918,
    longitude: -76.41986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23050',
  },
  {
    city: 'Fork Union',
    county_fips: 51065,
    county_fips_all: '51065',
    county: 'Fluvanna',
    county_names_all: 'Fluvanna',
    county_weights: '{"51065": 100}',
    density: 27.8,
    imprecise: false,
    latitude: 37.7706,
    longitude: -78.21852,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23055',
  },
  {
    city: 'Foster',
    county_fips: 51115,
    county_fips_all: '51115',
    county: 'Mathews',
    county_names_all: 'Mathews',
    county_weights: '{"51115": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 37.41809,
    longitude: -76.38724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23056',
  },
  {
    city: 'Glen Allen',
    county_fips: 51085,
    county_fips_all: '51085|51087|51075',
    county: 'Hanover',
    county_names_all: 'Hanover|Henrico|Goochland',
    county_weights: '{"51085": 59.08, "51087": 39.08, "51075": 1.84}',
    density: 358.2,
    imprecise: false,
    latitude: 37.70424,
    longitude: -77.56539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23059',
  },
  {
    city: 'Glen Allen',
    county_fips: 51087,
    county_fips_all: '51087',
    county: 'Henrico',
    county_names_all: 'Henrico',
    county_weights: '{"51087": 100}',
    density: 925.5,
    imprecise: false,
    latitude: 37.65981,
    longitude: -77.53427,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23060',
  },
  {
    city: 'Gloucester',
    county_fips: 51073,
    county_fips_all: '51073',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"51073": 100}',
    density: 56.9,
    imprecise: false,
    latitude: 37.4331,
    longitude: -76.55019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23061',
  },
  {
    city: 'Gloucester Point',
    county_fips: 51073,
    county_fips_all: '51073',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"51073": 100}',
    density: 436.1,
    imprecise: false,
    latitude: 37.258,
    longitude: -76.50404,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23062',
  },
  {
    city: 'Goochland',
    county_fips: 51075,
    county_fips_all: '51075',
    county: 'Goochland',
    county_names_all: 'Goochland',
    county_weights: '{"51075": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 37.71694,
    longitude: -77.99882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23063',
  },
  {
    city: 'Gum Spring',
    county_fips: 51075,
    county_fips_all: '51075|51109',
    county: 'Goochland',
    county_names_all: 'Goochland|Louisa',
    county_weights: '{"51075": 76.33, "51109": 23.67}',
    density: 29.4,
    imprecise: false,
    latitude: 37.8016,
    longitude: -77.92979,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23065',
  },
  {
    city: 'Gwynn',
    county_fips: 51115,
    county_fips_all: '51115',
    county: 'Mathews',
    county_names_all: 'Mathews',
    county_weights: '{"51115": 100}',
    density: 84.6,
    imprecise: false,
    latitude: 37.49836,
    longitude: -76.28831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23066',
  },
  {
    city: 'Hallieford',
    county_fips: 51115,
    county_fips_all: '51115',
    county: 'Mathews',
    county_names_all: 'Mathews',
    county_weights: '{"51115": 100}',
    density: 152.6,
    imprecise: false,
    latitude: 37.49511,
    longitude: -76.33727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23068',
  },
  {
    city: 'Hanover',
    county_fips: 51085,
    county_fips_all: '51085|51101|51033',
    county: 'Hanover',
    county_names_all: 'Hanover|King William|Caroline',
    county_weights: '{"51085": 41.69, "51101": 35.39, "51033": 22.92}',
    density: 19.1,
    imprecise: false,
    latitude: 37.76924,
    longitude: -77.32874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23069',
  },
  {
    city: 'Hardyville',
    county_fips: 51119,
    county_fips_all: '51119',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"51119": 100}',
    density: 75.2,
    imprecise: false,
    latitude: 37.55065,
    longitude: -76.38528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23070',
  },
  {
    city: 'Hartfield',
    county_fips: 51119,
    county_fips_all: '51119',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"51119": 100}',
    density: 59.5,
    imprecise: false,
    latitude: 37.54326,
    longitude: -76.45228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23071',
  },
  {
    city: 'Hayes',
    county_fips: 51073,
    county_fips_all: '51073',
    county: 'Gloucester',
    county_names_all: 'Gloucester',
    county_weights: '{"51073": 100}',
    density: 144.6,
    imprecise: false,
    latitude: 37.29543,
    longitude: -76.48148,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23072',
  },
  {
    city: 'Henrico',
    county_fips: 51087,
    county_fips_all: '51087',
    county: 'Henrico',
    county_names_all: 'Henrico',
    county_weights: '{"51087": 100}',
    density: 699.3,
    imprecise: false,
    latitude: 37.54938,
    longitude: -77.31591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23075',
  },
  {
    city: 'Hudgins',
    county_fips: 51115,
    county_fips_all: '51115',
    county: 'Mathews',
    county_names_all: 'Mathews',
    county_weights: '{"51115": 100}',
    density: 73.7,
    imprecise: false,
    latitude: 37.47328,
    longitude: -76.30499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23076',
  },
  {
    city: 'Jamaica',
    county_fips: 51119,
    county_fips_all: '51119',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"51119": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 37.7248,
    longitude: -76.68941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23079',
  },
  {
    city: 'Jetersville',
    county_fips: 51007,
    county_fips_all: '51007|51135',
    county: 'Amelia',
    county_names_all: 'Amelia|Nottoway',
    county_weights: '{"51007": 98.34, "51135": 1.66}',
    density: 13.8,
    imprecise: false,
    latitude: 37.31899,
    longitude: -78.11111,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23083',
  },
  {
    city: 'Kents Store',
    county_fips: 51065,
    county_fips_all: '51065|51075|51109',
    county: 'Fluvanna',
    county_names_all: 'Fluvanna|Goochland|Louisa',
    county_weights: '{"51065": 73.53, "51075": 19.39, "51109": 7.08}',
    density: 16.3,
    imprecise: false,
    latitude: 37.8864,
    longitude: -78.11162,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23084',
  },
  {
    city: 'King And Queen Court House',
    county_fips: 51097,
    county_fips_all: '51097',
    county: 'King and Queen',
    county_names_all: 'King and Queen',
    county_weights: '{"51097": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 37.70623,
    longitude: -76.84205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23085',
  },
  {
    city: 'King William',
    county_fips: 51101,
    county_fips_all: '51101',
    county: 'King William',
    county_names_all: 'King William',
    county_weights: '{"51101": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 37.66296,
    longitude: -77.05394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23086',
  },
  {
    city: 'Lanexa',
    county_fips: 51127,
    county_fips_all: '51127|51095',
    county: 'New Kent',
    county_names_all: 'New Kent|James City',
    county_weights: '{"51127": 87.35, "51095": 12.65}',
    density: 30.8,
    imprecise: false,
    latitude: 37.47593,
    longitude: -76.91212,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23089',
  },
  {
    city: 'Little Plymouth',
    county_fips: 51097,
    county_fips_all: '51097',
    county: 'King and Queen',
    county_names_all: 'King and Queen',
    county_weights: '{"51097": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 37.64647,
    longitude: -76.80167,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23091',
  },
  {
    city: 'Locust Hill',
    county_fips: 51119,
    county_fips_all: '51119',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"51119": 100}',
    density: 51.2,
    imprecise: false,
    latitude: 37.59402,
    longitude: -76.50755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23092',
  },
  {
    city: 'Louisa',
    county_fips: 51109,
    county_fips_all: '51109|51075|51065',
    county: 'Louisa',
    county_names_all: 'Louisa|Goochland|Fluvanna',
    county_weights: '{"51109": 94.97, "51075": 4.24, "51065": 0.79}',
    density: 27.8,
    imprecise: false,
    latitude: 38.00153,
    longitude: -78.03595,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23093',
  },
  {
    city: 'Maidens',
    county_fips: 51075,
    county_fips_all: '51075|51109|51085',
    county: 'Goochland',
    county_names_all: 'Goochland|Louisa|Hanover',
    county_weights: '{"51075": 76.03, "51109": 17.58, "51085": 6.39}',
    density: 50.7,
    imprecise: false,
    latitude: 37.71053,
    longitude: -77.83325,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23102',
  },
  {
    city: 'Manakin Sabot',
    county_fips: 51075,
    county_fips_all: '51075',
    county: 'Goochland',
    county_names_all: 'Goochland',
    county_weights: '{"51075": 100}',
    density: 69.6,
    imprecise: false,
    latitude: 37.6506,
    longitude: -77.72754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23103',
  },
  {
    city: 'Manquin',
    county_fips: 51101,
    county_fips_all: '51101',
    county: 'King William',
    county_names_all: 'King William',
    county_weights: '{"51101": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 37.71524,
    longitude: -77.2062,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23106',
  },
  {
    city: 'Mascot',
    county_fips: 51097,
    county_fips_all: '51097',
    county: 'King and Queen',
    county_names_all: 'King and Queen',
    county_weights: '{"51097": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 37.65523,
    longitude: -76.73015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23108',
  },
  {
    city: 'Mathews',
    county_fips: 51115,
    county_fips_all: '51115',
    county: 'Mathews',
    county_names_all: 'Mathews',
    county_weights: '{"51115": 100}',
    density: 44.3,
    imprecise: false,
    latitude: 37.43263,
    longitude: -76.32445,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23109',
  },
  {
    city: 'Mattaponi',
    county_fips: 51097,
    county_fips_all: '51097',
    county: 'King and Queen',
    county_names_all: 'King and Queen',
    county_weights: '{"51097": 100}',
    density: 14,
    imprecise: false,
    latitude: 37.58338,
    longitude: -76.76578,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23110',
  },
  {
    city: 'Mechanicsville',
    county_fips: 51085,
    county_fips_all: '51085',
    county: 'Hanover',
    county_names_all: 'Hanover',
    county_weights: '{"51085": 100}',
    density: 190.5,
    imprecise: false,
    latitude: 37.6112,
    longitude: -77.24697,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23111',
  },
  {
    city: 'Midlothian',
    county_fips: 51041,
    county_fips_all: '51041|51145',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield|Powhatan',
    county_weights: '{"51041": 99.28, "51145": 0.72}',
    density: 686.7,
    imprecise: false,
    latitude: 37.43738,
    longitude: -77.66394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23112',
  },
  {
    city: 'Midlothian',
    county_fips: 51041,
    county_fips_all: '51041|51145|51760',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield|Powhatan|Richmond',
    county_weights: '{"51041": 53.56, "51145": 46.34, "51760": 0.1}',
    density: 290.9,
    imprecise: false,
    latitude: 37.53935,
    longitude: -77.68093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23113',
  },
  {
    city: 'Midlothian',
    county_fips: 51041,
    county_fips_all: '51041',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield',
    county_weights: '{"51041": 100}',
    density: 688.1,
    imprecise: false,
    latitude: 37.48317,
    longitude: -77.66054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23114',
  },
  {
    city: 'Mechanicsville',
    county_fips: 51085,
    county_fips_all: '51085',
    county: 'Hanover',
    county_names_all: 'Hanover',
    county_weights: '{"51085": 100}',
    density: 240.1,
    imprecise: false,
    latitude: 37.67152,
    longitude: -77.33458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23116',
  },
  {
    city: 'Mineral',
    county_fips: 51109,
    county_fips_all: '51109|51177|51075',
    county: 'Louisa',
    county_names_all: 'Louisa|Spotsylvania|Goochland',
    county_weights: '{"51109": 88.45, "51177": 8.45, "51075": 3.1}',
    density: 28.3,
    imprecise: false,
    latitude: 37.97736,
    longitude: -77.87365,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23117',
  },
  {
    city: 'Moon',
    county_fips: 51115,
    county_fips_all: '51115',
    county: 'Mathews',
    county_names_all: 'Mathews',
    county_weights: '{"51115": 100}',
    density: 48.9,
    imprecise: false,
    latitude: 37.45139,
    longitude: -76.27978,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23119',
  },
  {
    city: 'Moseley',
    county_fips: 51041,
    county_fips_all: '51041|51145',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield|Powhatan',
    county_weights: '{"51041": 93.68, "51145": 6.32}',
    density: 107.5,
    imprecise: false,
    latitude: 37.40872,
    longitude: -77.78468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23120',
  },
  {
    city: 'New Canton',
    county_fips: 51029,
    county_fips_all: '51029|51049',
    county: 'Buckingham',
    county_names_all: 'Buckingham|Cumberland',
    county_weights: '{"51029": 91.74, "51049": 8.26}',
    density: 17.8,
    imprecise: false,
    latitude: 37.65238,
    longitude: -78.3031,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23123',
  },
  {
    city: 'New Kent',
    county_fips: 51127,
    county_fips_all: '51127',
    county: 'New Kent',
    county_names_all: 'New Kent',
    county_weights: '{"51127": 100}',
    density: 37.3,
    imprecise: false,
    latitude: 37.55271,
    longitude: -77.05949,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23124',
  },
  {
    city: 'Newtown',
    county_fips: 51097,
    county_fips_all: '51097',
    county: 'King and Queen',
    county_names_all: 'King and Queen',
    county_weights: '{"51097": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 37.92285,
    longitude: -77.1448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23126',
  },
  {
    city: 'North',
    county_fips: 51115,
    county_fips_all: '51115|51073',
    county: 'Mathews',
    county_names_all: 'Mathews|Gloucester',
    county_weights: '{"51115": 85.17, "51073": 14.83}',
    density: 16.6,
    imprecise: false,
    latitude: 37.4514,
    longitude: -76.43216,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23128',
  },
  {
    city: 'Oilville',
    county_fips: 51075,
    county_fips_all: '51075',
    county: 'Goochland',
    county_names_all: 'Goochland',
    county_weights: '{"51075": 100}',
    density: 29.4,
    imprecise: false,
    latitude: 37.705,
    longitude: -77.78261,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23129',
  },
  {
    city: 'Onemo',
    county_fips: 51115,
    county_fips_all: '51115',
    county: 'Mathews',
    county_names_all: 'Mathews',
    county_weights: '{"51115": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 37.39048,
    longitude: -76.26494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23130',
  },
  {
    city: 'Port Haywood',
    county_fips: 51115,
    county_fips_all: '51115',
    county: 'Mathews',
    county_names_all: 'Mathews',
    county_weights: '{"51115": 100}',
    density: 40.8,
    imprecise: false,
    latitude: 37.36245,
    longitude: -76.30062,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23138',
  },
  {
    city: 'Powhatan',
    county_fips: 51145,
    county_fips_all: '51145|51049',
    county: 'Powhatan',
    county_names_all: 'Powhatan|Cumberland',
    county_weights: '{"51145": 98.69, "51049": 1.31}',
    density: 44.6,
    imprecise: false,
    latitude: 37.54999,
    longitude: -77.93507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23139',
  },
  {
    city: 'Providence Forge',
    county_fips: 51127,
    county_fips_all: '51127|51036',
    county: 'New Kent',
    county_names_all: 'New Kent|Charles City',
    county_weights: '{"51127": 57.97, "51036": 42.03}',
    density: 41.4,
    imprecise: false,
    latitude: 37.43852,
    longitude: -77.04818,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23140',
  },
  {
    city: 'Quinton',
    county_fips: 51127,
    county_fips_all: '51127',
    county: 'New Kent',
    county_names_all: 'New Kent',
    county_weights: '{"51127": 100}',
    density: 85.8,
    imprecise: false,
    latitude: 37.53042,
    longitude: -77.15791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23141',
  },
  {
    city: 'Rockville',
    county_fips: 51085,
    county_fips_all: '51085|51075',
    county: 'Hanover',
    county_names_all: 'Hanover|Goochland',
    county_weights: '{"51085": 78.47, "51075": 21.53}',
    density: 41.3,
    imprecise: false,
    latitude: 37.7273,
    longitude: -77.70928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23146',
  },
  {
    city: 'Ruthville',
    county_fips: 51036,
    county_fips_all: '51036',
    county: 'Charles City',
    county_names_all: 'Charles City',
    county_weights: '{"51036": 100}',
    density: 153.2,
    imprecise: false,
    latitude: 37.36965,
    longitude: -77.0391,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23147',
  },
  {
    city: 'Saint Stephens Church',
    county_fips: 51097,
    county_fips_all: '51097|51057',
    county: 'King and Queen',
    county_names_all: 'King and Queen|Essex',
    county_weights: '{"51097": 93.46, "51057": 6.54}',
    density: 9.7,
    imprecise: false,
    latitude: 37.84262,
    longitude: -77.06223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23148',
  },
  {
    city: 'Saluda',
    county_fips: 51119,
    county_fips_all: '51119|51073|51097',
    county: 'Middlesex',
    county_names_all: 'Middlesex|Gloucester|King and Queen',
    county_weights: '{"51119": 43.64, "51073": 38.74, "51097": 17.61}',
    density: 17.8,
    imprecise: false,
    latitude: 37.56794,
    longitude: -76.61599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23149',
  },
  {
    city: 'Sandston',
    county_fips: 51087,
    county_fips_all: '51087',
    county: 'Henrico',
    county_names_all: 'Henrico',
    county_weights: '{"51087": 100}',
    density: 164.2,
    imprecise: false,
    latitude: 37.50718,
    longitude: -77.25402,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23150',
  },
  {
    city: 'Sandy Hook',
    county_fips: 51075,
    county_fips_all: '51075',
    county: 'Goochland',
    county_names_all: 'Goochland',
    county_weights: '{"51075": 100}',
    density: 46.1,
    imprecise: false,
    latitude: 37.77641,
    longitude: -77.95719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23153',
  },
  {
    city: 'Shacklefords',
    county_fips: 51097,
    county_fips_all: '51097',
    county: 'King and Queen',
    county_names_all: 'King and Queen',
    county_weights: '{"51097": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 37.5244,
    longitude: -76.71106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23156',
  },
  {
    city: 'Stevensville',
    county_fips: 51097,
    county_fips_all: '51097',
    county: 'King and Queen',
    county_names_all: 'King and Queen',
    county_weights: '{"51097": 100}',
    density: 14,
    imprecise: false,
    latitude: 37.72152,
    longitude: -76.93037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23161',
  },
  {
    city: 'Susan',
    county_fips: 51115,
    county_fips_all: '51115',
    county: 'Mathews',
    county_names_all: 'Mathews',
    county_weights: '{"51115": 100}',
    density: 19.7,
    imprecise: false,
    latitude: 37.3572,
    longitude: -76.29765,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 78,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23163',
  },
  {
    city: 'Toano',
    county_fips: 51095,
    county_fips_all: '51095',
    county: 'James City',
    county_names_all: 'James City',
    county_weights: '{"51095": 100}',
    density: 125.4,
    imprecise: false,
    latitude: 37.3942,
    longitude: -76.832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23168',
  },
  {
    city: 'Topping',
    county_fips: 51119,
    county_fips_all: '51119',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"51119": 100}',
    density: 48.8,
    imprecise: false,
    latitude: 37.58945,
    longitude: -76.46225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23169',
  },
  {
    city: 'Urbanna',
    county_fips: 51119,
    county_fips_all: '51119',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"51119": 100}',
    density: 49.9,
    imprecise: false,
    latitude: 37.65343,
    longitude: -76.62407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23175',
  },
  {
    city: 'Wake',
    county_fips: 51119,
    county_fips_all: '51119',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"51119": 100}',
    density: 56.3,
    imprecise: false,
    latitude: 37.56934,
    longitude: -76.41991,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23176',
  },
  {
    city: 'Walkerton',
    county_fips: 51097,
    county_fips_all: '51097|51101',
    county: 'King and Queen',
    county_names_all: 'King and Queen|King William',
    county_weights: '{"51097": 88.53, "51101": 11.47}',
    density: 11.3,
    imprecise: false,
    latitude: 37.73088,
    longitude: -77.00295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23177',
  },
  {
    city: 'Water View',
    county_fips: 51119,
    county_fips_all: '51119',
    county: 'Middlesex',
    county_names_all: 'Middlesex',
    county_weights: '{"51119": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 37.69977,
    longitude: -76.62045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23180',
  },
  {
    city: 'West Point',
    county_fips: 51101,
    county_fips_all: '51101|51127',
    county: 'King William',
    county_names_all: 'King William|New Kent',
    county_weights: '{"51101": 90.8, "51127": 9.2}',
    density: 32.9,
    imprecise: false,
    latitude: 37.59809,
    longitude: -76.889,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23181',
  },
  {
    city: 'Williamsburg',
    county_fips: 51095,
    county_fips_all: '51095|51199|51830|51036',
    county: 'James City',
    county_names_all: 'James City|York|Williamsburg|Charles City',
    county_weights:
      '{"51095": 54.37, "51199": 32.0, "51830": 13.16, "51036": 0.47}',
    density: 372.8,
    imprecise: false,
    latitude: 37.24927,
    longitude: -76.68702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23185',
  },
  {
    city: 'Williamsburg',
    county_fips: 51095,
    county_fips_all: '51095|51199|51830',
    county: 'James City',
    county_names_all: 'James City|York|Williamsburg',
    county_weights: '{"51095": 70.69, "51199": 28.22, "51830": 1.09}',
    density: 181.8,
    imprecise: false,
    latitude: 37.33849,
    longitude: -76.74925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23188',
  },
  {
    city: 'Montpelier',
    county_fips: 51085,
    county_fips_all: '51085|51109',
    county: 'Hanover',
    county_names_all: 'Hanover|Louisa',
    county_weights: '{"51085": 95.89, "51109": 4.11}',
    density: 37.7,
    imprecise: false,
    latitude: 37.81732,
    longitude: -77.68209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23192',
  },
  {
    city: 'Richmond',
    county_fips: 51760,
    county_fips_all: '51760',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"51760": 100}',
    density: 1181.8,
    imprecise: false,
    latitude: 37.54076,
    longitude: -77.43484,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23219',
  },
  {
    city: 'Richmond',
    county_fips: 51760,
    county_fips_all: '51760',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"51760": 100}',
    density: 2768.2,
    imprecise: false,
    latitude: 37.54923,
    longitude: -77.46012,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23220',
  },
  {
    city: 'Richmond',
    county_fips: 51760,
    county_fips_all: '51760',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"51760": 100}',
    density: 1683.9,
    imprecise: false,
    latitude: 37.5533,
    longitude: -77.49056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23221',
  },
  {
    city: 'Richmond',
    county_fips: 51087,
    county_fips_all: '51087|51760',
    county: 'Henrico',
    county_names_all: 'Henrico|Richmond',
    county_weights: '{"51087": 58.62, "51760": 41.38}',
    density: 1245,
    imprecise: false,
    latitude: 37.58265,
    longitude: -77.41894,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23222',
  },
  {
    city: 'Richmond',
    county_fips: 51087,
    county_fips_all: '51087|51760',
    county: 'Henrico',
    county_names_all: 'Henrico|Richmond',
    county_weights: '{"51087": 76.75, "51760": 23.25}',
    density: 1265.9,
    imprecise: false,
    latitude: 37.55595,
    longitude: -77.37927,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23223',
  },
  {
    city: 'Richmond',
    county_fips: 51760,
    county_fips_all: '51760|51041',
    county: 'Richmond',
    county_names_all: 'Richmond|Chesterfield',
    county_weights: '{"51760": 94.64, "51041": 5.36}',
    density: 1355.1,
    imprecise: false,
    latitude: 37.4985,
    longitude: -77.46563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23224',
  },
  {
    city: 'Richmond',
    county_fips: 51760,
    county_fips_all: '51760|51041',
    county: 'Richmond',
    county_names_all: 'Richmond|Chesterfield',
    county_weights: '{"51760": 81.16, "51041": 18.84}',
    density: 1183.9,
    imprecise: false,
    latitude: 37.51872,
    longitude: -77.51044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23225',
  },
  {
    city: 'Richmond',
    county_fips: 51760,
    county_fips_all: '51760|51087',
    county: 'Richmond',
    county_names_all: 'Richmond|Henrico',
    county_weights: '{"51760": 57.1, "51087": 42.9}',
    density: 1061.7,
    imprecise: false,
    latitude: 37.57774,
    longitude: -77.5198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23226',
  },
  {
    city: 'Richmond',
    county_fips: 51087,
    county_fips_all: '51087|51760',
    county: 'Henrico',
    county_names_all: 'Henrico|Richmond',
    county_weights: '{"51087": 74.26, "51760": 25.74}',
    density: 838.4,
    imprecise: false,
    latitude: 37.61486,
    longitude: -77.44234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23227',
  },
  {
    city: 'Henrico',
    county_fips: 51087,
    county_fips_all: '51087',
    county: 'Henrico',
    county_names_all: 'Henrico',
    county_weights: '{"51087": 100}',
    density: 1270.4,
    imprecise: false,
    latitude: 37.62588,
    longitude: -77.49125,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23228',
  },
  {
    city: 'Henrico',
    county_fips: 51087,
    county_fips_all: '51087',
    county: 'Henrico',
    county_names_all: 'Henrico',
    county_weights: '{"51087": 100}',
    density: 983.7,
    imprecise: false,
    latitude: 37.58785,
    longitude: -77.56973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23229',
  },
  {
    city: 'Richmond',
    county_fips: 51087,
    county_fips_all: '51087|51760',
    county: 'Henrico',
    county_names_all: 'Henrico|Richmond',
    county_weights: '{"51087": 71.97, "51760": 28.03}',
    density: 807.9,
    imprecise: false,
    latitude: 37.587,
    longitude: -77.49153,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23230',
  },
  {
    city: 'Henrico',
    county_fips: 51087,
    county_fips_all: '51087|51036|51760',
    county: 'Henrico',
    county_names_all: 'Henrico|Charles City|Richmond',
    county_weights: '{"51087": 94.78, "51036": 3.96, "51760": 1.26}',
    density: 168.7,
    imprecise: false,
    latitude: 37.44219,
    longitude: -77.31903,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23231',
  },
  {
    city: 'Henrico',
    county_fips: 51087,
    county_fips_all: '51087|51075',
    county: 'Henrico',
    county_names_all: 'Henrico|Goochland',
    county_weights: '{"51087": 73.25, "51075": 26.75}',
    density: 946.1,
    imprecise: false,
    latitude: 37.64461,
    longitude: -77.62828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23233',
  },
  {
    city: 'Richmond',
    county_fips: 51041,
    county_fips_all: '51041|51760',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield|Richmond',
    county_weights: '{"51041": 61.86, "51760": 38.14}',
    density: 959.1,
    imprecise: false,
    latitude: 37.45293,
    longitude: -77.46752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23234',
  },
  {
    city: 'Richmond',
    county_fips: 51041,
    county_fips_all: '51041|51760',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield|Richmond',
    county_weights: '{"51041": 73.59, "51760": 26.41}',
    density: 725.8,
    imprecise: false,
    latitude: 37.51314,
    longitude: -77.56426,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23235',
  },
  {
    city: 'Richmond',
    county_fips: 51041,
    county_fips_all: '51041',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield',
    county_weights: '{"51041": 100}',
    density: 741.2,
    imprecise: false,
    latitude: 37.47438,
    longitude: -77.58634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23236',
  },
  {
    city: 'Richmond',
    county_fips: 51041,
    county_fips_all: '51041',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield',
    county_weights: '{"51041": 100}',
    density: 485.3,
    imprecise: false,
    latitude: 37.40173,
    longitude: -77.45433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23237',
  },
  {
    city: 'Henrico',
    county_fips: 51075,
    county_fips_all: '51075|51087',
    county: 'Goochland',
    county_names_all: 'Goochland|Henrico',
    county_weights: '{"51075": 56.78, "51087": 43.22}',
    density: 474.7,
    imprecise: false,
    latitude: 37.59595,
    longitude: -77.64138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23238',
  },
  {
    city: 'Richmond',
    county_fips: 51087,
    county_fips_all: '51087',
    county: 'Henrico',
    county_names_all: 'Henrico',
    county_weights: '{"51087": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.50517,
    longitude: -77.32098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23250',
  },
  {
    city: 'Henrico',
    county_fips: 51087,
    county_fips_all: '51087',
    county: 'Henrico',
    county_names_all: 'Henrico',
    county_weights: '{"51087": 100}',
    density: 1839.6,
    imprecise: false,
    latitude: 37.63048,
    longitude: -77.54205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23294',
  },
  {
    city: 'Accomac',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 24.2,
    imprecise: false,
    latitude: 37.68402,
    longitude: -75.6397,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23301',
  },
  {
    city: 'Assawoman',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 37.85858,
    longitude: -75.52197,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23302',
  },
  {
    city: 'Atlantic',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 37.90346,
    longitude: -75.50562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23303',
  },
  {
    city: 'Battery Park',
    county_fips: 51093,
    county_fips_all: '51093',
    county: 'Isle of Wight',
    county_names_all: 'Isle of Wight',
    county_weights: '{"51093": 100}',
    density: 95.4,
    imprecise: false,
    latitude: 36.99586,
    longitude: -76.56993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23304',
  },
  {
    city: 'Belle Haven',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 56.5,
    imprecise: false,
    latitude: 37.56859,
    longitude: -75.88148,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23306',
  },
  {
    city: 'Birdsnest',
    county_fips: 51131,
    county_fips_all: '51131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"51131": 100}',
    density: 32.3,
    imprecise: false,
    latitude: 37.43282,
    longitude: -75.87095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23307',
  },
  {
    city: 'Bloxom',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 26,
    imprecise: false,
    latitude: 37.82431,
    longitude: -75.61773,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23308',
  },
  {
    city: 'Cape Charles',
    county_fips: 51131,
    county_fips_all: '51131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"51131": 100}',
    density: 29.8,
    imprecise: false,
    latitude: 37.26407,
    longitude: -75.95676,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23310',
  },
  {
    city: 'Carrollton',
    county_fips: 51093,
    county_fips_all: '51093',
    county: 'Isle of Wight',
    county_names_all: 'Isle of Wight',
    county_weights: '{"51093": 100}',
    density: 200.4,
    imprecise: false,
    latitude: 36.95054,
    longitude: -76.53625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23314',
  },
  {
    city: 'Carrsville',
    county_fips: 51093,
    county_fips_all: '51093',
    county: 'Isle of Wight',
    county_names_all: 'Isle of Wight',
    county_weights: '{"51093": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 36.73861,
    longitude: -76.84289,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23315',
  },
  {
    city: 'Cheriton',
    county_fips: 51131,
    county_fips_all: '51131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"51131": 100}',
    density: 64.2,
    imprecise: false,
    latitude: 37.29517,
    longitude: -75.96635,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23316',
  },
  {
    city: 'Chesapeake',
    county_fips: 51550,
    county_fips_all: '51550',
    county: 'Chesapeake',
    county_names_all: 'Chesapeake',
    county_weights: '{"51550": 100}',
    density: 719,
    imprecise: false,
    latitude: 36.75208,
    longitude: -76.21807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23320',
  },
  {
    city: 'Chesapeake',
    county_fips: 51550,
    county_fips_all: '51550',
    county: 'Chesapeake',
    county_names_all: 'Chesapeake',
    county_weights: '{"51550": 100}',
    density: 581.9,
    imprecise: false,
    latitude: 36.80067,
    longitude: -76.42189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23321',
  },
  {
    city: 'Chesapeake',
    county_fips: 51550,
    county_fips_all: '51550',
    county: 'Chesapeake',
    county_names_all: 'Chesapeake',
    county_weights: '{"51550": 100}',
    density: 137.7,
    imprecise: false,
    latitude: 36.62703,
    longitude: -76.26929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23322',
  },
  {
    city: 'Chesapeake',
    county_fips: 51550,
    county_fips_all: '51550|51800',
    county: 'Chesapeake',
    county_names_all: 'Chesapeake|Suffolk',
    county_weights: '{"51550": 99.88, "51800": 0.12}',
    density: 202.9,
    imprecise: false,
    latitude: 36.70785,
    longitude: -76.37949,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23323',
  },
  {
    city: 'Chesapeake',
    county_fips: 51550,
    county_fips_all: '51550',
    county: 'Chesapeake',
    county_names_all: 'Chesapeake',
    county_weights: '{"51550": 100}',
    density: 1431.3,
    imprecise: false,
    latitude: 36.79996,
    longitude: -76.27517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23324',
  },
  {
    city: 'Chesapeake',
    county_fips: 51550,
    county_fips_all: '51550',
    county: 'Chesapeake',
    county_names_all: 'Chesapeake',
    county_weights: '{"51550": 100}',
    density: 1960.8,
    imprecise: false,
    latitude: 36.81507,
    longitude: -76.239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23325',
  },
  {
    city: 'Chincoteague Island',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 66.3,
    imprecise: false,
    latitude: 37.95461,
    longitude: -75.33759,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23336',
  },
  {
    city: 'Wallops Island',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 42.2,
    imprecise: false,
    latitude: 37.93332,
    longitude: -75.46691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23337',
  },
  {
    city: 'Eastville',
    county_fips: 51131,
    county_fips_all: '51131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"51131": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 37.36026,
    longitude: -75.96798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23347',
  },
  {
    city: 'Exmore',
    county_fips: 51131,
    county_fips_all: '51131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"51131": 100}',
    density: 35,
    imprecise: false,
    latitude: 37.51489,
    longitude: -75.87428,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23350',
  },
  {
    city: 'Franktown',
    county_fips: 51131,
    county_fips_all: '51131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"51131": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 37.47806,
    longitude: -75.90225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23354',
  },
  {
    city: 'Greenbackville',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 176.9,
    imprecise: false,
    latitude: 37.9905,
    longitude: -75.39228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23356',
  },
  {
    city: 'Greenbush',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 59.7,
    imprecise: false,
    latitude: 37.75862,
    longitude: -75.67459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23357',
  },
  {
    city: 'Hacksneck',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 37.64406,
    longitude: -75.86495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23358',
  },
  {
    city: 'Hallwood',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 37.88643,
    longitude: -75.60422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23359',
  },
  {
    city: 'Harborton',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 40,
    imprecise: false,
    latitude: 37.65731,
    longitude: -75.83226,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23389',
  },
  {
    city: 'Horntown',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 24.7,
    imprecise: false,
    latitude: 37.97051,
    longitude: -75.45159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23395',
  },
  {
    city: 'Jamesville',
    county_fips: 51131,
    county_fips_all: '51131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"51131": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 37.52054,
    longitude: -75.93971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23398',
  },
  {
    city: 'Keller',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 51.8,
    imprecise: false,
    latitude: 37.62776,
    longitude: -75.77843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23401',
  },
  {
    city: 'Machipongo',
    county_fips: 51131,
    county_fips_all: '51131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"51131": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 37.41466,
    longitude: -75.91969,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23405',
  },
  {
    city: 'Mappsville',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 37.8432,
    longitude: -75.55362,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23407',
  },
  {
    city: 'Marionville',
    county_fips: 51131,
    county_fips_all: '51131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"51131": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.4533,
    longitude: -75.84587,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23408',
  },
  {
    city: 'Mears',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 37.88017,
    longitude: -75.64709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23409',
  },
  {
    city: 'Melfa',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 31.3,
    imprecise: false,
    latitude: 37.63802,
    longitude: -75.74306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23410',
  },
  {
    city: 'Nassawadox',
    county_fips: 51131,
    county_fips_all: '51131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"51131": 100}',
    density: 40.3,
    imprecise: false,
    latitude: 37.4653,
    longitude: -75.85356,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23413',
  },
  {
    city: 'Nelsonia',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 31.2,
    imprecise: false,
    latitude: 37.81375,
    longitude: -75.58688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23414',
  },
  {
    city: 'New Church',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 28,
    imprecise: false,
    latitude: 37.97459,
    longitude: -75.53443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23415',
  },
  {
    city: 'Oak Hall',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 37.93371,
    longitude: -75.557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23416',
  },
  {
    city: 'Onancock',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 31.2,
    imprecise: false,
    latitude: 37.73061,
    longitude: -75.76687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23417',
  },
  {
    city: 'Onley',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 37.63821,
    longitude: -75.66926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23418',
  },
  {
    city: 'Painter',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 29,
    imprecise: false,
    latitude: 37.58275,
    longitude: -75.81166,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23420',
  },
  {
    city: 'Parksley',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 51.4,
    imprecise: false,
    latitude: 37.76564,
    longitude: -75.61429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23421',
  },
  {
    city: 'Pungoteague',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 37.63647,
    longitude: -75.82397,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23422',
  },
  {
    city: 'Quinby',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 37.52361,
    longitude: -75.73969,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23423',
  },
  {
    city: 'Sanford',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 37.92706,
    longitude: -75.67506,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23426',
  },
  {
    city: 'Saxis',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 37.9124,
    longitude: -75.71344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23427',
  },
  {
    city: 'Smithfield',
    county_fips: 51093,
    county_fips_all: '51093|51181',
    county: 'Isle of Wight',
    county_names_all: 'Isle of Wight|Surry',
    county_weights: '{"51093": 97.04, "51181": 2.96}',
    density: 70.9,
    imprecise: false,
    latitude: 36.98615,
    longitude: -76.66337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23430',
  },
  {
    city: 'Suffolk',
    county_fips: 51800,
    county_fips_all: '51800',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"51800": 100}',
    density: 33.6,
    imprecise: false,
    latitude: 36.87099,
    longitude: -76.55097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23432',
  },
  {
    city: 'Suffolk',
    county_fips: 51800,
    county_fips_all: '51800',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"51800": 100}',
    density: 313.2,
    imprecise: false,
    latitude: 36.90763,
    longitude: -76.49183,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23433',
  },
  {
    city: 'Suffolk',
    county_fips: 51800,
    county_fips_all: '51800',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"51800": 100}',
    density: 101.6,
    imprecise: false,
    latitude: 36.70163,
    longitude: -76.59074,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23434',
  },
  {
    city: 'Suffolk',
    county_fips: 51800,
    county_fips_all: '51800',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"51800": 100}',
    density: 364.9,
    imprecise: false,
    latitude: 36.83751,
    longitude: -76.4803,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23435',
  },
  {
    city: 'Suffolk',
    county_fips: 51800,
    county_fips_all: '51800',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"51800": 100}',
    density: 218.7,
    imprecise: false,
    latitude: 36.89516,
    longitude: -76.50873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23436',
  },
  {
    city: 'Suffolk',
    county_fips: 51800,
    county_fips_all: '51800',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"51800": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 36.63533,
    longitude: -76.80256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23437',
  },
  {
    city: 'Suffolk',
    county_fips: 51800,
    county_fips_all: '51800',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"51800": 100}',
    density: 17,
    imprecise: false,
    latitude: 36.58116,
    longitude: -76.69749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23438',
  },
  {
    city: 'Tangier',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 61.4,
    imprecise: false,
    latitude: 37.83048,
    longitude: -75.99019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23440',
  },
  {
    city: 'Tasley',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.71208,
    longitude: -75.69943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23441',
  },
  {
    city: 'Temperanceville',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 37.90127,
    longitude: -75.56874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23442',
  },
  {
    city: 'Virginia Beach',
    county_fips: 51810,
    county_fips_all: '51810',
    county: 'Virginia Beach',
    county_names_all: 'Virginia Beach',
    county_weights: '{"51810": 100}',
    density: 859.7,
    imprecise: false,
    latitude: 36.87175,
    longitude: -76.00689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23451',
  },
  {
    city: 'Virginia Beach',
    county_fips: 51810,
    county_fips_all: '51810',
    county: 'Virginia Beach',
    county_names_all: 'Virginia Beach',
    county_weights: '{"51810": 100}',
    density: 1492.2,
    imprecise: false,
    latitude: 36.84604,
    longitude: -76.09197,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23452',
  },
  {
    city: 'Virginia Beach',
    county_fips: 51810,
    county_fips_all: '51810',
    county: 'Virginia Beach',
    county_names_all: 'Virginia Beach',
    county_weights: '{"51810": 100}',
    density: 1459.1,
    imprecise: false,
    latitude: 36.785,
    longitude: -76.07679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23453',
  },
  {
    city: 'Virginia Beach',
    county_fips: 51810,
    county_fips_all: '51810',
    county: 'Virginia Beach',
    county_names_all: 'Virginia Beach',
    county_weights: '{"51810": 100}',
    density: 998.8,
    imprecise: false,
    latitude: 36.83216,
    longitude: -76.02616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23454',
  },
  {
    city: 'Virginia Beach',
    county_fips: 51810,
    county_fips_all: '51810',
    county: 'Virginia Beach',
    county_names_all: 'Virginia Beach',
    county_weights: '{"51810": 100}',
    density: 1271.5,
    imprecise: false,
    latitude: 36.88974,
    longitude: -76.1441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23455',
  },
  {
    city: 'Virginia Beach',
    county_fips: 51810,
    county_fips_all: '51810',
    county: 'Virginia Beach',
    county_names_all: 'Virginia Beach',
    county_weights: '{"51810": 100}',
    density: 476.8,
    imprecise: false,
    latitude: 36.73435,
    longitude: -76.03492,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 61911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23456',
  },
  {
    city: 'Virginia Beach',
    county_fips: 51810,
    county_fips_all: '51810',
    county: 'Virginia Beach',
    county_names_all: 'Virginia Beach',
    county_weights: '{"51810": 100}',
    density: 27.4,
    imprecise: false,
    latitude: 36.61686,
    longitude: -76.01576,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23457',
  },
  {
    city: 'Virginia Beach',
    county_fips: 51810,
    county_fips_all: '51810',
    county: 'Virginia Beach',
    county_names_all: 'Virginia Beach',
    county_weights: '{"51810": 100}',
    density: 2315.9,
    imprecise: false,
    latitude: 36.8366,
    longitude: -76.15105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23462',
  },
  {
    city: 'Virginia Beach',
    county_fips: 51810,
    county_fips_all: '51810',
    county: 'Virginia Beach',
    county_names_all: 'Virginia Beach',
    county_weights: '{"51810": 100}',
    density: 1738.8,
    imprecise: false,
    latitude: 36.79732,
    longitude: -76.17899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 75061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23464',
  },
  {
    city: 'Wachapreague',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 67.7,
    imprecise: false,
    latitude: 37.61388,
    longitude: -75.69077,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23480',
  },
  {
    city: 'Willis Wharf',
    county_fips: 51131,
    county_fips_all: '51131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"51131": 100}',
    density: 305.1,
    imprecise: false,
    latitude: 37.5177,
    longitude: -75.80824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23486',
  },
  {
    city: 'Windsor',
    county_fips: 51093,
    county_fips_all: '51093',
    county: 'Isle of Wight',
    county_names_all: 'Isle of Wight',
    county_weights: '{"51093": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 36.85197,
    longitude: -76.72303,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23487',
  },
  {
    city: 'Withams',
    county_fips: 51001,
    county_fips_all: '51001',
    county: 'Accomack',
    county_names_all: 'Accomack',
    county_weights: '{"51001": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 37.95237,
    longitude: -75.60831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23488',
  },
  {
    city: 'Norfolk',
    county_fips: 51710,
    county_fips_all: '51710',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"51710": 100}',
    density: 795.1,
    imprecise: false,
    latitude: 36.86274,
    longitude: -76.20983,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23502',
  },
  {
    city: 'Norfolk',
    county_fips: 51710,
    county_fips_all: '51710',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"51710": 100}',
    density: 2312.2,
    imprecise: false,
    latitude: 36.94727,
    longitude: -76.26223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23503',
  },
  {
    city: 'Norfolk',
    county_fips: 51710,
    county_fips_all: '51710',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"51710": 100}',
    density: 2218.5,
    imprecise: false,
    latitude: 36.85677,
    longitude: -76.26568,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23504',
  },
  {
    city: 'Norfolk',
    county_fips: 51710,
    county_fips_all: '51710',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"51710": 100}',
    density: 1660,
    imprecise: false,
    latitude: 36.91418,
    longitude: -76.29081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23505',
  },
  {
    city: 'Norfolk',
    county_fips: 51710,
    county_fips_all: '51710',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"51710": 100}',
    density: 2826.5,
    imprecise: false,
    latitude: 36.8642,
    longitude: -76.30304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23507',
  },
  {
    city: 'Norfolk',
    county_fips: 51710,
    county_fips_all: '51710',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"51710": 100}',
    density: 2246,
    imprecise: false,
    latitude: 36.8844,
    longitude: -76.30898,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23508',
  },
  {
    city: 'Norfolk',
    county_fips: 51710,
    county_fips_all: '51710',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"51710": 100}',
    density: 1988.9,
    imprecise: false,
    latitude: 36.88215,
    longitude: -76.26203,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23509',
  },
  {
    city: 'Norfolk',
    county_fips: 51710,
    county_fips_all: '51710',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"51710": 100}',
    density: 3086.8,
    imprecise: false,
    latitude: 36.8518,
    longitude: -76.29154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23510',
  },
  {
    city: 'Norfolk',
    county_fips: 51710,
    county_fips_all: '51710',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"51710": 100}',
    density: 729.5,
    imprecise: false,
    latitude: 36.94,
    longitude: -76.30055,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23511',
  },
  {
    city: 'Norfolk',
    county_fips: 51710,
    county_fips_all: '51710',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"51710": 100}',
    density: 2179.7,
    imprecise: false,
    latitude: 36.88948,
    longitude: -76.23831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23513',
  },
  {
    city: 'Norfolk',
    county_fips: 51710,
    county_fips_all: '51710',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"51710": 100}',
    density: 2305.4,
    imprecise: false,
    latitude: 36.86927,
    longitude: -76.29198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23517',
  },
  {
    city: 'Norfolk',
    county_fips: 51710,
    county_fips_all: '51710|51810',
    county: 'Norfolk',
    county_names_all: 'Norfolk|Virginia Beach',
    county_weights: '{"51710": 99.83, "51810": 0.17}',
    density: 1873,
    imprecise: false,
    latitude: 36.91638,
    longitude: -76.21586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23518',
  },
  {
    city: 'Norfolk',
    county_fips: 51710,
    county_fips_all: '51710',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"51710": 100}',
    density: 1512.2,
    imprecise: false,
    latitude: 36.83254,
    longitude: -76.27199,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23523',
  },
  {
    city: 'Newport News',
    county_fips: 51700,
    county_fips_all: '51700',
    county: 'Newport News',
    county_names_all: 'Newport News',
    county_weights: '{"51700": 100}',
    density: 1383.5,
    imprecise: false,
    latitude: 37.05862,
    longitude: -76.46414,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23601',
  },
  {
    city: 'Newport News',
    county_fips: 51700,
    county_fips_all: '51700',
    county: 'Newport News',
    county_names_all: 'Newport News',
    county_weights: '{"51700": 100}',
    density: 1240.7,
    imprecise: false,
    latitude: 37.11511,
    longitude: -76.51625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23602',
  },
  {
    city: 'Newport News',
    county_fips: 51700,
    county_fips_all: '51700|51199',
    county: 'Newport News',
    county_names_all: 'Newport News|York',
    county_weights: '{"51700": 97.62, "51199": 2.38}',
    density: 194.6,
    imprecise: false,
    latitude: 37.19188,
    longitude: -76.56563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23603',
  },
  {
    city: 'Fort Eustis',
    county_fips: 51700,
    county_fips_all: '51700',
    county: 'Newport News',
    county_names_all: 'Newport News',
    county_weights: '{"51700": 100}',
    density: 140.7,
    imprecise: false,
    latitude: 37.13195,
    longitude: -76.58902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23604',
  },
  {
    city: 'Newport News',
    county_fips: 51700,
    county_fips_all: '51700|51650',
    county: 'Newport News',
    county_names_all: 'Newport News|Hampton',
    county_weights: '{"51700": 84.95, "51650": 15.05}',
    density: 1404.2,
    imprecise: false,
    latitude: 37.01754,
    longitude: -76.43527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23605',
  },
  {
    city: 'Newport News',
    county_fips: 51700,
    county_fips_all: '51700',
    county: 'Newport News',
    county_names_all: 'Newport News',
    county_weights: '{"51700": 100}',
    density: 1197.7,
    imprecise: false,
    latitude: 37.07847,
    longitude: -76.49557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23606',
  },
  {
    city: 'Newport News',
    county_fips: 51700,
    county_fips_all: '51700|51650',
    county: 'Newport News',
    county_names_all: 'Newport News|Hampton',
    county_weights: '{"51700": 99.86, "51650": 0.14}',
    density: 1485.4,
    imprecise: false,
    latitude: 36.98753,
    longitude: -76.42235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23607',
  },
  {
    city: 'Newport News',
    county_fips: 51700,
    county_fips_all: '51700',
    county: 'Newport News',
    county_names_all: 'Newport News',
    county_weights: '{"51700": 100}',
    density: 1567.6,
    imprecise: false,
    latitude: 37.15093,
    longitude: -76.54343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23608',
  },
  {
    city: 'Fort Monroe',
    county_fips: 51650,
    county_fips_all: '51650',
    county: 'Hampton',
    county_names_all: 'Hampton',
    county_weights: '{"51650": 100}',
    density: 215.9,
    imprecise: false,
    latitude: 37.0099,
    longitude: -76.30451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23651',
  },
  {
    city: 'Hampton',
    county_fips: 51650,
    county_fips_all: '51650',
    county: 'Hampton',
    county_names_all: 'Hampton',
    county_weights: '{"51650": 100}',
    density: 1143.5,
    imprecise: false,
    latitude: 37.00804,
    longitude: -76.38631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23661',
  },
  {
    city: 'Poquoson',
    county_fips: 51735,
    county_fips_all: '51735',
    county: 'Poquoson',
    county_names_all: 'Poquoson',
    county_weights: '{"51735": 100}',
    density: 317.8,
    imprecise: false,
    latitude: 37.13178,
    longitude: -76.35678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23662',
  },
  {
    city: 'Hampton',
    county_fips: 51650,
    county_fips_all: '51650',
    county: 'Hampton',
    county_names_all: 'Hampton',
    county_weights: '{"51650": 100}',
    density: 2013.4,
    imprecise: false,
    latitude: 37.03216,
    longitude: -76.31589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23663',
  },
  {
    city: 'Hampton',
    county_fips: 51650,
    county_fips_all: '51650',
    county: 'Hampton',
    county_names_all: 'Hampton',
    county_weights: '{"51650": 100}',
    density: 692.4,
    imprecise: false,
    latitude: 37.07467,
    longitude: -76.2925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23664',
  },
  {
    city: 'Hampton',
    county_fips: 51650,
    county_fips_all: '51650|51199',
    county: 'Hampton',
    county_names_all: 'Hampton|York',
    county_weights: '{"51650": 91.33, "51199": 8.67}',
    density: 456.6,
    imprecise: false,
    latitude: 37.08963,
    longitude: -76.36302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23665',
  },
  {
    city: 'Hampton',
    county_fips: 51650,
    county_fips_all: '51650',
    county: 'Hampton',
    county_names_all: 'Hampton',
    county_weights: '{"51650": 100}',
    density: 1080,
    imprecise: false,
    latitude: 37.05818,
    longitude: -76.40817,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23666',
  },
  {
    city: 'Hampton',
    county_fips: 51650,
    county_fips_all: '51650',
    county: 'Hampton',
    county_names_all: 'Hampton',
    county_weights: '{"51650": 100}',
    density: 1273.9,
    imprecise: false,
    latitude: 37.05052,
    longitude: -76.33952,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23669',
  },
  {
    city: 'Yorktown',
    county_fips: 51199,
    county_fips_all: '51199',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"51199": 100}',
    density: 154.8,
    imprecise: false,
    latitude: 37.21829,
    longitude: -76.52371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23690',
  },
  {
    city: 'Yorktown',
    county_fips: 51199,
    county_fips_all: '51199',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"51199": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 37.25906,
    longitude: -76.57322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23691',
  },
  {
    city: 'Yorktown',
    county_fips: 51199,
    county_fips_all: '51199',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"51199": 100}',
    density: 383.7,
    imprecise: false,
    latitude: 37.18107,
    longitude: -76.45868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23692',
  },
  {
    city: 'Yorktown',
    county_fips: 51199,
    county_fips_all: '51199',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"51199": 100}',
    density: 655.2,
    imprecise: false,
    latitude: 37.12669,
    longitude: -76.44755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23693',
  },
  {
    city: 'Seaford',
    county_fips: 51199,
    county_fips_all: '51199',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"51199": 100}',
    density: 271.4,
    imprecise: false,
    latitude: 37.19249,
    longitude: -76.42589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23696',
  },
  {
    city: 'Portsmouth',
    county_fips: 51740,
    county_fips_all: '51740',
    county: 'Portsmouth',
    county_names_all: 'Portsmouth',
    county_weights: '{"51740": 100}',
    density: 1215.1,
    imprecise: false,
    latitude: 36.81158,
    longitude: -76.36986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23701',
  },
  {
    city: 'Portsmouth',
    county_fips: 51740,
    county_fips_all: '51740',
    county: 'Portsmouth',
    county_names_all: 'Portsmouth',
    county_weights: '{"51740": 100}',
    density: 2010,
    imprecise: false,
    latitude: 36.80292,
    longitude: -76.32679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23702',
  },
  {
    city: 'Portsmouth',
    county_fips: 51740,
    county_fips_all: '51740',
    county: 'Portsmouth',
    county_names_all: 'Portsmouth',
    county_weights: '{"51740": 100}',
    density: 709.5,
    imprecise: false,
    latitude: 36.88039,
    longitude: -76.37101,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23703',
  },
  {
    city: 'Portsmouth',
    county_fips: 51740,
    county_fips_all: '51740',
    county: 'Portsmouth',
    county_names_all: 'Portsmouth',
    county_weights: '{"51740": 100}',
    density: 1640.5,
    imprecise: false,
    latitude: 36.82603,
    longitude: -76.3123,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23704',
  },
  {
    city: 'Portsmouth',
    county_fips: 51740,
    county_fips_all: '51740',
    county: 'Portsmouth',
    county_names_all: 'Portsmouth',
    county_weights: '{"51740": 100}',
    density: 1462.2,
    imprecise: false,
    latitude: 36.84255,
    longitude: -76.34002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23707',
  },
  {
    city: 'Fort Gregg Adams',
    county_fips: 51149,
    county_fips_all: '51149',
    county: 'Prince George',
    county_names_all: 'Prince George',
    county_weights: '{"51149": 100}',
    density: 523.4,
    imprecise: false,
    latitude: 37.23618,
    longitude: -77.33582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23801',
  },
  {
    city: 'Petersburg',
    county_fips: 51053,
    county_fips_all: '51053|51041|51730',
    county: 'Dinwiddie',
    county_names_all: 'Dinwiddie|Chesterfield|Petersburg',
    county_weights: '{"51053": 43.82, "51041": 41.63, "51730": 14.55}',
    density: 224.7,
    imprecise: false,
    latitude: 37.21183,
    longitude: -77.48028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23803',
  },
  {
    city: 'Petersburg',
    county_fips: 51149,
    county_fips_all: '51149|51053|51730',
    county: 'Prince George',
    county_names_all: 'Prince George|Dinwiddie|Petersburg',
    county_weights: '{"51149": 43.08, "51053": 40.05, "51730": 16.87}',
    density: 115.6,
    imprecise: false,
    latitude: 37.12922,
    longitude: -77.3953,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23805',
  },
  {
    city: 'Alberta',
    county_fips: 51025,
    county_fips_all: '51025',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"51025": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 36.876,
    longitude: -77.91794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23821',
  },
  {
    city: 'Blackstone',
    county_fips: 51135,
    county_fips_all: '51135|51053|51025|51111',
    county: 'Nottoway',
    county_names_all: 'Nottoway|Dinwiddie|Brunswick|Lunenburg',
    county_weights:
      '{"51135": 75.94, "51053": 12.43, "51025": 8.93, "51111": 2.7}',
    density: 12.7,
    imprecise: false,
    latitude: 37.08767,
    longitude: -77.95749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23824',
  },
  {
    city: 'Boykins',
    county_fips: 51175,
    county_fips_all: '51175',
    county: 'Southampton',
    county_names_all: 'Southampton',
    county_weights: '{"51175": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 36.61491,
    longitude: -77.20724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23827',
  },
  {
    city: 'Branchville',
    county_fips: 51175,
    county_fips_all: '51175',
    county: 'Southampton',
    county_names_all: 'Southampton',
    county_weights: '{"51175": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 36.58693,
    longitude: -77.28557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23828',
  },
  {
    city: 'Capron',
    county_fips: 51175,
    county_fips_all: '51175',
    county: 'Southampton',
    county_names_all: 'Southampton',
    county_weights: '{"51175": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 36.73393,
    longitude: -77.22525,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23829',
  },
  {
    city: 'Carson',
    county_fips: 51053,
    county_fips_all: '51053|51183|51149',
    county: 'Dinwiddie',
    county_names_all: 'Dinwiddie|Sussex|Prince George',
    county_weights: '{"51053": 51.59, "51183": 27.14, "51149": 21.27}',
    density: 10.8,
    imprecise: false,
    latitude: 37.02098,
    longitude: -77.39771,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23830',
  },
  {
    city: 'Chester',
    county_fips: 51041,
    county_fips_all: '51041',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield',
    county_weights: '{"51041": 100}',
    density: 645.4,
    imprecise: false,
    latitude: 37.34437,
    longitude: -77.44998,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23831',
  },
  {
    city: 'Chesterfield',
    county_fips: 51041,
    county_fips_all: '51041',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield',
    county_weights: '{"51041": 100}',
    density: 385.3,
    imprecise: false,
    latitude: 37.39436,
    longitude: -77.59491,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23832',
  },
  {
    city: 'Church Road',
    county_fips: 51053,
    county_fips_all: '51053|51007',
    county: 'Dinwiddie',
    county_names_all: 'Dinwiddie|Amelia',
    county_weights: '{"51053": 72.88, "51007": 27.12}',
    density: 14.6,
    imprecise: false,
    latitude: 37.21094,
    longitude: -77.66947,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23833',
  },
  {
    city: 'Colonial Heights',
    county_fips: 51041,
    county_fips_all: '51041|51570',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield|Colonial Heights',
    county_weights: '{"51041": 69.26, "51570": 30.74}',
    density: 432.5,
    imprecise: false,
    latitude: 37.28911,
    longitude: -77.40063,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23834',
  },
  {
    city: 'Chester',
    county_fips: 51041,
    county_fips_all: '51041',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield',
    county_weights: '{"51041": 100}',
    density: 222.2,
    imprecise: false,
    latitude: 37.35087,
    longitude: -77.33253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23836',
  },
  {
    city: 'Courtland',
    county_fips: 51175,
    county_fips_all: '51175|51183',
    county: 'Southampton',
    county_names_all: 'Southampton|Sussex',
    county_weights: '{"51175": 92.68, "51183": 7.32}',
    density: 16.2,
    imprecise: false,
    latitude: 36.75816,
    longitude: -77.08753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23837',
  },
  {
    city: 'Chesterfield',
    county_fips: 51041,
    county_fips_all: '51041',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield',
    county_weights: '{"51041": 100}',
    density: 69.1,
    imprecise: false,
    latitude: 37.31772,
    longitude: -77.63288,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23838',
  },
  {
    city: 'Dendron',
    county_fips: 51181,
    county_fips_all: '51181',
    county: 'Surry',
    county_names_all: 'Surry',
    county_weights: '{"51181": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 37.08718,
    longitude: -76.91895,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23839',
  },
  {
    city: 'Dewitt',
    county_fips: 51053,
    county_fips_all: '51053',
    county: 'Dinwiddie',
    county_names_all: 'Dinwiddie',
    county_weights: '{"51053": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 37.05638,
    longitude: -77.67076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23840',
  },
  {
    city: 'Dinwiddie',
    county_fips: 51053,
    county_fips_all: '51053',
    county: 'Dinwiddie',
    county_names_all: 'Dinwiddie',
    county_weights: '{"51053": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 37.05421,
    longitude: -77.55305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23841',
  },
  {
    city: 'Disputanta',
    county_fips: 51149,
    county_fips_all: '51149|51183|51181',
    county: 'Prince George',
    county_names_all: 'Prince George|Sussex|Surry',
    county_weights: '{"51149": 82.42, "51183": 15.43, "51181": 2.15}',
    density: 19.2,
    imprecise: false,
    latitude: 37.13625,
    longitude: -77.22086,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23842',
  },
  {
    city: 'Dolphin',
    county_fips: 51025,
    county_fips_all: '51025',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"51025": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 36.84988,
    longitude: -77.8109,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23843',
  },
  {
    city: 'Drewryville',
    county_fips: 51175,
    county_fips_all: '51175',
    county: 'Southampton',
    county_names_all: 'Southampton',
    county_weights: '{"51175": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 36.67032,
    longitude: -77.3358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23844',
  },
  {
    city: 'Ebony',
    county_fips: 51025,
    county_fips_all: '51025',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"51025": 100}',
    density: 9,
    imprecise: false,
    latitude: 36.57048,
    longitude: -77.99322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23845',
  },
  {
    city: 'Elberon',
    county_fips: 51181,
    county_fips_all: '51181',
    county: 'Surry',
    county_names_all: 'Surry',
    county_weights: '{"51181": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 37.05947,
    longitude: -76.83224,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23846',
  },
  {
    city: 'Emporia',
    county_fips: 51081,
    county_fips_all: '51081|51025|51175|51183|51595',
    county: 'Greensville',
    county_names_all: 'Greensville|Brunswick|Southampton|Sussex|Emporia',
    county_weights:
      '{"51081": 78.73, "51025": 6.76, "51175": 6.69, "51183": 5.41, "51595": 2.41}',
    density: 18.2,
    imprecise: false,
    latitude: 36.668,
    longitude: -77.54972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23847',
  },
  {
    city: 'Ford',
    county_fips: 51053,
    county_fips_all: '51053|51007',
    county: 'Dinwiddie',
    county_names_all: 'Dinwiddie|Amelia',
    county_weights: '{"51053": 70.45, "51007": 29.55}',
    density: 9.8,
    imprecise: false,
    latitude: 37.16276,
    longitude: -77.7434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23850',
  },
  {
    city: 'Franklin',
    county_fips: 51175,
    county_fips_all: '51175|51093|51620',
    county: 'Southampton',
    county_names_all: 'Southampton|Isle of Wight|Franklin',
    county_weights: '{"51175": 78.43, "51093": 14.02, "51620": 7.55}',
    density: 47,
    imprecise: false,
    latitude: 36.6521,
    longitude: -76.95776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23851',
  },
  {
    city: 'Freeman',
    county_fips: 51025,
    county_fips_all: '51025|51081',
    county: 'Brunswick',
    county_names_all: 'Brunswick|Greensville',
    county_weights: '{"51025": 95.04, "51081": 4.96}',
    density: 4.1,
    imprecise: false,
    latitude: 36.78735,
    longitude: -77.70291,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23856',
  },
  {
    city: 'Gasburg',
    county_fips: 51025,
    county_fips_all: '51025',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"51025": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 36.58389,
    longitude: -77.88588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23857',
  },
  {
    city: 'Hopewell',
    county_fips: 51149,
    county_fips_all: '51149|51670',
    county: 'Prince George',
    county_names_all: 'Prince George|Hopewell',
    county_weights: '{"51149": 80.31, "51670": 19.69}',
    density: 268.1,
    imprecise: false,
    latitude: 37.28267,
    longitude: -77.22267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23860',
  },
  {
    city: 'Ivor',
    county_fips: 51175,
    county_fips_all: '51175|51093|51181',
    county: 'Southampton',
    county_names_all: 'Southampton|Isle of Wight|Surry',
    county_weights: '{"51175": 63.54, "51093": 36.0, "51181": 0.46}',
    density: 9,
    imprecise: false,
    latitude: 36.92012,
    longitude: -76.86693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23866',
  },
  {
    city: 'Jarratt',
    county_fips: 51183,
    county_fips_all: '51183|51081',
    county: 'Sussex',
    county_names_all: 'Sussex|Greensville',
    county_weights: '{"51183": 58.41, "51081": 41.59}',
    density: 20.5,
    imprecise: false,
    latitude: 36.82063,
    longitude: -77.4878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23867',
  },
  {
    city: 'Lawrenceville',
    county_fips: 51025,
    county_fips_all: '51025',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"51025": 100}',
    density: 20.1,
    imprecise: false,
    latitude: 36.70991,
    longitude: -77.8038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23868',
  },
  {
    city: 'McKenney',
    county_fips: 51053,
    county_fips_all: '51053',
    county: 'Dinwiddie',
    county_names_all: 'Dinwiddie',
    county_weights: '{"51053": 100}',
    density: 10,
    imprecise: false,
    latitude: 36.98351,
    longitude: -77.72629,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23872',
  },
  {
    city: 'Newsoms',
    county_fips: 51175,
    county_fips_all: '51175',
    county: 'Southampton',
    county_names_all: 'Southampton',
    county_weights: '{"51175": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 36.60761,
    longitude: -77.09803,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23874',
  },
  {
    city: 'Prince George',
    county_fips: 51149,
    county_fips_all: '51149',
    county: 'Prince George',
    county_names_all: 'Prince George',
    county_weights: '{"51149": 100}',
    density: 141.3,
    imprecise: false,
    latitude: 37.22941,
    longitude: -77.25845,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23875',
  },
  {
    city: 'Rawlings',
    county_fips: 51025,
    county_fips_all: '51025',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"51025": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 36.95635,
    longitude: -77.83343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23876',
  },
  {
    city: 'Sedley',
    county_fips: 51175,
    county_fips_all: '51175',
    county: 'Southampton',
    county_names_all: 'Southampton',
    county_weights: '{"51175": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 36.8291,
    longitude: -77.02065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23878',
  },
  {
    city: 'Skippers',
    county_fips: 51081,
    county_fips_all: '51081',
    county: 'Greensville',
    county_names_all: 'Greensville',
    county_weights: '{"51081": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 36.59224,
    longitude: -77.59547,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23879',
  },
  {
    city: 'Spring Grove',
    county_fips: 51181,
    county_fips_all: '51181|51149',
    county: 'Surry',
    county_names_all: 'Surry|Prince George',
    county_weights: '{"51181": 67.56, "51149": 32.44}',
    density: 9,
    imprecise: false,
    latitude: 37.1917,
    longitude: -76.98588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23881',
  },
  {
    city: 'Stony Creek',
    county_fips: 51183,
    county_fips_all: '51183|51053',
    county: 'Sussex',
    county_names_all: 'Sussex|Dinwiddie',
    county_weights: '{"51183": 79.55, "51053": 20.45}',
    density: 4.9,
    imprecise: false,
    latitude: 36.92591,
    longitude: -77.41543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23882',
  },
  {
    city: 'Surry',
    county_fips: 51181,
    county_fips_all: '51181',
    county: 'Surry',
    county_names_all: 'Surry',
    county_weights: '{"51181": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 37.12546,
    longitude: -76.7502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23883',
  },
  {
    city: 'Sussex',
    county_fips: 51183,
    county_fips_all: '51183',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"51183": 100}',
    density: 30,
    imprecise: false,
    latitude: 36.91733,
    longitude: -77.28011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23884',
  },
  {
    city: 'Sutherland',
    county_fips: 51053,
    county_fips_all: '51053',
    county: 'Dinwiddie',
    county_names_all: 'Dinwiddie',
    county_weights: '{"51053": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 37.18521,
    longitude: -77.57834,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23885',
  },
  {
    city: 'Valentines',
    county_fips: 51025,
    county_fips_all: '51025',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"51025": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 36.56762,
    longitude: -77.81658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23887',
  },
  {
    city: 'Wakefield',
    county_fips: 51183,
    county_fips_all: '51183|51181|51175',
    county: 'Sussex',
    county_names_all: 'Sussex|Surry|Southampton',
    county_weights: '{"51183": 43.38, "51181": 28.85, "51175": 27.76}',
    density: 11.3,
    imprecise: false,
    latitude: 36.95383,
    longitude: -76.97802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23888',
  },
  {
    city: 'Warfield',
    county_fips: 51025,
    county_fips_all: '51025',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"51025": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 36.8972,
    longitude: -77.74395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23889',
  },
  {
    city: 'Waverly',
    county_fips: 51183,
    county_fips_all: '51183|51181',
    county: 'Sussex',
    county_names_all: 'Sussex|Surry',
    county_weights: '{"51183": 80.08, "51181": 19.92}',
    density: 8.2,
    imprecise: false,
    latitude: 37.00755,
    longitude: -77.11837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23890',
  },
  {
    city: 'White Plains',
    county_fips: 51025,
    county_fips_all: '51025',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"51025": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 36.6244,
    longitude: -77.93658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23893',
  },
  {
    city: 'Wilsons',
    county_fips: 51053,
    county_fips_all: '51053|51135',
    county: 'Dinwiddie',
    county_names_all: 'Dinwiddie|Nottoway',
    county_weights: '{"51053": 90.67, "51135": 9.33}',
    density: 4.5,
    imprecise: false,
    latitude: 37.13867,
    longitude: -77.82404,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23894',
  },
  {
    city: 'Yale',
    county_fips: 51183,
    county_fips_all: '51183|51175',
    county: 'Sussex',
    county_names_all: 'Sussex|Southampton',
    county_weights: '{"51183": 99.77, "51175": 0.23}',
    density: 5.9,
    imprecise: false,
    latitude: 36.83399,
    longitude: -77.28234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23897',
  },
  {
    city: 'Zuni',
    county_fips: 51093,
    county_fips_all: '51093|51175',
    county: 'Isle of Wight',
    county_names_all: 'Isle of Wight|Southampton',
    county_weights: '{"51093": 50.18, "51175": 49.82}',
    density: 17.3,
    imprecise: false,
    latitude: 36.82737,
    longitude: -76.85662,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23898',
  },
  {
    city: 'Claremont',
    county_fips: 51181,
    county_fips_all: '51181',
    county: 'Surry',
    county_names_all: 'Surry',
    county_weights: '{"51181": 100}',
    density: 59.4,
    imprecise: false,
    latitude: 37.23079,
    longitude: -76.96562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23899',
  },
  {
    city: 'Farmville',
    county_fips: 51049,
    county_fips_all: '51049|51147|51029',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Prince Edward|Buckingham',
    county_weights: '{"51049": 40.91, "51147": 40.3, "51029": 18.79}',
    density: 30.3,
    imprecise: false,
    latitude: 37.32309,
    longitude: -78.41186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23901',
  },
  {
    city: 'Baskerville',
    county_fips: 51117,
    county_fips_all: '51117',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"51117": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 36.70668,
    longitude: -78.28627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23915',
  },
  {
    city: 'Boydton',
    county_fips: 51117,
    county_fips_all: '51117',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"51117": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 36.62378,
    longitude: -78.34144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23917',
  },
  {
    city: 'Bracey',
    county_fips: 51117,
    county_fips_all: '51117|51025',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg|Brunswick',
    county_weights: '{"51117": 88.6, "51025": 11.4}',
    density: 33.3,
    imprecise: false,
    latitude: 36.59103,
    longitude: -78.13305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23919',
  },
  {
    city: 'Brodnax',
    county_fips: 51025,
    county_fips_all: '51025|51117|51111',
    county: 'Brunswick',
    county_names_all: 'Brunswick|Mecklenburg|Lunenburg',
    county_weights: '{"51025": 82.44, "51117": 10.51, "51111": 7.05}',
    density: 9.8,
    imprecise: false,
    latitude: 36.72452,
    longitude: -77.97266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23920',
  },
  {
    city: 'Buckingham',
    county_fips: 51029,
    county_fips_all: '51029',
    county: 'Buckingham',
    county_names_all: 'Buckingham',
    county_weights: '{"51029": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 37.59143,
    longitude: -78.61413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23921',
  },
  {
    city: 'Burkeville',
    county_fips: 51135,
    county_fips_all: '51135|51147',
    county: 'Nottoway',
    county_names_all: 'Nottoway|Prince Edward',
    county_weights: '{"51135": 77.31, "51147": 22.69}',
    density: 22.1,
    imprecise: false,
    latitude: 37.17987,
    longitude: -78.21219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23922',
  },
  {
    city: 'Charlotte Court House',
    county_fips: 51037,
    county_fips_all: '51037|51147',
    county: 'Charlotte',
    county_names_all: 'Charlotte|Prince Edward',
    county_weights: '{"51037": 94.19, "51147": 5.81}',
    density: 8.7,
    imprecise: false,
    latitude: 37.09316,
    longitude: -78.64627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23923',
  },
  {
    city: 'Chase City',
    county_fips: 51117,
    county_fips_all: '51117|51111|51037',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg|Lunenburg|Charlotte',
    county_weights: '{"51117": 84.84, "51111": 9.35, "51037": 5.81}',
    density: 16.1,
    imprecise: false,
    latitude: 36.80919,
    longitude: -78.43396,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23924',
  },
  {
    city: 'Clarksville',
    county_fips: 51117,
    county_fips_all: '51117',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"51117": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 36.60899,
    longitude: -78.51258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23927',
  },
  {
    city: 'Crewe',
    county_fips: 51135,
    county_fips_all: '51135',
    county: 'Nottoway',
    county_names_all: 'Nottoway',
    county_weights: '{"51135": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 37.17468,
    longitude: -78.09608,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23930',
  },
  {
    city: 'Cullen',
    county_fips: 51147,
    county_fips_all: '51147|51037',
    county: 'Prince Edward',
    county_names_all: 'Prince Edward|Charlotte',
    county_weights: '{"51147": 55.31, "51037": 44.69}',
    density: 4.2,
    imprecise: false,
    latitude: 37.17613,
    longitude: -78.62373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23934',
  },
  {
    city: 'Dillwyn',
    county_fips: 51029,
    county_fips_all: '51029|51049',
    county: 'Buckingham',
    county_names_all: 'Buckingham|Cumberland',
    county_weights: '{"51029": 97.98, "51049": 2.02}',
    density: 13.7,
    imprecise: false,
    latitude: 37.52494,
    longitude: -78.4819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23936',
  },
  {
    city: 'Drakes Branch',
    county_fips: 51037,
    county_fips_all: '51037|51111',
    county: 'Charlotte',
    county_names_all: 'Charlotte|Lunenburg',
    county_weights: '{"51037": 77.68, "51111": 22.32}',
    density: 11,
    imprecise: false,
    latitude: 36.94547,
    longitude: -78.52463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23937',
  },
  {
    city: 'Dundas',
    county_fips: 51025,
    county_fips_all: '51025|51111',
    county: 'Brunswick',
    county_names_all: 'Brunswick|Lunenburg',
    county_weights: '{"51025": 59.94, "51111": 40.06}',
    density: 5.2,
    imprecise: false,
    latitude: 36.90541,
    longitude: -78.00464,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23938',
  },
  {
    city: 'Green Bay',
    county_fips: 51147,
    county_fips_all: '51147|51111',
    county: 'Prince Edward',
    county_names_all: 'Prince Edward|Lunenburg',
    county_weights: '{"51147": 61.47, "51111": 38.53}',
    density: 6.2,
    imprecise: false,
    latitude: 37.13241,
    longitude: -78.30138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23942',
  },
  {
    city: 'Kenbridge',
    county_fips: 51111,
    county_fips_all: '51111',
    county: 'Lunenburg',
    county_names_all: 'Lunenburg',
    county_weights: '{"51111": 100}',
    density: 12,
    imprecise: false,
    latitude: 36.9056,
    longitude: -78.13319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23944',
  },
  {
    city: 'Keysville',
    county_fips: 51111,
    county_fips_all: '51111|51037|51147',
    county: 'Lunenburg',
    county_names_all: 'Lunenburg|Charlotte|Prince Edward',
    county_weights: '{"51111": 51.65, "51037": 37.42, "51147": 10.93}',
    density: 10.1,
    imprecise: false,
    latitude: 37.02265,
    longitude: -78.44284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23947',
  },
  {
    city: 'La Crosse',
    county_fips: 51117,
    county_fips_all: '51117|51025',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg|Brunswick',
    county_weights: '{"51117": 84.41, "51025": 15.59}',
    density: 20.4,
    imprecise: false,
    latitude: 36.66005,
    longitude: -78.07699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23950',
  },
  {
    city: 'Lunenburg',
    county_fips: 51111,
    county_fips_all: '51111',
    county: 'Lunenburg',
    county_names_all: 'Lunenburg',
    county_weights: '{"51111": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 36.91786,
    longitude: -78.27886,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23952',
  },
  {
    city: 'Meherrin',
    county_fips: 51147,
    county_fips_all: '51147|51111',
    county: 'Prince Edward',
    county_names_all: 'Prince Edward|Lunenburg',
    county_weights: '{"51147": 64.97, "51111": 35.03}',
    density: 13.8,
    imprecise: false,
    latitude: 37.10893,
    longitude: -78.38705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23954',
  },
  {
    city: 'Nottoway',
    county_fips: 51135,
    county_fips_all: '51135',
    county: 'Nottoway',
    county_names_all: 'Nottoway',
    county_weights: '{"51135": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 37.10816,
    longitude: -78.06556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23955',
  },
  {
    city: 'Pamplin',
    county_fips: 51011,
    county_fips_all: '51011|51147|51037',
    county: 'Appomattox',
    county_names_all: 'Appomattox|Prince Edward|Charlotte',
    county_weights: '{"51011": 45.73, "51147": 42.75, "51037": 11.52}',
    density: 13.6,
    imprecise: false,
    latitude: 37.26848,
    longitude: -78.65581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23958',
  },
  {
    city: 'Phenix',
    county_fips: 51037,
    county_fips_all: '51037',
    county: 'Charlotte',
    county_names_all: 'Charlotte',
    county_weights: '{"51037": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 37.10472,
    longitude: -78.79654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23959',
  },
  {
    city: 'Prospect',
    county_fips: 51147,
    county_fips_all: '51147|51011',
    county: 'Prince Edward',
    county_names_all: 'Prince Edward|Appomattox',
    county_weights: '{"51147": 97.07, "51011": 2.93}',
    density: 19.7,
    imprecise: false,
    latitude: 37.31531,
    longitude: -78.5579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23960',
  },
  {
    city: 'Randolph',
    county_fips: 51037,
    county_fips_all: '51037|51083',
    county: 'Charlotte',
    county_names_all: 'Charlotte|Halifax',
    county_weights: '{"51037": 80.59, "51083": 19.41}',
    density: 5.1,
    imprecise: false,
    latitude: 36.93865,
    longitude: -78.70399,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23962',
  },
  {
    city: 'Red House',
    county_fips: 51037,
    county_fips_all: '51037|51031|51011',
    county: 'Charlotte',
    county_names_all: 'Charlotte|Campbell|Appomattox',
    county_weights: '{"51037": 72.49, "51031": 23.57, "51011": 3.94}',
    density: 8.7,
    imprecise: false,
    latitude: 37.195,
    longitude: -78.80168,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23963',
  },
  {
    city: 'Red Oak',
    county_fips: 51037,
    county_fips_all: '51037|51117',
    county: 'Charlotte',
    county_names_all: 'Charlotte|Mecklenburg',
    county_weights: '{"51037": 88.16, "51117": 11.84}',
    density: 7.7,
    imprecise: false,
    latitude: 36.77713,
    longitude: -78.63149,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23964',
  },
  {
    city: 'Rice',
    county_fips: 51147,
    county_fips_all: '51147|51007|51135',
    county: 'Prince Edward',
    county_names_all: 'Prince Edward|Amelia|Nottoway',
    county_weights: '{"51147": 80.02, "51007": 18.82, "51135": 1.16}',
    density: 13,
    imprecise: false,
    latitude: 37.29177,
    longitude: -78.27418,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23966',
  },
  {
    city: 'Saxe',
    county_fips: 51037,
    county_fips_all: '51037',
    county: 'Charlotte',
    county_names_all: 'Charlotte',
    county_weights: '{"51037": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 36.91813,
    longitude: -78.62857,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23967',
  },
  {
    city: 'Skipwith',
    county_fips: 51117,
    county_fips_all: '51117',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"51117": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 36.72123,
    longitude: -78.51922,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23968',
  },
  {
    city: 'South Hill',
    county_fips: 51117,
    county_fips_all: '51117|51111',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg|Lunenburg',
    county_weights: '{"51117": 78.21, "51111": 21.79}',
    density: 25.8,
    imprecise: false,
    latitude: 36.74818,
    longitude: -78.18637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23970',
  },
  {
    city: 'Victoria',
    county_fips: 51111,
    county_fips_all: '51111',
    county: 'Lunenburg',
    county_names_all: 'Lunenburg',
    county_weights: '{"51111": 100}',
    density: 20,
    imprecise: false,
    latitude: 36.97323,
    longitude: -78.24549,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23974',
  },
  {
    city: 'Wylliesburg',
    county_fips: 51037,
    county_fips_all: '51037',
    county: 'Charlotte',
    county_names_all: 'Charlotte',
    county_weights: '{"51037": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 36.8482,
    longitude: -78.5797,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23976',
  },
  {
    city: 'Roanoke',
    county_fips: 51770,
    county_fips_all: '51770',
    county: 'Roanoke',
    county_names_all: 'Roanoke',
    county_weights: '{"51770": 100}',
    density: 1831.9,
    imprecise: false,
    latitude: 37.27048,
    longitude: -79.94128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24011',
  },
  {
    city: 'Roanoke',
    county_fips: 51770,
    county_fips_all: '51770|51023|51161',
    county: 'Roanoke',
    county_names_all: 'Roanoke|Botetourt|Roanoke',
    county_weights: '{"51770": 49.5, "51023": 27.39, "51161": 23.11}',
    density: 536.1,
    imprecise: false,
    latitude: 37.31585,
    longitude: -79.89833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24012',
  },
  {
    city: 'Roanoke',
    county_fips: 51770,
    county_fips_all: '51770',
    county: 'Roanoke',
    county_names_all: 'Roanoke',
    county_weights: '{"51770": 100}',
    density: 1422.3,
    imprecise: false,
    latitude: 37.26691,
    longitude: -79.92219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24013',
  },
  {
    city: 'Roanoke',
    county_fips: 51161,
    county_fips_all: '51161|51770',
    county: 'Roanoke',
    county_names_all: 'Roanoke|Roanoke',
    county_weights: '{"51161": 72.0, "51770": 28.0}',
    density: 216.4,
    imprecise: false,
    latitude: 37.22427,
    longitude: -79.91282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24014',
  },
  {
    city: 'Roanoke',
    county_fips: 51770,
    county_fips_all: '51770|51161',
    county: 'Roanoke',
    county_names_all: 'Roanoke|Roanoke',
    county_weights: '{"51770": 96.71, "51161": 3.29}',
    density: 1308.6,
    imprecise: false,
    latitude: 37.25588,
    longitude: -79.97979,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24015',
  },
  {
    city: 'Roanoke',
    county_fips: 51770,
    county_fips_all: '51770',
    county: 'Roanoke',
    county_names_all: 'Roanoke',
    county_weights: '{"51770": 100}',
    density: 1356.5,
    imprecise: false,
    latitude: 37.27208,
    longitude: -79.95468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24016',
  },
  {
    city: 'Roanoke',
    county_fips: 51770,
    county_fips_all: '51770',
    county: 'Roanoke',
    county_names_all: 'Roanoke',
    county_weights: '{"51770": 100}',
    density: 1013,
    imprecise: false,
    latitude: 37.29472,
    longitude: -79.99183,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24017',
  },
  {
    city: 'Roanoke',
    county_fips: 51161,
    county_fips_all: '51161|51770',
    county: 'Roanoke',
    county_names_all: 'Roanoke|Roanoke',
    county_weights: '{"51161": 93.77, "51770": 6.23}',
    density: 349.5,
    imprecise: false,
    latitude: 37.21238,
    longitude: -80.04261,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24018',
  },
  {
    city: 'Roanoke',
    county_fips: 51161,
    county_fips_all: '51161|51023|51770',
    county: 'Roanoke',
    county_names_all: 'Roanoke|Botetourt|Roanoke',
    county_weights: '{"51161": 65.92, "51023": 23.81, "51770": 10.27}',
    density: 365,
    imprecise: false,
    latitude: 37.3446,
    longitude: -79.95564,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24019',
  },
  {
    city: 'Roanoke',
    county_fips: 51161,
    county_fips_all: '51161',
    county: 'Roanoke',
    county_names_all: 'Roanoke',
    county_weights: '{"51161": 100}',
    density: 633.3,
    imprecise: false,
    latitude: 37.35739,
    longitude: -79.94279,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24020',
  },
  {
    city: 'Roanoke',
    county_fips: 51770,
    county_fips_all: '51770',
    county: 'Roanoke',
    county_names_all: 'Roanoke',
    county_weights: '{"51770": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.27689,
    longitude: -79.93429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24022',
  },
  {
    city: 'Ararat',
    county_fips: 51141,
    county_fips_all: '51141|51035',
    county: 'Patrick',
    county_names_all: 'Patrick|Carroll',
    county_weights: '{"51141": 96.37, "51035": 3.63}',
    density: 18.6,
    imprecise: false,
    latitude: 36.60999,
    longitude: -80.53283,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24053',
  },
  {
    city: 'Axton',
    county_fips: 51089,
    county_fips_all: '51089|51143',
    county: 'Henry',
    county_names_all: 'Henry|Pittsylvania',
    county_weights: '{"51089": 67.4, "51143": 32.6}',
    density: 21,
    imprecise: false,
    latitude: 36.67806,
    longitude: -79.70396,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24054',
  },
  {
    city: 'Bassett',
    county_fips: 51089,
    county_fips_all: '51089|51067|51141',
    county: 'Henry',
    county_names_all: 'Henry|Franklin|Patrick',
    county_weights: '{"51089": 77.46, "51067": 11.94, "51141": 10.6}',
    density: 52.7,
    imprecise: false,
    latitude: 36.76333,
    longitude: -79.99741,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24055',
  },
  {
    city: 'Belspring',
    county_fips: 51155,
    county_fips_all: '51155',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"51155": 100}',
    density: 40.5,
    imprecise: false,
    latitude: 37.18257,
    longitude: -80.61637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24058',
  },
  {
    city: 'Bent Mountain',
    county_fips: 51161,
    county_fips_all: '51161|51067|51121',
    county: 'Roanoke',
    county_names_all: 'Roanoke|Franklin|Montgomery',
    county_weights: '{"51161": 88.62, "51067": 10.93, "51121": 0.45}',
    density: 13.5,
    imprecise: false,
    latitude: 37.15577,
    longitude: -80.13159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24059',
  },
  {
    city: 'Blacksburg',
    county_fips: 51121,
    county_fips_all: '51121',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"51121": 100}',
    density: 143.3,
    imprecise: false,
    latitude: 37.25772,
    longitude: -80.41961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24060',
  },
  {
    city: 'Blue Ridge',
    county_fips: 51019,
    county_fips_all: '51019|51023',
    county: 'Bedford',
    county_names_all: 'Bedford|Botetourt',
    county_weights: '{"51019": 68.73, "51023": 31.27}',
    density: 54.7,
    imprecise: false,
    latitude: 37.37237,
    longitude: -79.7759,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24064',
  },
  {
    city: 'Boones Mill',
    county_fips: 51067,
    county_fips_all: '51067|51161',
    county: 'Franklin',
    county_names_all: 'Franklin|Roanoke',
    county_weights: '{"51067": 84.5, "51161": 15.5}',
    density: 31,
    imprecise: false,
    latitude: 37.11814,
    longitude: -79.96453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24065',
  },
  {
    city: 'Buchanan',
    county_fips: 51023,
    county_fips_all: '51023|51163',
    county: 'Botetourt',
    county_names_all: 'Botetourt|Rockbridge',
    county_weights: '{"51023": 98.35, "51163": 1.65}',
    density: 12.2,
    imprecise: false,
    latitude: 37.5382,
    longitude: -79.67822,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24066',
  },
  {
    city: 'Callaway',
    county_fips: 51067,
    county_fips_all: '51067',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"51067": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 37.03737,
    longitude: -80.06884,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24067',
  },
  {
    city: 'Cascade',
    county_fips: 51143,
    county_fips_all: '51143',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania',
    county_weights: '{"51143": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 36.58376,
    longitude: -79.63779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24069',
  },
  {
    city: 'Catawba',
    county_fips: 51161,
    county_fips_all: '51161|51045|51121',
    county: 'Roanoke',
    county_names_all: 'Roanoke|Craig|Montgomery',
    county_weights: '{"51161": 47.93, "51045": 47.16, "51121": 4.91}',
    density: 8,
    imprecise: false,
    latitude: 37.37316,
    longitude: -80.21238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24070',
  },
  {
    city: 'Check',
    county_fips: 51063,
    county_fips_all: '51063',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"51063": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 37.03809,
    longitude: -80.23113,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24072',
  },
  {
    city: 'Christiansburg',
    county_fips: 51121,
    county_fips_all: '51121',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"51121": 100}',
    density: 127.9,
    imprecise: false,
    latitude: 37.13053,
    longitude: -80.4225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24073',
  },
  {
    city: 'Claudville',
    county_fips: 51141,
    county_fips_all: '51141',
    county: 'Patrick',
    county_names_all: 'Patrick',
    county_weights: '{"51141": 100}',
    density: 8,
    imprecise: false,
    latitude: 36.59704,
    longitude: -80.42116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24076',
  },
  {
    city: 'Cloverdale',
    county_fips: 51023,
    county_fips_all: '51023',
    county: 'Botetourt',
    county_names_all: 'Botetourt',
    county_weights: '{"51023": 100}',
    density: 626.3,
    imprecise: false,
    latitude: 37.36337,
    longitude: -79.90278,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24077',
  },
  {
    city: 'Collinsville',
    county_fips: 51089,
    county_fips_all: '51089',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"51089": 100}',
    density: 359.6,
    imprecise: false,
    latitude: 36.72376,
    longitude: -79.91303,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24078',
  },
  {
    city: 'Copper Hill',
    county_fips: 51063,
    county_fips_all: '51063|51067',
    county: 'Floyd',
    county_names_all: 'Floyd|Franklin',
    county_weights: '{"51063": 96.93, "51067": 3.07}',
    density: 13.8,
    imprecise: false,
    latitude: 37.0539,
    longitude: -80.15418,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24079',
  },
  {
    city: 'Critz',
    county_fips: 51141,
    county_fips_all: '51141',
    county: 'Patrick',
    county_names_all: 'Patrick',
    county_weights: '{"51141": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 36.62923,
    longitude: -80.13204,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24082',
  },
  {
    city: 'Daleville',
    county_fips: 51023,
    county_fips_all: '51023',
    county: 'Botetourt',
    county_names_all: 'Botetourt',
    county_weights: '{"51023": 100}',
    density: 189.9,
    imprecise: false,
    latitude: 37.40614,
    longitude: -79.92031,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24083',
  },
  {
    city: 'Dublin',
    county_fips: 51155,
    county_fips_all: '51155|51021',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Bland',
    county_weights: '{"51155": 74.94, "51021": 25.06}',
    density: 36.1,
    imprecise: false,
    latitude: 37.11468,
    longitude: -80.79088,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24084',
  },
  {
    city: 'Eagle Rock',
    county_fips: 51023,
    county_fips_all: '51023|51005',
    county: 'Botetourt',
    county_names_all: 'Botetourt|Alleghany',
    county_weights: '{"51023": 98.4, "51005": 1.6}',
    density: 5.6,
    imprecise: false,
    latitude: 37.67539,
    longitude: -79.83639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24085',
  },
  {
    city: 'Eggleston',
    county_fips: 51071,
    county_fips_all: '51071',
    county: 'Giles',
    county_names_all: 'Giles',
    county_weights: '{"51071": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 37.27268,
    longitude: -80.63585,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24086',
  },
  {
    city: 'Elliston',
    county_fips: 51121,
    county_fips_all: '51121|51161',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Roanoke',
    county_weights: '{"51121": 96.46, "51161": 3.54}',
    density: 33.3,
    imprecise: false,
    latitude: 37.22594,
    longitude: -80.24748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24087',
  },
  {
    city: 'Ferrum',
    county_fips: 51067,
    county_fips_all: '51067|51141',
    county: 'Franklin',
    county_names_all: 'Franklin|Patrick',
    county_weights: '{"51067": 83.69, "51141": 16.31}',
    density: 17.2,
    imprecise: false,
    latitude: 36.89492,
    longitude: -80.0798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24088',
  },
  {
    city: 'Fieldale',
    county_fips: 51089,
    county_fips_all: '51089',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"51089": 100}',
    density: 70.9,
    imprecise: false,
    latitude: 36.70392,
    longitude: -79.96078,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24089',
  },
  {
    city: 'Fincastle',
    county_fips: 51023,
    county_fips_all: '51023',
    county: 'Botetourt',
    county_names_all: 'Botetourt',
    county_weights: '{"51023": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 37.52633,
    longitude: -79.88921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24090',
  },
  {
    city: 'Floyd',
    county_fips: 51063,
    county_fips_all: '51063|51067|51141',
    county: 'Floyd',
    county_names_all: 'Floyd|Franklin|Patrick',
    county_weights: '{"51063": 94.5, "51067": 3.9, "51141": 1.6}',
    density: 16.7,
    imprecise: false,
    latitude: 36.92131,
    longitude: -80.32264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24091',
  },
  {
    city: 'Glade Hill',
    county_fips: 51067,
    county_fips_all: '51067',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"51067": 100}',
    density: 35.2,
    imprecise: false,
    latitude: 37.00158,
    longitude: -79.76306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24092',
  },
  {
    city: 'Glen Lyn',
    county_fips: 51071,
    county_fips_all: '51071',
    county: 'Giles',
    county_names_all: 'Giles',
    county_weights: '{"51071": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 37.38784,
    longitude: -80.85657,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24093',
  },
  {
    city: 'Goodview',
    county_fips: 51019,
    county_fips_all: '51019',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"51019": 100}',
    density: 61,
    imprecise: false,
    latitude: 37.22304,
    longitude: -79.73787,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24095',
  },
  {
    city: 'Hardy',
    county_fips: 51067,
    county_fips_all: '51067|51019|51161',
    county: 'Franklin',
    county_names_all: 'Franklin|Bedford|Roanoke',
    county_weights: '{"51067": 91.67, "51019": 7.27, "51161": 1.06}',
    density: 43,
    imprecise: false,
    latitude: 37.17702,
    longitude: -79.80111,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24101',
  },
  {
    city: 'Henry',
    county_fips: 51067,
    county_fips_all: '51067|51089',
    county: 'Franklin',
    county_names_all: 'Franklin|Henry',
    county_weights: '{"51067": 92.66, "51089": 7.34}',
    density: 15.4,
    imprecise: false,
    latitude: 36.83994,
    longitude: -79.99891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24102',
  },
  {
    city: 'Huddleston',
    county_fips: 51019,
    county_fips_all: '51019',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"51019": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 37.13546,
    longitude: -79.48773,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24104',
  },
  {
    city: 'Indian Valley',
    county_fips: 51063,
    county_fips_all: '51063|51035',
    county: 'Floyd',
    county_names_all: 'Floyd|Carroll',
    county_weights: '{"51063": 65.6, "51035": 34.4}',
    density: 8.1,
    imprecise: false,
    latitude: 36.90278,
    longitude: -80.60127,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24105',
  },
  {
    city: 'Martinsville',
    county_fips: 51089,
    county_fips_all: '51089|51067|51690',
    county: 'Henry',
    county_names_all: 'Henry|Franklin|Martinsville',
    county_weights: '{"51089": 79.94, "51067": 12.82, "51690": 7.24}',
    density: 79.2,
    imprecise: false,
    latitude: 36.72378,
    longitude: -79.84921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24112',
  },
  {
    city: 'Meadows Of Dan',
    county_fips: 51141,
    county_fips_all: '51141|51063|51035',
    county: 'Patrick',
    county_names_all: 'Patrick|Floyd|Carroll',
    county_weights: '{"51141": 74.2, "51063": 17.02, "51035": 8.78}',
    density: 8.1,
    imprecise: false,
    latitude: 36.71891,
    longitude: -80.41277,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24120',
  },
  {
    city: 'Moneta',
    county_fips: 51019,
    county_fips_all: '51019|51067',
    county: 'Bedford',
    county_names_all: 'Bedford|Franklin',
    county_weights: '{"51019": 73.07, "51067": 26.93}',
    density: 43.4,
    imprecise: false,
    latitude: 37.1709,
    longitude: -79.64141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24121',
  },
  {
    city: 'Montvale',
    county_fips: 51019,
    county_fips_all: '51019',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"51019": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 37.4212,
    longitude: -79.69372,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24122',
  },
  {
    city: 'Narrows',
    county_fips: 51071,
    county_fips_all: '51071|51021',
    county: 'Giles',
    county_names_all: 'Giles|Bland',
    county_weights: '{"51071": 88.03, "51021": 11.97}',
    density: 20.2,
    imprecise: false,
    latitude: 37.30996,
    longitude: -80.86774,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24124',
  },
  {
    city: 'New Castle',
    county_fips: 51045,
    county_fips_all: '51045',
    county: 'Craig',
    county_names_all: 'Craig',
    county_weights: '{"51045": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 37.47949,
    longitude: -80.19468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24127',
  },
  {
    city: 'Newport',
    county_fips: 51071,
    county_fips_all: '51071|51045',
    county: 'Giles',
    county_names_all: 'Giles|Craig',
    county_weights: '{"51071": 71.37, "51045": 28.63}',
    density: 7.6,
    imprecise: false,
    latitude: 37.3426,
    longitude: -80.47196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24128',
  },
  {
    city: 'New River',
    county_fips: 51155,
    county_fips_all: '51155',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"51155": 100}',
    density: 1184.1,
    imprecise: false,
    latitude: 37.13947,
    longitude: -80.5918,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24129',
  },
  {
    city: 'Paint Bank',
    county_fips: 51045,
    county_fips_all: '51045',
    county: 'Craig',
    county_names_all: 'Craig',
    county_weights: '{"51045": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 37.56836,
    longitude: -80.22894,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24131',
  },
  {
    city: 'Parrott',
    county_fips: 51155,
    county_fips_all: '51155',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"51155": 100}',
    density: 18.5,
    imprecise: false,
    latitude: 37.20534,
    longitude: -80.64707,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24132',
  },
  {
    city: 'Patrick Springs',
    county_fips: 51141,
    county_fips_all: '51141|51089',
    county: 'Patrick',
    county_names_all: 'Patrick|Henry',
    county_weights: '{"51141": 99.46, "51089": 0.54}',
    density: 21.1,
    imprecise: false,
    latitude: 36.67563,
    longitude: -80.12794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24133',
  },
  {
    city: 'Pearisburg',
    county_fips: 51071,
    county_fips_all: '51071',
    county: 'Giles',
    county_names_all: 'Giles',
    county_weights: '{"51071": 100}',
    density: 20,
    imprecise: false,
    latitude: 37.24595,
    longitude: -80.77901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24134',
  },
  {
    city: 'Pembroke',
    county_fips: 51071,
    county_fips_all: '51071',
    county: 'Giles',
    county_names_all: 'Giles',
    county_weights: '{"51071": 100}',
    density: 35.2,
    imprecise: false,
    latitude: 37.31927,
    longitude: -80.60686,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24136',
  },
  {
    city: 'Penhook',
    county_fips: 51067,
    county_fips_all: '51067|51143',
    county: 'Franklin',
    county_names_all: 'Franklin|Pittsylvania',
    county_weights: '{"51067": 78.76, "51143": 21.24}',
    density: 14.9,
    imprecise: false,
    latitude: 36.92587,
    longitude: -79.65456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24137',
  },
  {
    city: 'Pilot',
    county_fips: 51121,
    county_fips_all: '51121|51063',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Floyd',
    county_weights: '{"51121": 50.07, "51063": 49.93}',
    density: 22,
    imprecise: false,
    latitude: 37.05052,
    longitude: -80.31684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24138',
  },
  {
    city: 'Pittsville',
    county_fips: 51143,
    county_fips_all: '51143|51019',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania|Bedford',
    county_weights: '{"51143": 75.36, "51019": 24.64}',
    density: 10.4,
    imprecise: false,
    latitude: 37.01092,
    longitude: -79.4752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24139',
  },
  {
    city: 'Radford',
    county_fips: 51155,
    county_fips_all: '51155|51121|51750|51063',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Montgomery|Radford|Floyd',
    county_weights:
      '{"51155": 48.7, "51121": 29.82, "51750": 14.32, "51063": 7.15}',
    density: 126.5,
    imprecise: false,
    latitude: 37.10105,
    longitude: -80.56677,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24141',
  },
  {
    city: 'Rich Creek',
    county_fips: 51071,
    county_fips_all: '51071',
    county: 'Giles',
    county_names_all: 'Giles',
    county_weights: '{"51071": 100}',
    density: 84.7,
    imprecise: false,
    latitude: 37.40178,
    longitude: -80.82815,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24147',
  },
  {
    city: 'Ridgeway',
    county_fips: 51089,
    county_fips_all: '51089',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"51089": 100}',
    density: 45.5,
    imprecise: false,
    latitude: 36.58156,
    longitude: -79.87231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24148',
  },
  {
    city: 'Riner',
    county_fips: 51121,
    county_fips_all: '51121|51063',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Floyd',
    county_weights: '{"51121": 66.11, "51063": 33.89}',
    density: 27.9,
    imprecise: false,
    latitude: 37.02277,
    longitude: -80.43424,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24149',
  },
  {
    city: 'Ripplemead',
    county_fips: 51071,
    county_fips_all: '51071',
    county: 'Giles',
    county_names_all: 'Giles',
    county_weights: '{"51071": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 37.40229,
    longitude: -80.59694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24150',
  },
  {
    city: 'Rocky Mount',
    county_fips: 51067,
    county_fips_all: '51067',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"51067": 100}',
    density: 42.4,
    imprecise: false,
    latitude: 36.95827,
    longitude: -79.86457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24151',
  },
  {
    city: 'Salem',
    county_fips: 51161,
    county_fips_all: '51161|51775|51023',
    county: 'Roanoke',
    county_names_all: 'Roanoke|Salem|Botetourt',
    county_weights: '{"51161": 84.73, "51775": 14.37, "51023": 0.9}',
    density: 148.4,
    imprecise: false,
    latitude: 37.29674,
    longitude: -80.11609,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24153',
  },
  {
    city: 'Sandy Level',
    county_fips: 51143,
    county_fips_all: '51143',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania',
    county_weights: '{"51143": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 36.98132,
    longitude: -79.54391,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24161',
  },
  {
    city: 'Shawsville',
    county_fips: 51121,
    county_fips_all: '51121|51063',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Floyd',
    county_weights: '{"51121": 97.78, "51063": 2.22}',
    density: 18.6,
    imprecise: false,
    latitude: 37.13735,
    longitude: -80.25828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24162',
  },
  {
    city: 'Spencer',
    county_fips: 51089,
    county_fips_all: '51089|51141',
    county: 'Henry',
    county_names_all: 'Henry|Patrick',
    county_weights: '{"51089": 51.32, "51141": 48.68}',
    density: 17.7,
    imprecise: false,
    latitude: 36.58368,
    longitude: -80.05319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24165',
  },
  {
    city: 'Staffordsville',
    county_fips: 51071,
    county_fips_all: '51071',
    county: 'Giles',
    county_names_all: 'Giles',
    county_weights: '{"51071": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 37.24718,
    longitude: -80.7345,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24167',
  },
  {
    city: 'Stanleytown',
    county_fips: 51089,
    county_fips_all: '51089',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"51089": 100}',
    density: 67.9,
    imprecise: false,
    latitude: 36.73613,
    longitude: -79.94876,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24168',
  },
  {
    city: 'Stuart',
    county_fips: 51141,
    county_fips_all: '51141',
    county: 'Patrick',
    county_names_all: 'Patrick',
    county_weights: '{"51141": 100}',
    density: 16,
    imprecise: false,
    latitude: 36.67095,
    longitude: -80.23835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24171',
  },
  {
    city: 'Thaxton',
    county_fips: 51019,
    county_fips_all: '51019',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"51019": 100}',
    density: 26.9,
    imprecise: false,
    latitude: 37.35087,
    longitude: -79.66762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24174',
  },
  {
    city: 'Troutville',
    county_fips: 51023,
    county_fips_all: '51023|51161',
    county: 'Botetourt',
    county_names_all: 'Botetourt|Roanoke',
    county_weights: '{"51023": 95.33, "51161": 4.67}',
    density: 39,
    imprecise: false,
    latitude: 37.42589,
    longitude: -79.93788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24175',
  },
  {
    city: 'Union Hall',
    county_fips: 51067,
    county_fips_all: '51067',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"51067": 100}',
    density: 27.8,
    imprecise: false,
    latitude: 37.00937,
    longitude: -79.69193,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24176',
  },
  {
    city: 'Vinton',
    county_fips: 51019,
    county_fips_all: '51019|51161|51770',
    county: 'Bedford',
    county_names_all: 'Bedford|Roanoke|Roanoke',
    county_weights: '{"51019": 80.78, "51161": 18.79, "51770": 0.43}',
    density: 152.6,
    imprecise: false,
    latitude: 37.2855,
    longitude: -79.79963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24179',
  },
  {
    city: 'Wirtz',
    county_fips: 51067,
    county_fips_all: '51067',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"51067": 100}',
    density: 42.2,
    imprecise: false,
    latitude: 37.0881,
    longitude: -79.77642,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24184',
  },
  {
    city: 'Woolwine',
    county_fips: 51141,
    county_fips_all: '51141',
    county: 'Patrick',
    county_names_all: 'Patrick',
    county_weights: '{"51141": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 36.80868,
    longitude: -80.27557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24185',
  },
  {
    city: 'Bristol',
    county_fips: 51520,
    county_fips_all: '51520',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"51520": 100}',
    density: 607.3,
    imprecise: false,
    latitude: 36.61059,
    longitude: -82.16971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24201',
  },
  {
    city: 'Bristol',
    county_fips: 51191,
    county_fips_all: '51191|51169|51520',
    county: 'Washington',
    county_names_all: 'Washington|Scott|Bristol',
    county_weights: '{"51191": 79.66, "51169": 18.15, "51520": 2.19}',
    density: 37.1,
    imprecise: false,
    latitude: 36.65904,
    longitude: -82.21564,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24202',
  },
  {
    city: 'Abingdon',
    county_fips: 51191,
    county_fips_all: '51191',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"51191": 100}',
    density: 45,
    imprecise: false,
    latitude: 36.77231,
    longitude: -82.02244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24210',
  },
  {
    city: 'Abingdon',
    county_fips: 51191,
    county_fips_all: '51191',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"51191": 100}',
    density: 56.6,
    imprecise: false,
    latitude: 36.65413,
    longitude: -81.95643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24211',
  },
  {
    city: 'Appalachia',
    county_fips: 51195,
    county_fips_all: '51195',
    county: 'Wise',
    county_names_all: 'Wise',
    county_weights: '{"51195": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 36.94237,
    longitude: -82.79571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24216',
  },
  {
    city: 'Bee',
    county_fips: 51051,
    county_fips_all: '51051|51027',
    county: 'Dickenson',
    county_names_all: 'Dickenson|Buchanan',
    county_weights: '{"51051": 77.43, "51027": 22.57}',
    density: 7,
    imprecise: false,
    latitude: 37.1014,
    longitude: -82.17783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24217',
  },
  {
    city: 'Big Stone Gap',
    county_fips: 51195,
    county_fips_all: '51195|51105|51169',
    county: 'Wise',
    county_names_all: 'Wise|Lee|Scott',
    county_weights: '{"51195": 68.51, "51105": 24.44, "51169": 7.05}',
    density: 55.5,
    imprecise: false,
    latitude: 36.84831,
    longitude: -82.74645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24219',
  },
  {
    city: 'Birchleaf',
    county_fips: 51051,
    county_fips_all: '51051',
    county: 'Dickenson',
    county_names_all: 'Dickenson',
    county_weights: '{"51051": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 37.11957,
    longitude: -82.22641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24220',
  },
  {
    city: 'Blackwater',
    county_fips: 51105,
    county_fips_all: '51105|51169',
    county: 'Lee',
    county_names_all: 'Lee|Scott',
    county_weights: '{"51105": 61.01, "51169": 38.99}',
    density: 4.7,
    imprecise: false,
    latitude: 36.63398,
    longitude: -82.9943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24221',
  },
  {
    city: 'Castlewood',
    county_fips: 51167,
    county_fips_all: '51167',
    county: 'Russell',
    county_names_all: 'Russell',
    county_weights: '{"51167": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 36.86059,
    longitude: -82.28322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24224',
  },
  {
    city: 'Cleveland',
    county_fips: 51167,
    county_fips_all: '51167|51051',
    county: 'Russell',
    county_names_all: 'Russell|Dickenson',
    county_weights: '{"51167": 99.02, "51051": 0.98}',
    density: 11.4,
    imprecise: false,
    latitude: 36.97543,
    longitude: -82.14115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24225',
  },
  {
    city: 'Clinchco',
    county_fips: 51051,
    county_fips_all: '51051',
    county: 'Dickenson',
    county_names_all: 'Dickenson',
    county_weights: '{"51051": 100}',
    density: 31.2,
    imprecise: false,
    latitude: 37.14223,
    longitude: -82.33384,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24226',
  },
  {
    city: 'Clintwood',
    county_fips: 51051,
    county_fips_all: '51051',
    county: 'Dickenson',
    county_names_all: 'Dickenson',
    county_weights: '{"51051": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 37.17047,
    longitude: -82.44963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24228',
  },
  {
    city: 'Coeburn',
    county_fips: 51195,
    county_fips_all: '51195|51051|51169',
    county: 'Wise',
    county_names_all: 'Wise|Dickenson|Scott',
    county_weights: '{"51195": 58.47, "51051": 34.02, "51169": 7.51}',
    density: 21.5,
    imprecise: false,
    latitude: 36.96928,
    longitude: -82.45449,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24230',
  },
  {
    city: 'Damascus',
    county_fips: 51191,
    county_fips_all: '51191|51173',
    county: 'Washington',
    county_names_all: 'Washington|Smyth',
    county_weights: '{"51191": 95.94, "51173": 4.06}',
    density: 20,
    imprecise: false,
    latitude: 36.64408,
    longitude: -81.73689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24236',
  },
  {
    city: 'Dante',
    county_fips: 51051,
    county_fips_all: '51051|51167',
    county: 'Dickenson',
    county_names_all: 'Dickenson|Russell',
    county_weights: '{"51051": 76.47, "51167": 23.53}',
    density: 7.6,
    imprecise: false,
    latitude: 37.03939,
    longitude: -82.26424,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24237',
  },
  {
    city: 'Davenport',
    county_fips: 51027,
    county_fips_all: '51027',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"51027": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 37.1136,
    longitude: -82.14577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24239',
  },
  {
    city: 'Dryden',
    county_fips: 51105,
    county_fips_all: '51105',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"51105": 100}',
    density: 24.4,
    imprecise: false,
    latitude: 36.78174,
    longitude: -82.92083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24243',
  },
  {
    city: 'Duffield',
    county_fips: 51169,
    county_fips_all: '51169|51105',
    county: 'Scott',
    county_names_all: 'Scott|Lee',
    county_weights: '{"51169": 82.7, "51105": 17.3}',
    density: 12.8,
    imprecise: false,
    latitude: 36.71075,
    longitude: -82.79785,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24244',
  },
  {
    city: 'Dungannon',
    county_fips: 51169,
    county_fips_all: '51169',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"51169": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 36.84045,
    longitude: -82.51598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24245',
  },
  {
    city: 'East Stone Gap',
    county_fips: 51195,
    county_fips_all: '51195',
    county: 'Wise',
    county_names_all: 'Wise',
    county_weights: '{"51195": 100}',
    density: 75.9,
    imprecise: false,
    latitude: 36.86609,
    longitude: -82.74395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 78,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24246',
  },
  {
    city: 'Ewing',
    county_fips: 51105,
    county_fips_all: '51105',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"51105": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 36.62708,
    longitude: -83.50767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24248',
  },
  {
    city: 'Fort Blackmore',
    county_fips: 51169,
    county_fips_all: '51169',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"51169": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 36.75752,
    longitude: -82.58705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24250',
  },
  {
    city: 'Gate City',
    county_fips: 51169,
    county_fips_all: '51169',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"51169": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 36.65807,
    longitude: -82.60582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24251',
  },
  {
    city: 'Haysi',
    county_fips: 51051,
    county_fips_all: '51051|51027',
    county: 'Dickenson',
    county_names_all: 'Dickenson|Buchanan',
    county_weights: '{"51051": 82.43, "51027": 17.57}',
    density: 21,
    imprecise: false,
    latitude: 37.22344,
    longitude: -82.28503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24256',
  },
  {
    city: 'Hiltons',
    county_fips: 51169,
    county_fips_all: '51169|51191',
    county: 'Scott',
    county_names_all: 'Scott|Washington',
    county_weights: '{"51169": 93.27, "51191": 6.73}',
    density: 11.4,
    imprecise: false,
    latitude: 36.6517,
    longitude: -82.41199,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24258',
  },
  {
    city: 'Honaker',
    county_fips: 51167,
    county_fips_all: '51167|51027',
    county: 'Russell',
    county_names_all: 'Russell|Buchanan',
    county_weights: '{"51167": 78.65, "51027": 21.35}',
    density: 20.3,
    imprecise: false,
    latitude: 37.02291,
    longitude: -82.00059,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24260',
  },
  {
    city: 'Jonesville',
    county_fips: 51105,
    county_fips_all: '51105',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"51105": 100}',
    density: 19,
    imprecise: false,
    latitude: 36.67164,
    longitude: -83.15079,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24263',
  },
  {
    city: 'Keokee',
    county_fips: 51105,
    county_fips_all: '51105',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"51105": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 36.83811,
    longitude: -82.93904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24265',
  },
  {
    city: 'Lebanon',
    county_fips: 51167,
    county_fips_all: '51167',
    county: 'Russell',
    county_names_all: 'Russell',
    county_weights: '{"51167": 100}',
    density: 26.7,
    imprecise: false,
    latitude: 36.8671,
    longitude: -82.10523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24266',
  },
  {
    city: 'McClure',
    county_fips: 51051,
    county_fips_all: '51051',
    county: 'Dickenson',
    county_names_all: 'Dickenson',
    county_weights: '{"51051": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 37.0803,
    longitude: -82.37894,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24269',
  },
  {
    city: 'Mendota',
    county_fips: 51191,
    county_fips_all: '51191',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"51191": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 36.72846,
    longitude: -82.24693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24270',
  },
  {
    city: 'Nickelsville',
    county_fips: 51169,
    county_fips_all: '51169|51167',
    county: 'Scott',
    county_names_all: 'Scott|Russell',
    county_weights: '{"51169": 99.19, "51167": 0.81}',
    density: 15.2,
    imprecise: false,
    latitude: 36.74712,
    longitude: -82.41714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24271',
  },
  {
    city: 'Nora',
    county_fips: 51051,
    county_fips_all: '51051',
    county: 'Dickenson',
    county_names_all: 'Dickenson',
    county_weights: '{"51051": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 37.0302,
    longitude: -82.33401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24272',
  },
  {
    city: 'Norton',
    county_fips: 51195,
    county_fips_all: '51195|51720',
    county: 'Wise',
    county_names_all: 'Wise|Norton',
    county_weights: '{"51195": 88.4, "51720": 11.6}',
    density: 33.5,
    imprecise: false,
    latitude: 36.96142,
    longitude: -82.65632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24273',
  },
  {
    city: 'Pennington Gap',
    county_fips: 51105,
    county_fips_all: '51105',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"51105": 100}',
    density: 42.4,
    imprecise: false,
    latitude: 36.74948,
    longitude: -83.03037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24277',
  },
  {
    city: 'Pound',
    county_fips: 51195,
    county_fips_all: '51195',
    county: 'Wise',
    county_names_all: 'Wise',
    county_weights: '{"51195": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 37.10383,
    longitude: -82.61909,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24279',
  },
  {
    city: 'Rosedale',
    county_fips: 51167,
    county_fips_all: '51167',
    county: 'Russell',
    county_names_all: 'Russell',
    county_weights: '{"51167": 100}',
    density: 30.3,
    imprecise: false,
    latitude: 36.95575,
    longitude: -81.94167,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24280',
  },
  {
    city: 'Rose Hill',
    county_fips: 51105,
    county_fips_all: '51105',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"51105": 100}',
    density: 14,
    imprecise: false,
    latitude: 36.65051,
    longitude: -83.3295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24281',
  },
  {
    city: 'Saint Charles',
    county_fips: 51105,
    county_fips_all: '51105',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"51105": 100}',
    density: 29.7,
    imprecise: false,
    latitude: 36.82159,
    longitude: -83.05533,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24282',
  },
  {
    city: 'Saint Paul',
    county_fips: 51195,
    county_fips_all: '51195|51167|51051',
    county: 'Wise',
    county_names_all: 'Wise|Russell|Dickenson',
    county_weights: '{"51195": 70.08, "51167": 16.54, "51051": 13.38}',
    density: 27.4,
    imprecise: false,
    latitude: 36.94155,
    longitude: -82.34554,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24283',
  },
  {
    city: 'Weber City',
    county_fips: 51169,
    county_fips_all: '51169',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"51169": 100}',
    density: 175,
    imprecise: false,
    latitude: 36.61186,
    longitude: -82.56688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24290',
  },
  {
    city: 'Whitetop',
    county_fips: 51077,
    county_fips_all: '51077',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"51077": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 36.6147,
    longitude: -81.5791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24292',
  },
  {
    city: 'Wise',
    county_fips: 51195,
    county_fips_all: '51195',
    county: 'Wise',
    county_names_all: 'Wise',
    county_weights: '{"51195": 100}',
    density: 66.7,
    imprecise: false,
    latitude: 37.00559,
    longitude: -82.56458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24293',
  },
  {
    city: 'Pulaski',
    county_fips: 51155,
    county_fips_all: '51155',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"51155": 100}',
    density: 61.3,
    imprecise: false,
    latitude: 37.06319,
    longitude: -80.79735,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24301',
  },
  {
    city: 'Atkins',
    county_fips: 51173,
    county_fips_all: '51173',
    county: 'Smyth',
    county_names_all: 'Smyth',
    county_weights: '{"51173": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 36.87292,
    longitude: -81.40161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24311',
  },
  {
    city: 'Austinville',
    county_fips: 51035,
    county_fips_all: '51035|51197',
    county: 'Carroll',
    county_names_all: 'Carroll|Wythe',
    county_weights: '{"51035": 68.73, "51197": 31.27}',
    density: 17.8,
    imprecise: false,
    latitude: 36.83117,
    longitude: -80.86897,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24312',
  },
  {
    city: 'Barren Springs',
    county_fips: 51197,
    county_fips_all: '51197|51155',
    county: 'Wythe',
    county_names_all: 'Wythe|Pulaski',
    county_weights: '{"51197": 90.07, "51155": 9.93}',
    density: 40.9,
    imprecise: false,
    latitude: 36.9105,
    longitude: -80.79805,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24313',
  },
  {
    city: 'Bastian',
    county_fips: 51021,
    county_fips_all: '51021|51185',
    county: 'Bland',
    county_names_all: 'Bland|Tazewell',
    county_weights: '{"51021": 90.57, "51185": 9.43}',
    density: 5.3,
    imprecise: false,
    latitude: 37.17166,
    longitude: -81.20728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24314',
  },
  {
    city: 'Bland',
    county_fips: 51021,
    county_fips_all: '51021|51071',
    county: 'Bland',
    county_names_all: 'Bland|Giles',
    county_weights: '{"51021": 95.66, "51071": 4.34}',
    density: 9,
    imprecise: false,
    latitude: 37.1393,
    longitude: -81.0534,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24315',
  },
  {
    city: 'Broadford',
    county_fips: 51185,
    county_fips_all: '51185|51173',
    county: 'Tazewell',
    county_names_all: 'Tazewell|Smyth',
    county_weights: '{"51185": 90.86, "51173": 9.14}',
    density: 3.5,
    imprecise: false,
    latitude: 36.95277,
    longitude: -81.67145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24316',
  },
  {
    city: 'Cana',
    county_fips: 51035,
    county_fips_all: '51035|51141',
    county: 'Carroll',
    county_names_all: 'Carroll|Patrick',
    county_weights: '{"51035": 93.49, "51141": 6.51}',
    density: 33.8,
    imprecise: false,
    latitude: 36.60138,
    longitude: -80.66876,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24317',
  },
  {
    city: 'Ceres',
    county_fips: 51021,
    county_fips_all: '51021|51173',
    county: 'Bland',
    county_names_all: 'Bland|Smyth',
    county_weights: '{"51021": 66.25, "51173": 33.75}',
    density: 2,
    imprecise: false,
    latitude: 37.00047,
    longitude: -81.38658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24318',
  },
  {
    city: 'Chilhowie',
    county_fips: 51173,
    county_fips_all: '51173|51191',
    county: 'Smyth',
    county_names_all: 'Smyth|Washington',
    county_weights: '{"51173": 79.3, "51191": 20.7}',
    density: 43.3,
    imprecise: false,
    latitude: 36.76048,
    longitude: -81.65778,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24319',
  },
  {
    city: 'Cripple Creek',
    county_fips: 51197,
    county_fips_all: '51197',
    county: 'Wythe',
    county_names_all: 'Wythe',
    county_weights: '{"51197": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 36.80534,
    longitude: -81.1195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24322',
  },
  {
    city: 'Crockett',
    county_fips: 51197,
    county_fips_all: '51197',
    county: 'Wythe',
    county_names_all: 'Wythe',
    county_weights: '{"51197": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 36.86513,
    longitude: -81.1997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24323',
  },
  {
    city: 'Draper',
    county_fips: 51155,
    county_fips_all: '51155|51197',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Wythe',
    county_weights: '{"51155": 76.28, "51197": 23.72}',
    density: 22.6,
    imprecise: false,
    latitude: 36.97461,
    longitude: -80.78836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24324',
  },
  {
    city: 'Dugspur',
    county_fips: 51035,
    county_fips_all: '51035',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"51035": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 36.80918,
    longitude: -80.60608,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24325',
  },
  {
    city: 'Elk Creek',
    county_fips: 51077,
    county_fips_all: '51077',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"51077": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 36.72771,
    longitude: -81.19625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24326',
  },
  {
    city: 'Emory',
    county_fips: 51191,
    county_fips_all: '51191',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"51191": 100}',
    density: 819.6,
    imprecise: false,
    latitude: 36.77357,
    longitude: -81.82971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24327',
  },
  {
    city: 'Fancy Gap',
    county_fips: 51035,
    county_fips_all: '51035|51141',
    county: 'Carroll',
    county_names_all: 'Carroll|Patrick',
    county_weights: '{"51035": 99.48, "51141": 0.52}',
    density: 19.3,
    imprecise: false,
    latitude: 36.66185,
    longitude: -80.69382,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24328',
  },
  {
    city: 'Fries',
    county_fips: 51077,
    county_fips_all: '51077|51035',
    county: 'Grayson',
    county_names_all: 'Grayson|Carroll',
    county_weights: '{"51077": 78.87, "51035": 21.13}',
    density: 26.9,
    imprecise: false,
    latitude: 36.72375,
    longitude: -81.02471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24330',
  },
  {
    city: 'Galax',
    county_fips: 51077,
    county_fips_all: '51077|51035|51640',
    county: 'Grayson',
    county_names_all: 'Grayson|Carroll|Galax',
    county_weights: '{"51077": 51.59, "51035": 42.82, "51640": 5.59}',
    density: 46.3,
    imprecise: false,
    latitude: 36.64057,
    longitude: -80.92921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24333',
  },
  {
    city: 'Glade Spring',
    county_fips: 51191,
    county_fips_all: '51191',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"51191": 100}',
    density: 35.4,
    imprecise: false,
    latitude: 36.75267,
    longitude: -81.75891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24340',
  },
  {
    city: 'Hillsville',
    county_fips: 51035,
    county_fips_all: '51035|51141|51197',
    county: 'Carroll',
    county_names_all: 'Carroll|Patrick|Wythe',
    county_weights: '{"51035": 95.06, "51141": 2.58, "51197": 2.36}',
    density: 28.2,
    imprecise: false,
    latitude: 36.76612,
    longitude: -80.70045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24343',
  },
  {
    city: 'Hiwassee',
    county_fips: 51155,
    county_fips_all: '51155|51035|51121',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Carroll|Montgomery',
    county_weights: '{"51155": 87.12, "51035": 9.03, "51121": 3.85}',
    density: 7.9,
    imprecise: false,
    latitude: 36.95958,
    longitude: -80.65598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24347',
  },
  {
    city: 'Independence',
    county_fips: 51077,
    county_fips_all: '51077',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"51077": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 36.63897,
    longitude: -81.17392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24348',
  },
  {
    city: 'Ivanhoe',
    county_fips: 51197,
    county_fips_all: '51197|51035|51077',
    county: 'Wythe',
    county_names_all: 'Wythe|Carroll|Grayson',
    county_weights: '{"51197": 49.52, "51035": 30.0, "51077": 20.48}',
    density: 8.9,
    imprecise: false,
    latitude: 36.81109,
    longitude: -81.01757,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24350',
  },
  {
    city: 'Lambsburg',
    county_fips: 51035,
    county_fips_all: '51035',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"51035": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 36.58081,
    longitude: -80.76591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24351',
  },
  {
    city: 'Laurel Fork',
    county_fips: 51035,
    county_fips_all: '51035|51063',
    county: 'Carroll',
    county_names_all: 'Carroll|Floyd',
    county_weights: '{"51035": 98.92, "51063": 1.08}',
    density: 18,
    imprecise: false,
    latitude: 36.71547,
    longitude: -80.53437,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24352',
  },
  {
    city: 'Marion',
    county_fips: 51173,
    county_fips_all: '51173',
    county: 'Smyth',
    county_names_all: 'Smyth',
    county_weights: '{"51173": 100}',
    density: 41.9,
    imprecise: false,
    latitude: 36.82159,
    longitude: -81.54001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24354',
  },
  {
    city: 'Max Meadows',
    county_fips: 51197,
    county_fips_all: '51197|51035',
    county: 'Wythe',
    county_names_all: 'Wythe|Carroll',
    county_weights: '{"51197": 98.81, "51035": 1.19}',
    density: 24,
    imprecise: false,
    latitude: 36.93917,
    longitude: -80.9023,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24360',
  },
  {
    city: 'Meadowview',
    county_fips: 51191,
    county_fips_all: '51191',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"51191": 100}',
    density: 31.7,
    imprecise: false,
    latitude: 36.76672,
    longitude: -81.84552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24361',
  },
  {
    city: 'Mouth Of Wilson',
    county_fips: 51077,
    county_fips_all: '51077',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"51077": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 36.6137,
    longitude: -81.40084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24363',
  },
  {
    city: 'Rocky Gap',
    county_fips: 51021,
    county_fips_all: '51021',
    county: 'Bland',
    county_names_all: 'Bland',
    county_weights: '{"51021": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 37.26426,
    longitude: -81.10315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24366',
  },
  {
    city: 'Rural Retreat',
    county_fips: 51197,
    county_fips_all: '51197|51173',
    county: 'Wythe',
    county_names_all: 'Wythe|Smyth',
    county_weights: '{"51197": 72.64, "51173": 27.36}',
    density: 24.8,
    imprecise: false,
    latitude: 36.89283,
    longitude: -81.30003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24368',
  },
  {
    city: 'Saltville',
    county_fips: 51173,
    county_fips_all: '51173|51191',
    county: 'Smyth',
    county_names_all: 'Smyth|Washington',
    county_weights: '{"51173": 79.91, "51191": 20.09}',
    density: 14.7,
    imprecise: false,
    latitude: 36.91345,
    longitude: -81.69107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24370',
  },
  {
    city: 'Speedwell',
    county_fips: 51197,
    county_fips_all: '51197',
    county: 'Wythe',
    county_names_all: 'Wythe',
    county_weights: '{"51197": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 36.79129,
    longitude: -81.20178,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24374',
  },
  {
    city: 'Sugar Grove',
    county_fips: 51173,
    county_fips_all: '51173',
    county: 'Smyth',
    county_names_all: 'Smyth',
    county_weights: '{"51173": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 36.77128,
    longitude: -81.39026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24375',
  },
  {
    city: 'Tannersville',
    county_fips: 51185,
    county_fips_all: '51185',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"51185": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 37.00206,
    longitude: -81.56961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24377',
  },
  {
    city: 'Troutdale',
    county_fips: 51077,
    county_fips_all: '51077|51173',
    county: 'Grayson',
    county_names_all: 'Grayson|Smyth',
    county_weights: '{"51077": 80.95, "51173": 19.05}',
    density: 5,
    imprecise: false,
    latitude: 36.69126,
    longitude: -81.42944,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24378',
  },
  {
    city: 'Willis',
    county_fips: 51063,
    county_fips_all: '51063|51035',
    county: 'Floyd',
    county_names_all: 'Floyd|Carroll',
    county_weights: '{"51063": 93.02, "51035": 6.98}',
    density: 12.6,
    imprecise: false,
    latitude: 36.85672,
    longitude: -80.50183,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24380',
  },
  {
    city: 'Woodlawn',
    county_fips: 51035,
    county_fips_all: '51035',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"51035": 100}',
    density: 23.5,
    imprecise: false,
    latitude: 36.72453,
    longitude: -80.83924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24381',
  },
  {
    city: 'Wytheville',
    county_fips: 51197,
    county_fips_all: '51197',
    county: 'Wythe',
    county_names_all: 'Wythe',
    county_weights: '{"51197": 100}',
    density: 29.6,
    imprecise: false,
    latitude: 36.95702,
    longitude: -81.10652,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24382',
  },
  {
    city: 'Staunton',
    county_fips: 51015,
    county_fips_all: '51015|51790',
    county: 'Augusta',
    county_names_all: 'Augusta|Staunton',
    county_weights: '{"51015": 85.0, "51790": 15.0}',
    density: 113,
    imprecise: false,
    latitude: 38.13257,
    longitude: -79.08846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24401',
  },
  {
    city: 'Augusta Springs',
    county_fips: 51015,
    county_fips_all: '51015',
    county: 'Augusta',
    county_names_all: 'Augusta',
    county_weights: '{"51015": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 38.11784,
    longitude: -79.33052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24411',
  },
  {
    city: 'Bacova',
    county_fips: 51017,
    county_fips_all: '51017',
    county: 'Bath',
    county_names_all: 'Bath',
    county_weights: '{"51017": 100}',
    density: 23.5,
    imprecise: false,
    latitude: 38.05774,
    longitude: -79.83096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24412',
  },
  {
    city: 'Blue Grass',
    county_fips: 51091,
    county_fips_all: '51091',
    county: 'Highland',
    county_names_all: 'Highland',
    county_weights: '{"51091": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 38.50753,
    longitude: -79.55925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24413',
  },
  {
    city: 'Brownsburg',
    county_fips: 51163,
    county_fips_all: '51163',
    county: 'Rockbridge',
    county_names_all: 'Rockbridge',
    county_weights: '{"51163": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 37.91099,
    longitude: -79.31126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 90,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24415',
  },
  {
    city: 'Buena Vista',
    county_fips: 51163,
    county_fips_all: '51163|51530',
    county: 'Rockbridge',
    county_names_all: 'Rockbridge|Buena Vista',
    county_weights: '{"51163": 89.49, "51530": 10.51}',
    density: 56.8,
    imprecise: false,
    latitude: 37.72892,
    longitude: -79.35534,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24416',
  },
  {
    city: 'Churchville',
    county_fips: 51015,
    county_fips_all: '51015',
    county: 'Augusta',
    county_names_all: 'Augusta',
    county_weights: '{"51015": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 38.26389,
    longitude: -79.20019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24421',
  },
  {
    city: 'Clifton Forge',
    county_fips: 51005,
    county_fips_all: '51005|51023',
    county: 'Alleghany',
    county_names_all: 'Alleghany|Botetourt',
    county_weights: '{"51005": 95.93, "51023": 4.07}',
    density: 25.9,
    imprecise: false,
    latitude: 37.83041,
    longitude: -79.75128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24422',
  },
  {
    city: 'Covington',
    county_fips: 51005,
    county_fips_all: '51005|51045|51580',
    county: 'Alleghany',
    county_names_all: 'Alleghany|Craig|Covington',
    county_weights: '{"51005": 94.98, "51045": 3.48, "51580": 1.54}',
    density: 14.7,
    imprecise: false,
    latitude: 37.76589,
    longitude: -80.06927,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24426',
  },
  {
    city: 'Craigsville',
    county_fips: 51015,
    county_fips_all: '51015',
    county: 'Augusta',
    county_names_all: 'Augusta',
    county_weights: '{"51015": 100}',
    density: 50.8,
    imprecise: false,
    latitude: 38.076,
    longitude: -79.34181,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24430',
  },
  {
    city: 'Crimora',
    county_fips: 51015,
    county_fips_all: '51015',
    county: 'Augusta',
    county_names_all: 'Augusta',
    county_weights: '{"51015": 100}',
    density: 56.3,
    imprecise: false,
    latitude: 38.16897,
    longitude: -78.83924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24431',
  },
  {
    city: 'Deerfield',
    county_fips: 51015,
    county_fips_all: '51015|51017',
    county: 'Augusta',
    county_names_all: 'Augusta|Bath',
    county_weights: '{"51015": 89.02, "51017": 10.98}',
    density: 5,
    imprecise: false,
    latitude: 38.17639,
    longitude: -79.43845,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24432',
  },
  {
    city: 'Doe Hill',
    county_fips: 51091,
    county_fips_all: '51091',
    county: 'Highland',
    county_names_all: 'Highland',
    county_weights: '{"51091": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 38.41817,
    longitude: -79.46461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 88,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24433',
  },
  {
    city: 'Fairfield',
    county_fips: 51163,
    county_fips_all: '51163',
    county: 'Rockbridge',
    county_names_all: 'Rockbridge',
    county_weights: '{"51163": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 37.86716,
    longitude: -79.30663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24435',
  },
  {
    city: 'Fort Defiance',
    county_fips: 51015,
    county_fips_all: '51015',
    county: 'Augusta',
    county_names_all: 'Augusta',
    county_weights: '{"51015": 100}',
    density: 51.7,
    imprecise: false,
    latitude: 38.2116,
    longitude: -78.933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24437',
  },
  {
    city: 'Goshen',
    county_fips: 51163,
    county_fips_all: '51163|51015',
    county: 'Rockbridge',
    county_names_all: 'Rockbridge|Augusta',
    county_weights: '{"51163": 71.77, "51015": 28.23}',
    density: 3.6,
    imprecise: false,
    latitude: 38.01151,
    longitude: -79.47359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24439',
  },
  {
    city: 'Greenville',
    county_fips: 51015,
    county_fips_all: '51015',
    county: 'Augusta',
    county_names_all: 'Augusta',
    county_weights: '{"51015": 100}',
    density: 40.4,
    imprecise: false,
    latitude: 37.99595,
    longitude: -79.16574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24440',
  },
  {
    city: 'Grottoes',
    county_fips: 51015,
    county_fips_all: '51015|51165',
    county: 'Augusta',
    county_names_all: 'Augusta|Rockingham',
    county_weights: '{"51015": 65.53, "51165": 34.47}',
    density: 47.6,
    imprecise: false,
    latitude: 38.22823,
    longitude: -78.8109,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24441',
  },
  {
    city: 'Head Waters',
    county_fips: 51091,
    county_fips_all: '51091',
    county: 'Highland',
    county_names_all: 'Highland',
    county_weights: '{"51091": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 38.35971,
    longitude: -79.39028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24442',
  },
  {
    city: 'Hot Springs',
    county_fips: 51017,
    county_fips_all: '51017|51005',
    county: 'Bath',
    county_names_all: 'Bath|Alleghany',
    county_weights: '{"51017": 79.14, "51005": 20.86}',
    density: 9.3,
    imprecise: false,
    latitude: 37.96615,
    longitude: -79.88013,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24445',
  },
  {
    city: 'Iron Gate',
    county_fips: 51005,
    county_fips_all: '51005',
    county: 'Alleghany',
    county_names_all: 'Alleghany',
    county_weights: '{"51005": 100}',
    density: 527.6,
    imprecise: false,
    latitude: 37.79836,
    longitude: -79.79002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24448',
  },
  {
    city: 'Lexington',
    county_fips: 51163,
    county_fips_all: '51163|51023|51678',
    county: 'Rockbridge',
    county_names_all: 'Rockbridge|Botetourt|Lexington',
    county_weights: '{"51163": 91.05, "51023": 7.81, "51678": 1.14}',
    density: 31.1,
    imprecise: false,
    latitude: 37.77883,
    longitude: -79.53888,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24450',
  },
  {
    city: 'Low Moor',
    county_fips: 51005,
    county_fips_all: '51005',
    county: 'Alleghany',
    county_names_all: 'Alleghany',
    county_weights: '{"51005": 100}',
    density: 141.6,
    imprecise: false,
    latitude: 37.79379,
    longitude: -79.87014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24457',
  },
  {
    city: 'McDowell',
    county_fips: 51091,
    county_fips_all: '51091',
    county: 'Highland',
    county_names_all: 'Highland',
    county_weights: '{"51091": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 38.33066,
    longitude: -79.51201,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24458',
  },
  {
    city: 'Middlebrook',
    county_fips: 51015,
    county_fips_all: '51015|51163',
    county: 'Augusta',
    county_names_all: 'Augusta|Rockbridge',
    county_weights: '{"51015": 88.08, "51163": 11.92}',
    density: 4.3,
    imprecise: false,
    latitude: 38.02955,
    longitude: -79.28621,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24459',
  },
  {
    city: 'Millboro',
    county_fips: 51017,
    county_fips_all: '51017',
    county: 'Bath',
    county_names_all: 'Bath',
    county_weights: '{"51017": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 38.02237,
    longitude: -79.65048,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24460',
  },
  {
    city: 'Montebello',
    county_fips: 51125,
    county_fips_all: '51125',
    county: 'Nelson',
    county_names_all: 'Nelson',
    county_weights: '{"51125": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 37.86082,
    longitude: -79.10398,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24464',
  },
  {
    city: 'Monterey',
    county_fips: 51091,
    county_fips_all: '51091',
    county: 'Highland',
    county_names_all: 'Highland',
    county_weights: '{"51091": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 38.39611,
    longitude: -79.64636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24465',
  },
  {
    city: 'Mount Sidney',
    county_fips: 51015,
    county_fips_all: '51015',
    county: 'Augusta',
    county_names_all: 'Augusta',
    county_weights: '{"51015": 100}',
    density: 36.9,
    imprecise: false,
    latitude: 38.2592,
    longitude: -78.97249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24467',
  },
  {
    city: 'New Hope',
    county_fips: 51015,
    county_fips_all: '51015',
    county: 'Augusta',
    county_names_all: 'Augusta',
    county_weights: '{"51015": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.20099,
    longitude: -78.90828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24469',
  },
  {
    city: 'Port Republic',
    county_fips: 51165,
    county_fips_all: '51165',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"51165": 100}',
    density: 41.4,
    imprecise: false,
    latitude: 38.30837,
    longitude: -78.79645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24471',
  },
  {
    city: 'Raphine',
    county_fips: 51163,
    county_fips_all: '51163|51015',
    county: 'Rockbridge',
    county_names_all: 'Rockbridge|Augusta',
    county_weights: '{"51163": 50.64, "51015": 49.36}',
    density: 11.8,
    imprecise: false,
    latitude: 37.93833,
    longitude: -79.22194,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24472',
  },
  {
    city: 'Rockbridge Baths',
    county_fips: 51163,
    county_fips_all: '51163',
    county: 'Rockbridge',
    county_names_all: 'Rockbridge',
    county_weights: '{"51163": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 37.9129,
    longitude: -79.41052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24473',
  },
  {
    city: 'Selma',
    county_fips: 51005,
    county_fips_all: '51005',
    county: 'Alleghany',
    county_names_all: 'Alleghany',
    county_weights: '{"51005": 100}',
    density: 95.8,
    imprecise: false,
    latitude: 37.80504,
    longitude: -79.84731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24474',
  },
  {
    city: 'Steeles Tavern',
    county_fips: 51015,
    county_fips_all: '51015',
    county: 'Augusta',
    county_names_all: 'Augusta',
    county_weights: '{"51015": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 37.97231,
    longitude: -79.22,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24476',
  },
  {
    city: 'Stuarts Draft',
    county_fips: 51015,
    county_fips_all: '51015',
    county: 'Augusta',
    county_names_all: 'Augusta',
    county_weights: '{"51015": 100}',
    density: 90.6,
    imprecise: false,
    latitude: 38.00416,
    longitude: -79.04374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24477',
  },
  {
    city: 'Swoope',
    county_fips: 51015,
    county_fips_all: '51015',
    county: 'Augusta',
    county_names_all: 'Augusta',
    county_weights: '{"51015": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 38.15353,
    longitude: -79.23992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24479',
  },
  {
    city: 'Verona',
    county_fips: 51015,
    county_fips_all: '51015|51790',
    county: 'Augusta',
    county_names_all: 'Augusta|Staunton',
    county_weights: '{"51015": 99.9, "51790": 0.1}',
    density: 123.7,
    imprecise: false,
    latitude: 38.20502,
    longitude: -78.99706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24482',
  },
  {
    city: 'Vesuvius',
    county_fips: 51163,
    county_fips_all: '51163|51009|51125',
    county: 'Rockbridge',
    county_names_all: 'Rockbridge|Amherst|Nelson',
    county_weights: '{"51163": 61.11, "51009": 35.97, "51125": 2.92}',
    density: 2.6,
    imprecise: false,
    latitude: 37.81484,
    longitude: -79.2256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24483',
  },
  {
    city: 'Warm Springs',
    county_fips: 51017,
    county_fips_all: '51017|51091',
    county: 'Bath',
    county_names_all: 'Bath|Highland',
    county_weights: '{"51017": 88.69, "51091": 11.31}',
    density: 1.1,
    imprecise: false,
    latitude: 38.1448,
    longitude: -79.82013,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24484',
  },
  {
    city: 'West Augusta',
    county_fips: 51015,
    county_fips_all: '51015',
    county: 'Augusta',
    county_names_all: 'Augusta',
    county_weights: '{"51015": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 38.27521,
    longitude: -79.33165,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24485',
  },
  {
    city: 'Weyers Cave',
    county_fips: 51015,
    county_fips_all: '51015|51165',
    county: 'Augusta',
    county_names_all: 'Augusta|Rockingham',
    county_weights: '{"51015": 90.8, "51165": 9.2}',
    density: 59.7,
    imprecise: false,
    latitude: 38.29366,
    longitude: -78.92925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24486',
  },
  {
    city: 'Williamsville',
    county_fips: 51091,
    county_fips_all: '51091|51017',
    county: 'Highland',
    county_names_all: 'Highland|Bath',
    county_weights: '{"51091": 59.25, "51017": 40.75}',
    density: 2.4,
    imprecise: false,
    latitude: 38.20099,
    longitude: -79.58105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24487',
  },
  {
    city: 'Lynchburg',
    county_fips: 51031,
    county_fips_all: '51031|51680',
    county: 'Campbell',
    county_names_all: 'Campbell|Lynchburg',
    county_weights: '{"51031": 62.74, "51680": 37.26}',
    density: 265.7,
    imprecise: false,
    latitude: 37.35565,
    longitude: -79.15608,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24501',
  },
  {
    city: 'Lynchburg',
    county_fips: 51680,
    county_fips_all: '51680|51031|51019',
    county: 'Lynchburg',
    county_names_all: 'Lynchburg|Campbell|Bedford',
    county_weights: '{"51680": 57.04, "51031": 38.67, "51019": 4.29}',
    density: 542,
    imprecise: false,
    latitude: 37.35624,
    longitude: -79.2194,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24502',
  },
  {
    city: 'Lynchburg',
    county_fips: 51019,
    county_fips_all: '51019|51680',
    county: 'Bedford',
    county_names_all: 'Bedford|Lynchburg',
    county_weights: '{"51019": 65.34, "51680": 34.66}',
    density: 214.7,
    imprecise: false,
    latitude: 37.45272,
    longitude: -79.24286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24503',
  },
  {
    city: 'Lynchburg',
    county_fips: 51031,
    county_fips_all: '51031|51680|51011',
    county: 'Campbell',
    county_names_all: 'Campbell|Lynchburg|Appomattox',
    county_weights: '{"51031": 78.12, "51680": 12.6, "51011": 9.28}',
    density: 99.1,
    imprecise: false,
    latitude: 37.36673,
    longitude: -79.04953,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24504',
  },
  {
    city: 'Altavista',
    county_fips: 51031,
    county_fips_all: '51031',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"51031": 100}',
    density: 59.1,
    imprecise: false,
    latitude: 37.14532,
    longitude: -79.23258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24517',
  },
  {
    city: 'Alton',
    county_fips: 51083,
    county_fips_all: '51083',
    county: 'Halifax',
    county_names_all: 'Halifax',
    county_weights: '{"51083": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 36.58486,
    longitude: -79.03752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24520',
  },
  {
    city: 'Amherst',
    county_fips: 51009,
    county_fips_all: '51009|51125',
    county: 'Amherst',
    county_names_all: 'Amherst|Nelson',
    county_weights: '{"51009": 95.77, "51125": 4.23}',
    density: 18.8,
    imprecise: false,
    latitude: 37.63672,
    longitude: -79.09539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24521',
  },
  {
    city: 'Appomattox',
    county_fips: 51011,
    county_fips_all: '51011|51029|51037',
    county: 'Appomattox',
    county_names_all: 'Appomattox|Buckingham|Charlotte',
    county_weights: '{"51011": 96.26, "51029": 3.48, "51037": 0.26}',
    density: 19.4,
    imprecise: false,
    latitude: 37.37324,
    longitude: -78.78591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24522',
  },
  {
    city: 'Bedford',
    county_fips: 51019,
    county_fips_all: '51019',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"51019": 100}',
    density: 34.2,
    imprecise: false,
    latitude: 37.3364,
    longitude: -79.52347,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24523',
  },
  {
    city: 'Big Island',
    county_fips: 51019,
    county_fips_all: '51019|51009',
    county: 'Bedford',
    county_names_all: 'Bedford|Amherst',
    county_weights: '{"51019": 71.36, "51009": 28.64}',
    density: 8.1,
    imprecise: false,
    latitude: 37.55452,
    longitude: -79.40169,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24526',
  },
  {
    city: 'Blairs',
    county_fips: 51143,
    county_fips_all: '51143',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania',
    county_weights: '{"51143": 100}',
    density: 40.7,
    imprecise: false,
    latitude: 36.7324,
    longitude: -79.34577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24527',
  },
  {
    city: 'Brookneal',
    county_fips: 51031,
    county_fips_all: '51031|51037',
    county: 'Campbell',
    county_names_all: 'Campbell|Charlotte',
    county_weights: '{"51031": 56.86, "51037": 43.14}',
    density: 14.6,
    imprecise: false,
    latitude: 37.07733,
    longitude: -78.8777,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24528',
  },
  {
    city: 'Buffalo Junction',
    county_fips: 51117,
    county_fips_all: '51117',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"51117": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 36.62452,
    longitude: -78.64001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24529',
  },
  {
    city: 'Callands',
    county_fips: 51143,
    county_fips_all: '51143|51089',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania|Henry',
    county_weights: '{"51143": 90.29, "51089": 9.71}',
    density: 7.3,
    imprecise: false,
    latitude: 36.80785,
    longitude: -79.61044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24530',
  },
  {
    city: 'Chatham',
    county_fips: 51143,
    county_fips_all: '51143',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania',
    county_weights: '{"51143": 100}',
    density: 17,
    imprecise: false,
    latitude: 36.83922,
    longitude: -79.44332,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24531',
  },
  {
    city: 'Clover',
    county_fips: 51083,
    county_fips_all: '51083',
    county: 'Halifax',
    county_names_all: 'Halifax',
    county_weights: '{"51083": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 36.87835,
    longitude: -78.76691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24534',
  },
  {
    city: 'Coleman Falls',
    county_fips: 51019,
    county_fips_all: '51019',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"51019": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 37.48996,
    longitude: -79.32097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24536',
  },
  {
    city: 'Concord',
    county_fips: 51031,
    county_fips_all: '51031|51011',
    county: 'Campbell',
    county_names_all: 'Campbell|Appomattox',
    county_weights: '{"51031": 60.21, "51011": 39.79}',
    density: 21.6,
    imprecise: false,
    latitude: 37.32908,
    longitude: -78.95367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24538',
  },
  {
    city: 'Crystal Hill',
    county_fips: 51083,
    county_fips_all: '51083',
    county: 'Halifax',
    county_names_all: 'Halifax',
    county_weights: '{"51083": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 36.85376,
    longitude: -78.90728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24539',
  },
  {
    city: 'Danville',
    county_fips: 51143,
    county_fips_all: '51143|51590',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania|Danville',
    county_weights: '{"51143": 76.94, "51590": 23.06}',
    density: 159.6,
    imprecise: false,
    latitude: 36.64235,
    longitude: -79.42473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24540',
  },
  {
    city: 'Danville',
    county_fips: 51143,
    county_fips_all: '51143|51590',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania|Danville',
    county_weights: '{"51143": 65.47, "51590": 34.53}',
    density: 144,
    imprecise: false,
    latitude: 36.59072,
    longitude: -79.51572,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24541',
  },
  {
    city: 'Dry Fork',
    county_fips: 51143,
    county_fips_all: '51143',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania',
    county_weights: '{"51143": 100}',
    density: 31.2,
    imprecise: false,
    latitude: 36.71584,
    longitude: -79.50632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24549',
  },
  {
    city: 'Evington',
    county_fips: 51031,
    county_fips_all: '51031|51019',
    county: 'Campbell',
    county_names_all: 'Campbell|Bedford',
    county_weights: '{"51031": 87.57, "51019": 12.43}',
    density: 49.9,
    imprecise: false,
    latitude: 37.23493,
    longitude: -79.26898,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24550',
  },
  {
    city: 'Forest',
    county_fips: 51019,
    county_fips_all: '51019|51031|51680',
    county: 'Bedford',
    county_names_all: 'Bedford|Campbell|Lynchburg',
    county_weights: '{"51019": 97.24, "51031": 2.41, "51680": 0.35}',
    density: 148.6,
    imprecise: false,
    latitude: 37.36655,
    longitude: -79.3268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24551',
  },
  {
    city: 'Gladstone',
    county_fips: 51029,
    county_fips_all: '51029|51125|51009|51011',
    county: 'Buckingham',
    county_names_all: 'Buckingham|Nelson|Amherst|Appomattox',
    county_weights:
      '{"51029": 44.07, "51125": 21.22, "51009": 18.12, "51011": 16.58}',
    density: 4.6,
    imprecise: false,
    latitude: 37.54845,
    longitude: -78.81907,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24553',
  },
  {
    city: 'Gladys',
    county_fips: 51031,
    county_fips_all: '51031',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"51031": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 37.13674,
    longitude: -79.06639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24554',
  },
  {
    city: 'Glasgow',
    county_fips: 51163,
    county_fips_all: '51163',
    county: 'Rockbridge',
    county_names_all: 'Rockbridge',
    county_weights: '{"51163": 100}',
    density: 35.9,
    imprecise: false,
    latitude: 37.6678,
    longitude: -79.47007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24555',
  },
  {
    city: 'Goode',
    county_fips: 51019,
    county_fips_all: '51019',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"51019": 100}',
    density: 25.2,
    imprecise: false,
    latitude: 37.38093,
    longitude: -79.4021,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24556',
  },
  {
    city: 'Gretna',
    county_fips: 51143,
    county_fips_all: '51143|51083',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania|Halifax',
    county_weights: '{"51143": 99.77, "51083": 0.23}',
    density: 18.2,
    imprecise: false,
    latitude: 36.9666,
    longitude: -79.30401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24557',
  },
  {
    city: 'Halifax',
    county_fips: 51083,
    county_fips_all: '51083',
    county: 'Halifax',
    county_names_all: 'Halifax',
    county_weights: '{"51083": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 36.77914,
    longitude: -78.95741,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24558',
  },
  {
    city: 'Howardsville',
    county_fips: 51029,
    county_fips_all: '51029|51125|51003',
    county: 'Buckingham',
    county_names_all: 'Buckingham|Nelson|Albemarle',
    county_weights: '{"51029": 64.72, "51125": 27.28, "51003": 8.0}',
    density: 13.9,
    imprecise: false,
    latitude: 37.70577,
    longitude: -78.62241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24562',
  },
  {
    city: 'Hurt',
    county_fips: 51143,
    county_fips_all: '51143',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania',
    county_weights: '{"51143": 100}',
    density: 29.1,
    imprecise: false,
    latitude: 37.06106,
    longitude: -79.27385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24563',
  },
  {
    city: 'Java',
    county_fips: 51143,
    county_fips_all: '51143|51083',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania|Halifax',
    county_weights: '{"51143": 83.81, "51083": 16.19}',
    density: 7.3,
    imprecise: false,
    latitude: 36.85259,
    longitude: -79.18588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24565',
  },
  {
    city: 'Keeling',
    county_fips: 51143,
    county_fips_all: '51143',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania',
    county_weights: '{"51143": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 36.72747,
    longitude: -79.25069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24566',
  },
  {
    city: 'Long Island',
    county_fips: 51143,
    county_fips_all: '51143|51031|51083',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania|Campbell|Halifax',
    county_weights: '{"51143": 62.13, "51031": 19.05, "51083": 18.82}',
    density: 12,
    imprecise: false,
    latitude: 37.0463,
    longitude: -79.12129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24569',
  },
  {
    city: 'Lowry',
    county_fips: 51019,
    county_fips_all: '51019',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"51019": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.3486,
    longitude: -79.4272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24570',
  },
  {
    city: 'Lynch Station',
    county_fips: 51031,
    county_fips_all: '51031|51019',
    county: 'Campbell',
    county_names_all: 'Campbell|Bedford',
    county_weights: '{"51031": 60.27, "51019": 39.73}',
    density: 15.8,
    imprecise: false,
    latitude: 37.13671,
    longitude: -79.37983,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24571',
  },
  {
    city: 'Madison Heights',
    county_fips: 51009,
    county_fips_all: '51009',
    county: 'Amherst',
    county_names_all: 'Amherst',
    county_weights: '{"51009": 100}',
    density: 91.7,
    imprecise: false,
    latitude: 37.46514,
    longitude: -79.09628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24572',
  },
  {
    city: 'Monroe',
    county_fips: 51009,
    county_fips_all: '51009',
    county: 'Amherst',
    county_names_all: 'Amherst',
    county_weights: '{"51009": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 37.57589,
    longitude: -79.24714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24574',
  },
  {
    city: 'Nathalie',
    county_fips: 51083,
    county_fips_all: '51083',
    county: 'Halifax',
    county_names_all: 'Halifax',
    county_weights: '{"51083": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 36.93762,
    longitude: -78.97553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24577',
  },
  {
    city: 'Natural Bridge',
    county_fips: 51163,
    county_fips_all: '51163',
    county: 'Rockbridge',
    county_names_all: 'Rockbridge',
    county_weights: '{"51163": 100}',
    density: 5,
    imprecise: false,
    latitude: 37.66269,
    longitude: -79.55693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24578',
  },
  {
    city: 'Natural Bridge Station',
    county_fips: 51163,
    county_fips_all: '51163',
    county: 'Rockbridge',
    county_names_all: 'Rockbridge',
    county_weights: '{"51163": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 37.58763,
    longitude: -79.50483,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24579',
  },
  {
    city: 'Nelson',
    county_fips: 51117,
    county_fips_all: '51117',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"51117": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 36.58328,
    longitude: -78.68,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24580',
  },
  {
    city: 'Norwood',
    county_fips: 51125,
    county_fips_all: '51125',
    county: 'Nelson',
    county_names_all: 'Nelson',
    county_weights: '{"51125": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.65692,
    longitude: -78.8098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24581',
  },
  {
    city: 'Ringgold',
    county_fips: 51143,
    county_fips_all: '51143',
    county: 'Pittsylvania',
    county_names_all: 'Pittsylvania',
    county_weights: '{"51143": 100}',
    density: 34.6,
    imprecise: false,
    latitude: 36.60776,
    longitude: -79.2828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24586',
  },
  {
    city: 'Rustburg',
    county_fips: 51031,
    county_fips_all: '51031',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"51031": 100}',
    density: 47.2,
    imprecise: false,
    latitude: 37.26408,
    longitude: -79.09997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24588',
  },
  {
    city: 'Scottsburg',
    county_fips: 51083,
    county_fips_all: '51083',
    county: 'Halifax',
    county_names_all: 'Halifax',
    county_weights: '{"51083": 100}',
    density: 9,
    imprecise: false,
    latitude: 36.75528,
    longitude: -78.75555,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24589',
  },
  {
    city: 'Scottsville',
    county_fips: 51029,
    county_fips_all: '51029|51003|51065',
    county: 'Buckingham',
    county_names_all: 'Buckingham|Albemarle|Fluvanna',
    county_weights: '{"51029": 35.8, "51003": 35.59, "51065": 28.62}',
    density: 19.6,
    imprecise: false,
    latitude: 37.79353,
    longitude: -78.47767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24590',
  },
  {
    city: 'South Boston',
    county_fips: 51083,
    county_fips_all: '51083|51143',
    county: 'Halifax',
    county_names_all: 'Halifax|Pittsylvania',
    county_weights: '{"51083": 99.66, "51143": 0.34}',
    density: 44.9,
    imprecise: false,
    latitude: 36.67808,
    longitude: -78.95474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24592',
  },
  {
    city: 'Spout Spring',
    county_fips: 51011,
    county_fips_all: '51011|51031',
    county: 'Appomattox',
    county_names_all: 'Appomattox|Campbell',
    county_weights: '{"51011": 98.08, "51031": 1.92}',
    density: 23.9,
    imprecise: false,
    latitude: 37.32651,
    longitude: -78.91342,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24593',
  },
  {
    city: 'Sutherlin',
    county_fips: 51083,
    county_fips_all: '51083|51143',
    county: 'Halifax',
    county_names_all: 'Halifax|Pittsylvania',
    county_weights: '{"51083": 57.48, "51143": 42.52}',
    density: 8.8,
    imprecise: false,
    latitude: 36.64217,
    longitude: -79.18504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24594',
  },
  {
    city: 'Sweet Briar',
    county_fips: 51009,
    county_fips_all: '51009',
    county: 'Amherst',
    county_names_all: 'Amherst',
    county_weights: '{"51009": 100}',
    density: 161.3,
    imprecise: false,
    latitude: 37.55904,
    longitude: -79.08421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24595',
  },
  {
    city: 'Vernon Hill',
    county_fips: 51083,
    county_fips_all: '51083|51143',
    county: 'Halifax',
    county_names_all: 'Halifax|Pittsylvania',
    county_weights: '{"51083": 87.24, "51143": 12.76}',
    density: 5.4,
    imprecise: false,
    latitude: 36.78553,
    longitude: -79.1095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24597',
  },
  {
    city: 'Virgilina',
    county_fips: 51083,
    county_fips_all: '51083|51117',
    county: 'Halifax',
    county_names_all: 'Halifax|Mecklenburg',
    county_weights: '{"51083": 96.37, "51117": 3.63}',
    density: 6.8,
    imprecise: false,
    latitude: 36.60521,
    longitude: -78.7828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24598',
  },
  {
    city: 'Wingina',
    county_fips: 51029,
    county_fips_all: '51029|51125',
    county: 'Buckingham',
    county_names_all: 'Buckingham|Nelson',
    county_weights: '{"51029": 52.19, "51125": 47.81}',
    density: 3.7,
    imprecise: false,
    latitude: 37.63289,
    longitude: -78.72452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24599',
  },
  {
    city: 'Amonate',
    county_fips: 51185,
    county_fips_all: '51185',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"51185": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.19068,
    longitude: -81.64049,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24601',
  },
  {
    city: 'Bandy',
    county_fips: 51185,
    county_fips_all: '51185',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"51185": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 37.18383,
    longitude: -81.65762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24602',
  },
  {
    city: 'Big Rock',
    county_fips: 51027,
    county_fips_all: '51027',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"51027": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 37.35607,
    longitude: -82.1914,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24603',
  },
  {
    city: 'Bishop',
    county_fips: 51185,
    county_fips_all: '51185|54047',
    county: 'Tazewell',
    county_names_all: 'Tazewell|McDowell',
    county_weights: '{"51185": 79.37, "54047": 20.63}',
    density: 23.6,
    imprecise: false,
    latitude: 37.21088,
    longitude: -81.54378,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24604',
  },
  {
    city: 'Bluefield',
    county_fips: 51185,
    county_fips_all: '51185',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"51185": 100}',
    density: 69.8,
    imprecise: false,
    latitude: 37.24093,
    longitude: -81.36123,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24605',
  },
  {
    city: 'Boissevain',
    county_fips: 51185,
    county_fips_all: '51185',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"51185": 100}',
    density: 51,
    imprecise: false,
    latitude: 37.28814,
    longitude: -81.39183,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24606',
  },
  {
    city: 'Breaks',
    county_fips: 51027,
    county_fips_all: '51027|51051',
    county: 'Buchanan',
    county_names_all: 'Buchanan|Dickenson',
    county_weights: '{"51027": 62.4, "51051": 37.6}',
    density: 8.4,
    imprecise: false,
    latitude: 37.29498,
    longitude: -82.26533,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24607',
  },
  {
    city: 'Cedar Bluff',
    county_fips: 51185,
    county_fips_all: '51185|51167',
    county: 'Tazewell',
    county_names_all: 'Tazewell|Russell',
    county_weights: '{"51185": 50.43, "51167": 49.57}',
    density: 31.9,
    imprecise: false,
    latitude: 37.02955,
    longitude: -81.795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24609',
  },
  {
    city: 'Doran',
    county_fips: 51185,
    county_fips_all: '51185',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"51185": 100}',
    density: 40.2,
    imprecise: false,
    latitude: 37.09728,
    longitude: -81.84461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24612',
  },
  {
    city: 'Falls Mills',
    county_fips: 51185,
    county_fips_all: '51185',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"51185": 100}',
    density: 9,
    imprecise: false,
    latitude: 37.262,
    longitude: -81.3385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24613',
  },
  {
    city: 'Grundy',
    county_fips: 51027,
    county_fips_all: '51027',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"51027": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 37.31466,
    longitude: -82.07181,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24614',
  },
  {
    city: 'Hurley',
    county_fips: 51027,
    county_fips_all: '51027',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"51027": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 37.43335,
    longitude: -82.01932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24620',
  },
  {
    city: 'Jewell Ridge',
    county_fips: 51027,
    county_fips_all: '51027|51185|54047',
    county: 'Buchanan',
    county_names_all: 'Buchanan|Tazewell|McDowell',
    county_weights: '{"51027": 53.21, "51185": 34.1, "54047": 12.69}',
    density: 3.8,
    imprecise: false,
    latitude: 37.22005,
    longitude: -81.79638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24622',
  },
  {
    city: 'North Tazewell',
    county_fips: 51185,
    county_fips_all: '51185',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"51185": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 37.17292,
    longitude: -81.4782,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24630',
  },
  {
    city: 'Oakwood',
    county_fips: 51027,
    county_fips_all: '51027',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"51027": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 37.2202,
    longitude: -81.99714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24631',
  },
  {
    city: 'Pilgrims Knob',
    county_fips: 51027,
    county_fips_all: '51027',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"51027": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 37.27411,
    longitude: -81.90253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24634',
  },
  {
    city: 'Pocahontas',
    county_fips: 51185,
    county_fips_all: '51185',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"51185": 100}',
    density: 44.9,
    imprecise: false,
    latitude: 37.30683,
    longitude: -81.34962,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24635',
  },
  {
    city: 'Pounding Mill',
    county_fips: 51185,
    county_fips_all: '51185',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"51185": 100}',
    density: 45.6,
    imprecise: false,
    latitude: 37.05258,
    longitude: -81.70981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24637',
  },
  {
    city: 'Raven',
    county_fips: 51027,
    county_fips_all: '51027|51185|51167',
    county: 'Buchanan',
    county_names_all: 'Buchanan|Tazewell|Russell',
    county_weights: '{"51027": 72.0, "51185": 23.87, "51167": 4.13}',
    density: 22,
    imprecise: false,
    latitude: 37.17357,
    longitude: -81.90461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24639',
  },
  {
    city: 'Richlands',
    county_fips: 51185,
    county_fips_all: '51185',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"51185": 100}',
    density: 108.7,
    imprecise: false,
    latitude: 37.11797,
    longitude: -81.80802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24641',
  },
  {
    city: 'Rowe',
    county_fips: 51027,
    county_fips_all: '51027',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"51027": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 37.13751,
    longitude: -82.02976,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24646',
  },
  {
    city: 'Swords Creek',
    county_fips: 51167,
    county_fips_all: '51167|51027',
    county: 'Russell',
    county_names_all: 'Russell|Buchanan',
    county_weights: '{"51167": 99.29, "51027": 0.71}',
    density: 25.5,
    imprecise: false,
    latitude: 37.08303,
    longitude: -81.92198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24649',
  },
  {
    city: 'Tazewell',
    county_fips: 51185,
    county_fips_all: '51185',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"51185": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 37.07732,
    longitude: -81.50054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24651',
  },
  {
    city: 'Vansant',
    county_fips: 51027,
    county_fips_all: '51027',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"51027": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 37.1743,
    longitude: -82.12364,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24656',
  },
  {
    city: 'Whitewood',
    county_fips: 51027,
    county_fips_all: '51027',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"51027": 100}',
    density: 6,
    imprecise: false,
    latitude: 37.22363,
    longitude: -81.84737,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24657',
  },
  {
    city: 'Bluefield',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 108,
    imprecise: false,
    latitude: 37.29929,
    longitude: -81.2065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24701',
  },
  {
    city: 'Athens',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 94.9,
    imprecise: false,
    latitude: 37.46903,
    longitude: -81.02029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24712',
  },
  {
    city: 'Beeson',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 37.47627,
    longitude: -81.18352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24714',
  },
  {
    city: 'Bramwell',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 37.33408,
    longitude: -81.32933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24715',
  },
  {
    city: 'Bud',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 71.5,
    imprecise: false,
    latitude: 37.53331,
    longitude: -81.37337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24716',
  },
  {
    city: 'Covel',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 46.7,
    imprecise: false,
    latitude: 37.48722,
    longitude: -81.32652,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24719',
  },
  {
    city: 'Bramwell',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 29.5,
    imprecise: false,
    latitude: 37.33603,
    longitude: -81.31579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24724',
  },
  {
    city: 'Herndon',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 37.52084,
    longitude: -81.37229,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24726',
  },
  {
    city: 'Hiawatha',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 37.44759,
    longitude: -81.24699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24729',
  },
  {
    city: 'Kegley',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 51.8,
    imprecise: false,
    latitude: 37.39733,
    longitude: -81.15162,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24731',
  },
  {
    city: 'Lashmeet',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 37.44986,
    longitude: -81.20094,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24733',
  },
  {
    city: 'Matoaka',
    county_fips: 54109,
    county_fips_all: '54109|54055',
    county: 'Wyoming',
    county_names_all: 'Wyoming|Mercer',
    county_weights: '{"54109": 52.0, "54055": 48.0}',
    density: 5.9,
    imprecise: false,
    latitude: 37.45045,
    longitude: -81.29589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24736',
  },
  {
    city: 'Montcalm',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 45,
    imprecise: false,
    latitude: 37.35042,
    longitude: -81.26055,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24737',
  },
  {
    city: 'Nemours',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.3032,
    longitude: -81.32013,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24738',
  },
  {
    city: 'Princeton',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 43,
    imprecise: false,
    latitude: 37.36784,
    longitude: -80.9949,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24739',
  },
  {
    city: 'Princeton',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 208,
    imprecise: false,
    latitude: 37.4042,
    longitude: -81.10205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24740',
  },
  {
    city: 'Rock',
    county_fips: 54055,
    county_fips_all: '54055|54047',
    county: 'Mercer',
    county_names_all: 'Mercer|McDowell',
    county_weights: '{"54055": 97.27, "54047": 2.73}',
    density: 28.2,
    imprecise: false,
    latitude: 37.40182,
    longitude: -81.2273,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24747',
  },
  {
    city: 'Welch',
    county_fips: 54109,
    county_fips_all: '54109|54047',
    county: 'Wyoming',
    county_names_all: 'Wyoming|McDowell',
    county_weights: '{"54109": 52.8, "54047": 47.2}',
    density: 17.3,
    imprecise: false,
    latitude: 37.46841,
    longitude: -81.55544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24801',
  },
  {
    city: 'Anawalt',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 37.33142,
    longitude: -81.41048,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24808',
  },
  {
    city: 'Avondale',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 37.40881,
    longitude: -81.75381,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24811',
  },
  {
    city: 'Bartley',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 37.35954,
    longitude: -81.72489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24813',
  },
  {
    city: 'Berwind',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 37.22036,
    longitude: -81.63026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24815',
  },
  {
    city: 'Big Sandy',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 91.9,
    imprecise: false,
    latitude: 37.46139,
    longitude: -81.70516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24816',
  },
  {
    city: 'Bradshaw',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 32.9,
    imprecise: false,
    latitude: 37.34206,
    longitude: -81.81721,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24817',
  },
  {
    city: 'Brenton',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 22.2,
    imprecise: false,
    latitude: 37.60809,
    longitude: -81.62275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24818',
  },
  {
    city: 'Clear Fork',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 37.62908,
    longitude: -81.68755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24822',
  },
  {
    city: 'Coal Mountain',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 37.66761,
    longitude: -81.74105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24823',
  },
  {
    city: 'Cucumber',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 37.29212,
    longitude: -81.62411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24826',
  },
  {
    city: 'Cyclone',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 37.75186,
    longitude: -81.65997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24827',
  },
  {
    city: 'Davy',
    county_fips: 54047,
    county_fips_all: '54047|54109',
    county: 'McDowell',
    county_names_all: 'McDowell|Wyoming',
    county_weights: '{"54047": 86.15, "54109": 13.85}',
    density: 11.1,
    imprecise: false,
    latitude: 37.49975,
    longitude: -81.6553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24828',
  },
  {
    city: 'Elbert',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 37.33399,
    longitude: -81.55799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24830',
  },
  {
    city: 'Elkhorn',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 37.38943,
    longitude: -81.44085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24831',
  },
  {
    city: 'Fanrock',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 21,
    imprecise: false,
    latitude: 37.54313,
    longitude: -81.66093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24834',
  },
  {
    city: 'Gary',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 43,
    imprecise: false,
    latitude: 37.36846,
    longitude: -81.54908,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24836',
  },
  {
    city: 'Hanover',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 37.58216,
    longitude: -81.76504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24839',
  },
  {
    city: 'Hensley',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.48378,
    longitude: -81.70923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24843',
  },
  {
    city: 'Iaeger',
    county_fips: 54047,
    county_fips_all: '54047|54109',
    county: 'McDowell',
    county_names_all: 'McDowell|Wyoming',
    county_weights: '{"54047": 71.52, "54109": 28.48}',
    density: 7.1,
    imprecise: false,
    latitude: 37.48554,
    longitude: -81.78703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24844',
  },
  {
    city: 'Ikes Fork',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 37.52643,
    longitude: -81.80041,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24845',
  },
  {
    city: 'Isaban',
    county_fips: 54047,
    county_fips_all: '54047|54059',
    county: 'McDowell',
    county_names_all: 'McDowell|Mingo',
    county_weights: '{"54047": 63.88, "54059": 36.12}',
    density: 10.6,
    imprecise: false,
    latitude: 37.52611,
    longitude: -81.89175,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24846',
  },
  {
    city: 'Itmann',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 31.3,
    imprecise: false,
    latitude: 37.57339,
    longitude: -81.41455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24847',
  },
  {
    city: 'Jenkinjones',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 22,
    imprecise: false,
    latitude: 37.28206,
    longitude: -81.43413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24848',
  },
  {
    city: 'Jesse',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 37.67435,
    longitude: -81.55848,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24849',
  },
  {
    city: 'Jolo',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 37.37807,
    longitude: -81.88516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24850',
  },
  {
    city: 'Justice',
    county_fips: 54059,
    county_fips_all: '54059|54109',
    county: 'Mingo',
    county_names_all: 'Mingo|Wyoming',
    county_weights: '{"54059": 99.09, "54109": 0.91}',
    density: 54,
    imprecise: false,
    latitude: 37.59922,
    longitude: -81.83805,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24851',
  },
  {
    city: 'Kimball',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 37.42924,
    longitude: -81.51686,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24853',
  },
  {
    city: 'Kopperston',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 37.73997,
    longitude: -81.5789,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24854',
  },
  {
    city: 'Lynco',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 37.69591,
    longitude: -81.67557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24857',
  },
  {
    city: 'Matheny',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 41.1,
    imprecise: false,
    latitude: 37.65919,
    longitude: -81.59075,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24860',
  },
  {
    city: 'Maybeury',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 37.36182,
    longitude: -81.36525,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 90,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24861',
  },
  {
    city: 'Mohawk',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 37.47905,
    longitude: -81.9489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24862',
  },
  {
    city: 'Newhall',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 37.25216,
    longitude: -81.59925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24866',
  },
  {
    city: 'New Richmond',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 37.60432,
    longitude: -81.45261,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24867',
  },
  {
    city: 'Northfork',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 37.42412,
    longitude: -81.40259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24868',
  },
  {
    city: 'North Spring',
    county_fips: 54109,
    county_fips_all: '54109|54047',
    county: 'Wyoming',
    county_names_all: 'Wyoming|McDowell',
    county_weights: '{"54109": 99.86, "54047": 0.14}',
    density: 22,
    imprecise: false,
    latitude: 37.56133,
    longitude: -81.82315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24869',
  },
  {
    city: 'Oceana',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 37.73784,
    longitude: -81.53203,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24870',
  },
  {
    city: 'Pageton',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 37.31693,
    longitude: -81.48552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24871',
  },
  {
    city: 'Panther',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 37.44986,
    longitude: -81.8932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24872',
  },
  {
    city: 'Paynesville',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 37.35734,
    longitude: -81.87415,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24873',
  },
  {
    city: 'Pineville',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 32.6,
    imprecise: false,
    latitude: 37.60201,
    longitude: -81.53072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24874',
  },
  {
    city: 'Premier',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 37.4321,
    longitude: -81.63086,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24878',
  },
  {
    city: 'Raysal',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 37.31639,
    longitude: -81.76725,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24879',
  },
  {
    city: 'Rock View',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 37.64679,
    longitude: -81.53187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24880',
  },
  {
    city: 'Roderfield',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 37.44435,
    longitude: -81.68785,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 82,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24881',
  },
  {
    city: 'Simon',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 28.5,
    imprecise: false,
    latitude: 37.62771,
    longitude: -81.76623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24882',
  },
  {
    city: 'Squire',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 1,
    imprecise: false,
    latitude: 37.27943,
    longitude: -81.55048,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24884',
  },
  {
    city: 'Switchback',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.37808,
    longitude: -81.38664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24887',
  },
  {
    city: 'Thorpe',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 37.36195,
    longitude: -81.48876,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 90,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24888',
  },
  {
    city: 'War',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 37.31691,
    longitude: -81.69699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24892',
  },
  {
    city: 'Warriormine',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 37.25186,
    longitude: -81.69052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24894',
  },
  {
    city: 'Wilcoe',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 37.37718,
    longitude: -81.58208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24895',
  },
  {
    city: 'Wyoming',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 52.5,
    imprecise: false,
    latitude: 37.58752,
    longitude: -81.57504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24898',
  },
  {
    city: 'Lewisburg',
    county_fips: 54025,
    county_fips_all: '54025',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier',
    county_weights: '{"54025": 100}',
    density: 37.7,
    imprecise: false,
    latitude: 37.85298,
    longitude: -80.47598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24901',
  },
  {
    city: 'Alderson',
    county_fips: 54025,
    county_fips_all: '54025|54089|54063',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier|Summers|Monroe',
    county_weights: '{"54025": 44.38, "54089": 32.59, "54063": 23.03}',
    density: 13.4,
    imprecise: false,
    latitude: 37.74173,
    longitude: -80.66835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24910',
  },
  {
    city: 'Arbovale',
    county_fips: 54075,
    county_fips_all: '54075',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"54075": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 38.4693,
    longitude: -79.78668,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24915',
  },
  {
    city: 'Asbury',
    county_fips: 54025,
    county_fips_all: '54025',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier',
    county_weights: '{"54025": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 37.82735,
    longitude: -80.57735,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24916',
  },
  {
    city: 'Ballard',
    county_fips: 54063,
    county_fips_all: '54063|54089',
    county: 'Monroe',
    county_names_all: 'Monroe|Summers',
    county_weights: '{"54063": 99.23, "54089": 0.77}',
    density: 14.7,
    imprecise: false,
    latitude: 37.51793,
    longitude: -80.75461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24918',
  },
  {
    city: 'Bartow',
    county_fips: 54075,
    county_fips_all: '54075',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"54075": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 38.58918,
    longitude: -79.71723,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24920',
  },
  {
    city: 'Buckeye',
    county_fips: 54075,
    county_fips_all: '54075',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"54075": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 38.19294,
    longitude: -80.15174,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24924',
  },
  {
    city: 'Caldwell',
    county_fips: 54025,
    county_fips_all: '54025|54063',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier|Monroe',
    county_weights: '{"54025": 73.54, "54063": 26.46}',
    density: 5.7,
    imprecise: false,
    latitude: 37.72919,
    longitude: -80.38348,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24925',
  },
  {
    city: 'Cass',
    county_fips: 54075,
    county_fips_all: '54075',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"54075": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 38.38999,
    longitude: -79.965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24927',
  },
  {
    city: 'Crawley',
    county_fips: 54025,
    county_fips_all: '54025',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier',
    county_weights: '{"54025": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 37.91471,
    longitude: -80.59355,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24931',
  },
  {
    city: 'Dunmore',
    county_fips: 54075,
    county_fips_all: '54075',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"54075": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 38.32836,
    longitude: -79.89267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24934',
  },
  {
    city: 'Forest Hill',
    county_fips: 54089,
    county_fips_all: '54089',
    county: 'Summers',
    county_names_all: 'Summers',
    county_weights: '{"54089": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 37.56362,
    longitude: -80.80344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24935',
  },
  {
    city: 'Frankford',
    county_fips: 54025,
    county_fips_all: '54025',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier',
    county_weights: '{"54025": 100}',
    density: 16,
    imprecise: false,
    latitude: 37.92516,
    longitude: -80.38083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24938',
  },
  {
    city: 'Gap Mills',
    county_fips: 54063,
    county_fips_all: '54063',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"54063": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 37.58824,
    longitude: -80.3577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24941',
  },
  {
    city: 'Grassy Meadows',
    county_fips: 54025,
    county_fips_all: '54025',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier',
    county_weights: '{"54025": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 37.83632,
    longitude: -80.72709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24943',
  },
  {
    city: 'Green Bank',
    county_fips: 54075,
    county_fips_all: '54075',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"54075": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 38.39926,
    longitude: -79.77108,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24944',
  },
  {
    city: 'Greenville',
    county_fips: 54063,
    county_fips_all: '54063',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"54063": 100}',
    density: 6,
    imprecise: false,
    latitude: 37.54113,
    longitude: -80.68795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24945',
  },
  {
    city: 'Hillsboro',
    county_fips: 54075,
    county_fips_all: '54075',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"54075": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 38.17891,
    longitude: -80.2671,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24946',
  },
  {
    city: 'Lindside',
    county_fips: 54063,
    county_fips_all: '54063',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"54063": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 37.48358,
    longitude: -80.63103,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24951',
  },
  {
    city: 'Marlinton',
    county_fips: 54075,
    county_fips_all: '54075',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"54075": 100}',
    density: 4,
    imprecise: false,
    latitude: 38.22932,
    longitude: -80.07436,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24954',
  },
  {
    city: 'Maxwelton',
    county_fips: 54025,
    county_fips_all: '54025',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier',
    county_weights: '{"54025": 100}',
    density: 32.8,
    imprecise: false,
    latitude: 37.88729,
    longitude: -80.40827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24957',
  },
  {
    city: 'Pence Springs',
    county_fips: 54089,
    county_fips_all: '54089',
    county: 'Summers',
    county_names_all: 'Summers',
    county_weights: '{"54089": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 37.66029,
    longitude: -80.72041,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24962',
  },
  {
    city: 'Peterstown',
    county_fips: 54063,
    county_fips_all: '54063|54089',
    county: 'Monroe',
    county_names_all: 'Monroe|Summers',
    county_weights: '{"54063": 82.0, "54089": 18.0}',
    density: 27.4,
    imprecise: false,
    latitude: 37.43743,
    longitude: -80.77617,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24963',
  },
  {
    city: 'Renick',
    county_fips: 54025,
    county_fips_all: '54025',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier',
    county_weights: '{"54025": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 38.03345,
    longitude: -80.35283,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24966',
  },
  {
    city: 'Ronceverte',
    county_fips: 54025,
    county_fips_all: '54025|54063',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier|Monroe',
    county_weights: '{"54025": 96.06, "54063": 3.94}',
    density: 37,
    imprecise: false,
    latitude: 37.73238,
    longitude: -80.47574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24970',
  },
  {
    city: 'Secondcreek',
    county_fips: 54063,
    county_fips_all: '54063',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"54063": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 37.65395,
    longitude: -80.44693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24974',
  },
  {
    city: 'Sinks Grove',
    county_fips: 54063,
    county_fips_all: '54063|54025',
    county: 'Monroe',
    county_names_all: 'Monroe|Greenbrier',
    county_weights: '{"54063": 90.36, "54025": 9.64}',
    density: 11.3,
    imprecise: false,
    latitude: 37.66513,
    longitude: -80.52273,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24976',
  },
  {
    city: 'Smoot',
    county_fips: 54025,
    county_fips_all: '54025',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier',
    county_weights: '{"54025": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 37.90823,
    longitude: -80.67527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24977',
  },
  {
    city: 'Talcott',
    county_fips: 54089,
    county_fips_all: '54089|54063',
    county: 'Summers',
    county_names_all: 'Summers|Monroe',
    county_weights: '{"54089": 86.68, "54063": 13.32}',
    density: 22.8,
    imprecise: false,
    latitude: 37.63256,
    longitude: -80.73968,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24981',
  },
  {
    city: 'Union',
    county_fips: 54063,
    county_fips_all: '54063',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"54063": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 37.59165,
    longitude: -80.51672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24983',
  },
  {
    city: 'Waiteville',
    county_fips: 54063,
    county_fips_all: '54063',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"54063": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 37.48942,
    longitude: -80.41749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24984',
  },
  {
    city: 'Wayside',
    county_fips: 54063,
    county_fips_all: '54063|54089',
    county: 'Monroe',
    county_names_all: 'Monroe|Summers',
    county_weights: '{"54063": 78.76, "54089": 21.24}',
    density: 4.3,
    imprecise: false,
    latitude: 37.59989,
    longitude: -80.68948,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24985',
  },
  {
    city: 'White Sulphur Springs',
    county_fips: 54025,
    county_fips_all: '54025|54075',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier|Pocahontas',
    county_weights: '{"54025": 96.91, "54075": 3.09}',
    density: 8,
    imprecise: false,
    latitude: 37.91189,
    longitude: -80.19455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24986',
  },
  {
    city: 'Williamsburg',
    county_fips: 54025,
    county_fips_all: '54025',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier',
    county_weights: '{"54025": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 38.00702,
    longitude: -80.48972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24991',
  },
  {
    city: 'Wolfcreek',
    county_fips: 54063,
    county_fips_all: '54063',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"54063": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 37.66095,
    longitude: -80.63512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24993',
  },
  {
    city: 'Alloy',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.13087,
    longitude: -81.25466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25002',
  },
  {
    city: 'Alum Creek',
    county_fips: 54039,
    county_fips_all: '54039|54043|54005',
    county: 'Kanawha',
    county_names_all: 'Kanawha|Lincoln|Boone',
    county_weights: '{"54039": 70.54, "54043": 29.36, "54005": 0.1}',
    density: 20.5,
    imprecise: false,
    latitude: 38.25101,
    longitude: -81.77925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25003',
  },
  {
    city: 'Amma',
    county_fips: 54087,
    county_fips_all: '54087',
    county: 'Roane',
    county_names_all: 'Roane',
    county_weights: '{"54087": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 38.58201,
    longitude: -81.26982,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25005',
  },
  {
    city: 'Arnett',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 49.4,
    imprecise: false,
    latitude: 37.8252,
    longitude: -81.42766,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25007',
  },
  {
    city: 'Artie',
    county_fips: 54081,
    county_fips_all: '54081|54019',
    county: 'Raleigh',
    county_names_all: 'Raleigh|Fayette',
    county_weights: '{"54081": 99.71, "54019": 0.29}',
    density: 3.2,
    imprecise: false,
    latitude: 37.95044,
    longitude: -81.35766,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25008',
  },
  {
    city: 'Ashford',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 38.19237,
    longitude: -81.71301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25009',
  },
  {
    city: 'Bancroft',
    county_fips: 54079,
    county_fips_all: '54079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"54079": 100}',
    density: 275.3,
    imprecise: false,
    latitude: 38.51169,
    longitude: -81.8363,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25011',
  },
  {
    city: 'Belle',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 50.3,
    imprecise: false,
    latitude: 38.24293,
    longitude: -81.49226,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25015',
  },
  {
    city: 'Bickmore',
    county_fips: 54015,
    county_fips_all: '54015',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"54015": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 38.37663,
    longitude: -81.08955,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25019',
  },
  {
    city: 'Bim',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 37.91587,
    longitude: -81.68482,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25021',
  },
  {
    city: 'Blair',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 37.84157,
    longitude: -81.79241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25022',
  },
  {
    city: 'Bloomingrose',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 37.5,
    imprecise: false,
    latitude: 38.15744,
    longitude: -81.6266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25024',
  },
  {
    city: 'Blount',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 38.29378,
    longitude: -81.4018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25025',
  },
  {
    city: 'Bob White',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 34.5,
    imprecise: false,
    latitude: 37.95598,
    longitude: -81.72535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25028',
  },
  {
    city: 'Bomont',
    county_fips: 54015,
    county_fips_all: '54015',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"54015": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 38.45028,
    longitude: -81.22599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25030',
  },
  {
    city: 'Boomer',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 122.4,
    imprecise: false,
    latitude: 38.14615,
    longitude: -81.2801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25031',
  },
  {
    city: 'Buffalo',
    county_fips: 54079,
    county_fips_all: '54079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"54079": 100}',
    density: 35.5,
    imprecise: false,
    latitude: 38.61095,
    longitude: -81.92511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25033',
  },
  {
    city: 'Cabin Creek',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 38.16339,
    longitude: -81.52399,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25035',
  },
  {
    city: 'Cannelton',
    county_fips: 54019,
    county_fips_all: '54019|54039',
    county: 'Fayette',
    county_names_all: 'Fayette|Kanawha',
    county_weights: '{"54019": 99.41, "54039": 0.59}',
    density: 4.2,
    imprecise: false,
    latitude: 38.19168,
    longitude: -81.26438,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25036',
  },
  {
    city: 'Cedar Grove',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 38.24642,
    longitude: -81.36524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25039',
  },
  {
    city: 'Charlton Heights',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 65.7,
    imprecise: false,
    latitude: 38.13673,
    longitude: -81.24385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25040',
  },
  {
    city: 'Clay',
    county_fips: 54015,
    county_fips_all: '54015|54067',
    county: 'Clay',
    county_names_all: 'Clay|Nicholas',
    county_weights: '{"54015": 87.21, "54067": 12.79}',
    density: 4.6,
    imprecise: false,
    latitude: 38.44092,
    longitude: -80.98981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25043',
  },
  {
    city: 'Clear Creek',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 37.91139,
    longitude: -81.32118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25044',
  },
  {
    city: 'Clendenin',
    county_fips: 54039,
    county_fips_all: '54039|54087|54015',
    county: 'Kanawha',
    county_names_all: 'Kanawha|Roane|Clay',
    county_weights: '{"54039": 78.19, "54087": 13.88, "54015": 7.93}',
    density: 12.5,
    imprecise: false,
    latitude: 38.45603,
    longitude: -81.32474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25045',
  },
  {
    city: 'Clothier',
    county_fips: 54005,
    county_fips_all: '54005|54045',
    county: 'Boone',
    county_names_all: 'Boone|Logan',
    county_weights: '{"54005": 96.51, "54045": 3.49}',
    density: 7.1,
    imprecise: false,
    latitude: 37.9219,
    longitude: -81.76027,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25047',
  },
  {
    city: 'Colcord',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 37.95442,
    longitude: -81.44656,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25048',
  },
  {
    city: 'Comfort',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 38.11954,
    longitude: -81.57315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25049',
  },
  {
    city: 'Costa',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 101.7,
    imprecise: false,
    latitude: 38.15885,
    longitude: -81.70929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25051',
  },
  {
    city: 'Danville',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 30,
    imprecise: false,
    latitude: 38.04725,
    longitude: -81.87633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25053',
  },
  {
    city: 'Dawes',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 429.1,
    imprecise: false,
    latitude: 38.12226,
    longitude: -81.45044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25054',
  },
  {
    city: 'Deep Water',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 38.1078,
    longitude: -81.23783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25057',
  },
  {
    city: 'Dixie',
    county_fips: 54019,
    county_fips_all: '54019|54067|54039|54015',
    county: 'Fayette',
    county_names_all: 'Fayette|Nicholas|Kanawha|Clay',
    county_weights:
      '{"54019": 51.99, "54067": 47.78, "54039": 0.13, "54015": 0.1}',
    density: 24,
    imprecise: false,
    latitude: 38.25422,
    longitude: -81.2153,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25059',
  },
  {
    city: 'Dorothy',
    county_fips: 54081,
    county_fips_all: '54081|54005',
    county: 'Raleigh',
    county_names_all: 'Raleigh|Boone',
    county_weights: '{"54081": 99.87, "54005": 0.13}',
    density: 2.9,
    imprecise: false,
    latitude: 37.97058,
    longitude: -81.47286,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25060',
  },
  {
    city: 'Drybranch',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 38.1751,
    longitude: -81.43342,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25061',
  },
  {
    city: 'Dry Creek',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 37.87549,
    longitude: -81.44411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25062',
  },
  {
    city: 'Duck',
    county_fips: 54007,
    county_fips_all: '54007|54015|54067',
    county: 'Braxton',
    county_names_all: 'Braxton|Clay|Nicholas',
    county_weights: '{"54007": 57.37, "54015": 40.45, "54067": 2.18}',
    density: 6.8,
    imprecise: false,
    latitude: 38.57761,
    longitude: -80.92572,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25063',
  },
  {
    city: 'Dunbar',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 524.6,
    imprecise: false,
    latitude: 38.37631,
    longitude: -81.74764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25064',
  },
  {
    city: 'East Bank',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 379.7,
    imprecise: false,
    latitude: 38.20963,
    longitude: -81.44018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25067',
  },
  {
    city: 'Eleanor',
    county_fips: 54079,
    county_fips_all: '54079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"54079": 100}',
    density: 147.7,
    imprecise: false,
    latitude: 38.54667,
    longitude: -81.93179,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25070',
  },
  {
    city: 'Elkview',
    county_fips: 54039,
    county_fips_all: '54039|54087',
    county: 'Kanawha',
    county_names_all: 'Kanawha|Roane',
    county_weights: '{"54039": 91.32, "54087": 8.68}',
    density: 38.1,
    imprecise: false,
    latitude: 38.47732,
    longitude: -81.46756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25071',
  },
  {
    city: 'Eskdale',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 38.0526,
    longitude: -81.42915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25075',
  },
  {
    city: 'Ethel',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 37.86889,
    longitude: -81.937,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25076',
  },
  {
    city: 'Foster',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 27.1,
    imprecise: false,
    latitude: 38.08235,
    longitude: -81.76875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25081',
  },
  {
    city: 'Fraziers Bottom',
    county_fips: 54079,
    county_fips_all: '54079|54053',
    county: 'Putnam',
    county_names_all: 'Putnam|Mason',
    county_weights: '{"54079": 52.15, "54053": 47.85}',
    density: 13.6,
    imprecise: false,
    latitude: 38.60861,
    longitude: -82.02879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25082',
  },
  {
    city: 'Gallagher',
    county_fips: 54039,
    county_fips_all: '54039|54019|54081',
    county: 'Kanawha',
    county_names_all: 'Kanawha|Fayette|Raleigh',
    county_weights: '{"54039": 62.76, "54019": 37.13, "54081": 0.11}',
    density: 6.2,
    imprecise: false,
    latitude: 38.06809,
    longitude: -81.36118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25083',
  },
  {
    city: 'Gauley Bridge',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 38.16762,
    longitude: -81.18867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25085',
  },
  {
    city: 'Glasgow',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 253.3,
    imprecise: false,
    latitude: 38.21326,
    longitude: -81.41238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25086',
  },
  {
    city: 'Glen',
    county_fips: 54015,
    county_fips_all: '54015',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"54015": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 38.37963,
    longitude: -81.21551,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25088',
  },
  {
    city: 'Glen Ferris',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 18,
    imprecise: false,
    latitude: 38.15544,
    longitude: -81.21655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25090',
  },
  {
    city: 'Gordon',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 37.9653,
    longitude: -81.64137,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25093',
  },
  {
    city: 'Handley',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 34.8,
    imprecise: false,
    latitude: 38.16735,
    longitude: -81.35192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25102',
  },
  {
    city: 'Hansford',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 14,
    imprecise: false,
    latitude: 38.18207,
    longitude: -81.38225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25103',
  },
  {
    city: 'Henderson',
    county_fips: 54053,
    county_fips_all: '54053',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"54053": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 38.77598,
    longitude: -82.08237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25106',
  },
  {
    city: 'Hernshaw',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 38.22427,
    longitude: -81.64493,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25107',
  },
  {
    city: 'Hewett',
    county_fips: 54005,
    county_fips_all: '54005|54045',
    county: 'Boone',
    county_names_all: 'Boone|Logan',
    county_weights: '{"54005": 99.8, "54045": 0.2}',
    density: 34.8,
    imprecise: false,
    latitude: 37.9655,
    longitude: -81.87289,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25108',
  },
  {
    city: 'Hometown',
    county_fips: 54079,
    county_fips_all: '54079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"54079": 100}',
    density: 971.6,
    imprecise: false,
    latitude: 38.53097,
    longitude: -81.86062,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25109',
  },
  {
    city: 'Hugheston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 10,
    imprecise: false,
    latitude: 38.21324,
    longitude: -81.3264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25110',
  },
  {
    city: 'Indore',
    county_fips: 54015,
    county_fips_all: '54015|54067',
    county: 'Clay',
    county_names_all: 'Clay|Nicholas',
    county_weights: '{"54015": 55.87, "54067": 44.13}',
    density: 3.1,
    imprecise: false,
    latitude: 38.34841,
    longitude: -81.12591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25111',
  },
  {
    city: 'Institute',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 1594.8,
    imprecise: false,
    latitude: 38.38103,
    longitude: -81.76633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25112',
  },
  {
    city: 'Ivydale',
    county_fips: 54015,
    county_fips_all: '54015',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"54015": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 38.55741,
    longitude: -81.03338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25113',
  },
  {
    city: 'Jeffrey',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 37.98199,
    longitude: -81.7986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25114',
  },
  {
    city: 'Kanawha Falls',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 38.13065,
    longitude: -81.18997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25115',
  },
  {
    city: 'Kimberly',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 28.5,
    imprecise: false,
    latitude: 38.11882,
    longitude: -81.32294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25118',
  },
  {
    city: 'Kincaid',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 38.03362,
    longitude: -81.27494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25119',
  },
  {
    city: 'Lake',
    county_fips: 54045,
    county_fips_all: '54045|54005',
    county: 'Logan',
    county_names_all: 'Logan|Boone',
    county_weights: '{"54045": 97.28, "54005": 2.72}',
    density: 11.8,
    imprecise: false,
    latitude: 37.91167,
    longitude: -81.87787,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25121',
  },
  {
    city: 'Leon',
    county_fips: 54053,
    county_fips_all: '54053|54079',
    county: 'Mason',
    county_names_all: 'Mason|Putnam',
    county_weights: '{"54053": 80.93, "54079": 19.07}',
    density: 8.1,
    imprecise: false,
    latitude: 38.73172,
    longitude: -81.90214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25123',
  },
  {
    city: 'Liberty',
    county_fips: 54079,
    county_fips_all: '54079|54039|54035',
    county: 'Putnam',
    county_names_all: 'Putnam|Kanawha|Jackson',
    county_weights: '{"54079": 93.13, "54039": 6.1, "54035": 0.77}',
    density: 17.9,
    imprecise: false,
    latitude: 38.62006,
    longitude: -81.76536,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25124',
  },
  {
    city: 'Lizemores',
    county_fips: 54015,
    county_fips_all: '54015|54067',
    county: 'Clay',
    county_names_all: 'Clay|Nicholas',
    county_weights: '{"54015": 92.72, "54067": 7.28}',
    density: 13.3,
    imprecise: false,
    latitude: 38.31554,
    longitude: -81.19074,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25125',
  },
  {
    city: 'London',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 49.4,
    imprecise: false,
    latitude: 38.19058,
    longitude: -81.35382,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25126',
  },
  {
    city: 'Madison',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 53.9,
    imprecise: false,
    latitude: 38.02776,
    longitude: -81.7455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25130',
  },
  {
    city: 'Mammoth',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 38.29328,
    longitude: -81.33441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25132',
  },
  {
    city: 'Maysel',
    county_fips: 54015,
    county_fips_all: '54015',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"54015": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 38.47976,
    longitude: -81.11831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25133',
  },
  {
    city: 'Miami',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 38.13596,
    longitude: -81.48553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25134',
  },
  {
    city: 'Montgomery',
    county_fips: 54019,
    county_fips_all: '54019|54039',
    county: 'Fayette',
    county_names_all: 'Fayette|Kanawha',
    county_weights: '{"54019": 91.38, "54039": 8.62}',
    density: 115.9,
    imprecise: false,
    latitude: 38.15864,
    longitude: -81.31977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25136',
  },
  {
    city: 'Mount Carbon',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 23.8,
    imprecise: false,
    latitude: 38.11038,
    longitude: -81.2874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25139',
  },
  {
    city: 'Naoma',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 37.86738,
    longitude: -81.49733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25140',
  },
  {
    city: 'Nebo',
    county_fips: 54015,
    county_fips_all: '54015|54013',
    county: 'Clay',
    county_names_all: 'Clay|Calhoun',
    county_weights: '{"54015": 95.22, "54013": 4.78}',
    density: 17.8,
    imprecise: false,
    latitude: 38.6305,
    longitude: -81.03592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25141',
  },
  {
    city: 'Nellis',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 38.15001,
    longitude: -81.73066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25142',
  },
  {
    city: 'Nitro',
    county_fips: 54039,
    county_fips_all: '54039|54079',
    county: 'Kanawha',
    county_names_all: 'Kanawha|Putnam',
    county_weights: '{"54039": 67.18, "54079": 32.82}',
    density: 379,
    imprecise: false,
    latitude: 38.42001,
    longitude: -81.82414,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25143',
  },
  {
    city: 'Orgas',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 38.03511,
    longitude: -81.53695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25148',
  },
  {
    city: 'Ottawa',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 37.9558,
    longitude: -81.7745,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25149',
  },
  {
    city: 'Peytona',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 38.11572,
    longitude: -81.70249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25154',
  },
  {
    city: 'Pinch',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 1614.7,
    imprecise: false,
    latitude: 38.41181,
    longitude: -81.48217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25156',
  },
  {
    city: 'Poca',
    county_fips: 54079,
    county_fips_all: '54079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"54079": 100}',
    density: 41.4,
    imprecise: false,
    latitude: 38.50186,
    longitude: -81.7806,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25159',
  },
  {
    city: 'Pond Gap',
    county_fips: 54039,
    county_fips_all: '54039|54015',
    county: 'Kanawha',
    county_names_all: 'Kanawha|Clay',
    county_weights: '{"54039": 99.83, "54015": 0.17}',
    density: 6.4,
    imprecise: false,
    latitude: 38.29884,
    longitude: -81.27314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25160',
  },
  {
    city: 'Powellton',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 38.06123,
    longitude: -81.3189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25161',
  },
  {
    city: 'Pratt',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 516.2,
    imprecise: false,
    latitude: 38.20712,
    longitude: -81.38435,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25162',
  },
  {
    city: 'Procious',
    county_fips: 54015,
    county_fips_all: '54015|54087',
    county: 'Clay',
    county_names_all: 'Clay|Roane',
    county_weights: '{"54015": 65.43, "54087": 34.57}',
    density: 5.8,
    imprecise: false,
    latitude: 38.50406,
    longitude: -81.19373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25164',
  },
  {
    city: 'Racine',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 56,
    imprecise: false,
    latitude: 38.14907,
    longitude: -81.65308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25165',
  },
  {
    city: 'Red House',
    county_fips: 54079,
    county_fips_all: '54079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"54079": 100}',
    density: 28.2,
    imprecise: false,
    latitude: 38.56394,
    longitude: -81.87733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25168',
  },
  {
    city: 'Ridgeview',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 24.7,
    imprecise: false,
    latitude: 38.12788,
    longitude: -81.76288,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25169',
  },
  {
    city: 'Robson',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 38.07519,
    longitude: -81.21898,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 67,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25173',
  },
  {
    city: 'Rock Creek',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 37.86115,
    longitude: -81.41376,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25174',
  },
  {
    city: 'Saint Albans',
    county_fips: 54039,
    county_fips_all: '54039|54079',
    county: 'Kanawha',
    county_names_all: 'Kanawha|Putnam',
    county_weights: '{"54039": 93.43, "54079": 6.57}',
    density: 277.2,
    imprecise: false,
    latitude: 38.36928,
    longitude: -81.85021,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25177',
  },
  {
    city: 'Seth',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 38.04962,
    longitude: -81.63476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25181',
  },
  {
    city: 'Sharples',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 37.9074,
    longitude: -81.79745,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25183',
  },
  {
    city: 'Smithers',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 157.3,
    imprecise: false,
    latitude: 38.17113,
    longitude: -81.29811,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25186',
  },
  {
    city: 'Sylvester',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 38.01672,
    longitude: -81.55089,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25193',
  },
  {
    city: 'Tad',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 38.3489,
    longitude: -81.48645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25201',
  },
  {
    city: 'Tornado',
    county_fips: 54039,
    county_fips_all: '54039|54043',
    county: 'Kanawha',
    county_names_all: 'Kanawha|Lincoln',
    county_weights: '{"54039": 52.42, "54043": 47.58}',
    density: 42.8,
    imprecise: false,
    latitude: 38.31593,
    longitude: -81.85372,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25202',
  },
  {
    city: 'Turtle Creek',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 40.2,
    imprecise: false,
    latitude: 38.02125,
    longitude: -81.88162,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25203',
  },
  {
    city: 'Twilight',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 37.91546,
    longitude: -81.60914,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25204',
  },
  {
    city: 'Uneeda',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 38.01841,
    longitude: -81.78926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25205',
  },
  {
    city: 'Van',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 16.1,
    imprecise: false,
    latitude: 37.9596,
    longitude: -81.69296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25206',
  },
  {
    city: 'Wharton',
    county_fips: 54005,
    county_fips_all: '54005',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"54005": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 37.84579,
    longitude: -81.64282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25208',
  },
  {
    city: 'Whitesville',
    county_fips: 54005,
    county_fips_all: '54005|54081',
    county: 'Boone',
    county_names_all: 'Boone|Raleigh',
    county_weights: '{"54005": 51.77, "54081": 48.23}',
    density: 8.1,
    imprecise: false,
    latitude: 37.96271,
    longitude: -81.52861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25209',
  },
  {
    city: 'Widen',
    county_fips: 54015,
    county_fips_all: '54015',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"54015": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 38.46107,
    longitude: -80.87932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25211',
  },
  {
    city: 'Winfield',
    county_fips: 54079,
    county_fips_all: '54079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"54079": 100}',
    density: 67,
    imprecise: false,
    latitude: 38.50776,
    longitude: -81.91796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25213',
  },
  {
    city: 'Winifrede',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 58,
    imprecise: false,
    latitude: 38.18947,
    longitude: -81.55127,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25214',
  },
  {
    city: 'Advent',
    county_fips: 54035,
    county_fips_all: '54035',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"54035": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 38.60464,
    longitude: -81.591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25231',
  },
  {
    city: 'Arnoldsburg',
    county_fips: 54013,
    county_fips_all: '54013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"54013": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 38.81291,
    longitude: -81.12343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25234',
  },
  {
    city: 'Chloe',
    county_fips: 54013,
    county_fips_all: '54013|54015|54007',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Clay|Braxton',
    county_weights: '{"54013": 88.84, "54015": 9.37, "54007": 1.79}',
    density: 9.1,
    imprecise: false,
    latitude: 38.66939,
    longitude: -81.08874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25235',
  },
  {
    city: 'Cottageville',
    county_fips: 54035,
    county_fips_all: '54035|54053',
    county: 'Jackson',
    county_names_all: 'Jackson|Mason',
    county_weights: '{"54035": 83.97, "54053": 16.03}',
    density: 23.9,
    imprecise: false,
    latitude: 38.84616,
    longitude: -81.83941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25239',
  },
  {
    city: 'Evans',
    county_fips: 54035,
    county_fips_all: '54035|54053',
    county: 'Jackson',
    county_names_all: 'Jackson|Mason',
    county_weights: '{"54035": 71.18, "54053": 28.82}',
    density: 35.5,
    imprecise: false,
    latitude: 38.78427,
    longitude: -81.80801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25241',
  },
  {
    city: 'Gandeeville',
    county_fips: 54087,
    county_fips_all: '54087|54035',
    county: 'Roane',
    county_names_all: 'Roane|Jackson',
    county_weights: '{"54087": 96.22, "54035": 3.78}',
    density: 5.2,
    imprecise: false,
    latitude: 38.67841,
    longitude: -81.48216,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25243',
  },
  {
    city: 'Gay',
    county_fips: 54035,
    county_fips_all: '54035|54087',
    county: 'Jackson',
    county_names_all: 'Jackson|Roane',
    county_weights: '{"54035": 67.12, "54087": 32.88}',
    density: 10.4,
    imprecise: false,
    latitude: 38.77068,
    longitude: -81.54237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25244',
  },
  {
    city: 'Hartford',
    county_fips: 54053,
    county_fips_all: '54053',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"54053": 100}',
    density: 151.6,
    imprecise: false,
    latitude: 39.001,
    longitude: -81.98987,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25247',
  },
  {
    city: 'Kenna',
    county_fips: 54035,
    county_fips_all: '54035|54039',
    county: 'Jackson',
    county_names_all: 'Jackson|Kanawha',
    county_weights: '{"54035": 98.31, "54039": 1.69}',
    density: 18.8,
    imprecise: false,
    latitude: 38.64255,
    longitude: -81.61454,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25248',
  },
  {
    city: 'Left Hand',
    county_fips: 54087,
    county_fips_all: '54087',
    county: 'Roane',
    county_names_all: 'Roane',
    county_weights: '{"54087": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 38.62119,
    longitude: -81.23173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25251',
  },
  {
    city: 'Le Roy',
    county_fips: 54035,
    county_fips_all: '54035|54087|54105',
    county: 'Jackson',
    county_names_all: 'Jackson|Roane|Wirt',
    county_weights: '{"54035": 55.55, "54087": 26.62, "54105": 17.83}',
    density: 7.1,
    imprecise: false,
    latitude: 38.88345,
    longitude: -81.53679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25252',
  },
  {
    city: 'Letart',
    county_fips: 54053,
    county_fips_all: '54053',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"54053": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 38.91947,
    longitude: -81.9669,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25253',
  },
  {
    city: 'Looneyville',
    county_fips: 54087,
    county_fips_all: '54087',
    county: 'Roane',
    county_names_all: 'Roane',
    county_weights: '{"54087": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 38.67465,
    longitude: -81.24836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25259',
  },
  {
    city: 'Mason',
    county_fips: 54053,
    county_fips_all: '54053|39105',
    county: 'Mason',
    county_names_all: 'Mason|Meigs',
    county_weights: '{"54053": 99.24, "39105": 0.76}',
    density: 232.1,
    imprecise: false,
    latitude: 39.01653,
    longitude: -82.02465,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25260',
  },
  {
    city: 'Millstone',
    county_fips: 54013,
    county_fips_all: '54013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"54013": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 38.83027,
    longitude: -81.08886,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25261',
  },
  {
    city: 'Millwood',
    county_fips: 54035,
    county_fips_all: '54035',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"54035": 100}',
    density: 120.6,
    imprecise: false,
    latitude: 38.90751,
    longitude: -81.83219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25262',
  },
  {
    city: 'Mount Alto',
    county_fips: 54053,
    county_fips_all: '54053|54035',
    county: 'Mason',
    county_names_all: 'Mason|Jackson',
    county_weights: '{"54053": 51.03, "54035": 48.97}',
    density: 26.3,
    imprecise: false,
    latitude: 38.85547,
    longitude: -81.89516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25264',
  },
  {
    city: 'New Haven',
    county_fips: 54053,
    county_fips_all: '54053',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"54053": 100}',
    density: 208.2,
    imprecise: false,
    latitude: 38.98129,
    longitude: -81.97356,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25265',
  },
  {
    city: 'Newton',
    county_fips: 54087,
    county_fips_all: '54087',
    county: 'Roane',
    county_names_all: 'Roane',
    county_weights: '{"54087": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 38.60224,
    longitude: -81.1589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25266',
  },
  {
    city: 'Normantown',
    county_fips: 54021,
    county_fips_all: '54021|54013',
    county: 'Gilmer',
    county_names_all: 'Gilmer|Calhoun',
    county_weights: '{"54021": 90.34, "54013": 9.66}',
    density: 3.9,
    imprecise: false,
    latitude: 38.85778,
    longitude: -80.94187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25267',
  },
  {
    city: 'Orma',
    county_fips: 54013,
    county_fips_all: '54013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"54013": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 38.73969,
    longitude: -81.107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25268',
  },
  {
    city: 'Reedy',
    county_fips: 54087,
    county_fips_all: '54087|54105',
    county: 'Roane',
    county_names_all: 'Roane|Wirt',
    county_weights: '{"54087": 90.03, "54105": 9.97}',
    density: 10.6,
    imprecise: false,
    latitude: 38.88174,
    longitude: -81.43395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25270',
  },
  {
    city: 'Ripley',
    county_fips: 54035,
    county_fips_all: '54035',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"54035": 100}',
    density: 29.8,
    imprecise: false,
    latitude: 38.78845,
    longitude: -81.68625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25271',
  },
  {
    city: 'Sandyville',
    county_fips: 54035,
    county_fips_all: '54035',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"54035": 100}',
    density: 14,
    imprecise: false,
    latitude: 38.92451,
    longitude: -81.61687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25275',
  },
  {
    city: 'Spencer',
    county_fips: 54087,
    county_fips_all: '54087',
    county: 'Roane',
    county_names_all: 'Roane',
    county_weights: '{"54087": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 38.78803,
    longitude: -81.33203,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25276',
  },
  {
    city: 'Wallback',
    county_fips: 54015,
    county_fips_all: '54015',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"54015": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 38.54723,
    longitude: -81.1129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25285',
  },
  {
    city: 'Walton',
    county_fips: 54087,
    county_fips_all: '54087',
    county: 'Roane',
    county_names_all: 'Roane',
    county_weights: '{"54087": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 38.62098,
    longitude: -81.39728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25286',
  },
  {
    city: 'West Columbia',
    county_fips: 54053,
    county_fips_all: '54053',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"54053": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 38.96158,
    longitude: -82.04834,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25287',
  },
  {
    city: 'Charleston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 719.3,
    imprecise: false,
    latitude: 38.35123,
    longitude: -81.62761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25301',
  },
  {
    city: 'Charleston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 410,
    imprecise: false,
    latitude: 38.39053,
    longitude: -81.59879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25302',
  },
  {
    city: 'South Charleston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 798.9,
    imprecise: false,
    latitude: 38.36033,
    longitude: -81.68679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25303',
  },
  {
    city: 'Charleston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 346.1,
    imprecise: false,
    latitude: 38.30521,
    longitude: -81.59044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25304',
  },
  {
    city: 'Charleston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.33682,
    longitude: -81.61313,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25305',
  },
  {
    city: 'Charleston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 62.8,
    imprecise: false,
    latitude: 38.31071,
    longitude: -81.49087,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25306',
  },
  {
    city: 'South Charleston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 150.9,
    imprecise: false,
    latitude: 38.31177,
    longitude: -81.75715,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25309',
  },
  {
    city: 'Charleston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 147.7,
    imprecise: false,
    latitude: 38.36308,
    longitude: -81.55357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25311',
  },
  {
    city: 'Charleston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 54.6,
    imprecise: false,
    latitude: 38.46156,
    longitude: -81.656,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25312',
  },
  {
    city: 'Charleston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 224.2,
    imprecise: false,
    latitude: 38.41547,
    longitude: -81.75704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25313',
  },
  {
    city: 'Charleston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 174.7,
    imprecise: false,
    latitude: 38.29705,
    longitude: -81.65463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25314',
  },
  {
    city: 'Charleston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 62.7,
    imprecise: false,
    latitude: 38.21032,
    longitude: -81.57992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25315',
  },
  {
    city: 'Charleston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 29.2,
    imprecise: false,
    latitude: 38.54124,
    longitude: -81.62706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25320',
  },
  {
    city: 'Charleston',
    county_fips: 54039,
    county_fips_all: '54039',
    county: 'Kanawha',
    county_names_all: 'Kanawha',
    county_weights: '{"54039": 100}',
    density: 330.9,
    imprecise: false,
    latitude: 38.38523,
    longitude: -81.6642,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25387',
  },
  {
    city: 'Martinsburg',
    county_fips: 54003,
    county_fips_all: '54003',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"54003": 100}',
    density: 989,
    imprecise: false,
    latitude: 39.45642,
    longitude: -77.97267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25401',
  },
  {
    city: 'Martinsburg',
    county_fips: 54003,
    county_fips_all: '54003',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"54003": 100}',
    density: 157.3,
    imprecise: false,
    latitude: 39.4842,
    longitude: -78.00725,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25403',
  },
  {
    city: 'Martinsburg',
    county_fips: 54003,
    county_fips_all: '54003',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"54003": 100}',
    density: 244.3,
    imprecise: false,
    latitude: 39.48631,
    longitude: -77.89782,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25404',
  },
  {
    city: 'Martinsburg',
    county_fips: 54003,
    county_fips_all: '54003',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"54003": 100}',
    density: 254.1,
    imprecise: false,
    latitude: 39.40892,
    longitude: -77.96235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25405',
  },
  {
    city: 'Berkeley Springs',
    county_fips: 54065,
    county_fips_all: '54065',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"54065": 100}',
    density: 34.2,
    imprecise: false,
    latitude: 39.55497,
    longitude: -78.22004,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25411',
  },
  {
    city: 'Bunker Hill',
    county_fips: 54003,
    county_fips_all: '54003',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"54003": 100}',
    density: 162.4,
    imprecise: false,
    latitude: 39.31632,
    longitude: -78.053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25413',
  },
  {
    city: 'Charles Town',
    county_fips: 54037,
    county_fips_all: '54037',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"54037": 100}',
    density: 143.8,
    imprecise: false,
    latitude: 39.25273,
    longitude: -77.87055,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25414',
  },
  {
    city: 'Falling Waters',
    county_fips: 54003,
    county_fips_all: '54003',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"54003": 100}',
    density: 291.5,
    imprecise: false,
    latitude: 39.58286,
    longitude: -77.88493,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25419',
  },
  {
    city: 'Gerrardstown',
    county_fips: 54003,
    county_fips_all: '54003',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"54003": 100}',
    density: 64.1,
    imprecise: false,
    latitude: 39.38095,
    longitude: -78.11969,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25420',
  },
  {
    city: 'Glengary',
    county_fips: 54003,
    county_fips_all: '54003',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"54003": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.37821,
    longitude: -78.16384,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25421',
  },
  {
    city: 'Great Cacapon',
    county_fips: 54065,
    county_fips_all: '54065|54027',
    county: 'Morgan',
    county_names_all: 'Morgan|Hampshire',
    county_weights: '{"54065": 95.09, "54027": 4.91}',
    density: 8.5,
    imprecise: false,
    latitude: 39.55812,
    longitude: -78.35887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25422',
  },
  {
    city: 'Harpers Ferry',
    county_fips: 54037,
    county_fips_all: '54037',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"54037": 100}',
    density: 117.3,
    imprecise: false,
    latitude: 39.27613,
    longitude: -77.79184,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25425',
  },
  {
    city: 'Hedgesville',
    county_fips: 54003,
    county_fips_all: '54003|54065',
    county: 'Berkeley',
    county_names_all: 'Berkeley|Morgan',
    county_weights: '{"54003": 87.84, "54065": 12.16}',
    density: 49,
    imprecise: false,
    latitude: 39.52608,
    longitude: -78.09098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25427',
  },
  {
    city: 'Inwood',
    county_fips: 54003,
    county_fips_all: '54003',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"54003": 100}',
    density: 260.6,
    imprecise: false,
    latitude: 39.37407,
    longitude: -78.02729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25428',
  },
  {
    city: 'Kearneysville',
    county_fips: 54037,
    county_fips_all: '54037|54003',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Berkeley',
    county_weights: '{"54037": 90.97, "54003": 9.03}',
    density: 75.2,
    imprecise: false,
    latitude: 39.34024,
    longitude: -77.93899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25430',
  },
  {
    city: 'Levels',
    county_fips: 54027,
    county_fips_all: '54027',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"54027": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 39.48682,
    longitude: -78.57279,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25431',
  },
  {
    city: 'Millville',
    county_fips: 54037,
    county_fips_all: '54037',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"54037": 100}',
    density: 632.7,
    imprecise: false,
    latitude: 39.29562,
    longitude: -77.78663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25432',
  },
  {
    city: 'Paw Paw',
    county_fips: 54027,
    county_fips_all: '54027|54065',
    county: 'Hampshire',
    county_names_all: 'Hampshire|Morgan',
    county_weights: '{"54027": 85.95, "54065": 14.05}',
    density: 16.9,
    imprecise: false,
    latitude: 39.45797,
    longitude: -78.45038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25434',
  },
  {
    city: 'Points',
    county_fips: 54027,
    county_fips_all: '54027',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"54027": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 39.4225,
    longitude: -78.57623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25437',
  },
  {
    city: 'Ranson',
    county_fips: 54037,
    county_fips_all: '54037',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"54037": 100}',
    density: 289.4,
    imprecise: false,
    latitude: 39.31853,
    longitude: -77.86448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25438',
  },
  {
    city: 'Shenandoah Junction',
    county_fips: 54037,
    county_fips_all: '54037',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"54037": 100}',
    density: 73.5,
    imprecise: false,
    latitude: 39.37157,
    longitude: -77.83181,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25442',
  },
  {
    city: 'Shepherdstown',
    county_fips: 54037,
    county_fips_all: '54037|54003',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Berkeley',
    county_weights: '{"54037": 89.74, "54003": 10.26}',
    density: 94.3,
    imprecise: false,
    latitude: 39.43835,
    longitude: -77.81477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25443',
  },
  {
    city: 'Slanesville',
    county_fips: 54027,
    county_fips_all: '54027',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"54027": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 39.43543,
    longitude: -78.52081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25444',
  },
  {
    city: 'Summit Point',
    county_fips: 54037,
    county_fips_all: '54037',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"54037": 100}',
    density: 35.9,
    imprecise: false,
    latitude: 39.24013,
    longitude: -77.95705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25446',
  },
  {
    city: 'Alkol',
    county_fips: 54043,
    county_fips_all: '54043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"54043": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 38.16035,
    longitude: -81.95582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25501',
  },
  {
    city: 'Apple Grove',
    county_fips: 54053,
    county_fips_all: '54053',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"54053": 100}',
    density: 6,
    imprecise: false,
    latitude: 38.66501,
    longitude: -82.11024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25502',
  },
  {
    city: 'Ashton',
    county_fips: 54053,
    county_fips_all: '54053',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"54053": 100}',
    density: 21.3,
    imprecise: false,
    latitude: 38.60835,
    longitude: -82.11666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25503',
  },
  {
    city: 'Barboursville',
    county_fips: 54011,
    county_fips_all: '54011|54099',
    county: 'Cabell',
    county_names_all: 'Cabell|Wayne',
    county_weights: '{"54011": 90.24, "54099": 9.76}',
    density: 90.5,
    imprecise: false,
    latitude: 38.37297,
    longitude: -82.26674,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25504',
  },
  {
    city: 'Big Creek',
    county_fips: 54043,
    county_fips_all: '54043|54045',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Logan',
    county_weights: '{"54043": 58.32, "54045": 41.68}',
    density: 44.9,
    imprecise: false,
    latitude: 38.01967,
    longitude: -82.03075,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25505',
  },
  {
    city: 'Branchland',
    county_fips: 54043,
    county_fips_all: '54043|54011',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Cabell',
    county_weights: '{"54043": 83.89, "54011": 16.11}',
    density: 20.1,
    imprecise: false,
    latitude: 38.20826,
    longitude: -82.18665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25506',
  },
  {
    city: 'Ceredo',
    county_fips: 54099,
    county_fips_all: '54099',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"54099": 100}',
    density: 652.1,
    imprecise: false,
    latitude: 38.39945,
    longitude: -82.55193,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25507',
  },
  {
    city: 'Chapmanville',
    county_fips: 54045,
    county_fips_all: '54045|54005',
    county: 'Logan',
    county_names_all: 'Logan|Boone',
    county_weights: '{"54045": 84.36, "54005": 15.64}',
    density: 41.8,
    imprecise: false,
    latitude: 37.96388,
    longitude: -82.01394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25508',
  },
  {
    city: 'Culloden',
    county_fips: 54011,
    county_fips_all: '54011|54043|54079',
    county: 'Cabell',
    county_names_all: 'Cabell|Lincoln|Putnam',
    county_weights: '{"54011": 49.52, "54043": 26.93, "54079": 23.55}',
    density: 59.5,
    imprecise: false,
    latitude: 38.38832,
    longitude: -82.06599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25510',
  },
  {
    city: 'Dunlow',
    county_fips: 54099,
    county_fips_all: '54099',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"54099": 100}',
    density: 4,
    imprecise: false,
    latitude: 38.03194,
    longitude: -82.35637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25511',
  },
  {
    city: 'East Lynn',
    county_fips: 54099,
    county_fips_all: '54099',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"54099": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 38.17784,
    longitude: -82.32056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25512',
  },
  {
    city: 'Fort Gay',
    county_fips: 54099,
    county_fips_all: '54099',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"54099": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 38.08136,
    longitude: -82.51678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25514',
  },
  {
    city: 'Gallipolis Ferry',
    county_fips: 54053,
    county_fips_all: '54053',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"54053": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 38.75731,
    longitude: -82.15262,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25515',
  },
  {
    city: 'Genoa',
    county_fips: 54099,
    county_fips_all: '54099',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"54099": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 38.10989,
    longitude: -82.45368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25517',
  },
  {
    city: 'Glenwood',
    county_fips: 54011,
    county_fips_all: '54011|54053',
    county: 'Cabell',
    county_names_all: 'Cabell|Mason',
    county_weights: '{"54011": 54.38, "54053": 45.62}',
    density: 11.5,
    imprecise: false,
    latitude: 38.55773,
    longitude: -82.17899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25520',
  },
  {
    city: 'Griffithsville',
    county_fips: 54043,
    county_fips_all: '54043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"54043": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 38.22915,
    longitude: -81.98641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25521',
  },
  {
    city: 'Hamlin',
    county_fips: 54043,
    county_fips_all: '54043|54079',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Putnam',
    county_weights: '{"54043": 89.03, "54079": 10.97}',
    density: 27.3,
    imprecise: false,
    latitude: 38.27934,
    longitude: -82.06754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25523',
  },
  {
    city: 'Harts',
    county_fips: 54043,
    county_fips_all: '54043|54045|54099',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Logan|Wayne',
    county_weights: '{"54043": 71.06, "54045": 23.23, "54099": 5.71}',
    density: 10.1,
    imprecise: false,
    latitude: 38.01309,
    longitude: -82.11712,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25524',
  },
  {
    city: 'Hurricane',
    county_fips: 54079,
    county_fips_all: '54079|54043|54053',
    county: 'Putnam',
    county_names_all: 'Putnam|Lincoln|Mason',
    county_weights: '{"54079": 98.63, "54043": 1.11, "54053": 0.26}',
    density: 95.3,
    imprecise: false,
    latitude: 38.3984,
    longitude: -81.98279,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25526',
  },
  {
    city: 'Julian',
    county_fips: 54005,
    county_fips_all: '54005|54043',
    county: 'Boone',
    county_names_all: 'Boone|Lincoln',
    county_weights: '{"54005": 94.78, "54043": 5.22}',
    density: 12.1,
    imprecise: false,
    latitude: 38.15573,
    longitude: -81.8245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25529',
  },
  {
    city: 'Kenova',
    county_fips: 54099,
    county_fips_all: '54099',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"54099": 100}',
    density: 177.9,
    imprecise: false,
    latitude: 38.35629,
    longitude: -82.56337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25530',
  },
  {
    city: 'Kiahsville',
    county_fips: 54099,
    county_fips_all: '54099',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"54099": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 38.08065,
    longitude: -82.27781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25534',
  },
  {
    city: 'Lavalette',
    county_fips: 54099,
    county_fips_all: '54099',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"54099": 100}',
    density: 60.8,
    imprecise: false,
    latitude: 38.30772,
    longitude: -82.43405,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25535',
  },
  {
    city: 'Lesage',
    county_fips: 54011,
    county_fips_all: '54011',
    county: 'Cabell',
    county_names_all: 'Cabell',
    county_weights: '{"54011": 100}',
    density: 30.8,
    imprecise: false,
    latitude: 38.53399,
    longitude: -82.26926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25537',
  },
  {
    city: 'Midkiff',
    county_fips: 54043,
    county_fips_all: '54043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"54043": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 38.15709,
    longitude: -82.13914,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25540',
  },
  {
    city: 'Milton',
    county_fips: 54011,
    county_fips_all: '54011|54053',
    county: 'Cabell',
    county_names_all: 'Cabell|Mason',
    county_weights: '{"54011": 80.45, "54053": 19.55}',
    density: 51.3,
    imprecise: false,
    latitude: 38.45884,
    longitude: -82.12707,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25541',
  },
  {
    city: 'Myra',
    county_fips: 54043,
    county_fips_all: '54043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"54043": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 38.23078,
    longitude: -82.11017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25544',
  },
  {
    city: 'Ona',
    county_fips: 54011,
    county_fips_all: '54011',
    county: 'Cabell',
    county_names_all: 'Cabell',
    county_weights: '{"54011": 100}',
    density: 83,
    imprecise: false,
    latitude: 38.45847,
    longitude: -82.22456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25545',
  },
  {
    city: 'Pecks Mill',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 44.6,
    imprecise: false,
    latitude: 37.92627,
    longitude: -81.9537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25547',
  },
  {
    city: 'Point Pleasant',
    county_fips: 54053,
    county_fips_all: '54053',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"54053": 100}',
    density: 70.2,
    imprecise: false,
    latitude: 38.86655,
    longitude: -82.0749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25550',
  },
  {
    city: 'Prichard',
    county_fips: 54099,
    county_fips_all: '54099',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"54099": 100}',
    density: 20.6,
    imprecise: false,
    latitude: 38.23525,
    longitude: -82.55913,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25555',
  },
  {
    city: 'Ranger',
    county_fips: 54043,
    county_fips_all: '54043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"54043": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 38.09923,
    longitude: -82.16262,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25557',
  },
  {
    city: 'Salt Rock',
    county_fips: 54011,
    county_fips_all: '54011',
    county: 'Cabell',
    county_names_all: 'Cabell',
    county_weights: '{"54011": 100}',
    density: 37.1,
    imprecise: false,
    latitude: 38.32753,
    longitude: -82.23181,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25559',
  },
  {
    city: 'Scott Depot',
    county_fips: 54079,
    county_fips_all: '54079',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"54079": 100}',
    density: 169.3,
    imprecise: false,
    latitude: 38.44736,
    longitude: -81.89908,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25560',
  },
  {
    city: 'Sod',
    county_fips: 54043,
    county_fips_all: '54043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"54043": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 38.26302,
    longitude: -81.88835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25564',
  },
  {
    city: 'Spurlockville',
    county_fips: 54043,
    county_fips_all: '54043|54005',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Boone',
    county_weights: '{"54043": 58.78, "54005": 41.22}',
    density: 7.7,
    imprecise: false,
    latitude: 38.10998,
    longitude: -81.96631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25565',
  },
  {
    city: 'Sumerco',
    county_fips: 54043,
    county_fips_all: '54043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"54043": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 38.21971,
    longitude: -81.87294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25567',
  },
  {
    city: 'Wayne',
    county_fips: 54099,
    county_fips_all: '54099',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"54099": 100}',
    density: 32.5,
    imprecise: false,
    latitude: 38.23508,
    longitude: -82.41927,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25570',
  },
  {
    city: 'West Hamlin',
    county_fips: 54043,
    county_fips_all: '54043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"54043": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 38.2947,
    longitude: -82.15632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25571',
  },
  {
    city: 'Yawkey',
    county_fips: 54043,
    county_fips_all: '54043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"54043": 100}',
    density: 20.6,
    imprecise: false,
    latitude: 38.22725,
    longitude: -81.94549,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25573',
  },
  {
    city: 'Logan',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 81.1,
    imprecise: false,
    latitude: 37.86255,
    longitude: -82.0026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25601',
  },
  {
    city: 'Accoville',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 71.6,
    imprecise: false,
    latitude: 37.76641,
    longitude: -81.82878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25606',
  },
  {
    city: 'Amherstdale',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 37.78125,
    longitude: -81.77081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25607',
  },
  {
    city: 'Baisden',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 39.5,
    imprecise: false,
    latitude: 37.57512,
    longitude: -81.89165,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25608',
  },
  {
    city: 'Bruno',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 56.3,
    imprecise: false,
    latitude: 37.6832,
    longitude: -81.87068,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25611',
  },
  {
    city: 'Chauncey',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 66.5,
    imprecise: false,
    latitude: 37.76396,
    longitude: -81.98064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25612',
  },
  {
    city: 'Davin',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 37.74549,
    longitude: -81.80275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25617',
  },
  {
    city: 'Gilbert',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 37.63149,
    longitude: -81.89643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25621',
  },
  {
    city: 'Henlawson',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 73.4,
    imprecise: false,
    latitude: 37.90393,
    longitude: -81.97162,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25624',
  },
  {
    city: 'Holden',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 31.3,
    imprecise: false,
    latitude: 37.82237,
    longitude: -82.09206,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25625',
  },
  {
    city: 'Kistler',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 78.2,
    imprecise: false,
    latitude: 37.7657,
    longitude: -81.86237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25628',
  },
  {
    city: 'Lorado',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 37.79821,
    longitude: -81.6816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25630',
  },
  {
    city: 'Lyburn',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 37.76292,
    longitude: -81.9368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25632',
  },
  {
    city: 'Mallory',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 121,
    imprecise: false,
    latitude: 37.73017,
    longitude: -81.82461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25634',
  },
  {
    city: 'Man',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 37.71937,
    longitude: -81.87261,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25635',
  },
  {
    city: 'Mount Gay',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 84.5,
    imprecise: false,
    latitude: 37.85086,
    longitude: -82.02805,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25637',
  },
  {
    city: 'Omar',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 37.74423,
    longitude: -82.05133,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25638',
  },
  {
    city: 'Peach Creek',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 34.9,
    imprecise: false,
    latitude: 37.88674,
    longitude: -81.95905,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25639',
  },
  {
    city: 'Sarah Ann',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 37.70191,
    longitude: -82.00107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25644',
  },
  {
    city: 'Stollings',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 37.83187,
    longitude: -81.89349,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25646',
  },
  {
    city: 'Switzer',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 20.6,
    imprecise: false,
    latitude: 37.786,
    longitude: -81.98738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25647',
  },
  {
    city: 'Verdunville',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 53.3,
    imprecise: false,
    latitude: 37.87166,
    longitude: -82.08489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25649',
  },
  {
    city: 'Verner',
    county_fips: 54045,
    county_fips_all: '54045|54059',
    county: 'Logan',
    county_names_all: 'Logan|Mingo',
    county_weights: '{"54045": 80.91, "54059": 19.09}',
    density: 1.6,
    imprecise: false,
    latitude: 37.68358,
    longitude: -81.78773,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 86,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25650',
  },
  {
    city: 'Wharncliffe',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 37.57142,
    longitude: -81.9662,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25651',
  },
  {
    city: 'Whitman',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 40.6,
    imprecise: false,
    latitude: 37.78702,
    longitude: -82.04865,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25652',
  },
  {
    city: 'Wilkinson',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 37.8287,
    longitude: -81.9944,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25653',
  },
  {
    city: 'Yolyn',
    county_fips: 54045,
    county_fips_all: '54045',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"54045": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 37.80302,
    longitude: -81.87401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25654',
  },
  {
    city: 'Williamson',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 39.7,
    imprecise: false,
    latitude: 37.71062,
    longitude: -82.25377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25661',
  },
  {
    city: 'Breeden',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 37.9203,
    longitude: -82.29432,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25666',
  },
  {
    city: 'Chattaroy',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 89.5,
    imprecise: false,
    latitude: 37.70619,
    longitude: -82.2738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25667',
  },
  {
    city: 'Crum',
    county_fips: 54099,
    county_fips_all: '54099',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"54099": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 37.93186,
    longitude: -82.4519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25669',
  },
  {
    city: 'Delbarton',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 37.7385,
    longitude: -82.15588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25670',
  },
  {
    city: 'Dingess',
    county_fips: 54059,
    county_fips_all: '54059|54043',
    county: 'Mingo',
    county_names_all: 'Mingo|Lincoln',
    county_weights: '{"54059": 99.9, "54043": 0.1}',
    density: 15.5,
    imprecise: false,
    latitude: 37.90411,
    longitude: -82.20283,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25671',
  },
  {
    city: 'Edgarton',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 37.57017,
    longitude: -82.10044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25672',
  },
  {
    city: 'Kermit',
    county_fips: 54059,
    county_fips_all: '54059|54099',
    county: 'Mingo',
    county_names_all: 'Mingo|Wayne',
    county_weights: '{"54059": 73.74, "54099": 26.26}',
    density: 15,
    imprecise: false,
    latitude: 37.87114,
    longitude: -82.34672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25674',
  },
  {
    city: 'Lenore',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 37.82509,
    longitude: -82.22972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25676',
  },
  {
    city: 'Matewan',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 37.59564,
    longitude: -82.08187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25678',
  },
  {
    city: 'Naugatuck',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 37.79592,
    longitude: -82.31426,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25685',
  },
  {
    city: 'North Matewan',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 40,
    imprecise: false,
    latitude: 37.63952,
    longitude: -82.15832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25688',
  },
  {
    city: 'Ragland',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 57.3,
    imprecise: false,
    latitude: 37.69124,
    longitude: -82.15505,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25690',
  },
  {
    city: 'Red Jacket',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 26.1,
    imprecise: false,
    latitude: 37.61804,
    longitude: -82.07375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25692',
  },
  {
    city: 'Varney',
    county_fips: 54059,
    county_fips_all: '54059',
    county: 'Mingo',
    county_names_all: 'Mingo',
    county_weights: '{"54059": 100}',
    density: 23.9,
    imprecise: false,
    latitude: 37.66116,
    longitude: -82.07154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25696',
  },
  {
    city: 'Wilsondale',
    county_fips: 54099,
    county_fips_all: '54099|54043',
    county: 'Wayne',
    county_names_all: 'Wayne|Lincoln',
    county_weights: '{"54099": 75.3, "54043": 24.7}',
    density: 0.6,
    imprecise: false,
    latitude: 37.96297,
    longitude: -82.31493,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25699',
  },
  {
    city: 'Huntington',
    county_fips: 54011,
    county_fips_all: '54011|54099',
    county: 'Cabell',
    county_names_all: 'Cabell|Wayne',
    county_weights: '{"54011": 74.48, "54099": 25.52}',
    density: 210.3,
    imprecise: false,
    latitude: 38.36809,
    longitude: -82.41127,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25701',
  },
  {
    city: 'Huntington',
    county_fips: 54011,
    county_fips_all: '54011',
    county: 'Cabell',
    county_names_all: 'Cabell',
    county_weights: '{"54011": 100}',
    density: 253.5,
    imprecise: false,
    latitude: 38.43825,
    longitude: -82.33344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25702',
  },
  {
    city: 'Huntington',
    county_fips: 54011,
    county_fips_all: '54011',
    county: 'Cabell',
    county_names_all: 'Cabell',
    county_weights: '{"54011": 100}',
    density: 1738.9,
    imprecise: false,
    latitude: 38.42201,
    longitude: -82.41827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25703',
  },
  {
    city: 'Huntington',
    county_fips: 54099,
    county_fips_all: '54099|54011',
    county: 'Wayne',
    county_names_all: 'Wayne|Cabell',
    county_weights: '{"54099": 92.69, "54011": 7.31}',
    density: 179.4,
    imprecise: false,
    latitude: 38.34969,
    longitude: -82.50693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25704',
  },
  {
    city: 'Huntington',
    county_fips: 54011,
    county_fips_all: '54011',
    county: 'Cabell',
    county_names_all: 'Cabell',
    county_weights: '{"54011": 100}',
    density: 697.6,
    imprecise: false,
    latitude: 38.40636,
    longitude: -82.36276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25705',
  },
  {
    city: 'Beckley',
    county_fips: 54081,
    county_fips_all: '54081|54019',
    county: 'Raleigh',
    county_names_all: 'Raleigh|Fayette',
    county_weights: '{"54081": 99.87, "54019": 0.13}',
    density: 121.2,
    imprecise: false,
    latitude: 37.83805,
    longitude: -81.27017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25801',
  },
  {
    city: 'Allen Junction',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 105.4,
    imprecise: false,
    latitude: 37.58355,
    longitude: -81.34953,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25810',
  },
  {
    city: 'Amigo',
    county_fips: 54081,
    county_fips_all: '54081|54109',
    county: 'Raleigh',
    county_names_all: 'Raleigh|Wyoming',
    county_weights: '{"54081": 99.81, "54109": 0.19}',
    density: 0.7,
    imprecise: false,
    latitude: 37.60835,
    longitude: -81.3065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25811',
  },
  {
    city: 'Ansted',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 57.6,
    imprecise: false,
    latitude: 38.14048,
    longitude: -81.11512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25812',
  },
  {
    city: 'Beaver',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 58.5,
    imprecise: false,
    latitude: 37.78309,
    longitude: -81.10001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25813',
  },
  {
    city: 'Bolt',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 37.76393,
    longitude: -81.42191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25817',
  },
  {
    city: 'Bradley',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 122.8,
    imprecise: false,
    latitude: 37.8608,
    longitude: -81.19252,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25818',
  },
  {
    city: 'Camp Creek',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 37.50812,
    longitude: -81.13549,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25820',
  },
  {
    city: 'Coal City',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 37.66626,
    longitude: -81.18231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25823',
  },
  {
    city: 'Cool Ridge',
    county_fips: 54081,
    county_fips_all: '54081|54089',
    county: 'Raleigh',
    county_names_all: 'Raleigh|Summers',
    county_weights: '{"54081": 85.72, "54089": 14.28}',
    density: 46.3,
    imprecise: false,
    latitude: 37.64736,
    longitude: -81.08862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25825',
  },
  {
    city: 'Corinne',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 297,
    imprecise: false,
    latitude: 37.57291,
    longitude: -81.36565,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25826',
  },
  {
    city: 'Crab Orchard',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 96.3,
    imprecise: false,
    latitude: 37.73869,
    longitude: -81.25368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25827',
  },
  {
    city: 'Danese',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 37.95645,
    longitude: -80.94037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25831',
  },
  {
    city: 'Daniels',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 148.4,
    imprecise: false,
    latitude: 37.72637,
    longitude: -81.10494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25832',
  },
  {
    city: 'Eccles',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 64.3,
    imprecise: false,
    latitude: 37.78693,
    longitude: -81.27804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25836',
  },
  {
    city: 'Edmond',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 19.6,
    imprecise: false,
    latitude: 38.06041,
    longitude: -81.0383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25837',
  },
  {
    city: 'Fairdale',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 29.7,
    imprecise: false,
    latitude: 37.78091,
    longitude: -81.38228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25839',
  },
  {
    city: 'Fayetteville',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 46.7,
    imprecise: false,
    latitude: 38.04001,
    longitude: -81.11442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25840',
  },
  {
    city: 'Flat Top',
    county_fips: 54055,
    county_fips_all: '54055|54089',
    county: 'Mercer',
    county_names_all: 'Mercer|Summers',
    county_weights: '{"54055": 89.02, "54089": 10.98}',
    density: 6.5,
    imprecise: false,
    latitude: 37.55325,
    longitude: -81.09061,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25841',
  },
  {
    city: 'Ghent',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 37.62129,
    longitude: -81.14129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25843',
  },
  {
    city: 'Glen Daniel',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 37.81056,
    longitude: -81.37022,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25844',
  },
  {
    city: 'Glen Fork',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 37.70291,
    longitude: -81.51107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25845',
  },
  {
    city: 'Glen Jean',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 37.92476,
    longitude: -81.16628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25846',
  },
  {
    city: 'Glen Rogers',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 37.71427,
    longitude: -81.43117,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25848',
  },
  {
    city: 'Glen White',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 107.9,
    imprecise: false,
    latitude: 37.73175,
    longitude: -81.27799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25849',
  },
  {
    city: 'Harper',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.80177,
    longitude: -81.26154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25851',
  },
  {
    city: 'Helen',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 37.64616,
    longitude: -81.27827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25853',
  },
  {
    city: 'Hico',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 38.12629,
    longitude: -80.97537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25854',
  },
  {
    city: 'Hilltop',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 279.4,
    imprecise: false,
    latitude: 37.94052,
    longitude: -81.15296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25855',
  },
  {
    city: 'Josephine',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.61443,
    longitude: -81.23288,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25857',
  },
  {
    city: 'Lansing',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 38.08448,
    longitude: -81.05192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25862',
  },
  {
    city: 'Layland',
    county_fips: 54019,
    county_fips_all: '54019|54081',
    county: 'Fayette',
    county_names_all: 'Fayette|Raleigh',
    county_weights: '{"54019": 86.78, "54081": 13.22}',
    density: 5.5,
    imprecise: false,
    latitude: 37.87948,
    longitude: -81.01781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25864',
  },
  {
    city: 'Lester',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 37.73076,
    longitude: -81.35212,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25865',
  },
  {
    city: 'Lochgelly',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 52.5,
    imprecise: false,
    latitude: 38.00883,
    longitude: -81.15738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25866',
  },
  {
    city: 'Lookout',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 38.07172,
    longitude: -80.96461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25868',
  },
  {
    city: 'Maben',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 37.63931,
    longitude: -81.3813,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25870',
  },
  {
    city: 'Mabscott',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 444.8,
    imprecise: false,
    latitude: 37.76917,
    longitude: -81.21165,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25871',
  },
  {
    city: 'MacArthur',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 521.8,
    imprecise: false,
    latitude: 37.75136,
    longitude: -81.21515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25873',
  },
  {
    city: 'McGraws',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 25.1,
    imprecise: false,
    latitude: 37.66907,
    longitude: -81.45956,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25875',
  },
  {
    city: 'Saulsville',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 37.63677,
    longitude: -81.44731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 90,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25876',
  },
  {
    city: 'Midway',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 91.1,
    imprecise: false,
    latitude: 37.71303,
    longitude: -81.22464,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25878',
  },
  {
    city: 'Minden',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 63.2,
    imprecise: false,
    latitude: 37.98048,
    longitude: -81.10453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25879',
  },
  {
    city: 'Mount Hope',
    county_fips: 54081,
    county_fips_all: '54081|54019',
    county: 'Raleigh',
    county_names_all: 'Raleigh|Fayette',
    county_weights: '{"54081": 68.27, "54019": 31.73}',
    density: 81.4,
    imprecise: false,
    latitude: 37.87672,
    longitude: -81.20095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25880',
  },
  {
    city: 'Mullens',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 93.1,
    imprecise: false,
    latitude: 37.60359,
    longitude: -81.39892,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25882',
  },
  {
    city: 'Oak Hill',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 100.7,
    imprecise: false,
    latitude: 37.93575,
    longitude: -81.11242,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25901',
  },
  {
    city: 'Odd',
    county_fips: 54081,
    county_fips_all: '54081|54055',
    county: 'Raleigh',
    county_names_all: 'Raleigh|Mercer',
    county_weights: '{"54081": 75.01, "54055": 24.99}',
    density: 3.9,
    imprecise: false,
    latitude: 37.56301,
    longitude: -81.21115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25902',
  },
  {
    city: 'Pax',
    county_fips: 54019,
    county_fips_all: '54019|54081',
    county: 'Fayette',
    county_names_all: 'Fayette|Raleigh',
    county_weights: '{"54019": 99.85, "54081": 0.15}',
    density: 11.5,
    imprecise: false,
    latitude: 37.9128,
    longitude: -81.25213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25904',
  },
  {
    city: 'Prince',
    county_fips: 54019,
    county_fips_all: '54019|54081',
    county: 'Fayette',
    county_names_all: 'Fayette|Raleigh',
    county_weights: '{"54019": 99.8, "54081": 0.2}',
    density: 58.9,
    imprecise: false,
    latitude: 37.8593,
    longitude: -81.07196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25907',
  },
  {
    city: 'Princewick',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 28.3,
    imprecise: false,
    latitude: 37.66782,
    longitude: -81.24434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25908',
  },
  {
    city: 'Prosperity',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 695,
    imprecise: false,
    latitude: 37.83687,
    longitude: -81.20192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25909',
  },
  {
    city: 'Raleigh',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 82.9,
    imprecise: false,
    latitude: 37.75232,
    longitude: -81.17848,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25911',
  },
  {
    city: 'Rhodell',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 25.2,
    imprecise: false,
    latitude: 37.61575,
    longitude: -81.28691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25915',
  },
  {
    city: 'Sabine',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 54,
    imprecise: false,
    latitude: 37.67818,
    longitude: -81.49019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25916',
  },
  {
    city: 'Scarbro',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 11,
    imprecise: false,
    latitude: 37.97944,
    longitude: -81.25021,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25917',
  },
  {
    city: 'Shady Spring',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 29.7,
    imprecise: false,
    latitude: 37.74575,
    longitude: -81.00993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25918',
  },
  {
    city: 'Slab Fork',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 22.5,
    imprecise: false,
    latitude: 37.68646,
    longitude: -81.33661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25920',
  },
  {
    city: 'Sophia',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 59.8,
    imprecise: false,
    latitude: 37.69181,
    longitude: -81.25882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25921',
  },
  {
    city: 'Spanishburg',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 37.47147,
    longitude: -81.09966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25922',
  },
  {
    city: 'Stephenson',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 37.55481,
    longitude: -81.34126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25928',
  },
  {
    city: 'Surveyor',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 37.75623,
    longitude: -81.30282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25932',
  },
  {
    city: 'Thurmond',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 37.92917,
    longitude: -81.03105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25936',
  },
  {
    city: 'Victor',
    county_fips: 54019,
    county_fips_all: '54019|54067',
    county: 'Fayette',
    county_names_all: 'Fayette|Nicholas',
    county_weights: '{"54019": 99.88, "54067": 0.12}',
    density: 15.5,
    imprecise: false,
    latitude: 38.15993,
    longitude: -81.03447,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25938',
  },
  {
    city: 'Winona',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 38.02691,
    longitude: -80.98836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25942',
  },
  {
    city: 'Wyco',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.59657,
    longitude: -81.34914,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25943',
  },
  {
    city: 'Hinton',
    county_fips: 54089,
    county_fips_all: '54089|54081',
    county: 'Summers',
    county_names_all: 'Summers|Raleigh',
    county_weights: '{"54089": 88.72, "54081": 11.28}',
    density: 16.7,
    imprecise: false,
    latitude: 37.65535,
    longitude: -80.87197,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25951',
  },
  {
    city: 'Charmco',
    county_fips: 54025,
    county_fips_all: '54025',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier',
    county_weights: '{"54025": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 38.02156,
    longitude: -80.76077,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25958',
  },
  {
    city: 'Rainelle',
    county_fips: 54019,
    county_fips_all: '54019|54025',
    county: 'Fayette',
    county_names_all: 'Fayette|Greenbrier',
    county_weights: '{"54019": 62.12, "54025": 37.88}',
    density: 16.8,
    imprecise: false,
    latitude: 37.97044,
    longitude: -80.8098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25962',
  },
  {
    city: 'Green Sulphur Springs',
    county_fips: 54089,
    county_fips_all: '54089',
    county: 'Summers',
    county_names_all: 'Summers',
    county_weights: '{"54089": 100}',
    density: 2,
    imprecise: false,
    latitude: 37.7975,
    longitude: -80.76729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 95,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25966',
  },
  {
    city: 'Jumping Branch',
    county_fips: 54089,
    county_fips_all: '54089|54081',
    county: 'Summers',
    county_names_all: 'Summers|Raleigh',
    county_weights: '{"54089": 99.69, "54081": 0.31}',
    density: 18.8,
    imprecise: false,
    latitude: 37.61657,
    longitude: -81.00903,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25969',
  },
  {
    city: 'Lerona',
    county_fips: 54055,
    county_fips_all: '54055',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"54055": 100}',
    density: 30.3,
    imprecise: false,
    latitude: 37.48001,
    longitude: -80.97821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25971',
  },
  {
    city: 'Leslie',
    county_fips: 54025,
    county_fips_all: '54025',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier',
    county_weights: '{"54025": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 38.03576,
    longitude: -80.7222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25972',
  },
  {
    city: 'Meadow Bridge',
    county_fips: 54019,
    county_fips_all: '54019|54089|54025',
    county: 'Fayette',
    county_names_all: 'Fayette|Summers|Greenbrier',
    county_weights: '{"54019": 43.2, "54089": 40.19, "54025": 16.62}',
    density: 12.9,
    imprecise: false,
    latitude: 37.84372,
    longitude: -80.86221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25976',
  },
  {
    city: 'Meadow Creek',
    county_fips: 54089,
    county_fips_all: '54089',
    county: 'Summers',
    county_names_all: 'Summers',
    county_weights: '{"54089": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 37.80819,
    longitude: -80.90571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25977',
  },
  {
    city: 'Nimitz',
    county_fips: 54089,
    county_fips_all: '54089',
    county: 'Summers',
    county_names_all: 'Summers',
    county_weights: '{"54089": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 37.62861,
    longitude: -80.94138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25978',
  },
  {
    city: 'Pipestem',
    county_fips: 54089,
    county_fips_all: '54089|54055',
    county: 'Summers',
    county_names_all: 'Summers|Mercer',
    county_weights: '{"54089": 93.08, "54055": 6.92}',
    density: 4.6,
    imprecise: false,
    latitude: 37.5126,
    longitude: -80.91736,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25979',
  },
  {
    city: 'Quinwood',
    county_fips: 54025,
    county_fips_all: '54025|54067',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier|Nicholas',
    county_weights: '{"54025": 72.16, "54067": 27.84}',
    density: 5.6,
    imprecise: false,
    latitude: 38.08321,
    longitude: -80.70274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25981',
  },
  {
    city: 'Rupert',
    county_fips: 54025,
    county_fips_all: '54025',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier',
    county_weights: '{"54025": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 38.01409,
    longitude: -80.6026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25984',
  },
  {
    city: 'Sandstone',
    county_fips: 54089,
    county_fips_all: '54089',
    county: 'Summers',
    county_names_all: 'Summers',
    county_weights: '{"54089": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 37.75752,
    longitude: -80.83044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25985',
  },
  {
    city: 'Spring Dale',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 37.89395,
    longitude: -80.81741,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25986',
  },
  {
    city: 'White Oak',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 42,
    imprecise: false,
    latitude: 37.67864,
    longitude: -81.04594,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25989',
  },
  {
    city: 'Wheeling',
    county_fips: 54069,
    county_fips_all: '54069|54051|54009',
    county: 'Ohio',
    county_names_all: 'Ohio|Marshall|Brooke',
    county_weights: '{"54069": 62.5, "54051": 33.48, "54009": 4.02}',
    density: 169.5,
    imprecise: false,
    latitude: 40.0693,
    longitude: -80.6508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26003',
  },
  {
    city: 'Beech Bottom',
    county_fips: 54009,
    county_fips_all: '54009',
    county: 'Brooke',
    county_names_all: 'Brooke',
    county_weights: '{"54009": 100}',
    density: 145.4,
    imprecise: false,
    latitude: 40.21662,
    longitude: -80.65965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26030',
  },
  {
    city: 'Benwood',
    county_fips: 54051,
    county_fips_all: '54051',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"54051": 100}',
    density: 136.2,
    imprecise: false,
    latitude: 40.00236,
    longitude: -80.71985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26031',
  },
  {
    city: 'Bethany',
    county_fips: 54009,
    county_fips_all: '54009|54069',
    county: 'Brooke',
    county_names_all: 'Brooke|Ohio',
    county_weights: '{"54009": 89.58, "54069": 10.42}',
    density: 35.6,
    imprecise: false,
    latitude: 40.18646,
    longitude: -80.55024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26032',
  },
  {
    city: 'Cameron',
    county_fips: 54051,
    county_fips_all: '54051',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"54051": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 39.8284,
    longitude: -80.57985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26033',
  },
  {
    city: 'Chester',
    county_fips: 54029,
    county_fips_all: '54029',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"54029": 100}',
    density: 119.2,
    imprecise: false,
    latitude: 40.59404,
    longitude: -80.55258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26034',
  },
  {
    city: 'Colliers',
    county_fips: 54009,
    county_fips_all: '54009',
    county: 'Brooke',
    county_names_all: 'Brooke',
    county_weights: '{"54009": 100}',
    density: 55,
    imprecise: false,
    latitude: 40.3482,
    longitude: -80.55522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26035',
  },
  {
    city: 'Dallas',
    county_fips: 54051,
    county_fips_all: '54051',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"54051": 100}',
    density: 23.8,
    imprecise: false,
    latitude: 39.98406,
    longitude: -80.54339,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26036',
  },
  {
    city: 'Follansbee',
    county_fips: 54009,
    county_fips_all: '54009',
    county: 'Brooke',
    county_names_all: 'Brooke',
    county_weights: '{"54009": 100}',
    density: 324.1,
    imprecise: false,
    latitude: 40.3344,
    longitude: -80.58494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26037',
  },
  {
    city: 'Glen Dale',
    county_fips: 54051,
    county_fips_all: '54051',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"54051": 100}',
    density: 174.1,
    imprecise: false,
    latitude: 39.96329,
    longitude: -80.72595,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26038',
  },
  {
    city: 'Glen Easton',
    county_fips: 54051,
    county_fips_all: '54051',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"54051": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 39.81641,
    longitude: -80.66969,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26039',
  },
  {
    city: 'Mcmechen',
    county_fips: 54051,
    county_fips_all: '54051',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"54051": 100}',
    density: 974.7,
    imprecise: false,
    latitude: 39.98389,
    longitude: -80.73104,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26040',
  },
  {
    city: 'Moundsville',
    county_fips: 54051,
    county_fips_all: '54051',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"54051": 100}',
    density: 93.5,
    imprecise: false,
    latitude: 39.89764,
    longitude: -80.7107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26041',
  },
  {
    city: 'New Cumberland',
    county_fips: 54029,
    county_fips_all: '54029',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"54029": 100}',
    density: 49.7,
    imprecise: false,
    latitude: 40.53223,
    longitude: -80.5837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26047',
  },
  {
    city: 'Newell',
    county_fips: 54029,
    county_fips_all: '54029',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"54029": 100}',
    density: 220.4,
    imprecise: false,
    latitude: 40.60108,
    longitude: -80.62646,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26050',
  },
  {
    city: 'Proctor',
    county_fips: 54051,
    county_fips_all: '54051|54103',
    county: 'Marshall',
    county_names_all: 'Marshall|Wetzel',
    county_weights: '{"54051": 72.37, "54103": 27.63}',
    density: 6,
    imprecise: false,
    latitude: 39.75338,
    longitude: -80.77396,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26055',
  },
  {
    city: 'New Manchester',
    county_fips: 54029,
    county_fips_all: '54029',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"54029": 100}',
    density: 40,
    imprecise: false,
    latitude: 40.5211,
    longitude: -80.57022,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26056',
  },
  {
    city: 'Short Creek',
    county_fips: 54009,
    county_fips_all: '54009|54069',
    county: 'Brooke',
    county_names_all: 'Brooke|Ohio',
    county_weights: '{"54009": 97.19, "54069": 2.81}',
    density: 42,
    imprecise: false,
    latitude: 40.18622,
    longitude: -80.66453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26058',
  },
  {
    city: 'Triadelphia',
    county_fips: 54069,
    county_fips_all: '54069',
    county: 'Ohio',
    county_names_all: 'Ohio',
    county_weights: '{"54069": 100}',
    density: 47.8,
    imprecise: false,
    latitude: 40.07156,
    longitude: -80.59379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26059',
  },
  {
    city: 'Valley Grove',
    county_fips: 54069,
    county_fips_all: '54069',
    county: 'Ohio',
    county_names_all: 'Ohio',
    county_weights: '{"54069": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 40.10465,
    longitude: -80.54649,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26060',
  },
  {
    city: 'Weirton',
    county_fips: 54029,
    county_fips_all: '54029|54009',
    county: 'Hancock',
    county_names_all: 'Hancock|Brooke',
    county_weights: '{"54029": 76.26, "54009": 23.74}',
    density: 286.6,
    imprecise: false,
    latitude: 40.42189,
    longitude: -80.56123,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26062',
  },
  {
    city: 'Wellsburg',
    county_fips: 54009,
    county_fips_all: '54009',
    county: 'Brooke',
    county_names_all: 'Brooke',
    county_weights: '{"54009": 100}',
    density: 74.8,
    imprecise: false,
    latitude: 40.25008,
    longitude: -80.58037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26070',
  },
  {
    city: 'West Liberty',
    county_fips: 54069,
    county_fips_all: '54069',
    county: 'Ohio',
    county_names_all: 'Ohio',
    county_weights: '{"54069": 100}',
    density: 550.8,
    imprecise: false,
    latitude: 40.16889,
    longitude: -80.59813,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26074',
  },
  {
    city: 'Windsor Heights',
    county_fips: 54009,
    county_fips_all: '54009',
    county: 'Brooke',
    county_names_all: 'Brooke',
    county_weights: '{"54009": 100}',
    density: 65.2,
    imprecise: false,
    latitude: 40.19748,
    longitude: -80.64567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26075',
  },
  {
    city: 'Parkersburg',
    county_fips: 54107,
    county_fips_all: '54107',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"54107": 100}',
    density: 351.1,
    imprecise: false,
    latitude: 39.23394,
    longitude: -81.57483,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26101',
  },
  {
    city: 'Parkersburg',
    county_fips: 54107,
    county_fips_all: '54107',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"54107": 100}',
    density: 175.1,
    imprecise: false,
    latitude: 39.27413,
    longitude: -81.47779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26104',
  },
  {
    city: 'Vienna',
    county_fips: 54107,
    county_fips_all: '54107',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"54107": 100}',
    density: 392.4,
    imprecise: false,
    latitude: 39.32949,
    longitude: -81.52267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26105',
  },
  {
    city: 'Belleville',
    county_fips: 54107,
    county_fips_all: '54107',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"54107": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 39.11973,
    longitude: -81.66968,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26133',
  },
  {
    city: 'Belmont',
    county_fips: 54073,
    county_fips_all: '54073',
    county: 'Pleasants',
    county_names_all: 'Pleasants',
    county_weights: '{"54073": 100}',
    density: 437.4,
    imprecise: false,
    latitude: 39.37686,
    longitude: -81.27544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26134',
  },
  {
    city: 'Big Bend',
    county_fips: 54013,
    county_fips_all: '54013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"54013": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 38.96553,
    longitude: -81.11478,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26136',
  },
  {
    city: 'Big Springs',
    county_fips: 54021,
    county_fips_all: '54021|54013|54085',
    county: 'Gilmer',
    county_names_all: 'Gilmer|Calhoun|Ritchie',
    county_weights: '{"54021": 44.14, "54013": 34.4, "54085": 21.46}',
    density: 6.2,
    imprecise: false,
    latitude: 39.00647,
    longitude: -81.0385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26137',
  },
  {
    city: 'Brohard',
    county_fips: 54013,
    county_fips_all: '54013|54105',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Wirt',
    county_weights: '{"54013": 55.98, "54105": 44.02}',
    density: 2,
    imprecise: false,
    latitude: 39.02114,
    longitude: -81.18155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26138',
  },
  {
    city: 'Creston',
    county_fips: 54013,
    county_fips_all: '54013|54105',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Wirt',
    county_weights: '{"54013": 52.18, "54105": 47.82}',
    density: 3.6,
    imprecise: false,
    latitude: 38.92925,
    longitude: -81.26059,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26141',
  },
  {
    city: 'Davisville',
    county_fips: 54107,
    county_fips_all: '54107',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"54107": 100}',
    density: 82.5,
    imprecise: false,
    latitude: 39.21488,
    longitude: -81.45431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26142',
  },
  {
    city: 'Elizabeth',
    county_fips: 54105,
    county_fips_all: '54105|54107|54085|54035',
    county: 'Wirt',
    county_names_all: 'Wirt|Wood|Ritchie|Jackson',
    county_weights:
      '{"54105": 85.28, "54107": 7.0, "54085": 5.06, "54035": 2.66}',
    density: 9.7,
    imprecise: false,
    latitude: 39.06338,
    longitude: -81.3764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26143',
  },
  {
    city: 'Friendly',
    county_fips: 54095,
    county_fips_all: '54095|54073',
    county: 'Tyler',
    county_names_all: 'Tyler|Pleasants',
    county_weights: '{"54095": 62.72, "54073": 37.28}',
    density: 10.2,
    imprecise: false,
    latitude: 39.45053,
    longitude: -81.03601,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26146',
  },
  {
    city: 'Grantsville',
    county_fips: 54013,
    county_fips_all: '54013|54021',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Gilmer',
    county_weights: '{"54013": 92.32, "54021": 7.68}',
    density: 17.5,
    imprecise: false,
    latitude: 38.91368,
    longitude: -81.07629,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26147',
  },
  {
    city: 'Macfarlan',
    county_fips: 54085,
    county_fips_all: '54085',
    county: 'Ritchie',
    county_names_all: 'Ritchie',
    county_weights: '{"54085": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 39.07122,
    longitude: -81.18088,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26148',
  },
  {
    city: 'Middlebourne',
    county_fips: 54095,
    county_fips_all: '54095',
    county: 'Tyler',
    county_names_all: 'Tyler',
    county_weights: '{"54095": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 39.47429,
    longitude: -80.88269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26149',
  },
  {
    city: 'Mineral Wells',
    county_fips: 54107,
    county_fips_all: '54107',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"54107": 100}',
    density: 51.5,
    imprecise: false,
    latitude: 39.1566,
    longitude: -81.53697,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26150',
  },
  {
    city: 'Mount Zion',
    county_fips: 54013,
    county_fips_all: '54013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"54013": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 38.89493,
    longitude: -81.17503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26151',
  },
  {
    city: 'Munday',
    county_fips: 54013,
    county_fips_all: '54013|54105',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Wirt',
    county_weights: '{"54013": 71.12, "54105": 28.88}',
    density: 0,
    imprecise: false,
    latitude: 38.98355,
    longitude: -81.19308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26152',
  },
  {
    city: 'New Martinsville',
    county_fips: 54103,
    county_fips_all: '54103|54095|54051',
    county: 'Wetzel',
    county_names_all: 'Wetzel|Tyler|Marshall',
    county_weights: '{"54103": 85.51, "54095": 12.53, "54051": 1.96}',
    density: 27.1,
    imprecise: false,
    latitude: 39.6333,
    longitude: -80.76707,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26155',
  },
  {
    city: 'Paden City',
    county_fips: 54103,
    county_fips_all: '54103|54095',
    county: 'Wetzel',
    county_names_all: 'Wetzel|Tyler',
    county_weights: '{"54103": 75.99, "54095": 24.01}',
    density: 930.2,
    imprecise: false,
    latitude: 39.60724,
    longitude: -80.93216,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26159',
  },
  {
    city: 'Palestine',
    county_fips: 54105,
    county_fips_all: '54105',
    county: 'Wirt',
    county_names_all: 'Wirt',
    county_weights: '{"54105": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 38.98066,
    longitude: -81.41368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26160',
  },
  {
    city: 'Petroleum',
    county_fips: 54085,
    county_fips_all: '54085',
    county: 'Ritchie',
    county_names_all: 'Ritchie',
    county_weights: '{"54085": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 39.16789,
    longitude: -81.2526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26161',
  },
  {
    city: 'Porters Falls',
    county_fips: 54103,
    county_fips_all: '54103',
    county: 'Wetzel',
    county_names_all: 'Wetzel',
    county_weights: '{"54103": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.57231,
    longitude: -80.76572,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26162',
  },
  {
    city: 'Ravenswood',
    county_fips: 54035,
    county_fips_all: '54035|54107',
    county: 'Jackson',
    county_names_all: 'Jackson|Wood',
    county_weights: '{"54035": 97.3, "54107": 2.7}',
    density: 28.1,
    imprecise: false,
    latitude: 38.99061,
    longitude: -81.71949,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26164',
  },
  {
    city: 'Reader',
    county_fips: 54103,
    county_fips_all: '54103',
    county: 'Wetzel',
    county_names_all: 'Wetzel',
    county_weights: '{"54103": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 39.53454,
    longitude: -80.71429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26167',
  },
  {
    city: 'Rockport',
    county_fips: 54107,
    county_fips_all: '54107',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"54107": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 39.07291,
    longitude: -81.57121,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26169',
  },
  {
    city: 'Saint Marys',
    county_fips: 54073,
    county_fips_all: '54073|54085',
    county: 'Pleasants',
    county_names_all: 'Pleasants|Ritchie',
    county_weights: '{"54073": 96.45, "54085": 3.55}',
    density: 20.3,
    imprecise: false,
    latitude: 39.36136,
    longitude: -81.17136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26170',
  },
  {
    city: 'Sistersville',
    county_fips: 54095,
    county_fips_all: '54095',
    county: 'Tyler',
    county_names_all: 'Tyler',
    county_weights: '{"54095": 100}',
    density: 28,
    imprecise: false,
    latitude: 39.53899,
    longitude: -80.96577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26175',
  },
  {
    city: 'Smithville',
    county_fips: 54085,
    county_fips_all: '54085',
    county: 'Ritchie',
    county_names_all: 'Ritchie',
    county_weights: '{"54085": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 39.06001,
    longitude: -81.02888,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26178',
  },
  {
    city: 'Walker',
    county_fips: 54107,
    county_fips_all: '54107|54105',
    county: 'Wood',
    county_names_all: 'Wood|Wirt',
    county_weights: '{"54107": 87.81, "54105": 12.19}',
    density: 12.1,
    imprecise: false,
    latitude: 39.20016,
    longitude: -81.36699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26180',
  },
  {
    city: 'Washington',
    county_fips: 54107,
    county_fips_all: '54107',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"54107": 100}',
    density: 61.2,
    imprecise: false,
    latitude: 39.20707,
    longitude: -81.6733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26181',
  },
  {
    city: 'Waverly',
    county_fips: 54107,
    county_fips_all: '54107|54073',
    county: 'Wood',
    county_names_all: 'Wood|Pleasants',
    county_weights: '{"54107": 86.99, "54073": 13.01}',
    density: 23.1,
    imprecise: false,
    latitude: 39.29739,
    longitude: -81.35086,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26184',
  },
  {
    city: 'Williamstown',
    county_fips: 54107,
    county_fips_all: '54107',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"54107": 100}',
    density: 108.7,
    imprecise: false,
    latitude: 39.36711,
    longitude: -81.44894,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26187',
  },
  {
    city: 'Buckhannon',
    county_fips: 54097,
    county_fips_all: '54097|54001|54041',
    county: 'Upshur',
    county_names_all: 'Upshur|Barbour|Lewis',
    county_weights: '{"54097": 88.01, "54001": 8.3, "54041": 3.69}',
    density: 41,
    imprecise: false,
    latitude: 39.00082,
    longitude: -80.20249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26201',
  },
  {
    city: 'Fenwick',
    county_fips: 54067,
    county_fips_all: '54067',
    county: 'Nicholas',
    county_names_all: 'Nicholas',
    county_weights: '{"54067": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 38.22657,
    longitude: -80.62639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26202',
  },
  {
    city: 'Erbacon',
    county_fips: 54101,
    county_fips_all: '54101|54067|54007',
    county: 'Webster',
    county_names_all: 'Webster|Nicholas|Braxton',
    county_weights: '{"54101": 84.9, "54067": 7.8, "54007": 7.3}',
    density: 3.1,
    imprecise: false,
    latitude: 38.53136,
    longitude: -80.60149,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26203',
  },
  {
    city: 'Craigsville',
    county_fips: 54067,
    county_fips_all: '54067',
    county: 'Nicholas',
    county_names_all: 'Nicholas',
    county_weights: '{"54067": 100}',
    density: 50.4,
    imprecise: false,
    latitude: 38.32078,
    longitude: -80.64828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26205',
  },
  {
    city: 'Cowen',
    county_fips: 54101,
    county_fips_all: '54101',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"54101": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 38.36992,
    longitude: -80.47848,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26206',
  },
  {
    city: 'Camden On Gauley',
    county_fips: 54101,
    county_fips_all: '54101|54067',
    county: 'Webster',
    county_names_all: 'Webster|Nicholas',
    county_weights: '{"54101": 64.88, "54067": 35.12}',
    density: 8.7,
    imprecise: false,
    latitude: 38.34781,
    longitude: -80.57314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26208',
  },
  {
    city: 'Snowshoe',
    county_fips: 54075,
    county_fips_all: '54075',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"54075": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 38.39401,
    longitude: -80.04434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26209',
  },
  {
    city: 'Adrian',
    county_fips: 54097,
    county_fips_all: '54097',
    county: 'Upshur',
    county_names_all: 'Upshur',
    county_weights: '{"54097": 100}',
    density: 168.9,
    imprecise: false,
    latitude: 38.90315,
    longitude: -80.27812,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26210',
  },
  {
    city: 'Cleveland',
    county_fips: 54101,
    county_fips_all: '54101|54041',
    county: 'Webster',
    county_names_all: 'Webster|Lewis',
    county_weights: '{"54101": 99.85, "54041": 0.15}',
    density: 15.4,
    imprecise: false,
    latitude: 38.71931,
    longitude: -80.37915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26215',
  },
  {
    city: 'Diana',
    county_fips: 54101,
    county_fips_all: '54101',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"54101": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 38.60837,
    longitude: -80.45901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26217',
  },
  {
    city: 'French Creek',
    county_fips: 54097,
    county_fips_all: '54097',
    county: 'Upshur',
    county_names_all: 'Upshur',
    county_weights: '{"54097": 100}',
    density: 16.1,
    imprecise: false,
    latitude: 38.84506,
    longitude: -80.26798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26218',
  },
  {
    city: 'Hacker Valley',
    county_fips: 54101,
    county_fips_all: '54101',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"54101": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 38.66123,
    longitude: -80.37122,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26222',
  },
  {
    city: 'Helvetia',
    county_fips: 54083,
    county_fips_all: '54083|54097',
    county: 'Randolph',
    county_names_all: 'Randolph|Upshur',
    county_weights: '{"54083": 52.56, "54097": 47.44}',
    density: 3.9,
    imprecise: false,
    latitude: 38.74485,
    longitude: -80.17474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26224',
  },
  {
    city: 'Kanawha Head',
    county_fips: 54097,
    county_fips_all: '54097',
    county: 'Upshur',
    county_names_all: 'Upshur',
    county_weights: '{"54097": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 38.75437,
    longitude: -80.37054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26228',
  },
  {
    city: 'Pickens',
    county_fips: 54083,
    county_fips_all: '54083',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"54083": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 38.6437,
    longitude: -80.18881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26230',
  },
  {
    city: 'Rock Cave',
    county_fips: 54097,
    county_fips_all: '54097',
    county: 'Upshur',
    county_names_all: 'Upshur',
    county_weights: '{"54097": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 38.76618,
    longitude: -80.30833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26234',
  },
  {
    city: 'Selbyville',
    county_fips: 54083,
    county_fips_all: '54083|54097',
    county: 'Randolph',
    county_names_all: 'Randolph|Upshur',
    county_weights: '{"54083": 94.65, "54097": 5.35}',
    density: 0.8,
    imprecise: false,
    latitude: 38.71755,
    longitude: -80.23088,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26236',
  },
  {
    city: 'Tallmansville',
    county_fips: 54097,
    county_fips_all: '54097',
    county: 'Upshur',
    county_names_all: 'Upshur',
    county_weights: '{"54097": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 38.84769,
    longitude: -80.15145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26237',
  },
  {
    city: 'Volga',
    county_fips: 54001,
    county_fips_all: '54001|54097',
    county: 'Barbour',
    county_names_all: 'Barbour|Upshur',
    county_weights: '{"54001": 89.21, "54097": 10.79}',
    density: 20.5,
    imprecise: false,
    latitude: 39.10178,
    longitude: -80.1584,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26238',
  },
  {
    city: 'Elkins',
    county_fips: 54083,
    county_fips_all: '54083',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"54083": 100}',
    density: 52,
    imprecise: false,
    latitude: 38.9163,
    longitude: -79.79229,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26241',
  },
  {
    city: 'Belington',
    county_fips: 54001,
    county_fips_all: '54001|54083',
    county: 'Barbour',
    county_names_all: 'Barbour|Randolph',
    county_weights: '{"54001": 90.79, "54083": 9.21}',
    density: 22.5,
    imprecise: false,
    latitude: 39.02757,
    longitude: -79.96198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26250',
  },
  {
    city: 'Beverly',
    county_fips: 54083,
    county_fips_all: '54083',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"54083": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 38.80772,
    longitude: -79.85654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26253',
  },
  {
    city: 'Bowden',
    county_fips: 54083,
    county_fips_all: '54083|54093',
    county: 'Randolph',
    county_names_all: 'Randolph|Tucker',
    county_weights: '{"54083": 87.15, "54093": 12.85}',
    density: 0.4,
    imprecise: false,
    latitude: 38.91261,
    longitude: -79.65341,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26254',
  },
  {
    city: 'Coalton',
    county_fips: 54083,
    county_fips_all: '54083',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"54083": 100}',
    density: 20.1,
    imprecise: false,
    latitude: 38.9226,
    longitude: -80.01239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26257',
  },
  {
    city: 'Dailey',
    county_fips: 54083,
    county_fips_all: '54083',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"54083": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 38.82536,
    longitude: -79.91528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26259',
  },
  {
    city: 'Davis',
    county_fips: 54093,
    county_fips_all: '54093',
    county: 'Tucker',
    county_names_all: 'Tucker',
    county_weights: '{"54093": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 39.08923,
    longitude: -79.41147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26260',
  },
  {
    city: 'Richwood',
    county_fips: 54025,
    county_fips_all: '54025|54067',
    county: 'Greenbrier',
    county_names_all: 'Greenbrier|Nicholas',
    county_weights: '{"54025": 66.89, "54067": 33.11}',
    density: 6.4,
    imprecise: false,
    latitude: 38.18881,
    longitude: -80.50454,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26261',
  },
  {
    city: 'Dryfork',
    county_fips: 54083,
    county_fips_all: '54083|54093',
    county: 'Randolph',
    county_names_all: 'Randolph|Tucker',
    county_weights: '{"54083": 73.92, "54093": 26.08}',
    density: 2.1,
    imprecise: false,
    latitude: 38.95705,
    longitude: -79.43586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26263',
  },
  {
    city: 'Durbin',
    county_fips: 54075,
    county_fips_all: '54075',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"54075": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 38.58923,
    longitude: -79.82277,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26264',
  },
  {
    city: 'Upperglade',
    county_fips: 54101,
    county_fips_all: '54101',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"54101": 100}',
    density: 20.8,
    imprecise: false,
    latitude: 38.43411,
    longitude: -80.50219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26266',
  },
  {
    city: 'Ellamore',
    county_fips: 54083,
    county_fips_all: '54083|54097|54001',
    county: 'Randolph',
    county_names_all: 'Randolph|Upshur|Barbour',
    county_weights: '{"54083": 62.36, "54097": 35.47, "54001": 2.17}',
    density: 10.8,
    imprecise: false,
    latitude: 38.92557,
    longitude: -80.08069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26267',
  },
  {
    city: 'Glady',
    county_fips: 54083,
    county_fips_all: '54083',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"54083": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 38.71457,
    longitude: -79.82276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26268',
  },
  {
    city: 'Hambleton',
    county_fips: 54093,
    county_fips_all: '54093',
    county: 'Tucker',
    county_names_all: 'Tucker',
    county_weights: '{"54093": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 39.11612,
    longitude: -79.61617,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26269',
  },
  {
    city: 'Harman',
    county_fips: 54083,
    county_fips_all: '54083',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"54083": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 38.81229,
    longitude: -79.60034,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26270',
  },
  {
    city: 'Hendricks',
    county_fips: 54093,
    county_fips_all: '54093',
    county: 'Tucker',
    county_names_all: 'Tucker',
    county_weights: '{"54093": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 39.049,
    longitude: -79.55194,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26271',
  },
  {
    city: 'Huttonsville',
    county_fips: 54083,
    county_fips_all: '54083',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"54083": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 38.62993,
    longitude: -79.963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26273',
  },
  {
    city: 'Junior',
    county_fips: 54001,
    county_fips_all: '54001',
    county: 'Barbour',
    county_names_all: 'Barbour',
    county_weights: '{"54001": 100}',
    density: 44.2,
    imprecise: false,
    latitude: 38.98313,
    longitude: -79.94583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26275',
  },
  {
    city: 'Kerens',
    county_fips: 54083,
    county_fips_all: '54083|54093',
    county: 'Randolph',
    county_names_all: 'Randolph|Tucker',
    county_weights: '{"54083": 51.58, "54093": 48.42}',
    density: 13.3,
    imprecise: false,
    latitude: 39.03201,
    longitude: -79.75659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26276',
  },
  {
    city: 'Mabie',
    county_fips: 54083,
    county_fips_all: '54083',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"54083": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 38.82572,
    longitude: -80.02547,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26278',
  },
  {
    city: 'Mill Creek',
    county_fips: 54083,
    county_fips_all: '54083',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"54083": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 38.71738,
    longitude: -80.03775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26280',
  },
  {
    city: 'Monterville',
    county_fips: 54083,
    county_fips_all: '54083',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"54083": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 38.52022,
    longitude: -80.14619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26282',
  },
  {
    city: 'Montrose',
    county_fips: 54083,
    county_fips_all: '54083|54093|54001',
    county: 'Randolph',
    county_names_all: 'Randolph|Tucker|Barbour',
    county_weights: '{"54083": 63.11, "54093": 21.73, "54001": 15.16}',
    density: 10.4,
    imprecise: false,
    latitude: 39.06436,
    longitude: -79.82088,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26283',
  },
  {
    city: 'Norton',
    county_fips: 54083,
    county_fips_all: '54083',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"54083": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 38.9102,
    longitude: -79.94945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26285',
  },
  {
    city: 'Parsons',
    county_fips: 54093,
    county_fips_all: '54093|54077',
    county: 'Tucker',
    county_names_all: 'Tucker|Preston',
    county_weights: '{"54093": 98.83, "54077": 1.17}',
    density: 7.9,
    imprecise: false,
    latitude: 39.16657,
    longitude: -79.69057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26287',
  },
  {
    city: 'Webster Springs',
    county_fips: 54101,
    county_fips_all: '54101',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"54101": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 38.49664,
    longitude: -80.3645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26288',
  },
  {
    city: 'Red Creek',
    county_fips: 54093,
    county_fips_all: '54093|54083',
    county: 'Tucker',
    county_names_all: 'Tucker|Randolph',
    county_weights: '{"54093": 99.7, "54083": 0.3}',
    density: 1.1,
    imprecise: false,
    latitude: 38.98972,
    longitude: -79.51268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26289',
  },
  {
    city: 'Slatyfork',
    county_fips: 54075,
    county_fips_all: '54075',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"54075": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 38.44109,
    longitude: -80.08637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26291',
  },
  {
    city: 'Thomas',
    county_fips: 54093,
    county_fips_all: '54093',
    county: 'Tucker',
    county_names_all: 'Tucker',
    county_weights: '{"54093": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 39.15247,
    longitude: -79.52916,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26292',
  },
  {
    city: 'Valley Bend',
    county_fips: 54083,
    county_fips_all: '54083',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"54083": 100}',
    density: 44.4,
    imprecise: false,
    latitude: 38.7824,
    longitude: -79.9365,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26293',
  },
  {
    city: 'Valley Head',
    county_fips: 54083,
    county_fips_all: '54083|54075',
    county: 'Randolph',
    county_names_all: 'Randolph|Pocahontas',
    county_weights: '{"54083": 98.45, "54075": 1.55}',
    density: 4.5,
    imprecise: false,
    latitude: 38.53443,
    longitude: -80.02309,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26294',
  },
  {
    city: 'Whitmer',
    county_fips: 54083,
    county_fips_all: '54083',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"54083": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.75425,
    longitude: -79.56369,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26296',
  },
  {
    city: 'Bergoo',
    county_fips: 54101,
    county_fips_all: '54101',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"54101": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 38.45054,
    longitude: -80.26552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26298',
  },
  {
    city: 'Clarksburg',
    county_fips: 54033,
    county_fips_all: '54033',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"54033": 100}',
    density: 143.8,
    imprecise: false,
    latitude: 39.28629,
    longitude: -80.37735,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26301',
  },
  {
    city: 'Alma',
    county_fips: 54095,
    county_fips_all: '54095|54017',
    county: 'Tyler',
    county_names_all: 'Tyler|Doddridge',
    county_weights: '{"54095": 95.98, "54017": 4.02}',
    density: 4.8,
    imprecise: false,
    latitude: 39.41514,
    longitude: -80.82614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26320',
  },
  {
    city: 'Alum Bridge',
    county_fips: 54041,
    county_fips_all: '54041|54017',
    county: 'Lewis',
    county_names_all: 'Lewis|Doddridge',
    county_weights: '{"54041": 90.03, "54017": 9.97}',
    density: 5.6,
    imprecise: false,
    latitude: 39.05461,
    longitude: -80.68732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26321',
  },
  {
    city: 'Anmoore',
    county_fips: 54033,
    county_fips_all: '54033',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"54033": 100}',
    density: 136.6,
    imprecise: false,
    latitude: 39.2623,
    longitude: -80.29057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26323',
  },
  {
    city: 'Auburn',
    county_fips: 54085,
    county_fips_all: '54085',
    county: 'Ritchie',
    county_names_all: 'Ritchie',
    county_weights: '{"54085": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 39.09749,
    longitude: -80.882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26325',
  },
  {
    city: 'Berea',
    county_fips: 54085,
    county_fips_all: '54085',
    county: 'Ritchie',
    county_names_all: 'Ritchie',
    county_weights: '{"54085": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 39.12283,
    longitude: -80.9406,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26327',
  },
  {
    city: 'Bridgeport',
    county_fips: 54033,
    county_fips_all: '54033|54091|54001',
    county: 'Harrison',
    county_names_all: 'Harrison|Taylor|Barbour',
    county_weights: '{"54033": 71.36, "54091": 20.17, "54001": 8.47}',
    density: 85.2,
    imprecise: false,
    latitude: 39.28837,
    longitude: -80.22109,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26330',
  },
  {
    city: 'Burnsville',
    county_fips: 54007,
    county_fips_all: '54007|54021',
    county: 'Braxton',
    county_names_all: 'Braxton|Gilmer',
    county_weights: '{"54007": 70.66, "54021": 29.34}',
    density: 10.2,
    imprecise: false,
    latitude: 38.85364,
    longitude: -80.67683,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26335',
  },
  {
    city: 'Cairo',
    county_fips: 54085,
    county_fips_all: '54085',
    county: 'Ritchie',
    county_names_all: 'Ritchie',
    county_weights: '{"54085": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 39.23856,
    longitude: -81.16388,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26337',
  },
  {
    city: 'Camden',
    county_fips: 54041,
    county_fips_all: '54041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"54041": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 39.08503,
    longitude: -80.61941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26338',
  },
  {
    city: 'Center Point',
    county_fips: 54017,
    county_fips_all: '54017',
    county: 'Doddridge',
    county_names_all: 'Doddridge',
    county_weights: '{"54017": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 39.42231,
    longitude: -80.60998,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26339',
  },
  {
    city: 'Coxs Mills',
    county_fips: 54021,
    county_fips_all: '54021',
    county: 'Gilmer',
    county_names_all: 'Gilmer',
    county_weights: '{"54021": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 39.0248,
    longitude: -80.84698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26342',
  },
  {
    city: 'Crawford',
    county_fips: 54041,
    county_fips_all: '54041|54097',
    county: 'Lewis',
    county_names_all: 'Lewis|Upshur',
    county_weights: '{"54041": 50.05, "54097": 49.95}',
    density: 5.9,
    imprecise: false,
    latitude: 38.82665,
    longitude: -80.39831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26343',
  },
  {
    city: 'Ellenboro',
    county_fips: 54085,
    county_fips_all: '54085|54073|54095',
    county: 'Ritchie',
    county_names_all: 'Ritchie|Pleasants|Tyler',
    county_weights: '{"54085": 88.72, "54073": 10.79, "54095": 0.49}',
    density: 10.7,
    imprecise: false,
    latitude: 39.29247,
    longitude: -81.06294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26346',
  },
  {
    city: 'Flemington',
    county_fips: 54091,
    county_fips_all: '54091|54001',
    county: 'Taylor',
    county_names_all: 'Taylor|Barbour',
    county_weights: '{"54091": 73.64, "54001": 26.36}',
    density: 26.5,
    imprecise: false,
    latitude: 39.26371,
    longitude: -80.1261,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26347',
  },
  {
    city: 'Folsom',
    county_fips: 54103,
    county_fips_all: '54103',
    county: 'Wetzel',
    county_names_all: 'Wetzel',
    county_weights: '{"54103": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 39.46035,
    longitude: -80.53474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26348',
  },
  {
    city: 'Galloway',
    county_fips: 54001,
    county_fips_all: '54001',
    county: 'Barbour',
    county_names_all: 'Barbour',
    county_weights: '{"54001": 100}',
    density: 37.7,
    imprecise: false,
    latitude: 39.22757,
    longitude: -80.11098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26349',
  },
  {
    city: 'Glenville',
    county_fips: 54021,
    county_fips_all: '54021|54007',
    county: 'Gilmer',
    county_names_all: 'Gilmer|Braxton',
    county_weights: '{"54021": 95.73, "54007": 4.27}',
    density: 24.2,
    imprecise: false,
    latitude: 38.92846,
    longitude: -80.84479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26351',
  },
  {
    city: 'Grafton',
    county_fips: 54091,
    county_fips_all: '54091|54049',
    county: 'Taylor',
    county_names_all: 'Taylor|Marion',
    county_weights: '{"54091": 98.24, "54049": 1.76}',
    density: 39.8,
    imprecise: false,
    latitude: 39.34847,
    longitude: -80.02866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26354',
  },
  {
    city: 'Gypsy',
    county_fips: 54033,
    county_fips_all: '54033',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"54033": 100}',
    density: 139.7,
    imprecise: false,
    latitude: 39.36507,
    longitude: -80.31776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26361',
  },
  {
    city: 'Harrisville',
    county_fips: 54085,
    county_fips_all: '54085',
    county: 'Ritchie',
    county_names_all: 'Ritchie',
    county_weights: '{"54085": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 39.15457,
    longitude: -81.05705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26362',
  },
  {
    city: 'Haywood',
    county_fips: 54033,
    county_fips_all: '54033',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"54033": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 39.38266,
    longitude: -80.33474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26366',
  },
  {
    city: 'Hepzibah',
    county_fips: 54033,
    county_fips_all: '54033',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"54033": 100}',
    density: 76,
    imprecise: false,
    latitude: 39.33527,
    longitude: -80.33117,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26369',
  },
  {
    city: 'Horner',
    county_fips: 54041,
    county_fips_all: '54041|54097',
    county: 'Lewis',
    county_names_all: 'Lewis|Upshur',
    county_weights: '{"54041": 97.75, "54097": 2.25}',
    density: 7.8,
    imprecise: false,
    latitude: 38.95859,
    longitude: -80.37155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26372',
  },
  {
    city: 'Independence',
    county_fips: 54077,
    county_fips_all: '54077|54091|54061',
    county: 'Preston',
    county_names_all: 'Preston|Taylor|Monongalia',
    county_weights: '{"54077": 71.35, "54091": 18.2, "54061": 10.45}',
    density: 18,
    imprecise: false,
    latitude: 39.44755,
    longitude: -79.88101,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26374',
  },
  {
    city: 'Ireland',
    county_fips: 54007,
    county_fips_all: '54007|54041',
    county: 'Braxton',
    county_names_all: 'Braxton|Lewis',
    county_weights: '{"54007": 53.94, "54041": 46.06}',
    density: 5.3,
    imprecise: false,
    latitude: 38.77565,
    longitude: -80.46864,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26376',
  },
  {
    city: 'Jacksonburg',
    county_fips: 54103,
    county_fips_all: '54103|54095',
    county: 'Wetzel',
    county_names_all: 'Wetzel|Tyler',
    county_weights: '{"54103": 67.67, "54095": 32.33}',
    density: 4.1,
    imprecise: false,
    latitude: 39.49185,
    longitude: -80.64068,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26377',
  },
  {
    city: 'Jane Lew',
    county_fips: 54041,
    county_fips_all: '54041|54033',
    county: 'Lewis',
    county_names_all: 'Lewis|Harrison',
    county_weights: '{"54041": 66.85, "54033": 33.15}',
    density: 25.8,
    imprecise: false,
    latitude: 39.12264,
    longitude: -80.44772,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26378',
  },
  {
    city: 'Linn',
    county_fips: 54021,
    county_fips_all: '54021|54041',
    county: 'Gilmer',
    county_names_all: 'Gilmer|Lewis',
    county_weights: '{"54021": 84.89, "54041": 15.11}',
    density: 2.7,
    imprecise: false,
    latitude: 38.97467,
    longitude: -80.7178,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26384',
  },
  {
    city: 'Lost Creek',
    county_fips: 54033,
    county_fips_all: '54033',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"54033": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 39.15895,
    longitude: -80.3517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26385',
  },
  {
    city: 'Lumberport',
    county_fips: 54033,
    county_fips_all: '54033',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"54033": 100}',
    density: 29.6,
    imprecise: false,
    latitude: 39.39878,
    longitude: -80.40263,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26386',
  },
  {
    city: 'Meadowbrook',
    county_fips: 54033,
    county_fips_all: '54033',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"54033": 100}',
    density: 34.6,
    imprecise: false,
    latitude: 39.34636,
    longitude: -80.30996,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26404',
  },
  {
    city: 'Moatsville',
    county_fips: 54001,
    county_fips_all: '54001|54077',
    county: 'Barbour',
    county_names_all: 'Barbour|Preston',
    county_weights: '{"54001": 75.41, "54077": 24.59}',
    density: 5,
    imprecise: false,
    latitude: 39.23093,
    longitude: -79.89076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26405',
  },
  {
    city: 'Mount Clare',
    county_fips: 54033,
    county_fips_all: '54033',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"54033": 100}',
    density: 26.1,
    imprecise: false,
    latitude: 39.20313,
    longitude: -80.28973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26408',
  },
  {
    city: 'Newburg',
    county_fips: 54077,
    county_fips_all: '54077',
    county: 'Preston',
    county_names_all: 'Preston',
    county_weights: '{"54077": 100}',
    density: 10,
    imprecise: false,
    latitude: 39.4032,
    longitude: -79.82389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26410',
  },
  {
    city: 'New Milton',
    county_fips: 54017,
    county_fips_all: '54017|54021',
    county: 'Doddridge',
    county_names_all: 'Doddridge|Gilmer',
    county_weights: '{"54017": 97.93, "54021": 2.07}',
    density: 2.7,
    imprecise: false,
    latitude: 39.18078,
    longitude: -80.70723,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26411',
  },
  {
    city: 'Orlando',
    county_fips: 54041,
    county_fips_all: '54041|54007|54021',
    county: 'Lewis',
    county_names_all: 'Lewis|Braxton|Gilmer',
    county_weights: '{"54041": 41.3, "54007": 39.47, "54021": 19.24}',
    density: 6,
    imprecise: false,
    latitude: 38.89164,
    longitude: -80.59457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26412',
  },
  {
    city: 'Pennsboro',
    county_fips: 54085,
    county_fips_all: '54085|54095|54017',
    county: 'Ritchie',
    county_names_all: 'Ritchie|Tyler|Doddridge',
    county_weights: '{"54085": 68.8, "54095": 16.73, "54017": 14.47}',
    density: 12.6,
    imprecise: false,
    latitude: 39.29808,
    longitude: -80.93499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26415',
  },
  {
    city: 'Philippi',
    county_fips: 54001,
    county_fips_all: '54001|54091',
    county: 'Barbour',
    county_names_all: 'Barbour|Taylor',
    county_weights: '{"54001": 99.06, "54091": 0.94}',
    density: 21.1,
    imprecise: false,
    latitude: 39.16349,
    longitude: -80.02245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26416',
  },
  {
    city: 'Pine Grove',
    county_fips: 54103,
    county_fips_all: '54103',
    county: 'Wetzel',
    county_names_all: 'Wetzel',
    county_weights: '{"54103": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 39.58469,
    longitude: -80.631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26419',
  },
  {
    city: 'Pullman',
    county_fips: 54085,
    county_fips_all: '54085',
    county: 'Ritchie',
    county_names_all: 'Ritchie',
    county_weights: '{"54085": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 39.18412,
    longitude: -80.91607,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26421',
  },
  {
    city: 'Reynoldsville',
    county_fips: 54033,
    county_fips_all: '54033',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"54033": 100}',
    density: 14,
    imprecise: false,
    latitude: 39.29797,
    longitude: -80.43323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26422',
  },
  {
    city: 'Rosemont',
    county_fips: 54091,
    county_fips_all: '54091|54033',
    county: 'Taylor',
    county_names_all: 'Taylor|Harrison',
    county_weights: '{"54091": 99.9, "54033": 0.1}',
    density: 31.7,
    imprecise: false,
    latitude: 39.28117,
    longitude: -80.17272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26424',
  },
  {
    city: 'Rowlesburg',
    county_fips: 54077,
    county_fips_all: '54077|54093',
    county: 'Preston',
    county_names_all: 'Preston|Tucker',
    county_weights: '{"54077": 96.87, "54093": 3.13}',
    density: 6.9,
    imprecise: false,
    latitude: 39.3116,
    longitude: -79.68651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26425',
  },
  {
    city: 'Salem',
    county_fips: 54017,
    county_fips_all: '54017|54033',
    county: 'Doddridge',
    county_names_all: 'Doddridge|Harrison',
    county_weights: '{"54017": 54.46, "54033": 45.54}',
    density: 21.4,
    imprecise: false,
    latitude: 39.28758,
    longitude: -80.56313,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26426',
  },
  {
    city: 'Sand Fork',
    county_fips: 54021,
    county_fips_all: '54021',
    county: 'Gilmer',
    county_names_all: 'Gilmer',
    county_weights: '{"54021": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 38.88475,
    longitude: -80.7598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26430',
  },
  {
    city: 'Shinnston',
    county_fips: 54033,
    county_fips_all: '54033|54091',
    county: 'Harrison',
    county_names_all: 'Harrison|Taylor',
    county_weights: '{"54033": 97.67, "54091": 2.33}',
    density: 80.2,
    imprecise: false,
    latitude: 39.39144,
    longitude: -80.28085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26431',
  },
  {
    city: 'Simpson',
    county_fips: 54091,
    county_fips_all: '54091',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"54091": 100}',
    density: 345.8,
    imprecise: false,
    latitude: 39.26743,
    longitude: -80.08875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26435',
  },
  {
    city: 'Smithburg',
    county_fips: 54017,
    county_fips_all: '54017',
    county: 'Doddridge',
    county_names_all: 'Doddridge',
    county_weights: '{"54017": 100}',
    density: 45.2,
    imprecise: false,
    latitude: 39.2965,
    longitude: -80.71683,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26436',
  },
  {
    city: 'Smithfield',
    county_fips: 54103,
    county_fips_all: '54103|54049',
    county: 'Wetzel',
    county_names_all: 'Wetzel|Marion',
    county_weights: '{"54103": 96.16, "54049": 3.84}',
    density: 6.6,
    imprecise: false,
    latitude: 39.53147,
    longitude: -80.5193,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26437',
  },
  {
    city: 'Spelter',
    county_fips: 54033,
    county_fips_all: '54033',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"54033": 100}',
    density: 67.9,
    imprecise: false,
    latitude: 39.34315,
    longitude: -80.31631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26438',
  },
  {
    city: 'Thornton',
    county_fips: 54091,
    county_fips_all: '54091|54077|54001',
    county: 'Taylor',
    county_names_all: 'Taylor|Preston|Barbour',
    county_weights: '{"54091": 51.4, "54077": 31.4, "54001": 17.2}',
    density: 10,
    imprecise: false,
    latitude: 39.32947,
    longitude: -79.90625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26440',
  },
  {
    city: 'Troy',
    county_fips: 54021,
    county_fips_all: '54021|54017',
    county: 'Gilmer',
    county_names_all: 'Gilmer|Doddridge',
    county_weights: '{"54021": 86.65, "54017": 13.35}',
    density: 8.3,
    imprecise: false,
    latitude: 39.06814,
    longitude: -80.7554,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26443',
  },
  {
    city: 'Tunnelton',
    county_fips: 54077,
    county_fips_all: '54077',
    county: 'Preston',
    county_names_all: 'Preston',
    county_weights: '{"54077": 100}',
    density: 21.3,
    imprecise: false,
    latitude: 39.36861,
    longitude: -79.7626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26444',
  },
  {
    city: 'Walkersville',
    county_fips: 54041,
    county_fips_all: '54041|54007',
    county: 'Lewis',
    county_names_all: 'Lewis|Braxton',
    county_weights: '{"54041": 94.0, "54007": 6.0}',
    density: 6.2,
    imprecise: false,
    latitude: 38.90546,
    longitude: -80.4854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26447',
  },
  {
    city: 'Wallace',
    county_fips: 54033,
    county_fips_all: '54033|54049|54017',
    county: 'Harrison',
    county_names_all: 'Harrison|Marion|Doddridge',
    county_weights: '{"54033": 90.89, "54049": 5.57, "54017": 3.54}',
    density: 10.1,
    imprecise: false,
    latitude: 39.40595,
    longitude: -80.49265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26448',
  },
  {
    city: 'West Milford',
    county_fips: 54033,
    county_fips_all: '54033',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"54033": 100}',
    density: 424.9,
    imprecise: false,
    latitude: 39.20439,
    longitude: -80.40352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26451',
  },
  {
    city: 'Weston',
    county_fips: 54041,
    county_fips_all: '54041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"54041": 100}',
    density: 30.3,
    imprecise: false,
    latitude: 39.03286,
    longitude: -80.51315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26452',
  },
  {
    city: 'West Union',
    county_fips: 54017,
    county_fips_all: '54017|54085|54095',
    county: 'Doddridge',
    county_names_all: 'Doddridge|Ritchie|Tyler',
    county_weights: '{"54017": 87.02, "54085": 8.73, "54095": 4.25}',
    density: 8.2,
    imprecise: false,
    latitude: 39.28078,
    longitude: -80.77354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26456',
  },
  {
    city: 'Wyatt',
    county_fips: 54033,
    county_fips_all: '54033',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"54033": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 39.43174,
    longitude: -80.35007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26463',
  },
  {
    city: 'Morgantown',
    county_fips: 54061,
    county_fips_all: '54061',
    county: 'Monongalia',
    county_names_all: 'Monongalia',
    county_weights: '{"54061": 100}',
    density: 128.8,
    imprecise: false,
    latitude: 39.62872,
    longitude: -80.04025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26501',
  },
  {
    city: 'Morgantown',
    county_fips: 54061,
    county_fips_all: '54061',
    county: 'Monongalia',
    county_names_all: 'Monongalia',
    county_weights: '{"54061": 100}',
    density: 1144.4,
    imprecise: false,
    latitude: 39.6511,
    longitude: -79.94306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26505',
  },
  {
    city: 'Morgantown',
    county_fips: 54061,
    county_fips_all: '54061',
    county: 'Monongalia',
    county_names_all: 'Monongalia',
    county_weights: '{"54061": 100}',
    density: 2393.8,
    imprecise: false,
    latitude: 39.64677,
    longitude: -79.9701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26506',
  },
  {
    city: 'Morgantown',
    county_fips: 54061,
    county_fips_all: '54061',
    county: 'Monongalia',
    county_names_all: 'Monongalia',
    county_weights: '{"54061": 100}',
    density: 126.2,
    imprecise: false,
    latitude: 39.59941,
    longitude: -79.89724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26508',
  },
  {
    city: 'Albright',
    county_fips: 54077,
    county_fips_all: '54077',
    county: 'Preston',
    county_names_all: 'Preston',
    county_weights: '{"54077": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 39.55179,
    longitude: -79.63212,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26519',
  },
  {
    city: 'Arthurdale',
    county_fips: 54077,
    county_fips_all: '54077',
    county: 'Preston',
    county_names_all: 'Preston',
    county_weights: '{"54077": 100}',
    density: 63.7,
    imprecise: false,
    latitude: 39.50105,
    longitude: -79.82393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26520',
  },
  {
    city: 'Blacksville',
    county_fips: 54061,
    county_fips_all: '54061',
    county: 'Monongalia',
    county_names_all: 'Monongalia',
    county_weights: '{"54061": 100}',
    density: 22.6,
    imprecise: false,
    latitude: 39.71374,
    longitude: -80.23065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26521',
  },
  {
    city: 'Bretz',
    county_fips: 54077,
    county_fips_all: '54077',
    county: 'Preston',
    county_names_all: 'Preston',
    county_weights: '{"54077": 100}',
    density: 162.4,
    imprecise: false,
    latitude: 39.54075,
    longitude: -79.80716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26524',
  },
  {
    city: 'Bruceton Mills',
    county_fips: 54077,
    county_fips_all: '54077',
    county: 'Preston',
    county_names_all: 'Preston',
    county_weights: '{"54077": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 39.65465,
    longitude: -79.6184,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26525',
  },
  {
    city: 'Granville',
    county_fips: 54061,
    county_fips_all: '54061',
    county: 'Monongalia',
    county_names_all: 'Monongalia',
    county_weights: '{"54061": 100}',
    density: 240.1,
    imprecise: false,
    latitude: 39.64748,
    longitude: -79.99733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26534',
  },
  {
    city: 'Kingwood',
    county_fips: 54077,
    county_fips_all: '54077',
    county: 'Preston',
    county_names_all: 'Preston',
    county_weights: '{"54077": 100}',
    density: 49,
    imprecise: false,
    latitude: 39.4846,
    longitude: -79.71189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26537',
  },
  {
    city: 'Maidsville',
    county_fips: 54061,
    county_fips_all: '54061',
    county: 'Monongalia',
    county_names_all: 'Monongalia',
    county_weights: '{"54061": 100}',
    density: 31,
    imprecise: false,
    latitude: 39.68179,
    longitude: -80.07458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26541',
  },
  {
    city: 'Masontown',
    county_fips: 54077,
    county_fips_all: '54077|54061',
    county: 'Preston',
    county_names_all: 'Preston|Monongalia',
    county_weights: '{"54077": 75.48, "54061": 24.52}',
    density: 22.3,
    imprecise: false,
    latitude: 39.573,
    longitude: -79.79041,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26542',
  },
  {
    city: 'Osage',
    county_fips: 54061,
    county_fips_all: '54061',
    county: 'Monongalia',
    county_names_all: 'Monongalia',
    county_weights: '{"54061": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.66375,
    longitude: -80.00219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26543',
  },
  {
    city: 'Pentress',
    county_fips: 54061,
    county_fips_all: '54061',
    county: 'Monongalia',
    county_names_all: 'Monongalia',
    county_weights: '{"54061": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.71233,
    longitude: -80.17064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26544',
  },
  {
    city: 'Pursglove',
    county_fips: 54061,
    county_fips_all: '54061',
    county: 'Monongalia',
    county_names_all: 'Monongalia',
    county_weights: '{"54061": 100}',
    density: 132.4,
    imprecise: false,
    latitude: 39.66099,
    longitude: -80.03115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26546',
  },
  {
    city: 'Reedsville',
    county_fips: 54077,
    county_fips_all: '54077',
    county: 'Preston',
    county_names_all: 'Preston',
    county_weights: '{"54077": 100}',
    density: 71.7,
    imprecise: false,
    latitude: 39.5133,
    longitude: -79.80757,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26547',
  },
  {
    city: 'Fairmont',
    county_fips: 54049,
    county_fips_all: '54049|54061|54091|54033',
    county: 'Marion',
    county_names_all: 'Marion|Monongalia|Taylor|Harrison',
    county_weights:
      '{"54049": 87.26, "54061": 8.04, "54091": 3.24, "54033": 1.46}',
    density: 123.3,
    imprecise: false,
    latitude: 39.46475,
    longitude: -80.11461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26554',
  },
  {
    city: 'Barrackville',
    county_fips: 54049,
    county_fips_all: '54049',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"54049": 100}',
    density: 182.9,
    imprecise: false,
    latitude: 39.52141,
    longitude: -80.18015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26559',
  },
  {
    city: 'Baxter',
    county_fips: 54049,
    county_fips_all: '54049',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"54049": 100}',
    density: 375.8,
    imprecise: false,
    latitude: 39.54088,
    longitude: -80.14362,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26560',
  },
  {
    city: 'Burton',
    county_fips: 54103,
    county_fips_all: '54103|54061',
    county: 'Wetzel',
    county_names_all: 'Wetzel|Monongalia',
    county_weights: '{"54103": 68.34, "54061": 31.66}',
    density: 8,
    imprecise: false,
    latitude: 39.63957,
    longitude: -80.45072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26562',
  },
  {
    city: 'Carolina',
    county_fips: 54049,
    county_fips_all: '54049',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"54049": 100}',
    density: 141.7,
    imprecise: false,
    latitude: 39.48085,
    longitude: -80.27369,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26563',
  },
  {
    city: 'Enterprise',
    county_fips: 54033,
    county_fips_all: '54033|54049',
    county: 'Harrison',
    county_names_all: 'Harrison|Marion',
    county_weights: '{"54033": 99.9, "54049": 0.1}',
    density: 212.9,
    imprecise: false,
    latitude: 39.42542,
    longitude: -80.27729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26568',
  },
  {
    city: 'Fairview',
    county_fips: 54061,
    county_fips_all: '54061|54049',
    county: 'Monongalia',
    county_names_all: 'Monongalia|Marion',
    county_weights: '{"54061": 74.18, "54049": 25.82}',
    density: 20.2,
    imprecise: false,
    latitude: 39.64284,
    longitude: -80.23444,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26570',
  },
  {
    city: 'Farmington',
    county_fips: 54049,
    county_fips_all: '54049',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"54049": 100}',
    density: 41.8,
    imprecise: false,
    latitude: 39.51945,
    longitude: -80.26013,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26571',
  },
  {
    city: 'Four States',
    county_fips: 54049,
    county_fips_all: '54049',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"54049": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 39.4871,
    longitude: -80.31973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26572',
  },
  {
    city: 'Grant Town',
    county_fips: 54049,
    county_fips_all: '54049',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"54049": 100}',
    density: 397.7,
    imprecise: false,
    latitude: 39.55926,
    longitude: -80.17741,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26574',
  },
  {
    city: 'Hundred',
    county_fips: 54103,
    county_fips_all: '54103|54061',
    county: 'Wetzel',
    county_names_all: 'Wetzel|Monongalia',
    county_weights: '{"54103": 72.83, "54061": 27.17}',
    density: 9.5,
    imprecise: false,
    latitude: 39.6978,
    longitude: -80.43256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26575',
  },
  {
    city: 'Idamay',
    county_fips: 54049,
    county_fips_all: '54049',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"54049": 100}',
    density: 208.4,
    imprecise: false,
    latitude: 39.49307,
    longitude: -80.25644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26576',
  },
  {
    city: 'Littleton',
    county_fips: 54103,
    county_fips_all: '54103',
    county: 'Wetzel',
    county_names_all: 'Wetzel',
    county_weights: '{"54103": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 39.66554,
    longitude: -80.56781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26581',
  },
  {
    city: 'Mannington',
    county_fips: 54049,
    county_fips_all: '54049|54033|54061',
    county: 'Marion',
    county_names_all: 'Marion|Harrison|Monongalia',
    county_weights: '{"54049": 97.57, "54033": 1.75, "54061": 0.68}',
    density: 16.7,
    imprecise: false,
    latitude: 39.53114,
    longitude: -80.38767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26582',
  },
  {
    city: 'Metz',
    county_fips: 54049,
    county_fips_all: '54049|54103',
    county: 'Marion',
    county_names_all: 'Marion|Wetzel',
    county_weights: '{"54049": 67.05, "54103": 32.95}',
    density: 12.7,
    imprecise: false,
    latitude: 39.6065,
    longitude: -80.42379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26585',
  },
  {
    city: 'Montana Mines',
    county_fips: 54049,
    county_fips_all: '54049',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"54049": 100}',
    density: 220.1,
    imprecise: false,
    latitude: 39.52786,
    longitude: -80.10952,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26586',
  },
  {
    city: 'Rachel',
    county_fips: 54049,
    county_fips_all: '54049',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"54049": 100}',
    density: 52,
    imprecise: false,
    latitude: 39.51606,
    longitude: -80.29751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 98,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26587',
  },
  {
    city: 'Rivesville',
    county_fips: 54049,
    county_fips_all: '54049|54061',
    county: 'Marion',
    county_names_all: 'Marion|Monongalia',
    county_weights: '{"54049": 79.13, "54061": 20.87}',
    density: 29.5,
    imprecise: false,
    latitude: 39.5738,
    longitude: -80.15339,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26588',
  },
  {
    city: 'Wana',
    county_fips: 54061,
    county_fips_all: '54061',
    county: 'Monongalia',
    county_names_all: 'Monongalia',
    county_weights: '{"54061": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 39.67428,
    longitude: -80.31674,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26590',
  },
  {
    city: 'Worthington',
    county_fips: 54049,
    county_fips_all: '54049|54033',
    county: 'Marion',
    county_names_all: 'Marion|Harrison',
    county_weights: '{"54049": 96.17, "54033": 3.83}',
    density: 50.2,
    imprecise: false,
    latitude: 39.45499,
    longitude: -80.2903,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26591',
  },
  {
    city: 'Sutton',
    county_fips: 54007,
    county_fips_all: '54007',
    county: 'Braxton',
    county_names_all: 'Braxton',
    county_weights: '{"54007": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 38.63307,
    longitude: -80.6567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26601',
  },
  {
    city: 'Birch River',
    county_fips: 54067,
    county_fips_all: '54067|54101',
    county: 'Nicholas',
    county_names_all: 'Nicholas|Webster',
    county_weights: '{"54067": 80.24, "54101": 19.76}',
    density: 3.7,
    imprecise: false,
    latitude: 38.47769,
    longitude: -80.71887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26610',
  },
  {
    city: 'Cedarville',
    county_fips: 54021,
    county_fips_all: '54021',
    county: 'Gilmer',
    county_names_all: 'Gilmer',
    county_weights: '{"54021": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 38.84639,
    longitude: -80.83339,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26611',
  },
  {
    city: 'Copen',
    county_fips: 54007,
    county_fips_all: '54007',
    county: 'Braxton',
    county_names_all: 'Braxton',
    county_weights: '{"54007": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 38.83242,
    longitude: -80.73136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26615',
  },
  {
    city: 'Dille',
    county_fips: 54067,
    county_fips_all: '54067|54015',
    county: 'Nicholas',
    county_names_all: 'Nicholas|Clay',
    county_weights: '{"54067": 81.67, "54015": 18.33}',
    density: 27.6,
    imprecise: false,
    latitude: 38.4828,
    longitude: -80.82572,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26617',
  },
  {
    city: 'Exchange',
    county_fips: 54007,
    county_fips_all: '54007',
    county: 'Braxton',
    county_names_all: 'Braxton',
    county_weights: '{"54007": 100}',
    density: 9,
    imprecise: false,
    latitude: 38.77542,
    longitude: -80.73562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26619',
  },
  {
    city: 'Flatwoods',
    county_fips: 54007,
    county_fips_all: '54007',
    county: 'Braxton',
    county_names_all: 'Braxton',
    county_weights: '{"54007": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 38.72186,
    longitude: -80.56057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26621',
  },
  {
    city: 'Frametown',
    county_fips: 54007,
    county_fips_all: '54007|54021',
    county: 'Braxton',
    county_names_all: 'Braxton|Gilmer',
    county_weights: '{"54007": 97.83, "54021": 2.17}',
    density: 8.9,
    imprecise: false,
    latitude: 38.6576,
    longitude: -80.87714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26623',
  },
  {
    city: 'Gassaway',
    county_fips: 54007,
    county_fips_all: '54007|54021',
    county: 'Braxton',
    county_names_all: 'Braxton|Gilmer',
    county_weights: '{"54007": 94.46, "54021": 5.54}',
    density: 10.9,
    imprecise: false,
    latitude: 38.72071,
    longitude: -80.80883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26624',
  },
  {
    city: 'Heaters',
    county_fips: 54007,
    county_fips_all: '54007',
    county: 'Braxton',
    county_names_all: 'Braxton',
    county_weights: '{"54007": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 38.75578,
    longitude: -80.5943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26627',
  },
  {
    city: 'Little Birch',
    county_fips: 54007,
    county_fips_all: '54007',
    county: 'Braxton',
    county_names_all: 'Braxton',
    county_weights: '{"54007": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 38.56846,
    longitude: -80.70152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26629',
  },
  {
    city: 'Napier',
    county_fips: 54007,
    county_fips_all: '54007',
    county: 'Braxton',
    county_names_all: 'Braxton',
    county_weights: '{"54007": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 38.79795,
    longitude: -80.56856,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26631',
  },
  {
    city: 'Rosedale',
    county_fips: 54007,
    county_fips_all: '54007|54021|54013',
    county: 'Braxton',
    county_names_all: 'Braxton|Gilmer|Calhoun',
    county_weights: '{"54007": 46.14, "54021": 43.68, "54013": 10.19}',
    density: 4.1,
    imprecise: false,
    latitude: 38.73386,
    longitude: -80.96599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26636',
  },
  {
    city: 'Shock',
    county_fips: 54021,
    county_fips_all: '54021|54013',
    county: 'Gilmer',
    county_names_all: 'Gilmer|Calhoun',
    county_weights: '{"54021": 84.86, "54013": 15.14}',
    density: 1.7,
    imprecise: false,
    latitude: 38.77265,
    longitude: -80.99878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26638',
  },
  {
    city: 'Summersville',
    county_fips: 54067,
    county_fips_all: '54067',
    county: 'Nicholas',
    county_names_all: 'Nicholas',
    county_weights: '{"54067": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 38.3185,
    longitude: -80.87902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26651',
  },
  {
    city: 'Belva',
    county_fips: 54067,
    county_fips_all: '54067|54019',
    county: 'Nicholas',
    county_names_all: 'Nicholas|Fayette',
    county_weights: '{"54067": 56.17, "54019": 43.83}',
    density: 10.2,
    imprecise: false,
    latitude: 38.24358,
    longitude: -81.18082,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26656',
  },
  {
    city: 'Calvin',
    county_fips: 54067,
    county_fips_all: '54067',
    county: 'Nicholas',
    county_names_all: 'Nicholas',
    county_weights: '{"54067": 100}',
    density: 25.6,
    imprecise: false,
    latitude: 38.35513,
    longitude: -80.70061,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26660',
  },
  {
    city: 'Canvas',
    county_fips: 54067,
    county_fips_all: '54067',
    county: 'Nicholas',
    county_names_all: 'Nicholas',
    county_weights: '{"54067": 100}',
    density: 28.5,
    imprecise: false,
    latitude: 38.25813,
    longitude: -80.7695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26662',
  },
  {
    city: 'Drennen',
    county_fips: 54067,
    county_fips_all: '54067|54019',
    county: 'Nicholas',
    county_names_all: 'Nicholas|Fayette',
    county_weights: '{"54067": 99.46, "54019": 0.54}',
    density: 9.8,
    imprecise: false,
    latitude: 38.2384,
    longitude: -80.99908,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26667',
  },
  {
    city: 'Gilboa',
    county_fips: 54067,
    county_fips_all: '54067',
    county: 'Nicholas',
    county_names_all: 'Nicholas',
    county_weights: '{"54067": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 38.31978,
    longitude: -80.90929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26671',
  },
  {
    city: 'Leivasy',
    county_fips: 54067,
    county_fips_all: '54067',
    county: 'Nicholas',
    county_names_all: 'Nicholas',
    county_weights: '{"54067": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 38.16173,
    longitude: -80.65944,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26676',
  },
  {
    city: 'Mount Lookout',
    county_fips: 54067,
    county_fips_all: '54067',
    county: 'Nicholas',
    county_names_all: 'Nicholas',
    county_weights: '{"54067": 100}',
    density: 38.6,
    imprecise: false,
    latitude: 38.16883,
    longitude: -80.91085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26678',
  },
  {
    city: 'Mount Nebo',
    county_fips: 54067,
    county_fips_all: '54067',
    county: 'Nicholas',
    county_names_all: 'Nicholas',
    county_weights: '{"54067": 100}',
    density: 12,
    imprecise: false,
    latitude: 38.16509,
    longitude: -80.7971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26679',
  },
  {
    city: 'Nallen',
    county_fips: 54019,
    county_fips_all: '54019|54025|54067',
    county: 'Fayette',
    county_names_all: 'Fayette|Greenbrier|Nicholas',
    county_weights: '{"54019": 44.55, "54025": 32.05, "54067": 23.4}',
    density: 3.4,
    imprecise: false,
    latitude: 38.08991,
    longitude: -80.87423,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26680',
  },
  {
    city: 'Nettie',
    county_fips: 54067,
    county_fips_all: '54067',
    county: 'Nicholas',
    county_names_all: 'Nicholas',
    county_weights: '{"54067": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 38.22983,
    longitude: -80.71905,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26681',
  },
  {
    city: 'Pool',
    county_fips: 54067,
    county_fips_all: '54067',
    county: 'Nicholas',
    county_names_all: 'Nicholas',
    county_weights: '{"54067": 100}',
    density: 45.5,
    imprecise: false,
    latitude: 38.16324,
    longitude: -80.8544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26684',
  },
  {
    city: 'Swiss',
    county_fips: 54019,
    county_fips_all: '54019|54067',
    county: 'Fayette',
    county_names_all: 'Fayette|Nicholas',
    county_weights: '{"54019": 55.89, "54067": 44.11}',
    density: 8,
    imprecise: false,
    latitude: 38.21757,
    longitude: -81.12069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26690',
  },
  {
    city: 'Tioga',
    county_fips: 54067,
    county_fips_all: '54067|54101',
    county: 'Nicholas',
    county_names_all: 'Nicholas|Webster',
    county_weights: '{"54067": 96.03, "54101": 3.97}',
    density: 20.3,
    imprecise: false,
    latitude: 38.39785,
    longitude: -80.67213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26691',
  },
  {
    city: 'Augusta',
    county_fips: 54027,
    county_fips_all: '54027',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"54027": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 39.28619,
    longitude: -78.59471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26704',
  },
  {
    city: 'Aurora',
    county_fips: 54077,
    county_fips_all: '54077',
    county: 'Preston',
    county_names_all: 'Preston',
    county_weights: '{"54077": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 39.32388,
    longitude: -79.56663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26705',
  },
  {
    city: 'Bayard',
    county_fips: 54023,
    county_fips_all: '54023',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"54023": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 39.22275,
    longitude: -79.39418,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26707',
  },
  {
    city: 'Burlington',
    county_fips: 54057,
    county_fips_all: '54057|54023|54027',
    county: 'Mineral',
    county_names_all: 'Mineral|Grant|Hampshire',
    county_weights: '{"54057": 74.33, "54023": 22.59, "54027": 3.08}',
    density: 9,
    imprecise: false,
    latitude: 39.30996,
    longitude: -78.94544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26710',
  },
  {
    city: 'Capon Bridge',
    county_fips: 54027,
    county_fips_all: '54027',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"54027": 100}',
    density: 20.7,
    imprecise: false,
    latitude: 39.30301,
    longitude: -78.47073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26711',
  },
  {
    city: 'Delray',
    county_fips: 54027,
    county_fips_all: '54027',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"54027": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 39.17634,
    longitude: -78.64177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26714',
  },
  {
    city: 'Eglon',
    county_fips: 54077,
    county_fips_all: '54077',
    county: 'Preston',
    county_names_all: 'Preston',
    county_weights: '{"54077": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 39.2641,
    longitude: -79.51892,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26716',
  },
  {
    city: 'Elk Garden',
    county_fips: 54057,
    county_fips_all: '54057|54023',
    county: 'Mineral',
    county_names_all: 'Mineral|Grant',
    county_weights: '{"54057": 82.6, "54023": 17.4}',
    density: 15,
    imprecise: false,
    latitude: 39.34583,
    longitude: -79.17597,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26717',
  },
  {
    city: 'Fort Ashby',
    county_fips: 54057,
    county_fips_all: '54057',
    county: 'Mineral',
    county_names_all: 'Mineral',
    county_weights: '{"54057": 100}',
    density: 45.8,
    imprecise: false,
    latitude: 39.49778,
    longitude: -78.7678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26719',
  },
  {
    city: 'Gormania',
    county_fips: 54023,
    county_fips_all: '54023',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"54023": 100}',
    density: 3,
    imprecise: false,
    latitude: 39.27761,
    longitude: -79.33126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26720',
  },
  {
    city: 'Green Spring',
    county_fips: 54027,
    county_fips_all: '54027',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"54027": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 39.49774,
    longitude: -78.63463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26722',
  },
  {
    city: 'Keyser',
    county_fips: 54057,
    county_fips_all: '54057|54023',
    county: 'Mineral',
    county_names_all: 'Mineral|Grant',
    county_weights: '{"54057": 85.82, "54023": 14.18}',
    density: 32.6,
    imprecise: false,
    latitude: 39.40508,
    longitude: -78.98222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26726',
  },
  {
    city: 'Lahmansville',
    county_fips: 54023,
    county_fips_all: '54023',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"54023": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 39.15243,
    longitude: -79.06859,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26731',
  },
  {
    city: 'Mount Storm',
    county_fips: 54023,
    county_fips_all: '54023',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"54023": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 39.21508,
    longitude: -79.2647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26739',
  },
  {
    city: 'New Creek',
    county_fips: 54057,
    county_fips_all: '54057|54023',
    county: 'Mineral',
    county_names_all: 'Mineral|Grant',
    county_weights: '{"54057": 50.66, "54023": 49.34}',
    density: 11.9,
    imprecise: false,
    latitude: 39.28873,
    longitude: -79.07998,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26743',
  },
  {
    city: 'Piedmont',
    county_fips: 54057,
    county_fips_all: '54057',
    county: 'Mineral',
    county_names_all: 'Mineral',
    county_weights: '{"54057": 100}',
    density: 696.8,
    imprecise: false,
    latitude: 39.47764,
    longitude: -79.04627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26750',
  },
  {
    city: 'Ridgeley',
    county_fips: 54057,
    county_fips_all: '54057',
    county: 'Mineral',
    county_names_all: 'Mineral',
    county_weights: '{"54057": 100}',
    density: 89.2,
    imprecise: false,
    latitude: 39.56017,
    longitude: -78.79026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26753',
  },
  {
    city: 'Rio',
    county_fips: 54027,
    county_fips_all: '54027|54031',
    county: 'Hampshire',
    county_names_all: 'Hampshire|Hardy',
    county_weights: '{"54027": 53.98, "54031": 46.02}',
    density: 7.2,
    imprecise: false,
    latitude: 39.15856,
    longitude: -78.73534,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26755',
  },
  {
    city: 'Romney',
    county_fips: 54027,
    county_fips_all: '54027',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"54027": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 39.31652,
    longitude: -78.75001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26757',
  },
  {
    city: 'Shanks',
    county_fips: 54027,
    county_fips_all: '54027',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"54027": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 39.27303,
    longitude: -78.6997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26761',
  },
  {
    city: 'Springfield',
    county_fips: 54027,
    county_fips_all: '54027|54057',
    county: 'Hampshire',
    county_names_all: 'Hampshire|Mineral',
    county_weights: '{"54027": 65.69, "54057": 34.31}',
    density: 9.9,
    imprecise: false,
    latitude: 39.4789,
    longitude: -78.69316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26763',
  },
  {
    city: 'Terra Alta',
    county_fips: 54077,
    county_fips_all: '54077',
    county: 'Preston',
    county_names_all: 'Preston',
    county_weights: '{"54077": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 39.45042,
    longitude: -79.56035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26764',
  },
  {
    city: 'Wiley Ford',
    county_fips: 54057,
    county_fips_all: '54057',
    county: 'Mineral',
    county_names_all: 'Mineral',
    county_weights: '{"54057": 100}',
    density: 65.1,
    imprecise: false,
    latitude: 39.61581,
    longitude: -78.75674,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26767',
  },
  {
    city: 'Baker',
    county_fips: 54031,
    county_fips_all: '54031',
    county: 'Hardy',
    county_names_all: 'Hardy',
    county_weights: '{"54031": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 39.05694,
    longitude: -78.79374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26801',
  },
  {
    city: 'Brandywine',
    county_fips: 54071,
    county_fips_all: '54071',
    county: 'Pendleton',
    county_names_all: 'Pendleton',
    county_weights: '{"54071": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 38.64454,
    longitude: -79.18706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26802',
  },
  {
    city: 'Circleville',
    county_fips: 54071,
    county_fips_all: '54071',
    county: 'Pendleton',
    county_names_all: 'Pendleton',
    county_weights: '{"54071": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 38.63306,
    longitude: -79.54526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26804',
  },
  {
    city: 'Franklin',
    county_fips: 54071,
    county_fips_all: '54071',
    county: 'Pendleton',
    county_names_all: 'Pendleton',
    county_weights: '{"54071": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 38.62895,
    longitude: -79.36157,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26807',
  },
  {
    city: 'High View',
    county_fips: 54027,
    county_fips_all: '54027',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"54027": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 39.19563,
    longitude: -78.44416,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26808',
  },
  {
    city: 'Lost City',
    county_fips: 54031,
    county_fips_all: '54031',
    county: 'Hardy',
    county_names_all: 'Hardy',
    county_weights: '{"54031": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 38.97721,
    longitude: -78.74853,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26810',
  },
  {
    city: 'Mathias',
    county_fips: 54031,
    county_fips_all: '54031',
    county: 'Hardy',
    county_names_all: 'Hardy',
    county_weights: '{"54031": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 38.88184,
    longitude: -78.87688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26812',
  },
  {
    city: 'Riverton',
    county_fips: 54071,
    county_fips_all: '54071',
    county: 'Pendleton',
    county_names_all: 'Pendleton',
    county_weights: '{"54071": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 38.75176,
    longitude: -79.46648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26814',
  },
  {
    city: 'Sugar Grove',
    county_fips: 54071,
    county_fips_all: '54071',
    county: 'Pendleton',
    county_names_all: 'Pendleton',
    county_weights: '{"54071": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 38.48923,
    longitude: -79.35884,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26815',
  },
  {
    city: 'Bloomery',
    county_fips: 54027,
    county_fips_all: '54027',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"54027": 100}',
    density: 8,
    imprecise: false,
    latitude: 39.35957,
    longitude: -78.39067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26817',
  },
  {
    city: 'Fisher',
    county_fips: 54031,
    county_fips_all: '54031',
    county: 'Hardy',
    county_names_all: 'Hardy',
    county_weights: '{"54031": 100}',
    density: 23.5,
    imprecise: false,
    latitude: 39.07662,
    longitude: -79.02238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26818',
  },
  {
    city: 'Capon Springs',
    county_fips: 54027,
    county_fips_all: '54027',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"54027": 100}',
    density: 3,
    imprecise: false,
    latitude: 39.13033,
    longitude: -78.51139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26823',
  },
  {
    city: 'Maysville',
    county_fips: 54023,
    county_fips_all: '54023',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"54023": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 39.08119,
    longitude: -79.2083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26833',
  },
  {
    city: 'Moorefield',
    county_fips: 54031,
    county_fips_all: '54031',
    county: 'Hardy',
    county_names_all: 'Hardy',
    county_weights: '{"54031": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 39.00693,
    longitude: -78.96366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26836',
  },
  {
    city: 'Milam',
    county_fips: 54031,
    county_fips_all: '54031',
    county: 'Hardy',
    county_names_all: 'Hardy',
    county_weights: '{"54031": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.80492,
    longitude: -79.07237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26838',
  },
  {
    city: 'Old Fields',
    county_fips: 54031,
    county_fips_all: '54031',
    county: 'Hardy',
    county_names_all: 'Hardy',
    county_weights: '{"54031": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 39.16734,
    longitude: -78.96193,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26845',
  },
  {
    city: 'Petersburg',
    county_fips: 54023,
    county_fips_all: '54023|54031|54071',
    county: 'Grant',
    county_names_all: 'Grant|Hardy|Pendleton',
    county_weights: '{"54023": 96.82, "54031": 1.63, "54071": 1.55}',
    density: 15,
    imprecise: false,
    latitude: 38.95809,
    longitude: -79.15189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26847',
  },
  {
    city: 'Wardensville',
    county_fips: 54031,
    county_fips_all: '54031|54027',
    county: 'Hardy',
    county_names_all: 'Hardy|Hampshire',
    county_weights: '{"54031": 93.83, "54027": 6.17}',
    density: 7.1,
    imprecise: false,
    latitude: 39.04801,
    longitude: -78.62878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26851',
  },
  {
    city: 'Purgitsville',
    county_fips: 54027,
    county_fips_all: '54027|54031|54057',
    county: 'Hampshire',
    county_names_all: 'Hampshire|Hardy|Mineral',
    county_weights: '{"54027": 74.26, "54031": 14.2, "54057": 11.54}',
    density: 8.5,
    imprecise: false,
    latitude: 39.2477,
    longitude: -78.91599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26852',
  },
  {
    city: 'Cabins',
    county_fips: 54023,
    county_fips_all: '54023|54071',
    county: 'Grant',
    county_names_all: 'Grant|Pendleton',
    county_weights: '{"54023": 77.37, "54071": 22.63}',
    density: 13.9,
    imprecise: false,
    latitude: 38.96933,
    longitude: -79.25935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26855',
  },
  {
    city: 'Yellow Spring',
    county_fips: 54027,
    county_fips_all: '54027',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"54027": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 39.19053,
    longitude: -78.51932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26865',
  },
  {
    city: 'Upper Tract',
    county_fips: 54071,
    county_fips_all: '54071|54023',
    county: 'Pendleton',
    county_names_all: 'Pendleton|Grant',
    county_weights: '{"54071": 93.63, "54023": 6.37}',
    density: 4,
    imprecise: false,
    latitude: 38.80493,
    longitude: -79.2512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26866',
  },
  {
    city: 'Seneca Rocks',
    county_fips: 54071,
    county_fips_all: '54071',
    county: 'Pendleton',
    county_names_all: 'Pendleton',
    county_weights: '{"54071": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 38.84273,
    longitude: -79.40118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26884',
  },
  {
    city: 'Onego',
    county_fips: 54071,
    county_fips_all: '54071',
    county: 'Pendleton',
    county_names_all: 'Pendleton',
    county_weights: '{"54071": 100}',
    density: 2,
    imprecise: false,
    latitude: 38.88742,
    longitude: -79.40064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '26886',
  },
  {
    city: 'Advance',
    county_fips: 37059,
    county_fips_all: '37059',
    county: 'Davie',
    county_names_all: 'Davie',
    county_weights: '{"37059": 100}',
    density: 99.9,
    imprecise: false,
    latitude: 35.94352,
    longitude: -80.43673,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27006',
  },
  {
    city: 'Ararat',
    county_fips: 37171,
    county_fips_all: '37171',
    county: 'Surry',
    county_names_all: 'Surry',
    county_weights: '{"37171": 100}',
    density: 39.3,
    imprecise: false,
    latitude: 36.38799,
    longitude: -80.59144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27007',
  },
  {
    city: 'Belews Creek',
    county_fips: 37067,
    county_fips_all: '37067|37169',
    county: 'Forsyth',
    county_names_all: 'Forsyth|Stokes',
    county_weights: '{"37067": 90.74, "37169": 9.26}',
    density: 68.8,
    imprecise: false,
    latitude: 36.23089,
    longitude: -80.07927,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27009',
  },
  {
    city: 'Boonville',
    county_fips: 37197,
    county_fips_all: '37197',
    county: 'Yadkin',
    county_names_all: 'Yadkin',
    county_weights: '{"37197": 100}',
    density: 41.9,
    imprecise: false,
    latitude: 36.21649,
    longitude: -80.69728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27011',
  },
  {
    city: 'Clemmons',
    county_fips: 37067,
    county_fips_all: '37067|37057',
    county: 'Forsyth',
    county_names_all: 'Forsyth|Davidson',
    county_weights: '{"37067": 62.61, "37057": 37.39}',
    density: 280.8,
    imprecise: false,
    latitude: 36.00434,
    longitude: -80.37547,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27012',
  },
  {
    city: 'Cleveland',
    county_fips: 37159,
    county_fips_all: '37159|37097',
    county: 'Rowan',
    county_names_all: 'Rowan|Iredell',
    county_weights: '{"37159": 80.7, "37097": 19.3}',
    density: 33.7,
    imprecise: false,
    latitude: 35.75633,
    longitude: -80.70235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27013',
  },
  {
    city: 'Cooleemee',
    county_fips: 37059,
    county_fips_all: '37059',
    county: 'Davie',
    county_names_all: 'Davie',
    county_weights: '{"37059": 100}',
    density: 581.6,
    imprecise: false,
    latitude: 35.8121,
    longitude: -80.55508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27014',
  },
  {
    city: 'Danbury',
    county_fips: 37169,
    county_fips_all: '37169',
    county: 'Stokes',
    county_names_all: 'Stokes',
    county_weights: '{"37169": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 36.44318,
    longitude: -80.2219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27016',
  },
  {
    city: 'Dobson',
    county_fips: 37171,
    county_fips_all: '37171',
    county: 'Surry',
    county_names_all: 'Surry',
    county_weights: '{"37171": 100}',
    density: 35.9,
    imprecise: false,
    latitude: 36.38141,
    longitude: -80.76052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27017',
  },
  {
    city: 'East Bend',
    county_fips: 37197,
    county_fips_all: '37197',
    county: 'Yadkin',
    county_names_all: 'Yadkin',
    county_weights: '{"37197": 100}',
    density: 34.7,
    imprecise: false,
    latitude: 36.1978,
    longitude: -80.52096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27018',
  },
  {
    city: 'Germanton',
    county_fips: 37169,
    county_fips_all: '37169|37067',
    county: 'Stokes',
    county_names_all: 'Stokes|Forsyth',
    county_weights: '{"37169": 68.23, "37067": 31.77}',
    density: 38.3,
    imprecise: false,
    latitude: 36.28604,
    longitude: -80.23548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27019',
  },
  {
    city: 'Hamptonville',
    county_fips: 37197,
    county_fips_all: '37197|37097|37193',
    county: 'Yadkin',
    county_names_all: 'Yadkin|Iredell|Wilkes',
    county_weights: '{"37197": 78.34, "37097": 13.92, "37193": 7.74}',
    density: 31.5,
    imprecise: false,
    latitude: 36.1047,
    longitude: -80.81272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27020',
  },
  {
    city: 'King',
    county_fips: 37169,
    county_fips_all: '37169|37067',
    county: 'Stokes',
    county_names_all: 'Stokes|Forsyth',
    county_weights: '{"37169": 99.31, "37067": 0.69}',
    density: 122.9,
    imprecise: false,
    latitude: 36.31859,
    longitude: -80.3386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27021',
  },
  {
    city: 'Lawsonville',
    county_fips: 37169,
    county_fips_all: '37169',
    county: 'Stokes',
    county_names_all: 'Stokes',
    county_weights: '{"37169": 100}',
    density: 15,
    imprecise: false,
    latitude: 36.51409,
    longitude: -80.21739,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27022',
  },
  {
    city: 'Lewisville',
    county_fips: 37067,
    county_fips_all: '37067',
    county: 'Forsyth',
    county_names_all: 'Forsyth',
    county_weights: '{"37067": 100}',
    density: 200.5,
    imprecise: false,
    latitude: 36.09103,
    longitude: -80.45101,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27023',
  },
  {
    city: 'Lowgap',
    county_fips: 37171,
    county_fips_all: '37171',
    county: 'Surry',
    county_names_all: 'Surry',
    county_weights: '{"37171": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 36.52399,
    longitude: -80.84027,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27024',
  },
  {
    city: 'Madison',
    county_fips: 37157,
    county_fips_all: '37157|37169',
    county: 'Rockingham',
    county_names_all: 'Rockingham|Stokes',
    county_weights: '{"37157": 71.89, "37169": 28.11}',
    density: 49.5,
    imprecise: false,
    latitude: 36.3771,
    longitude: -79.97148,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27025',
  },
  {
    city: 'Mayodan',
    county_fips: 37157,
    county_fips_all: '37157',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"37157": 100}',
    density: 70,
    imprecise: false,
    latitude: 36.4456,
    longitude: -79.98883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27027',
  },
  {
    city: 'Mocksville',
    county_fips: 37059,
    county_fips_all: '37059|37097',
    county: 'Davie',
    county_names_all: 'Davie|Iredell',
    county_weights: '{"37059": 99.38, "37097": 0.62}',
    density: 53.2,
    imprecise: false,
    latitude: 35.92433,
    longitude: -80.5742,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27028',
  },
  {
    city: 'Mount Airy',
    county_fips: 37171,
    county_fips_all: '37171|37169',
    county: 'Surry',
    county_names_all: 'Surry|Stokes',
    county_weights: '{"37171": 95.73, "37169": 4.27}',
    density: 82.1,
    imprecise: false,
    latitude: 36.48836,
    longitude: -80.63013,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27030',
  },
  {
    city: 'Pfafftown',
    county_fips: 37067,
    county_fips_all: '37067',
    county: 'Forsyth',
    county_names_all: 'Forsyth',
    county_weights: '{"37067": 100}',
    density: 185.3,
    imprecise: false,
    latitude: 36.16869,
    longitude: -80.38969,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27040',
  },
  {
    city: 'Pilot Mountain',
    county_fips: 37171,
    county_fips_all: '37171|37169',
    county: 'Surry',
    county_names_all: 'Surry|Stokes',
    county_weights: '{"37171": 81.38, "37169": 18.62}',
    density: 53.1,
    imprecise: false,
    latitude: 36.41539,
    longitude: -80.48465,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27041',
  },
  {
    city: 'Pine Hall',
    county_fips: 37169,
    county_fips_all: '37169',
    county: 'Stokes',
    county_names_all: 'Stokes',
    county_weights: '{"37169": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 36.34177,
    longitude: -80.05434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27042',
  },
  {
    city: 'Pinnacle',
    county_fips: 37169,
    county_fips_all: '37169|37171|37067',
    county: 'Stokes',
    county_names_all: 'Stokes|Surry|Forsyth',
    county_weights: '{"37169": 52.27, "37171": 47.09, "37067": 0.64}',
    density: 35.5,
    imprecise: false,
    latitude: 36.33709,
    longitude: -80.44917,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27043',
  },
  {
    city: 'Rural Hall',
    county_fips: 37067,
    county_fips_all: '37067|37169',
    county: 'Forsyth',
    county_names_all: 'Forsyth|Stokes',
    county_weights: '{"37067": 91.48, "37169": 8.52}',
    density: 179.5,
    imprecise: false,
    latitude: 36.23482,
    longitude: -80.29614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27045',
  },
  {
    city: 'Sandy Ridge',
    county_fips: 37169,
    county_fips_all: '37169',
    county: 'Stokes',
    county_names_all: 'Stokes',
    county_weights: '{"37169": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 36.49228,
    longitude: -80.09223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27046',
  },
  {
    city: 'Siloam',
    county_fips: 37171,
    county_fips_all: '37171',
    county: 'Surry',
    county_names_all: 'Surry',
    county_weights: '{"37171": 100}',
    density: 23.5,
    imprecise: false,
    latitude: 36.31178,
    longitude: -80.57786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27047',
  },
  {
    city: 'Stoneville',
    county_fips: 37157,
    county_fips_all: '37157|51089',
    county: 'Rockingham',
    county_names_all: 'Rockingham|Henry',
    county_weights: '{"37157": 98.59, "51089": 1.41}',
    density: 36.2,
    imprecise: false,
    latitude: 36.47611,
    longitude: -79.91295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27048',
  },
  {
    city: 'Tobaccoville',
    county_fips: 37067,
    county_fips_all: '37067|37169',
    county: 'Forsyth',
    county_names_all: 'Forsyth|Stokes',
    county_weights: '{"37067": 87.0, "37169": 13.0}',
    density: 59,
    imprecise: false,
    latitude: 36.23608,
    longitude: -80.40116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27050',
  },
  {
    city: 'Walkertown',
    county_fips: 37067,
    county_fips_all: '37067',
    county: 'Forsyth',
    county_names_all: 'Forsyth',
    county_weights: '{"37067": 100}',
    density: 166,
    imprecise: false,
    latitude: 36.18728,
    longitude: -80.16012,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27051',
  },
  {
    city: 'Walnut Cove',
    county_fips: 37169,
    county_fips_all: '37169|37067',
    county: 'Stokes',
    county_names_all: 'Stokes|Forsyth',
    county_weights: '{"37169": 89.04, "37067": 10.96}',
    density: 41,
    imprecise: false,
    latitude: 36.32259,
    longitude: -80.14552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27052',
  },
  {
    city: 'Westfield',
    county_fips: 37169,
    county_fips_all: '37169|37171',
    county: 'Stokes',
    county_names_all: 'Stokes|Surry',
    county_weights: '{"37169": 96.53, "37171": 3.47}',
    density: 17,
    imprecise: false,
    latitude: 36.47317,
    longitude: -80.34989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27053',
  },
  {
    city: 'Woodleaf',
    county_fips: 37159,
    county_fips_all: '37159',
    county: 'Rowan',
    county_names_all: 'Rowan',
    county_weights: '{"37159": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 35.79304,
    longitude: -80.59833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27054',
  },
  {
    city: 'Yadkinville',
    county_fips: 37197,
    county_fips_all: '37197|37059|37097',
    county: 'Yadkin',
    county_names_all: 'Yadkin|Davie|Iredell',
    county_weights: '{"37197": 96.96, "37059": 1.73, "37097": 1.31}',
    density: 50.9,
    imprecise: false,
    latitude: 36.11382,
    longitude: -80.63586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27055',
  },
  {
    city: 'Winston Salem',
    county_fips: 37067,
    county_fips_all: '37067',
    county: 'Forsyth',
    county_names_all: 'Forsyth',
    county_weights: '{"37067": 100}',
    density: 710.8,
    imprecise: false,
    latitude: 36.11204,
    longitude: -80.19889,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27101',
  },
  {
    city: 'Winston Salem',
    county_fips: 37067,
    county_fips_all: '37067',
    county: 'Forsyth',
    county_names_all: 'Forsyth',
    county_weights: '{"37067": 100}',
    density: 691.1,
    imprecise: false,
    latitude: 36.05822,
    longitude: -80.32125,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27103',
  },
  {
    city: 'Winston Salem',
    county_fips: 37067,
    county_fips_all: '37067',
    county: 'Forsyth',
    county_names_all: 'Forsyth',
    county_weights: '{"37067": 100}',
    density: 990.8,
    imprecise: false,
    latitude: 36.09465,
    longitude: -80.32501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27104',
  },
  {
    city: 'Winston Salem',
    county_fips: 37067,
    county_fips_all: '37067',
    county: 'Forsyth',
    county_names_all: 'Forsyth',
    county_weights: '{"37067": 100}',
    density: 465.7,
    imprecise: false,
    latitude: 36.16294,
    longitude: -80.23521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27105',
  },
  {
    city: 'Winston Salem',
    county_fips: 37067,
    county_fips_all: '37067',
    county: 'Forsyth',
    county_names_all: 'Forsyth',
    county_weights: '{"37067": 100}',
    density: 673.6,
    imprecise: false,
    latitude: 36.14255,
    longitude: -80.3228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27106',
  },
  {
    city: 'Winston Salem',
    county_fips: 37057,
    county_fips_all: '37057|37067',
    county: 'Davidson',
    county_names_all: 'Davidson|Forsyth',
    county_weights: '{"37057": 52.5, "37067": 47.5}',
    density: 296.2,
    imprecise: false,
    latitude: 36.01488,
    longitude: -80.17819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27107',
  },
  {
    city: 'Winston Salem',
    county_fips: 37067,
    county_fips_all: '37067|37057',
    county: 'Forsyth',
    county_names_all: 'Forsyth|Davidson',
    county_weights: '{"37067": 81.55, "37057": 18.45}',
    density: 545,
    imprecise: false,
    latitude: 36.02028,
    longitude: -80.27847,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27127',
  },
  {
    city: 'Alamance',
    county_fips: 37001,
    county_fips_all: '37001',
    county: 'Alamance',
    county_names_all: 'Alamance',
    county_weights: '{"37001": 100}',
    density: 245.6,
    imprecise: false,
    latitude: 36.03258,
    longitude: -79.48418,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27201',
  },
  {
    city: 'Altamahaw',
    county_fips: 37001,
    county_fips_all: '37001',
    county: 'Alamance',
    county_names_all: 'Alamance',
    county_weights: '{"37001": 100}',
    density: 2922.3,
    imprecise: false,
    latitude: 36.18565,
    longitude: -79.50594,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27202',
  },
  {
    city: 'Asheboro',
    county_fips: 37151,
    county_fips_all: '37151',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"37151": 100}',
    density: 398.7,
    imprecise: false,
    latitude: 35.73253,
    longitude: -79.78857,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27203',
  },
  {
    city: 'Asheboro',
    county_fips: 37151,
    county_fips_all: '37151',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"37151": 100}',
    density: 63.8,
    imprecise: false,
    latitude: 35.6399,
    longitude: -79.85094,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27205',
  },
  {
    city: 'Bear Creek',
    county_fips: 37037,
    county_fips_all: '37037',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"37037": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 35.6064,
    longitude: -79.38893,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27207',
  },
  {
    city: 'Bennett',
    county_fips: 37037,
    county_fips_all: '37037|37151|37125',
    county: 'Chatham',
    county_names_all: 'Chatham|Randolph|Moore',
    county_weights: '{"37037": 52.95, "37151": 38.65, "37125": 8.4}',
    density: 18.7,
    imprecise: false,
    latitude: 35.56246,
    longitude: -79.54231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27208',
  },
  {
    city: 'Biscoe',
    county_fips: 37123,
    county_fips_all: '37123|37125',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Moore',
    county_weights: '{"37123": 68.46, "37125": 31.54}',
    density: 32.3,
    imprecise: false,
    latitude: 35.34254,
    longitude: -79.74936,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27209',
  },
  {
    city: 'Blanch',
    county_fips: 37033,
    county_fips_all: '37033',
    county: 'Caswell',
    county_names_all: 'Caswell',
    county_weights: '{"37033": 100}',
    density: 15,
    imprecise: false,
    latitude: 36.46207,
    longitude: -79.27976,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27212',
  },
  {
    city: 'Bonlee',
    county_fips: 37037,
    county_fips_all: '37037',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"37037": 100}',
    density: 37,
    imprecise: false,
    latitude: 35.6473,
    longitude: -79.40454,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27213',
  },
  {
    city: 'Browns Summit',
    county_fips: 37081,
    county_fips_all: '37081|37157',
    county: 'Guilford',
    county_names_all: 'Guilford|Rockingham',
    county_weights: '{"37081": 89.07, "37157": 10.93}',
    density: 111.2,
    imprecise: false,
    latitude: 36.21407,
    longitude: -79.68283,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27214',
  },
  {
    city: 'Burlington',
    county_fips: 37001,
    county_fips_all: '37001|37081',
    county: 'Alamance',
    county_names_all: 'Alamance|Guilford',
    county_weights: '{"37001": 88.5, "37081": 11.5}',
    density: 288.3,
    imprecise: false,
    latitude: 36.03055,
    longitude: -79.48729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27215',
  },
  {
    city: 'Burlington',
    county_fips: 37001,
    county_fips_all: '37001|37033',
    county: 'Alamance',
    county_names_all: 'Alamance|Caswell',
    county_weights: '{"37001": 82.77, "37033": 17.23}',
    density: 129.8,
    imprecise: false,
    latitude: 36.19221,
    longitude: -79.38404,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27217',
  },
  {
    city: 'Candor',
    county_fips: 37123,
    county_fips_all: '37123|37153',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Richmond',
    county_weights: '{"37123": 97.25, "37153": 2.75}',
    density: 14.7,
    imprecise: false,
    latitude: 35.24853,
    longitude: -79.79873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27229',
  },
  {
    city: 'Cedar Grove',
    county_fips: 37135,
    county_fips_all: '37135|37033|37145',
    county: 'Orange',
    county_names_all: 'Orange|Caswell|Person',
    county_weights: '{"37135": 97.23, "37033": 1.65, "37145": 1.12}',
    density: 25.7,
    imprecise: false,
    latitude: 36.20455,
    longitude: -79.17268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27231',
  },
  {
    city: 'Climax',
    county_fips: 37151,
    county_fips_all: '37151|37081',
    county: 'Randolph',
    county_names_all: 'Randolph|Guilford',
    county_weights: '{"37151": 66.48, "37081": 33.52}',
    density: 50.3,
    imprecise: false,
    latitude: 35.8882,
    longitude: -79.6988,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27233',
  },
  {
    city: 'Colfax',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 152,
    imprecise: false,
    latitude: 36.09734,
    longitude: -80.00871,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27235',
  },
  {
    city: 'Denton',
    county_fips: 37057,
    county_fips_all: '37057|37151',
    county: 'Davidson',
    county_names_all: 'Davidson|Randolph',
    county_weights: '{"37057": 60.4, "37151": 39.6}',
    density: 19.7,
    imprecise: false,
    latitude: 35.60566,
    longitude: -80.09024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27239',
  },
  {
    city: 'Eagle Springs',
    county_fips: 37125,
    county_fips_all: '37125',
    county: 'Moore',
    county_names_all: 'Moore',
    county_weights: '{"37125": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 35.33645,
    longitude: -79.63761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27242',
  },
  {
    city: 'Efland',
    county_fips: 37135,
    county_fips_all: '37135',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"37135": 100}',
    density: 54.4,
    imprecise: false,
    latitude: 36.07821,
    longitude: -79.1945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27243',
  },
  {
    city: 'Elon',
    county_fips: 37001,
    county_fips_all: '37001|37033|37081',
    county: 'Alamance',
    county_names_all: 'Alamance|Caswell|Guilford',
    county_weights: '{"37001": 47.03, "37033": 41.59, "37081": 11.37}',
    density: 117.2,
    imprecise: false,
    latitude: 36.21402,
    longitude: -79.48747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27244',
  },
  {
    city: 'Ether',
    county_fips: 37123,
    county_fips_all: '37123',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"37123": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 35.46096,
    longitude: -79.78784,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27247',
  },
  {
    city: 'Franklinville',
    county_fips: 37151,
    county_fips_all: '37151',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"37151": 100}',
    density: 47.5,
    imprecise: false,
    latitude: 35.78916,
    longitude: -79.70953,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27248',
  },
  {
    city: 'Gibsonville',
    county_fips: 37081,
    county_fips_all: '37081|37001|37157|37033',
    county: 'Guilford',
    county_names_all: 'Guilford|Alamance|Rockingham|Caswell',
    county_weights:
      '{"37081": 79.77, "37001": 8.89, "37157": 8.28, "37033": 3.06}',
    density: 88.7,
    imprecise: false,
    latitude: 36.16014,
    longitude: -79.58134,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27249',
  },
  {
    city: 'Goldston',
    county_fips: 37037,
    county_fips_all: '37037',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"37037": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 35.56033,
    longitude: -79.35563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27252',
  },
  {
    city: 'Graham',
    county_fips: 37001,
    county_fips_all: '37001',
    county: 'Alamance',
    county_names_all: 'Alamance',
    county_weights: '{"37001": 100}',
    density: 156.1,
    imprecise: false,
    latitude: 35.96239,
    longitude: -79.34581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27253',
  },
  {
    city: 'Gulf',
    county_fips: 37037,
    county_fips_all: '37037',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"37037": 100}',
    density: 22.2,
    imprecise: false,
    latitude: 35.56058,
    longitude: -79.2725,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27256',
  },
  {
    city: 'Haw River',
    county_fips: 37001,
    county_fips_all: '37001',
    county: 'Alamance',
    county_names_all: 'Alamance',
    county_weights: '{"37001": 100}',
    density: 131.5,
    imprecise: false,
    latitude: 36.03401,
    longitude: -79.32623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27258',
  },
  {
    city: 'Highfalls',
    county_fips: 37125,
    county_fips_all: '37125',
    county: 'Moore',
    county_names_all: 'Moore',
    county_weights: '{"37125": 100}',
    density: 4,
    imprecise: false,
    latitude: 35.49149,
    longitude: -79.52624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27259',
  },
  {
    city: 'High Point',
    county_fips: 37081,
    county_fips_all: '37081|37151',
    county: 'Guilford',
    county_names_all: 'Guilford|Randolph',
    county_weights: '{"37081": 96.49, "37151": 3.51}',
    density: 789.2,
    imprecise: false,
    latitude: 35.95473,
    longitude: -79.98697,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27260',
  },
  {
    city: 'High Point',
    county_fips: 37081,
    county_fips_all: '37081|37057|37151',
    county: 'Guilford',
    county_names_all: 'Guilford|Davidson|Randolph',
    county_weights: '{"37081": 66.52, "37057": 32.84, "37151": 0.64}',
    density: 829.9,
    imprecise: false,
    latitude: 35.96191,
    longitude: -80.03845,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27262',
  },
  {
    city: 'High Point',
    county_fips: 37151,
    county_fips_all: '37151|37081',
    county: 'Randolph',
    county_names_all: 'Randolph|Guilford',
    county_weights: '{"37151": 61.04, "37081": 38.96}',
    density: 212.1,
    imprecise: false,
    latitude: 35.90931,
    longitude: -79.93829,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27263',
  },
  {
    city: 'High Point',
    county_fips: 37081,
    county_fips_all: '37081|37057|37067',
    county: 'Guilford',
    county_names_all: 'Guilford|Davidson|Forsyth',
    county_weights: '{"37081": 59.39, "37057": 37.66, "37067": 2.95}',
    density: 454,
    imprecise: false,
    latitude: 36.00947,
    longitude: -80.03272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27265',
  },
  {
    city: 'Hillsborough',
    county_fips: 37135,
    county_fips_all: '37135|37063',
    county: 'Orange',
    county_names_all: 'Orange|Durham',
    county_weights: '{"37135": 95.99, "37063": 4.01}',
    density: 104,
    imprecise: false,
    latitude: 36.08673,
    longitude: -79.08778,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27278',
  },
  {
    city: 'Jackson Springs',
    county_fips: 37125,
    county_fips_all: '37125|37123|37153',
    county: 'Moore',
    county_names_all: 'Moore|Montgomery|Richmond',
    county_weights: '{"37125": 58.76, "37123": 28.99, "37153": 12.25}',
    density: 21.8,
    imprecise: false,
    latitude: 35.18538,
    longitude: -79.62689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27281',
  },
  {
    city: 'Jamestown',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 417.8,
    imprecise: false,
    latitude: 35.99656,
    longitude: -79.92869,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27282',
  },
  {
    city: 'Julian',
    county_fips: 37081,
    county_fips_all: '37081|37151',
    county: 'Guilford',
    county_names_all: 'Guilford|Randolph',
    county_weights: '{"37081": 98.54, "37151": 1.46}',
    density: 50.4,
    imprecise: false,
    latitude: 35.95293,
    longitude: -79.63621,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27283',
  },
  {
    city: 'Kernersville',
    county_fips: 37067,
    county_fips_all: '37067|37081|37057',
    county: 'Forsyth',
    county_names_all: 'Forsyth|Guilford|Davidson',
    county_weights: '{"37067": 82.89, "37081": 14.39, "37057": 2.72}',
    density: 284.5,
    imprecise: false,
    latitude: 36.11818,
    longitude: -80.07794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27284',
  },
  {
    city: 'Eden',
    county_fips: 37157,
    county_fips_all: '37157',
    county: 'Rockingham',
    county_names_all: 'Rockingham',
    county_weights: '{"37157": 100}',
    density: 123.9,
    imprecise: false,
    latitude: 36.49812,
    longitude: -79.74587,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27288',
  },
  {
    city: 'Leasburg',
    county_fips: 37033,
    county_fips_all: '37033|37145',
    county: 'Caswell',
    county_names_all: 'Caswell|Person',
    county_weights: '{"37033": 68.4, "37145": 31.6}',
    density: 12.7,
    imprecise: false,
    latitude: 36.40173,
    longitude: -79.16679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27291',
  },
  {
    city: 'Lexington',
    county_fips: 37057,
    county_fips_all: '37057|37151',
    county: 'Davidson',
    county_names_all: 'Davidson|Randolph',
    county_weights: '{"37057": 99.36, "37151": 0.64}',
    density: 108.1,
    imprecise: false,
    latitude: 35.73469,
    longitude: -80.20845,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27292',
  },
  {
    city: 'Lexington',
    county_fips: 37057,
    county_fips_all: '37057',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"37057": 100}',
    density: 118.8,
    imprecise: false,
    latitude: 35.86756,
    longitude: -80.31623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27295',
  },
  {
    city: 'Liberty',
    county_fips: 37151,
    county_fips_all: '37151|37001|37081|37037',
    county: 'Randolph',
    county_names_all: 'Randolph|Alamance|Guilford|Chatham',
    county_weights:
      '{"37151": 44.39, "37001": 30.87, "37081": 23.74, "37037": 1.0}',
    density: 41.1,
    imprecise: false,
    latitude: 35.88563,
    longitude: -79.56816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27298',
  },
  {
    city: 'Linwood',
    county_fips: 37057,
    county_fips_all: '37057',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"37057": 100}',
    density: 70.7,
    imprecise: false,
    latitude: 35.75131,
    longitude: -80.38402,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27299',
  },
  {
    city: 'McLeansville',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 128.4,
    imprecise: false,
    latitude: 36.11512,
    longitude: -79.66755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27301',
  },
  {
    city: 'Mebane',
    county_fips: 37001,
    county_fips_all: '37001|37135|37033',
    county: 'Alamance',
    county_names_all: 'Alamance|Orange|Caswell',
    county_weights: '{"37001": 40.99, "37135": 36.01, "37033": 23.0}',
    density: 119.2,
    imprecise: false,
    latitude: 36.13749,
    longitude: -79.2647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27302',
  },
  {
    city: 'Milton',
    county_fips: 37033,
    county_fips_all: '37033|37145',
    county: 'Caswell',
    county_names_all: 'Caswell|Person',
    county_weights: '{"37033": 97.49, "37145": 2.51}',
    density: 21.1,
    imprecise: false,
    latitude: 36.52029,
    longitude: -79.22553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27305',
  },
  {
    city: 'Mount Gilead',
    county_fips: 37123,
    county_fips_all: '37123|37153',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Richmond',
    county_weights: '{"37123": 77.29, "37153": 22.71}',
    density: 11.5,
    imprecise: false,
    latitude: 35.22098,
    longitude: -79.97685,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27306',
  },
  {
    city: 'Oak Ridge',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 185.6,
    imprecise: false,
    latitude: 36.17294,
    longitude: -79.99159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27310',
  },
  {
    city: 'Pelham',
    county_fips: 37033,
    county_fips_all: '37033|37157',
    county: 'Caswell',
    county_names_all: 'Caswell|Rockingham',
    county_weights: '{"37033": 81.88, "37157": 18.12}',
    density: 30.2,
    imprecise: false,
    latitude: 36.48137,
    longitude: -79.47577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27311',
  },
  {
    city: 'Pittsboro',
    county_fips: 37037,
    county_fips_all: '37037|37001',
    county: 'Chatham',
    county_names_all: 'Chatham|Alamance',
    county_weights: '{"37037": 99.37, "37001": 0.63}',
    density: 52.7,
    imprecise: false,
    latitude: 35.75446,
    longitude: -79.19648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27312',
  },
  {
    city: 'Pleasant Garden',
    county_fips: 37081,
    county_fips_all: '37081|37151',
    county: 'Guilford',
    county_names_all: 'Guilford|Randolph',
    county_weights: '{"37081": 69.83, "37151": 30.17}',
    density: 107.5,
    imprecise: false,
    latitude: 35.92892,
    longitude: -79.75142,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27313',
  },
  {
    city: 'Prospect Hill',
    county_fips: 37033,
    county_fips_all: '37033',
    county: 'Caswell',
    county_names_all: 'Caswell',
    county_weights: '{"37033": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 36.29072,
    longitude: -79.18594,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27314',
  },
  {
    city: 'Providence',
    county_fips: 37033,
    county_fips_all: '37033',
    county: 'Caswell',
    county_names_all: 'Caswell',
    county_weights: '{"37033": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 36.50613,
    longitude: -79.39173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27315',
  },
  {
    city: 'Ramseur',
    county_fips: 37151,
    county_fips_all: '37151',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"37151": 100}',
    density: 40.4,
    imprecise: false,
    latitude: 35.68996,
    longitude: -79.62366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27316',
  },
  {
    city: 'Randleman',
    county_fips: 37151,
    county_fips_all: '37151|37081',
    county: 'Randolph',
    county_names_all: 'Randolph|Guilford',
    county_weights: '{"37151": 95.15, "37081": 4.85}',
    density: 127.5,
    imprecise: false,
    latitude: 35.83809,
    longitude: -79.80376,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27317',
  },
  {
    city: 'Reidsville',
    county_fips: 37157,
    county_fips_all: '37157|37033|37081',
    county: 'Rockingham',
    county_names_all: 'Rockingham|Caswell|Guilford',
    county_weights: '{"37157": 87.72, "37033": 12.03, "37081": 0.25}',
    density: 61.3,
    imprecise: false,
    latitude: 36.3434,
    longitude: -79.6599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27320',
  },
  {
    city: 'Robbins',
    county_fips: 37125,
    county_fips_all: '37125|37151',
    county: 'Moore',
    county_names_all: 'Moore|Randolph',
    county_weights: '{"37125": 98.84, "37151": 1.16}',
    density: 31.5,
    imprecise: false,
    latitude: 35.46236,
    longitude: -79.57249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27325',
  },
  {
    city: 'Ruffin',
    county_fips: 37157,
    county_fips_all: '37157|37033',
    county: 'Rockingham',
    county_names_all: 'Rockingham|Caswell',
    county_weights: '{"37157": 68.8, "37033": 31.2}',
    density: 20.2,
    imprecise: false,
    latitude: 36.45542,
    longitude: -79.55867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27326',
  },
  {
    city: 'Sanford',
    county_fips: 37105,
    county_fips_all: '37105|37037|37125|37085',
    county: 'Lee',
    county_names_all: 'Lee|Chatham|Moore|Harnett',
    county_weights:
      '{"37105": 83.36, "37037": 8.42, "37125": 6.12, "37085": 2.1}',
    density: 72.9,
    imprecise: false,
    latitude: 35.51624,
    longitude: -79.18394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27330',
  },
  {
    city: 'Sanford',
    county_fips: 37105,
    county_fips_all: '37105|37085',
    county: 'Lee',
    county_names_all: 'Lee|Harnett',
    county_weights: '{"37105": 64.17, "37085": 35.83}',
    density: 133.2,
    imprecise: false,
    latitude: 35.37836,
    longitude: -79.13599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27332',
  },
  {
    city: 'Saxapahaw',
    county_fips: 37001,
    county_fips_all: '37001',
    county: 'Alamance',
    county_names_all: 'Alamance',
    county_weights: '{"37001": 100}',
    density: 52.2,
    imprecise: false,
    latitude: 35.94557,
    longitude: -79.31141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27340',
  },
  {
    city: 'Seagrove',
    county_fips: 37151,
    county_fips_all: '37151|37125|37123',
    county: 'Randolph',
    county_names_all: 'Randolph|Moore|Montgomery',
    county_weights: '{"37151": 63.49, "37125": 28.68, "37123": 7.83}',
    density: 21.6,
    imprecise: false,
    latitude: 35.52467,
    longitude: -79.70014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27341',
  },
  {
    city: 'Sedalia',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 168,
    imprecise: false,
    latitude: 36.06641,
    longitude: -79.6186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27342',
  },
  {
    city: 'Semora',
    county_fips: 37145,
    county_fips_all: '37145|37033',
    county: 'Person',
    county_names_all: 'Person|Caswell',
    county_weights: '{"37145": 77.45, "37033": 22.55}',
    density: 10.2,
    imprecise: false,
    latitude: 36.50229,
    longitude: -79.08892,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27343',
  },
  {
    city: 'Siler City',
    county_fips: 37037,
    county_fips_all: '37037|37151',
    county: 'Chatham',
    county_names_all: 'Chatham|Randolph',
    county_weights: '{"37037": 94.94, "37151": 5.06}',
    density: 44.6,
    imprecise: false,
    latitude: 35.7289,
    longitude: -79.43366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27344',
  },
  {
    city: 'Snow Camp',
    county_fips: 37001,
    county_fips_all: '37001|37037',
    county: 'Alamance',
    county_names_all: 'Alamance|Chatham',
    county_weights: '{"37001": 91.34, "37037": 8.66}',
    density: 42.8,
    imprecise: false,
    latitude: 35.89845,
    longitude: -79.41202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27349',
  },
  {
    city: 'Sophia',
    county_fips: 37151,
    county_fips_all: '37151',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"37151": 100}',
    density: 62.4,
    imprecise: false,
    latitude: 35.80631,
    longitude: -79.88917,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27350',
  },
  {
    city: 'Southmont',
    county_fips: 37057,
    county_fips_all: '37057',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"37057": 100}',
    density: 277,
    imprecise: false,
    latitude: 35.65976,
    longitude: -80.26786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27351',
  },
  {
    city: 'Staley',
    county_fips: 37151,
    county_fips_all: '37151|37037',
    county: 'Randolph',
    county_names_all: 'Randolph|Chatham',
    county_weights: '{"37151": 68.49, "37037": 31.51}',
    density: 25.6,
    imprecise: false,
    latitude: 35.78859,
    longitude: -79.5678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27355',
  },
  {
    city: 'Star',
    county_fips: 37123,
    county_fips_all: '37123|37125',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Moore',
    county_weights: '{"37123": 78.79, "37125": 21.21}',
    density: 21.8,
    imprecise: false,
    latitude: 35.43991,
    longitude: -79.7982,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27356',
  },
  {
    city: 'Stokesdale',
    county_fips: 37157,
    county_fips_all: '37157|37081|37169',
    county: 'Rockingham',
    county_names_all: 'Rockingham|Guilford|Stokes',
    county_weights: '{"37157": 63.45, "37081": 36.42, "37169": 0.13}',
    density: 89.8,
    imprecise: false,
    latitude: 36.26844,
    longitude: -79.97641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27357',
  },
  {
    city: 'Summerfield',
    county_fips: 37081,
    county_fips_all: '37081|37157',
    county: 'Guilford',
    county_names_all: 'Guilford|Rockingham',
    county_weights: '{"37081": 70.99, "37157": 29.01}',
    density: 114.8,
    imprecise: false,
    latitude: 36.22723,
    longitude: -79.88124,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27358',
  },
  {
    city: 'Thomasville',
    county_fips: 37057,
    county_fips_all: '37057|37151',
    county: 'Davidson',
    county_names_all: 'Davidson|Randolph',
    county_weights: '{"37057": 87.83, "37151": 12.17}',
    density: 216.1,
    imprecise: false,
    latitude: 35.85684,
    longitude: -80.09987,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27360',
  },
  {
    city: 'Trinity',
    county_fips: 37151,
    county_fips_all: '37151',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"37151": 100}',
    density: 96.9,
    imprecise: false,
    latitude: 35.8116,
    longitude: -79.99133,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27370',
  },
  {
    city: 'Troy',
    county_fips: 37123,
    county_fips_all: '37123|37151',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Randolph',
    county_weights: '{"37123": 92.37, "37151": 7.63}',
    density: 20.4,
    imprecise: false,
    latitude: 35.42489,
    longitude: -79.94912,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27371',
  },
  {
    city: 'Welcome',
    county_fips: 37057,
    county_fips_all: '37057',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"37057": 100}',
    density: 63.2,
    imprecise: false,
    latitude: 35.91752,
    longitude: -80.25777,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27374',
  },
  {
    city: 'West End',
    county_fips: 37125,
    county_fips_all: '37125',
    county: 'Moore',
    county_names_all: 'Moore',
    county_weights: '{"37125": 100}',
    density: 52.5,
    imprecise: false,
    latitude: 35.25607,
    longitude: -79.53184,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27376',
  },
  {
    city: 'Whitsett',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 163.3,
    imprecise: false,
    latitude: 36.03728,
    longitude: -79.60221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27377',
  },
  {
    city: 'Yanceyville',
    county_fips: 37033,
    county_fips_all: '37033',
    county: 'Caswell',
    county_names_all: 'Caswell',
    county_weights: '{"37033": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 36.37653,
    longitude: -79.34653,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27379',
  },
  {
    city: 'Greensboro',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 1460.9,
    imprecise: false,
    latitude: 36.06995,
    longitude: -79.76724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27401',
  },
  {
    city: 'Greensboro',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 1511.2,
    imprecise: false,
    latitude: 36.06406,
    longitude: -79.82538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27403',
  },
  {
    city: 'Greensboro',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 668.3,
    imprecise: false,
    latitude: 36.11373,
    longitude: -79.73463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27405',
  },
  {
    city: 'Greensboro',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 337.6,
    imprecise: false,
    latitude: 35.9982,
    longitude: -79.76686,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27406',
  },
  {
    city: 'Greensboro',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 677.9,
    imprecise: false,
    latitude: 36.01124,
    longitude: -79.87588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27407',
  },
  {
    city: 'Greensboro',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 829.6,
    imprecise: false,
    latitude: 36.10321,
    longitude: -79.81411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27408',
  },
  {
    city: 'Greensboro',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 340.3,
    imprecise: false,
    latitude: 36.09242,
    longitude: -79.94431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27409',
  },
  {
    city: 'Greensboro',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 665.4,
    imprecise: false,
    latitude: 36.11826,
    longitude: -79.89223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27410',
  },
  {
    city: 'Greensboro',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 393.9,
    imprecise: false,
    latitude: 36.18283,
    longitude: -79.80794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27455',
  },
  {
    city: 'Angier',
    county_fips: 37085,
    county_fips_all: '37085|37101|37183',
    county: 'Harnett',
    county_names_all: 'Harnett|Johnston|Wake',
    county_weights: '{"37085": 61.85, "37101": 37.33, "37183": 0.82}',
    density: 152.4,
    imprecise: false,
    latitude: 35.48684,
    longitude: -78.68419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27501',
  },
  {
    city: 'Apex',
    county_fips: 37183,
    county_fips_all: '37183|37037',
    county: 'Wake',
    county_names_all: 'Wake|Chatham',
    county_weights: '{"37183": 79.53, "37037": 20.47}',
    density: 661.4,
    imprecise: false,
    latitude: 35.72123,
    longitude: -78.90828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27502',
  },
  {
    city: 'Bahama',
    county_fips: 37063,
    county_fips_all: '37063',
    county: 'Durham',
    county_names_all: 'Durham',
    county_weights: '{"37063": 100}',
    density: 55,
    imprecise: false,
    latitude: 36.15832,
    longitude: -78.87757,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27503',
  },
  {
    city: 'Benson',
    county_fips: 37101,
    county_fips_all: '37101|37085',
    county: 'Johnston',
    county_names_all: 'Johnston|Harnett',
    county_weights: '{"37101": 97.15, "37085": 2.85}',
    density: 73.4,
    imprecise: false,
    latitude: 35.39963,
    longitude: -78.51863,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27504',
  },
  {
    city: 'Broadway',
    county_fips: 37085,
    county_fips_all: '37085|37105',
    county: 'Harnett',
    county_names_all: 'Harnett|Lee',
    county_weights: '{"37085": 96.27, "37105": 3.73}',
    density: 58.5,
    imprecise: false,
    latitude: 35.414,
    longitude: -79.00198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27505',
  },
  {
    city: 'Buies Creek',
    county_fips: 37085,
    county_fips_all: '37085',
    county: 'Harnett',
    county_names_all: 'Harnett',
    county_weights: '{"37085": 100}',
    density: 1490.2,
    imprecise: false,
    latitude: 35.40875,
    longitude: -78.73896,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27506',
  },
  {
    city: 'Bullock',
    county_fips: 37077,
    county_fips_all: '37077|37181',
    county: 'Granville',
    county_names_all: 'Granville|Vance',
    county_weights: '{"37077": 78.26, "37181": 21.74}',
    density: 12.9,
    imprecise: false,
    latitude: 36.51253,
    longitude: -78.55143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27507',
  },
  {
    city: 'Bunn',
    county_fips: 37069,
    county_fips_all: '37069',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"37069": 100}',
    density: 86.2,
    imprecise: false,
    latitude: 35.95882,
    longitude: -78.25105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27508',
  },
  {
    city: 'Butner',
    county_fips: 37077,
    county_fips_all: '37077',
    county: 'Granville',
    county_names_all: 'Granville',
    county_weights: '{"37077": 100}',
    density: 204.5,
    imprecise: false,
    latitude: 36.12889,
    longitude: -78.77604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27509',
  },
  {
    city: 'Carrboro',
    county_fips: 37135,
    county_fips_all: '37135',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"37135": 100}',
    density: 1674.2,
    imprecise: false,
    latitude: 35.91147,
    longitude: -79.08211,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27510',
  },
  {
    city: 'Cary',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 1093.2,
    imprecise: false,
    latitude: 35.76324,
    longitude: -78.78437,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27511',
  },
  {
    city: 'Cary',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 1106.4,
    imprecise: false,
    latitude: 35.80269,
    longitude: -78.80159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27513',
  },
  {
    city: 'Chapel Hill',
    county_fips: 37135,
    county_fips_all: '37135',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"37135": 100}',
    density: 648.7,
    imprecise: false,
    latitude: 35.96776,
    longitude: -79.04406,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27514',
  },
  {
    city: 'Chapel Hill',
    county_fips: 37135,
    county_fips_all: '37135|37037',
    county: 'Orange',
    county_names_all: 'Orange|Chatham',
    county_weights: '{"37135": 83.49, "37037": 16.51}',
    density: 195.6,
    imprecise: false,
    latitude: 35.91239,
    longitude: -79.15156,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27516',
  },
  {
    city: 'Chapel Hill',
    county_fips: 37037,
    county_fips_all: '37037|37135|37063',
    county: 'Chatham',
    county_names_all: 'Chatham|Orange|Durham',
    county_weights: '{"37037": 61.14, "37135": 21.46, "37063": 17.4}',
    density: 248.1,
    imprecise: false,
    latitude: 35.84389,
    longitude: -79.03186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27517',
  },
  {
    city: 'Cary',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 769.9,
    imprecise: false,
    latitude: 35.72927,
    longitude: -78.7736,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27518',
  },
  {
    city: 'Cary',
    county_fips: 37183,
    county_fips_all: '37183|37037',
    county: 'Wake',
    county_names_all: 'Wake|Chatham',
    county_weights: '{"37183": 91.86, "37037": 8.14}',
    density: 1209.6,
    imprecise: false,
    latitude: 35.80815,
    longitude: -78.88711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27519',
  },
  {
    city: 'Clayton',
    county_fips: 37101,
    county_fips_all: '37101|37183',
    county: 'Johnston',
    county_names_all: 'Johnston|Wake',
    county_weights: '{"37101": 95.9, "37183": 4.1}',
    density: 261.9,
    imprecise: false,
    latitude: 35.61274,
    longitude: -78.47075,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27520',
  },
  {
    city: 'Coats',
    county_fips: 37085,
    county_fips_all: '37085',
    county: 'Harnett',
    county_names_all: 'Harnett',
    county_weights: '{"37085": 100}',
    density: 97.2,
    imprecise: false,
    latitude: 35.41298,
    longitude: -78.65847,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27521',
  },
  {
    city: 'Creedmoor',
    county_fips: 37077,
    county_fips_all: '37077|37183',
    county: 'Granville',
    county_names_all: 'Granville|Wake',
    county_weights: '{"37077": 84.25, "37183": 15.75}',
    density: 69.8,
    imprecise: false,
    latitude: 36.10565,
    longitude: -78.67676,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27522',
  },
  {
    city: 'Apex',
    county_fips: 37037,
    county_fips_all: '37037|37183',
    county: 'Chatham',
    county_names_all: 'Chatham|Wake',
    county_weights: '{"37037": 70.4, "37183": 29.6}',
    density: 203.1,
    imprecise: false,
    latitude: 35.77102,
    longitude: -78.95367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27523',
  },
  {
    city: 'Four Oaks',
    county_fips: 37101,
    county_fips_all: '37101|37191',
    county: 'Johnston',
    county_names_all: 'Johnston|Wayne',
    county_weights: '{"37101": 92.07, "37191": 7.93}',
    density: 40.2,
    imprecise: false,
    latitude: 35.39392,
    longitude: -78.37948,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27524',
  },
  {
    city: 'Franklinton',
    county_fips: 37069,
    county_fips_all: '37069|37077',
    county: 'Franklin',
    county_names_all: 'Franklin|Granville',
    county_weights: '{"37069": 72.16, "37077": 27.84}',
    density: 70.4,
    imprecise: false,
    latitude: 36.11721,
    longitude: -78.46997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27525',
  },
  {
    city: 'Fuquay Varina',
    county_fips: 37085,
    county_fips_all: '37085|37183',
    county: 'Harnett',
    county_names_all: 'Harnett|Wake',
    county_weights: '{"37085": 59.64, "37183": 40.36}',
    density: 242.2,
    imprecise: false,
    latitude: 35.54179,
    longitude: -78.8274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 61588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27526',
  },
  {
    city: 'Clayton',
    county_fips: 37101,
    county_fips_all: '37101',
    county: 'Johnston',
    county_names_all: 'Johnston',
    county_weights: '{"37101": 100}',
    density: 343.8,
    imprecise: false,
    latitude: 35.65767,
    longitude: -78.38336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27527',
  },
  {
    city: 'Garner',
    county_fips: 37183,
    county_fips_all: '37183|37101',
    county: 'Wake',
    county_names_all: 'Wake|Johnston',
    county_weights: '{"37183": 66.55, "37101": 33.45}',
    density: 369.7,
    imprecise: false,
    latitude: 35.65048,
    longitude: -78.58167,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27529',
  },
  {
    city: 'Goldsboro',
    county_fips: 37191,
    county_fips_all: '37191',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"37191": 100}',
    density: 136.4,
    imprecise: false,
    latitude: 35.36825,
    longitude: -78.07511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27530',
  },
  {
    city: 'Goldsboro',
    county_fips: 37191,
    county_fips_all: '37191',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"37191": 100}',
    density: 1701.6,
    imprecise: false,
    latitude: 35.38746,
    longitude: -78.03896,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27533',
  },
  {
    city: 'Goldsboro',
    county_fips: 37191,
    county_fips_all: '37191|37079',
    county: 'Wayne',
    county_names_all: 'Wayne|Greene',
    county_weights: '{"37191": 99.22, "37079": 0.78}',
    density: 160.7,
    imprecise: false,
    latitude: 35.37153,
    longitude: -77.90646,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27534',
  },
  {
    city: 'Henderson',
    county_fips: 37181,
    county_fips_all: '37181',
    county: 'Vance',
    county_names_all: 'Vance',
    county_weights: '{"37181": 100}',
    density: 488.3,
    imprecise: false,
    latitude: 36.32645,
    longitude: -78.40754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27536',
  },
  {
    city: 'Henderson',
    county_fips: 37181,
    county_fips_all: '37181|37069|37185',
    county: 'Vance',
    county_names_all: 'Vance|Franklin|Warren',
    county_weights: '{"37181": 88.38, "37069": 7.61, "37185": 4.01}',
    density: 51.4,
    imprecise: false,
    latitude: 36.35343,
    longitude: -78.38887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27537',
  },
  {
    city: 'Apex',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 322.3,
    imprecise: false,
    latitude: 35.67713,
    longitude: -78.81269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27539',
  },
  {
    city: 'Holly Springs',
    county_fips: 37183,
    county_fips_all: '37183|37085|37037',
    county: 'Wake',
    county_names_all: 'Wake|Harnett|Chatham',
    county_weights: '{"37183": 73.0, "37085": 19.92, "37037": 7.08}',
    density: 384.3,
    imprecise: false,
    latitude: 35.6103,
    longitude: -78.87332,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27540',
  },
  {
    city: 'Hurdle Mills',
    county_fips: 37145,
    county_fips_all: '37145|37135|37033',
    county: 'Person',
    county_names_all: 'Person|Orange|Caswell',
    county_weights: '{"37145": 68.12, "37135": 31.51, "37033": 0.37}',
    density: 18.9,
    imprecise: false,
    latitude: 36.26176,
    longitude: -79.0866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27541',
  },
  {
    city: 'Kenly',
    county_fips: 37101,
    county_fips_all: '37101|37195|37191',
    county: 'Johnston',
    county_names_all: 'Johnston|Wilson|Wayne',
    county_weights: '{"37101": 63.31, "37195": 28.52, "37191": 8.17}',
    density: 42.2,
    imprecise: false,
    latitude: 35.61776,
    longitude: -78.1377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27542',
  },
  {
    city: 'Kittrell',
    county_fips: 37181,
    county_fips_all: '37181|37069|37077',
    county: 'Vance',
    county_names_all: 'Vance|Franklin|Granville',
    county_weights: '{"37181": 50.91, "37069": 29.73, "37077": 19.36}',
    density: 21.4,
    imprecise: false,
    latitude: 36.20018,
    longitude: -78.44097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27544',
  },
  {
    city: 'Knightdale',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 416.9,
    imprecise: false,
    latitude: 35.78513,
    longitude: -78.48045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27545',
  },
  {
    city: 'Lillington',
    county_fips: 37085,
    county_fips_all: '37085',
    county: 'Harnett',
    county_names_all: 'Harnett',
    county_weights: '{"37085": 100}',
    density: 67.5,
    imprecise: false,
    latitude: 35.38458,
    longitude: -78.86626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27546',
  },
  {
    city: 'Louisburg',
    county_fips: 37069,
    county_fips_all: '37069',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"37069": 100}',
    density: 42.6,
    imprecise: false,
    latitude: 36.10439,
    longitude: -78.24282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27549',
  },
  {
    city: 'Macon',
    county_fips: 37185,
    county_fips_all: '37185',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"37185": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 36.43339,
    longitude: -78.05231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27551',
  },
  {
    city: 'Manson',
    county_fips: 37185,
    county_fips_all: '37185|37181',
    county: 'Warren',
    county_names_all: 'Warren|Vance',
    county_weights: '{"37185": 58.84, "37181": 41.16}',
    density: 15.1,
    imprecise: false,
    latitude: 36.48047,
    longitude: -78.30643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27553',
  },
  {
    city: 'Micro',
    county_fips: 37101,
    county_fips_all: '37101',
    county: 'Johnston',
    county_names_all: 'Johnston',
    county_weights: '{"37101": 100}',
    density: 527.6,
    imprecise: false,
    latitude: 35.56242,
    longitude: -78.20353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27555',
  },
  {
    city: 'Middleburg',
    county_fips: 37181,
    county_fips_all: '37181',
    county: 'Vance',
    county_names_all: 'Vance',
    county_weights: '{"37181": 100}',
    density: 26,
    imprecise: false,
    latitude: 36.39869,
    longitude: -78.31294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27556',
  },
  {
    city: 'Middlesex',
    county_fips: 37127,
    county_fips_all: '37127|37101|37195|37069',
    county: 'Nash',
    county_names_all: 'Nash|Johnston|Wilson|Franklin',
    county_weights:
      '{"37127": 64.63, "37101": 32.3, "37195": 2.82, "37069": 0.25}',
    density: 49.8,
    imprecise: false,
    latitude: 35.77941,
    longitude: -78.2,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27557',
  },
  {
    city: 'Moncure',
    county_fips: 37037,
    county_fips_all: '37037',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"37037": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 35.6299,
    longitude: -79.0973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27559',
  },
  {
    city: 'Morrisville',
    county_fips: 37183,
    county_fips_all: '37183|37063',
    county: 'Wake',
    county_names_all: 'Wake|Durham',
    county_weights: '{"37183": 87.12, "37063": 12.88}',
    density: 574.6,
    imprecise: false,
    latitude: 35.85845,
    longitude: -78.82544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27560',
  },
  {
    city: 'New Hill',
    county_fips: 37037,
    county_fips_all: '37037|37183',
    county: 'Chatham',
    county_names_all: 'Chatham|Wake',
    county_weights: '{"37037": 60.03, "37183": 39.97}',
    density: 40.3,
    imprecise: false,
    latitude: 35.64157,
    longitude: -78.98141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27562',
  },
  {
    city: 'Norlina',
    county_fips: 37185,
    county_fips_all: '37185|37181',
    county: 'Warren',
    county_names_all: 'Warren|Vance',
    county_weights: '{"37185": 97.02, "37181": 2.98}',
    density: 28.2,
    imprecise: false,
    latitude: 36.4312,
    longitude: -78.23343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27563',
  },
  {
    city: 'Oxford',
    county_fips: 37077,
    county_fips_all: '37077|37181|37145',
    county: 'Granville',
    county_names_all: 'Granville|Vance|Person',
    county_weights: '{"37077": 94.74, "37181": 4.03, "37145": 1.23}',
    density: 28.8,
    imprecise: false,
    latitude: 36.36203,
    longitude: -78.64604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27565',
  },
  {
    city: 'Pine Level',
    county_fips: 37101,
    county_fips_all: '37101',
    county: 'Johnston',
    county_names_all: 'Johnston',
    county_weights: '{"37101": 100}',
    density: 490.2,
    imprecise: false,
    latitude: 35.51132,
    longitude: -78.24299,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27568',
  },
  {
    city: 'Princeton',
    county_fips: 37101,
    county_fips_all: '37101|37191',
    county: 'Johnston',
    county_names_all: 'Johnston|Wayne',
    county_weights: '{"37101": 79.02, "37191": 20.98}',
    density: 42.6,
    imprecise: false,
    latitude: 35.43306,
    longitude: -78.17432,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27569',
  },
  {
    city: 'Ridgeway',
    county_fips: 37185,
    county_fips_all: '37185',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"37185": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.43861,
    longitude: -78.23662,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27570',
  },
  {
    city: 'Rolesville',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 721.1,
    imprecise: false,
    latitude: 35.92151,
    longitude: -78.4647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27571',
  },
  {
    city: 'Rougemont',
    county_fips: 37145,
    county_fips_all: '37145|37063|37135|37077',
    county: 'Person',
    county_names_all: 'Person|Durham|Orange|Granville',
    county_weights:
      '{"37145": 35.78, "37063": 24.48, "37135": 23.55, "37077": 16.19}',
    density: 22.3,
    imprecise: false,
    latitude: 36.24872,
    longitude: -78.88045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27572',
  },
  {
    city: 'Roxboro',
    county_fips: 37145,
    county_fips_all: '37145',
    county: 'Person',
    county_names_all: 'Person',
    county_weights: '{"37145": 100}',
    density: 257.3,
    imprecise: false,
    latitude: 36.3978,
    longitude: -78.97476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27573',
  },
  {
    city: 'Roxboro',
    county_fips: 37145,
    county_fips_all: '37145|37077',
    county: 'Person',
    county_names_all: 'Person|Granville',
    county_weights: '{"37145": 97.36, "37077": 2.64}',
    density: 30.1,
    imprecise: false,
    latitude: 36.43166,
    longitude: -78.94147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27574',
  },
  {
    city: 'Selma',
    county_fips: 37101,
    county_fips_all: '37101',
    county: 'Johnston',
    county_names_all: 'Johnston',
    county_weights: '{"37101": 100}',
    density: 102.7,
    imprecise: false,
    latitude: 35.58297,
    longitude: -78.25776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27576',
  },
  {
    city: 'Smithfield',
    county_fips: 37101,
    county_fips_all: '37101',
    county: 'Johnston',
    county_names_all: 'Johnston',
    county_weights: '{"37101": 100}',
    density: 105.6,
    imprecise: false,
    latitude: 35.49166,
    longitude: -78.3446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27577',
  },
  {
    city: 'Stem',
    county_fips: 37077,
    county_fips_all: '37077',
    county: 'Granville',
    county_names_all: 'Granville',
    county_weights: '{"37077": 100}',
    density: 41.4,
    imprecise: false,
    latitude: 36.20155,
    longitude: -78.73355,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27581',
  },
  {
    city: 'Stovall',
    county_fips: 37077,
    county_fips_all: '37077',
    county: 'Granville',
    county_names_all: 'Granville',
    county_weights: '{"37077": 100}',
    density: 96.7,
    imprecise: false,
    latitude: 36.44736,
    longitude: -78.5691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27582',
  },
  {
    city: 'Timberlake',
    county_fips: 37145,
    county_fips_all: '37145|37135|37063',
    county: 'Person',
    county_names_all: 'Person|Orange|Durham',
    county_weights: '{"37145": 95.8, "37135": 2.88, "37063": 1.32}',
    density: 56.8,
    imprecise: false,
    latitude: 36.29723,
    longitude: -78.93153,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27583',
  },
  {
    city: 'Townsville',
    county_fips: 37181,
    county_fips_all: '37181',
    county: 'Vance',
    county_names_all: 'Vance',
    county_weights: '{"37181": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 36.4934,
    longitude: -78.44601,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27584',
  },
  {
    city: 'Wake Forest',
    county_fips: 37183,
    county_fips_all: '37183|37077|37069',
    county: 'Wake',
    county_names_all: 'Wake|Granville|Franklin',
    county_weights: '{"37183": 88.25, "37077": 9.18, "37069": 2.57}',
    density: 304.5,
    imprecise: false,
    latitude: 35.98098,
    longitude: -78.54963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 82886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27587',
  },
  {
    city: 'Warrenton',
    county_fips: 37185,
    county_fips_all: '37185|37069',
    county: 'Warren',
    county_names_all: 'Warren|Franklin',
    county_weights: '{"37185": 96.36, "37069": 3.64}',
    density: 15.4,
    imprecise: false,
    latitude: 36.33461,
    longitude: -78.12819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27589',
  },
  {
    city: 'Wendell',
    county_fips: 37183,
    county_fips_all: '37183|37101',
    county: 'Wake',
    county_names_all: 'Wake|Johnston',
    county_weights: '{"37183": 69.75, "37101": 30.25}',
    density: 172.9,
    imprecise: false,
    latitude: 35.7859,
    longitude: -78.38638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27591',
  },
  {
    city: 'Willow Spring',
    county_fips: 37183,
    county_fips_all: '37183|37101|37085',
    county: 'Wake',
    county_names_all: 'Wake|Johnston|Harnett',
    county_weights: '{"37183": 60.21, "37101": 39.25, "37085": 0.54}',
    density: 207.8,
    imprecise: false,
    latitude: 35.55922,
    longitude: -78.67164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27592',
  },
  {
    city: 'Wilsons Mills',
    county_fips: 37101,
    county_fips_all: '37101',
    county: 'Johnston',
    county_names_all: 'Johnston',
    county_weights: '{"37101": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.58579,
    longitude: -78.36231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27593',
  },
  {
    city: 'Wise',
    county_fips: 37185,
    county_fips_all: '37185',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"37185": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 36.47294,
    longitude: -78.16622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27594',
  },
  {
    city: 'Youngsville',
    county_fips: 37069,
    county_fips_all: '37069|37183|37077',
    county: 'Franklin',
    county_names_all: 'Franklin|Wake|Granville',
    county_weights: '{"37069": 90.88, "37183": 5.86, "37077": 3.26}',
    density: 162.5,
    imprecise: false,
    latitude: 36.00906,
    longitude: -78.44448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27596',
  },
  {
    city: 'Zebulon',
    county_fips: 37183,
    county_fips_all: '37183|37069|37101|37127',
    county: 'Wake',
    county_names_all: 'Wake|Franklin|Johnston|Nash',
    county_weights:
      '{"37183": 42.19, "37069": 28.47, "37101": 22.91, "37127": 6.43}',
    density: 98.4,
    imprecise: false,
    latitude: 35.84034,
    longitude: -78.30303,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27597',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 2103.1,
    imprecise: false,
    latitude: 35.7737,
    longitude: -78.63453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27601',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183|37101',
    county: 'Wake',
    county_names_all: 'Wake|Johnston',
    county_weights: '{"37183": 95.39, "37101": 4.61}',
    density: 405.3,
    imprecise: false,
    latitude: 35.66408,
    longitude: -78.66186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27603',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 898.5,
    imprecise: false,
    latitude: 35.82011,
    longitude: -78.56369,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27604',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 2370.7,
    imprecise: false,
    latitude: 35.79046,
    longitude: -78.65452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27605',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 717.2,
    imprecise: false,
    latitude: 35.73991,
    longitude: -78.71833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27606',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 632,
    imprecise: false,
    latitude: 35.82145,
    longitude: -78.72697,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27607',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 1410.5,
    imprecise: false,
    latitude: 35.81004,
    longitude: -78.64815,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27608',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 1255.3,
    imprecise: false,
    latitude: 35.8437,
    longitude: -78.63282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27609',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183|37101',
    county: 'Wake',
    county_names_all: 'Wake|Johnston',
    county_weights: '{"37183": 99.81, "37101": 0.19}',
    density: 696.2,
    imprecise: false,
    latitude: 35.7435,
    longitude: -78.54644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 81419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27610',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 975.5,
    imprecise: false,
    latitude: 35.85034,
    longitude: -78.70387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27612',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183|37063',
    county: 'Wake',
    county_names_all: 'Wake|Durham',
    county_weights: '{"37183": 83.69, "37063": 16.31}',
    density: 684.9,
    imprecise: false,
    latitude: 35.92633,
    longitude: -78.71183,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27613',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 476.4,
    imprecise: false,
    latitude: 35.94739,
    longitude: -78.62059,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27614',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 940.3,
    imprecise: false,
    latitude: 35.89772,
    longitude: -78.636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27615',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 1090.3,
    imprecise: false,
    latitude: 35.86735,
    longitude: -78.53792,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27616',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183|37063',
    county: 'Wake',
    county_names_all: 'Wake|Durham',
    county_weights: '{"37183": 97.55, "37063": 2.45}',
    density: 944.6,
    imprecise: false,
    latitude: 35.90723,
    longitude: -78.77221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27617',
  },
  {
    city: 'Durham',
    county_fips: 37063,
    county_fips_all: '37063',
    county: 'Durham',
    county_names_all: 'Durham',
    county_weights: '{"37063": 100}',
    density: 1823.5,
    imprecise: false,
    latitude: 35.99858,
    longitude: -78.89872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27701',
  },
  {
    city: 'Durham',
    county_fips: 37063,
    county_fips_all: '37063|37183',
    county: 'Durham',
    county_names_all: 'Durham|Wake',
    county_weights: '{"37063": 99.38, "37183": 0.62}',
    density: 499.3,
    imprecise: false,
    latitude: 35.96299,
    longitude: -78.80452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27703',
  },
  {
    city: 'Durham',
    county_fips: 37063,
    county_fips_all: '37063',
    county: 'Durham',
    county_names_all: 'Durham',
    county_weights: '{"37063": 100}',
    density: 373.7,
    imprecise: false,
    latitude: 36.04088,
    longitude: -78.83007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27704',
  },
  {
    city: 'Durham',
    county_fips: 37063,
    county_fips_all: '37063|37135',
    county: 'Durham',
    county_names_all: 'Durham|Orange',
    county_weights: '{"37063": 53.04, "37135": 46.96}',
    density: 458.2,
    imprecise: false,
    latitude: 36.0259,
    longitude: -78.98046,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27705',
  },
  {
    city: 'Durham',
    county_fips: 37063,
    county_fips_all: '37063|37135',
    county: 'Durham',
    county_names_all: 'Durham|Orange',
    county_weights: '{"37063": 91.45, "37135": 8.55}',
    density: 956.1,
    imprecise: false,
    latitude: 35.95463,
    longitude: -78.95451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27707',
  },
  {
    city: 'Durham',
    county_fips: 37063,
    county_fips_all: '37063',
    county: 'Durham',
    county_names_all: 'Durham',
    county_weights: '{"37063": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.91441,
    longitude: -78.86666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27709',
  },
  {
    city: 'Durham',
    county_fips: 37063,
    county_fips_all: '37063|37135',
    county: 'Durham',
    county_names_all: 'Durham|Orange',
    county_weights: '{"37063": 98.31, "37135": 1.69}',
    density: 282.4,
    imprecise: false,
    latitude: 36.09606,
    longitude: -78.90481,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27712',
  },
  {
    city: 'Durham',
    county_fips: 37063,
    county_fips_all: '37063|37037|37183',
    county: 'Durham',
    county_names_all: 'Durham|Chatham|Wake',
    county_weights: '{"37063": 66.07, "37037": 33.42, "37183": 0.51}',
    density: 646.5,
    imprecise: false,
    latitude: 35.88401,
    longitude: -78.936,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27713',
  },
  {
    city: 'Rocky Mount',
    county_fips: 37065,
    county_fips_all: '37065',
    county: 'Edgecombe',
    county_names_all: 'Edgecombe',
    county_weights: '{"37065": 100}',
    density: 112.9,
    imprecise: false,
    latitude: 35.91209,
    longitude: -77.73656,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27801',
  },
  {
    city: 'Rocky Mount',
    county_fips: 37127,
    county_fips_all: '37127|37195|37065',
    county: 'Nash',
    county_names_all: 'Nash|Wilson|Edgecombe',
    county_weights: '{"37127": 84.98, "37195": 9.29, "37065": 5.73}',
    density: 184.6,
    imprecise: false,
    latitude: 35.89627,
    longitude: -77.85407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27803',
  },
  {
    city: 'Rocky Mount',
    county_fips: 37127,
    county_fips_all: '37127',
    county: 'Nash',
    county_names_all: 'Nash',
    county_weights: '{"37127": 100}',
    density: 275.5,
    imprecise: false,
    latitude: 35.98958,
    longitude: -77.84778,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27804',
  },
  {
    city: 'Aulander',
    county_fips: 37015,
    county_fips_all: '37015|37091',
    county: 'Bertie',
    county_names_all: 'Bertie|Hertford',
    county_weights: '{"37015": 60.76, "37091": 39.24}',
    density: 8.9,
    imprecise: false,
    latitude: 36.20863,
    longitude: -77.08861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27805',
  },
  {
    city: 'Aurora',
    county_fips: 37013,
    county_fips_all: '37013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"37013": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 35.29713,
    longitude: -76.76264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27806',
  },
  {
    city: 'Bailey',
    county_fips: 37127,
    county_fips_all: '37127|37195',
    county: 'Nash',
    county_names_all: 'Nash|Wilson',
    county_weights: '{"37127": 92.99, "37195": 7.01}',
    density: 47.8,
    imprecise: false,
    latitude: 35.80915,
    longitude: -78.0917,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27807',
  },
  {
    city: 'Bath',
    county_fips: 37013,
    county_fips_all: '37013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"37013": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 35.47228,
    longitude: -76.76494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27808',
  },
  {
    city: 'Battleboro',
    county_fips: 37065,
    county_fips_all: '37065|37127',
    county: 'Edgecombe',
    county_names_all: 'Edgecombe|Nash',
    county_weights: '{"37065": 62.78, "37127": 37.22}',
    density: 19.8,
    imprecise: false,
    latitude: 36.01932,
    longitude: -77.74085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27809',
  },
  {
    city: 'Belhaven',
    county_fips: 37095,
    county_fips_all: '37095|37013',
    county: 'Hyde',
    county_names_all: 'Hyde|Beaufort',
    county_weights: '{"37095": 60.22, "37013": 39.78}',
    density: 6.4,
    imprecise: false,
    latitude: 35.58637,
    longitude: -76.49706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27810',
  },
  {
    city: 'Bethel',
    county_fips: 37147,
    county_fips_all: '37147|37065|37117',
    county: 'Pitt',
    county_names_all: 'Pitt|Edgecombe|Martin',
    county_weights: '{"37147": 65.16, "37065": 26.54, "37117": 8.3}',
    density: 14.4,
    imprecise: false,
    latitude: 35.80506,
    longitude: -77.37616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27812',
  },
  {
    city: 'Black Creek',
    county_fips: 37195,
    county_fips_all: '37195',
    county: 'Wilson',
    county_names_all: 'Wilson',
    county_weights: '{"37195": 100}',
    density: 260.7,
    imprecise: false,
    latitude: 35.63083,
    longitude: -77.93587,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27813',
  },
  {
    city: 'Blounts Creek',
    county_fips: 37013,
    county_fips_all: '37013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"37013": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 35.37987,
    longitude: -76.93513,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27814',
  },
  {
    city: 'Castalia',
    county_fips: 37069,
    county_fips_all: '37069|37127',
    county: 'Franklin',
    county_names_all: 'Franklin|Nash',
    county_weights: '{"37069": 51.81, "37127": 48.19}',
    density: 17.9,
    imprecise: false,
    latitude: 36.10732,
    longitude: -78.07245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27816',
  },
  {
    city: 'Chocowinity',
    county_fips: 37013,
    county_fips_all: '37013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"37013": 100}',
    density: 30,
    imprecise: false,
    latitude: 35.4506,
    longitude: -77.0825,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27817',
  },
  {
    city: 'Como',
    county_fips: 37091,
    county_fips_all: '37091',
    county: 'Hertford',
    county_names_all: 'Hertford',
    county_weights: '{"37091": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 36.50275,
    longitude: -77.01394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27818',
  },
  {
    city: 'Conetoe',
    county_fips: 37065,
    county_fips_all: '37065',
    county: 'Edgecombe',
    county_names_all: 'Edgecombe',
    county_weights: '{"37065": 100}',
    density: 155.8,
    imprecise: false,
    latitude: 35.81412,
    longitude: -77.45731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27819',
  },
  {
    city: 'Conway',
    county_fips: 37131,
    county_fips_all: '37131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"37131": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 36.4154,
    longitude: -77.24431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27820',
  },
  {
    city: 'Edward',
    county_fips: 37013,
    county_fips_all: '37013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"37013": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 35.3237,
    longitude: -76.87392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27821',
  },
  {
    city: 'Elm City',
    county_fips: 37195,
    county_fips_all: '37195|37127|37065',
    county: 'Wilson',
    county_names_all: 'Wilson|Nash|Edgecombe',
    county_weights: '{"37195": 74.63, "37127": 16.58, "37065": 8.79}',
    density: 34.5,
    imprecise: false,
    latitude: 35.80402,
    longitude: -77.83868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27822',
  },
  {
    city: 'Enfield',
    county_fips: 37083,
    county_fips_all: '37083',
    county: 'Halifax',
    county_names_all: 'Halifax',
    county_weights: '{"37083": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 36.20616,
    longitude: -77.71685,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27823',
  },
  {
    city: 'Engelhard',
    county_fips: 37095,
    county_fips_all: '37095',
    county: 'Hyde',
    county_names_all: 'Hyde',
    county_weights: '{"37095": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 35.55688,
    longitude: -76.02105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27824',
  },
  {
    city: 'Everetts',
    county_fips: 37117,
    county_fips_all: '37117',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"37117": 100}',
    density: 103.7,
    imprecise: false,
    latitude: 35.83527,
    longitude: -77.17152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27825',
  },
  {
    city: 'Fairfield',
    county_fips: 37095,
    county_fips_all: '37095|37177',
    county: 'Hyde',
    county_names_all: 'Hyde|Tyrrell',
    county_weights: '{"37095": 73.93, "37177": 26.07}',
    density: 2,
    imprecise: false,
    latitude: 35.58988,
    longitude: -76.2521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27826',
  },
  {
    city: 'Falkland',
    county_fips: 37147,
    county_fips_all: '37147',
    county: 'Pitt',
    county_names_all: 'Pitt',
    county_weights: '{"37147": 100}',
    density: 225.9,
    imprecise: false,
    latitude: 35.69823,
    longitude: -77.51224,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27827',
  },
  {
    city: 'Farmville',
    county_fips: 37147,
    county_fips_all: '37147|37079',
    county: 'Pitt',
    county_names_all: 'Pitt|Greene',
    county_weights: '{"37147": 68.59, "37079": 31.41}',
    density: 38.5,
    imprecise: false,
    latitude: 35.58509,
    longitude: -77.58519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27828',
  },
  {
    city: 'Fountain',
    county_fips: 37147,
    county_fips_all: '37147|37065|37195',
    county: 'Pitt',
    county_names_all: 'Pitt|Edgecombe|Wilson',
    county_weights: '{"37147": 63.4, "37065": 20.64, "37195": 15.96}',
    density: 13.9,
    imprecise: false,
    latitude: 35.69272,
    longitude: -77.61215,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27829',
  },
  {
    city: 'Fremont',
    county_fips: 37191,
    county_fips_all: '37191|37195',
    county: 'Wayne',
    county_names_all: 'Wayne|Wilson',
    county_weights: '{"37191": 89.43, "37195": 10.57}',
    density: 26.5,
    imprecise: false,
    latitude: 35.55557,
    longitude: -77.95224,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27830',
  },
  {
    city: 'Garysburg',
    county_fips: 37131,
    county_fips_all: '37131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"37131": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 36.45614,
    longitude: -77.56574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27831',
  },
  {
    city: 'Gaston',
    county_fips: 37131,
    county_fips_all: '37131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"37131": 100}',
    density: 32.2,
    imprecise: false,
    latitude: 36.51262,
    longitude: -77.72178,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27832',
  },
  {
    city: 'Greenville',
    county_fips: 37147,
    county_fips_all: '37147|37013|37065',
    county: 'Pitt',
    county_names_all: 'Pitt|Beaufort|Edgecombe',
    county_weights: '{"37147": 96.27, "37013": 2.67, "37065": 1.06}',
    density: 124.8,
    imprecise: false,
    latitude: 35.6571,
    longitude: -77.37981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27834',
  },
  {
    city: 'Grimesland',
    county_fips: 37147,
    county_fips_all: '37147|37013',
    county: 'Pitt',
    county_names_all: 'Pitt|Beaufort',
    county_weights: '{"37147": 96.92, "37013": 3.08}',
    density: 42.5,
    imprecise: false,
    latitude: 35.51606,
    longitude: -77.20892,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27837',
  },
  {
    city: 'Halifax',
    county_fips: 37083,
    county_fips_all: '37083',
    county: 'Halifax',
    county_names_all: 'Halifax',
    county_weights: '{"37083": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 36.28818,
    longitude: -77.55009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27839',
  },
  {
    city: 'Hamilton',
    county_fips: 37117,
    county_fips_all: '37117',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"37117": 100}',
    density: 21.3,
    imprecise: false,
    latitude: 35.9343,
    longitude: -77.23186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27840',
  },
  {
    city: 'Hassell',
    county_fips: 37117,
    county_fips_all: '37117',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"37117": 100}',
    density: 65.2,
    imprecise: false,
    latitude: 35.90859,
    longitude: -77.27632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27841',
  },
  {
    city: 'Henrico',
    county_fips: 37131,
    county_fips_all: '37131|37185',
    county: 'Northampton',
    county_names_all: 'Northampton|Warren',
    county_weights: '{"37131": 92.12, "37185": 7.88}',
    density: 56.4,
    imprecise: false,
    latitude: 36.52458,
    longitude: -77.85593,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27842',
  },
  {
    city: 'Hobgood',
    county_fips: 37065,
    county_fips_all: '37065|37117|37083',
    county: 'Edgecombe',
    county_names_all: 'Edgecombe|Martin|Halifax',
    county_weights: '{"37065": 34.53, "37117": 33.07, "37083": 32.4}',
    density: 5.6,
    imprecise: false,
    latitude: 35.99332,
    longitude: -77.39509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27843',
  },
  {
    city: 'Hollister',
    county_fips: 37083,
    county_fips_all: '37083|37185|37127|37069',
    county: 'Halifax',
    county_names_all: 'Halifax|Warren|Nash|Franklin',
    county_weights:
      '{"37083": 71.12, "37185": 20.68, "37127": 4.53, "37069": 3.67}',
    density: 23.8,
    imprecise: false,
    latitude: 36.24555,
    longitude: -77.94945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27844',
  },
  {
    city: 'Jackson',
    county_fips: 37131,
    county_fips_all: '37131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"37131": 100}',
    density: 8,
    imprecise: false,
    latitude: 36.37403,
    longitude: -77.43331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27845',
  },
  {
    city: 'Jamesville',
    county_fips: 37117,
    county_fips_all: '37117',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"37117": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 35.76519,
    longitude: -76.89191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27846',
  },
  {
    city: 'Kelford',
    county_fips: 37015,
    county_fips_all: '37015',
    county: 'Bertie',
    county_names_all: 'Bertie',
    county_weights: '{"37015": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 36.18597,
    longitude: -77.20738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27847',
  },
  {
    city: 'Lewiston Woodville',
    county_fips: 37015,
    county_fips_all: '37015',
    county: 'Bertie',
    county_names_all: 'Bertie',
    county_weights: '{"37015": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 36.06796,
    longitude: -77.20675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27849',
  },
  {
    city: 'Littleton',
    county_fips: 37083,
    county_fips_all: '37083|37185',
    county: 'Halifax',
    county_names_all: 'Halifax|Warren',
    county_weights: '{"37083": 61.86, "37185": 38.14}',
    density: 14.3,
    imprecise: false,
    latitude: 36.40202,
    longitude: -77.88141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27850',
  },
  {
    city: 'Lucama',
    county_fips: 37195,
    county_fips_all: '37195|37191',
    county: 'Wilson',
    county_names_all: 'Wilson|Wayne',
    county_weights: '{"37195": 99.11, "37191": 0.89}',
    density: 46.5,
    imprecise: false,
    latitude: 35.63965,
    longitude: -78.02739,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27851',
  },
  {
    city: 'Macclesfield',
    county_fips: 37065,
    county_fips_all: '37065|37147|37195',
    county: 'Edgecombe',
    county_names_all: 'Edgecombe|Pitt|Wilson',
    county_weights: '{"37065": 81.44, "37147": 9.89, "37195": 8.67}',
    density: 18.2,
    imprecise: false,
    latitude: 35.75288,
    longitude: -77.63581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27852',
  },
  {
    city: 'Margarettsville',
    county_fips: 37131,
    county_fips_all: '37131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"37131": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 36.51716,
    longitude: -77.30488,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27853',
  },
  {
    city: 'Murfreesboro',
    county_fips: 37091,
    county_fips_all: '37091|37131',
    county: 'Hertford',
    county_names_all: 'Hertford|Northampton',
    county_weights: '{"37091": 83.52, "37131": 16.48}',
    density: 40.6,
    imprecise: false,
    latitude: 36.42171,
    longitude: -77.08432,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27855',
  },
  {
    city: 'Nashville',
    county_fips: 37127,
    county_fips_all: '37127',
    county: 'Nash',
    county_names_all: 'Nash',
    county_weights: '{"37127": 100}',
    density: 51.6,
    imprecise: false,
    latitude: 36.00998,
    longitude: -77.98151,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27856',
  },
  {
    city: 'Oak City',
    county_fips: 37117,
    county_fips_all: '37117',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"37117": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 35.96968,
    longitude: -77.27198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27857',
  },
  {
    city: 'Greenville',
    county_fips: 37147,
    county_fips_all: '37147',
    county: 'Pitt',
    county_names_all: 'Pitt',
    county_weights: '{"37147": 100}',
    density: 369.6,
    imprecise: false,
    latitude: 35.53229,
    longitude: -77.29709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27858',
  },
  {
    city: 'Pantego',
    county_fips: 37013,
    county_fips_all: '37013|37187|37095',
    county: 'Beaufort',
    county_names_all: 'Beaufort|Washington|Hyde',
    county_weights: '{"37013": 53.75, "37187": 31.54, "37095": 14.71}',
    density: 4,
    imprecise: false,
    latitude: 35.67693,
    longitude: -76.65001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27860',
  },
  {
    city: 'Parmele',
    county_fips: 37117,
    county_fips_all: '37117',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"37117": 100}',
    density: 100.3,
    imprecise: false,
    latitude: 35.81716,
    longitude: -77.31899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27861',
  },
  {
    city: 'Pendleton',
    county_fips: 37131,
    county_fips_all: '37131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"37131": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 36.49264,
    longitude: -77.18906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27862',
  },
  {
    city: 'Pikeville',
    county_fips: 37191,
    county_fips_all: '37191|37079|37101',
    county: 'Wayne',
    county_names_all: 'Wayne|Greene|Johnston',
    county_weights: '{"37191": 96.03, "37079": 2.82, "37101": 1.15}',
    density: 80.2,
    imprecise: false,
    latitude: 35.48739,
    longitude: -77.96993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27863',
  },
  {
    city: 'Pinetops',
    county_fips: 37065,
    county_fips_all: '37065',
    county: 'Edgecombe',
    county_names_all: 'Edgecombe',
    county_weights: '{"37065": 100}',
    density: 42.2,
    imprecise: false,
    latitude: 35.8075,
    longitude: -77.64789,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27864',
  },
  {
    city: 'Pinetown',
    county_fips: 37013,
    county_fips_all: '37013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"37013": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 35.60588,
    longitude: -76.83244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27865',
  },
  {
    city: 'Pleasant Hill',
    county_fips: 37131,
    county_fips_all: '37131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"37131": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 36.51832,
    longitude: -77.51577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27866',
  },
  {
    city: 'Rich Square',
    county_fips: 37131,
    county_fips_all: '37131|37015',
    county: 'Northampton',
    county_names_all: 'Northampton|Bertie',
    county_weights: '{"37131": 99.7, "37015": 0.3}',
    density: 8.6,
    imprecise: false,
    latitude: 36.26631,
    longitude: -77.31665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27869',
  },
  {
    city: 'Roanoke Rapids',
    county_fips: 37083,
    county_fips_all: '37083',
    county: 'Halifax',
    county_names_all: 'Halifax',
    county_weights: '{"37083": 100}',
    density: 147.8,
    imprecise: false,
    latitude: 36.43053,
    longitude: -77.71828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27870',
  },
  {
    city: 'Robersonville',
    county_fips: 37117,
    county_fips_all: '37117|37147|37013',
    county: 'Martin',
    county_names_all: 'Martin|Pitt|Beaufort',
    county_weights: '{"37117": 72.5, "37147": 26.86, "37013": 0.64}',
    density: 14,
    imprecise: false,
    latitude: 35.81355,
    longitude: -77.26306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27871',
  },
  {
    city: 'Roxobel',
    county_fips: 37015,
    county_fips_all: '37015',
    county: 'Bertie',
    county_names_all: 'Bertie',
    county_weights: '{"37015": 100}',
    density: 62,
    imprecise: false,
    latitude: 36.20096,
    longitude: -77.24601,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27872',
  },
  {
    city: 'Saratoga',
    county_fips: 37195,
    county_fips_all: '37195',
    county: 'Wilson',
    county_names_all: 'Wilson',
    county_weights: '{"37195": 100}',
    density: 137.6,
    imprecise: false,
    latitude: 35.65331,
    longitude: -77.77606,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27873',
  },
  {
    city: 'Scotland Neck',
    county_fips: 37083,
    county_fips_all: '37083',
    county: 'Halifax',
    county_names_all: 'Halifax',
    county_weights: '{"37083": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 36.12874,
    longitude: -77.41037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27874',
  },
  {
    city: 'Scranton',
    county_fips: 37095,
    county_fips_all: '37095',
    county: 'Hyde',
    county_names_all: 'Hyde',
    county_weights: '{"37095": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 35.45623,
    longitude: -76.48532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27875',
  },
  {
    city: 'Seaboard',
    county_fips: 37131,
    county_fips_all: '37131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"37131": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 36.48015,
    longitude: -77.40065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27876',
  },
  {
    city: 'Severn',
    county_fips: 37131,
    county_fips_all: '37131',
    county: 'Northampton',
    county_names_all: 'Northampton',
    county_weights: '{"37131": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.51883,
    longitude: -77.19219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27877',
  },
  {
    city: 'Sharpsburg',
    county_fips: 37127,
    county_fips_all: '37127|37195|37065',
    county: 'Nash',
    county_names_all: 'Nash|Wilson|Edgecombe',
    county_weights: '{"37127": 59.16, "37195": 27.87, "37065": 12.97}',
    density: 536.9,
    imprecise: false,
    latitude: 35.86606,
    longitude: -77.83062,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27878',
  },
  {
    city: 'Simpson',
    county_fips: 37147,
    county_fips_all: '37147',
    county: 'Pitt',
    county_names_all: 'Pitt',
    county_weights: '{"37147": 100}',
    density: 408.1,
    imprecise: false,
    latitude: 35.57456,
    longitude: -77.27968,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27879',
  },
  {
    city: 'Sims',
    county_fips: 37195,
    county_fips_all: '37195|37127',
    county: 'Wilson',
    county_names_all: 'Wilson|Nash',
    county_weights: '{"37195": 96.07, "37127": 3.93}',
    density: 59.7,
    imprecise: false,
    latitude: 35.73656,
    longitude: -78.08912,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27880',
  },
  {
    city: 'Speed',
    county_fips: 37065,
    county_fips_all: '37065',
    county: 'Edgecombe',
    county_names_all: 'Edgecombe',
    county_weights: '{"37065": 100}',
    density: 140.9,
    imprecise: false,
    latitude: 35.9702,
    longitude: -77.44228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27881',
  },
  {
    city: 'Spring Hope',
    county_fips: 37127,
    county_fips_all: '37127|37069',
    county: 'Nash',
    county_names_all: 'Nash|Franklin',
    county_weights: '{"37127": 78.09, "37069": 21.91}',
    density: 31.2,
    imprecise: false,
    latitude: 35.94222,
    longitude: -78.11825,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27882',
  },
  {
    city: 'Stantonsburg',
    county_fips: 37195,
    county_fips_all: '37195|37079|37191',
    county: 'Wilson',
    county_names_all: 'Wilson|Greene|Wayne',
    county_weights: '{"37195": 47.81, "37079": 36.65, "37191": 15.55}',
    density: 20.2,
    imprecise: false,
    latitude: 35.59141,
    longitude: -77.80095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27883',
  },
  {
    city: 'Stokes',
    county_fips: 37147,
    county_fips_all: '37147',
    county: 'Pitt',
    county_names_all: 'Pitt',
    county_weights: '{"37147": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 35.70771,
    longitude: -77.27176,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27884',
  },
  {
    city: 'Swanquarter',
    county_fips: 37095,
    county_fips_all: '37095',
    county: 'Hyde',
    county_names_all: 'Hyde',
    county_weights: '{"37095": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 35.44429,
    longitude: -76.23125,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27885',
  },
  {
    city: 'Tarboro',
    county_fips: 37065,
    county_fips_all: '37065|37147',
    county: 'Edgecombe',
    county_names_all: 'Edgecombe|Pitt',
    county_weights: '{"37065": 96.99, "37147": 3.01}',
    density: 37.1,
    imprecise: false,
    latitude: 35.90369,
    longitude: -77.52248,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27886',
  },
  {
    city: 'Walstonburg',
    county_fips: 37079,
    county_fips_all: '37079|37195|37147',
    county: 'Greene',
    county_names_all: 'Greene|Wilson|Pitt',
    county_weights: '{"37079": 72.92, "37195": 17.01, "37147": 10.07}',
    density: 14,
    imprecise: false,
    latitude: 35.59589,
    longitude: -77.70448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27888',
  },
  {
    city: 'Washington',
    county_fips: 37013,
    county_fips_all: '37013|37147|37117',
    county: 'Beaufort',
    county_names_all: 'Beaufort|Pitt|Martin',
    county_weights: '{"37013": 90.25, "37147": 7.74, "37117": 2.01}',
    density: 53.4,
    imprecise: false,
    latitude: 35.58909,
    longitude: -77.02386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27889',
  },
  {
    city: 'Weldon',
    county_fips: 37083,
    county_fips_all: '37083',
    county: 'Halifax',
    county_names_all: 'Halifax',
    county_weights: '{"37083": 100}',
    density: 94.7,
    imprecise: false,
    latitude: 36.41505,
    longitude: -77.59194,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27890',
  },
  {
    city: 'Whitakers',
    county_fips: 37127,
    county_fips_all: '37127|37065|37083',
    county: 'Nash',
    county_names_all: 'Nash|Edgecombe|Halifax',
    county_weights: '{"37127": 47.81, "37065": 45.21, "37083": 6.97}',
    density: 13.3,
    imprecise: false,
    latitude: 36.09968,
    longitude: -77.74103,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27891',
  },
  {
    city: 'Williamston',
    county_fips: 37117,
    county_fips_all: '37117|37013',
    county: 'Martin',
    county_names_all: 'Martin|Beaufort',
    county_weights: '{"37117": 99.57, "37013": 0.43}',
    density: 27.7,
    imprecise: false,
    latitude: 35.81844,
    longitude: -77.06434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27892',
  },
  {
    city: 'Wilson',
    county_fips: 37195,
    county_fips_all: '37195',
    county: 'Wilson',
    county_names_all: 'Wilson',
    county_weights: '{"37195": 100}',
    density: 136.4,
    imprecise: false,
    latitude: 35.69351,
    longitude: -77.90458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27893',
  },
  {
    city: 'Wilson',
    county_fips: 37195,
    county_fips_all: '37195|37127',
    county: 'Wilson',
    county_names_all: 'Wilson|Nash',
    county_weights: '{"37195": 67.72, "37127": 32.28}',
    density: 213.7,
    imprecise: false,
    latitude: 35.79303,
    longitude: -77.97399,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27896',
  },
  {
    city: 'Woodland',
    county_fips: 37131,
    county_fips_all: '37131|37091',
    county: 'Northampton',
    county_names_all: 'Northampton|Hertford',
    county_weights: '{"37131": 79.63, "37091": 20.37}',
    density: 10.4,
    imprecise: false,
    latitude: 36.3246,
    longitude: -77.20969,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27897',
  },
  {
    city: 'Elizabeth City',
    county_fips: 37139,
    county_fips_all: '37139',
    county: 'Pasquotank',
    county_names_all: 'Pasquotank',
    county_weights: '{"37139": 100}',
    density: 69.5,
    imprecise: false,
    latitude: 36.29548,
    longitude: -76.28394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27909',
  },
  {
    city: 'Ahoskie',
    county_fips: 37091,
    county_fips_all: '37091|37015',
    county: 'Hertford',
    county_names_all: 'Hertford|Bertie',
    county_weights: '{"37091": 69.7, "37015": 30.3}',
    density: 27.7,
    imprecise: false,
    latitude: 36.27996,
    longitude: -76.99281,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27910',
  },
  {
    city: 'Avon',
    county_fips: 37055,
    county_fips_all: '37055',
    county: 'Dare',
    county_names_all: 'Dare',
    county_weights: '{"37055": 100}',
    density: 16,
    imprecise: false,
    latitude: 35.40794,
    longitude: -75.49465,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27915',
  },
  {
    city: 'Aydlett',
    county_fips: 37053,
    county_fips_all: '37053',
    county: 'Currituck',
    county_names_all: 'Currituck',
    county_weights: '{"37053": 100}',
    density: 57.2,
    imprecise: false,
    latitude: 36.32933,
    longitude: -75.91996,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27916',
  },
  {
    city: 'Barco',
    county_fips: 37053,
    county_fips_all: '37053',
    county: 'Currituck',
    county_names_all: 'Currituck',
    county_weights: '{"37053": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 36.36071,
    longitude: -75.99071,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27917',
  },
  {
    city: 'Belvidere',
    county_fips: 37143,
    county_fips_all: '37143|37041',
    county: 'Perquimans',
    county_names_all: 'Perquimans|Chowan',
    county_weights: '{"37143": 90.38, "37041": 9.62}',
    density: 6.1,
    imprecise: false,
    latitude: 36.31178,
    longitude: -76.50293,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27919',
  },
  {
    city: 'Buxton',
    county_fips: 37055,
    county_fips_all: '37055',
    county: 'Dare',
    county_names_all: 'Dare',
    county_weights: '{"37055": 100}',
    density: 62.4,
    imprecise: false,
    latitude: 35.25109,
    longitude: -75.54755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27920',
  },
  {
    city: 'Camden',
    county_fips: 37029,
    county_fips_all: '37029',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"37029": 100}',
    density: 30.6,
    imprecise: false,
    latitude: 36.3446,
    longitude: -76.15512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27921',
  },
  {
    city: 'Cofield',
    county_fips: 37091,
    county_fips_all: '37091',
    county: 'Hertford',
    county_names_all: 'Hertford',
    county_weights: '{"37091": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 36.32118,
    longitude: -76.84837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27922',
  },
  {
    city: 'Coinjock',
    county_fips: 37053,
    county_fips_all: '37053',
    county: 'Currituck',
    county_names_all: 'Currituck',
    county_weights: '{"37053": 100}',
    density: 55.6,
    imprecise: false,
    latitude: 36.38852,
    longitude: -75.93562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27923',
  },
  {
    city: 'Colerain',
    county_fips: 37015,
    county_fips_all: '37015|37091',
    county: 'Bertie',
    county_names_all: 'Bertie|Hertford',
    county_weights: '{"37015": 91.63, "37091": 8.37}',
    density: 10.7,
    imprecise: false,
    latitude: 36.17835,
    longitude: -76.83822,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27924',
  },
  {
    city: 'Columbia',
    county_fips: 37177,
    county_fips_all: '37177',
    county: 'Tyrrell',
    county_names_all: 'Tyrrell',
    county_weights: '{"37177": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 35.84336,
    longitude: -76.18349,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27925',
  },
  {
    city: 'Corapeake',
    county_fips: 37073,
    county_fips_all: '37073',
    county: 'Gates',
    county_names_all: 'Gates',
    county_weights: '{"37073": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 36.51687,
    longitude: -76.60288,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27926',
  },
  {
    city: 'Corolla',
    county_fips: 37053,
    county_fips_all: '37053',
    county: 'Currituck',
    county_names_all: 'Currituck',
    county_weights: '{"37053": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 36.4131,
    longitude: -75.8497,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27927',
  },
  {
    city: 'Creswell',
    county_fips: 37187,
    county_fips_all: '37187|37177',
    county: 'Washington',
    county_names_all: 'Washington|Tyrrell',
    county_weights: '{"37187": 72.98, "37177": 27.02}',
    density: 4.7,
    imprecise: false,
    latitude: 35.80857,
    longitude: -76.43579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27928',
  },
  {
    city: 'Currituck',
    county_fips: 37053,
    county_fips_all: '37053',
    county: 'Currituck',
    county_names_all: 'Currituck',
    county_weights: '{"37053": 100}',
    density: 81.8,
    imprecise: false,
    latitude: 36.42407,
    longitude: -76.02534,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27929',
  },
  {
    city: 'Edenton',
    county_fips: 37041,
    county_fips_all: '37041|37143',
    county: 'Chowan',
    county_names_all: 'Chowan|Perquimans',
    county_weights: '{"37041": 90.92, "37143": 9.08}',
    density: 37.7,
    imprecise: false,
    latitude: 36.10223,
    longitude: -76.59414,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27932',
  },
  {
    city: 'Eure',
    county_fips: 37073,
    county_fips_all: '37073',
    county: 'Gates',
    county_names_all: 'Gates',
    county_weights: '{"37073": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 36.43026,
    longitude: -76.85962,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27935',
  },
  {
    city: 'Frisco',
    county_fips: 37055,
    county_fips_all: '37055',
    county: 'Dare',
    county_names_all: 'Dare',
    county_weights: '{"37055": 100}',
    density: 49.2,
    imprecise: false,
    latitude: 35.24224,
    longitude: -75.60547,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27936',
  },
  {
    city: 'Gates',
    county_fips: 37073,
    county_fips_all: '37073',
    county: 'Gates',
    county_names_all: 'Gates',
    county_weights: '{"37073": 100}',
    density: 14,
    imprecise: false,
    latitude: 36.50453,
    longitude: -76.77726,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27937',
  },
  {
    city: 'Gatesville',
    county_fips: 37073,
    county_fips_all: '37073',
    county: 'Gates',
    county_names_all: 'Gates',
    county_weights: '{"37073": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 36.38422,
    longitude: -76.71628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27938',
  },
  {
    city: 'Grandy',
    county_fips: 37053,
    county_fips_all: '37053',
    county: 'Currituck',
    county_names_all: 'Currituck',
    county_weights: '{"37053": 100}',
    density: 111.5,
    imprecise: false,
    latitude: 36.23528,
    longitude: -75.87689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27939',
  },
  {
    city: 'Harbinger',
    county_fips: 37053,
    county_fips_all: '37053',
    county: 'Currituck',
    county_names_all: 'Currituck',
    county_weights: '{"37053": 100}',
    density: 97.3,
    imprecise: false,
    latitude: 36.09147,
    longitude: -75.81678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27941',
  },
  {
    city: 'Harrellsville',
    county_fips: 37091,
    county_fips_all: '37091',
    county: 'Hertford',
    county_names_all: 'Hertford',
    county_weights: '{"37091": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 36.28785,
    longitude: -76.7597,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27942',
  },
  {
    city: 'Hatteras',
    county_fips: 37055,
    county_fips_all: '37055',
    county: 'Dare',
    county_names_all: 'Dare',
    county_weights: '{"37055": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 35.21432,
    longitude: -75.69363,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27943',
  },
  {
    city: 'Hertford',
    county_fips: 37143,
    county_fips_all: '37143',
    county: 'Perquimans',
    county_names_all: 'Perquimans',
    county_weights: '{"37143": 100}',
    density: 25,
    imprecise: false,
    latitude: 36.17908,
    longitude: -76.41446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27944',
  },
  {
    city: 'Hobbsville',
    county_fips: 37073,
    county_fips_all: '37073|37041',
    county: 'Gates',
    county_names_all: 'Gates|Chowan',
    county_weights: '{"37073": 87.19, "37041": 12.81}',
    density: 8.9,
    imprecise: false,
    latitude: 36.35901,
    longitude: -76.59648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27946',
  },
  {
    city: 'Jarvisburg',
    county_fips: 37053,
    county_fips_all: '37053',
    county: 'Currituck',
    county_names_all: 'Currituck',
    county_weights: '{"37053": 100}',
    density: 38.4,
    imprecise: false,
    latitude: 36.20278,
    longitude: -75.86922,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27947',
  },
  {
    city: 'Kill Devil Hills',
    county_fips: 37055,
    county_fips_all: '37055',
    county: 'Dare',
    county_names_all: 'Dare',
    county_weights: '{"37055": 100}',
    density: 518.7,
    imprecise: false,
    latitude: 36.01761,
    longitude: -75.68663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27948',
  },
  {
    city: 'Kitty Hawk',
    county_fips: 37055,
    county_fips_all: '37055',
    county: 'Dare',
    county_names_all: 'Dare',
    county_weights: '{"37055": 100}',
    density: 210,
    imprecise: false,
    latitude: 36.10814,
    longitude: -75.73112,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27949',
  },
  {
    city: 'Knotts Island',
    county_fips: 37053,
    county_fips_all: '37053|51810',
    county: 'Currituck',
    county_names_all: 'Currituck|Virginia Beach',
    county_weights: '{"37053": 99.83, "51810": 0.17}',
    density: 23.3,
    imprecise: false,
    latitude: 36.52599,
    longitude: -76.00081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27950',
  },
  {
    city: 'Manns Harbor',
    county_fips: 37055,
    county_fips_all: '37055',
    county: 'Dare',
    county_names_all: 'Dare',
    county_weights: '{"37055": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 35.79298,
    longitude: -75.8685,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27953',
  },
  {
    city: 'Manteo',
    county_fips: 37055,
    county_fips_all: '37055',
    county: 'Dare',
    county_names_all: 'Dare',
    county_weights: '{"37055": 100}',
    density: 315.6,
    imprecise: false,
    latitude: 35.91056,
    longitude: -75.68202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27954',
  },
  {
    city: 'Maple',
    county_fips: 37053,
    county_fips_all: '37053',
    county: 'Currituck',
    county_names_all: 'Currituck',
    county_weights: '{"37053": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 36.39999,
    longitude: -76.00115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27956',
  },
  {
    city: 'Merry Hill',
    county_fips: 37015,
    county_fips_all: '37015',
    county: 'Bertie',
    county_names_all: 'Bertie',
    county_weights: '{"37015": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 36.05577,
    longitude: -76.76293,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27957',
  },
  {
    city: 'Moyock',
    county_fips: 37053,
    county_fips_all: '37053',
    county: 'Currituck',
    county_names_all: 'Currituck',
    county_weights: '{"37053": 100}',
    density: 69.7,
    imprecise: false,
    latitude: 36.48971,
    longitude: -76.15378,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27958',
  },
  {
    city: 'Nags Head',
    county_fips: 37055,
    county_fips_all: '37055',
    county: 'Dare',
    county_names_all: 'Dare',
    county_weights: '{"37055": 100}',
    density: 83.3,
    imprecise: false,
    latitude: 35.88566,
    longitude: -75.59641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27959',
  },
  {
    city: 'Ocracoke',
    county_fips: 37095,
    county_fips_all: '37095',
    county: 'Hyde',
    county_names_all: 'Hyde',
    county_weights: '{"37095": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 35.12593,
    longitude: -75.92165,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27960',
  },
  {
    city: 'Plymouth',
    county_fips: 37187,
    county_fips_all: '37187|37013',
    county: 'Washington',
    county_names_all: 'Washington|Beaufort',
    county_weights: '{"37187": 93.12, "37013": 6.88}',
    density: 32,
    imprecise: false,
    latitude: 35.78437,
    longitude: -76.75026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27962',
  },
  {
    city: 'Point Harbor',
    county_fips: 37053,
    county_fips_all: '37053',
    county: 'Currituck',
    county_names_all: 'Currituck',
    county_weights: '{"37053": 100}',
    density: 130.8,
    imprecise: false,
    latitude: 36.10074,
    longitude: -75.80438,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27964',
  },
  {
    city: 'Poplar Branch',
    county_fips: 37053,
    county_fips_all: '37053',
    county: 'Currituck',
    county_names_all: 'Currituck',
    county_weights: '{"37053": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 36.28404,
    longitude: -75.92681,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27965',
  },
  {
    city: 'Powells Point',
    county_fips: 37053,
    county_fips_all: '37053',
    county: 'Currituck',
    county_names_all: 'Currituck',
    county_weights: '{"37053": 100}',
    density: 55.6,
    imprecise: false,
    latitude: 36.13325,
    longitude: -75.83833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27966',
  },
  {
    city: 'Powellsville',
    county_fips: 37015,
    county_fips_all: '37015',
    county: 'Bertie',
    county_names_all: 'Bertie',
    county_weights: '{"37015": 100}',
    density: 41.6,
    imprecise: false,
    latitude: 36.22232,
    longitude: -76.90838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27967',
  },
  {
    city: 'Rodanthe',
    county_fips: 37055,
    county_fips_all: '37055',
    county: 'Dare',
    county_names_all: 'Dare',
    county_weights: '{"37055": 100}',
    density: 39.7,
    imprecise: false,
    latitude: 35.68549,
    longitude: -75.49195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27968',
  },
  {
    city: 'Roduco',
    county_fips: 37073,
    county_fips_all: '37073',
    county: 'Gates',
    county_names_all: 'Gates',
    county_weights: '{"37073": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 36.4633,
    longitude: -76.80259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27969',
  },
  {
    city: 'Roper',
    county_fips: 37187,
    county_fips_all: '37187',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"37187": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 35.87596,
    longitude: -76.57945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27970',
  },
  {
    city: 'Salvo',
    county_fips: 37055,
    county_fips_all: '37055',
    county: 'Dare',
    county_names_all: 'Dare',
    county_weights: '{"37055": 100}',
    density: 89.9,
    imprecise: false,
    latitude: 35.55427,
    longitude: -75.46986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27972',
  },
  {
    city: 'Shawboro',
    county_fips: 37053,
    county_fips_all: '37053|37029',
    county: 'Currituck',
    county_names_all: 'Currituck|Camden',
    county_weights: '{"37053": 62.54, "37029": 37.46}',
    density: 11.6,
    imprecise: false,
    latitude: 36.36448,
    longitude: -76.07058,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27973',
  },
  {
    city: 'Shiloh',
    county_fips: 37029,
    county_fips_all: '37029',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"37029": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 36.23941,
    longitude: -76.00264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27974',
  },
  {
    city: 'South Mills',
    county_fips: 37029,
    county_fips_all: '37029',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"37029": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 36.48185,
    longitude: -76.34005,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27976',
  },
  {
    city: 'Stumpy Point',
    county_fips: 37055,
    county_fips_all: '37055',
    county: 'Dare',
    county_names_all: 'Dare',
    county_weights: '{"37055": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 35.66438,
    longitude: -75.76959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27978',
  },
  {
    city: 'Sunbury',
    county_fips: 37073,
    county_fips_all: '37073',
    county: 'Gates',
    county_names_all: 'Gates',
    county_weights: '{"37073": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 36.44072,
    longitude: -76.56243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27979',
  },
  {
    city: 'Tyner',
    county_fips: 37041,
    county_fips_all: '37041|37143',
    county: 'Chowan',
    county_names_all: 'Chowan|Perquimans',
    county_weights: '{"37041": 87.6, "37143": 12.4}',
    density: 13,
    imprecise: false,
    latitude: 36.24292,
    longitude: -76.62161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27980',
  },
  {
    city: 'Wanchese',
    county_fips: 37055,
    county_fips_all: '37055',
    county: 'Dare',
    county_names_all: 'Dare',
    county_weights: '{"37055": 100}',
    density: 83.4,
    imprecise: false,
    latitude: 35.85602,
    longitude: -75.64041,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27981',
  },
  {
    city: 'Waves',
    county_fips: 37055,
    county_fips_all: '37055',
    county: 'Dare',
    county_names_all: 'Dare',
    county_weights: '{"37055": 100}',
    density: 84.1,
    imprecise: false,
    latitude: 35.5635,
    longitude: -75.46466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27982',
  },
  {
    city: 'Windsor',
    county_fips: 37015,
    county_fips_all: '37015',
    county: 'Bertie',
    county_names_all: 'Bertie',
    county_weights: '{"37015": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 35.98198,
    longitude: -76.94704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27983',
  },
  {
    city: 'Winfall',
    county_fips: 37143,
    county_fips_all: '37143',
    county: 'Perquimans',
    county_names_all: 'Perquimans',
    county_weights: '{"37143": 100}',
    density: 465.9,
    imprecise: false,
    latitude: 36.22085,
    longitude: -76.46928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27985',
  },
  {
    city: 'Winton',
    county_fips: 37091,
    county_fips_all: '37091',
    county: 'Hertford',
    county_names_all: 'Hertford',
    county_weights: '{"37091": 100}',
    density: 34.6,
    imprecise: false,
    latitude: 36.3891,
    longitude: -76.92816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27986',
  },
  {
    city: 'Albemarle',
    county_fips: 37167,
    county_fips_all: '37167',
    county: 'Stanly',
    county_names_all: 'Stanly',
    county_weights: '{"37167": 100}',
    density: 77.7,
    imprecise: false,
    latitude: 35.33594,
    longitude: -80.20419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28001',
  },
  {
    city: 'Alexis',
    county_fips: 37071,
    county_fips_all: '37071|37109',
    county: 'Gaston',
    county_names_all: 'Gaston|Lincoln',
    county_weights: '{"37071": 51.42, "37109": 48.58}',
    density: 127.3,
    imprecise: false,
    latitude: 35.40664,
    longitude: -81.0926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28006',
  },
  {
    city: 'Ansonville',
    county_fips: 37007,
    county_fips_all: '37007',
    county: 'Anson',
    county_names_all: 'Anson',
    county_weights: '{"37007": 100}',
    density: 37.2,
    imprecise: false,
    latitude: 35.12169,
    longitude: -80.13052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28007',
  },
  {
    city: 'Badin',
    county_fips: 37167,
    county_fips_all: '37167',
    county: 'Stanly',
    county_names_all: 'Stanly',
    county_weights: '{"37167": 100}',
    density: 198.1,
    imprecise: false,
    latitude: 35.40826,
    longitude: -80.10743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28009',
  },
  {
    city: 'Belmont',
    county_fips: 37071,
    county_fips_all: '37071',
    county: 'Gaston',
    county_names_all: 'Gaston',
    county_weights: '{"37071": 100}',
    density: 376.2,
    imprecise: false,
    latitude: 35.21054,
    longitude: -81.04077,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28012',
  },
  {
    city: 'Bessemer City',
    county_fips: 37071,
    county_fips_all: '37071',
    county: 'Gaston',
    county_names_all: 'Gaston',
    county_weights: '{"37071": 100}',
    density: 117.8,
    imprecise: false,
    latitude: 35.31729,
    longitude: -81.28737,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28016',
  },
  {
    city: 'Boiling Springs',
    county_fips: 37045,
    county_fips_all: '37045',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"37045": 100}',
    density: 1490.4,
    imprecise: false,
    latitude: 35.24708,
    longitude: -81.67059,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28017',
  },
  {
    city: 'Bostic',
    county_fips: 37161,
    county_fips_all: '37161',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"37161": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 35.48458,
    longitude: -81.79393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28018',
  },
  {
    city: 'Caroleen',
    county_fips: 37161,
    county_fips_all: '37161',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"37161": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.28395,
    longitude: -81.79396,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28019',
  },
  {
    city: 'Casar',
    county_fips: 37045,
    county_fips_all: '37045|37161',
    county: 'Cleveland',
    county_names_all: 'Cleveland|Rutherford',
    county_weights: '{"37045": 87.31, "37161": 12.69}',
    density: 18.7,
    imprecise: false,
    latitude: 35.52408,
    longitude: -81.64328,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28020',
  },
  {
    city: 'Cherryville',
    county_fips: 37071,
    county_fips_all: '37071|37109|37045',
    county: 'Gaston',
    county_names_all: 'Gaston|Lincoln|Cleveland',
    county_weights: '{"37071": 43.01, "37109": 32.25, "37045": 24.74}',
    density: 91,
    imprecise: false,
    latitude: 35.39952,
    longitude: -81.41035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28021',
  },
  {
    city: 'China Grove',
    county_fips: 37159,
    county_fips_all: '37159',
    county: 'Rowan',
    county_names_all: 'Rowan',
    county_weights: '{"37159": 100}',
    density: 128.6,
    imprecise: false,
    latitude: 35.56922,
    longitude: -80.60321,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28023',
  },
  {
    city: 'Cliffside',
    county_fips: 37161,
    county_fips_all: '37161',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"37161": 100}',
    density: 42.2,
    imprecise: false,
    latitude: 35.24347,
    longitude: -81.77066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28024',
  },
  {
    city: 'Concord',
    county_fips: 37025,
    county_fips_all: '37025',
    county: 'Cabarrus',
    county_names_all: 'Cabarrus',
    county_weights: '{"37025": 100}',
    density: 207.8,
    imprecise: false,
    latitude: 35.38095,
    longitude: -80.52719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28025',
  },
  {
    city: 'Concord',
    county_fips: 37025,
    county_fips_all: '37025',
    county: 'Cabarrus',
    county_names_all: 'Cabarrus',
    county_weights: '{"37025": 100}',
    density: 457.6,
    imprecise: false,
    latitude: 35.40879,
    longitude: -80.67524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 81772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28027',
  },
  {
    city: 'Cornelius',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 876.4,
    imprecise: false,
    latitude: 35.47539,
    longitude: -80.89344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28031',
  },
  {
    city: 'Cramerton',
    county_fips: 37071,
    county_fips_all: '37071',
    county: 'Gaston',
    county_names_all: 'Gaston',
    county_weights: '{"37071": 100}',
    density: 534,
    imprecise: false,
    latitude: 35.23354,
    longitude: -81.07925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28032',
  },
  {
    city: 'Crouse',
    county_fips: 37109,
    county_fips_all: '37109|37071',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Gaston',
    county_weights: '{"37109": 63.4, "37071": 36.6}',
    density: 83.3,
    imprecise: false,
    latitude: 35.42005,
    longitude: -81.3239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28033',
  },
  {
    city: 'Dallas',
    county_fips: 37071,
    county_fips_all: '37071',
    county: 'Gaston',
    county_names_all: 'Gaston',
    county_weights: '{"37071": 100}',
    density: 160.5,
    imprecise: false,
    latitude: 35.35323,
    longitude: -81.18016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28034',
  },
  {
    city: 'Davidson',
    county_fips: 37119,
    county_fips_all: '37119|37025|37097|37159',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg|Cabarrus|Iredell|Rowan',
    county_weights:
      '{"37119": 59.06, "37025": 32.73, "37097": 7.89, "37159": 0.32}',
    density: 378.4,
    imprecise: false,
    latitude: 35.48586,
    longitude: -80.79375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28036',
  },
  {
    city: 'Denver',
    county_fips: 37109,
    county_fips_all: '37109|37035',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Catawba',
    county_weights: '{"37109": 89.75, "37035": 10.25}',
    density: 248.3,
    imprecise: false,
    latitude: 35.5064,
    longitude: -81.01712,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28037',
  },
  {
    city: 'East Spencer',
    county_fips: 37159,
    county_fips_all: '37159',
    county: 'Rowan',
    county_names_all: 'Rowan',
    county_weights: '{"37159": 100}',
    density: 256.1,
    imprecise: false,
    latitude: 35.6803,
    longitude: -80.43626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28039',
  },
  {
    city: 'Ellenboro',
    county_fips: 37161,
    county_fips_all: '37161|37045',
    county: 'Rutherford',
    county_names_all: 'Rutherford|Cleveland',
    county_weights: '{"37161": 96.15, "37045": 3.85}',
    density: 39.7,
    imprecise: false,
    latitude: 35.38738,
    longitude: -81.74762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28040',
  },
  {
    city: 'Faith',
    county_fips: 37159,
    county_fips_all: '37159',
    county: 'Rowan',
    county_names_all: 'Rowan',
    county_weights: '{"37159": 100}',
    density: 24.5,
    imprecise: false,
    latitude: 35.58747,
    longitude: -80.46249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28041',
  },
  {
    city: 'Fallston',
    county_fips: 37045,
    county_fips_all: '37045',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"37045": 100}',
    density: 229.1,
    imprecise: false,
    latitude: 35.42334,
    longitude: -81.50747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28042',
  },
  {
    city: 'Forest City',
    county_fips: 37161,
    county_fips_all: '37161',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"37161": 100}',
    density: 121.9,
    imprecise: false,
    latitude: 35.31301,
    longitude: -81.86971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28043',
  },
  {
    city: 'Gastonia',
    county_fips: 37071,
    county_fips_all: '37071',
    county: 'Gaston',
    county_names_all: 'Gaston',
    county_weights: '{"37071": 100}',
    density: 338.2,
    imprecise: false,
    latitude: 35.22492,
    longitude: -81.23266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28052',
  },
  {
    city: 'Gastonia',
    county_fips: 37071,
    county_fips_all: '37071',
    county: 'Gaston',
    county_names_all: 'Gaston',
    county_weights: '{"37071": 100}',
    density: 832.9,
    imprecise: false,
    latitude: 35.26128,
    longitude: -81.15072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28054',
  },
  {
    city: 'Gastonia',
    county_fips: 37071,
    county_fips_all: '37071',
    county: 'Gaston',
    county_names_all: 'Gaston',
    county_weights: '{"37071": 100}',
    density: 289.6,
    imprecise: false,
    latitude: 35.21768,
    longitude: -81.12503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28056',
  },
  {
    city: 'Gold Hill',
    county_fips: 37159,
    county_fips_all: '37159|37025|37167',
    county: 'Rowan',
    county_names_all: 'Rowan|Cabarrus|Stanly',
    county_weights: '{"37159": 66.85, "37025": 26.62, "37167": 6.53}',
    density: 33.4,
    imprecise: false,
    latitude: 35.51859,
    longitude: -80.32175,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28071',
  },
  {
    city: 'Granite Quarry',
    county_fips: 37159,
    county_fips_all: '37159',
    county: 'Rowan',
    county_names_all: 'Rowan',
    county_weights: '{"37159": 100}',
    density: 325.3,
    imprecise: false,
    latitude: 35.61326,
    longitude: -80.44241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28072',
  },
  {
    city: 'Grover',
    county_fips: 37045,
    county_fips_all: '37045',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"37045": 100}',
    density: 88.4,
    imprecise: false,
    latitude: 35.19776,
    longitude: -81.48126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28073',
  },
  {
    city: 'Harris',
    county_fips: 37161,
    county_fips_all: '37161',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"37161": 100}',
    density: 47,
    imprecise: false,
    latitude: 35.23933,
    longitude: -81.8783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28074',
  },
  {
    city: 'Harrisburg',
    county_fips: 37025,
    county_fips_all: '37025',
    county: 'Cabarrus',
    county_names_all: 'Cabarrus',
    county_weights: '{"37025": 100}',
    density: 393.8,
    imprecise: false,
    latitude: 35.30192,
    longitude: -80.63929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28075',
  },
  {
    city: 'Henrietta',
    county_fips: 37161,
    county_fips_all: '37161',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"37161": 100}',
    density: 38.8,
    imprecise: false,
    latitude: 35.25904,
    longitude: -81.79074,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28076',
  },
  {
    city: 'High Shoals',
    county_fips: 37071,
    county_fips_all: '37071',
    county: 'Gaston',
    county_names_all: 'Gaston',
    county_weights: '{"37071": 100}',
    density: 170.4,
    imprecise: false,
    latitude: 35.40413,
    longitude: -81.20284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28077',
  },
  {
    city: 'Huntersville',
    county_fips: 37119,
    county_fips_all: '37119|37025',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg|Cabarrus',
    county_weights: '{"37119": 98.19, "37025": 1.81}',
    density: 434.2,
    imprecise: false,
    latitude: 35.40545,
    longitude: -80.86633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28078',
  },
  {
    city: 'Indian Trail',
    county_fips: 37179,
    county_fips_all: '37179',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"37179": 100}',
    density: 356.5,
    imprecise: false,
    latitude: 35.1132,
    longitude: -80.60183,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28079',
  },
  {
    city: 'Iron Station',
    county_fips: 37109,
    county_fips_all: '37109|37071',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Gaston',
    county_weights: '{"37109": 99.56, "37071": 0.44}',
    density: 72.9,
    imprecise: false,
    latitude: 35.45269,
    longitude: -81.10995,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28080',
  },
  {
    city: 'Kannapolis',
    county_fips: 37025,
    county_fips_all: '37025|37159',
    county: 'Cabarrus',
    county_names_all: 'Cabarrus|Rowan',
    county_weights: '{"37025": 50.66, "37159": 49.34}',
    density: 370.8,
    imprecise: false,
    latitude: 35.50199,
    longitude: -80.67024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28081',
  },
  {
    city: 'Kannapolis',
    county_fips: 37025,
    county_fips_all: '37025|37159',
    county: 'Cabarrus',
    county_names_all: 'Cabarrus|Rowan',
    county_weights: '{"37025": 75.27, "37159": 24.73}',
    density: 542.4,
    imprecise: false,
    latitude: 35.49108,
    longitude: -80.58092,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28083',
  },
  {
    city: 'Kings Mountain',
    county_fips: 37045,
    county_fips_all: '37045|37071',
    county: 'Cleveland',
    county_names_all: 'Cleveland|Gaston',
    county_weights: '{"37045": 74.19, "37071": 25.81}',
    density: 125.6,
    imprecise: false,
    latitude: 35.24381,
    longitude: -81.37028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28086',
  },
  {
    city: 'Landis',
    county_fips: 37159,
    county_fips_all: '37159',
    county: 'Rowan',
    county_names_all: 'Rowan',
    county_weights: '{"37159": 100}',
    density: 415.5,
    imprecise: false,
    latitude: 35.54437,
    longitude: -80.61463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28088',
  },
  {
    city: 'Lattimore',
    county_fips: 37045,
    county_fips_all: '37045',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"37045": 100}',
    density: 154.5,
    imprecise: false,
    latitude: 35.3202,
    longitude: -81.66067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28089',
  },
  {
    city: 'Lawndale',
    county_fips: 37045,
    county_fips_all: '37045|37109|37023|37035',
    county: 'Cleveland',
    county_names_all: 'Cleveland|Lincoln|Burke|Catawba',
    county_weights:
      '{"37045": 94.26, "37109": 3.46, "37023": 1.22, "37035": 1.06}',
    density: 29.9,
    imprecise: false,
    latitude: 35.45987,
    longitude: -81.55957,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28090',
  },
  {
    city: 'Lilesville',
    county_fips: 37007,
    county_fips_all: '37007',
    county: 'Anson',
    county_names_all: 'Anson',
    county_weights: '{"37007": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 34.98628,
    longitude: -79.93171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28091',
  },
  {
    city: 'Lincolnton',
    county_fips: 37109,
    county_fips_all: '37109|37071|37035',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Gaston|Catawba',
    county_weights: '{"37109": 87.49, "37071": 7.89, "37035": 4.62}',
    density: 129.9,
    imprecise: false,
    latitude: 35.48404,
    longitude: -81.25391,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28092',
  },
  {
    city: 'Locust',
    county_fips: 37167,
    county_fips_all: '37167|37025',
    county: 'Stanly',
    county_names_all: 'Stanly|Cabarrus',
    county_weights: '{"37167": 98.05, "37025": 1.95}',
    density: 106.5,
    imprecise: false,
    latitude: 35.29675,
    longitude: -80.39327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28097',
  },
  {
    city: 'Lowell',
    county_fips: 37071,
    county_fips_all: '37071',
    county: 'Gaston',
    county_names_all: 'Gaston',
    county_weights: '{"37071": 100}',
    density: 408.3,
    imprecise: false,
    latitude: 35.27057,
    longitude: -81.09749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28098',
  },
  {
    city: 'McAdenville',
    county_fips: 37071,
    county_fips_all: '37071',
    county: 'Gaston',
    county_names_all: 'Gaston',
    county_weights: '{"37071": 100}',
    density: 679.5,
    imprecise: false,
    latitude: 35.25703,
    longitude: -81.07572,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28101',
  },
  {
    city: 'McFarlan',
    county_fips: 37007,
    county_fips_all: '37007',
    county: 'Anson',
    county_names_all: 'Anson',
    county_weights: '{"37007": 100}',
    density: 68.9,
    imprecise: false,
    latitude: 34.81482,
    longitude: -79.97663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28102',
  },
  {
    city: 'Marshville',
    county_fips: 37179,
    county_fips_all: '37179|37007',
    county: 'Union',
    county_names_all: 'Union|Anson',
    county_weights: '{"37179": 97.52, "37007": 2.48}',
    density: 27,
    imprecise: false,
    latitude: 35.0037,
    longitude: -80.35316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28103',
  },
  {
    city: 'Matthews',
    county_fips: 37179,
    county_fips_all: '37179|37119',
    county: 'Union',
    county_names_all: 'Union|Mecklenburg',
    county_weights: '{"37179": 96.91, "37119": 3.09}',
    density: 477.9,
    imprecise: false,
    latitude: 35.06017,
    longitude: -80.69666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28104',
  },
  {
    city: 'Matthews',
    county_fips: 37119,
    county_fips_all: '37119|37179',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg|Union',
    county_weights: '{"37119": 98.57, "37179": 1.43}',
    density: 778,
    imprecise: false,
    latitude: 35.11914,
    longitude: -80.71116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28105',
  },
  {
    city: 'Midland',
    county_fips: 37025,
    county_fips_all: '37025|37119|37179|37167',
    county: 'Cabarrus',
    county_names_all: 'Cabarrus|Mecklenburg|Union|Stanly',
    county_weights:
      '{"37025": 91.45, "37119": 3.87, "37179": 3.08, "37167": 1.6}',
    density: 80.9,
    imprecise: false,
    latitude: 35.24992,
    longitude: -80.52115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28107',
  },
  {
    city: 'Mineral Springs',
    county_fips: 37179,
    county_fips_all: '37179',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"37179": 100}',
    density: 64,
    imprecise: false,
    latitude: 34.93411,
    longitude: -80.67975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28108',
  },
  {
    city: 'Misenheimer',
    county_fips: 37167,
    county_fips_all: '37167',
    county: 'Stanly',
    county_names_all: 'Stanly',
    county_weights: '{"37167": 100}',
    density: 445,
    imprecise: false,
    latitude: 35.48609,
    longitude: -80.28628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28109',
  },
  {
    city: 'Monroe',
    county_fips: 37179,
    county_fips_all: '37179',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"37179": 100}',
    density: 172.7,
    imprecise: false,
    latitude: 35.06552,
    longitude: -80.52781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28110',
  },
  {
    city: 'Monroe',
    county_fips: 37179,
    county_fips_all: '37179',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"37179": 100}',
    density: 83.2,
    imprecise: false,
    latitude: 34.89355,
    longitude: -80.54113,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28112',
  },
  {
    city: 'Mooresboro',
    county_fips: 37045,
    county_fips_all: '37045|37161',
    county: 'Cleveland',
    county_names_all: 'Cleveland|Rutherford',
    county_weights: '{"37045": 54.43, "37161": 45.57}',
    density: 41.8,
    imprecise: false,
    latitude: 35.23,
    longitude: -81.74814,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28114',
  },
  {
    city: 'Mooresville',
    county_fips: 37097,
    county_fips_all: '37097|37159',
    county: 'Iredell',
    county_names_all: 'Iredell|Rowan',
    county_weights: '{"37097": 70.68, "37159": 29.32}',
    density: 225.3,
    imprecise: false,
    latitude: 35.58001,
    longitude: -80.77477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28115',
  },
  {
    city: 'Mooresville',
    county_fips: 37097,
    county_fips_all: '37097',
    county: 'Iredell',
    county_names_all: 'Iredell',
    county_weights: '{"37097": 100}',
    density: 482.2,
    imprecise: false,
    latitude: 35.57405,
    longitude: -80.89658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28117',
  },
  {
    city: 'Morven',
    county_fips: 37007,
    county_fips_all: '37007',
    county: 'Anson',
    county_names_all: 'Anson',
    county_weights: '{"37007": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 34.85112,
    longitude: -80.01492,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28119',
  },
  {
    city: 'Mount Holly',
    county_fips: 37071,
    county_fips_all: '37071',
    county: 'Gaston',
    county_names_all: 'Gaston',
    county_weights: '{"37071": 100}',
    density: 317.6,
    imprecise: false,
    latitude: 35.33305,
    longitude: -81.02692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28120',
  },
  {
    city: 'Mount Pleasant',
    county_fips: 37025,
    county_fips_all: '37025|37167',
    county: 'Cabarrus',
    county_names_all: 'Cabarrus|Stanly',
    county_weights: '{"37025": 86.24, "37167": 13.76}',
    density: 46.6,
    imprecise: false,
    latitude: 35.40136,
    longitude: -80.40406,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28124',
  },
  {
    city: 'Mount Ulla',
    county_fips: 37159,
    county_fips_all: '37159|37097',
    county: 'Rowan',
    county_names_all: 'Rowan|Iredell',
    county_weights: '{"37159": 95.11, "37097": 4.89}',
    density: 27.8,
    imprecise: false,
    latitude: 35.66061,
    longitude: -80.69949,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28125',
  },
  {
    city: 'New London',
    county_fips: 37167,
    county_fips_all: '37167|37123|37057|37159',
    county: 'Stanly',
    county_names_all: 'Stanly|Montgomery|Davidson|Rowan',
    county_weights:
      '{"37167": 60.29, "37123": 33.76, "37057": 4.99, "37159": 0.95}',
    density: 44,
    imprecise: false,
    latitude: 35.44978,
    longitude: -80.16552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28127',
  },
  {
    city: 'Norwood',
    county_fips: 37167,
    county_fips_all: '37167',
    county: 'Stanly',
    county_names_all: 'Stanly',
    county_weights: '{"37167": 100}',
    density: 37.2,
    imprecise: false,
    latitude: 35.21476,
    longitude: -80.15862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28128',
  },
  {
    city: 'Oakboro',
    county_fips: 37167,
    county_fips_all: '37167',
    county: 'Stanly',
    county_names_all: 'Stanly',
    county_weights: '{"37167": 100}',
    density: 52.1,
    imprecise: false,
    latitude: 35.23224,
    longitude: -80.32737,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28129',
  },
  {
    city: 'Peachland',
    county_fips: 37007,
    county_fips_all: '37007|37179',
    county: 'Anson',
    county_names_all: 'Anson|Union',
    county_weights: '{"37007": 95.64, "37179": 4.36}',
    density: 9.7,
    imprecise: false,
    latitude: 34.93468,
    longitude: -80.26239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28133',
  },
  {
    city: 'Pineville',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 613.2,
    imprecise: false,
    latitude: 35.08364,
    longitude: -80.89125,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28134',
  },
  {
    city: 'Polkton',
    county_fips: 37007,
    county_fips_all: '37007',
    county: 'Anson',
    county_names_all: 'Anson',
    county_weights: '{"37007": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 35.03547,
    longitude: -80.21412,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28135',
  },
  {
    city: 'Polkville',
    county_fips: 37045,
    county_fips_all: '37045',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"37045": 100}',
    density: 326,
    imprecise: false,
    latitude: 35.4206,
    longitude: -81.64241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28136',
  },
  {
    city: 'Richfield',
    county_fips: 37167,
    county_fips_all: '37167|37159',
    county: 'Stanly',
    county_names_all: 'Stanly|Rowan',
    county_weights: '{"37167": 54.26, "37159": 45.74}',
    density: 23.2,
    imprecise: false,
    latitude: 35.50009,
    longitude: -80.25783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28137',
  },
  {
    city: 'Rockwell',
    county_fips: 37159,
    county_fips_all: '37159|37025',
    county: 'Rowan',
    county_names_all: 'Rowan|Cabarrus',
    county_weights: '{"37159": 74.97, "37025": 25.03}',
    density: 88.2,
    imprecise: false,
    latitude: 35.52121,
    longitude: -80.44193,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28138',
  },
  {
    city: 'Rutherfordton',
    county_fips: 37161,
    county_fips_all: '37161|37149',
    county: 'Rutherford',
    county_names_all: 'Rutherford|Polk',
    county_weights: '{"37161": 86.68, "37149": 13.32}',
    density: 42.5,
    imprecise: false,
    latitude: 35.34736,
    longitude: -81.99702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28139',
  },
  {
    city: 'Salisbury',
    county_fips: 37159,
    county_fips_all: '37159',
    county: 'Rowan',
    county_names_all: 'Rowan',
    county_weights: '{"37159": 100}',
    density: 359.2,
    imprecise: false,
    latitude: 35.70645,
    longitude: -80.46341,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28144',
  },
  {
    city: 'Salisbury',
    county_fips: 37159,
    county_fips_all: '37159',
    county: 'Rowan',
    county_names_all: 'Rowan',
    county_weights: '{"37159": 100}',
    density: 124.4,
    imprecise: false,
    latitude: 35.62194,
    longitude: -80.39563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28146',
  },
  {
    city: 'Salisbury',
    county_fips: 37159,
    county_fips_all: '37159',
    county: 'Rowan',
    county_names_all: 'Rowan',
    county_weights: '{"37159": 100}',
    density: 128.4,
    imprecise: false,
    latitude: 35.67997,
    longitude: -80.56275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28147',
  },
  {
    city: 'Shelby',
    county_fips: 37045,
    county_fips_all: '37045|37161',
    county: 'Cleveland',
    county_names_all: 'Cleveland|Rutherford',
    county_weights: '{"37045": 99.76, "37161": 0.24}',
    density: 99.2,
    imprecise: false,
    latitude: 35.34712,
    longitude: -81.57502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28150',
  },
  {
    city: 'Shelby',
    county_fips: 37045,
    county_fips_all: '37045',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"37045": 100}',
    density: 126.9,
    imprecise: false,
    latitude: 35.24188,
    longitude: -81.59289,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28152',
  },
  {
    city: 'Spencer',
    county_fips: 37159,
    county_fips_all: '37159',
    county: 'Rowan',
    county_names_all: 'Rowan',
    county_weights: '{"37159": 100}',
    density: 561.5,
    imprecise: false,
    latitude: 35.69411,
    longitude: -80.43528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28159',
  },
  {
    city: 'Spindale',
    county_fips: 37161,
    county_fips_all: '37161',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"37161": 100}',
    density: 257,
    imprecise: false,
    latitude: 35.36064,
    longitude: -81.92234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28160',
  },
  {
    city: 'Stanfield',
    county_fips: 37167,
    county_fips_all: '37167',
    county: 'Stanly',
    county_names_all: 'Stanly',
    county_weights: '{"37167": 100}',
    density: 72,
    imprecise: false,
    latitude: 35.20702,
    longitude: -80.4285,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28163',
  },
  {
    city: 'Stanley',
    county_fips: 37071,
    county_fips_all: '37071|37109',
    county: 'Gaston',
    county_names_all: 'Gaston|Lincoln',
    county_weights: '{"37071": 62.79, "37109": 37.21}',
    density: 158.9,
    imprecise: false,
    latitude: 35.39091,
    longitude: -81.03846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28164',
  },
  {
    city: 'Troutman',
    county_fips: 37097,
    county_fips_all: '37097',
    county: 'Iredell',
    county_names_all: 'Iredell',
    county_weights: '{"37097": 100}',
    density: 158.1,
    imprecise: false,
    latitude: 35.68025,
    longitude: -80.87528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28166',
  },
  {
    city: 'Union Mills',
    county_fips: 37161,
    county_fips_all: '37161|37111',
    county: 'Rutherford',
    county_names_all: 'Rutherford|McDowell',
    county_weights: '{"37161": 93.31, "37111": 6.69}',
    density: 11.8,
    imprecise: false,
    latitude: 35.5062,
    longitude: -81.95986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28167',
  },
  {
    city: 'Vale',
    county_fips: 37109,
    county_fips_all: '37109|37035|37023|37045',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Catawba|Burke|Cleveland',
    county_weights:
      '{"37109": 59.21, "37035": 40.47, "37023": 0.22, "37045": 0.1}',
    density: 46.5,
    imprecise: false,
    latitude: 35.55452,
    longitude: -81.42228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28168',
  },
  {
    city: 'Waco',
    county_fips: 37045,
    county_fips_all: '37045',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"37045": 100}',
    density: 71.1,
    imprecise: false,
    latitude: 35.36036,
    longitude: -81.42935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28169',
  },
  {
    city: 'Wadesboro',
    county_fips: 37007,
    county_fips_all: '37007',
    county: 'Anson',
    county_names_all: 'Anson',
    county_weights: '{"37007": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 34.99263,
    longitude: -80.09259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28170',
  },
  {
    city: 'Waxhaw',
    county_fips: 37179,
    county_fips_all: '37179',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"37179": 100}',
    density: 237,
    imprecise: false,
    latitude: 34.91532,
    longitude: -80.73021,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28173',
  },
  {
    city: 'Wingate',
    county_fips: 37179,
    county_fips_all: '37179',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"37179": 100}',
    density: 101.5,
    imprecise: false,
    latitude: 34.96959,
    longitude: -80.4382,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28174',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 3777.5,
    imprecise: false,
    latitude: 35.22773,
    longitude: -80.8447,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28202',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 2320.2,
    imprecise: false,
    latitude: 35.20832,
    longitude: -80.8577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28203',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 2039.3,
    imprecise: false,
    latitude: 35.21469,
    longitude: -80.82677,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28204',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 1691.2,
    imprecise: false,
    latitude: 35.22019,
    longitude: -80.78737,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28205',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 850.7,
    imprecise: false,
    latitude: 35.25631,
    longitude: -80.82144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28206',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 1514,
    imprecise: false,
    latitude: 35.19512,
    longitude: -80.82606,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28207',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 767,
    imprecise: false,
    latitude: 35.23153,
    longitude: -80.90611,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28208',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 1710.9,
    imprecise: false,
    latitude: 35.17878,
    longitude: -80.85418,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28209',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 1474.3,
    imprecise: false,
    latitude: 35.12969,
    longitude: -80.8548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28210',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 1196,
    imprecise: false,
    latitude: 35.16816,
    longitude: -80.79604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28211',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 1784,
    imprecise: false,
    latitude: 35.1896,
    longitude: -80.74519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28212',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119|37025',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg|Cabarrus',
    county_weights: '{"37119": 98.16, "37025": 1.84}',
    density: 1246.1,
    imprecise: false,
    latitude: 35.28459,
    longitude: -80.73339,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28213',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 499.2,
    imprecise: false,
    latitude: 35.27177,
    longitude: -80.96847,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28214',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119|37025',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg|Cabarrus',
    county_weights: '{"37119": 93.02, "37025": 6.98}',
    density: 892.3,
    imprecise: false,
    latitude: 35.24854,
    longitude: -80.69571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28215',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 739.6,
    imprecise: false,
    latitude: 35.31039,
    longitude: -80.8883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28216',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 829.1,
    imprecise: false,
    latitude: 35.17146,
    longitude: -80.9077,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28217',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 1032.5,
    imprecise: false,
    latitude: 35.10767,
    longitude: -80.81837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28226',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119|37179',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg|Union',
    county_weights: '{"37119": 99.21, "37179": 0.79}',
    density: 581.5,
    imprecise: false,
    latitude: 35.18851,
    longitude: -80.6507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28227',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119|37025',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg|Cabarrus',
    county_weights: '{"37119": 99.07, "37025": 0.93}',
    density: 919,
    imprecise: false,
    latitude: 35.32609,
    longitude: -80.74234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28262',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119|37025',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg|Cabarrus',
    county_weights: '{"37119": 96.93, "37025": 3.07}',
    density: 1005.1,
    imprecise: false,
    latitude: 35.33747,
    longitude: -80.8026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 79586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28269',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 1008.3,
    imprecise: false,
    latitude: 35.10963,
    longitude: -80.76005,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28270',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 873.9,
    imprecise: false,
    latitude: 35.12624,
    longitude: -80.94469,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28273',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 1181.3,
    imprecise: false,
    latitude: 35.05212,
    longitude: -80.81622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 73882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28277',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 501.5,
    imprecise: false,
    latitude: 35.13063,
    longitude: -81.00753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28278',
  },
  {
    city: 'Fayetteville',
    county_fips: 37051,
    county_fips_all: '37051',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"37051": 100}',
    density: 523.2,
    imprecise: false,
    latitude: 35.07442,
    longitude: -78.88376,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28301',
  },
  {
    city: 'Fayetteville',
    county_fips: 37051,
    county_fips_all: '37051',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"37051": 100}',
    density: 776.4,
    imprecise: false,
    latitude: 35.0852,
    longitude: -78.95815,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28303',
  },
  {
    city: 'Fayetteville',
    county_fips: 37051,
    county_fips_all: '37051|37093',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Hoke',
    county_weights: '{"37051": 97.53, "37093": 2.47}',
    density: 824.5,
    imprecise: false,
    latitude: 35.02498,
    longitude: -78.99072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28304',
  },
  {
    city: 'Fayetteville',
    county_fips: 37051,
    county_fips_all: '37051',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"37051": 100}',
    density: 847.7,
    imprecise: false,
    latitude: 35.05321,
    longitude: -78.90687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28305',
  },
  {
    city: 'Fayetteville',
    county_fips: 37051,
    county_fips_all: '37051|37017|37093',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Bladen|Hoke',
    county_weights: '{"37051": 95.23, "37017": 3.64, "37093": 1.13}',
    density: 238.3,
    imprecise: false,
    latitude: 34.9582,
    longitude: -78.89487,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28306',
  },
  {
    city: 'Fort Bragg',
    county_fips: 37051,
    county_fips_all: '37051',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"37051": 100}',
    density: 617.6,
    imprecise: false,
    latitude: 35.14154,
    longitude: -78.99447,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28307',
  },
  {
    city: 'Fayetteville',
    county_fips: 37051,
    county_fips_all: '37051',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"37051": 100}',
    density: 387.2,
    imprecise: false,
    latitude: 35.17033,
    longitude: -78.88223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28311',
  },
  {
    city: 'Fayetteville',
    county_fips: 37051,
    county_fips_all: '37051|37017',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Bladen',
    county_weights: '{"37051": 85.37, "37017": 14.63}',
    density: 46.6,
    imprecise: false,
    latitude: 34.94713,
    longitude: -78.73225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28312',
  },
  {
    city: 'Fayetteville',
    county_fips: 37051,
    county_fips_all: '37051',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"37051": 100}',
    density: 1112.2,
    imprecise: false,
    latitude: 35.0557,
    longitude: -79.01678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28314',
  },
  {
    city: 'Aberdeen',
    county_fips: 37125,
    county_fips_all: '37125|37093',
    county: 'Moore',
    county_names_all: 'Moore|Hoke',
    county_weights: '{"37125": 66.46, "37093": 33.54}',
    density: 83.7,
    imprecise: false,
    latitude: 35.1122,
    longitude: -79.44452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28315',
  },
  {
    city: 'Autryville',
    county_fips: 37163,
    county_fips_all: '37163|37051',
    county: 'Sampson',
    county_names_all: 'Sampson|Cumberland',
    county_weights: '{"37163": 68.83, "37051": 31.17}',
    density: 17.4,
    imprecise: false,
    latitude: 35.0176,
    longitude: -78.61665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28318',
  },
  {
    city: 'Bladenboro',
    county_fips: 37017,
    county_fips_all: '37017|37047',
    county: 'Bladen',
    county_names_all: 'Bladen|Columbus',
    county_weights: '{"37017": 94.24, "37047": 5.76}',
    density: 26.5,
    imprecise: false,
    latitude: 34.55378,
    longitude: -78.77456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28320',
  },
  {
    city: 'Bunnlevel',
    county_fips: 37085,
    county_fips_all: '37085',
    county: 'Harnett',
    county_names_all: 'Harnett',
    county_weights: '{"37085": 100}',
    density: 49.5,
    imprecise: false,
    latitude: 35.31192,
    longitude: -78.83842,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28323',
  },
  {
    city: 'Calypso',
    county_fips: 37061,
    county_fips_all: '37061',
    county: 'Duplin',
    county_names_all: 'Duplin',
    county_weights: '{"37061": 100}',
    density: 156.4,
    imprecise: false,
    latitude: 35.15335,
    longitude: -78.10425,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28325',
  },
  {
    city: 'Cameron',
    county_fips: 37085,
    county_fips_all: '37085|37125|37105',
    county: 'Harnett',
    county_names_all: 'Harnett|Moore|Lee',
    county_weights: '{"37085": 56.43, "37125": 36.04, "37105": 7.53}',
    density: 85.5,
    imprecise: false,
    latitude: 35.27938,
    longitude: -79.16989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28326',
  },
  {
    city: 'Carthage',
    county_fips: 37125,
    county_fips_all: '37125',
    county: 'Moore',
    county_names_all: 'Moore',
    county_weights: '{"37125": 100}',
    density: 40.1,
    imprecise: false,
    latitude: 35.35759,
    longitude: -79.42333,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28327',
  },
  {
    city: 'Clinton',
    county_fips: 37163,
    county_fips_all: '37163',
    county: 'Sampson',
    county_names_all: 'Sampson',
    county_weights: '{"37163": 100}',
    density: 42.3,
    imprecise: false,
    latitude: 35.00504,
    longitude: -78.33513,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28328',
  },
  {
    city: 'Cordova',
    county_fips: 37153,
    county_fips_all: '37153',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"37153": 100}',
    density: 351.7,
    imprecise: false,
    latitude: 34.91077,
    longitude: -79.82332,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28330',
  },
  {
    city: 'Cumberland',
    county_fips: 37051,
    county_fips_all: '37051',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"37051": 100}',
    density: 93.6,
    imprecise: false,
    latitude: 35.19883,
    longitude: -78.64944,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28331',
  },
  {
    city: 'Dublin',
    county_fips: 37017,
    county_fips_all: '37017',
    county: 'Bladen',
    county_names_all: 'Bladen',
    county_weights: '{"37017": 100}',
    density: 73.2,
    imprecise: false,
    latitude: 34.65808,
    longitude: -78.70971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28332',
  },
  {
    city: 'Dudley',
    county_fips: 37191,
    county_fips_all: '37191',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"37191": 100}',
    density: 89,
    imprecise: false,
    latitude: 35.28292,
    longitude: -78.01239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28333',
  },
  {
    city: 'Dunn',
    county_fips: 37163,
    county_fips_all: '37163|37085|37051|37101',
    county: 'Sampson',
    county_names_all: 'Sampson|Harnett|Cumberland|Johnston',
    county_weights:
      '{"37163": 46.56, "37085": 36.83, "37051": 8.5, "37101": 8.12}',
    density: 55.1,
    imprecise: false,
    latitude: 35.2681,
    longitude: -78.57051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28334',
  },
  {
    city: 'Elizabethtown',
    county_fips: 37017,
    county_fips_all: '37017',
    county: 'Bladen',
    county_names_all: 'Bladen',
    county_weights: '{"37017": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 34.66094,
    longitude: -78.57733,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28337',
  },
  {
    city: 'Ellerbe',
    county_fips: 37153,
    county_fips_all: '37153',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"37153": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 35.09644,
    longitude: -79.75506,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28338',
  },
  {
    city: 'Erwin',
    county_fips: 37085,
    county_fips_all: '37085',
    county: 'Harnett',
    county_names_all: 'Harnett',
    county_weights: '{"37085": 100}',
    density: 74.8,
    imprecise: false,
    latitude: 35.31409,
    longitude: -78.72115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28339',
  },
  {
    city: 'Fairmont',
    county_fips: 37155,
    county_fips_all: '37155',
    county: 'Robeson',
    county_names_all: 'Robeson',
    county_weights: '{"37155": 100}',
    density: 29,
    imprecise: false,
    latitude: 34.47136,
    longitude: -79.1403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28340',
  },
  {
    city: 'Faison',
    county_fips: 37163,
    county_fips_all: '37163|37061',
    county: 'Sampson',
    county_names_all: 'Sampson|Duplin',
    county_weights: '{"37163": 58.91, "37061": 41.09}',
    density: 11.9,
    imprecise: false,
    latitude: 35.11919,
    longitude: -78.17577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28341',
  },
  {
    city: 'Falcon',
    county_fips: 37051,
    county_fips_all: '37051',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"37051": 100}',
    density: 67.3,
    imprecise: false,
    latitude: 35.18949,
    longitude: -78.6499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28342',
  },
  {
    city: 'Gibson',
    county_fips: 37165,
    county_fips_all: '37165',
    county: 'Scotland',
    county_names_all: 'Scotland',
    county_weights: '{"37165": 100}',
    density: 39.1,
    imprecise: false,
    latitude: 34.76454,
    longitude: -79.58129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28343',
  },
  {
    city: 'Godwin',
    county_fips: 37163,
    county_fips_all: '37163|37051',
    county: 'Sampson',
    county_names_all: 'Sampson|Cumberland',
    county_weights: '{"37163": 61.15, "37051": 38.85}',
    density: 50.5,
    imprecise: false,
    latitude: 35.16506,
    longitude: -78.63139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28344',
  },
  {
    city: 'Hamlet',
    county_fips: 37153,
    county_fips_all: '37153|37165',
    county: 'Richmond',
    county_names_all: 'Richmond|Scotland',
    county_weights: '{"37153": 96.47, "37165": 3.53}',
    density: 67.2,
    imprecise: false,
    latitude: 34.87464,
    longitude: -79.6716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28345',
  },
  {
    city: 'Hoffman',
    county_fips: 37153,
    county_fips_all: '37153|37125',
    county: 'Richmond',
    county_names_all: 'Richmond|Moore',
    county_weights: '{"37153": 84.14, "37125": 15.86}',
    density: 22.7,
    imprecise: false,
    latitude: 35.04652,
    longitude: -79.56203,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28347',
  },
  {
    city: 'Hope Mills',
    county_fips: 37051,
    county_fips_all: '37051',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"37051": 100}',
    density: 358.5,
    imprecise: false,
    latitude: 34.92691,
    longitude: -78.91313,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28348',
  },
  {
    city: 'Kenansville',
    county_fips: 37061,
    county_fips_all: '37061',
    county: 'Duplin',
    county_names_all: 'Duplin',
    county_weights: '{"37061": 100}',
    density: 22,
    imprecise: false,
    latitude: 34.98206,
    longitude: -77.92033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28349',
  },
  {
    city: 'Lakeview',
    county_fips: 37125,
    county_fips_all: '37125',
    county: 'Moore',
    county_names_all: 'Moore',
    county_weights: '{"37125": 100}',
    density: 37.3,
    imprecise: false,
    latitude: 35.2488,
    longitude: -79.32064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28350',
  },
  {
    city: 'Laurel Hill',
    county_fips: 37165,
    county_fips_all: '37165|37153',
    county: 'Scotland',
    county_names_all: 'Scotland|Richmond',
    county_weights: '{"37165": 97.05, "37153": 2.95}',
    density: 29.8,
    imprecise: false,
    latitude: 34.84098,
    longitude: -79.56102,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28351',
  },
  {
    city: 'Laurinburg',
    county_fips: 37165,
    county_fips_all: '37165',
    county: 'Scotland',
    county_names_all: 'Scotland',
    county_weights: '{"37165": 100}',
    density: 73.5,
    imprecise: false,
    latitude: 34.76762,
    longitude: -79.45321,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28352',
  },
  {
    city: 'Lemon Springs',
    county_fips: 37105,
    county_fips_all: '37105',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"37105": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.39053,
    longitude: -79.19514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28355',
  },
  {
    city: 'Linden',
    county_fips: 37051,
    county_fips_all: '37051|37085',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Harnett',
    county_weights: '{"37051": 79.41, "37085": 20.59}',
    density: 46,
    imprecise: false,
    latitude: 35.23092,
    longitude: -78.79113,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28356',
  },
  {
    city: 'Lumber Bridge',
    county_fips: 37155,
    county_fips_all: '37155|37093',
    county: 'Robeson',
    county_names_all: 'Robeson|Hoke',
    county_weights: '{"37155": 54.56, "37093": 45.44}',
    density: 31.4,
    imprecise: false,
    latitude: 34.90606,
    longitude: -79.08688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28357',
  },
  {
    city: 'Lumberton',
    county_fips: 37155,
    county_fips_all: '37155',
    county: 'Robeson',
    county_names_all: 'Robeson',
    county_weights: '{"37155": 100}',
    density: 64.9,
    imprecise: false,
    latitude: 34.60527,
    longitude: -78.94097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28358',
  },
  {
    city: 'Lumberton',
    county_fips: 37155,
    county_fips_all: '37155',
    county: 'Robeson',
    county_names_all: 'Robeson',
    county_weights: '{"37155": 100}',
    density: 6975.6,
    imprecise: false,
    latitude: 34.58686,
    longitude: -79.05475,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28359',
  },
  {
    city: 'Lumberton',
    county_fips: 37155,
    county_fips_all: '37155',
    county: 'Robeson',
    county_names_all: 'Robeson',
    county_weights: '{"37155": 100}',
    density: 67.1,
    imprecise: false,
    latitude: 34.67588,
    longitude: -79.07582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28360',
  },
  {
    city: 'Marietta',
    county_fips: 37155,
    county_fips_all: '37155',
    county: 'Robeson',
    county_names_all: 'Robeson',
    county_weights: '{"37155": 100}',
    density: 36,
    imprecise: false,
    latitude: 34.36961,
    longitude: -79.12882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28362',
  },
  {
    city: 'Marston',
    county_fips: 37165,
    county_fips_all: '37165|37153',
    county: 'Scotland',
    county_names_all: 'Scotland|Richmond',
    county_weights: '{"37165": 73.86, "37153": 26.14}',
    density: 5,
    imprecise: false,
    latitude: 34.95772,
    longitude: -79.53384,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28363',
  },
  {
    city: 'Maxton',
    county_fips: 37155,
    county_fips_all: '37155|37165|37093',
    county: 'Robeson',
    county_names_all: 'Robeson|Scotland|Hoke',
    county_weights: '{"37155": 91.65, "37165": 6.92, "37093": 1.43}',
    density: 36.8,
    imprecise: false,
    latitude: 34.71447,
    longitude: -79.32759,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28364',
  },
  {
    city: 'Mount Olive',
    county_fips: 37061,
    county_fips_all: '37061|37191|37163',
    county: 'Duplin',
    county_names_all: 'Duplin|Wayne|Sampson',
    county_weights: '{"37061": 48.98, "37191": 46.19, "37163": 4.83}',
    density: 32.3,
    imprecise: false,
    latitude: 35.17807,
    longitude: -78.05827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28365',
  },
  {
    city: 'Newton Grove',
    county_fips: 37163,
    county_fips_all: '37163|37101',
    county: 'Sampson',
    county_names_all: 'Sampson|Johnston',
    county_weights: '{"37163": 79.59, "37101": 20.41}',
    density: 16.9,
    imprecise: false,
    latitude: 35.22974,
    longitude: -78.36317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28366',
  },
  {
    city: 'Norman',
    county_fips: 37153,
    county_fips_all: '37153|37123',
    county: 'Richmond',
    county_names_all: 'Richmond|Montgomery',
    county_weights: '{"37153": 99.67, "37123": 0.33}',
    density: 61.6,
    imprecise: false,
    latitude: 35.16982,
    longitude: -79.72325,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28367',
  },
  {
    city: 'Olivia',
    county_fips: 37085,
    county_fips_all: '37085',
    county: 'Harnett',
    county_names_all: 'Harnett',
    county_weights: '{"37085": 100}',
    density: 56.1,
    imprecise: false,
    latitude: 35.36942,
    longitude: -79.11331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28368',
  },
  {
    city: 'Orrum',
    county_fips: 37155,
    county_fips_all: '37155',
    county: 'Robeson',
    county_names_all: 'Robeson',
    county_weights: '{"37155": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 34.42184,
    longitude: -79.02901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28369',
  },
  {
    city: 'Parkton',
    county_fips: 37155,
    county_fips_all: '37155|37051|37093',
    county: 'Robeson',
    county_names_all: 'Robeson|Cumberland|Hoke',
    county_weights: '{"37155": 78.06, "37051": 19.78, "37093": 2.16}',
    density: 81,
    imprecise: false,
    latitude: 34.9079,
    longitude: -78.99018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28371',
  },
  {
    city: 'Pembroke',
    county_fips: 37155,
    county_fips_all: '37155',
    county: 'Robeson',
    county_names_all: 'Robeson',
    county_weights: '{"37155": 100}',
    density: 108.9,
    imprecise: false,
    latitude: 34.69991,
    longitude: -79.1786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28372',
  },
  {
    city: 'Pinebluff',
    county_fips: 37125,
    county_fips_all: '37125',
    county: 'Moore',
    county_names_all: 'Moore',
    county_weights: '{"37125": 100}',
    density: 77.4,
    imprecise: false,
    latitude: 35.09079,
    longitude: -79.48522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28373',
  },
  {
    city: 'Pinehurst',
    county_fips: 37125,
    county_fips_all: '37125',
    county: 'Moore',
    county_names_all: 'Moore',
    county_weights: '{"37125": 100}',
    density: 363.1,
    imprecise: false,
    latitude: 35.19705,
    longitude: -79.46009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28374',
  },
  {
    city: 'Proctorville',
    county_fips: 37155,
    county_fips_all: '37155',
    county: 'Robeson',
    county_names_all: 'Robeson',
    county_weights: '{"37155": 100}',
    density: 46.3,
    imprecise: false,
    latitude: 34.47723,
    longitude: -79.04337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28375',
  },
  {
    city: 'Raeford',
    county_fips: 37093,
    county_fips_all: '37093',
    county: 'Hoke',
    county_names_all: 'Hoke',
    county_weights: '{"37093": 100}',
    density: 62.2,
    imprecise: false,
    latitude: 35.052,
    longitude: -79.23342,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28376',
  },
  {
    city: 'Red Springs',
    county_fips: 37093,
    county_fips_all: '37093|37155',
    county: 'Hoke',
    county_names_all: 'Hoke|Robeson',
    county_weights: '{"37093": 51.53, "37155": 48.47}',
    density: 44.4,
    imprecise: false,
    latitude: 34.83526,
    longitude: -79.21282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28377',
  },
  {
    city: 'Rex',
    county_fips: 37155,
    county_fips_all: '37155',
    county: 'Robeson',
    county_names_all: 'Robeson',
    county_weights: '{"37155": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.85872,
    longitude: -79.0506,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28378',
  },
  {
    city: 'Rockingham',
    county_fips: 37153,
    county_fips_all: '37153',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"37153": 100}',
    density: 59.7,
    imprecise: false,
    latitude: 34.93073,
    longitude: -79.78252,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28379',
  },
  {
    city: 'Roseboro',
    county_fips: 37163,
    county_fips_all: '37163|37051',
    county: 'Sampson',
    county_names_all: 'Sampson|Cumberland',
    county_weights: '{"37163": 87.22, "37051": 12.78}',
    density: 23.9,
    imprecise: false,
    latitude: 34.97546,
    longitude: -78.50561,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28382',
  },
  {
    city: 'Rowland',
    county_fips: 37155,
    county_fips_all: '37155',
    county: 'Robeson',
    county_names_all: 'Robeson',
    county_weights: '{"37155": 100}',
    density: 25,
    imprecise: false,
    latitude: 34.57553,
    longitude: -79.26856,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28383',
  },
  {
    city: 'Saint Pauls',
    county_fips: 37155,
    county_fips_all: '37155|37017|37051',
    county: 'Robeson',
    county_names_all: 'Robeson|Bladen|Cumberland',
    county_weights: '{"37155": 83.86, "37017": 13.07, "37051": 3.07}',
    density: 43.3,
    imprecise: false,
    latitude: 34.79687,
    longitude: -78.95035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28384',
  },
  {
    city: 'Salemburg',
    county_fips: 37163,
    county_fips_all: '37163',
    county: 'Sampson',
    county_names_all: 'Sampson',
    county_weights: '{"37163": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 35.04461,
    longitude: -78.50012,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28385',
  },
  {
    city: 'Shannon',
    county_fips: 37155,
    county_fips_all: '37155|37093',
    county: 'Robeson',
    county_names_all: 'Robeson|Hoke',
    county_weights: '{"37155": 58.46, "37093": 41.54}',
    density: 48.7,
    imprecise: false,
    latitude: 34.85889,
    longitude: -79.12984,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28386',
  },
  {
    city: 'Southern Pines',
    county_fips: 37125,
    county_fips_all: '37125',
    county: 'Moore',
    county_names_all: 'Moore',
    county_weights: '{"37125": 100}',
    density: 210,
    imprecise: false,
    latitude: 35.18059,
    longitude: -79.37566,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28387',
  },
  {
    city: 'Spring Lake',
    county_fips: 37085,
    county_fips_all: '37085|37051',
    county: 'Harnett',
    county_names_all: 'Harnett|Cumberland',
    county_weights: '{"37085": 52.23, "37051": 47.77}',
    density: 154,
    imprecise: false,
    latitude: 35.21783,
    longitude: -78.95488,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28390',
  },
  {
    city: 'Stedman',
    county_fips: 37051,
    county_fips_all: '37051|37163',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Sampson',
    county_weights: '{"37051": 99.31, "37163": 0.69}',
    density: 58.5,
    imprecise: false,
    latitude: 35.03045,
    longitude: -78.70009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28391',
  },
  {
    city: 'Tar Heel',
    county_fips: 37017,
    county_fips_all: '37017',
    county: 'Bladen',
    county_names_all: 'Bladen',
    county_weights: '{"37017": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 34.73467,
    longitude: -78.79465,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28392',
  },
  {
    city: 'Turkey',
    county_fips: 37163,
    county_fips_all: '37163|37061',
    county: 'Sampson',
    county_names_all: 'Sampson|Duplin',
    county_weights: '{"37163": 99.36, "37061": 0.64}',
    density: 14.1,
    imprecise: false,
    latitude: 34.98205,
    longitude: -78.18895,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28393',
  },
  {
    city: 'Vass',
    county_fips: 37125,
    county_fips_all: '37125',
    county: 'Moore',
    county_names_all: 'Moore',
    county_weights: '{"37125": 100}',
    density: 55.5,
    imprecise: false,
    latitude: 35.21652,
    longitude: -79.23777,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28394',
  },
  {
    city: 'Wade',
    county_fips: 37051,
    county_fips_all: '37051',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"37051": 100}',
    density: 20.6,
    imprecise: false,
    latitude: 35.13643,
    longitude: -78.73855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28395',
  },
  {
    city: 'Wagram',
    county_fips: 37165,
    county_fips_all: '37165',
    county: 'Scotland',
    county_names_all: 'Scotland',
    county_weights: '{"37165": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 34.93948,
    longitude: -79.40971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28396',
  },
  {
    city: 'Warsaw',
    county_fips: 37061,
    county_fips_all: '37061',
    county: 'Duplin',
    county_names_all: 'Duplin',
    county_weights: '{"37061": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 34.99307,
    longitude: -78.07143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28398',
  },
  {
    city: 'White Oak',
    county_fips: 37017,
    county_fips_all: '37017|37051',
    county: 'Bladen',
    county_names_all: 'Bladen|Cumberland',
    county_weights: '{"37017": 93.9, "37051": 6.1}',
    density: 8.9,
    imprecise: false,
    latitude: 34.77885,
    longitude: -78.72953,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28399',
  },
  {
    city: 'Wilmington',
    county_fips: 37129,
    county_fips_all: '37129|37141',
    county: 'New Hanover',
    county_names_all: 'New Hanover|Pender',
    county_weights: '{"37129": 80.6, "37141": 19.4}',
    density: 274.2,
    imprecise: false,
    latitude: 34.29053,
    longitude: -77.97053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28401',
  },
  {
    city: 'Wilmington',
    county_fips: 37129,
    county_fips_all: '37129',
    county: 'New Hanover',
    county_names_all: 'New Hanover',
    county_weights: '{"37129": 100}',
    density: 1109.6,
    imprecise: false,
    latitude: 34.22177,
    longitude: -77.87902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28403',
  },
  {
    city: 'Wilmington',
    county_fips: 37129,
    county_fips_all: '37129',
    county: 'New Hanover',
    county_names_all: 'New Hanover',
    county_weights: '{"37129": 100}',
    density: 581.6,
    imprecise: false,
    latitude: 34.26388,
    longitude: -77.86743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28405',
  },
  {
    city: 'Wilmington',
    county_fips: 37129,
    county_fips_all: '37129',
    county: 'New Hanover',
    county_names_all: 'New Hanover',
    county_weights: '{"37129": 100}',
    density: 623.2,
    imprecise: false,
    latitude: 34.15244,
    longitude: -77.86477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28409',
  },
  {
    city: 'Wilmington',
    county_fips: 37129,
    county_fips_all: '37129|37141',
    county: 'New Hanover',
    county_names_all: 'New Hanover|Pender',
    county_weights: '{"37129": 80.48, "37141": 19.52}',
    density: 348.8,
    imprecise: false,
    latitude: 34.3015,
    longitude: -77.79307,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28411',
  },
  {
    city: 'Wilmington',
    county_fips: 37129,
    county_fips_all: '37129',
    county: 'New Hanover',
    county_names_all: 'New Hanover',
    county_weights: '{"37129": 100}',
    density: 765.9,
    imprecise: false,
    latitude: 34.13306,
    longitude: -77.9191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28412',
  },
  {
    city: 'Ash',
    county_fips: 37019,
    county_fips_all: '37019',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"37019": 100}',
    density: 6,
    imprecise: false,
    latitude: 34.07831,
    longitude: -78.46087,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28420',
  },
  {
    city: 'Atkinson',
    county_fips: 37141,
    county_fips_all: '37141',
    county: 'Pender',
    county_names_all: 'Pender',
    county_weights: '{"37141": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 34.52183,
    longitude: -78.17802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28421',
  },
  {
    city: 'Bolivia',
    county_fips: 37019,
    county_fips_all: '37019',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"37019": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 34.05192,
    longitude: -78.20147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28422',
  },
  {
    city: 'Bolton',
    county_fips: 37047,
    county_fips_all: '37047|37017',
    county: 'Columbus',
    county_names_all: 'Columbus|Bladen',
    county_weights: '{"37047": 96.11, "37017": 3.89}',
    density: 7.6,
    imprecise: false,
    latitude: 34.27782,
    longitude: -78.40483,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28423',
  },
  {
    city: 'Brunswick',
    county_fips: 37047,
    county_fips_all: '37047',
    county: 'Columbus',
    county_names_all: 'Columbus',
    county_weights: '{"37047": 100}',
    density: 242.4,
    imprecise: false,
    latitude: 34.29032,
    longitude: -78.69971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 90,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28424',
  },
  {
    city: 'Burgaw',
    county_fips: 37141,
    county_fips_all: '37141',
    county: 'Pender',
    county_names_all: 'Pender',
    county_weights: '{"37141": 100}',
    density: 28.6,
    imprecise: false,
    latitude: 34.5591,
    longitude: -77.90253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28425',
  },
  {
    city: 'Carolina Beach',
    county_fips: 37129,
    county_fips_all: '37129',
    county: 'New Hanover',
    county_names_all: 'New Hanover',
    county_weights: '{"37129": 100}',
    density: 533.8,
    imprecise: false,
    latitude: 34.03831,
    longitude: -77.90682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28428',
  },
  {
    city: 'Castle Hayne',
    county_fips: 37129,
    county_fips_all: '37129',
    county: 'New Hanover',
    county_names_all: 'New Hanover',
    county_weights: '{"37129": 100}',
    density: 93.9,
    imprecise: false,
    latitude: 34.34171,
    longitude: -77.9011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28429',
  },
  {
    city: 'Cerro Gordo',
    county_fips: 37047,
    county_fips_all: '37047',
    county: 'Columbus',
    county_names_all: 'Columbus',
    county_weights: '{"37047": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 34.28419,
    longitude: -78.93333,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28430',
  },
  {
    city: 'Chadbourn',
    county_fips: 37047,
    county_fips_all: '37047',
    county: 'Columbus',
    county_names_all: 'Columbus',
    county_weights: '{"37047": 100}',
    density: 29,
    imprecise: false,
    latitude: 34.31661,
    longitude: -78.84397,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28431',
  },
  {
    city: 'Clarendon',
    county_fips: 37047,
    county_fips_all: '37047',
    county: 'Columbus',
    county_names_all: 'Columbus',
    county_weights: '{"37047": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 34.17018,
    longitude: -78.75795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28432',
  },
  {
    city: 'Clarkton',
    county_fips: 37017,
    county_fips_all: '37017|37047',
    county: 'Bladen',
    county_names_all: 'Bladen|Columbus',
    county_weights: '{"37017": 73.73, "37047": 26.27}',
    density: 13.9,
    imprecise: false,
    latitude: 34.48979,
    longitude: -78.62598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28433',
  },
  {
    city: 'Council',
    county_fips: 37017,
    county_fips_all: '37017',
    county: 'Bladen',
    county_names_all: 'Bladen',
    county_weights: '{"37017": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 34.47154,
    longitude: -78.47479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28434',
  },
  {
    city: 'Currie',
    county_fips: 37141,
    county_fips_all: '37141',
    county: 'Pender',
    county_names_all: 'Pender',
    county_weights: '{"37141": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 34.41007,
    longitude: -78.11508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28435',
  },
  {
    city: 'Delco',
    county_fips: 37047,
    county_fips_all: '37047',
    county: 'Columbus',
    county_names_all: 'Columbus',
    county_weights: '{"37047": 100}',
    density: 17,
    imprecise: false,
    latitude: 34.26703,
    longitude: -78.27552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28436',
  },
  {
    city: 'Evergreen',
    county_fips: 37047,
    county_fips_all: '37047|37017',
    county: 'Columbus',
    county_names_all: 'Columbus|Bladen',
    county_weights: '{"37047": 95.51, "37017": 4.49}',
    density: 13.5,
    imprecise: false,
    latitude: 34.4166,
    longitude: -78.92221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28438',
  },
  {
    city: 'Fair Bluff',
    county_fips: 37047,
    county_fips_all: '37047',
    county: 'Columbus',
    county_names_all: 'Columbus',
    county_weights: '{"37047": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 34.29411,
    longitude: -79.00947,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28439',
  },
  {
    city: 'Garland',
    county_fips: 37163,
    county_fips_all: '37163|37017',
    county: 'Sampson',
    county_names_all: 'Sampson|Bladen',
    county_weights: '{"37163": 52.91, "37017": 47.09}',
    density: 6.8,
    imprecise: false,
    latitude: 34.79047,
    longitude: -78.4355,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28441',
  },
  {
    city: 'Hallsboro',
    county_fips: 37047,
    county_fips_all: '37047',
    county: 'Columbus',
    county_names_all: 'Columbus',
    county_weights: '{"37047": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 34.31023,
    longitude: -78.60106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28442',
  },
  {
    city: 'Hampstead',
    county_fips: 37141,
    county_fips_all: '37141',
    county: 'Pender',
    county_names_all: 'Pender',
    county_weights: '{"37141": 100}',
    density: 75.2,
    imprecise: false,
    latitude: 34.46211,
    longitude: -77.67312,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28443',
  },
  {
    city: 'Harrells',
    county_fips: 37163,
    county_fips_all: '37163|37017|37061',
    county: 'Sampson',
    county_names_all: 'Sampson|Bladen|Duplin',
    county_weights: '{"37163": 53.21, "37017": 43.71, "37061": 3.08}',
    density: 9.1,
    imprecise: false,
    latitude: 34.6885,
    longitude: -78.31798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28444',
  },
  {
    city: 'Holly Ridge',
    county_fips: 37133,
    county_fips_all: '37133|37141',
    county: 'Onslow',
    county_names_all: 'Onslow|Pender',
    county_weights: '{"37133": 88.15, "37141": 11.85}',
    density: 40.2,
    imprecise: false,
    latitude: 34.54199,
    longitude: -77.54019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28445',
  },
  {
    city: 'Ivanhoe',
    county_fips: 37017,
    county_fips_all: '37017|37163|37141',
    county: 'Bladen',
    county_names_all: 'Bladen|Sampson|Pender',
    county_weights: '{"37017": 41.74, "37163": 30.87, "37141": 27.4}',
    density: 5.8,
    imprecise: false,
    latitude: 34.59953,
    longitude: -78.25848,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28447',
  },
  {
    city: 'Kelly',
    county_fips: 37017,
    county_fips_all: '37017|37141',
    county: 'Bladen',
    county_names_all: 'Bladen|Pender',
    county_weights: '{"37017": 95.29, "37141": 4.71}',
    density: 3.1,
    imprecise: false,
    latitude: 34.49078,
    longitude: -78.31933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28448',
  },
  {
    city: 'Kure Beach',
    county_fips: 37129,
    county_fips_all: '37129',
    county: 'New Hanover',
    county_names_all: 'New Hanover',
    county_weights: '{"37129": 100}',
    density: 207.7,
    imprecise: false,
    latitude: 33.98151,
    longitude: -77.92748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28449',
  },
  {
    city: 'Lake Waccamaw',
    county_fips: 37047,
    county_fips_all: '37047',
    county: 'Columbus',
    county_names_all: 'Columbus',
    county_weights: '{"37047": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 34.29689,
    longitude: -78.51425,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28450',
  },
  {
    city: 'Leland',
    county_fips: 37019,
    county_fips_all: '37019',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"37019": 100}',
    density: 105.2,
    imprecise: false,
    latitude: 34.2327,
    longitude: -78.11503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28451',
  },
  {
    city: 'Longwood',
    county_fips: 37019,
    county_fips_all: '37019',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"37019": 100}',
    density: 88.8,
    imprecise: false,
    latitude: 34.0031,
    longitude: -78.55068,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28452',
  },
  {
    city: 'Magnolia',
    county_fips: 37061,
    county_fips_all: '37061|37163',
    county: 'Duplin',
    county_names_all: 'Duplin|Sampson',
    county_weights: '{"37061": 75.38, "37163": 24.62}',
    density: 14.6,
    imprecise: false,
    latitude: 34.88283,
    longitude: -78.06805,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28453',
  },
  {
    city: 'Maple Hill',
    county_fips: 37133,
    county_fips_all: '37133|37141',
    county: 'Onslow',
    county_names_all: 'Onslow|Pender',
    county_weights: '{"37133": 53.18, "37141": 46.82}',
    density: 13.8,
    imprecise: false,
    latitude: 34.6703,
    longitude: -77.65393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28454',
  },
  {
    city: 'Nakina',
    county_fips: 37047,
    county_fips_all: '37047',
    county: 'Columbus',
    county_names_all: 'Columbus',
    county_weights: '{"37047": 100}',
    density: 9,
    imprecise: false,
    latitude: 34.11045,
    longitude: -78.62865,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28455',
  },
  {
    city: 'Riegelwood',
    county_fips: 37047,
    county_fips_all: '37047|37017|37019',
    county: 'Columbus',
    county_names_all: 'Columbus|Bladen|Brunswick',
    county_weights: '{"37047": 43.83, "37017": 43.12, "37019": 13.04}',
    density: 18.9,
    imprecise: false,
    latitude: 34.37678,
    longitude: -78.29228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28456',
  },
  {
    city: 'Rocky Point',
    county_fips: 37141,
    county_fips_all: '37141',
    county: 'Pender',
    county_names_all: 'Pender',
    county_weights: '{"37141": 100}',
    density: 30,
    imprecise: false,
    latitude: 34.45608,
    longitude: -77.86618,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28457',
  },
  {
    city: 'Rose Hill',
    county_fips: 37061,
    county_fips_all: '37061|37163',
    county: 'Duplin',
    county_names_all: 'Duplin|Sampson',
    county_weights: '{"37061": 69.65, "37163": 30.35}',
    density: 18.4,
    imprecise: false,
    latitude: 34.81886,
    longitude: -78.07895,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28458',
  },
  {
    city: 'Sneads Ferry',
    county_fips: 37133,
    county_fips_all: '37133',
    county: 'Onslow',
    county_names_all: 'Onslow',
    county_weights: '{"37133": 100}',
    density: 187.4,
    imprecise: false,
    latitude: 34.52569,
    longitude: -77.41873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28460',
  },
  {
    city: 'Southport',
    county_fips: 37019,
    county_fips_all: '37019',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"37019": 100}',
    density: 120.9,
    imprecise: false,
    latitude: 33.96607,
    longitude: -78.03874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28461',
  },
  {
    city: 'Supply',
    county_fips: 37019,
    county_fips_all: '37019',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"37019": 100}',
    density: 65.8,
    imprecise: false,
    latitude: 34,
    longitude: -78.30497,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28462',
  },
  {
    city: 'Tabor City',
    county_fips: 37047,
    county_fips_all: '37047',
    county: 'Columbus',
    county_names_all: 'Columbus',
    county_weights: '{"37047": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 34.10213,
    longitude: -78.78001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28463',
  },
  {
    city: 'Teachey',
    county_fips: 37061,
    county_fips_all: '37061',
    county: 'Duplin',
    county_names_all: 'Duplin',
    county_weights: '{"37061": 100}',
    density: 34.6,
    imprecise: false,
    latitude: 34.77661,
    longitude: -78.01854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28464',
  },
  {
    city: 'Oak Island',
    county_fips: 37019,
    county_fips_all: '37019',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"37019": 100}',
    density: 309.9,
    imprecise: false,
    latitude: 33.91227,
    longitude: -78.09913,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28465',
  },
  {
    city: 'Wallace',
    county_fips: 37061,
    county_fips_all: '37061|37141',
    county: 'Duplin',
    county_names_all: 'Duplin|Pender',
    county_weights: '{"37061": 63.07, "37141": 36.93}',
    density: 19.2,
    imprecise: false,
    latitude: 34.73219,
    longitude: -77.8954,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28466',
  },
  {
    city: 'Calabash',
    county_fips: 37019,
    county_fips_all: '37019',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"37019": 100}',
    density: 295.9,
    imprecise: false,
    latitude: 33.91968,
    longitude: -78.58434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28467',
  },
  {
    city: 'Sunset Beach',
    county_fips: 37019,
    county_fips_all: '37019',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"37019": 100}',
    density: 104.1,
    imprecise: false,
    latitude: 33.90333,
    longitude: -78.52295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28468',
  },
  {
    city: 'Ocean Isle Beach',
    county_fips: 37019,
    county_fips_all: '37019',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"37019": 100}',
    density: 156,
    imprecise: false,
    latitude: 33.93271,
    longitude: -78.47159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28469',
  },
  {
    city: 'Shallotte',
    county_fips: 37019,
    county_fips_all: '37019',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"37019": 100}',
    density: 97,
    imprecise: false,
    latitude: 33.96415,
    longitude: -78.3987,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28470',
  },
  {
    city: 'Whiteville',
    county_fips: 37047,
    county_fips_all: '37047',
    county: 'Columbus',
    county_names_all: 'Columbus',
    county_weights: '{"37047": 100}',
    density: 32.7,
    imprecise: false,
    latitude: 34.29707,
    longitude: -78.68452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28472',
  },
  {
    city: 'Willard',
    county_fips: 37141,
    county_fips_all: '37141|37163|37061',
    county: 'Pender',
    county_names_all: 'Pender|Sampson|Duplin',
    county_weights: '{"37141": 91.58, "37163": 7.09, "37061": 1.33}',
    density: 15.8,
    imprecise: false,
    latitude: 34.64217,
    longitude: -78.04255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28478',
  },
  {
    city: 'Winnabow',
    county_fips: 37019,
    county_fips_all: '37019',
    county: 'Brunswick',
    county_names_all: 'Brunswick',
    county_weights: '{"37019": 100}',
    density: 27.4,
    imprecise: false,
    latitude: 34.09488,
    longitude: -78.01496,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28479',
  },
  {
    city: 'Wrightsville Beach',
    county_fips: 37129,
    county_fips_all: '37129',
    county: 'New Hanover',
    county_names_all: 'New Hanover',
    county_weights: '{"37129": 100}',
    density: 274.9,
    imprecise: false,
    latitude: 34.21679,
    longitude: -77.79957,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28480',
  },
  {
    city: 'Kinston',
    county_fips: 37107,
    county_fips_all: '37107|37103',
    county: 'Lenoir',
    county_names_all: 'Lenoir|Jones',
    county_weights: '{"37107": 74.72, "37103": 25.28}',
    density: 68.2,
    imprecise: false,
    latitude: 35.23838,
    longitude: -77.52658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28501',
  },
  {
    city: 'Kinston',
    county_fips: 37107,
    county_fips_all: '37107|37103',
    county: 'Lenoir',
    county_names_all: 'Lenoir|Jones',
    county_weights: '{"37107": 98.0, "37103": 2.0}',
    density: 65,
    imprecise: false,
    latitude: 35.22755,
    longitude: -77.63566,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28504',
  },
  {
    city: 'Albertson',
    county_fips: 37061,
    county_fips_all: '37061',
    county: 'Duplin',
    county_names_all: 'Duplin',
    county_weights: '{"37061": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 35.09684,
    longitude: -77.82789,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28508',
  },
  {
    city: 'Alliance',
    county_fips: 37137,
    county_fips_all: '37137',
    county: 'Pamlico',
    county_names_all: 'Pamlico',
    county_weights: '{"37137": 100}',
    density: 555.8,
    imprecise: false,
    latitude: 35.14524,
    longitude: -76.80662,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28509',
  },
  {
    city: 'Arapahoe',
    county_fips: 37137,
    county_fips_all: '37137',
    county: 'Pamlico',
    county_names_all: 'Pamlico',
    county_weights: '{"37137": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 35.00516,
    longitude: -76.81171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28510',
  },
  {
    city: 'Atlantic',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 28.8,
    imprecise: false,
    latitude: 34.89959,
    longitude: -76.35195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28511',
  },
  {
    city: 'Atlantic Beach',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 212.1,
    imprecise: false,
    latitude: 34.69857,
    longitude: -76.77505,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28512',
  },
  {
    city: 'Ayden',
    county_fips: 37147,
    county_fips_all: '37147|37079',
    county: 'Pitt',
    county_names_all: 'Pitt|Greene',
    county_weights: '{"37147": 87.02, "37079": 12.98}',
    density: 45.9,
    imprecise: false,
    latitude: 35.44276,
    longitude: -77.3897,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28513',
  },
  {
    city: 'Bayboro',
    county_fips: 37137,
    county_fips_all: '37137',
    county: 'Pamlico',
    county_names_all: 'Pamlico',
    county_weights: '{"37137": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 35.19285,
    longitude: -76.70263,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28515',
  },
  {
    city: 'Beaufort',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 34.7,
    imprecise: false,
    latitude: 34.84827,
    longitude: -76.61128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28516',
  },
  {
    city: 'Beulaville',
    county_fips: 37061,
    county_fips_all: '37061|37133',
    county: 'Duplin',
    county_names_all: 'Duplin|Onslow',
    county_weights: '{"37061": 88.88, "37133": 11.12}',
    density: 30.9,
    imprecise: false,
    latitude: 34.89678,
    longitude: -77.75569,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28518',
  },
  {
    city: 'Bridgeton',
    county_fips: 37049,
    county_fips_all: '37049',
    county: 'Craven',
    county_names_all: 'Craven',
    county_weights: '{"37049": 100}',
    density: 115.5,
    imprecise: false,
    latitude: 35.1268,
    longitude: -77.01477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28519',
  },
  {
    city: 'Cedar Island',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 34.95613,
    longitude: -76.44484,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28520',
  },
  {
    city: 'Chinquapin',
    county_fips: 37061,
    county_fips_all: '37061|37133',
    county: 'Duplin',
    county_names_all: 'Duplin|Onslow',
    county_weights: '{"37061": 96.39, "37133": 3.61}',
    density: 14.9,
    imprecise: false,
    latitude: 34.82136,
    longitude: -77.73684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28521',
  },
  {
    city: 'Cove City',
    county_fips: 37049,
    county_fips_all: '37049',
    county: 'Craven',
    county_names_all: 'Craven',
    county_weights: '{"37049": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 35.20662,
    longitude: -77.29541,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28523',
  },
  {
    city: 'Davis',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 34.78893,
    longitude: -76.47452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28524',
  },
  {
    city: 'Deep Run',
    county_fips: 37107,
    county_fips_all: '37107|37061',
    county: 'Lenoir',
    county_names_all: 'Lenoir|Duplin',
    county_weights: '{"37107": 92.43, "37061": 7.57}',
    density: 29.4,
    imprecise: false,
    latitude: 35.1241,
    longitude: -77.68987,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28525',
  },
  {
    city: 'Dover',
    county_fips: 37049,
    county_fips_all: '37049|37103|37107',
    county: 'Craven',
    county_names_all: 'Craven|Jones|Lenoir',
    county_weights: '{"37049": 62.71, "37103": 31.49, "37107": 5.8}',
    density: 7.4,
    imprecise: false,
    latitude: 35.24439,
    longitude: -77.40447,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28526',
  },
  {
    city: 'Ernul',
    county_fips: 37049,
    county_fips_all: '37049',
    county: 'Craven',
    county_names_all: 'Craven',
    county_weights: '{"37049": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 35.26396,
    longitude: -77.01568,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28527',
  },
  {
    city: 'Gloucester',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 56.3,
    imprecise: false,
    latitude: 34.73695,
    longitude: -76.5396,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28528',
  },
  {
    city: 'Grantsboro',
    county_fips: 37137,
    county_fips_all: '37137',
    county: 'Pamlico',
    county_names_all: 'Pamlico',
    county_weights: '{"37137": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 35.12237,
    longitude: -76.86848,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28529',
  },
  {
    city: 'Grifton',
    county_fips: 37147,
    county_fips_all: '37147|37107|37049|37079',
    county: 'Pitt',
    county_names_all: 'Pitt|Lenoir|Craven|Greene',
    county_weights:
      '{"37147": 39.45, "37107": 35.71, "37049": 16.54, "37079": 8.29}',
    density: 33.9,
    imprecise: false,
    latitude: 35.372,
    longitude: -77.41579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28530',
  },
  {
    city: 'Harkers Island',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 182.6,
    imprecise: false,
    latitude: 34.70015,
    longitude: -76.56116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28531',
  },
  {
    city: 'Havelock',
    county_fips: 37049,
    county_fips_all: '37049',
    county: 'Craven',
    county_names_all: 'Craven',
    county_weights: '{"37049": 100}',
    density: 48.8,
    imprecise: false,
    latitude: 34.88857,
    longitude: -76.90872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28532',
  },
  {
    city: 'Hobucken',
    county_fips: 37137,
    county_fips_all: '37137',
    county: 'Pamlico',
    county_names_all: 'Pamlico',
    county_weights: '{"37137": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 35.25558,
    longitude: -76.55912,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28537',
  },
  {
    city: 'Hookerton',
    county_fips: 37079,
    county_fips_all: '37079|37107',
    county: 'Greene',
    county_names_all: 'Greene|Lenoir',
    county_weights: '{"37079": 82.34, "37107": 17.66}',
    density: 27.3,
    imprecise: false,
    latitude: 35.41769,
    longitude: -77.56366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28538',
  },
  {
    city: 'Hubert',
    county_fips: 37133,
    county_fips_all: '37133',
    county: 'Onslow',
    county_names_all: 'Onslow',
    county_weights: '{"37133": 100}',
    density: 91.9,
    imprecise: false,
    latitude: 34.6891,
    longitude: -77.23615,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28539',
  },
  {
    city: 'Jacksonville',
    county_fips: 37133,
    county_fips_all: '37133',
    county: 'Onslow',
    county_names_all: 'Onslow',
    county_weights: '{"37133": 100}',
    density: 172,
    imprecise: false,
    latitude: 34.74361,
    longitude: -77.49833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28540',
  },
  {
    city: 'Tarawa Terrace',
    county_fips: 37133,
    county_fips_all: '37133',
    county: 'Onslow',
    county_names_all: 'Onslow',
    county_weights: '{"37133": 100}',
    density: 511.9,
    imprecise: false,
    latitude: 34.73263,
    longitude: -77.39825,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28543',
  },
  {
    city: 'Midway Park',
    county_fips: 37133,
    county_fips_all: '37133',
    county: 'Onslow',
    county_names_all: 'Onslow',
    county_weights: '{"37133": 100}',
    density: 159.4,
    imprecise: false,
    latitude: 34.70853,
    longitude: -77.31562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28544',
  },
  {
    city: 'Jacksonville',
    county_fips: 37133,
    county_fips_all: '37133',
    county: 'Onslow',
    county_names_all: 'Onslow',
    county_weights: '{"37133": 100}',
    density: 175.5,
    imprecise: false,
    latitude: 34.83461,
    longitude: -77.38818,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28546',
  },
  {
    city: 'Camp Lejeune',
    county_fips: 37133,
    county_fips_all: '37133',
    county: 'Onslow',
    county_names_all: 'Onslow',
    county_weights: '{"37133": 100}',
    density: 114.2,
    imprecise: false,
    latitude: 34.62518,
    longitude: -77.36307,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28547',
  },
  {
    city: 'La Grange',
    county_fips: 37107,
    county_fips_all: '37107|37191|37079',
    county: 'Lenoir',
    county_names_all: 'Lenoir|Wayne|Greene',
    county_weights: '{"37107": 57.95, "37191": 26.94, "37079": 15.11}',
    density: 41,
    imprecise: false,
    latitude: 35.32204,
    longitude: -77.78087,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28551',
  },
  {
    city: 'Lowland',
    county_fips: 37137,
    county_fips_all: '37137',
    county: 'Pamlico',
    county_names_all: 'Pamlico',
    county_weights: '{"37137": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 35.29281,
    longitude: -76.54382,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28552',
  },
  {
    city: 'Marshallberg',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 143.8,
    imprecise: false,
    latitude: 34.73217,
    longitude: -76.51335,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28553',
  },
  {
    city: 'Maury',
    county_fips: 37079,
    county_fips_all: '37079',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"37079": 100}',
    density: 43.1,
    imprecise: false,
    latitude: 35.47569,
    longitude: -77.5926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28554',
  },
  {
    city: 'Maysville',
    county_fips: 37133,
    county_fips_all: '37133|37103',
    county: 'Onslow',
    county_names_all: 'Onslow|Jones',
    county_weights: '{"37133": 50.91, "37103": 49.09}',
    density: 16.1,
    imprecise: false,
    latitude: 34.86982,
    longitude: -77.24543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28555',
  },
  {
    city: 'Merritt',
    county_fips: 37137,
    county_fips_all: '37137',
    county: 'Pamlico',
    county_names_all: 'Pamlico',
    county_weights: '{"37137": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 35.12233,
    longitude: -76.66904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28556',
  },
  {
    city: 'Morehead City',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 415.1,
    imprecise: false,
    latitude: 34.74064,
    longitude: -76.74566,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28557',
  },
  {
    city: 'New Bern',
    county_fips: 37049,
    county_fips_all: '37049|37137',
    county: 'Craven',
    county_names_all: 'Craven|Pamlico',
    county_weights: '{"37049": 63.55, "37137": 36.45}',
    density: 90.3,
    imprecise: false,
    latitude: 35.13354,
    longitude: -76.97575,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28560',
  },
  {
    city: 'New Bern',
    county_fips: 37049,
    county_fips_all: '37049|37103',
    county: 'Craven',
    county_names_all: 'Craven|Jones',
    county_weights: '{"37049": 92.21, "37103": 7.79}',
    density: 99.5,
    imprecise: false,
    latitude: 35.08105,
    longitude: -77.12486,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28562',
  },
  {
    city: 'Newport',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 57.6,
    imprecise: false,
    latitude: 34.78123,
    longitude: -76.88003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28570',
  },
  {
    city: 'Oriental',
    county_fips: 37137,
    county_fips_all: '37137',
    county: 'Pamlico',
    county_names_all: 'Pamlico',
    county_weights: '{"37137": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 35.05679,
    longitude: -76.72311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28571',
  },
  {
    city: 'Pink Hill',
    county_fips: 37061,
    county_fips_all: '37061|37107|37103|37133',
    county: 'Duplin',
    county_names_all: 'Duplin|Lenoir|Jones|Onslow',
    county_weights:
      '{"37061": 52.5, "37107": 26.74, "37103": 20.43, "37133": 0.33}',
    density: 23.3,
    imprecise: false,
    latitude: 35.02256,
    longitude: -77.72637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28572',
  },
  {
    city: 'Pollocksville',
    county_fips: 37103,
    county_fips_all: '37103|37049',
    county: 'Jones',
    county_names_all: 'Jones|Craven',
    county_weights: '{"37103": 98.39, "37049": 1.61}',
    density: 7,
    imprecise: false,
    latitude: 34.97997,
    longitude: -77.19794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28573',
  },
  {
    city: 'Richlands',
    county_fips: 37133,
    county_fips_all: '37133|37061|37103',
    county: 'Onslow',
    county_names_all: 'Onslow|Duplin|Jones',
    county_weights: '{"37133": 92.15, "37061": 4.0, "37103": 3.85}',
    density: 65.3,
    imprecise: false,
    latitude: 34.87716,
    longitude: -77.59212,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28574',
  },
  {
    city: 'Salter Path',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 273.1,
    imprecise: false,
    latitude: 34.68833,
    longitude: -76.88129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28575',
  },
  {
    city: 'Sealevel',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 34.91494,
    longitude: -76.40769,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28577',
  },
  {
    city: 'Seven Springs',
    county_fips: 37191,
    county_fips_all: '37191|37107|37061',
    county: 'Wayne',
    county_names_all: 'Wayne|Lenoir|Duplin',
    county_weights: '{"37191": 57.62, "37107": 27.89, "37061": 14.49}',
    density: 24.9,
    imprecise: false,
    latitude: 35.20017,
    longitude: -77.86332,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28578',
  },
  {
    city: 'Smyrna',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 34.80411,
    longitude: -76.50422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28579',
  },
  {
    city: 'Snow Hill',
    county_fips: 37079,
    county_fips_all: '37079|37107',
    county: 'Greene',
    county_names_all: 'Greene|Lenoir',
    county_weights: '{"37079": 99.63, "37107": 0.37}',
    density: 41.5,
    imprecise: false,
    latitude: 35.45116,
    longitude: -77.68053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28580',
  },
  {
    city: 'Stacy',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 5,
    imprecise: false,
    latitude: 34.84992,
    longitude: -76.43341,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28581',
  },
  {
    city: 'Stella',
    county_fips: 37133,
    county_fips_all: '37133|37031',
    county: 'Onslow',
    county_names_all: 'Onslow|Carteret',
    county_weights: '{"37133": 56.95, "37031": 43.05}',
    density: 46.6,
    imprecise: false,
    latitude: 34.7613,
    longitude: -77.14507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28582',
  },
  {
    city: 'Swansboro',
    county_fips: 37031,
    county_fips_all: '37031|37133',
    county: 'Carteret',
    county_names_all: 'Carteret|Onslow',
    county_weights: '{"37031": 70.42, "37133": 29.58}',
    density: 170.1,
    imprecise: false,
    latitude: 34.72632,
    longitude: -77.10002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28584',
  },
  {
    city: 'Trenton',
    county_fips: 37103,
    county_fips_all: '37103',
    county: 'Jones',
    county_names_all: 'Jones',
    county_weights: '{"37103": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 35.05264,
    longitude: -77.41497,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28585',
  },
  {
    city: 'Vanceboro',
    county_fips: 37049,
    county_fips_all: '37049|37013|37147',
    county: 'Craven',
    county_names_all: 'Craven|Beaufort|Pitt',
    county_weights: '{"37049": 91.37, "37013": 4.81, "37147": 3.82}',
    density: 23.7,
    imprecise: false,
    latitude: 35.31884,
    longitude: -77.16602,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28586',
  },
  {
    city: 'Vandemere',
    county_fips: 37137,
    county_fips_all: '37137',
    county: 'Pamlico',
    county_names_all: 'Pamlico',
    county_weights: '{"37137": 100}',
    density: 39.7,
    imprecise: false,
    latitude: 35.18714,
    longitude: -76.66783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28587',
  },
  {
    city: 'Williston',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 18,
    imprecise: false,
    latitude: 34.79343,
    longitude: -76.49398,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28589',
  },
  {
    city: 'Winterville',
    county_fips: 37147,
    county_fips_all: '37147',
    county: 'Pitt',
    county_names_all: 'Pitt',
    county_weights: '{"37147": 100}',
    density: 257.4,
    imprecise: false,
    latitude: 35.52046,
    longitude: -77.41651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28590',
  },
  {
    city: 'Emerald Isle',
    county_fips: 37031,
    county_fips_all: '37031',
    county: 'Carteret',
    county_names_all: 'Carteret',
    county_weights: '{"37031": 100}',
    density: 266,
    imprecise: false,
    latitude: 34.66486,
    longitude: -77.02918,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28594',
  },
  {
    city: 'Hickory',
    county_fips: 37035,
    county_fips_all: '37035|37023|37003|37027',
    county: 'Catawba',
    county_names_all: 'Catawba|Burke|Alexander|Caldwell',
    county_weights:
      '{"37035": 63.04, "37023": 15.45, "37003": 12.99, "37027": 8.52}',
    density: 437.5,
    imprecise: false,
    latitude: 35.7729,
    longitude: -81.32704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28601',
  },
  {
    city: 'Hickory',
    county_fips: 37035,
    county_fips_all: '37035|37023',
    county: 'Catawba',
    county_names_all: 'Catawba|Burke',
    county_weights: '{"37035": 80.91, "37023": 19.09}',
    density: 170,
    imprecise: false,
    latitude: 35.67574,
    longitude: -81.38459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28602',
  },
  {
    city: 'Banner Elk',
    county_fips: 37189,
    county_fips_all: '37189|37011',
    county: 'Watauga',
    county_names_all: 'Watauga|Avery',
    county_weights: '{"37189": 57.65, "37011": 42.35}',
    density: 44.3,
    imprecise: false,
    latitude: 36.17701,
    longitude: -81.84745,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28604',
  },
  {
    city: 'Blowing Rock',
    county_fips: 37189,
    county_fips_all: '37189|37027|37011',
    county: 'Watauga',
    county_names_all: 'Watauga|Caldwell|Avery',
    county_weights: '{"37189": 71.48, "37027": 22.38, "37011": 6.14}',
    density: 45.7,
    imprecise: false,
    latitude: 36.13454,
    longitude: -81.70218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28605',
  },
  {
    city: 'Boomer',
    county_fips: 37193,
    county_fips_all: '37193|37027',
    county: 'Wilkes',
    county_names_all: 'Wilkes|Caldwell',
    county_weights: '{"37193": 89.0, "37027": 11.0}',
    density: 19.6,
    imprecise: false,
    latitude: 36.05346,
    longitude: -81.31413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28606',
  },
  {
    city: 'Boone',
    county_fips: 37189,
    county_fips_all: '37189',
    county: 'Watauga',
    county_names_all: 'Watauga',
    county_weights: '{"37189": 100}',
    density: 135.4,
    imprecise: false,
    latitude: 36.21547,
    longitude: -81.64427,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28607',
  },
  {
    city: 'Catawba',
    county_fips: 37035,
    county_fips_all: '37035',
    county: 'Catawba',
    county_names_all: 'Catawba',
    county_weights: '{"37035": 100}',
    density: 55.9,
    imprecise: false,
    latitude: 35.67608,
    longitude: -81.05314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28609',
  },
  {
    city: 'Claremont',
    county_fips: 37035,
    county_fips_all: '37035',
    county: 'Catawba',
    county_names_all: 'Catawba',
    county_weights: '{"37035": 100}',
    density: 98.6,
    imprecise: false,
    latitude: 35.73103,
    longitude: -81.13837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28610',
  },
  {
    city: 'Collettsville',
    county_fips: 37027,
    county_fips_all: '37027|37011',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Avery',
    county_weights: '{"37027": 80.91, "37011": 19.09}',
    density: 2.3,
    imprecise: false,
    latitude: 36.00608,
    longitude: -81.73699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28611',
  },
  {
    city: 'Connelly Springs',
    county_fips: 37023,
    county_fips_all: '37023|37035',
    county: 'Burke',
    county_names_all: 'Burke|Catawba',
    county_weights: '{"37023": 98.37, "37035": 1.63}',
    density: 54.5,
    imprecise: false,
    latitude: 35.6641,
    longitude: -81.53619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28612',
  },
  {
    city: 'Conover',
    county_fips: 37035,
    county_fips_all: '37035',
    county: 'Catawba',
    county_names_all: 'Catawba',
    county_weights: '{"37035": 100}',
    density: 212.9,
    imprecise: false,
    latitude: 35.73978,
    longitude: -81.20897,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28613',
  },
  {
    city: 'Creston',
    county_fips: 37009,
    county_fips_all: '37009',
    county: 'Ashe',
    county_names_all: 'Ashe',
    county_weights: '{"37009": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 36.46407,
    longitude: -81.65368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28615',
  },
  {
    city: 'Crossnore',
    county_fips: 37011,
    county_fips_all: '37011',
    county: 'Avery',
    county_names_all: 'Avery',
    county_weights: '{"37011": 100}',
    density: 84,
    imprecise: false,
    latitude: 36.02138,
    longitude: -81.93021,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28616',
  },
  {
    city: 'Crumpler',
    county_fips: 37009,
    county_fips_all: '37009',
    county: 'Ashe',
    county_names_all: 'Ashe',
    county_weights: '{"37009": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 36.48433,
    longitude: -81.38264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28617',
  },
  {
    city: 'Deep Gap',
    county_fips: 37189,
    county_fips_all: '37189|37193',
    county: 'Watauga',
    county_names_all: 'Watauga|Wilkes',
    county_weights: '{"37189": 88.42, "37193": 11.58}',
    density: 22.7,
    imprecise: false,
    latitude: 36.20888,
    longitude: -81.51291,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28618',
  },
  {
    city: 'Drexel',
    county_fips: 37023,
    county_fips_all: '37023',
    county: 'Burke',
    county_names_all: 'Burke',
    county_weights: '{"37023": 100}',
    density: 398.4,
    imprecise: false,
    latitude: 35.76013,
    longitude: -81.60674,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28619',
  },
  {
    city: 'Elkin',
    county_fips: 37171,
    county_fips_all: '37171|37193',
    county: 'Surry',
    county_names_all: 'Surry|Wilkes',
    county_weights: '{"37171": 68.25, "37193": 31.75}',
    density: 53.6,
    imprecise: false,
    latitude: 36.30863,
    longitude: -80.83612,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28621',
  },
  {
    city: 'Elk Park',
    county_fips: 37011,
    county_fips_all: '37011|37189',
    county: 'Avery',
    county_names_all: 'Avery|Watauga',
    county_weights: '{"37011": 99.73, "37189": 0.27}',
    density: 33.4,
    imprecise: false,
    latitude: 36.19492,
    longitude: -81.94899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28622',
  },
  {
    city: 'Ennice',
    county_fips: 37005,
    county_fips_all: '37005|37171',
    county: 'Alleghany',
    county_names_all: 'Alleghany|Surry',
    county_weights: '{"37005": 99.87, "37171": 0.13}',
    density: 23.5,
    imprecise: false,
    latitude: 36.53088,
    longitude: -80.97185,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28623',
  },
  {
    city: 'Ferguson',
    county_fips: 37193,
    county_fips_all: '37193|37027',
    county: 'Wilkes',
    county_names_all: 'Wilkes|Caldwell',
    county_weights: '{"37193": 99.63, "37027": 0.37}',
    density: 9.5,
    imprecise: false,
    latitude: 36.11971,
    longitude: -81.41327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28624',
  },
  {
    city: 'Statesville',
    county_fips: 37097,
    county_fips_all: '37097|37003|37059',
    county: 'Iredell',
    county_names_all: 'Iredell|Alexander|Davie',
    county_weights: '{"37097": 98.06, "37003": 1.51, "37059": 0.43}',
    density: 76.6,
    imprecise: false,
    latitude: 35.86487,
    longitude: -80.88709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28625',
  },
  {
    city: 'Fleetwood',
    county_fips: 37009,
    county_fips_all: '37009',
    county: 'Ashe',
    county_names_all: 'Ashe',
    county_weights: '{"37009": 100}',
    density: 41.2,
    imprecise: false,
    latitude: 36.29256,
    longitude: -81.50119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28626',
  },
  {
    city: 'Glade Valley',
    county_fips: 37005,
    county_fips_all: '37005',
    county: 'Alleghany',
    county_names_all: 'Alleghany',
    county_weights: '{"37005": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 36.4528,
    longitude: -81.01294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28627',
  },
  {
    city: 'Glen Alpine',
    county_fips: 37023,
    county_fips_all: '37023',
    county: 'Burke',
    county_names_all: 'Burke',
    county_weights: '{"37023": 100}',
    density: 82,
    imprecise: false,
    latitude: 35.72914,
    longitude: -81.77826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28628',
  },
  {
    city: 'Glendale Springs',
    county_fips: 37009,
    county_fips_all: '37009',
    county: 'Ashe',
    county_names_all: 'Ashe',
    county_weights: '{"37009": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 36.34196,
    longitude: -81.36423,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28629',
  },
  {
    city: 'Granite Falls',
    county_fips: 37027,
    county_fips_all: '37027|37003',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Alexander',
    county_weights: '{"37027": 98.56, "37003": 1.44}',
    density: 122.7,
    imprecise: false,
    latitude: 35.82771,
    longitude: -81.41998,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28630',
  },
  {
    city: 'Grassy Creek',
    county_fips: 37009,
    county_fips_all: '37009|37005',
    county: 'Ashe',
    county_names_all: 'Ashe|Alleghany',
    county_weights: '{"37009": 90.26, "37005": 9.74}',
    density: 11.4,
    imprecise: false,
    latitude: 36.55218,
    longitude: -81.40994,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28631',
  },
  {
    city: 'Harmony',
    county_fips: 37097,
    county_fips_all: '37097|37059|37197',
    county: 'Iredell',
    county_names_all: 'Iredell|Davie|Yadkin',
    county_weights: '{"37097": 89.48, "37059": 9.59, "37197": 0.93}',
    density: 33.2,
    imprecise: false,
    latitude: 35.97052,
    longitude: -80.75528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28634',
  },
  {
    city: 'Hays',
    county_fips: 37193,
    county_fips_all: '37193',
    county: 'Wilkes',
    county_names_all: 'Wilkes',
    county_weights: '{"37193": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 36.33297,
    longitude: -81.12603,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28635',
  },
  {
    city: 'Hiddenite',
    county_fips: 37003,
    county_fips_all: '37003|37097',
    county: 'Alexander',
    county_names_all: 'Alexander|Iredell',
    county_weights: '{"37003": 93.44, "37097": 6.56}',
    density: 30,
    imprecise: false,
    latitude: 35.94241,
    longitude: -81.06589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28636',
  },
  {
    city: 'Hildebran',
    county_fips: 37023,
    county_fips_all: '37023',
    county: 'Burke',
    county_names_all: 'Burke',
    county_weights: '{"37023": 100}',
    density: 279.3,
    imprecise: false,
    latitude: 35.71768,
    longitude: -81.41939,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28637',
  },
  {
    city: 'Hudson',
    county_fips: 37027,
    county_fips_all: '37027',
    county: 'Caldwell',
    county_names_all: 'Caldwell',
    county_weights: '{"37027": 100}',
    density: 239,
    imprecise: false,
    latitude: 35.84411,
    longitude: -81.47701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28638',
  },
  {
    city: 'Jefferson',
    county_fips: 37009,
    county_fips_all: '37009|37193',
    county: 'Ashe',
    county_names_all: 'Ashe|Wilkes',
    county_weights: '{"37009": 99.81, "37193": 0.19}',
    density: 50.2,
    imprecise: false,
    latitude: 36.40385,
    longitude: -81.40751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28640',
  },
  {
    city: 'Jonas Ridge',
    county_fips: 37023,
    county_fips_all: '37023',
    county: 'Burke',
    county_names_all: 'Burke',
    county_weights: '{"37023": 100}',
    density: 260,
    imprecise: false,
    latitude: 35.97902,
    longitude: -81.89684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28641',
  },
  {
    city: 'Jonesville',
    county_fips: 37197,
    county_fips_all: '37197|37193',
    county: 'Yadkin',
    county_names_all: 'Yadkin|Wilkes',
    county_weights: '{"37197": 88.57, "37193": 11.43}',
    density: 67,
    imprecise: false,
    latitude: 36.22433,
    longitude: -80.81628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28642',
  },
  {
    city: 'Lansing',
    county_fips: 37009,
    county_fips_all: '37009',
    county: 'Ashe',
    county_names_all: 'Ashe',
    county_weights: '{"37009": 100}',
    density: 20,
    imprecise: false,
    latitude: 36.52982,
    longitude: -81.53486,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28643',
  },
  {
    city: 'Laurel Springs',
    county_fips: 37005,
    county_fips_all: '37005|37009|37193',
    county: 'Alleghany',
    county_names_all: 'Alleghany|Ashe|Wilkes',
    county_weights: '{"37005": 53.61, "37009": 45.32, "37193": 1.07}',
    density: 7.7,
    imprecise: false,
    latitude: 36.43134,
    longitude: -81.26758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28644',
  },
  {
    city: 'Lenoir',
    county_fips: 37027,
    county_fips_all: '37027|37189|37023|37193',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Watauga|Burke|Wilkes',
    county_weights:
      '{"37027": 95.75, "37189": 2.43, "37023": 1.1, "37193": 0.72}',
    density: 54,
    imprecise: false,
    latitude: 35.97778,
    longitude: -81.54371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28645',
  },
  {
    city: 'Linville',
    county_fips: 37011,
    county_fips_all: '37011',
    county: 'Avery',
    county_names_all: 'Avery',
    county_weights: '{"37011": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 36.08261,
    longitude: -81.83811,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28646',
  },
  {
    city: 'McGrady',
    county_fips: 37193,
    county_fips_all: '37193',
    county: 'Wilkes',
    county_names_all: 'Wilkes',
    county_weights: '{"37193": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 36.33198,
    longitude: -81.20326,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28649',
  },
  {
    city: 'Maiden',
    county_fips: 37035,
    county_fips_all: '37035|37109',
    county: 'Catawba',
    county_names_all: 'Catawba|Lincoln',
    county_weights: '{"37035": 81.76, "37109": 18.24}',
    density: 101.2,
    imprecise: false,
    latitude: 35.57347,
    longitude: -81.15668,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28650',
  },
  {
    city: 'Millers Creek',
    county_fips: 37193,
    county_fips_all: '37193',
    county: 'Wilkes',
    county_names_all: 'Wilkes',
    county_weights: '{"37193": 100}',
    density: 25.6,
    imprecise: false,
    latitude: 36.27241,
    longitude: -81.28496,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28651',
  },
  {
    city: 'Minneapolis',
    county_fips: 37011,
    county_fips_all: '37011',
    county: 'Avery',
    county_names_all: 'Avery',
    county_weights: '{"37011": 100}',
    density: 44.2,
    imprecise: false,
    latitude: 36.08969,
    longitude: -81.98656,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28652',
  },
  {
    city: 'Montezuma',
    county_fips: 37011,
    county_fips_all: '37011',
    county: 'Avery',
    county_names_all: 'Avery',
    county_weights: '{"37011": 100}',
    density: 239.7,
    imprecise: false,
    latitude: 36.06615,
    longitude: -81.90072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28653',
  },
  {
    city: 'Moravian Falls',
    county_fips: 37193,
    county_fips_all: '37193|37003',
    county: 'Wilkes',
    county_names_all: 'Wilkes|Alexander',
    county_weights: '{"37193": 92.48, "37003": 7.52}',
    density: 19.9,
    imprecise: false,
    latitude: 36.06338,
    longitude: -81.15003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28654',
  },
  {
    city: 'Morganton',
    county_fips: 37023,
    county_fips_all: '37023|37027|37111',
    county: 'Burke',
    county_names_all: 'Burke|Caldwell|McDowell',
    county_weights: '{"37023": 99.29, "37027": 0.43, "37111": 0.28}',
    density: 65.5,
    imprecise: false,
    latitude: 35.75578,
    longitude: -81.74212,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28655',
  },
  {
    city: 'Newland',
    county_fips: 37011,
    county_fips_all: '37011|37023|37111',
    county: 'Avery',
    county_names_all: 'Avery|Burke|McDowell',
    county_weights: '{"37011": 83.98, "37023": 15.14, "37111": 0.88}',
    density: 19.8,
    imprecise: false,
    latitude: 36.02833,
    longitude: -81.93977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28657',
  },
  {
    city: 'Newton',
    county_fips: 37035,
    county_fips_all: '37035',
    county: 'Catawba',
    county_names_all: 'Catawba',
    county_weights: '{"37035": 100}',
    density: 142.6,
    imprecise: false,
    latitude: 35.63557,
    longitude: -81.24222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28658',
  },
  {
    city: 'North Wilkesboro',
    county_fips: 37193,
    county_fips_all: '37193',
    county: 'Wilkes',
    county_names_all: 'Wilkes',
    county_weights: '{"37193": 100}',
    density: 82.2,
    imprecise: false,
    latitude: 36.16647,
    longitude: -81.07913,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28659',
  },
  {
    city: 'Olin',
    county_fips: 37097,
    county_fips_all: '37097',
    county: 'Iredell',
    county_names_all: 'Iredell',
    county_weights: '{"37097": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 35.9689,
    longitude: -80.85785,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28660',
  },
  {
    city: 'Pineola',
    county_fips: 37011,
    county_fips_all: '37011',
    county: 'Avery',
    county_names_all: 'Avery',
    county_weights: '{"37011": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.02237,
    longitude: -81.89171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28662',
  },
  {
    city: 'Piney Creek',
    county_fips: 37005,
    county_fips_all: '37005',
    county: 'Alleghany',
    county_names_all: 'Alleghany',
    county_weights: '{"37005": 100}',
    density: 15,
    imprecise: false,
    latitude: 36.53477,
    longitude: -81.30063,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28663',
  },
  {
    city: 'Plumtree',
    county_fips: 37011,
    county_fips_all: '37011',
    county: 'Avery',
    county_names_all: 'Avery',
    county_weights: '{"37011": 100}',
    density: 23.8,
    imprecise: false,
    latitude: 36.04249,
    longitude: -82.00596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28664',
  },
  {
    city: 'Purlear',
    county_fips: 37193,
    county_fips_all: '37193',
    county: 'Wilkes',
    county_names_all: 'Wilkes',
    county_weights: '{"37193": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 36.20969,
    longitude: -81.37392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28665',
  },
  {
    city: 'Icard',
    county_fips: 37023,
    county_fips_all: '37023',
    county: 'Burke',
    county_names_all: 'Burke',
    county_weights: '{"37023": 100}',
    density: 1166.7,
    imprecise: false,
    latitude: 35.71864,
    longitude: -81.47057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28666',
  },
  {
    city: 'Rhodhiss',
    county_fips: 37027,
    county_fips_all: '37027|37023',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Burke',
    county_weights: '{"37027": 85.97, "37023": 14.03}',
    density: 247.5,
    imprecise: false,
    latitude: 35.77423,
    longitude: -81.42793,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28667',
  },
  {
    city: 'Roaring Gap',
    county_fips: 37005,
    county_fips_all: '37005',
    county: 'Alleghany',
    county_names_all: 'Alleghany',
    county_weights: '{"37005": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 36.40698,
    longitude: -80.99024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28668',
  },
  {
    city: 'Roaring River',
    county_fips: 37193,
    county_fips_all: '37193',
    county: 'Wilkes',
    county_names_all: 'Wilkes',
    county_weights: '{"37193": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 36.22538,
    longitude: -80.99443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28669',
  },
  {
    city: 'Ronda',
    county_fips: 37193,
    county_fips_all: '37193',
    county: 'Wilkes',
    county_names_all: 'Wilkes',
    county_weights: '{"37193": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 36.19508,
    longitude: -80.92282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28670',
  },
  {
    city: 'Rutherford College',
    county_fips: 37023,
    county_fips_all: '37023',
    county: 'Burke',
    county_names_all: 'Burke',
    county_weights: '{"37023": 100}',
    density: 351.4,
    imprecise: false,
    latitude: 35.7502,
    longitude: -81.52668,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28671',
  },
  {
    city: 'Scottville',
    county_fips: 37009,
    county_fips_all: '37009|37005',
    county: 'Ashe',
    county_names_all: 'Ashe|Alleghany',
    county_weights: '{"37009": 99.8, "37005": 0.2}',
    density: 28.7,
    imprecise: false,
    latitude: 36.48381,
    longitude: -81.32735,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28672',
  },
  {
    city: 'Sherrills Ford',
    county_fips: 37035,
    county_fips_all: '37035|37109',
    county: 'Catawba',
    county_names_all: 'Catawba|Lincoln',
    county_weights: '{"37035": 99.52, "37109": 0.48}',
    density: 112,
    imprecise: false,
    latitude: 35.60704,
    longitude: -80.99817,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28673',
  },
  {
    city: 'Sparta',
    county_fips: 37005,
    county_fips_all: '37005|51077|37193',
    county: 'Alleghany',
    county_names_all: 'Alleghany|Grayson|Wilkes',
    county_weights: '{"37005": 99.11, "51077": 0.7, "37193": 0.19}',
    density: 24.3,
    imprecise: false,
    latitude: 36.50642,
    longitude: -81.13546,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28675',
  },
  {
    city: 'State Road',
    county_fips: 37171,
    county_fips_all: '37171|37193',
    county: 'Surry',
    county_names_all: 'Surry|Wilkes',
    county_weights: '{"37171": 76.21, "37193": 23.79}',
    density: 42.6,
    imprecise: false,
    latitude: 36.3283,
    longitude: -80.85722,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28676',
  },
  {
    city: 'Statesville',
    county_fips: 37097,
    county_fips_all: '37097',
    county: 'Iredell',
    county_names_all: 'Iredell',
    county_weights: '{"37097": 100}',
    density: 180.6,
    imprecise: false,
    latitude: 35.73743,
    longitude: -80.92272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28677',
  },
  {
    city: 'Stony Point',
    county_fips: 37097,
    county_fips_all: '37097|37003',
    county: 'Iredell',
    county_names_all: 'Iredell|Alexander',
    county_weights: '{"37097": 53.83, "37003": 46.17}',
    density: 45.5,
    imprecise: false,
    latitude: 35.83586,
    longitude: -81.06151,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28678',
  },
  {
    city: 'Sugar Grove',
    county_fips: 37189,
    county_fips_all: '37189|37011',
    county: 'Watauga',
    county_names_all: 'Watauga|Avery',
    county_weights: '{"37189": 96.06, "37011": 3.94}',
    density: 36.9,
    imprecise: false,
    latitude: 36.25962,
    longitude: -81.84207,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28679',
  },
  {
    city: 'Taylorsville',
    county_fips: 37003,
    county_fips_all: '37003',
    county: 'Alexander',
    county_names_all: 'Alexander',
    county_weights: '{"37003": 100}',
    density: 58.9,
    imprecise: false,
    latitude: 35.92185,
    longitude: -81.22151,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28681',
  },
  {
    city: 'Terrell',
    county_fips: 37035,
    county_fips_all: '37035',
    county: 'Catawba',
    county_names_all: 'Catawba',
    county_weights: '{"37035": 100}',
    density: 171.7,
    imprecise: false,
    latitude: 35.5838,
    longitude: -80.96369,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28682',
  },
  {
    city: 'Thurmond',
    county_fips: 37171,
    county_fips_all: '37171|37193',
    county: 'Surry',
    county_names_all: 'Surry|Wilkes',
    county_weights: '{"37171": 73.04, "37193": 26.96}',
    density: 18,
    imprecise: false,
    latitude: 36.38835,
    longitude: -80.91219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28683',
  },
  {
    city: 'Todd',
    county_fips: 37009,
    county_fips_all: '37009|37189',
    county: 'Ashe',
    county_names_all: 'Ashe|Watauga',
    county_weights: '{"37009": 55.96, "37189": 44.04}',
    density: 15.1,
    imprecise: false,
    latitude: 36.33541,
    longitude: -81.6163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28684',
  },
  {
    city: 'Traphill',
    county_fips: 37193,
    county_fips_all: '37193',
    county: 'Wilkes',
    county_names_all: 'Wilkes',
    county_weights: '{"37193": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 36.34729,
    longitude: -81.04097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28685',
  },
  {
    city: 'Union Grove',
    county_fips: 37097,
    county_fips_all: '37097|37193|37197|37003',
    county: 'Iredell',
    county_names_all: 'Iredell|Wilkes|Yadkin|Alexander',
    county_weights:
      '{"37097": 64.26, "37193": 17.08, "37197": 10.07, "37003": 8.59}',
    density: 18.6,
    imprecise: false,
    latitude: 36.04319,
    longitude: -80.93345,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28689',
  },
  {
    city: 'Valdese',
    county_fips: 37023,
    county_fips_all: '37023',
    county: 'Burke',
    county_names_all: 'Burke',
    county_weights: '{"37023": 100}',
    density: 164.8,
    imprecise: false,
    latitude: 35.73237,
    longitude: -81.5739,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28690',
  },
  {
    city: 'Vilas',
    county_fips: 37189,
    county_fips_all: '37189',
    county: 'Watauga',
    county_names_all: 'Watauga',
    county_weights: '{"37189": 100}',
    density: 42.2,
    imprecise: false,
    latitude: 36.28023,
    longitude: -81.79259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28692',
  },
  {
    city: 'Warrensville',
    county_fips: 37009,
    county_fips_all: '37009',
    county: 'Ashe',
    county_names_all: 'Ashe',
    county_weights: '{"37009": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 36.46622,
    longitude: -81.55434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28693',
  },
  {
    city: 'West Jefferson',
    county_fips: 37009,
    county_fips_all: '37009',
    county: 'Ashe',
    county_names_all: 'Ashe',
    county_weights: '{"37009": 100}',
    density: 42.1,
    imprecise: false,
    latitude: 36.36197,
    longitude: -81.47465,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28694',
  },
  {
    city: 'Wilkesboro',
    county_fips: 37193,
    county_fips_all: '37193',
    county: 'Wilkes',
    county_names_all: 'Wilkes',
    county_weights: '{"37193": 100}',
    density: 83.1,
    imprecise: false,
    latitude: 36.13666,
    longitude: -81.16317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28697',
  },
  {
    city: 'Zionville',
    county_fips: 37189,
    county_fips_all: '37189|37009',
    county: 'Watauga',
    county_names_all: 'Watauga|Ashe',
    county_weights: '{"37189": 76.05, "37009": 23.95}',
    density: 34.6,
    imprecise: false,
    latitude: 36.344,
    longitude: -81.73604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28698',
  },
  {
    city: 'Alexander',
    county_fips: 37021,
    county_fips_all: '37021|37115',
    county: 'Buncombe',
    county_names_all: 'Buncombe|Madison',
    county_weights: '{"37021": 96.12, "37115": 3.88}',
    density: 123.2,
    imprecise: false,
    latitude: 35.70558,
    longitude: -82.64096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28701',
  },
  {
    city: 'Almond',
    county_fips: 37075,
    county_fips_all: '37075|37173',
    county: 'Graham',
    county_names_all: 'Graham|Swain',
    county_weights: '{"37075": 95.79, "37173": 4.21}',
    density: 9.3,
    imprecise: false,
    latitude: 35.39346,
    longitude: -83.62906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28702',
  },
  {
    city: 'Arden',
    county_fips: 37021,
    county_fips_all: '37021|37089',
    county: 'Buncombe',
    county_names_all: 'Buncombe|Henderson',
    county_weights: '{"37021": 93.74, "37089": 6.26}',
    density: 309.3,
    imprecise: false,
    latitude: 35.46305,
    longitude: -82.57142,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28704',
  },
  {
    city: 'Bakersville',
    county_fips: 37121,
    county_fips_all: '37121|37199',
    county: 'Mitchell',
    county_names_all: 'Mitchell|Yancey',
    county_weights: '{"37121": 99.53, "37199": 0.47}',
    density: 20.9,
    imprecise: false,
    latitude: 36.04349,
    longitude: -82.1573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28705',
  },
  {
    city: 'Balsam',
    county_fips: 37099,
    county_fips_all: '37099',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"37099": 100}',
    density: 16,
    imprecise: false,
    latitude: 35.39873,
    longitude: -83.0662,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28707',
  },
  {
    city: 'Balsam Grove',
    county_fips: 37175,
    county_fips_all: '37175',
    county: 'Transylvania',
    county_names_all: 'Transylvania',
    county_weights: '{"37175": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 35.27105,
    longitude: -82.85979,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28708',
  },
  {
    city: 'Barnardsville',
    county_fips: 37021,
    county_fips_all: '37021',
    county: 'Buncombe',
    county_names_all: 'Buncombe',
    county_weights: '{"37021": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 35.76321,
    longitude: -82.40428,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28709',
  },
  {
    city: 'Bat Cave',
    county_fips: 37089,
    county_fips_all: '37089',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"37089": 100}',
    density: 34,
    imprecise: false,
    latitude: 35.45683,
    longitude: -82.27971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 78,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28710',
  },
  {
    city: 'Black Mountain',
    county_fips: 37021,
    county_fips_all: '37021|37111|37161|37089',
    county: 'Buncombe',
    county_names_all: 'Buncombe|McDowell|Rutherford|Henderson',
    county_weights:
      '{"37021": 79.39, "37111": 10.66, "37161": 9.09, "37089": 0.86}',
    density: 47.1,
    imprecise: false,
    latitude: 35.59666,
    longitude: -82.28767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28711',
  },
  {
    city: 'Brevard',
    county_fips: 37175,
    county_fips_all: '37175',
    county: 'Transylvania',
    county_names_all: 'Transylvania',
    county_weights: '{"37175": 100}',
    density: 66.4,
    imprecise: false,
    latitude: 35.17324,
    longitude: -82.76711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28712',
  },
  {
    city: 'Bryson City',
    county_fips: 37173,
    county_fips_all: '37173|37113',
    county: 'Swain',
    county_names_all: 'Swain|Macon',
    county_weights: '{"37173": 99.76, "37113": 0.24}',
    density: 23.3,
    imprecise: false,
    latitude: 35.3697,
    longitude: -83.50559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28713',
  },
  {
    city: 'Burnsville',
    county_fips: 37199,
    county_fips_all: '37199',
    county: 'Yancey',
    county_names_all: 'Yancey',
    county_weights: '{"37199": 100}',
    density: 24.6,
    imprecise: false,
    latitude: 35.87739,
    longitude: -82.30714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28714',
  },
  {
    city: 'Candler',
    county_fips: 37021,
    county_fips_all: '37021',
    county: 'Buncombe',
    county_names_all: 'Buncombe',
    county_weights: '{"37021": 100}',
    density: 150,
    imprecise: false,
    latitude: 35.51247,
    longitude: -82.71196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28715',
  },
  {
    city: 'Canton',
    county_fips: 37087,
    county_fips_all: '37087',
    county: 'Haywood',
    county_names_all: 'Haywood',
    county_weights: '{"37087": 100}',
    density: 41,
    imprecise: false,
    latitude: 35.4358,
    longitude: -82.86126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28716',
  },
  {
    city: 'Cashiers',
    county_fips: 37099,
    county_fips_all: '37099',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"37099": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 35.07131,
    longitude: -83.09458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28717',
  },
  {
    city: 'Cedar Mountain',
    county_fips: 37175,
    county_fips_all: '37175',
    county: 'Transylvania',
    county_names_all: 'Transylvania',
    county_weights: '{"37175": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 35.16614,
    longitude: -82.63108,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28718',
  },
  {
    city: 'Cherokee',
    county_fips: 37173,
    county_fips_all: '37173|37099',
    county: 'Swain',
    county_names_all: 'Swain|Jackson',
    county_weights: '{"37173": 92.42, "37099": 7.58}',
    density: 6.6,
    imprecise: false,
    latitude: 35.53223,
    longitude: -83.47056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28719',
  },
  {
    city: 'Chimney Rock',
    county_fips: 37161,
    county_fips_all: '37161',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"37161": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 35.42766,
    longitude: -82.25145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28720',
  },
  {
    city: 'Clyde',
    county_fips: 37087,
    county_fips_all: '37087',
    county: 'Haywood',
    county_names_all: 'Haywood',
    county_weights: '{"37087": 100}',
    density: 43.9,
    imprecise: false,
    latitude: 35.63378,
    longitude: -82.93081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28721',
  },
  {
    city: 'Columbus',
    county_fips: 37149,
    county_fips_all: '37149',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"37149": 100}',
    density: 53.6,
    imprecise: false,
    latitude: 35.23408,
    longitude: -82.12794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28722',
  },
  {
    city: 'Cullowhee',
    county_fips: 37099,
    county_fips_all: '37099',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"37099": 100}',
    density: 44,
    imprecise: false,
    latitude: 35.27776,
    longitude: -83.12195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28723',
  },
  {
    city: 'Dillsboro',
    county_fips: 37099,
    county_fips_all: '37099',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"37099": 100}',
    density: 65.2,
    imprecise: false,
    latitude: 35.37631,
    longitude: -83.26411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 90,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28725',
  },
  {
    city: 'East Flat Rock',
    county_fips: 37089,
    county_fips_all: '37089',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"37089": 100}',
    density: 682.3,
    imprecise: false,
    latitude: 35.282,
    longitude: -82.41752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28726',
  },
  {
    city: 'Etowah',
    county_fips: 37089,
    county_fips_all: '37089',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"37089": 100}',
    density: 342.3,
    imprecise: false,
    latitude: 35.31961,
    longitude: -82.60283,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28729',
  },
  {
    city: 'Fairview',
    county_fips: 37021,
    county_fips_all: '37021',
    county: 'Buncombe',
    county_names_all: 'Buncombe',
    county_weights: '{"37021": 100}',
    density: 64.8,
    imprecise: false,
    latitude: 35.52792,
    longitude: -82.37588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28730',
  },
  {
    city: 'Flat Rock',
    county_fips: 37089,
    county_fips_all: '37089|37149',
    county: 'Henderson',
    county_names_all: 'Henderson|Polk',
    county_weights: '{"37089": 80.63, "37149": 19.37}',
    density: 101.1,
    imprecise: false,
    latitude: 35.28905,
    longitude: -82.37796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28731',
  },
  {
    city: 'Fletcher',
    county_fips: 37089,
    county_fips_all: '37089|37021',
    county: 'Henderson',
    county_names_all: 'Henderson|Buncombe',
    county_weights: '{"37089": 63.76, "37021": 36.24}',
    density: 180,
    imprecise: false,
    latitude: 35.44667,
    longitude: -82.46577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28732',
  },
  {
    city: 'Fontana Dam',
    county_fips: 37075,
    county_fips_all: '37075',
    county: 'Graham',
    county_names_all: 'Graham',
    county_weights: '{"37075": 100}',
    density: 2,
    imprecise: false,
    latitude: 35.43536,
    longitude: -83.78403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28733',
  },
  {
    city: 'Franklin',
    county_fips: 37113,
    county_fips_all: '37113|37043',
    county: 'Macon',
    county_names_all: 'Macon|Clay',
    county_weights: '{"37113": 98.71, "37043": 1.29}',
    density: 38,
    imprecise: false,
    latitude: 35.1825,
    longitude: -83.42599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28734',
  },
  {
    city: 'Gerton',
    county_fips: 37089,
    county_fips_all: '37089',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"37089": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 35.47544,
    longitude: -82.3485,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28735',
  },
  {
    city: 'Glenville',
    county_fips: 37099,
    county_fips_all: '37099',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"37099": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 35.18039,
    longitude: -83.0838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28736',
  },
  {
    city: 'Hendersonville',
    county_fips: 37089,
    county_fips_all: '37089|37175',
    county: 'Henderson',
    county_names_all: 'Henderson|Transylvania',
    county_weights: '{"37089": 95.32, "37175": 4.68}',
    density: 131.9,
    imprecise: false,
    latitude: 35.2719,
    longitude: -82.5419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28739',
  },
  {
    city: 'Green Mountain',
    county_fips: 37199,
    county_fips_all: '37199|37121',
    county: 'Yancey',
    county_names_all: 'Yancey|Mitchell',
    county_weights: '{"37199": 54.55, "37121": 45.45}',
    density: 9.5,
    imprecise: false,
    latitude: 36.04118,
    longitude: -82.30287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28740',
  },
  {
    city: 'Highlands',
    county_fips: 37113,
    county_fips_all: '37113|37099',
    county: 'Macon',
    county_names_all: 'Macon|Jackson',
    county_weights: '{"37113": 86.99, "37099": 13.01}',
    density: 18.2,
    imprecise: false,
    latitude: 35.06614,
    longitude: -83.21053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28741',
  },
  {
    city: 'Horse Shoe',
    county_fips: 37089,
    county_fips_all: '37089|37175',
    county: 'Henderson',
    county_names_all: 'Henderson|Transylvania',
    county_weights: '{"37089": 98.76, "37175": 1.24}',
    density: 22.6,
    imprecise: false,
    latitude: 35.39486,
    longitude: -82.65436,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28742',
  },
  {
    city: 'Hot Springs',
    county_fips: 37115,
    county_fips_all: '37115|37087',
    county: 'Madison',
    county_names_all: 'Madison|Haywood',
    county_weights: '{"37115": 81.28, "37087": 18.72}',
    density: 6.9,
    imprecise: false,
    latitude: 35.80869,
    longitude: -82.90114,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28743',
  },
  {
    city: 'Lake Junaluska',
    county_fips: 37087,
    county_fips_all: '37087',
    county: 'Haywood',
    county_names_all: 'Haywood',
    county_weights: '{"37087": 100}',
    density: 432.7,
    imprecise: false,
    latitude: 35.52524,
    longitude: -82.97152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28745',
  },
  {
    city: 'Lake Lure',
    county_fips: 37161,
    county_fips_all: '37161',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"37161": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 35.461,
    longitude: -82.16779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28746',
  },
  {
    city: 'Lake Toxaway',
    county_fips: 37175,
    county_fips_all: '37175',
    county: 'Transylvania',
    county_names_all: 'Transylvania',
    county_weights: '{"37175": 100}',
    density: 16,
    imprecise: false,
    latitude: 35.15185,
    longitude: -82.9249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28747',
  },
  {
    city: 'Leicester',
    county_fips: 37021,
    county_fips_all: '37021|37115',
    county: 'Buncombe',
    county_names_all: 'Buncombe|Madison',
    county_weights: '{"37021": 89.05, "37115": 10.95}',
    density: 51.3,
    imprecise: false,
    latitude: 35.65492,
    longitude: -82.76032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28748',
  },
  {
    city: 'Little Switzerland',
    county_fips: 37111,
    county_fips_all: '37111|37121',
    county: 'McDowell',
    county_names_all: 'McDowell|Mitchell',
    county_weights: '{"37111": 72.98, "37121": 27.02}',
    density: 0,
    imprecise: false,
    latitude: 35.84098,
    longitude: -82.09797,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28749',
  },
  {
    city: 'Maggie Valley',
    county_fips: 37087,
    county_fips_all: '37087|37099',
    county: 'Haywood',
    county_names_all: 'Haywood|Jackson',
    county_weights: '{"37087": 78.29, "37099": 21.71}',
    density: 35.1,
    imprecise: false,
    latitude: 35.50547,
    longitude: -83.11955,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28751',
  },
  {
    city: 'Marion',
    county_fips: 37111,
    county_fips_all: '37111|37161',
    county: 'McDowell',
    county_names_all: 'McDowell|Rutherford',
    county_weights: '{"37111": 99.85, "37161": 0.15}',
    density: 47,
    imprecise: false,
    latitude: 35.71124,
    longitude: -82.03631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28752',
  },
  {
    city: 'Marshall',
    county_fips: 37115,
    county_fips_all: '37115|37021',
    county: 'Madison',
    county_names_all: 'Madison|Buncombe',
    county_weights: '{"37115": 97.86, "37021": 2.14}',
    density: 15.6,
    imprecise: false,
    latitude: 35.87181,
    longitude: -82.7002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28753',
  },
  {
    city: 'Mars Hill',
    county_fips: 37115,
    county_fips_all: '37115|37199',
    county: 'Madison',
    county_names_all: 'Madison|Yancey',
    county_weights: '{"37115": 94.61, "37199": 5.39}',
    density: 42.8,
    imprecise: false,
    latitude: 35.87696,
    longitude: -82.51441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28754',
  },
  {
    city: 'Micaville',
    county_fips: 37199,
    county_fips_all: '37199',
    county: 'Yancey',
    county_names_all: 'Yancey',
    county_weights: '{"37199": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.90825,
    longitude: -82.21756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28755',
  },
  {
    city: 'Mill Spring',
    county_fips: 37149,
    county_fips_all: '37149|37161',
    county: 'Polk',
    county_names_all: 'Polk|Rutherford',
    county_weights: '{"37149": 98.85, "37161": 1.15}',
    density: 22.9,
    imprecise: false,
    latitude: 35.34256,
    longitude: -82.18219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28756',
  },
  {
    city: 'Montreat',
    county_fips: 37021,
    county_fips_all: '37021',
    county: 'Buncombe',
    county_names_all: 'Buncombe',
    county_weights: '{"37021": 100}',
    density: 89.3,
    imprecise: false,
    latitude: 35.64781,
    longitude: -82.30006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28757',
  },
  {
    city: 'Mountain Home',
    county_fips: 37089,
    county_fips_all: '37089',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"37089": 100}',
    density: 2910.5,
    imprecise: false,
    latitude: 35.37489,
    longitude: -82.49569,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28758',
  },
  {
    city: 'Mills River',
    county_fips: 37089,
    county_fips_all: '37089|37021',
    county: 'Henderson',
    county_names_all: 'Henderson|Buncombe',
    county_weights: '{"37089": 98.59, "37021": 1.41}',
    density: 119.1,
    imprecise: false,
    latitude: 35.38348,
    longitude: -82.58431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28759',
  },
  {
    city: 'Nebo',
    county_fips: 37111,
    county_fips_all: '37111|37023',
    county: 'McDowell',
    county_names_all: 'McDowell|Burke',
    county_weights: '{"37111": 69.99, "37023": 30.01}',
    density: 30.3,
    imprecise: false,
    latitude: 35.69134,
    longitude: -81.90714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28761',
  },
  {
    city: 'Old Fort',
    county_fips: 37111,
    county_fips_all: '37111',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"37111": 100}',
    density: 26.7,
    imprecise: false,
    latitude: 35.63517,
    longitude: -82.18929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28762',
  },
  {
    city: 'Otto',
    county_fips: 37113,
    county_fips_all: '37113',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"37113": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 35.03796,
    longitude: -83.43215,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28763',
  },
  {
    city: 'Penrose',
    county_fips: 37175,
    county_fips_all: '37175|37089',
    county: 'Transylvania',
    county_names_all: 'Transylvania|Henderson',
    county_weights: '{"37175": 87.11, "37089": 12.89}',
    density: 81,
    imprecise: false,
    latitude: 35.24945,
    longitude: -82.61923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28766',
  },
  {
    city: 'Pisgah Forest',
    county_fips: 37175,
    county_fips_all: '37175',
    county: 'Transylvania',
    county_names_all: 'Transylvania',
    county_weights: '{"37175": 100}',
    density: 31.4,
    imprecise: false,
    latitude: 35.30437,
    longitude: -82.70925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28768',
  },
  {
    city: 'Ridgecrest',
    county_fips: 37021,
    county_fips_all: '37021|37111',
    county: 'Buncombe',
    county_names_all: 'Buncombe|McDowell',
    county_weights: '{"37021": 99.85, "37111": 0.15}',
    density: 0,
    imprecise: false,
    latitude: 35.62104,
    longitude: -82.2782,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28770',
  },
  {
    city: 'Robbinsville',
    county_fips: 37075,
    county_fips_all: '37075|37173',
    county: 'Graham',
    county_names_all: 'Graham|Swain',
    county_weights: '{"37075": 98.91, "37173": 1.09}',
    density: 11.3,
    imprecise: false,
    latitude: 35.34245,
    longitude: -83.8567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28771',
  },
  {
    city: 'Rosman',
    county_fips: 37175,
    county_fips_all: '37175',
    county: 'Transylvania',
    county_names_all: 'Transylvania',
    county_weights: '{"37175": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 35.13927,
    longitude: -82.83709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28772',
  },
  {
    city: 'Saluda',
    county_fips: 37149,
    county_fips_all: '37149|37089',
    county: 'Polk',
    county_names_all: 'Polk|Henderson',
    county_weights: '{"37149": 73.43, "37089": 26.57}',
    density: 27.5,
    imprecise: false,
    latitude: 35.25246,
    longitude: -82.31166,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28773',
  },
  {
    city: 'Sapphire',
    county_fips: 37175,
    county_fips_all: '37175|37099',
    county: 'Transylvania',
    county_names_all: 'Transylvania|Jackson',
    county_weights: '{"37175": 61.72, "37099": 38.28}',
    density: 10.3,
    imprecise: false,
    latitude: 35.08976,
    longitude: -82.99791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28774',
  },
  {
    city: 'Scaly Mountain',
    county_fips: 37113,
    county_fips_all: '37113',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"37113": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 35.01916,
    longitude: -83.32186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28775',
  },
  {
    city: 'Spruce Pine',
    county_fips: 37121,
    county_fips_all: '37121|37011|37111|37199',
    county: 'Mitchell',
    county_names_all: 'Mitchell|Avery|McDowell|Yancey',
    county_weights:
      '{"37121": 79.55, "37011": 15.02, "37111": 3.34, "37199": 2.09}',
    density: 54.8,
    imprecise: false,
    latitude: 35.90833,
    longitude: -82.06617,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28777',
  },
  {
    city: 'Swannanoa',
    county_fips: 37021,
    county_fips_all: '37021',
    county: 'Buncombe',
    county_names_all: 'Buncombe',
    county_weights: '{"37021": 100}',
    density: 160.9,
    imprecise: false,
    latitude: 35.61667,
    longitude: -82.40768,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28778',
  },
  {
    city: 'Sylva',
    county_fips: 37099,
    county_fips_all: '37099',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"37099": 100}',
    density: 64.6,
    imprecise: false,
    latitude: 35.3558,
    longitude: -83.20962,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28779',
  },
  {
    city: 'Topton',
    county_fips: 37113,
    county_fips_all: '37113',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"37113": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 35.21417,
    longitude: -83.63877,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28781',
  },
  {
    city: 'Tryon',
    county_fips: 37149,
    county_fips_all: '37149',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"37149": 100}',
    density: 51.3,
    imprecise: false,
    latitude: 35.23569,
    longitude: -82.1519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28782',
  },
  {
    city: 'Tuckasegee',
    county_fips: 37099,
    county_fips_all: '37099',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"37099": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 35.24906,
    longitude: -83.02,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28783',
  },
  {
    city: 'Waynesville',
    county_fips: 37087,
    county_fips_all: '37087',
    county: 'Haywood',
    county_names_all: 'Haywood',
    county_weights: '{"37087": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 35.64632,
    longitude: -83.08952,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28785',
  },
  {
    city: 'Waynesville',
    county_fips: 37087,
    county_fips_all: '37087',
    county: 'Haywood',
    county_names_all: 'Haywood',
    county_weights: '{"37087": 100}',
    density: 116.7,
    imprecise: false,
    latitude: 35.46272,
    longitude: -82.99294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28786',
  },
  {
    city: 'Weaverville',
    county_fips: 37021,
    county_fips_all: '37021|37115',
    county: 'Buncombe',
    county_names_all: 'Buncombe|Madison',
    county_weights: '{"37021": 94.62, "37115": 5.38}',
    density: 110.7,
    imprecise: false,
    latitude: 35.72795,
    longitude: -82.52306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28787',
  },
  {
    city: 'Webster',
    county_fips: 37099,
    county_fips_all: '37099',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"37099": 100}',
    density: 132.2,
    imprecise: false,
    latitude: 35.35044,
    longitude: -83.22266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28788',
  },
  {
    city: 'Whittier',
    county_fips: 37099,
    county_fips_all: '37099|37173',
    county: 'Jackson',
    county_names_all: 'Jackson|Swain',
    county_weights: '{"37099": 72.45, "37173": 27.55}',
    density: 38.2,
    imprecise: false,
    latitude: 35.4077,
    longitude: -83.31727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28789',
  },
  {
    city: 'Zirconia',
    county_fips: 37089,
    county_fips_all: '37089',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"37089": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 35.20036,
    longitude: -82.49507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28790',
  },
  {
    city: 'Hendersonville',
    county_fips: 37089,
    county_fips_all: '37089',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"37089": 100}',
    density: 348.6,
    imprecise: false,
    latitude: 35.35674,
    longitude: -82.508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28791',
  },
  {
    city: 'Hendersonville',
    county_fips: 37089,
    county_fips_all: '37089|37021',
    county: 'Henderson',
    county_names_all: 'Henderson|Buncombe',
    county_weights: '{"37089": 96.88, "37021": 3.12}',
    density: 137.5,
    imprecise: false,
    latitude: 35.39289,
    longitude: -82.36786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28792',
  },
  {
    city: 'Asheville',
    county_fips: 37021,
    county_fips_all: '37021',
    county: 'Buncombe',
    county_names_all: 'Buncombe',
    county_weights: '{"37021": 100}',
    density: 1110.4,
    imprecise: false,
    latitude: 35.59441,
    longitude: -82.55785,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28801',
  },
  {
    city: 'Asheville',
    county_fips: 37021,
    county_fips_all: '37021',
    county: 'Buncombe',
    county_names_all: 'Buncombe',
    county_weights: '{"37021": 100}',
    density: 339.3,
    imprecise: false,
    latitude: 35.52949,
    longitude: -82.52007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28803',
  },
  {
    city: 'Asheville',
    county_fips: 37021,
    county_fips_all: '37021',
    county: 'Buncombe',
    county_names_all: 'Buncombe',
    county_weights: '{"37021": 100}',
    density: 347.3,
    imprecise: false,
    latitude: 35.64814,
    longitude: -82.5612,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28804',
  },
  {
    city: 'Asheville',
    county_fips: 37021,
    county_fips_all: '37021',
    county: 'Buncombe',
    county_names_all: 'Buncombe',
    county_weights: '{"37021": 100}',
    density: 291.4,
    imprecise: false,
    latitude: 35.61528,
    longitude: -82.47923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28805',
  },
  {
    city: 'Asheville',
    county_fips: 37021,
    county_fips_all: '37021',
    county: 'Buncombe',
    county_names_all: 'Buncombe',
    county_weights: '{"37021": 100}',
    density: 439.6,
    imprecise: false,
    latitude: 35.57154,
    longitude: -82.61386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28806',
  },
  {
    city: 'Andrews',
    county_fips: 37039,
    county_fips_all: '37039',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"37039": 100}',
    density: 30.8,
    imprecise: false,
    latitude: 35.20127,
    longitude: -83.80506,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28901',
  },
  {
    city: 'Brasstown',
    county_fips: 37043,
    county_fips_all: '37043|37039',
    county: 'Clay',
    county_names_all: 'Clay|Cherokee',
    county_weights: '{"37043": 66.76, "37039": 33.24}',
    density: 16.9,
    imprecise: false,
    latitude: 35.02503,
    longitude: -83.9571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28902',
  },
  {
    city: 'Hayesville',
    county_fips: 37043,
    county_fips_all: '37043',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"37043": 100}',
    density: 20.8,
    imprecise: false,
    latitude: 35.06185,
    longitude: -83.73041,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28904',
  },
  {
    city: 'Marble',
    county_fips: 37039,
    county_fips_all: '37039',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"37039": 100}',
    density: 26.1,
    imprecise: false,
    latitude: 35.1631,
    longitude: -83.9409,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28905',
  },
  {
    city: 'Murphy',
    county_fips: 37039,
    county_fips_all: '37039',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"37039": 100}',
    density: 23.8,
    imprecise: false,
    latitude: 35.11873,
    longitude: -84.13343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28906',
  },
  {
    city: 'Warne',
    county_fips: 37043,
    county_fips_all: '37043',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"37043": 100}',
    density: 40.6,
    imprecise: false,
    latitude: 35.00125,
    longitude: -83.90319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28909',
  },
  {
    city: 'Alcolu',
    county_fips: 45027,
    county_fips_all: '45027|45085',
    county: 'Clarendon',
    county_names_all: 'Clarendon|Sumter',
    county_weights: '{"45027": 89.1, "45085": 10.9}',
    density: 12.9,
    imprecise: false,
    latitude: 33.78528,
    longitude: -80.17338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29001',
  },
  {
    city: 'Bamberg',
    county_fips: 45009,
    county_fips_all: '45009',
    county: 'Bamberg',
    county_names_all: 'Bamberg',
    county_weights: '{"45009": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 33.24135,
    longitude: -81.01838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29003',
  },
  {
    city: 'Batesburg',
    county_fips: 45081,
    county_fips_all: '45081|45003|45063',
    county: 'Saluda',
    county_names_all: 'Saluda|Aiken|Lexington',
    county_weights: '{"45081": 40.59, "45003": 37.65, "45063": 21.76}',
    density: 25.7,
    imprecise: false,
    latitude: 33.87673,
    longitude: -81.55294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29006',
  },
  {
    city: 'Bethune',
    county_fips: 45055,
    county_fips_all: '45055|45025|45061',
    county: 'Kershaw',
    county_names_all: 'Kershaw|Chesterfield|Lee',
    county_weights: '{"45055": 91.28, "45025": 6.15, "45061": 2.57}',
    density: 8.4,
    imprecise: false,
    latitude: 34.44097,
    longitude: -80.37642,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29009',
  },
  {
    city: 'Bishopville',
    county_fips: 45061,
    county_fips_all: '45061|45055',
    county: 'Lee',
    county_names_all: 'Lee|Kershaw',
    county_weights: '{"45061": 99.29, "45055": 0.71}',
    density: 23,
    imprecise: false,
    latitude: 34.21487,
    longitude: -80.26946,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29010',
  },
  {
    city: 'Blackstock',
    county_fips: 45039,
    county_fips_all: '45039|45023',
    county: 'Fairfield',
    county_names_all: 'Fairfield|Chester',
    county_weights: '{"45039": 58.03, "45023": 41.97}',
    density: 3.8,
    imprecise: false,
    latitude: 34.54368,
    longitude: -81.13553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29014',
  },
  {
    city: 'Blair',
    county_fips: 45039,
    county_fips_all: '45039',
    county: 'Fairfield',
    county_names_all: 'Fairfield',
    county_weights: '{"45039": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 34.4412,
    longitude: -81.33807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29015',
  },
  {
    city: 'Blythewood',
    county_fips: 45079,
    county_fips_all: '45079|45039',
    county: 'Richland',
    county_names_all: 'Richland|Fairfield',
    county_weights: '{"45079": 90.46, "45039": 9.54}',
    density: 135.2,
    imprecise: false,
    latitude: 34.20367,
    longitude: -80.99296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29016',
  },
  {
    city: 'Bowman',
    county_fips: 45075,
    county_fips_all: '45075|45035',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg|Dorchester',
    county_weights: '{"45075": 97.45, "45035": 2.55}',
    density: 13,
    imprecise: false,
    latitude: 33.34619,
    longitude: -80.64373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29018',
  },
  {
    city: 'Camden',
    county_fips: 45055,
    county_fips_all: '45055|45061',
    county: 'Kershaw',
    county_names_all: 'Kershaw|Lee',
    county_weights: '{"45055": 94.16, "45061": 5.84}',
    density: 38.6,
    imprecise: false,
    latitude: 34.31036,
    longitude: -80.59334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29020',
  },
  {
    city: 'Cameron',
    county_fips: 45017,
    county_fips_all: '45017|45075',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Orangeburg',
    county_weights: '{"45017": 79.51, "45075": 20.49}',
    density: 8.3,
    imprecise: false,
    latitude: 33.57917,
    longitude: -80.65441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29030',
  },
  {
    city: 'Carlisle',
    county_fips: 45023,
    county_fips_all: '45023|45087|45039',
    county: 'Chester',
    county_names_all: 'Chester|Union|Fairfield',
    county_weights: '{"45023": 50.21, "45087": 44.09, "45039": 5.7}',
    density: 4.8,
    imprecise: false,
    latitude: 34.60624,
    longitude: -81.42665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29031',
  },
  {
    city: 'Cassatt',
    county_fips: 45055,
    county_fips_all: '45055|45061',
    county: 'Kershaw',
    county_names_all: 'Kershaw|Lee',
    county_weights: '{"45055": 78.8, "45061": 21.2}',
    density: 22.9,
    imprecise: false,
    latitude: 34.34002,
    longitude: -80.44374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29032',
  },
  {
    city: 'Cayce',
    county_fips: 45063,
    county_fips_all: '45063',
    county: 'Lexington',
    county_names_all: 'Lexington',
    county_weights: '{"45063": 100}',
    density: 494.7,
    imprecise: false,
    latitude: 33.9552,
    longitude: -81.05691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29033',
  },
  {
    city: 'Chapin',
    county_fips: 45063,
    county_fips_all: '45063|45079|45071',
    county: 'Lexington',
    county_names_all: 'Lexington|Richland|Newberry',
    county_weights: '{"45063": 72.66, "45079": 23.69, "45071": 3.65}',
    density: 186.4,
    imprecise: false,
    latitude: 34.13396,
    longitude: -81.33622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29036',
  },
  {
    city: 'Chappells',
    county_fips: 45071,
    county_fips_all: '45071|45081|45059',
    county: 'Newberry',
    county_names_all: 'Newberry|Saluda|Laurens',
    county_weights: '{"45071": 57.22, "45081": 37.88, "45059": 4.9}',
    density: 5.5,
    imprecise: false,
    latitude: 34.18961,
    longitude: -81.86868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29037',
  },
  {
    city: 'Cope',
    county_fips: 45075,
    county_fips_all: '45075',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg',
    county_weights: '{"45075": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 33.37494,
    longitude: -80.98095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29038',
  },
  {
    city: 'Cordova',
    county_fips: 45075,
    county_fips_all: '45075',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg',
    county_weights: '{"45075": 100}',
    density: 47.3,
    imprecise: false,
    latitude: 33.41855,
    longitude: -80.90556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29039',
  },
  {
    city: 'Dalzell',
    county_fips: 45085,
    county_fips_all: '45085|45061',
    county: 'Sumter',
    county_names_all: 'Sumter|Lee',
    county_weights: '{"45085": 61.46, "45061": 38.54}',
    density: 63.3,
    imprecise: false,
    latitude: 34.06253,
    longitude: -80.43455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29040',
  },
  {
    city: 'Denmark',
    county_fips: 45009,
    county_fips_all: '45009',
    county: 'Bamberg',
    county_names_all: 'Bamberg',
    county_weights: '{"45009": 100}',
    density: 30.8,
    imprecise: false,
    latitude: 33.30735,
    longitude: -81.14723,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29042',
  },
  {
    city: 'Eastover',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 33.93437,
    longitude: -80.69446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29044',
  },
  {
    city: 'Elgin',
    county_fips: 45055,
    county_fips_all: '45055|45079|45039',
    county: 'Kershaw',
    county_names_all: 'Kershaw|Richland|Fairfield',
    county_weights: '{"45055": 64.46, "45079": 33.6, "45039": 1.94}',
    density: 178.4,
    imprecise: false,
    latitude: 34.18389,
    longitude: -80.8141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29045',
  },
  {
    city: 'Elliott',
    county_fips: 45061,
    county_fips_all: '45061',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"45061": 100}',
    density: 21.5,
    imprecise: false,
    latitude: 34.11252,
    longitude: -80.16131,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29046',
  },
  {
    city: 'Elloree',
    county_fips: 45017,
    county_fips_all: '45017|45075',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Orangeburg',
    county_weights: '{"45017": 51.18, "45075": 48.82}',
    density: 21.3,
    imprecise: false,
    latitude: 33.53218,
    longitude: -80.57956,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29047',
  },
  {
    city: 'Eutawville',
    county_fips: 45075,
    county_fips_all: '45075',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg',
    county_weights: '{"45075": 100}',
    density: 42.9,
    imprecise: false,
    latitude: 33.39057,
    longitude: -80.29702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29048',
  },
  {
    city: 'Gable',
    county_fips: 45027,
    county_fips_all: '45027|45085',
    county: 'Clarendon',
    county_names_all: 'Clarendon|Sumter',
    county_weights: '{"45027": 52.99, "45085": 47.01}',
    density: 7.2,
    imprecise: false,
    latitude: 33.8669,
    longitude: -80.12231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29051',
  },
  {
    city: 'Gadsden',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 33.81036,
    longitude: -80.73832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29052',
  },
  {
    city: 'Gaston',
    county_fips: 45063,
    county_fips_all: '45063|45017',
    county: 'Lexington',
    county_names_all: 'Lexington|Calhoun',
    county_weights: '{"45063": 70.99, "45017": 29.01}',
    density: 101.2,
    imprecise: false,
    latitude: 33.82734,
    longitude: -81.08646,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29053',
  },
  {
    city: 'Gilbert',
    county_fips: 45063,
    county_fips_all: '45063',
    county: 'Lexington',
    county_names_all: 'Lexington',
    county_weights: '{"45063": 100}',
    density: 75.3,
    imprecise: false,
    latitude: 33.94834,
    longitude: -81.37875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29054',
  },
  {
    city: 'Great Falls',
    county_fips: 45023,
    county_fips_all: '45023|45039|45057',
    county: 'Chester',
    county_names_all: 'Chester|Fairfield|Lancaster',
    county_weights: '{"45023": 67.98, "45039": 31.9, "45057": 0.12}',
    density: 43.7,
    imprecise: false,
    latitude: 34.57248,
    longitude: -80.91753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29055',
  },
  {
    city: 'Greeleyville',
    county_fips: 45089,
    county_fips_all: '45089|45027',
    county: 'Williamsburg',
    county_names_all: 'Williamsburg|Clarendon',
    county_weights: '{"45089": 88.6, "45027": 11.4}',
    density: 8.3,
    imprecise: false,
    latitude: 33.60798,
    longitude: -79.99473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29056',
  },
  {
    city: 'Heath Springs',
    county_fips: 45057,
    county_fips_all: '45057|45055',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Kershaw',
    county_weights: '{"45057": 90.05, "45055": 9.95}',
    density: 14.5,
    imprecise: false,
    latitude: 34.56297,
    longitude: -80.73473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29058',
  },
  {
    city: 'Holly Hill',
    county_fips: 45075,
    county_fips_all: '45075|45015',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg|Berkeley',
    county_weights: '{"45075": 95.18, "45015": 4.82}',
    density: 17.3,
    imprecise: false,
    latitude: 33.32853,
    longitude: -80.41891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29059',
  },
  {
    city: 'Hopkins',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 54.8,
    imprecise: false,
    latitude: 33.89923,
    longitude: -80.84955,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29061',
  },
  {
    city: 'Horatio',
    county_fips: 45085,
    county_fips_all: '45085',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"45085": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 33.99818,
    longitude: -80.60785,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29062',
  },
  {
    city: 'Irmo',
    county_fips: 45079,
    county_fips_all: '45079|45063',
    county: 'Richland',
    county_names_all: 'Richland|Lexington',
    county_weights: '{"45079": 97.19, "45063": 2.81}',
    density: 367.7,
    imprecise: false,
    latitude: 34.13948,
    longitude: -81.20457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29063',
  },
  {
    city: 'Jenkinsville',
    county_fips: 45039,
    county_fips_all: '45039',
    county: 'Fairfield',
    county_names_all: 'Fairfield',
    county_weights: '{"45039": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 34.29495,
    longitude: -81.29239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29065',
  },
  {
    city: 'Kershaw',
    county_fips: 45057,
    county_fips_all: '45057|45055',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Kershaw',
    county_weights: '{"45057": 54.13, "45055": 45.87}',
    density: 22.6,
    imprecise: false,
    latitude: 34.54976,
    longitude: -80.53268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29067',
  },
  {
    city: 'Lamar',
    county_fips: 45031,
    county_fips_all: '45031|45061',
    county: 'Darlington',
    county_names_all: 'Darlington|Lee',
    county_weights: '{"45031": 78.46, "45061": 21.54}',
    density: 22.9,
    imprecise: false,
    latitude: 34.18798,
    longitude: -80.09654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29069',
  },
  {
    city: 'Leesville',
    county_fips: 45063,
    county_fips_all: '45063|45081',
    county: 'Lexington',
    county_names_all: 'Lexington|Saluda',
    county_weights: '{"45063": 77.83, "45081": 22.17}',
    density: 36.8,
    imprecise: false,
    latitude: 33.91742,
    longitude: -81.45517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29070',
  },
  {
    city: 'Lexington',
    county_fips: 45063,
    county_fips_all: '45063',
    county: 'Lexington',
    county_names_all: 'Lexington',
    county_weights: '{"45063": 100}',
    density: 393.9,
    imprecise: false,
    latitude: 33.9985,
    longitude: -81.27098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29072',
  },
  {
    city: 'Lexington',
    county_fips: 45063,
    county_fips_all: '45063',
    county: 'Lexington',
    county_names_all: 'Lexington',
    county_weights: '{"45063": 100}',
    density: 250.8,
    imprecise: false,
    latitude: 33.89299,
    longitude: -81.23774,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29073',
  },
  {
    city: 'Liberty Hill',
    county_fips: 45055,
    county_fips_all: '45055',
    county: 'Kershaw',
    county_names_all: 'Kershaw',
    county_weights: '{"45055": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 34.4512,
    longitude: -80.8144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29074',
  },
  {
    city: 'Little Mountain',
    county_fips: 45071,
    county_fips_all: '45071|45079|45063',
    county: 'Newberry',
    county_names_all: 'Newberry|Richland|Lexington',
    county_weights: '{"45071": 66.45, "45079": 26.93, "45063": 6.62}',
    density: 26.6,
    imprecise: false,
    latitude: 34.19985,
    longitude: -81.37581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29075',
  },
  {
    city: 'Lugoff',
    county_fips: 45055,
    county_fips_all: '45055|45079',
    county: 'Kershaw',
    county_names_all: 'Kershaw|Richland',
    county_weights: '{"45055": 88.54, "45079": 11.46}',
    density: 50,
    imprecise: false,
    latitude: 34.18162,
    longitude: -80.6994,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29078',
  },
  {
    city: 'Lydia',
    county_fips: 45031,
    county_fips_all: '45031',
    county: 'Darlington',
    county_names_all: 'Darlington',
    county_weights: '{"45031": 100}',
    density: 210.2,
    imprecise: false,
    latitude: 34.289,
    longitude: -80.11318,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29079',
  },
  {
    city: 'Lynchburg',
    county_fips: 45061,
    county_fips_all: '45061|45085',
    county: 'Lee',
    county_names_all: 'Lee|Sumter',
    county_weights: '{"45061": 55.62, "45085": 44.38}',
    density: 7.8,
    imprecise: false,
    latitude: 34.01525,
    longitude: -80.08374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29080',
  },
  {
    city: 'Ehrhardt',
    county_fips: 45009,
    county_fips_all: '45009|45029',
    county: 'Bamberg',
    county_names_all: 'Bamberg|Colleton',
    county_weights: '{"45009": 85.4, "45029": 14.6}',
    density: 5.3,
    imprecise: false,
    latitude: 33.09161,
    longitude: -81.0426,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29081',
  },
  {
    city: 'Lodge',
    county_fips: 45029,
    county_fips_all: '45029|45009',
    county: 'Colleton',
    county_names_all: 'Colleton|Bamberg',
    county_weights: '{"45029": 96.81, "45009": 3.19}',
    density: 3.8,
    imprecise: false,
    latitude: 33.04012,
    longitude: -80.93868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29082',
  },
  {
    city: 'McBee',
    county_fips: 45025,
    county_fips_all: '45025|45031',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield|Darlington',
    county_weights: '{"45025": 87.28, "45031": 12.72}',
    density: 7.9,
    imprecise: false,
    latitude: 34.47798,
    longitude: -80.24038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29101',
  },
  {
    city: 'Manning',
    county_fips: 45027,
    county_fips_all: '45027',
    county: 'Clarendon',
    county_names_all: 'Clarendon',
    county_weights: '{"45027": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 33.6437,
    longitude: -80.19225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29102',
  },
  {
    city: 'Mayesville',
    county_fips: 45061,
    county_fips_all: '45061|45085',
    county: 'Lee',
    county_names_all: 'Lee|Sumter',
    county_weights: '{"45061": 51.67, "45085": 48.33}',
    density: 10.2,
    imprecise: false,
    latitude: 33.99524,
    longitude: -80.21373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29104',
  },
  {
    city: 'Monetta',
    county_fips: 45003,
    county_fips_all: '45003|45081',
    county: 'Aiken',
    county_names_all: 'Aiken|Saluda',
    county_weights: '{"45003": 76.04, "45081": 23.96}',
    density: 20.4,
    imprecise: false,
    latitude: 33.80764,
    longitude: -81.59047,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29105',
  },
  {
    city: 'Neeses',
    county_fips: 45075,
    county_fips_all: '45075',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg',
    county_weights: '{"45075": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 33.52348,
    longitude: -81.11856,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29107',
  },
  {
    city: 'Newberry',
    county_fips: 45071,
    county_fips_all: '45071',
    county: 'Newberry',
    county_names_all: 'Newberry',
    county_weights: '{"45071": 100}',
    density: 36,
    imprecise: false,
    latitude: 34.29805,
    longitude: -81.62433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29108',
  },
  {
    city: 'New Zion',
    county_fips: 45027,
    county_fips_all: '45027|45089',
    county: 'Clarendon',
    county_names_all: 'Clarendon|Williamsburg',
    county_weights: '{"45027": 88.39, "45089": 11.61}',
    density: 8.3,
    imprecise: false,
    latitude: 33.78648,
    longitude: -80.01433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29111',
  },
  {
    city: 'North',
    county_fips: 45075,
    county_fips_all: '45075|45017|45063',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg|Calhoun|Lexington',
    county_weights: '{"45075": 88.13, "45017": 9.01, "45063": 2.86}',
    density: 12.3,
    imprecise: false,
    latitude: 33.62662,
    longitude: -81.0837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29112',
  },
  {
    city: 'Norway',
    county_fips: 45075,
    county_fips_all: '45075',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg',
    county_weights: '{"45075": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 33.43514,
    longitude: -81.13173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29113',
  },
  {
    city: 'Olanta',
    county_fips: 45041,
    county_fips_all: '45041|45085|45027',
    county: 'Florence',
    county_names_all: 'Florence|Sumter|Clarendon',
    county_weights: '{"45041": 58.8, "45085": 39.52, "45027": 1.68}',
    density: 20,
    imprecise: false,
    latitude: 33.95436,
    longitude: -79.93537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29114',
  },
  {
    city: 'Orangeburg',
    county_fips: 45075,
    county_fips_all: '45075',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg',
    county_weights: '{"45075": 100}',
    density: 85,
    imprecise: false,
    latitude: 33.47673,
    longitude: -80.84758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29115',
  },
  {
    city: 'Orangeburg',
    county_fips: 45075,
    county_fips_all: '45075|45017',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg|Calhoun',
    county_weights: '{"45075": 92.87, "45017": 7.13}',
    density: 76.3,
    imprecise: false,
    latitude: 33.57056,
    longitude: -80.89501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29118',
  },
  {
    city: 'Peak',
    county_fips: 45071,
    county_fips_all: '45071',
    county: 'Newberry',
    county_names_all: 'Newberry',
    county_weights: '{"45071": 100}',
    density: 88.8,
    imprecise: false,
    latitude: 34.24015,
    longitude: -81.32532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29122',
  },
  {
    city: 'Pelion',
    county_fips: 45063,
    county_fips_all: '45063',
    county: 'Lexington',
    county_names_all: 'Lexington',
    county_weights: '{"45063": 100}',
    density: 45,
    imprecise: false,
    latitude: 33.76563,
    longitude: -81.25844,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29123',
  },
  {
    city: 'Pinewood',
    county_fips: 45085,
    county_fips_all: '45085|45027',
    county: 'Sumter',
    county_names_all: 'Sumter|Clarendon',
    county_weights: '{"45085": 53.33, "45027": 46.67}',
    density: 9.5,
    imprecise: false,
    latitude: 33.70165,
    longitude: -80.47434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29125',
  },
  {
    city: 'Pomaria',
    county_fips: 45071,
    county_fips_all: '45071',
    county: 'Newberry',
    county_names_all: 'Newberry',
    county_weights: '{"45071": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 34.32195,
    longitude: -81.41932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29126',
  },
  {
    city: 'Prosperity',
    county_fips: 45071,
    county_fips_all: '45071|45081',
    county: 'Newberry',
    county_names_all: 'Newberry|Saluda',
    county_weights: '{"45071": 93.54, "45081": 6.46}',
    density: 38.2,
    imprecise: false,
    latitude: 34.16568,
    longitude: -81.51192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29127',
  },
  {
    city: 'Rembert',
    county_fips: 45085,
    county_fips_all: '45085|45055|45061',
    county: 'Sumter',
    county_names_all: 'Sumter|Kershaw|Lee',
    county_weights: '{"45085": 64.5, "45055": 23.99, "45061": 11.51}',
    density: 16.1,
    imprecise: false,
    latitude: 34.0963,
    longitude: -80.53268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29128',
  },
  {
    city: 'Ridge Spring',
    county_fips: 45003,
    county_fips_all: '45003|45081|45037',
    county: 'Aiken',
    county_names_all: 'Aiken|Saluda|Edgefield',
    county_weights: '{"45003": 55.0, "45081": 32.8, "45037": 12.2}',
    density: 21.3,
    imprecise: false,
    latitude: 33.79236,
    longitude: -81.66823,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29129',
  },
  {
    city: 'Ridgeway',
    county_fips: 45039,
    county_fips_all: '45039|45055|45079',
    county: 'Fairfield',
    county_names_all: 'Fairfield|Kershaw|Richland',
    county_weights: '{"45039": 83.46, "45055": 15.41, "45079": 1.13}',
    density: 16,
    imprecise: false,
    latitude: 34.32757,
    longitude: -80.89205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29130',
  },
  {
    city: 'Rowesville',
    county_fips: 45075,
    county_fips_all: '45075',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg',
    county_weights: '{"45075": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 33.35726,
    longitude: -80.80698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29133',
  },
  {
    city: 'Saint Matthews',
    county_fips: 45017,
    county_fips_all: '45017|45075',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Orangeburg',
    county_weights: '{"45017": 98.93, "45075": 1.07}',
    density: 16.5,
    imprecise: false,
    latitude: 33.68834,
    longitude: -80.7875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29135',
  },
  {
    city: 'Salley',
    county_fips: 45003,
    county_fips_all: '45003|45075',
    county: 'Aiken',
    county_names_all: 'Aiken|Orangeburg',
    county_weights: '{"45003": 82.95, "45075": 17.05}',
    density: 9.3,
    imprecise: false,
    latitude: 33.59626,
    longitude: -81.32226,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29137',
  },
  {
    city: 'Saluda',
    county_fips: 45081,
    county_fips_all: '45081|45047|45037',
    county: 'Saluda',
    county_names_all: 'Saluda|Greenwood|Edgefield',
    county_weights: '{"45081": 97.02, "45047": 2.55, "45037": 0.43}',
    density: 17.5,
    imprecise: false,
    latitude: 34.04491,
    longitude: -81.77152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29138',
  },
  {
    city: 'Santee',
    county_fips: 45075,
    county_fips_all: '45075',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg',
    county_weights: '{"45075": 100}',
    density: 36,
    imprecise: false,
    latitude: 33.46491,
    longitude: -80.52329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29142',
  },
  {
    city: 'Silverstreet',
    county_fips: 45071,
    county_fips_all: '45071',
    county: 'Newberry',
    county_names_all: 'Newberry',
    county_weights: '{"45071": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 34.21905,
    longitude: -81.77453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29145',
  },
  {
    city: 'Springfield',
    county_fips: 45075,
    county_fips_all: '45075|45003',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg|Aiken',
    county_weights: '{"45075": 66.63, "45003": 33.37}',
    density: 7.9,
    imprecise: false,
    latitude: 33.50816,
    longitude: -81.29812,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29146',
  },
  {
    city: 'Summerton',
    county_fips: 45027,
    county_fips_all: '45027',
    county: 'Clarendon',
    county_names_all: 'Clarendon',
    county_weights: '{"45027": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 33.53731,
    longitude: -80.34386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29148',
  },
  {
    city: 'Sumter',
    county_fips: 45085,
    county_fips_all: '45085',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"45085": 100}',
    density: 339,
    imprecise: false,
    latitude: 33.87621,
    longitude: -80.35609,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29150',
  },
  {
    city: 'Shaw Afb',
    county_fips: 45085,
    county_fips_all: '45085',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"45085": 100}',
    density: 148.9,
    imprecise: false,
    latitude: 33.97517,
    longitude: -80.47019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29152',
  },
  {
    city: 'Sumter',
    county_fips: 45085,
    county_fips_all: '45085|45061',
    county: 'Sumter',
    county_names_all: 'Sumter|Lee',
    county_weights: '{"45085": 87.28, "45061": 12.72}',
    density: 38.7,
    imprecise: false,
    latitude: 33.96515,
    longitude: -80.30675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29153',
  },
  {
    city: 'Sumter',
    county_fips: 45085,
    county_fips_all: '45085',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"45085": 100}',
    density: 106.6,
    imprecise: false,
    latitude: 33.88515,
    longitude: -80.47547,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29154',
  },
  {
    city: 'Swansea',
    county_fips: 45063,
    county_fips_all: '45063|45017|45075',
    county: 'Lexington',
    county_names_all: 'Lexington|Calhoun|Orangeburg',
    county_weights: '{"45063": 61.5, "45017": 38.08, "45075": 0.42}',
    density: 24.3,
    imprecise: false,
    latitude: 33.74358,
    longitude: -81.04188,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29160',
  },
  {
    city: 'Timmonsville',
    county_fips: 45041,
    county_fips_all: '45041|45031',
    county: 'Florence',
    county_names_all: 'Florence|Darlington',
    county_weights: '{"45041": 75.74, "45031": 24.26}',
    density: 27.7,
    imprecise: false,
    latitude: 34.10532,
    longitude: -79.94143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29161',
  },
  {
    city: 'Turbeville',
    county_fips: 45027,
    county_fips_all: '45027|45085',
    county: 'Clarendon',
    county_names_all: 'Clarendon|Sumter',
    county_weights: '{"45027": 96.53, "45085": 3.47}',
    density: 43.2,
    imprecise: false,
    latitude: 33.88751,
    longitude: -80.00865,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29162',
  },
  {
    city: 'Vance',
    county_fips: 45075,
    county_fips_all: '45075',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg',
    county_weights: '{"45075": 100}',
    density: 19,
    imprecise: false,
    latitude: 33.42019,
    longitude: -80.43918,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29163',
  },
  {
    city: 'Wagener',
    county_fips: 45003,
    county_fips_all: '45003',
    county: 'Aiken',
    county_names_all: 'Aiken',
    county_weights: '{"45003": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 33.65699,
    longitude: -81.42586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29164',
  },
  {
    city: 'Ward',
    county_fips: 45081,
    county_fips_all: '45081',
    county: 'Saluda',
    county_names_all: 'Saluda',
    county_weights: '{"45081": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 33.90102,
    longitude: -81.71304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29166',
  },
  {
    city: 'Wedgefield',
    county_fips: 45085,
    county_fips_all: '45085',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"45085": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 33.84848,
    longitude: -80.54483,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29168',
  },
  {
    city: 'West Columbia',
    county_fips: 45063,
    county_fips_all: '45063|45079',
    county: 'Lexington',
    county_names_all: 'Lexington|Richland',
    county_weights: '{"45063": 99.77, "45079": 0.23}',
    density: 719.3,
    imprecise: false,
    latitude: 33.9967,
    longitude: -81.09676,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29169',
  },
  {
    city: 'West Columbia',
    county_fips: 45063,
    county_fips_all: '45063',
    county: 'Lexington',
    county_names_all: 'Lexington',
    county_weights: '{"45063": 100}',
    density: 335.5,
    imprecise: false,
    latitude: 33.93929,
    longitude: -81.14487,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29170',
  },
  {
    city: 'West Columbia',
    county_fips: 45063,
    county_fips_all: '45063',
    county: 'Lexington',
    county_names_all: 'Lexington',
    county_weights: '{"45063": 100}',
    density: 145.1,
    imprecise: false,
    latitude: 33.90603,
    longitude: -81.07264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29172',
  },
  {
    city: 'Westville',
    county_fips: 45055,
    county_fips_all: '45055',
    county: 'Kershaw',
    county_names_all: 'Kershaw',
    county_weights: '{"45055": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 34.44266,
    longitude: -80.60666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29175',
  },
  {
    city: 'White Rock',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 497.9,
    imprecise: false,
    latitude: 34.1405,
    longitude: -81.2675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29177',
  },
  {
    city: 'Whitmire',
    county_fips: 45071,
    county_fips_all: '45071|45087|45059',
    county: 'Newberry',
    county_names_all: 'Newberry|Union|Laurens',
    county_weights: '{"45071": 50.49, "45087": 36.6, "45059": 12.91}',
    density: 8.8,
    imprecise: false,
    latitude: 34.4992,
    longitude: -81.5961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29178',
  },
  {
    city: 'Winnsboro',
    county_fips: 45039,
    county_fips_all: '45039|45079',
    county: 'Fairfield',
    county_names_all: 'Fairfield|Richland',
    county_weights: '{"45039": 95.55, "45079": 4.45}',
    density: 14.7,
    imprecise: false,
    latitude: 34.36472,
    longitude: -81.09821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29180',
  },
  {
    city: 'Columbia',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 823.9,
    imprecise: false,
    latitude: 33.98381,
    longitude: -81.02829,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29201',
  },
  {
    city: 'Columbia',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 252.1,
    imprecise: false,
    latitude: 34.10198,
    longitude: -81.04009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29203',
  },
  {
    city: 'Columbia',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 1101.5,
    imprecise: false,
    latitude: 34.02938,
    longitude: -81.00008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29204',
  },
  {
    city: 'Columbia',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 1329,
    imprecise: false,
    latitude: 33.99001,
    longitude: -80.99661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29205',
  },
  {
    city: 'Columbia',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 883.4,
    imprecise: false,
    latitude: 34.02848,
    longitude: -80.95828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29206',
  },
  {
    city: 'Columbia',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 47.2,
    imprecise: false,
    latitude: 34.04306,
    longitude: -80.84208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29207',
  },
  {
    city: 'Columbia',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 278.1,
    imprecise: false,
    latitude: 33.92442,
    longitude: -80.95284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29209',
  },
  {
    city: 'Columbia',
    county_fips: 45079,
    county_fips_all: '45079|45063',
    county: 'Richland',
    county_names_all: 'Richland|Lexington',
    county_weights: '{"45079": 70.49, "45063": 29.51}',
    density: 920.3,
    imprecise: false,
    latitude: 34.04764,
    longitude: -81.10697,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29210',
  },
  {
    city: 'Columbia',
    county_fips: 45063,
    county_fips_all: '45063|45079',
    county: 'Lexington',
    county_names_all: 'Lexington|Richland',
    county_weights: '{"45063": 77.74, "45079": 22.26}',
    density: 499.5,
    imprecise: false,
    latitude: 34.0777,
    longitude: -81.2022,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29212',
  },
  {
    city: 'Columbia',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 809.6,
    imprecise: false,
    latitude: 34.09243,
    longitude: -80.92153,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29223',
  },
  {
    city: 'Columbia',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 1096.5,
    imprecise: false,
    latitude: 34.14697,
    longitude: -80.89316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29229',
  },
  {
    city: 'Spartanburg',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 508.7,
    imprecise: false,
    latitude: 34.93516,
    longitude: -82.01301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29301',
  },
  {
    city: 'Spartanburg',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 151.6,
    imprecise: false,
    latitude: 34.89399,
    longitude: -81.84151,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29302',
  },
  {
    city: 'Spartanburg',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 337.8,
    imprecise: false,
    latitude: 34.99424,
    longitude: -81.96883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29303',
  },
  {
    city: 'Spartanburg',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 330.7,
    imprecise: false,
    latitude: 34.89338,
    longitude: -81.92177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29306',
  },
  {
    city: 'Spartanburg',
    county_fips: 45083,
    county_fips_all: '45083|45021',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg|Cherokee',
    county_weights: '{"45083": 89.27, "45021": 10.73}',
    density: 165,
    imprecise: false,
    latitude: 34.98381,
    longitude: -81.83146,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29307',
  },
  {
    city: 'Boiling Springs',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 585.7,
    imprecise: false,
    latitude: 35.04179,
    longitude: -81.9766,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29316',
  },
  {
    city: 'Arcadia',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 376.9,
    imprecise: false,
    latitude: 34.95847,
    longitude: -81.9922,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29320',
  },
  {
    city: 'Buffalo',
    county_fips: 45087,
    county_fips_all: '45087',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"45087": 100}',
    density: 31.8,
    imprecise: false,
    latitude: 34.71975,
    longitude: -81.74151,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29321',
  },
  {
    city: 'Campobello',
    county_fips: 45083,
    county_fips_all: '45083|45045',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg|Greenville',
    county_weights: '{"45083": 97.74, "45045": 2.26}',
    density: 72.9,
    imprecise: false,
    latitude: 35.12254,
    longitude: -82.13157,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29322',
  },
  {
    city: 'Chesnee',
    county_fips: 45083,
    county_fips_all: '45083|45021',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg|Cherokee',
    county_weights: '{"45083": 87.16, "45021": 12.84}',
    density: 84.7,
    imprecise: false,
    latitude: 35.12911,
    longitude: -81.90902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29323',
  },
  {
    city: 'Clifton',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 26,
    imprecise: false,
    latitude: 34.98944,
    longitude: -81.82523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29324',
  },
  {
    city: 'Clinton',
    county_fips: 45059,
    county_fips_all: '45059',
    county: 'Laurens',
    county_names_all: 'Laurens',
    county_weights: '{"45059": 100}',
    density: 35.3,
    imprecise: false,
    latitude: 34.47682,
    longitude: -81.83973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29325',
  },
  {
    city: 'Converse',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 437.9,
    imprecise: false,
    latitude: 34.99262,
    longitude: -81.83682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29329',
  },
  {
    city: 'Cowpens',
    county_fips: 45021,
    county_fips_all: '45021|45083',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Spartanburg',
    county_weights: '{"45021": 52.45, "45083": 47.55}',
    density: 92.4,
    imprecise: false,
    latitude: 35.05362,
    longitude: -81.80463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29330',
  },
  {
    city: 'Cross Anchor',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 52.1,
    imprecise: false,
    latitude: 34.64351,
    longitude: -81.85836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 98,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29331',
  },
  {
    city: 'Cross Hill',
    county_fips: 45059,
    county_fips_all: '45059|45071',
    county: 'Laurens',
    county_names_all: 'Laurens|Newberry',
    county_weights: '{"45059": 96.7, "45071": 3.3}',
    density: 29.3,
    imprecise: false,
    latitude: 34.28329,
    longitude: -81.97292,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29332',
  },
  {
    city: 'Drayton',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 242.1,
    imprecise: false,
    latitude: 34.97092,
    longitude: -81.91069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29333',
  },
  {
    city: 'Duncan',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 312.2,
    imprecise: false,
    latitude: 34.90372,
    longitude: -82.12526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29334',
  },
  {
    city: 'Enoree',
    county_fips: 45083,
    county_fips_all: '45083|45059|45087',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg|Laurens|Union',
    county_weights: '{"45083": 66.79, "45059": 18.98, "45087": 14.23}',
    density: 22.1,
    imprecise: false,
    latitude: 34.65714,
    longitude: -81.90035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29335',
  },
  {
    city: 'Fingerville',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 126,
    imprecise: false,
    latitude: 35.13444,
    longitude: -82.00172,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29338',
  },
  {
    city: 'Gaffney',
    county_fips: 45021,
    county_fips_all: '45021',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"45021": 100}',
    density: 49.1,
    imprecise: false,
    latitude: 34.98225,
    longitude: -81.59427,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29340',
  },
  {
    city: 'Gaffney',
    county_fips: 45021,
    county_fips_all: '45021',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"45021": 100}',
    density: 85.6,
    imprecise: false,
    latitude: 35.1184,
    longitude: -81.71321,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29341',
  },
  {
    city: 'Glendale',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 403.2,
    imprecise: false,
    latitude: 34.94524,
    longitude: -81.83627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29346',
  },
  {
    city: 'Inman',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 196.2,
    imprecise: false,
    latitude: 35.07045,
    longitude: -82.0688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29349',
  },
  {
    city: 'Joanna',
    county_fips: 45059,
    county_fips_all: '45059',
    county: 'Laurens',
    county_names_all: 'Laurens',
    county_weights: '{"45059": 100}',
    density: 113.8,
    imprecise: false,
    latitude: 34.42177,
    longitude: -81.80967,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29351',
  },
  {
    city: 'Jonesville',
    county_fips: 45087,
    county_fips_all: '45087',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"45087": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 34.83064,
    longitude: -81.65636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29353',
  },
  {
    city: 'Kinards',
    county_fips: 45071,
    county_fips_all: '45071|45059',
    county: 'Newberry',
    county_names_all: 'Newberry|Laurens',
    county_weights: '{"45071": 73.11, "45059": 26.89}',
    density: 4,
    imprecise: false,
    latitude: 34.37012,
    longitude: -81.75894,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29355',
  },
  {
    city: 'Landrum',
    county_fips: 45045,
    county_fips_all: '45045|45083',
    county: 'Greenville',
    county_names_all: 'Greenville|Spartanburg',
    county_weights: '{"45045": 75.99, "45083": 24.01}',
    density: 42.1,
    imprecise: false,
    latitude: 35.14411,
    longitude: -82.26187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29356',
  },
  {
    city: 'Laurens',
    county_fips: 45059,
    county_fips_all: '45059',
    county: 'Laurens',
    county_names_all: 'Laurens',
    county_weights: '{"45059": 100}',
    density: 56.7,
    imprecise: false,
    latitude: 34.49361,
    longitude: -82.04884,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29360',
  },
  {
    city: 'Lockhart',
    county_fips: 45087,
    county_fips_all: '45087|45023',
    county: 'Union',
    county_names_all: 'Union|Chester',
    county_weights: '{"45087": 98.88, "45023": 1.12}',
    density: 274.1,
    imprecise: false,
    latitude: 34.78846,
    longitude: -81.46202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29364',
  },
  {
    city: 'Lyman',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 309.3,
    imprecise: false,
    latitude: 34.98079,
    longitude: -82.16869,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29365',
  },
  {
    city: 'Mayo',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 495.1,
    imprecise: false,
    latitude: 35.08262,
    longitude: -81.86281,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29368',
  },
  {
    city: 'Moore',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 226.8,
    imprecise: false,
    latitude: 34.86535,
    longitude: -82.02207,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29369',
  },
  {
    city: 'Mountville',
    county_fips: 45059,
    county_fips_all: '45059',
    county: 'Laurens',
    county_names_all: 'Laurens',
    county_weights: '{"45059": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 34.37315,
    longitude: -81.96816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29370',
  },
  {
    city: 'Pacolet',
    county_fips: 45021,
    county_fips_all: '45021|45083|45087',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Spartanburg|Union',
    county_weights: '{"45021": 42.36, "45083": 31.88, "45087": 25.76}',
    density: 32.2,
    imprecise: false,
    latitude: 34.9059,
    longitude: -81.70878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29372',
  },
  {
    city: 'Pacolet Mills',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 391,
    imprecise: false,
    latitude: 34.92442,
    longitude: -81.74276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29373',
  },
  {
    city: 'Pauline',
    county_fips: 45083,
    county_fips_all: '45083|45087',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg|Union',
    county_weights: '{"45083": 90.18, "45087": 9.82}',
    density: 24.4,
    imprecise: false,
    latitude: 34.7861,
    longitude: -81.84854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29374',
  },
  {
    city: 'Reidville',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 557.2,
    imprecise: false,
    latitude: 34.86049,
    longitude: -82.11386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29375',
  },
  {
    city: 'Roebuck',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 89.5,
    imprecise: false,
    latitude: 34.81564,
    longitude: -81.94921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29376',
  },
  {
    city: 'Startex',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 130.2,
    imprecise: false,
    latitude: 34.93036,
    longitude: -82.0971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29377',
  },
  {
    city: 'Una',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 965.1,
    imprecise: false,
    latitude: 34.96684,
    longitude: -81.96857,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29378',
  },
  {
    city: 'Union',
    county_fips: 45087,
    county_fips_all: '45087',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"45087": 100}',
    density: 28,
    imprecise: false,
    latitude: 34.68772,
    longitude: -81.60403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29379',
  },
  {
    city: 'Waterloo',
    county_fips: 45059,
    county_fips_all: '45059',
    county: 'Laurens',
    county_names_all: 'Laurens',
    county_weights: '{"45059": 100}',
    density: 31,
    imprecise: false,
    latitude: 34.33976,
    longitude: -82.0904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29384',
  },
  {
    city: 'Wellford',
    county_fips: 45083,
    county_fips_all: '45083',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg',
    county_weights: '{"45083": 100}',
    density: 168.6,
    imprecise: false,
    latitude: 34.97623,
    longitude: -82.1024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29385',
  },
  {
    city: 'Woodruff',
    county_fips: 45083,
    county_fips_all: '45083|45059',
    county: 'Spartanburg',
    county_names_all: 'Spartanburg|Laurens',
    county_weights: '{"45083": 94.23, "45059": 5.77}',
    density: 67,
    imprecise: false,
    latitude: 34.76292,
    longitude: -82.04299,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29388',
  },
  {
    city: 'Charleston',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 2350,
    imprecise: false,
    latitude: 32.77868,
    longitude: -79.9354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29401',
  },
  {
    city: 'Charleston',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 1611.7,
    imprecise: false,
    latitude: 32.80347,
    longitude: -79.94561,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29403',
  },
  {
    city: 'Charleston Afb',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 178.4,
    imprecise: false,
    latitude: 32.89783,
    longitude: -80.05246,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29404',
  },
  {
    city: 'North Charleston',
    county_fips: 45019,
    county_fips_all: '45019|45015',
    county: 'Charleston',
    county_names_all: 'Charleston|Berkeley',
    county_weights: '{"45019": 98.52, "45015": 1.48}',
    density: 690.5,
    imprecise: false,
    latitude: 32.85207,
    longitude: -79.97903,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29405',
  },
  {
    city: 'Charleston',
    county_fips: 45019,
    county_fips_all: '45019|45015',
    county: 'Charleston',
    county_names_all: 'Charleston|Berkeley',
    county_weights: '{"45019": 96.56, "45015": 3.44}',
    density: 805.7,
    imprecise: false,
    latitude: 32.93417,
    longitude: -80.03083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29406',
  },
  {
    city: 'Charleston',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 922.2,
    imprecise: false,
    latitude: 32.79912,
    longitude: -79.99872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29407',
  },
  {
    city: 'Hanahan',
    county_fips: 45015,
    county_fips_all: '45015|45019',
    county: 'Berkeley',
    county_names_all: 'Berkeley|Charleston',
    county_weights: '{"45015": 99.69, "45019": 0.31}',
    density: 787.4,
    imprecise: false,
    latitude: 32.93258,
    longitude: -80.0056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29410',
  },
  {
    city: 'Charleston',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 386.6,
    imprecise: false,
    latitude: 32.70979,
    longitude: -79.95115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29412',
  },
  {
    city: 'Charleston',
    county_fips: 45019,
    county_fips_all: '45019|45035',
    county: 'Charleston',
    county_names_all: 'Charleston|Dorchester',
    county_weights: '{"45019": 82.3, "45035": 17.7}',
    density: 352.5,
    imprecise: false,
    latitude: 32.84479,
    longitude: -80.10756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29414',
  },
  {
    city: 'North Charleston',
    county_fips: 45019,
    county_fips_all: '45019|45035',
    county: 'Charleston',
    county_names_all: 'Charleston|Dorchester',
    county_weights: '{"45019": 78.22, "45035": 21.78}',
    density: 760.4,
    imprecise: false,
    latitude: 32.88896,
    longitude: -80.0644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29418',
  },
  {
    city: 'North Charleston',
    county_fips: 45035,
    county_fips_all: '45035|45019',
    county: 'Dorchester',
    county_names_all: 'Dorchester|Charleston',
    county_weights: '{"45035": 59.8, "45019": 40.2}',
    density: 922.4,
    imprecise: false,
    latitude: 32.93202,
    longitude: -80.09938,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29420',
  },
  {
    city: 'Adams Run',
    county_fips: 45019,
    county_fips_all: '45019|45035|45029',
    county: 'Charleston',
    county_names_all: 'Charleston|Dorchester|Colleton',
    county_weights: '{"45019": 83.43, "45035": 16.43, "45029": 0.14}',
    density: 8.3,
    imprecise: false,
    latitude: 32.79275,
    longitude: -80.37023,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29426',
  },
  {
    city: 'Awendaw',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 32.98699,
    longitude: -79.68011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29429',
  },
  {
    city: 'Bonneau',
    county_fips: 45015,
    county_fips_all: '45015',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"45015": 100}',
    density: 34.5,
    imprecise: false,
    latitude: 33.27708,
    longitude: -79.87711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29431',
  },
  {
    city: 'Branchville',
    county_fips: 45075,
    county_fips_all: '45075|45009|45035',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg|Bamberg|Dorchester',
    county_weights: '{"45075": 60.49, "45009": 32.53, "45035": 6.98}',
    density: 7.8,
    imprecise: false,
    latitude: 33.2294,
    longitude: -80.81428,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29432',
  },
  {
    city: 'Cordesville',
    county_fips: 45015,
    county_fips_all: '45015',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"45015": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 33.14027,
    longitude: -79.8453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29434',
  },
  {
    city: 'Cottageville',
    county_fips: 45029,
    county_fips_all: '45029',
    county: 'Colleton',
    county_names_all: 'Colleton',
    county_weights: '{"45029": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 32.9526,
    longitude: -80.4672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29435',
  },
  {
    city: 'Cross',
    county_fips: 45015,
    county_fips_all: '45015|45075',
    county: 'Berkeley',
    county_names_all: 'Berkeley|Orangeburg',
    county_weights: '{"45015": 95.36, "45075": 4.64}',
    density: 18,
    imprecise: false,
    latitude: 33.31658,
    longitude: -80.18457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29436',
  },
  {
    city: 'Dorchester',
    county_fips: 45035,
    county_fips_all: '45035',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"45035": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 33.13673,
    longitude: -80.42319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29437',
  },
  {
    city: 'Edisto Island',
    county_fips: 45019,
    county_fips_all: '45019|45029',
    county: 'Charleston',
    county_names_all: 'Charleston|Colleton',
    county_weights: '{"45019": 92.08, "45029": 7.92}',
    density: 14.5,
    imprecise: false,
    latitude: 32.5722,
    longitude: -80.31893,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29438',
  },
  {
    city: 'Folly Beach',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 149.4,
    imprecise: false,
    latitude: 32.66636,
    longitude: -79.92902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29439',
  },
  {
    city: 'Georgetown',
    county_fips: 45043,
    county_fips_all: '45043|45089',
    county: 'Georgetown',
    county_names_all: 'Georgetown|Williamsburg',
    county_weights: '{"45043": 99.47, "45089": 0.53}',
    density: 20.2,
    imprecise: false,
    latitude: 33.38229,
    longitude: -79.32908,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29440',
  },
  {
    city: 'Goose Creek',
    county_fips: 45015,
    county_fips_all: '45015',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"45015": 100}',
    density: 398.4,
    imprecise: false,
    latitude: 32.9976,
    longitude: -79.98757,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29445',
  },
  {
    city: 'Green Pond',
    county_fips: 45029,
    county_fips_all: '45029|45019',
    county: 'Colleton',
    county_names_all: 'Colleton|Charleston',
    county_weights: '{"45029": 99.76, "45019": 0.24}',
    density: 2.6,
    imprecise: false,
    latitude: 32.6281,
    longitude: -80.54028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29446',
  },
  {
    city: 'Harleyville',
    county_fips: 45035,
    county_fips_all: '45035',
    county: 'Dorchester',
    county_names_all: 'Dorchester',
    county_weights: '{"45035": 100}',
    density: 13,
    imprecise: false,
    latitude: 33.24062,
    longitude: -80.44639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29448',
  },
  {
    city: 'Hollywood',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 41.1,
    imprecise: false,
    latitude: 32.70183,
    longitude: -80.28038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29449',
  },
  {
    city: 'Huger',
    county_fips: 45015,
    county_fips_all: '45015|45019',
    county: 'Berkeley',
    county_names_all: 'Berkeley|Charleston',
    county_weights: '{"45015": 94.51, "45019": 5.49}',
    density: 7.8,
    imprecise: false,
    latitude: 33.08731,
    longitude: -79.77164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29450',
  },
  {
    city: 'Isle Of Palms',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 184.7,
    imprecise: false,
    latitude: 32.81633,
    longitude: -79.75266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29451',
  },
  {
    city: 'Jacksonboro',
    county_fips: 45029,
    county_fips_all: '45029|45019',
    county: 'Colleton',
    county_names_all: 'Colleton|Charleston',
    county_weights: '{"45029": 99.76, "45019": 0.24}',
    density: 2.2,
    imprecise: false,
    latitude: 32.6997,
    longitude: -80.46998,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29452',
  },
  {
    city: 'Jamestown',
    county_fips: 45015,
    county_fips_all: '45015|45019',
    county: 'Berkeley',
    county_names_all: 'Berkeley|Charleston',
    county_weights: '{"45015": 99.86, "45019": 0.14}',
    density: 4.9,
    imprecise: false,
    latitude: 33.21984,
    longitude: -79.61269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29453',
  },
  {
    city: 'Johns Island',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 106.2,
    imprecise: false,
    latitude: 32.68581,
    longitude: -80.08604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29455',
  },
  {
    city: 'Ladson',
    county_fips: 45019,
    county_fips_all: '45019|45015|45035',
    county: 'Charleston',
    county_names_all: 'Charleston|Berkeley|Dorchester',
    county_weights: '{"45019": 46.42, "45015": 28.85, "45035": 24.74}',
    density: 880.9,
    imprecise: false,
    latitude: 32.98433,
    longitude: -80.11206,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29456',
  },
  {
    city: 'McClellanville',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 33.11922,
    longitude: -79.4872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29458',
  },
  {
    city: 'Moncks Corner',
    county_fips: 45015,
    county_fips_all: '45015',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"45015": 100}',
    density: 103,
    imprecise: false,
    latitude: 33.17009,
    longitude: -80.00773,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29461',
  },
  {
    city: 'Mount Pleasant',
    county_fips: 45019,
    county_fips_all: '45019|45015',
    county: 'Charleston',
    county_names_all: 'Charleston|Berkeley',
    county_weights: '{"45019": 98.78, "45015": 1.22}',
    density: 679.5,
    imprecise: false,
    latitude: 32.82082,
    longitude: -79.85583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29464',
  },
  {
    city: 'Mount Pleasant',
    county_fips: 45019,
    county_fips_all: '45019|45015',
    county: 'Charleston',
    county_names_all: 'Charleston|Berkeley',
    county_weights: '{"45019": 99.82, "45015": 0.18}',
    density: 594.7,
    imprecise: false,
    latitude: 32.87486,
    longitude: -79.78785,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29466',
  },
  {
    city: 'Pineville',
    county_fips: 45015,
    county_fips_all: '45015',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"45015": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 33.42624,
    longitude: -80.06856,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29468',
  },
  {
    city: 'Pinopolis',
    county_fips: 45015,
    county_fips_all: '45015',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"45015": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 33.24366,
    longitude: -80.13106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29469',
  },
  {
    city: 'Ravenel',
    county_fips: 45019,
    county_fips_all: '45019|45035',
    county: 'Charleston',
    county_names_all: 'Charleston|Dorchester',
    county_weights: '{"45019": 66.26, "45035": 33.74}',
    density: 30,
    imprecise: false,
    latitude: 32.81904,
    longitude: -80.23855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29470',
  },
  {
    city: 'Reevesville',
    county_fips: 45035,
    county_fips_all: '45035|45075',
    county: 'Dorchester',
    county_names_all: 'Dorchester|Orangeburg',
    county_weights: '{"45035": 97.15, "45075": 2.85}',
    density: 10.2,
    imprecise: false,
    latitude: 33.18714,
    longitude: -80.66955,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29471',
  },
  {
    city: 'Ridgeville',
    county_fips: 45035,
    county_fips_all: '45035|45015|45029',
    county: 'Dorchester',
    county_names_all: 'Dorchester|Berkeley|Colleton',
    county_weights: '{"45035": 59.63, "45015": 32.32, "45029": 8.05}',
    density: 25.9,
    imprecise: false,
    latitude: 33.05379,
    longitude: -80.31928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29472',
  },
  {
    city: 'Round O',
    county_fips: 45029,
    county_fips_all: '45029',
    county: 'Colleton',
    county_names_all: 'Colleton',
    county_weights: '{"45029": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 32.90833,
    longitude: -80.52448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29474',
  },
  {
    city: 'Ruffin',
    county_fips: 45029,
    county_fips_all: '45029',
    county: 'Colleton',
    county_names_all: 'Colleton',
    county_weights: '{"45029": 100}',
    density: 9,
    imprecise: false,
    latitude: 32.96687,
    longitude: -80.8189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29475',
  },
  {
    city: 'Saint George',
    county_fips: 45035,
    county_fips_all: '45035|45075',
    county: 'Dorchester',
    county_names_all: 'Dorchester|Orangeburg',
    county_weights: '{"45035": 99.13, "45075": 0.87}',
    density: 25.1,
    imprecise: false,
    latitude: 33.16626,
    longitude: -80.57176,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29477',
  },
  {
    city: 'Saint Stephen',
    county_fips: 45015,
    county_fips_all: '45015',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"45015": 100}',
    density: 25.6,
    imprecise: false,
    latitude: 33.3808,
    longitude: -79.89499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29479',
  },
  {
    city: 'Smoaks',
    county_fips: 45029,
    county_fips_all: '45029|45009',
    county: 'Colleton',
    county_names_all: 'Colleton|Bamberg',
    county_weights: '{"45029": 84.61, "45009": 15.39}',
    density: 7.7,
    imprecise: false,
    latitude: 33.11382,
    longitude: -80.80301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29481',
  },
  {
    city: 'Sullivans Island',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 322.6,
    imprecise: false,
    latitude: 32.76845,
    longitude: -79.83556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29482',
  },
  {
    city: 'Summerville',
    county_fips: 45035,
    county_fips_all: '45035|45015|45019',
    county: 'Dorchester',
    county_names_all: 'Dorchester|Berkeley|Charleston',
    county_weights: '{"45035": 83.41, "45015": 16.28, "45019": 0.31}',
    density: 428.4,
    imprecise: false,
    latitude: 33.03126,
    longitude: -80.23205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29483',
  },
  {
    city: 'Summerville',
    county_fips: 45035,
    county_fips_all: '45035|45019',
    county: 'Dorchester',
    county_names_all: 'Dorchester|Charleston',
    county_weights: '{"45035": 93.58, "45019": 6.42}',
    density: 465.1,
    imprecise: false,
    latitude: 32.94398,
    longitude: -80.19362,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29485',
  },
  {
    city: 'Summerville',
    county_fips: 45015,
    county_fips_all: '45015',
    county: 'Berkeley',
    county_names_all: 'Berkeley',
    county_weights: '{"45015": 100}',
    density: 334.5,
    imprecise: false,
    latitude: 33.10744,
    longitude: -80.1458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29486',
  },
  {
    city: 'Wadmalaw Island',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 32.65691,
    longitude: -80.18476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29487',
  },
  {
    city: 'Walterboro',
    county_fips: 45029,
    county_fips_all: '45029',
    county: 'Colleton',
    county_names_all: 'Colleton',
    county_weights: '{"45029": 100}',
    density: 36.6,
    imprecise: false,
    latitude: 32.90664,
    longitude: -80.67458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29488',
  },
  {
    city: 'Charleston',
    county_fips: 45015,
    county_fips_all: '45015|45019',
    county: 'Berkeley',
    county_names_all: 'Berkeley|Charleston',
    county_weights: '{"45015": 99.76, "45019": 0.24}',
    density: 149.5,
    imprecise: false,
    latitude: 32.91657,
    longitude: -79.87818,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29492',
  },
  {
    city: 'Williams',
    county_fips: 45029,
    county_fips_all: '45029',
    county: 'Colleton',
    county_names_all: 'Colleton',
    county_weights: '{"45029": 100}',
    density: 24.5,
    imprecise: false,
    latitude: 33.04536,
    longitude: -80.84276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29493',
  },
  {
    city: 'Florence',
    county_fips: 45041,
    county_fips_all: '45041|45031',
    county: 'Florence',
    county_names_all: 'Florence|Darlington',
    county_weights: '{"45041": 85.45, "45031": 14.55}',
    density: 358.7,
    imprecise: false,
    latitude: 34.20414,
    longitude: -79.82654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29501',
  },
  {
    city: 'Florence',
    county_fips: 45041,
    county_fips_all: '45041',
    county: 'Florence',
    county_names_all: 'Florence',
    county_weights: '{"45041": 100}',
    density: 181.4,
    imprecise: false,
    latitude: 34.12348,
    longitude: -79.68974,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29505',
  },
  {
    city: 'Florence',
    county_fips: 45041,
    county_fips_all: '45041|45031',
    county: 'Florence',
    county_names_all: 'Florence|Darlington',
    county_weights: '{"45041": 97.95, "45031": 2.05}',
    density: 66.4,
    imprecise: false,
    latitude: 34.2103,
    longitude: -79.64432,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29506',
  },
  {
    city: 'Andrews',
    county_fips: 45089,
    county_fips_all: '45089|45043',
    county: 'Williamsburg',
    county_names_all: 'Williamsburg|Georgetown',
    county_weights: '{"45089": 65.09, "45043": 34.91}',
    density: 13,
    imprecise: false,
    latitude: 33.45326,
    longitude: -79.61068,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29510',
  },
  {
    city: 'Aynor',
    county_fips: 45051,
    county_fips_all: '45051',
    county: 'Horry',
    county_names_all: 'Horry',
    county_weights: '{"45051": 100}',
    density: 46.5,
    imprecise: false,
    latitude: 33.97519,
    longitude: -79.11043,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29511',
  },
  {
    city: 'Bennettsville',
    county_fips: 45069,
    county_fips_all: '45069',
    county: 'Marlboro',
    county_names_all: 'Marlboro',
    county_weights: '{"45069": 100}',
    density: 30.6,
    imprecise: false,
    latitude: 34.62733,
    longitude: -79.71091,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29512',
  },
  {
    city: 'Blenheim',
    county_fips: 45069,
    county_fips_all: '45069',
    county: 'Marlboro',
    county_names_all: 'Marlboro',
    county_weights: '{"45069": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 34.44323,
    longitude: -79.62414,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29516',
  },
  {
    city: 'Cades',
    county_fips: 45089,
    county_fips_all: '45089|45027',
    county: 'Williamsburg',
    county_names_all: 'Williamsburg|Clarendon',
    county_weights: '{"45089": 99.51, "45027": 0.49}',
    density: 9.2,
    imprecise: false,
    latitude: 33.7892,
    longitude: -79.84851,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29518',
  },
  {
    city: 'Centenary',
    county_fips: 45067,
    county_fips_all: '45067',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"45067": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 34.01622,
    longitude: -79.36048,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29519',
  },
  {
    city: 'Cheraw',
    county_fips: 45025,
    county_fips_all: '45025|45069',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield|Marlboro',
    county_weights: '{"45025": 99.82, "45069": 0.18}',
    density: 38.6,
    imprecise: false,
    latitude: 34.68083,
    longitude: -79.92601,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29520',
  },
  {
    city: 'Clio',
    county_fips: 45069,
    county_fips_all: '45069|45033',
    county: 'Marlboro',
    county_names_all: 'Marlboro|Dillon',
    county_weights: '{"45069": 94.56, "45033": 5.44}',
    density: 14.9,
    imprecise: false,
    latitude: 34.5722,
    longitude: -79.53327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29525',
  },
  {
    city: 'Conway',
    county_fips: 45051,
    county_fips_all: '45051',
    county: 'Horry',
    county_names_all: 'Horry',
    county_weights: '{"45051": 100}',
    density: 119.4,
    imprecise: false,
    latitude: 33.86696,
    longitude: -78.9718,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29526',
  },
  {
    city: 'Conway',
    county_fips: 45051,
    county_fips_all: '45051',
    county: 'Horry',
    county_names_all: 'Horry',
    county_weights: '{"45051": 100}',
    density: 70.8,
    imprecise: false,
    latitude: 33.78271,
    longitude: -79.14715,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29527',
  },
  {
    city: 'Coward',
    county_fips: 45041,
    county_fips_all: '45041',
    county: 'Florence',
    county_names_all: 'Florence',
    county_weights: '{"45041": 100}',
    density: 25.2,
    imprecise: false,
    latitude: 33.98984,
    longitude: -79.74222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29530',
  },
  {
    city: 'Darlington',
    county_fips: 45031,
    county_fips_all: '45031',
    county: 'Darlington',
    county_names_all: 'Darlington',
    county_weights: '{"45031": 100}',
    density: 66.8,
    imprecise: false,
    latitude: 34.28421,
    longitude: -79.85119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29532',
  },
  {
    city: 'Dillon',
    county_fips: 45033,
    county_fips_all: '45033',
    county: 'Dillon',
    county_names_all: 'Dillon',
    county_weights: '{"45033": 100}',
    density: 44.8,
    imprecise: false,
    latitude: 34.41911,
    longitude: -79.37241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29536',
  },
  {
    city: 'Darlington',
    county_fips: 45031,
    county_fips_all: '45031',
    county: 'Darlington',
    county_names_all: 'Darlington',
    county_weights: '{"45031": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 34.38903,
    longitude: -79.85028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29540',
  },
  {
    city: 'Effingham',
    county_fips: 45041,
    county_fips_all: '45041',
    county: 'Florence',
    county_names_all: 'Florence',
    county_weights: '{"45041": 100}',
    density: 45.1,
    imprecise: false,
    latitude: 34.0653,
    longitude: -79.74087,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29541',
  },
  {
    city: 'Fork',
    county_fips: 45033,
    county_fips_all: '45033',
    county: 'Dillon',
    county_names_all: 'Dillon',
    county_weights: '{"45033": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 34.28759,
    longitude: -79.26591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29543',
  },
  {
    city: 'Galivants Ferry',
    county_fips: 45051,
    county_fips_all: '45051',
    county: 'Horry',
    county_names_all: 'Horry',
    county_weights: '{"45051": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 34.00067,
    longitude: -79.21083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29544',
  },
  {
    city: 'Green Sea',
    county_fips: 45051,
    county_fips_all: '45051',
    county: 'Horry',
    county_names_all: 'Horry',
    county_weights: '{"45051": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 34.16175,
    longitude: -78.96635,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29545',
  },
  {
    city: 'Gresham',
    county_fips: 45067,
    county_fips_all: '45067',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"45067": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 33.89001,
    longitude: -79.35151,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29546',
  },
  {
    city: 'Hamer',
    county_fips: 45033,
    county_fips_all: '45033',
    county: 'Dillon',
    county_names_all: 'Dillon',
    county_weights: '{"45033": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 34.48684,
    longitude: -79.33243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29547',
  },
  {
    city: 'Hartsville',
    county_fips: 45031,
    county_fips_all: '45031|45025|45061',
    county: 'Darlington',
    county_names_all: 'Darlington|Chesterfield|Lee',
    county_weights: '{"45031": 80.94, "45025": 16.83, "45061": 2.23}',
    density: 55.5,
    imprecise: false,
    latitude: 34.39309,
    longitude: -80.07595,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29550',
  },
  {
    city: 'Hemingway',
    county_fips: 45043,
    county_fips_all: '45043|45089|45041',
    county: 'Georgetown',
    county_names_all: 'Georgetown|Williamsburg|Florence',
    county_weights: '{"45043": 51.81, "45089": 47.38, "45041": 0.81}',
    density: 15.9,
    imprecise: false,
    latitude: 33.69879,
    longitude: -79.38816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29554',
  },
  {
    city: 'Johnsonville',
    county_fips: 45041,
    county_fips_all: '45041|45089',
    county: 'Florence',
    county_names_all: 'Florence|Williamsburg',
    county_weights: '{"45041": 92.46, "45089": 7.54}',
    density: 24.3,
    imprecise: false,
    latitude: 33.83864,
    longitude: -79.46191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29555',
  },
  {
    city: 'Kingstree',
    county_fips: 45089,
    county_fips_all: '45089',
    county: 'Williamsburg',
    county_names_all: 'Williamsburg',
    county_weights: '{"45089": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 33.66849,
    longitude: -79.76403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29556',
  },
  {
    city: 'Lake City',
    county_fips: 45041,
    county_fips_all: '45041|45089|45027',
    county: 'Florence',
    county_names_all: 'Florence|Williamsburg|Clarendon',
    county_weights: '{"45041": 48.1, "45089": 42.0, "45027": 9.89}',
    density: 28.7,
    imprecise: false,
    latitude: 33.83535,
    longitude: -79.74747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29560',
  },
  {
    city: 'Lake View',
    county_fips: 45033,
    county_fips_all: '45033',
    county: 'Dillon',
    county_names_all: 'Dillon',
    county_weights: '{"45033": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 34.35301,
    longitude: -79.2044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29563',
  },
  {
    city: 'Lane',
    county_fips: 45089,
    county_fips_all: '45089',
    county: 'Williamsburg',
    county_names_all: 'Williamsburg',
    county_weights: '{"45089": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 33.47686,
    longitude: -79.85522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29564',
  },
  {
    city: 'Latta',
    county_fips: 45033,
    county_fips_all: '45033|45067|45069',
    county: 'Dillon',
    county_names_all: 'Dillon|Marion|Marlboro',
    county_weights: '{"45033": 92.43, "45067": 4.43, "45069": 3.14}',
    density: 21.7,
    imprecise: false,
    latitude: 34.35841,
    longitude: -79.50457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29565',
  },
  {
    city: 'Little River',
    county_fips: 45051,
    county_fips_all: '45051',
    county: 'Horry',
    county_names_all: 'Horry',
    county_weights: '{"45051": 100}',
    density: 283.7,
    imprecise: false,
    latitude: 33.8821,
    longitude: -78.65906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29566',
  },
  {
    city: 'Little Rock',
    county_fips: 45033,
    county_fips_all: '45033',
    county: 'Dillon',
    county_names_all: 'Dillon',
    county_weights: '{"45033": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 34.55325,
    longitude: -79.42649,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29567',
  },
  {
    city: 'Longs',
    county_fips: 45051,
    county_fips_all: '45051',
    county: 'Horry',
    county_names_all: 'Horry',
    county_weights: '{"45051": 100}',
    density: 73.7,
    imprecise: false,
    latitude: 33.90815,
    longitude: -78.75455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29568',
  },
  {
    city: 'Loris',
    county_fips: 45051,
    county_fips_all: '45051',
    county: 'Horry',
    county_names_all: 'Horry',
    county_weights: '{"45051": 100}',
    density: 40.3,
    imprecise: false,
    latitude: 34.0326,
    longitude: -78.90359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29569',
  },
  {
    city: 'McColl',
    county_fips: 45069,
    county_fips_all: '45069',
    county: 'Marlboro',
    county_names_all: 'Marlboro',
    county_weights: '{"45069": 100}',
    density: 33.1,
    imprecise: false,
    latitude: 34.67495,
    longitude: -79.5624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29570',
  },
  {
    city: 'Marion',
    county_fips: 45067,
    county_fips_all: '45067|45033',
    county: 'Marion',
    county_names_all: 'Marion|Dillon',
    county_weights: '{"45067": 99.56, "45033": 0.44}',
    density: 25.8,
    imprecise: false,
    latitude: 34.138,
    longitude: -79.42205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29571',
  },
  {
    city: 'Myrtle Beach',
    county_fips: 45051,
    county_fips_all: '45051',
    county: 'Horry',
    county_names_all: 'Horry',
    county_weights: '{"45051": 100}',
    density: 526.4,
    imprecise: false,
    latitude: 33.76798,
    longitude: -78.79279,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29572',
  },
  {
    city: 'Mullins',
    county_fips: 45067,
    county_fips_all: '45067|45033',
    county: 'Marion',
    county_names_all: 'Marion|Dillon',
    county_weights: '{"45067": 99.55, "45033": 0.45}',
    density: 36.9,
    imprecise: false,
    latitude: 34.17134,
    longitude: -79.26695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29574',
  },
  {
    city: 'Myrtle Beach',
    county_fips: 45051,
    county_fips_all: '45051',
    county: 'Horry',
    county_names_all: 'Horry',
    county_weights: '{"45051": 100}',
    density: 783.4,
    imprecise: false,
    latitude: 33.628,
    longitude: -78.97369,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29575',
  },
  {
    city: 'Murrells Inlet',
    county_fips: 45051,
    county_fips_all: '45051|45043',
    county: 'Horry',
    county_names_all: 'Horry|Georgetown',
    county_weights: '{"45051": 53.47, "45043": 46.53}',
    density: 439.6,
    imprecise: false,
    latitude: 33.56952,
    longitude: -79.05076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29576',
  },
  {
    city: 'Myrtle Beach',
    county_fips: 45051,
    county_fips_all: '45051',
    county: 'Horry',
    county_names_all: 'Horry',
    county_weights: '{"45051": 100}',
    density: 599.2,
    imprecise: false,
    latitude: 33.69711,
    longitude: -78.90495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29577',
  },
  {
    city: 'Myrtle Beach',
    county_fips: 45051,
    county_fips_all: '45051',
    county: 'Horry',
    county_names_all: 'Horry',
    county_weights: '{"45051": 100}',
    density: 414.8,
    imprecise: false,
    latitude: 33.76052,
    longitude: -78.91463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29579',
  },
  {
    city: 'Nesmith',
    county_fips: 45089,
    county_fips_all: '45089',
    county: 'Williamsburg',
    county_names_all: 'Williamsburg',
    county_weights: '{"45089": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 33.65827,
    longitude: -79.56164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29580',
  },
  {
    city: 'Nichols',
    county_fips: 45051,
    county_fips_all: '45051|45033|45067',
    county: 'Horry',
    county_names_all: 'Horry|Dillon|Marion',
    county_weights: '{"45051": 73.29, "45033": 15.84, "45067": 10.87}',
    density: 11.4,
    imprecise: false,
    latitude: 34.19864,
    longitude: -79.11295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29581',
  },
  {
    city: 'North Myrtle Beach',
    county_fips: 45051,
    county_fips_all: '45051',
    county: 'Horry',
    county_names_all: 'Horry',
    county_weights: '{"45051": 100}',
    density: 355.2,
    imprecise: false,
    latitude: 33.83423,
    longitude: -78.66049,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29582',
  },
  {
    city: 'Pamplico',
    county_fips: 45041,
    county_fips_all: '45041',
    county: 'Florence',
    county_names_all: 'Florence',
    county_weights: '{"45041": 100}',
    density: 18.5,
    imprecise: false,
    latitude: 33.9724,
    longitude: -79.57045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29583',
  },
  {
    city: 'Patrick',
    county_fips: 45025,
    county_fips_all: '45025',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield',
    county_weights: '{"45025": 100}',
    density: 10,
    imprecise: false,
    latitude: 34.5764,
    longitude: -80.05419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29584',
  },
  {
    city: 'Pawleys Island',
    county_fips: 45043,
    county_fips_all: '45043',
    county: 'Georgetown',
    county_names_all: 'Georgetown',
    county_weights: '{"45043": 100}',
    density: 106,
    imprecise: false,
    latitude: 33.50537,
    longitude: -79.13557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29585',
  },
  {
    city: 'Myrtle Beach',
    county_fips: 45051,
    county_fips_all: '45051',
    county: 'Horry',
    county_names_all: 'Horry',
    county_weights: '{"45051": 100}',
    density: 484,
    imprecise: false,
    latitude: 33.67112,
    longitude: -79.02574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29588',
  },
  {
    city: 'Rains',
    county_fips: 45067,
    county_fips_all: '45067',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"45067": 100}',
    density: 89.6,
    imprecise: false,
    latitude: 34.10037,
    longitude: -79.32015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29589',
  },
  {
    city: 'Salters',
    county_fips: 45089,
    county_fips_all: '45089',
    county: 'Williamsburg',
    county_names_all: 'Williamsburg',
    county_weights: '{"45089": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 33.55892,
    longitude: -79.84784,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29590',
  },
  {
    city: 'Scranton',
    county_fips: 45041,
    county_fips_all: '45041',
    county: 'Florence',
    county_names_all: 'Florence',
    county_weights: '{"45041": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 33.93894,
    longitude: -79.759,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29591',
  },
  {
    city: 'Sellers',
    county_fips: 45067,
    county_fips_all: '45067|45033',
    county: 'Marion',
    county_names_all: 'Marion|Dillon',
    county_weights: '{"45067": 57.24, "45033": 42.76}',
    density: 10.9,
    imprecise: false,
    latitude: 34.26941,
    longitude: -79.47704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29592',
  },
  {
    city: 'Society Hill',
    county_fips: 45031,
    county_fips_all: '45031|45025',
    county: 'Darlington',
    county_names_all: 'Darlington|Chesterfield',
    county_weights: '{"45031": 64.34, "45025": 35.66}',
    density: 8.6,
    imprecise: false,
    latitude: 34.49462,
    longitude: -79.85429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29593',
  },
  {
    city: 'Tatum',
    county_fips: 45069,
    county_fips_all: '45069',
    county: 'Marlboro',
    county_names_all: 'Marlboro',
    county_weights: '{"45069": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 34.64017,
    longitude: -79.57728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29594',
  },
  {
    city: 'Wallace',
    county_fips: 45069,
    county_fips_all: '45069',
    county: 'Marlboro',
    county_names_all: 'Marlboro',
    county_weights: '{"45069": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 34.74456,
    longitude: -79.83978,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29596',
  },
  {
    city: 'Greenville',
    county_fips: 45045,
    county_fips_all: '45045',
    county: 'Greenville',
    county_names_all: 'Greenville',
    county_weights: '{"45045": 100}',
    density: 1253.2,
    imprecise: false,
    latitude: 34.84744,
    longitude: -82.40257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29601',
  },
  {
    city: 'Greenville',
    county_fips: 45045,
    county_fips_all: '45045',
    county: 'Greenville',
    county_names_all: 'Greenville',
    county_weights: '{"45045": 100}',
    density: 633.1,
    imprecise: false,
    latitude: 34.77693,
    longitude: -82.38064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29605',
  },
  {
    city: 'Greenville',
    county_fips: 45045,
    county_fips_all: '45045',
    county: 'Greenville',
    county_names_all: 'Greenville',
    county_weights: '{"45045": 100}',
    density: 615,
    imprecise: false,
    latitude: 34.80952,
    longitude: -82.33193,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29607',
  },
  {
    city: 'Greenville',
    county_fips: 45045,
    county_fips_all: '45045',
    county: 'Greenville',
    county_names_all: 'Greenville',
    county_weights: '{"45045": 100}',
    density: 513.1,
    imprecise: false,
    latitude: 34.91209,
    longitude: -82.38928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29609',
  },
  {
    city: 'Greenville',
    county_fips: 45045,
    county_fips_all: '45045|45007|45077',
    county: 'Greenville',
    county_names_all: 'Greenville|Anderson|Pickens',
    county_weights: '{"45045": 86.01, "45007": 11.65, "45077": 2.34}',
    density: 521.8,
    imprecise: false,
    latitude: 34.83137,
    longitude: -82.45965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29611',
  },
  {
    city: 'Greenville',
    county_fips: 45045,
    county_fips_all: '45045',
    county: 'Greenville',
    county_names_all: 'Greenville',
    county_weights: '{"45045": 100}',
    density: 779.4,
    imprecise: false,
    latitude: 34.85591,
    longitude: -82.29553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29615',
  },
  {
    city: 'Greenville',
    county_fips: 45045,
    county_fips_all: '45045',
    county: 'Greenville',
    county_names_all: 'Greenville',
    county_weights: '{"45045": 100}',
    density: 458.2,
    imprecise: false,
    latitude: 34.91262,
    longitude: -82.4666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29617',
  },
  {
    city: 'Abbeville',
    county_fips: 45001,
    county_fips_all: '45001|45065',
    county: 'Abbeville',
    county_names_all: 'Abbeville|McCormick',
    county_weights: '{"45001": 96.08, "45065": 3.92}',
    density: 18.1,
    imprecise: false,
    latitude: 34.1813,
    longitude: -82.42804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29620',
  },
  {
    city: 'Anderson',
    county_fips: 45007,
    county_fips_all: '45007',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"45007": 100}',
    density: 206,
    imprecise: false,
    latitude: 34.50598,
    longitude: -82.60328,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29621',
  },
  {
    city: 'Anderson',
    county_fips: 45007,
    county_fips_all: '45007',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"45007": 100}',
    density: 185,
    imprecise: false,
    latitude: 34.43778,
    longitude: -82.62553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29624',
  },
  {
    city: 'Anderson',
    county_fips: 45007,
    county_fips_all: '45007',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"45007": 100}',
    density: 230.4,
    imprecise: false,
    latitude: 34.55577,
    longitude: -82.76294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29625',
  },
  {
    city: 'Anderson',
    county_fips: 45007,
    county_fips_all: '45007',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"45007": 100}',
    density: 103.9,
    imprecise: false,
    latitude: 34.46004,
    longitude: -82.76057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29626',
  },
  {
    city: 'Belton',
    county_fips: 45007,
    county_fips_all: '45007|45045|45001',
    county: 'Anderson',
    county_names_all: 'Anderson|Greenville|Abbeville',
    county_weights: '{"45007": 82.88, "45045": 15.7, "45001": 1.42}',
    density: 59.4,
    imprecise: false,
    latitude: 34.51807,
    longitude: -82.47861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29627',
  },
  {
    city: 'Calhoun Falls',
    county_fips: 45001,
    county_fips_all: '45001|45065',
    county: 'Abbeville',
    county_names_all: 'Abbeville|McCormick',
    county_weights: '{"45001": 77.89, "45065": 22.11}',
    density: 13.7,
    imprecise: false,
    latitude: 34.09253,
    longitude: -82.55821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29628',
  },
  {
    city: 'Central',
    county_fips: 45077,
    county_fips_all: '45077|45007',
    county: 'Pickens',
    county_names_all: 'Pickens|Anderson',
    county_weights: '{"45077": 88.02, "45007": 11.98}',
    density: 100.3,
    imprecise: false,
    latitude: 34.73882,
    longitude: -82.79646,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29630',
  },
  {
    city: 'Clemson',
    county_fips: 45077,
    county_fips_all: '45077|45007',
    county: 'Pickens',
    county_names_all: 'Pickens|Anderson',
    county_weights: '{"45077": 99.51, "45007": 0.49}',
    density: 746.4,
    imprecise: false,
    latitude: 34.68133,
    longitude: -82.81716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29631',
  },
  {
    city: 'Cleveland',
    county_fips: 45045,
    county_fips_all: '45045|45077',
    county: 'Greenville',
    county_names_all: 'Greenville|Pickens',
    county_weights: '{"45045": 81.79, "45077": 18.21}',
    density: 9.9,
    imprecise: false,
    latitude: 35.07754,
    longitude: -82.63152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29635',
  },
  {
    city: 'Donalds',
    county_fips: 45001,
    county_fips_all: '45001|45047',
    county: 'Abbeville',
    county_names_all: 'Abbeville|Greenwood',
    county_weights: '{"45001": 83.92, "45047": 16.08}',
    density: 22.2,
    imprecise: false,
    latitude: 34.36087,
    longitude: -82.3346,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29638',
  },
  {
    city: 'Due West',
    county_fips: 45001,
    county_fips_all: '45001',
    county: 'Abbeville',
    county_names_all: 'Abbeville',
    county_weights: '{"45001": 100}',
    density: 42,
    imprecise: false,
    latitude: 34.31402,
    longitude: -82.4205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29639',
  },
  {
    city: 'Easley',
    county_fips: 45077,
    county_fips_all: '45077',
    county: 'Pickens',
    county_names_all: 'Pickens',
    county_weights: '{"45077": 100}',
    density: 149.4,
    imprecise: false,
    latitude: 34.88706,
    longitude: -82.57725,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29640',
  },
  {
    city: 'Easley',
    county_fips: 45007,
    county_fips_all: '45007|45077',
    county: 'Anderson',
    county_names_all: 'Anderson|Pickens',
    county_weights: '{"45007": 55.55, "45077": 44.45}',
    density: 280.3,
    imprecise: false,
    latitude: 34.77487,
    longitude: -82.56538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29642',
  },
  {
    city: 'Fair Play',
    county_fips: 45073,
    county_fips_all: '45073|45007',
    county: 'Oconee',
    county_names_all: 'Oconee|Anderson',
    county_weights: '{"45073": 65.16, "45007": 34.84}',
    density: 38,
    imprecise: false,
    latitude: 34.50506,
    longitude: -82.97441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29643',
  },
  {
    city: 'Fountain Inn',
    county_fips: 45045,
    county_fips_all: '45045|45059',
    county: 'Greenville',
    county_names_all: 'Greenville|Laurens',
    county_weights: '{"45045": 50.14, "45059": 49.86}',
    density: 107.9,
    imprecise: false,
    latitude: 34.66864,
    longitude: -82.19714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29644',
  },
  {
    city: 'Gray Court',
    county_fips: 45059,
    county_fips_all: '45059|45045',
    county: 'Laurens',
    county_names_all: 'Laurens|Greenville',
    county_weights: '{"45059": 99.88, "45045": 0.12}',
    density: 40.1,
    imprecise: false,
    latitude: 34.59453,
    longitude: -82.12375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29645',
  },
  {
    city: 'Greenwood',
    county_fips: 45047,
    county_fips_all: '45047|45001',
    county: 'Greenwood',
    county_names_all: 'Greenwood|Abbeville',
    county_weights: '{"45047": 96.05, "45001": 3.95}',
    density: 106.2,
    imprecise: false,
    latitude: 34.13995,
    longitude: -82.15032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29646',
  },
  {
    city: 'Greenwood',
    county_fips: 45047,
    county_fips_all: '45047|45001',
    county: 'Greenwood',
    county_names_all: 'Greenwood|Abbeville',
    county_weights: '{"45047": 97.44, "45001": 2.56}',
    density: 189.2,
    imprecise: false,
    latitude: 34.24354,
    longitude: -82.13825,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29649',
  },
  {
    city: 'Greer',
    county_fips: 45045,
    county_fips_all: '45045|45083',
    county: 'Greenville',
    county_names_all: 'Greenville|Spartanburg',
    county_weights: '{"45045": 98.74, "45083": 1.26}',
    density: 912.9,
    imprecise: false,
    latitude: 34.89805,
    longitude: -82.25826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29650',
  },
  {
    city: 'Greer',
    county_fips: 45045,
    county_fips_all: '45045|45083',
    county: 'Greenville',
    county_names_all: 'Greenville|Spartanburg',
    county_weights: '{"45045": 56.27, "45083": 43.73}',
    density: 243.9,
    imprecise: false,
    latitude: 34.94653,
    longitude: -82.22649,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29651',
  },
  {
    city: 'Hodges',
    county_fips: 45047,
    county_fips_all: '45047|45001',
    county: 'Greenwood',
    county_names_all: 'Greenwood|Abbeville',
    county_weights: '{"45047": 92.73, "45001": 7.27}',
    density: 23.4,
    imprecise: false,
    latitude: 34.30028,
    longitude: -82.23173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29653',
  },
  {
    city: 'Honea Path',
    county_fips: 45007,
    county_fips_all: '45007|45001|45045|45059',
    county: 'Anderson',
    county_names_all: 'Anderson|Abbeville|Greenville|Laurens',
    county_weights:
      '{"45007": 36.74, "45001": 29.52, "45045": 23.41, "45059": 10.33}',
    density: 36,
    imprecise: false,
    latitude: 34.46621,
    longitude: -82.36354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29654',
  },
  {
    city: 'Iva',
    county_fips: 45001,
    county_fips_all: '45001|45007',
    county: 'Abbeville',
    county_names_all: 'Abbeville|Anderson',
    county_weights: '{"45001": 54.97, "45007": 45.03}',
    density: 20.8,
    imprecise: false,
    latitude: 34.267,
    longitude: -82.64032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29655',
  },
  {
    city: 'Liberty',
    county_fips: 45077,
    county_fips_all: '45077|45007',
    county: 'Pickens',
    county_names_all: 'Pickens|Anderson',
    county_weights: '{"45077": 76.18, "45007": 23.82}',
    density: 99.9,
    imprecise: false,
    latitude: 34.76713,
    longitude: -82.68941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29657',
  },
  {
    city: 'Long Creek',
    county_fips: 45073,
    county_fips_all: '45073',
    county: 'Oconee',
    county_names_all: 'Oconee',
    county_weights: '{"45073": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 34.76191,
    longitude: -83.29858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29658',
  },
  {
    city: 'Lowndesville',
    county_fips: 45001,
    county_fips_all: '45001',
    county: 'Abbeville',
    county_names_all: 'Abbeville',
    county_weights: '{"45001": 100}',
    density: 145.5,
    imprecise: false,
    latitude: 34.21167,
    longitude: -82.64535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29659',
  },
  {
    city: 'Marietta',
    county_fips: 45045,
    county_fips_all: '45045|45077',
    county: 'Greenville',
    county_names_all: 'Greenville|Pickens',
    county_weights: '{"45045": 80.17, "45077": 19.83}',
    density: 31.7,
    imprecise: false,
    latitude: 35.06706,
    longitude: -82.53852,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29661',
  },
  {
    city: 'Mauldin',
    county_fips: 45045,
    county_fips_all: '45045',
    county: 'Greenville',
    county_names_all: 'Greenville',
    county_weights: '{"45045": 100}',
    density: 1047.5,
    imprecise: false,
    latitude: 34.77837,
    longitude: -82.30557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29662',
  },
  {
    city: 'Mountain Rest',
    county_fips: 45073,
    county_fips_all: '45073',
    county: 'Oconee',
    county_names_all: 'Oconee',
    county_weights: '{"45073": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 34.86393,
    longitude: -83.15991,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29664',
  },
  {
    city: 'Newry',
    county_fips: 45073,
    county_fips_all: '45073',
    county: 'Oconee',
    county_names_all: 'Oconee',
    county_weights: '{"45073": 100}',
    density: 538.8,
    imprecise: false,
    latitude: 34.72399,
    longitude: -82.91413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29665',
  },
  {
    city: 'Ninety Six',
    county_fips: 45047,
    county_fips_all: '45047|45081',
    county: 'Greenwood',
    county_names_all: 'Greenwood|Saluda',
    county_weights: '{"45047": 94.64, "45081": 5.36}',
    density: 21.8,
    imprecise: false,
    latitude: 34.12345,
    longitude: -81.99121,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29666',
  },
  {
    city: 'Norris',
    county_fips: 45077,
    county_fips_all: '45077',
    county: 'Pickens',
    county_names_all: 'Pickens',
    county_weights: '{"45077": 100}',
    density: 176.7,
    imprecise: false,
    latitude: 34.76446,
    longitude: -82.75655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29667',
  },
  {
    city: 'Pelzer',
    county_fips: 45045,
    county_fips_all: '45045|45007',
    county: 'Greenville',
    county_names_all: 'Greenville|Anderson',
    county_weights: '{"45045": 72.14, "45007": 27.86}',
    density: 100.7,
    imprecise: false,
    latitude: 34.6405,
    longitude: -82.41495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29669',
  },
  {
    city: 'Pendleton',
    county_fips: 45007,
    county_fips_all: '45007|45077',
    county: 'Anderson',
    county_names_all: 'Anderson|Pickens',
    county_weights: '{"45007": 95.25, "45077": 4.75}',
    density: 76.3,
    imprecise: false,
    latitude: 34.64191,
    longitude: -82.72455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29670',
  },
  {
    city: 'Pickens',
    county_fips: 45077,
    county_fips_all: '45077',
    county: 'Pickens',
    county_names_all: 'Pickens',
    county_weights: '{"45077": 100}',
    density: 54.5,
    imprecise: false,
    latitude: 34.94071,
    longitude: -82.72057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29671',
  },
  {
    city: 'Seneca',
    county_fips: 45073,
    county_fips_all: '45073',
    county: 'Oconee',
    county_names_all: 'Oconee',
    county_weights: '{"45073": 100}',
    density: 125.7,
    imprecise: false,
    latitude: 34.75036,
    longitude: -82.94257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29672',
  },
  {
    city: 'Piedmont',
    county_fips: 45045,
    county_fips_all: '45045|45007',
    county: 'Greenville',
    county_names_all: 'Greenville|Anderson',
    county_weights: '{"45045": 53.9, "45007": 46.1}',
    density: 166.7,
    imprecise: false,
    latitude: 34.71901,
    longitude: -82.455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29673',
  },
  {
    city: 'Salem',
    county_fips: 45073,
    county_fips_all: '45073',
    county: 'Oconee',
    county_names_all: 'Oconee',
    county_weights: '{"45073": 100}',
    density: 32.2,
    imprecise: false,
    latitude: 34.93326,
    longitude: -82.96006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29676',
  },
  {
    city: 'Seneca',
    county_fips: 45073,
    county_fips_all: '45073|45077',
    county: 'Oconee',
    county_names_all: 'Oconee|Pickens',
    county_weights: '{"45073": 99.47, "45077": 0.53}',
    density: 115,
    imprecise: false,
    latitude: 34.63365,
    longitude: -82.93991,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29678',
  },
  {
    city: 'Simpsonville',
    county_fips: 45045,
    county_fips_all: '45045',
    county: 'Greenville',
    county_names_all: 'Greenville',
    county_weights: '{"45045": 100}',
    density: 475.2,
    imprecise: false,
    latitude: 34.69011,
    longitude: -82.29073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29680',
  },
  {
    city: 'Simpsonville',
    county_fips: 45045,
    county_fips_all: '45045|45059',
    county: 'Greenville',
    county_names_all: 'Greenville|Laurens',
    county_weights: '{"45045": 97.43, "45059": 2.57}',
    density: 606.7,
    imprecise: false,
    latitude: 34.76988,
    longitude: -82.22218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29681',
  },
  {
    city: 'Six Mile',
    county_fips: 45077,
    county_fips_all: '45077',
    county: 'Pickens',
    county_names_all: 'Pickens',
    county_weights: '{"45077": 100}',
    density: 59.2,
    imprecise: false,
    latitude: 34.83295,
    longitude: -82.84701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29682',
  },
  {
    city: 'Slater',
    county_fips: 45045,
    county_fips_all: '45045',
    county: 'Greenville',
    county_names_all: 'Greenville',
    county_weights: '{"45045": 100}',
    density: 695.9,
    imprecise: false,
    latitude: 35.03032,
    longitude: -82.49306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29683',
  },
  {
    city: 'Starr',
    county_fips: 45007,
    county_fips_all: '45007',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"45007": 100}',
    density: 38.8,
    imprecise: false,
    latitude: 34.3791,
    longitude: -82.72722,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29684',
  },
  {
    city: 'Sunset',
    county_fips: 45077,
    county_fips_all: '45077',
    county: 'Pickens',
    county_names_all: 'Pickens',
    county_weights: '{"45077": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 34.98297,
    longitude: -82.84727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29685',
  },
  {
    city: 'Tamassee',
    county_fips: 45073,
    county_fips_all: '45073',
    county: 'Oconee',
    county_names_all: 'Oconee',
    county_weights: '{"45073": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 34.92858,
    longitude: -83.04541,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29686',
  },
  {
    city: 'Taylors',
    county_fips: 45045,
    county_fips_all: '45045',
    county: 'Greenville',
    county_names_all: 'Greenville',
    county_weights: '{"45045": 100}',
    density: 359.1,
    imprecise: false,
    latitude: 34.9855,
    longitude: -82.32833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29687',
  },
  {
    city: 'Townville',
    county_fips: 45007,
    county_fips_all: '45007|45073',
    county: 'Anderson',
    county_names_all: 'Anderson|Oconee',
    county_weights: '{"45007": 88.92, "45073": 11.08}',
    density: 45.3,
    imprecise: false,
    latitude: 34.53624,
    longitude: -82.87658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29689',
  },
  {
    city: 'Travelers Rest',
    county_fips: 45045,
    county_fips_all: '45045',
    county: 'Greenville',
    county_names_all: 'Greenville',
    county_weights: '{"45045": 100}',
    density: 96.7,
    imprecise: false,
    latitude: 35.06008,
    longitude: -82.42136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29690',
  },
  {
    city: 'Walhalla',
    county_fips: 45073,
    county_fips_all: '45073',
    county: 'Oconee',
    county_names_all: 'Oconee',
    county_weights: '{"45073": 100}',
    density: 75,
    imprecise: false,
    latitude: 34.78547,
    longitude: -83.07669,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29691',
  },
  {
    city: 'Ware Shoals',
    county_fips: 45059,
    county_fips_all: '45059|45047|45001',
    county: 'Laurens',
    county_names_all: 'Laurens|Greenwood|Abbeville',
    county_weights: '{"45059": 80.02, "45047": 12.64, "45001": 7.34}',
    density: 44,
    imprecise: false,
    latitude: 34.42142,
    longitude: -82.22208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29692',
  },
  {
    city: 'Westminster',
    county_fips: 45073,
    county_fips_all: '45073',
    county: 'Oconee',
    county_names_all: 'Oconee',
    county_weights: '{"45073": 100}',
    density: 33.7,
    imprecise: false,
    latitude: 34.65641,
    longitude: -83.15284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29693',
  },
  {
    city: 'West Union',
    county_fips: 45073,
    county_fips_all: '45073',
    county: 'Oconee',
    county_names_all: 'Oconee',
    county_weights: '{"45073": 100}',
    density: 90.8,
    imprecise: false,
    latitude: 34.77458,
    longitude: -83.00771,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29696',
  },
  {
    city: 'Williamston',
    county_fips: 45007,
    county_fips_all: '45007',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"45007": 100}',
    density: 133.6,
    imprecise: false,
    latitude: 34.62887,
    longitude: -82.54786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29697',
  },
  {
    city: 'Blacksburg',
    county_fips: 45021,
    county_fips_all: '45021|45091',
    county: 'Cherokee',
    county_names_all: 'Cherokee|York',
    county_weights: '{"45021": 85.58, "45091": 14.42}',
    density: 40.4,
    imprecise: false,
    latitude: 35.11674,
    longitude: -81.47884,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29702',
  },
  {
    city: 'Catawba',
    county_fips: 45091,
    county_fips_all: '45091|45023|45057',
    county: 'York',
    county_names_all: 'York|Chester|Lancaster',
    county_weights: '{"45091": 56.7, "45023": 43.19, "45057": 0.11}',
    density: 45,
    imprecise: false,
    latitude: 34.82293,
    longitude: -80.91592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29704',
  },
  {
    city: 'Chester',
    county_fips: 45023,
    county_fips_all: '45023|45091',
    county: 'Chester',
    county_names_all: 'Chester|York',
    county_weights: '{"45023": 99.68, "45091": 0.32}',
    density: 27,
    imprecise: false,
    latitude: 34.71773,
    longitude: -81.23055,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29706',
  },
  {
    city: 'Fort Mill',
    county_fips: 45057,
    county_fips_all: '45057|45091',
    county: 'Lancaster',
    county_names_all: 'Lancaster|York',
    county_weights: '{"45057": 99.85, "45091": 0.15}',
    density: 510.6,
    imprecise: false,
    latitude: 34.98148,
    longitude: -80.85669,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29707',
  },
  {
    city: 'Fort Mill',
    county_fips: 45091,
    county_fips_all: '45091',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"45091": 100}',
    density: 883,
    imprecise: false,
    latitude: 35.04655,
    longitude: -80.98604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29708',
  },
  {
    city: 'Chesterfield',
    county_fips: 45025,
    county_fips_all: '45025',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield',
    county_weights: '{"45025": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 34.71882,
    longitude: -80.09752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29709',
  },
  {
    city: 'Clover',
    county_fips: 45091,
    county_fips_all: '45091',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"45091": 100}',
    density: 137.4,
    imprecise: false,
    latitude: 35.10598,
    longitude: -81.22209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29710',
  },
  {
    city: 'Edgemoor',
    county_fips: 45023,
    county_fips_all: '45023|45091',
    county: 'Chester',
    county_names_all: 'Chester|York',
    county_weights: '{"45023": 84.93, "45091": 15.07}',
    density: 27.4,
    imprecise: false,
    latitude: 34.79439,
    longitude: -80.98398,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29712',
  },
  {
    city: 'Fort Lawn',
    county_fips: 45023,
    county_fips_all: '45023|45057',
    county: 'Chester',
    county_names_all: 'Chester|Lancaster',
    county_weights: '{"45023": 99.82, "45057": 0.18}',
    density: 41.1,
    imprecise: false,
    latitude: 34.71171,
    longitude: -80.9145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29714',
  },
  {
    city: 'Fort Mill',
    county_fips: 45091,
    county_fips_all: '45091|45057',
    county: 'York',
    county_names_all: 'York|Lancaster',
    county_weights: '{"45091": 99.76, "45057": 0.24}',
    density: 517.3,
    imprecise: false,
    latitude: 35.01028,
    longitude: -80.92752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29715',
  },
  {
    city: 'Hickory Grove',
    county_fips: 45091,
    county_fips_all: '45091|45021',
    county: 'York',
    county_names_all: 'York|Cherokee',
    county_weights: '{"45091": 99.86, "45021": 0.14}',
    density: 17,
    imprecise: false,
    latitude: 34.95119,
    longitude: -81.44304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29717',
  },
  {
    city: 'Jefferson',
    county_fips: 45025,
    county_fips_all: '45025|45055|45057',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield|Kershaw|Lancaster',
    county_weights: '{"45025": 90.47, "45055": 6.96, "45057": 2.57}',
    density: 15.4,
    imprecise: false,
    latitude: 34.6291,
    longitude: -80.35469,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29718',
  },
  {
    city: 'Lancaster',
    county_fips: 45057,
    county_fips_all: '45057',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"45057": 100}',
    density: 72.6,
    imprecise: false,
    latitude: 34.74265,
    longitude: -80.73684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29720',
  },
  {
    city: 'McConnells',
    county_fips: 45091,
    county_fips_all: '45091|45023',
    county: 'York',
    county_names_all: 'York|Chester',
    county_weights: '{"45091": 99.85, "45023": 0.15}',
    density: 19,
    imprecise: false,
    latitude: 34.85738,
    longitude: -81.23223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29726',
  },
  {
    city: 'Mount Croghan',
    county_fips: 45025,
    county_fips_all: '45025',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield',
    county_weights: '{"45025": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 34.71566,
    longitude: -80.2684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29727',
  },
  {
    city: 'Pageland',
    county_fips: 45025,
    county_fips_all: '45025',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield',
    county_weights: '{"45025": 100}',
    density: 36.7,
    imprecise: false,
    latitude: 34.76831,
    longitude: -80.40445,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29728',
  },
  {
    city: 'Richburg',
    county_fips: 45023,
    county_fips_all: '45023',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"45023": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 34.67716,
    longitude: -81.00528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29729',
  },
  {
    city: 'Rock Hill',
    county_fips: 45091,
    county_fips_all: '45091|45023',
    county: 'York',
    county_names_all: 'York|Chester',
    county_weights: '{"45091": 95.26, "45023": 4.74}',
    density: 188.3,
    imprecise: false,
    latitude: 34.8878,
    longitude: -81.02116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29730',
  },
  {
    city: 'Rock Hill',
    county_fips: 45091,
    county_fips_all: '45091',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"45091": 100}',
    density: 421.7,
    imprecise: false,
    latitude: 34.96979,
    longitude: -81.07963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29732',
  },
  {
    city: 'Ruby',
    county_fips: 45025,
    county_fips_all: '45025',
    county: 'Chesterfield',
    county_names_all: 'Chesterfield',
    county_weights: '{"45025": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 34.72511,
    longitude: -80.20138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29741',
  },
  {
    city: 'Sharon',
    county_fips: 45091,
    county_fips_all: '45091|45023',
    county: 'York',
    county_names_all: 'York|Chester',
    county_weights: '{"45091": 83.66, "45023": 16.34}',
    density: 11.9,
    imprecise: false,
    latitude: 34.86939,
    longitude: -81.38155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29742',
  },
  {
    city: 'Smyrna',
    county_fips: 45091,
    county_fips_all: '45091|45021',
    county: 'York',
    county_names_all: 'York|Cherokee',
    county_weights: '{"45091": 84.51, "45021": 15.49}',
    density: 19,
    imprecise: false,
    latitude: 35.02865,
    longitude: -81.40772,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29743',
  },
  {
    city: 'York',
    county_fips: 45091,
    county_fips_all: '45091',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"45091": 100}',
    density: 99.3,
    imprecise: false,
    latitude: 34.99549,
    longitude: -81.21573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29745',
  },
  {
    city: 'Aiken',
    county_fips: 45003,
    county_fips_all: '45003',
    county: 'Aiken',
    county_names_all: 'Aiken',
    county_weights: '{"45003": 100}',
    density: 135.1,
    imprecise: false,
    latitude: 33.58675,
    longitude: -81.69701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29801',
  },
  {
    city: 'Aiken',
    county_fips: 45003,
    county_fips_all: '45003',
    county: 'Aiken',
    county_names_all: 'Aiken',
    county_weights: '{"45003": 100}',
    density: 123.2,
    imprecise: false,
    latitude: 33.45889,
    longitude: -81.70076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29803',
  },
  {
    city: 'Aiken',
    county_fips: 45003,
    county_fips_all: '45003',
    county: 'Aiken',
    county_names_all: 'Aiken',
    county_weights: '{"45003": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 33.6495,
    longitude: -81.61044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29805',
  },
  {
    city: 'New Ellenton',
    county_fips: 45003,
    county_fips_all: '45003',
    county: 'Aiken',
    county_names_all: 'Aiken',
    county_weights: '{"45003": 100}',
    density: 164.6,
    imprecise: false,
    latitude: 33.41653,
    longitude: -81.6889,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29809',
  },
  {
    city: 'Allendale',
    county_fips: 45005,
    county_fips_all: '45005',
    county: 'Allendale',
    county_names_all: 'Allendale',
    county_weights: '{"45005": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 32.99358,
    longitude: -81.3798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29810',
  },
  {
    city: 'Barnwell',
    county_fips: 45011,
    county_fips_all: '45011|45005',
    county: 'Barnwell',
    county_names_all: 'Barnwell|Allendale',
    county_weights: '{"45011": 97.67, "45005": 2.33}',
    density: 24.8,
    imprecise: false,
    latitude: 33.21185,
    longitude: -81.37911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29812',
  },
  {
    city: 'Bath',
    county_fips: 45003,
    county_fips_all: '45003',
    county: 'Aiken',
    county_names_all: 'Aiken',
    county_weights: '{"45003": 100}',
    density: 706.6,
    imprecise: false,
    latitude: 33.50105,
    longitude: -81.87164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29816',
  },
  {
    city: 'Blackville',
    county_fips: 45011,
    county_fips_all: '45011|45009',
    county: 'Barnwell',
    county_names_all: 'Barnwell|Bamberg',
    county_weights: '{"45011": 83.85, "45009": 16.15}',
    density: 14,
    imprecise: false,
    latitude: 33.36989,
    longitude: -81.27096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29817',
  },
  {
    city: 'Bradley',
    county_fips: 45047,
    county_fips_all: '45047|45001|45065',
    county: 'Greenwood',
    county_names_all: 'Greenwood|Abbeville|McCormick',
    county_weights: '{"45047": 83.18, "45001": 11.28, "45065": 5.54}',
    density: 4.4,
    imprecise: false,
    latitude: 34.04764,
    longitude: -82.22632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29819',
  },
  {
    city: 'Clarks Hill',
    county_fips: 45037,
    county_fips_all: '45037|45065',
    county: 'Edgefield',
    county_names_all: 'Edgefield|McCormick',
    county_weights: '{"45037": 51.59, "45065": 48.41}',
    density: 8,
    imprecise: false,
    latitude: 33.64242,
    longitude: -82.11667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29821',
  },
  {
    city: 'Edgefield',
    county_fips: 45037,
    county_fips_all: '45037|45081',
    county: 'Edgefield',
    county_names_all: 'Edgefield|Saluda',
    county_weights: '{"45037": 98.26, "45081": 1.74}',
    density: 12.8,
    imprecise: false,
    latitude: 33.81647,
    longitude: -81.99666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29824',
  },
  {
    city: 'Elko',
    county_fips: 45011,
    county_fips_all: '45011',
    county: 'Barnwell',
    county_names_all: 'Barnwell',
    county_weights: '{"45011": 100}',
    density: 46.1,
    imprecise: false,
    latitude: 33.383,
    longitude: -81.36697,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29826',
  },
  {
    city: 'Fairfax',
    county_fips: 45005,
    county_fips_all: '45005|45049',
    county: 'Allendale',
    county_names_all: 'Allendale|Hampton',
    county_weights: '{"45005": 96.17, "45049": 3.83}',
    density: 12.5,
    imprecise: false,
    latitude: 32.96951,
    longitude: -81.24542,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29827',
  },
  {
    city: 'Gloverville',
    county_fips: 45003,
    county_fips_all: '45003',
    county: 'Aiken',
    county_names_all: 'Aiken',
    county_weights: '{"45003": 100}',
    density: 289,
    imprecise: false,
    latitude: 33.52299,
    longitude: -81.82891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29828',
  },
  {
    city: 'Graniteville',
    county_fips: 45003,
    county_fips_all: '45003',
    county: 'Aiken',
    county_names_all: 'Aiken',
    county_weights: '{"45003": 100}',
    density: 137.1,
    imprecise: false,
    latitude: 33.57715,
    longitude: -81.85537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29829',
  },
  {
    city: 'Jackson',
    county_fips: 45003,
    county_fips_all: '45003',
    county: 'Aiken',
    county_names_all: 'Aiken',
    county_weights: '{"45003": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 33.33657,
    longitude: -81.84293,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29831',
  },
  {
    city: 'Johnston',
    county_fips: 45037,
    county_fips_all: '45037|45081|45003',
    county: 'Edgefield',
    county_names_all: 'Edgefield|Saluda|Aiken',
    county_weights: '{"45037": 66.76, "45081": 32.4, "45003": 0.84}',
    density: 20.7,
    imprecise: false,
    latitude: 33.83922,
    longitude: -81.80656,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29832',
  },
  {
    city: 'Langley',
    county_fips: 45003,
    county_fips_all: '45003',
    county: 'Aiken',
    county_names_all: 'Aiken',
    county_weights: '{"45003": 100}',
    density: 642,
    imprecise: false,
    latitude: 33.5178,
    longitude: -81.84216,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29834',
  },
  {
    city: 'McCormick',
    county_fips: 45065,
    county_fips_all: '45065|45037',
    county: 'McCormick',
    county_names_all: 'McCormick|Edgefield',
    county_weights: '{"45065": 85.45, "45037": 14.55}',
    density: 15.6,
    imprecise: false,
    latitude: 33.91779,
    longitude: -82.29559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29835',
  },
  {
    city: 'Martin',
    county_fips: 45005,
    county_fips_all: '45005|45011',
    county: 'Allendale',
    county_names_all: 'Allendale|Barnwell',
    county_weights: '{"45005": 83.08, "45011": 16.92}',
    density: 1.2,
    imprecise: false,
    latitude: 33.09046,
    longitude: -81.50026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29836',
  },
  {
    city: 'Modoc',
    county_fips: 45037,
    county_fips_all: '45037|45065',
    county: 'Edgefield',
    county_names_all: 'Edgefield|McCormick',
    county_weights: '{"45037": 60.52, "45065": 39.48}',
    density: 11,
    imprecise: false,
    latitude: 33.73452,
    longitude: -82.1667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29838',
  },
  {
    city: 'Mount Carmel',
    county_fips: 45065,
    county_fips_all: '45065',
    county: 'McCormick',
    county_names_all: 'McCormick',
    county_weights: '{"45065": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 33.99797,
    longitude: -82.52749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29840',
  },
  {
    city: 'North Augusta',
    county_fips: 45003,
    county_fips_all: '45003',
    county: 'Aiken',
    county_names_all: 'Aiken',
    county_weights: '{"45003": 100}',
    density: 390.9,
    imprecise: false,
    latitude: 33.52508,
    longitude: -81.93954,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29841',
  },
  {
    city: 'Beech Island',
    county_fips: 45003,
    county_fips_all: '45003',
    county: 'Aiken',
    county_names_all: 'Aiken',
    county_weights: '{"45003": 100}',
    density: 75.6,
    imprecise: false,
    latitude: 33.44559,
    longitude: -81.8645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29842',
  },
  {
    city: 'Olar',
    county_fips: 45009,
    county_fips_all: '45009|45011',
    county: 'Bamberg',
    county_names_all: 'Bamberg|Barnwell',
    county_weights: '{"45009": 81.28, "45011": 18.72}',
    density: 5.5,
    imprecise: false,
    latitude: 33.18385,
    longitude: -81.18218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29843',
  },
  {
    city: 'Parksville',
    county_fips: 45065,
    county_fips_all: '45065',
    county: 'McCormick',
    county_names_all: 'McCormick',
    county_weights: '{"45065": 100}',
    density: 41.1,
    imprecise: false,
    latitude: 33.78528,
    longitude: -82.2142,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29844',
  },
  {
    city: 'Plum Branch',
    county_fips: 45065,
    county_fips_all: '45065|45037',
    county: 'McCormick',
    county_names_all: 'McCormick|Edgefield',
    county_weights: '{"45065": 92.36, "45037": 7.64}',
    density: 4.5,
    imprecise: false,
    latitude: 33.8231,
    longitude: -82.20788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29845',
  },
  {
    city: 'Trenton',
    county_fips: 45037,
    county_fips_all: '45037|45003',
    county: 'Edgefield',
    county_names_all: 'Edgefield|Aiken',
    county_weights: '{"45037": 75.66, "45003": 24.34}',
    density: 23.7,
    imprecise: false,
    latitude: 33.69941,
    longitude: -81.84878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29847',
  },
  {
    city: 'Troy',
    county_fips: 45065,
    county_fips_all: '45065|45047|45081',
    county: 'McCormick',
    county_names_all: 'McCormick|Greenwood|Saluda',
    county_weights: '{"45065": 53.03, "45047": 38.06, "45081": 8.91}',
    density: 3.7,
    imprecise: false,
    latitude: 33.99616,
    longitude: -82.18304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29848',
  },
  {
    city: 'Ulmer',
    county_fips: 45005,
    county_fips_all: '45005|45011',
    county: 'Allendale',
    county_names_all: 'Allendale|Barnwell',
    county_weights: '{"45005": 73.59, "45011": 26.41}',
    density: 2.5,
    imprecise: false,
    latitude: 33.10168,
    longitude: -81.23641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29849',
  },
  {
    city: 'Warrenville',
    county_fips: 45003,
    county_fips_all: '45003',
    county: 'Aiken',
    county_names_all: 'Aiken',
    county_weights: '{"45003": 100}',
    density: 158.9,
    imprecise: false,
    latitude: 33.51098,
    longitude: -81.81597,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29851',
  },
  {
    city: 'Williston',
    county_fips: 45011,
    county_fips_all: '45011|45003',
    county: 'Barnwell',
    county_names_all: 'Barnwell|Aiken',
    county_weights: '{"45011": 75.21, "45003": 24.79}',
    density: 18.9,
    imprecise: false,
    latitude: 33.39871,
    longitude: -81.43217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29853',
  },
  {
    city: 'Windsor',
    county_fips: 45003,
    county_fips_all: '45003',
    county: 'Aiken',
    county_names_all: 'Aiken',
    county_weights: '{"45003": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 33.48365,
    longitude: -81.51276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29856',
  },
  {
    city: 'North Augusta',
    county_fips: 45037,
    county_fips_all: '45037|45003',
    county: 'Edgefield',
    county_names_all: 'Edgefield|Aiken',
    county_weights: '{"45037": 85.51, "45003": 14.49}',
    density: 129.3,
    imprecise: false,
    latitude: 33.60667,
    longitude: -81.97776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29860',
  },
  {
    city: 'Beaufort',
    county_fips: 45013,
    county_fips_all: '45013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"45013": 100}',
    density: 375.8,
    imprecise: false,
    latitude: 32.37426,
    longitude: -80.69438,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29902',
  },
  {
    city: 'Beaufort',
    county_fips: 45013,
    county_fips_all: '45013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"45013": 100}',
    density: 155.6,
    imprecise: false,
    latitude: 32.47899,
    longitude: -80.72198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29904',
  },
  {
    city: 'Parris Island',
    county_fips: 45013,
    county_fips_all: '45013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"45013": 100}',
    density: 235.5,
    imprecise: false,
    latitude: 32.35383,
    longitude: -80.69537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29905',
  },
  {
    city: 'Beaufort',
    county_fips: 45013,
    county_fips_all: '45013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"45013": 100}',
    density: 217.6,
    imprecise: false,
    latitude: 32.44521,
    longitude: -80.75159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29906',
  },
  {
    city: 'Beaufort',
    county_fips: 45013,
    county_fips_all: '45013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"45013": 100}',
    density: 138.8,
    imprecise: false,
    latitude: 32.45326,
    longitude: -80.60926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29907',
  },
  {
    city: 'Okatie',
    county_fips: 45013,
    county_fips_all: '45013|45053',
    county: 'Beaufort',
    county_names_all: 'Beaufort|Jasper',
    county_weights: '{"45013": 98.36, "45053": 1.64}',
    density: 166.5,
    imprecise: false,
    latitude: 32.34042,
    longitude: -80.85465,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29909',
  },
  {
    city: 'Bluffton',
    county_fips: 45013,
    county_fips_all: '45013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"45013": 100}',
    density: 196,
    imprecise: false,
    latitude: 32.2204,
    longitude: -80.88277,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29910',
  },
  {
    city: 'Brunson',
    county_fips: 45049,
    county_fips_all: '45049|45005',
    county: 'Hampton',
    county_names_all: 'Hampton|Allendale',
    county_weights: '{"45049": 99.9, "45005": 0.1}',
    density: 7.2,
    imprecise: false,
    latitude: 32.9327,
    longitude: -81.14536,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29911',
  },
  {
    city: 'Coosawhatchie',
    county_fips: 45053,
    county_fips_all: '45053',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"45053": 100}',
    density: 29,
    imprecise: false,
    latitude: 32.58262,
    longitude: -80.93102,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29912',
  },
  {
    city: 'Daufuskie Island',
    county_fips: 45013,
    county_fips_all: '45013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"45013": 100}',
    density: 22.2,
    imprecise: false,
    latitude: 32.11464,
    longitude: -80.86892,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29915',
  },
  {
    city: 'Early Branch',
    county_fips: 45049,
    county_fips_all: '45049|45053',
    county: 'Hampton',
    county_names_all: 'Hampton|Jasper',
    county_weights: '{"45049": 63.06, "45053": 36.94}',
    density: 8.9,
    imprecise: false,
    latitude: 32.72863,
    longitude: -80.95708,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29916',
  },
  {
    city: 'Estill',
    county_fips: 45049,
    county_fips_all: '45049',
    county: 'Hampton',
    county_names_all: 'Hampton',
    county_weights: '{"45049": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 32.74461,
    longitude: -81.24899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29918',
  },
  {
    city: 'Saint Helena Island',
    county_fips: 45013,
    county_fips_all: '45013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"45013": 100}',
    density: 42,
    imprecise: false,
    latitude: 32.36441,
    longitude: -80.54946,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29920',
  },
  {
    city: 'Furman',
    county_fips: 45049,
    county_fips_all: '45049',
    county: 'Hampton',
    county_names_all: 'Hampton',
    county_weights: '{"45049": 100}',
    density: 46.4,
    imprecise: false,
    latitude: 32.68664,
    longitude: -81.18011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29921',
  },
  {
    city: 'Garnett',
    county_fips: 45049,
    county_fips_all: '45049|45053',
    county: 'Hampton',
    county_names_all: 'Hampton|Jasper',
    county_weights: '{"45049": 66.78, "45053": 33.22}',
    density: 2.1,
    imprecise: false,
    latitude: 32.59632,
    longitude: -81.27407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29922',
  },
  {
    city: 'Gifford',
    county_fips: 45049,
    county_fips_all: '45049',
    county: 'Hampton',
    county_names_all: 'Hampton',
    county_weights: '{"45049": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 32.84821,
    longitude: -81.23856,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29923',
  },
  {
    city: 'Hampton',
    county_fips: 45049,
    county_fips_all: '45049',
    county: 'Hampton',
    county_names_all: 'Hampton',
    county_weights: '{"45049": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 32.87737,
    longitude: -81.10749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29924',
  },
  {
    city: 'Hilton Head Island',
    county_fips: 45013,
    county_fips_all: '45013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"45013": 100}',
    density: 329,
    imprecise: false,
    latitude: 32.22936,
    longitude: -80.74931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29926',
  },
  {
    city: 'Hardeeville',
    county_fips: 45053,
    county_fips_all: '45053|45013',
    county: 'Jasper',
    county_names_all: 'Jasper|Beaufort',
    county_weights: '{"45053": 99.59, "45013": 0.41}',
    density: 21.9,
    imprecise: false,
    latitude: 32.24343,
    longitude: -81.04971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29927',
  },
  {
    city: 'Hilton Head Island',
    county_fips: 45013,
    county_fips_all: '45013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"45013": 100}',
    density: 294.4,
    imprecise: false,
    latitude: 32.16214,
    longitude: -80.76274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29928',
  },
  {
    city: 'Islandton',
    county_fips: 45029,
    county_fips_all: '45029',
    county: 'Colleton',
    county_names_all: 'Colleton',
    county_weights: '{"45029": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 32.93805,
    longitude: -80.9434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29929',
  },
  {
    city: 'Luray',
    county_fips: 45005,
    county_fips_all: '45005|45049',
    county: 'Allendale',
    county_names_all: 'Allendale|Hampton',
    county_weights: '{"45005": 88.73, "45049": 11.27}',
    density: 1.8,
    imprecise: false,
    latitude: 32.82529,
    longitude: -81.34853,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29932',
  },
  {
    city: 'Pineland',
    county_fips: 45053,
    county_fips_all: '45053|45049',
    county: 'Jasper',
    county_names_all: 'Jasper|Hampton',
    county_weights: '{"45053": 87.42, "45049": 12.58}',
    density: 5.9,
    imprecise: false,
    latitude: 32.59651,
    longitude: -81.11245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29934',
  },
  {
    city: 'Port Royal',
    county_fips: 45013,
    county_fips_all: '45013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"45013": 100}',
    density: 581.5,
    imprecise: false,
    latitude: 32.38277,
    longitude: -80.6963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29935',
  },
  {
    city: 'Ridgeland',
    county_fips: 45053,
    county_fips_all: '45053',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"45053": 100}',
    density: 25,
    imprecise: false,
    latitude: 32.48475,
    longitude: -80.96766,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29936',
  },
  {
    city: 'Seabrook',
    county_fips: 45013,
    county_fips_all: '45013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"45013": 100}',
    density: 17,
    imprecise: false,
    latitude: 32.5524,
    longitude: -80.67511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29940',
  },
  {
    city: 'Sheldon',
    county_fips: 45013,
    county_fips_all: '45013',
    county: 'Beaufort',
    county_names_all: 'Beaufort',
    county_weights: '{"45013": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 32.54357,
    longitude: -80.81509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29941',
  },
  {
    city: 'Tillman',
    county_fips: 45053,
    county_fips_all: '45053',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"45053": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 32.4821,
    longitude: -81.14952,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29943',
  },
  {
    city: 'Varnville',
    county_fips: 45049,
    county_fips_all: '45049|45053',
    county: 'Hampton',
    county_names_all: 'Hampton|Jasper',
    county_weights: '{"45049": 86.15, "45053": 13.85}',
    density: 12.6,
    imprecise: false,
    latitude: 32.79129,
    longitude: -81.03409,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29944',
  },
  {
    city: 'Yemassee',
    county_fips: 45029,
    county_fips_all: '45029|45013|45053|45049',
    county: 'Colleton',
    county_names_all: 'Colleton|Beaufort|Jasper|Hampton',
    county_weights:
      '{"45029": 41.83, "45013": 27.05, "45053": 15.83, "45049": 15.28}',
    density: 7.3,
    imprecise: false,
    latitude: 32.68694,
    longitude: -80.80912,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29945',
  },
  {
    city: 'Avondale Estates',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 1188.4,
    imprecise: false,
    latitude: 33.77309,
    longitude: -84.26093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30002',
  },
  {
    city: 'Alpharetta',
    county_fips: 13121,
    county_fips_all: '13121|13117|13057',
    county: 'Fulton',
    county_names_all: 'Fulton|Forsyth|Cherokee',
    county_weights: '{"13121": 68.53, "13117": 15.89, "13057": 15.58}',
    density: 457.9,
    imprecise: false,
    latitude: 34.14352,
    longitude: -84.29926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30004',
  },
  {
    city: 'Alpharetta',
    county_fips: 13121,
    county_fips_all: '13121|13117',
    county: 'Fulton',
    county_names_all: 'Fulton|Forsyth',
    county_weights: '{"13121": 70.51, "13117": 29.49}',
    density: 1022.9,
    imprecise: false,
    latitude: 34.08582,
    longitude: -84.22158,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30005',
  },
  {
    city: 'Marietta',
    county_fips: 13067,
    county_fips_all: '13067',
    county: 'Cobb',
    county_names_all: 'Cobb',
    county_weights: '{"13067": 100}',
    density: 1438.4,
    imprecise: false,
    latitude: 33.8966,
    longitude: -84.58847,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30008',
  },
  {
    city: 'Alpharetta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 894.3,
    imprecise: false,
    latitude: 34.07711,
    longitude: -84.3029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30009',
  },
  {
    city: 'Auburn',
    county_fips: 13013,
    county_fips_all: '13013|13135',
    county: 'Barrow',
    county_names_all: 'Barrow|Gwinnett',
    county_weights: '{"13013": 73.89, "13135": 26.11}',
    density: 310.8,
    imprecise: false,
    latitude: 34.02281,
    longitude: -83.8364,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30011',
  },
  {
    city: 'Conyers',
    county_fips: 13247,
    county_fips_all: '13247|13297|13089',
    county: 'Rockdale',
    county_names_all: 'Rockdale|Walton|DeKalb',
    county_weights: '{"13247": 96.61, "13297": 2.8, "13089": 0.59}',
    density: 313.9,
    imprecise: false,
    latitude: 33.71739,
    longitude: -83.99913,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30012',
  },
  {
    city: 'Conyers',
    county_fips: 13247,
    county_fips_all: '13247|13217',
    county: 'Rockdale',
    county_names_all: 'Rockdale|Newton',
    county_weights: '{"13247": 94.99, "13217": 5.01}',
    density: 385.3,
    imprecise: false,
    latitude: 33.643,
    longitude: -83.97147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30013',
  },
  {
    city: 'Covington',
    county_fips: 13217,
    county_fips_all: '13217|13297|13159',
    county: 'Newton',
    county_names_all: 'Newton|Walton|Jasper',
    county_weights: '{"13217": 77.75, "13297": 21.3, "13159": 0.95}',
    density: 132.6,
    imprecise: false,
    latitude: 33.58109,
    longitude: -83.8191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30014',
  },
  {
    city: 'Covington',
    county_fips: 13217,
    county_fips_all: '13217|13247',
    county: 'Newton',
    county_names_all: 'Newton|Rockdale',
    county_weights: '{"13217": 99.62, "13247": 0.38}',
    density: 267.7,
    imprecise: false,
    latitude: 33.51836,
    longitude: -83.93073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30016',
  },
  {
    city: 'Grayson',
    county_fips: 13135,
    county_fips_all: '13135',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett',
    county_weights: '{"13135": 100}',
    density: 889.2,
    imprecise: false,
    latitude: 33.88939,
    longitude: -83.96348,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30017',
  },
  {
    city: 'Jersey',
    county_fips: 13297,
    county_fips_all: '13297',
    county: 'Walton',
    county_names_all: 'Walton',
    county_weights: '{"13297": 100}',
    density: 71.7,
    imprecise: false,
    latitude: 33.71737,
    longitude: -83.80034,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30018',
  },
  {
    city: 'Dacula',
    county_fips: 13135,
    county_fips_all: '13135|13297',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett|Walton',
    county_weights: '{"13135": 96.05, "13297": 3.95}',
    density: 421.5,
    imprecise: false,
    latitude: 33.97642,
    longitude: -83.88252,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30019',
  },
  {
    city: 'Clarkston',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 2999.9,
    imprecise: false,
    latitude: 33.80803,
    longitude: -84.23909,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30021',
  },
  {
    city: 'Alpharetta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 1052.7,
    imprecise: false,
    latitude: 34.02745,
    longitude: -84.24643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30022',
  },
  {
    city: 'Suwanee',
    county_fips: 13135,
    county_fips_all: '13135|13117|13121',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett|Forsyth|Fulton',
    county_weights: '{"13135": 65.24, "13117": 31.96, "13121": 2.8}',
    density: 816.2,
    imprecise: false,
    latitude: 34.06341,
    longitude: -84.09116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 88067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30024',
  },
  {
    city: 'Social Circle',
    county_fips: 13297,
    county_fips_all: '13297|13217|13211',
    county: 'Walton',
    county_names_all: 'Walton|Newton|Morgan',
    county_weights: '{"13297": 70.66, "13217": 28.3, "13211": 1.04}',
    density: 61.4,
    imprecise: false,
    latitude: 33.65689,
    longitude: -83.69869,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30025',
  },
  {
    city: 'Cumming',
    county_fips: 13117,
    county_fips_all: '13117|13057',
    county: 'Forsyth',
    county_names_all: 'Forsyth|Cherokee',
    county_weights: '{"13117": 92.71, "13057": 7.29}',
    density: 297,
    imprecise: false,
    latitude: 34.28928,
    longitude: -84.17985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30028',
  },
  {
    city: 'Decatur',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 1820.4,
    imprecise: false,
    latitude: 33.7721,
    longitude: -84.29135,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30030',
  },
  {
    city: 'Decatur',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 1214.9,
    imprecise: false,
    latitude: 33.73987,
    longitude: -84.2641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30032',
  },
  {
    city: 'Decatur',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 1368.7,
    imprecise: false,
    latitude: 33.81342,
    longitude: -84.28355,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30033',
  },
  {
    city: 'Decatur',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 962.3,
    imprecise: false,
    latitude: 33.69198,
    longitude: -84.24835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30034',
  },
  {
    city: 'Decatur',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 976.8,
    imprecise: false,
    latitude: 33.72563,
    longitude: -84.20541,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30035',
  },
  {
    city: 'Lithonia',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 586.8,
    imprecise: false,
    latitude: 33.67078,
    longitude: -84.14209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30038',
  },
  {
    city: 'Snellville',
    county_fips: 13135,
    county_fips_all: '13135|13089',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett|DeKalb',
    county_weights: '{"13135": 94.32, "13089": 5.68}',
    density: 806.3,
    imprecise: false,
    latitude: 33.79871,
    longitude: -84.03414,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30039',
  },
  {
    city: 'Cumming',
    county_fips: 13117,
    county_fips_all: '13117|13057',
    county: 'Forsyth',
    county_names_all: 'Forsyth|Cherokee',
    county_weights: '{"13117": 97.84, "13057": 2.16}',
    density: 552.5,
    imprecise: false,
    latitude: 34.21622,
    longitude: -84.17978,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 82532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30040',
  },
  {
    city: 'Cumming',
    county_fips: 13117,
    county_fips_all: '13117',
    county: 'Forsyth',
    county_names_all: 'Forsyth',
    county_weights: '{"13117": 100}',
    density: 502.3,
    imprecise: false,
    latitude: 34.20166,
    longitude: -84.09371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 77664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30041',
  },
  {
    city: 'Lawrenceville',
    county_fips: 13135,
    county_fips_all: '13135',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett',
    county_weights: '{"13135": 100}',
    density: 1026.5,
    imprecise: false,
    latitude: 34.00353,
    longitude: -84.00703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 87929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30043',
  },
  {
    city: 'Lawrenceville',
    county_fips: 13135,
    county_fips_all: '13135',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett',
    county_weights: '{"13135": 100}',
    density: 1577.9,
    imprecise: false,
    latitude: 33.92207,
    longitude: -84.06924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 101475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30044',
  },
  {
    city: 'Lawrenceville',
    county_fips: 13135,
    county_fips_all: '13135',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett',
    county_weights: '{"13135": 100}',
    density: 817.1,
    imprecise: false,
    latitude: 33.93046,
    longitude: -83.93019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30045',
  },
  {
    city: 'Lawrenceville',
    county_fips: 13135,
    county_fips_all: '13135',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett',
    county_weights: '{"13135": 100}',
    density: 1020.8,
    imprecise: false,
    latitude: 33.9497,
    longitude: -83.99389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30046',
  },
  {
    city: 'Lilburn',
    county_fips: 13135,
    county_fips_all: '13135',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett',
    county_weights: '{"13135": 100}',
    density: 989.3,
    imprecise: false,
    latitude: 33.87104,
    longitude: -84.11304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 70121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30047',
  },
  {
    city: 'Loganville',
    county_fips: 13297,
    county_fips_all: '13297|13135|13247|13217',
    county: 'Walton',
    county_names_all: 'Walton|Gwinnett|Rockdale|Newton',
    county_weights:
      '{"13297": 66.97, "13135": 27.12, "13247": 4.61, "13217": 1.3}',
    density: 346.6,
    imprecise: false,
    latitude: 33.81654,
    longitude: -83.89538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 79811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30052',
  },
  {
    city: 'Oxford',
    county_fips: 13217,
    county_fips_all: '13217|13297',
    county: 'Newton',
    county_names_all: 'Newton|Walton',
    county_weights: '{"13217": 85.02, "13297": 14.98}',
    density: 101.2,
    imprecise: false,
    latitude: 33.67651,
    longitude: -83.87558,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30054',
  },
  {
    city: 'Mansfield',
    county_fips: 13217,
    county_fips_all: '13217|13159|13211',
    county: 'Newton',
    county_names_all: 'Newton|Jasper|Morgan',
    county_weights: '{"13217": 49.17, "13159": 38.87, "13211": 11.95}',
    density: 27.6,
    imprecise: false,
    latitude: 33.49055,
    longitude: -83.74224,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30055',
  },
  {
    city: 'Newborn',
    county_fips: 13159,
    county_fips_all: '13159|13211|13217',
    county: 'Jasper',
    county_names_all: 'Jasper|Morgan|Newton',
    county_weights: '{"13159": 47.85, "13211": 38.36, "13217": 13.8}',
    density: 20.7,
    imprecise: false,
    latitude: 33.49496,
    longitude: -83.65068,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30056',
  },
  {
    city: 'Lithonia',
    county_fips: 13089,
    county_fips_all: '13089|13247',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Rockdale',
    county_weights: '{"13089": 99.51, "13247": 0.49}',
    density: 791.8,
    imprecise: false,
    latitude: 33.7377,
    longitude: -84.10779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30058',
  },
  {
    city: 'Marietta',
    county_fips: 13067,
    county_fips_all: '13067',
    county: 'Cobb',
    county_names_all: 'Cobb',
    county_weights: '{"13067": 100}',
    density: 958.7,
    imprecise: false,
    latitude: 33.9209,
    longitude: -84.543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30060',
  },
  {
    city: 'Marietta',
    county_fips: 13067,
    county_fips_all: '13067',
    county: 'Cobb',
    county_names_all: 'Cobb',
    county_weights: '{"13067": 100}',
    density: 929.4,
    imprecise: false,
    latitude: 33.99977,
    longitude: -84.46899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30062',
  },
  {
    city: 'Marietta',
    county_fips: 13067,
    county_fips_all: '13067',
    county: 'Cobb',
    county_names_all: 'Cobb',
    county_weights: '{"13067": 100}',
    density: 655.1,
    imprecise: false,
    latitude: 33.93809,
    longitude: -84.61691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30064',
  },
  {
    city: 'Marietta',
    county_fips: 13067,
    county_fips_all: '13067',
    county: 'Cobb',
    county_names_all: 'Cobb',
    county_weights: '{"13067": 100}',
    density: 878.1,
    imprecise: false,
    latitude: 34.034,
    longitude: -84.50798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 61761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30066',
  },
  {
    city: 'Marietta',
    county_fips: 13067,
    county_fips_all: '13067',
    county: 'Cobb',
    county_names_all: 'Cobb',
    county_weights: '{"13067": 100}',
    density: 1270.1,
    imprecise: false,
    latitude: 33.93286,
    longitude: -84.46187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30067',
  },
  {
    city: 'Marietta',
    county_fips: 13067,
    county_fips_all: '13067|13121',
    county: 'Cobb',
    county_names_all: 'Cobb|Fulton',
    county_weights: '{"13067": 99.84, "13121": 0.16}',
    density: 908.3,
    imprecise: false,
    latitude: 33.96887,
    longitude: -84.43273,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30068',
  },
  {
    city: 'Porterdale',
    county_fips: 13217,
    county_fips_all: '13217',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"13217": 100}',
    density: 952,
    imprecise: false,
    latitude: 33.5733,
    longitude: -83.89546,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30070',
  },
  {
    city: 'Norcross',
    county_fips: 13135,
    county_fips_all: '13135',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett',
    county_weights: '{"13135": 100}',
    density: 824.4,
    imprecise: false,
    latitude: 33.93977,
    longitude: -84.20561,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30071',
  },
  {
    city: 'Pine Lake',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 2408.9,
    imprecise: false,
    latitude: 33.79115,
    longitude: -84.20598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30072',
  },
  {
    city: 'Roswell',
    county_fips: 13121,
    county_fips_all: '13121|13067|13057',
    county: 'Fulton',
    county_names_all: 'Fulton|Cobb|Cherokee',
    county_weights: '{"13121": 84.14, "13067": 14.13, "13057": 1.73}',
    density: 730.6,
    imprecise: false,
    latitude: 34.05282,
    longitude: -84.38739,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30075',
  },
  {
    city: 'Roswell',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 1109.5,
    imprecise: false,
    latitude: 34.02777,
    longitude: -84.31723,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30076',
  },
  {
    city: 'Snellville',
    county_fips: 13135,
    county_fips_all: '13135',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett',
    county_weights: '{"13135": 100}',
    density: 928,
    imprecise: false,
    latitude: 33.86118,
    longitude: -84.01795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30078',
  },
  {
    city: 'Scottdale',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 1591.3,
    imprecise: false,
    latitude: 33.79173,
    longitude: -84.25839,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30079',
  },
  {
    city: 'Smyrna',
    county_fips: 13067,
    county_fips_all: '13067',
    county: 'Cobb',
    county_names_all: 'Cobb',
    county_weights: '{"13067": 100}',
    density: 1632.2,
    imprecise: false,
    latitude: 33.87864,
    longitude: -84.5053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30080',
  },
  {
    city: 'Smyrna',
    county_fips: 13067,
    county_fips_all: '13067',
    county: 'Cobb',
    county_names_all: 'Cobb',
    county_weights: '{"13067": 100}',
    density: 1002,
    imprecise: false,
    latitude: 33.85517,
    longitude: -84.5373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30082',
  },
  {
    city: 'Stone Mountain',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 1356.2,
    imprecise: false,
    latitude: 33.79641,
    longitude: -84.19231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30083',
  },
  {
    city: 'Tucker',
    county_fips: 13089,
    county_fips_all: '13089|13135',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Gwinnett',
    county_weights: '{"13089": 82.43, "13135": 17.57}',
    density: 992.2,
    imprecise: false,
    latitude: 33.85457,
    longitude: -84.21657,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30084',
  },
  {
    city: 'Stone Mountain',
    county_fips: 13089,
    county_fips_all: '13089|13135',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Gwinnett',
    county_weights: '{"13089": 68.7, "13135": 31.3}',
    density: 665.2,
    imprecise: false,
    latitude: 33.81087,
    longitude: -84.13135,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30087',
  },
  {
    city: 'Stone Mountain',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 1439.6,
    imprecise: false,
    latitude: 33.75959,
    longitude: -84.17918,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30088',
  },
  {
    city: 'Peachtree Corners',
    county_fips: 13135,
    county_fips_all: '13135|13121',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett|Fulton',
    county_weights: '{"13135": 98.45, "13121": 1.55}',
    density: 1277.9,
    imprecise: false,
    latitude: 33.97145,
    longitude: -84.23537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30092',
  },
  {
    city: 'Norcross',
    county_fips: 13135,
    county_fips_all: '13135',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett',
    county_weights: '{"13135": 100}',
    density: 1492.9,
    imprecise: false,
    latitude: 33.90879,
    longitude: -84.17839,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30093',
  },
  {
    city: 'Conyers',
    county_fips: 13247,
    county_fips_all: '13247|13089',
    county: 'Rockdale',
    county_names_all: 'Rockdale|DeKalb',
    county_weights: '{"13247": 99.38, "13089": 0.62}',
    density: 331.5,
    imprecise: false,
    latitude: 33.61243,
    longitude: -84.0555,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30094',
  },
  {
    city: 'Duluth',
    county_fips: 13135,
    county_fips_all: '13135|13121',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett|Fulton',
    county_weights: '{"13135": 99.89, "13121": 0.11}',
    density: 1217.5,
    imprecise: false,
    latitude: 33.97691,
    longitude: -84.14791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30096',
  },
  {
    city: 'Duluth',
    county_fips: 13121,
    county_fips_all: '13121|13135|13117',
    county: 'Fulton',
    county_names_all: 'Fulton|Gwinnett|Forsyth',
    county_weights: '{"13121": 49.83, "13135": 42.86, "13117": 7.31}',
    density: 769.4,
    imprecise: false,
    latitude: 34.0271,
    longitude: -84.14702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30097',
  },
  {
    city: 'Acworth',
    county_fips: 13067,
    county_fips_all: '13067|13223|13015|13057',
    county: 'Cobb',
    county_names_all: 'Cobb|Paulding|Bartow|Cherokee',
    county_weights:
      '{"13067": 68.58, "13223": 25.33, "13015": 5.53, "13057": 0.56}',
    density: 590,
    imprecise: false,
    latitude: 34.04355,
    longitude: -84.71244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30101',
  },
  {
    city: 'Acworth',
    county_fips: 13057,
    county_fips_all: '13057|13015|13067',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Bartow|Cobb',
    county_weights: '{"13057": 46.4, "13015": 43.42, "13067": 10.18}',
    density: 556.7,
    imprecise: false,
    latitude: 34.10857,
    longitude: -84.64622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30102',
  },
  {
    city: 'Adairsville',
    county_fips: 13015,
    county_fips_all: '13015|13129|13115',
    county: 'Bartow',
    county_names_all: 'Bartow|Gordon|Floyd',
    county_weights: '{"13015": 68.56, "13129": 24.04, "13115": 7.4}',
    density: 54.3,
    imprecise: false,
    latitude: 34.36457,
    longitude: -84.92014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30103',
  },
  {
    city: 'Aragon',
    county_fips: 13233,
    county_fips_all: '13233|13115|13015',
    county: 'Polk',
    county_names_all: 'Polk|Floyd|Bartow',
    county_weights: '{"13233": 56.83, "13115": 30.93, "13015": 12.24}',
    density: 62.3,
    imprecise: false,
    latitude: 34.0879,
    longitude: -85.06982,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30104',
  },
  {
    city: 'Armuchee',
    county_fips: 13115,
    county_fips_all: '13115|13055',
    county: 'Floyd',
    county_names_all: 'Floyd|Chattooga',
    county_weights: '{"13115": 80.75, "13055": 19.25}',
    density: 15.5,
    imprecise: false,
    latitude: 34.47012,
    longitude: -85.15532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30105',
  },
  {
    city: 'Austell',
    county_fips: 13067,
    county_fips_all: '13067|13097',
    county: 'Cobb',
    county_names_all: 'Cobb|Douglas',
    county_weights: '{"13067": 97.46, "13097": 2.54}',
    density: 708.2,
    imprecise: false,
    latitude: 33.83476,
    longitude: -84.62947,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30106',
  },
  {
    city: 'Ball Ground',
    county_fips: 13057,
    county_fips_all: '13057|13227|13117',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Pickens|Forsyth',
    county_weights: '{"13057": 80.47, "13227": 14.97, "13117": 4.56}',
    density: 68.3,
    imprecise: false,
    latitude: 34.3352,
    longitude: -84.34744,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30107',
  },
  {
    city: 'Bowdon',
    county_fips: 13045,
    county_fips_all: '13045|13149',
    county: 'Carroll',
    county_names_all: 'Carroll|Heard',
    county_weights: '{"13045": 96.4, "13149": 3.6}',
    density: 29.2,
    imprecise: false,
    latitude: 33.53172,
    longitude: -85.26242,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30108',
  },
  {
    city: 'Bremen',
    county_fips: 13143,
    county_fips_all: '13143|13045',
    county: 'Haralson',
    county_names_all: 'Haralson|Carroll',
    county_weights: '{"13143": 89.43, "13045": 10.57}',
    density: 79.5,
    imprecise: false,
    latitude: 33.74071,
    longitude: -85.137,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30110',
  },
  {
    city: 'Clarkdale',
    county_fips: 13067,
    county_fips_all: '13067',
    county: 'Cobb',
    county_names_all: 'Cobb',
    county_weights: '{"13067": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.8318,
    longitude: -84.65499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30111',
  },
  {
    city: 'Buchanan',
    county_fips: 13143,
    county_fips_all: '13143|13233',
    county: 'Haralson',
    county_names_all: 'Haralson|Polk',
    county_weights: '{"13143": 92.38, "13233": 7.62}',
    density: 23.1,
    imprecise: false,
    latitude: 33.8531,
    longitude: -85.20967,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30113',
  },
  {
    city: 'Canton',
    county_fips: 13057,
    county_fips_all: '13057',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"13057": 100}',
    density: 253.1,
    imprecise: false,
    latitude: 34.24433,
    longitude: -84.5393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30114',
  },
  {
    city: 'Canton',
    county_fips: 13057,
    county_fips_all: '13057',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"13057": 100}',
    density: 283.3,
    imprecise: false,
    latitude: 34.21296,
    longitude: -84.40138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30115',
  },
  {
    city: 'Carrollton',
    county_fips: 13045,
    county_fips_all: '13045',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"13045": 100}',
    density: 81.6,
    imprecise: false,
    latitude: 33.55224,
    longitude: -85.01298,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30116',
  },
  {
    city: 'Carrollton',
    county_fips: 13045,
    county_fips_all: '13045',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"13045": 100}',
    density: 142.2,
    imprecise: false,
    latitude: 33.58113,
    longitude: -85.13197,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30117',
  },
  {
    city: 'Cartersville',
    county_fips: 13015,
    county_fips_all: '13015|13223',
    county: 'Bartow',
    county_names_all: 'Bartow|Paulding',
    county_weights: '{"13015": 99.62, "13223": 0.38}',
    density: 186.4,
    imprecise: false,
    latitude: 34.16639,
    longitude: -84.85597,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30120',
  },
  {
    city: 'Cartersville',
    county_fips: 13015,
    county_fips_all: '13015',
    county: 'Bartow',
    county_names_all: 'Bartow',
    county_weights: '{"13015": 100}',
    density: 173.9,
    imprecise: false,
    latitude: 34.21073,
    longitude: -84.77802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30121',
  },
  {
    city: 'Lithia Springs',
    county_fips: 13097,
    county_fips_all: '13097|13067',
    county: 'Douglas',
    county_names_all: 'Douglas|Cobb',
    county_weights: '{"13097": 99.38, "13067": 0.62}',
    density: 421.9,
    imprecise: false,
    latitude: 33.76329,
    longitude: -84.6386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30122',
  },
  {
    city: 'Cave Spring',
    county_fips: 13115,
    county_fips_all: '13115|13233',
    county: 'Floyd',
    county_names_all: 'Floyd|Polk',
    county_weights: '{"13115": 98.94, "13233": 1.06}',
    density: 16.7,
    imprecise: false,
    latitude: 34.12872,
    longitude: -85.35589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30124',
  },
  {
    city: 'Cedartown',
    county_fips: 13233,
    county_fips_all: '13233|13115|13143',
    county: 'Polk',
    county_names_all: 'Polk|Floyd|Haralson',
    county_weights: '{"13233": 97.27, "13115": 2.22, "13143": 0.51}',
    density: 51.5,
    imprecise: false,
    latitude: 34.00067,
    longitude: -85.27331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30125',
  },
  {
    city: 'Mableton',
    county_fips: 13067,
    county_fips_all: '13067|13121',
    county: 'Cobb',
    county_names_all: 'Cobb|Fulton',
    county_weights: '{"13067": 99.81, "13121": 0.19}',
    density: 787.2,
    imprecise: false,
    latitude: 33.81588,
    longitude: -84.55171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30126',
  },
  {
    city: 'Powder Springs',
    county_fips: 13067,
    county_fips_all: '13067|13223',
    county: 'Cobb',
    county_names_all: 'Cobb|Paulding',
    county_weights: '{"13067": 84.55, "13223": 15.45}',
    density: 538.8,
    imprecise: false,
    latitude: 33.87647,
    longitude: -84.69648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30127',
  },
  {
    city: 'Dallas',
    county_fips: 13223,
    county_fips_all: '13223',
    county: 'Paulding',
    county_names_all: 'Paulding',
    county_weights: '{"13223": 100}',
    density: 201.1,
    imprecise: false,
    latitude: 33.99042,
    longitude: -84.85279,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30132',
  },
  {
    city: 'Douglasville',
    county_fips: 13097,
    county_fips_all: '13097|13223',
    county: 'Douglas',
    county_names_all: 'Douglas|Paulding',
    county_weights: '{"13097": 67.5, "13223": 32.5}',
    density: 352.8,
    imprecise: false,
    latitude: 33.77436,
    longitude: -84.78241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30134',
  },
  {
    city: 'Douglasville',
    county_fips: 13097,
    county_fips_all: '13097|13121',
    county: 'Douglas',
    county_names_all: 'Douglas|Fulton',
    county_weights: '{"13097": 99.83, "13121": 0.17}',
    density: 308.5,
    imprecise: false,
    latitude: 33.67285,
    longitude: -84.74523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30135',
  },
  {
    city: 'Emerson',
    county_fips: 13015,
    county_fips_all: '13015',
    county: 'Bartow',
    county_names_all: 'Bartow',
    county_weights: '{"13015": 100}',
    density: 206.8,
    imprecise: false,
    latitude: 34.11657,
    longitude: -84.7657,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30137',
  },
  {
    city: 'Fairmount',
    county_fips: 13129,
    county_fips_all: '13129|13227|13015',
    county: 'Gordon',
    county_names_all: 'Gordon|Pickens|Bartow',
    county_weights: '{"13129": 60.23, "13227": 21.71, "13015": 18.06}',
    density: 25.8,
    imprecise: false,
    latitude: 34.43346,
    longitude: -84.70575,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30139',
  },
  {
    city: 'Hiram',
    county_fips: 13223,
    county_fips_all: '13223|13067',
    county: 'Paulding',
    county_names_all: 'Paulding|Cobb',
    county_weights: '{"13223": 99.74, "13067": 0.26}',
    density: 380.5,
    imprecise: false,
    latitude: 33.86244,
    longitude: -84.77521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30141',
  },
  {
    city: 'Jasper',
    county_fips: 13227,
    county_fips_all: '13227|13085|13057',
    county: 'Pickens',
    county_names_all: 'Pickens|Dawson|Cherokee',
    county_weights: '{"13227": 88.09, "13085": 9.89, "13057": 2.02}',
    density: 70.7,
    imprecise: false,
    latitude: 34.46198,
    longitude: -84.42385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30143',
  },
  {
    city: 'Kennesaw',
    county_fips: 13067,
    county_fips_all: '13067',
    county: 'Cobb',
    county_names_all: 'Cobb',
    county_weights: '{"13067": 100}',
    density: 1041,
    imprecise: false,
    latitude: 34.03672,
    longitude: -84.59174,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30144',
  },
  {
    city: 'Kingston',
    county_fips: 13015,
    county_fips_all: '13015|13115',
    county: 'Bartow',
    county_names_all: 'Bartow|Floyd',
    county_weights: '{"13015": 82.0, "13115": 18.0}',
    density: 46.7,
    imprecise: false,
    latitude: 34.24177,
    longitude: -84.98076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30145',
  },
  {
    city: 'Lindale',
    county_fips: 13115,
    county_fips_all: '13115|13233',
    county: 'Floyd',
    county_names_all: 'Floyd|Polk',
    county_weights: '{"13115": 92.54, "13233": 7.46}',
    density: 95.3,
    imprecise: false,
    latitude: 34.13751,
    longitude: -85.21877,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30147',
  },
  {
    city: 'Marble Hill',
    county_fips: 13085,
    county_fips_all: '13085|13227',
    county: 'Dawson',
    county_names_all: 'Dawson|Pickens',
    county_weights: '{"13085": 54.36, "13227": 45.64}',
    density: 38.1,
    imprecise: false,
    latitude: 34.46009,
    longitude: -84.2648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30148',
  },
  {
    city: 'Kennesaw',
    county_fips: 13067,
    county_fips_all: '13067',
    county: 'Cobb',
    county_names_all: 'Cobb',
    county_weights: '{"13067": 100}',
    density: 777.9,
    imprecise: false,
    latitude: 33.99435,
    longitude: -84.6474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30152',
  },
  {
    city: 'Rockmart',
    county_fips: 13233,
    county_fips_all: '13233|13223|13143',
    county: 'Polk',
    county_names_all: 'Polk|Paulding|Haralson',
    county_weights: '{"13233": 70.91, "13223": 19.95, "13143": 9.14}',
    density: 57.9,
    imprecise: false,
    latitude: 33.96678,
    longitude: -85.05425,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30153',
  },
  {
    city: 'Dallas',
    county_fips: 13223,
    county_fips_all: '13223|13067',
    county: 'Paulding',
    county_names_all: 'Paulding|Cobb',
    county_weights: '{"13223": 99.0, "13067": 1.0}',
    density: 242.5,
    imprecise: false,
    latitude: 33.88641,
    longitude: -84.8731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30157',
  },
  {
    city: 'Rome',
    county_fips: 13115,
    county_fips_all: '13115|13015',
    county: 'Floyd',
    county_names_all: 'Floyd|Bartow',
    county_weights: '{"13115": 98.5, "13015": 1.5}',
    density: 93.5,
    imprecise: false,
    latitude: 34.23758,
    longitude: -85.17319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30161',
  },
  {
    city: 'Rome',
    county_fips: 13115,
    county_fips_all: '13115|01019|13055',
    county: 'Floyd',
    county_names_all: 'Floyd|Cherokee|Chattooga',
    county_weights: '{"13115": 98.15, "01019": 0.93, "13055": 0.92}',
    density: 99.4,
    imprecise: false,
    latitude: 34.30279,
    longitude: -85.27233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30165',
  },
  {
    city: 'Austell',
    county_fips: 13067,
    county_fips_all: '13067|13097',
    county: 'Cobb',
    county_names_all: 'Cobb|Douglas',
    county_weights: '{"13067": 90.46, "13097": 9.54}',
    density: 830.8,
    imprecise: false,
    latitude: 33.78354,
    longitude: -84.58765,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30168',
  },
  {
    city: 'Roopville',
    county_fips: 13045,
    county_fips_all: '13045|13149',
    county: 'Carroll',
    county_names_all: 'Carroll|Heard',
    county_weights: '{"13045": 52.09, "13149": 47.91}',
    density: 31.7,
    imprecise: false,
    latitude: 33.43065,
    longitude: -85.16821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30170',
  },
  {
    city: 'Rydal',
    county_fips: 13015,
    county_fips_all: '13015|13129',
    county: 'Bartow',
    county_names_all: 'Bartow|Gordon',
    county_weights: '{"13015": 85.85, "13129": 14.15}',
    density: 30.5,
    imprecise: false,
    latitude: 34.36122,
    longitude: -84.73584,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30171',
  },
  {
    city: 'Silver Creek',
    county_fips: 13115,
    county_fips_all: '13115|13233',
    county: 'Floyd',
    county_names_all: 'Floyd|Polk',
    county_weights: '{"13115": 90.38, "13233": 9.62}',
    density: 77.6,
    imprecise: false,
    latitude: 34.13541,
    longitude: -85.14217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30173',
  },
  {
    city: 'Talking Rock',
    county_fips: 13227,
    county_fips_all: '13227|13123',
    county: 'Pickens',
    county_names_all: 'Pickens|Gilmer',
    county_weights: '{"13227": 57.21, "13123": 42.79}',
    density: 27,
    imprecise: false,
    latitude: 34.54239,
    longitude: -84.52793,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30175',
  },
  {
    city: 'Tallapoosa',
    county_fips: 13143,
    county_fips_all: '13143',
    county: 'Haralson',
    county_names_all: 'Haralson',
    county_weights: '{"13143": 100}',
    density: 32.8,
    imprecise: false,
    latitude: 33.76972,
    longitude: -85.30398,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30176',
  },
  {
    city: 'Tate',
    county_fips: 13227,
    county_fips_all: '13227',
    county: 'Pickens',
    county_names_all: 'Pickens',
    county_weights: '{"13227": 100}',
    density: 83.4,
    imprecise: false,
    latitude: 34.40705,
    longitude: -84.37401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30177',
  },
  {
    city: 'Taylorsville',
    county_fips: 13015,
    county_fips_all: '13015|13233|13223',
    county: 'Bartow',
    county_names_all: 'Bartow|Polk|Paulding',
    county_weights: '{"13015": 60.87, "13233": 22.37, "13223": 16.76}',
    density: 29,
    imprecise: false,
    latitude: 34.09709,
    longitude: -84.97051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30178',
  },
  {
    city: 'Temple',
    county_fips: 13045,
    county_fips_all: '13045|13223|13143',
    county: 'Carroll',
    county_names_all: 'Carroll|Paulding|Haralson',
    county_weights: '{"13045": 52.01, "13223": 27.16, "13143": 20.83}',
    density: 104.7,
    imprecise: false,
    latitude: 33.78088,
    longitude: -85.01961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30179',
  },
  {
    city: 'Villa Rica',
    county_fips: 13045,
    county_fips_all: '13045|13097|13223',
    county: 'Carroll',
    county_names_all: 'Carroll|Douglas|Paulding',
    county_weights: '{"13045": 62.78, "13097": 27.52, "13223": 9.7}',
    density: 214.5,
    imprecise: false,
    latitude: 33.72018,
    longitude: -84.91956,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30180',
  },
  {
    city: 'Waco',
    county_fips: 13045,
    county_fips_all: '13045|13143',
    county: 'Carroll',
    county_names_all: 'Carroll|Haralson',
    county_weights: '{"13045": 63.54, "13143": 36.46}',
    density: 42.3,
    imprecise: false,
    latitude: 33.65603,
    longitude: -85.24628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30182',
  },
  {
    city: 'Waleska',
    county_fips: 13057,
    county_fips_all: '13057|13227|13015',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Pickens|Bartow',
    county_weights: '{"13057": 95.95, "13227": 3.61, "13015": 0.44}',
    density: 38.6,
    imprecise: false,
    latitude: 34.33854,
    longitude: -84.59762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30183',
  },
  {
    city: 'White',
    county_fips: 13015,
    county_fips_all: '13015|13057',
    county: 'Bartow',
    county_names_all: 'Bartow|Cherokee',
    county_weights: '{"13015": 89.54, "13057": 10.46}',
    density: 36,
    imprecise: false,
    latitude: 34.26042,
    longitude: -84.71603,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30184',
  },
  {
    city: 'Whitesburg',
    county_fips: 13045,
    county_fips_all: '13045|13097|13121',
    county: 'Carroll',
    county_names_all: 'Carroll|Douglas|Fulton',
    county_weights: '{"13045": 95.38, "13097": 4.5, "13121": 0.12}',
    density: 28.5,
    imprecise: false,
    latitude: 33.51975,
    longitude: -84.90879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30185',
  },
  {
    city: 'Winston',
    county_fips: 13097,
    county_fips_all: '13097|13045',
    county: 'Douglas',
    county_names_all: 'Douglas|Carroll',
    county_weights: '{"13097": 98.51, "13045": 1.49}',
    density: 99.8,
    imprecise: false,
    latitude: 33.65736,
    longitude: -84.85454,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30187',
  },
  {
    city: 'Woodstock',
    county_fips: 13057,
    county_fips_all: '13057|13067|13121',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Cobb|Fulton',
    county_weights: '{"13057": 98.91, "13067": 0.99, "13121": 0.1}',
    density: 614.5,
    imprecise: false,
    latitude: 34.11873,
    longitude: -84.45526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30188',
  },
  {
    city: 'Woodstock',
    county_fips: 13057,
    county_fips_all: '13057',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"13057": 100}',
    density: 801.9,
    imprecise: false,
    latitude: 34.12835,
    longitude: -84.57148,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30189',
  },
  {
    city: 'Barnesville',
    county_fips: 13171,
    county_fips_all: '13171|13293|13207',
    county: 'Lamar',
    county_names_all: 'Lamar|Upson|Monroe',
    county_weights: '{"13171": 91.93, "13293": 4.15, "13207": 3.92}',
    density: 42,
    imprecise: false,
    latitude: 33.05844,
    longitude: -84.12343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30204',
  },
  {
    city: 'Brooks',
    county_fips: 13113,
    county_fips_all: '13113|13255',
    county: 'Fayette',
    county_names_all: 'Fayette|Spalding',
    county_weights: '{"13113": 60.8, "13255": 39.2}',
    density: 30.3,
    imprecise: false,
    latitude: 33.26911,
    longitude: -84.46634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30205',
  },
  {
    city: 'Concord',
    county_fips: 13231,
    county_fips_all: '13231',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"13231": 100}',
    density: 25.9,
    imprecise: false,
    latitude: 33.09671,
    longitude: -84.46303,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30206',
  },
  {
    city: 'Fairburn',
    county_fips: 13121,
    county_fips_all: '13121|13113',
    county: 'Fulton',
    county_names_all: 'Fulton|Fayette',
    county_weights: '{"13121": 99.61, "13113": 0.39}',
    density: 314.5,
    imprecise: false,
    latitude: 33.59113,
    longitude: -84.6333,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30213',
  },
  {
    city: 'Fayetteville',
    county_fips: 13113,
    county_fips_all: '13113|13121',
    county: 'Fayette',
    county_names_all: 'Fayette|Fulton',
    county_weights: '{"13113": 99.63, "13121": 0.37}',
    density: 233.1,
    imprecise: false,
    latitude: 33.49222,
    longitude: -84.48697,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30214',
  },
  {
    city: 'Fayetteville',
    county_fips: 13113,
    county_fips_all: '13113|13063',
    county: 'Fayette',
    county_names_all: 'Fayette|Clayton',
    county_weights: '{"13113": 97.69, "13063": 2.31}',
    density: 220.5,
    imprecise: false,
    latitude: 33.3888,
    longitude: -84.45709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30215',
  },
  {
    city: 'Flovilla',
    county_fips: 13035,
    county_fips_all: '13035|13207',
    county: 'Butts',
    county_names_all: 'Butts|Monroe',
    county_weights: '{"13035": 99.88, "13207": 0.12}',
    density: 31.7,
    imprecise: false,
    latitude: 33.23951,
    longitude: -83.88162,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30216',
  },
  {
    city: 'Franklin',
    county_fips: 13149,
    county_fips_all: '13149|13285',
    county: 'Heard',
    county_names_all: 'Heard|Troup',
    county_weights: '{"13149": 96.73, "13285": 3.27}',
    density: 14.2,
    imprecise: false,
    latitude: 33.28671,
    longitude: -85.13309,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30217',
  },
  {
    city: 'Gay',
    county_fips: 13199,
    county_fips_all: '13199',
    county: 'Meriwether',
    county_names_all: 'Meriwether',
    county_weights: '{"13199": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 33.12706,
    longitude: -84.58093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30218',
  },
  {
    city: 'Grantville',
    county_fips: 13077,
    county_fips_all: '13077|13199',
    county: 'Coweta',
    county_names_all: 'Coweta|Meriwether',
    county_weights: '{"13077": 56.63, "13199": 43.37}',
    density: 40.7,
    imprecise: false,
    latitude: 33.22849,
    longitude: -84.82463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30220',
  },
  {
    city: 'Greenville',
    county_fips: 13199,
    county_fips_all: '13199',
    county: 'Meriwether',
    county_names_all: 'Meriwether',
    county_weights: '{"13199": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 33.04113,
    longitude: -84.74294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30222',
  },
  {
    city: 'Griffin',
    county_fips: 13255,
    county_fips_all: '13255',
    county: 'Spalding',
    county_names_all: 'Spalding',
    county_weights: '{"13255": 100}',
    density: 136.8,
    imprecise: false,
    latitude: 33.28635,
    longitude: -84.28012,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30223',
  },
  {
    city: 'Griffin',
    county_fips: 13255,
    county_fips_all: '13255|13231|13171',
    county: 'Spalding',
    county_names_all: 'Spalding|Pike|Lamar',
    county_weights: '{"13255": 74.69, "13231": 15.19, "13171": 10.12}',
    density: 162.1,
    imprecise: false,
    latitude: 33.20411,
    longitude: -84.23587,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30224',
  },
  {
    city: 'Hampton',
    county_fips: 13151,
    county_fips_all: '13151|13063|13255',
    county: 'Henry',
    county_names_all: 'Henry|Clayton|Spalding',
    county_weights: '{"13151": 66.1, "13063": 28.24, "13255": 5.66}',
    density: 276.7,
    imprecise: false,
    latitude: 33.40374,
    longitude: -84.30575,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30228',
  },
  {
    city: 'Haralson',
    county_fips: 13077,
    county_fips_all: '13077',
    county: 'Coweta',
    county_names_all: 'Coweta',
    county_weights: '{"13077": 100}',
    density: 525.5,
    imprecise: false,
    latitude: 33.22791,
    longitude: -84.57033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30229',
  },
  {
    city: 'Hogansville',
    county_fips: 13285,
    county_fips_all: '13285|13199|13149|13077',
    county: 'Troup',
    county_names_all: 'Troup|Meriwether|Heard|Coweta',
    county_weights:
      '{"13285": 56.3, "13199": 22.01, "13149": 16.59, "13077": 5.1}',
    density: 24.3,
    imprecise: false,
    latitude: 33.16699,
    longitude: -84.92071,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30230',
  },
  {
    city: 'Jackson',
    county_fips: 13035,
    county_fips_all: '13035|13207|13151|13171|13217',
    county: 'Butts',
    county_names_all: 'Butts|Monroe|Henry|Lamar|Newton',
    county_weights:
      '{"13035": 86.71, "13207": 5.76, "13151": 4.36, "13171": 2.99, "13217": 0.18}',
    density: 64.6,
    imprecise: false,
    latitude: 33.29492,
    longitude: -83.97501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30233',
  },
  {
    city: 'Jenkinsburg',
    county_fips: 13035,
    county_fips_all: '13035|13151',
    county: 'Butts',
    county_names_all: 'Butts|Henry',
    county_weights: '{"13035": 93.51, "13151": 6.49}',
    density: 81.6,
    imprecise: false,
    latitude: 33.33001,
    longitude: -84.02617,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30234',
  },
  {
    city: 'Jonesboro',
    county_fips: 13063,
    county_fips_all: '13063|13151',
    county: 'Clayton',
    county_names_all: 'Clayton|Henry',
    county_weights: '{"13063": 89.89, "13151": 10.11}',
    density: 597.1,
    imprecise: false,
    latitude: 33.52157,
    longitude: -84.32405,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30236',
  },
  {
    city: 'Jonesboro',
    county_fips: 13063,
    county_fips_all: '13063|13113',
    county: 'Clayton',
    county_names_all: 'Clayton|Fayette',
    county_weights: '{"13063": 86.1, "13113": 13.9}',
    density: 963.8,
    imprecise: false,
    latitude: 33.4949,
    longitude: -84.38181,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30238',
  },
  {
    city: 'Lagrange',
    county_fips: 13285,
    county_fips_all: '13285|13149',
    county: 'Troup',
    county_names_all: 'Troup|Heard',
    county_weights: '{"13285": 99.82, "13149": 0.18}',
    density: 86.5,
    imprecise: false,
    latitude: 33.03757,
    longitude: -85.12222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30240',
  },
  {
    city: 'Lagrange',
    county_fips: 13285,
    county_fips_all: '13285',
    county: 'Troup',
    county_names_all: 'Troup',
    county_weights: '{"13285": 100}',
    density: 88.7,
    imprecise: false,
    latitude: 33.02115,
    longitude: -84.95285,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30241',
  },
  {
    city: 'Locust Grove',
    county_fips: 13151,
    county_fips_all: '13151|13035|13255',
    county: 'Henry',
    county_names_all: 'Henry|Butts|Spalding',
    county_weights: '{"13151": 83.9, "13035": 8.07, "13255": 8.03}',
    density: 196.9,
    imprecise: false,
    latitude: 33.34975,
    longitude: -84.10838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30248',
  },
  {
    city: 'Lovejoy',
    county_fips: 13063,
    county_fips_all: '13063',
    county: 'Clayton',
    county_names_all: 'Clayton',
    county_weights: '{"13063": 100}',
    density: 8107.5,
    imprecise: false,
    latitude: 33.43473,
    longitude: -84.30603,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30250',
  },
  {
    city: 'Luthersville',
    county_fips: 13199,
    county_fips_all: '13199|13077',
    county: 'Meriwether',
    county_names_all: 'Meriwether|Coweta',
    county_weights: '{"13199": 97.18, "13077": 2.82}',
    density: 26,
    imprecise: false,
    latitude: 33.18871,
    longitude: -84.69983,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30251',
  },
  {
    city: 'Mcdonough',
    county_fips: 13151,
    county_fips_all: '13151|13247',
    county: 'Henry',
    county_names_all: 'Henry|Rockdale',
    county_weights: '{"13151": 94.99, "13247": 5.01}',
    density: 203.4,
    imprecise: false,
    latitude: 33.47206,
    longitude: -84.06416,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30252',
  },
  {
    city: 'Mcdonough',
    county_fips: 13151,
    county_fips_all: '13151',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"13151": 100}',
    density: 533.7,
    imprecise: false,
    latitude: 33.45028,
    longitude: -84.18579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30253',
  },
  {
    city: 'Meansville',
    county_fips: 13231,
    county_fips_all: '13231|13293|13171',
    county: 'Pike',
    county_names_all: 'Pike|Upson|Lamar',
    county_weights: '{"13231": 70.94, "13293": 20.54, "13171": 8.52}',
    density: 30.7,
    imprecise: false,
    latitude: 33.01654,
    longitude: -84.31515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30256',
  },
  {
    city: 'Milner',
    county_fips: 13171,
    county_fips_all: '13171|13231',
    county: 'Lamar',
    county_names_all: 'Lamar|Pike',
    county_weights: '{"13171": 90.92, "13231": 9.08}',
    density: 42.1,
    imprecise: false,
    latitude: 33.14218,
    longitude: -84.18606,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30257',
  },
  {
    city: 'Molena',
    county_fips: 13231,
    county_fips_all: '13231|13293',
    county: 'Pike',
    county_names_all: 'Pike|Upson',
    county_weights: '{"13231": 61.8, "13293": 38.2}',
    density: 18.7,
    imprecise: false,
    latitude: 32.99278,
    longitude: -84.47024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30258',
  },
  {
    city: 'Moreland',
    county_fips: 13077,
    county_fips_all: '13077',
    county: 'Coweta',
    county_names_all: 'Coweta',
    county_weights: '{"13077": 100}',
    density: 44.5,
    imprecise: false,
    latitude: 33.26522,
    longitude: -84.74073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30259',
  },
  {
    city: 'Morrow',
    county_fips: 13063,
    county_fips_all: '13063',
    county: 'Clayton',
    county_names_all: 'Clayton',
    county_weights: '{"13063": 100}',
    density: 1016.3,
    imprecise: false,
    latitude: 33.5862,
    longitude: -84.33046,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30260',
  },
  {
    city: 'Newnan',
    county_fips: 13077,
    county_fips_all: '13077|13149',
    county: 'Coweta',
    county_names_all: 'Coweta|Heard',
    county_weights: '{"13077": 99.48, "13149": 0.52}',
    density: 120.2,
    imprecise: false,
    latitude: 33.38852,
    longitude: -84.85911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 61695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30263',
  },
  {
    city: 'Newnan',
    county_fips: 13077,
    county_fips_all: '13077',
    county: 'Coweta',
    county_names_all: 'Coweta',
    county_weights: '{"13077": 100}',
    density: 350.5,
    imprecise: false,
    latitude: 33.41649,
    longitude: -84.70749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30265',
  },
  {
    city: 'Palmetto',
    county_fips: 13121,
    county_fips_all: '13121|13077',
    county: 'Fulton',
    county_names_all: 'Fulton|Coweta',
    county_weights: '{"13121": 87.24, "13077": 12.76}',
    density: 60.7,
    imprecise: false,
    latitude: 33.54357,
    longitude: -84.72262,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30268',
  },
  {
    city: 'Peachtree City',
    county_fips: 13113,
    county_fips_all: '13113',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"13113": 100}',
    density: 597.9,
    imprecise: false,
    latitude: 33.39375,
    longitude: -84.56974,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30269',
  },
  {
    city: 'Red Oak',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.62313,
    longitude: -84.50175,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30272',
  },
  {
    city: 'Rex',
    county_fips: 13063,
    county_fips_all: '13063|13151',
    county: 'Clayton',
    county_names_all: 'Clayton|Henry',
    county_weights: '{"13063": 85.7, "13151": 14.3}',
    density: 964.5,
    imprecise: false,
    latitude: 33.58365,
    longitude: -84.27208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30273',
  },
  {
    city: 'Riverdale',
    county_fips: 13063,
    county_fips_all: '13063',
    county: 'Clayton',
    county_names_all: 'Clayton',
    county_weights: '{"13063": 100}',
    density: 1288.7,
    imprecise: false,
    latitude: 33.55583,
    longitude: -84.40091,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30274',
  },
  {
    city: 'Sargent',
    county_fips: 13077,
    county_fips_all: '13077',
    county: 'Coweta',
    county_names_all: 'Coweta',
    county_weights: '{"13077": 100}',
    density: 2909.8,
    imprecise: false,
    latitude: 33.43066,
    longitude: -84.86798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30275',
  },
  {
    city: 'Senoia',
    county_fips: 13077,
    county_fips_all: '13077|13199|13113',
    county: 'Coweta',
    county_names_all: 'Coweta|Meriwether|Fayette',
    county_weights: '{"13077": 76.88, "13199": 18.91, "13113": 4.21}',
    density: 80.2,
    imprecise: false,
    latitude: 33.26552,
    longitude: -84.582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30276',
  },
  {
    city: 'Sharpsburg',
    county_fips: 13077,
    county_fips_all: '13077',
    county: 'Coweta',
    county_names_all: 'Coweta',
    county_weights: '{"13077": 100}',
    density: 183.3,
    imprecise: false,
    latitude: 33.37962,
    longitude: -84.64767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30277',
  },
  {
    city: 'Stockbridge',
    county_fips: 13151,
    county_fips_all: '13151|13247|13063',
    county: 'Henry',
    county_names_all: 'Henry|Rockdale|Clayton',
    county_weights: '{"13151": 79.24, "13247": 19.15, "13063": 1.61}',
    density: 399.1,
    imprecise: false,
    latitude: 33.56338,
    longitude: -84.1961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30281',
  },
  {
    city: 'Sunny Side',
    county_fips: 13255,
    county_fips_all: '13255',
    county: 'Spalding',
    county_names_all: 'Spalding',
    county_weights: '{"13255": 100}',
    density: 98.4,
    imprecise: false,
    latitude: 33.34032,
    longitude: -84.28858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30284',
  },
  {
    city: 'The Rock',
    county_fips: 13293,
    county_fips_all: '13293|13171|13231',
    county: 'Upson',
    county_names_all: 'Upson|Lamar|Pike',
    county_weights: '{"13293": 61.8, "13171": 20.94, "13231": 17.26}',
    density: 14.2,
    imprecise: false,
    latitude: 32.98647,
    longitude: -84.25255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30285',
  },
  {
    city: 'Thomaston',
    county_fips: 13293,
    county_fips_all: '13293',
    county: 'Upson',
    county_names_all: 'Upson',
    county_weights: '{"13293": 100}',
    density: 47.9,
    imprecise: false,
    latitude: 32.88078,
    longitude: -84.33334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30286',
  },
  {
    city: 'Conley',
    county_fips: 13089,
    county_fips_all: '13089|13063|13121',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Clayton|Fulton',
    county_weights: '{"13089": 70.93, "13063": 28.93, "13121": 0.14}',
    density: 450.7,
    imprecise: false,
    latitude: 33.65502,
    longitude: -84.32813,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30288',
  },
  {
    city: 'Turin',
    county_fips: 13077,
    county_fips_all: '13077',
    county: 'Coweta',
    county_names_all: 'Coweta',
    county_weights: '{"13077": 100}',
    density: 1376.3,
    imprecise: false,
    latitude: 33.32358,
    longitude: -84.63368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30289',
  },
  {
    city: 'Tyrone',
    county_fips: 13113,
    county_fips_all: '13113|13077',
    county: 'Fayette',
    county_names_all: 'Fayette|Coweta',
    county_weights: '{"13113": 99.83, "13077": 0.17}',
    density: 201.5,
    imprecise: false,
    latitude: 33.47675,
    longitude: -84.58804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30290',
  },
  {
    city: 'Union City',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 900.2,
    imprecise: false,
    latitude: 33.57569,
    longitude: -84.5408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30291',
  },
  {
    city: 'Williamson',
    county_fips: 13231,
    county_fips_all: '13231|13255',
    county: 'Pike',
    county_names_all: 'Pike|Spalding',
    county_weights: '{"13231": 77.66, "13255": 22.34}',
    density: 42.5,
    imprecise: false,
    latitude: 33.17207,
    longitude: -84.39438,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30292',
  },
  {
    city: 'Woodbury',
    county_fips: 13199,
    county_fips_all: '13199',
    county: 'Meriwether',
    county_names_all: 'Meriwether',
    county_weights: '{"13199": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 32.97581,
    longitude: -84.59612,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30293',
  },
  {
    city: 'Ellenwood',
    county_fips: 13089,
    county_fips_all: '13089|13063|13151|13247',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Clayton|Henry|Rockdale',
    county_weights:
      '{"13089": 36.3, "13063": 35.19, "13151": 27.36, "13247": 1.15}',
    density: 495.1,
    imprecise: false,
    latitude: 33.6371,
    longitude: -84.26289,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30294',
  },
  {
    city: 'Zebulon',
    county_fips: 13231,
    county_fips_all: '13231|13171',
    county: 'Pike',
    county_names_all: 'Pike|Lamar',
    county_weights: '{"13231": 97.37, "13171": 2.63}',
    density: 45.3,
    imprecise: false,
    latitude: 33.09319,
    longitude: -84.31819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30295',
  },
  {
    city: 'Riverdale',
    county_fips: 13063,
    county_fips_all: '13063|13121',
    county: 'Clayton',
    county_names_all: 'Clayton|Fulton',
    county_weights: '{"13063": 79.96, "13121": 20.04}',
    density: 1000.1,
    imprecise: false,
    latitude: 33.56351,
    longitude: -84.44254,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30296',
  },
  {
    city: 'Forest Park',
    county_fips: 13063,
    county_fips_all: '13063',
    county: 'Clayton',
    county_names_all: 'Clayton',
    county_weights: '{"13063": 100}',
    density: 1029.6,
    imprecise: false,
    latitude: 33.61511,
    longitude: -84.37145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30297',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 2531.3,
    imprecise: false,
    latitude: 33.75284,
    longitude: -84.39028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30303',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 1670.8,
    imprecise: false,
    latitude: 33.83518,
    longitude: -84.38931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30305',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121|13089',
    county: 'Fulton',
    county_names_all: 'Fulton|DeKalb',
    county_weights: '{"13121": 57.67, "13089": 42.33}',
    density: 2050.2,
    imprecise: false,
    latitude: 33.78867,
    longitude: -84.35136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30306',
  },
  {
    city: 'Atlanta',
    county_fips: 13089,
    county_fips_all: '13089|13121',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Fulton',
    county_weights: '{"13089": 82.16, "13121": 17.84}',
    density: 1843.9,
    imprecise: false,
    latitude: 33.77053,
    longitude: -84.33419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30307',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 5602.2,
    imprecise: false,
    latitude: 33.77094,
    longitude: -84.37773,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30308',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 3789.9,
    imprecise: false,
    latitude: 33.798,
    longitude: -84.38774,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30309',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 1221.9,
    imprecise: false,
    latitude: 33.72695,
    longitude: -84.42726,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30310',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 1083.5,
    imprecise: false,
    latitude: 33.72345,
    longitude: -84.47442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30311',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 3142,
    imprecise: false,
    latitude: 33.74463,
    longitude: -84.37577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30312',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 3587.5,
    imprecise: false,
    latitude: 33.76369,
    longitude: -84.39761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30313',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 1974.9,
    imprecise: false,
    latitude: 33.75787,
    longitude: -84.43193,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30314',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121|13089',
    county: 'Fulton',
    county_names_all: 'Fulton|DeKalb',
    county_weights: '{"13121": 99.28, "13089": 0.72}',
    density: 1153.5,
    imprecise: false,
    latitude: 33.70312,
    longitude: -84.38272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30315',
  },
  {
    city: 'Atlanta',
    county_fips: 13089,
    county_fips_all: '13089|13121',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Fulton',
    county_weights: '{"13089": 84.31, "13121": 15.69}',
    density: 1039.2,
    imprecise: false,
    latitude: 33.71277,
    longitude: -84.33218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30316',
  },
  {
    city: 'Atlanta',
    county_fips: 13089,
    county_fips_all: '13089|13121',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Fulton',
    county_weights: '{"13089": 99.8, "13121": 0.2}',
    density: 1704.5,
    imprecise: false,
    latitude: 33.74913,
    longitude: -84.31537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30317',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 1133.3,
    imprecise: false,
    latitude: 33.79235,
    longitude: -84.44831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30318',
  },
  {
    city: 'Atlanta',
    county_fips: 13089,
    county_fips_all: '13089|13121',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Fulton',
    county_weights: '{"13089": 85.32, "13121": 14.68}',
    density: 1721,
    imprecise: false,
    latitude: 33.87875,
    longitude: -84.33596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30319',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121|13089',
    county: 'Fulton',
    county_names_all: 'Fulton|DeKalb',
    county_weights: '{"13121": 75.18, "13089": 24.82}',
    density: 2126.1,
    imprecise: false,
    latitude: 33.8196,
    longitude: -84.3572,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30324',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 4217.6,
    imprecise: false,
    latitude: 33.84957,
    longitude: -84.36342,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30326',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 523.2,
    imprecise: false,
    latitude: 33.86708,
    longitude: -84.42358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30327',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 1197.1,
    imprecise: false,
    latitude: 33.93194,
    longitude: -84.38617,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30328',
  },
  {
    city: 'Atlanta',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 1921.4,
    imprecise: false,
    latitude: 33.82625,
    longitude: -84.32282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30329',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 640.4,
    imprecise: false,
    latitude: 33.70627,
    longitude: -84.54439,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30331',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121|13097',
    county: 'Fulton',
    county_names_all: 'Fulton|Douglas',
    county_weights: '{"13121": 99.87, "13097": 0.13}',
    density: 19.5,
    imprecise: false,
    latitude: 33.73718,
    longitude: -84.56768,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30336',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121|13063',
    county: 'Fulton',
    county_names_all: 'Fulton|Clayton',
    county_weights: '{"13121": 53.43, "13063": 46.57}',
    density: 337.6,
    imprecise: false,
    latitude: 33.64019,
    longitude: -84.44962,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30337',
  },
  {
    city: 'Atlanta',
    county_fips: 13089,
    county_fips_all: '13089|13121',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Fulton',
    county_weights: '{"13089": 97.84, "13121": 2.16}',
    density: 1546.2,
    imprecise: false,
    latitude: 33.9437,
    longitude: -84.31801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30338',
  },
  {
    city: 'Atlanta',
    county_fips: 13067,
    county_fips_all: '13067|13121',
    county: 'Cobb',
    county_names_all: 'Cobb|Fulton',
    county_weights: '{"13067": 94.36, "13121": 5.64}',
    density: 1383.5,
    imprecise: false,
    latitude: 33.86786,
    longitude: -84.46483,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30339',
  },
  {
    city: 'Atlanta',
    county_fips: 13089,
    county_fips_all: '13089|13135',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Gwinnett',
    county_weights: '{"13089": 80.81, "13135": 19.19}',
    density: 1407.3,
    imprecise: false,
    latitude: 33.89808,
    longitude: -84.25113,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30340',
  },
  {
    city: 'Atlanta',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 1391.2,
    imprecise: false,
    latitude: 33.88711,
    longitude: -84.28992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30341',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 1436.4,
    imprecise: false,
    latitude: 33.88227,
    longitude: -84.37429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30342',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 1126.8,
    imprecise: false,
    latitude: 33.67508,
    longitude: -84.46029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30344',
  },
  {
    city: 'Atlanta',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 1336.9,
    imprecise: false,
    latitude: 33.85082,
    longitude: -84.28317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30345',
  },
  {
    city: 'Atlanta',
    county_fips: 13089,
    county_fips_all: '13089|13121',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Fulton',
    county_weights: '{"13089": 99.88, "13121": 0.12}',
    density: 1687.1,
    imprecise: false,
    latitude: 33.92425,
    longitude: -84.33881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30346',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121|13063',
    county: 'Fulton',
    county_names_all: 'Fulton|Clayton',
    county_weights: '{"13121": 85.61, "13063": 14.39}',
    density: 672.1,
    imprecise: false,
    latitude: 33.62346,
    longitude: -84.52591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 79872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30349',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121|13089|13067',
    county: 'Fulton',
    county_names_all: 'Fulton|DeKalb|Cobb',
    county_weights: '{"13121": 99.32, "13089": 0.55, "13067": 0.13}',
    density: 1077.2,
    imprecise: false,
    latitude: 33.97881,
    longitude: -84.33366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30350',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121|13063|13089',
    county: 'Fulton',
    county_names_all: 'Fulton|Clayton|DeKalb',
    county_weights: '{"13121": 86.65, "13063": 13.25, "13089": 0.1}',
    density: 583.1,
    imprecise: false,
    latitude: 33.66058,
    longitude: -84.38609,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30354',
  },
  {
    city: 'Atlanta',
    county_fips: 13089,
    county_fips_all: '13089|13135',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Gwinnett',
    county_weights: '{"13089": 72.72, "13135": 27.28}',
    density: 1064.7,
    imprecise: false,
    latitude: 33.93198,
    longitude: -84.27302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30360',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 5507.9,
    imprecise: false,
    latitude: 33.79147,
    longitude: -84.39887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30363',
  },
  {
    city: 'Swainsboro',
    county_fips: 13107,
    county_fips_all: '13107',
    county: 'Emanuel',
    county_names_all: 'Emanuel',
    county_weights: '{"13107": 100}',
    density: 20.8,
    imprecise: false,
    latitude: 32.604,
    longitude: -82.34825,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30401',
  },
  {
    city: 'Ailey',
    county_fips: 13209,
    county_fips_all: '13209',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"13209": 100}',
    density: 10,
    imprecise: false,
    latitude: 32.18655,
    longitude: -82.51767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30410',
  },
  {
    city: 'Alamo',
    county_fips: 13309,
    county_fips_all: '13309|13175',
    county: 'Wheeler',
    county_names_all: 'Wheeler|Laurens',
    county_weights: '{"13309": 85.11, "13175": 14.89}',
    density: 13.8,
    imprecise: false,
    latitude: 32.1254,
    longitude: -82.79362,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30411',
  },
  {
    city: 'Alston',
    county_fips: 13209,
    county_fips_all: '13209',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"13209": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 32.07973,
    longitude: -82.48643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30412',
  },
  {
    city: 'Bartow',
    county_fips: 13163,
    county_fips_all: '13163|13303|13167',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Washington|Johnson',
    county_weights: '{"13163": 55.12, "13303": 30.7, "13167": 14.18}',
    density: 4,
    imprecise: false,
    latitude: 32.88467,
    longitude: -82.51393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30413',
  },
  {
    city: 'Bellville',
    county_fips: 13109,
    county_fips_all: '13109',
    county: 'Evans',
    county_names_all: 'Evans',
    county_weights: '{"13109": 100}',
    density: 57.7,
    imprecise: false,
    latitude: 32.15618,
    longitude: -81.98522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30414',
  },
  {
    city: 'Brooklet',
    county_fips: 13031,
    county_fips_all: '13031',
    county: 'Bulloch',
    county_names_all: 'Bulloch',
    county_weights: '{"13031": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 32.32773,
    longitude: -81.6008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30415',
  },
  {
    city: 'Claxton',
    county_fips: 13109,
    county_fips_all: '13109|13267',
    county: 'Evans',
    county_names_all: 'Evans|Tattnall',
    county_weights: '{"13109": 86.33, "13267": 13.67}',
    density: 25.2,
    imprecise: false,
    latitude: 32.16953,
    longitude: -81.91978,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30417',
  },
  {
    city: 'Cobbtown',
    county_fips: 13043,
    county_fips_all: '13043|13267|13109',
    county: 'Candler',
    county_names_all: 'Candler|Tattnall|Evans',
    county_weights: '{"13043": 57.61, "13267": 41.65, "13109": 0.74}',
    density: 11,
    imprecise: false,
    latitude: 32.30363,
    longitude: -82.12958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30420',
  },
  {
    city: 'Collins',
    county_fips: 13267,
    county_fips_all: '13267',
    county: 'Tattnall',
    county_names_all: 'Tattnall',
    county_weights: '{"13267": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 32.18401,
    longitude: -82.11096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30421',
  },
  {
    city: 'Daisy',
    county_fips: 13109,
    county_fips_all: '13109',
    county: 'Evans',
    county_names_all: 'Evans',
    county_weights: '{"13109": 100}',
    density: 27.9,
    imprecise: false,
    latitude: 32.14601,
    longitude: -81.82301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30423',
  },
  {
    city: 'Garfield',
    county_fips: 13107,
    county_fips_all: '13107|13165|13031',
    county: 'Emanuel',
    county_names_all: 'Emanuel|Jenkins|Bulloch',
    county_weights: '{"13107": 50.46, "13165": 37.04, "13031": 12.5}',
    density: 6.9,
    imprecise: false,
    latitude: 32.64732,
    longitude: -82.02337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30425',
  },
  {
    city: 'Girard',
    county_fips: 13033,
    county_fips_all: '13033|13251',
    county: 'Burke',
    county_names_all: 'Burke|Screven',
    county_weights: '{"13033": 72.2, "13251": 27.8}',
    density: 2.3,
    imprecise: false,
    latitude: 33.03546,
    longitude: -81.65159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30426',
  },
  {
    city: 'Glennville',
    county_fips: 13267,
    county_fips_all: '13267|13183|13109',
    county: 'Tattnall',
    county_names_all: 'Tattnall|Long|Evans',
    county_weights: '{"13267": 82.39, "13183": 17.07, "13109": 0.54}',
    density: 21,
    imprecise: false,
    latitude: 31.92271,
    longitude: -81.96622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30427',
  },
  {
    city: 'Glenwood',
    county_fips: 13309,
    county_fips_all: '13309|13175',
    county: 'Wheeler',
    county_names_all: 'Wheeler|Laurens',
    county_weights: '{"13309": 74.66, "13175": 25.34}',
    density: 6.5,
    imprecise: false,
    latitude: 32.21706,
    longitude: -82.71436,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30428',
  },
  {
    city: 'Hagan',
    county_fips: 13109,
    county_fips_all: '13109',
    county: 'Evans',
    county_names_all: 'Evans',
    county_weights: '{"13109": 100}',
    density: 178.2,
    imprecise: false,
    latitude: 32.15897,
    longitude: -81.93714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30429',
  },
  {
    city: 'Louisville',
    county_fips: 13163,
    county_fips_all: '13163|13033',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Burke',
    county_weights: '{"13163": 81.9, "13033": 18.1}',
    density: 9.3,
    imprecise: false,
    latitude: 33.02867,
    longitude: -82.3727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30434',
  },
  {
    city: 'Lyons',
    county_fips: 13279,
    county_fips_all: '13279|13107|13267|13283',
    county: 'Toombs',
    county_names_all: 'Toombs|Emanuel|Tattnall|Treutlen',
    county_weights:
      '{"13279": 80.88, "13107": 16.63, "13267": 2.1, "13283": 0.39}',
    density: 16,
    imprecise: false,
    latitude: 32.1494,
    longitude: -82.29026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30436',
  },
  {
    city: 'Metter',
    county_fips: 13043,
    county_fips_all: '13043|13107|13031',
    county: 'Candler',
    county_names_all: 'Candler|Emanuel|Bulloch',
    county_weights: '{"13043": 97.3, "13107": 2.57, "13031": 0.13}',
    density: 19.1,
    imprecise: false,
    latitude: 32.4169,
    longitude: -82.07112,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30439',
  },
  {
    city: 'Midville',
    county_fips: 13107,
    county_fips_all: '13107|13033|13165',
    county: 'Emanuel',
    county_names_all: 'Emanuel|Burke|Jenkins',
    county_weights: '{"13107": 55.94, "13033": 42.67, "13165": 1.39}',
    density: 4.3,
    imprecise: false,
    latitude: 32.81467,
    longitude: -82.23682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30441',
  },
  {
    city: 'Millen',
    county_fips: 13165,
    county_fips_all: '13165|13033|13251',
    county: 'Jenkins',
    county_names_all: 'Jenkins|Burke|Screven',
    county_weights: '{"13165": 88.67, "13033": 10.59, "13251": 0.74}',
    density: 9.3,
    imprecise: false,
    latitude: 32.81677,
    longitude: -81.97549,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30442',
  },
  {
    city: 'Mount Vernon',
    county_fips: 13209,
    county_fips_all: '13209|13283',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Treutlen',
    county_weights: '{"13209": 99.14, "13283": 0.86}',
    density: 15.6,
    imprecise: false,
    latitude: 32.16715,
    longitude: -82.58413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30445',
  },
  {
    city: 'Newington',
    county_fips: 13251,
    county_fips_all: '13251|13103',
    county: 'Screven',
    county_names_all: 'Screven|Effingham',
    county_weights: '{"13251": 61.59, "13103": 38.41}',
    density: 15.2,
    imprecise: false,
    latitude: 32.5599,
    longitude: -81.46734,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30446',
  },
  {
    city: 'Nunez',
    county_fips: 13107,
    county_fips_all: '13107',
    county: 'Emanuel',
    county_names_all: 'Emanuel',
    county_weights: '{"13107": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 32.48754,
    longitude: -82.36444,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30448',
  },
  {
    city: 'Oliver',
    county_fips: 13251,
    county_fips_all: '13251|13103',
    county: 'Screven',
    county_names_all: 'Screven|Effingham',
    county_weights: '{"13251": 98.81, "13103": 1.19}',
    density: 23.3,
    imprecise: false,
    latitude: 32.52254,
    longitude: -81.52987,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30449',
  },
  {
    city: 'Portal',
    county_fips: 13031,
    county_fips_all: '13031|13107',
    county: 'Bulloch',
    county_names_all: 'Bulloch|Emanuel',
    county_weights: '{"13031": 98.02, "13107": 1.98}',
    density: 18.1,
    imprecise: false,
    latitude: 32.55964,
    longitude: -81.93322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30450',
  },
  {
    city: 'Pulaski',
    county_fips: 13043,
    county_fips_all: '13043',
    county: 'Candler',
    county_names_all: 'Candler',
    county_weights: '{"13043": 100}',
    density: 55.7,
    imprecise: false,
    latitude: 32.39325,
    longitude: -81.95622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30451',
  },
  {
    city: 'Register',
    county_fips: 13031,
    county_fips_all: '13031|13109|13043',
    county: 'Bulloch',
    county_names_all: 'Bulloch|Evans|Candler',
    county_weights: '{"13031": 92.64, "13109": 6.68, "13043": 0.68}',
    density: 7.8,
    imprecise: false,
    latitude: 32.31706,
    longitude: -81.89417,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30452',
  },
  {
    city: 'Reidsville',
    county_fips: 13267,
    county_fips_all: '13267',
    county: 'Tattnall',
    county_names_all: 'Tattnall',
    county_weights: '{"13267": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 32.01926,
    longitude: -82.11899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30453',
  },
  {
    city: 'Rockledge',
    county_fips: 13175,
    county_fips_all: '13175',
    county: 'Laurens',
    county_names_all: 'Laurens',
    county_weights: '{"13175": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 32.43857,
    longitude: -82.73421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30454',
  },
  {
    city: 'Rocky Ford',
    county_fips: 13251,
    county_fips_all: '13251|13165',
    county: 'Screven',
    county_names_all: 'Screven|Jenkins',
    county_weights: '{"13251": 97.41, "13165": 2.59}',
    density: 6.3,
    imprecise: false,
    latitude: 32.70111,
    longitude: -81.80652,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30455',
  },
  {
    city: 'Sardis',
    county_fips: 13033,
    county_fips_all: '13033',
    county: 'Burke',
    county_names_all: 'Burke',
    county_weights: '{"13033": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 32.98137,
    longitude: -81.79246,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30456',
  },
  {
    city: 'Soperton',
    county_fips: 13283,
    county_fips_all: '13283|13209|13107',
    county: 'Treutlen',
    county_names_all: 'Treutlen|Montgomery|Emanuel',
    county_weights: '{"13283": 92.7, "13209": 4.56, "13107": 2.74}',
    density: 12.4,
    imprecise: false,
    latitude: 32.39852,
    longitude: -82.56498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30457',
  },
  {
    city: 'Statesboro',
    county_fips: 13031,
    county_fips_all: '13031',
    county: 'Bulloch',
    county_names_all: 'Bulloch',
    county_weights: '{"13031": 100}',
    density: 134.9,
    imprecise: false,
    latitude: 32.39732,
    longitude: -81.82694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30458',
  },
  {
    city: 'Statesboro',
    county_fips: 13031,
    county_fips_all: '13031',
    county: 'Bulloch',
    county_names_all: 'Bulloch',
    county_weights: '{"13031": 100}',
    density: 41.3,
    imprecise: false,
    latitude: 32.5072,
    longitude: -81.71941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30461',
  },
  {
    city: 'Stillmore',
    county_fips: 13107,
    county_fips_all: '13107',
    county: 'Emanuel',
    county_names_all: 'Emanuel',
    county_weights: '{"13107": 100}',
    density: 71.6,
    imprecise: false,
    latitude: 32.43509,
    longitude: -82.22186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30464',
  },
  {
    city: 'Sylvania',
    county_fips: 13251,
    county_fips_all: '13251',
    county: 'Screven',
    county_names_all: 'Screven',
    county_weights: '{"13251": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 32.75114,
    longitude: -81.60468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30467',
  },
  {
    city: 'Tarrytown',
    county_fips: 13209,
    county_fips_all: '13209|13283',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Treutlen',
    county_weights: '{"13209": 56.64, "13283": 43.36}',
    density: 6.1,
    imprecise: false,
    latitude: 32.33018,
    longitude: -82.51818,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30470',
  },
  {
    city: 'Twin City',
    county_fips: 13107,
    county_fips_all: '13107|13031|13043',
    county: 'Emanuel',
    county_names_all: 'Emanuel|Bulloch|Candler',
    county_weights: '{"13107": 94.95, "13031": 3.38, "13043": 1.67}',
    density: 12.2,
    imprecise: false,
    latitude: 32.53816,
    longitude: -82.18563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30471',
  },
  {
    city: 'Uvalda',
    county_fips: 13279,
    county_fips_all: '13279|13209',
    county: 'Toombs',
    county_names_all: 'Toombs|Montgomery',
    county_weights: '{"13279": 54.11, "13209": 45.89}',
    density: 11.4,
    imprecise: false,
    latitude: 32.01613,
    longitude: -82.47198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30473',
  },
  {
    city: 'Vidalia',
    county_fips: 13279,
    county_fips_all: '13279|13209|13107|13283',
    county: 'Toombs',
    county_names_all: 'Toombs|Montgomery|Emanuel|Treutlen',
    county_weights:
      '{"13279": 71.1, "13209": 21.47, "13107": 4.55, "13283": 2.88}',
    density: 52.2,
    imprecise: false,
    latitude: 32.22393,
    longitude: -82.41381,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30474',
  },
  {
    city: 'Wadley',
    county_fips: 13163,
    county_fips_all: '13163',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"13163": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 32.86279,
    longitude: -82.3979,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30477',
  },
  {
    city: 'Gainesville',
    county_fips: 13139,
    county_fips_all: '13139',
    county: 'Hall',
    county_names_all: 'Hall',
    county_weights: '{"13139": 100}',
    density: 569.8,
    imprecise: false,
    latitude: 34.31844,
    longitude: -83.81636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30501',
  },
  {
    city: 'Gainesville',
    county_fips: 13139,
    county_fips_all: '13139',
    county: 'Hall',
    county_names_all: 'Hall',
    county_weights: '{"13139": 100}',
    density: 626,
    imprecise: false,
    latitude: 34.26639,
    longitude: -83.88751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30504',
  },
  {
    city: 'Gainesville',
    county_fips: 13139,
    county_fips_all: '13139|13117',
    county: 'Hall',
    county_names_all: 'Hall|Forsyth',
    county_weights: '{"13139": 72.93, "13117": 27.07}',
    density: 175.2,
    imprecise: false,
    latitude: 34.34918,
    longitude: -83.89486,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30506',
  },
  {
    city: 'Gainesville',
    county_fips: 13139,
    county_fips_all: '13139',
    county: 'Hall',
    county_names_all: 'Hall',
    county_weights: '{"13139": 100}',
    density: 180.1,
    imprecise: false,
    latitude: 34.26082,
    longitude: -83.76622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30507',
  },
  {
    city: 'Alto',
    county_fips: 13011,
    county_fips_all: '13011|13137|13139',
    county: 'Banks',
    county_names_all: 'Banks|Habersham|Hall',
    county_weights: '{"13011": 56.9, "13137": 28.19, "13139": 14.91}',
    density: 75,
    imprecise: false,
    latitude: 34.44194,
    longitude: -83.58446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30510',
  },
  {
    city: 'Baldwin',
    county_fips: 13011,
    county_fips_all: '13011|13257|13137',
    county: 'Banks',
    county_names_all: 'Banks|Stephens|Habersham',
    county_weights: '{"13011": 92.85, "13257": 4.05, "13137": 3.1}',
    density: 37.8,
    imprecise: false,
    latitude: 34.45674,
    longitude: -83.47474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30511',
  },
  {
    city: 'Blairsville',
    county_fips: 13291,
    county_fips_all: '13291|13111',
    county: 'Union',
    county_names_all: 'Union|Fannin',
    county_weights: '{"13291": 99.16, "13111": 0.84}',
    density: 43.4,
    imprecise: false,
    latitude: 34.85667,
    longitude: -83.97204,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30512',
  },
  {
    city: 'Blue Ridge',
    county_fips: 13111,
    county_fips_all: '13111|13123',
    county: 'Fannin',
    county_names_all: 'Fannin|Gilmer',
    county_weights: '{"13111": 95.22, "13123": 4.78}',
    density: 30.7,
    imprecise: false,
    latitude: 34.82469,
    longitude: -84.31891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30513',
  },
  {
    city: 'Bowersville',
    county_fips: 13147,
    county_fips_all: '13147|13119',
    county: 'Hart',
    county_names_all: 'Hart|Franklin',
    county_weights: '{"13147": 99.85, "13119": 0.15}',
    density: 34.3,
    imprecise: false,
    latitude: 34.37535,
    longitude: -83.03748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30516',
  },
  {
    city: 'Braselton',
    county_fips: 13157,
    county_fips_all: '13157|13139|13135|13013',
    county: 'Jackson',
    county_names_all: 'Jackson|Hall|Gwinnett|Barrow',
    county_weights:
      '{"13157": 51.87, "13139": 29.92, "13135": 10.86, "13013": 7.35}',
    density: 264.8,
    imprecise: false,
    latitude: 34.13047,
    longitude: -83.7975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30517',
  },
  {
    city: 'Buford',
    county_fips: 13135,
    county_fips_all: '13135|13139',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett|Hall',
    county_weights: '{"13135": 70.51, "13139": 29.49}',
    density: 558.5,
    imprecise: false,
    latitude: 34.132,
    longitude: -84.02578,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30518',
  },
  {
    city: 'Buford',
    county_fips: 13135,
    county_fips_all: '13135|13139',
    county: 'Gwinnett',
    county_names_all: 'Gwinnett|Hall',
    county_weights: '{"13135": 88.72, "13139": 11.28}',
    density: 686.2,
    imprecise: false,
    latitude: 34.08792,
    longitude: -83.9423,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30519',
  },
  {
    city: 'Canon',
    county_fips: 13147,
    county_fips_all: '13147|13119',
    county: 'Hart',
    county_names_all: 'Hart|Franklin',
    county_weights: '{"13147": 52.7, "13119": 47.3}',
    density: 34.3,
    imprecise: false,
    latitude: 34.33833,
    longitude: -83.08661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30520',
  },
  {
    city: 'Carnesville',
    county_fips: 13119,
    county_fips_all: '13119|13011',
    county: 'Franklin',
    county_names_all: 'Franklin|Banks',
    county_weights: '{"13119": 94.16, "13011": 5.84}',
    density: 28.4,
    imprecise: false,
    latitude: 34.36202,
    longitude: -83.29355,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30521',
  },
  {
    city: 'Cherry Log',
    county_fips: 13123,
    county_fips_all: '13123|13111',
    county: 'Gilmer',
    county_names_all: 'Gilmer|Fannin',
    county_weights: '{"13123": 73.18, "13111": 26.82}',
    density: 5.9,
    imprecise: false,
    latitude: 34.78351,
    longitude: -84.34233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30522',
  },
  {
    city: 'Clarkesville',
    county_fips: 13137,
    county_fips_all: '13137|13241',
    county: 'Habersham',
    county_names_all: 'Habersham|Rabun',
    county_weights: '{"13137": 83.85, "13241": 16.15}',
    density: 29.4,
    imprecise: false,
    latitude: 34.72012,
    longitude: -83.54166,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30523',
  },
  {
    city: 'Clayton',
    county_fips: 13241,
    county_fips_all: '13241|13281',
    county: 'Rabun',
    county_names_all: 'Rabun|Towns',
    county_weights: '{"13241": 98.06, "13281": 1.94}',
    density: 13.8,
    imprecise: false,
    latitude: 34.91289,
    longitude: -83.35853,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30525',
  },
  {
    city: 'Clermont',
    county_fips: 13139,
    county_fips_all: '13139',
    county: 'Hall',
    county_names_all: 'Hall',
    county_weights: '{"13139": 100}',
    density: 60.7,
    imprecise: false,
    latitude: 34.47948,
    longitude: -83.7863,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30527',
  },
  {
    city: 'Cleveland',
    county_fips: 13311,
    county_fips_all: '13311|13187',
    county: 'White',
    county_names_all: 'White|Lumpkin',
    county_weights: '{"13311": 89.0, "13187": 11.0}',
    density: 56,
    imprecise: false,
    latitude: 34.6083,
    longitude: -83.77589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30528',
  },
  {
    city: 'Commerce',
    county_fips: 13157,
    county_fips_all: '13157|13011',
    county: 'Jackson',
    county_names_all: 'Jackson|Banks',
    county_weights: '{"13157": 73.55, "13011": 26.45}',
    density: 98.4,
    imprecise: false,
    latitude: 34.2155,
    longitude: -83.482,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30529',
  },
  {
    city: 'Commerce',
    county_fips: 13011,
    county_fips_all: '13011|13157|13195|13119',
    county: 'Banks',
    county_names_all: 'Banks|Jackson|Madison|Franklin',
    county_weights:
      '{"13011": 41.82, "13157": 25.83, "13195": 17.32, "13119": 15.02}',
    density: 35.4,
    imprecise: false,
    latitude: 34.22691,
    longitude: -83.38433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30530',
  },
  {
    city: 'Cornelia',
    county_fips: 13137,
    county_fips_all: '13137|13139',
    county: 'Habersham',
    county_names_all: 'Habersham|Hall',
    county_weights: '{"13137": 85.21, "13139": 14.79}',
    density: 121,
    imprecise: false,
    latitude: 34.51017,
    longitude: -83.59103,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30531',
  },
  {
    city: 'Dahlonega',
    county_fips: 13187,
    county_fips_all: '13187|13085|13139|13311',
    county: 'Lumpkin',
    county_names_all: 'Lumpkin|Dawson|Hall|White',
    county_weights:
      '{"13187": 95.32, "13085": 2.57, "13139": 1.71, "13311": 0.4}',
    density: 44.6,
    imprecise: false,
    latitude: 34.57344,
    longitude: -84.01576,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30533',
  },
  {
    city: 'Dawsonville',
    county_fips: 13085,
    county_fips_all: '13085|13187|13117|13227|13057',
    county: 'Dawson',
    county_names_all: 'Dawson|Lumpkin|Forsyth|Pickens|Cherokee',
    county_weights:
      '{"13085": 85.36, "13187": 9.71, "13117": 3.0, "13227": 1.27, "13057": 0.66}',
    density: 62.3,
    imprecise: false,
    latitude: 34.43085,
    longitude: -84.1439,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30534',
  },
  {
    city: 'Demorest',
    county_fips: 13137,
    county_fips_all: '13137',
    county: 'Habersham',
    county_names_all: 'Habersham',
    county_weights: '{"13137": 100}',
    density: 113.1,
    imprecise: false,
    latitude: 34.58063,
    longitude: -83.57652,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30535',
  },
  {
    city: 'Ellijay',
    county_fips: 13123,
    county_fips_all: '13123|13085',
    county: 'Gilmer',
    county_names_all: 'Gilmer|Dawson',
    county_weights: '{"13123": 97.75, "13085": 2.25}',
    density: 23.5,
    imprecise: false,
    latitude: 34.65151,
    longitude: -84.35223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30536',
  },
  {
    city: 'Dillard',
    county_fips: 13241,
    county_fips_all: '13241',
    county: 'Rabun',
    county_names_all: 'Rabun',
    county_weights: '{"13241": 100}',
    density: 28.9,
    imprecise: false,
    latitude: 34.97855,
    longitude: -83.32975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30537',
  },
  {
    city: 'Eastanollee',
    county_fips: 13257,
    county_fips_all: '13257|13119',
    county: 'Stephens',
    county_names_all: 'Stephens|Franklin',
    county_weights: '{"13257": 88.11, "13119": 11.89}',
    density: 43.7,
    imprecise: false,
    latitude: 34.5035,
    longitude: -83.26888,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30538',
  },
  {
    city: 'East Ellijay',
    county_fips: 13123,
    county_fips_all: '13123',
    county: 'Gilmer',
    county_names_all: 'Gilmer',
    county_weights: '{"13123": 100}',
    density: 136.4,
    imprecise: false,
    latitude: 34.68061,
    longitude: -84.47016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30539',
  },
  {
    city: 'Ellijay',
    county_fips: 13123,
    county_fips_all: '13123',
    county: 'Gilmer',
    county_names_all: 'Gilmer',
    county_weights: '{"13123": 100}',
    density: 40.4,
    imprecise: false,
    latitude: 34.72313,
    longitude: -84.54421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30540',
  },
  {
    city: 'Epworth',
    county_fips: 13111,
    county_fips_all: '13111',
    county: 'Fannin',
    county_names_all: 'Fannin',
    county_weights: '{"13111": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 34.91164,
    longitude: -84.53482,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30541',
  },
  {
    city: 'Flowery Branch',
    county_fips: 13139,
    county_fips_all: '13139',
    county: 'Hall',
    county_names_all: 'Hall',
    county_weights: '{"13139": 100}',
    density: 351.2,
    imprecise: false,
    latitude: 34.17846,
    longitude: -83.90915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30542',
  },
  {
    city: 'Gillsville',
    county_fips: 13139,
    county_fips_all: '13139|13011|13157',
    county: 'Hall',
    county_names_all: 'Hall|Banks|Jackson',
    county_weights: '{"13139": 56.49, "13011": 32.66, "13157": 10.85}',
    density: 62.8,
    imprecise: false,
    latitude: 34.29781,
    longitude: -83.64971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30543',
  },
  {
    city: 'Helen',
    county_fips: 13311,
    county_fips_all: '13311',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"13311": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 34.74208,
    longitude: -83.75813,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30545',
  },
  {
    city: 'Hiawassee',
    county_fips: 13281,
    county_fips_all: '13281',
    county: 'Towns',
    county_names_all: 'Towns',
    county_weights: '{"13281": 100}',
    density: 24,
    imprecise: false,
    latitude: 34.90673,
    longitude: -83.71016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30546',
  },
  {
    city: 'Homer',
    county_fips: 13011,
    county_fips_all: '13011',
    county: 'Banks',
    county_names_all: 'Banks',
    county_weights: '{"13011": 100}',
    density: 26.8,
    imprecise: false,
    latitude: 34.35737,
    longitude: -83.46095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30547',
  },
  {
    city: 'Hoschton',
    county_fips: 13157,
    county_fips_all: '13157|13013|13139|13135',
    county: 'Jackson',
    county_names_all: 'Jackson|Barrow|Hall|Gwinnett',
    county_weights:
      '{"13157": 62.0, "13013": 19.96, "13139": 9.04, "13135": 9.0}',
    density: 250.5,
    imprecise: false,
    latitude: 34.09311,
    longitude: -83.7646,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30548',
  },
  {
    city: 'Jefferson',
    county_fips: 13157,
    county_fips_all: '13157',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"13157": 100}',
    density: 117.3,
    imprecise: false,
    latitude: 34.10731,
    longitude: -83.57684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30549',
  },
  {
    city: 'Lakemont',
    county_fips: 13241,
    county_fips_all: '13241',
    county: 'Rabun',
    county_names_all: 'Rabun',
    county_weights: '{"13241": 100}',
    density: 13,
    imprecise: false,
    latitude: 34.76965,
    longitude: -83.44575,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30552',
  },
  {
    city: 'Lavonia',
    county_fips: 13119,
    county_fips_all: '13119|13147',
    county: 'Franklin',
    county_names_all: 'Franklin|Hart',
    county_weights: '{"13119": 58.85, "13147": 41.15}',
    density: 55.8,
    imprecise: false,
    latitude: 34.44473,
    longitude: -83.08771,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30553',
  },
  {
    city: 'Lula',
    county_fips: 13139,
    county_fips_all: '13139|13011',
    county: 'Hall',
    county_names_all: 'Hall|Banks',
    county_weights: '{"13139": 60.5, "13011": 39.5}',
    density: 48.5,
    imprecise: false,
    latitude: 34.40093,
    longitude: -83.65926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30554',
  },
  {
    city: 'McCaysville',
    county_fips: 13111,
    county_fips_all: '13111',
    county: 'Fannin',
    county_names_all: 'Fannin',
    county_weights: '{"13111": 100}',
    density: 88.1,
    imprecise: false,
    latitude: 34.97216,
    longitude: -84.42459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30555',
  },
  {
    city: 'Martin',
    county_fips: 13119,
    county_fips_all: '13119|13257',
    county: 'Franklin',
    county_names_all: 'Franklin|Stephens',
    county_weights: '{"13119": 59.4, "13257": 40.6}',
    density: 31.6,
    imprecise: false,
    latitude: 34.48143,
    longitude: -83.18484,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30557',
  },
  {
    city: 'Maysville',
    county_fips: 13157,
    county_fips_all: '13157|13011',
    county: 'Jackson',
    county_names_all: 'Jackson|Banks',
    county_weights: '{"13157": 53.82, "13011": 46.18}',
    density: 34.8,
    imprecise: false,
    latitude: 34.2683,
    longitude: -83.56787,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30558',
  },
  {
    city: 'Mineral Bluff',
    county_fips: 13111,
    county_fips_all: '13111',
    county: 'Fannin',
    county_names_all: 'Fannin',
    county_weights: '{"13111": 100}',
    density: 38.5,
    imprecise: false,
    latitude: 34.95233,
    longitude: -84.26612,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30559',
  },
  {
    city: 'Morganton',
    county_fips: 13111,
    county_fips_all: '13111|13291',
    county: 'Fannin',
    county_names_all: 'Fannin|Union',
    county_weights: '{"13111": 89.2, "13291": 10.8}',
    density: 23.2,
    imprecise: false,
    latitude: 34.87785,
    longitude: -84.19528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30560',
  },
  {
    city: 'Mountain City',
    county_fips: 13241,
    county_fips_all: '13241',
    county: 'Rabun',
    county_names_all: 'Rabun',
    county_weights: '{"13241": 100}',
    density: 283.4,
    imprecise: false,
    latitude: 34.91937,
    longitude: -83.38177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30562',
  },
  {
    city: 'Mount Airy',
    county_fips: 13137,
    county_fips_all: '13137|13257',
    county: 'Habersham',
    county_names_all: 'Habersham|Stephens',
    county_weights: '{"13137": 98.78, "13257": 1.22}',
    density: 62.6,
    imprecise: false,
    latitude: 34.5596,
    longitude: -83.46283,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30563',
  },
  {
    city: 'Murrayville',
    county_fips: 13139,
    county_fips_all: '13139|13187|13311',
    county: 'Hall',
    county_names_all: 'Hall|Lumpkin|White',
    county_weights: '{"13139": 57.86, "13187": 37.19, "13311": 4.95}',
    density: 60.6,
    imprecise: false,
    latitude: 34.47251,
    longitude: -83.8826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30564',
  },
  {
    city: 'Nicholson',
    county_fips: 13157,
    county_fips_all: '13157|13195',
    county: 'Jackson',
    county_names_all: 'Jackson|Madison',
    county_weights: '{"13157": 86.97, "13195": 13.03}',
    density: 55.4,
    imprecise: false,
    latitude: 34.08802,
    longitude: -83.41203,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30565',
  },
  {
    city: 'Oakwood',
    county_fips: 13139,
    county_fips_all: '13139',
    county: 'Hall',
    county_names_all: 'Hall',
    county_weights: '{"13139": 100}',
    density: 453.4,
    imprecise: false,
    latitude: 34.23747,
    longitude: -83.89477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30566',
  },
  {
    city: 'Pendergrass',
    county_fips: 13157,
    county_fips_all: '13157|13139',
    county: 'Jackson',
    county_names_all: 'Jackson|Hall',
    county_weights: '{"13157": 98.81, "13139": 1.19}',
    density: 73,
    imprecise: false,
    latitude: 34.18326,
    longitude: -83.6814,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30567',
  },
  {
    city: 'Rabun Gap',
    county_fips: 13241,
    county_fips_all: '13241',
    county: 'Rabun',
    county_names_all: 'Rabun',
    county_weights: '{"13241": 100}',
    density: 26.9,
    imprecise: false,
    latitude: 34.95348,
    longitude: -83.41218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30568',
  },
  {
    city: 'Sautee Nacoochee',
    county_fips: 13311,
    county_fips_all: '13311',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"13311": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 34.71219,
    longitude: -83.68322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30571',
  },
  {
    city: 'Suches',
    county_fips: 13291,
    county_fips_all: '13291|13111',
    county: 'Union',
    county_names_all: 'Union|Fannin',
    county_weights: '{"13291": 69.68, "13111": 30.32}',
    density: 3.3,
    imprecise: false,
    latitude: 34.73539,
    longitude: -84.07364,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30572',
  },
  {
    city: 'Tallulah Falls',
    county_fips: 13241,
    county_fips_all: '13241',
    county: 'Rabun',
    county_names_all: 'Rabun',
    county_weights: '{"13241": 100}',
    density: 31.4,
    imprecise: false,
    latitude: 34.74242,
    longitude: -83.39986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30573',
  },
  {
    city: 'Talmo',
    county_fips: 13157,
    county_fips_all: '13157|13139',
    county: 'Jackson',
    county_names_all: 'Jackson|Hall',
    county_weights: '{"13157": 67.5, "13139": 32.5}',
    density: 55.3,
    imprecise: false,
    latitude: 34.20353,
    longitude: -83.71556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30575',
  },
  {
    city: 'Tiger',
    county_fips: 13241,
    county_fips_all: '13241',
    county: 'Rabun',
    county_names_all: 'Rabun',
    county_weights: '{"13241": 100}',
    density: 32.7,
    imprecise: false,
    latitude: 34.82682,
    longitude: -83.44539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30576',
  },
  {
    city: 'Toccoa',
    county_fips: 13257,
    county_fips_all: '13257|13119|13137|13011',
    county: 'Stephens',
    county_names_all: 'Stephens|Franklin|Habersham|Banks',
    county_weights:
      '{"13257": 83.2, "13119": 11.09, "13137": 4.32, "13011": 1.39}',
    density: 56.4,
    imprecise: false,
    latitude: 34.55549,
    longitude: -83.32632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30577',
  },
  {
    city: 'Wiley',
    county_fips: 13241,
    county_fips_all: '13241',
    county: 'Rabun',
    county_names_all: 'Rabun',
    county_weights: '{"13241": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 34.80195,
    longitude: -83.42405,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30581',
  },
  {
    city: 'Young Harris',
    county_fips: 13281,
    county_fips_all: '13281|13291',
    county: 'Towns',
    county_names_all: 'Towns|Union',
    county_weights: '{"13281": 62.94, "13291": 37.06}',
    density: 39.3,
    imprecise: false,
    latitude: 34.9494,
    longitude: -83.89869,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30582',
  },
  {
    city: 'Athens',
    county_fips: 13059,
    county_fips_all: '13059|13195|13157',
    county: 'Clarke',
    county_names_all: 'Clarke|Madison|Jackson',
    county_weights: '{"13059": 89.99, "13195": 5.95, "13157": 4.06}',
    density: 427.8,
    imprecise: false,
    latitude: 34.00032,
    longitude: -83.34851,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30601',
  },
  {
    city: 'Athens',
    county_fips: 13059,
    county_fips_all: '13059|13219',
    county: 'Clarke',
    county_names_all: 'Clarke|Oconee',
    county_weights: '{"13059": 95.06, "13219": 4.94}',
    density: 419.8,
    imprecise: false,
    latitude: 33.90551,
    longitude: -83.32405,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30605',
  },
  {
    city: 'Athens',
    county_fips: 13059,
    county_fips_all: '13059|13219',
    county: 'Clarke',
    county_names_all: 'Clarke|Oconee',
    county_weights: '{"13059": 73.67, "13219": 26.33}',
    density: 601.9,
    imprecise: false,
    latitude: 33.93873,
    longitude: -83.43305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30606',
  },
  {
    city: 'Athens',
    county_fips: 13157,
    county_fips_all: '13157|13059',
    county: 'Jackson',
    county_names_all: 'Jackson|Clarke',
    county_weights: '{"13157": 62.9, "13059": 37.1}',
    density: 111.1,
    imprecise: false,
    latitude: 34.01895,
    longitude: -83.44774,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30607',
  },
  {
    city: 'Arnoldsville',
    county_fips: 13221,
    county_fips_all: '13221|13219',
    county: 'Oglethorpe',
    county_names_all: 'Oglethorpe|Oconee',
    county_weights: '{"13221": 96.5, "13219": 3.5}',
    density: 25.6,
    imprecise: false,
    latitude: 33.85752,
    longitude: -83.2403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30619',
  },
  {
    city: 'Bethlehem',
    county_fips: 13013,
    county_fips_all: '13013|13135|13297',
    county: 'Barrow',
    county_names_all: 'Barrow|Gwinnett|Walton',
    county_weights: '{"13013": 77.96, "13135": 15.54, "13297": 6.5}',
    density: 315.4,
    imprecise: false,
    latitude: 33.92917,
    longitude: -83.75958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30620',
  },
  {
    city: 'Bishop',
    county_fips: 13219,
    county_fips_all: '13219|13211',
    county: 'Oconee',
    county_names_all: 'Oconee|Morgan',
    county_weights: '{"13219": 64.77, "13211": 35.23}',
    density: 52.3,
    imprecise: false,
    latitude: 33.80194,
    longitude: -83.4791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30621',
  },
  {
    city: 'Bogart',
    county_fips: 13219,
    county_fips_all: '13219|13059|13157|13013',
    county: 'Oconee',
    county_names_all: 'Oconee|Clarke|Jackson|Barrow',
    county_weights:
      '{"13219": 67.97, "13059": 22.72, "13157": 8.65, "13013": 0.66}',
    density: 117.7,
    imprecise: false,
    latitude: 33.92041,
    longitude: -83.53076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30622',
  },
  {
    city: 'Bostwick',
    county_fips: 13211,
    county_fips_all: '13211',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"13211": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 33.73113,
    longitude: -83.51592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30623',
  },
  {
    city: 'Bowman',
    county_fips: 13105,
    county_fips_all: '13105|13147|13195',
    county: 'Elbert',
    county_names_all: 'Elbert|Hart|Madison',
    county_weights: '{"13105": 82.51, "13147": 10.75, "13195": 6.74}',
    density: 27.7,
    imprecise: false,
    latitude: 34.18097,
    longitude: -83.03885,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30624',
  },
  {
    city: 'Buckhead',
    county_fips: 13211,
    county_fips_all: '13211|13237',
    county: 'Morgan',
    county_names_all: 'Morgan|Putnam',
    county_weights: '{"13211": 88.65, "13237": 11.35}',
    density: 21.3,
    imprecise: false,
    latitude: 33.52128,
    longitude: -83.34211,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30625',
  },
  {
    city: 'Carlton',
    county_fips: 13221,
    county_fips_all: '13221|13195',
    county: 'Oglethorpe',
    county_names_all: 'Oglethorpe|Madison',
    county_weights: '{"13221": 82.31, "13195": 17.69}',
    density: 8.1,
    imprecise: false,
    latitude: 33.98264,
    longitude: -82.96265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30627',
  },
  {
    city: 'Colbert',
    county_fips: 13195,
    county_fips_all: '13195|13221',
    county: 'Madison',
    county_names_all: 'Madison|Oglethorpe',
    county_weights: '{"13195": 70.07, "13221": 29.93}',
    density: 52.6,
    imprecise: false,
    latitude: 34.03115,
    longitude: -83.21364,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30628',
  },
  {
    city: 'Comer',
    county_fips: 13195,
    county_fips_all: '13195|13221',
    county: 'Madison',
    county_names_all: 'Madison|Oglethorpe',
    county_weights: '{"13195": 71.31, "13221": 28.69}',
    density: 27.7,
    imprecise: false,
    latitude: 34.07779,
    longitude: -83.11625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30629',
  },
  {
    city: 'Crawford',
    county_fips: 13221,
    county_fips_all: '13221',
    county: 'Oglethorpe',
    county_names_all: 'Oglethorpe',
    county_weights: '{"13221": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 33.89894,
    longitude: -83.14366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30630',
  },
  {
    city: 'Crawfordville',
    county_fips: 13265,
    county_fips_all: '13265|13317|13133',
    county: 'Taliaferro',
    county_names_all: 'Taliaferro|Wilkes|Greene',
    county_weights: '{"13265": 95.84, "13317": 2.97, "13133": 1.19}',
    density: 3.9,
    imprecise: false,
    latitude: 33.56553,
    longitude: -82.87034,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30631',
  },
  {
    city: 'Danielsville',
    county_fips: 13195,
    county_fips_all: '13195|13119|13011',
    county: 'Madison',
    county_names_all: 'Madison|Franklin|Banks',
    county_weights: '{"13195": 97.79, "13119": 1.92, "13011": 0.29}',
    density: 35.1,
    imprecise: false,
    latitude: 34.17896,
    longitude: -83.24612,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30633',
  },
  {
    city: 'Dewy Rose',
    county_fips: 13105,
    county_fips_all: '13105|13147',
    county: 'Elbert',
    county_names_all: 'Elbert|Hart',
    county_weights: '{"13105": 72.82, "13147": 27.18}',
    density: 15.7,
    imprecise: false,
    latitude: 34.20307,
    longitude: -82.94522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30634',
  },
  {
    city: 'Elberton',
    county_fips: 13105,
    county_fips_all: '13105|13147',
    county: 'Elbert',
    county_names_all: 'Elbert|Hart',
    county_weights: '{"13105": 98.66, "13147": 1.34}',
    density: 21.5,
    imprecise: false,
    latitude: 34.10346,
    longitude: -82.80145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30635',
  },
  {
    city: 'Franklin Springs',
    county_fips: 13119,
    county_fips_all: '13119',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"13119": 100}',
    density: 318.9,
    imprecise: false,
    latitude: 34.28283,
    longitude: -83.15232,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30639',
  },
  {
    city: 'Good Hope',
    county_fips: 13297,
    county_fips_all: '13297|13211',
    county: 'Walton',
    county_names_all: 'Walton|Morgan',
    county_weights: '{"13297": 77.08, "13211": 22.92}',
    density: 19.6,
    imprecise: false,
    latitude: 33.77872,
    longitude: -83.56456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30641',
  },
  {
    city: 'Greensboro',
    county_fips: 13133,
    county_fips_all: '13133',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"13133": 100}',
    density: 32.2,
    imprecise: false,
    latitude: 33.5446,
    longitude: -83.1832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30642',
  },
  {
    city: 'Hartwell',
    county_fips: 13147,
    county_fips_all: '13147',
    county: 'Hart',
    county_names_all: 'Hart',
    county_weights: '{"13147": 100}',
    density: 58,
    imprecise: false,
    latitude: 34.36464,
    longitude: -82.91143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30643',
  },
  {
    city: 'Hull',
    county_fips: 13195,
    county_fips_all: '13195|13059|13157',
    county: 'Madison',
    county_names_all: 'Madison|Clarke|Jackson',
    county_weights: '{"13195": 99.15, "13059": 0.44, "13157": 0.41}',
    density: 89.7,
    imprecise: false,
    latitude: 34.08011,
    longitude: -83.31254,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30646',
  },
  {
    city: 'Lexington',
    county_fips: 13221,
    county_fips_all: '13221',
    county: 'Oglethorpe',
    county_names_all: 'Oglethorpe',
    county_weights: '{"13221": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 33.87577,
    longitude: -83.03319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30648',
  },
  {
    city: 'Madison',
    county_fips: 13211,
    county_fips_all: '13211|13133|13297|13237',
    county: 'Morgan',
    county_names_all: 'Morgan|Greene|Walton|Putnam',
    county_weights:
      '{"13211": 89.86, "13133": 8.21, "13297": 1.23, "13237": 0.69}',
    density: 23.6,
    imprecise: false,
    latitude: 33.5907,
    longitude: -83.46693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30650',
  },
  {
    city: 'Monroe',
    county_fips: 13297,
    county_fips_all: '13297',
    county: 'Walton',
    county_names_all: 'Walton',
    county_weights: '{"13297": 100}',
    density: 138.5,
    imprecise: false,
    latitude: 33.78214,
    longitude: -83.69072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30655',
  },
  {
    city: 'Monroe',
    county_fips: 13297,
    county_fips_all: '13297|13013',
    county: 'Walton',
    county_names_all: 'Walton|Barrow',
    county_weights: '{"13297": 96.6, "13013": 3.4}',
    density: 100.7,
    imprecise: false,
    latitude: 33.86302,
    longitude: -83.71903,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30656',
  },
  {
    city: 'Rayle',
    county_fips: 13317,
    county_fips_all: '13317|13221|13265',
    county: 'Wilkes',
    county_names_all: 'Wilkes|Oglethorpe|Taliaferro',
    county_weights: '{"13317": 62.93, "13221": 36.09, "13265": 0.98}',
    density: 4,
    imprecise: false,
    latitude: 33.78237,
    longitude: -82.94369,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30660',
  },
  {
    city: 'Royston',
    county_fips: 13119,
    county_fips_all: '13119|13147|13195|13105',
    county: 'Franklin',
    county_names_all: 'Franklin|Hart|Madison|Elbert',
    county_weights:
      '{"13119": 51.4, "13147": 25.17, "13195": 21.75, "13105": 1.68}',
    density: 36.8,
    imprecise: false,
    latitude: 34.26383,
    longitude: -83.14624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30662',
  },
  {
    city: 'Rutledge',
    county_fips: 13211,
    county_fips_all: '13211',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"13211": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 33.61572,
    longitude: -83.60357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30663',
  },
  {
    city: 'Sharon',
    county_fips: 13265,
    county_fips_all: '13265',
    county: 'Taliaferro',
    county_names_all: 'Taliaferro',
    county_weights: '{"13265": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 33.55786,
    longitude: -82.79904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30664',
  },
  {
    city: 'Siloam',
    county_fips: 13133,
    county_fips_all: '13133',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"13133": 100}',
    density: 155.8,
    imprecise: false,
    latitude: 33.53707,
    longitude: -83.07475,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30665',
  },
  {
    city: 'Statham',
    county_fips: 13013,
    county_fips_all: '13013|13219|13157',
    county: 'Barrow',
    county_names_all: 'Barrow|Oconee|Jackson',
    county_weights: '{"13013": 59.72, "13219": 30.58, "13157": 9.7}',
    density: 114.7,
    imprecise: false,
    latitude: 33.95891,
    longitude: -83.58266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30666',
  },
  {
    city: 'Stephens',
    county_fips: 13221,
    county_fips_all: '13221',
    county: 'Oglethorpe',
    county_names_all: 'Oglethorpe',
    county_weights: '{"13221": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 33.78526,
    longitude: -83.16634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30667',
  },
  {
    city: 'Tignall',
    county_fips: 13317,
    county_fips_all: '13317|13181',
    county: 'Wilkes',
    county_names_all: 'Wilkes|Lincoln',
    county_weights: '{"13317": 79.77, "13181": 20.23}',
    density: 6.1,
    imprecise: false,
    latitude: 33.90835,
    longitude: -82.69486,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30668',
  },
  {
    city: 'Union Point',
    county_fips: 13133,
    county_fips_all: '13133|13221|13265',
    county: 'Greene',
    county_names_all: 'Greene|Oglethorpe|Taliaferro',
    county_weights: '{"13133": 77.03, "13221": 11.78, "13265": 11.19}',
    density: 8.6,
    imprecise: false,
    latitude: 33.67159,
    longitude: -83.11187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30669',
  },
  {
    city: 'Washington',
    county_fips: 13317,
    county_fips_all: '13317',
    county: 'Wilkes',
    county_names_all: 'Wilkes',
    county_weights: '{"13317": 100}',
    density: 9,
    imprecise: false,
    latitude: 33.72716,
    longitude: -82.71594,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30673',
  },
  {
    city: 'Watkinsville',
    county_fips: 13219,
    county_fips_all: '13219|13133',
    county: 'Oconee',
    county_names_all: 'Oconee|Greene',
    county_weights: '{"13219": 86.47, "13133": 13.53}',
    density: 71.4,
    imprecise: false,
    latitude: 33.7929,
    longitude: -83.38186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30677',
  },
  {
    city: 'White Plains',
    county_fips: 13133,
    county_fips_all: '13133|13141|13265',
    county: 'Greene',
    county_names_all: 'Greene|Hancock|Taliaferro',
    county_weights: '{"13133": 75.1, "13141": 20.9, "13265": 4.0}',
    density: 6.8,
    imprecise: false,
    latitude: 33.44626,
    longitude: -83.07598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30678',
  },
  {
    city: 'Winder',
    county_fips: 13013,
    county_fips_all: '13013|13157|13219',
    county: 'Barrow',
    county_names_all: 'Barrow|Jackson|Oconee',
    county_weights: '{"13013": 94.56, "13157": 3.18, "13219": 2.26}',
    density: 196.8,
    imprecise: false,
    latitude: 33.99725,
    longitude: -83.69743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30680',
  },
  {
    city: 'Winterville',
    county_fips: 13221,
    county_fips_all: '13221|13059|13195',
    county: 'Oglethorpe',
    county_names_all: 'Oglethorpe|Clarke|Madison',
    county_weights: '{"13221": 57.14, "13059": 41.46, "13195": 1.4}',
    density: 72.7,
    imprecise: false,
    latitude: 33.94703,
    longitude: -83.25775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30683',
  },
  {
    city: 'Calhoun',
    county_fips: 13129,
    county_fips_all: '13129|13115',
    county: 'Gordon',
    county_names_all: 'Gordon|Floyd',
    county_weights: '{"13129": 94.22, "13115": 5.78}',
    density: 113.7,
    imprecise: false,
    latitude: 34.49535,
    longitude: -84.95385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30701',
  },
  {
    city: 'Chatsworth',
    county_fips: 13213,
    county_fips_all: '13213',
    county: 'Murray',
    county_names_all: 'Murray',
    county_weights: '{"13213": 100}',
    density: 53.6,
    imprecise: false,
    latitude: 34.74711,
    longitude: -84.74929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30705',
  },
  {
    city: 'Chickamauga',
    county_fips: 13295,
    county_fips_all: '13295|13047',
    county: 'Walker',
    county_names_all: 'Walker|Catoosa',
    county_weights: '{"13295": 95.98, "13047": 4.02}',
    density: 53.3,
    imprecise: false,
    latitude: 34.77943,
    longitude: -85.36028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30707',
  },
  {
    city: 'Cisco',
    county_fips: 13213,
    county_fips_all: '13213',
    county: 'Murray',
    county_names_all: 'Murray',
    county_weights: '{"13213": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 34.93985,
    longitude: -84.66754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30708',
  },
  {
    city: 'Cohutta',
    county_fips: 13313,
    county_fips_all: '13313|13047',
    county: 'Whitfield',
    county_names_all: 'Whitfield|Catoosa',
    county_weights: '{"13313": 99.79, "13047": 0.21}',
    density: 60.8,
    imprecise: false,
    latitude: 34.95002,
    longitude: -84.91993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30710',
  },
  {
    city: 'Crandall',
    county_fips: 13213,
    county_fips_all: '13213',
    county: 'Murray',
    county_names_all: 'Murray',
    county_weights: '{"13213": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 34.92905,
    longitude: -84.76259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30711',
  },
  {
    city: 'Dalton',
    county_fips: 13313,
    county_fips_all: '13313',
    county: 'Whitfield',
    county_names_all: 'Whitfield',
    county_weights: '{"13313": 100}',
    density: 216.3,
    imprecise: false,
    latitude: 34.73472,
    longitude: -85.00289,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30720',
  },
  {
    city: 'Dalton',
    county_fips: 13313,
    county_fips_all: '13313|13213',
    county: 'Whitfield',
    county_names_all: 'Whitfield|Murray',
    county_weights: '{"13313": 95.77, "13213": 4.23}',
    density: 161.6,
    imprecise: false,
    latitude: 34.79168,
    longitude: -84.91187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30721',
  },
  {
    city: 'Eton',
    county_fips: 13213,
    county_fips_all: '13213',
    county: 'Murray',
    county_names_all: 'Murray',
    county_weights: '{"13213": 100}',
    density: 110.6,
    imprecise: false,
    latitude: 34.8253,
    longitude: -84.75795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30724',
  },
  {
    city: 'Flintstone',
    county_fips: 13295,
    county_fips_all: '13295',
    county: 'Walker',
    county_names_all: 'Walker',
    county_weights: '{"13295": 100}',
    density: 124.5,
    imprecise: false,
    latitude: 34.92443,
    longitude: -85.35359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30725',
  },
  {
    city: 'Graysville',
    county_fips: 13047,
    county_fips_all: '13047',
    county: 'Catoosa',
    county_names_all: 'Catoosa',
    county_weights: '{"13047": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.97579,
    longitude: -85.13959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30726',
  },
  {
    city: 'La Fayette',
    county_fips: 13295,
    county_fips_all: '13295',
    county: 'Walker',
    county_names_all: 'Walker',
    county_weights: '{"13295": 100}',
    density: 41.8,
    imprecise: false,
    latitude: 34.68015,
    longitude: -85.23417,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30728',
  },
  {
    city: 'Lyerly',
    county_fips: 13055,
    county_fips_all: '13055',
    county: 'Chattooga',
    county_names_all: 'Chattooga',
    county_weights: '{"13055": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 34.36017,
    longitude: -85.42172,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30730',
  },
  {
    city: 'Menlo',
    county_fips: 13055,
    county_fips_all: '13055|13295|13083',
    county: 'Chattooga',
    county_names_all: 'Chattooga|Walker|Dade',
    county_weights: '{"13055": 54.33, "13295": 29.82, "13083": 15.85}',
    density: 11.5,
    imprecise: false,
    latitude: 34.58317,
    longitude: -85.47894,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30731',
  },
  {
    city: 'Plainville',
    county_fips: 13129,
    county_fips_all: '13129|13115',
    county: 'Gordon',
    county_names_all: 'Gordon|Floyd',
    county_weights: '{"13129": 89.16, "13115": 10.84}',
    density: 62,
    imprecise: false,
    latitude: 34.41574,
    longitude: -85.04349,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30733',
  },
  {
    city: 'Ranger',
    county_fips: 13129,
    county_fips_all: '13129|13227',
    county: 'Gordon',
    county_names_all: 'Gordon|Pickens',
    county_weights: '{"13129": 88.4, "13227": 11.6}',
    density: 14.1,
    imprecise: false,
    latitude: 34.53361,
    longitude: -84.71346,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30734',
  },
  {
    city: 'Resaca',
    county_fips: 13129,
    county_fips_all: '13129|13213|13313',
    county: 'Gordon',
    county_names_all: 'Gordon|Murray|Whitfield',
    county_weights: '{"13129": 71.93, "13213": 20.14, "13313": 7.93}',
    density: 43.4,
    imprecise: false,
    latitude: 34.60183,
    longitude: -84.89375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30735',
  },
  {
    city: 'Ringgold',
    county_fips: 13047,
    county_fips_all: '13047|13313|13295',
    county: 'Catoosa',
    county_names_all: 'Catoosa|Whitfield|Walker',
    county_weights: '{"13047": 95.55, "13313": 3.13, "13295": 1.32}',
    density: 137.8,
    imprecise: false,
    latitude: 34.90244,
    longitude: -85.13306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30736',
  },
  {
    city: 'Rising Fawn',
    county_fips: 13083,
    county_fips_all: '13083|13295',
    county: 'Dade',
    county_names_all: 'Dade|Walker',
    county_weights: '{"13083": 68.3, "13295": 31.7}',
    density: 14.9,
    imprecise: false,
    latitude: 34.79534,
    longitude: -85.47846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30738',
  },
  {
    city: 'Rock Spring',
    county_fips: 13295,
    county_fips_all: '13295|13047',
    county: 'Walker',
    county_names_all: 'Walker|Catoosa',
    county_weights: '{"13295": 74.9, "13047": 25.1}',
    density: 101.9,
    imprecise: false,
    latitude: 34.80345,
    longitude: -85.21515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30739',
  },
  {
    city: 'Rocky Face',
    county_fips: 13313,
    county_fips_all: '13313|13295',
    county: 'Whitfield',
    county_names_all: 'Whitfield|Walker',
    county_weights: '{"13313": 91.99, "13295": 8.01}',
    density: 65.9,
    imprecise: false,
    latitude: 34.75407,
    longitude: -85.07786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30740',
  },
  {
    city: 'Rossville',
    county_fips: 13295,
    county_fips_all: '13295|13047',
    county: 'Walker',
    county_names_all: 'Walker|Catoosa',
    county_weights: '{"13295": 72.36, "13047": 27.64}',
    density: 466.4,
    imprecise: false,
    latitude: 34.95168,
    longitude: -85.28213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30741',
  },
  {
    city: 'Fort Oglethorpe',
    county_fips: 13047,
    county_fips_all: '13047|13295',
    county: 'Catoosa',
    county_names_all: 'Catoosa|Walker',
    county_weights: '{"13047": 99.87, "13295": 0.13}',
    density: 412.3,
    imprecise: false,
    latitude: 34.93566,
    longitude: -85.24482,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30742',
  },
  {
    city: 'Sugar Valley',
    county_fips: 13129,
    county_fips_all: '13129|13295',
    county: 'Gordon',
    county_names_all: 'Gordon|Walker',
    county_weights: '{"13129": 84.55, "13295": 15.45}',
    density: 27,
    imprecise: false,
    latitude: 34.59214,
    longitude: -85.03285,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30746',
  },
  {
    city: 'Summerville',
    county_fips: 13055,
    county_fips_all: '13055|13295',
    county: 'Chattooga',
    county_names_all: 'Chattooga|Walker',
    county_weights: '{"13055": 90.55, "13295": 9.45}',
    density: 28.9,
    imprecise: false,
    latitude: 34.50179,
    longitude: -85.29407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30747',
  },
  {
    city: 'Lookout Mountain',
    county_fips: 13295,
    county_fips_all: '13295|13083',
    county: 'Walker',
    county_names_all: 'Walker|Dade',
    county_weights: '{"13295": 63.4, "13083": 36.6}',
    density: 143.4,
    imprecise: false,
    latitude: 34.93681,
    longitude: -85.3882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30750',
  },
  {
    city: 'Tennga',
    county_fips: 13213,
    county_fips_all: '13213',
    county: 'Murray',
    county_names_all: 'Murray',
    county_weights: '{"13213": 100}',
    density: 227.5,
    imprecise: false,
    latitude: 34.98212,
    longitude: -84.73743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30751',
  },
  {
    city: 'Trenton',
    county_fips: 13083,
    county_fips_all: '13083',
    county: 'Dade',
    county_names_all: 'Dade',
    county_weights: '{"13083": 100}',
    density: 48.6,
    imprecise: false,
    latitude: 34.91136,
    longitude: -85.53079,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30752',
  },
  {
    city: 'Trion',
    county_fips: 13055,
    county_fips_all: '13055|13295',
    county: 'Chattooga',
    county_names_all: 'Chattooga|Walker',
    county_weights: '{"13055": 60.83, "13295": 39.17}',
    density: 77.3,
    imprecise: false,
    latitude: 34.57896,
    longitude: -85.28806,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30753',
  },
  {
    city: 'Tunnel Hill',
    county_fips: 13313,
    county_fips_all: '13313|13047',
    county: 'Whitfield',
    county_names_all: 'Whitfield|Catoosa',
    county_weights: '{"13313": 52.48, "13047": 47.52}',
    density: 102.9,
    imprecise: false,
    latitude: 34.86944,
    longitude: -85.04072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30755',
  },
  {
    city: 'Varnell',
    county_fips: 13313,
    county_fips_all: '13313',
    county: 'Whitfield',
    county_names_all: 'Whitfield',
    county_weights: '{"13313": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.90103,
    longitude: -84.97458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30756',
  },
  {
    city: 'Wildwood',
    county_fips: 13083,
    county_fips_all: '13083',
    county: 'Dade',
    county_names_all: 'Dade',
    county_weights: '{"13083": 100}',
    density: 30,
    imprecise: false,
    latitude: 34.94164,
    longitude: -85.4324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30757',
  },
  {
    city: 'Appling',
    county_fips: 13073,
    county_fips_all: '13073|13189',
    county: 'Columbia',
    county_names_all: 'Columbia|McDuffie',
    county_weights: '{"13073": 98.49, "13189": 1.51}',
    density: 19.2,
    imprecise: false,
    latitude: 33.60215,
    longitude: -82.31832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30802',
  },
  {
    city: 'Avera',
    county_fips: 13163,
    county_fips_all: '13163|13125',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Glascock',
    county_weights: '{"13163": 98.94, "13125": 1.06}',
    density: 7.2,
    imprecise: false,
    latitude: 33.13878,
    longitude: -82.55013,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30803',
  },
  {
    city: 'Blythe',
    county_fips: 13245,
    county_fips_all: '13245|13033',
    county: 'Richmond',
    county_names_all: 'Richmond|Burke',
    county_weights: '{"13245": 59.54, "13033": 40.46}',
    density: 24.7,
    imprecise: false,
    latitude: 33.28012,
    longitude: -82.19936,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30805',
  },
  {
    city: 'Camak',
    county_fips: 13301,
    county_fips_all: '13301',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"13301": 100}',
    density: 183.2,
    imprecise: false,
    latitude: 33.45517,
    longitude: -82.64777,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30807',
  },
  {
    city: 'Dearing',
    county_fips: 13189,
    county_fips_all: '13189|13301',
    county: 'McDuffie',
    county_names_all: 'McDuffie|Warren',
    county_weights: '{"13189": 98.28, "13301": 1.72}',
    density: 28.3,
    imprecise: false,
    latitude: 33.38234,
    longitude: -82.40237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30808',
  },
  {
    city: 'Evans',
    county_fips: 13073,
    county_fips_all: '13073',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"13073": 100}',
    density: 478.6,
    imprecise: false,
    latitude: 33.55522,
    longitude: -82.16357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30809',
  },
  {
    city: 'Gibson',
    county_fips: 13125,
    county_fips_all: '13125|13163|13301',
    county: 'Glascock',
    county_names_all: 'Glascock|Jefferson|Warren',
    county_weights: '{"13125": 90.84, "13163": 4.61, "13301": 4.55}',
    density: 10.2,
    imprecise: false,
    latitude: 33.23247,
    longitude: -82.58849,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30810',
  },
  {
    city: 'Gracewood',
    county_fips: 13245,
    county_fips_all: '13245',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"13245": 100}',
    density: 557.2,
    imprecise: false,
    latitude: 33.36731,
    longitude: -82.0291,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30812',
  },
  {
    city: 'Grovetown',
    county_fips: 13073,
    county_fips_all: '13073|13245',
    county: 'Columbia',
    county_names_all: 'Columbia|Richmond',
    county_weights: '{"13073": 95.34, "13245": 4.66}',
    density: 401.9,
    imprecise: false,
    latitude: 33.47037,
    longitude: -82.2193,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30813',
  },
  {
    city: 'Harlem',
    county_fips: 13073,
    county_fips_all: '13073|13189',
    county: 'Columbia',
    county_names_all: 'Columbia|McDuffie',
    county_weights: '{"13073": 83.95, "13189": 16.05}',
    density: 77.1,
    imprecise: false,
    latitude: 33.43604,
    longitude: -82.31879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30814',
  },
  {
    city: 'Hephzibah',
    county_fips: 13245,
    county_fips_all: '13245|13033',
    county: 'Richmond',
    county_names_all: 'Richmond|Burke',
    county_weights: '{"13245": 71.93, "13033": 28.07}',
    density: 134.5,
    imprecise: false,
    latitude: 33.2869,
    longitude: -82.0829,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30815',
  },
  {
    city: 'Keysville',
    county_fips: 13033,
    county_fips_all: '13033|13163',
    county: 'Burke',
    county_names_all: 'Burke|Jefferson',
    county_weights: '{"13033": 86.53, "13163": 13.47}',
    density: 7.5,
    imprecise: false,
    latitude: 33.1639,
    longitude: -82.17061,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30816',
  },
  {
    city: 'Lincolnton',
    county_fips: 13181,
    county_fips_all: '13181|13317',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Wilkes',
    county_weights: '{"13181": 98.35, "13317": 1.65}',
    density: 15.3,
    imprecise: false,
    latitude: 33.7746,
    longitude: -82.43469,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30817',
  },
  {
    city: 'Matthews',
    county_fips: 13163,
    county_fips_all: '13163',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"13163": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 33.26765,
    longitude: -82.32646,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30818',
  },
  {
    city: 'Mitchell',
    county_fips: 13125,
    county_fips_all: '13125|13301|13303|13141',
    county: 'Glascock',
    county_names_all: 'Glascock|Warren|Washington|Hancock',
    county_weights:
      '{"13125": 54.22, "13301": 16.95, "13303": 16.43, "13141": 12.4}',
    density: 4.6,
    imprecise: false,
    latitude: 33.22457,
    longitude: -82.71989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30820',
  },
  {
    city: 'Norwood',
    county_fips: 13301,
    county_fips_all: '13301',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"13301": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 33.48502,
    longitude: -82.73121,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30821',
  },
  {
    city: 'Perkins',
    county_fips: 13165,
    county_fips_all: '13165',
    county: 'Jenkins',
    county_names_all: 'Jenkins',
    county_weights: '{"13165": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.91866,
    longitude: -81.94439,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30822',
  },
  {
    city: 'Stapleton',
    county_fips: 13163,
    county_fips_all: '13163|13301|13125',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Warren|Glascock',
    county_weights: '{"13163": 59.18, "13301": 24.59, "13125": 16.23}',
    density: 9,
    imprecise: false,
    latitude: 33.222,
    longitude: -82.45647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30823',
  },
  {
    city: 'Thomson',
    county_fips: 13189,
    county_fips_all: '13189|13301|13073',
    county: 'McDuffie',
    county_names_all: 'McDuffie|Warren|Columbia',
    county_weights: '{"13189": 98.33, "13301": 1.5, "13073": 0.17}',
    density: 34.9,
    imprecise: false,
    latitude: 33.51586,
    longitude: -82.51467,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30824',
  },
  {
    city: 'Warrenton',
    county_fips: 13301,
    county_fips_all: '13301|13125',
    county: 'Warren',
    county_names_all: 'Warren|Glascock',
    county_weights: '{"13301": 96.22, "13125": 3.78}',
    density: 9.8,
    imprecise: false,
    latitude: 33.37281,
    longitude: -82.65351,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30828',
  },
  {
    city: 'Waynesboro',
    county_fips: 13033,
    county_fips_all: '13033',
    county: 'Burke',
    county_names_all: 'Burke',
    county_weights: '{"13033": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 33.08204,
    longitude: -81.9751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30830',
  },
  {
    city: 'Wrens',
    county_fips: 13163,
    county_fips_all: '13163',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"13163": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 33.18934,
    longitude: -82.36014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30833',
  },
  {
    city: 'Augusta',
    county_fips: 13245,
    county_fips_all: '13245',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"13245": 100}',
    density: 361.3,
    imprecise: false,
    latitude: 33.43811,
    longitude: -81.95327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30901',
  },
  {
    city: 'Augusta',
    county_fips: 13245,
    county_fips_all: '13245',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"13245": 100}',
    density: 823.4,
    imprecise: false,
    latitude: 33.47864,
    longitude: -82.01315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30904',
  },
  {
    city: 'Augusta',
    county_fips: 13245,
    county_fips_all: '13245',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"13245": 100}',
    density: 149.4,
    imprecise: false,
    latitude: 33.4087,
    longitude: -82.15073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30905',
  },
  {
    city: 'Augusta',
    county_fips: 13245,
    county_fips_all: '13245',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"13245": 100}',
    density: 269.1,
    imprecise: false,
    latitude: 33.34842,
    longitude: -81.97239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30906',
  },
  {
    city: 'Augusta',
    county_fips: 13073,
    county_fips_all: '13073|13245',
    county: 'Columbia',
    county_names_all: 'Columbia|Richmond',
    county_weights: '{"13073": 77.23, "13245": 22.77}',
    density: 751.9,
    imprecise: false,
    latitude: 33.52193,
    longitude: -82.08596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30907',
  },
  {
    city: 'Augusta',
    county_fips: 13245,
    county_fips_all: '13245|13073',
    county: 'Richmond',
    county_names_all: 'Richmond|Columbia',
    county_weights: '{"13245": 98.46, "13073": 1.54}',
    density: 704.4,
    imprecise: false,
    latitude: 33.47068,
    longitude: -82.08376,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30909',
  },
  {
    city: 'Abbeville',
    county_fips: 13315,
    county_fips_all: '13315',
    county: 'Wilcox',
    county_names_all: 'Wilcox',
    county_weights: '{"13315": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 31.97595,
    longitude: -83.33979,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31001',
  },
  {
    city: 'Adrian',
    county_fips: 13107,
    county_fips_all: '13107|13175|13167|13283',
    county: 'Emanuel',
    county_names_all: 'Emanuel|Laurens|Johnson|Treutlen',
    county_weights:
      '{"13107": 45.23, "13175": 21.73, "13167": 21.39, "13283": 11.65}',
    density: 9,
    imprecise: false,
    latitude: 32.54802,
    longitude: -82.59012,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31002',
  },
  {
    city: 'Allentown',
    county_fips: 13319,
    county_fips_all: '13319',
    county: 'Wilkinson',
    county_names_all: 'Wilkinson',
    county_weights: '{"13319": 100}',
    density: 41.6,
    imprecise: false,
    latitude: 32.59688,
    longitude: -83.22299,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31003',
  },
  {
    city: 'Bolingbroke',
    county_fips: 13207,
    county_fips_all: '13207',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"13207": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.95167,
    longitude: -83.80536,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31004',
  },
  {
    city: 'Bonaire',
    county_fips: 13153,
    county_fips_all: '13153',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"13153": 100}',
    density: 368.7,
    imprecise: false,
    latitude: 32.54533,
    longitude: -83.59497,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31005',
  },
  {
    city: 'Butler',
    county_fips: 13269,
    county_fips_all: '13269',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"13269": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 32.58164,
    longitude: -84.25531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31006',
  },
  {
    city: 'Byromville',
    county_fips: 13093,
    county_fips_all: '13093',
    county: 'Dooly',
    county_names_all: 'Dooly',
    county_weights: '{"13093": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 32.18917,
    longitude: -83.93377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31007',
  },
  {
    city: 'Byron',
    county_fips: 13225,
    county_fips_all: '13225|13079|13153',
    county: 'Peach',
    county_names_all: 'Peach|Crawford|Houston',
    county_weights: '{"13225": 61.92, "13079": 34.27, "13153": 3.81}',
    density: 122.7,
    imprecise: false,
    latitude: 32.65479,
    longitude: -83.78287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31008',
  },
  {
    city: 'Cadwell',
    county_fips: 13175,
    county_fips_all: '13175',
    county: 'Laurens',
    county_names_all: 'Laurens',
    county_weights: '{"13175": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 32.27636,
    longitude: -83.00564,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31009',
  },
  {
    city: 'Chauncey',
    county_fips: 13091,
    county_fips_all: '13091|13175',
    county: 'Dodge',
    county_names_all: 'Dodge|Laurens',
    county_weights: '{"13091": 96.09, "13175": 3.91}',
    density: 3.6,
    imprecise: false,
    latitude: 32.13315,
    longitude: -83.0556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31011',
  },
  {
    city: 'Chester',
    county_fips: 13091,
    county_fips_all: '13091|13023|13175',
    county: 'Dodge',
    county_names_all: 'Dodge|Bleckley|Laurens',
    county_weights: '{"13091": 74.72, "13023": 22.67, "13175": 2.61}',
    density: 19.7,
    imprecise: false,
    latitude: 32.39422,
    longitude: -83.17717,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31012',
  },
  {
    city: 'Cochran',
    county_fips: 13023,
    county_fips_all: '13023|13091|13289|13235',
    county: 'Bleckley',
    county_names_all: 'Bleckley|Dodge|Twiggs|Pulaski',
    county_weights:
      '{"13023": 77.04, "13091": 14.13, "13289": 8.5, "13235": 0.33}',
    density: 23.6,
    imprecise: false,
    latitude: 32.41439,
    longitude: -83.34504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31014',
  },
  {
    city: 'Cordele',
    county_fips: 13081,
    county_fips_all: '13081|13315|13093',
    county: 'Crisp',
    county_names_all: 'Crisp|Wilcox|Dooly',
    county_weights: '{"13081": 96.57, "13315": 2.93, "13093": 0.5}',
    density: 33.8,
    imprecise: false,
    latitude: 31.93729,
    longitude: -83.77444,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31015',
  },
  {
    city: 'Culloden',
    county_fips: 13207,
    county_fips_all: '13207|13293|13079|13171',
    county: 'Monroe',
    county_names_all: 'Monroe|Upson|Crawford|Lamar',
    county_weights:
      '{"13207": 43.44, "13293": 33.75, "13079": 17.93, "13171": 4.88}',
    density: 7.1,
    imprecise: false,
    latitude: 32.83656,
    longitude: -84.11477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31016',
  },
  {
    city: 'Danville',
    county_fips: 13319,
    county_fips_all: '13319|13289|13023',
    county: 'Wilkinson',
    county_names_all: 'Wilkinson|Twiggs|Bleckley',
    county_weights: '{"13319": 52.92, "13289": 27.53, "13023": 19.55}',
    density: 5.4,
    imprecise: false,
    latitude: 32.62075,
    longitude: -83.23305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31017',
  },
  {
    city: 'Davisboro',
    county_fips: 13303,
    county_fips_all: '13303',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"13303": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 32.97888,
    longitude: -82.62012,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31018',
  },
  {
    city: 'Dexter',
    county_fips: 13175,
    county_fips_all: '13175',
    county: 'Laurens',
    county_names_all: 'Laurens',
    county_weights: '{"13175": 100}',
    density: 22.7,
    imprecise: false,
    latitude: 32.42622,
    longitude: -83.0534,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31019',
  },
  {
    city: 'Dry Branch',
    county_fips: 13289,
    county_fips_all: '13289|13021',
    county: 'Twiggs',
    county_names_all: 'Twiggs|Bibb',
    county_weights: '{"13289": 96.06, "13021": 3.94}',
    density: 4.9,
    imprecise: false,
    latitude: 32.65376,
    longitude: -83.501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31020',
  },
  {
    city: 'Dublin',
    county_fips: 13175,
    county_fips_all: '13175',
    county: 'Laurens',
    county_names_all: 'Laurens',
    county_weights: '{"13175": 100}',
    density: 46.6,
    imprecise: false,
    latitude: 32.49002,
    longitude: -82.93435,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31021',
  },
  {
    city: 'Dudley',
    county_fips: 13175,
    county_fips_all: '13175|13023',
    county: 'Laurens',
    county_names_all: 'Laurens|Bleckley',
    county_weights: '{"13175": 95.11, "13023": 4.89}',
    density: 13.6,
    imprecise: false,
    latitude: 32.51216,
    longitude: -83.10954,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31022',
  },
  {
    city: 'Eastman',
    county_fips: 13091,
    county_fips_all: '13091|13235',
    county: 'Dodge',
    county_names_all: 'Dodge|Pulaski',
    county_weights: '{"13091": 96.46, "13235": 3.54}',
    density: 19,
    imprecise: false,
    latitude: 32.18288,
    longitude: -83.1991,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31023',
  },
  {
    city: 'Eatonton',
    county_fips: 13237,
    county_fips_all: '13237',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"13237": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 33.32344,
    longitude: -83.36987,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31024',
  },
  {
    city: 'Elko',
    county_fips: 13153,
    county_fips_all: '13153',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"13153": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 32.33833,
    longitude: -83.73876,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31025',
  },
  {
    city: 'East Dublin',
    county_fips: 13175,
    county_fips_all: '13175',
    county: 'Laurens',
    county_names_all: 'Laurens',
    county_weights: '{"13175": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 32.57405,
    longitude: -82.81959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31027',
  },
  {
    city: 'Centerville',
    county_fips: 13153,
    county_fips_all: '13153',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"13153": 100}',
    density: 875.4,
    imprecise: false,
    latitude: 32.63164,
    longitude: -83.68459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31028',
  },
  {
    city: 'Forsyth',
    county_fips: 13207,
    county_fips_all: '13207',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"13207": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 33.03894,
    longitude: -83.92977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31029',
  },
  {
    city: 'Fort Valley',
    county_fips: 13225,
    county_fips_all: '13225|13079|13193',
    county: 'Peach',
    county_names_all: 'Peach|Crawford|Macon',
    county_weights: '{"13225": 58.56, "13079": 38.05, "13193": 3.39}',
    density: 38.6,
    imprecise: false,
    latitude: 32.56861,
    longitude: -83.89103,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31030',
  },
  {
    city: 'Gordon',
    county_fips: 13319,
    county_fips_all: '13319|13289|13009|13169',
    county: 'Wilkinson',
    county_names_all: 'Wilkinson|Twiggs|Baldwin|Jones',
    county_weights:
      '{"13319": 65.99, "13289": 16.68, "13009": 13.08, "13169": 4.25}',
    density: 21.3,
    imprecise: false,
    latitude: 32.87424,
    longitude: -83.32555,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31031',
  },
  {
    city: 'Gray',
    county_fips: 13169,
    county_fips_all: '13169',
    county: 'Jones',
    county_names_all: 'Jones',
    county_weights: '{"13169": 100}',
    density: 34.4,
    imprecise: false,
    latitude: 33.01039,
    longitude: -83.57292,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31032',
  },
  {
    city: 'Haddock',
    county_fips: 13169,
    county_fips_all: '13169|13009',
    county: 'Jones',
    county_names_all: 'Jones|Baldwin',
    county_weights: '{"13169": 88.65, "13009": 11.35}',
    density: 15.8,
    imprecise: false,
    latitude: 33.07661,
    longitude: -83.43643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31033',
  },
  {
    city: 'Hardwick',
    county_fips: 13009,
    county_fips_all: '13009',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"13009": 100}',
    density: 107,
    imprecise: false,
    latitude: 33.05473,
    longitude: -83.22538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31034',
  },
  {
    city: 'Harrison',
    county_fips: 13303,
    county_fips_all: '13303',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"13303": 100}',
    density: 10,
    imprecise: false,
    latitude: 32.84601,
    longitude: -82.7062,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31035',
  },
  {
    city: 'Hawkinsville',
    county_fips: 13235,
    county_fips_all: '13235|13153|13023|13091',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Houston|Bleckley|Dodge',
    county_weights:
      '{"13235": 81.94, "13153": 16.66, "13023": 1.08, "13091": 0.32}',
    density: 17.5,
    imprecise: false,
    latitude: 32.27055,
    longitude: -83.49597,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31036',
  },
  {
    city: 'McRae Helena',
    county_fips: 13271,
    county_fips_all: '13271|13091|13309|13175',
    county: 'Telfair',
    county_names_all: 'Telfair|Dodge|Wheeler|Laurens',
    county_weights:
      '{"13271": 36.14, "13091": 29.48, "13309": 25.6, "13175": 8.77}',
    density: 22.5,
    imprecise: false,
    latitude: 32.12056,
    longitude: -82.93245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31037',
  },
  {
    city: 'Hillsboro',
    county_fips: 13169,
    county_fips_all: '13169|13159|13237',
    county: 'Jones',
    county_names_all: 'Jones|Jasper|Putnam',
    county_weights: '{"13169": 58.52, "13159": 32.49, "13237": 8.99}',
    density: 2.3,
    imprecise: false,
    latitude: 33.15554,
    longitude: -83.61644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31038',
  },
  {
    city: 'Howard',
    county_fips: 13269,
    county_fips_all: '13269',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"13269": 100}',
    density: 6,
    imprecise: false,
    latitude: 32.6024,
    longitude: -84.38036,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31039',
  },
  {
    city: 'Ideal',
    county_fips: 13193,
    county_fips_all: '13193',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"13193": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 32.37905,
    longitude: -84.1721,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31041',
  },
  {
    city: 'Irwinton',
    county_fips: 13319,
    county_fips_all: '13319',
    county: 'Wilkinson',
    county_names_all: 'Wilkinson',
    county_weights: '{"13319": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 32.74421,
    longitude: -83.16964,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31042',
  },
  {
    city: 'Jeffersonville',
    county_fips: 13289,
    county_fips_all: '13289|13319',
    county: 'Twiggs',
    county_names_all: 'Twiggs|Wilkinson',
    county_weights: '{"13289": 91.12, "13319": 8.88}',
    density: 7.9,
    imprecise: false,
    latitude: 32.66857,
    longitude: -83.37612,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31044',
  },
  {
    city: 'Jewell',
    county_fips: 13141,
    county_fips_all: '13141|13301',
    county: 'Hancock',
    county_names_all: 'Hancock|Warren',
    county_weights: '{"13141": 75.24, "13301": 24.76}',
    density: 1.8,
    imprecise: false,
    latitude: 33.28484,
    longitude: -82.78933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31045',
  },
  {
    city: 'Juliette',
    county_fips: 13207,
    county_fips_all: '13207|13169',
    county: 'Monroe',
    county_names_all: 'Monroe|Jones',
    county_weights: '{"13207": 69.72, "13169": 30.28}',
    density: 16.9,
    imprecise: false,
    latitude: 33.05237,
    longitude: -83.78302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31046',
  },
  {
    city: 'Kathleen',
    county_fips: 13153,
    county_fips_all: '13153',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"13153": 100}',
    density: 103.6,
    imprecise: false,
    latitude: 32.46786,
    longitude: -83.58009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31047',
  },
  {
    city: 'Kite',
    county_fips: 13167,
    county_fips_all: '13167|13107',
    county: 'Johnson',
    county_names_all: 'Johnson|Emanuel',
    county_weights: '{"13167": 80.15, "13107": 19.85}',
    density: 6.6,
    imprecise: false,
    latitude: 32.68281,
    longitude: -82.52634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31049',
  },
  {
    city: 'Knoxville',
    county_fips: 13079,
    county_fips_all: '13079',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"13079": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 32.72924,
    longitude: -83.94096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31050',
  },
  {
    city: 'Lilly',
    county_fips: 13093,
    county_fips_all: '13093',
    county: 'Dooly',
    county_names_all: 'Dooly',
    county_weights: '{"13093": 100}',
    density: 110.1,
    imprecise: false,
    latitude: 32.14456,
    longitude: -83.87812,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31051',
  },
  {
    city: 'Lizella',
    county_fips: 13021,
    county_fips_all: '13021|13079',
    county: 'Bibb',
    county_names_all: 'Bibb|Crawford',
    county_weights: '{"13021": 52.27, "13079": 47.73}',
    density: 48.8,
    imprecise: false,
    latitude: 32.7743,
    longitude: -83.84664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31052',
  },
  {
    city: 'McIntyre',
    county_fips: 13319,
    county_fips_all: '13319',
    county: 'Wilkinson',
    county_names_all: 'Wilkinson',
    county_weights: '{"13319": 100}',
    density: 9,
    imprecise: false,
    latitude: 32.88214,
    longitude: -83.20723,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31054',
  },
  {
    city: 'McRae Helena',
    county_fips: 13271,
    county_fips_all: '13271',
    county: 'Telfair',
    county_names_all: 'Telfair',
    county_weights: '{"13271": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 31.98248,
    longitude: -82.89046,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31055',
  },
  {
    city: 'Marshallville',
    county_fips: 13193,
    county_fips_all: '13193',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"13193": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 32.43319,
    longitude: -83.94324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31057',
  },
  {
    city: 'Mauk',
    county_fips: 13269,
    county_fips_all: '13269|13197|13249',
    county: 'Taylor',
    county_names_all: 'Taylor|Marion|Schley',
    county_weights: '{"13269": 59.86, "13197": 39.58, "13249": 0.56}',
    density: 7.2,
    imprecise: false,
    latitude: 32.4911,
    longitude: -84.41273,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31058',
  },
  {
    city: 'Milan',
    county_fips: 13271,
    county_fips_all: '13271|13091',
    county: 'Telfair',
    county_names_all: 'Telfair|Dodge',
    county_weights: '{"13271": 70.04, "13091": 29.96}',
    density: 8.6,
    imprecise: false,
    latitude: 31.98333,
    longitude: -83.05673,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31060',
  },
  {
    city: 'Milledgeville',
    county_fips: 13009,
    county_fips_all: '13009|13319|13141|13237',
    county: 'Baldwin',
    county_names_all: 'Baldwin|Wilkinson|Hancock|Putnam',
    county_weights:
      '{"13009": 81.11, "13319": 14.39, "13141": 3.32, "13237": 1.18}',
    density: 59.1,
    imprecise: false,
    latitude: 33.06041,
    longitude: -83.22816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31061',
  },
  {
    city: 'Montezuma',
    county_fips: 13193,
    county_fips_all: '13193|13093',
    county: 'Macon',
    county_names_all: 'Macon|Dooly',
    county_weights: '{"13193": 88.2, "13093": 11.8}',
    density: 14.7,
    imprecise: false,
    latitude: 32.29249,
    longitude: -83.9648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31063',
  },
  {
    city: 'Monticello',
    county_fips: 13159,
    county_fips_all: '13159',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"13159": 100}',
    density: 16.1,
    imprecise: false,
    latitude: 33.29031,
    longitude: -83.69986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31064',
  },
  {
    city: 'Montrose',
    county_fips: 13175,
    county_fips_all: '13175|13023|13319',
    county: 'Laurens',
    county_names_all: 'Laurens|Bleckley|Wilkinson',
    county_weights: '{"13175": 66.24, "13023": 26.56, "13319": 7.2}',
    density: 8.4,
    imprecise: false,
    latitude: 32.56301,
    longitude: -83.16642,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31065',
  },
  {
    city: 'Musella',
    county_fips: 13079,
    county_fips_all: '13079|13207|13021',
    county: 'Crawford',
    county_names_all: 'Crawford|Monroe|Bibb',
    county_weights: '{"13079": 92.8, "13207": 6.0, "13021": 1.2}',
    density: 5,
    imprecise: false,
    latitude: 32.80757,
    longitude: -83.98953,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31066',
  },
  {
    city: 'Oconee',
    county_fips: 13303,
    county_fips_all: '13303|13319',
    county: 'Washington',
    county_names_all: 'Washington|Wilkinson',
    county_weights: '{"13303": 99.56, "13319": 0.44}',
    density: 62.9,
    imprecise: false,
    latitude: 32.85229,
    longitude: -82.96471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31067',
  },
  {
    city: 'Oglethorpe',
    county_fips: 13193,
    county_fips_all: '13193',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"13193": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 32.33226,
    longitude: -84.10704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31068',
  },
  {
    city: 'Perry',
    county_fips: 13153,
    county_fips_all: '13153|13225|13193',
    county: 'Houston',
    county_names_all: 'Houston|Peach|Macon',
    county_weights: '{"13153": 95.58, "13225": 3.82, "13193": 0.6}',
    density: 88.8,
    imprecise: false,
    latitude: 32.4406,
    longitude: -83.74373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31069',
  },
  {
    city: 'Pinehurst',
    county_fips: 13093,
    county_fips_all: '13093',
    county: 'Dooly',
    county_names_all: 'Dooly',
    county_weights: '{"13093": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 32.18801,
    longitude: -83.78669,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31070',
  },
  {
    city: 'Pineview',
    county_fips: 13235,
    county_fips_all: '13235|13315',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Wilcox',
    county_weights: '{"13235": 68.07, "13315": 31.93}',
    density: 7.1,
    imprecise: false,
    latitude: 32.13325,
    longitude: -83.52255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31071',
  },
  {
    city: 'Pitts',
    county_fips: 13315,
    county_fips_all: '13315|13081|13093',
    county: 'Wilcox',
    county_names_all: 'Wilcox|Crisp|Dooly',
    county_weights: '{"13315": 92.65, "13081": 5.04, "13093": 2.31}',
    density: 5.6,
    imprecise: false,
    latitude: 31.96582,
    longitude: -83.56619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31072',
  },
  {
    city: 'Rentz',
    county_fips: 13175,
    county_fips_all: '13175',
    county: 'Laurens',
    county_names_all: 'Laurens',
    county_weights: '{"13175": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 32.35428,
    longitude: -82.95277,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31075',
  },
  {
    city: 'Reynolds',
    county_fips: 13269,
    county_fips_all: '13269|13193',
    county: 'Taylor',
    county_names_all: 'Taylor|Macon',
    county_weights: '{"13269": 69.78, "13193": 30.22}',
    density: 9.3,
    imprecise: false,
    latitude: 32.54709,
    longitude: -84.10762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31076',
  },
  {
    city: 'Rhine',
    county_fips: 13091,
    county_fips_all: '13091|13271',
    county: 'Dodge',
    county_names_all: 'Dodge|Telfair',
    county_weights: '{"13091": 53.2, "13271": 46.8}',
    density: 6.9,
    imprecise: false,
    latitude: 31.93489,
    longitude: -83.17727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31077',
  },
  {
    city: 'Roberta',
    county_fips: 13079,
    county_fips_all: '13079',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"13079": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 32.6987,
    longitude: -84.06456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31078',
  },
  {
    city: 'Rochelle',
    county_fips: 13315,
    county_fips_all: '13315|13017',
    county: 'Wilcox',
    county_names_all: 'Wilcox|Ben Hill',
    county_weights: '{"13315": 90.89, "13017": 9.11}',
    density: 8.3,
    imprecise: false,
    latitude: 31.94104,
    longitude: -83.46303,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31079',
  },
  {
    city: 'Rupert',
    county_fips: 13269,
    county_fips_all: '13269|13193|13249',
    county: 'Taylor',
    county_names_all: 'Taylor|Macon|Schley',
    county_weights: '{"13269": 88.3, "13193": 10.51, "13249": 1.19}',
    density: 2.2,
    imprecise: false,
    latitude: 32.40824,
    longitude: -84.27725,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31081',
  },
  {
    city: 'Sandersville',
    county_fips: 13303,
    county_fips_all: '13303|13009',
    county: 'Washington',
    county_names_all: 'Washington|Baldwin',
    county_weights: '{"13303": 97.13, "13009": 2.87}',
    density: 17.4,
    imprecise: false,
    latitude: 32.992,
    longitude: -82.89815,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31082',
  },
  {
    city: 'Scotland',
    county_fips: 13271,
    county_fips_all: '13271',
    county: 'Telfair',
    county_names_all: 'Telfair',
    county_weights: '{"13271": 100}',
    density: 88.5,
    imprecise: false,
    latitude: 32.04473,
    longitude: -82.81957,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31083',
  },
  {
    city: 'Shady Dale',
    county_fips: 13159,
    county_fips_all: '13159',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"13159": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 33.42557,
    longitude: -83.631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31085',
  },
  {
    city: 'Sparta',
    county_fips: 13141,
    county_fips_all: '13141|13009|13303',
    county: 'Hancock',
    county_names_all: 'Hancock|Baldwin|Washington',
    county_weights: '{"13141": 97.67, "13009": 1.6, "13303": 0.73}',
    density: 7.8,
    imprecise: false,
    latitude: 33.26609,
    longitude: -83.00712,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31087',
  },
  {
    city: 'Warner Robins',
    county_fips: 13153,
    county_fips_all: '13153',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"13153": 100}',
    density: 768.4,
    imprecise: false,
    latitude: 32.58587,
    longitude: -83.65528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31088',
  },
  {
    city: 'Tennille',
    county_fips: 13303,
    county_fips_all: '13303|13167',
    county: 'Washington',
    county_names_all: 'Washington|Johnson',
    county_weights: '{"13303": 84.92, "13167": 15.08}',
    density: 10.4,
    imprecise: false,
    latitude: 32.85239,
    longitude: -82.86361,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31089',
  },
  {
    city: 'Toomsboro',
    county_fips: 13319,
    county_fips_all: '13319',
    county: 'Wilkinson',
    county_names_all: 'Wilkinson',
    county_weights: '{"13319": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 32.79599,
    longitude: -83.0512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31090',
  },
  {
    city: 'Unadilla',
    county_fips: 13093,
    county_fips_all: '13093|13235|13153',
    county: 'Dooly',
    county_names_all: 'Dooly|Pulaski|Houston',
    county_weights: '{"13093": 94.86, "13235": 2.67, "13153": 2.47}',
    density: 17.6,
    imprecise: false,
    latitude: 32.23653,
    longitude: -83.69966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31091',
  },
  {
    city: 'Vienna',
    county_fips: 13093,
    county_fips_all: '13093|13081|13315',
    county: 'Dooly',
    county_names_all: 'Dooly|Crisp|Wilcox',
    county_weights: '{"13093": 91.26, "13081": 5.39, "13315": 3.35}',
    density: 10.3,
    imprecise: false,
    latitude: 32.08984,
    longitude: -83.78304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31092',
  },
  {
    city: 'Warner Robins',
    county_fips: 13153,
    county_fips_all: '13153',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"13153": 100}',
    density: 508.1,
    imprecise: false,
    latitude: 32.64815,
    longitude: -83.65688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31093',
  },
  {
    city: 'Warthen',
    county_fips: 13303,
    county_fips_all: '13303',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"13303": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 33.11378,
    longitude: -82.79892,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31094',
  },
  {
    city: 'Wrightsville',
    county_fips: 13167,
    county_fips_all: '13167|13303|13175',
    county: 'Johnson',
    county_names_all: 'Johnson|Washington|Laurens',
    county_weights: '{"13167": 88.74, "13303": 6.9, "13175": 4.36}',
    density: 15.3,
    imprecise: false,
    latitude: 32.71875,
    longitude: -82.70636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31096',
  },
  {
    city: 'Yatesville',
    county_fips: 13293,
    county_fips_all: '13293|13171|13207',
    county: 'Upson',
    county_names_all: 'Upson|Lamar|Monroe',
    county_weights: '{"13293": 86.74, "13171": 11.59, "13207": 1.67}',
    density: 9.9,
    imprecise: false,
    latitude: 32.89947,
    longitude: -84.15554,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31097',
  },
  {
    city: 'Warner Robins',
    county_fips: 13153,
    county_fips_all: '13153',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"13153": 100}',
    density: 69,
    imprecise: false,
    latitude: 32.61898,
    longitude: -83.57357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31098',
  },
  {
    city: 'Macon',
    county_fips: 13021,
    county_fips_all: '13021',
    county: 'Bibb',
    county_names_all: 'Bibb',
    county_weights: '{"13021": 100}',
    density: 325.4,
    imprecise: false,
    latitude: 32.81433,
    longitude: -83.61846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31201',
  },
  {
    city: 'Macon',
    county_fips: 13021,
    county_fips_all: '13021',
    county: 'Bibb',
    county_names_all: 'Bibb',
    county_weights: '{"13021": 100}',
    density: 858.3,
    imprecise: false,
    latitude: 32.84996,
    longitude: -83.67609,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31204',
  },
  {
    city: 'Macon',
    county_fips: 13021,
    county_fips_all: '13021',
    county: 'Bibb',
    county_names_all: 'Bibb',
    county_weights: '{"13021": 100}',
    density: 352.2,
    imprecise: false,
    latitude: 32.79383,
    longitude: -83.6832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31206',
  },
  {
    city: 'Macon',
    county_fips: 13021,
    county_fips_all: '13021|13207',
    county: 'Bibb',
    county_names_all: 'Bibb|Monroe',
    county_weights: '{"13021": 75.17, "13207": 24.83}',
    density: 310.9,
    imprecise: false,
    latitude: 32.90486,
    longitude: -83.7356,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31210',
  },
  {
    city: 'Macon',
    county_fips: 13169,
    county_fips_all: '13169|13021',
    county: 'Jones',
    county_names_all: 'Jones|Bibb',
    county_weights: '{"13169": 81.46, "13021": 18.54}',
    density: 138.2,
    imprecise: false,
    latitude: 32.90665,
    longitude: -83.60435,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31211',
  },
  {
    city: 'Macon',
    county_fips: 13021,
    county_fips_all: '13021',
    county: 'Bibb',
    county_names_all: 'Bibb',
    county_weights: '{"13021": 100}',
    density: 109.9,
    imprecise: false,
    latitude: 32.72885,
    longitude: -83.67914,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31216',
  },
  {
    city: 'Macon',
    county_fips: 13169,
    county_fips_all: '13169|13021|13289',
    county: 'Jones',
    county_names_all: 'Jones|Bibb|Twiggs',
    county_weights: '{"13169": 39.78, "13021": 30.49, "13289": 29.73}',
    density: 63.5,
    imprecise: false,
    latitude: 32.84506,
    longitude: -83.50568,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31217',
  },
  {
    city: 'Macon',
    county_fips: 13021,
    county_fips_all: '13021|13207',
    county: 'Bibb',
    county_names_all: 'Bibb|Monroe',
    county_weights: '{"13021": 57.28, "13207": 42.72}',
    density: 131.9,
    imprecise: false,
    latitude: 32.87813,
    longitude: -83.8209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31220',
  },
  {
    city: 'Allenhurst',
    county_fips: 13179,
    county_fips_all: '13179|13183',
    county: 'Liberty',
    county_names_all: 'Liberty|Long',
    county_weights: '{"13179": 57.45, "13183": 42.55}',
    density: 108,
    imprecise: false,
    latitude: 31.7581,
    longitude: -81.60386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31301',
  },
  {
    city: 'Bloomingdale',
    county_fips: 13051,
    county_fips_all: '13051|13103',
    county: 'Chatham',
    county_names_all: 'Chatham|Effingham',
    county_weights: '{"13051": 58.62, "13103": 41.38}',
    density: 82,
    imprecise: false,
    latitude: 32.12567,
    longitude: -81.34134,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31302',
  },
  {
    city: 'Clyo',
    county_fips: 13103,
    county_fips_all: '13103',
    county: 'Effingham',
    county_names_all: 'Effingham',
    county_weights: '{"13103": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 32.49631,
    longitude: -81.30616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31303',
  },
  {
    city: 'Darien',
    county_fips: 13191,
    county_fips_all: '13191',
    county: 'McIntosh',
    county_names_all: 'McIntosh',
    county_weights: '{"13191": 100}',
    density: 31.9,
    imprecise: false,
    latitude: 31.39057,
    longitude: -81.39054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31305',
  },
  {
    city: 'Eden',
    county_fips: 13103,
    county_fips_all: '13103|13029',
    county: 'Effingham',
    county_names_all: 'Effingham|Bryan',
    county_weights: '{"13103": 99.9, "13029": 0.1}',
    density: 143.6,
    imprecise: false,
    latitude: 32.17979,
    longitude: -81.3967,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31307',
  },
  {
    city: 'Ellabell',
    county_fips: 13029,
    county_fips_all: '13029|13031',
    county: 'Bryan',
    county_names_all: 'Bryan|Bulloch',
    county_weights: '{"13029": 80.52, "13031": 19.48}',
    density: 38.5,
    imprecise: false,
    latitude: 32.1758,
    longitude: -81.48024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31308',
  },
  {
    city: 'Fleming',
    county_fips: 13179,
    county_fips_all: '13179',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"13179": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 31.88382,
    longitude: -81.44358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31309',
  },
  {
    city: 'Guyton',
    county_fips: 13103,
    county_fips_all: '13103',
    county: 'Effingham',
    county_names_all: 'Effingham',
    county_weights: '{"13103": 100}',
    density: 57.4,
    imprecise: false,
    latitude: 32.3211,
    longitude: -81.40126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31312',
  },
  {
    city: 'Hinesville',
    county_fips: 13179,
    county_fips_all: '13179|13183',
    county: 'Liberty',
    county_names_all: 'Liberty|Long',
    county_weights: '{"13179": 97.1, "13183": 2.9}',
    density: 270.6,
    imprecise: false,
    latitude: 31.83534,
    longitude: -81.6183,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31313',
  },
  {
    city: 'Fort Stewart',
    county_fips: 13179,
    county_fips_all: '13179',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"13179": 100}',
    density: 865.8,
    imprecise: false,
    latitude: 31.88768,
    longitude: -81.60598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31315',
  },
  {
    city: 'Ludowici',
    county_fips: 13183,
    county_fips_all: '13183',
    county: 'Long',
    county_names_all: 'Long',
    county_weights: '{"13183": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 31.7183,
    longitude: -81.73457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31316',
  },
  {
    city: 'Meldrim',
    county_fips: 13103,
    county_fips_all: '13103',
    county: 'Effingham',
    county_names_all: 'Effingham',
    county_weights: '{"13103": 100}',
    density: 67.1,
    imprecise: false,
    latitude: 32.13575,
    longitude: -81.37566,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31318',
  },
  {
    city: 'Midway',
    county_fips: 13179,
    county_fips_all: '13179',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"13179": 100}',
    density: 33.7,
    imprecise: false,
    latitude: 31.76707,
    longitude: -81.36231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31320',
  },
  {
    city: 'Pembroke',
    county_fips: 13029,
    county_fips_all: '13029|13031',
    county: 'Bryan',
    county_names_all: 'Bryan|Bulloch',
    county_weights: '{"13029": 50.21, "13031": 49.79}',
    density: 19.7,
    imprecise: false,
    latitude: 32.18185,
    longitude: -81.66472,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31321',
  },
  {
    city: 'Pooler',
    county_fips: 13051,
    county_fips_all: '13051',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"13051": 100}',
    density: 394.8,
    imprecise: false,
    latitude: 32.10265,
    longitude: -81.25626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31322',
  },
  {
    city: 'Riceboro',
    county_fips: 13179,
    county_fips_all: '13179|13191|13183',
    county: 'Liberty',
    county_names_all: 'Liberty|McIntosh|Long',
    county_weights: '{"13179": 56.16, "13191": 30.48, "13183": 13.36}',
    density: 3.4,
    imprecise: false,
    latitude: 31.67359,
    longitude: -81.45304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31323',
  },
  {
    city: 'Richmond Hill',
    county_fips: 13029,
    county_fips_all: '13029',
    county: 'Bryan',
    county_names_all: 'Bryan',
    county_weights: '{"13029": 100}',
    density: 111.3,
    imprecise: false,
    latitude: 31.85707,
    longitude: -81.26951,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31324',
  },
  {
    city: 'Rincon',
    county_fips: 13103,
    county_fips_all: '13103',
    county: 'Effingham',
    county_names_all: 'Effingham',
    county_weights: '{"13103": 100}',
    density: 134.8,
    imprecise: false,
    latitude: 32.29653,
    longitude: -81.22824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31326',
  },
  {
    city: 'Sapelo Island',
    county_fips: 13191,
    county_fips_all: '13191',
    county: 'McIntosh',
    county_names_all: 'McIntosh',
    county_weights: '{"13191": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.44909,
    longitude: -81.25132,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31327',
  },
  {
    city: 'Tybee Island',
    county_fips: 13051,
    county_fips_all: '13051',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"13051": 100}',
    density: 140.2,
    imprecise: false,
    latitude: 32.01046,
    longitude: -80.89009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31328',
  },
  {
    city: 'Springfield',
    county_fips: 13103,
    county_fips_all: '13103',
    county: 'Effingham',
    county_names_all: 'Effingham',
    county_weights: '{"13103": 100}',
    density: 40.2,
    imprecise: false,
    latitude: 32.4251,
    longitude: -81.34314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31329',
  },
  {
    city: 'Townsend',
    county_fips: 13191,
    county_fips_all: '13191',
    county: 'McIntosh',
    county_names_all: 'McIntosh',
    county_weights: '{"13191": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 31.5159,
    longitude: -81.42042,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31331',
  },
  {
    city: 'Walthourville',
    county_fips: 13179,
    county_fips_all: '13179',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"13179": 100}',
    density: 631.9,
    imprecise: false,
    latitude: 31.76786,
    longitude: -81.62758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31333',
  },
  {
    city: 'Savannah',
    county_fips: 13051,
    county_fips_all: '13051',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"13051": 100}',
    density: 2312.9,
    imprecise: false,
    latitude: 32.06831,
    longitude: -81.09252,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31401',
  },
  {
    city: 'Savannah',
    county_fips: 13051,
    county_fips_all: '13051',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"13051": 100}',
    density: 846.4,
    imprecise: false,
    latitude: 32.05064,
    longitude: -81.05367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31404',
  },
  {
    city: 'Savannah',
    county_fips: 13051,
    county_fips_all: '13051',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"13051": 100}',
    density: 504.1,
    imprecise: false,
    latitude: 32.0392,
    longitude: -81.17352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31405',
  },
  {
    city: 'Savannah',
    county_fips: 13051,
    county_fips_all: '13051',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"13051": 100}',
    density: 514.4,
    imprecise: false,
    latitude: 31.97783,
    longitude: -81.08517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31406',
  },
  {
    city: 'Port Wentworth',
    county_fips: 13051,
    county_fips_all: '13051',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"13051": 100}',
    density: 283.7,
    imprecise: false,
    latitude: 32.18232,
    longitude: -81.19942,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31407',
  },
  {
    city: 'Savannah',
    county_fips: 13051,
    county_fips_all: '13051',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"13051": 100}',
    density: 212.7,
    imprecise: false,
    latitude: 32.11164,
    longitude: -81.18158,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31408',
  },
  {
    city: 'Savannah',
    county_fips: 13051,
    county_fips_all: '13051',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"13051": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 32.0106,
    longitude: -81.15539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31409',
  },
  {
    city: 'Savannah',
    county_fips: 13051,
    county_fips_all: '13051',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"13051": 100}',
    density: 379.9,
    imprecise: false,
    latitude: 32.01821,
    longitude: -80.99215,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31410',
  },
  {
    city: 'Savannah',
    county_fips: 13051,
    county_fips_all: '13051',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"13051": 100}',
    density: 161.2,
    imprecise: false,
    latitude: 31.94002,
    longitude: -81.03511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31411',
  },
  {
    city: 'Savannah',
    county_fips: 13051,
    county_fips_all: '13051',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"13051": 100}',
    density: 649.2,
    imprecise: false,
    latitude: 32.0802,
    longitude: -81.126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31415',
  },
  {
    city: 'Savannah',
    county_fips: 13051,
    county_fips_all: '13051',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"13051": 100}',
    density: 302.3,
    imprecise: false,
    latitude: 31.98479,
    longitude: -81.23867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31419',
  },
  {
    city: 'Waycross',
    county_fips: 13299,
    county_fips_all: '13299',
    county: 'Ware',
    county_names_all: 'Ware',
    county_weights: '{"13299": 100}',
    density: 434.9,
    imprecise: false,
    latitude: 31.22693,
    longitude: -82.34852,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31501',
  },
  {
    city: 'Waycross',
    county_fips: 13299,
    county_fips_all: '13299|13025|13229',
    county: 'Ware',
    county_names_all: 'Ware|Brantley|Pierce',
    county_weights: '{"13299": 91.34, "13025": 7.94, "13229": 0.72}',
    density: 25.7,
    imprecise: false,
    latitude: 31.17687,
    longitude: -82.40173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31503',
  },
  {
    city: 'Alma',
    county_fips: 13005,
    county_fips_all: '13005|13229',
    county: 'Bacon',
    county_names_all: 'Bacon|Pierce',
    county_weights: '{"13005": 89.89, "13229": 10.11}',
    density: 16.8,
    imprecise: false,
    latitude: 31.54729,
    longitude: -82.43992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31510',
  },
  {
    city: 'Ambrose',
    county_fips: 13069,
    county_fips_all: '13069',
    county: 'Coffee',
    county_names_all: 'Coffee',
    county_weights: '{"13069": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 31.54535,
    longitude: -83.01255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31512',
  },
  {
    city: 'Baxley',
    county_fips: 13001,
    county_fips_all: '13001',
    county: 'Appling',
    county_names_all: 'Appling',
    county_weights: '{"13001": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 31.77792,
    longitude: -82.34622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31513',
  },
  {
    city: 'Blackshear',
    county_fips: 13229,
    county_fips_all: '13229',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"13229": 100}',
    density: 37.8,
    imprecise: false,
    latitude: 31.30946,
    longitude: -82.2565,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31516',
  },
  {
    city: 'Bristol',
    county_fips: 13001,
    county_fips_all: '13001|13229|13305',
    county: 'Appling',
    county_names_all: 'Appling|Pierce|Wayne',
    county_weights: '{"13001": 57.5, "13229": 30.79, "13305": 11.71}',
    density: 6.6,
    imprecise: false,
    latitude: 31.51272,
    longitude: -82.18325,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31518',
  },
  {
    city: 'Broxton',
    county_fips: 13069,
    county_fips_all: '13069|13161',
    county: 'Coffee',
    county_names_all: 'Coffee|Jeff Davis',
    county_weights: '{"13069": 89.17, "13161": 10.83}',
    density: 9.7,
    imprecise: false,
    latitude: 31.67641,
    longitude: -82.86946,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31519',
  },
  {
    city: 'Brunswick',
    county_fips: 13127,
    county_fips_all: '13127',
    county: 'Glynn',
    county_names_all: 'Glynn',
    county_weights: '{"13127": 100}',
    density: 427.7,
    imprecise: false,
    latitude: 31.17745,
    longitude: -81.48729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31520',
  },
  {
    city: 'Saint Simons Island',
    county_fips: 13127,
    county_fips_all: '13127',
    county: 'Glynn',
    county_names_all: 'Glynn',
    county_weights: '{"13127": 100}',
    density: 128.6,
    imprecise: false,
    latitude: 31.23595,
    longitude: -81.35528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31522',
  },
  {
    city: 'Brunswick',
    county_fips: 13127,
    county_fips_all: '13127',
    county: 'Glynn',
    county_names_all: 'Glynn',
    county_weights: '{"13127": 100}',
    density: 31.1,
    imprecise: false,
    latitude: 31.21113,
    longitude: -81.61519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31523',
  },
  {
    city: 'Brunswick',
    county_fips: 13127,
    county_fips_all: '13127',
    county: 'Glynn',
    county_names_all: 'Glynn',
    county_weights: '{"13127": 100}',
    density: 113.6,
    imprecise: false,
    latitude: 31.3114,
    longitude: -81.5229,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31525',
  },
  {
    city: 'Jekyll Island',
    county_fips: 13127,
    county_fips_all: '13127',
    county: 'Glynn',
    county_names_all: 'Glynn',
    county_weights: '{"13127": 100}',
    density: 30.5,
    imprecise: false,
    latitude: 31.07155,
    longitude: -81.42225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31527',
  },
  {
    city: 'Denton',
    county_fips: 13161,
    county_fips_all: '13161',
    county: 'Jeff Davis',
    county_names_all: 'Jeff Davis',
    county_weights: '{"13161": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 31.72462,
    longitude: -82.74889,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31532',
  },
  {
    city: 'Douglas',
    county_fips: 13069,
    county_fips_all: '13069',
    county: 'Coffee',
    county_names_all: 'Coffee',
    county_weights: '{"13069": 100}',
    density: 99.2,
    imprecise: false,
    latitude: 31.55021,
    longitude: -82.8287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31533',
  },
  {
    city: 'Douglas',
    county_fips: 13069,
    county_fips_all: '13069',
    county: 'Coffee',
    county_names_all: 'Coffee',
    county_weights: '{"13069": 100}',
    density: 55.3,
    imprecise: false,
    latitude: 31.45841,
    longitude: -82.86504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31535',
  },
  {
    city: 'Folkston',
    county_fips: 13049,
    county_fips_all: '13049|13039',
    county: 'Charlton',
    county_names_all: 'Charlton|Camden',
    county_weights: '{"13049": 95.11, "13039": 4.89}',
    density: 6.6,
    imprecise: false,
    latitude: 30.89223,
    longitude: -82.12492,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31537',
  },
  {
    city: 'Hazlehurst',
    county_fips: 13161,
    county_fips_all: '13161|13001',
    county: 'Jeff Davis',
    county_names_all: 'Jeff Davis|Appling',
    county_weights: '{"13161": 97.98, "13001": 2.02}',
    density: 19.9,
    imprecise: false,
    latitude: 31.82393,
    longitude: -82.60658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31539',
  },
  {
    city: 'Hoboken',
    county_fips: 13025,
    county_fips_all: '13025',
    county: 'Brantley',
    county_names_all: 'Brantley',
    county_weights: '{"13025": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 31.1528,
    longitude: -82.12166,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31542',
  },
  {
    city: 'Hortense',
    county_fips: 13025,
    county_fips_all: '13025|13305|13127',
    county: 'Brantley',
    county_names_all: 'Brantley|Wayne|Glynn',
    county_weights: '{"13025": 50.37, "13305": 41.61, "13127": 8.02}',
    density: 11.6,
    imprecise: false,
    latitude: 31.34455,
    longitude: -81.82697,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31543',
  },
  {
    city: 'Jacksonville',
    county_fips: 13271,
    county_fips_all: '13271',
    county: 'Telfair',
    county_names_all: 'Telfair',
    county_weights: '{"13271": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 31.83802,
    longitude: -82.95561,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31544',
  },
  {
    city: 'Jesup',
    county_fips: 13305,
    county_fips_all: '13305',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"13305": 100}',
    density: 63,
    imprecise: false,
    latitude: 31.64867,
    longitude: -81.9405,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31545',
  },
  {
    city: 'Jesup',
    county_fips: 13305,
    county_fips_all: '13305',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"13305": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 31.52521,
    longitude: -81.8113,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31546',
  },
  {
    city: 'Kings Bay',
    county_fips: 13039,
    county_fips_all: '13039',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"13039": 100}',
    density: 34.1,
    imprecise: false,
    latitude: 30.79096,
    longitude: -81.53443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31547',
  },
  {
    city: 'Kingsland',
    county_fips: 13039,
    county_fips_all: '13039',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"13039": 100}',
    density: 148.1,
    imprecise: false,
    latitude: 30.7953,
    longitude: -81.71043,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31548',
  },
  {
    city: 'Lumber City',
    county_fips: 13271,
    county_fips_all: '13271|13309',
    county: 'Telfair',
    county_names_all: 'Telfair|Wheeler',
    county_weights: '{"13271": 56.49, "13309": 43.51}',
    density: 5.9,
    imprecise: false,
    latitude: 31.94503,
    longitude: -82.70922,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31549',
  },
  {
    city: 'Manor',
    county_fips: 13299,
    county_fips_all: '13299|13065',
    county: 'Ware',
    county_names_all: 'Ware|Clinch',
    county_weights: '{"13299": 91.89, "13065": 8.11}',
    density: 5.8,
    imprecise: false,
    latitude: 31.13924,
    longitude: -82.59575,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31550',
  },
  {
    city: 'Mershon',
    county_fips: 13229,
    county_fips_all: '13229|13005',
    county: 'Pierce',
    county_names_all: 'Pierce|Bacon',
    county_weights: '{"13229": 52.39, "13005": 47.61}',
    density: 5.7,
    imprecise: false,
    latitude: 31.49223,
    longitude: -82.27322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31551',
  },
  {
    city: 'Millwood',
    county_fips: 13299,
    county_fips_all: '13299|13003|13069',
    county: 'Ware',
    county_names_all: 'Ware|Atkinson|Coffee',
    county_weights: '{"13299": 90.19, "13003": 6.76, "13069": 3.05}',
    density: 2.7,
    imprecise: false,
    latitude: 31.29144,
    longitude: -82.5996,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31552',
  },
  {
    city: 'Nahunta',
    county_fips: 13025,
    county_fips_all: '13025|13049',
    county: 'Brantley',
    county_names_all: 'Brantley|Charlton',
    county_weights: '{"13025": 98.09, "13049": 1.91}',
    density: 11.2,
    imprecise: false,
    latitude: 31.17307,
    longitude: -81.98026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31553',
  },
  {
    city: 'Nicholls',
    county_fips: 13069,
    county_fips_all: '13069|13299|13005',
    county: 'Coffee',
    county_names_all: 'Coffee|Ware|Bacon',
    county_weights: '{"13069": 51.73, "13299": 25.01, "13005": 23.26}',
    density: 12.7,
    imprecise: false,
    latitude: 31.48265,
    longitude: -82.61861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31554',
  },
  {
    city: 'Odum',
    county_fips: 13305,
    county_fips_all: '13305|13001',
    county: 'Wayne',
    county_names_all: 'Wayne|Appling',
    county_weights: '{"13305": 83.18, "13001": 16.82}',
    density: 7.8,
    imprecise: false,
    latitude: 31.70275,
    longitude: -82.06647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31555',
  },
  {
    city: 'Offerman',
    county_fips: 13229,
    county_fips_all: '13229',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"13229": 100}',
    density: 70.1,
    imprecise: false,
    latitude: 31.40508,
    longitude: -82.1152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31556',
  },
  {
    city: 'Patterson',
    county_fips: 13229,
    county_fips_all: '13229|13025|13001',
    county: 'Pierce',
    county_names_all: 'Pierce|Brantley|Appling',
    county_weights: '{"13229": 93.42, "13025": 4.02, "13001": 2.56}',
    density: 12.6,
    imprecise: false,
    latitude: 31.3745,
    longitude: -82.09711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31557',
  },
  {
    city: 'Saint Marys',
    county_fips: 13039,
    county_fips_all: '13039',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"13039": 100}',
    density: 121.6,
    imprecise: false,
    latitude: 30.80173,
    longitude: -81.51606,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31558',
  },
  {
    city: 'Screven',
    county_fips: 13305,
    county_fips_all: '13305|13001',
    county: 'Wayne',
    county_names_all: 'Wayne|Appling',
    county_weights: '{"13305": 99.34, "13001": 0.66}',
    density: 9.2,
    imprecise: false,
    latitude: 31.50312,
    longitude: -82.02896,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31560',
  },
  {
    city: 'Sea Island',
    county_fips: 13127,
    county_fips_all: '13127',
    county: 'Glynn',
    county_names_all: 'Glynn',
    county_weights: '{"13127": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 31.20199,
    longitude: -81.3373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31561',
  },
  {
    city: 'Saint George',
    county_fips: 13049,
    county_fips_all: '13049',
    county: 'Charlton',
    county_names_all: 'Charlton',
    county_weights: '{"13049": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 30.47778,
    longitude: -82.10755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31562',
  },
  {
    city: 'Surrency',
    county_fips: 13001,
    county_fips_all: '13001',
    county: 'Appling',
    county_names_all: 'Appling',
    county_weights: '{"13001": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 31.73653,
    longitude: -82.18288,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31563',
  },
  {
    city: 'Waresboro',
    county_fips: 13299,
    county_fips_all: '13299',
    county: 'Ware',
    county_names_all: 'Ware',
    county_weights: '{"13299": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.24872,
    longitude: -82.47093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31564',
  },
  {
    city: 'Waverly',
    county_fips: 13039,
    county_fips_all: '13039',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"13039": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 31.06868,
    longitude: -81.64783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31565',
  },
  {
    city: 'Waynesville',
    county_fips: 13025,
    county_fips_all: '13025|13127|13039',
    county: 'Brantley',
    county_names_all: 'Brantley|Glynn|Camden',
    county_weights: '{"13025": 79.44, "13127": 13.61, "13039": 6.95}',
    density: 23.6,
    imprecise: false,
    latitude: 31.18357,
    longitude: -81.8084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3987,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31566',
  },
  {
    city: 'West Green',
    county_fips: 13069,
    county_fips_all: '13069',
    county: 'Coffee',
    county_names_all: 'Coffee',
    county_weights: '{"13069": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 31.63011,
    longitude: -82.70705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31567',
  },
  {
    city: 'White Oak',
    county_fips: 13039,
    county_fips_all: '13039',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"13039": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 31.00975,
    longitude: -81.82218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31568',
  },
  {
    city: 'Woodbine',
    county_fips: 13039,
    county_fips_all: '13039',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"13039": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 30.90167,
    longitude: -81.68249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31569',
  },
  {
    city: 'Valdosta',
    county_fips: 13185,
    county_fips_all: '13185|13027',
    county: 'Lowndes',
    county_names_all: 'Lowndes|Brooks',
    county_weights: '{"13185": 99.65, "13027": 0.35}',
    density: 76,
    imprecise: false,
    latitude: 30.74772,
    longitude: -83.33968,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31601',
  },
  {
    city: 'Valdosta',
    county_fips: 13185,
    county_fips_all: '13185|13027',
    county: 'Lowndes',
    county_names_all: 'Lowndes|Brooks',
    county_weights: '{"13185": 61.31, "13027": 38.69}',
    density: 345.7,
    imprecise: false,
    latitude: 30.86734,
    longitude: -83.34269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31602',
  },
  {
    city: 'Valdosta',
    county_fips: 13185,
    county_fips_all: '13185',
    county: 'Lowndes',
    county_names_all: 'Lowndes',
    county_weights: '{"13185": 100}',
    density: 196.4,
    imprecise: false,
    latitude: 30.93334,
    longitude: -83.23482,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31605',
  },
  {
    city: 'Valdosta',
    county_fips: 13185,
    county_fips_all: '13185|13101',
    county: 'Lowndes',
    county_names_all: 'Lowndes|Echols',
    county_weights: '{"13185": 93.9, "13101": 6.1}',
    density: 32.4,
    imprecise: false,
    latitude: 30.7963,
    longitude: -83.18647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31606',
  },
  {
    city: 'Adel',
    county_fips: 13075,
    county_fips_all: '13075',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"13075": 100}',
    density: 33.9,
    imprecise: false,
    latitude: 31.11861,
    longitude: -83.43731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31620',
  },
  {
    city: 'Alapaha',
    county_fips: 13019,
    county_fips_all: '13019',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"13019": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 31.37446,
    longitude: -83.2023,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31622',
  },
  {
    city: 'Argyle',
    county_fips: 13065,
    county_fips_all: '13065',
    county: 'Clinch',
    county_names_all: 'Clinch',
    county_weights: '{"13065": 100}',
    density: 338.6,
    imprecise: false,
    latitude: 31.07137,
    longitude: -82.644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31623',
  },
  {
    city: 'Axson',
    county_fips: 13003,
    county_fips_all: '13003|13069|13299',
    county: 'Atkinson',
    county_names_all: 'Atkinson|Coffee|Ware',
    county_weights: '{"13003": 87.16, "13069": 11.23, "13299": 1.61}',
    density: 7.8,
    imprecise: false,
    latitude: 31.29911,
    longitude: -82.72612,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31624',
  },
  {
    city: 'Barney',
    county_fips: 13027,
    county_fips_all: '13027',
    county: 'Brooks',
    county_names_all: 'Brooks',
    county_weights: '{"13027": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 30.9918,
    longitude: -83.52556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31625',
  },
  {
    city: 'Boston',
    county_fips: 13275,
    county_fips_all: '13275|13027',
    county: 'Thomas',
    county_names_all: 'Thomas|Brooks',
    county_weights: '{"13275": 92.11, "13027": 7.89}',
    density: 8.2,
    imprecise: false,
    latitude: 30.77609,
    longitude: -83.80208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31626',
  },
  {
    city: 'Cecil',
    county_fips: 13075,
    county_fips_all: '13075',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"13075": 100}',
    density: 149.7,
    imprecise: false,
    latitude: 31.03923,
    longitude: -83.39238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31627',
  },
  {
    city: 'Dixie',
    county_fips: 13027,
    county_fips_all: '13027',
    county: 'Brooks',
    county_names_all: 'Brooks',
    county_weights: '{"13027": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 30.82051,
    longitude: -83.68809,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31629',
  },
  {
    city: 'Du Pont',
    county_fips: 13065,
    county_fips_all: '13065|13101',
    county: 'Clinch',
    county_names_all: 'Clinch|Echols',
    county_weights: '{"13065": 82.04, "13101": 17.96}',
    density: 2.3,
    imprecise: false,
    latitude: 30.92354,
    longitude: -82.85667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31630',
  },
  {
    city: 'Fargo',
    county_fips: 13101,
    county_fips_all: '13101|13065|13049|13299',
    county: 'Echols',
    county_names_all: 'Echols|Clinch|Charlton|Ware',
    county_weights:
      '{"13101": 57.25, "13065": 32.48, "13049": 8.68, "13299": 1.59}',
    density: 0.9,
    imprecise: false,
    latitude: 30.71119,
    longitude: -82.64657,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31631',
  },
  {
    city: 'Hahira',
    county_fips: 13185,
    county_fips_all: '13185|13075',
    county: 'Lowndes',
    county_names_all: 'Lowndes|Cook',
    county_weights: '{"13185": 78.93, "13075": 21.07}',
    density: 54.8,
    imprecise: false,
    latitude: 30.9876,
    longitude: -83.36006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31632',
  },
  {
    city: 'Homerville',
    county_fips: 13065,
    county_fips_all: '13065',
    county: 'Clinch',
    county_names_all: 'Clinch',
    county_weights: '{"13065": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 31.02867,
    longitude: -82.7321,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31634',
  },
  {
    city: 'Lakeland',
    county_fips: 13173,
    county_fips_all: '13173|13003|13065',
    county: 'Lanier',
    county_names_all: 'Lanier|Atkinson|Clinch',
    county_weights: '{"13173": 78.45, "13003": 11.75, "13065": 9.81}',
    density: 18.3,
    imprecise: false,
    latitude: 31.103,
    longitude: -83.04317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31635',
  },
  {
    city: 'Lake Park',
    county_fips: 13101,
    county_fips_all: '13101|13185',
    county: 'Echols',
    county_names_all: 'Echols|Lowndes',
    county_weights: '{"13101": 59.7, "13185": 40.3}',
    density: 22.1,
    imprecise: false,
    latitude: 30.7337,
    longitude: -83.1096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31636',
  },
  {
    city: 'Lenox',
    county_fips: 13075,
    county_fips_all: '13075|13019|13071|13277',
    county: 'Cook',
    county_names_all: 'Cook|Berrien|Colquitt|Tift',
    county_weights:
      '{"13075": 41.58, "13019": 35.34, "13071": 16.74, "13277": 6.33}',
    density: 15.1,
    imprecise: false,
    latitude: 31.293,
    longitude: -83.44092,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31637',
  },
  {
    city: 'Morven',
    county_fips: 13027,
    county_fips_all: '13027',
    county: 'Brooks',
    county_names_all: 'Brooks',
    county_weights: '{"13027": 100}',
    density: 16.1,
    imprecise: false,
    latitude: 30.90627,
    longitude: -83.51589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31638',
  },
  {
    city: 'Nashville',
    county_fips: 13019,
    county_fips_all: '13019|13173',
    county: 'Berrien',
    county_names_all: 'Berrien|Lanier',
    county_weights: '{"13019": 98.92, "13173": 1.08}',
    density: 20.2,
    imprecise: false,
    latitude: 31.21239,
    longitude: -83.19248,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31639',
  },
  {
    city: 'Naylor',
    county_fips: 13185,
    county_fips_all: '13185|13173',
    county: 'Lowndes',
    county_names_all: 'Lowndes|Lanier',
    county_weights: '{"13185": 58.69, "13173": 41.31}',
    density: 7.6,
    imprecise: false,
    latitude: 30.93182,
    longitude: -83.09672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31641',
  },
  {
    city: 'Pearson',
    county_fips: 13003,
    county_fips_all: '13003|13065',
    county: 'Atkinson',
    county_names_all: 'Atkinson|Clinch',
    county_weights: '{"13003": 82.95, "13065": 17.05}',
    density: 9.1,
    imprecise: false,
    latitude: 31.25989,
    longitude: -82.88273,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31642',
  },
  {
    city: 'Quitman',
    county_fips: 13027,
    county_fips_all: '13027',
    county: 'Brooks',
    county_names_all: 'Brooks',
    county_weights: '{"13027": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 30.77061,
    longitude: -83.55859,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31643',
  },
  {
    city: 'Ray City',
    county_fips: 13019,
    county_fips_all: '13019|13173|13185',
    county: 'Berrien',
    county_names_all: 'Berrien|Lanier|Lowndes',
    county_weights: '{"13019": 69.49, "13173": 18.53, "13185": 11.98}',
    density: 39.4,
    imprecise: false,
    latitude: 31.06245,
    longitude: -83.21846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31645',
  },
  {
    city: 'Sparks',
    county_fips: 13075,
    county_fips_all: '13075',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"13075": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 31.21033,
    longitude: -83.43158,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31647',
  },
  {
    city: 'Statenville',
    county_fips: 13101,
    county_fips_all: '13101',
    county: 'Echols',
    county_names_all: 'Echols',
    county_weights: '{"13101": 100}',
    density: 21,
    imprecise: false,
    latitude: 30.70834,
    longitude: -83.00838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31648',
  },
  {
    city: 'Stockton',
    county_fips: 13173,
    county_fips_all: '13173|13101',
    county: 'Lanier',
    county_names_all: 'Lanier|Echols',
    county_weights: '{"13173": 97.85, "13101": 2.15}',
    density: 13,
    imprecise: false,
    latitude: 30.94349,
    longitude: -83.00781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31649',
  },
  {
    city: 'Willacoochee',
    county_fips: 13003,
    county_fips_all: '13003|13069',
    county: 'Atkinson',
    county_names_all: 'Atkinson|Coffee',
    county_weights: '{"13003": 66.79, "13069": 33.21}',
    density: 9.2,
    imprecise: false,
    latitude: 31.38327,
    longitude: -83.02761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31650',
  },
  {
    city: 'Albany',
    county_fips: 13095,
    county_fips_all: '13095|13177',
    county: 'Dougherty',
    county_names_all: 'Dougherty|Lee',
    county_weights: '{"13095": 90.39, "13177": 9.61}',
    density: 294.2,
    imprecise: false,
    latitude: 31.57376,
    longitude: -84.15508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31701',
  },
  {
    city: 'Albany',
    county_fips: 13095,
    county_fips_all: '13095|13321|13205',
    county: 'Dougherty',
    county_names_all: 'Dougherty|Worth|Mitchell',
    county_weights: '{"13095": 76.45, "13321": 12.45, "13205": 11.1}',
    density: 84.7,
    imprecise: false,
    latitude: 31.51169,
    longitude: -84.05333,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31705',
  },
  {
    city: 'Albany',
    county_fips: 13095,
    county_fips_all: '13095|13177',
    county: 'Dougherty',
    county_names_all: 'Dougherty|Lee',
    county_weights: '{"13095": 91.14, "13177": 8.86}',
    density: 476.7,
    imprecise: false,
    latitude: 31.58736,
    longitude: -84.20689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31707',
  },
  {
    city: 'Americus',
    county_fips: 13261,
    county_fips_all: '13261',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"13261": 100}',
    density: 49.7,
    imprecise: false,
    latitude: 32.05071,
    longitude: -84.14011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31709',
  },
  {
    city: 'Andersonville',
    county_fips: 13261,
    county_fips_all: '13261|13193|13249',
    county: 'Sumter',
    county_names_all: 'Sumter|Macon|Schley',
    county_weights: '{"13261": 61.91, "13193": 37.28, "13249": 0.81}',
    density: 4.6,
    imprecise: false,
    latitude: 32.18766,
    longitude: -84.12258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31711',
  },
  {
    city: 'Arabi',
    county_fips: 13081,
    county_fips_all: '13081|13287|13321',
    county: 'Crisp',
    county_names_all: 'Crisp|Turner|Worth',
    county_weights: '{"13081": 78.02, "13287": 20.5, "13321": 1.48}',
    density: 7.4,
    imprecise: false,
    latitude: 31.8215,
    longitude: -83.72806,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31712',
  },
  {
    city: 'Ashburn',
    county_fips: 13287,
    county_fips_all: '13287|13321|13277',
    county: 'Turner',
    county_names_all: 'Turner|Worth|Tift',
    county_weights: '{"13287": 91.46, "13321": 7.74, "13277": 0.8}',
    density: 13.6,
    imprecise: false,
    latitude: 31.71075,
    longitude: -83.67496,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31714',
  },
  {
    city: 'Baconton',
    county_fips: 13205,
    county_fips_all: '13205',
    county: 'Mitchell',
    county_names_all: 'Mitchell',
    county_weights: '{"13205": 100}',
    density: 12,
    imprecise: false,
    latitude: 31.36512,
    longitude: -84.11445,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31716',
  },
  {
    city: 'Americus',
    county_fips: 13261,
    county_fips_all: '13261|13249',
    county: 'Sumter',
    county_names_all: 'Sumter|Schley',
    county_weights: '{"13261": 99.24, "13249": 0.76}',
    density: 34.8,
    imprecise: false,
    latitude: 32.08261,
    longitude: -84.29768,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31719',
  },
  {
    city: 'Barwick',
    county_fips: 13027,
    county_fips_all: '13027|13275',
    county: 'Brooks',
    county_names_all: 'Brooks|Thomas',
    county_weights: '{"13027": 93.16, "13275": 6.84}',
    density: 33.2,
    imprecise: false,
    latitude: 30.87986,
    longitude: -83.72297,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31720',
  },
  {
    city: 'Albany',
    county_fips: 13095,
    county_fips_all: '13095|13007|13177|13273',
    county: 'Dougherty',
    county_names_all: 'Dougherty|Baker|Lee|Terrell',
    county_weights:
      '{"13095": 82.76, "13007": 15.95, "13177": 0.67, "13273": 0.62}',
    density: 34,
    imprecise: false,
    latitude: 31.5087,
    longitude: -84.30331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31721',
  },
  {
    city: 'Berlin',
    county_fips: 13071,
    county_fips_all: '13071',
    county: 'Colquitt',
    county_names_all: 'Colquitt',
    county_weights: '{"13071": 100}',
    density: 80.1,
    imprecise: false,
    latitude: 31.05492,
    longitude: -83.61559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31722',
  },
  {
    city: 'Brookfield',
    county_fips: 13277,
    county_fips_all: '13277',
    county: 'Tift',
    county_names_all: 'Tift',
    county_weights: '{"13277": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.41778,
    longitude: -83.3874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31727',
  },
  {
    city: 'Camilla',
    county_fips: 13205,
    county_fips_all: '13205|13087',
    county: 'Mitchell',
    county_names_all: 'Mitchell|Decatur',
    county_weights: '{"13205": 96.94, "13087": 3.06}',
    density: 13,
    imprecise: false,
    latitude: 31.20749,
    longitude: -84.28438,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31730',
  },
  {
    city: 'Chula',
    county_fips: 13155,
    county_fips_all: '13155|13277',
    county: 'Irwin',
    county_names_all: 'Irwin|Tift',
    county_weights: '{"13155": 61.44, "13277": 38.56}',
    density: 9.8,
    imprecise: false,
    latitude: 31.59293,
    longitude: -83.48599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31733',
  },
  {
    city: 'Cobb',
    county_fips: 13261,
    county_fips_all: '13261',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"13261": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 31.97195,
    longitude: -83.96446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31735',
  },
  {
    city: 'Coolidge',
    county_fips: 13275,
    county_fips_all: '13275|13071',
    county: 'Thomas',
    county_names_all: 'Thomas|Colquitt',
    county_weights: '{"13275": 73.56, "13071": 26.44}',
    density: 17.3,
    imprecise: false,
    latitude: 31.01133,
    longitude: -83.87502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31738',
  },
  {
    city: 'De Soto',
    county_fips: 13177,
    county_fips_all: '13177|13261',
    county: 'Lee',
    county_names_all: 'Lee|Sumter',
    county_weights: '{"13177": 60.35, "13261": 39.65}',
    density: 2.5,
    imprecise: false,
    latitude: 31.90089,
    longitude: -84.00604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31743',
  },
  {
    city: 'Doerun',
    county_fips: 13321,
    county_fips_all: '13321|13071|13205',
    county: 'Worth',
    county_names_all: 'Worth|Colquitt|Mitchell',
    county_weights: '{"13321": 54.04, "13071": 42.8, "13205": 3.16}',
    density: 9.1,
    imprecise: false,
    latitude: 31.33709,
    longitude: -83.90646,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31744',
  },
  {
    city: 'Ellenton',
    county_fips: 13071,
    county_fips_all: '13071',
    county: 'Colquitt',
    county_names_all: 'Colquitt',
    county_weights: '{"13071": 100}',
    density: 143.3,
    imprecise: false,
    latitude: 31.1753,
    longitude: -83.58736,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31747',
  },
  {
    city: 'Enigma',
    county_fips: 13019,
    county_fips_all: '13019|13155|13277',
    county: 'Berrien',
    county_names_all: 'Berrien|Irwin|Tift',
    county_weights: '{"13019": 78.08, "13155": 13.6, "13277": 8.32}',
    density: 15.6,
    imprecise: false,
    latitude: 31.42128,
    longitude: -83.3315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31749',
  },
  {
    city: 'Fitzgerald',
    county_fips: 13017,
    county_fips_all: '13017|13155',
    county: 'Ben Hill',
    county_names_all: 'Ben Hill|Irwin',
    county_weights: '{"13017": 74.4, "13155": 25.6}',
    density: 25.5,
    imprecise: false,
    latitude: 31.73391,
    longitude: -83.21752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31750',
  },
  {
    city: 'Funston',
    county_fips: 13071,
    county_fips_all: '13071',
    county: 'Colquitt',
    county_names_all: 'Colquitt',
    county_weights: '{"13071": 100}',
    density: 1420.3,
    imprecise: false,
    latitude: 31.20044,
    longitude: -83.87287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31753',
  },
  {
    city: 'Hartsfield',
    county_fips: 13071,
    county_fips_all: '13071|13205',
    county: 'Colquitt',
    county_names_all: 'Colquitt|Mitchell',
    county_weights: '{"13071": 99.82, "13205": 0.18}',
    density: 14.1,
    imprecise: false,
    latitude: 31.17558,
    longitude: -83.96224,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31756',
  },
  {
    city: 'Thomasville',
    county_fips: 13275,
    county_fips_all: '13275',
    county: 'Thomas',
    county_names_all: 'Thomas',
    county_weights: '{"13275": 100}',
    density: 51.8,
    imprecise: false,
    latitude: 30.87291,
    longitude: -83.89945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31757',
  },
  {
    city: 'Leesburg',
    county_fips: 13177,
    county_fips_all: '13177|13095|13273',
    county: 'Lee',
    county_names_all: 'Lee|Dougherty|Terrell',
    county_weights: '{"13177": 99.06, "13095": 0.79, "13273": 0.15}',
    density: 45.6,
    imprecise: false,
    latitude: 31.73889,
    longitude: -84.14711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31763',
  },
  {
    city: 'Leslie',
    county_fips: 13261,
    county_fips_all: '13261|13177',
    county: 'Sumter',
    county_names_all: 'Sumter|Lee',
    county_weights: '{"13261": 85.91, "13177": 14.09}',
    density: 9.3,
    imprecise: false,
    latitude: 31.9772,
    longitude: -84.08135,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31764',
  },
  {
    city: 'Meigs',
    county_fips: 13205,
    county_fips_all: '13205|13275|13071',
    county: 'Mitchell',
    county_names_all: 'Mitchell|Thomas|Colquitt',
    county_weights: '{"13205": 50.07, "13275": 28.99, "13071": 20.94}',
    density: 12.8,
    imprecise: false,
    latitude: 31.09514,
    longitude: -84.0346,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31765',
  },
  {
    city: 'Moultrie',
    county_fips: 13071,
    county_fips_all: '13071',
    county: 'Colquitt',
    county_names_all: 'Colquitt',
    county_weights: '{"13071": 100}',
    density: 59.4,
    imprecise: false,
    latitude: 31.19329,
    longitude: -83.84047,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31768',
  },
  {
    city: 'Norman Park',
    county_fips: 13071,
    county_fips_all: '13071|13321',
    county: 'Colquitt',
    county_names_all: 'Colquitt|Worth',
    county_weights: '{"13071": 96.93, "13321": 3.07}',
    density: 24.1,
    imprecise: false,
    latitude: 31.24332,
    longitude: -83.64775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31771',
  },
  {
    city: 'Oakfield',
    county_fips: 13321,
    county_fips_all: '13321',
    county: 'Worth',
    county_names_all: 'Worth',
    county_weights: '{"13321": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 31.72213,
    longitude: -83.96504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31772',
  },
  {
    city: 'Ochlocknee',
    county_fips: 13275,
    county_fips_all: '13275|13131|13071',
    county: 'Thomas',
    county_names_all: 'Thomas|Grady|Colquitt',
    county_weights: '{"13275": 78.94, "13131": 19.09, "13071": 1.97}',
    density: 18,
    imprecise: false,
    latitude: 30.97795,
    longitude: -84.04624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31773',
  },
  {
    city: 'Ocilla',
    county_fips: 13155,
    county_fips_all: '13155',
    county: 'Irwin',
    county_names_all: 'Irwin',
    county_weights: '{"13155": 100}',
    density: 14,
    imprecise: false,
    latitude: 31.56102,
    longitude: -83.27125,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31774',
  },
  {
    city: 'Omega',
    county_fips: 13071,
    county_fips_all: '13071|13277|13321',
    county: 'Colquitt',
    county_names_all: 'Colquitt|Tift|Worth',
    county_weights: '{"13071": 43.61, "13277": 37.43, "13321": 18.96}',
    density: 25.2,
    imprecise: false,
    latitude: 31.33418,
    longitude: -83.60366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31775',
  },
  {
    city: 'Pavo',
    county_fips: 13027,
    county_fips_all: '13027|13275|13071',
    county: 'Brooks',
    county_names_all: 'Brooks|Thomas|Colquitt',
    county_weights: '{"13027": 61.54, "13275": 35.9, "13071": 2.56}',
    density: 10.1,
    imprecise: false,
    latitude: 30.9754,
    longitude: -83.70931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31778',
  },
  {
    city: 'Pelham',
    county_fips: 13205,
    county_fips_all: '13205|13131|13275',
    county: 'Mitchell',
    county_names_all: 'Mitchell|Grady|Thomas',
    county_weights: '{"13205": 64.66, "13131": 33.15, "13275": 2.19}',
    density: 24.5,
    imprecise: false,
    latitude: 31.10032,
    longitude: -84.19117,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31779',
  },
  {
    city: 'Plains',
    county_fips: 13261,
    county_fips_all: '13261|13307',
    county: 'Sumter',
    county_names_all: 'Sumter|Webster',
    county_weights: '{"13261": 90.51, "13307": 9.49}',
    density: 7.5,
    imprecise: false,
    latitude: 32.02898,
    longitude: -84.39024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31780',
  },
  {
    city: 'Poulan',
    county_fips: 13321,
    county_fips_all: '13321',
    county: 'Worth',
    county_names_all: 'Worth',
    county_weights: '{"13321": 100}',
    density: 31,
    imprecise: false,
    latitude: 31.56062,
    longitude: -83.79316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31781',
  },
  {
    city: 'Rebecca',
    county_fips: 13287,
    county_fips_all: '13287|13155|13017',
    county: 'Turner',
    county_names_all: 'Turner|Irwin|Ben Hill',
    county_weights: '{"13287": 52.33, "13155": 28.25, "13017": 19.42}',
    density: 6.7,
    imprecise: false,
    latitude: 31.76416,
    longitude: -83.4738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31783',
  },
  {
    city: 'Sale City',
    county_fips: 13205,
    county_fips_all: '13205',
    county: 'Mitchell',
    county_names_all: 'Mitchell',
    county_weights: '{"13205": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 31.25671,
    longitude: -84.0431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31784',
  },
  {
    city: 'Smithville',
    county_fips: 13177,
    county_fips_all: '13177|13261',
    county: 'Lee',
    county_names_all: 'Lee|Sumter',
    county_weights: '{"13177": 66.0, "13261": 34.0}',
    density: 5.1,
    imprecise: false,
    latitude: 31.89994,
    longitude: -84.24947,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31787',
  },
  {
    city: 'Moultrie',
    county_fips: 13071,
    county_fips_all: '13071|13027',
    county: 'Colquitt',
    county_names_all: 'Colquitt|Brooks',
    county_weights: '{"13071": 98.13, "13027": 1.87}',
    density: 33.9,
    imprecise: false,
    latitude: 31.10891,
    longitude: -83.68099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31788',
  },
  {
    city: 'Sumner',
    county_fips: 13321,
    county_fips_all: '13321',
    county: 'Worth',
    county_names_all: 'Worth',
    county_weights: '{"13321": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 31.47858,
    longitude: -83.73257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31789',
  },
  {
    city: 'Sycamore',
    county_fips: 13287,
    county_fips_all: '13287|13155|13277',
    county: 'Turner',
    county_names_all: 'Turner|Irwin|Tift',
    county_weights: '{"13287": 94.03, "13155": 3.19, "13277": 2.78}',
    density: 14.8,
    imprecise: false,
    latitude: 31.64823,
    longitude: -83.5693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31790',
  },
  {
    city: 'Sylvester',
    county_fips: 13321,
    county_fips_all: '13321|13095',
    county: 'Worth',
    county_names_all: 'Worth|Dougherty',
    county_weights: '{"13321": 99.64, "13095": 0.36}',
    density: 20.7,
    imprecise: false,
    latitude: 31.53383,
    longitude: -83.87833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31791',
  },
  {
    city: 'Thomasville',
    county_fips: 13275,
    county_fips_all: '13275|13131',
    county: 'Thomas',
    county_names_all: 'Thomas|Grady',
    county_weights: '{"13275": 70.82, "13131": 29.18}',
    density: 41.9,
    imprecise: false,
    latitude: 30.77079,
    longitude: -84.04238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31792',
  },
  {
    city: 'Tifton',
    county_fips: 13277,
    county_fips_all: '13277',
    county: 'Tift',
    county_names_all: 'Tift',
    county_weights: '{"13277": 100}',
    density: 43.7,
    imprecise: false,
    latitude: 31.46104,
    longitude: -83.58386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31793',
  },
  {
    city: 'Tifton',
    county_fips: 13277,
    county_fips_all: '13277|13019',
    county: 'Tift',
    county_names_all: 'Tift|Berrien',
    county_weights: '{"13277": 90.78, "13019": 9.22}',
    density: 88.2,
    imprecise: false,
    latitude: 31.44418,
    longitude: -83.45151,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31794',
  },
  {
    city: 'Ty Ty',
    county_fips: 13321,
    county_fips_all: '13321|13277',
    county: 'Worth',
    county_names_all: 'Worth|Tift',
    county_weights: '{"13321": 73.23, "13277": 26.77}',
    density: 13,
    imprecise: false,
    latitude: 31.47611,
    longitude: -83.67633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31795',
  },
  {
    city: 'Warwick',
    county_fips: 13321,
    county_fips_all: '13321|13081',
    county: 'Worth',
    county_names_all: 'Worth|Crisp',
    county_weights: '{"13321": 99.1, "13081": 0.9}',
    density: 5.7,
    imprecise: false,
    latitude: 31.77351,
    longitude: -83.87659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31796',
  },
  {
    city: 'Wray',
    county_fips: 13155,
    county_fips_all: '13155|13069|13017',
    county: 'Irwin',
    county_names_all: 'Irwin|Coffee|Ben Hill',
    county_weights: '{"13155": 53.3, "13069": 34.23, "13017": 12.47}',
    density: 2.7,
    imprecise: false,
    latitude: 31.64117,
    longitude: -83.04333,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31798',
  },
  {
    city: 'Box Springs',
    county_fips: 13197,
    county_fips_all: '13197|13263|13215',
    county: 'Marion',
    county_names_all: 'Marion|Talbot|Muscogee',
    county_weights: '{"13197": 64.88, "13263": 32.63, "13215": 2.49}',
    density: 13.5,
    imprecise: false,
    latitude: 32.51765,
    longitude: -84.5906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31801',
  },
  {
    city: 'Buena Vista',
    county_fips: 13197,
    county_fips_all: '13197|13249|13307',
    county: 'Marion',
    county_names_all: 'Marion|Schley|Webster',
    county_weights: '{"13197": 93.63, "13249": 5.63, "13307": 0.74}',
    density: 6.1,
    imprecise: false,
    latitude: 32.30501,
    longitude: -84.51682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31803',
  },
  {
    city: 'Cataula',
    county_fips: 13145,
    county_fips_all: '13145',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"13145": 100}',
    density: 50.8,
    imprecise: false,
    latitude: 32.66199,
    longitude: -84.88402,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31804',
  },
  {
    city: 'Cusseta',
    county_fips: 13053,
    county_fips_all: '13053|13259',
    county: 'Chattahoochee',
    county_names_all: 'Chattahoochee|Stewart',
    county_weights: '{"13053": 83.37, "13259": 16.63}',
    density: 10.4,
    imprecise: false,
    latitude: 32.26621,
    longitude: -84.74612,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31805',
  },
  {
    city: 'Ellaville',
    county_fips: 13249,
    county_fips_all: '13249|13193',
    county: 'Schley',
    county_names_all: 'Schley|Macon',
    county_weights: '{"13249": 92.86, "13193": 7.14}',
    density: 10,
    imprecise: false,
    latitude: 32.26147,
    longitude: -84.30043,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31806',
  },
  {
    city: 'Ellerslie',
    county_fips: 13145,
    county_fips_all: '13145',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"13145": 100}',
    density: 77.6,
    imprecise: false,
    latitude: 32.64054,
    longitude: -84.80142,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31807',
  },
  {
    city: 'Fortson',
    county_fips: 13145,
    county_fips_all: '13145|13215',
    county: 'Harris',
    county_names_all: 'Harris|Muscogee',
    county_weights: '{"13145": 79.64, "13215": 20.36}',
    density: 61.9,
    imprecise: false,
    latitude: 32.63545,
    longitude: -85.00707,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31808',
  },
  {
    city: 'Geneva',
    county_fips: 13263,
    county_fips_all: '13263',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"13263": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 32.56775,
    longitude: -84.53236,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31810',
  },
  {
    city: 'Hamilton',
    county_fips: 13145,
    county_fips_all: '13145',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"13145": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 32.74522,
    longitude: -84.93327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31811',
  },
  {
    city: 'Junction City',
    county_fips: 13263,
    county_fips_all: '13263|13269',
    county: 'Talbot',
    county_names_all: 'Talbot|Taylor',
    county_weights: '{"13263": 79.54, "13269": 20.46}',
    density: 2.8,
    imprecise: false,
    latitude: 32.63173,
    longitude: -84.42019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31812',
  },
  {
    city: 'Louvale',
    county_fips: 13259,
    county_fips_all: '13259',
    county: 'Stewart',
    county_names_all: 'Stewart',
    county_weights: '{"13259": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 32.20531,
    longitude: -84.8614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31814',
  },
  {
    city: 'Lumpkin',
    county_fips: 13259,
    county_fips_all: '13259',
    county: 'Stewart',
    county_names_all: 'Stewart',
    county_weights: '{"13259": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 32.04117,
    longitude: -84.85407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31815',
  },
  {
    city: 'Manchester',
    county_fips: 13199,
    county_fips_all: '13199|13263',
    county: 'Meriwether',
    county_names_all: 'Meriwether|Talbot',
    county_weights: '{"13199": 85.89, "13263": 14.11}',
    density: 49.6,
    imprecise: false,
    latitude: 32.8762,
    longitude: -84.60169,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31816',
  },
  {
    city: 'Midland',
    county_fips: 13215,
    county_fips_all: '13215|13145',
    county: 'Muscogee',
    county_names_all: 'Muscogee|Harris',
    county_weights: '{"13215": 60.23, "13145": 39.77}',
    density: 130.9,
    imprecise: false,
    latitude: 32.57576,
    longitude: -84.82947,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31820',
  },
  {
    city: 'Omaha',
    county_fips: 13259,
    county_fips_all: '13259',
    county: 'Stewart',
    county_names_all: 'Stewart',
    county_weights: '{"13259": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 32.14048,
    longitude: -84.97083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31821',
  },
  {
    city: 'Pine Mountain',
    county_fips: 13145,
    county_fips_all: '13145|13285|13199',
    county: 'Harris',
    county_names_all: 'Harris|Troup|Meriwether',
    county_weights: '{"13145": 49.84, "13285": 32.47, "13199": 17.69}',
    density: 18.1,
    imprecise: false,
    latitude: 32.86708,
    longitude: -84.91107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31822',
  },
  {
    city: 'Pine Mountain Valley',
    county_fips: 13145,
    county_fips_all: '13145',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"13145": 100}',
    density: 27,
    imprecise: false,
    latitude: 32.80061,
    longitude: -84.81377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31823',
  },
  {
    city: 'Preston',
    county_fips: 13307,
    county_fips_all: '13307|13197',
    county: 'Webster',
    county_names_all: 'Webster|Marion',
    county_weights: '{"13307": 98.18, "13197": 1.82}',
    density: 3.5,
    imprecise: false,
    latitude: 32.05687,
    longitude: -84.5229,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31824',
  },
  {
    city: 'Richland',
    county_fips: 13259,
    county_fips_all: '13259|13307',
    county: 'Stewart',
    county_names_all: 'Stewart|Webster',
    county_weights: '{"13259": 70.21, "13307": 29.79}',
    density: 7.9,
    imprecise: false,
    latitude: 32.1081,
    longitude: -84.6693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31825',
  },
  {
    city: 'Shiloh',
    county_fips: 13145,
    county_fips_all: '13145|13263',
    county: 'Harris',
    county_names_all: 'Harris|Talbot',
    county_weights: '{"13145": 65.99, "13263": 34.01}',
    density: 19.1,
    imprecise: false,
    latitude: 32.79526,
    longitude: -84.70292,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31826',
  },
  {
    city: 'Talbotton',
    county_fips: 13263,
    county_fips_all: '13263',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"13263": 100}',
    density: 4,
    imprecise: false,
    latitude: 32.69821,
    longitude: -84.49847,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31827',
  },
  {
    city: 'Upatoi',
    county_fips: 13215,
    county_fips_all: '13215|13145',
    county: 'Muscogee',
    county_names_all: 'Muscogee|Harris',
    county_weights: '{"13215": 84.22, "13145": 15.78}',
    density: 49.2,
    imprecise: false,
    latitude: 32.56681,
    longitude: -84.72787,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31829',
  },
  {
    city: 'Warm Springs',
    county_fips: 13199,
    county_fips_all: '13199|13145',
    county: 'Meriwether',
    county_names_all: 'Meriwether|Harris',
    county_weights: '{"13199": 90.21, "13145": 9.79}',
    density: 15.4,
    imprecise: false,
    latitude: 32.8951,
    longitude: -84.72689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31830',
  },
  {
    city: 'Waverly Hall',
    county_fips: 13145,
    county_fips_all: '13145|13263',
    county: 'Harris',
    county_names_all: 'Harris|Talbot',
    county_weights: '{"13145": 62.4, "13263": 37.6}',
    density: 23.4,
    imprecise: false,
    latitude: 32.66486,
    longitude: -84.70701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31831',
  },
  {
    city: 'Weston',
    county_fips: 13307,
    county_fips_all: '13307|13243',
    county: 'Webster',
    county_names_all: 'Webster|Randolph',
    county_weights: '{"13307": 87.56, "13243": 12.44}',
    density: 0.9,
    imprecise: false,
    latitude: 31.95501,
    longitude: -84.61709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 67,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31832',
  },
  {
    city: 'West Point',
    county_fips: 13145,
    county_fips_all: '13145|13285',
    county: 'Harris',
    county_names_all: 'Harris|Troup',
    county_weights: '{"13145": 60.91, "13285": 39.09}',
    density: 27,
    imprecise: false,
    latitude: 32.84963,
    longitude: -85.09202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31833',
  },
  {
    city: 'Woodland',
    county_fips: 13263,
    county_fips_all: '13263',
    county: 'Talbot',
    county_names_all: 'Talbot',
    county_weights: '{"13263": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 32.79189,
    longitude: -84.54891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31836',
  },
  {
    city: 'Columbus',
    county_fips: 13215,
    county_fips_all: '13215',
    county: 'Muscogee',
    county_names_all: 'Muscogee',
    county_weights: '{"13215": 100}',
    density: 513.1,
    imprecise: false,
    latitude: 32.46461,
    longitude: -84.97986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31901',
  },
  {
    city: 'Columbus',
    county_fips: 13215,
    county_fips_all: '13215',
    county: 'Muscogee',
    county_names_all: 'Muscogee',
    county_weights: '{"13215": 100}',
    density: 799.1,
    imprecise: false,
    latitude: 32.41484,
    longitude: -84.95321,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31903',
  },
  {
    city: 'Columbus',
    county_fips: 13215,
    county_fips_all: '13215',
    county: 'Muscogee',
    county_names_all: 'Muscogee',
    county_weights: '{"13215": 100}',
    density: 496.8,
    imprecise: false,
    latitude: 32.55189,
    longitude: -85.00009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31904',
  },
  {
    city: 'Fort Benning',
    county_fips: 13053,
    county_fips_all: '13053|13215',
    county: 'Chattahoochee',
    county_names_all: 'Chattahoochee|Muscogee',
    county_weights: '{"13053": 80.97, "13215": 19.03}',
    density: 64.2,
    imprecise: false,
    latitude: 32.37304,
    longitude: -84.84331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31905',
  },
  {
    city: 'Columbus',
    county_fips: 13215,
    county_fips_all: '13215',
    county: 'Muscogee',
    county_names_all: 'Muscogee',
    county_weights: '{"13215": 100}',
    density: 1146.7,
    imprecise: false,
    latitude: 32.46815,
    longitude: -84.94963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31906',
  },
  {
    city: 'Columbus',
    county_fips: 13215,
    county_fips_all: '13215',
    county: 'Muscogee',
    county_names_all: 'Muscogee',
    county_weights: '{"13215": 100}',
    density: 957,
    imprecise: false,
    latitude: 32.48388,
    longitude: -84.89976,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31907',
  },
  {
    city: 'Columbus',
    county_fips: 13215,
    county_fips_all: '13215',
    county: 'Muscogee',
    county_names_all: 'Muscogee',
    county_weights: '{"13215": 100}',
    density: 812.8,
    imprecise: false,
    latitude: 32.54517,
    longitude: -84.92385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31909',
  },
  {
    city: 'Fleming Island',
    county_fips: 12019,
    county_fips_all: '12019',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"12019": 100}',
    density: 725.6,
    imprecise: false,
    latitude: 30.09813,
    longitude: -81.71255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32003',
  },
  {
    city: 'Branford',
    county_fips: 12067,
    county_fips_all: '12067|12041|12121|12029',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Gilchrist|Suwannee|Dixie',
    county_weights:
      '{"12067": 46.09, "12041": 24.59, "12121": 23.75, "12029": 5.56}',
    density: 15,
    imprecise: false,
    latitude: 29.90351,
    longitude: -82.90311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32008',
  },
  {
    city: 'Bryceville',
    county_fips: 12089,
    county_fips_all: '12089',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"12089": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 30.42078,
    longitude: -81.97252,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32009',
  },
  {
    city: 'Callahan',
    county_fips: 12089,
    county_fips_all: '12089',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"12089": 100}',
    density: 35.3,
    imprecise: false,
    latitude: 30.56985,
    longitude: -81.83975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32011',
  },
  {
    city: 'Day',
    county_fips: 12067,
    county_fips_all: '12067',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"12067": 100}',
    density: 7633.6,
    imprecise: false,
    latitude: 30.19366,
    longitude: -83.29116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32013',
  },
  {
    city: 'Lake City',
    county_fips: 12023,
    county_fips_all: '12023|12121',
    county: 'Columbia',
    county_names_all: 'Columbia|Suwannee',
    county_weights: '{"12023": 81.42, "12121": 18.58}',
    density: 54.9,
    imprecise: false,
    latitude: 30.0793,
    longitude: -82.72597,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32024',
  },
  {
    city: 'Lake City',
    county_fips: 12023,
    county_fips_all: '12023',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"12023": 100}',
    density: 84.7,
    imprecise: false,
    latitude: 30.11266,
    longitude: -82.57072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32025',
  },
  {
    city: 'Elkton',
    county_fips: 12109,
    county_fips_all: '12109',
    county: 'St. Johns',
    county_names_all: 'St. Johns',
    county_weights: '{"12109": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 29.78851,
    longitude: -81.44263,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32033',
  },
  {
    city: 'Fernandina Beach',
    county_fips: 12089,
    county_fips_all: '12089',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"12089": 100}',
    density: 243.8,
    imprecise: false,
    latitude: 30.624,
    longitude: -81.49392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32034',
  },
  {
    city: 'Fort White',
    county_fips: 12023,
    county_fips_all: '12023',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"12023": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 29.93617,
    longitude: -82.69924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32038',
  },
  {
    city: 'Glen Saint Mary',
    county_fips: 12003,
    county_fips_all: '12003',
    county: 'Baker',
    county_names_all: 'Baker',
    county_weights: '{"12003": 100}',
    density: 28.6,
    imprecise: false,
    latitude: 30.24696,
    longitude: -82.23531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32040',
  },
  {
    city: 'Green Cove Springs',
    county_fips: 12019,
    county_fips_all: '12019|12107',
    county: 'Clay',
    county_names_all: 'Clay|Putnam',
    county_weights: '{"12019": 93.13, "12107": 6.87}',
    density: 58.2,
    imprecise: false,
    latitude: 29.92991,
    longitude: -81.74304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32043',
  },
  {
    city: 'Hampton',
    county_fips: 12007,
    county_fips_all: '12007|12001',
    county: 'Bradford',
    county_names_all: 'Bradford|Alachua',
    county_weights: '{"12007": 93.71, "12001": 6.29}',
    density: 57.3,
    imprecise: false,
    latitude: 29.85344,
    longitude: -82.16425,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32044',
  },
  {
    city: 'Hilliard',
    county_fips: 12089,
    county_fips_all: '12089',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"12089": 100}',
    density: 20.8,
    imprecise: false,
    latitude: 30.70253,
    longitude: -81.91718,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32046',
  },
  {
    city: 'Jasper',
    county_fips: 12047,
    county_fips_all: '12047',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"12047": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 30.48683,
    longitude: -82.94499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32052',
  },
  {
    city: 'Jennings',
    county_fips: 12047,
    county_fips_all: '12047',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"12047": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 30.56417,
    longitude: -83.1519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32053',
  },
  {
    city: 'Lake Butler',
    county_fips: 12125,
    county_fips_all: '12125|12007',
    county: 'Union',
    county_names_all: 'Union|Bradford',
    county_weights: '{"12125": 91.31, "12007": 8.69}',
    density: 22.5,
    imprecise: false,
    latitude: 30.0281,
    longitude: -82.39143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32054',
  },
  {
    city: 'Lake City',
    county_fips: 12023,
    county_fips_all: '12023',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"12023": 100}',
    density: 36.8,
    imprecise: false,
    latitude: 30.27031,
    longitude: -82.62507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32055',
  },
  {
    city: 'Lawtey',
    county_fips: 12007,
    county_fips_all: '12007|12125|12019',
    county: 'Bradford',
    county_names_all: 'Bradford|Union|Clay',
    county_weights: '{"12007": 86.69, "12125": 10.47, "12019": 2.84}',
    density: 25.1,
    imprecise: false,
    latitude: 30.07988,
    longitude: -82.10743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32058',
  },
  {
    city: 'Lee',
    county_fips: 12079,
    county_fips_all: '12079',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"12079": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 30.38672,
    longitude: -83.27066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32059',
  },
  {
    city: 'Live Oak',
    county_fips: 12121,
    county_fips_all: '12121',
    county: 'Suwannee',
    county_names_all: 'Suwannee',
    county_weights: '{"12121": 100}',
    density: 22,
    imprecise: false,
    latitude: 30.27554,
    longitude: -83.04935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32060',
  },
  {
    city: 'Lulu',
    county_fips: 12023,
    county_fips_all: '12023',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"12023": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 30.08311,
    longitude: -82.51666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32061',
  },
  {
    city: 'McAlpin',
    county_fips: 12121,
    county_fips_all: '12121',
    county: 'Suwannee',
    county_names_all: 'Suwannee',
    county_weights: '{"12121": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 30.13276,
    longitude: -82.9754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32062',
  },
  {
    city: 'Macclenny',
    county_fips: 12003,
    county_fips_all: '12003',
    county: 'Baker',
    county_names_all: 'Baker',
    county_weights: '{"12003": 100}',
    density: 77,
    imprecise: false,
    latitude: 30.27045,
    longitude: -82.11974,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32063',
  },
  {
    city: 'Live Oak',
    county_fips: 12121,
    county_fips_all: '12121',
    county: 'Suwannee',
    county_names_all: 'Suwannee',
    county_weights: '{"12121": 100}',
    density: 322.4,
    imprecise: false,
    latitude: 30.28907,
    longitude: -83.02375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32064',
  },
  {
    city: 'Orange Park',
    county_fips: 12019,
    county_fips_all: '12019',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"12019": 100}',
    density: 810.4,
    imprecise: false,
    latitude: 30.15613,
    longitude: -81.81762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32065',
  },
  {
    city: 'Mayo',
    county_fips: 12067,
    county_fips_all: '12067',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"12067": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 30.04423,
    longitude: -83.22495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32066',
  },
  {
    city: 'Middleburg',
    county_fips: 12019,
    county_fips_all: '12019',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"12019": 100}',
    density: 197.1,
    imprecise: false,
    latitude: 30.08218,
    longitude: -81.88245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32068',
  },
  {
    city: "O'Brien",
    county_fips: 12121,
    county_fips_all: '12121',
    county: 'Suwannee',
    county_names_all: 'Suwannee',
    county_weights: '{"12121": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 30.04097,
    longitude: -82.945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32071',
  },
  {
    city: 'Orange Park',
    county_fips: 12019,
    county_fips_all: '12019',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"12019": 100}',
    density: 998.9,
    imprecise: false,
    latitude: 30.16766,
    longitude: -81.74069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32073',
  },
  {
    city: 'Penney Farms',
    county_fips: 12019,
    county_fips_all: '12019',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"12019": 100}',
    density: 357.7,
    imprecise: false,
    latitude: 29.97814,
    longitude: -81.80563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32079',
  },
  {
    city: 'Saint Augustine',
    county_fips: 12109,
    county_fips_all: '12109|12035',
    county: 'St. Johns',
    county_names_all: 'St. Johns|Flagler',
    county_weights: '{"12109": 99.06, "12035": 0.94}',
    density: 512.9,
    imprecise: false,
    latitude: 29.82453,
    longitude: -81.27412,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32080',
  },
  {
    city: 'Ponte Vedra',
    county_fips: 12109,
    county_fips_all: '12109|12031',
    county: 'St. Johns',
    county_names_all: 'St. Johns|Duval',
    county_weights: '{"12109": 90.41, "12031": 9.59}',
    density: 326,
    imprecise: false,
    latitude: 30.12143,
    longitude: -81.42089,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32081',
  },
  {
    city: 'Ponte Vedra Beach',
    county_fips: 12109,
    county_fips_all: '12109',
    county: 'St. Johns',
    county_names_all: 'St. Johns',
    county_weights: '{"12109": 100}',
    density: 339,
    imprecise: false,
    latitude: 30.12488,
    longitude: -81.36577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32082',
  },
  {
    city: 'Raiford',
    county_fips: 12125,
    county_fips_all: '12125|12007',
    county: 'Union',
    county_names_all: 'Union|Bradford',
    county_weights: '{"12125": 98.05, "12007": 1.95}',
    density: 25.1,
    imprecise: false,
    latitude: 30.09074,
    longitude: -82.23222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32083',
  },
  {
    city: 'Saint Augustine',
    county_fips: 12109,
    county_fips_all: '12109',
    county: 'St. Johns',
    county_names_all: 'St. Johns',
    county_weights: '{"12109": 100}',
    density: 319.1,
    imprecise: false,
    latitude: 29.91412,
    longitude: -81.36417,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32084',
  },
  {
    city: 'Saint Augustine',
    county_fips: 12109,
    county_fips_all: '12109',
    county: 'St. Johns',
    county_names_all: 'St. Johns',
    county_weights: '{"12109": 100}',
    density: 204.7,
    imprecise: false,
    latitude: 29.75656,
    longitude: -81.30282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32086',
  },
  {
    city: 'Sanderson',
    county_fips: 12003,
    county_fips_all: '12003',
    county: 'Baker',
    county_names_all: 'Baker',
    county_weights: '{"12003": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 30.36999,
    longitude: -82.29741,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32087',
  },
  {
    city: 'Starke',
    county_fips: 12007,
    county_fips_all: '12007|12019',
    county: 'Bradford',
    county_names_all: 'Bradford|Clay',
    county_weights: '{"12007": 83.22, "12019": 16.78}',
    density: 37.4,
    imprecise: false,
    latitude: 29.93205,
    longitude: -82.11324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32091',
  },
  {
    city: 'Saint Augustine',
    county_fips: 12109,
    county_fips_all: '12109',
    county: 'St. Johns',
    county_names_all: 'St. Johns',
    county_weights: '{"12109": 100}',
    density: 165.2,
    imprecise: false,
    latitude: 29.92849,
    longitude: -81.52209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32092',
  },
  {
    city: 'Wellborn',
    county_fips: 12121,
    county_fips_all: '12121|12023',
    county: 'Suwannee',
    county_names_all: 'Suwannee|Columbia',
    county_weights: '{"12121": 88.48, "12023": 11.52}',
    density: 23.8,
    imprecise: false,
    latitude: 30.19797,
    longitude: -82.82767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32094',
  },
  {
    city: 'Saint Augustine',
    county_fips: 12109,
    county_fips_all: '12109',
    county: 'St. Johns',
    county_names_all: 'St. Johns',
    county_weights: '{"12109": 100}',
    density: 144,
    imprecise: false,
    latitude: 30.01693,
    longitude: -81.40927,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32095',
  },
  {
    city: 'White Springs',
    county_fips: 12023,
    county_fips_all: '12023|12047|12121',
    county: 'Columbia',
    county_names_all: 'Columbia|Hamilton|Suwannee',
    county_weights: '{"12023": 55.39, "12047": 42.96, "12121": 1.65}',
    density: 8.2,
    imprecise: false,
    latitude: 30.43678,
    longitude: -82.7011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32096',
  },
  {
    city: 'Yulee',
    county_fips: 12089,
    county_fips_all: '12089',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"12089": 100}',
    density: 82.7,
    imprecise: false,
    latitude: 30.65851,
    longitude: -81.64478,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32097',
  },
  {
    city: 'Astor',
    county_fips: 12069,
    county_fips_all: '12069|12127',
    county: 'Lake',
    county_names_all: 'Lake|Volusia',
    county_weights: '{"12069": 61.11, "12127": 38.89}',
    density: 14.7,
    imprecise: false,
    latitude: 29.1359,
    longitude: -81.52544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32102',
  },
  {
    city: 'Bunnell',
    county_fips: 12035,
    county_fips_all: '12035',
    county: 'Flagler',
    county_names_all: 'Flagler',
    county_weights: '{"12035": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 29.44456,
    longitude: -81.36131,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32110',
  },
  {
    city: 'Crescent City',
    county_fips: 12107,
    county_fips_all: '12107',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"12107": 100}',
    density: 61.6,
    imprecise: false,
    latitude: 29.42664,
    longitude: -81.55649,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32112',
  },
  {
    city: 'Citra',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 26.9,
    imprecise: false,
    latitude: 29.39836,
    longitude: -82.08127,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32113',
  },
  {
    city: 'Daytona Beach',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 911,
    imprecise: false,
    latitude: 29.19312,
    longitude: -81.04915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32114',
  },
  {
    city: 'Daytona Beach',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 996.3,
    imprecise: false,
    latitude: 29.23351,
    longitude: -81.06727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32117',
  },
  {
    city: 'Daytona Beach',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 1673.8,
    imprecise: false,
    latitude: 29.21035,
    longitude: -81.00425,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32118',
  },
  {
    city: 'Daytona Beach',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 1102.9,
    imprecise: false,
    latitude: 29.16001,
    longitude: -81.02707,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32119',
  },
  {
    city: 'Daytona Beach',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 71.7,
    imprecise: false,
    latitude: 29.15802,
    longitude: -81.15732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32124',
  },
  {
    city: 'Port Orange',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 768.6,
    imprecise: false,
    latitude: 29.10866,
    longitude: -80.97907,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32127',
  },
  {
    city: 'Port Orange',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 257.1,
    imprecise: false,
    latitude: 29.09773,
    longitude: -81.07467,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32128',
  },
  {
    city: 'Port Orange',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 1190.9,
    imprecise: false,
    latitude: 29.13721,
    longitude: -81.02381,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32129',
  },
  {
    city: 'De Leon Springs',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 29.15704,
    longitude: -81.34501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32130',
  },
  {
    city: 'East Palatka',
    county_fips: 12107,
    county_fips_all: '12107|12109',
    county: 'Putnam',
    county_names_all: 'Putnam|St. Johns',
    county_weights: '{"12107": 93.98, "12109": 6.02}',
    density: 54.8,
    imprecise: false,
    latitude: 29.67803,
    longitude: -81.56785,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32131',
  },
  {
    city: 'Edgewater',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 432.4,
    imprecise: false,
    latitude: 28.97731,
    longitude: -80.92345,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32132',
  },
  {
    city: 'Eastlake Weir',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 177,
    imprecise: false,
    latitude: 29.01061,
    longitude: -81.92036,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32133',
  },
  {
    city: 'Fort McCoy',
    county_fips: 12083,
    county_fips_all: '12083|12107|12069',
    county: 'Marion',
    county_names_all: 'Marion|Putnam|Lake',
    county_weights: '{"12083": 79.09, "12107": 19.48, "12069": 1.43}',
    density: 10.7,
    imprecise: false,
    latitude: 29.37177,
    longitude: -81.82562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32134',
  },
  {
    city: 'Flagler Beach',
    county_fips: 12035,
    county_fips_all: '12035|12127',
    county: 'Flagler',
    county_names_all: 'Flagler|Volusia',
    county_weights: '{"12035": 90.25, "12127": 9.75}',
    density: 182.1,
    imprecise: false,
    latitude: 29.45252,
    longitude: -81.14025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32136',
  },
  {
    city: 'Palm Coast',
    county_fips: 12035,
    county_fips_all: '12035',
    county: 'Flagler',
    county_names_all: 'Flagler',
    county_weights: '{"12035": 100}',
    density: 299.4,
    imprecise: false,
    latitude: 29.58057,
    longitude: -81.22455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32137',
  },
  {
    city: 'Georgetown',
    county_fips: 12107,
    county_fips_all: '12107|12127',
    county: 'Putnam',
    county_names_all: 'Putnam|Volusia',
    county_weights: '{"12107": 99.79, "12127": 0.21}',
    density: 30,
    imprecise: false,
    latitude: 29.37693,
    longitude: -81.61431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32139',
  },
  {
    city: 'Florahome',
    county_fips: 12107,
    county_fips_all: '12107|12019',
    county: 'Putnam',
    county_names_all: 'Putnam|Clay',
    county_weights: '{"12107": 90.17, "12019": 9.83}',
    density: 17.1,
    imprecise: false,
    latitude: 29.76274,
    longitude: -81.86306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32140',
  },
  {
    city: 'Edgewater',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 306.7,
    imprecise: false,
    latitude: 28.92322,
    longitude: -80.90196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32141',
  },
  {
    city: 'Hastings',
    county_fips: 12109,
    county_fips_all: '12109|12107',
    county: 'St. Johns',
    county_names_all: 'St. Johns|Putnam',
    county_weights: '{"12109": 99.35, "12107": 0.65}',
    density: 24.8,
    imprecise: false,
    latitude: 29.67899,
    longitude: -81.41973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32145',
  },
  {
    city: 'Hollister',
    county_fips: 12107,
    county_fips_all: '12107',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"12107": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 29.63157,
    longitude: -81.79577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32147',
  },
  {
    city: 'Interlachen',
    county_fips: 12107,
    county_fips_all: '12107',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"12107": 100}',
    density: 59.6,
    imprecise: false,
    latitude: 29.60088,
    longitude: -81.88191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32148',
  },
  {
    city: 'Lake Como',
    county_fips: 12107,
    county_fips_all: '12107',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"12107": 100}',
    density: 98.2,
    imprecise: false,
    latitude: 29.46296,
    longitude: -81.58165,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32157',
  },
  {
    city: 'Lady Lake',
    county_fips: 12069,
    county_fips_all: '12069|12119',
    county: 'Lake',
    county_names_all: 'Lake|Sumter',
    county_weights: '{"12069": 85.93, "12119": 14.07}',
    density: 411,
    imprecise: false,
    latitude: 28.92456,
    longitude: -81.90528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32159',
  },
  {
    city: 'The Villages',
    county_fips: 12119,
    county_fips_all: '12119|12083',
    county: 'Sumter',
    county_names_all: 'Sumter|Marion',
    county_weights: '{"12119": 84.95, "12083": 15.05}',
    density: 939.8,
    imprecise: false,
    latitude: 28.91629,
    longitude: -81.99374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32162',
  },
  {
    city: 'The Villages',
    county_fips: 12119,
    county_fips_all: '12119|12069',
    county: 'Sumter',
    county_names_all: 'Sumter|Lake',
    county_weights: '{"12119": 90.56, "12069": 9.44}',
    density: 583.3,
    imprecise: false,
    latitude: 28.81878,
    longitude: -81.98663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32163',
  },
  {
    city: 'Palm Coast',
    county_fips: 12035,
    county_fips_all: '12035',
    county: 'Flagler',
    county_names_all: 'Flagler',
    county_weights: '{"12035": 100}',
    density: 672.9,
    imprecise: false,
    latitude: 29.48316,
    longitude: -81.2174,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32164',
  },
  {
    city: 'New Smyrna Beach',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 79.9,
    imprecise: false,
    latitude: 28.98214,
    longitude: -81.03721,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32168',
  },
  {
    city: 'New Smyrna Beach',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 242.9,
    imprecise: false,
    latitude: 28.97934,
    longitude: -80.87386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32169',
  },
  {
    city: 'Ormond Beach',
    county_fips: 12127,
    county_fips_all: '12127|12035',
    county: 'Volusia',
    county_names_all: 'Volusia|Flagler',
    county_weights: '{"12127": 71.82, "12035": 28.18}',
    density: 168.7,
    imprecise: false,
    latitude: 29.28928,
    longitude: -81.16446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32174',
  },
  {
    city: 'Ormond Beach',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 1006.8,
    imprecise: false,
    latitude: 29.33216,
    longitude: -81.06327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32176',
  },
  {
    city: 'Palatka',
    county_fips: 12107,
    county_fips_all: '12107',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"12107": 100}',
    density: 43.7,
    imprecise: false,
    latitude: 29.69011,
    longitude: -81.70565,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32177',
  },
  {
    city: 'Ocklawaha',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 47.9,
    imprecise: false,
    latitude: 29.09631,
    longitude: -81.89686,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32179',
  },
  {
    city: 'Pierson',
    county_fips: 12127,
    county_fips_all: '12127|12035',
    county: 'Volusia',
    county_names_all: 'Volusia|Flagler',
    county_weights: '{"12127": 88.09, "12035": 11.91}',
    density: 19,
    imprecise: false,
    latitude: 29.23437,
    longitude: -81.44521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32180',
  },
  {
    city: 'Pomona Park',
    county_fips: 12107,
    county_fips_all: '12107',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"12107": 100}',
    density: 35.9,
    imprecise: false,
    latitude: 29.50658,
    longitude: -81.60126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32181',
  },
  {
    city: 'Orange Springs',
    county_fips: 12083,
    county_fips_all: '12083|12107',
    county: 'Marion',
    county_names_all: 'Marion|Putnam',
    county_weights: '{"12083": 98.56, "12107": 1.44}',
    density: 47.6,
    imprecise: false,
    latitude: 29.50926,
    longitude: -81.94113,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32182',
  },
  {
    city: 'San Mateo',
    county_fips: 12107,
    county_fips_all: '12107',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"12107": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 29.57827,
    longitude: -81.55392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32187',
  },
  {
    city: 'Satsuma',
    county_fips: 12107,
    county_fips_all: '12107',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"12107": 100}',
    density: 73.8,
    imprecise: false,
    latitude: 29.54991,
    longitude: -81.64819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32189',
  },
  {
    city: 'Seville',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 29.33289,
    longitude: -81.49056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32190',
  },
  {
    city: 'Sparr',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 31.5,
    imprecise: false,
    latitude: 29.35005,
    longitude: -82.11109,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32192',
  },
  {
    city: 'Welaka',
    county_fips: 12107,
    county_fips_all: '12107',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"12107": 100}',
    density: 133.8,
    imprecise: false,
    latitude: 29.47605,
    longitude: -81.6647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32193',
  },
  {
    city: 'Weirsdale',
    county_fips: 12083,
    county_fips_all: '12083|12069',
    county: 'Marion',
    county_names_all: 'Marion|Lake',
    county_weights: '{"12083": 87.29, "12069": 12.71}',
    density: 48.9,
    imprecise: false,
    latitude: 28.9854,
    longitude: -81.89814,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32195',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1173.3,
    imprecise: false,
    latitude: 30.32505,
    longitude: -81.64786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32202',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.33702,
    longitude: -81.67129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32203',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1315.4,
    imprecise: false,
    latitude: 30.31636,
    longitude: -81.68095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32204',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1454.5,
    imprecise: false,
    latitude: 30.30275,
    longitude: -81.72257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32205',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1059.5,
    imprecise: false,
    latitude: 30.35069,
    longitude: -81.63865,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32206',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1248.6,
    imprecise: false,
    latitude: 30.29,
    longitude: -81.64018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32207',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1095.2,
    imprecise: false,
    latitude: 30.39351,
    longitude: -81.68245,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32208',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1437.7,
    imprecise: false,
    latitude: 30.36141,
    longitude: -81.69573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32209',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1159.4,
    imprecise: false,
    latitude: 30.26491,
    longitude: -81.74746,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32210',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1732.4,
    imprecise: false,
    latitude: 30.33276,
    longitude: -81.58428,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32211',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 146.4,
    imprecise: false,
    latitude: 30.21916,
    longitude: -81.67869,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32212',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1288.5,
    imprecise: false,
    latitude: 30.27891,
    longitude: -81.58305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32216',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1452.4,
    imprecise: false,
    latitude: 30.2394,
    longitude: -81.62722,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32217',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 291.2,
    imprecise: false,
    latitude: 30.48673,
    longitude: -81.66959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 72905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32218',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 77.3,
    imprecise: false,
    latitude: 30.41815,
    longitude: -81.81367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32219',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 123.1,
    imprecise: false,
    latitude: 30.33693,
    longitude: -81.85335,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32220',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 267.1,
    imprecise: false,
    latitude: 30.26043,
    longitude: -81.86764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32221',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 618.7,
    imprecise: false,
    latitude: 30.21651,
    longitude: -81.8293,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32222',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 878.1,
    imprecise: false,
    latitude: 30.1549,
    longitude: -81.64821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32223',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031|12109',
    county: 'Duval',
    county_names_all: 'Duval|St. Johns',
    county_weights: '{"12031": 91.71, "12109": 8.29}',
    density: 779.1,
    imprecise: false,
    latitude: 30.26815,
    longitude: -81.4642,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32224',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 820.5,
    imprecise: false,
    latitude: 30.35768,
    longitude: -81.50592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32225',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 95.8,
    imprecise: false,
    latitude: 30.46444,
    longitude: -81.50999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32226',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1120.1,
    imprecise: false,
    latitude: 30.38792,
    longitude: -81.40571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32227',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 662.3,
    imprecise: false,
    latitude: 30.39158,
    longitude: -81.40022,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32228',
  },
  {
    city: 'Atlantic Beach',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 932.1,
    imprecise: false,
    latitude: 30.35943,
    longitude: -81.42098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32233',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031|12019|12003|12089',
    county: 'Duval',
    county_names_all: 'Duval|Clay|Baker|Nassau',
    county_weights:
      '{"12031": 45.8, "12019": 28.87, "12003": 20.97, "12089": 4.36}',
    density: 24.6,
    imprecise: false,
    latitude: 30.20784,
    longitude: -82.01096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32234',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1041.6,
    imprecise: false,
    latitude: 30.2171,
    longitude: -81.75384,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32244',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1264.7,
    imprecise: false,
    latitude: 30.29422,
    longitude: -81.51782,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32246',
  },
  {
    city: 'Jacksonville Beach',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1253.4,
    imprecise: false,
    latitude: 30.27846,
    longitude: -81.41035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32250',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 433.6,
    imprecise: false,
    latitude: 30.34164,
    longitude: -81.73549,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32254',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 366.1,
    imprecise: false,
    latitude: 30.1929,
    longitude: -81.50309,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32256',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1352,
    imprecise: false,
    latitude: 30.19515,
    longitude: -81.6123,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32257',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 875.6,
    imprecise: false,
    latitude: 30.13874,
    longitude: -81.54941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32258',
  },
  {
    city: 'Saint Johns',
    county_fips: 12109,
    county_fips_all: '12109|12031',
    county: 'St. Johns',
    county_names_all: 'St. Johns|Duval',
    county_weights: '{"12109": 98.86, "12031": 1.14}',
    density: 512.2,
    imprecise: false,
    latitude: 30.07109,
    longitude: -81.6029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 75016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32259',
  },
  {
    city: 'Neptune Beach',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1184.2,
    imprecise: false,
    latitude: 30.31648,
    longitude: -81.41177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32266',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 1959.9,
    imprecise: false,
    latitude: 30.3728,
    longitude: -81.59465,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32277',
  },
  {
    city: 'Tallahassee',
    county_fips: 12073,
    county_fips_all: '12073',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"12073": 100}',
    density: 1211.5,
    imprecise: false,
    latitude: 30.42701,
    longitude: -84.25799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32301',
  },
  {
    city: 'Tallahassee',
    county_fips: 12073,
    county_fips_all: '12073',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"12073": 100}',
    density: 552,
    imprecise: false,
    latitude: 30.51237,
    longitude: -84.34386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32303',
  },
  {
    city: 'Tallahassee',
    county_fips: 12073,
    county_fips_all: '12073',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"12073": 100}',
    density: 1314.7,
    imprecise: false,
    latitude: 30.45346,
    longitude: -84.35314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32304',
  },
  {
    city: 'Tallahassee',
    county_fips: 12073,
    county_fips_all: '12073',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"12073": 100}',
    density: 78,
    imprecise: false,
    latitude: 30.3337,
    longitude: -84.26977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32305',
  },
  {
    city: 'Tallahassee',
    county_fips: 12073,
    county_fips_all: '12073',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"12073": 100}',
    density: 596.1,
    imprecise: false,
    latitude: 30.4781,
    longitude: -84.21968,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32308',
  },
  {
    city: 'Tallahassee',
    county_fips: 12073,
    county_fips_all: '12073',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"12073": 100}',
    density: 106.2,
    imprecise: false,
    latitude: 30.57174,
    longitude: -84.10128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32309',
  },
  {
    city: 'Tallahassee',
    county_fips: 12073,
    county_fips_all: '12073',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"12073": 100}',
    density: 62.6,
    imprecise: false,
    latitude: 30.39924,
    longitude: -84.50694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32310',
  },
  {
    city: 'Tallahassee',
    county_fips: 12073,
    county_fips_all: '12073',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"12073": 100}',
    density: 149.7,
    imprecise: false,
    latitude: 30.39647,
    longitude: -84.16843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32311',
  },
  {
    city: 'Tallahassee',
    county_fips: 12073,
    county_fips_all: '12073',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"12073": 100}',
    density: 133.2,
    imprecise: false,
    latitude: 30.60421,
    longitude: -84.23996,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32312',
  },
  {
    city: 'Tallahassee',
    county_fips: 12073,
    county_fips_all: '12073',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"12073": 100}',
    density: 159.2,
    imprecise: false,
    latitude: 30.46746,
    longitude: -84.11442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32317',
  },
  {
    city: 'Apalachicola',
    county_fips: 12037,
    county_fips_all: '12037',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"12037": 100}',
    density: 45.8,
    imprecise: false,
    latitude: 29.74232,
    longitude: -85.06938,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32320',
  },
  {
    city: 'Bristol',
    county_fips: 12077,
    county_fips_all: '12077|12037',
    county: 'Liberty',
    county_names_all: 'Liberty|Franklin',
    county_weights: '{"12077": 97.72, "12037": 2.28}',
    density: 5.7,
    imprecise: false,
    latitude: 30.26196,
    longitude: -84.9891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32321',
  },
  {
    city: 'Carrabelle',
    county_fips: 12037,
    county_fips_all: '12037',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"12037": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 29.89948,
    longitude: -84.62327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32322',
  },
  {
    city: 'Lanark Village',
    county_fips: 12037,
    county_fips_all: '12037',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"12037": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 29.89185,
    longitude: -84.6122,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 90,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32323',
  },
  {
    city: 'Chattahoochee',
    county_fips: 12039,
    county_fips_all: '12039',
    county: 'Gadsden',
    county_names_all: 'Gadsden',
    county_weights: '{"12039": 100}',
    density: 27.4,
    imprecise: false,
    latitude: 30.65635,
    longitude: -84.79126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32324',
  },
  {
    city: 'Crawfordville',
    county_fips: 12129,
    county_fips_all: '12129',
    county: 'Wakulla',
    county_names_all: 'Wakulla',
    county_weights: '{"12129": 100}',
    density: 51.5,
    imprecise: false,
    latitude: 30.18705,
    longitude: -84.30472,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32327',
  },
  {
    city: 'Eastpoint',
    county_fips: 12037,
    county_fips_all: '12037',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"12037": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 29.8463,
    longitude: -84.90991,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32328',
  },
  {
    city: 'Greensboro',
    county_fips: 12039,
    county_fips_all: '12039',
    county: 'Gadsden',
    county_names_all: 'Gadsden',
    county_weights: '{"12039": 100}',
    density: 112.1,
    imprecise: false,
    latitude: 30.57859,
    longitude: -84.74799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32330',
  },
  {
    city: 'Greenville',
    county_fips: 12079,
    county_fips_all: '12079|12123|12065',
    county: 'Madison',
    county_names_all: 'Madison|Taylor|Jefferson',
    county_weights: '{"12079": 73.43, "12123": 13.77, "12065": 12.8}',
    density: 5.2,
    imprecise: false,
    latitude: 30.45851,
    longitude: -83.6294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32331',
  },
  {
    city: 'Gretna',
    county_fips: 12039,
    county_fips_all: '12039',
    county: 'Gadsden',
    county_names_all: 'Gadsden',
    county_weights: '{"12039": 100}',
    density: 142.8,
    imprecise: false,
    latitude: 30.61168,
    longitude: -84.6657,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32332',
  },
  {
    city: 'Havana',
    county_fips: 12039,
    county_fips_all: '12039',
    county: 'Gadsden',
    county_names_all: 'Gadsden',
    county_weights: '{"12039": 100}',
    density: 41.9,
    imprecise: false,
    latitude: 30.60677,
    longitude: -84.41249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32333',
  },
  {
    city: 'Hosford',
    county_fips: 12077,
    county_fips_all: '12077',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"12077": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 30.2612,
    longitude: -84.75835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32334',
  },
  {
    city: 'Lamont',
    county_fips: 12123,
    county_fips_all: '12123|12065|12079',
    county: 'Taylor',
    county_names_all: 'Taylor|Jefferson|Madison',
    county_weights: '{"12123": 47.44, "12065": 40.29, "12079": 12.27}',
    density: 2.4,
    imprecise: false,
    latitude: 30.26371,
    longitude: -83.86319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32336',
  },
  {
    city: 'Lloyd',
    county_fips: 12065,
    county_fips_all: '12065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"12065": 100}',
    density: 206.5,
    imprecise: false,
    latitude: 30.48307,
    longitude: -84.02104,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32337',
  },
  {
    city: 'Madison',
    county_fips: 12079,
    county_fips_all: '12079',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"12079": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 30.45651,
    longitude: -83.42667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32340',
  },
  {
    city: 'Midway',
    county_fips: 12039,
    county_fips_all: '12039',
    county: 'Gadsden',
    county_names_all: 'Gadsden',
    county_weights: '{"12039": 100}',
    density: 52.5,
    imprecise: false,
    latitude: 30.48515,
    longitude: -84.47652,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32343',
  },
  {
    city: 'Monticello',
    county_fips: 12065,
    county_fips_all: '12065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"12065": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 30.44645,
    longitude: -83.91902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32344',
  },
  {
    city: 'Panacea',
    county_fips: 12129,
    county_fips_all: '12129|12037',
    county: 'Wakulla',
    county_names_all: 'Wakulla|Franklin',
    county_weights: '{"12129": 60.54, "12037": 39.46}',
    density: 32,
    imprecise: false,
    latitude: 29.97919,
    longitude: -84.38387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32346',
  },
  {
    city: 'Perry',
    county_fips: 12123,
    county_fips_all: '12123',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"12123": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 30.14416,
    longitude: -83.64268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32347',
  },
  {
    city: 'Perry',
    county_fips: 12123,
    county_fips_all: '12123',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"12123": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 29.94808,
    longitude: -83.56762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32348',
  },
  {
    city: 'Pinetta',
    county_fips: 12079,
    county_fips_all: '12079',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"12079": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 30.58662,
    longitude: -83.32242,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32350',
  },
  {
    city: 'Quincy',
    county_fips: 12039,
    county_fips_all: '12039',
    county: 'Gadsden',
    county_names_all: 'Gadsden',
    county_weights: '{"12039": 100}',
    density: 29.7,
    imprecise: false,
    latitude: 30.52358,
    longitude: -84.68362,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32351',
  },
  {
    city: 'Quincy',
    county_fips: 12039,
    county_fips_all: '12039',
    county: 'Gadsden',
    county_names_all: 'Gadsden',
    county_weights: '{"12039": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 30.6499,
    longitude: -84.58535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32352',
  },
  {
    city: 'Saint Marks',
    county_fips: 12129,
    county_fips_all: '12129',
    county: 'Wakulla',
    county_names_all: 'Wakulla',
    county_weights: '{"12129": 100}',
    density: 33.8,
    imprecise: false,
    latitude: 30.1695,
    longitude: -84.21002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32355',
  },
  {
    city: 'Salem',
    county_fips: 12123,
    county_fips_all: '12123',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"12123": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 29.85387,
    longitude: -83.40018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32356',
  },
  {
    city: 'Sopchoppy',
    county_fips: 12129,
    county_fips_all: '12129|12037',
    county: 'Wakulla',
    county_names_all: 'Wakulla|Franklin',
    county_weights: '{"12129": 84.78, "12037": 15.22}',
    density: 4.1,
    imprecise: false,
    latitude: 30.09535,
    longitude: -84.54468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32358',
  },
  {
    city: 'Steinhatchee',
    county_fips: 12029,
    county_fips_all: '12029|12123',
    county: 'Dixie',
    county_names_all: 'Dixie|Taylor',
    county_weights: '{"12029": 61.1, "12123": 38.9}',
    density: 3,
    imprecise: false,
    latitude: 29.66181,
    longitude: -83.37047,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32359',
  },
  {
    city: 'Telogia',
    county_fips: 12077,
    county_fips_all: '12077',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"12077": 100}',
    density: 173.2,
    imprecise: false,
    latitude: 30.36506,
    longitude: -84.81238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32360',
  },
  {
    city: 'Wacissa',
    county_fips: 12065,
    county_fips_all: '12065',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"12065": 100}',
    density: 40.3,
    imprecise: false,
    latitude: 30.35765,
    longitude: -83.98865,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32361',
  },
  {
    city: 'Panama City',
    county_fips: 12005,
    county_fips_all: '12005',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"12005": 100}',
    density: 585.5,
    imprecise: false,
    latitude: 30.14477,
    longitude: -85.67448,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32401',
  },
  {
    city: 'Panama City',
    county_fips: 12005,
    county_fips_all: '12005',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"12005": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 30.05337,
    longitude: -85.55679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32403',
  },
  {
    city: 'Panama City',
    county_fips: 12005,
    county_fips_all: '12005',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"12005": 100}',
    density: 121.5,
    imprecise: false,
    latitude: 30.19075,
    longitude: -85.51122,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32404',
  },
  {
    city: 'Panama City',
    county_fips: 12005,
    county_fips_all: '12005',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"12005": 100}',
    density: 616.5,
    imprecise: false,
    latitude: 30.20002,
    longitude: -85.66869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32405',
  },
  {
    city: 'Panama City Beach',
    county_fips: 12005,
    county_fips_all: '12005',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"12005": 100}',
    density: 424.6,
    imprecise: false,
    latitude: 30.20276,
    longitude: -85.7912,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32407',
  },
  {
    city: 'Panama City',
    county_fips: 12005,
    county_fips_all: '12005',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"12005": 100}',
    density: 848.2,
    imprecise: false,
    latitude: 30.1593,
    longitude: -85.75324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32408',
  },
  {
    city: 'Panama City',
    county_fips: 12005,
    county_fips_all: '12005',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"12005": 100}',
    density: 33.9,
    imprecise: false,
    latitude: 30.33447,
    longitude: -85.70516,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32409',
  },
  {
    city: 'Panama City Beach',
    county_fips: 12005,
    county_fips_all: '12005|12131',
    county: 'Bay',
    county_names_all: 'Bay|Walton',
    county_weights: '{"12005": 99.58, "12131": 0.42}',
    density: 55.1,
    imprecise: false,
    latitude: 30.30975,
    longitude: -85.88745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32413',
  },
  {
    city: 'Alford',
    county_fips: 12063,
    county_fips_all: '12063|12133',
    county: 'Jackson',
    county_names_all: 'Jackson|Washington',
    county_weights: '{"12063": 97.61, "12133": 2.39}',
    density: 15.7,
    imprecise: false,
    latitude: 30.63637,
    longitude: -85.38123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32420',
  },
  {
    city: 'Altha',
    county_fips: 12013,
    county_fips_all: '12013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"12013": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 30.52973,
    longitude: -85.19308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32421',
  },
  {
    city: 'Bascom',
    county_fips: 12063,
    county_fips_all: '12063',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"12063": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 30.94496,
    longitude: -85.06073,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32423',
  },
  {
    city: 'Blountstown',
    county_fips: 12013,
    county_fips_all: '12013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"12013": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 30.38901,
    longitude: -85.08232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32424',
  },
  {
    city: 'Bonifay',
    county_fips: 12059,
    county_fips_all: '12059|12133',
    county: 'Holmes',
    county_names_all: 'Holmes|Washington',
    county_weights: '{"12059": 85.81, "12133": 14.19}',
    density: 20.3,
    imprecise: false,
    latitude: 30.85538,
    longitude: -85.72225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32425',
  },
  {
    city: 'Campbellton',
    county_fips: 12063,
    county_fips_all: '12063',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"12063": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 30.94861,
    longitude: -85.36714,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32426',
  },
  {
    city: 'Caryville',
    county_fips: 12133,
    county_fips_all: '12133',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"12133": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 30.71587,
    longitude: -85.79311,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32427',
  },
  {
    city: 'Chipley',
    county_fips: 12133,
    county_fips_all: '12133|12005|12063',
    county: 'Washington',
    county_names_all: 'Washington|Bay|Jackson',
    county_weights: '{"12133": 97.48, "12005": 1.67, "12063": 0.85}',
    density: 24.2,
    imprecise: false,
    latitude: 30.61797,
    longitude: -85.57154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32428',
  },
  {
    city: 'Clarksville',
    county_fips: 12013,
    county_fips_all: '12013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"12013": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 30.41872,
    longitude: -85.22562,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32430',
  },
  {
    city: 'Cottondale',
    county_fips: 12063,
    county_fips_all: '12063|12133',
    county: 'Jackson',
    county_names_all: 'Jackson|Washington',
    county_weights: '{"12063": 82.98, "12133": 17.02}',
    density: 17.1,
    imprecise: false,
    latitude: 30.78609,
    longitude: -85.40982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32431',
  },
  {
    city: 'Cypress',
    county_fips: 12063,
    county_fips_all: '12063',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"12063": 100}',
    density: 112.9,
    imprecise: false,
    latitude: 30.71415,
    longitude: -85.07727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32432',
  },
  {
    city: 'Defuniak Springs',
    county_fips: 12131,
    county_fips_all: '12131',
    county: 'Walton',
    county_names_all: 'Walton',
    county_weights: '{"12131": 100}',
    density: 30.3,
    imprecise: false,
    latitude: 30.84848,
    longitude: -86.19822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32433',
  },
  {
    city: 'Defuniak Springs',
    county_fips: 12131,
    county_fips_all: '12131',
    county: 'Walton',
    county_names_all: 'Walton',
    county_weights: '{"12131": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 30.65367,
    longitude: -86.11597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32435',
  },
  {
    city: 'Ebro',
    county_fips: 12133,
    county_fips_all: '12133|12005',
    county: 'Washington',
    county_names_all: 'Washington|Bay',
    county_weights: '{"12133": 77.53, "12005": 22.47}',
    density: 4.7,
    imprecise: false,
    latitude: 30.43315,
    longitude: -85.90694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32437',
  },
  {
    city: 'Fountain',
    county_fips: 12005,
    county_fips_all: '12005|12013|12063|12133',
    county: 'Bay',
    county_names_all: 'Bay|Calhoun|Jackson|Washington',
    county_weights:
      '{"12005": 77.1, "12013": 17.09, "12063": 4.6, "12133": 1.21}',
    density: 32.8,
    imprecise: false,
    latitude: 30.51251,
    longitude: -85.41744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32438',
  },
  {
    city: 'Freeport',
    county_fips: 12131,
    county_fips_all: '12131',
    county: 'Walton',
    county_names_all: 'Walton',
    county_weights: '{"12131": 100}',
    density: 61.3,
    imprecise: false,
    latitude: 30.49082,
    longitude: -86.12933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32439',
  },
  {
    city: 'Graceville',
    county_fips: 12063,
    county_fips_all: '12063|12059',
    county: 'Jackson',
    county_names_all: 'Jackson|Holmes',
    county_weights: '{"12063": 69.01, "12059": 30.99}',
    density: 29.7,
    imprecise: false,
    latitude: 30.92025,
    longitude: -85.52588,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32440',
  },
  {
    city: 'Grand Ridge',
    county_fips: 12063,
    county_fips_all: '12063|12013',
    county: 'Jackson',
    county_names_all: 'Jackson|Calhoun',
    county_weights: '{"12063": 89.76, "12013": 10.24}',
    density: 14,
    imprecise: false,
    latitude: 30.68531,
    longitude: -85.00829,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32442',
  },
  {
    city: 'Greenwood',
    county_fips: 12063,
    county_fips_all: '12063',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"12063": 100}',
    density: 19.6,
    imprecise: false,
    latitude: 30.86586,
    longitude: -85.11695,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32443',
  },
  {
    city: 'Lynn Haven',
    county_fips: 12005,
    county_fips_all: '12005',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"12005": 100}',
    density: 844.3,
    imprecise: false,
    latitude: 30.23854,
    longitude: -85.65185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32444',
  },
  {
    city: 'Malone',
    county_fips: 12063,
    county_fips_all: '12063',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"12063": 100}',
    density: 37.1,
    imprecise: false,
    latitude: 30.96924,
    longitude: -85.19504,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32445',
  },
  {
    city: 'Marianna',
    county_fips: 12063,
    county_fips_all: '12063',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"12063": 100}',
    density: 25.5,
    imprecise: false,
    latitude: 30.84493,
    longitude: -85.23017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32446',
  },
  {
    city: 'Marianna',
    county_fips: 12063,
    county_fips_all: '12063|12013',
    county: 'Jackson',
    county_names_all: 'Jackson|Calhoun',
    county_weights: '{"12063": 99.3, "12013": 0.7}',
    density: 18.3,
    imprecise: false,
    latitude: 30.66663,
    longitude: -85.21616,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32448',
  },
  {
    city: 'Wewahitchka',
    county_fips: 12013,
    county_fips_all: '12013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"12013": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 30.27611,
    longitude: -85.20607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32449',
  },
  {
    city: 'Ponce De Leon',
    county_fips: 12131,
    county_fips_all: '12131|12059',
    county: 'Walton',
    county_names_all: 'Walton|Holmes',
    county_weights: '{"12131": 67.84, "12059": 32.16}',
    density: 7.5,
    imprecise: false,
    latitude: 30.63831,
    longitude: -85.96395,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32455',
  },
  {
    city: 'Port Saint Joe',
    county_fips: 12045,
    county_fips_all: '12045|12005|12037',
    county: 'Gulf',
    county_names_all: 'Gulf|Bay|Franklin',
    county_weights: '{"12045": 72.37, "12005": 20.32, "12037": 7.31}',
    density: 27.3,
    imprecise: false,
    latitude: 29.84586,
    longitude: -85.3188,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32456',
  },
  {
    city: 'Santa Rosa Beach',
    county_fips: 12131,
    county_fips_all: '12131',
    county: 'Walton',
    county_names_all: 'Walton',
    county_weights: '{"12131": 100}',
    density: 166.6,
    imprecise: false,
    latitude: 30.36527,
    longitude: -86.18429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32459',
  },
  {
    city: 'Sneads',
    county_fips: 12063,
    county_fips_all: '12063',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"12063": 100}',
    density: 29,
    imprecise: false,
    latitude: 30.77565,
    longitude: -84.94949,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32460',
  },
  {
    city: 'Inlet Beach',
    county_fips: 12131,
    county_fips_all: '12131',
    county: 'Walton',
    county_names_all: 'Walton',
    county_weights: '{"12131": 100}',
    density: 97.5,
    imprecise: false,
    latitude: 30.30905,
    longitude: -86.03508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32461',
  },
  {
    city: 'Vernon',
    county_fips: 12133,
    county_fips_all: '12133|12131|12005',
    county: 'Washington',
    county_names_all: 'Washington|Walton|Bay',
    county_weights: '{"12133": 81.89, "12131": 16.68, "12005": 1.43}',
    density: 9.8,
    imprecise: false,
    latitude: 30.55753,
    longitude: -85.83241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32462',
  },
  {
    city: 'Wausau',
    county_fips: 12133,
    county_fips_all: '12133',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"12133": 100}',
    density: 109.9,
    imprecise: false,
    latitude: 30.6279,
    longitude: -85.58728,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32463',
  },
  {
    city: 'Westville',
    county_fips: 12059,
    county_fips_all: '12059|12131',
    county: 'Holmes',
    county_names_all: 'Holmes|Walton',
    county_weights: '{"12059": 81.84, "12131": 18.16}',
    density: 7.2,
    imprecise: false,
    latitude: 30.89687,
    longitude: -85.95592,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32464',
  },
  {
    city: 'Wewahitchka',
    county_fips: 12045,
    county_fips_all: '12045',
    county: 'Gulf',
    county_names_all: 'Gulf',
    county_weights: '{"12045": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 30.00239,
    longitude: -85.18615,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32465',
  },
  {
    city: 'Youngstown',
    county_fips: 12005,
    county_fips_all: '12005|12013|12133',
    county: 'Bay',
    county_names_all: 'Bay|Calhoun|Washington',
    county_weights: '{"12005": 65.66, "12013": 24.08, "12133": 10.26}',
    density: 13.2,
    imprecise: false,
    latitude: 30.38618,
    longitude: -85.464,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32466',
  },
  {
    city: 'Pensacola',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 1155.6,
    imprecise: false,
    latitude: 30.42826,
    longitude: -87.22277,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32501',
  },
  {
    city: 'Pensacola',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 609.3,
    imprecise: false,
    latitude: 30.40928,
    longitude: -87.22636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32502',
  },
  {
    city: 'Pensacola',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 1027.5,
    imprecise: false,
    latitude: 30.46022,
    longitude: -87.21372,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32503',
  },
  {
    city: 'Pensacola',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 815.4,
    imprecise: false,
    latitude: 30.48495,
    longitude: -87.19093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32504',
  },
  {
    city: 'Pensacola',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 830.8,
    imprecise: false,
    latitude: 30.45575,
    longitude: -87.26082,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32505',
  },
  {
    city: 'Pensacola',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 436,
    imprecise: false,
    latitude: 30.39152,
    longitude: -87.37167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32506',
  },
  {
    city: 'Pensacola',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 446.4,
    imprecise: false,
    latitude: 30.34035,
    longitude: -87.37706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32507',
  },
  {
    city: 'Pensacola',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 282.6,
    imprecise: false,
    latitude: 30.35614,
    longitude: -87.29866,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32508',
  },
  {
    city: 'Pensacola',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 827,
    imprecise: false,
    latitude: 30.53209,
    longitude: -87.22235,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32514',
  },
  {
    city: 'Pensacola',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 295.3,
    imprecise: false,
    latitude: 30.49824,
    longitude: -87.36543,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32526',
  },
  {
    city: 'Bagdad',
    county_fips: 12113,
    county_fips_all: '12113',
    county: 'Santa Rosa',
    county_names_all: 'Santa Rosa',
    county_weights: '{"12113": 100}',
    density: 133.5,
    imprecise: false,
    latitude: 30.5926,
    longitude: -87.02344,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32530',
  },
  {
    city: 'Baker',
    county_fips: 12091,
    county_fips_all: '12091|12113',
    county: 'Okaloosa',
    county_names_all: 'Okaloosa|Santa Rosa',
    county_weights: '{"12091": 87.95, "12113": 12.05}',
    density: 12.4,
    imprecise: false,
    latitude: 30.88513,
    longitude: -86.696,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32531',
  },
  {
    city: 'Cantonment',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 159.4,
    imprecise: false,
    latitude: 30.61329,
    longitude: -87.32561,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32533',
  },
  {
    city: 'Pensacola',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 667.9,
    imprecise: false,
    latitude: 30.53276,
    longitude: -87.28374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32534',
  },
  {
    city: 'Century',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 30.9,
    imprecise: false,
    latitude: 30.96515,
    longitude: -87.34673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32535',
  },
  {
    city: 'Crestview',
    county_fips: 12091,
    county_fips_all: '12091',
    county: 'Okaloosa',
    county_names_all: 'Okaloosa',
    county_weights: '{"12091": 100}',
    density: 232.6,
    imprecise: false,
    latitude: 30.75399,
    longitude: -86.59491,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32536',
  },
  {
    city: 'Crestview',
    county_fips: 12091,
    county_fips_all: '12091|12131',
    county: 'Okaloosa',
    county_names_all: 'Okaloosa|Walton',
    county_weights: '{"12091": 88.79, "12131": 11.21}',
    density: 100.5,
    imprecise: false,
    latitude: 30.78128,
    longitude: -86.46646,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32539',
  },
  {
    city: 'Destin',
    county_fips: 12091,
    county_fips_all: '12091',
    county: 'Okaloosa',
    county_names_all: 'Okaloosa',
    county_weights: '{"12091": 100}',
    density: 579.5,
    imprecise: false,
    latitude: 30.39666,
    longitude: -86.47486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32541',
  },
  {
    city: 'Eglin Afb',
    county_fips: 12091,
    county_fips_all: '12091',
    county: 'Okaloosa',
    county_names_all: 'Okaloosa',
    county_weights: '{"12091": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 30.58743,
    longitude: -86.59296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32542',
  },
  {
    city: 'Hurlburt Field',
    county_fips: 12091,
    county_fips_all: '12091',
    county: 'Okaloosa',
    county_names_all: 'Okaloosa',
    county_weights: '{"12091": 100}',
    density: 105.9,
    imprecise: false,
    latitude: 30.42801,
    longitude: -86.70441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32544',
  },
  {
    city: 'Fort Walton Beach',
    county_fips: 12091,
    county_fips_all: '12091',
    county: 'Okaloosa',
    county_names_all: 'Okaloosa',
    county_weights: '{"12091": 100}',
    density: 473.2,
    imprecise: false,
    latitude: 30.46649,
    longitude: -86.65513,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32547',
  },
  {
    city: 'Fort Walton Beach',
    county_fips: 12091,
    county_fips_all: '12091',
    county: 'Okaloosa',
    county_names_all: 'Okaloosa',
    county_weights: '{"12091": 100}',
    density: 759.7,
    imprecise: false,
    latitude: 30.4094,
    longitude: -86.6494,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32548',
  },
  {
    city: 'Miramar Beach',
    county_fips: 12131,
    county_fips_all: '12131',
    county: 'Walton',
    county_names_all: 'Walton',
    county_weights: '{"12131": 100}',
    density: 468.9,
    imprecise: false,
    latitude: 30.38541,
    longitude: -86.34438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32550',
  },
  {
    city: 'Gulf Breeze',
    county_fips: 12033,
    county_fips_all: '12033|12113',
    county: 'Escambia',
    county_names_all: 'Escambia|Santa Rosa',
    county_weights: '{"12033": 77.78, "12113": 22.22}',
    density: 299,
    imprecise: false,
    latitude: 30.35165,
    longitude: -87.10906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32561',
  },
  {
    city: 'Gulf Breeze',
    county_fips: 12113,
    county_fips_all: '12113',
    county: 'Santa Rosa',
    county_names_all: 'Santa Rosa',
    county_weights: '{"12113": 100}',
    density: 704.7,
    imprecise: false,
    latitude: 30.38782,
    longitude: -87.0331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32563',
  },
  {
    city: 'Holt',
    county_fips: 12113,
    county_fips_all: '12113|12091',
    county: 'Santa Rosa',
    county_names_all: 'Santa Rosa|Okaloosa',
    county_weights: '{"12113": 50.15, "12091": 49.85}',
    density: 10,
    imprecise: false,
    latitude: 30.72755,
    longitude: -86.7875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32564',
  },
  {
    city: 'Jay',
    county_fips: 12113,
    county_fips_all: '12113',
    county: 'Santa Rosa',
    county_names_all: 'Santa Rosa',
    county_weights: '{"12113": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 30.89241,
    longitude: -87.14071,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32565',
  },
  {
    city: 'Navarre',
    county_fips: 12113,
    county_fips_all: '12113',
    county: 'Santa Rosa',
    county_names_all: 'Santa Rosa',
    county_weights: '{"12113": 100}',
    density: 432.6,
    imprecise: false,
    latitude: 30.4253,
    longitude: -86.8843,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32566',
  },
  {
    city: 'Laurel Hill',
    county_fips: 12091,
    county_fips_all: '12091|12131',
    county: 'Okaloosa',
    county_names_all: 'Okaloosa|Walton',
    county_weights: '{"12091": 65.23, "12131": 34.77}',
    density: 14.9,
    imprecise: false,
    latitude: 30.92207,
    longitude: -86.43396,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32567',
  },
  {
    city: 'McDavid',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 30.87085,
    longitude: -87.46792,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32568',
  },
  {
    city: 'Mary Esther',
    county_fips: 12091,
    county_fips_all: '12091',
    county: 'Okaloosa',
    county_names_all: 'Okaloosa',
    county_weights: '{"12091": 100}',
    density: 1121.3,
    imprecise: false,
    latitude: 30.40666,
    longitude: -86.72962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32569',
  },
  {
    city: 'Milton',
    county_fips: 12113,
    county_fips_all: '12113',
    county: 'Santa Rosa',
    county_names_all: 'Santa Rosa',
    county_weights: '{"12113": 100}',
    density: 47.7,
    imprecise: false,
    latitude: 30.80022,
    longitude: -86.98158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32570',
  },
  {
    city: 'Milton',
    county_fips: 12113,
    county_fips_all: '12113',
    county: 'Santa Rosa',
    county_names_all: 'Santa Rosa',
    county_weights: '{"12113": 100}',
    density: 144.6,
    imprecise: false,
    latitude: 30.67162,
    longitude: -87.20004,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32571',
  },
  {
    city: 'Molino',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 31.8,
    imprecise: false,
    latitude: 30.73453,
    longitude: -87.37471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32577',
  },
  {
    city: 'Niceville',
    county_fips: 12091,
    county_fips_all: '12091|12131',
    county: 'Okaloosa',
    county_names_all: 'Okaloosa|Walton',
    county_weights: '{"12091": 97.72, "12131": 2.28}',
    density: 578.8,
    imprecise: false,
    latitude: 30.50871,
    longitude: -86.4535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32578',
  },
  {
    city: 'Shalimar',
    county_fips: 12091,
    county_fips_all: '12091',
    county: 'Okaloosa',
    county_names_all: 'Okaloosa',
    county_weights: '{"12091": 100}',
    density: 1163.1,
    imprecise: false,
    latitude: 30.44553,
    longitude: -86.57401,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32579',
  },
  {
    city: 'Valparaiso',
    county_fips: 12091,
    county_fips_all: '12091',
    county: 'Okaloosa',
    county_names_all: 'Okaloosa',
    county_weights: '{"12091": 100}',
    density: 208.8,
    imprecise: false,
    latitude: 30.50337,
    longitude: -86.50942,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32580',
  },
  {
    city: 'Milton',
    county_fips: 12113,
    county_fips_all: '12113',
    county: 'Santa Rosa',
    county_names_all: 'Santa Rosa',
    county_weights: '{"12113": 100}',
    density: 98.3,
    imprecise: false,
    latitude: 30.60084,
    longitude: -86.97513,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32583',
  },
  {
    city: 'Gainesville',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 1946.7,
    imprecise: false,
    latitude: 29.64886,
    longitude: -82.32506,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32601',
  },
  {
    city: 'Gainesville',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 3303.7,
    imprecise: false,
    latitude: 29.65305,
    longitude: -82.35054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32603',
  },
  {
    city: 'Gainesville',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 971.1,
    imprecise: false,
    latitude: 29.67659,
    longitude: -82.37351,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32605',
  },
  {
    city: 'Gainesville',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 577.4,
    imprecise: false,
    latitude: 29.68169,
    longitude: -82.44391,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32606',
  },
  {
    city: 'Gainesville',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 1096.3,
    imprecise: false,
    latitude: 29.64524,
    longitude: -82.41923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32607',
  },
  {
    city: 'Gainesville',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 473.9,
    imprecise: false,
    latitude: 29.59271,
    longitude: -82.3935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32608',
  },
  {
    city: 'Gainesville',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 64.9,
    imprecise: false,
    latitude: 29.76296,
    longitude: -82.27978,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32609',
  },
  {
    city: 'Alachua',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 47,
    imprecise: false,
    latitude: 29.81706,
    longitude: -82.49065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32615',
  },
  {
    city: 'Alachua',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 207.3,
    imprecise: false,
    latitude: 29.78205,
    longitude: -82.49933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32616',
  },
  {
    city: 'Anthony',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 58.2,
    imprecise: false,
    latitude: 29.30659,
    longitude: -82.07553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32617',
  },
  {
    city: 'Archer',
    county_fips: 12001,
    county_fips_all: '12001|12075',
    county: 'Alachua',
    county_names_all: 'Alachua|Levy',
    county_weights: '{"12001": 80.26, "12075": 19.74}',
    density: 29.6,
    imprecise: false,
    latitude: 29.53789,
    longitude: -82.52295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32618',
  },
  {
    city: 'Bell',
    county_fips: 12041,
    county_fips_all: '12041',
    county: 'Gilchrist',
    county_names_all: 'Gilchrist',
    county_weights: '{"12041": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 29.75661,
    longitude: -82.86668,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32619',
  },
  {
    city: 'Bronson',
    county_fips: 12075,
    county_fips_all: '12075',
    county: 'Levy',
    county_names_all: 'Levy',
    county_weights: '{"12075": 100}',
    density: 33.5,
    imprecise: false,
    latitude: 29.426,
    longitude: -82.62936,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32621',
  },
  {
    city: 'Brooker',
    county_fips: 12007,
    county_fips_all: '12007|12001',
    county: 'Bradford',
    county_names_all: 'Bradford|Alachua',
    county_weights: '{"12007": 85.64, "12001": 14.36}',
    density: 7.3,
    imprecise: false,
    latitude: 29.89914,
    longitude: -82.31216,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32622',
  },
  {
    city: 'Cedar Key',
    county_fips: 12075,
    county_fips_all: '12075',
    county: 'Levy',
    county_names_all: 'Levy',
    county_weights: '{"12075": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 29.23005,
    longitude: -82.98331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32625',
  },
  {
    city: 'Chiefland',
    county_fips: 12075,
    county_fips_all: '12075',
    county: 'Levy',
    county_names_all: 'Levy',
    county_weights: '{"12075": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 29.42146,
    longitude: -82.89464,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32626',
  },
  {
    city: 'Cross City',
    county_fips: 12029,
    county_fips_all: '12029',
    county: 'Dixie',
    county_names_all: 'Dixie',
    county_weights: '{"12029": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 29.65471,
    longitude: -83.16247,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32628',
  },
  {
    city: 'Earleton',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 28.7,
    imprecise: false,
    latitude: 29.71719,
    longitude: -82.10225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32631',
  },
  {
    city: 'Fairfield',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 54.9,
    imprecise: false,
    latitude: 29.3646,
    longitude: -82.25419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32634',
  },
  {
    city: 'Gulf Hammock',
    county_fips: 12075,
    county_fips_all: '12075',
    county: 'Levy',
    county_names_all: 'Levy',
    county_weights: '{"12075": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 29.23092,
    longitude: -82.72007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32639',
  },
  {
    city: 'Hawthorne',
    county_fips: 12001,
    county_fips_all: '12001|12107',
    county: 'Alachua',
    county_names_all: 'Alachua|Putnam',
    county_weights: '{"12001": 62.72, "12107": 37.28}',
    density: 21.8,
    imprecise: false,
    latitude: 29.56889,
    longitude: -82.08021,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32640',
  },
  {
    city: 'Gainesville',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 78.5,
    imprecise: false,
    latitude: 29.62956,
    longitude: -82.22557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32641',
  },
  {
    city: 'High Springs',
    county_fips: 12001,
    county_fips_all: '12001|12041|12023',
    county: 'Alachua',
    county_names_all: 'Alachua|Gilchrist|Columbia',
    county_weights: '{"12001": 52.23, "12041": 35.03, "12023": 12.74}',
    density: 41.2,
    imprecise: false,
    latitude: 29.81845,
    longitude: -82.64155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32643',
  },
  {
    city: 'Horseshoe Beach',
    county_fips: 12029,
    county_fips_all: '12029',
    county: 'Dixie',
    county_names_all: 'Dixie',
    county_weights: '{"12029": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 29.50515,
    longitude: -83.24498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32648',
  },
  {
    city: 'Gainesville',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 152.1,
    imprecise: false,
    latitude: 29.74506,
    longitude: -82.40546,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32653',
  },
  {
    city: 'Keystone Heights',
    county_fips: 12019,
    county_fips_all: '12019|12007',
    county: 'Clay',
    county_names_all: 'Clay|Bradford',
    county_weights: '{"12019": 95.35, "12007": 4.65}',
    density: 87.2,
    imprecise: false,
    latitude: 29.82533,
    longitude: -81.95287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32656',
  },
  {
    city: 'La Crosse',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 78.6,
    imprecise: false,
    latitude: 29.84817,
    longitude: -82.41214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32658',
  },
  {
    city: 'McIntosh',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 170.3,
    imprecise: false,
    latitude: 29.44986,
    longitude: -82.22187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32664',
  },
  {
    city: 'Melrose',
    county_fips: 12107,
    county_fips_all: '12107|12001|12019|12007',
    county: 'Putnam',
    county_names_all: 'Putnam|Alachua|Clay|Bradford',
    county_weights:
      '{"12107": 59.73, "12001": 20.37, "12019": 14.2, "12007": 5.7}',
    density: 45.3,
    imprecise: false,
    latitude: 29.72301,
    longitude: -81.99145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32666',
  },
  {
    city: 'Micanopy',
    county_fips: 12001,
    county_fips_all: '12001|12083',
    county: 'Alachua',
    county_names_all: 'Alachua|Marion',
    county_weights: '{"12001": 57.5, "12083": 42.5}',
    density: 16.8,
    imprecise: false,
    latitude: 29.49484,
    longitude: -82.31084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32667',
  },
  {
    city: 'Morriston',
    county_fips: 12075,
    county_fips_all: '12075|12083',
    county: 'Levy',
    county_names_all: 'Levy|Marion',
    county_weights: '{"12075": 81.31, "12083": 18.69}',
    density: 14.7,
    imprecise: false,
    latitude: 29.26327,
    longitude: -82.50321,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32668',
  },
  {
    city: 'Newberry',
    county_fips: 12001,
    county_fips_all: '12001|12041|12075',
    county: 'Alachua',
    county_names_all: 'Alachua|Gilchrist|Levy',
    county_weights: '{"12001": 83.05, "12041": 12.11, "12075": 4.84}',
    density: 69.3,
    imprecise: false,
    latitude: 29.63666,
    longitude: -82.60015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32669',
  },
  {
    city: 'Old Town',
    county_fips: 12029,
    county_fips_all: '12029',
    county: 'Dixie',
    county_names_all: 'Dixie',
    county_weights: '{"12029": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 29.58144,
    longitude: -83.08041,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32680',
  },
  {
    city: 'Orange Lake',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 756.6,
    imprecise: false,
    latitude: 29.42694,
    longitude: -82.21527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32681',
  },
  {
    city: 'Otter Creek',
    county_fips: 12075,
    county_fips_all: '12075',
    county: 'Levy',
    county_names_all: 'Levy',
    county_weights: '{"12075": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 29.29519,
    longitude: -82.76743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32683',
  },
  {
    city: 'Reddick',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 26,
    imprecise: false,
    latitude: 29.36214,
    longitude: -82.26236,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32686',
  },
  {
    city: 'Suwannee',
    county_fips: 12029,
    county_fips_all: '12029',
    county: 'Dixie',
    county_names_all: 'Dixie',
    county_weights: '{"12029": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 29.32519,
    longitude: -83.15995,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32692',
  },
  {
    city: 'Trenton',
    county_fips: 12041,
    county_fips_all: '12041|12075',
    county: 'Gilchrist',
    county_names_all: 'Gilchrist|Levy',
    county_weights: '{"12041": 75.13, "12075": 24.87}',
    density: 24.6,
    imprecise: false,
    latitude: 29.62814,
    longitude: -82.79446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32693',
  },
  {
    city: 'Waldo',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 29.79086,
    longitude: -82.15367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32694',
  },
  {
    city: 'Williston',
    county_fips: 12075,
    county_fips_all: '12075|12083',
    county: 'Levy',
    county_names_all: 'Levy|Marion',
    county_weights: '{"12075": 79.57, "12083": 20.43}',
    density: 42.1,
    imprecise: false,
    latitude: 29.39544,
    longitude: -82.46728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32696',
  },
  {
    city: 'Worthington Springs',
    county_fips: 12125,
    county_fips_all: '12125',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"12125": 100}',
    density: 264.1,
    imprecise: false,
    latitude: 29.92831,
    longitude: -82.42538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32697',
  },
  {
    city: 'Altamonte Springs',
    county_fips: 12117,
    county_fips_all: '12117',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"12117": 100}',
    density: 1685.5,
    imprecise: false,
    latitude: 28.66509,
    longitude: -81.36916,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32701',
  },
  {
    city: 'Altoona',
    county_fips: 12069,
    county_fips_all: '12069|12083',
    county: 'Lake',
    county_names_all: 'Lake|Marion',
    county_weights: '{"12069": 77.12, "12083": 22.88}',
    density: 17.2,
    imprecise: false,
    latitude: 29.04642,
    longitude: -81.6259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32702',
  },
  {
    city: 'Apopka',
    county_fips: 12095,
    county_fips_all: '12095|12117',
    county: 'Orange',
    county_names_all: 'Orange|Seminole',
    county_weights: '{"12095": 90.8, "12117": 9.2}',
    density: 712.7,
    imprecise: false,
    latitude: 28.65579,
    longitude: -81.52139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32703',
  },
  {
    city: 'Casselberry',
    county_fips: 12117,
    county_fips_all: '12117',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"12117": 100}',
    density: 1585.5,
    imprecise: false,
    latitude: 28.66255,
    longitude: -81.31403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32707',
  },
  {
    city: 'Winter Springs',
    county_fips: 12117,
    county_fips_all: '12117',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"12117": 100}',
    density: 1021.9,
    imprecise: false,
    latitude: 28.68751,
    longitude: -81.27086,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32708',
  },
  {
    city: 'Christmas',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 28.49266,
    longitude: -80.98801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32709',
  },
  {
    city: 'Apopka',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 273,
    imprecise: false,
    latitude: 28.72917,
    longitude: -81.54103,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32712',
  },
  {
    city: 'Debary',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 463.3,
    imprecise: false,
    latitude: 28.8816,
    longitude: -81.3238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32713',
  },
  {
    city: 'Altamonte Springs',
    county_fips: 12117,
    county_fips_all: '12117',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"12117": 100}',
    density: 1724.7,
    imprecise: false,
    latitude: 28.66237,
    longitude: -81.4115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32714',
  },
  {
    city: 'Deland',
    county_fips: 12127,
    county_fips_all: '12127|12069',
    county: 'Volusia',
    county_names_all: 'Volusia|Lake',
    county_weights: '{"12127": 55.86, "12069": 44.14}',
    density: 211.2,
    imprecise: false,
    latitude: 29.01775,
    longitude: -81.37802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32720',
  },
  {
    city: 'Deland',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 208.1,
    imprecise: false,
    latitude: 29.0506,
    longitude: -81.23284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32724',
  },
  {
    city: 'Deltona',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 870.8,
    imprecise: false,
    latitude: 28.88368,
    longitude: -81.25061,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51987,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32725',
  },
  {
    city: 'Eustis',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 830.7,
    imprecise: false,
    latitude: 28.8541,
    longitude: -81.68,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32726',
  },
  {
    city: 'Casselberry',
    county_fips: 12117,
    county_fips_all: '12117',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"12117": 100}',
    density: 1907.1,
    imprecise: false,
    latitude: 28.65242,
    longitude: -81.34301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32730',
  },
  {
    city: 'Geneva',
    county_fips: 12117,
    county_fips_all: '12117',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"12117": 100}',
    density: 36.5,
    imprecise: false,
    latitude: 28.74565,
    longitude: -81.10563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32732',
  },
  {
    city: 'Grand Island',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 513.2,
    imprecise: false,
    latitude: 28.89099,
    longitude: -81.73718,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32735',
  },
  {
    city: 'Eustis',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 44.9,
    imprecise: false,
    latitude: 28.89831,
    longitude: -81.49317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32736',
  },
  {
    city: 'Deltona',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 739.6,
    imprecise: false,
    latitude: 28.90755,
    longitude: -81.18862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32738',
  },
  {
    city: 'Lake Helen',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 103.2,
    imprecise: false,
    latitude: 28.98497,
    longitude: -81.21899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32744',
  },
  {
    city: 'Lake Mary',
    county_fips: 12117,
    county_fips_all: '12117',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"12117": 100}',
    density: 855.7,
    imprecise: false,
    latitude: 28.76297,
    longitude: -81.35499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32746',
  },
  {
    city: 'Longwood',
    county_fips: 12117,
    county_fips_all: '12117',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"12117": 100}',
    density: 885.2,
    imprecise: false,
    latitude: 28.7074,
    longitude: -81.34955,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32750',
  },
  {
    city: 'Maitland',
    county_fips: 12095,
    county_fips_all: '12095|12117',
    county: 'Orange',
    county_names_all: 'Orange|Seminole',
    county_weights: '{"12095": 76.68, "12117": 23.32}',
    density: 1215.9,
    imprecise: false,
    latitude: 28.631,
    longitude: -81.36457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32751',
  },
  {
    city: 'Mims',
    county_fips: 12009,
    county_fips_all: '12009|12127',
    county: 'Brevard',
    county_names_all: 'Brevard|Volusia',
    county_weights: '{"12009": 78.46, "12127": 21.54}',
    density: 33.9,
    imprecise: false,
    latitude: 28.68565,
    longitude: -80.9208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32754',
  },
  {
    city: 'Mount Dora',
    county_fips: 12069,
    county_fips_all: '12069|12095',
    county: 'Lake',
    county_names_all: 'Lake|Orange',
    county_weights: '{"12069": 67.86, "12095": 32.14}',
    density: 373.5,
    imprecise: false,
    latitude: 28.77954,
    longitude: -81.637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32757',
  },
  {
    city: 'Oak Hill',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 25.5,
    imprecise: false,
    latitude: 28.84004,
    longitude: -80.9034,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32759',
  },
  {
    city: 'Orange City',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 460.6,
    imprecise: false,
    latitude: 28.94291,
    longitude: -81.30593,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32763',
  },
  {
    city: 'Osteen',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 28.83883,
    longitude: -81.07239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32764',
  },
  {
    city: 'Oviedo',
    county_fips: 12117,
    county_fips_all: '12117',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"12117": 100}',
    density: 637.9,
    imprecise: false,
    latitude: 28.66732,
    longitude: -81.20033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32765',
  },
  {
    city: 'Oviedo',
    county_fips: 12117,
    county_fips_all: '12117',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"12117": 100}',
    density: 142.9,
    imprecise: false,
    latitude: 28.64761,
    longitude: -81.08124,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32766',
  },
  {
    city: 'Paisley',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 23.9,
    imprecise: false,
    latitude: 29.01957,
    longitude: -81.52065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32767',
  },
  {
    city: 'Plymouth',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 0,
    imprecise: false,
    latitude: 28.69577,
    longitude: -81.55795,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32768',
  },
  {
    city: 'Sanford',
    county_fips: 12117,
    county_fips_all: '12117',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"12117": 100}',
    density: 644.7,
    imprecise: false,
    latitude: 28.81496,
    longitude: -81.31751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32771',
  },
  {
    city: 'Sanford',
    county_fips: 12117,
    county_fips_all: '12117',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"12117": 100}',
    density: 476,
    imprecise: false,
    latitude: 28.75264,
    longitude: -81.24659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32773',
  },
  {
    city: 'Scottsmoor',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 0,
    imprecise: false,
    latitude: 28.76704,
    longitude: -80.8767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32775',
  },
  {
    city: 'Sorrento',
    county_fips: 12069,
    county_fips_all: '12069|12095',
    county: 'Lake',
    county_names_all: 'Lake|Orange',
    county_weights: '{"12069": 85.09, "12095": 14.91}',
    density: 102.5,
    imprecise: false,
    latitude: 28.81033,
    longitude: -81.4872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32776',
  },
  {
    city: 'Tavares',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 380.7,
    imprecise: false,
    latitude: 28.77554,
    longitude: -81.72884,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32778',
  },
  {
    city: 'Longwood',
    county_fips: 12117,
    county_fips_all: '12117',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"12117": 100}',
    density: 591.8,
    imprecise: false,
    latitude: 28.71632,
    longitude: -81.41343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32779',
  },
  {
    city: 'Titusville',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 227.1,
    imprecise: false,
    latitude: 28.54672,
    longitude: -80.7841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32780',
  },
  {
    city: 'Umatilla',
    county_fips: 12083,
    county_fips_all: '12083|12069',
    county: 'Marion',
    county_names_all: 'Marion|Lake',
    county_weights: '{"12083": 53.19, "12069": 46.81}',
    density: 41.7,
    imprecise: false,
    latitude: 28.97626,
    longitude: -81.7232,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32784',
  },
  {
    city: 'Winter Park',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1375.2,
    imprecise: false,
    latitude: 28.59977,
    longitude: -81.35235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32789',
  },
  {
    city: 'Winter Park',
    county_fips: 12117,
    county_fips_all: '12117|12095',
    county: 'Seminole',
    county_names_all: 'Seminole|Orange',
    county_weights: '{"12117": 51.71, "12095": 48.29}',
    density: 1688.2,
    imprecise: false,
    latitude: 28.61066,
    longitude: -81.29923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32792',
  },
  {
    city: 'Titusville',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 541.7,
    imprecise: false,
    latitude: 28.62591,
    longitude: -80.84051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32796',
  },
  {
    city: 'Zellwood',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 358.9,
    imprecise: false,
    latitude: 28.72647,
    longitude: -81.58648,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32798',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 2978.2,
    imprecise: false,
    latitude: 28.542,
    longitude: -81.37343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32801',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1256.5,
    imprecise: false,
    latitude: 28.55592,
    longitude: -81.34895,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32803',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1172.2,
    imprecise: false,
    latitude: 28.57688,
    longitude: -81.39748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32804',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1094.5,
    imprecise: false,
    latitude: 28.52981,
    longitude: -81.40614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32805',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1476.6,
    imprecise: false,
    latitude: 28.5123,
    longitude: -81.36031,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32806',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1583.6,
    imprecise: false,
    latitude: 28.55245,
    longitude: -81.30165,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32807',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1957.2,
    imprecise: false,
    latitude: 28.57932,
    longitude: -81.44342,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32808',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1086.9,
    imprecise: false,
    latitude: 28.46301,
    longitude: -81.38428,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32809',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095|12117',
    county: 'Orange',
    county_names_all: 'Orange|Seminole',
    county_weights: '{"12095": 99.89, "12117": 0.11}',
    density: 1555.2,
    imprecise: false,
    latitude: 28.62113,
    longitude: -81.42863,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32810',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1927.9,
    imprecise: false,
    latitude: 28.51624,
    longitude: -81.44516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32811',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1577.7,
    imprecise: false,
    latitude: 28.4848,
    longitude: -81.32767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32812',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 2994.7,
    imprecise: false,
    latitude: 28.57002,
    longitude: -81.32663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32814',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1218.3,
    imprecise: false,
    latitude: 28.59002,
    longitude: -81.2445,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32817',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 2050.9,
    imprecise: false,
    latitude: 28.58518,
    longitude: -81.48716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32818',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 564.5,
    imprecise: false,
    latitude: 28.45565,
    longitude: -81.472,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32819',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 278.6,
    imprecise: false,
    latitude: 28.58493,
    longitude: -81.12127,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32820',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 619.2,
    imprecise: false,
    latitude: 28.38095,
    longitude: -81.47719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32821',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1904.8,
    imprecise: false,
    latitude: 28.49001,
    longitude: -81.29056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 67081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32822',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 672.8,
    imprecise: false,
    latitude: 28.38991,
    longitude: -81.34471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32824',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1338.1,
    imprecise: false,
    latitude: 28.53681,
    longitude: -81.24243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32825',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1525.7,
    imprecise: false,
    latitude: 28.58543,
    longitude: -81.18263,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32826',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 335.7,
    imprecise: false,
    latitude: 28.41399,
    longitude: -81.29032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32827',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1282.6,
    imprecise: false,
    latitude: 28.53052,
    longitude: -81.17022,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32828',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 414.9,
    imprecise: false,
    latitude: 28.47639,
    longitude: -81.22478,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32829',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 28.38643,
    longitude: -81.56732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32830',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 90.5,
    imprecise: false,
    latitude: 28.47439,
    longitude: -81.14729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32831',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 286.6,
    imprecise: false,
    latitude: 28.39843,
    longitude: -81.18407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32832',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 128.9,
    imprecise: false,
    latitude: 28.4948,
    longitude: -81.081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32833',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 2022.5,
    imprecise: false,
    latitude: 28.52182,
    longitude: -81.48473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32835',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 844.7,
    imprecise: false,
    latitude: 28.41734,
    longitude: -81.51536,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32836',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1136.9,
    imprecise: false,
    latitude: 28.38074,
    longitude: -81.41998,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32837',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 2767.2,
    imprecise: false,
    latitude: 28.48833,
    longitude: -81.40689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32839',
  },
  {
    city: 'Melbourne',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 925.7,
    imprecise: false,
    latitude: 28.07887,
    longitude: -80.62268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32901',
  },
  {
    city: 'Indialantic',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 1474.7,
    imprecise: false,
    latitude: 28.10818,
    longitude: -80.58709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32903',
  },
  {
    city: 'Melbourne',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 66.2,
    imprecise: false,
    latitude: 28.01,
    longitude: -80.79104,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32904',
  },
  {
    city: 'Palm Bay',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 986.6,
    imprecise: false,
    latitude: 28.03136,
    longitude: -80.59997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32905',
  },
  {
    city: 'Palm Bay',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 1070.2,
    imprecise: false,
    latitude: 28.01565,
    longitude: -80.68187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32907',
  },
  {
    city: 'Palm Bay',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 332.4,
    imprecise: false,
    latitude: 27.95622,
    longitude: -80.69827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32908',
  },
  {
    city: 'Palm Bay',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 279.9,
    imprecise: false,
    latitude: 27.90435,
    longitude: -80.65515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32909',
  },
  {
    city: 'Cape Canaveral',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 155.9,
    imprecise: false,
    latitude: 28.44603,
    longitude: -80.58503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32920',
  },
  {
    city: 'Cocoa',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 1042.7,
    imprecise: false,
    latitude: 28.37252,
    longitude: -80.74279,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32922',
  },
  {
    city: 'Patrick Air Force Base',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 205,
    imprecise: false,
    latitude: 28.24272,
    longitude: -80.62287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32925',
  },
  {
    city: 'Cocoa',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 184.2,
    imprecise: false,
    latitude: 28.39051,
    longitude: -80.81773,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32926',
  },
  {
    city: 'Cocoa',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 439.9,
    imprecise: false,
    latitude: 28.46372,
    longitude: -80.80709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32927',
  },
  {
    city: 'Cocoa Beach',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 1053.4,
    imprecise: false,
    latitude: 28.32193,
    longitude: -80.62731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32931',
  },
  {
    city: 'Melbourne',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 312.7,
    imprecise: false,
    latitude: 28.13532,
    longitude: -80.71153,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32934',
  },
  {
    city: 'Melbourne',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 1232.9,
    imprecise: false,
    latitude: 28.1444,
    longitude: -80.64832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32935',
  },
  {
    city: 'Satellite Beach',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 1581.4,
    imprecise: false,
    latitude: 28.17464,
    longitude: -80.61146,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32937',
  },
  {
    city: 'Melbourne',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 348.6,
    imprecise: false,
    latitude: 28.21813,
    longitude: -80.7543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32940',
  },
  {
    city: 'Fellsmere',
    county_fips: 12061,
    county_fips_all: '12061|12009',
    county: 'Indian River',
    county_names_all: 'Indian River|Brevard',
    county_weights: '{"12061": 78.68, "12009": 21.32}',
    density: 24.1,
    imprecise: false,
    latitude: 27.75901,
    longitude: -80.61826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32948',
  },
  {
    city: 'Grant',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 83.5,
    imprecise: false,
    latitude: 27.92005,
    longitude: -80.55203,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32949',
  },
  {
    city: 'Malabar',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 85.8,
    imprecise: false,
    latitude: 27.9757,
    longitude: -80.57839,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32950',
  },
  {
    city: 'Melbourne Beach',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 536.2,
    imprecise: false,
    latitude: 27.9595,
    longitude: -80.51498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32951',
  },
  {
    city: 'Merritt Island',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 678.2,
    imprecise: false,
    latitude: 28.31749,
    longitude: -80.66832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32952',
  },
  {
    city: 'Merritt Island',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 240.5,
    imprecise: false,
    latitude: 28.45613,
    longitude: -80.69916,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32953',
  },
  {
    city: 'Rockledge',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 311.3,
    imprecise: false,
    latitude: 28.29414,
    longitude: -80.77528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32955',
  },
  {
    city: 'Sebastian',
    county_fips: 12061,
    county_fips_all: '12061',
    county: 'Indian River',
    county_names_all: 'Indian River',
    county_weights: '{"12061": 100}',
    density: 416.2,
    imprecise: false,
    latitude: 27.79364,
    longitude: -80.49135,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32958',
  },
  {
    city: 'Sharpes',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 244.1,
    imprecise: false,
    latitude: 28.44513,
    longitude: -80.7637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32959',
  },
  {
    city: 'Vero Beach',
    county_fips: 12061,
    county_fips_all: '12061',
    county: 'Indian River',
    county_names_all: 'Indian River',
    county_weights: '{"12061": 100}',
    density: 882.3,
    imprecise: false,
    latitude: 27.64069,
    longitude: -80.40366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32960',
  },
  {
    city: 'Vero Beach',
    county_fips: 12061,
    county_fips_all: '12061|12111',
    county: 'Indian River',
    county_names_all: 'Indian River|St. Lucie',
    county_weights: '{"12061": 99.84, "12111": 0.16}',
    density: 788.6,
    imprecise: false,
    latitude: 27.5865,
    longitude: -80.38414,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32962',
  },
  {
    city: 'Vero Beach',
    county_fips: 12061,
    county_fips_all: '12061',
    county: 'Indian River',
    county_names_all: 'Indian River',
    county_weights: '{"12061": 100}',
    density: 332.7,
    imprecise: false,
    latitude: 27.71951,
    longitude: -80.39646,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32963',
  },
  {
    city: 'Vero Beach',
    county_fips: 12061,
    county_fips_all: '12061',
    county: 'Indian River',
    county_names_all: 'Indian River',
    county_weights: '{"12061": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 27.68716,
    longitude: -80.70693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32966',
  },
  {
    city: 'Vero Beach',
    county_fips: 12061,
    county_fips_all: '12061',
    county: 'Indian River',
    county_names_all: 'Indian River',
    county_weights: '{"12061": 100}',
    density: 263.2,
    imprecise: false,
    latitude: 27.71359,
    longitude: -80.46015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32967',
  },
  {
    city: 'Vero Beach',
    county_fips: 12061,
    county_fips_all: '12061|12111',
    county: 'Indian River',
    county_names_all: 'Indian River|St. Lucie',
    county_weights: '{"12061": 99.74, "12111": 0.26}',
    density: 141.3,
    imprecise: false,
    latitude: 27.58808,
    longitude: -80.50993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32968',
  },
  {
    city: 'Wabasso',
    county_fips: 12061,
    county_fips_all: '12061',
    county: 'Indian River',
    county_names_all: 'Indian River',
    county_weights: '{"12061": 100}',
    density: 68,
    imprecise: false,
    latitude: 27.75402,
    longitude: -80.45136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32970',
  },
  {
    city: 'Sebastian',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 145.5,
    imprecise: false,
    latitude: 27.86198,
    longitude: -80.53721,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32976',
  },
  {
    city: 'Long Key',
    county_fips: 12087,
    county_fips_all: '12087',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"12087": 100}',
    density: 49.4,
    imprecise: false,
    latitude: 24.82041,
    longitude: -80.80992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33001',
  },
  {
    city: 'Dania',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 977,
    imprecise: false,
    latitude: 26.05939,
    longitude: -80.13637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33004',
  },
  {
    city: 'Hallandale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 3512.6,
    imprecise: false,
    latitude: 25.98531,
    longitude: -80.1466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33009',
  },
  {
    city: 'Hialeah',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 3725.8,
    imprecise: false,
    latitude: 25.83309,
    longitude: -80.27902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33010',
  },
  {
    city: 'Hialeah',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 4669.1,
    imprecise: false,
    latitude: 25.86583,
    longitude: -80.30247,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33012',
  },
  {
    city: 'Hialeah',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 3129.3,
    imprecise: false,
    latitude: 25.86209,
    longitude: -80.27032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33013',
  },
  {
    city: 'Hialeah',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2478.4,
    imprecise: false,
    latitude: 25.90332,
    longitude: -80.30173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33014',
  },
  {
    city: 'Hialeah',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 4519,
    imprecise: false,
    latitude: 25.94116,
    longitude: -80.31761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33015',
  },
  {
    city: 'Hialeah',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 4203.1,
    imprecise: false,
    latitude: 25.89361,
    longitude: -80.33186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33016',
  },
  {
    city: 'Hialeah',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 796.2,
    imprecise: false,
    latitude: 25.92,
    longitude: -80.39274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33018',
  },
  {
    city: 'Hollywood',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1473.5,
    imprecise: false,
    latitude: 26.02346,
    longitude: -80.1236,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33019',
  },
  {
    city: 'Hollywood',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2972.1,
    imprecise: false,
    latitude: 26.01911,
    longitude: -80.15251,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33020',
  },
  {
    city: 'Hollywood',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2118,
    imprecise: false,
    latitude: 26.02277,
    longitude: -80.18742,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33021',
  },
  {
    city: 'Hollywood',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 0,
    imprecise: false,
    latitude: 26.01385,
    longitude: -80.14407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33022',
  },
  {
    city: 'Hollywood',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 3190.4,
    imprecise: false,
    latitude: 25.98812,
    longitude: -80.21263,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 72344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33023',
  },
  {
    city: 'Hollywood',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2548.4,
    imprecise: false,
    latitude: 26.02501,
    longitude: -80.24475,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 76585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33024',
  },
  {
    city: 'Hollywood',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2816.5,
    imprecise: false,
    latitude: 25.98737,
    longitude: -80.28134,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 76967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33025',
  },
  {
    city: 'Hollywood',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2613.5,
    imprecise: false,
    latitude: 26.02575,
    longitude: -80.29625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33026',
  },
  {
    city: 'Hollywood',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1881.8,
    imprecise: false,
    latitude: 25.98245,
    longitude: -80.34359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33027',
  },
  {
    city: 'Pembroke Pines',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1907.9,
    imprecise: false,
    latitude: 26.01852,
    longitude: -80.34488,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33028',
  },
  {
    city: 'Hollywood',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1015.1,
    imprecise: false,
    latitude: 25.99184,
    longitude: -80.40794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33029',
  },
  {
    city: 'Homestead',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 824.4,
    imprecise: false,
    latitude: 25.4848,
    longitude: -80.50857,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33030',
  },
  {
    city: 'Homestead',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 127.3,
    imprecise: false,
    latitude: 25.52709,
    longitude: -80.50312,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33031',
  },
  {
    city: 'Homestead',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 1378.7,
    imprecise: false,
    latitude: 25.52963,
    longitude: -80.39234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33032',
  },
  {
    city: 'Homestead',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 1235.6,
    imprecise: false,
    latitude: 25.47858,
    longitude: -80.4057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33033',
  },
  {
    city: 'Homestead',
    county_fips: 12086,
    county_fips_all: '12086|12087',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade|Monroe',
    county_weights: '{"12086": 52.45, "12087": 47.55}',
    density: 7.8,
    imprecise: false,
    latitude: 25.4195,
    longitude: -80.86342,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33034',
  },
  {
    city: 'Homestead',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 225.3,
    imprecise: false,
    latitude: 25.4216,
    longitude: -80.4036,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33035',
  },
  {
    city: 'Islamorada',
    county_fips: 12087,
    county_fips_all: '12087',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"12087": 100}',
    density: 249.5,
    imprecise: false,
    latitude: 24.9227,
    longitude: -80.6385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33036',
  },
  {
    city: 'Key Largo',
    county_fips: 12087,
    county_fips_all: '12087',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"12087": 100}',
    density: 173.3,
    imprecise: false,
    latitude: 25.19779,
    longitude: -80.38634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33037',
  },
  {
    city: 'Key West',
    county_fips: 12087,
    county_fips_all: '12087',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"12087": 100}',
    density: 771.8,
    imprecise: false,
    latitude: 24.5855,
    longitude: -81.74904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33040',
  },
  {
    city: 'Summerland Key',
    county_fips: 12087,
    county_fips_all: '12087',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"12087": 100}',
    density: 90.1,
    imprecise: false,
    latitude: 24.67481,
    longitude: -81.50717,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33042',
  },
  {
    city: 'Big Pine Key',
    county_fips: 12087,
    county_fips_all: '12087',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"12087": 100}',
    density: 99.7,
    imprecise: false,
    latitude: 24.70563,
    longitude: -81.3587,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33043',
  },
  {
    city: 'Marathon',
    county_fips: 12087,
    county_fips_all: '12087',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"12087": 100}',
    density: 449.2,
    imprecise: false,
    latitude: 24.72843,
    longitude: -81.03405,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33050',
  },
  {
    city: 'Key Colony Beach',
    county_fips: 12087,
    county_fips_all: '12087',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"12087": 100}',
    density: 449.8,
    imprecise: false,
    latitude: 24.72328,
    longitude: -81.02155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33051',
  },
  {
    city: 'Opa Locka',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 1427.7,
    imprecise: false,
    latitude: 25.90775,
    longitude: -80.25753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33054',
  },
  {
    city: 'Opa Locka',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2421.4,
    imprecise: false,
    latitude: 25.94812,
    longitude: -80.27809,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33055',
  },
  {
    city: 'Miami Gardens',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2387.2,
    imprecise: false,
    latitude: 25.94922,
    longitude: -80.24562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33056',
  },
  {
    city: 'Pompano Beach',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2067.5,
    imprecise: false,
    latitude: 26.23513,
    longitude: -80.12084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33060',
  },
  {
    city: 'Pompano Beach',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2469,
    imprecise: false,
    latitude: 26.24101,
    longitude: -80.09399,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33062',
  },
  {
    city: 'Pompano Beach',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2610.3,
    imprecise: false,
    latitude: 26.25138,
    longitude: -80.21014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33063',
  },
  {
    city: 'Pompano Beach',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2442.1,
    imprecise: false,
    latitude: 26.27806,
    longitude: -80.11524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33064',
  },
  {
    city: 'Coral Springs',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2651.5,
    imprecise: false,
    latitude: 26.27318,
    longitude: -80.26029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33065',
  },
  {
    city: 'Pompano Beach',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2127.1,
    imprecise: false,
    latitude: 26.25347,
    longitude: -80.17753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33066',
  },
  {
    city: 'Pompano Beach',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1062,
    imprecise: false,
    latitude: 26.307,
    longitude: -80.2257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33067',
  },
  {
    city: 'Pompano Beach',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 3265.5,
    imprecise: false,
    latitude: 26.21644,
    longitude: -80.21535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33068',
  },
  {
    city: 'Pompano Beach',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1199.9,
    imprecise: false,
    latitude: 26.23565,
    longitude: -80.15808,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33069',
  },
  {
    city: 'Tavernier',
    county_fips: 12087,
    county_fips_all: '12087',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"12087": 100}',
    density: 526.3,
    imprecise: false,
    latitude: 25.00873,
    longitude: -80.52501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33070',
  },
  {
    city: 'Coral Springs',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2177.2,
    imprecise: false,
    latitude: 26.24395,
    longitude: -80.26627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33071',
  },
  {
    city: 'Pompano Beach',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1604.6,
    imprecise: false,
    latitude: 26.29818,
    longitude: -80.1827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33073',
  },
  {
    city: 'Pompano Beach',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1601.9,
    imprecise: false,
    latitude: 26.31788,
    longitude: -80.27431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33076',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 0,
    imprecise: false,
    latitude: 25.77976,
    longitude: -80.19877,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33101',
  },
  {
    city: 'Miami Beach',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 1324.9,
    imprecise: false,
    latitude: 25.7616,
    longitude: -80.14197,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33109',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 271.9,
    imprecise: false,
    latitude: 25.80523,
    longitude: -80.31706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33122',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 5606.8,
    imprecise: false,
    latitude: 25.7839,
    longitude: -80.23738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33125',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 3390.5,
    imprecise: false,
    latitude: 25.78061,
    longitude: -80.30054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33126',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 3139.5,
    imprecise: false,
    latitude: 25.81307,
    longitude: -80.20553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33127',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 8515.5,
    imprecise: false,
    latitude: 25.77661,
    longitude: -80.20407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33128',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 4106.3,
    imprecise: false,
    latitude: 25.7527,
    longitude: -80.20046,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33129',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 12342.6,
    imprecise: false,
    latitude: 25.76805,
    longitude: -80.20291,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33130',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 17793.2,
    imprecise: false,
    latitude: 25.76417,
    longitude: -80.18459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33131',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 5174.5,
    imprecise: false,
    latitude: 25.77719,
    longitude: -80.17395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33132',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 3412.7,
    imprecise: false,
    latitude: 25.72983,
    longitude: -80.24327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33133',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2819.4,
    imprecise: false,
    latitude: 25.75338,
    longitude: -80.2712,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33134',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 6561.7,
    imprecise: false,
    latitude: 25.76657,
    longitude: -80.23495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33135',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 4556.2,
    imprecise: false,
    latitude: 25.78703,
    longitude: -80.20444,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33136',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 5617.4,
    imprecise: false,
    latitude: 25.81538,
    longitude: -80.17798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33137',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2656.1,
    imprecise: false,
    latitude: 25.85388,
    longitude: -80.17846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33138',
  },
  {
    city: 'Miami Beach',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 4683.7,
    imprecise: false,
    latitude: 25.78523,
    longitude: -80.15085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33139',
  },
  {
    city: 'Miami Beach',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2544.2,
    imprecise: false,
    latitude: 25.81606,
    longitude: -80.13895,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33140',
  },
  {
    city: 'Miami Beach',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 6090.2,
    imprecise: false,
    latitude: 25.85116,
    longitude: -80.14147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33141',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2085.5,
    imprecise: false,
    latitude: 25.80665,
    longitude: -80.25517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33142',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 1677.4,
    imprecise: false,
    latitude: 25.70255,
    longitude: -80.29792,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33143',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 3237.5,
    imprecise: false,
    latitude: 25.76335,
    longitude: -80.31228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33144',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 4518.7,
    imprecise: false,
    latitude: 25.75322,
    longitude: -80.23461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33145',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2345.4,
    imprecise: false,
    latitude: 25.72059,
    longitude: -80.27274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33146',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2698.2,
    imprecise: false,
    latitude: 25.85104,
    longitude: -80.23861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33147',
  },
  {
    city: 'Key Biscayne',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 1212.8,
    imprecise: false,
    latitude: 25.72479,
    longitude: -80.16118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33149',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 3443.8,
    imprecise: false,
    latitude: 25.85196,
    longitude: -80.20702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33150',
  },
  {
    city: 'Miami Beach',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2902.2,
    imprecise: false,
    latitude: 25.88609,
    longitude: -80.13332,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33154',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2303.7,
    imprecise: false,
    latitude: 25.73672,
    longitude: -80.31117,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33155',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 936.1,
    imprecise: false,
    latitude: 25.66779,
    longitude: -80.29728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33156',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 1824.1,
    imprecise: false,
    latitude: 25.60671,
    longitude: -80.34314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 70596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33157',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 826.2,
    imprecise: false,
    latitude: 25.63744,
    longitude: -80.30945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33158',
  },
  {
    city: 'North Miami Beach',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 3806.7,
    imprecise: false,
    latitude: 25.93234,
    longitude: -80.13583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33160',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 3860.1,
    imprecise: false,
    latitude: 25.89357,
    longitude: -80.18285,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33161',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 3390.6,
    imprecise: false,
    latitude: 25.92845,
    longitude: -80.17844,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33162',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2511.3,
    imprecise: false,
    latitude: 25.73437,
    longitude: -80.35862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33165',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 1376.2,
    imprecise: false,
    latitude: 25.8253,
    longitude: -80.31049,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33166',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2174,
    imprecise: false,
    latitude: 25.8848,
    longitude: -80.23631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33167',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2552.4,
    imprecise: false,
    latitude: 25.89318,
    longitude: -80.2093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33168',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2467.9,
    imprecise: false,
    latitude: 25.94298,
    longitude: -80.2147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33169',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 519.5,
    imprecise: false,
    latitude: 25.55827,
    longitude: -80.45313,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33170',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2359.2,
    imprecise: false,
    latitude: 25.78655,
    longitude: -80.3623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33172',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2241,
    imprecise: false,
    latitude: 25.70163,
    longitude: -80.35765,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33173',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 4435.3,
    imprecise: false,
    latitude: 25.76199,
    longitude: -80.36029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33174',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2357.4,
    imprecise: false,
    latitude: 25.73435,
    longitude: -80.40621,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33175',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 1659.1,
    imprecise: false,
    latitude: 25.65876,
    longitude: -80.35919,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33176',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 1816.2,
    imprecise: false,
    latitude: 25.59703,
    longitude: -80.40458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33177',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 428.4,
    imprecise: false,
    latitude: 25.83578,
    longitude: -80.4213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 67789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33178',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 3957.6,
    imprecise: false,
    latitude: 25.95821,
    longitude: -80.17981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33179',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 4042,
    imprecise: false,
    latitude: 25.96145,
    longitude: -80.1415,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33180',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2644,
    imprecise: false,
    latitude: 25.89717,
    longitude: -80.1531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33181',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 1388,
    imprecise: false,
    latitude: 25.78252,
    longitude: -80.40182,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33182',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2347.6,
    imprecise: false,
    latitude: 25.70047,
    longitude: -80.40578,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33183',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 3099.5,
    imprecise: false,
    latitude: 25.7597,
    longitude: -80.4066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33184',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 1599.4,
    imprecise: false,
    latitude: 25.73035,
    longitude: -80.45448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33185',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2164.6,
    imprecise: false,
    latitude: 25.65565,
    longitude: -80.41062,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33186',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 62.1,
    imprecise: false,
    latitude: 25.54889,
    longitude: -80.57638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33187',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 1982.4,
    imprecise: false,
    latitude: 25.57314,
    longitude: -80.33929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33189',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 3457.6,
    imprecise: false,
    latitude: 25.55734,
    longitude: -80.34897,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33190',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 2425.1,
    imprecise: false,
    latitude: 25.70175,
    longitude: -80.46672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33193',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 27.3,
    imprecise: false,
    latitude: 25.7163,
    longitude: -80.62799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33194',
  },
  {
    city: 'Miami',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 404.4,
    imprecise: false,
    latitude: 25.64505,
    longitude: -80.55524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33196',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 3021,
    imprecise: false,
    latitude: 26.12128,
    longitude: -80.12745,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33301',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2267.9,
    imprecise: false,
    latitude: 26.13845,
    longitude: -80.12166,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33304',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2328,
    imprecise: false,
    latitude: 26.15375,
    longitude: -80.123,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33305',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1347.4,
    imprecise: false,
    latitude: 26.16548,
    longitude: -80.11404,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33306',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2342.2,
    imprecise: false,
    latitude: 26.18952,
    longitude: -80.10859,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33308',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1489.2,
    imprecise: false,
    latitude: 26.18793,
    longitude: -80.17385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33309',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2788.4,
    imprecise: false,
    latitude: 26.14412,
    longitude: -80.17319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 74898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33311',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1839.8,
    imprecise: false,
    latitude: 26.08835,
    longitude: -80.18166,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33312',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 3873.4,
    imprecise: false,
    latitude: 26.15069,
    longitude: -80.22634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33313',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1370,
    imprecise: false,
    latitude: 26.06822,
    longitude: -80.22391,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33314',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 996.6,
    imprecise: false,
    latitude: 26.08703,
    longitude: -80.15297,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33315',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1178.4,
    imprecise: false,
    latitude: 26.09913,
    longitude: -80.12398,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33316',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1533.2,
    imprecise: false,
    latitude: 26.11268,
    longitude: -80.22607,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33317',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 3092.5,
    imprecise: false,
    latitude: 26.1826,
    longitude: -80.22641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33319',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2403.1,
    imprecise: false,
    latitude: 26.2121,
    longitude: -80.2697,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33321',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2882.4,
    imprecise: false,
    latitude: 26.14997,
    longitude: -80.27429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33322',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1212.6,
    imprecise: false,
    latitude: 26.14988,
    longitude: -80.32222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33323',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2141.1,
    imprecise: false,
    latitude: 26.11205,
    longitude: -80.27469,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33324',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1326.7,
    imprecise: false,
    latitude: 26.11032,
    longitude: -80.32261,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33325',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1810.6,
    imprecise: false,
    latitude: 26.11033,
    longitude: -80.37403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33326',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 60.7,
    imprecise: false,
    latitude: 26.24429,
    longitude: -80.39267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33327',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1218.2,
    imprecise: false,
    latitude: 26.06673,
    longitude: -80.27301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33328',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 477.3,
    imprecise: false,
    latitude: 26.06034,
    longitude: -80.32333,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33330',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 816.9,
    imprecise: false,
    latitude: 26.0587,
    longitude: -80.36989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33331',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 122.8,
    imprecise: false,
    latitude: 26.03825,
    longitude: -80.44352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33332',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2505.6,
    imprecise: false,
    latitude: 26.18316,
    longitude: -80.13456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33334',
  },
  {
    city: 'Fort Lauderdale',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2531,
    imprecise: false,
    latitude: 26.17938,
    longitude: -80.27463,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33351',
  },
  {
    city: 'Plantation',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 0,
    imprecise: false,
    latitude: 26.11715,
    longitude: -80.25409,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33388',
  },
  {
    city: 'West Palm Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 2563.5,
    imprecise: false,
    latitude: 26.71805,
    longitude: -80.0685,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33401',
  },
  {
    city: 'West Palm Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1677.6,
    imprecise: false,
    latitude: 26.8032,
    longitude: -80.07562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33403',
  },
  {
    city: 'West Palm Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1635.8,
    imprecise: false,
    latitude: 26.78248,
    longitude: -80.06567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33404',
  },
  {
    city: 'West Palm Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1693,
    imprecise: false,
    latitude: 26.66774,
    longitude: -80.0584,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33405',
  },
  {
    city: 'West Palm Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1197,
    imprecise: false,
    latitude: 26.66503,
    longitude: -80.09093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33406',
  },
  {
    city: 'West Palm Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1364.7,
    imprecise: false,
    latitude: 26.75841,
    longitude: -80.09195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33407',
  },
  {
    city: 'North Palm Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1068.1,
    imprecise: false,
    latitude: 26.84115,
    longitude: -80.05677,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33408',
  },
  {
    city: 'West Palm Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 2068.2,
    imprecise: false,
    latitude: 26.7161,
    longitude: -80.0965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33409',
  },
  {
    city: 'Palm Beach Gardens',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1248.3,
    imprecise: false,
    latitude: 26.84629,
    longitude: -80.08823,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33410',
  },
  {
    city: 'West Palm Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 851.5,
    imprecise: false,
    latitude: 26.71517,
    longitude: -80.20305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 76863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33411',
  },
  {
    city: 'West Palm Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 103.2,
    imprecise: false,
    latitude: 26.80561,
    longitude: -80.21557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33412',
  },
  {
    city: 'West Palm Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1000,
    imprecise: false,
    latitude: 26.66397,
    longitude: -80.1553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33413',
  },
  {
    city: 'Wellington',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 819.8,
    imprecise: false,
    latitude: 26.64829,
    longitude: -80.24943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33414',
  },
  {
    city: 'West Palm Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 2883.2,
    imprecise: false,
    latitude: 26.66002,
    longitude: -80.12742,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33415',
  },
  {
    city: 'West Palm Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 2224.1,
    imprecise: false,
    latitude: 26.71994,
    longitude: -80.12495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33417',
  },
  {
    city: 'Palm Beach Gardens',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 367.8,
    imprecise: false,
    latitude: 26.86077,
    longitude: -80.16641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33418',
  },
  {
    city: 'Boynton Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1524,
    imprecise: false,
    latitude: 26.53359,
    longitude: -80.08295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33426',
  },
  {
    city: 'Boca Raton',
    county_fips: 12099,
    county_fips_all: '12099|12011',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach|Broward',
    county_weights: '{"12099": 99.86, "12011": 0.14}',
    density: 1594.5,
    imprecise: false,
    latitude: 26.35054,
    longitude: -80.22792,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33428',
  },
  {
    city: 'Belle Glade',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 31.9,
    imprecise: false,
    latitude: 26.61415,
    longitude: -80.57952,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33430',
  },
  {
    city: 'Boca Raton',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1140.3,
    imprecise: false,
    latitude: 26.37996,
    longitude: -80.1028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33431',
  },
  {
    city: 'Boca Raton',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1817,
    imprecise: false,
    latitude: 26.34546,
    longitude: -80.0838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33432',
  },
  {
    city: 'Boca Raton',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1920.8,
    imprecise: false,
    latitude: 26.34706,
    longitude: -80.15919,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33433',
  },
  {
    city: 'Boca Raton',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1212.2,
    imprecise: false,
    latitude: 26.38139,
    longitude: -80.16913,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33434',
  },
  {
    city: 'Boynton Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 2241.6,
    imprecise: false,
    latitude: 26.52565,
    longitude: -80.06297,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33435',
  },
  {
    city: 'Boynton Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1600,
    imprecise: false,
    latitude: 26.52423,
    longitude: -80.10758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33436',
  },
  {
    city: 'Boynton Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1336.8,
    imprecise: false,
    latitude: 26.51164,
    longitude: -80.14917,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33437',
  },
  {
    city: 'Canal Point',
    county_fips: 12085,
    county_fips_all: '12085|12099',
    county: 'Martin',
    county_names_all: 'Martin|Palm Beach',
    county_weights: '{"12085": 64.74, "12099": 35.26}',
    density: 2.5,
    imprecise: false,
    latitude: 26.95443,
    longitude: -80.56524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33438',
  },
  {
    city: 'Clewiston',
    county_fips: 12051,
    county_fips_all: '12051|12099',
    county: 'Hendry',
    county_names_all: 'Hendry|Palm Beach',
    county_weights: '{"12051": 95.37, "12099": 4.63}',
    density: 11.1,
    imprecise: false,
    latitude: 26.54065,
    longitude: -81.04325,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33440',
  },
  {
    city: 'Deerfield Beach',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 2428.6,
    imprecise: false,
    latitude: 26.31096,
    longitude: -80.09885,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33441',
  },
  {
    city: 'Deerfield Beach',
    county_fips: 12011,
    county_fips_all: '12011',
    county: 'Broward',
    county_names_all: 'Broward',
    county_weights: '{"12011": 100}',
    density: 1763.3,
    imprecise: false,
    latitude: 26.31012,
    longitude: -80.14503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33442',
  },
  {
    city: 'Delray Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1754.7,
    imprecise: false,
    latitude: 26.45781,
    longitude: -80.08002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33444',
  },
  {
    city: 'Delray Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1582.4,
    imprecise: false,
    latitude: 26.4548,
    longitude: -80.1063,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33445',
  },
  {
    city: 'Delray Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 585,
    imprecise: false,
    latitude: 26.45444,
    longitude: -80.18353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33446',
  },
  {
    city: 'Lake Worth',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 207.8,
    imprecise: false,
    latitude: 26.59272,
    longitude: -80.2339,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33449',
  },
  {
    city: 'Hobe Sound',
    county_fips: 12085,
    county_fips_all: '12085',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"12085": 100}',
    density: 136.6,
    imprecise: false,
    latitude: 27.05748,
    longitude: -80.1703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33455',
  },
  {
    city: 'Jupiter',
    county_fips: 12099,
    county_fips_all: '12099|12085',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach|Martin',
    county_weights: '{"12099": 80.72, "12085": 19.28}',
    density: 1052.9,
    imprecise: false,
    latitude: 26.93477,
    longitude: -80.12906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33458',
  },
  {
    city: 'Lake Worth Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 3084.1,
    imprecise: false,
    latitude: 26.61872,
    longitude: -80.05527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33460',
  },
  {
    city: 'Lake Worth',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 2684.3,
    imprecise: false,
    latitude: 26.61936,
    longitude: -80.09048,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33461',
  },
  {
    city: 'Lake Worth',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1505.8,
    imprecise: false,
    latitude: 26.58027,
    longitude: -80.07337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33462',
  },
  {
    city: 'Lake Worth',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 2345.5,
    imprecise: false,
    latitude: 26.59508,
    longitude: -80.12968,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33463',
  },
  {
    city: 'Lake Worth',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1205.1,
    imprecise: false,
    latitude: 26.59472,
    longitude: -80.17567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33467',
  },
  {
    city: 'Jupiter',
    county_fips: 12085,
    county_fips_all: '12085|12099',
    county: 'Martin',
    county_names_all: 'Martin|Palm Beach',
    county_weights: '{"12085": 69.2, "12099": 30.8}',
    density: 524.3,
    imprecise: false,
    latitude: 26.98275,
    longitude: -80.1092,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33469',
  },
  {
    city: 'Loxahatchee',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 67,
    imprecise: false,
    latitude: 26.7832,
    longitude: -80.38063,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33470',
  },
  {
    city: 'Moore Haven',
    county_fips: 12043,
    county_fips_all: '12043',
    county: 'Glades',
    county_names_all: 'Glades',
    county_weights: '{"12043": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 26.9105,
    longitude: -81.19754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33471',
  },
  {
    city: 'Boynton Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 514.4,
    imprecise: false,
    latitude: 26.53974,
    longitude: -80.18903,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33472',
  },
  {
    city: 'Boynton Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 641.7,
    imprecise: false,
    latitude: 26.50328,
    longitude: -80.19225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33473',
  },
  {
    city: 'Pahokee',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 129,
    imprecise: false,
    latitude: 26.80109,
    longitude: -80.65305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33476',
  },
  {
    city: 'Jupiter',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 804.2,
    imprecise: false,
    latitude: 26.91401,
    longitude: -80.0799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33477',
  },
  {
    city: 'Jupiter',
    county_fips: 12099,
    county_fips_all: '12099|12085',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach|Martin',
    county_weights: '{"12099": 80.05, "12085": 19.95}',
    density: 88.1,
    imprecise: false,
    latitude: 26.93788,
    longitude: -80.26298,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33478',
  },
  {
    city: 'Palm Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1075.1,
    imprecise: false,
    latitude: 26.69796,
    longitude: -80.04075,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33480',
  },
  {
    city: 'Delray Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1282.4,
    imprecise: false,
    latitude: 26.46157,
    longitude: -80.0638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33483',
  },
  {
    city: 'Delray Beach',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1680.3,
    imprecise: false,
    latitude: 26.45432,
    longitude: -80.13434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33484',
  },
  {
    city: 'Boca Raton',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1676.3,
    imprecise: false,
    latitude: 26.34729,
    longitude: -80.11449,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33486',
  },
  {
    city: 'Boca Raton',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 1192.8,
    imprecise: false,
    latitude: 26.40991,
    longitude: -80.09169,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33487',
  },
  {
    city: 'South Bay',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 26.47559,
    longitude: -80.72306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33493',
  },
  {
    city: 'Boca Raton',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 972.7,
    imprecise: false,
    latitude: 26.40887,
    longitude: -80.16139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33496',
  },
  {
    city: 'Boca Raton',
    county_fips: 12099,
    county_fips_all: '12099',
    county: 'Palm Beach',
    county_names_all: 'Palm Beach',
    county_weights: '{"12099": 100}',
    density: 650.2,
    imprecise: false,
    latitude: 26.39529,
    longitude: -80.21982,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33498',
  },
  {
    city: 'Balm',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 564.7,
    imprecise: false,
    latitude: 27.76375,
    longitude: -82.27425,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33503',
  },
  {
    city: 'Brandon',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1558,
    imprecise: false,
    latitude: 27.95564,
    longitude: -82.29986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33510',
  },
  {
    city: 'Brandon',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1495.2,
    imprecise: false,
    latitude: 27.9099,
    longitude: -82.29405,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33511',
  },
  {
    city: 'Bushnell',
    county_fips: 12119,
    county_fips_all: '12119',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"12119": 100}',
    density: 64.5,
    imprecise: false,
    latitude: 28.66849,
    longitude: -82.17143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33513',
  },
  {
    city: 'Center Hill',
    county_fips: 12119,
    county_fips_all: '12119',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"12119": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 28.65771,
    longitude: -81.99886,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33514',
  },
  {
    city: 'Coleman',
    county_fips: 12119,
    county_fips_all: '12119',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"12119": 100}',
    density: 75.6,
    imprecise: false,
    latitude: 28.79788,
    longitude: -82.0752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33521',
  },
  {
    city: 'Dade City',
    county_fips: 12101,
    county_fips_all: '12101|12053',
    county: 'Pasco',
    county_names_all: 'Pasco|Hernando',
    county_weights: '{"12101": 92.33, "12053": 7.67}',
    density: 71.2,
    imprecise: false,
    latitude: 28.41787,
    longitude: -82.26476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33523',
  },
  {
    city: 'Dade City',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 84.7,
    imprecise: false,
    latitude: 28.33503,
    longitude: -82.18383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33525',
  },
  {
    city: 'Dover',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 213.3,
    imprecise: false,
    latitude: 27.97571,
    longitude: -82.2138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33527',
  },
  {
    city: 'Durant',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 116.4,
    imprecise: false,
    latitude: 27.90773,
    longitude: -82.17236,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33530',
  },
  {
    city: 'Gibsonton',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 519.7,
    imprecise: false,
    latitude: 27.82273,
    longitude: -82.37505,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33534',
  },
  {
    city: 'Lake Panasoffkee',
    county_fips: 12119,
    county_fips_all: '12119',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"12119": 100}',
    density: 26.6,
    imprecise: false,
    latitude: 28.84679,
    longitude: -82.18218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33538',
  },
  {
    city: 'Zephyrhills',
    county_fips: 12101,
    county_fips_all: '12101|12057',
    county: 'Pasco',
    county_names_all: 'Pasco|Hillsborough',
    county_weights: '{"12101": 91.67, "12057": 8.33}',
    density: 121.9,
    imprecise: false,
    latitude: 28.21936,
    longitude: -82.14866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33540',
  },
  {
    city: 'Zephyrhills',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 400.5,
    imprecise: false,
    latitude: 28.23029,
    longitude: -82.22073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33541',
  },
  {
    city: 'Zephyrhills',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 873.9,
    imprecise: false,
    latitude: 28.23562,
    longitude: -82.17708,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33542',
  },
  {
    city: 'Wesley Chapel',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 597.9,
    imprecise: false,
    latitude: 28.20279,
    longitude: -82.30503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33543',
  },
  {
    city: 'Wesley Chapel',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 401.5,
    imprecise: false,
    latitude: 28.25132,
    longitude: -82.37039,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33544',
  },
  {
    city: 'Wesley Chapel',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 438.9,
    imprecise: false,
    latitude: 28.26578,
    longitude: -82.28832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33545',
  },
  {
    city: 'Lithia',
    county_fips: 12057,
    county_fips_all: '12057|12105',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough|Polk',
    county_weights: '{"12057": 97.54, "12105": 2.46}',
    density: 75.6,
    imprecise: false,
    latitude: 27.77239,
    longitude: -82.13665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33547',
  },
  {
    city: 'Lutz',
    county_fips: 12057,
    county_fips_all: '12057|12101',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough|Pasco',
    county_weights: '{"12057": 96.46, "12101": 3.54}',
    density: 454.6,
    imprecise: false,
    latitude: 28.13788,
    longitude: -82.48184,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33548',
  },
  {
    city: 'Lutz',
    county_fips: 12057,
    county_fips_all: '12057|12101',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough|Pasco',
    county_weights: '{"12057": 81.78, "12101": 18.22}',
    density: 575.5,
    imprecise: false,
    latitude: 28.1392,
    longitude: -82.44624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33549',
  },
  {
    city: 'Mango',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 0,
    imprecise: false,
    latitude: 27.97956,
    longitude: -82.30698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33550',
  },
  {
    city: 'Odessa',
    county_fips: 12057,
    county_fips_all: '12057|12101',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough|Pasco',
    county_weights: '{"12057": 55.85, "12101": 44.15}',
    density: 228.9,
    imprecise: false,
    latitude: 28.17029,
    longitude: -82.59264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33556',
  },
  {
    city: 'Lutz',
    county_fips: 12057,
    county_fips_all: '12057|12101',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough|Pasco',
    county_weights: '{"12057": 65.3, "12101": 34.7}',
    density: 706.3,
    imprecise: false,
    latitude: 28.15871,
    longitude: -82.51597,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33558',
  },
  {
    city: 'Lutz',
    county_fips: 12057,
    county_fips_all: '12057|12101',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough|Pasco',
    county_weights: '{"12057": 58.49, "12101": 41.51}',
    density: 608.6,
    imprecise: false,
    latitude: 28.15788,
    longitude: -82.41007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33559',
  },
  {
    city: 'Plant City',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 662.7,
    imprecise: false,
    latitude: 28.01694,
    longitude: -82.12544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33563',
  },
  {
    city: 'Plant City',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 89.3,
    imprecise: false,
    latitude: 28.08858,
    longitude: -82.15595,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33565',
  },
  {
    city: 'Plant City',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 399.9,
    imprecise: false,
    latitude: 27.99241,
    longitude: -82.1172,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33566',
  },
  {
    city: 'Plant City',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 116.6,
    imprecise: false,
    latitude: 27.92159,
    longitude: -82.1217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33567',
  },
  {
    city: 'Riverview',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 772.7,
    imprecise: false,
    latitude: 27.84429,
    longitude: -82.29069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33569',
  },
  {
    city: 'Ruskin',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 307.6,
    imprecise: false,
    latitude: 27.69354,
    longitude: -82.45861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33570',
  },
  {
    city: 'Apollo Beach',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 782.4,
    imprecise: false,
    latitude: 27.7659,
    longitude: -82.39999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33572',
  },
  {
    city: 'Sun City Center',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 812.6,
    imprecise: false,
    latitude: 27.72179,
    longitude: -82.36,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33573',
  },
  {
    city: 'Saint Leo',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 2618.6,
    imprecise: false,
    latitude: 28.33811,
    longitude: -82.257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33574',
  },
  {
    city: 'San Antonio',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 116.9,
    imprecise: false,
    latitude: 28.32472,
    longitude: -82.31682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33576',
  },
  {
    city: 'Riverview',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1149.4,
    imprecise: false,
    latitude: 27.86187,
    longitude: -82.34775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33578',
  },
  {
    city: 'Riverview',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 884.4,
    imprecise: false,
    latitude: 27.79585,
    longitude: -82.28376,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33579',
  },
  {
    city: 'Seffner',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 575,
    imprecise: false,
    latitude: 28.00637,
    longitude: -82.28959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33584',
  },
  {
    city: 'Sumterville',
    county_fips: 12119,
    county_fips_all: '12119',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"12119": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 28.74089,
    longitude: -82.03347,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33585',
  },
  {
    city: 'Thonotosassa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 89.7,
    imprecise: false,
    latitude: 28.10087,
    longitude: -82.28698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33592',
  },
  {
    city: 'Valrico',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1409.9,
    imprecise: false,
    latitude: 27.94081,
    longitude: -82.24207,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33594',
  },
  {
    city: 'Valrico',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 943.1,
    imprecise: false,
    latitude: 27.88765,
    longitude: -82.23591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33596',
  },
  {
    city: 'Webster',
    county_fips: 12119,
    county_fips_all: '12119|12053|12101',
    county: 'Sumter',
    county_names_all: 'Sumter|Hernando|Pasco',
    county_weights: '{"12119": 55.54, "12053": 23.19, "12101": 21.27}',
    density: 27.2,
    imprecise: false,
    latitude: 28.52675,
    longitude: -82.08613,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33597',
  },
  {
    city: 'Wimauma',
    county_fips: 12057,
    county_fips_all: '12057|12081',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough|Manatee',
    county_weights: '{"12057": 92.51, "12081": 7.49}',
    density: 150.5,
    imprecise: false,
    latitude: 27.69531,
    longitude: -82.29025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33598',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 3195.8,
    imprecise: false,
    latitude: 27.95371,
    longitude: -82.45675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33602',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1856.7,
    imprecise: false,
    latitude: 27.98526,
    longitude: -82.46458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33603',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 2071,
    imprecise: false,
    latitude: 28.01686,
    longitude: -82.45519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33604',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 789.7,
    imprecise: false,
    latitude: 27.95121,
    longitude: -82.42924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33605',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 2895.4,
    imprecise: false,
    latitude: 27.93209,
    longitude: -82.46493,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33606',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1052.5,
    imprecise: false,
    latitude: 27.96677,
    longitude: -82.51408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33607',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1790.5,
    imprecise: false,
    latitude: 27.94307,
    longitude: -82.51108,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33609',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 999.3,
    imprecise: false,
    latitude: 27.9972,
    longitude: -82.38015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33610',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 2261.9,
    imprecise: false,
    latitude: 27.89059,
    longitude: -82.50632,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33611',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1902.7,
    imprecise: false,
    latitude: 28.05071,
    longitude: -82.451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33612',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1948.3,
    imprecise: false,
    latitude: 28.08344,
    longitude: -82.44873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33613',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1875,
    imprecise: false,
    latitude: 28.00619,
    longitude: -82.50598,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33614',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 2130.5,
    imprecise: false,
    latitude: 28.00546,
    longitude: -82.58144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33615',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1556.3,
    imprecise: false,
    latitude: 27.86712,
    longitude: -82.5287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33616',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 2090.9,
    imprecise: false,
    latitude: 28.03893,
    longitude: -82.39327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33617',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1270.5,
    imprecise: false,
    latitude: 28.07313,
    longitude: -82.49781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33618',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 581.8,
    imprecise: false,
    latitude: 27.93536,
    longitude: -82.37841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33619',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 111.3,
    imprecise: false,
    latitude: 27.8436,
    longitude: -82.50089,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33621',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1756.6,
    imprecise: false,
    latitude: 28.07903,
    longitude: -82.52608,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33624',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1279.7,
    imprecise: false,
    latitude: 28.06807,
    longitude: -82.56016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33625',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 962.1,
    imprecise: false,
    latitude: 28.06256,
    longitude: -82.61526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33626',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 2224.1,
    imprecise: false,
    latitude: 27.92181,
    longitude: -82.51007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33629',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1000.3,
    imprecise: false,
    latitude: 28.00769,
    longitude: -82.54614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33634',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 1159,
    imprecise: false,
    latitude: 28.02408,
    longitude: -82.61882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33635',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 870.2,
    imprecise: false,
    latitude: 28.04715,
    longitude: -82.36118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33637',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 892.3,
    imprecise: false,
    latitude: 28.13401,
    longitude: -82.36017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 74844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33647',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 2726.5,
    imprecise: false,
    latitude: 27.7705,
    longitude: -82.63566,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33701',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1164.7,
    imprecise: false,
    latitude: 27.84567,
    longitude: -82.63251,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33702',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1944.4,
    imprecise: false,
    latitude: 27.81756,
    longitude: -82.62433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33703',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1831.5,
    imprecise: false,
    latitude: 27.79666,
    longitude: -82.63292,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33704',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1932.4,
    imprecise: false,
    latitude: 27.73641,
    longitude: -82.64265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33705',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1615.3,
    imprecise: false,
    latitude: 27.74396,
    longitude: -82.75014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33706',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1778.4,
    imprecise: false,
    latitude: 27.74913,
    longitude: -82.72293,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33707',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1707.1,
    imprecise: false,
    latitude: 27.81192,
    longitude: -82.7933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33708',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1889,
    imprecise: false,
    latitude: 27.81721,
    longitude: -82.73075,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33709',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1636.7,
    imprecise: false,
    latitude: 27.7898,
    longitude: -82.73069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33710',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1642.9,
    imprecise: false,
    latitude: 27.73884,
    longitude: -82.68845,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33711',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1638.1,
    imprecise: false,
    latitude: 27.73719,
    longitude: -82.66535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33712',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1874.3,
    imprecise: false,
    latitude: 27.78882,
    longitude: -82.67753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33713',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 2032.9,
    imprecise: false,
    latitude: 27.81696,
    longitude: -82.67794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33714',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 816.5,
    imprecise: false,
    latitude: 27.66323,
    longitude: -82.72214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33715',
  },
  {
    city: 'Saint Petersburg',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1041.9,
    imprecise: false,
    latitude: 27.8774,
    longitude: -82.65119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33716',
  },
  {
    city: 'Bay Pines',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 39,
    imprecise: false,
    latitude: 27.8084,
    longitude: -82.77451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33744',
  },
  {
    city: 'Clearwater',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1939.8,
    imprecise: false,
    latitude: 27.9793,
    longitude: -82.78007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33755',
  },
  {
    city: 'Clearwater',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1724,
    imprecise: false,
    latitude: 27.94421,
    longitude: -82.79216,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33756',
  },
  {
    city: 'Clearwater',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1284.7,
    imprecise: false,
    latitude: 27.98095,
    longitude: -82.7145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33759',
  },
  {
    city: 'Clearwater',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1405,
    imprecise: false,
    latitude: 27.90535,
    longitude: -82.71389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33760',
  },
  {
    city: 'Clearwater',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1395.8,
    imprecise: false,
    latitude: 28.03103,
    longitude: -82.72511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33761',
  },
  {
    city: 'Clearwater',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 275.6,
    imprecise: false,
    latitude: 27.89685,
    longitude: -82.67946,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33762',
  },
  {
    city: 'Clearwater',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 2434.6,
    imprecise: false,
    latitude: 28.00298,
    longitude: -82.74347,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33763',
  },
  {
    city: 'Clearwater',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1670.1,
    imprecise: false,
    latitude: 27.93679,
    longitude: -82.7424,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33764',
  },
  {
    city: 'Clearwater',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1276.4,
    imprecise: false,
    latitude: 27.97452,
    longitude: -82.74419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33765',
  },
  {
    city: 'Clearwater Beach',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1554.3,
    imprecise: false,
    latitude: 27.97022,
    longitude: -82.82329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33767',
  },
  {
    city: 'Largo',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1883.7,
    imprecise: false,
    latitude: 27.91477,
    longitude: -82.8035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33770',
  },
  {
    city: 'Largo',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1779.2,
    imprecise: false,
    latitude: 27.90585,
    longitude: -82.7583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33771',
  },
  {
    city: 'Seminole',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1736.4,
    imprecise: false,
    latitude: 27.84286,
    longitude: -82.79666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33772',
  },
  {
    city: 'Largo',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1278.3,
    imprecise: false,
    latitude: 27.88156,
    longitude: -82.75594,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33773',
  },
  {
    city: 'Largo',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1667,
    imprecise: false,
    latitude: 27.88275,
    longitude: -82.8278,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33774',
  },
  {
    city: 'Seminole',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1431.5,
    imprecise: false,
    latitude: 27.84975,
    longitude: -82.82634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33776',
  },
  {
    city: 'Seminole',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1304,
    imprecise: false,
    latitude: 27.85257,
    longitude: -82.76026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33777',
  },
  {
    city: 'Largo',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1724.7,
    imprecise: false,
    latitude: 27.88266,
    longitude: -82.79843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33778',
  },
  {
    city: 'Pinellas Park',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1649.1,
    imprecise: false,
    latitude: 27.83861,
    longitude: -82.71512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33781',
  },
  {
    city: 'Pinellas Park',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1610,
    imprecise: false,
    latitude: 27.85964,
    longitude: -82.70901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33782',
  },
  {
    city: 'Indian Rocks Beach',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1607.6,
    imprecise: false,
    latitude: 27.88559,
    longitude: -82.84425,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33785',
  },
  {
    city: 'Belleair Beach',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1139.2,
    imprecise: false,
    latitude: 27.92385,
    longitude: -82.83635,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33786',
  },
  {
    city: 'Lakeland',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 722,
    imprecise: false,
    latitude: 28.0401,
    longitude: -81.8947,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33801',
  },
  {
    city: 'Lakeland',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 682.3,
    imprecise: false,
    latitude: 28.00887,
    longitude: -81.93604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33803',
  },
  {
    city: 'Lakeland',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 427.7,
    imprecise: false,
    latitude: 28.09829,
    longitude: -81.91279,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33805',
  },
  {
    city: 'Lakeland',
    county_fips: 12105,
    county_fips_all: '12105|12101',
    county: 'Polk',
    county_names_all: 'Polk|Pasco',
    county_weights: '{"12105": 99.83, "12101": 0.17}',
    density: 180.5,
    imprecise: false,
    latitude: 28.20291,
    longitude: -81.96597,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33809',
  },
  {
    city: 'Lakeland',
    county_fips: 12105,
    county_fips_all: '12105|12057',
    county: 'Polk',
    county_names_all: 'Polk|Hillsborough',
    county_weights: '{"12105": 73.18, "12057": 26.82}',
    density: 329.4,
    imprecise: false,
    latitude: 28.13027,
    longitude: -82.03989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33810',
  },
  {
    city: 'Lakeland',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 422.4,
    imprecise: false,
    latitude: 27.97933,
    longitude: -82.01866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33811',
  },
  {
    city: 'Lakeland',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 645.4,
    imprecise: false,
    latitude: 27.97262,
    longitude: -81.89304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33812',
  },
  {
    city: 'Lakeland',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 711.2,
    imprecise: false,
    latitude: 27.94789,
    longitude: -81.92701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33813',
  },
  {
    city: 'Lakeland',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 731,
    imprecise: false,
    latitude: 28.04067,
    longitude: -81.99634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33815',
  },
  {
    city: 'Auburndale',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 462.1,
    imprecise: false,
    latitude: 28.09041,
    longitude: -81.81267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33823',
  },
  {
    city: 'Avon Park',
    county_fips: 12055,
    county_fips_all: '12055|12105',
    county: 'Highlands',
    county_names_all: 'Highlands|Polk',
    county_weights: '{"12055": 65.77, "12105": 34.23}',
    density: 87.3,
    imprecise: false,
    latitude: 27.62704,
    longitude: -81.44343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33825',
  },
  {
    city: 'Babson Park',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 29.5,
    imprecise: false,
    latitude: 27.81445,
    longitude: -81.51484,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33827',
  },
  {
    city: 'Bartow',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 108.1,
    imprecise: false,
    latitude: 27.88234,
    longitude: -81.80565,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33830',
  },
  {
    city: 'Bowling Green',
    county_fips: 12049,
    county_fips_all: '12049|12105',
    county: 'Hardee',
    county_names_all: 'Hardee|Polk',
    county_weights: '{"12049": 65.8, "12105": 34.2}',
    density: 17.8,
    imprecise: false,
    latitude: 27.62778,
    longitude: -81.92115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33834',
  },
  {
    city: 'Bradley',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 76.9,
    imprecise: false,
    latitude: 27.78829,
    longitude: -81.97256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33835',
  },
  {
    city: 'Davenport',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 356.4,
    imprecise: false,
    latitude: 28.19012,
    longitude: -81.59163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33837',
  },
  {
    city: 'Dundee',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 299.6,
    imprecise: false,
    latitude: 28.01851,
    longitude: -81.60956,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33838',
  },
  {
    city: 'Eagle Lake',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 562,
    imprecise: false,
    latitude: 27.97481,
    longitude: -81.75365,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33839',
  },
  {
    city: 'Eaton Park',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 0,
    imprecise: false,
    latitude: 28.00915,
    longitude: -81.90506,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33840',
  },
  {
    city: 'Fort Meade',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 27.7381,
    longitude: -81.7674,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33841',
  },
  {
    city: 'Frostproof',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 34.9,
    imprecise: false,
    latitude: 27.73131,
    longitude: -81.5108,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33843',
  },
  {
    city: 'Haines City',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 203.6,
    imprecise: false,
    latitude: 28.08616,
    longitude: -81.58717,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33844',
  },
  {
    city: 'Homeland',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 190.7,
    imprecise: false,
    latitude: 27.80864,
    longitude: -81.82381,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33847',
  },
  {
    city: 'Intercession City',
    county_fips: 12097,
    county_fips_all: '12097',
    county: 'Osceola',
    county_names_all: 'Osceola',
    county_weights: '{"12097": 100}',
    density: 22.6,
    imprecise: false,
    latitude: 28.27594,
    longitude: -81.50824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33848',
  },
  {
    city: 'Kathleen',
    county_fips: 12105,
    county_fips_all: '12105|12101',
    county: 'Polk',
    county_names_all: 'Polk|Pasco',
    county_weights: '{"12105": 98.28, "12101": 1.72}',
    density: 14.6,
    imprecise: false,
    latitude: 28.21613,
    longitude: -82.07414,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33849',
  },
  {
    city: 'Lake Alfred',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 224.9,
    imprecise: false,
    latitude: 28.11886,
    longitude: -81.73191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33850',
  },
  {
    city: 'Lake Hamilton',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 359.9,
    imprecise: false,
    latitude: 28.04439,
    longitude: -81.62677,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33851',
  },
  {
    city: 'Lake Placid',
    county_fips: 12055,
    county_fips_all: '12055',
    county: 'Highlands',
    county_names_all: 'Highlands',
    county_weights: '{"12055": 100}',
    density: 29.7,
    imprecise: false,
    latitude: 27.25904,
    longitude: -81.37844,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33852',
  },
  {
    city: 'Lake Wales',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 565,
    imprecise: false,
    latitude: 27.90023,
    longitude: -81.58556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33853',
  },
  {
    city: 'Lakeshore',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 1917.3,
    imprecise: false,
    latitude: 27.85608,
    longitude: -81.41033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33854',
  },
  {
    city: 'Indian Lake Estates',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 27.79104,
    longitude: -81.35971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33855',
  },
  {
    city: 'Nalcrest',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 1385.2,
    imprecise: false,
    latitude: 27.85648,
    longitude: -81.42828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33856',
  },
  {
    city: 'Lorida',
    county_fips: 12055,
    county_fips_all: '12055',
    county: 'Highlands',
    county_names_all: 'Highlands',
    county_weights: '{"12055": 100}',
    density: 2,
    imprecise: false,
    latitude: 27.35647,
    longitude: -81.16517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33857',
  },
  {
    city: 'Loughman',
    county_fips: 12105,
    county_fips_all: '12105|12097',
    county: 'Polk',
    county_names_all: 'Polk|Osceola',
    county_weights: '{"12105": 99.87, "12097": 0.13}',
    density: 635.3,
    imprecise: false,
    latitude: 28.24506,
    longitude: -81.55832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33858',
  },
  {
    city: 'Lake Wales',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 100.4,
    imprecise: false,
    latitude: 27.88428,
    longitude: -81.63106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33859',
  },
  {
    city: 'Mulberry',
    county_fips: 12105,
    county_fips_all: '12105|12057',
    county: 'Polk',
    county_names_all: 'Polk|Hillsborough',
    county_weights: '{"12105": 98.69, "12057": 1.31}',
    density: 97.7,
    imprecise: false,
    latitude: 27.8056,
    longitude: -81.99511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33860',
  },
  {
    city: 'Ona',
    county_fips: 12049,
    county_fips_all: '12049|12027',
    county: 'Hardee',
    county_names_all: 'Hardee|DeSoto',
    county_weights: '{"12049": 97.04, "12027": 2.96}',
    density: 1.1,
    imprecise: false,
    latitude: 27.42944,
    longitude: -81.96262,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33865',
  },
  {
    city: 'River Ranch',
    county_fips: 12105,
    county_fips_all: '12105|12097',
    county: 'Polk',
    county_names_all: 'Polk|Osceola',
    county_weights: '{"12105": 99.85, "12097": 0.15}',
    density: 3.7,
    imprecise: false,
    latitude: 27.78249,
    longitude: -81.20136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33867',
  },
  {
    city: 'Polk City',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 28.25882,
    longitude: -81.84769,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33868',
  },
  {
    city: 'Sebring',
    county_fips: 12055,
    county_fips_all: '12055',
    county: 'Highlands',
    county_names_all: 'Highlands',
    county_weights: '{"12055": 100}',
    density: 102.1,
    imprecise: false,
    latitude: 27.50571,
    longitude: -81.36071,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33870',
  },
  {
    city: 'Sebring',
    county_fips: 12055,
    county_fips_all: '12055',
    county: 'Highlands',
    county_names_all: 'Highlands',
    county_weights: '{"12055": 100}',
    density: 233.6,
    imprecise: false,
    latitude: 27.50911,
    longitude: -81.53147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33872',
  },
  {
    city: 'Wauchula',
    county_fips: 12049,
    county_fips_all: '12049',
    county: 'Hardee',
    county_names_all: 'Hardee',
    county_weights: '{"12049": 100}',
    density: 43.2,
    imprecise: false,
    latitude: 27.56181,
    longitude: -81.77855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33873',
  },
  {
    city: 'Sebring',
    county_fips: 12055,
    county_fips_all: '12055',
    county: 'Highlands',
    county_names_all: 'Highlands',
    county_weights: '{"12055": 100}',
    density: 85.7,
    imprecise: false,
    latitude: 27.41813,
    longitude: -81.49198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33875',
  },
  {
    city: 'Sebring',
    county_fips: 12055,
    county_fips_all: '12055',
    county: 'Highlands',
    county_names_all: 'Highlands',
    county_weights: '{"12055": 100}',
    density: 83.9,
    imprecise: false,
    latitude: 27.4269,
    longitude: -81.35086,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33876',
  },
  {
    city: 'Waverly',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 27.98766,
    longitude: -81.61985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33877',
  },
  {
    city: 'Winter Haven',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 517,
    imprecise: false,
    latitude: 27.9914,
    longitude: -81.77448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33880',
  },
  {
    city: 'Winter Haven',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 719.1,
    imprecise: false,
    latitude: 28.05439,
    longitude: -81.70081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33881',
  },
  {
    city: 'Winter Haven',
    county_fips: 12105,
    county_fips_all: '12105',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"12105": 100}',
    density: 581.6,
    imprecise: false,
    latitude: 27.97669,
    longitude: -81.67653,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33884',
  },
  {
    city: 'Zolfo Springs',
    county_fips: 12049,
    county_fips_all: '12049',
    county: 'Hardee',
    county_names_all: 'Hardee',
    county_weights: '{"12049": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 27.4558,
    longitude: -81.68354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33890',
  },
  {
    city: 'Davenport',
    county_fips: 12097,
    county_fips_all: '12097|12105',
    county: 'Osceola',
    county_names_all: 'Osceola|Polk',
    county_weights: '{"12097": 63.43, "12105": 36.57}',
    density: 511,
    imprecise: false,
    latitude: 28.24663,
    longitude: -81.57526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33896',
  },
  {
    city: 'Davenport',
    county_fips: 12105,
    county_fips_all: '12105|12097',
    county: 'Polk',
    county_names_all: 'Polk|Osceola',
    county_weights: '{"12105": 99.03, "12097": 0.97}',
    density: 278.6,
    imprecise: false,
    latitude: 28.28088,
    longitude: -81.69533,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33897',
  },
  {
    city: 'Lake Wales',
    county_fips: 12105,
    county_fips_all: '12105|12097',
    county: 'Polk',
    county_names_all: 'Polk|Osceola',
    county_weights: '{"12105": 87.12, "12097": 12.88}',
    density: 24.1,
    imprecise: false,
    latitude: 27.83946,
    longitude: -81.34943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33898',
  },
  {
    city: 'Fort Myers',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 1514.2,
    imprecise: false,
    latitude: 26.62304,
    longitude: -81.88228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33901',
  },
  {
    city: 'North Fort Myers',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 806.2,
    imprecise: false,
    latitude: 26.68217,
    longitude: -81.90688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33903',
  },
  {
    city: 'Cape Coral',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 1333.1,
    imprecise: false,
    latitude: 26.57601,
    longitude: -81.94536,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33904',
  },
  {
    city: 'Fort Myers',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 397.8,
    imprecise: false,
    latitude: 26.66873,
    longitude: -81.76166,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33905',
  },
  {
    city: 'Fort Myers',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 1316.4,
    imprecise: false,
    latitude: 26.56447,
    longitude: -81.87171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33907',
  },
  {
    city: 'Fort Myers',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 422.2,
    imprecise: false,
    latitude: 26.48857,
    longitude: -81.91319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33908',
  },
  {
    city: 'Cape Coral',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 410.7,
    imprecise: false,
    latitude: 26.72032,
    longitude: -81.96443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33909',
  },
  {
    city: 'Fort Myers',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 355.4,
    imprecise: false,
    latitude: 26.53288,
    longitude: -81.82502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33912',
  },
  {
    city: 'Fort Myers',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 120.5,
    imprecise: false,
    latitude: 26.51718,
    longitude: -81.69712,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33913',
  },
  {
    city: 'Cape Coral',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 784.3,
    imprecise: false,
    latitude: 26.57052,
    longitude: -82.01944,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33914',
  },
  {
    city: 'Fort Myers',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 1049.4,
    imprecise: false,
    latitude: 26.63998,
    longitude: -81.84104,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33916',
  },
  {
    city: 'North Fort Myers',
    county_fips: 12071,
    county_fips_all: '12071|12015',
    county: 'Lee',
    county_names_all: 'Lee|Charlotte',
    county_weights: '{"12071": 73.22, "12015": 26.78}',
    density: 196.7,
    imprecise: false,
    latitude: 26.75403,
    longitude: -81.84779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33917',
  },
  {
    city: 'Fort Myers',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 1342.2,
    imprecise: false,
    latitude: 26.55607,
    longitude: -81.90388,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33919',
  },
  {
    city: 'Alva',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 56.4,
    imprecise: false,
    latitude: 26.72903,
    longitude: -81.6529,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33920',
  },
  {
    city: 'Boca Grande',
    county_fips: 12071,
    county_fips_all: '12071|12015',
    county: 'Lee',
    county_names_all: 'Lee|Charlotte',
    county_weights: '{"12071": 71.39, "12015": 28.61}',
    density: 54.7,
    imprecise: false,
    latitude: 26.77919,
    longitude: -82.25386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33921',
  },
  {
    city: 'Bokeelia',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 78.2,
    imprecise: false,
    latitude: 26.66476,
    longitude: -82.15897,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33922',
  },
  {
    city: 'Captiva',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 26.54521,
    longitude: -82.19832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33924',
  },
  {
    city: 'Estero',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 295.7,
    imprecise: false,
    latitude: 26.43545,
    longitude: -81.71002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33928',
  },
  {
    city: 'Felda',
    county_fips: 12051,
    county_fips_all: '12051',
    county: 'Hendry',
    county_names_all: 'Hendry',
    county_weights: '{"12051": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 26.55916,
    longitude: -81.40069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33930',
  },
  {
    city: 'Fort Myers Beach',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 313.3,
    imprecise: false,
    latitude: 26.44036,
    longitude: -81.90974,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33931',
  },
  {
    city: 'Labelle',
    county_fips: 12051,
    county_fips_all: '12051|12043',
    county: 'Hendry',
    county_names_all: 'Hendry|Glades',
    county_weights: '{"12051": 58.29, "12043": 41.71}',
    density: 24.6,
    imprecise: false,
    latitude: 26.75692,
    longitude: -81.41966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33935',
  },
  {
    city: 'Lehigh Acres',
    county_fips: 12051,
    county_fips_all: '12051|12071',
    county: 'Hendry',
    county_names_all: 'Hendry|Lee',
    county_weights: '{"12051": 67.55, "12071": 32.45}',
    density: 298.7,
    imprecise: false,
    latitude: 26.6292,
    longitude: -81.5602,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33936',
  },
  {
    city: 'Palmdale',
    county_fips: 12043,
    county_fips_all: '12043',
    county: 'Glades',
    county_names_all: 'Glades',
    county_weights: '{"12043": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 26.97163,
    longitude: -81.36924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33944',
  },
  {
    city: 'Placida',
    county_fips: 12015,
    county_fips_all: '12015',
    county: 'Charlotte',
    county_names_all: 'Charlotte',
    county_weights: '{"12015": 100}',
    density: 110.9,
    imprecise: false,
    latitude: 26.853,
    longitude: -82.26958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33946',
  },
  {
    city: 'Rotonda West',
    county_fips: 12015,
    county_fips_all: '12015',
    county: 'Charlotte',
    county_names_all: 'Charlotte',
    county_weights: '{"12015": 100}',
    density: 303.4,
    imprecise: false,
    latitude: 26.89015,
    longitude: -82.27184,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33947',
  },
  {
    city: 'Port Charlotte',
    county_fips: 12015,
    county_fips_all: '12015',
    county: 'Charlotte',
    county_names_all: 'Charlotte',
    county_weights: '{"12015": 100}',
    density: 556.7,
    imprecise: false,
    latitude: 26.98411,
    longitude: -82.15126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33948',
  },
  {
    city: 'Punta Gorda',
    county_fips: 12015,
    county_fips_all: '12015',
    county: 'Charlotte',
    county_names_all: 'Charlotte',
    county_weights: '{"12015": 100}',
    density: 539.9,
    imprecise: false,
    latitude: 26.91166,
    longitude: -82.04009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33950',
  },
  {
    city: 'Port Charlotte',
    county_fips: 12015,
    county_fips_all: '12015',
    county: 'Charlotte',
    county_names_all: 'Charlotte',
    county_weights: '{"12015": 100}',
    density: 1233.8,
    imprecise: false,
    latitude: 26.99008,
    longitude: -82.0972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33952',
  },
  {
    city: 'Port Charlotte',
    county_fips: 12015,
    county_fips_all: '12015',
    county: 'Charlotte',
    county_names_all: 'Charlotte',
    county_weights: '{"12015": 100}',
    density: 198.9,
    imprecise: false,
    latitude: 26.99991,
    longitude: -82.21222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33953',
  },
  {
    city: 'Port Charlotte',
    county_fips: 12015,
    county_fips_all: '12015',
    county: 'Charlotte',
    county_names_all: 'Charlotte',
    county_weights: '{"12015": 100}',
    density: 502,
    imprecise: false,
    latitude: 27.02506,
    longitude: -82.12167,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33954',
  },
  {
    city: 'Punta Gorda',
    county_fips: 12015,
    county_fips_all: '12015|12071',
    county: 'Charlotte',
    county_names_all: 'Charlotte|Lee',
    county_weights: '{"12015": 98.42, "12071": 1.58}',
    density: 61.1,
    imprecise: false,
    latitude: 26.82528,
    longitude: -81.97007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33955',
  },
  {
    city: 'Saint James City',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 80.7,
    imprecise: false,
    latitude: 26.54622,
    longitude: -82.09589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33956',
  },
  {
    city: 'Sanibel',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 152.7,
    imprecise: false,
    latitude: 26.4534,
    longitude: -82.10228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33957',
  },
  {
    city: 'Venus',
    county_fips: 12055,
    county_fips_all: '12055|12043',
    county: 'Highlands',
    county_names_all: 'Highlands|Glades',
    county_weights: '{"12055": 72.64, "12043": 27.36}',
    density: 1.1,
    imprecise: false,
    latitude: 27.07709,
    longitude: -81.41682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33960',
  },
  {
    city: 'Fort Myers',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 551.8,
    imprecise: false,
    latitude: 26.58234,
    longitude: -81.83206,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33966',
  },
  {
    city: 'Fort Myers',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 1431.7,
    imprecise: false,
    latitude: 26.47226,
    longitude: -81.81231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33967',
  },
  {
    city: 'Lehigh Acres',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 700.3,
    imprecise: false,
    latitude: 26.63856,
    longitude: -81.69948,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33971',
  },
  {
    city: 'Lehigh Acres',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 264.1,
    imprecise: false,
    latitude: 26.64954,
    longitude: -81.61721,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33972',
  },
  {
    city: 'Lehigh Acres',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 1462.7,
    imprecise: false,
    latitude: 26.6014,
    longitude: -81.73012,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33973',
  },
  {
    city: 'Lehigh Acres',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 343.6,
    imprecise: false,
    latitude: 26.56205,
    longitude: -81.60271,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33974',
  },
  {
    city: 'Lehigh Acres',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 843.8,
    imprecise: false,
    latitude: 26.59128,
    longitude: -81.68543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33976',
  },
  {
    city: 'Punta Gorda',
    county_fips: 12015,
    county_fips_all: '12015',
    county: 'Charlotte',
    county_names_all: 'Charlotte',
    county_weights: '{"12015": 100}',
    density: 553.3,
    imprecise: false,
    latitude: 26.98062,
    longitude: -82.05206,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33980',
  },
  {
    city: 'Port Charlotte',
    county_fips: 12015,
    county_fips_all: '12015',
    county: 'Charlotte',
    county_names_all: 'Charlotte',
    county_weights: '{"12015": 100}',
    density: 132.7,
    imprecise: false,
    latitude: 26.87544,
    longitude: -82.21047,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33981',
  },
  {
    city: 'Punta Gorda',
    county_fips: 12015,
    county_fips_all: '12015',
    county: 'Charlotte',
    county_names_all: 'Charlotte',
    county_weights: '{"12015": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 26.91587,
    longitude: -81.75753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33982',
  },
  {
    city: 'Punta Gorda',
    county_fips: 12015,
    county_fips_all: '12015',
    county: 'Charlotte',
    county_names_all: 'Charlotte',
    county_weights: '{"12015": 100}',
    density: 670.7,
    imprecise: false,
    latitude: 27.00712,
    longitude: -82.01508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33983',
  },
  {
    city: 'Cape Coral',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 1433.9,
    imprecise: false,
    latitude: 26.62875,
    longitude: -81.94602,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33990',
  },
  {
    city: 'Cape Coral',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 835.4,
    imprecise: false,
    latitude: 26.63074,
    longitude: -82.01065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33991',
  },
  {
    city: 'Cape Coral',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 314.6,
    imprecise: false,
    latitude: 26.67194,
    longitude: -82.04522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33993',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 0,
    imprecise: false,
    latitude: 26.05694,
    longitude: -81.78056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34101',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 764.5,
    imprecise: false,
    latitude: 26.13783,
    longitude: -81.79654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34102',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 1124.2,
    imprecise: false,
    latitude: 26.19197,
    longitude: -81.80207,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34103',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 1034.5,
    imprecise: false,
    latitude: 26.15321,
    longitude: -81.74214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34104',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 628.5,
    imprecise: false,
    latitude: 26.18938,
    longitude: -81.7626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34105',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 799.9,
    imprecise: false,
    latitude: 26.24533,
    longitude: -81.80694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34108',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 841.5,
    imprecise: false,
    latitude: 26.24073,
    longitude: -81.76365,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34109',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021|12071',
    county: 'Collier',
    county_names_all: 'Collier|Lee',
    county_weights: '{"12021": 94.99, "12071": 5.01}',
    density: 617.8,
    imprecise: false,
    latitude: 26.29619,
    longitude: -81.78505,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34110',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 707.3,
    imprecise: false,
    latitude: 26.12053,
    longitude: -81.73908,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34112',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 388.8,
    imprecise: false,
    latitude: 26.05685,
    longitude: -81.73523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34113',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 51.5,
    imprecise: false,
    latitude: 25.98902,
    longitude: -81.58517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34114',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 1480,
    imprecise: false,
    latitude: 26.18816,
    longitude: -81.71058,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34116',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 56,
    imprecise: false,
    latitude: 26.11864,
    longitude: -81.548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34117',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021|12071',
    county: 'Collier',
    county_names_all: 'Collier|Lee',
    county_weights: '{"12021": 97.94, "12071": 2.06}',
    density: 630.3,
    imprecise: false,
    latitude: 26.26658,
    longitude: -81.71493,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34119',
  },
  {
    city: 'Naples',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 116.1,
    imprecise: false,
    latitude: 26.31382,
    longitude: -81.58344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34120',
  },
  {
    city: 'Bonita Springs',
    county_fips: 12071,
    county_fips_all: '12071|12021',
    county: 'Lee',
    county_names_all: 'Lee|Collier',
    county_weights: '{"12071": 89.51, "12021": 10.49}',
    density: 473.2,
    imprecise: false,
    latitude: 26.36634,
    longitude: -81.83503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34134',
  },
  {
    city: 'Bonita Springs',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 301.6,
    imprecise: false,
    latitude: 26.36923,
    longitude: -81.73303,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34135',
  },
  {
    city: 'Copeland',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 26.03542,
    longitude: -81.40757,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 68,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34137',
  },
  {
    city: 'Chokoloskee',
    county_fips: 12021,
    county_fips_all: '12021|12087',
    county: 'Collier',
    county_names_all: 'Collier|Monroe',
    county_weights: '{"12021": 99.83, "12087": 0.17}',
    density: 1119.5,
    imprecise: false,
    latitude: 25.82255,
    longitude: -81.37084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34138',
  },
  {
    city: 'Everglades City',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 65.4,
    imprecise: false,
    latitude: 25.85449,
    longitude: -81.38253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34139',
  },
  {
    city: 'Goodland',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 25.92531,
    longitude: -81.65888,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34140',
  },
  {
    city: 'Ochopee',
    county_fips: 12021,
    county_fips_all: '12021|12087|12086',
    county: 'Collier',
    county_names_all: 'Collier|Monroe|Miami-Dade',
    county_weights: '{"12021": 75.03, "12087": 20.3, "12086": 4.67}',
    density: 0.1,
    imprecise: false,
    latitude: 25.91774,
    longitude: -81.07706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34141',
  },
  {
    city: 'Immokalee',
    county_fips: 12021,
    county_fips_all: '12021|12051',
    county: 'Collier',
    county_names_all: 'Collier|Hendry',
    county_weights: '{"12021": 82.25, "12051": 17.75}',
    density: 21.7,
    imprecise: false,
    latitude: 26.31392,
    longitude: -81.28601,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34142',
  },
  {
    city: 'Marco Island',
    county_fips: 12021,
    county_fips_all: '12021',
    county: 'Collier',
    county_names_all: 'Collier',
    county_weights: '{"12021": 100}',
    density: 384.7,
    imprecise: false,
    latitude: 25.91903,
    longitude: -81.69506,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34145',
  },
  {
    city: 'Bradenton',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 421.3,
    imprecise: false,
    latitude: 27.4029,
    longitude: -82.46784,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34201',
  },
  {
    city: 'Bradenton',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 454.6,
    imprecise: false,
    latitude: 27.40722,
    longitude: -82.39254,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34202',
  },
  {
    city: 'Bradenton',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 1013.5,
    imprecise: false,
    latitude: 27.44319,
    longitude: -82.50834,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34203',
  },
  {
    city: 'Bradenton',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 1910.2,
    imprecise: false,
    latitude: 27.48418,
    longitude: -82.5835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34205',
  },
  {
    city: 'Bradenton',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 2133.5,
    imprecise: false,
    latitude: 27.43762,
    longitude: -82.57993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34207',
  },
  {
    city: 'Bradenton',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 1030.7,
    imprecise: false,
    latitude: 27.48693,
    longitude: -82.51404,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34208',
  },
  {
    city: 'Bradenton',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 1016.3,
    imprecise: false,
    latitude: 27.49489,
    longitude: -82.6433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34209',
  },
  {
    city: 'Bradenton',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 768.3,
    imprecise: false,
    latitude: 27.43897,
    longitude: -82.63117,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34210',
  },
  {
    city: 'Bradenton',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 283.4,
    imprecise: false,
    latitude: 27.44944,
    longitude: -82.37738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34211',
  },
  {
    city: 'Bradenton',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 443,
    imprecise: false,
    latitude: 27.49559,
    longitude: -82.40528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34212',
  },
  {
    city: 'Cortez',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 460.9,
    imprecise: false,
    latitude: 27.47444,
    longitude: -82.68409,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34215',
  },
  {
    city: 'Anna Maria',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 392.8,
    imprecise: false,
    latitude: 27.52837,
    longitude: -82.7331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34216',
  },
  {
    city: 'Bradenton Beach',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 675.7,
    imprecise: false,
    latitude: 27.48916,
    longitude: -82.7044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34217',
  },
  {
    city: 'Parrish',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 61,
    imprecise: false,
    latitude: 27.58041,
    longitude: -82.26094,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34219',
  },
  {
    city: 'Palmetto',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 402.6,
    imprecise: false,
    latitude: 27.57777,
    longitude: -82.54285,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34221',
  },
  {
    city: 'Ellenton',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 1076.2,
    imprecise: false,
    latitude: 27.53474,
    longitude: -82.50699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34222',
  },
  {
    city: 'Englewood',
    county_fips: 12115,
    county_fips_all: '12115|12015',
    county: 'Sarasota',
    county_names_all: 'Sarasota|Charlotte',
    county_weights: '{"12115": 89.78, "12015": 10.22}',
    density: 183.4,
    imprecise: false,
    latitude: 26.97963,
    longitude: -82.33257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34223',
  },
  {
    city: 'Englewood',
    county_fips: 12015,
    county_fips_all: '12015|12115',
    county: 'Charlotte',
    county_names_all: 'Charlotte|Sarasota',
    county_weights: '{"12015": 95.16, "12115": 4.84}',
    density: 467.1,
    imprecise: false,
    latitude: 26.91902,
    longitude: -82.30581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34224',
  },
  {
    city: 'Longboat Key',
    county_fips: 12081,
    county_fips_all: '12081|12115',
    county: 'Manatee',
    county_names_all: 'Manatee|Sarasota',
    county_weights: '{"12081": 52.65, "12115": 47.35}',
    density: 713.8,
    imprecise: false,
    latitude: 27.39258,
    longitude: -82.63407,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34228',
  },
  {
    city: 'Osprey',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 485.5,
    imprecise: false,
    latitude: 27.19159,
    longitude: -82.48309,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34229',
  },
  {
    city: 'Sarasota',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 1324.2,
    imprecise: false,
    latitude: 27.26651,
    longitude: -82.51626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34231',
  },
  {
    city: 'Sarasota',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 1190.3,
    imprecise: false,
    latitude: 27.32601,
    longitude: -82.47239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34232',
  },
  {
    city: 'Sarasota',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 1206.4,
    imprecise: false,
    latitude: 27.2836,
    longitude: -82.47311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34233',
  },
  {
    city: 'Sarasota',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 1358.2,
    imprecise: false,
    latitude: 27.36934,
    longitude: -82.5574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34234',
  },
  {
    city: 'Sarasota',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 941.4,
    imprecise: false,
    latitude: 27.36673,
    longitude: -82.47724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34235',
  },
  {
    city: 'Sarasota',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 1568.7,
    imprecise: false,
    latitude: 27.32964,
    longitude: -82.55874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34236',
  },
  {
    city: 'Sarasota',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 1702.5,
    imprecise: false,
    latitude: 27.33761,
    longitude: -82.51409,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34237',
  },
  {
    city: 'Sarasota',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 696.7,
    imprecise: false,
    latitude: 27.23049,
    longitude: -82.4687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34238',
  },
  {
    city: 'Sarasota',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 1271.6,
    imprecise: false,
    latitude: 27.31094,
    longitude: -82.52179,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34239',
  },
  {
    city: 'Sarasota',
    county_fips: 12115,
    county_fips_all: '12115|12081',
    county: 'Sarasota',
    county_names_all: 'Sarasota|Manatee',
    county_weights: '{"12115": 99.86, "12081": 0.14}',
    density: 109,
    imprecise: false,
    latitude: 27.34218,
    longitude: -82.35177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34240',
  },
  {
    city: 'Sarasota',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 90.3,
    imprecise: false,
    latitude: 27.24944,
    longitude: -82.37305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34241',
  },
  {
    city: 'Sarasota',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 813,
    imprecise: false,
    latitude: 27.26237,
    longitude: -82.53997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34242',
  },
  {
    city: 'Sarasota',
    county_fips: 12081,
    county_fips_all: '12081|12115',
    county: 'Manatee',
    county_names_all: 'Manatee|Sarasota',
    county_weights: '{"12081": 81.74, "12115": 18.26}',
    density: 704,
    imprecise: false,
    latitude: 27.40264,
    longitude: -82.52809,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34243',
  },
  {
    city: 'Terra Ceia',
    county_fips: 12081,
    county_fips_all: '12081',
    county: 'Manatee',
    county_names_all: 'Manatee',
    county_weights: '{"12081": 100}',
    density: 187.1,
    imprecise: false,
    latitude: 27.57168,
    longitude: -82.58923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34250',
  },
  {
    city: 'Myakka City',
    county_fips: 12081,
    county_fips_all: '12081|12115',
    county: 'Manatee',
    county_names_all: 'Manatee|Sarasota',
    county_weights: '{"12081": 99.17, "12115": 0.83}',
    density: 7.7,
    imprecise: false,
    latitude: 27.37819,
    longitude: -82.17152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34251',
  },
  {
    city: 'Arcadia',
    county_fips: 12027,
    county_fips_all: '12027|12115',
    county: 'DeSoto',
    county_names_all: 'DeSoto|Sarasota',
    county_weights: '{"12027": 93.37, "12115": 6.63}',
    density: 19.9,
    imprecise: false,
    latitude: 27.19895,
    longitude: -81.80304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34266',
  },
  {
    city: 'Fort Ogden',
    county_fips: 12027,
    county_fips_all: '12027',
    county: 'DeSoto',
    county_names_all: 'DeSoto',
    county_weights: '{"12027": 100}',
    density: 64.8,
    imprecise: false,
    latitude: 27.0893,
    longitude: -81.9543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34267',
  },
  {
    city: 'Nocatee',
    county_fips: 12027,
    county_fips_all: '12027',
    county: 'DeSoto',
    county_names_all: 'DeSoto',
    county_weights: '{"12027": 100}',
    density: 64.8,
    imprecise: false,
    latitude: 27.14459,
    longitude: -81.91775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34268',
  },
  {
    city: 'Arcadia',
    county_fips: 12027,
    county_fips_all: '12027',
    county: 'DeSoto',
    county_names_all: 'DeSoto',
    county_weights: '{"12027": 100}',
    density: 21.8,
    imprecise: false,
    latitude: 27.08865,
    longitude: -81.9639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34269',
  },
  {
    city: 'Nokomis',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 337.4,
    imprecise: false,
    latitude: 27.15203,
    longitude: -82.41966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34275',
  },
  {
    city: 'Venice',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 865.4,
    imprecise: false,
    latitude: 27.0918,
    longitude: -82.43408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34285',
  },
  {
    city: 'North Port',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 317,
    imprecise: false,
    latitude: 27.09099,
    longitude: -82.14147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34286',
  },
  {
    city: 'North Port',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 574.4,
    imprecise: false,
    latitude: 27.05735,
    longitude: -82.24677,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34287',
  },
  {
    city: 'North Port',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 364.9,
    imprecise: false,
    latitude: 27.05385,
    longitude: -82.11161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34288',
  },
  {
    city: 'North Port',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 477.7,
    imprecise: false,
    latitude: 27.08587,
    longitude: -82.13664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34289',
  },
  {
    city: 'North Port',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 184.6,
    imprecise: false,
    latitude: 27.11494,
    longitude: -82.21722,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34291',
  },
  {
    city: 'Venice',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 209,
    imprecise: false,
    latitude: 27.10308,
    longitude: -82.33496,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34292',
  },
  {
    city: 'Venice',
    county_fips: 12115,
    county_fips_all: '12115',
    county: 'Sarasota',
    county_names_all: 'Sarasota',
    county_weights: '{"12115": 100}',
    density: 595.5,
    imprecise: false,
    latitude: 27.04642,
    longitude: -82.35595,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34293',
  },
  {
    city: 'Belleview',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 312.3,
    imprecise: false,
    latitude: 29.05359,
    longitude: -82.04008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34420',
  },
  {
    city: 'Crystal River',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 58.5,
    imprecise: false,
    latitude: 28.9608,
    longitude: -82.63421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34428',
  },
  {
    city: 'Crystal River',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 81.4,
    imprecise: false,
    latitude: 28.85737,
    longitude: -82.65152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34429',
  },
  {
    city: 'Dunnellon',
    county_fips: 12083,
    county_fips_all: '12083|12075',
    county: 'Marion',
    county_names_all: 'Marion|Levy',
    county_weights: '{"12083": 55.06, "12075": 44.94}',
    density: 36.3,
    imprecise: false,
    latitude: 29.1339,
    longitude: -82.52963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34431',
  },
  {
    city: 'Dunnellon',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 49.9,
    imprecise: false,
    latitude: 29.06588,
    longitude: -82.36353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34432',
  },
  {
    city: 'Dunnellon',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 96.4,
    imprecise: false,
    latitude: 28.996,
    longitude: -82.52383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34433',
  },
  {
    city: 'Dunnellon',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 162.6,
    imprecise: false,
    latitude: 28.99535,
    longitude: -82.43775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34434',
  },
  {
    city: 'Floral City',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 57.5,
    imprecise: false,
    latitude: 28.72672,
    longitude: -82.29134,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34436',
  },
  {
    city: 'Hernando',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 183.1,
    imprecise: false,
    latitude: 28.93084,
    longitude: -82.39122,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34442',
  },
  {
    city: 'Holder',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 77.7,
    imprecise: false,
    latitude: 28.97143,
    longitude: -82.42414,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34445',
  },
  {
    city: 'Homosassa',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 247.1,
    imprecise: false,
    latitude: 28.74904,
    longitude: -82.52344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34446',
  },
  {
    city: 'Homosassa',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 57.7,
    imprecise: false,
    latitude: 28.77009,
    longitude: -82.61201,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34448',
  },
  {
    city: 'Inglis',
    county_fips: 12075,
    county_fips_all: '12075|12017',
    county: 'Levy',
    county_names_all: 'Levy|Citrus',
    county_weights: '{"12075": 92.97, "12017": 7.03}',
    density: 10.5,
    imprecise: false,
    latitude: 29.10451,
    longitude: -82.68694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34449',
  },
  {
    city: 'Inverness',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 142.8,
    imprecise: false,
    latitude: 28.82699,
    longitude: -82.25767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34450',
  },
  {
    city: 'Inverness',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 90,
    imprecise: false,
    latitude: 28.76231,
    longitude: -82.37986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34452',
  },
  {
    city: 'Inverness',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 151.5,
    imprecise: false,
    latitude: 28.89276,
    longitude: -82.33663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34453',
  },
  {
    city: 'Lecanto',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 112.9,
    imprecise: false,
    latitude: 28.81544,
    longitude: -82.48029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34461',
  },
  {
    city: 'Beverly Hills',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 299.8,
    imprecise: false,
    latitude: 28.92869,
    longitude: -82.49092,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34465',
  },
  {
    city: 'Ocala',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 645.8,
    imprecise: false,
    latitude: 29.20098,
    longitude: -82.08262,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34470',
  },
  {
    city: 'Ocala',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 552.1,
    imprecise: false,
    latitude: 29.16054,
    longitude: -82.12786,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34471',
  },
  {
    city: 'Ocala',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 381.5,
    imprecise: false,
    latitude: 29.11187,
    longitude: -81.99625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34472',
  },
  {
    city: 'Ocala',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 288.8,
    imprecise: false,
    latitude: 29.00506,
    longitude: -82.18833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34473',
  },
  {
    city: 'Ocala',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 373.1,
    imprecise: false,
    latitude: 29.15515,
    longitude: -82.21106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34474',
  },
  {
    city: 'Ocala',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 198.6,
    imprecise: false,
    latitude: 29.25282,
    longitude: -82.16065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34475',
  },
  {
    city: 'Ocala',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 323.7,
    imprecise: false,
    latitude: 29.08579,
    longitude: -82.19279,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34476',
  },
  {
    city: 'Ocala',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 285.9,
    imprecise: false,
    latitude: 29.25285,
    longitude: -82.10945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34479',
  },
  {
    city: 'Ocala',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 258.1,
    imprecise: false,
    latitude: 29.10178,
    longitude: -82.09975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34480',
  },
  {
    city: 'Ocala',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 149.4,
    imprecise: false,
    latitude: 29.11902,
    longitude: -82.30769,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34481',
  },
  {
    city: 'Ocala',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 94.7,
    imprecise: false,
    latitude: 29.24984,
    longitude: -82.27702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34482',
  },
  {
    city: 'Oxford',
    county_fips: 12119,
    county_fips_all: '12119',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"12119": 100}',
    density: 60.6,
    imprecise: false,
    latitude: 28.93417,
    longitude: -82.08867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34484',
  },
  {
    city: 'Homosassa',
    county_fips: 12017,
    county_fips_all: '12017',
    county: 'Citrus',
    county_names_all: 'Citrus',
    county_weights: '{"12017": 100}',
    density: 0,
    imprecise: false,
    latitude: 28.78148,
    longitude: -82.61272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34487',
  },
  {
    city: 'Silver Springs',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 51.6,
    imprecise: false,
    latitude: 29.22584,
    longitude: -81.93226,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34488',
  },
  {
    city: 'Summerfield',
    county_fips: 12083,
    county_fips_all: '12083',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"12083": 100}',
    density: 286.4,
    imprecise: false,
    latitude: 28.99634,
    longitude: -82.04665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34491',
  },
  {
    city: 'Yankeetown',
    county_fips: 12075,
    county_fips_all: '12075',
    county: 'Levy',
    county_names_all: 'Levy',
    county_weights: '{"12075": 100}',
    density: 35.5,
    imprecise: false,
    latitude: 29.03299,
    longitude: -82.734,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34498',
  },
  {
    city: 'Brooksville',
    county_fips: 12053,
    county_fips_all: '12053|12017',
    county: 'Hernando',
    county_names_all: 'Hernando|Citrus',
    county_weights: '{"12053": 99.77, "12017": 0.23}',
    density: 81.7,
    imprecise: false,
    latitude: 28.5892,
    longitude: -82.36857,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34601',
  },
  {
    city: 'Brooksville',
    county_fips: 12053,
    county_fips_all: '12053',
    county: 'Hernando',
    county_names_all: 'Hernando',
    county_weights: '{"12053": 100}',
    density: 64.2,
    imprecise: false,
    latitude: 28.50252,
    longitude: -82.28007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34602',
  },
  {
    city: 'Brooksville',
    county_fips: 12053,
    county_fips_all: '12053',
    county: 'Hernando',
    county_names_all: 'Hernando',
    county_weights: '{"12053": 100}',
    density: 145,
    imprecise: false,
    latitude: 28.4781,
    longitude: -82.43322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34604',
  },
  {
    city: 'Spring Hill',
    county_fips: 12053,
    county_fips_all: '12053',
    county: 'Hernando',
    county_names_all: 'Hernando',
    county_weights: '{"12053": 100}',
    density: 956.8,
    imprecise: false,
    latitude: 28.46961,
    longitude: -82.59759,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34606',
  },
  {
    city: 'Spring Hill',
    county_fips: 12053,
    county_fips_all: '12053',
    county: 'Hernando',
    county_names_all: 'Hernando',
    county_weights: '{"12053": 100}',
    density: 57.5,
    imprecise: false,
    latitude: 28.57528,
    longitude: -82.62715,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34607',
  },
  {
    city: 'Spring Hill',
    county_fips: 12053,
    county_fips_all: '12053',
    county: 'Hernando',
    county_names_all: 'Hernando',
    county_weights: '{"12053": 100}',
    density: 928.9,
    imprecise: false,
    latitude: 28.48258,
    longitude: -82.5532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34608',
  },
  {
    city: 'Spring Hill',
    county_fips: 12053,
    county_fips_all: '12053',
    county: 'Hernando',
    county_names_all: 'Hernando',
    county_weights: '{"12053": 100}',
    density: 822.4,
    imprecise: false,
    latitude: 28.4792,
    longitude: -82.50818,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34609',
  },
  {
    city: 'Spring Hill',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 96.4,
    imprecise: false,
    latitude: 28.38339,
    longitude: -82.50058,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34610',
  },
  {
    city: 'Brooksville',
    county_fips: 12053,
    county_fips_all: '12053',
    county: 'Hernando',
    county_names_all: 'Hernando',
    county_weights: '{"12053": 100}',
    density: 200.9,
    imprecise: false,
    latitude: 28.56183,
    longitude: -82.53803,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34613',
  },
  {
    city: 'Brooksville',
    county_fips: 12053,
    county_fips_all: '12053',
    county: 'Hernando',
    county_names_all: 'Hernando',
    county_weights: '{"12053": 100}',
    density: 76.9,
    imprecise: false,
    latitude: 28.64627,
    longitude: -82.51324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34614',
  },
  {
    city: "Land O'Lakes",
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 340.8,
    imprecise: false,
    latitude: 28.29589,
    longitude: -82.46368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34637',
  },
  {
    city: "Land O'Lakes",
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 314,
    imprecise: false,
    latitude: 28.26035,
    longitude: -82.52036,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34638',
  },
  {
    city: "Land O'Lakes",
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 439.9,
    imprecise: false,
    latitude: 28.24456,
    longitude: -82.42475,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34639',
  },
  {
    city: 'New Port Richey',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 1233.8,
    imprecise: false,
    latitude: 28.2368,
    longitude: -82.73661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34652',
  },
  {
    city: 'New Port Richey',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 1268.7,
    imprecise: false,
    latitude: 28.24266,
    longitude: -82.69308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34653',
  },
  {
    city: 'New Port Richey',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 371.4,
    imprecise: false,
    latitude: 28.29757,
    longitude: -82.62904,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34654',
  },
  {
    city: 'New Port Richey',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 715.1,
    imprecise: false,
    latitude: 28.21201,
    longitude: -82.65516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34655',
  },
  {
    city: 'Nobleton',
    county_fips: 12053,
    county_fips_all: '12053',
    county: 'Hernando',
    county_names_all: 'Hernando',
    county_weights: '{"12053": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 28.62108,
    longitude: -82.26507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34661',
  },
  {
    city: 'Hudson',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 388,
    imprecise: false,
    latitude: 28.38926,
    longitude: -82.65654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34667',
  },
  {
    city: 'Port Richey',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 1230.3,
    imprecise: false,
    latitude: 28.30176,
    longitude: -82.70516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34668',
  },
  {
    city: 'Hudson',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 301.2,
    imprecise: false,
    latitude: 28.3577,
    longitude: -82.61476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34669',
  },
  {
    city: 'Oldsmar',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 694.6,
    imprecise: false,
    latitude: 28.05293,
    longitude: -82.67549,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34677',
  },
  {
    city: 'Aripeka',
    county_fips: 12101,
    county_fips_all: '12101',
    county: 'Pasco',
    county_names_all: 'Pasco',
    county_weights: '{"12101": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 28.42226,
    longitude: -82.67716,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34679',
  },
  {
    city: 'Crystal Beach',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 684.1,
    imprecise: false,
    latitude: 28.0903,
    longitude: -82.77801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34681',
  },
  {
    city: 'Palm Harbor',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1272.5,
    imprecise: false,
    latitude: 28.08626,
    longitude: -82.76025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34683',
  },
  {
    city: 'Palm Harbor',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1549.4,
    imprecise: false,
    latitude: 28.08122,
    longitude: -82.72779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34684',
  },
  {
    city: 'Palm Harbor',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 697.5,
    imprecise: false,
    latitude: 28.09995,
    longitude: -82.68851,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34685',
  },
  {
    city: 'Tarpon Springs',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 207.8,
    imprecise: false,
    latitude: 28.14445,
    longitude: -82.68543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34688',
  },
  {
    city: 'Tarpon Springs',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 999.9,
    imprecise: false,
    latitude: 28.14971,
    longitude: -82.75956,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34689',
  },
  {
    city: 'Holiday',
    county_fips: 12101,
    county_fips_all: '12101|12103',
    county: 'Pasco',
    county_names_all: 'Pasco|Pinellas',
    county_weights: '{"12101": 99.78, "12103": 0.22}',
    density: 1407.8,
    imprecise: false,
    latitude: 28.19228,
    longitude: -82.72726,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34690',
  },
  {
    city: 'Holiday',
    county_fips: 12101,
    county_fips_all: '12101|12103',
    county: 'Pasco',
    county_names_all: 'Pasco|Pinellas',
    county_weights: '{"12101": 99.57, "12103": 0.43}',
    density: 1053.1,
    imprecise: false,
    latitude: 28.19042,
    longitude: -82.76603,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34691',
  },
  {
    city: 'Safety Harbor',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1251.7,
    imprecise: false,
    latitude: 28.00927,
    longitude: -82.69673,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34695',
  },
  {
    city: 'Dunedin',
    county_fips: 12103,
    county_fips_all: '12103',
    county: 'Pinellas',
    county_names_all: 'Pinellas',
    county_weights: '{"12103": 100}',
    density: 1318.2,
    imprecise: false,
    latitude: 28.03204,
    longitude: -82.78433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34698',
  },
  {
    city: 'Astatula',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 58.6,
    imprecise: false,
    latitude: 28.69367,
    longitude: -81.71138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34705',
  },
  {
    city: 'Clermont',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 693.2,
    imprecise: false,
    latitude: 28.52724,
    longitude: -81.75349,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 70317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34711',
  },
  {
    city: 'Clermont',
    county_fips: 12069,
    county_fips_all: '12069|12105',
    county: 'Lake',
    county_names_all: 'Lake|Polk',
    county_weights: '{"12069": 99.61, "12105": 0.39}',
    density: 87.3,
    imprecise: false,
    latitude: 28.40406,
    longitude: -81.80132,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34714',
  },
  {
    city: 'Clermont',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 328.2,
    imprecise: false,
    latitude: 28.6242,
    longitude: -81.73019,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34715',
  },
  {
    city: 'Ferndale',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 0,
    imprecise: false,
    latitude: 28.61764,
    longitude: -81.69901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34729',
  },
  {
    city: 'Fruitland Park',
    county_fips: 12069,
    county_fips_all: '12069|12119',
    county: 'Lake',
    county_names_all: 'Lake|Sumter',
    county_weights: '{"12069": 99.55, "12119": 0.45}',
    density: 297.9,
    imprecise: false,
    latitude: 28.86788,
    longitude: -81.89638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34731',
  },
  {
    city: 'Gotha',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 817.2,
    imprecise: false,
    latitude: 28.5376,
    longitude: -81.52204,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34734',
  },
  {
    city: 'Groveland',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 94,
    imprecise: false,
    latitude: 28.57883,
    longitude: -81.88844,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34736',
  },
  {
    city: 'Howey In The Hills',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 70.3,
    imprecise: false,
    latitude: 28.69638,
    longitude: -81.80243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34737',
  },
  {
    city: 'Kenansville',
    county_fips: 12097,
    county_fips_all: '12097',
    county: 'Osceola',
    county_names_all: 'Osceola',
    county_weights: '{"12097": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 27.92236,
    longitude: -81.10762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34739',
  },
  {
    city: 'Kissimmee',
    county_fips: 12097,
    county_fips_all: '12097',
    county: 'Osceola',
    county_names_all: 'Osceola',
    county_weights: '{"12097": 100}',
    density: 1513.8,
    imprecise: false,
    latitude: 28.30544,
    longitude: -81.42567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34741',
  },
  {
    city: 'Kissimmee',
    county_fips: 12097,
    county_fips_all: '12097',
    county: 'Osceola',
    county_names_all: 'Osceola',
    county_weights: '{"12097": 100}',
    density: 2240.2,
    imprecise: false,
    latitude: 28.33066,
    longitude: -81.35441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34743',
  },
  {
    city: 'Kissimmee',
    county_fips: 12097,
    county_fips_all: '12097',
    county: 'Osceola',
    county_names_all: 'Osceola',
    county_weights: '{"12097": 100}',
    density: 773,
    imprecise: false,
    latitude: 28.2954,
    longitude: -81.34675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34744',
  },
  {
    city: 'Kissimmee',
    county_fips: 12097,
    county_fips_all: '12097',
    county: 'Osceola',
    county_names_all: 'Osceola',
    county_weights: '{"12097": 100}',
    density: 531.3,
    imprecise: false,
    latitude: 28.24233,
    longitude: -81.4423,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34746',
  },
  {
    city: 'Kissimmee',
    county_fips: 12097,
    county_fips_all: '12097|12095',
    county: 'Osceola',
    county_names_all: 'Osceola|Orange',
    county_weights: '{"12097": 94.75, "12095": 5.25}',
    density: 274.4,
    imprecise: false,
    latitude: 28.31111,
    longitude: -81.59107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34747',
  },
  {
    city: 'Leesburg',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 470.9,
    imprecise: false,
    latitude: 28.77366,
    longitude: -81.88552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34748',
  },
  {
    city: 'Mascotte',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 653.1,
    imprecise: false,
    latitude: 28.58684,
    longitude: -81.89624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34753',
  },
  {
    city: 'Montverde',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 207,
    imprecise: false,
    latitude: 28.58651,
    longitude: -81.68214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34756',
  },
  {
    city: 'Kissimmee',
    county_fips: 12097,
    county_fips_all: '12097',
    county: 'Osceola',
    county_names_all: 'Osceola',
    county_weights: '{"12097": 100}',
    density: 692.5,
    imprecise: false,
    latitude: 28.19142,
    longitude: -81.4871,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34758',
  },
  {
    city: 'Kissimmee',
    county_fips: 12105,
    county_fips_all: '12105|12097',
    county: 'Polk',
    county_names_all: 'Polk|Osceola',
    county_weights: '{"12105": 64.62, "12097": 35.38}',
    density: 228.2,
    imprecise: false,
    latitude: 28.09113,
    longitude: -81.43774,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34759',
  },
  {
    city: 'Oakland',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 510.3,
    imprecise: false,
    latitude: 28.55694,
    longitude: -81.62916,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34760',
  },
  {
    city: 'Ocoee',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 1046.7,
    imprecise: false,
    latitude: 28.57975,
    longitude: -81.53386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34761',
  },
  {
    city: 'The Villages',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 56.4,
    imprecise: false,
    latitude: 28.75772,
    longitude: -81.9152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34762',
  },
  {
    city: 'Saint Cloud',
    county_fips: 12097,
    county_fips_all: '12097',
    county: 'Osceola',
    county_names_all: 'Osceola',
    county_weights: '{"12097": 100}',
    density: 1102.3,
    imprecise: false,
    latitude: 28.24366,
    longitude: -81.29412,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34769',
  },
  {
    city: 'Saint Cloud',
    county_fips: 12097,
    county_fips_all: '12097',
    county: 'Osceola',
    county_names_all: 'Osceola',
    county_weights: '{"12097": 100}',
    density: 88.1,
    imprecise: false,
    latitude: 28.26647,
    longitude: -81.11908,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34771',
  },
  {
    city: 'Saint Cloud',
    county_fips: 12097,
    county_fips_all: '12097',
    county: 'Osceola',
    county_names_all: 'Osceola',
    county_weights: '{"12097": 100}',
    density: 157.3,
    imprecise: false,
    latitude: 28.16534,
    longitude: -81.27273,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34772',
  },
  {
    city: 'Saint Cloud',
    county_fips: 12097,
    county_fips_all: '12097',
    county: 'Osceola',
    county_names_all: 'Osceola',
    county_weights: '{"12097": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 28.14695,
    longitude: -80.99968,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34773',
  },
  {
    city: 'Wildwood',
    county_fips: 12119,
    county_fips_all: '12119',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"12119": 100}',
    density: 129.8,
    imprecise: false,
    latitude: 28.84516,
    longitude: -82.06065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34785',
  },
  {
    city: 'Windermere',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 824.4,
    imprecise: false,
    latitude: 28.48161,
    longitude: -81.55501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34786',
  },
  {
    city: 'Winter Garden',
    county_fips: 12095,
    county_fips_all: '12095|12069',
    county: 'Orange',
    county_names_all: 'Orange|Lake',
    county_weights: '{"12095": 83.13, "12069": 16.87}',
    density: 582.4,
    imprecise: false,
    latitude: 28.48309,
    longitude: -81.62833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 101441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34787',
  },
  {
    city: 'Leesburg',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 236.4,
    imprecise: false,
    latitude: 28.88542,
    longitude: -81.79678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34788',
  },
  {
    city: 'Yalaha',
    county_fips: 12069,
    county_fips_all: '12069',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"12069": 100}',
    density: 100.8,
    imprecise: false,
    latitude: 28.73517,
    longitude: -81.81813,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34797',
  },
  {
    city: 'Fort Pierce',
    county_fips: 12111,
    county_fips_all: '12111',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie',
    county_weights: '{"12111": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 27.45219,
    longitude: -80.55213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34945',
  },
  {
    city: 'Fort Pierce',
    county_fips: 12111,
    county_fips_all: '12111',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie',
    county_weights: '{"12111": 100}',
    density: 173.8,
    imprecise: false,
    latitude: 27.50456,
    longitude: -80.36106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34946',
  },
  {
    city: 'Fort Pierce',
    county_fips: 12111,
    county_fips_all: '12111',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie',
    county_weights: '{"12111": 100}',
    density: 509.3,
    imprecise: false,
    latitude: 27.44903,
    longitude: -80.37633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34947',
  },
  {
    city: 'Fort Pierce',
    county_fips: 12111,
    county_fips_all: '12111',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie',
    county_weights: '{"12111": 100}',
    density: 307.2,
    imprecise: false,
    latitude: 27.4668,
    longitude: -80.30417,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34949',
  },
  {
    city: 'Fort Pierce',
    county_fips: 12111,
    county_fips_all: '12111',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie',
    county_weights: '{"12111": 100}',
    density: 1304.9,
    imprecise: false,
    latitude: 27.44341,
    longitude: -80.32969,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34950',
  },
  {
    city: 'Fort Pierce',
    county_fips: 12111,
    county_fips_all: '12111',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie',
    county_weights: '{"12111": 100}',
    density: 272.1,
    imprecise: false,
    latitude: 27.52268,
    longitude: -80.41783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34951',
  },
  {
    city: 'Port Saint Lucie',
    county_fips: 12111,
    county_fips_all: '12111',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie',
    county_weights: '{"12111": 100}',
    density: 668.6,
    imprecise: false,
    latitude: 27.2969,
    longitude: -80.29748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34952',
  },
  {
    city: 'Port Saint Lucie',
    county_fips: 12111,
    county_fips_all: '12111',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie',
    county_weights: '{"12111": 100}',
    density: 1407.8,
    imprecise: false,
    latitude: 27.24938,
    longitude: -80.38137,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 86875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34953',
  },
  {
    city: 'Indiantown',
    county_fips: 12085,
    county_fips_all: '12085',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"12085": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 27.07969,
    longitude: -80.50074,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34956',
  },
  {
    city: 'Jensen Beach',
    county_fips: 12111,
    county_fips_all: '12111|12085',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie|Martin',
    county_weights: '{"12111": 57.69, "12085": 42.31}',
    density: 553.7,
    imprecise: false,
    latitude: 27.28399,
    longitude: -80.24252,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34957',
  },
  {
    city: 'Okeechobee',
    county_fips: 12093,
    county_fips_all: '12093|12097|12111',
    county: 'Okeechobee',
    county_names_all: 'Okeechobee|Osceola|St. Lucie',
    county_weights: '{"12093": 79.8, "12097": 14.45, "12111": 5.75}',
    density: 9.1,
    imprecise: false,
    latitude: 27.48016,
    longitude: -80.90926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34972',
  },
  {
    city: 'Okeechobee',
    county_fips: 12043,
    county_fips_all: '12043|12093|12085|12055',
    county: 'Glades',
    county_names_all: 'Glades|Okeechobee|Martin|Highlands',
    county_weights:
      '{"12043": 52.13, "12093": 22.42, "12085": 15.53, "12055": 9.92}',
    density: 24.6,
    imprecise: false,
    latitude: 27.15062,
    longitude: -80.91371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34974',
  },
  {
    city: 'Fort Pierce',
    county_fips: 12111,
    county_fips_all: '12111',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie',
    county_weights: '{"12111": 100}',
    density: 180.5,
    imprecise: false,
    latitude: 27.39329,
    longitude: -80.37163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34981',
  },
  {
    city: 'Fort Pierce',
    county_fips: 12111,
    county_fips_all: '12111',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie',
    county_weights: '{"12111": 100}',
    density: 775.7,
    imprecise: false,
    latitude: 27.37669,
    longitude: -80.31082,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34982',
  },
  {
    city: 'Port Saint Lucie',
    county_fips: 12111,
    county_fips_all: '12111',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie',
    county_weights: '{"12111": 100}',
    density: 1267.1,
    imprecise: false,
    latitude: 27.32295,
    longitude: -80.35052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34983',
  },
  {
    city: 'Port Saint Lucie',
    county_fips: 12111,
    county_fips_all: '12111',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie',
    county_weights: '{"12111": 100}',
    density: 794.2,
    imprecise: false,
    latitude: 27.24784,
    longitude: -80.33456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34984',
  },
  {
    city: 'Port Saint Lucie',
    county_fips: 12111,
    county_fips_all: '12111',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie',
    county_weights: '{"12111": 100}',
    density: 631.7,
    imprecise: false,
    latitude: 27.32804,
    longitude: -80.40524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34986',
  },
  {
    city: 'Port Saint Lucie',
    county_fips: 12111,
    county_fips_all: '12111',
    county: 'St. Lucie',
    county_names_all: 'St. Lucie',
    county_weights: '{"12111": 100}',
    density: 73.3,
    imprecise: false,
    latitude: 27.28637,
    longitude: -80.50953,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34987',
  },
  {
    city: 'Palm City',
    county_fips: 12085,
    county_fips_all: '12085|12111',
    county: 'Martin',
    county_names_all: 'Martin|St. Lucie',
    county_weights: '{"12085": 97.47, "12111": 2.53}',
    density: 114.6,
    imprecise: false,
    latitude: 27.13623,
    longitude: -80.35655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34990',
  },
  {
    city: 'Stuart',
    county_fips: 12085,
    county_fips_all: '12085',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"12085": 100}',
    density: 1073.7,
    imprecise: false,
    latitude: 27.19954,
    longitude: -80.2557,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34994',
  },
  {
    city: 'Stuart',
    county_fips: 12085,
    county_fips_all: '12085',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"12085": 100}',
    density: 612.6,
    imprecise: false,
    latitude: 27.20071,
    longitude: -80.19644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34996',
  },
  {
    city: 'Stuart',
    county_fips: 12085,
    county_fips_all: '12085',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"12085": 100}',
    density: 200.4,
    imprecise: false,
    latitude: 27.05085,
    longitude: -80.27268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '34997',
  },
  {
    city: 'Moody',
    county_fips: 1115,
    county_fips_all: '01115',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"01115": 100}',
    density: 272.2,
    imprecise: false,
    latitude: 33.60369,
    longitude: -86.49333,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35004',
  },
  {
    city: 'Adamsville',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 100.3,
    imprecise: false,
    latitude: 33.59215,
    longitude: -86.99833,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35005',
  },
  {
    city: 'Adger',
    county_fips: 1073,
    county_fips_all: '01073|01127|01125',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Walker|Tuscaloosa',
    county_weights: '{"01073": 95.12, "01127": 2.88, "01125": 2.0}',
    density: 14.5,
    imprecise: false,
    latitude: 33.43159,
    longitude: -87.19961,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35006',
  },
  {
    city: 'Alabaster',
    county_fips: 1117,
    county_fips_all: '01117',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"01117": 100}',
    density: 282.7,
    imprecise: false,
    latitude: 33.21751,
    longitude: -86.79307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35007',
  },
  {
    city: 'Alexander City',
    county_fips: 1123,
    county_fips_all: '01123|01037|01051',
    county: 'Tallapoosa',
    county_names_all: 'Tallapoosa|Coosa|Elmore',
    county_weights: '{"01123": 75.52, "01037": 18.24, "01051": 6.24}',
    density: 33.5,
    imprecise: false,
    latitude: 32.91433,
    longitude: -85.93816,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35010',
  },
  {
    city: 'Allgood',
    county_fips: 1009,
    county_fips_all: '01009',
    county: 'Blount',
    county_names_all: 'Blount',
    county_weights: '{"01009": 100}',
    density: 1935.2,
    imprecise: false,
    latitude: 33.90166,
    longitude: -86.51785,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35013',
  },
  {
    city: 'Alpine',
    county_fips: 1121,
    county_fips_all: '01121',
    county: 'Talladega',
    county_names_all: 'Talladega',
    county_weights: '{"01121": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 33.36097,
    longitude: -86.25909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35014',
  },
  {
    city: 'Arab',
    county_fips: 1095,
    county_fips_all: '01095|01043|01009|01103',
    county: 'Marshall',
    county_names_all: 'Marshall|Cullman|Blount|Morgan',
    county_weights:
      '{"01095": 68.68, "01043": 21.19, "01009": 5.6, "01103": 4.53}',
    density: 83.9,
    imprecise: false,
    latitude: 34.32545,
    longitude: -86.5033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35016',
  },
  {
    city: 'Baileyton',
    county_fips: 1043,
    county_fips_all: '01043|01103',
    county: 'Cullman',
    county_names_all: 'Cullman|Morgan',
    county_weights: '{"01043": 63.28, "01103": 36.72}',
    density: 30,
    imprecise: false,
    latitude: 34.29828,
    longitude: -86.63496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35019',
  },
  {
    city: 'Bessemer',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 580.5,
    imprecise: false,
    latitude: 33.40502,
    longitude: -86.95436,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35020',
  },
  {
    city: 'Bessemer',
    county_fips: 1073,
    county_fips_all: '01073|01117',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Shelby',
    county_weights: '{"01073": 93.68, "01117": 6.32}',
    density: 139.2,
    imprecise: false,
    latitude: 33.33107,
    longitude: -86.95959,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35022',
  },
  {
    city: 'Bessemer',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 107.5,
    imprecise: false,
    latitude: 33.46674,
    longitude: -87.08891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35023',
  },
  {
    city: 'Blountsville',
    county_fips: 1009,
    county_fips_all: '01009',
    county: 'Blount',
    county_names_all: 'Blount',
    county_weights: '{"01009": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 34.10256,
    longitude: -86.5455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35031',
  },
  {
    city: 'Bon Air',
    county_fips: 1121,
    county_fips_all: '01121',
    county: 'Talladega',
    county_names_all: 'Talladega',
    county_weights: '{"01121": 100}',
    density: 627.1,
    imprecise: false,
    latitude: 33.26321,
    longitude: -86.33408,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35032',
  },
  {
    city: 'Bremen',
    county_fips: 1043,
    county_fips_all: '01043|01127',
    county: 'Cullman',
    county_names_all: 'Cullman|Walker',
    county_weights: '{"01043": 88.17, "01127": 11.83}',
    density: 20.4,
    imprecise: false,
    latitude: 33.94517,
    longitude: -87.02904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35033',
  },
  {
    city: 'Brent',
    county_fips: 1007,
    county_fips_all: '01007|01105',
    county: 'Bibb',
    county_names_all: 'Bibb|Perry',
    county_weights: '{"01007": 88.32, "01105": 11.68}',
    density: 17.9,
    imprecise: false,
    latitude: 32.9016,
    longitude: -87.26948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35034',
  },
  {
    city: 'Brierfield',
    county_fips: 1007,
    county_fips_all: '01007|01117',
    county: 'Bibb',
    county_names_all: 'Bibb|Shelby',
    county_weights: '{"01007": 94.43, "01117": 5.57}',
    density: 7.6,
    imprecise: false,
    latitude: 33.04423,
    longitude: -86.97149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35035',
  },
  {
    city: 'Brookside',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 1439,
    imprecise: false,
    latitude: 33.64095,
    longitude: -86.91601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35036',
  },
  {
    city: 'Calera',
    county_fips: 1117,
    county_fips_all: '01117|01021',
    county: 'Shelby',
    county_names_all: 'Shelby|Chilton',
    county_weights: '{"01117": 83.29, "01021": 16.71}',
    density: 95.6,
    imprecise: false,
    latitude: 33.10487,
    longitude: -86.72958,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35040',
  },
  {
    city: 'Centreville',
    county_fips: 1007,
    county_fips_all: '01007|01105',
    county: 'Bibb',
    county_names_all: 'Bibb|Perry',
    county_weights: '{"01007": 83.0, "01105": 17.0}',
    density: 11.9,
    imprecise: false,
    latitude: 32.93297,
    longitude: -87.12542,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35042',
  },
  {
    city: 'Chelsea',
    county_fips: 1117,
    county_fips_all: '01117',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"01117": 100}',
    density: 132.4,
    imprecise: false,
    latitude: 33.30926,
    longitude: -86.66028,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35043',
  },
  {
    city: 'Childersburg',
    county_fips: 1121,
    county_fips_all: '01121',
    county: 'Talladega',
    county_names_all: 'Talladega',
    county_weights: '{"01121": 100}',
    density: 42.1,
    imprecise: false,
    latitude: 33.26859,
    longitude: -86.36324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35044',
  },
  {
    city: 'Clanton',
    county_fips: 1021,
    county_fips_all: '01021',
    county: 'Chilton',
    county_names_all: 'Chilton',
    county_weights: '{"01021": 100}',
    density: 52.4,
    imprecise: false,
    latitude: 32.81127,
    longitude: -86.67249,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35045',
  },
  {
    city: 'Clanton',
    county_fips: 1021,
    county_fips_all: '01021|01037',
    county: 'Chilton',
    county_names_all: 'Chilton|Coosa',
    county_weights: '{"01021": 76.96, "01037": 23.04}',
    density: 14.6,
    imprecise: false,
    latitude: 32.923,
    longitude: -86.54127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35046',
  },
  {
    city: 'Cleveland',
    county_fips: 1009,
    county_fips_all: '01009',
    county: 'Blount',
    county_names_all: 'Blount',
    county_weights: '{"01009": 100}',
    density: 37.3,
    imprecise: false,
    latitude: 33.95674,
    longitude: -86.59904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35049',
  },
  {
    city: 'Columbiana',
    county_fips: 1117,
    county_fips_all: '01117',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"01117": 100}',
    density: 37.4,
    imprecise: false,
    latitude: 33.20457,
    longitude: -86.61523,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35051',
  },
  {
    city: 'Crane Hill',
    county_fips: 1043,
    county_fips_all: '01043|01133',
    county: 'Cullman',
    county_names_all: 'Cullman|Winston',
    county_weights: '{"01043": 90.97, "01133": 9.03}',
    density: 25.2,
    imprecise: false,
    latitude: 34.05495,
    longitude: -87.06527,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35053',
  },
  {
    city: 'Cropwell',
    county_fips: 1115,
    county_fips_all: '01115',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"01115": 100}',
    density: 78.5,
    imprecise: false,
    latitude: 33.50417,
    longitude: -86.32693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35054',
  },
  {
    city: 'Cullman',
    county_fips: 1043,
    county_fips_all: '01043',
    county: 'Cullman',
    county_names_all: 'Cullman',
    county_weights: '{"01043": 100}',
    density: 139.9,
    imprecise: false,
    latitude: 34.1542,
    longitude: -86.75932,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35055',
  },
  {
    city: 'Cullman',
    county_fips: 1043,
    county_fips_all: '01043',
    county: 'Cullman',
    county_names_all: 'Cullman',
    county_weights: '{"01043": 100}',
    density: 44.5,
    imprecise: false,
    latitude: 34.13788,
    longitude: -86.95876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35057',
  },
  {
    city: 'Cullman',
    county_fips: 1043,
    county_fips_all: '01043',
    county: 'Cullman',
    county_names_all: 'Cullman',
    county_weights: '{"01043": 100}',
    density: 59.3,
    imprecise: false,
    latitude: 34.23082,
    longitude: -86.73265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35058',
  },
  {
    city: 'Docena',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 177.8,
    imprecise: false,
    latitude: 33.55768,
    longitude: -86.92822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35060',
  },
  {
    city: 'Dolomite',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 157.8,
    imprecise: false,
    latitude: 33.47529,
    longitude: -86.9469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35061',
  },
  {
    city: 'Dora',
    county_fips: 1073,
    county_fips_all: '01073|01127',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Walker',
    county_weights: '{"01073": 65.13, "01127": 34.87}',
    density: 72.8,
    imprecise: false,
    latitude: 33.72862,
    longitude: -87.02775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35062',
  },
  {
    city: 'Empire',
    county_fips: 1127,
    county_fips_all: '01127|01009|01073',
    county: 'Walker',
    county_names_all: 'Walker|Blount|Jefferson',
    county_weights: '{"01127": 87.64, "01009": 9.19, "01073": 3.17}',
    density: 34.7,
    imprecise: false,
    latitude: 33.8221,
    longitude: -87.00765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35063',
  },
  {
    city: 'Fairfield',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 1061.1,
    imprecise: false,
    latitude: 33.47474,
    longitude: -86.91964,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35064',
  },
  {
    city: 'Fultondale',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 264.1,
    imprecise: false,
    latitude: 33.60933,
    longitude: -86.83174,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35068',
  },
  {
    city: 'Garden City',
    county_fips: 1043,
    county_fips_all: '01043',
    county: 'Cullman',
    county_names_all: 'Cullman',
    county_weights: '{"01043": 100}',
    density: 267.6,
    imprecise: false,
    latitude: 34.01394,
    longitude: -86.74443,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35070',
  },
  {
    city: 'Gardendale',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 115.7,
    imprecise: false,
    latitude: 33.70376,
    longitude: -86.84286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35071',
  },
  {
    city: 'Goodwater',
    county_fips: 1037,
    county_fips_all: '01037|01027|01123|01121',
    county: 'Coosa',
    county_names_all: 'Coosa|Clay|Tallapoosa|Talladega',
    county_weights:
      '{"01037": 46.66, "01027": 42.07, "01123": 11.11, "01121": 0.16}',
    density: 10.3,
    imprecise: false,
    latitude: 33.08985,
    longitude: -86.06057,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35072',
  },
  {
    city: 'Graysville',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 39.7,
    imprecise: false,
    latitude: 33.65377,
    longitude: -86.98051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35073',
  },
  {
    city: 'Green Pond',
    county_fips: 1007,
    county_fips_all: '01007',
    county: 'Bibb',
    county_names_all: 'Bibb',
    county_weights: '{"01007": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.22235,
    longitude: -87.12415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35074',
  },
  {
    city: 'Hanceville',
    county_fips: 1043,
    county_fips_all: '01043',
    county: 'Cullman',
    county_names_all: 'Cullman',
    county_weights: '{"01043": 100}',
    density: 33.7,
    imprecise: false,
    latitude: 34.01984,
    longitude: -86.83108,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35077',
  },
  {
    city: 'Harpersville',
    county_fips: 1117,
    county_fips_all: '01117',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"01117": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 33.32279,
    longitude: -86.44116,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35078',
  },
  {
    city: 'Hayden',
    county_fips: 1009,
    county_fips_all: '01009',
    county: 'Blount',
    county_names_all: 'Blount',
    county_weights: '{"01009": 100}',
    density: 35.5,
    imprecise: false,
    latitude: 33.94118,
    longitude: -86.75261,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35079',
  },
  {
    city: 'Helena',
    county_fips: 1117,
    county_fips_all: '01117|01073',
    county: 'Shelby',
    county_names_all: 'Shelby|Jefferson',
    county_weights: '{"01117": 99.51, "01073": 0.49}',
    density: 169.4,
    imprecise: false,
    latitude: 33.25508,
    longitude: -86.91894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35080',
  },
  {
    city: 'Hollins',
    county_fips: 1027,
    county_fips_all: '01027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"01027": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.1563,
    longitude: -86.15456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35082',
  },
  {
    city: 'Holly Pond',
    county_fips: 1043,
    county_fips_all: '01043',
    county: 'Cullman',
    county_names_all: 'Cullman',
    county_weights: '{"01043": 100}',
    density: 55.7,
    imprecise: false,
    latitude: 34.19718,
    longitude: -86.5931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35083',
  },
  {
    city: 'Jemison',
    county_fips: 1021,
    county_fips_all: '01021',
    county: 'Chilton',
    county_names_all: 'Chilton',
    county_weights: '{"01021": 100}',
    density: 32.2,
    imprecise: false,
    latitude: 32.97975,
    longitude: -86.73584,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35085',
  },
  {
    city: 'Joppa',
    county_fips: 1043,
    county_fips_all: '01043|01103|01095',
    county: 'Cullman',
    county_names_all: 'Cullman|Morgan|Marshall',
    county_weights: '{"01043": 48.41, "01103": 38.46, "01095": 13.12}',
    density: 38.5,
    imprecise: false,
    latitude: 34.30556,
    longitude: -86.58252,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35087',
  },
  {
    city: 'Kellyton',
    county_fips: 1037,
    county_fips_all: '01037|01123',
    county: 'Coosa',
    county_names_all: 'Coosa|Tallapoosa',
    county_weights: '{"01037": 81.8, "01123": 18.2}',
    density: 11.9,
    imprecise: false,
    latitude: 32.9426,
    longitude: -86.07457,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35089',
  },
  {
    city: 'Kimberly',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 188.3,
    imprecise: false,
    latitude: 33.78344,
    longitude: -86.78963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35091',
  },
  {
    city: 'Leeds',
    county_fips: 1073,
    county_fips_all: '01073|01117|01115',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Shelby|St. Clair',
    county_weights: '{"01073": 52.07, "01117": 33.26, "01115": 14.67}',
    density: 97.6,
    imprecise: false,
    latitude: 33.52057,
    longitude: -86.56127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35094',
  },
  {
    city: 'Lincoln',
    county_fips: 1121,
    county_fips_all: '01121|01015',
    county: 'Talladega',
    county_names_all: 'Talladega|Calhoun',
    county_weights: '{"01121": 89.25, "01015": 10.75}',
    density: 46.2,
    imprecise: false,
    latitude: 33.62141,
    longitude: -86.10849,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35096',
  },
  {
    city: 'Locust Fork',
    county_fips: 1009,
    county_fips_all: '01009',
    county: 'Blount',
    county_names_all: 'Blount',
    county_weights: '{"01009": 100}',
    density: 90.9,
    imprecise: false,
    latitude: 33.89871,
    longitude: -86.62526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35097',
  },
  {
    city: 'Logan',
    county_fips: 1043,
    county_fips_all: '01043|01133',
    county: 'Cullman',
    county_names_all: 'Cullman|Winston',
    county_weights: '{"01043": 83.32, "01133": 16.68}',
    density: 18.1,
    imprecise: false,
    latitude: 34.12779,
    longitude: -87.04626,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35098',
  },
  {
    city: 'McCalla',
    county_fips: 1073,
    county_fips_all: '01073|01125|01007',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Tuscaloosa|Bibb',
    county_weights: '{"01073": 54.26, "01125": 42.85, "01007": 2.89}',
    density: 126.6,
    imprecise: false,
    latitude: 33.28309,
    longitude: -87.09002,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35111',
  },
  {
    city: 'Margaret',
    county_fips: 1115,
    county_fips_all: '01115',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"01115": 100}',
    density: 43.2,
    imprecise: false,
    latitude: 33.69374,
    longitude: -86.47248,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35112',
  },
  {
    city: 'Alabaster',
    county_fips: 1117,
    county_fips_all: '01117',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"01117": 100}',
    density: 288.7,
    imprecise: false,
    latitude: 33.22274,
    longitude: -86.86739,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35114',
  },
  {
    city: 'Montevallo',
    county_fips: 1117,
    county_fips_all: '01117|01021|01007',
    county: 'Shelby',
    county_names_all: 'Shelby|Chilton|Bibb',
    county_weights: '{"01117": 70.19, "01021": 18.04, "01007": 11.77}',
    density: 55.1,
    imprecise: false,
    latitude: 33.12133,
    longitude: -86.89605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35115',
  },
  {
    city: 'Morris',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 89.6,
    imprecise: false,
    latitude: 33.73167,
    longitude: -86.76819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35116',
  },
  {
    city: 'Mount Olive',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 74.3,
    imprecise: false,
    latitude: 33.67085,
    longitude: -86.89678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35117',
  },
  {
    city: 'Mulga',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 31.6,
    imprecise: false,
    latitude: 33.53916,
    longitude: -87.05212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35118',
  },
  {
    city: 'New Castle',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.63809,
    longitude: -86.77864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35119',
  },
  {
    city: 'Odenville',
    county_fips: 1115,
    county_fips_all: '01115',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"01115": 100}',
    density: 96.7,
    imprecise: false,
    latitude: 33.66777,
    longitude: -86.42064,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35120',
  },
  {
    city: 'Oneonta',
    county_fips: 1009,
    county_fips_all: '01009|01115|01055',
    county: 'Blount',
    county_names_all: 'Blount|St. Clair|Etowah',
    county_weights: '{"01009": 97.13, "01115": 2.11, "01055": 0.76}',
    density: 43.2,
    imprecise: false,
    latitude: 33.9397,
    longitude: -86.454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35121',
  },
  {
    city: 'Pelham',
    county_fips: 1117,
    county_fips_all: '01117',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"01117": 100}',
    density: 228.5,
    imprecise: false,
    latitude: 33.31368,
    longitude: -86.76194,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35124',
  },
  {
    city: 'Pell City',
    county_fips: 1115,
    county_fips_all: '01115',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"01115": 100}',
    density: 91.9,
    imprecise: false,
    latitude: 33.62567,
    longitude: -86.29594,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35125',
  },
  {
    city: 'Pinson',
    county_fips: 1073,
    county_fips_all: '01073|01009',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Blount',
    county_weights: '{"01073": 96.58, "01009": 3.42}',
    density: 145.1,
    imprecise: false,
    latitude: 33.73071,
    longitude: -86.65385,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35126',
  },
  {
    city: 'Pleasant Grove',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 359.9,
    imprecise: false,
    latitude: 33.49118,
    longitude: -86.97581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35127',
  },
  {
    city: 'Pell City',
    county_fips: 1115,
    county_fips_all: '01115|01117',
    county: 'St. Clair',
    county_names_all: 'St. Clair|Shelby',
    county_weights: '{"01115": 98.19, "01117": 1.81}',
    density: 58.4,
    imprecise: false,
    latitude: 33.54738,
    longitude: -86.34596,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35128',
  },
  {
    city: 'Quinton',
    county_fips: 1127,
    county_fips_all: '01127|01073',
    county: 'Walker',
    county_names_all: 'Walker|Jefferson',
    county_weights: '{"01127": 56.03, "01073": 43.97}',
    density: 18.4,
    imprecise: false,
    latitude: 33.63235,
    longitude: -87.13313,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35130',
  },
  {
    city: 'Ragland',
    county_fips: 1115,
    county_fips_all: '01115',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"01115": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 33.72062,
    longitude: -86.19965,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35131',
  },
  {
    city: 'Remlap',
    county_fips: 1009,
    county_fips_all: '01009|01115',
    county: 'Blount',
    county_names_all: 'Blount|St. Clair',
    county_weights: '{"01009": 92.32, "01115": 7.68}',
    density: 25.1,
    imprecise: false,
    latitude: 33.81969,
    longitude: -86.59878,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35133',
  },
  {
    city: 'Riverside',
    county_fips: 1115,
    county_fips_all: '01115',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"01115": 100}',
    density: 92.7,
    imprecise: false,
    latitude: 33.61814,
    longitude: -86.1991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35135',
  },
  {
    city: 'Rockford',
    county_fips: 1037,
    county_fips_all: '01037',
    county: 'Coosa',
    county_names_all: 'Coosa',
    county_weights: '{"01037": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 32.87877,
    longitude: -86.28965,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35136',
  },
  {
    city: 'Shelby',
    county_fips: 1117,
    county_fips_all: '01117',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"01117": 100}',
    density: 27.8,
    imprecise: false,
    latitude: 33.08797,
    longitude: -86.55369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35143',
  },
  {
    city: 'Springville',
    county_fips: 1115,
    county_fips_all: '01115|01009|01073',
    county: 'St. Clair',
    county_names_all: 'St. Clair|Blount|Jefferson',
    county_weights: '{"01115": 81.16, "01009": 16.17, "01073": 2.67}',
    density: 52.3,
    imprecise: false,
    latitude: 33.79275,
    longitude: -86.43258,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35146',
  },
  {
    city: 'Sterrett',
    county_fips: 1117,
    county_fips_all: '01117',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"01117": 100}',
    density: 38.8,
    imprecise: false,
    latitude: 33.41233,
    longitude: -86.53164,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35147',
  },
  {
    city: 'Sumiton',
    county_fips: 1127,
    county_fips_all: '01127|01073',
    county: 'Walker',
    county_names_all: 'Walker|Jefferson',
    county_weights: '{"01127": 97.98, "01073": 2.02}',
    density: 139.2,
    imprecise: false,
    latitude: 33.75643,
    longitude: -87.04556,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35148',
  },
  {
    city: 'Sycamore',
    county_fips: 1121,
    county_fips_all: '01121',
    county: 'Talladega',
    county_names_all: 'Talladega',
    county_weights: '{"01121": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.24378,
    longitude: -86.20709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35149',
  },
  {
    city: 'Sylacauga',
    county_fips: 1121,
    county_fips_all: '01121|01037|01027',
    county: 'Talladega',
    county_names_all: 'Talladega|Coosa|Clay',
    county_weights: '{"01121": 97.31, "01037": 2.28, "01027": 0.41}',
    density: 109.4,
    imprecise: false,
    latitude: 33.18581,
    longitude: -86.24454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35150',
  },
  {
    city: 'Sylacauga',
    county_fips: 1121,
    county_fips_all: '01121|01037',
    county: 'Talladega',
    county_names_all: 'Talladega|Coosa',
    county_weights: '{"01121": 52.07, "01037": 47.93}',
    density: 19.5,
    imprecise: false,
    latitude: 33.108,
    longitude: -86.36704,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35151',
  },
  {
    city: 'Talladega',
    county_fips: 1121,
    county_fips_all: '01121|01027',
    county: 'Talladega',
    county_names_all: 'Talladega|Clay',
    county_weights: '{"01121": 77.56, "01027": 22.44}',
    density: 30.2,
    imprecise: false,
    latitude: 33.36898,
    longitude: -86.1005,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35160',
  },
  {
    city: 'Thorsby',
    county_fips: 1021,
    county_fips_all: '01021',
    county: 'Chilton',
    county_names_all: 'Chilton',
    county_weights: '{"01021": 100}',
    density: 40.5,
    imprecise: false,
    latitude: 32.87823,
    longitude: -86.74636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35171',
  },
  {
    city: 'Trafford',
    county_fips: 1009,
    county_fips_all: '01009|01073',
    county: 'Blount',
    county_names_all: 'Blount|Jefferson',
    county_weights: '{"01009": 81.15, "01073": 18.85}',
    density: 35.5,
    imprecise: false,
    latitude: 33.84389,
    longitude: -86.69788,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35172',
  },
  {
    city: 'Trussville',
    county_fips: 1073,
    county_fips_all: '01073|01115',
    county: 'Jefferson',
    county_names_all: 'Jefferson|St. Clair',
    county_weights: '{"01073": 76.14, "01115": 23.86}',
    density: 189.1,
    imprecise: false,
    latitude: 33.65284,
    longitude: -86.56337,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35173',
  },
  {
    city: 'Union Grove',
    county_fips: 1095,
    county_fips_all: '01095|01103',
    county: 'Marshall',
    county_names_all: 'Marshall|Morgan',
    county_weights: '{"01095": 82.62, "01103": 17.38}',
    density: 29.6,
    imprecise: false,
    latitude: 34.43731,
    longitude: -86.51673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35175',
  },
  {
    city: 'Vandiver',
    county_fips: 1117,
    county_fips_all: '01117',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"01117": 100}',
    density: 30.8,
    imprecise: false,
    latitude: 33.4817,
    longitude: -86.50221,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35176',
  },
  {
    city: 'Vincent',
    county_fips: 1117,
    county_fips_all: '01117|01115',
    county: 'Shelby',
    county_names_all: 'Shelby|St. Clair',
    county_weights: '{"01117": 78.69, "01115": 21.31}',
    density: 20.6,
    imprecise: false,
    latitude: 33.42003,
    longitude: -86.39993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35178',
  },
  {
    city: 'Vinemont',
    county_fips: 1043,
    county_fips_all: '01043|01133|01103',
    county: 'Cullman',
    county_names_all: 'Cullman|Winston|Morgan',
    county_weights: '{"01043": 91.05, "01133": 4.55, "01103": 4.4}',
    density: 37.6,
    imprecise: false,
    latitude: 34.27004,
    longitude: -86.96847,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35179',
  },
  {
    city: 'Warrior',
    county_fips: 1073,
    county_fips_all: '01073|01009',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Blount',
    county_weights: '{"01073": 63.53, "01009": 36.47}',
    density: 58.7,
    imprecise: false,
    latitude: 33.82388,
    longitude: -86.83987,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35180',
  },
  {
    city: 'Watson',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 962.3,
    imprecise: false,
    latitude: 33.62647,
    longitude: -86.87999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 98,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35181',
  },
  {
    city: 'Weogufka',
    county_fips: 1037,
    county_fips_all: '01037',
    county: 'Coosa',
    county_names_all: 'Coosa',
    county_weights: '{"01037": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 33.00675,
    longitude: -86.35706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35183',
  },
  {
    city: 'West Blocton',
    county_fips: 1007,
    county_fips_all: '01007|01125',
    county: 'Bibb',
    county_names_all: 'Bibb|Tuscaloosa',
    county_weights: '{"01007": 99.75, "01125": 0.25}',
    density: 15.8,
    imprecise: false,
    latitude: 33.1152,
    longitude: -87.13931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35184',
  },
  {
    city: 'Westover',
    county_fips: 1117,
    county_fips_all: '01117',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"01117": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.34903,
    longitude: -86.53871,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35185',
  },
  {
    city: 'Wilsonville',
    county_fips: 1117,
    county_fips_all: '01117',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"01117": 100}',
    density: 36.4,
    imprecise: false,
    latitude: 33.25699,
    longitude: -86.51442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35186',
  },
  {
    city: 'Woodstock',
    county_fips: 1007,
    county_fips_all: '01007|01125',
    county: 'Bibb',
    county_names_all: 'Bibb|Tuscaloosa',
    county_weights: '{"01007": 73.48, "01125": 26.52}',
    density: 41.4,
    imprecise: false,
    latitude: 33.18326,
    longitude: -87.17322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35188',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 652.5,
    imprecise: false,
    latitude: 33.51847,
    longitude: -86.80999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35203',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 687.4,
    imprecise: false,
    latitude: 33.52203,
    longitude: -86.84067,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35204',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 1951.4,
    imprecise: false,
    latitude: 33.49509,
    longitude: -86.8084,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35205',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 599.9,
    imprecise: false,
    latitude: 33.57024,
    longitude: -86.71328,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35206',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 255.8,
    imprecise: false,
    latitude: 33.5682,
    longitude: -86.8223,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35207',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 1409.6,
    imprecise: false,
    latitude: 33.49717,
    longitude: -86.87909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35208',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 1317.4,
    imprecise: false,
    latitude: 33.46507,
    longitude: -86.81107,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35209',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 213.7,
    imprecise: false,
    latitude: 33.5431,
    longitude: -86.6661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35210',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 581.2,
    imprecise: false,
    latitude: 33.45262,
    longitude: -86.87046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35211',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 633.6,
    imprecise: false,
    latitude: 33.54765,
    longitude: -86.75272,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35212',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 953.1,
    imprecise: false,
    latitude: 33.50659,
    longitude: -86.74241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35213',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 264.9,
    imprecise: false,
    latitude: 33.57322,
    longitude: -86.89081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35214',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 599.6,
    imprecise: false,
    latitude: 33.64911,
    longitude: -86.70435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35215',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073|01117',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Shelby',
    county_weights: '{"01073": 98.04, "01117": 1.96}',
    density: 1020.9,
    imprecise: false,
    latitude: 33.41995,
    longitude: -86.78746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35216',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 267.1,
    imprecise: false,
    latitude: 33.60711,
    longitude: -86.7613,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35217',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 1027,
    imprecise: false,
    latitude: 33.50771,
    longitude: -86.89388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35218',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 326.4,
    imprecise: false,
    latitude: 33.4497,
    longitude: -86.89901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35221',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 828.4,
    imprecise: false,
    latitude: 33.52378,
    longitude: -86.76994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35222',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 487.6,
    imprecise: false,
    latitude: 33.48777,
    longitude: -86.73605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35223',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 112.9,
    imprecise: false,
    latitude: 33.52965,
    longitude: -86.94518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35224',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 842,
    imprecise: false,
    latitude: 33.39823,
    longitude: -86.84421,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35226',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 900.8,
    imprecise: false,
    latitude: 33.45606,
    longitude: -86.92165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35228',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 905.3,
    imprecise: false,
    latitude: 33.50916,
    longitude: -86.80132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35233',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 446.7,
    imprecise: false,
    latitude: 33.54005,
    longitude: -86.80382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35234',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 587.6,
    imprecise: false,
    latitude: 33.61723,
    longitude: -86.65008,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35235',
  },
  {
    city: 'Birmingham',
    county_fips: 1117,
    county_fips_all: '01117|01073',
    county: 'Shelby',
    county_names_all: 'Shelby|Jefferson',
    county_weights: '{"01117": 80.44, "01073": 19.56}',
    density: 423,
    imprecise: false,
    latitude: 33.42371,
    longitude: -86.67073,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35242',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073|01117',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Shelby',
    county_weights: '{"01073": 97.71, "01117": 2.29}',
    density: 560.1,
    imprecise: false,
    latitude: 33.44185,
    longitude: -86.74055,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35243',
  },
  {
    city: 'Birmingham',
    county_fips: 1117,
    county_fips_all: '01117|01073',
    county: 'Shelby',
    county_names_all: 'Shelby|Jefferson',
    county_weights: '{"01117": 54.13, "01073": 45.87}',
    density: 618.6,
    imprecise: false,
    latitude: 33.35205,
    longitude: -86.8267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35244',
  },
  {
    city: 'Tuscaloosa',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 418.4,
    imprecise: false,
    latitude: 33.179,
    longitude: -87.61586,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35401',
  },
  {
    city: 'Tuscaloosa',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 520.6,
    imprecise: false,
    latitude: 33.21661,
    longitude: -87.48655,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35404',
  },
  {
    city: 'Tuscaloosa',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 360.8,
    imprecise: false,
    latitude: 33.12087,
    longitude: -87.55082,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35405',
  },
  {
    city: 'Tuscaloosa',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 90.2,
    imprecise: false,
    latitude: 33.33194,
    longitude: -87.4683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35406',
  },
  {
    city: 'Akron',
    county_fips: 1065,
    county_fips_all: '01065',
    county: 'Hale',
    county_names_all: 'Hale',
    county_weights: '{"01065": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 32.85616,
    longitude: -87.73114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35441',
  },
  {
    city: 'Aliceville',
    county_fips: 1107,
    county_fips_all: '01107|01119|01063',
    county: 'Pickens',
    county_names_all: 'Pickens|Sumter|Greene',
    county_weights: '{"01107": 74.47, "01119": 20.41, "01063": 5.12}',
    density: 7.6,
    imprecise: false,
    latitude: 33.06016,
    longitude: -88.20159,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35442',
  },
  {
    city: 'Boligee',
    county_fips: 1063,
    county_fips_all: '01063',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"01063": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 32.76538,
    longitude: -88.01908,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35443',
  },
  {
    city: 'Brookwood',
    county_fips: 1125,
    county_fips_all: '01125|01073',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa|Jefferson',
    county_weights: '{"01125": 93.49, "01073": 6.51}',
    density: 10.8,
    imprecise: false,
    latitude: 33.33474,
    longitude: -87.30387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35444',
  },
  {
    city: 'Buhl',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 33.21642,
    longitude: -87.74833,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35446',
  },
  {
    city: 'Carrollton',
    county_fips: 1107,
    county_fips_all: '01107',
    county: 'Pickens',
    county_names_all: 'Pickens',
    county_weights: '{"01107": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 33.25701,
    longitude: -88.15716,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35447',
  },
  {
    city: 'Coker',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 32,
    imprecise: false,
    latitude: 33.28349,
    longitude: -87.6854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35452',
  },
  {
    city: 'Cottondale',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 53.9,
    imprecise: false,
    latitude: 33.16176,
    longitude: -87.387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35453',
  },
  {
    city: 'Duncanville',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 33.05651,
    longitude: -87.43515,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35456',
  },
  {
    city: 'Elrod',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 33.3814,
    longitude: -87.79713,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35458',
  },
  {
    city: 'Emelle',
    county_fips: 1119,
    county_fips_all: '01119',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"01119": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 32.79337,
    longitude: -88.3003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35459',
  },
  {
    city: 'Epes',
    county_fips: 1119,
    county_fips_all: '01119',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"01119": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 32.71882,
    longitude: -88.19452,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35460',
  },
  {
    city: 'Ethelsville',
    county_fips: 1107,
    county_fips_all: '01107',
    county: 'Pickens',
    county_names_all: 'Pickens',
    county_weights: '{"01107": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 33.41749,
    longitude: -88.21158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35461',
  },
  {
    city: 'Eutaw',
    county_fips: 1063,
    county_fips_all: '01063',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"01063": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 32.93389,
    longitude: -87.94183,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35462',
  },
  {
    city: 'Fosters',
    county_fips: 1125,
    county_fips_all: '01125|01063',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa|Greene',
    county_weights: '{"01125": 82.98, "01063": 17.02}',
    density: 10.8,
    imprecise: false,
    latitude: 33.0563,
    longitude: -87.68687,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35463',
  },
  {
    city: 'Gainesville',
    county_fips: 1119,
    county_fips_all: '01119|01063',
    county: 'Sumter',
    county_names_all: 'Sumter|Greene',
    county_weights: '{"01119": 89.8, "01063": 10.2}',
    density: 4.2,
    imprecise: false,
    latitude: 32.78369,
    longitude: -88.14383,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35464',
  },
  {
    city: 'Gordo',
    county_fips: 1107,
    county_fips_all: '01107|01125',
    county: 'Pickens',
    county_names_all: 'Pickens|Tuscaloosa',
    county_weights: '{"01107": 86.03, "01125": 13.97}',
    density: 7,
    imprecise: false,
    latitude: 33.25904,
    longitude: -87.91554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35466',
  },
  {
    city: 'Knoxville',
    county_fips: 1063,
    county_fips_all: '01063|01125',
    county: 'Greene',
    county_names_all: 'Greene|Tuscaloosa',
    county_weights: '{"01063": 79.51, "01125": 20.49}',
    density: 5.4,
    imprecise: false,
    latitude: 33.01447,
    longitude: -87.80578,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35469',
  },
  {
    city: 'Livingston',
    county_fips: 1119,
    county_fips_all: '01119',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"01119": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 32.56801,
    longitude: -88.09894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35470',
  },
  {
    city: 'Northport',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 272.6,
    imprecise: false,
    latitude: 33.27236,
    longitude: -87.58481,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35473',
  },
  {
    city: 'Moundville',
    county_fips: 1065,
    county_fips_all: '01065|01125',
    county: 'Hale',
    county_names_all: 'Hale|Tuscaloosa',
    county_weights: '{"01065": 88.9, "01125": 11.1}',
    density: 18,
    imprecise: false,
    latitude: 32.93679,
    longitude: -87.57226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35474',
  },
  {
    city: 'Northport',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 33.42792,
    longitude: -87.5854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35475',
  },
  {
    city: 'Northport',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 476.8,
    imprecise: false,
    latitude: 33.2271,
    longitude: -87.60464,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35476',
  },
  {
    city: 'Panola',
    county_fips: 1119,
    county_fips_all: '01119|01107',
    county: 'Sumter',
    county_names_all: 'Sumter|Pickens',
    county_weights: '{"01119": 99.6, "01107": 0.4}',
    density: 8.7,
    imprecise: false,
    latitude: 32.96304,
    longitude: -88.23121,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35477',
  },
  {
    city: 'Ralph',
    county_fips: 1125,
    county_fips_all: '01125|01063',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa|Greene',
    county_weights: '{"01125": 72.76, "01063": 27.24}',
    density: 11.9,
    imprecise: false,
    latitude: 33.09794,
    longitude: -87.80734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35480',
  },
  {
    city: 'Reform',
    county_fips: 1107,
    county_fips_all: '01107',
    county: 'Pickens',
    county_names_all: 'Pickens',
    county_weights: '{"01107": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 33.39852,
    longitude: -88.03934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35481',
  },
  {
    city: 'Vance',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 25.6,
    imprecise: false,
    latitude: 33.21607,
    longitude: -87.24546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35490',
  },
  {
    city: 'West Greene',
    county_fips: 1063,
    county_fips_all: '01063',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"01063": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.93665,
    longitude: -88.09774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35491',
  },
  {
    city: 'Jasper',
    county_fips: 1127,
    county_fips_all: '01127',
    county: 'Walker',
    county_names_all: 'Walker',
    county_weights: '{"01127": 100}',
    density: 80.1,
    imprecise: false,
    latitude: 33.82145,
    longitude: -87.29544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35501',
  },
  {
    city: 'Jasper',
    county_fips: 1127,
    county_fips_all: '01127|01133',
    county: 'Walker',
    county_names_all: 'Walker|Winston',
    county_weights: '{"01127": 91.1, "01133": 8.9}',
    density: 45.8,
    imprecise: false,
    latitude: 33.93664,
    longitude: -87.30147,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35503',
  },
  {
    city: 'Jasper',
    county_fips: 1127,
    county_fips_all: '01127',
    county: 'Walker',
    county_names_all: 'Walker',
    county_weights: '{"01127": 100}',
    density: 56.7,
    imprecise: false,
    latitude: 33.89311,
    longitude: -87.16672,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35504',
  },
  {
    city: 'Addison',
    county_fips: 1133,
    county_fips_all: '01133|01043',
    county: 'Winston',
    county_names_all: 'Winston|Cullman',
    county_weights: '{"01133": 97.88, "01043": 2.12}',
    density: 12.4,
    imprecise: false,
    latitude: 34.23066,
    longitude: -87.18374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35540',
  },
  {
    city: 'Arley',
    county_fips: 1133,
    county_fips_all: '01133|01043',
    county: 'Winston',
    county_names_all: 'Winston|Cullman',
    county_weights: '{"01133": 99.04, "01043": 0.96}',
    density: 22.7,
    imprecise: false,
    latitude: 34.07936,
    longitude: -87.1801,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35541',
  },
  {
    city: 'Bankston',
    county_fips: 1057,
    county_fips_all: '01057',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"01057": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 33.7083,
    longitude: -87.68161,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35542',
  },
  {
    city: 'Bear Creek',
    county_fips: 1093,
    county_fips_all: '01093',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"01093": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 34.21219,
    longitude: -87.75197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35543',
  },
  {
    city: 'Beaverton',
    county_fips: 1075,
    county_fips_all: '01075',
    county: 'Lamar',
    county_names_all: 'Lamar',
    county_weights: '{"01075": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 33.95392,
    longitude: -88.02022,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35544',
  },
  {
    city: 'Belk',
    county_fips: 1057,
    county_fips_all: '01057',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"01057": 100}',
    density: 93.9,
    imprecise: false,
    latitude: 33.6421,
    longitude: -87.93147,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35545',
  },
  {
    city: 'Berry',
    county_fips: 1125,
    county_fips_all: '01125|01057|01127',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa|Fayette|Walker',
    county_weights: '{"01125": 48.66, "01057": 43.36, "01127": 7.97}',
    density: 7,
    imprecise: false,
    latitude: 33.60555,
    longitude: -87.54763,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35546',
  },
  {
    city: 'Brilliant',
    county_fips: 1093,
    county_fips_all: '01093',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"01093": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 34.06263,
    longitude: -87.75251,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35548',
  },
  {
    city: 'Carbon Hill',
    county_fips: 1057,
    county_fips_all: '01057|01127',
    county: 'Fayette',
    county_names_all: 'Fayette|Walker',
    county_weights: '{"01057": 50.75, "01127": 49.25}',
    density: 11.3,
    imprecise: false,
    latitude: 33.83474,
    longitude: -87.55001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35549',
  },
  {
    city: 'Cordova',
    county_fips: 1127,
    county_fips_all: '01127',
    county: 'Walker',
    county_names_all: 'Walker',
    county_weights: '{"01127": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 33.74249,
    longitude: -87.16534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35550',
  },
  {
    city: 'Detroit',
    county_fips: 1093,
    county_fips_all: '01093|01075',
    county: 'Marion',
    county_names_all: 'Marion|Lamar',
    county_weights: '{"01093": 60.34, "01075": 39.66}',
    density: 5.6,
    imprecise: false,
    latitude: 34.07311,
    longitude: -88.14266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35552',
  },
  {
    city: 'Double Springs',
    county_fips: 1133,
    county_fips_all: '01133',
    county: 'Winston',
    county_names_all: 'Winston',
    county_weights: '{"01133": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 34.12471,
    longitude: -87.38794,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35553',
  },
  {
    city: 'Eldridge',
    county_fips: 1057,
    county_fips_all: '01057|01127|01093',
    county: 'Fayette',
    county_names_all: 'Fayette|Walker|Marion',
    county_weights: '{"01057": 55.57, "01127": 25.4, "01093": 19.03}',
    density: 8.8,
    imprecise: false,
    latitude: 33.89745,
    longitude: -87.65593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35554',
  },
  {
    city: 'Fayette',
    county_fips: 1057,
    county_fips_all: '01057|01125|01075|01107',
    county: 'Fayette',
    county_names_all: 'Fayette|Tuscaloosa|Lamar|Pickens',
    county_weights:
      '{"01057": 87.82, "01125": 7.12, "01075": 3.96, "01107": 1.1}',
    density: 11,
    imprecise: false,
    latitude: 33.66829,
    longitude: -87.82309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35555',
  },
  {
    city: 'Glen Allen',
    county_fips: 1057,
    county_fips_all: '01057',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"01057": 100}',
    density: 413.8,
    imprecise: false,
    latitude: 33.91166,
    longitude: -87.73537,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35559',
  },
  {
    city: 'Guin',
    county_fips: 1093,
    county_fips_all: '01093|01057|01075',
    county: 'Marion',
    county_names_all: 'Marion|Fayette|Lamar',
    county_weights: '{"01093": 88.0, "01057": 6.87, "01075": 5.13}',
    density: 15.7,
    imprecise: false,
    latitude: 33.99678,
    longitude: -87.90149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35563',
  },
  {
    city: 'Hackleburg',
    county_fips: 1093,
    county_fips_all: '01093|01059',
    county: 'Marion',
    county_names_all: 'Marion|Franklin',
    county_weights: '{"01093": 92.82, "01059": 7.18}',
    density: 13.3,
    imprecise: false,
    latitude: 34.25733,
    longitude: -87.84306,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35564',
  },
  {
    city: 'Haleyville',
    county_fips: 1133,
    county_fips_all: '01133|01093|01079|01059',
    county: 'Winston',
    county_names_all: 'Winston|Marion|Lawrence|Franklin',
    county_weights:
      '{"01133": 53.44, "01093": 23.12, "01079": 17.53, "01059": 5.91}',
    density: 14.7,
    imprecise: false,
    latitude: 34.23555,
    longitude: -87.56309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35565',
  },
  {
    city: 'Hamilton',
    county_fips: 1093,
    county_fips_all: '01093|01075',
    county: 'Marion',
    county_names_all: 'Marion|Lamar',
    county_weights: '{"01093": 99.14, "01075": 0.86}',
    density: 18.4,
    imprecise: false,
    latitude: 34.16532,
    longitude: -87.99466,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35570',
  },
  {
    city: 'Hodges',
    county_fips: 1059,
    county_fips_all: '01059|01093',
    county: 'Franklin',
    county_names_all: 'Franklin|Marion',
    county_weights: '{"01059": 78.43, "01093": 21.57}',
    density: 4.6,
    imprecise: false,
    latitude: 34.35153,
    longitude: -87.94672,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35571',
  },
  {
    city: 'Houston',
    county_fips: 1133,
    county_fips_all: '01133',
    county: 'Winston',
    county_names_all: 'Winston',
    county_weights: '{"01133": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 34.20672,
    longitude: -87.29447,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35572',
  },
  {
    city: 'Kansas',
    county_fips: 1127,
    county_fips_all: '01127',
    county: 'Walker',
    county_names_all: 'Walker',
    county_weights: '{"01127": 100}',
    density: 378.3,
    imprecise: false,
    latitude: 33.90137,
    longitude: -87.54999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35573',
  },
  {
    city: 'Kennedy',
    county_fips: 1075,
    county_fips_all: '01075|01107|01057',
    county: 'Lamar',
    county_names_all: 'Lamar|Pickens|Fayette',
    county_weights: '{"01075": 53.52, "01107": 34.02, "01057": 12.46}',
    density: 4.8,
    imprecise: false,
    latitude: 33.5683,
    longitude: -87.95757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35574',
  },
  {
    city: 'Lynn',
    county_fips: 1133,
    county_fips_all: '01133',
    county: 'Winston',
    county_names_all: 'Winston',
    county_weights: '{"01133": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 34.04521,
    longitude: -87.57716,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35575',
  },
  {
    city: 'Millport',
    county_fips: 1075,
    county_fips_all: '01075|01107',
    county: 'Lamar',
    county_names_all: 'Lamar|Pickens',
    county_weights: '{"01075": 80.53, "01107": 19.47}',
    density: 8.1,
    imprecise: false,
    latitude: 33.582,
    longitude: -88.1315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35576',
  },
  {
    city: 'Natural Bridge',
    county_fips: 1133,
    county_fips_all: '01133',
    county: 'Winston',
    county_names_all: 'Winston',
    county_weights: '{"01133": 100}',
    density: 37,
    imprecise: false,
    latitude: 34.09175,
    longitude: -87.59931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35577',
  },
  {
    city: 'Nauvoo',
    county_fips: 1127,
    county_fips_all: '01127|01133',
    county: 'Walker',
    county_names_all: 'Walker|Winston',
    county_weights: '{"01127": 64.5, "01133": 35.5}',
    density: 17.8,
    imprecise: false,
    latitude: 33.982,
    longitude: -87.46638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35578',
  },
  {
    city: 'Oakman',
    county_fips: 1127,
    county_fips_all: '01127|01125',
    county: 'Walker',
    county_names_all: 'Walker|Tuscaloosa',
    county_weights: '{"01127": 76.65, "01125": 23.35}',
    density: 7.2,
    imprecise: false,
    latitude: 33.63069,
    longitude: -87.34441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35579',
  },
  {
    city: 'Parrish',
    county_fips: 1127,
    county_fips_all: '01127',
    county: 'Walker',
    county_names_all: 'Walker',
    county_weights: '{"01127": 100}',
    density: 23.3,
    imprecise: false,
    latitude: 33.7011,
    longitude: -87.27331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35580',
  },
  {
    city: 'Phil Campbell',
    county_fips: 1059,
    county_fips_all: '01059|01093',
    county: 'Franklin',
    county_names_all: 'Franklin|Marion',
    county_weights: '{"01059": 87.65, "01093": 12.35}',
    density: 19,
    imprecise: false,
    latitude: 34.35789,
    longitude: -87.71267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35581',
  },
  {
    city: 'Red Bay',
    county_fips: 1059,
    county_fips_all: '01059',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"01059": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 34.48577,
    longitude: -88.09536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35582',
  },
  {
    city: 'Sipsey',
    county_fips: 1127,
    county_fips_all: '01127',
    county: 'Walker',
    county_names_all: 'Walker',
    county_weights: '{"01127": 100}',
    density: 195.4,
    imprecise: false,
    latitude: 33.82161,
    longitude: -87.08692,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35584',
  },
  {
    city: 'Spruce Pine',
    county_fips: 1059,
    county_fips_all: '01059',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"01059": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 34.41868,
    longitude: -87.82008,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35585',
  },
  {
    city: 'Sulligent',
    county_fips: 1075,
    county_fips_all: '01075',
    county: 'Lamar',
    county_names_all: 'Lamar',
    county_weights: '{"01075": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 33.87332,
    longitude: -88.13837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35586',
  },
  {
    city: 'Townley',
    county_fips: 1127,
    county_fips_all: '01127',
    county: 'Walker',
    county_names_all: 'Walker',
    county_weights: '{"01127": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 33.80071,
    longitude: -87.4521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35587',
  },
  {
    city: 'Vernon',
    county_fips: 1075,
    county_fips_all: '01075',
    county: 'Lamar',
    county_names_all: 'Lamar',
    county_weights: '{"01075": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 33.74315,
    longitude: -88.09672,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35592',
  },
  {
    city: 'Vina',
    county_fips: 1059,
    county_fips_all: '01059|01093',
    county: 'Franklin',
    county_names_all: 'Franklin|Marion',
    county_weights: '{"01059": 64.81, "01093": 35.19}',
    density: 4.5,
    imprecise: false,
    latitude: 34.35721,
    longitude: -88.07328,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35593',
  },
  {
    city: 'Winfield',
    county_fips: 1057,
    county_fips_all: '01057|01093',
    county: 'Fayette',
    county_names_all: 'Fayette|Marion',
    county_weights: '{"01057": 50.15, "01093": 49.85}',
    density: 19.6,
    imprecise: false,
    latitude: 33.92222,
    longitude: -87.7813,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35594',
  },
  {
    city: 'Decatur',
    county_fips: 1103,
    county_fips_all: '01103',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"01103": 100}',
    density: 516.7,
    imprecise: false,
    latitude: 34.60616,
    longitude: -87.00795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35601',
  },
  {
    city: 'Decatur',
    county_fips: 1103,
    county_fips_all: '01103|01079',
    county: 'Morgan',
    county_names_all: 'Morgan|Lawrence',
    county_weights: '{"01103": 99.49, "01079": 0.51}',
    density: 174.9,
    imprecise: false,
    latitude: 34.53712,
    longitude: -86.96717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35603',
  },
  {
    city: 'Anderson',
    county_fips: 1077,
    county_fips_all: '01077|01083',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale|Limestone',
    county_weights: '{"01077": 70.36, "01083": 29.64}',
    density: 15.8,
    imprecise: false,
    latitude: 34.95361,
    longitude: -87.23714,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35610',
  },
  {
    city: 'Athens',
    county_fips: 1083,
    county_fips_all: '01083',
    county: 'Limestone',
    county_names_all: 'Limestone',
    county_weights: '{"01083": 100}',
    density: 100.6,
    imprecise: false,
    latitude: 34.76554,
    longitude: -87.08418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35611',
  },
  {
    city: 'Athens',
    county_fips: 1083,
    county_fips_all: '01083',
    county: 'Limestone',
    county_names_all: 'Limestone',
    county_weights: '{"01083": 100}',
    density: 131.4,
    imprecise: false,
    latitude: 34.82336,
    longitude: -86.88001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35613',
  },
  {
    city: 'Athens',
    county_fips: 1083,
    county_fips_all: '01083|01077',
    county: 'Limestone',
    county_names_all: 'Limestone|Lauderdale',
    county_weights: '{"01083": 98.32, "01077": 1.68}',
    density: 45.6,
    imprecise: false,
    latitude: 34.86433,
    longitude: -87.08457,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35614',
  },
  {
    city: 'Belle Mina',
    county_fips: 1083,
    county_fips_all: '01083',
    county: 'Limestone',
    county_names_all: 'Limestone',
    county_weights: '{"01083": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 34.66229,
    longitude: -86.87596,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35615',
  },
  {
    city: 'Cherokee',
    county_fips: 1033,
    county_fips_all: '01033',
    county: 'Colbert',
    county_names_all: 'Colbert',
    county_weights: '{"01033": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 34.7382,
    longitude: -88.01889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35616',
  },
  {
    city: 'Courtland',
    county_fips: 1079,
    county_fips_all: '01079',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"01079": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 34.64334,
    longitude: -87.30552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35618',
  },
  {
    city: 'Danville',
    county_fips: 1079,
    county_fips_all: '01079|01103|01043',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Morgan|Cullman',
    county_weights: '{"01079": 68.24, "01103": 31.6, "01043": 0.16}',
    density: 15.7,
    imprecise: false,
    latitude: 34.38606,
    longitude: -87.14545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35619',
  },
  {
    city: 'Elkmont',
    county_fips: 1083,
    county_fips_all: '01083',
    county: 'Limestone',
    county_names_all: 'Limestone',
    county_weights: '{"01083": 100}',
    density: 39.1,
    imprecise: false,
    latitude: 34.93141,
    longitude: -86.99086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35620',
  },
  {
    city: 'Eva',
    county_fips: 1103,
    county_fips_all: '01103|01043',
    county: 'Morgan',
    county_names_all: 'Morgan|Cullman',
    county_weights: '{"01103": 96.67, "01043": 3.33}',
    density: 29.5,
    imprecise: false,
    latitude: 34.34967,
    longitude: -86.7239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35621',
  },
  {
    city: 'Falkville',
    county_fips: 1103,
    county_fips_all: '01103|01043',
    county: 'Morgan',
    county_names_all: 'Morgan|Cullman',
    county_weights: '{"01103": 84.6, "01043": 15.4}',
    density: 27.4,
    imprecise: false,
    latitude: 34.34491,
    longitude: -86.89535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35622',
  },
  {
    city: 'Florence',
    county_fips: 1077,
    county_fips_all: '01077',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale',
    county_weights: '{"01077": 100}',
    density: 519.7,
    imprecise: false,
    latitude: 34.82526,
    longitude: -87.66018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35630',
  },
  {
    city: 'Florence',
    county_fips: 1077,
    county_fips_all: '01077',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale',
    county_weights: '{"01077": 100}',
    density: 38.6,
    imprecise: false,
    latitude: 34.87586,
    longitude: -87.79645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35633',
  },
  {
    city: 'Florence',
    county_fips: 1077,
    county_fips_all: '01077',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale',
    county_weights: '{"01077": 100}',
    density: 55.4,
    imprecise: false,
    latitude: 34.92306,
    longitude: -87.60738,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35634',
  },
  {
    city: 'Hartselle',
    county_fips: 1103,
    county_fips_all: '01103',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"01103": 100}',
    density: 98.8,
    imprecise: false,
    latitude: 34.4414,
    longitude: -86.94315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35640',
  },
  {
    city: 'Hillsboro',
    county_fips: 1079,
    county_fips_all: '01079',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"01079": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 34.66882,
    longitude: -87.20707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35643',
  },
  {
    city: 'Killen',
    county_fips: 1077,
    county_fips_all: '01077',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale',
    county_weights: '{"01077": 100}',
    density: 70.6,
    imprecise: false,
    latitude: 34.89605,
    longitude: -87.4936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35645',
  },
  {
    city: 'Leighton',
    county_fips: 1033,
    county_fips_all: '01033',
    county: 'Colbert',
    county_names_all: 'Colbert',
    county_weights: '{"01033": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 34.66988,
    longitude: -87.53165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35646',
  },
  {
    city: 'Lester',
    county_fips: 1083,
    county_fips_all: '01083',
    county: 'Limestone',
    county_names_all: 'Limestone',
    county_weights: '{"01083": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 34.96539,
    longitude: -87.11933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35647',
  },
  {
    city: 'Lexington',
    county_fips: 1077,
    county_fips_all: '01077',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale',
    county_weights: '{"01077": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 34.95857,
    longitude: -87.38022,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35648',
  },
  {
    city: 'Mooresville',
    county_fips: 1083,
    county_fips_all: '01083',
    county: 'Limestone',
    county_names_all: 'Limestone',
    county_weights: '{"01083": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 34.62091,
    longitude: -86.87965,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35649',
  },
  {
    city: 'Moulton',
    county_fips: 1079,
    county_fips_all: '01079',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"01079": 100}',
    density: 24.5,
    imprecise: false,
    latitude: 34.45176,
    longitude: -87.30289,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35650',
  },
  {
    city: 'Mount Hope',
    county_fips: 1079,
    county_fips_all: '01079',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"01079": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 34.46254,
    longitude: -87.48044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35651',
  },
  {
    city: 'Rogersville',
    county_fips: 1077,
    county_fips_all: '01077|01083',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale|Limestone',
    county_weights: '{"01077": 97.89, "01083": 2.11}',
    density: 41.5,
    imprecise: false,
    latitude: 34.84742,
    longitude: -87.31137,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35652',
  },
  {
    city: 'Russellville',
    county_fips: 1059,
    county_fips_all: '01059|01033',
    county: 'Franklin',
    county_names_all: 'Franklin|Colbert',
    county_weights: '{"01059": 79.12, "01033": 20.88}',
    density: 29.6,
    imprecise: false,
    latitude: 34.53131,
    longitude: -87.86974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35653',
  },
  {
    city: 'Russellville',
    county_fips: 1059,
    county_fips_all: '01059|01033|01079',
    county: 'Franklin',
    county_names_all: 'Franklin|Colbert|Lawrence',
    county_weights: '{"01059": 82.45, "01033": 9.64, "01079": 7.91}',
    density: 22.6,
    imprecise: false,
    latitude: 34.49971,
    longitude: -87.62,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35654',
  },
  {
    city: 'Sheffield',
    county_fips: 1033,
    county_fips_all: '01033',
    county: 'Colbert',
    county_names_all: 'Colbert',
    county_weights: '{"01033": 100}',
    density: 587.7,
    imprecise: false,
    latitude: 34.75837,
    longitude: -87.69847,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35660',
  },
  {
    city: 'Muscle Shoals',
    county_fips: 1033,
    county_fips_all: '01033',
    county: 'Colbert',
    county_names_all: 'Colbert',
    county_weights: '{"01033": 100}',
    density: 144.6,
    imprecise: false,
    latitude: 34.77737,
    longitude: -87.56331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35661',
  },
  {
    city: 'Somerville',
    county_fips: 1103,
    county_fips_all: '01103',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"01103": 100}',
    density: 30.4,
    imprecise: false,
    latitude: 34.46318,
    longitude: -86.72356,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35670',
  },
  {
    city: 'Tanner',
    county_fips: 1083,
    county_fips_all: '01083',
    county: 'Limestone',
    county_names_all: 'Limestone',
    county_weights: '{"01083": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 34.66607,
    longitude: -86.95191,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35671',
  },
  {
    city: 'Town Creek',
    county_fips: 1079,
    county_fips_all: '01079|01033',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Colbert',
    county_weights: '{"01079": 94.45, "01033": 5.55}',
    density: 16.2,
    imprecise: false,
    latitude: 34.65106,
    longitude: -87.40705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35672',
  },
  {
    city: 'Trinity',
    county_fips: 1079,
    county_fips_all: '01079|01103',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Morgan',
    county_weights: '{"01079": 71.65, "01103": 28.35}',
    density: 60.5,
    imprecise: false,
    latitude: 34.58601,
    longitude: -87.13166,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35673',
  },
  {
    city: 'Tuscumbia',
    county_fips: 1033,
    county_fips_all: '01033',
    county: 'Colbert',
    county_names_all: 'Colbert',
    county_weights: '{"01033": 100}',
    density: 44.8,
    imprecise: false,
    latitude: 34.66343,
    longitude: -87.75996,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35674',
  },
  {
    city: 'Waterloo',
    county_fips: 1077,
    county_fips_all: '01077',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale',
    county_weights: '{"01077": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 34.95367,
    longitude: -88.02529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35677',
  },
  {
    city: 'Ardmore',
    county_fips: 1083,
    county_fips_all: '01083|01089',
    county: 'Limestone',
    county_names_all: 'Limestone|Madison',
    county_weights: '{"01083": 55.34, "01089": 44.66}',
    density: 74.3,
    imprecise: false,
    latitude: 34.96914,
    longitude: -86.79501,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35739',
  },
  {
    city: 'Bridgeport',
    county_fips: 1071,
    county_fips_all: '01071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"01071": 100}',
    density: 37.2,
    imprecise: false,
    latitude: 34.95009,
    longitude: -85.75855,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35740',
  },
  {
    city: 'Brownsboro',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 72,
    imprecise: false,
    latitude: 34.7242,
    longitude: -86.47745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35741',
  },
  {
    city: 'Dutton',
    county_fips: 1071,
    county_fips_all: '01071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"01071": 100}',
    density: 30.1,
    imprecise: false,
    latitude: 34.61435,
    longitude: -85.90603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35744',
  },
  {
    city: 'Estillfork',
    county_fips: 1071,
    county_fips_all: '01071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"01071": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 34.94101,
    longitude: -86.20002,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35745',
  },
  {
    city: 'Fackler',
    county_fips: 1071,
    county_fips_all: '01071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"01071": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 34.8287,
    longitude: -85.99868,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35746',
  },
  {
    city: 'Grant',
    county_fips: 1095,
    county_fips_all: '01095',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"01095": 100}',
    density: 33.6,
    imprecise: false,
    latitude: 34.49414,
    longitude: -86.30497,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35747',
  },
  {
    city: 'Gurley',
    county_fips: 1089,
    county_fips_all: '01089|01071',
    county: 'Madison',
    county_names_all: 'Madison|Jackson',
    county_weights: '{"01089": 92.96, "01071": 7.04}',
    density: 37.8,
    imprecise: false,
    latitude: 34.71925,
    longitude: -86.39036,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35748',
  },
  {
    city: 'Harvest',
    county_fips: 1089,
    county_fips_all: '01089|01083',
    county: 'Madison',
    county_names_all: 'Madison|Limestone',
    county_weights: '{"01089": 70.04, "01083": 29.96}',
    density: 272.3,
    imprecise: false,
    latitude: 34.82314,
    longitude: -86.75662,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35749',
  },
  {
    city: 'Hazel Green',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 84.8,
    imprecise: false,
    latitude: 34.95407,
    longitude: -86.5951,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35750',
  },
  {
    city: 'Hollywood',
    county_fips: 1071,
    county_fips_all: '01071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"01071": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 34.75593,
    longitude: -85.95119,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35752',
  },
  {
    city: 'Laceys Spring',
    county_fips: 1103,
    county_fips_all: '01103|01095',
    county: 'Morgan',
    county_names_all: 'Morgan|Marshall',
    county_weights: '{"01103": 96.54, "01095": 3.46}',
    density: 48.9,
    imprecise: false,
    latitude: 34.51819,
    longitude: -86.61099,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35754',
  },
  {
    city: 'Langston',
    county_fips: 1095,
    county_fips_all: '01095|01071',
    county: 'Marshall',
    county_names_all: 'Marshall|Jackson',
    county_weights: '{"01095": 62.03, "01071": 37.97}',
    density: 10.2,
    imprecise: false,
    latitude: 34.50676,
    longitude: -86.12609,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35755',
  },
  {
    city: 'Madison',
    county_fips: 1083,
    county_fips_all: '01083|01089',
    county: 'Limestone',
    county_names_all: 'Limestone|Madison',
    county_weights: '{"01083": 81.76, "01089": 18.24}',
    density: 120,
    imprecise: false,
    latitude: 34.64287,
    longitude: -86.82114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35756',
  },
  {
    city: 'Madison',
    county_fips: 1089,
    county_fips_all: '01089|01083',
    county: 'Madison',
    county_names_all: 'Madison|Limestone',
    county_weights: '{"01089": 96.68, "01083": 3.32}',
    density: 613.4,
    imprecise: false,
    latitude: 34.78426,
    longitude: -86.74419,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35757',
  },
  {
    city: 'Madison',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 713.1,
    imprecise: false,
    latitude: 34.71417,
    longitude: -86.74707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35758',
  },
  {
    city: 'Meridianville',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 294.6,
    imprecise: false,
    latitude: 34.86856,
    longitude: -86.55262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35759',
  },
  {
    city: 'New Hope',
    county_fips: 1089,
    county_fips_all: '01089|01095',
    county: 'Madison',
    county_names_all: 'Madison|Marshall',
    county_weights: '{"01089": 92.68, "01095": 7.32}',
    density: 35.4,
    imprecise: false,
    latitude: 34.54768,
    longitude: -86.38324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35760',
  },
  {
    city: 'New Market',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 44.9,
    imprecise: false,
    latitude: 34.914,
    longitude: -86.41001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35761',
  },
  {
    city: 'Owens Cross Roads',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 187.3,
    imprecise: false,
    latitude: 34.62022,
    longitude: -86.46615,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35763',
  },
  {
    city: 'Paint Rock',
    county_fips: 1071,
    county_fips_all: '01071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"01071": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 34.73102,
    longitude: -86.31381,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35764',
  },
  {
    city: 'Pisgah',
    county_fips: 1071,
    county_fips_all: '01071|01049',
    county: 'Jackson',
    county_names_all: 'Jackson|DeKalb',
    county_weights: '{"01071": 94.8, "01049": 5.2}',
    density: 22.7,
    imprecise: false,
    latitude: 34.69393,
    longitude: -85.82423,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35765',
  },
  {
    city: 'Princeton',
    county_fips: 1071,
    county_fips_all: '01071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"01071": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 34.87342,
    longitude: -86.27661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35766',
  },
  {
    city: 'Scottsboro',
    county_fips: 1071,
    county_fips_all: '01071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"01071": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 34.77852,
    longitude: -86.10383,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35768',
  },
  {
    city: 'Scottsboro',
    county_fips: 1071,
    county_fips_all: '01071|01095',
    county: 'Jackson',
    county_names_all: 'Jackson|Marshall',
    county_weights: '{"01071": 73.36, "01095": 26.64}',
    density: 60.7,
    imprecise: false,
    latitude: 34.59255,
    longitude: -86.09472,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35769',
  },
  {
    city: 'Section',
    county_fips: 1071,
    county_fips_all: '01071|01049',
    county: 'Jackson',
    county_names_all: 'Jackson|DeKalb',
    county_weights: '{"01071": 96.26, "01049": 3.74}',
    density: 21.2,
    imprecise: false,
    latitude: 34.53635,
    longitude: -85.99843,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35771',
  },
  {
    city: 'Stevenson',
    county_fips: 1071,
    county_fips_all: '01071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"01071": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 34.89152,
    longitude: -85.88614,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35772',
  },
  {
    city: 'Toney',
    county_fips: 1089,
    county_fips_all: '01089|01083',
    county: 'Madison',
    county_names_all: 'Madison|Limestone',
    county_weights: '{"01089": 78.2, "01083": 21.8}',
    density: 77.8,
    imprecise: false,
    latitude: 34.89431,
    longitude: -86.71282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35773',
  },
  {
    city: 'Trenton',
    county_fips: 1071,
    county_fips_all: '01071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"01071": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 34.7611,
    longitude: -86.22805,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35774',
  },
  {
    city: 'Valhermoso Springs',
    county_fips: 1103,
    county_fips_all: '01103',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"01103": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 34.5477,
    longitude: -86.69623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35775',
  },
  {
    city: 'Woodville',
    county_fips: 1071,
    county_fips_all: '01071|01095|01089',
    county: 'Jackson',
    county_names_all: 'Jackson|Marshall|Madison',
    county_weights: '{"01071": 78.79, "01095": 18.71, "01089": 2.5}',
    density: 12.2,
    imprecise: false,
    latitude: 34.66083,
    longitude: -86.24338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35776',
  },
  {
    city: 'Huntsville',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 651.4,
    imprecise: false,
    latitude: 34.72497,
    longitude: -86.56304,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35801',
  },
  {
    city: 'Huntsville',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 560.9,
    imprecise: false,
    latitude: 34.67398,
    longitude: -86.55449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35802',
  },
  {
    city: 'Huntsville',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 229.1,
    imprecise: false,
    latitude: 34.56476,
    longitude: -86.52185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35803',
  },
  {
    city: 'Huntsville',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 876.1,
    imprecise: false,
    latitude: 34.70875,
    longitude: -86.6219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35805',
  },
  {
    city: 'Huntsville',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 442.4,
    imprecise: false,
    latitude: 34.76615,
    longitude: -86.68324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35806',
  },
  {
    city: 'Huntsville',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 34.63236,
    longitude: -86.65579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35808',
  },
  {
    city: 'Huntsville',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 450.5,
    imprecise: false,
    latitude: 34.80183,
    longitude: -86.60264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35810',
  },
  {
    city: 'Huntsville',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 255.5,
    imprecise: false,
    latitude: 34.79925,
    longitude: -86.50386,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35811',
  },
  {
    city: 'Huntsville',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 1215.2,
    imprecise: false,
    latitude: 34.73923,
    longitude: -86.62985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35816',
  },
  {
    city: 'Huntsville',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 293.5,
    imprecise: false,
    latitude: 34.64458,
    longitude: -86.75193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35824',
  },
  {
    city: 'Gadsden',
    county_fips: 1055,
    county_fips_all: '01055|01019',
    county: 'Etowah',
    county_names_all: 'Etowah|Cherokee',
    county_weights: '{"01055": 96.69, "01019": 3.31}',
    density: 122.5,
    imprecise: false,
    latitude: 34.04848,
    longitude: -85.92395,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35901',
  },
  {
    city: 'Gadsden',
    county_fips: 1055,
    county_fips_all: '01055|01019',
    county: 'Etowah',
    county_names_all: 'Etowah|Cherokee',
    county_weights: '{"01055": 91.47, "01019": 8.53}',
    density: 96.8,
    imprecise: false,
    latitude: 34.03144,
    longitude: -85.85703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35903',
  },
  {
    city: 'Gadsden',
    county_fips: 1055,
    county_fips_all: '01055',
    county: 'Etowah',
    county_names_all: 'Etowah',
    county_weights: '{"01055": 100}',
    density: 110.9,
    imprecise: false,
    latitude: 34.07569,
    longitude: -85.98519,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35904',
  },
  {
    city: 'Gadsden',
    county_fips: 1055,
    county_fips_all: '01055|01015',
    county: 'Etowah',
    county_names_all: 'Etowah|Calhoun',
    county_weights: '{"01055": 76.46, "01015": 23.54}',
    density: 59.6,
    imprecise: false,
    latitude: 33.93667,
    longitude: -85.89842,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35905',
  },
  {
    city: 'Rainbow City',
    county_fips: 1055,
    county_fips_all: '01055',
    county: 'Etowah',
    county_names_all: 'Etowah',
    county_weights: '{"01055": 100}',
    density: 115.3,
    imprecise: false,
    latitude: 33.93159,
    longitude: -86.09033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35906',
  },
  {
    city: 'Gadsden',
    county_fips: 1055,
    county_fips_all: '01055',
    county: 'Etowah',
    county_names_all: 'Etowah',
    county_weights: '{"01055": 100}',
    density: 163.6,
    imprecise: false,
    latitude: 33.89874,
    longitude: -86.02408,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35907',
  },
  {
    city: 'Albertville',
    county_fips: 1095,
    county_fips_all: '01095',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"01095": 100}',
    density: 201.8,
    imprecise: false,
    latitude: 34.25273,
    longitude: -86.26023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35950',
  },
  {
    city: 'Albertville',
    county_fips: 1095,
    county_fips_all: '01095|01049',
    county: 'Marshall',
    county_names_all: 'Marshall|DeKalb',
    county_weights: '{"01095": 81.02, "01049": 18.98}',
    density: 73.8,
    imprecise: false,
    latitude: 34.33713,
    longitude: -86.1553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35951',
  },
  {
    city: 'Altoona',
    county_fips: 1055,
    county_fips_all: '01055|01009|01095',
    county: 'Etowah',
    county_names_all: 'Etowah|Blount|Marshall',
    county_weights: '{"01055": 55.03, "01009": 44.66, "01095": 0.31}',
    density: 29.7,
    imprecise: false,
    latitude: 34.05322,
    longitude: -86.3082,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35952',
  },
  {
    city: 'Ashville',
    county_fips: 1115,
    county_fips_all: '01115',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"01115": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 33.81058,
    longitude: -86.20986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35953',
  },
  {
    city: 'Attalla',
    county_fips: 1055,
    county_fips_all: '01055|01049',
    county: 'Etowah',
    county_names_all: 'Etowah|DeKalb',
    county_weights: '{"01055": 94.71, "01049": 5.29}',
    density: 43.7,
    imprecise: false,
    latitude: 34.08952,
    longitude: -86.05771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35954',
  },
  {
    city: 'Boaz',
    county_fips: 1055,
    county_fips_all: '01055|01049',
    county: 'Etowah',
    county_names_all: 'Etowah|DeKalb',
    county_weights: '{"01055": 99.87, "01049": 0.13}',
    density: 45.5,
    imprecise: false,
    latitude: 34.1433,
    longitude: -86.14799,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35956',
  },
  {
    city: 'Boaz',
    county_fips: 1095,
    county_fips_all: '01095|01049|01009',
    county: 'Marshall',
    county_names_all: 'Marshall|DeKalb|Blount',
    county_weights: '{"01095": 74.38, "01049": 20.62, "01009": 4.99}',
    density: 82.6,
    imprecise: false,
    latitude: 34.19105,
    longitude: -86.19531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35957',
  },
  {
    city: 'Bryant',
    county_fips: 1071,
    county_fips_all: '01071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"01071": 100}',
    density: 25.1,
    imprecise: false,
    latitude: 34.91796,
    longitude: -85.64731,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35958',
  },
  {
    city: 'Cedar Bluff',
    county_fips: 1019,
    county_fips_all: '01019|01049',
    county: 'Cherokee',
    county_names_all: 'Cherokee|DeKalb',
    county_weights: '{"01019": 99.51, "01049": 0.49}',
    density: 29.5,
    imprecise: false,
    latitude: 34.23968,
    longitude: -85.60575,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35959',
  },
  {
    city: 'Centre',
    county_fips: 1019,
    county_fips_all: '01019',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"01019": 100}',
    density: 25.6,
    imprecise: false,
    latitude: 34.12515,
    longitude: -85.56786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35960',
  },
  {
    city: 'Collinsville',
    county_fips: 1049,
    county_fips_all: '01049|01019|01055',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Cherokee|Etowah',
    county_weights: '{"01049": 81.47, "01019": 10.57, "01055": 7.96}',
    density: 19.2,
    imprecise: false,
    latitude: 34.27753,
    longitude: -85.86241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35961',
  },
  {
    city: 'Crossville',
    county_fips: 1049,
    county_fips_all: '01049|01095',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Marshall',
    county_weights: '{"01049": 90.75, "01095": 9.25}',
    density: 46.8,
    imprecise: false,
    latitude: 34.29916,
    longitude: -86.03795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35962',
  },
  {
    city: 'Dawson',
    county_fips: 1049,
    county_fips_all: '01049',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"01049": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 34.35812,
    longitude: -85.93114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35963',
  },
  {
    city: 'Flat Rock',
    county_fips: 1071,
    county_fips_all: '01071|01049',
    county: 'Jackson',
    county_names_all: 'Jackson|DeKalb',
    county_weights: '{"01071": 75.52, "01049": 24.48}',
    density: 16.2,
    imprecise: false,
    latitude: 34.79696,
    longitude: -85.68833,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35966',
  },
  {
    city: 'Fort Payne',
    county_fips: 1049,
    county_fips_all: '01049|01019',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Cherokee',
    county_weights: '{"01049": 92.34, "01019": 7.66}',
    density: 51.5,
    imprecise: false,
    latitude: 34.3981,
    longitude: -85.69698,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35967',
  },
  {
    city: 'Fort Payne',
    county_fips: 1049,
    county_fips_all: '01049',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"01049": 100}',
    density: 28.9,
    imprecise: false,
    latitude: 34.48095,
    longitude: -85.77232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35968',
  },
  {
    city: 'Fyffe',
    county_fips: 1049,
    county_fips_all: '01049|01071',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Jackson',
    county_weights: '{"01049": 99.66, "01071": 0.34}',
    density: 31.1,
    imprecise: false,
    latitude: 34.45603,
    longitude: -85.9466,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35971',
  },
  {
    city: 'Gallant',
    county_fips: 1055,
    county_fips_all: '01055|01115',
    county: 'Etowah',
    county_names_all: 'Etowah|St. Clair',
    county_weights: '{"01055": 64.99, "01115": 35.01}',
    density: 19,
    imprecise: false,
    latitude: 33.98797,
    longitude: -86.24943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35972',
  },
  {
    city: 'Gaylesville',
    county_fips: 1019,
    county_fips_all: '01019',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"01019": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 34.34222,
    longitude: -85.5554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35973',
  },
  {
    city: 'Geraldine',
    county_fips: 1049,
    county_fips_all: '01049',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"01049": 100}',
    density: 47.4,
    imprecise: false,
    latitude: 34.36284,
    longitude: -86.0099,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35974',
  },
  {
    city: 'Groveoak',
    county_fips: 1049,
    county_fips_all: '01049|01095',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Marshall',
    county_weights: '{"01049": 72.66, "01095": 27.34}',
    density: 18.7,
    imprecise: false,
    latitude: 34.43832,
    longitude: -86.06655,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35975',
  },
  {
    city: 'Guntersville',
    county_fips: 1095,
    county_fips_all: '01095|01009',
    county: 'Marshall',
    county_names_all: 'Marshall|Blount',
    county_weights: '{"01095": 93.82, "01009": 6.18}',
    density: 50.8,
    imprecise: false,
    latitude: 34.34819,
    longitude: -86.32919,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35976',
  },
  {
    city: 'Henagar',
    county_fips: 1049,
    county_fips_all: '01049|01071',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Jackson',
    county_weights: '{"01049": 77.51, "01071": 22.49}',
    density: 31.1,
    imprecise: false,
    latitude: 34.64239,
    longitude: -85.72983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35978',
  },
  {
    city: 'Higdon',
    county_fips: 1049,
    county_fips_all: '01049|01071',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Jackson',
    county_weights: '{"01049": 64.23, "01071": 35.77}',
    density: 36.7,
    imprecise: false,
    latitude: 34.82994,
    longitude: -85.6125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35979',
  },
  {
    city: 'Horton',
    county_fips: 1095,
    county_fips_all: '01095|01009',
    county: 'Marshall',
    county_names_all: 'Marshall|Blount',
    county_weights: '{"01095": 52.17, "01009": 47.83}',
    density: 45,
    imprecise: false,
    latitude: 34.17719,
    longitude: -86.38335,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35980',
  },
  {
    city: 'Ider',
    county_fips: 1049,
    county_fips_all: '01049',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"01049": 100}',
    density: 30.4,
    imprecise: false,
    latitude: 34.72218,
    longitude: -85.64072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35981',
  },
  {
    city: 'Leesburg',
    county_fips: 1019,
    county_fips_all: '01019|01049',
    county: 'Cherokee',
    county_names_all: 'Cherokee|DeKalb',
    county_weights: '{"01019": 99.6, "01049": 0.4}',
    density: 28.6,
    imprecise: false,
    latitude: 34.17088,
    longitude: -85.76746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35983',
  },
  {
    city: 'Mentone',
    county_fips: 1049,
    county_fips_all: '01049|01019',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Cherokee',
    county_weights: '{"01049": 70.23, "01019": 29.77}',
    density: 7.7,
    imprecise: false,
    latitude: 34.52781,
    longitude: -85.56594,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35984',
  },
  {
    city: 'Rainsville',
    county_fips: 1049,
    county_fips_all: '01049',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"01049": 100}',
    density: 73.6,
    imprecise: false,
    latitude: 34.50524,
    longitude: -85.84012,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35986',
  },
  {
    city: 'Steele',
    county_fips: 1115,
    county_fips_all: '01115',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"01115": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 33.91557,
    longitude: -86.23889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35987',
  },
  {
    city: 'Sylvania',
    county_fips: 1049,
    county_fips_all: '01049',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"01049": 100}',
    density: 74.3,
    imprecise: false,
    latitude: 34.5589,
    longitude: -85.79994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35988',
  },
  {
    city: 'Valley Head',
    county_fips: 1049,
    county_fips_all: '01049',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"01049": 100}',
    density: 22.5,
    imprecise: false,
    latitude: 34.60858,
    longitude: -85.63162,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35989',
  },
  {
    city: 'Walnut Grove',
    county_fips: 1055,
    county_fips_all: '01055',
    county: 'Etowah',
    county_names_all: 'Etowah',
    county_weights: '{"01055": 100}',
    density: 481.5,
    imprecise: false,
    latitude: 34.06676,
    longitude: -86.3052,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35990',
  },
  {
    city: 'Autaugaville',
    county_fips: 1001,
    county_fips_all: '01001',
    county: 'Autauga',
    county_names_all: 'Autauga',
    county_weights: '{"01001": 100}',
    density: 9,
    imprecise: false,
    latitude: 32.44651,
    longitude: -86.72536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36003',
  },
  {
    city: 'Banks',
    county_fips: 1109,
    county_fips_all: '01109|01011|01005',
    county: 'Pike',
    county_names_all: 'Pike|Bullock|Barbour',
    county_weights: '{"01109": 54.7, "01011": 44.91, "01005": 0.39}',
    density: 4.1,
    imprecise: false,
    latitude: 31.88137,
    longitude: -85.72802,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36005',
  },
  {
    city: 'Billingsley',
    county_fips: 1001,
    county_fips_all: '01001|01021',
    county: 'Autauga',
    county_names_all: 'Autauga|Chilton',
    county_weights: '{"01001": 75.57, "01021": 24.43}',
    density: 10.3,
    imprecise: false,
    latitude: 32.63831,
    longitude: -86.72531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36006',
  },
  {
    city: 'Booth',
    county_fips: 1001,
    county_fips_all: '01001',
    county: 'Autauga',
    county_names_all: 'Autauga',
    county_weights: '{"01001": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.49747,
    longitude: -86.56416,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36008',
  },
  {
    city: 'Brantley',
    county_fips: 1041,
    county_fips_all: '01041|01031',
    county: 'Crenshaw',
    county_names_all: 'Crenshaw|Coffee',
    county_weights: '{"01041": 98.81, "01031": 1.19}',
    density: 5,
    imprecise: false,
    latitude: 31.58395,
    longitude: -86.30531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36009',
  },
  {
    city: 'Brundidge',
    county_fips: 1109,
    county_fips_all: '01109|01031|01045',
    county: 'Pike',
    county_names_all: 'Pike|Coffee|Dale',
    county_weights: '{"01109": 80.96, "01031": 16.98, "01045": 2.06}',
    density: 16.2,
    imprecise: false,
    latitude: 31.66751,
    longitude: -85.81439,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36010',
  },
  {
    city: 'Cecil',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 32.2976,
    longitude: -85.97959,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36013',
  },
  {
    city: 'Clayton',
    county_fips: 1005,
    county_fips_all: '01005|01067',
    county: 'Barbour',
    county_names_all: 'Barbour|Henry',
    county_weights: '{"01005": 98.63, "01067": 1.37}',
    density: 7.3,
    imprecise: false,
    latitude: 31.84562,
    longitude: -85.4255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36016',
  },
  {
    city: 'Clio',
    county_fips: 1005,
    county_fips_all: '01005',
    county: 'Barbour',
    county_names_all: 'Barbour',
    county_weights: '{"01005": 100}',
    density: 19.6,
    imprecise: false,
    latitude: 31.68142,
    longitude: -85.55411,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36017',
  },
  {
    city: 'Coosada',
    county_fips: 1051,
    county_fips_all: '01051',
    county: 'Elmore',
    county_names_all: 'Elmore',
    county_weights: '{"01051": 100}',
    density: 52,
    imprecise: false,
    latitude: 32.49616,
    longitude: -86.31858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36020',
  },
  {
    city: 'Deatsville',
    county_fips: 1051,
    county_fips_all: '01051|01001',
    county: 'Elmore',
    county_names_all: 'Elmore|Autauga',
    county_weights: '{"01051": 56.31, "01001": 43.69}',
    density: 67.3,
    imprecise: false,
    latitude: 32.61951,
    longitude: -86.40492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36022',
  },
  {
    city: 'Eclectic',
    county_fips: 1051,
    county_fips_all: '01051',
    county: 'Elmore',
    county_names_all: 'Elmore',
    county_weights: '{"01051": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 32.6654,
    longitude: -86.03312,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36024',
  },
  {
    city: 'Elmore',
    county_fips: 1051,
    county_fips_all: '01051',
    county: 'Elmore',
    county_names_all: 'Elmore',
    county_weights: '{"01051": 100}',
    density: 224.4,
    imprecise: false,
    latitude: 32.54664,
    longitude: -86.33941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36025',
  },
  {
    city: 'Equality',
    county_fips: 1037,
    county_fips_all: '01037|01051',
    county: 'Coosa',
    county_names_all: 'Coosa|Elmore',
    county_weights: '{"01037": 75.92, "01051": 24.08}',
    density: 8.1,
    imprecise: false,
    latitude: 32.77587,
    longitude: -86.13269,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36026',
  },
  {
    city: 'Eufaula',
    county_fips: 1005,
    county_fips_all: '01005|01113|01067',
    county: 'Barbour',
    county_names_all: 'Barbour|Russell|Henry',
    county_weights: '{"01005": 85.23, "01113": 12.07, "01067": 2.7}',
    density: 19.8,
    imprecise: false,
    latitude: 31.93307,
    longitude: -85.20968,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36027',
  },
  {
    city: 'Dozier',
    county_fips: 1039,
    county_fips_all: '01039|01041',
    county: 'Covington',
    county_names_all: 'Covington|Crenshaw',
    county_weights: '{"01039": 60.06, "01041": 39.94}',
    density: 5.3,
    imprecise: false,
    latitude: 31.49031,
    longitude: -86.38271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36028',
  },
  {
    city: 'Fitzpatrick',
    county_fips: 1011,
    county_fips_all: '01011|01087|01101',
    county: 'Bullock',
    county_names_all: 'Bullock|Macon|Montgomery',
    county_weights: '{"01011": 87.58, "01087": 9.12, "01101": 3.3}',
    density: 2.6,
    imprecise: false,
    latitude: 32.18479,
    longitude: -85.92953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36029',
  },
  {
    city: 'Forest Home',
    county_fips: 1013,
    county_fips_all: '01013',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"01013": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 31.86044,
    longitude: -86.85697,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36030',
  },
  {
    city: 'Fort Davis',
    county_fips: 1087,
    county_fips_all: '01087|01011',
    county: 'Macon',
    county_names_all: 'Macon|Bullock',
    county_weights: '{"01087": 99.9, "01011": 0.1}',
    density: 5.6,
    imprecise: false,
    latitude: 32.24944,
    longitude: -85.75157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36031',
  },
  {
    city: 'Fort Deposit',
    county_fips: 1085,
    county_fips_all: '01085|01013',
    county: 'Lowndes',
    county_names_all: 'Lowndes|Butler',
    county_weights: '{"01085": 85.68, "01013": 14.32}',
    density: 8,
    imprecise: false,
    latitude: 31.99857,
    longitude: -86.57179,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36032',
  },
  {
    city: 'Georgiana',
    county_fips: 1013,
    county_fips_all: '01013|01035|01099',
    county: 'Butler',
    county_names_all: 'Butler|Conecuh|Monroe',
    county_weights: '{"01013": 90.47, "01035": 7.51, "01099": 2.02}',
    density: 6.9,
    imprecise: false,
    latitude: 31.66983,
    longitude: -86.771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36033',
  },
  {
    city: 'Glenwood',
    county_fips: 1109,
    county_fips_all: '01109|01031|01041',
    county: 'Pike',
    county_names_all: 'Pike|Coffee|Crenshaw',
    county_weights: '{"01109": 47.59, "01031": 32.09, "01041": 20.32}',
    density: 3.2,
    imprecise: false,
    latitude: 31.62308,
    longitude: -86.11155,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36034',
  },
  {
    city: 'Goshen',
    county_fips: 1109,
    county_fips_all: '01109|01041',
    county: 'Pike',
    county_names_all: 'Pike|Crenshaw',
    county_weights: '{"01109": 80.19, "01041": 19.81}',
    density: 6.2,
    imprecise: false,
    latitude: 31.79285,
    longitude: -86.12415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36035',
  },
  {
    city: 'Grady',
    county_fips: 1101,
    county_fips_all: '01101|01041',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Crenshaw',
    county_weights: '{"01101": 69.84, "01041": 30.16}',
    density: 7.5,
    imprecise: false,
    latitude: 31.97541,
    longitude: -86.16063,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36036',
  },
  {
    city: 'Greenville',
    county_fips: 1013,
    county_fips_all: '01013|01041',
    county: 'Butler',
    county_names_all: 'Butler|Crenshaw',
    county_weights: '{"01013": 98.02, "01041": 1.98}',
    density: 13.3,
    imprecise: false,
    latitude: 31.79384,
    longitude: -86.62356,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36037',
  },
  {
    city: 'Gantt',
    county_fips: 1039,
    county_fips_all: '01039',
    county: 'Covington',
    county_names_all: 'Covington',
    county_weights: '{"01039": 100}',
    density: 108.5,
    imprecise: false,
    latitude: 31.40788,
    longitude: -86.4869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36038',
  },
  {
    city: 'Hayneville',
    county_fips: 1085,
    county_fips_all: '01085',
    county: 'Lowndes',
    county_names_all: 'Lowndes',
    county_weights: '{"01085": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 32.17795,
    longitude: -86.66972,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36040',
  },
  {
    city: 'Highland Home',
    county_fips: 1041,
    county_fips_all: '01041|01101',
    county: 'Crenshaw',
    county_names_all: 'Crenshaw|Montgomery',
    county_weights: '{"01041": 98.85, "01101": 1.15}',
    density: 10.8,
    imprecise: false,
    latitude: 31.92361,
    longitude: -86.32172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36041',
  },
  {
    city: 'Honoraville',
    county_fips: 1041,
    county_fips_all: '01041|01013',
    county: 'Crenshaw',
    county_names_all: 'Crenshaw|Butler',
    county_weights: '{"01041": 50.87, "01013": 49.13}',
    density: 8.6,
    imprecise: false,
    latitude: 31.86655,
    longitude: -86.44897,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36042',
  },
  {
    city: 'Hope Hull',
    county_fips: 1085,
    county_fips_all: '01085|01101',
    county: 'Lowndes',
    county_names_all: 'Lowndes|Montgomery',
    county_weights: '{"01085": 55.77, "01101": 44.23}',
    density: 10.1,
    imprecise: false,
    latitude: 32.1939,
    longitude: -86.42811,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36043',
  },
  {
    city: 'Lapine',
    county_fips: 1041,
    county_fips_all: '01041|01101',
    county: 'Crenshaw',
    county_names_all: 'Crenshaw|Montgomery',
    county_weights: '{"01041": 67.4, "01101": 32.6}',
    density: 8.6,
    imprecise: false,
    latitude: 31.9994,
    longitude: -86.33948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36046',
  },
  {
    city: 'Letohatchee',
    county_fips: 1085,
    county_fips_all: '01085|01101',
    county: 'Lowndes',
    county_names_all: 'Lowndes|Montgomery',
    county_weights: '{"01085": 90.02, "01101": 9.98}',
    density: 4,
    imprecise: false,
    latitude: 32.07868,
    longitude: -86.52474,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36047',
  },
  {
    city: 'Louisville',
    county_fips: 1005,
    county_fips_all: '01005',
    county: 'Barbour',
    county_names_all: 'Barbour',
    county_weights: '{"01005": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 31.79011,
    longitude: -85.59066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36048',
  },
  {
    city: 'Luverne',
    county_fips: 1041,
    county_fips_all: '01041|01109',
    county: 'Crenshaw',
    county_names_all: 'Crenshaw|Pike',
    county_weights: '{"01041": 95.81, "01109": 4.19}',
    density: 12.3,
    imprecise: false,
    latitude: 31.76612,
    longitude: -86.28092,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36049',
  },
  {
    city: 'Marbury',
    county_fips: 1001,
    county_fips_all: '01001|01051|01021',
    county: 'Autauga',
    county_names_all: 'Autauga|Elmore|Chilton',
    county_weights: '{"01001": 63.88, "01051": 19.93, "01021": 16.19}',
    density: 22.6,
    imprecise: false,
    latitude: 32.68771,
    longitude: -86.488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36051',
  },
  {
    city: 'Mathews',
    county_fips: 1101,
    county_fips_all: '01101|01011',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Bullock',
    county_weights: '{"01101": 90.35, "01011": 9.65}',
    density: 4.6,
    imprecise: false,
    latitude: 32.17935,
    longitude: -86.04309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36052',
  },
  {
    city: 'Midway',
    county_fips: 1005,
    county_fips_all: '01005|01011',
    county: 'Barbour',
    county_names_all: 'Barbour|Bullock',
    county_weights: '{"01005": 58.93, "01011": 41.07}',
    density: 2.9,
    imprecise: false,
    latitude: 32.03514,
    longitude: -85.43945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36053',
  },
  {
    city: 'Millbrook',
    county_fips: 1051,
    county_fips_all: '01051|01101',
    county: 'Elmore',
    county_names_all: 'Elmore|Montgomery',
    county_weights: '{"01051": 86.92, "01101": 13.08}',
    density: 200.9,
    imprecise: false,
    latitude: 32.46821,
    longitude: -86.35962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36054',
  },
  {
    city: 'Mount Meigs',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 323.2,
    imprecise: false,
    latitude: 32.37464,
    longitude: -86.08461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36057',
  },
  {
    city: 'Pike Road',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 63.3,
    imprecise: false,
    latitude: 32.3008,
    longitude: -86.08186,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36064',
  },
  {
    city: 'Prattville',
    county_fips: 1001,
    county_fips_all: '01001|01051',
    county: 'Autauga',
    county_names_all: 'Autauga|Elmore',
    county_weights: '{"01001": 67.38, "01051": 32.62}',
    density: 434.3,
    imprecise: false,
    latitude: 32.48216,
    longitude: -86.42431,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36066',
  },
  {
    city: 'Prattville',
    county_fips: 1001,
    county_fips_all: '01001',
    county: 'Autauga',
    county_names_all: 'Autauga',
    county_weights: '{"01001": 100}',
    density: 44.7,
    imprecise: false,
    latitude: 32.51134,
    longitude: -86.57084,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36067',
  },
  {
    city: 'Ramer',
    county_fips: 1101,
    county_fips_all: '01101|01109',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Pike',
    county_weights: '{"01101": 94.69, "01109": 5.31}',
    density: 5.3,
    imprecise: false,
    latitude: 32.0905,
    longitude: -86.16008,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36069',
  },
  {
    city: 'Rutledge',
    county_fips: 1041,
    county_fips_all: '01041|01013',
    county: 'Crenshaw',
    county_names_all: 'Crenshaw|Butler',
    county_weights: '{"01041": 86.78, "01013": 13.22}',
    density: 4.3,
    imprecise: false,
    latitude: 31.70534,
    longitude: -86.39815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36071',
  },
  {
    city: 'Shorter',
    county_fips: 1087,
    county_fips_all: '01087',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"01087": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 32.38913,
    longitude: -85.91257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36075',
  },
  {
    city: 'Tallassee',
    county_fips: 1051,
    county_fips_all: '01051|01123|01087',
    county: 'Elmore',
    county_names_all: 'Elmore|Tallapoosa|Macon',
    county_weights: '{"01051": 73.1, "01123": 24.27, "01087": 2.63}',
    density: 30,
    imprecise: false,
    latitude: 32.53991,
    longitude: -85.93328,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36078',
  },
  {
    city: 'Troy',
    county_fips: 1109,
    county_fips_all: '01109|01031',
    county: 'Pike',
    county_names_all: 'Pike|Coffee',
    county_weights: '{"01109": 92.92, "01031": 7.08}',
    density: 18.9,
    imprecise: false,
    latitude: 31.76605,
    longitude: -86.01206,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36079',
  },
  {
    city: 'Titus',
    county_fips: 1051,
    county_fips_all: '01051|01037',
    county: 'Elmore',
    county_names_all: 'Elmore|Coosa',
    county_weights: '{"01051": 96.66, "01037": 3.34}',
    density: 18.8,
    imprecise: false,
    latitude: 32.70497,
    longitude: -86.28662,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36080',
  },
  {
    city: 'Troy',
    county_fips: 1109,
    county_fips_all: '01109|01011',
    county: 'Pike',
    county_names_all: 'Pike|Bullock',
    county_weights: '{"01109": 85.26, "01011": 14.74}',
    density: 27.9,
    imprecise: false,
    latitude: 31.90663,
    longitude: -85.89804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36081',
  },
  {
    city: 'Tuskegee',
    county_fips: 1087,
    county_fips_all: '01087',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"01087": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 32.39512,
    longitude: -85.68672,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36083',
  },
  {
    city: 'Tuskegee Institute',
    county_fips: 1087,
    county_fips_all: '01087',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"01087": 100}',
    density: 452.2,
    imprecise: false,
    latitude: 32.41911,
    longitude: -85.718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36088',
  },
  {
    city: 'Union Springs',
    county_fips: 1011,
    county_fips_all: '01011|01087',
    county: 'Bullock',
    county_names_all: 'Bullock|Macon',
    county_weights: '{"01011": 77.86, "01087": 22.14}',
    density: 9.2,
    imprecise: false,
    latitude: 32.15745,
    longitude: -85.69872,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36089',
  },
  {
    city: 'Verbena',
    county_fips: 1021,
    county_fips_all: '01021|01001|01037',
    county: 'Chilton',
    county_names_all: 'Chilton|Autauga|Coosa',
    county_weights: '{"01021": 84.65, "01001": 14.99, "01037": 0.36}',
    density: 15.2,
    imprecise: false,
    latitude: 32.74881,
    longitude: -86.52021,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36091',
  },
  {
    city: 'Wetumpka',
    county_fips: 1051,
    county_fips_all: '01051',
    county: 'Elmore',
    county_names_all: 'Elmore',
    county_weights: '{"01051": 100}',
    density: 62.2,
    imprecise: false,
    latitude: 32.61401,
    longitude: -86.19619,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36092',
  },
  {
    city: 'Wetumpka',
    county_fips: 1051,
    county_fips_all: '01051',
    county: 'Elmore',
    county_names_all: 'Elmore',
    county_weights: '{"01051": 100}',
    density: 56.1,
    imprecise: false,
    latitude: 32.49584,
    longitude: -86.13956,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36093',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 3579.7,
    imprecise: false,
    latitude: 32.38177,
    longitude: -86.29763,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36101',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 389.2,
    imprecise: false,
    latitude: 32.39889,
    longitude: -86.31593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36104',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 51.7,
    imprecise: false,
    latitude: 32.21808,
    longitude: -86.28778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36105',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 877.3,
    imprecise: false,
    latitude: 32.35264,
    longitude: -86.25793,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36106',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 969,
    imprecise: false,
    latitude: 32.38434,
    longitude: -86.2795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36107',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 81.1,
    imprecise: false,
    latitude: 32.33956,
    longitude: -86.40602,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36108',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 803.6,
    imprecise: false,
    latitude: 32.38682,
    longitude: -86.24052,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36109',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 158.4,
    imprecise: false,
    latitude: 32.44899,
    longitude: -86.25566,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36110',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 1074.5,
    imprecise: false,
    latitude: 32.33755,
    longitude: -86.27154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36111',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 532.7,
    imprecise: false,
    latitude: 32.38146,
    longitude: -86.34172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36113',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 862.3,
    imprecise: false,
    latitude: 32.40688,
    longitude: -86.24685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36115',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 327.5,
    imprecise: false,
    latitude: 32.27312,
    longitude: -86.21765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36116',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 385.4,
    imprecise: false,
    latitude: 32.37831,
    longitude: -86.14627,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36117',
  },
  {
    city: 'Anniston',
    county_fips: 1015,
    county_fips_all: '01015',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"01015": 100}',
    density: 168.5,
    imprecise: false,
    latitude: 33.65082,
    longitude: -85.88264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36201',
  },
  {
    city: 'Oxford',
    county_fips: 1015,
    county_fips_all: '01015|01121',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Talladega',
    county_weights: '{"01015": 60.36, "01121": 39.64}',
    density: 185.2,
    imprecise: false,
    latitude: 33.58205,
    longitude: -85.83312,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36203',
  },
  {
    city: 'Anniston',
    county_fips: 1015,
    county_fips_all: '01015',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"01015": 100}',
    density: 34.4,
    imprecise: false,
    latitude: 33.70037,
    longitude: -85.78898,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36205',
  },
  {
    city: 'Anniston',
    county_fips: 1015,
    county_fips_all: '01015',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"01015": 100}',
    density: 273.7,
    imprecise: false,
    latitude: 33.73225,
    longitude: -85.81638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36206',
  },
  {
    city: 'Anniston',
    county_fips: 1015,
    county_fips_all: '01015',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"01015": 100}',
    density: 99.2,
    imprecise: false,
    latitude: 33.68196,
    longitude: -85.71356,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36207',
  },
  {
    city: 'Alexandria',
    county_fips: 1015,
    county_fips_all: '01015',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"01015": 100}',
    density: 85.4,
    imprecise: false,
    latitude: 33.76564,
    longitude: -85.89675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36250',
  },
  {
    city: 'Ashland',
    county_fips: 1027,
    county_fips_all: '01027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"01027": 100}',
    density: 14,
    imprecise: false,
    latitude: 33.22996,
    longitude: -85.86532,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36251',
  },
  {
    city: 'Cragford',
    county_fips: 1027,
    county_fips_all: '01027|01123',
    county: 'Clay',
    county_names_all: 'Clay|Tallapoosa',
    county_weights: '{"01027": 97.74, "01123": 2.26}',
    density: 6.3,
    imprecise: false,
    latitude: 33.18094,
    longitude: -85.73933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36255',
  },
  {
    city: 'Daviston',
    county_fips: 1123,
    county_fips_all: '01123|01027',
    county: 'Tallapoosa',
    county_names_all: 'Tallapoosa|Clay',
    county_weights: '{"01123": 96.07, "01027": 3.93}',
    density: 6.2,
    imprecise: false,
    latitude: 33.04181,
    longitude: -85.70775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36256',
  },
  {
    city: 'Delta',
    county_fips: 1029,
    county_fips_all: '01029|01027|01111',
    county: 'Cleburne',
    county_names_all: 'Cleburne|Clay|Randolph',
    county_weights: '{"01029": 46.13, "01027": 42.39, "01111": 11.48}',
    density: 6.1,
    imprecise: false,
    latitude: 33.47795,
    longitude: -85.716,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36258',
  },
  {
    city: 'Eastaboga',
    county_fips: 1121,
    county_fips_all: '01121|01015',
    county: 'Talladega',
    county_names_all: 'Talladega|Calhoun',
    county_weights: '{"01121": 63.23, "01015": 36.77}',
    density: 61.7,
    imprecise: false,
    latitude: 33.58662,
    longitude: -86.00025,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36260',
  },
  {
    city: 'Fruithurst',
    county_fips: 1029,
    county_fips_all: '01029',
    county: 'Cleburne',
    county_names_all: 'Cleburne',
    county_weights: '{"01029": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 33.7965,
    longitude: -85.46741,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36262',
  },
  {
    city: 'Graham',
    county_fips: 1111,
    county_fips_all: '01111|01029',
    county: 'Randolph',
    county_names_all: 'Randolph|Cleburne',
    county_weights: '{"01111": 99.88, "01029": 0.12}',
    density: 9.9,
    imprecise: false,
    latitude: 33.46727,
    longitude: -85.36016,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36263',
  },
  {
    city: 'Heflin',
    county_fips: 1029,
    county_fips_all: '01029|01111',
    county: 'Cleburne',
    county_names_all: 'Cleburne|Randolph',
    county_weights: '{"01029": 91.7, "01111": 8.3}',
    density: 13,
    imprecise: false,
    latitude: 33.59305,
    longitude: -85.53817,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36264',
  },
  {
    city: 'Jacksonville',
    county_fips: 1015,
    county_fips_all: '01015',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"01015": 100}',
    density: 88.4,
    imprecise: false,
    latitude: 33.84659,
    longitude: -85.78662,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36265',
  },
  {
    city: 'Lineville',
    county_fips: 1027,
    county_fips_all: '01027|01111',
    county: 'Clay',
    county_names_all: 'Clay|Randolph',
    county_weights: '{"01027": 78.77, "01111": 21.23}',
    density: 11.8,
    imprecise: false,
    latitude: 33.35338,
    longitude: -85.75062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36266',
  },
  {
    city: 'Millerville',
    county_fips: 1027,
    county_fips_all: '01027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"01027": 100}',
    density: 87.2,
    imprecise: false,
    latitude: 33.19513,
    longitude: -85.94659,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36267',
  },
  {
    city: 'Munford',
    county_fips: 1121,
    county_fips_all: '01121|01027',
    county: 'Talladega',
    county_names_all: 'Talladega|Clay',
    county_weights: '{"01121": 89.67, "01027": 10.33}',
    density: 23.9,
    imprecise: false,
    latitude: 33.49469,
    longitude: -85.94016,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36268',
  },
  {
    city: 'Muscadine',
    county_fips: 1029,
    county_fips_all: '01029',
    county: 'Cleburne',
    county_names_all: 'Cleburne',
    county_weights: '{"01029": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 33.73569,
    longitude: -85.38314,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36269',
  },
  {
    city: 'Ohatchee',
    county_fips: 1015,
    county_fips_all: '01015|01055',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Etowah',
    county_weights: '{"01015": 99.82, "01055": 0.18}',
    density: 28.8,
    imprecise: false,
    latitude: 33.78215,
    longitude: -86.01624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36271',
  },
  {
    city: 'Piedmont',
    county_fips: 1019,
    county_fips_all: '01019|01015|01029|01055',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Calhoun|Cleburne|Etowah',
    county_weights:
      '{"01019": 42.22, "01015": 33.51, "01029": 19.63, "01055": 4.64}',
    density: 15.7,
    imprecise: false,
    latitude: 33.94441,
    longitude: -85.60454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36272',
  },
  {
    city: 'Ranburne',
    county_fips: 1029,
    county_fips_all: '01029',
    county: 'Cleburne',
    county_names_all: 'Cleburne',
    county_weights: '{"01029": 100}',
    density: 27.4,
    imprecise: false,
    latitude: 33.53904,
    longitude: -85.37742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36273',
  },
  {
    city: 'Roanoke',
    county_fips: 1111,
    county_fips_all: '01111|01017',
    county: 'Randolph',
    county_names_all: 'Randolph|Chambers',
    county_weights: '{"01111": 82.79, "01017": 17.21}',
    density: 21.4,
    imprecise: false,
    latitude: 33.17687,
    longitude: -85.36283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36274',
  },
  {
    city: 'Wadley',
    county_fips: 1111,
    county_fips_all: '01111|01017|01027|01123',
    county: 'Randolph',
    county_names_all: 'Randolph|Chambers|Clay|Tallapoosa',
    county_weights:
      '{"01111": 54.6, "01017": 24.2, "01027": 14.75, "01123": 6.45}',
    density: 6.8,
    imprecise: false,
    latitude: 33.12644,
    longitude: -85.57772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36276',
  },
  {
    city: 'Weaver',
    county_fips: 1015,
    county_fips_all: '01015',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"01015": 100}',
    density: 246.5,
    imprecise: false,
    latitude: 33.7609,
    longitude: -85.81541,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36277',
  },
  {
    city: 'Wedowee',
    county_fips: 1111,
    county_fips_all: '01111',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"01111": 100}',
    density: 12,
    imprecise: false,
    latitude: 33.31885,
    longitude: -85.5253,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36278',
  },
  {
    city: 'Wellington',
    county_fips: 1015,
    county_fips_all: '01015',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"01015": 100}',
    density: 39,
    imprecise: false,
    latitude: 33.87237,
    longitude: -85.88645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36279',
  },
  {
    city: 'Woodland',
    county_fips: 1111,
    county_fips_all: '01111',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"01111": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 33.38427,
    longitude: -85.3891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36280',
  },
  {
    city: 'Dothan',
    county_fips: 1069,
    county_fips_all: '01069|01061',
    county: 'Houston',
    county_names_all: 'Houston|Geneva',
    county_weights: '{"01069": 95.38, "01061": 4.62}',
    density: 170.8,
    imprecise: false,
    latitude: 31.14387,
    longitude: -85.40321,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36301',
  },
  {
    city: 'Dothan',
    county_fips: 1069,
    county_fips_all: '01069|01045|01067',
    county: 'Houston',
    county_names_all: 'Houston|Dale|Henry',
    county_weights: '{"01069": 90.88, "01045": 8.19, "01067": 0.93}',
    density: 197.9,
    imprecise: false,
    latitude: 31.26389,
    longitude: -85.39213,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36303',
  },
  {
    city: 'Dothan',
    county_fips: 1069,
    county_fips_all: '01069|01061',
    county: 'Houston',
    county_names_all: 'Houston|Geneva',
    county_weights: '{"01069": 65.52, "01061": 34.48}',
    density: 219.4,
    imprecise: false,
    latitude: 31.20229,
    longitude: -85.49798,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36305',
  },
  {
    city: 'Abbeville',
    county_fips: 1067,
    county_fips_all: '01067',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"01067": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 31.60296,
    longitude: -85.21229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36310',
  },
  {
    city: 'Ariton',
    county_fips: 1045,
    county_fips_all: '01045|01005|01031',
    county: 'Dale',
    county_names_all: 'Dale|Barbour|Coffee',
    county_weights: '{"01045": 54.84, "01005": 35.58, "01031": 9.58}',
    density: 9.5,
    imprecise: false,
    latitude: 31.60092,
    longitude: -85.68372,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36311',
  },
  {
    city: 'Ashford',
    county_fips: 1069,
    county_fips_all: '01069',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"01069": 100}',
    density: 32.6,
    imprecise: false,
    latitude: 31.16748,
    longitude: -85.23867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36312',
  },
  {
    city: 'Bellwood',
    county_fips: 1061,
    county_fips_all: '01061',
    county: 'Geneva',
    county_names_all: 'Geneva',
    county_weights: '{"01061": 100}',
    density: 19,
    imprecise: false,
    latitude: 31.18024,
    longitude: -85.79368,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36313',
  },
  {
    city: 'Black',
    county_fips: 1061,
    county_fips_all: '01061',
    county: 'Geneva',
    county_names_all: 'Geneva',
    county_weights: '{"01061": 100}',
    density: 10,
    imprecise: false,
    latitude: 31.02141,
    longitude: -85.77645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36314',
  },
  {
    city: 'Chancellor',
    county_fips: 1061,
    county_fips_all: '01061|01031',
    county: 'Geneva',
    county_names_all: 'Geneva|Coffee',
    county_weights: '{"01061": 65.39, "01031": 34.61}',
    density: 14.6,
    imprecise: false,
    latitude: 31.17835,
    longitude: -85.86496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36316',
  },
  {
    city: 'Clopton',
    county_fips: 1067,
    county_fips_all: '01067|01045|01005',
    county: 'Henry',
    county_names_all: 'Henry|Dale|Barbour',
    county_weights: '{"01067": 83.46, "01045": 8.69, "01005": 7.85}',
    density: 9.8,
    imprecise: false,
    latitude: 31.63532,
    longitude: -85.38748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36317',
  },
  {
    city: 'Coffee Springs',
    county_fips: 1061,
    county_fips_all: '01061|01031',
    county: 'Geneva',
    county_names_all: 'Geneva|Coffee',
    county_weights: '{"01061": 67.84, "01031": 32.16}',
    density: 9.9,
    imprecise: false,
    latitude: 31.17612,
    longitude: -85.95653,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36318',
  },
  {
    city: 'Columbia',
    county_fips: 1067,
    county_fips_all: '01067|01069',
    county: 'Henry',
    county_names_all: 'Henry|Houston',
    county_weights: '{"01067": 60.45, "01069": 39.55}',
    density: 9.2,
    imprecise: false,
    latitude: 31.32367,
    longitude: -85.14931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36319',
  },
  {
    city: 'Cottonwood',
    county_fips: 1069,
    county_fips_all: '01069',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"01069": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 31.05105,
    longitude: -85.31765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36320',
  },
  {
    city: 'Cowarts',
    county_fips: 1069,
    county_fips_all: '01069',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"01069": 100}',
    density: 130.9,
    imprecise: false,
    latitude: 31.20558,
    longitude: -85.30093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36321',
  },
  {
    city: 'Daleville',
    county_fips: 1045,
    county_fips_all: '01045|01061|01031',
    county: 'Dale',
    county_names_all: 'Dale|Geneva|Coffee',
    county_weights: '{"01045": 93.04, "01061": 5.96, "01031": 1.0}',
    density: 51.7,
    imprecise: false,
    latitude: 31.25575,
    longitude: -85.73249,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36322',
  },
  {
    city: 'Elba',
    county_fips: 1031,
    county_fips_all: '01031',
    county: 'Coffee',
    county_names_all: 'Coffee',
    county_weights: '{"01031": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 31.42702,
    longitude: -86.07221,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36323',
  },
  {
    city: 'Enterprise',
    county_fips: 1031,
    county_fips_all: '01031|01045',
    county: 'Coffee',
    county_names_all: 'Coffee|Dale',
    county_weights: '{"01031": 92.39, "01045": 7.61}',
    density: 137.4,
    imprecise: false,
    latitude: 31.30743,
    longitude: -85.85854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36330',
  },
  {
    city: 'Geneva',
    county_fips: 1061,
    county_fips_all: '01061',
    county: 'Geneva',
    county_names_all: 'Geneva',
    county_weights: '{"01061": 100}',
    density: 41.6,
    imprecise: false,
    latitude: 31.05391,
    longitude: -85.89155,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36340',
  },
  {
    city: 'Gordon',
    county_fips: 1069,
    county_fips_all: '01069',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"01069": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 31.05753,
    longitude: -85.11812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36343',
  },
  {
    city: 'Hartford',
    county_fips: 1061,
    county_fips_all: '01061',
    county: 'Geneva',
    county_names_all: 'Geneva',
    county_weights: '{"01061": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 31.1007,
    longitude: -85.70931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36344',
  },
  {
    city: 'Headland',
    county_fips: 1067,
    county_fips_all: '01067|01069|01045',
    county: 'Henry',
    county_names_all: 'Henry|Houston|Dale',
    county_weights: '{"01067": 83.77, "01069": 9.94, "01045": 6.29}',
    density: 27.5,
    imprecise: false,
    latitude: 31.3741,
    longitude: -85.31,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36345',
  },
  {
    city: 'Jack',
    county_fips: 1031,
    county_fips_all: '01031',
    county: 'Coffee',
    county_names_all: 'Coffee',
    county_weights: '{"01031": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 31.55783,
    longitude: -85.9331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36346',
  },
  {
    city: 'Midland City',
    county_fips: 1045,
    county_fips_all: '01045|01069',
    county: 'Dale',
    county_names_all: 'Dale|Houston',
    county_weights: '{"01045": 97.76, "01069": 2.24}',
    density: 38.3,
    imprecise: false,
    latitude: 31.3435,
    longitude: -85.49669,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36350',
  },
  {
    city: 'New Brockton',
    county_fips: 1031,
    county_fips_all: '01031',
    county: 'Coffee',
    county_names_all: 'Coffee',
    county_weights: '{"01031": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 31.41469,
    longitude: -85.90596,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36351',
  },
  {
    city: 'Newton',
    county_fips: 1069,
    county_fips_all: '01069|01045|01061',
    county: 'Houston',
    county_names_all: 'Houston|Dale|Geneva',
    county_weights: '{"01069": 58.07, "01045": 39.01, "01061": 2.92}',
    density: 31.1,
    imprecise: false,
    latitude: 31.25682,
    longitude: -85.61629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36352',
  },
  {
    city: 'Newville',
    county_fips: 1067,
    county_fips_all: '01067|01045',
    county: 'Henry',
    county_names_all: 'Henry|Dale',
    county_weights: '{"01067": 81.98, "01045": 18.02}',
    density: 8.5,
    imprecise: false,
    latitude: 31.4817,
    longitude: -85.36208,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36353',
  },
  {
    city: 'Ozark',
    county_fips: 1045,
    county_fips_all: '01045|01031',
    county: 'Dale',
    county_names_all: 'Dale|Coffee',
    county_weights: '{"01045": 98.57, "01031": 1.43}',
    density: 41.4,
    imprecise: false,
    latitude: 31.46648,
    longitude: -85.61641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36360',
  },
  {
    city: 'Fort Novosel',
    county_fips: 1045,
    county_fips_all: '01045',
    county: 'Dale',
    county_names_all: 'Dale',
    county_weights: '{"01045": 100}',
    density: 61.8,
    imprecise: false,
    latitude: 31.35072,
    longitude: -85.69027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36362',
  },
  {
    city: 'Pansey',
    county_fips: 1069,
    county_fips_all: '01069',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"01069": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 31.13175,
    longitude: -85.15688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36370',
  },
  {
    city: 'Pinckard',
    county_fips: 1045,
    county_fips_all: '01045',
    county: 'Dale',
    county_names_all: 'Dale',
    county_weights: '{"01045": 100}',
    density: 49.6,
    imprecise: false,
    latitude: 31.3208,
    longitude: -85.54738,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36371',
  },
  {
    city: 'Shorterville',
    county_fips: 1067,
    county_fips_all: '01067',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"01067": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 31.52131,
    longitude: -85.10355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36373',
  },
  {
    city: 'Skipperville',
    county_fips: 1045,
    county_fips_all: '01045|01005',
    county: 'Dale',
    county_names_all: 'Dale|Barbour',
    county_weights: '{"01045": 88.53, "01005": 11.47}',
    density: 4.9,
    imprecise: false,
    latitude: 31.5723,
    longitude: -85.48956,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36374',
  },
  {
    city: 'Slocomb',
    county_fips: 1061,
    county_fips_all: '01061|01069',
    county: 'Geneva',
    county_names_all: 'Geneva|Houston',
    county_weights: '{"01061": 78.64, "01069": 21.36}',
    density: 24.9,
    imprecise: false,
    latitude: 31.07681,
    longitude: -85.54111,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36375',
  },
  {
    city: 'Webb',
    county_fips: 1069,
    county_fips_all: '01069',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"01069": 100}',
    density: 33.9,
    imprecise: false,
    latitude: 31.25213,
    longitude: -85.26961,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36376',
  },
  {
    city: 'Evergreen',
    county_fips: 1035,
    county_fips_all: '01035|01099|01053',
    county: 'Conecuh',
    county_names_all: 'Conecuh|Monroe|Escambia',
    county_weights: '{"01035": 93.53, "01099": 5.68, "01053": 0.79}',
    density: 6.4,
    imprecise: false,
    latitude: 31.47123,
    longitude: -86.94928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36401',
  },
  {
    city: 'Andalusia',
    county_fips: 1039,
    county_fips_all: '01039|01053',
    county: 'Covington',
    county_names_all: 'Covington|Escambia',
    county_weights: '{"01039": 80.27, "01053": 19.73}',
    density: 15.1,
    imprecise: false,
    latitude: 31.18092,
    longitude: -86.57618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36420',
  },
  {
    city: 'Andalusia',
    county_fips: 1039,
    county_fips_all: '01039|01035',
    county: 'Covington',
    county_names_all: 'Covington|Conecuh',
    county_weights: '{"01039": 84.07, "01035": 15.93}',
    density: 17.7,
    imprecise: false,
    latitude: 31.32769,
    longitude: -86.50903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36421',
  },
  {
    city: 'Beatrice',
    county_fips: 1099,
    county_fips_all: '01099',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"01099": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 31.75884,
    longitude: -87.19731,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36425',
  },
  {
    city: 'Brewton',
    county_fips: 1053,
    county_fips_all: '01053|01035',
    county: 'Escambia',
    county_names_all: 'Escambia|Conecuh',
    county_weights: '{"01053": 96.26, "01035": 3.74}',
    density: 12.7,
    imprecise: false,
    latitude: 31.14386,
    longitude: -87.076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36426',
  },
  {
    city: 'Castleberry',
    county_fips: 1035,
    county_fips_all: '01035|01053',
    county: 'Conecuh',
    county_names_all: 'Conecuh|Escambia',
    county_weights: '{"01035": 74.91, "01053": 25.09}',
    density: 5.4,
    imprecise: false,
    latitude: 31.30055,
    longitude: -87.03888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36432',
  },
  {
    city: 'Coy',
    county_fips: 1131,
    county_fips_all: '01131|01099',
    county: 'Wilcox',
    county_names_all: 'Wilcox|Monroe',
    county_weights: '{"01131": 99.85, "01099": 0.15}',
    density: 4.6,
    imprecise: false,
    latitude: 31.87889,
    longitude: -87.45564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36435',
  },
  {
    city: 'Dickinson',
    county_fips: 1025,
    county_fips_all: '01025',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"01025": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 31.76636,
    longitude: -87.6614,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36436',
  },
  {
    city: 'Excel',
    county_fips: 1099,
    county_fips_all: '01099',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"01099": 100}',
    density: 62.2,
    imprecise: false,
    latitude: 31.42252,
    longitude: -87.34512,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36439',
  },
  {
    city: 'Flomaton',
    county_fips: 1053,
    county_fips_all: '01053',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"01053": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 31.04064,
    longitude: -87.25885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36441',
  },
  {
    city: 'Florala',
    county_fips: 1039,
    county_fips_all: '01039|01061',
    county: 'Covington',
    county_names_all: 'Covington|Geneva',
    county_weights: '{"01039": 99.6, "01061": 0.4}',
    density: 6.7,
    imprecise: false,
    latitude: 31.07312,
    longitude: -86.36355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36442',
  },
  {
    city: 'Franklin',
    county_fips: 1099,
    county_fips_all: '01099',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"01099": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 31.65935,
    longitude: -87.4651,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36444',
  },
  {
    city: 'Frisco City',
    county_fips: 1099,
    county_fips_all: '01099',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"01099": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 31.44397,
    longitude: -87.44982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36445',
  },
  {
    city: 'Fulton',
    county_fips: 1025,
    county_fips_all: '01025',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"01025": 100}',
    density: 89.3,
    imprecise: false,
    latitude: 31.79146,
    longitude: -87.72446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36446',
  },
  {
    city: 'Grove Hill',
    county_fips: 1025,
    county_fips_all: '01025',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"01025": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 31.69769,
    longitude: -87.80664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36451',
  },
  {
    city: 'Kinston',
    county_fips: 1031,
    county_fips_all: '01031|01061|01039',
    county: 'Coffee',
    county_names_all: 'Coffee|Geneva|Covington',
    county_weights: '{"01031": 52.26, "01061": 39.06, "01039": 8.68}',
    density: 10.1,
    imprecise: false,
    latitude: 31.19788,
    longitude: -86.14726,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36453',
  },
  {
    city: 'Lenox',
    county_fips: 1035,
    county_fips_all: '01035',
    county: 'Conecuh',
    county_names_all: 'Conecuh',
    county_weights: '{"01035": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 31.34368,
    longitude: -87.20185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36454',
  },
  {
    city: 'Lockhart',
    county_fips: 1039,
    county_fips_all: '01039',
    county: 'Covington',
    county_names_all: 'Covington',
    county_weights: '{"01039": 100}',
    density: 188.6,
    imprecise: false,
    latitude: 31.01212,
    longitude: -86.35321,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36455',
  },
  {
    city: 'McKenzie',
    county_fips: 1035,
    county_fips_all: '01035|01013|01039',
    county: 'Conecuh',
    county_names_all: 'Conecuh|Butler|Covington',
    county_weights: '{"01035": 51.08, "01013": 42.74, "01039": 6.18}',
    density: 4,
    imprecise: false,
    latitude: 31.57103,
    longitude: -86.82556,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36456',
  },
  {
    city: 'Monroeville',
    county_fips: 1099,
    county_fips_all: '01099|01035',
    county: 'Monroe',
    county_names_all: 'Monroe|Conecuh',
    county_weights: '{"01099": 96.92, "01035": 3.08}',
    density: 24.6,
    imprecise: false,
    latitude: 31.52679,
    longitude: -87.30786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36460',
  },
  {
    city: 'Opp',
    county_fips: 1039,
    county_fips_all: '01039|01031',
    county: 'Covington',
    county_names_all: 'Covington|Coffee',
    county_weights: '{"01039": 94.16, "01031": 5.84}',
    density: 23.4,
    imprecise: false,
    latitude: 31.2795,
    longitude: -86.25579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36467',
  },
  {
    city: 'Perdue Hill',
    county_fips: 1099,
    county_fips_all: '01099',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"01099": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.51602,
    longitude: -87.55518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36470',
  },
  {
    city: 'Peterman',
    county_fips: 1099,
    county_fips_all: '01099|01035',
    county: 'Monroe',
    county_names_all: 'Monroe|Conecuh',
    county_weights: '{"01099": 90.14, "01035": 9.86}',
    density: 2,
    imprecise: false,
    latitude: 31.62616,
    longitude: -87.22861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36471',
  },
  {
    city: 'Range',
    county_fips: 1035,
    county_fips_all: '01035',
    county: 'Conecuh',
    county_names_all: 'Conecuh',
    county_weights: '{"01035": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 31.32009,
    longitude: -87.21967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 95,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36473',
  },
  {
    city: 'Red Level',
    county_fips: 1039,
    county_fips_all: '01039|01035|01013',
    county: 'Covington',
    county_names_all: 'Covington|Conecuh|Butler',
    county_weights: '{"01039": 74.12, "01035": 14.77, "01013": 11.11}',
    density: 5.7,
    imprecise: false,
    latitude: 31.42664,
    longitude: -86.62022,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36474',
  },
  {
    city: 'Repton',
    county_fips: 1035,
    county_fips_all: '01035|01099',
    county: 'Conecuh',
    county_names_all: 'Conecuh|Monroe',
    county_weights: '{"01035": 86.87, "01099": 13.13}',
    density: 5,
    imprecise: false,
    latitude: 31.38511,
    longitude: -87.22717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36475',
  },
  {
    city: 'River Falls',
    county_fips: 1039,
    county_fips_all: '01039',
    county: 'Covington',
    county_names_all: 'Covington',
    county_weights: '{"01039": 100}',
    density: 47.1,
    imprecise: false,
    latitude: 31.35359,
    longitude: -86.54633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36476',
  },
  {
    city: 'Samson',
    county_fips: 1061,
    county_fips_all: '01061|01031|01039',
    county: 'Geneva',
    county_names_all: 'Geneva|Coffee|Covington',
    county_weights: '{"01061": 89.06, "01031": 10.49, "01039": 0.45}',
    density: 11.1,
    imprecise: false,
    latitude: 31.08741,
    longitude: -86.05407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36477',
  },
  {
    city: 'Uriah',
    county_fips: 1099,
    county_fips_all: '01099',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"01099": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 31.32976,
    longitude: -87.61125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36480',
  },
  {
    city: 'Vredenburgh',
    county_fips: 1099,
    county_fips_all: '01099',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"01099": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 31.77356,
    longitude: -87.37553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36481',
  },
  {
    city: 'Whatley',
    county_fips: 1025,
    county_fips_all: '01025|01099',
    county: 'Clarke',
    county_names_all: 'Clarke|Monroe',
    county_weights: '{"01025": 91.24, "01099": 8.76}',
    density: 1.7,
    imprecise: false,
    latitude: 31.6223,
    longitude: -87.63424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36482',
  },
  {
    city: 'Wing',
    county_fips: 1039,
    county_fips_all: '01039|01053',
    county: 'Covington',
    county_names_all: 'Covington|Escambia',
    county_weights: '{"01039": 54.84, "01053": 45.16}',
    density: 2,
    imprecise: false,
    latitude: 31.04273,
    longitude: -86.68494,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36483',
  },
  {
    city: 'Atmore',
    county_fips: 1053,
    county_fips_all: '01053|01003|01099|01035',
    county: 'Escambia',
    county_names_all: 'Escambia|Baldwin|Monroe|Conecuh',
    county_weights:
      '{"01053": 79.3, "01003": 10.09, "01099": 7.75, "01035": 2.86}',
    density: 18.2,
    imprecise: false,
    latitude: 31.14498,
    longitude: -87.49303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36502',
  },
  {
    city: 'Axis',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 30.94978,
    longitude: -88.0225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36505',
  },
  {
    city: 'Bay Minette',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 30.85893,
    longitude: -87.74188,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36507',
  },
  {
    city: 'Bayou La Batre',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 48,
    imprecise: false,
    latitude: 30.4077,
    longitude: -88.24726,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36509',
  },
  {
    city: 'Bon Secour',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 66.1,
    imprecise: false,
    latitude: 30.31173,
    longitude: -87.74259,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36511',
  },
  {
    city: 'Bucks',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 31.00327,
    longitude: -88.01023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36512',
  },
  {
    city: 'Calvert',
    county_fips: 1129,
    county_fips_all: '01129|01097',
    county: 'Washington',
    county_names_all: 'Washington|Mobile',
    county_weights: '{"01129": 52.84, "01097": 47.16}',
    density: 8.1,
    imprecise: false,
    latitude: 31.15516,
    longitude: -87.99021,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36513',
  },
  {
    city: 'Chatom',
    county_fips: 1129,
    county_fips_all: '01129',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"01129": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 31.47082,
    longitude: -88.27546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36518',
  },
  {
    city: 'Chunchula',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 30.96241,
    longitude: -88.18526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36521',
  },
  {
    city: 'Citronelle',
    county_fips: 1097,
    county_fips_all: '01097|01129',
    county: 'Mobile',
    county_names_all: 'Mobile|Washington',
    county_weights: '{"01097": 77.56, "01129": 22.44}',
    density: 11.8,
    imprecise: false,
    latitude: 31.08296,
    longitude: -88.27795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36522',
  },
  {
    city: 'Coden',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 31.2,
    imprecise: false,
    latitude: 30.37852,
    longitude: -88.16536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36523',
  },
  {
    city: 'Coffeeville',
    county_fips: 1025,
    county_fips_all: '01025',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"01025": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 31.80868,
    longitude: -88.0203,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36524',
  },
  {
    city: 'Creola',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 42.6,
    imprecise: false,
    latitude: 30.8898,
    longitude: -88.02329,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36525',
  },
  {
    city: 'Daphne',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 373.7,
    imprecise: false,
    latitude: 30.61187,
    longitude: -87.86151,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36526',
  },
  {
    city: 'Daphne',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 198.5,
    imprecise: false,
    latitude: 30.69679,
    longitude: -87.87734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36527',
  },
  {
    city: 'Dauphin Island',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 113.9,
    imprecise: false,
    latitude: 30.25253,
    longitude: -88.14381,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36528',
  },
  {
    city: 'Deer Park',
    county_fips: 1129,
    county_fips_all: '01129',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"01129": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 31.29279,
    longitude: -88.27281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36529',
  },
  {
    city: 'Elberta',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 30.41192,
    longitude: -87.55445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36530',
  },
  {
    city: 'Fairhope',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 201.1,
    imprecise: false,
    latitude: 30.48197,
    longitude: -87.86207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36532',
  },
  {
    city: 'Foley',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 169.5,
    imprecise: false,
    latitude: 30.38562,
    longitude: -87.72514,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36535',
  },
  {
    city: 'Frankville',
    county_fips: 1129,
    county_fips_all: '01129',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"01129": 100}',
    density: 3,
    imprecise: false,
    latitude: 31.65948,
    longitude: -88.13836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36538',
  },
  {
    city: 'Fruitdale',
    county_fips: 1129,
    county_fips_all: '01129',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"01129": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 31.3475,
    longitude: -88.39358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36539',
  },
  {
    city: 'Gainestown',
    county_fips: 1025,
    county_fips_all: '01025',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"01025": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 31.44702,
    longitude: -87.66487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36540',
  },
  {
    city: 'Grand Bay',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 64.6,
    imprecise: false,
    latitude: 30.49084,
    longitude: -88.34384,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36541',
  },
  {
    city: 'Gulf Shores',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 140.4,
    imprecise: false,
    latitude: 30.27683,
    longitude: -87.73867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36542',
  },
  {
    city: 'Huxford',
    county_fips: 1053,
    county_fips_all: '01053',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"01053": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 31.22129,
    longitude: -87.46592,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36543',
  },
  {
    city: 'Irvington',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 100,
    imprecise: false,
    latitude: 30.47436,
    longitude: -88.234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36544',
  },
  {
    city: 'Jackson',
    county_fips: 1025,
    county_fips_all: '01025',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"01025": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 31.48767,
    longitude: -87.87424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36545',
  },
  {
    city: 'Gulf Shores',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.25278,
    longitude: -87.65405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36547',
  },
  {
    city: 'Leroy',
    county_fips: 1129,
    county_fips_all: '01129',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"01129": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 31.48326,
    longitude: -87.97226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36548',
  },
  {
    city: 'Lillian',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 74.7,
    imprecise: false,
    latitude: 30.41377,
    longitude: -87.44951,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36549',
  },
  {
    city: 'Little River',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 31.25212,
    longitude: -87.74294,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36550',
  },
  {
    city: 'Loxley',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 70,
    imprecise: false,
    latitude: 30.63982,
    longitude: -87.7504,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36551',
  },
  {
    city: 'McIntosh',
    county_fips: 1129,
    county_fips_all: '01129',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"01129": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 31.22852,
    longitude: -88.08658,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36553',
  },
  {
    city: 'Magnolia Springs',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 420.8,
    imprecise: false,
    latitude: 30.40006,
    longitude: -87.77312,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36555',
  },
  {
    city: 'Malcolm',
    county_fips: 1129,
    county_fips_all: '01129',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"01129": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.20649,
    longitude: -87.97127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36556',
  },
  {
    city: 'Millry',
    county_fips: 1129,
    county_fips_all: '01129|01023',
    county: 'Washington',
    county_names_all: 'Washington|Choctaw',
    county_weights: '{"01129": 89.45, "01023": 10.55}',
    density: 6.9,
    imprecise: false,
    latitude: 31.61606,
    longitude: -88.33034,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36558',
  },
  {
    city: 'Montrose',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 221.7,
    imprecise: false,
    latitude: 30.56894,
    longitude: -87.90393,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36559',
  },
  {
    city: 'Mount Vernon',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 31.08553,
    longitude: -88.04991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36560',
  },
  {
    city: 'Orange Beach',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 220.3,
    imprecise: false,
    latitude: 30.28813,
    longitude: -87.57142,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36561',
  },
  {
    city: 'Perdido',
    county_fips: 1003,
    county_fips_all: '01003|01053',
    county: 'Baldwin',
    county_names_all: 'Baldwin|Escambia',
    county_weights: '{"01003": 94.77, "01053": 5.23}',
    density: 12.7,
    imprecise: false,
    latitude: 31.03738,
    longitude: -87.66274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36562',
  },
  {
    city: 'Point Clear',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.46983,
    longitude: -87.91467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36564',
  },
  {
    city: 'Robertsdale',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 30.61483,
    longitude: -87.55792,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36567',
  },
  {
    city: 'Saint Elmo',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 108.8,
    imprecise: false,
    latitude: 30.51291,
    longitude: -88.27067,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36568',
  },
  {
    city: 'Saint Stephens',
    county_fips: 1129,
    county_fips_all: '01129',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"01129": 100}',
    density: 4,
    imprecise: false,
    latitude: 31.54418,
    longitude: -88.07907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36569',
  },
  {
    city: 'Saraland',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 168.5,
    imprecise: false,
    latitude: 30.85055,
    longitude: -88.10415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36571',
  },
  {
    city: 'Satsuma',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 331.4,
    imprecise: false,
    latitude: 30.85617,
    longitude: -88.05956,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36572',
  },
  {
    city: 'Seminole',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 37.8,
    imprecise: false,
    latitude: 30.5141,
    longitude: -87.48258,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36574',
  },
  {
    city: 'Semmes',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 226.2,
    imprecise: false,
    latitude: 30.76825,
    longitude: -88.27276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36575',
  },
  {
    city: 'Silverhill',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 88.9,
    imprecise: false,
    latitude: 30.52654,
    longitude: -87.76654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36576',
  },
  {
    city: 'Stapleton',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 24.4,
    imprecise: false,
    latitude: 30.73867,
    longitude: -87.77275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36578',
  },
  {
    city: 'Stockton',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 4,
    imprecise: false,
    latitude: 31.11395,
    longitude: -87.78616,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36579',
  },
  {
    city: 'Summerdale',
    county_fips: 1003,
    county_fips_all: '01003',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"01003": 100}',
    density: 48.7,
    imprecise: false,
    latitude: 30.48085,
    longitude: -87.70321,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36580',
  },
  {
    city: 'Sunflower',
    county_fips: 1129,
    county_fips_all: '01129',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"01129": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 31.36645,
    longitude: -88.0098,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36581',
  },
  {
    city: 'Theodore',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 114.8,
    imprecise: false,
    latitude: 30.51616,
    longitude: -88.17719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36582',
  },
  {
    city: 'Tibbie',
    county_fips: 1129,
    county_fips_all: '01129',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"01129": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 31.36677,
    longitude: -88.1869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36583',
  },
  {
    city: 'Vinegar Bend',
    county_fips: 1129,
    county_fips_all: '01129',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"01129": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 31.19579,
    longitude: -88.38385,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36584',
  },
  {
    city: 'Wagarville',
    county_fips: 1129,
    county_fips_all: '01129',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"01129": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 31.36985,
    longitude: -88.02338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36585',
  },
  {
    city: 'Wilmer',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 41.7,
    imprecise: false,
    latitude: 30.83599,
    longitude: -88.35006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36587',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 102.6,
    imprecise: false,
    latitude: 30.69834,
    longitude: -88.03815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36602',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 785.2,
    imprecise: false,
    latitude: 30.68426,
    longitude: -88.05273,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36603',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 1313.4,
    imprecise: false,
    latitude: 30.68229,
    longitude: -88.06837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36604',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 551.3,
    imprecise: false,
    latitude: 30.60649,
    longitude: -88.09064,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36605',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 1056,
    imprecise: false,
    latitude: 30.67088,
    longitude: -88.10617,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36606',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 691.6,
    imprecise: false,
    latitude: 30.699,
    longitude: -88.10552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36607',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 230.5,
    imprecise: false,
    latitude: 30.68115,
    longitude: -88.29593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36608',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 1372.4,
    imprecise: false,
    latitude: 30.66086,
    longitude: -88.16378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36609',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 505.1,
    imprecise: false,
    latitude: 30.73721,
    longitude: -88.07389,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36610',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 500.9,
    imprecise: false,
    latitude: 30.7702,
    longitude: -88.07747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36611',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 421,
    imprecise: false,
    latitude: 30.75283,
    longitude: -88.11285,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36612',
  },
  {
    city: 'Eight Mile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 90.8,
    imprecise: false,
    latitude: 30.81175,
    longitude: -88.18176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36613',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.63563,
    longitude: -88.06717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36615',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 948.2,
    imprecise: false,
    latitude: 30.71544,
    longitude: -88.09518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36617',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 433.4,
    imprecise: false,
    latitude: 30.73612,
    longitude: -88.17333,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36618',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 319,
    imprecise: false,
    latitude: 30.59488,
    longitude: -88.19302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36619',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 599.6,
    imprecise: false,
    latitude: 30.69586,
    longitude: -88.0803,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36652',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 1244.2,
    imprecise: false,
    latitude: 30.73683,
    longitude: -88.10896,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36663',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 567.2,
    imprecise: false,
    latitude: 30.62676,
    longitude: -88.14989,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36693',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 446.1,
    imprecise: false,
    latitude: 30.6309,
    longitude: -88.27775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36695',
  },
  {
    city: 'Selma',
    county_fips: 1047,
    county_fips_all: '01047|01105',
    county: 'Dallas',
    county_names_all: 'Dallas|Perry',
    county_weights: '{"01047": 63.58, "01105": 36.42}',
    density: 30.9,
    imprecise: false,
    latitude: 32.49672,
    longitude: -87.0568,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36701',
  },
  {
    city: 'Selma',
    county_fips: 1047,
    county_fips_all: '01047|01001',
    county: 'Dallas',
    county_names_all: 'Dallas|Autauga',
    county_weights: '{"01047": 74.29, "01001": 25.71}',
    density: 28.2,
    imprecise: false,
    latitude: 32.43387,
    longitude: -86.91118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36703',
  },
  {
    city: 'Alberta',
    county_fips: 1131,
    county_fips_all: '01131',
    county: 'Wilcox',
    county_names_all: 'Wilcox',
    county_weights: '{"01131": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 32.16493,
    longitude: -87.34684,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36720',
  },
  {
    city: 'Arlington',
    county_fips: 1131,
    county_fips_all: '01131|01091',
    county: 'Wilcox',
    county_names_all: 'Wilcox|Marengo',
    county_weights: '{"01131": 92.59, "01091": 7.41}',
    density: 1.3,
    imprecise: false,
    latitude: 32.08124,
    longitude: -87.57661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36722',
  },
  {
    city: 'Boykin',
    county_fips: 1131,
    county_fips_all: '01131',
    county: 'Wilcox',
    county_names_all: 'Wilcox',
    county_weights: '{"01131": 100}',
    density: 16.1,
    imprecise: false,
    latitude: 32.06633,
    longitude: -87.2907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36723',
  },
  {
    city: 'Camden',
    county_fips: 1131,
    county_fips_all: '01131|01099',
    county: 'Wilcox',
    county_names_all: 'Wilcox|Monroe',
    county_weights: '{"01131": 99.85, "01099": 0.15}',
    density: 6,
    imprecise: false,
    latitude: 31.97043,
    longitude: -87.27532,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36726',
  },
  {
    city: 'Campbell',
    county_fips: 1025,
    county_fips_all: '01025',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"01025": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 31.91193,
    longitude: -88.02054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36727',
  },
  {
    city: 'Catherine',
    county_fips: 1131,
    county_fips_all: '01131|01091',
    county: 'Wilcox',
    county_names_all: 'Wilcox|Marengo',
    county_weights: '{"01131": 75.9, "01091": 24.1}',
    density: 3.3,
    imprecise: false,
    latitude: 32.16625,
    longitude: -87.48416,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36728',
  },
  {
    city: 'Demopolis',
    county_fips: 1091,
    county_fips_all: '01091',
    county: 'Marengo',
    county_names_all: 'Marengo',
    county_weights: '{"01091": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 32.41638,
    longitude: -87.91367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36732',
  },
  {
    city: 'Dixons Mills',
    county_fips: 1091,
    county_fips_all: '01091',
    county: 'Marengo',
    county_names_all: 'Marengo',
    county_weights: '{"01091": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 32.07832,
    longitude: -87.76444,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36736',
  },
  {
    city: 'Faunsdale',
    county_fips: 1091,
    county_fips_all: '01091|01065',
    county: 'Marengo',
    county_names_all: 'Marengo|Hale',
    county_weights: '{"01091": 73.05, "01065": 26.95}',
    density: 3.9,
    imprecise: false,
    latitude: 32.43421,
    longitude: -87.62481,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36738',
  },
  {
    city: 'Forkland',
    county_fips: 1063,
    county_fips_all: '01063',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"01063": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 32.62421,
    longitude: -87.83209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36740',
  },
  {
    city: 'Furman',
    county_fips: 1131,
    county_fips_all: '01131',
    county: 'Wilcox',
    county_names_all: 'Wilcox',
    county_weights: '{"01131": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.02198,
    longitude: -87.02594,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36741',
  },
  {
    city: 'Gallion',
    county_fips: 1091,
    county_fips_all: '01091|01065',
    county: 'Marengo',
    county_names_all: 'Marengo|Hale',
    county_weights: '{"01091": 71.57, "01065": 28.43}',
    density: 8.7,
    imprecise: false,
    latitude: 32.45836,
    longitude: -87.74215,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36742',
  },
  {
    city: 'Greensboro',
    county_fips: 1065,
    county_fips_all: '01065|01105',
    county: 'Hale',
    county_names_all: 'Hale|Perry',
    county_weights: '{"01065": 98.49, "01105": 1.51}',
    density: 9.5,
    imprecise: false,
    latitude: 32.69178,
    longitude: -87.59845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36744',
  },
  {
    city: 'Linden',
    county_fips: 1091,
    county_fips_all: '01091',
    county: 'Marengo',
    county_names_all: 'Marengo',
    county_weights: '{"01091": 100}',
    density: 7,
    imprecise: false,
    latitude: 32.27084,
    longitude: -87.77728,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36748',
  },
  {
    city: 'Jones',
    county_fips: 1001,
    county_fips_all: '01001|01047',
    county: 'Autauga',
    county_names_all: 'Autauga|Dallas',
    county_weights: '{"01001": 83.42, "01047": 16.58}',
    density: 5.4,
    imprecise: false,
    latitude: 32.54759,
    longitude: -86.85303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36749',
  },
  {
    city: 'Maplesville',
    county_fips: 1021,
    county_fips_all: '01021|01007',
    county: 'Chilton',
    county_names_all: 'Chilton|Bibb',
    county_weights: '{"01021": 98.76, "01007": 1.24}',
    density: 11.7,
    imprecise: false,
    latitude: 32.78396,
    longitude: -86.84361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36750',
  },
  {
    city: 'Lower Peach Tree',
    county_fips: 1025,
    county_fips_all: '01025|01131|01099',
    county: 'Clarke',
    county_names_all: 'Clarke|Wilcox|Monroe',
    county_weights: '{"01025": 39.96, "01131": 33.98, "01099": 26.05}',
    density: 3.2,
    imprecise: false,
    latitude: 31.80808,
    longitude: -87.54865,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36751',
  },
  {
    city: 'Lowndesboro',
    county_fips: 1085,
    county_fips_all: '01085',
    county: 'Lowndes',
    county_names_all: 'Lowndes',
    county_weights: '{"01085": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 32.30628,
    longitude: -86.62544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36752',
  },
  {
    city: 'McWilliams',
    county_fips: 1131,
    county_fips_all: '01131|01099',
    county: 'Wilcox',
    county_names_all: 'Wilcox|Monroe',
    county_weights: '{"01131": 99.84, "01099": 0.16}',
    density: 0,
    imprecise: false,
    latitude: 31.83698,
    longitude: -87.10762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36753',
  },
  {
    city: 'Magnolia',
    county_fips: 1091,
    county_fips_all: '01091',
    county: 'Marengo',
    county_names_all: 'Marengo',
    county_weights: '{"01091": 100}',
    density: 3,
    imprecise: false,
    latitude: 32.15731,
    longitude: -87.70238,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36754',
  },
  {
    city: 'Marion',
    county_fips: 1105,
    county_fips_all: '01105|01065',
    county: 'Perry',
    county_names_all: 'Perry|Hale',
    county_weights: '{"01105": 99.9, "01065": 0.1}',
    density: 5.4,
    imprecise: false,
    latitude: 32.69327,
    longitude: -87.29873,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36756',
  },
  {
    city: 'Plantersville',
    county_fips: 1021,
    county_fips_all: '01021|01047|01001',
    county: 'Chilton',
    county_names_all: 'Chilton|Dallas|Autauga',
    county_weights: '{"01021": 37.77, "01047": 31.23, "01001": 31.0}',
    density: 7.2,
    imprecise: false,
    latitude: 32.6491,
    longitude: -86.89975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36758',
  },
  {
    city: 'Marion Junction',
    county_fips: 1047,
    county_fips_all: '01047|01105',
    county: 'Dallas',
    county_names_all: 'Dallas|Perry',
    county_weights: '{"01047": 79.63, "01105": 20.37}',
    density: 2.1,
    imprecise: false,
    latitude: 32.42977,
    longitude: -87.28722,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36759',
  },
  {
    city: 'Minter',
    county_fips: 1047,
    county_fips_all: '01047|01085|01131',
    county: 'Dallas',
    county_names_all: 'Dallas|Lowndes|Wilcox',
    county_weights: '{"01047": 59.94, "01085": 31.61, "01131": 8.45}',
    density: 1.4,
    imprecise: false,
    latitude: 32.07872,
    longitude: -86.97602,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36761',
  },
  {
    city: 'Myrtlewood',
    county_fips: 1091,
    county_fips_all: '01091',
    county: 'Marengo',
    county_names_all: 'Marengo',
    county_weights: '{"01091": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 32.26184,
    longitude: -87.96509,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36763',
  },
  {
    city: 'Nanafalia',
    county_fips: 1091,
    county_fips_all: '01091',
    county: 'Marengo',
    county_names_all: 'Marengo',
    county_weights: '{"01091": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.11518,
    longitude: -87.98526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36764',
  },
  {
    city: 'Newbern',
    county_fips: 1105,
    county_fips_all: '01105|01065',
    county: 'Perry',
    county_names_all: 'Perry|Hale',
    county_weights: '{"01105": 50.71, "01065": 49.29}',
    density: 3.8,
    imprecise: false,
    latitude: 32.59278,
    longitude: -87.51933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36765',
  },
  {
    city: 'Oak Hill',
    county_fips: 1131,
    county_fips_all: '01131',
    county: 'Wilcox',
    county_names_all: 'Wilcox',
    county_weights: '{"01131": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 31.95505,
    longitude: -87.08668,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36766',
  },
  {
    city: 'Orrville',
    county_fips: 1047,
    county_fips_all: '01047',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"01047": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 32.25083,
    longitude: -87.21042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36767',
  },
  {
    city: 'Pine Apple',
    county_fips: 1131,
    county_fips_all: '01131|01099',
    county: 'Wilcox',
    county_names_all: 'Wilcox|Monroe',
    county_weights: '{"01131": 73.4, "01099": 26.6}',
    density: 1.2,
    imprecise: false,
    latitude: 31.8837,
    longitude: -87.01186,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36768',
  },
  {
    city: 'Pine Hill',
    county_fips: 1131,
    county_fips_all: '01131|01091',
    county: 'Wilcox',
    county_names_all: 'Wilcox|Marengo',
    county_weights: '{"01131": 86.76, "01091": 13.24}',
    density: 5.6,
    imprecise: false,
    latitude: 31.99306,
    longitude: -87.55049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36769',
  },
  {
    city: 'Sardis',
    county_fips: 1047,
    county_fips_all: '01047|01085',
    county: 'Dallas',
    county_names_all: 'Dallas|Lowndes',
    county_weights: '{"01047": 64.65, "01085": 35.35}',
    density: 2.4,
    imprecise: false,
    latitude: 32.20066,
    longitude: -86.95487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36775',
  },
  {
    city: 'Sawyerville',
    county_fips: 1065,
    county_fips_all: '01065',
    county: 'Hale',
    county_names_all: 'Hale',
    county_weights: '{"01065": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 32.74513,
    longitude: -87.74488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36776',
  },
  {
    city: 'Sweet Water',
    county_fips: 1091,
    county_fips_all: '01091',
    county: 'Marengo',
    county_names_all: 'Marengo',
    county_weights: '{"01091": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 32.11684,
    longitude: -87.90996,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36782',
  },
  {
    city: 'Thomaston',
    county_fips: 1091,
    county_fips_all: '01091|01131',
    county: 'Marengo',
    county_names_all: 'Marengo|Wilcox',
    county_weights: '{"01091": 94.05, "01131": 5.95}',
    density: 2.4,
    imprecise: false,
    latitude: 32.24085,
    longitude: -87.6081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36783',
  },
  {
    city: 'Thomasville',
    county_fips: 1025,
    county_fips_all: '01025|01091|01131',
    county: 'Clarke',
    county_names_all: 'Clarke|Marengo|Wilcox',
    county_weights: '{"01025": 71.94, "01091": 26.3, "01131": 1.76}',
    density: 8.4,
    imprecise: false,
    latitude: 31.94208,
    longitude: -87.82271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36784',
  },
  {
    city: 'Tyler',
    county_fips: 1085,
    county_fips_all: '01085|01047',
    county: 'Lowndes',
    county_names_all: 'Lowndes|Dallas',
    county_weights: '{"01085": 55.65, "01047": 44.35}',
    density: 4.4,
    imprecise: false,
    latitude: 32.27615,
    longitude: -86.82683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36785',
  },
  {
    city: 'Uniontown',
    county_fips: 1105,
    county_fips_all: '01105|01091|01065',
    county: 'Perry',
    county_names_all: 'Perry|Marengo|Hale',
    county_weights: '{"01105": 77.1, "01091": 19.33, "01065": 3.57}',
    density: 6.2,
    imprecise: false,
    latitude: 32.43832,
    longitude: -87.49002,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36786',
  },
  {
    city: 'Stanton',
    county_fips: 1021,
    county_fips_all: '01021',
    county: 'Chilton',
    county_names_all: 'Chilton',
    county_weights: '{"01021": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 32.72758,
    longitude: -86.9107,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36790',
  },
  {
    city: 'Randolph',
    county_fips: 1007,
    county_fips_all: '01007|01021',
    county: 'Bibb',
    county_names_all: 'Bibb|Chilton',
    county_weights: '{"01007": 81.88, "01021": 18.12}',
    density: 4.1,
    imprecise: false,
    latitude: 32.92146,
    longitude: -86.91147,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36792',
  },
  {
    city: 'Lawley',
    county_fips: 1007,
    county_fips_all: '01007|01021|01105',
    county: 'Bibb',
    county_names_all: 'Bibb|Chilton|Perry',
    county_weights: '{"01007": 45.92, "01021": 30.95, "01105": 23.13}',
    density: 4.3,
    imprecise: false,
    latitude: 32.8292,
    longitude: -87.00947,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36793',
  },
  {
    city: 'Opelika',
    county_fips: 1081,
    county_fips_all: '01081|01017',
    county: 'Lee',
    county_names_all: 'Lee|Chambers',
    county_weights: '{"01081": 78.24, "01017": 21.76}',
    density: 125.4,
    imprecise: false,
    latitude: 32.701,
    longitude: -85.39243,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36801',
  },
  {
    city: 'Opelika',
    county_fips: 1081,
    county_fips_all: '01081|01113|01087',
    county: 'Lee',
    county_names_all: 'Lee|Russell|Macon',
    county_weights: '{"01081": 78.03, "01113": 14.56, "01087": 7.41}',
    density: 40.2,
    imprecise: false,
    latitude: 32.53045,
    longitude: -85.33875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36804',
  },
  {
    city: 'Auburn',
    county_fips: 1081,
    county_fips_all: '01081|01087',
    county: 'Lee',
    county_names_all: 'Lee|Macon',
    county_weights: '{"01081": 56.02, "01087": 43.98}',
    density: 173.8,
    imprecise: false,
    latitude: 32.5339,
    longitude: -85.49449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36830',
  },
  {
    city: 'Auburn',
    county_fips: 1081,
    county_fips_all: '01081|01087',
    county: 'Lee',
    county_names_all: 'Lee|Macon',
    county_weights: '{"01081": 96.94, "01087": 3.06}',
    density: 175.5,
    imprecise: false,
    latitude: 32.59447,
    longitude: -85.58163,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36832',
  },
  {
    city: 'Camp Hill',
    county_fips: 1123,
    county_fips_all: '01123|01017|01081',
    county: 'Tallapoosa',
    county_names_all: 'Tallapoosa|Chambers|Lee',
    county_weights: '{"01123": 72.36, "01017": 17.6, "01081": 10.04}',
    density: 6.4,
    imprecise: false,
    latitude: 32.78857,
    longitude: -85.65336,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36850',
  },
  {
    city: 'Cottonton',
    county_fips: 1113,
    county_fips_all: '01113',
    county: 'Russell',
    county_names_all: 'Russell',
    county_weights: '{"01113": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.15039,
    longitude: -85.08094,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36851',
  },
  {
    city: 'Cusseta',
    county_fips: 1017,
    county_fips_all: '01017|01081',
    county: 'Chambers',
    county_names_all: 'Chambers|Lee',
    county_weights: '{"01017": 60.49, "01081": 39.51}',
    density: 30.4,
    imprecise: false,
    latitude: 32.75343,
    longitude: -85.27942,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36852',
  },
  {
    city: 'Dadeville',
    county_fips: 1123,
    county_fips_all: '01123',
    county: 'Tallapoosa',
    county_names_all: 'Tallapoosa',
    county_weights: '{"01123": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 32.80557,
    longitude: -85.76809,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36853',
  },
  {
    city: 'Valley',
    county_fips: 1017,
    county_fips_all: '01017|01081',
    county: 'Chambers',
    county_names_all: 'Chambers|Lee',
    county_weights: '{"01017": 56.35, "01081": 43.65}',
    density: 105.6,
    imprecise: false,
    latitude: 32.75257,
    longitude: -85.18484,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36854',
  },
  {
    city: 'Five Points',
    county_fips: 1017,
    county_fips_all: '01017|13285',
    county: 'Chambers',
    county_names_all: 'Chambers|Troup',
    county_weights: '{"01017": 98.94, "13285": 1.06}',
    density: 7.8,
    imprecise: false,
    latitude: 33.03709,
    longitude: -85.30516,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36855',
  },
  {
    city: 'Fort Mitchell',
    county_fips: 1113,
    county_fips_all: '01113',
    county: 'Russell',
    county_names_all: 'Russell',
    county_weights: '{"01113": 100}',
    density: 86.9,
    imprecise: false,
    latitude: 32.26897,
    longitude: -84.99757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36856',
  },
  {
    city: 'Hatchechubbee',
    county_fips: 1113,
    county_fips_all: '01113',
    county: 'Russell',
    county_names_all: 'Russell',
    county_weights: '{"01113": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 32.30061,
    longitude: -85.30138,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36858',
  },
  {
    city: 'Hurtsboro',
    county_fips: 1113,
    county_fips_all: '01113|01087|01011',
    county: 'Russell',
    county_names_all: 'Russell|Macon|Bullock',
    county_weights: '{"01113": 62.5, "01087": 19.35, "01011": 18.15}',
    density: 3.7,
    imprecise: false,
    latitude: 32.26118,
    longitude: -85.42064,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36860',
  },
  {
    city: 'Jacksons Gap',
    county_fips: 1123,
    county_fips_all: '01123',
    county: 'Tallapoosa',
    county_names_all: 'Tallapoosa',
    county_weights: '{"01123": 100}',
    density: 22,
    imprecise: false,
    latitude: 32.88585,
    longitude: -85.83232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36861',
  },
  {
    city: 'Lafayette',
    county_fips: 1017,
    county_fips_all: '01017',
    county: 'Chambers',
    county_names_all: 'Chambers',
    county_weights: '{"01017": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 32.90612,
    longitude: -85.44283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36862',
  },
  {
    city: 'Lanett',
    county_fips: 1017,
    county_fips_all: '01017',
    county: 'Chambers',
    county_names_all: 'Chambers',
    county_weights: '{"01017": 100}',
    density: 48.1,
    imprecise: false,
    latitude: 32.89722,
    longitude: -85.25916,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36863',
  },
  {
    city: 'Loachapoka',
    county_fips: 1081,
    county_fips_all: '01081',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"01081": 100}',
    density: 73.9,
    imprecise: false,
    latitude: 32.60259,
    longitude: -85.58946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36865',
  },
  {
    city: 'Notasulga',
    county_fips: 1087,
    county_fips_all: '01087|01123|01081',
    county: 'Macon',
    county_names_all: 'Macon|Tallapoosa|Lee',
    county_weights: '{"01087": 68.59, "01123": 22.49, "01081": 8.92}',
    density: 17.2,
    imprecise: false,
    latitude: 32.55468,
    longitude: -85.71459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36866',
  },
  {
    city: 'Phenix City',
    county_fips: 1113,
    county_fips_all: '01113|01081',
    county: 'Russell',
    county_names_all: 'Russell|Lee',
    county_weights: '{"01113": 65.06, "01081": 34.94}',
    density: 701,
    imprecise: false,
    latitude: 32.49823,
    longitude: -85.02304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36867',
  },
  {
    city: 'Phenix City',
    county_fips: 1113,
    county_fips_all: '01113',
    county: 'Russell',
    county_names_all: 'Russell',
    county_weights: '{"01113": 100}',
    density: 108.8,
    imprecise: false,
    latitude: 32.41891,
    longitude: -85.0779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36869',
  },
  {
    city: 'Phenix City',
    county_fips: 1081,
    county_fips_all: '01081|01113',
    county: 'Lee',
    county_names_all: 'Lee|Russell',
    county_weights: '{"01081": 64.21, "01113": 35.79}',
    density: 292.1,
    imprecise: false,
    latitude: 32.48308,
    longitude: -85.11942,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36870',
  },
  {
    city: 'Pittsview',
    county_fips: 1113,
    county_fips_all: '01113',
    county: 'Russell',
    county_names_all: 'Russell',
    county_weights: '{"01113": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 32.17455,
    longitude: -85.14892,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36871',
  },
  {
    city: 'Salem',
    county_fips: 1081,
    county_fips_all: '01081|01113',
    county: 'Lee',
    county_names_all: 'Lee|Russell',
    county_weights: '{"01081": 94.8, "01113": 5.2}',
    density: 31.4,
    imprecise: false,
    latitude: 32.56603,
    longitude: -85.20322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36874',
  },
  {
    city: 'Seale',
    county_fips: 1113,
    county_fips_all: '01113',
    county: 'Russell',
    county_names_all: 'Russell',
    county_weights: '{"01113": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 32.32632,
    longitude: -85.16295,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36875',
  },
  {
    city: 'Smiths Station',
    county_fips: 1081,
    county_fips_all: '01081|01113',
    county: 'Lee',
    county_names_all: 'Lee|Russell',
    county_weights: '{"01081": 99.9, "01113": 0.1}',
    density: 139.7,
    imprecise: false,
    latitude: 32.55465,
    longitude: -85.0974,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36877',
  },
  {
    city: 'Waverly',
    county_fips: 1017,
    county_fips_all: '01017|01081|01123',
    county: 'Chambers',
    county_names_all: 'Chambers|Lee|Tallapoosa',
    county_weights: '{"01017": 48.32, "01081": 46.18, "01123": 5.51}',
    density: 12.5,
    imprecise: false,
    latitude: 32.73091,
    longitude: -85.55449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36879',
  },
  {
    city: 'Bellamy',
    county_fips: 1119,
    county_fips_all: '01119',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"01119": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 32.42284,
    longitude: -88.1465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36901',
  },
  {
    city: 'Butler',
    county_fips: 1023,
    county_fips_all: '01023',
    county: 'Choctaw',
    county_names_all: 'Choctaw',
    county_weights: '{"01023": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 32.10287,
    longitude: -88.25596,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36904',
  },
  {
    city: 'Cuba',
    county_fips: 1119,
    county_fips_all: '01119',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"01119": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 32.43895,
    longitude: -88.34797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36907',
  },
  {
    city: 'Gilbertown',
    county_fips: 1023,
    county_fips_all: '01023',
    county: 'Choctaw',
    county_names_all: 'Choctaw',
    county_weights: '{"01023": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 31.89818,
    longitude: -88.30807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36908',
  },
  {
    city: 'Jachin',
    county_fips: 1023,
    county_fips_all: '01023',
    county: 'Choctaw',
    county_names_all: 'Choctaw',
    county_weights: '{"01023": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 32.23078,
    longitude: -88.15928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36910',
  },
  {
    city: 'Lisman',
    county_fips: 1023,
    county_fips_all: '01023|01119',
    county: 'Choctaw',
    county_names_all: 'Choctaw|Sumter',
    county_weights: '{"01023": 94.05, "01119": 5.95}',
    density: 3.1,
    imprecise: false,
    latitude: 32.23825,
    longitude: -88.30369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36912',
  },
  {
    city: 'Melvin',
    county_fips: 1023,
    county_fips_all: '01023',
    county: 'Choctaw',
    county_names_all: 'Choctaw',
    county_weights: '{"01023": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 31.96069,
    longitude: -88.44667,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36913',
  },
  {
    city: 'Needham',
    county_fips: 1023,
    county_fips_all: '01023',
    county: 'Choctaw',
    county_names_all: 'Choctaw',
    county_weights: '{"01023": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 31.95894,
    longitude: -88.36019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36915',
  },
  {
    city: 'Pennington',
    county_fips: 1023,
    county_fips_all: '01023',
    county: 'Choctaw',
    county_names_all: 'Choctaw',
    county_weights: '{"01023": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 32.23788,
    longitude: -88.04143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36916',
  },
  {
    city: 'Silas',
    county_fips: 1023,
    county_fips_all: '01023',
    county: 'Choctaw',
    county_names_all: 'Choctaw',
    county_weights: '{"01023": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 31.76765,
    longitude: -88.2894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36919',
  },
  {
    city: 'Toxey',
    county_fips: 1023,
    county_fips_all: '01023',
    county: 'Choctaw',
    county_names_all: 'Choctaw',
    county_weights: '{"01023": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 31.96956,
    longitude: -88.19108,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36921',
  },
  {
    city: 'Ward',
    county_fips: 1023,
    county_fips_all: '01023|01119',
    county: 'Choctaw',
    county_names_all: 'Choctaw|Sumter',
    county_weights: '{"01023": 51.57, "01119": 48.43}',
    density: 1.5,
    imprecise: false,
    latitude: 32.30061,
    longitude: -88.15068,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36922',
  },
  {
    city: 'York',
    county_fips: 1119,
    county_fips_all: '01119',
    county: 'Sumter',
    county_names_all: 'Sumter',
    county_weights: '{"01119": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 32.43468,
    longitude: -88.1791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36925',
  },
  {
    city: 'Adams',
    county_fips: 47147,
    county_fips_all: '47147|47125',
    county: 'Robertson',
    county_names_all: 'Robertson|Montgomery',
    county_weights: '{"47147": 61.25, "47125": 38.75}',
    density: 26.6,
    imprecise: false,
    latitude: 36.5675,
    longitude: -87.10894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37010',
  },
  {
    city: 'Alexandria',
    county_fips: 47041,
    county_fips_all: '47041|47189|47159',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Wilson|Smith',
    county_weights: '{"47041": 57.58, "47189": 22.01, "47159": 20.41}',
    density: 22.2,
    imprecise: false,
    latitude: 36.07112,
    longitude: -86.00563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37012',
  },
  {
    city: 'Antioch',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 1036.1,
    imprecise: false,
    latitude: 36.04658,
    longitude: -86.63445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 105212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37013',
  },
  {
    city: 'Arrington',
    county_fips: 47187,
    county_fips_all: '47187|47149',
    county: 'Williamson',
    county_names_all: 'Williamson|Rutherford',
    county_weights: '{"47187": 69.4, "47149": 30.6}',
    density: 56.7,
    imprecise: false,
    latitude: 35.8725,
    longitude: -86.6532,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37014',
  },
  {
    city: 'Ashland City',
    county_fips: 47021,
    county_fips_all: '47021|47037|47125',
    county: 'Cheatham',
    county_names_all: 'Cheatham|Davidson|Montgomery',
    county_weights: '{"47021": 92.85, "47037": 5.7, "47125": 1.45}',
    density: 47.1,
    imprecise: false,
    latitude: 36.28798,
    longitude: -87.08113,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37015',
  },
  {
    city: 'Auburntown',
    county_fips: 47189,
    county_fips_all: '47189|47015',
    county: 'Wilson',
    county_names_all: 'Wilson|Cannon',
    county_weights: '{"47189": 59.06, "47015": 40.94}',
    density: 10.4,
    imprecise: false,
    latitude: 35.96355,
    longitude: -86.11364,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37016',
  },
  {
    city: 'Beechgrove',
    county_fips: 47031,
    county_fips_all: '47031|47003',
    county: 'Coffee',
    county_names_all: 'Coffee|Bedford',
    county_weights: '{"47031": 90.59, "47003": 9.41}',
    density: 24,
    imprecise: false,
    latitude: 35.64255,
    longitude: -86.19876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37018',
  },
  {
    city: 'Belfast',
    county_fips: 47117,
    county_fips_all: '47117',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"47117": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 35.39094,
    longitude: -86.70943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37019',
  },
  {
    city: 'Bell Buckle',
    county_fips: 47003,
    county_fips_all: '47003|47149',
    county: 'Bedford',
    county_names_all: 'Bedford|Rutherford',
    county_weights: '{"47003": 75.66, "47149": 24.34}',
    density: 21,
    imprecise: false,
    latitude: 35.62563,
    longitude: -86.39927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37020',
  },
  {
    city: 'Bethpage',
    county_fips: 47165,
    county_fips_all: '47165|47169|47111',
    county: 'Sumner',
    county_names_all: 'Sumner|Trousdale|Macon',
    county_weights: '{"47165": 85.07, "47169": 13.34, "47111": 1.59}',
    density: 25.4,
    imprecise: false,
    latitude: 36.4997,
    longitude: -86.31017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37022',
  },
  {
    city: 'Big Rock',
    county_fips: 47161,
    county_fips_all: '47161',
    county: 'Stewart',
    county_names_all: 'Stewart',
    county_weights: '{"47161": 100}',
    density: 37,
    imprecise: false,
    latitude: 36.58409,
    longitude: -87.78302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37023',
  },
  {
    city: 'Bon Aqua',
    county_fips: 47081,
    county_fips_all: '47081|47043|47187',
    county: 'Hickman',
    county_names_all: 'Hickman|Dickson|Williamson',
    county_weights: '{"47081": 72.8, "47043": 23.99, "47187": 3.21}',
    density: 41.4,
    imprecise: false,
    latitude: 35.95263,
    longitude: -87.30855,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37025',
  },
  {
    city: 'Bradyville',
    county_fips: 47015,
    county_fips_all: '47015|47031',
    county: 'Cannon',
    county_names_all: 'Cannon|Coffee',
    county_weights: '{"47015": 96.34, "47031": 3.66}',
    density: 15.5,
    imprecise: false,
    latitude: 35.69578,
    longitude: -86.10746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37026',
  },
  {
    city: 'Brentwood',
    county_fips: 47187,
    county_fips_all: '47187|47037',
    county: 'Williamson',
    county_names_all: 'Williamson|Davidson',
    county_weights: '{"47187": 86.43, "47037": 13.57}',
    density: 417.4,
    imprecise: false,
    latitude: 35.99978,
    longitude: -86.78439,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 61630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37027',
  },
  {
    city: 'Bumpus Mills',
    county_fips: 47161,
    county_fips_all: '47161',
    county: 'Stewart',
    county_names_all: 'Stewart',
    county_weights: '{"47161": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 36.62793,
    longitude: -87.85723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37028',
  },
  {
    city: 'Burns',
    county_fips: 47043,
    county_fips_all: '47043',
    county: 'Dickson',
    county_names_all: 'Dickson',
    county_weights: '{"47043": 100}',
    density: 56.7,
    imprecise: false,
    latitude: 36.04253,
    longitude: -87.2678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37029',
  },
  {
    city: 'Carthage',
    county_fips: 47159,
    county_fips_all: '47159|47087',
    county: 'Smith',
    county_names_all: 'Smith|Jackson',
    county_weights: '{"47159": 99.79, "47087": 0.21}',
    density: 48.6,
    imprecise: false,
    latitude: 36.27374,
    longitude: -85.95035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37030',
  },
  {
    city: 'Castalian Springs',
    county_fips: 47165,
    county_fips_all: '47165|47169',
    county: 'Sumner',
    county_names_all: 'Sumner|Trousdale',
    county_weights: '{"47165": 78.43, "47169": 21.57}',
    density: 39.6,
    imprecise: false,
    latitude: 36.3721,
    longitude: -86.30328,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37031',
  },
  {
    city: 'Cedar Hill',
    county_fips: 47147,
    county_fips_all: '47147|47021|47125',
    county: 'Robertson',
    county_names_all: 'Robertson|Cheatham|Montgomery',
    county_weights: '{"47147": 98.42, "47021": 1.47, "47125": 0.11}',
    density: 26.7,
    imprecise: false,
    latitude: 36.52518,
    longitude: -87.01647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37032',
  },
  {
    city: 'Centerville',
    county_fips: 47081,
    county_fips_all: '47081|47135',
    county: 'Hickman',
    county_names_all: 'Hickman|Perry',
    county_weights: '{"47081": 98.04, "47135": 1.96}',
    density: 12,
    imprecise: false,
    latitude: 35.73493,
    longitude: -87.55365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37033',
  },
  {
    city: 'Chapel Hill',
    county_fips: 47117,
    county_fips_all: '47117|47003',
    county: 'Marshall',
    county_names_all: 'Marshall|Bedford',
    county_weights: '{"47117": 76.85, "47003": 23.15}',
    density: 47,
    imprecise: false,
    latitude: 35.63977,
    longitude: -86.69158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37034',
  },
  {
    city: 'Chapmansboro',
    county_fips: 47021,
    county_fips_all: '47021',
    county: 'Cheatham',
    county_names_all: 'Cheatham',
    county_weights: '{"47021": 100}',
    density: 54.9,
    imprecise: false,
    latitude: 36.3849,
    longitude: -87.12602,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37035',
  },
  {
    city: 'Charlotte',
    county_fips: 47043,
    county_fips_all: '47043|47021',
    county: 'Dickson',
    county_names_all: 'Dickson|Cheatham',
    county_weights: '{"47043": 93.34, "47021": 6.66}',
    density: 27.9,
    imprecise: false,
    latitude: 36.23979,
    longitude: -87.27182,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37036',
  },
  {
    city: 'Christiana',
    county_fips: 47149,
    county_fips_all: '47149',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"47149": 100}',
    density: 49.1,
    imprecise: false,
    latitude: 35.70272,
    longitude: -86.35318,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37037',
  },
  {
    city: 'Clarksville',
    county_fips: 47125,
    county_fips_all: '47125',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"47125": 100}',
    density: 270.3,
    imprecise: false,
    latitude: 36.52408,
    longitude: -87.33287,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37040',
  },
  {
    city: 'Clarksville',
    county_fips: 47125,
    county_fips_all: '47125',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"47125": 100}',
    density: 595.1,
    imprecise: false,
    latitude: 36.56894,
    longitude: -87.41225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 87652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37042',
  },
  {
    city: 'Clarksville',
    county_fips: 47125,
    county_fips_all: '47125|47021',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Cheatham',
    county_weights: '{"47125": 98.31, "47021": 1.69}',
    density: 209.1,
    imprecise: false,
    latitude: 36.49842,
    longitude: -87.23197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37043',
  },
  {
    city: 'College Grove',
    county_fips: 47187,
    county_fips_all: '47187|47149|47117',
    county: 'Williamson',
    county_names_all: 'Williamson|Rutherford|Marshall',
    county_weights: '{"47187": 91.97, "47149": 6.3, "47117": 1.73}',
    density: 39.5,
    imprecise: false,
    latitude: 35.77995,
    longitude: -86.71582,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37046',
  },
  {
    city: 'Cornersville',
    county_fips: 47117,
    county_fips_all: '47117|47055|47103',
    county: 'Marshall',
    county_names_all: 'Marshall|Giles|Lincoln',
    county_weights: '{"47117": 78.22, "47055": 19.93, "47103": 1.85}',
    density: 16.6,
    imprecise: false,
    latitude: 35.31291,
    longitude: -86.83191,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37047',
  },
  {
    city: 'Cottontown',
    county_fips: 47165,
    county_fips_all: '47165|47147',
    county: 'Sumner',
    county_names_all: 'Sumner|Robertson',
    county_weights: '{"47165": 95.75, "47147": 4.25}',
    density: 53,
    imprecise: false,
    latitude: 36.4904,
    longitude: -86.59112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37048',
  },
  {
    city: 'Cross Plains',
    county_fips: 47147,
    county_fips_all: '47147',
    county: 'Robertson',
    county_names_all: 'Robertson',
    county_weights: '{"47147": 100}',
    density: 60.1,
    imprecise: false,
    latitude: 36.55985,
    longitude: -86.67887,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37049',
  },
  {
    city: 'Cumberland City',
    county_fips: 47161,
    county_fips_all: '47161|47083|47125',
    county: 'Stewart',
    county_names_all: 'Stewart|Houston|Montgomery',
    county_weights: '{"47161": 52.77, "47083": 26.13, "47125": 21.1}',
    density: 13.2,
    imprecise: false,
    latitude: 36.3713,
    longitude: -87.63586,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37050',
  },
  {
    city: 'Cumberland Furnace',
    county_fips: 47043,
    county_fips_all: '47043|47125|47083',
    county: 'Dickson',
    county_names_all: 'Dickson|Montgomery|Houston',
    county_weights: '{"47043": 72.33, "47125": 23.77, "47083": 3.9}',
    density: 18,
    imprecise: false,
    latitude: 36.30426,
    longitude: -87.41405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37051',
  },
  {
    city: 'Cunningham',
    county_fips: 47125,
    county_fips_all: '47125|47043',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Dickson',
    county_weights: '{"47125": 98.2, "47043": 1.8}',
    density: 18.4,
    imprecise: false,
    latitude: 36.37534,
    longitude: -87.40095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37052',
  },
  {
    city: 'Dickson',
    county_fips: 47043,
    county_fips_all: '47043|47081',
    county: 'Dickson',
    county_names_all: 'Dickson|Hickman',
    county_weights: '{"47043": 91.59, "47081": 8.41}',
    density: 55.6,
    imprecise: false,
    latitude: 36.07921,
    longitude: -87.44238,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37055',
  },
  {
    city: 'Dixon Springs',
    county_fips: 47169,
    county_fips_all: '47169|47159|47111',
    county: 'Trousdale',
    county_names_all: 'Trousdale|Smith|Macon',
    county_weights: '{"47169": 38.14, "47159": 31.37, "47111": 30.49}',
    density: 13.3,
    imprecise: false,
    latitude: 36.40466,
    longitude: -86.02726,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37057',
  },
  {
    city: 'Dover',
    county_fips: 47161,
    county_fips_all: '47161',
    county: 'Stewart',
    county_names_all: 'Stewart',
    county_weights: '{"47161": 100}',
    density: 16,
    imprecise: false,
    latitude: 36.47872,
    longitude: -87.8807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37058',
  },
  {
    city: 'Dowelltown',
    county_fips: 47041,
    county_fips_all: '47041',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"47041": 100}',
    density: 21.8,
    imprecise: false,
    latitude: 35.98611,
    longitude: -85.90798,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37059',
  },
  {
    city: 'Eagleville',
    county_fips: 47149,
    county_fips_all: '47149|47187|47003|47117',
    county: 'Rutherford',
    county_names_all: 'Rutherford|Williamson|Bedford|Marshall',
    county_weights:
      '{"47149": 74.7, "47187": 12.71, "47003": 11.57, "47117": 1.02}',
    density: 32.5,
    imprecise: false,
    latitude: 35.74924,
    longitude: -86.63428,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37060',
  },
  {
    city: 'Erin',
    county_fips: 47083,
    county_fips_all: '47083|47125|47161',
    county: 'Houston',
    county_names_all: 'Houston|Montgomery|Stewart',
    county_weights: '{"47083": 98.55, "47125": 0.9, "47161": 0.55}',
    density: 23.4,
    imprecise: false,
    latitude: 36.28918,
    longitude: -87.66528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37061',
  },
  {
    city: 'Fairview',
    county_fips: 47187,
    county_fips_all: '47187|47043',
    county: 'Williamson',
    county_names_all: 'Williamson|Dickson',
    county_weights: '{"47187": 93.19, "47043": 6.81}',
    density: 77.3,
    imprecise: false,
    latitude: 35.98833,
    longitude: -87.13483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37062',
  },
  {
    city: 'Franklin',
    county_fips: 47187,
    county_fips_all: '47187|47037',
    county: 'Williamson',
    county_names_all: 'Williamson|Davidson',
    county_weights: '{"47187": 99.22, "47037": 0.78}',
    density: 141.7,
    imprecise: false,
    latitude: 35.88966,
    longitude: -86.96112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 67513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37064',
  },
  {
    city: 'Gallatin',
    county_fips: 47165,
    county_fips_all: '47165',
    county: 'Sumner',
    county_names_all: 'Sumner',
    county_weights: '{"47165": 100}',
    density: 214.6,
    imprecise: false,
    latitude: 36.39871,
    longitude: -86.45594,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37066',
  },
  {
    city: 'Franklin',
    county_fips: 47187,
    county_fips_all: '47187',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"47187": 100}',
    density: 374.5,
    imprecise: false,
    latitude: 35.91314,
    longitude: -86.77461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37067',
  },
  {
    city: 'Franklin',
    county_fips: 47187,
    county_fips_all: '47187',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"47187": 100}',
    density: 217.1,
    imprecise: false,
    latitude: 35.98753,
    longitude: -86.90664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37069',
  },
  {
    city: 'Goodlettsville',
    county_fips: 47037,
    county_fips_all: '47037|47165|47147',
    county: 'Davidson',
    county_names_all: 'Davidson|Sumner|Robertson',
    county_weights: '{"47037": 50.7, "47165": 34.45, "47147": 14.85}',
    density: 160.4,
    imprecise: false,
    latitude: 36.35686,
    longitude: -86.74494,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37072',
  },
  {
    city: 'Greenbrier',
    county_fips: 47147,
    county_fips_all: '47147',
    county: 'Robertson',
    county_names_all: 'Robertson',
    county_weights: '{"47147": 100}',
    density: 113.1,
    imprecise: false,
    latitude: 36.42834,
    longitude: -86.81414,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37073',
  },
  {
    city: 'Hartsville',
    county_fips: 47169,
    county_fips_all: '47169|47111',
    county: 'Trousdale',
    county_names_all: 'Trousdale|Macon',
    county_weights: '{"47169": 74.2, "47111": 25.8}',
    density: 42.3,
    imprecise: false,
    latitude: 36.41552,
    longitude: -86.14724,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37074',
  },
  {
    city: 'Hendersonville',
    county_fips: 47165,
    county_fips_all: '47165|47189',
    county: 'Sumner',
    county_names_all: 'Sumner|Wilson',
    county_weights: '{"47165": 99.89, "47189": 0.11}',
    density: 480.8,
    imprecise: false,
    latitude: 36.34085,
    longitude: -86.60845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 73522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37075',
  },
  {
    city: 'Hermitage',
    county_fips: 47037,
    county_fips_all: '47037|47189',
    county: 'Davidson',
    county_names_all: 'Davidson|Wilson',
    county_weights: '{"47037": 93.14, "47189": 6.86}',
    density: 541.7,
    imprecise: false,
    latitude: 36.14512,
    longitude: -86.57977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37076',
  },
  {
    city: 'Hurricane Mills',
    county_fips: 47085,
    county_fips_all: '47085|47081',
    county: 'Humphreys',
    county_names_all: 'Humphreys|Hickman',
    county_weights: '{"47085": 97.58, "47081": 2.42}',
    density: 3.9,
    imprecise: false,
    latitude: 35.92366,
    longitude: -87.77138,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37078',
  },
  {
    city: 'Indian Mound',
    county_fips: 47161,
    county_fips_all: '47161|47125',
    county: 'Stewart',
    county_names_all: 'Stewart|Montgomery',
    county_weights: '{"47161": 80.08, "47125": 19.92}',
    density: 14.5,
    imprecise: false,
    latitude: 36.4826,
    longitude: -87.65939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37079',
  },
  {
    city: 'Joelton',
    county_fips: 47037,
    county_fips_all: '47037|47021|47147',
    county: 'Davidson',
    county_names_all: 'Davidson|Cheatham|Robertson',
    county_weights: '{"47037": 59.49, "47021": 39.78, "47147": 0.73}',
    density: 53.8,
    imprecise: false,
    latitude: 36.32901,
    longitude: -86.91633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37080',
  },
  {
    city: 'Kingston Springs',
    county_fips: 47021,
    county_fips_all: '47021',
    county: 'Cheatham',
    county_names_all: 'Cheatham',
    county_weights: '{"47021": 100}',
    density: 50.3,
    imprecise: false,
    latitude: 36.09717,
    longitude: -87.11484,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37082',
  },
  {
    city: 'Lafayette',
    county_fips: 47111,
    county_fips_all: '47111',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"47111": 100}',
    density: 45.4,
    imprecise: false,
    latitude: 36.54357,
    longitude: -86.00149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37083',
  },
  {
    city: 'Lascassas',
    county_fips: 47149,
    county_fips_all: '47149|47189',
    county: 'Rutherford',
    county_names_all: 'Rutherford|Wilson',
    county_weights: '{"47149": 72.56, "47189": 27.44}',
    density: 41.1,
    imprecise: false,
    latitude: 35.95308,
    longitude: -86.27912,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37085',
  },
  {
    city: 'La Vergne',
    county_fips: 47149,
    county_fips_all: '47149|47037',
    county: 'Rutherford',
    county_names_all: 'Rutherford|Davidson',
    county_weights: '{"47149": 94.89, "47037": 5.11}',
    density: 605.7,
    imprecise: false,
    latitude: 36.02177,
    longitude: -86.55971,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37086',
  },
  {
    city: 'Lebanon',
    county_fips: 47189,
    county_fips_all: '47189|47159|47169',
    county: 'Wilson',
    county_names_all: 'Wilson|Smith|Trousdale',
    county_weights: '{"47189": 87.0, "47159": 7.42, "47169": 5.58}',
    density: 132.6,
    imprecise: false,
    latitude: 36.2733,
    longitude: -86.27224,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37087',
  },
  {
    city: 'Lebanon',
    county_fips: 47189,
    county_fips_all: '47189|47159|47149',
    county: 'Wilson',
    county_names_all: 'Wilson|Smith|Rutherford',
    county_weights: '{"47189": 96.29, "47159": 2.73, "47149": 0.98}',
    density: 45.9,
    imprecise: false,
    latitude: 36.12439,
    longitude: -86.29707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37090',
  },
  {
    city: 'Lewisburg',
    county_fips: 47117,
    county_fips_all: '47117|47003|47119',
    county: 'Marshall',
    county_names_all: 'Marshall|Bedford|Maury',
    county_weights: '{"47117": 91.11, "47003": 7.81, "47119": 1.08}',
    density: 46.4,
    imprecise: false,
    latitude: 35.48546,
    longitude: -86.76405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37091',
  },
  {
    city: 'Liberty',
    county_fips: 47041,
    county_fips_all: '47041|47015|47189',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Cannon|Wilson',
    county_weights: '{"47041": 76.38, "47015": 21.58, "47189": 2.04}',
    density: 8.5,
    imprecise: false,
    latitude: 35.98295,
    longitude: -85.95919,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37095',
  },
  {
    city: 'Linden',
    county_fips: 47135,
    county_fips_all: '47135|47181|47101',
    county: 'Perry',
    county_names_all: 'Perry|Wayne|Lewis',
    county_weights: '{"47135": 97.4, "47181": 2.14, "47101": 0.46}',
    density: 7.5,
    imprecise: false,
    latitude: 35.60487,
    longitude: -87.86054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37096',
  },
  {
    city: 'Lobelville',
    county_fips: 47135,
    county_fips_all: '47135',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"47135": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 35.7785,
    longitude: -87.8303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37097',
  },
  {
    city: 'Lyles',
    county_fips: 47081,
    county_fips_all: '47081',
    county: 'Hickman',
    county_names_all: 'Hickman',
    county_weights: '{"47081": 100}',
    density: 39.9,
    imprecise: false,
    latitude: 35.87142,
    longitude: -87.31075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37098',
  },
  {
    city: 'McEwen',
    county_fips: 47085,
    county_fips_all: '47085|47081|47083',
    county: 'Humphreys',
    county_names_all: 'Humphreys|Hickman|Houston',
    county_weights: '{"47085": 86.93, "47081": 8.82, "47083": 4.25}',
    density: 12.5,
    imprecise: false,
    latitude: 36.06625,
    longitude: -87.63741,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37101',
  },
  {
    city: 'Mcminnville',
    county_fips: 47177,
    county_fips_all: '47177|47061|47175|47015|47153',
    county: 'Warren',
    county_names_all: 'Warren|Grundy|Van Buren|Cannon|Sequatchie',
    county_weights:
      '{"47177": 78.62, "47061": 14.89, "47175": 3.02, "47015": 1.93, "47153": 1.54}',
    density: 35.4,
    imprecise: false,
    latitude: 35.6436,
    longitude: -85.74314,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37110',
  },
  {
    city: 'Madison',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 730.8,
    imprecise: false,
    latitude: 36.25444,
    longitude: -86.69636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37115',
  },
  {
    city: 'Milton',
    county_fips: 47149,
    county_fips_all: '47149|47189|47015',
    county: 'Rutherford',
    county_names_all: 'Rutherford|Wilson|Cannon',
    county_weights: '{"47149": 69.32, "47189": 22.65, "47015": 8.03}',
    density: 12.9,
    imprecise: false,
    latitude: 35.92569,
    longitude: -86.18903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37118',
  },
  {
    city: 'Mount Juliet',
    county_fips: 47189,
    county_fips_all: '47189|47149|47037|47165',
    county: 'Wilson',
    county_names_all: 'Wilson|Rutherford|Davidson|Sumner',
    county_weights:
      '{"47189": 90.08, "47149": 8.74, "47037": 0.91, "47165": 0.27}',
    density: 236.9,
    imprecise: false,
    latitude: 36.17791,
    longitude: -86.48872,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 68492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37122',
  },
  {
    city: 'Murfreesboro',
    county_fips: 47149,
    county_fips_all: '47149',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"47149": 100}',
    density: 176.3,
    imprecise: false,
    latitude: 35.77947,
    longitude: -86.32723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37127',
  },
  {
    city: 'Murfreesboro',
    county_fips: 47149,
    county_fips_all: '47149',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"47149": 100}',
    density: 540.1,
    imprecise: false,
    latitude: 35.80343,
    longitude: -86.47483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 79268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37128',
  },
  {
    city: 'Murfreesboro',
    county_fips: 47149,
    county_fips_all: '47149',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"47149": 100}',
    density: 307.2,
    imprecise: false,
    latitude: 35.92556,
    longitude: -86.44098,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37129',
  },
  {
    city: 'Murfreesboro',
    county_fips: 47149,
    county_fips_all: '47149',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"47149": 100}',
    density: 414.1,
    imprecise: false,
    latitude: 35.8809,
    longitude: -86.33003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37130',
  },
  {
    city: 'New Johnsonville',
    county_fips: 47085,
    county_fips_all: '47085',
    county: 'Humphreys',
    county_names_all: 'Humphreys',
    county_weights: '{"47085": 100}',
    density: 31.9,
    imprecise: false,
    latitude: 36.0014,
    longitude: -87.95063,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37134',
  },
  {
    city: 'Nolensville',
    county_fips: 47187,
    county_fips_all: '47187|47037|47149',
    county: 'Williamson',
    county_names_all: 'Williamson|Davidson|Rutherford',
    county_weights: '{"47187": 88.54, "47037": 8.22, "47149": 3.24}',
    density: 255.5,
    imprecise: false,
    latitude: 35.93562,
    longitude: -86.6625,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37135',
  },
  {
    city: 'Nunnelly',
    county_fips: 47081,
    county_fips_all: '47081',
    county: 'Hickman',
    county_names_all: 'Hickman',
    county_weights: '{"47081": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 35.87912,
    longitude: -87.50276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37137',
  },
  {
    city: 'Old Hickory',
    county_fips: 47037,
    county_fips_all: '47037|47189|47165',
    county: 'Davidson',
    county_names_all: 'Davidson|Wilson|Sumner',
    county_weights: '{"47037": 68.59, "47189": 27.93, "47165": 3.48}',
    density: 486.2,
    imprecise: false,
    latitude: 36.24652,
    longitude: -86.61938,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37138',
  },
  {
    city: 'Only',
    county_fips: 47081,
    county_fips_all: '47081',
    county: 'Hickman',
    county_names_all: 'Hickman',
    county_weights: '{"47081": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 35.86345,
    longitude: -87.65245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37140',
  },
  {
    city: 'Orlinda',
    county_fips: 47147,
    county_fips_all: '47147',
    county: 'Robertson',
    county_names_all: 'Robertson',
    county_weights: '{"47147": 100}',
    density: 30.8,
    imprecise: false,
    latitude: 36.6145,
    longitude: -86.69894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37141',
  },
  {
    city: 'Palmyra',
    county_fips: 47125,
    county_fips_all: '47125',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"47125": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 36.41164,
    longitude: -87.50112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37142',
  },
  {
    city: 'Pegram',
    county_fips: 47021,
    county_fips_all: '47021|47037',
    county: 'Cheatham',
    county_names_all: 'Cheatham|Davidson',
    county_weights: '{"47021": 81.41, "47037": 18.59}',
    density: 49.1,
    imprecise: false,
    latitude: 36.13137,
    longitude: -87.03038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37143',
  },
  {
    city: 'Petersburg',
    county_fips: 47103,
    county_fips_all: '47103|47117|47003|47127|47055',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Marshall|Bedford|Moore|Giles',
    county_weights:
      '{"47103": 58.79, "47117": 28.0, "47003": 8.27, "47127": 3.28, "47055": 1.66}',
    density: 8.5,
    imprecise: false,
    latitude: 35.30516,
    longitude: -86.65585,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37144',
  },
  {
    city: 'Pleasant Shade',
    county_fips: 47159,
    county_fips_all: '47159|47111|47087',
    county: 'Smith',
    county_names_all: 'Smith|Macon|Jackson',
    county_weights: '{"47159": 70.88, "47111": 18.69, "47087": 10.43}',
    density: 11.9,
    imprecise: false,
    latitude: 36.38179,
    longitude: -85.91203,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37145',
  },
  {
    city: 'Pleasant View',
    county_fips: 47147,
    county_fips_all: '47147|47021',
    county: 'Robertson',
    county_names_all: 'Robertson|Cheatham',
    county_weights: '{"47147": 53.59, "47021": 46.41}',
    density: 95.8,
    imprecise: false,
    latitude: 36.4047,
    longitude: -87.03123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37146',
  },
  {
    city: 'Portland',
    county_fips: 47165,
    county_fips_all: '47165|47147',
    county: 'Sumner',
    county_names_all: 'Sumner|Robertson',
    county_weights: '{"47165": 85.19, "47147": 14.81}',
    density: 76.9,
    imprecise: false,
    latitude: 36.57694,
    longitude: -86.50224,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37148',
  },
  {
    city: 'Readyville',
    county_fips: 47149,
    county_fips_all: '47149|47015',
    county: 'Rutherford',
    county_names_all: 'Rutherford|Cannon',
    county_weights: '{"47149": 57.26, "47015": 42.74}',
    density: 15.7,
    imprecise: false,
    latitude: 35.80876,
    longitude: -86.19311,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37149',
  },
  {
    city: 'Red Boiling Springs',
    county_fips: 47111,
    county_fips_all: '47111|47027|47087',
    county: 'Macon',
    county_names_all: 'Macon|Clay|Jackson',
    county_weights: '{"47111": 54.17, "47027": 40.53, "47087": 5.3}',
    density: 16.7,
    imprecise: false,
    latitude: 36.54437,
    longitude: -85.81082,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37150',
  },
  {
    city: 'Riddleton',
    county_fips: 47159,
    county_fips_all: '47159',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"47159": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 36.31288,
    longitude: -86.04536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37151',
  },
  {
    city: 'Rockvale',
    county_fips: 47149,
    county_fips_all: '47149|47003',
    county: 'Rutherford',
    county_names_all: 'Rutherford|Bedford',
    county_weights: '{"47149": 90.11, "47003": 9.89}',
    density: 42,
    imprecise: false,
    latitude: 35.7645,
    longitude: -86.55531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37153',
  },
  {
    city: 'Shelbyville',
    county_fips: 47003,
    county_fips_all: '47003|47127',
    county: 'Bedford',
    county_names_all: 'Bedford|Moore',
    county_weights: '{"47003": 97.91, "47127": 2.09}',
    density: 63.1,
    imprecise: false,
    latitude: 35.46562,
    longitude: -86.48268,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37160',
  },
  {
    city: 'Slayden',
    county_fips: 47043,
    county_fips_all: '47043',
    county: 'Dickson',
    county_names_all: 'Dickson',
    county_weights: '{"47043": 100}',
    density: 40,
    imprecise: false,
    latitude: 36.29005,
    longitude: -87.46943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37165',
  },
  {
    city: 'Smithville',
    county_fips: 47041,
    county_fips_all: '47041|47177|47015',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Warren|Cannon',
    county_weights: '{"47041": 91.48, "47177": 6.93, "47015": 1.59}',
    density: 39.3,
    imprecise: false,
    latitude: 35.92444,
    longitude: -85.78978,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37166',
  },
  {
    city: 'Smyrna',
    county_fips: 47149,
    county_fips_all: '47149',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"47149": 100}',
    density: 466.9,
    imprecise: false,
    latitude: 35.96325,
    longitude: -86.52922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 66504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37167',
  },
  {
    city: 'Southside',
    county_fips: 47125,
    county_fips_all: '47125|47043',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Dickson',
    county_weights: '{"47125": 99.9, "47043": 0.1}',
    density: 22.6,
    imprecise: false,
    latitude: 36.36442,
    longitude: -87.30365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37171',
  },
  {
    city: 'Springfield',
    county_fips: 47147,
    county_fips_all: '47147',
    county: 'Robertson',
    county_names_all: 'Robertson',
    county_weights: '{"47147": 100}',
    density: 67.1,
    imprecise: false,
    latitude: 36.53661,
    longitude: -86.86005,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37172',
  },
  {
    city: 'Spring Hill',
    county_fips: 47119,
    county_fips_all: '47119|47187|47117',
    county: 'Maury',
    county_names_all: 'Maury|Williamson|Marshall',
    county_weights: '{"47119": 74.76, "47187": 23.76, "47117": 1.48}',
    density: 298.6,
    imprecise: false,
    latitude: 35.72197,
    longitude: -86.8995,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37174',
  },
  {
    city: 'Stewart',
    county_fips: 47083,
    county_fips_all: '47083|47161',
    county: 'Houston',
    county_names_all: 'Houston|Stewart',
    county_weights: '{"47083": 58.89, "47161": 41.11}',
    density: 4.9,
    imprecise: false,
    latitude: 36.32349,
    longitude: -87.89678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37175',
  },
  {
    city: 'Tennessee Ridge',
    county_fips: 47083,
    county_fips_all: '47083|47161',
    county: 'Houston',
    county_names_all: 'Houston|Stewart',
    county_weights: '{"47083": 60.92, "47161": 39.08}',
    density: 18.2,
    imprecise: false,
    latitude: 36.3195,
    longitude: -87.78694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37178',
  },
  {
    city: 'Thompsons Station',
    county_fips: 47187,
    county_fips_all: '47187',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"47187": 100}',
    density: 131.3,
    imprecise: false,
    latitude: 35.8073,
    longitude: -86.91517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37179',
  },
  {
    city: 'Unionville',
    county_fips: 47003,
    county_fips_all: '47003|47149|47117',
    county: 'Bedford',
    county_names_all: 'Bedford|Rutherford|Marshall',
    county_weights: '{"47003": 92.27, "47149": 7.23, "47117": 0.5}',
    density: 38.9,
    imprecise: false,
    latitude: 35.6189,
    longitude: -86.57679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37180',
  },
  {
    city: 'Vanleer',
    county_fips: 47043,
    county_fips_all: '47043|47083',
    county: 'Dickson',
    county_names_all: 'Dickson|Houston',
    county_weights: '{"47043": 65.39, "47083": 34.61}',
    density: 13.9,
    imprecise: false,
    latitude: 36.241,
    longitude: -87.49706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37181',
  },
  {
    city: 'Wartrace',
    county_fips: 47003,
    county_fips_all: '47003|47031|47127',
    county: 'Bedford',
    county_names_all: 'Bedford|Coffee|Moore',
    county_weights: '{"47003": 79.52, "47031": 15.44, "47127": 5.04}',
    density: 16.5,
    imprecise: false,
    latitude: 35.5104,
    longitude: -86.30162,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37183',
  },
  {
    city: 'Watertown',
    county_fips: 47189,
    county_fips_all: '47189|47159',
    county: 'Wilson',
    county_names_all: 'Wilson|Smith',
    county_weights: '{"47189": 96.51, "47159": 3.49}',
    density: 25.5,
    imprecise: false,
    latitude: 36.08682,
    longitude: -86.14524,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37184',
  },
  {
    city: 'Waverly',
    county_fips: 47085,
    county_fips_all: '47085|47083',
    county: 'Humphreys',
    county_names_all: 'Humphreys|Houston',
    county_weights: '{"47085": 99.73, "47083": 0.27}',
    density: 15.6,
    imprecise: false,
    latitude: 36.07118,
    longitude: -87.8392,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37185',
  },
  {
    city: 'Westmoreland',
    county_fips: 47165,
    county_fips_all: '47165|47111',
    county: 'Sumner',
    county_names_all: 'Sumner|Macon',
    county_weights: '{"47165": 54.03, "47111": 45.97}',
    density: 38.3,
    imprecise: false,
    latitude: 36.58644,
    longitude: -86.22868,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37186',
  },
  {
    city: 'White Bluff',
    county_fips: 47043,
    county_fips_all: '47043|47021',
    county: 'Dickson',
    county_names_all: 'Dickson|Cheatham',
    county_weights: '{"47043": 77.63, "47021": 22.37}',
    density: 43.4,
    imprecise: false,
    latitude: 36.1471,
    longitude: -87.19885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37187',
  },
  {
    city: 'White House',
    county_fips: 47147,
    county_fips_all: '47147|47165',
    county: 'Robertson',
    county_names_all: 'Robertson|Sumner',
    county_weights: '{"47147": 73.04, "47165": 26.96}',
    density: 229.1,
    imprecise: false,
    latitude: 36.48048,
    longitude: -86.68101,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37188',
  },
  {
    city: 'Whites Creek',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 52.7,
    imprecise: false,
    latitude: 36.27875,
    longitude: -86.82983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37189',
  },
  {
    city: 'Woodbury',
    county_fips: 47015,
    county_fips_all: '47015|47177',
    county: 'Cannon',
    county_names_all: 'Cannon|Warren',
    county_weights: '{"47015": 98.46, "47177": 1.54}',
    density: 26.5,
    imprecise: false,
    latitude: 35.82599,
    longitude: -86.0424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37190',
  },
  {
    city: 'Woodlawn',
    county_fips: 47125,
    county_fips_all: '47125',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"47125": 100}',
    density: 32.5,
    imprecise: false,
    latitude: 36.50726,
    longitude: -87.52392,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37191',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 1764.2,
    imprecise: false,
    latitude: 36.16662,
    longitude: -86.77799,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37201',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 1973.7,
    imprecise: false,
    latitude: 36.14937,
    longitude: -86.78986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37203',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 871.8,
    imprecise: false,
    latitude: 36.10669,
    longitude: -86.77463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37204',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 671.9,
    imprecise: false,
    latitude: 36.11075,
    longitude: -86.87274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37205',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 1422,
    imprecise: false,
    latitude: 36.18085,
    longitude: -86.73117,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37206',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 825.7,
    imprecise: false,
    latitude: 36.23278,
    longitude: -86.77765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37207',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 1674.8,
    imprecise: false,
    latitude: 36.17691,
    longitude: -86.80901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37208',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037|47021',
    county: 'Davidson',
    county_names_all: 'Davidson|Cheatham',
    county_weights: '{"47037": 99.68, "47021": 0.32}',
    density: 433.9,
    imprecise: false,
    latitude: 36.15591,
    longitude: -86.91638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37209',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 737.5,
    imprecise: false,
    latitude: 36.1442,
    longitude: -86.73374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37210',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 1360.8,
    imprecise: false,
    latitude: 36.06704,
    longitude: -86.72345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 76573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37211',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 2891.1,
    imprecise: false,
    latitude: 36.13376,
    longitude: -86.80167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37212',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 36.16654,
    longitude: -86.76731,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37213',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 524.3,
    imprecise: false,
    latitude: 36.16789,
    longitude: -86.66296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37214',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037|47187',
    county: 'Davidson',
    county_names_all: 'Davidson|Williamson',
    county_weights: '{"47037": 98.32, "47187": 1.68}',
    density: 554.6,
    imprecise: false,
    latitude: 36.08197,
    longitude: -86.83492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37215',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 1092.4,
    imprecise: false,
    latitude: 36.21589,
    longitude: -86.72676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37216',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 692.9,
    imprecise: false,
    latitude: 36.10836,
    longitude: -86.66178,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37217',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 151.2,
    imprecise: false,
    latitude: 36.20814,
    longitude: -86.89158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37218',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 4295.3,
    imprecise: false,
    latitude: 36.1663,
    longitude: -86.78299,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37219',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 263.6,
    imprecise: false,
    latitude: 36.06759,
    longitude: -86.78127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37220',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037|47187',
    county: 'Davidson',
    county_names_all: 'Davidson|Williamson',
    county_weights: '{"47037": 91.34, "47187": 8.66}',
    density: 328.2,
    imprecise: false,
    latitude: 36.05991,
    longitude: -86.97189,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37221',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 684.7,
    imprecise: false,
    latitude: 36.19513,
    longitude: -86.80418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37228',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.1657,
    longitude: -86.77946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37238',
  },
  {
    city: 'Altamont',
    county_fips: 47061,
    county_fips_all: '47061',
    county: 'Grundy',
    county_names_all: 'Grundy',
    county_weights: '{"47061": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 35.42765,
    longitude: -85.80295,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37301',
  },
  {
    city: 'Apison',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 113.7,
    imprecise: false,
    latitude: 35.01303,
    longitude: -85.01961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37302',
  },
  {
    city: 'Athens',
    county_fips: 47107,
    county_fips_all: '47107',
    county: 'McMinn',
    county_names_all: 'McMinn',
    county_weights: '{"47107": 100}',
    density: 66.6,
    imprecise: false,
    latitude: 35.4403,
    longitude: -84.64051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37303',
  },
  {
    city: 'Beersheba Springs',
    county_fips: 47061,
    county_fips_all: '47061',
    county: 'Grundy',
    county_names_all: 'Grundy',
    county_weights: '{"47061": 100}',
    density: 24.2,
    imprecise: false,
    latitude: 35.45795,
    longitude: -85.70195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37305',
  },
  {
    city: 'Belvidere',
    county_fips: 47051,
    county_fips_all: '47051|47127',
    county: 'Franklin',
    county_names_all: 'Franklin|Moore',
    county_weights: '{"47051": 90.6, "47127": 9.4}',
    density: 6.3,
    imprecise: false,
    latitude: 35.09776,
    longitude: -86.18928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37306',
  },
  {
    city: 'Benton',
    county_fips: 47139,
    county_fips_all: '47139|47011',
    county: 'Polk',
    county_names_all: 'Polk|Bradley',
    county_weights: '{"47139": 99.01, "47011": 0.99}',
    density: 35.6,
    imprecise: false,
    latitude: 35.16676,
    longitude: -84.62158,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37307',
  },
  {
    city: 'Birchwood',
    county_fips: 47065,
    county_fips_all: '47065|47121',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Meigs',
    county_weights: '{"47065": 56.76, "47121": 43.24}',
    density: 33.3,
    imprecise: false,
    latitude: 35.3476,
    longitude: -84.99728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37308',
  },
  {
    city: 'Calhoun',
    county_fips: 47107,
    county_fips_all: '47107|47139',
    county: 'McMinn',
    county_names_all: 'McMinn|Polk',
    county_weights: '{"47107": 88.76, "47139": 11.24}',
    density: 20.9,
    imprecise: false,
    latitude: 35.30595,
    longitude: -84.74453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37309',
  },
  {
    city: 'Charleston',
    county_fips: 47011,
    county_fips_all: '47011|47139',
    county: 'Bradley',
    county_names_all: 'Bradley|Polk',
    county_weights: '{"47011": 89.42, "47139": 10.58}',
    density: 39.5,
    imprecise: false,
    latitude: 35.26237,
    longitude: -84.77767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37310',
  },
  {
    city: 'Cleveland',
    county_fips: 47011,
    county_fips_all: '47011|47065',
    county: 'Bradley',
    county_names_all: 'Bradley|Hamilton',
    county_weights: '{"47011": 97.9, "47065": 2.1}',
    density: 236.8,
    imprecise: false,
    latitude: 35.10054,
    longitude: -84.92298,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37311',
  },
  {
    city: 'Cleveland',
    county_fips: 47011,
    county_fips_all: '47011',
    county: 'Bradley',
    county_names_all: 'Bradley',
    county_weights: '{"47011": 100}',
    density: 219.8,
    imprecise: false,
    latitude: 35.2286,
    longitude: -84.87344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37312',
  },
  {
    city: 'Coalmont',
    county_fips: 47061,
    county_fips_all: '47061',
    county: 'Grundy',
    county_names_all: 'Grundy',
    county_weights: '{"47061": 100}',
    density: 30.3,
    imprecise: false,
    latitude: 35.37703,
    longitude: -85.70245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37313',
  },
  {
    city: 'Collegedale',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 5560.5,
    imprecise: false,
    latitude: 35.04722,
    longitude: -85.05158,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37315',
  },
  {
    city: 'Conasauga',
    county_fips: 47139,
    county_fips_all: '47139',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"47139": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.00161,
    longitude: -84.72975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37316',
  },
  {
    city: 'Copperhill',
    county_fips: 47139,
    county_fips_all: '47139',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"47139": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 35.03079,
    longitude: -84.44341,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37317',
  },
  {
    city: 'Cowan',
    county_fips: 47051,
    county_fips_all: '47051',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"47051": 100}',
    density: 65.4,
    imprecise: false,
    latitude: 35.17879,
    longitude: -85.97994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37318',
  },
  {
    city: 'Dayton',
    county_fips: 47143,
    county_fips_all: '47143|47007',
    county: 'Rhea',
    county_names_all: 'Rhea|Bledsoe',
    county_weights: '{"47143": 95.36, "47007": 4.64}',
    density: 71.4,
    imprecise: false,
    latitude: 35.50239,
    longitude: -85.00801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37321',
  },
  {
    city: 'Decatur',
    county_fips: 47121,
    county_fips_all: '47121|47107',
    county: 'Meigs',
    county_names_all: 'Meigs|McMinn',
    county_weights: '{"47121": 92.04, "47107": 7.96}',
    density: 26.1,
    imprecise: false,
    latitude: 35.49562,
    longitude: -84.81512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37322',
  },
  {
    city: 'Cleveland',
    county_fips: 47011,
    county_fips_all: '47011|47139',
    county: 'Bradley',
    county_names_all: 'Bradley|Polk',
    county_weights: '{"47011": 99.66, "47139": 0.34}',
    density: 107.6,
    imprecise: false,
    latitude: 35.09627,
    longitude: -84.81984,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37323',
  },
  {
    city: 'Decherd',
    county_fips: 47051,
    county_fips_all: '47051',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"47051": 100}',
    density: 32.7,
    imprecise: false,
    latitude: 35.25251,
    longitude: -86.00044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37324',
  },
  {
    city: 'Delano',
    county_fips: 47139,
    county_fips_all: '47139|47107',
    county: 'Polk',
    county_names_all: 'Polk|McMinn',
    county_weights: '{"47139": 87.89, "47107": 12.11}',
    density: 35.8,
    imprecise: false,
    latitude: 35.24726,
    longitude: -84.61108,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37325',
  },
  {
    city: 'Ducktown',
    county_fips: 47139,
    county_fips_all: '47139',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"47139": 100}',
    density: 89.5,
    imprecise: false,
    latitude: 35.04023,
    longitude: -84.38329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37326',
  },
  {
    city: 'Dunlap',
    county_fips: 47153,
    county_fips_all: '47153|47007|47175',
    county: 'Sequatchie',
    county_names_all: 'Sequatchie|Bledsoe|Van Buren',
    county_weights: '{"47153": 82.17, "47007": 16.21, "47175": 1.62}',
    density: 27.2,
    imprecise: false,
    latitude: 35.42251,
    longitude: -85.39993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37327',
  },
  {
    city: 'Elora',
    county_fips: 47103,
    county_fips_all: '47103|47051',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Franklin',
    county_weights: '{"47103": 95.17, "47051": 4.83}',
    density: 23.2,
    imprecise: false,
    latitude: 35.02825,
    longitude: -86.36876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37328',
  },
  {
    city: 'Englewood',
    county_fips: 47107,
    county_fips_all: '47107|47123',
    county: 'McMinn',
    county_names_all: 'McMinn|Monroe',
    county_weights: '{"47107": 84.47, "47123": 15.53}',
    density: 42.9,
    imprecise: false,
    latitude: 35.39201,
    longitude: -84.46017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37329',
  },
  {
    city: 'Estill Springs',
    county_fips: 47051,
    county_fips_all: '47051|47031',
    county: 'Franklin',
    county_names_all: 'Franklin|Coffee',
    county_weights: '{"47051": 92.85, "47031": 7.15}',
    density: 71.6,
    imprecise: false,
    latitude: 35.28411,
    longitude: -86.12967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37330',
  },
  {
    city: 'Etowah',
    county_fips: 47107,
    county_fips_all: '47107',
    county: 'McMinn',
    county_names_all: 'McMinn',
    county_weights: '{"47107": 100}',
    density: 74.7,
    imprecise: false,
    latitude: 35.31662,
    longitude: -84.5336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37331',
  },
  {
    city: 'Evensville',
    county_fips: 47143,
    county_fips_all: '47143|47007',
    county: 'Rhea',
    county_names_all: 'Rhea|Bledsoe',
    county_weights: '{"47143": 94.18, "47007": 5.82}',
    density: 9.8,
    imprecise: false,
    latitude: 35.59418,
    longitude: -84.96277,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37332',
  },
  {
    city: 'Farner',
    county_fips: 47139,
    county_fips_all: '47139',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"47139": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 35.14844,
    longitude: -84.35981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37333',
  },
  {
    city: 'Fayetteville',
    county_fips: 47103,
    county_fips_all: '47103|47127|47003',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Moore|Bedford',
    county_weights: '{"47103": 93.11, "47127": 6.52, "47003": 0.37}',
    density: 36.1,
    imprecise: false,
    latitude: 35.16532,
    longitude: -86.57966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37334',
  },
  {
    city: 'Flintville',
    county_fips: 47103,
    county_fips_all: '47103|47051',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Franklin',
    county_weights: '{"47103": 97.22, "47051": 2.78}',
    density: 22,
    imprecise: false,
    latitude: 35.06584,
    longitude: -86.40548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37335',
  },
  {
    city: 'Georgetown',
    county_fips: 47121,
    county_fips_all: '47121|47065|47011',
    county: 'Meigs',
    county_names_all: 'Meigs|Hamilton|Bradley',
    county_weights: '{"47121": 35.96, "47065": 33.35, "47011": 30.69}',
    density: 39.6,
    imprecise: false,
    latitude: 35.30117,
    longitude: -84.93413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37336',
  },
  {
    city: 'Grandview',
    county_fips: 47143,
    county_fips_all: '47143|47035|47007',
    county: 'Rhea',
    county_names_all: 'Rhea|Cumberland|Bledsoe',
    county_weights: '{"47143": 50.24, "47035": 43.85, "47007": 5.91}',
    density: 7.9,
    imprecise: false,
    latitude: 35.78594,
    longitude: -84.86651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37337',
  },
  {
    city: 'Graysville',
    county_fips: 47007,
    county_fips_all: '47007|47153|47065|47143',
    county: 'Bledsoe',
    county_names_all: 'Bledsoe|Sequatchie|Hamilton|Rhea',
    county_weights:
      '{"47007": 58.52, "47153": 20.37, "47065": 16.01, "47143": 5.1}',
    density: 17.6,
    imprecise: false,
    latitude: 35.42356,
    longitude: -85.20942,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37338',
  },
  {
    city: 'Gruetli Laager',
    county_fips: 47061,
    county_fips_all: '47061',
    county: 'Grundy',
    county_names_all: 'Grundy',
    county_weights: '{"47061": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 35.37386,
    longitude: -85.63222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37339',
  },
  {
    city: 'Guild',
    county_fips: 47115,
    county_fips_all: '47115',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"47115": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 35.02085,
    longitude: -85.53179,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37340',
  },
  {
    city: 'Harrison',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 178.3,
    imprecise: false,
    latitude: 35.21386,
    longitude: -85.0834,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37341',
  },
  {
    city: 'Hillsboro',
    county_fips: 47031,
    county_fips_all: '47031',
    county: 'Coffee',
    county_names_all: 'Coffee',
    county_weights: '{"47031": 100}',
    density: 21.8,
    imprecise: false,
    latitude: 35.38175,
    longitude: -85.94937,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37342',
  },
  {
    city: 'Hixson',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 413.7,
    imprecise: false,
    latitude: 35.16904,
    longitude: -85.20899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37343',
  },
  {
    city: 'Huntland',
    county_fips: 47051,
    county_fips_all: '47051',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"47051": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 35.0366,
    longitude: -86.24299,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37345',
  },
  {
    city: 'Jasper',
    county_fips: 47115,
    county_fips_all: '47115',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"47115": 100}',
    density: 67.9,
    imprecise: false,
    latitude: 35.06088,
    longitude: -85.61894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37347',
  },
  {
    city: 'Kelso',
    county_fips: 47103,
    county_fips_all: '47103',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"47103": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 35.11935,
    longitude: -86.44222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37348',
  },
  {
    city: 'Lookout Mountain',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 606.9,
    imprecise: false,
    latitude: 34.99445,
    longitude: -85.3516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37350',
  },
  {
    city: 'Lupton City',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 248.8,
    imprecise: false,
    latitude: 35.10073,
    longitude: -85.26135,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37351',
  },
  {
    city: 'Lynchburg',
    county_fips: 47127,
    county_fips_all: '47127|47051',
    county: 'Moore',
    county_names_all: 'Moore|Franklin',
    county_weights: '{"47127": 99.17, "47051": 0.83}',
    density: 24.5,
    imprecise: false,
    latitude: 35.27981,
    longitude: -86.35417,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37352',
  },
  {
    city: 'McDonald',
    county_fips: 47011,
    county_fips_all: '47011|47065',
    county: 'Bradley',
    county_names_all: 'Bradley|Hamilton',
    county_weights: '{"47011": 87.24, "47065": 12.76}',
    density: 50.9,
    imprecise: false,
    latitude: 35.12288,
    longitude: -84.9855,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37353',
  },
  {
    city: 'Madisonville',
    county_fips: 47123,
    county_fips_all: '47123|47107',
    county: 'Monroe',
    county_names_all: 'Monroe|McMinn',
    county_weights: '{"47123": 97.02, "47107": 2.98}',
    density: 57,
    imprecise: false,
    latitude: 35.50195,
    longitude: -84.34387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37354',
  },
  {
    city: 'Manchester',
    county_fips: 47031,
    county_fips_all: '47031',
    county: 'Coffee',
    county_names_all: 'Coffee',
    county_weights: '{"47031": 100}',
    density: 55.6,
    imprecise: false,
    latitude: 35.50843,
    longitude: -86.07866,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37355',
  },
  {
    city: 'Monteagle',
    county_fips: 47115,
    county_fips_all: '47115|47061|47051',
    county: 'Marion',
    county_names_all: 'Marion|Grundy|Franklin',
    county_weights: '{"47115": 56.24, "47061": 42.88, "47051": 0.88}',
    density: 42.1,
    imprecise: false,
    latitude: 35.22952,
    longitude: -85.82393,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37356',
  },
  {
    city: 'Morrison',
    county_fips: 47177,
    county_fips_all: '47177|47031|47061|47015',
    county: 'Warren',
    county_names_all: 'Warren|Coffee|Grundy|Cannon',
    county_weights:
      '{"47177": 54.31, "47031": 28.61, "47061": 10.4, "47015": 6.68}',
    density: 17.8,
    imprecise: false,
    latitude: 35.59454,
    longitude: -85.92003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37357',
  },
  {
    city: 'Mulberry',
    county_fips: 47103,
    county_fips_all: '47103|47127',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Moore',
    county_weights: '{"47103": 80.51, "47127": 19.49}',
    density: 10.6,
    imprecise: false,
    latitude: 35.19776,
    longitude: -86.4119,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37359',
  },
  {
    city: 'Normandy',
    county_fips: 47003,
    county_fips_all: '47003|47031|47127',
    county: 'Bedford',
    county_names_all: 'Bedford|Coffee|Moore',
    county_weights: '{"47003": 58.8, "47031": 37.03, "47127": 4.17}',
    density: 24,
    imprecise: false,
    latitude: 35.44702,
    longitude: -86.25586,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37360',
  },
  {
    city: 'Ocoee',
    county_fips: 47139,
    county_fips_all: '47139',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"47139": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 35.08543,
    longitude: -84.6551,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37361',
  },
  {
    city: 'Old Fort',
    county_fips: 47139,
    county_fips_all: '47139|47011',
    county: 'Polk',
    county_names_all: 'Polk|Bradley',
    county_weights: '{"47139": 79.26, "47011": 20.74}',
    density: 19.8,
    imprecise: false,
    latitude: 35.03152,
    longitude: -84.70028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37362',
  },
  {
    city: 'Ooltewah',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 270.3,
    imprecise: false,
    latitude: 35.11551,
    longitude: -85.0549,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37363',
  },
  {
    city: 'Palmer',
    county_fips: 47061,
    county_fips_all: '47061|47153',
    county: 'Grundy',
    county_names_all: 'Grundy|Sequatchie',
    county_weights: '{"47061": 70.61, "47153": 29.39}',
    density: 11.5,
    imprecise: false,
    latitude: 35.37287,
    longitude: -85.54013,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37365',
  },
  {
    city: 'Pelham',
    county_fips: 47061,
    county_fips_all: '47061|47051',
    county: 'Grundy',
    county_names_all: 'Grundy|Franklin',
    county_weights: '{"47061": 99.54, "47051": 0.46}',
    density: 9,
    imprecise: false,
    latitude: 35.32054,
    longitude: -85.84224,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37366',
  },
  {
    city: 'Pikeville',
    county_fips: 47007,
    county_fips_all: '47007|47035|47175',
    county: 'Bledsoe',
    county_names_all: 'Bledsoe|Cumberland|Van Buren',
    county_weights: '{"47007": 91.77, "47035": 4.41, "47175": 3.82}',
    density: 14.5,
    imprecise: false,
    latitude: 35.62959,
    longitude: -85.21832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37367',
  },
  {
    city: 'Reliance',
    county_fips: 47139,
    county_fips_all: '47139|47123',
    county: 'Polk',
    county_names_all: 'Polk|Monroe',
    county_weights: '{"47139": 90.47, "47123": 9.53}',
    density: 2.5,
    imprecise: false,
    latitude: 35.19908,
    longitude: -84.47707,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37369',
  },
  {
    city: 'Riceville',
    county_fips: 47107,
    county_fips_all: '47107',
    county: 'McMinn',
    county_names_all: 'McMinn',
    county_weights: '{"47107": 100}',
    density: 33.9,
    imprecise: false,
    latitude: 35.35903,
    longitude: -84.70064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37370',
  },
  {
    city: 'Sale Creek',
    county_fips: 47065,
    county_fips_all: '47065|47143',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Rhea',
    county_weights: '{"47065": 99.61, "47143": 0.39}',
    density: 31.1,
    imprecise: false,
    latitude: 35.39476,
    longitude: -85.10373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37373',
  },
  {
    city: 'Sequatchie',
    county_fips: 47115,
    county_fips_all: '47115',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"47115": 100}',
    density: 10,
    imprecise: false,
    latitude: 35.16404,
    longitude: -85.65818,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37374',
  },
  {
    city: 'Sewanee',
    county_fips: 47051,
    county_fips_all: '47051|47115',
    county: 'Franklin',
    county_names_all: 'Franklin|Marion',
    county_weights: '{"47051": 66.23, "47115": 33.77}',
    density: 21.8,
    imprecise: false,
    latitude: 35.15355,
    longitude: -85.88173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37375',
  },
  {
    city: 'Sherwood',
    county_fips: 47051,
    county_fips_all: '47051|47115',
    county: 'Franklin',
    county_names_all: 'Franklin|Marion',
    county_weights: '{"47051": 97.31, "47115": 2.69}',
    density: 1.7,
    imprecise: false,
    latitude: 35.04748,
    longitude: -85.95834,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37376',
  },
  {
    city: 'Signal Mountain',
    county_fips: 47065,
    county_fips_all: '47065|47153|47115',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Sequatchie|Marion',
    county_weights: '{"47065": 50.17, "47153": 46.24, "47115": 3.59}',
    density: 82.5,
    imprecise: false,
    latitude: 35.21243,
    longitude: -85.3389,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37377',
  },
  {
    city: 'Soddy Daisy',
    county_fips: 47065,
    county_fips_all: '47065|47153|47007',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Sequatchie|Bledsoe',
    county_weights: '{"47065": 88.6, "47153": 6.08, "47007": 5.32}',
    density: 106.8,
    imprecise: false,
    latitude: 35.29407,
    longitude: -85.17429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37379',
  },
  {
    city: 'South Pittsburg',
    county_fips: 47115,
    county_fips_all: '47115|47051',
    county: 'Marion',
    county_names_all: 'Marion|Franklin',
    county_weights: '{"47115": 98.62, "47051": 1.38}',
    density: 20.5,
    imprecise: false,
    latitude: 35.07265,
    longitude: -85.75754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37380',
  },
  {
    city: 'Spring City',
    county_fips: 47143,
    county_fips_all: '47143|47007',
    county: 'Rhea',
    county_names_all: 'Rhea|Bledsoe',
    county_weights: '{"47143": 81.59, "47007": 18.41}',
    density: 30.4,
    imprecise: false,
    latitude: 35.68533,
    longitude: -84.8775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37381',
  },
  {
    city: 'Tellico Plains',
    county_fips: 47123,
    county_fips_all: '47123',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"47123": 100}',
    density: 13,
    imprecise: false,
    latitude: 35.33494,
    longitude: -84.22933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37385',
  },
  {
    city: 'Tracy City',
    county_fips: 47061,
    county_fips_all: '47061|47115',
    county: 'Grundy',
    county_names_all: 'Grundy|Marion',
    county_weights: '{"47061": 68.72, "47115": 31.28}',
    density: 19.1,
    imprecise: false,
    latitude: 35.27745,
    longitude: -85.71427,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37387',
  },
  {
    city: 'Tullahoma',
    county_fips: 47031,
    county_fips_all: '47031|47051|47127|47003',
    county: 'Coffee',
    county_names_all: 'Coffee|Franklin|Moore|Bedford',
    county_weights:
      '{"47031": 42.99, "47051": 33.94, "47127": 19.73, "47003": 3.34}',
    density: 91.5,
    imprecise: false,
    latitude: 35.35141,
    longitude: -86.19747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37388',
  },
  {
    city: 'Turtletown',
    county_fips: 47139,
    county_fips_all: '47139',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"47139": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 35.09049,
    longitude: -84.35327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37391',
  },
  {
    city: 'Viola',
    county_fips: 47177,
    county_fips_all: '47177',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"47177": 100}',
    density: 307,
    imprecise: false,
    latitude: 35.53918,
    longitude: -85.86047,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37394',
  },
  {
    city: 'Whiteside',
    county_fips: 47115,
    county_fips_all: '47115',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"47115": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 35.00198,
    longitude: -85.50353,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37396',
  },
  {
    city: 'Whitwell',
    county_fips: 47115,
    county_fips_all: '47115|47153',
    county: 'Marion',
    county_names_all: 'Marion|Sequatchie',
    county_weights: '{"47115": 84.65, "47153": 15.35}',
    density: 27.1,
    imprecise: false,
    latitude: 35.21046,
    longitude: -85.51819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37397',
  },
  {
    city: 'Winchester',
    county_fips: 47051,
    county_fips_all: '47051|47127',
    county: 'Franklin',
    county_names_all: 'Franklin|Moore',
    county_weights: '{"47051": 94.38, "47127": 5.62}',
    density: 55.6,
    imprecise: false,
    latitude: 35.18182,
    longitude: -86.13808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37398',
  },
  {
    city: 'Chattanooga',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 1187.1,
    imprecise: false,
    latitude: 35.04672,
    longitude: -85.31553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37402',
  },
  {
    city: 'Chattanooga',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 1452.2,
    imprecise: false,
    latitude: 35.0476,
    longitude: -85.29448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37403',
  },
  {
    city: 'Chattanooga',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 1098.1,
    imprecise: false,
    latitude: 35.02827,
    longitude: -85.27331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37404',
  },
  {
    city: 'Chattanooga',
    county_fips: 47115,
    county_fips_all: '47115|47065',
    county: 'Marion',
    county_names_all: 'Marion|Hamilton',
    county_weights: '{"47115": 73.25, "47065": 26.75}',
    density: 128.7,
    imprecise: false,
    latitude: 35.11757,
    longitude: -85.40429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37405',
  },
  {
    city: 'Chattanooga',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 425.2,
    imprecise: false,
    latitude: 35.07246,
    longitude: -85.24541,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37406',
  },
  {
    city: 'Chattanooga',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 1039.9,
    imprecise: false,
    latitude: 35.002,
    longitude: -85.28941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37407',
  },
  {
    city: 'Chattanooga',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 636.3,
    imprecise: false,
    latitude: 35.03048,
    longitude: -85.31237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37408',
  },
  {
    city: 'Chattanooga',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 293.5,
    imprecise: false,
    latitude: 35.0012,
    longitude: -85.34466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37409',
  },
  {
    city: 'Chattanooga',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 527.2,
    imprecise: false,
    latitude: 35.002,
    longitude: -85.31366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37410',
  },
  {
    city: 'Chattanooga',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 999.3,
    imprecise: false,
    latitude: 35.02655,
    longitude: -85.23026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37411',
  },
  {
    city: 'Chattanooga',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 974.9,
    imprecise: false,
    latitude: 34.9974,
    longitude: -85.22726,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37412',
  },
  {
    city: 'Chattanooga',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 532.9,
    imprecise: false,
    latitude: 35.12735,
    longitude: -85.27932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37415',
  },
  {
    city: 'Chattanooga',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 261.6,
    imprecise: false,
    latitude: 35.09856,
    longitude: -85.15751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37416',
  },
  {
    city: 'Chattanooga',
    county_fips: 47115,
    county_fips_all: '47115|47065',
    county: 'Marion',
    county_names_all: 'Marion|Hamilton',
    county_weights: '{"47115": 53.89, "47065": 46.11}',
    density: 47.1,
    imprecise: false,
    latitude: 35.04052,
    longitude: -85.41734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37419',
  },
  {
    city: 'Chattanooga',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 645.3,
    imprecise: false,
    latitude: 35.02915,
    longitude: -85.153,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37421',
  },
  {
    city: 'Chattanooga',
    county_fips: 47065,
    county_fips_all: '47065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"47065": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.04897,
    longitude: -85.31217,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37450',
  },
  {
    city: 'Johnson City',
    county_fips: 47179,
    county_fips_all: '47179|47019|47171',
    county: 'Washington',
    county_names_all: 'Washington|Carter|Unicoi',
    county_weights: '{"47179": 53.45, "47019": 44.06, "47171": 2.49}',
    density: 307.5,
    imprecise: false,
    latitude: 36.32838,
    longitude: -82.31974,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37601',
  },
  {
    city: 'Johnson City',
    county_fips: 47179,
    county_fips_all: '47179|47019',
    county: 'Washington',
    county_names_all: 'Washington|Carter',
    county_weights: '{"47179": 94.35, "47019": 5.65}',
    density: 457.1,
    imprecise: false,
    latitude: 36.29923,
    longitude: -82.38302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37604',
  },
  {
    city: 'Johnson City',
    county_fips: 47179,
    county_fips_all: '47179',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"47179": 100}',
    density: 234.4,
    imprecise: false,
    latitude: 36.39771,
    longitude: -82.45246,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37615',
  },
  {
    city: 'Afton',
    county_fips: 47059,
    county_fips_all: '47059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"47059": 100}',
    density: 50.2,
    imprecise: false,
    latitude: 36.22619,
    longitude: -82.7498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37616',
  },
  {
    city: 'Blountville',
    county_fips: 47163,
    county_fips_all: '47163',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"47163": 100}',
    density: 97.4,
    imprecise: false,
    latitude: 36.53155,
    longitude: -82.37248,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37617',
  },
  {
    city: 'Bluff City',
    county_fips: 47163,
    county_fips_all: '47163',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"47163": 100}',
    density: 69.9,
    imprecise: false,
    latitude: 36.46555,
    longitude: -82.20833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37618',
  },
  {
    city: 'Bristol',
    county_fips: 47163,
    county_fips_all: '47163',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"47163": 100}',
    density: 115.9,
    imprecise: false,
    latitude: 36.55124,
    longitude: -82.09867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37620',
  },
  {
    city: 'Butler',
    county_fips: 47091,
    county_fips_all: '47091|47019',
    county: 'Johnson',
    county_names_all: 'Johnson|Carter',
    county_weights: '{"47091": 63.03, "47019": 36.97}',
    density: 14.2,
    imprecise: false,
    latitude: 36.33023,
    longitude: -81.9773,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37640',
  },
  {
    city: 'Chuckey',
    county_fips: 47059,
    county_fips_all: '47059|47179',
    county: 'Greene',
    county_names_all: 'Greene|Washington',
    county_weights: '{"47059": 82.38, "47179": 17.62}',
    density: 40.1,
    imprecise: false,
    latitude: 36.20015,
    longitude: -82.66306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37641',
  },
  {
    city: 'Church Hill',
    county_fips: 47073,
    county_fips_all: '47073|51169',
    county: 'Hawkins',
    county_names_all: 'Hawkins|Scott',
    county_weights: '{"47073": 99.53, "51169": 0.47}',
    density: 103.1,
    imprecise: false,
    latitude: 36.53261,
    longitude: -82.7267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37642',
  },
  {
    city: 'Elizabethton',
    county_fips: 47019,
    county_fips_all: '47019|47171',
    county: 'Carter',
    county_names_all: 'Carter|Unicoi',
    county_weights: '{"47019": 98.8, "47171": 1.2}',
    density: 100.5,
    imprecise: false,
    latitude: 36.37513,
    longitude: -82.13729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37643',
  },
  {
    city: 'Mount Carmel',
    county_fips: 47073,
    county_fips_all: '47073',
    county: 'Hawkins',
    county_names_all: 'Hawkins',
    county_weights: '{"47073": 100}',
    density: 338,
    imprecise: false,
    latitude: 36.56275,
    longitude: -82.66243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37645',
  },
  {
    city: 'Erwin',
    county_fips: 47171,
    county_fips_all: '47171|47179',
    county: 'Unicoi',
    county_names_all: 'Unicoi|Washington',
    county_weights: '{"47171": 96.06, "47179": 3.94}',
    density: 50.9,
    imprecise: false,
    latitude: 36.10416,
    longitude: -82.45938,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37650',
  },
  {
    city: 'Fall Branch',
    county_fips: 47179,
    county_fips_all: '47179|47059|47163',
    county: 'Washington',
    county_names_all: 'Washington|Greene|Sullivan',
    county_weights: '{"47179": 62.88, "47059": 28.82, "47163": 8.3}',
    density: 51.1,
    imprecise: false,
    latitude: 36.39997,
    longitude: -82.63075,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37656',
  },
  {
    city: 'Flag Pond',
    county_fips: 47171,
    county_fips_all: '47171',
    county: 'Unicoi',
    county_names_all: 'Unicoi',
    county_weights: '{"47171": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 36.01725,
    longitude: -82.56057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37657',
  },
  {
    city: 'Hampton',
    county_fips: 47019,
    county_fips_all: '47019|47171',
    county: 'Carter',
    county_names_all: 'Carter|Unicoi',
    county_weights: '{"47019": 99.75, "47171": 0.25}',
    density: 33.1,
    imprecise: false,
    latitude: 36.26352,
    longitude: -82.1535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37658',
  },
  {
    city: 'Jonesborough',
    county_fips: 47179,
    county_fips_all: '47179|47163',
    county: 'Washington',
    county_names_all: 'Washington|Sullivan',
    county_weights: '{"47179": 99.31, "47163": 0.69}',
    density: 88.5,
    imprecise: false,
    latitude: 36.28074,
    longitude: -82.4938,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37659',
  },
  {
    city: 'Kingsport',
    county_fips: 47163,
    county_fips_all: '47163|47073',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Hawkins',
    county_weights: '{"47163": 90.53, "47073": 9.47}',
    density: 240.9,
    imprecise: false,
    latitude: 36.52938,
    longitude: -82.57339,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37660',
  },
  {
    city: 'Kingsport',
    county_fips: 47163,
    county_fips_all: '47163|47179',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Washington',
    county_weights: '{"47163": 95.26, "47179": 4.74}',
    density: 213.3,
    imprecise: false,
    latitude: 36.46466,
    longitude: -82.48525,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37663',
  },
  {
    city: 'Kingsport',
    county_fips: 47163,
    county_fips_all: '47163',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"47163": 100}',
    density: 321.6,
    imprecise: false,
    latitude: 36.51163,
    longitude: -82.50729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37664',
  },
  {
    city: 'Kingsport',
    county_fips: 47163,
    county_fips_all: '47163',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"47163": 100}',
    density: 604.7,
    imprecise: false,
    latitude: 36.57951,
    longitude: -82.57304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37665',
  },
  {
    city: 'Laurel Bloomery',
    county_fips: 47091,
    county_fips_all: '47091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"47091": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 36.57462,
    longitude: -81.72556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37680',
  },
  {
    city: 'Limestone',
    county_fips: 47179,
    county_fips_all: '47179|47059',
    county: 'Washington',
    county_names_all: 'Washington|Greene',
    county_weights: '{"47179": 62.76, "47059": 37.24}',
    density: 33.9,
    imprecise: false,
    latitude: 36.25465,
    longitude: -82.62672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37681',
  },
  {
    city: 'Milligan',
    county_fips: 47019,
    county_fips_all: '47019',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"47019": 100}',
    density: 2238,
    imprecise: false,
    latitude: 36.30035,
    longitude: -82.29169,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37682',
  },
  {
    city: 'Mountain City',
    county_fips: 47091,
    county_fips_all: '47091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"47091": 100}',
    density: 37.3,
    imprecise: false,
    latitude: 36.45303,
    longitude: -81.82233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37683',
  },
  {
    city: 'Piney Flats',
    county_fips: 47163,
    county_fips_all: '47163|47179',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Washington',
    county_weights: '{"47163": 99.61, "47179": 0.39}',
    density: 124.4,
    imprecise: false,
    latitude: 36.44175,
    longitude: -82.34639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37686',
  },
  {
    city: 'Roan Mountain',
    county_fips: 47019,
    county_fips_all: '47019',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"47019": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 36.18667,
    longitude: -82.09667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37687',
  },
  {
    city: 'Shady Valley',
    county_fips: 47091,
    county_fips_all: '47091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"47091": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 36.54548,
    longitude: -81.88281,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37688',
  },
  {
    city: 'Telford',
    county_fips: 47179,
    county_fips_all: '47179',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"47179": 100}',
    density: 72.2,
    imprecise: false,
    latitude: 36.25124,
    longitude: -82.55895,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37690',
  },
  {
    city: 'Trade',
    county_fips: 47091,
    county_fips_all: '47091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"47091": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 36.36792,
    longitude: -81.75519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37691',
  },
  {
    city: 'Unicoi',
    county_fips: 47171,
    county_fips_all: '47171',
    county: 'Unicoi',
    county_names_all: 'Unicoi',
    county_weights: '{"47171": 100}',
    density: 34.7,
    imprecise: false,
    latitude: 36.18456,
    longitude: -82.30413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37692',
  },
  {
    city: 'Watauga',
    county_fips: 47019,
    county_fips_all: '47019|47163|47179',
    county: 'Carter',
    county_names_all: 'Carter|Sullivan|Washington',
    county_weights: '{"47019": 79.42, "47163": 17.62, "47179": 2.96}',
    density: 52.8,
    imprecise: false,
    latitude: 36.3849,
    longitude: -82.27588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37694',
  },
  {
    city: 'Alcoa',
    county_fips: 47009,
    county_fips_all: '47009',
    county: 'Blount',
    county_names_all: 'Blount',
    county_weights: '{"47009": 100}',
    density: 368.4,
    imprecise: false,
    latitude: 35.79393,
    longitude: -83.98461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37701',
  },
  {
    city: 'Andersonville',
    county_fips: 47001,
    county_fips_all: '47001|47173',
    county: 'Anderson',
    county_names_all: 'Anderson|Union',
    county_weights: '{"47001": 67.5, "47173": 32.5}',
    density: 45.3,
    imprecise: false,
    latitude: 36.22862,
    longitude: -84.00947,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37705',
  },
  {
    city: 'Bean Station',
    county_fips: 47057,
    county_fips_all: '47057',
    county: 'Grainger',
    county_names_all: 'Grainger',
    county_weights: '{"47057": 100}',
    density: 60.9,
    imprecise: false,
    latitude: 36.32312,
    longitude: -83.33588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37708',
  },
  {
    city: 'Blaine',
    county_fips: 47057,
    county_fips_all: '47057|47093',
    county: 'Grainger',
    county_names_all: 'Grainger|Knox',
    county_weights: '{"47057": 98.65, "47093": 1.35}',
    density: 38.9,
    imprecise: false,
    latitude: 36.16798,
    longitude: -83.66479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37709',
  },
  {
    city: 'Briceville',
    county_fips: 47001,
    county_fips_all: '47001',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"47001": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 36.15802,
    longitude: -84.3177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37710',
  },
  {
    city: 'Bulls Gap',
    county_fips: 47073,
    county_fips_all: '47073|47059|47063',
    county: 'Hawkins',
    county_names_all: 'Hawkins|Greene|Hamblen',
    county_weights: '{"47073": 55.13, "47059": 41.08, "47063": 3.79}',
    density: 41.8,
    imprecise: false,
    latitude: 36.28102,
    longitude: -83.03885,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37711',
  },
  {
    city: 'Bybee',
    county_fips: 47029,
    county_fips_all: '47029',
    county: 'Cocke',
    county_names_all: 'Cocke',
    county_weights: '{"47029": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 36.09073,
    longitude: -83.13373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37713',
  },
  {
    city: 'Caryville',
    county_fips: 47013,
    county_fips_all: '47013',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"47013": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 36.26656,
    longitude: -84.25277,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37714',
  },
  {
    city: 'Clairfield',
    county_fips: 47025,
    county_fips_all: '47025|47013',
    county: 'Claiborne',
    county_names_all: 'Claiborne|Campbell',
    county_weights: '{"47025": 72.99, "47013": 27.01}',
    density: 12.2,
    imprecise: false,
    latitude: 36.55323,
    longitude: -83.95894,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37715',
  },
  {
    city: 'Clinton',
    county_fips: 47001,
    county_fips_all: '47001',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"47001": 100}',
    density: 126.9,
    imprecise: false,
    latitude: 36.09919,
    longitude: -84.16822,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37716',
  },
  {
    city: 'Coalfield',
    county_fips: 47129,
    county_fips_all: '47129',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"47129": 100}',
    density: 26.6,
    imprecise: false,
    latitude: 36.02196,
    longitude: -84.42815,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37719',
  },
  {
    city: 'Corryton',
    county_fips: 47093,
    county_fips_all: '47093|47173',
    county: 'Knox',
    county_names_all: 'Knox|Union',
    county_weights: '{"47093": 90.09, "47173": 9.91}',
    density: 112.1,
    imprecise: false,
    latitude: 36.13155,
    longitude: -83.80829,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37721',
  },
  {
    city: 'Cosby',
    county_fips: 47029,
    county_fips_all: '47029|47155',
    county: 'Cocke',
    county_names_all: 'Cocke|Sevier',
    county_weights: '{"47029": 85.67, "47155": 14.33}',
    density: 28.9,
    imprecise: false,
    latitude: 35.80611,
    longitude: -83.23339,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37722',
  },
  {
    city: 'Crab Orchard',
    county_fips: 47035,
    county_fips_all: '47035',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"47035": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 35.96044,
    longitude: -84.82171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37723',
  },
  {
    city: 'Cumberland Gap',
    county_fips: 47025,
    county_fips_all: '47025',
    county: 'Claiborne',
    county_names_all: 'Claiborne',
    county_weights: '{"47025": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 36.54457,
    longitude: -83.69328,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37724',
  },
  {
    city: 'Dandridge',
    county_fips: 47089,
    county_fips_all: '47089|47155',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Sevier',
    county_weights: '{"47089": 98.92, "47155": 1.08}',
    density: 75.7,
    imprecise: false,
    latitude: 35.99778,
    longitude: -83.39678,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37725',
  },
  {
    city: 'Deer Lodge',
    county_fips: 47129,
    county_fips_all: '47129|47049',
    county: 'Morgan',
    county_names_all: 'Morgan|Fentress',
    county_weights: '{"47129": 87.58, "47049": 12.42}',
    density: 10.8,
    imprecise: false,
    latitude: 36.20464,
    longitude: -84.8386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37726',
  },
  {
    city: 'Del Rio',
    county_fips: 47029,
    county_fips_all: '47029',
    county: 'Cocke',
    county_names_all: 'Cocke',
    county_weights: '{"47029": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 35.88885,
    longitude: -83.00651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37727',
  },
  {
    city: 'Duff',
    county_fips: 47013,
    county_fips_all: '47013',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"47013": 100}',
    density: 10,
    imprecise: false,
    latitude: 36.51412,
    longitude: -84.03276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37729',
  },
  {
    city: 'Eagan',
    county_fips: 47025,
    county_fips_all: '47025|47013',
    county: 'Claiborne',
    county_names_all: 'Claiborne|Campbell',
    county_weights: '{"47025": 99.43, "47013": 0.57}',
    density: 8.4,
    imprecise: false,
    latitude: 36.56837,
    longitude: -83.97357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37730',
  },
  {
    city: 'Eidson',
    county_fips: 47073,
    county_fips_all: '47073|47067',
    county: 'Hawkins',
    county_names_all: 'Hawkins|Hancock',
    county_weights: '{"47073": 50.11, "47067": 49.89}',
    density: 4.4,
    imprecise: false,
    latitude: 36.54383,
    longitude: -83.00873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37731',
  },
  {
    city: 'Elgin',
    county_fips: 47151,
    county_fips_all: '47151',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"47151": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.32792,
    longitude: -84.6282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37732',
  },
  {
    city: 'Friendsville',
    county_fips: 47009,
    county_fips_all: '47009|47105',
    county: 'Blount',
    county_names_all: 'Blount|Loudon',
    county_weights: '{"47009": 93.62, "47105": 6.38}',
    density: 102.5,
    imprecise: false,
    latitude: 35.75778,
    longitude: -84.11913,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37737',
  },
  {
    city: 'Gatlinburg',
    county_fips: 47155,
    county_fips_all: '47155',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"47155": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 35.67125,
    longitude: -83.47641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37738',
  },
  {
    city: 'Greenback',
    county_fips: 47105,
    county_fips_all: '47105|47009',
    county: 'Loudon',
    county_names_all: 'Loudon|Blount',
    county_weights: '{"47105": 69.37, "47009": 30.63}',
    density: 55.1,
    imprecise: false,
    latitude: 35.67548,
    longitude: -84.18049,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37742',
  },
  {
    city: 'Greeneville',
    county_fips: 47059,
    county_fips_all: '47059|47029',
    county: 'Greene',
    county_names_all: 'Greene|Cocke',
    county_weights: '{"47059": 98.14, "47029": 1.86}',
    density: 42.7,
    imprecise: false,
    latitude: 36.06663,
    longitude: -82.85659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37743',
  },
  {
    city: 'Greeneville',
    county_fips: 47059,
    county_fips_all: '47059|47073',
    county: 'Greene',
    county_names_all: 'Greene|Hawkins',
    county_weights: '{"47059": 96.61, "47073": 3.39}',
    density: 66.8,
    imprecise: false,
    latitude: 36.2784,
    longitude: -82.82631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37745',
  },
  {
    city: 'Harriman',
    county_fips: 47145,
    county_fips_all: '47145|47129',
    county: 'Roane',
    county_names_all: 'Roane|Morgan',
    county_weights: '{"47145": 71.47, "47129": 28.53}',
    density: 63.7,
    imprecise: false,
    latitude: 35.94797,
    longitude: -84.51413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37748',
  },
  {
    city: 'Harrogate',
    county_fips: 47025,
    county_fips_all: '47025|51105',
    county: 'Claiborne',
    county_names_all: 'Claiborne|Lee',
    county_weights: '{"47025": 99.42, "51105": 0.58}',
    density: 50.6,
    imprecise: false,
    latitude: 36.56735,
    longitude: -83.55422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37752',
  },
  {
    city: 'Hartford',
    county_fips: 47029,
    county_fips_all: '47029',
    county: 'Cocke',
    county_names_all: 'Cocke',
    county_weights: '{"47029": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 35.82276,
    longitude: -83.098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37753',
  },
  {
    city: 'Heiskell',
    county_fips: 47001,
    county_fips_all: '47001|47093|47173',
    county: 'Anderson',
    county_names_all: 'Anderson|Knox|Union',
    county_weights: '{"47001": 68.37, "47093": 27.18, "47173": 4.45}',
    density: 42.5,
    imprecise: false,
    latitude: 36.13059,
    longitude: -84.03305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37754',
  },
  {
    city: 'Helenwood',
    county_fips: 47151,
    county_fips_all: '47151',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"47151": 100}',
    density: 34.7,
    imprecise: false,
    latitude: 36.42249,
    longitude: -84.53166,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37755',
  },
  {
    city: 'Huntsville',
    county_fips: 47151,
    county_fips_all: '47151|47013',
    county: 'Scott',
    county_names_all: 'Scott|Campbell',
    county_weights: '{"47151": 87.44, "47013": 12.56}',
    density: 9.4,
    imprecise: false,
    latitude: 36.30165,
    longitude: -84.40704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37756',
  },
  {
    city: 'Jacksboro',
    county_fips: 47013,
    county_fips_all: '47013',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"47013": 100}',
    density: 137.8,
    imprecise: false,
    latitude: 36.30182,
    longitude: -84.14371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37757',
  },
  {
    city: 'Jefferson City',
    county_fips: 47089,
    county_fips_all: '47089',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"47089": 100}',
    density: 125.7,
    imprecise: false,
    latitude: 36.10773,
    longitude: -83.46443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37760',
  },
  {
    city: 'Jellico',
    county_fips: 47013,
    county_fips_all: '47013',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"47013": 100}',
    density: 64.3,
    imprecise: false,
    latitude: 36.57657,
    longitude: -84.12323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37762',
  },
  {
    city: 'Kingston',
    county_fips: 47145,
    county_fips_all: '47145',
    county: 'Roane',
    county_names_all: 'Roane',
    county_weights: '{"47145": 100}',
    density: 76.3,
    imprecise: false,
    latitude: 35.82344,
    longitude: -84.49356,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37763',
  },
  {
    city: 'Kodak',
    county_fips: 47155,
    county_fips_all: '47155|47093|47089',
    county: 'Sevier',
    county_names_all: 'Sevier|Knox|Jefferson',
    county_weights: '{"47155": 87.37, "47093": 12.39, "47089": 0.24}',
    density: 142.4,
    imprecise: false,
    latitude: 35.97074,
    longitude: -83.61585,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37764',
  },
  {
    city: 'Kyles Ford',
    county_fips: 47067,
    county_fips_all: '47067',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"47067": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 36.57219,
    longitude: -83.06534,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37765',
  },
  {
    city: 'La Follette',
    county_fips: 47013,
    county_fips_all: '47013',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"47013": 100}',
    density: 52.2,
    imprecise: false,
    latitude: 36.39958,
    longitude: -84.07275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37766',
  },
  {
    city: 'Rocky Top',
    county_fips: 47001,
    county_fips_all: '47001|47013',
    county: 'Anderson',
    county_names_all: 'Anderson|Campbell',
    county_weights: '{"47001": 81.22, "47013": 18.78}',
    density: 75.2,
    imprecise: false,
    latitude: 36.21799,
    longitude: -84.15532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37769',
  },
  {
    city: 'Lancing',
    county_fips: 47129,
    county_fips_all: '47129',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"47129": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 36.15239,
    longitude: -84.6418,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37770',
  },
  {
    city: 'Lenoir City',
    county_fips: 47105,
    county_fips_all: '47105|47145',
    county: 'Loudon',
    county_names_all: 'Loudon|Roane',
    county_weights: '{"47105": 74.89, "47145": 25.11}',
    density: 138.9,
    imprecise: false,
    latitude: 35.8382,
    longitude: -84.31748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37771',
  },
  {
    city: 'Lenoir City',
    county_fips: 47105,
    county_fips_all: '47105|47093',
    county: 'Loudon',
    county_names_all: 'Loudon|Knox',
    county_weights: '{"47105": 99.88, "47093": 0.12}',
    density: 146.2,
    imprecise: false,
    latitude: 35.78775,
    longitude: -84.21876,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37772',
  },
  {
    city: 'Loudon',
    county_fips: 47105,
    county_fips_all: '47105|47145|47123',
    county: 'Loudon',
    county_names_all: 'Loudon|Roane|Monroe',
    county_weights: '{"47105": 86.78, "47145": 12.08, "47123": 1.14}',
    density: 95.4,
    imprecise: false,
    latitude: 35.7317,
    longitude: -84.35526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37774',
  },
  {
    city: 'Louisville',
    county_fips: 47009,
    county_fips_all: '47009|47093',
    county: 'Blount',
    county_names_all: 'Blount|Knox',
    county_weights: '{"47009": 99.83, "47093": 0.17}',
    density: 151.2,
    imprecise: false,
    latitude: 35.82742,
    longitude: -84.05186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37777',
  },
  {
    city: 'Luttrell',
    county_fips: 47173,
    county_fips_all: '47173|47093|47057',
    county: 'Union',
    county_names_all: 'Union|Knox|Grainger',
    county_weights: '{"47173": 95.74, "47093": 4.05, "47057": 0.21}',
    density: 40.8,
    imprecise: false,
    latitude: 36.21093,
    longitude: -83.75793,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37779',
  },
  {
    city: 'Maryville',
    county_fips: 47009,
    county_fips_all: '47009|47123',
    county: 'Blount',
    county_names_all: 'Blount|Monroe',
    county_weights: '{"47009": 87.63, "47123": 12.37}',
    density: 156.3,
    imprecise: false,
    latitude: 35.67134,
    longitude: -84.08453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37801',
  },
  {
    city: 'Maryville',
    county_fips: 47009,
    county_fips_all: '47009',
    county: 'Blount',
    county_names_all: 'Blount',
    county_weights: '{"47009": 100}',
    density: 148.8,
    imprecise: false,
    latitude: 35.67115,
    longitude: -83.97761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37803',
  },
  {
    city: 'Maryville',
    county_fips: 47009,
    county_fips_all: '47009',
    county: 'Blount',
    county_names_all: 'Blount',
    county_weights: '{"47009": 100}',
    density: 303.3,
    imprecise: false,
    latitude: 35.79228,
    longitude: -83.89311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37804',
  },
  {
    city: 'Mascot',
    county_fips: 47093,
    county_fips_all: '47093|47057',
    county: 'Knox',
    county_names_all: 'Knox|Grainger',
    county_weights: '{"47093": 88.42, "47057": 11.58}',
    density: 78.1,
    imprecise: false,
    latitude: 36.08645,
    longitude: -83.72368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37806',
  },
  {
    city: 'Maynardville',
    county_fips: 47173,
    county_fips_all: '47173|47093',
    county: 'Union',
    county_names_all: 'Union|Knox',
    county_weights: '{"47173": 99.38, "47093": 0.62}',
    density: 53.5,
    imprecise: false,
    latitude: 36.25955,
    longitude: -83.82702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37807',
  },
  {
    city: 'Midway',
    county_fips: 47059,
    county_fips_all: '47059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"47059": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 36.15431,
    longitude: -83.03611,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37809',
  },
  {
    city: 'Mohawk',
    county_fips: 47059,
    county_fips_all: '47059',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"47059": 100}',
    density: 21,
    imprecise: false,
    latitude: 36.17984,
    longitude: -83.10296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37810',
  },
  {
    city: 'Mooresburg',
    county_fips: 47073,
    county_fips_all: '47073|47057',
    county: 'Hawkins',
    county_names_all: 'Hawkins|Grainger',
    county_weights: '{"47073": 98.39, "47057": 1.61}',
    density: 39.3,
    imprecise: false,
    latitude: 36.35558,
    longitude: -83.2144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37811',
  },
  {
    city: 'Morristown',
    county_fips: 47063,
    county_fips_all: '47063|47089',
    county: 'Hamblen',
    county_names_all: 'Hamblen|Jefferson',
    county_weights: '{"47063": 97.36, "47089": 2.64}',
    density: 121.7,
    imprecise: false,
    latitude: 36.17644,
    longitude: -83.26542,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37813',
  },
  {
    city: 'Morristown',
    county_fips: 47063,
    county_fips_all: '47063',
    county: 'Hamblen',
    county_names_all: 'Hamblen',
    county_weights: '{"47063": 100}',
    density: 310.2,
    imprecise: false,
    latitude: 36.23604,
    longitude: -83.3317,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37814',
  },
  {
    city: 'Mosheim',
    county_fips: 47059,
    county_fips_all: '47059|47029',
    county: 'Greene',
    county_names_all: 'Greene|Cocke',
    county_weights: '{"47059": 99.77, "47029": 0.23}',
    density: 48.3,
    imprecise: false,
    latitude: 36.18581,
    longitude: -82.97233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37818',
  },
  {
    city: 'Newcomb',
    county_fips: 47013,
    county_fips_all: '47013',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"47013": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 36.55649,
    longitude: -84.21169,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37819',
  },
  {
    city: 'New Market',
    county_fips: 47089,
    county_fips_all: '47089',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"47089": 100}',
    density: 47.5,
    imprecise: false,
    latitude: 36.08364,
    longitude: -83.56715,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37820',
  },
  {
    city: 'Newport',
    county_fips: 47029,
    county_fips_all: '47029|47089',
    county: 'Cocke',
    county_names_all: 'Cocke|Jefferson',
    county_weights: '{"47029": 99.8, "47089": 0.2}',
    density: 68.2,
    imprecise: false,
    latitude: 35.97688,
    longitude: -83.19506,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37821',
  },
  {
    city: 'New Tazewell',
    county_fips: 47025,
    county_fips_all: '47025|47173',
    county: 'Claiborne',
    county_names_all: 'Claiborne|Union',
    county_weights: '{"47025": 94.81, "47173": 5.19}',
    density: 37.3,
    imprecise: false,
    latitude: 36.41221,
    longitude: -83.68196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37825',
  },
  {
    city: 'Niota',
    county_fips: 47107,
    county_fips_all: '47107|47121',
    county: 'McMinn',
    county_names_all: 'McMinn|Meigs',
    county_weights: '{"47107": 98.73, "47121": 1.27}',
    density: 24.8,
    imprecise: false,
    latitude: 35.55825,
    longitude: -84.58984,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37826',
  },
  {
    city: 'Norris',
    county_fips: 47001,
    county_fips_all: '47001',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"47001": 100}',
    density: 165.1,
    imprecise: false,
    latitude: 36.19788,
    longitude: -84.06889,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37828',
  },
  {
    city: 'Oakdale',
    county_fips: 47129,
    county_fips_all: '47129',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"47129": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 36.00094,
    longitude: -84.61331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37829',
  },
  {
    city: 'Oak Ridge',
    county_fips: 47001,
    county_fips_all: '47001|47145|47093',
    county: 'Anderson',
    county_names_all: 'Anderson|Roane|Knox',
    county_weights: '{"47001": 52.24, "47145": 47.23, "47093": 0.53}',
    density: 150.4,
    imprecise: false,
    latitude: 35.96431,
    longitude: -84.29221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37830',
  },
  {
    city: 'Oliver Springs',
    county_fips: 47129,
    county_fips_all: '47129|47001|47145',
    county: 'Morgan',
    county_names_all: 'Morgan|Anderson|Roane',
    county_weights: '{"47129": 44.27, "47001": 36.8, "47145": 18.92}',
    density: 47.9,
    imprecise: false,
    latitude: 36.05849,
    longitude: -84.37047,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37840',
  },
  {
    city: 'Oneida',
    county_fips: 47151,
    county_fips_all: '47151',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"47151": 100}',
    density: 26.7,
    imprecise: false,
    latitude: 36.5088,
    longitude: -84.54665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37841',
  },
  {
    city: 'Parrottsville',
    county_fips: 47029,
    county_fips_all: '47029',
    county: 'Cocke',
    county_names_all: 'Cocke',
    county_weights: '{"47029": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 36.01137,
    longitude: -83.04979,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37843',
  },
  {
    city: 'Petros',
    county_fips: 47129,
    county_fips_all: '47129',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"47129": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 36.10369,
    longitude: -84.45022,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37845',
  },
  {
    city: 'Philadelphia',
    county_fips: 47105,
    county_fips_all: '47105|47145|47123|47107|47121',
    county: 'Loudon',
    county_names_all: 'Loudon|Roane|Monroe|McMinn|Meigs',
    county_weights:
      '{"47105": 42.69, "47145": 38.7, "47123": 14.53, "47107": 3.94, "47121": 0.13}',
    density: 24.4,
    imprecise: false,
    latitude: 35.68008,
    longitude: -84.48505,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37846',
  },
  {
    city: 'Pioneer',
    county_fips: 47013,
    county_fips_all: '47013|47151',
    county: 'Campbell',
    county_names_all: 'Campbell|Scott',
    county_weights: '{"47013": 81.65, "47151": 18.35}',
    density: 6.6,
    imprecise: false,
    latitude: 36.43156,
    longitude: -84.27346,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37847',
  },
  {
    city: 'Powder Springs',
    county_fips: 47057,
    county_fips_all: '47057|47173',
    county: 'Grainger',
    county_names_all: 'Grainger|Union',
    county_weights: '{"47057": 74.67, "47173": 25.33}',
    density: 7,
    imprecise: false,
    latitude: 36.23701,
    longitude: -83.68179,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37848',
  },
  {
    city: 'Powell',
    county_fips: 47093,
    county_fips_all: '47093|47001',
    county: 'Knox',
    county_names_all: 'Knox|Anderson',
    county_weights: '{"47093": 70.8, "47001": 29.2}',
    density: 285.4,
    imprecise: false,
    latitude: 36.0578,
    longitude: -84.04476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37849',
  },
  {
    city: 'Robbins',
    county_fips: 47151,
    county_fips_all: '47151|47129',
    county: 'Scott',
    county_names_all: 'Scott|Morgan',
    county_weights: '{"47151": 90.73, "47129": 9.27}',
    density: 10.1,
    imprecise: false,
    latitude: 36.32365,
    longitude: -84.57454,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37852',
  },
  {
    city: 'Rockford',
    county_fips: 47009,
    county_fips_all: '47009|47093',
    county: 'Blount',
    county_names_all: 'Blount|Knox',
    county_weights: '{"47009": 91.21, "47093": 8.79}',
    density: 77.6,
    imprecise: false,
    latitude: 35.83723,
    longitude: -83.90854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37853',
  },
  {
    city: 'Rockwood',
    county_fips: 47145,
    county_fips_all: '47145|47035|47129',
    county: 'Roane',
    county_names_all: 'Roane|Cumberland|Morgan',
    county_weights: '{"47145": 47.68, "47035": 39.65, "47129": 12.66}',
    density: 35.3,
    imprecise: false,
    latitude: 35.88004,
    longitude: -84.71454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37854',
  },
  {
    city: 'Rogersville',
    county_fips: 47073,
    county_fips_all: '47073|47163',
    county: 'Hawkins',
    county_names_all: 'Hawkins|Sullivan',
    county_weights: '{"47073": 99.4, "47163": 0.6}',
    density: 35.5,
    imprecise: false,
    latitude: 36.42145,
    longitude: -82.94269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37857',
  },
  {
    city: 'Russellville',
    county_fips: 47063,
    county_fips_all: '47063',
    county: 'Hamblen',
    county_names_all: 'Hamblen',
    county_weights: '{"47063": 100}',
    density: 59.4,
    imprecise: false,
    latitude: 36.24492,
    longitude: -83.18441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37860',
  },
  {
    city: 'Rutledge',
    county_fips: 47057,
    county_fips_all: '47057',
    county: 'Grainger',
    county_names_all: 'Grainger',
    county_weights: '{"47057": 100}',
    density: 33.7,
    imprecise: false,
    latitude: 36.24516,
    longitude: -83.51421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37861',
  },
  {
    city: 'Sevierville',
    county_fips: 47155,
    county_fips_all: '47155',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"47155": 100}',
    density: 102.8,
    imprecise: false,
    latitude: 35.78314,
    longitude: -83.61232,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37862',
  },
  {
    city: 'Pigeon Forge',
    county_fips: 47155,
    county_fips_all: '47155',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"47155": 100}',
    density: 148.3,
    imprecise: false,
    latitude: 35.7864,
    longitude: -83.56367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37863',
  },
  {
    city: 'Seymour',
    county_fips: 47155,
    county_fips_all: '47155|47009',
    county: 'Sevier',
    county_names_all: 'Sevier|Blount',
    county_weights: '{"47155": 69.3, "47009": 30.7}',
    density: 132,
    imprecise: false,
    latitude: 35.84609,
    longitude: -83.73974,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37865',
  },
  {
    city: 'Sharps Chapel',
    county_fips: 47173,
    county_fips_all: '47173',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"47173": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 36.35017,
    longitude: -83.8517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37866',
  },
  {
    city: 'Sneedville',
    county_fips: 47067,
    county_fips_all: '47067|47073|47025',
    county: 'Hancock',
    county_names_all: 'Hancock|Hawkins|Claiborne',
    county_weights: '{"47067": 88.44, "47073": 6.7, "47025": 4.86}',
    density: 15.3,
    imprecise: false,
    latitude: 36.51555,
    longitude: -83.24579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37869',
  },
  {
    city: 'Speedwell',
    county_fips: 47025,
    county_fips_all: '47025|47013|47173',
    county: 'Claiborne',
    county_names_all: 'Claiborne|Campbell|Union',
    county_weights: '{"47025": 73.2, "47013": 15.26, "47173": 11.54}',
    density: 20.4,
    imprecise: false,
    latitude: 36.46319,
    longitude: -83.83562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37870',
  },
  {
    city: 'Strawberry Plains',
    county_fips: 47093,
    county_fips_all: '47093|47089|47155',
    county: 'Knox',
    county_names_all: 'Knox|Jefferson|Sevier',
    county_weights: '{"47093": 45.45, "47089": 42.92, "47155": 11.63}',
    density: 98,
    imprecise: false,
    latitude: 36.04693,
    longitude: -83.67932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37871',
  },
  {
    city: 'Sunbright',
    county_fips: 47129,
    county_fips_all: '47129|47151',
    county: 'Morgan',
    county_names_all: 'Morgan|Scott',
    county_weights: '{"47129": 86.35, "47151": 13.65}',
    density: 9.9,
    imprecise: false,
    latitude: 36.26869,
    longitude: -84.68119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37872',
  },
  {
    city: 'Surgoinsville',
    county_fips: 47073,
    county_fips_all: '47073',
    county: 'Hawkins',
    county_names_all: 'Hawkins',
    county_weights: '{"47073": 100}',
    density: 24.4,
    imprecise: false,
    latitude: 36.52446,
    longitude: -82.84754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37873',
  },
  {
    city: 'Sweetwater',
    county_fips: 47123,
    county_fips_all: '47123|47107|47105|47145',
    county: 'Monroe',
    county_names_all: 'Monroe|McMinn|Loudon|Roane',
    county_weights:
      '{"47123": 70.29, "47107": 20.58, "47105": 8.72, "47145": 0.41}',
    density: 62.2,
    imprecise: false,
    latitude: 35.59749,
    longitude: -84.45823,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37874',
  },
  {
    city: 'Sevierville',
    county_fips: 47155,
    county_fips_all: '47155|47089',
    county: 'Sevier',
    county_names_all: 'Sevier|Jefferson',
    county_weights: '{"47155": 91.46, "47089": 8.54}',
    density: 69.4,
    imprecise: false,
    latitude: 35.8645,
    longitude: -83.47876,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37876',
  },
  {
    city: 'Talbott',
    county_fips: 47089,
    county_fips_all: '47089|47063',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Hamblen',
    county_weights: '{"47089": 55.4, "47063": 44.6}',
    density: 134,
    imprecise: false,
    latitude: 36.15176,
    longitude: -83.40503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37877',
  },
  {
    city: 'Tallassee',
    county_fips: 47009,
    county_fips_all: '47009',
    county: 'Blount',
    county_names_all: 'Blount',
    county_weights: '{"47009": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 35.59406,
    longitude: -83.98358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37878',
  },
  {
    city: 'Tazewell',
    county_fips: 47025,
    county_fips_all: '47025|47067',
    county: 'Claiborne',
    county_names_all: 'Claiborne|Hancock',
    county_weights: '{"47025": 80.38, "47067": 19.62}',
    density: 26.1,
    imprecise: false,
    latitude: 36.48403,
    longitude: -83.48705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37879',
  },
  {
    city: 'Ten Mile',
    county_fips: 47121,
    county_fips_all: '47121|47145|47107',
    county: 'Meigs',
    county_names_all: 'Meigs|Roane|McMinn',
    county_weights: '{"47121": 56.61, "47145": 42.93, "47107": 0.46}',
    density: 18.9,
    imprecise: false,
    latitude: 35.7012,
    longitude: -84.66453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37880',
  },
  {
    city: 'Thorn Hill',
    county_fips: 47057,
    county_fips_all: '47057|47067|47073|47025',
    county: 'Grainger',
    county_names_all: 'Grainger|Hancock|Hawkins|Claiborne',
    county_weights:
      '{"47057": 56.61, "47067": 35.83, "47073": 6.99, "47025": 0.57}',
    density: 9,
    imprecise: false,
    latitude: 36.39861,
    longitude: -83.34393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37881',
  },
  {
    city: 'Townsend',
    county_fips: 47009,
    county_fips_all: '47009',
    county: 'Blount',
    county_names_all: 'Blount',
    county_weights: '{"47009": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 35.60335,
    longitude: -83.82118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37882',
  },
  {
    city: 'Vonore',
    county_fips: 47123,
    county_fips_all: '47123|47105',
    county: 'Monroe',
    county_names_all: 'Monroe|Loudon',
    county_weights: '{"47123": 97.86, "47105": 2.14}',
    density: 16.7,
    imprecise: false,
    latitude: 35.50392,
    longitude: -84.12539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37885',
  },
  {
    city: 'Walland',
    county_fips: 47009,
    county_fips_all: '47009',
    county: 'Blount',
    county_names_all: 'Blount',
    county_weights: '{"47009": 100}',
    density: 33.4,
    imprecise: false,
    latitude: 35.74142,
    longitude: -83.80747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37886',
  },
  {
    city: 'Wartburg',
    county_fips: 47129,
    county_fips_all: '47129',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"47129": 100}',
    density: 31.1,
    imprecise: false,
    latitude: 36.0772,
    longitude: -84.61573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37887',
  },
  {
    city: 'Washburn',
    county_fips: 47057,
    county_fips_all: '47057|47173',
    county: 'Grainger',
    county_names_all: 'Grainger|Union',
    county_weights: '{"47057": 90.99, "47173": 9.01}',
    density: 23.8,
    imprecise: false,
    latitude: 36.31063,
    longitude: -83.61266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37888',
  },
  {
    city: 'White Pine',
    county_fips: 47089,
    county_fips_all: '47089|47063',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Hamblen',
    county_weights: '{"47089": 94.1, "47063": 5.9}',
    density: 76.4,
    imprecise: false,
    latitude: 36.08144,
    longitude: -83.29299,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37890',
  },
  {
    city: 'Whitesburg',
    county_fips: 47063,
    county_fips_all: '47063|47073',
    county: 'Hamblen',
    county_names_all: 'Hamblen|Hawkins',
    county_weights: '{"47063": 64.91, "47073": 35.09}',
    density: 40.7,
    imprecise: false,
    latitude: 36.29172,
    longitude: -83.13992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37891',
  },
  {
    city: 'Winfield',
    county_fips: 47151,
    county_fips_all: '47151',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"47151": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 36.55666,
    longitude: -84.37132,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37892',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 2106.8,
    imprecise: false,
    latitude: 35.96203,
    longitude: -83.92039,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37902',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 952.3,
    imprecise: false,
    latitude: 35.94716,
    longitude: -84.02275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37909',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 786.4,
    imprecise: false,
    latitude: 36.00849,
    longitude: -83.98465,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37912',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 208.8,
    imprecise: false,
    latitude: 35.97988,
    longitude: -83.79937,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37914',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 1227.5,
    imprecise: false,
    latitude: 35.97057,
    longitude: -83.90002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37915',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 4270,
    imprecise: false,
    latitude: 35.95309,
    longitude: -83.9335,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37916',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 1000.2,
    imprecise: false,
    latitude: 36.00156,
    longitude: -83.91265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37917',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 513.6,
    imprecise: false,
    latitude: 36.0599,
    longitude: -83.91082,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37918',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 641.7,
    imprecise: false,
    latitude: 35.91429,
    longitude: -84.00106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37919',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093|47009',
    county: 'Knox',
    county_names_all: 'Knox|Blount',
    county_weights: '{"47093": 99.23, "47009": 0.77}',
    density: 240.3,
    imprecise: false,
    latitude: 35.91084,
    longitude: -83.85909,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37920',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 697.3,
    imprecise: false,
    latitude: 35.97877,
    longitude: -84.00028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37921',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093|47105',
    county: 'Knox',
    county_names_all: 'Knox|Loudon',
    county_weights: '{"47093": 99.35, "47105": 0.65}',
    density: 562.5,
    imprecise: false,
    latitude: 35.86124,
    longitude: -84.10127,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37922',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 1049.2,
    imprecise: false,
    latitude: 35.92697,
    longitude: -84.08076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37923',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 199.8,
    imprecise: false,
    latitude: 36.03554,
    longitude: -83.80211,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37924',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.96241,
    longitude: -83.91597,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37929',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093|47001',
    county: 'Knox',
    county_names_all: 'Knox|Anderson',
    county_weights: '{"47093": 91.49, "47001": 8.51}',
    density: 433.4,
    imprecise: false,
    latitude: 35.97611,
    longitude: -84.12496,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37931',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 338.6,
    imprecise: false,
    latitude: 35.92273,
    longitude: -84.19562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37932',
  },
  {
    city: 'Farragut',
    county_fips: 47093,
    county_fips_all: '47093',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"47093": 100}',
    density: 626.4,
    imprecise: false,
    latitude: 35.87338,
    longitude: -84.17882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37934',
  },
  {
    city: 'Knoxville',
    county_fips: 47093,
    county_fips_all: '47093|47173|47001',
    county: 'Knox',
    county_names_all: 'Knox|Union|Anderson',
    county_weights: '{"47093": 99.02, "47173": 0.6, "47001": 0.38}',
    density: 208,
    imprecise: false,
    latitude: 36.12499,
    longitude: -83.93815,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37938',
  },
  {
    city: 'Alamo',
    county_fips: 47033,
    county_fips_all: '47033',
    county: 'Crockett',
    county_names_all: 'Crockett',
    county_weights: '{"47033": 100}',
    density: 23.8,
    imprecise: false,
    latitude: 35.81323,
    longitude: -89.15505,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38001',
  },
  {
    city: 'Arlington',
    county_fips: 47157,
    county_fips_all: '47157|47047',
    county: 'Shelby',
    county_names_all: 'Shelby|Fayette',
    county_weights: '{"47157": 87.26, "47047": 12.74}',
    density: 145.7,
    imprecise: false,
    latitude: 35.28854,
    longitude: -89.70926,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38002',
  },
  {
    city: 'Atoka',
    county_fips: 47167,
    county_fips_all: '47167|47157',
    county: 'Tipton',
    county_names_all: 'Tipton|Shelby',
    county_weights: '{"47167": 79.21, "47157": 20.79}',
    density: 169.4,
    imprecise: false,
    latitude: 35.41909,
    longitude: -89.76687,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38004',
  },
  {
    city: 'Bells',
    county_fips: 47075,
    county_fips_all: '47075|47033|47113',
    county: 'Haywood',
    county_names_all: 'Haywood|Crockett|Madison',
    county_weights: '{"47075": 48.49, "47033": 45.32, "47113": 6.18}',
    density: 20.2,
    imprecise: false,
    latitude: 35.69507,
    longitude: -89.09761,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38006',
  },
  {
    city: 'Bogota',
    county_fips: 47045,
    county_fips_all: '47045',
    county: 'Dyer',
    county_names_all: 'Dyer',
    county_weights: '{"47045": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.16422,
    longitude: -89.43925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38007',
  },
  {
    city: 'Bolivar',
    county_fips: 47069,
    county_fips_all: '47069',
    county: 'Hardeman',
    county_names_all: 'Hardeman',
    county_weights: '{"47069": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 35.24455,
    longitude: -88.99879,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38008',
  },
  {
    city: 'Brighton',
    county_fips: 47167,
    county_fips_all: '47167|47157',
    county: 'Tipton',
    county_names_all: 'Tipton|Shelby',
    county_weights: '{"47167": 96.84, "47157": 3.16}',
    density: 67.3,
    imprecise: false,
    latitude: 35.47266,
    longitude: -89.71415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38011',
  },
  {
    city: 'Brownsville',
    county_fips: 47075,
    county_fips_all: '47075',
    county: 'Haywood',
    county_names_all: 'Haywood',
    county_weights: '{"47075": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 35.60959,
    longitude: -89.27085,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38012',
  },
  {
    city: 'Burlison',
    county_fips: 47167,
    county_fips_all: '47167',
    county: 'Tipton',
    county_names_all: 'Tipton',
    county_weights: '{"47167": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 35.55948,
    longitude: -89.82436,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38015',
  },
  {
    city: 'Cordova',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 940.8,
    imprecise: false,
    latitude: 35.17956,
    longitude: -89.76046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38016',
  },
  {
    city: 'Collierville',
    county_fips: 47157,
    county_fips_all: '47157|47047',
    county: 'Shelby',
    county_names_all: 'Shelby|Fayette',
    county_weights: '{"47157": 56.54, "47047": 43.46}',
    density: 267.7,
    imprecise: false,
    latitude: 35.06722,
    longitude: -89.65347,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38017',
  },
  {
    city: 'Cordova',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 797.3,
    imprecise: false,
    latitude: 35.13781,
    longitude: -89.76647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38018',
  },
  {
    city: 'Covington',
    county_fips: 47167,
    county_fips_all: '47167',
    county: 'Tipton',
    county_names_all: 'Tipton',
    county_weights: '{"47167": 100}',
    density: 43.3,
    imprecise: false,
    latitude: 35.56114,
    longitude: -89.6304,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38019',
  },
  {
    city: 'Crockett Mills',
    county_fips: 47033,
    county_fips_all: '47033',
    county: 'Crockett',
    county_names_all: 'Crockett',
    county_weights: '{"47033": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.87042,
    longitude: -89.18411,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38021',
  },
  {
    city: 'Drummonds',
    county_fips: 47167,
    county_fips_all: '47167',
    county: 'Tipton',
    county_names_all: 'Tipton',
    county_weights: '{"47167": 100}',
    density: 29.1,
    imprecise: false,
    latitude: 35.47468,
    longitude: -89.95114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38023',
  },
  {
    city: 'Dyersburg',
    county_fips: 47045,
    county_fips_all: '47045',
    county: 'Dyer',
    county_names_all: 'Dyer',
    county_weights: '{"47045": 100}',
    density: 70.1,
    imprecise: false,
    latitude: 36.03743,
    longitude: -89.38511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38024',
  },
  {
    city: 'Eads',
    county_fips: 47047,
    county_fips_all: '47047|47157',
    county: 'Fayette',
    county_names_all: 'Fayette|Shelby',
    county_weights: '{"47047": 52.86, "47157": 47.14}',
    density: 52.2,
    imprecise: false,
    latitude: 35.18486,
    longitude: -89.63474,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38028',
  },
  {
    city: 'Ellendale',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.24205,
    longitude: -89.82351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38029',
  },
  {
    city: 'Finley',
    county_fips: 47045,
    county_fips_all: '47045',
    county: 'Dyer',
    county_names_all: 'Dyer',
    county_weights: '{"47045": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 35.99942,
    longitude: -89.59981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38030',
  },
  {
    city: 'Friendship',
    county_fips: 47033,
    county_fips_all: '47033|47045',
    county: 'Crockett',
    county_names_all: 'Crockett|Dyer',
    county_weights: '{"47033": 65.63, "47045": 34.37}',
    density: 12.1,
    imprecise: false,
    latitude: 35.91273,
    longitude: -89.236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38034',
  },
  {
    city: 'Gallaway',
    county_fips: 47047,
    county_fips_all: '47047',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"47047": 100}',
    density: 351.1,
    imprecise: false,
    latitude: 35.32715,
    longitude: -89.61941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38036',
  },
  {
    city: 'Gates',
    county_fips: 47075,
    county_fips_all: '47075|47097',
    county: 'Haywood',
    county_names_all: 'Haywood|Lauderdale',
    county_weights: '{"47075": 59.14, "47097": 40.86}',
    density: 14.6,
    imprecise: false,
    latitude: 35.79433,
    longitude: -89.39232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38037',
  },
  {
    city: 'Grand Junction',
    county_fips: 47069,
    county_fips_all: '47069|47047',
    county: 'Hardeman',
    county_names_all: 'Hardeman|Fayette',
    county_weights: '{"47069": 57.53, "47047": 42.47}',
    density: 7.5,
    imprecise: false,
    latitude: 35.0571,
    longitude: -89.18545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38039',
  },
  {
    city: 'Halls',
    county_fips: 47097,
    county_fips_all: '47097|47033|47045',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale|Crockett|Dyer',
    county_weights: '{"47097": 72.73, "47033": 18.74, "47045": 8.53}',
    density: 13,
    imprecise: false,
    latitude: 35.88185,
    longitude: -89.48065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38040',
  },
  {
    city: 'Henning',
    county_fips: 47097,
    county_fips_all: '47097',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale',
    county_weights: '{"47097": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 35.64397,
    longitude: -89.70204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38041',
  },
  {
    city: 'Hickory Valley',
    county_fips: 47069,
    county_fips_all: '47069|47047',
    county: 'Hardeman',
    county_names_all: 'Hardeman|Fayette',
    county_weights: '{"47069": 85.22, "47047": 14.78}',
    density: 3.5,
    imprecise: false,
    latitude: 35.15059,
    longitude: -89.13848,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38042',
  },
  {
    city: 'Hornsby',
    county_fips: 47069,
    county_fips_all: '47069|47109|47023',
    county: 'Hardeman',
    county_names_all: 'Hardeman|McNairy|Chester',
    county_weights: '{"47069": 81.2, "47109": 13.35, "47023": 5.45}',
    density: 7.2,
    imprecise: false,
    latitude: 35.20736,
    longitude: -88.80244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38044',
  },
  {
    city: 'La Grange',
    county_fips: 47047,
    county_fips_all: '47047',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"47047": 100}',
    density: 48.3,
    imprecise: false,
    latitude: 35.04598,
    longitude: -89.24408,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38046',
  },
  {
    city: 'Lenox',
    county_fips: 47045,
    county_fips_all: '47045',
    county: 'Dyer',
    county_names_all: 'Dyer',
    county_weights: '{"47045": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 36.06499,
    longitude: -89.55569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38047',
  },
  {
    city: 'Mason',
    county_fips: 47047,
    county_fips_all: '47047|47167',
    county: 'Fayette',
    county_names_all: 'Fayette|Tipton',
    county_weights: '{"47047": 62.52, "47167": 37.48}',
    density: 13.7,
    imprecise: false,
    latitude: 35.38689,
    longitude: -89.544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38049',
  },
  {
    city: 'Maury City',
    county_fips: 47033,
    county_fips_all: '47033',
    county: 'Crockett',
    county_names_all: 'Crockett',
    county_weights: '{"47033": 100}',
    density: 266.8,
    imprecise: false,
    latitude: 35.81635,
    longitude: -89.22712,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38050',
  },
  {
    city: 'Middleton',
    county_fips: 47069,
    county_fips_all: '47069',
    county: 'Hardeman',
    county_names_all: 'Hardeman',
    county_weights: '{"47069": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 35.08574,
    longitude: -88.91308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38052',
  },
  {
    city: 'Millington',
    county_fips: 47157,
    county_fips_all: '47157|47167',
    county: 'Shelby',
    county_names_all: 'Shelby|Tipton',
    county_weights: '{"47157": 92.6, "47167": 7.4}',
    density: 60.2,
    imprecise: false,
    latitude: 35.33583,
    longitude: -89.95,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38053',
  },
  {
    city: 'Millington',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 126.4,
    imprecise: false,
    latitude: 35.3358,
    longitude: -89.8744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38054',
  },
  {
    city: 'Moscow',
    county_fips: 47047,
    county_fips_all: '47047',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"47047": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 35.05381,
    longitude: -89.36772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38057',
  },
  {
    city: 'Munford',
    county_fips: 47167,
    county_fips_all: '47167',
    county: 'Tipton',
    county_names_all: 'Tipton',
    county_weights: '{"47167": 100}',
    density: 153.4,
    imprecise: false,
    latitude: 35.45861,
    longitude: -89.81933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38058',
  },
  {
    city: 'Newbern',
    county_fips: 47045,
    county_fips_all: '47045|47053',
    county: 'Dyer',
    county_names_all: 'Dyer|Gibson',
    county_weights: '{"47045": 86.62, "47053": 13.38}',
    density: 24.4,
    imprecise: false,
    latitude: 36.11132,
    longitude: -89.24113,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38059',
  },
  {
    city: 'Oakland',
    county_fips: 47047,
    county_fips_all: '47047',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"47047": 100}',
    density: 108,
    imprecise: false,
    latitude: 35.21214,
    longitude: -89.50468,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38060',
  },
  {
    city: 'Pocahontas',
    county_fips: 47109,
    county_fips_all: '47109|47069',
    county: 'McNairy',
    county_names_all: 'McNairy|Hardeman',
    county_weights: '{"47109": 71.68, "47069": 28.32}',
    density: 6.4,
    imprecise: false,
    latitude: 35.06704,
    longitude: -88.7647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38061',
  },
  {
    city: 'Ripley',
    county_fips: 47097,
    county_fips_all: '47097|47075',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale|Haywood',
    county_weights: '{"47097": 90.91, "47075": 9.09}',
    density: 21.6,
    imprecise: false,
    latitude: 35.74598,
    longitude: -89.63412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38063',
  },
  {
    city: 'Rossville',
    county_fips: 47047,
    county_fips_all: '47047',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"47047": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 35.07421,
    longitude: -89.53944,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38066',
  },
  {
    city: 'Saulsbury',
    county_fips: 47069,
    county_fips_all: '47069',
    county: 'Hardeman',
    county_names_all: 'Hardeman',
    county_weights: '{"47069": 100}',
    density: 12,
    imprecise: false,
    latitude: 35.08561,
    longitude: -89.04804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38067',
  },
  {
    city: 'Somerville',
    county_fips: 47047,
    county_fips_all: '47047',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"47047": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 35.25972,
    longitude: -89.3349,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38068',
  },
  {
    city: 'Stanton',
    county_fips: 47075,
    county_fips_all: '47075|47167|47047',
    county: 'Haywood',
    county_names_all: 'Haywood|Tipton|Fayette',
    county_weights: '{"47075": 84.29, "47167": 12.79, "47047": 2.92}',
    density: 8.3,
    imprecise: false,
    latitude: 35.46209,
    longitude: -89.37151,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38069',
  },
  {
    city: 'Tigrett',
    county_fips: 47045,
    county_fips_all: '47045',
    county: 'Dyer',
    county_names_all: 'Dyer',
    county_weights: '{"47045": 100}',
    density: 32.3,
    imprecise: false,
    latitude: 35.94045,
    longitude: -89.24915,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38070',
  },
  {
    city: 'Whiteville',
    county_fips: 47069,
    county_fips_all: '47069|47075|47047',
    county: 'Hardeman',
    county_names_all: 'Hardeman|Haywood|Fayette',
    county_weights: '{"47069": 58.96, "47075": 28.58, "47047": 12.46}',
    density: 18.5,
    imprecise: false,
    latitude: 35.37197,
    longitude: -89.15569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38075',
  },
  {
    city: 'Williston',
    county_fips: 47047,
    county_fips_all: '47047',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"47047": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 35.12301,
    longitude: -89.45633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38076',
  },
  {
    city: 'Wynnburg',
    county_fips: 47095,
    county_fips_all: '47095',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"47095": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.32852,
    longitude: -89.4744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38077',
  },
  {
    city: 'Tiptonville',
    county_fips: 47095,
    county_fips_all: '47095|21075',
    county: 'Lake',
    county_names_all: 'Lake|Fulton',
    county_weights: '{"47095": 87.04, "21075": 12.96}',
    density: 14.9,
    imprecise: false,
    latitude: 36.41378,
    longitude: -89.47032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38079',
  },
  {
    city: 'Ridgely',
    county_fips: 47095,
    county_fips_all: '47095|47045|47131',
    county: 'Lake',
    county_names_all: 'Lake|Dyer|Obion',
    county_weights: '{"47095": 52.4, "47045": 45.37, "47131": 2.23}',
    density: 6.9,
    imprecise: false,
    latitude: 36.20295,
    longitude: -89.52142,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38080',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 2115.1,
    imprecise: false,
    latitude: 35.15308,
    longitude: -90.05518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38103',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 1764.8,
    imprecise: false,
    latitude: 35.13253,
    longitude: -90.00435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38104',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 1264.1,
    imprecise: false,
    latitude: 35.1512,
    longitude: -90.03541,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38105',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 778.4,
    imprecise: false,
    latitude: 35.10067,
    longitude: -90.0375,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38106',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 985.8,
    imprecise: false,
    latitude: 35.17054,
    longitude: -90.02397,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38107',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 892.7,
    imprecise: false,
    latitude: 35.1763,
    longitude: -89.96382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38108',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 274.5,
    imprecise: false,
    latitude: 35.0341,
    longitude: -90.13533,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38109',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 1656.5,
    imprecise: false,
    latitude: 35.11014,
    longitude: -89.94429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38111',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 1350.5,
    imprecise: false,
    latitude: 35.14791,
    longitude: -89.97661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38112',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.10198,
    longitude: -90.13285,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38113',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 1031.6,
    imprecise: false,
    latitude: 35.09648,
    longitude: -89.98596,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38114',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 1731.5,
    imprecise: false,
    latitude: 35.05499,
    longitude: -89.86362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38115',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 787.7,
    imprecise: false,
    latitude: 35.03213,
    longitude: -90.01001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38116',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 1059.9,
    imprecise: false,
    latitude: 35.11504,
    longitude: -89.90551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38117',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 495.6,
    imprecise: false,
    latitude: 35.03655,
    longitude: -89.93021,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38118',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 1027.6,
    imprecise: false,
    latitude: 35.07986,
    longitude: -89.84593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38119',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 534.1,
    imprecise: false,
    latitude: 35.12344,
    longitude: -89.85237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38120',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 1473.8,
    imprecise: false,
    latitude: 35.1571,
    longitude: -89.92247,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38122',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 875.1,
    imprecise: false,
    latitude: 35.02537,
    longitude: -89.78936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38125',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 1235.7,
    imprecise: false,
    latitude: 35.12695,
    longitude: -90.04378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38126',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 404.3,
    imprecise: false,
    latitude: 35.23795,
    longitude: -90.01753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38127',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 688.7,
    imprecise: false,
    latitude: 35.22623,
    longitude: -89.92612,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38128',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.06603,
    longitude: -89.99266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38131',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 35.07069,
    longitude: -90.00033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38132',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 632.7,
    imprecise: false,
    latitude: 35.21292,
    longitude: -89.79474,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38133',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 913.5,
    imprecise: false,
    latitude: 35.17674,
    longitude: -89.85992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38134',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 908.3,
    imprecise: false,
    latitude: 35.23876,
    longitude: -89.8497,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38135',
  },
  {
    city: 'Germantown',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 819.5,
    imprecise: false,
    latitude: 35.08477,
    longitude: -89.7993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38138',
  },
  {
    city: 'Germantown',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 730.4,
    imprecise: false,
    latitude: 35.08615,
    longitude: -89.75581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38139',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 1184.3,
    imprecise: false,
    latitude: 35.01599,
    longitude: -89.85472,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38141',
  },
  {
    city: 'McKenzie',
    county_fips: 47017,
    county_fips_all: '47017|47183|47079',
    county: 'Carroll',
    county_names_all: 'Carroll|Weakley|Henry',
    county_weights: '{"47017": 59.17, "47183": 27.4, "47079": 13.43}',
    density: 29.1,
    imprecise: false,
    latitude: 36.12335,
    longitude: -88.53131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38201',
  },
  {
    city: 'Atwood',
    county_fips: 47017,
    county_fips_all: '47017|47053',
    county: 'Carroll',
    county_names_all: 'Carroll|Gibson',
    county_weights: '{"47017": 72.09, "47053": 27.91}',
    density: 17.3,
    imprecise: false,
    latitude: 35.98836,
    longitude: -88.673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38220',
  },
  {
    city: 'Big Sandy',
    county_fips: 47005,
    county_fips_all: '47005',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"47005": 100}',
    density: 11,
    imprecise: false,
    latitude: 36.24552,
    longitude: -88.03685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38221',
  },
  {
    city: 'Buchanan',
    county_fips: 47079,
    county_fips_all: '47079',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"47079": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 36.44512,
    longitude: -88.16288,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38222',
  },
  {
    city: 'Cottage Grove',
    county_fips: 47079,
    county_fips_all: '47079|47183',
    county: 'Henry',
    county_names_all: 'Henry|Weakley',
    county_weights: '{"47079": 88.07, "47183": 11.93}',
    density: 6.7,
    imprecise: false,
    latitude: 36.39172,
    longitude: -88.48774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38224',
  },
  {
    city: 'Dresden',
    county_fips: 47183,
    county_fips_all: '47183',
    county: 'Weakley',
    county_names_all: 'Weakley',
    county_weights: '{"47183": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 36.31764,
    longitude: -88.67937,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38225',
  },
  {
    city: 'Dukedom',
    county_fips: 47183,
    county_fips_all: '47183',
    county: 'Weakley',
    county_names_all: 'Weakley',
    county_weights: '{"47183": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 36.47722,
    longitude: -88.66382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38226',
  },
  {
    city: 'Gleason',
    county_fips: 47183,
    county_fips_all: '47183|47079',
    county: 'Weakley',
    county_names_all: 'Weakley|Henry',
    county_weights: '{"47183": 98.61, "47079": 1.39}',
    density: 15.1,
    imprecise: false,
    latitude: 36.22108,
    longitude: -88.60939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38229',
  },
  {
    city: 'Greenfield',
    county_fips: 47183,
    county_fips_all: '47183',
    county: 'Weakley',
    county_names_all: 'Weakley',
    county_weights: '{"47183": 100}',
    density: 17,
    imprecise: false,
    latitude: 36.15592,
    longitude: -88.77154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38230',
  },
  {
    city: 'Henry',
    county_fips: 47079,
    county_fips_all: '47079',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"47079": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 36.21277,
    longitude: -88.42442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38231',
  },
  {
    city: 'Hornbeak',
    county_fips: 47131,
    county_fips_all: '47131',
    county: 'Obion',
    county_names_all: 'Obion',
    county_weights: '{"47131": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 36.34828,
    longitude: -89.32295,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38232',
  },
  {
    city: 'Kenton',
    county_fips: 47053,
    county_fips_all: '47053|47131',
    county: 'Gibson',
    county_names_all: 'Gibson|Obion',
    county_weights: '{"47053": 51.34, "47131": 48.66}',
    density: 11.1,
    imprecise: false,
    latitude: 36.20411,
    longitude: -89.04622,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38233',
  },
  {
    city: 'McLemoresville',
    county_fips: 47017,
    county_fips_all: '47017',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"47017": 100}',
    density: 56,
    imprecise: false,
    latitude: 35.99116,
    longitude: -88.58109,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38235',
  },
  {
    city: 'Mansfield',
    county_fips: 47079,
    county_fips_all: '47079',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"47079": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 36.17572,
    longitude: -88.26463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38236',
  },
  {
    city: 'Martin',
    county_fips: 47183,
    county_fips_all: '47183|47131',
    county: 'Weakley',
    county_names_all: 'Weakley|Obion',
    county_weights: '{"47183": 96.53, "47131": 3.47}',
    density: 43.7,
    imprecise: false,
    latitude: 36.36406,
    longitude: -88.83162,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38237',
  },
  {
    city: 'Obion',
    county_fips: 47131,
    county_fips_all: '47131|47045',
    county: 'Obion',
    county_names_all: 'Obion|Dyer',
    county_weights: '{"47131": 89.42, "47045": 10.58}',
    density: 7.4,
    imprecise: false,
    latitude: 36.25091,
    longitude: -89.32045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38240',
  },
  {
    city: 'Palmersville',
    county_fips: 47183,
    county_fips_all: '47183',
    county: 'Weakley',
    county_names_all: 'Weakley',
    county_weights: '{"47183": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 36.42852,
    longitude: -88.58964,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38241',
  },
  {
    city: 'Paris',
    county_fips: 47079,
    county_fips_all: '47079|47183',
    county: 'Henry',
    county_names_all: 'Henry|Weakley',
    county_weights: '{"47079": 93.6, "47183": 6.4}',
    density: 42.5,
    imprecise: false,
    latitude: 36.3076,
    longitude: -88.33244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38242',
  },
  {
    city: 'Puryear',
    county_fips: 47079,
    county_fips_all: '47079',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"47079": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 36.44636,
    longitude: -88.3539,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38251',
  },
  {
    city: 'Rives',
    county_fips: 47131,
    county_fips_all: '47131',
    county: 'Obion',
    county_names_all: 'Obion',
    county_weights: '{"47131": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 36.29821,
    longitude: -89.05822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38253',
  },
  {
    city: 'Sharon',
    county_fips: 47183,
    county_fips_all: '47183|47131',
    county: 'Weakley',
    county_names_all: 'Weakley|Obion',
    county_weights: '{"47183": 97.37, "47131": 2.63}',
    density: 17.8,
    imprecise: false,
    latitude: 36.23954,
    longitude: -88.86483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38255',
  },
  {
    city: 'Springville',
    county_fips: 47079,
    county_fips_all: '47079',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"47079": 100}',
    density: 18.5,
    imprecise: false,
    latitude: 36.31388,
    longitude: -88.12539,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38256',
  },
  {
    city: 'South Fulton',
    county_fips: 47131,
    county_fips_all: '47131|47183',
    county: 'Obion',
    county_names_all: 'Obion|Weakley',
    county_weights: '{"47131": 85.93, "47183": 14.07}',
    density: 30.9,
    imprecise: false,
    latitude: 36.46386,
    longitude: -88.88397,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38257',
  },
  {
    city: 'Trezevant',
    county_fips: 47017,
    county_fips_all: '47017',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"47017": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 36.02094,
    longitude: -88.61188,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38258',
  },
  {
    city: 'Trimble',
    county_fips: 47131,
    county_fips_all: '47131|47045|47053',
    county: 'Obion',
    county_names_all: 'Obion|Dyer|Gibson',
    county_weights: '{"47131": 50.87, "47045": 36.75, "47053": 12.38}',
    density: 9.4,
    imprecise: false,
    latitude: 36.20204,
    longitude: -89.18439,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38259',
  },
  {
    city: 'Troy',
    county_fips: 47131,
    county_fips_all: '47131',
    county: 'Obion',
    county_names_all: 'Obion',
    county_weights: '{"47131": 100}',
    density: 20.1,
    imprecise: false,
    latitude: 36.36961,
    longitude: -89.21128,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38260',
  },
  {
    city: 'Union City',
    county_fips: 47131,
    county_fips_all: '47131|47183',
    county: 'Obion',
    county_names_all: 'Obion|Weakley',
    county_weights: '{"47131": 99.65, "47183": 0.35}',
    density: 35.8,
    imprecise: false,
    latitude: 36.43214,
    longitude: -89.11583,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38261',
  },
  {
    city: 'Jackson',
    county_fips: 47113,
    county_fips_all: '47113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"47113": 100}',
    density: 85.8,
    imprecise: false,
    latitude: 35.5908,
    longitude: -88.8531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38301',
  },
  {
    city: 'Jackson',
    county_fips: 47113,
    county_fips_all: '47113|47017',
    county: 'Madison',
    county_names_all: 'Madison|Carroll',
    county_weights: '{"47113": 97.34, "47017": 2.66}',
    density: 161.3,
    imprecise: false,
    latitude: 35.70108,
    longitude: -88.76779,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38305',
  },
  {
    city: 'Adamsville',
    county_fips: 47109,
    county_fips_all: '47109|47071',
    county: 'McNairy',
    county_names_all: 'McNairy|Hardin',
    county_weights: '{"47109": 68.79, "47071": 31.21}',
    density: 24.6,
    imprecise: false,
    latitude: 35.26175,
    longitude: -88.39832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38310',
  },
  {
    city: 'Bath Springs',
    county_fips: 47039,
    county_fips_all: '47039',
    county: 'Decatur',
    county_names_all: 'Decatur',
    county_weights: '{"47039": 100}',
    density: 5,
    imprecise: false,
    latitude: 35.43842,
    longitude: -88.09737,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38311',
  },
  {
    city: 'Beech Bluff',
    county_fips: 47113,
    county_fips_all: '47113|47077|47023',
    county: 'Madison',
    county_names_all: 'Madison|Henderson|Chester',
    county_weights: '{"47113": 55.62, "47077": 22.31, "47023": 22.07}',
    density: 16.8,
    imprecise: false,
    latitude: 35.60107,
    longitude: -88.62541,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38313',
  },
  {
    city: 'Bethel Springs',
    county_fips: 47109,
    county_fips_all: '47109|47023',
    county: 'McNairy',
    county_names_all: 'McNairy|Chester',
    county_weights: '{"47109": 90.97, "47023": 9.03}',
    density: 12.6,
    imprecise: false,
    latitude: 35.26918,
    longitude: -88.6241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38315',
  },
  {
    city: 'Bradford',
    county_fips: 47053,
    county_fips_all: '47053',
    county: 'Gibson',
    county_names_all: 'Gibson',
    county_weights: '{"47053": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 36.06873,
    longitude: -88.81547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38316',
  },
  {
    city: 'Bruceton',
    county_fips: 47017,
    county_fips_all: '47017|47005',
    county: 'Carroll',
    county_names_all: 'Carroll|Benton',
    county_weights: '{"47017": 93.91, "47005": 6.09}',
    density: 25.7,
    imprecise: false,
    latitude: 36.05425,
    longitude: -88.26965,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38317',
  },
  {
    city: 'Buena Vista',
    county_fips: 47017,
    county_fips_all: '47017',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"47017": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 35.95687,
    longitude: -88.26189,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38318',
  },
  {
    city: 'Camden',
    county_fips: 47005,
    county_fips_all: '47005',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"47005": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 36.04764,
    longitude: -88.1095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38320',
  },
  {
    city: 'Cedar Grove',
    county_fips: 47017,
    county_fips_all: '47017|47077',
    county: 'Carroll',
    county_names_all: 'Carroll|Henderson',
    county_weights: '{"47017": 57.92, "47077": 42.08}',
    density: 10.1,
    imprecise: false,
    latitude: 35.83341,
    longitude: -88.53013,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38321',
  },
  {
    city: 'Counce',
    county_fips: 47071,
    county_fips_all: '47071|28141',
    county: 'Hardin',
    county_names_all: 'Hardin|Tishomingo',
    county_weights: '{"47071": 98.7, "28141": 1.3}',
    density: 21.5,
    imprecise: false,
    latitude: 35.04419,
    longitude: -88.27514,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38326',
  },
  {
    city: 'Crump',
    county_fips: 47071,
    county_fips_all: '47071',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"47071": 100}',
    density: 107.5,
    imprecise: false,
    latitude: 35.22348,
    longitude: -88.30085,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38327',
  },
  {
    city: 'Darden',
    county_fips: 47077,
    county_fips_all: '47077|47039',
    county: 'Henderson',
    county_names_all: 'Henderson|Decatur',
    county_weights: '{"47077": 84.35, "47039": 15.65}',
    density: 11.1,
    imprecise: false,
    latitude: 35.67601,
    longitude: -88.21222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38328',
  },
  {
    city: 'Decaturville',
    county_fips: 47039,
    county_fips_all: '47039|47077',
    county: 'Decatur',
    county_names_all: 'Decatur|Henderson',
    county_weights: '{"47039": 94.68, "47077": 5.32}',
    density: 11.2,
    imprecise: false,
    latitude: 35.54541,
    longitude: -88.11283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38329',
  },
  {
    city: 'Dyer',
    county_fips: 47053,
    county_fips_all: '47053',
    county: 'Gibson',
    county_names_all: 'Gibson',
    county_weights: '{"47053": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 36.0675,
    longitude: -89.03316,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38330',
  },
  {
    city: 'Enville',
    county_fips: 47023,
    county_fips_all: '47023|47109',
    county: 'Chester',
    county_names_all: 'Chester|McNairy',
    county_weights: '{"47023": 86.91, "47109": 13.09}',
    density: 8.7,
    imprecise: false,
    latitude: 35.41978,
    longitude: -88.42934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38332',
  },
  {
    city: 'Eva',
    county_fips: 47005,
    county_fips_all: '47005',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"47005": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 36.12236,
    longitude: -87.9709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38333',
  },
  {
    city: 'Finger',
    county_fips: 47109,
    county_fips_all: '47109|47023',
    county: 'McNairy',
    county_names_all: 'McNairy|Chester',
    county_weights: '{"47109": 70.14, "47023": 29.86}',
    density: 16.2,
    imprecise: false,
    latitude: 35.35342,
    longitude: -88.58977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38334',
  },
  {
    city: 'Gadsden',
    county_fips: 47033,
    county_fips_all: '47033',
    county: 'Crockett',
    county_names_all: 'Crockett',
    county_weights: '{"47033": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 35.78515,
    longitude: -89.01149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38337',
  },
  {
    city: 'Gibson',
    county_fips: 47053,
    county_fips_all: '47053',
    county: 'Gibson',
    county_names_all: 'Gibson',
    county_weights: '{"47053": 100}',
    density: 206,
    imprecise: false,
    latitude: 35.87483,
    longitude: -88.84863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38338',
  },
  {
    city: 'Guys',
    county_fips: 47109,
    county_fips_all: '47109',
    county: 'McNairy',
    county_names_all: 'McNairy',
    county_weights: '{"47109": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 35.0524,
    longitude: -88.5147,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38339',
  },
  {
    city: 'Henderson',
    county_fips: 47023,
    county_fips_all: '47023|47069|47109',
    county: 'Chester',
    county_names_all: 'Chester|Hardeman|McNairy',
    county_weights: '{"47023": 87.74, "47069": 12.16, "47109": 0.1}',
    density: 28.2,
    imprecise: false,
    latitude: 35.40021,
    longitude: -88.68226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38340',
  },
  {
    city: 'Holladay',
    county_fips: 47005,
    county_fips_all: '47005|47039|47017',
    county: 'Benton',
    county_names_all: 'Benton|Decatur|Carroll',
    county_weights: '{"47005": 77.08, "47039": 20.89, "47017": 2.03}',
    density: 7.4,
    imprecise: false,
    latitude: 35.87677,
    longitude: -88.08888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38341',
  },
  {
    city: 'Hollow Rock',
    county_fips: 47017,
    county_fips_all: '47017',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"47017": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 36.10766,
    longitude: -88.29024,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38342',
  },
  {
    city: 'Humboldt',
    county_fips: 47053,
    county_fips_all: '47053|47033|47113',
    county: 'Gibson',
    county_names_all: 'Gibson|Crockett|Madison',
    county_weights: '{"47053": 60.98, "47033": 21.32, "47113": 17.7}',
    density: 43.1,
    imprecise: false,
    latitude: 35.82727,
    longitude: -88.92819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38343',
  },
  {
    city: 'Huntingdon',
    county_fips: 47017,
    county_fips_all: '47017',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"47017": 100}',
    density: 20.7,
    imprecise: false,
    latitude: 35.97716,
    longitude: -88.43066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38344',
  },
  {
    city: 'Huron',
    county_fips: 47077,
    county_fips_all: '47077',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"47077": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 35.59109,
    longitude: -88.51163,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38345',
  },
  {
    city: 'Jacks Creek',
    county_fips: 47023,
    county_fips_all: '47023|47077',
    county: 'Chester',
    county_names_all: 'Chester|Henderson',
    county_weights: '{"47023": 99.88, "47077": 0.12}',
    density: 22.6,
    imprecise: false,
    latitude: 35.47632,
    longitude: -88.49846,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38347',
  },
  {
    city: 'Lavinia',
    county_fips: 47017,
    county_fips_all: '47017|47113',
    county: 'Carroll',
    county_names_all: 'Carroll|Madison',
    county_weights: '{"47017": 98.66, "47113": 1.34}',
    density: 7,
    imprecise: false,
    latitude: 35.86893,
    longitude: -88.65198,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38348',
  },
  {
    city: 'Lexington',
    county_fips: 47077,
    county_fips_all: '47077|47113',
    county: 'Henderson',
    county_names_all: 'Henderson|Madison',
    county_weights: '{"47077": 99.43, "47113": 0.57}',
    density: 33.9,
    imprecise: false,
    latitude: 35.66324,
    longitude: -88.40401,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38351',
  },
  {
    city: 'Luray',
    county_fips: 47023,
    county_fips_all: '47023|47077',
    county: 'Chester',
    county_names_all: 'Chester|Henderson',
    county_weights: '{"47023": 67.73, "47077": 32.27}',
    density: 15.4,
    imprecise: false,
    latitude: 35.53037,
    longitude: -88.53308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38352',
  },
  {
    city: 'Medina',
    county_fips: 47113,
    county_fips_all: '47113|47053',
    county: 'Madison',
    county_names_all: 'Madison|Gibson',
    county_weights: '{"47113": 63.18, "47053": 36.82}',
    density: 86.3,
    imprecise: false,
    latitude: 35.78637,
    longitude: -88.76942,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38355',
  },
  {
    city: 'Medon',
    county_fips: 47113,
    county_fips_all: '47113|47069|47023',
    county: 'Madison',
    county_names_all: 'Madison|Hardeman|Chester',
    county_weights: '{"47113": 57.9, "47069": 35.58, "47023": 6.52}',
    density: 11.8,
    imprecise: false,
    latitude: 35.43877,
    longitude: -88.89029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38356',
  },
  {
    city: 'Michie',
    county_fips: 47109,
    county_fips_all: '47109|47071',
    county: 'McNairy',
    county_names_all: 'McNairy|Hardin',
    county_weights: '{"47109": 75.18, "47071": 24.82}',
    density: 20.7,
    imprecise: false,
    latitude: 35.04888,
    longitude: -88.4112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38357',
  },
  {
    city: 'Milan',
    county_fips: 47053,
    county_fips_all: '47053',
    county: 'Gibson',
    county_names_all: 'Gibson',
    county_weights: '{"47053": 100}',
    density: 60.1,
    imprecise: false,
    latitude: 35.91661,
    longitude: -88.75934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38358',
  },
  {
    city: 'Milledgeville',
    county_fips: 47071,
    county_fips_all: '47071|47109|47023',
    county: 'Hardin',
    county_names_all: 'Hardin|McNairy|Chester',
    county_weights: '{"47071": 81.75, "47109": 14.58, "47023": 3.67}',
    density: 19.5,
    imprecise: false,
    latitude: 35.37222,
    longitude: -88.35109,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38359',
  },
  {
    city: 'Morris Chapel',
    county_fips: 47071,
    county_fips_all: '47071|47109',
    county: 'Hardin',
    county_names_all: 'Hardin|McNairy',
    county_weights: '{"47071": 91.92, "47109": 8.08}',
    density: 9.4,
    imprecise: false,
    latitude: 35.31897,
    longitude: -88.29232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38361',
  },
  {
    city: 'Oakfield',
    county_fips: 47113,
    county_fips_all: '47113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"47113": 100}',
    density: 45.2,
    imprecise: false,
    latitude: 35.72696,
    longitude: -88.78508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38362',
  },
  {
    city: 'Parsons',
    county_fips: 47039,
    county_fips_all: '47039|47077',
    county: 'Decatur',
    county_names_all: 'Decatur|Henderson',
    county_weights: '{"47039": 96.09, "47077": 3.91}',
    density: 26,
    imprecise: false,
    latitude: 35.68625,
    longitude: -88.11051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38363',
  },
  {
    city: 'Pickwick Dam',
    county_fips: 47071,
    county_fips_all: '47071',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"47071": 100}',
    density: 49.1,
    imprecise: false,
    latitude: 35.05383,
    longitude: -88.23627,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38365',
  },
  {
    city: 'Pinson',
    county_fips: 47113,
    county_fips_all: '47113|47023',
    county: 'Madison',
    county_names_all: 'Madison|Chester',
    county_weights: '{"47113": 72.93, "47023": 27.07}',
    density: 19,
    imprecise: false,
    latitude: 35.47797,
    longitude: -88.74461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38366',
  },
  {
    city: 'Ramer',
    county_fips: 47109,
    county_fips_all: '47109',
    county: 'McNairy',
    county_names_all: 'McNairy',
    county_weights: '{"47109": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 35.05266,
    longitude: -88.62728,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38367',
  },
  {
    city: 'Reagan',
    county_fips: 47077,
    county_fips_all: '47077|47023',
    county: 'Henderson',
    county_names_all: 'Henderson|Chester',
    county_weights: '{"47077": 82.7, "47023": 17.3}',
    density: 19.3,
    imprecise: false,
    latitude: 35.50191,
    longitude: -88.35659,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38368',
  },
  {
    city: 'Rutherford',
    county_fips: 47053,
    county_fips_all: '47053',
    county: 'Gibson',
    county_names_all: 'Gibson',
    county_weights: '{"47053": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 36.13253,
    longitude: -88.9652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38369',
  },
  {
    city: 'Saltillo',
    county_fips: 47071,
    county_fips_all: '47071|47077|47039',
    county: 'Hardin',
    county_names_all: 'Hardin|Henderson|Decatur',
    county_weights: '{"47071": 88.4, "47077": 11.5, "47039": 0.1}',
    density: 19.2,
    imprecise: false,
    latitude: 35.38942,
    longitude: -88.2465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38370',
  },
  {
    city: 'Sardis',
    county_fips: 47077,
    county_fips_all: '47077|47071|47039',
    county: 'Henderson',
    county_names_all: 'Henderson|Hardin|Decatur',
    county_weights: '{"47077": 53.38, "47071": 42.52, "47039": 4.1}',
    density: 9.9,
    imprecise: false,
    latitude: 35.42346,
    longitude: -88.2967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38371',
  },
  {
    city: 'Savannah',
    county_fips: 47071,
    county_fips_all: '47071',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"47071": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 35.16516,
    longitude: -88.14523,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38372',
  },
  {
    city: 'Scotts Hill',
    county_fips: 47039,
    county_fips_all: '47039|47077',
    county: 'Decatur',
    county_names_all: 'Decatur|Henderson',
    county_weights: '{"47039": 51.41, "47077": 48.59}',
    density: 15.6,
    imprecise: false,
    latitude: 35.51192,
    longitude: -88.23469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38374',
  },
  {
    city: 'Selmer',
    county_fips: 47109,
    county_fips_all: '47109',
    county: 'McNairy',
    county_names_all: 'McNairy',
    county_weights: '{"47109": 100}',
    density: 29,
    imprecise: false,
    latitude: 35.16142,
    longitude: -88.58811,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38375',
  },
  {
    city: 'Shiloh',
    county_fips: 47071,
    county_fips_all: '47071|47109',
    county: 'Hardin',
    county_names_all: 'Hardin|McNairy',
    county_weights: '{"47071": 96.07, "47109": 3.93}',
    density: 8.3,
    imprecise: false,
    latitude: 35.12974,
    longitude: -88.34447,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38376',
  },
  {
    city: 'Stantonville',
    county_fips: 47109,
    county_fips_all: '47109|47071',
    county: 'McNairy',
    county_names_all: 'McNairy|Hardin',
    county_weights: '{"47109": 90.42, "47071": 9.58}',
    density: 18.2,
    imprecise: false,
    latitude: 35.16388,
    longitude: -88.42825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38379',
  },
  {
    city: 'Sugar Tree',
    county_fips: 47039,
    county_fips_all: '47039|47005',
    county: 'Decatur',
    county_names_all: 'Decatur|Benton',
    county_weights: '{"47039": 87.66, "47005": 12.34}',
    density: 5.3,
    imprecise: false,
    latitude: 35.79114,
    longitude: -88.03263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38380',
  },
  {
    city: 'Toone',
    county_fips: 47069,
    county_fips_all: '47069',
    county: 'Hardeman',
    county_names_all: 'Hardeman',
    county_weights: '{"47069": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 35.35144,
    longitude: -88.96205,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38381',
  },
  {
    city: 'Trenton',
    county_fips: 47053,
    county_fips_all: '47053',
    county: 'Gibson',
    county_names_all: 'Gibson',
    county_weights: '{"47053": 100}',
    density: 19,
    imprecise: false,
    latitude: 35.96925,
    longitude: -88.99186,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38382',
  },
  {
    city: 'Westport',
    county_fips: 47017,
    county_fips_all: '47017|47005',
    county: 'Carroll',
    county_names_all: 'Carroll|Benton',
    county_weights: '{"47017": 89.25, "47005": 10.75}',
    density: 3.7,
    imprecise: false,
    latitude: 35.86573,
    longitude: -88.26968,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38387',
  },
  {
    city: 'Wildersville',
    county_fips: 47077,
    county_fips_all: '47077|47039',
    county: 'Henderson',
    county_names_all: 'Henderson|Decatur',
    county_weights: '{"47077": 99.34, "47039": 0.66}',
    density: 8.8,
    imprecise: false,
    latitude: 35.77672,
    longitude: -88.31535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38388',
  },
  {
    city: 'Yorkville',
    county_fips: 47053,
    county_fips_all: '47053',
    county: 'Gibson',
    county_names_all: 'Gibson',
    county_weights: '{"47053": 100}',
    density: 270.7,
    imprecise: false,
    latitude: 36.10315,
    longitude: -89.12134,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38389',
  },
  {
    city: 'Yuma',
    county_fips: 47017,
    county_fips_all: '47017|47077',
    county: 'Carroll',
    county_names_all: 'Carroll|Henderson',
    county_weights: '{"47017": 80.74, "47077": 19.26}',
    density: 14.8,
    imprecise: false,
    latitude: 35.83845,
    longitude: -88.37797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38390',
  },
  {
    city: 'Denmark',
    county_fips: 47113,
    county_fips_all: '47113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"47113": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 35.55026,
    longitude: -88.99033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38391',
  },
  {
    city: 'Mercer',
    county_fips: 47113,
    county_fips_all: '47113|47069',
    county: 'Madison',
    county_names_all: 'Madison|Hardeman',
    county_weights: '{"47113": 74.47, "47069": 25.53}',
    density: 8.2,
    imprecise: false,
    latitude: 35.45908,
    longitude: -89.03709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38392',
  },
  {
    city: 'Columbia',
    county_fips: 47119,
    county_fips_all: '47119|47187|47117',
    county: 'Maury',
    county_names_all: 'Maury|Williamson|Marshall',
    county_weights: '{"47119": 96.07, "47187": 2.1, "47117": 1.83}',
    density: 87.8,
    imprecise: false,
    latitude: 35.62955,
    longitude: -87.02097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 67482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38401',
  },
  {
    city: 'Clifton',
    county_fips: 47181,
    county_fips_all: '47181|47071|47135',
    county: 'Wayne',
    county_names_all: 'Wayne|Hardin|Perry',
    county_weights: '{"47181": 58.82, "47071": 26.49, "47135": 14.69}',
    density: 13.1,
    imprecise: false,
    latitude: 35.40706,
    longitude: -87.96588,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38425',
  },
  {
    city: 'Ardmore',
    county_fips: 47103,
    county_fips_all: '47103|47055',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Giles',
    county_weights: '{"47103": 52.62, "47055": 47.38}',
    density: 19.2,
    imprecise: false,
    latitude: 35.05231,
    longitude: -86.82954,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38449',
  },
  {
    city: 'Collinwood',
    county_fips: 47181,
    county_fips_all: '47181',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"47181": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 35.18523,
    longitude: -87.80143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38450',
  },
  {
    city: 'Culleoka',
    county_fips: 47119,
    county_fips_all: '47119|47117|47055',
    county: 'Maury',
    county_names_all: 'Maury|Marshall|Giles',
    county_weights: '{"47119": 81.07, "47117": 16.84, "47055": 2.09}',
    density: 19,
    imprecise: false,
    latitude: 35.46706,
    longitude: -86.99573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38451',
  },
  {
    city: 'Cypress Inn',
    county_fips: 47181,
    county_fips_all: '47181',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"47181": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 35.07898,
    longitude: -87.79239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38452',
  },
  {
    city: 'Dellrose',
    county_fips: 47103,
    county_fips_all: '47103|47055',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Giles',
    county_weights: '{"47103": 75.76, "47055": 24.24}',
    density: 11.7,
    imprecise: false,
    latitude: 35.11923,
    longitude: -86.81472,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38453',
  },
  {
    city: 'Duck River',
    county_fips: 47081,
    county_fips_all: '47081',
    county: 'Hickman',
    county_names_all: 'Hickman',
    county_weights: '{"47081": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 35.72334,
    longitude: -87.35538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38454',
  },
  {
    city: 'Elkton',
    county_fips: 47055,
    county_fips_all: '47055',
    county: 'Giles',
    county_names_all: 'Giles',
    county_weights: '{"47055": 100}',
    density: 163.1,
    imprecise: false,
    latitude: 35.06199,
    longitude: -86.89366,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38455',
  },
  {
    city: 'Ethridge',
    county_fips: 47099,
    county_fips_all: '47099|47055',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Giles',
    county_weights: '{"47099": 70.64, "47055": 29.36}',
    density: 25.4,
    imprecise: false,
    latitude: 35.33464,
    longitude: -87.26559,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38456',
  },
  {
    city: 'Five Points',
    county_fips: 47099,
    county_fips_all: '47099',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"47099": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 35.0297,
    longitude: -87.28482,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38457',
  },
  {
    city: 'Frankewing',
    county_fips: 47103,
    county_fips_all: '47103|47055',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Giles',
    county_weights: '{"47103": 89.1, "47055": 10.9}',
    density: 10,
    imprecise: false,
    latitude: 35.19135,
    longitude: -86.80219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38459',
  },
  {
    city: 'Goodspring',
    county_fips: 47055,
    county_fips_all: '47055',
    county: 'Giles',
    county_names_all: 'Giles',
    county_weights: '{"47055": 100}',
    density: 25,
    imprecise: false,
    latitude: 35.10116,
    longitude: -87.15937,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38460',
  },
  {
    city: 'Hampshire',
    county_fips: 47101,
    county_fips_all: '47101|47119|47081',
    county: 'Lewis',
    county_names_all: 'Lewis|Maury|Hickman',
    county_weights: '{"47101": 56.86, "47119": 41.48, "47081": 1.66}',
    density: 7.7,
    imprecise: false,
    latitude: 35.59514,
    longitude: -87.33987,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38461',
  },
  {
    city: 'Hohenwald',
    county_fips: 47101,
    county_fips_all: '47101|47081',
    county: 'Lewis',
    county_names_all: 'Lewis|Hickman',
    county_weights: '{"47101": 98.32, "47081": 1.68}',
    density: 20,
    imprecise: false,
    latitude: 35.53142,
    longitude: -87.54869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38462',
  },
  {
    city: 'Iron City',
    county_fips: 47181,
    county_fips_all: '47181|47099',
    county: 'Wayne',
    county_names_all: 'Wayne|Lawrence',
    county_weights: '{"47181": 77.16, "47099": 22.84}',
    density: 8.9,
    imprecise: false,
    latitude: 35.06802,
    longitude: -87.64494,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38463',
  },
  {
    city: 'Lawrenceburg',
    county_fips: 47099,
    county_fips_all: '47099|47181|47055|47101',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Wayne|Giles|Lewis',
    county_weights:
      '{"47099": 81.24, "47181": 12.1, "47055": 6.28, "47101": 0.38}',
    density: 33.6,
    imprecise: false,
    latitude: 35.29035,
    longitude: -87.42845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38464',
  },
  {
    city: 'Leoma',
    county_fips: 47099,
    county_fips_all: '47099|47055',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Giles',
    county_weights: '{"47099": 92.26, "47055": 7.74}',
    density: 21.5,
    imprecise: false,
    latitude: 35.13083,
    longitude: -87.29072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38468',
  },
  {
    city: 'Loretto',
    county_fips: 47099,
    county_fips_all: '47099',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"47099": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 35.0741,
    longitude: -87.42765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38469',
  },
  {
    city: 'Lutts',
    county_fips: 47181,
    county_fips_all: '47181',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"47181": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 35.0771,
    longitude: -87.92134,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38471',
  },
  {
    city: 'Lynnville',
    county_fips: 47055,
    county_fips_all: '47055|47117',
    county: 'Giles',
    county_names_all: 'Giles|Marshall',
    county_weights: '{"47055": 96.36, "47117": 3.64}',
    density: 9.5,
    imprecise: false,
    latitude: 35.3773,
    longitude: -87.03873,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38472',
  },
  {
    city: 'Minor Hill',
    county_fips: 47055,
    county_fips_all: '47055|47099',
    county: 'Giles',
    county_names_all: 'Giles|Lawrence',
    county_weights: '{"47055": 98.29, "47099": 1.71}',
    density: 15.7,
    imprecise: false,
    latitude: 35.02775,
    longitude: -87.17057,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38473',
  },
  {
    city: 'Mount Pleasant',
    county_fips: 47119,
    county_fips_all: '47119|47101|47055|47099',
    county: 'Maury',
    county_names_all: 'Maury|Lewis|Giles|Lawrence',
    county_weights:
      '{"47119": 86.84, "47101": 9.3, "47055": 2.22, "47099": 1.64}',
    density: 33.9,
    imprecise: false,
    latitude: 35.51848,
    longitude: -87.22966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38474',
  },
  {
    city: 'Olivehill',
    county_fips: 47071,
    county_fips_all: '47071|47181',
    county: 'Hardin',
    county_names_all: 'Hardin|Wayne',
    county_weights: '{"47071": 77.52, "47181": 22.48}',
    density: 5.3,
    imprecise: false,
    latitude: 35.2624,
    longitude: -88.02336,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38475',
  },
  {
    city: 'Primm Springs',
    county_fips: 47187,
    county_fips_all: '47187|47081|47119',
    county: 'Williamson',
    county_names_all: 'Williamson|Hickman|Maury',
    county_weights: '{"47187": 42.39, "47081": 40.42, "47119": 17.19}',
    density: 11.6,
    imprecise: false,
    latitude: 35.84341,
    longitude: -87.20984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38476',
  },
  {
    city: 'Prospect',
    county_fips: 47055,
    county_fips_all: '47055',
    county: 'Giles',
    county_names_all: 'Giles',
    county_weights: '{"47055": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 35.05075,
    longitude: -87.00932,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38477',
  },
  {
    city: 'Pulaski',
    county_fips: 47055,
    county_fips_all: '47055',
    county: 'Giles',
    county_names_all: 'Giles',
    county_weights: '{"47055": 100}',
    density: 28.5,
    imprecise: false,
    latitude: 35.21565,
    longitude: -87.01329,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38478',
  },
  {
    city: 'Saint Joseph',
    county_fips: 47099,
    county_fips_all: '47099',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"47099": 100}',
    density: 32.7,
    imprecise: false,
    latitude: 35.02813,
    longitude: -87.48863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38481',
  },
  {
    city: 'Santa Fe',
    county_fips: 47119,
    county_fips_all: '47119',
    county: 'Maury',
    county_names_all: 'Maury',
    county_weights: '{"47119": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 35.76792,
    longitude: -87.14574,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38482',
  },
  {
    city: 'Summertown',
    county_fips: 47099,
    county_fips_all: '47099|47101|47055|47119',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Lewis|Giles|Maury',
    county_weights:
      '{"47099": 56.77, "47101": 35.42, "47055": 7.17, "47119": 0.64}',
    density: 29,
    imprecise: false,
    latitude: 35.43411,
    longitude: -87.33476,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38483',
  },
  {
    city: 'Waynesboro',
    county_fips: 47181,
    county_fips_all: '47181|47101',
    county: 'Wayne',
    county_names_all: 'Wayne|Lewis',
    county_weights: '{"47181": 99.02, "47101": 0.98}',
    density: 8.4,
    imprecise: false,
    latitude: 35.33281,
    longitude: -87.77659,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38485',
  },
  {
    city: 'Westpoint',
    county_fips: 47099,
    county_fips_all: '47099|47181',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Wayne',
    county_weights: '{"47099": 79.6, "47181": 20.4}',
    density: 6.2,
    imprecise: false,
    latitude: 35.17306,
    longitude: -87.54029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38486',
  },
  {
    city: 'Williamsport',
    county_fips: 47119,
    county_fips_all: '47119|47081',
    county: 'Maury',
    county_names_all: 'Maury|Hickman',
    county_weights: '{"47119": 64.97, "47081": 35.03}',
    density: 5.7,
    imprecise: false,
    latitude: 35.72163,
    longitude: -87.23589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38487',
  },
  {
    city: 'Taft',
    county_fips: 47103,
    county_fips_all: '47103',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"47103": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 35.03906,
    longitude: -86.68569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38488',
  },
  {
    city: 'Cookeville',
    county_fips: 47141,
    county_fips_all: '47141|47087|47133',
    county: 'Putnam',
    county_names_all: 'Putnam|Jackson|Overton',
    county_weights: '{"47141": 63.55, "47087": 35.09, "47133": 1.36}',
    density: 188.3,
    imprecise: false,
    latitude: 36.22682,
    longitude: -85.53841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38501',
  },
  {
    city: 'Cookeville',
    county_fips: 47141,
    county_fips_all: '47141',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"47141": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.16333,
    longitude: -85.50588,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38503',
  },
  {
    city: 'Allardt',
    county_fips: 47049,
    county_fips_all: '47049|47151',
    county: 'Fentress',
    county_names_all: 'Fentress|Scott',
    county_weights: '{"47049": 84.27, "47151": 15.73}',
    density: 5.9,
    imprecise: false,
    latitude: 36.39314,
    longitude: -84.73528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38504',
  },
  {
    city: 'Cookeville',
    county_fips: 47141,
    county_fips_all: '47141|47133|47185|47087',
    county: 'Putnam',
    county_names_all: 'Putnam|Overton|White|Jackson',
    county_weights:
      '{"47141": 70.21, "47133": 25.31, "47185": 4.02, "47087": 0.46}',
    density: 70.7,
    imprecise: false,
    latitude: 36.18334,
    longitude: -85.44246,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38506',
  },
  {
    city: 'Allons',
    county_fips: 47027,
    county_fips_all: '47027|47133',
    county: 'Clay',
    county_names_all: 'Clay|Overton',
    county_weights: '{"47027": 57.11, "47133": 42.89}',
    density: 11.9,
    imprecise: false,
    latitude: 36.52903,
    longitude: -85.33767,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38541',
  },
  {
    city: 'Allred',
    county_fips: 47133,
    county_fips_all: '47133',
    county: 'Overton',
    county_names_all: 'Overton',
    county_weights: '{"47133": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.31576,
    longitude: -85.20113,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38542',
  },
  {
    city: 'Alpine',
    county_fips: 47133,
    county_fips_all: '47133|47137',
    county: 'Overton',
    county_names_all: 'Overton|Pickett',
    county_weights: '{"47133": 88.08, "47137": 11.92}',
    density: 3.1,
    imprecise: false,
    latitude: 36.37514,
    longitude: -85.15931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38543',
  },
  {
    city: 'Baxter',
    county_fips: 47141,
    county_fips_all: '47141|47041',
    county: 'Putnam',
    county_names_all: 'Putnam|DeKalb',
    county_weights: '{"47141": 87.98, "47041": 12.02}',
    density: 39.8,
    imprecise: false,
    latitude: 36.11605,
    longitude: -85.66238,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38544',
  },
  {
    city: 'Bloomington Springs',
    county_fips: 47087,
    county_fips_all: '47087|47141',
    county: 'Jackson',
    county_names_all: 'Jackson|Putnam',
    county_weights: '{"47087": 67.2, "47141": 32.8}',
    density: 26.4,
    imprecise: false,
    latitude: 36.23133,
    longitude: -85.65964,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38545',
  },
  {
    city: 'Brush Creek',
    county_fips: 47159,
    county_fips_all: '47159',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"47159": 100}',
    density: 26,
    imprecise: false,
    latitude: 36.14954,
    longitude: -86.00833,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38547',
  },
  {
    city: 'Buffalo Valley',
    county_fips: 47141,
    county_fips_all: '47141|47159|47041',
    county: 'Putnam',
    county_names_all: 'Putnam|Smith|DeKalb',
    county_weights: '{"47141": 64.02, "47159": 33.12, "47041": 2.86}',
    density: 15.7,
    imprecise: false,
    latitude: 36.17252,
    longitude: -85.79197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38548',
  },
  {
    city: 'Byrdstown',
    county_fips: 47137,
    county_fips_all: '47137|47049|21053',
    county: 'Pickett',
    county_names_all: 'Pickett|Fentress|Clinton',
    county_weights: '{"47137": 93.7, "47049": 4.45, "21053": 1.85}',
    density: 21.7,
    imprecise: false,
    latitude: 36.5617,
    longitude: -85.15243,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38549',
  },
  {
    city: 'Campaign',
    county_fips: 47177,
    county_fips_all: '47177',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"47177": 100}',
    density: 2185.1,
    imprecise: false,
    latitude: 35.76982,
    longitude: -85.63268,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38550',
  },
  {
    city: 'Celina',
    county_fips: 47027,
    county_fips_all: '47027|47087',
    county: 'Clay',
    county_names_all: 'Clay|Jackson',
    county_weights: '{"47027": 97.82, "47087": 2.18}',
    density: 19.3,
    imprecise: false,
    latitude: 36.55804,
    longitude: -85.48699,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38551',
  },
  {
    city: 'Chestnut Mound',
    county_fips: 47159,
    county_fips_all: '47159',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"47159": 100}',
    density: 25,
    imprecise: false,
    latitude: 36.2166,
    longitude: -85.81195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38552',
  },
  {
    city: 'Clarkrange',
    county_fips: 47049,
    county_fips_all: '47049',
    county: 'Fentress',
    county_names_all: 'Fentress',
    county_weights: '{"47049": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 36.20322,
    longitude: -85.00442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38553',
  },
  {
    city: 'Crawford',
    county_fips: 47133,
    county_fips_all: '47133',
    county: 'Overton',
    county_names_all: 'Overton',
    county_weights: '{"47133": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 36.25131,
    longitude: -85.16095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38554',
  },
  {
    city: 'Crossville',
    county_fips: 47035,
    county_fips_all: '47035',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"47035": 100}',
    density: 90.3,
    imprecise: false,
    latitude: 35.88956,
    longitude: -84.97537,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38555',
  },
  {
    city: 'Jamestown',
    county_fips: 47049,
    county_fips_all: '47049|47137',
    county: 'Fentress',
    county_names_all: 'Fentress|Pickett',
    county_weights: '{"47049": 99.36, "47137": 0.64}',
    density: 15.8,
    imprecise: false,
    latitude: 36.41016,
    longitude: -84.9249,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38556',
  },
  {
    city: 'Crossville',
    county_fips: 47035,
    county_fips_all: '47035',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"47035": 100}',
    density: 181.4,
    imprecise: false,
    latitude: 36.00532,
    longitude: -84.87374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38558',
  },
  {
    city: 'Doyle',
    county_fips: 47175,
    county_fips_all: '47175|47185',
    county: 'Van Buren',
    county_names_all: 'Van Buren|White',
    county_weights: '{"47175": 69.55, "47185": 30.45}',
    density: 29.7,
    imprecise: false,
    latitude: 35.80692,
    longitude: -85.51334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38559',
  },
  {
    city: 'Elmwood',
    county_fips: 47159,
    county_fips_all: '47159',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"47159": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 36.23458,
    longitude: -85.8713,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38560',
  },
  {
    city: 'Gainesboro',
    county_fips: 47087,
    county_fips_all: '47087',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"47087": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 36.35173,
    longitude: -85.65932,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38562',
  },
  {
    city: 'Gordonsville',
    county_fips: 47159,
    county_fips_all: '47159',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"47159": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 36.19658,
    longitude: -86.0147,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38563',
  },
  {
    city: 'Granville',
    county_fips: 47087,
    county_fips_all: '47087|47141',
    county: 'Jackson',
    county_names_all: 'Jackson|Putnam',
    county_weights: '{"47087": 90.73, "47141": 9.27}',
    density: 6.7,
    imprecise: false,
    latitude: 36.27144,
    longitude: -85.75364,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38564',
  },
  {
    city: 'Grimsley',
    county_fips: 47049,
    county_fips_all: '47049',
    county: 'Fentress',
    county_names_all: 'Fentress',
    county_weights: '{"47049": 100}',
    density: 44.9,
    imprecise: false,
    latitude: 36.26296,
    longitude: -85.00992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38565',
  },
  {
    city: 'Hickman',
    county_fips: 47159,
    county_fips_all: '47159|47041',
    county: 'Smith',
    county_names_all: 'Smith|DeKalb',
    county_weights: '{"47159": 87.58, "47041": 12.42}',
    density: 19.9,
    imprecise: false,
    latitude: 36.13392,
    longitude: -85.91518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38567',
  },
  {
    city: 'Hilham',
    county_fips: 47133,
    county_fips_all: '47133|47027|47087',
    county: 'Overton',
    county_names_all: 'Overton|Clay|Jackson',
    county_weights: '{"47133": 53.13, "47027": 37.16, "47087": 9.71}',
    density: 12.8,
    imprecise: false,
    latitude: 36.43594,
    longitude: -85.46907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38568',
  },
  {
    city: 'Lancaster',
    county_fips: 47159,
    county_fips_all: '47159|47041',
    county: 'Smith',
    county_names_all: 'Smith|DeKalb',
    county_weights: '{"47159": 52.99, "47041": 47.01}',
    density: 11.2,
    imprecise: false,
    latitude: 36.10887,
    longitude: -85.85647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38569',
  },
  {
    city: 'Livingston',
    county_fips: 47133,
    county_fips_all: '47133',
    county: 'Overton',
    county_names_all: 'Overton',
    county_weights: '{"47133": 100}',
    density: 33.3,
    imprecise: false,
    latitude: 36.37678,
    longitude: -85.31983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38570',
  },
  {
    city: 'Crossville',
    county_fips: 47035,
    county_fips_all: '47035',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"47035": 100}',
    density: 25,
    imprecise: false,
    latitude: 36.0513,
    longitude: -85.01374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38571',
  },
  {
    city: 'Crossville',
    county_fips: 47035,
    county_fips_all: '47035|47007',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Bledsoe',
    county_weights: '{"47035": 91.4, "47007": 8.6}',
    density: 29.4,
    imprecise: false,
    latitude: 35.84764,
    longitude: -85.12778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38572',
  },
  {
    city: 'Monroe',
    county_fips: 47133,
    county_fips_all: '47133|47137|47027',
    county: 'Overton',
    county_names_all: 'Overton|Pickett|Clay',
    county_weights: '{"47133": 61.66, "47137": 36.75, "47027": 1.59}',
    density: 12.1,
    imprecise: false,
    latitude: 36.48945,
    longitude: -85.21931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38573',
  },
  {
    city: 'Monterey',
    county_fips: 47141,
    county_fips_all: '47141|47133|47035|47049',
    county: 'Putnam',
    county_names_all: 'Putnam|Overton|Cumberland|Fentress',
    county_weights:
      '{"47141": 48.63, "47133": 32.93, "47035": 13.84, "47049": 4.6}',
    density: 20.7,
    imprecise: false,
    latitude: 36.141,
    longitude: -85.22498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38574',
  },
  {
    city: 'Moss',
    county_fips: 47027,
    county_fips_all: '47027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"47027": 100}',
    density: 7,
    imprecise: false,
    latitude: 36.55848,
    longitude: -85.63515,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38575',
  },
  {
    city: 'Pall Mall',
    county_fips: 47137,
    county_fips_all: '47137|47049',
    county: 'Pickett',
    county_names_all: 'Pickett|Fentress',
    county_weights: '{"47137": 56.95, "47049": 43.05}',
    density: 5.9,
    imprecise: false,
    latitude: 36.56453,
    longitude: -84.94651,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38577',
  },
  {
    city: 'Pleasant Hill',
    county_fips: 47035,
    county_fips_all: '47035',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"47035": 100}',
    density: 150.8,
    imprecise: false,
    latitude: 35.98031,
    longitude: -85.19886,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38578',
  },
  {
    city: 'Quebeck',
    county_fips: 47185,
    county_fips_all: '47185',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"47185": 100}',
    density: 31.1,
    imprecise: false,
    latitude: 35.83218,
    longitude: -85.54919,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38579',
  },
  {
    city: 'Rickman',
    county_fips: 47133,
    county_fips_all: '47133',
    county: 'Overton',
    county_names_all: 'Overton',
    county_weights: '{"47133": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 36.27729,
    longitude: -85.29522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38580',
  },
  {
    city: 'Rock Island',
    county_fips: 47177,
    county_fips_all: '47177|47175|47041',
    county: 'Warren',
    county_names_all: 'Warren|Van Buren|DeKalb',
    county_weights: '{"47177": 53.67, "47175": 44.91, "47041": 1.42}',
    density: 16.1,
    imprecise: false,
    latitude: 35.73834,
    longitude: -85.62141,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38581',
  },
  {
    city: 'Silver Point',
    county_fips: 47141,
    county_fips_all: '47141|47041',
    county: 'Putnam',
    county_names_all: 'Putnam|DeKalb',
    county_weights: '{"47141": 52.76, "47041": 47.24}',
    density: 14.5,
    imprecise: false,
    latitude: 36.09431,
    longitude: -85.75382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38582',
  },
  {
    city: 'Sparta',
    county_fips: 47185,
    county_fips_all: '47185|47041|47141|47035|47175',
    county: 'White',
    county_names_all: 'White|DeKalb|Putnam|Cumberland|Van Buren',
    county_weights:
      '{"47185": 81.3, "47041": 5.87, "47141": 5.59, "47035": 4.88, "47175": 2.36}',
    density: 27.2,
    imprecise: false,
    latitude: 35.94649,
    longitude: -85.43781,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38583',
  },
  {
    city: 'Spencer',
    county_fips: 47175,
    county_fips_all: '47175|47153',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Sequatchie',
    county_weights: '{"47175": 97.72, "47153": 2.28}',
    density: 8.5,
    imprecise: false,
    latitude: 35.68995,
    longitude: -85.42274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38585',
  },
  {
    city: 'Walling',
    county_fips: 47185,
    county_fips_all: '47185',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"47185": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 35.8677,
    longitude: -85.61723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38587',
  },
  {
    city: 'Whitleyville',
    county_fips: 47087,
    county_fips_all: '47087|47027|47111',
    county: 'Jackson',
    county_names_all: 'Jackson|Clay|Macon',
    county_weights: '{"47087": 84.92, "47027": 12.47, "47111": 2.61}',
    density: 4.6,
    imprecise: false,
    latitude: 36.45613,
    longitude: -85.7189,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38588',
  },
  {
    city: 'Wilder',
    county_fips: 47049,
    county_fips_all: '47049|47133',
    county: 'Fentress',
    county_names_all: 'Fentress|Overton',
    county_weights: '{"47049": 90.74, "47133": 9.26}',
    density: 6.7,
    imprecise: false,
    latitude: 36.28551,
    longitude: -85.07624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38589',
  },
  {
    city: 'Abbeville',
    county_fips: 28071,
    county_fips_all: '28071',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"28071": 100}',
    density: 11,
    imprecise: false,
    latitude: 34.48146,
    longitude: -89.45166,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38601',
  },
  {
    city: 'Ashland',
    county_fips: 28009,
    county_fips_all: '28009|28139',
    county: 'Benton',
    county_names_all: 'Benton|Tippah',
    county_weights: '{"28009": 96.0, "28139": 4.0}',
    density: 7.1,
    imprecise: false,
    latitude: 34.83949,
    longitude: -89.14163,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38603',
  },
  {
    city: 'Batesville',
    county_fips: 28107,
    county_fips_all: '28107|28119|28071',
    county: 'Panola',
    county_names_all: 'Panola|Quitman|Lafayette',
    county_weights: '{"28107": 95.81, "28119": 2.75, "28071": 1.44}',
    density: 24.9,
    imprecise: false,
    latitude: 34.30375,
    longitude: -89.9581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38606',
  },
  {
    city: 'Blue Mountain',
    county_fips: 28139,
    county_fips_all: '28139|28009|28145',
    county: 'Tippah',
    county_names_all: 'Tippah|Benton|Union',
    county_weights: '{"28139": 72.62, "28009": 15.58, "28145": 11.8}',
    density: 12.7,
    imprecise: false,
    latitude: 34.65357,
    longitude: -89.02637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38610',
  },
  {
    city: 'Byhalia',
    county_fips: 28093,
    county_fips_all: '28093|28033',
    county: 'Marshall',
    county_names_all: 'Marshall|DeSoto',
    county_weights: '{"28093": 81.29, "28033": 18.71}',
    density: 33.3,
    imprecise: false,
    latitude: 34.85467,
    longitude: -89.67116,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38611',
  },
  {
    city: 'Clarksdale',
    county_fips: 28027,
    county_fips_all: '28027|28011',
    county: 'Coahoma',
    county_names_all: 'Coahoma|Bolivar',
    county_weights: '{"28027": 96.94, "28011": 3.06}',
    density: 25.7,
    imprecise: false,
    latitude: 34.15914,
    longitude: -90.60747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38614',
  },
  {
    city: 'Coahoma',
    county_fips: 28027,
    county_fips_all: '28027|28119',
    county: 'Coahoma',
    county_names_all: 'Coahoma|Quitman',
    county_weights: '{"28027": 99.14, "28119": 0.86}',
    density: 3.4,
    imprecise: false,
    latitude: 34.36261,
    longitude: -90.49342,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38617',
  },
  {
    city: 'Coldwater',
    county_fips: 28137,
    county_fips_all: '28137|28033|28093',
    county: 'Tate',
    county_names_all: 'Tate|DeSoto|Marshall',
    county_weights: '{"28137": 96.99, "28033": 2.3, "28093": 0.71}',
    density: 19.2,
    imprecise: false,
    latitude: 34.70203,
    longitude: -89.93415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38618',
  },
  {
    city: 'Como',
    county_fips: 28107,
    county_fips_all: '28107|28071|28137',
    county: 'Panola',
    county_names_all: 'Panola|Lafayette|Tate',
    county_weights: '{"28107": 70.1, "28071": 25.1, "28137": 4.8}',
    density: 14.5,
    imprecise: false,
    latitude: 34.51288,
    longitude: -89.82678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38619',
  },
  {
    city: 'Courtland',
    county_fips: 28107,
    county_fips_all: '28107',
    county: 'Panola',
    county_names_all: 'Panola',
    county_weights: '{"28107": 100}',
    density: 22.2,
    imprecise: false,
    latitude: 34.23206,
    longitude: -89.9156,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38620',
  },
  {
    city: 'Crenshaw',
    county_fips: 28107,
    county_fips_all: '28107|28119',
    county: 'Panola',
    county_names_all: 'Panola|Quitman',
    county_weights: '{"28107": 80.0, "28119": 20.0}',
    density: 9.9,
    imprecise: false,
    latitude: 34.4528,
    longitude: -90.1731,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38621',
  },
  {
    city: 'Crowder',
    county_fips: 28107,
    county_fips_all: '28107|28119|28135',
    county: 'Panola',
    county_names_all: 'Panola|Quitman|Tallahatchie',
    county_weights: '{"28107": 59.59, "28119": 40.21, "28135": 0.2}',
    density: 255.3,
    imprecise: false,
    latitude: 34.16944,
    longitude: -90.13448,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38622',
  },
  {
    city: 'Darling',
    county_fips: 28119,
    county_fips_all: '28119',
    county: 'Quitman',
    county_names_all: 'Quitman',
    county_weights: '{"28119": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 34.36131,
    longitude: -90.29692,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 82,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38623',
  },
  {
    city: 'Dumas',
    county_fips: 28139,
    county_fips_all: '28139|28145',
    county: 'Tippah',
    county_names_all: 'Tippah|Union',
    county_weights: '{"28139": 68.53, "28145": 31.47}',
    density: 14.6,
    imprecise: false,
    latitude: 34.61866,
    longitude: -88.8334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38625',
  },
  {
    city: 'Dundee',
    county_fips: 28143,
    county_fips_all: '28143|28027',
    county: 'Tunica',
    county_names_all: 'Tunica|Coahoma',
    county_weights: '{"28143": 81.71, "28027": 18.29}',
    density: 2.8,
    imprecise: false,
    latitude: 34.5182,
    longitude: -90.43966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38626',
  },
  {
    city: 'Etta',
    county_fips: 28071,
    county_fips_all: '28071|28145',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Union',
    county_weights: '{"28071": 52.46, "28145": 47.54}',
    density: 7,
    imprecise: false,
    latitude: 34.44503,
    longitude: -89.24563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38627',
  },
  {
    city: 'Falkner',
    county_fips: 28139,
    county_fips_all: '28139|28009',
    county: 'Tippah',
    county_names_all: 'Tippah|Benton',
    county_weights: '{"28139": 71.33, "28009": 28.67}',
    density: 18.2,
    imprecise: false,
    latitude: 34.86914,
    longitude: -88.99421,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38629',
  },
  {
    city: 'Friars Point',
    county_fips: 28027,
    county_fips_all: '28027',
    county: 'Coahoma',
    county_names_all: 'Coahoma',
    county_weights: '{"28027": 100}',
    density: 126.5,
    imprecise: false,
    latitude: 34.35891,
    longitude: -90.62765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38631',
  },
  {
    city: 'Hernando',
    county_fips: 28033,
    county_fips_all: '28033',
    county: 'DeSoto',
    county_names_all: 'DeSoto',
    county_weights: '{"28033": 100}',
    density: 74.7,
    imprecise: false,
    latitude: 34.79973,
    longitude: -90.00629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38632',
  },
  {
    city: 'Hickory Flat',
    county_fips: 28009,
    county_fips_all: '28009|28145',
    county: 'Benton',
    county_names_all: 'Benton|Union',
    county_weights: '{"28009": 79.99, "28145": 20.01}',
    density: 8.5,
    imprecise: false,
    latitude: 34.64206,
    longitude: -89.19671,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38633',
  },
  {
    city: 'Holly Springs',
    county_fips: 28093,
    county_fips_all: '28093|28009|28137',
    county: 'Marshall',
    county_names_all: 'Marshall|Benton|Tate',
    county_weights: '{"28093": 91.43, "28009": 6.1, "28137": 2.47}',
    density: 17.4,
    imprecise: false,
    latitude: 34.7677,
    longitude: -89.47896,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38635',
  },
  {
    city: 'Horn Lake',
    county_fips: 28033,
    county_fips_all: '28033',
    county: 'DeSoto',
    county_names_all: 'DeSoto',
    county_weights: '{"28033": 100}',
    density: 649.4,
    imprecise: false,
    latitude: 34.95105,
    longitude: -90.05004,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38637',
  },
  {
    city: 'Jonestown',
    county_fips: 28027,
    county_fips_all: '28027',
    county: 'Coahoma',
    county_names_all: 'Coahoma',
    county_weights: '{"28027": 100}',
    density: 38.3,
    imprecise: false,
    latitude: 34.30909,
    longitude: -90.4285,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38639',
  },
  {
    city: 'Lake Cormorant',
    county_fips: 28033,
    county_fips_all: '28033',
    county: 'DeSoto',
    county_names_all: 'DeSoto',
    county_weights: '{"28033": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 34.90616,
    longitude: -90.1857,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38641',
  },
  {
    city: 'Lamar',
    county_fips: 28009,
    county_fips_all: '28009|28093',
    county: 'Benton',
    county_names_all: 'Benton|Marshall',
    county_weights: '{"28009": 55.13, "28093": 44.87}',
    density: 10.9,
    imprecise: false,
    latitude: 34.91861,
    longitude: -89.33901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38642',
  },
  {
    city: 'Lambert',
    county_fips: 28119,
    county_fips_all: '28119|28135',
    county: 'Quitman',
    county_names_all: 'Quitman|Tallahatchie',
    county_weights: '{"28119": 96.7, "28135": 3.3}',
    density: 3.1,
    imprecise: false,
    latitude: 34.15082,
    longitude: -90.26281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38643',
  },
  {
    city: 'Lula',
    county_fips: 28027,
    county_fips_all: '28027',
    county: 'Coahoma',
    county_names_all: 'Coahoma',
    county_weights: '{"28027": 100}',
    density: 105,
    imprecise: false,
    latitude: 34.45899,
    longitude: -90.47576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38644',
  },
  {
    city: 'Lyon',
    county_fips: 28027,
    county_fips_all: '28027|28119',
    county: 'Coahoma',
    county_names_all: 'Coahoma|Quitman',
    county_weights: '{"28027": 82.62, "28119": 17.38}',
    density: 4.8,
    imprecise: false,
    latitude: 34.2469,
    longitude: -90.47663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38645',
  },
  {
    city: 'Marks',
    county_fips: 28119,
    county_fips_all: '28119',
    county: 'Quitman',
    county_names_all: 'Quitman',
    county_weights: '{"28119": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 34.28141,
    longitude: -90.29673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38646',
  },
  {
    city: 'Michigan City',
    county_fips: 28009,
    county_fips_all: '28009',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"28009": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 34.95851,
    longitude: -89.21746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38647',
  },
  {
    city: 'Myrtle',
    county_fips: 28145,
    county_fips_all: '28145|28009',
    county: 'Union',
    county_names_all: 'Union|Benton',
    county_weights: '{"28145": 91.83, "28009": 8.17}',
    density: 22.5,
    imprecise: false,
    latitude: 34.52776,
    longitude: -89.14165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38650',
  },
  {
    city: 'Nesbit',
    county_fips: 28033,
    county_fips_all: '28033',
    county: 'DeSoto',
    county_names_all: 'DeSoto',
    county_weights: '{"28033": 100}',
    density: 102.3,
    imprecise: false,
    latitude: 34.89172,
    longitude: -90.00359,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38651',
  },
  {
    city: 'New Albany',
    county_fips: 28145,
    county_fips_all: '28145',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"28145": 100}',
    density: 39.5,
    imprecise: false,
    latitude: 34.48545,
    longitude: -88.99652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38652',
  },
  {
    city: 'Olive Branch',
    county_fips: 28033,
    county_fips_all: '28033|28093',
    county: 'DeSoto',
    county_names_all: 'DeSoto|Marshall',
    county_weights: '{"28033": 96.64, "28093": 3.36}',
    density: 243.5,
    imprecise: false,
    latitude: 34.93635,
    longitude: -89.82409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38654',
  },
  {
    city: 'Oxford',
    county_fips: 28071,
    county_fips_all: '28071',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"28071": 100}',
    density: 49.2,
    imprecise: false,
    latitude: 34.33114,
    longitude: -89.4825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38655',
  },
  {
    city: 'Pope',
    county_fips: 28107,
    county_fips_all: '28107|28161',
    county: 'Panola',
    county_names_all: 'Panola|Yalobusha',
    county_weights: '{"28107": 94.55, "28161": 5.45}',
    density: 19.1,
    imprecise: false,
    latitude: 34.19011,
    longitude: -89.89906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38658',
  },
  {
    city: 'Potts Camp',
    county_fips: 28093,
    county_fips_all: '28093|28009',
    county: 'Marshall',
    county_names_all: 'Marshall|Benton',
    county_weights: '{"28093": 80.27, "28009": 19.73}',
    density: 7,
    imprecise: false,
    latitude: 34.62073,
    longitude: -89.32065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38659',
  },
  {
    city: 'Red Banks',
    county_fips: 28093,
    county_fips_all: '28093',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"28093": 100}',
    density: 27.1,
    imprecise: false,
    latitude: 34.89009,
    longitude: -89.55918,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38661',
  },
  {
    city: 'Ripley',
    county_fips: 28139,
    county_fips_all: '28139|28009',
    county: 'Tippah',
    county_names_all: 'Tippah|Benton',
    county_weights: '{"28139": 99.18, "28009": 0.82}',
    density: 23.1,
    imprecise: false,
    latitude: 34.74111,
    longitude: -88.89718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38663',
  },
  {
    city: 'Robinsonville',
    county_fips: 28143,
    county_fips_all: '28143',
    county: 'Tunica',
    county_names_all: 'Tunica',
    county_weights: '{"28143": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 34.80434,
    longitude: -90.33217,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38664',
  },
  {
    city: 'Sarah',
    county_fips: 28137,
    county_fips_all: '28137|28107|28143',
    county: 'Tate',
    county_names_all: 'Tate|Panola|Tunica',
    county_weights: '{"28137": 61.62, "28107": 26.8, "28143": 11.58}',
    density: 20.7,
    imprecise: false,
    latitude: 34.58165,
    longitude: -90.16693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38665',
  },
  {
    city: 'Sardis',
    county_fips: 28107,
    county_fips_all: '28107',
    county: 'Panola',
    county_names_all: 'Panola',
    county_weights: '{"28107": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 34.42007,
    longitude: -89.92708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38666',
  },
  {
    city: 'Senatobia',
    county_fips: 28137,
    county_fips_all: '28137|28107',
    county: 'Tate',
    county_names_all: 'Tate|Panola',
    county_weights: '{"28137": 97.15, "28107": 2.85}',
    density: 35.6,
    imprecise: false,
    latitude: 34.60109,
    longitude: -89.92505,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38668',
  },
  {
    city: 'Sledge',
    county_fips: 28119,
    county_fips_all: '28119|28143',
    county: 'Quitman',
    county_names_all: 'Quitman|Tunica',
    county_weights: '{"28119": 74.9, "28143": 25.1}',
    density: 3.7,
    imprecise: false,
    latitude: 34.42815,
    longitude: -90.28899,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38670',
  },
  {
    city: 'Southaven',
    county_fips: 28033,
    county_fips_all: '28033',
    county: 'DeSoto',
    county_names_all: 'DeSoto',
    county_weights: '{"28033": 100}',
    density: 648.3,
    imprecise: false,
    latitude: 34.96376,
    longitude: -89.99567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38671',
  },
  {
    city: 'Southaven',
    county_fips: 28033,
    county_fips_all: '28033',
    county: 'DeSoto',
    county_names_all: 'DeSoto',
    county_weights: '{"28033": 100}',
    density: 487.4,
    imprecise: false,
    latitude: 34.93727,
    longitude: -89.94943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38672',
  },
  {
    city: 'Taylor',
    county_fips: 28071,
    county_fips_all: '28071',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"28071": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 34.29607,
    longitude: -89.62485,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38673',
  },
  {
    city: 'Tiplersville',
    county_fips: 28139,
    county_fips_all: '28139',
    county: 'Tippah',
    county_names_all: 'Tippah',
    county_weights: '{"28139": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 34.8718,
    longitude: -88.89549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38674',
  },
  {
    city: 'Tunica',
    county_fips: 28143,
    county_fips_all: '28143',
    county: 'Tunica',
    county_names_all: 'Tunica',
    county_weights: '{"28143": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 34.67274,
    longitude: -90.3682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38676',
  },
  {
    city: 'Walls',
    county_fips: 28033,
    county_fips_all: '28033',
    county: 'DeSoto',
    county_names_all: 'DeSoto',
    county_weights: '{"28033": 100}',
    density: 109,
    imprecise: false,
    latitude: 34.96152,
    longitude: -90.14463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38680',
  },
  {
    city: 'Walnut',
    county_fips: 28139,
    county_fips_all: '28139|28003|28009',
    county: 'Tippah',
    county_names_all: 'Tippah|Alcorn|Benton',
    county_weights: '{"28139": 54.71, "28003": 38.37, "28009": 6.92}',
    density: 11.4,
    imprecise: false,
    latitude: 34.93504,
    longitude: -88.85997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38683',
  },
  {
    city: 'Waterford',
    county_fips: 28093,
    county_fips_all: '28093|28071',
    county: 'Marshall',
    county_names_all: 'Marshall|Lafayette',
    county_weights: '{"28093": 94.18, "28071": 5.82}',
    density: 6,
    imprecise: false,
    latitude: 34.5953,
    longitude: -89.48827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38685',
  },
  {
    city: 'Greenville',
    county_fips: 28151,
    county_fips_all: '28151',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"28151": 100}',
    density: 90,
    imprecise: false,
    latitude: 33.30621,
    longitude: -91.03346,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38701',
  },
  {
    city: 'Greenville',
    county_fips: 28151,
    county_fips_all: '28151|28011',
    county: 'Washington',
    county_names_all: 'Washington|Bolivar',
    county_weights: '{"28151": 86.73, "28011": 13.27}',
    density: 30,
    imprecise: false,
    latitude: 33.47081,
    longitude: -91.04775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38703',
  },
  {
    city: 'Alligator',
    county_fips: 28027,
    county_fips_all: '28027|28011',
    county: 'Coahoma',
    county_names_all: 'Coahoma|Bolivar',
    county_weights: '{"28027": 55.13, "28011": 44.87}',
    density: 3.8,
    imprecise: false,
    latitude: 34.11907,
    longitude: -90.78741,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38720',
  },
  {
    city: 'Anguilla',
    county_fips: 28125,
    county_fips_all: '28125',
    county: 'Sharkey',
    county_names_all: 'Sharkey',
    county_weights: '{"28125": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 32.96598,
    longitude: -90.75876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38721',
  },
  {
    city: 'Arcola',
    county_fips: 28151,
    county_fips_all: '28151',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"28151": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 33.26116,
    longitude: -90.88304,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38722',
  },
  {
    city: 'Avon',
    county_fips: 28151,
    county_fips_all: '28151',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"28151": 100}',
    density: 186.1,
    imprecise: false,
    latitude: 33.22967,
    longitude: -91.03845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38723',
  },
  {
    city: 'Benoit',
    county_fips: 28011,
    county_fips_all: '28011',
    county: 'Bolivar',
    county_names_all: 'Bolivar',
    county_weights: '{"28011": 100}',
    density: 3,
    imprecise: false,
    latitude: 33.63834,
    longitude: -91.05543,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38725',
  },
  {
    city: 'Beulah',
    county_fips: 28011,
    county_fips_all: '28011',
    county: 'Bolivar',
    county_names_all: 'Bolivar',
    county_weights: '{"28011": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 33.75207,
    longitude: -90.97664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38726',
  },
  {
    city: 'Boyle',
    county_fips: 28011,
    county_fips_all: '28011',
    county: 'Bolivar',
    county_names_all: 'Bolivar',
    county_weights: '{"28011": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 33.6883,
    longitude: -90.79932,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38730',
  },
  {
    city: 'Chatham',
    county_fips: 28151,
    county_fips_all: '28151',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"28151": 100}',
    density: 1,
    imprecise: false,
    latitude: 33.11524,
    longitude: -91.13829,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38731',
  },
  {
    city: 'Cleveland',
    county_fips: 28011,
    county_fips_all: '28011|28133',
    county: 'Bolivar',
    county_names_all: 'Bolivar|Sunflower',
    county_weights: '{"28011": 76.84, "28133": 23.16}',
    density: 73,
    imprecise: false,
    latitude: 33.75556,
    longitude: -90.72558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38732',
  },
  {
    city: 'Doddsville',
    county_fips: 28133,
    county_fips_all: '28133|28083',
    county: 'Sunflower',
    county_names_all: 'Sunflower|Leflore',
    county_weights: '{"28133": 93.98, "28083": 6.02}',
    density: 3.4,
    imprecise: false,
    latitude: 33.64389,
    longitude: -90.54173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38736',
  },
  {
    city: 'Drew',
    county_fips: 28133,
    county_fips_all: '28133|28135',
    county: 'Sunflower',
    county_names_all: 'Sunflower|Tallahatchie',
    county_weights: '{"28133": 69.43, "28135": 30.57}',
    density: 9.9,
    imprecise: false,
    latitude: 33.85683,
    longitude: -90.4928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38737',
  },
  {
    city: 'Parchman',
    county_fips: 28133,
    county_fips_all: '28133',
    county: 'Sunflower',
    county_names_all: 'Sunflower',
    county_weights: '{"28133": 100}',
    density: 50.6,
    imprecise: false,
    latitude: 33.93049,
    longitude: -90.53653,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38738',
  },
  {
    city: 'Duncan',
    county_fips: 28011,
    county_fips_all: '28011|28027',
    county: 'Bolivar',
    county_names_all: 'Bolivar|Coahoma',
    county_weights: '{"28011": 99.63, "28027": 0.37}',
    density: 2.8,
    imprecise: false,
    latitude: 34.04825,
    longitude: -90.79039,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38740',
  },
  {
    city: 'Glen Allan',
    county_fips: 28151,
    county_fips_all: '28151|28055',
    county: 'Washington',
    county_names_all: 'Washington|Issaquena',
    county_weights: '{"28151": 70.99, "28055": 29.01}',
    density: 2.8,
    imprecise: false,
    latitude: 33.03066,
    longitude: -91.05371,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38744',
  },
  {
    city: 'Grace',
    county_fips: 28055,
    county_fips_all: '28055',
    county: 'Issaquena',
    county_names_all: 'Issaquena',
    county_weights: '{"28055": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 32.98592,
    longitude: -91.00499,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38745',
  },
  {
    city: 'Gunnison',
    county_fips: 28011,
    county_fips_all: '28011',
    county: 'Bolivar',
    county_names_all: 'Bolivar',
    county_weights: '{"28011": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 33.95677,
    longitude: -90.94112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38746',
  },
  {
    city: 'Hollandale',
    county_fips: 28151,
    county_fips_all: '28151|28125',
    county: 'Washington',
    county_names_all: 'Washington|Sharkey',
    county_weights: '{"28151": 94.85, "28125": 5.15}',
    density: 4.7,
    imprecise: false,
    latitude: 33.15787,
    longitude: -90.87964,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38748',
  },
  {
    city: 'Indianola',
    county_fips: 28133,
    county_fips_all: '28133',
    county: 'Sunflower',
    county_names_all: 'Sunflower',
    county_weights: '{"28133": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 33.45326,
    longitude: -90.67469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38751',
  },
  {
    city: 'Inverness',
    county_fips: 28133,
    county_fips_all: '28133|28053',
    county: 'Sunflower',
    county_names_all: 'Sunflower|Humphreys',
    county_weights: '{"28133": 88.97, "28053": 11.03}',
    density: 6.1,
    imprecise: false,
    latitude: 33.34845,
    longitude: -90.58583,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38753',
  },
  {
    city: 'Isola',
    county_fips: 28053,
    county_fips_all: '28053|28133',
    county: 'Humphreys',
    county_names_all: 'Humphreys|Sunflower',
    county_weights: '{"28053": 72.97, "28133": 27.03}',
    density: 5.2,
    imprecise: false,
    latitude: 33.24816,
    longitude: -90.62066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38754',
  },
  {
    city: 'Leland',
    county_fips: 28151,
    county_fips_all: '28151',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"28151": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 33.39326,
    longitude: -90.85827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38756',
  },
  {
    city: 'Merigold',
    county_fips: 28011,
    county_fips_all: '28011|28133',
    county: 'Bolivar',
    county_names_all: 'Bolivar|Sunflower',
    county_weights: '{"28011": 71.58, "28133": 28.42}',
    density: 8,
    imprecise: false,
    latitude: 33.82495,
    longitude: -90.73501,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38759',
  },
  {
    city: 'Metcalfe',
    county_fips: 28151,
    county_fips_all: '28151',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"28151": 100}',
    density: 220.8,
    imprecise: false,
    latitude: 33.4535,
    longitude: -90.99394,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38760',
  },
  {
    city: 'Moorhead',
    county_fips: 28133,
    county_fips_all: '28133|28083',
    county: 'Sunflower',
    county_names_all: 'Sunflower|Leflore',
    county_weights: '{"28133": 69.36, "28083": 30.64}',
    density: 13.3,
    imprecise: false,
    latitude: 33.42507,
    longitude: -90.47658,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38761',
  },
  {
    city: 'Mound Bayou',
    county_fips: 28011,
    county_fips_all: '28011|28133',
    county: 'Bolivar',
    county_names_all: 'Bolivar|Sunflower',
    county_weights: '{"28011": 79.06, "28133": 20.94}',
    density: 11.2,
    imprecise: false,
    latitude: 33.8885,
    longitude: -90.72681,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38762',
  },
  {
    city: 'Pace',
    county_fips: 28011,
    county_fips_all: '28011',
    county: 'Bolivar',
    county_names_all: 'Bolivar',
    county_weights: '{"28011": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 33.79878,
    longitude: -90.87965,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38764',
  },
  {
    city: 'Panther Burn',
    county_fips: 28125,
    county_fips_all: '28125',
    county: 'Sharkey',
    county_names_all: 'Sharkey',
    county_weights: '{"28125": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 33.0493,
    longitude: -90.8896,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38765',
  },
  {
    city: 'Rena Lara',
    county_fips: 28027,
    county_fips_all: '28027',
    county: 'Coahoma',
    county_names_all: 'Coahoma',
    county_weights: '{"28027": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 34.12809,
    longitude: -90.80552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38767',
  },
  {
    city: 'Rome',
    county_fips: 28133,
    county_fips_all: '28133',
    county: 'Sunflower',
    county_names_all: 'Sunflower',
    county_weights: '{"28133": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 33.96576,
    longitude: -90.48036,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38768',
  },
  {
    city: 'Rosedale',
    county_fips: 28011,
    county_fips_all: '28011|05041',
    county: 'Bolivar',
    county_names_all: 'Bolivar|Desha',
    county_weights: '{"28011": 91.6, "05041": 8.4}',
    density: 10.3,
    imprecise: false,
    latitude: 33.84255,
    longitude: -90.97678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38769',
  },
  {
    city: 'Ruleville',
    county_fips: 28133,
    county_fips_all: '28133',
    county: 'Sunflower',
    county_names_all: 'Sunflower',
    county_weights: '{"28133": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 33.73914,
    longitude: -90.5243,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38771',
  },
  {
    city: 'Scott',
    county_fips: 28011,
    county_fips_all: '28011|28151',
    county: 'Bolivar',
    county_names_all: 'Bolivar|Washington',
    county_weights: '{"28011": 99.84, "28151": 0.16}',
    density: 2,
    imprecise: false,
    latitude: 33.56254,
    longitude: -91.08769,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38772',
  },
  {
    city: 'Shaw',
    county_fips: 28011,
    county_fips_all: '28011|28133',
    county: 'Bolivar',
    county_names_all: 'Bolivar|Sunflower',
    county_weights: '{"28011": 71.53, "28133": 28.47}',
    density: 6.6,
    imprecise: false,
    latitude: 33.60455,
    longitude: -90.77388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38773',
  },
  {
    city: 'Shelby',
    county_fips: 28011,
    county_fips_all: '28011',
    county: 'Bolivar',
    county_names_all: 'Bolivar',
    county_weights: '{"28011": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 33.9659,
    longitude: -90.76695,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38774',
  },
  {
    city: 'Stoneville',
    county_fips: 28151,
    county_fips_all: '28151',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"28151": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.42466,
    longitude: -90.92752,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38776',
  },
  {
    city: 'Sunflower',
    county_fips: 28133,
    county_fips_all: '28133',
    county: 'Sunflower',
    county_names_all: 'Sunflower',
    county_weights: '{"28133": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 33.54564,
    longitude: -90.51832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38778',
  },
  {
    city: 'Winstonville',
    county_fips: 28011,
    county_fips_all: '28011',
    county: 'Bolivar',
    county_names_all: 'Bolivar',
    county_weights: '{"28011": 100}',
    density: 86.3,
    imprecise: false,
    latitude: 33.90876,
    longitude: -90.75684,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38781',
  },
  {
    city: 'Tupelo',
    county_fips: 28081,
    county_fips_all: '28081|28115',
    county: 'Lee',
    county_names_all: 'Lee|Pontotoc',
    county_weights: '{"28081": 82.64, "28115": 17.36}',
    density: 158,
    imprecise: false,
    latitude: 34.22256,
    longitude: -88.7762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38801',
  },
  {
    city: 'Tupelo',
    county_fips: 28081,
    county_fips_all: '28081|28057',
    county: 'Lee',
    county_names_all: 'Lee|Itawamba',
    county_weights: '{"28081": 97.71, "28057": 2.29}',
    density: 82.1,
    imprecise: false,
    latitude: 34.28094,
    longitude: -88.67246,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38804',
  },
  {
    city: 'Amory',
    county_fips: 28095,
    county_fips_all: '28095',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"28095": 100}',
    density: 34.9,
    imprecise: false,
    latitude: 33.97503,
    longitude: -88.43918,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38821',
  },
  {
    city: 'Baldwyn',
    county_fips: 28117,
    county_fips_all: '28117|28081|28145|28057|28139',
    county: 'Prentiss',
    county_names_all: 'Prentiss|Lee|Union|Itawamba|Tippah',
    county_weights:
      '{"28117": 47.39, "28081": 24.64, "28145": 14.22, "28057": 7.8, "28139": 5.95}',
    density: 21.7,
    imprecise: false,
    latitude: 34.52303,
    longitude: -88.64334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38824',
  },
  {
    city: 'Belden',
    county_fips: 28115,
    county_fips_all: '28115|28081',
    county: 'Pontotoc',
    county_names_all: 'Pontotoc|Lee',
    county_weights: '{"28115": 71.77, "28081": 28.23}',
    density: 74.1,
    imprecise: false,
    latitude: 34.30164,
    longitude: -88.84655,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38826',
  },
  {
    city: 'Belmont',
    county_fips: 28141,
    county_fips_all: '28141',
    county: 'Tishomingo',
    county_names_all: 'Tishomingo',
    county_weights: '{"28141": 100}',
    density: 29.4,
    imprecise: false,
    latitude: 34.53,
    longitude: -88.20244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38827',
  },
  {
    city: 'Blue Springs',
    county_fips: 28145,
    county_fips_all: '28145|28115|28081',
    county: 'Union',
    county_names_all: 'Union|Pontotoc|Lee',
    county_weights: '{"28145": 80.87, "28115": 15.11, "28081": 4.02}',
    density: 21.2,
    imprecise: false,
    latitude: 34.42365,
    longitude: -88.86789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38828',
  },
  {
    city: 'Booneville',
    county_fips: 28117,
    county_fips_all: '28117|28139',
    county: 'Prentiss',
    county_names_all: 'Prentiss|Tippah',
    county_weights: '{"28117": 92.67, "28139": 7.33}',
    density: 27.9,
    imprecise: false,
    latitude: 34.65229,
    longitude: -88.53639,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38829',
  },
  {
    city: 'Burnsville',
    county_fips: 28141,
    county_fips_all: '28141|28003|28117',
    county: 'Tishomingo',
    county_names_all: 'Tishomingo|Alcorn|Prentiss',
    county_weights: '{"28141": 77.24, "28003": 14.93, "28117": 7.83}',
    density: 20.2,
    imprecise: false,
    latitude: 34.82259,
    longitude: -88.34274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38833',
  },
  {
    city: 'Corinth',
    county_fips: 28003,
    county_fips_all: '28003|28141',
    county: 'Alcorn',
    county_names_all: 'Alcorn|Tishomingo',
    county_weights: '{"28003": 98.57, "28141": 1.43}',
    density: 47.3,
    imprecise: false,
    latitude: 34.91627,
    longitude: -88.56027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38834',
  },
  {
    city: 'Dennis',
    county_fips: 28141,
    county_fips_all: '28141|28117',
    county: 'Tishomingo',
    county_names_all: 'Tishomingo|Prentiss',
    county_weights: '{"28141": 99.16, "28117": 0.84}',
    density: 9.6,
    imprecise: false,
    latitude: 34.5448,
    longitude: -88.2643,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38838',
  },
  {
    city: 'Derma',
    county_fips: 28013,
    county_fips_all: '28013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"28013": 100}',
    density: 660,
    imprecise: false,
    latitude: 33.8558,
    longitude: -89.28404,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38839',
  },
  {
    city: 'Ecru',
    county_fips: 28115,
    county_fips_all: '28115|28145',
    county: 'Pontotoc',
    county_names_all: 'Pontotoc|Union',
    county_weights: '{"28115": 90.69, "28145": 9.31}',
    density: 46.4,
    imprecise: false,
    latitude: 34.34943,
    longitude: -89.02237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38841',
  },
  {
    city: 'Fulton',
    county_fips: 28057,
    county_fips_all: '28057|28081',
    county: 'Itawamba',
    county_names_all: 'Itawamba|Lee',
    county_weights: '{"28057": 99.56, "28081": 0.44}',
    density: 24.3,
    imprecise: false,
    latitude: 34.26753,
    longitude: -88.37437,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38843',
  },
  {
    city: 'Gattman',
    county_fips: 28095,
    county_fips_all: '28095',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"28095": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 33.839,
    longitude: -88.25593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38844',
  },
  {
    city: 'Glen',
    county_fips: 28003,
    county_fips_all: '28003|28141',
    county: 'Alcorn',
    county_names_all: 'Alcorn|Tishomingo',
    county_weights: '{"28003": 80.17, "28141": 19.83}',
    density: 22.9,
    imprecise: false,
    latitude: 34.85135,
    longitude: -88.39501,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38846',
  },
  {
    city: 'Golden',
    county_fips: 28057,
    county_fips_all: '28057|28141',
    county: 'Itawamba',
    county_names_all: 'Itawamba|Tishomingo',
    county_weights: '{"28057": 87.07, "28141": 12.93}',
    density: 14.3,
    imprecise: false,
    latitude: 34.40772,
    longitude: -88.24074,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38847',
  },
  {
    city: 'Greenwood Springs',
    county_fips: 28095,
    county_fips_all: '28095',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"28095": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 33.94523,
    longitude: -88.27797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38848',
  },
  {
    city: 'Guntown',
    county_fips: 28081,
    county_fips_all: '28081|28145|28057',
    county: 'Lee',
    county_names_all: 'Lee|Union|Itawamba',
    county_weights: '{"28081": 81.11, "28145": 17.92, "28057": 0.97}',
    density: 30.8,
    imprecise: false,
    latitude: 34.45442,
    longitude: -88.69319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38849',
  },
  {
    city: 'Houlka',
    county_fips: 28017,
    county_fips_all: '28017|28013|28115',
    county: 'Chickasaw',
    county_names_all: 'Chickasaw|Calhoun|Pontotoc',
    county_weights: '{"28017": 61.28, "28013": 21.16, "28115": 17.56}',
    density: 8.3,
    imprecise: false,
    latitude: 34.04792,
    longitude: -89.06705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38850',
  },
  {
    city: 'Houston',
    county_fips: 28017,
    county_fips_all: '28017',
    county: 'Chickasaw',
    county_names_all: 'Chickasaw',
    county_weights: '{"28017": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 33.90763,
    longitude: -88.9637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38851',
  },
  {
    city: 'Iuka',
    county_fips: 28141,
    county_fips_all: '28141|01033',
    county: 'Tishomingo',
    county_names_all: 'Tishomingo|Colbert',
    county_weights: '{"28141": 99.7, "01033": 0.3}',
    density: 17,
    imprecise: false,
    latitude: 34.84484,
    longitude: -88.21598,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38852',
  },
  {
    city: 'Mantachie',
    county_fips: 28057,
    county_fips_all: '28057',
    county: 'Itawamba',
    county_names_all: 'Itawamba',
    county_weights: '{"28057": 100}',
    density: 35.9,
    imprecise: false,
    latitude: 34.32646,
    longitude: -88.48659,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38855',
  },
  {
    city: 'Marietta',
    county_fips: 28057,
    county_fips_all: '28057|28117',
    county: 'Itawamba',
    county_names_all: 'Itawamba|Prentiss',
    county_weights: '{"28057": 54.57, "28117": 45.43}',
    density: 8,
    imprecise: false,
    latitude: 34.46835,
    longitude: -88.44553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38856',
  },
  {
    city: 'Mooreville',
    county_fips: 28081,
    county_fips_all: '28081',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"28081": 100}',
    density: 84,
    imprecise: false,
    latitude: 34.28004,
    longitude: -88.57808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38857',
  },
  {
    city: 'Nettleton',
    county_fips: 28057,
    county_fips_all: '28057|28095|28081',
    county: 'Itawamba',
    county_names_all: 'Itawamba|Monroe|Lee',
    county_weights: '{"28057": 44.88, "28095": 37.49, "28081": 17.64}',
    density: 17.3,
    imprecise: false,
    latitude: 34.10145,
    longitude: -88.53726,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38858',
  },
  {
    city: 'New Site',
    county_fips: 28117,
    county_fips_all: '28117',
    county: 'Prentiss',
    county_names_all: 'Prentiss',
    county_weights: '{"28117": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 34.52865,
    longitude: -88.37548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38859',
  },
  {
    city: 'Okolona',
    county_fips: 28017,
    county_fips_all: '28017|28095|28081|28115',
    county: 'Chickasaw',
    county_names_all: 'Chickasaw|Monroe|Lee|Pontotoc',
    county_weights:
      '{"28017": 74.43, "28095": 21.66, "28081": 3.37, "28115": 0.54}',
    density: 15.1,
    imprecise: false,
    latitude: 33.97649,
    longitude: -88.75879,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38860',
  },
  {
    city: 'Plantersville',
    county_fips: 28081,
    county_fips_all: '28081',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"28081": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 34.16871,
    longitude: -88.62048,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38862',
  },
  {
    city: 'Pontotoc',
    county_fips: 28115,
    county_fips_all: '28115|28071',
    county: 'Pontotoc',
    county_names_all: 'Pontotoc|Lafayette',
    county_weights: '{"28115": 96.06, "28071": 3.94}',
    density: 25.4,
    imprecise: false,
    latitude: 34.2167,
    longitude: -89.02738,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38863',
  },
  {
    city: 'Randolph',
    county_fips: 28115,
    county_fips_all: '28115|28013',
    county: 'Pontotoc',
    county_names_all: 'Pontotoc|Calhoun',
    county_weights: '{"28115": 77.87, "28013": 22.13}',
    density: 10.2,
    imprecise: false,
    latitude: 34.14325,
    longitude: -89.20167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38864',
  },
  {
    city: 'Rienzi',
    county_fips: 28003,
    county_fips_all: '28003|28117',
    county: 'Alcorn',
    county_names_all: 'Alcorn|Prentiss',
    county_weights: '{"28003": 78.41, "28117": 21.59}',
    density: 15.8,
    imprecise: false,
    latitude: 34.78003,
    longitude: -88.58821,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38865',
  },
  {
    city: 'Saltillo',
    county_fips: 28081,
    county_fips_all: '28081',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"28081": 100}',
    density: 63.7,
    imprecise: false,
    latitude: 34.36644,
    longitude: -88.68187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38866',
  },
  {
    city: 'Shannon',
    county_fips: 28081,
    county_fips_all: '28081|28115|28095|28017',
    county: 'Lee',
    county_names_all: 'Lee|Pontotoc|Monroe|Chickasaw',
    county_weights:
      '{"28081": 74.26, "28115": 15.43, "28095": 7.39, "28017": 2.92}',
    density: 23.1,
    imprecise: false,
    latitude: 34.12168,
    longitude: -88.74692,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38868',
  },
  {
    city: 'Sherman',
    county_fips: 28115,
    county_fips_all: '28115',
    county: 'Pontotoc',
    county_names_all: 'Pontotoc',
    county_weights: '{"28115": 100}',
    density: 95,
    imprecise: false,
    latitude: 34.35627,
    longitude: -88.83635,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38869',
  },
  {
    city: 'Smithville',
    county_fips: 28095,
    county_fips_all: '28095|28057',
    county: 'Monroe',
    county_names_all: 'Monroe|Itawamba',
    county_weights: '{"28095": 70.67, "28057": 29.33}',
    density: 12,
    imprecise: false,
    latitude: 34.06886,
    longitude: -88.34125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38870',
  },
  {
    city: 'Thaxton',
    county_fips: 28115,
    county_fips_all: '28115|28071|28145',
    county: 'Pontotoc',
    county_names_all: 'Pontotoc|Lafayette|Union',
    county_weights: '{"28115": 75.05, "28071": 17.0, "28145": 7.95}',
    density: 16.3,
    imprecise: false,
    latitude: 34.33582,
    longitude: -89.2055,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38871',
  },
  {
    city: 'Tishomingo',
    county_fips: 28141,
    county_fips_all: '28141|28117',
    county: 'Tishomingo',
    county_names_all: 'Tishomingo|Prentiss',
    county_weights: '{"28141": 93.58, "28117": 6.42}',
    density: 9.9,
    imprecise: false,
    latitude: 34.66169,
    longitude: -88.25141,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38873',
  },
  {
    city: 'Tremont',
    county_fips: 28057,
    county_fips_all: '28057',
    county: 'Itawamba',
    county_names_all: 'Itawamba',
    county_weights: '{"28057": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 34.21457,
    longitude: -88.23112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38876',
  },
  {
    city: 'Vardaman',
    county_fips: 28013,
    county_fips_all: '28013|28017',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Chickasaw',
    county_weights: '{"28013": 94.17, "28017": 5.83}',
    density: 10.8,
    imprecise: false,
    latitude: 33.88179,
    longitude: -89.19231,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38878',
  },
  {
    city: 'Verona',
    county_fips: 28081,
    county_fips_all: '28081',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"28081": 100}',
    density: 181.8,
    imprecise: false,
    latitude: 34.19519,
    longitude: -88.71209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38879',
  },
  {
    city: 'Grenada',
    county_fips: 28043,
    county_fips_all: '28043|28015|28135|28097',
    county: 'Grenada',
    county_names_all: 'Grenada|Carroll|Tallahatchie|Montgomery',
    county_weights:
      '{"28043": 86.23, "28015": 9.33, "28135": 3.56, "28097": 0.88}',
    density: 28.4,
    imprecise: false,
    latitude: 33.76275,
    longitude: -89.79799,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38901',
  },
  {
    city: 'Big Creek',
    county_fips: 28013,
    county_fips_all: '28013|28043',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Grenada',
    county_weights: '{"28013": 93.62, "28043": 6.38}',
    density: 4.2,
    imprecise: false,
    latitude: 33.86466,
    longitude: -89.46453,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38914',
  },
  {
    city: 'Bruce',
    county_fips: 28013,
    county_fips_all: '28013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"28013": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 34.02807,
    longitude: -89.38957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38915',
  },
  {
    city: 'Calhoun City',
    county_fips: 28013,
    county_fips_all: '28013|28155',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Webster',
    county_weights: '{"28013": 95.48, "28155": 4.52}',
    density: 10.1,
    imprecise: false,
    latitude: 33.81815,
    longitude: -89.35158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38916',
  },
  {
    city: 'Carrollton',
    county_fips: 28015,
    county_fips_all: '28015',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"28015": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 33.54902,
    longitude: -89.95501,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38917',
  },
  {
    city: 'Cascilla',
    county_fips: 28135,
    county_fips_all: '28135',
    county: 'Tallahatchie',
    county_names_all: 'Tallahatchie',
    county_weights: '{"28135": 100}',
    density: 3,
    imprecise: false,
    latitude: 33.8823,
    longitude: -90.05018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38920',
  },
  {
    city: 'Charleston',
    county_fips: 28135,
    county_fips_all: '28135',
    county: 'Tallahatchie',
    county_names_all: 'Tallahatchie',
    county_weights: '{"28135": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 33.98328,
    longitude: -90.1425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38921',
  },
  {
    city: 'Coffeeville',
    county_fips: 28161,
    county_fips_all: '28161|28043',
    county: 'Yalobusha',
    county_names_all: 'Yalobusha|Grenada',
    county_weights: '{"28161": 80.37, "28043": 19.63}',
    density: 5.7,
    imprecise: false,
    latitude: 33.93641,
    longitude: -89.64878,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38922',
  },
  {
    city: 'Coila',
    county_fips: 28015,
    county_fips_all: '28015',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"28015": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 33.37829,
    longitude: -89.99354,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38923',
  },
  {
    city: 'Cruger',
    county_fips: 28051,
    county_fips_all: '28051|28053|28015|28083',
    county: 'Holmes',
    county_names_all: 'Holmes|Humphreys|Carroll|Leflore',
    county_weights:
      '{"28051": 66.48, "28053": 15.91, "28015": 10.89, "28083": 6.72}',
    density: 2.4,
    imprecise: false,
    latitude: 33.29342,
    longitude: -90.22392,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38924',
  },
  {
    city: 'Duck Hill',
    county_fips: 28097,
    county_fips_all: '28097|28043|28155',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Grenada|Webster',
    county_weights: '{"28097": 78.36, "28043": 11.35, "28155": 10.29}',
    density: 4.7,
    imprecise: false,
    latitude: 33.62917,
    longitude: -89.61961,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38925',
  },
  {
    city: 'Enid',
    county_fips: 28135,
    county_fips_all: '28135|28107|28161',
    county: 'Tallahatchie',
    county_names_all: 'Tallahatchie|Panola|Yalobusha',
    county_weights: '{"28135": 83.63, "28107": 15.09, "28161": 1.28}',
    density: 8.3,
    imprecise: false,
    latitude: 34.13394,
    longitude: -90.01827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38927',
  },
  {
    city: 'Glendora',
    county_fips: 28135,
    county_fips_all: '28135',
    county: 'Tallahatchie',
    county_names_all: 'Tallahatchie',
    county_weights: '{"28135": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 33.85405,
    longitude: -90.28731,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38928',
  },
  {
    city: 'Gore Springs',
    county_fips: 28043,
    county_fips_all: '28043|28155|28013',
    county: 'Grenada',
    county_names_all: 'Grenada|Webster|Calhoun',
    county_weights: '{"28043": 60.72, "28155": 31.95, "28013": 7.33}',
    density: 10.4,
    imprecise: false,
    latitude: 33.74014,
    longitude: -89.52425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38929',
  },
  {
    city: 'Greenwood',
    county_fips: 28083,
    county_fips_all: '28083|28015',
    county: 'Leflore',
    county_names_all: 'Leflore|Carroll',
    county_weights: '{"28083": 62.46, "28015": 37.54}',
    density: 45.1,
    imprecise: false,
    latitude: 33.52845,
    longitude: -90.14245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38930',
  },
  {
    city: 'Holcomb',
    county_fips: 28043,
    county_fips_all: '28043|28135|28015',
    county: 'Grenada',
    county_names_all: 'Grenada|Tallahatchie|Carroll',
    county_weights: '{"28043": 72.9, "28135": 19.1, "28015": 8.0}',
    density: 5.1,
    imprecise: false,
    latitude: 33.75145,
    longitude: -90.03505,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38940',
  },
  {
    city: 'Itta Bena',
    county_fips: 28083,
    county_fips_all: '28083',
    county: 'Leflore',
    county_names_all: 'Leflore',
    county_weights: '{"28083": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 33.48655,
    longitude: -90.35909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38941',
  },
  {
    city: 'McCarley',
    county_fips: 28015,
    county_fips_all: '28015',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"28015": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 33.52033,
    longitude: -89.84525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38943',
  },
  {
    city: 'Minter City',
    county_fips: 28083,
    county_fips_all: '28083|28135',
    county: 'Leflore',
    county_names_all: 'Leflore|Tallahatchie',
    county_weights: '{"28083": 96.74, "28135": 3.26}',
    density: 1.2,
    imprecise: false,
    latitude: 33.76106,
    longitude: -90.34242,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38944',
  },
  {
    city: 'Morgan City',
    county_fips: 28083,
    county_fips_all: '28083',
    county: 'Leflore',
    county_names_all: 'Leflore',
    county_weights: '{"28083": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 33.37701,
    longitude: -90.35591,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38946',
  },
  {
    city: 'North Carrollton',
    county_fips: 28015,
    county_fips_all: '28015',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"28015": 100}',
    density: 175.5,
    imprecise: false,
    latitude: 33.51718,
    longitude: -89.92128,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38947',
  },
  {
    city: 'Oakland',
    county_fips: 28161,
    county_fips_all: '28161|28135',
    county: 'Yalobusha',
    county_names_all: 'Yalobusha|Tallahatchie',
    county_weights: '{"28161": 69.27, "28135": 30.73}',
    density: 6.8,
    imprecise: false,
    latitude: 34.07635,
    longitude: -89.89364,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38948',
  },
  {
    city: 'Philipp',
    county_fips: 28135,
    county_fips_all: '28135|28083',
    county: 'Tallahatchie',
    county_names_all: 'Tallahatchie|Leflore',
    county_weights: '{"28135": 71.54, "28083": 28.46}',
    density: 4.4,
    imprecise: false,
    latitude: 33.74281,
    longitude: -90.19758,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38950',
  },
  {
    city: 'Pittsboro',
    county_fips: 28013,
    county_fips_all: '28013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"28013": 100}',
    density: 8,
    imprecise: false,
    latitude: 33.97605,
    longitude: -89.28802,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38951',
  },
  {
    city: 'Schlater',
    county_fips: 28083,
    county_fips_all: '28083',
    county: 'Leflore',
    county_names_all: 'Leflore',
    county_weights: '{"28083": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 33.63041,
    longitude: -90.33711,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38952',
  },
  {
    city: 'Scobey',
    county_fips: 28135,
    county_fips_all: '28135|28161|28043',
    county: 'Tallahatchie',
    county_names_all: 'Tallahatchie|Yalobusha|Grenada',
    county_weights: '{"28135": 45.77, "28161": 41.8, "28043": 12.43}',
    density: 3.1,
    imprecise: false,
    latitude: 33.91821,
    longitude: -89.92325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38953',
  },
  {
    city: 'Sidon',
    county_fips: 28083,
    county_fips_all: '28083|28015|28051',
    county: 'Leflore',
    county_names_all: 'Leflore|Carroll|Holmes',
    county_weights: '{"28083": 82.01, "28015": 15.59, "28051": 2.4}',
    density: 4.6,
    imprecise: false,
    latitude: 33.41301,
    longitude: -90.21536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38954',
  },
  {
    city: 'Sumner',
    county_fips: 28135,
    county_fips_all: '28135',
    county: 'Tallahatchie',
    county_names_all: 'Tallahatchie',
    county_weights: '{"28135": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 33.98747,
    longitude: -90.37296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38957',
  },
  {
    city: 'Tillatoba',
    county_fips: 28161,
    county_fips_all: '28161|28135',
    county: 'Yalobusha',
    county_names_all: 'Yalobusha|Tallahatchie',
    county_weights: '{"28161": 68.48, "28135": 31.52}',
    density: 2.2,
    imprecise: false,
    latitude: 33.96463,
    longitude: -89.8859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38961',
  },
  {
    city: 'Tippo',
    county_fips: 28135,
    county_fips_all: '28135',
    county: 'Tallahatchie',
    county_names_all: 'Tallahatchie',
    county_weights: '{"28135": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 33.87201,
    longitude: -90.18465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38962',
  },
  {
    city: 'Tutwiler',
    county_fips: 28135,
    county_fips_all: '28135|28027|28133',
    county: 'Tallahatchie',
    county_names_all: 'Tallahatchie|Coahoma|Sunflower',
    county_weights: '{"28135": 62.93, "28027": 19.73, "28133": 17.34}',
    density: 6.4,
    imprecise: false,
    latitude: 34.00442,
    longitude: -90.40598,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38963',
  },
  {
    city: 'Vance',
    county_fips: 28119,
    county_fips_all: '28119|28135',
    county: 'Quitman',
    county_names_all: 'Quitman|Tallahatchie',
    county_weights: '{"28119": 88.19, "28135": 11.81}',
    density: 1.3,
    imprecise: false,
    latitude: 34.11035,
    longitude: -90.38868,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38964',
  },
  {
    city: 'Water Valley',
    county_fips: 28161,
    county_fips_all: '28161|28071|28013|28107',
    county: 'Yalobusha',
    county_names_all: 'Yalobusha|Lafayette|Calhoun|Panola',
    county_weights:
      '{"28161": 58.72, "28071": 21.43, "28013": 15.77, "28107": 4.08}',
    density: 13.8,
    imprecise: false,
    latitude: 34.13486,
    longitude: -89.59257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38965',
  },
  {
    city: 'Webb',
    county_fips: 28135,
    county_fips_all: '28135',
    county: 'Tallahatchie',
    county_names_all: 'Tallahatchie',
    county_weights: '{"28135": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 33.9202,
    longitude: -90.31828,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38966',
  },
  {
    city: 'Winona',
    county_fips: 28097,
    county_fips_all: '28097|28015',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Carroll',
    county_weights: '{"28097": 61.21, "28015": 38.79}',
    density: 15.1,
    imprecise: false,
    latitude: 33.45832,
    longitude: -89.72026,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38967',
  },
  {
    city: 'Belzoni',
    county_fips: 28053,
    county_fips_all: '28053|28083|28051|28133',
    county: 'Humphreys',
    county_names_all: 'Humphreys|Leflore|Holmes|Sunflower',
    county_weights:
      '{"28053": 73.07, "28083": 22.46, "28051": 2.82, "28133": 1.65}',
    density: 8.1,
    imprecise: false,
    latitude: 33.20179,
    longitude: -90.47023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39038',
  },
  {
    city: 'Benton',
    county_fips: 28163,
    county_fips_all: '28163',
    county: 'Yazoo',
    county_names_all: 'Yazoo',
    county_weights: '{"28163": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 32.82216,
    longitude: -90.22757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39039',
  },
  {
    city: 'Bentonia',
    county_fips: 28163,
    county_fips_all: '28163',
    county: 'Yazoo',
    county_names_all: 'Yazoo',
    county_weights: '{"28163": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 32.63907,
    longitude: -90.41314,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39040',
  },
  {
    city: 'Bolton',
    county_fips: 28049,
    county_fips_all: '28049|28089',
    county: 'Hinds',
    county_names_all: 'Hinds|Madison',
    county_weights: '{"28049": 99.59, "28089": 0.41}',
    density: 8.5,
    imprecise: false,
    latitude: 32.41757,
    longitude: -90.47273,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39041',
  },
  {
    city: 'Brandon',
    county_fips: 28121,
    county_fips_all: '28121|28129',
    county: 'Rankin',
    county_names_all: 'Rankin|Smith',
    county_weights: '{"28121": 98.73, "28129": 1.27}',
    density: 70.6,
    imprecise: false,
    latitude: 32.2135,
    longitude: -89.88966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39042',
  },
  {
    city: 'Braxton',
    county_fips: 28127,
    county_fips_all: '28127|28121',
    county: 'Simpson',
    county_names_all: 'Simpson|Rankin',
    county_weights: '{"28127": 59.26, "28121": 40.74}',
    density: 8.3,
    imprecise: false,
    latitude: 32.02869,
    longitude: -89.97161,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39044',
  },
  {
    city: 'Camden',
    county_fips: 28089,
    county_fips_all: '28089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"28089": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 32.78735,
    longitude: -89.8173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39045',
  },
  {
    city: 'Canton',
    county_fips: 28089,
    county_fips_all: '28089|28163',
    county: 'Madison',
    county_names_all: 'Madison|Yazoo',
    county_weights: '{"28089": 99.85, "28163": 0.15}',
    density: 35.2,
    imprecise: false,
    latitude: 32.62834,
    longitude: -89.99634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39046',
  },
  {
    city: 'Brandon',
    county_fips: 28121,
    county_fips_all: '28121',
    county: 'Rankin',
    county_names_all: 'Rankin',
    county_weights: '{"28121": 100}',
    density: 162.5,
    imprecise: false,
    latitude: 32.43356,
    longitude: -89.95011,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39047',
  },
  {
    city: 'Carthage',
    county_fips: 28079,
    county_fips_all: '28079|28099|28089|28007',
    county: 'Leake',
    county_names_all: 'Leake|Neshoba|Madison|Attala',
    county_weights:
      '{"28079": 90.9, "28099": 5.43, "28089": 2.25, "28007": 1.42}',
    density: 13.4,
    imprecise: false,
    latitude: 32.7868,
    longitude: -89.50718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39051',
  },
  {
    city: 'Cary',
    county_fips: 28125,
    county_fips_all: '28125',
    county: 'Sharkey',
    county_names_all: 'Sharkey',
    county_weights: '{"28125": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 32.79855,
    longitude: -90.93525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39054',
  },
  {
    city: 'Clinton',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 191,
    imprecise: false,
    latitude: 32.37384,
    longitude: -90.35083,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39056',
  },
  {
    city: 'Conehatta',
    county_fips: 28101,
    county_fips_all: '28101|28123',
    county: 'Newton',
    county_names_all: 'Newton|Scott',
    county_weights: '{"28101": 87.49, "28123": 12.51}',
    density: 16.8,
    imprecise: false,
    latitude: 32.49268,
    longitude: -89.28381,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39057',
  },
  {
    city: 'Crystal Springs',
    county_fips: 28029,
    county_fips_all: '28029|28049',
    county: 'Copiah',
    county_names_all: 'Copiah|Hinds',
    county_weights: '{"28029": 94.54, "28049": 5.46}',
    density: 30.3,
    imprecise: false,
    latitude: 31.98194,
    longitude: -90.35141,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39059',
  },
  {
    city: 'Delta City',
    county_fips: 28125,
    county_fips_all: '28125',
    county: 'Sharkey',
    county_names_all: 'Sharkey',
    county_weights: '{"28125": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.08597,
    longitude: -90.80324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39061',
  },
  {
    city: 'D Lo',
    county_fips: 28127,
    county_fips_all: '28127',
    county: 'Simpson',
    county_names_all: 'Simpson',
    county_weights: '{"28127": 100}',
    density: 118.9,
    imprecise: false,
    latitude: 31.98479,
    longitude: -89.89815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39062',
  },
  {
    city: 'Durant',
    county_fips: 28051,
    county_fips_all: '28051',
    county: 'Holmes',
    county_names_all: 'Holmes',
    county_weights: '{"28051": 100}',
    density: 11,
    imprecise: false,
    latitude: 33.11698,
    longitude: -89.89975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39063',
  },
  {
    city: 'Edwards',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 32.30188,
    longitude: -90.60502,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39066',
  },
  {
    city: 'Ethel',
    county_fips: 28007,
    county_fips_all: '28007',
    county: 'Attala',
    county_names_all: 'Attala',
    county_weights: '{"28007": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 33.11574,
    longitude: -89.44853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39067',
  },
  {
    city: 'Fayette',
    county_fips: 28063,
    county_fips_all: '28063|28037',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Franklin',
    county_weights: '{"28063": 97.03, "28037": 2.97}',
    density: 9.9,
    imprecise: false,
    latitude: 31.6836,
    longitude: -91.04038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39069',
  },
  {
    city: 'Flora',
    county_fips: 28089,
    county_fips_all: '28089|28049',
    county: 'Madison',
    county_names_all: 'Madison|Hinds',
    county_weights: '{"28089": 99.07, "28049": 0.93}',
    density: 20.4,
    imprecise: false,
    latitude: 32.54887,
    longitude: -90.3185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39071',
  },
  {
    city: 'Florence',
    county_fips: 28121,
    county_fips_all: '28121|28127',
    county: 'Rankin',
    county_names_all: 'Rankin|Simpson',
    county_weights: '{"28121": 78.02, "28127": 21.98}',
    density: 50.5,
    imprecise: false,
    latitude: 32.10269,
    longitude: -90.13049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39073',
  },
  {
    city: 'Forest',
    county_fips: 28123,
    county_fips_all: '28123|28129',
    county: 'Scott',
    county_names_all: 'Scott|Smith',
    county_weights: '{"28123": 83.23, "28129": 16.77}',
    density: 19.9,
    imprecise: false,
    latitude: 32.3872,
    longitude: -89.47398,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39074',
  },
  {
    city: 'Georgetown',
    county_fips: 28029,
    county_fips_all: '28029|28127',
    county: 'Copiah',
    county_names_all: 'Copiah|Simpson',
    county_weights: '{"28029": 99.52, "28127": 0.48}',
    density: 8.2,
    imprecise: false,
    latitude: 31.87901,
    longitude: -90.19596,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39078',
  },
  {
    city: 'Goodman',
    county_fips: 28007,
    county_fips_all: '28007|28051|28089',
    county: 'Attala',
    county_names_all: 'Attala|Holmes|Madison',
    county_weights: '{"28007": 53.9, "28051": 36.98, "28089": 9.12}',
    density: 6.6,
    imprecise: false,
    latitude: 32.93178,
    longitude: -89.88449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39079',
  },
  {
    city: 'Harrisville',
    county_fips: 28127,
    county_fips_all: '28127',
    county: 'Simpson',
    county_names_all: 'Simpson',
    county_weights: '{"28127": 100}',
    density: 9,
    imprecise: false,
    latitude: 31.94663,
    longitude: -90.12369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39082',
  },
  {
    city: 'Hazlehurst',
    county_fips: 28029,
    county_fips_all: '28029|28085',
    county: 'Copiah',
    county_names_all: 'Copiah|Lincoln',
    county_weights: '{"28029": 98.3, "28085": 1.7}',
    density: 10.3,
    imprecise: false,
    latitude: 31.83467,
    longitude: -90.46997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39083',
  },
  {
    city: 'Hermanville',
    county_fips: 28021,
    county_fips_all: '28021|28029',
    county: 'Claiborne',
    county_names_all: 'Claiborne|Copiah',
    county_weights: '{"28021": 65.61, "28029": 34.39}',
    density: 3.1,
    imprecise: false,
    latitude: 31.96275,
    longitude: -90.75964,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39086',
  },
  {
    city: 'Holly Bluff',
    county_fips: 28125,
    county_fips_all: '28125',
    county: 'Sharkey',
    county_names_all: 'Sharkey',
    county_weights: '{"28125": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 32.73287,
    longitude: -90.7545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39088',
  },
  {
    city: 'Kosciusko',
    county_fips: 28007,
    county_fips_all: '28007|28079|28159',
    county: 'Attala',
    county_names_all: 'Attala|Leake|Winston',
    county_weights: '{"28007": 84.11, "28079": 15.53, "28159": 0.36}',
    density: 17.7,
    imprecise: false,
    latitude: 33.00775,
    longitude: -89.54503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39090',
  },
  {
    city: 'Lake',
    county_fips: 28123,
    county_fips_all: '28123|28101|28129',
    county: 'Scott',
    county_names_all: 'Scott|Newton|Smith',
    county_weights: '{"28123": 79.83, "28101": 14.19, "28129": 5.98}',
    density: 12.8,
    imprecise: false,
    latitude: 32.31489,
    longitude: -89.36833,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39092',
  },
  {
    city: 'Lena',
    county_fips: 28079,
    county_fips_all: '28079|28123|28121',
    county: 'Leake',
    county_names_all: 'Leake|Scott|Rankin',
    county_weights: '{"28079": 43.08, "28123": 37.9, "28121": 19.02}',
    density: 6.7,
    imprecise: false,
    latitude: 32.57497,
    longitude: -89.67591,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39094',
  },
  {
    city: 'Lexington',
    county_fips: 28051,
    county_fips_all: '28051|28015|28163',
    county: 'Holmes',
    county_names_all: 'Holmes|Carroll|Yazoo',
    county_weights: '{"28051": 91.85, "28015": 5.66, "28163": 2.49}',
    density: 7.4,
    imprecise: false,
    latitude: 33.11929,
    longitude: -90.09452,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39095',
  },
  {
    city: 'Lorman',
    county_fips: 28063,
    county_fips_all: '28063|28021',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Claiborne',
    county_weights: '{"28063": 81.76, "28021": 18.24}',
    density: 4.5,
    imprecise: false,
    latitude: 31.82508,
    longitude: -91.11672,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39096',
  },
  {
    city: 'Louise',
    county_fips: 28053,
    county_fips_all: '28053',
    county: 'Humphreys',
    county_names_all: 'Humphreys',
    county_weights: '{"28053": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 32.99105,
    longitude: -90.59478,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39097',
  },
  {
    city: 'McCool',
    county_fips: 28007,
    county_fips_all: '28007|28019|28159',
    county: 'Attala',
    county_names_all: 'Attala|Choctaw|Winston',
    county_weights: '{"28007": 49.57, "28019": 27.74, "28159": 22.68}',
    density: 4.3,
    imprecise: false,
    latitude: 33.15684,
    longitude: -89.33033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39108',
  },
  {
    city: 'Madison',
    county_fips: 28089,
    county_fips_all: '28089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"28089": 100}',
    density: 262.1,
    imprecise: false,
    latitude: 32.50325,
    longitude: -90.13791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39110',
  },
  {
    city: 'Magee',
    county_fips: 28127,
    county_fips_all: '28127|28129',
    county: 'Simpson',
    county_names_all: 'Simpson|Smith',
    county_weights: '{"28127": 78.98, "28129": 21.02}',
    density: 25,
    imprecise: false,
    latitude: 31.89536,
    longitude: -89.71816,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39111',
  },
  {
    city: 'Mayersville',
    county_fips: 28055,
    county_fips_all: '28055',
    county: 'Issaquena',
    county_names_all: 'Issaquena',
    county_weights: '{"28055": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 32.82707,
    longitude: -91.06476,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39113',
  },
  {
    city: 'Mendenhall',
    county_fips: 28127,
    county_fips_all: '28127|28121',
    county: 'Simpson',
    county_names_all: 'Simpson|Rankin',
    county_weights: '{"28127": 88.2, "28121": 11.8}',
    density: 19,
    imprecise: false,
    latitude: 31.95331,
    longitude: -89.83257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39114',
  },
  {
    city: 'Midnight',
    county_fips: 28053,
    county_fips_all: '28053',
    county: 'Humphreys',
    county_names_all: 'Humphreys',
    county_weights: '{"28053": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 33.04679,
    longitude: -90.56133,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39115',
  },
  {
    city: 'Mize',
    county_fips: 28129,
    county_fips_all: '28129',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"28129": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 31.89165,
    longitude: -89.54925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39116',
  },
  {
    city: 'Morton',
    county_fips: 28123,
    county_fips_all: '28123|28129|28121',
    county: 'Scott',
    county_names_all: 'Scott|Smith|Rankin',
    county_weights: '{"28123": 70.35, "28129": 25.82, "28121": 3.83}',
    density: 16,
    imprecise: false,
    latitude: 32.31096,
    longitude: -89.66413,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39117',
  },
  {
    city: 'Mount Olive',
    county_fips: 28031,
    county_fips_all: '28031|28129|28065|28127',
    county: 'Covington',
    county_names_all: 'Covington|Smith|Jefferson Davis|Simpson',
    county_weights:
      '{"28031": 55.98, "28129": 15.85, "28065": 15.68, "28127": 12.49}',
    density: 15,
    imprecise: false,
    latitude: 31.75236,
    longitude: -89.67509,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39119',
  },
  {
    city: 'Natchez',
    county_fips: 28001,
    county_fips_all: '28001|28063',
    county: 'Adams',
    county_names_all: 'Adams|Jefferson',
    county_weights: '{"28001": 87.49, "28063": 12.51}',
    density: 23.2,
    imprecise: false,
    latitude: 31.51148,
    longitude: -91.35206,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39120',
  },
  {
    city: 'Newhebron',
    county_fips: 28065,
    county_fips_all: '28065|28127|28077',
    county: 'Jefferson Davis',
    county_names_all: 'Jefferson Davis|Simpson|Lawrence',
    county_weights: '{"28065": 36.46, "28127": 32.04, "28077": 31.5}',
    density: 9.4,
    imprecise: false,
    latitude: 31.75211,
    longitude: -90.00512,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39140',
  },
  {
    city: 'Pattison',
    county_fips: 28021,
    county_fips_all: '28021|28063|28029',
    county: 'Claiborne',
    county_names_all: 'Claiborne|Jefferson|Copiah',
    county_weights: '{"28021": 61.13, "28063": 21.37, "28029": 17.5}',
    density: 3.1,
    imprecise: false,
    latitude: 31.82971,
    longitude: -90.80155,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39144',
  },
  {
    city: 'Pelahatchie',
    county_fips: 28121,
    county_fips_all: '28121|28123',
    county: 'Rankin',
    county_names_all: 'Rankin|Scott',
    county_weights: '{"28121": 97.99, "28123": 2.01}',
    density: 15.8,
    imprecise: false,
    latitude: 32.33862,
    longitude: -89.79819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39145',
  },
  {
    city: 'Pickens',
    county_fips: 28089,
    county_fips_all: '28089|28051|28163',
    county: 'Madison',
    county_names_all: 'Madison|Holmes|Yazoo',
    county_weights: '{"28089": 42.62, "28051": 40.22, "28163": 17.16}',
    density: 7.4,
    imprecise: false,
    latitude: 32.88078,
    longitude: -89.99316,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39146',
  },
  {
    city: 'Piney Woods',
    county_fips: 28121,
    county_fips_all: '28121',
    county: 'Rankin',
    county_names_all: 'Rankin',
    county_weights: '{"28121": 100}',
    density: 99.9,
    imprecise: false,
    latitude: 32.06159,
    longitude: -89.99459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39148',
  },
  {
    city: 'Pinola',
    county_fips: 28127,
    county_fips_all: '28127',
    county: 'Simpson',
    county_names_all: 'Simpson',
    county_weights: '{"28127": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 31.83354,
    longitude: -90.00985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39149',
  },
  {
    city: 'Port Gibson',
    county_fips: 28021,
    county_fips_all: '28021',
    county: 'Claiborne',
    county_names_all: 'Claiborne',
    county_weights: '{"28021": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 31.99264,
    longitude: -90.98487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39150',
  },
  {
    city: 'Pulaski',
    county_fips: 28129,
    county_fips_all: '28129|28123',
    county: 'Smith',
    county_names_all: 'Smith|Scott',
    county_weights: '{"28129": 65.01, "28123": 34.99}',
    density: 3.1,
    imprecise: false,
    latitude: 32.2011,
    longitude: -89.57779,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39152',
  },
  {
    city: 'Raleigh',
    county_fips: 28129,
    county_fips_all: '28129',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"28129": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 32.05133,
    longitude: -89.50159,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39153',
  },
  {
    city: 'Raymond',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 30.5,
    imprecise: false,
    latitude: 32.22695,
    longitude: -90.44762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39154',
  },
  {
    city: 'Redwood',
    county_fips: 28149,
    county_fips_all: '28149',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"28149": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 32.53901,
    longitude: -90.77056,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39156',
  },
  {
    city: 'Ridgeland',
    county_fips: 28089,
    county_fips_all: '28089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"28089": 100}',
    density: 315.8,
    imprecise: false,
    latitude: 32.42537,
    longitude: -90.16685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39157',
  },
  {
    city: 'Rolling Fork',
    county_fips: 28125,
    county_fips_all: '28125|28055',
    county: 'Sharkey',
    county_names_all: 'Sharkey|Issaquena',
    county_weights: '{"28125": 55.43, "28055": 44.57}',
    density: 3,
    imprecise: false,
    latitude: 32.82894,
    longitude: -90.92476,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39159',
  },
  {
    city: 'Sallis',
    county_fips: 28007,
    county_fips_all: '28007|28079',
    county: 'Attala',
    county_names_all: 'Attala|Leake',
    county_weights: '{"28007": 91.73, "28079": 8.27}',
    density: 7.7,
    imprecise: false,
    latitude: 32.99756,
    longitude: -89.75336,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39160',
  },
  {
    city: 'Satartia',
    county_fips: 28163,
    county_fips_all: '28163',
    county: 'Yazoo',
    county_names_all: 'Yazoo',
    county_weights: '{"28163": 100}',
    density: 1,
    imprecise: false,
    latitude: 32.62627,
    longitude: -90.63395,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39162',
  },
  {
    city: 'Silver City',
    county_fips: 28053,
    county_fips_all: '28053',
    county: 'Humphreys',
    county_names_all: 'Humphreys',
    county_weights: '{"28053": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 33.05161,
    longitude: -90.48208,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39166',
  },
  {
    city: 'Star',
    county_fips: 28121,
    county_fips_all: '28121',
    county: 'Rankin',
    county_names_all: 'Rankin',
    county_weights: '{"28121": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.09316,
    longitude: -90.04003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39167',
  },
  {
    city: 'Taylorsville',
    county_fips: 28129,
    county_fips_all: '28129|28067|28031',
    county: 'Smith',
    county_names_all: 'Smith|Jones|Covington',
    county_weights: '{"28129": 64.53, "28067": 19.84, "28031": 15.63}',
    density: 16.2,
    imprecise: false,
    latitude: 31.82994,
    longitude: -89.40974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39168',
  },
  {
    city: 'Tchula',
    county_fips: 28051,
    county_fips_all: '28051',
    county: 'Holmes',
    county_names_all: 'Holmes',
    county_weights: '{"28051": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 33.13515,
    longitude: -90.29371,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39169',
  },
  {
    city: 'Terry',
    county_fips: 28049,
    county_fips_all: '28049|28029',
    county: 'Hinds',
    county_names_all: 'Hinds|Copiah',
    county_weights: '{"28049": 97.8, "28029": 2.2}',
    density: 36.1,
    imprecise: false,
    latitude: 32.11182,
    longitude: -90.3377,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39170',
  },
  {
    city: 'Tinsley',
    county_fips: 28163,
    county_fips_all: '28163',
    county: 'Yazoo',
    county_names_all: 'Yazoo',
    county_weights: '{"28163": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 32.74247,
    longitude: -90.47219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39173',
  },
  {
    city: 'Tougaloo',
    county_fips: 28089,
    county_fips_all: '28089|28049',
    county: 'Madison',
    county_names_all: 'Madison|Hinds',
    county_weights: '{"28089": 60.47, "28049": 39.53}',
    density: 763.8,
    imprecise: false,
    latitude: 32.4009,
    longitude: -90.16018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39174',
  },
  {
    city: 'Utica',
    county_fips: 28049,
    county_fips_all: '28049|28029|28021',
    county: 'Hinds',
    county_names_all: 'Hinds|Copiah|Claiborne',
    county_weights: '{"28049": 58.83, "28029": 25.57, "28021": 15.6}',
    density: 7,
    imprecise: false,
    latitude: 32.09238,
    longitude: -90.62097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39175',
  },
  {
    city: 'Vaiden',
    county_fips: 28015,
    county_fips_all: '28015|28007|28097',
    county: 'Carroll',
    county_names_all: 'Carroll|Attala|Montgomery',
    county_weights: '{"28015": 68.6, "28007": 20.96, "28097": 10.44}',
    density: 6.1,
    imprecise: false,
    latitude: 33.30398,
    longitude: -89.74859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39176',
  },
  {
    city: 'Valley Park',
    county_fips: 28055,
    county_fips_all: '28055',
    county: 'Issaquena',
    county_names_all: 'Issaquena',
    county_weights: '{"28055": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 32.61286,
    longitude: -90.84546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39177',
  },
  {
    city: 'Vaughan',
    county_fips: 28163,
    county_fips_all: '28163',
    county: 'Yazoo',
    county_names_all: 'Yazoo',
    county_weights: '{"28163": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 32.80873,
    longitude: -90.0984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39179',
  },
  {
    city: 'Vicksburg',
    county_fips: 28149,
    county_fips_all: '28149',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"28149": 100}',
    density: 42.1,
    imprecise: false,
    latitude: 32.223,
    longitude: -90.90225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39180',
  },
  {
    city: 'Vicksburg',
    county_fips: 28149,
    county_fips_all: '28149|28055',
    county: 'Warren',
    county_names_all: 'Warren|Issaquena',
    county_weights: '{"28149": 86.63, "28055": 13.37}',
    density: 17.1,
    imprecise: false,
    latitude: 32.4554,
    longitude: -90.83307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39183',
  },
  {
    city: 'Walnut Grove',
    county_fips: 28079,
    county_fips_all: '28079|28123',
    county: 'Leake',
    county_names_all: 'Leake|Scott',
    county_weights: '{"28079": 74.36, "28123": 25.64}',
    density: 20,
    imprecise: false,
    latitude: 32.60412,
    longitude: -89.4003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39189',
  },
  {
    city: 'Wesson',
    county_fips: 28029,
    county_fips_all: '28029|28085|28077',
    county: 'Copiah',
    county_names_all: 'Copiah|Lincoln|Lawrence',
    county_weights: '{"28029": 60.36, "28085": 38.08, "28077": 1.56}',
    density: 14.7,
    imprecise: false,
    latitude: 31.71492,
    longitude: -90.40764,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39191',
  },
  {
    city: 'West',
    county_fips: 28007,
    county_fips_all: '28007|28051|28015',
    county: 'Attala',
    county_names_all: 'Attala|Holmes|Carroll',
    county_weights: '{"28007": 57.22, "28051": 29.55, "28015": 13.23}',
    density: 4.2,
    imprecise: false,
    latitude: 33.19153,
    longitude: -89.75324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39192',
  },
  {
    city: 'Whitfield',
    county_fips: 28121,
    county_fips_all: '28121',
    county: 'Rankin',
    county_names_all: 'Rankin',
    county_weights: '{"28121": 100}',
    density: 154.4,
    imprecise: false,
    latitude: 32.23625,
    longitude: -90.07681,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39193',
  },
  {
    city: 'Yazoo City',
    county_fips: 28163,
    county_fips_all: '28163|28053',
    county: 'Yazoo',
    county_names_all: 'Yazoo|Humphreys',
    county_weights: '{"28163": 94.47, "28053": 5.53}',
    density: 15.9,
    imprecise: false,
    latitude: 32.83423,
    longitude: -90.49856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39194',
  },
  {
    city: 'Jackson',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 159.5,
    imprecise: false,
    latitude: 32.28981,
    longitude: -90.18398,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39201',
  },
  {
    city: 'Jackson',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 680.7,
    imprecise: false,
    latitude: 32.31105,
    longitude: -90.16956,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39202',
  },
  {
    city: 'Jackson',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 684.7,
    imprecise: false,
    latitude: 32.30928,
    longitude: -90.20042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39203',
  },
  {
    city: 'Jackson',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 542.6,
    imprecise: false,
    latitude: 32.28313,
    longitude: -90.23689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39204',
  },
  {
    city: 'Jackson',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 1015.2,
    imprecise: false,
    latitude: 32.37237,
    longitude: -90.17268,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39206',
  },
  {
    city: 'Pearl',
    county_fips: 28121,
    county_fips_all: '28121',
    county: 'Rankin',
    county_names_all: 'Rankin',
    county_weights: '{"28121": 100}',
    density: 278.1,
    imprecise: false,
    latitude: 32.25827,
    longitude: -90.08908,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39208',
  },
  {
    city: 'Jackson',
    county_fips: 28049,
    county_fips_all: '28049|28089',
    county: 'Hinds',
    county_names_all: 'Hinds|Madison',
    county_weights: '{"28049": 96.78, "28089": 3.22}',
    density: 159.7,
    imprecise: false,
    latitude: 32.39498,
    longitude: -90.30168,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39209',
  },
  {
    city: 'Jackson',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 747.6,
    imprecise: false,
    latitude: 32.37176,
    longitude: -90.12219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39211',
  },
  {
    city: 'Jackson',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 334.7,
    imprecise: false,
    latitude: 32.24081,
    longitude: -90.26174,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39212',
  },
  {
    city: 'Jackson',
    county_fips: 28049,
    county_fips_all: '28049|28089',
    county: 'Hinds',
    county_names_all: 'Hinds|Madison',
    county_weights: '{"28049": 97.02, "28089": 2.98}',
    density: 255.2,
    imprecise: false,
    latitude: 32.39384,
    longitude: -90.23007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39213',
  },
  {
    city: 'Jackson',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 361.2,
    imprecise: false,
    latitude: 32.33463,
    longitude: -90.1606,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39216',
  },
  {
    city: 'Richland',
    county_fips: 28121,
    county_fips_all: '28121',
    county: 'Rankin',
    county_names_all: 'Rankin',
    county_weights: '{"28121": 100}',
    density: 149.7,
    imprecise: false,
    latitude: 32.22825,
    longitude: -90.15857,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39218',
  },
  {
    city: 'Flowood',
    county_fips: 28121,
    county_fips_all: '28121',
    county: 'Rankin',
    county_names_all: 'Rankin',
    county_weights: '{"28121": 100}',
    density: 139.2,
    imprecise: false,
    latitude: 32.3361,
    longitude: -90.08693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39232',
  },
  {
    city: 'Jackson',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.30114,
    longitude: -90.1889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39269',
  },
  {
    city: 'Byram',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 235.7,
    imprecise: false,
    latitude: 32.18838,
    longitude: -90.26335,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39272',
  },
  {
    city: 'Meridian',
    county_fips: 28075,
    county_fips_all: '28075|28023',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale|Clarke',
    county_weights: '{"28075": 68.91, "28023": 31.09}',
    density: 30.8,
    imprecise: false,
    latitude: 32.27289,
    longitude: -88.59226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39301',
  },
  {
    city: 'Meridian',
    county_fips: 28075,
    county_fips_all: '28075',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale',
    county_weights: '{"28075": 100}',
    density: 84.3,
    imprecise: false,
    latitude: 32.46392,
    longitude: -88.72465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39305',
  },
  {
    city: 'Meridian',
    county_fips: 28075,
    county_fips_all: '28075',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale',
    county_weights: '{"28075": 100}',
    density: 64.1,
    imprecise: false,
    latitude: 32.33847,
    longitude: -88.79217,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39307',
  },
  {
    city: 'Bailey',
    county_fips: 28075,
    county_fips_all: '28075|28069',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale|Kemper',
    county_weights: '{"28075": 57.75, "28069": 42.25}',
    density: 15.9,
    imprecise: false,
    latitude: 32.56169,
    longitude: -88.74507,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39320',
  },
  {
    city: 'Buckatunna',
    county_fips: 28153,
    county_fips_all: '28153',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"28153": 100}',
    density: 9,
    imprecise: false,
    latitude: 31.58344,
    longitude: -88.53203,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39322',
  },
  {
    city: 'Chunky',
    county_fips: 28101,
    county_fips_all: '28101|28075',
    county: 'Newton',
    county_names_all: 'Newton|Lauderdale',
    county_weights: '{"28101": 66.36, "28075": 33.64}',
    density: 6.6,
    imprecise: false,
    latitude: 32.34971,
    longitude: -88.92624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39323',
  },
  {
    city: 'Clara',
    county_fips: 28153,
    county_fips_all: '28153',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"28153": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.58032,
    longitude: -88.69755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39324',
  },
  {
    city: 'Collinsville',
    county_fips: 28075,
    county_fips_all: '28075|28069|28099|28101',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale|Kemper|Neshoba|Newton',
    county_weights:
      '{"28075": 56.03, "28069": 29.81, "28099": 10.14, "28101": 4.02}',
    density: 21.7,
    imprecise: false,
    latitude: 32.56198,
    longitude: -88.87362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39325',
  },
  {
    city: 'Daleville',
    county_fips: 28069,
    county_fips_all: '28069|28075',
    county: 'Kemper',
    county_names_all: 'Kemper|Lauderdale',
    county_weights: '{"28069": 72.94, "28075": 27.06}',
    density: 2.6,
    imprecise: false,
    latitude: 32.59814,
    longitude: -88.67904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39326',
  },
  {
    city: 'Decatur',
    county_fips: 28101,
    county_fips_all: '28101',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"28101": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 32.44563,
    longitude: -89.12173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39327',
  },
  {
    city: 'De Kalb',
    county_fips: 28069,
    county_fips_all: '28069',
    county: 'Kemper',
    county_names_all: 'Kemper',
    county_weights: '{"28069": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 32.75012,
    longitude: -88.69564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39328',
  },
  {
    city: 'Enterprise',
    county_fips: 28023,
    county_fips_all: '28023|28075|28061|28101',
    county: 'Clarke',
    county_names_all: 'Clarke|Lauderdale|Jasper|Newton',
    county_weights:
      '{"28023": 58.06, "28075": 28.66, "28061": 8.81, "28101": 4.47}',
    density: 9.6,
    imprecise: false,
    latitude: 32.19385,
    longitude: -88.85689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39330',
  },
  {
    city: 'Hickory',
    county_fips: 28101,
    county_fips_all: '28101|28061',
    county: 'Newton',
    county_names_all: 'Newton|Jasper',
    county_weights: '{"28101": 90.19, "28061": 9.81}',
    density: 11.1,
    imprecise: false,
    latitude: 32.30399,
    longitude: -89.0046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39332',
  },
  {
    city: 'Lauderdale',
    county_fips: 28075,
    county_fips_all: '28075|28069',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale|Kemper',
    county_weights: '{"28075": 85.38, "28069": 14.62}',
    density: 9.8,
    imprecise: false,
    latitude: 32.53214,
    longitude: -88.49263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39335',
  },
  {
    city: 'Lawrence',
    county_fips: 28101,
    county_fips_all: '28101|28061|28129',
    county: 'Newton',
    county_names_all: 'Newton|Jasper|Smith',
    county_weights: '{"28101": 86.86, "28061": 8.6, "28129": 4.54}',
    density: 7.4,
    imprecise: false,
    latitude: 32.29081,
    longitude: -89.27253,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39336',
  },
  {
    city: 'Little Rock',
    county_fips: 28101,
    county_fips_all: '28101|28099',
    county: 'Newton',
    county_names_all: 'Newton|Neshoba',
    county_weights: '{"28101": 94.14, "28099": 5.86}',
    density: 8.4,
    imprecise: false,
    latitude: 32.51447,
    longitude: -88.98528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39337',
  },
  {
    city: 'Louin',
    county_fips: 28061,
    county_fips_all: '28061|28129',
    county: 'Jasper',
    county_names_all: 'Jasper|Smith',
    county_weights: '{"28061": 81.72, "28129": 18.28}',
    density: 6.6,
    imprecise: false,
    latitude: 32.11034,
    longitude: -89.23274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39338',
  },
  {
    city: 'Louisville',
    county_fips: 28159,
    county_fips_all: '28159',
    county: 'Winston',
    county_names_all: 'Winston',
    county_weights: '{"28159": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 33.10417,
    longitude: -89.00259,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39339',
  },
  {
    city: 'Macon',
    county_fips: 28103,
    county_fips_all: '28103|28159',
    county: 'Noxubee',
    county_names_all: 'Noxubee|Winston',
    county_weights: '{"28103": 96.32, "28159": 3.68}',
    density: 6.9,
    imprecise: false,
    latitude: 33.0998,
    longitude: -88.55702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39341',
  },
  {
    city: 'Marion',
    county_fips: 28075,
    county_fips_all: '28075',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale',
    county_weights: '{"28075": 100}',
    density: 229.4,
    imprecise: false,
    latitude: 32.42566,
    longitude: -88.64968,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39342',
  },
  {
    city: 'Newton',
    county_fips: 28101,
    county_fips_all: '28101|28061',
    county: 'Newton',
    county_names_all: 'Newton|Jasper',
    county_weights: '{"28101": 83.58, "28061": 16.42}',
    density: 16.1,
    imprecise: false,
    latitude: 32.28717,
    longitude: -89.12974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39345',
  },
  {
    city: 'Noxapater',
    county_fips: 28159,
    county_fips_all: '28159|28099',
    county: 'Winston',
    county_names_all: 'Winston|Neshoba',
    county_weights: '{"28159": 85.82, "28099": 14.18}',
    density: 8.4,
    imprecise: false,
    latitude: 32.96171,
    longitude: -89.089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39346',
  },
  {
    city: 'Pachuta',
    county_fips: 28061,
    county_fips_all: '28061|28023',
    county: 'Jasper',
    county_names_all: 'Jasper|Clarke',
    county_weights: '{"28061": 65.14, "28023": 34.86}',
    density: 7.2,
    imprecise: false,
    latitude: 32.05507,
    longitude: -88.93419,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39347',
  },
  {
    city: 'Paulding',
    county_fips: 28061,
    county_fips_all: '28061',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"28061": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 32.00007,
    longitude: -89.03475,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39348',
  },
  {
    city: 'Philadelphia',
    county_fips: 28099,
    county_fips_all: '28099|28159|28069|28079',
    county: 'Neshoba',
    county_names_all: 'Neshoba|Winston|Kemper|Leake',
    county_weights:
      '{"28099": 90.54, "28159": 5.82, "28069": 1.98, "28079": 1.66}',
    density: 22.2,
    imprecise: false,
    latitude: 32.79674,
    longitude: -89.12984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39350',
  },
  {
    city: 'Porterville',
    county_fips: 28069,
    county_fips_all: '28069',
    county: 'Kemper',
    county_names_all: 'Kemper',
    county_weights: '{"28069": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 32.66834,
    longitude: -88.47808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39352',
  },
  {
    city: 'Preston',
    county_fips: 28069,
    county_fips_all: '28069|28159|28103|28099',
    county: 'Kemper',
    county_names_all: 'Kemper|Winston|Noxubee|Neshoba',
    county_weights:
      '{"28069": 72.38, "28159": 11.87, "28103": 7.95, "28099": 7.8}',
    density: 5.7,
    imprecise: false,
    latitude: 32.87945,
    longitude: -88.83625,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39354',
  },
  {
    city: 'Quitman',
    county_fips: 28023,
    county_fips_all: '28023',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"28023": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 32.05808,
    longitude: -88.61965,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39355',
  },
  {
    city: 'Rose Hill',
    county_fips: 28061,
    county_fips_all: '28061',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"28061": 100}',
    density: 5,
    imprecise: false,
    latitude: 32.13632,
    longitude: -89.0283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39356',
  },
  {
    city: 'Scooba',
    county_fips: 28069,
    county_fips_all: '28069|28103',
    county: 'Kemper',
    county_names_all: 'Kemper|Noxubee',
    county_weights: '{"28069": 96.25, "28103": 3.75}',
    density: 2.6,
    imprecise: false,
    latitude: 32.83317,
    longitude: -88.45605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39358',
  },
  {
    city: 'Sebastopol',
    county_fips: 28123,
    county_fips_all: '28123',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"28123": 100}',
    density: 67.4,
    imprecise: false,
    latitude: 32.56852,
    longitude: -89.33206,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39359',
  },
  {
    city: 'Shubuta',
    county_fips: 28023,
    county_fips_all: '28023|28153',
    county: 'Clarke',
    county_names_all: 'Clarke|Wayne',
    county_weights: '{"28023": 61.56, "28153": 38.44}',
    density: 7.9,
    imprecise: false,
    latitude: 31.86357,
    longitude: -88.7409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39360',
  },
  {
    city: 'Shuqualak',
    county_fips: 28103,
    county_fips_all: '28103|28069',
    county: 'Noxubee',
    county_names_all: 'Noxubee|Kemper',
    county_weights: '{"28103": 99.85, "28069": 0.15}',
    density: 3.5,
    imprecise: false,
    latitude: 32.97952,
    longitude: -88.61234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39361',
  },
  {
    city: 'State Line',
    county_fips: 28041,
    county_fips_all: '28041|28153',
    county: 'Greene',
    county_names_all: 'Greene|Wayne',
    county_weights: '{"28041": 64.81, "28153": 35.19}',
    density: 6.6,
    imprecise: false,
    latitude: 31.39326,
    longitude: -88.53988,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39362',
  },
  {
    city: 'Stonewall',
    county_fips: 28023,
    county_fips_all: '28023',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"28023": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 32.11918,
    longitude: -88.77628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39363',
  },
  {
    city: 'Toomsuba',
    county_fips: 28075,
    county_fips_all: '28075',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale',
    county_weights: '{"28075": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 32.40597,
    longitude: -88.49617,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39364',
  },
  {
    city: 'Union',
    county_fips: 28099,
    county_fips_all: '28099|28101|28079|28069',
    county: 'Neshoba',
    county_names_all: 'Neshoba|Newton|Leake|Kemper',
    county_weights:
      '{"28099": 71.03, "28101": 28.26, "28079": 0.55, "28069": 0.16}',
    density: 16.2,
    imprecise: false,
    latitude: 32.60486,
    longitude: -89.12225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39365',
  },
  {
    city: 'Vossburg',
    county_fips: 28023,
    county_fips_all: '28023|28061',
    county: 'Clarke',
    county_names_all: 'Clarke|Jasper',
    county_weights: '{"28023": 56.02, "28061": 43.98}',
    density: 5.1,
    imprecise: false,
    latitude: 31.93795,
    longitude: -88.90057,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39366',
  },
  {
    city: 'Waynesboro',
    county_fips: 28153,
    county_fips_all: '28153|28023',
    county: 'Wayne',
    county_names_all: 'Wayne|Clarke',
    county_weights: '{"28153": 95.4, "28023": 4.6}',
    density: 11.6,
    imprecise: false,
    latitude: 31.68219,
    longitude: -88.6644,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39367',
  },
  {
    city: 'Hattiesburg',
    county_fips: 28035,
    county_fips_all: '28035|28067|28031|28073',
    county: 'Forrest',
    county_names_all: 'Forrest|Jones|Covington|Lamar',
    county_weights:
      '{"28035": 95.42, "28067": 3.93, "28031": 0.44, "28073": 0.21}',
    density: 87,
    imprecise: false,
    latitude: 31.23496,
    longitude: -89.26912,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39401',
  },
  {
    city: 'Hattiesburg',
    county_fips: 28073,
    county_fips_all: '28073|28035|28031',
    county: 'Lamar',
    county_names_all: 'Lamar|Forrest|Covington',
    county_weights: '{"28073": 56.49, "28035": 41.87, "28031": 1.64}',
    density: 184.8,
    imprecise: false,
    latitude: 31.33446,
    longitude: -89.4132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39402',
  },
  {
    city: 'Bassfield',
    county_fips: 28065,
    county_fips_all: '28065|28091',
    county: 'Jefferson Davis',
    county_names_all: 'Jefferson Davis|Marion',
    county_weights: '{"28065": 82.76, "28091": 17.24}',
    density: 14.8,
    imprecise: false,
    latitude: 31.48411,
    longitude: -89.71179,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39421',
  },
  {
    city: 'Bay Springs',
    county_fips: 28061,
    county_fips_all: '28061|28129',
    county: 'Jasper',
    county_names_all: 'Jasper|Smith',
    county_weights: '{"28061": 71.46, "28129": 28.54}',
    density: 12.2,
    imprecise: false,
    latitude: 31.95953,
    longitude: -89.26745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39422',
  },
  {
    city: 'Beaumont',
    county_fips: 28111,
    county_fips_all: '28111|28041',
    county: 'Perry',
    county_names_all: 'Perry|Greene',
    county_weights: '{"28111": 97.37, "28041": 2.63}',
    density: 10.5,
    imprecise: false,
    latitude: 31.17553,
    longitude: -88.91103,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39423',
  },
  {
    city: 'Brooklyn',
    county_fips: 28111,
    county_fips_all: '28111|28035',
    county: 'Perry',
    county_names_all: 'Perry|Forrest',
    county_weights: '{"28111": 79.47, "28035": 20.53}',
    density: 3.5,
    imprecise: false,
    latitude: 31.05633,
    longitude: -89.06322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39425',
  },
  {
    city: 'Carriere',
    county_fips: 28109,
    county_fips_all: '28109|28045',
    county: 'Pearl River',
    county_names_all: 'Pearl River|Hancock',
    county_weights: '{"28109": 89.75, "28045": 10.25}',
    density: 39.6,
    imprecise: false,
    latitude: 30.65375,
    longitude: -89.65709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39426',
  },
  {
    city: 'Carson',
    county_fips: 28065,
    county_fips_all: '28065',
    county: 'Jefferson Davis',
    county_names_all: 'Jefferson Davis',
    county_weights: '{"28065": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 31.48693,
    longitude: -89.82701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39427',
  },
  {
    city: 'Collins',
    county_fips: 28031,
    county_fips_all: '28031',
    county: 'Covington',
    county_names_all: 'Covington',
    county_weights: '{"28031": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 31.65017,
    longitude: -89.57215,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39428',
  },
  {
    city: 'Columbia',
    county_fips: 28091,
    county_fips_all: '28091|28073|28065',
    county: 'Marion',
    county_names_all: 'Marion|Lamar|Jefferson Davis',
    county_weights: '{"28091": 95.96, "28073": 2.69, "28065": 1.35}',
    density: 21.1,
    imprecise: false,
    latitude: 31.25052,
    longitude: -89.76337,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39429',
  },
  {
    city: 'Ellisville',
    county_fips: 28067,
    county_fips_all: '28067',
    county: 'Jones',
    county_names_all: 'Jones',
    county_weights: '{"28067": 100}',
    density: 28.5,
    imprecise: false,
    latitude: 31.57883,
    longitude: -89.21981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39437',
  },
  {
    city: 'Heidelberg',
    county_fips: 28061,
    county_fips_all: '28061|28067|28023|28153',
    county: 'Jasper',
    county_names_all: 'Jasper|Jones|Clarke|Wayne',
    county_weights:
      '{"28061": 67.13, "28067": 19.03, "28023": 6.96, "28153": 6.88}',
    density: 14.6,
    imprecise: false,
    latitude: 31.85865,
    longitude: -89.00227,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39439',
  },
  {
    city: 'Laurel',
    county_fips: 28067,
    county_fips_all: '28067',
    county: 'Jones',
    county_names_all: 'Jones',
    county_weights: '{"28067": 100}',
    density: 422.9,
    imprecise: false,
    latitude: 31.694,
    longitude: -89.14791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39440',
  },
  {
    city: 'Laurel',
    county_fips: 28067,
    county_fips_all: '28067|28153|28061',
    county: 'Jones',
    county_names_all: 'Jones|Wayne|Jasper',
    county_weights: '{"28067": 68.43, "28153": 17.53, "28061": 14.04}',
    density: 30.1,
    imprecise: false,
    latitude: 31.71932,
    longitude: -89.07376,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39443',
  },
  {
    city: 'Leakesville',
    county_fips: 28041,
    county_fips_all: '28041',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"28041": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 31.16722,
    longitude: -88.61757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39451',
  },
  {
    city: 'Lucedale',
    county_fips: 28039,
    county_fips_all: '28039|28041|28059',
    county: 'George',
    county_names_all: 'George|Greene|Jackson',
    county_weights: '{"28039": 71.96, "28041": 16.72, "28059": 11.32}',
    density: 21.1,
    imprecise: false,
    latitude: 30.88002,
    longitude: -88.59097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39452',
  },
  {
    city: 'Lumberton',
    county_fips: 28073,
    county_fips_all: '28073|28109|28035|28131|28091',
    county: 'Lamar',
    county_names_all: 'Lamar|Pearl River|Forrest|Stone|Marion',
    county_weights:
      '{"28073": 45.91, "28109": 31.17, "28035": 10.67, "28131": 8.47, "28091": 3.78}',
    density: 8.3,
    imprecise: false,
    latitude: 31.01084,
    longitude: -89.46931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39455',
  },
  {
    city: 'McLain',
    county_fips: 28041,
    county_fips_all: '28041|28111|28039',
    county: 'Greene',
    county_names_all: 'Greene|Perry|George',
    county_weights: '{"28041": 46.35, "28111": 29.7, "28039": 23.95}',
    density: 3.4,
    imprecise: false,
    latitude: 31.0282,
    longitude: -88.81819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39456',
  },
  {
    city: 'Moselle',
    county_fips: 28067,
    county_fips_all: '28067',
    county: 'Jones',
    county_names_all: 'Jones',
    county_weights: '{"28067": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 31.49021,
    longitude: -89.30216,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39459',
  },
  {
    city: 'Neely',
    county_fips: 28041,
    county_fips_all: '28041',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"28041": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 31.18703,
    longitude: -88.73992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39461',
  },
  {
    city: 'New Augusta',
    county_fips: 28111,
    county_fips_all: '28111',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"28111": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 31.22105,
    longitude: -89.05738,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39462',
  },
  {
    city: 'Ovett',
    county_fips: 28067,
    county_fips_all: '28067|28111',
    county: 'Jones',
    county_names_all: 'Jones|Perry',
    county_weights: '{"28067": 84.33, "28111": 15.67}',
    density: 8.6,
    imprecise: false,
    latitude: 31.49268,
    longitude: -89.06129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39464',
  },
  {
    city: 'Petal',
    county_fips: 28035,
    county_fips_all: '28035|28111|28067',
    county: 'Forrest',
    county_names_all: 'Forrest|Perry|Jones',
    county_weights: '{"28035": 76.58, "28111": 22.84, "28067": 0.58}',
    density: 72,
    imprecise: false,
    latitude: 31.34456,
    longitude: -89.18751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39465',
  },
  {
    city: 'Picayune',
    county_fips: 28109,
    county_fips_all: '28109|28045',
    county: 'Pearl River',
    county_names_all: 'Pearl River|Hancock',
    county_weights: '{"28109": 63.33, "28045": 36.67}',
    density: 70.8,
    imprecise: false,
    latitude: 30.53328,
    longitude: -89.63424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39466',
  },
  {
    city: 'Poplarville',
    county_fips: 28109,
    county_fips_all: '28109|28045|28131',
    county: 'Pearl River',
    county_names_all: 'Pearl River|Hancock|Stone',
    county_weights: '{"28109": 98.8, "28045": 1.08, "28131": 0.12}',
    density: 12.5,
    imprecise: false,
    latitude: 30.81602,
    longitude: -89.57581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39470',
  },
  {
    city: 'Prentiss',
    county_fips: 28065,
    county_fips_all: '28065|28031',
    county: 'Jefferson Davis',
    county_names_all: 'Jefferson Davis|Covington',
    county_weights: '{"28065": 99.36, "28031": 0.64}',
    density: 15.3,
    imprecise: false,
    latitude: 31.61739,
    longitude: -89.85458,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39474',
  },
  {
    city: 'Purvis',
    county_fips: 28073,
    county_fips_all: '28073|28035',
    county: 'Lamar',
    county_names_all: 'Lamar|Forrest',
    county_weights: '{"28073": 82.94, "28035": 17.06}',
    density: 35.4,
    imprecise: false,
    latitude: 31.15496,
    longitude: -89.4129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39475',
  },
  {
    city: 'Richton',
    county_fips: 28111,
    county_fips_all: '28111|28041|28153|28067',
    county: 'Perry',
    county_names_all: 'Perry|Greene|Wayne|Jones',
    county_weights:
      '{"28111": 41.87, "28041": 32.77, "28153": 19.64, "28067": 5.72}',
    density: 6.1,
    imprecise: false,
    latitude: 31.37855,
    longitude: -88.86764,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39476',
  },
  {
    city: 'Sandersville',
    county_fips: 28067,
    county_fips_all: '28067',
    county: 'Jones',
    county_names_all: 'Jones',
    county_weights: '{"28067": 100}',
    density: 28.6,
    imprecise: false,
    latitude: 31.79291,
    longitude: -89.03579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39477',
  },
  {
    city: 'Sandy Hook',
    county_fips: 28091,
    county_fips_all: '28091|28147',
    county: 'Marion',
    county_names_all: 'Marion|Walthall',
    county_weights: '{"28091": 54.07, "28147": 45.93}',
    density: 10.7,
    imprecise: false,
    latitude: 31.05306,
    longitude: -89.85768,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39478',
  },
  {
    city: 'Seminary',
    county_fips: 28031,
    county_fips_all: '28031|28067',
    county: 'Covington',
    county_names_all: 'Covington|Jones',
    county_weights: '{"28031": 86.88, "28067": 13.12}',
    density: 17.1,
    imprecise: false,
    latitude: 31.53775,
    longitude: -89.46065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39479',
  },
  {
    city: 'Soso',
    county_fips: 28067,
    county_fips_all: '28067|28061',
    county: 'Jones',
    county_names_all: 'Jones|Jasper',
    county_weights: '{"28067": 95.42, "28061": 4.58}',
    density: 16.3,
    imprecise: false,
    latitude: 31.70889,
    longitude: -89.31529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39480',
  },
  {
    city: 'Stringer',
    county_fips: 28061,
    county_fips_all: '28061|28129',
    county: 'Jasper',
    county_names_all: 'Jasper|Smith',
    county_weights: '{"28061": 98.69, "28129": 1.31}',
    density: 16.1,
    imprecise: false,
    latitude: 31.86738,
    longitude: -89.24457,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39481',
  },
  {
    city: 'Sumrall',
    county_fips: 28073,
    county_fips_all: '28073|28065|28031|28091',
    county: 'Lamar',
    county_names_all: 'Lamar|Jefferson Davis|Covington|Marion',
    county_weights:
      '{"28073": 69.07, "28065": 15.76, "28031": 9.37, "28091": 5.8}',
    density: 24.7,
    imprecise: false,
    latitude: 31.37271,
    longitude: -89.57966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39482',
  },
  {
    city: 'Foxworth',
    county_fips: 28091,
    county_fips_all: '28091|28147',
    county: 'Marion',
    county_names_all: 'Marion|Walthall',
    county_weights: '{"28091": 96.69, "28147": 3.31}',
    density: 13.3,
    imprecise: false,
    latitude: 31.23515,
    longitude: -89.92674,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39483',
  },
  {
    city: 'Gulfport',
    county_fips: 28047,
    county_fips_all: '28047',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"28047": 100}',
    density: 606.8,
    imprecise: false,
    latitude: 30.3857,
    longitude: -89.10309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39501',
  },
  {
    city: 'Gulfport',
    county_fips: 28047,
    county_fips_all: '28047',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"28047": 100}',
    density: 186,
    imprecise: false,
    latitude: 30.47432,
    longitude: -89.14752,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39503',
  },
  {
    city: 'Gulfport',
    county_fips: 28047,
    county_fips_all: '28047',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"28047": 100}',
    density: 872,
    imprecise: false,
    latitude: 30.39945,
    longitude: -89.03628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39507',
  },
  {
    city: 'Bay Saint Louis',
    county_fips: 28045,
    county_fips_all: '28045',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"28045": 100}',
    density: 62,
    imprecise: false,
    latitude: 30.26885,
    longitude: -89.47132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39520',
  },
  {
    city: 'Diamondhead',
    county_fips: 28045,
    county_fips_all: '28045',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"28045": 100}',
    density: 344.3,
    imprecise: false,
    latitude: 30.38123,
    longitude: -89.37065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39525',
  },
  {
    city: 'Biloxi',
    county_fips: 28047,
    county_fips_all: '28047',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"28047": 100}',
    density: 660.6,
    imprecise: false,
    latitude: 30.40344,
    longitude: -88.89165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39530',
  },
  {
    city: 'Biloxi',
    county_fips: 28047,
    county_fips_all: '28047',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"28047": 100}',
    density: 1100.1,
    imprecise: false,
    latitude: 30.40459,
    longitude: -88.96735,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39531',
  },
  {
    city: 'Biloxi',
    county_fips: 28047,
    county_fips_all: '28047|28059',
    county: 'Harrison',
    county_names_all: 'Harrison|Jackson',
    county_weights: '{"28047": 89.89, "28059": 10.11}',
    density: 172.2,
    imprecise: false,
    latitude: 30.50155,
    longitude: -88.97454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39532',
  },
  {
    city: 'Biloxi',
    county_fips: 28047,
    county_fips_all: '28047',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"28047": 100}',
    density: 409.3,
    imprecise: false,
    latitude: 30.40856,
    longitude: -88.92122,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39534',
  },
  {
    city: 'Diberville',
    county_fips: 28047,
    county_fips_all: '28047',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"28047": 100}',
    density: 447.8,
    imprecise: false,
    latitude: 30.47108,
    longitude: -88.90088,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39540',
  },
  {
    city: 'Gautier',
    county_fips: 28059,
    county_fips_all: '28059',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"28059": 100}',
    density: 235.3,
    imprecise: false,
    latitude: 30.41625,
    longitude: -88.64848,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39553',
  },
  {
    city: 'Kiln',
    county_fips: 28045,
    county_fips_all: '28045',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"28045": 100}',
    density: 22.7,
    imprecise: false,
    latitude: 30.44457,
    longitude: -89.42747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39556',
  },
  {
    city: 'Long Beach',
    county_fips: 28047,
    county_fips_all: '28047',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"28047": 100}',
    density: 356.4,
    imprecise: false,
    latitude: 30.37356,
    longitude: -89.17356,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39560',
  },
  {
    city: 'McHenry',
    county_fips: 28131,
    county_fips_all: '28131',
    county: 'Stone',
    county_names_all: 'Stone',
    county_weights: '{"28131": 100}',
    density: 29,
    imprecise: false,
    latitude: 30.70633,
    longitude: -89.16049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39561',
  },
  {
    city: 'Moss Point',
    county_fips: 28059,
    county_fips_all: '28059',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"28059": 100}',
    density: 31.9,
    imprecise: false,
    latitude: 30.54573,
    longitude: -88.49039,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39562',
  },
  {
    city: 'Moss Point',
    county_fips: 28059,
    county_fips_all: '28059',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"28059": 100}',
    density: 231.1,
    imprecise: false,
    latitude: 30.42449,
    longitude: -88.52601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39563',
  },
  {
    city: 'Ocean Springs',
    county_fips: 28059,
    county_fips_all: '28059',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"28059": 100}',
    density: 313.4,
    imprecise: false,
    latitude: 30.40518,
    longitude: -88.75471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39564',
  },
  {
    city: 'Vancleave',
    county_fips: 28059,
    county_fips_all: '28059|28047',
    county: 'Jackson',
    county_names_all: 'Jackson|Harrison',
    county_weights: '{"28059": 96.24, "28047": 3.76}',
    density: 29.5,
    imprecise: false,
    latitude: 30.5759,
    longitude: -88.75207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39565',
  },
  {
    city: 'Pascagoula',
    county_fips: 28059,
    county_fips_all: '28059',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"28059": 100}',
    density: 623.4,
    imprecise: false,
    latitude: 30.36192,
    longitude: -88.55254,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39567',
  },
  {
    city: 'Pass Christian',
    county_fips: 28047,
    county_fips_all: '28047|28045',
    county: 'Harrison',
    county_names_all: 'Harrison|Hancock',
    county_weights: '{"28047": 95.71, "28045": 4.29}',
    density: 66.1,
    imprecise: false,
    latitude: 30.41662,
    longitude: -89.28125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39571',
  },
  {
    city: 'Pearlington',
    county_fips: 28045,
    county_fips_all: '28045',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"28045": 100}',
    density: 47.4,
    imprecise: false,
    latitude: 30.25089,
    longitude: -89.60127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39572',
  },
  {
    city: 'Perkinston',
    county_fips: 28131,
    county_fips_all: '28131|28039|28045|28059|28109|28047',
    county: 'Stone',
    county_names_all: 'Stone|George|Hancock|Jackson|Pearl River|Harrison',
    county_weights:
      '{"28131": 58.82, "28039": 16.09, "28045": 11.58, "28059": 8.15, "28109": 2.82, "28047": 2.54}',
    density: 10.3,
    imprecise: false,
    latitude: 30.72692,
    longitude: -89.08271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39573',
  },
  {
    city: 'Saucier',
    county_fips: 28047,
    county_fips_all: '28047|28131',
    county: 'Harrison',
    county_names_all: 'Harrison|Stone',
    county_weights: '{"28047": 98.49, "28131": 1.51}',
    density: 24.5,
    imprecise: false,
    latitude: 30.60912,
    longitude: -89.10489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39574',
  },
  {
    city: 'Waveland',
    county_fips: 28045,
    county_fips_all: '28045',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"28045": 100}',
    density: 378.2,
    imprecise: false,
    latitude: 30.28699,
    longitude: -89.38511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39576',
  },
  {
    city: 'Wiggins',
    county_fips: 28131,
    county_fips_all: '28131|28111|28035',
    county: 'Stone',
    county_names_all: 'Stone|Perry|Forrest',
    county_weights: '{"28131": 54.84, "28111": 28.46, "28035": 16.7}',
    density: 15.6,
    imprecise: false,
    latitude: 30.90213,
    longitude: -89.07971,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39577',
  },
  {
    city: 'Pascagoula',
    county_fips: 28059,
    county_fips_all: '28059',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"28059": 100}',
    density: 314,
    imprecise: false,
    latitude: 30.35048,
    longitude: -88.49324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39581',
  },
  {
    city: 'Brookhaven',
    county_fips: 28085,
    county_fips_all: '28085|28037',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Franklin',
    county_weights: '{"28085": 90.56, "28037": 9.44}',
    density: 34.4,
    imprecise: false,
    latitude: 31.56548,
    longitude: -90.47762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39601',
  },
  {
    city: 'Bogue Chitto',
    county_fips: 28085,
    county_fips_all: '28085',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"28085": 100}',
    density: 15,
    imprecise: false,
    latitude: 31.43729,
    longitude: -90.45737,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39629',
  },
  {
    city: 'Bude',
    county_fips: 28037,
    county_fips_all: '28037',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"28037": 100}',
    density: 111.9,
    imprecise: false,
    latitude: 31.45939,
    longitude: -90.84544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39630',
  },
  {
    city: 'Centreville',
    county_fips: 28157,
    county_fips_all: '28157|28005',
    county: 'Wilkinson',
    county_names_all: 'Wilkinson|Amite',
    county_weights: '{"28157": 69.63, "28005": 30.37}',
    density: 11.1,
    imprecise: false,
    latitude: 31.07321,
    longitude: -91.09581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39631',
  },
  {
    city: 'Crosby',
    county_fips: 28157,
    county_fips_all: '28157|28005',
    county: 'Wilkinson',
    county_names_all: 'Wilkinson|Amite',
    county_weights: '{"28157": 90.18, "28005": 9.82}',
    density: 2.6,
    imprecise: false,
    latitude: 31.287,
    longitude: -91.16663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39633',
  },
  {
    city: 'Fernwood',
    county_fips: 28113,
    county_fips_all: '28113',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"28113": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.18432,
    longitude: -90.44859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39635',
  },
  {
    city: 'Gloster',
    county_fips: 28005,
    county_fips_all: '28005|28157',
    county: 'Amite',
    county_names_all: 'Amite|Wilkinson',
    county_weights: '{"28005": 83.28, "28157": 16.72}',
    density: 6.8,
    imprecise: false,
    latitude: 31.22378,
    longitude: -90.99747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39638',
  },
  {
    city: 'Jayess',
    county_fips: 28077,
    county_fips_all: '28077|28147|28113|28085',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Walthall|Pike|Lincoln',
    county_weights:
      '{"28077": 50.88, "28147": 40.56, "28113": 6.26, "28085": 2.3}',
    density: 18.6,
    imprecise: false,
    latitude: 31.35717,
    longitude: -90.17042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39641',
  },
  {
    city: 'Kokomo',
    county_fips: 28091,
    county_fips_all: '28091|28147',
    county: 'Marion',
    county_names_all: 'Marion|Walthall',
    county_weights: '{"28091": 73.77, "28147": 26.23}',
    density: 13.3,
    imprecise: false,
    latitude: 31.24575,
    longitude: -90.01368,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39643',
  },
  {
    city: 'Liberty',
    county_fips: 28005,
    county_fips_all: '28005',
    county: 'Amite',
    county_names_all: 'Amite',
    county_weights: '{"28005": 100}',
    density: 5,
    imprecise: false,
    latitude: 31.1485,
    longitude: -90.79399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39645',
  },
  {
    city: 'McCall Creek',
    county_fips: 28037,
    county_fips_all: '28037|28085',
    county: 'Franklin',
    county_names_all: 'Franklin|Lincoln',
    county_weights: '{"28037": 95.44, "28085": 4.56}',
    density: 4.3,
    imprecise: false,
    latitude: 31.51498,
    longitude: -90.7143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39647',
  },
  {
    city: 'Mccomb',
    county_fips: 28113,
    county_fips_all: '28113',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"28113": 100}',
    density: 73.3,
    imprecise: false,
    latitude: 31.18611,
    longitude: -90.38804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39648',
  },
  {
    city: 'Magnolia',
    county_fips: 28113,
    county_fips_all: '28113|28005',
    county: 'Pike',
    county_names_all: 'Pike|Amite',
    county_weights: '{"28113": 72.59, "28005": 27.41}',
    density: 17.9,
    imprecise: false,
    latitude: 31.11034,
    longitude: -90.46701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39652',
  },
  {
    city: 'Meadville',
    county_fips: 28037,
    county_fips_all: '28037|28063|28005',
    county: 'Franklin',
    county_names_all: 'Franklin|Jefferson|Amite',
    county_weights: '{"28037": 94.21, "28063": 3.9, "28005": 1.89}',
    density: 5.5,
    imprecise: false,
    latitude: 31.46055,
    longitude: -90.86727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39653',
  },
  {
    city: 'Monticello',
    county_fips: 28077,
    county_fips_all: '28077|28085',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Lincoln',
    county_weights: '{"28077": 96.82, "28085": 3.18}',
    density: 11.7,
    imprecise: false,
    latitude: 31.53716,
    longitude: -90.13831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39654',
  },
  {
    city: 'Oak Vale',
    county_fips: 28065,
    county_fips_all: '28065|28077',
    county: 'Jefferson Davis',
    county_names_all: 'Jefferson Davis|Lawrence',
    county_weights: '{"28065": 76.17, "28077": 23.83}',
    density: 4.8,
    imprecise: false,
    latitude: 31.45055,
    longitude: -89.92843,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39656',
  },
  {
    city: 'Osyka',
    county_fips: 28113,
    county_fips_all: '28113|28005|28147',
    county: 'Pike',
    county_names_all: 'Pike|Amite|Walthall',
    county_weights: '{"28113": 57.63, "28005": 42.1, "28147": 0.27}',
    density: 7.2,
    imprecise: false,
    latitude: 31.02727,
    longitude: -90.50334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39657',
  },
  {
    city: 'Roxie',
    county_fips: 28037,
    county_fips_all: '28037|28001|28063',
    county: 'Franklin',
    county_names_all: 'Franklin|Adams|Jefferson',
    county_weights: '{"28037": 83.28, "28001": 16.6, "28063": 0.12}',
    density: 3.5,
    imprecise: false,
    latitude: 31.48704,
    longitude: -91.07952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39661',
  },
  {
    city: 'Ruth',
    county_fips: 28085,
    county_fips_all: '28085|28113|28077',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Pike|Lawrence',
    county_weights: '{"28085": 65.92, "28113": 26.84, "28077": 7.24}',
    density: 11.6,
    imprecise: false,
    latitude: 31.38778,
    longitude: -90.29838,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39662',
  },
  {
    city: 'Silver Creek',
    county_fips: 28077,
    county_fips_all: '28077|28065',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Jefferson Davis',
    county_weights: '{"28077": 93.25, "28065": 6.75}',
    density: 7.6,
    imprecise: false,
    latitude: 31.58615,
    longitude: -90.02955,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39663',
  },
  {
    city: 'Smithdale',
    county_fips: 28005,
    county_fips_all: '28005|28037|28085',
    county: 'Amite',
    county_names_all: 'Amite|Franklin|Lincoln',
    county_weights: '{"28005": 58.32, "28037": 31.76, "28085": 9.92}',
    density: 8.8,
    imprecise: false,
    latitude: 31.32894,
    longitude: -90.68252,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39664',
  },
  {
    city: 'Sontag',
    county_fips: 28077,
    county_fips_all: '28077|28085',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Lincoln',
    county_weights: '{"28077": 75.08, "28085": 24.92}',
    density: 4.9,
    imprecise: false,
    latitude: 31.64125,
    longitude: -90.21404,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39665',
  },
  {
    city: 'Summit',
    county_fips: 28113,
    county_fips_all: '28113|28005|28085',
    county: 'Pike',
    county_names_all: 'Pike|Amite|Lincoln',
    county_weights: '{"28113": 59.51, "28005": 30.1, "28085": 10.39}',
    density: 26.9,
    imprecise: false,
    latitude: 31.2853,
    longitude: -90.48857,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39666',
  },
  {
    city: 'Tylertown',
    county_fips: 28147,
    county_fips_all: '28147|28113|28091',
    county: 'Walthall',
    county_names_all: 'Walthall|Pike|Marion',
    county_weights: '{"28147": 93.72, "28113": 4.13, "28091": 2.15}',
    density: 12.8,
    imprecise: false,
    latitude: 31.1298,
    longitude: -90.12656,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39667',
  },
  {
    city: 'Union Church',
    county_fips: 28063,
    county_fips_all: '28063|28085|28037|28029',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Lincoln|Franklin|Copiah',
    county_weights:
      '{"28063": 81.43, "28085": 15.91, "28037": 2.1, "28029": 0.55}',
    density: 4.6,
    imprecise: false,
    latitude: 31.69126,
    longitude: -90.79126,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39668',
  },
  {
    city: 'Woodville',
    county_fips: 28157,
    county_fips_all: '28157',
    county: 'Wilkinson',
    county_names_all: 'Wilkinson',
    county_weights: '{"28157": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 31.14966,
    longitude: -91.39547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39669',
  },
  {
    city: 'Columbus',
    county_fips: 28087,
    county_fips_all: '28087',
    county: 'Lowndes',
    county_names_all: 'Lowndes',
    county_weights: '{"28087": 100}',
    density: 24.2,
    imprecise: false,
    latitude: 33.41091,
    longitude: -88.50807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39701',
  },
  {
    city: 'Columbus',
    county_fips: 28087,
    county_fips_all: '28087',
    county: 'Lowndes',
    county_names_all: 'Lowndes',
    county_weights: '{"28087": 100}',
    density: 90.7,
    imprecise: false,
    latitude: 33.43876,
    longitude: -88.34493,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39702',
  },
  {
    city: 'Columbus',
    county_fips: 28087,
    county_fips_all: '28087',
    county: 'Lowndes',
    county_names_all: 'Lowndes',
    county_weights: '{"28087": 100}',
    density: 73.4,
    imprecise: false,
    latitude: 33.58669,
    longitude: -88.43705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39705',
  },
  {
    city: 'Aberdeen',
    county_fips: 28095,
    county_fips_all: '28095',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"28095": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 33.83926,
    longitude: -88.56267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39730',
  },
  {
    city: 'Ackerman',
    county_fips: 28019,
    county_fips_all: '28019',
    county: 'Choctaw',
    county_names_all: 'Choctaw',
    county_weights: '{"28019": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 33.34511,
    longitude: -89.18998,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39735',
  },
  {
    city: 'Artesia',
    county_fips: 28087,
    county_fips_all: '28087',
    county: 'Lowndes',
    county_names_all: 'Lowndes',
    county_weights: '{"28087": 100}',
    density: 207.5,
    imprecise: false,
    latitude: 33.4169,
    longitude: -88.64178,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39736',
  },
  {
    city: 'Bellefontaine',
    county_fips: 28155,
    county_fips_all: '28155',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"28155": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 33.65211,
    longitude: -89.33573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39737',
  },
  {
    city: 'Brooksville',
    county_fips: 28103,
    county_fips_all: '28103',
    county: 'Noxubee',
    county_names_all: 'Noxubee',
    county_weights: '{"28103": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 33.23843,
    longitude: -88.57855,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39739',
  },
  {
    city: 'Caledonia',
    county_fips: 28087,
    county_fips_all: '28087|28095',
    county: 'Lowndes',
    county_names_all: 'Lowndes|Monroe',
    county_weights: '{"28087": 68.23, "28095": 31.77}',
    density: 29.8,
    imprecise: false,
    latitude: 33.71668,
    longitude: -88.31287,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39740',
  },
  {
    city: 'Cedarbluff',
    county_fips: 28025,
    county_fips_all: '28025',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"28025": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 33.65254,
    longitude: -88.85536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39741',
  },
  {
    city: 'Crawford',
    county_fips: 28087,
    county_fips_all: '28087|28105|28103',
    county: 'Lowndes',
    county_names_all: 'Lowndes|Oktibbeha|Noxubee',
    county_weights: '{"28087": 71.69, "28105": 22.65, "28103": 5.66}',
    density: 9.5,
    imprecise: false,
    latitude: 33.31913,
    longitude: -88.61308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39743',
  },
  {
    city: 'Eupora',
    county_fips: 28155,
    county_fips_all: '28155|28019|28013',
    county: 'Webster',
    county_names_all: 'Webster|Choctaw|Calhoun',
    county_weights: '{"28155": 78.93, "28019": 15.94, "28013": 5.13}',
    density: 8.4,
    imprecise: false,
    latitude: 33.58344,
    longitude: -89.30374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39744',
  },
  {
    city: 'French Camp',
    county_fips: 28007,
    county_fips_all: '28007|28019|28097',
    county: 'Attala',
    county_names_all: 'Attala|Choctaw|Montgomery',
    county_weights: '{"28007": 37.14, "28019": 35.15, "28097": 27.7}',
    density: 5.4,
    imprecise: false,
    latitude: 33.29984,
    longitude: -89.46277,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39745',
  },
  {
    city: 'Hamilton',
    county_fips: 28095,
    county_fips_all: '28095',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"28095": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 33.74697,
    longitude: -88.41544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39746',
  },
  {
    city: 'Kilmichael',
    county_fips: 28097,
    county_fips_all: '28097',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"28097": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 33.42283,
    longitude: -89.5538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39747',
  },
  {
    city: 'Maben',
    county_fips: 28155,
    county_fips_all: '28155|28105|28025|28019',
    county: 'Webster',
    county_names_all: 'Webster|Oktibbeha|Clay|Choctaw',
    county_weights:
      '{"28155": 46.06, "28105": 40.32, "28025": 10.82, "28019": 2.8}',
    density: 16.6,
    imprecise: false,
    latitude: 33.56331,
    longitude: -89.05751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39750',
  },
  {
    city: 'Mantee',
    county_fips: 28155,
    county_fips_all: '28155|28025|28017',
    county: 'Webster',
    county_names_all: 'Webster|Clay|Chickasaw',
    county_weights: '{"28155": 67.12, "28025": 20.76, "28017": 12.12}',
    density: 7,
    imprecise: false,
    latitude: 33.70444,
    longitude: -89.10004,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39751',
  },
  {
    city: 'Mathiston',
    county_fips: 28019,
    county_fips_all: '28019|28155',
    county: 'Choctaw',
    county_names_all: 'Choctaw|Webster',
    county_weights: '{"28019": 66.56, "28155": 33.44}',
    density: 12.3,
    imprecise: false,
    latitude: 33.5198,
    longitude: -89.15427,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39752',
  },
  {
    city: 'Mayhew',
    county_fips: 28087,
    county_fips_all: '28087',
    county: 'Lowndes',
    county_names_all: 'Lowndes',
    county_weights: '{"28087": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.48441,
    longitude: -88.63052,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39753',
  },
  {
    city: 'Pheba',
    county_fips: 28025,
    county_fips_all: '28025|28105',
    county: 'Clay',
    county_names_all: 'Clay|Oktibbeha',
    county_weights: '{"28025": 80.15, "28105": 19.85}',
    density: 3.8,
    imprecise: false,
    latitude: 33.61275,
    longitude: -88.95138,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39755',
  },
  {
    city: 'Prairie',
    county_fips: 28025,
    county_fips_all: '28025|28095|28017',
    county: 'Clay',
    county_names_all: 'Clay|Monroe|Chickasaw',
    county_weights: '{"28025": 46.12, "28095": 39.78, "28017": 14.11}',
    density: 11.8,
    imprecise: false,
    latitude: 33.78356,
    longitude: -88.74266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39756',
  },
  {
    city: 'Starkville',
    county_fips: 28105,
    county_fips_all: '28105|28087',
    county: 'Oktibbeha',
    county_names_all: 'Oktibbeha|Lowndes',
    county_weights: '{"28105": 97.36, "28087": 2.64}',
    density: 51,
    imprecise: false,
    latitude: 33.43491,
    longitude: -88.82631,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39759',
  },
  {
    city: 'Mississippi State',
    county_fips: 28105,
    county_fips_all: '28105',
    county: 'Oktibbeha',
    county_names_all: 'Oktibbeha',
    county_weights: '{"28105": 100}',
    density: 1596.8,
    imprecise: false,
    latitude: 33.44648,
    longitude: -88.79576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39762',
  },
  {
    city: 'Steens',
    county_fips: 28087,
    county_fips_all: '28087',
    county: 'Lowndes',
    county_names_all: 'Lowndes',
    county_weights: '{"28087": 100}',
    density: 28.8,
    imprecise: false,
    latitude: 33.5876,
    longitude: -88.31598,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39766',
  },
  {
    city: 'Stewart',
    county_fips: 28155,
    county_fips_all: '28155|28019|28097',
    county: 'Webster',
    county_names_all: 'Webster|Choctaw|Montgomery',
    county_weights: '{"28155": 53.62, "28019": 26.47, "28097": 19.91}',
    density: 2.6,
    imprecise: false,
    latitude: 33.47263,
    longitude: -89.45001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39767',
  },
  {
    city: 'Sturgis',
    county_fips: 28105,
    county_fips_all: '28105|28159|28019',
    county: 'Oktibbeha',
    county_names_all: 'Oktibbeha|Winston|Choctaw',
    county_weights: '{"28105": 57.88, "28159": 36.74, "28019": 5.38}',
    density: 4.6,
    imprecise: false,
    latitude: 33.31867,
    longitude: -89.01136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39769',
  },
  {
    city: 'Walthall',
    county_fips: 28155,
    county_fips_all: '28155',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"28155": 100}',
    density: 50.7,
    imprecise: false,
    latitude: 33.60694,
    longitude: -89.27873,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39771',
  },
  {
    city: 'Weir',
    county_fips: 28019,
    county_fips_all: '28019|28007|28159',
    county: 'Choctaw',
    county_names_all: 'Choctaw|Attala|Winston',
    county_weights: '{"28019": 92.31, "28007": 5.06, "28159": 2.63}',
    density: 9.4,
    imprecise: false,
    latitude: 33.30509,
    longitude: -89.29893,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39772',
  },
  {
    city: 'West Point',
    county_fips: 28025,
    county_fips_all: '28025|28095',
    county: 'Clay',
    county_names_all: 'Clay|Monroe',
    county_weights: '{"28025": 94.86, "28095": 5.14}',
    density: 25.9,
    imprecise: false,
    latitude: 33.63892,
    longitude: -88.67558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39773',
  },
  {
    city: 'Woodland',
    county_fips: 28017,
    county_fips_all: '28017|28025',
    county: 'Chickasaw',
    county_names_all: 'Chickasaw|Clay',
    county_weights: '{"28017": 81.36, "28025": 18.64}',
    density: 6.9,
    imprecise: false,
    latitude: 33.78517,
    longitude: -89.03239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39776',
  },
  {
    city: 'Arlington',
    county_fips: 13037,
    county_fips_all: '13037|13099|13007',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Early|Baker',
    county_weights: '{"13037": 46.82, "13099": 39.8, "13007": 13.38}',
    density: 5.1,
    imprecise: false,
    latitude: 31.42631,
    longitude: -84.68361,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39813',
  },
  {
    city: 'Attapulgus',
    county_fips: 13087,
    county_fips_all: '13087',
    county: 'Decatur',
    county_names_all: 'Decatur',
    county_weights: '{"13087": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 30.74138,
    longitude: -84.4935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39815',
  },
  {
    city: 'Bainbridge',
    county_fips: 13087,
    county_fips_all: '13087',
    county: 'Decatur',
    county_names_all: 'Decatur',
    county_weights: '{"13087": 100}',
    density: 29.8,
    imprecise: false,
    latitude: 30.93953,
    longitude: -84.59132,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39817',
  },
  {
    city: 'Bainbridge',
    county_fips: 13087,
    county_fips_all: '13087',
    county: 'Decatur',
    county_names_all: 'Decatur',
    county_weights: '{"13087": 100}',
    density: 31.2,
    imprecise: false,
    latitude: 30.78485,
    longitude: -84.64297,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39819',
  },
  {
    city: 'Blakely',
    county_fips: 13099,
    county_fips_all: '13099|13201',
    county: 'Early',
    county_names_all: 'Early|Miller',
    county_weights: '{"13099": 95.24, "13201": 4.76}',
    density: 10,
    imprecise: false,
    latitude: 31.34004,
    longitude: -84.94641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39823',
  },
  {
    city: 'Bluffton',
    county_fips: 13061,
    county_fips_all: '13061|13099',
    county: 'Clay',
    county_names_all: 'Clay|Early',
    county_weights: '{"13061": 70.74, "13099": 29.26}',
    density: 4.5,
    imprecise: false,
    latitude: 31.52882,
    longitude: -84.86552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39824',
  },
  {
    city: 'Brinson',
    county_fips: 13087,
    county_fips_all: '13087|13253',
    county: 'Decatur',
    county_names_all: 'Decatur|Seminole',
    county_weights: '{"13087": 85.42, "13253": 14.58}',
    density: 7.3,
    imprecise: false,
    latitude: 30.92359,
    longitude: -84.73496,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39825',
  },
  {
    city: 'Bronwood',
    county_fips: 13273,
    county_fips_all: '13273',
    county: 'Terrell',
    county_names_all: 'Terrell',
    county_weights: '{"13273": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 31.82092,
    longitude: -84.32423,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39826',
  },
  {
    city: 'Cairo',
    county_fips: 13131,
    county_fips_all: '13131',
    county: 'Grady',
    county_names_all: 'Grady',
    county_weights: '{"13131": 100}',
    density: 26.1,
    imprecise: false,
    latitude: 30.94911,
    longitude: -84.21674,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39827',
  },
  {
    city: 'Cairo',
    county_fips: 13131,
    county_fips_all: '13131',
    county: 'Grady',
    county_names_all: 'Grady',
    county_weights: '{"13131": 100}',
    density: 43.8,
    imprecise: false,
    latitude: 30.79741,
    longitude: -84.22444,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39828',
  },
  {
    city: 'Cedar Springs',
    county_fips: 13099,
    county_fips_all: '13099',
    county: 'Early',
    county_names_all: 'Early',
    county_weights: '{"13099": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.19304,
    longitude: -85.0257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39832',
  },
  {
    city: 'Climax',
    county_fips: 13087,
    county_fips_all: '13087',
    county: 'Decatur',
    county_names_all: 'Decatur',
    county_weights: '{"13087": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 30.89298,
    longitude: -84.42749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39834',
  },
  {
    city: 'Coleman',
    county_fips: 13243,
    county_fips_all: '13243|13061',
    county: 'Randolph',
    county_names_all: 'Randolph|Clay',
    county_weights: '{"13243": 86.23, "13061": 13.77}',
    density: 2,
    imprecise: false,
    latitude: 31.66293,
    longitude: -84.87726,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39836',
  },
  {
    city: 'Colquitt',
    county_fips: 13201,
    county_fips_all: '13201|13007|13087|13099',
    county: 'Miller',
    county_names_all: 'Miller|Baker|Decatur|Early',
    county_weights:
      '{"13201": 78.2, "13007": 11.36, "13087": 10.05, "13099": 0.39}',
    density: 7.4,
    imprecise: false,
    latitude: 31.15321,
    longitude: -84.67283,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39837',
  },
  {
    city: 'Cuthbert',
    county_fips: 13243,
    county_fips_all: '13243',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"13243": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 31.78874,
    longitude: -84.75986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39840',
  },
  {
    city: 'Damascus',
    county_fips: 13099,
    county_fips_all: '13099|13007|13201',
    county: 'Early',
    county_names_all: 'Early|Baker|Miller',
    county_weights: '{"13099": 70.88, "13007": 17.43, "13201": 11.69}',
    density: 3.6,
    imprecise: false,
    latitude: 31.29031,
    longitude: -84.69124,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39841',
  },
  {
    city: 'Dawson',
    county_fips: 13273,
    county_fips_all: '13273|13037',
    county: 'Terrell',
    county_names_all: 'Terrell|Calhoun',
    county_weights: '{"13273": 99.73, "13037": 0.27}',
    density: 11.2,
    imprecise: false,
    latitude: 31.75837,
    longitude: -84.44314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39842',
  },
  {
    city: 'Donalsonville',
    county_fips: 13253,
    county_fips_all: '13253|13201|13099',
    county: 'Seminole',
    county_names_all: 'Seminole|Miller|Early',
    county_weights: '{"13253": 85.46, "13201": 14.12, "13099": 0.42}',
    density: 17,
    imprecise: false,
    latitude: 30.95011,
    longitude: -84.89329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39845',
  },
  {
    city: 'Edison',
    county_fips: 13037,
    county_fips_all: '13037|13061|13243',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Clay|Randolph',
    county_weights: '{"13037": 90.72, "13061": 8.04, "13243": 1.24}',
    density: 8.8,
    imprecise: false,
    latitude: 31.56841,
    longitude: -84.74271,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39846',
  },
  {
    city: 'Fort Gaines',
    county_fips: 13061,
    county_fips_all: '13061|13243',
    county: 'Clay',
    county_names_all: 'Clay|Randolph',
    county_weights: '{"13061": 92.05, "13243": 7.95}',
    density: 5.9,
    imprecise: false,
    latitude: 31.63432,
    longitude: -85.00086,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39851',
  },
  {
    city: 'Georgetown',
    county_fips: 13239,
    county_fips_all: '13239|13061',
    county: 'Quitman',
    county_names_all: 'Quitman|Clay',
    county_weights: '{"13239": 94.03, "13061": 5.97}',
    density: 8.2,
    imprecise: false,
    latitude: 31.86713,
    longitude: -85.04881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39854',
  },
  {
    city: 'Iron City',
    county_fips: 13253,
    county_fips_all: '13253|13201',
    county: 'Seminole',
    county_names_all: 'Seminole|Miller',
    county_weights: '{"13253": 96.74, "13201": 3.26}',
    density: 6.4,
    imprecise: false,
    latitude: 30.99493,
    longitude: -84.80731,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39859',
  },
  {
    city: 'Jakin',
    county_fips: 13099,
    county_fips_all: '13099|13253',
    county: 'Early',
    county_names_all: 'Early|Seminole',
    county_weights: '{"13099": 97.96, "13253": 2.04}',
    density: 5.5,
    imprecise: false,
    latitude: 31.13635,
    longitude: -84.9884,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39861',
  },
  {
    city: 'Leary',
    county_fips: 13037,
    county_fips_all: '13037|13007',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Baker',
    county_weights: '{"13037": 58.51, "13007": 41.49}',
    density: 2.3,
    imprecise: false,
    latitude: 31.45694,
    longitude: -84.51615,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39862',
  },
  {
    city: 'Morgan',
    county_fips: 13037,
    county_fips_all: '13037|13243',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Randolph',
    county_weights: '{"13037": 95.77, "13243": 4.23}',
    density: 13.4,
    imprecise: false,
    latitude: 31.55954,
    longitude: -84.60553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39866',
  },
  {
    city: 'Morris',
    county_fips: 13239,
    county_fips_all: '13239|13243|13061|13259',
    county: 'Quitman',
    county_names_all: 'Quitman|Randolph|Clay|Stewart',
    county_weights:
      '{"13239": 45.22, "13243": 26.59, "13061": 19.05, "13259": 9.15}',
    density: 0.5,
    imprecise: false,
    latitude: 31.84076,
    longitude: -84.93684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39867',
  },
  {
    city: 'Newton',
    county_fips: 13007,
    county_fips_all: '13007',
    county: 'Baker',
    county_names_all: 'Baker',
    county_weights: '{"13007": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 31.31944,
    longitude: -84.41071,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39870',
  },
  {
    city: 'Parrott',
    county_fips: 13273,
    county_fips_all: '13273|13307',
    county: 'Terrell',
    county_names_all: 'Terrell|Webster',
    county_weights: '{"13273": 62.88, "13307": 37.12}',
    density: 3.5,
    imprecise: false,
    latitude: 31.9183,
    longitude: -84.50647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39877',
  },
  {
    city: 'Sasser',
    county_fips: 13273,
    county_fips_all: '13273',
    county: 'Terrell',
    county_names_all: 'Terrell',
    county_weights: '{"13273": 100}',
    density: 63.8,
    imprecise: false,
    latitude: 31.72189,
    longitude: -84.34304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39885',
  },
  {
    city: 'Shellman',
    county_fips: 13243,
    county_fips_all: '13243|13273|13037',
    county: 'Randolph',
    county_names_all: 'Randolph|Terrell|Calhoun',
    county_weights: '{"13243": 92.83, "13273": 4.29, "13037": 2.88}',
    density: 5.1,
    imprecise: false,
    latitude: 31.73469,
    longitude: -84.61554,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39886',
  },
  {
    city: 'Whigham',
    county_fips: 13131,
    county_fips_all: '13131|13087',
    county: 'Grady',
    county_names_all: 'Grady|Decatur',
    county_weights: '{"13131": 92.0, "13087": 8.0}',
    density: 9.9,
    imprecise: false,
    latitude: 30.91234,
    longitude: -84.33297,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '39897',
  },
  {
    city: 'Bagdad',
    county_fips: 21211,
    county_fips_all: '21211|21073',
    county: 'Shelby',
    county_names_all: 'Shelby|Franklin',
    county_weights: '{"21211": 92.6, "21073": 7.4}',
    density: 16.1,
    imprecise: false,
    latitude: 38.26863,
    longitude: -85.04367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40003',
  },
  {
    city: 'Bardstown',
    county_fips: 21179,
    county_fips_all: '21179',
    county: 'Nelson',
    county_names_all: 'Nelson',
    county_weights: '{"21179": 100}',
    density: 81.3,
    imprecise: false,
    latitude: 37.80279,
    longitude: -85.4695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40004',
  },
  {
    city: 'Bedford',
    county_fips: 21223,
    county_fips_all: '21223|21041',
    county: 'Trimble',
    county_names_all: 'Trimble|Carroll',
    county_weights: '{"21223": 98.9, "21041": 1.1}',
    density: 21.5,
    imprecise: false,
    latitude: 38.59626,
    longitude: -85.32861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40006',
  },
  {
    city: 'Bethlehem',
    county_fips: 21103,
    county_fips_all: '21103',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"21103": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 38.4524,
    longitude: -85.00176,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40007',
  },
  {
    city: 'Bloomfield',
    county_fips: 21179,
    county_fips_all: '21179|21215',
    county: 'Nelson',
    county_names_all: 'Nelson|Spencer',
    county_weights: '{"21179": 82.05, "21215": 17.95}',
    density: 17.3,
    imprecise: false,
    latitude: 37.91735,
    longitude: -85.28097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40008',
  },
  {
    city: 'Bradfordsville',
    county_fips: 21155,
    county_fips_all: '21155|21217|21045',
    county: 'Marion',
    county_names_all: 'Marion|Taylor|Casey',
    county_weights: '{"21155": 72.7, "21217": 21.39, "21045": 5.91}',
    density: 11.1,
    imprecise: false,
    latitude: 37.47075,
    longitude: -85.099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40009',
  },
  {
    city: 'Buckner',
    county_fips: 21185,
    county_fips_all: '21185',
    county: 'Oldham',
    county_names_all: 'Oldham',
    county_weights: '{"21185": 100}',
    density: 170.7,
    imprecise: false,
    latitude: 38.37226,
    longitude: -85.45431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40010',
  },
  {
    city: 'Campbellsburg',
    county_fips: 21103,
    county_fips_all: '21103|21223|21041',
    county: 'Henry',
    county_names_all: 'Henry|Trimble|Carroll',
    county_weights: '{"21103": 71.5, "21223": 20.02, "21041": 8.48}',
    density: 17.7,
    imprecise: false,
    latitude: 38.53048,
    longitude: -85.1718,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40011',
  },
  {
    city: 'Chaplin',
    county_fips: 21179,
    county_fips_all: '21179|21005',
    county: 'Nelson',
    county_names_all: 'Nelson|Anderson',
    county_weights: '{"21179": 78.07, "21005": 21.93}',
    density: 24.8,
    imprecise: false,
    latitude: 37.90697,
    longitude: -85.17376,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40012',
  },
  {
    city: 'Coxs Creek',
    county_fips: 21179,
    county_fips_all: '21179|21215|21029',
    county: 'Nelson',
    county_names_all: 'Nelson|Spencer|Bullitt',
    county_weights: '{"21179": 76.57, "21215": 13.73, "21029": 9.7}',
    density: 34.1,
    imprecise: false,
    latitude: 37.93427,
    longitude: -85.48684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40013',
  },
  {
    city: 'Crestwood',
    county_fips: 21185,
    county_fips_all: '21185',
    county: 'Oldham',
    county_names_all: 'Oldham',
    county_weights: '{"21185": 100}',
    density: 171.3,
    imprecise: false,
    latitude: 38.3412,
    longitude: -85.43181,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40014',
  },
  {
    city: 'Eminence',
    county_fips: 21103,
    county_fips_all: '21103|21211',
    county: 'Henry',
    county_names_all: 'Henry|Shelby',
    county_weights: '{"21103": 70.92, "21211": 29.08}',
    density: 42.2,
    imprecise: false,
    latitude: 38.37416,
    longitude: -85.17437,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40019',
  },
  {
    city: 'Fairfield',
    county_fips: 21179,
    county_fips_all: '21179',
    county: 'Nelson',
    county_names_all: 'Nelson',
    county_weights: '{"21179": 100}',
    density: 161.9,
    imprecise: false,
    latitude: 37.93503,
    longitude: -85.38753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40020',
  },
  {
    city: 'Finchville',
    county_fips: 21211,
    county_fips_all: '21211',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"21211": 100}',
    density: 21.3,
    imprecise: false,
    latitude: 38.15242,
    longitude: -85.3341,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40022',
  },
  {
    city: 'Fisherville',
    county_fips: 21111,
    county_fips_all: '21111|21215|21211',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Spencer|Shelby',
    county_weights: '{"21111": 59.93, "21215": 32.36, "21211": 7.71}',
    density: 109.3,
    imprecise: false,
    latitude: 38.16264,
    longitude: -85.42367,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 6870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40023',
  },
  {
    city: 'Glenview',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 169.5,
    imprecise: false,
    latitude: 38.30133,
    longitude: -85.65202,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40025',
  },
  {
    city: 'Goshen',
    county_fips: 21185,
    county_fips_all: '21185',
    county: 'Oldham',
    county_names_all: 'Oldham',
    county_weights: '{"21185": 100}',
    density: 74.5,
    imprecise: false,
    latitude: 38.42687,
    longitude: -85.52902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40026',
  },
  {
    city: 'La Grange',
    county_fips: 21185,
    county_fips_all: '21185|21103',
    county: 'Oldham',
    county_names_all: 'Oldham|Henry',
    county_weights: '{"21185": 93.55, "21103": 6.45}',
    density: 151.6,
    imprecise: false,
    latitude: 38.42617,
    longitude: -85.39368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40031',
  },
  {
    city: 'Lebanon',
    county_fips: 21155,
    county_fips_all: '21155|21229',
    county: 'Marion',
    county_names_all: 'Marion|Washington',
    county_weights: '{"21155": 97.83, "21229": 2.17}',
    density: 32.8,
    imprecise: false,
    latitude: 37.55935,
    longitude: -85.23928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40033',
  },
  {
    city: 'Lockport',
    county_fips: 21103,
    county_fips_all: '21103',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"21103": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 38.44317,
    longitude: -84.97272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40036',
  },
  {
    city: 'Loretto',
    county_fips: 21155,
    county_fips_all: '21155|21179|21229',
    county: 'Marion',
    county_names_all: 'Marion|Nelson|Washington',
    county_weights: '{"21155": 87.97, "21179": 11.47, "21229": 0.56}',
    density: 21.5,
    imprecise: false,
    latitude: 37.65409,
    longitude: -85.41196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40037',
  },
  {
    city: 'Mackville',
    county_fips: 21229,
    county_fips_all: '21229',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"21229": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 37.77433,
    longitude: -85.05727,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40040',
  },
  {
    city: 'Milton',
    county_fips: 21223,
    county_fips_all: '21223|21041',
    county: 'Trimble',
    county_names_all: 'Trimble|Carroll',
    county_weights: '{"21223": 72.32, "21041": 27.68}',
    density: 24.1,
    imprecise: false,
    latitude: 38.69376,
    longitude: -85.35641,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40045',
  },
  {
    city: 'Mount Eden',
    county_fips: 21215,
    county_fips_all: '21215|21005|21211',
    county: 'Spencer',
    county_names_all: 'Spencer|Anderson|Shelby',
    county_weights: '{"21215": 76.18, "21005": 16.74, "21211": 7.08}',
    density: 8.8,
    imprecise: false,
    latitude: 38.02324,
    longitude: -85.17729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40046',
  },
  {
    city: 'Mount Washington',
    county_fips: 21029,
    county_fips_all: '21029|21215|21111',
    county: 'Bullitt',
    county_names_all: 'Bullitt|Spencer|Jefferson',
    county_weights: '{"21029": 95.35, "21215": 4.27, "21111": 0.38}',
    density: 305.7,
    imprecise: false,
    latitude: 38.04007,
    longitude: -85.55453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40047',
  },
  {
    city: 'New Castle',
    county_fips: 21103,
    county_fips_all: '21103',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"21103": 100}',
    density: 45.8,
    imprecise: false,
    latitude: 38.44596,
    longitude: -85.17753,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40050',
  },
  {
    city: 'New Haven',
    county_fips: 21179,
    county_fips_all: '21179|21123|21093',
    county: 'Nelson',
    county_names_all: 'Nelson|Larue|Hardin',
    county_weights: '{"21179": 68.22, "21123": 28.55, "21093": 3.23}',
    density: 19.9,
    imprecise: false,
    latitude: 37.65293,
    longitude: -85.57949,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40051',
  },
  {
    city: 'New Hope',
    county_fips: 21179,
    county_fips_all: '21179|21123|21155',
    county: 'Nelson',
    county_names_all: 'Nelson|Larue|Marion',
    county_weights: '{"21179": 44.92, "21123": 37.01, "21155": 18.07}',
    density: 11.1,
    imprecise: false,
    latitude: 37.58417,
    longitude: -85.51154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40052',
  },
  {
    city: 'Pendleton',
    county_fips: 21223,
    county_fips_all: '21223|21103|21185',
    county: 'Trimble',
    county_names_all: 'Trimble|Henry|Oldham',
    county_weights: '{"21223": 47.67, "21103": 29.58, "21185": 22.76}',
    density: 31.8,
    imprecise: false,
    latitude: 38.49889,
    longitude: -85.32867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40055',
  },
  {
    city: 'Pewee Valley',
    county_fips: 21185,
    county_fips_all: '21185',
    county: 'Oldham',
    county_names_all: 'Oldham',
    county_weights: '{"21185": 100}',
    density: 450.1,
    imprecise: false,
    latitude: 38.30654,
    longitude: -85.48784,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40056',
  },
  {
    city: 'Pleasureville',
    county_fips: 21103,
    county_fips_all: '21103|21211',
    county: 'Henry',
    county_names_all: 'Henry|Shelby',
    county_weights: '{"21103": 80.26, "21211": 19.74}',
    density: 16.6,
    imprecise: false,
    latitude: 38.38636,
    longitude: -85.0491,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40057',
  },
  {
    city: 'Port Royal',
    county_fips: 21103,
    county_fips_all: '21103',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"21103": 100}',
    density: 722.1,
    imprecise: false,
    latitude: 38.43265,
    longitude: -85.17002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40058',
  },
  {
    city: 'Prospect',
    county_fips: 21185,
    county_fips_all: '21185|21111',
    county: 'Oldham',
    county_names_all: 'Oldham|Jefferson',
    county_weights: '{"21185": 60.62, "21111": 39.38}',
    density: 286.3,
    imprecise: false,
    latitude: 38.35784,
    longitude: -85.58441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40059',
  },
  {
    city: 'Raywick',
    county_fips: 21155,
    county_fips_all: '21155',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"21155": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 37.53529,
    longitude: -85.44371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40060',
  },
  {
    city: 'Saint Francis',
    county_fips: 21155,
    county_fips_all: '21155',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"21155": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 37.59969,
    longitude: -85.43161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40062',
  },
  {
    city: 'Saint Mary',
    county_fips: 21155,
    county_fips_all: '21155',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"21155": 100}',
    density: 1679.3,
    imprecise: false,
    latitude: 37.57052,
    longitude: -85.34336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40063',
  },
  {
    city: 'Shelbyville',
    county_fips: 21211,
    county_fips_all: '21211|21215',
    county: 'Shelby',
    county_names_all: 'Shelby|Spencer',
    county_weights: '{"21211": 99.53, "21215": 0.47}',
    density: 74.1,
    imprecise: false,
    latitude: 38.21225,
    longitude: -85.20734,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40065',
  },
  {
    city: 'Simpsonville',
    county_fips: 21211,
    county_fips_all: '21211',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"21211": 100}',
    density: 56.5,
    imprecise: false,
    latitude: 38.2269,
    longitude: -85.364,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40067',
  },
  {
    city: 'Smithfield',
    county_fips: 21103,
    county_fips_all: '21103|21211|21185',
    county: 'Henry',
    county_names_all: 'Henry|Shelby|Oldham',
    county_weights: '{"21103": 68.97, "21211": 16.7, "21185": 14.33}',
    density: 23,
    imprecise: false,
    latitude: 38.38933,
    longitude: -85.27131,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40068',
  },
  {
    city: 'Springfield',
    county_fips: 21229,
    county_fips_all: '21229|21155',
    county: 'Washington',
    county_names_all: 'Washington|Marion',
    county_weights: '{"21229": 97.73, "21155": 2.27}',
    density: 16.4,
    imprecise: false,
    latitude: 37.71627,
    longitude: -85.21764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40069',
  },
  {
    city: 'Sulphur',
    county_fips: 21103,
    county_fips_all: '21103',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"21103": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 38.47969,
    longitude: -85.24405,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40070',
  },
  {
    city: 'Taylorsville',
    county_fips: 21215,
    county_fips_all: '21215|21029|21211',
    county: 'Spencer',
    county_names_all: 'Spencer|Bullitt|Shelby',
    county_weights: '{"21215": 93.87, "21029": 5.02, "21211": 1.11}',
    density: 54.9,
    imprecise: false,
    latitude: 38.04327,
    longitude: -85.37069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40071',
  },
  {
    city: 'Turners Station',
    county_fips: 21103,
    county_fips_all: '21103|21041',
    county: 'Henry',
    county_names_all: 'Henry|Carroll',
    county_weights: '{"21103": 78.81, "21041": 21.19}',
    density: 9.2,
    imprecise: false,
    latitude: 38.56169,
    longitude: -85.11346,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40075',
  },
  {
    city: 'Waddy',
    county_fips: 21211,
    county_fips_all: '21211|21005|21073|21215',
    county: 'Shelby',
    county_names_all: 'Shelby|Anderson|Franklin|Spencer',
    county_weights:
      '{"21211": 86.84, "21005": 8.59, "21073": 3.77, "21215": 0.8}',
    density: 19.6,
    imprecise: false,
    latitude: 38.11301,
    longitude: -85.08671,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40076',
  },
  {
    city: 'Westport',
    county_fips: 21185,
    county_fips_all: '21185',
    county: 'Oldham',
    county_names_all: 'Oldham',
    county_weights: '{"21185": 100}',
    density: 33.7,
    imprecise: false,
    latitude: 38.49996,
    longitude: -85.43768,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40077',
  },
  {
    city: 'Willisburg',
    county_fips: 21229,
    county_fips_all: '21229',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"21229": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 37.84272,
    longitude: -85.14902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40078',
  },
  {
    city: 'Battletown',
    county_fips: 21163,
    county_fips_all: '21163',
    county: 'Meade',
    county_names_all: 'Meade',
    county_weights: '{"21163": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 38.09012,
    longitude: -86.34053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40104',
  },
  {
    city: 'Boston',
    county_fips: 21179,
    county_fips_all: '21179',
    county: 'Nelson',
    county_names_all: 'Nelson',
    county_weights: '{"21179": 100}',
    density: 16,
    imprecise: false,
    latitude: 37.76952,
    longitude: -85.63798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40107',
  },
  {
    city: 'Brandenburg',
    county_fips: 21163,
    county_fips_all: '21163',
    county: 'Meade',
    county_names_all: 'Meade',
    county_weights: '{"21163": 100}',
    density: 71.7,
    imprecise: false,
    latitude: 37.96964,
    longitude: -86.16791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40108',
  },
  {
    city: 'Brooks',
    county_fips: 21029,
    county_fips_all: '21029|21111',
    county: 'Bullitt',
    county_names_all: 'Bullitt|Jefferson',
    county_weights: '{"21029": 97.01, "21111": 2.99}',
    density: 68.6,
    imprecise: false,
    latitude: 38.05857,
    longitude: -85.75469,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40109',
  },
  {
    city: 'Clermont',
    county_fips: 21029,
    county_fips_all: '21029',
    county: 'Bullitt',
    county_names_all: 'Bullitt',
    county_weights: '{"21029": 100}',
    density: 34,
    imprecise: false,
    latitude: 37.93478,
    longitude: -85.64015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40110',
  },
  {
    city: 'Cloverport',
    county_fips: 21027,
    county_fips_all: '21027',
    county: 'Breckinridge',
    county_names_all: 'Breckinridge',
    county_weights: '{"21027": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 37.77881,
    longitude: -86.62881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40111',
  },
  {
    city: 'Custer',
    county_fips: 21027,
    county_fips_all: '21027',
    county: 'Breckinridge',
    county_names_all: 'Breckinridge',
    county_weights: '{"21027": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 37.73784,
    longitude: -86.22707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40115',
  },
  {
    city: 'Ekron',
    county_fips: 21163,
    county_fips_all: '21163',
    county: 'Meade',
    county_names_all: 'Meade',
    county_weights: '{"21163": 100}',
    density: 37.5,
    imprecise: false,
    latitude: 37.89919,
    longitude: -86.1247,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40117',
  },
  {
    city: 'Fairdale',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 274.9,
    imprecise: false,
    latitude: 38.09805,
    longitude: -85.75572,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 10697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40118',
  },
  {
    city: 'Falls Of Rough',
    county_fips: 21027,
    county_fips_all: '21027|21085|21183',
    county: 'Breckinridge',
    county_names_all: 'Breckinridge|Grayson|Ohio',
    county_weights: '{"21027": 53.12, "21085": 42.45, "21183": 4.43}',
    density: 7.1,
    imprecise: false,
    latitude: 37.60799,
    longitude: -86.54925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40119',
  },
  {
    city: 'Fort Knox',
    county_fips: 21093,
    county_fips_all: '21093|21163',
    county: 'Hardin',
    county_names_all: 'Hardin|Meade',
    county_weights: '{"21093": 84.08, "21163": 15.92}',
    density: 96.9,
    imprecise: false,
    latitude: 37.92614,
    longitude: -85.95292,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40121',
  },
  {
    city: 'Garfield',
    county_fips: 21027,
    county_fips_all: '21027|21093',
    county: 'Breckinridge',
    county_names_all: 'Breckinridge|Hardin',
    county_weights: '{"21027": 96.5, "21093": 3.5}',
    density: 12.4,
    imprecise: false,
    latitude: 37.71867,
    longitude: -86.29047,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40140',
  },
  {
    city: 'Guston',
    county_fips: 21163,
    county_fips_all: '21163|21027',
    county: 'Meade',
    county_names_all: 'Meade|Breckinridge',
    county_weights: '{"21163": 93.55, "21027": 6.45}',
    density: 19.2,
    imprecise: false,
    latitude: 37.88898,
    longitude: -86.21095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40142',
  },
  {
    city: 'Hardinsburg',
    county_fips: 21027,
    county_fips_all: '21027',
    county: 'Breckinridge',
    county_names_all: 'Breckinridge',
    county_weights: '{"21027": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 37.78541,
    longitude: -86.50507,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40143',
  },
  {
    city: 'Harned',
    county_fips: 21027,
    county_fips_all: '21027',
    county: 'Breckinridge',
    county_names_all: 'Breckinridge',
    county_weights: '{"21027": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 37.75899,
    longitude: -86.37732,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40144',
  },
  {
    city: 'Hudson',
    county_fips: 21027,
    county_fips_all: '21027|21093',
    county: 'Breckinridge',
    county_names_all: 'Breckinridge|Hardin',
    county_weights: '{"21027": 99.84, "21093": 0.16}',
    density: 12.1,
    imprecise: false,
    latitude: 37.64607,
    longitude: -86.32019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40145',
  },
  {
    city: 'Irvington',
    county_fips: 21027,
    county_fips_all: '21027|21163',
    county: 'Breckinridge',
    county_names_all: 'Breckinridge|Meade',
    county_weights: '{"21027": 96.67, "21163": 3.33}',
    density: 18.7,
    imprecise: false,
    latitude: 37.84622,
    longitude: -86.31954,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40146',
  },
  {
    city: 'Lebanon Junction',
    county_fips: 21029,
    county_fips_all: '21029|21093',
    county: 'Bullitt',
    county_names_all: 'Bullitt|Hardin',
    county_weights: '{"21029": 96.05, "21093": 3.95}',
    density: 31.1,
    imprecise: false,
    latitude: 37.87458,
    longitude: -85.68799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40150',
  },
  {
    city: 'McDaniels',
    county_fips: 21027,
    county_fips_all: '21027',
    county: 'Breckinridge',
    county_names_all: 'Breckinridge',
    county_weights: '{"21027": 100}',
    density: 28.3,
    imprecise: false,
    latitude: 37.61389,
    longitude: -86.44185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40152',
  },
  {
    city: 'Muldraugh',
    county_fips: 21163,
    county_fips_all: '21163',
    county: 'Meade',
    county_names_all: 'Meade',
    county_weights: '{"21163": 100}',
    density: 343.9,
    imprecise: false,
    latitude: 37.94684,
    longitude: -85.99303,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40155',
  },
  {
    city: 'Payneville',
    county_fips: 21163,
    county_fips_all: '21163|21027',
    county: 'Meade',
    county_names_all: 'Meade|Breckinridge',
    county_weights: '{"21163": 89.66, "21027": 10.34}',
    density: 10.2,
    imprecise: false,
    latitude: 38.02111,
    longitude: -86.37694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40157',
  },
  {
    city: 'Radcliff',
    county_fips: 21093,
    county_fips_all: '21093',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"21093": 100}',
    density: 532.4,
    imprecise: false,
    latitude: 37.8144,
    longitude: -85.93971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40160',
  },
  {
    city: 'Rhodelia',
    county_fips: 21163,
    county_fips_all: '21163|21027',
    county: 'Meade',
    county_names_all: 'Meade|Breckinridge',
    county_weights: '{"21163": 99.16, "21027": 0.84}',
    density: 9.4,
    imprecise: false,
    latitude: 38.00422,
    longitude: -86.39887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40161',
  },
  {
    city: 'Rineyville',
    county_fips: 21093,
    county_fips_all: '21093',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"21093": 100}',
    density: 48.5,
    imprecise: false,
    latitude: 37.7517,
    longitude: -86.04394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40162',
  },
  {
    city: 'Shepherdsville',
    county_fips: 21029,
    county_fips_all: '21029',
    county: 'Bullitt',
    county_names_all: 'Bullitt',
    county_weights: '{"21029": 100}',
    density: 130.9,
    imprecise: false,
    latitude: 37.99407,
    longitude: -85.68918,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40165',
  },
  {
    city: 'Stephensport',
    county_fips: 21027,
    county_fips_all: '21027',
    county: 'Breckinridge',
    county_names_all: 'Breckinridge',
    county_weights: '{"21027": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 37.96479,
    longitude: -86.49607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40170',
  },
  {
    city: 'Vine Grove',
    county_fips: 21163,
    county_fips_all: '21163|21093|21027',
    county: 'Meade',
    county_names_all: 'Meade|Hardin|Breckinridge',
    county_weights: '{"21163": 45.95, "21093": 34.65, "21027": 19.4}',
    density: 75.2,
    imprecise: false,
    latitude: 37.81907,
    longitude: -86.08635,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40175',
  },
  {
    city: 'Webster',
    county_fips: 21027,
    county_fips_all: '21027|21163',
    county: 'Breckinridge',
    county_names_all: 'Breckinridge|Meade',
    county_weights: '{"21027": 64.32, "21163": 35.68}',
    density: 9.5,
    imprecise: false,
    latitude: 37.92377,
    longitude: -86.34652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40176',
  },
  {
    city: 'West Point',
    county_fips: 21029,
    county_fips_all: '21029|21093|21111',
    county: 'Bullitt',
    county_names_all: 'Bullitt|Hardin|Jefferson',
    county_weights: '{"21029": 48.44, "21093": 44.38, "21111": 7.18}',
    density: 38,
    imprecise: false,
    latitude: 38.0009,
    longitude: -85.92502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40177',
  },
  {
    city: 'Westview',
    county_fips: 21027,
    county_fips_all: '21027',
    county: 'Breckinridge',
    county_names_all: 'Breckinridge',
    county_weights: '{"21027": 100}',
    density: 24.6,
    imprecise: false,
    latitude: 37.65834,
    longitude: -86.40853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40178',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1736.3,
    imprecise: false,
    latitude: 38.25288,
    longitude: -85.75205,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 7261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40202',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 2366,
    imprecise: false,
    latitude: 38.24722,
    longitude: -85.765,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 17742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40203',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1707.3,
    imprecise: false,
    latitude: 38.23873,
    longitude: -85.7208,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 14034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40204',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1382.7,
    imprecise: false,
    latitude: 38.22313,
    longitude: -85.68275,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 24664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40205',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1332.4,
    imprecise: false,
    latitude: 38.25788,
    longitude: -85.70205,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 20161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40206',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 950.8,
    imprecise: false,
    latitude: 38.26357,
    longitude: -85.65543,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 28903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40207',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 2309.1,
    imprecise: false,
    latitude: 38.2176,
    longitude: -85.7659,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 15605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40208',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 57.1,
    imprecise: false,
    latitude: 38.18492,
    longitude: -85.74372,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40209',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1644.3,
    imprecise: false,
    latitude: 38.23161,
    longitude: -85.78592,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 13518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40210',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1077.9,
    imprecise: false,
    latitude: 38.23425,
    longitude: -85.82147,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 20407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40211',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1478.2,
    imprecise: false,
    latitude: 38.26787,
    longitude: -85.80256,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 14661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40212',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 647.1,
    imprecise: false,
    latitude: 38.177,
    longitude: -85.71571,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 16054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40213',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1171.2,
    imprecise: false,
    latitude: 38.15141,
    longitude: -85.78285,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 45405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40214',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 2271.1,
    imprecise: false,
    latitude: 38.19052,
    longitude: -85.78555,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 20532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40215',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1086.4,
    imprecise: false,
    latitude: 38.18707,
    longitude: -85.83738,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 44047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40216',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1877.5,
    imprecise: false,
    latitude: 38.21689,
    longitude: -85.73725,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 11663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40217',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1447.3,
    imprecise: false,
    latitude: 38.19036,
    longitude: -85.65698,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 33736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40218',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1037,
    imprecise: false,
    latitude: 38.13907,
    longitude: -85.68877,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 39909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40219',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1768.4,
    imprecise: false,
    latitude: 38.21535,
    longitude: -85.61794,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 35078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40220',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.18644,
    longitude: -85.75302,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40221',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 876.8,
    imprecise: false,
    latitude: 38.26436,
    longitude: -85.61173,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 21470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40222',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 730.1,
    imprecise: false,
    latitude: 38.26153,
    longitude: -85.54328,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 22798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40223',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 806.1,
    imprecise: false,
    latitude: 38.13931,
    longitude: -85.62947,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 18085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40228',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111|21029',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Bullitt',
    county_weights: '{"21111": 70.65, "21029": 29.35}',
    density: 910.7,
    imprecise: false,
    latitude: 38.09074,
    longitude: -85.65597,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 41299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40229',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.19551,
    longitude: -85.69523,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40231',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111|21185',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Oldham',
    county_weights: '{"21111": 97.84, "21185": 2.16}',
    density: 905.1,
    imprecise: false,
    latitude: 38.30339,
    longitude: -85.5774,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 30696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40241',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1507.9,
    imprecise: false,
    latitude: 38.27639,
    longitude: -85.59042,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 11168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40242',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1128,
    imprecise: false,
    latitude: 38.23917,
    longitude: -85.53188,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 12002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40243',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111|21211|21185',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Shelby|Oldham',
    county_weights: '{"21111": 72.06, "21211": 27.34, "21185": 0.6}',
    density: 472.3,
    imprecise: false,
    latitude: 38.26574,
    longitude: -85.45327,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 39835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40245',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 887.5,
    imprecise: false,
    latitude: 38.14514,
    longitude: -85.87253,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 26841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40258',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111|21029',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Bullitt',
    county_weights: '{"21111": 95.68, "21029": 4.32}',
    density: 444.2,
    imprecise: false,
    latitude: 38.08291,
    longitude: -85.85315,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 38289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40272',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 703.2,
    imprecise: false,
    latitude: 38.1275,
    longitude: -85.57823,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 41222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40291',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111|21029',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Bullitt',
    county_weights: '{"21111": 99.41, "21029": 0.59}',
    density: 301.9,
    imprecise: false,
    latitude: 38.16319,
    longitude: -85.51613,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 42207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40299',
  },
  {
    city: 'Burgin',
    county_fips: 21167,
    county_fips_all: '21167',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"21167": 100}',
    density: 319.8,
    imprecise: false,
    latitude: 37.752,
    longitude: -84.76941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40310',
  },
  {
    city: 'Carlisle',
    county_fips: 21181,
    county_fips_all: '21181|21017|21011|21201',
    county: 'Nicholas',
    county_names_all: 'Nicholas|Bourbon|Bath|Robertson',
    county_weights:
      '{"21181": 89.34, "21017": 9.5, "21011": 0.91, "21201": 0.25}',
    density: 17.4,
    imprecise: false,
    latitude: 38.32407,
    longitude: -84.02256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40311',
  },
  {
    city: 'Clay City',
    county_fips: 21197,
    county_fips_all: '21197',
    county: 'Powell',
    county_names_all: 'Powell',
    county_weights: '{"21197": 100}',
    density: 40.7,
    imprecise: false,
    latitude: 37.84386,
    longitude: -83.93013,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40312',
  },
  {
    city: 'Clearfield',
    county_fips: 21205,
    county_fips_all: '21205',
    county: 'Rowan',
    county_names_all: 'Rowan',
    county_weights: '{"21205": 100}',
    density: 39.5,
    imprecise: false,
    latitude: 38.13215,
    longitude: -83.38973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40313',
  },
  {
    city: 'Denniston',
    county_fips: 21165,
    county_fips_all: '21165',
    county: 'Menifee',
    county_names_all: 'Menifee',
    county_weights: '{"21165": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 37.93419,
    longitude: -83.52895,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40316',
  },
  {
    city: 'Frenchburg',
    county_fips: 21165,
    county_fips_all: '21165',
    county: 'Menifee',
    county_names_all: 'Menifee',
    county_weights: '{"21165": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 37.93367,
    longitude: -83.63329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40322',
  },
  {
    city: 'Georgetown',
    county_fips: 21209,
    county_fips_all: '21209|21017|21067',
    county: 'Scott',
    county_names_all: 'Scott|Bourbon|Fayette',
    county_weights: '{"21209": 96.06, "21017": 2.2, "21067": 1.74}',
    density: 132.9,
    imprecise: false,
    latitude: 38.24786,
    longitude: -84.54956,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40324',
  },
  {
    city: 'Gravel Switch',
    county_fips: 21155,
    county_fips_all: '21155|21021|21045',
    county: 'Marion',
    county_names_all: 'Marion|Boyle|Casey',
    county_weights: '{"21155": 39.24, "21021": 33.85, "21045": 26.91}',
    density: 6.2,
    imprecise: false,
    latitude: 37.56632,
    longitude: -85.02565,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40328',
  },
  {
    city: 'Harrodsburg',
    county_fips: 21167,
    county_fips_all: '21167|21229',
    county: 'Mercer',
    county_names_all: 'Mercer|Washington',
    county_weights: '{"21167": 88.39, "21229": 11.61}',
    density: 37.2,
    imprecise: false,
    latitude: 37.78912,
    longitude: -84.89016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40330',
  },
  {
    city: 'Hope',
    county_fips: 21011,
    county_fips_all: '21011',
    county: 'Bath',
    county_names_all: 'Bath',
    county_weights: '{"21011": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.0197,
    longitude: -83.74943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40334',
  },
  {
    city: 'Irvine',
    county_fips: 21065,
    county_fips_all: '21065|21129|21109',
    county: 'Estill',
    county_names_all: 'Estill|Lee|Jackson',
    county_weights: '{"21065": 94.02, "21129": 4.25, "21109": 1.73}',
    density: 23.4,
    imprecise: false,
    latitude: 37.68352,
    longitude: -83.9832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40336',
  },
  {
    city: 'Jeffersonville',
    county_fips: 21173,
    county_fips_all: '21173',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"21173": 100}',
    density: 35.9,
    imprecise: false,
    latitude: 37.95286,
    longitude: -83.85644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40337',
  },
  {
    city: 'Keene',
    county_fips: 21113,
    county_fips_all: '21113',
    county: 'Jessamine',
    county_names_all: 'Jessamine',
    county_weights: '{"21113": 100}',
    density: 1087.2,
    imprecise: false,
    latitude: 37.94313,
    longitude: -84.64107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40339',
  },
  {
    city: 'Lawrenceburg',
    county_fips: 21005,
    county_fips_all: '21005|21167|21211',
    county: 'Anderson',
    county_names_all: 'Anderson|Mercer|Shelby',
    county_weights: '{"21005": 99.14, "21167": 0.45, "21211": 0.41}',
    density: 50,
    imprecise: false,
    latitude: 38.0036,
    longitude: -84.9837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40342',
  },
  {
    city: 'Means',
    county_fips: 21165,
    county_fips_all: '21165|21011|21173',
    county: 'Menifee',
    county_names_all: 'Menifee|Bath|Montgomery',
    county_weights: '{"21165": 64.08, "21011": 20.05, "21173": 15.87}',
    density: 16.7,
    imprecise: false,
    latitude: 37.98339,
    longitude: -83.74384,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40346',
  },
  {
    city: 'Midway',
    county_fips: 21239,
    county_fips_all: '21239|21073|21209',
    county: 'Woodford',
    county_names_all: 'Woodford|Franklin|Scott',
    county_weights: '{"21239": 76.15, "21073": 12.65, "21209": 11.2}',
    density: 37.7,
    imprecise: false,
    latitude: 38.15794,
    longitude: -84.71915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40347',
  },
  {
    city: 'Millersburg',
    county_fips: 21017,
    county_fips_all: '21017',
    county: 'Bourbon',
    county_names_all: 'Bourbon',
    county_weights: '{"21017": 100}',
    density: 395.4,
    imprecise: false,
    latitude: 38.30296,
    longitude: -84.14613,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40348',
  },
  {
    city: 'Moorefield',
    county_fips: 21181,
    county_fips_all: '21181',
    county: 'Nicholas',
    county_names_all: 'Nicholas',
    county_weights: '{"21181": 100}',
    density: 2,
    imprecise: false,
    latitude: 38.30512,
    longitude: -83.87881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40350',
  },
  {
    city: 'Morehead',
    county_fips: 21205,
    county_fips_all: '21205|21063|21043',
    county: 'Rowan',
    county_names_all: 'Rowan|Elliott|Carter',
    county_weights: '{"21205": 94.01, "21063": 5.69, "21043": 0.3}',
    density: 32.1,
    imprecise: false,
    latitude: 38.19817,
    longitude: -83.4133,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40351',
  },
  {
    city: 'Mount Sterling',
    county_fips: 21173,
    county_fips_all: '21173|21049|21011|21017',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Clark|Bath|Bourbon',
    county_weights:
      '{"21173": 93.47, "21049": 5.79, "21011": 0.61, "21017": 0.13}',
    density: 62.1,
    imprecise: false,
    latitude: 38.06514,
    longitude: -83.94853,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40353',
  },
  {
    city: 'New Liberty',
    county_fips: 21187,
    county_fips_all: '21187',
    county: 'Owen',
    county_names_all: 'Owen',
    county_weights: '{"21187": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 38.61023,
    longitude: -84.86535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40355',
  },
  {
    city: 'Nicholasville',
    county_fips: 21113,
    county_fips_all: '21113',
    county: 'Jessamine',
    county_names_all: 'Jessamine',
    county_weights: '{"21113": 100}',
    density: 126.9,
    imprecise: false,
    latitude: 37.87307,
    longitude: -84.56554,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40356',
  },
  {
    city: 'North Middletown',
    county_fips: 21017,
    county_fips_all: '21017',
    county: 'Bourbon',
    county_names_all: 'Bourbon',
    county_weights: '{"21017": 100}',
    density: 817.2,
    imprecise: false,
    latitude: 38.14519,
    longitude: -84.10843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40357',
  },
  {
    city: 'Olympia',
    county_fips: 21011,
    county_fips_all: '21011',
    county: 'Bath',
    county_names_all: 'Bath',
    county_weights: '{"21011": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 38.05769,
    longitude: -83.6831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40358',
  },
  {
    city: 'Owenton',
    county_fips: 21187,
    county_fips_all: '21187',
    county: 'Owen',
    county_names_all: 'Owen',
    county_weights: '{"21187": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 38.48224,
    longitude: -84.8209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40359',
  },
  {
    city: 'Owingsville',
    county_fips: 21011,
    county_fips_all: '21011|21173',
    county: 'Bath',
    county_names_all: 'Bath|Montgomery',
    county_weights: '{"21011": 96.04, "21173": 3.96}',
    density: 19.8,
    imprecise: false,
    latitude: 38.15665,
    longitude: -83.76679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40360',
  },
  {
    city: 'Paris',
    county_fips: 21017,
    county_fips_all: '21017|21097|21067|21181',
    county: 'Bourbon',
    county_names_all: 'Bourbon|Harrison|Fayette|Nicholas',
    county_weights:
      '{"21017": 97.73, "21097": 1.18, "21067": 0.8, "21181": 0.29}',
    density: 27.6,
    imprecise: false,
    latitude: 38.20536,
    longitude: -84.22415,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40361',
  },
  {
    city: 'Perry Park',
    county_fips: 21187,
    county_fips_all: '21187',
    county: 'Owen',
    county_names_all: 'Owen',
    county_weights: '{"21187": 100}',
    density: 166.5,
    imprecise: false,
    latitude: 38.51439,
    longitude: -85.00976,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40363',
  },
  {
    city: 'Sadieville',
    county_fips: 21209,
    county_fips_all: '21209|21097',
    county: 'Scott',
    county_names_all: 'Scott|Harrison',
    county_weights: '{"21209": 77.63, "21097": 22.37}',
    density: 13.5,
    imprecise: false,
    latitude: 38.39382,
    longitude: -84.52971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40370',
  },
  {
    city: 'Salt Lick',
    county_fips: 21011,
    county_fips_all: '21011|21165',
    county: 'Bath',
    county_names_all: 'Bath|Menifee',
    county_weights: '{"21011": 78.74, "21165": 21.26}',
    density: 12.6,
    imprecise: false,
    latitude: 38.07716,
    longitude: -83.59561,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40371',
  },
  {
    city: 'Salvisa',
    county_fips: 21167,
    county_fips_all: '21167|21005',
    county: 'Mercer',
    county_names_all: 'Mercer|Anderson',
    county_weights: '{"21167": 94.46, "21005": 5.54}',
    density: 15,
    imprecise: false,
    latitude: 37.90899,
    longitude: -84.88537,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40372',
  },
  {
    city: 'Sharpsburg',
    county_fips: 21011,
    county_fips_all: '21011|21181|21017',
    county: 'Bath',
    county_names_all: 'Bath|Nicholas|Bourbon',
    county_weights: '{"21011": 83.93, "21181": 11.76, "21017": 4.31}',
    density: 16.1,
    imprecise: false,
    latitude: 38.21419,
    longitude: -83.90359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40374',
  },
  {
    city: 'Slade',
    county_fips: 21197,
    county_fips_all: '21197',
    county: 'Powell',
    county_names_all: 'Powell',
    county_weights: '{"21197": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 37.7839,
    longitude: -83.69604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40376',
  },
  {
    city: 'Stamping Ground',
    county_fips: 21209,
    county_fips_all: '21209|21073|21187',
    county: 'Scott',
    county_names_all: 'Scott|Franklin|Owen',
    county_weights: '{"21209": 90.04, "21073": 6.72, "21187": 3.24}',
    density: 22.3,
    imprecise: false,
    latitude: 38.30778,
    longitude: -84.68992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40379',
  },
  {
    city: 'Stanton',
    county_fips: 21197,
    county_fips_all: '21197|21065',
    county: 'Powell',
    county_names_all: 'Powell|Estill',
    county_weights: '{"21197": 92.39, "21065": 7.61}',
    density: 22.5,
    imprecise: false,
    latitude: 37.81965,
    longitude: -83.78006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40380',
  },
  {
    city: 'Versailles',
    county_fips: 21239,
    county_fips_all: '21239|21113',
    county: 'Woodford',
    county_names_all: 'Woodford|Jessamine',
    county_weights: '{"21239": 97.19, "21113": 2.81}',
    density: 63.7,
    imprecise: false,
    latitude: 38.01022,
    longitude: -84.73919,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40383',
  },
  {
    city: 'Waco',
    county_fips: 21151,
    county_fips_all: '21151',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"21151": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 37.73866,
    longitude: -84.13085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40385',
  },
  {
    city: 'Wellington',
    county_fips: 21165,
    county_fips_all: '21165|21175',
    county: 'Menifee',
    county_names_all: 'Menifee|Morgan',
    county_weights: '{"21165": 77.61, "21175": 22.39}',
    density: 10.9,
    imprecise: false,
    latitude: 37.93494,
    longitude: -83.49027,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40387',
  },
  {
    city: 'Wilmore',
    county_fips: 21113,
    county_fips_all: '21113',
    county: 'Jessamine',
    county_names_all: 'Jessamine',
    county_weights: '{"21113": 100}',
    density: 116.1,
    imprecise: false,
    latitude: 37.85407,
    longitude: -84.67075,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40390',
  },
  {
    city: 'Winchester',
    county_fips: 21049,
    county_fips_all: '21049|21067',
    county: 'Clark',
    county_names_all: 'Clark|Fayette',
    county_weights: '{"21049": 99.35, "21067": 0.65}',
    density: 59.9,
    imprecise: false,
    latitude: 37.96969,
    longitude: -84.14507,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40391',
  },
  {
    city: 'Annville',
    county_fips: 21109,
    county_fips_all: '21109',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"21109": 100}',
    density: 20,
    imprecise: false,
    latitude: 37.29663,
    longitude: -83.97008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40402',
  },
  {
    city: 'Berea',
    county_fips: 21151,
    county_fips_all: '21151|21079|21203',
    county: 'Madison',
    county_names_all: 'Madison|Garrard|Rockcastle',
    county_weights: '{"21151": 76.54, "21079": 14.37, "21203": 9.09}',
    density: 96,
    imprecise: false,
    latitude: 37.57052,
    longitude: -84.26622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40403',
  },
  {
    city: 'Brodhead',
    county_fips: 21203,
    county_fips_all: '21203|21137|21199',
    county: 'Rockcastle',
    county_names_all: 'Rockcastle|Lincoln|Pulaski',
    county_weights: '{"21203": 94.47, "21137": 3.43, "21199": 2.1}',
    density: 29.6,
    imprecise: false,
    latitude: 37.37667,
    longitude: -84.42971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40409',
  },
  {
    city: 'Crab Orchard',
    county_fips: 21137,
    county_fips_all: '21137|21079|21203|21199',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Garrard|Rockcastle|Pulaski',
    county_weights:
      '{"21137": 55.75, "21079": 20.82, "21203": 18.26, "21199": 5.17}',
    density: 21.3,
    imprecise: false,
    latitude: 37.44791,
    longitude: -84.49204,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40419',
  },
  {
    city: 'Danville',
    county_fips: 21021,
    county_fips_all: '21021|21137',
    county: 'Boyle',
    county_names_all: 'Boyle|Lincoln',
    county_weights: '{"21021": 94.3, "21137": 5.7}',
    density: 92.5,
    imprecise: false,
    latitude: 37.64235,
    longitude: -84.80488,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40422',
  },
  {
    city: 'Gray Hawk',
    county_fips: 21109,
    county_fips_all: '21109',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"21109": 100}',
    density: 1228.8,
    imprecise: false,
    latitude: 37.39364,
    longitude: -83.93949,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40434',
  },
  {
    city: 'Hustonville',
    county_fips: 21045,
    county_fips_all: '21045|21137',
    county: 'Casey',
    county_names_all: 'Casey|Lincoln',
    county_weights: '{"21045": 52.36, "21137": 47.64}',
    density: 16.1,
    imprecise: false,
    latitude: 37.44531,
    longitude: -84.85486,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40437',
  },
  {
    city: 'Junction City',
    county_fips: 21021,
    county_fips_all: '21021|21137',
    county: 'Boyle',
    county_names_all: 'Boyle|Lincoln',
    county_weights: '{"21021": 99.88, "21137": 0.12}',
    density: 71,
    imprecise: false,
    latitude: 37.57628,
    longitude: -84.8322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40440',
  },
  {
    city: 'Kings Mountain',
    county_fips: 21137,
    county_fips_all: '21137|21045',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Casey',
    county_weights: '{"21137": 53.85, "21045": 46.15}',
    density: 11.3,
    imprecise: false,
    latitude: 37.35205,
    longitude: -84.72868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40442',
  },
  {
    city: 'Lancaster',
    county_fips: 21079,
    county_fips_all: '21079|21137',
    county: 'Garrard',
    county_names_all: 'Garrard|Lincoln',
    county_weights: '{"21079": 96.57, "21137": 3.43}',
    density: 34.6,
    imprecise: false,
    latitude: 37.67893,
    longitude: -84.58819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40444',
  },
  {
    city: 'Livingston',
    county_fips: 21203,
    county_fips_all: '21203',
    county: 'Rockcastle',
    county_names_all: 'Rockcastle',
    county_weights: '{"21203": 100}',
    density: 6,
    imprecise: false,
    latitude: 37.3125,
    longitude: -84.21159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40445',
  },
  {
    city: 'McKee',
    county_fips: 21109,
    county_fips_all: '21109|21189|21065|21203',
    county: 'Jackson',
    county_names_all: 'Jackson|Owsley|Estill|Rockcastle',
    county_weights:
      '{"21109": 94.52, "21189": 4.13, "21065": 0.68, "21203": 0.67}',
    density: 12.7,
    imprecise: false,
    latitude: 37.45496,
    longitude: -84.0299,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40447',
  },
  {
    city: 'McKinney',
    county_fips: 21137,
    county_fips_all: '21137',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"21137": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.45624,
    longitude: -84.75799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40448',
  },
  {
    city: 'Mount Vernon',
    county_fips: 21203,
    county_fips_all: '21203',
    county: 'Rockcastle',
    county_names_all: 'Rockcastle',
    county_weights: '{"21203": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 37.3538,
    longitude: -84.32099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40456',
  },
  {
    city: 'Orlando',
    county_fips: 21203,
    county_fips_all: '21203',
    county: 'Rockcastle',
    county_names_all: 'Rockcastle',
    county_weights: '{"21203": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 37.39385,
    longitude: -84.23985,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40460',
  },
  {
    city: 'Paint Lick',
    county_fips: 21079,
    county_fips_all: '21079|21151',
    county: 'Garrard',
    county_names_all: 'Garrard|Madison',
    county_weights: '{"21079": 65.16, "21151": 34.84}',
    density: 17.5,
    imprecise: false,
    latitude: 37.59014,
    longitude: -84.40849,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40461',
  },
  {
    city: 'Parksville',
    county_fips: 21021,
    county_fips_all: '21021|21045',
    county: 'Boyle',
    county_names_all: 'Boyle|Casey',
    county_weights: '{"21021": 72.12, "21045": 27.88}',
    density: 12.2,
    imprecise: false,
    latitude: 37.55579,
    longitude: -84.91148,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40464',
  },
  {
    city: 'Perryville',
    county_fips: 21021,
    county_fips_all: '21021|21229|21167',
    county: 'Boyle',
    county_names_all: 'Boyle|Washington|Mercer',
    county_weights: '{"21021": 79.22, "21229": 14.14, "21167": 6.64}',
    density: 27.2,
    imprecise: false,
    latitude: 37.65158,
    longitude: -84.98782,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40468',
  },
  {
    city: 'Ravenna',
    county_fips: 21065,
    county_fips_all: '21065',
    county: 'Estill',
    county_names_all: 'Estill',
    county_weights: '{"21065": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 37.71841,
    longitude: -83.87562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40472',
  },
  {
    city: 'Richmond',
    county_fips: 21151,
    county_fips_all: '21151',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"21151": 100}',
    density: 88.6,
    imprecise: false,
    latitude: 37.7635,
    longitude: -84.30828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40475',
  },
  {
    city: 'Sandgap',
    county_fips: 21109,
    county_fips_all: '21109',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"21109": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 37.42658,
    longitude: -84.09116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40481',
  },
  {
    city: 'Stanford',
    county_fips: 21137,
    county_fips_all: '21137|21079|21045',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Garrard|Casey',
    county_weights: '{"21137": 96.45, "21079": 2.69, "21045": 0.86}',
    density: 34.1,
    imprecise: false,
    latitude: 37.5153,
    longitude: -84.676,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40484',
  },
  {
    city: 'Tyner',
    county_fips: 21109,
    county_fips_all: '21109|21189|21051',
    county: 'Jackson',
    county_names_all: 'Jackson|Owsley|Clay',
    county_weights: '{"21109": 90.5, "21189": 8.05, "21051": 1.45}',
    density: 17.8,
    imprecise: false,
    latitude: 37.37238,
    longitude: -83.86123,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40486',
  },
  {
    city: 'Waynesburg',
    county_fips: 21137,
    county_fips_all: '21137|21045',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Casey',
    county_weights: '{"21137": 85.54, "21045": 14.46}',
    density: 26.9,
    imprecise: false,
    latitude: 37.36629,
    longitude: -84.64435,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40489',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"21067": 100}',
    density: 1411.3,
    imprecise: false,
    latitude: 38.01376,
    longitude: -84.48189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40502',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"21067": 100}',
    density: 1199.8,
    imprecise: false,
    latitude: 38.0047,
    longitude: -84.53434,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40503',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"21067": 100}',
    density: 1617.1,
    imprecise: false,
    latitude: 38.04181,
    longitude: -84.54133,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40504',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"21067": 100}',
    density: 1237,
    imprecise: false,
    latitude: 38.06039,
    longitude: -84.45679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40505',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"21067": 100}',
    density: 1935.6,
    imprecise: false,
    latitude: 38.04686,
    longitude: -84.49628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40507',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"21067": 100}',
    density: 2180.5,
    imprecise: false,
    latitude: 38.05004,
    longitude: -84.50018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40508',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067|21049',
    county: 'Fayette',
    county_names_all: 'Fayette|Clark',
    county_weights: '{"21067": 91.48, "21049": 8.52}',
    density: 380.3,
    imprecise: false,
    latitude: 37.99408,
    longitude: -84.36791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40509',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"21067": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 38.07243,
    longitude: -84.60138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40510',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067|21209|21017',
    county: 'Fayette',
    county_names_all: 'Fayette|Scott|Bourbon',
    county_weights: '{"21067": 90.97, "21209": 4.88, "21017": 4.15}',
    density: 171.3,
    imprecise: false,
    latitude: 38.13278,
    longitude: -84.47392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40511',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067|21239',
    county: 'Fayette',
    county_names_all: 'Fayette|Woodford',
    county_weights: '{"21067": 99.87, "21239": 0.13}',
    density: 290,
    imprecise: false,
    latitude: 38.01626,
    longitude: -84.60694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40513',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"21067": 100}',
    density: 2193.8,
    imprecise: false,
    latitude: 37.98279,
    longitude: -84.56352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40514',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067|21049|21113',
    county: 'Fayette',
    county_names_all: 'Fayette|Clark|Jessamine',
    county_weights: '{"21067": 85.48, "21049": 8.03, "21113": 6.49}',
    density: 261.1,
    imprecise: false,
    latitude: 37.92021,
    longitude: -84.4152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40515',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067|21017',
    county: 'Fayette',
    county_names_all: 'Fayette|Bourbon',
    county_weights: '{"21067": 86.3, "21017": 13.7}',
    density: 36.8,
    imprecise: false,
    latitude: 38.07366,
    longitude: -84.36631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40516',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"21067": 100}',
    density: 2230.5,
    imprecise: false,
    latitude: 37.98386,
    longitude: -84.48833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40517',
  },
  {
    city: 'Frankfort',
    county_fips: 21073,
    county_fips_all: '21073|21239|21211|21103',
    county: 'Franklin',
    county_names_all: 'Franklin|Woodford|Shelby|Henry',
    county_weights:
      '{"21073": 88.89, "21239": 5.8, "21211": 4.38, "21103": 0.93}',
    density: 92.1,
    imprecise: false,
    latitude: 38.23294,
    longitude: -84.88327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40601',
  },
  {
    city: 'Corbin',
    county_fips: 21235,
    county_fips_all: '21235|21125|21121',
    county: 'Whitley',
    county_names_all: 'Whitley|Laurel|Knox',
    county_weights: '{"21235": 60.96, "21125": 21.47, "21121": 17.57}',
    density: 78.3,
    imprecise: false,
    latitude: 36.91759,
    longitude: -84.16651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40701',
  },
  {
    city: 'East Bernstadt',
    county_fips: 21125,
    county_fips_all: '21125',
    county: 'Laurel',
    county_names_all: 'Laurel',
    county_weights: '{"21125": 100}',
    density: 29.8,
    imprecise: false,
    latitude: 37.2435,
    longitude: -84.14788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40729',
  },
  {
    city: 'Gray',
    county_fips: 21121,
    county_fips_all: '21121|21125',
    county: 'Knox',
    county_names_all: 'Knox|Laurel',
    county_weights: '{"21121": 95.56, "21125": 4.44}',
    density: 30.6,
    imprecise: false,
    latitude: 36.92642,
    longitude: -83.96609,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40734',
  },
  {
    city: 'Keavy',
    county_fips: 21125,
    county_fips_all: '21125',
    county: 'Laurel',
    county_names_all: 'Laurel',
    county_weights: '{"21125": 100}',
    density: 85.1,
    imprecise: false,
    latitude: 37.00838,
    longitude: -84.13902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40737',
  },
  {
    city: 'Lily',
    county_fips: 21125,
    county_fips_all: '21125',
    county: 'Laurel',
    county_names_all: 'Laurel',
    county_weights: '{"21125": 100}',
    density: 99.1,
    imprecise: false,
    latitude: 37.02111,
    longitude: -84.03888,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40740',
  },
  {
    city: 'London',
    county_fips: 21125,
    county_fips_all: '21125|21051',
    county: 'Laurel',
    county_names_all: 'Laurel|Clay',
    county_weights: '{"21125": 96.95, "21051": 3.05}',
    density: 43.5,
    imprecise: false,
    latitude: 37.13349,
    longitude: -84.11636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40741',
  },
  {
    city: 'London',
    county_fips: 21125,
    county_fips_all: '21125|21051',
    county: 'Laurel',
    county_names_all: 'Laurel|Clay',
    county_weights: '{"21125": 97.76, "21051": 2.24}',
    density: 74.9,
    imprecise: false,
    latitude: 37.03841,
    longitude: -84.08864,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40744',
  },
  {
    city: 'Rockholds',
    county_fips: 21235,
    county_fips_all: '21235|21121',
    county: 'Whitley',
    county_names_all: 'Whitley|Knox',
    county_weights: '{"21235": 84.49, "21121": 15.51}',
    density: 24.5,
    imprecise: false,
    latitude: 36.82034,
    longitude: -84.0571,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40759',
  },
  {
    city: 'Siler',
    county_fips: 21235,
    county_fips_all: '21235|21121',
    county: 'Whitley',
    county_names_all: 'Whitley|Knox',
    county_weights: '{"21235": 87.86, "21121": 12.14}',
    density: 6.1,
    imprecise: false,
    latitude: 36.68848,
    longitude: -83.94403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40763',
  },
  {
    city: 'Williamsburg',
    county_fips: 21235,
    county_fips_all: '21235|21147',
    county: 'Whitley',
    county_names_all: 'Whitley|McCreary',
    county_weights: '{"21235": 93.47, "21147": 6.53}',
    density: 25.1,
    imprecise: false,
    latitude: 36.7116,
    longitude: -84.17284,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40769',
  },
  {
    city: 'Woodbine',
    county_fips: 21121,
    county_fips_all: '21121|21235',
    county: 'Knox',
    county_names_all: 'Knox|Whitley',
    county_weights: '{"21121": 86.48, "21235": 13.52}',
    density: 71.6,
    imprecise: false,
    latitude: 36.85942,
    longitude: -84.03459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40771',
  },
  {
    city: 'Ages Brookside',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.85692,
    longitude: -83.25493,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40801',
  },
  {
    city: 'Asher',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 37.04572,
    longitude: -83.42185,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40803',
  },
  {
    city: 'Baxter',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 36.88595,
    longitude: -83.2881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40806',
  },
  {
    city: 'Benham',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 1441.6,
    imprecise: false,
    latitude: 36.9647,
    longitude: -82.95578,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40807',
  },
  {
    city: 'Big Laurel',
    county_fips: 21131,
    county_fips_all: '21131|21095',
    county: 'Leslie',
    county_names_all: 'Leslie|Harlan',
    county_weights: '{"21131": 85.45, "21095": 14.55}',
    density: 0.1,
    imprecise: false,
    latitude: 36.9995,
    longitude: -83.2801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40808',
  },
  {
    city: 'Bledsoe',
    county_fips: 21095,
    county_fips_all: '21095|21131',
    county: 'Harlan',
    county_names_all: 'Harlan|Leslie',
    county_weights: '{"21095": 90.42, "21131": 9.58}',
    density: 7.5,
    imprecise: false,
    latitude: 36.93176,
    longitude: -83.30451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40810',
  },
  {
    city: 'Calvin',
    county_fips: 21013,
    county_fips_all: '21013',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"21013": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 36.71526,
    longitude: -83.59838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40813',
  },
  {
    city: 'Cawood',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 36.7876,
    longitude: -83.22876,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40815',
  },
  {
    city: 'Coldiron',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 19,
    imprecise: false,
    latitude: 36.81025,
    longitude: -83.46242,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40819',
  },
  {
    city: 'Cranks',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 36.77552,
    longitude: -83.16515,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40820',
  },
  {
    city: 'Cumberland',
    county_fips: 21095,
    county_fips_all: '21095|21133',
    county: 'Harlan',
    county_names_all: 'Harlan|Letcher',
    county_weights: '{"21095": 99.85, "21133": 0.15}',
    density: 29.8,
    imprecise: false,
    latitude: 36.95664,
    longitude: -82.98864,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40823',
  },
  {
    city: 'Dayhoit',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 93.9,
    imprecise: false,
    latitude: 36.82489,
    longitude: -83.37221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40824',
  },
  {
    city: 'Eolia',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 10,
    imprecise: false,
    latitude: 37.05637,
    longitude: -82.7783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40826',
  },
  {
    city: 'Essie',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 20,
    imprecise: false,
    latitude: 37.05208,
    longitude: -83.47187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40827',
  },
  {
    city: 'Evarts',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 32.6,
    imprecise: false,
    latitude: 36.87107,
    longitude: -83.14868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40828',
  },
  {
    city: 'Grays Knob',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 36.798,
    longitude: -83.29655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40829',
  },
  {
    city: 'Harlan',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 36.76457,
    longitude: -83.33454,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40831',
  },
  {
    city: 'Helton',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 36.9457,
    longitude: -83.41854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40840',
  },
  {
    city: 'Holmes Mill',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 36.88826,
    longitude: -82.93666,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40843',
  },
  {
    city: 'Hoskinston',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 37.05506,
    longitude: -83.35406,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40844',
  },
  {
    city: 'Kenvir',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 138.7,
    imprecise: false,
    latitude: 36.85281,
    longitude: -83.15798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40847',
  },
  {
    city: 'Lejunior',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 148.5,
    imprecise: false,
    latitude: 36.89941,
    longitude: -83.13469,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40849',
  },
  {
    city: 'Loyall',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 111,
    imprecise: false,
    latitude: 36.84664,
    longitude: -83.35634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40854',
  },
  {
    city: 'Lynch',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 36.94931,
    longitude: -82.89836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40855',
  },
  {
    city: 'Miracle',
    county_fips: 21013,
    county_fips_all: '21013',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"21013": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 36.70574,
    longitude: -83.52939,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40856',
  },
  {
    city: 'Partridge',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 37.01418,
    longitude: -82.87096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40862',
  },
  {
    city: 'Pathfork',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 11,
    imprecise: false,
    latitude: 36.74048,
    longitude: -83.44567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40863',
  },
  {
    city: 'Putney',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 44.5,
    imprecise: false,
    latitude: 36.91637,
    longitude: -83.21804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40865',
  },
  {
    city: 'Stinnett',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 51,
    imprecise: false,
    latitude: 37.09367,
    longitude: -83.41638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40868',
  },
  {
    city: 'Totz',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 36.93211,
    longitude: -83.14858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40870',
  },
  {
    city: 'Wallins Creek',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 30.6,
    imprecise: false,
    latitude: 36.81541,
    longitude: -83.40411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40873',
  },
  {
    city: 'Warbranch',
    county_fips: 21131,
    county_fips_all: '21131|21051',
    county: 'Leslie',
    county_names_all: 'Leslie|Clay',
    county_weights: '{"21131": 81.59, "21051": 18.41}',
    density: 0.9,
    imprecise: false,
    latitude: 36.98407,
    longitude: -83.47345,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40874',
  },
  {
    city: 'Arjay',
    county_fips: 21013,
    county_fips_all: '21013',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"21013": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 36.84824,
    longitude: -83.62435,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40902',
  },
  {
    city: 'Artemus',
    county_fips: 21121,
    county_fips_all: '21121',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"21121": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 36.80973,
    longitude: -83.83163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40903',
  },
  {
    city: 'Barbourville',
    county_fips: 21121,
    county_fips_all: '21121|21235',
    county: 'Knox',
    county_names_all: 'Knox|Whitley',
    county_weights: '{"21121": 97.72, "21235": 2.28}',
    density: 30.4,
    imprecise: false,
    latitude: 36.88828,
    longitude: -83.87546,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40906',
  },
  {
    city: 'Beverly',
    county_fips: 21013,
    county_fips_all: '21013|21051',
    county: 'Bell',
    county_names_all: 'Bell|Clay',
    county_weights: '{"21013": 67.47, "21051": 32.53}',
    density: 6.3,
    imprecise: false,
    latitude: 36.94986,
    longitude: -83.54367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40913',
  },
  {
    city: 'Big Creek',
    county_fips: 21051,
    county_fips_all: '21051|21131',
    county: 'Clay',
    county_names_all: 'Clay|Leslie',
    county_weights: '{"21051": 71.68, "21131": 28.32}',
    density: 7.1,
    imprecise: false,
    latitude: 37.0932,
    longitude: -83.56154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40914',
  },
  {
    city: 'Bimble',
    county_fips: 21121,
    county_fips_all: '21121',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"21121": 100}',
    density: 39.2,
    imprecise: false,
    latitude: 36.89235,
    longitude: -83.82025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40915',
  },
  {
    city: 'Bryants Store',
    county_fips: 21121,
    county_fips_all: '21121',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"21121": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 36.78195,
    longitude: -83.90185,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40921',
  },
  {
    city: 'Cannon',
    county_fips: 21121,
    county_fips_all: '21121',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"21121": 100}',
    density: 48.1,
    imprecise: false,
    latitude: 36.92059,
    longitude: -83.84923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40923',
  },
  {
    city: 'Closplint',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 36.89081,
    longitude: -83.03445,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40927',
  },
  {
    city: 'Flat Lick',
    county_fips: 21121,
    county_fips_all: '21121',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"21121": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 36.91107,
    longitude: -83.71264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40935',
  },
  {
    city: 'Fourmile',
    county_fips: 21013,
    county_fips_all: '21013|21121',
    county: 'Bell',
    county_names_all: 'Bell|Knox',
    county_weights: '{"21013": 99.13, "21121": 0.87}',
    density: 10.1,
    imprecise: false,
    latitude: 36.81217,
    longitude: -83.71152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40939',
  },
  {
    city: 'Frakes',
    county_fips: 21013,
    county_fips_all: '21013|21235',
    county: 'Bell',
    county_names_all: 'Bell|Whitley',
    county_weights: '{"21013": 54.08, "21235": 45.92}',
    density: 4.7,
    imprecise: false,
    latitude: 36.60991,
    longitude: -83.92988,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40940',
  },
  {
    city: 'Garrard',
    county_fips: 21051,
    county_fips_all: '21051',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"21051": 100}',
    density: 737.9,
    imprecise: false,
    latitude: 37.12981,
    longitude: -83.74585,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40941',
  },
  {
    city: 'Girdler',
    county_fips: 21121,
    county_fips_all: '21121',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"21121": 100}',
    density: 78.9,
    imprecise: false,
    latitude: 36.95494,
    longitude: -83.85631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40943',
  },
  {
    city: 'Heidrick',
    county_fips: 21121,
    county_fips_all: '21121',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"21121": 100}',
    density: 92.5,
    imprecise: false,
    latitude: 36.90253,
    longitude: -83.86717,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40949',
  },
  {
    city: 'Manchester',
    county_fips: 21051,
    county_fips_all: '21051|21125',
    county: 'Clay',
    county_names_all: 'Clay|Laurel',
    county_weights: '{"21051": 99.81, "21125": 0.19}',
    density: 19.7,
    imprecise: false,
    latitude: 37.14912,
    longitude: -83.74922,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40962',
  },
  {
    city: 'Middlesboro',
    county_fips: 21013,
    county_fips_all: '21013|47025',
    county: 'Bell',
    county_names_all: 'Bell|Claiborne',
    county_weights: '{"21013": 85.05, "47025": 14.95}',
    density: 51.7,
    imprecise: false,
    latitude: 36.62469,
    longitude: -83.73461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40965',
  },
  {
    city: 'Oneida',
    county_fips: 21051,
    county_fips_all: '21051|21131',
    county: 'Clay',
    county_names_all: 'Clay|Leslie',
    county_weights: '{"21051": 98.79, "21131": 1.21}',
    density: 6.6,
    imprecise: false,
    latitude: 37.24501,
    longitude: -83.60692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40972',
  },
  {
    city: 'Pineville',
    county_fips: 21013,
    county_fips_all: '21013',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"21013": 100}',
    density: 24.2,
    imprecise: false,
    latitude: 36.72332,
    longitude: -83.72867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40977',
  },
  {
    city: 'Roark',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.00491,
    longitude: -83.495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40979',
  },
  {
    city: 'Saul',
    county_fips: 21193,
    county_fips_all: '21193|21131',
    county: 'Perry',
    county_names_all: 'Perry|Leslie',
    county_weights: '{"21193": 99.72, "21131": 0.28}',
    density: 0,
    imprecise: false,
    latitude: 37.27792,
    longitude: -83.48531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40981',
  },
  {
    city: 'Scalf',
    county_fips: 21121,
    county_fips_all: '21121',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"21121": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 36.93241,
    longitude: -83.69421,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40982',
  },
  {
    city: 'Sextons Creek',
    county_fips: 21189,
    county_fips_all: '21189|21051',
    county: 'Owsley',
    county_names_all: 'Owsley|Clay',
    county_weights: '{"21189": 58.29, "21051": 41.71}',
    density: 6.1,
    imprecise: false,
    latitude: 37.34608,
    longitude: -83.75339,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40983',
  },
  {
    city: 'Stoney Fork',
    county_fips: 21013,
    county_fips_all: '21013|21095',
    county: 'Bell',
    county_names_all: 'Bell|Harlan',
    county_weights: '{"21013": 95.34, "21095": 4.66}',
    density: 8.4,
    imprecise: false,
    latitude: 36.85928,
    longitude: -83.52838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40988',
  },
  {
    city: 'Trosper',
    county_fips: 21121,
    county_fips_all: '21121',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"21121": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 36.75268,
    longitude: -83.82322,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40995',
  },
  {
    city: 'Alexandria',
    county_fips: 21037,
    county_fips_all: '21037',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"21037": 100}',
    density: 144.3,
    imprecise: false,
    latitude: 38.91409,
    longitude: -84.40256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41001',
  },
  {
    city: 'Augusta',
    county_fips: 21023,
    county_fips_all: '21023',
    county: 'Bracken',
    county_names_all: 'Bracken',
    county_weights: '{"21023": 100}',
    density: 24,
    imprecise: false,
    latitude: 38.73002,
    longitude: -83.98282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41002',
  },
  {
    city: 'Berry',
    county_fips: 21097,
    county_fips_all: '21097|21191|21081',
    county: 'Harrison',
    county_names_all: 'Harrison|Pendleton|Grant',
    county_weights: '{"21097": 73.93, "21191": 20.74, "21081": 5.33}',
    density: 13.7,
    imprecise: false,
    latitude: 38.53181,
    longitude: -84.39164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41003',
  },
  {
    city: 'Brooksville',
    county_fips: 21023,
    county_fips_all: '21023|21201|21191',
    county: 'Bracken',
    county_names_all: 'Bracken|Robertson|Pendleton',
    county_weights: '{"21023": 93.73, "21201": 5.86, "21191": 0.41}',
    density: 13.9,
    imprecise: false,
    latitude: 38.65549,
    longitude: -84.10134,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41004',
  },
  {
    city: 'Burlington',
    county_fips: 21015,
    county_fips_all: '21015',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"21015": 100}',
    density: 189.6,
    imprecise: false,
    latitude: 39.00709,
    longitude: -84.76541,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41005',
  },
  {
    city: 'Butler',
    county_fips: 21191,
    county_fips_all: '21191|21037',
    county: 'Pendleton',
    county_names_all: 'Pendleton|Campbell',
    county_weights: '{"21191": 88.04, "21037": 11.96}',
    density: 32.8,
    imprecise: false,
    latitude: 38.78475,
    longitude: -84.34298,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41006',
  },
  {
    city: 'California',
    county_fips: 21037,
    county_fips_all: '21037|21191',
    county: 'Campbell',
    county_names_all: 'Campbell|Pendleton',
    county_weights: '{"21037": 89.46, "21191": 10.54}',
    density: 34.6,
    imprecise: false,
    latitude: 38.89289,
    longitude: -84.30788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41007',
  },
  {
    city: 'Carrollton',
    county_fips: 21041,
    county_fips_all: '21041|21223',
    county: 'Carroll',
    county_names_all: 'Carroll|Trimble',
    county_weights: '{"21041": 95.62, "21223": 4.38}',
    density: 63,
    imprecise: false,
    latitude: 38.65648,
    longitude: -85.16873,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41008',
  },
  {
    city: 'Corinth',
    county_fips: 21081,
    county_fips_all: '21081|21187|21097|21209',
    county: 'Grant',
    county_names_all: 'Grant|Owen|Harrison|Scott',
    county_weights:
      '{"21081": 43.32, "21187": 39.31, "21097": 14.89, "21209": 2.48}',
    density: 13.6,
    imprecise: false,
    latitude: 38.50085,
    longitude: -84.60763,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41010',
  },
  {
    city: 'Covington',
    county_fips: 21117,
    county_fips_all: '21117',
    county: 'Kenton',
    county_names_all: 'Kenton',
    county_weights: '{"21117": 100}',
    density: 1480.8,
    imprecise: false,
    latitude: 39.06802,
    longitude: -84.53065,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41011',
  },
  {
    city: 'Covington',
    county_fips: 21117,
    county_fips_all: '21117',
    county: 'Kenton',
    county_names_all: 'Kenton',
    county_weights: '{"21117": 100}',
    density: 2780,
    imprecise: false,
    latitude: 39.0655,
    longitude: -84.50464,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41014',
  },
  {
    city: 'Latonia',
    county_fips: 21117,
    county_fips_all: '21117',
    county: 'Kenton',
    county_names_all: 'Kenton',
    county_weights: '{"21117": 100}',
    density: 315.9,
    imprecise: false,
    latitude: 38.97885,
    longitude: -84.48456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41015',
  },
  {
    city: 'Covington',
    county_fips: 21117,
    county_fips_all: '21117',
    county: 'Kenton',
    county_names_all: 'Kenton',
    county_weights: '{"21117": 100}',
    density: 1511,
    imprecise: false,
    latitude: 39.08701,
    longitude: -84.5487,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41016',
  },
  {
    city: 'Ft Mitchell',
    county_fips: 21117,
    county_fips_all: '21117',
    county: 'Kenton',
    county_names_all: 'Kenton',
    county_weights: '{"21117": 100}',
    density: 741.2,
    imprecise: false,
    latitude: 39.02893,
    longitude: -84.56177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41017',
  },
  {
    city: 'Erlanger',
    county_fips: 21117,
    county_fips_all: '21117|21015',
    county: 'Kenton',
    county_names_all: 'Kenton|Boone',
    county_weights: '{"21117": 77.28, "21015": 22.72}',
    density: 965.5,
    imprecise: false,
    latitude: 39.01546,
    longitude: -84.60282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41018',
  },
  {
    city: 'Crittenden',
    county_fips: 21081,
    county_fips_all: '21081|21117|21015|21191',
    county: 'Grant',
    county_names_all: 'Grant|Kenton|Boone|Pendleton',
    county_weights:
      '{"21081": 62.27, "21117": 29.19, "21015": 7.74, "21191": 0.8}',
    density: 72.9,
    imprecise: false,
    latitude: 38.78582,
    longitude: -84.58754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41030',
  },
  {
    city: 'Cynthiana',
    county_fips: 21097,
    county_fips_all: '21097|21181|21017',
    county: 'Harrison',
    county_names_all: 'Harrison|Nicholas|Bourbon',
    county_weights: '{"21097": 90.96, "21181": 5.64, "21017": 3.4}',
    density: 28.4,
    imprecise: false,
    latitude: 38.41383,
    longitude: -84.28631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41031',
  },
  {
    city: 'De Mossville',
    county_fips: 21191,
    county_fips_all: '21191|21117',
    county: 'Pendleton',
    county_names_all: 'Pendleton|Kenton',
    county_weights: '{"21191": 82.61, "21117": 17.39}',
    density: 19.4,
    imprecise: false,
    latitude: 38.77131,
    longitude: -84.46114,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41033',
  },
  {
    city: 'Dover',
    county_fips: 21161,
    county_fips_all: '21161|21023',
    county: 'Mason',
    county_names_all: 'Mason|Bracken',
    county_weights: '{"21161": 97.57, "21023": 2.43}',
    density: 15.7,
    imprecise: false,
    latitude: 38.70104,
    longitude: -83.90426,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41034',
  },
  {
    city: 'Dry Ridge',
    county_fips: 21081,
    county_fips_all: '21081|21187|21191',
    county: 'Grant',
    county_names_all: 'Grant|Owen|Pendleton',
    county_weights: '{"21081": 96.98, "21187": 1.51, "21191": 1.51}',
    density: 43.1,
    imprecise: false,
    latitude: 38.70322,
    longitude: -84.66141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41035',
  },
  {
    city: 'Ewing',
    county_fips: 21069,
    county_fips_all: '21069|21181|21161|21201',
    county: 'Fleming',
    county_names_all: 'Fleming|Nicholas|Mason|Robertson',
    county_weights:
      '{"21069": 84.67, "21181": 10.73, "21161": 2.43, "21201": 2.17}',
    density: 14.5,
    imprecise: false,
    latitude: 38.41381,
    longitude: -83.88074,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41039',
  },
  {
    city: 'Falmouth',
    county_fips: 21191,
    county_fips_all: '21191|21023',
    county: 'Pendleton',
    county_names_all: 'Pendleton|Bracken',
    county_weights: '{"21191": 95.67, "21023": 4.33}',
    density: 18.2,
    imprecise: false,
    latitude: 38.65232,
    longitude: -84.33188,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41040',
  },
  {
    city: 'Flemingsburg',
    county_fips: 21069,
    county_fips_all: '21069',
    county: 'Fleming',
    county_names_all: 'Fleming',
    county_weights: '{"21069": 100}',
    density: 28,
    imprecise: false,
    latitude: 38.40548,
    longitude: -83.72338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41041',
  },
  {
    city: 'Florence',
    county_fips: 21015,
    county_fips_all: '21015|21117',
    county: 'Boone',
    county_names_all: 'Boone|Kenton',
    county_weights: '{"21015": 94.59, "21117": 5.41}',
    density: 1006.3,
    imprecise: false,
    latitude: 38.98595,
    longitude: -84.64906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41042',
  },
  {
    city: 'Foster',
    county_fips: 21023,
    county_fips_all: '21023|21191',
    county: 'Bracken',
    county_names_all: 'Bracken|Pendleton',
    county_weights: '{"21023": 71.85, "21191": 28.15}',
    density: 13.1,
    imprecise: false,
    latitude: 38.75644,
    longitude: -84.19832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41043',
  },
  {
    city: 'Germantown',
    county_fips: 21161,
    county_fips_all: '21161|21201|21023',
    county: 'Mason',
    county_names_all: 'Mason|Robertson|Bracken',
    county_weights: '{"21161": 38.98, "21201": 30.93, "21023": 30.09}',
    density: 16.1,
    imprecise: false,
    latitude: 38.60513,
    longitude: -83.97265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41044',
  },
  {
    city: 'Ghent',
    county_fips: 21041,
    county_fips_all: '21041|21077',
    county: 'Carroll',
    county_names_all: 'Carroll|Gallatin',
    county_weights: '{"21041": 64.88, "21077": 35.12}',
    density: 14.4,
    imprecise: false,
    latitude: 38.72262,
    longitude: -85.02091,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41045',
  },
  {
    city: 'Glencoe',
    county_fips: 21187,
    county_fips_all: '21187|21077|21081',
    county: 'Owen',
    county_names_all: 'Owen|Gallatin|Grant',
    county_weights: '{"21187": 45.15, "21077": 36.69, "21081": 18.16}',
    density: 21.3,
    imprecise: false,
    latitude: 38.70953,
    longitude: -84.80637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41046',
  },
  {
    city: 'Hebron',
    county_fips: 21015,
    county_fips_all: '21015',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"21015": 100}',
    density: 186.7,
    imprecise: false,
    latitude: 39.08366,
    longitude: -84.70585,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41048',
  },
  {
    city: 'Hillsboro',
    county_fips: 21069,
    county_fips_all: '21069|21205',
    county: 'Fleming',
    county_names_all: 'Fleming|Rowan',
    county_weights: '{"21069": 99.74, "21205": 0.26}',
    density: 10,
    imprecise: false,
    latitude: 38.27465,
    longitude: -83.64581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41049',
  },
  {
    city: 'Independence',
    county_fips: 21117,
    county_fips_all: '21117',
    county: 'Kenton',
    county_names_all: 'Kenton',
    county_weights: '{"21117": 100}',
    density: 423.4,
    imprecise: false,
    latitude: 38.93233,
    longitude: -84.54451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41051',
  },
  {
    city: 'Jonesville',
    county_fips: 21081,
    county_fips_all: '21081|21187',
    county: 'Grant',
    county_names_all: 'Grant|Owen',
    county_weights: '{"21081": 53.09, "21187": 46.91}',
    density: 11.4,
    imprecise: false,
    latitude: 38.65914,
    longitude: -84.77777,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41052',
  },
  {
    city: 'Mayslick',
    county_fips: 21161,
    county_fips_all: '21161|21069|21201',
    county: 'Mason',
    county_names_all: 'Mason|Fleming|Robertson',
    county_weights: '{"21161": 89.11, "21069": 6.73, "21201": 4.16}',
    density: 11,
    imprecise: false,
    latitude: 38.51787,
    longitude: -83.86995,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41055',
  },
  {
    city: 'Maysville',
    county_fips: 21161,
    county_fips_all: '21161|21135|21069',
    county: 'Mason',
    county_names_all: 'Mason|Lewis|Fleming',
    county_weights: '{"21161": 98.23, "21135": 1.27, "21069": 0.5}',
    density: 37.2,
    imprecise: false,
    latitude: 38.59913,
    longitude: -83.77576,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41056',
  },
  {
    city: 'Melbourne',
    county_fips: 21037,
    county_fips_all: '21037',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"21037": 100}',
    density: 68.2,
    imprecise: false,
    latitude: 39.00504,
    longitude: -84.35213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41059',
  },
  {
    city: 'Morning View',
    county_fips: 21117,
    county_fips_all: '21117',
    county: 'Kenton',
    county_names_all: 'Kenton',
    county_weights: '{"21117": 100}',
    density: 35,
    imprecise: false,
    latitude: 38.85323,
    longitude: -84.49983,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41063',
  },
  {
    city: 'Mount Olivet',
    county_fips: 21201,
    county_fips_all: '21201|21023|21097',
    county: 'Robertson',
    county_names_all: 'Robertson|Bracken|Harrison',
    county_weights: '{"21201": 93.75, "21023": 5.43, "21097": 0.82}',
    density: 9.9,
    imprecise: false,
    latitude: 38.51462,
    longitude: -84.07106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41064',
  },
  {
    city: 'Newport',
    county_fips: 21037,
    county_fips_all: '21037',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"21037": 100}',
    density: 1381.6,
    imprecise: false,
    latitude: 39.0732,
    longitude: -84.48211,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41071',
  },
  {
    city: 'Bellevue',
    county_fips: 21037,
    county_fips_all: '21037',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"21037": 100}',
    density: 2403.5,
    imprecise: false,
    latitude: 39.10123,
    longitude: -84.47748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41073',
  },
  {
    city: 'Dayton',
    county_fips: 21037,
    county_fips_all: '21037',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"21037": 100}',
    density: 1532.4,
    imprecise: false,
    latitude: 39.11018,
    longitude: -84.4607,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41074',
  },
  {
    city: 'Fort Thomas',
    county_fips: 21037,
    county_fips_all: '21037',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"21037": 100}',
    density: 1140.9,
    imprecise: false,
    latitude: 39.07838,
    longitude: -84.45248,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41075',
  },
  {
    city: 'Newport',
    county_fips: 21037,
    county_fips_all: '21037',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"21037": 100}',
    density: 345.5,
    imprecise: false,
    latitude: 39.0178,
    longitude: -84.44084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41076',
  },
  {
    city: 'Petersburg',
    county_fips: 21015,
    county_fips_all: '21015',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"21015": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 39.0493,
    longitude: -84.82938,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41080',
  },
  {
    city: 'Sanders',
    county_fips: 21041,
    county_fips_all: '21041|21077|21187',
    county: 'Carroll',
    county_names_all: 'Carroll|Gallatin|Owen',
    county_weights: '{"21041": 62.23, "21077": 30.37, "21187": 7.4}',
    density: 16.2,
    imprecise: false,
    latitude: 38.67513,
    longitude: -84.98805,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41083',
  },
  {
    city: 'Silver Grove',
    county_fips: 21037,
    county_fips_all: '21037',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"21037": 100}',
    density: 727.3,
    imprecise: false,
    latitude: 39.03508,
    longitude: -84.39378,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41085',
  },
  {
    city: 'Sparta',
    county_fips: 21077,
    county_fips_all: '21077|21187',
    county: 'Gallatin',
    county_names_all: 'Gallatin|Owen',
    county_weights: '{"21077": 53.64, "21187": 46.36}',
    density: 18,
    imprecise: false,
    latitude: 38.69219,
    longitude: -84.88241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41086',
  },
  {
    city: 'Union',
    county_fips: 21015,
    county_fips_all: '21015',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"21015": 100}',
    density: 173.5,
    imprecise: false,
    latitude: 38.92056,
    longitude: -84.7379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41091',
  },
  {
    city: 'Verona',
    county_fips: 21015,
    county_fips_all: '21015|21077|21081',
    county: 'Boone',
    county_names_all: 'Boone|Gallatin|Grant',
    county_weights: '{"21015": 64.91, "21077": 33.23, "21081": 1.86}',
    density: 31.6,
    imprecise: false,
    latitude: 38.81811,
    longitude: -84.70115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41092',
  },
  {
    city: 'Wallingford',
    county_fips: 21069,
    county_fips_all: '21069|21135',
    county: 'Fleming',
    county_names_all: 'Fleming|Lewis',
    county_weights: '{"21069": 81.48, "21135": 18.52}',
    density: 9,
    imprecise: false,
    latitude: 38.39441,
    longitude: -83.56269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41093',
  },
  {
    city: 'Walton',
    county_fips: 21015,
    county_fips_all: '21015|21117',
    county: 'Boone',
    county_names_all: 'Boone|Kenton',
    county_weights: '{"21015": 62.7, "21117": 37.3}',
    density: 132.9,
    imprecise: false,
    latitude: 38.88213,
    longitude: -84.62292,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41094',
  },
  {
    city: 'Warsaw',
    county_fips: 21077,
    county_fips_all: '21077',
    county: 'Gallatin',
    county_names_all: 'Gallatin',
    county_weights: '{"21077": 100}',
    density: 57.3,
    imprecise: false,
    latitude: 38.79033,
    longitude: -84.81567,
    militaryZip: false,
    timezone: 'America/Indiana/Vevay',
    population: 4106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41095',
  },
  {
    city: 'Williamstown',
    county_fips: 21081,
    county_fips_all: '21081|21191',
    county: 'Grant',
    county_names_all: 'Grant|Pendleton',
    county_weights: '{"21081": 87.51, "21191": 12.49}',
    density: 31.5,
    imprecise: false,
    latitude: 38.62088,
    longitude: -84.58033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41097',
  },
  {
    city: 'Worthville',
    county_fips: 21187,
    county_fips_all: '21187|21041',
    county: 'Owen',
    county_names_all: 'Owen|Carroll',
    county_weights: '{"21187": 83.44, "21041": 16.56}',
    density: 10.7,
    imprecise: false,
    latitude: 38.59553,
    longitude: -84.99513,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41098',
  },
  {
    city: 'Ashland',
    county_fips: 21019,
    county_fips_all: '21019|21089',
    county: 'Boyd',
    county_names_all: 'Boyd|Greenup',
    county_weights: '{"21019": 82.64, "21089": 17.36}',
    density: 722.7,
    imprecise: false,
    latitude: 38.47392,
    longitude: -82.65045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41101',
  },
  {
    city: 'Ashland',
    county_fips: 21019,
    county_fips_all: '21019|21089|21043',
    county: 'Boyd',
    county_names_all: 'Boyd|Greenup|Carter',
    county_weights: '{"21019": 88.94, "21089": 9.7, "21043": 1.36}',
    density: 160,
    imprecise: false,
    latitude: 38.42045,
    longitude: -82.72425,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41102',
  },
  {
    city: 'Argillite',
    county_fips: 21089,
    county_fips_all: '21089',
    county: 'Greenup',
    county_names_all: 'Greenup',
    county_weights: '{"21089": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 38.44911,
    longitude: -82.83032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41121',
  },
  {
    city: 'Blaine',
    county_fips: 21127,
    county_fips_all: '21127',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"21127": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 38.02148,
    longitude: -82.85118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41124',
  },
  {
    city: 'Catlettsburg',
    county_fips: 21019,
    county_fips_all: '21019|21127',
    county: 'Boyd',
    county_names_all: 'Boyd|Lawrence',
    county_weights: '{"21019": 78.65, "21127": 21.35}',
    density: 39.7,
    imprecise: false,
    latitude: 38.31755,
    longitude: -82.64073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41129',
  },
  {
    city: 'Denton',
    county_fips: 21043,
    county_fips_all: '21043|21127',
    county: 'Carter',
    county_names_all: 'Carter|Lawrence',
    county_weights: '{"21043": 93.56, "21127": 6.44}',
    density: 14.5,
    imprecise: false,
    latitude: 38.25667,
    longitude: -82.8314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41132',
  },
  {
    city: 'Emerson',
    county_fips: 21135,
    county_fips_all: '21135',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"21135": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 38.36026,
    longitude: -83.28796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41135',
  },
  {
    city: 'Flatwoods',
    county_fips: 21089,
    county_fips_all: '21089',
    county: 'Greenup',
    county_names_all: 'Greenup',
    county_weights: '{"21089": 100}',
    density: 378.8,
    imprecise: false,
    latitude: 38.50927,
    longitude: -82.73288,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41139',
  },
  {
    city: 'Garrison',
    county_fips: 21135,
    county_fips_all: '21135|21089',
    county: 'Lewis',
    county_names_all: 'Lewis|Greenup',
    county_weights: '{"21135": 57.5, "21089": 42.5}',
    density: 14,
    imprecise: false,
    latitude: 38.54381,
    longitude: -83.13357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41141',
  },
  {
    city: 'Grahn',
    county_fips: 21043,
    county_fips_all: '21043',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"21043": 100}',
    density: 65.2,
    imprecise: false,
    latitude: 38.27774,
    longitude: -83.07308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41142',
  },
  {
    city: 'Grayson',
    county_fips: 21043,
    county_fips_all: '21043|21089',
    county: 'Carter',
    county_names_all: 'Carter|Greenup',
    county_weights: '{"21043": 90.48, "21089": 9.52}',
    density: 26.4,
    imprecise: false,
    latitude: 38.33916,
    longitude: -82.97704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41143',
  },
  {
    city: 'Greenup',
    county_fips: 21089,
    county_fips_all: '21089',
    county: 'Greenup',
    county_names_all: 'Greenup',
    county_weights: '{"21089": 100}',
    density: 24.8,
    imprecise: false,
    latitude: 38.53461,
    longitude: -82.91208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41144',
  },
  {
    city: 'Hitchins',
    county_fips: 21043,
    county_fips_all: '21043',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"21043": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 38.27701,
    longitude: -82.88969,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41146',
  },
  {
    city: 'Isonville',
    county_fips: 21063,
    county_fips_all: '21063',
    county: 'Elliott',
    county_names_all: 'Elliott',
    county_weights: '{"21063": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 38.06008,
    longitude: -83.05438,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41149',
  },
  {
    city: 'Martha',
    county_fips: 21127,
    county_fips_all: '21127',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"21127": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 38.01305,
    longitude: -82.96993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41159',
  },
  {
    city: 'Olive Hill',
    county_fips: 21043,
    county_fips_all: '21043|21063|21135|21205',
    county: 'Carter',
    county_names_all: 'Carter|Elliott|Lewis|Rowan',
    county_weights:
      '{"21043": 77.0, "21063": 22.43, "21135": 0.42, "21205": 0.15}',
    density: 20,
    imprecise: false,
    latitude: 38.28914,
    longitude: -83.16231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41164',
  },
  {
    city: 'Quincy',
    county_fips: 21135,
    county_fips_all: '21135',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"21135": 100}',
    density: 25,
    imprecise: false,
    latitude: 38.63464,
    longitude: -83.09328,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41166',
  },
  {
    city: 'Rush',
    county_fips: 21019,
    county_fips_all: '21019|21043',
    county: 'Boyd',
    county_names_all: 'Boyd|Carter',
    county_weights: '{"21019": 64.62, "21043": 35.38}',
    density: 24,
    imprecise: false,
    latitude: 38.30732,
    longitude: -82.76992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41168',
  },
  {
    city: 'Russell',
    county_fips: 21089,
    county_fips_all: '21089',
    county: 'Greenup',
    county_names_all: 'Greenup',
    county_weights: '{"21089": 100}',
    density: 345.3,
    imprecise: false,
    latitude: 38.52232,
    longitude: -82.71316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41169',
  },
  {
    city: 'Sandy Hook',
    county_fips: 21063,
    county_fips_all: '21063',
    county: 'Elliott',
    county_names_all: 'Elliott',
    county_weights: '{"21063": 100}',
    density: 15,
    imprecise: false,
    latitude: 38.09336,
    longitude: -83.08901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41171',
  },
  {
    city: 'South Portsmouth',
    county_fips: 21089,
    county_fips_all: '21089|21135',
    county: 'Greenup',
    county_names_all: 'Greenup|Lewis',
    county_weights: '{"21089": 73.66, "21135": 26.34}',
    density: 25,
    imprecise: false,
    latitude: 38.69841,
    longitude: -83.0139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41174',
  },
  {
    city: 'South Shore',
    county_fips: 21089,
    county_fips_all: '21089',
    county: 'Greenup',
    county_names_all: 'Greenup',
    county_weights: '{"21089": 100}',
    density: 27.3,
    imprecise: false,
    latitude: 38.64574,
    longitude: -82.97791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41175',
  },
  {
    city: 'Vanceburg',
    county_fips: 21135,
    county_fips_all: '21135',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"21135": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 38.52483,
    longitude: -83.38988,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41179',
  },
  {
    city: 'Webbville',
    county_fips: 21127,
    county_fips_all: '21127|21063|21043',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Elliott|Carter',
    county_weights: '{"21127": 74.2, "21063": 20.66, "21043": 5.14}',
    density: 3.3,
    imprecise: false,
    latitude: 38.13358,
    longitude: -82.85999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41180',
  },
  {
    city: 'Willard',
    county_fips: 21043,
    county_fips_all: '21043',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"21043": 100}',
    density: 9,
    imprecise: false,
    latitude: 38.20758,
    longitude: -82.87425,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41181',
  },
  {
    city: 'Worthington',
    county_fips: 21089,
    county_fips_all: '21089',
    county: 'Greenup',
    county_names_all: 'Greenup',
    county_weights: '{"21089": 100}',
    density: 449.8,
    imprecise: false,
    latitude: 38.55,
    longitude: -82.73707,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41183',
  },
  {
    city: 'Tollesboro',
    county_fips: 21135,
    county_fips_all: '21135',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"21135": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 38.54493,
    longitude: -83.56175,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41189',
  },
  {
    city: 'Adams',
    county_fips: 21127,
    county_fips_all: '21127',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"21127": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 38.06201,
    longitude: -82.7576,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41201',
  },
  {
    city: 'Beauty',
    county_fips: 21159,
    county_fips_all: '21159',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"21159": 100}',
    density: 39.5,
    imprecise: false,
    latitude: 37.85241,
    longitude: -82.46112,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41203',
  },
  {
    city: 'Boons Camp',
    county_fips: 21115,
    county_fips_all: '21115',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"21115": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 37.81784,
    longitude: -82.6843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41204',
  },
  {
    city: 'Debord',
    county_fips: 21159,
    county_fips_all: '21159',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"21159": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 37.79448,
    longitude: -82.59839,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41214',
  },
  {
    city: 'East Point',
    county_fips: 21071,
    county_fips_all: '21071|21115',
    county: 'Floyd',
    county_names_all: 'Floyd|Johnson',
    county_weights: '{"21071": 66.46, "21115": 33.54}',
    density: 22.3,
    imprecise: false,
    latitude: 37.73016,
    longitude: -82.81308,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41216',
  },
  {
    city: 'Flatgap',
    county_fips: 21115,
    county_fips_all: '21115|21175',
    county: 'Johnson',
    county_names_all: 'Johnson|Morgan',
    county_weights: '{"21115": 96.1, "21175": 3.9}',
    density: 18.2,
    imprecise: false,
    latitude: 37.92586,
    longitude: -82.90882,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41219',
  },
  {
    city: 'Hagerhill',
    county_fips: 21115,
    county_fips_all: '21115',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"21115": 100}',
    density: 34.6,
    imprecise: false,
    latitude: 37.77036,
    longitude: -82.85032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41222',
  },
  {
    city: 'Inez',
    county_fips: 21159,
    county_fips_all: '21159',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"21159": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 37.82089,
    longitude: -82.53936,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41224',
  },
  {
    city: 'Louisa',
    county_fips: 21127,
    county_fips_all: '21127|21159',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Martin',
    county_weights: '{"21127": 96.75, "21159": 3.25}',
    density: 21,
    imprecise: false,
    latitude: 38.0656,
    longitude: -82.66196,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41230',
  },
  {
    city: 'Lovely',
    county_fips: 21159,
    county_fips_all: '21159',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"21159": 100}',
    density: 38.5,
    imprecise: false,
    latitude: 37.79447,
    longitude: -82.38903,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41231',
  },
  {
    city: 'Lowmansville',
    county_fips: 21127,
    county_fips_all: '21127|21115',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Johnson',
    county_weights: '{"21127": 69.17, "21115": 30.83}',
    density: 6.2,
    imprecise: false,
    latitude: 37.93602,
    longitude: -82.74007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41232',
  },
  {
    city: 'Meally',
    county_fips: 21115,
    county_fips_all: '21115',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"21115": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 37.79654,
    longitude: -82.74161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41234',
  },
  {
    city: 'Oil Springs',
    county_fips: 21115,
    county_fips_all: '21115',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"21115": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 37.83943,
    longitude: -82.95072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41238',
  },
  {
    city: 'Paintsville',
    county_fips: 21115,
    county_fips_all: '21115',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"21115": 100}',
    density: 67.1,
    imprecise: false,
    latitude: 37.82103,
    longitude: -82.78927,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41240',
  },
  {
    city: 'Pilgrim',
    county_fips: 21159,
    county_fips_all: '21159',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"21159": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 37.73511,
    longitude: -82.46079,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41250',
  },
  {
    city: 'River',
    county_fips: 21115,
    county_fips_all: '21115|21127',
    county: 'Johnson',
    county_names_all: 'Johnson|Lawrence',
    county_weights: '{"21115": 92.23, "21127": 7.77}',
    density: 23.6,
    imprecise: false,
    latitude: 37.8845,
    longitude: -82.72711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41254',
  },
  {
    city: 'Sitka',
    county_fips: 21115,
    county_fips_all: '21115',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"21115": 100}',
    density: 21.8,
    imprecise: false,
    latitude: 37.91014,
    longitude: -82.83765,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41255',
  },
  {
    city: 'Staffordsville',
    county_fips: 21115,
    county_fips_all: '21115',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"21115": 100}',
    density: 41.9,
    imprecise: false,
    latitude: 37.82446,
    longitude: -82.88135,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41256',
  },
  {
    city: 'Stambaugh',
    county_fips: 21115,
    county_fips_all: '21115',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"21115": 100}',
    density: 29.6,
    imprecise: false,
    latitude: 37.91372,
    longitude: -82.8044,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41257',
  },
  {
    city: 'Thelma',
    county_fips: 21115,
    county_fips_all: '21115',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"21115": 100}',
    density: 123.5,
    imprecise: false,
    latitude: 37.82253,
    longitude: -82.75126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41260',
  },
  {
    city: 'Tomahawk',
    county_fips: 21159,
    county_fips_all: '21159',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"21159": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 37.85112,
    longitude: -82.61377,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41262',
  },
  {
    city: 'Tutor Key',
    county_fips: 21115,
    county_fips_all: '21115',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"21115": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 37.85717,
    longitude: -82.76256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41263',
  },
  {
    city: 'Ulysses',
    county_fips: 21127,
    county_fips_all: '21127',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"21127": 100}',
    density: 22,
    imprecise: false,
    latitude: 37.94021,
    longitude: -82.677,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41264',
  },
  {
    city: 'Van Lear',
    county_fips: 21115,
    county_fips_all: '21115|21071',
    county: 'Johnson',
    county_names_all: 'Johnson|Floyd',
    county_weights: '{"21115": 78.96, "21071": 21.04}',
    density: 15.9,
    imprecise: false,
    latitude: 37.75424,
    longitude: -82.70446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41265',
  },
  {
    city: 'Warfield',
    county_fips: 21159,
    county_fips_all: '21159',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"21159": 100}',
    density: 86.9,
    imprecise: false,
    latitude: 37.87514,
    longitude: -82.43591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41267',
  },
  {
    city: 'West Van Lear',
    county_fips: 21115,
    county_fips_all: '21115',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"21115": 100}',
    density: 1131.6,
    imprecise: false,
    latitude: 37.78797,
    longitude: -82.78433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41268',
  },
  {
    city: 'Williamsport',
    county_fips: 21115,
    county_fips_all: '21115',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"21115": 100}',
    density: 46.3,
    imprecise: false,
    latitude: 37.82773,
    longitude: -82.72453,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41271',
  },
  {
    city: 'Wittensville',
    county_fips: 21115,
    county_fips_all: '21115',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"21115": 100}',
    density: 54.2,
    imprecise: false,
    latitude: 37.86174,
    longitude: -82.81164,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41274',
  },
  {
    city: 'Campton',
    county_fips: 21237,
    county_fips_all: '21237|21025|21129',
    county: 'Wolfe',
    county_names_all: 'Wolfe|Breathitt|Lee',
    county_weights: '{"21237": 84.29, "21025": 7.93, "21129": 7.78}',
    density: 11,
    imprecise: false,
    latitude: 37.72121,
    longitude: -83.48941,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41301',
  },
  {
    city: 'Bays',
    county_fips: 21025,
    county_fips_all: '21025|21153',
    county: 'Breathitt',
    county_names_all: 'Breathitt|Magoffin',
    county_weights: '{"21025": 99.89, "21153": 0.11}',
    density: 0,
    imprecise: false,
    latitude: 37.64068,
    longitude: -83.25147,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41310',
  },
  {
    city: 'Beattyville',
    county_fips: 21129,
    county_fips_all: '21129|21189|21025',
    county: 'Lee',
    county_names_all: 'Lee|Owsley|Breathitt',
    county_weights: '{"21129": 98.62, "21189": 0.95, "21025": 0.43}',
    density: 14.3,
    imprecise: false,
    latitude: 37.57896,
    longitude: -83.72163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41311',
  },
  {
    city: 'Booneville',
    county_fips: 21189,
    county_fips_all: '21189|21025',
    county: 'Owsley',
    county_names_all: 'Owsley|Breathitt',
    county_weights: '{"21189": 74.77, "21025": 25.23}',
    density: 8.8,
    imprecise: false,
    latitude: 37.44008,
    longitude: -83.63743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41314',
  },
  {
    city: 'Clayhole',
    county_fips: 21025,
    county_fips_all: '21025',
    county: 'Breathitt',
    county_names_all: 'Breathitt',
    county_weights: '{"21025": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 37.46029,
    longitude: -83.19851,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41317',
  },
  {
    city: 'Hazel Green',
    county_fips: 21175,
    county_fips_all: '21175|21237',
    county: 'Morgan',
    county_names_all: 'Morgan|Wolfe',
    county_weights: '{"21175": 61.2, "21237": 38.8}',
    density: 7.9,
    imprecise: false,
    latitude: 37.80029,
    longitude: -83.37575,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41332',
  },
  {
    city: 'Jackson',
    county_fips: 21025,
    county_fips_all: '21025|21119|21129',
    county: 'Breathitt',
    county_names_all: 'Breathitt|Knott|Lee',
    county_weights: '{"21025": 92.02, "21119": 6.55, "21129": 1.43}',
    density: 12.4,
    imprecise: false,
    latitude: 37.53158,
    longitude: -83.29231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41339',
  },
  {
    city: 'Lost Creek',
    county_fips: 21025,
    county_fips_all: '21025',
    county: 'Breathitt',
    county_names_all: 'Breathitt',
    county_weights: '{"21025": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 37.42577,
    longitude: -83.31387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41348',
  },
  {
    city: 'Mistletoe',
    county_fips: 21189,
    county_fips_all: '21189',
    county: 'Owsley',
    county_names_all: 'Owsley',
    county_weights: '{"21189": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 37.32754,
    longitude: -83.59363,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41351',
  },
  {
    city: 'Mize',
    county_fips: 21175,
    county_fips_all: '21175',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"21175": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 37.82357,
    longitude: -83.33511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41352',
  },
  {
    city: 'Pine Ridge',
    county_fips: 21237,
    county_fips_all: '21237|21197',
    county: 'Wolfe',
    county_names_all: 'Wolfe|Powell',
    county_weights: '{"21237": 98.91, "21197": 1.09}',
    density: 5.3,
    imprecise: false,
    latitude: 37.78889,
    longitude: -83.6264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41360',
  },
  {
    city: 'Ricetown',
    county_fips: 21189,
    county_fips_all: '21189',
    county: 'Owsley',
    county_names_all: 'Owsley',
    county_weights: '{"21189": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 37.37569,
    longitude: -83.64172,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41364',
  },
  {
    city: 'Rogers',
    county_fips: 21237,
    county_fips_all: '21237',
    county: 'Wolfe',
    county_names_all: 'Wolfe',
    county_weights: '{"21237": 100}',
    density: 19.6,
    imprecise: false,
    latitude: 37.71117,
    longitude: -83.62663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41365',
  },
  {
    city: 'Rousseau',
    county_fips: 21025,
    county_fips_all: '21025',
    county: 'Breathitt',
    county_names_all: 'Breathitt',
    county_weights: '{"21025": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.62472,
    longitude: -83.21959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41366',
  },
  {
    city: 'Rowdy',
    county_fips: 21193,
    county_fips_all: '21193',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"21193": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 37.4045,
    longitude: -83.23218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41367',
  },
  {
    city: 'Vancleve',
    county_fips: 21025,
    county_fips_all: '21025',
    county: 'Breathitt',
    county_names_all: 'Breathitt',
    county_weights: '{"21025": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 37.64998,
    longitude: -83.33665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41385',
  },
  {
    city: 'Vincent',
    county_fips: 21189,
    county_fips_all: '21189',
    county: 'Owsley',
    county_names_all: 'Owsley',
    county_weights: '{"21189": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 37.47992,
    longitude: -83.79273,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41386',
  },
  {
    city: 'Whick',
    county_fips: 21025,
    county_fips_all: '21025',
    county: 'Breathitt',
    county_names_all: 'Breathitt',
    county_weights: '{"21025": 100}',
    density: 55.3,
    imprecise: false,
    latitude: 37.41872,
    longitude: -83.3792,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41390',
  },
  {
    city: 'Zoe',
    county_fips: 21129,
    county_fips_all: '21129',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"21129": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 37.66683,
    longitude: -83.67709,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41397',
  },
  {
    city: 'Cannel City',
    county_fips: 21175,
    county_fips_all: '21175',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"21175": 100}',
    density: 32,
    imprecise: false,
    latitude: 37.79508,
    longitude: -83.28828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41408',
  },
  {
    city: 'Elkfork',
    county_fips: 21175,
    county_fips_all: '21175',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"21175": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 37.99027,
    longitude: -83.17397,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41421',
  },
  {
    city: 'Ezel',
    county_fips: 21175,
    county_fips_all: '21175|21237',
    county: 'Morgan',
    county_names_all: 'Morgan|Wolfe',
    county_weights: '{"21175": 98.79, "21237": 1.21}',
    density: 16.3,
    imprecise: false,
    latitude: 37.88407,
    longitude: -83.42761,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41425',
  },
  {
    city: 'Royalton',
    county_fips: 21153,
    county_fips_all: '21153',
    county: 'Magoffin',
    county_names_all: 'Magoffin',
    county_weights: '{"21153": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 37.65974,
    longitude: -82.97201,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41464',
  },
  {
    city: 'Salyersville',
    county_fips: 21153,
    county_fips_all: '21153',
    county: 'Magoffin',
    county_names_all: 'Magoffin',
    county_weights: '{"21153": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 37.72985,
    longitude: -83.08494,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41465',
  },
  {
    city: 'West Liberty',
    county_fips: 21175,
    county_fips_all: '21175|21063',
    county: 'Morgan',
    county_names_all: 'Morgan|Elliott',
    county_weights: '{"21175": 99.13, "21063": 0.87}',
    density: 15.4,
    imprecise: false,
    latitude: 37.94179,
    longitude: -83.22334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41472',
  },
  {
    city: 'Pikeville',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 47.7,
    imprecise: false,
    latitude: 37.50805,
    longitude: -82.5154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41501',
  },
  {
    city: 'South Williamson',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 77.7,
    imprecise: false,
    latitude: 37.66079,
    longitude: -82.28446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41503',
  },
  {
    city: 'Ashcamp',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 37.25251,
    longitude: -82.47772,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41512',
  },
  {
    city: 'Belcher',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 37.35282,
    longitude: -82.34329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41513',
  },
  {
    city: 'Belfry',
    county_fips: 21195,
    county_fips_all: '21195|21159',
    county: 'Pike',
    county_names_all: 'Pike|Martin',
    county_weights: '{"21195": 97.97, "21159": 2.03}',
    density: 20,
    imprecise: false,
    latitude: 37.67135,
    longitude: -82.33169,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41514',
  },
  {
    city: 'Burdine',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 1245.6,
    imprecise: false,
    latitude: 37.18919,
    longitude: -82.60026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41517',
  },
  {
    city: 'Canada',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 30.8,
    imprecise: false,
    latitude: 37.58359,
    longitude: -82.32334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41519',
  },
  {
    city: 'Elkhorn City',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 23.9,
    imprecise: false,
    latitude: 37.31644,
    longitude: -82.40088,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41522',
  },
  {
    city: 'Fedscreek',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 37.43345,
    longitude: -82.23444,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41524',
  },
  {
    city: 'Forest Hills',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 55.9,
    imprecise: false,
    latitude: 37.63187,
    longitude: -82.29378,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41527',
  },
  {
    city: 'Freeburn',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 23.3,
    imprecise: false,
    latitude: 37.55458,
    longitude: -82.13984,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41528',
  },
  {
    city: 'Hardy',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 34.1,
    imprecise: false,
    latitude: 37.59509,
    longitude: -82.23131,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41531',
  },
  {
    city: 'Hellier',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 37.27748,
    longitude: -82.49644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41534',
  },
  {
    city: 'Huddy',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 87.9,
    imprecise: false,
    latitude: 37.59368,
    longitude: -82.28422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41535',
  },
  {
    city: 'Jenkins',
    county_fips: 21133,
    county_fips_all: '21133|21195',
    county: 'Letcher',
    county_names_all: 'Letcher|Pike',
    county_weights: '{"21133": 50.86, "21195": 49.14}',
    density: 24.3,
    imprecise: false,
    latitude: 37.22221,
    longitude: -82.61619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41537',
  },
  {
    city: 'Jonancy',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 45,
    imprecise: false,
    latitude: 37.30338,
    longitude: -82.58891,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41538',
  },
  {
    city: 'Kimper',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 37.50265,
    longitude: -82.32231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41539',
  },
  {
    city: 'Lick Creek',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 37.39013,
    longitude: -82.32318,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41540',
  },
  {
    city: 'McAndrews',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 35.8,
    imprecise: false,
    latitude: 37.54837,
    longitude: -82.28226,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41543',
  },
  {
    city: 'McCarr',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 37.59602,
    longitude: -82.17368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41544',
  },
  {
    city: 'Majestic',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 37.53821,
    longitude: -82.09437,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41547',
  },
  {
    city: 'Mouthcard',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 37.37847,
    longitude: -82.25372,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41548',
  },
  {
    city: 'Phelps',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 22.7,
    imprecise: false,
    latitude: 37.48057,
    longitude: -82.16025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41553',
  },
  {
    city: 'Phyllis',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 25.6,
    imprecise: false,
    latitude: 37.43919,
    longitude: -82.32446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41554',
  },
  {
    city: 'Pinsonfork',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 47.2,
    imprecise: false,
    latitude: 37.53816,
    longitude: -82.2589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41555',
  },
  {
    city: 'Raccoon',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 32.5,
    imprecise: false,
    latitude: 37.48189,
    longitude: -82.41548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41557',
  },
  {
    city: 'Ransom',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 37.53953,
    longitude: -82.20819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41558',
  },
  {
    city: 'Regina',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 37.37997,
    longitude: -82.39017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41559',
  },
  {
    city: 'Robinson Creek',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 23.3,
    imprecise: false,
    latitude: 37.39423,
    longitude: -82.57875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41560',
  },
  {
    city: 'Shelbiana',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 35.2,
    imprecise: false,
    latitude: 37.3991,
    longitude: -82.47052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41562',
  },
  {
    city: 'Sidney',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 37.60476,
    longitude: -82.3667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41564',
  },
  {
    city: 'Steele',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 37.40836,
    longitude: -82.1922,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41566',
  },
  {
    city: 'Stone',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 37.56897,
    longitude: -82.28621,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 78,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41567',
  },
  {
    city: 'Stopover',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 37.50369,
    longitude: -82.05896,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41568',
  },
  {
    city: 'Varney',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 37.62651,
    longitude: -82.44437,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41571',
  },
  {
    city: 'Virgie',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 27.6,
    imprecise: false,
    latitude: 37.31342,
    longitude: -82.64368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41572',
  },
  {
    city: 'Allen',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 38.1,
    imprecise: false,
    latitude: 37.60969,
    longitude: -82.72037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41601',
  },
  {
    city: 'Auxier',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 94.4,
    imprecise: false,
    latitude: 37.7387,
    longitude: -82.75249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41602',
  },
  {
    city: 'Banner',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 51.7,
    imprecise: false,
    latitude: 37.55934,
    longitude: -82.68704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41603',
  },
  {
    city: 'Beaver',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 37.38986,
    longitude: -82.66782,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41604',
  },
  {
    city: 'Betsy Layne',
    county_fips: 21071,
    county_fips_all: '21071|21195',
    county: 'Floyd',
    county_names_all: 'Floyd|Pike',
    county_weights: '{"21071": 72.77, "21195": 27.23}',
    density: 71.5,
    imprecise: false,
    latitude: 37.55498,
    longitude: -82.63009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41605',
  },
  {
    city: 'Bevinsville',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 5,
    imprecise: false,
    latitude: 37.34594,
    longitude: -82.7375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41606',
  },
  {
    city: 'Blue River',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 37.62216,
    longitude: -82.8438,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41607',
  },
  {
    city: 'Dana',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 61.8,
    imprecise: false,
    latitude: 37.54211,
    longitude: -82.68337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41615',
  },
  {
    city: 'David',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 18,
    imprecise: false,
    latitude: 37.58522,
    longitude: -82.87847,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41616',
  },
  {
    city: 'Drift',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 37.48328,
    longitude: -82.74187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41619',
  },
  {
    city: 'Dwale',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 82.9,
    imprecise: false,
    latitude: 37.6269,
    longitude: -82.72663,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41621',
  },
  {
    city: 'Eastern',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 37.51377,
    longitude: -82.80925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41622',
  },
  {
    city: 'Garrett',
    county_fips: 21071,
    county_fips_all: '21071|21119',
    county: 'Floyd',
    county_names_all: 'Floyd|Knott',
    county_weights: '{"21071": 54.14, "21119": 45.86}',
    density: 20.8,
    imprecise: false,
    latitude: 37.46416,
    longitude: -82.84992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41630',
  },
  {
    city: 'Grethel',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 43.5,
    imprecise: false,
    latitude: 37.46801,
    longitude: -82.65365,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41631',
  },
  {
    city: 'Gunlock',
    county_fips: 21153,
    county_fips_all: '21153',
    county: 'Magoffin',
    county_names_all: 'Magoffin',
    county_weights: '{"21153": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 37.55029,
    longitude: -82.94982,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41632',
  },
  {
    city: 'Harold',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 56.2,
    imprecise: false,
    latitude: 37.48009,
    longitude: -82.62831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41635',
  },
  {
    city: 'Hi Hat',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 29.4,
    imprecise: false,
    latitude: 37.39772,
    longitude: -82.73087,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41636',
  },
  {
    city: 'Hueysville',
    county_fips: 21119,
    county_fips_all: '21119|21071|21153',
    county: 'Knott',
    county_names_all: 'Knott|Floyd|Magoffin',
    county_weights: '{"21119": 56.11, "21071": 35.35, "21153": 8.54}',
    density: 9.4,
    imprecise: false,
    latitude: 37.47649,
    longitude: -82.92643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41640',
  },
  {
    city: 'Ivel',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 43.5,
    imprecise: false,
    latitude: 37.59569,
    longitude: -82.64457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41642',
  },
  {
    city: 'Lackey',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 37.43778,
    longitude: -82.84307,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41643',
  },
  {
    city: 'Langley',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 37.2,
    imprecise: false,
    latitude: 37.52872,
    longitude: -82.79294,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41645',
  },
  {
    city: 'McDowell',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 37.43056,
    longitude: -82.71737,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41647',
  },
  {
    city: 'Martin',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 34,
    imprecise: false,
    latitude: 37.57139,
    longitude: -82.78337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41649',
  },
  {
    city: 'Melvin',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 41.4,
    imprecise: false,
    latitude: 37.34722,
    longitude: -82.68166,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41650',
  },
  {
    city: 'Minnie',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 241.2,
    imprecise: false,
    latitude: 37.46716,
    longitude: -82.75527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41651',
  },
  {
    city: 'Prestonsburg',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 34.2,
    imprecise: false,
    latitude: 37.6603,
    longitude: -82.76466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41653',
  },
  {
    city: 'Printer',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 25.1,
    imprecise: false,
    latitude: 37.50496,
    longitude: -82.72465,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41655',
  },
  {
    city: 'Stanville',
    county_fips: 21195,
    county_fips_all: '21195|21071',
    county: 'Pike',
    county_names_all: 'Pike|Floyd',
    county_weights: '{"21195": 74.29, "21071": 25.71}',
    density: 35.8,
    imprecise: false,
    latitude: 37.58415,
    longitude: -82.60064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41659',
  },
  {
    city: 'Teaberry',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 28.3,
    imprecise: false,
    latitude: 37.41341,
    longitude: -82.63846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41660',
  },
  {
    city: 'Tram',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 53.2,
    imprecise: false,
    latitude: 37.56844,
    longitude: -82.65966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41663',
  },
  {
    city: 'Wayland',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 26.8,
    imprecise: false,
    latitude: 37.4396,
    longitude: -82.80621,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41666',
  },
  {
    city: 'Weeksbury',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 28.2,
    imprecise: false,
    latitude: 37.31138,
    longitude: -82.69881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41667',
  },
  {
    city: 'Wheelwright',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 145.1,
    imprecise: false,
    latitude: 37.33375,
    longitude: -82.71469,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41669',
  },
  {
    city: 'Hazard',
    county_fips: 21193,
    county_fips_all: '21193|21119',
    county: 'Perry',
    county_names_all: 'Perry|Knott',
    county_weights: '{"21193": 78.55, "21119": 21.45}',
    density: 48,
    imprecise: false,
    latitude: 37.29778,
    longitude: -83.18781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41701',
  },
  {
    city: 'Ary',
    county_fips: 21193,
    county_fips_all: '21193',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"21193": 100}',
    density: 60.9,
    imprecise: false,
    latitude: 37.3744,
    longitude: -83.13751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41712',
  },
  {
    city: 'Avawam',
    county_fips: 21193,
    county_fips_all: '21193',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"21193": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.22703,
    longitude: -83.27799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41713',
  },
  {
    city: 'Bear Branch',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 37.16519,
    longitude: -83.5075,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41714',
  },
  {
    city: 'Bonnyman',
    county_fips: 21193,
    county_fips_all: '21193',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"21193": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 37.29727,
    longitude: -83.24526,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41719',
  },
  {
    city: 'Buckhorn',
    county_fips: 21193,
    county_fips_all: '21193|21189|21025',
    county: 'Perry',
    county_names_all: 'Perry|Owsley|Breathitt',
    county_weights: '{"21193": 77.56, "21189": 11.39, "21025": 11.04}',
    density: 3.5,
    imprecise: false,
    latitude: 37.31371,
    longitude: -83.49949,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41721',
  },
  {
    city: 'Bulan',
    county_fips: 21119,
    county_fips_all: '21119|21193',
    county: 'Knott',
    county_names_all: 'Knott|Perry',
    county_weights: '{"21119": 79.14, "21193": 20.86}',
    density: 9.2,
    imprecise: false,
    latitude: 37.40441,
    longitude: -83.10329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41722',
  },
  {
    city: 'Busy',
    county_fips: 21193,
    county_fips_all: '21193|21131',
    county: 'Perry',
    county_names_all: 'Perry|Leslie',
    county_weights: '{"21193": 77.42, "21131": 22.58}',
    density: 23.5,
    imprecise: false,
    latitude: 37.25469,
    longitude: -83.31409,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41723',
  },
  {
    city: 'Carrie',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 37.31667,
    longitude: -83.03244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41725',
  },
  {
    city: 'Chavies',
    county_fips: 21193,
    county_fips_all: '21193',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"21193": 100}',
    density: 39.7,
    imprecise: false,
    latitude: 37.35624,
    longitude: -83.32352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41727',
  },
  {
    city: 'Combs',
    county_fips: 21193,
    county_fips_all: '21193',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"21193": 100}',
    density: 104.7,
    imprecise: false,
    latitude: 37.2681,
    longitude: -83.2159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41729',
  },
  {
    city: 'Cornettsville',
    county_fips: 21193,
    county_fips_all: '21193|21133',
    county: 'Perry',
    county_names_all: 'Perry|Letcher',
    county_weights: '{"21193": 76.28, "21133": 23.72}',
    density: 9.8,
    imprecise: false,
    latitude: 37.10312,
    longitude: -83.08393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41731',
  },
  {
    city: 'Delphia',
    county_fips: 21193,
    county_fips_all: '21193',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"21193": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 37.01793,
    longitude: -83.09963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41735',
  },
  {
    city: 'Dwarf',
    county_fips: 21193,
    county_fips_all: '21193',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"21193": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 37.32596,
    longitude: -83.12802,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41739',
  },
  {
    city: 'Emmalena',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 37.35649,
    longitude: -83.0467,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41740',
  },
  {
    city: 'Gays Creek',
    county_fips: 21193,
    county_fips_all: '21193|21025',
    county: 'Perry',
    county_names_all: 'Perry|Breathitt',
    county_weights: '{"21193": 84.31, "21025": 15.69}',
    density: 47.6,
    imprecise: false,
    latitude: 37.34449,
    longitude: -83.42848,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41745',
  },
  {
    city: 'Happy',
    county_fips: 21193,
    county_fips_all: '21193',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"21193": 100}',
    density: 61.2,
    imprecise: false,
    latitude: 37.21574,
    longitude: -83.09779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41746',
  },
  {
    city: 'Hyden',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 37.19364,
    longitude: -83.4199,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41749',
  },
  {
    city: 'Jeff',
    county_fips: 21193,
    county_fips_all: '21193|21119',
    county: 'Perry',
    county_names_all: 'Perry|Knott',
    county_weights: '{"21193": 99.85, "21119": 0.15}',
    density: 28.2,
    imprecise: false,
    latitude: 37.2196,
    longitude: -83.12659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41751',
  },
  {
    city: 'Krypton',
    county_fips: 21193,
    county_fips_all: '21193|21131',
    county: 'Perry',
    county_names_all: 'Perry|Leslie',
    county_weights: '{"21193": 81.43, "21131": 18.57}',
    density: 28.3,
    imprecise: false,
    latitude: 37.30025,
    longitude: -83.32459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41754',
  },
  {
    city: 'Sassafras',
    county_fips: 21119,
    county_fips_all: '21119|21193',
    county: 'Knott',
    county_names_all: 'Knott|Perry',
    county_weights: '{"21119": 99.72, "21193": 0.28}',
    density: 31,
    imprecise: false,
    latitude: 37.23211,
    longitude: -83.02521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41759',
  },
  {
    city: 'Scuddy',
    county_fips: 21193,
    county_fips_all: '21193',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"21193": 100}',
    density: 73.8,
    imprecise: false,
    latitude: 37.19456,
    longitude: -83.08588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41760',
  },
  {
    city: 'Sizerock',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 7,
    imprecise: false,
    latitude: 37.20742,
    longitude: -83.50077,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41762',
  },
  {
    city: 'Slemp',
    county_fips: 21193,
    county_fips_all: '21193',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"21193": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 37.05439,
    longitude: -83.12157,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41763',
  },
  {
    city: 'Smilax',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 13,
    imprecise: false,
    latitude: 37.12924,
    longitude: -83.25545,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41764',
  },
  {
    city: 'Thousandsticks',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 48,
    imprecise: false,
    latitude: 37.18526,
    longitude: -83.44443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41766',
  },
  {
    city: 'Vest',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 37.4075,
    longitude: -83.01679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41772',
  },
  {
    city: 'Vicco',
    county_fips: 21119,
    county_fips_all: '21119|21193',
    county: 'Knott',
    county_names_all: 'Knott|Perry',
    county_weights: '{"21119": 50.91, "21193": 49.09}',
    density: 19.9,
    imprecise: false,
    latitude: 37.23534,
    longitude: -83.01721,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41773',
  },
  {
    city: 'Viper',
    county_fips: 21193,
    county_fips_all: '21193',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"21193": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 37.15512,
    longitude: -83.13847,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41774',
  },
  {
    city: 'Wendover',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 37.09373,
    longitude: -83.34207,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41775',
  },
  {
    city: 'Wooton',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 37.15933,
    longitude: -83.28158,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41776',
  },
  {
    city: 'Yeaddiss',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 37.06022,
    longitude: -83.23276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41777',
  },
  {
    city: 'Yerkes',
    county_fips: 21193,
    county_fips_all: '21193',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"21193": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 37.26612,
    longitude: -83.3223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41778',
  },
  {
    city: 'Blackey',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 39.3,
    imprecise: false,
    latitude: 37.14923,
    longitude: -82.98993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41804',
  },
  {
    city: 'Cromona',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 53,
    imprecise: false,
    latitude: 37.18492,
    longitude: -82.67278,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41810',
  },
  {
    city: 'Deane',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 37.2473,
    longitude: -82.74445,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41812',
  },
  {
    city: 'Ermine',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 42.8,
    imprecise: false,
    latitude: 37.15821,
    longitude: -82.79799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41815',
  },
  {
    city: 'Garner',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 37.35922,
    longitude: -82.90038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41817',
  },
  {
    city: 'Gordon',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 6,
    imprecise: false,
    latitude: 36.99191,
    longitude: -83.07788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41819',
  },
  {
    city: 'Hallie',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 37.07563,
    longitude: -83.00711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41821',
  },
  {
    city: 'Hindman',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 42.6,
    imprecise: false,
    latitude: 37.31991,
    longitude: -82.97848,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41822',
  },
  {
    city: 'Isom',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 52.4,
    imprecise: false,
    latitude: 37.18771,
    longitude: -82.88015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41824',
  },
  {
    city: 'Jackhorn',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 37.23323,
    longitude: -82.70854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41825',
  },
  {
    city: 'Jeremiah',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 29,
    imprecise: false,
    latitude: 37.17348,
    longitude: -82.92115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41826',
  },
  {
    city: 'Kite',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 37.2971,
    longitude: -82.78444,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41828',
  },
  {
    city: 'Leburn',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 37.38531,
    longitude: -82.94633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41831',
  },
  {
    city: 'Letcher',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 37.15286,
    longitude: -82.9548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41832',
  },
  {
    city: 'Linefork',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 37.02919,
    longitude: -82.97323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41833',
  },
  {
    city: 'Littcarr',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 14,
    imprecise: false,
    latitude: 37.26585,
    longitude: -82.94661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41834',
  },
  {
    city: 'McRoberts',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 34.5,
    imprecise: false,
    latitude: 37.21196,
    longitude: -82.67114,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41835',
  },
  {
    city: 'Mallie',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 20.1,
    imprecise: false,
    latitude: 37.25839,
    longitude: -82.90887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41836',
  },
  {
    city: 'Mayking',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 40.1,
    imprecise: false,
    latitude: 37.1215,
    longitude: -82.75231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41837',
  },
  {
    city: 'Millstone',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 31.5,
    imprecise: false,
    latitude: 37.19677,
    longitude: -82.75144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41838',
  },
  {
    city: 'Mousie',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 37.42041,
    longitude: -82.87741,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41839',
  },
  {
    city: 'Neon',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 96.9,
    imprecise: false,
    latitude: 37.19962,
    longitude: -82.71813,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41840',
  },
  {
    city: 'Pine Top',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 37.27495,
    longitude: -82.85938,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41843',
  },
  {
    city: 'Pippa Passes',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 37.32916,
    longitude: -82.8643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41844',
  },
  {
    city: 'Premium',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 37.1396,
    longitude: -82.90301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41845',
  },
  {
    city: 'Redfox',
    county_fips: 21119,
    county_fips_all: '21119|21133',
    county: 'Knott',
    county_names_all: 'Knott|Letcher',
    county_weights: '{"21119": 99.89, "21133": 0.11}',
    density: 8,
    imprecise: false,
    latitude: 37.20823,
    longitude: -82.95961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41847',
  },
  {
    city: 'Roxana',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 37.11491,
    longitude: -82.94384,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41848',
  },
  {
    city: 'Seco',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 37.1744,
    longitude: -82.73251,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 75,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41849',
  },
  {
    city: 'Thornton',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 36.9,
    imprecise: false,
    latitude: 37.18874,
    longitude: -82.78496,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41855',
  },
  {
    city: 'Whitesburg',
    county_fips: 21133,
    county_fips_all: '21133',
    county: 'Letcher',
    county_names_all: 'Letcher',
    county_weights: '{"21133": 100}',
    density: 31.1,
    imprecise: false,
    latitude: 37.1454,
    longitude: -82.84697,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41858',
  },
  {
    city: 'Topmost',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 37.34971,
    longitude: -82.78929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41862',
  },
  {
    city: 'Paducah',
    county_fips: 21145,
    county_fips_all: '21145',
    county: 'McCracken',
    county_names_all: 'McCracken',
    county_weights: '{"21145": 100}',
    density: 160.5,
    imprecise: false,
    latitude: 37.03317,
    longitude: -88.7135,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42001',
  },
  {
    city: 'Paducah',
    county_fips: 21145,
    county_fips_all: '21145|21083',
    county: 'McCracken',
    county_names_all: 'McCracken|Graves',
    county_weights: '{"21145": 99.18, "21083": 0.82}',
    density: 166,
    imprecise: false,
    latitude: 37.00653,
    longitude: -88.58472,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42003',
  },
  {
    city: 'Almo',
    county_fips: 21035,
    county_fips_all: '21035',
    county: 'Calloway',
    county_names_all: 'Calloway',
    county_weights: '{"21035": 100}',
    density: 39.4,
    imprecise: false,
    latitude: 36.68913,
    longitude: -88.29145,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42020',
  },
  {
    city: 'Arlington',
    county_fips: 21039,
    county_fips_all: '21039|21105',
    county: 'Carlisle',
    county_names_all: 'Carlisle|Hickman',
    county_weights: '{"21039": 90.26, "21105": 9.74}',
    density: 7.4,
    imprecise: false,
    latitude: 36.80129,
    longitude: -88.9957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42021',
  },
  {
    city: 'Bandana',
    county_fips: 21007,
    county_fips_all: '21007',
    county: 'Ballard',
    county_names_all: 'Ballard',
    county_weights: '{"21007": 100}',
    density: 155.5,
    imprecise: false,
    latitude: 37.14593,
    longitude: -88.94553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42022',
  },
  {
    city: 'Bardwell',
    county_fips: 21039,
    county_fips_all: '21039',
    county: 'Carlisle',
    county_names_all: 'Carlisle',
    county_weights: '{"21039": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 36.87623,
    longitude: -88.98742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42023',
  },
  {
    city: 'Barlow',
    county_fips: 21007,
    county_fips_all: '21007',
    county: 'Ballard',
    county_names_all: 'Ballard',
    county_weights: '{"21007": 100}',
    density: 10,
    imprecise: false,
    latitude: 37.0742,
    longitude: -89.05026,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42024',
  },
  {
    city: 'Benton',
    county_fips: 21157,
    county_fips_all: '21157|21083|21035',
    county: 'Marshall',
    county_names_all: 'Marshall|Graves|Calloway',
    county_weights: '{"21157": 96.43, "21083": 2.15, "21035": 1.42}',
    density: 38.6,
    imprecise: false,
    latitude: 36.85764,
    longitude: -88.33441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42025',
  },
  {
    city: 'Boaz',
    county_fips: 21083,
    county_fips_all: '21083|21145',
    county: 'Graves',
    county_names_all: 'Graves|McCracken',
    county_weights: '{"21083": 85.7, "21145": 14.3}',
    density: 15.7,
    imprecise: false,
    latitude: 36.91585,
    longitude: -88.63018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42027',
  },
  {
    city: 'Burna',
    county_fips: 21139,
    county_fips_all: '21139',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"21139": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 37.23637,
    longitude: -88.33946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42028',
  },
  {
    city: 'Calvert City',
    county_fips: 21157,
    county_fips_all: '21157',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"21157": 100}',
    density: 46.5,
    imprecise: false,
    latitude: 37.00963,
    longitude: -88.38947,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42029',
  },
  {
    city: 'Clinton',
    county_fips: 21105,
    county_fips_all: '21105',
    county: 'Hickman',
    county_names_all: 'Hickman',
    county_weights: '{"21105": 100}',
    density: 9,
    imprecise: false,
    latitude: 36.68741,
    longitude: -88.98864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42031',
  },
  {
    city: 'Columbus',
    county_fips: 21105,
    county_fips_all: '21105',
    county: 'Hickman',
    county_names_all: 'Hickman',
    county_weights: '{"21105": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 36.751,
    longitude: -89.10378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42032',
  },
  {
    city: 'Cunningham',
    county_fips: 21039,
    county_fips_all: '21039|21083',
    county: 'Carlisle',
    county_names_all: 'Carlisle|Graves',
    county_weights: '{"21039": 77.72, "21083": 22.28}',
    density: 11.8,
    imprecise: false,
    latitude: 36.90392,
    longitude: -88.83674,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42035',
  },
  {
    city: 'Dexter',
    county_fips: 21035,
    county_fips_all: '21035|21157',
    county: 'Calloway',
    county_names_all: 'Calloway|Marshall',
    county_weights: '{"21035": 98.6, "21157": 1.4}',
    density: 16.7,
    imprecise: false,
    latitude: 36.72246,
    longitude: -88.23048,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42036',
  },
  {
    city: 'Dycusburg',
    county_fips: 21055,
    county_fips_all: '21055',
    county: 'Crittenden',
    county_names_all: 'Crittenden',
    county_weights: '{"21055": 100}',
    density: 110.9,
    imprecise: false,
    latitude: 37.15843,
    longitude: -88.18441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42037',
  },
  {
    city: 'Eddyville',
    county_fips: 21143,
    county_fips_all: '21143|21033',
    county: 'Lyon',
    county_names_all: 'Lyon|Caldwell',
    county_weights: '{"21143": 98.65, "21033": 1.35}',
    density: 28,
    imprecise: false,
    latitude: 37.04137,
    longitude: -88.02364,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42038',
  },
  {
    city: 'Fancy Farm',
    county_fips: 21083,
    county_fips_all: '21083|21105|21039',
    county: 'Graves',
    county_names_all: 'Graves|Hickman|Carlisle',
    county_weights: '{"21083": 33.86, "21105": 33.52, "21039": 32.62}',
    density: 13.4,
    imprecise: false,
    latitude: 36.78535,
    longitude: -88.82809,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42039',
  },
  {
    city: 'Farmington',
    county_fips: 21083,
    county_fips_all: '21083|21035',
    county: 'Graves',
    county_names_all: 'Graves|Calloway',
    county_weights: '{"21083": 79.55, "21035": 20.45}',
    density: 8.4,
    imprecise: false,
    latitude: 36.62454,
    longitude: -88.50371,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42040',
  },
  {
    city: 'Fulton',
    county_fips: 21075,
    county_fips_all: '21075|21083|21105',
    county: 'Fulton',
    county_names_all: 'Fulton|Graves|Hickman',
    county_weights: '{"21075": 49.42, "21083": 27.82, "21105": 22.76}',
    density: 15.9,
    imprecise: false,
    latitude: 36.54593,
    longitude: -88.87456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42041',
  },
  {
    city: 'Gilbertsville',
    county_fips: 21157,
    county_fips_all: '21157',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"21157": 100}',
    density: 63.7,
    imprecise: false,
    latitude: 36.95744,
    longitude: -88.26417,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42044',
  },
  {
    city: 'Grand Rivers',
    county_fips: 21139,
    county_fips_all: '21139',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"21139": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 37.072,
    longitude: -88.26453,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42045',
  },
  {
    city: 'Hampton',
    county_fips: 21139,
    county_fips_all: '21139',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"21139": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 37.30061,
    longitude: -88.39046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42047',
  },
  {
    city: 'Hardin',
    county_fips: 21157,
    county_fips_all: '21157|21035',
    county: 'Marshall',
    county_names_all: 'Marshall|Calloway',
    county_weights: '{"21157": 93.36, "21035": 6.64}',
    density: 30.1,
    imprecise: false,
    latitude: 36.76676,
    longitude: -88.23533,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42048',
  },
  {
    city: 'Hazel',
    county_fips: 21035,
    county_fips_all: '21035|21083',
    county: 'Calloway',
    county_names_all: 'Calloway|Graves',
    county_weights: '{"21035": 99.15, "21083": 0.85}',
    density: 11.3,
    imprecise: false,
    latitude: 36.51874,
    longitude: -88.31828,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42049',
  },
  {
    city: 'Hickman',
    county_fips: 21075,
    county_fips_all: '21075',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"21075": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 36.54675,
    longitude: -89.20347,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42050',
  },
  {
    city: 'Hickory',
    county_fips: 21083,
    county_fips_all: '21083',
    county: 'Graves',
    county_names_all: 'Graves',
    county_weights: '{"21083": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 36.85629,
    longitude: -88.64522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42051',
  },
  {
    city: 'Kevil',
    county_fips: 21007,
    county_fips_all: '21007|21145',
    county: 'Ballard',
    county_names_all: 'Ballard|McCracken',
    county_weights: '{"21007": 50.84, "21145": 49.16}',
    density: 17.1,
    imprecise: false,
    latitude: 37.1033,
    longitude: -88.87606,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42053',
  },
  {
    city: 'Kirksey',
    county_fips: 21035,
    county_fips_all: '21035|21157|21083',
    county: 'Calloway',
    county_names_all: 'Calloway|Marshall|Graves',
    county_weights: '{"21035": 85.99, "21157": 9.74, "21083": 4.27}',
    density: 9.8,
    imprecise: false,
    latitude: 36.71734,
    longitude: -88.43149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42054',
  },
  {
    city: 'Kuttawa',
    county_fips: 21143,
    county_fips_all: '21143',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"21143": 100}',
    density: 19,
    imprecise: false,
    latitude: 37.06959,
    longitude: -88.16765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42055',
  },
  {
    city: 'La Center',
    county_fips: 21007,
    county_fips_all: '21007',
    county: 'Ballard',
    county_names_all: 'Ballard',
    county_weights: '{"21007": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 37.11088,
    longitude: -88.98452,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42056',
  },
  {
    city: 'Ledbetter',
    county_fips: 21139,
    county_fips_all: '21139',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"21139": 100}',
    density: 54,
    imprecise: false,
    latitude: 37.05329,
    longitude: -88.4714,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42058',
  },
  {
    city: 'Lovelaceville',
    county_fips: 21007,
    county_fips_all: '21007',
    county: 'Ballard',
    county_names_all: 'Ballard',
    county_weights: '{"21007": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 36.96385,
    longitude: -88.82778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42060',
  },
  {
    city: 'Lowes',
    county_fips: 21083,
    county_fips_all: '21083',
    county: 'Graves',
    county_names_all: 'Graves',
    county_weights: '{"21083": 100}',
    density: 65,
    imprecise: false,
    latitude: 36.88262,
    longitude: -88.76959,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 59,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42061',
  },
  {
    city: 'Marion',
    county_fips: 21055,
    county_fips_all: '21055|21033',
    county: 'Crittenden',
    county_names_all: 'Crittenden|Caldwell',
    county_weights: '{"21055": 95.55, "21033": 4.45}',
    density: 10.6,
    imprecise: false,
    latitude: 37.35022,
    longitude: -88.09158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42064',
  },
  {
    city: 'Mayfield',
    county_fips: 21083,
    county_fips_all: '21083|21157|21035',
    county: 'Graves',
    county_names_all: 'Graves|Marshall|Calloway',
    county_weights: '{"21083": 98.14, "21157": 1.69, "21035": 0.17}',
    density: 42.5,
    imprecise: false,
    latitude: 36.73328,
    longitude: -88.6403,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42066',
  },
  {
    city: 'Melber',
    county_fips: 21083,
    county_fips_all: '21083|21145',
    county: 'Graves',
    county_names_all: 'Graves|McCracken',
    county_weights: '{"21083": 79.16, "21145": 20.84}',
    density: 19.2,
    imprecise: false,
    latitude: 36.92328,
    longitude: -88.75828,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42069',
  },
  {
    city: 'Murray',
    county_fips: 21035,
    county_fips_all: '21035|21083',
    county: 'Calloway',
    county_names_all: 'Calloway|Graves',
    county_weights: '{"21035": 99.47, "21083": 0.53}',
    density: 57.2,
    imprecise: false,
    latitude: 36.62139,
    longitude: -88.28291,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42071',
  },
  {
    city: 'New Concord',
    county_fips: 21035,
    county_fips_all: '21035',
    county: 'Calloway',
    county_names_all: 'Calloway',
    county_weights: '{"21035": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 36.55906,
    longitude: -88.09473,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42076',
  },
  {
    city: 'Salem',
    county_fips: 21139,
    county_fips_all: '21139|21055',
    county: 'Livingston',
    county_names_all: 'Livingston|Crittenden',
    county_weights: '{"21139": 75.74, "21055": 24.26}',
    density: 7.4,
    imprecise: false,
    latitude: 37.28876,
    longitude: -88.27202,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42078',
  },
  {
    city: 'Sedalia',
    county_fips: 21083,
    county_fips_all: '21083',
    county: 'Graves',
    county_names_all: 'Graves',
    county_weights: '{"21083": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 36.55978,
    longitude: -88.57611,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42079',
  },
  {
    city: 'Smithland',
    county_fips: 21139,
    county_fips_all: '21139',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"21139": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 37.22821,
    longitude: -88.40274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42081',
  },
  {
    city: 'Symsonia',
    county_fips: 21083,
    county_fips_all: '21083|21157|21145',
    county: 'Graves',
    county_names_all: 'Graves|Marshall|McCracken',
    county_weights: '{"21083": 55.12, "21157": 30.46, "21145": 14.42}',
    density: 25.2,
    imprecise: false,
    latitude: 36.91618,
    longitude: -88.50092,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42082',
  },
  {
    city: 'Tiline',
    county_fips: 21139,
    county_fips_all: '21139',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"21139": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 37.16381,
    longitude: -88.27767,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42083',
  },
  {
    city: 'Water Valley',
    county_fips: 21083,
    county_fips_all: '21083|21105',
    county: 'Graves',
    county_names_all: 'Graves|Hickman',
    county_weights: '{"21083": 56.63, "21105": 43.37}',
    density: 12.3,
    imprecise: false,
    latitude: 36.56942,
    longitude: -88.80044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42085',
  },
  {
    city: 'West Paducah',
    county_fips: 21145,
    county_fips_all: '21145',
    county: 'McCracken',
    county_names_all: 'McCracken',
    county_weights: '{"21145": 100}',
    density: 46.6,
    imprecise: false,
    latitude: 37.0828,
    longitude: -88.76838,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42086',
  },
  {
    city: 'Wickliffe',
    county_fips: 21007,
    county_fips_all: '21007',
    county: 'Ballard',
    county_names_all: 'Ballard',
    county_weights: '{"21007": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 36.97328,
    longitude: -89.00323,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42087',
  },
  {
    city: 'Wingo',
    county_fips: 21083,
    county_fips_all: '21083|21105',
    county: 'Graves',
    county_names_all: 'Graves|Hickman',
    county_weights: '{"21083": 80.5, "21105": 19.5}',
    density: 14.2,
    imprecise: false,
    latitude: 36.61808,
    longitude: -88.75409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42088',
  },
  {
    city: 'Bowling Green',
    county_fips: 21227,
    county_fips_all: '21227|21061|21031',
    county: 'Warren',
    county_names_all: 'Warren|Edmonson|Butler',
    county_weights: '{"21227": 88.54, "21061": 8.14, "21031": 3.32}',
    density: 89.9,
    imprecise: false,
    latitude: 37.06552,
    longitude: -86.47809,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 65421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42101',
  },
  {
    city: 'Bowling Green',
    county_fips: 21227,
    county_fips_all: '21227',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"21227": 100}',
    density: 120.1,
    imprecise: false,
    latitude: 36.94802,
    longitude: -86.33396,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42103',
  },
  {
    city: 'Bowling Green',
    county_fips: 21227,
    county_fips_all: '21227|21213',
    county: 'Warren',
    county_names_all: 'Warren|Simpson',
    county_weights: '{"21227": 91.29, "21213": 8.71}',
    density: 279.9,
    imprecise: false,
    latitude: 36.87718,
    longitude: -86.45233,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42104',
  },
  {
    city: 'Adolphus',
    county_fips: 21003,
    county_fips_all: '21003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"21003": 100}',
    density: 24.5,
    imprecise: false,
    latitude: 36.67196,
    longitude: -86.27465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42120',
  },
  {
    city: 'Alvaton',
    county_fips: 21227,
    county_fips_all: '21227|21003',
    county: 'Warren',
    county_names_all: 'Warren|Allen',
    county_weights: '{"21227": 94.65, "21003": 5.35}',
    density: 56.5,
    imprecise: false,
    latitude: 36.85885,
    longitude: -86.35718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42122',
  },
  {
    city: 'Austin',
    county_fips: 21009,
    county_fips_all: '21009',
    county: 'Barren',
    county_names_all: 'Barren',
    county_weights: '{"21009": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 36.82039,
    longitude: -85.99573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42123',
  },
  {
    city: 'Cave City',
    county_fips: 21009,
    county_fips_all: '21009|21099',
    county: 'Barren',
    county_names_all: 'Barren|Hart',
    county_weights: '{"21009": 85.18, "21099": 14.82}',
    density: 30.2,
    imprecise: false,
    latitude: 37.12167,
    longitude: -85.92746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42127',
  },
  {
    city: 'Edmonton',
    county_fips: 21169,
    county_fips_all: '21169|21001',
    county: 'Metcalfe',
    county_names_all: 'Metcalfe|Adair',
    county_weights: '{"21169": 95.1, "21001": 4.9}',
    density: 14.6,
    imprecise: false,
    latitude: 36.99,
    longitude: -85.58992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42129',
  },
  {
    city: 'Etoile',
    county_fips: 21009,
    county_fips_all: '21009',
    county: 'Barren',
    county_names_all: 'Barren',
    county_weights: '{"21009": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 36.82734,
    longitude: -85.90915,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42131',
  },
  {
    city: 'Fountain Run',
    county_fips: 21171,
    county_fips_all: '21171|21009|21003',
    county: 'Monroe',
    county_names_all: 'Monroe|Barren|Allen',
    county_weights: '{"21171": 43.23, "21009": 32.32, "21003": 24.45}',
    density: 7.3,
    imprecise: false,
    latitude: 36.72248,
    longitude: -85.95468,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42133',
  },
  {
    city: 'Franklin',
    county_fips: 21213,
    county_fips_all: '21213|21003',
    county: 'Simpson',
    county_names_all: 'Simpson|Allen',
    county_weights: '{"21213": 93.27, "21003": 6.73}',
    density: 35.2,
    imprecise: false,
    latitude: 36.72626,
    longitude: -86.56433,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42134',
  },
  {
    city: 'Gamaliel',
    county_fips: 21171,
    county_fips_all: '21171',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"21171": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 36.65549,
    longitude: -85.83108,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42140',
  },
  {
    city: 'Glasgow',
    county_fips: 21009,
    county_fips_all: '21009',
    county: 'Barren',
    county_names_all: 'Barren',
    county_weights: '{"21009": 100}',
    density: 45.3,
    imprecise: false,
    latitude: 36.94883,
    longitude: -85.91489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42141',
  },
  {
    city: 'Holland',
    county_fips: 21003,
    county_fips_all: '21003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"21003": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 36.68006,
    longitude: -86.04234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42153',
  },
  {
    city: 'Knob Lick',
    county_fips: 21169,
    county_fips_all: '21169|21009',
    county: 'Metcalfe',
    county_names_all: 'Metcalfe|Barren',
    county_weights: '{"21169": 87.18, "21009": 12.82}',
    density: 10,
    imprecise: false,
    latitude: 37.04876,
    longitude: -85.72421,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42154',
  },
  {
    city: 'Lucas',
    county_fips: 21009,
    county_fips_all: '21009',
    county: 'Barren',
    county_names_all: 'Barren',
    county_weights: '{"21009": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 36.85947,
    longitude: -86.04952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42156',
  },
  {
    city: 'Mount Hermon',
    county_fips: 21171,
    county_fips_all: '21171',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"21171": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 36.78872,
    longitude: -85.8187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42157',
  },
  {
    city: 'Oakland',
    county_fips: 21227,
    county_fips_all: '21227',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"21227": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 36.99594,
    longitude: -86.24771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42159',
  },
  {
    city: 'Park City',
    county_fips: 21061,
    county_fips_all: '21061|21009',
    county: 'Edmonson',
    county_names_all: 'Edmonson|Barren',
    county_weights: '{"21061": 55.21, "21009": 44.79}',
    density: 16.9,
    imprecise: false,
    latitude: 37.10339,
    longitude: -86.08035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42160',
  },
  {
    city: 'Rocky Hill',
    county_fips: 21061,
    county_fips_all: '21061',
    county: 'Edmonson',
    county_names_all: 'Edmonson',
    county_weights: '{"21061": 100}',
    density: 22.6,
    imprecise: false,
    latitude: 37.07968,
    longitude: -86.13466,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42163',
  },
  {
    city: 'Scottsville',
    county_fips: 21003,
    county_fips_all: '21003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"21003": 100}',
    density: 26.1,
    imprecise: false,
    latitude: 36.7704,
    longitude: -86.18096,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42164',
  },
  {
    city: 'Summer Shade',
    county_fips: 21169,
    county_fips_all: '21169|21009|21171',
    county: 'Metcalfe',
    county_names_all: 'Metcalfe|Barren|Monroe',
    county_weights: '{"21169": 61.13, "21009": 24.4, "21171": 14.47}',
    density: 14.7,
    imprecise: false,
    latitude: 36.87768,
    longitude: -85.71503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42166',
  },
  {
    city: 'Tompkinsville',
    county_fips: 21171,
    county_fips_all: '21171|21057|21169',
    county: 'Monroe',
    county_names_all: 'Monroe|Cumberland|Metcalfe',
    county_weights: '{"21171": 97.77, "21057": 1.27, "21169": 0.96}',
    density: 15.5,
    imprecise: false,
    latitude: 36.72432,
    longitude: -85.66998,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42167',
  },
  {
    city: 'Woodburn',
    county_fips: 21227,
    county_fips_all: '21227|21213',
    county: 'Warren',
    county_names_all: 'Warren|Simpson',
    county_weights: '{"21227": 50.88, "21213": 49.12}',
    density: 24.4,
    imprecise: false,
    latitude: 36.84678,
    longitude: -86.57459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42170',
  },
  {
    city: 'Smiths Grove',
    county_fips: 21227,
    county_fips_all: '21227|21061|21009',
    county: 'Warren',
    county_names_all: 'Warren|Edmonson|Barren',
    county_weights: '{"21227": 47.84, "21061": 27.57, "21009": 24.59}',
    density: 25.1,
    imprecise: false,
    latitude: 37.03609,
    longitude: -86.16728,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42171',
  },
  {
    city: 'Adairville',
    county_fips: 21141,
    county_fips_all: '21141|21213',
    county: 'Logan',
    county_names_all: 'Logan|Simpson',
    county_weights: '{"21141": 97.87, "21213": 2.13}',
    density: 11.6,
    imprecise: false,
    latitude: 36.68732,
    longitude: -86.85916,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42202',
  },
  {
    city: 'Allensville',
    county_fips: 21219,
    county_fips_all: '21219|21141',
    county: 'Todd',
    county_names_all: 'Todd|Logan',
    county_weights: '{"21219": 71.17, "21141": 28.83}',
    density: 6.6,
    imprecise: false,
    latitude: 36.69509,
    longitude: -87.08096,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42204',
  },
  {
    city: 'Auburn',
    county_fips: 21141,
    county_fips_all: '21141|21213|21227',
    county: 'Logan',
    county_names_all: 'Logan|Simpson|Warren',
    county_weights: '{"21141": 86.31, "21213": 12.58, "21227": 1.11}',
    density: 20,
    imprecise: false,
    latitude: 36.88221,
    longitude: -86.72302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42206',
  },
  {
    city: 'Bee Spring',
    county_fips: 21061,
    county_fips_all: '21061|21085',
    county: 'Edmonson',
    county_names_all: 'Edmonson|Grayson',
    county_weights: '{"21061": 97.54, "21085": 2.46}',
    density: 18.7,
    imprecise: false,
    latitude: 37.30357,
    longitude: -86.27858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42207',
  },
  {
    city: 'Brownsville',
    county_fips: 21061,
    county_fips_all: '21061',
    county: 'Edmonson',
    county_names_all: 'Edmonson',
    county_weights: '{"21061": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 37.21724,
    longitude: -86.31438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42210',
  },
  {
    city: 'Cadiz',
    county_fips: 21221,
    county_fips_all: '21221|21033',
    county: 'Trigg',
    county_names_all: 'Trigg|Caldwell',
    county_weights: '{"21221": 99.84, "21033": 0.16}',
    density: 18.3,
    imprecise: false,
    latitude: 36.82016,
    longitude: -87.83709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42211',
  },
  {
    city: 'Center',
    county_fips: 21169,
    county_fips_all: '21169|21087',
    county: 'Metcalfe',
    county_names_all: 'Metcalfe|Green',
    county_weights: '{"21169": 81.26, "21087": 18.74}',
    density: 13.6,
    imprecise: false,
    latitude: 37.13428,
    longitude: -85.68822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42214',
  },
  {
    city: 'Cerulean',
    county_fips: 21047,
    county_fips_all: '21047|21221',
    county: 'Christian',
    county_names_all: 'Christian|Trigg',
    county_weights: '{"21047": 73.27, "21221": 26.73}',
    density: 9,
    imprecise: false,
    latitude: 36.99256,
    longitude: -87.67018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42215',
  },
  {
    city: 'Crofton',
    county_fips: 21047,
    county_fips_all: '21047',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"21047": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 37.04915,
    longitude: -87.47212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42217',
  },
  {
    city: 'Elkton',
    county_fips: 21219,
    county_fips_all: '21219|21047|21177',
    county: 'Todd',
    county_names_all: 'Todd|Christian|Muhlenberg',
    county_weights: '{"21219": 98.59, "21047": 1.14, "21177": 0.27}',
    density: 13.7,
    imprecise: false,
    latitude: 36.90129,
    longitude: -87.18395,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42220',
  },
  {
    city: 'Fort Campbell',
    county_fips: 47125,
    county_fips_all: '47125|21047',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Christian',
    county_weights: '{"47125": 55.05, "21047": 44.95}',
    density: 337.9,
    imprecise: false,
    latitude: 36.6381,
    longitude: -87.47258,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42223',
  },
  {
    city: 'Gracey',
    county_fips: 21047,
    county_fips_all: '21047|21221',
    county: 'Christian',
    county_names_all: 'Christian|Trigg',
    county_weights: '{"21047": 73.12, "21221": 26.88}',
    density: 12.5,
    imprecise: false,
    latitude: 36.86665,
    longitude: -87.66167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42232',
  },
  {
    city: 'Guthrie',
    county_fips: 21219,
    county_fips_all: '21219',
    county: 'Todd',
    county_names_all: 'Todd',
    county_weights: '{"21219": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 36.70656,
    longitude: -87.17598,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42234',
  },
  {
    city: 'Herndon',
    county_fips: 21047,
    county_fips_all: '21047|21221',
    county: 'Christian',
    county_names_all: 'Christian|Trigg',
    county_weights: '{"21047": 92.65, "21221": 7.35}',
    density: 5.7,
    imprecise: false,
    latitude: 36.7196,
    longitude: -87.61225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42236',
  },
  {
    city: 'Hopkinsville',
    county_fips: 21047,
    county_fips_all: '21047',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"21047": 100}',
    density: 57.7,
    imprecise: false,
    latitude: 36.88388,
    longitude: -87.46024,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42240',
  },
  {
    city: 'Jetson',
    county_fips: 21031,
    county_fips_all: '21031',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"21031": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 37.23713,
    longitude: -86.50029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42252',
  },
  {
    city: 'La Fayette',
    county_fips: 21047,
    county_fips_all: '21047',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"21047": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 36.66435,
    longitude: -87.63852,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42254',
  },
  {
    city: 'Lewisburg',
    county_fips: 21141,
    county_fips_all: '21141|21031|21219|21177',
    county: 'Logan',
    county_names_all: 'Logan|Butler|Todd|Muhlenberg',
    county_weights:
      '{"21141": 61.46, "21031": 24.08, "21219": 12.08, "21177": 2.38}',
    density: 10,
    imprecise: false,
    latitude: 37.01666,
    longitude: -86.94796,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42256',
  },
  {
    city: 'Mammoth Cave',
    county_fips: 21061,
    county_fips_all: '21061',
    county: 'Edmonson',
    county_names_all: 'Edmonson',
    county_weights: '{"21061": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 37.23524,
    longitude: -86.17206,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42259',
  },
  {
    city: 'Morgantown',
    county_fips: 21031,
    county_fips_all: '21031',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"21031": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 37.22405,
    longitude: -86.67015,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42261',
  },
  {
    city: 'Oak Grove',
    county_fips: 21047,
    county_fips_all: '21047',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"21047": 100}',
    density: 119.5,
    imprecise: false,
    latitude: 36.68386,
    longitude: -87.44714,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42262',
  },
  {
    city: 'Olmstead',
    county_fips: 21141,
    county_fips_all: '21141|21219',
    county: 'Logan',
    county_names_all: 'Logan|Todd',
    county_weights: '{"21141": 87.8, "21219": 12.2}',
    density: 4.5,
    imprecise: false,
    latitude: 36.739,
    longitude: -87.00141,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42265',
  },
  {
    city: 'Pembroke',
    county_fips: 21047,
    county_fips_all: '21047|21219',
    county: 'Christian',
    county_names_all: 'Christian|Todd',
    county_weights: '{"21047": 87.96, "21219": 12.04}',
    density: 15.7,
    imprecise: false,
    latitude: 36.76562,
    longitude: -87.3601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42266',
  },
  {
    city: 'Rochester',
    county_fips: 21031,
    county_fips_all: '21031',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"21031": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 37.20128,
    longitude: -86.85916,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42273',
  },
  {
    city: 'Rockfield',
    county_fips: 21227,
    county_fips_all: '21227|21141',
    county: 'Warren',
    county_names_all: 'Warren|Logan',
    county_weights: '{"21227": 88.74, "21141": 11.26}',
    density: 20.3,
    imprecise: false,
    latitude: 36.94915,
    longitude: -86.60534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42274',
  },
  {
    city: 'Roundhill',
    county_fips: 21031,
    county_fips_all: '21031|21061',
    county: 'Butler',
    county_names_all: 'Butler|Edmonson',
    county_weights: '{"21031": 72.88, "21061": 27.12}',
    density: 7.1,
    imprecise: false,
    latitude: 37.22701,
    longitude: -86.44628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42275',
  },
  {
    city: 'Russellville',
    county_fips: 21141,
    county_fips_all: '21141|21031',
    county: 'Logan',
    county_names_all: 'Logan|Butler',
    county_weights: '{"21141": 99.86, "21031": 0.14}',
    density: 30.2,
    imprecise: false,
    latitude: 36.86093,
    longitude: -86.87727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42276',
  },
  {
    city: 'Sharon Grove',
    county_fips: 21219,
    county_fips_all: '21219',
    county: 'Todd',
    county_names_all: 'Todd',
    county_weights: '{"21219": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 36.95055,
    longitude: -87.09927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42280',
  },
  {
    city: 'Sweeden',
    county_fips: 21061,
    county_fips_all: '21061',
    county: 'Edmonson',
    county_names_all: 'Edmonson',
    county_weights: '{"21061": 100}',
    density: 24.5,
    imprecise: false,
    latitude: 37.26418,
    longitude: -86.29751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42285',
  },
  {
    city: 'Trenton',
    county_fips: 21219,
    county_fips_all: '21219|21047',
    county: 'Todd',
    county_names_all: 'Todd|Christian',
    county_weights: '{"21219": 94.31, "21047": 5.69}',
    density: 12.2,
    imprecise: false,
    latitude: 36.72749,
    longitude: -87.26959,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42286',
  },
  {
    city: 'Owensboro',
    county_fips: 21059,
    county_fips_all: '21059|21101|21149',
    county: 'Daviess',
    county_names_all: 'Daviess|Henderson|McLean',
    county_weights: '{"21059": 95.38, "21101": 4.14, "21149": 0.48}',
    density: 101.4,
    imprecise: false,
    latitude: 37.73983,
    longitude: -87.24643,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42301',
  },
  {
    city: 'Owensboro',
    county_fips: 21059,
    county_fips_all: '21059',
    county: 'Daviess',
    county_names_all: 'Daviess',
    county_weights: '{"21059": 100}',
    density: 333,
    imprecise: false,
    latitude: 37.76138,
    longitude: -87.04889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42303',
  },
  {
    city: 'Beaver Dam',
    county_fips: 21183,
    county_fips_all: '21183|21031',
    county: 'Ohio',
    county_names_all: 'Ohio|Butler',
    county_weights: '{"21183": 92.36, "21031": 7.64}',
    density: 23.6,
    imprecise: false,
    latitude: 37.35093,
    longitude: -86.87291,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42320',
  },
  {
    city: 'Beech Creek',
    county_fips: 21177,
    county_fips_all: '21177',
    county: 'Muhlenberg',
    county_names_all: 'Muhlenberg',
    county_weights: '{"21177": 100}',
    density: 58.4,
    imprecise: false,
    latitude: 37.17977,
    longitude: -87.05195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42321',
  },
  {
    city: 'Beech Grove',
    county_fips: 21149,
    county_fips_all: '21149',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"21149": 100}',
    density: 35.5,
    imprecise: false,
    latitude: 37.62083,
    longitude: -87.38821,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42322',
  },
  {
    city: 'Beechmont',
    county_fips: 21177,
    county_fips_all: '21177',
    county: 'Muhlenberg',
    county_names_all: 'Muhlenberg',
    county_weights: '{"21177": 100}',
    density: 223.2,
    imprecise: false,
    latitude: 37.17406,
    longitude: -87.03261,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42323',
  },
  {
    city: 'Belton',
    county_fips: 21177,
    county_fips_all: '21177',
    county: 'Muhlenberg',
    county_names_all: 'Muhlenberg',
    county_weights: '{"21177": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 37.13863,
    longitude: -87.00974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42324',
  },
  {
    city: 'Bremen',
    county_fips: 21177,
    county_fips_all: '21177',
    county: 'Muhlenberg',
    county_names_all: 'Muhlenberg',
    county_weights: '{"21177": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 37.32537,
    longitude: -87.27375,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42325',
  },
  {
    city: 'Browder',
    county_fips: 21177,
    county_fips_all: '21177',
    county: 'Muhlenberg',
    county_names_all: 'Muhlenberg',
    county_weights: '{"21177": 100}',
    density: 7,
    imprecise: false,
    latitude: 37.23666,
    longitude: -87.00835,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42326',
  },
  {
    city: 'Calhoun',
    county_fips: 21149,
    county_fips_all: '21149|21059',
    county: 'McLean',
    county_names_all: 'McLean|Daviess',
    county_weights: '{"21149": 99.02, "21059": 0.98}',
    density: 13.2,
    imprecise: false,
    latitude: 37.58721,
    longitude: -87.30042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42327',
  },
  {
    city: 'Centertown',
    county_fips: 21183,
    county_fips_all: '21183',
    county: 'Ohio',
    county_names_all: 'Ohio',
    county_weights: '{"21183": 100}',
    density: 7,
    imprecise: false,
    latitude: 37.41898,
    longitude: -87.0429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42328',
  },
  {
    city: 'Central City',
    county_fips: 21177,
    county_fips_all: '21177',
    county: 'Muhlenberg',
    county_names_all: 'Muhlenberg',
    county_weights: '{"21177": 100}',
    density: 34.8,
    imprecise: false,
    latitude: 37.31436,
    longitude: -87.12245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42330',
  },
  {
    city: 'Cleaton',
    county_fips: 21177,
    county_fips_all: '21177',
    county: 'Muhlenberg',
    county_names_all: 'Muhlenberg',
    county_weights: '{"21177": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 37.25099,
    longitude: -87.08935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42332',
  },
  {
    city: 'Cromwell',
    county_fips: 21183,
    county_fips_all: '21183|21031',
    county: 'Ohio',
    county_names_all: 'Ohio|Butler',
    county_weights: '{"21183": 94.68, "21031": 5.32}',
    density: 6.9,
    imprecise: false,
    latitude: 37.37718,
    longitude: -86.75609,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42333',
  },
  {
    city: 'Drakesboro',
    county_fips: 21177,
    county_fips_all: '21177',
    county: 'Muhlenberg',
    county_names_all: 'Muhlenberg',
    county_weights: '{"21177": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 37.22309,
    longitude: -86.99964,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42337',
  },
  {
    city: 'Dundee',
    county_fips: 21183,
    county_fips_all: '21183',
    county: 'Ohio',
    county_names_all: 'Ohio',
    county_weights: '{"21183": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 37.55295,
    longitude: -86.77408,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42338',
  },
  {
    city: 'Dunmor',
    county_fips: 21177,
    county_fips_all: '21177|21031',
    county: 'Muhlenberg',
    county_names_all: 'Muhlenberg|Butler',
    county_weights: '{"21177": 82.5, "21031": 17.5}',
    density: 8.9,
    imprecise: false,
    latitude: 37.11326,
    longitude: -86.95033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42339',
  },
  {
    city: 'Fordsville',
    county_fips: 21183,
    county_fips_all: '21183|21091|21027',
    county: 'Ohio',
    county_names_all: 'Ohio|Hancock|Breckinridge',
    county_weights: '{"21183": 76.26, "21091": 20.75, "21027": 2.99}',
    density: 6.3,
    imprecise: false,
    latitude: 37.63594,
    longitude: -86.69795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42343',
  },
  {
    city: 'Graham',
    county_fips: 21177,
    county_fips_all: '21177',
    county: 'Muhlenberg',
    county_names_all: 'Muhlenberg',
    county_weights: '{"21177": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 37.25681,
    longitude: -87.32053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42344',
  },
  {
    city: 'Greenville',
    county_fips: 21177,
    county_fips_all: '21177|21219',
    county: 'Muhlenberg',
    county_names_all: 'Muhlenberg|Todd',
    county_weights: '{"21177": 99.4, "21219": 0.6}',
    density: 28.7,
    imprecise: false,
    latitude: 37.14839,
    longitude: -87.18943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42345',
  },
  {
    city: 'Hartford',
    county_fips: 21183,
    county_fips_all: '21183',
    county: 'Ohio',
    county_names_all: 'Ohio',
    county_weights: '{"21183": 100}',
    density: 18.5,
    imprecise: false,
    latitude: 37.52414,
    longitude: -86.88715,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42347',
  },
  {
    city: 'Hawesville',
    county_fips: 21091,
    county_fips_all: '21091|21059',
    county: 'Hancock',
    county_names_all: 'Hancock|Daviess',
    county_weights: '{"21091": 88.36, "21059": 11.64}',
    density: 17.5,
    imprecise: false,
    latitude: 37.83379,
    longitude: -86.76578,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42348',
  },
  {
    city: 'Horse Branch',
    county_fips: 21183,
    county_fips_all: '21183|21085',
    county: 'Ohio',
    county_names_all: 'Ohio|Grayson',
    county_weights: '{"21183": 89.73, "21085": 10.27}',
    density: 13.5,
    imprecise: false,
    latitude: 37.42695,
    longitude: -86.67425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42349',
  },
  {
    city: 'Island',
    county_fips: 21149,
    county_fips_all: '21149',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"21149": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 37.44852,
    longitude: -87.1831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42350',
  },
  {
    city: 'Lewisport',
    county_fips: 21091,
    county_fips_all: '21091|21059',
    county: 'Hancock',
    county_names_all: 'Hancock|Daviess',
    county_weights: '{"21091": 76.23, "21059": 23.77}',
    density: 25,
    imprecise: false,
    latitude: 37.9026,
    longitude: -86.87903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42351',
  },
  {
    city: 'Livermore',
    county_fips: 21149,
    county_fips_all: '21149|21183',
    county: 'McLean',
    county_names_all: 'McLean|Ohio',
    county_weights: '{"21149": 59.18, "21183": 40.82}',
    density: 32.9,
    imprecise: false,
    latitude: 37.51333,
    longitude: -87.0833,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42352',
  },
  {
    city: 'McHenry',
    county_fips: 21183,
    county_fips_all: '21183',
    county: 'Ohio',
    county_names_all: 'Ohio',
    county_weights: '{"21183": 100}',
    density: 135.9,
    imprecise: false,
    latitude: 37.37915,
    longitude: -86.9273,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42354',
  },
  {
    city: 'Maceo',
    county_fips: 21059,
    county_fips_all: '21059',
    county: 'Daviess',
    county_names_all: 'Daviess',
    county_weights: '{"21059": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 37.86206,
    longitude: -86.9895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42355',
  },
  {
    city: 'Maple Mount',
    county_fips: 21059,
    county_fips_all: '21059',
    county: 'Daviess',
    county_names_all: 'Daviess',
    county_weights: '{"21059": 100}',
    density: 1135.4,
    imprecise: false,
    latitude: 37.69364,
    longitude: -87.32289,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42356',
  },
  {
    city: 'Philpot',
    county_fips: 21059,
    county_fips_all: '21059|21183|21091',
    county: 'Daviess',
    county_names_all: 'Daviess|Ohio|Hancock',
    county_weights: '{"21059": 94.76, "21183": 4.18, "21091": 1.06}',
    density: 25.8,
    imprecise: false,
    latitude: 37.72404,
    longitude: -86.93988,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42366',
  },
  {
    city: 'Powderly',
    county_fips: 21177,
    county_fips_all: '21177',
    county: 'Muhlenberg',
    county_names_all: 'Muhlenberg',
    county_weights: '{"21177": 100}',
    density: 154.3,
    imprecise: false,
    latitude: 37.2448,
    longitude: -87.16133,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42367',
  },
  {
    city: 'Reynolds Station',
    county_fips: 21091,
    county_fips_all: '21091|21183',
    county: 'Hancock',
    county_names_all: 'Hancock|Ohio',
    county_weights: '{"21091": 55.67, "21183": 44.33}',
    density: 8.7,
    imprecise: false,
    latitude: 37.71258,
    longitude: -86.75133,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42368',
  },
  {
    city: 'Rockport',
    county_fips: 21183,
    county_fips_all: '21183|21177',
    county: 'Ohio',
    county_names_all: 'Ohio|Muhlenberg',
    county_weights: '{"21183": 99.9, "21177": 0.1}',
    density: 28.5,
    imprecise: false,
    latitude: 37.3517,
    longitude: -87.00719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42369',
  },
  {
    city: 'Rosine',
    county_fips: 21183,
    county_fips_all: '21183',
    county: 'Ohio',
    county_names_all: 'Ohio',
    county_weights: '{"21183": 100}',
    density: 44.8,
    imprecise: false,
    latitude: 37.4497,
    longitude: -86.74121,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42370',
  },
  {
    city: 'Rumsey',
    county_fips: 21149,
    county_fips_all: '21149',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"21149": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 37.4978,
    longitude: -87.29362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42371',
  },
  {
    city: 'Sacramento',
    county_fips: 21149,
    county_fips_all: '21149|21177',
    county: 'McLean',
    county_names_all: 'McLean|Muhlenberg',
    county_weights: '{"21149": 72.05, "21177": 27.95}',
    density: 14.1,
    imprecise: false,
    latitude: 37.40588,
    longitude: -87.2773,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42372',
  },
  {
    city: 'South Carrollton',
    county_fips: 21177,
    county_fips_all: '21177',
    county: 'Muhlenberg',
    county_names_all: 'Muhlenberg',
    county_weights: '{"21177": 100}',
    density: 213.2,
    imprecise: false,
    latitude: 37.33333,
    longitude: -87.14045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42374',
  },
  {
    city: 'Utica',
    county_fips: 21059,
    county_fips_all: '21059|21183|21149',
    county: 'Daviess',
    county_names_all: 'Daviess|Ohio|McLean',
    county_weights: '{"21059": 80.9, "21183": 10.62, "21149": 8.48}',
    density: 27.1,
    imprecise: false,
    latitude: 37.61626,
    longitude: -87.08619,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42376',
  },
  {
    city: 'Whitesville',
    county_fips: 21183,
    county_fips_all: '21183|21059',
    county: 'Ohio',
    county_names_all: 'Ohio|Daviess',
    county_weights: '{"21183": 63.07, "21059": 36.93}',
    density: 22.1,
    imprecise: false,
    latitude: 37.65093,
    longitude: -86.87258,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42378',
  },
  {
    city: 'Clay',
    county_fips: 21233,
    county_fips_all: '21233|21225',
    county: 'Webster',
    county_names_all: 'Webster|Union',
    county_weights: '{"21233": 94.31, "21225": 5.69}',
    density: 9.3,
    imprecise: false,
    latitude: 37.47878,
    longitude: -87.83636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42404',
  },
  {
    city: 'Corydon',
    county_fips: 21101,
    county_fips_all: '21101',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"21101": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 37.77792,
    longitude: -87.74496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42406',
  },
  {
    city: 'Dawson Springs',
    county_fips: 21107,
    county_fips_all: '21107|21033|21047',
    county: 'Hopkins',
    county_names_all: 'Hopkins|Caldwell|Christian',
    county_weights: '{"21107": 57.92, "21033": 26.8, "21047": 15.28}',
    density: 15.8,
    imprecise: false,
    latitude: 37.1797,
    longitude: -87.69229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42408',
  },
  {
    city: 'Dixon',
    county_fips: 21233,
    county_fips_all: '21233',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"21233": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 37.5436,
    longitude: -87.69947,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42409',
  },
  {
    city: 'Earlington',
    county_fips: 21107,
    county_fips_all: '21107',
    county: 'Hopkins',
    county_names_all: 'Hopkins',
    county_weights: '{"21107": 100}',
    density: 140.3,
    imprecise: false,
    latitude: 37.27655,
    longitude: -87.51078,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42410',
  },
  {
    city: 'Fredonia',
    county_fips: 21033,
    county_fips_all: '21033|21055|21143',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Crittenden|Lyon',
    county_weights: '{"21033": 67.88, "21055": 24.6, "21143": 7.52}',
    density: 9.8,
    imprecise: false,
    latitude: 37.20315,
    longitude: -88.02852,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42411',
  },
  {
    city: 'Hanson',
    county_fips: 21107,
    county_fips_all: '21107',
    county: 'Hopkins',
    county_names_all: 'Hopkins',
    county_weights: '{"21107": 100}',
    density: 21.3,
    imprecise: false,
    latitude: 37.44257,
    longitude: -87.46919,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42413',
  },
  {
    city: 'Henderson',
    county_fips: 21101,
    county_fips_all: '21101',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"21101": 100}',
    density: 76.9,
    imprecise: false,
    latitude: 37.79875,
    longitude: -87.51517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42420',
  },
  {
    city: 'Madisonville',
    county_fips: 21107,
    county_fips_all: '21107',
    county: 'Hopkins',
    county_names_all: 'Hopkins',
    county_weights: '{"21107": 100}',
    density: 63,
    imprecise: false,
    latitude: 37.33319,
    longitude: -87.47512,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42431',
  },
  {
    city: 'Manitou',
    county_fips: 21107,
    county_fips_all: '21107',
    county: 'Hopkins',
    county_names_all: 'Hopkins',
    county_weights: '{"21107": 100}',
    density: 27.6,
    imprecise: false,
    latitude: 37.41462,
    longitude: -87.56946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42436',
  },
  {
    city: 'Morganfield',
    county_fips: 21225,
    county_fips_all: '21225|21233',
    county: 'Union',
    county_names_all: 'Union|Webster',
    county_weights: '{"21225": 97.1, "21233": 2.9}',
    density: 16.1,
    imprecise: false,
    latitude: 37.66234,
    longitude: -87.92067,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42437',
  },
  {
    city: 'Mortons Gap',
    county_fips: 21107,
    county_fips_all: '21107',
    county: 'Hopkins',
    county_names_all: 'Hopkins',
    county_weights: '{"21107": 100}',
    density: 177.6,
    imprecise: false,
    latitude: 37.23887,
    longitude: -87.46782,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42440',
  },
  {
    city: 'Nebo',
    county_fips: 21107,
    county_fips_all: '21107|21233',
    county: 'Hopkins',
    county_names_all: 'Hopkins|Webster',
    county_weights: '{"21107": 93.03, "21233": 6.97}',
    density: 10.7,
    imprecise: false,
    latitude: 37.36768,
    longitude: -87.65962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42441',
  },
  {
    city: 'Nortonville',
    county_fips: 21107,
    county_fips_all: '21107|21047',
    county: 'Hopkins',
    county_names_all: 'Hopkins|Christian',
    county_weights: '{"21107": 99.04, "21047": 0.96}',
    density: 24.5,
    imprecise: false,
    latitude: 37.17408,
    longitude: -87.48652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42442',
  },
  {
    city: 'Poole',
    county_fips: 21233,
    county_fips_all: '21233|21101',
    county: 'Webster',
    county_names_all: 'Webster|Henderson',
    county_weights: '{"21233": 99.85, "21101": 0.15}',
    density: 0,
    imprecise: false,
    latitude: 37.64152,
    longitude: -87.6455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42444',
  },
  {
    city: 'Princeton',
    county_fips: 21033,
    county_fips_all: '21033|21143|21107|21221',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Lyon|Hopkins|Trigg',
    county_weights:
      '{"21033": 90.97, "21143": 4.65, "21107": 4.15, "21221": 0.23}',
    density: 15.6,
    imprecise: false,
    latitude: 37.12861,
    longitude: -87.86052,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42445',
  },
  {
    city: 'Providence',
    county_fips: 21233,
    county_fips_all: '21233|21107|21055',
    county: 'Webster',
    county_names_all: 'Webster|Hopkins|Crittenden',
    county_weights: '{"21233": 49.78, "21107": 31.84, "21055": 18.38}',
    density: 20.5,
    imprecise: false,
    latitude: 37.38741,
    longitude: -87.77535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42450',
  },
  {
    city: 'Reed',
    county_fips: 21101,
    county_fips_all: '21101',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"21101": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 37.88165,
    longitude: -87.38966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42451',
  },
  {
    city: 'Robards',
    county_fips: 21101,
    county_fips_all: '21101|21233',
    county: 'Henderson',
    county_names_all: 'Henderson|Webster',
    county_weights: '{"21101": 91.69, "21233": 8.31}',
    density: 12.5,
    imprecise: false,
    latitude: 37.68531,
    longitude: -87.53654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42452',
  },
  {
    city: 'Saint Charles',
    county_fips: 21107,
    county_fips_all: '21107|21047',
    county: 'Hopkins',
    county_names_all: 'Hopkins|Christian',
    county_weights: '{"21107": 93.32, "21047": 6.68}',
    density: 7.6,
    imprecise: false,
    latitude: 37.14888,
    longitude: -87.58275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42453',
  },
  {
    city: 'Sebree',
    county_fips: 21233,
    county_fips_all: '21233',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"21233": 100}',
    density: 20,
    imprecise: false,
    latitude: 37.5858,
    longitude: -87.53938,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42455',
  },
  {
    city: 'Slaughters',
    county_fips: 21233,
    county_fips_all: '21233|21107',
    county: 'Webster',
    county_names_all: 'Webster|Hopkins',
    county_weights: '{"21233": 63.48, "21107": 36.52}',
    density: 8.6,
    imprecise: false,
    latitude: 37.51182,
    longitude: -87.49929,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42456',
  },
  {
    city: 'Spottsville',
    county_fips: 21101,
    county_fips_all: '21101',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"21101": 100}',
    density: 34.5,
    imprecise: false,
    latitude: 37.85249,
    longitude: -87.42367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42458',
  },
  {
    city: 'Sturgis',
    county_fips: 21225,
    county_fips_all: '21225|21055',
    county: 'Union',
    county_names_all: 'Union|Crittenden',
    county_weights: '{"21225": 82.38, "21055": 17.62}',
    density: 12,
    imprecise: false,
    latitude: 37.5637,
    longitude: -88.01837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42459',
  },
  {
    city: 'Uniontown',
    county_fips: 21225,
    county_fips_all: '21225|21101',
    county: 'Union',
    county_names_all: 'Union|Henderson',
    county_weights: '{"21225": 98.75, "21101": 1.25}',
    density: 15.7,
    imprecise: false,
    latitude: 37.78668,
    longitude: -87.88807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42461',
  },
  {
    city: 'Waverly',
    county_fips: 21225,
    county_fips_all: '21225|21101',
    county: 'Union',
    county_names_all: 'Union|Henderson',
    county_weights: '{"21225": 68.05, "21101": 31.95}',
    density: 12.2,
    imprecise: false,
    latitude: 37.74123,
    longitude: -87.79834,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42462',
  },
  {
    city: 'Wheatcroft',
    county_fips: 21233,
    county_fips_all: '21233',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"21233": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 37.47897,
    longitude: -87.86717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42463',
  },
  {
    city: 'White Plains',
    county_fips: 21107,
    county_fips_all: '21107|21047|21177',
    county: 'Hopkins',
    county_names_all: 'Hopkins|Christian|Muhlenberg',
    county_weights: '{"21107": 71.08, "21047": 15.4, "21177": 13.52}',
    density: 11.7,
    imprecise: false,
    latitude: 37.18132,
    longitude: -87.37148,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42464',
  },
  {
    city: 'Somerset',
    county_fips: 21199,
    county_fips_all: '21199',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"21199": 100}',
    density: 35.2,
    imprecise: false,
    latitude: 37.06174,
    longitude: -84.44973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42501',
  },
  {
    city: 'Somerset',
    county_fips: 21199,
    county_fips_all: '21199',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"21199": 100}',
    density: 75.5,
    imprecise: false,
    latitude: 37.15677,
    longitude: -84.52511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42503',
  },
  {
    city: 'Bronston',
    county_fips: 21199,
    county_fips_all: '21199|21231',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Wayne',
    county_weights: '{"21199": 52.46, "21231": 47.54}',
    density: 34.2,
    imprecise: false,
    latitude: 36.9253,
    longitude: -84.64265,
    militaryZip: false,
    timezone: 'America/Kentucky/Monticello',
    population: 3031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42518',
  },
  {
    city: 'Burnside',
    county_fips: 21199,
    county_fips_all: '21199',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"21199": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 36.93932,
    longitude: -84.53573,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42519',
  },
  {
    city: 'Dunnville',
    county_fips: 21045,
    county_fips_all: '21045|21207|21001',
    county: 'Casey',
    county_names_all: 'Casey|Russell|Adair',
    county_weights: '{"21045": 66.3, "21207": 17.53, "21001": 16.17}',
    density: 15.6,
    imprecise: false,
    latitude: 37.18335,
    longitude: -85.01712,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42528',
  },
  {
    city: 'Ferguson',
    county_fips: 21199,
    county_fips_all: '21199',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"21199": 100}',
    density: 213.5,
    imprecise: false,
    latitude: 37.06752,
    longitude: -84.59382,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42533',
  },
  {
    city: 'Liberty',
    county_fips: 21045,
    county_fips_all: '21045|21001',
    county: 'Casey',
    county_names_all: 'Casey|Adair',
    county_weights: '{"21045": 98.95, "21001": 1.05}',
    density: 16.3,
    imprecise: false,
    latitude: 37.30566,
    longitude: -84.95265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42539',
  },
  {
    city: 'Middleburg',
    county_fips: 21045,
    county_fips_all: '21045',
    county: 'Casey',
    county_names_all: 'Casey',
    county_weights: '{"21045": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 37.37325,
    longitude: -84.80778,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42541',
  },
  {
    city: 'Nancy',
    county_fips: 21199,
    county_fips_all: '21199|21207|21231',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Russell|Wayne',
    county_weights: '{"21199": 73.6, "21207": 16.53, "21231": 9.87}',
    density: 15,
    imprecise: false,
    latitude: 37.03473,
    longitude: -84.8143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42544',
  },
  {
    city: 'Science Hill',
    county_fips: 21199,
    county_fips_all: '21199',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"21199": 100}',
    density: 33.2,
    imprecise: false,
    latitude: 37.1716,
    longitude: -84.70056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42553',
  },
  {
    city: 'Yosemite',
    county_fips: 21045,
    county_fips_all: '21045',
    county: 'Casey',
    county_names_all: 'Casey',
    county_weights: '{"21045": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 37.28389,
    longitude: -84.77932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42566',
  },
  {
    city: 'Eubank',
    county_fips: 21199,
    county_fips_all: '21199|21137',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Lincoln',
    county_weights: '{"21199": 87.78, "21137": 12.22}',
    density: 23.6,
    imprecise: false,
    latitude: 37.26441,
    longitude: -84.60454,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42567',
  },
  {
    city: 'Albany',
    county_fips: 21053,
    county_fips_all: '21053|21207|21231|47137',
    county: 'Clinton',
    county_names_all: 'Clinton|Russell|Wayne|Pickett',
    county_weights:
      '{"21053": 97.63, "21207": 1.25, "21231": 0.96, "47137": 0.16}',
    density: 18.3,
    imprecise: false,
    latitude: 36.73201,
    longitude: -85.13324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42602',
  },
  {
    city: 'Alpha',
    county_fips: 21231,
    county_fips_all: '21231|21053',
    county: 'Wayne',
    county_names_all: 'Wayne|Clinton',
    county_weights: '{"21231": 55.16, "21053": 44.84}',
    density: 23.5,
    imprecise: false,
    latitude: 36.77875,
    longitude: -85.01093,
    militaryZip: false,
    timezone: 'America/Kentucky/Monticello',
    population: 694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42603',
  },
  {
    city: 'Jamestown',
    county_fips: 21207,
    county_fips_all: '21207',
    county: 'Russell',
    county_names_all: 'Russell',
    county_weights: '{"21207": 100}',
    density: 19.7,
    imprecise: false,
    latitude: 36.92551,
    longitude: -85.11732,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42629',
  },
  {
    city: 'Marshes Siding',
    county_fips: 21147,
    county_fips_all: '21147',
    county: 'McCreary',
    county_names_all: 'McCreary',
    county_weights: '{"21147": 100}',
    density: 195.8,
    imprecise: false,
    latitude: 36.74039,
    longitude: -84.48098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42631',
  },
  {
    city: 'Monticello',
    county_fips: 21231,
    county_fips_all: '21231',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"21231": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 36.79245,
    longitude: -84.83155,
    militaryZip: false,
    timezone: 'America/Kentucky/Monticello',
    population: 18606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42633',
  },
  {
    city: 'Parkers Lake',
    county_fips: 21147,
    county_fips_all: '21147',
    county: 'McCreary',
    county_names_all: 'McCreary',
    county_weights: '{"21147": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 36.88043,
    longitude: -84.41601,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42634',
  },
  {
    city: 'Pine Knot',
    county_fips: 21147,
    county_fips_all: '21147',
    county: 'McCreary',
    county_names_all: 'McCreary',
    county_weights: '{"21147": 100}',
    density: 72.5,
    imprecise: false,
    latitude: 36.67601,
    longitude: -84.40033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42635',
  },
  {
    city: 'Revelo',
    county_fips: 21147,
    county_fips_all: '21147',
    county: 'McCreary',
    county_names_all: 'McCreary',
    county_weights: '{"21147": 100}',
    density: 79.9,
    imprecise: false,
    latitude: 36.67487,
    longitude: -84.4689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42638',
  },
  {
    city: 'Russell Springs',
    county_fips: 21207,
    county_fips_all: '21207|21001|21199|21045',
    county: 'Russell',
    county_names_all: 'Russell|Adair|Pulaski|Casey',
    county_weights:
      '{"21207": 86.34, "21001": 10.01, "21199": 2.94, "21045": 0.71}',
    density: 37.1,
    imprecise: false,
    latitude: 37.05624,
    longitude: -85.0352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42642',
  },
  {
    city: 'Stearns',
    county_fips: 21147,
    county_fips_all: '21147',
    county: 'McCreary',
    county_names_all: 'McCreary',
    county_weights: '{"21147": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 36.6922,
    longitude: -84.61144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42647',
  },
  {
    city: 'Strunk',
    county_fips: 21147,
    county_fips_all: '21147',
    county: 'McCreary',
    county_names_all: 'McCreary',
    county_weights: '{"21147": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 36.6253,
    longitude: -84.41798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42649',
  },
  {
    city: 'Whitley City',
    county_fips: 21147,
    county_fips_all: '21147',
    county: 'McCreary',
    county_names_all: 'McCreary',
    county_weights: '{"21147": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 36.78117,
    longitude: -84.4618,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42653',
  },
  {
    city: 'Elizabethtown',
    county_fips: 21093,
    county_fips_all: '21093',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"21093": 100}',
    density: 128.8,
    imprecise: false,
    latitude: 37.70502,
    longitude: -85.83881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53987,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42701',
  },
  {
    city: 'Big Clifty',
    county_fips: 21093,
    county_fips_all: '21093|21085',
    county: 'Hardin',
    county_names_all: 'Hardin|Grayson',
    county_weights: '{"21093": 52.39, "21085": 47.61}',
    density: 12.2,
    imprecise: false,
    latitude: 37.56098,
    longitude: -86.15791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42712',
  },
  {
    city: 'Bonnieville',
    county_fips: 21099,
    county_fips_all: '21099',
    county: 'Hart',
    county_names_all: 'Hart',
    county_weights: '{"21099": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 37.37631,
    longitude: -85.88282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42713',
  },
  {
    city: 'Breeding',
    county_fips: 21001,
    county_fips_all: '21001|21169|21057',
    county: 'Adair',
    county_names_all: 'Adair|Metcalfe|Cumberland',
    county_weights: '{"21001": 61.76, "21169": 22.53, "21057": 15.71}',
    density: 6.4,
    imprecise: false,
    latitude: 36.94352,
    longitude: -85.4134,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42715',
  },
  {
    city: 'Buffalo',
    county_fips: 21123,
    county_fips_all: '21123|21087|21217',
    county: 'Larue',
    county_names_all: 'Larue|Green|Taylor',
    county_weights: '{"21123": 74.84, "21087": 14.82, "21217": 10.34}',
    density: 20.4,
    imprecise: false,
    latitude: 37.47495,
    longitude: -85.61925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42716',
  },
  {
    city: 'Burkesville',
    county_fips: 21057,
    county_fips_all: '21057|21053',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Clinton',
    county_weights: '{"21057": 97.38, "21053": 2.62}',
    density: 7.6,
    imprecise: false,
    latitude: 36.78169,
    longitude: -85.38331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42717',
  },
  {
    city: 'Campbellsville',
    county_fips: 21217,
    county_fips_all: '21217|21155|21087|21123',
    county: 'Taylor',
    county_names_all: 'Taylor|Marion|Green|Larue',
    county_weights:
      '{"21217": 74.82, "21155": 13.06, "21087": 7.12, "21123": 5.0}',
    density: 38.9,
    imprecise: false,
    latitude: 37.38994,
    longitude: -85.37561,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42718',
  },
  {
    city: 'Caneyville',
    county_fips: 21085,
    county_fips_all: '21085|21031|21061',
    county: 'Grayson',
    county_names_all: 'Grayson|Butler|Edmonson',
    county_weights: '{"21085": 89.94, "21031": 6.12, "21061": 3.94}',
    density: 11.8,
    imprecise: false,
    latitude: 37.42173,
    longitude: -86.49593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42721',
  },
  {
    city: 'Canmer',
    county_fips: 21099,
    county_fips_all: '21099',
    county: 'Hart',
    county_names_all: 'Hart',
    county_weights: '{"21099": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 37.27628,
    longitude: -85.71703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42722',
  },
  {
    city: 'Cecilia',
    county_fips: 21093,
    county_fips_all: '21093',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"21093": 100}',
    density: 27.1,
    imprecise: false,
    latitude: 37.67293,
    longitude: -86.06461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42724',
  },
  {
    city: 'Clarkson',
    county_fips: 21085,
    county_fips_all: '21085',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"21085": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 37.42423,
    longitude: -86.15035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42726',
  },
  {
    city: 'Columbia',
    county_fips: 21001,
    county_fips_all: '21001|21217|21169',
    county: 'Adair',
    county_names_all: 'Adair|Taylor|Metcalfe',
    county_weights: '{"21001": 96.09, "21217": 3.81, "21169": 0.1}',
    density: 19.7,
    imprecise: false,
    latitude: 37.10943,
    longitude: -85.28873,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42728',
  },
  {
    city: 'Cub Run',
    county_fips: 21099,
    county_fips_all: '21099|21061',
    county: 'Hart',
    county_names_all: 'Hart|Edmonson',
    county_weights: '{"21099": 70.89, "21061": 29.11}',
    density: 20.2,
    imprecise: false,
    latitude: 37.30167,
    longitude: -86.09719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42729',
  },
  {
    city: 'Eastview',
    county_fips: 21093,
    county_fips_all: '21093',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"21093": 100}',
    density: 11,
    imprecise: false,
    latitude: 37.61,
    longitude: -86.11235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42732',
  },
  {
    city: 'Elk Horn',
    county_fips: 21217,
    county_fips_all: '21217|21045|21001',
    county: 'Taylor',
    county_names_all: 'Taylor|Casey|Adair',
    county_weights: '{"21217": 72.57, "21045": 25.04, "21001": 2.39}',
    density: 11.2,
    imprecise: false,
    latitude: 37.34008,
    longitude: -85.18028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42733',
  },
  {
    city: 'Glendale',
    county_fips: 21093,
    county_fips_all: '21093',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"21093": 100}',
    density: 23.3,
    imprecise: false,
    latitude: 37.59174,
    longitude: -85.94358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42740',
  },
  {
    city: 'Greensburg',
    county_fips: 21087,
    county_fips_all: '21087|21001',
    county: 'Green',
    county_names_all: 'Green|Adair',
    county_weights: '{"21087": 97.32, "21001": 2.68}',
    density: 17.5,
    imprecise: false,
    latitude: 37.22958,
    longitude: -85.53175,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42743',
  },
  {
    city: 'Hardyville',
    county_fips: 21099,
    county_fips_all: '21099|21087|21169',
    county: 'Hart',
    county_names_all: 'Hart|Green|Metcalfe',
    county_weights: '{"21099": 78.66, "21087": 15.29, "21169": 6.05}',
    density: 17.1,
    imprecise: false,
    latitude: 37.21233,
    longitude: -85.73304,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42746',
  },
  {
    city: 'Hodgenville',
    county_fips: 21123,
    county_fips_all: '21123|21093',
    county: 'Larue',
    county_names_all: 'Larue|Hardin',
    county_weights: '{"21123": 99.81, "21093": 0.19}',
    density: 28.2,
    imprecise: false,
    latitude: 37.57029,
    longitude: -85.70952,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42748',
  },
  {
    city: 'Horse Cave',
    county_fips: 21099,
    county_fips_all: '21099|21169|21009',
    county: 'Hart',
    county_names_all: 'Hart|Metcalfe|Barren',
    county_weights: '{"21099": 80.3, "21169": 13.31, "21009": 6.39}',
    density: 18.6,
    imprecise: false,
    latitude: 37.18983,
    longitude: -85.87516,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42749',
  },
  {
    city: 'Knifley',
    county_fips: 21001,
    county_fips_all: '21001',
    county: 'Adair',
    county_names_all: 'Adair',
    county_weights: '{"21001": 100}',
    density: 10,
    imprecise: false,
    latitude: 37.22299,
    longitude: -85.17411,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42753',
  },
  {
    city: 'Leitchfield',
    county_fips: 21085,
    county_fips_all: '21085|21027|21061',
    county: 'Grayson',
    county_names_all: 'Grayson|Breckinridge|Edmonson',
    county_weights: '{"21085": 90.1, "21027": 9.3, "21061": 0.6}',
    density: 34.6,
    imprecise: false,
    latitude: 37.47814,
    longitude: -86.31379,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42754',
  },
  {
    city: 'Magnolia',
    county_fips: 21099,
    county_fips_all: '21099|21123|21087',
    county: 'Hart',
    county_names_all: 'Hart|Larue|Green',
    county_weights: '{"21099": 63.22, "21123": 29.63, "21087": 7.15}',
    density: 12.6,
    imprecise: false,
    latitude: 37.40192,
    longitude: -85.72501,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42757',
  },
  {
    city: 'Mannsville',
    county_fips: 21217,
    county_fips_all: '21217',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"21217": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.37656,
    longitude: -85.19756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42758',
  },
  {
    city: 'Marrowbone',
    county_fips: 21057,
    county_fips_all: '21057',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"21057": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 36.82909,
    longitude: -85.51334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42759',
  },
  {
    city: 'Millwood',
    county_fips: 21085,
    county_fips_all: '21085',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"21085": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 37.45366,
    longitude: -86.39527,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42762',
  },
  {
    city: 'Mount Sherman',
    county_fips: 21087,
    county_fips_all: '21087|21123',
    county: 'Green',
    county_names_all: 'Green|Larue',
    county_weights: '{"21087": 86.92, "21123": 13.08}',
    density: 11.4,
    imprecise: false,
    latitude: 37.42948,
    longitude: -85.62507,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42764',
  },
  {
    city: 'Munfordville',
    county_fips: 21099,
    county_fips_all: '21099',
    county: 'Hart',
    county_names_all: 'Hart',
    county_weights: '{"21099": 100}',
    density: 24.1,
    imprecise: false,
    latitude: 37.30699,
    longitude: -85.93115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42765',
  },
  {
    city: 'Sonora',
    county_fips: 21093,
    county_fips_all: '21093|21123',
    county: 'Hardin',
    county_names_all: 'Hardin|Larue',
    county_weights: '{"21093": 69.11, "21123": 30.89}',
    density: 12.2,
    imprecise: false,
    latitude: 37.51577,
    longitude: -85.91834,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42776',
  },
  {
    city: 'Summersville',
    county_fips: 21087,
    county_fips_all: '21087|21099',
    county: 'Green',
    county_names_all: 'Green|Hart',
    county_weights: '{"21087": 87.17, "21099": 12.83}',
    density: 8.1,
    imprecise: false,
    latitude: 37.34475,
    longitude: -85.63702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42782',
  },
  {
    city: 'Upton',
    county_fips: 21099,
    county_fips_all: '21099|21093|21123',
    county: 'Hart',
    county_names_all: 'Hart|Hardin|Larue',
    county_weights: '{"21099": 39.46, "21093": 36.34, "21123": 24.2}',
    density: 18.1,
    imprecise: false,
    latitude: 37.4503,
    longitude: -85.92272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42784',
  },
  {
    city: 'White Mills',
    county_fips: 21093,
    county_fips_all: '21093',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"21093": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 37.52774,
    longitude: -86.0372,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42788',
  },
  {
    city: 'Alexandria',
    county_fips: 39089,
    county_fips_all: '39089',
    county: 'Licking',
    county_names_all: 'Licking',
    county_weights: '{"39089": 100}',
    density: 38.1,
    imprecise: false,
    latitude: 40.08794,
    longitude: -82.61289,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43001',
  },
  {
    city: 'Amlin',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1304.8,
    imprecise: false,
    latitude: 40.05982,
    longitude: -83.17305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43002',
  },
  {
    city: 'Ashley',
    county_fips: 39041,
    county_fips_all: '39041|39117',
    county: 'Delaware',
    county_names_all: 'Delaware|Morrow',
    county_weights: '{"39041": 50.82, "39117": 49.18}',
    density: 42.5,
    imprecise: false,
    latitude: 40.41017,
    longitude: -82.96866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43003',
  },
  {
    city: 'Blacklick',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 972.1,
    imprecise: false,
    latitude: 40.01664,
    longitude: -82.80025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43004',
  },
  {
    city: 'Bladensburg',
    county_fips: 39083,
    county_fips_all: '39083',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"39083": 100}',
    density: 67.1,
    imprecise: false,
    latitude: 40.28241,
    longitude: -82.26728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43005',
  },
  {
    city: 'Brinkhaven',
    county_fips: 39031,
    county_fips_all: '39031|39075|39083',
    county: 'Coshocton',
    county_names_all: 'Coshocton|Holmes|Knox',
    county_weights: '{"39031": 45.63, "39075": 44.07, "39083": 10.3}',
    density: 12,
    imprecise: false,
    latitude: 40.4591,
    longitude: -82.14554,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43006',
  },
  {
    city: 'Broadway',
    county_fips: 39159,
    county_fips_all: '39159',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"39159": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 40.33154,
    longitude: -83.40595,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43007',
  },
  {
    city: 'Buckeye Lake',
    county_fips: 39089,
    county_fips_all: '39089',
    county: 'Licking',
    county_names_all: 'Licking',
    county_weights: '{"39089": 100}',
    density: 625.7,
    imprecise: false,
    latitude: 39.93348,
    longitude: -82.4817,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43008',
  },
  {
    city: 'Cable',
    county_fips: 39021,
    county_fips_all: '39021',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"39021": 100}',
    density: 25.5,
    imprecise: false,
    latitude: 40.17188,
    longitude: -83.64234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43009',
  },
  {
    city: 'Catawba',
    county_fips: 39023,
    county_fips_all: '39023',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"39023": 100}',
    density: 510.3,
    imprecise: false,
    latitude: 39.99964,
    longitude: -83.6219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43010',
  },
  {
    city: 'Centerburg',
    county_fips: 39083,
    county_fips_all: '39083|39089|39117|39041',
    county: 'Knox',
    county_names_all: 'Knox|Licking|Morrow|Delaware',
    county_weights:
      '{"39083": 51.72, "39089": 19.3, "39117": 15.37, "39041": 13.61}',
    density: 31.8,
    imprecise: false,
    latitude: 40.30946,
    longitude: -82.68456,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43011',
  },
  {
    city: 'Croton',
    county_fips: 39089,
    county_fips_all: '39089|39041',
    county: 'Licking',
    county_names_all: 'Licking|Delaware',
    county_weights: '{"39089": 99.05, "39041": 0.95}',
    density: 33.7,
    imprecise: false,
    latitude: 40.23101,
    longitude: -82.6895,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43013',
  },
  {
    city: 'Danville',
    county_fips: 39083,
    county_fips_all: '39083|39031|39005',
    county: 'Knox',
    county_names_all: 'Knox|Coshocton|Ashland',
    county_weights: '{"39083": 94.41, "39031": 5.05, "39005": 0.54}',
    density: 20.6,
    imprecise: false,
    latitude: 40.46646,
    longitude: -82.25242,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43014',
  },
  {
    city: 'Delaware',
    county_fips: 39041,
    county_fips_all: '39041|39159',
    county: 'Delaware',
    county_names_all: 'Delaware|Union',
    county_weights: '{"39041": 99.49, "39159": 0.51}',
    density: 185.3,
    imprecise: false,
    latitude: 40.29812,
    longitude: -83.06049,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 61401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43015',
  },
  {
    city: 'Dublin',
    county_fips: 39049,
    county_fips_all: '39049|39159|39041',
    county: 'Franklin',
    county_names_all: 'Franklin|Union|Delaware',
    county_weights: '{"39049": 90.83, "39159": 8.5, "39041": 0.67}',
    density: 942,
    imprecise: false,
    latitude: 40.09732,
    longitude: -83.15535,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43016',
  },
  {
    city: 'Dublin',
    county_fips: 39049,
    county_fips_all: '39049|39041|39159',
    county: 'Franklin',
    county_names_all: 'Franklin|Delaware|Union',
    county_weights: '{"39049": 74.02, "39041": 21.92, "39159": 4.06}',
    density: 995.2,
    imprecise: false,
    latitude: 40.1189,
    longitude: -83.13314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43017',
  },
  {
    city: 'Etna',
    county_fips: 39089,
    county_fips_all: '39089',
    county: 'Licking',
    county_names_all: 'Licking',
    county_weights: '{"39089": 100}',
    density: 178.1,
    imprecise: false,
    latitude: 39.95377,
    longitude: -82.67613,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43018',
  },
  {
    city: 'Fredericktown',
    county_fips: 39083,
    county_fips_all: '39083|39117|39139',
    county: 'Knox',
    county_names_all: 'Knox|Morrow|Richland',
    county_weights: '{"39083": 68.99, "39117": 28.3, "39139": 2.71}',
    density: 33.2,
    imprecise: false,
    latitude: 40.49527,
    longitude: -82.57831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43019',
  },
  {
    city: 'Galena',
    county_fips: 39041,
    county_fips_all: '39041',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"39041": 100}',
    density: 143,
    imprecise: false,
    latitude: 40.20301,
    longitude: -82.88476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43021',
  },
  {
    city: 'Gambier',
    county_fips: 39083,
    county_fips_all: '39083',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"39083": 100}',
    density: 33.4,
    imprecise: false,
    latitude: 40.33765,
    longitude: -82.34135,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43022',
  },
  {
    city: 'Granville',
    county_fips: 39089,
    county_fips_all: '39089',
    county: 'Licking',
    county_names_all: 'Licking',
    county_weights: '{"39089": 100}',
    density: 121.3,
    imprecise: false,
    latitude: 40.07603,
    longitude: -82.53061,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43023',
  },
  {
    city: 'Hebron',
    county_fips: 39089,
    county_fips_all: '39089',
    county: 'Licking',
    county_names_all: 'Licking',
    county_weights: '{"39089": 100}',
    density: 58.3,
    imprecise: false,
    latitude: 39.96653,
    longitude: -82.51529,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43025',
  },
  {
    city: 'Hilliard',
    county_fips: 39049,
    county_fips_all: '39049|39097',
    county: 'Franklin',
    county_names_all: 'Franklin|Madison',
    county_weights: '{"39049": 99.0, "39097": 1.0}',
    density: 713.7,
    imprecise: false,
    latitude: 40.02197,
    longitude: -83.18472,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43026',
  },
  {
    city: 'Howard',
    county_fips: 39083,
    county_fips_all: '39083',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"39083": 100}',
    density: 59.4,
    imprecise: false,
    latitude: 40.40335,
    longitude: -82.29783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43028',
  },
  {
    city: 'Irwin',
    county_fips: 39097,
    county_fips_all: '39097|39159',
    county: 'Madison',
    county_names_all: 'Madison|Union',
    county_weights: '{"39097": 78.68, "39159": 21.32}',
    density: 9,
    imprecise: false,
    latitude: 40.09598,
    longitude: -83.45408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43029',
  },
  {
    city: 'Jacksontown',
    county_fips: 39089,
    county_fips_all: '39089',
    county: 'Licking',
    county_names_all: 'Licking',
    county_weights: '{"39089": 100}',
    density: 46.9,
    imprecise: false,
    latitude: 39.96783,
    longitude: -82.40667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43030',
  },
  {
    city: 'Johnstown',
    county_fips: 39089,
    county_fips_all: '39089|39041',
    county: 'Licking',
    county_names_all: 'Licking|Delaware',
    county_weights: '{"39089": 94.68, "39041": 5.32}',
    density: 63,
    imprecise: false,
    latitude: 40.16292,
    longitude: -82.66378,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43031',
  },
  {
    city: 'Kirkersville',
    county_fips: 39089,
    county_fips_all: '39089',
    county: 'Licking',
    county_names_all: 'Licking',
    county_weights: '{"39089": 100}',
    density: 205.7,
    imprecise: false,
    latitude: 39.96098,
    longitude: -82.59984,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43033',
  },
  {
    city: 'Lewis Center',
    county_fips: 39041,
    county_fips_all: '39041',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"39041": 100}',
    density: 709.1,
    imprecise: false,
    latitude: 40.18622,
    longitude: -82.9969,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43035',
  },
  {
    city: 'Magnetic Springs',
    county_fips: 39159,
    county_fips_all: '39159',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"39159": 100}',
    density: 850.5,
    imprecise: false,
    latitude: 40.3524,
    longitude: -83.26325,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43036',
  },
  {
    city: 'Martinsburg',
    county_fips: 39083,
    county_fips_all: '39083',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"39083": 100}',
    density: 34.9,
    imprecise: false,
    latitude: 40.28062,
    longitude: -82.31654,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43037',
  },
  {
    city: 'Marysville',
    county_fips: 39159,
    county_fips_all: '39159|39041',
    county: 'Union',
    county_names_all: 'Union|Delaware',
    county_weights: '{"39159": 99.22, "39041": 0.78}',
    density: 90.5,
    imprecise: false,
    latitude: 40.26115,
    longitude: -83.35812,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43040',
  },
  {
    city: 'Mechanicsburg',
    county_fips: 39021,
    county_fips_all: '39021|39097|39023',
    county: 'Champaign',
    county_names_all: 'Champaign|Madison|Clark',
    county_weights: '{"39021": 68.91, "39097": 16.33, "39023": 14.76}',
    density: 24.1,
    imprecise: false,
    latitude: 40.05145,
    longitude: -83.56423,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43044',
  },
  {
    city: 'Milford Center',
    county_fips: 39159,
    county_fips_all: '39159|39021',
    county: 'Union',
    county_names_all: 'Union|Champaign',
    county_weights: '{"39159": 92.87, "39021": 7.13}',
    density: 17.9,
    imprecise: false,
    latitude: 40.16932,
    longitude: -83.44975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43045',
  },
  {
    city: 'Millersport',
    county_fips: 39045,
    county_fips_all: '39045|39089',
    county: 'Fairfield',
    county_names_all: 'Fairfield|Licking',
    county_weights: '{"39045": 88.57, "39089": 11.43}',
    density: 42.7,
    imprecise: false,
    latitude: 39.89917,
    longitude: -82.53844,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43046',
  },
  {
    city: 'Mingo',
    county_fips: 39021,
    county_fips_all: '39021',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"39021": 100}',
    density: 656.4,
    imprecise: false,
    latitude: 40.20795,
    longitude: -83.63797,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43047',
  },
  {
    city: 'Mount Vernon',
    county_fips: 39083,
    county_fips_all: '39083|39117',
    county: 'Knox',
    county_names_all: 'Knox|Morrow',
    county_weights: '{"39083": 99.39, "39117": 0.61}',
    density: 77.9,
    imprecise: false,
    latitude: 40.37188,
    longitude: -82.49536,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43050',
  },
  {
    city: 'New Albany',
    county_fips: 39049,
    county_fips_all: '39049|39089|39041',
    county: 'Franklin',
    county_names_all: 'Franklin|Licking|Delaware',
    county_weights: '{"39049": 78.74, "39089": 19.75, "39041": 1.51}',
    density: 415,
    imprecise: false,
    latitude: 40.07998,
    longitude: -82.79253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43054',
  },
  {
    city: 'Newark',
    county_fips: 39089,
    county_fips_all: '39089',
    county: 'Licking',
    county_names_all: 'Licking',
    county_weights: '{"39089": 100}',
    density: 216.8,
    imprecise: false,
    latitude: 40.1168,
    longitude: -82.37672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 63281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43055',
  },
  {
    city: 'Heath',
    county_fips: 39089,
    county_fips_all: '39089|39119',
    county: 'Licking',
    county_names_all: 'Licking|Muskingum',
    county_weights: '{"39089": 97.67, "39119": 2.33}',
    density: 78.3,
    imprecise: false,
    latitude: 40.00895,
    longitude: -82.33057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43056',
  },
  {
    city: 'North Lewisburg',
    county_fips: 39021,
    county_fips_all: '39021|39091|39159',
    county: 'Champaign',
    county_names_all: 'Champaign|Logan|Union',
    county_weights: '{"39021": 69.13, "39091": 21.79, "39159": 9.08}',
    density: 34.9,
    imprecise: false,
    latitude: 40.21978,
    longitude: -83.57295,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43060',
  },
  {
    city: 'Ostrander',
    county_fips: 39041,
    county_fips_all: '39041|39159',
    county: 'Delaware',
    county_names_all: 'Delaware|Union',
    county_weights: '{"39041": 83.63, "39159": 16.37}',
    density: 42,
    imprecise: false,
    latitude: 40.28775,
    longitude: -83.20256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43061',
  },
  {
    city: 'Pataskala',
    county_fips: 39089,
    county_fips_all: '39089|39045',
    county: 'Licking',
    county_names_all: 'Licking|Fairfield',
    county_weights: '{"39089": 98.33, "39045": 1.67}',
    density: 166.6,
    imprecise: false,
    latitude: 40.00556,
    longitude: -82.67964,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43062',
  },
  {
    city: 'Plain City',
    county_fips: 39097,
    county_fips_all: '39097|39159|39049',
    county: 'Madison',
    county_names_all: 'Madison|Union|Franklin',
    county_weights: '{"39097": 56.33, "39159": 43.38, "39049": 0.29}',
    density: 67.6,
    imprecise: false,
    latitude: 40.09819,
    longitude: -83.28863,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43064',
  },
  {
    city: 'Powell',
    county_fips: 39041,
    county_fips_all: '39041|39049',
    county: 'Delaware',
    county_names_all: 'Delaware|Franklin',
    county_weights: '{"39041": 95.57, "39049": 4.43}',
    density: 641.8,
    imprecise: false,
    latitude: 40.17655,
    longitude: -83.09445,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43065',
  },
  {
    city: 'Radnor',
    county_fips: 39041,
    county_fips_all: '39041',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"39041": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 40.39877,
    longitude: -83.16313,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43066',
  },
  {
    city: 'Raymond',
    county_fips: 39159,
    county_fips_all: '39159|39091',
    county: 'Union',
    county_names_all: 'Union|Logan',
    county_weights: '{"39159": 89.6, "39091": 10.4}',
    density: 22.2,
    imprecise: false,
    latitude: 40.34368,
    longitude: -83.48388,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43067',
  },
  {
    city: 'Reynoldsburg',
    county_fips: 39049,
    county_fips_all: '39049|39089|39045',
    county: 'Franklin',
    county_names_all: 'Franklin|Licking|Fairfield',
    county_weights: '{"39049": 49.4, "39089": 41.71, "39045": 8.89}',
    density: 1184.4,
    imprecise: false,
    latitude: 39.95667,
    longitude: -82.78468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43068',
  },
  {
    city: 'Rosewood',
    county_fips: 39021,
    county_fips_all: '39021',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"39021": 100}',
    density: 160.2,
    imprecise: false,
    latitude: 40.22056,
    longitude: -83.95651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43070',
  },
  {
    city: 'Saint Louisville',
    county_fips: 39089,
    county_fips_all: '39089',
    county: 'Licking',
    county_names_all: 'Licking',
    county_weights: '{"39089": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 40.18479,
    longitude: -82.35509,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43071',
  },
  {
    city: 'Saint Paris',
    county_fips: 39021,
    county_fips_all: '39021',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"39021": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 40.1172,
    longitude: -83.95514,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43072',
  },
  {
    city: 'Sunbury',
    county_fips: 39041,
    county_fips_all: '39041|39089',
    county: 'Delaware',
    county_names_all: 'Delaware|Licking',
    county_weights: '{"39041": 97.92, "39089": 2.08}',
    density: 76.5,
    imprecise: false,
    latitude: 40.28008,
    longitude: -82.84899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43074',
  },
  {
    city: 'Thornville',
    county_fips: 39127,
    county_fips_all: '39127|39089|39045',
    county: 'Perry',
    county_names_all: 'Perry|Licking|Fairfield',
    county_weights: '{"39127": 57.36, "39089": 31.72, "39045": 10.92}',
    density: 56,
    imprecise: false,
    latitude: 39.89594,
    longitude: -82.39497,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43076',
  },
  {
    city: 'Unionville Center',
    county_fips: 39159,
    county_fips_all: '39159',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"39159": 100}',
    density: 651.7,
    imprecise: false,
    latitude: 40.13675,
    longitude: -83.34165,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43077',
  },
  {
    city: 'Urbana',
    county_fips: 39021,
    county_fips_all: '39021|39023',
    county: 'Champaign',
    county_names_all: 'Champaign|Clark',
    county_weights: '{"39021": 99.18, "39023": 0.82}',
    density: 50.6,
    imprecise: false,
    latitude: 40.11302,
    longitude: -83.77538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43078',
  },
  {
    city: 'Utica',
    county_fips: 39089,
    county_fips_all: '39089|39083',
    county: 'Licking',
    county_names_all: 'Licking|Knox',
    county_weights: '{"39089": 59.93, "39083": 40.07}',
    density: 28,
    imprecise: false,
    latitude: 40.24284,
    longitude: -82.43126,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43080',
  },
  {
    city: 'Westerville',
    county_fips: 39049,
    county_fips_all: '39049|39041',
    county: 'Franklin',
    county_names_all: 'Franklin|Delaware',
    county_weights: '{"39049": 99.38, "39041": 0.62}',
    density: 999.6,
    imprecise: false,
    latitude: 40.11064,
    longitude: -82.89083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43081',
  },
  {
    city: 'Westerville',
    county_fips: 39041,
    county_fips_all: '39041',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"39041": 100}',
    density: 637,
    imprecise: false,
    latitude: 40.15537,
    longitude: -82.88437,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43082',
  },
  {
    city: 'Woodstock',
    county_fips: 39021,
    county_fips_all: '39021|39159',
    county: 'Champaign',
    county_names_all: 'Champaign|Union',
    county_weights: '{"39021": 97.94, "39159": 2.06}',
    density: 18.3,
    imprecise: false,
    latitude: 40.15764,
    longitude: -83.54223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43084',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1404,
    imprecise: false,
    latitude: 40.09959,
    longitude: -83.01639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43085',
  },
  {
    city: 'Adelphi',
    county_fips: 39141,
    county_fips_all: '39141',
    county: 'Ross',
    county_names_all: 'Ross',
    county_weights: '{"39141": 100}',
    density: 445.5,
    imprecise: false,
    latitude: 39.46466,
    longitude: -82.74563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43101',
  },
  {
    city: 'Amanda',
    county_fips: 39045,
    county_fips_all: '39045|39073|39129',
    county: 'Fairfield',
    county_names_all: 'Fairfield|Hocking|Pickaway',
    county_weights: '{"39045": 95.97, "39073": 3.45, "39129": 0.58}',
    density: 25,
    imprecise: false,
    latitude: 39.64076,
    longitude: -82.76118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43102',
  },
  {
    city: 'Ashville',
    county_fips: 39129,
    county_fips_all: '39129|39045',
    county: 'Pickaway',
    county_names_all: 'Pickaway|Fairfield',
    county_weights: '{"39129": 99.39, "39045": 0.61}',
    density: 60.6,
    imprecise: false,
    latitude: 39.72484,
    longitude: -82.93428,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43103',
  },
  {
    city: 'Baltimore',
    county_fips: 39045,
    county_fips_all: '39045|39089',
    county: 'Fairfield',
    county_names_all: 'Fairfield|Licking',
    county_weights: '{"39045": 99.47, "39089": 0.53}',
    density: 61.2,
    imprecise: false,
    latitude: 39.86513,
    longitude: -82.61826,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43105',
  },
  {
    city: 'Bloomingburg',
    county_fips: 39047,
    county_fips_all: '39047',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"39047": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 39.6448,
    longitude: -83.41853,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43106',
  },
  {
    city: 'Bremen',
    county_fips: 39045,
    county_fips_all: '39045|39073|39127',
    county: 'Fairfield',
    county_names_all: 'Fairfield|Hocking|Perry',
    county_weights: '{"39045": 87.37, "39073": 7.96, "39127": 4.67}',
    density: 49.2,
    imprecise: false,
    latitude: 39.69254,
    longitude: -82.40993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43107',
  },
  {
    city: 'Brice',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 349.5,
    imprecise: false,
    latitude: 39.9127,
    longitude: -82.83385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43109',
  },
  {
    city: 'Canal Winchester',
    county_fips: 39045,
    county_fips_all: '39045|39049|39129',
    county: 'Fairfield',
    county_names_all: 'Fairfield|Franklin|Pickaway',
    county_weights: '{"39045": 59.07, "39049": 39.01, "39129": 1.92}',
    density: 360.2,
    imprecise: false,
    latitude: 39.82825,
    longitude: -82.80143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43110',
  },
  {
    city: 'Carbon Hill',
    county_fips: 39073,
    county_fips_all: '39073',
    county: 'Hocking',
    county_names_all: 'Hocking',
    county_weights: '{"39073": 100}',
    density: 237.7,
    imprecise: false,
    latitude: 39.50212,
    longitude: -82.24257,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43111',
  },
  {
    city: 'Carroll',
    county_fips: 39045,
    county_fips_all: '39045',
    county: 'Fairfield',
    county_names_all: 'Fairfield',
    county_weights: '{"39045": 100}',
    density: 53.5,
    imprecise: false,
    latitude: 39.79719,
    longitude: -82.70472,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43112',
  },
  {
    city: 'Circleville',
    county_fips: 39129,
    county_fips_all: '39129|39045',
    county: 'Pickaway',
    county_names_all: 'Pickaway|Fairfield',
    county_weights: '{"39129": 99.59, "39045": 0.41}',
    density: 58.3,
    imprecise: false,
    latitude: 39.59114,
    longitude: -82.96192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43113',
  },
  {
    city: 'Clarksburg',
    county_fips: 39141,
    county_fips_all: '39141|39129',
    county: 'Ross',
    county_names_all: 'Ross|Pickaway',
    county_weights: '{"39141": 83.27, "39129": 16.73}',
    density: 15.6,
    imprecise: false,
    latitude: 39.48989,
    longitude: -83.16579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43115',
  },
  {
    city: 'Commercial Point',
    county_fips: 39129,
    county_fips_all: '39129',
    county: 'Pickaway',
    county_names_all: 'Pickaway',
    county_weights: '{"39129": 100}',
    density: 1023.5,
    imprecise: false,
    latitude: 39.77284,
    longitude: -83.06275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43116',
  },
  {
    city: 'Derby',
    county_fips: 39129,
    county_fips_all: '39129',
    county: 'Pickaway',
    county_names_all: 'Pickaway',
    county_weights: '{"39129": 100}',
    density: 162.2,
    imprecise: false,
    latitude: 39.76874,
    longitude: -83.20622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43117',
  },
  {
    city: 'Galloway',
    county_fips: 39049,
    county_fips_all: '39049|39097',
    county: 'Franklin',
    county_names_all: 'Franklin|Madison',
    county_weights: '{"39049": 88.73, "39097": 11.27}',
    density: 356.7,
    imprecise: false,
    latitude: 39.93487,
    longitude: -83.20059,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43119',
  },
  {
    city: 'Grove City',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 437,
    imprecise: false,
    latitude: 39.86801,
    longitude: -83.12088,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 67626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43123',
  },
  {
    city: 'Groveport',
    county_fips: 39049,
    county_fips_all: '39049|39129',
    county: 'Franklin',
    county_names_all: 'Franklin|Pickaway',
    county_weights: '{"39049": 87.04, "39129": 12.96}',
    density: 181.7,
    imprecise: false,
    latitude: 39.83747,
    longitude: -82.88588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43125',
  },
  {
    city: 'Harrisburg',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 753.5,
    imprecise: false,
    latitude: 39.81077,
    longitude: -83.16857,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43126',
  },
  {
    city: 'Haydenville',
    county_fips: 39073,
    county_fips_all: '39073',
    county: 'Hocking',
    county_names_all: 'Hocking',
    county_weights: '{"39073": 100}',
    density: 96.5,
    imprecise: false,
    latitude: 39.47559,
    longitude: -82.32183,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43127',
  },
  {
    city: 'Jeffersonville',
    county_fips: 39047,
    county_fips_all: '39047',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"39047": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 39.66359,
    longitude: -83.57893,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43128',
  },
  {
    city: 'Lancaster',
    county_fips: 39045,
    county_fips_all: '39045|39073',
    county: 'Fairfield',
    county_names_all: 'Fairfield|Hocking',
    county_weights: '{"39045": 99.81, "39073": 0.19}',
    density: 147.7,
    imprecise: false,
    latitude: 39.70013,
    longitude: -82.60992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43130',
  },
  {
    city: 'Laurelville',
    county_fips: 39073,
    county_fips_all: '39073|39129|39141|39163',
    county: 'Hocking',
    county_names_all: 'Hocking|Pickaway|Ross|Vinton',
    county_weights:
      '{"39073": 79.14, "39129": 12.17, "39141": 7.91, "39163": 0.78}',
    density: 16.5,
    imprecise: false,
    latitude: 39.4711,
    longitude: -82.69736,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43135',
  },
  {
    city: 'Lithopolis',
    county_fips: 39045,
    county_fips_all: '39045',
    county: 'Fairfield',
    county_names_all: 'Fairfield',
    county_weights: '{"39045": 100}',
    density: 716.5,
    imprecise: false,
    latitude: 39.80157,
    longitude: -82.81543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43136',
  },
  {
    city: 'Lockbourne',
    county_fips: 39049,
    county_fips_all: '39049|39129',
    county: 'Franklin',
    county_names_all: 'Franklin|Pickaway',
    county_weights: '{"39049": 50.25, "39129": 49.75}',
    density: 29.2,
    imprecise: false,
    latitude: 39.80486,
    longitude: -82.98694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43137',
  },
  {
    city: 'Logan',
    county_fips: 39073,
    county_fips_all: '39073|39127|39163',
    county: 'Hocking',
    county_names_all: 'Hocking|Perry|Vinton',
    county_weights: '{"39073": 94.08, "39127": 5.43, "39163": 0.49}',
    density: 41.5,
    imprecise: false,
    latitude: 39.52225,
    longitude: -82.41335,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43138',
  },
  {
    city: 'London',
    county_fips: 39097,
    county_fips_all: '39097|39049|39023',
    county: 'Madison',
    county_names_all: 'Madison|Franklin|Clark',
    county_weights: '{"39097": 96.56, "39049": 2.21, "39023": 1.23}',
    density: 42.6,
    imprecise: false,
    latitude: 39.88406,
    longitude: -83.42946,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43140',
  },
  {
    city: 'Milledgeville',
    county_fips: 39047,
    county_fips_all: '39047',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"39047": 100}',
    density: 463.5,
    imprecise: false,
    latitude: 39.59289,
    longitude: -83.58777,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43142',
  },
  {
    city: 'Mount Sterling',
    county_fips: 39097,
    county_fips_all: '39097|39129|39047',
    county: 'Madison',
    county_names_all: 'Madison|Pickaway|Fayette',
    county_weights: '{"39097": 52.99, "39129": 29.71, "39047": 17.3}',
    density: 16.8,
    imprecise: false,
    latitude: 39.71801,
    longitude: -83.29672,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43143',
  },
  {
    city: 'Murray City',
    county_fips: 39073,
    county_fips_all: '39073',
    county: 'Hocking',
    county_names_all: 'Hocking',
    county_weights: '{"39073": 100}',
    density: 17,
    imprecise: false,
    latitude: 39.52797,
    longitude: -82.19155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43144',
  },
  {
    city: 'New Holland',
    county_fips: 39129,
    county_fips_all: '39129|39047',
    county: 'Pickaway',
    county_names_all: 'Pickaway|Fayette',
    county_weights: '{"39129": 51.17, "39047": 48.83}',
    density: 14.9,
    imprecise: false,
    latitude: 39.56281,
    longitude: -83.2594,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43145',
  },
  {
    city: 'Orient',
    county_fips: 39129,
    county_fips_all: '39129|39049|39097',
    county: 'Pickaway',
    county_names_all: 'Pickaway|Franklin|Madison',
    county_weights: '{"39129": 80.89, "39049": 17.9, "39097": 1.21}',
    density: 66.4,
    imprecise: false,
    latitude: 39.77293,
    longitude: -83.14333,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43146',
  },
  {
    city: 'Pickerington',
    county_fips: 39045,
    county_fips_all: '39045|39089|39049',
    county: 'Fairfield',
    county_names_all: 'Fairfield|Licking|Franklin',
    county_weights: '{"39045": 98.44, "39089": 0.92, "39049": 0.64}',
    density: 606.2,
    imprecise: false,
    latitude: 39.8982,
    longitude: -82.74227,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43147',
  },
  {
    city: 'Pleasantville',
    county_fips: 39045,
    county_fips_all: '39045|39127',
    county: 'Fairfield',
    county_names_all: 'Fairfield|Perry',
    county_weights: '{"39045": 89.83, "39127": 10.17}',
    density: 27.2,
    imprecise: false,
    latitude: 39.81809,
    longitude: -82.49887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43148',
  },
  {
    city: 'Rockbridge',
    county_fips: 39073,
    county_fips_all: '39073',
    county: 'Hocking',
    county_names_all: 'Hocking',
    county_weights: '{"39073": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 39.53742,
    longitude: -82.57188,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43149',
  },
  {
    city: 'Rushville',
    county_fips: 39045,
    county_fips_all: '39045|39127',
    county: 'Fairfield',
    county_names_all: 'Fairfield|Perry',
    county_weights: '{"39045": 57.66, "39127": 42.34}',
    density: 36.4,
    imprecise: false,
    latitude: 39.77446,
    longitude: -82.40565,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43150',
  },
  {
    city: 'Sedalia',
    county_fips: 39097,
    county_fips_all: '39097',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"39097": 100}',
    density: 346.3,
    imprecise: false,
    latitude: 39.73317,
    longitude: -83.47661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43151',
  },
  {
    city: 'South Bloomingville',
    county_fips: 39073,
    county_fips_all: '39073|39163',
    county: 'Hocking',
    county_names_all: 'Hocking|Vinton',
    county_weights: '{"39073": 76.96, "39163": 23.04}',
    density: 7.7,
    imprecise: false,
    latitude: 39.39211,
    longitude: -82.61433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43152',
  },
  {
    city: 'South Solon',
    county_fips: 39097,
    county_fips_all: '39097|39023|39047|39057',
    county: 'Madison',
    county_names_all: 'Madison|Clark|Fayette|Greene',
    county_weights:
      '{"39097": 74.81, "39023": 13.76, "39047": 9.04, "39057": 2.39}',
    density: 8.3,
    imprecise: false,
    latitude: 39.74071,
    longitude: -83.56781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43153',
  },
  {
    city: 'Stoutsville',
    county_fips: 39045,
    county_fips_all: '39045|39129',
    county: 'Fairfield',
    county_names_all: 'Fairfield|Pickaway',
    county_weights: '{"39045": 66.4, "39129": 33.6}',
    density: 49.4,
    imprecise: false,
    latitude: 39.60327,
    longitude: -82.82622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43154',
  },
  {
    city: 'Sugar Grove',
    county_fips: 39045,
    county_fips_all: '39045|39073',
    county: 'Fairfield',
    county_names_all: 'Fairfield|Hocking',
    county_weights: '{"39045": 61.0, "39073": 39.0}',
    density: 30.7,
    imprecise: false,
    latitude: 39.6251,
    longitude: -82.52618,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43155',
  },
  {
    city: 'Tarlton',
    county_fips: 39129,
    county_fips_all: '39129',
    county: 'Pickaway',
    county_names_all: 'Pickaway',
    county_weights: '{"39129": 100}',
    density: 306.1,
    imprecise: false,
    latitude: 39.55389,
    longitude: -82.77621,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43156',
  },
  {
    city: 'Thurston',
    county_fips: 39045,
    county_fips_all: '39045',
    county: 'Fairfield',
    county_names_all: 'Fairfield',
    county_weights: '{"39045": 100}',
    density: 582.2,
    imprecise: false,
    latitude: 39.84303,
    longitude: -82.54675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43157',
  },
  {
    city: 'Union Furnace',
    county_fips: 39073,
    county_fips_all: '39073',
    county: 'Hocking',
    county_names_all: 'Hocking',
    county_weights: '{"39073": 100}',
    density: 26.8,
    imprecise: false,
    latitude: 39.44968,
    longitude: -82.35546,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43158',
  },
  {
    city: 'Washington Court House',
    county_fips: 39047,
    county_fips_all: '39047|39141',
    county: 'Fayette',
    county_names_all: 'Fayette|Ross',
    county_weights: '{"39047": 94.09, "39141": 5.91}',
    density: 40,
    imprecise: false,
    latitude: 39.52871,
    longitude: -83.43917,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43160',
  },
  {
    city: 'West Jefferson',
    county_fips: 39097,
    county_fips_all: '39097',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"39097": 100}',
    density: 56.6,
    imprecise: false,
    latitude: 39.94369,
    longitude: -83.30633,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43162',
  },
  {
    city: 'Williamsport',
    county_fips: 39129,
    county_fips_all: '39129|39141',
    county: 'Pickaway',
    county_names_all: 'Pickaway|Ross',
    county_weights: '{"39129": 91.58, "39141": 8.42}',
    density: 13.5,
    imprecise: false,
    latitude: 39.58349,
    longitude: -83.12009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43164',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 4338.2,
    imprecise: false,
    latitude: 39.99114,
    longitude: -83.00056,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43201',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 3202.8,
    imprecise: false,
    latitude: 40.02126,
    longitude: -83.01394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43202',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 2309.3,
    imprecise: false,
    latitude: 39.9729,
    longitude: -82.96922,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43203',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1773.6,
    imprecise: false,
    latitude: 39.96135,
    longitude: -83.08052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43204',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 2038.7,
    imprecise: false,
    latitude: 39.9575,
    longitude: -82.96244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43205',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 2812.8,
    imprecise: false,
    latitude: 39.94205,
    longitude: -82.97346,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43206',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 789.4,
    imprecise: false,
    latitude: 39.89599,
    longitude: -82.96392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43207',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1778.5,
    imprecise: false,
    latitude: 39.95462,
    longitude: -82.92992,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43209',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 3161.1,
    imprecise: false,
    latitude: 40.00487,
    longitude: -83.02182,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43210',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1827.8,
    imprecise: false,
    latitude: 40.01163,
    longitude: -82.97244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43211',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 2418.5,
    imprecise: false,
    latitude: 39.98763,
    longitude: -83.04215,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43212',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1356.6,
    imprecise: false,
    latitude: 39.97117,
    longitude: -82.86746,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43213',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1517.3,
    imprecise: false,
    latitude: 40.0523,
    longitude: -83.01996,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43214',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1339.7,
    imprecise: false,
    latitude: 39.96633,
    longitude: -83.01262,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43215',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 187.9,
    imprecise: false,
    latitude: 39.81667,
    longitude: -82.93279,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43217',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.01765,
    longitude: -82.92367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43218',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 782.4,
    imprecise: false,
    latitude: 40.00774,
    longitude: -82.92233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43219',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1681.3,
    imprecise: false,
    latitude: 40.04847,
    longitude: -83.07161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43220',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1428.3,
    imprecise: false,
    latitude: 40.02334,
    longitude: -83.07744,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43221',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1318.5,
    imprecise: false,
    latitude: 39.961,
    longitude: -83.03581,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43222',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1088.1,
    imprecise: false,
    latitude: 39.92636,
    longitude: -83.03395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43223',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 2070.8,
    imprecise: false,
    latitude: 40.04256,
    longitude: -82.9664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43224',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 2359.9,
    imprecise: false,
    latitude: 39.94511,
    longitude: -82.88858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43227',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1146.7,
    imprecise: false,
    latitude: 39.96367,
    longitude: -83.12478,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43228',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 2350.5,
    imprecise: false,
    latitude: 40.08569,
    longitude: -82.97636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43229',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1098.9,
    imprecise: false,
    latitude: 40.03648,
    longitude: -82.87057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43230',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 2136.8,
    imprecise: false,
    latitude: 40.07843,
    longitude: -82.93914,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43231',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"39049": 100}',
    density: 1469.5,
    imprecise: false,
    latitude: 39.92189,
    longitude: -82.87053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43232',
  },
  {
    city: 'Columbus',
    county_fips: 39049,
    county_fips_all: '39049|39041',
    county: 'Franklin',
    county_names_all: 'Franklin|Delaware',
    county_weights: '{"39049": 99.87, "39041": 0.13}',
    density: 1216.6,
    imprecise: false,
    latitude: 40.10193,
    longitude: -83.05442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43235',
  },
  {
    city: 'Columbus',
    county_fips: 39041,
    county_fips_all: '39041',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"39041": 100}',
    density: 1205.9,
    imprecise: false,
    latitude: 40.14501,
    longitude: -82.98209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43240',
  },
  {
    city: 'Marion',
    county_fips: 39101,
    county_fips_all: '39101|39033|39159',
    county: 'Marion',
    county_names_all: 'Marion|Crawford|Union',
    county_weights: '{"39101": 95.06, "39033": 4.71, "39159": 0.23}',
    density: 106.3,
    imprecise: false,
    latitude: 40.59995,
    longitude: -83.12967,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43302',
  },
  {
    city: 'Belle Center',
    county_fips: 39065,
    county_fips_all: '39065|39091',
    county: 'Hardin',
    county_names_all: 'Hardin|Logan',
    county_weights: '{"39065": 54.72, "39091": 45.28}',
    density: 18.5,
    imprecise: false,
    latitude: 40.5346,
    longitude: -83.78029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43310',
  },
  {
    city: 'Bellefontaine',
    county_fips: 39091,
    county_fips_all: '39091',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"39091": 100}',
    density: 75.8,
    imprecise: false,
    latitude: 40.36427,
    longitude: -83.75812,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43311',
  },
  {
    city: 'Caledonia',
    county_fips: 39101,
    county_fips_all: '39101|39033|39117',
    county: 'Marion',
    county_names_all: 'Marion|Crawford|Morrow',
    county_weights: '{"39101": 79.94, "39033": 11.91, "39117": 8.15}',
    density: 17.3,
    imprecise: false,
    latitude: 40.6474,
    longitude: -82.96122,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43314',
  },
  {
    city: 'Cardington',
    county_fips: 39117,
    county_fips_all: '39117|39101',
    county: 'Morrow',
    county_names_all: 'Morrow|Marion',
    county_weights: '{"39117": 90.27, "39101": 9.73}',
    density: 31.6,
    imprecise: false,
    latitude: 40.4841,
    longitude: -82.87872,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43315',
  },
  {
    city: 'Carey',
    county_fips: 39175,
    county_fips_all: '39175|39147|39063',
    county: 'Wyandot',
    county_names_all: 'Wyandot|Seneca|Hancock',
    county_weights: '{"39175": 79.25, "39147": 17.03, "39063": 3.72}',
    density: 30.4,
    imprecise: false,
    latitude: 40.95184,
    longitude: -83.38596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43316',
  },
  {
    city: 'Chesterville',
    county_fips: 39117,
    county_fips_all: '39117',
    county: 'Morrow',
    county_names_all: 'Morrow',
    county_weights: '{"39117": 100}',
    density: 303.5,
    imprecise: false,
    latitude: 40.47748,
    longitude: -82.68202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43317',
  },
  {
    city: 'De Graff',
    county_fips: 39091,
    county_fips_all: '39091|39021',
    county: 'Logan',
    county_names_all: 'Logan|Champaign',
    county_weights: '{"39091": 67.88, "39021": 32.12}',
    density: 26.2,
    imprecise: false,
    latitude: 40.30948,
    longitude: -83.91378,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43318',
  },
  {
    city: 'East Liberty',
    county_fips: 39091,
    county_fips_all: '39091|39159',
    county: 'Logan',
    county_names_all: 'Logan|Union',
    county_weights: '{"39091": 99.16, "39159": 0.84}',
    density: 17.4,
    imprecise: false,
    latitude: 40.30525,
    longitude: -83.57738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43319',
  },
  {
    city: 'Edison',
    county_fips: 39117,
    county_fips_all: '39117',
    county: 'Morrow',
    county_names_all: 'Morrow',
    county_weights: '{"39117": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 40.5886,
    longitude: -82.89994,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43320',
  },
  {
    city: 'Fulton',
    county_fips: 39117,
    county_fips_all: '39117',
    county: 'Morrow',
    county_names_all: 'Morrow',
    county_weights: '{"39117": 100}',
    density: 953.8,
    imprecise: false,
    latitude: 40.463,
    longitude: -82.82889,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43321',
  },
  {
    city: 'Green Camp',
    county_fips: 39101,
    county_fips_all: '39101',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"39101": 100}',
    density: 570.9,
    imprecise: false,
    latitude: 40.5327,
    longitude: -83.20815,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43322',
  },
  {
    city: 'Harpster',
    county_fips: 39175,
    county_fips_all: '39175|39101',
    county: 'Wyandot',
    county_names_all: 'Wyandot|Marion',
    county_weights: '{"39175": 96.33, "39101": 3.67}',
    density: 6.3,
    imprecise: false,
    latitude: 40.73116,
    longitude: -83.25211,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43323',
  },
  {
    city: 'Huntsville',
    county_fips: 39091,
    county_fips_all: '39091',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"39091": 100}',
    density: 36.9,
    imprecise: false,
    latitude: 40.44632,
    longitude: -83.81207,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43324',
  },
  {
    city: 'Iberia',
    county_fips: 39117,
    county_fips_all: '39117',
    county: 'Morrow',
    county_names_all: 'Morrow',
    county_weights: '{"39117": 100}',
    density: 32,
    imprecise: false,
    latitude: 40.66939,
    longitude: -82.83102,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43325',
  },
  {
    city: 'Kenton',
    county_fips: 39065,
    county_fips_all: '39065|39101',
    county: 'Hardin',
    county_names_all: 'Hardin|Marion',
    county_weights: '{"39065": 99.31, "39101": 0.69}',
    density: 26,
    imprecise: false,
    latitude: 40.64149,
    longitude: -83.61443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43326',
  },
  {
    city: 'Kirby',
    county_fips: 39175,
    county_fips_all: '39175',
    county: 'Wyandot',
    county_names_all: 'Wyandot',
    county_weights: '{"39175": 100}',
    density: 358.3,
    imprecise: false,
    latitude: 40.81349,
    longitude: -83.41935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43330',
  },
  {
    city: 'Lakeview',
    county_fips: 39091,
    county_fips_all: '39091|39011|39065',
    county: 'Logan',
    county_names_all: 'Logan|Auglaize|Hardin',
    county_weights: '{"39091": 69.8, "39011": 25.08, "39065": 5.12}',
    density: 51.4,
    imprecise: false,
    latitude: 40.51794,
    longitude: -83.9191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43331',
  },
  {
    city: 'La Rue',
    county_fips: 39101,
    county_fips_all: '39101|39065|39175',
    county: 'Marion',
    county_names_all: 'Marion|Hardin|Wyandot',
    county_weights: '{"39101": 86.71, "39065": 9.42, "39175": 3.87}',
    density: 13.7,
    imprecise: false,
    latitude: 40.58369,
    longitude: -83.37769,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43332',
  },
  {
    city: 'Lewistown',
    county_fips: 39091,
    county_fips_all: '39091',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"39091": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 40.43927,
    longitude: -83.93221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43333',
  },
  {
    city: 'Marengo',
    county_fips: 39117,
    county_fips_all: '39117|39041',
    county: 'Morrow',
    county_names_all: 'Morrow|Delaware',
    county_weights: '{"39117": 97.48, "39041": 2.52}',
    density: 37,
    imprecise: false,
    latitude: 40.39912,
    longitude: -82.79863,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43334',
  },
  {
    city: 'Middleburg',
    county_fips: 39091,
    county_fips_all: '39091',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"39091": 100}',
    density: 30.6,
    imprecise: false,
    latitude: 40.28337,
    longitude: -83.57651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43336',
  },
  {
    city: 'Morral',
    county_fips: 39101,
    county_fips_all: '39101|39175',
    county: 'Marion',
    county_names_all: 'Marion|Wyandot',
    county_weights: '{"39101": 79.33, "39175": 20.67}',
    density: 6.8,
    imprecise: false,
    latitude: 40.68336,
    longitude: -83.24107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43337',
  },
  {
    city: 'Mount Gilead',
    county_fips: 39117,
    county_fips_all: '39117',
    county: 'Morrow',
    county_names_all: 'Morrow',
    county_weights: '{"39117": 100}',
    density: 43.1,
    imprecise: false,
    latitude: 40.56207,
    longitude: -82.75958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43338',
  },
  {
    city: 'Mount Victory',
    county_fips: 39065,
    county_fips_all: '39065|39159',
    county: 'Hardin',
    county_names_all: 'Hardin|Union',
    county_weights: '{"39065": 79.95, "39159": 20.05}',
    density: 16.7,
    imprecise: false,
    latitude: 40.53748,
    longitude: -83.48,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43340',
  },
  {
    city: 'New Bloomington',
    county_fips: 39101,
    county_fips_all: '39101',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"39101": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 40.59577,
    longitude: -83.31544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43341',
  },
  {
    city: 'Prospect',
    county_fips: 39101,
    county_fips_all: '39101|39159|39041',
    county: 'Marion',
    county_names_all: 'Marion|Union|Delaware',
    county_weights: '{"39101": 88.72, "39159": 6.66, "39041": 4.62}',
    density: 34.7,
    imprecise: false,
    latitude: 40.47533,
    longitude: -83.17994,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43342',
  },
  {
    city: 'Quincy',
    county_fips: 39091,
    county_fips_all: '39091|39021',
    county: 'Logan',
    county_names_all: 'Logan|Champaign',
    county_weights: '{"39091": 76.8, "39021": 23.2}',
    density: 14.7,
    imprecise: false,
    latitude: 40.3073,
    longitude: -83.97647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43343',
  },
  {
    city: 'Richwood',
    county_fips: 39159,
    county_fips_all: '39159|39041|39101',
    county: 'Union',
    county_names_all: 'Union|Delaware|Marion',
    county_weights: '{"39159": 94.4, "39041": 4.73, "39101": 0.87}',
    density: 24.3,
    imprecise: false,
    latitude: 40.43219,
    longitude: -83.33832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43344',
  },
  {
    city: 'Ridgeway',
    county_fips: 39091,
    county_fips_all: '39091|39065|39159',
    county: 'Logan',
    county_names_all: 'Logan|Hardin|Union',
    county_weights: '{"39091": 53.09, "39065": 46.5, "39159": 0.41}',
    density: 9,
    imprecise: false,
    latitude: 40.51341,
    longitude: -83.58167,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43345',
  },
  {
    city: 'Roundhead',
    county_fips: 39065,
    county_fips_all: '39065',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"39065": 100}',
    density: 85.9,
    imprecise: false,
    latitude: 40.5768,
    longitude: -83.84518,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43346',
  },
  {
    city: 'Rushsylvania',
    county_fips: 39091,
    county_fips_all: '39091|39065',
    county: 'Logan',
    county_names_all: 'Logan|Hardin',
    county_weights: '{"39091": 89.75, "39065": 10.25}',
    density: 14,
    imprecise: false,
    latitude: 40.47771,
    longitude: -83.65804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43347',
  },
  {
    city: 'Russells Point',
    county_fips: 39091,
    county_fips_all: '39091',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"39091": 100}',
    density: 316.1,
    imprecise: false,
    latitude: 40.46754,
    longitude: -83.88857,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43348',
  },
  {
    city: 'Sparta',
    county_fips: 39117,
    county_fips_all: '39117',
    county: 'Morrow',
    county_names_all: 'Morrow',
    county_weights: '{"39117": 100}',
    density: 409.6,
    imprecise: false,
    latitude: 40.39557,
    longitude: -82.69977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43350',
  },
  {
    city: 'Upper Sandusky',
    county_fips: 39175,
    county_fips_all: '39175',
    county: 'Wyandot',
    county_names_all: 'Wyandot',
    county_weights: '{"39175": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 40.82501,
    longitude: -83.30424,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43351',
  },
  {
    city: 'Waldo',
    county_fips: 39101,
    county_fips_all: '39101|39041|39117',
    county: 'Marion',
    county_names_all: 'Marion|Delaware|Morrow',
    county_weights: '{"39101": 72.56, "39041": 17.66, "39117": 9.78}',
    density: 20.9,
    imprecise: false,
    latitude: 40.45748,
    longitude: -83.04788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43356',
  },
  {
    city: 'West Liberty',
    county_fips: 39091,
    county_fips_all: '39091|39021',
    county: 'Logan',
    county_names_all: 'Logan|Champaign',
    county_weights: '{"39091": 56.26, "39021": 43.74}',
    density: 27.8,
    imprecise: false,
    latitude: 40.25316,
    longitude: -83.74711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43357',
  },
  {
    city: 'West Mansfield',
    county_fips: 39159,
    county_fips_all: '39159|39091',
    county: 'Union',
    county_names_all: 'Union|Logan',
    county_weights: '{"39159": 51.7, "39091": 48.3}',
    density: 14.4,
    imprecise: false,
    latitude: 40.41898,
    longitude: -83.53129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43358',
  },
  {
    city: 'Wharton',
    county_fips: 39175,
    county_fips_all: '39175',
    county: 'Wyandot',
    county_names_all: 'Wyandot',
    county_weights: '{"39175": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 40.86977,
    longitude: -83.45319,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43359',
  },
  {
    city: 'Zanesfield',
    county_fips: 39091,
    county_fips_all: '39091',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"39091": 100}',
    density: 19.7,
    imprecise: false,
    latitude: 40.33272,
    longitude: -83.63114,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43360',
  },
  {
    city: 'Bowling Green',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 109.5,
    imprecise: false,
    latitude: 41.40957,
    longitude: -83.65389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43402',
  },
  {
    city: 'Bradner',
    county_fips: 39173,
    county_fips_all: '39173|39143',
    county: 'Wood',
    county_names_all: 'Wood|Sandusky',
    county_weights: '{"39173": 83.49, "39143": 16.51}',
    density: 33.2,
    imprecise: false,
    latitude: 41.33605,
    longitude: -83.4372,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43406',
  },
  {
    city: 'Burgoon',
    county_fips: 39143,
    county_fips_all: '39143|39147',
    county: 'Sandusky',
    county_names_all: 'Sandusky|Seneca',
    county_weights: '{"39143": 99.82, "39147": 0.18}',
    density: 12.7,
    imprecise: false,
    latitude: 41.27717,
    longitude: -83.24994,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43407',
  },
  {
    city: 'Clay Center',
    county_fips: 39123,
    county_fips_all: '39123',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"39123": 100}',
    density: 226.7,
    imprecise: false,
    latitude: 41.57179,
    longitude: -83.36352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43408',
  },
  {
    city: 'Clyde',
    county_fips: 39143,
    county_fips_all: '39143|39147',
    county: 'Sandusky',
    county_names_all: 'Sandusky|Seneca',
    county_weights: '{"39143": 90.96, "39147": 9.04}',
    density: 76.8,
    imprecise: false,
    latitude: 41.30792,
    longitude: -82.95807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43410',
  },
  {
    city: 'Curtice',
    county_fips: 39095,
    county_fips_all: '39095|39123',
    county: 'Lucas',
    county_names_all: 'Lucas|Ottawa',
    county_weights: '{"39095": 61.64, "39123": 38.36}',
    density: 58.3,
    imprecise: false,
    latitude: 41.62933,
    longitude: -83.31961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43412',
  },
  {
    city: 'Cygnet',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 41.24205,
    longitude: -83.65476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43413',
  },
  {
    city: 'Dunbridge',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 125.7,
    imprecise: false,
    latitude: 41.45165,
    longitude: -83.61724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43414',
  },
  {
    city: 'Elmore',
    county_fips: 39123,
    county_fips_all: '39123|39143',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Sandusky',
    county_weights: '{"39123": 85.72, "39143": 14.28}',
    density: 39.2,
    imprecise: false,
    latitude: 41.48532,
    longitude: -83.27055,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43416',
  },
  {
    city: 'Fremont',
    county_fips: 39143,
    county_fips_all: '39143|39123',
    county: 'Sandusky',
    county_names_all: 'Sandusky|Ottawa',
    county_weights: '{"39143": 99.8, "39123": 0.2}',
    density: 83.6,
    imprecise: false,
    latitude: 41.35749,
    longitude: -83.11265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43420',
  },
  {
    city: 'Genoa',
    county_fips: 39123,
    county_fips_all: '39123|39173|39143',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Wood|Sandusky',
    county_weights: '{"39123": 79.08, "39173": 13.5, "39143": 7.42}',
    density: 74.1,
    imprecise: false,
    latitude: 41.5238,
    longitude: -83.37329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43430',
  },
  {
    city: 'Gibsonburg',
    county_fips: 39143,
    county_fips_all: '39143|39173',
    county: 'Sandusky',
    county_names_all: 'Sandusky|Wood',
    county_weights: '{"39143": 97.44, "39173": 2.56}',
    density: 35.6,
    imprecise: false,
    latitude: 41.38998,
    longitude: -83.33964,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43431',
  },
  {
    city: 'Graytown',
    county_fips: 39123,
    county_fips_all: '39123',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"39123": 100}',
    density: 24.1,
    imprecise: false,
    latitude: 41.56115,
    longitude: -83.24934,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43432',
  },
  {
    city: 'Gypsum',
    county_fips: 39123,
    county_fips_all: '39123',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"39123": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.50463,
    longitude: -82.88033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43433',
  },
  {
    city: 'Harbor View',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 1817,
    imprecise: false,
    latitude: 41.69319,
    longitude: -83.44474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43434',
  },
  {
    city: 'Helena',
    county_fips: 39143,
    county_fips_all: '39143',
    county: 'Sandusky',
    county_names_all: 'Sandusky',
    county_weights: '{"39143": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 41.32634,
    longitude: -83.31197,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43435',
  },
  {
    city: 'Isle Saint George',
    county_fips: 39123,
    county_fips_all: '39123',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"39123": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.71522,
    longitude: -82.82098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43436',
  },
  {
    city: 'Jerry City',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 190,
    imprecise: false,
    latitude: 41.25396,
    longitude: -83.60176,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43437',
  },
  {
    city: 'Kelleys Island',
    county_fips: 39043,
    county_fips_all: '39043',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"39043": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 41.60343,
    longitude: -82.70268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43438',
  },
  {
    city: 'Lacarne',
    county_fips: 39123,
    county_fips_all: '39123',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"39123": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.51758,
    longitude: -83.04275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43439',
  },
  {
    city: 'Lakeside Marblehead',
    county_fips: 39123,
    county_fips_all: '39123',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"39123": 100}',
    density: 102.6,
    imprecise: false,
    latitude: 41.52662,
    longitude: -82.78145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43440',
  },
  {
    city: 'Lindsey',
    county_fips: 39143,
    county_fips_all: '39143|39123',
    county: 'Sandusky',
    county_names_all: 'Sandusky|Ottawa',
    county_weights: '{"39143": 95.96, "39123": 4.04}',
    density: 18.1,
    imprecise: false,
    latitude: 41.42911,
    longitude: -83.21496,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43442',
  },
  {
    city: 'Luckey',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 50.4,
    imprecise: false,
    latitude: 41.46099,
    longitude: -83.46906,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43443',
  },
  {
    city: 'Martin',
    county_fips: 39123,
    county_fips_all: '39123|39095',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Lucas',
    county_weights: '{"39123": 82.02, "39095": 17.98}',
    density: 15.2,
    imprecise: false,
    latitude: 41.58644,
    longitude: -83.29488,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43445',
  },
  {
    city: 'Middle Bass',
    county_fips: 39123,
    county_fips_all: '39123',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"39123": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 41.68483,
    longitude: -82.80863,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43446',
  },
  {
    city: 'Millbury',
    county_fips: 39173,
    county_fips_all: '39173|39123',
    county: 'Wood',
    county_names_all: 'Wood|Ottawa',
    county_weights: '{"39173": 69.97, "39123": 30.03}',
    density: 74.5,
    imprecise: false,
    latitude: 41.56654,
    longitude: -83.43429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43447',
  },
  {
    city: 'Oak Harbor',
    county_fips: 39123,
    county_fips_all: '39123|39143',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Sandusky',
    county_weights: '{"39123": 97.65, "39143": 2.35}',
    density: 34.9,
    imprecise: false,
    latitude: 41.5357,
    longitude: -83.14151,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43449',
  },
  {
    city: 'Pemberville',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 35.6,
    imprecise: false,
    latitude: 41.40013,
    longitude: -83.49324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43450',
  },
  {
    city: 'Portage',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 41.31551,
    longitude: -83.61614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43451',
  },
  {
    city: 'Port Clinton',
    county_fips: 39123,
    county_fips_all: '39123',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"39123": 100}',
    density: 119.2,
    imprecise: false,
    latitude: 41.51568,
    longitude: -82.96522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43452',
  },
  {
    city: 'Put In Bay',
    county_fips: 39123,
    county_fips_all: '39123',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"39123": 100}',
    density: 105.6,
    imprecise: false,
    latitude: 41.64934,
    longitude: -82.82497,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43456',
  },
  {
    city: 'Risingsun',
    county_fips: 39173,
    county_fips_all: '39173|39143|39147',
    county: 'Wood',
    county_names_all: 'Wood|Sandusky|Seneca',
    county_weights: '{"39173": 56.13, "39143": 37.6, "39147": 6.27}',
    density: 28.5,
    imprecise: false,
    latitude: 41.26788,
    longitude: -83.42508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43457',
  },
  {
    city: 'Rocky Ridge',
    county_fips: 39123,
    county_fips_all: '39123',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"39123": 100}',
    density: 109.6,
    imprecise: false,
    latitude: 41.53105,
    longitude: -83.21258,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43458',
  },
  {
    city: 'Rossford',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 921,
    imprecise: false,
    latitude: 41.60392,
    longitude: -83.56328,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43460',
  },
  {
    city: 'Rudolph',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 41.28352,
    longitude: -83.71887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43462',
  },
  {
    city: 'Stony Ridge',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 473.6,
    imprecise: false,
    latitude: 41.51141,
    longitude: -83.50511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43463',
  },
  {
    city: 'Vickery',
    county_fips: 39143,
    county_fips_all: '39143|39043',
    county: 'Sandusky',
    county_names_all: 'Sandusky|Erie',
    county_weights: '{"39143": 94.19, "39043": 5.81}',
    density: 25,
    imprecise: false,
    latitude: 41.40318,
    longitude: -82.93116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43464',
  },
  {
    city: 'Walbridge',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 171.6,
    imprecise: false,
    latitude: 41.56593,
    longitude: -83.50489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43465',
  },
  {
    city: 'Wayne',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 34,
    imprecise: false,
    latitude: 41.29234,
    longitude: -83.51394,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43466',
  },
  {
    city: 'West Millgrove',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 330.3,
    imprecise: false,
    latitude: 41.24328,
    longitude: -83.49098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43467',
  },
  {
    city: 'Williston',
    county_fips: 39123,
    county_fips_all: '39123',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"39123": 100}',
    density: 107.8,
    imprecise: false,
    latitude: 41.59974,
    longitude: -83.34661,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43468',
  },
  {
    city: 'Woodville',
    county_fips: 39143,
    county_fips_all: '39143|39123',
    county: 'Sandusky',
    county_names_all: 'Sandusky|Ottawa',
    county_weights: '{"39143": 91.84, "39123": 8.16}',
    density: 48.9,
    imprecise: false,
    latitude: 41.45947,
    longitude: -83.36474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43469',
  },
  {
    city: 'Alvordton',
    county_fips: 39171,
    county_fips_all: '39171',
    county: 'Williams',
    county_names_all: 'Williams',
    county_weights: '{"39171": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 41.66966,
    longitude: -84.46095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43501',
  },
  {
    city: 'Archbold',
    county_fips: 39051,
    county_fips_all: '39051|39069|39171',
    county: 'Fulton',
    county_names_all: 'Fulton|Henry|Williams',
    county_weights: '{"39051": 77.62, "39069": 20.19, "39171": 2.19}',
    density: 36.6,
    imprecise: false,
    latitude: 41.53181,
    longitude: -84.30201,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43502',
  },
  {
    city: 'Berkey',
    county_fips: 39095,
    county_fips_all: '39095|39051',
    county: 'Lucas',
    county_names_all: 'Lucas|Fulton',
    county_weights: '{"39095": 97.12, "39051": 2.88}',
    density: 27.1,
    imprecise: false,
    latitude: 41.69736,
    longitude: -83.8369,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43504',
  },
  {
    city: 'Blakeslee',
    county_fips: 39171,
    county_fips_all: '39171',
    county: 'Williams',
    county_names_all: 'Williams',
    county_weights: '{"39171": 100}',
    density: 311.9,
    imprecise: false,
    latitude: 41.52429,
    longitude: -84.73101,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43505',
  },
  {
    city: 'Bryan',
    county_fips: 39171,
    county_fips_all: '39171|39039',
    county: 'Williams',
    county_names_all: 'Williams|Defiance',
    county_weights: '{"39171": 82.17, "39039": 17.83}',
    density: 55,
    imprecise: false,
    latitude: 41.46739,
    longitude: -84.55704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43506',
  },
  {
    city: 'Colton',
    county_fips: 39069,
    county_fips_all: '39069',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"39069": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 41.46484,
    longitude: -83.94712,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43510',
  },
  {
    city: 'Custar',
    county_fips: 39173,
    county_fips_all: '39173|39069',
    county: 'Wood',
    county_names_all: 'Wood|Henry',
    county_weights: '{"39173": 93.54, "39069": 6.46}',
    density: 6.9,
    imprecise: false,
    latitude: 41.26384,
    longitude: -83.82376,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43511',
  },
  {
    city: 'Defiance',
    county_fips: 39039,
    county_fips_all: '39039|39125|39069',
    county: 'Defiance',
    county_names_all: 'Defiance|Paulding|Henry',
    county_weights: '{"39039": 92.95, "39125": 6.03, "39069": 1.02}',
    density: 49.7,
    imprecise: false,
    latitude: 41.30309,
    longitude: -84.35874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43512',
  },
  {
    city: 'Delta',
    county_fips: 39051,
    county_fips_all: '39051',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"39051": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 41.58656,
    longitude: -84.00746,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43515',
  },
  {
    city: 'Deshler',
    county_fips: 39069,
    county_fips_all: '39069|39173|39063|39137',
    county: 'Henry',
    county_names_all: 'Henry|Wood|Hancock|Putnam',
    county_weights:
      '{"39069": 67.72, "39173": 27.27, "39063": 3.68, "39137": 1.33}',
    density: 14.9,
    imprecise: false,
    latitude: 41.21579,
    longitude: -83.91081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43516',
  },
  {
    city: 'Edgerton',
    county_fips: 39171,
    county_fips_all: '39171|39039',
    county: 'Williams',
    county_names_all: 'Williams|Defiance',
    county_weights: '{"39171": 59.53, "39039": 40.47}',
    density: 20.8,
    imprecise: false,
    latitude: 41.44003,
    longitude: -84.72833,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43517',
  },
  {
    city: 'Edon',
    county_fips: 39171,
    county_fips_all: '39171',
    county: 'Williams',
    county_names_all: 'Williams',
    county_weights: '{"39171": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 41.58977,
    longitude: -84.75385,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43518',
  },
  {
    city: 'Evansport',
    county_fips: 39039,
    county_fips_all: '39039',
    county: 'Defiance',
    county_names_all: 'Defiance',
    county_weights: '{"39039": 100}',
    density: 77.2,
    imprecise: false,
    latitude: 41.42092,
    longitude: -84.40854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43519',
  },
  {
    city: 'Farmer',
    county_fips: 39039,
    county_fips_all: '39039',
    county: 'Defiance',
    county_names_all: 'Defiance',
    county_weights: '{"39039": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.38008,
    longitude: -84.63565,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43520',
  },
  {
    city: 'Fayette',
    county_fips: 39051,
    county_fips_all: '39051|39171',
    county: 'Fulton',
    county_names_all: 'Fulton|Williams',
    county_weights: '{"39051": 97.54, "39171": 2.46}',
    density: 14.4,
    imprecise: false,
    latitude: 41.66377,
    longitude: -84.29717,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43521',
  },
  {
    city: 'Grand Rapids',
    county_fips: 39173,
    county_fips_all: '39173|39095|39069',
    county: 'Wood',
    county_names_all: 'Wood|Lucas|Henry',
    county_weights: '{"39173": 56.26, "39095": 43.2, "39069": 0.54}',
    density: 38.4,
    imprecise: false,
    latitude: 41.42058,
    longitude: -83.84352,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43522',
  },
  {
    city: 'Grelton',
    county_fips: 39069,
    county_fips_all: '39069',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"39069": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 41.33875,
    longitude: -83.99865,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43523',
  },
  {
    city: 'Hamler',
    county_fips: 39069,
    county_fips_all: '39069',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"39069": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 41.22839,
    longitude: -84.039,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43524',
  },
  {
    city: 'Haskins',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 592,
    imprecise: false,
    latitude: 41.46663,
    longitude: -83.70098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43525',
  },
  {
    city: 'Hicksville',
    county_fips: 39039,
    county_fips_all: '39039|39125',
    county: 'Defiance',
    county_names_all: 'Defiance|Paulding',
    county_weights: '{"39039": 93.11, "39125": 6.89}',
    density: 32.8,
    imprecise: false,
    latitude: 41.31339,
    longitude: -84.73024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43526',
  },
  {
    city: 'Holgate',
    county_fips: 39069,
    county_fips_all: '39069|39039',
    county: 'Henry',
    county_names_all: 'Henry|Defiance',
    county_weights: '{"39069": 91.4, "39039": 8.6}',
    density: 16.4,
    imprecise: false,
    latitude: 41.25121,
    longitude: -84.1593,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43527',
  },
  {
    city: 'Holland',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 334.6,
    imprecise: false,
    latitude: 41.62908,
    longitude: -83.74923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43528',
  },
  {
    city: 'Hoytville',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 198.4,
    imprecise: false,
    latitude: 41.18998,
    longitude: -83.78431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43529',
  },
  {
    city: 'Jewell',
    county_fips: 39039,
    county_fips_all: '39039',
    county: 'Defiance',
    county_names_all: 'Defiance',
    county_weights: '{"39039": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.32794,
    longitude: -84.28933,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43530',
  },
  {
    city: 'Kunkle',
    county_fips: 39171,
    county_fips_all: '39171',
    county: 'Williams',
    county_names_all: 'Williams',
    county_weights: '{"39171": 100}',
    density: 474.7,
    imprecise: false,
    latitude: 41.63511,
    longitude: -84.4957,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43531',
  },
  {
    city: 'Liberty Center',
    county_fips: 39069,
    county_fips_all: '39069|39051|39095',
    county: 'Henry',
    county_names_all: 'Henry|Fulton|Lucas',
    county_weights: '{"39069": 94.37, "39051": 3.49, "39095": 2.14}',
    density: 27.3,
    imprecise: false,
    latitude: 41.45486,
    longitude: -83.97008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43532',
  },
  {
    city: 'Lyons',
    county_fips: 39051,
    county_fips_all: '39051',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"39051": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 41.69335,
    longitude: -84.07997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43533',
  },
  {
    city: 'McClure',
    county_fips: 39069,
    county_fips_all: '39069',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"39069": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 41.35446,
    longitude: -83.92914,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43534',
  },
  {
    city: 'Malinta',
    county_fips: 39069,
    county_fips_all: '39069',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"39069": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 41.30592,
    longitude: -84.02416,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43535',
  },
  {
    city: 'Mark Center',
    county_fips: 39039,
    county_fips_all: '39039',
    county: 'Defiance',
    county_names_all: 'Defiance',
    county_weights: '{"39039": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 41.31345,
    longitude: -84.634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43536',
  },
  {
    city: 'Maumee',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 625.5,
    imprecise: false,
    latitude: 41.57433,
    longitude: -83.68542,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43537',
  },
  {
    city: 'Metamora',
    county_fips: 39051,
    county_fips_all: '39051',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"39051": 100}',
    density: 33.8,
    imprecise: false,
    latitude: 41.69545,
    longitude: -83.943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43540',
  },
  {
    city: 'Milton Center',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 177.5,
    imprecise: false,
    latitude: 41.30075,
    longitude: -83.82953,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43541',
  },
  {
    city: 'Monclova',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 108.4,
    imprecise: false,
    latitude: 41.56642,
    longitude: -83.76531,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43542',
  },
  {
    city: 'Montpelier',
    county_fips: 39171,
    county_fips_all: '39171',
    county: 'Williams',
    county_names_all: 'Williams',
    county_weights: '{"39171": 100}',
    density: 33.7,
    imprecise: false,
    latitude: 41.60575,
    longitude: -84.6338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43543',
  },
  {
    city: 'Napoleon',
    county_fips: 39069,
    county_fips_all: '39069|39039',
    county: 'Henry',
    county_names_all: 'Henry|Defiance',
    county_weights: '{"39069": 99.06, "39039": 0.94}',
    density: 41.2,
    imprecise: false,
    latitude: 41.39163,
    longitude: -84.12719,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43545',
  },
  {
    city: 'Neapolis',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 590.9,
    imprecise: false,
    latitude: 41.49214,
    longitude: -83.87634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43547',
  },
  {
    city: 'New Bavaria',
    county_fips: 39069,
    county_fips_all: '39069|39039|39137',
    county: 'Henry',
    county_names_all: 'Henry|Defiance|Putnam',
    county_weights: '{"39069": 86.39, "39039": 12.31, "39137": 1.3}',
    density: 13.1,
    imprecise: false,
    latitude: 41.18867,
    longitude: -84.17296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43548',
  },
  {
    city: 'Ney',
    county_fips: 39039,
    county_fips_all: '39039',
    county: 'Defiance',
    county_names_all: 'Defiance',
    county_weights: '{"39039": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 41.37519,
    longitude: -84.51818,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43549',
  },
  {
    city: 'Perrysburg',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 217.7,
    imprecise: false,
    latitude: 41.52095,
    longitude: -83.57503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 43770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43551',
  },
  {
    city: 'Pettisville',
    county_fips: 39051,
    county_fips_all: '39051',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"39051": 100}',
    density: 496.7,
    imprecise: false,
    latitude: 41.53096,
    longitude: -84.22382,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43553',
  },
  {
    city: 'Pioneer',
    county_fips: 39171,
    county_fips_all: '39171',
    county: 'Williams',
    county_names_all: 'Williams',
    county_weights: '{"39171": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 41.66024,
    longitude: -84.56239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43554',
  },
  {
    city: 'Ridgeville Corners',
    county_fips: 39069,
    county_fips_all: '39069',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"39069": 100}',
    density: 146.9,
    imprecise: false,
    latitude: 41.43772,
    longitude: -84.25596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43555',
  },
  {
    city: 'Sherwood',
    county_fips: 39039,
    county_fips_all: '39039',
    county: 'Defiance',
    county_names_all: 'Defiance',
    county_weights: '{"39039": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 41.30575,
    longitude: -84.56984,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43556',
  },
  {
    city: 'Stryker',
    county_fips: 39171,
    county_fips_all: '39171|39069|39051',
    county: 'Williams',
    county_names_all: 'Williams|Henry|Fulton',
    county_weights: '{"39171": 92.17, "39069": 6.32, "39051": 1.51}',
    density: 30.3,
    imprecise: false,
    latitude: 41.48354,
    longitude: -84.39693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43557',
  },
  {
    city: 'Swanton',
    county_fips: 39051,
    county_fips_all: '39051|39095',
    county: 'Fulton',
    county_names_all: 'Fulton|Lucas',
    county_weights: '{"39051": 51.18, "39095": 48.82}',
    density: 58.7,
    imprecise: false,
    latitude: 41.5935,
    longitude: -83.8781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43558',
  },
  {
    city: 'Sylvania',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 606.3,
    imprecise: false,
    latitude: 41.70067,
    longitude: -83.73799,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43560',
  },
  {
    city: 'Tontogany',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 729.5,
    imprecise: false,
    latitude: 41.42044,
    longitude: -83.74011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43565',
  },
  {
    city: 'Waterville',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 180.7,
    imprecise: false,
    latitude: 41.49467,
    longitude: -83.75838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43566',
  },
  {
    city: 'Wauseon',
    county_fips: 39051,
    county_fips_all: '39051|39069',
    county: 'Fulton',
    county_names_all: 'Fulton|Henry',
    county_weights: '{"39051": 98.51, "39069": 1.49}',
    density: 43.1,
    imprecise: false,
    latitude: 41.57592,
    longitude: -84.15248,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43567',
  },
  {
    city: 'Weston',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 41.3513,
    longitude: -83.78844,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43569',
  },
  {
    city: 'West Unity',
    county_fips: 39171,
    county_fips_all: '39171|39051',
    county: 'Williams',
    county_names_all: 'Williams|Fulton',
    county_weights: '{"39171": 93.09, "39051": 6.91}',
    density: 24.7,
    imprecise: false,
    latitude: 41.58616,
    longitude: -84.44116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43570',
  },
  {
    city: 'Whitehouse',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 128.9,
    imprecise: false,
    latitude: 41.51574,
    longitude: -83.81796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43571',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 1314.9,
    imprecise: false,
    latitude: 41.65217,
    longitude: -83.53977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43604',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095|39173',
    county: 'Lucas',
    county_names_all: 'Lucas|Wood',
    county_weights: '{"39095": 98.65, "39173": 1.35}',
    density: 1315.7,
    imprecise: false,
    latitude: 41.64734,
    longitude: -83.50722,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43605',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 1490.3,
    imprecise: false,
    latitude: 41.67178,
    longitude: -83.61085,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43606',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 1037.6,
    imprecise: false,
    latitude: 41.64761,
    longitude: -83.60582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43607',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 1581.6,
    imprecise: false,
    latitude: 41.68008,
    longitude: -83.53062,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43608',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 1714.5,
    imprecise: false,
    latitude: 41.62849,
    longitude: -83.57824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43609',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 1262.5,
    imprecise: false,
    latitude: 41.67775,
    longitude: -83.5614,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43610',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 985.6,
    imprecise: false,
    latitude: 41.70241,
    longitude: -83.49154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43611',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 954.3,
    imprecise: false,
    latitude: 41.70946,
    longitude: -83.54899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43612',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 1940.1,
    imprecise: false,
    latitude: 41.70628,
    longitude: -83.60374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43613',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 1249.8,
    imprecise: false,
    latitude: 41.60336,
    longitude: -83.62715,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43614',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 940.3,
    imprecise: false,
    latitude: 41.65045,
    longitude: -83.67255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43615',
  },
  {
    city: 'Oregon',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 203.9,
    imprecise: false,
    latitude: 41.65727,
    longitude: -83.40931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43616',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 629.2,
    imprecise: false,
    latitude: 41.66416,
    longitude: -83.72808,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43617',
  },
  {
    city: 'Northwood',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 237.9,
    imprecise: false,
    latitude: 41.60424,
    longitude: -83.47348,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43619',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 1766.8,
    imprecise: false,
    latitude: 41.66519,
    longitude: -83.5547,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43620',
  },
  {
    city: 'Toledo',
    county_fips: 39095,
    county_fips_all: '39095',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"39095": 100}',
    density: 1169.9,
    imprecise: false,
    latitude: 41.70419,
    longitude: -83.65095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43623',
  },
  {
    city: 'Zanesville',
    county_fips: 39119,
    county_fips_all: '39119',
    county: 'Muskingum',
    county_names_all: 'Muskingum',
    county_weights: '{"39119": 100}',
    density: 120.6,
    imprecise: false,
    latitude: 39.95986,
    longitude: -81.99498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43701',
  },
  {
    city: 'Ava',
    county_fips: 39121,
    county_fips_all: '39121',
    county: 'Noble',
    county_names_all: 'Noble',
    county_weights: '{"39121": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.84262,
    longitude: -81.57738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43711',
  },
  {
    city: 'Barnesville',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 39.98979,
    longitude: -81.17368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43713',
  },
  {
    city: 'Beallsville',
    county_fips: 39111,
    county_fips_all: '39111|39013',
    county: 'Monroe',
    county_names_all: 'Monroe|Belmont',
    county_weights: '{"39111": 72.36, "39013": 27.64}',
    density: 11.3,
    imprecise: false,
    latitude: 39.83683,
    longitude: -81.00752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43716',
  },
  {
    city: 'Belle Valley',
    county_fips: 39121,
    county_fips_all: '39121',
    county: 'Noble',
    county_names_all: 'Noble',
    county_weights: '{"39121": 100}',
    density: 225,
    imprecise: false,
    latitude: 39.78943,
    longitude: -81.5548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43717',
  },
  {
    city: 'Belmont',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 40.00926,
    longitude: -81.00596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43718',
  },
  {
    city: 'Bethesda',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 26.8,
    imprecise: false,
    latitude: 39.98907,
    longitude: -81.07938,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43719',
  },
  {
    city: 'Blue Rock',
    county_fips: 39119,
    county_fips_all: '39119|39115',
    county: 'Muskingum',
    county_names_all: 'Muskingum|Morgan',
    county_weights: '{"39119": 92.68, "39115": 7.32}',
    density: 10.5,
    imprecise: false,
    latitude: 39.79272,
    longitude: -81.86886,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43720',
  },
  {
    city: 'Brownsville',
    county_fips: 39089,
    county_fips_all: '39089',
    county: 'Licking',
    county_names_all: 'Licking',
    county_weights: '{"39089": 100}',
    density: 212.4,
    imprecise: false,
    latitude: 39.94927,
    longitude: -82.26015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43721',
  },
  {
    city: 'Buffalo',
    county_fips: 39059,
    county_fips_all: '39059',
    county: 'Guernsey',
    county_names_all: 'Guernsey',
    county_weights: '{"39059": 100}',
    density: 487.8,
    imprecise: false,
    latitude: 39.91933,
    longitude: -81.52001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43722',
  },
  {
    city: 'Byesville',
    county_fips: 39059,
    county_fips_all: '39059',
    county: 'Guernsey',
    county_names_all: 'Guernsey',
    county_weights: '{"39059": 100}',
    density: 110,
    imprecise: false,
    latitude: 39.96022,
    longitude: -81.5412,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43723',
  },
  {
    city: 'Caldwell',
    county_fips: 39121,
    county_fips_all: '39121|39115|39059',
    county: 'Noble',
    county_names_all: 'Noble|Morgan|Guernsey',
    county_weights: '{"39121": 93.96, "39115": 5.81, "39059": 0.23}',
    density: 22.7,
    imprecise: false,
    latitude: 39.73267,
    longitude: -81.5166,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43724',
  },
  {
    city: 'Cambridge',
    county_fips: 39059,
    county_fips_all: '39059',
    county: 'Guernsey',
    county_names_all: 'Guernsey',
    county_weights: '{"39059": 100}',
    density: 60.5,
    imprecise: false,
    latitude: 40.03949,
    longitude: -81.59934,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43725',
  },
  {
    city: 'Chandlersville',
    county_fips: 39119,
    county_fips_all: '39119',
    county: 'Muskingum',
    county_names_all: 'Muskingum',
    county_weights: '{"39119": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 39.8714,
    longitude: -81.79884,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43727',
  },
  {
    city: 'Chesterhill',
    county_fips: 39115,
    county_fips_all: '39115|39009',
    county: 'Morgan',
    county_names_all: 'Morgan|Athens',
    county_weights: '{"39115": 96.56, "39009": 3.44}',
    density: 12.9,
    imprecise: false,
    latitude: 39.49188,
    longitude: -81.89676,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43728',
  },
  {
    city: 'Corning',
    county_fips: 39127,
    county_fips_all: '39127',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"39127": 100}',
    density: 23.8,
    imprecise: false,
    latitude: 39.6294,
    longitude: -82.09435,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43730',
  },
  {
    city: 'Crooksville',
    county_fips: 39127,
    county_fips_all: '39127|39115',
    county: 'Perry',
    county_names_all: 'Perry|Morgan',
    county_weights: '{"39127": 59.38, "39115": 40.62}',
    density: 38,
    imprecise: false,
    latitude: 39.72768,
    longitude: -82.0675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43731',
  },
  {
    city: 'Cumberland',
    county_fips: 39059,
    county_fips_all: '39059|39121|39119',
    county: 'Guernsey',
    county_names_all: 'Guernsey|Noble|Muskingum',
    county_weights: '{"39059": 44.04, "39121": 33.58, "39119": 22.37}',
    density: 8.9,
    imprecise: false,
    latitude: 39.84409,
    longitude: -81.65883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43732',
  },
  {
    city: 'Derwent',
    county_fips: 39059,
    county_fips_all: '39059',
    county: 'Guernsey',
    county_names_all: 'Guernsey',
    county_weights: '{"39059": 100}',
    density: 27.6,
    imprecise: false,
    latitude: 39.92736,
    longitude: -81.53807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43733',
  },
  {
    city: 'Duncan Falls',
    county_fips: 39119,
    county_fips_all: '39119',
    county: 'Muskingum',
    county_names_all: 'Muskingum',
    county_weights: '{"39119": 100}',
    density: 171.3,
    imprecise: false,
    latitude: 39.88144,
    longitude: -81.90489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43734',
  },
  {
    city: 'East Fultonham',
    county_fips: 39119,
    county_fips_all: '39119',
    county: 'Muskingum',
    county_names_all: 'Muskingum',
    county_weights: '{"39119": 100}',
    density: 345.7,
    imprecise: false,
    latitude: 39.85437,
    longitude: -82.11917,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43735',
  },
  {
    city: 'Glenford',
    county_fips: 39127,
    county_fips_all: '39127|39089',
    county: 'Perry',
    county_names_all: 'Perry|Licking',
    county_weights: '{"39127": 63.83, "39089": 36.17}',
    density: 27.8,
    imprecise: false,
    latitude: 39.90693,
    longitude: -82.29025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43739',
  },
  {
    city: 'Gratiot',
    county_fips: 39089,
    county_fips_all: '39089|39119',
    county: 'Licking',
    county_names_all: 'Licking|Muskingum',
    county_weights: '{"39089": 55.93, "39119": 44.07}',
    density: 708,
    imprecise: false,
    latitude: 39.9515,
    longitude: -82.21706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43740',
  },
  {
    city: 'Hopewell',
    county_fips: 39119,
    county_fips_all: '39119|39089',
    county: 'Muskingum',
    county_names_all: 'Muskingum|Licking',
    county_weights: '{"39119": 92.11, "39089": 7.89}',
    density: 15.4,
    imprecise: false,
    latitude: 39.97146,
    longitude: -82.17287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43746',
  },
  {
    city: 'Jerusalem',
    county_fips: 39013,
    county_fips_all: '39013|39111',
    county: 'Belmont',
    county_names_all: 'Belmont|Monroe',
    county_weights: '{"39013": 50.06, "39111": 49.94}',
    density: 14.7,
    imprecise: false,
    latitude: 39.85784,
    longitude: -81.12128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43747',
  },
  {
    city: 'Junction City',
    county_fips: 39127,
    county_fips_all: '39127',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"39127": 100}',
    density: 31.3,
    imprecise: false,
    latitude: 39.69788,
    longitude: -82.30899,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43748',
  },
  {
    city: 'Kimbolton',
    county_fips: 39059,
    county_fips_all: '39059|39031|39157',
    county: 'Guernsey',
    county_names_all: 'Guernsey|Coshocton|Tuscarawas',
    county_weights: '{"39059": 86.99, "39031": 12.62, "39157": 0.39}',
    density: 10.1,
    imprecise: false,
    latitude: 40.15932,
    longitude: -81.56411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43749',
  },
  {
    city: 'Kipling',
    county_fips: 39059,
    county_fips_all: '39059',
    county: 'Guernsey',
    county_names_all: 'Guernsey',
    county_weights: '{"39059": 100}',
    density: 41.4,
    imprecise: false,
    latitude: 39.99353,
    longitude: -81.50975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43750',
  },
  {
    city: 'Lewisville',
    county_fips: 39111,
    county_fips_all: '39111',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"39111": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 39.75586,
    longitude: -81.24017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43754',
  },
  {
    city: 'Lore City',
    county_fips: 39059,
    county_fips_all: '39059',
    county: 'Guernsey',
    county_names_all: 'Guernsey',
    county_weights: '{"39059": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 40.0537,
    longitude: -81.43318,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43755',
  },
  {
    city: 'Mcconnelsville',
    county_fips: 39115,
    county_fips_all: '39115|39119',
    county: 'Morgan',
    county_names_all: 'Morgan|Muskingum',
    county_weights: '{"39115": 98.64, "39119": 1.36}',
    density: 15.5,
    imprecise: false,
    latitude: 39.68993,
    longitude: -81.79574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43756',
  },
  {
    city: 'Malta',
    county_fips: 39115,
    county_fips_all: '39115',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"39115": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 39.62482,
    longitude: -81.9432,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43758',
  },
  {
    city: 'Morristown',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 150.7,
    imprecise: false,
    latitude: 40.06393,
    longitude: -81.06942,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43759',
  },
  {
    city: 'Mount Perry',
    county_fips: 39127,
    county_fips_all: '39127|39119|39089',
    county: 'Perry',
    county_names_all: 'Perry|Muskingum|Licking',
    county_weights: '{"39127": 59.53, "39119": 32.82, "39089": 7.65}',
    density: 16.5,
    imprecise: false,
    latitude: 39.8858,
    longitude: -82.19577,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43760',
  },
  {
    city: 'Moxahala',
    county_fips: 39127,
    county_fips_all: '39127',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"39127": 100}',
    density: 30.4,
    imprecise: false,
    latitude: 39.66829,
    longitude: -82.14798,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43761',
  },
  {
    city: 'New Concord',
    county_fips: 39119,
    county_fips_all: '39119|39059',
    county: 'Muskingum',
    county_names_all: 'Muskingum|Guernsey',
    county_weights: '{"39119": 74.23, "39059": 25.77}',
    density: 25.8,
    imprecise: false,
    latitude: 40.03156,
    longitude: -81.74007,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43762',
  },
  {
    city: 'New Lexington',
    county_fips: 39127,
    county_fips_all: '39127',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"39127": 100}',
    density: 51.9,
    imprecise: false,
    latitude: 39.71485,
    longitude: -82.19239,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43764',
  },
  {
    city: 'New Straitsville',
    county_fips: 39127,
    county_fips_all: '39127|39073',
    county: 'Perry',
    county_names_all: 'Perry|Hocking',
    county_weights: '{"39127": 81.02, "39073": 18.98}',
    density: 13,
    imprecise: false,
    latitude: 39.59492,
    longitude: -82.2501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43766',
  },
  {
    city: 'Norwich',
    county_fips: 39119,
    county_fips_all: '39119',
    county: 'Muskingum',
    county_names_all: 'Muskingum',
    county_weights: '{"39119": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 40.00653,
    longitude: -81.80198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43767',
  },
  {
    city: 'Old Washington',
    county_fips: 39059,
    county_fips_all: '39059',
    county: 'Guernsey',
    county_names_all: 'Guernsey',
    county_weights: '{"39059": 100}',
    density: 126.5,
    imprecise: false,
    latitude: 40.03776,
    longitude: -81.44477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43768',
  },
  {
    city: 'Philo',
    county_fips: 39119,
    county_fips_all: '39119',
    county: 'Muskingum',
    county_names_all: 'Muskingum',
    county_weights: '{"39119": 100}',
    density: 35.3,
    imprecise: false,
    latitude: 39.83586,
    longitude: -81.94135,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43771',
  },
  {
    city: 'Pleasant City',
    county_fips: 39121,
    county_fips_all: '39121|39059',
    county: 'Noble',
    county_names_all: 'Noble|Guernsey',
    county_weights: '{"39121": 70.13, "39059": 29.87}',
    density: 17.5,
    imprecise: false,
    latitude: 39.88063,
    longitude: -81.52448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43772',
  },
  {
    city: 'Quaker City',
    county_fips: 39059,
    county_fips_all: '39059|39121|39111',
    county: 'Guernsey',
    county_names_all: 'Guernsey|Noble|Monroe',
    county_weights: '{"39059": 59.14, "39121": 39.41, "39111": 1.45}',
    density: 9.4,
    imprecise: false,
    latitude: 39.98758,
    longitude: -81.29636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43773',
  },
  {
    city: 'Roseville',
    county_fips: 39119,
    county_fips_all: '39119|39127',
    county: 'Muskingum',
    county_names_all: 'Muskingum|Perry',
    county_weights: '{"39119": 70.12, "39127": 29.88}',
    density: 31,
    imprecise: false,
    latitude: 39.81896,
    longitude: -82.08543,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43777',
  },
  {
    city: 'Salesville',
    county_fips: 39059,
    county_fips_all: '39059|39121',
    county: 'Guernsey',
    county_names_all: 'Guernsey|Noble',
    county_weights: '{"39059": 95.98, "39121": 4.02}',
    density: 13,
    imprecise: false,
    latitude: 40.01111,
    longitude: -81.37001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43778',
  },
  {
    city: 'Sarahsville',
    county_fips: 39121,
    county_fips_all: '39121',
    county: 'Noble',
    county_names_all: 'Noble',
    county_weights: '{"39121": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 39.81718,
    longitude: -81.42528,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43779',
  },
  {
    city: 'Senecaville',
    county_fips: 39059,
    county_fips_all: '39059|39121',
    county: 'Guernsey',
    county_names_all: 'Guernsey|Noble',
    county_weights: '{"39059": 61.74, "39121": 38.26}',
    density: 25,
    imprecise: false,
    latitude: 39.92229,
    longitude: -81.44024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43780',
  },
  {
    city: 'Shawnee',
    county_fips: 39127,
    county_fips_all: '39127',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"39127": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 39.62129,
    longitude: -82.2185,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43782',
  },
  {
    city: 'Somerset',
    county_fips: 39127,
    county_fips_all: '39127',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"39127": 100}',
    density: 31.9,
    imprecise: false,
    latitude: 39.80389,
    longitude: -82.28878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43783',
  },
  {
    city: 'Stafford',
    county_fips: 39111,
    county_fips_all: '39111',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"39111": 100}',
    density: 109.6,
    imprecise: false,
    latitude: 39.71086,
    longitude: -81.27704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43786',
  },
  {
    city: 'Stockport',
    county_fips: 39115,
    county_fips_all: '39115|39167',
    county: 'Morgan',
    county_names_all: 'Morgan|Washington',
    county_weights: '{"39115": 83.79, "39167": 16.21}',
    density: 12.9,
    imprecise: false,
    latitude: 39.53292,
    longitude: -81.80554,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43787',
  },
  {
    city: 'Summerfield',
    county_fips: 39121,
    county_fips_all: '39121|39111',
    county: 'Noble',
    county_names_all: 'Noble|Monroe',
    county_weights: '{"39121": 71.2, "39111": 28.8}',
    density: 7,
    imprecise: false,
    latitude: 39.80175,
    longitude: -81.3334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43788',
  },
  {
    city: 'White Cottage',
    county_fips: 39119,
    county_fips_all: '39119',
    county: 'Muskingum',
    county_names_all: 'Muskingum',
    county_weights: '{"39119": 100}',
    density: 64.5,
    imprecise: false,
    latitude: 39.87757,
    longitude: -82.08877,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43791',
  },
  {
    city: 'Woodsfield',
    county_fips: 39111,
    county_fips_all: '39111',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"39111": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 39.74362,
    longitude: -81.10219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43793',
  },
  {
    city: 'Adamsville',
    county_fips: 39119,
    county_fips_all: '39119',
    county: 'Muskingum',
    county_names_all: 'Muskingum',
    county_weights: '{"39119": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 40.09346,
    longitude: -81.85687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43802',
  },
  {
    city: 'Baltic',
    county_fips: 39075,
    county_fips_all: '39075|39157|39031',
    county: 'Holmes',
    county_names_all: 'Holmes|Tuscarawas|Coshocton',
    county_weights: '{"39075": 66.56, "39157": 18.74, "39031": 14.7}',
    density: 43.1,
    imprecise: false,
    latitude: 40.4545,
    longitude: -81.73704,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43804',
  },
  {
    city: 'Blissfield',
    county_fips: 39031,
    county_fips_all: '39031',
    county: 'Coshocton',
    county_names_all: 'Coshocton',
    county_weights: '{"39031": 100}',
    density: 113.7,
    imprecise: false,
    latitude: 40.39177,
    longitude: -81.97223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43805',
  },
  {
    city: 'Conesville',
    county_fips: 39031,
    county_fips_all: '39031',
    county: 'Coshocton',
    county_names_all: 'Coshocton',
    county_weights: '{"39031": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 40.18285,
    longitude: -81.93232,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43811',
  },
  {
    city: 'Coshocton',
    county_fips: 39031,
    county_fips_all: '39031',
    county: 'Coshocton',
    county_names_all: 'Coshocton',
    county_weights: '{"39031": 100}',
    density: 45.6,
    imprecise: false,
    latitude: 40.27268,
    longitude: -81.88347,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43812',
  },
  {
    city: 'Dresden',
    county_fips: 39119,
    county_fips_all: '39119|39031',
    county: 'Muskingum',
    county_names_all: 'Muskingum|Coshocton',
    county_weights: '{"39119": 71.93, "39031": 28.07}',
    density: 19,
    imprecise: false,
    latitude: 40.13559,
    longitude: -82.00695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43821',
  },
  {
    city: 'Frazeysburg',
    county_fips: 39119,
    county_fips_all: '39119|39089|39031|39083',
    county: 'Muskingum',
    county_names_all: 'Muskingum|Licking|Coshocton|Knox',
    county_weights:
      '{"39119": 38.92, "39089": 28.65, "39031": 21.26, "39083": 11.17}',
    density: 22.2,
    imprecise: false,
    latitude: 40.17409,
    longitude: -82.16958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43822',
  },
  {
    city: 'Fresno',
    county_fips: 39031,
    county_fips_all: '39031|39157',
    county: 'Coshocton',
    county_names_all: 'Coshocton|Tuscarawas',
    county_weights: '{"39031": 94.03, "39157": 5.97}',
    density: 22.2,
    imprecise: false,
    latitude: 40.36407,
    longitude: -81.76116,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43824',
  },
  {
    city: 'Nashport',
    county_fips: 39119,
    county_fips_all: '39119|39089',
    county: 'Muskingum',
    county_names_all: 'Muskingum|Licking',
    county_weights: '{"39119": 71.67, "39089": 28.33}',
    density: 50.5,
    imprecise: false,
    latitude: 40.06116,
    longitude: -82.14812,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43830',
  },
  {
    city: 'Newcomerstown',
    county_fips: 39157,
    county_fips_all: '39157|39031|39059',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas|Coshocton|Guernsey',
    county_weights: '{"39157": 60.36, "39031": 30.79, "39059": 8.85}',
    density: 26.5,
    imprecise: false,
    latitude: 40.27333,
    longitude: -81.57931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43832',
  },
  {
    city: 'Plainfield',
    county_fips: 39031,
    county_fips_all: '39031',
    county: 'Coshocton',
    county_names_all: 'Coshocton',
    county_weights: '{"39031": 100}',
    density: 354.3,
    imprecise: false,
    latitude: 40.2087,
    longitude: -81.71854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43836',
  },
  {
    city: 'Port Washington',
    county_fips: 39157,
    county_fips_all: '39157|39059',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas|Guernsey',
    county_weights: '{"39157": 92.58, "39059": 7.42}',
    density: 10.4,
    imprecise: false,
    latitude: 40.29773,
    longitude: -81.47846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43837',
  },
  {
    city: 'Stone Creek',
    county_fips: 39157,
    county_fips_all: '39157|39031',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas|Coshocton',
    county_weights: '{"39157": 99.62, "39031": 0.38}',
    density: 15.2,
    imprecise: false,
    latitude: 40.40511,
    longitude: -81.60025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43840',
  },
  {
    city: 'Trinway',
    county_fips: 39119,
    county_fips_all: '39119',
    county: 'Muskingum',
    county_names_all: 'Muskingum',
    county_weights: '{"39119": 100}',
    density: 409.8,
    imprecise: false,
    latitude: 40.13749,
    longitude: -82.01182,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43842',
  },
  {
    city: 'Walhonding',
    county_fips: 39031,
    county_fips_all: '39031|39083',
    county: 'Coshocton',
    county_names_all: 'Coshocton|Knox',
    county_weights: '{"39031": 71.28, "39083": 28.72}',
    density: 5.4,
    imprecise: false,
    latitude: 40.33485,
    longitude: -82.17711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43843',
  },
  {
    city: 'Warsaw',
    county_fips: 39031,
    county_fips_all: '39031',
    county: 'Coshocton',
    county_names_all: 'Coshocton',
    county_weights: '{"39031": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 40.33349,
    longitude: -82.05163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43844',
  },
  {
    city: 'West Lafayette',
    county_fips: 39031,
    county_fips_all: '39031',
    county: 'Coshocton',
    county_names_all: 'Coshocton',
    county_weights: '{"39031": 100}',
    density: 65.2,
    imprecise: false,
    latitude: 40.25692,
    longitude: -81.73144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43845',
  },
  {
    city: 'Adena',
    county_fips: 39081,
    county_fips_all: '39081|39067|39013',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Harrison|Belmont',
    county_weights: '{"39081": 65.67, "39067": 25.93, "39013": 8.4}',
    density: 27.9,
    imprecise: false,
    latitude: 40.21691,
    longitude: -80.86637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43901',
  },
  {
    city: 'Alledonia',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 39.88731,
    longitude: -80.95596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43902',
  },
  {
    city: 'Amsterdam',
    county_fips: 39019,
    county_fips_all: '39019|39081',
    county: 'Carroll',
    county_names_all: 'Carroll|Jefferson',
    county_weights: '{"39019": 65.19, "39081": 34.81}',
    density: 22,
    imprecise: false,
    latitude: 40.47042,
    longitude: -80.95131,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43903',
  },
  {
    city: 'Barton',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 87.8,
    imprecise: false,
    latitude: 40.11159,
    longitude: -80.8408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43905',
  },
  {
    city: 'Bellaire',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 93.4,
    imprecise: false,
    latitude: 40.0132,
    longitude: -80.80118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43906',
  },
  {
    city: 'Cadiz',
    county_fips: 39067,
    county_fips_all: '39067|39081',
    county: 'Harrison',
    county_names_all: 'Harrison|Jefferson',
    county_weights: '{"39067": 96.71, "39081": 3.29}',
    density: 11.9,
    imprecise: false,
    latitude: 40.25697,
    longitude: -81.0205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43907',
  },
  {
    city: 'Bergholz',
    county_fips: 39081,
    county_fips_all: '39081|39019',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Carroll',
    county_weights: '{"39081": 92.77, "39019": 7.23}',
    density: 13.5,
    imprecise: false,
    latitude: 40.50867,
    longitude: -80.87349,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43908',
  },
  {
    city: 'Blaine',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 238.8,
    imprecise: false,
    latitude: 40.06774,
    longitude: -80.81552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43909',
  },
  {
    city: 'Bloomingdale',
    county_fips: 39081,
    county_fips_all: '39081|39067',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Harrison',
    county_weights: '{"39081": 93.81, "39067": 6.19}',
    density: 22.6,
    imprecise: false,
    latitude: 40.37039,
    longitude: -80.8214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43910',
  },
  {
    city: 'Bridgeport',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 123.8,
    imprecise: false,
    latitude: 40.08708,
    longitude: -80.79255,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43912',
  },
  {
    city: 'Brilliant',
    county_fips: 39081,
    county_fips_all: '39081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"39081": 100}',
    density: 193.1,
    imprecise: false,
    latitude: 40.27048,
    longitude: -80.63154,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43913',
  },
  {
    city: 'Cameron',
    county_fips: 39111,
    county_fips_all: '39111',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"39111": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.77532,
    longitude: -80.95288,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43914',
  },
  {
    city: 'Clarington',
    county_fips: 39111,
    county_fips_all: '39111',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"39111": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 39.75775,
    longitude: -80.89729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43915',
  },
  {
    city: 'Dillonvale',
    county_fips: 39081,
    county_fips_all: '39081|39013',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Belmont',
    county_weights: '{"39081": 91.31, "39013": 8.69}',
    density: 26.4,
    imprecise: false,
    latitude: 40.22396,
    longitude: -80.80546,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43917',
  },
  {
    city: 'East Liverpool',
    county_fips: 39029,
    county_fips_all: '39029',
    county: 'Columbiana',
    county_names_all: 'Columbiana',
    county_weights: '{"39029": 100}',
    density: 194.6,
    imprecise: false,
    latitude: 40.67608,
    longitude: -80.57965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43920',
  },
  {
    city: 'East Springfield',
    county_fips: 39081,
    county_fips_all: '39081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"39081": 100}',
    density: 72.1,
    imprecise: false,
    latitude: 40.44583,
    longitude: -80.86242,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43925',
  },
  {
    city: 'Empire',
    county_fips: 39081,
    county_fips_all: '39081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"39081": 100}',
    density: 321.7,
    imprecise: false,
    latitude: 40.51068,
    longitude: -80.62252,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43926',
  },
  {
    city: 'Glencoe',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 85,
    imprecise: false,
    latitude: 40.01088,
    longitude: -80.88172,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43928',
  },
  {
    city: 'Hammondsville',
    county_fips: 39081,
    county_fips_all: '39081|39029',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Columbiana',
    county_weights: '{"39081": 81.75, "39029": 18.25}',
    density: 12.1,
    imprecise: false,
    latitude: 40.56978,
    longitude: -80.77372,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43930',
  },
  {
    city: 'Hannibal',
    county_fips: 39111,
    county_fips_all: '39111',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"39111": 100}',
    density: 174.8,
    imprecise: false,
    latitude: 39.67288,
    longitude: -80.87137,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43931',
  },
  {
    city: 'Irondale',
    county_fips: 39081,
    county_fips_all: '39081|39029',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Columbiana',
    county_weights: '{"39081": 92.73, "39029": 7.27}',
    density: 17.5,
    imprecise: false,
    latitude: 40.53145,
    longitude: -80.74699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43932',
  },
  {
    city: 'Jacobsburg',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 16,
    imprecise: false,
    latitude: 39.93917,
    longitude: -80.89588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43933',
  },
  {
    city: 'Lansing',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 342.6,
    imprecise: false,
    latitude: 40.0752,
    longitude: -80.79123,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43934',
  },
  {
    city: 'Martins Ferry',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 161.6,
    imprecise: false,
    latitude: 40.1247,
    longitude: -80.75225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43935',
  },
  {
    city: 'Mingo Junction',
    county_fips: 39081,
    county_fips_all: '39081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"39081": 100}',
    density: 66.9,
    imprecise: false,
    latitude: 40.30138,
    longitude: -80.67199,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43938',
  },
  {
    city: 'Mount Pleasant',
    county_fips: 39081,
    county_fips_all: '39081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"39081": 100}',
    density: 143.8,
    imprecise: false,
    latitude: 40.16723,
    longitude: -80.79993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43939',
  },
  {
    city: 'Neffs',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 239.4,
    imprecise: false,
    latitude: 40.02863,
    longitude: -80.82541,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43940',
  },
  {
    city: 'Powhatan Point',
    county_fips: 39013,
    county_fips_all: '39013|39111',
    county: 'Belmont',
    county_names_all: 'Belmont|Monroe',
    county_weights: '{"39013": 73.24, "39111": 26.76}',
    density: 37.2,
    imprecise: false,
    latitude: 39.86367,
    longitude: -80.84875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43942',
  },
  {
    city: 'Rayland',
    county_fips: 39081,
    county_fips_all: '39081|39013',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Belmont',
    county_weights: '{"39081": 97.93, "39013": 2.07}',
    density: 29.6,
    imprecise: false,
    latitude: 40.2242,
    longitude: -80.73269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43943',
  },
  {
    city: 'Richmond',
    county_fips: 39081,
    county_fips_all: '39081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"39081": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 40.43623,
    longitude: -80.76853,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43944',
  },
  {
    city: 'Salineville',
    county_fips: 39029,
    county_fips_all: '39029|39019|39081',
    county: 'Columbiana',
    county_names_all: 'Columbiana|Carroll|Jefferson',
    county_weights: '{"39029": 59.22, "39019": 28.76, "39081": 12.02}',
    density: 16.6,
    imprecise: false,
    latitude: 40.63156,
    longitude: -80.84797,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43945',
  },
  {
    city: 'Sardis',
    county_fips: 39111,
    county_fips_all: '39111',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"39111": 100}',
    density: 10,
    imprecise: false,
    latitude: 39.64792,
    longitude: -80.96887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43946',
  },
  {
    city: 'Shadyside',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 109.7,
    imprecise: false,
    latitude: 39.95448,
    longitude: -80.78755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43947',
  },
  {
    city: 'Smithfield',
    county_fips: 39081,
    county_fips_all: '39081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"39081": 100}',
    density: 400.3,
    imprecise: false,
    latitude: 40.26847,
    longitude: -80.78002,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43948',
  },
  {
    city: 'Saint Clairsville',
    county_fips: 39013,
    county_fips_all: '39013|39067',
    county: 'Belmont',
    county_names_all: 'Belmont|Harrison',
    county_weights: '{"39013": 97.79, "39067": 2.21}',
    density: 77.5,
    imprecise: false,
    latitude: 40.09164,
    longitude: -80.92193,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43950',
  },
  {
    city: 'Lafferty',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 40.11475,
    longitude: -81.01405,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43951',
  },
  {
    city: 'Steubenville',
    county_fips: 39081,
    county_fips_all: '39081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"39081": 100}',
    density: 268,
    imprecise: false,
    latitude: 40.39763,
    longitude: -80.66278,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43952',
  },
  {
    city: 'Steubenville',
    county_fips: 39081,
    county_fips_all: '39081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"39081": 100}',
    density: 235.2,
    imprecise: false,
    latitude: 40.35815,
    longitude: -80.70548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43953',
  },
  {
    city: 'Stratton',
    county_fips: 39081,
    county_fips_all: '39081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"39081": 100}',
    density: 411.9,
    imprecise: false,
    latitude: 40.52343,
    longitude: -80.63025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43961',
  },
  {
    city: 'Summitville',
    county_fips: 39029,
    county_fips_all: '39029',
    county: 'Columbiana',
    county_names_all: 'Columbiana',
    county_weights: '{"39029": 100}',
    density: 48.4,
    imprecise: false,
    latitude: 40.67315,
    longitude: -80.88919,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 67,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43962',
  },
  {
    city: 'Tiltonsville',
    county_fips: 39081,
    county_fips_all: '39081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"39081": 100}',
    density: 1105.5,
    imprecise: false,
    latitude: 40.17155,
    longitude: -80.69698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43963',
  },
  {
    city: 'Toronto',
    county_fips: 39081,
    county_fips_all: '39081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"39081": 100}',
    density: 73.1,
    imprecise: false,
    latitude: 40.48695,
    longitude: -80.66928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43964',
  },
  {
    city: 'Warnock',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 40.02309,
    longitude: -80.94371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43967',
  },
  {
    city: 'Wellsville',
    county_fips: 39029,
    county_fips_all: '39029',
    county: 'Columbiana',
    county_names_all: 'Columbiana',
    county_weights: '{"39029": 100}',
    density: 75.3,
    imprecise: false,
    latitude: 40.63365,
    longitude: -80.68729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43968',
  },
  {
    city: 'Yorkville',
    county_fips: 39081,
    county_fips_all: '39081|39013',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Belmont',
    county_weights: '{"39081": 67.29, "39013": 32.71}',
    density: 281.1,
    imprecise: false,
    latitude: 40.15811,
    longitude: -80.71301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43971',
  },
  {
    city: 'Bannock',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 319.5,
    imprecise: false,
    latitude: 40.10164,
    longitude: -80.9749,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43972',
  },
  {
    city: 'Freeport',
    county_fips: 39067,
    county_fips_all: '39067|39059|39157',
    county: 'Harrison',
    county_names_all: 'Harrison|Guernsey|Tuscarawas',
    county_weights: '{"39067": 52.15, "39059": 47.21, "39157": 0.64}',
    density: 9,
    imprecise: false,
    latitude: 40.19111,
    longitude: -81.27688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43973',
  },
  {
    city: 'Harrisville',
    county_fips: 39067,
    county_fips_all: '39067',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"39067": 100}',
    density: 542.6,
    imprecise: false,
    latitude: 40.18205,
    longitude: -80.88728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43974',
  },
  {
    city: 'Hopedale',
    county_fips: 39067,
    county_fips_all: '39067|39081',
    county: 'Harrison',
    county_names_all: 'Harrison|Jefferson',
    county_weights: '{"39067": 99.9, "39081": 0.1}',
    density: 26.3,
    imprecise: false,
    latitude: 40.36981,
    longitude: -80.90655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43976',
  },
  {
    city: 'Flushing',
    county_fips: 39013,
    county_fips_all: '39013|39067',
    county: 'Belmont',
    county_names_all: 'Belmont|Harrison',
    county_weights: '{"39013": 78.97, "39067": 21.03}',
    density: 20.2,
    imprecise: false,
    latitude: 40.14519,
    longitude: -81.10451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43977',
  },
  {
    city: 'New Athens',
    county_fips: 39067,
    county_fips_all: '39067',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"39067": 100}',
    density: 389.9,
    imprecise: false,
    latitude: 40.18401,
    longitude: -80.99466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43981',
  },
  {
    city: 'Piedmont',
    county_fips: 39013,
    county_fips_all: '39013|39059|39067',
    county: 'Belmont',
    county_names_all: 'Belmont|Guernsey|Harrison',
    county_weights: '{"39013": 75.15, "39059": 12.6, "39067": 12.25}',
    density: 13.9,
    imprecise: false,
    latitude: 40.13886,
    longitude: -81.20296,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43983',
  },
  {
    city: 'Holloway',
    county_fips: 39013,
    county_fips_all: '39013',
    county: 'Belmont',
    county_names_all: 'Belmont',
    county_weights: '{"39013": 100}',
    density: 136.1,
    imprecise: false,
    latitude: 40.16168,
    longitude: -81.13155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43985',
  },
  {
    city: 'Jewett',
    county_fips: 39067,
    county_fips_all: '39067|39019',
    county: 'Harrison',
    county_names_all: 'Harrison|Carroll',
    county_weights: '{"39067": 97.03, "39019": 2.97}',
    density: 14.4,
    imprecise: false,
    latitude: 40.3784,
    longitude: -80.99036,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43986',
  },
  {
    city: 'Scio',
    county_fips: 39067,
    county_fips_all: '39067|39019',
    county: 'Harrison',
    county_names_all: 'Harrison|Carroll',
    county_weights: '{"39067": 66.41, "39019": 33.59}',
    density: 17.3,
    imprecise: false,
    latitude: 40.40486,
    longitude: -81.09925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43988',
  },
  {
    city: 'Amherst',
    county_fips: 39093,
    county_fips_all: '39093',
    county: 'Lorain',
    county_names_all: 'Lorain',
    county_weights: '{"39093": 100}',
    density: 249.3,
    imprecise: false,
    latitude: 41.36825,
    longitude: -82.25958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44001',
  },
  {
    city: 'Andover',
    county_fips: 39007,
    county_fips_all: '39007',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula',
    county_weights: '{"39007": 100}',
    density: 29,
    imprecise: false,
    latitude: 41.6202,
    longitude: -80.58361,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44003',
  },
  {
    city: 'Ashtabula',
    county_fips: 39007,
    county_fips_all: '39007',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula',
    county_weights: '{"39007": 100}',
    density: 162.2,
    imprecise: false,
    latitude: 41.85255,
    longitude: -80.78738,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44004',
  },
  {
    city: 'Austinburg',
    county_fips: 39007,
    county_fips_all: '39007',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula',
    county_weights: '{"39007": 100}',
    density: 32.8,
    imprecise: false,
    latitude: 41.76087,
    longitude: -80.85152,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44010',
  },
  {
    city: 'Avon',
    county_fips: 39093,
    county_fips_all: '39093',
    county: 'Lorain',
    county_names_all: 'Lorain',
    county_weights: '{"39093": 100}',
    density: 470.2,
    imprecise: false,
    latitude: 41.44855,
    longitude: -82.0187,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44011',
  },
  {
    city: 'Avon Lake',
    county_fips: 39093,
    county_fips_all: '39093',
    county: 'Lorain',
    county_names_all: 'Lorain',
    county_weights: '{"39093": 100}',
    density: 893.4,
    imprecise: false,
    latitude: 41.49443,
    longitude: -82.01594,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44012',
  },
  {
    city: 'Berea',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1148.7,
    imprecise: false,
    latitude: 41.36867,
    longitude: -81.86303,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44017',
  },
  {
    city: 'Burton',
    county_fips: 39055,
    county_fips_all: '39055',
    county: 'Geauga',
    county_names_all: 'Geauga',
    county_weights: '{"39055": 100}',
    density: 56.5,
    imprecise: false,
    latitude: 41.44141,
    longitude: -81.14579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44021',
  },
  {
    city: 'Chagrin Falls',
    county_fips: 39035,
    county_fips_all: '39035|39055',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga|Geauga',
    county_weights: '{"39035": 72.59, "39055": 27.41}',
    density: 212.8,
    imprecise: false,
    latitude: 41.44747,
    longitude: -81.4045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44022',
  },
  {
    city: 'Chagrin Falls',
    county_fips: 39055,
    county_fips_all: '39055',
    county: 'Geauga',
    county_names_all: 'Geauga',
    county_weights: '{"39055": 100}',
    density: 141.8,
    imprecise: false,
    latitude: 41.38732,
    longitude: -81.28858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44023',
  },
  {
    city: 'Chardon',
    county_fips: 39055,
    county_fips_all: '39055|39085',
    county: 'Geauga',
    county_names_all: 'Geauga|Lake',
    county_weights: '{"39055": 97.69, "39085": 2.31}',
    density: 103.1,
    imprecise: false,
    latitude: 41.57668,
    longitude: -81.19112,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44024',
  },
  {
    city: 'Chesterland',
    county_fips: 39055,
    county_fips_all: '39055',
    county: 'Geauga',
    county_names_all: 'Geauga',
    county_weights: '{"39055": 100}',
    density: 143.5,
    imprecise: false,
    latitude: 41.53182,
    longitude: -81.3305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44026',
  },
  {
    city: 'Columbia Station',
    county_fips: 39093,
    county_fips_all: '39093',
    county: 'Lorain',
    county_names_all: 'Lorain',
    county_weights: '{"39093": 100}',
    density: 111,
    imprecise: false,
    latitude: 41.30986,
    longitude: -81.93959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44028',
  },
  {
    city: 'Conneaut',
    county_fips: 39007,
    county_fips_all: '39007',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula',
    county_weights: '{"39007": 100}',
    density: 106.5,
    imprecise: false,
    latitude: 41.8973,
    longitude: -80.58061,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44030',
  },
  {
    city: 'Dorset',
    county_fips: 39007,
    county_fips_all: '39007',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula',
    county_weights: '{"39007": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 41.6658,
    longitude: -80.66954,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44032',
  },
  {
    city: 'Elyria',
    county_fips: 39093,
    county_fips_all: '39093',
    county: 'Lorain',
    county_names_all: 'Lorain',
    county_weights: '{"39093": 100}',
    density: 504.7,
    imprecise: false,
    latitude: 41.36539,
    longitude: -82.13025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 62179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44035',
  },
  {
    city: 'North Ridgeville',
    county_fips: 39093,
    county_fips_all: '39093',
    county: 'Lorain',
    county_names_all: 'Lorain',
    county_weights: '{"39093": 100}',
    density: 589.4,
    imprecise: false,
    latitude: 41.38404,
    longitude: -82.02014,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44039',
  },
  {
    city: 'Gates Mills',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 120.4,
    imprecise: false,
    latitude: 41.53128,
    longitude: -81.4112,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44040',
  },
  {
    city: 'Geneva',
    county_fips: 39007,
    county_fips_all: '39007|39085',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula|Lake',
    county_weights: '{"39007": 97.76, "39085": 2.24}',
    density: 83.1,
    imprecise: false,
    latitude: 41.77579,
    longitude: -80.95223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44041',
  },
  {
    city: 'Grafton',
    county_fips: 39093,
    county_fips_all: '39093',
    county: 'Lorain',
    county_names_all: 'Lorain',
    county_weights: '{"39093": 100}',
    density: 105,
    imprecise: false,
    latitude: 41.26779,
    longitude: -82.04188,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44044',
  },
  {
    city: 'Grand River',
    county_fips: 39085,
    county_fips_all: '39085',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"39085": 100}',
    density: 251.7,
    imprecise: false,
    latitude: 41.7461,
    longitude: -81.28512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44045',
  },
  {
    city: 'Huntsburg',
    county_fips: 39055,
    county_fips_all: '39055',
    county: 'Geauga',
    county_names_all: 'Geauga',
    county_weights: '{"39055": 100}',
    density: 38.7,
    imprecise: false,
    latitude: 41.54157,
    longitude: -81.07227,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44046',
  },
  {
    city: 'Jefferson',
    county_fips: 39007,
    county_fips_all: '39007',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula',
    county_weights: '{"39007": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 41.71887,
    longitude: -80.73921,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44047',
  },
  {
    city: 'Kingsville',
    county_fips: 39007,
    county_fips_all: '39007',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula',
    county_weights: '{"39007": 100}',
    density: 32.6,
    imprecise: false,
    latitude: 41.84697,
    longitude: -80.64343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44048',
  },
  {
    city: 'Kipton',
    county_fips: 39093,
    county_fips_all: '39093',
    county: 'Lorain',
    county_names_all: 'Lorain',
    county_weights: '{"39093": 100}',
    density: 272.5,
    imprecise: false,
    latitude: 41.26626,
    longitude: -82.30553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44049',
  },
  {
    city: 'Lagrange',
    county_fips: 39093,
    county_fips_all: '39093',
    county: 'Lorain',
    county_names_all: 'Lorain',
    county_weights: '{"39093": 100}',
    density: 106.7,
    imprecise: false,
    latitude: 41.24853,
    longitude: -82.13119,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44050',
  },
  {
    city: 'Lorain',
    county_fips: 39093,
    county_fips_all: '39093',
    county: 'Lorain',
    county_names_all: 'Lorain',
    county_weights: '{"39093": 100}',
    density: 1149.7,
    imprecise: false,
    latitude: 41.45519,
    longitude: -82.16133,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44052',
  },
  {
    city: 'Lorain',
    county_fips: 39093,
    county_fips_all: '39093',
    county: 'Lorain',
    county_names_all: 'Lorain',
    county_weights: '{"39093": 100}',
    density: 751.5,
    imprecise: false,
    latitude: 41.42694,
    longitude: -82.22138,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44053',
  },
  {
    city: 'Sheffield Lake',
    county_fips: 39093,
    county_fips_all: '39093',
    county: 'Lorain',
    county_names_all: 'Lorain',
    county_weights: '{"39093": 100}',
    density: 394.9,
    imprecise: false,
    latitude: 41.46419,
    longitude: -82.0931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44054',
  },
  {
    city: 'Lorain',
    county_fips: 39093,
    county_fips_all: '39093',
    county: 'Lorain',
    county_names_all: 'Lorain',
    county_weights: '{"39093": 100}',
    density: 1228.4,
    imprecise: false,
    latitude: 41.43309,
    longitude: -82.13354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44055',
  },
  {
    city: 'Macedonia',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 480.7,
    imprecise: false,
    latitude: 41.31465,
    longitude: -81.49868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44056',
  },
  {
    city: 'Madison',
    county_fips: 39085,
    county_fips_all: '39085|39055|39007',
    county: 'Lake',
    county_names_all: 'Lake|Geauga|Ashtabula',
    county_weights: '{"39085": 94.32, "39055": 5.15, "39007": 0.53}',
    density: 149.9,
    imprecise: false,
    latitude: 41.76675,
    longitude: -81.05965,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44057',
  },
  {
    city: 'Mentor',
    county_fips: 39085,
    county_fips_all: '39085|39055',
    county: 'Lake',
    county_names_all: 'Lake|Geauga',
    county_weights: '{"39085": 94.07, "39055": 5.93}',
    density: 587.7,
    imprecise: false,
    latitude: 41.67742,
    longitude: -81.32806,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44060',
  },
  {
    city: 'Middlefield',
    county_fips: 39055,
    county_fips_all: '39055|39155|39007',
    county: 'Geauga',
    county_names_all: 'Geauga|Trumbull|Ashtabula',
    county_weights: '{"39055": 69.76, "39155": 24.69, "39007": 5.55}',
    density: 87.4,
    imprecise: false,
    latitude: 41.45899,
    longitude: -81.02698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44062',
  },
  {
    city: 'Montville',
    county_fips: 39055,
    county_fips_all: '39055|39007',
    county: 'Geauga',
    county_names_all: 'Geauga|Ashtabula',
    county_weights: '{"39055": 97.31, "39007": 2.69}',
    density: 22.2,
    imprecise: false,
    latitude: 41.60567,
    longitude: -81.0477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44064',
  },
  {
    city: 'Newbury',
    county_fips: 39055,
    county_fips_all: '39055',
    county: 'Geauga',
    county_names_all: 'Geauga',
    county_weights: '{"39055": 100}',
    density: 67.8,
    imprecise: false,
    latitude: 41.46308,
    longitude: -81.24408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44065',
  },
  {
    city: 'Northfield',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 447.7,
    imprecise: false,
    latitude: 41.31386,
    longitude: -81.5476,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44067',
  },
  {
    city: 'North Kingsville',
    county_fips: 39007,
    county_fips_all: '39007',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula',
    county_weights: '{"39007": 100}',
    density: 141.7,
    imprecise: false,
    latitude: 41.90619,
    longitude: -80.67886,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44068',
  },
  {
    city: 'North Olmsted',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1056,
    imprecise: false,
    latitude: 41.41493,
    longitude: -81.91905,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44070',
  },
  {
    city: 'Novelty',
    county_fips: 39055,
    county_fips_all: '39055',
    county: 'Geauga',
    county_names_all: 'Geauga',
    county_weights: '{"39055": 100}',
    density: 113.1,
    imprecise: false,
    latitude: 41.47196,
    longitude: -81.32917,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44072',
  },
  {
    city: 'Oberlin',
    county_fips: 39093,
    county_fips_all: '39093',
    county: 'Lorain',
    county_names_all: 'Lorain',
    county_weights: '{"39093": 100}',
    density: 89.1,
    imprecise: false,
    latitude: 41.28858,
    longitude: -82.23643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44074',
  },
  {
    city: 'Orwell',
    county_fips: 39007,
    county_fips_all: '39007|39155',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula|Trumbull',
    county_weights: '{"39007": 85.08, "39155": 14.92}',
    density: 26.5,
    imprecise: false,
    latitude: 41.52728,
    longitude: -80.81867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44076',
  },
  {
    city: 'Painesville',
    county_fips: 39085,
    county_fips_all: '39085',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"39085": 100}',
    density: 365.6,
    imprecise: false,
    latitude: 41.69933,
    longitude: -81.21142,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44077',
  },
  {
    city: 'Parkman',
    county_fips: 39055,
    county_fips_all: '39055',
    county: 'Geauga',
    county_names_all: 'Geauga',
    county_weights: '{"39055": 100}',
    density: 68.4,
    imprecise: false,
    latitude: 41.36886,
    longitude: -81.05966,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44080',
  },
  {
    city: 'Perry',
    county_fips: 39085,
    county_fips_all: '39085',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"39085": 100}',
    density: 130.5,
    imprecise: false,
    latitude: 41.76589,
    longitude: -81.14551,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44081',
  },
  {
    city: 'Pierpont',
    county_fips: 39007,
    county_fips_all: '39007',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula',
    county_weights: '{"39007": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 41.76012,
    longitude: -80.56558,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44082',
  },
  {
    city: 'Rock Creek',
    county_fips: 39007,
    county_fips_all: '39007',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula',
    county_weights: '{"39007": 100}',
    density: 34.2,
    imprecise: false,
    latitude: 41.67242,
    longitude: -80.89605,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44084',
  },
  {
    city: 'Rome',
    county_fips: 39007,
    county_fips_all: '39007',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula',
    county_weights: '{"39007": 100}',
    density: 26.8,
    imprecise: false,
    latitude: 41.60463,
    longitude: -80.87128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44085',
  },
  {
    city: 'Thompson',
    county_fips: 39055,
    county_fips_all: '39055|39085|39007',
    county: 'Geauga',
    county_names_all: 'Geauga|Lake|Ashtabula',
    county_weights: '{"39055": 86.55, "39085": 11.76, "39007": 1.69}',
    density: 35.6,
    imprecise: false,
    latitude: 41.67443,
    longitude: -81.05599,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44086',
  },
  {
    city: 'Twinsburg',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 476.6,
    imprecise: false,
    latitude: 41.31706,
    longitude: -81.44106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44087',
  },
  {
    city: 'Vermilion',
    county_fips: 39043,
    county_fips_all: '39043|39093',
    county: 'Erie',
    county_names_all: 'Erie|Lorain',
    county_weights: '{"39043": 62.08, "39093": 37.92}',
    density: 174.8,
    imprecise: false,
    latitude: 41.38894,
    longitude: -82.36552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44089',
  },
  {
    city: 'Wellington',
    county_fips: 39093,
    county_fips_all: '39093|39103',
    county: 'Lorain',
    county_names_all: 'Lorain|Medina',
    county_weights: '{"39093": 98.92, "39103": 1.08}',
    density: 40.9,
    imprecise: false,
    latitude: 41.16757,
    longitude: -82.22836,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44090',
  },
  {
    city: 'Wickliffe',
    county_fips: 39085,
    county_fips_all: '39085',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"39085": 100}',
    density: 920.9,
    imprecise: false,
    latitude: 41.59797,
    longitude: -81.46867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44092',
  },
  {
    city: 'Williamsfield',
    county_fips: 39007,
    county_fips_all: '39007',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula',
    county_weights: '{"39007": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 41.53478,
    longitude: -80.61637,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44093',
  },
  {
    city: 'Willoughby',
    county_fips: 39085,
    county_fips_all: '39085|39055',
    county: 'Lake',
    county_names_all: 'Lake|Geauga',
    county_weights: '{"39085": 98.98, "39055": 1.02}',
    density: 358.8,
    imprecise: false,
    latitude: 41.60985,
    longitude: -81.3791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44094',
  },
  {
    city: 'Eastlake',
    county_fips: 39085,
    county_fips_all: '39085',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"39085": 100}',
    density: 1371.1,
    imprecise: false,
    latitude: 41.65223,
    longitude: -81.44209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44095',
  },
  {
    city: 'Windsor',
    county_fips: 39007,
    county_fips_all: '39007|39055',
    county: 'Ashtabula',
    county_names_all: 'Ashtabula|Geauga',
    county_weights: '{"39007": 85.76, "39055": 14.24}',
    density: 30.1,
    imprecise: false,
    latitude: 41.55125,
    longitude: -80.97446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44099',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 2880.5,
    imprecise: false,
    latitude: 41.48988,
    longitude: -81.6717,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44101',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 2533.3,
    imprecise: false,
    latitude: 41.4749,
    longitude: -81.73751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44102',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1324.1,
    imprecise: false,
    latitude: 41.51559,
    longitude: -81.64301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44103',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1554.9,
    imprecise: false,
    latitude: 41.48238,
    longitude: -81.62702,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44104',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1391.2,
    imprecise: false,
    latitude: 41.45069,
    longitude: -81.63032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44105',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 2256.4,
    imprecise: false,
    latitude: 41.5062,
    longitude: -81.60679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44106',
  },
  {
    city: 'Lakewood',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 3589.8,
    imprecise: false,
    latitude: 41.48263,
    longitude: -81.80025,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44107',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1676.8,
    imprecise: false,
    latitude: 41.53992,
    longitude: -81.60988,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44108',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 2146.1,
    imprecise: false,
    latitude: 41.44457,
    longitude: -81.69681,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44109',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1586.1,
    imprecise: false,
    latitude: 41.56365,
    longitude: -81.57111,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44110',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 2477.8,
    imprecise: false,
    latitude: 41.45775,
    longitude: -81.78986,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44111',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1717.6,
    imprecise: false,
    latitude: 41.53562,
    longitude: -81.57369,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44112',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 2040.9,
    imprecise: false,
    latitude: 41.48343,
    longitude: -81.69638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44113',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 948.8,
    imprecise: false,
    latitude: 41.5137,
    longitude: -81.67625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44114',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1828.1,
    imprecise: false,
    latitude: 41.49211,
    longitude: -81.66999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44115',
  },
  {
    city: 'Rocky River',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1700.5,
    imprecise: false,
    latitude: 41.47011,
    longitude: -81.85194,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44116',
  },
  {
    city: 'Euclid',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 931.8,
    imprecise: false,
    latitude: 41.57145,
    longitude: -81.52695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44117',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 2230,
    imprecise: false,
    latitude: 41.5016,
    longitude: -81.55653,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44118',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 2302.1,
    imprecise: false,
    latitude: 41.58673,
    longitude: -81.54748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44119',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 2447.8,
    imprecise: false,
    latitude: 41.47337,
    longitude: -81.58015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44120',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1961.6,
    imprecise: false,
    latitude: 41.52626,
    longitude: -81.53246,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44121',
  },
  {
    city: 'Beachwood',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1136.3,
    imprecise: false,
    latitude: 41.4701,
    longitude: -81.51272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44122',
  },
  {
    city: 'Euclid',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 2752.3,
    imprecise: false,
    latitude: 41.60365,
    longitude: -81.52441,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44123',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1013.2,
    imprecise: false,
    latitude: 41.49999,
    longitude: -81.46774,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44124',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 812.6,
    imprecise: false,
    latitude: 41.40658,
    longitude: -81.61548,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44125',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1459.9,
    imprecise: false,
    latitude: 41.44263,
    longitude: -81.85278,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44126',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 913.2,
    imprecise: false,
    latitude: 41.471,
    longitude: -81.64874,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44127',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1192.6,
    imprecise: false,
    latitude: 41.43766,
    longitude: -81.54036,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44128',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1903,
    imprecise: false,
    latitude: 41.39035,
    longitude: -81.73536,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44129',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1119.1,
    imprecise: false,
    latitude: 41.378,
    longitude: -81.7868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44130',
  },
  {
    city: 'Independence',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 505.4,
    imprecise: false,
    latitude: 41.3835,
    longitude: -81.65349,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44131',
  },
  {
    city: 'Euclid',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1772.8,
    imprecise: false,
    latitude: 41.60484,
    longitude: -81.49958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44132',
  },
  {
    city: 'North Royalton',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 558.7,
    imprecise: false,
    latitude: 41.31388,
    longitude: -81.74497,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44133',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1503.4,
    imprecise: false,
    latitude: 41.38496,
    longitude: -81.70459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44134',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1065.3,
    imprecise: false,
    latitude: 41.42472,
    longitude: -81.82135,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44135',
  },
  {
    city: 'Strongsville',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 712.1,
    imprecise: false,
    latitude: 41.31265,
    longitude: -81.81064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44136',
  },
  {
    city: 'Maple Heights',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1731.9,
    imprecise: false,
    latitude: 41.40903,
    longitude: -81.56274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44137',
  },
  {
    city: 'Olmsted Falls',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 647.7,
    imprecise: false,
    latitude: 41.37363,
    longitude: -81.92302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44138',
  },
  {
    city: 'Solon',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 415.9,
    imprecise: false,
    latitude: 41.38325,
    longitude: -81.44439,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44139',
  },
  {
    city: 'Bay Village',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1351.7,
    imprecise: false,
    latitude: 41.48508,
    longitude: -81.93171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44140',
  },
  {
    city: 'Brecksville',
    county_fips: 39035,
    county_fips_all: '39035|39153',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga|Summit',
    county_weights: '{"39035": 82.15, "39153": 17.85}',
    density: 221.7,
    imprecise: false,
    latitude: 41.30139,
    longitude: -81.61439,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44141',
  },
  {
    city: 'Brook Park',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 949.2,
    imprecise: false,
    latitude: 41.40205,
    longitude: -81.82406,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44142',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 674.8,
    imprecise: false,
    latitude: 41.55358,
    longitude: -81.47513,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44143',
  },
  {
    city: 'Cleveland',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 1488.5,
    imprecise: false,
    latitude: 41.43738,
    longitude: -81.74272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44144',
  },
  {
    city: 'Westlake',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 826.4,
    imprecise: false,
    latitude: 41.45245,
    longitude: -81.92944,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44145',
  },
  {
    city: 'Bedford',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 565.9,
    imprecise: false,
    latitude: 41.38161,
    longitude: -81.53018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44146',
  },
  {
    city: 'Broadview Heights',
    county_fips: 39035,
    county_fips_all: '39035',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga',
    county_weights: '{"39035": 100}',
    density: 587.9,
    imprecise: false,
    latitude: 41.31956,
    longitude: -81.67797,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44147',
  },
  {
    city: 'Strongsville',
    county_fips: 39035,
    county_fips_all: '39035|39103',
    county: 'Cuyahoga',
    county_names_all: 'Cuyahoga|Medina',
    county_weights: '{"39035": 98.16, "39103": 1.84}',
    density: 720.5,
    imprecise: false,
    latitude: 41.31223,
    longitude: -81.8563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44149',
  },
  {
    city: 'Atwater',
    county_fips: 39133,
    county_fips_all: '39133|39151',
    county: 'Portage',
    county_names_all: 'Portage|Stark',
    county_weights: '{"39133": 98.22, "39151": 1.78}',
    density: 48.8,
    imprecise: false,
    latitude: 41.02741,
    longitude: -81.18354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44201',
  },
  {
    city: 'Aurora',
    county_fips: 39133,
    county_fips_all: '39133|39153|39055',
    county: 'Portage',
    county_names_all: 'Portage|Summit|Geauga',
    county_weights: '{"39133": 88.43, "39153": 6.32, "39055": 5.25}',
    density: 293.8,
    imprecise: false,
    latitude: 41.31645,
    longitude: -81.34243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44202',
  },
  {
    city: 'Barberton',
    county_fips: 39153,
    county_fips_all: '39153|39103|39169',
    county: 'Summit',
    county_names_all: 'Summit|Medina|Wayne',
    county_weights: '{"39153": 97.65, "39103": 1.49, "39169": 0.86}',
    density: 426.5,
    imprecise: false,
    latitude: 41.02013,
    longitude: -81.62896,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44203',
  },
  {
    city: 'Brunswick',
    county_fips: 39103,
    county_fips_all: '39103',
    county: 'Medina',
    county_names_all: 'Medina',
    county_weights: '{"39103": 100}',
    density: 841.9,
    imprecise: false,
    latitude: 41.24386,
    longitude: -81.82863,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44212',
  },
  {
    city: 'Burbank',
    county_fips: 39169,
    county_fips_all: '39169|39103',
    county: 'Wayne',
    county_names_all: 'Wayne|Medina',
    county_weights: '{"39169": 85.77, "39103": 14.23}',
    density: 35.8,
    imprecise: false,
    latitude: 40.95081,
    longitude: -81.99935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44214',
  },
  {
    city: 'Chippewa Lake',
    county_fips: 39103,
    county_fips_all: '39103',
    county: 'Medina',
    county_names_all: 'Medina',
    county_weights: '{"39103": 100}',
    density: 461.1,
    imprecise: false,
    latitude: 41.07195,
    longitude: -81.8994,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44215',
  },
  {
    city: 'Clinton',
    county_fips: 39153,
    county_fips_all: '39153|39151|39169',
    county: 'Summit',
    county_names_all: 'Summit|Stark|Wayne',
    county_weights: '{"39153": 95.37, "39151": 4.09, "39169": 0.54}',
    density: 155.3,
    imprecise: false,
    latitude: 40.93848,
    longitude: -81.58397,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44216',
  },
  {
    city: 'Creston',
    county_fips: 39169,
    county_fips_all: '39169|39103',
    county: 'Wayne',
    county_names_all: 'Wayne|Medina',
    county_weights: '{"39169": 87.85, "39103": 12.15}',
    density: 49.9,
    imprecise: false,
    latitude: 40.95561,
    longitude: -81.9133,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44217',
  },
  {
    city: 'Cuyahoga Falls',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 1724.2,
    imprecise: false,
    latitude: 41.13898,
    longitude: -81.47624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44221',
  },
  {
    city: 'Cuyahoga Falls',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 481.4,
    imprecise: false,
    latitude: 41.16968,
    longitude: -81.53051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44223',
  },
  {
    city: 'Stow',
    county_fips: 39153,
    county_fips_all: '39153|39133',
    county: 'Summit',
    county_names_all: 'Summit|Portage',
    county_weights: '{"39153": 98.3, "39133": 1.7}',
    density: 741.6,
    imprecise: false,
    latitude: 41.17697,
    longitude: -81.44016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44224',
  },
  {
    city: 'Doylestown',
    county_fips: 39169,
    county_fips_all: '39169|39103|39153',
    county: 'Wayne',
    county_names_all: 'Wayne|Medina|Summit',
    county_weights: '{"39169": 93.25, "39103": 5.95, "39153": 0.8}',
    density: 172.9,
    imprecise: false,
    latitude: 40.96237,
    longitude: -81.69064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44230',
  },
  {
    city: 'Garrettsville',
    county_fips: 39133,
    county_fips_all: '39133|39055',
    county: 'Portage',
    county_names_all: 'Portage|Geauga',
    county_weights: '{"39133": 84.92, "39055": 15.08}',
    density: 64.9,
    imprecise: false,
    latitude: 41.30692,
    longitude: -81.07197,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44231',
  },
  {
    city: 'Green',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.93254,
    longitude: -81.46354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44232',
  },
  {
    city: 'Hinckley',
    county_fips: 39103,
    county_fips_all: '39103',
    county: 'Medina',
    county_names_all: 'Medina',
    county_weights: '{"39103": 100}',
    density: 117.2,
    imprecise: false,
    latitude: 41.23943,
    longitude: -81.73513,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44233',
  },
  {
    city: 'Hiram',
    county_fips: 39133,
    county_fips_all: '39133|39055',
    county: 'Portage',
    county_names_all: 'Portage|Geauga',
    county_weights: '{"39133": 65.21, "39055": 34.79}',
    density: 55.5,
    imprecise: false,
    latitude: 41.33454,
    longitude: -81.15822,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44234',
  },
  {
    city: 'Homerville',
    county_fips: 39103,
    county_fips_all: '39103|39005',
    county: 'Medina',
    county_names_all: 'Medina|Ashland',
    county_weights: '{"39103": 97.97, "39005": 2.03}',
    density: 20.7,
    imprecise: false,
    latitude: 41.0316,
    longitude: -82.12246,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44235',
  },
  {
    city: 'Hudson',
    county_fips: 39153,
    county_fips_all: '39153|39133',
    county: 'Summit',
    county_names_all: 'Summit|Portage',
    county_weights: '{"39153": 99.29, "39133": 0.71}',
    density: 312.7,
    imprecise: false,
    latitude: 41.24669,
    longitude: -81.44775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44236',
  },
  {
    city: 'Kent',
    county_fips: 39133,
    county_fips_all: '39133|39153',
    county: 'Portage',
    county_names_all: 'Portage|Summit',
    county_weights: '{"39133": 99.68, "39153": 0.32}',
    density: 367.1,
    imprecise: false,
    latitude: 41.13329,
    longitude: -81.34241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44240',
  },
  {
    city: 'Streetsboro',
    county_fips: 39133,
    county_fips_all: '39133',
    county: 'Portage',
    county_names_all: 'Portage',
    county_weights: '{"39133": 100}',
    density: 322.5,
    imprecise: false,
    latitude: 41.23945,
    longitude: -81.34728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44241',
  },
  {
    city: 'Lakemore',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 952.1,
    imprecise: false,
    latitude: 41.02159,
    longitude: -81.43331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44250',
  },
  {
    city: 'Westfield Center',
    county_fips: 39103,
    county_fips_all: '39103',
    county: 'Medina',
    county_names_all: 'Medina',
    county_weights: '{"39103": 100}',
    density: 252.8,
    imprecise: false,
    latitude: 41.02814,
    longitude: -81.92764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44251',
  },
  {
    city: 'Litchfield',
    county_fips: 39103,
    county_fips_all: '39103|39093',
    county: 'Medina',
    county_names_all: 'Medina|Lorain',
    county_weights: '{"39103": 83.25, "39093": 16.75}',
    density: 49.9,
    imprecise: false,
    latitude: 41.16571,
    longitude: -82.03767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44253',
  },
  {
    city: 'Lodi',
    county_fips: 39103,
    county_fips_all: '39103',
    county: 'Medina',
    county_names_all: 'Medina',
    county_weights: '{"39103": 100}',
    density: 72.6,
    imprecise: false,
    latitude: 41.04522,
    longitude: -82.01282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44254',
  },
  {
    city: 'Mantua',
    county_fips: 39133,
    county_fips_all: '39133',
    county: 'Portage',
    county_names_all: 'Portage',
    county_weights: '{"39133": 100}',
    density: 66.1,
    imprecise: false,
    latitude: 41.28658,
    longitude: -81.22982,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44255',
  },
  {
    city: 'Medina',
    county_fips: 39103,
    county_fips_all: '39103|39093',
    county: 'Medina',
    county_names_all: 'Medina|Lorain',
    county_weights: '{"39103": 99.5, "39093": 0.5}',
    density: 191.7,
    imprecise: false,
    latitude: 41.14092,
    longitude: -81.85954,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 64924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44256',
  },
  {
    city: 'Mogadore',
    county_fips: 39133,
    county_fips_all: '39133|39153|39151',
    county: 'Portage',
    county_names_all: 'Portage|Summit|Stark',
    county_weights: '{"39133": 93.7, "39153": 5.14, "39151": 1.16}',
    density: 149.6,
    imprecise: false,
    latitude: 41.03684,
    longitude: -81.34079,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44260',
  },
  {
    city: 'Munroe Falls',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 721.9,
    imprecise: false,
    latitude: 41.13901,
    longitude: -81.43492,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44262',
  },
  {
    city: 'Peninsula',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 59.8,
    imprecise: false,
    latitude: 41.22966,
    longitude: -81.54311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44264',
  },
  {
    city: 'Ravenna',
    county_fips: 39133,
    county_fips_all: '39133',
    county: 'Portage',
    county_names_all: 'Portage',
    county_weights: '{"39133": 100}',
    density: 137,
    imprecise: false,
    latitude: 41.1662,
    longitude: -81.19829,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44266',
  },
  {
    city: 'Rittman',
    county_fips: 39169,
    county_fips_all: '39169|39103',
    county: 'Wayne',
    county_names_all: 'Wayne|Medina',
    county_weights: '{"39169": 83.56, "39103": 16.44}',
    density: 159.7,
    imprecise: false,
    latitude: 40.96317,
    longitude: -81.77696,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44270',
  },
  {
    city: 'Rootstown',
    county_fips: 39133,
    county_fips_all: '39133',
    county: 'Portage',
    county_names_all: 'Portage',
    county_weights: '{"39133": 100}',
    density: 96.2,
    imprecise: false,
    latitude: 41.08691,
    longitude: -81.18244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44272',
  },
  {
    city: 'Seville',
    county_fips: 39103,
    county_fips_all: '39103|39169',
    county: 'Medina',
    county_names_all: 'Medina|Wayne',
    county_weights: '{"39103": 98.76, "39169": 1.24}',
    density: 69.4,
    imprecise: false,
    latitude: 41.0291,
    longitude: -81.87739,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44273',
  },
  {
    city: 'Sharon Center',
    county_fips: 39103,
    county_fips_all: '39103',
    county: 'Medina',
    county_names_all: 'Medina',
    county_weights: '{"39103": 100}',
    density: 31.4,
    imprecise: false,
    latitude: 41.09944,
    longitude: -81.7285,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44274',
  },
  {
    city: 'Spencer',
    county_fips: 39103,
    county_fips_all: '39103|39093',
    county: 'Medina',
    county_names_all: 'Medina|Lorain',
    county_weights: '{"39103": 93.29, "39093": 6.71}',
    density: 33.2,
    imprecise: false,
    latitude: 41.09976,
    longitude: -82.09927,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44275',
  },
  {
    city: 'Sterling',
    county_fips: 39169,
    county_fips_all: '39169',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"39169": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 40.93667,
    longitude: -81.83502,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44276',
  },
  {
    city: 'Tallmadge',
    county_fips: 39153,
    county_fips_all: '39153|39133',
    county: 'Summit',
    county_names_all: 'Summit|Portage',
    county_weights: '{"39153": 96.09, "39133": 3.91}',
    density: 488.2,
    imprecise: false,
    latitude: 41.10052,
    longitude: -81.42137,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44278',
  },
  {
    city: 'Valley City',
    county_fips: 39103,
    county_fips_all: '39103|39093',
    county: 'Medina',
    county_names_all: 'Medina|Lorain',
    county_weights: '{"39103": 98.37, "39093": 1.63}',
    density: 83.8,
    imprecise: false,
    latitude: 41.23812,
    longitude: -81.92339,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44280',
  },
  {
    city: 'Wadsworth',
    county_fips: 39103,
    county_fips_all: '39103|39153',
    county: 'Medina',
    county_names_all: 'Medina|Summit',
    county_weights: '{"39103": 97.96, "39153": 2.04}',
    density: 280.3,
    imprecise: false,
    latitude: 41.05851,
    longitude: -81.73854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 34704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44281',
  },
  {
    city: 'Wayland',
    county_fips: 39133,
    county_fips_all: '39133',
    county: 'Portage',
    county_names_all: 'Portage',
    county_weights: '{"39133": 100}',
    density: 35.9,
    imprecise: false,
    latitude: 41.16241,
    longitude: -81.06595,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44285',
  },
  {
    city: 'Richfield',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 102.9,
    imprecise: false,
    latitude: 41.23668,
    longitude: -81.64017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44286',
  },
  {
    city: 'West Salem',
    county_fips: 39169,
    county_fips_all: '39169|39005|39103',
    county: 'Wayne',
    county_names_all: 'Wayne|Ashland|Medina',
    county_weights: '{"39169": 64.83, "39005": 27.0, "39103": 8.17}',
    density: 45.9,
    imprecise: false,
    latitude: 40.94,
    longitude: -82.1005,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44287',
  },
  {
    city: 'Windham',
    county_fips: 39133,
    county_fips_all: '39133|39155',
    county: 'Portage',
    county_names_all: 'Portage|Trumbull',
    county_weights: '{"39133": 97.91, "39155": 2.09}',
    density: 87.8,
    imprecise: false,
    latitude: 41.2392,
    longitude: -81.08354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44288',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 1484.2,
    imprecise: false,
    latitude: 41.04398,
    longitude: -81.52449,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44301',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 2351.4,
    imprecise: false,
    latitude: 41.08951,
    longitude: -81.53857,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44302',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 1342.3,
    imprecise: false,
    latitude: 41.10448,
    longitude: -81.53732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44303',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 1174.9,
    imprecise: false,
    latitude: 41.08585,
    longitude: -81.50908,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44304',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 1212.9,
    imprecise: false,
    latitude: 41.07643,
    longitude: -81.46226,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44305',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 967.5,
    imprecise: false,
    latitude: 41.03927,
    longitude: -81.48316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44306',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 1315.9,
    imprecise: false,
    latitude: 41.07049,
    longitude: -81.546,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44307',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 861.2,
    imprecise: false,
    latitude: 41.0818,
    longitude: -81.51751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44308',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 1595.3,
    imprecise: false,
    latitude: 41.10771,
    longitude: -81.49948,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44310',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 1559.8,
    imprecise: false,
    latitude: 41.06427,
    longitude: -81.52047,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44311',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153|39133',
    county: 'Summit',
    county_names_all: 'Summit|Portage',
    county_weights: '{"39153": 99.34, "39133": 0.66}',
    density: 616.9,
    imprecise: false,
    latitude: 41.01462,
    longitude: -81.4412,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44312',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 762.2,
    imprecise: false,
    latitude: 41.13239,
    longitude: -81.56512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44313',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 1581.3,
    imprecise: false,
    latitude: 41.04048,
    longitude: -81.55838,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44314',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 436.7,
    imprecise: false,
    latitude: 40.98402,
    longitude: -81.53169,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44319',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 681.1,
    imprecise: false,
    latitude: 41.07818,
    longitude: -81.58379,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44320',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153|39103',
    county: 'Summit',
    county_names_all: 'Summit|Medina',
    county_weights: '{"39153": 97.15, "39103": 2.85}',
    density: 419.8,
    imprecise: false,
    latitude: 41.09994,
    longitude: -81.65182,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44321',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153|39103',
    county: 'Summit',
    county_names_all: 'Summit|Medina',
    county_weights: '{"39153": 98.37, "39103": 1.63}',
    density: 266.6,
    imprecise: false,
    latitude: 41.16195,
    longitude: -81.63419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44333',
  },
  {
    city: 'Berlin Center',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 32,
    imprecise: false,
    latitude: 41.02457,
    longitude: -80.94658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44401',
  },
  {
    city: 'Bristolville',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 27.8,
    imprecise: false,
    latitude: 41.38893,
    longitude: -80.85513,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44402',
  },
  {
    city: 'Brookfield',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 100.6,
    imprecise: false,
    latitude: 41.24053,
    longitude: -80.58265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44403',
  },
  {
    city: 'Burghill',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 41.1,
    imprecise: false,
    latitude: 41.3277,
    longitude: -80.54861,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44404',
  },
  {
    city: 'Campbell',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 842.6,
    imprecise: false,
    latitude: 41.07787,
    longitude: -80.59136,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44405',
  },
  {
    city: 'Canfield',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 159,
    imprecise: false,
    latitude: 41.01132,
    longitude: -80.77194,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44406',
  },
  {
    city: 'Columbiana',
    county_fips: 39029,
    county_fips_all: '39029|39099',
    county: 'Columbiana',
    county_names_all: 'Columbiana|Mahoning',
    county_weights: '{"39029": 62.87, "39099": 37.13}',
    density: 120.9,
    imprecise: false,
    latitude: 40.88487,
    longitude: -80.68569,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44408',
  },
  {
    city: 'Cortland',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 94.4,
    imprecise: false,
    latitude: 41.34817,
    longitude: -80.72629,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44410',
  },
  {
    city: 'Deerfield',
    county_fips: 39133,
    county_fips_all: '39133',
    county: 'Portage',
    county_names_all: 'Portage',
    county_weights: '{"39133": 100}',
    density: 44.5,
    imprecise: false,
    latitude: 41.0326,
    longitude: -81.05092,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44411',
  },
  {
    city: 'Diamond',
    county_fips: 39133,
    county_fips_all: '39133|39099',
    county: 'Portage',
    county_names_all: 'Portage|Mahoning',
    county_weights: '{"39133": 75.12, "39099": 24.88}',
    density: 51,
    imprecise: false,
    latitude: 41.09671,
    longitude: -81.0229,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44412',
  },
  {
    city: 'East Palestine',
    county_fips: 39029,
    county_fips_all: '39029',
    county: 'Columbiana',
    county_names_all: 'Columbiana',
    county_weights: '{"39029": 100}',
    density: 116.6,
    imprecise: false,
    latitude: 40.84803,
    longitude: -80.5549,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44413',
  },
  {
    city: 'Elkton',
    county_fips: 39029,
    county_fips_all: '39029',
    county: 'Columbiana',
    county_names_all: 'Columbiana',
    county_weights: '{"39029": 100}',
    density: 358.2,
    imprecise: false,
    latitude: 40.77068,
    longitude: -80.70455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44415',
  },
  {
    city: 'Farmdale',
    county_fips: 39155,
    county_fips_all: '39155|39007',
    county: 'Trumbull',
    county_names_all: 'Trumbull|Ashtabula',
    county_weights: '{"39155": 99.77, "39007": 0.23}',
    density: 17.4,
    imprecise: false,
    latitude: 41.43336,
    longitude: -80.66329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44417',
  },
  {
    city: 'Fowler',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 41.30692,
    longitude: -80.60465,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44418',
  },
  {
    city: 'Girard',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 398.3,
    imprecise: false,
    latitude: 41.17384,
    longitude: -80.67726,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44420',
  },
  {
    city: 'Hanoverton',
    county_fips: 39029,
    county_fips_all: '39029',
    county: 'Columbiana',
    county_names_all: 'Columbiana',
    county_weights: '{"39029": 100}',
    density: 28.9,
    imprecise: false,
    latitude: 40.7524,
    longitude: -80.89963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44423',
  },
  {
    city: 'Hartford',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 41.32201,
    longitude: -80.58326,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44424',
  },
  {
    city: 'Hubbard',
    county_fips: 39155,
    county_fips_all: '39155|39099',
    county: 'Trumbull',
    county_names_all: 'Trumbull|Mahoning',
    county_weights: '{"39155": 95.68, "39099": 4.32}',
    density: 171.7,
    imprecise: false,
    latitude: 41.17022,
    longitude: -80.57395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44425',
  },
  {
    city: 'Kensington',
    county_fips: 39019,
    county_fips_all: '39019|39029',
    county: 'Carroll',
    county_names_all: 'Carroll|Columbiana',
    county_weights: '{"39019": 52.36, "39029": 47.64}',
    density: 17.6,
    imprecise: false,
    latitude: 40.71672,
    longitude: -80.95686,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44427',
  },
  {
    city: 'Kinsman',
    county_fips: 39155,
    county_fips_all: '39155|39007',
    county: 'Trumbull',
    county_names_all: 'Trumbull|Ashtabula',
    county_weights: '{"39155": 96.5, "39007": 3.5}',
    density: 22.2,
    imprecise: false,
    latitude: 41.43458,
    longitude: -80.5779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44428',
  },
  {
    city: 'Lake Milton',
    county_fips: 39099,
    county_fips_all: '39099|39133',
    county: 'Mahoning',
    county_names_all: 'Mahoning|Portage',
    county_weights: '{"39099": 97.0, "39133": 3.0}',
    density: 136.2,
    imprecise: false,
    latitude: 41.09648,
    longitude: -80.98156,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44429',
  },
  {
    city: 'Leavittsburg',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 143.3,
    imprecise: false,
    latitude: 41.24011,
    longitude: -80.90804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44430',
  },
  {
    city: 'Leetonia',
    county_fips: 39029,
    county_fips_all: '39029',
    county: 'Columbiana',
    county_names_all: 'Columbiana',
    county_weights: '{"39029": 100}',
    density: 67.4,
    imprecise: false,
    latitude: 40.84748,
    longitude: -80.75365,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44431',
  },
  {
    city: 'Lisbon',
    county_fips: 39029,
    county_fips_all: '39029',
    county: 'Columbiana',
    county_names_all: 'Columbiana',
    county_weights: '{"39029": 100}',
    density: 43.9,
    imprecise: false,
    latitude: 40.74974,
    longitude: -80.75149,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44432',
  },
  {
    city: 'Lowellville',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 53.8,
    imprecise: false,
    latitude: 41.05775,
    longitude: -80.54241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44436',
  },
  {
    city: 'McDonald',
    county_fips: 39155,
    county_fips_all: '39155|39099',
    county: 'Trumbull',
    county_names_all: 'Trumbull|Mahoning',
    county_weights: '{"39155": 94.26, "39099": 5.74}',
    density: 388.8,
    imprecise: false,
    latitude: 41.15536,
    longitude: -80.73,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44437',
  },
  {
    city: 'Masury',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 203.1,
    imprecise: false,
    latitude: 41.24252,
    longitude: -80.5345,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44438',
  },
  {
    city: 'Mesopotamia',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 66.3,
    imprecise: false,
    latitude: 41.45436,
    longitude: -80.95552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44439',
  },
  {
    city: 'Mineral Ridge',
    county_fips: 39155,
    county_fips_all: '39155|39099',
    county: 'Trumbull',
    county_names_all: 'Trumbull|Mahoning',
    county_weights: '{"39155": 91.52, "39099": 8.48}',
    density: 202.6,
    imprecise: false,
    latitude: 41.1482,
    longitude: -80.78439,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44440',
  },
  {
    city: 'Negley',
    county_fips: 39029,
    county_fips_all: '39029',
    county: 'Columbiana',
    county_names_all: 'Columbiana',
    county_weights: '{"39029": 100}',
    density: 37.1,
    imprecise: false,
    latitude: 40.75802,
    longitude: -80.55264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44441',
  },
  {
    city: 'New Middletown',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 160.5,
    imprecise: false,
    latitude: 40.96591,
    longitude: -80.54963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44442',
  },
  {
    city: 'New Springfield',
    county_fips: 39099,
    county_fips_all: '39099|39029',
    county: 'Mahoning',
    county_names_all: 'Mahoning|Columbiana',
    county_weights: '{"39099": 93.25, "39029": 6.75}',
    density: 46.9,
    imprecise: false,
    latitude: 40.92351,
    longitude: -80.59473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44443',
  },
  {
    city: 'Newton Falls',
    county_fips: 39155,
    county_fips_all: '39155|39133|39099',
    county: 'Trumbull',
    county_names_all: 'Trumbull|Portage|Mahoning',
    county_weights: '{"39155": 72.24, "39133": 21.21, "39099": 6.55}',
    density: 86.7,
    imprecise: false,
    latitude: 41.17559,
    longitude: -80.97647,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44444',
  },
  {
    city: 'New Waterford',
    county_fips: 39029,
    county_fips_all: '39029',
    county: 'Columbiana',
    county_names_all: 'Columbiana',
    county_weights: '{"39029": 100}',
    density: 72.7,
    imprecise: false,
    latitude: 40.84834,
    longitude: -80.61732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44445',
  },
  {
    city: 'Niles',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 554,
    imprecise: false,
    latitude: 41.18958,
    longitude: -80.74692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44446',
  },
  {
    city: 'North Benton',
    county_fips: 39099,
    county_fips_all: '39099|39133',
    county: 'Mahoning',
    county_names_all: 'Mahoning|Portage',
    county_weights: '{"39099": 75.17, "39133": 24.83}',
    density: 34.4,
    imprecise: false,
    latitude: 40.97957,
    longitude: -81.02446,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44449',
  },
  {
    city: 'North Bloomfield',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 19.7,
    imprecise: false,
    latitude: 41.45397,
    longitude: -80.82576,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44450',
  },
  {
    city: 'North Jackson',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 28.9,
    imprecise: false,
    latitude: 41.08104,
    longitude: -80.86887,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44451',
  },
  {
    city: 'North Lima',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 73.5,
    imprecise: false,
    latitude: 40.94711,
    longitude: -80.66232,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44452',
  },
  {
    city: 'Petersburg',
    county_fips: 39099,
    county_fips_all: '39099|39029',
    county: 'Mahoning',
    county_names_all: 'Mahoning|Columbiana',
    county_weights: '{"39099": 91.54, "39029": 8.46}',
    density: 51.3,
    imprecise: false,
    latitude: 40.9197,
    longitude: -80.53976,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44454',
  },
  {
    city: 'Rogers',
    county_fips: 39029,
    county_fips_all: '39029',
    county: 'Columbiana',
    county_names_all: 'Columbiana',
    county_weights: '{"39029": 100}',
    density: 34.4,
    imprecise: false,
    latitude: 40.77581,
    longitude: -80.60485,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44455',
  },
  {
    city: 'Salem',
    county_fips: 39029,
    county_fips_all: '39029|39099',
    county: 'Columbiana',
    county_names_all: 'Columbiana|Mahoning',
    county_weights: '{"39029": 54.81, "39099": 45.19}',
    density: 90.2,
    imprecise: false,
    latitude: 40.90221,
    longitude: -80.87026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44460',
  },
  {
    city: 'Southington',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 58.3,
    imprecise: false,
    latitude: 41.29783,
    longitude: -80.95999,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44470',
  },
  {
    city: 'Struthers',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 887.2,
    imprecise: false,
    latitude: 41.04793,
    longitude: -80.58973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44471',
  },
  {
    city: 'Vienna',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 66.4,
    imprecise: false,
    latitude: 41.24684,
    longitude: -80.66326,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44473',
  },
  {
    city: 'Warren',
    county_fips: 39155,
    county_fips_all: '39155|39099',
    county: 'Trumbull',
    county_names_all: 'Trumbull|Mahoning',
    county_weights: '{"39155": 96.89, "39099": 3.11}',
    density: 69.2,
    imprecise: false,
    latitude: 41.22736,
    longitude: -80.86344,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44481',
  },
  {
    city: 'Warren',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 543.3,
    imprecise: false,
    latitude: 41.26537,
    longitude: -80.81575,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44483',
  },
  {
    city: 'Warren',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 460.3,
    imprecise: false,
    latitude: 41.2348,
    longitude: -80.74962,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44484',
  },
  {
    city: 'Warren',
    county_fips: 39155,
    county_fips_all: '39155',
    county: 'Trumbull',
    county_names_all: 'Trumbull',
    county_weights: '{"39155": 100}',
    density: 738.1,
    imprecise: false,
    latitude: 41.24032,
    longitude: -80.848,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44485',
  },
  {
    city: 'Washingtonville',
    county_fips: 39029,
    county_fips_all: '39029|39099',
    county: 'Columbiana',
    county_names_all: 'Columbiana|Mahoning',
    county_weights: '{"39029": 52.76, "39099": 47.24}',
    density: 292.8,
    imprecise: false,
    latitude: 40.90041,
    longitude: -80.76801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44490',
  },
  {
    city: 'West Farmington',
    county_fips: 39155,
    county_fips_all: '39155|39055|39133',
    county: 'Trumbull',
    county_names_all: 'Trumbull|Geauga|Portage',
    county_weights: '{"39155": 83.61, "39055": 14.92, "39133": 1.47}',
    density: 46.1,
    imprecise: false,
    latitude: 41.37368,
    longitude: -80.96478,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44491',
  },
  {
    city: 'Winona',
    county_fips: 39029,
    county_fips_all: '39029',
    county: 'Columbiana',
    county_names_all: 'Columbiana',
    county_weights: '{"39029": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 40.82192,
    longitude: -80.88864,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44493',
  },
  {
    city: 'Youngstown',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 663.4,
    imprecise: false,
    latitude: 41.08365,
    longitude: -80.64253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44502',
  },
  {
    city: 'Youngstown',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 815.5,
    imprecise: false,
    latitude: 41.09918,
    longitude: -80.64912,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44503',
  },
  {
    city: 'Youngstown',
    county_fips: 39099,
    county_fips_all: '39099|39155',
    county: 'Mahoning',
    county_names_all: 'Mahoning|Trumbull',
    county_weights: '{"39099": 98.43, "39155": 1.57}',
    density: 1630.8,
    imprecise: false,
    latitude: 41.12327,
    longitude: -80.65363,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44504',
  },
  {
    city: 'Youngstown',
    county_fips: 39099,
    county_fips_all: '39099|39155',
    county: 'Mahoning',
    county_names_all: 'Mahoning|Trumbull',
    county_weights: '{"39099": 63.8, "39155": 36.2}',
    density: 359.3,
    imprecise: false,
    latitude: 41.12735,
    longitude: -80.61687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44505',
  },
  {
    city: 'Youngstown',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 438.1,
    imprecise: false,
    latitude: 41.09356,
    longitude: -80.62583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44506',
  },
  {
    city: 'Youngstown',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 916.1,
    imprecise: false,
    latitude: 41.07436,
    longitude: -80.65542,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44507',
  },
  {
    city: 'Youngstown',
    county_fips: 39099,
    county_fips_all: '39099|39155',
    county: 'Mahoning',
    county_names_all: 'Mahoning|Trumbull',
    county_weights: '{"39099": 93.91, "39155": 6.09}',
    density: 723.8,
    imprecise: false,
    latitude: 41.10986,
    longitude: -80.69655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44509',
  },
  {
    city: 'Youngstown',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 408.3,
    imprecise: false,
    latitude: 41.12246,
    longitude: -80.67424,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44510',
  },
  {
    city: 'Youngstown',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 987.8,
    imprecise: false,
    latitude: 41.06927,
    longitude: -80.69617,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44511',
  },
  {
    city: 'Youngstown',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 738.3,
    imprecise: false,
    latitude: 41.0249,
    longitude: -80.66757,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44512',
  },
  {
    city: 'Youngstown',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 415.6,
    imprecise: false,
    latitude: 40.99838,
    longitude: -80.60868,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44514',
  },
  {
    city: 'Youngstown',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 578.8,
    imprecise: false,
    latitude: 41.1029,
    longitude: -80.76201,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44515',
  },
  {
    city: 'Alliance',
    county_fips: 39151,
    county_fips_all: '39151|39099|39029',
    county: 'Stark',
    county_names_all: 'Stark|Mahoning|Columbiana',
    county_weights: '{"39151": 73.29, "39099": 14.38, "39029": 12.33}',
    density: 153.9,
    imprecise: false,
    latitude: 40.91978,
    longitude: -81.1278,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44601',
  },
  {
    city: 'Apple Creek',
    county_fips: 39169,
    county_fips_all: '39169',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"39169": 100}',
    density: 74.4,
    imprecise: false,
    latitude: 40.73313,
    longitude: -81.79625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44606',
  },
  {
    city: 'Augusta',
    county_fips: 39019,
    county_fips_all: '39019',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"39019": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 40.69589,
    longitude: -81.02685,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44607',
  },
  {
    city: 'Beach City',
    county_fips: 39151,
    county_fips_all: '39151|39157',
    county: 'Stark',
    county_names_all: 'Stark|Tuscarawas',
    county_weights: '{"39151": 72.21, "39157": 27.79}',
    density: 46.9,
    imprecise: false,
    latitude: 40.65241,
    longitude: -81.59714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44608',
  },
  {
    city: 'Beloit',
    county_fips: 39099,
    county_fips_all: '39099|39029',
    county: 'Mahoning',
    county_names_all: 'Mahoning|Columbiana',
    county_weights: '{"39099": 57.13, "39029": 42.87}',
    density: 54.2,
    imprecise: false,
    latitude: 40.9121,
    longitude: -80.9879,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44609',
  },
  {
    city: 'Berlin',
    county_fips: 39075,
    county_fips_all: '39075',
    county: 'Holmes',
    county_names_all: 'Holmes',
    county_weights: '{"39075": 100}',
    density: 314.2,
    imprecise: false,
    latitude: 40.56078,
    longitude: -81.80139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44610',
  },
  {
    city: 'Big Prairie',
    county_fips: 39075,
    county_fips_all: '39075|39169',
    county: 'Holmes',
    county_names_all: 'Holmes|Wayne',
    county_weights: '{"39075": 95.05, "39169": 4.95}',
    density: 32.8,
    imprecise: false,
    latitude: 40.60785,
    longitude: -82.08141,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44611',
  },
  {
    city: 'Bolivar',
    county_fips: 39157,
    county_fips_all: '39157|39151',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas|Stark',
    county_weights: '{"39157": 83.82, "39151": 16.18}',
    density: 76.7,
    imprecise: false,
    latitude: 40.63488,
    longitude: -81.46098,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44612',
  },
  {
    city: 'Brewster',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 381.8,
    imprecise: false,
    latitude: 40.71338,
    longitude: -81.60026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44613',
  },
  {
    city: 'Canal Fulton',
    county_fips: 39151,
    county_fips_all: '39151|39153|39169',
    county: 'Stark',
    county_names_all: 'Stark|Summit|Wayne',
    county_weights: '{"39151": 91.44, "39153": 5.05, "39169": 3.51}',
    density: 223.1,
    imprecise: false,
    latitude: 40.88689,
    longitude: -81.58747,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44614',
  },
  {
    city: 'Carrollton',
    county_fips: 39019,
    county_fips_all: '39019',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"39019": 100}',
    density: 26.9,
    imprecise: false,
    latitude: 40.5669,
    longitude: -81.0739,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44615',
  },
  {
    city: 'Dalton',
    county_fips: 39169,
    county_fips_all: '39169|39151',
    county: 'Wayne',
    county_names_all: 'Wayne|Stark',
    county_weights: '{"39169": 91.92, "39151": 8.08}',
    density: 72,
    imprecise: false,
    latitude: 40.7722,
    longitude: -81.68925,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44618',
  },
  {
    city: 'Damascus',
    county_fips: 39099,
    county_fips_all: '39099|39029',
    county: 'Mahoning',
    county_names_all: 'Mahoning|Columbiana',
    county_weights: '{"39099": 97.79, "39029": 2.21}',
    density: 206.9,
    imprecise: false,
    latitude: 40.90536,
    longitude: -80.95381,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44619',
  },
  {
    city: 'Dellroy',
    county_fips: 39019,
    county_fips_all: '39019',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"39019": 100}',
    density: 25.2,
    imprecise: false,
    latitude: 40.5811,
    longitude: -81.21592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44620',
  },
  {
    city: 'Dennison',
    county_fips: 39157,
    county_fips_all: '39157|39067|39019',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas|Harrison|Carroll',
    county_weights: '{"39157": 65.49, "39067": 19.03, "39019": 15.48}',
    density: 55,
    imprecise: false,
    latitude: 40.42878,
    longitude: -81.28955,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44621',
  },
  {
    city: 'Dover',
    county_fips: 39157,
    county_fips_all: '39157',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas',
    county_weights: '{"39157": 100}',
    density: 129.6,
    imprecise: false,
    latitude: 40.54883,
    longitude: -81.48375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44622',
  },
  {
    city: 'Dundee',
    county_fips: 39075,
    county_fips_all: '39075|39157|39169|39151',
    county: 'Holmes',
    county_names_all: 'Holmes|Tuscarawas|Wayne|Stark',
    county_weights:
      '{"39075": 44.2, "39157": 43.45, "39169": 10.78, "39151": 1.57}',
    density: 52.2,
    imprecise: false,
    latitude: 40.61249,
    longitude: -81.66157,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44624',
  },
  {
    city: 'East Rochester',
    county_fips: 39029,
    county_fips_all: '39029|39019',
    county: 'Columbiana',
    county_names_all: 'Columbiana|Carroll',
    county_weights: '{"39029": 77.99, "39019": 22.01}',
    density: 19.3,
    imprecise: false,
    latitude: 40.7623,
    longitude: -80.99919,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44625',
  },
  {
    city: 'East Sparta',
    county_fips: 39151,
    county_fips_all: '39151|39157',
    county: 'Stark',
    county_names_all: 'Stark|Tuscarawas',
    county_weights: '{"39151": 94.41, "39157": 5.59}',
    density: 36.3,
    imprecise: false,
    latitude: 40.68994,
    longitude: -81.38404,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44626',
  },
  {
    city: 'Fredericksburg',
    county_fips: 39075,
    county_fips_all: '39075|39169',
    county: 'Holmes',
    county_names_all: 'Holmes|Wayne',
    county_weights: '{"39075": 51.15, "39169": 48.85}',
    density: 57.6,
    imprecise: false,
    latitude: 40.66665,
    longitude: -81.83393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44627',
  },
  {
    city: 'Glenmont',
    county_fips: 39075,
    county_fips_all: '39075|39083',
    county: 'Holmes',
    county_names_all: 'Holmes|Knox',
    county_weights: '{"39075": 66.81, "39083": 33.19}',
    density: 12,
    imprecise: false,
    latitude: 40.538,
    longitude: -82.1551,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44628',
  },
  {
    city: 'Gnadenhutten',
    county_fips: 39157,
    county_fips_all: '39157',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas',
    county_weights: '{"39157": 100}',
    density: 50,
    imprecise: false,
    latitude: 40.35107,
    longitude: -81.44553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44629',
  },
  {
    city: 'Greentown',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.92695,
    longitude: -81.40408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44630',
  },
  {
    city: 'Hartville',
    county_fips: 39151,
    county_fips_all: '39151|39133',
    county: 'Stark',
    county_names_all: 'Stark|Portage',
    county_weights: '{"39151": 86.54, "39133": 13.46}',
    density: 150.2,
    imprecise: false,
    latitude: 40.96401,
    longitude: -81.3048,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44632',
  },
  {
    city: 'Holmesville',
    county_fips: 39075,
    county_fips_all: '39075',
    county: 'Holmes',
    county_names_all: 'Holmes',
    county_weights: '{"39075": 100}',
    density: 43.1,
    imprecise: false,
    latitude: 40.63182,
    longitude: -81.93601,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44633',
  },
  {
    city: 'Homeworth',
    county_fips: 39029,
    county_fips_all: '39029|39151',
    county: 'Columbiana',
    county_names_all: 'Columbiana|Stark',
    county_weights: '{"39029": 85.43, "39151": 14.57}',
    density: 39,
    imprecise: false,
    latitude: 40.83385,
    longitude: -81.04685,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44634',
  },
  {
    city: 'Killbuck',
    county_fips: 39075,
    county_fips_all: '39075|39031',
    county: 'Holmes',
    county_names_all: 'Holmes|Coshocton',
    county_weights: '{"39075": 78.46, "39031": 21.54}',
    density: 20,
    imprecise: false,
    latitude: 40.47996,
    longitude: -82.03347,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44637',
  },
  {
    city: 'Lakeville',
    county_fips: 39075,
    county_fips_all: '39075|39005|39169',
    county: 'Holmes',
    county_names_all: 'Holmes|Ashland|Wayne',
    county_weights: '{"39075": 62.43, "39005": 27.48, "39169": 10.09}',
    density: 19.1,
    imprecise: false,
    latitude: 40.6502,
    longitude: -82.13521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44638',
  },
  {
    city: 'Leesville',
    county_fips: 39019,
    county_fips_all: '39019',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"39019": 100}',
    density: 336.9,
    imprecise: false,
    latitude: 40.45166,
    longitude: -81.20963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44639',
  },
  {
    city: 'Limaville',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 181.8,
    imprecise: false,
    latitude: 40.98455,
    longitude: -81.14858,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44640',
  },
  {
    city: 'Louisville',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 140.9,
    imprecise: false,
    latitude: 40.86528,
    longitude: -81.23977,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44641',
  },
  {
    city: 'Magnolia',
    county_fips: 39019,
    county_fips_all: '39019|39151|39157',
    county: 'Carroll',
    county_names_all: 'Carroll|Stark|Tuscarawas',
    county_weights: '{"39019": 49.77, "39151": 36.54, "39157": 13.69}',
    density: 50.3,
    imprecise: false,
    latitude: 40.64304,
    longitude: -81.2998,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44643',
  },
  {
    city: 'Malvern',
    county_fips: 39019,
    county_fips_all: '39019',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"39019": 100}',
    density: 76.1,
    imprecise: false,
    latitude: 40.68691,
    longitude: -81.17639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44644',
  },
  {
    city: 'Marshallville',
    county_fips: 39169,
    county_fips_all: '39169|39151|39153',
    county: 'Wayne',
    county_names_all: 'Wayne|Stark|Summit',
    county_weights: '{"39169": 99.38, "39151": 0.34, "39153": 0.28}',
    density: 40.1,
    imprecise: false,
    latitude: 40.90796,
    longitude: -81.71845,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44645',
  },
  {
    city: 'Massillon',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 640.7,
    imprecise: false,
    latitude: 40.81055,
    longitude: -81.49835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 47741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44646',
  },
  {
    city: 'Massillon',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 242.1,
    imprecise: false,
    latitude: 40.79537,
    longitude: -81.56575,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44647',
  },
  {
    city: 'Mechanicstown',
    county_fips: 39019,
    county_fips_all: '39019',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"39019": 100}',
    density: 14,
    imprecise: false,
    latitude: 40.6231,
    longitude: -80.9556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44651',
  },
  {
    city: 'Middlebranch',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 1013.9,
    imprecise: false,
    latitude: 40.90088,
    longitude: -81.33015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44652',
  },
  {
    city: 'Midvale',
    county_fips: 39157,
    county_fips_all: '39157',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas',
    county_weights: '{"39157": 100}',
    density: 552.3,
    imprecise: false,
    latitude: 40.43711,
    longitude: -81.37105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44653',
  },
  {
    city: 'Millersburg',
    county_fips: 39075,
    county_fips_all: '39075|39031',
    county: 'Holmes',
    county_names_all: 'Holmes|Coshocton',
    county_weights: '{"39075": 93.88, "39031": 6.12}',
    density: 51.5,
    imprecise: false,
    latitude: 40.53861,
    longitude: -81.87162,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44654',
  },
  {
    city: 'Mineral City',
    county_fips: 39157,
    county_fips_all: '39157|39019',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas|Carroll',
    county_weights: '{"39157": 83.6, "39019": 16.4}',
    density: 24.7,
    imprecise: false,
    latitude: 40.57027,
    longitude: -81.33104,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44656',
  },
  {
    city: 'Minerva',
    county_fips: 39019,
    county_fips_all: '39019|39151|39029',
    county: 'Carroll',
    county_names_all: 'Carroll|Stark|Columbiana',
    county_weights: '{"39019": 36.47, "39151": 34.83, "39029": 28.69}',
    density: 58.8,
    imprecise: false,
    latitude: 40.74313,
    longitude: -81.09343,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44657',
  },
  {
    city: 'Mount Eaton',
    county_fips: 39169,
    county_fips_all: '39169',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"39169": 100}',
    density: 285.6,
    imprecise: false,
    latitude: 40.6948,
    longitude: -81.70191,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44659',
  },
  {
    city: 'Mount Hope',
    county_fips: 39075,
    county_fips_all: '39075',
    county: 'Holmes',
    county_names_all: 'Holmes',
    county_weights: '{"39075": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 40.62382,
    longitude: -81.77487,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44660',
  },
  {
    city: 'Nashville',
    county_fips: 39075,
    county_fips_all: '39075',
    county: 'Holmes',
    county_names_all: 'Holmes',
    county_weights: '{"39075": 100}',
    density: 258.9,
    imprecise: false,
    latitude: 40.5874,
    longitude: -82.11662,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44661',
  },
  {
    city: 'Navarre',
    county_fips: 39151,
    county_fips_all: '39151|39169',
    county: 'Stark',
    county_names_all: 'Stark|Wayne',
    county_weights: '{"39151": 90.17, "39169": 9.83}',
    density: 69.3,
    imprecise: false,
    latitude: 40.71036,
    longitude: -81.55468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44662',
  },
  {
    city: 'New Philadelphia',
    county_fips: 39157,
    county_fips_all: '39157',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas',
    county_weights: '{"39157": 100}',
    density: 97.7,
    imprecise: false,
    latitude: 40.46066,
    longitude: -81.44961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44663',
  },
  {
    city: 'North Georgetown',
    county_fips: 39029,
    county_fips_all: '39029',
    county: 'Columbiana',
    county_names_all: 'Columbiana',
    county_weights: '{"39029": 100}',
    density: 75.4,
    imprecise: false,
    latitude: 40.83555,
    longitude: -80.98706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44665',
  },
  {
    city: 'North Lawrence',
    county_fips: 39151,
    county_fips_all: '39151|39169',
    county: 'Stark',
    county_names_all: 'Stark|Wayne',
    county_weights: '{"39151": 71.29, "39169": 28.71}',
    density: 53.4,
    imprecise: false,
    latitude: 40.84232,
    longitude: -81.63202,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44666',
  },
  {
    city: 'Orrville',
    county_fips: 39169,
    county_fips_all: '39169',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"39169": 100}',
    density: 114.7,
    imprecise: false,
    latitude: 40.83386,
    longitude: -81.76495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44667',
  },
  {
    city: 'Paris',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 38.1,
    imprecise: false,
    latitude: 40.79613,
    longitude: -81.15619,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44669',
  },
  {
    city: 'Robertsville',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 624,
    imprecise: false,
    latitude: 40.76305,
    longitude: -81.18788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44670',
  },
  {
    city: 'Sandyville',
    county_fips: 39157,
    county_fips_all: '39157',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas',
    county_weights: '{"39157": 100}',
    density: 51.9,
    imprecise: false,
    latitude: 40.64511,
    longitude: -81.36565,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44671',
  },
  {
    city: 'Sebring',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 568,
    imprecise: false,
    latitude: 40.92045,
    longitude: -81.02375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44672',
  },
  {
    city: 'Sherrodsville',
    county_fips: 39019,
    county_fips_all: '39019|39157',
    county: 'Carroll',
    county_names_all: 'Carroll|Tuscarawas',
    county_weights: '{"39019": 70.75, "39157": 29.25}',
    density: 31.2,
    imprecise: false,
    latitude: 40.50245,
    longitude: -81.24975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44675',
  },
  {
    city: 'Shreve',
    county_fips: 39169,
    county_fips_all: '39169|39075',
    county: 'Wayne',
    county_names_all: 'Wayne|Holmes',
    county_weights: '{"39169": 73.16, "39075": 26.84}',
    density: 34.1,
    imprecise: false,
    latitude: 40.6891,
    longitude: -82.03266,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44676',
  },
  {
    city: 'Smithville',
    county_fips: 39169,
    county_fips_all: '39169',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"39169": 100}',
    density: 62.1,
    imprecise: false,
    latitude: 40.87254,
    longitude: -81.85983,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44677',
  },
  {
    city: 'Somerdale',
    county_fips: 39157,
    county_fips_all: '39157',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas',
    county_weights: '{"39157": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 40.56478,
    longitude: -81.36408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44678',
  },
  {
    city: 'Strasburg',
    county_fips: 39157,
    county_fips_all: '39157',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas',
    county_weights: '{"39157": 100}',
    density: 83.2,
    imprecise: false,
    latitude: 40.60174,
    longitude: -81.54512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44680',
  },
  {
    city: 'Sugarcreek',
    county_fips: 39157,
    county_fips_all: '39157|39075',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas|Holmes',
    county_weights: '{"39157": 58.88, "39075": 41.12}',
    density: 63.1,
    imprecise: false,
    latitude: 40.50018,
    longitude: -81.6625,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44681',
  },
  {
    city: 'Tuscarawas',
    county_fips: 39157,
    county_fips_all: '39157',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas',
    county_weights: '{"39157": 100}',
    density: 1115.5,
    imprecise: false,
    latitude: 40.39765,
    longitude: -81.40323,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44682',
  },
  {
    city: 'Uhrichsville',
    county_fips: 39157,
    county_fips_all: '39157|39067',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas|Harrison',
    county_weights: '{"39157": 74.89, "39067": 25.11}',
    density: 46.4,
    imprecise: false,
    latitude: 40.35505,
    longitude: -81.3218,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44683',
  },
  {
    city: 'Uniontown',
    county_fips: 39153,
    county_fips_all: '39153|39151',
    county: 'Summit',
    county_names_all: 'Summit|Stark',
    county_weights: '{"39153": 51.59, "39151": 48.41}',
    density: 434.8,
    imprecise: false,
    latitude: 40.9596,
    longitude: -81.42361,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44685',
  },
  {
    city: 'Walnut Creek',
    county_fips: 39075,
    county_fips_all: '39075',
    county: 'Holmes',
    county_names_all: 'Holmes',
    county_weights: '{"39075": 100}',
    density: 245,
    imprecise: false,
    latitude: 40.53941,
    longitude: -81.71189,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44687',
  },
  {
    city: 'Waynesburg',
    county_fips: 39151,
    county_fips_all: '39151|39019',
    county: 'Stark',
    county_names_all: 'Stark|Carroll',
    county_weights: '{"39151": 70.29, "39019": 29.71}',
    density: 46.5,
    imprecise: false,
    latitude: 40.68458,
    longitude: -81.25757,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44688',
  },
  {
    city: 'Wilmot',
    county_fips: 39075,
    county_fips_all: '39075|39151',
    county: 'Holmes',
    county_names_all: 'Holmes|Stark',
    county_weights: '{"39075": 86.25, "39151": 13.75}',
    density: 58,
    imprecise: false,
    latitude: 40.65071,
    longitude: -81.66209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44689',
  },
  {
    city: 'Winesburg',
    county_fips: 39075,
    county_fips_all: '39075',
    county: 'Holmes',
    county_names_all: 'Holmes',
    county_weights: '{"39075": 100}',
    density: 101.5,
    imprecise: false,
    latitude: 40.61353,
    longitude: -81.69391,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44690',
  },
  {
    city: 'Wooster',
    county_fips: 39169,
    county_fips_all: '39169|39005',
    county: 'Wayne',
    county_names_all: 'Wayne|Ashland',
    county_weights: '{"39169": 99.53, "39005": 0.47}',
    density: 110.5,
    imprecise: false,
    latitude: 40.80714,
    longitude: -81.97971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 44344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44691',
  },
  {
    city: 'Deersville',
    county_fips: 39067,
    county_fips_all: '39067',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"39067": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 40.2978,
    longitude: -81.18821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44693',
  },
  {
    city: 'Bowerston',
    county_fips: 39019,
    county_fips_all: '39019|39067',
    county: 'Carroll',
    county_names_all: 'Carroll|Harrison',
    county_weights: '{"39019": 58.87, "39067": 41.13}',
    density: 16.8,
    imprecise: false,
    latitude: 40.43868,
    longitude: -81.1754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44695',
  },
  {
    city: 'Zoar',
    county_fips: 39157,
    county_fips_all: '39157',
    county: 'Tuscarawas',
    county_names_all: 'Tuscarawas',
    county_weights: '{"39157": 100}',
    density: 66.8,
    imprecise: false,
    latitude: 40.60807,
    longitude: -81.41175,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44697',
  },
  {
    city: 'Tippecanoe',
    county_fips: 39067,
    county_fips_all: '39067|39157',
    county: 'Harrison',
    county_names_all: 'Harrison|Tuscarawas',
    county_weights: '{"39067": 72.45, "39157": 27.55}',
    density: 4.9,
    imprecise: false,
    latitude: 40.27789,
    longitude: -81.28752,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44699',
  },
  {
    city: 'Canton',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 662,
    imprecise: false,
    latitude: 40.79992,
    longitude: -81.37665,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44702',
  },
  {
    city: 'Canton',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 2944.1,
    imprecise: false,
    latitude: 40.81093,
    longitude: -81.38134,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44703',
  },
  {
    city: 'Canton',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 692.3,
    imprecise: false,
    latitude: 40.80001,
    longitude: -81.34329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44704',
  },
  {
    city: 'Canton',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 819.7,
    imprecise: false,
    latitude: 40.83347,
    longitude: -81.3327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44705',
  },
  {
    city: 'Canton',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 338.5,
    imprecise: false,
    latitude: 40.75382,
    longitude: -81.4198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44706',
  },
  {
    city: 'Canton',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 228,
    imprecise: false,
    latitude: 40.76031,
    longitude: -81.34715,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44707',
  },
  {
    city: 'Canton',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 931.7,
    imprecise: false,
    latitude: 40.81708,
    longitude: -81.43486,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44708',
  },
  {
    city: 'Canton',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 1237.7,
    imprecise: false,
    latitude: 40.84218,
    longitude: -81.38634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44709',
  },
  {
    city: 'Canton',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 1589.4,
    imprecise: false,
    latitude: 40.78962,
    longitude: -81.42659,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44710',
  },
  {
    city: 'Canton',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 1512.5,
    imprecise: false,
    latitude: 40.83606,
    longitude: -81.35905,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44714',
  },
  {
    city: 'Canton',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 577.2,
    imprecise: false,
    latitude: 40.85122,
    longitude: -81.44806,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44718',
  },
  {
    city: 'North Canton',
    county_fips: 39151,
    county_fips_all: '39151|39153',
    county: 'Stark',
    county_names_all: 'Stark|Summit',
    county_weights: '{"39151": 72.22, "39153": 27.78}',
    density: 448.1,
    imprecise: false,
    latitude: 40.90112,
    longitude: -81.43259,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44720',
  },
  {
    city: 'Canton',
    county_fips: 39151,
    county_fips_all: '39151',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"39151": 100}',
    density: 347.1,
    imprecise: false,
    latitude: 40.89443,
    longitude: -81.32694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44721',
  },
  {
    city: 'East Canton',
    county_fips: 39151,
    county_fips_all: '39151|39019',
    county: 'Stark',
    county_names_all: 'Stark|Carroll',
    county_weights: '{"39151": 96.87, "39019": 3.13}',
    density: 64.4,
    imprecise: false,
    latitude: 40.76706,
    longitude: -81.25814,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44730',
  },
  {
    city: 'Alvada',
    county_fips: 39147,
    county_fips_all: '39147|39063',
    county: 'Seneca',
    county_names_all: 'Seneca|Hancock',
    county_weights: '{"39147": 50.93, "39063": 49.07}',
    density: 10.4,
    imprecise: false,
    latitude: 41.04534,
    longitude: -83.41912,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44802',
  },
  {
    city: 'Arcadia',
    county_fips: 39063,
    county_fips_all: '39063',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"39063": 100}',
    density: 35,
    imprecise: false,
    latitude: 41.10708,
    longitude: -83.53538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44804',
  },
  {
    city: 'Ashland',
    county_fips: 39005,
    county_fips_all: '39005|39139',
    county: 'Ashland',
    county_names_all: 'Ashland|Richland',
    county_weights: '{"39005": 94.9, "39139": 5.1}',
    density: 78.7,
    imprecise: false,
    latitude: 40.87335,
    longitude: -82.32096,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44805',
  },
  {
    city: 'Attica',
    county_fips: 39147,
    county_fips_all: '39147|39077',
    county: 'Seneca',
    county_names_all: 'Seneca|Huron',
    county_weights: '{"39147": 80.04, "39077": 19.96}',
    density: 12.4,
    imprecise: false,
    latitude: 41.06508,
    longitude: -82.87533,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44807',
  },
  {
    city: 'Bascom',
    county_fips: 39147,
    county_fips_all: '39147',
    county: 'Seneca',
    county_names_all: 'Seneca',
    county_weights: '{"39147": 100}',
    density: 80.6,
    imprecise: false,
    latitude: 41.13215,
    longitude: -83.29391,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44809',
  },
  {
    city: 'Bellevue',
    county_fips: 39077,
    county_fips_all: '39077|39147|39143|39043',
    county: 'Huron',
    county_names_all: 'Huron|Seneca|Sandusky|Erie',
    county_weights:
      '{"39077": 33.25, "39147": 32.81, "39143": 19.44, "39043": 14.5}',
    density: 41.4,
    imprecise: false,
    latitude: 41.24445,
    longitude: -82.84474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44811',
  },
  {
    city: 'Bellville',
    county_fips: 39139,
    county_fips_all: '39139|39117|39083',
    county: 'Richland',
    county_names_all: 'Richland|Morrow|Knox',
    county_weights: '{"39139": 86.15, "39117": 9.01, "39083": 4.84}',
    density: 50.9,
    imprecise: false,
    latitude: 40.60135,
    longitude: -82.52814,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44813',
  },
  {
    city: 'Berlin Heights',
    county_fips: 39043,
    county_fips_all: '39043',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"39043": 100}',
    density: 35.8,
    imprecise: false,
    latitude: 41.32162,
    longitude: -82.4714,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44814',
  },
  {
    city: 'Bettsville',
    county_fips: 39147,
    county_fips_all: '39147',
    county: 'Seneca',
    county_names_all: 'Seneca',
    county_weights: '{"39147": 100}',
    density: 240.9,
    imprecise: false,
    latitude: 41.24697,
    longitude: -83.23947,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44815',
  },
  {
    city: 'Bloomdale',
    county_fips: 39173,
    county_fips_all: '39173|39063',
    county: 'Wood',
    county_names_all: 'Wood|Hancock',
    county_weights: '{"39173": 85.35, "39063": 14.65}',
    density: 18.8,
    imprecise: false,
    latitude: 41.1987,
    longitude: -83.54676,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44817',
  },
  {
    city: 'Bloomville',
    county_fips: 39147,
    county_fips_all: '39147|39033',
    county: 'Seneca',
    county_names_all: 'Seneca|Crawford',
    county_weights: '{"39147": 50.53, "39033": 49.47}',
    density: 10.2,
    imprecise: false,
    latitude: 41.0002,
    longitude: -82.99645,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44818',
  },
  {
    city: 'Bucyrus',
    county_fips: 39033,
    county_fips_all: '39033|39175',
    county: 'Crawford',
    county_names_all: 'Crawford|Wyandot',
    county_weights: '{"39033": 99.47, "39175": 0.53}',
    density: 41.6,
    imprecise: false,
    latitude: 40.81829,
    longitude: -82.97186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44820',
  },
  {
    city: 'Butler',
    county_fips: 39139,
    county_fips_all: '39139|39083',
    county: 'Richland',
    county_names_all: 'Richland|Knox',
    county_weights: '{"39139": 58.88, "39083": 41.12}',
    density: 33.8,
    imprecise: false,
    latitude: 40.55705,
    longitude: -82.39929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44822',
  },
  {
    city: 'Castalia',
    county_fips: 39043,
    county_fips_all: '39043|39143',
    county: 'Erie',
    county_names_all: 'Erie|Sandusky',
    county_weights: '{"39043": 94.28, "39143": 5.72}',
    density: 56,
    imprecise: false,
    latitude: 41.37952,
    longitude: -82.80422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44824',
  },
  {
    city: 'Chatfield',
    county_fips: 39033,
    county_fips_all: '39033',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"39033": 100}',
    density: 495.8,
    imprecise: false,
    latitude: 40.95443,
    longitude: -82.94194,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44825',
  },
  {
    city: 'Collins',
    county_fips: 39077,
    county_fips_all: '39077|39043',
    county: 'Huron',
    county_names_all: 'Huron|Erie',
    county_weights: '{"39077": 90.38, "39043": 9.62}',
    density: 14.4,
    imprecise: false,
    latitude: 41.23993,
    longitude: -82.47931,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44826',
  },
  {
    city: 'Crestline',
    county_fips: 39033,
    county_fips_all: '39033|39139',
    county: 'Crawford',
    county_names_all: 'Crawford|Richland',
    county_weights: '{"39033": 78.14, "39139": 21.86}',
    density: 55.7,
    imprecise: false,
    latitude: 40.81921,
    longitude: -82.75923,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44827',
  },
  {
    city: 'Flat Rock',
    county_fips: 39147,
    county_fips_all: '39147',
    county: 'Seneca',
    county_names_all: 'Seneca',
    county_weights: '{"39147": 100}',
    density: 314.4,
    imprecise: false,
    latitude: 41.23367,
    longitude: -82.85957,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44828',
  },
  {
    city: 'Fostoria',
    county_fips: 39147,
    county_fips_all: '39147|39063|39173',
    county: 'Seneca',
    county_names_all: 'Seneca|Hancock|Wood',
    county_weights: '{"39147": 58.86, "39063": 22.2, "39173": 18.94}',
    density: 60.9,
    imprecise: false,
    latitude: 41.16603,
    longitude: -83.40081,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44830',
  },
  {
    city: 'Galion',
    county_fips: 39117,
    county_fips_all: '39117|39033|39139|39101',
    county: 'Morrow',
    county_names_all: 'Morrow|Crawford|Richland|Marion',
    county_weights:
      '{"39117": 43.67, "39033": 42.52, "39139": 8.31, "39101": 5.51}',
    density: 67.9,
    imprecise: false,
    latitude: 40.71059,
    longitude: -82.79484,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44833',
  },
  {
    city: 'Green Springs',
    county_fips: 39147,
    county_fips_all: '39147|39143',
    county: 'Seneca',
    county_names_all: 'Seneca|Sandusky',
    county_weights: '{"39147": 82.08, "39143": 17.92}',
    density: 27,
    imprecise: false,
    latitude: 41.23772,
    longitude: -83.05455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44836',
  },
  {
    city: 'Greenwich',
    county_fips: 39077,
    county_fips_all: '39077|39005|39139',
    county: 'Huron',
    county_names_all: 'Huron|Ashland|Richland',
    county_weights: '{"39077": 64.54, "39005": 18.59, "39139": 16.87}',
    density: 27.4,
    imprecise: false,
    latitude: 41.01745,
    longitude: -82.48241,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44837',
  },
  {
    city: 'Hayesville',
    county_fips: 39005,
    county_fips_all: '39005',
    county: 'Ashland',
    county_names_all: 'Ashland',
    county_weights: '{"39005": 100}',
    density: 301.1,
    imprecise: false,
    latitude: 40.77186,
    longitude: -82.25947,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44838',
  },
  {
    city: 'Huron',
    county_fips: 39043,
    county_fips_all: '39043',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"39043": 100}',
    density: 133.2,
    imprecise: false,
    latitude: 41.3725,
    longitude: -82.55656,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44839',
  },
  {
    city: 'Jeromesville',
    county_fips: 39005,
    county_fips_all: '39005|39169',
    county: 'Ashland',
    county_names_all: 'Ashland|Wayne',
    county_weights: '{"39005": 99.77, "39169": 0.23}',
    density: 29,
    imprecise: false,
    latitude: 40.79231,
    longitude: -82.17973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44840',
  },
  {
    city: 'Kansas',
    county_fips: 39147,
    county_fips_all: '39147|39143',
    county: 'Seneca',
    county_names_all: 'Seneca|Sandusky',
    county_weights: '{"39147": 55.1, "39143": 44.9}',
    density: 9.7,
    imprecise: false,
    latitude: 41.25126,
    longitude: -83.31139,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44841',
  },
  {
    city: 'Loudonville',
    county_fips: 39005,
    county_fips_all: '39005|39075|39083',
    county: 'Ashland',
    county_names_all: 'Ashland|Holmes|Knox',
    county_weights: '{"39005": 71.02, "39075": 26.71, "39083": 2.27}',
    density: 28.2,
    imprecise: false,
    latitude: 40.64903,
    longitude: -82.22498,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44842',
  },
  {
    city: 'Lucas',
    county_fips: 39139,
    county_fips_all: '39139|39005',
    county: 'Richland',
    county_names_all: 'Richland|Ashland',
    county_weights: '{"39139": 96.8, "39005": 3.2}',
    density: 34.5,
    imprecise: false,
    latitude: 40.6886,
    longitude: -82.40959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44843',
  },
  {
    city: 'McCutchenville',
    county_fips: 39147,
    county_fips_all: '39147|39175',
    county: 'Seneca',
    county_names_all: 'Seneca|Wyandot',
    county_weights: '{"39147": 52.37, "39175": 47.63}',
    density: 15.6,
    imprecise: false,
    latitude: 40.9926,
    longitude: -83.25839,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44844',
  },
  {
    city: 'Milan',
    county_fips: 39043,
    county_fips_all: '39043|39077',
    county: 'Erie',
    county_names_all: 'Erie|Huron',
    county_weights: '{"39043": 97.24, "39077": 2.76}',
    density: 60.3,
    imprecise: false,
    latitude: 41.31589,
    longitude: -82.60832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44846',
  },
  {
    city: 'Monroeville',
    county_fips: 39077,
    county_fips_all: '39077|39043',
    county: 'Huron',
    county_names_all: 'Huron|Erie',
    county_weights: '{"39077": 76.24, "39043": 23.76}',
    density: 19.9,
    imprecise: false,
    latitude: 41.23025,
    longitude: -82.70821,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44847',
  },
  {
    city: 'Nevada',
    county_fips: 39175,
    county_fips_all: '39175|39033|39101',
    county: 'Wyandot',
    county_names_all: 'Wyandot|Crawford|Marion',
    county_weights: '{"39175": 73.19, "39033": 23.53, "39101": 3.28}',
    density: 16.8,
    imprecise: false,
    latitude: 40.80863,
    longitude: -83.13186,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44849',
  },
  {
    city: 'New Haven',
    county_fips: 39077,
    county_fips_all: '39077',
    county: 'Huron',
    county_names_all: 'Huron',
    county_weights: '{"39077": 100}',
    density: 158,
    imprecise: false,
    latitude: 41.03539,
    longitude: -82.68403,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44850',
  },
  {
    city: 'New London',
    county_fips: 39077,
    county_fips_all: '39077|39093|39005',
    county: 'Huron',
    county_names_all: 'Huron|Lorain|Ashland',
    county_weights: '{"39077": 72.79, "39093": 18.72, "39005": 8.49}',
    density: 25.6,
    imprecise: false,
    latitude: 41.10577,
    longitude: -82.40166,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44851',
  },
  {
    city: 'New Riegel',
    county_fips: 39147,
    county_fips_all: '39147',
    county: 'Seneca',
    county_names_all: 'Seneca',
    county_weights: '{"39147": 100}',
    density: 19.7,
    imprecise: false,
    latitude: 41.05501,
    longitude: -83.30399,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44853',
  },
  {
    city: 'New Washington',
    county_fips: 39033,
    county_fips_all: '39033|39147',
    county: 'Crawford',
    county_names_all: 'Crawford|Seneca',
    county_weights: '{"39033": 92.76, "39147": 7.24}',
    density: 15.4,
    imprecise: false,
    latitude: 40.94723,
    longitude: -82.85748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44854',
  },
  {
    city: 'North Fairfield',
    county_fips: 39077,
    county_fips_all: '39077',
    county: 'Huron',
    county_names_all: 'Huron',
    county_weights: '{"39077": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 41.10414,
    longitude: -82.58664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44855',
  },
  {
    city: 'North Robinson',
    county_fips: 39033,
    county_fips_all: '39033',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"39033": 100}',
    density: 629,
    imprecise: false,
    latitude: 40.79398,
    longitude: -82.85627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44856',
  },
  {
    city: 'Norwalk',
    county_fips: 39077,
    county_fips_all: '39077|39043',
    county: 'Huron',
    county_names_all: 'Huron|Erie',
    county_weights: '{"39077": 97.43, "39043": 2.57}',
    density: 110.2,
    imprecise: false,
    latitude: 41.21785,
    longitude: -82.58212,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44857',
  },
  {
    city: 'Nova',
    county_fips: 39005,
    county_fips_all: '39005|39093',
    county: 'Ashland',
    county_names_all: 'Ashland|Lorain',
    county_weights: '{"39005": 96.49, "39093": 3.51}',
    density: 24.7,
    imprecise: false,
    latitude: 41.02103,
    longitude: -82.32636,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44859',
  },
  {
    city: 'Old Fort',
    county_fips: 39147,
    county_fips_all: '39147',
    county: 'Seneca',
    county_names_all: 'Seneca',
    county_weights: '{"39147": 100}',
    density: 56.2,
    imprecise: false,
    latitude: 41.24254,
    longitude: -83.14626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44861',
  },
  {
    city: 'Perrysville',
    county_fips: 39005,
    county_fips_all: '39005|39139',
    county: 'Ashland',
    county_names_all: 'Ashland|Richland',
    county_weights: '{"39005": 73.91, "39139": 26.09}',
    density: 21.6,
    imprecise: false,
    latitude: 40.66748,
    longitude: -82.31871,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44864',
  },
  {
    city: 'Plymouth',
    county_fips: 39077,
    county_fips_all: '39077|39139|39033',
    county: 'Huron',
    county_names_all: 'Huron|Richland|Crawford',
    county_weights: '{"39077": 46.09, "39139": 44.15, "39033": 9.76}',
    density: 33.1,
    imprecise: false,
    latitude: 40.99165,
    longitude: -82.68168,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44865',
  },
  {
    city: 'Polk',
    county_fips: 39005,
    county_fips_all: '39005',
    county: 'Ashland',
    county_names_all: 'Ashland',
    county_weights: '{"39005": 100}',
    density: 29.7,
    imprecise: false,
    latitude: 40.92082,
    longitude: -82.19483,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44866',
  },
  {
    city: 'Republic',
    county_fips: 39147,
    county_fips_all: '39147',
    county: 'Seneca',
    county_names_all: 'Seneca',
    county_weights: '{"39147": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 41.14755,
    longitude: -82.98963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44867',
  },
  {
    city: 'Sandusky',
    county_fips: 39043,
    county_fips_all: '39043',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"39043": 100}',
    density: 253.5,
    imprecise: false,
    latitude: 41.40623,
    longitude: -82.7171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44870',
  },
  {
    city: 'Savannah',
    county_fips: 39005,
    county_fips_all: '39005',
    county: 'Ashland',
    county_names_all: 'Ashland',
    county_weights: '{"39005": 100}',
    density: 238.8,
    imprecise: false,
    latitude: 40.96859,
    longitude: -82.36631,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44874',
  },
  {
    city: 'Shelby',
    county_fips: 39139,
    county_fips_all: '39139|39033',
    county: 'Richland',
    county_names_all: 'Richland|Crawford',
    county_weights: '{"39139": 93.17, "39033": 6.83}',
    density: 67,
    imprecise: false,
    latitude: 40.88645,
    longitude: -82.6489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44875',
  },
  {
    city: 'Shiloh',
    county_fips: 39139,
    county_fips_all: '39139|39077|39005',
    county: 'Richland',
    county_names_all: 'Richland|Huron|Ashland',
    county_weights: '{"39139": 89.82, "39077": 5.86, "39005": 4.32}',
    density: 18.1,
    imprecise: false,
    latitude: 40.95111,
    longitude: -82.51963,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44878',
  },
  {
    city: 'Sullivan',
    county_fips: 39005,
    county_fips_all: '39005|39093|39103',
    county: 'Ashland',
    county_names_all: 'Ashland|Lorain|Medina',
    county_weights: '{"39005": 86.05, "39093": 12.32, "39103": 1.63}',
    density: 40.3,
    imprecise: false,
    latitude: 41.03352,
    longitude: -82.21993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44880',
  },
  {
    city: 'Sulphur Springs',
    county_fips: 39033,
    county_fips_all: '39033',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"39033": 100}',
    density: 1328.8,
    imprecise: false,
    latitude: 40.8703,
    longitude: -82.87687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44881',
  },
  {
    city: 'Sycamore',
    county_fips: 39175,
    county_fips_all: '39175|39033|39147',
    county: 'Wyandot',
    county_names_all: 'Wyandot|Crawford|Seneca',
    county_weights: '{"39175": 57.82, "39033": 32.85, "39147": 9.33}',
    density: 11.5,
    imprecise: false,
    latitude: 40.94759,
    longitude: -83.13734,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44882',
  },
  {
    city: 'Tiffin',
    county_fips: 39147,
    county_fips_all: '39147',
    county: 'Seneca',
    county_names_all: 'Seneca',
    county_weights: '{"39147": 100}',
    density: 65.8,
    imprecise: false,
    latitude: 41.12395,
    longitude: -83.17459,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44883',
  },
  {
    city: 'Tiro',
    county_fips: 39033,
    county_fips_all: '39033',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"39033": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 40.9205,
    longitude: -82.788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44887',
  },
  {
    city: 'Wakeman',
    county_fips: 39077,
    county_fips_all: '39077|39043|39093',
    county: 'Huron',
    county_names_all: 'Huron|Erie|Lorain',
    county_weights: '{"39077": 63.9, "39043": 23.08, "39093": 13.02}',
    density: 37.8,
    imprecise: false,
    latitude: 41.24661,
    longitude: -82.38195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44889',
  },
  {
    city: 'Willard',
    county_fips: 39077,
    county_fips_all: '39077',
    county: 'Huron',
    county_names_all: 'Huron',
    county_weights: '{"39077": 100}',
    density: 47.3,
    imprecise: false,
    latitude: 41.0818,
    longitude: -82.71248,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44890',
  },
  {
    city: 'Mansfield',
    county_fips: 39139,
    county_fips_all: '39139',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"39139": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.76391,
    longitude: -82.51247,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44901',
  },
  {
    city: 'Mansfield',
    county_fips: 39139,
    county_fips_all: '39139',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"39139": 100}',
    density: 914.1,
    imprecise: false,
    latitude: 40.7589,
    longitude: -82.51095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44902',
  },
  {
    city: 'Mansfield',
    county_fips: 39139,
    county_fips_all: '39139|39117|39005',
    county: 'Richland',
    county_names_all: 'Richland|Morrow|Ashland',
    county_weights: '{"39139": 95.02, "39117": 3.83, "39005": 1.15}',
    density: 86.8,
    imprecise: false,
    latitude: 40.77624,
    longitude: -82.52655,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44903',
  },
  {
    city: 'Mansfield',
    county_fips: 39139,
    county_fips_all: '39139|39117',
    county: 'Richland',
    county_names_all: 'Richland|Morrow',
    county_weights: '{"39139": 62.25, "39117": 37.75}',
    density: 99.9,
    imprecise: false,
    latitude: 40.66578,
    longitude: -82.61505,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44904',
  },
  {
    city: 'Mansfield',
    county_fips: 39139,
    county_fips_all: '39139',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"39139": 100}',
    density: 488.9,
    imprecise: false,
    latitude: 40.77753,
    longitude: -82.46915,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44905',
  },
  {
    city: 'Mansfield',
    county_fips: 39139,
    county_fips_all: '39139',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"39139": 100}',
    density: 343.8,
    imprecise: false,
    latitude: 40.76413,
    longitude: -82.57778,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44906',
  },
  {
    city: 'Mansfield',
    county_fips: 39139,
    county_fips_all: '39139',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"39139": 100}',
    density: 810.8,
    imprecise: false,
    latitude: 40.72761,
    longitude: -82.52129,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44907',
  },
  {
    city: 'Addyston',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 410.2,
    imprecise: false,
    latitude: 39.13713,
    longitude: -84.71045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45001',
  },
  {
    city: 'Cleves',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 232.1,
    imprecise: false,
    latitude: 39.19871,
    longitude: -84.73422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45002',
  },
  {
    city: 'College Corner',
    county_fips: 39135,
    county_fips_all: '39135|39017',
    county: 'Preble',
    county_names_all: 'Preble|Butler',
    county_weights: '{"39135": 82.25, "39017": 17.75}',
    density: 21.3,
    imprecise: false,
    latitude: 39.58427,
    longitude: -84.77942,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45003',
  },
  {
    city: 'Franklin',
    county_fips: 39165,
    county_fips_all: '39165|39113',
    county: 'Warren',
    county_names_all: 'Warren|Montgomery',
    county_weights: '{"39165": 99.4, "39113": 0.6}',
    density: 339.9,
    imprecise: false,
    latitude: 39.53478,
    longitude: -84.3018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45005',
  },
  {
    city: 'Hamilton',
    county_fips: 39017,
    county_fips_all: '39017',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"39017": 100}',
    density: 485,
    imprecise: false,
    latitude: 39.42892,
    longitude: -84.50173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 75864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45011',
  },
  {
    city: 'Hamilton',
    county_fips: 39017,
    county_fips_all: '39017|39061',
    county: 'Butler',
    county_names_all: 'Butler|Hamilton',
    county_weights: '{"39017": 96.75, "39061": 3.25}',
    density: 177.2,
    imprecise: false,
    latitude: 39.40649,
    longitude: -84.6501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 53998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45013',
  },
  {
    city: 'Fairfield',
    county_fips: 39017,
    county_fips_all: '39017',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"39017": 100}',
    density: 782.3,
    imprecise: false,
    latitude: 39.32822,
    longitude: -84.5521,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45014',
  },
  {
    city: 'Hamilton',
    county_fips: 39017,
    county_fips_all: '39017',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"39017": 100}',
    density: 756.8,
    imprecise: false,
    latitude: 39.36273,
    longitude: -84.53785,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45015',
  },
  {
    city: 'Harrison',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 208.1,
    imprecise: false,
    latitude: 39.25621,
    longitude: -84.76287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45030',
  },
  {
    city: 'Harveysburg',
    county_fips: 39165,
    county_fips_all: '39165',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"39165": 100}',
    density: 727.4,
    imprecise: false,
    latitude: 39.50268,
    longitude: -84.00811,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45032',
  },
  {
    city: 'Hooven',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 460,
    imprecise: false,
    latitude: 39.17962,
    longitude: -84.76469,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45033',
  },
  {
    city: 'Kings Mills',
    county_fips: 39165,
    county_fips_all: '39165',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"39165": 100}',
    density: 499.3,
    imprecise: false,
    latitude: 39.35749,
    longitude: -84.24687,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45034',
  },
  {
    city: 'Lebanon',
    county_fips: 39165,
    county_fips_all: '39165',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"39165": 100}',
    density: 200.8,
    imprecise: false,
    latitude: 39.44487,
    longitude: -84.21832,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 42204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45036',
  },
  {
    city: 'Maineville',
    county_fips: 39165,
    county_fips_all: '39165',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"39165": 100}',
    density: 703.3,
    imprecise: false,
    latitude: 39.32655,
    longitude: -84.23586,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45039',
  },
  {
    city: 'Mason',
    county_fips: 39165,
    county_fips_all: '39165',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"39165": 100}',
    density: 807.7,
    imprecise: false,
    latitude: 39.35023,
    longitude: -84.30996,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 59518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45040',
  },
  {
    city: 'Miamitown',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 253.4,
    imprecise: false,
    latitude: 39.21114,
    longitude: -84.70292,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45041',
  },
  {
    city: 'Middletown',
    county_fips: 39017,
    county_fips_all: '39017|39135|39113|39165',
    county: 'Butler',
    county_names_all: 'Butler|Preble|Montgomery|Warren',
    county_weights:
      '{"39017": 91.96, "39135": 6.5, "39113": 0.85, "39165": 0.69}',
    density: 217.1,
    imprecise: false,
    latitude: 39.54867,
    longitude: -84.43755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45042',
  },
  {
    city: 'Middletown',
    county_fips: 39017,
    county_fips_all: '39017|39165',
    county: 'Butler',
    county_names_all: 'Butler|Warren',
    county_weights: '{"39017": 92.16, "39165": 7.84}',
    density: 574.3,
    imprecise: false,
    latitude: 39.45028,
    longitude: -84.37988,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45044',
  },
  {
    city: 'Monroe',
    county_fips: 39017,
    county_fips_all: '39017|39165',
    county: 'Butler',
    county_names_all: 'Butler|Warren',
    county_weights: '{"39017": 82.81, "39165": 17.19}',
    density: 561.2,
    imprecise: false,
    latitude: 39.44437,
    longitude: -84.36594,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45050',
  },
  {
    city: 'North Bend',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 123.3,
    imprecise: false,
    latitude: 39.14505,
    longitude: -84.77849,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45052',
  },
  {
    city: 'Okeana',
    county_fips: 39017,
    county_fips_all: '39017',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"39017": 100}',
    density: 52.7,
    imprecise: false,
    latitude: 39.35273,
    longitude: -84.78053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45053',
  },
  {
    city: 'Oregonia',
    county_fips: 39165,
    county_fips_all: '39165',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"39165": 100}',
    density: 33.4,
    imprecise: false,
    latitude: 39.43844,
    longitude: -84.07418,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45054',
  },
  {
    city: 'Overpeck',
    county_fips: 39017,
    county_fips_all: '39017',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"39017": 100}',
    density: 333.1,
    imprecise: false,
    latitude: 39.45701,
    longitude: -84.51094,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45055',
  },
  {
    city: 'Oxford',
    county_fips: 39017,
    county_fips_all: '39017',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"39017": 100}',
    density: 141.5,
    imprecise: false,
    latitude: 39.49029,
    longitude: -84.74115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45056',
  },
  {
    city: 'Seven Mile',
    county_fips: 39017,
    county_fips_all: '39017',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"39017": 100}',
    density: 249.4,
    imprecise: false,
    latitude: 39.48501,
    longitude: -84.55371,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45062',
  },
  {
    city: 'Somerville',
    county_fips: 39017,
    county_fips_all: '39017|39135',
    county: 'Butler',
    county_names_all: 'Butler|Preble',
    county_weights: '{"39017": 51.48, "39135": 48.52}',
    density: 40.6,
    imprecise: false,
    latitude: 39.56806,
    longitude: -84.59785,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45064',
  },
  {
    city: 'South Lebanon',
    county_fips: 39165,
    county_fips_all: '39165',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"39165": 100}',
    density: 927.6,
    imprecise: false,
    latitude: 39.37016,
    longitude: -84.21426,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45065',
  },
  {
    city: 'Springboro',
    county_fips: 39165,
    county_fips_all: '39165|39113',
    county: 'Warren',
    county_names_all: 'Warren|Montgomery',
    county_weights: '{"39165": 98.99, "39113": 1.01}',
    density: 521.2,
    imprecise: false,
    latitude: 39.54925,
    longitude: -84.22265,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45066',
  },
  {
    city: 'Trenton',
    county_fips: 39017,
    county_fips_all: '39017',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"39017": 100}',
    density: 304.9,
    imprecise: false,
    latitude: 39.49017,
    longitude: -84.47948,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45067',
  },
  {
    city: 'Waynesville',
    county_fips: 39165,
    county_fips_all: '39165|39057|39027',
    county: 'Warren',
    county_names_all: 'Warren|Greene|Clinton',
    county_weights: '{"39165": 88.62, "39057": 9.46, "39027": 1.92}',
    density: 63.4,
    imprecise: false,
    latitude: 39.52813,
    longitude: -84.05922,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45068',
  },
  {
    city: 'West Chester',
    county_fips: 39017,
    county_fips_all: '39017|39061',
    county: 'Butler',
    county_names_all: 'Butler|Hamilton',
    county_weights: '{"39017": 99.23, "39061": 0.77}',
    density: 746.9,
    imprecise: false,
    latitude: 39.34213,
    longitude: -84.4105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 56037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45069',
  },
  {
    city: 'West Elkton',
    county_fips: 39135,
    county_fips_all: '39135',
    county: 'Preble',
    county_names_all: 'Preble',
    county_weights: '{"39135": 100}',
    density: 136.2,
    imprecise: false,
    latitude: 39.58968,
    longitude: -84.55804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45070',
  },
  {
    city: 'Aberdeen',
    county_fips: 39015,
    county_fips_all: '39015|39001',
    county: 'Brown',
    county_names_all: 'Brown|Adams',
    county_weights: '{"39015": 98.63, "39001": 1.37}',
    density: 44.2,
    imprecise: false,
    latitude: 38.69164,
    longitude: -83.74024,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45101',
  },
  {
    city: 'Amelia',
    county_fips: 39025,
    county_fips_all: '39025',
    county: 'Clermont',
    county_names_all: 'Clermont',
    county_weights: '{"39025": 100}',
    density: 444,
    imprecise: false,
    latitude: 39.01718,
    longitude: -84.20602,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45102',
  },
  {
    city: 'Batavia',
    county_fips: 39025,
    county_fips_all: '39025',
    county: 'Clermont',
    county_names_all: 'Clermont',
    county_weights: '{"39025": 100}',
    density: 167.2,
    imprecise: false,
    latitude: 39.0946,
    longitude: -84.14006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45103',
  },
  {
    city: 'Bentonville',
    county_fips: 39001,
    county_fips_all: '39001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"39001": 100}',
    density: 718.5,
    imprecise: false,
    latitude: 38.75015,
    longitude: -83.61235,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45105',
  },
  {
    city: 'Bethel',
    county_fips: 39025,
    county_fips_all: '39025|39015',
    county: 'Clermont',
    county_names_all: 'Clermont|Brown',
    county_weights: '{"39025": 79.13, "39015": 20.87}',
    density: 61.3,
    imprecise: false,
    latitude: 38.94633,
    longitude: -84.06831,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45106',
  },
  {
    city: 'Blanchester',
    county_fips: 39027,
    county_fips_all: '39027|39165|39015|39025',
    county: 'Clinton',
    county_names_all: 'Clinton|Warren|Brown|Clermont',
    county_weights:
      '{"39027": 52.13, "39165": 18.72, "39015": 18.08, "39025": 11.07}',
    density: 44,
    imprecise: false,
    latitude: 39.28888,
    longitude: -83.96967,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45107',
  },
  {
    city: 'Camp Dennison',
    county_fips: 39061,
    county_fips_all: '39061|39025',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Clermont',
    county_weights: '{"39061": 99.89, "39025": 0.11}',
    density: 90.5,
    imprecise: false,
    latitude: 39.20033,
    longitude: -84.28746,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45111',
  },
  {
    city: 'Chilo',
    county_fips: 39025,
    county_fips_all: '39025',
    county: 'Clermont',
    county_names_all: 'Clermont',
    county_weights: '{"39025": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 38.79377,
    longitude: -84.14144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45112',
  },
  {
    city: 'Clarksville',
    county_fips: 39027,
    county_fips_all: '39027|39165',
    county: 'Clinton',
    county_names_all: 'Clinton|Warren',
    county_weights: '{"39027": 57.93, "39165": 42.07}',
    density: 39.7,
    imprecise: false,
    latitude: 39.39991,
    longitude: -83.98561,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45113',
  },
  {
    city: 'Decatur',
    county_fips: 39015,
    county_fips_all: '39015',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"39015": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 38.80818,
    longitude: -83.70728,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45115',
  },
  {
    city: 'Fayetteville',
    county_fips: 39015,
    county_fips_all: '39015|39071|39025',
    county: 'Brown',
    county_names_all: 'Brown|Highland|Clermont',
    county_weights: '{"39015": 87.17, "39071": 9.0, "39025": 3.83}',
    density: 35,
    imprecise: false,
    latitude: 39.17192,
    longitude: -83.93107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45118',
  },
  {
    city: 'Feesburg',
    county_fips: 39015,
    county_fips_all: '39015',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"39015": 100}',
    density: 6499.4,
    imprecise: false,
    latitude: 38.8781,
    longitude: -83.99927,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45119',
  },
  {
    city: 'Felicity',
    county_fips: 39025,
    county_fips_all: '39025|39015',
    county: 'Clermont',
    county_names_all: 'Clermont|Brown',
    county_weights: '{"39025": 75.25, "39015": 24.75}',
    density: 25.3,
    imprecise: false,
    latitude: 38.82597,
    longitude: -84.09301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45120',
  },
  {
    city: 'Georgetown',
    county_fips: 39015,
    county_fips_all: '39015|39025',
    county: 'Brown',
    county_names_all: 'Brown|Clermont',
    county_weights: '{"39015": 95.19, "39025": 4.81}',
    density: 32.6,
    imprecise: false,
    latitude: 38.86769,
    longitude: -83.90911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45121',
  },
  {
    city: 'Goshen',
    county_fips: 39025,
    county_fips_all: '39025|39165',
    county: 'Clermont',
    county_names_all: 'Clermont|Warren',
    county_weights: '{"39025": 89.85, "39165": 10.15}',
    density: 100.4,
    imprecise: false,
    latitude: 39.22411,
    longitude: -84.12698,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45122',
  },
  {
    city: 'Greenfield',
    county_fips: 39071,
    county_fips_all: '39071|39141|39047',
    county: 'Highland',
    county_names_all: 'Highland|Ross|Fayette',
    county_weights: '{"39071": 43.29, "39141": 32.87, "39047": 23.84}',
    density: 31.6,
    imprecise: false,
    latitude: 39.3487,
    longitude: -83.38866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45123',
  },
  {
    city: 'Hamersville',
    county_fips: 39015,
    county_fips_all: '39015|39025',
    county: 'Brown',
    county_names_all: 'Brown|Clermont',
    county_weights: '{"39015": 82.62, "39025": 17.38}',
    density: 42.8,
    imprecise: false,
    latitude: 38.90886,
    longitude: -83.99897,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45130',
  },
  {
    city: 'Higginsport',
    county_fips: 39015,
    county_fips_all: '39015',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"39015": 100}',
    density: 427.9,
    imprecise: false,
    latitude: 38.78997,
    longitude: -83.96729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45131',
  },
  {
    city: 'Highland',
    county_fips: 39071,
    county_fips_all: '39071',
    county: 'Highland',
    county_names_all: 'Highland',
    county_weights: '{"39071": 100}',
    density: 220.7,
    imprecise: false,
    latitude: 39.34395,
    longitude: -83.5996,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45132',
  },
  {
    city: 'Hillsboro',
    county_fips: 39071,
    county_fips_all: '39071|39131|39015',
    county: 'Highland',
    county_names_all: 'Highland|Pike|Brown',
    county_weights: '{"39071": 96.66, "39131": 3.24, "39015": 0.1}',
    density: 28.8,
    imprecise: false,
    latitude: 39.15695,
    longitude: -83.57282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45133',
  },
  {
    city: 'Leesburg',
    county_fips: 39071,
    county_fips_all: '39071|39047|39027',
    county: 'Highland',
    county_names_all: 'Highland|Fayette|Clinton',
    county_weights: '{"39071": 68.76, "39047": 21.26, "39027": 9.98}',
    density: 27.3,
    imprecise: false,
    latitude: 39.35124,
    longitude: -83.54859,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45135',
  },
  {
    city: 'Loveland',
    county_fips: 39025,
    county_fips_all: '39025|39165|39061',
    county: 'Clermont',
    county_names_all: 'Clermont|Warren|Hamilton',
    county_weights: '{"39025": 53.33, "39165": 30.97, "39061": 15.7}',
    density: 501.1,
    imprecise: false,
    latitude: 39.25603,
    longitude: -84.24433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45140',
  },
  {
    city: 'Lynchburg',
    county_fips: 39071,
    county_fips_all: '39071|39027|39015',
    county: 'Highland',
    county_names_all: 'Highland|Clinton|Brown',
    county_weights: '{"39071": 76.24, "39027": 16.86, "39015": 6.9}',
    density: 26.1,
    imprecise: false,
    latitude: 39.21033,
    longitude: -83.80553,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45142',
  },
  {
    city: 'Manchester',
    county_fips: 39001,
    county_fips_all: '39001|39015',
    county: 'Adams',
    county_names_all: 'Adams|Brown',
    county_weights: '{"39001": 90.53, "39015": 9.47}',
    density: 22.5,
    imprecise: false,
    latitude: 38.70534,
    longitude: -83.6142,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45144',
  },
  {
    city: 'Martinsville',
    county_fips: 39027,
    county_fips_all: '39027',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"39027": 100}',
    density: 19.7,
    imprecise: false,
    latitude: 39.3154,
    longitude: -83.79945,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45146',
  },
  {
    city: 'Miamiville',
    county_fips: 39025,
    county_fips_all: '39025',
    county: 'Clermont',
    county_names_all: 'Clermont',
    county_weights: '{"39025": 100}',
    density: 109.8,
    imprecise: false,
    latitude: 39.21114,
    longitude: -84.30192,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45147',
  },
  {
    city: 'Midland',
    county_fips: 39027,
    county_fips_all: '39027|39015',
    county: 'Clinton',
    county_names_all: 'Clinton|Brown',
    county_weights: '{"39027": 98.44, "39015": 1.56}',
    density: 25.4,
    imprecise: false,
    latitude: 39.28849,
    longitude: -83.88466,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45148',
  },
  {
    city: 'Milford',
    county_fips: 39025,
    county_fips_all: '39025|39061',
    county: 'Clermont',
    county_names_all: 'Clermont|Hamilton',
    county_weights: '{"39025": 99.11, "39061": 0.89}',
    density: 401.2,
    imprecise: false,
    latitude: 39.16567,
    longitude: -84.23281,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45150',
  },
  {
    city: 'Morrow',
    county_fips: 39165,
    county_fips_all: '39165',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"39165": 100}',
    density: 117.8,
    imprecise: false,
    latitude: 39.35005,
    longitude: -84.12316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45152',
  },
  {
    city: 'Moscow',
    county_fips: 39025,
    county_fips_all: '39025',
    county: 'Clermont',
    county_names_all: 'Clermont',
    county_weights: '{"39025": 100}',
    density: 30.1,
    imprecise: false,
    latitude: 38.86977,
    longitude: -84.18474,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45153',
  },
  {
    city: 'Mount Orab',
    county_fips: 39015,
    county_fips_all: '39015|39071',
    county: 'Brown',
    county_names_all: 'Brown|Highland',
    county_weights: '{"39015": 88.59, "39071": 11.41}',
    density: 52.9,
    imprecise: false,
    latitude: 39.06137,
    longitude: -83.91997,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45154',
  },
  {
    city: 'Mowrystown',
    county_fips: 39071,
    county_fips_all: '39071',
    county: 'Highland',
    county_names_all: 'Highland',
    county_weights: '{"39071": 100}',
    density: 408.4,
    imprecise: false,
    latitude: 39.04057,
    longitude: -83.75181,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45155',
  },
  {
    city: 'Neville',
    county_fips: 39025,
    county_fips_all: '39025',
    county: 'Clermont',
    county_names_all: 'Clermont',
    county_weights: '{"39025": 100}',
    density: 174,
    imprecise: false,
    latitude: 38.80947,
    longitude: -84.21348,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 52,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45156',
  },
  {
    city: 'New Richmond',
    county_fips: 39025,
    county_fips_all: '39025',
    county: 'Clermont',
    county_names_all: 'Clermont',
    county_weights: '{"39025": 100}',
    density: 88.3,
    imprecise: false,
    latitude: 38.95599,
    longitude: -84.22824,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45157',
  },
  {
    city: 'Newtonsville',
    county_fips: 39025,
    county_fips_all: '39025',
    county: 'Clermont',
    county_names_all: 'Clermont',
    county_weights: '{"39025": 100}',
    density: 116.4,
    imprecise: false,
    latitude: 39.18229,
    longitude: -84.07769,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45158',
  },
  {
    city: 'New Vienna',
    county_fips: 39027,
    county_fips_all: '39027|39071',
    county: 'Clinton',
    county_names_all: 'Clinton|Highland',
    county_weights: '{"39027": 61.8, "39071": 38.2}',
    density: 25.4,
    imprecise: false,
    latitude: 39.33389,
    longitude: -83.68972,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45159',
  },
  {
    city: 'Owensville',
    county_fips: 39025,
    county_fips_all: '39025',
    county: 'Clermont',
    county_names_all: 'Clermont',
    county_weights: '{"39025": 100}',
    density: 632.6,
    imprecise: false,
    latitude: 39.12358,
    longitude: -84.13725,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45160',
  },
  {
    city: 'Pleasant Plain',
    county_fips: 39165,
    county_fips_all: '39165|39025',
    county: 'Warren',
    county_names_all: 'Warren|Clermont',
    county_weights: '{"39165": 64.01, "39025": 35.99}',
    density: 44.6,
    imprecise: false,
    latitude: 39.26913,
    longitude: -84.07851,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45162',
  },
  {
    city: 'Port William',
    county_fips: 39027,
    county_fips_all: '39027',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"39027": 100}',
    density: 391.2,
    imprecise: false,
    latitude: 39.55365,
    longitude: -83.78532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45164',
  },
  {
    city: 'Reesville',
    county_fips: 39027,
    county_fips_all: '39027',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"39027": 100}',
    density: 31.3,
    imprecise: false,
    latitude: 39.4766,
    longitude: -83.68774,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45166',
  },
  {
    city: 'Ripley',
    county_fips: 39015,
    county_fips_all: '39015',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"39015": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 38.77234,
    longitude: -83.79943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45167',
  },
  {
    city: 'Russellville',
    county_fips: 39015,
    county_fips_all: '39015',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"39015": 100}',
    density: 23.3,
    imprecise: false,
    latitude: 38.85266,
    longitude: -83.76783,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45168',
  },
  {
    city: 'Sabina',
    county_fips: 39027,
    county_fips_all: '39027|39047|39057',
    county: 'Clinton',
    county_names_all: 'Clinton|Fayette|Greene',
    county_weights: '{"39027": 73.83, "39047": 19.91, "39057": 6.26}',
    density: 16.7,
    imprecise: false,
    latitude: 39.505,
    longitude: -83.65035,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45169',
  },
  {
    city: 'Sardinia',
    county_fips: 39015,
    county_fips_all: '39015|39071',
    county: 'Brown',
    county_names_all: 'Brown|Highland',
    county_weights: '{"39015": 58.21, "39071": 41.79}',
    density: 27.5,
    imprecise: false,
    latitude: 39.01414,
    longitude: -83.7962,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45171',
  },
  {
    city: 'Sinking Spring',
    county_fips: 39071,
    county_fips_all: '39071',
    county: 'Highland',
    county_names_all: 'Highland',
    county_weights: '{"39071": 100}',
    density: 269.6,
    imprecise: false,
    latitude: 39.07447,
    longitude: -83.38688,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45172',
  },
  {
    city: 'Terrace Park',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 725.1,
    imprecise: false,
    latitude: 39.1588,
    longitude: -84.31073,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45174',
  },
  {
    city: 'Williamsburg',
    county_fips: 39025,
    county_fips_all: '39025|39015',
    county: 'Clermont',
    county_names_all: 'Clermont|Brown',
    county_weights: '{"39025": 64.7, "39015": 35.3}',
    density: 73.2,
    imprecise: false,
    latitude: 39.08438,
    longitude: -84.02205,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45176',
  },
  {
    city: 'Wilmington',
    county_fips: 39027,
    county_fips_all: '39027',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"39027": 100}',
    density: 52.1,
    imprecise: false,
    latitude: 39.46123,
    longitude: -83.83692,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45177',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 2590.1,
    imprecise: false,
    latitude: 39.10885,
    longitude: -84.50243,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45202',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 785.7,
    imprecise: false,
    latitude: 39.10403,
    longitude: -84.53337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45203',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1059.3,
    imprecise: false,
    latitude: 39.09536,
    longitude: -84.57225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45204',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 2572.8,
    imprecise: false,
    latitude: 39.11057,
    longitude: -84.57518,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45205',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1948.9,
    imprecise: false,
    latitude: 39.12736,
    longitude: -84.48451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45206',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 2265.7,
    imprecise: false,
    latitude: 39.14199,
    longitude: -84.4713,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45207',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1605.6,
    imprecise: false,
    latitude: 39.13522,
    longitude: -84.43393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45208',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1803,
    imprecise: false,
    latitude: 39.15336,
    longitude: -84.42762,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45209',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1629.6,
    imprecise: false,
    latitude: 39.15746,
    longitude: -84.59888,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45211',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 2270,
    imprecise: false,
    latitude: 39.16403,
    longitude: -84.45173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45212',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1375.3,
    imprecise: false,
    latitude: 39.18111,
    longitude: -84.42006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45213',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1242,
    imprecise: false,
    latitude: 39.12271,
    longitude: -84.54442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45214',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 984.1,
    imprecise: false,
    latitude: 39.23536,
    longitude: -84.46221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 30586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45215',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1323.9,
    imprecise: false,
    latitude: 39.20054,
    longitude: -84.48114,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45216',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1147.3,
    imprecise: false,
    latitude: 39.16718,
    longitude: -84.49792,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45217',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1126.4,
    imprecise: false,
    latitude: 39.26623,
    longitude: -84.51975,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45218',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 4868.3,
    imprecise: false,
    latitude: 39.12668,
    longitude: -84.51201,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45219',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1882.9,
    imprecise: false,
    latitude: 39.14736,
    longitude: -84.52101,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45220',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1182.1,
    imprecise: false,
    latitude: 39.1696,
    longitude: -84.55354,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45223',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1392.1,
    imprecise: false,
    latitude: 39.20215,
    longitude: -84.53222,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45224',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1264.2,
    imprecise: false,
    latitude: 39.14341,
    longitude: -84.55267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45225',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 392.4,
    imprecise: false,
    latitude: 39.11149,
    longitude: -84.41989,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45226',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1263.9,
    imprecise: false,
    latitude: 39.15403,
    longitude: -84.38524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45227',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1921.6,
    imprecise: false,
    latitude: 39.15342,
    longitude: -84.48612,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45229',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 772.7,
    imprecise: false,
    latitude: 39.07445,
    longitude: -84.39082,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45230',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1057,
    imprecise: false,
    latitude: 39.24617,
    longitude: -84.5383,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45231',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 608.5,
    imprecise: false,
    latitude: 39.1818,
    longitude: -84.51673,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45232',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 569.8,
    imprecise: false,
    latitude: 39.1191,
    longitude: -84.66559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45233',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1374.5,
    imprecise: false,
    latitude: 39.20949,
    longitude: -84.39701,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45236',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1328.2,
    imprecise: false,
    latitude: 39.19298,
    longitude: -84.45244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45237',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1812.1,
    imprecise: false,
    latitude: 39.10927,
    longitude: -84.61053,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 48351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45238',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1827.2,
    imprecise: false,
    latitude: 39.20439,
    longitude: -84.57979,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45239',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 1180.4,
    imprecise: false,
    latitude: 39.28434,
    longitude: -84.52605,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 29600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45240',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061|39017|39165',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Butler|Warren',
    county_weights: '{"39061": 79.94, "39017": 19.42, "39165": 0.64}',
    density: 529.1,
    imprecise: false,
    latitude: 39.27659,
    longitude: -84.40175,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45241',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 644.6,
    imprecise: false,
    latitude: 39.24348,
    longitude: -84.35621,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45242',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 320.4,
    imprecise: false,
    latitude: 39.18381,
    longitude: -84.34171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45243',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061|39025',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Clermont',
    county_weights: '{"39061": 69.33, "39025": 30.67}',
    density: 507.8,
    imprecise: false,
    latitude: 39.12009,
    longitude: -84.32764,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45244',
  },
  {
    city: 'Cincinnati',
    county_fips: 39025,
    county_fips_all: '39025',
    county: 'Clermont',
    county_names_all: 'Clermont',
    county_weights: '{"39025": 100}',
    density: 488.7,
    imprecise: false,
    latitude: 39.06065,
    longitude: -84.27748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45245',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061|39017',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Butler',
    county_weights: '{"39061": 76.73, "39017": 23.27}',
    density: 553.7,
    imprecise: false,
    latitude: 39.2906,
    longitude: -84.46612,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45246',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 430.9,
    imprecise: false,
    latitude: 39.22048,
    longitude: -84.65172,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45247',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 765.3,
    imprecise: false,
    latitude: 39.16442,
    longitude: -84.66229,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45248',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061|39165',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Warren',
    county_weights: '{"39061": 92.41, "39165": 7.59}',
    density: 822.3,
    imprecise: false,
    latitude: 39.27617,
    longitude: -84.32777,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45249',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 658.2,
    imprecise: false,
    latitude: 39.26789,
    longitude: -84.59422,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45251',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 159.7,
    imprecise: false,
    latitude: 39.27352,
    longitude: -84.63214,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45252',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061|39025',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Clermont',
    county_weights: '{"39061": 68.5, "39025": 31.5}',
    density: 665.5,
    imprecise: false,
    latitude: 39.05862,
    longitude: -84.32675,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45255',
  },
  {
    city: 'Alpha',
    county_fips: 39057,
    county_fips_all: '39057',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"39057": 100}',
    density: 780,
    imprecise: false,
    latitude: 39.71098,
    longitude: -84.02301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45301',
  },
  {
    city: 'Anna',
    county_fips: 39149,
    county_fips_all: '39149',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"39149": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 40.40068,
    longitude: -84.20756,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45302',
  },
  {
    city: 'Ansonia',
    county_fips: 39037,
    county_fips_all: '39037',
    county: 'Darke',
    county_names_all: 'Darke',
    county_weights: '{"39037": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 40.2146,
    longitude: -84.65627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45303',
  },
  {
    city: 'Arcanum',
    county_fips: 39037,
    county_fips_all: '39037|39135|39109',
    county: 'Darke',
    county_names_all: 'Darke|Preble|Miami',
    county_weights: '{"39037": 97.86, "39135": 1.55, "39109": 0.59}',
    density: 34.5,
    imprecise: false,
    latitude: 39.98756,
    longitude: -84.53145,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45304',
  },
  {
    city: 'Bellbrook',
    county_fips: 39057,
    county_fips_all: '39057',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"39057": 100}',
    density: 321,
    imprecise: false,
    latitude: 39.63628,
    longitude: -84.07769,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45305',
  },
  {
    city: 'Botkins',
    county_fips: 39149,
    county_fips_all: '39149|39011',
    county: 'Shelby',
    county_names_all: 'Shelby|Auglaize',
    county_weights: '{"39149": 98.34, "39011": 1.66}',
    density: 26.3,
    imprecise: false,
    latitude: 40.45856,
    longitude: -84.18575,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45306',
  },
  {
    city: 'Bowersville',
    county_fips: 39057,
    county_fips_all: '39057',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"39057": 100}',
    density: 484.6,
    imprecise: false,
    latitude: 39.58065,
    longitude: -83.72347,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45307',
  },
  {
    city: 'Bradford',
    county_fips: 39037,
    county_fips_all: '39037|39109',
    county: 'Darke',
    county_names_all: 'Darke|Miami',
    county_weights: '{"39037": 72.47, "39109": 27.53}',
    density: 33.3,
    imprecise: false,
    latitude: 40.12535,
    longitude: -84.45699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45308',
  },
  {
    city: 'Brookville',
    county_fips: 39113,
    county_fips_all: '39113|39037|39109|39135',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Darke|Miami|Preble',
    county_weights:
      '{"39113": 94.63, "39037": 2.41, "39109": 2.31, "39135": 0.65}',
    density: 69.5,
    imprecise: false,
    latitude: 39.84475,
    longitude: -84.42204,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45309',
  },
  {
    city: 'Burkettsville',
    county_fips: 39107,
    county_fips_all: '39107|39037',
    county: 'Mercer',
    county_names_all: 'Mercer|Darke',
    county_weights: '{"39107": 71.29, "39037": 28.71}',
    density: 505.3,
    imprecise: false,
    latitude: 40.35299,
    longitude: -84.64264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45310',
  },
  {
    city: 'Camden',
    county_fips: 39135,
    county_fips_all: '39135',
    county: 'Preble',
    county_names_all: 'Preble',
    county_weights: '{"39135": 100}',
    density: 25.9,
    imprecise: false,
    latitude: 39.62791,
    longitude: -84.66411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45311',
  },
  {
    city: 'Casstown',
    county_fips: 39109,
    county_fips_all: '39109|39021',
    county: 'Miami',
    county_names_all: 'Miami|Champaign',
    county_weights: '{"39109": 98.0, "39021": 2.0}',
    density: 15.3,
    imprecise: false,
    latitude: 40.06028,
    longitude: -84.07976,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45312',
  },
  {
    city: 'Cedarville',
    county_fips: 39057,
    county_fips_all: '39057|39023',
    county: 'Greene',
    county_names_all: 'Greene|Clark',
    county_weights: '{"39057": 98.1, "39023": 1.9}',
    density: 49.1,
    imprecise: false,
    latitude: 39.74608,
    longitude: -83.77363,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45314',
  },
  {
    city: 'Clayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 174.1,
    imprecise: false,
    latitude: 39.85772,
    longitude: -84.33875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45315',
  },
  {
    city: 'Clifton',
    county_fips: 39023,
    county_fips_all: '39023|39057',
    county: 'Clark',
    county_names_all: 'Clark|Greene',
    county_weights: '{"39023": 53.8, "39057": 46.2}',
    density: 420,
    imprecise: false,
    latitude: 39.79754,
    longitude: -83.82517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45316',
  },
  {
    city: 'Conover',
    county_fips: 39021,
    county_fips_all: '39021|39109|39149',
    county: 'Champaign',
    county_names_all: 'Champaign|Miami|Shelby',
    county_weights: '{"39021": 48.34, "39109": 38.1, "39149": 13.56}',
    density: 21.3,
    imprecise: false,
    latitude: 40.17328,
    longitude: -84.01971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45317',
  },
  {
    city: 'Covington',
    county_fips: 39109,
    county_fips_all: '39109|39037',
    county: 'Miami',
    county_names_all: 'Miami|Darke',
    county_weights: '{"39109": 99.33, "39037": 0.67}',
    density: 45.4,
    imprecise: false,
    latitude: 40.12745,
    longitude: -84.35391,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45318',
  },
  {
    city: 'Donnelsville',
    county_fips: 39023,
    county_fips_all: '39023',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"39023": 100}',
    density: 335.6,
    imprecise: false,
    latitude: 39.91608,
    longitude: -83.94324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45319',
  },
  {
    city: 'Eaton',
    county_fips: 39135,
    county_fips_all: '39135',
    county: 'Preble',
    county_names_all: 'Preble',
    county_weights: '{"39135": 100}',
    density: 44.5,
    imprecise: false,
    latitude: 39.74673,
    longitude: -84.68932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45320',
  },
  {
    city: 'Eldorado',
    county_fips: 39135,
    county_fips_all: '39135',
    county: 'Preble',
    county_names_all: 'Preble',
    county_weights: '{"39135": 100}',
    density: 34.8,
    imprecise: false,
    latitude: 39.87134,
    longitude: -84.67775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45321',
  },
  {
    city: 'Englewood',
    county_fips: 39113,
    county_fips_all: '39113|39109',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Miami',
    county_weights: '{"39113": 77.28, "39109": 22.72}',
    density: 381.1,
    imprecise: false,
    latitude: 39.89967,
    longitude: -84.33206,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 20884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45322',
  },
  {
    city: 'Enon',
    county_fips: 39023,
    county_fips_all: '39023',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"39023": 100}',
    density: 306,
    imprecise: false,
    latitude: 39.85131,
    longitude: -83.92794,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45323',
  },
  {
    city: 'Fairborn',
    county_fips: 39057,
    county_fips_all: '39057|39023',
    county: 'Greene',
    county_names_all: 'Greene|Clark',
    county_weights: '{"39057": 76.56, "39023": 23.44}',
    density: 479.9,
    imprecise: false,
    latitude: 39.81986,
    longitude: -84.00026,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 41194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45324',
  },
  {
    city: 'Farmersville',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 37.1,
    imprecise: false,
    latitude: 39.69297,
    longitude: -84.4269,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45325',
  },
  {
    city: 'Fletcher',
    county_fips: 39109,
    county_fips_all: '39109',
    county: 'Miami',
    county_names_all: 'Miami',
    county_weights: '{"39109": 100}',
    density: 23.9,
    imprecise: false,
    latitude: 40.14201,
    longitude: -84.09039,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45326',
  },
  {
    city: 'Germantown',
    county_fips: 39113,
    county_fips_all: '39113|39135|39017',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Preble|Butler',
    county_weights: '{"39113": 94.13, "39135": 4.2, "39017": 1.67}',
    density: 74.7,
    imprecise: false,
    latitude: 39.63286,
    longitude: -84.39841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45327',
  },
  {
    city: 'Gettysburg',
    county_fips: 39037,
    county_fips_all: '39037',
    county: 'Darke',
    county_names_all: 'Darke',
    county_weights: '{"39037": 100}',
    density: 534.9,
    imprecise: false,
    latitude: 40.11621,
    longitude: -84.49676,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45328',
  },
  {
    city: 'Gratis',
    county_fips: 39135,
    county_fips_all: '39135',
    county: 'Preble',
    county_names_all: 'Preble',
    county_weights: '{"39135": 100}',
    density: 295.2,
    imprecise: false,
    latitude: 39.64821,
    longitude: -84.5282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45330',
  },
  {
    city: 'Greenville',
    county_fips: 39037,
    county_fips_all: '39037',
    county: 'Darke',
    county_names_all: 'Darke',
    county_weights: '{"39037": 100}',
    density: 57.1,
    imprecise: false,
    latitude: 40.09729,
    longitude: -84.64616,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45331',
  },
  {
    city: 'Hollansburg',
    county_fips: 39037,
    county_fips_all: '39037',
    county: 'Darke',
    county_names_all: 'Darke',
    county_weights: '{"39037": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 39.99967,
    longitude: -84.78776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45332',
  },
  {
    city: 'Houston',
    county_fips: 39149,
    county_fips_all: '39149',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"39149": 100}',
    density: 31.1,
    imprecise: false,
    latitude: 40.2481,
    longitude: -84.33209,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45333',
  },
  {
    city: 'Jackson Center',
    county_fips: 39149,
    county_fips_all: '39149|39011|39091',
    county: 'Shelby',
    county_names_all: 'Shelby|Auglaize|Logan',
    county_weights: '{"39149": 93.66, "39011": 4.25, "39091": 2.09}',
    density: 27,
    imprecise: false,
    latitude: 40.44662,
    longitude: -84.04517,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45334',
  },
  {
    city: 'Jamestown',
    county_fips: 39057,
    county_fips_all: '39057|39047|39027',
    county: 'Greene',
    county_names_all: 'Greene|Fayette|Clinton',
    county_weights: '{"39057": 92.96, "39047": 4.14, "39027": 2.9}',
    density: 34.5,
    imprecise: false,
    latitude: 39.63079,
    longitude: -83.73353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45335',
  },
  {
    city: 'Kettlersville',
    county_fips: 39149,
    county_fips_all: '39149',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"39149": 100}',
    density: 62,
    imprecise: false,
    latitude: 40.44256,
    longitude: -84.25988,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45336',
  },
  {
    city: 'Laura',
    county_fips: 39109,
    county_fips_all: '39109|39037',
    county: 'Miami',
    county_names_all: 'Miami|Darke',
    county_weights: '{"39109": 62.94, "39037": 37.06}',
    density: 31.6,
    imprecise: false,
    latitude: 39.98019,
    longitude: -84.42095,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45337',
  },
  {
    city: 'Lewisburg',
    county_fips: 39135,
    county_fips_all: '39135|39037',
    county: 'Preble',
    county_names_all: 'Preble|Darke',
    county_weights: '{"39135": 99.69, "39037": 0.31}',
    density: 37.3,
    imprecise: false,
    latitude: 39.85147,
    longitude: -84.54417,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45338',
  },
  {
    city: 'Ludlow Falls',
    county_fips: 39109,
    county_fips_all: '39109',
    county: 'Miami',
    county_names_all: 'Miami',
    county_weights: '{"39109": 100}',
    density: 29.2,
    imprecise: false,
    latitude: 40.00826,
    longitude: -84.34315,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45339',
  },
  {
    city: 'Maplewood',
    county_fips: 39149,
    county_fips_all: '39149',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"39149": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 40.37184,
    longitude: -84.04935,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45340',
  },
  {
    city: 'Medway',
    county_fips: 39023,
    county_fips_all: '39023|39057',
    county: 'Clark',
    county_names_all: 'Clark|Greene',
    county_weights: '{"39023": 99.89, "39057": 0.11}',
    density: 219.4,
    imprecise: false,
    latitude: 39.87589,
    longitude: -84.02045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45341',
  },
  {
    city: 'Miamisburg',
    county_fips: 39113,
    county_fips_all: '39113|39165',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Warren',
    county_weights: '{"39113": 98.45, "39165": 1.55}',
    density: 406.9,
    imprecise: false,
    latitude: 39.62943,
    longitude: -84.27545,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45342',
  },
  {
    city: 'New Carlisle',
    county_fips: 39023,
    county_fips_all: '39023|39109|39021|39113',
    county: 'Clark',
    county_names_all: 'Clark|Miami|Champaign|Montgomery',
    county_weights:
      '{"39023": 78.3, "39109": 20.41, "39021": 1.1, "39113": 0.19}',
    density: 93.7,
    imprecise: false,
    latitude: 39.95567,
    longitude: -84.00734,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45344',
  },
  {
    city: 'New Lebanon',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 105.5,
    imprecise: false,
    latitude: 39.7392,
    longitude: -84.39926,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45345',
  },
  {
    city: 'New Madison',
    county_fips: 39037,
    county_fips_all: '39037',
    county: 'Darke',
    county_names_all: 'Darke',
    county_weights: '{"39037": 100}',
    density: 16,
    imprecise: false,
    latitude: 39.97934,
    longitude: -84.70911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45346',
  },
  {
    city: 'New Paris',
    county_fips: 39135,
    county_fips_all: '39135|39037',
    county: 'Preble',
    county_names_all: 'Preble|Darke',
    county_weights: '{"39135": 74.25, "39037": 25.75}',
    density: 28.6,
    imprecise: false,
    latitude: 39.88378,
    longitude: -84.76208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45347',
  },
  {
    city: 'New Weston',
    county_fips: 39037,
    county_fips_all: '39037',
    county: 'Darke',
    county_names_all: 'Darke',
    county_weights: '{"39037": 100}',
    density: 11,
    imprecise: false,
    latitude: 40.32663,
    longitude: -84.65404,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45348',
  },
  {
    city: 'North Hampton',
    county_fips: 39023,
    county_fips_all: '39023',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"39023": 100}',
    density: 452.6,
    imprecise: false,
    latitude: 39.98916,
    longitude: -83.94052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45349',
  },
  {
    city: 'North Star',
    county_fips: 39037,
    county_fips_all: '39037',
    county: 'Darke',
    county_names_all: 'Darke',
    county_weights: '{"39037": 100}',
    density: 137.2,
    imprecise: false,
    latitude: 40.32472,
    longitude: -84.57359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45350',
  },
  {
    city: 'Osgood',
    county_fips: 39037,
    county_fips_all: '39037',
    county: 'Darke',
    county_names_all: 'Darke',
    county_weights: '{"39037": 100}',
    density: 378,
    imprecise: false,
    latitude: 40.33954,
    longitude: -84.49574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45351',
  },
  {
    city: 'Palestine',
    county_fips: 39037,
    county_fips_all: '39037',
    county: 'Darke',
    county_names_all: 'Darke',
    county_weights: '{"39037": 100}',
    density: 452.1,
    imprecise: false,
    latitude: 40.05006,
    longitude: -84.74432,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45352',
  },
  {
    city: 'Pemberton',
    county_fips: 39149,
    county_fips_all: '39149',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"39149": 100}',
    density: 33.2,
    imprecise: false,
    latitude: 40.29252,
    longitude: -84.04274,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45353',
  },
  {
    city: 'Phillipsburg',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 237.5,
    imprecise: false,
    latitude: 39.91033,
    longitude: -84.39983,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45354',
  },
  {
    city: 'Piqua',
    county_fips: 39109,
    county_fips_all: '39109|39149',
    county: 'Miami',
    county_names_all: 'Miami|Shelby',
    county_weights: '{"39109": 84.5, "39149": 15.5}',
    density: 129,
    imprecise: false,
    latitude: 40.16252,
    longitude: -84.23097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45356',
  },
  {
    city: 'Pitsburg',
    county_fips: 39037,
    county_fips_all: '39037',
    county: 'Darke',
    county_names_all: 'Darke',
    county_weights: '{"39037": 100}',
    density: 854.1,
    imprecise: false,
    latitude: 39.98724,
    longitude: -84.48796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45358',
  },
  {
    city: 'Pleasant Hill',
    county_fips: 39109,
    county_fips_all: '39109',
    county: 'Miami',
    county_names_all: 'Miami',
    county_weights: '{"39109": 100}',
    density: 60.5,
    imprecise: false,
    latitude: 40.05067,
    longitude: -84.3511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45359',
  },
  {
    city: 'Port Jefferson',
    county_fips: 39149,
    county_fips_all: '39149',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"39149": 100}',
    density: 649.7,
    imprecise: false,
    latitude: 40.33028,
    longitude: -84.09206,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45360',
  },
  {
    city: 'Potsdam',
    county_fips: 39109,
    county_fips_all: '39109',
    county: 'Miami',
    county_names_all: 'Miami',
    county_weights: '{"39109": 100}',
    density: 219.1,
    imprecise: false,
    latitude: 39.96374,
    longitude: -84.41484,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45361',
  },
  {
    city: 'Rossburg',
    county_fips: 39037,
    county_fips_all: '39037',
    county: 'Darke',
    county_names_all: 'Darke',
    county_weights: '{"39037": 100}',
    density: 13,
    imprecise: false,
    latitude: 40.28684,
    longitude: -84.63368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45362',
  },
  {
    city: 'Russia',
    county_fips: 39149,
    county_fips_all: '39149',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"39149": 100}',
    density: 31.6,
    imprecise: false,
    latitude: 40.23925,
    longitude: -84.39841,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45363',
  },
  {
    city: 'Sidney',
    county_fips: 39149,
    county_fips_all: '39149|39021',
    county: 'Shelby',
    county_names_all: 'Shelby|Champaign',
    county_weights: '{"39149": 99.38, "39021": 0.62}',
    density: 71.8,
    imprecise: false,
    latitude: 40.2828,
    longitude: -84.15582,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45365',
  },
  {
    city: 'South Charleston',
    county_fips: 39023,
    county_fips_all: '39023|39057',
    county: 'Clark',
    county_names_all: 'Clark|Greene',
    county_weights: '{"39023": 93.17, "39057": 6.83}',
    density: 19,
    imprecise: false,
    latitude: 39.84376,
    longitude: -83.65413,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45368',
  },
  {
    city: 'South Vienna',
    county_fips: 39023,
    county_fips_all: '39023|39097',
    county: 'Clark',
    county_names_all: 'Clark|Madison',
    county_weights: '{"39023": 95.91, "39097": 4.09}',
    density: 37.1,
    imprecise: false,
    latitude: 39.95304,
    longitude: -83.60304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45369',
  },
  {
    city: 'Spring Valley',
    county_fips: 39057,
    county_fips_all: '39057',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"39057": 100}',
    density: 58.4,
    imprecise: false,
    latitude: 39.60853,
    longitude: -84.04015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45370',
  },
  {
    city: 'Tipp City',
    county_fips: 39109,
    county_fips_all: '39109|39113',
    county: 'Miami',
    county_names_all: 'Miami|Montgomery',
    county_weights: '{"39109": 95.71, "39113": 4.29}',
    density: 172.4,
    imprecise: false,
    latitude: 39.93885,
    longitude: -84.16357,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45371',
  },
  {
    city: 'Tremont City',
    county_fips: 39023,
    county_fips_all: '39023',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"39023": 100}',
    density: 462.1,
    imprecise: false,
    latitude: 40.01471,
    longitude: -83.83862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45372',
  },
  {
    city: 'Troy',
    county_fips: 39109,
    county_fips_all: '39109',
    county: 'Miami',
    county_names_all: 'Miami',
    county_weights: '{"39109": 100}',
    density: 165.4,
    imprecise: false,
    latitude: 40.03353,
    longitude: -84.19588,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 37565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45373',
  },
  {
    city: 'Vandalia',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 270.6,
    imprecise: false,
    latitude: 39.89636,
    longitude: -84.22774,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45377',
  },
  {
    city: 'Verona',
    county_fips: 39135,
    county_fips_all: '39135|39113',
    county: 'Preble',
    county_names_all: 'Preble|Montgomery',
    county_weights: '{"39135": 80.16, "39113": 19.84}',
    density: 679.1,
    imprecise: false,
    latitude: 39.90291,
    longitude: -84.48781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45378',
  },
  {
    city: 'Versailles',
    county_fips: 39037,
    county_fips_all: '39037|39149',
    county: 'Darke',
    county_names_all: 'Darke|Shelby',
    county_weights: '{"39037": 98.93, "39149": 1.07}',
    density: 30.2,
    imprecise: false,
    latitude: 40.24511,
    longitude: -84.51314,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45380',
  },
  {
    city: 'West Alexandria',
    county_fips: 39135,
    county_fips_all: '39135|39113',
    county: 'Preble',
    county_names_all: 'Preble|Montgomery',
    county_weights: '{"39135": 90.7, "39113": 9.3}',
    density: 40.3,
    imprecise: false,
    latitude: 39.73223,
    longitude: -84.52433,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45381',
  },
  {
    city: 'West Manchester',
    county_fips: 39135,
    county_fips_all: '39135|39037',
    county: 'Preble',
    county_names_all: 'Preble|Darke',
    county_weights: '{"39135": 75.95, "39037": 24.05}',
    density: 21.8,
    imprecise: false,
    latitude: 39.89621,
    longitude: -84.61626,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45382',
  },
  {
    city: 'West Milton',
    county_fips: 39109,
    county_fips_all: '39109',
    county: 'Miami',
    county_names_all: 'Miami',
    county_weights: '{"39109": 100}',
    density: 113.7,
    imprecise: false,
    latitude: 39.9572,
    longitude: -84.3337,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45383',
  },
  {
    city: 'Wilberforce',
    county_fips: 39057,
    county_fips_all: '39057',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"39057": 100}',
    density: 315.5,
    imprecise: false,
    latitude: 39.71444,
    longitude: -83.88638,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45384',
  },
  {
    city: 'Xenia',
    county_fips: 39057,
    county_fips_all: '39057',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"39057": 100}',
    density: 114.3,
    imprecise: false,
    latitude: 39.66813,
    longitude: -83.91457,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 40617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45385',
  },
  {
    city: 'Yellow Springs',
    county_fips: 39057,
    county_fips_all: '39057|39023',
    county: 'Greene',
    county_names_all: 'Greene|Clark',
    county_weights: '{"39057": 91.71, "39023": 8.29}',
    density: 71.4,
    imprecise: false,
    latitude: 39.79754,
    longitude: -83.88622,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45387',
  },
  {
    city: 'Yorkshire',
    county_fips: 39037,
    county_fips_all: '39037|39149|39107',
    county: 'Darke',
    county_names_all: 'Darke|Shelby|Mercer',
    county_weights: '{"39037": 95.79, "39149": 2.27, "39107": 1.94}',
    density: 18.6,
    imprecise: false,
    latitude: 40.32799,
    longitude: -84.47901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45388',
  },
  {
    city: 'Christiansburg',
    county_fips: 39021,
    county_fips_all: '39021',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"39021": 100}',
    density: 1360.6,
    imprecise: false,
    latitude: 40.05639,
    longitude: -84.02532,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45389',
  },
  {
    city: 'Union City',
    county_fips: 39037,
    county_fips_all: '39037|18135',
    county: 'Darke',
    county_names_all: 'Darke|Randolph',
    county_weights: '{"39037": 99.56, "18135": 0.44}',
    density: 24.7,
    imprecise: false,
    latitude: 40.21894,
    longitude: -84.76778,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45390',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 831.9,
    imprecise: false,
    latitude: 39.75983,
    longitude: -84.20751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45402',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 1669.6,
    imprecise: false,
    latitude: 39.76303,
    longitude: -84.14978,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45403',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 502,
    imprecise: false,
    latitude: 39.79011,
    longitude: -84.15324,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45404',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 1844.4,
    imprecise: false,
    latitude: 39.79241,
    longitude: -84.21592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 18955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45405',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 1549.4,
    imprecise: false,
    latitude: 39.78442,
    longitude: -84.24178,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45406',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 1605.7,
    imprecise: false,
    latitude: 39.72334,
    longitude: -84.19039,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45409',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 2357.2,
    imprecise: false,
    latitude: 39.74757,
    longitude: -84.15907,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45410',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 375.5,
    imprecise: false,
    latitude: 39.84008,
    longitude: -84.21115,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45414',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 801.1,
    imprecise: false,
    latitude: 39.83473,
    longitude: -84.2568,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45415',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 1124.3,
    imprecise: false,
    latitude: 39.80754,
    longitude: -84.25774,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45416',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 337.9,
    imprecise: false,
    latitude: 39.73427,
    longitude: -84.2844,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45417',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 1762.2,
    imprecise: false,
    latitude: 39.71436,
    longitude: -84.1676,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45419',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 1462.7,
    imprecise: false,
    latitude: 39.719,
    longitude: -84.13045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45420',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.7604,
    longitude: -84.19112,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45423',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113|39057|39109',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Greene|Miami',
    county_weights: '{"39113": 84.5, "39057": 11.42, "39109": 4.08}',
    density: 621.4,
    imprecise: false,
    latitude: 39.84695,
    longitude: -84.11032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 50725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45424',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 273.8,
    imprecise: false,
    latitude: 39.80094,
    longitude: -84.31461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45426',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 230.7,
    imprecise: false,
    latitude: 39.74211,
    longitude: -84.25954,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45428',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 1027.6,
    imprecise: false,
    latitude: 39.68411,
    longitude: -84.16248,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45429',
  },
  {
    city: 'Dayton',
    county_fips: 39057,
    county_fips_all: '39057',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"39057": 100}',
    density: 588.1,
    imprecise: false,
    latitude: 39.71296,
    longitude: -84.08435,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45430',
  },
  {
    city: 'Dayton',
    county_fips: 39057,
    county_fips_all: '39057|39113',
    county: 'Greene',
    county_names_all: 'Greene|Montgomery',
    county_weights: '{"39057": 61.69, "39113": 38.31}',
    density: 919.8,
    imprecise: false,
    latitude: 39.76488,
    longitude: -84.08012,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45431',
  },
  {
    city: 'Dayton',
    county_fips: 39057,
    county_fips_all: '39057|39113',
    county: 'Greene',
    county_names_all: 'Greene|Montgomery',
    county_weights: '{"39057": 66.53, "39113": 33.47}',
    density: 814.9,
    imprecise: false,
    latitude: 39.73934,
    longitude: -84.08627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45432',
  },
  {
    city: 'Dayton',
    county_fips: 39057,
    county_fips_all: '39057',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"39057": 100}',
    density: 81.9,
    imprecise: false,
    latitude: 39.81359,
    longitude: -84.05273,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45433',
  },
  {
    city: 'Dayton',
    county_fips: 39057,
    county_fips_all: '39057',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"39057": 100}',
    density: 463.6,
    imprecise: false,
    latitude: 39.72284,
    longitude: -84.03052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45434',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 591.3,
    imprecise: false,
    latitude: 39.69867,
    longitude: -84.22944,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45439',
  },
  {
    city: 'Dayton',
    county_fips: 39057,
    county_fips_all: '39057|39113',
    county: 'Greene',
    county_names_all: 'Greene|Montgomery',
    county_weights: '{"39057": 63.85, "39113": 36.15}',
    density: 938.6,
    imprecise: false,
    latitude: 39.67498,
    longitude: -84.10001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 22358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45440',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 1082.9,
    imprecise: false,
    latitude: 39.66472,
    longitude: -84.24067,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45449',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113|39165|39057',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Warren|Greene',
    county_weights: '{"39113": 82.35, "39165": 15.57, "39057": 2.08}',
    density: 752.2,
    imprecise: false,
    latitude: 39.60036,
    longitude: -84.1576,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 38712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45458',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113|39057',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Greene',
    county_weights: '{"39113": 96.63, "39057": 3.37}',
    density: 776.6,
    imprecise: false,
    latitude: 39.64658,
    longitude: -84.16693,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45459',
  },
  {
    city: 'Springfield',
    county_fips: 39023,
    county_fips_all: '39023',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"39023": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.92634,
    longitude: -83.80745,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45501',
  },
  {
    city: 'Springfield',
    county_fips: 39023,
    county_fips_all: '39023|39021',
    county: 'Clark',
    county_names_all: 'Clark|Champaign',
    county_weights: '{"39023": 98.66, "39021": 1.34}',
    density: 59.2,
    imprecise: false,
    latitude: 39.92791,
    longitude: -83.81703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45502',
  },
  {
    city: 'Springfield',
    county_fips: 39023,
    county_fips_all: '39023',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"39023": 100}',
    density: 721.5,
    imprecise: false,
    latitude: 39.96073,
    longitude: -83.7682,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 32638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45503',
  },
  {
    city: 'Springfield',
    county_fips: 39023,
    county_fips_all: '39023',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"39023": 100}',
    density: 287.8,
    imprecise: false,
    latitude: 39.94811,
    longitude: -83.86481,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45504',
  },
  {
    city: 'Springfield',
    county_fips: 39023,
    county_fips_all: '39023',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"39023": 100}',
    density: 562.1,
    imprecise: false,
    latitude: 39.90737,
    longitude: -83.7615,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45505',
  },
  {
    city: 'Springfield',
    county_fips: 39023,
    county_fips_all: '39023',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"39023": 100}',
    density: 424.4,
    imprecise: false,
    latitude: 39.89907,
    longitude: -83.85233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45506',
  },
  {
    city: 'Chillicothe',
    county_fips: 39141,
    county_fips_all: '39141|39131|39079',
    county: 'Ross',
    county_names_all: 'Ross|Pike|Jackson',
    county_weights: '{"39141": 93.94, "39131": 3.43, "39079": 2.63}',
    density: 61.8,
    imprecise: false,
    latitude: 39.30996,
    longitude: -82.9555,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 55836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45601',
  },
  {
    city: 'Bainbridge',
    county_fips: 39141,
    county_fips_all: '39141|39131|39071',
    county: 'Ross',
    county_names_all: 'Ross|Pike|Highland',
    county_weights: '{"39141": 62.01, "39131": 26.76, "39071": 11.23}',
    density: 17.1,
    imprecise: false,
    latitude: 39.21569,
    longitude: -83.27171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45612',
  },
  {
    city: 'Beaver',
    county_fips: 39131,
    county_fips_all: '39131|39079|39145',
    county: 'Pike',
    county_names_all: 'Pike|Jackson|Scioto',
    county_weights: '{"39131": 82.84, "39079": 12.75, "39145": 4.41}',
    density: 15.1,
    imprecise: false,
    latitude: 39.0318,
    longitude: -82.84885,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45613',
  },
  {
    city: 'Bidwell',
    county_fips: 39053,
    county_fips_all: '39053',
    county: 'Gallia',
    county_names_all: 'Gallia',
    county_weights: '{"39053": 100}',
    density: 29.6,
    imprecise: false,
    latitude: 38.92858,
    longitude: -82.27819,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45614',
  },
  {
    city: 'Blue Creek',
    county_fips: 39001,
    county_fips_all: '39001|39145',
    county: 'Adams',
    county_names_all: 'Adams|Scioto',
    county_weights: '{"39001": 74.45, "39145": 25.55}',
    density: 7.2,
    imprecise: false,
    latitude: 38.76018,
    longitude: -83.30864,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45616',
  },
  {
    city: 'Bourneville',
    county_fips: 39141,
    county_fips_all: '39141',
    county: 'Ross',
    county_names_all: 'Ross',
    county_weights: '{"39141": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.27967,
    longitude: -83.15559,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45617',
  },
  {
    city: 'Cherry Fork',
    county_fips: 39001,
    county_fips_all: '39001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"39001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.88502,
    longitude: -83.61623,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45618',
  },
  {
    city: 'Chesapeake',
    county_fips: 39087,
    county_fips_all: '39087',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"39087": 100}',
    density: 89,
    imprecise: false,
    latitude: 38.47257,
    longitude: -82.45157,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45619',
  },
  {
    city: 'Cheshire',
    county_fips: 39053,
    county_fips_all: '39053|39105',
    county: 'Gallia',
    county_names_all: 'Gallia|Meigs',
    county_weights: '{"39053": 97.7, "39105": 2.3}',
    density: 12.1,
    imprecise: false,
    latitude: 38.95564,
    longitude: -82.14052,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45620',
  },
  {
    city: 'Coalton',
    county_fips: 39079,
    county_fips_all: '39079',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"39079": 100}',
    density: 410.8,
    imprecise: false,
    latitude: 39.11138,
    longitude: -82.60996,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45621',
  },
  {
    city: 'Creola',
    county_fips: 39163,
    county_fips_all: '39163|39073',
    county: 'Vinton',
    county_names_all: 'Vinton|Hocking',
    county_weights: '{"39163": 82.44, "39073": 17.56}',
    density: 12,
    imprecise: false,
    latitude: 39.35905,
    longitude: -82.49522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45622',
  },
  {
    city: 'Crown City',
    county_fips: 39053,
    county_fips_all: '39053|39087',
    county: 'Gallia',
    county_names_all: 'Gallia|Lawrence',
    county_weights: '{"39053": 91.37, "39087": 8.63}',
    density: 17.1,
    imprecise: false,
    latitude: 38.64125,
    longitude: -82.26748,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45623',
  },
  {
    city: 'Cynthiana',
    county_fips: 39131,
    county_fips_all: '39131',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"39131": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.17301,
    longitude: -83.3487,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45624',
  },
  {
    city: 'Frankfort',
    county_fips: 39141,
    county_fips_all: '39141',
    county: 'Ross',
    county_names_all: 'Ross',
    county_weights: '{"39141": 100}',
    density: 30.6,
    imprecise: false,
    latitude: 39.38959,
    longitude: -83.19657,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45628',
  },
  {
    city: 'Franklin Furnace',
    county_fips: 39145,
    county_fips_all: '39145|39087',
    county: 'Scioto',
    county_names_all: 'Scioto|Lawrence',
    county_weights: '{"39145": 99.19, "39087": 0.81}',
    density: 36.6,
    imprecise: false,
    latitude: 38.65221,
    longitude: -82.81051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45629',
  },
  {
    city: 'Friendship',
    county_fips: 39145,
    county_fips_all: '39145',
    county: 'Scioto',
    county_names_all: 'Scioto',
    county_weights: '{"39145": 100}',
    density: 329.2,
    imprecise: false,
    latitude: 38.69758,
    longitude: -83.09275,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45630',
  },
  {
    city: 'Gallipolis',
    county_fips: 39053,
    county_fips_all: '39053',
    county: 'Gallia',
    county_names_all: 'Gallia',
    county_weights: '{"39053": 100}',
    density: 45.1,
    imprecise: false,
    latitude: 38.81672,
    longitude: -82.25486,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45631',
  },
  {
    city: 'Hamden',
    county_fips: 39163,
    county_fips_all: '39163|39079',
    county: 'Vinton',
    county_names_all: 'Vinton|Jackson',
    county_weights: '{"39163": 98.65, "39079": 1.35}',
    density: 18.6,
    imprecise: false,
    latitude: 39.17891,
    longitude: -82.49037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45634',
  },
  {
    city: 'Haverhill',
    county_fips: 39145,
    county_fips_all: '39145',
    county: 'Scioto',
    county_names_all: 'Scioto',
    county_weights: '{"39145": 100}',
    density: 74.9,
    imprecise: false,
    latitude: 38.58416,
    longitude: -82.81401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45636',
  },
  {
    city: 'Ironton',
    county_fips: 39087,
    county_fips_all: '39087|39145',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Scioto',
    county_weights: '{"39087": 88.73, "39145": 11.27}',
    density: 100.3,
    imprecise: false,
    latitude: 38.56217,
    longitude: -82.67607,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45638',
  },
  {
    city: 'Jackson',
    county_fips: 39079,
    county_fips_all: '39079',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"39079": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 39.02345,
    longitude: -82.65032,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45640',
  },
  {
    city: 'Jasper',
    county_fips: 39131,
    county_fips_all: '39131',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"39131": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.04692,
    longitude: -83.05408,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45642',
  },
  {
    city: 'Kingston',
    county_fips: 39141,
    county_fips_all: '39141|39129',
    county: 'Ross',
    county_names_all: 'Ross|Pickaway',
    county_weights: '{"39141": 67.56, "39129": 32.44}',
    density: 29.3,
    imprecise: false,
    latitude: 39.45245,
    longitude: -82.84176,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45644',
  },
  {
    city: 'Kitts Hill',
    county_fips: 39087,
    county_fips_all: '39087',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"39087": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 38.57082,
    longitude: -82.53159,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45645',
  },
  {
    city: 'Latham',
    county_fips: 39131,
    county_fips_all: '39131|39001',
    county: 'Pike',
    county_names_all: 'Pike|Adams',
    county_weights: '{"39131": 99.88, "39001": 0.12}',
    density: 3.3,
    imprecise: false,
    latitude: 39.07686,
    longitude: -83.31627,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45646',
  },
  {
    city: 'Londonderry',
    county_fips: 39163,
    county_fips_all: '39163|39141',
    county: 'Vinton',
    county_names_all: 'Vinton|Ross',
    county_weights: '{"39163": 64.33, "39141": 35.67}',
    density: 10.9,
    imprecise: false,
    latitude: 39.29597,
    longitude: -82.73803,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45647',
  },
  {
    city: 'Lucasville',
    county_fips: 39145,
    county_fips_all: '39145|39131',
    county: 'Scioto',
    county_names_all: 'Scioto|Pike',
    county_weights: '{"39145": 73.3, "39131": 26.7}',
    density: 31.4,
    imprecise: false,
    latitude: 38.92161,
    longitude: -83.01393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45648',
  },
  {
    city: 'Lynx',
    county_fips: 39001,
    county_fips_all: '39001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"39001": 100}',
    density: 11,
    imprecise: false,
    latitude: 38.74415,
    longitude: -83.42099,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45650',
  },
  {
    city: 'McArthur',
    county_fips: 39163,
    county_fips_all: '39163',
    county: 'Vinton',
    county_names_all: 'Vinton',
    county_weights: '{"39163": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 39.27665,
    longitude: -82.47706,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45651',
  },
  {
    city: 'McDermott',
    county_fips: 39145,
    county_fips_all: '39145',
    county: 'Scioto',
    county_names_all: 'Scioto',
    county_weights: '{"39145": 100}',
    density: 37.1,
    imprecise: false,
    latitude: 38.82911,
    longitude: -83.08018,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45652',
  },
  {
    city: 'Minford',
    county_fips: 39145,
    county_fips_all: '39145|39079',
    county: 'Scioto',
    county_names_all: 'Scioto|Jackson',
    county_weights: '{"39145": 98.73, "39079": 1.27}',
    density: 31.9,
    imprecise: false,
    latitude: 38.88976,
    longitude: -82.82306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45653',
  },
  {
    city: 'New Plymouth',
    county_fips: 39163,
    county_fips_all: '39163|39073',
    county: 'Vinton',
    county_names_all: 'Vinton|Hocking',
    county_weights: '{"39163": 72.43, "39073": 27.57}',
    density: 5.4,
    imprecise: false,
    latitude: 39.36671,
    longitude: -82.37774,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45654',
  },
  {
    city: 'Oak Hill',
    county_fips: 39079,
    county_fips_all: '39079|39053|39087|39145',
    county: 'Jackson',
    county_names_all: 'Jackson|Gallia|Lawrence|Scioto',
    county_weights:
      '{"39079": 73.44, "39053": 14.93, "39087": 10.82, "39145": 0.81}',
    density: 20.2,
    imprecise: false,
    latitude: 38.87565,
    longitude: -82.59143,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45656',
  },
  {
    city: 'Otway',
    county_fips: 39145,
    county_fips_all: '39145|39001|39131',
    county: 'Scioto',
    county_names_all: 'Scioto|Adams|Pike',
    county_weights: '{"39145": 87.1, "39001": 11.65, "39131": 1.25}',
    density: 8.9,
    imprecise: false,
    latitude: 38.85166,
    longitude: -83.21011,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45657',
  },
  {
    city: 'Patriot',
    county_fips: 39053,
    county_fips_all: '39053|39087',
    county: 'Gallia',
    county_names_all: 'Gallia|Lawrence',
    county_weights: '{"39053": 97.93, "39087": 2.07}',
    density: 10.4,
    imprecise: false,
    latitude: 38.76324,
    longitude: -82.41411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45658',
  },
  {
    city: 'Pedro',
    county_fips: 39087,
    county_fips_all: '39087|39145',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Scioto',
    county_weights: '{"39087": 99.78, "39145": 0.22}',
    density: 10.2,
    imprecise: false,
    latitude: 38.67117,
    longitude: -82.62331,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45659',
  },
  {
    city: 'Peebles',
    county_fips: 39001,
    county_fips_all: '39001|39131|39071|39145',
    county: 'Adams',
    county_names_all: 'Adams|Pike|Highland|Scioto',
    county_weights:
      '{"39001": 74.78, "39131": 19.35, "39071": 3.15, "39145": 2.72}',
    density: 15.1,
    imprecise: false,
    latitude: 38.98626,
    longitude: -83.358,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45660',
  },
  {
    city: 'Piketon',
    county_fips: 39131,
    county_fips_all: '39131|39145',
    county: 'Pike',
    county_names_all: 'Pike|Scioto',
    county_weights: '{"39131": 99.6, "39145": 0.4}',
    density: 26.1,
    imprecise: false,
    latitude: 39.04096,
    longitude: -83.10479,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45661',
  },
  {
    city: 'Portsmouth',
    county_fips: 39145,
    county_fips_all: '39145',
    county: 'Scioto',
    county_names_all: 'Scioto',
    county_weights: '{"39145": 100}',
    density: 187.1,
    imprecise: false,
    latitude: 38.78938,
    longitude: -82.92114,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45662',
  },
  {
    city: 'West Portsmouth',
    county_fips: 39145,
    county_fips_all: '39145',
    county: 'Scioto',
    county_names_all: 'Scioto',
    county_weights: '{"39145": 100}',
    density: 37.8,
    imprecise: false,
    latitude: 38.74507,
    longitude: -83.11198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45663',
  },
  {
    city: 'Proctorville',
    county_fips: 39087,
    county_fips_all: '39087',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"39087": 100}',
    density: 110.9,
    imprecise: false,
    latitude: 38.4935,
    longitude: -82.35857,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45669',
  },
  {
    city: 'Rarden',
    county_fips: 39145,
    county_fips_all: '39145|39131|39001',
    county: 'Scioto',
    county_names_all: 'Scioto|Pike|Adams',
    county_weights: '{"39145": 84.84, "39131": 14.72, "39001": 0.44}',
    density: 11.8,
    imprecise: false,
    latitude: 38.97339,
    longitude: -83.23775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45671',
  },
  {
    city: 'Ray',
    county_fips: 39163,
    county_fips_all: '39163|39079|39141',
    county: 'Vinton',
    county_names_all: 'Vinton|Jackson|Ross',
    county_weights: '{"39163": 57.85, "39079": 41.6, "39141": 0.55}',
    density: 9.1,
    imprecise: false,
    latitude: 39.20549,
    longitude: -82.67579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45672',
  },
  {
    city: 'Richmond Dale',
    county_fips: 39141,
    county_fips_all: '39141',
    county: 'Ross',
    county_names_all: 'Ross',
    county_weights: '{"39141": 100}',
    density: 372.8,
    imprecise: false,
    latitude: 39.20399,
    longitude: -82.81148,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45673',
  },
  {
    city: 'Rio Grande',
    county_fips: 39053,
    county_fips_all: '39053',
    county: 'Gallia',
    county_names_all: 'Gallia',
    county_weights: '{"39053": 100}',
    density: 203.9,
    imprecise: false,
    latitude: 38.87798,
    longitude: -82.38017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45674',
  },
  {
    city: 'Scioto Furnace',
    county_fips: 39145,
    county_fips_all: '39145',
    county: 'Scioto',
    county_names_all: 'Scioto',
    county_weights: '{"39145": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 38.79555,
    longitude: -82.75511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45677',
  },
  {
    city: 'Scottown',
    county_fips: 39087,
    county_fips_all: '39087|39053',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Gallia',
    county_weights: '{"39087": 81.5, "39053": 18.5}',
    density: 8.7,
    imprecise: false,
    latitude: 38.60595,
    longitude: -82.37883,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45678',
  },
  {
    city: 'Seaman',
    county_fips: 39001,
    county_fips_all: '39001|39071',
    county: 'Adams',
    county_names_all: 'Adams|Highland',
    county_weights: '{"39001": 91.76, "39071": 8.24}',
    density: 17.5,
    imprecise: false,
    latitude: 38.97634,
    longitude: -83.56788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45679',
  },
  {
    city: 'South Point',
    county_fips: 39087,
    county_fips_all: '39087',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"39087": 100}',
    density: 129,
    imprecise: false,
    latitude: 38.45526,
    longitude: -82.54489,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45680',
  },
  {
    city: 'South Salem',
    county_fips: 39141,
    county_fips_all: '39141',
    county: 'Ross',
    county_names_all: 'Ross',
    county_weights: '{"39141": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 39.30551,
    longitude: -83.24807,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45681',
  },
  {
    city: 'South Webster',
    county_fips: 39145,
    county_fips_all: '39145|39087|39079',
    county: 'Scioto',
    county_names_all: 'Scioto|Lawrence|Jackson',
    county_weights: '{"39145": 76.76, "39087": 21.15, "39079": 2.09}',
    density: 16.9,
    imprecise: false,
    latitude: 38.80839,
    longitude: -82.69658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45682',
  },
  {
    city: 'Stout',
    county_fips: 39001,
    county_fips_all: '39001|39145',
    county: 'Adams',
    county_names_all: 'Adams|Scioto',
    county_weights: '{"39001": 57.8, "39145": 42.2}',
    density: 7,
    imprecise: false,
    latitude: 38.67546,
    longitude: -83.27789,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45684',
  },
  {
    city: 'Thurman',
    county_fips: 39079,
    county_fips_all: '39079|39053',
    county: 'Jackson',
    county_names_all: 'Jackson|Gallia',
    county_weights: '{"39079": 65.5, "39053": 34.5}',
    density: 13.3,
    imprecise: false,
    latitude: 38.9333,
    longitude: -82.4527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45685',
  },
  {
    city: 'Vinton',
    county_fips: 39053,
    county_fips_all: '39053|39163|39105',
    county: 'Gallia',
    county_names_all: 'Gallia|Vinton|Meigs',
    county_weights: '{"39053": 61.32, "39163": 32.38, "39105": 6.3}',
    density: 13.5,
    imprecise: false,
    latitude: 39.00901,
    longitude: -82.36843,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45686',
  },
  {
    city: 'Waterloo',
    county_fips: 39087,
    county_fips_all: '39087|39053',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Gallia',
    county_weights: '{"39087": 97.57, "39053": 2.43}',
    density: 2.4,
    imprecise: false,
    latitude: 38.73013,
    longitude: -82.53155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45688',
  },
  {
    city: 'Waverly',
    county_fips: 39131,
    county_fips_all: '39131|39141',
    county: 'Pike',
    county_names_all: 'Pike|Ross',
    county_weights: '{"39131": 88.04, "39141": 11.96}',
    density: 38.2,
    imprecise: false,
    latitude: 39.13106,
    longitude: -83.01674,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45690',
  },
  {
    city: 'Wellston',
    county_fips: 39079,
    county_fips_all: '39079|39163',
    county: 'Jackson',
    county_names_all: 'Jackson|Vinton',
    county_weights: '{"39079": 99.55, "39163": 0.45}',
    density: 37.9,
    imprecise: false,
    latitude: 39.11582,
    longitude: -82.5426,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45692',
  },
  {
    city: 'West Union',
    county_fips: 39001,
    county_fips_all: '39001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"39001": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 38.80921,
    longitude: -83.53406,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 8714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45693',
  },
  {
    city: 'Wheelersburg',
    county_fips: 39145,
    county_fips_all: '39145',
    county: 'Scioto',
    county_names_all: 'Scioto',
    county_weights: '{"39145": 100}',
    density: 68.1,
    imprecise: false,
    latitude: 38.74807,
    longitude: -82.78345,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45694',
  },
  {
    city: 'Wilkesville',
    county_fips: 39163,
    county_fips_all: '39163',
    county: 'Vinton',
    county_names_all: 'Vinton',
    county_weights: '{"39163": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 39.1529,
    longitude: -82.36334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45695',
  },
  {
    city: 'Willow Wood',
    county_fips: 39087,
    county_fips_all: '39087',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"39087": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 38.60356,
    longitude: -82.45201,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45696',
  },
  {
    city: 'Winchester',
    county_fips: 39001,
    county_fips_all: '39001|39015|39071',
    county: 'Adams',
    county_names_all: 'Adams|Brown|Highland',
    county_weights: '{"39001": 51.27, "39015": 34.29, "39071": 14.44}',
    density: 20.9,
    imprecise: false,
    latitude: 38.9352,
    longitude: -83.66525,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45697',
  },
  {
    city: 'Zaleski',
    county_fips: 39163,
    county_fips_all: '39163',
    county: 'Vinton',
    county_names_all: 'Vinton',
    county_weights: '{"39163": 100}',
    density: 63.9,
    imprecise: false,
    latitude: 39.28811,
    longitude: -82.39604,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45698',
  },
  {
    city: 'Athens',
    county_fips: 39009,
    county_fips_all: '39009',
    county: 'Athens',
    county_names_all: 'Athens',
    county_weights: '{"39009": 100}',
    density: 86.6,
    imprecise: false,
    latitude: 39.31205,
    longitude: -82.08079,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 33329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45701',
  },
  {
    city: 'Albany',
    county_fips: 39105,
    county_fips_all: '39105|39009|39163',
    county: 'Meigs',
    county_names_all: 'Meigs|Athens|Vinton',
    county_weights: '{"39105": 45.79, "39009": 35.81, "39163": 18.4}',
    density: 20.1,
    imprecise: false,
    latitude: 39.19763,
    longitude: -82.22574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45710',
  },
  {
    city: 'Amesville',
    county_fips: 39009,
    county_fips_all: '39009|39115|39167',
    county: 'Athens',
    county_names_all: 'Athens|Morgan|Washington',
    county_weights: '{"39009": 81.66, "39115": 11.42, "39167": 6.92}',
    density: 9.6,
    imprecise: false,
    latitude: 39.42503,
    longitude: -81.93038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45711',
  },
  {
    city: 'Belpre',
    county_fips: 39167,
    county_fips_all: '39167',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"39167": 100}',
    density: 102.6,
    imprecise: false,
    latitude: 39.3183,
    longitude: -81.62001,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45714',
  },
  {
    city: 'Beverly',
    county_fips: 39115,
    county_fips_all: '39115|39167|39121',
    county: 'Morgan',
    county_names_all: 'Morgan|Washington|Noble',
    county_weights: '{"39115": 58.74, "39167": 27.17, "39121": 14.09}',
    density: 18.5,
    imprecise: false,
    latitude: 39.60484,
    longitude: -81.6268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45715',
  },
  {
    city: 'Buchtel',
    county_fips: 39009,
    county_fips_all: '39009',
    county: 'Athens',
    county_names_all: 'Athens',
    county_weights: '{"39009": 100}',
    density: 298.3,
    imprecise: false,
    latitude: 39.46295,
    longitude: -82.18401,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45716',
  },
  {
    city: 'Chauncey',
    county_fips: 39009,
    county_fips_all: '39009',
    county: 'Athens',
    county_names_all: 'Athens',
    county_weights: '{"39009": 100}',
    density: 373.5,
    imprecise: false,
    latitude: 39.39951,
    longitude: -82.1285,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45719',
  },
  {
    city: 'Chester',
    county_fips: 39105,
    county_fips_all: '39105',
    county: 'Meigs',
    county_names_all: 'Meigs',
    county_weights: '{"39105": 100}',
    density: 139.7,
    imprecise: false,
    latitude: 39.09404,
    longitude: -81.92312,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45720',
  },
  {
    city: 'Coolville',
    county_fips: 39009,
    county_fips_all: '39009|39105|39167',
    county: 'Athens',
    county_names_all: 'Athens|Meigs|Washington',
    county_weights: '{"39009": 78.41, "39105": 16.63, "39167": 4.96}',
    density: 21.5,
    imprecise: false,
    latitude: 39.22173,
    longitude: -81.8268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45723',
  },
  {
    city: 'Cutler',
    county_fips: 39167,
    county_fips_all: '39167',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"39167": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 39.38246,
    longitude: -81.79233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45724',
  },
  {
    city: 'Dexter City',
    county_fips: 39121,
    county_fips_all: '39121|39167',
    county: 'Noble',
    county_names_all: 'Noble|Washington',
    county_weights: '{"39121": 96.67, "39167": 3.33}',
    density: 11.6,
    imprecise: false,
    latitude: 39.64495,
    longitude: -81.48171,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45727',
  },
  {
    city: 'Fleming',
    county_fips: 39167,
    county_fips_all: '39167',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"39167": 100}',
    density: 31.4,
    imprecise: false,
    latitude: 39.41653,
    longitude: -81.60828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45729',
  },
  {
    city: 'Glouster',
    county_fips: 39009,
    county_fips_all: '39009|39115|39127',
    county: 'Athens',
    county_names_all: 'Athens|Morgan|Perry',
    county_weights: '{"39009": 47.66, "39115": 36.97, "39127": 15.37}',
    density: 20.8,
    imprecise: false,
    latitude: 39.51802,
    longitude: -82.06705,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45732',
  },
  {
    city: 'Graysville',
    county_fips: 39111,
    county_fips_all: '39111',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"39111": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 39.63982,
    longitude: -81.18816,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45734',
  },
  {
    city: 'Guysville',
    county_fips: 39009,
    county_fips_all: '39009|39105',
    county: 'Athens',
    county_names_all: 'Athens|Meigs',
    county_weights: '{"39009": 99.82, "39105": 0.18}',
    density: 15,
    imprecise: false,
    latitude: 39.25183,
    longitude: -81.9229,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45735',
  },
  {
    city: 'Hockingport',
    county_fips: 39009,
    county_fips_all: '39009',
    county: 'Athens',
    county_names_all: 'Athens',
    county_weights: '{"39009": 100}',
    density: 75.3,
    imprecise: false,
    latitude: 39.19055,
    longitude: -81.7462,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45739',
  },
  {
    city: 'Jacksonville',
    county_fips: 39009,
    county_fips_all: '39009',
    county: 'Athens',
    county_names_all: 'Athens',
    county_weights: '{"39009": 100}',
    density: 411,
    imprecise: false,
    latitude: 39.47709,
    longitude: -82.08023,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45740',
  },
  {
    city: 'Langsville',
    county_fips: 39105,
    county_fips_all: '39105',
    county: 'Meigs',
    county_names_all: 'Meigs',
    county_weights: '{"39105": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 39.06648,
    longitude: -82.2527,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45741',
  },
  {
    city: 'Little Hocking',
    county_fips: 39167,
    county_fips_all: '39167|39009',
    county: 'Washington',
    county_names_all: 'Washington|Athens',
    county_weights: '{"39167": 96.96, "39009": 3.04}',
    density: 54.4,
    imprecise: false,
    latitude: 39.28563,
    longitude: -81.73008,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45742',
  },
  {
    city: 'Long Bottom',
    county_fips: 39105,
    county_fips_all: '39105',
    county: 'Meigs',
    county_names_all: 'Meigs',
    county_weights: '{"39105": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 39.076,
    longitude: -81.85017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45743',
  },
  {
    city: 'Lowell',
    county_fips: 39167,
    county_fips_all: '39167|39121',
    county: 'Washington',
    county_names_all: 'Washington|Noble',
    county_weights: '{"39167": 95.47, "39121": 4.53}',
    density: 15,
    imprecise: false,
    latitude: 39.5396,
    longitude: -81.5077,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45744',
  },
  {
    city: 'Lower Salem',
    county_fips: 39121,
    county_fips_all: '39121|39167|39111',
    county: 'Noble',
    county_names_all: 'Noble|Washington|Monroe',
    county_weights: '{"39121": 51.51, "39167": 31.66, "39111": 16.83}',
    density: 5.6,
    imprecise: false,
    latitude: 39.61678,
    longitude: -81.32689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45745',
  },
  {
    city: 'Macksburg',
    county_fips: 39167,
    county_fips_all: '39167|39121',
    county: 'Washington',
    county_names_all: 'Washington|Noble',
    county_weights: '{"39167": 75.82, "39121": 24.18}',
    density: 7.4,
    imprecise: false,
    latitude: 39.604,
    longitude: -81.44809,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45746',
  },
  {
    city: 'Marietta',
    county_fips: 39167,
    county_fips_all: '39167',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"39167": 100}',
    density: 95.5,
    imprecise: false,
    latitude: 39.4301,
    longitude: -81.42947,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 26420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45750',
  },
  {
    city: 'Middleport',
    county_fips: 39105,
    county_fips_all: '39105|39053',
    county: 'Meigs',
    county_names_all: 'Meigs|Gallia',
    county_weights: '{"39105": 93.0, "39053": 7.0}',
    density: 72.9,
    imprecise: false,
    latitude: 39.01395,
    longitude: -82.12244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45760',
  },
  {
    city: 'Millfield',
    county_fips: 39009,
    county_fips_all: '39009',
    county: 'Athens',
    county_names_all: 'Athens',
    county_weights: '{"39009": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 39.42642,
    longitude: -82.0964,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45761',
  },
  {
    city: 'Nelsonville',
    county_fips: 39073,
    county_fips_all: '39073|39009',
    county: 'Hocking',
    county_names_all: 'Hocking|Athens',
    county_weights: '{"39073": 50.55, "39009": 49.45}',
    density: 37.7,
    imprecise: false,
    latitude: 39.45116,
    longitude: -82.24336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45764',
  },
  {
    city: 'New Marshfield',
    county_fips: 39009,
    county_fips_all: '39009|39163',
    county: 'Athens',
    county_names_all: 'Athens|Vinton',
    county_weights: '{"39009": 79.66, "39163": 20.34}',
    density: 15.4,
    imprecise: false,
    latitude: 39.31931,
    longitude: -82.26247,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45766',
  },
  {
    city: 'New Matamoras',
    county_fips: 39167,
    county_fips_all: '39167|39111',
    county: 'Washington',
    county_names_all: 'Washington|Monroe',
    county_weights: '{"39167": 68.1, "39111": 31.9}',
    density: 8.4,
    imprecise: false,
    latitude: 39.54367,
    longitude: -81.1312,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45767',
  },
  {
    city: 'Newport',
    county_fips: 39167,
    county_fips_all: '39167',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"39167": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 39.4149,
    longitude: -81.26468,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45768',
  },
  {
    city: 'Pomeroy',
    county_fips: 39105,
    county_fips_all: '39105',
    county: 'Meigs',
    county_names_all: 'Meigs',
    county_weights: '{"39105": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 39.1062,
    longitude: -82.04578,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45769',
  },
  {
    city: 'Portland',
    county_fips: 39105,
    county_fips_all: '39105',
    county: 'Meigs',
    county_names_all: 'Meigs',
    county_weights: '{"39105": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 38.98586,
    longitude: -81.80238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45770',
  },
  {
    city: 'Racine',
    county_fips: 39105,
    county_fips_all: '39105',
    county: 'Meigs',
    county_names_all: 'Meigs',
    county_weights: '{"39105": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 38.98204,
    longitude: -81.89902,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45771',
  },
  {
    city: 'Reedsville',
    county_fips: 39105,
    county_fips_all: '39105',
    county: 'Meigs',
    county_names_all: 'Meigs',
    county_weights: '{"39105": 100}',
    density: 14,
    imprecise: false,
    latitude: 39.1408,
    longitude: -81.82268,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45772',
  },
  {
    city: 'Reno',
    county_fips: 39167,
    county_fips_all: '39167',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"39167": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 39.45525,
    longitude: -81.28656,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45773',
  },
  {
    city: 'Rutland',
    county_fips: 39105,
    county_fips_all: '39105',
    county: 'Meigs',
    county_names_all: 'Meigs',
    county_weights: '{"39105": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 39.0876,
    longitude: -82.15596,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45775',
  },
  {
    city: 'Shade',
    county_fips: 39105,
    county_fips_all: '39105|39009',
    county: 'Meigs',
    county_names_all: 'Meigs|Athens',
    county_weights: '{"39105": 56.18, "39009": 43.82}',
    density: 23.8,
    imprecise: false,
    latitude: 39.18732,
    longitude: -82.0228,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45776',
  },
  {
    city: 'Stewart',
    county_fips: 39009,
    county_fips_all: '39009',
    county: 'Athens',
    county_names_all: 'Athens',
    county_weights: '{"39009": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 39.34672,
    longitude: -81.89555,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45778',
  },
  {
    city: 'Syracuse',
    county_fips: 39105,
    county_fips_all: '39105',
    county: 'Meigs',
    county_names_all: 'Meigs',
    county_weights: '{"39105": 100}',
    density: 249,
    imprecise: false,
    latitude: 38.99884,
    longitude: -81.97082,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45779',
  },
  {
    city: 'The Plains',
    county_fips: 39009,
    county_fips_all: '39009',
    county: 'Athens',
    county_names_all: 'Athens',
    county_weights: '{"39009": 100}',
    density: 374.1,
    imprecise: false,
    latitude: 39.36972,
    longitude: -82.13112,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45780',
  },
  {
    city: 'Trimble',
    county_fips: 39009,
    county_fips_all: '39009',
    county: 'Athens',
    county_names_all: 'Athens',
    county_weights: '{"39009": 100}',
    density: 266.7,
    imprecise: false,
    latitude: 39.48624,
    longitude: -82.08076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45782',
  },
  {
    city: 'Tuppers Plains',
    county_fips: 39105,
    county_fips_all: '39105',
    county: 'Meigs',
    county_names_all: 'Meigs',
    county_weights: '{"39105": 100}',
    density: 168.9,
    imprecise: false,
    latitude: 39.17505,
    longitude: -81.83929,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45783',
  },
  {
    city: 'Vincent',
    county_fips: 39167,
    county_fips_all: '39167',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"39167": 100}',
    density: 30.8,
    imprecise: false,
    latitude: 39.38879,
    longitude: -81.68805,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45784',
  },
  {
    city: 'Waterford',
    county_fips: 39167,
    county_fips_all: '39167|39115',
    county: 'Washington',
    county_names_all: 'Washington|Morgan',
    county_weights: '{"39167": 95.81, "39115": 4.19}',
    density: 19.4,
    imprecise: false,
    latitude: 39.50365,
    longitude: -81.65451,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45786',
  },
  {
    city: 'Whipple',
    county_fips: 39167,
    county_fips_all: '39167',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"39167": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 39.51349,
    longitude: -81.37016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45788',
  },
  {
    city: 'Wingett Run',
    county_fips: 39167,
    county_fips_all: '39167|39111',
    county: 'Washington',
    county_names_all: 'Washington|Monroe',
    county_weights: '{"39167": 89.94, "39111": 10.06}',
    density: 7.7,
    imprecise: false,
    latitude: 39.5514,
    longitude: -81.25592,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45789',
  },
  {
    city: 'Lima',
    county_fips: 39003,
    county_fips_all: '39003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"39003": 100}',
    density: 183.6,
    imprecise: false,
    latitude: 40.77476,
    longitude: -84.03703,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 21739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45801',
  },
  {
    city: 'Lima',
    county_fips: 39003,
    county_fips_all: '39003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"39003": 100}',
    density: 247.3,
    imprecise: false,
    latitude: 40.71569,
    longitude: -84.06911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45804',
  },
  {
    city: 'Lima',
    county_fips: 39003,
    county_fips_all: '39003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"39003": 100}',
    density: 646.1,
    imprecise: false,
    latitude: 40.72979,
    longitude: -84.16242,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 24387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45805',
  },
  {
    city: 'Lima',
    county_fips: 39003,
    county_fips_all: '39003|39011',
    county: 'Allen',
    county_names_all: 'Allen|Auglaize',
    county_weights: '{"39003": 78.44, "39011": 21.56}',
    density: 67.8,
    imprecise: false,
    latitude: 40.67615,
    longitude: -84.12651,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45806',
  },
  {
    city: 'Lima',
    county_fips: 39003,
    county_fips_all: '39003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"39003": 100}',
    density: 60.3,
    imprecise: false,
    latitude: 40.8072,
    longitude: -84.16699,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45807',
  },
  {
    city: 'Beaverdam',
    county_fips: 39003,
    county_fips_all: '39003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"39003": 100}',
    density: 226.4,
    imprecise: false,
    latitude: 40.83178,
    longitude: -83.9729,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45808',
  },
  {
    city: 'Gomer',
    county_fips: 39003,
    county_fips_all: '39003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"39003": 100}',
    density: 54.6,
    imprecise: false,
    latitude: 40.8431,
    longitude: -84.18522,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45809',
  },
  {
    city: 'Ada',
    county_fips: 39065,
    county_fips_all: '39065|39063|39003',
    county: 'Hardin',
    county_names_all: 'Hardin|Hancock|Allen',
    county_weights: '{"39065": 79.66, "39063": 12.22, "39003": 8.12}',
    density: 43.9,
    imprecise: false,
    latitude: 40.77721,
    longitude: -83.81097,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45810',
  },
  {
    city: 'Alger',
    county_fips: 39065,
    county_fips_all: '39065|39003',
    county: 'Hardin',
    county_names_all: 'Hardin|Allen',
    county_weights: '{"39065": 97.96, "39003": 2.04}',
    density: 20.2,
    imprecise: false,
    latitude: 40.68341,
    longitude: -83.8135,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45812',
  },
  {
    city: 'Antwerp',
    county_fips: 39125,
    county_fips_all: '39125|39039',
    county: 'Paulding',
    county_names_all: 'Paulding|Defiance',
    county_weights: '{"39125": 98.4, "39039": 1.6}',
    density: 25.6,
    imprecise: false,
    latitude: 41.18914,
    longitude: -84.73031,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45813',
  },
  {
    city: 'Arlington',
    county_fips: 39063,
    county_fips_all: '39063',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"39063": 100}',
    density: 27.6,
    imprecise: false,
    latitude: 40.90119,
    longitude: -83.61545,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45814',
  },
  {
    city: 'Belmore',
    county_fips: 39137,
    county_fips_all: '39137',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"39137": 100}',
    density: 147.8,
    imprecise: false,
    latitude: 41.157,
    longitude: -83.94267,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45815',
  },
  {
    city: 'Benton Ridge',
    county_fips: 39063,
    county_fips_all: '39063',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"39063": 100}',
    density: 513,
    imprecise: false,
    latitude: 41.00452,
    longitude: -83.79392,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45816',
  },
  {
    city: 'Bluffton',
    county_fips: 39003,
    county_fips_all: '39003|39063|39137',
    county: 'Allen',
    county_names_all: 'Allen|Hancock|Putnam',
    county_weights: '{"39003": 49.8, "39063": 47.04, "39137": 3.16}',
    density: 35.7,
    imprecise: false,
    latitude: 40.87691,
    longitude: -83.88279,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45817',
  },
  {
    city: 'Buckland',
    county_fips: 39011,
    county_fips_all: '39011',
    county: 'Auglaize',
    county_names_all: 'Auglaize',
    county_weights: '{"39011": 100}',
    density: 330.1,
    imprecise: false,
    latitude: 40.62407,
    longitude: -84.26033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45819',
  },
  {
    city: 'Cairo',
    county_fips: 39003,
    county_fips_all: '39003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"39003": 100}',
    density: 809.8,
    imprecise: false,
    latitude: 40.83074,
    longitude: -84.08473,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45820',
  },
  {
    city: 'Cecil',
    county_fips: 39125,
    county_fips_all: '39125|39039',
    county: 'Paulding',
    county_names_all: 'Paulding|Defiance',
    county_weights: '{"39125": 96.55, "39039": 3.45}',
    density: 7.5,
    imprecise: false,
    latitude: 41.22643,
    longitude: -84.56208,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45821',
  },
  {
    city: 'Celina',
    county_fips: 39107,
    county_fips_all: '39107',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"39107": 100}',
    density: 47.3,
    imprecise: false,
    latitude: 40.55266,
    longitude: -84.59664,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 19957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45822',
  },
  {
    city: 'Chickasaw',
    county_fips: 39107,
    county_fips_all: '39107',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"39107": 100}',
    density: 633.5,
    imprecise: false,
    latitude: 40.43658,
    longitude: -84.49368,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45826',
  },
  {
    city: 'Cloverdale',
    county_fips: 39137,
    county_fips_all: '39137|39125',
    county: 'Putnam',
    county_names_all: 'Putnam|Paulding',
    county_weights: '{"39137": 85.7, "39125": 14.3}',
    density: 13.2,
    imprecise: false,
    latitude: 41.00393,
    longitude: -84.30122,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45827',
  },
  {
    city: 'Coldwater',
    county_fips: 39107,
    county_fips_all: '39107',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"39107": 100}',
    density: 73,
    imprecise: false,
    latitude: 40.48672,
    longitude: -84.67677,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45828',
  },
  {
    city: 'Columbus Grove',
    county_fips: 39137,
    county_fips_all: '39137|39003',
    county: 'Putnam',
    county_names_all: 'Putnam|Allen',
    county_weights: '{"39137": 67.17, "39003": 32.83}',
    density: 21.2,
    imprecise: false,
    latitude: 40.90616,
    longitude: -84.09213,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45830',
  },
  {
    city: 'Continental',
    county_fips: 39137,
    county_fips_all: '39137|39039|39125',
    county: 'Putnam',
    county_names_all: 'Putnam|Defiance|Paulding',
    county_weights: '{"39137": 97.08, "39039": 2.23, "39125": 0.69}',
    density: 16.8,
    imprecise: false,
    latitude: 41.11141,
    longitude: -84.24993,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45831',
  },
  {
    city: 'Convoy',
    county_fips: 39161,
    county_fips_all: '39161|39125',
    county: 'Van Wert',
    county_names_all: 'Van Wert|Paulding',
    county_weights: '{"39161": 96.67, "39125": 3.33}',
    density: 18.2,
    imprecise: false,
    latitude: 40.92779,
    longitude: -84.7336,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45832',
  },
  {
    city: 'Delphos',
    county_fips: 39003,
    county_fips_all: '39003|39161|39137',
    county: 'Allen',
    county_names_all: 'Allen|Van Wert|Putnam',
    county_weights: '{"39003": 45.86, "39161": 44.68, "39137": 9.46}',
    density: 58.3,
    imprecise: false,
    latitude: 40.83415,
    longitude: -84.35264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45833',
  },
  {
    city: 'Dola',
    county_fips: 39065,
    county_fips_all: '39065',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"39065": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 40.75898,
    longitude: -83.70076,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45835',
  },
  {
    city: 'Dunkirk',
    county_fips: 39065,
    county_fips_all: '39065|39063',
    county: 'Hardin',
    county_names_all: 'Hardin|Hancock',
    county_weights: '{"39065": 96.16, "39063": 3.84}',
    density: 24.6,
    imprecise: false,
    latitude: 40.79304,
    longitude: -83.64311,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45836',
  },
  {
    city: 'Findlay',
    county_fips: 39063,
    county_fips_all: '39063',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"39063": 100}',
    density: 126.5,
    imprecise: false,
    latitude: 41.02626,
    longitude: -83.64943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 54559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45840',
  },
  {
    city: 'Jenera',
    county_fips: 39063,
    county_fips_all: '39063',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"39063": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 40.87955,
    longitude: -83.735,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45841',
  },
  {
    city: 'Forest',
    county_fips: 39065,
    county_fips_all: '39065|39175|39063',
    county: 'Hardin',
    county_names_all: 'Hardin|Wyandot|Hancock',
    county_weights: '{"39065": 37.78, "39175": 37.34, "39063": 24.88}',
    density: 16,
    imprecise: false,
    latitude: 40.78202,
    longitude: -83.53513,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45843',
  },
  {
    city: 'Fort Jennings',
    county_fips: 39137,
    county_fips_all: '39137|39161|39003',
    county: 'Putnam',
    county_names_all: 'Putnam|Van Wert|Allen',
    county_weights: '{"39137": 86.96, "39161": 8.38, "39003": 4.66}',
    density: 20.3,
    imprecise: false,
    latitude: 40.91733,
    longitude: -84.2856,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45844',
  },
  {
    city: 'Fort Loramie',
    county_fips: 39149,
    county_fips_all: '39149|39011',
    county: 'Shelby',
    county_names_all: 'Shelby|Auglaize',
    county_weights: '{"39149": 96.62, "39011": 3.38}',
    density: 40.5,
    imprecise: false,
    latitude: 40.32995,
    longitude: -84.37806,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45845',
  },
  {
    city: 'Fort Recovery',
    county_fips: 39107,
    county_fips_all: '39107|39037|18075',
    county: 'Mercer',
    county_names_all: 'Mercer|Darke|Jay',
    county_weights: '{"39107": 85.73, "39037": 14.04, "18075": 0.23}',
    density: 23.6,
    imprecise: false,
    latitude: 40.40986,
    longitude: -84.74644,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45846',
  },
  {
    city: 'Glandorf',
    county_fips: 39137,
    county_fips_all: '39137',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"39137": 100}',
    density: 234.6,
    imprecise: false,
    latitude: 41.02421,
    longitude: -84.07695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45848',
  },
  {
    city: 'Grover Hill',
    county_fips: 39125,
    county_fips_all: '39125|39161|39137',
    county: 'Paulding',
    county_names_all: 'Paulding|Van Wert|Putnam',
    county_weights: '{"39125": 74.37, "39161": 23.03, "39137": 2.6}',
    density: 8.9,
    imprecise: false,
    latitude: 41.01241,
    longitude: -84.45452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45849',
  },
  {
    city: 'Harrod',
    county_fips: 39003,
    county_fips_all: '39003|39065|39011',
    county: 'Allen',
    county_names_all: 'Allen|Hardin|Auglaize',
    county_weights: '{"39003": 80.82, "39065": 14.84, "39011": 4.34}',
    density: 23.5,
    imprecise: false,
    latitude: 40.70382,
    longitude: -83.91817,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45850',
  },
  {
    city: 'Haviland',
    county_fips: 39125,
    county_fips_all: '39125',
    county: 'Paulding',
    county_names_all: 'Paulding',
    county_weights: '{"39125": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 41.03267,
    longitude: -84.60289,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45851',
  },
  {
    city: 'Kalida',
    county_fips: 39137,
    county_fips_all: '39137',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"39137": 100}',
    density: 370.2,
    imprecise: false,
    latitude: 40.98625,
    longitude: -84.19469,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45853',
  },
  {
    city: 'Lafayette',
    county_fips: 39003,
    county_fips_all: '39003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"39003": 100}',
    density: 294.8,
    imprecise: false,
    latitude: 40.7582,
    longitude: -83.95231,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45854',
  },
  {
    city: 'Latty',
    county_fips: 39125,
    county_fips_all: '39125',
    county: 'Paulding',
    county_names_all: 'Paulding',
    county_weights: '{"39125": 100}',
    density: 289.9,
    imprecise: false,
    latitude: 41.08819,
    longitude: -84.5835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45855',
  },
  {
    city: 'Leipsic',
    county_fips: 39137,
    county_fips_all: '39137|39069|39063',
    county: 'Putnam',
    county_names_all: 'Putnam|Henry|Hancock',
    county_weights: '{"39137": 95.7, "39069": 3.24, "39063": 1.06}',
    density: 19,
    imprecise: false,
    latitude: 41.11452,
    longitude: -83.99917,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45856',
  },
  {
    city: 'McComb',
    county_fips: 39063,
    county_fips_all: '39063',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"39063": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 41.10688,
    longitude: -83.80338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45858',
  },
  {
    city: 'McGuffey',
    county_fips: 39065,
    county_fips_all: '39065',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"39065": 100}',
    density: 425.3,
    imprecise: false,
    latitude: 40.69305,
    longitude: -83.78574,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45859',
  },
  {
    city: 'Maria Stein',
    county_fips: 39107,
    county_fips_all: '39107',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"39107": 100}',
    density: 27,
    imprecise: false,
    latitude: 40.39365,
    longitude: -84.51566,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45860',
  },
  {
    city: 'Melrose',
    county_fips: 39125,
    county_fips_all: '39125',
    county: 'Paulding',
    county_names_all: 'Paulding',
    county_weights: '{"39125": 100}',
    density: 115.7,
    imprecise: false,
    latitude: 41.08587,
    longitude: -84.42569,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45861',
  },
  {
    city: 'Mendon',
    county_fips: 39107,
    county_fips_all: '39107|39011',
    county: 'Mercer',
    county_names_all: 'Mercer|Auglaize',
    county_weights: '{"39107": 92.4, "39011": 7.6}',
    density: 14.9,
    imprecise: false,
    latitude: 40.67079,
    longitude: -84.51356,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45862',
  },
  {
    city: 'Middle Point',
    county_fips: 39161,
    county_fips_all: '39161',
    county: 'Van Wert',
    county_names_all: 'Van Wert',
    county_weights: '{"39161": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 40.9041,
    longitude: -84.45477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45863',
  },
  {
    city: 'Miller City',
    county_fips: 39137,
    county_fips_all: '39137',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"39137": 100}',
    density: 76.8,
    imprecise: false,
    latitude: 41.09936,
    longitude: -84.14077,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45864',
  },
  {
    city: 'Minster',
    county_fips: 39011,
    county_fips_all: '39011|39149|39107',
    county: 'Auglaize',
    county_names_all: 'Auglaize|Shelby|Mercer',
    county_weights: '{"39011": 58.22, "39149": 39.69, "39107": 2.09}',
    density: 60.3,
    imprecise: false,
    latitude: 40.39379,
    longitude: -84.37219,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45865',
  },
  {
    city: 'Montezuma',
    county_fips: 39107,
    county_fips_all: '39107',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"39107": 100}',
    density: 441.9,
    imprecise: false,
    latitude: 40.48905,
    longitude: -84.54969,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45866',
  },
  {
    city: 'Mount Blanchard',
    county_fips: 39063,
    county_fips_all: '39063|39175',
    county: 'Hancock',
    county_names_all: 'Hancock|Wyandot',
    county_weights: '{"39063": 96.96, "39175": 3.04}',
    density: 15.3,
    imprecise: false,
    latitude: 40.89795,
    longitude: -83.53825,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45867',
  },
  {
    city: 'Mount Cory',
    county_fips: 39063,
    county_fips_all: '39063|39137',
    county: 'Hancock',
    county_names_all: 'Hancock|Putnam',
    county_weights: '{"39063": 95.88, "39137": 4.12}',
    density: 15.9,
    imprecise: false,
    latitude: 40.96986,
    longitude: -83.84839,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45868',
  },
  {
    city: 'New Bremen',
    county_fips: 39011,
    county_fips_all: '39011|39149|39107',
    county: 'Auglaize',
    county_names_all: 'Auglaize|Shelby|Mercer',
    county_weights: '{"39011": 76.52, "39149": 13.41, "39107": 10.07}',
    density: 44.7,
    imprecise: false,
    latitude: 40.4573,
    longitude: -84.39432,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45869',
  },
  {
    city: 'New Hampshire',
    county_fips: 39011,
    county_fips_all: '39011',
    county: 'Auglaize',
    county_names_all: 'Auglaize',
    county_weights: '{"39011": 100}',
    density: 523.4,
    imprecise: false,
    latitude: 40.55621,
    longitude: -83.95142,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45870',
  },
  {
    city: 'New Knoxville',
    county_fips: 39011,
    county_fips_all: '39011|39149',
    county: 'Auglaize',
    county_names_all: 'Auglaize|Shelby',
    county_weights: '{"39011": 72.45, "39149": 27.55}',
    density: 35.5,
    imprecise: false,
    latitude: 40.4932,
    longitude: -84.30089,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45871',
  },
  {
    city: 'North Baltimore',
    county_fips: 39173,
    county_fips_all: '39173|39063',
    county: 'Wood',
    county_names_all: 'Wood|Hancock',
    county_weights: '{"39173": 88.59, "39063": 11.41}',
    density: 57.2,
    imprecise: false,
    latitude: 41.18863,
    longitude: -83.68366,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45872',
  },
  {
    city: 'Oakwood',
    county_fips: 39125,
    county_fips_all: '39125|39137',
    county: 'Paulding',
    county_names_all: 'Paulding|Putnam',
    county_weights: '{"39125": 98.68, "39137": 1.32}',
    density: 17.8,
    imprecise: false,
    latitude: 41.11935,
    longitude: -84.39628,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45873',
  },
  {
    city: 'Ohio City',
    county_fips: 39161,
    county_fips_all: '39161',
    county: 'Van Wert',
    county_names_all: 'Van Wert',
    county_weights: '{"39161": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 40.78765,
    longitude: -84.67777,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45874',
  },
  {
    city: 'Ottawa',
    county_fips: 39137,
    county_fips_all: '39137',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"39137": 100}',
    density: 43.5,
    imprecise: false,
    latitude: 41.02271,
    longitude: -84.06118,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45875',
  },
  {
    city: 'Ottoville',
    county_fips: 39137,
    county_fips_all: '39137',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"39137": 100}',
    density: 339.9,
    imprecise: false,
    latitude: 40.93414,
    longitude: -84.33835,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45876',
  },
  {
    city: 'Pandora',
    county_fips: 39137,
    county_fips_all: '39137|39003|39063',
    county: 'Putnam',
    county_names_all: 'Putnam|Allen|Hancock',
    county_weights: '{"39137": 90.14, "39003": 8.92, "39063": 0.94}',
    density: 37.1,
    imprecise: false,
    latitude: 40.95393,
    longitude: -83.93779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45877',
  },
  {
    city: 'Paulding',
    county_fips: 39125,
    county_fips_all: '39125',
    county: 'Paulding',
    county_names_all: 'Paulding',
    county_weights: '{"39125": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 41.12918,
    longitude: -84.56471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45879',
  },
  {
    city: 'Payne',
    county_fips: 39125,
    county_fips_all: '39125',
    county: 'Paulding',
    county_names_all: 'Paulding',
    county_weights: '{"39125": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 41.0662,
    longitude: -84.73782,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45880',
  },
  {
    city: 'Rawson',
    county_fips: 39063,
    county_fips_all: '39063',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"39063": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 40.94976,
    longitude: -83.77426,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45881',
  },
  {
    city: 'Rockford',
    county_fips: 39107,
    county_fips_all: '39107|39161',
    county: 'Mercer',
    county_names_all: 'Mercer|Van Wert',
    county_weights: '{"39107": 93.91, "39161": 6.09}',
    density: 13.2,
    imprecise: false,
    latitude: 40.67823,
    longitude: -84.6754,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45882',
  },
  {
    city: 'Saint Henry',
    county_fips: 39107,
    county_fips_all: '39107|39037',
    county: 'Mercer',
    county_names_all: 'Mercer|Darke',
    county_weights: '{"39107": 97.4, "39037": 2.6}',
    density: 44,
    imprecise: false,
    latitude: 40.40574,
    longitude: -84.62791,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45883',
  },
  {
    city: 'Saint Johns',
    county_fips: 39011,
    county_fips_all: '39011',
    county: 'Auglaize',
    county_names_all: 'Auglaize',
    county_weights: '{"39011": 100}',
    density: 97.2,
    imprecise: false,
    latitude: 40.54865,
    longitude: -84.08333,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45884',
  },
  {
    city: 'Saint Marys',
    county_fips: 39011,
    county_fips_all: '39011',
    county: 'Auglaize',
    county_names_all: 'Auglaize',
    county_weights: '{"39011": 100}',
    density: 68,
    imprecise: false,
    latitude: 40.57182,
    longitude: -84.3871,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45885',
  },
  {
    city: 'Scott',
    county_fips: 39125,
    county_fips_all: '39125|39161',
    county: 'Paulding',
    county_names_all: 'Paulding|Van Wert',
    county_weights: '{"39125": 52.96, "39161": 47.04}',
    density: 6.9,
    imprecise: false,
    latitude: 40.99083,
    longitude: -84.61062,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45886',
  },
  {
    city: 'Spencerville',
    county_fips: 39003,
    county_fips_all: '39003|39011|39161|39107',
    county: 'Allen',
    county_names_all: 'Allen|Auglaize|Van Wert|Mercer',
    county_weights:
      '{"39003": 55.25, "39011": 24.42, "39161": 17.8, "39107": 2.53}',
    density: 24.5,
    imprecise: false,
    latitude: 40.71107,
    longitude: -84.36359,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45887',
  },
  {
    city: 'Uniopolis',
    county_fips: 39011,
    county_fips_all: '39011',
    county: 'Auglaize',
    county_names_all: 'Auglaize',
    county_weights: '{"39011": 100}',
    density: 241.2,
    imprecise: false,
    latitude: 40.60244,
    longitude: -84.08583,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45888',
  },
  {
    city: 'Van Buren',
    county_fips: 39063,
    county_fips_all: '39063|39173',
    county: 'Hancock',
    county_names_all: 'Hancock|Wood',
    county_weights: '{"39063": 99.72, "39173": 0.28}',
    density: 34,
    imprecise: false,
    latitude: 41.14606,
    longitude: -83.64101,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45889',
  },
  {
    city: 'Vanlue',
    county_fips: 39063,
    county_fips_all: '39063',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"39063": 100}',
    density: 22.7,
    imprecise: false,
    latitude: 40.97752,
    longitude: -83.49105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45890',
  },
  {
    city: 'Van Wert',
    county_fips: 39161,
    county_fips_all: '39161',
    county: 'Van Wert',
    county_names_all: 'Van Wert',
    county_weights: '{"39161": 100}',
    density: 44.8,
    imprecise: false,
    latitude: 40.8748,
    longitude: -84.57785,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45891',
  },
  {
    city: 'Vaughnsville',
    county_fips: 39137,
    county_fips_all: '39137',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"39137": 100}',
    density: 404.9,
    imprecise: false,
    latitude: 40.88146,
    longitude: -84.14536,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45893',
  },
  {
    city: 'Venedocia',
    county_fips: 39161,
    county_fips_all: '39161|39107',
    county: 'Van Wert',
    county_names_all: 'Van Wert|Mercer',
    county_weights: '{"39161": 96.98, "39107": 3.02}',
    density: 6.9,
    imprecise: false,
    latitude: 40.76252,
    longitude: -84.4684,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45894',
  },
  {
    city: 'Wapakoneta',
    county_fips: 39011,
    county_fips_all: '39011|39091|39003',
    county: 'Auglaize',
    county_names_all: 'Auglaize|Logan|Allen',
    county_weights: '{"39011": 98.29, "39091": 1.58, "39003": 0.13}',
    density: 37.2,
    imprecise: false,
    latitude: 40.56991,
    longitude: -84.15197,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 17998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45895',
  },
  {
    city: 'Waynesfield',
    county_fips: 39011,
    county_fips_all: '39011|39065|39003',
    county: 'Auglaize',
    county_names_all: 'Auglaize|Hardin|Allen',
    county_weights: '{"39011": 81.37, "39065": 12.49, "39003": 6.14}',
    density: 19.2,
    imprecise: false,
    latitude: 40.60667,
    longitude: -83.93775,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45896',
  },
  {
    city: 'Williamstown',
    county_fips: 39063,
    county_fips_all: '39063',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"39063": 100}',
    density: 37,
    imprecise: false,
    latitude: 40.83434,
    longitude: -83.65676,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45897',
  },
  {
    city: 'Willshire',
    county_fips: 39161,
    county_fips_all: '39161|39107',
    county: 'Van Wert',
    county_names_all: 'Van Wert|Mercer',
    county_weights: '{"39161": 66.54, "39107": 33.46}',
    density: 12.1,
    imprecise: false,
    latitude: 40.73617,
    longitude: -84.76429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45898',
  },
  {
    city: 'Wren',
    county_fips: 39161,
    county_fips_all: '39161',
    county: 'Van Wert',
    county_names_all: 'Van Wert',
    county_weights: '{"39161": 100}',
    density: 298.1,
    imprecise: false,
    latitude: 40.80088,
    longitude: -84.77491,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45899',
  },
  {
    city: 'Alexandria',
    county_fips: 18095,
    county_fips_all: '18095|18035',
    county: 'Madison',
    county_names_all: 'Madison|Delaware',
    county_weights: '{"18095": 96.49, "18035": 3.51}',
    density: 51.9,
    imprecise: false,
    latitude: 40.25141,
    longitude: -85.65838,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 10375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46001',
  },
  {
    city: 'Anderson',
    county_fips: 18095,
    county_fips_all: '18095',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"18095": 100}',
    density: 86.4,
    imprecise: false,
    latitude: 40.12759,
    longitude: -85.76178,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 16534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46011',
  },
  {
    city: 'Anderson',
    county_fips: 18095,
    county_fips_all: '18095|18035',
    county: 'Madison',
    county_names_all: 'Madison|Delaware',
    county_weights: '{"18095": 89.33, "18035": 10.67}',
    density: 251.4,
    imprecise: false,
    latitude: 40.1492,
    longitude: -85.62552,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 20855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46012',
  },
  {
    city: 'Anderson',
    county_fips: 18095,
    county_fips_all: '18095',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"18095": 100}',
    density: 352.1,
    imprecise: false,
    latitude: 40.05021,
    longitude: -85.67829,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 19073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46013',
  },
  {
    city: 'Anderson',
    county_fips: 18095,
    county_fips_all: '18095',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"18095": 100}',
    density: 1082.3,
    imprecise: false,
    latitude: 40.09781,
    longitude: -85.68152,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 17834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46016',
  },
  {
    city: 'Anderson',
    county_fips: 18095,
    county_fips_all: '18095|18035',
    county: 'Madison',
    county_names_all: 'Madison|Delaware',
    county_weights: '{"18095": 96.85, "18035": 3.15}',
    density: 112.9,
    imprecise: false,
    latitude: 40.07358,
    longitude: -85.60687,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46017',
  },
  {
    city: 'Arcadia',
    county_fips: 18057,
    county_fips_all: '18057',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"18057": 100}',
    density: 35.4,
    imprecise: false,
    latitude: 40.17031,
    longitude: -86.02118,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46030',
  },
  {
    city: 'Atlanta',
    county_fips: 18057,
    county_fips_all: '18057|18159',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Tipton',
    county_weights: '{"18057": 68.46, "18159": 31.54}',
    density: 18.5,
    imprecise: false,
    latitude: 40.20935,
    longitude: -86.01018,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46031',
  },
  {
    city: 'Carmel',
    county_fips: 18057,
    county_fips_all: '18057',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"18057": 100}',
    density: 784.7,
    imprecise: false,
    latitude: 39.96535,
    longitude: -86.17104,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 51515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46032',
  },
  {
    city: 'Carmel',
    county_fips: 18057,
    county_fips_all: '18057',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"18057": 100}',
    density: 905.7,
    imprecise: false,
    latitude: 39.97975,
    longitude: -86.08595,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 40881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46033',
  },
  {
    city: 'Cicero',
    county_fips: 18057,
    county_fips_all: '18057',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"18057": 100}',
    density: 92.9,
    imprecise: false,
    latitude: 40.13291,
    longitude: -86.04128,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 7531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46034',
  },
  {
    city: 'Colfax',
    county_fips: 18023,
    county_fips_all: '18023|18107|18011',
    county: 'Clinton',
    county_names_all: 'Clinton|Montgomery|Boone',
    county_weights: '{"18023": 46.59, "18107": 31.95, "18011": 21.46}',
    density: 20.9,
    imprecise: false,
    latitude: 40.18925,
    longitude: -86.67902,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46035',
  },
  {
    city: 'Elwood',
    county_fips: 18095,
    county_fips_all: '18095|18159|18053',
    county: 'Madison',
    county_names_all: 'Madison|Tipton|Grant',
    county_weights: '{"18095": 73.0, "18159": 25.27, "18053": 1.73}',
    density: 56.2,
    imprecise: false,
    latitude: 40.29689,
    longitude: -85.83289,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 11683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46036',
  },
  {
    city: 'Fishers',
    county_fips: 18057,
    county_fips_all: '18057',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"18057": 100}',
    density: 935.8,
    imprecise: false,
    latitude: 39.96077,
    longitude: -85.94446,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 48713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46037',
  },
  {
    city: 'Fishers',
    county_fips: 18057,
    county_fips_all: '18057',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"18057": 100}',
    density: 1088.9,
    imprecise: false,
    latitude: 39.96722,
    longitude: -86.01712,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 43754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46038',
  },
  {
    city: 'Forest',
    county_fips: 18023,
    county_fips_all: '18023',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"18023": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 40.37022,
    longitude: -86.31173,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46039',
  },
  {
    city: 'Fortville',
    county_fips: 18059,
    county_fips_all: '18059|18057|18095',
    county: 'Hancock',
    county_names_all: 'Hancock|Hamilton|Madison',
    county_weights: '{"18059": 61.44, "18057": 20.29, "18095": 18.27}',
    density: 195.7,
    imprecise: false,
    latitude: 39.92773,
    longitude: -85.83424,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 15943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46040',
  },
  {
    city: 'Frankfort',
    county_fips: 18023,
    county_fips_all: '18023|18015',
    county: 'Clinton',
    county_names_all: 'Clinton|Carroll',
    county_weights: '{"18023": 96.73, "18015": 3.27}',
    density: 36,
    imprecise: false,
    latitude: 40.29695,
    longitude: -86.49216,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 23134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46041',
  },
  {
    city: 'Frankton',
    county_fips: 18095,
    county_fips_all: '18095',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"18095": 100}',
    density: 46.9,
    imprecise: false,
    latitude: 40.2085,
    longitude: -85.79026,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46044',
  },
  {
    city: 'Goldsmith',
    county_fips: 18159,
    county_fips_all: '18159',
    county: 'Tipton',
    county_names_all: 'Tipton',
    county_weights: '{"18159": 100}',
    density: 829.3,
    imprecise: false,
    latitude: 40.2898,
    longitude: -86.14832,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46045',
  },
  {
    city: 'Hobbs',
    county_fips: 18159,
    county_fips_all: '18159',
    county: 'Tipton',
    county_names_all: 'Tipton',
    county_weights: '{"18159": 100}',
    density: 1369.3,
    imprecise: false,
    latitude: 40.28418,
    longitude: -85.94739,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46047',
  },
  {
    city: 'Ingalls',
    county_fips: 18095,
    county_fips_all: '18095',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"18095": 100}',
    density: 994.3,
    imprecise: false,
    latitude: 39.9543,
    longitude: -85.80755,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46048',
  },
  {
    city: 'Kempton',
    county_fips: 18159,
    county_fips_all: '18159|18023',
    county: 'Tipton',
    county_names_all: 'Tipton|Clinton',
    county_weights: '{"18159": 89.93, "18023": 10.07}',
    density: 11.2,
    imprecise: false,
    latitude: 40.29757,
    longitude: -86.22165,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46049',
  },
  {
    city: 'Kirklin',
    county_fips: 18023,
    county_fips_all: '18023|18011|18159|18057',
    county: 'Clinton',
    county_names_all: 'Clinton|Boone|Tipton|Hamilton',
    county_weights:
      '{"18023": 76.44, "18011": 18.73, "18159": 3.57, "18057": 1.26}',
    density: 14.6,
    imprecise: false,
    latitude: 40.20515,
    longitude: -86.34629,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46050',
  },
  {
    city: 'Lapel',
    county_fips: 18095,
    county_fips_all: '18095',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"18095": 100}',
    density: 72.7,
    imprecise: false,
    latitude: 40.05855,
    longitude: -85.83794,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46051',
  },
  {
    city: 'Lebanon',
    county_fips: 18011,
    county_fips_all: '18011',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"18011": 100}',
    density: 51.2,
    imprecise: false,
    latitude: 40.04448,
    longitude: -86.46086,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 23553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46052',
  },
  {
    city: 'Mccordsville',
    county_fips: 18059,
    county_fips_all: '18059|18057',
    county: 'Hancock',
    county_names_all: 'Hancock|Hamilton',
    county_weights: '{"18059": 92.25, "18057": 7.75}',
    density: 235.5,
    imprecise: false,
    latitude: 39.88627,
    longitude: -85.90404,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 16010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46055',
  },
  {
    city: 'Markleville',
    county_fips: 18095,
    county_fips_all: '18095|18059|18065',
    county: 'Madison',
    county_names_all: 'Madison|Hancock|Henry',
    county_weights: '{"18095": 77.16, "18059": 19.06, "18065": 3.78}',
    density: 32.6,
    imprecise: false,
    latitude: 39.97351,
    longitude: -85.6105,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46056',
  },
  {
    city: 'Michigantown',
    county_fips: 18023,
    county_fips_all: '18023',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"18023": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 40.33796,
    longitude: -86.37801,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46057',
  },
  {
    city: 'Mulberry',
    county_fips: 18023,
    county_fips_all: '18023|18157',
    county: 'Clinton',
    county_names_all: 'Clinton|Tippecanoe',
    county_weights: '{"18023": 99.32, "18157": 0.68}',
    density: 30.5,
    imprecise: false,
    latitude: 40.35981,
    longitude: -86.64777,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46058',
  },
  {
    city: 'Noblesville',
    county_fips: 18057,
    county_fips_all: '18057|18095',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Madison',
    county_weights: '{"18057": 98.28, "18095": 1.72}',
    density: 228,
    imprecise: false,
    latitude: 40.06616,
    longitude: -85.93137,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 47610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46060',
  },
  {
    city: 'Noblesville',
    county_fips: 18057,
    county_fips_all: '18057',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"18057": 100}',
    density: 473.1,
    imprecise: false,
    latitude: 40.06146,
    longitude: -86.05523,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 41060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46062',
  },
  {
    city: 'Orestes',
    county_fips: 18095,
    county_fips_all: '18095',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"18095": 100}',
    density: 265.2,
    imprecise: false,
    latitude: 40.27184,
    longitude: -85.72389,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46063',
  },
  {
    city: 'Pendleton',
    county_fips: 18095,
    county_fips_all: '18095|18059',
    county: 'Madison',
    county_names_all: 'Madison|Hancock',
    county_weights: '{"18095": 88.67, "18059": 11.33}',
    density: 106.9,
    imprecise: false,
    latitude: 39.98473,
    longitude: -85.74701,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 18499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46064',
  },
  {
    city: 'Rossville',
    county_fips: 18023,
    county_fips_all: '18023|18015',
    county: 'Clinton',
    county_names_all: 'Clinton|Carroll',
    county_weights: '{"18023": 66.7, "18015": 33.3}',
    density: 38.5,
    imprecise: false,
    latitude: 40.42318,
    longitude: -86.60992,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46065',
  },
  {
    city: 'Sharpsville',
    county_fips: 18159,
    county_fips_all: '18159|18067',
    county: 'Tipton',
    county_names_all: 'Tipton|Howard',
    county_weights: '{"18159": 97.12, "18067": 2.88}',
    density: 21.8,
    imprecise: false,
    latitude: 40.37511,
    longitude: -86.1112,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46068',
  },
  {
    city: 'Sheridan',
    county_fips: 18057,
    county_fips_all: '18057|18011|18023',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Boone|Clinton',
    county_weights: '{"18057": 57.04, "18011": 35.9, "18023": 7.06}',
    density: 32.8,
    imprecise: false,
    latitude: 40.13829,
    longitude: -86.23144,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 7504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46069',
  },
  {
    city: 'Summitville',
    county_fips: 18095,
    county_fips_all: '18095|18035|18053',
    county: 'Madison',
    county_names_all: 'Madison|Delaware|Grant',
    county_weights: '{"18095": 97.11, "18035": 2.75, "18053": 0.14}',
    density: 17.9,
    imprecise: false,
    latitude: 40.34315,
    longitude: -85.65928,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46070',
  },
  {
    city: 'Thorntown',
    county_fips: 18011,
    county_fips_all: '18011',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"18011": 100}',
    density: 17,
    imprecise: false,
    latitude: 40.11941,
    longitude: -86.60549,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46071',
  },
  {
    city: 'Tipton',
    county_fips: 18159,
    county_fips_all: '18159',
    county: 'Tipton',
    county_names_all: 'Tipton',
    county_weights: '{"18159": 100}',
    density: 31.8,
    imprecise: false,
    latitude: 40.28526,
    longitude: -86.06891,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 9049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46072',
  },
  {
    city: 'Westfield',
    county_fips: 18057,
    county_fips_all: '18057',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"18057": 100}',
    density: 519.1,
    imprecise: false,
    latitude: 40.03651,
    longitude: -86.17289,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 48901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46074',
  },
  {
    city: 'Whitestown',
    county_fips: 18011,
    county_fips_all: '18011',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"18011": 100}',
    density: 117.8,
    imprecise: false,
    latitude: 40.02637,
    longitude: -86.3346,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 9509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46075',
  },
  {
    city: 'Windfall',
    county_fips: 18159,
    county_fips_all: '18159|18067',
    county: 'Tipton',
    county_names_all: 'Tipton|Howard',
    county_weights: '{"18159": 97.75, "18067": 2.25}',
    density: 14.8,
    imprecise: false,
    latitude: 40.36318,
    longitude: -85.9374,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46076',
  },
  {
    city: 'Zionsville',
    county_fips: 18011,
    county_fips_all: '18011|18057|18097',
    county: 'Boone',
    county_names_all: 'Boone|Hamilton|Marion',
    county_weights: '{"18011": 91.98, "18057": 6.55, "18097": 1.47}',
    density: 320.2,
    imprecise: false,
    latitude: 39.98281,
    longitude: -86.28346,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 36760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46077',
  },
  {
    city: 'Advance',
    county_fips: 18011,
    county_fips_all: '18011',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"18011": 100}',
    density: 255.6,
    imprecise: false,
    latitude: 39.99556,
    longitude: -86.61993,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46102',
  },
  {
    city: 'Amo',
    county_fips: 18063,
    county_fips_all: '18063',
    county: 'Hendricks',
    county_names_all: 'Hendricks',
    county_weights: '{"18063": 100}',
    density: 304.6,
    imprecise: false,
    latitude: 39.6896,
    longitude: -86.61384,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46103',
  },
  {
    city: 'Arlington',
    county_fips: 18139,
    county_fips_all: '18139',
    county: 'Rush',
    county_names_all: 'Rush',
    county_weights: '{"18139": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 39.66041,
    longitude: -85.59545,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46104',
  },
  {
    city: 'Bainbridge',
    county_fips: 18133,
    county_fips_all: '18133',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"18133": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 39.76388,
    longitude: -86.81487,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46105',
  },
  {
    city: 'Bargersville',
    county_fips: 18081,
    county_fips_all: '18081|18109',
    county: 'Johnson',
    county_names_all: 'Johnson|Morgan',
    county_weights: '{"18081": 96.5, "18109": 3.5}',
    density: 139.2,
    imprecise: false,
    latitude: 39.51555,
    longitude: -86.20524,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 10159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46106',
  },
  {
    city: 'Beech Grove',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1507.5,
    imprecise: false,
    latitude: 39.71661,
    longitude: -86.09161,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 13020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46107',
  },
  {
    city: 'Boggstown',
    county_fips: 18145,
    county_fips_all: '18145',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"18145": 100}',
    density: 24.1,
    imprecise: false,
    latitude: 39.56021,
    longitude: -85.91333,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46110',
  },
  {
    city: 'Brooklyn',
    county_fips: 18109,
    county_fips_all: '18109',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"18109": 100}',
    density: 768.9,
    imprecise: false,
    latitude: 39.5417,
    longitude: -86.36863,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46111',
  },
  {
    city: 'Brownsburg',
    county_fips: 18063,
    county_fips_all: '18063|18011',
    county: 'Hendricks',
    county_names_all: 'Hendricks|Boone',
    county_weights: '{"18063": 96.65, "18011": 3.35}',
    density: 405.5,
    imprecise: false,
    latitude: 39.86561,
    longitude: -86.38215,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 44220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46112',
  },
  {
    city: 'Camby',
    county_fips: 18109,
    county_fips_all: '18109|18097|18063',
    county: 'Morgan',
    county_names_all: 'Morgan|Marion|Hendricks',
    county_weights: '{"18109": 48.0, "18097": 37.15, "18063": 14.85}',
    density: 416.6,
    imprecise: false,
    latitude: 39.635,
    longitude: -86.30548,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 17192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46113',
  },
  {
    city: 'Carthage',
    county_fips: 18139,
    county_fips_all: '18139|18059',
    county: 'Rush',
    county_names_all: 'Rush|Hancock',
    county_weights: '{"18139": 94.2, "18059": 5.8}',
    density: 15.8,
    imprecise: false,
    latitude: 39.7375,
    longitude: -85.56623,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46115',
  },
  {
    city: 'Charlottesville',
    county_fips: 18059,
    county_fips_all: '18059|18065',
    county: 'Hancock',
    county_names_all: 'Hancock|Henry',
    county_weights: '{"18059": 90.76, "18065": 9.24}',
    density: 18.6,
    imprecise: false,
    latitude: 39.81507,
    longitude: -85.61763,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46117',
  },
  {
    city: 'Clayton',
    county_fips: 18063,
    county_fips_all: '18063|18109',
    county: 'Hendricks',
    county_names_all: 'Hendricks|Morgan',
    county_weights: '{"18063": 92.58, "18109": 7.42}',
    density: 33.4,
    imprecise: false,
    latitude: 39.65317,
    longitude: -86.52394,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46118',
  },
  {
    city: 'Cloverdale',
    county_fips: 18133,
    county_fips_all: '18133|18119|18109',
    county: 'Putnam',
    county_names_all: 'Putnam|Owen|Morgan',
    county_weights: '{"18133": 81.25, "18119": 13.0, "18109": 5.75}',
    density: 25.1,
    imprecise: false,
    latitude: 39.51252,
    longitude: -86.78711,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46120',
  },
  {
    city: 'Coatesville',
    county_fips: 18063,
    county_fips_all: '18063|18133',
    county: 'Hendricks',
    county_names_all: 'Hendricks|Putnam',
    county_weights: '{"18063": 51.97, "18133": 48.03}',
    density: 36.8,
    imprecise: false,
    latitude: 39.67776,
    longitude: -86.67345,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46121',
  },
  {
    city: 'Danville',
    county_fips: 18063,
    county_fips_all: '18063',
    county: 'Hendricks',
    county_names_all: 'Hendricks',
    county_weights: '{"18063": 100}',
    density: 74.1,
    imprecise: false,
    latitude: 39.76822,
    longitude: -86.5475,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 16974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46122',
  },
  {
    city: 'Avon',
    county_fips: 18063,
    county_fips_all: '18063',
    county: 'Hendricks',
    county_names_all: 'Hendricks',
    county_weights: '{"18063": 100}',
    density: 585.6,
    imprecise: false,
    latitude: 39.76502,
    longitude: -86.40015,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 43353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46123',
  },
  {
    city: 'Edinburgh',
    county_fips: 18145,
    county_fips_all: '18145|18005|18081',
    county: 'Shelby',
    county_names_all: 'Shelby|Bartholomew|Johnson',
    county_weights: '{"18145": 46.4, "18005": 30.44, "18081": 23.15}',
    density: 38.3,
    imprecise: false,
    latitude: 39.36914,
    longitude: -85.94551,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 7304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46124',
  },
  {
    city: 'Eminence',
    county_fips: 18109,
    county_fips_all: '18109',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"18109": 100}',
    density: 89.4,
    imprecise: false,
    latitude: 39.52188,
    longitude: -86.64179,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46125',
  },
  {
    city: 'Fairland',
    county_fips: 18145,
    county_fips_all: '18145',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"18145": 100}',
    density: 46.1,
    imprecise: false,
    latitude: 39.62053,
    longitude: -85.88694,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46126',
  },
  {
    city: 'Falmouth',
    county_fips: 18139,
    county_fips_all: '18139|18041',
    county: 'Rush',
    county_names_all: 'Rush|Fayette',
    county_weights: '{"18139": 71.06, "18041": 28.94}',
    density: 7.3,
    imprecise: false,
    latitude: 39.71766,
    longitude: -85.3158,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46127',
  },
  {
    city: 'Fillmore',
    county_fips: 18133,
    county_fips_all: '18133',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"18133": 100}',
    density: 28.6,
    imprecise: false,
    latitude: 39.65634,
    longitude: -86.74312,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46128',
  },
  {
    city: 'Fountaintown',
    county_fips: 18145,
    county_fips_all: '18145|18059',
    county: 'Shelby',
    county_names_all: 'Shelby|Hancock',
    county_weights: '{"18145": 86.88, "18059": 13.12}',
    density: 31.4,
    imprecise: false,
    latitude: 39.67464,
    longitude: -85.83571,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46130',
  },
  {
    city: 'Franklin',
    county_fips: 18081,
    county_fips_all: '18081|18145',
    county: 'Johnson',
    county_names_all: 'Johnson|Shelby',
    county_weights: '{"18081": 93.1, "18145": 6.9}',
    density: 106.2,
    imprecise: false,
    latitude: 39.47196,
    longitude: -86.04233,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 34647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46131',
  },
  {
    city: 'Glenwood',
    county_fips: 18139,
    county_fips_all: '18139|18041',
    county: 'Rush',
    county_names_all: 'Rush|Fayette',
    county_weights: '{"18139": 52.82, "18041": 47.18}',
    density: 14.2,
    imprecise: false,
    latitude: 39.58945,
    longitude: -85.30044,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46133',
  },
  {
    city: 'Greencastle',
    county_fips: 18133,
    county_fips_all: '18133|18121',
    county: 'Putnam',
    county_names_all: 'Putnam|Parke',
    county_weights: '{"18133": 98.42, "18121": 1.58}',
    density: 45.4,
    imprecise: false,
    latitude: 39.65909,
    longitude: -86.89107,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 19632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46135',
  },
  {
    city: 'Greenfield',
    county_fips: 18059,
    county_fips_all: '18059|18139|18145',
    county: 'Hancock',
    county_names_all: 'Hancock|Rush|Shelby',
    county_weights: '{"18059": 98.93, "18139": 0.64, "18145": 0.43}',
    density: 97.4,
    imprecise: false,
    latitude: 39.80358,
    longitude: -85.77049,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 43511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46140',
  },
  {
    city: 'Greenwood',
    county_fips: 18081,
    county_fips_all: '18081',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"18081": 100}',
    density: 887.7,
    imprecise: false,
    latitude: 39.62029,
    longitude: -86.1764,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 34348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46142',
  },
  {
    city: 'Greenwood',
    county_fips: 18081,
    county_fips_all: '18081',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"18081": 100}',
    density: 482.7,
    imprecise: false,
    latitude: 39.59484,
    longitude: -86.11323,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 61803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46143',
  },
  {
    city: 'Gwynneville',
    county_fips: 18145,
    county_fips_all: '18145',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"18145": 100}',
    density: 65.6,
    imprecise: false,
    latitude: 39.66586,
    longitude: -85.64706,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46144',
  },
  {
    city: 'Homer',
    county_fips: 18139,
    county_fips_all: '18139',
    county: 'Rush',
    county_names_all: 'Rush',
    county_weights: '{"18139": 100}',
    density: 49.6,
    imprecise: false,
    latitude: 39.57968,
    longitude: -85.56972,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46146',
  },
  {
    city: 'Jamestown',
    county_fips: 18011,
    county_fips_all: '18011|18063',
    county: 'Boone',
    county_names_all: 'Boone|Hendricks',
    county_weights: '{"18011": 90.82, "18063": 9.18}',
    density: 17.1,
    imprecise: false,
    latitude: 39.96988,
    longitude: -86.62693,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46147',
  },
  {
    city: 'Knightstown',
    county_fips: 18065,
    county_fips_all: '18065|18139',
    county: 'Henry',
    county_names_all: 'Henry|Rush',
    county_weights: '{"18065": 68.29, "18139": 31.71}',
    density: 37.3,
    imprecise: false,
    latitude: 39.80906,
    longitude: -85.51296,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46148',
  },
  {
    city: 'Lizton',
    county_fips: 18063,
    county_fips_all: '18063',
    county: 'Hendricks',
    county_names_all: 'Hendricks',
    county_weights: '{"18063": 100}',
    density: 28.3,
    imprecise: false,
    latitude: 39.88545,
    longitude: -86.55758,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46149',
  },
  {
    city: 'Manilla',
    county_fips: 18139,
    county_fips_all: '18139|18145',
    county: 'Rush',
    county_names_all: 'Rush|Shelby',
    county_weights: '{"18139": 89.13, "18145": 10.87}',
    density: 12.8,
    imprecise: false,
    latitude: 39.54695,
    longitude: -85.60232,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46150',
  },
  {
    city: 'Martinsville',
    county_fips: 18109,
    county_fips_all: '18109|18105|18081',
    county: 'Morgan',
    county_names_all: 'Morgan|Monroe|Johnson',
    county_weights: '{"18109": 96.47, "18105": 3.31, "18081": 0.22}',
    density: 61.5,
    imprecise: false,
    latitude: 39.44783,
    longitude: -86.4275,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 32446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46151',
  },
  {
    city: 'Maxwell',
    county_fips: 18059,
    county_fips_all: '18059',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"18059": 100}',
    density: 1832.6,
    imprecise: false,
    latitude: 39.85639,
    longitude: -85.77038,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46154',
  },
  {
    city: 'Mays',
    county_fips: 18139,
    county_fips_all: '18139',
    county: 'Rush',
    county_names_all: 'Rush',
    county_weights: '{"18139": 100}',
    density: 886.6,
    imprecise: false,
    latitude: 39.74355,
    longitude: -85.42966,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46155',
  },
  {
    city: 'Milroy',
    county_fips: 18139,
    county_fips_all: '18139|18031',
    county: 'Rush',
    county_names_all: 'Rush|Decatur',
    county_weights: '{"18139": 99.2, "18031": 0.8}',
    density: 9.1,
    imprecise: false,
    latitude: 39.48451,
    longitude: -85.4806,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46156',
  },
  {
    city: 'Monrovia',
    county_fips: 18109,
    county_fips_all: '18109',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"18109": 100}',
    density: 57.6,
    imprecise: false,
    latitude: 39.55623,
    longitude: -86.52741,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46157',
  },
  {
    city: 'Mooresville',
    county_fips: 18109,
    county_fips_all: '18109|18063',
    county: 'Morgan',
    county_names_all: 'Morgan|Hendricks',
    county_weights: '{"18109": 88.68, "18063": 11.32}',
    density: 125.2,
    imprecise: false,
    latitude: 39.58275,
    longitude: -86.37405,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 24878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46158',
  },
  {
    city: 'Morgantown',
    county_fips: 18013,
    county_fips_all: '18013|18109|18081',
    county: 'Brown',
    county_names_all: 'Brown|Morgan|Johnson',
    county_weights: '{"18013": 48.18, "18109": 26.2, "18081": 25.62}',
    density: 28.8,
    imprecise: false,
    latitude: 39.35429,
    longitude: -86.26753,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 6514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46160',
  },
  {
    city: 'Morristown',
    county_fips: 18145,
    county_fips_all: '18145|18059|18139',
    county: 'Shelby',
    county_names_all: 'Shelby|Hancock|Rush',
    county_weights: '{"18145": 85.13, "18059": 11.03, "18139": 3.84}',
    density: 26.4,
    imprecise: false,
    latitude: 39.66959,
    longitude: -85.69395,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46161',
  },
  {
    city: 'Needham',
    county_fips: 18081,
    county_fips_all: '18081|18145',
    county: 'Johnson',
    county_names_all: 'Johnson|Shelby',
    county_weights: '{"18081": 53.76, "18145": 46.24}',
    density: 7.2,
    imprecise: false,
    latitude: 39.55021,
    longitude: -85.95242,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46162',
  },
  {
    city: 'New Palestine',
    county_fips: 18059,
    county_fips_all: '18059|18145|18097',
    county: 'Hancock',
    county_names_all: 'Hancock|Shelby|Marion',
    county_weights: '{"18059": 85.94, "18145": 13.07, "18097": 0.99}',
    density: 188.8,
    imprecise: false,
    latitude: 39.7287,
    longitude: -85.90435,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 14498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46163',
  },
  {
    city: 'Nineveh',
    county_fips: 18013,
    county_fips_all: '18013|18081',
    county: 'Brown',
    county_names_all: 'Brown|Johnson',
    county_weights: '{"18013": 85.94, "18081": 14.06}',
    density: 56.2,
    imprecise: false,
    latitude: 39.3036,
    longitude: -86.12301,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46164',
  },
  {
    city: 'North Salem',
    county_fips: 18063,
    county_fips_all: '18063|18133',
    county: 'Hendricks',
    county_names_all: 'Hendricks|Putnam',
    county_weights: '{"18063": 96.4, "18133": 3.6}',
    density: 18.4,
    imprecise: false,
    latitude: 39.84522,
    longitude: -86.64716,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46165',
  },
  {
    city: 'Paragon',
    county_fips: 18109,
    county_fips_all: '18109|18119',
    county: 'Morgan',
    county_names_all: 'Morgan|Owen',
    county_weights: '{"18109": 95.45, "18119": 4.55}',
    density: 27.9,
    imprecise: false,
    latitude: 39.42686,
    longitude: -86.58755,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46166',
  },
  {
    city: 'Pittsboro',
    county_fips: 18063,
    county_fips_all: '18063',
    county: 'Hendricks',
    county_names_all: 'Hendricks',
    county_weights: '{"18063": 100}',
    density: 92.3,
    imprecise: false,
    latitude: 39.87675,
    longitude: -86.46981,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 6944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46167',
  },
  {
    city: 'Plainfield',
    county_fips: 18063,
    county_fips_all: '18063',
    county: 'Hendricks',
    county_names_all: 'Hendricks',
    county_weights: '{"18063": 100}',
    density: 456.8,
    imprecise: false,
    latitude: 39.68985,
    longitude: -86.39262,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 38826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46168',
  },
  {
    city: 'Putnamville',
    county_fips: 18133,
    county_fips_all: '18133',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"18133": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.57164,
    longitude: -86.86277,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46170',
  },
  {
    city: 'Reelsville',
    county_fips: 18133,
    county_fips_all: '18133|18021',
    county: 'Putnam',
    county_names_all: 'Putnam|Clay',
    county_weights: '{"18133": 98.47, "18021": 1.53}',
    density: 20.1,
    imprecise: false,
    latitude: 39.53527,
    longitude: -86.96815,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46171',
  },
  {
    city: 'Roachdale',
    county_fips: 18133,
    county_fips_all: '18133|18107',
    county: 'Putnam',
    county_names_all: 'Putnam|Montgomery',
    county_weights: '{"18133": 94.73, "18107": 5.27}',
    density: 13.6,
    imprecise: false,
    latitude: 39.82725,
    longitude: -86.8144,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46172',
  },
  {
    city: 'Rushville',
    county_fips: 18139,
    county_fips_all: '18139|18031|18047|18041',
    county: 'Rush',
    county_names_all: 'Rush|Decatur|Franklin|Fayette',
    county_weights:
      '{"18139": 95.18, "18031": 2.23, "18047": 1.92, "18041": 0.67}',
    density: 17.9,
    imprecise: false,
    latitude: 39.60294,
    longitude: -85.42677,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 10440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46173',
  },
  {
    city: 'Russellville',
    county_fips: 18133,
    county_fips_all: '18133|18121',
    county: 'Putnam',
    county_names_all: 'Putnam|Parke',
    county_weights: '{"18133": 95.84, "18121": 4.16}',
    density: 8.1,
    imprecise: false,
    latitude: 39.82199,
    longitude: -86.97292,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46175',
  },
  {
    city: 'Shelbyville',
    county_fips: 18145,
    county_fips_all: '18145',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"18145": 100}',
    density: 65.6,
    imprecise: false,
    latitude: 39.52684,
    longitude: -85.77297,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 28782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46176',
  },
  {
    city: 'Stilesville',
    county_fips: 18109,
    county_fips_all: '18109|18063',
    county: 'Morgan',
    county_names_all: 'Morgan|Hendricks',
    county_weights: '{"18109": 55.86, "18063": 44.14}',
    density: 16.7,
    imprecise: false,
    latitude: 39.59652,
    longitude: -86.61801,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46180',
  },
  {
    city: 'Trafalgar',
    county_fips: 18081,
    county_fips_all: '18081|18013',
    county: 'Johnson',
    county_names_all: 'Johnson|Brown',
    county_weights: '{"18081": 84.64, "18013": 15.36}',
    density: 42.2,
    imprecise: false,
    latitude: 39.38044,
    longitude: -86.16119,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46181',
  },
  {
    city: 'Waldron',
    county_fips: 18145,
    county_fips_all: '18145|18139',
    county: 'Shelby',
    county_names_all: 'Shelby|Rush',
    county_weights: '{"18145": 82.07, "18139": 17.93}',
    density: 19.4,
    imprecise: false,
    latitude: 39.46157,
    longitude: -85.67005,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46182',
  },
  {
    city: 'West Newton',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 187.2,
    imprecise: false,
    latitude: 39.65397,
    longitude: -86.28121,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46183',
  },
  {
    city: 'Whiteland',
    county_fips: 18081,
    county_fips_all: '18081',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"18081": 100}',
    density: 283.6,
    imprecise: false,
    latitude: 39.55967,
    longitude: -86.07361,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 13304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46184',
  },
  {
    city: 'Wilkinson',
    county_fips: 18059,
    county_fips_all: '18059|18065',
    county: 'Hancock',
    county_names_all: 'Hancock|Henry',
    county_weights: '{"18059": 97.72, "18065": 2.28}',
    density: 25.1,
    imprecise: false,
    latitude: 39.89126,
    longitude: -85.64264,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46186',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 2097.5,
    imprecise: false,
    latitude: 39.77369,
    longitude: -86.10949,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 30335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46201',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1422.4,
    imprecise: false,
    latitude: 39.78363,
    longitude: -86.16187,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 20180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46202',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1045.9,
    imprecise: false,
    latitude: 39.7368,
    longitude: -86.09586,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 37758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46203',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 3871.1,
    imprecise: false,
    latitude: 39.77134,
    longitude: -86.15703,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 11400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46204',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1748,
    imprecise: false,
    latitude: 39.82813,
    longitude: -86.13499,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 28259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46205',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.76027,
    longitude: -86.16107,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46206',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1252.9,
    imprecise: false,
    latitude: 39.82307,
    longitude: -86.17307,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 22379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46208',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1266.3,
    imprecise: false,
    latitude: 39.7917,
    longitude: -86.29009,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 24472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46214',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 350.2,
    imprecise: false,
    latitude: 39.86593,
    longitude: -86.00929,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46216',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 673.7,
    imprecise: false,
    latitude: 39.67254,
    longitude: -86.19338,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 36917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46217',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1188.4,
    imprecise: false,
    latitude: 39.80713,
    longitude: -86.09958,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 29360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46218',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1150.3,
    imprecise: false,
    latitude: 39.78314,
    longitude: -86.04444,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 38855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46219',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1215.5,
    imprecise: false,
    latitude: 39.8676,
    longitude: -86.10818,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 36952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46220',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 522.3,
    imprecise: false,
    latitude: 39.69288,
    longitude: -86.23664,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 27027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46221',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1360,
    imprecise: false,
    latitude: 39.79088,
    longitude: -86.21477,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 38887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46222',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 2172.3,
    imprecise: false,
    latitude: 39.79537,
    longitude: -86.25624,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 40228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46224',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 585.8,
    imprecise: false,
    latitude: 39.74062,
    longitude: -86.16294,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 6037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46225',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1228.5,
    imprecise: false,
    latitude: 39.83968,
    longitude: -86.05117,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 47099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46226',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1332.2,
    imprecise: false,
    latitude: 39.67607,
    longitude: -86.13145,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 57587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46227',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 766.4,
    imprecise: false,
    latitude: 39.8487,
    longitude: -86.20045,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 15724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46228',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097|18059',
    county: 'Marion',
    county_names_all: 'Marion|Hancock',
    county_weights: '{"18097": 89.6, "18059": 10.4}',
    density: 968.4,
    imprecise: false,
    latitude: 39.78852,
    longitude: -85.978,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 28457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46229',
  },
  {
    city: 'Indianapolis',
    county_fips: 18063,
    county_fips_all: '18063|18097',
    county: 'Hendricks',
    county_names_all: 'Hendricks|Marion',
    county_weights: '{"18063": 52.39, "18097": 47.61}',
    density: 343.2,
    imprecise: false,
    latitude: 39.72086,
    longitude: -86.32712,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 10371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46231',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097|18063',
    county: 'Marion',
    county_names_all: 'Marion|Hendricks',
    county_weights: '{"18097": 51.92, "18063": 48.08}',
    density: 883.3,
    imprecise: false,
    latitude: 39.81077,
    longitude: -86.32665,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 28300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46234',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1463.5,
    imprecise: false,
    latitude: 39.83784,
    longitude: -85.97651,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 36317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46235',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097|18059',
    county: 'Marion',
    county_names_all: 'Marion|Hancock',
    county_weights: '{"18097": 99.9, "18059": 0.1}',
    density: 971.7,
    imprecise: false,
    latitude: 39.89132,
    longitude: -85.96766,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 26416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46236',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1143.8,
    imprecise: false,
    latitude: 39.67247,
    longitude: -86.0759,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 43473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46237',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097|18059',
    county: 'Marion',
    county_names_all: 'Marion|Hancock',
    county_weights: '{"18097": 99.16, "18059": 0.84}',
    density: 463.6,
    imprecise: false,
    latitude: 39.72311,
    longitude: -86.0004,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 33931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46239',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097|18057',
    county: 'Marion',
    county_names_all: 'Marion|Hamilton',
    county_weights: '{"18097": 97.9, "18057": 2.1}',
    density: 772.9,
    imprecise: false,
    latitude: 39.90697,
    longitude: -86.12367,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 19595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46240',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 526,
    imprecise: false,
    latitude: 39.72389,
    longitude: -86.26842,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 32565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46241',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097|18057',
    county: 'Marion',
    county_names_all: 'Marion|Hamilton',
    county_weights: '{"18097": 99.44, "18057": 0.56}',
    density: 904.7,
    imprecise: false,
    latitude: 39.90399,
    longitude: -86.06864,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 18147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46250',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"18097": 100}',
    density: 1247.7,
    imprecise: false,
    latitude: 39.84796,
    longitude: -86.26936,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 40674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46254',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097|18057',
    county: 'Marion',
    county_names_all: 'Marion|Hamilton',
    county_weights: '{"18097": 88.75, "18057": 11.25}',
    density: 727.2,
    imprecise: false,
    latitude: 39.90682,
    longitude: -86.01152,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 20990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46256',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097|18081|18145',
    county: 'Marion',
    county_names_all: 'Marion|Johnson|Shelby',
    county_weights: '{"18097": 67.89, "18081": 21.67, "18145": 10.44}',
    density: 258.2,
    imprecise: false,
    latitude: 39.65078,
    longitude: -85.98692,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 15169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46259',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097|18057',
    county: 'Marion',
    county_names_all: 'Marion|Hamilton',
    county_weights: '{"18097": 99.02, "18057": 0.98}',
    density: 1324,
    imprecise: false,
    latitude: 39.89744,
    longitude: -86.17927,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 35707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46260',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097|18011|18057',
    county: 'Marion',
    county_names_all: 'Marion|Boone|Hamilton',
    county_weights: '{"18097": 97.66, "18011": 1.71, "18057": 0.63}',
    density: 788.5,
    imprecise: false,
    latitude: 39.89769,
    longitude: -86.23253,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 25913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46268',
  },
  {
    city: 'Indianapolis',
    county_fips: 18097,
    county_fips_all: '18097|18063',
    county: 'Marion',
    county_names_all: 'Marion|Hendricks',
    county_weights: '{"18097": 95.74, "18063": 4.26}',
    density: 246.9,
    imprecise: false,
    latitude: 39.89389,
    longitude: -86.29606,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 8450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46278',
  },
  {
    city: 'Indianapolis',
    county_fips: 18057,
    county_fips_all: '18057',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"18057": 100}',
    density: 700,
    imprecise: false,
    latitude: 39.93714,
    longitude: -86.11786,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 7514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46280',
  },
  {
    city: 'Indianapolis',
    county_fips: 18057,
    county_fips_all: '18057',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"18057": 100}',
    density: 49,
    imprecise: false,
    latitude: 39.93376,
    longitude: -86.16256,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46290',
  },
  {
    city: 'Beverly Shores',
    county_fips: 18127,
    county_fips_all: '18127',
    county: 'Porter',
    county_names_all: 'Porter',
    county_weights: '{"18127": 100}',
    density: 57.1,
    imprecise: false,
    latitude: 41.68687,
    longitude: -86.97438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46301',
  },
  {
    city: 'Boone Grove',
    county_fips: 18127,
    county_fips_all: '18127',
    county: 'Porter',
    county_names_all: 'Porter',
    county_weights: '{"18127": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 41.3604,
    longitude: -87.12645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46302',
  },
  {
    city: 'Cedar Lake',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 237.4,
    imprecise: false,
    latitude: 41.37198,
    longitude: -87.4765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46303',
  },
  {
    city: 'Chesterton',
    county_fips: 18127,
    county_fips_all: '18127',
    county: 'Porter',
    county_names_all: 'Porter',
    county_weights: '{"18127": 100}',
    density: 189.2,
    imprecise: false,
    latitude: 41.61311,
    longitude: -87.04905,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46304',
  },
  {
    city: 'Crown Point',
    county_fips: 18089,
    county_fips_all: '18089|18127',
    county: 'Lake',
    county_names_all: 'Lake|Porter',
    county_weights: '{"18089": 97.07, "18127": 2.93}',
    density: 317.2,
    imprecise: false,
    latitude: 41.40215,
    longitude: -87.32693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 71673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46307',
  },
  {
    city: 'Demotte',
    county_fips: 18073,
    county_fips_all: '18073|18111',
    county: 'Jasper',
    county_names_all: 'Jasper|Newton',
    county_weights: '{"18073": 77.98, "18111": 22.02}',
    density: 85.7,
    imprecise: false,
    latitude: 41.18205,
    longitude: -87.23088,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46310',
  },
  {
    city: 'Dyer',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 714.6,
    imprecise: false,
    latitude: 41.46846,
    longitude: -87.50918,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46311',
  },
  {
    city: 'East Chicago',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 715.9,
    imprecise: false,
    latitude: 41.64705,
    longitude: -87.45446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46312',
  },
  {
    city: 'Griffith',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 719.2,
    imprecise: false,
    latitude: 41.52217,
    longitude: -87.42091,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46319',
  },
  {
    city: 'Hammond',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 1190,
    imprecise: false,
    latitude: 41.60893,
    longitude: -87.49754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46320',
  },
  {
    city: 'Munster',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 1206.6,
    imprecise: false,
    latitude: 41.54704,
    longitude: -87.50402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46321',
  },
  {
    city: 'Highland',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 1325.4,
    imprecise: false,
    latitude: 41.54818,
    longitude: -87.45884,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46322',
  },
  {
    city: 'Hammond',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 1435,
    imprecise: false,
    latitude: 41.58961,
    longitude: -87.45323,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46323',
  },
  {
    city: 'Hammond',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 1895.9,
    imprecise: false,
    latitude: 41.58324,
    longitude: -87.50155,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46324',
  },
  {
    city: 'Hammond',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 889.2,
    imprecise: false,
    latitude: 41.64048,
    longitude: -87.50677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46327',
  },
  {
    city: 'Hanna',
    county_fips: 18091,
    county_fips_all: '18091',
    county: 'LaPorte',
    county_names_all: 'LaPorte',
    county_weights: '{"18091": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 41.38339,
    longitude: -86.76846,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46340',
  },
  {
    city: 'Hebron',
    county_fips: 18127,
    county_fips_all: '18127|18089|18073',
    county: 'Porter',
    county_names_all: 'Porter|Lake|Jasper',
    county_weights: '{"18127": 49.73, "18089": 48.89, "18073": 1.38}',
    density: 40.6,
    imprecise: false,
    latitude: 41.30666,
    longitude: -87.21962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46341',
  },
  {
    city: 'Hobart',
    county_fips: 18089,
    county_fips_all: '18089|18127',
    county: 'Lake',
    county_names_all: 'Lake|Porter',
    county_weights: '{"18089": 72.16, "18127": 27.84}',
    density: 355.1,
    imprecise: false,
    latitude: 41.51761,
    longitude: -87.24468,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46342',
  },
  {
    city: 'Kingsbury',
    county_fips: 18091,
    county_fips_all: '18091',
    county: 'LaPorte',
    county_names_all: 'LaPorte',
    county_weights: '{"18091": 100}',
    density: 263.4,
    imprecise: false,
    latitude: 41.53032,
    longitude: -86.69995,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46345',
  },
  {
    city: 'Kingsford Heights',
    county_fips: 18091,
    county_fips_all: '18091',
    county: 'LaPorte',
    county_names_all: 'LaPorte',
    county_weights: '{"18091": 100}',
    density: 611.7,
    imprecise: false,
    latitude: 41.47816,
    longitude: -86.69332,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46346',
  },
  {
    city: 'Kouts',
    county_fips: 18127,
    county_fips_all: '18127',
    county: 'Porter',
    county_names_all: 'Porter',
    county_weights: '{"18127": 100}',
    density: 26.6,
    imprecise: false,
    latitude: 41.30502,
    longitude: -87.00859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46347',
  },
  {
    city: 'La Crosse',
    county_fips: 18091,
    county_fips_all: '18091|18127',
    county: 'LaPorte',
    county_names_all: 'LaPorte|Porter',
    county_weights: '{"18091": 98.92, "18127": 1.08}',
    density: 9.3,
    imprecise: false,
    latitude: 41.30981,
    longitude: -86.86244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46348',
  },
  {
    city: 'Lake Village',
    county_fips: 18111,
    county_fips_all: '18111',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"18111": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 41.10899,
    longitude: -87.42359,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46349',
  },
  {
    city: 'La Porte',
    county_fips: 18091,
    county_fips_all: '18091',
    county: 'LaPorte',
    county_names_all: 'LaPorte',
    county_weights: '{"18091": 100}',
    density: 89.3,
    imprecise: false,
    latitude: 41.60697,
    longitude: -86.72157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46350',
  },
  {
    city: 'Lowell',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 67.7,
    imprecise: false,
    latitude: 41.26117,
    longitude: -87.41863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46356',
  },
  {
    city: 'Michigan City',
    county_fips: 18091,
    county_fips_all: '18091|18127',
    county: 'LaPorte',
    county_names_all: 'LaPorte|Porter',
    county_weights: '{"18091": 84.22, "18127": 15.78}',
    density: 220.9,
    imprecise: false,
    latitude: 41.68739,
    longitude: -86.86464,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46360',
  },
  {
    city: 'Mill Creek',
    county_fips: 18091,
    county_fips_all: '18091',
    county: 'LaPorte',
    county_names_all: 'LaPorte',
    county_weights: '{"18091": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 41.60605,
    longitude: -86.54112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46365',
  },
  {
    city: 'North Judson',
    county_fips: 18149,
    county_fips_all: '18149|18131',
    county: 'Starke',
    county_names_all: 'Starke|Pulaski',
    county_weights: '{"18149": 85.09, "18131": 14.91}',
    density: 27,
    imprecise: false,
    latitude: 41.21443,
    longitude: -86.76922,
    militaryZip: false,
    timezone: 'America/Indiana/Knox',
    population: 5601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46366',
  },
  {
    city: 'Portage',
    county_fips: 18127,
    county_fips_all: '18127',
    county: 'Porter',
    county_names_all: 'Porter',
    county_weights: '{"18127": 100}',
    density: 614.2,
    imprecise: false,
    latitude: 41.5848,
    longitude: -87.17937,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46368',
  },
  {
    city: 'Rolling Prairie',
    county_fips: 18091,
    county_fips_all: '18091',
    county: 'LaPorte',
    county_names_all: 'LaPorte',
    county_weights: '{"18091": 100}',
    density: 34.9,
    imprecise: false,
    latitude: 41.67683,
    longitude: -86.6005,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46371',
  },
  {
    city: 'Saint John',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 668.6,
    imprecise: false,
    latitude: 41.44578,
    longitude: -87.46954,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46373',
  },
  {
    city: 'San Pierre',
    county_fips: 18149,
    county_fips_all: '18149|18073|18131',
    county: 'Starke',
    county_names_all: 'Starke|Jasper|Pulaski',
    county_weights: '{"18149": 71.8, "18073": 15.03, "18131": 13.16}',
    density: 14.3,
    imprecise: false,
    latitude: 41.20616,
    longitude: -86.895,
    militaryZip: false,
    timezone: 'America/Indiana/Knox',
    population: 1290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46374',
  },
  {
    city: 'Schererville',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 732,
    imprecise: false,
    latitude: 41.49162,
    longitude: -87.45193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46375',
  },
  {
    city: 'Schneider',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 41.1838,
    longitude: -87.47603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46376',
  },
  {
    city: 'Shelby',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 84.1,
    imprecise: false,
    latitude: 41.19432,
    longitude: -87.34777,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46377',
  },
  {
    city: 'Sumava Resorts',
    county_fips: 18111,
    county_fips_all: '18111',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"18111": 100}',
    density: 29.5,
    imprecise: false,
    latitude: 41.15682,
    longitude: -87.4302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46379',
  },
  {
    city: 'Thayer',
    county_fips: 18111,
    county_fips_all: '18111',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"18111": 100}',
    density: 38.3,
    imprecise: false,
    latitude: 41.17635,
    longitude: -87.33436,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46381',
  },
  {
    city: 'Union Mills',
    county_fips: 18091,
    county_fips_all: '18091',
    county: 'LaPorte',
    county_names_all: 'LaPorte',
    county_weights: '{"18091": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 41.46868,
    longitude: -86.76212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46382',
  },
  {
    city: 'Valparaiso',
    county_fips: 18127,
    county_fips_all: '18127',
    county: 'Porter',
    county_names_all: 'Porter',
    county_weights: '{"18127": 100}',
    density: 186,
    imprecise: false,
    latitude: 41.45838,
    longitude: -87.00156,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46383',
  },
  {
    city: 'Valparaiso',
    county_fips: 18127,
    county_fips_all: '18127',
    county: 'Porter',
    county_names_all: 'Porter',
    county_weights: '{"18127": 100}',
    density: 195.4,
    imprecise: false,
    latitude: 41.46395,
    longitude: -87.12396,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46385',
  },
  {
    city: 'Wanatah',
    county_fips: 18091,
    county_fips_all: '18091|18127',
    county: 'LaPorte',
    county_names_all: 'LaPorte|Porter',
    county_weights: '{"18091": 99.28, "18127": 0.72}',
    density: 20.1,
    imprecise: false,
    latitude: 41.41677,
    longitude: -86.8742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46390',
  },
  {
    city: 'Westville',
    county_fips: 18091,
    county_fips_all: '18091|18127',
    county: 'LaPorte',
    county_names_all: 'LaPorte|Porter',
    county_weights: '{"18091": 66.88, "18127": 33.12}',
    density: 87.4,
    imprecise: false,
    latitude: 41.5455,
    longitude: -86.91446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46391',
  },
  {
    city: 'Wheatfield',
    county_fips: 18073,
    county_fips_all: '18073',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"18073": 100}',
    density: 29.6,
    imprecise: false,
    latitude: 41.18509,
    longitude: -87.04948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46392',
  },
  {
    city: 'Wheeler',
    county_fips: 18127,
    county_fips_all: '18127',
    county: 'Porter',
    county_names_all: 'Porter',
    county_weights: '{"18127": 100}',
    density: 48.6,
    imprecise: false,
    latitude: 41.5139,
    longitude: -87.16801,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46393',
  },
  {
    city: 'Whiting',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 968.4,
    imprecise: false,
    latitude: 41.67733,
    longitude: -87.50279,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46394',
  },
  {
    city: 'Gary',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 267.1,
    imprecise: false,
    latitude: 41.61032,
    longitude: -87.33297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46402',
  },
  {
    city: 'Gary',
    county_fips: 18089,
    county_fips_all: '18089|18127',
    county: 'Lake',
    county_names_all: 'Lake|Porter',
    county_weights: '{"18089": 89.6, "18127": 10.4}',
    density: 461.7,
    imprecise: false,
    latitude: 41.60636,
    longitude: -87.25803,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46403',
  },
  {
    city: 'Gary',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 991.6,
    imprecise: false,
    latitude: 41.58475,
    longitude: -87.37502,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46404',
  },
  {
    city: 'Lake Station',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 521.1,
    imprecise: false,
    latitude: 41.57409,
    longitude: -87.26285,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46405',
  },
  {
    city: 'Gary',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 257.9,
    imprecise: false,
    latitude: 41.6022,
    longitude: -87.40804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46406',
  },
  {
    city: 'Gary',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 793.1,
    imprecise: false,
    latitude: 41.57844,
    longitude: -87.33047,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46407',
  },
  {
    city: 'Gary',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 624.2,
    imprecise: false,
    latitude: 41.54468,
    longitude: -87.36941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46408',
  },
  {
    city: 'Gary',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 774.9,
    imprecise: false,
    latitude: 41.54828,
    longitude: -87.32422,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46409',
  },
  {
    city: 'Merrillville',
    county_fips: 18089,
    county_fips_all: '18089',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"18089": 100}',
    density: 504.2,
    imprecise: false,
    latitude: 41.48083,
    longitude: -87.33293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46410',
  },
  {
    city: 'Argos',
    county_fips: 18099,
    county_fips_all: '18099|18049',
    county: 'Marshall',
    county_names_all: 'Marshall|Fulton',
    county_weights: '{"18099": 96.79, "18049": 3.21}',
    density: 20.5,
    imprecise: false,
    latitude: 41.22327,
    longitude: -86.24868,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46501',
  },
  {
    city: 'Atwood',
    county_fips: 18085,
    county_fips_all: '18085',
    county: 'Kosciusko',
    county_names_all: 'Kosciusko',
    county_weights: '{"18085": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.26099,
    longitude: -85.97699,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46502',
  },
  {
    city: 'Bourbon',
    county_fips: 18099,
    county_fips_all: '18099|18085',
    county: 'Marshall',
    county_names_all: 'Marshall|Kosciusko',
    county_weights: '{"18099": 95.78, "18085": 4.22}',
    density: 20.3,
    imprecise: false,
    latitude: 41.30057,
    longitude: -86.11204,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46504',
  },
  {
    city: 'Bremen',
    county_fips: 18099,
    county_fips_all: '18099|18141|18085',
    county: 'Marshall',
    county_names_all: 'Marshall|St. Joseph|Kosciusko',
    county_weights: '{"18099": 61.78, "18141": 37.51, "18085": 0.71}',
    density: 38.2,
    imprecise: false,
    latitude: 41.46316,
    longitude: -86.16915,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 9994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46506',
  },
  {
    city: 'Bristol',
    county_fips: 18039,
    county_fips_all: '18039',
    county: 'Elkhart',
    county_names_all: 'Elkhart',
    county_weights: '{"18039": 100}',
    density: 95.6,
    imprecise: false,
    latitude: 41.72138,
    longitude: -85.81571,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 9991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46507',
  },
  {
    city: 'Burket',
    county_fips: 18085,
    county_fips_all: '18085',
    county: 'Kosciusko',
    county_names_all: 'Kosciusko',
    county_weights: '{"18085": 100}',
    density: 976.6,
    imprecise: false,
    latitude: 41.15499,
    longitude: -85.96904,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46508',
  },
  {
    city: 'Claypool',
    county_fips: 18085,
    county_fips_all: '18085',
    county: 'Kosciusko',
    county_names_all: 'Kosciusko',
    county_weights: '{"18085": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 41.12068,
    longitude: -85.874,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46510',
  },
  {
    city: 'Culver',
    county_fips: 18099,
    county_fips_all: '18099|18149|18049|18131',
    county: 'Marshall',
    county_names_all: 'Marshall|Starke|Fulton|Pulaski',
    county_weights:
      '{"18099": 66.28, "18149": 21.74, "18049": 11.46, "18131": 0.52}',
    density: 21.7,
    imprecise: false,
    latitude: 41.22182,
    longitude: -86.42889,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46511',
  },
  {
    city: 'Donaldson',
    county_fips: 18099,
    county_fips_all: '18099',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"18099": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.3629,
    longitude: -86.44816,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46513',
  },
  {
    city: 'Elkhart',
    county_fips: 18039,
    county_fips_all: '18039',
    county: 'Elkhart',
    county_names_all: 'Elkhart',
    county_weights: '{"18039": 100}',
    density: 423,
    imprecise: false,
    latitude: 41.72328,
    longitude: -85.97547,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 42389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46514',
  },
  {
    city: 'Elkhart',
    county_fips: 18039,
    county_fips_all: '18039',
    county: 'Elkhart',
    county_names_all: 'Elkhart',
    county_weights: '{"18039": 100}',
    density: 703.1,
    imprecise: false,
    latitude: 41.6756,
    longitude: -85.94584,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 31871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46516',
  },
  {
    city: 'Elkhart',
    county_fips: 18039,
    county_fips_all: '18039',
    county: 'Elkhart',
    county_names_all: 'Elkhart',
    county_weights: '{"18039": 100}',
    density: 266,
    imprecise: false,
    latitude: 41.62429,
    longitude: -85.99675,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 25433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46517',
  },
  {
    city: 'Etna Green',
    county_fips: 18085,
    county_fips_all: '18085|18099',
    county: 'Kosciusko',
    county_names_all: 'Kosciusko|Marshall',
    county_weights: '{"18085": 98.58, "18099": 1.42}',
    density: 22.5,
    imprecise: false,
    latitude: 41.2979,
    longitude: -86.02143,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46524',
  },
  {
    city: 'Goshen',
    county_fips: 18039,
    county_fips_all: '18039',
    county: 'Elkhart',
    county_names_all: 'Elkhart',
    county_weights: '{"18039": 100}',
    density: 193.8,
    imprecise: false,
    latitude: 41.55307,
    longitude: -85.88448,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 33668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46526',
  },
  {
    city: 'Goshen',
    county_fips: 18039,
    county_fips_all: '18039',
    county: 'Elkhart',
    county_names_all: 'Elkhart',
    county_weights: '{"18039": 100}',
    density: 139.8,
    imprecise: false,
    latitude: 41.60698,
    longitude: -85.786,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 26248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46528',
  },
  {
    city: 'Granger',
    county_fips: 18141,
    county_fips_all: '18141|18039',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph|Elkhart',
    county_weights: '{"18141": 88.58, "18039": 11.42}',
    density: 501.7,
    imprecise: false,
    latitude: 41.74031,
    longitude: -86.12749,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 31598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46530',
  },
  {
    city: 'Grovertown',
    county_fips: 18149,
    county_fips_all: '18149|18099',
    county: 'Starke',
    county_names_all: 'Starke|Marshall',
    county_weights: '{"18149": 98.92, "18099": 1.08}',
    density: 33.2,
    imprecise: false,
    latitude: 41.35686,
    longitude: -86.51558,
    militaryZip: false,
    timezone: 'America/Indiana/Knox',
    population: 1825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46531',
  },
  {
    city: 'Hamlet',
    county_fips: 18149,
    county_fips_all: '18149|18091',
    county: 'Starke',
    county_names_all: 'Starke|LaPorte',
    county_weights: '{"18149": 58.75, "18091": 41.25}',
    density: 14.4,
    imprecise: false,
    latitude: 41.41762,
    longitude: -86.62119,
    militaryZip: false,
    timezone: 'America/Indiana/Knox',
    population: 1921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46532',
  },
  {
    city: 'Knox',
    county_fips: 18149,
    county_fips_all: '18149',
    county: 'Starke',
    county_names_all: 'Starke',
    county_weights: '{"18149": 100}',
    density: 34.8,
    imprecise: false,
    latitude: 41.28561,
    longitude: -86.61878,
    militaryZip: false,
    timezone: 'America/Indiana/Knox',
    population: 10811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46534',
  },
  {
    city: 'Lakeville',
    county_fips: 18141,
    county_fips_all: '18141|18099',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph|Marshall',
    county_weights: '{"18141": 91.45, "18099": 8.55}',
    density: 39.1,
    imprecise: false,
    latitude: 41.51913,
    longitude: -86.2867,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46536',
  },
  {
    city: 'Lapaz',
    county_fips: 18099,
    county_fips_all: '18099',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"18099": 100}',
    density: 442.5,
    imprecise: false,
    latitude: 41.45724,
    longitude: -86.30669,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46537',
  },
  {
    city: 'Leesburg',
    county_fips: 18085,
    county_fips_all: '18085',
    county: 'Kosciusko',
    county_names_all: 'Kosciusko',
    county_weights: '{"18085": 100}',
    density: 51.8,
    imprecise: false,
    latitude: 41.32829,
    longitude: -85.82703,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46538',
  },
  {
    city: 'Mentone',
    county_fips: 18085,
    county_fips_all: '18085|18049|18099',
    county: 'Kosciusko',
    county_names_all: 'Kosciusko|Fulton|Marshall',
    county_weights: '{"18085": 86.1, "18049": 8.2, "18099": 5.7}',
    density: 29.5,
    imprecise: false,
    latitude: 41.16579,
    longitude: -86.02545,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46539',
  },
  {
    city: 'Middlebury',
    county_fips: 18039,
    county_fips_all: '18039|18087',
    county: 'Elkhart',
    county_names_all: 'Elkhart|LaGrange',
    county_weights: '{"18039": 85.1, "18087": 14.9}',
    density: 84.5,
    imprecise: false,
    latitude: 41.67571,
    longitude: -85.69768,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 12993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46540',
  },
  {
    city: 'Milford',
    county_fips: 18085,
    county_fips_all: '18085|18039',
    county: 'Kosciusko',
    county_names_all: 'Kosciusko|Elkhart',
    county_weights: '{"18085": 96.33, "18039": 3.67}',
    density: 38.8,
    imprecise: false,
    latitude: 41.39303,
    longitude: -85.87448,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46542',
  },
  {
    city: 'Millersburg',
    county_fips: 18039,
    county_fips_all: '18039|18087|18113',
    county: 'Elkhart',
    county_names_all: 'Elkhart|LaGrange|Noble',
    county_weights: '{"18039": 64.48, "18087": 33.87, "18113": 1.65}',
    density: 60.3,
    imprecise: false,
    latitude: 41.53341,
    longitude: -85.67119,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46543',
  },
  {
    city: 'Mishawaka',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 301.6,
    imprecise: false,
    latitude: 41.61778,
    longitude: -86.13715,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 31077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46544',
  },
  {
    city: 'Mishawaka',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 560.7,
    imprecise: false,
    latitude: 41.69376,
    longitude: -86.14602,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 26606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46545',
  },
  {
    city: 'Nappanee',
    county_fips: 18039,
    county_fips_all: '18039|18085|18099|18141',
    county: 'Elkhart',
    county_names_all: 'Elkhart|Kosciusko|Marshall|St. Joseph',
    county_weights:
      '{"18039": 53.66, "18085": 34.97, "18099": 6.47, "18141": 4.9}',
    density: 69.2,
    imprecise: false,
    latitude: 41.44701,
    longitude: -86.00028,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 12843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46550',
  },
  {
    city: 'New Carlisle',
    county_fips: 18141,
    county_fips_all: '18141|18091',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph|LaPorte',
    county_weights: '{"18141": 75.19, "18091": 24.81}',
    density: 42.6,
    imprecise: false,
    latitude: 41.70731,
    longitude: -86.485,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 7047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46552',
  },
  {
    city: 'New Paris',
    county_fips: 18039,
    county_fips_all: '18039',
    county: 'Elkhart',
    county_names_all: 'Elkhart',
    county_weights: '{"18039": 100}',
    density: 47.1,
    imprecise: false,
    latitude: 41.48004,
    longitude: -85.85095,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46553',
  },
  {
    city: 'North Liberty',
    county_fips: 18141,
    county_fips_all: '18141|18091',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph|LaPorte',
    county_weights: '{"18141": 95.02, "18091": 4.98}',
    density: 25,
    imprecise: false,
    latitude: 41.56252,
    longitude: -86.41947,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46554',
  },
  {
    city: 'North Webster',
    county_fips: 18085,
    county_fips_all: '18085',
    county: 'Kosciusko',
    county_names_all: 'Kosciusko',
    county_weights: '{"18085": 100}',
    density: 96.2,
    imprecise: false,
    latitude: 41.32858,
    longitude: -85.68833,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46555',
  },
  {
    city: 'Notre Dame',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 1956.3,
    imprecise: false,
    latitude: 41.70198,
    longitude: -86.24513,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 8344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46556',
  },
  {
    city: 'Osceola',
    county_fips: 18141,
    county_fips_all: '18141|18039',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph|Elkhart',
    county_weights: '{"18141": 88.5, "18039": 11.5}',
    density: 398.3,
    imprecise: false,
    latitude: 41.66683,
    longitude: -86.07599,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 13996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46561',
  },
  {
    city: 'Pierceton',
    county_fips: 18085,
    county_fips_all: '18085|18183|18113',
    county: 'Kosciusko',
    county_names_all: 'Kosciusko|Whitley|Noble',
    county_weights: '{"18085": 83.78, "18183": 12.46, "18113": 3.76}',
    density: 32.3,
    imprecise: false,
    latitude: 41.20947,
    longitude: -85.69757,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46562',
  },
  {
    city: 'Plymouth',
    county_fips: 18099,
    county_fips_all: '18099|18149|18141',
    county: 'Marshall',
    county_names_all: 'Marshall|Starke|St. Joseph',
    county_weights: '{"18099": 98.64, "18149": 1.23, "18141": 0.13}',
    density: 59.5,
    imprecise: false,
    latitude: 41.35541,
    longitude: -86.32612,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 23615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46563',
  },
  {
    city: 'Shipshewana',
    county_fips: 18087,
    county_fips_all: '18087|18039',
    county: 'LaGrange',
    county_names_all: 'LaGrange|Elkhart',
    county_weights: '{"18087": 99.42, "18039": 0.58}',
    density: 55,
    imprecise: false,
    latitude: 41.69285,
    longitude: -85.5831,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 9014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46565',
  },
  {
    city: 'Syracuse',
    county_fips: 18085,
    county_fips_all: '18085|18039',
    county: 'Kosciusko',
    county_names_all: 'Kosciusko|Elkhart',
    county_weights: '{"18085": 65.64, "18039": 34.36}',
    density: 62.6,
    imprecise: false,
    latitude: 41.41473,
    longitude: -85.73044,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 9292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46567',
  },
  {
    city: 'Tippecanoe',
    county_fips: 18099,
    county_fips_all: '18099|18049',
    county: 'Marshall',
    county_names_all: 'Marshall|Fulton',
    county_weights: '{"18099": 97.72, "18049": 2.28}',
    density: 24.8,
    imprecise: false,
    latitude: 41.20766,
    longitude: -86.1207,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46570',
  },
  {
    city: 'Topeka',
    county_fips: 18087,
    county_fips_all: '18087|18113',
    county: 'LaGrange',
    county_names_all: 'LaGrange|Noble',
    county_weights: '{"18087": 95.16, "18113": 4.84}',
    density: 54.2,
    imprecise: false,
    latitude: 41.56795,
    longitude: -85.54667,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 6315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46571',
  },
  {
    city: 'Tyner',
    county_fips: 18099,
    county_fips_all: '18099',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"18099": 100}',
    density: 111.5,
    imprecise: false,
    latitude: 41.40804,
    longitude: -86.393,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46572',
  },
  {
    city: 'Wakarusa',
    county_fips: 18039,
    county_fips_all: '18039|18141',
    county: 'Elkhart',
    county_names_all: 'Elkhart|St. Joseph',
    county_weights: '{"18039": 51.01, "18141": 48.99}',
    density: 44.1,
    imprecise: false,
    latitude: 41.53941,
    longitude: -86.06054,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46573',
  },
  {
    city: 'Walkerton',
    county_fips: 18091,
    county_fips_all: '18091|18141|18099|18149',
    county: 'LaPorte',
    county_names_all: 'LaPorte|St. Joseph|Marshall|Starke',
    county_weights:
      '{"18091": 32.85, "18141": 29.38, "18099": 24.77, "18149": 13.0}',
    density: 29.4,
    imprecise: false,
    latitude: 41.47327,
    longitude: -86.48829,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 7426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46574',
  },
  {
    city: 'Warsaw',
    county_fips: 18085,
    county_fips_all: '18085',
    county: 'Kosciusko',
    county_names_all: 'Kosciusko',
    county_weights: '{"18085": 100}',
    density: 118.3,
    imprecise: false,
    latitude: 41.20884,
    longitude: -85.87212,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 21794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46580',
  },
  {
    city: 'Warsaw',
    county_fips: 18085,
    county_fips_all: '18085',
    county: 'Kosciusko',
    county_names_all: 'Kosciusko',
    county_weights: '{"18085": 100}',
    density: 97.8,
    imprecise: false,
    latitude: 41.28323,
    longitude: -85.85235,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 14604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46582',
  },
  {
    city: 'Winona Lake',
    county_fips: 18085,
    county_fips_all: '18085',
    county: 'Kosciusko',
    county_names_all: 'Kosciusko',
    county_weights: '{"18085": 100}',
    density: 704.4,
    imprecise: false,
    latitude: 41.21612,
    longitude: -85.80862,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46590',
  },
  {
    city: 'Wyatt',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.52633,
    longitude: -86.16367,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46595',
  },
  {
    city: 'South Bend',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 941.8,
    imprecise: false,
    latitude: 41.67065,
    longitude: -86.252,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46601',
  },
  {
    city: 'South Bend',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 1474.4,
    imprecise: false,
    latitude: 41.65389,
    longitude: -86.264,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 12279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46613',
  },
  {
    city: 'South Bend',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 214.6,
    imprecise: false,
    latitude: 41.60359,
    longitude: -86.28064,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 29602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46614',
  },
  {
    city: 'South Bend',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 1659.5,
    imprecise: false,
    latitude: 41.67494,
    longitude: -86.21151,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 14190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46615',
  },
  {
    city: 'South Bend',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 1607.9,
    imprecise: false,
    latitude: 41.69693,
    longitude: -86.26671,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46616',
  },
  {
    city: 'South Bend',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 1479,
    imprecise: false,
    latitude: 41.68435,
    longitude: -86.23513,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 10032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46617',
  },
  {
    city: 'South Bend',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 356.7,
    imprecise: false,
    latitude: 41.65997,
    longitude: -86.3532,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 21729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46619',
  },
  {
    city: 'South Bend',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 884.1,
    imprecise: false,
    latitude: 41.70252,
    longitude: -86.25164,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46624',
  },
  {
    city: 'South Bend',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 312.8,
    imprecise: false,
    latitude: 41.72103,
    longitude: -86.33465,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 27685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46628',
  },
  {
    city: 'South Bend',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 797.9,
    imprecise: false,
    latitude: 41.71518,
    longitude: -86.20832,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 6410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46635',
  },
  {
    city: 'South Bend',
    county_fips: 18141,
    county_fips_all: '18141',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"18141": 100}',
    density: 625.9,
    imprecise: false,
    latitude: 41.73358,
    longitude: -86.24299,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 16200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46637',
  },
  {
    city: 'Albion',
    county_fips: 18113,
    county_fips_all: '18113',
    county: 'Noble',
    county_names_all: 'Noble',
    county_weights: '{"18113": 100}',
    density: 31.7,
    imprecise: false,
    latitude: 41.35846,
    longitude: -85.43034,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 7944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46701',
  },
  {
    city: 'Andrews',
    county_fips: 18069,
    county_fips_all: '18069|18169',
    county: 'Huntington',
    county_names_all: 'Huntington|Wabash',
    county_weights: '{"18069": 81.9, "18169": 18.1}',
    density: 18.3,
    imprecise: false,
    latitude: 40.82681,
    longitude: -85.61732,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46702',
  },
  {
    city: 'Angola',
    county_fips: 18151,
    county_fips_all: '18151',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"18151": 100}',
    density: 59.2,
    imprecise: false,
    latitude: 41.65305,
    longitude: -85.00976,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 18572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46703',
  },
  {
    city: 'Arcola',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 403,
    imprecise: false,
    latitude: 41.10371,
    longitude: -85.29242,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46704',
  },
  {
    city: 'Ashley',
    county_fips: 18033,
    county_fips_all: '18033|18151',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Steuben',
    county_weights: '{"18033": 69.55, "18151": 30.45}',
    density: 34.2,
    imprecise: false,
    latitude: 41.51816,
    longitude: -85.06029,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46705',
  },
  {
    city: 'Auburn',
    county_fips: 18033,
    county_fips_all: '18033|18003',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Allen',
    county_weights: '{"18033": 96.35, "18003": 3.65}',
    density: 89.6,
    imprecise: false,
    latitude: 41.34242,
    longitude: -85.03922,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 20403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46706',
  },
  {
    city: 'Avilla',
    county_fips: 18113,
    county_fips_all: '18113|18033',
    county: 'Noble',
    county_names_all: 'Noble|DeKalb',
    county_weights: '{"18113": 86.79, "18033": 13.21}',
    density: 39.1,
    imprecise: false,
    latitude: 41.35167,
    longitude: -85.25168,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46710',
  },
  {
    city: 'Berne',
    county_fips: 18001,
    county_fips_all: '18001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"18001": 100}',
    density: 56,
    imprecise: false,
    latitude: 40.6635,
    longitude: -84.92398,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 8353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46711',
  },
  {
    city: 'Bluffton',
    county_fips: 18179,
    county_fips_all: '18179|18001',
    county: 'Wells',
    county_names_all: 'Wells|Adams',
    county_weights: '{"18179": 92.16, "18001": 7.84}',
    density: 45.6,
    imprecise: false,
    latitude: 40.71774,
    longitude: -85.17319,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 15734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46714',
  },
  {
    city: 'Butler',
    county_fips: 18033,
    county_fips_all: '18033',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"18033": 100}',
    density: 23.3,
    imprecise: false,
    latitude: 41.4237,
    longitude: -84.87425,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46721',
  },
  {
    city: 'Churubusco',
    county_fips: 18183,
    county_fips_all: '18183|18003|18113',
    county: 'Whitley',
    county_names_all: 'Whitley|Allen|Noble',
    county_weights: '{"18183": 40.4, "18003": 36.76, "18113": 22.83}',
    density: 50.5,
    imprecise: false,
    latitude: 41.23828,
    longitude: -85.32441,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 7617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46723',
  },
  {
    city: 'Columbia City',
    county_fips: 18183,
    county_fips_all: '18183|18113',
    county: 'Whitley',
    county_names_all: 'Whitley|Noble',
    county_weights: '{"18183": 97.79, "18113": 2.21}',
    density: 44.4,
    imprecise: false,
    latitude: 41.1518,
    longitude: -85.47655,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 23297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46725',
  },
  {
    city: 'Corunna',
    county_fips: 18033,
    county_fips_all: '18033',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"18033": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 41.454,
    longitude: -85.15504,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46730',
  },
  {
    city: 'Craigville',
    county_fips: 18179,
    county_fips_all: '18179',
    county: 'Wells',
    county_names_all: 'Wells',
    county_weights: '{"18179": 100}',
    density: 16.1,
    imprecise: false,
    latitude: 40.79751,
    longitude: -85.10267,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46731',
  },
  {
    city: 'Cromwell',
    county_fips: 18113,
    county_fips_all: '18113|18085',
    county: 'Noble',
    county_names_all: 'Noble|Kosciusko',
    county_weights: '{"18113": 92.87, "18085": 7.13}',
    density: 36.7,
    imprecise: false,
    latitude: 41.37697,
    longitude: -85.62169,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46732',
  },
  {
    city: 'Decatur',
    county_fips: 18001,
    county_fips_all: '18001|18003',
    county: 'Adams',
    county_names_all: 'Adams|Allen',
    county_weights: '{"18001": 97.02, "18003": 2.98}',
    density: 43.3,
    imprecise: false,
    latitude: 40.83033,
    longitude: -84.94023,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 19318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46733',
  },
  {
    city: 'Fremont',
    county_fips: 18151,
    county_fips_all: '18151',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"18151": 100}',
    density: 44.9,
    imprecise: false,
    latitude: 41.72209,
    longitude: -84.92233,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 7402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46737',
  },
  {
    city: 'Garrett',
    county_fips: 18033,
    county_fips_all: '18033',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"18033": 100}',
    density: 126.5,
    imprecise: false,
    latitude: 41.32189,
    longitude: -85.13731,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 8533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46738',
  },
  {
    city: 'Geneva',
    county_fips: 18001,
    county_fips_all: '18001|18179',
    county: 'Adams',
    county_names_all: 'Adams|Wells',
    county_weights: '{"18001": 91.82, "18179": 8.18}',
    density: 27.8,
    imprecise: false,
    latitude: 40.60298,
    longitude: -84.9638,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46740',
  },
  {
    city: 'Grabill',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 72.5,
    imprecise: false,
    latitude: 41.21161,
    longitude: -84.95176,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46741',
  },
  {
    city: 'Hamilton',
    county_fips: 18151,
    county_fips_all: '18151|18033',
    county: 'Steuben',
    county_names_all: 'Steuben|DeKalb',
    county_weights: '{"18151": 69.5, "18033": 30.5}',
    density: 24.5,
    imprecise: false,
    latitude: 41.54919,
    longitude: -84.87892,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46742',
  },
  {
    city: 'Harlan',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 38.8,
    imprecise: false,
    latitude: 41.21511,
    longitude: -84.85321,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46743',
  },
  {
    city: 'Hoagland',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 37.3,
    imprecise: false,
    latitude: 40.95194,
    longitude: -85.00887,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46745',
  },
  {
    city: 'Howe',
    county_fips: 18087,
    county_fips_all: '18087',
    county: 'LaGrange',
    county_names_all: 'LaGrange',
    county_weights: '{"18087": 100}',
    density: 25.3,
    imprecise: false,
    latitude: 41.72257,
    longitude: -85.34914,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46746',
  },
  {
    city: 'Hudson',
    county_fips: 18151,
    county_fips_all: '18151|18033|18087',
    county: 'Steuben',
    county_names_all: 'Steuben|DeKalb|LaGrange',
    county_weights: '{"18151": 74.26, "18033": 13.5, "18087": 12.24}',
    density: 25,
    imprecise: false,
    latitude: 41.56042,
    longitude: -85.15349,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46747',
  },
  {
    city: 'Huntertown',
    county_fips: 18003,
    county_fips_all: '18003|18113|18033',
    county: 'Allen',
    county_names_all: 'Allen|Noble|DeKalb',
    county_weights: '{"18003": 92.84, "18113": 4.41, "18033": 2.75}',
    density: 142.8,
    imprecise: false,
    latitude: 41.24829,
    longitude: -85.16727,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 6902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46748',
  },
  {
    city: 'Huntington',
    county_fips: 18069,
    county_fips_all: '18069|18183',
    county: 'Huntington',
    county_names_all: 'Huntington|Whitley',
    county_weights: '{"18069": 99.59, "18183": 0.41}',
    density: 52.3,
    imprecise: false,
    latitude: 40.87677,
    longitude: -85.49674,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 27271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46750',
  },
  {
    city: 'Kendallville',
    county_fips: 18113,
    county_fips_all: '18113|18033',
    county: 'Noble',
    county_names_all: 'Noble|DeKalb',
    county_weights: '{"18113": 98.42, "18033": 1.58}',
    density: 79.6,
    imprecise: false,
    latitude: 41.45119,
    longitude: -85.27209,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 15441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46755',
  },
  {
    city: 'Keystone',
    county_fips: 18179,
    county_fips_all: '18179',
    county: 'Wells',
    county_names_all: 'Wells',
    county_weights: '{"18179": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 40.59855,
    longitude: -85.18299,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46759',
  },
  {
    city: 'Kimmell',
    county_fips: 18113,
    county_fips_all: '18113',
    county: 'Noble',
    county_names_all: 'Noble',
    county_weights: '{"18113": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 41.34441,
    longitude: -85.55654,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46760',
  },
  {
    city: 'Lagrange',
    county_fips: 18087,
    county_fips_all: '18087|18151',
    county: 'LaGrange',
    county_names_all: 'LaGrange|Steuben',
    county_weights: '{"18087": 99.0, "18151": 1.0}',
    density: 37.7,
    imprecise: false,
    latitude: 41.63576,
    longitude: -85.37127,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 12032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46761',
  },
  {
    city: 'Laotto',
    county_fips: 18113,
    county_fips_all: '18113|18033',
    county: 'Noble',
    county_names_all: 'Noble|DeKalb',
    county_weights: '{"18113": 81.31, "18033": 18.69}',
    density: 22.5,
    imprecise: false,
    latitude: 41.29418,
    longitude: -85.2415,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46763',
  },
  {
    city: 'Larwill',
    county_fips: 18183,
    county_fips_all: '18183|18113',
    county: 'Whitley',
    county_names_all: 'Whitley|Noble',
    county_weights: '{"18183": 89.55, "18113": 10.45}',
    density: 18.7,
    imprecise: false,
    latitude: 41.2176,
    longitude: -85.62376,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46764',
  },
  {
    city: 'Leo',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 176.6,
    imprecise: false,
    latitude: 41.23361,
    longitude: -85.04047,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46765',
  },
  {
    city: 'Liberty Center',
    county_fips: 18179,
    county_fips_all: '18179',
    county: 'Wells',
    county_names_all: 'Wells',
    county_weights: '{"18179": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 40.70984,
    longitude: -85.29424,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46766',
  },
  {
    city: 'Ligonier',
    county_fips: 18113,
    county_fips_all: '18113|18039|18087',
    county: 'Noble',
    county_names_all: 'Noble|Elkhart|LaGrange',
    county_weights: '{"18113": 92.63, "18039": 5.32, "18087": 2.05}',
    density: 53.6,
    imprecise: false,
    latitude: 41.46487,
    longitude: -85.5764,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 9418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46767',
  },
  {
    city: 'Markle',
    county_fips: 18179,
    county_fips_all: '18179|18069',
    county: 'Wells',
    county_names_all: 'Wells|Huntington',
    county_weights: '{"18179": 61.35, "18069": 38.65}',
    density: 18.6,
    imprecise: false,
    latitude: 40.8298,
    longitude: -85.31873,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46770',
  },
  {
    city: 'Mongo',
    county_fips: 18087,
    county_fips_all: '18087',
    county: 'LaGrange',
    county_names_all: 'LaGrange',
    county_weights: '{"18087": 100}',
    density: 26.7,
    imprecise: false,
    latitude: 41.69272,
    longitude: -85.29639,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46771',
  },
  {
    city: 'Monroe',
    county_fips: 18001,
    county_fips_all: '18001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"18001": 100}',
    density: 34.1,
    imprecise: false,
    latitude: 40.7221,
    longitude: -84.91153,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46772',
  },
  {
    city: 'Monroeville',
    county_fips: 18003,
    county_fips_all: '18003|18001',
    county: 'Allen',
    county_names_all: 'Allen|Adams',
    county_weights: '{"18003": 93.98, "18001": 6.02}',
    density: 16.9,
    imprecise: false,
    latitude: 40.98401,
    longitude: -84.8759,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46773',
  },
  {
    city: 'New Haven',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 130.8,
    imprecise: false,
    latitude: 41.09103,
    longitude: -84.96955,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 17858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46774',
  },
  {
    city: 'Orland',
    county_fips: 18151,
    county_fips_all: '18151|18087',
    county: 'Steuben',
    county_names_all: 'Steuben|LaGrange',
    county_weights: '{"18151": 79.36, "18087": 20.64}',
    density: 23.9,
    imprecise: false,
    latitude: 41.72793,
    longitude: -85.16878,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46776',
  },
  {
    city: 'Ossian',
    county_fips: 18179,
    county_fips_all: '18179|18003|18001',
    county: 'Wells',
    county_names_all: 'Wells|Allen|Adams',
    county_weights: '{"18179": 92.3, "18003": 4.95, "18001": 2.75}',
    density: 40.6,
    imprecise: false,
    latitude: 40.87248,
    longitude: -85.15236,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 6081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46777',
  },
  {
    city: 'Petroleum',
    county_fips: 18179,
    county_fips_all: '18179',
    county: 'Wells',
    county_names_all: 'Wells',
    county_weights: '{"18179": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 40.61055,
    longitude: -85.15491,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46778',
  },
  {
    city: 'Pleasant Lake',
    county_fips: 18151,
    county_fips_all: '18151',
    county: 'Steuben',
    county_names_all: 'Steuben',
    county_weights: '{"18151": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 41.5725,
    longitude: -85.03094,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46779',
  },
  {
    city: 'Poneto',
    county_fips: 18179,
    county_fips_all: '18179',
    county: 'Wells',
    county_names_all: 'Wells',
    county_weights: '{"18179": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 40.63659,
    longitude: -85.27339,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46781',
  },
  {
    city: 'Roanoke',
    county_fips: 18069,
    county_fips_all: '18069|18003|18183|18179',
    county: 'Huntington',
    county_names_all: 'Huntington|Allen|Whitley|Wells',
    county_weights:
      '{"18069": 45.94, "18003": 32.8, "18183": 19.39, "18179": 1.86}',
    density: 49.2,
    imprecise: false,
    latitude: 40.97399,
    longitude: -85.35578,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 7764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46783',
  },
  {
    city: 'Rome City',
    county_fips: 18113,
    county_fips_all: '18113',
    county: 'Noble',
    county_names_all: 'Noble',
    county_weights: '{"18113": 100}',
    density: 56.8,
    imprecise: false,
    latitude: 41.49797,
    longitude: -85.38797,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46784',
  },
  {
    city: 'Saint Joe',
    county_fips: 18033,
    county_fips_all: '18033',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"18033": 100}',
    density: 22.5,
    imprecise: false,
    latitude: 41.31974,
    longitude: -84.88506,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46785',
  },
  {
    city: 'South Milford',
    county_fips: 18087,
    county_fips_all: '18087',
    county: 'LaGrange',
    county_names_all: 'LaGrange',
    county_weights: '{"18087": 100}',
    density: 500.7,
    imprecise: false,
    latitude: 41.53156,
    longitude: -85.27269,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46786',
  },
  {
    city: 'South Whitley',
    county_fips: 18183,
    county_fips_all: '18183|18085|18069',
    county: 'Whitley',
    county_names_all: 'Whitley|Kosciusko|Huntington',
    county_weights: '{"18183": 90.22, "18085": 8.42, "18069": 1.36}',
    density: 23.7,
    imprecise: false,
    latitude: 41.06598,
    longitude: -85.62085,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46787',
  },
  {
    city: 'Spencerville',
    county_fips: 18033,
    county_fips_all: '18033|18003',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Allen',
    county_weights: '{"18033": 53.17, "18003": 46.83}',
    density: 48.9,
    imprecise: false,
    latitude: 41.27005,
    longitude: -84.90876,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46788',
  },
  {
    city: 'Stroh',
    county_fips: 18087,
    county_fips_all: '18087|18151',
    county: 'LaGrange',
    county_names_all: 'LaGrange|Steuben',
    county_weights: '{"18087": 99.4, "18151": 0.6}',
    density: 457.8,
    imprecise: false,
    latitude: 41.58274,
    longitude: -85.19742,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46789',
  },
  {
    city: 'Uniondale',
    county_fips: 18179,
    county_fips_all: '18179',
    county: 'Wells',
    county_names_all: 'Wells',
    county_weights: '{"18179": 100}',
    density: 28.9,
    imprecise: false,
    latitude: 40.83699,
    longitude: -85.24325,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46791',
  },
  {
    city: 'Warren',
    county_fips: 18069,
    county_fips_all: '18069|18179',
    county: 'Huntington',
    county_names_all: 'Huntington|Wells',
    county_weights: '{"18069": 76.12, "18179": 23.88}',
    density: 14.1,
    imprecise: false,
    latitude: 40.68472,
    longitude: -85.43798,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46792',
  },
  {
    city: 'Waterloo',
    county_fips: 18033,
    county_fips_all: '18033|18151',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Steuben',
    county_weights: '{"18033": 99.14, "18151": 0.86}',
    density: 29.9,
    imprecise: false,
    latitude: 41.46106,
    longitude: -85.01928,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46793',
  },
  {
    city: 'Wawaka',
    county_fips: 18113,
    county_fips_all: '18113',
    county: 'Noble',
    county_names_all: 'Noble',
    county_weights: '{"18113": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 41.46654,
    longitude: -85.45946,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46794',
  },
  {
    city: 'Wolcottville',
    county_fips: 18087,
    county_fips_all: '18087|18113',
    county: 'LaGrange',
    county_names_all: 'LaGrange|Noble',
    county_weights: '{"18087": 86.49, "18113": 13.51}',
    density: 46.4,
    imprecise: false,
    latitude: 41.55116,
    longitude: -85.33941,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 6866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46795',
  },
  {
    city: 'Wolflake',
    county_fips: 18113,
    county_fips_all: '18113',
    county: 'Noble',
    county_names_all: 'Noble',
    county_weights: '{"18113": 100}',
    density: 2863.8,
    imprecise: false,
    latitude: 41.3367,
    longitude: -85.49583,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46796',
  },
  {
    city: 'Woodburn',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 31.8,
    imprecise: false,
    latitude: 41.12749,
    longitude: -84.86046,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46797',
  },
  {
    city: 'Yoder',
    county_fips: 18003,
    county_fips_all: '18003|18179',
    county: 'Allen',
    county_names_all: 'Allen|Wells',
    county_weights: '{"18003": 96.31, "18179": 3.69}',
    density: 20.3,
    imprecise: false,
    latitude: 40.94256,
    longitude: -85.22113,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46798',
  },
  {
    city: 'Zanesville',
    county_fips: 18179,
    county_fips_all: '18179|18003',
    county: 'Wells',
    county_names_all: 'Wells|Allen',
    county_weights: '{"18179": 61.45, "18003": 38.55}',
    density: 227.8,
    imprecise: false,
    latitude: 40.91592,
    longitude: -85.27923,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46799',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 1027.4,
    imprecise: false,
    latitude: 41.06787,
    longitude: -85.16299,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 11177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46802',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 567.8,
    imprecise: false,
    latitude: 41.06972,
    longitude: -85.08532,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 10994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46803',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 646.9,
    imprecise: false,
    latitude: 41.05421,
    longitude: -85.23913,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 29661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46804',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 1291.1,
    imprecise: false,
    latitude: 41.09918,
    longitude: -85.11762,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 21437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46805',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 1236,
    imprecise: false,
    latitude: 41.04649,
    longitude: -85.09224,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 26425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46806',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 1956.4,
    imprecise: false,
    latitude: 41.04489,
    longitude: -85.14763,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 16317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46807',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 717.2,
    imprecise: false,
    latitude: 41.09887,
    longitude: -85.17619,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 19684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46808',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 134.1,
    imprecise: false,
    latitude: 41.00088,
    longitude: -85.2102,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 8589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46809',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003|18183',
    county: 'Allen',
    county_names_all: 'Allen|Whitley',
    county_weights: '{"18003": 88.07, "18183": 11.93}',
    density: 339.9,
    imprecise: false,
    latitude: 41.04616,
    longitude: -85.30805,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 16778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46814',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 1088.4,
    imprecise: false,
    latitude: 41.1034,
    longitude: -85.05913,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 27238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46815',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 209.1,
    imprecise: false,
    latitude: 41.00396,
    longitude: -85.04169,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 19514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46816',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003|18183',
    county: 'Allen',
    county_names_all: 'Allen|Whitley',
    county_weights: '{"18003": 98.04, "18183": 1.96}',
    density: 126.9,
    imprecise: false,
    latitude: 41.14698,
    longitude: -85.25111,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 21954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46818',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003|18179',
    county: 'Allen',
    county_names_all: 'Allen|Wells',
    county_weights: '{"18003": 99.77, "18179": 0.23}',
    density: 139.2,
    imprecise: false,
    latitude: 40.96409,
    longitude: -85.13256,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 9369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46819',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 725.7,
    imprecise: false,
    latitude: 41.15397,
    longitude: -85.12425,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 29296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46825',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 680.8,
    imprecise: false,
    latitude: 41.15086,
    longitude: -85.04536,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 38166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46835',
  },
  {
    city: 'Fort Wayne',
    county_fips: 18003,
    county_fips_all: '18003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"18003": 100}',
    density: 499.3,
    imprecise: false,
    latitude: 41.2051,
    longitude: -85.10789,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 29583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46845',
  },
  {
    city: 'Kokomo',
    county_fips: 18067,
    county_fips_all: '18067|18103|18017',
    county: 'Howard',
    county_names_all: 'Howard|Miami|Cass',
    county_weights: '{"18067": 84.58, "18103": 15.18, "18017": 0.24}',
    density: 104.4,
    imprecise: false,
    latitude: 40.52487,
    longitude: -86.15639,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 38082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46901',
  },
  {
    city: 'Kokomo',
    county_fips: 18067,
    county_fips_all: '18067|18159',
    county: 'Howard',
    county_names_all: 'Howard|Tipton',
    county_weights: '{"18067": 97.65, "18159": 2.35}',
    density: 281.9,
    imprecise: false,
    latitude: 40.43743,
    longitude: -86.09111,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 37017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46902',
  },
  {
    city: 'Akron',
    county_fips: 18049,
    county_fips_all: '18049|18085|18103',
    county: 'Fulton',
    county_names_all: 'Fulton|Kosciusko|Miami',
    county_weights: '{"18049": 69.36, "18085": 25.0, "18103": 5.64}',
    density: 20.7,
    imprecise: false,
    latitude: 41.04537,
    longitude: -86.04151,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46910',
  },
  {
    city: 'Amboy',
    county_fips: 18103,
    county_fips_all: '18103|18169',
    county: 'Miami',
    county_names_all: 'Miami|Wabash',
    county_weights: '{"18103": 79.19, "18169": 20.81}',
    density: 16.7,
    imprecise: false,
    latitude: 40.62859,
    longitude: -85.94673,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46911',
  },
  {
    city: 'Bringhurst',
    county_fips: 18015,
    county_fips_all: '18015',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"18015": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 40.50364,
    longitude: -86.49739,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46913',
  },
  {
    city: 'Bunker Hill',
    county_fips: 18103,
    county_fips_all: '18103',
    county: 'Miami',
    county_names_all: 'Miami',
    county_weights: '{"18103": 100}',
    density: 55.1,
    imprecise: false,
    latitude: 40.63068,
    longitude: -86.09515,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46914',
  },
  {
    city: 'Burlington',
    county_fips: 18015,
    county_fips_all: '18015|18067',
    county: 'Carroll',
    county_names_all: 'Carroll|Howard',
    county_weights: '{"18015": 99.87, "18067": 0.13}',
    density: 95.6,
    imprecise: false,
    latitude: 40.47832,
    longitude: -86.38636,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46915',
  },
  {
    city: 'Camden',
    county_fips: 18015,
    county_fips_all: '18015',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"18015": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 40.62071,
    longitude: -86.46893,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46917',
  },
  {
    city: 'Converse',
    county_fips: 18053,
    county_fips_all: '18053|18103|18067',
    county: 'Grant',
    county_names_all: 'Grant|Miami|Howard',
    county_weights: '{"18053": 49.6, "18103": 36.43, "18067": 13.96}',
    density: 17.8,
    imprecise: false,
    latitude: 40.58826,
    longitude: -85.8706,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46919',
  },
  {
    city: 'Cutler',
    county_fips: 18015,
    county_fips_all: '18015',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"18015": 100}',
    density: 17,
    imprecise: false,
    latitude: 40.46459,
    longitude: -86.49502,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46920',
  },
  {
    city: 'Delong',
    county_fips: 18049,
    county_fips_all: '18049',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"18049": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.13993,
    longitude: -86.42197,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46922',
  },
  {
    city: 'Delphi',
    county_fips: 18015,
    county_fips_all: '18015|18157',
    county: 'Carroll',
    county_names_all: 'Carroll|Tippecanoe',
    county_weights: '{"18015": 98.62, "18157": 1.38}',
    density: 23.5,
    imprecise: false,
    latitude: 40.606,
    longitude: -86.64568,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 8221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46923',
  },
  {
    city: 'Denver',
    county_fips: 18103,
    county_fips_all: '18103|18017|18169',
    county: 'Miami',
    county_names_all: 'Miami|Cass|Wabash',
    county_weights: '{"18103": 93.31, "18017": 4.16, "18169": 2.53}',
    density: 14.7,
    imprecise: false,
    latitude: 40.88283,
    longitude: -86.04945,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46926',
  },
  {
    city: 'Fairmount',
    county_fips: 18053,
    county_fips_all: '18053|18095|18067',
    county: 'Grant',
    county_names_all: 'Grant|Madison|Howard',
    county_weights: '{"18053": 98.11, "18095": 1.63, "18067": 0.26}',
    density: 24.5,
    imprecise: false,
    latitude: 40.40763,
    longitude: -85.68618,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46928',
  },
  {
    city: 'Flora',
    county_fips: 18015,
    county_fips_all: '18015|18067',
    county: 'Carroll',
    county_names_all: 'Carroll|Howard',
    county_weights: '{"18015": 88.5, "18067": 11.5}',
    density: 24.3,
    imprecise: false,
    latitude: 40.54802,
    longitude: -86.47411,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46929',
  },
  {
    city: 'Fowlerton',
    county_fips: 18053,
    county_fips_all: '18053',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"18053": 100}',
    density: 379.6,
    imprecise: false,
    latitude: 40.40946,
    longitude: -85.57261,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46930',
  },
  {
    city: 'Fulton',
    county_fips: 18049,
    county_fips_all: '18049',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"18049": 100}',
    density: 524.2,
    imprecise: false,
    latitude: 40.94693,
    longitude: -86.26456,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46931',
  },
  {
    city: 'Galveston',
    county_fips: 18017,
    county_fips_all: '18017|18067|18103|18015',
    county: 'Cass',
    county_names_all: 'Cass|Howard|Miami|Carroll',
    county_weights:
      '{"18017": 88.37, "18067": 9.31, "18103": 1.58, "18015": 0.74}',
    density: 21.5,
    imprecise: false,
    latitude: 40.59675,
    longitude: -86.26243,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46932',
  },
  {
    city: 'Gas City',
    county_fips: 18053,
    county_fips_all: '18053',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"18053": 100}',
    density: 228.4,
    imprecise: false,
    latitude: 40.47887,
    longitude: -85.58091,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 6536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46933',
  },
  {
    city: 'Greentown',
    county_fips: 18067,
    county_fips_all: '18067',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"18067": 100}',
    density: 35,
    imprecise: false,
    latitude: 40.47942,
    longitude: -85.93102,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46936',
  },
  {
    city: 'Hemlock',
    county_fips: 18067,
    county_fips_all: '18067',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"18067": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 40.41523,
    longitude: -86.03693,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46937',
  },
  {
    city: 'Jonesboro',
    county_fips: 18053,
    county_fips_all: '18053',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"18053": 100}',
    density: 30.9,
    imprecise: false,
    latitude: 40.4482,
    longitude: -85.64892,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46938',
  },
  {
    city: 'Kewanna',
    county_fips: 18049,
    county_fips_all: '18049|18131',
    county: 'Fulton',
    county_names_all: 'Fulton|Pulaski',
    county_weights: '{"18049": 90.6, "18131": 9.4}',
    density: 7.7,
    imprecise: false,
    latitude: 40.99337,
    longitude: -86.40359,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46939',
  },
  {
    city: 'La Fontaine',
    county_fips: 18169,
    county_fips_all: '18169|18069|18053',
    county: 'Wabash',
    county_names_all: 'Wabash|Huntington|Grant',
    county_weights: '{"18169": 72.59, "18069": 23.34, "18053": 4.07}',
    density: 16.6,
    imprecise: false,
    latitude: 40.6882,
    longitude: -85.69857,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46940',
  },
  {
    city: 'Lagro',
    county_fips: 18169,
    county_fips_all: '18169',
    county: 'Wabash',
    county_names_all: 'Wabash',
    county_weights: '{"18169": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 40.82833,
    longitude: -85.69723,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46941',
  },
  {
    city: 'Laketon',
    county_fips: 18169,
    county_fips_all: '18169',
    county: 'Wabash',
    county_names_all: 'Wabash',
    county_weights: '{"18169": 100}',
    density: 211.2,
    imprecise: false,
    latitude: 40.9735,
    longitude: -85.84038,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46943',
  },
  {
    city: 'Leiters Ford',
    county_fips: 18049,
    county_fips_all: '18049',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"18049": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.1211,
    longitude: -86.38516,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46945',
  },
  {
    city: 'Liberty Mills',
    county_fips: 18169,
    county_fips_all: '18169|18085',
    county: 'Wabash',
    county_names_all: 'Wabash|Kosciusko',
    county_weights: '{"18169": 99.84, "18085": 0.16}',
    density: 105,
    imprecise: false,
    latitude: 41.03932,
    longitude: -85.73019,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 90,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46946',
  },
  {
    city: 'Logansport',
    county_fips: 18017,
    county_fips_all: '18017|18015',
    county: 'Cass',
    county_names_all: 'Cass|Carroll',
    county_weights: '{"18017": 92.12, "18015": 7.88}',
    density: 58.2,
    imprecise: false,
    latitude: 40.76044,
    longitude: -86.37303,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 28687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46947',
  },
  {
    city: 'Lucerne',
    county_fips: 18017,
    county_fips_all: '18017|18049',
    county: 'Cass',
    county_names_all: 'Cass|Fulton',
    county_weights: '{"18017": 94.27, "18049": 5.73}',
    density: 6,
    imprecise: false,
    latitude: 40.88391,
    longitude: -86.37162,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46950',
  },
  {
    city: 'Macy',
    county_fips: 18103,
    county_fips_all: '18103|18049',
    county: 'Miami',
    county_names_all: 'Miami|Fulton',
    county_weights: '{"18103": 82.87, "18049": 17.13}',
    density: 13.7,
    imprecise: false,
    latitude: 40.94616,
    longitude: -86.10528,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46951',
  },
  {
    city: 'Marion',
    county_fips: 18053,
    county_fips_all: '18053|18179|18069|18009',
    county: 'Grant',
    county_names_all: 'Grant|Wells|Huntington|Blackford',
    county_weights:
      '{"18053": 89.57, "18179": 4.63, "18069": 3.09, "18009": 2.71}',
    density: 66.6,
    imprecise: false,
    latitude: 40.59882,
    longitude: -85.63249,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 18189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46952',
  },
  {
    city: 'Marion',
    county_fips: 18053,
    county_fips_all: '18053',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"18053": 100}',
    density: 105.4,
    imprecise: false,
    latitude: 40.51928,
    longitude: -85.643,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 23372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46953',
  },
  {
    city: 'Matthews',
    county_fips: 18053,
    county_fips_all: '18053',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"18053": 100}',
    density: 399.2,
    imprecise: false,
    latitude: 40.38866,
    longitude: -85.49917,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46957',
  },
  {
    city: 'Mexico',
    county_fips: 18103,
    county_fips_all: '18103',
    county: 'Miami',
    county_names_all: 'Miami',
    county_weights: '{"18103": 100}',
    density: 185.2,
    imprecise: false,
    latitude: 40.81817,
    longitude: -86.12107,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46958',
  },
  {
    city: 'Miami',
    county_fips: 18103,
    county_fips_all: '18103',
    county: 'Miami',
    county_names_all: 'Miami',
    county_weights: '{"18103": 100}',
    density: 385.2,
    imprecise: false,
    latitude: 40.61272,
    longitude: -86.11245,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46959',
  },
  {
    city: 'Monterey',
    county_fips: 18131,
    county_fips_all: '18131|18149|18049',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Starke|Fulton',
    county_weights: '{"18131": 60.57, "18149": 35.9, "18049": 3.53}',
    density: 9.6,
    imprecise: false,
    latitude: 41.15735,
    longitude: -86.52397,
    militaryZip: false,
    timezone: 'America/Indiana/Winamac',
    population: 1018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46960',
  },
  {
    city: 'New Waverly',
    county_fips: 18017,
    county_fips_all: '18017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"18017": 100}',
    density: 95.6,
    imprecise: false,
    latitude: 40.76573,
    longitude: -86.18786,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46961',
  },
  {
    city: 'North Manchester',
    county_fips: 18169,
    county_fips_all: '18169|18085|18183',
    county: 'Wabash',
    county_names_all: 'Wabash|Kosciusko|Whitley',
    county_weights: '{"18169": 90.29, "18085": 8.46, "18183": 1.25}',
    density: 31.9,
    imprecise: false,
    latitude: 40.98774,
    longitude: -85.76675,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 8785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46962',
  },
  {
    city: 'Oakford',
    county_fips: 18067,
    county_fips_all: '18067',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"18067": 100}',
    density: 81.3,
    imprecise: false,
    latitude: 40.41601,
    longitude: -86.10183,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46965',
  },
  {
    city: 'Onward',
    county_fips: 18017,
    county_fips_all: '18017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"18017": 100}',
    density: 870,
    imprecise: false,
    latitude: 40.69504,
    longitude: -86.19483,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46967',
  },
  {
    city: 'Ora',
    county_fips: 18131,
    county_fips_all: '18131|18149',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Starke',
    county_weights: '{"18131": 59.25, "18149": 40.75}',
    density: 32.6,
    imprecise: false,
    latitude: 41.17049,
    longitude: -86.55179,
    militaryZip: false,
    timezone: 'America/Indiana/Winamac',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46968',
  },
  {
    city: 'Peru',
    county_fips: 18103,
    county_fips_all: '18103|18017|18169',
    county: 'Miami',
    county_names_all: 'Miami|Cass|Wabash',
    county_weights: '{"18103": 91.54, "18017": 7.65, "18169": 0.81}',
    density: 49.4,
    imprecise: false,
    latitude: 40.75827,
    longitude: -86.0614,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 23020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46970',
  },
  {
    city: 'Roann',
    county_fips: 18169,
    county_fips_all: '18169|18103',
    county: 'Wabash',
    county_names_all: 'Wabash|Miami',
    county_weights: '{"18169": 59.82, "18103": 40.18}',
    density: 14.6,
    imprecise: false,
    latitude: 40.94839,
    longitude: -85.93041,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46974',
  },
  {
    city: 'Rochester',
    county_fips: 18049,
    county_fips_all: '18049',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"18049": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 41.0718,
    longitude: -86.25177,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 13824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46975',
  },
  {
    city: 'Royal Center',
    county_fips: 18017,
    county_fips_all: '18017|18131|18181|18049',
    county: 'Cass',
    county_names_all: 'Cass|Pulaski|White|Fulton',
    county_weights:
      '{"18017": 88.92, "18131": 5.1, "18181": 4.83, "18049": 1.15}',
    density: 11.5,
    imprecise: false,
    latitude: 40.8587,
    longitude: -86.51113,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46978',
  },
  {
    city: 'Russiaville',
    county_fips: 18067,
    county_fips_all: '18067|18023|18159',
    county: 'Howard',
    county_names_all: 'Howard|Clinton|Tipton',
    county_weights: '{"18067": 88.14, "18023": 6.5, "18159": 5.36}',
    density: 42.4,
    imprecise: false,
    latitude: 40.42759,
    longitude: -86.27737,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46979',
  },
  {
    city: 'Servia',
    county_fips: 18169,
    county_fips_all: '18169',
    county: 'Wabash',
    county_names_all: 'Wabash',
    county_weights: '{"18169": 100}',
    density: 789.1,
    imprecise: false,
    latitude: 40.95598,
    longitude: -85.74155,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46980',
  },
  {
    city: 'Silver Lake',
    county_fips: 18085,
    county_fips_all: '18085|18169|18049',
    county: 'Kosciusko',
    county_names_all: 'Kosciusko|Wabash|Fulton',
    county_weights: '{"18085": 73.22, "18169": 23.49, "18049": 3.29}',
    density: 22.6,
    imprecise: false,
    latitude: 41.05717,
    longitude: -85.8882,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46982',
  },
  {
    city: 'Somerset',
    county_fips: 18169,
    county_fips_all: '18169',
    county: 'Wabash',
    county_names_all: 'Wabash',
    county_weights: '{"18169": 100}',
    density: 57.7,
    imprecise: false,
    latitude: 40.66777,
    longitude: -85.82975,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 8,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46984',
  },
  {
    city: 'Star City',
    county_fips: 18131,
    county_fips_all: '18131|18181|18049',
    county: 'Pulaski',
    county_names_all: 'Pulaski|White|Fulton',
    county_weights: '{"18131": 95.32, "18181": 3.98, "18049": 0.7}',
    density: 8.3,
    imprecise: false,
    latitude: 40.95485,
    longitude: -86.58225,
    militaryZip: false,
    timezone: 'America/Indiana/Winamac',
    population: 1419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46985',
  },
  {
    city: 'Swayzee',
    county_fips: 18053,
    county_fips_all: '18053',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"18053": 100}',
    density: 18,
    imprecise: false,
    latitude: 40.49481,
    longitude: -85.81929,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46986',
  },
  {
    city: 'Sweetser',
    county_fips: 18053,
    county_fips_all: '18053',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"18053": 100}',
    density: 455.5,
    imprecise: false,
    latitude: 40.56847,
    longitude: -85.76722,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46987',
  },
  {
    city: 'Twelve Mile',
    county_fips: 18017,
    county_fips_all: '18017|18049',
    county: 'Cass',
    county_names_all: 'Cass|Fulton',
    county_weights: '{"18017": 96.25, "18049": 3.75}',
    density: 15.7,
    imprecise: false,
    latitude: 40.8802,
    longitude: -86.23451,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46988',
  },
  {
    city: 'Upland',
    county_fips: 18053,
    county_fips_all: '18053|18035|18009',
    county: 'Grant',
    county_names_all: 'Grant|Delaware|Blackford',
    county_weights: '{"18053": 96.8, "18035": 2.14, "18009": 1.06}',
    density: 64.8,
    imprecise: false,
    latitude: 40.45056,
    longitude: -85.48115,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46989',
  },
  {
    city: 'Urbana',
    county_fips: 18169,
    county_fips_all: '18169',
    county: 'Wabash',
    county_names_all: 'Wabash',
    county_weights: '{"18169": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 40.89851,
    longitude: -85.73161,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46990',
  },
  {
    city: 'Van Buren',
    county_fips: 18053,
    county_fips_all: '18053|18069|18179',
    county: 'Grant',
    county_names_all: 'Grant|Huntington|Wells',
    county_weights: '{"18053": 82.85, "18069": 15.52, "18179": 1.63}',
    density: 18.9,
    imprecise: false,
    latitude: 40.63034,
    longitude: -85.50642,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46991',
  },
  {
    city: 'Wabash',
    county_fips: 18169,
    county_fips_all: '18169|18103',
    county: 'Wabash',
    county_names_all: 'Wabash|Miami',
    county_weights: '{"18169": 99.55, "18103": 0.45}',
    density: 38.9,
    imprecise: false,
    latitude: 40.78509,
    longitude: -85.82961,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 16438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46992',
  },
  {
    city: 'Walton',
    county_fips: 18017,
    county_fips_all: '18017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"18017": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 40.66661,
    longitude: -86.25766,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46994',
  },
  {
    city: 'Winamac',
    county_fips: 18131,
    county_fips_all: '18131|18181|18149',
    county: 'Pulaski',
    county_names_all: 'Pulaski|White|Starke',
    county_weights: '{"18131": 99.25, "18181": 0.55, "18149": 0.2}',
    density: 13.1,
    imprecise: false,
    latitude: 41.0626,
    longitude: -86.65906,
    militaryZip: false,
    timezone: 'America/Indiana/Winamac',
    population: 6441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46996',
  },
  {
    city: 'Young America',
    county_fips: 18017,
    county_fips_all: '18017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"18017": 100}',
    density: 132.2,
    imprecise: false,
    latitude: 40.57536,
    longitude: -86.35081,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46998',
  },
  {
    city: 'Aurora',
    county_fips: 18029,
    county_fips_all: '18029|18115',
    county: 'Dearborn',
    county_names_all: 'Dearborn|Ohio',
    county_weights: '{"18029": 78.52, "18115": 21.48}',
    density: 54.2,
    imprecise: false,
    latitude: 39.0579,
    longitude: -84.95689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 10696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47001',
  },
  {
    city: 'West College Corner',
    county_fips: 18161,
    county_fips_all: '18161|18047',
    county: 'Union',
    county_names_all: 'Union|Franklin',
    county_weights: '{"18161": 96.45, "18047": 3.55}',
    density: 31.2,
    imprecise: false,
    latitude: 39.55628,
    longitude: -84.84491,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47003',
  },
  {
    city: 'Batesville',
    county_fips: 18137,
    county_fips_all: '18137|18047|18031',
    county: 'Ripley',
    county_names_all: 'Ripley|Franklin|Decatur',
    county_weights: '{"18137": 54.04, "18047": 45.25, "18031": 0.71}',
    density: 47.2,
    imprecise: false,
    latitude: 39.29141,
    longitude: -85.21365,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 12988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47006',
  },
  {
    city: 'Bath',
    county_fips: 18047,
    county_fips_all: '18047|18161',
    county: 'Franklin',
    county_names_all: 'Franklin|Union',
    county_weights: '{"18047": 90.38, "18161": 9.62}',
    density: 8.5,
    imprecise: false,
    latitude: 39.4981,
    longitude: -84.83925,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47010',
  },
  {
    city: 'Bennington',
    county_fips: 18155,
    county_fips_all: '18155|18115',
    county: 'Switzerland',
    county_names_all: 'Switzerland|Ohio',
    county_weights: '{"18155": 90.63, "18115": 9.37}',
    density: 16.5,
    imprecise: false,
    latitude: 38.8724,
    longitude: -85.06887,
    militaryZip: false,
    timezone: 'America/Indiana/Vevay',
    population: 1420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47011',
  },
  {
    city: 'Brookville',
    county_fips: 18047,
    county_fips_all: '18047|18029',
    county: 'Franklin',
    county_names_all: 'Franklin|Dearborn',
    county_weights: '{"18047": 95.38, "18029": 4.62}',
    density: 25,
    imprecise: false,
    latitude: 39.41892,
    longitude: -84.97944,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 10733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47012',
  },
  {
    city: 'Cedar Grove',
    county_fips: 18047,
    county_fips_all: '18047|39017',
    county: 'Franklin',
    county_names_all: 'Franklin|Butler',
    county_weights: '{"18047": 99.88, "39017": 0.12}',
    density: 15.7,
    imprecise: false,
    latitude: 39.37414,
    longitude: -84.89484,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47016',
  },
  {
    city: 'Cross Plains',
    county_fips: 18137,
    county_fips_all: '18137|18155|18115',
    county: 'Ripley',
    county_names_all: 'Ripley|Switzerland|Ohio',
    county_weights: '{"18137": 74.29, "18155": 15.64, "18115": 10.07}',
    density: 9.9,
    imprecise: false,
    latitude: 38.93745,
    longitude: -85.17713,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47017',
  },
  {
    city: 'Dillsboro',
    county_fips: 18029,
    county_fips_all: '18029|18115|18137|18155',
    county: 'Dearborn',
    county_names_all: 'Dearborn|Ohio|Ripley|Switzerland',
    county_weights:
      '{"18029": 45.05, "18115": 27.59, "18137": 24.29, "18155": 3.06}',
    density: 21.6,
    imprecise: false,
    latitude: 38.98684,
    longitude: -85.0866,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47018',
  },
  {
    city: 'Florence',
    county_fips: 18155,
    county_fips_all: '18155',
    county: 'Switzerland',
    county_names_all: 'Switzerland',
    county_weights: '{"18155": 100}',
    density: 24.1,
    imprecise: false,
    latitude: 38.8119,
    longitude: -84.93221,
    militaryZip: false,
    timezone: 'America/Indiana/Vevay',
    population: 1177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47020',
  },
  {
    city: 'Friendship',
    county_fips: 18137,
    county_fips_all: '18137',
    county: 'Ripley',
    county_names_all: 'Ripley',
    county_weights: '{"18137": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.97015,
    longitude: -85.14855,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47021',
  },
  {
    city: 'Guilford',
    county_fips: 18029,
    county_fips_all: '18029',
    county: 'Dearborn',
    county_names_all: 'Dearborn',
    county_weights: '{"18029": 100}',
    density: 33.6,
    imprecise: false,
    latitude: 39.20722,
    longitude: -84.95089,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47022',
  },
  {
    city: 'Holton',
    county_fips: 18137,
    county_fips_all: '18137',
    county: 'Ripley',
    county_names_all: 'Ripley',
    county_weights: '{"18137": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 39.07255,
    longitude: -85.37467,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47023',
  },
  {
    city: 'Laurel',
    county_fips: 18047,
    county_fips_all: '18047|18041',
    county: 'Franklin',
    county_names_all: 'Franklin|Fayette',
    county_weights: '{"18047": 99.05, "18041": 0.95}',
    density: 17.1,
    imprecise: false,
    latitude: 39.47611,
    longitude: -85.19724,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47024',
  },
  {
    city: 'Lawrenceburg',
    county_fips: 18029,
    county_fips_all: '18029',
    county: 'Dearborn',
    county_names_all: 'Dearborn',
    county_weights: '{"18029": 100}',
    density: 174.1,
    imprecise: false,
    latitude: 39.15415,
    longitude: -84.87461,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47025',
  },
  {
    city: 'Metamora',
    county_fips: 18047,
    county_fips_all: '18047',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"18047": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 39.42686,
    longitude: -85.13319,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47030',
  },
  {
    city: 'Milan',
    county_fips: 18137,
    county_fips_all: '18137|18029',
    county: 'Ripley',
    county_names_all: 'Ripley|Dearborn',
    county_weights: '{"18137": 89.4, "18029": 10.6}',
    density: 34.5,
    imprecise: false,
    latitude: 39.12872,
    longitude: -85.15333,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47031',
  },
  {
    city: 'Moores Hill',
    county_fips: 18029,
    county_fips_all: '18029|18137',
    county: 'Dearborn',
    county_names_all: 'Dearborn|Ripley',
    county_weights: '{"18029": 92.83, "18137": 7.17}',
    density: 33,
    imprecise: false,
    latitude: 39.08109,
    longitude: -85.05503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47032',
  },
  {
    city: 'Morris',
    county_fips: 18137,
    county_fips_all: '18137',
    county: 'Ripley',
    county_names_all: 'Ripley',
    county_weights: '{"18137": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.28127,
    longitude: -85.17232,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47033',
  },
  {
    city: 'Napoleon',
    county_fips: 18137,
    county_fips_all: '18137',
    county: 'Ripley',
    county_names_all: 'Ripley',
    county_weights: '{"18137": 100}',
    density: 397.9,
    imprecise: false,
    latitude: 39.20428,
    longitude: -85.32739,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47034',
  },
  {
    city: 'New Trenton',
    county_fips: 18047,
    county_fips_all: '18047',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"18047": 100}',
    density: 256.8,
    imprecise: false,
    latitude: 39.31016,
    longitude: -84.90394,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47035',
  },
  {
    city: 'Oldenburg',
    county_fips: 18047,
    county_fips_all: '18047',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"18047": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 39.38563,
    longitude: -85.23972,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47036',
  },
  {
    city: 'Osgood',
    county_fips: 18137,
    county_fips_all: '18137|18079',
    county: 'Ripley',
    county_names_all: 'Ripley|Jennings',
    county_weights: '{"18137": 98.58, "18079": 1.42}',
    density: 21,
    imprecise: false,
    latitude: 39.16431,
    longitude: -85.31908,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47037',
  },
  {
    city: 'Patriot',
    county_fips: 18155,
    county_fips_all: '18155',
    county: 'Switzerland',
    county_names_all: 'Switzerland',
    county_weights: '{"18155": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 38.84588,
    longitude: -84.84212,
    militaryZip: false,
    timezone: 'America/Indiana/Vevay',
    population: 1006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47038',
  },
  {
    city: 'Rising Sun',
    county_fips: 18115,
    county_fips_all: '18115|18155',
    county: 'Ohio',
    county_names_all: 'Ohio|Switzerland',
    county_weights: '{"18115": 68.18, "18155": 31.82}',
    density: 31.4,
    imprecise: false,
    latitude: 38.91703,
    longitude: -84.92809,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47040',
  },
  {
    city: 'Sunman',
    county_fips: 18029,
    county_fips_all: '18029|18137|18047',
    county: 'Dearborn',
    county_names_all: 'Dearborn|Ripley|Franklin',
    county_weights: '{"18029": 51.21, "18137": 46.87, "18047": 1.92}',
    density: 29.2,
    imprecise: false,
    latitude: 39.23432,
    longitude: -85.0797,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47041',
  },
  {
    city: 'Versailles',
    county_fips: 18137,
    county_fips_all: '18137',
    county: 'Ripley',
    county_names_all: 'Ripley',
    county_weights: '{"18137": 100}',
    density: 21.7,
    imprecise: false,
    latitude: 39.01247,
    longitude: -85.25484,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47042',
  },
  {
    city: 'Vevay',
    county_fips: 18155,
    county_fips_all: '18155|18077',
    county: 'Switzerland',
    county_names_all: 'Switzerland|Jefferson',
    county_weights: '{"18155": 97.44, "18077": 2.56}',
    density: 18.2,
    imprecise: false,
    latitude: 38.7949,
    longitude: -85.10009,
    militaryZip: false,
    timezone: 'America/Indiana/Vevay',
    population: 4852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47043',
  },
  {
    city: 'West Harrison',
    county_fips: 18029,
    county_fips_all: '18029|18047',
    county: 'Dearborn',
    county_names_all: 'Dearborn|Franklin',
    county_weights: '{"18029": 57.26, "18047": 42.74}',
    density: 41.6,
    imprecise: false,
    latitude: 39.29828,
    longitude: -84.8788,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47060',
  },
  {
    city: 'Austin',
    county_fips: 18143,
    county_fips_all: '18143|18071',
    county: 'Scott',
    county_names_all: 'Scott|Jackson',
    county_weights: '{"18143": 80.72, "18071": 19.28}',
    density: 61.1,
    imprecise: false,
    latitude: 38.75745,
    longitude: -85.7951,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 6659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47102',
  },
  {
    city: 'Borden',
    county_fips: 18019,
    county_fips_all: '18019|18043|18175',
    county: 'Clark',
    county_names_all: 'Clark|Floyd|Washington',
    county_weights: '{"18019": 91.23, "18043": 4.79, "18175": 3.98}',
    density: 26.7,
    imprecise: false,
    latitude: 38.46071,
    longitude: -85.90326,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 4670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47106',
  },
  {
    city: 'Campbellsburg',
    county_fips: 18175,
    county_fips_all: '18175|18117',
    county: 'Washington',
    county_names_all: 'Washington|Orange',
    county_weights: '{"18175": 97.25, "18117": 2.75}',
    density: 8.9,
    imprecise: false,
    latitude: 38.6455,
    longitude: -86.25725,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47108',
  },
  {
    city: 'Central',
    county_fips: 18061,
    county_fips_all: '18061',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"18061": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 38.09541,
    longitude: -86.2077,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47110',
  },
  {
    city: 'Charlestown',
    county_fips: 18019,
    county_fips_all: '18019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"18019": 100}',
    density: 79.7,
    imprecise: false,
    latitude: 38.46604,
    longitude: -85.63271,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 17738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47111',
  },
  {
    city: 'Corydon',
    county_fips: 18061,
    county_fips_all: '18061',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"18061": 100}',
    density: 41.7,
    imprecise: false,
    latitude: 38.19235,
    longitude: -86.14512,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 17464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47112',
  },
  {
    city: 'Crandall',
    county_fips: 18061,
    county_fips_all: '18061',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"18061": 100}',
    density: 194.1,
    imprecise: false,
    latitude: 38.28754,
    longitude: -86.07335,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47114',
  },
  {
    city: 'Depauw',
    county_fips: 18061,
    county_fips_all: '18061',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"18061": 100}',
    density: 18.5,
    imprecise: false,
    latitude: 38.34465,
    longitude: -86.21655,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 2782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47115',
  },
  {
    city: 'Eckerty',
    county_fips: 18025,
    county_fips_all: '18025',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"18025": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 38.32521,
    longitude: -86.61668,
    militaryZip: false,
    timezone: 'America/Indiana/Marengo',
    population: 490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47116',
  },
  {
    city: 'Elizabeth',
    county_fips: 18061,
    county_fips_all: '18061|18043',
    county: 'Harrison',
    county_names_all: 'Harrison|Floyd',
    county_weights: '{"18061": 95.27, "18043": 4.73}',
    density: 20.5,
    imprecise: false,
    latitude: 38.10505,
    longitude: -85.97275,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 4400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47117',
  },
  {
    city: 'English',
    county_fips: 18025,
    county_fips_all: '18025|18123|18117',
    county: 'Crawford',
    county_names_all: 'Crawford|Perry|Orange',
    county_weights: '{"18025": 78.59, "18123": 11.71, "18117": 9.7}',
    density: 10.3,
    imprecise: false,
    latitude: 38.29788,
    longitude: -86.48449,
    militaryZip: false,
    timezone: 'America/Indiana/Marengo',
    population: 3529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47118',
  },
  {
    city: 'Floyds Knobs',
    county_fips: 18043,
    county_fips_all: '18043|18019',
    county: 'Floyd',
    county_names_all: 'Floyd|Clark',
    county_weights: '{"18043": 86.19, "18019": 13.81}',
    density: 111.4,
    imprecise: false,
    latitude: 38.36699,
    longitude: -85.88217,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 12042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47119',
  },
  {
    city: 'Fredericksburg',
    county_fips: 18175,
    county_fips_all: '18175|18061',
    county: 'Washington',
    county_names_all: 'Washington|Harrison',
    county_weights: '{"18175": 99.02, "18061": 0.98}',
    density: 19.6,
    imprecise: false,
    latitude: 38.45568,
    longitude: -86.19075,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47120',
  },
  {
    city: 'Georgetown',
    county_fips: 18043,
    county_fips_all: '18043|18061',
    county: 'Floyd',
    county_names_all: 'Floyd|Harrison',
    county_weights: '{"18043": 66.46, "18061": 33.54}',
    density: 124.1,
    imprecise: false,
    latitude: 38.3041,
    longitude: -85.98303,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 11357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47122',
  },
  {
    city: 'Grantsburg',
    county_fips: 18025,
    county_fips_all: '18025',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"18025": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 38.2856,
    longitude: -86.47181,
    militaryZip: false,
    timezone: 'America/Indiana/Marengo',
    population: 68,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47123',
  },
  {
    city: 'Greenville',
    county_fips: 18043,
    county_fips_all: '18043|18061',
    county: 'Floyd',
    county_names_all: 'Floyd|Harrison',
    county_weights: '{"18043": 78.72, "18061": 21.28}',
    density: 85.9,
    imprecise: false,
    latitude: 38.36591,
    longitude: -86.00523,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 5357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47124',
  },
  {
    city: 'Hardinsburg',
    county_fips: 18175,
    county_fips_all: '18175|18117',
    county: 'Washington',
    county_names_all: 'Washington|Orange',
    county_weights: '{"18175": 51.93, "18117": 48.07}',
    density: 17.9,
    imprecise: false,
    latitude: 38.46341,
    longitude: -86.30825,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47125',
  },
  {
    city: 'Henryville',
    county_fips: 18019,
    county_fips_all: '18019|18175',
    county: 'Clark',
    county_names_all: 'Clark|Washington',
    county_weights: '{"18019": 96.2, "18175": 3.8}',
    density: 46,
    imprecise: false,
    latitude: 38.54979,
    longitude: -85.77844,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 4372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47126',
  },
  {
    city: 'Clarksville',
    county_fips: 18019,
    county_fips_all: '18019|18043',
    county: 'Clark',
    county_names_all: 'Clark|Floyd',
    county_weights: '{"18019": 99.79, "18043": 0.21}',
    density: 790.2,
    imprecise: false,
    latitude: 38.31378,
    longitude: -85.76874,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 19582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47129',
  },
  {
    city: 'Jeffersonville',
    county_fips: 18019,
    county_fips_all: '18019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"18019": 100}',
    density: 574.8,
    imprecise: false,
    latitude: 38.33528,
    longitude: -85.69689,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 50514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47130',
  },
  {
    city: 'Laconia',
    county_fips: 18061,
    county_fips_all: '18061',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"18061": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 38.04108,
    longitude: -86.0744,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 1257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47135',
  },
  {
    city: 'Lanesville',
    county_fips: 18061,
    county_fips_all: '18061|18043',
    county: 'Harrison',
    county_names_all: 'Harrison|Floyd',
    county_weights: '{"18061": 54.03, "18043": 45.97}',
    density: 66.5,
    imprecise: false,
    latitude: 38.23511,
    longitude: -85.96194,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 4756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47136',
  },
  {
    city: 'Leavenworth',
    county_fips: 18025,
    county_fips_all: '18025|18061|18123',
    county: 'Crawford',
    county_names_all: 'Crawford|Harrison|Perry',
    county_weights: '{"18025": 93.64, "18061": 3.25, "18123": 3.11}',
    density: 9.5,
    imprecise: false,
    latitude: 38.18899,
    longitude: -86.37626,
    militaryZip: false,
    timezone: 'America/Indiana/Marengo',
    population: 1532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47137',
  },
  {
    city: 'Lexington',
    county_fips: 18077,
    county_fips_all: '18077|18143',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Scott',
    county_weights: '{"18077": 53.56, "18143": 46.44}',
    density: 25.1,
    imprecise: false,
    latitude: 38.68215,
    longitude: -85.59759,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47138',
  },
  {
    city: 'Marengo',
    county_fips: 18025,
    county_fips_all: '18025|18117',
    county: 'Crawford',
    county_names_all: 'Crawford|Orange',
    county_weights: '{"18025": 58.59, "18117": 41.41}',
    density: 22,
    imprecise: false,
    latitude: 38.38063,
    longitude: -86.36892,
    militaryZip: false,
    timezone: 'America/Indiana/Marengo',
    population: 2539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47140',
  },
  {
    city: 'Marysville',
    county_fips: 18019,
    county_fips_all: '18019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"18019": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 38.54925,
    longitude: -85.60841,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 1584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47141',
  },
  {
    city: 'Mauckport',
    county_fips: 18061,
    county_fips_all: '18061',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"18061": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 38.0684,
    longitude: -86.21042,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47142',
  },
  {
    city: 'Memphis',
    county_fips: 18019,
    county_fips_all: '18019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"18019": 100}',
    density: 70.9,
    imprecise: false,
    latitude: 38.46877,
    longitude: -85.77314,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 3833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47143',
  },
  {
    city: 'Milltown',
    county_fips: 18025,
    county_fips_all: '18025',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"18025": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 38.33454,
    longitude: -86.30115,
    militaryZip: false,
    timezone: 'America/Indiana/Marengo',
    population: 1782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47145',
  },
  {
    city: 'Nabb',
    county_fips: 18019,
    county_fips_all: '18019|18077|18143',
    county: 'Clark',
    county_names_all: 'Clark|Jefferson|Scott',
    county_weights: '{"18019": 59.58, "18077": 24.21, "18143": 16.21}',
    density: 15.6,
    imprecise: false,
    latitude: 38.5942,
    longitude: -85.53866,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 1317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47147',
  },
  {
    city: 'New Albany',
    county_fips: 18043,
    county_fips_all: '18043|18019',
    county: 'Floyd',
    county_names_all: 'Floyd|Clark',
    county_weights: '{"18043": 99.54, "18019": 0.46}',
    density: 421.7,
    imprecise: false,
    latitude: 38.28831,
    longitude: -85.84775,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 49144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47150',
  },
  {
    city: 'New Salisbury',
    county_fips: 18061,
    county_fips_all: '18061',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"18061": 100}',
    density: 62,
    imprecise: false,
    latitude: 38.32281,
    longitude: -86.10366,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 3611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47161',
  },
  {
    city: 'New Washington',
    county_fips: 18019,
    county_fips_all: '18019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"18019": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 38.55477,
    longitude: -85.48873,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47162',
  },
  {
    city: 'Otisco',
    county_fips: 18019,
    county_fips_all: '18019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"18019": 100}',
    density: 34.7,
    imprecise: false,
    latitude: 38.54101,
    longitude: -85.67928,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 1335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47163',
  },
  {
    city: 'Palmyra',
    county_fips: 18061,
    county_fips_all: '18061|18175|18043',
    county: 'Harrison',
    county_names_all: 'Harrison|Washington|Floyd',
    county_weights: '{"18061": 66.75, "18175": 31.62, "18043": 1.63}',
    density: 35,
    imprecise: false,
    latitude: 38.40462,
    longitude: -86.09079,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 3312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47164',
  },
  {
    city: 'Pekin',
    county_fips: 18175,
    county_fips_all: '18175|18043|18019',
    county: 'Washington',
    county_names_all: 'Washington|Floyd|Clark',
    county_weights: '{"18175": 95.96, "18043": 2.62, "18019": 1.42}',
    density: 30.8,
    imprecise: false,
    latitude: 38.50152,
    longitude: -86.00508,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 6292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47165',
  },
  {
    city: 'Ramsey',
    county_fips: 18061,
    county_fips_all: '18061',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"18061": 100}',
    density: 46,
    imprecise: false,
    latitude: 38.30668,
    longitude: -86.16901,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 1484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47166',
  },
  {
    city: 'Salem',
    county_fips: 18175,
    county_fips_all: '18175',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"18175": 100}',
    density: 27.9,
    imprecise: false,
    latitude: 38.6077,
    longitude: -86.09047,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 15375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47167',
  },
  {
    city: 'Scottsburg',
    county_fips: 18143,
    county_fips_all: '18143|18175|18077',
    county: 'Scott',
    county_names_all: 'Scott|Washington|Jefferson',
    county_weights: '{"18143": 63.29, "18175": 36.49, "18077": 0.22}',
    density: 40.8,
    imprecise: false,
    latitude: 38.68734,
    longitude: -85.84667,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 15451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47170',
  },
  {
    city: 'Sellersburg',
    county_fips: 18019,
    county_fips_all: '18019|18043',
    county: 'Clark',
    county_names_all: 'Clark|Floyd',
    county_weights: '{"18019": 87.91, "18043": 12.09}',
    density: 334,
    imprecise: false,
    latitude: 38.39745,
    longitude: -85.76886,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 21045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47172',
  },
  {
    city: 'Sulphur',
    county_fips: 18025,
    county_fips_all: '18025',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"18025": 100}',
    density: 10,
    imprecise: false,
    latitude: 38.22716,
    longitude: -86.482,
    militaryZip: false,
    timezone: 'America/Indiana/Marengo',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47174',
  },
  {
    city: 'Taswell',
    county_fips: 18025,
    county_fips_all: '18025|18117',
    county: 'Crawford',
    county_names_all: 'Crawford|Orange',
    county_weights: '{"18025": 93.22, "18117": 6.78}',
    density: 12.8,
    imprecise: false,
    latitude: 38.35902,
    longitude: -86.55236,
    militaryZip: false,
    timezone: 'America/Indiana/Marengo',
    population: 847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47175',
  },
  {
    city: 'Underwood',
    county_fips: 18143,
    county_fips_all: '18143|18019',
    county: 'Scott',
    county_names_all: 'Scott|Clark',
    county_weights: '{"18143": 69.87, "18019": 30.13}',
    density: 28.8,
    imprecise: false,
    latitude: 38.59947,
    longitude: -85.78197,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 1782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47177',
  },
  {
    city: 'Columbus',
    county_fips: 18005,
    county_fips_all: '18005|18013',
    county: 'Bartholomew',
    county_names_all: 'Bartholomew|Brown',
    county_weights: '{"18005": 84.67, "18013": 15.33}',
    density: 91.9,
    imprecise: false,
    latitude: 39.15074,
    longitude: -85.99432,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 47900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47201',
  },
  {
    city: 'Columbus',
    county_fips: 18005,
    county_fips_all: '18005',
    county: 'Bartholomew',
    county_names_all: 'Bartholomew',
    county_weights: '{"18005": 100}',
    density: 131.3,
    imprecise: false,
    latitude: 39.23189,
    longitude: -85.83281,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 26200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47203',
  },
  {
    city: 'Brownstown',
    county_fips: 18071,
    county_fips_all: '18071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"18071": 100}',
    density: 28.7,
    imprecise: false,
    latitude: 38.87786,
    longitude: -86.05471,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 6136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47220',
  },
  {
    city: 'Butlerville',
    county_fips: 18079,
    county_fips_all: '18079',
    county: 'Jennings',
    county_names_all: 'Jennings',
    county_weights: '{"18079": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 39.0555,
    longitude: -85.48218,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47223',
  },
  {
    city: 'Canaan',
    county_fips: 18077,
    county_fips_all: '18077|18155',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Switzerland',
    county_weights: '{"18077": 68.3, "18155": 31.7}',
    density: 8.3,
    imprecise: false,
    latitude: 38.88816,
    longitude: -85.22474,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47224',
  },
  {
    city: 'Clarksburg',
    county_fips: 18031,
    county_fips_all: '18031',
    county: 'Decatur',
    county_names_all: 'Decatur',
    county_weights: '{"18031": 100}',
    density: 214,
    imprecise: false,
    latitude: 39.43554,
    longitude: -85.34424,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47225',
  },
  {
    city: 'Clifford',
    county_fips: 18005,
    county_fips_all: '18005',
    county: 'Bartholomew',
    county_names_all: 'Bartholomew',
    county_weights: '{"18005": 100}',
    density: 720.6,
    imprecise: false,
    latitude: 39.28266,
    longitude: -85.86907,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47226',
  },
  {
    city: 'Commiskey',
    county_fips: 18079,
    county_fips_all: '18079|18077',
    county: 'Jennings',
    county_names_all: 'Jennings|Jefferson',
    county_weights: '{"18079": 84.94, "18077": 15.06}',
    density: 9.6,
    imprecise: false,
    latitude: 38.87506,
    longitude: -85.65678,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47227',
  },
  {
    city: 'Crothersville',
    county_fips: 18071,
    county_fips_all: '18071|18079',
    county: 'Jackson',
    county_names_all: 'Jackson|Jennings',
    county_weights: '{"18071": 89.0, "18079": 11.0}',
    density: 23.5,
    imprecise: false,
    latitude: 38.80289,
    longitude: -85.86688,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47229',
  },
  {
    city: 'Deputy',
    county_fips: 18077,
    county_fips_all: '18077|18143|18079',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Scott|Jennings',
    county_weights: '{"18077": 78.62, "18143": 15.24, "18079": 6.14}',
    density: 15.8,
    imprecise: false,
    latitude: 38.7946,
    longitude: -85.63139,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47230',
  },
  {
    city: 'Dupont',
    county_fips: 18077,
    county_fips_all: '18077|18079',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Jennings',
    county_weights: '{"18077": 64.13, "18079": 35.87}',
    density: 9.7,
    imprecise: false,
    latitude: 38.89792,
    longitude: -85.4996,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47231',
  },
  {
    city: 'Elizabethtown',
    county_fips: 18005,
    county_fips_all: '18005|18079',
    county: 'Bartholomew',
    county_names_all: 'Bartholomew|Jennings',
    county_weights: '{"18005": 70.26, "18079": 29.74}',
    density: 27.9,
    imprecise: false,
    latitude: 39.11297,
    longitude: -85.79428,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47232',
  },
  {
    city: 'Flat Rock',
    county_fips: 18145,
    county_fips_all: '18145|18005',
    county: 'Shelby',
    county_names_all: 'Shelby|Bartholomew',
    county_weights: '{"18145": 96.92, "18005": 3.08}',
    density: 18.6,
    imprecise: false,
    latitude: 39.37611,
    longitude: -85.76837,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47234',
  },
  {
    city: 'Freetown',
    county_fips: 18071,
    county_fips_all: '18071|18013',
    county: 'Jackson',
    county_names_all: 'Jackson|Brown',
    county_weights: '{"18071": 69.9, "18013": 30.1}',
    density: 15.2,
    imprecise: false,
    latitude: 39.01385,
    longitude: -86.14046,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47235',
  },
  {
    city: 'Grammer',
    county_fips: 18005,
    county_fips_all: '18005',
    county: 'Bartholomew',
    county_names_all: 'Bartholomew',
    county_weights: '{"18005": 100}',
    density: 326.5,
    imprecise: false,
    latitude: 39.15181,
    longitude: -85.72536,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47236',
  },
  {
    city: 'Greensburg',
    county_fips: 18031,
    county_fips_all: '18031|18145|18047|18137|18139',
    county: 'Decatur',
    county_names_all: 'Decatur|Shelby|Franklin|Ripley|Rush',
    county_weights:
      '{"18031": 95.54, "18145": 1.77, "18047": 1.44, "18137": 0.91, "18139": 0.34}',
    density: 27.3,
    imprecise: false,
    latitude: 39.32394,
    longitude: -85.48028,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 21484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47240',
  },
  {
    city: 'Hanover',
    county_fips: 18077,
    county_fips_all: '18077',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"18077": 100}',
    density: 72.6,
    imprecise: false,
    latitude: 38.67214,
    longitude: -85.48177,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 6225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47243',
  },
  {
    city: 'Hartsville',
    county_fips: 18005,
    county_fips_all: '18005|18031',
    county: 'Bartholomew',
    county_names_all: 'Bartholomew|Decatur',
    county_weights: '{"18005": 83.53, "18031": 16.47}',
    density: 12.1,
    imprecise: false,
    latitude: 39.21802,
    longitude: -85.70232,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47244',
  },
  {
    city: 'Hope',
    county_fips: 18005,
    county_fips_all: '18005|18031',
    county: 'Bartholomew',
    county_names_all: 'Bartholomew|Decatur',
    county_weights: '{"18005": 99.34, "18031": 0.66}',
    density: 28.7,
    imprecise: false,
    latitude: 39.29804,
    longitude: -85.76606,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47246',
  },
  {
    city: 'Jonesville',
    county_fips: 18005,
    county_fips_all: '18005',
    county: 'Bartholomew',
    county_names_all: 'Bartholomew',
    county_weights: '{"18005": 100}',
    density: 351.4,
    imprecise: false,
    latitude: 39.05993,
    longitude: -85.88783,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47247',
  },
  {
    city: 'Madison',
    county_fips: 18077,
    county_fips_all: '18077|18137|18155',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Ripley|Switzerland',
    county_weights: '{"18077": 84.75, "18137": 10.44, "18155": 4.81}',
    density: 41.8,
    imprecise: false,
    latitude: 38.81867,
    longitude: -85.3552,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 22884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47250',
  },
  {
    city: 'Medora',
    county_fips: 18071,
    county_fips_all: '18071|18093',
    county: 'Jackson',
    county_names_all: 'Jackson|Lawrence',
    county_weights: '{"18071": 99.39, "18093": 0.61}',
    density: 12.5,
    imprecise: false,
    latitude: 38.83596,
    longitude: -86.19909,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47260',
  },
  {
    city: 'New Point',
    county_fips: 18031,
    county_fips_all: '18031',
    county: 'Decatur',
    county_names_all: 'Decatur',
    county_weights: '{"18031": 100}',
    density: 544.6,
    imprecise: false,
    latitude: 39.30864,
    longitude: -85.32832,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47263',
  },
  {
    city: 'Norman',
    county_fips: 18071,
    county_fips_all: '18071|18093|18105',
    county: 'Jackson',
    county_names_all: 'Jackson|Lawrence|Monroe',
    county_weights: '{"18071": 74.4, "18093": 22.59, "18105": 3.0}',
    density: 6.8,
    imprecise: false,
    latitude: 38.96434,
    longitude: -86.26313,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47264',
  },
  {
    city: 'North Vernon',
    county_fips: 18079,
    county_fips_all: '18079|18031',
    county: 'Jennings',
    county_names_all: 'Jennings|Decatur',
    county_weights: '{"18079": 99.7, "18031": 0.3}',
    density: 43.6,
    imprecise: false,
    latitude: 39.00818,
    longitude: -85.62685,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 20937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47265',
  },
  {
    city: 'Paris Crossing',
    county_fips: 18079,
    county_fips_all: '18079|18077',
    county: 'Jennings',
    county_names_all: 'Jennings|Jefferson',
    county_weights: '{"18079": 87.67, "18077": 12.33}',
    density: 11.1,
    imprecise: false,
    latitude: 38.8397,
    longitude: -85.71913,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47270',
  },
  {
    city: 'Saint Paul',
    county_fips: 18031,
    county_fips_all: '18031|18145|18139',
    county: 'Decatur',
    county_names_all: 'Decatur|Shelby|Rush',
    county_weights: '{"18031": 58.82, "18145": 39.54, "18139": 1.64}',
    density: 23.1,
    imprecise: false,
    latitude: 39.41519,
    longitude: -85.61942,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47272',
  },
  {
    city: 'Scipio',
    county_fips: 18079,
    county_fips_all: '18079|18005',
    county: 'Jennings',
    county_names_all: 'Jennings|Bartholomew',
    county_weights: '{"18079": 96.78, "18005": 3.22}',
    density: 21.9,
    imprecise: false,
    latitude: 39.07472,
    longitude: -85.7359,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47273',
  },
  {
    city: 'Seymour',
    county_fips: 18071,
    county_fips_all: '18071|18005|18079|18013',
    county: 'Jackson',
    county_names_all: 'Jackson|Bartholomew|Jennings|Brown',
    county_weights:
      '{"18071": 87.83, "18005": 5.5, "18079": 5.05, "18013": 1.62}',
    density: 59.5,
    imprecise: false,
    latitude: 38.96261,
    longitude: -85.92877,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 33068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47274',
  },
  {
    city: 'Taylorsville',
    county_fips: 18005,
    county_fips_all: '18005',
    county: 'Bartholomew',
    county_names_all: 'Bartholomew',
    county_weights: '{"18005": 100}',
    density: 445.2,
    imprecise: false,
    latitude: 39.29655,
    longitude: -85.95047,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47280',
  },
  {
    city: 'Vallonia',
    county_fips: 18071,
    county_fips_all: '18071|18175',
    county: 'Jackson',
    county_names_all: 'Jackson|Washington',
    county_weights: '{"18071": 60.38, "18175": 39.62}',
    density: 10.1,
    imprecise: false,
    latitude: 38.78563,
    longitude: -86.10324,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47281',
  },
  {
    city: 'Vernon',
    county_fips: 18079,
    county_fips_all: '18079',
    county: 'Jennings',
    county_names_all: 'Jennings',
    county_weights: '{"18079": 100}',
    density: 359.6,
    imprecise: false,
    latitude: 38.98538,
    longitude: -85.6101,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47282',
  },
  {
    city: 'Westport',
    county_fips: 18031,
    county_fips_all: '18031|18079|18005',
    county: 'Decatur',
    county_names_all: 'Decatur|Jennings|Bartholomew',
    county_weights: '{"18031": 81.51, "18079": 14.34, "18005": 4.15}',
    density: 24.9,
    imprecise: false,
    latitude: 39.16978,
    longitude: -85.58647,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47283',
  },
  {
    city: 'Muncie',
    county_fips: 18035,
    county_fips_all: '18035|18065',
    county: 'Delaware',
    county_names_all: 'Delaware|Henry',
    county_weights: '{"18035": 96.77, "18065": 3.23}',
    density: 150.9,
    imprecise: false,
    latitude: 40.12992,
    longitude: -85.37553,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 25473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47302',
  },
  {
    city: 'Muncie',
    county_fips: 18035,
    county_fips_all: '18035',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"18035": 100}',
    density: 162.3,
    imprecise: false,
    latitude: 40.27108,
    longitude: -85.37648,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 24392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47303',
  },
  {
    city: 'Muncie',
    county_fips: 18035,
    county_fips_all: '18035',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"18035": 100}',
    density: 347.6,
    imprecise: false,
    latitude: 40.23398,
    longitude: -85.45973,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 31237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47304',
  },
  {
    city: 'Muncie',
    county_fips: 18035,
    county_fips_all: '18035',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"18035": 100}',
    density: 1041.9,
    imprecise: false,
    latitude: 40.19387,
    longitude: -85.38556,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47305',
  },
  {
    city: 'Albany',
    county_fips: 18035,
    county_fips_all: '18035|18135|18075',
    county: 'Delaware',
    county_names_all: 'Delaware|Randolph|Jay',
    county_weights: '{"18035": 94.43, "18135": 4.96, "18075": 0.61}',
    density: 54,
    imprecise: false,
    latitude: 40.2787,
    longitude: -85.2672,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47320',
  },
  {
    city: 'Boston',
    county_fips: 18177,
    county_fips_all: '18177',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"18177": 100}',
    density: 425.8,
    imprecise: false,
    latitude: 39.74119,
    longitude: -84.85172,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47324',
  },
  {
    city: 'Brownsville',
    county_fips: 18161,
    county_fips_all: '18161|18041|18177',
    county: 'Union',
    county_names_all: 'Union|Fayette|Wayne',
    county_weights: '{"18161": 71.02, "18041": 17.78, "18177": 11.2}',
    density: 12.8,
    imprecise: false,
    latitude: 39.69395,
    longitude: -85.01834,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47325',
  },
  {
    city: 'Bryant',
    county_fips: 18075,
    county_fips_all: '18075|18001',
    county: 'Jay',
    county_names_all: 'Jay|Adams',
    county_weights: '{"18075": 95.98, "18001": 4.02}',
    density: 10.5,
    imprecise: false,
    latitude: 40.54597,
    longitude: -84.97018,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47326',
  },
  {
    city: 'Cambridge City',
    county_fips: 18177,
    county_fips_all: '18177|18065',
    county: 'Wayne',
    county_names_all: 'Wayne|Henry',
    county_weights: '{"18177": 77.16, "18065": 22.84}',
    density: 31.1,
    imprecise: false,
    latitude: 39.8318,
    longitude: -85.17314,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47327',
  },
  {
    city: 'Centerville',
    county_fips: 18177,
    county_fips_all: '18177',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"18177": 100}',
    density: 38,
    imprecise: false,
    latitude: 39.78792,
    longitude: -85.02226,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47330',
  },
  {
    city: 'Connersville',
    county_fips: 18041,
    county_fips_all: '18041|18161|18047|18177',
    county: 'Fayette',
    county_names_all: 'Fayette|Union|Franklin|Wayne',
    county_weights:
      '{"18041": 94.48, "18161": 3.2, "18047": 1.42, "18177": 0.9}',
    density: 45.9,
    imprecise: false,
    latitude: 39.63086,
    longitude: -85.16313,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 22786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47331',
  },
  {
    city: 'Daleville',
    county_fips: 18035,
    county_fips_all: '18035|18065',
    county: 'Delaware',
    county_names_all: 'Delaware|Henry',
    county_weights: '{"18035": 96.55, "18065": 3.45}',
    density: 52.6,
    imprecise: false,
    latitude: 40.11267,
    longitude: -85.52357,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47334',
  },
  {
    city: 'Dublin',
    county_fips: 18177,
    county_fips_all: '18177',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"18177": 100}',
    density: 610.5,
    imprecise: false,
    latitude: 39.81171,
    longitude: -85.20675,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47335',
  },
  {
    city: 'Dunkirk',
    county_fips: 18075,
    county_fips_all: '18075|18035|18009',
    county: 'Jay',
    county_names_all: 'Jay|Delaware|Blackford',
    county_weights: '{"18075": 53.42, "18035": 29.58, "18009": 17.0}',
    density: 23.5,
    imprecise: false,
    latitude: 40.39694,
    longitude: -85.20821,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47336',
  },
  {
    city: 'Dunreith',
    county_fips: 18065,
    county_fips_all: '18065',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"18065": 100}',
    density: 673.1,
    imprecise: false,
    latitude: 39.80286,
    longitude: -85.43736,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47337',
  },
  {
    city: 'Eaton',
    county_fips: 18035,
    county_fips_all: '18035|18009',
    county: 'Delaware',
    county_names_all: 'Delaware|Blackford',
    county_weights: '{"18035": 92.9, "18009": 7.1}',
    density: 30.4,
    imprecise: false,
    latitude: 40.34363,
    longitude: -85.33977,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47338',
  },
  {
    city: 'Economy',
    county_fips: 18177,
    county_fips_all: '18177',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"18177": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 39.96337,
    longitude: -85.09471,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47339',
  },
  {
    city: 'Farmland',
    county_fips: 18135,
    county_fips_all: '18135',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"18135": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 40.181,
    longitude: -85.1318,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47340',
  },
  {
    city: 'Fountain City',
    county_fips: 18177,
    county_fips_all: '18177',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"18177": 100}',
    density: 28.2,
    imprecise: false,
    latitude: 39.9741,
    longitude: -84.89361,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47341',
  },
  {
    city: 'Gaston',
    county_fips: 18035,
    county_fips_all: '18035',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"18035": 100}',
    density: 21.3,
    imprecise: false,
    latitude: 40.32184,
    longitude: -85.5105,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47342',
  },
  {
    city: 'Greensboro',
    county_fips: 18065,
    county_fips_all: '18065',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"18065": 100}',
    density: 622,
    imprecise: false,
    latitude: 39.87857,
    longitude: -85.464,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47344',
  },
  {
    city: 'Greens Fork',
    county_fips: 18177,
    county_fips_all: '18177',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"18177": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 39.892,
    longitude: -85.04765,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47345',
  },
  {
    city: 'Hagerstown',
    county_fips: 18177,
    county_fips_all: '18177|18065',
    county: 'Wayne',
    county_names_all: 'Wayne|Henry',
    county_weights: '{"18177": 84.8, "18065": 15.2}',
    density: 33.2,
    imprecise: false,
    latitude: 39.93442,
    longitude: -85.16306,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47346',
  },
  {
    city: 'Hartford City',
    county_fips: 18009,
    county_fips_all: '18009|18053',
    county: 'Blackford',
    county_names_all: 'Blackford|Grant',
    county_weights: '{"18009": 98.26, "18053": 1.74}',
    density: 30.1,
    imprecise: false,
    latitude: 40.45725,
    longitude: -85.34855,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 9080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47348',
  },
  {
    city: 'Kennard',
    county_fips: 18065,
    county_fips_all: '18065',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"18065": 100}',
    density: 582.9,
    imprecise: false,
    latitude: 39.90442,
    longitude: -85.52001,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47351',
  },
  {
    city: 'Lewisville',
    county_fips: 18065,
    county_fips_all: '18065|18139|18041',
    county: 'Henry',
    county_names_all: 'Henry|Rush|Fayette',
    county_weights: '{"18065": 61.57, "18139": 35.27, "18041": 3.16}',
    density: 11.7,
    imprecise: false,
    latitude: 39.79597,
    longitude: -85.3637,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47352',
  },
  {
    city: 'Liberty',
    county_fips: 18161,
    county_fips_all: '18161|18047',
    county: 'Union',
    county_names_all: 'Union|Franklin',
    county_weights: '{"18161": 99.64, "18047": 0.36}',
    density: 15.2,
    imprecise: false,
    latitude: 39.62757,
    longitude: -84.92057,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47353',
  },
  {
    city: 'Losantville',
    county_fips: 18135,
    county_fips_all: '18135|18065|18035|18177',
    county: 'Randolph',
    county_names_all: 'Randolph|Henry|Delaware|Wayne',
    county_weights:
      '{"18135": 56.83, "18065": 22.87, "18035": 14.29, "18177": 6.01}',
    density: 15.7,
    imprecise: false,
    latitude: 40.04628,
    longitude: -85.19933,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47354',
  },
  {
    city: 'Lynn',
    county_fips: 18135,
    county_fips_all: '18135|18177',
    county: 'Randolph',
    county_names_all: 'Randolph|Wayne',
    county_weights: '{"18135": 98.66, "18177": 1.34}',
    density: 18.6,
    imprecise: false,
    latitude: 40.04376,
    longitude: -84.9258,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47355',
  },
  {
    city: 'Middletown',
    county_fips: 18065,
    county_fips_all: '18065|18095|18035',
    county: 'Henry',
    county_names_all: 'Henry|Madison|Delaware',
    county_weights: '{"18065": 90.57, "18095": 5.55, "18035": 3.88}',
    density: 39,
    imprecise: false,
    latitude: 40.03079,
    longitude: -85.50415,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47356',
  },
  {
    city: 'Milton',
    county_fips: 18177,
    county_fips_all: '18177|18041',
    county: 'Wayne',
    county_names_all: 'Wayne|Fayette',
    county_weights: '{"18177": 74.54, "18041": 25.46}',
    density: 12.9,
    imprecise: false,
    latitude: 39.75773,
    longitude: -85.14795,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47357',
  },
  {
    city: 'Modoc',
    county_fips: 18135,
    county_fips_all: '18135|18177',
    county: 'Randolph',
    county_names_all: 'Randolph|Wayne',
    county_weights: '{"18135": 93.57, "18177": 6.43}',
    density: 8.4,
    imprecise: false,
    latitude: 40.05488,
    longitude: -85.11204,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47358',
  },
  {
    city: 'Montpelier',
    county_fips: 18009,
    county_fips_all: '18009|18179',
    county: 'Blackford',
    county_names_all: 'Blackford|Wells',
    county_weights: '{"18009": 62.73, "18179": 37.27}',
    density: 23.9,
    imprecise: false,
    latitude: 40.55203,
    longitude: -85.28642,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47359',
  },
  {
    city: 'Mooreland',
    county_fips: 18065,
    county_fips_all: '18065|18177|18135',
    county: 'Henry',
    county_names_all: 'Henry|Wayne|Randolph',
    county_weights: '{"18065": 94.58, "18177": 4.06, "18135": 1.36}',
    density: 19.2,
    imprecise: false,
    latitude: 40.01677,
    longitude: -85.2614,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47360',
  },
  {
    city: 'Mount Summit',
    county_fips: 18065,
    county_fips_all: '18065',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"18065": 100}',
    density: 2147.4,
    imprecise: false,
    latitude: 40.00415,
    longitude: -85.38492,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47361',
  },
  {
    city: 'New Castle',
    county_fips: 18065,
    county_fips_all: '18065',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"18065": 100}',
    density: 76.7,
    imprecise: false,
    latitude: 39.93186,
    longitude: -85.36998,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 29337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47362',
  },
  {
    city: 'New Lisbon',
    county_fips: 18065,
    county_fips_all: '18065',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"18065": 100}',
    density: 110.3,
    imprecise: false,
    latitude: 39.86127,
    longitude: -85.26068,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47366',
  },
  {
    city: 'Oakville',
    county_fips: 18035,
    county_fips_all: '18035',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"18035": 100}',
    density: 107,
    imprecise: false,
    latitude: 40.08366,
    longitude: -85.39207,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47367',
  },
  {
    city: 'Parker City',
    county_fips: 18135,
    county_fips_all: '18135|18035',
    county: 'Randolph',
    county_names_all: 'Randolph|Delaware',
    county_weights: '{"18135": 76.66, "18035": 23.34}',
    density: 22.9,
    imprecise: false,
    latitude: 40.18082,
    longitude: -85.20025,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47368',
  },
  {
    city: 'Pennville',
    county_fips: 18075,
    county_fips_all: '18075|18009',
    county: 'Jay',
    county_names_all: 'Jay|Blackford',
    county_weights: '{"18075": 94.8, "18009": 5.2}',
    density: 13.3,
    imprecise: false,
    latitude: 40.50714,
    longitude: -85.14715,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47369',
  },
  {
    city: 'Pershing',
    county_fips: 18177,
    county_fips_all: '18177',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"18177": 100}',
    density: 804.1,
    imprecise: false,
    latitude: 39.81281,
    longitude: -85.13779,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47370',
  },
  {
    city: 'Portland',
    county_fips: 18075,
    county_fips_all: '18075',
    county: 'Jay',
    county_names_all: 'Jay',
    county_weights: '{"18075": 100}',
    density: 21.8,
    imprecise: false,
    latitude: 40.41874,
    longitude: -84.95896,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 12424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47371',
  },
  {
    city: 'Redkey',
    county_fips: 18075,
    county_fips_all: '18075|18135',
    county: 'Jay',
    county_names_all: 'Jay|Randolph',
    county_weights: '{"18075": 94.28, "18135": 5.72}',
    density: 27.4,
    imprecise: false,
    latitude: 40.33863,
    longitude: -85.15356,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47373',
  },
  {
    city: 'Richmond',
    county_fips: 18177,
    county_fips_all: '18177|18161',
    county: 'Wayne',
    county_names_all: 'Wayne|Union',
    county_weights: '{"18177": 98.86, "18161": 1.14}',
    density: 143.8,
    imprecise: false,
    latitude: 39.83376,
    longitude: -84.88997,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 44615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47374',
  },
  {
    city: 'Ridgeville',
    county_fips: 18135,
    county_fips_all: '18135|18075',
    county: 'Randolph',
    county_names_all: 'Randolph|Jay',
    county_weights: '{"18135": 88.63, "18075": 11.37}',
    density: 12,
    imprecise: false,
    latitude: 40.28553,
    longitude: -85.03439,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47380',
  },
  {
    city: 'Salamonia',
    county_fips: 18075,
    county_fips_all: '18075',
    county: 'Jay',
    county_names_all: 'Jay',
    county_weights: '{"18075": 100}',
    density: 128.5,
    imprecise: false,
    latitude: 40.38665,
    longitude: -84.86465,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47381',
  },
  {
    city: 'Saratoga',
    county_fips: 18135,
    county_fips_all: '18135',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"18135": 100}',
    density: 679.3,
    imprecise: false,
    latitude: 40.23692,
    longitude: -84.91845,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47382',
  },
  {
    city: 'Selma',
    county_fips: 18035,
    county_fips_all: '18035',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"18035": 100}',
    density: 31.6,
    imprecise: false,
    latitude: 40.15123,
    longitude: -85.26399,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47383',
  },
  {
    city: 'Shirley',
    county_fips: 18065,
    county_fips_all: '18065|18059',
    county: 'Henry',
    county_names_all: 'Henry|Hancock',
    county_weights: '{"18065": 86.25, "18059": 13.75}',
    density: 26.7,
    imprecise: false,
    latitude: 39.91365,
    longitude: -85.55352,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47384',
  },
  {
    city: 'Spiceland',
    county_fips: 18065,
    county_fips_all: '18065',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"18065": 100}',
    density: 44.2,
    imprecise: false,
    latitude: 39.83194,
    longitude: -85.44825,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47385',
  },
  {
    city: 'Springport',
    county_fips: 18065,
    county_fips_all: '18065',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"18065": 100}',
    density: 28.8,
    imprecise: false,
    latitude: 40.05277,
    longitude: -85.38305,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47386',
  },
  {
    city: 'Straughn',
    county_fips: 18065,
    county_fips_all: '18065',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"18065": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 39.83677,
    longitude: -85.2945,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47387',
  },
  {
    city: 'Sulphur Springs',
    county_fips: 18065,
    county_fips_all: '18065',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"18065": 100}',
    density: 770.8,
    imprecise: false,
    latitude: 40.0056,
    longitude: -85.44352,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47388',
  },
  {
    city: 'Union City',
    county_fips: 18135,
    county_fips_all: '18135|18075',
    county: 'Randolph',
    county_names_all: 'Randolph|Jay',
    county_weights: '{"18135": 93.15, "18075": 6.85}',
    density: 24.6,
    imprecise: false,
    latitude: 40.20625,
    longitude: -84.84671,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47390',
  },
  {
    city: 'Webster',
    county_fips: 18177,
    county_fips_all: '18177',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"18177": 100}',
    density: 240.2,
    imprecise: false,
    latitude: 39.91005,
    longitude: -84.94394,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47392',
  },
  {
    city: 'Williamsburg',
    county_fips: 18177,
    county_fips_all: '18177|18135',
    county: 'Wayne',
    county_names_all: 'Wayne|Randolph',
    county_weights: '{"18177": 88.02, "18135": 11.98}',
    density: 19.7,
    imprecise: false,
    latitude: 39.96559,
    longitude: -85.00325,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47393',
  },
  {
    city: 'Winchester',
    county_fips: 18135,
    county_fips_all: '18135',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"18135": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 40.1679,
    longitude: -84.98667,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 7879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47394',
  },
  {
    city: 'Yorktown',
    county_fips: 18035,
    county_fips_all: '18035',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"18035": 100}',
    density: 86.9,
    imprecise: false,
    latitude: 40.18661,
    longitude: -85.51632,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 7712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47396',
  },
  {
    city: 'Bloomington',
    county_fips: 18105,
    county_fips_all: '18105|18013',
    county: 'Monroe',
    county_names_all: 'Monroe|Brown',
    county_weights: '{"18105": 97.29, "18013": 2.71}',
    density: 189.8,
    imprecise: false,
    latitude: 39.08613,
    longitude: -86.45138,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 40607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47401',
  },
  {
    city: 'Bloomington',
    county_fips: 18105,
    county_fips_all: '18105|18055',
    county: 'Monroe',
    county_names_all: 'Monroe|Greene',
    county_weights: '{"18105": 98.55, "18055": 1.45}',
    density: 156.2,
    imprecise: false,
    latitude: 39.08635,
    longitude: -86.61082,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 34396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47403',
  },
  {
    city: 'Bloomington',
    county_fips: 18105,
    county_fips_all: '18105|18119',
    county: 'Monroe',
    county_names_all: 'Monroe|Owen',
    county_weights: '{"18105": 98.15, "18119": 1.85}',
    density: 167.1,
    imprecise: false,
    latitude: 39.22064,
    longitude: -86.5896,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 22744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47404',
  },
  {
    city: 'Bloomington',
    county_fips: 18105,
    county_fips_all: '18105',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"18105": 100}',
    density: 1821.3,
    imprecise: false,
    latitude: 39.16761,
    longitude: -86.5211,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47405',
  },
  {
    city: 'Bloomington',
    county_fips: 18105,
    county_fips_all: '18105',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"18105": 100}',
    density: 5335.6,
    imprecise: false,
    latitude: 39.17501,
    longitude: -86.51516,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 8208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47406',
  },
  {
    city: 'Bloomington',
    county_fips: 18105,
    county_fips_all: '18105',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"18105": 100}',
    density: 138.1,
    imprecise: false,
    latitude: 39.2283,
    longitude: -86.46452,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 23053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47408',
  },
  {
    city: 'Avoca',
    county_fips: 18093,
    county_fips_all: '18093',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"18093": 100}',
    density: 72.1,
    imprecise: false,
    latitude: 38.91903,
    longitude: -86.54933,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47420',
  },
  {
    city: 'Bedford',
    county_fips: 18093,
    county_fips_all: '18093|18105',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Monroe',
    county_weights: '{"18093": 99.79, "18105": 0.21}',
    density: 57.8,
    imprecise: false,
    latitude: 38.86415,
    longitude: -86.45122,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 27599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47421',
  },
  {
    city: 'Bloomfield',
    county_fips: 18055,
    county_fips_all: '18055',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"18055": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 39.01918,
    longitude: -86.86998,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 8861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47424',
  },
  {
    city: 'Coal City',
    county_fips: 18119,
    county_fips_all: '18119|18021',
    county: 'Owen',
    county_names_all: 'Owen|Clay',
    county_weights: '{"18119": 88.36, "18021": 11.64}',
    density: 7.6,
    imprecise: false,
    latitude: 39.23915,
    longitude: -87.01266,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47427',
  },
  {
    city: 'Ellettsville',
    county_fips: 18105,
    county_fips_all: '18105',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"18105": 100}',
    density: 119.1,
    imprecise: false,
    latitude: 39.27581,
    longitude: -86.61444,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 7399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47429',
  },
  {
    city: 'Freedom',
    county_fips: 18119,
    county_fips_all: '18119',
    county: 'Owen',
    county_names_all: 'Owen',
    county_weights: '{"18119": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 39.24052,
    longitude: -86.90655,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47431',
  },
  {
    city: 'French Lick',
    county_fips: 18117,
    county_fips_all: '18117|18037|18101',
    county: 'Orange',
    county_names_all: 'Orange|Dubois|Martin',
    county_weights: '{"18117": 79.69, "18037": 10.7, "18101": 9.61}',
    density: 23.9,
    imprecise: false,
    latitude: 38.49268,
    longitude: -86.63942,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47432',
  },
  {
    city: 'Gosport',
    county_fips: 18119,
    county_fips_all: '18119|18105|18109',
    county: 'Owen',
    county_names_all: 'Owen|Monroe|Morgan',
    county_weights: '{"18119": 55.19, "18105": 30.24, "18109": 14.57}',
    density: 20.4,
    imprecise: false,
    latitude: 39.35569,
    longitude: -86.655,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47433',
  },
  {
    city: 'Harrodsburg',
    county_fips: 18105,
    county_fips_all: '18105',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"18105": 100}',
    density: 695.1,
    imprecise: false,
    latitude: 39.01277,
    longitude: -86.54569,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 13,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47434',
  },
  {
    city: 'Helmsburg',
    county_fips: 18013,
    county_fips_all: '18013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"18013": 100}',
    density: 10299.2,
    imprecise: false,
    latitude: 39.26576,
    longitude: -86.29516,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47435',
  },
  {
    city: 'Heltonville',
    county_fips: 18093,
    county_fips_all: '18093|18105',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Monroe',
    county_weights: '{"18093": 69.57, "18105": 30.43}',
    density: 13.2,
    imprecise: false,
    latitude: 38.9598,
    longitude: -86.38358,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47436',
  },
  {
    city: 'Huron',
    county_fips: 18093,
    county_fips_all: '18093',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"18093": 100}',
    density: 8,
    imprecise: false,
    latitude: 38.7135,
    longitude: -86.6769,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47437',
  },
  {
    city: 'Jasonville',
    county_fips: 18055,
    county_fips_all: '18055|18021|18153',
    county: 'Greene',
    county_names_all: 'Greene|Clay|Sullivan',
    county_weights: '{"18055": 52.04, "18021": 35.8, "18153": 12.16}',
    density: 26.7,
    imprecise: false,
    latitude: 39.1582,
    longitude: -87.18237,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47438',
  },
  {
    city: 'Linton',
    county_fips: 18055,
    county_fips_all: '18055',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"18055": 100}',
    density: 52.3,
    imprecise: false,
    latitude: 39.03976,
    longitude: -87.1743,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 8910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47441',
  },
  {
    city: 'Lyons',
    county_fips: 18055,
    county_fips_all: '18055',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"18055": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 38.96651,
    longitude: -87.09059,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47443',
  },
  {
    city: 'Midland',
    county_fips: 18055,
    county_fips_all: '18055',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"18055": 100}',
    density: 69.9,
    imprecise: false,
    latitude: 39.11289,
    longitude: -87.18944,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47445',
  },
  {
    city: 'Mitchell',
    county_fips: 18093,
    county_fips_all: '18093|18101',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Martin',
    county_weights: '{"18093": 91.02, "18101": 8.98}',
    density: 28.1,
    imprecise: false,
    latitude: 38.73818,
    longitude: -86.52031,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 9133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47446',
  },
  {
    city: 'Nashville',
    county_fips: 18013,
    county_fips_all: '18013|18105|18005',
    county: 'Brown',
    county_names_all: 'Brown|Monroe|Bartholomew',
    county_weights: '{"18013": 97.31, "18105": 1.67, "18005": 1.02}',
    density: 16.7,
    imprecise: false,
    latitude: 39.17531,
    longitude: -86.24481,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 8117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47448',
  },
  {
    city: 'Newberry',
    county_fips: 18055,
    county_fips_all: '18055|18027',
    county: 'Greene',
    county_names_all: 'Greene|Daviess',
    county_weights: '{"18055": 99.89, "18027": 0.11}',
    density: 6.1,
    imprecise: false,
    latitude: 38.92672,
    longitude: -86.9894,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47449',
  },
  {
    city: 'Oolitic',
    county_fips: 18093,
    county_fips_all: '18093',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"18093": 100}',
    density: 560.5,
    imprecise: false,
    latitude: 38.89176,
    longitude: -86.52536,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47451',
  },
  {
    city: 'Orleans',
    county_fips: 18117,
    county_fips_all: '18117|18093|18175',
    county: 'Orange',
    county_names_all: 'Orange|Lawrence|Washington',
    county_weights: '{"18117": 87.92, "18093": 11.57, "18175": 0.51}',
    density: 20.1,
    imprecise: false,
    latitude: 38.6422,
    longitude: -86.41901,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47452',
  },
  {
    city: 'Owensburg',
    county_fips: 18055,
    county_fips_all: '18055',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"18055": 100}',
    density: 33.3,
    imprecise: false,
    latitude: 38.93472,
    longitude: -86.76773,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47453',
  },
  {
    city: 'Paoli',
    county_fips: 18117,
    county_fips_all: '18117',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"18117": 100}',
    density: 22.5,
    imprecise: false,
    latitude: 38.51596,
    longitude: -86.45989,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 7555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47454',
  },
  {
    city: 'Patricksburg',
    county_fips: 18119,
    county_fips_all: '18119',
    county: 'Owen',
    county_names_all: 'Owen',
    county_weights: '{"18119": 100}',
    density: 438.3,
    imprecise: false,
    latitude: 39.31271,
    longitude: -86.95672,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47455',
  },
  {
    city: 'Quincy',
    county_fips: 18119,
    county_fips_all: '18119|18109|18133',
    county: 'Owen',
    county_names_all: 'Owen|Morgan|Putnam',
    county_weights: '{"18119": 66.11, "18109": 19.69, "18133": 14.2}',
    density: 20.2,
    imprecise: false,
    latitude: 39.46314,
    longitude: -86.69781,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47456',
  },
  {
    city: 'Scotland',
    county_fips: 18055,
    county_fips_all: '18055',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"18055": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.91183,
    longitude: -86.9047,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47457',
  },
  {
    city: 'Smithville',
    county_fips: 18105,
    county_fips_all: '18105',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"18105": 100}',
    density: 591.7,
    imprecise: false,
    latitude: 39.07044,
    longitude: -86.50712,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47458',
  },
  {
    city: 'Solsberry',
    county_fips: 18055,
    county_fips_all: '18055|18119',
    county: 'Greene',
    county_names_all: 'Greene|Owen',
    county_weights: '{"18055": 97.6, "18119": 2.4}',
    density: 23,
    imprecise: false,
    latitude: 39.11167,
    longitude: -86.75125,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47459',
  },
  {
    city: 'Spencer',
    county_fips: 18119,
    county_fips_all: '18119|18105|18055',
    county: 'Owen',
    county_names_all: 'Owen|Monroe|Greene',
    county_weights: '{"18119": 96.83, "18105": 2.12, "18055": 1.05}',
    density: 28.2,
    imprecise: false,
    latitude: 39.28153,
    longitude: -86.78951,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 11006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47460',
  },
  {
    city: 'Springville',
    county_fips: 18093,
    county_fips_all: '18093|18055|18105',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Greene|Monroe',
    county_weights: '{"18093": 56.08, "18055": 30.75, "18105": 13.17}',
    density: 22.6,
    imprecise: false,
    latitude: 38.95755,
    longitude: -86.64815,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47462',
  },
  {
    city: 'Stinesville',
    county_fips: 18105,
    county_fips_all: '18105',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"18105": 100}',
    density: 989.5,
    imprecise: false,
    latitude: 39.29995,
    longitude: -86.64979,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47464',
  },
  {
    city: 'Switz City',
    county_fips: 18055,
    county_fips_all: '18055',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"18055": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 39.05474,
    longitude: -87.04338,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47465',
  },
  {
    city: 'Tunnelton',
    county_fips: 18093,
    county_fips_all: '18093',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"18093": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.76776,
    longitude: -86.34463,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47467',
  },
  {
    city: 'Unionville',
    county_fips: 18105,
    county_fips_all: '18105|18013',
    county: 'Monroe',
    county_names_all: 'Monroe|Brown',
    county_weights: '{"18105": 78.14, "18013": 21.86}',
    density: 16.6,
    imprecise: false,
    latitude: 39.27801,
    longitude: -86.40482,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47468',
  },
  {
    city: 'West Baden Springs',
    county_fips: 18117,
    county_fips_all: '18117',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"18117": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 38.61892,
    longitude: -86.61172,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47469',
  },
  {
    city: 'Williams',
    county_fips: 18093,
    county_fips_all: '18093|18101',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Martin',
    county_weights: '{"18093": 82.2, "18101": 17.8}',
    density: 14.5,
    imprecise: false,
    latitude: 38.81623,
    longitude: -86.64799,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47470',
  },
  {
    city: 'Worthington',
    county_fips: 18055,
    county_fips_all: '18055|18119',
    county: 'Greene',
    county_names_all: 'Greene|Owen',
    county_weights: '{"18055": 78.93, "18119": 21.07}',
    density: 16.5,
    imprecise: false,
    latitude: 39.14253,
    longitude: -86.99788,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47471',
  },
  {
    city: 'Washington',
    county_fips: 18027,
    county_fips_all: '18027',
    county: 'Daviess',
    county_names_all: 'Daviess',
    county_weights: '{"18027": 100}',
    density: 51.5,
    imprecise: false,
    latitude: 38.66139,
    longitude: -87.17479,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 18612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47501',
  },
  {
    city: 'Bicknell',
    county_fips: 18083,
    county_fips_all: '18083',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"18083": 100}',
    density: 34.2,
    imprecise: false,
    latitude: 38.779,
    longitude: -87.31809,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 4243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47512',
  },
  {
    city: 'Birdseye',
    county_fips: 18037,
    county_fips_all: '18037|18025|18123|18117',
    county: 'Dubois',
    county_names_all: 'Dubois|Crawford|Perry|Orange',
    county_weights:
      '{"18037": 51.95, "18025": 26.27, "18123": 17.15, "18117": 4.63}',
    density: 8.9,
    imprecise: false,
    latitude: 38.30405,
    longitude: -86.6995,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 1581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47513',
  },
  {
    city: 'Branchville',
    county_fips: 18123,
    county_fips_all: '18123',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"18123": 100}',
    density: 75.5,
    imprecise: false,
    latitude: 38.14861,
    longitude: -86.59403,
    militaryZip: false,
    timezone: 'America/Indiana/Tell_City',
    population: 1377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47514',
  },
  {
    city: 'Bristow',
    county_fips: 18123,
    county_fips_all: '18123',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"18123": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 38.17769,
    longitude: -86.70226,
    militaryZip: false,
    timezone: 'America/Indiana/Tell_City',
    population: 1305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47515',
  },
  {
    city: 'Bruceville',
    county_fips: 18083,
    county_fips_all: '18083',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"18083": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 38.7645,
    longitude: -87.41857,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47516',
  },
  {
    city: 'Cannelburg',
    county_fips: 18027,
    county_fips_all: '18027',
    county: 'Daviess',
    county_names_all: 'Daviess',
    county_weights: '{"18027": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 38.5976,
    longitude: -86.98793,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47519',
  },
  {
    city: 'Cannelton',
    county_fips: 18123,
    county_fips_all: '18123',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"18123": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 37.99351,
    longitude: -86.5902,
    militaryZip: false,
    timezone: 'America/Indiana/Tell_City',
    population: 2933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47520',
  },
  {
    city: 'Celestine',
    county_fips: 18037,
    county_fips_all: '18037',
    county: 'Dubois',
    county_names_all: 'Dubois',
    county_weights: '{"18037": 100}',
    density: 16,
    imprecise: false,
    latitude: 38.39238,
    longitude: -86.72941,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47521',
  },
  {
    city: 'Crane',
    county_fips: 18101,
    county_fips_all: '18101',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"18101": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 38.88545,
    longitude: -86.80543,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47522',
  },
  {
    city: 'Dale',
    county_fips: 18173,
    county_fips_all: '18173|18147|18037',
    county: 'Warrick',
    county_names_all: 'Warrick|Spencer|Dubois',
    county_weights: '{"18173": 54.16, "18147": 43.74, "18037": 2.1}',
    density: 20.4,
    imprecise: false,
    latitude: 38.17354,
    longitude: -87.02934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47523',
  },
  {
    city: 'Decker',
    county_fips: 18083,
    county_fips_all: '18083',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"18083": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 38.48312,
    longitude: -87.61733,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47524',
  },
  {
    city: 'Derby',
    county_fips: 18123,
    county_fips_all: '18123',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"18123": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 38.02856,
    longitude: -86.55359,
    militaryZip: false,
    timezone: 'America/Indiana/Tell_City',
    population: 235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47525',
  },
  {
    city: 'Dubois',
    county_fips: 18037,
    county_fips_all: '18037|18117',
    county: 'Dubois',
    county_names_all: 'Dubois|Orange',
    county_weights: '{"18037": 98.81, "18117": 1.19}',
    density: 15.3,
    imprecise: false,
    latitude: 38.47232,
    longitude: -86.77772,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 2195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47527',
  },
  {
    city: 'Edwardsport',
    county_fips: 18083,
    county_fips_all: '18083',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"18083": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 38.84447,
    longitude: -87.26806,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47528',
  },
  {
    city: 'Elnora',
    county_fips: 18027,
    county_fips_all: '18027|18055',
    county: 'Daviess',
    county_names_all: 'Daviess|Greene',
    county_weights: '{"18027": 94.79, "18055": 5.21}',
    density: 12.8,
    imprecise: false,
    latitude: 38.86386,
    longitude: -87.07804,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 1037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47529',
  },
  {
    city: 'Evanston',
    county_fips: 18147,
    county_fips_all: '18147',
    county: 'Spencer',
    county_names_all: 'Spencer',
    county_weights: '{"18147": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 38.04161,
    longitude: -86.84867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47531',
  },
  {
    city: 'Ferdinand',
    county_fips: 18037,
    county_fips_all: '18037|18147|18123',
    county: 'Dubois',
    county_names_all: 'Dubois|Spencer|Perry',
    county_weights: '{"18037": 61.89, "18147": 32.59, "18123": 5.52}',
    density: 23.9,
    imprecise: false,
    latitude: 38.2198,
    longitude: -86.86036,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 4447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47532',
  },
  {
    city: 'Freelandville',
    county_fips: 18083,
    county_fips_all: '18083',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"18083": 100}',
    density: 64.9,
    imprecise: false,
    latitude: 38.86265,
    longitude: -87.31285,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47535',
  },
  {
    city: 'Gentryville',
    county_fips: 18147,
    county_fips_all: '18147|18173',
    county: 'Spencer',
    county_names_all: 'Spencer|Warrick',
    county_weights: '{"18147": 54.59, "18173": 45.41}',
    density: 13.3,
    imprecise: false,
    latitude: 38.10971,
    longitude: -87.06888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47537',
  },
  {
    city: 'Holland',
    county_fips: 18037,
    county_fips_all: '18037|18173|18125|18147',
    county: 'Dubois',
    county_names_all: 'Dubois|Warrick|Pike|Spencer',
    county_weights:
      '{"18037": 84.73, "18173": 10.97, "18125": 3.21, "18147": 1.09}',
    density: 24.9,
    imprecise: false,
    latitude: 38.23777,
    longitude: -87.04673,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 1332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47541',
  },
  {
    city: 'Huntingburg',
    county_fips: 18037,
    county_fips_all: '18037|18125',
    county: 'Dubois',
    county_names_all: 'Dubois|Pike',
    county_weights: '{"18037": 98.68, "18125": 1.32}',
    density: 50.4,
    imprecise: false,
    latitude: 38.29928,
    longitude: -86.96712,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 10350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47542',
  },
  {
    city: 'Jasper',
    county_fips: 18037,
    county_fips_all: '18037',
    county: 'Dubois',
    county_names_all: 'Dubois',
    county_weights: '{"18037": 100}',
    density: 70.5,
    imprecise: false,
    latitude: 38.42071,
    longitude: -86.93469,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 22191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47546',
  },
  {
    city: 'Lamar',
    county_fips: 18147,
    county_fips_all: '18147',
    county: 'Spencer',
    county_names_all: 'Spencer',
    county_weights: '{"18147": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 38.06213,
    longitude: -86.92877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47550',
  },
  {
    city: 'Leopold',
    county_fips: 18123,
    county_fips_all: '18123',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"18123": 100}',
    density: 8,
    imprecise: false,
    latitude: 38.12153,
    longitude: -86.56353,
    militaryZip: false,
    timezone: 'America/Indiana/Tell_City',
    population: 607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47551',
  },
  {
    city: 'Lincoln City',
    county_fips: 18147,
    county_fips_all: '18147',
    county: 'Spencer',
    county_names_all: 'Spencer',
    county_weights: '{"18147": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 38.10862,
    longitude: -86.99527,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47552',
  },
  {
    city: 'Loogootee',
    county_fips: 18101,
    county_fips_all: '18101|18027',
    county: 'Martin',
    county_names_all: 'Martin|Daviess',
    county_weights: '{"18101": 60.69, "18027": 39.31}',
    density: 24.5,
    imprecise: false,
    latitude: 38.65398,
    longitude: -86.91108,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 8777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47553',
  },
  {
    city: 'Monroe City',
    county_fips: 18083,
    county_fips_all: '18083',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"18083": 100}',
    density: 11,
    imprecise: false,
    latitude: 38.57005,
    longitude: -87.34132,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 1345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47557',
  },
  {
    city: 'Montgomery',
    county_fips: 18027,
    county_fips_all: '18027',
    county: 'Daviess',
    county_names_all: 'Daviess',
    county_weights: '{"18027": 100}',
    density: 24.1,
    imprecise: false,
    latitude: 38.64506,
    longitude: -87.04578,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 5354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47558',
  },
  {
    city: 'Oaktown',
    county_fips: 18083,
    county_fips_all: '18083|18153',
    county: 'Knox',
    county_names_all: 'Knox|Sullivan',
    county_weights: '{"18083": 94.3, "18153": 5.7}',
    density: 7.2,
    imprecise: false,
    latitude: 38.85705,
    longitude: -87.43611,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 1442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47561',
  },
  {
    city: 'Odon',
    county_fips: 18027,
    county_fips_all: '18027|18101',
    county: 'Daviess',
    county_names_all: 'Daviess|Martin',
    county_weights: '{"18027": 98.78, "18101": 1.22}',
    density: 29.1,
    imprecise: false,
    latitude: 38.83493,
    longitude: -86.98268,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 4967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47562',
  },
  {
    city: 'Otwell',
    county_fips: 18125,
    county_fips_all: '18125|18037',
    county: 'Pike',
    county_names_all: 'Pike|Dubois',
    county_weights: '{"18125": 74.0, "18037": 26.0}',
    density: 13.8,
    imprecise: false,
    latitude: 38.48166,
    longitude: -87.09566,
    militaryZip: false,
    timezone: 'America/Indiana/Petersburg',
    population: 1378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47564',
  },
  {
    city: 'Petersburg',
    county_fips: 18125,
    county_fips_all: '18125',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"18125": 100}',
    density: 20.6,
    imprecise: false,
    latitude: 38.46954,
    longitude: -87.30554,
    militaryZip: false,
    timezone: 'America/Indiana/Petersburg',
    population: 6172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47567',
  },
  {
    city: 'Plainville',
    county_fips: 18027,
    county_fips_all: '18027',
    county: 'Daviess',
    county_names_all: 'Daviess',
    county_weights: '{"18027": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 38.79121,
    longitude: -87.13654,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47568',
  },
  {
    city: 'Ragsdale',
    county_fips: 18083,
    county_fips_all: '18083',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"18083": 100}',
    density: 233.7,
    imprecise: false,
    latitude: 38.74418,
    longitude: -87.322,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47573',
  },
  {
    city: 'Rome',
    county_fips: 18123,
    county_fips_all: '18123',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"18123": 100}',
    density: 1,
    imprecise: false,
    latitude: 37.95265,
    longitude: -86.56323,
    militaryZip: false,
    timezone: 'America/Indiana/Tell_City',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47574',
  },
  {
    city: 'Saint Anthony',
    county_fips: 18037,
    county_fips_all: '18037',
    county: 'Dubois',
    county_names_all: 'Dubois',
    county_weights: '{"18037": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 38.32314,
    longitude: -86.81128,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 1070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47575',
  },
  {
    city: 'Saint Croix',
    county_fips: 18123,
    county_fips_all: '18123|18025',
    county: 'Perry',
    county_names_all: 'Perry|Crawford',
    county_weights: '{"18123": 82.93, "18025": 17.07}',
    density: 9.7,
    imprecise: false,
    latitude: 38.19089,
    longitude: -86.58936,
    militaryZip: false,
    timezone: 'America/Indiana/Tell_City',
    population: 672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47576',
  },
  {
    city: 'Saint Meinrad',
    county_fips: 18147,
    county_fips_all: '18147|18123',
    county: 'Spencer',
    county_names_all: 'Spencer|Perry',
    county_weights: '{"18147": 58.5, "18123": 41.5}',
    density: 19.4,
    imprecise: false,
    latitude: 38.15004,
    longitude: -86.80766,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47577',
  },
  {
    city: 'Sandborn',
    county_fips: 18083,
    county_fips_all: '18083|18055',
    county: 'Knox',
    county_names_all: 'Knox|Greene',
    county_weights: '{"18083": 67.11, "18055": 32.89}',
    density: 5,
    imprecise: false,
    latitude: 38.89288,
    longitude: -87.19055,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47578',
  },
  {
    city: 'Santa Claus',
    county_fips: 18147,
    county_fips_all: '18147',
    county: 'Spencer',
    county_names_all: 'Spencer',
    county_weights: '{"18147": 100}',
    density: 97,
    imprecise: false,
    latitude: 38.11149,
    longitude: -86.91322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47579',
  },
  {
    city: 'Schnellville',
    county_fips: 18037,
    county_fips_all: '18037',
    county: 'Dubois',
    county_names_all: 'Dubois',
    county_weights: '{"18037": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 38.35355,
    longitude: -86.77008,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47580',
  },
  {
    city: 'Shoals',
    county_fips: 18101,
    county_fips_all: '18101',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"18101": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 38.65972,
    longitude: -86.76908,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 3009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47581',
  },
  {
    city: 'Spurgeon',
    county_fips: 18125,
    county_fips_all: '18125',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"18125": 100}',
    density: 192.1,
    imprecise: false,
    latitude: 38.25111,
    longitude: -87.25797,
    militaryZip: false,
    timezone: 'America/Indiana/Petersburg',
    population: 149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47584',
  },
  {
    city: 'Stendal',
    county_fips: 18125,
    county_fips_all: '18125',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"18125": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 38.26787,
    longitude: -87.16617,
    militaryZip: false,
    timezone: 'America/Indiana/Petersburg',
    population: 592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47585',
  },
  {
    city: 'Tell City',
    county_fips: 18123,
    county_fips_all: '18123',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"18123": 100}',
    density: 43.1,
    imprecise: false,
    latitude: 38.03684,
    longitude: -86.69297,
    militaryZip: false,
    timezone: 'America/Indiana/Tell_City',
    population: 10826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47586',
  },
  {
    city: 'Troy',
    county_fips: 18147,
    county_fips_all: '18147|18123',
    county: 'Spencer',
    county_names_all: 'Spencer|Perry',
    county_weights: '{"18147": 56.78, "18123": 43.22}',
    density: 22.9,
    imprecise: false,
    latitude: 38.06959,
    longitude: -86.77826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47588',
  },
  {
    city: 'Velpen',
    county_fips: 18125,
    county_fips_all: '18125|18037',
    county: 'Pike',
    county_names_all: 'Pike|Dubois',
    county_weights: '{"18125": 85.47, "18037": 14.53}',
    density: 5.2,
    imprecise: false,
    latitude: 38.35314,
    longitude: -87.10113,
    militaryZip: false,
    timezone: 'America/Indiana/Petersburg',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47590',
  },
  {
    city: 'Vincennes',
    county_fips: 18083,
    county_fips_all: '18083',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"18083": 100}',
    density: 58.4,
    imprecise: false,
    latitude: 38.62136,
    longitude: -87.50594,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 25168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47591',
  },
  {
    city: 'Westphalia',
    county_fips: 18083,
    county_fips_all: '18083',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"18083": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 38.86318,
    longitude: -87.23382,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47596',
  },
  {
    city: 'Wheatland',
    county_fips: 18083,
    county_fips_all: '18083',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"18083": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 38.64745,
    longitude: -87.29802,
    militaryZip: false,
    timezone: 'America/Indiana/Vincennes',
    population: 745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47597',
  },
  {
    city: 'Winslow',
    county_fips: 18125,
    county_fips_all: '18125',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"18125": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 38.3875,
    longitude: -87.20711,
    militaryZip: false,
    timezone: 'America/Indiana/Petersburg',
    population: 3031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47598',
  },
  {
    city: 'Boonville',
    county_fips: 18173,
    county_fips_all: '18173|18147',
    county: 'Warrick',
    county_names_all: 'Warrick|Spencer',
    county_weights: '{"18173": 94.23, "18147": 5.77}',
    density: 40.2,
    imprecise: false,
    latitude: 38.05301,
    longitude: -87.25526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47601',
  },
  {
    city: 'Chandler',
    county_fips: 18173,
    county_fips_all: '18173',
    county: 'Warrick',
    county_names_all: 'Warrick',
    county_weights: '{"18173": 100}',
    density: 60,
    imprecise: false,
    latitude: 38.06041,
    longitude: -87.39988,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47610',
  },
  {
    city: 'Chrisney',
    county_fips: 18147,
    county_fips_all: '18147',
    county: 'Spencer',
    county_names_all: 'Spencer',
    county_weights: '{"18147": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 38.02474,
    longitude: -87.05812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47611',
  },
  {
    city: 'Cynthiana',
    county_fips: 18051,
    county_fips_all: '18051|18129',
    county: 'Gibson',
    county_names_all: 'Gibson|Posey',
    county_weights: '{"18051": 60.87, "18129": 39.13}',
    density: 19.5,
    imprecise: false,
    latitude: 38.1946,
    longitude: -87.70155,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47612',
  },
  {
    city: 'Elberfeld',
    county_fips: 18173,
    county_fips_all: '18173|18051',
    county: 'Warrick',
    county_names_all: 'Warrick|Gibson',
    county_weights: '{"18173": 82.26, "18051": 17.74}',
    density: 19.3,
    imprecise: false,
    latitude: 38.15413,
    longitude: -87.42062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47613',
  },
  {
    city: 'Grandview',
    county_fips: 18147,
    county_fips_all: '18147',
    county: 'Spencer',
    county_names_all: 'Spencer',
    county_weights: '{"18147": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 37.97214,
    longitude: -86.95643,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47615',
  },
  {
    city: 'Griffin',
    county_fips: 18051,
    county_fips_all: '18051|18129',
    county: 'Gibson',
    county_names_all: 'Gibson|Posey',
    county_weights: '{"18051": 54.54, "18129": 45.46}',
    density: 2,
    imprecise: false,
    latitude: 38.23482,
    longitude: -87.91038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47616',
  },
  {
    city: 'Lynnville',
    county_fips: 18173,
    county_fips_all: '18173|18051|18125',
    county: 'Warrick',
    county_names_all: 'Warrick|Gibson|Pike',
    county_weights: '{"18173": 83.07, "18051": 12.38, "18125": 4.55}',
    density: 16,
    imprecise: false,
    latitude: 38.1924,
    longitude: -87.30742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47619',
  },
  {
    city: 'Mount Vernon',
    county_fips: 18129,
    county_fips_all: '18129',
    county: 'Posey',
    county_names_all: 'Posey',
    county_weights: '{"18129": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 37.93284,
    longitude: -87.90555,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47620',
  },
  {
    city: 'Newburgh',
    county_fips: 18173,
    county_fips_all: '18173',
    county: 'Warrick',
    county_names_all: 'Warrick',
    county_weights: '{"18173": 100}',
    density: 327.2,
    imprecise: false,
    latitude: 37.95615,
    longitude: -87.35569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47630',
  },
  {
    city: 'New Harmony',
    county_fips: 18129,
    county_fips_all: '18129',
    county: 'Posey',
    county_names_all: 'Posey',
    county_weights: '{"18129": 100}',
    density: 14,
    imprecise: false,
    latitude: 38.10082,
    longitude: -87.90967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47631',
  },
  {
    city: 'Poseyville',
    county_fips: 18129,
    county_fips_all: '18129|18051|18163',
    county: 'Posey',
    county_names_all: 'Posey|Gibson|Vanderburgh',
    county_weights: '{"18129": 88.95, "18051": 10.41, "18163": 0.64}',
    density: 16.4,
    imprecise: false,
    latitude: 38.16835,
    longitude: -87.78736,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47633',
  },
  {
    city: 'Richland',
    county_fips: 18147,
    county_fips_all: '18147',
    county: 'Spencer',
    county_names_all: 'Spencer',
    county_weights: '{"18147": 100}',
    density: 18.5,
    imprecise: false,
    latitude: 37.93893,
    longitude: -87.1848,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47634',
  },
  {
    city: 'Rockport',
    county_fips: 18147,
    county_fips_all: '18147',
    county: 'Spencer',
    county_names_all: 'Spencer',
    county_weights: '{"18147": 100}',
    density: 23.9,
    imprecise: false,
    latitude: 37.8862,
    longitude: -87.10751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47635',
  },
  {
    city: 'Tennyson',
    county_fips: 18173,
    county_fips_all: '18173|18147',
    county: 'Warrick',
    county_names_all: 'Warrick|Spencer',
    county_weights: '{"18173": 92.29, "18147": 7.71}',
    density: 7.5,
    imprecise: false,
    latitude: 38.13679,
    longitude: -87.15865,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47637',
  },
  {
    city: 'Wadesville',
    county_fips: 18129,
    county_fips_all: '18129',
    county: 'Posey',
    county_names_all: 'Posey',
    county_weights: '{"18129": 100}',
    density: 29.4,
    imprecise: false,
    latitude: 38.06959,
    longitude: -87.77489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47638',
  },
  {
    city: 'Haubstadt',
    county_fips: 18051,
    county_fips_all: '18051|18163|18173',
    county: 'Gibson',
    county_names_all: 'Gibson|Vanderburgh|Warrick',
    county_weights: '{"18051": 72.91, "18163": 26.15, "18173": 0.94}',
    density: 39.5,
    imprecise: false,
    latitude: 38.18228,
    longitude: -87.57132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47639',
  },
  {
    city: 'Hazleton',
    county_fips: 18051,
    county_fips_all: '18051|18125',
    county: 'Gibson',
    county_names_all: 'Gibson|Pike',
    county_weights: '{"18051": 69.02, "18125": 30.98}',
    density: 9.4,
    imprecise: false,
    latitude: 38.47708,
    longitude: -87.49301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47640',
  },
  {
    city: 'Fort Branch',
    county_fips: 18051,
    county_fips_all: '18051',
    county: 'Gibson',
    county_names_all: 'Gibson',
    county_weights: '{"18051": 100}',
    density: 34.9,
    imprecise: false,
    latitude: 38.24611,
    longitude: -87.54851,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47648',
  },
  {
    city: 'Francisco',
    county_fips: 18051,
    county_fips_all: '18051',
    county: 'Gibson',
    county_names_all: 'Gibson',
    county_weights: '{"18051": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 38.35154,
    longitude: -87.44786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47649',
  },
  {
    city: 'Mackey',
    county_fips: 18051,
    county_fips_all: '18051',
    county: 'Gibson',
    county_names_all: 'Gibson',
    county_weights: '{"18051": 100}',
    density: 311.4,
    imprecise: false,
    latitude: 38.2534,
    longitude: -87.391,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47654',
  },
  {
    city: 'Oakland City',
    county_fips: 18051,
    county_fips_all: '18051|18125|18173',
    county: 'Gibson',
    county_names_all: 'Gibson|Pike|Warrick',
    county_weights: '{"18051": 63.62, "18125": 35.24, "18173": 1.14}',
    density: 22,
    imprecise: false,
    latitude: 38.29712,
    longitude: -87.33191,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47660',
  },
  {
    city: 'Owensville',
    county_fips: 18051,
    county_fips_all: '18051',
    county: 'Gibson',
    county_names_all: 'Gibson',
    county_weights: '{"18051": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 38.28016,
    longitude: -87.72738,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47665',
  },
  {
    city: 'Patoka',
    county_fips: 18051,
    county_fips_all: '18051',
    county: 'Gibson',
    county_names_all: 'Gibson',
    county_weights: '{"18051": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 38.41922,
    longitude: -87.60042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47666',
  },
  {
    city: 'Princeton',
    county_fips: 18051,
    county_fips_all: '18051',
    county: 'Gibson',
    county_names_all: 'Gibson',
    county_weights: '{"18051": 100}',
    density: 55.3,
    imprecise: false,
    latitude: 38.34355,
    longitude: -87.57797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47670',
  },
  {
    city: 'Evansville',
    county_fips: 18163,
    county_fips_all: '18163',
    county: 'Vanderburgh',
    county_names_all: 'Vanderburgh',
    county_weights: '{"18163": 100}',
    density: 422,
    imprecise: false,
    latitude: 37.97387,
    longitude: -87.57357,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47708',
  },
  {
    city: 'Evansville',
    county_fips: 18163,
    county_fips_all: '18163',
    county: 'Vanderburgh',
    county_names_all: 'Vanderburgh',
    county_weights: '{"18163": 100}',
    density: 824.9,
    imprecise: false,
    latitude: 38.02518,
    longitude: -87.57618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47710',
  },
  {
    city: 'Evansville',
    county_fips: 18163,
    county_fips_all: '18163',
    county: 'Vanderburgh',
    county_names_all: 'Vanderburgh',
    county_weights: '{"18163": 100}',
    density: 724.1,
    imprecise: false,
    latitude: 38.0157,
    longitude: -87.53606,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47711',
  },
  {
    city: 'Evansville',
    county_fips: 18163,
    county_fips_all: '18163|18129',
    county: 'Vanderburgh',
    county_names_all: 'Vanderburgh|Posey',
    county_weights: '{"18163": 81.22, "18129": 18.78}',
    density: 156.7,
    imprecise: false,
    latitude: 37.92869,
    longitude: -87.65951,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47712',
  },
  {
    city: 'Evansville',
    county_fips: 18163,
    county_fips_all: '18163',
    county: 'Vanderburgh',
    county_names_all: 'Vanderburgh',
    county_weights: '{"18163": 100}',
    density: 777.7,
    imprecise: false,
    latitude: 37.9475,
    longitude: -87.55432,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47713',
  },
  {
    city: 'Evansville',
    county_fips: 18163,
    county_fips_all: '18163',
    county: 'Vanderburgh',
    county_names_all: 'Vanderburgh',
    county_weights: '{"18163": 100}',
    density: 1544.7,
    imprecise: false,
    latitude: 37.95768,
    longitude: -87.52102,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47714',
  },
  {
    city: 'Evansville',
    county_fips: 18163,
    county_fips_all: '18163',
    county: 'Vanderburgh',
    county_names_all: 'Vanderburgh',
    county_weights: '{"18163": 100}',
    density: 514.1,
    imprecise: false,
    latitude: 37.97229,
    longitude: -87.48097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47715',
  },
  {
    city: 'Evansville',
    county_fips: 18163,
    county_fips_all: '18163',
    county: 'Vanderburgh',
    county_names_all: 'Vanderburgh',
    county_weights: '{"18163": 100}',
    density: 118.9,
    imprecise: false,
    latitude: 38.06065,
    longitude: -87.64247,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47720',
  },
  {
    city: 'Evansville',
    county_fips: 18163,
    county_fips_all: '18163|18173|18051',
    county: 'Vanderburgh',
    county_names_all: 'Vanderburgh|Warrick|Gibson',
    county_weights: '{"18163": 97.77, "18173": 1.55, "18051": 0.68}',
    density: 137.6,
    imprecise: false,
    latitude: 38.10721,
    longitude: -87.52855,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47725',
  },
  {
    city: 'Terre Haute',
    county_fips: 18167,
    county_fips_all: '18167|18021',
    county: 'Vigo',
    county_names_all: 'Vigo|Clay',
    county_weights: '{"18167": 99.74, "18021": 0.26}',
    density: 80.6,
    imprecise: false,
    latitude: 39.35153,
    longitude: -87.4106,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 33135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47802',
  },
  {
    city: 'Terre Haute',
    county_fips: 18167,
    county_fips_all: '18167',
    county: 'Vigo',
    county_names_all: 'Vigo',
    county_weights: '{"18167": 100}',
    density: 251.3,
    imprecise: false,
    latitude: 39.46433,
    longitude: -87.30855,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 21746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47803',
  },
  {
    city: 'Terre Haute',
    county_fips: 18167,
    county_fips_all: '18167',
    county: 'Vigo',
    county_names_all: 'Vigo',
    county_weights: '{"18167": 100}',
    density: 615.8,
    imprecise: false,
    latitude: 39.49756,
    longitude: -87.39031,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 10553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47804',
  },
  {
    city: 'Terre Haute',
    county_fips: 18167,
    county_fips_all: '18167',
    county: 'Vigo',
    county_names_all: 'Vigo',
    county_weights: '{"18167": 100}',
    density: 93.4,
    imprecise: false,
    latitude: 39.54768,
    longitude: -87.32739,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 12619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47805',
  },
  {
    city: 'Terre Haute',
    county_fips: 18167,
    county_fips_all: '18167',
    county: 'Vigo',
    county_names_all: 'Vigo',
    county_weights: '{"18167": 100}',
    density: 1339.8,
    imprecise: false,
    latitude: 39.47061,
    longitude: -87.40262,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 13140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47807',
  },
  {
    city: 'Blanford',
    county_fips: 18165,
    county_fips_all: '18165',
    county: 'Vermillion',
    county_names_all: 'Vermillion',
    county_weights: '{"18165": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.66549,
    longitude: -87.52177,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47831',
  },
  {
    city: 'Bloomingdale',
    county_fips: 18121,
    county_fips_all: '18121',
    county: 'Parke',
    county_names_all: 'Parke',
    county_weights: '{"18121": 100}',
    density: 9,
    imprecise: false,
    latitude: 39.87879,
    longitude: -87.25463,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47832',
  },
  {
    city: 'Bowling Green',
    county_fips: 18021,
    county_fips_all: '18021|18119',
    county: 'Clay',
    county_names_all: 'Clay|Owen',
    county_weights: '{"18021": 57.34, "18119": 42.66}',
    density: 8.1,
    imprecise: false,
    latitude: 39.35841,
    longitude: -86.97773,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47833',
  },
  {
    city: 'Brazil',
    county_fips: 18021,
    county_fips_all: '18021|18121|18167',
    county: 'Clay',
    county_names_all: 'Clay|Parke|Vigo',
    county_weights: '{"18021": 78.8, "18121": 12.13, "18167": 9.07}',
    density: 46.6,
    imprecise: false,
    latitude: 39.52423,
    longitude: -87.12276,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 18625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47834',
  },
  {
    city: 'Bridgeton',
    county_fips: 18121,
    county_fips_all: '18121',
    county: 'Parke',
    county_names_all: 'Parke',
    county_weights: '{"18121": 100}',
    density: 62,
    imprecise: false,
    latitude: 39.64924,
    longitude: -87.17221,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47836',
  },
  {
    city: 'Carbon',
    county_fips: 18121,
    county_fips_all: '18121|18021',
    county: 'Parke',
    county_names_all: 'Parke|Clay',
    county_weights: '{"18121": 73.6, "18021": 26.4}',
    density: 12.2,
    imprecise: false,
    latitude: 39.62929,
    longitude: -87.11281,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47837',
  },
  {
    city: 'Carlisle',
    county_fips: 18153,
    county_fips_all: '18153',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"18153": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 38.95679,
    longitude: -87.37812,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47838',
  },
  {
    city: 'Centerpoint',
    county_fips: 18021,
    county_fips_all: '18021|18133',
    county: 'Clay',
    county_names_all: 'Clay|Putnam',
    county_weights: '{"18021": 95.35, "18133": 4.65}',
    density: 15.2,
    imprecise: false,
    latitude: 39.40863,
    longitude: -87.05937,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47840',
  },
  {
    city: 'Clay City',
    county_fips: 18021,
    county_fips_all: '18021|18119',
    county: 'Clay',
    county_names_all: 'Clay|Owen',
    county_weights: '{"18021": 97.1, "18119": 2.9}',
    density: 15,
    imprecise: false,
    latitude: 39.27764,
    longitude: -87.11492,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47841',
  },
  {
    city: 'Clinton',
    county_fips: 18165,
    county_fips_all: '18165|18167',
    county: 'Vermillion',
    county_names_all: 'Vermillion|Vigo',
    county_weights: '{"18165": 98.14, "18167": 1.86}',
    density: 51.3,
    imprecise: false,
    latitude: 39.67569,
    longitude: -87.462,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 9652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47842',
  },
  {
    city: 'Coalmont',
    county_fips: 18021,
    county_fips_all: '18021',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"18021": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 39.1936,
    longitude: -87.23386,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47845',
  },
  {
    city: 'Cory',
    county_fips: 18021,
    county_fips_all: '18021',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"18021": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 39.36601,
    longitude: -87.20041,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47846',
  },
  {
    city: 'Dana',
    county_fips: 18165,
    county_fips_all: '18165',
    county: 'Vermillion',
    county_names_all: 'Vermillion',
    county_weights: '{"18165": 100}',
    density: 7,
    imprecise: false,
    latitude: 39.82293,
    longitude: -87.48865,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47847',
  },
  {
    city: 'Dugger',
    county_fips: 18153,
    county_fips_all: '18153|18055',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Greene',
    county_weights: '{"18153": 87.38, "18055": 12.62}',
    density: 31.6,
    imprecise: false,
    latitude: 39.04159,
    longitude: -87.26108,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47848',
  },
  {
    city: 'Fairbanks',
    county_fips: 18153,
    county_fips_all: '18153',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"18153": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 39.19196,
    longitude: -87.56131,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47849',
  },
  {
    city: 'Farmersburg',
    county_fips: 18153,
    county_fips_all: '18153|18167',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Vigo',
    county_weights: '{"18153": 75.48, "18167": 24.52}',
    density: 15.6,
    imprecise: false,
    latitude: 39.24441,
    longitude: -87.43763,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47850',
  },
  {
    city: 'Fontanet',
    county_fips: 18167,
    county_fips_all: '18167',
    county: 'Vigo',
    county_names_all: 'Vigo',
    county_weights: '{"18167": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.5736,
    longitude: -87.24594,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47851',
  },
  {
    city: 'Harmony',
    county_fips: 18021,
    county_fips_all: '18021',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"18021": 100}',
    density: 707.9,
    imprecise: false,
    latitude: 39.53757,
    longitude: -87.07277,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47853',
  },
  {
    city: 'Hillsdale',
    county_fips: 18165,
    county_fips_all: '18165',
    county: 'Vermillion',
    county_names_all: 'Vermillion',
    county_weights: '{"18165": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 39.80874,
    longitude: -87.41299,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47854',
  },
  {
    city: 'Hymera',
    county_fips: 18153,
    county_fips_all: '18153',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"18153": 100}',
    density: 329.1,
    imprecise: false,
    latitude: 39.18844,
    longitude: -87.30216,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47855',
  },
  {
    city: 'Knightsville',
    county_fips: 18021,
    county_fips_all: '18021',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"18021": 100}',
    density: 263.2,
    imprecise: false,
    latitude: 39.52403,
    longitude: -87.09111,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47857',
  },
  {
    city: 'Lewis',
    county_fips: 18021,
    county_fips_all: '18021|18167|18153',
    county: 'Clay',
    county_names_all: 'Clay|Vigo|Sullivan',
    county_weights: '{"18021": 61.39, "18167": 24.87, "18153": 13.74}',
    density: 11.8,
    imprecise: false,
    latitude: 39.26268,
    longitude: -87.22868,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47858',
  },
  {
    city: 'Marshall',
    county_fips: 18121,
    county_fips_all: '18121',
    county: 'Parke',
    county_names_all: 'Parke',
    county_weights: '{"18121": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 39.88595,
    longitude: -87.16999,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47859',
  },
  {
    city: 'Mecca',
    county_fips: 18121,
    county_fips_all: '18121',
    county: 'Parke',
    county_names_all: 'Parke',
    county_weights: '{"18121": 100}',
    density: 306.3,
    imprecise: false,
    latitude: 39.72215,
    longitude: -87.33013,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47860',
  },
  {
    city: 'Merom',
    county_fips: 18153,
    county_fips_all: '18153',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"18153": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 39.06528,
    longitude: -87.56658,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47861',
  },
  {
    city: 'Montezuma',
    county_fips: 18121,
    county_fips_all: '18121',
    county: 'Parke',
    county_names_all: 'Parke',
    county_weights: '{"18121": 100}',
    density: 14,
    imprecise: false,
    latitude: 39.77184,
    longitude: -87.34527,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47862',
  },
  {
    city: 'New Goshen',
    county_fips: 18167,
    county_fips_all: '18167',
    county: 'Vigo',
    county_names_all: 'Vigo',
    county_weights: '{"18167": 100}',
    density: 995.6,
    imprecise: false,
    latitude: 39.57848,
    longitude: -87.45921,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47863',
  },
  {
    city: 'Pimento',
    county_fips: 18167,
    county_fips_all: '18167|18153',
    county: 'Vigo',
    county_names_all: 'Vigo|Sullivan',
    county_weights: '{"18167": 85.01, "18153": 14.99}',
    density: 14.2,
    imprecise: false,
    latitude: 39.28302,
    longitude: -87.3247,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47866',
  },
  {
    city: 'Poland',
    county_fips: 18119,
    county_fips_all: '18119|18021|18133',
    county: 'Owen',
    county_names_all: 'Owen|Clay|Putnam',
    county_weights: '{"18119": 81.25, "18021": 13.9, "18133": 4.85}',
    density: 17.7,
    imprecise: false,
    latitude: 39.40892,
    longitude: -86.89822,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47868',
  },
  {
    city: 'Prairie Creek',
    county_fips: 18167,
    county_fips_all: '18167',
    county: 'Vigo',
    county_names_all: 'Vigo',
    county_weights: '{"18167": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.2751,
    longitude: -87.49658,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47869',
  },
  {
    city: 'Prairieton',
    county_fips: 18167,
    county_fips_all: '18167',
    county: 'Vigo',
    county_names_all: 'Vigo',
    county_weights: '{"18167": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.37016,
    longitude: -87.47353,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47870',
  },
  {
    city: 'Riley',
    county_fips: 18167,
    county_fips_all: '18167',
    county: 'Vigo',
    county_names_all: 'Vigo',
    county_weights: '{"18167": 100}',
    density: 1968.8,
    imprecise: false,
    latitude: 39.38978,
    longitude: -87.30026,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47871',
  },
  {
    city: 'Rockville',
    county_fips: 18121,
    county_fips_all: '18121|18133',
    county: 'Parke',
    county_names_all: 'Parke|Putnam',
    county_weights: '{"18121": 99.68, "18133": 0.32}',
    density: 19.5,
    imprecise: false,
    latitude: 39.75331,
    longitude: -87.16271,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 8557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47872',
  },
  {
    city: 'Rosedale',
    county_fips: 18121,
    county_fips_all: '18121|18167|18021',
    county: 'Parke',
    county_names_all: 'Parke|Vigo|Clay',
    county_weights: '{"18121": 76.44, "18167": 19.48, "18021": 4.08}',
    density: 18.5,
    imprecise: false,
    latitude: 39.62913,
    longitude: -87.27792,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47874',
  },
  {
    city: 'Saint Bernice',
    county_fips: 18165,
    county_fips_all: '18165',
    county: 'Vermillion',
    county_names_all: 'Vermillion',
    county_weights: '{"18165": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.71447,
    longitude: -87.52222,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47875',
  },
  {
    city: 'Saint Mary Of The Woods',
    county_fips: 18167,
    county_fips_all: '18167',
    county: 'Vigo',
    county_names_all: 'Vigo',
    county_weights: '{"18167": 100}',
    density: 595.6,
    imprecise: false,
    latitude: 39.50996,
    longitude: -87.46113,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47876',
  },
  {
    city: 'Shelburn',
    county_fips: 18153,
    county_fips_all: '18153|18021',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Clay',
    county_weights: '{"18153": 99.02, "18021": 0.98}',
    density: 16.5,
    imprecise: false,
    latitude: 39.18863,
    longitude: -87.37619,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47879',
  },
  {
    city: 'Shepardsville',
    county_fips: 18167,
    county_fips_all: '18167',
    county: 'Vigo',
    county_names_all: 'Vigo',
    county_weights: '{"18167": 100}',
    density: 163.7,
    imprecise: false,
    latitude: 39.59976,
    longitude: -87.41885,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47880',
  },
  {
    city: 'Staunton',
    county_fips: 18021,
    county_fips_all: '18021',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"18021": 100}',
    density: 693.5,
    imprecise: false,
    latitude: 39.48722,
    longitude: -87.19029,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47881',
  },
  {
    city: 'Sullivan',
    county_fips: 18153,
    county_fips_all: '18153',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"18153": 100}',
    density: 23.8,
    imprecise: false,
    latitude: 39.09034,
    longitude: -87.41186,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 8735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47882',
  },
  {
    city: 'Universal',
    county_fips: 18165,
    county_fips_all: '18165',
    county: 'Vermillion',
    county_names_all: 'Vermillion',
    county_weights: '{"18165": 100}',
    density: 176.1,
    imprecise: false,
    latitude: 39.62308,
    longitude: -87.45362,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47884',
  },
  {
    city: 'West Terre Haute',
    county_fips: 18167,
    county_fips_all: '18167',
    county: 'Vigo',
    county_names_all: 'Vigo',
    county_weights: '{"18167": 100}',
    density: 43,
    imprecise: false,
    latitude: 39.50872,
    longitude: -87.47679,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 9209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47885',
  },
  {
    city: 'Lafayette',
    county_fips: 18157,
    county_fips_all: '18157',
    county: 'Tippecanoe',
    county_names_all: 'Tippecanoe',
    county_weights: '{"18157": 100}',
    density: 2950.2,
    imprecise: false,
    latitude: 40.4178,
    longitude: -86.88995,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 4585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47901',
  },
  {
    city: 'Lafayette',
    county_fips: 18157,
    county_fips_all: '18157',
    county: 'Tippecanoe',
    county_names_all: 'Tippecanoe',
    county_weights: '{"18157": 100}',
    density: 1088.5,
    imprecise: false,
    latitude: 40.43835,
    longitude: -86.87609,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 16257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47904',
  },
  {
    city: 'Lafayette',
    county_fips: 18157,
    county_fips_all: '18157|18015|18023',
    county: 'Tippecanoe',
    county_names_all: 'Tippecanoe|Carroll|Clinton',
    county_weights: '{"18157": 98.08, "18015": 1.44, "18023": 0.48}',
    density: 135.4,
    imprecise: false,
    latitude: 40.4218,
    longitude: -86.76418,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 42219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47905',
  },
  {
    city: 'West Lafayette',
    county_fips: 18157,
    county_fips_all: '18157|18181|18171',
    county: 'Tippecanoe',
    county_names_all: 'Tippecanoe|White|Warren',
    county_weights: '{"18157": 92.77, "18181": 3.94, "18171": 3.29}',
    density: 217.4,
    imprecise: false,
    latitude: 40.48541,
    longitude: -86.98584,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 75198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47906',
  },
  {
    city: 'Lafayette',
    county_fips: 18157,
    county_fips_all: '18157',
    county: 'Tippecanoe',
    county_names_all: 'Tippecanoe',
    county_weights: '{"18157": 100}',
    density: 142.5,
    imprecise: false,
    latitude: 40.32357,
    longitude: -86.89933,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 43561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47909',
  },
  {
    city: 'Alamo',
    county_fips: 18107,
    county_fips_all: '18107',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"18107": 100}',
    density: 279,
    imprecise: false,
    latitude: 39.98343,
    longitude: -87.05524,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47916',
  },
  {
    city: 'Ambia',
    county_fips: 18171,
    county_fips_all: '18171|18007',
    county: 'Warren',
    county_names_all: 'Warren|Benton',
    county_weights: '{"18171": 59.1, "18007": 40.9}',
    density: 2.5,
    imprecise: false,
    latitude: 40.46881,
    longitude: -87.47633,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47917',
  },
  {
    city: 'Attica',
    county_fips: 18045,
    county_fips_all: '18045|18171|18157',
    county: 'Fountain',
    county_names_all: 'Fountain|Warren|Tippecanoe',
    county_weights: '{"18045": 59.57, "18171": 38.01, "18157": 2.42}',
    density: 15.6,
    imprecise: false,
    latitude: 40.30388,
    longitude: -87.20628,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47918',
  },
  {
    city: 'Battle Ground',
    county_fips: 18157,
    county_fips_all: '18157|18181|18015',
    county: 'Tippecanoe',
    county_names_all: 'Tippecanoe|White|Carroll',
    county_weights: '{"18157": 76.53, "18181": 19.62, "18015": 3.85}',
    density: 32.1,
    imprecise: false,
    latitude: 40.54712,
    longitude: -86.8195,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47920',
  },
  {
    city: 'Boswell',
    county_fips: 18007,
    county_fips_all: '18007|18171',
    county: 'Benton',
    county_names_all: 'Benton|Warren',
    county_weights: '{"18007": 52.53, "18171": 47.47}',
    density: 12.4,
    imprecise: false,
    latitude: 40.47838,
    longitude: -87.37485,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47921',
  },
  {
    city: 'Brook',
    county_fips: 18111,
    county_fips_all: '18111|18073',
    county: 'Newton',
    county_names_all: 'Newton|Jasper',
    county_weights: '{"18111": 91.45, "18073": 8.55}',
    density: 7.5,
    imprecise: false,
    latitude: 40.8762,
    longitude: -87.35369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47922',
  },
  {
    city: 'Brookston',
    county_fips: 18181,
    county_fips_all: '18181|18015',
    county: 'White',
    county_names_all: 'White|Carroll',
    county_weights: '{"18181": 97.11, "18015": 2.89}',
    density: 15.7,
    imprecise: false,
    latitude: 40.61015,
    longitude: -86.92667,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47923',
  },
  {
    city: 'Buck Creek',
    county_fips: 18157,
    county_fips_all: '18157',
    county: 'Tippecanoe',
    county_names_all: 'Tippecanoe',
    county_weights: '{"18157": 100}',
    density: 126.2,
    imprecise: false,
    latitude: 40.48991,
    longitude: -86.75759,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47924',
  },
  {
    city: 'Buffalo',
    county_fips: 18181,
    county_fips_all: '18181',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"18181": 100}',
    density: 1132.5,
    imprecise: false,
    latitude: 40.88205,
    longitude: -86.74477,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47925',
  },
  {
    city: 'Burnettsville',
    county_fips: 18181,
    county_fips_all: '18181|18015',
    county: 'White',
    county_names_all: 'White|Carroll',
    county_weights: '{"18181": 63.33, "18015": 36.67}',
    density: 8.9,
    imprecise: false,
    latitude: 40.77789,
    longitude: -86.59707,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47926',
  },
  {
    city: 'Cayuga',
    county_fips: 18165,
    county_fips_all: '18165',
    county: 'Vermillion',
    county_names_all: 'Vermillion',
    county_weights: '{"18165": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 39.93237,
    longitude: -87.46501,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47928',
  },
  {
    city: 'Chalmers',
    county_fips: 18181,
    county_fips_all: '18181',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"18181": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 40.67587,
    longitude: -86.9185,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47929',
  },
  {
    city: 'Clarks Hill',
    county_fips: 18157,
    county_fips_all: '18157|18107|18023',
    county: 'Tippecanoe',
    county_names_all: 'Tippecanoe|Montgomery|Clinton',
    county_weights: '{"18157": 81.21, "18107": 17.6, "18023": 1.19}',
    density: 15.7,
    imprecise: false,
    latitude: 40.23764,
    longitude: -86.74137,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47930',
  },
  {
    city: 'Covington',
    county_fips: 18045,
    county_fips_all: '18045|18171|18165',
    county: 'Fountain',
    county_names_all: 'Fountain|Warren|Vermillion',
    county_weights: '{"18045": 63.78, "18171": 19.26, "18165": 16.96}',
    density: 18.3,
    imprecise: false,
    latitude: 40.12764,
    longitude: -87.40761,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 5035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47932',
  },
  {
    city: 'Crawfordsville',
    county_fips: 18107,
    county_fips_all: '18107|18045|18011',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Fountain|Boone',
    county_weights: '{"18107": 98.2, "18045": 1.37, "18011": 0.43}',
    density: 46.5,
    imprecise: false,
    latitude: 40.03728,
    longitude: -86.90234,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 28357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47933',
  },
  {
    city: 'Darlington',
    county_fips: 18107,
    county_fips_all: '18107',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"18107": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 40.11749,
    longitude: -86.7447,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47940',
  },
  {
    city: 'Dayton',
    county_fips: 18157,
    county_fips_all: '18157',
    county: 'Tippecanoe',
    county_names_all: 'Tippecanoe',
    county_weights: '{"18157": 100}',
    density: 537.7,
    imprecise: false,
    latitude: 40.37539,
    longitude: -86.77128,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47941',
  },
  {
    city: 'Earl Park',
    county_fips: 18007,
    county_fips_all: '18007|18111',
    county: 'Benton',
    county_names_all: 'Benton|Newton',
    county_weights: '{"18007": 95.73, "18111": 4.27}',
    density: 5,
    imprecise: false,
    latitude: 40.68791,
    longitude: -87.4472,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47942',
  },
  {
    city: 'Fair Oaks',
    county_fips: 18111,
    county_fips_all: '18111|18073',
    county: 'Newton',
    county_names_all: 'Newton|Jasper',
    county_weights: '{"18111": 54.88, "18073": 45.12}',
    density: 5.8,
    imprecise: false,
    latitude: 41.0594,
    longitude: -87.28006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47943',
  },
  {
    city: 'Fowler',
    county_fips: 18007,
    county_fips_all: '18007|18171|18181',
    county: 'Benton',
    county_names_all: 'Benton|Warren|White',
    county_weights: '{"18007": 97.59, "18171": 1.88, "18181": 0.53}',
    density: 6.9,
    imprecise: false,
    latitude: 40.61067,
    longitude: -87.32804,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47944',
  },
  {
    city: 'Francesville',
    county_fips: 18131,
    county_fips_all: '18131|18073',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Jasper',
    county_weights: '{"18131": 80.66, "18073": 19.34}',
    density: 7.6,
    imprecise: false,
    latitude: 40.98427,
    longitude: -86.87014,
    militaryZip: false,
    timezone: 'America/Indiana/Winamac',
    population: 1801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47946',
  },
  {
    city: 'Goodland',
    county_fips: 18111,
    county_fips_all: '18111|18073|18007',
    county: 'Newton',
    county_names_all: 'Newton|Jasper|Benton',
    county_weights: '{"18111": 54.38, "18073": 28.12, "18007": 17.5}',
    density: 6.6,
    imprecise: false,
    latitude: 40.77638,
    longitude: -87.28676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47948',
  },
  {
    city: 'Hillsboro',
    county_fips: 18045,
    county_fips_all: '18045|18107',
    county: 'Fountain',
    county_names_all: 'Fountain|Montgomery',
    county_weights: '{"18045": 96.71, "18107": 3.29}',
    density: 14.6,
    imprecise: false,
    latitude: 40.06288,
    longitude: -87.13504,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47949',
  },
  {
    city: 'Idaville',
    county_fips: 18181,
    county_fips_all: '18181|18015',
    county: 'White',
    county_names_all: 'White|Carroll',
    county_weights: '{"18181": 90.24, "18015": 9.76}',
    density: 7,
    imprecise: false,
    latitude: 40.80175,
    longitude: -86.65355,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47950',
  },
  {
    city: 'Kentland',
    county_fips: 18111,
    county_fips_all: '18111',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"18111": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 40.79049,
    longitude: -87.4435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47951',
  },
  {
    city: 'Kingman',
    county_fips: 18045,
    county_fips_all: '18045|18121',
    county: 'Fountain',
    county_names_all: 'Fountain|Parke',
    county_weights: '{"18045": 65.54, "18121": 34.46}',
    density: 8.8,
    imprecise: false,
    latitude: 39.96186,
    longitude: -87.30049,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47952',
  },
  {
    city: 'Ladoga',
    county_fips: 18107,
    county_fips_all: '18107|18133',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Putnam',
    county_weights: '{"18107": 94.39, "18133": 5.61}',
    density: 13.1,
    imprecise: false,
    latitude: 39.90048,
    longitude: -86.8178,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47954',
  },
  {
    city: 'Linden',
    county_fips: 18107,
    county_fips_all: '18107|18157',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Tippecanoe',
    county_weights: '{"18107": 88.44, "18157": 11.56}',
    density: 12.6,
    imprecise: false,
    latitude: 40.1954,
    longitude: -86.86513,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47955',
  },
  {
    city: 'Medaryville',
    county_fips: 18131,
    county_fips_all: '18131|18073',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Jasper',
    county_weights: '{"18131": 86.37, "18073": 13.63}',
    density: 13.3,
    imprecise: false,
    latitude: 41.08937,
    longitude: -86.8772,
    militaryZip: false,
    timezone: 'America/Indiana/Winamac',
    population: 2071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47957',
  },
  {
    city: 'Mellott',
    county_fips: 18045,
    county_fips_all: '18045',
    county: 'Fountain',
    county_names_all: 'Fountain',
    county_weights: '{"18045": 100}',
    density: 241.9,
    imprecise: false,
    latitude: 40.16452,
    longitude: -87.14862,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47958',
  },
  {
    city: 'Monon',
    county_fips: 18181,
    county_fips_all: '18181|18073|18131',
    county: 'White',
    county_names_all: 'White|Jasper|Pulaski',
    county_weights: '{"18181": 85.23, "18073": 11.71, "18131": 3.06}',
    density: 15.2,
    imprecise: false,
    latitude: 40.86603,
    longitude: -86.89786,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 2679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47959',
  },
  {
    city: 'Monticello',
    county_fips: 18181,
    county_fips_all: '18181|18015|18131',
    county: 'White',
    county_names_all: 'White|Carroll|Pulaski',
    county_weights: '{"18181": 84.17, "18015": 15.57, "18131": 0.26}',
    density: 48.4,
    imprecise: false,
    latitude: 40.78261,
    longitude: -86.74938,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 14825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47960',
  },
  {
    city: 'Morocco',
    county_fips: 18111,
    county_fips_all: '18111',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"18111": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 40.96811,
    longitude: -87.44371,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47963',
  },
  {
    city: 'Mount Ayr',
    county_fips: 18111,
    county_fips_all: '18111',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"18111": 100}',
    density: 232,
    imprecise: false,
    latitude: 40.9523,
    longitude: -87.2996,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 90,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47964',
  },
  {
    city: 'New Market',
    county_fips: 18107,
    county_fips_all: '18107',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"18107": 100}',
    density: 479,
    imprecise: false,
    latitude: 39.95452,
    longitude: -86.91996,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47965',
  },
  {
    city: 'Newport',
    county_fips: 18165,
    county_fips_all: '18165',
    county: 'Vermillion',
    county_names_all: 'Vermillion',
    county_weights: '{"18165": 100}',
    density: 95.5,
    imprecise: false,
    latitude: 39.88843,
    longitude: -87.41433,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47966',
  },
  {
    city: 'New Richmond',
    county_fips: 18107,
    county_fips_all: '18107|18157',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Tippecanoe',
    county_weights: '{"18107": 77.1, "18157": 22.9}',
    density: 10.1,
    imprecise: false,
    latitude: 40.1942,
    longitude: -86.99899,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47967',
  },
  {
    city: 'New Ross',
    county_fips: 18107,
    county_fips_all: '18107|18011|18063',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Boone|Hendricks',
    county_weights: '{"18107": 88.13, "18011": 10.46, "18063": 1.41}',
    density: 20.1,
    imprecise: false,
    latitude: 39.96209,
    longitude: -86.74542,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47968',
  },
  {
    city: 'Newtown',
    county_fips: 18045,
    county_fips_all: '18045',
    county: 'Fountain',
    county_names_all: 'Fountain',
    county_weights: '{"18045": 100}',
    density: 192.7,
    imprecise: false,
    latitude: 40.20355,
    longitude: -87.14892,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47969',
  },
  {
    city: 'Otterbein',
    county_fips: 18171,
    county_fips_all: '18171|18007|18157|18181',
    county: 'Warren',
    county_names_all: 'Warren|Benton|Tippecanoe|White',
    county_weights:
      '{"18171": 48.54, "18007": 46.17, "18157": 3.63, "18181": 1.66}',
    density: 19.2,
    imprecise: false,
    latitude: 40.47423,
    longitude: -87.13031,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47970',
  },
  {
    city: 'Oxford',
    county_fips: 18007,
    county_fips_all: '18007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"18007": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 40.52946,
    longitude: -87.23751,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47971',
  },
  {
    city: 'Perrysville',
    county_fips: 18165,
    county_fips_all: '18165',
    county: 'Vermillion',
    county_names_all: 'Vermillion',
    county_weights: '{"18165": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 40.04297,
    longitude: -87.47356,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47974',
  },
  {
    city: 'Pine Village',
    county_fips: 18171,
    county_fips_all: '18171|18007',
    county: 'Warren',
    county_names_all: 'Warren|Benton',
    county_weights: '{"18171": 95.67, "18007": 4.33}',
    density: 5.9,
    imprecise: false,
    latitude: 40.44436,
    longitude: -87.25348,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47975',
  },
  {
    city: 'Remington',
    county_fips: 18073,
    county_fips_all: '18073|18007|18181',
    county: 'Jasper',
    county_names_all: 'Jasper|Benton|White',
    county_weights: '{"18073": 61.58, "18007": 35.62, "18181": 2.8}',
    density: 11.6,
    imprecise: false,
    latitude: 40.76132,
    longitude: -87.15786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47977',
  },
  {
    city: 'Rensselaer',
    county_fips: 18073,
    county_fips_all: '18073|18111|18181',
    county: 'Jasper',
    county_names_all: 'Jasper|Newton|White',
    county_weights: '{"18073": 96.55, "18111": 2.29, "18181": 1.16}',
    density: 15,
    imprecise: false,
    latitude: 40.97991,
    longitude: -87.1163,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47978',
  },
  {
    city: 'Reynolds',
    county_fips: 18181,
    county_fips_all: '18181',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"18181": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 40.75393,
    longitude: -86.90131,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47980',
  },
  {
    city: 'Romney',
    county_fips: 18157,
    county_fips_all: '18157|18107',
    county: 'Tippecanoe',
    county_names_all: 'Tippecanoe|Montgomery',
    county_weights: '{"18157": 98.15, "18107": 1.85}',
    density: 7.9,
    imprecise: false,
    latitude: 40.24599,
    longitude: -86.93128,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47981',
  },
  {
    city: 'State Line',
    county_fips: 18171,
    county_fips_all: '18171',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"18171": 100}',
    density: 303.1,
    imprecise: false,
    latitude: 40.19728,
    longitude: -87.5268,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47982',
  },
  {
    city: 'Stockwell',
    county_fips: 18157,
    county_fips_all: '18157',
    county: 'Tippecanoe',
    county_names_all: 'Tippecanoe',
    county_weights: '{"18157": 100}',
    density: 845.6,
    imprecise: false,
    latitude: 40.28633,
    longitude: -86.77345,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47983',
  },
  {
    city: 'Templeton',
    county_fips: 18007,
    county_fips_all: '18007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"18007": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.51384,
    longitude: -87.20719,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47986',
  },
  {
    city: 'Veedersburg',
    county_fips: 18045,
    county_fips_all: '18045',
    county: 'Fountain',
    county_names_all: 'Fountain',
    county_weights: '{"18045": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 40.11916,
    longitude: -87.23428,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47987',
  },
  {
    city: 'Waveland',
    county_fips: 18107,
    county_fips_all: '18107|18121|18133',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Parke|Putnam',
    county_weights: '{"18107": 65.39, "18121": 32.85, "18133": 1.76}',
    density: 12.3,
    imprecise: false,
    latitude: 39.88871,
    longitude: -87.05243,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47989',
  },
  {
    city: 'Waynetown',
    county_fips: 18107,
    county_fips_all: '18107|18045',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Fountain',
    county_weights: '{"18107": 90.66, "18045": 9.34}',
    density: 11.9,
    imprecise: false,
    latitude: 40.06118,
    longitude: -87.05952,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47990',
  },
  {
    city: 'West Lebanon',
    county_fips: 18171,
    county_fips_all: '18171',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"18171": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 40.28034,
    longitude: -87.44794,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47991',
  },
  {
    city: 'Westpoint',
    county_fips: 18157,
    county_fips_all: '18157',
    county: 'Tippecanoe',
    county_names_all: 'Tippecanoe',
    county_weights: '{"18157": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 40.31933,
    longitude: -87.0519,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47992',
  },
  {
    city: 'Williamsport',
    county_fips: 18171,
    county_fips_all: '18171',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"18171": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 40.31161,
    longitude: -87.41603,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47993',
  },
  {
    city: 'Wingate',
    county_fips: 18107,
    county_fips_all: '18107|18045',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Fountain',
    county_weights: '{"18107": 61.54, "18045": 38.46}',
    density: 12,
    imprecise: false,
    latitude: 40.18233,
    longitude: -87.08231,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47994',
  },
  {
    city: 'Wolcott',
    county_fips: 18181,
    county_fips_all: '18181|18007|18073',
    county: 'White',
    county_names_all: 'White|Benton|Jasper',
    county_weights: '{"18181": 95.85, "18007": 2.38, "18073": 1.77}',
    density: 8.7,
    imprecise: false,
    latitude: 40.75861,
    longitude: -87.0329,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47995',
  },
  {
    city: 'Yeoman',
    county_fips: 18015,
    county_fips_all: '18015',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"18015": 100}',
    density: 713.7,
    imprecise: false,
    latitude: 40.66769,
    longitude: -86.72379,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47997',
  },
  {
    city: 'Algonac',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 227.7,
    imprecise: false,
    latitude: 42.63732,
    longitude: -82.57949,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48001',
  },
  {
    city: 'Allenton',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 42.93916,
    longitude: -82.92601,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48002',
  },
  {
    city: 'Almont',
    county_fips: 26087,
    county_fips_all: '26087',
    county: 'Lapeer',
    county_names_all: 'Lapeer',
    county_weights: '{"26087": 100}',
    density: 73.7,
    imprecise: false,
    latitude: 42.93228,
    longitude: -83.04088,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48003',
  },
  {
    city: 'Armada',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 56.3,
    imprecise: false,
    latitude: 42.85022,
    longitude: -82.92317,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48005',
  },
  {
    city: 'Avoca',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 21,
    imprecise: false,
    latitude: 43.0754,
    longitude: -82.69642,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48006',
  },
  {
    city: 'Birmingham',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1693.3,
    imprecise: false,
    latitude: 42.54381,
    longitude: -83.21765,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48009',
  },
  {
    city: 'Capac',
    county_fips: 26147,
    county_fips_all: '26147|26087',
    county: 'St. Clair',
    county_names_all: 'St. Clair|Lapeer',
    county_weights: '{"26147": 96.2, "26087": 3.8}',
    density: 45.1,
    imprecise: false,
    latitude: 43.02466,
    longitude: -82.93115,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48014',
  },
  {
    city: 'Center Line',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1864.5,
    imprecise: false,
    latitude: 42.48055,
    longitude: -83.02743,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48015',
  },
  {
    city: 'Clawson',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1995.5,
    imprecise: false,
    latitude: 42.53669,
    longitude: -83.15039,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48017',
  },
  {
    city: 'Eastpointe',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 2548.1,
    imprecise: false,
    latitude: 42.46567,
    longitude: -82.94598,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 33982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48021',
  },
  {
    city: 'Emmett',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 27.6,
    imprecise: false,
    latitude: 43.02824,
    longitude: -82.81111,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48022',
  },
  {
    city: 'Fair Haven',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 114,
    imprecise: false,
    latitude: 42.70102,
    longitude: -82.6593,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48023',
  },
  {
    city: 'Franklin',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 707.5,
    imprecise: false,
    latitude: 42.52032,
    longitude: -83.26744,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 14734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48025',
  },
  {
    city: 'Fraser',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1359.7,
    imprecise: false,
    latitude: 42.53879,
    longitude: -82.94964,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 14583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48026',
  },
  {
    city: 'Goodells',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 32.9,
    imprecise: false,
    latitude: 42.94466,
    longitude: -82.68217,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48027',
  },
  {
    city: 'Harsens Island',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 42.58947,
    longitude: -82.61948,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48028',
  },
  {
    city: 'Hazel Park',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 2050.1,
    imprecise: false,
    latitude: 42.46193,
    longitude: -83.09769,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 14963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48030',
  },
  {
    city: 'Jeddo',
    county_fips: 26147,
    county_fips_all: '26147|26151',
    county: 'St. Clair',
    county_names_all: 'St. Clair|Sanilac',
    county_weights: '{"26147": 80.38, "26151": 19.62}',
    density: 19.6,
    imprecise: false,
    latitude: 43.13278,
    longitude: -82.59457,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48032',
  },
  {
    city: 'Southfield',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 730.9,
    imprecise: false,
    latitude: 42.46478,
    longitude: -83.28812,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48033',
  },
  {
    city: 'Southfield',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1328.8,
    imprecise: false,
    latitude: 42.49689,
    longitude: -83.29102,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 14796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48034',
  },
  {
    city: 'Clinton Township',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1474.4,
    imprecise: false,
    latitude: 42.55615,
    longitude: -82.90948,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 33569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48035',
  },
  {
    city: 'Clinton Township',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1042.5,
    imprecise: false,
    latitude: 42.59227,
    longitude: -82.89971,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 22538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48036',
  },
  {
    city: 'Clinton Township',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1572.8,
    imprecise: false,
    latitude: 42.6054,
    longitude: -82.94152,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 44422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48038',
  },
  {
    city: 'Marine City',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 124.8,
    imprecise: false,
    latitude: 42.69664,
    longitude: -82.55052,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48039',
  },
  {
    city: 'Marysville',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 554.4,
    imprecise: false,
    latitude: 42.90983,
    longitude: -82.48022,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48040',
  },
  {
    city: 'Memphis',
    county_fips: 26147,
    county_fips_all: '26147|26099',
    county: 'St. Clair',
    county_names_all: 'St. Clair|Macomb',
    county_weights: '{"26147": 96.79, "26099": 3.21}',
    density: 41.5,
    imprecise: false,
    latitude: 42.93861,
    longitude: -82.80271,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48041',
  },
  {
    city: 'Macomb',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 574.8,
    imprecise: false,
    latitude: 42.68673,
    longitude: -82.90857,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 33875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48042',
  },
  {
    city: 'Mount Clemens',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1461.1,
    imprecise: false,
    latitude: 42.59763,
    longitude: -82.88208,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 15429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48043',
  },
  {
    city: 'Macomb',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1680.8,
    imprecise: false,
    latitude: 42.64988,
    longitude: -82.9296,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 58754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48044',
  },
  {
    city: 'Harrison Township',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 651.8,
    imprecise: false,
    latitude: 42.59121,
    longitude: -82.83017,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 24061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48045',
  },
  {
    city: 'New Baltimore',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 864,
    imprecise: false,
    latitude: 42.67754,
    longitude: -82.77744,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 40302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48047',
  },
  {
    city: 'New Haven',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 217.9,
    imprecise: false,
    latitude: 42.7417,
    longitude: -82.79558,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48048',
  },
  {
    city: 'North Street',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 59.2,
    imprecise: false,
    latitude: 43.0361,
    longitude: -82.57504,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48049',
  },
  {
    city: 'New Haven',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 27.8,
    imprecise: false,
    latitude: 42.78486,
    longitude: -82.80139,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48050',
  },
  {
    city: 'New Baltimore',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 487.7,
    imprecise: false,
    latitude: 42.69067,
    longitude: -82.82582,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48051',
  },
  {
    city: 'East China',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 68.3,
    imprecise: false,
    latitude: 42.77054,
    longitude: -82.54515,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48054',
  },
  {
    city: 'Fort Gratiot',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 188.8,
    imprecise: false,
    latitude: 43.08253,
    longitude: -82.49913,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 15499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48059',
  },
  {
    city: 'Port Huron',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 732.3,
    imprecise: false,
    latitude: 42.97835,
    longitude: -82.46297,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 39342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48060',
  },
  {
    city: 'Richmond',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 91.7,
    imprecise: false,
    latitude: 42.84899,
    longitude: -82.79989,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48062',
  },
  {
    city: 'Columbus',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 44.2,
    imprecise: false,
    latitude: 42.85581,
    longitude: -82.67676,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48063',
  },
  {
    city: 'Casco',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 43.6,
    imprecise: false,
    latitude: 42.76719,
    longitude: -82.67233,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48064',
  },
  {
    city: 'Romeo',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 119.8,
    imprecise: false,
    latitude: 42.84554,
    longitude: -83.04072,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48065',
  },
  {
    city: 'Roseville',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1845.2,
    imprecise: false,
    latitude: 42.50735,
    longitude: -82.93697,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 47123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48066',
  },
  {
    city: 'Royal Oak',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 2106.5,
    imprecise: false,
    latitude: 42.49053,
    longitude: -83.13786,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 24868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48067',
  },
  {
    city: 'Pleasant Ridge',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1758.2,
    imprecise: false,
    latitude: 42.47151,
    longitude: -83.14447,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48069',
  },
  {
    city: 'Huntington Woods',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1640.6,
    imprecise: false,
    latitude: 42.48161,
    longitude: -83.16852,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48070',
  },
  {
    city: 'Madison Heights',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1546.4,
    imprecise: false,
    latitude: 42.50726,
    longitude: -83.10337,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 28419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48071',
  },
  {
    city: 'Berkley',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 2440,
    imprecise: false,
    latitude: 42.49789,
    longitude: -83.18586,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 15149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48072',
  },
  {
    city: 'Royal Oak',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1728.7,
    imprecise: false,
    latitude: 42.51919,
    longitude: -83.16437,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 33106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48073',
  },
  {
    city: 'Smiths Creek',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 99.9,
    imprecise: false,
    latitude: 42.9484,
    longitude: -82.56196,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48074',
  },
  {
    city: 'Southfield',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1216.2,
    imprecise: false,
    latitude: 42.4618,
    longitude: -83.2299,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 22841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48075',
  },
  {
    city: 'Southfield',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1382.8,
    imprecise: false,
    latitude: 42.49754,
    longitude: -83.23067,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 25405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48076',
  },
  {
    city: 'Saint Clair',
    county_fips: 26147,
    county_fips_all: '26147',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"26147": 100}',
    density: 117.3,
    imprecise: false,
    latitude: 42.8576,
    longitude: -82.54721,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 12711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48079',
  },
  {
    city: 'Saint Clair Shores',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1892.9,
    imprecise: false,
    latitude: 42.46418,
    longitude: -82.90031,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48080',
  },
  {
    city: 'Saint Clair Shores',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 2027,
    imprecise: false,
    latitude: 42.4955,
    longitude: -82.89912,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48081',
  },
  {
    city: 'Saint Clair Shores',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1870.8,
    imprecise: false,
    latitude: 42.5271,
    longitude: -82.88711,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 16027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48082',
  },
  {
    city: 'Troy',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1065.3,
    imprecise: false,
    latitude: 42.557,
    longitude: -83.11676,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 23771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48083',
  },
  {
    city: 'Troy',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 996.6,
    imprecise: false,
    latitude: 42.56065,
    longitude: -83.17559,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 15960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48084',
  },
  {
    city: 'Troy',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1130.3,
    imprecise: false,
    latitude: 42.6006,
    longitude: -83.11982,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 27231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48085',
  },
  {
    city: 'Warren',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 2008,
    imprecise: false,
    latitude: 42.51573,
    longitude: -82.98298,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 22991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48088',
  },
  {
    city: 'Warren',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1536.4,
    imprecise: false,
    latitude: 42.4702,
    longitude: -82.99549,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 31853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48089',
  },
  {
    city: 'Warren',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1498.4,
    imprecise: false,
    latitude: 42.4681,
    longitude: -83.05819,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 30696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48091',
  },
  {
    city: 'Warren',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1297,
    imprecise: false,
    latitude: 42.51308,
    longitude: -83.05968,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 27374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48092',
  },
  {
    city: 'Warren',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1638.9,
    imprecise: false,
    latitude: 42.51483,
    longitude: -83.01554,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 25014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48093',
  },
  {
    city: 'Washington',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 456.9,
    imprecise: false,
    latitude: 42.73645,
    longitude: -83.03718,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48094',
  },
  {
    city: 'Washington',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 129.4,
    imprecise: false,
    latitude: 42.77977,
    longitude: -83.03837,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48095',
  },
  {
    city: 'Ray',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 39.9,
    imprecise: false,
    latitude: 42.76132,
    longitude: -82.9199,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48096',
  },
  {
    city: 'Yale',
    county_fips: 26147,
    county_fips_all: '26147|26151',
    county: 'St. Clair',
    county_names_all: 'St. Clair|Sanilac',
    county_weights: '{"26147": 77.68, "26151": 22.32}',
    density: 27.4,
    imprecise: false,
    latitude: 43.12639,
    longitude: -82.82955,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48097',
  },
  {
    city: 'Troy',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 860.1,
    imprecise: false,
    latitude: 42.59903,
    longitude: -83.1789,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48098',
  },
  {
    city: 'Allen Park',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1530.6,
    imprecise: false,
    latitude: 42.25976,
    longitude: -83.21067,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 27925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48101',
  },
  {
    city: 'Ann Arbor',
    county_fips: 26161,
    county_fips_all: '26161',
    county: 'Washtenaw',
    county_names_all: 'Washtenaw',
    county_weights: '{"26161": 100}',
    density: 319.5,
    imprecise: false,
    latitude: 42.2581,
    longitude: -83.84333,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 55054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48103',
  },
  {
    city: 'Ann Arbor',
    county_fips: 26161,
    county_fips_all: '26161',
    county: 'Washtenaw',
    county_names_all: 'Washtenaw',
    county_weights: '{"26161": 100}',
    density: 2178.4,
    imprecise: false,
    latitude: 42.26343,
    longitude: -83.71748,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 43979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48104',
  },
  {
    city: 'Ann Arbor',
    county_fips: 26161,
    county_fips_all: '26161',
    county: 'Washtenaw',
    county_names_all: 'Washtenaw',
    county_weights: '{"26161": 100}',
    density: 288.9,
    imprecise: false,
    latitude: 42.33117,
    longitude: -83.70587,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 37048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48105',
  },
  {
    city: 'Ann Arbor',
    county_fips: 26161,
    county_fips_all: '26161',
    county: 'Washtenaw',
    county_names_all: 'Washtenaw',
    county_weights: '{"26161": 100}',
    density: 636.7,
    imprecise: false,
    latitude: 42.22206,
    longitude: -83.7317,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 27666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48108',
  },
  {
    city: 'Ann Arbor',
    county_fips: 26161,
    county_fips_all: '26161',
    county: 'Washtenaw',
    county_names_all: 'Washtenaw',
    county_weights: '{"26161": 100}',
    density: 1643.6,
    imprecise: false,
    latitude: 42.28408,
    longitude: -83.72531,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48109',
  },
  {
    city: 'Belleville',
    county_fips: 26163,
    county_fips_all: '26163|26161|26115',
    county: 'Wayne',
    county_names_all: 'Wayne|Washtenaw|Monroe',
    county_weights: '{"26163": 97.27, "26161": 2.11, "26115": 0.62}',
    density: 258,
    imprecise: false,
    latitude: 42.17976,
    longitude: -83.48762,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 44709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48111',
  },
  {
    city: 'Brighton',
    county_fips: 26093,
    county_fips_all: '26093',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"26093": 100}',
    density: 287.9,
    imprecise: false,
    latitude: 42.56784,
    longitude: -83.75537,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48114',
  },
  {
    city: 'Brighton',
    county_fips: 26093,
    county_fips_all: '26093',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"26093": 100}',
    density: 285.3,
    imprecise: false,
    latitude: 42.50428,
    longitude: -83.78069,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 27289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48116',
  },
  {
    city: 'Carleton',
    county_fips: 26115,
    county_fips_all: '26115|26163',
    county: 'Monroe',
    county_names_all: 'Monroe|Wayne',
    county_weights: '{"26115": 99.35, "26163": 0.65}',
    density: 73.2,
    imprecise: false,
    latitude: 42.04984,
    longitude: -83.40997,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 10262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48117',
  },
  {
    city: 'Chelsea',
    county_fips: 26161,
    county_fips_all: '26161',
    county: 'Washtenaw',
    county_names_all: 'Washtenaw',
    county_weights: '{"26161": 100}',
    density: 59.3,
    imprecise: false,
    latitude: 42.31151,
    longitude: -84.03835,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 13246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48118',
  },
  {
    city: 'Dearborn',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 683.7,
    imprecise: false,
    latitude: 42.30524,
    longitude: -83.1718,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48120',
  },
  {
    city: 'Melvindale',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1781.8,
    imprecise: false,
    latitude: 42.28018,
    longitude: -83.17819,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 12554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48122',
  },
  {
    city: 'Dearborn',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1508.8,
    imprecise: false,
    latitude: 42.29828,
    longitude: -83.24796,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 34479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48124',
  },
  {
    city: 'Dearborn Heights',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 2109.3,
    imprecise: false,
    latitude: 42.27793,
    longitude: -83.26536,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 22125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48125',
  },
  {
    city: 'Dearborn',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 2397.6,
    imprecise: false,
    latitude: 42.32999,
    longitude: -83.18678,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 51997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48126',
  },
  {
    city: 'Dearborn Heights',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1991.2,
    imprecise: false,
    latitude: 42.33663,
    longitude: -83.28292,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 39646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48127',
  },
  {
    city: 'Dearborn',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 2110.4,
    imprecise: false,
    latitude: 42.32054,
    longitude: -83.25952,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 12624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48128',
  },
  {
    city: 'Dexter',
    county_fips: 26161,
    county_fips_all: '26161',
    county: 'Washtenaw',
    county_names_all: 'Washtenaw',
    county_weights: '{"26161": 100}',
    density: 102.5,
    imprecise: false,
    latitude: 42.3547,
    longitude: -83.90272,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 16986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48130',
  },
  {
    city: 'Dundee',
    county_fips: 26115,
    county_fips_all: '26115',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"26115": 100}',
    density: 66.6,
    imprecise: false,
    latitude: 41.96553,
    longitude: -83.67268,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48131',
  },
  {
    city: 'Erie',
    county_fips: 26115,
    county_fips_all: '26115',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"26115": 100}',
    density: 100.6,
    imprecise: false,
    latitude: 41.78428,
    longitude: -83.48816,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48133',
  },
  {
    city: 'Flat Rock',
    county_fips: 26163,
    county_fips_all: '26163|26115',
    county: 'Wayne',
    county_names_all: 'Wayne|Monroe',
    county_weights: '{"26163": 84.96, "26115": 15.04}',
    density: 498.6,
    imprecise: false,
    latitude: 42.10813,
    longitude: -83.29556,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 23935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48134',
  },
  {
    city: 'Garden City',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1761,
    imprecise: false,
    latitude: 42.32438,
    longitude: -83.34122,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 26739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48135',
  },
  {
    city: 'Gregory',
    county_fips: 26093,
    county_fips_all: '26093|26161',
    county: 'Livingston',
    county_names_all: 'Livingston|Washtenaw',
    county_weights: '{"26093": 72.04, "26161": 27.96}',
    density: 37.1,
    imprecise: false,
    latitude: 42.46191,
    longitude: -84.07367,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48137',
  },
  {
    city: 'Grosse Ile',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 463.2,
    imprecise: false,
    latitude: 42.13156,
    longitude: -83.1586,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 10344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48138',
  },
  {
    city: 'Hamburg',
    county_fips: 26093,
    county_fips_all: '26093',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"26093": 100}',
    density: 63.4,
    imprecise: false,
    latitude: 42.45298,
    longitude: -83.80796,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48139',
  },
  {
    city: 'Ida',
    county_fips: 26115,
    county_fips_all: '26115',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"26115": 100}',
    density: 53.7,
    imprecise: false,
    latitude: 41.88141,
    longitude: -83.58274,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48140',
  },
  {
    city: 'Inkster',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1570.2,
    imprecise: false,
    latitude: 42.29349,
    longitude: -83.31483,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 25428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48141',
  },
  {
    city: 'Lakeland',
    county_fips: 26093,
    county_fips_all: '26093',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"26093": 100}',
    density: 1417.8,
    imprecise: false,
    latitude: 42.45877,
    longitude: -83.84701,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48143',
  },
  {
    city: 'Lambertville',
    county_fips: 26115,
    county_fips_all: '26115',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"26115": 100}',
    density: 511.5,
    imprecise: false,
    latitude: 41.75325,
    longitude: -83.62803,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 10507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48144',
  },
  {
    city: 'La Salle',
    county_fips: 26115,
    county_fips_all: '26115',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"26115": 100}',
    density: 66.1,
    imprecise: false,
    latitude: 41.85122,
    longitude: -83.46331,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48145',
  },
  {
    city: 'Lincoln Park',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 2597.1,
    imprecise: false,
    latitude: 42.24322,
    longitude: -83.18114,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 39257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48146',
  },
  {
    city: 'Livonia',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 850.4,
    imprecise: false,
    latitude: 42.36859,
    longitude: -83.37261,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 26687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48150',
  },
  {
    city: 'Livonia',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 967.6,
    imprecise: false,
    latitude: 42.42597,
    longitude: -83.37433,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 30119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48152',
  },
  {
    city: 'Livonia',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1235.4,
    imprecise: false,
    latitude: 42.39737,
    longitude: -83.37315,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 37045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48154',
  },
  {
    city: 'Luna Pier',
    county_fips: 26115,
    county_fips_all: '26115',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"26115": 100}',
    density: 510.5,
    imprecise: false,
    latitude: 41.81495,
    longitude: -83.43776,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48157',
  },
  {
    city: 'Manchester',
    county_fips: 26161,
    county_fips_all: '26161|26075',
    county: 'Washtenaw',
    county_names_all: 'Washtenaw|Jackson',
    county_weights: '{"26161": 98.54, "26075": 1.46}',
    density: 31.6,
    imprecise: false,
    latitude: 42.15564,
    longitude: -84.03031,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48158',
  },
  {
    city: 'Maybee',
    county_fips: 26115,
    county_fips_all: '26115',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"26115": 100}',
    density: 31,
    imprecise: false,
    latitude: 42.02562,
    longitude: -83.55598,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48159',
  },
  {
    city: 'Milan',
    county_fips: 26115,
    county_fips_all: '26115|26161',
    county: 'Monroe',
    county_names_all: 'Monroe|Washtenaw',
    county_weights: '{"26115": 51.87, "26161": 48.13}',
    density: 69.2,
    imprecise: false,
    latitude: 42.08256,
    longitude: -83.67978,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 13972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48160',
  },
  {
    city: 'Monroe',
    county_fips: 26115,
    county_fips_all: '26115',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"26115": 100}',
    density: 226.6,
    imprecise: false,
    latitude: 41.90818,
    longitude: -83.47263,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 26304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48161',
  },
  {
    city: 'Monroe',
    county_fips: 26115,
    county_fips_all: '26115',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"26115": 100}',
    density: 189.2,
    imprecise: false,
    latitude: 41.96045,
    longitude: -83.43503,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 28156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48162',
  },
  {
    city: 'New Boston',
    county_fips: 26163,
    county_fips_all: '26163|26115',
    county: 'Wayne',
    county_names_all: 'Wayne|Monroe',
    county_weights: '{"26163": 96.28, "26115": 3.72}',
    density: 122,
    imprecise: false,
    latitude: 42.1264,
    longitude: -83.39391,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48164',
  },
  {
    city: 'New Hudson',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 372.9,
    imprecise: false,
    latitude: 42.49968,
    longitude: -83.61623,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48165',
  },
  {
    city: 'Newport',
    county_fips: 26115,
    county_fips_all: '26115',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"26115": 100}',
    density: 204,
    imprecise: false,
    latitude: 41.98677,
    longitude: -83.29375,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 14056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48166',
  },
  {
    city: 'Northville',
    county_fips: 26125,
    county_fips_all: '26125|26163|26161',
    county: 'Oakland',
    county_names_all: 'Oakland|Wayne|Washtenaw',
    county_weights: '{"26125": 45.41, "26163": 30.32, "26161": 24.27}',
    density: 491.2,
    imprecise: false,
    latitude: 42.43455,
    longitude: -83.5313,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 24713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48167',
  },
  {
    city: 'Northville',
    county_fips: 26163,
    county_fips_all: '26163|26161',
    county: 'Wayne',
    county_names_all: 'Wayne|Washtenaw',
    county_weights: '{"26163": 55.14, "26161": 44.86}',
    density: 493.5,
    imprecise: false,
    latitude: 42.40559,
    longitude: -83.54051,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 25038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48168',
  },
  {
    city: 'Pinckney',
    county_fips: 26093,
    county_fips_all: '26093|26161',
    county: 'Livingston',
    county_names_all: 'Livingston|Washtenaw',
    county_weights: '{"26093": 92.99, "26161": 7.01}',
    density: 137.4,
    imprecise: false,
    latitude: 42.46348,
    longitude: -83.94955,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48169',
  },
  {
    city: 'Plymouth',
    county_fips: 26163,
    county_fips_all: '26163|26161',
    county: 'Wayne',
    county_names_all: 'Wayne|Washtenaw',
    county_weights: '{"26163": 54.65, "26161": 45.35}',
    density: 448.7,
    imprecise: false,
    latitude: 42.36758,
    longitude: -83.53271,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 40076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48170',
  },
  {
    city: 'Rockwood',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 418.8,
    imprecise: false,
    latitude: 42.07638,
    longitude: -83.21521,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 12931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48173',
  },
  {
    city: 'Romulus',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 304.8,
    imprecise: false,
    latitude: 42.20862,
    longitude: -83.35413,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 32211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48174',
  },
  {
    city: 'Saline',
    county_fips: 26161,
    county_fips_all: '26161|26091',
    county: 'Washtenaw',
    county_names_all: 'Washtenaw|Lenawee',
    county_weights: '{"26161": 99.64, "26091": 0.36}',
    density: 127.9,
    imprecise: false,
    latitude: 42.15067,
    longitude: -83.81477,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 23451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48176',
  },
  {
    city: 'Samaria',
    county_fips: 26115,
    county_fips_all: '26115',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"26115": 100}',
    density: 290.8,
    imprecise: false,
    latitude: 41.8048,
    longitude: -83.58157,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48177',
  },
  {
    city: 'South Lyon',
    county_fips: 26125,
    county_fips_all: '26125|26161|26093',
    county: 'Oakland',
    county_names_all: 'Oakland|Washtenaw|Livingston',
    county_weights: '{"26125": 36.03, "26161": 33.18, "26093": 30.79}',
    density: 304.2,
    imprecise: false,
    latitude: 42.44463,
    longitude: -83.66399,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 37789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48178',
  },
  {
    city: 'South Rockwood',
    county_fips: 26115,
    county_fips_all: '26115',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"26115": 100}',
    density: 60.9,
    imprecise: false,
    latitude: 42.03882,
    longitude: -83.26061,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48179',
  },
  {
    city: 'Taylor',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1015,
    imprecise: false,
    latitude: 42.22605,
    longitude: -83.26881,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 62081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48180',
  },
  {
    city: 'Temperance',
    county_fips: 26115,
    county_fips_all: '26115',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"26115": 100}',
    density: 198.6,
    imprecise: false,
    latitude: 41.7919,
    longitude: -83.57831,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48182',
  },
  {
    city: 'Trenton',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 893.8,
    imprecise: false,
    latitude: 42.1361,
    longitude: -83.22045,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 41765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48183',
  },
  {
    city: 'Wayne',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 930.3,
    imprecise: false,
    latitude: 42.27403,
    longitude: -83.39494,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48184',
  },
  {
    city: 'Westland',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1539.3,
    imprecise: false,
    latitude: 42.33579,
    longitude: -83.38458,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 48530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48185',
  },
  {
    city: 'Westland',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1641,
    imprecise: false,
    latitude: 42.29481,
    longitude: -83.37461,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 35103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48186',
  },
  {
    city: 'Canton',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1140.1,
    imprecise: false,
    latitude: 42.3292,
    longitude: -83.48784,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 53376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48187',
  },
  {
    city: 'Canton',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 986.1,
    imprecise: false,
    latitude: 42.28579,
    longitude: -83.48638,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 45665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48188',
  },
  {
    city: 'Whitmore Lake',
    county_fips: 26161,
    county_fips_all: '26161|26093',
    county: 'Washtenaw',
    county_names_all: 'Washtenaw|Livingston',
    county_weights: '{"26161": 68.43, "26093": 31.57}',
    density: 156.9,
    imprecise: false,
    latitude: 42.41137,
    longitude: -83.78306,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 13893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48189',
  },
  {
    city: 'Whittaker',
    county_fips: 26161,
    county_fips_all: '26161',
    county: 'Washtenaw',
    county_names_all: 'Washtenaw',
    county_weights: '{"26161": 100}',
    density: 35,
    imprecise: false,
    latitude: 42.13162,
    longitude: -83.60327,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48190',
  },
  {
    city: 'Willis',
    county_fips: 26161,
    county_fips_all: '26161|26115',
    county: 'Washtenaw',
    county_names_all: 'Washtenaw|Monroe',
    county_weights: '{"26161": 87.7, "26115": 12.3}',
    density: 105.5,
    imprecise: false,
    latitude: 42.12022,
    longitude: -83.56492,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48191',
  },
  {
    city: 'Wyandotte',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1786.6,
    imprecise: false,
    latitude: 42.21156,
    longitude: -83.15654,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 24489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48192',
  },
  {
    city: 'Riverview',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 870.1,
    imprecise: false,
    latitude: 42.17341,
    longitude: -83.21042,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 16119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48193',
  },
  {
    city: 'Southgate',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1649.3,
    imprecise: false,
    latitude: 42.20472,
    longitude: -83.20568,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 29366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48195',
  },
  {
    city: 'Ypsilanti',
    county_fips: 26161,
    county_fips_all: '26161',
    county: 'Washtenaw',
    county_names_all: 'Washtenaw',
    county_weights: '{"26161": 100}',
    density: 622.9,
    imprecise: false,
    latitude: 42.1973,
    longitude: -83.62903,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 66525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48197',
  },
  {
    city: 'Ypsilanti',
    county_fips: 26161,
    county_fips_all: '26161',
    county: 'Washtenaw',
    county_names_all: 'Washtenaw',
    county_weights: '{"26161": 100}',
    density: 454.3,
    imprecise: false,
    latitude: 42.27519,
    longitude: -83.58822,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 39244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48198',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 3074.5,
    imprecise: false,
    latitude: 42.34706,
    longitude: -83.06009,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 15091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48201',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1817.8,
    imprecise: false,
    latitude: 42.37463,
    longitude: -83.07764,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 15780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48202',
  },
  {
    city: 'Highland Park',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 942.7,
    imprecise: false,
    latitude: 42.42176,
    longitude: -83.1031,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48203',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1589.9,
    imprecise: false,
    latitude: 42.36582,
    longitude: -83.14286,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48204',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 2078.1,
    imprecise: false,
    latitude: 42.43317,
    longitude: -82.98131,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 34187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48205',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1899.9,
    imprecise: false,
    latitude: 42.3751,
    longitude: -83.10782,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 15227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48206',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1278.2,
    imprecise: false,
    latitude: 42.34753,
    longitude: -83.01104,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48207',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 967,
    imprecise: false,
    latitude: 42.34844,
    longitude: -83.09173,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48208',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1542.9,
    imprecise: false,
    latitude: 42.30524,
    longitude: -83.11649,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 27184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48209',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 2087.7,
    imprecise: false,
    latitude: 42.33644,
    longitude: -83.12875,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 26722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48210',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 493,
    imprecise: false,
    latitude: 42.38175,
    longitude: -83.04616,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48211',
  },
  {
    city: 'Hamtramck',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 3166.2,
    imprecise: false,
    latitude: 42.41003,
    longitude: -83.05601,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 43384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48212',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1187.9,
    imprecise: false,
    latitude: 42.39787,
    longitude: -82.9955,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48213',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1421.3,
    imprecise: false,
    latitude: 42.36504,
    longitude: -82.98697,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48214',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1009.3,
    imprecise: false,
    latitude: 42.37523,
    longitude: -82.95428,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 10322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48215',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 998.3,
    imprecise: false,
    latitude: 42.32637,
    longitude: -83.07927,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48216',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1098.1,
    imprecise: false,
    latitude: 42.27803,
    longitude: -83.15409,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48217',
  },
  {
    city: 'River Rouge',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1241,
    imprecise: false,
    latitude: 42.27049,
    longitude: -83.13076,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48218',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 2161.6,
    imprecise: false,
    latitude: 42.42573,
    longitude: -83.25282,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 47208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48219',
  },
  {
    city: 'Ferndale',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1879.3,
    imprecise: false,
    latitude: 42.45805,
    longitude: -83.13519,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48220',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 3076.6,
    imprecise: false,
    latitude: 42.4272,
    longitude: -83.14949,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 41392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48221',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1443.4,
    imprecise: false,
    latitude: 42.39341,
    longitude: -83.24619,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 22622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48223',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 2654.7,
    imprecise: false,
    latitude: 42.41074,
    longitude: -82.94147,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 39668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48224',
  },
  {
    city: 'Harper Woods',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 2324.8,
    imprecise: false,
    latitude: 42.43893,
    longitude: -82.92965,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 16098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48225',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 2169.4,
    imprecise: false,
    latitude: 42.33182,
    longitude: -83.05034,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48226',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 2073.8,
    imprecise: false,
    latitude: 42.38732,
    longitude: -83.1926,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 40302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48227',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 2172.8,
    imprecise: false,
    latitude: 42.35562,
    longitude: -83.21791,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 50117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48228',
  },
  {
    city: 'Ecorse',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1234.6,
    imprecise: false,
    latitude: 42.24889,
    longitude: -83.1399,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48229',
  },
  {
    city: 'Grosse Pointe',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 2037.4,
    imprecise: false,
    latitude: 42.38353,
    longitude: -82.92304,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48230',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1618.4,
    imprecise: false,
    latitude: 42.4312,
    longitude: -83.03952,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 32760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48234',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 2819.2,
    imprecise: false,
    latitude: 42.42702,
    longitude: -83.1947,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 45600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48235',
  },
  {
    city: 'Grosse Pointe',
    county_fips: 26163,
    county_fips_all: '26163|26099',
    county: 'Wayne',
    county_names_all: 'Wayne|Macomb',
    county_weights: '{"26163": 97.61, "26099": 2.39}',
    density: 1623.1,
    imprecise: false,
    latitude: 42.42504,
    longitude: -82.89687,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 31435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48236',
  },
  {
    city: 'Oak Park',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 2199.4,
    imprecise: false,
    latitude: 42.46494,
    longitude: -83.18241,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 29318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48237',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1768.4,
    imprecise: false,
    latitude: 42.39626,
    longitude: -83.14136,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 24731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48238',
  },
  {
    city: 'Redford',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1507.4,
    imprecise: false,
    latitude: 42.37638,
    longitude: -83.28574,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 36976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48239',
  },
  {
    city: 'Redford',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 1751.8,
    imprecise: false,
    latitude: 42.42447,
    longitude: -83.30128,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48240',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.21258,
    longitude: -83.35203,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48242',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.32994,
    longitude: -83.03955,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48243',
  },
  {
    city: 'Bloomfield Hills',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 770.6,
    imprecise: false,
    latitude: 42.54441,
    longitude: -83.28284,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 14682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48301',
  },
  {
    city: 'Bloomfield Hills',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 612.7,
    imprecise: false,
    latitude: 42.5849,
    longitude: -83.29608,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48302',
  },
  {
    city: 'Bloomfield Hills',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 589,
    imprecise: false,
    latitude: 42.58745,
    longitude: -83.23442,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48304',
  },
  {
    city: 'Rochester',
    county_fips: 26125,
    county_fips_all: '26125|26099',
    county: 'Oakland',
    county_names_all: 'Oakland|Macomb',
    county_weights: '{"26125": 98.08, "26099": 1.92}',
    density: 496.2,
    imprecise: false,
    latitude: 42.72243,
    longitude: -83.14944,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 28389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48306',
  },
  {
    city: 'Rochester',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1134.2,
    imprecise: false,
    latitude: 42.65953,
    longitude: -83.12301,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 44714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48307',
  },
  {
    city: 'Rochester',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 761.3,
    imprecise: false,
    latitude: 42.65866,
    longitude: -83.18348,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 30685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48309',
  },
  {
    city: 'Sterling Heights',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1893.9,
    imprecise: false,
    latitude: 42.56511,
    longitude: -83.06694,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 43354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48310',
  },
  {
    city: 'Sterling Heights',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1191.9,
    imprecise: false,
    latitude: 42.55831,
    longitude: -83.00914,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 34401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48312',
  },
  {
    city: 'Sterling Heights',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1514.4,
    imprecise: false,
    latitude: 42.59985,
    longitude: -82.99984,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 34015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48313',
  },
  {
    city: 'Sterling Heights',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 1080.8,
    imprecise: false,
    latitude: 42.60978,
    longitude: -83.05426,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48314',
  },
  {
    city: 'Utica',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 853.6,
    imprecise: false,
    latitude: 42.67254,
    longitude: -82.9963,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 28472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48315',
  },
  {
    city: 'Utica',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 987.9,
    imprecise: false,
    latitude: 42.69059,
    longitude: -83.05671,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 28784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48316',
  },
  {
    city: 'Utica',
    county_fips: 26099,
    county_fips_all: '26099',
    county: 'Macomb',
    county_names_all: 'Macomb',
    county_weights: '{"26099": 100}',
    density: 884.1,
    imprecise: false,
    latitude: 42.64673,
    longitude: -83.05334,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 27565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48317',
  },
  {
    city: 'Keego Harbor',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1507.8,
    imprecise: false,
    latitude: 42.61274,
    longitude: -83.33824,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48320',
  },
  {
    city: 'West Bloomfield',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1083,
    imprecise: false,
    latitude: 42.54214,
    longitude: -83.38139,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 32885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48322',
  },
  {
    city: 'West Bloomfield',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 774.4,
    imprecise: false,
    latitude: 42.57036,
    longitude: -83.37651,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48323',
  },
  {
    city: 'West Bloomfield',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 769.5,
    imprecise: false,
    latitude: 42.59702,
    longitude: -83.39151,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48324',
  },
  {
    city: 'Auburn Hills',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 558.4,
    imprecise: false,
    latitude: 42.67536,
    longitude: -83.2531,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 24514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48326',
  },
  {
    city: 'Waterford',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 715.3,
    imprecise: false,
    latitude: 42.6443,
    longitude: -83.41417,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48327',
  },
  {
    city: 'Waterford',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1058.4,
    imprecise: false,
    latitude: 42.64597,
    longitude: -83.35603,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 24478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48328',
  },
  {
    city: 'Waterford',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 926.9,
    imprecise: false,
    latitude: 42.68826,
    longitude: -83.38854,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 24715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48329',
  },
  {
    city: 'Farmington',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 894.2,
    imprecise: false,
    latitude: 42.50389,
    longitude: -83.40863,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48331',
  },
  {
    city: 'Farmington',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 835.1,
    imprecise: false,
    latitude: 42.50662,
    longitude: -83.34964,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 19618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48334',
  },
  {
    city: 'Farmington',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1341.2,
    imprecise: false,
    latitude: 42.46229,
    longitude: -83.40271,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 25077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48335',
  },
  {
    city: 'Farmington',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1095.7,
    imprecise: false,
    latitude: 42.46333,
    longitude: -83.34803,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 26432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48336',
  },
  {
    city: 'Pontiac',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1294.2,
    imprecise: false,
    latitude: 42.67065,
    longitude: -83.29019,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 25669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48340',
  },
  {
    city: 'Pontiac',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1084.9,
    imprecise: false,
    latitude: 42.6275,
    longitude: -83.29433,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48341',
  },
  {
    city: 'Pontiac',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1296.8,
    imprecise: false,
    latitude: 42.64389,
    longitude: -83.27591,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48342',
  },
  {
    city: 'Clarkston',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 493.7,
    imprecise: false,
    latitude: 42.72156,
    longitude: -83.42388,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 23167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48346',
  },
  {
    city: 'Clarkston',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 282.2,
    imprecise: false,
    latitude: 42.76677,
    longitude: -83.40088,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 24574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48348',
  },
  {
    city: 'Davisburg',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 132.2,
    imprecise: false,
    latitude: 42.74082,
    longitude: -83.53374,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48350',
  },
  {
    city: 'Hartland',
    county_fips: 26093,
    county_fips_all: '26093',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"26093": 100}',
    density: 215.5,
    imprecise: false,
    latitude: 42.64736,
    longitude: -83.71627,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48353',
  },
  {
    city: 'Highland',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 230.6,
    imprecise: false,
    latitude: 42.65532,
    longitude: -83.58904,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48356',
  },
  {
    city: 'Highland',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 256.9,
    imprecise: false,
    latitude: 42.65358,
    longitude: -83.6432,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48357',
  },
  {
    city: 'Lake Orion',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 367,
    imprecise: false,
    latitude: 42.7218,
    longitude: -83.27801,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 10401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48359',
  },
  {
    city: 'Lake Orion',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 411.4,
    imprecise: false,
    latitude: 42.74903,
    longitude: -83.26789,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 12116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48360',
  },
  {
    city: 'Lake Orion',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 572.1,
    imprecise: false,
    latitude: 42.782,
    longitude: -83.2696,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 14966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48362',
  },
  {
    city: 'Oakland',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 136.6,
    imprecise: false,
    latitude: 42.77209,
    longitude: -83.16114,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48363',
  },
  {
    city: 'Leonard',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 76.9,
    imprecise: false,
    latitude: 42.84282,
    longitude: -83.14143,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48367',
  },
  {
    city: 'Oxford',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 62.2,
    imprecise: false,
    latitude: 42.83797,
    longitude: -83.19981,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48370',
  },
  {
    city: 'Oxford',
    county_fips: 26125,
    county_fips_all: '26125|26087',
    county: 'Oakland',
    county_names_all: 'Oakland|Lapeer',
    county_weights: '{"26125": 88.24, "26087": 11.76}',
    density: 216.8,
    imprecise: false,
    latitude: 42.84544,
    longitude: -83.28785,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 25972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48371',
  },
  {
    city: 'Novi',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 752,
    imprecise: false,
    latitude: 42.47083,
    longitude: -83.52384,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48374',
  },
  {
    city: 'Novi',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 1107.5,
    imprecise: false,
    latitude: 42.46537,
    longitude: -83.46385,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 24029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48375',
  },
  {
    city: 'Novi',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 796.6,
    imprecise: false,
    latitude: 42.50646,
    longitude: -83.4727,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 19816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48377',
  },
  {
    city: 'Milford',
    county_fips: 26125,
    county_fips_all: '26125|26093',
    county: 'Oakland',
    county_names_all: 'Oakland|Livingston',
    county_weights: '{"26125": 62.62, "26093": 37.38}',
    density: 96.1,
    imprecise: false,
    latitude: 42.57902,
    longitude: -83.66602,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48380',
  },
  {
    city: 'Milford',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 279,
    imprecise: false,
    latitude: 42.5628,
    longitude: -83.59336,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 14094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48381',
  },
  {
    city: 'Commerce Township',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 567.8,
    imprecise: false,
    latitude: 42.59006,
    longitude: -83.507,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 24479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48382',
  },
  {
    city: 'White Lake',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 307.7,
    imprecise: false,
    latitude: 42.65533,
    longitude: -83.53485,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 13285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48383',
  },
  {
    city: 'White Lake',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 410.2,
    imprecise: false,
    latitude: 42.65826,
    longitude: -83.47549,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48386',
  },
  {
    city: 'Walled Lake',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 740.8,
    imprecise: false,
    latitude: 42.55197,
    longitude: -83.4752,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 23939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48390',
  },
  {
    city: 'Wixom',
    county_fips: 26125,
    county_fips_all: '26125',
    county: 'Oakland',
    county_names_all: 'Oakland',
    county_weights: '{"26125": 100}',
    density: 572.9,
    imprecise: false,
    latitude: 42.52123,
    longitude: -83.54532,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48393',
  },
  {
    city: 'Applegate',
    county_fips: 26151,
    county_fips_all: '26151',
    county: 'Sanilac',
    county_names_all: 'Sanilac',
    county_weights: '{"26151": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 43.3526,
    longitude: -82.66061,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48401',
  },
  {
    city: 'Argyle',
    county_fips: 26151,
    county_fips_all: '26151',
    county: 'Sanilac',
    county_names_all: 'Sanilac',
    county_weights: '{"26151": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 43.56629,
    longitude: -82.9362,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48410',
  },
  {
    city: 'Atlas',
    county_fips: 26049,
    county_fips_all: '26049',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"26049": 100}',
    density: 81.3,
    imprecise: false,
    latitude: 42.93577,
    longitude: -83.53202,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48411',
  },
  {
    city: 'Attica',
    county_fips: 26087,
    county_fips_all: '26087',
    county: 'Lapeer',
    county_names_all: 'Lapeer',
    county_weights: '{"26087": 100}',
    density: 45.6,
    imprecise: false,
    latitude: 43.06484,
    longitude: -83.16932,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48412',
  },
  {
    city: 'Bad Axe',
    county_fips: 26063,
    county_fips_all: '26063',
    county: 'Huron',
    county_names_all: 'Huron',
    county_weights: '{"26063": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 43.80231,
    longitude: -82.99663,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48413',
  },
  {
    city: 'Bancroft',
    county_fips: 26155,
    county_fips_all: '26155',
    county: 'Shiawassee',
    county_names_all: 'Shiawassee',
    county_weights: '{"26155": 100}',
    density: 30.4,
    imprecise: false,
    latitude: 42.86391,
    longitude: -84.08098,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48414',
  },
  {
    city: 'Birch Run',
    county_fips: 26145,
    county_fips_all: '26145|26157|26049',
    county: 'Saginaw',
    county_names_all: 'Saginaw|Tuscola|Genesee',
    county_weights: '{"26145": 95.28, "26157": 2.85, "26049": 1.87}',
    density: 53.2,
    imprecise: false,
    latitude: 43.27165,
    longitude: -83.80111,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48415',
  },
  {
    city: 'Brown City',
    county_fips: 26151,
    county_fips_all: '26151|26087|26147',
    county: 'Sanilac',
    county_names_all: 'Sanilac|Lapeer|St. Clair',
    county_weights: '{"26151": 53.72, "26087": 40.42, "26147": 5.86}',
    density: 17,
    imprecise: false,
    latitude: 43.21791,
    longitude: -82.98476,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48416',
  },
  {
    city: 'Burt',
    county_fips: 26145,
    county_fips_all: '26145',
    county: 'Saginaw',
    county_names_all: 'Saginaw',
    county_weights: '{"26145": 100}',
    density: 37,
    imprecise: false,
    latitude: 43.25998,
    longitude: -83.93686,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48417',
  },
  {
    city: 'Byron',
    county_fips: 26155,
    county_fips_all: '26155|26049|26093',
    county: 'Shiawassee',
    county_names_all: 'Shiawassee|Genesee|Livingston',
    county_weights: '{"26155": 65.8, "26049": 25.22, "26093": 8.98}',
    density: 42.3,
    imprecise: false,
    latitude: 42.80427,
    longitude: -83.97066,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48418',
  },
  {
    city: 'Carsonville',
    county_fips: 26151,
    county_fips_all: '26151',
    county: 'Sanilac',
    county_names_all: 'Sanilac',
    county_weights: '{"26151": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 43.42884,
    longitude: -82.65762,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48419',
  },
  {
    city: 'Clio',
    county_fips: 26049,
    county_fips_all: '26049|26157|26145',
    county: 'Genesee',
    county_names_all: 'Genesee|Tuscola|Saginaw',
    county_weights: '{"26049": 96.24, "26157": 3.27, "26145": 0.49}',
    density: 123.2,
    imprecise: false,
    latitude: 43.17968,
    longitude: -83.71176,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48420',
  },
  {
    city: 'Columbiaville',
    county_fips: 26087,
    county_fips_all: '26087|26049',
    county: 'Lapeer',
    county_names_all: 'Lapeer|Genesee',
    county_weights: '{"26087": 95.12, "26049": 4.88}',
    density: 64.6,
    imprecise: false,
    latitude: 43.15321,
    longitude: -83.39262,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48421',
  },
  {
    city: 'Croswell',
    county_fips: 26151,
    county_fips_all: '26151',
    county: 'Sanilac',
    county_names_all: 'Sanilac',
    county_weights: '{"26151": 100}',
    density: 24.7,
    imprecise: false,
    latitude: 43.26265,
    longitude: -82.65069,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48422',
  },
  {
    city: 'Davison',
    county_fips: 26049,
    county_fips_all: '26049|26087',
    county: 'Genesee',
    county_names_all: 'Genesee|Lapeer',
    county_weights: '{"26049": 98.75, "26087": 1.25}',
    density: 202.2,
    imprecise: false,
    latitude: 43.03982,
    longitude: -83.51404,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 33757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48423',
  },
  {
    city: 'Decker',
    county_fips: 26151,
    county_fips_all: '26151',
    county: 'Sanilac',
    county_names_all: 'Sanilac',
    county_weights: '{"26151": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 43.50856,
    longitude: -83.06025,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48426',
  },
  {
    city: 'Deckerville',
    county_fips: 26151,
    county_fips_all: '26151',
    county: 'Sanilac',
    county_names_all: 'Sanilac',
    county_weights: '{"26151": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 43.53789,
    longitude: -82.72378,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48427',
  },
  {
    city: 'Dryden',
    county_fips: 26087,
    county_fips_all: '26087|26125',
    county: 'Lapeer',
    county_names_all: 'Lapeer|Oakland',
    county_weights: '{"26087": 98.71, "26125": 1.29}',
    density: 60.2,
    imprecise: false,
    latitude: 42.93752,
    longitude: -83.14756,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48428',
  },
  {
    city: 'Durand',
    county_fips: 26155,
    county_fips_all: '26155|26049',
    county: 'Shiawassee',
    county_names_all: 'Shiawassee|Genesee',
    county_weights: '{"26155": 96.78, "26049": 3.22}',
    density: 59.8,
    imprecise: false,
    latitude: 42.90774,
    longitude: -84.00544,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48429',
  },
  {
    city: 'Fenton',
    county_fips: 26093,
    county_fips_all: '26093|26049|26125',
    county: 'Livingston',
    county_names_all: 'Livingston|Genesee|Oakland',
    county_weights: '{"26093": 65.68, "26049": 24.42, "26125": 9.9}',
    density: 182.5,
    imprecise: false,
    latitude: 42.75752,
    longitude: -83.74208,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 39309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48430',
  },
  {
    city: 'Filion',
    county_fips: 26063,
    county_fips_all: '26063',
    county: 'Huron',
    county_names_all: 'Huron',
    county_weights: '{"26063": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 43.90013,
    longitude: -82.97923,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48432',
  },
  {
    city: 'Flushing',
    county_fips: 26049,
    county_fips_all: '26049|26155',
    county: 'Genesee',
    county_names_all: 'Genesee|Shiawassee',
    county_weights: '{"26049": 96.18, "26155": 3.82}',
    density: 183.4,
    imprecise: false,
    latitude: 43.07632,
    longitude: -83.8661,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 26384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48433',
  },
  {
    city: 'Forestville',
    county_fips: 26151,
    county_fips_all: '26151',
    county: 'Sanilac',
    county_names_all: 'Sanilac',
    county_weights: '{"26151": 100}',
    density: 66.1,
    imprecise: false,
    latitude: 43.65988,
    longitude: -82.61263,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48434',
  },
  {
    city: 'Fostoria',
    county_fips: 26087,
    county_fips_all: '26087|26157',
    county: 'Lapeer',
    county_names_all: 'Lapeer|Tuscola',
    county_weights: '{"26087": 50.12, "26157": 49.88}',
    density: 37.7,
    imprecise: false,
    latitude: 43.24863,
    longitude: -83.3598,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48435',
  },
  {
    city: 'Gaines',
    county_fips: 26049,
    county_fips_all: '26049|26155',
    county: 'Genesee',
    county_names_all: 'Genesee|Shiawassee',
    county_weights: '{"26049": 90.5, "26155": 9.5}',
    density: 48.9,
    imprecise: false,
    latitude: 42.87017,
    longitude: -83.87704,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48436',
  },
  {
    city: 'Genesee',
    county_fips: 26049,
    county_fips_all: '26049',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"26049": 100}',
    density: 186.3,
    imprecise: false,
    latitude: 43.11248,
    longitude: -83.61893,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48437',
  },
  {
    city: 'Goodrich',
    county_fips: 26049,
    county_fips_all: '26049|26087',
    county: 'Genesee',
    county_names_all: 'Genesee|Lapeer',
    county_weights: '{"26049": 71.42, "26087": 28.58}',
    density: 91.9,
    imprecise: false,
    latitude: 42.91142,
    longitude: -83.47819,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48438',
  },
  {
    city: 'Grand Blanc',
    county_fips: 26049,
    county_fips_all: '26049|26125',
    county: 'Genesee',
    county_names_all: 'Genesee|Oakland',
    county_weights: '{"26049": 98.68, "26125": 1.32}',
    density: 367.7,
    imprecise: false,
    latitude: 42.91733,
    longitude: -83.63018,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 51900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48439',
  },
  {
    city: 'Hadley',
    county_fips: 26087,
    county_fips_all: '26087',
    county: 'Lapeer',
    county_names_all: 'Lapeer',
    county_weights: '{"26087": 100}',
    density: 215.4,
    imprecise: false,
    latitude: 42.95567,
    longitude: -83.40785,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48440',
  },
  {
    city: 'Harbor Beach',
    county_fips: 26063,
    county_fips_all: '26063|26151',
    county: 'Huron',
    county_names_all: 'Huron|Sanilac',
    county_weights: '{"26063": 98.25, "26151": 1.75}',
    density: 13.9,
    imprecise: false,
    latitude: 43.80515,
    longitude: -82.71727,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48441',
  },
  {
    city: 'Holly',
    county_fips: 26125,
    county_fips_all: '26125|26049|26093',
    county: 'Oakland',
    county_names_all: 'Oakland|Genesee|Livingston',
    county_weights: '{"26125": 95.98, "26049": 2.91, "26093": 1.11}',
    density: 102.5,
    imprecise: false,
    latitude: 42.79316,
    longitude: -83.60224,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 22788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48442',
  },
  {
    city: 'Imlay City',
    county_fips: 26087,
    county_fips_all: '26087|26147',
    county: 'Lapeer',
    county_names_all: 'Lapeer|St. Clair',
    county_weights: '{"26087": 93.56, "26147": 6.44}',
    density: 44.9,
    imprecise: false,
    latitude: 43.06455,
    longitude: -83.05471,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48444',
  },
  {
    city: 'Kinde',
    county_fips: 26063,
    county_fips_all: '26063',
    county: 'Huron',
    county_names_all: 'Huron',
    county_weights: '{"26063": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 43.95243,
    longitude: -82.98769,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48445',
  },
  {
    city: 'Lapeer',
    county_fips: 26087,
    county_fips_all: '26087',
    county: 'Lapeer',
    county_names_all: 'Lapeer',
    county_weights: '{"26087": 100}',
    density: 96.9,
    imprecise: false,
    latitude: 43.05259,
    longitude: -83.33745,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 30581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48446',
  },
  {
    city: 'Lennon',
    county_fips: 26155,
    county_fips_all: '26155|26049',
    county: 'Shiawassee',
    county_names_all: 'Shiawassee|Genesee',
    county_weights: '{"26155": 72.57, "26049": 27.43}',
    density: 42.8,
    imprecise: false,
    latitude: 42.99518,
    longitude: -83.94552,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48449',
  },
  {
    city: 'Lexington',
    county_fips: 26151,
    county_fips_all: '26151',
    county: 'Sanilac',
    county_names_all: 'Sanilac',
    county_weights: '{"26151": 100}',
    density: 76.3,
    imprecise: false,
    latitude: 43.25289,
    longitude: -82.54123,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48450',
  },
  {
    city: 'Linden',
    county_fips: 26049,
    county_fips_all: '26049|26093',
    county: 'Genesee',
    county_names_all: 'Genesee|Livingston',
    county_weights: '{"26049": 74.72, "26093": 25.28}',
    density: 182.5,
    imprecise: false,
    latitude: 42.80365,
    longitude: -83.81683,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 16097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48451',
  },
  {
    city: 'Marlette',
    county_fips: 26151,
    county_fips_all: '26151|26087|26157',
    county: 'Sanilac',
    county_names_all: 'Sanilac|Lapeer|Tuscola',
    county_weights: '{"26151": 82.58, "26087": 11.79, "26157": 5.63}',
    density: 18.2,
    imprecise: false,
    latitude: 43.34374,
    longitude: -83.03493,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48453',
  },
  {
    city: 'Melvin',
    county_fips: 26151,
    county_fips_all: '26151',
    county: 'Sanilac',
    county_names_all: 'Sanilac',
    county_weights: '{"26151": 100}',
    density: 15,
    imprecise: false,
    latitude: 43.19999,
    longitude: -82.81833,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48454',
  },
  {
    city: 'Metamora',
    county_fips: 26087,
    county_fips_all: '26087',
    county: 'Lapeer',
    county_names_all: 'Lapeer',
    county_weights: '{"26087": 100}',
    density: 51,
    imprecise: false,
    latitude: 42.94028,
    longitude: -83.29131,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48455',
  },
  {
    city: 'Minden City',
    county_fips: 26151,
    county_fips_all: '26151|26063',
    county: 'Sanilac',
    county_names_all: 'Sanilac|Huron',
    county_weights: '{"26151": 79.83, "26063": 20.17}',
    density: 6.8,
    imprecise: false,
    latitude: 43.67102,
    longitude: -82.75818,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48456',
  },
  {
    city: 'Montrose',
    county_fips: 26049,
    county_fips_all: '26049|26145',
    county: 'Genesee',
    county_names_all: 'Genesee|Saginaw',
    county_weights: '{"26049": 72.06, "26145": 27.94}',
    density: 78.8,
    imprecise: false,
    latitude: 43.19018,
    longitude: -83.89306,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48457',
  },
  {
    city: 'Mount Morris',
    county_fips: 26049,
    county_fips_all: '26049',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"26049": 100}',
    density: 210.8,
    imprecise: false,
    latitude: 43.1209,
    longitude: -83.68308,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 19519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48458',
  },
  {
    city: 'New Lothrop',
    county_fips: 26155,
    county_fips_all: '26155|26145|26049',
    county: 'Shiawassee',
    county_names_all: 'Shiawassee|Saginaw|Genesee',
    county_weights: '{"26155": 58.92, "26145": 40.78, "26049": 0.3}',
    density: 30.2,
    imprecise: false,
    latitude: 43.12734,
    longitude: -83.98586,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48460',
  },
  {
    city: 'North Branch',
    county_fips: 26087,
    county_fips_all: '26087',
    county: 'Lapeer',
    county_names_all: 'Lapeer',
    county_weights: '{"26087": 100}',
    density: 36.6,
    imprecise: false,
    latitude: 43.2024,
    longitude: -83.20669,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48461',
  },
  {
    city: 'Ortonville',
    county_fips: 26125,
    county_fips_all: '26125|26087|26049',
    county: 'Oakland',
    county_names_all: 'Oakland|Lapeer|Genesee',
    county_weights: '{"26125": 90.92, "26087": 8.67, "26049": 0.41}',
    density: 112.8,
    imprecise: false,
    latitude: 42.84733,
    longitude: -83.42576,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 13279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48462',
  },
  {
    city: 'Otisville',
    county_fips: 26049,
    county_fips_all: '26049|26087',
    county: 'Genesee',
    county_names_all: 'Genesee|Lapeer',
    county_weights: '{"26049": 99.76, "26087": 0.24}',
    density: 50.9,
    imprecise: false,
    latitude: 43.16418,
    longitude: -83.52202,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48463',
  },
  {
    city: 'Otter Lake',
    county_fips: 26087,
    county_fips_all: '26087|26157|26049',
    county: 'Lapeer',
    county_names_all: 'Lapeer|Tuscola|Genesee',
    county_weights: '{"26087": 79.77, "26157": 13.05, "26049": 7.18}',
    density: 48.8,
    imprecise: false,
    latitude: 43.21562,
    longitude: -83.41884,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48464',
  },
  {
    city: 'Palms',
    county_fips: 26151,
    county_fips_all: '26151',
    county: 'Sanilac',
    county_names_all: 'Sanilac',
    county_weights: '{"26151": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 43.61485,
    longitude: -82.71099,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48465',
  },
  {
    city: 'Peck',
    county_fips: 26151,
    county_fips_all: '26151',
    county: 'Sanilac',
    county_names_all: 'Sanilac',
    county_weights: '{"26151": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 43.27693,
    longitude: -82.81731,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48466',
  },
  {
    city: 'Port Austin',
    county_fips: 26063,
    county_fips_all: '26063',
    county: 'Huron',
    county_names_all: 'Huron',
    county_weights: '{"26063": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 44.00768,
    longitude: -82.98763,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48467',
  },
  {
    city: 'Port Hope',
    county_fips: 26063,
    county_fips_all: '26063',
    county: 'Huron',
    county_names_all: 'Huron',
    county_weights: '{"26063": 100}',
    density: 8,
    imprecise: false,
    latitude: 43.94113,
    longitude: -82.79021,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48468',
  },
  {
    city: 'Port Sanilac',
    county_fips: 26151,
    county_fips_all: '26151',
    county: 'Sanilac',
    county_names_all: 'Sanilac',
    county_weights: '{"26151": 100}',
    density: 68,
    imprecise: false,
    latitude: 43.43927,
    longitude: -82.55849,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48469',
  },
  {
    city: 'Ruth',
    county_fips: 26063,
    county_fips_all: '26063|26151',
    county: 'Huron',
    county_names_all: 'Huron|Sanilac',
    county_weights: '{"26063": 99.52, "26151": 0.48}',
    density: 5.7,
    imprecise: false,
    latitude: 43.73253,
    longitude: -82.76158,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48470',
  },
  {
    city: 'Sandusky',
    county_fips: 26151,
    county_fips_all: '26151',
    county: 'Sanilac',
    county_names_all: 'Sanilac',
    county_weights: '{"26151": 100}',
    density: 20.7,
    imprecise: false,
    latitude: 43.41868,
    longitude: -82.85369,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48471',
  },
  {
    city: 'Snover',
    county_fips: 26151,
    county_fips_all: '26151',
    county: 'Sanilac',
    county_names_all: 'Sanilac',
    county_weights: '{"26151": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 43.51211,
    longitude: -82.95732,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48472',
  },
  {
    city: 'Swartz Creek',
    county_fips: 26049,
    county_fips_all: '26049',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"26049": 100}',
    density: 153.4,
    imprecise: false,
    latitude: 42.94012,
    longitude: -83.8274,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 22339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48473',
  },
  {
    city: 'Ubly',
    county_fips: 26151,
    county_fips_all: '26151|26063',
    county: 'Sanilac',
    county_names_all: 'Sanilac|Huron',
    county_weights: '{"26151": 53.98, "26063": 46.02}',
    density: 8,
    imprecise: false,
    latitude: 43.67141,
    longitude: -82.93732,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48475',
  },
  {
    city: 'Vernon',
    county_fips: 26155,
    county_fips_all: '26155',
    county: 'Shiawassee',
    county_names_all: 'Shiawassee',
    county_weights: '{"26155": 100}',
    density: 389.6,
    imprecise: false,
    latitude: 42.93765,
    longitude: -84.03319,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48476',
  },
  {
    city: 'Flint',
    county_fips: 26049,
    county_fips_all: '26049',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"26049": 100}',
    density: 1197.7,
    imprecise: false,
    latitude: 43.01429,
    longitude: -83.68866,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48502',
  },
  {
    city: 'Flint',
    county_fips: 26049,
    county_fips_all: '26049',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"26049": 100}',
    density: 1020.4,
    imprecise: false,
    latitude: 43.01139,
    longitude: -83.68901,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 22347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48503',
  },
  {
    city: 'Flint',
    county_fips: 26049,
    county_fips_all: '26049',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"26049": 100}',
    density: 635.2,
    imprecise: false,
    latitude: 43.05632,
    longitude: -83.74948,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 24218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48504',
  },
  {
    city: 'Flint',
    county_fips: 26049,
    county_fips_all: '26049',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"26049": 100}',
    density: 558.2,
    imprecise: false,
    latitude: 43.06948,
    longitude: -83.69079,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48505',
  },
  {
    city: 'Flint',
    county_fips: 26049,
    county_fips_all: '26049',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"26049": 100}',
    density: 515.9,
    imprecise: false,
    latitude: 43.06775,
    longitude: -83.62253,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 24712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48506',
  },
  {
    city: 'Flint',
    county_fips: 26049,
    county_fips_all: '26049',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"26049": 100}',
    density: 502.6,
    imprecise: false,
    latitude: 42.96498,
    longitude: -83.71687,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 28723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48507',
  },
  {
    city: 'Burton',
    county_fips: 26049,
    county_fips_all: '26049',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"26049": 100}',
    density: 379.6,
    imprecise: false,
    latitude: 43.02635,
    longitude: -83.60527,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48509',
  },
  {
    city: 'Burton',
    county_fips: 26049,
    county_fips_all: '26049',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"26049": 100}',
    density: 398.6,
    imprecise: false,
    latitude: 42.98772,
    longitude: -83.60701,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48519',
  },
  {
    city: 'Burton',
    county_fips: 26049,
    county_fips_all: '26049',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"26049": 100}',
    density: 750.5,
    imprecise: false,
    latitude: 42.97237,
    longitude: -83.66221,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48529',
  },
  {
    city: 'Flint',
    county_fips: 26049,
    county_fips_all: '26049',
    county: 'Genesee',
    county_names_all: 'Genesee',
    county_weights: '{"26049": 100}',
    density: 447.6,
    imprecise: false,
    latitude: 43.01203,
    longitude: -83.79429,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48532',
  },
  {
    city: 'Saginaw',
    county_fips: 26145,
    county_fips_all: '26145',
    county: 'Saginaw',
    county_names_all: 'Saginaw',
    county_weights: '{"26145": 100}',
    density: 116.9,
    imprecise: false,
    latitude: 43.40096,
    longitude: -83.8952,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 31601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48601',
  },
  {
    city: 'Saginaw',
    county_fips: 26145,
    county_fips_all: '26145',
    county: 'Saginaw',
    county_names_all: 'Saginaw',
    county_weights: '{"26145": 100}',
    density: 1340.1,
    imprecise: false,
    latitude: 43.41971,
    longitude: -83.97469,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 27127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48602',
  },
  {
    city: 'Saginaw',
    county_fips: 26145,
    county_fips_all: '26145',
    county: 'Saginaw',
    county_names_all: 'Saginaw',
    county_weights: '{"26145": 100}',
    density: 588.1,
    imprecise: false,
    latitude: 43.46332,
    longitude: -84.03115,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 27757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48603',
  },
  {
    city: 'Saginaw',
    county_fips: 26145,
    county_fips_all: '26145|26017',
    county: 'Saginaw',
    county_names_all: 'Saginaw|Bay',
    county_weights: '{"26145": 91.25, "26017": 8.75}',
    density: 161.9,
    imprecise: false,
    latitude: 43.49749,
    longitude: -83.95887,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48604',
  },
  {
    city: 'Saginaw',
    county_fips: 26145,
    county_fips_all: '26145',
    county: 'Saginaw',
    county_names_all: 'Saginaw',
    county_weights: '{"26145": 100}',
    density: 654.7,
    imprecise: false,
    latitude: 43.43136,
    longitude: -83.93409,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48607',
  },
  {
    city: 'Saginaw',
    county_fips: 26145,
    county_fips_all: '26145',
    county: 'Saginaw',
    county_names_all: 'Saginaw',
    county_weights: '{"26145": 100}',
    density: 103,
    imprecise: false,
    latitude: 43.3878,
    longitude: -84.08786,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48609',
  },
  {
    city: 'Alger',
    county_fips: 26051,
    county_fips_all: '26051|26011|26129',
    county: 'Gladwin',
    county_names_all: 'Gladwin|Arenac|Ogemaw',
    county_weights: '{"26051": 48.38, "26011": 26.23, "26129": 25.39}',
    density: 10.1,
    imprecise: false,
    latitude: 44.12789,
    longitude: -84.1801,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48610',
  },
  {
    city: 'Auburn',
    county_fips: 26017,
    county_fips_all: '26017',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"26017": 100}',
    density: 61.6,
    imprecise: false,
    latitude: 43.63187,
    longitude: -84.0936,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48611',
  },
  {
    city: 'Beaverton',
    county_fips: 26051,
    county_fips_all: '26051|26035|26111',
    county: 'Gladwin',
    county_names_all: 'Gladwin|Clare|Midland',
    county_weights: '{"26051": 96.56, "26035": 2.28, "26111": 1.16}',
    density: 26.8,
    imprecise: false,
    latitude: 43.88001,
    longitude: -84.43637,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48612',
  },
  {
    city: 'Bentley',
    county_fips: 26017,
    county_fips_all: '26017|26051',
    county: 'Bay',
    county_names_all: 'Bay|Gladwin',
    county_weights: '{"26017": 58.17, "26051": 41.83}',
    density: 8.3,
    imprecise: false,
    latitude: 43.94355,
    longitude: -84.15791,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48613',
  },
  {
    city: 'Brant',
    county_fips: 26145,
    county_fips_all: '26145|26057',
    county: 'Saginaw',
    county_names_all: 'Saginaw|Gratiot',
    county_weights: '{"26145": 94.94, "26057": 5.06}',
    density: 10.3,
    imprecise: false,
    latitude: 43.25084,
    longitude: -84.30147,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48614',
  },
  {
    city: 'Breckenridge',
    county_fips: 26057,
    county_fips_all: '26057|26111',
    county: 'Gratiot',
    county_names_all: 'Gratiot|Midland',
    county_weights: '{"26057": 67.67, "26111": 32.33}',
    density: 21.4,
    imprecise: false,
    latitude: 43.42671,
    longitude: -84.47326,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48615',
  },
  {
    city: 'Chesaning',
    county_fips: 26145,
    county_fips_all: '26145|26155',
    county: 'Saginaw',
    county_names_all: 'Saginaw|Shiawassee',
    county_weights: '{"26145": 98.32, "26155": 1.68}',
    density: 36.1,
    imprecise: false,
    latitude: 43.19336,
    longitude: -84.11311,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48616',
  },
  {
    city: 'Clare',
    county_fips: 26035,
    county_fips_all: '26035|26073',
    county: 'Clare',
    county_names_all: 'Clare|Isabella',
    county_weights: '{"26035": 64.86, "26073": 35.14}',
    density: 26.4,
    imprecise: false,
    latitude: 43.84695,
    longitude: -84.71717,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48617',
  },
  {
    city: 'Coleman',
    county_fips: 26111,
    county_fips_all: '26111|26073|26051',
    county: 'Midland',
    county_names_all: 'Midland|Isabella|Gladwin',
    county_weights: '{"26111": 76.61, "26073": 21.26, "26051": 2.13}',
    density: 19.6,
    imprecise: false,
    latitude: 43.73602,
    longitude: -84.5584,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48618',
  },
  {
    city: 'Comins',
    county_fips: 26135,
    county_fips_all: '26135|26119',
    county: 'Oscoda',
    county_names_all: 'Oscoda|Montmorency',
    county_weights: '{"26135": 81.46, "26119": 18.54}',
    density: 2.1,
    imprecise: false,
    latitude: 44.82224,
    longitude: -84.01996,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48619',
  },
  {
    city: 'Edenville',
    county_fips: 26111,
    county_fips_all: '26111',
    county: 'Midland',
    county_names_all: 'Midland',
    county_weights: '{"26111": 100}',
    density: 99.2,
    imprecise: false,
    latitude: 43.80865,
    longitude: -84.37805,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48620',
  },
  {
    city: 'Fairview',
    county_fips: 26135,
    county_fips_all: '26135',
    county: 'Oscoda',
    county_names_all: 'Oscoda',
    county_weights: '{"26135": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 44.72064,
    longitude: -83.99408,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48621',
  },
  {
    city: 'Farwell',
    county_fips: 26035,
    county_fips_all: '26035|26073',
    county: 'Clare',
    county_names_all: 'Clare|Isabella',
    county_weights: '{"26035": 63.86, "26073": 36.14}',
    density: 28.4,
    imprecise: false,
    latitude: 43.83304,
    longitude: -84.884,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48622',
  },
  {
    city: 'Freeland',
    county_fips: 26145,
    county_fips_all: '26145|26111|26017',
    county: 'Saginaw',
    county_names_all: 'Saginaw|Midland|Bay',
    county_weights: '{"26145": 63.88, "26111": 23.89, "26017": 12.23}',
    density: 80.2,
    imprecise: false,
    latitude: 43.5198,
    longitude: -84.13523,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 15129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48623',
  },
  {
    city: 'Gladwin',
    county_fips: 26051,
    county_fips_all: '26051|26143|26035|26129',
    county: 'Gladwin',
    county_names_all: 'Gladwin|Roscommon|Clare|Ogemaw',
    county_weights:
      '{"26051": 76.8, "26143": 11.97, "26035": 10.12, "26129": 1.11}',
    density: 18.4,
    imprecise: false,
    latitude: 44.05919,
    longitude: -84.45859,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 16234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48624',
  },
  {
    city: 'Harrison',
    county_fips: 26035,
    county_fips_all: '26035',
    county: 'Clare',
    county_names_all: 'Clare',
    county_weights: '{"26035": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 44.04976,
    longitude: -84.8345,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 12704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48625',
  },
  {
    city: 'Hemlock',
    county_fips: 26145,
    county_fips_all: '26145|26111',
    county: 'Saginaw',
    county_names_all: 'Saginaw|Midland',
    county_weights: '{"26145": 87.85, "26111": 12.15}',
    density: 34,
    imprecise: false,
    latitude: 43.4218,
    longitude: -84.22686,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48626',
  },
  {
    city: 'Higgins Lake',
    county_fips: 26143,
    county_fips_all: '26143',
    county: 'Roscommon',
    county_names_all: 'Roscommon',
    county_weights: '{"26143": 100}',
    density: 121.3,
    imprecise: false,
    latitude: 44.46177,
    longitude: -84.74869,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48627',
  },
  {
    city: 'Hope',
    county_fips: 26111,
    county_fips_all: '26111|26051',
    county: 'Midland',
    county_names_all: 'Midland|Gladwin',
    county_weights: '{"26111": 90.65, "26051": 9.35}',
    density: 23.5,
    imprecise: false,
    latitude: 43.78166,
    longitude: -84.32856,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48628',
  },
  {
    city: 'Houghton Lake',
    county_fips: 26143,
    county_fips_all: '26143|26113',
    county: 'Roscommon',
    county_names_all: 'Roscommon|Missaukee',
    county_weights: '{"26143": 99.85, "26113": 0.15}',
    density: 39.9,
    imprecise: false,
    latitude: 44.3107,
    longitude: -84.77977,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48629',
  },
  {
    city: 'Houghton Lake Heights',
    county_fips: 26143,
    county_fips_all: '26143',
    county: 'Roscommon',
    county_names_all: 'Roscommon',
    county_weights: '{"26143": 100}',
    density: 124.1,
    imprecise: false,
    latitude: 44.32532,
    longitude: -84.773,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48630',
  },
  {
    city: 'Kawkawlin',
    county_fips: 26017,
    county_fips_all: '26017',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"26017": 100}',
    density: 43.1,
    imprecise: false,
    latitude: 43.6849,
    longitude: -84.00155,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48631',
  },
  {
    city: 'Lake',
    county_fips: 26035,
    county_fips_all: '26035|26073|26133|26107',
    county: 'Clare',
    county_names_all: 'Clare|Isabella|Osceola|Mecosta',
    county_weights:
      '{"26035": 64.29, "26073": 30.9, "26133": 4.45, "26107": 0.36}',
    density: 16.5,
    imprecise: false,
    latitude: 43.85597,
    longitude: -85.01954,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48632',
  },
  {
    city: 'Lake George',
    county_fips: 26035,
    county_fips_all: '26035',
    county: 'Clare',
    county_names_all: 'Clare',
    county_weights: '{"26035": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 43.94827,
    longitude: -84.93409,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 95,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48633',
  },
  {
    city: 'Linwood',
    county_fips: 26017,
    county_fips_all: '26017',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"26017": 100}',
    density: 34.2,
    imprecise: false,
    latitude: 43.75405,
    longitude: -84.05414,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48634',
  },
  {
    city: 'Lupton',
    county_fips: 26129,
    county_fips_all: '26129',
    county: 'Ogemaw',
    county_names_all: 'Ogemaw',
    county_weights: '{"26129": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 44.39575,
    longitude: -83.99699,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48635',
  },
  {
    city: 'Luzerne',
    county_fips: 26135,
    county_fips_all: '26135',
    county: 'Oscoda',
    county_names_all: 'Oscoda',
    county_weights: '{"26135": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 44.58871,
    longitude: -84.28569,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48636',
  },
  {
    city: 'Merrill',
    county_fips: 26145,
    county_fips_all: '26145|26111|26057',
    county: 'Saginaw',
    county_names_all: 'Saginaw|Midland|Gratiot',
    county_weights: '{"26145": 68.89, "26111": 18.9, "26057": 12.21}',
    density: 16.5,
    imprecise: false,
    latitude: 43.41499,
    longitude: -84.33646,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48637',
  },
  {
    city: 'Saginaw',
    county_fips: 26145,
    county_fips_all: '26145',
    county: 'Saginaw',
    county_names_all: 'Saginaw',
    county_weights: '{"26145": 100}',
    density: 759.8,
    imprecise: false,
    latitude: 43.41681,
    longitude: -84.01958,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 12875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48638',
  },
  {
    city: 'Midland',
    county_fips: 26111,
    county_fips_all: '26111',
    county: 'Midland',
    county_names_all: 'Midland',
    county_weights: '{"26111": 100}',
    density: 119.4,
    imprecise: false,
    latitude: 43.58394,
    longitude: -84.33648,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 32492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48640',
  },
  {
    city: 'Midland',
    county_fips: 26111,
    county_fips_all: '26111|26017',
    county: 'Midland',
    county_names_all: 'Midland|Bay',
    county_weights: '{"26111": 84.03, "26017": 15.97}',
    density: 125.5,
    imprecise: false,
    latitude: 43.69945,
    longitude: -84.22849,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 34039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48642',
  },
  {
    city: 'Mio',
    county_fips: 26135,
    county_fips_all: '26135|26001',
    county: 'Oscoda',
    county_names_all: 'Oscoda|Alcona',
    county_weights: '{"26135": 97.07, "26001": 2.93}',
    density: 9.2,
    imprecise: false,
    latitude: 44.65309,
    longitude: -84.08148,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48647',
  },
  {
    city: 'Oakley',
    county_fips: 26145,
    county_fips_all: '26145|26155',
    county: 'Saginaw',
    county_names_all: 'Saginaw|Shiawassee',
    county_weights: '{"26145": 94.21, "26155": 5.79}',
    density: 23.9,
    imprecise: false,
    latitude: 43.15695,
    longitude: -84.21709,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48649',
  },
  {
    city: 'Pinconning',
    county_fips: 26017,
    county_fips_all: '26017|26011',
    county: 'Bay',
    county_names_all: 'Bay|Arenac',
    county_weights: '{"26017": 93.56, "26011": 6.44}',
    density: 26.4,
    imprecise: false,
    latitude: 43.85181,
    longitude: -84.01746,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48650',
  },
  {
    city: 'Prudenville',
    county_fips: 26143,
    county_fips_all: '26143',
    county: 'Roscommon',
    county_names_all: 'Roscommon',
    county_weights: '{"26143": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 44.25057,
    longitude: -84.61687,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48651',
  },
  {
    city: 'Rhodes',
    county_fips: 26051,
    county_fips_all: '26051|26017|26111',
    county: 'Gladwin',
    county_names_all: 'Gladwin|Bay|Midland',
    county_weights: '{"26051": 55.81, "26017": 22.34, "26111": 21.85}',
    density: 11.9,
    imprecise: false,
    latitude: 43.84834,
    longitude: -84.20716,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48652',
  },
  {
    city: 'Roscommon',
    county_fips: 26143,
    county_fips_all: '26143|26039',
    county: 'Roscommon',
    county_names_all: 'Roscommon|Crawford',
    county_weights: '{"26143": 61.16, "26039": 38.84}',
    density: 15.5,
    imprecise: false,
    latitude: 44.48936,
    longitude: -84.60624,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48653',
  },
  {
    city: 'Rose City',
    county_fips: 26129,
    county_fips_all: '26129|26135',
    county: 'Ogemaw',
    county_names_all: 'Ogemaw|Oscoda',
    county_weights: '{"26129": 76.86, "26135": 23.14}',
    density: 9.4,
    imprecise: false,
    latitude: 44.45468,
    longitude: -84.12627,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48654',
  },
  {
    city: 'Saint Charles',
    county_fips: 26145,
    county_fips_all: '26145',
    county: 'Saginaw',
    county_names_all: 'Saginaw',
    county_weights: '{"26145": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 43.29171,
    longitude: -84.15743,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48655',
  },
  {
    city: 'Saint Helen',
    county_fips: 26143,
    county_fips_all: '26143',
    county: 'Roscommon',
    county_names_all: 'Roscommon',
    county_weights: '{"26143": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 44.34953,
    longitude: -84.45801,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48656',
  },
  {
    city: 'Sanford',
    county_fips: 26111,
    county_fips_all: '26111',
    county: 'Midland',
    county_names_all: 'Midland',
    county_weights: '{"26111": 100}',
    density: 47.5,
    imprecise: false,
    latitude: 43.70945,
    longitude: -84.4213,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48657',
  },
  {
    city: 'Standish',
    county_fips: 26011,
    county_fips_all: '26011|26017',
    county: 'Arenac',
    county_names_all: 'Arenac|Bay',
    county_weights: '{"26011": 89.62, "26017": 10.38}',
    density: 22.3,
    imprecise: false,
    latitude: 43.98038,
    longitude: -83.94072,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48658',
  },
  {
    city: 'Sterling',
    county_fips: 26011,
    county_fips_all: '26011|26017',
    county: 'Arenac',
    county_names_all: 'Arenac|Bay',
    county_weights: '{"26011": 97.93, "26017": 2.07}',
    density: 13,
    imprecise: false,
    latitude: 44.06792,
    longitude: -84.05154,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48659',
  },
  {
    city: 'West Branch',
    county_fips: 26129,
    county_fips_all: '26129',
    county: 'Ogemaw',
    county_names_all: 'Ogemaw',
    county_weights: '{"26129": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 44.33005,
    longitude: -84.24087,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 10618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48661',
  },
  {
    city: 'Wheeler',
    county_fips: 26057,
    county_fips_all: '26057|26111',
    county: 'Gratiot',
    county_names_all: 'Gratiot|Midland',
    county_weights: '{"26057": 78.25, "26111": 21.75}',
    density: 9.1,
    imprecise: false,
    latitude: 43.40217,
    longitude: -84.40961,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48662',
  },
  {
    city: 'Akron',
    county_fips: 26157,
    county_fips_all: '26157',
    county: 'Tuscola',
    county_names_all: 'Tuscola',
    county_weights: '{"26157": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 43.5879,
    longitude: -83.54649,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48701',
  },
  {
    city: 'Au Gres',
    county_fips: 26011,
    county_fips_all: '26011',
    county: 'Arenac',
    county_names_all: 'Arenac',
    county_weights: '{"26011": 100}',
    density: 26.8,
    imprecise: false,
    latitude: 44.06766,
    longitude: -83.66904,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48703',
  },
  {
    city: 'Barton City',
    county_fips: 26001,
    county_fips_all: '26001',
    county: 'Alcona',
    county_names_all: 'Alcona',
    county_weights: '{"26001": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 44.68715,
    longitude: -83.65279,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48705',
  },
  {
    city: 'Bay City',
    county_fips: 26017,
    county_fips_all: '26017',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"26017": 100}',
    density: 227,
    imprecise: false,
    latitude: 43.59937,
    longitude: -83.95623,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 38974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48706',
  },
  {
    city: 'Bay City',
    county_fips: 26017,
    county_fips_all: '26017|26145',
    county: 'Bay',
    county_names_all: 'Bay|Saginaw',
    county_weights: '{"26017": 89.82, "26145": 10.18}',
    density: 340.7,
    imprecise: false,
    latitude: 43.55653,
    longitude: -83.84853,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 25635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48708',
  },
  {
    city: 'Bay Port',
    county_fips: 26063,
    county_fips_all: '26063',
    county: 'Huron',
    county_names_all: 'Huron',
    county_weights: '{"26063": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 43.8294,
    longitude: -83.34808,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48720',
  },
  {
    city: 'Black River',
    county_fips: 26001,
    county_fips_all: '26001',
    county: 'Alcona',
    county_names_all: 'Alcona',
    county_weights: '{"26001": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 44.80453,
    longitude: -83.3459,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48721',
  },
  {
    city: 'Bridgeport',
    county_fips: 26145,
    county_fips_all: '26145',
    county: 'Saginaw',
    county_names_all: 'Saginaw',
    county_weights: '{"26145": 100}',
    density: 69,
    imprecise: false,
    latitude: 43.34554,
    longitude: -83.83961,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48722',
  },
  {
    city: 'Caro',
    county_fips: 26157,
    county_fips_all: '26157',
    county: 'Tuscola',
    county_names_all: 'Tuscola',
    county_weights: '{"26157": 100}',
    density: 34.2,
    imprecise: false,
    latitude: 43.4861,
    longitude: -83.38499,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48723',
  },
  {
    city: 'Carrollton',
    county_fips: 26145,
    county_fips_all: '26145',
    county: 'Saginaw',
    county_names_all: 'Saginaw',
    county_weights: '{"26145": 100}',
    density: 947.5,
    imprecise: false,
    latitude: 43.4569,
    longitude: -83.92709,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48724',
  },
  {
    city: 'Caseville',
    county_fips: 26063,
    county_fips_all: '26063',
    county: 'Huron',
    county_names_all: 'Huron',
    county_weights: '{"26063": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 43.93763,
    longitude: -83.20596,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48725',
  },
  {
    city: 'Cass City',
    county_fips: 26157,
    county_fips_all: '26157|26151|26063',
    county: 'Tuscola',
    county_names_all: 'Tuscola|Sanilac|Huron',
    county_weights: '{"26157": 64.79, "26151": 26.26, "26063": 8.95}',
    density: 17.8,
    imprecise: false,
    latitude: 43.60776,
    longitude: -83.16833,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48726',
  },
  {
    city: 'Clifford',
    county_fips: 26087,
    county_fips_all: '26087|26157',
    county: 'Lapeer',
    county_names_all: 'Lapeer|Tuscola',
    county_weights: '{"26087": 73.03, "26157": 26.97}',
    density: 15.3,
    imprecise: false,
    latitude: 43.30695,
    longitude: -83.17935,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48727',
  },
  {
    city: 'Curran',
    county_fips: 26001,
    county_fips_all: '26001|26135',
    county: 'Alcona',
    county_names_all: 'Alcona|Oscoda',
    county_weights: '{"26001": 87.7, "26135": 12.3}',
    density: 1,
    imprecise: false,
    latitude: 44.74659,
    longitude: -83.82344,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48728',
  },
  {
    city: 'Deford',
    county_fips: 26157,
    county_fips_all: '26157',
    county: 'Tuscola',
    county_names_all: 'Tuscola',
    county_weights: '{"26157": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 43.49621,
    longitude: -83.17828,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48729',
  },
  {
    city: 'East Tawas',
    county_fips: 26069,
    county_fips_all: '26069',
    county: 'Iosco',
    county_names_all: 'Iosco',
    county_weights: '{"26069": 100}',
    density: 21.7,
    imprecise: false,
    latitude: 44.35443,
    longitude: -83.48804,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48730',
  },
  {
    city: 'Elkton',
    county_fips: 26063,
    county_fips_all: '26063',
    county: 'Huron',
    county_names_all: 'Huron',
    county_weights: '{"26063": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 43.83898,
    longitude: -83.15784,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48731',
  },
  {
    city: 'Essexville',
    county_fips: 26017,
    county_fips_all: '26017',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"26017": 100}',
    density: 177.9,
    imprecise: false,
    latitude: 43.60666,
    longitude: -83.78274,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48732',
  },
  {
    city: 'Fairgrove',
    county_fips: 26157,
    county_fips_all: '26157',
    county: 'Tuscola',
    county_names_all: 'Tuscola',
    county_weights: '{"26157": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 43.53306,
    longitude: -83.59029,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48733',
  },
  {
    city: 'Frankenmuth',
    county_fips: 26145,
    county_fips_all: '26145|26157',
    county: 'Saginaw',
    county_names_all: 'Saginaw|Tuscola',
    county_weights: '{"26145": 89.72, "26157": 10.28}',
    density: 75.1,
    imprecise: false,
    latitude: 43.35519,
    longitude: -83.74321,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48734',
  },
  {
    city: 'Gagetown',
    county_fips: 26157,
    county_fips_all: '26157|26063',
    county: 'Tuscola',
    county_names_all: 'Tuscola|Huron',
    county_weights: '{"26157": 53.43, "26063": 46.57}',
    density: 10,
    imprecise: false,
    latitude: 43.66861,
    longitude: -83.27294,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48735',
  },
  {
    city: 'Glennie',
    county_fips: 26001,
    county_fips_all: '26001|26069',
    county: 'Alcona',
    county_names_all: 'Alcona|Iosco',
    county_weights: '{"26001": 72.41, "26069": 27.59}',
    density: 3.9,
    imprecise: false,
    latitude: 44.54588,
    longitude: -83.70871,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48737',
  },
  {
    city: 'Greenbush',
    county_fips: 26001,
    county_fips_all: '26001|26069',
    county: 'Alcona',
    county_names_all: 'Alcona|Iosco',
    county_weights: '{"26001": 96.26, "26069": 3.74}',
    density: 34.7,
    imprecise: false,
    latitude: 44.54995,
    longitude: -83.33786,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48738',
  },
  {
    city: 'Hale',
    county_fips: 26069,
    county_fips_all: '26069|26129',
    county: 'Iosco',
    county_names_all: 'Iosco|Ogemaw',
    county_weights: '{"26069": 70.54, "26129": 29.46}',
    density: 14.6,
    imprecise: false,
    latitude: 44.37597,
    longitude: -83.83238,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48739',
  },
  {
    city: 'Harrisville',
    county_fips: 26001,
    county_fips_all: '26001',
    county: 'Alcona',
    county_names_all: 'Alcona',
    county_weights: '{"26001": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 44.66014,
    longitude: -83.37873,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48740',
  },
  {
    city: 'Kingston',
    county_fips: 26157,
    county_fips_all: '26157',
    county: 'Tuscola',
    county_names_all: 'Tuscola',
    county_weights: '{"26157": 100}',
    density: 18,
    imprecise: false,
    latitude: 43.40487,
    longitude: -83.18121,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48741',
  },
  {
    city: 'Lincoln',
    county_fips: 26001,
    county_fips_all: '26001',
    county: 'Alcona',
    county_names_all: 'Alcona',
    county_weights: '{"26001": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 44.71934,
    longitude: -83.44542,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48742',
  },
  {
    city: 'Long Lake',
    county_fips: 26069,
    county_fips_all: '26069',
    county: 'Iosco',
    county_names_all: 'Iosco',
    county_weights: '{"26069": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 44.44025,
    longitude: -83.87066,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48743',
  },
  {
    city: 'Mayville',
    county_fips: 26157,
    county_fips_all: '26157|26087',
    county: 'Tuscola',
    county_names_all: 'Tuscola|Lapeer',
    county_weights: '{"26157": 84.2, "26087": 15.8}',
    density: 26.5,
    imprecise: false,
    latitude: 43.34797,
    longitude: -83.36051,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48744',
  },
  {
    city: 'Mikado',
    county_fips: 26001,
    county_fips_all: '26001|26069',
    county: 'Alcona',
    county_names_all: 'Alcona|Iosco',
    county_weights: '{"26001": 97.25, "26069": 2.75}',
    density: 6.9,
    imprecise: false,
    latitude: 44.57059,
    longitude: -83.47425,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48745',
  },
  {
    city: 'Millington',
    county_fips: 26157,
    county_fips_all: '26157|26049',
    county: 'Tuscola',
    county_names_all: 'Tuscola|Genesee',
    county_weights: '{"26157": 89.48, "26049": 10.52}',
    density: 38.6,
    imprecise: false,
    latitude: 43.26397,
    longitude: -83.54155,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48746',
  },
  {
    city: 'Munger',
    county_fips: 26017,
    county_fips_all: '26017|26145',
    county: 'Bay',
    county_names_all: 'Bay|Saginaw',
    county_weights: '{"26017": 95.88, "26145": 4.12}',
    density: 18.8,
    imprecise: false,
    latitude: 43.52119,
    longitude: -83.76085,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48747',
  },
  {
    city: 'National City',
    county_fips: 26069,
    county_fips_all: '26069',
    county: 'Iosco',
    county_names_all: 'Iosco',
    county_weights: '{"26069": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 44.30398,
    longitude: -83.67392,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48748',
  },
  {
    city: 'Omer',
    county_fips: 26011,
    county_fips_all: '26011',
    county: 'Arenac',
    county_names_all: 'Arenac',
    county_weights: '{"26011": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 44.05512,
    longitude: -83.89183,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48749',
  },
  {
    city: 'Oscoda',
    county_fips: 26069,
    county_fips_all: '26069|26001',
    county: 'Iosco',
    county_names_all: 'Iosco|Alcona',
    county_weights: '{"26069": 96.99, "26001": 3.01}',
    density: 34.2,
    imprecise: false,
    latitude: 44.44338,
    longitude: -83.45652,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48750',
  },
  {
    city: 'Owendale',
    county_fips: 26063,
    county_fips_all: '26063',
    county: 'Huron',
    county_names_all: 'Huron',
    county_weights: '{"26063": 100}',
    density: 11,
    imprecise: false,
    latitude: 43.734,
    longitude: -83.23774,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48754',
  },
  {
    city: 'Pigeon',
    county_fips: 26063,
    county_fips_all: '26063',
    county: 'Huron',
    county_names_all: 'Huron',
    county_weights: '{"26063": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 43.83571,
    longitude: -83.26832,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48755',
  },
  {
    city: 'Prescott',
    county_fips: 26129,
    county_fips_all: '26129|26011',
    county: 'Ogemaw',
    county_names_all: 'Ogemaw|Arenac',
    county_weights: '{"26129": 99.67, "26011": 0.33}',
    density: 19.6,
    imprecise: false,
    latitude: 44.23142,
    longitude: -83.97409,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48756',
  },
  {
    city: 'Reese',
    county_fips: 26157,
    county_fips_all: '26157|26145|26017',
    county: 'Tuscola',
    county_names_all: 'Tuscola|Saginaw|Bay',
    county_weights: '{"26157": 66.47, "26145": 26.12, "26017": 7.41}',
    density: 25.9,
    imprecise: false,
    latitude: 43.46748,
    longitude: -83.679,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48757',
  },
  {
    city: 'Sebewaing',
    county_fips: 26063,
    county_fips_all: '26063|26157',
    county: 'Huron',
    county_names_all: 'Huron|Tuscola',
    county_weights: '{"26063": 99.08, "26157": 0.92}',
    density: 27.8,
    imprecise: false,
    latitude: 43.7265,
    longitude: -83.39323,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48759',
  },
  {
    city: 'Silverwood',
    county_fips: 26087,
    county_fips_all: '26087|26157',
    county: 'Lapeer',
    county_names_all: 'Lapeer|Tuscola',
    county_weights: '{"26087": 54.23, "26157": 45.77}',
    density: 17.3,
    imprecise: false,
    latitude: 43.32095,
    longitude: -83.25595,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48760',
  },
  {
    city: 'South Branch',
    county_fips: 26129,
    county_fips_all: '26129|26001|26135|26069',
    county: 'Ogemaw',
    county_names_all: 'Ogemaw|Alcona|Oscoda|Iosco',
    county_weights:
      '{"26129": 35.34, "26001": 30.25, "26135": 17.66, "26069": 16.76}',
    density: 3.9,
    imprecise: false,
    latitude: 44.51129,
    longitude: -83.89658,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48761',
  },
  {
    city: 'Spruce',
    county_fips: 26001,
    county_fips_all: '26001|26007',
    county: 'Alcona',
    county_names_all: 'Alcona|Alpena',
    county_weights: '{"26001": 87.82, "26007": 12.18}',
    density: 6.3,
    imprecise: false,
    latitude: 44.80757,
    longitude: -83.48695,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48762',
  },
  {
    city: 'Tawas City',
    county_fips: 26069,
    county_fips_all: '26069|26011',
    county: 'Iosco',
    county_names_all: 'Iosco|Arenac',
    county_weights: '{"26069": 92.69, "26011": 7.31}',
    density: 21.2,
    imprecise: false,
    latitude: 44.25017,
    longitude: -83.61441,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48763',
  },
  {
    city: 'Turner',
    county_fips: 26011,
    county_fips_all: '26011|26069',
    county: 'Arenac',
    county_names_all: 'Arenac|Iosco',
    county_weights: '{"26011": 60.38, "26069": 39.62}',
    density: 3.6,
    imprecise: false,
    latitude: 44.15367,
    longitude: -83.71885,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48765',
  },
  {
    city: 'Twining',
    county_fips: 26011,
    county_fips_all: '26011',
    county: 'Arenac',
    county_names_all: 'Arenac',
    county_weights: '{"26011": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 44.11128,
    longitude: -83.84794,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48766',
  },
  {
    city: 'Unionville',
    county_fips: 26157,
    county_fips_all: '26157|26063',
    county: 'Tuscola',
    county_names_all: 'Tuscola|Huron',
    county_weights: '{"26157": 96.9, "26063": 3.1}',
    density: 10.8,
    imprecise: false,
    latitude: 43.64172,
    longitude: -83.45541,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48767',
  },
  {
    city: 'Vassar',
    county_fips: 26157,
    county_fips_all: '26157',
    county: 'Tuscola',
    county_names_all: 'Tuscola',
    county_weights: '{"26157": 100}',
    density: 33.2,
    imprecise: false,
    latitude: 43.37077,
    longitude: -83.57661,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48768',
  },
  {
    city: 'Whittemore',
    county_fips: 26069,
    county_fips_all: '26069|26129',
    county: 'Iosco',
    county_names_all: 'Iosco|Ogemaw',
    county_weights: '{"26069": 99.4, "26129": 0.6}',
    density: 10.3,
    imprecise: false,
    latitude: 44.24978,
    longitude: -83.82037,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48770',
  },
  {
    city: 'Alma',
    county_fips: 26057,
    county_fips_all: '26057',
    county: 'Gratiot',
    county_names_all: 'Gratiot',
    county_weights: '{"26057": 100}',
    density: 72.4,
    imprecise: false,
    latitude: 43.37871,
    longitude: -84.67667,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 13278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48801',
  },
  {
    city: 'Ashley',
    county_fips: 26057,
    county_fips_all: '26057',
    county: 'Gratiot',
    county_names_all: 'Gratiot',
    county_weights: '{"26057": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 43.18568,
    longitude: -84.49675,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48806',
  },
  {
    city: 'Bannister',
    county_fips: 26057,
    county_fips_all: '26057|26145',
    county: 'Gratiot',
    county_names_all: 'Gratiot|Saginaw',
    county_weights: '{"26057": 79.72, "26145": 20.28}',
    density: 9.9,
    imprecise: false,
    latitude: 43.15277,
    longitude: -84.40671,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48807',
  },
  {
    city: 'Bath',
    county_fips: 26037,
    county_fips_all: '26037',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"26037": 100}',
    density: 104.6,
    imprecise: false,
    latitude: 42.82591,
    longitude: -84.45081,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48808',
  },
  {
    city: 'Belding',
    county_fips: 26067,
    county_fips_all: '26067|26081|26117',
    county: 'Ionia',
    county_names_all: 'Ionia|Kent|Montcalm',
    county_weights: '{"26067": 77.38, "26081": 20.72, "26117": 1.9}',
    density: 53.2,
    imprecise: false,
    latitude: 43.0646,
    longitude: -85.25712,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48809',
  },
  {
    city: 'Carson City',
    county_fips: 26117,
    county_fips_all: '26117|26057',
    county: 'Montcalm',
    county_names_all: 'Montcalm|Gratiot',
    county_weights: '{"26117": 63.13, "26057": 36.87}',
    density: 46.5,
    imprecise: false,
    latitude: 43.18226,
    longitude: -84.85518,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48811',
  },
  {
    city: 'Charlotte',
    county_fips: 26045,
    county_fips_all: '26045|26025',
    county: 'Eaton',
    county_names_all: 'Eaton|Calhoun',
    county_weights: '{"26045": 99.86, "26025": 0.14}',
    density: 47.2,
    imprecise: false,
    latitude: 42.57862,
    longitude: -84.84524,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48813',
  },
  {
    city: 'Clarksville',
    county_fips: 26067,
    county_fips_all: '26067|26081',
    county: 'Ionia',
    county_names_all: 'Ionia|Kent',
    county_weights: '{"26067": 98.06, "26081": 1.94}',
    density: 34,
    imprecise: false,
    latitude: 42.84155,
    longitude: -85.25387,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48815',
  },
  {
    city: 'Cohoctah',
    county_fips: 26093,
    county_fips_all: '26093',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"26093": 100}',
    density: 216.3,
    imprecise: false,
    latitude: 42.76151,
    longitude: -83.95172,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48816',
  },
  {
    city: 'Corunna',
    county_fips: 26155,
    county_fips_all: '26155',
    county: 'Shiawassee',
    county_names_all: 'Shiawassee',
    county_weights: '{"26155": 100}',
    density: 35.5,
    imprecise: false,
    latitude: 43.01795,
    longitude: -84.03772,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48817',
  },
  {
    city: 'Crystal',
    county_fips: 26117,
    county_fips_all: '26117',
    county: 'Montcalm',
    county_names_all: 'Montcalm',
    county_weights: '{"26117": 100}',
    density: 40,
    imprecise: false,
    latitude: 43.2759,
    longitude: -84.89661,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48818',
  },
  {
    city: 'Dansville',
    county_fips: 26065,
    county_fips_all: '26065',
    county: 'Ingham',
    county_names_all: 'Ingham',
    county_weights: '{"26065": 100}',
    density: 22.6,
    imprecise: false,
    latitude: 42.54721,
    longitude: -84.28521,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48819',
  },
  {
    city: 'Dewitt',
    county_fips: 26037,
    county_fips_all: '26037',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"26037": 100}',
    density: 107.8,
    imprecise: false,
    latitude: 42.86277,
    longitude: -84.59374,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48820',
  },
  {
    city: 'Dimondale',
    county_fips: 26045,
    county_fips_all: '26045|26065',
    county: 'Eaton',
    county_names_all: 'Eaton|Ingham',
    county_weights: '{"26045": 95.33, "26065": 4.67}',
    density: 122.7,
    imprecise: false,
    latitude: 42.63873,
    longitude: -84.64958,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48821',
  },
  {
    city: 'Eagle',
    county_fips: 26037,
    county_fips_all: '26037',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"26037": 100}',
    density: 27.8,
    imprecise: false,
    latitude: 42.83407,
    longitude: -84.76065,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48822',
  },
  {
    city: 'East Lansing',
    county_fips: 26065,
    county_fips_all: '26065|26037',
    county: 'Ingham',
    county_names_all: 'Ingham|Clinton',
    county_weights: '{"26065": 57.39, "26037": 42.61}',
    density: 816.9,
    imprecise: false,
    latitude: 42.76225,
    longitude: -84.45407,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 50034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48823',
  },
  {
    city: 'East Lansing',
    county_fips: 26065,
    county_fips_all: '26065',
    county: 'Ingham',
    county_names_all: 'Ingham',
    county_weights: '{"26065": 100}',
    density: 666.3,
    imprecise: false,
    latitude: 42.72129,
    longitude: -84.47607,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48824',
  },
  {
    city: 'East Lansing',
    county_fips: 26065,
    county_fips_all: '26065',
    county: 'Ingham',
    county_names_all: 'Ingham',
    county_weights: '{"26065": 100}',
    density: 6343.7,
    imprecise: false,
    latitude: 42.72844,
    longitude: -84.48067,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48825',
  },
  {
    city: 'Eaton Rapids',
    county_fips: 26045,
    county_fips_all: '26045|26065|26075',
    county: 'Eaton',
    county_names_all: 'Eaton|Ingham|Jackson',
    county_weights: '{"26045": 82.25, "26065": 15.85, "26075": 1.9}',
    density: 53.7,
    imprecise: false,
    latitude: 42.509,
    longitude: -84.65971,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 15831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48827',
  },
  {
    city: 'Edmore',
    county_fips: 26117,
    county_fips_all: '26117|26073',
    county: 'Montcalm',
    county_names_all: 'Montcalm|Isabella',
    county_weights: '{"26117": 96.2, "26073": 3.8}',
    density: 20.8,
    imprecise: false,
    latitude: 43.40027,
    longitude: -85.02037,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48829',
  },
  {
    city: 'Elsie',
    county_fips: 26037,
    county_fips_all: '26037|26155|26145|26057',
    county: 'Clinton',
    county_names_all: 'Clinton|Shiawassee|Saginaw|Gratiot',
    county_weights:
      '{"26037": 44.67, "26155": 33.0, "26145": 20.44, "26057": 1.89}',
    density: 16.3,
    imprecise: false,
    latitude: 43.10253,
    longitude: -84.3744,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48831',
  },
  {
    city: 'Elwell',
    county_fips: 26057,
    county_fips_all: '26057',
    county: 'Gratiot',
    county_names_all: 'Gratiot',
    county_weights: '{"26057": 100}',
    density: 19.6,
    imprecise: false,
    latitude: 43.41212,
    longitude: -84.77767,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48832',
  },
  {
    city: 'Fenwick',
    county_fips: 26117,
    county_fips_all: '26117|26067',
    county: 'Montcalm',
    county_names_all: 'Montcalm|Ionia',
    county_weights: '{"26117": 66.94, "26067": 33.06}',
    density: 17.1,
    imprecise: false,
    latitude: 43.12981,
    longitude: -85.03108,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48834',
  },
  {
    city: 'Fowler',
    county_fips: 26037,
    county_fips_all: '26037',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"26037": 100}',
    density: 19,
    imprecise: false,
    latitude: 43.03008,
    longitude: -84.74655,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48835',
  },
  {
    city: 'Fowlerville',
    county_fips: 26093,
    county_fips_all: '26093',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"26093": 100}',
    density: 62,
    imprecise: false,
    latitude: 42.66899,
    longitude: -84.07421,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 15089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48836',
  },
  {
    city: 'Grand Ledge',
    county_fips: 26045,
    county_fips_all: '26045|26037|26067',
    county: 'Eaton',
    county_names_all: 'Eaton|Clinton|Ionia',
    county_weights: '{"26045": 71.21, "26037": 24.26, "26067": 4.53}',
    density: 98.2,
    imprecise: false,
    latitude: 42.7453,
    longitude: -84.76701,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 19947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48837',
  },
  {
    city: 'Greenville',
    county_fips: 26117,
    county_fips_all: '26117|26081|26067',
    county: 'Montcalm',
    county_names_all: 'Montcalm|Kent|Ionia',
    county_weights: '{"26117": 77.28, "26081": 21.26, "26067": 1.46}',
    density: 75.6,
    imprecise: false,
    latitude: 43.18268,
    longitude: -85.25943,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48838',
  },
  {
    city: 'Haslett',
    county_fips: 26065,
    county_fips_all: '26065|26155|26037',
    county: 'Ingham',
    county_names_all: 'Ingham|Shiawassee|Clinton',
    county_weights: '{"26065": 61.84, "26155": 19.97, "26037": 18.19}',
    density: 254.4,
    imprecise: false,
    latitude: 42.76685,
    longitude: -84.37071,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 12386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48840',
  },
  {
    city: 'Henderson',
    county_fips: 26155,
    county_fips_all: '26155|26145',
    county: 'Shiawassee',
    county_names_all: 'Shiawassee|Saginaw',
    county_weights: '{"26155": 79.6, "26145": 20.4}',
    density: 12.1,
    imprecise: false,
    latitude: 43.11372,
    longitude: -84.2392,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48841',
  },
  {
    city: 'Holt',
    county_fips: 26065,
    county_fips_all: '26065|26045',
    county: 'Ingham',
    county_names_all: 'Ingham|Eaton',
    county_weights: '{"26065": 98.29, "26045": 1.71}',
    density: 492.4,
    imprecise: false,
    latitude: 42.63469,
    longitude: -84.53931,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48842',
  },
  {
    city: 'Howell',
    county_fips: 26093,
    county_fips_all: '26093',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"26093": 100}',
    density: 206.8,
    imprecise: false,
    latitude: 42.56891,
    longitude: -83.92333,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 48014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48843',
  },
  {
    city: 'Hubbardston',
    county_fips: 26067,
    county_fips_all: '26067|26037|26117|26057',
    county: 'Ionia',
    county_names_all: 'Ionia|Clinton|Montcalm|Gratiot',
    county_weights:
      '{"26067": 43.57, "26037": 29.59, "26117": 18.28, "26057": 8.55}',
    density: 20.2,
    imprecise: false,
    latitude: 43.10746,
    longitude: -84.854,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48845',
  },
  {
    city: 'Ionia',
    county_fips: 26067,
    county_fips_all: '26067',
    county: 'Ionia',
    county_names_all: 'Ionia',
    county_weights: '{"26067": 100}',
    density: 75.4,
    imprecise: false,
    latitude: 42.98611,
    longitude: -85.05754,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48846',
  },
  {
    city: 'Ithaca',
    county_fips: 26057,
    county_fips_all: '26057',
    county: 'Gratiot',
    county_names_all: 'Gratiot',
    county_weights: '{"26057": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 43.2714,
    longitude: -84.5776,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48847',
  },
  {
    city: 'Laingsburg',
    county_fips: 26155,
    county_fips_all: '26155|26037',
    county: 'Shiawassee',
    county_names_all: 'Shiawassee|Clinton',
    county_weights: '{"26155": 58.99, "26037": 41.01}',
    density: 47.2,
    imprecise: false,
    latitude: 42.88584,
    longitude: -84.35673,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48848',
  },
  {
    city: 'Lake Odessa',
    county_fips: 26067,
    county_fips_all: '26067|26015|26045',
    county: 'Ionia',
    county_names_all: 'Ionia|Barry|Eaton',
    county_weights: '{"26067": 77.17, "26015": 17.89, "26045": 4.94}',
    density: 26.4,
    imprecise: false,
    latitude: 42.7984,
    longitude: -85.13298,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48849',
  },
  {
    city: 'Lakeview',
    county_fips: 26117,
    county_fips_all: '26117|26107',
    county: 'Montcalm',
    county_names_all: 'Montcalm|Mecosta',
    county_weights: '{"26117": 67.18, "26107": 32.82}',
    density: 21.6,
    imprecise: false,
    latitude: 43.4374,
    longitude: -85.25519,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48850',
  },
  {
    city: 'Lyons',
    county_fips: 26067,
    county_fips_all: '26067',
    county: 'Ionia',
    county_names_all: 'Ionia',
    county_weights: '{"26067": 100}',
    density: 28.8,
    imprecise: false,
    latitude: 42.95469,
    longitude: -84.9364,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48851',
  },
  {
    city: 'Mcbrides',
    county_fips: 26117,
    county_fips_all: '26117',
    county: 'Montcalm',
    county_names_all: 'Montcalm',
    county_weights: '{"26117": 100}',
    density: 293,
    imprecise: false,
    latitude: 43.35256,
    longitude: -85.04652,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48852',
  },
  {
    city: 'Maple Rapids',
    county_fips: 26037,
    county_fips_all: '26037',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"26037": 100}',
    density: 439.9,
    imprecise: false,
    latitude: 43.10371,
    longitude: -84.68999,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48853',
  },
  {
    city: 'Mason',
    county_fips: 26065,
    county_fips_all: '26065',
    county: 'Ingham',
    county_names_all: 'Ingham',
    county_weights: '{"26065": 100}',
    density: 66.5,
    imprecise: false,
    latitude: 42.58199,
    longitude: -84.45182,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 19529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48854',
  },
  {
    city: 'Howell',
    county_fips: 26093,
    county_fips_all: '26093',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"26093": 100}',
    density: 70.7,
    imprecise: false,
    latitude: 42.68759,
    longitude: -83.91331,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 16668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48855',
  },
  {
    city: 'Middleton',
    county_fips: 26057,
    county_fips_all: '26057',
    county: 'Gratiot',
    county_names_all: 'Gratiot',
    county_weights: '{"26057": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 43.19994,
    longitude: -84.7372,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48856',
  },
  {
    city: 'Morrice',
    county_fips: 26155,
    county_fips_all: '26155',
    county: 'Shiawassee',
    county_names_all: 'Shiawassee',
    county_weights: '{"26155": 100}',
    density: 50.4,
    imprecise: false,
    latitude: 42.84243,
    longitude: -84.15503,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48857',
  },
  {
    city: 'Mount Pleasant',
    county_fips: 26073,
    county_fips_all: '26073|26111',
    county: 'Isabella',
    county_names_all: 'Isabella|Midland',
    county_weights: '{"26073": 98.61, "26111": 1.39}',
    density: 93.5,
    imprecise: false,
    latitude: 43.61483,
    longitude: -84.79576,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 42226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48858',
  },
  {
    city: 'Muir',
    county_fips: 26067,
    county_fips_all: '26067',
    county: 'Ionia',
    county_names_all: 'Ionia',
    county_weights: '{"26067": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 43.05089,
    longitude: -84.90939,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48860',
  },
  {
    city: 'Mulliken',
    county_fips: 26045,
    county_fips_all: '26045|26067',
    county: 'Eaton',
    county_names_all: 'Eaton|Ionia',
    county_weights: '{"26045": 91.49, "26067": 8.51}',
    density: 26.1,
    imprecise: false,
    latitude: 42.73002,
    longitude: -84.91741,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48861',
  },
  {
    city: 'North Star',
    county_fips: 26057,
    county_fips_all: '26057',
    county: 'Gratiot',
    county_names_all: 'Gratiot',
    county_weights: '{"26057": 100}',
    density: 114.2,
    imprecise: false,
    latitude: 43.24987,
    longitude: -84.54847,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 59,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48862',
  },
  {
    city: 'Okemos',
    county_fips: 26065,
    county_fips_all: '26065',
    county: 'Ingham',
    county_names_all: 'Ingham',
    county_weights: '{"26065": 100}',
    density: 459.4,
    imprecise: false,
    latitude: 42.70215,
    longitude: -84.40902,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 23901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48864',
  },
  {
    city: 'Orleans',
    county_fips: 26067,
    county_fips_all: '26067',
    county: 'Ionia',
    county_names_all: 'Ionia',
    county_weights: '{"26067": 100}',
    density: 34,
    imprecise: false,
    latitude: 43.08785,
    longitude: -85.10725,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48865',
  },
  {
    city: 'Ovid',
    county_fips: 26037,
    county_fips_all: '26037|26155',
    county: 'Clinton',
    county_names_all: 'Clinton|Shiawassee',
    county_weights: '{"26037": 55.38, "26155": 44.62}',
    density: 35.9,
    imprecise: false,
    latitude: 42.99303,
    longitude: -84.37219,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48866',
  },
  {
    city: 'Owosso',
    county_fips: 26155,
    county_fips_all: '26155',
    county: 'Shiawassee',
    county_names_all: 'Shiawassee',
    county_weights: '{"26155": 100}',
    density: 78.1,
    imprecise: false,
    latitude: 43.00537,
    longitude: -84.18766,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 27500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48867',
  },
  {
    city: 'Palo',
    county_fips: 26067,
    county_fips_all: '26067',
    county: 'Ionia',
    county_names_all: 'Ionia',
    county_weights: '{"26067": 100}',
    density: 1198.4,
    imprecise: false,
    latitude: 43.11027,
    longitude: -84.98483,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48870',
  },
  {
    city: 'Perrinton',
    county_fips: 26057,
    county_fips_all: '26057',
    county: 'Gratiot',
    county_names_all: 'Gratiot',
    county_weights: '{"26057": 100}',
    density: 27.8,
    imprecise: false,
    latitude: 43.15476,
    longitude: -84.67874,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48871',
  },
  {
    city: 'Perry',
    county_fips: 26155,
    county_fips_all: '26155|26065|26093',
    county: 'Shiawassee',
    county_names_all: 'Shiawassee|Ingham|Livingston',
    county_weights: '{"26155": 80.28, "26065": 16.06, "26093": 3.66}',
    density: 42.7,
    imprecise: false,
    latitude: 42.80065,
    longitude: -84.2189,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48872',
  },
  {
    city: 'Pewamo',
    county_fips: 26067,
    county_fips_all: '26067|26037',
    county: 'Ionia',
    county_names_all: 'Ionia|Clinton',
    county_weights: '{"26067": 50.07, "26037": 49.93}',
    density: 15.5,
    imprecise: false,
    latitude: 43.00978,
    longitude: -84.83608,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48873',
  },
  {
    city: 'Pompeii',
    county_fips: 26057,
    county_fips_all: '26057',
    county: 'Gratiot',
    county_names_all: 'Gratiot',
    county_weights: '{"26057": 100}',
    density: 71.7,
    imprecise: false,
    latitude: 43.18644,
    longitude: -84.59498,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48874',
  },
  {
    city: 'Portland',
    county_fips: 26067,
    county_fips_all: '26067|26037',
    county: 'Ionia',
    county_names_all: 'Ionia|Clinton',
    county_weights: '{"26067": 90.06, "26037": 9.94}',
    density: 51.6,
    imprecise: false,
    latitude: 42.8578,
    longitude: -84.93201,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48875',
  },
  {
    city: 'Potterville',
    county_fips: 26045,
    county_fips_all: '26045',
    county: 'Eaton',
    county_names_all: 'Eaton',
    county_weights: '{"26045": 100}',
    density: 124.8,
    imprecise: false,
    latitude: 42.64757,
    longitude: -84.73631,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48876',
  },
  {
    city: 'Riverdale',
    county_fips: 26057,
    county_fips_all: '26057|26117|26073',
    county: 'Gratiot',
    county_names_all: 'Gratiot|Montcalm|Isabella',
    county_weights: '{"26057": 46.02, "26117": 41.45, "26073": 12.52}',
    density: 20.5,
    imprecise: false,
    latitude: 43.40068,
    longitude: -84.84316,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48877',
  },
  {
    city: 'Rosebush',
    county_fips: 26073,
    county_fips_all: '26073',
    county: 'Isabella',
    county_names_all: 'Isabella',
    county_weights: '{"26073": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 43.71225,
    longitude: -84.77686,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48878',
  },
  {
    city: 'Saint Johns',
    county_fips: 26037,
    county_fips_all: '26037|26057',
    county: 'Clinton',
    county_names_all: 'Clinton|Gratiot',
    county_weights: '{"26037": 96.12, "26057": 3.88}',
    density: 37.2,
    imprecise: false,
    latitude: 43.00629,
    longitude: -84.57981,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48879',
  },
  {
    city: 'Saint Louis',
    county_fips: 26057,
    county_fips_all: '26057|26111|26073',
    county: 'Gratiot',
    county_names_all: 'Gratiot|Midland|Isabella',
    county_weights: '{"26057": 54.06, "26111": 38.11, "26073": 7.83}',
    density: 51.6,
    imprecise: false,
    latitude: 43.458,
    longitude: -84.57135,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48880',
  },
  {
    city: 'Saranac',
    county_fips: 26067,
    county_fips_all: '26067',
    county: 'Ionia',
    county_names_all: 'Ionia',
    county_weights: '{"26067": 100}',
    density: 39.3,
    imprecise: false,
    latitude: 42.934,
    longitude: -85.20214,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48881',
  },
  {
    city: 'Shepherd',
    county_fips: 26073,
    county_fips_all: '26073|26111|26057',
    county: 'Isabella',
    county_names_all: 'Isabella|Midland|Gratiot',
    county_weights: '{"26073": 64.7, "26111": 35.02, "26057": 0.28}',
    density: 24.5,
    imprecise: false,
    latitude: 43.54336,
    longitude: -84.66771,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48883',
  },
  {
    city: 'Sheridan',
    county_fips: 26117,
    county_fips_all: '26117',
    county: 'Montcalm',
    county_names_all: 'Montcalm',
    county_weights: '{"26117": 100}',
    density: 32,
    imprecise: false,
    latitude: 43.20731,
    longitude: -85.04249,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48884',
  },
  {
    city: 'Sidney',
    county_fips: 26117,
    county_fips_all: '26117',
    county: 'Montcalm',
    county_names_all: 'Montcalm',
    county_weights: '{"26117": 100}',
    density: 24.8,
    imprecise: false,
    latitude: 43.24908,
    longitude: -85.14356,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48885',
  },
  {
    city: 'Six Lakes',
    county_fips: 26117,
    county_fips_all: '26117|26107',
    county: 'Montcalm',
    county_names_all: 'Montcalm|Mecosta',
    county_weights: '{"26117": 95.6, "26107": 4.4}',
    density: 19.3,
    imprecise: false,
    latitude: 43.41994,
    longitude: -85.16092,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48886',
  },
  {
    city: 'Stanton',
    county_fips: 26117,
    county_fips_all: '26117',
    county: 'Montcalm',
    county_names_all: 'Montcalm',
    county_weights: '{"26117": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 43.3089,
    longitude: -85.09566,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48888',
  },
  {
    city: 'Sumner',
    county_fips: 26057,
    county_fips_all: '26057|26117',
    county: 'Gratiot',
    county_names_all: 'Gratiot|Montcalm',
    county_weights: '{"26057": 98.51, "26117": 1.49}',
    density: 19,
    imprecise: false,
    latitude: 43.29133,
    longitude: -84.79701,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48889',
  },
  {
    city: 'Sunfield',
    county_fips: 26045,
    county_fips_all: '26045|26067',
    county: 'Eaton',
    county_names_all: 'Eaton|Ionia',
    county_weights: '{"26045": 53.34, "26067": 46.66}',
    density: 25.1,
    imprecise: false,
    latitude: 42.76878,
    longitude: -84.97167,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48890',
  },
  {
    city: 'Vestaburg',
    county_fips: 26117,
    county_fips_all: '26117',
    county: 'Montcalm',
    county_names_all: 'Montcalm',
    county_weights: '{"26117": 100}',
    density: 27.9,
    imprecise: false,
    latitude: 43.39676,
    longitude: -84.91469,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48891',
  },
  {
    city: 'Webberville',
    county_fips: 26065,
    county_fips_all: '26065|26093',
    county: 'Ingham',
    county_names_all: 'Ingham|Livingston',
    county_weights: '{"26065": 79.43, "26093": 20.57}',
    density: 33,
    imprecise: false,
    latitude: 42.63662,
    longitude: -84.17477,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48892',
  },
  {
    city: 'Weidman',
    county_fips: 26073,
    county_fips_all: '26073',
    county: 'Isabella',
    county_names_all: 'Isabella',
    county_weights: '{"26073": 100}',
    density: 44.7,
    imprecise: false,
    latitude: 43.68329,
    longitude: -84.97805,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48893',
  },
  {
    city: 'Westphalia',
    county_fips: 26037,
    county_fips_all: '26037|26067',
    county: 'Clinton',
    county_names_all: 'Clinton|Ionia',
    county_weights: '{"26037": 86.3, "26067": 13.7}',
    density: 24.6,
    imprecise: false,
    latitude: 42.92841,
    longitude: -84.79489,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48894',
  },
  {
    city: 'Williamston',
    county_fips: 26065,
    county_fips_all: '26065',
    county: 'Ingham',
    county_names_all: 'Ingham',
    county_weights: '{"26065": 100}',
    density: 51.8,
    imprecise: false,
    latitude: 42.68946,
    longitude: -84.28061,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48895',
  },
  {
    city: 'Winn',
    county_fips: 26073,
    county_fips_all: '26073',
    county: 'Isabella',
    county_names_all: 'Isabella',
    county_weights: '{"26073": 100}',
    density: 322.5,
    imprecise: false,
    latitude: 43.52127,
    longitude: -84.90101,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48896',
  },
  {
    city: 'Woodland',
    county_fips: 26015,
    county_fips_all: '26015|26045',
    county: 'Barry',
    county_names_all: 'Barry|Eaton',
    county_weights: '{"26015": 97.38, "26045": 2.62}',
    density: 19.9,
    imprecise: false,
    latitude: 42.70498,
    longitude: -85.13193,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48897',
  },
  {
    city: 'Lansing',
    county_fips: 26037,
    county_fips_all: '26037|26065|26045',
    county: 'Clinton',
    county_names_all: 'Clinton|Ingham|Eaton',
    county_weights: '{"26037": 77.23, "26065": 17.04, "26045": 5.73}',
    density: 307.5,
    imprecise: false,
    latitude: 42.78489,
    longitude: -84.58886,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 25901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48906',
  },
  {
    city: 'Lansing',
    county_fips: 26065,
    county_fips_all: '26065',
    county: 'Ingham',
    county_names_all: 'Ingham',
    county_weights: '{"26065": 100}',
    density: 890.9,
    imprecise: false,
    latitude: 42.6969,
    longitude: -84.52541,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 32800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48910',
  },
  {
    city: 'Lansing',
    county_fips: 26065,
    county_fips_all: '26065|26045',
    county: 'Ingham',
    county_names_all: 'Ingham|Eaton',
    county_weights: '{"26065": 79.92, "26045": 20.08}',
    density: 888.1,
    imprecise: false,
    latitude: 42.67351,
    longitude: -84.57285,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 39876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48911',
  },
  {
    city: 'Lansing',
    county_fips: 26065,
    county_fips_all: '26065',
    county: 'Ingham',
    county_names_all: 'Ingham',
    county_weights: '{"26065": 100}',
    density: 1301.3,
    imprecise: false,
    latitude: 42.73896,
    longitude: -84.52319,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48912',
  },
  {
    city: 'Lansing',
    county_fips: 26065,
    county_fips_all: '26065',
    county: 'Ingham',
    county_names_all: 'Ingham',
    county_weights: '{"26065": 100}',
    density: 2020.6,
    imprecise: false,
    latitude: 42.73885,
    longitude: -84.57076,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48915',
  },
  {
    city: 'Lansing',
    county_fips: 26045,
    county_fips_all: '26045|26065',
    county: 'Eaton',
    county_names_all: 'Eaton|Ingham',
    county_weights: '{"26045": 86.33, "26065": 13.67}',
    density: 523.1,
    imprecise: false,
    latitude: 42.72509,
    longitude: -84.63897,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 32483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48917',
  },
  {
    city: 'Lansing',
    county_fips: 26065,
    county_fips_all: '26065',
    county: 'Ingham',
    county_names_all: 'Ingham',
    county_weights: '{"26065": 100}',
    density: 1148.4,
    imprecise: false,
    latitude: 42.72956,
    longitude: -84.55595,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48933',
  },
  {
    city: 'Kalamazoo',
    county_fips: 26077,
    county_fips_all: '26077',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo',
    county_weights: '{"26077": 100}',
    density: 1054,
    imprecise: false,
    latitude: 42.2647,
    longitude: -85.56265,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49001',
  },
  {
    city: 'Portage',
    county_fips: 26077,
    county_fips_all: '26077',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo',
    county_weights: '{"26077": 100}',
    density: 440.7,
    imprecise: false,
    latitude: 42.19867,
    longitude: -85.55906,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 19737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49002',
  },
  {
    city: 'Kalamazoo',
    county_fips: 26077,
    county_fips_all: '26077',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo',
    county_weights: '{"26077": 100}',
    density: 312,
    imprecise: false,
    latitude: 42.34903,
    longitude: -85.55954,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49004',
  },
  {
    city: 'Kalamazoo',
    county_fips: 26077,
    county_fips_all: '26077',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo',
    county_weights: '{"26077": 100}',
    density: 1713.8,
    imprecise: false,
    latitude: 42.29539,
    longitude: -85.6291,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 26507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49006',
  },
  {
    city: 'Kalamazoo',
    county_fips: 26077,
    county_fips_all: '26077',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo',
    county_weights: '{"26077": 100}',
    density: 1087.4,
    imprecise: false,
    latitude: 42.30252,
    longitude: -85.5883,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49007',
  },
  {
    city: 'Kalamazoo',
    county_fips: 26077,
    county_fips_all: '26077',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo',
    county_weights: '{"26077": 100}',
    density: 927.1,
    imprecise: false,
    latitude: 42.26337,
    longitude: -85.61528,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 16137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49008',
  },
  {
    city: 'Kalamazoo',
    county_fips: 26077,
    county_fips_all: '26077|26159',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo|Van Buren',
    county_weights: '{"26077": 95.9, "26159": 4.1}',
    density: 181.2,
    imprecise: false,
    latitude: 42.30913,
    longitude: -85.69278,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 47971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49009',
  },
  {
    city: 'Allegan',
    county_fips: 26005,
    county_fips_all: '26005|26159',
    county: 'Allegan',
    county_names_all: 'Allegan|Van Buren',
    county_weights: '{"26005": 99.08, "26159": 0.92}',
    density: 44.8,
    imprecise: false,
    latitude: 42.53418,
    longitude: -85.87298,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49010',
  },
  {
    city: 'Athens',
    county_fips: 26025,
    county_fips_all: '26025|26023|26149',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Branch|St. Joseph',
    county_weights: '{"26025": 89.29, "26023": 9.04, "26149": 1.67}',
    density: 28.5,
    imprecise: false,
    latitude: 42.10288,
    longitude: -85.22285,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49011',
  },
  {
    city: 'Augusta',
    county_fips: 26077,
    county_fips_all: '26077|26025',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo|Calhoun',
    county_weights: '{"26077": 98.31, "26025": 1.69}',
    density: 29.5,
    imprecise: false,
    latitude: 42.34626,
    longitude: -85.34116,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49012',
  },
  {
    city: 'Bangor',
    county_fips: 26159,
    county_fips_all: '26159',
    county: 'Van Buren',
    county_names_all: 'Van Buren',
    county_weights: '{"26159": 100}',
    density: 36.2,
    imprecise: false,
    latitude: 42.30524,
    longitude: -86.10796,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49013',
  },
  {
    city: 'Battle Creek',
    county_fips: 26025,
    county_fips_all: '26025',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"26025": 100}',
    density: 117,
    imprecise: false,
    latitude: 42.30996,
    longitude: -85.10711,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49014',
  },
  {
    city: 'Battle Creek',
    county_fips: 26025,
    county_fips_all: '26025|26077',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Kalamazoo',
    county_weights: '{"26025": 99.89, "26077": 0.11}',
    density: 394.2,
    imprecise: false,
    latitude: 42.27467,
    longitude: -85.23115,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 27765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49015',
  },
  {
    city: 'Battle Creek',
    county_fips: 26025,
    county_fips_all: '26025|26015',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Barry',
    county_weights: '{"26025": 76.49, "26015": 23.51}',
    density: 144.9,
    imprecise: false,
    latitude: 42.3979,
    longitude: -85.2111,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49017',
  },
  {
    city: 'Bellevue',
    county_fips: 26045,
    county_fips_all: '26045|26015|26025',
    county: 'Eaton',
    county_names_all: 'Eaton|Barry|Calhoun',
    county_weights: '{"26045": 45.63, "26015": 39.02, "26025": 15.35}',
    density: 26,
    imprecise: false,
    latitude: 42.4588,
    longitude: -85.06435,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49021',
  },
  {
    city: 'Benton Harbor',
    county_fips: 26021,
    county_fips_all: '26021|26159',
    county: 'Berrien',
    county_names_all: 'Berrien|Van Buren',
    county_weights: '{"26021": 97.33, "26159": 2.67}',
    density: 169.1,
    imprecise: false,
    latitude: 42.11434,
    longitude: -86.3675,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 29460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49022',
  },
  {
    city: 'Portage',
    county_fips: 26077,
    county_fips_all: '26077',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo',
    county_weights: '{"26077": 100}',
    density: 690.1,
    imprecise: false,
    latitude: 42.20207,
    longitude: -85.61917,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 30823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49024',
  },
  {
    city: 'Bloomingdale',
    county_fips: 26159,
    county_fips_all: '26159|26005',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Allegan',
    county_weights: '{"26159": 88.0, "26005": 12.0}',
    density: 23.2,
    imprecise: false,
    latitude: 42.37778,
    longitude: -85.96273,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49026',
  },
  {
    city: 'Breedsville',
    county_fips: 26159,
    county_fips_all: '26159',
    county: 'Van Buren',
    county_names_all: 'Van Buren',
    county_weights: '{"26159": 100}',
    density: 214.4,
    imprecise: false,
    latitude: 42.3482,
    longitude: -86.06939,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49027',
  },
  {
    city: 'Bronson',
    county_fips: 26023,
    county_fips_all: '26023',
    county: 'Branch',
    county_names_all: 'Branch',
    county_weights: '{"26023": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 41.84438,
    longitude: -85.1837,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49028',
  },
  {
    city: 'Burlington',
    county_fips: 26025,
    county_fips_all: '26025',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"26025": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 42.1423,
    longitude: -85.09107,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49029',
  },
  {
    city: 'Burr Oak',
    county_fips: 26149,
    county_fips_all: '26149|26023',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph|Branch',
    county_weights: '{"26149": 86.36, "26023": 13.64}',
    density: 20.7,
    imprecise: false,
    latitude: 41.85529,
    longitude: -85.33129,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49030',
  },
  {
    city: 'Cassopolis',
    county_fips: 26027,
    county_fips_all: '26027',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"26027": 100}',
    density: 26.8,
    imprecise: false,
    latitude: 41.89883,
    longitude: -85.98849,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49031',
  },
  {
    city: 'Centreville',
    county_fips: 26149,
    county_fips_all: '26149',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"26149": 100}',
    density: 35.7,
    imprecise: false,
    latitude: 41.91779,
    longitude: -85.50767,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49032',
  },
  {
    city: 'Ceresco',
    county_fips: 26025,
    county_fips_all: '26025',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"26025": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 42.22654,
    longitude: -85.09193,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49033',
  },
  {
    city: 'Climax',
    county_fips: 26077,
    county_fips_all: '26077|26025',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo|Calhoun',
    county_weights: '{"26077": 79.3, "26025": 20.7}',
    density: 20.2,
    imprecise: false,
    latitude: 42.23178,
    longitude: -85.33403,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49034',
  },
  {
    city: 'Coldwater',
    county_fips: 26023,
    county_fips_all: '26023',
    county: 'Branch',
    county_names_all: 'Branch',
    county_weights: '{"26023": 100}',
    density: 62.2,
    imprecise: false,
    latitude: 41.90565,
    longitude: -85.02391,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 24826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49036',
  },
  {
    city: 'Battle Creek',
    county_fips: 26025,
    county_fips_all: '26025',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"26025": 100}',
    density: 410.7,
    imprecise: false,
    latitude: 42.33448,
    longitude: -85.24706,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49037',
  },
  {
    city: 'Coloma',
    county_fips: 26021,
    county_fips_all: '26021|26159',
    county: 'Berrien',
    county_names_all: 'Berrien|Van Buren',
    county_weights: '{"26021": 86.69, "26159": 13.31}',
    density: 85.4,
    imprecise: false,
    latitude: 42.20554,
    longitude: -86.32489,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49038',
  },
  {
    city: 'Colon',
    county_fips: 26149,
    county_fips_all: '26149|26023',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph|Branch',
    county_weights: '{"26149": 73.53, "26023": 26.47}',
    density: 31.7,
    imprecise: false,
    latitude: 41.96847,
    longitude: -85.32398,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49040',
  },
  {
    city: 'Constantine',
    county_fips: 26149,
    county_fips_all: '26149|26027',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph|Cass',
    county_weights: '{"26149": 92.1, "26027": 7.9}',
    density: 30.9,
    imprecise: false,
    latitude: 41.85665,
    longitude: -85.67142,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49042',
  },
  {
    city: 'Covert',
    county_fips: 26159,
    county_fips_all: '26159',
    county: 'Van Buren',
    county_names_all: 'Van Buren',
    county_weights: '{"26159": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 42.28658,
    longitude: -86.2656,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49043',
  },
  {
    city: 'Decatur',
    county_fips: 26159,
    county_fips_all: '26159|26027',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Cass',
    county_weights: '{"26159": 80.0, "26027": 20.0}',
    density: 23.8,
    imprecise: false,
    latitude: 42.1038,
    longitude: -86.00219,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49045',
  },
  {
    city: 'Delton',
    county_fips: 26015,
    county_fips_all: '26015',
    county: 'Barry',
    county_names_all: 'Barry',
    county_weights: '{"26015": 100}',
    density: 33.5,
    imprecise: false,
    latitude: 42.51229,
    longitude: -85.40249,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49046',
  },
  {
    city: 'Dowagiac',
    county_fips: 26027,
    county_fips_all: '26027|26159|26021',
    county: 'Cass',
    county_names_all: 'Cass|Van Buren|Berrien',
    county_weights: '{"26027": 90.33, "26159": 7.84, "26021": 1.83}',
    density: 48.1,
    imprecise: false,
    latitude: 42.00437,
    longitude: -86.12138,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 14858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49047',
  },
  {
    city: 'Kalamazoo',
    county_fips: 26077,
    county_fips_all: '26077',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo',
    county_weights: '{"26077": 100}',
    density: 250.4,
    imprecise: false,
    latitude: 42.27202,
    longitude: -85.49893,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 22791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49048',
  },
  {
    city: 'Dowling',
    county_fips: 26015,
    county_fips_all: '26015',
    county: 'Barry',
    county_names_all: 'Barry',
    county_weights: '{"26015": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 42.50598,
    longitude: -85.23651,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49050',
  },
  {
    city: 'East Leroy',
    county_fips: 26025,
    county_fips_all: '26025',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"26025": 100}',
    density: 38.3,
    imprecise: false,
    latitude: 42.18207,
    longitude: -85.23803,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49051',
  },
  {
    city: 'Fulton',
    county_fips: 26077,
    county_fips_all: '26077|26025',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo|Calhoun',
    county_weights: '{"26077": 77.02, "26025": 22.98}',
    density: 15,
    imprecise: false,
    latitude: 42.11538,
    longitude: -85.31936,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49052',
  },
  {
    city: 'Galesburg',
    county_fips: 26077,
    county_fips_all: '26077',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo',
    county_weights: '{"26077": 100}',
    density: 123.5,
    imprecise: false,
    latitude: 42.28877,
    longitude: -85.41722,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49053',
  },
  {
    city: 'Gobles',
    county_fips: 26159,
    county_fips_all: '26159|26005',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Allegan',
    county_weights: '{"26159": 92.49, "26005": 7.51}',
    density: 39.9,
    imprecise: false,
    latitude: 42.37022,
    longitude: -85.85327,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49055',
  },
  {
    city: 'Grand Junction',
    county_fips: 26159,
    county_fips_all: '26159|26005',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Allegan',
    county_weights: '{"26159": 63.62, "26005": 36.38}',
    density: 29.9,
    imprecise: false,
    latitude: 42.39951,
    longitude: -86.05967,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49056',
  },
  {
    city: 'Hartford',
    county_fips: 26159,
    county_fips_all: '26159',
    county: 'Van Buren',
    county_names_all: 'Van Buren',
    county_weights: '{"26159": 100}',
    density: 50.4,
    imprecise: false,
    latitude: 42.18647,
    longitude: -86.16691,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49057',
  },
  {
    city: 'Hastings',
    county_fips: 26015,
    county_fips_all: '26015',
    county: 'Barry',
    county_names_all: 'Barry',
    county_weights: '{"26015": 100}',
    density: 51.1,
    imprecise: false,
    latitude: 42.63331,
    longitude: -85.29316,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 19551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49058',
  },
  {
    city: 'Hickory Corners',
    county_fips: 26015,
    county_fips_all: '26015|26077',
    county: 'Barry',
    county_names_all: 'Barry|Kalamazoo',
    county_weights: '{"26015": 73.68, "26077": 26.32}',
    density: 52,
    imprecise: false,
    latitude: 42.42738,
    longitude: -85.39589,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49060',
  },
  {
    city: 'Jones',
    county_fips: 26027,
    county_fips_all: '26027',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"26027": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 41.87964,
    longitude: -85.82551,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49061',
  },
  {
    city: 'Lacota',
    county_fips: 26159,
    county_fips_all: '26159',
    county: 'Van Buren',
    county_names_all: 'Van Buren',
    county_weights: '{"26159": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.4098,
    longitude: -86.1396,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49063',
  },
  {
    city: 'Lawrence',
    county_fips: 26159,
    county_fips_all: '26159',
    county: 'Van Buren',
    county_names_all: 'Van Buren',
    county_weights: '{"26159": 100}',
    density: 29.2,
    imprecise: false,
    latitude: 42.22028,
    longitude: -86.04991,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49064',
  },
  {
    city: 'Lawton',
    county_fips: 26159,
    county_fips_all: '26159|26077',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Kalamazoo',
    county_weights: '{"26159": 98.77, "26077": 1.23}',
    density: 61.1,
    imprecise: false,
    latitude: 42.13645,
    longitude: -85.83928,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49065',
  },
  {
    city: 'Leonidas',
    county_fips: 26149,
    county_fips_all: '26149',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"26149": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 42.03319,
    longitude: -85.35007,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49066',
  },
  {
    city: 'Marcellus',
    county_fips: 26027,
    county_fips_all: '26027|26149|26159',
    county: 'Cass',
    county_names_all: 'Cass|St. Joseph|Van Buren',
    county_weights: '{"26027": 63.8, "26149": 28.61, "26159": 7.59}',
    density: 18.7,
    imprecise: false,
    latitude: 42.02359,
    longitude: -85.79982,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49067',
  },
  {
    city: 'Marshall',
    county_fips: 26025,
    county_fips_all: '26025',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"26025": 100}',
    density: 43.8,
    imprecise: false,
    latitude: 42.2765,
    longitude: -84.94063,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 14729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49068',
  },
  {
    city: 'Martin',
    county_fips: 26005,
    county_fips_all: '26005',
    county: 'Allegan',
    county_names_all: 'Allegan',
    county_weights: '{"26005": 100}',
    density: 34.9,
    imprecise: false,
    latitude: 42.54023,
    longitude: -85.62879,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49070',
  },
  {
    city: 'Mattawan',
    county_fips: 26159,
    county_fips_all: '26159|26077',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Kalamazoo',
    county_weights: '{"26159": 74.14, "26077": 25.86}',
    density: 160.2,
    imprecise: false,
    latitude: 42.2275,
    longitude: -85.78002,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 12198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49071',
  },
  {
    city: 'Mendon',
    county_fips: 26149,
    county_fips_all: '26149|26077',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph|Kalamazoo',
    county_weights: '{"26149": 96.33, "26077": 3.67}',
    density: 19.4,
    imprecise: false,
    latitude: 42.01295,
    longitude: -85.45825,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49072',
  },
  {
    city: 'Nashville',
    county_fips: 26015,
    county_fips_all: '26015|26045',
    county: 'Barry',
    county_names_all: 'Barry|Eaton',
    county_weights: '{"26015": 84.75, "26045": 15.25}',
    density: 28,
    imprecise: false,
    latitude: 42.57971,
    longitude: -85.11717,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49073',
  },
  {
    city: 'Nazareth',
    county_fips: 26077,
    county_fips_all: '26077',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo',
    county_weights: '{"26077": 100}',
    density: 298.4,
    imprecise: false,
    latitude: 42.3198,
    longitude: -85.53991,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49074',
  },
  {
    city: 'Nottawa',
    county_fips: 26149,
    county_fips_all: '26149',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"26149": 100}',
    density: 1312.6,
    imprecise: false,
    latitude: 41.91783,
    longitude: -85.44899,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49075',
  },
  {
    city: 'Olivet',
    county_fips: 26045,
    county_fips_all: '26045|26025',
    county: 'Eaton',
    county_names_all: 'Eaton|Calhoun',
    county_weights: '{"26045": 54.36, "26025": 45.64}',
    density: 29,
    imprecise: false,
    latitude: 42.4309,
    longitude: -84.88657,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49076',
  },
  {
    city: 'Otsego',
    county_fips: 26005,
    county_fips_all: '26005|26077|26159',
    county: 'Allegan',
    county_names_all: 'Allegan|Kalamazoo|Van Buren',
    county_weights: '{"26005": 84.93, "26077": 12.06, "26159": 3.01}',
    density: 78.1,
    imprecise: false,
    latitude: 42.46585,
    longitude: -85.72846,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 10018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49078',
  },
  {
    city: 'Paw Paw',
    county_fips: 26159,
    county_fips_all: '26159',
    county: 'Van Buren',
    county_names_all: 'Van Buren',
    county_weights: '{"26159": 100}',
    density: 62.1,
    imprecise: false,
    latitude: 42.23997,
    longitude: -85.90901,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 13414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49079',
  },
  {
    city: 'Plainwell',
    county_fips: 26005,
    county_fips_all: '26005|26015|26077',
    county: 'Allegan',
    county_names_all: 'Allegan|Barry|Kalamazoo',
    county_weights: '{"26005": 52.32, "26015": 31.54, "26077": 16.14}',
    density: 79.8,
    imprecise: false,
    latitude: 42.46086,
    longitude: -85.57711,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 16002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49080',
  },
  {
    city: 'Quincy',
    county_fips: 26023,
    county_fips_all: '26023|26059',
    county: 'Branch',
    county_names_all: 'Branch|Hillsdale',
    county_weights: '{"26023": 92.46, "26059": 7.54}',
    density: 30.4,
    imprecise: false,
    latitude: 41.94257,
    longitude: -84.876,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49082',
  },
  {
    city: 'Richland',
    county_fips: 26077,
    county_fips_all: '26077',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo',
    county_weights: '{"26077": 100}',
    density: 95.3,
    imprecise: false,
    latitude: 42.3784,
    longitude: -85.45899,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49083',
  },
  {
    city: 'Riverside',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 158.5,
    imprecise: false,
    latitude: 42.18018,
    longitude: -86.3852,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49084',
  },
  {
    city: 'Saint Joseph',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 381.2,
    imprecise: false,
    latitude: 42.04883,
    longitude: -86.45923,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 23827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49085',
  },
  {
    city: 'Schoolcraft',
    county_fips: 26077,
    county_fips_all: '26077|26159',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo|Van Buren',
    county_weights: '{"26077": 95.31, "26159": 4.69}',
    density: 39,
    imprecise: false,
    latitude: 42.12209,
    longitude: -85.68557,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49087',
  },
  {
    city: 'Scotts',
    county_fips: 26077,
    county_fips_all: '26077',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo',
    county_weights: '{"26077": 100}',
    density: 40.9,
    imprecise: false,
    latitude: 42.18602,
    longitude: -85.42503,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49088',
  },
  {
    city: 'Sherwood',
    county_fips: 26023,
    county_fips_all: '26023',
    county: 'Branch',
    county_names_all: 'Branch',
    county_weights: '{"26023": 100}',
    density: 22,
    imprecise: false,
    latitude: 42.00181,
    longitude: -85.23113,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49089',
  },
  {
    city: 'South Haven',
    county_fips: 26159,
    county_fips_all: '26159|26005',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Allegan',
    county_weights: '{"26159": 59.19, "26005": 40.81}',
    density: 65.4,
    imprecise: false,
    latitude: 42.40853,
    longitude: -86.2168,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 13250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49090',
  },
  {
    city: 'Sturgis',
    county_fips: 26149,
    county_fips_all: '26149',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph',
    county_weights: '{"26149": 100}',
    density: 85.5,
    imprecise: false,
    latitude: 41.82509,
    longitude: -85.44627,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 19337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49091',
  },
  {
    city: 'Tekonsha',
    county_fips: 26025,
    county_fips_all: '26025|26023',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Branch',
    county_weights: '{"26025": 72.24, "26023": 27.76}',
    density: 12.9,
    imprecise: false,
    latitude: 42.09822,
    longitude: -84.97335,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49092',
  },
  {
    city: 'Three Rivers',
    county_fips: 26149,
    county_fips_all: '26149|26027',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph|Cass',
    county_weights: '{"26149": 94.87, "26027": 5.13}',
    density: 67.4,
    imprecise: false,
    latitude: 41.97375,
    longitude: -85.64665,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49093',
  },
  {
    city: 'Union City',
    county_fips: 26023,
    county_fips_all: '26023|26025',
    county: 'Branch',
    county_names_all: 'Branch|Calhoun',
    county_weights: '{"26023": 77.48, "26025": 22.52}',
    density: 26.1,
    imprecise: false,
    latitude: 42.04696,
    longitude: -85.11752,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49094',
  },
  {
    city: 'Vandalia',
    county_fips: 26027,
    county_fips_all: '26027',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"26027": 100}',
    density: 32.9,
    imprecise: false,
    latitude: 41.91008,
    longitude: -85.8826,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49095',
  },
  {
    city: 'Vermontville',
    county_fips: 26045,
    county_fips_all: '26045',
    county: 'Eaton',
    county_names_all: 'Eaton',
    county_weights: '{"26045": 100}',
    density: 20.1,
    imprecise: false,
    latitude: 42.63794,
    longitude: -85.01409,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49096',
  },
  {
    city: 'Vicksburg',
    county_fips: 26077,
    county_fips_all: '26077|26149',
    county: 'Kalamazoo',
    county_names_all: 'Kalamazoo|St. Joseph',
    county_weights: '{"26077": 94.91, "26149": 5.09}',
    density: 64.9,
    imprecise: false,
    latitude: 42.11491,
    longitude: -85.48985,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49097',
  },
  {
    city: 'Watervliet',
    county_fips: 26021,
    county_fips_all: '26021|26159',
    county: 'Berrien',
    county_names_all: 'Berrien|Van Buren',
    county_weights: '{"26021": 77.07, "26159": 22.93}',
    density: 73.7,
    imprecise: false,
    latitude: 42.16756,
    longitude: -86.2425,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49098',
  },
  {
    city: 'White Pigeon',
    county_fips: 26149,
    county_fips_all: '26149|26027',
    county: 'St. Joseph',
    county_names_all: 'St. Joseph|Cass',
    county_weights: '{"26149": 82.19, "26027": 17.81}',
    density: 39.6,
    imprecise: false,
    latitude: 41.79139,
    longitude: -85.67437,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49099',
  },
  {
    city: 'Baroda',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 55.1,
    imprecise: false,
    latitude: 41.94462,
    longitude: -86.48429,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49101',
  },
  {
    city: 'Berrien Center',
    county_fips: 26021,
    county_fips_all: '26021|26027',
    county: 'Berrien',
    county_names_all: 'Berrien|Cass',
    county_weights: '{"26021": 95.79, "26027": 4.21}',
    density: 37.9,
    imprecise: false,
    latitude: 41.95194,
    longitude: -86.26037,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49102',
  },
  {
    city: 'Berrien Springs',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 99.8,
    imprecise: false,
    latitude: 41.94559,
    longitude: -86.37519,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49103',
  },
  {
    city: 'Bridgman',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 124.6,
    imprecise: false,
    latitude: 41.93452,
    longitude: -86.55105,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49106',
  },
  {
    city: 'Buchanan',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 60.1,
    imprecise: false,
    latitude: 41.84804,
    longitude: -86.41396,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 10323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49107',
  },
  {
    city: 'Eau Claire',
    county_fips: 26021,
    county_fips_all: '26021|26027',
    county: 'Berrien',
    county_names_all: 'Berrien|Cass',
    county_weights: '{"26021": 95.95, "26027": 4.05}',
    density: 28.1,
    imprecise: false,
    latitude: 42.02544,
    longitude: -86.28621,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49111',
  },
  {
    city: 'Edwardsburg',
    county_fips: 26027,
    county_fips_all: '26027',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"26027": 100}',
    density: 93.1,
    imprecise: false,
    latitude: 41.79833,
    longitude: -86.03425,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 10544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49112',
  },
  {
    city: 'Galien',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 41.80259,
    longitude: -86.50044,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49113',
  },
  {
    city: 'Harbert',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 66.7,
    imprecise: false,
    latitude: 41.87537,
    longitude: -86.63389,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49115',
  },
  {
    city: 'Lakeside',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 21.5,
    imprecise: false,
    latitude: 41.84836,
    longitude: -86.66637,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 86,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49116',
  },
  {
    city: 'New Buffalo',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 68.1,
    imprecise: false,
    latitude: 41.78028,
    longitude: -86.72696,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49117',
  },
  {
    city: 'New Troy',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 102.2,
    imprecise: false,
    latitude: 41.87564,
    longitude: -86.54862,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49119',
  },
  {
    city: 'Niles',
    county_fips: 26021,
    county_fips_all: '26021|26027',
    county: 'Berrien',
    county_names_all: 'Berrien|Cass',
    county_weights: '{"26021": 53.17, "26027": 46.83}',
    density: 120.9,
    imprecise: false,
    latitude: 41.83148,
    longitude: -86.23162,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 36495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49120',
  },
  {
    city: 'Sawyer',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 58.7,
    imprecise: false,
    latitude: 41.88698,
    longitude: -86.57946,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49125',
  },
  {
    city: 'Sodus',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 40.7,
    imprecise: false,
    latitude: 42.02593,
    longitude: -86.36946,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49126',
  },
  {
    city: 'Stevensville',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 251.3,
    imprecise: false,
    latitude: 42.00411,
    longitude: -86.51597,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49127',
  },
  {
    city: 'Three Oaks',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 30.5,
    imprecise: false,
    latitude: 41.81706,
    longitude: -86.60457,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49128',
  },
  {
    city: 'Union Pier',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 51.4,
    imprecise: false,
    latitude: 41.81699,
    longitude: -86.68839,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49129',
  },
  {
    city: 'Union',
    county_fips: 26027,
    county_fips_all: '26027',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"26027": 100}',
    density: 41.2,
    imprecise: false,
    latitude: 41.78086,
    longitude: -85.85997,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49130',
  },
  {
    city: 'Jackson',
    county_fips: 26075,
    county_fips_all: '26075',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"26075": 100}',
    density: 122.3,
    imprecise: false,
    latitude: 42.25213,
    longitude: -84.38301,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 49107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49201',
  },
  {
    city: 'Jackson',
    county_fips: 26075,
    county_fips_all: '26075',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"26075": 100}',
    density: 562.6,
    imprecise: false,
    latitude: 42.26737,
    longitude: -84.4107,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49202',
  },
  {
    city: 'Jackson',
    county_fips: 26075,
    county_fips_all: '26075',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"26075": 100}',
    density: 531.9,
    imprecise: false,
    latitude: 42.22096,
    longitude: -84.40347,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 36474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49203',
  },
  {
    city: 'Addison',
    county_fips: 26091,
    county_fips_all: '26091|26059',
    county: 'Lenawee',
    county_names_all: 'Lenawee|Hillsdale',
    county_weights: '{"26091": 71.95, "26059": 28.05}',
    density: 29.4,
    imprecise: false,
    latitude: 41.99511,
    longitude: -84.34108,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49220',
  },
  {
    city: 'Adrian',
    county_fips: 26091,
    county_fips_all: '26091',
    county: 'Lenawee',
    county_names_all: 'Lenawee',
    county_weights: '{"26091": 100}',
    density: 132.3,
    imprecise: false,
    latitude: 41.90343,
    longitude: -84.06372,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 41087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49221',
  },
  {
    city: 'Albion',
    county_fips: 26025,
    county_fips_all: '26025|26075',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Jackson',
    county_weights: '{"26025": 69.27, "26075": 30.73}',
    density: 52,
    imprecise: false,
    latitude: 42.27982,
    longitude: -84.74852,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 13447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49224',
  },
  {
    city: 'Allen',
    county_fips: 26059,
    county_fips_all: '26059',
    county: 'Hillsdale',
    county_names_all: 'Hillsdale',
    county_weights: '{"26059": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 41.9498,
    longitude: -84.77036,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49227',
  },
  {
    city: 'Blissfield',
    county_fips: 26091,
    county_fips_all: '26091|26115',
    county: 'Lenawee',
    county_names_all: 'Lenawee|Monroe',
    county_weights: '{"26091": 99.52, "26115": 0.48}',
    density: 26.8,
    imprecise: false,
    latitude: 41.8039,
    longitude: -83.88247,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49228',
  },
  {
    city: 'Britton',
    county_fips: 26091,
    county_fips_all: '26091|26115|26161',
    county: 'Lenawee',
    county_names_all: 'Lenawee|Monroe|Washtenaw',
    county_weights: '{"26091": 87.87, "26115": 10.78, "26161": 1.35}',
    density: 24.4,
    imprecise: false,
    latitude: 41.99005,
    longitude: -83.82655,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49229',
  },
  {
    city: 'Brooklyn',
    county_fips: 26075,
    county_fips_all: '26075|26091',
    county: 'Jackson',
    county_names_all: 'Jackson|Lenawee',
    county_weights: '{"26075": 72.62, "26091": 27.38}',
    density: 60.8,
    imprecise: false,
    latitude: 42.09701,
    longitude: -84.22266,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 10077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49230',
  },
  {
    city: 'Camden',
    county_fips: 26059,
    county_fips_all: '26059',
    county: 'Hillsdale',
    county_names_all: 'Hillsdale',
    county_weights: '{"26059": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 41.74049,
    longitude: -84.66858,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49232',
  },
  {
    city: 'Cement City',
    county_fips: 26059,
    county_fips_all: '26059|26075|26091',
    county: 'Hillsdale',
    county_names_all: 'Hillsdale|Jackson|Lenawee',
    county_weights: '{"26059": 36.44, "26075": 35.29, "26091": 28.28}',
    density: 53.2,
    imprecise: false,
    latitude: 42.0644,
    longitude: -84.36512,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49233',
  },
  {
    city: 'Clarklake',
    county_fips: 26075,
    county_fips_all: '26075',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"26075": 100}',
    density: 45.6,
    imprecise: false,
    latitude: 42.12114,
    longitude: -84.3673,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49234',
  },
  {
    city: 'Clayton',
    county_fips: 26091,
    county_fips_all: '26091',
    county: 'Lenawee',
    county_names_all: 'Lenawee',
    county_weights: '{"26091": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 41.86348,
    longitude: -84.21348,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49235',
  },
  {
    city: 'Clinton',
    county_fips: 26091,
    county_fips_all: '26091|26161',
    county: 'Lenawee',
    county_names_all: 'Lenawee|Washtenaw',
    county_weights: '{"26091": 54.61, "26161": 45.39}',
    density: 51.6,
    imprecise: false,
    latitude: 42.07792,
    longitude: -83.95035,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49236',
  },
  {
    city: 'Concord',
    county_fips: 26075,
    county_fips_all: '26075|26025',
    county: 'Jackson',
    county_names_all: 'Jackson|Calhoun',
    county_weights: '{"26075": 94.22, "26025": 5.78}',
    density: 29.2,
    imprecise: false,
    latitude: 42.1731,
    longitude: -84.64906,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49237',
  },
  {
    city: 'Deerfield',
    county_fips: 26091,
    county_fips_all: '26091|26115',
    county: 'Lenawee',
    county_names_all: 'Lenawee|Monroe',
    county_weights: '{"26091": 70.2, "26115": 29.8}',
    density: 24.9,
    imprecise: false,
    latitude: 41.90593,
    longitude: -83.78809,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49238',
  },
  {
    city: 'Grass Lake',
    county_fips: 26075,
    county_fips_all: '26075|26161',
    county: 'Jackson',
    county_names_all: 'Jackson|Washtenaw',
    county_weights: '{"26075": 84.9, "26161": 15.1}',
    density: 32.9,
    imprecise: false,
    latitude: 42.27821,
    longitude: -84.18027,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49240',
  },
  {
    city: 'Hanover',
    county_fips: 26075,
    county_fips_all: '26075',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"26075": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 42.10121,
    longitude: -84.60149,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49241',
  },
  {
    city: 'Hillsdale',
    county_fips: 26059,
    county_fips_all: '26059',
    county: 'Hillsdale',
    county_names_all: 'Hillsdale',
    county_weights: '{"26059": 100}',
    density: 62.9,
    imprecise: false,
    latitude: 41.88434,
    longitude: -84.61581,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 14750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49242',
  },
  {
    city: 'Homer',
    county_fips: 26025,
    county_fips_all: '26025|26023|26075',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Branch|Jackson',
    county_weights: '{"26025": 96.35, "26023": 2.06, "26075": 1.59}',
    density: 19,
    imprecise: false,
    latitude: 42.14085,
    longitude: -84.81797,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49245',
  },
  {
    city: 'Horton',
    county_fips: 26075,
    county_fips_all: '26075|26059',
    county: 'Jackson',
    county_names_all: 'Jackson|Hillsdale',
    county_weights: '{"26075": 91.75, "26059": 8.25}',
    density: 37.9,
    imprecise: false,
    latitude: 42.12268,
    longitude: -84.50366,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49246',
  },
  {
    city: 'Hudson',
    county_fips: 26091,
    county_fips_all: '26091|26059',
    county: 'Lenawee',
    county_names_all: 'Lenawee|Hillsdale',
    county_weights: '{"26091": 63.95, "26059": 36.05}',
    density: 23.9,
    imprecise: false,
    latitude: 41.84712,
    longitude: -84.34189,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49247',
  },
  {
    city: 'Jasper',
    county_fips: 26091,
    county_fips_all: '26091',
    county: 'Lenawee',
    county_names_all: 'Lenawee',
    county_weights: '{"26091": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 41.75651,
    longitude: -84.01137,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49248',
  },
  {
    city: 'Jerome',
    county_fips: 26059,
    county_fips_all: '26059|26075',
    county: 'Hillsdale',
    county_names_all: 'Hillsdale|Jackson',
    county_weights: '{"26059": 95.64, "26075": 4.36}',
    density: 45.5,
    imprecise: false,
    latitude: 42.02275,
    longitude: -84.45575,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49249',
  },
  {
    city: 'Jonesville',
    county_fips: 26059,
    county_fips_all: '26059|26075',
    county: 'Hillsdale',
    county_names_all: 'Hillsdale|Jackson',
    county_weights: '{"26059": 96.17, "26075": 3.83}',
    density: 27.7,
    imprecise: false,
    latitude: 42.01875,
    longitude: -84.62168,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49250',
  },
  {
    city: 'Leslie',
    county_fips: 26065,
    county_fips_all: '26065|26075',
    county: 'Ingham',
    county_names_all: 'Ingham|Jackson',
    county_weights: '{"26065": 94.95, "26075": 5.05}',
    density: 39.4,
    imprecise: false,
    latitude: 42.46561,
    longitude: -84.40916,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49251',
  },
  {
    city: 'Litchfield',
    county_fips: 26059,
    county_fips_all: '26059|26023|26075|26025',
    county: 'Hillsdale',
    county_names_all: 'Hillsdale|Branch|Jackson|Calhoun',
    county_weights:
      '{"26059": 80.53, "26023": 7.9, "26075": 6.76, "26025": 4.81}',
    density: 23.1,
    imprecise: false,
    latitude: 42.03853,
    longitude: -84.76683,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49252',
  },
  {
    city: 'Manitou Beach',
    county_fips: 26091,
    county_fips_all: '26091',
    county: 'Lenawee',
    county_names_all: 'Lenawee',
    county_weights: '{"26091": 100}',
    density: 49.2,
    imprecise: false,
    latitude: 41.96443,
    longitude: -84.2697,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49253',
  },
  {
    city: 'Michigan Center',
    county_fips: 26075,
    county_fips_all: '26075',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"26075": 100}',
    density: 512.6,
    imprecise: false,
    latitude: 42.2268,
    longitude: -84.32165,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49254',
  },
  {
    city: 'Montgomery',
    county_fips: 26023,
    county_fips_all: '26023|26059',
    county: 'Branch',
    county_names_all: 'Branch|Hillsdale',
    county_weights: '{"26023": 60.89, "26059": 39.11}',
    density: 20.1,
    imprecise: false,
    latitude: 41.77152,
    longitude: -84.85499,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49255',
  },
  {
    city: 'Morenci',
    county_fips: 26091,
    county_fips_all: '26091',
    county: 'Lenawee',
    county_names_all: 'Lenawee',
    county_weights: '{"26091": 100}',
    density: 24.2,
    imprecise: false,
    latitude: 41.74989,
    longitude: -84.22122,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49256',
  },
  {
    city: 'Mosherville',
    county_fips: 26059,
    county_fips_all: '26059',
    county: 'Hillsdale',
    county_names_all: 'Hillsdale',
    county_weights: '{"26059": 100}',
    density: 770.4,
    imprecise: false,
    latitude: 42.06,
    longitude: -84.65833,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49258',
  },
  {
    city: 'Munith',
    county_fips: 26075,
    county_fips_all: '26075',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"26075": 100}',
    density: 35.2,
    imprecise: false,
    latitude: 42.38099,
    longitude: -84.25763,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49259',
  },
  {
    city: 'Napoleon',
    county_fips: 26075,
    county_fips_all: '26075',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"26075": 100}',
    density: 105.4,
    imprecise: false,
    latitude: 42.16174,
    longitude: -84.2472,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49261',
  },
  {
    city: 'North Adams',
    county_fips: 26059,
    county_fips_all: '26059',
    county: 'Hillsdale',
    county_names_all: 'Hillsdale',
    county_weights: '{"26059": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 41.96162,
    longitude: -84.4673,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49262',
  },
  {
    city: 'Norvell',
    county_fips: 26075,
    county_fips_all: '26075',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"26075": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.15817,
    longitude: -84.18225,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49263',
  },
  {
    city: 'Onondaga',
    county_fips: 26065,
    county_fips_all: '26065|26075|26045',
    county: 'Ingham',
    county_names_all: 'Ingham|Jackson|Eaton',
    county_weights: '{"26065": 71.83, "26075": 26.3, "26045": 1.87}',
    density: 21,
    imprecise: false,
    latitude: 42.44118,
    longitude: -84.55122,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49264',
  },
  {
    city: 'Onsted',
    county_fips: 26091,
    county_fips_all: '26091',
    county: 'Lenawee',
    county_names_all: 'Lenawee',
    county_weights: '{"26091": 100}',
    density: 61.5,
    imprecise: false,
    latitude: 42.01022,
    longitude: -84.17432,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49265',
  },
  {
    city: 'Osseo',
    county_fips: 26059,
    county_fips_all: '26059',
    county: 'Hillsdale',
    county_names_all: 'Hillsdale',
    county_weights: '{"26059": 100}',
    density: 25.6,
    imprecise: false,
    latitude: 41.84247,
    longitude: -84.54641,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49266',
  },
  {
    city: 'Ottawa Lake',
    county_fips: 26115,
    county_fips_all: '26115|26091',
    county: 'Monroe',
    county_names_all: 'Monroe|Lenawee',
    county_weights: '{"26115": 79.25, "26091": 20.75}',
    density: 39.4,
    imprecise: false,
    latitude: 41.75979,
    longitude: -83.72341,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49267',
  },
  {
    city: 'Palmyra',
    county_fips: 26091,
    county_fips_all: '26091',
    county: 'Lenawee',
    county_names_all: 'Lenawee',
    county_weights: '{"26091": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 41.87156,
    longitude: -83.92565,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49268',
  },
  {
    city: 'Parma',
    county_fips: 26075,
    county_fips_all: '26075',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"26075": 100}',
    density: 38.3,
    imprecise: false,
    latitude: 42.29307,
    longitude: -84.586,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49269',
  },
  {
    city: 'Petersburg',
    county_fips: 26115,
    county_fips_all: '26115',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"26115": 100}',
    density: 47.9,
    imprecise: false,
    latitude: 41.86864,
    longitude: -83.68206,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49270',
  },
  {
    city: 'Pittsford',
    county_fips: 26059,
    county_fips_all: '26059',
    county: 'Hillsdale',
    county_names_all: 'Hillsdale',
    county_weights: '{"26059": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 41.83813,
    longitude: -84.45382,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49271',
  },
  {
    city: 'Pleasant Lake',
    county_fips: 26075,
    county_fips_all: '26075',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"26075": 100}',
    density: 100,
    imprecise: false,
    latitude: 42.39299,
    longitude: -84.34974,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49272',
  },
  {
    city: 'Reading',
    county_fips: 26059,
    county_fips_all: '26059|26023',
    county: 'Hillsdale',
    county_names_all: 'Hillsdale|Branch',
    county_weights: '{"26059": 84.12, "26023": 15.88}',
    density: 23,
    imprecise: false,
    latitude: 41.83689,
    longitude: -84.76419,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49274',
  },
  {
    city: 'Riga',
    county_fips: 26091,
    county_fips_all: '26091|26115',
    county: 'Lenawee',
    county_names_all: 'Lenawee|Monroe',
    county_weights: '{"26091": 68.77, "26115": 31.23}',
    density: 11.9,
    imprecise: false,
    latitude: 41.79733,
    longitude: -83.7843,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49276',
  },
  {
    city: 'Rives Junction',
    county_fips: 26075,
    county_fips_all: '26075',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"26075": 100}',
    density: 34.2,
    imprecise: false,
    latitude: 42.38871,
    longitude: -84.46679,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49277',
  },
  {
    city: 'Sand Creek',
    county_fips: 26091,
    county_fips_all: '26091',
    county: 'Lenawee',
    county_names_all: 'Lenawee',
    county_weights: '{"26091": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 41.77965,
    longitude: -84.10409,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49279',
  },
  {
    city: 'Somerset Center',
    county_fips: 26059,
    county_fips_all: '26059',
    county: 'Hillsdale',
    county_names_all: 'Hillsdale',
    county_weights: '{"26059": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 42.03496,
    longitude: -84.40518,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 82,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49282',
  },
  {
    city: 'Spring Arbor',
    county_fips: 26075,
    county_fips_all: '26075',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"26075": 100}',
    density: 134.5,
    imprecise: false,
    latitude: 42.20486,
    longitude: -84.55478,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49283',
  },
  {
    city: 'Springport',
    county_fips: 26075,
    county_fips_all: '26075|26025|26045',
    county: 'Jackson',
    county_names_all: 'Jackson|Calhoun|Eaton',
    county_weights: '{"26075": 62.32, "26025": 30.02, "26045": 7.66}',
    density: 18.1,
    imprecise: false,
    latitude: 42.38507,
    longitude: -84.69128,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49284',
  },
  {
    city: 'Stockbridge',
    county_fips: 26065,
    county_fips_all: '26065|26075|26093|26161',
    county: 'Ingham',
    county_names_all: 'Ingham|Jackson|Livingston|Washtenaw',
    county_weights:
      '{"26065": 80.17, "26075": 10.11, "26093": 6.36, "26161": 3.36}',
    density: 31.7,
    imprecise: false,
    latitude: 42.46855,
    longitude: -84.20752,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49285',
  },
  {
    city: 'Tecumseh',
    county_fips: 26091,
    county_fips_all: '26091',
    county: 'Lenawee',
    county_names_all: 'Lenawee',
    county_weights: '{"26091": 100}',
    density: 93.8,
    imprecise: false,
    latitude: 42.01443,
    longitude: -83.93447,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 14128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49286',
  },
  {
    city: 'Tipton',
    county_fips: 26091,
    county_fips_all: '26091|26161',
    county: 'Lenawee',
    county_names_all: 'Lenawee|Washtenaw',
    county_weights: '{"26091": 94.36, "26161": 5.64}',
    density: 27,
    imprecise: false,
    latitude: 42.02177,
    longitude: -84.08263,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49287',
  },
  {
    city: 'Waldron',
    county_fips: 26059,
    county_fips_all: '26059|26091',
    county: 'Hillsdale',
    county_names_all: 'Hillsdale|Lenawee',
    county_weights: '{"26059": 87.41, "26091": 12.59}',
    density: 15.1,
    imprecise: false,
    latitude: 41.73534,
    longitude: -84.43211,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49288',
  },
  {
    city: 'Weston',
    county_fips: 26091,
    county_fips_all: '26091',
    county: 'Lenawee',
    county_names_all: 'Lenawee',
    county_weights: '{"26091": 100}',
    density: 210.8,
    imprecise: false,
    latitude: 41.77144,
    longitude: -84.10702,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49289',
  },
  {
    city: 'Ada',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 134.8,
    imprecise: false,
    latitude: 42.97716,
    longitude: -85.47671,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 19846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49301',
  },
  {
    city: 'Alto',
    county_fips: 26081,
    county_fips_all: '26081|26067',
    county: 'Kent',
    county_names_all: 'Kent|Ionia',
    county_weights: '{"26081": 99.78, "26067": 0.22}',
    density: 75.3,
    imprecise: false,
    latitude: 42.82307,
    longitude: -85.39871,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49302',
  },
  {
    city: 'Bailey',
    county_fips: 26121,
    county_fips_all: '26121|26123',
    county: 'Muskegon',
    county_names_all: 'Muskegon|Newaygo',
    county_weights: '{"26121": 93.51, "26123": 6.49}',
    density: 20.2,
    imprecise: false,
    latitude: 43.27803,
    longitude: -85.85824,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49303',
  },
  {
    city: 'Baldwin',
    county_fips: 26085,
    county_fips_all: '26085',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"26085": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 43.91027,
    longitude: -85.87417,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49304',
  },
  {
    city: 'Barryton',
    county_fips: 26107,
    county_fips_all: '26107|26073',
    county: 'Mecosta',
    county_names_all: 'Mecosta|Isabella',
    county_weights: '{"26107": 84.36, "26073": 15.64}',
    density: 18,
    imprecise: false,
    latitude: 43.74926,
    longitude: -85.15023,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49305',
  },
  {
    city: 'Belmont',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 231.1,
    imprecise: false,
    latitude: 43.07296,
    longitude: -85.56939,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49306',
  },
  {
    city: 'Big Rapids',
    county_fips: 26107,
    county_fips_all: '26107|26123',
    county: 'Mecosta',
    county_names_all: 'Mecosta|Newaygo',
    county_weights: '{"26107": 80.59, "26123": 19.41}',
    density: 52.8,
    imprecise: false,
    latitude: 43.69797,
    longitude: -85.48272,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49307',
  },
  {
    city: 'Bitely',
    county_fips: 26123,
    county_fips_all: '26123|26085',
    county: 'Newaygo',
    county_names_all: 'Newaygo|Lake',
    county_weights: '{"26123": 95.02, "26085": 4.98}',
    density: 5.6,
    imprecise: false,
    latitude: 43.76021,
    longitude: -85.87842,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49309',
  },
  {
    city: 'Blanchard',
    county_fips: 26073,
    county_fips_all: '26073|26107|26117',
    county: 'Isabella',
    county_names_all: 'Isabella|Mecosta|Montcalm',
    county_weights: '{"26073": 62.68, "26107": 35.0, "26117": 2.32}',
    density: 14,
    imprecise: false,
    latitude: 43.51525,
    longitude: -85.05448,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49310',
  },
  {
    city: 'Brohman',
    county_fips: 26123,
    county_fips_all: '26123',
    county: 'Newaygo',
    county_names_all: 'Newaygo',
    county_weights: '{"26123": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 43.69009,
    longitude: -85.79992,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49312',
  },
  {
    city: 'Byron Center',
    county_fips: 26081,
    county_fips_all: '26081|26139|26005',
    county: 'Kent',
    county_names_all: 'Kent|Ottawa|Allegan',
    county_weights: '{"26081": 71.77, "26139": 18.14, "26005": 10.09}',
    density: 189.5,
    imprecise: false,
    latitude: 42.80101,
    longitude: -85.73589,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 27091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49315',
  },
  {
    city: 'Caledonia',
    county_fips: 26081,
    county_fips_all: '26081|26005|26015',
    county: 'Kent',
    county_names_all: 'Kent|Allegan|Barry',
    county_weights: '{"26081": 78.27, "26005": 18.86, "26015": 2.87}',
    density: 178.7,
    imprecise: false,
    latitude: 42.79644,
    longitude: -85.55564,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 26427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49316',
  },
  {
    city: 'Casnovia',
    county_fips: 26121,
    county_fips_all: '26121|26139|26081',
    county: 'Muskegon',
    county_names_all: 'Muskegon|Ottawa|Kent',
    county_weights: '{"26121": 72.89, "26139": 23.24, "26081": 3.87}',
    density: 30.9,
    imprecise: false,
    latitude: 43.22319,
    longitude: -85.82981,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49318',
  },
  {
    city: 'Cedar Springs',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 84.1,
    imprecise: false,
    latitude: 43.22767,
    longitude: -85.5281,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49319',
  },
  {
    city: 'Chippewa Lake',
    county_fips: 26107,
    county_fips_all: '26107',
    county: 'Mecosta',
    county_names_all: 'Mecosta',
    county_weights: '{"26107": 100}',
    density: 53.5,
    imprecise: false,
    latitude: 43.75264,
    longitude: -85.29276,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49320',
  },
  {
    city: 'Comstock Park',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 234.2,
    imprecise: false,
    latitude: 43.0737,
    longitude: -85.68198,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 15970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49321',
  },
  {
    city: 'Coral',
    county_fips: 26117,
    county_fips_all: '26117',
    county: 'Montcalm',
    county_names_all: 'Montcalm',
    county_weights: '{"26117": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 43.35685,
    longitude: -85.35261,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49322',
  },
  {
    city: 'Dorr',
    county_fips: 26005,
    county_fips_all: '26005|26139',
    county: 'Allegan',
    county_names_all: 'Allegan|Ottawa',
    county_weights: '{"26005": 99.0, "26139": 1.0}',
    density: 85.3,
    imprecise: false,
    latitude: 42.72541,
    longitude: -85.7871,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49323',
  },
  {
    city: 'Freeport',
    county_fips: 26015,
    county_fips_all: '26015|26067|26081',
    county: 'Barry',
    county_names_all: 'Barry|Ionia|Kent',
    county_weights: '{"26015": 69.13, "26067": 20.99, "26081": 9.88}',
    density: 37.6,
    imprecise: false,
    latitude: 42.76155,
    longitude: -85.30162,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49325',
  },
  {
    city: 'Gowen',
    county_fips: 26081,
    county_fips_all: '26081|26117',
    county: 'Kent',
    county_names_all: 'Kent|Montcalm',
    county_weights: '{"26081": 61.73, "26117": 38.27}',
    density: 63.8,
    imprecise: false,
    latitude: 43.25069,
    longitude: -85.32083,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49326',
  },
  {
    city: 'Grant',
    county_fips: 26123,
    county_fips_all: '26123|26121|26081',
    county: 'Newaygo',
    county_names_all: 'Newaygo|Muskegon|Kent',
    county_weights: '{"26123": 98.9, "26121": 0.61, "26081": 0.49}',
    density: 37.7,
    imprecise: false,
    latitude: 43.33507,
    longitude: -85.84558,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49327',
  },
  {
    city: 'Hopkins',
    county_fips: 26005,
    county_fips_all: '26005',
    county: 'Allegan',
    county_names_all: 'Allegan',
    county_weights: '{"26005": 100}',
    density: 28.5,
    imprecise: false,
    latitude: 42.6304,
    longitude: -85.75703,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49328',
  },
  {
    city: 'Howard City',
    county_fips: 26117,
    county_fips_all: '26117|26123',
    county: 'Montcalm',
    county_names_all: 'Montcalm|Newaygo',
    county_weights: '{"26117": 77.62, "26123": 22.38}',
    density: 45,
    imprecise: false,
    latitude: 43.40567,
    longitude: -85.48771,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49329',
  },
  {
    city: 'Kent City',
    county_fips: 26081,
    county_fips_all: '26081|26123|26139|26121',
    county: 'Kent',
    county_names_all: 'Kent|Newaygo|Ottawa|Muskegon',
    county_weights:
      '{"26081": 86.96, "26123": 8.2, "26139": 3.77, "26121": 1.07}',
    density: 49.4,
    imprecise: false,
    latitude: 43.24463,
    longitude: -85.73721,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49330',
  },
  {
    city: 'Lowell',
    county_fips: 26081,
    county_fips_all: '26081|26067',
    county: 'Kent',
    county_names_all: 'Kent|Ionia',
    county_weights: '{"26081": 78.74, "26067": 21.26}',
    density: 74.5,
    imprecise: false,
    latitude: 42.95161,
    longitude: -85.35139,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49331',
  },
  {
    city: 'Mecosta',
    county_fips: 26107,
    county_fips_all: '26107',
    county: 'Mecosta',
    county_names_all: 'Mecosta',
    county_weights: '{"26107": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 43.62323,
    longitude: -85.24468,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49332',
  },
  {
    city: 'Middleville',
    county_fips: 26015,
    county_fips_all: '26015|26081|26005',
    county: 'Barry',
    county_names_all: 'Barry|Kent|Allegan',
    county_weights: '{"26015": 96.51, "26081": 2.26, "26005": 1.23}',
    density: 62.2,
    imprecise: false,
    latitude: 42.69546,
    longitude: -85.46343,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 12753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49333',
  },
  {
    city: 'Moline',
    county_fips: 26005,
    county_fips_all: '26005',
    county: 'Allegan',
    county_names_all: 'Allegan',
    county_weights: '{"26005": 100}',
    density: 156.6,
    imprecise: false,
    latitude: 42.74626,
    longitude: -85.66907,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49335',
  },
  {
    city: 'Morley',
    county_fips: 26107,
    county_fips_all: '26107|26117|26123',
    county: 'Mecosta',
    county_names_all: 'Mecosta|Montcalm|Newaygo',
    county_weights: '{"26107": 90.15, "26117": 9.06, "26123": 0.79}',
    density: 22.9,
    imprecise: false,
    latitude: 43.50752,
    longitude: -85.42862,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49336',
  },
  {
    city: 'Newaygo',
    county_fips: 26123,
    county_fips_all: '26123|26117|26107',
    county: 'Newaygo',
    county_names_all: 'Newaygo|Montcalm|Mecosta',
    county_weights: '{"26123": 94.62, "26117": 3.14, "26107": 2.24}',
    density: 46,
    imprecise: false,
    latitude: 43.43472,
    longitude: -85.71437,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 13149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49337',
  },
  {
    city: 'Paris',
    county_fips: 26123,
    county_fips_all: '26123|26107|26133',
    county: 'Newaygo',
    county_names_all: 'Newaygo|Mecosta|Osceola',
    county_weights: '{"26123": 70.14, "26107": 29.67, "26133": 0.19}',
    density: 13.4,
    imprecise: false,
    latitude: 43.75888,
    longitude: -85.61033,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49338',
  },
  {
    city: 'Pierson',
    county_fips: 26117,
    county_fips_all: '26117|26123',
    county: 'Montcalm',
    county_names_all: 'Montcalm|Newaygo',
    county_weights: '{"26117": 95.15, "26123": 4.85}',
    density: 28.2,
    imprecise: false,
    latitude: 43.33574,
    longitude: -85.49454,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49339',
  },
  {
    city: 'Remus',
    county_fips: 26107,
    county_fips_all: '26107|26073',
    county: 'Mecosta',
    county_names_all: 'Mecosta|Isabella',
    county_weights: '{"26107": 70.72, "26073": 29.28}',
    density: 11,
    imprecise: false,
    latitude: 43.62213,
    longitude: -85.11222,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49340',
  },
  {
    city: 'Rockford',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 180,
    imprecise: false,
    latitude: 43.12433,
    longitude: -85.49246,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 39409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49341',
  },
  {
    city: 'Rodney',
    county_fips: 26107,
    county_fips_all: '26107',
    county: 'Mecosta',
    county_names_all: 'Mecosta',
    county_weights: '{"26107": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 43.69634,
    longitude: -85.32156,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49342',
  },
  {
    city: 'Sand Lake',
    county_fips: 26081,
    county_fips_all: '26081|26123|26117',
    county: 'Kent',
    county_names_all: 'Kent|Newaygo|Montcalm',
    county_weights: '{"26081": 52.9, "26123": 36.93, "26117": 10.17}',
    density: 39.6,
    imprecise: false,
    latitude: 43.29579,
    longitude: -85.53115,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49343',
  },
  {
    city: 'Shelbyville',
    county_fips: 26005,
    county_fips_all: '26005|26015',
    county: 'Allegan',
    county_names_all: 'Allegan|Barry',
    county_weights: '{"26005": 80.72, "26015": 19.28}',
    density: 47,
    imprecise: false,
    latitude: 42.5919,
    longitude: -85.59028,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49344',
  },
  {
    city: 'Sparta',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 100,
    imprecise: false,
    latitude: 43.15419,
    longitude: -85.70224,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 13512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49345',
  },
  {
    city: 'Stanwood',
    county_fips: 26107,
    county_fips_all: '26107|26123',
    county: 'Mecosta',
    county_names_all: 'Mecosta|Newaygo',
    county_weights: '{"26107": 96.97, "26123": 3.03}',
    density: 33.2,
    imprecise: false,
    latitude: 43.58616,
    longitude: -85.42213,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49346',
  },
  {
    city: 'Trufant',
    county_fips: 26117,
    county_fips_all: '26117|26081',
    county: 'Montcalm',
    county_names_all: 'Montcalm|Kent',
    county_weights: '{"26117": 97.01, "26081": 2.99}',
    density: 34.2,
    imprecise: false,
    latitude: 43.31488,
    longitude: -85.34352,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49347',
  },
  {
    city: 'Wayland',
    county_fips: 26005,
    county_fips_all: '26005|26015|26081',
    county: 'Allegan',
    county_names_all: 'Allegan|Barry|Kent',
    county_weights: '{"26005": 89.89, "26015": 8.15, "26081": 1.96}',
    density: 80.5,
    imprecise: false,
    latitude: 42.68379,
    longitude: -85.61619,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 13699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49348',
  },
  {
    city: 'White Cloud',
    county_fips: 26123,
    county_fips_all: '26123',
    county: 'Newaygo',
    county_names_all: 'Newaygo',
    county_weights: '{"26123": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 43.58291,
    longitude: -85.74167,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49349',
  },
  {
    city: 'Allendale',
    county_fips: 26139,
    county_fips_all: '26139',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"26139": 100}',
    density: 359,
    imprecise: false,
    latitude: 42.9763,
    longitude: -85.95604,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 29674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49401',
  },
  {
    city: 'Branch',
    county_fips: 26085,
    county_fips_all: '26085|26105|26127',
    county: 'Lake',
    county_names_all: 'Lake|Mason|Oceana',
    county_weights: '{"26085": 51.85, "26105": 47.01, "26127": 1.14}',
    density: 3.9,
    imprecise: false,
    latitude: 43.94228,
    longitude: -86.03284,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49402',
  },
  {
    city: 'Conklin',
    county_fips: 26139,
    county_fips_all: '26139|26121|26081',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Muskegon|Kent',
    county_weights: '{"26139": 88.85, "26121": 6.94, "26081": 4.21}',
    density: 20.3,
    imprecise: false,
    latitude: 43.13316,
    longitude: -85.85022,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49403',
  },
  {
    city: 'Coopersville',
    county_fips: 26139,
    county_fips_all: '26139|26121',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Muskegon',
    county_weights: '{"26139": 93.56, "26121": 6.44}',
    density: 56.5,
    imprecise: false,
    latitude: 43.06602,
    longitude: -85.95129,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49404',
  },
  {
    city: 'Custer',
    county_fips: 26105,
    county_fips_all: '26105',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"26105": 100}',
    density: 9,
    imprecise: false,
    latitude: 43.91051,
    longitude: -86.18931,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49405',
  },
  {
    city: 'Douglas',
    county_fips: 26005,
    county_fips_all: '26005',
    county: 'Allegan',
    county_names_all: 'Allegan',
    county_weights: '{"26005": 100}',
    density: 279,
    imprecise: false,
    latitude: 42.64224,
    longitude: -86.209,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49406',
  },
  {
    city: 'Fennville',
    county_fips: 26005,
    county_fips_all: '26005',
    county: 'Allegan',
    county_names_all: 'Allegan',
    county_weights: '{"26005": 100}',
    density: 36.8,
    imprecise: false,
    latitude: 42.57077,
    longitude: -86.11479,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 10288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49408',
  },
  {
    city: 'Ferrysburg',
    county_fips: 26139,
    county_fips_all: '26139',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"26139": 100}',
    density: 270.6,
    imprecise: false,
    latitude: 43.08077,
    longitude: -86.21826,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49409',
  },
  {
    city: 'Fountain',
    county_fips: 26105,
    county_fips_all: '26105',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"26105": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 44.01986,
    longitude: -86.14265,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49410',
  },
  {
    city: 'Free Soil',
    county_fips: 26105,
    county_fips_all: '26105|26101',
    county: 'Mason',
    county_names_all: 'Mason|Manistee',
    county_weights: '{"26105": 95.07, "26101": 4.93}',
    density: 6,
    imprecise: false,
    latitude: 44.11006,
    longitude: -86.25385,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49411',
  },
  {
    city: 'Fremont',
    county_fips: 26123,
    county_fips_all: '26123|26127|26121',
    county: 'Newaygo',
    county_names_all: 'Newaygo|Oceana|Muskegon',
    county_weights: '{"26123": 97.26, "26127": 1.99, "26121": 0.75}',
    density: 42.3,
    imprecise: false,
    latitude: 43.4699,
    longitude: -85.94747,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 12097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49412',
  },
  {
    city: 'Fruitport',
    county_fips: 26121,
    county_fips_all: '26121|26139',
    county: 'Muskegon',
    county_names_all: 'Muskegon|Ottawa',
    county_weights: '{"26121": 91.8, "26139": 8.2}',
    density: 88.5,
    imprecise: false,
    latitude: 43.15238,
    longitude: -86.1166,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49415',
  },
  {
    city: 'Grand Haven',
    county_fips: 26139,
    county_fips_all: '26139',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"26139": 100}',
    density: 279.2,
    imprecise: false,
    latitude: 43.01519,
    longitude: -86.14387,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 33878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49417',
  },
  {
    city: 'Grandville',
    county_fips: 26081,
    county_fips_all: '26081|26139',
    county: 'Kent',
    county_names_all: 'Kent|Ottawa',
    county_weights: '{"26081": 64.35, "26139": 35.65}',
    density: 648.9,
    imprecise: false,
    latitude: 42.8774,
    longitude: -85.77226,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 31913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49418',
  },
  {
    city: 'Hamilton',
    county_fips: 26005,
    county_fips_all: '26005',
    county: 'Allegan',
    county_names_all: 'Allegan',
    county_weights: '{"26005": 100}',
    density: 45.8,
    imprecise: false,
    latitude: 42.67768,
    longitude: -85.97826,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49419',
  },
  {
    city: 'Hart',
    county_fips: 26127,
    county_fips_all: '26127',
    county: 'Oceana',
    county_names_all: 'Oceana',
    county_weights: '{"26127": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 43.71958,
    longitude: -86.2811,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49420',
  },
  {
    city: 'Hesperia',
    county_fips: 26127,
    county_fips_all: '26127|26123',
    county: 'Oceana',
    county_names_all: 'Oceana|Newaygo',
    county_weights: '{"26127": 59.76, "26123": 40.24}',
    density: 17.4,
    imprecise: false,
    latitude: 43.59945,
    longitude: -86.06658,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49421',
  },
  {
    city: 'Holland',
    county_fips: 26005,
    county_fips_all: '26005|26139',
    county: 'Allegan',
    county_names_all: 'Allegan|Ottawa',
    county_weights: '{"26005": 82.62, "26139": 17.38}',
    density: 233.4,
    imprecise: false,
    latitude: 42.73964,
    longitude: -86.09015,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 47060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49423',
  },
  {
    city: 'Holland',
    county_fips: 26139,
    county_fips_all: '26139',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"26139": 100}',
    density: 335.7,
    imprecise: false,
    latitude: 42.84269,
    longitude: -86.12431,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 49810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49424',
  },
  {
    city: 'Holton',
    county_fips: 26121,
    county_fips_all: '26121|26127|26123',
    county: 'Muskegon',
    county_names_all: 'Muskegon|Oceana|Newaygo',
    county_weights: '{"26121": 63.19, "26127": 27.52, "26123": 9.29}',
    density: 21.2,
    imprecise: false,
    latitude: 43.43941,
    longitude: -86.09981,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49425',
  },
  {
    city: 'Hudsonville',
    county_fips: 26139,
    county_fips_all: '26139|26005',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Allegan',
    county_weights: '{"26139": 99.53, "26005": 0.47}',
    density: 259.5,
    imprecise: false,
    latitude: 42.86636,
    longitude: -85.89038,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 40523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49426',
  },
  {
    city: 'Jenison',
    county_fips: 26139,
    county_fips_all: '26139',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"26139": 100}',
    density: 678,
    imprecise: false,
    latitude: 42.92042,
    longitude: -85.83712,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 28209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49428',
  },
  {
    city: 'Lamont',
    county_fips: 26139,
    county_fips_all: '26139',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"26139": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 43.01192,
    longitude: -85.90053,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49430',
  },
  {
    city: 'Ludington',
    county_fips: 26105,
    county_fips_all: '26105',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"26105": 100}',
    density: 69.1,
    imprecise: false,
    latitude: 43.97251,
    longitude: -86.39792,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 17184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49431',
  },
  {
    city: 'Macatawa',
    county_fips: 26139,
    county_fips_all: '26139|26005',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Allegan',
    county_weights: '{"26139": 88.77, "26005": 11.23}',
    density: 574.9,
    imprecise: false,
    latitude: 42.76975,
    longitude: -86.20774,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49434',
  },
  {
    city: 'Marne',
    county_fips: 26139,
    county_fips_all: '26139|26081',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Kent',
    county_weights: '{"26139": 98.43, "26081": 1.57}',
    density: 68.6,
    imprecise: false,
    latitude: 43.02683,
    longitude: -85.84049,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49435',
  },
  {
    city: 'Mears',
    county_fips: 26127,
    county_fips_all: '26127',
    county: 'Oceana',
    county_names_all: 'Oceana',
    county_weights: '{"26127": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 43.68042,
    longitude: -86.46203,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49436',
  },
  {
    city: 'Montague',
    county_fips: 26121,
    county_fips_all: '26121|26127',
    county: 'Muskegon',
    county_names_all: 'Muskegon|Oceana',
    county_weights: '{"26121": 62.36, "26127": 37.64}',
    density: 40.6,
    imprecise: false,
    latitude: 43.4588,
    longitude: -86.38121,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49437',
  },
  {
    city: 'Muskegon',
    county_fips: 26121,
    county_fips_all: '26121',
    county: 'Muskegon',
    county_names_all: 'Muskegon',
    county_weights: '{"26121": 100}',
    density: 952.9,
    imprecise: false,
    latitude: 43.23852,
    longitude: -86.25387,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49440',
  },
  {
    city: 'Muskegon',
    county_fips: 26121,
    county_fips_all: '26121',
    county: 'Muskegon',
    county_names_all: 'Muskegon',
    county_weights: '{"26121": 100}',
    density: 654.3,
    imprecise: false,
    latitude: 43.18745,
    longitude: -86.2736,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 36779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49441',
  },
  {
    city: 'Muskegon',
    county_fips: 26121,
    county_fips_all: '26121',
    county: 'Muskegon',
    county_names_all: 'Muskegon',
    county_weights: '{"26121": 100}',
    density: 421.4,
    imprecise: false,
    latitude: 43.23995,
    longitude: -86.13278,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 44766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49442',
  },
  {
    city: 'Muskegon',
    county_fips: 26121,
    county_fips_all: '26121',
    county: 'Muskegon',
    county_names_all: 'Muskegon',
    county_weights: '{"26121": 100}',
    density: 547.7,
    imprecise: false,
    latitude: 43.22204,
    longitude: -86.24155,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49443',
  },
  {
    city: 'Muskegon',
    county_fips: 26121,
    county_fips_all: '26121',
    county: 'Muskegon',
    county_names_all: 'Muskegon',
    county_weights: '{"26121": 100}',
    density: 412.7,
    imprecise: false,
    latitude: 43.17671,
    longitude: -86.19892,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 26372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49444',
  },
  {
    city: 'Muskegon',
    county_fips: 26121,
    county_fips_all: '26121',
    county: 'Muskegon',
    county_names_all: 'Muskegon',
    county_weights: '{"26121": 100}',
    density: 134.6,
    imprecise: false,
    latitude: 43.297,
    longitude: -86.27481,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49445',
  },
  {
    city: 'New Era',
    county_fips: 26127,
    county_fips_all: '26127',
    county: 'Oceana',
    county_names_all: 'Oceana',
    county_weights: '{"26127": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 43.55306,
    longitude: -86.39096,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49446',
  },
  {
    city: 'Nunica',
    county_fips: 26139,
    county_fips_all: '26139|26121',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Muskegon',
    county_weights: '{"26139": 80.64, "26121": 19.36}',
    density: 51.1,
    imprecise: false,
    latitude: 43.09074,
    longitude: -86.07432,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49448',
  },
  {
    city: 'Pentwater',
    county_fips: 26127,
    county_fips_all: '26127|26105',
    county: 'Oceana',
    county_names_all: 'Oceana|Mason',
    county_weights: '{"26127": 68.65, "26105": 31.35}',
    density: 23.9,
    imprecise: false,
    latitude: 43.79927,
    longitude: -86.37496,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49449',
  },
  {
    city: 'Pullman',
    county_fips: 26005,
    county_fips_all: '26005',
    county: 'Allegan',
    county_names_all: 'Allegan',
    county_weights: '{"26005": 100}',
    density: 39.5,
    imprecise: false,
    latitude: 42.48333,
    longitude: -86.08051,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49450',
  },
  {
    city: 'Ravenna',
    county_fips: 26121,
    county_fips_all: '26121|26139|26123',
    county: 'Muskegon',
    county_names_all: 'Muskegon|Ottawa|Newaygo',
    county_weights: '{"26121": 95.29, "26139": 3.92, "26123": 0.79}',
    density: 29.1,
    imprecise: false,
    latitude: 43.21177,
    longitude: -85.96966,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49451',
  },
  {
    city: 'Rothbury',
    county_fips: 26127,
    county_fips_all: '26127',
    county: 'Oceana',
    county_names_all: 'Oceana',
    county_weights: '{"26127": 100}',
    density: 19,
    imprecise: false,
    latitude: 43.51316,
    longitude: -86.25548,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49452',
  },
  {
    city: 'Saugatuck',
    county_fips: 26005,
    county_fips_all: '26005',
    county: 'Allegan',
    county_names_all: 'Allegan',
    county_weights: '{"26005": 100}',
    density: 108.2,
    imprecise: false,
    latitude: 42.66511,
    longitude: -86.17388,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49453',
  },
  {
    city: 'Scottville',
    county_fips: 26105,
    county_fips_all: '26105',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"26105": 100}',
    density: 25.9,
    imprecise: false,
    latitude: 43.95208,
    longitude: -86.28638,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49454',
  },
  {
    city: 'Shelby',
    county_fips: 26127,
    county_fips_all: '26127',
    county: 'Oceana',
    county_names_all: 'Oceana',
    county_weights: '{"26127": 100}',
    density: 24.7,
    imprecise: false,
    latitude: 43.60976,
    longitude: -86.36723,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49455',
  },
  {
    city: 'Spring Lake',
    county_fips: 26139,
    county_fips_all: '26139|26121',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Muskegon',
    county_weights: '{"26139": 88.15, "26121": 11.85}',
    density: 304,
    imprecise: false,
    latitude: 43.09026,
    longitude: -86.19347,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 19931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49456',
  },
  {
    city: 'Twin Lake',
    county_fips: 26121,
    county_fips_all: '26121|26123',
    county: 'Muskegon',
    county_names_all: 'Muskegon|Newaygo',
    county_weights: '{"26121": 97.17, "26123": 2.83}',
    density: 52.8,
    imprecise: false,
    latitude: 43.35105,
    longitude: -86.14455,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 11086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49457',
  },
  {
    city: 'Walhalla',
    county_fips: 26105,
    county_fips_all: '26105',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"26105": 100}',
    density: 138.9,
    imprecise: false,
    latitude: 43.94818,
    longitude: -86.11529,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49458',
  },
  {
    city: 'Walkerville',
    county_fips: 26127,
    county_fips_all: '26127|26123',
    county: 'Oceana',
    county_names_all: 'Oceana|Newaygo',
    county_weights: '{"26127": 94.54, "26123": 5.46}',
    density: 7.4,
    imprecise: false,
    latitude: 43.73678,
    longitude: -86.10805,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49459',
  },
  {
    city: 'West Olive',
    county_fips: 26139,
    county_fips_all: '26139',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"26139": 100}',
    density: 66.3,
    imprecise: false,
    latitude: 42.93473,
    longitude: -86.1429,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49460',
  },
  {
    city: 'Whitehall',
    county_fips: 26121,
    county_fips_all: '26121',
    county: 'Muskegon',
    county_names_all: 'Muskegon',
    county_weights: '{"26121": 100}',
    density: 86.7,
    imprecise: false,
    latitude: 43.38215,
    longitude: -86.32317,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49461',
  },
  {
    city: 'Zeeland',
    county_fips: 26139,
    county_fips_all: '26139|26005',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Allegan',
    county_weights: '{"26139": 94.76, "26005": 5.24}',
    density: 152.6,
    imprecise: false,
    latitude: 42.84183,
    longitude: -85.98338,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 28914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49464',
  },
  {
    city: 'Grand Rapids',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 2100.3,
    imprecise: false,
    latitude: 42.96282,
    longitude: -85.65872,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 39489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49503',
  },
  {
    city: 'Grand Rapids',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 1398.8,
    imprecise: false,
    latitude: 42.98047,
    longitude: -85.70937,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 40036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49504',
  },
  {
    city: 'Grand Rapids',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 1429.8,
    imprecise: false,
    latitude: 42.9984,
    longitude: -85.63699,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 32426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49505',
  },
  {
    city: 'Grand Rapids',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 1838.9,
    imprecise: false,
    latitude: 42.94515,
    longitude: -85.6136,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 34673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49506',
  },
  {
    city: 'Grand Rapids',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 2682.3,
    imprecise: false,
    latitude: 42.93054,
    longitude: -85.65524,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 38487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49507',
  },
  {
    city: 'Grand Rapids',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 1400.9,
    imprecise: false,
    latitude: 42.87459,
    longitude: -85.62586,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 42720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49508',
  },
  {
    city: 'Wyoming',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 1494.5,
    imprecise: false,
    latitude: 42.89773,
    longitude: -85.69299,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 28152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49509',
  },
  {
    city: 'Grand Rapids',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 308.2,
    imprecise: false,
    latitude: 42.8821,
    longitude: -85.54764,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49512',
  },
  {
    city: 'Wyoming',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 1350.6,
    imprecise: false,
    latitude: 42.89914,
    longitude: -85.7192,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 27965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49519',
  },
  {
    city: 'Grand Rapids',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 509.1,
    imprecise: false,
    latitude: 43.02144,
    longitude: -85.5918,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 30887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49525',
  },
  {
    city: 'Grand Rapids',
    county_fips: 26139,
    county_fips_all: '26139|26081',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Kent',
    county_weights: '{"26139": 50.85, "26081": 49.15}',
    density: 259.7,
    imprecise: false,
    latitude: 42.97106,
    longitude: -85.78834,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 23719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49534',
  },
  {
    city: 'Grand Rapids',
    county_fips: 26081,
    county_fips_all: '26081|26139',
    county: 'Kent',
    county_names_all: 'Kent|Ottawa',
    county_weights: '{"26081": 96.17, "26139": 3.83}',
    density: 187,
    imprecise: false,
    latitude: 43.04591,
    longitude: -85.7417,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49544',
  },
  {
    city: 'Grand Rapids',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 750.4,
    imprecise: false,
    latitude: 42.92815,
    longitude: -85.53629,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 34721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49546',
  },
  {
    city: 'Grand Rapids',
    county_fips: 26081,
    county_fips_all: '26081',
    county: 'Kent',
    county_names_all: 'Kent',
    county_weights: '{"26081": 100}',
    density: 1248.2,
    imprecise: false,
    latitude: 42.86795,
    longitude: -85.66273,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 34777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49548',
  },
  {
    city: 'Cadillac',
    county_fips: 26165,
    county_fips_all: '26165|26085|26113',
    county: 'Wexford',
    county_names_all: 'Wexford|Lake|Missaukee',
    county_weights: '{"26165": 88.41, "26085": 8.68, "26113": 2.91}',
    density: 38.8,
    imprecise: false,
    latitude: 44.2385,
    longitude: -85.5211,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 22092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49601',
  },
  {
    city: 'Alba',
    county_fips: 26009,
    county_fips_all: '26009',
    county: 'Antrim',
    county_names_all: 'Antrim',
    county_weights: '{"26009": 100}',
    density: 48.8,
    imprecise: false,
    latitude: 44.97995,
    longitude: -84.97873,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49611',
  },
  {
    city: 'Alden',
    county_fips: 26009,
    county_fips_all: '26009|26079',
    county: 'Antrim',
    county_names_all: 'Antrim|Kalkaska',
    county_weights: '{"26009": 50.66, "26079": 49.34}',
    density: 18.9,
    imprecise: false,
    latitude: 44.86212,
    longitude: -85.22561,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49612',
  },
  {
    city: 'Arcadia',
    county_fips: 26101,
    county_fips_all: '26101|26019',
    county: 'Manistee',
    county_names_all: 'Manistee|Benzie',
    county_weights: '{"26101": 57.91, "26019": 42.09}',
    density: 8.4,
    imprecise: false,
    latitude: 44.50538,
    longitude: -86.20412,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49613',
  },
  {
    city: 'Bear Lake',
    county_fips: 26101,
    county_fips_all: '26101',
    county: 'Manistee',
    county_names_all: 'Manistee',
    county_weights: '{"26101": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 44.43886,
    longitude: -86.10879,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49614',
  },
  {
    city: 'Bellaire',
    county_fips: 26009,
    county_fips_all: '26009',
    county: 'Antrim',
    county_names_all: 'Antrim',
    county_weights: '{"26009": 100}',
    density: 23.3,
    imprecise: false,
    latitude: 44.97219,
    longitude: -85.20683,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49615',
  },
  {
    city: 'Benzonia',
    county_fips: 26019,
    county_fips_all: '26019',
    county: 'Benzie',
    county_names_all: 'Benzie',
    county_weights: '{"26019": 100}',
    density: 23,
    imprecise: false,
    latitude: 44.57491,
    longitude: -86.08448,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49616',
  },
  {
    city: 'Beulah',
    county_fips: 26019,
    county_fips_all: '26019',
    county: 'Benzie',
    county_names_all: 'Benzie',
    county_weights: '{"26019": 100}',
    density: 30,
    imprecise: false,
    latitude: 44.64105,
    longitude: -86.03505,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49617',
  },
  {
    city: 'Boon',
    county_fips: 26165,
    county_fips_all: '26165',
    county: 'Wexford',
    county_names_all: 'Wexford',
    county_weights: '{"26165": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 44.30096,
    longitude: -85.59853,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49618',
  },
  {
    city: 'Brethren',
    county_fips: 26101,
    county_fips_all: '26101',
    county: 'Manistee',
    county_names_all: 'Manistee',
    county_weights: '{"26101": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 44.30331,
    longitude: -85.98784,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49619',
  },
  {
    city: 'Buckley',
    county_fips: 26055,
    county_fips_all: '26055|26165',
    county: 'Grand Traverse',
    county_names_all: 'Grand Traverse|Wexford',
    county_weights: '{"26055": 52.57, "26165": 47.43}',
    density: 20.2,
    imprecise: false,
    latitude: 44.5188,
    longitude: -85.68976,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49620',
  },
  {
    city: 'Cedar',
    county_fips: 26089,
    county_fips_all: '26089',
    county: 'Leelanau',
    county_names_all: 'Leelanau',
    county_weights: '{"26089": 100}',
    density: 24.5,
    imprecise: false,
    latitude: 44.86229,
    longitude: -85.77555,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49621',
  },
  {
    city: 'Central Lake',
    county_fips: 26009,
    county_fips_all: '26009',
    county: 'Antrim',
    county_names_all: 'Antrim',
    county_weights: '{"26009": 100}',
    density: 22.5,
    imprecise: false,
    latitude: 45.0785,
    longitude: -85.26583,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49622',
  },
  {
    city: 'Chase',
    county_fips: 26085,
    county_fips_all: '26085',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"26085": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 43.90367,
    longitude: -85.68285,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49623',
  },
  {
    city: 'Copemish',
    county_fips: 26101,
    county_fips_all: '26101|26165',
    county: 'Manistee',
    county_names_all: 'Manistee|Wexford',
    county_weights: '{"26101": 91.76, "26165": 8.24}',
    density: 8,
    imprecise: false,
    latitude: 44.42785,
    longitude: -85.87348,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49625',
  },
  {
    city: 'Eastlake',
    county_fips: 26101,
    county_fips_all: '26101',
    county: 'Manistee',
    county_names_all: 'Manistee',
    county_weights: '{"26101": 100}',
    density: 175.9,
    imprecise: false,
    latitude: 44.24284,
    longitude: -86.29252,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49626',
  },
  {
    city: 'Eastport',
    county_fips: 26009,
    county_fips_all: '26009',
    county: 'Antrim',
    county_names_all: 'Antrim',
    county_weights: '{"26009": 100}',
    density: 53.8,
    imprecise: false,
    latitude: 45.11261,
    longitude: -85.35677,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49627',
  },
  {
    city: 'Elberta',
    county_fips: 26019,
    county_fips_all: '26019',
    county: 'Benzie',
    county_names_all: 'Benzie',
    county_weights: '{"26019": 100}',
    density: 89.5,
    imprecise: false,
    latitude: 44.62087,
    longitude: -86.23095,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49628',
  },
  {
    city: 'Elk Rapids',
    county_fips: 26009,
    county_fips_all: '26009',
    county: 'Antrim',
    county_names_all: 'Antrim',
    county_weights: '{"26009": 100}',
    density: 209.7,
    imprecise: false,
    latitude: 44.90835,
    longitude: -85.39424,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49629',
  },
  {
    city: 'Empire',
    county_fips: 26089,
    county_fips_all: '26089|26019',
    county: 'Leelanau',
    county_names_all: 'Leelanau|Benzie',
    county_weights: '{"26089": 96.74, "26019": 3.26}',
    density: 8.9,
    imprecise: false,
    latitude: 44.92262,
    longitude: -86.00074,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49630',
  },
  {
    city: 'Evart',
    county_fips: 26133,
    county_fips_all: '26133|26107',
    county: 'Osceola',
    county_names_all: 'Osceola|Mecosta',
    county_weights: '{"26133": 84.99, "26107": 15.01}',
    density: 15.4,
    imprecise: false,
    latitude: 43.91707,
    longitude: -85.25788,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 5765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49631',
  },
  {
    city: 'Falmouth',
    county_fips: 26113,
    county_fips_all: '26113',
    county: 'Missaukee',
    county_names_all: 'Missaukee',
    county_weights: '{"26113": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 44.23993,
    longitude: -84.97268,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49632',
  },
  {
    city: 'Fife Lake',
    county_fips: 26079,
    county_fips_all: '26079|26055|26165|26113',
    county: 'Kalkaska',
    county_names_all: 'Kalkaska|Grand Traverse|Wexford|Missaukee',
    county_weights:
      '{"26079": 72.14, "26055": 18.08, "26165": 5.61, "26113": 4.17}',
    density: 7.8,
    imprecise: false,
    latitude: 44.55709,
    longitude: -85.19318,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49633',
  },
  {
    city: 'Filer City',
    county_fips: 26101,
    county_fips_all: '26101',
    county: 'Manistee',
    county_names_all: 'Manistee',
    county_weights: '{"26101": 100}',
    density: 265.1,
    imprecise: false,
    latitude: 44.2149,
    longitude: -86.28896,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49634',
  },
  {
    city: 'Frankfort',
    county_fips: 26019,
    county_fips_all: '26019',
    county: 'Benzie',
    county_names_all: 'Benzie',
    county_weights: '{"26019": 100}',
    density: 33.5,
    imprecise: false,
    latitude: 44.62261,
    longitude: -86.18914,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49635',
  },
  {
    city: 'Glen Arbor',
    county_fips: 26089,
    county_fips_all: '26089',
    county: 'Leelanau',
    county_names_all: 'Leelanau',
    county_weights: '{"26089": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 44.87261,
    longitude: -85.99292,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49636',
  },
  {
    city: 'Grawn',
    county_fips: 26055,
    county_fips_all: '26055',
    county: 'Grand Traverse',
    county_names_all: 'Grand Traverse',
    county_weights: '{"26055": 100}',
    density: 63.4,
    imprecise: false,
    latitude: 44.62897,
    longitude: -85.71083,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49637',
  },
  {
    city: 'Harrietta',
    county_fips: 26165,
    county_fips_all: '26165|26101',
    county: 'Wexford',
    county_names_all: 'Wexford|Manistee',
    county_weights: '{"26165": 78.29, "26101": 21.71}',
    density: 4.8,
    imprecise: false,
    latitude: 44.28463,
    longitude: -85.75073,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49638',
  },
  {
    city: 'Hersey',
    county_fips: 26133,
    county_fips_all: '26133|26107',
    county: 'Osceola',
    county_names_all: 'Osceola|Mecosta',
    county_weights: '{"26133": 77.15, "26107": 22.85}',
    density: 16.5,
    imprecise: false,
    latitude: 43.8467,
    longitude: -85.39768,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49639',
  },
  {
    city: 'Honor',
    county_fips: 26019,
    county_fips_all: '26019|26089',
    county: 'Benzie',
    county_names_all: 'Benzie|Leelanau',
    county_weights: '{"26019": 97.03, "26089": 2.97}',
    density: 7.5,
    imprecise: false,
    latitude: 44.72088,
    longitude: -86.03664,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49640',
  },
  {
    city: 'Idlewild',
    county_fips: 26085,
    county_fips_all: '26085',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"26085": 100}',
    density: 25,
    imprecise: false,
    latitude: 43.87927,
    longitude: -85.77059,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49642',
  },
  {
    city: 'Interlochen',
    county_fips: 26019,
    county_fips_all: '26019|26055',
    county: 'Benzie',
    county_names_all: 'Benzie|Grand Traverse',
    county_weights: '{"26019": 57.45, "26055": 42.55}',
    density: 45.1,
    imprecise: false,
    latitude: 44.63959,
    longitude: -85.83357,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49643',
  },
  {
    city: 'Irons',
    county_fips: 26085,
    county_fips_all: '26085|26105|26101',
    county: 'Lake',
    county_names_all: 'Lake|Mason|Manistee',
    county_weights: '{"26085": 93.58, "26105": 3.65, "26101": 2.77}',
    density: 6,
    imprecise: false,
    latitude: 44.10787,
    longitude: -85.91989,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49644',
  },
  {
    city: 'Kaleva',
    county_fips: 26101,
    county_fips_all: '26101',
    county: 'Manistee',
    county_names_all: 'Manistee',
    county_weights: '{"26101": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 44.37157,
    longitude: -86.02411,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49645',
  },
  {
    city: 'Kalkaska',
    county_fips: 26079,
    county_fips_all: '26079',
    county: 'Kalkaska',
    county_names_all: 'Kalkaska',
    county_weights: '{"26079": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 44.72727,
    longitude: -85.04926,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49646',
  },
  {
    city: 'Kewadin',
    county_fips: 26009,
    county_fips_all: '26009',
    county: 'Antrim',
    county_names_all: 'Antrim',
    county_weights: '{"26009": 100}',
    density: 36.5,
    imprecise: false,
    latitude: 44.98359,
    longitude: -85.3435,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49648',
  },
  {
    city: 'Kingsley',
    county_fips: 26055,
    county_fips_all: '26055|26165',
    county: 'Grand Traverse',
    county_names_all: 'Grand Traverse|Wexford',
    county_weights: '{"26055": 91.0, "26165": 9.0}',
    density: 25.3,
    imprecise: false,
    latitude: 44.5685,
    longitude: -85.52596,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49649',
  },
  {
    city: 'Lake Ann',
    county_fips: 26019,
    county_fips_all: '26019',
    county: 'Benzie',
    county_names_all: 'Benzie',
    county_weights: '{"26019": 100}',
    density: 54.8,
    imprecise: false,
    latitude: 44.73359,
    longitude: -85.88033,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49650',
  },
  {
    city: 'Lake City',
    county_fips: 26113,
    county_fips_all: '26113',
    county: 'Missaukee',
    county_names_all: 'Missaukee',
    county_weights: '{"26113": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 44.39603,
    longitude: -85.10862,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49651',
  },
  {
    city: 'Lake Leelanau',
    county_fips: 26089,
    county_fips_all: '26089',
    county: 'Leelanau',
    county_names_all: 'Leelanau',
    county_weights: '{"26089": 100}',
    density: 24.5,
    imprecise: false,
    latitude: 44.97184,
    longitude: -85.7302,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49653',
  },
  {
    city: 'Leland',
    county_fips: 26089,
    county_fips_all: '26089',
    county: 'Leelanau',
    county_names_all: 'Leelanau',
    county_weights: '{"26089": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 45.0268,
    longitude: -86.00875,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49654',
  },
  {
    city: 'Leroy',
    county_fips: 26133,
    county_fips_all: '26133|26085',
    county: 'Osceola',
    county_names_all: 'Osceola|Lake',
    county_weights: '{"26133": 97.74, "26085": 2.26}',
    density: 14.9,
    imprecise: false,
    latitude: 44.02718,
    longitude: -85.43875,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49655',
  },
  {
    city: 'Luther',
    county_fips: 26085,
    county_fips_all: '26085',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"26085": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 44.05248,
    longitude: -85.69789,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49656',
  },
  {
    city: 'McBain',
    county_fips: 26113,
    county_fips_all: '26113|26165',
    county: 'Missaukee',
    county_names_all: 'Missaukee|Wexford',
    county_weights: '{"26113": 99.67, "26165": 0.33}',
    density: 15.9,
    imprecise: false,
    latitude: 44.21523,
    longitude: -85.17653,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49657',
  },
  {
    city: 'Mancelona',
    county_fips: 26009,
    county_fips_all: '26009|26079',
    county: 'Antrim',
    county_names_all: 'Antrim|Kalkaska',
    county_weights: '{"26009": 74.53, "26079": 25.47}',
    density: 15.7,
    imprecise: false,
    latitude: 44.90265,
    longitude: -85.02679,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49659',
  },
  {
    city: 'Manistee',
    county_fips: 26101,
    county_fips_all: '26101|26105',
    county: 'Manistee',
    county_names_all: 'Manistee|Mason',
    county_weights: '{"26101": 82.3, "26105": 17.7}',
    density: 32.8,
    imprecise: false,
    latitude: 44.23236,
    longitude: -86.21125,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 14578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49660',
  },
  {
    city: 'Manton',
    county_fips: 26165,
    county_fips_all: '26165|26113',
    county: 'Wexford',
    county_names_all: 'Wexford|Missaukee',
    county_weights: '{"26165": 66.47, "26113": 33.53}',
    density: 15.2,
    imprecise: false,
    latitude: 44.42494,
    longitude: -85.39147,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49663',
  },
  {
    city: 'Maple City',
    county_fips: 26089,
    county_fips_all: '26089',
    county: 'Leelanau',
    county_names_all: 'Leelanau',
    county_weights: '{"26089": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 44.87457,
    longitude: -85.89058,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49664',
  },
  {
    city: 'Marion',
    county_fips: 26133,
    county_fips_all: '26133|26035|26113',
    county: 'Osceola',
    county_names_all: 'Osceola|Clare|Missaukee',
    county_weights: '{"26133": 64.33, "26035": 29.06, "26113": 6.61}',
    density: 9.8,
    imprecise: false,
    latitude: 44.0995,
    longitude: -85.1309,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49665',
  },
  {
    city: 'Merritt',
    county_fips: 26113,
    county_fips_all: '26113',
    county: 'Missaukee',
    county_names_all: 'Missaukee',
    county_weights: '{"26113": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 44.34892,
    longitude: -84.91898,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49667',
  },
  {
    city: 'Mesick',
    county_fips: 26165,
    county_fips_all: '26165|26101',
    county: 'Wexford',
    county_names_all: 'Wexford|Manistee',
    county_weights: '{"26165": 98.08, "26101": 1.92}',
    density: 11.9,
    imprecise: false,
    latitude: 44.4028,
    longitude: -85.70965,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49668',
  },
  {
    city: 'Northport',
    county_fips: 26089,
    county_fips_all: '26089',
    county: 'Leelanau',
    county_names_all: 'Leelanau',
    county_weights: '{"26089": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 45.12088,
    longitude: -85.62096,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49670',
  },
  {
    city: 'Omena',
    county_fips: 26089,
    county_fips_all: '26089',
    county: 'Leelanau',
    county_names_all: 'Leelanau',
    county_weights: '{"26089": 100}',
    density: 36,
    imprecise: false,
    latitude: 45.0544,
    longitude: -85.58882,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49674',
  },
  {
    city: 'Onekama',
    county_fips: 26101,
    county_fips_all: '26101',
    county: 'Manistee',
    county_names_all: 'Manistee',
    county_weights: '{"26101": 100}',
    density: 34,
    imprecise: false,
    latitude: 44.37506,
    longitude: -86.21978,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49675',
  },
  {
    city: 'Rapid City',
    county_fips: 26079,
    county_fips_all: '26079|26009',
    county: 'Kalkaska',
    county_names_all: 'Kalkaska|Antrim',
    county_weights: '{"26079": 52.71, "26009": 47.29}',
    density: 34.1,
    imprecise: false,
    latitude: 44.84147,
    longitude: -85.29028,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49676',
  },
  {
    city: 'Reed City',
    county_fips: 26133,
    county_fips_all: '26133|26085|26123',
    county: 'Osceola',
    county_names_all: 'Osceola|Lake|Newaygo',
    county_weights: '{"26133": 58.05, "26085": 30.13, "26123": 11.82}',
    density: 21.4,
    imprecise: false,
    latitude: 43.89533,
    longitude: -85.54254,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49677',
  },
  {
    city: 'Sears',
    county_fips: 26133,
    county_fips_all: '26133|26107',
    county: 'Osceola',
    county_names_all: 'Osceola|Mecosta',
    county_weights: '{"26133": 86.61, "26107": 13.39}',
    density: 9.5,
    imprecise: false,
    latitude: 43.8747,
    longitude: -85.14895,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49679',
  },
  {
    city: 'South Boardman',
    county_fips: 26079,
    county_fips_all: '26079',
    county: 'Kalkaska',
    county_names_all: 'Kalkaska',
    county_weights: '{"26079": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 44.64174,
    longitude: -85.25089,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49680',
  },
  {
    city: 'Suttons Bay',
    county_fips: 26089,
    county_fips_all: '26089',
    county: 'Leelanau',
    county_names_all: 'Leelanau',
    county_weights: '{"26089": 100}',
    density: 44,
    imprecise: false,
    latitude: 44.97954,
    longitude: -85.6512,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49682',
  },
  {
    city: 'Thompsonville',
    county_fips: 26019,
    county_fips_all: '26019|26101|26055|26165',
    county: 'Benzie',
    county_names_all: 'Benzie|Manistee|Grand Traverse|Wexford',
    county_weights:
      '{"26019": 70.7, "26101": 22.66, "26055": 5.38, "26165": 1.26}',
    density: 9.9,
    imprecise: false,
    latitude: 44.53948,
    longitude: -85.93009,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49683',
  },
  {
    city: 'Traverse City',
    county_fips: 26089,
    county_fips_all: '26089|26055|26019',
    county: 'Leelanau',
    county_names_all: 'Leelanau|Grand Traverse|Benzie',
    county_weights: '{"26089": 62.23, "26055": 31.71, "26019": 6.06}',
    density: 158,
    imprecise: false,
    latitude: 44.80191,
    longitude: -85.70549,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49684',
  },
  {
    city: 'Traverse City',
    county_fips: 26055,
    county_fips_all: '26055',
    county: 'Grand Traverse',
    county_names_all: 'Grand Traverse',
    county_weights: '{"26055": 100}',
    density: 151.8,
    imprecise: false,
    latitude: 44.69859,
    longitude: -85.70425,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49685',
  },
  {
    city: 'Traverse City',
    county_fips: 26055,
    county_fips_all: '26055',
    county: 'Grand Traverse',
    county_names_all: 'Grand Traverse',
    county_weights: '{"26055": 100}',
    density: 208,
    imprecise: false,
    latitude: 44.82841,
    longitude: -85.53597,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 25492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49686',
  },
  {
    city: 'Tustin',
    county_fips: 26133,
    county_fips_all: '26133|26085|26165',
    county: 'Osceola',
    county_names_all: 'Osceola|Lake|Wexford',
    county_weights: '{"26133": 88.64, "26085": 10.47, "26165": 0.89}',
    density: 10.5,
    imprecise: false,
    latitude: 44.12115,
    longitude: -85.44349,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49688',
  },
  {
    city: 'Wellston',
    county_fips: 26101,
    county_fips_all: '26101|26165',
    county: 'Manistee',
    county_names_all: 'Manistee|Wexford',
    county_weights: '{"26101": 83.85, "26165": 16.15}',
    density: 8.3,
    imprecise: false,
    latitude: 44.21165,
    longitude: -85.91484,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49689',
  },
  {
    city: 'Williamsburg',
    county_fips: 26055,
    county_fips_all: '26055|26079|26009',
    county: 'Grand Traverse',
    county_names_all: 'Grand Traverse|Kalkaska|Antrim',
    county_weights: '{"26055": 77.39, "26079": 17.52, "26009": 5.09}',
    density: 31.1,
    imprecise: false,
    latitude: 44.77915,
    longitude: -85.38964,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49690',
  },
  {
    city: 'Traverse City',
    county_fips: 26055,
    county_fips_all: '26055',
    county: 'Grand Traverse',
    county_names_all: 'Grand Traverse',
    county_weights: '{"26055": 100}',
    density: 58.9,
    imprecise: false,
    latitude: 44.6764,
    longitude: -85.48413,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 10477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49696',
  },
  {
    city: 'Mackinaw City',
    county_fips: 26047,
    county_fips_all: '26047|26031',
    county: 'Emmet',
    county_names_all: 'Emmet|Cheboygan',
    county_weights: '{"26047": 64.1, "26031": 35.9}',
    density: 19.6,
    imprecise: false,
    latitude: 45.75195,
    longitude: -84.7426,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49701',
  },
  {
    city: 'Afton',
    county_fips: 26031,
    county_fips_all: '26031',
    county: 'Cheboygan',
    county_names_all: 'Cheboygan',
    county_weights: '{"26031": 100}',
    density: 5,
    imprecise: false,
    latitude: 45.34826,
    longitude: -84.45824,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49705',
  },
  {
    city: 'Alanson',
    county_fips: 26047,
    county_fips_all: '26047|26031',
    county: 'Emmet',
    county_names_all: 'Emmet|Cheboygan',
    county_weights: '{"26047": 73.04, "26031": 26.96}',
    density: 32.5,
    imprecise: false,
    latitude: 45.44129,
    longitude: -84.77915,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49706',
  },
  {
    city: 'Alpena',
    county_fips: 26007,
    county_fips_all: '26007|26141',
    county: 'Alpena',
    county_names_all: 'Alpena|Presque Isle',
    county_weights: '{"26007": 96.16, "26141": 3.84}',
    density: 39.2,
    imprecise: false,
    latitude: 45.09375,
    longitude: -83.50186,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 21881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49707',
  },
  {
    city: 'Atlanta',
    county_fips: 26119,
    county_fips_all: '26119',
    county: 'Montmorency',
    county_names_all: 'Montmorency',
    county_weights: '{"26119": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 45.03102,
    longitude: -84.17094,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49709',
  },
  {
    city: 'Barbeau',
    county_fips: 26033,
    county_fips_all: '26033',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"26033": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 46.27717,
    longitude: -84.18478,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49710',
  },
  {
    city: 'Boyne City',
    county_fips: 26029,
    county_fips_all: '26029|26009',
    county: 'Charlevoix',
    county_names_all: 'Charlevoix|Antrim',
    county_weights: '{"26029": 91.58, "26009": 8.42}',
    density: 43.4,
    imprecise: false,
    latitude: 45.2113,
    longitude: -85.01089,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49712',
  },
  {
    city: 'Boyne Falls',
    county_fips: 26029,
    county_fips_all: '26029|26047|26009',
    county: 'Charlevoix',
    county_names_all: 'Charlevoix|Emmet|Antrim',
    county_weights: '{"26029": 94.41, "26047": 3.64, "26009": 1.95}',
    density: 7.7,
    imprecise: false,
    latitude: 45.21602,
    longitude: -84.85185,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49713',
  },
  {
    city: 'Brimley',
    county_fips: 26033,
    county_fips_all: '26033',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"26033": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 46.3923,
    longitude: -84.69493,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49715',
  },
  {
    city: 'Brutus',
    county_fips: 26047,
    county_fips_all: '26047|26031',
    county: 'Emmet',
    county_names_all: 'Emmet|Cheboygan',
    county_weights: '{"26047": 71.71, "26031": 28.29}',
    density: 17,
    imprecise: false,
    latitude: 45.50975,
    longitude: -84.75104,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49716',
  },
  {
    city: 'Burt Lake',
    county_fips: 26031,
    county_fips_all: '26031',
    county: 'Cheboygan',
    county_names_all: 'Cheboygan',
    county_weights: '{"26031": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 45.43671,
    longitude: -84.69796,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 43,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49717',
  },
  {
    city: 'Carp Lake',
    county_fips: 26047,
    county_fips_all: '26047|26031',
    county: 'Emmet',
    county_names_all: 'Emmet|Cheboygan',
    county_weights: '{"26047": 81.41, "26031": 18.59}',
    density: 5.4,
    imprecise: false,
    latitude: 45.71438,
    longitude: -84.81275,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49718',
  },
  {
    city: 'Cedarville',
    county_fips: 26097,
    county_fips_all: '26097|26033',
    county: 'Mackinac',
    county_names_all: 'Mackinac|Chippewa',
    county_weights: '{"26097": 83.96, "26033": 16.04}',
    density: 8.2,
    imprecise: false,
    latitude: 46.0073,
    longitude: -84.29304,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49719',
  },
  {
    city: 'Charlevoix',
    county_fips: 26029,
    county_fips_all: '26029|26009',
    county: 'Charlevoix',
    county_names_all: 'Charlevoix|Antrim',
    county_weights: '{"26029": 91.98, "26009": 8.02}',
    density: 36.4,
    imprecise: false,
    latitude: 45.27555,
    longitude: -85.23984,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49720',
  },
  {
    city: 'Cheboygan',
    county_fips: 26031,
    county_fips_all: '26031',
    county: 'Cheboygan',
    county_names_all: 'Cheboygan',
    county_weights: '{"26031": 100}',
    density: 20.1,
    imprecise: false,
    latitude: 45.57181,
    longitude: -84.45711,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 13891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49721',
  },
  {
    city: 'Conway',
    county_fips: 26047,
    county_fips_all: '26047',
    county: 'Emmet',
    county_names_all: 'Emmet',
    county_weights: '{"26047": 100}',
    density: 70.7,
    imprecise: false,
    latitude: 45.42135,
    longitude: -84.86459,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49722',
  },
  {
    city: 'Dafter',
    county_fips: 26033,
    county_fips_all: '26033',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"26033": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 46.32744,
    longitude: -84.3884,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49724',
  },
  {
    city: 'De Tour Village',
    county_fips: 26033,
    county_fips_all: '26033',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"26033": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 46.00337,
    longitude: -84.01308,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49725',
  },
  {
    city: 'Drummond Island',
    county_fips: 26033,
    county_fips_all: '26033',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"26033": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 46.00169,
    longitude: -83.66277,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49726',
  },
  {
    city: 'East Jordan',
    county_fips: 26029,
    county_fips_all: '26029|26009',
    county: 'Charlevoix',
    county_names_all: 'Charlevoix|Antrim',
    county_weights: '{"26029": 53.39, "26009": 46.61}',
    density: 21.7,
    imprecise: false,
    latitude: 45.13452,
    longitude: -85.10679,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49727',
  },
  {
    city: 'Eckerman',
    county_fips: 26033,
    county_fips_all: '26033',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"26033": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 46.3702,
    longitude: -84.99387,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49728',
  },
  {
    city: 'Ellsworth',
    county_fips: 26009,
    county_fips_all: '26009|26029',
    county: 'Antrim',
    county_names_all: 'Antrim|Charlevoix',
    county_weights: '{"26009": 84.16, "26029": 15.84}',
    density: 15.3,
    imprecise: false,
    latitude: 45.16123,
    longitude: -85.28255,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49729',
  },
  {
    city: 'Elmira',
    county_fips: 26009,
    county_fips_all: '26009|26137|26029',
    county: 'Antrim',
    county_names_all: 'Antrim|Otsego|Charlevoix',
    county_weights: '{"26009": 63.14, "26137": 21.74, "26029": 15.12}',
    density: 8.8,
    imprecise: false,
    latitude: 45.04641,
    longitude: -84.87644,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49730',
  },
  {
    city: 'Frederic',
    county_fips: 26039,
    county_fips_all: '26039|26137',
    county: 'Crawford',
    county_names_all: 'Crawford|Otsego',
    county_weights: '{"26039": 87.3, "26137": 12.7}',
    density: 7.2,
    imprecise: false,
    latitude: 44.80368,
    longitude: -84.7291,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49733',
  },
  {
    city: 'Gaylord',
    county_fips: 26137,
    county_fips_all: '26137',
    county: 'Otsego',
    county_names_all: 'Otsego',
    county_weights: '{"26137": 100}',
    density: 32.3,
    imprecise: false,
    latitude: 44.99576,
    longitude: -84.67117,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 20773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49735',
  },
  {
    city: 'Goetzville',
    county_fips: 26033,
    county_fips_all: '26033',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"26033": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 46.07877,
    longitude: -84.14573,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49736',
  },
  {
    city: 'Grayling',
    county_fips: 26039,
    county_fips_all: '26039|26079|26137',
    county: 'Crawford',
    county_names_all: 'Crawford|Kalkaska|Otsego',
    county_weights: '{"26039": 93.95, "26079": 4.01, "26137": 2.04}',
    density: 11.3,
    imprecise: false,
    latitude: 44.69296,
    longitude: -84.60578,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 9696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49738',
  },
  {
    city: 'Harbor Springs',
    county_fips: 26047,
    county_fips_all: '26047',
    county: 'Emmet',
    county_names_all: 'Emmet',
    county_weights: '{"26047": 100}',
    density: 22.2,
    imprecise: false,
    latitude: 45.52303,
    longitude: -84.99887,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49740',
  },
  {
    city: 'Hawks',
    county_fips: 26141,
    county_fips_all: '26141',
    county: 'Presque Isle',
    county_names_all: 'Presque Isle',
    county_weights: '{"26141": 100}',
    density: 4,
    imprecise: false,
    latitude: 45.27124,
    longitude: -83.89394,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49743',
  },
  {
    city: 'Herron',
    county_fips: 26007,
    county_fips_all: '26007',
    county: 'Alpena',
    county_names_all: 'Alpena',
    county_weights: '{"26007": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 45.00354,
    longitude: -83.66405,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49744',
  },
  {
    city: 'Hessel',
    county_fips: 26097,
    county_fips_all: '26097',
    county: 'Mackinac',
    county_names_all: 'Mackinac',
    county_weights: '{"26097": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 46.05065,
    longitude: -84.519,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49745',
  },
  {
    city: 'Hillman',
    county_fips: 26119,
    county_fips_all: '26119|26007',
    county: 'Montmorency',
    county_names_all: 'Montmorency|Alpena',
    county_weights: '{"26119": 80.92, "26007": 19.08}',
    density: 6,
    imprecise: false,
    latitude: 45.06437,
    longitude: -83.95239,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49746',
  },
  {
    city: 'Hubbard Lake',
    county_fips: 26001,
    county_fips_all: '26001|26007',
    county: 'Alcona',
    county_names_all: 'Alcona|Alpena',
    county_weights: '{"26001": 54.76, "26007": 45.24}',
    density: 8.2,
    imprecise: false,
    latitude: 44.85132,
    longitude: -83.64516,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49747',
  },
  {
    city: 'Hulbert',
    county_fips: 26033,
    county_fips_all: '26033|26095',
    county: 'Chippewa',
    county_names_all: 'Chippewa|Luce',
    county_weights: '{"26033": 91.7, "26095": 8.3}',
    density: 0.8,
    imprecise: false,
    latitude: 46.37491,
    longitude: -85.18039,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49748',
  },
  {
    city: 'Indian River',
    county_fips: 26031,
    county_fips_all: '26031',
    county: 'Cheboygan',
    county_names_all: 'Cheboygan',
    county_weights: '{"26031": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 45.41634,
    longitude: -84.57891,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49749',
  },
  {
    city: 'Johannesburg',
    county_fips: 26137,
    county_fips_all: '26137|26119',
    county: 'Otsego',
    county_names_all: 'Otsego|Montmorency',
    county_weights: '{"26137": 70.16, "26119": 29.84}',
    density: 5.4,
    imprecise: false,
    latitude: 44.99496,
    longitude: -84.41309,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49751',
  },
  {
    city: 'Kinross',
    county_fips: 26033,
    county_fips_all: '26033',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"26033": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 46.27629,
    longitude: -84.46091,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49752',
  },
  {
    city: 'Lachine',
    county_fips: 26007,
    county_fips_all: '26007',
    county: 'Alpena',
    county_names_all: 'Alpena',
    county_weights: '{"26007": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 45.01566,
    longitude: -83.77644,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49753',
  },
  {
    city: 'Levering',
    county_fips: 26047,
    county_fips_all: '26047|26031',
    county: 'Emmet',
    county_names_all: 'Emmet|Cheboygan',
    county_weights: '{"26047": 73.2, "26031": 26.8}',
    density: 6.8,
    imprecise: false,
    latitude: 45.63886,
    longitude: -84.80524,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49755',
  },
  {
    city: 'Lewiston',
    county_fips: 26135,
    county_fips_all: '26135|26119|26039|26137',
    county: 'Oscoda',
    county_names_all: 'Oscoda|Montmorency|Crawford|Otsego',
    county_weights:
      '{"26135": 60.72, "26119": 34.83, "26039": 2.52, "26137": 1.93}',
    density: 8.3,
    imprecise: false,
    latitude: 44.81482,
    longitude: -84.27339,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49756',
  },
  {
    city: 'Mackinac Island',
    county_fips: 26097,
    county_fips_all: '26097',
    county: 'Mackinac',
    county_names_all: 'Mackinac',
    county_weights: '{"26097": 100}',
    density: 49.8,
    imprecise: false,
    latitude: 45.85933,
    longitude: -84.62533,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49757',
  },
  {
    city: 'Millersburg',
    county_fips: 26141,
    county_fips_all: '26141',
    county: 'Presque Isle',
    county_names_all: 'Presque Isle',
    county_weights: '{"26141": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 45.40545,
    longitude: -84.10055,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49759',
  },
  {
    city: 'Moran',
    county_fips: 26097,
    county_fips_all: '26097|26033',
    county: 'Mackinac',
    county_names_all: 'Mackinac|Chippewa',
    county_weights: '{"26097": 95.82, "26033": 4.18}',
    density: 2.1,
    imprecise: false,
    latitude: 46.05715,
    longitude: -84.88881,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49760',
  },
  {
    city: 'Naubinway',
    county_fips: 26097,
    county_fips_all: '26097',
    county: 'Mackinac',
    county_names_all: 'Mackinac',
    county_weights: '{"26097": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 46.13126,
    longitude: -85.24115,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49762',
  },
  {
    city: 'Oden',
    county_fips: 26047,
    county_fips_all: '26047',
    county: 'Emmet',
    county_names_all: 'Emmet',
    county_weights: '{"26047": 100}',
    density: 483.1,
    imprecise: false,
    latitude: 45.42356,
    longitude: -84.82824,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49764',
  },
  {
    city: 'Onaway',
    county_fips: 26141,
    county_fips_all: '26141|26031',
    county: 'Presque Isle',
    county_names_all: 'Presque Isle|Cheboygan',
    county_weights: '{"26141": 50.82, "26031": 49.18}',
    density: 7,
    imprecise: false,
    latitude: 45.33379,
    longitude: -84.25229,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49765',
  },
  {
    city: 'Ossineke',
    county_fips: 26007,
    county_fips_all: '26007',
    county: 'Alpena',
    county_names_all: 'Alpena',
    county_weights: '{"26007": 100}',
    density: 21.7,
    imprecise: false,
    latitude: 44.90643,
    longitude: -83.4512,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49766',
  },
  {
    city: 'Paradise',
    county_fips: 26033,
    county_fips_all: '26033',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"26033": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 46.63217,
    longitude: -85.13434,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49768',
  },
  {
    city: 'Pellston',
    county_fips: 26047,
    county_fips_all: '26047|26031',
    county: 'Emmet',
    county_names_all: 'Emmet|Cheboygan',
    county_weights: '{"26047": 85.56, "26031": 14.44}',
    density: 11.6,
    imprecise: false,
    latitude: 45.56797,
    longitude: -84.85681,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49769',
  },
  {
    city: 'Petoskey',
    county_fips: 26047,
    county_fips_all: '26047|26029|26031',
    county: 'Emmet',
    county_names_all: 'Emmet|Charlevoix|Cheboygan',
    county_weights: '{"26047": 94.75, "26029": 4.19, "26031": 1.06}',
    density: 64.3,
    imprecise: false,
    latitude: 45.34396,
    longitude: -84.88903,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49770',
  },
  {
    city: 'Pickford',
    county_fips: 26033,
    county_fips_all: '26033|26097',
    county: 'Chippewa',
    county_names_all: 'Chippewa|Mackinac',
    county_weights: '{"26033": 78.21, "26097": 21.79}',
    density: 5.1,
    imprecise: false,
    latitude: 46.16081,
    longitude: -84.33798,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49774',
  },
  {
    city: 'Pointe Aux Pins',
    county_fips: 26097,
    county_fips_all: '26097',
    county: 'Mackinac',
    county_names_all: 'Mackinac',
    county_weights: '{"26097": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 45.76941,
    longitude: -84.46333,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49775',
  },
  {
    city: 'Posen',
    county_fips: 26141,
    county_fips_all: '26141|26007',
    county: 'Presque Isle',
    county_names_all: 'Presque Isle|Alpena',
    county_weights: '{"26141": 75.41, "26007": 24.59}',
    density: 5.3,
    imprecise: false,
    latitude: 45.24634,
    longitude: -83.6873,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49776',
  },
  {
    city: 'Presque Isle',
    county_fips: 26141,
    county_fips_all: '26141',
    county: 'Presque Isle',
    county_names_all: 'Presque Isle',
    county_weights: '{"26141": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 45.28323,
    longitude: -83.49624,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49777',
  },
  {
    city: 'Rogers City',
    county_fips: 26141,
    county_fips_all: '26141',
    county: 'Presque Isle',
    county_names_all: 'Presque Isle',
    county_weights: '{"26141": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 45.39651,
    longitude: -83.87153,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49779',
  },
  {
    city: 'Rudyard',
    county_fips: 26033,
    county_fips_all: '26033|26097',
    county: 'Chippewa',
    county_names_all: 'Chippewa|Mackinac',
    county_weights: '{"26033": 74.57, "26097": 25.43}',
    density: 2.4,
    imprecise: false,
    latitude: 46.20913,
    longitude: -84.6854,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49780',
  },
  {
    city: 'Saint Ignace',
    county_fips: 26097,
    county_fips_all: '26097',
    county: 'Mackinac',
    county_names_all: 'Mackinac',
    county_weights: '{"26097": 100}',
    density: 19.7,
    imprecise: false,
    latitude: 45.95272,
    longitude: -84.77652,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49781',
  },
  {
    city: 'Beaver Island',
    county_fips: 26029,
    county_fips_all: '26029',
    county: 'Charlevoix',
    county_names_all: 'Charlevoix',
    county_weights: '{"26029": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 45.65547,
    longitude: -85.55199,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49782',
  },
  {
    city: 'Sault Sainte Marie',
    county_fips: 26033,
    county_fips_all: '26033',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"26033": 100}',
    density: 48.5,
    imprecise: false,
    latitude: 46.41495,
    longitude: -84.28006,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 18681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49783',
  },
  {
    city: 'Kincheloe',
    county_fips: 26033,
    county_fips_all: '26033',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"26033": 100}',
    density: 144.8,
    imprecise: false,
    latitude: 46.26418,
    longitude: -84.46779,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49788',
  },
  {
    city: 'Topinabee',
    county_fips: 26031,
    county_fips_all: '26031',
    county: 'Cheboygan',
    county_names_all: 'Cheboygan',
    county_weights: '{"26031": 100}',
    density: 121.2,
    imprecise: false,
    latitude: 45.48093,
    longitude: -84.59945,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49791',
  },
  {
    city: 'Trout Lake',
    county_fips: 26033,
    county_fips_all: '26033|26097',
    county: 'Chippewa',
    county_names_all: 'Chippewa|Mackinac',
    county_weights: '{"26033": 79.41, "26097": 20.59}',
    density: 0.7,
    imprecise: false,
    latitude: 46.21221,
    longitude: -85.04417,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49793',
  },
  {
    city: 'Vanderbilt',
    county_fips: 26137,
    county_fips_all: '26137|26029|26031',
    county: 'Otsego',
    county_names_all: 'Otsego|Charlevoix|Cheboygan',
    county_weights: '{"26137": 84.4, "26029": 8.12, "26031": 7.48}',
    density: 5.4,
    imprecise: false,
    latitude: 45.15835,
    longitude: -84.57563,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49795',
  },
  {
    city: 'Walloon Lake',
    county_fips: 26029,
    county_fips_all: '26029',
    county: 'Charlevoix',
    county_names_all: 'Charlevoix',
    county_weights: '{"26029": 100}',
    density: 87.6,
    imprecise: false,
    latitude: 45.27407,
    longitude: -84.94712,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49796',
  },
  {
    city: 'Wolverine',
    county_fips: 26031,
    county_fips_all: '26031',
    county: 'Cheboygan',
    county_names_all: 'Cheboygan',
    county_weights: '{"26031": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 45.26597,
    longitude: -84.58177,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49799',
  },
  {
    city: 'Iron Mountain',
    county_fips: 26043,
    county_fips_all: '26043',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"26043": 100}',
    density: 37,
    imprecise: false,
    latitude: 45.9191,
    longitude: -88.01795,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 11860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49801',
  },
  {
    city: 'Kingsford',
    county_fips: 26043,
    county_fips_all: '26043',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"26043": 100}',
    density: 292.5,
    imprecise: false,
    latitude: 45.80053,
    longitude: -88.07718,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 5975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49802',
  },
  {
    city: 'Allouez',
    county_fips: 26083,
    county_fips_all: '26083|26061',
    county: 'Keweenaw',
    county_names_all: 'Keweenaw|Houghton',
    county_weights: '{"26083": 99.74, "26061": 0.26}',
    density: 4.4,
    imprecise: false,
    latitude: 47.3481,
    longitude: -88.38535,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49805',
  },
  {
    city: 'Au Train',
    county_fips: 26003,
    county_fips_all: '26003',
    county: 'Alger',
    county_names_all: 'Alger',
    county_weights: '{"26003": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 46.43802,
    longitude: -86.90056,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49806',
  },
  {
    city: 'Bark River',
    county_fips: 26041,
    county_fips_all: '26041|26109',
    county: 'Delta',
    county_names_all: 'Delta|Menominee',
    county_weights: '{"26041": 75.58, "26109": 24.42}',
    density: 8.5,
    imprecise: false,
    latitude: 45.71211,
    longitude: -87.28885,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49807',
  },
  {
    city: 'Big Bay',
    county_fips: 26103,
    county_fips_all: '26103',
    county: 'Marquette',
    county_names_all: 'Marquette',
    county_weights: '{"26103": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 46.8109,
    longitude: -87.8764,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49808',
  },
  {
    city: 'Carney',
    county_fips: 26109,
    county_fips_all: '26109',
    county: 'Menominee',
    county_names_all: 'Menominee',
    county_weights: '{"26109": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 45.59094,
    longitude: -87.50269,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49812',
  },
  {
    city: 'Champion',
    county_fips: 26103,
    county_fips_all: '26103',
    county: 'Marquette',
    county_names_all: 'Marquette',
    county_weights: '{"26103": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 46.54459,
    longitude: -87.94395,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49814',
  },
  {
    city: 'Channing',
    county_fips: 26043,
    county_fips_all: '26043',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"26043": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 46.18465,
    longitude: -87.95967,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49815',
  },
  {
    city: 'Chatham',
    county_fips: 26003,
    county_fips_all: '26003',
    county: 'Alger',
    county_names_all: 'Alger',
    county_weights: '{"26003": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 46.27517,
    longitude: -86.89863,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49816',
  },
  {
    city: 'Cooks',
    county_fips: 26041,
    county_fips_all: '26041|26153',
    county: 'Delta',
    county_names_all: 'Delta|Schoolcraft',
    county_weights: '{"26041": 60.12, "26153": 39.88}',
    density: 2.7,
    imprecise: false,
    latitude: 45.94711,
    longitude: -86.49946,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49817',
  },
  {
    city: 'Cornell',
    county_fips: 26103,
    county_fips_all: '26103|26041',
    county: 'Marquette',
    county_names_all: 'Marquette|Delta',
    county_weights: '{"26103": 52.36, "26041": 47.64}',
    density: 2.6,
    imprecise: false,
    latitude: 45.98223,
    longitude: -87.34745,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49818',
  },
  {
    city: 'Curtis',
    county_fips: 26097,
    county_fips_all: '26097',
    county: 'Mackinac',
    county_names_all: 'Mackinac',
    county_weights: '{"26097": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 46.18965,
    longitude: -85.67951,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49820',
  },
  {
    city: 'Daggett',
    county_fips: 26109,
    county_fips_all: '26109',
    county: 'Menominee',
    county_names_all: 'Menominee',
    county_weights: '{"26109": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 45.52167,
    longitude: -87.63052,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 1286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49821',
  },
  {
    city: 'Deerton',
    county_fips: 26003,
    county_fips_all: '26003|26103',
    county: 'Alger',
    county_names_all: 'Alger|Marquette',
    county_weights: '{"26003": 97.46, "26103": 2.54}',
    density: 1.4,
    imprecise: false,
    latitude: 46.45095,
    longitude: -87.02812,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49822',
  },
  {
    city: 'Eben Junction',
    county_fips: 26003,
    county_fips_all: '26003',
    county: 'Alger',
    county_names_all: 'Alger',
    county_weights: '{"26003": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 46.36039,
    longitude: -86.98462,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49825',
  },
  {
    city: 'Engadine',
    county_fips: 26097,
    county_fips_all: '26097',
    county: 'Mackinac',
    county_names_all: 'Mackinac',
    county_weights: '{"26097": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 46.1751,
    longitude: -85.53607,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49827',
  },
  {
    city: 'Escanaba',
    county_fips: 26041,
    county_fips_all: '26041',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"26041": 100}',
    density: 95,
    imprecise: false,
    latitude: 45.76773,
    longitude: -87.16522,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 16416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49829',
  },
  {
    city: 'Felch',
    county_fips: 26043,
    county_fips_all: '26043|26103',
    county: 'Dickinson',
    county_names_all: 'Dickinson|Marquette',
    county_weights: '{"26043": 68.03, "26103": 31.97}',
    density: 1.5,
    imprecise: false,
    latitude: 46.05777,
    longitude: -87.7356,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49831',
  },
  {
    city: 'Little Lake',
    county_fips: 26103,
    county_fips_all: '26103',
    county: 'Marquette',
    county_names_all: 'Marquette',
    county_weights: '{"26103": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 46.27504,
    longitude: -87.29142,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49833',
  },
  {
    city: 'Foster City',
    county_fips: 26043,
    county_fips_all: '26043',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"26043": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 45.96829,
    longitude: -87.70292,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49834',
  },
  {
    city: 'Garden',
    county_fips: 26041,
    county_fips_all: '26041',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"26041": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 45.74396,
    longitude: -86.57555,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49835',
  },
  {
    city: 'Germfask',
    county_fips: 26153,
    county_fips_all: '26153|26097|26095',
    county: 'Schoolcraft',
    county_names_all: 'Schoolcraft|Mackinac|Luce',
    county_weights: '{"26153": 72.63, "26097": 27.26, "26095": 0.11}',
    density: 4,
    imprecise: false,
    latitude: 46.1971,
    longitude: -85.88725,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49836',
  },
  {
    city: 'Gladstone',
    county_fips: 26041,
    county_fips_all: '26041',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"26041": 100}',
    density: 57.4,
    imprecise: false,
    latitude: 45.87129,
    longitude: -87.09781,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 10265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49837',
  },
  {
    city: 'Gould City',
    county_fips: 26097,
    county_fips_all: '26097',
    county: 'Mackinac',
    county_names_all: 'Mackinac',
    county_weights: '{"26097": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 46.06473,
    longitude: -85.75035,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49838',
  },
  {
    city: 'Grand Marais',
    county_fips: 26003,
    county_fips_all: '26003',
    county: 'Alger',
    county_names_all: 'Alger',
    county_weights: '{"26003": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 46.59994,
    longitude: -86.11555,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49839',
  },
  {
    city: 'Gulliver',
    county_fips: 26153,
    county_fips_all: '26153',
    county: 'Schoolcraft',
    county_names_all: 'Schoolcraft',
    county_weights: '{"26153": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 46.13742,
    longitude: -86.06009,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49840',
  },
  {
    city: 'Gwinn',
    county_fips: 26103,
    county_fips_all: '26103',
    county: 'Marquette',
    county_names_all: 'Marquette',
    county_weights: '{"26103": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 46.27145,
    longitude: -87.49873,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49841',
  },
  {
    city: 'Hermansville',
    county_fips: 26109,
    county_fips_all: '26109',
    county: 'Menominee',
    county_names_all: 'Menominee',
    county_weights: '{"26109": 100}',
    density: 7,
    imprecise: false,
    latitude: 45.70585,
    longitude: -87.63267,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 1083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49847',
  },
  {
    city: 'Ingalls',
    county_fips: 26109,
    county_fips_all: '26109',
    county: 'Menominee',
    county_names_all: 'Menominee',
    county_weights: '{"26109": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 45.37926,
    longitude: -87.63576,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49848',
  },
  {
    city: 'Ishpeming',
    county_fips: 26103,
    county_fips_all: '26103',
    county: 'Marquette',
    county_names_all: 'Marquette',
    county_weights: '{"26103": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 46.423,
    longitude: -87.76797,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 12117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49849',
  },
  {
    city: 'Loretto',
    county_fips: 26043,
    county_fips_all: '26043',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"26043": 100}',
    density: 292.5,
    imprecise: false,
    latitude: 45.78399,
    longitude: -87.81807,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49852',
  },
  {
    city: 'McMillan',
    county_fips: 26095,
    county_fips_all: '26095|26097',
    county: 'Luce',
    county_names_all: 'Luce|Mackinac',
    county_weights: '{"26095": 98.74, "26097": 1.26}',
    density: 3.1,
    imprecise: false,
    latitude: 46.36112,
    longitude: -85.74494,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49853',
  },
  {
    city: 'Manistique',
    county_fips: 26153,
    county_fips_all: '26153|26041',
    county: 'Schoolcraft',
    county_names_all: 'Schoolcraft|Delta',
    county_weights: '{"26153": 94.51, "26041": 5.49}',
    density: 5.1,
    imprecise: false,
    latitude: 46.09581,
    longitude: -86.36453,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 6199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49854',
  },
  {
    city: 'Marquette',
    county_fips: 26103,
    county_fips_all: '26103',
    county: 'Marquette',
    county_names_all: 'Marquette',
    county_weights: '{"26103": 100}',
    density: 63.2,
    imprecise: false,
    latitude: 46.56603,
    longitude: -87.45932,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 33876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49855',
  },
  {
    city: 'Menominee',
    county_fips: 26109,
    county_fips_all: '26109',
    county: 'Menominee',
    county_names_all: 'Menominee',
    county_weights: '{"26109": 100}',
    density: 53,
    imprecise: false,
    latitude: 45.21989,
    longitude: -87.58325,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 11927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49858',
  },
  {
    city: 'Michigamme',
    county_fips: 26013,
    county_fips_all: '26013|26103',
    county: 'Baraga',
    county_names_all: 'Baraga|Marquette',
    county_weights: '{"26013": 87.57, "26103": 12.43}',
    density: 1.1,
    imprecise: false,
    latitude: 46.57639,
    longitude: -88.16043,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49861',
  },
  {
    city: 'Munising',
    county_fips: 26003,
    county_fips_all: '26003',
    county: 'Alger',
    county_names_all: 'Alger',
    county_weights: '{"26003": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 46.38021,
    longitude: -86.7153,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49862',
  },
  {
    city: 'Nadeau',
    county_fips: 26109,
    county_fips_all: '26109',
    county: 'Menominee',
    county_names_all: 'Menominee',
    county_weights: '{"26109": 100}',
    density: 85.1,
    imprecise: false,
    latitude: 45.61295,
    longitude: -87.55163,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49863',
  },
  {
    city: 'Nahma',
    county_fips: 26041,
    county_fips_all: '26041',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"26041": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 45.84444,
    longitude: -86.65104,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49864',
  },
  {
    city: 'Negaunee',
    county_fips: 26103,
    county_fips_all: '26103',
    county: 'Marquette',
    county_names_all: 'Marquette',
    county_weights: '{"26103": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 46.54989,
    longitude: -87.66246,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 8207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49866',
  },
  {
    city: 'Newberry',
    county_fips: 26095,
    county_fips_all: '26095',
    county: 'Luce',
    county_names_all: 'Luce',
    county_weights: '{"26095": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 46.49317,
    longitude: -85.50586,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 4964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49868',
  },
  {
    city: 'Norway',
    county_fips: 26043,
    county_fips_all: '26043',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"26043": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 45.87315,
    longitude: -87.89964,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 3509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49870',
  },
  {
    city: 'Palmer',
    county_fips: 26103,
    county_fips_all: '26103',
    county: 'Marquette',
    county_names_all: 'Marquette',
    county_weights: '{"26103": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 46.42433,
    longitude: -87.53282,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49871',
  },
  {
    city: 'Perkins',
    county_fips: 26041,
    county_fips_all: '26041',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"26041": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 46.01824,
    longitude: -87.08222,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49872',
  },
  {
    city: 'Perronville',
    county_fips: 26109,
    county_fips_all: '26109',
    county: 'Menominee',
    county_names_all: 'Menominee',
    county_weights: '{"26109": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 45.876,
    longitude: -87.51824,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49873',
  },
  {
    city: 'Powers',
    county_fips: 26109,
    county_fips_all: '26109',
    county: 'Menominee',
    county_names_all: 'Menominee',
    county_weights: '{"26109": 100}',
    density: 10,
    imprecise: false,
    latitude: 45.70394,
    longitude: -87.50568,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 1098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49874',
  },
  {
    city: 'Quinnesec',
    county_fips: 26043,
    county_fips_all: '26043',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"26043": 100}',
    density: 85.6,
    imprecise: false,
    latitude: 45.80211,
    longitude: -87.97729,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49876',
  },
  {
    city: 'Ralph',
    county_fips: 26043,
    county_fips_all: '26043',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"26043": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 46.15651,
    longitude: -87.7425,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49877',
  },
  {
    city: 'Rapid River',
    county_fips: 26041,
    county_fips_all: '26041|26003',
    county: 'Delta',
    county_names_all: 'Delta|Alger',
    county_weights: '{"26041": 97.21, "26003": 2.79}',
    density: 2.8,
    imprecise: false,
    latitude: 45.95852,
    longitude: -86.86516,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49878',
  },
  {
    city: 'Republic',
    county_fips: 26103,
    county_fips_all: '26103|26071',
    county: 'Marquette',
    county_names_all: 'Marquette|Iron',
    county_weights: '{"26103": 64.65, "26071": 35.35}',
    density: 2.3,
    imprecise: false,
    latitude: 46.3437,
    longitude: -88.08432,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49879',
  },
  {
    city: 'Rock',
    county_fips: 26103,
    county_fips_all: '26103|26041',
    county: 'Marquette',
    county_names_all: 'Marquette|Delta',
    county_weights: '{"26103": 57.27, "26041": 42.73}',
    density: 1.8,
    imprecise: false,
    latitude: 46.11693,
    longitude: -87.22515,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49880',
  },
  {
    city: 'Sagola',
    county_fips: 26043,
    county_fips_all: '26043',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"26043": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 46.07852,
    longitude: -88.03259,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49881',
  },
  {
    city: 'Seney',
    county_fips: 26153,
    county_fips_all: '26153|26003',
    county: 'Schoolcraft',
    county_names_all: 'Schoolcraft|Alger',
    county_weights: '{"26153": 81.17, "26003": 18.83}',
    density: 0.3,
    imprecise: false,
    latitude: 46.42885,
    longitude: -86.0318,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49883',
  },
  {
    city: 'Shingleton',
    county_fips: 26003,
    county_fips_all: '26003|26153',
    county: 'Alger',
    county_names_all: 'Alger|Schoolcraft',
    county_weights: '{"26003": 56.28, "26153": 43.72}',
    density: 1,
    imprecise: false,
    latitude: 46.41734,
    longitude: -86.35554,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49884',
  },
  {
    city: 'Skandia',
    county_fips: 26103,
    county_fips_all: '26103|26003',
    county: 'Marquette',
    county_names_all: 'Marquette|Alger',
    county_weights: '{"26103": 84.48, "26003": 15.52}',
    density: 5.1,
    imprecise: false,
    latitude: 46.34658,
    longitude: -87.19238,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49885',
  },
  {
    city: 'Spalding',
    county_fips: 26109,
    county_fips_all: '26109',
    county: 'Menominee',
    county_names_all: 'Menominee',
    county_weights: '{"26109": 100}',
    density: 36.5,
    imprecise: false,
    latitude: 45.69748,
    longitude: -87.49409,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49886',
  },
  {
    city: 'Stephenson',
    county_fips: 26109,
    county_fips_all: '26109',
    county: 'Menominee',
    county_names_all: 'Menominee',
    county_weights: '{"26109": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 45.43104,
    longitude: -87.56773,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 2731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49887',
  },
  {
    city: 'Trenary',
    county_fips: 26003,
    county_fips_all: '26003',
    county: 'Alger',
    county_names_all: 'Alger',
    county_weights: '{"26003": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 46.23206,
    longitude: -87.02828,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49891',
  },
  {
    city: 'Vulcan',
    county_fips: 26043,
    county_fips_all: '26043|26109',
    county: 'Dickinson',
    county_names_all: 'Dickinson|Menominee',
    county_weights: '{"26043": 69.67, "26109": 30.33}',
    density: 5.1,
    imprecise: false,
    latitude: 45.77547,
    longitude: -87.77243,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 2037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49892',
  },
  {
    city: 'Wallace',
    county_fips: 26109,
    county_fips_all: '26109',
    county: 'Menominee',
    county_names_all: 'Menominee',
    county_weights: '{"26109": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 45.29767,
    longitude: -87.59927,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 1320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49893',
  },
  {
    city: 'Wells',
    county_fips: 26041,
    county_fips_all: '26041',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"26041": 100}',
    density: 456.1,
    imprecise: false,
    latitude: 45.78292,
    longitude: -87.07634,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49894',
  },
  {
    city: 'Wetmore',
    county_fips: 26041,
    county_fips_all: '26041|26003|26153',
    county: 'Delta',
    county_names_all: 'Delta|Alger|Schoolcraft',
    county_weights: '{"26041": 49.0, "26003": 44.35, "26153": 6.65}',
    density: 1.5,
    imprecise: false,
    latitude: 46.16807,
    longitude: -86.66593,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49895',
  },
  {
    city: 'Wilson',
    county_fips: 26109,
    county_fips_all: '26109',
    county: 'Menominee',
    county_names_all: 'Menominee',
    county_weights: '{"26109": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 45.67748,
    longitude: -87.38953,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 1660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49896',
  },
  {
    city: 'Ahmeek',
    county_fips: 26083,
    county_fips_all: '26083',
    county: 'Keweenaw',
    county_names_all: 'Keweenaw',
    county_weights: '{"26083": 100}',
    density: 106.5,
    imprecise: false,
    latitude: 47.29384,
    longitude: -88.39094,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49901',
  },
  {
    city: 'Alpha',
    county_fips: 26071,
    county_fips_all: '26071',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"26071": 100}',
    density: 114.9,
    imprecise: false,
    latitude: 46.04905,
    longitude: -88.37744,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49902',
  },
  {
    city: 'Amasa',
    county_fips: 26071,
    county_fips_all: '26071',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"26071": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 46.33455,
    longitude: -88.48496,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49903',
  },
  {
    city: 'Atlantic Mine',
    county_fips: 26061,
    county_fips_all: '26061',
    county: 'Houghton',
    county_names_all: 'Houghton',
    county_weights: '{"26061": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 47.10694,
    longitude: -88.71395,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49905',
  },
  {
    city: 'Baraga',
    county_fips: 26013,
    county_fips_all: '26013',
    county: 'Baraga',
    county_names_all: 'Baraga',
    county_weights: '{"26013": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 46.75276,
    longitude: -88.57034,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49908',
  },
  {
    city: 'Bergland',
    county_fips: 26131,
    county_fips_all: '26131',
    county: 'Ontonagon',
    county_names_all: 'Ontonagon',
    county_weights: '{"26131": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 46.61815,
    longitude: -89.54308,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49910',
  },
  {
    city: 'Bessemer',
    county_fips: 26053,
    county_fips_all: '26053',
    county: 'Gogebic',
    county_names_all: 'Gogebic',
    county_weights: '{"26053": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 46.49247,
    longitude: -90.05235,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 2729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49911',
  },
  {
    city: 'Bruce Crossing',
    county_fips: 26131,
    county_fips_all: '26131',
    county: 'Ontonagon',
    county_names_all: 'Ontonagon',
    county_weights: '{"26131": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 46.49393,
    longitude: -89.20017,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49912',
  },
  {
    city: 'Calumet',
    county_fips: 26061,
    county_fips_all: '26061|26083',
    county: 'Houghton',
    county_names_all: 'Houghton|Keweenaw',
    county_weights: '{"26061": 92.77, "26083": 7.23}',
    density: 38.4,
    imprecise: false,
    latitude: 47.23746,
    longitude: -88.44994,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49913',
  },
  {
    city: 'Caspian',
    county_fips: 26071,
    county_fips_all: '26071',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"26071": 100}',
    density: 182.8,
    imprecise: false,
    latitude: 46.06464,
    longitude: -88.62708,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49915',
  },
  {
    city: 'Chassell',
    county_fips: 26061,
    county_fips_all: '26061',
    county: 'Houghton',
    county_names_all: 'Houghton',
    county_weights: '{"26061": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 46.97891,
    longitude: -88.59519,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49916',
  },
  {
    city: 'Copper City',
    county_fips: 26061,
    county_fips_all: '26061',
    county: 'Houghton',
    county_names_all: 'Houghton',
    county_weights: '{"26061": 100}',
    density: 73.3,
    imprecise: false,
    latitude: 47.28138,
    longitude: -88.35908,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49917',
  },
  {
    city: 'Copper Harbor',
    county_fips: 26083,
    county_fips_all: '26083',
    county: 'Keweenaw',
    county_names_all: 'Keweenaw',
    county_weights: '{"26083": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 47.43585,
    longitude: -87.81238,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49918',
  },
  {
    city: 'Covington',
    county_fips: 26013,
    county_fips_all: '26013',
    county: 'Baraga',
    county_names_all: 'Baraga',
    county_weights: '{"26013": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 46.50995,
    longitude: -88.43518,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49919',
  },
  {
    city: 'Crystal Falls',
    county_fips: 26071,
    county_fips_all: '26071',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"26071": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 46.14087,
    longitude: -88.30079,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 4380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49920',
  },
  {
    city: 'Dodgeville',
    county_fips: 26061,
    county_fips_all: '26061',
    county: 'Houghton',
    county_names_all: 'Houghton',
    county_weights: '{"26061": 100}',
    density: 275.4,
    imprecise: false,
    latitude: 47.09084,
    longitude: -88.5818,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49921',
  },
  {
    city: 'Dollar Bay',
    county_fips: 26061,
    county_fips_all: '26061',
    county: 'Houghton',
    county_names_all: 'Houghton',
    county_weights: '{"26061": 100}',
    density: 115.8,
    imprecise: false,
    latitude: 47.12369,
    longitude: -88.49522,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49922',
  },
  {
    city: 'Ewen',
    county_fips: 26131,
    county_fips_all: '26131',
    county: 'Ontonagon',
    county_names_all: 'Ontonagon',
    county_weights: '{"26131": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 46.55088,
    longitude: -89.37681,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49925',
  },
  {
    city: 'Gaastra',
    county_fips: 26071,
    county_fips_all: '26071',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"26071": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 46.04475,
    longitude: -88.57108,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49927',
  },
  {
    city: 'Greenland',
    county_fips: 26131,
    county_fips_all: '26131',
    county: 'Ontonagon',
    county_names_all: 'Ontonagon',
    county_weights: '{"26131": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 46.79874,
    longitude: -89.09567,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49929',
  },
  {
    city: 'Hancock',
    county_fips: 26061,
    county_fips_all: '26061',
    county: 'Houghton',
    county_names_all: 'Houghton',
    county_weights: '{"26061": 100}',
    density: 57.8,
    imprecise: false,
    latitude: 47.15577,
    longitude: -88.53542,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 7405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49930',
  },
  {
    city: 'Houghton',
    county_fips: 26061,
    county_fips_all: '26061',
    county: 'Houghton',
    county_names_all: 'Houghton',
    county_weights: '{"26061": 100}',
    density: 153.4,
    imprecise: false,
    latitude: 47.13652,
    longitude: -88.6063,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 10475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49931',
  },
  {
    city: 'Hubbell',
    county_fips: 26061,
    county_fips_all: '26061',
    county: 'Houghton',
    county_names_all: 'Houghton',
    county_weights: '{"26061": 100}',
    density: 232.3,
    imprecise: false,
    latitude: 47.16539,
    longitude: -88.43967,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49934',
  },
  {
    city: 'Iron River',
    county_fips: 26071,
    county_fips_all: '26071',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"26071": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 46.19493,
    longitude: -88.7463,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 5841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49935',
  },
  {
    city: 'Ironwood',
    county_fips: 26053,
    county_fips_all: '26053',
    county: 'Gogebic',
    county_names_all: 'Gogebic',
    county_weights: '{"26053": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 46.51493,
    longitude: -90.13264,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 7460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49938',
  },
  {
    city: 'Lake Linden',
    county_fips: 26061,
    county_fips_all: '26061|26083',
    county: 'Houghton',
    county_names_all: 'Houghton|Keweenaw',
    county_weights: '{"26061": 65.23, "26083": 34.77}',
    density: 7.1,
    imprecise: false,
    latitude: 47.16956,
    longitude: -88.30752,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49945',
  },
  {
    city: 'Lanse',
    county_fips: 26013,
    county_fips_all: '26013',
    county: 'Baraga',
    county_names_all: 'Baraga',
    county_weights: '{"26013": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 46.7189,
    longitude: -88.33725,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 3757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49946',
  },
  {
    city: 'Marenisco',
    county_fips: 26053,
    county_fips_all: '26053|26131',
    county: 'Gogebic',
    county_names_all: 'Gogebic|Ontonagon',
    county_weights: '{"26053": 80.38, "26131": 19.62}',
    density: 0.7,
    imprecise: false,
    latitude: 46.42589,
    longitude: -89.60536,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49947',
  },
  {
    city: 'Mass City',
    county_fips: 26131,
    county_fips_all: '26131|26061',
    county: 'Ontonagon',
    county_names_all: 'Ontonagon|Houghton',
    county_weights: '{"26131": 98.43, "26061": 1.57}',
    density: 2,
    imprecise: false,
    latitude: 46.74567,
    longitude: -88.99919,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49948',
  },
  {
    city: 'Mohawk',
    county_fips: 26083,
    county_fips_all: '26083',
    county: 'Keweenaw',
    county_names_all: 'Keweenaw',
    county_weights: '{"26083": 100}',
    density: 2,
    imprecise: false,
    latitude: 47.37834,
    longitude: -88.12035,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49950',
  },
  {
    city: 'Nisula',
    county_fips: 26061,
    county_fips_all: '26061|26131',
    county: 'Houghton',
    county_names_all: 'Houghton|Ontonagon',
    county_weights: '{"26061": 97.64, "26131": 2.36}',
    density: 0.5,
    imprecise: false,
    latitude: 46.68309,
    longitude: -88.78408,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49952',
  },
  {
    city: 'Ontonagon',
    county_fips: 26131,
    county_fips_all: '26131',
    county: 'Ontonagon',
    county_names_all: 'Ontonagon',
    county_weights: '{"26131": 100}',
    density: 2,
    imprecise: false,
    latitude: 46.79328,
    longitude: -89.42477,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49953',
  },
  {
    city: 'Painesdale',
    county_fips: 26061,
    county_fips_all: '26061',
    county: 'Houghton',
    county_names_all: 'Houghton',
    county_weights: '{"26061": 100}',
    density: 24,
    imprecise: false,
    latitude: 47.00788,
    longitude: -88.69373,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49955',
  },
  {
    city: 'Pelkie',
    county_fips: 26061,
    county_fips_all: '26061|26013',
    county: 'Houghton',
    county_names_all: 'Houghton|Baraga',
    county_weights: '{"26061": 69.74, "26013": 30.26}',
    density: 2.6,
    imprecise: false,
    latitude: 46.8165,
    longitude: -88.67595,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49958',
  },
  {
    city: 'Ramsay',
    county_fips: 26053,
    county_fips_all: '26053',
    county: 'Gogebic',
    county_names_all: 'Gogebic',
    county_weights: '{"26053": 100}',
    density: 143.4,
    imprecise: false,
    latitude: 46.46987,
    longitude: -89.99803,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49959',
  },
  {
    city: 'Rockland',
    county_fips: 26131,
    county_fips_all: '26131',
    county: 'Ontonagon',
    county_names_all: 'Ontonagon',
    county_weights: '{"26131": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 46.71139,
    longitude: -89.25085,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49960',
  },
  {
    city: 'Sidnaw',
    county_fips: 26061,
    county_fips_all: '26061',
    county: 'Houghton',
    county_names_all: 'Houghton',
    county_weights: '{"26061": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 46.50667,
    longitude: -88.74358,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49961',
  },
  {
    city: 'Skanee',
    county_fips: 26013,
    county_fips_all: '26013',
    county: 'Baraga',
    county_names_all: 'Baraga',
    county_weights: '{"26013": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 46.82142,
    longitude: -88.1409,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49962',
  },
  {
    city: 'South Range',
    county_fips: 26061,
    county_fips_all: '26061',
    county: 'Houghton',
    county_names_all: 'Houghton',
    county_weights: '{"26061": 100}',
    density: 45.2,
    imprecise: false,
    latitude: 47.04897,
    longitude: -88.64002,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49963',
  },
  {
    city: 'Toivola',
    county_fips: 26061,
    county_fips_all: '26061|26131',
    county: 'Houghton',
    county_names_all: 'Houghton|Ontonagon',
    county_weights: '{"26061": 87.07, "26131": 12.93}',
    density: 1.1,
    imprecise: false,
    latitude: 46.94752,
    longitude: -88.85878,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49965',
  },
  {
    city: 'Trout Creek',
    county_fips: 26061,
    county_fips_all: '26061|26131|26071',
    county: 'Houghton',
    county_names_all: 'Houghton|Ontonagon|Iron',
    county_weights: '{"26061": 43.55, "26131": 36.77, "26071": 19.68}',
    density: 0.4,
    imprecise: false,
    latitude: 46.49377,
    longitude: -88.95551,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49967',
  },
  {
    city: 'Wakefield',
    county_fips: 26053,
    county_fips_all: '26053',
    county: 'Gogebic',
    county_names_all: 'Gogebic',
    county_weights: '{"26053": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 46.50199,
    longitude: -89.88314,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 2203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49968',
  },
  {
    city: 'Watersmeet',
    county_fips: 26053,
    county_fips_all: '26053',
    county: 'Gogebic',
    county_names_all: 'Gogebic',
    county_weights: '{"26053": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 46.24608,
    longitude: -89.21431,
    militaryZip: false,
    timezone: 'America/Menominee',
    population: 1000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49969',
  },
  {
    city: 'Watton',
    county_fips: 26013,
    county_fips_all: '26013',
    county: 'Baraga',
    county_names_all: 'Baraga',
    county_weights: '{"26013": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 46.53555,
    longitude: -88.59783,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49970',
  },
  {
    city: 'White Pine',
    county_fips: 26131,
    county_fips_all: '26131',
    county: 'Ontonagon',
    county_names_all: 'Ontonagon',
    county_weights: '{"26131": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 46.71043,
    longitude: -89.62866,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49971',
  },
  {
    city: 'Ackworth',
    county_fips: 19181,
    county_fips_all: '19181',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"19181": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 41.3611,
    longitude: -93.43321,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50001',
  },
  {
    city: 'Adair',
    county_fips: 19077,
    county_fips_all: '19077|19001|19009',
    county: 'Guthrie',
    county_names_all: 'Guthrie|Adair|Audubon',
    county_weights: '{"19077": 53.43, "19001": 45.18, "19009": 1.39}',
    density: 5.2,
    imprecise: false,
    latitude: 41.51236,
    longitude: -94.64801,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50002',
  },
  {
    city: 'Adel',
    county_fips: 19049,
    county_fips_all: '19049',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"19049": 100}',
    density: 33.4,
    imprecise: false,
    latitude: 41.61192,
    longitude: -94.04352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50003',
  },
  {
    city: 'Albion',
    county_fips: 19127,
    county_fips_all: '19127',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"19127": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 42.1295,
    longitude: -93.02683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50005',
  },
  {
    city: 'Alden',
    county_fips: 19083,
    county_fips_all: '19083|19069|19079',
    county: 'Hardin',
    county_names_all: 'Hardin|Franklin|Hamilton',
    county_weights: '{"19083": 68.8, "19069": 30.33, "19079": 0.87}',
    density: 4.5,
    imprecise: false,
    latitude: 42.51354,
    longitude: -93.40227,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50006',
  },
  {
    city: 'Alleman',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 31.6,
    imprecise: false,
    latitude: 41.80365,
    longitude: -93.60043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50007',
  },
  {
    city: 'Allerton',
    county_fips: 19185,
    county_fips_all: '19185',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"19185": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 40.67847,
    longitude: -93.38549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50008',
  },
  {
    city: 'Altoona',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 316.6,
    imprecise: false,
    latitude: 41.64313,
    longitude: -93.45945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50009',
  },
  {
    city: 'Ames',
    county_fips: 19169,
    county_fips_all: '19169',
    county: 'Story',
    county_names_all: 'Story',
    county_weights: '{"19169": 100}',
    density: 216.5,
    imprecise: false,
    latitude: 42.03316,
    longitude: -93.58761,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50010',
  },
  {
    city: 'Ames',
    county_fips: 19169,
    county_fips_all: '19169|19015',
    county: 'Story',
    county_names_all: 'Story|Boone',
    county_weights: '{"19169": 56.16, "19015": 43.84}',
    density: 234.7,
    imprecise: false,
    latitude: 42.04993,
    longitude: -93.69342,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50014',
  },
  {
    city: 'Anita',
    county_fips: 19029,
    county_fips_all: '19029|19001|19009|19077',
    county: 'Cass',
    county_names_all: 'Cass|Adair|Audubon|Guthrie',
    county_weights:
      '{"19029": 77.51, "19001": 11.71, "19009": 9.77, "19077": 1.01}',
    density: 4.8,
    imprecise: false,
    latitude: 41.43364,
    longitude: -94.75215,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50020',
  },
  {
    city: 'Ankeny',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 485.6,
    imprecise: false,
    latitude: 41.7207,
    longitude: -93.56838,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50021',
  },
  {
    city: 'Atlantic',
    county_fips: 19029,
    county_fips_all: '19029|19009|19165',
    county: 'Cass',
    county_names_all: 'Cass|Audubon|Shelby',
    county_weights: '{"19029": 89.3, "19009": 6.58, "19165": 4.12}',
    density: 19.1,
    imprecise: false,
    latitude: 41.41737,
    longitude: -95.00352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50022',
  },
  {
    city: 'Ankeny',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 852.5,
    imprecise: false,
    latitude: 41.72768,
    longitude: -93.63412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50023',
  },
  {
    city: 'Audubon',
    county_fips: 19009,
    county_fips_all: '19009|19077',
    county: 'Audubon',
    county_names_all: 'Audubon|Guthrie',
    county_weights: '{"19009": 98.48, "19077": 1.52}',
    density: 6.2,
    imprecise: false,
    latitude: 41.75628,
    longitude: -94.92034,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50025',
  },
  {
    city: 'Bagley',
    county_fips: 19077,
    county_fips_all: '19077|19073',
    county: 'Guthrie',
    county_names_all: 'Guthrie|Greene',
    county_weights: '{"19077": 57.06, "19073": 42.94}',
    density: 3.3,
    imprecise: false,
    latitude: 41.85823,
    longitude: -94.44958,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50026',
  },
  {
    city: 'Barnes City',
    county_fips: 19123,
    county_fips_all: '19123|19157',
    county: 'Mahaska',
    county_names_all: 'Mahaska|Poweshiek',
    county_weights: '{"19123": 99.26, "19157": 0.74}',
    density: 2.1,
    imprecise: false,
    latitude: 41.4739,
    longitude: -92.47194,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50027',
  },
  {
    city: 'Baxter',
    county_fips: 19099,
    county_fips_all: '19099|19127',
    county: 'Jasper',
    county_names_all: 'Jasper|Marshall',
    county_weights: '{"19099": 95.53, "19127": 4.47}',
    density: 16.9,
    imprecise: false,
    latitude: 41.81729,
    longitude: -93.15102,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50028',
  },
  {
    city: 'Bayard',
    county_fips: 19077,
    county_fips_all: '19077|19073',
    county: 'Guthrie',
    county_names_all: 'Guthrie|Greene',
    county_weights: '{"19077": 92.13, "19073": 7.87}',
    density: 5.3,
    imprecise: false,
    latitude: 41.82497,
    longitude: -94.55075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50029',
  },
  {
    city: 'Beaver',
    county_fips: 19015,
    county_fips_all: '19015',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"19015": 100}',
    density: 93,
    imprecise: false,
    latitude: 42.03881,
    longitude: -94.14003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50031',
  },
  {
    city: 'Berwick',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 642.2,
    imprecise: false,
    latitude: 41.66591,
    longitude: -93.54301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50032',
  },
  {
    city: 'Bevington',
    county_fips: 19121,
    county_fips_all: '19121',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"19121": 100}',
    density: 23.8,
    imprecise: false,
    latitude: 41.36048,
    longitude: -93.79416,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50033',
  },
  {
    city: 'Blairsburg',
    county_fips: 19079,
    county_fips_all: '19079|19197',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Wright',
    county_weights: '{"19079": 66.12, "19197": 33.88}',
    density: 2,
    imprecise: false,
    latitude: 42.52921,
    longitude: -93.65438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50034',
  },
  {
    city: 'Bondurant',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 90.5,
    imprecise: false,
    latitude: 41.7248,
    longitude: -93.45957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50035',
  },
  {
    city: 'Boone',
    county_fips: 19015,
    county_fips_all: '19015|19079',
    county: 'Boone',
    county_names_all: 'Boone|Hamilton',
    county_weights: '{"19015": 98.44, "19079": 1.56}',
    density: 32.5,
    imprecise: false,
    latitude: 42.0892,
    longitude: -93.85378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50036',
  },
  {
    city: 'Booneville',
    county_fips: 19049,
    county_fips_all: '19049',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"19049": 100}',
    density: 23.5,
    imprecise: false,
    latitude: 41.52186,
    longitude: -93.90064,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50038',
  },
  {
    city: 'Bouton',
    county_fips: 19049,
    county_fips_all: '19049|19015',
    county: 'Dallas',
    county_names_all: 'Dallas|Boone',
    county_weights: '{"19049": 93.99, "19015": 6.01}',
    density: 6.4,
    imprecise: false,
    latitude: 41.82615,
    longitude: -94.00653,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50039',
  },
  {
    city: 'Boxholm',
    county_fips: 19015,
    county_fips_all: '19015',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"19015": 100}',
    density: 43.2,
    imprecise: false,
    latitude: 42.17363,
    longitude: -94.10121,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50040',
  },
  {
    city: 'Bradford',
    county_fips: 19069,
    county_fips_all: '19069',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"19069": 100}',
    density: 139,
    imprecise: false,
    latitude: 42.63429,
    longitude: -93.24662,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50041',
  },
  {
    city: 'Brayton',
    county_fips: 19009,
    county_fips_all: '19009|19029',
    county: 'Audubon',
    county_names_all: 'Audubon|Cass',
    county_weights: '{"19009": 97.56, "19029": 2.44}',
    density: 2.6,
    imprecise: false,
    latitude: 41.53326,
    longitude: -94.90004,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50042',
  },
  {
    city: 'Bussey',
    county_fips: 19125,
    county_fips_all: '19125|19123|19135',
    county: 'Marion',
    county_names_all: 'Marion|Mahaska|Monroe',
    county_weights: '{"19125": 59.41, "19123": 36.51, "19135": 4.08}',
    density: 7.3,
    imprecise: false,
    latitude: 41.20247,
    longitude: -92.88907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50044',
  },
  {
    city: 'Cambridge',
    county_fips: 19169,
    county_fips_all: '19169|19153',
    county: 'Story',
    county_names_all: 'Story|Polk',
    county_weights: '{"19169": 72.77, "19153": 27.23}',
    density: 12.6,
    imprecise: false,
    latitude: 41.88974,
    longitude: -93.5234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50046',
  },
  {
    city: 'Carlisle',
    county_fips: 19181,
    county_fips_all: '19181|19153',
    county: 'Warren',
    county_names_all: 'Warren|Polk',
    county_weights: '{"19181": 73.86, "19153": 26.14}',
    density: 38.4,
    imprecise: false,
    latitude: 41.47551,
    longitude: -93.46556,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50047',
  },
  {
    city: 'Casey',
    county_fips: 19077,
    county_fips_all: '19077|19001',
    county: 'Guthrie',
    county_names_all: 'Guthrie|Adair',
    county_weights: '{"19077": 55.83, "19001": 44.17}',
    density: 2.5,
    imprecise: false,
    latitude: 41.51167,
    longitude: -94.51936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50048',
  },
  {
    city: 'Chariton',
    county_fips: 19117,
    county_fips_all: '19117|19185|19125',
    county: 'Lucas',
    county_names_all: 'Lucas|Wayne|Marion',
    county_weights: '{"19117": 97.46, "19185": 1.63, "19125": 0.91}',
    density: 11.9,
    imprecise: false,
    latitude: 41.03741,
    longitude: -93.29566,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50049',
  },
  {
    city: 'Churdan',
    county_fips: 19073,
    county_fips_all: '19073|19025|19027',
    county: 'Greene',
    county_names_all: 'Greene|Calhoun|Carroll',
    county_weights: '{"19073": 93.56, "19025": 3.88, "19027": 2.56}',
    density: 3.5,
    imprecise: false,
    latitude: 42.16459,
    longitude: -94.51054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50050',
  },
  {
    city: 'Clemons',
    county_fips: 19127,
    county_fips_all: '19127',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"19127": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 42.13875,
    longitude: -93.13736,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50051',
  },
  {
    city: 'Clio',
    county_fips: 19185,
    county_fips_all: '19185',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"19185": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 40.64417,
    longitude: -93.44538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50052',
  },
  {
    city: 'Colfax',
    county_fips: 19099,
    county_fips_all: '19099',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"19099": 100}',
    density: 20,
    imprecise: false,
    latitude: 41.68729,
    longitude: -93.23196,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50054',
  },
  {
    city: 'Collins',
    county_fips: 19169,
    county_fips_all: '19169|19099|19127',
    county: 'Story',
    county_names_all: 'Story|Jasper|Marshall',
    county_weights: '{"19169": 65.17, "19099": 30.45, "19127": 4.38}',
    density: 8.3,
    imprecise: false,
    latitude: 41.88456,
    longitude: -93.2889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50055',
  },
  {
    city: 'Colo',
    county_fips: 19169,
    county_fips_all: '19169',
    county: 'Story',
    county_names_all: 'Story',
    county_weights: '{"19169": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 42.01925,
    longitude: -93.29701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50056',
  },
  {
    city: 'Columbia',
    county_fips: 19125,
    county_fips_all: '19125',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"19125": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 41.17859,
    longitude: -93.14554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50057',
  },
  {
    city: 'Coon Rapids',
    county_fips: 19077,
    county_fips_all: '19077|19027|19009|19073',
    county: 'Guthrie',
    county_names_all: 'Guthrie|Carroll|Audubon|Greene',
    county_weights:
      '{"19077": 39.45, "19027": 39.02, "19009": 12.08, "19073": 9.45}',
    density: 5.5,
    imprecise: false,
    latitude: 41.85773,
    longitude: -94.69044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50058',
  },
  {
    city: 'Corydon',
    county_fips: 19185,
    county_fips_all: '19185',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"19185": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 40.75508,
    longitude: -93.31922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50060',
  },
  {
    city: 'Cumming',
    county_fips: 19121,
    county_fips_all: '19121|19181|19049|19153',
    county: 'Madison',
    county_names_all: 'Madison|Warren|Dallas|Polk',
    county_weights:
      '{"19121": 51.93, "19181": 33.7, "19049": 7.44, "19153": 6.93}',
    density: 26.5,
    imprecise: false,
    latitude: 41.48022,
    longitude: -93.79343,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50061',
  },
  {
    city: 'Melcher Dallas',
    county_fips: 19125,
    county_fips_all: '19125',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"19125": 100}',
    density: 10,
    imprecise: false,
    latitude: 41.23499,
    longitude: -93.24425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50062',
  },
  {
    city: 'Dallas Center',
    county_fips: 19049,
    county_fips_all: '19049',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"19049": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 41.69669,
    longitude: -93.93677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50063',
  },
  {
    city: 'Dana',
    county_fips: 19073,
    county_fips_all: '19073|19015',
    county: 'Greene',
    county_names_all: 'Greene|Boone',
    county_weights: '{"19073": 89.45, "19015": 10.55}',
    density: 2,
    imprecise: false,
    latitude: 42.10671,
    longitude: -94.229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50064',
  },
  {
    city: 'Davis City',
    county_fips: 19053,
    county_fips_all: '19053',
    county: 'Decatur',
    county_names_all: 'Decatur',
    county_weights: '{"19053": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 40.60859,
    longitude: -93.78089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50065',
  },
  {
    city: 'Dawson',
    county_fips: 19049,
    county_fips_all: '19049',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"19049": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 41.8051,
    longitude: -94.22708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50066',
  },
  {
    city: 'Decatur',
    county_fips: 19053,
    county_fips_all: '19053',
    county: 'Decatur',
    county_names_all: 'Decatur',
    county_weights: '{"19053": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 40.70452,
    longitude: -93.85914,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50067',
  },
  {
    city: 'Derby',
    county_fips: 19117,
    county_fips_all: '19117|19185',
    county: 'Lucas',
    county_names_all: 'Lucas|Wayne',
    county_weights: '{"19117": 90.9, "19185": 9.1}',
    density: 1.9,
    imprecise: false,
    latitude: 40.94229,
    longitude: -93.46704,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50068',
  },
  {
    city: 'De Soto',
    county_fips: 19049,
    county_fips_all: '19049',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"19049": 100}',
    density: 81.3,
    imprecise: false,
    latitude: 41.52104,
    longitude: -94.02993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50069',
  },
  {
    city: 'Dexter',
    county_fips: 19121,
    county_fips_all: '19121|19001|19077|19049',
    county: 'Madison',
    county_names_all: 'Madison|Adair|Guthrie|Dallas',
    county_weights:
      '{"19121": 39.86, "19001": 28.23, "19077": 16.09, "19049": 15.81}',
    density: 7.2,
    imprecise: false,
    latitude: 41.45402,
    longitude: -94.23745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50070',
  },
  {
    city: 'Dows',
    county_fips: 19197,
    county_fips_all: '19197|19069',
    county: 'Wright',
    county_names_all: 'Wright|Franklin',
    county_weights: '{"19197": 55.84, "19069": 44.16}',
    density: 2.9,
    imprecise: false,
    latitude: 42.64931,
    longitude: -93.50597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50071',
  },
  {
    city: 'Earlham',
    county_fips: 19121,
    county_fips_all: '19121|19049',
    county: 'Madison',
    county_names_all: 'Madison|Dallas',
    county_weights: '{"19121": 74.73, "19049": 25.27}',
    density: 12.8,
    imprecise: false,
    latitude: 41.46984,
    longitude: -94.12115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50072',
  },
  {
    city: 'Elkhart',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 41.79234,
    longitude: -93.52463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50073',
  },
  {
    city: 'Ellston',
    county_fips: 19159,
    county_fips_all: '19159|19175',
    county: 'Ringgold',
    county_names_all: 'Ringgold|Union',
    county_weights: '{"19159": 85.09, "19175": 14.91}',
    density: 1.7,
    imprecise: false,
    latitude: 40.85685,
    longitude: -94.07524,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50074',
  },
  {
    city: 'Ellsworth',
    county_fips: 19079,
    county_fips_all: '19079',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"19079": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 42.33516,
    longitude: -93.56054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50075',
  },
  {
    city: 'Exira',
    county_fips: 19009,
    county_fips_all: '19009|19077',
    county: 'Audubon',
    county_names_all: 'Audubon|Guthrie',
    county_weights: '{"19009": 99.07, "19077": 0.93}',
    density: 4.6,
    imprecise: false,
    latitude: 41.595,
    longitude: -94.8576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50076',
  },
  {
    city: 'Ferguson',
    county_fips: 19127,
    county_fips_all: '19127',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"19127": 100}',
    density: 128.2,
    imprecise: false,
    latitude: 41.93862,
    longitude: -92.8629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 85,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50078',
  },
  {
    city: 'Galt',
    county_fips: 19197,
    county_fips_all: '19197',
    county: 'Wright',
    county_names_all: 'Wright',
    county_weights: '{"19197": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 42.66713,
    longitude: -93.63423,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50101',
  },
  {
    city: 'Garden City',
    county_fips: 19083,
    county_fips_all: '19083',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"19083": 100}',
    density: 27.6,
    imprecise: false,
    latitude: 42.24554,
    longitude: -93.40022,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50102',
  },
  {
    city: 'Garden Grove',
    county_fips: 19053,
    county_fips_all: '19053',
    county: 'Decatur',
    county_names_all: 'Decatur',
    county_weights: '{"19053": 100}',
    density: 3,
    imprecise: false,
    latitude: 40.79292,
    longitude: -93.61079,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50103',
  },
  {
    city: 'Gibson',
    county_fips: 19107,
    county_fips_all: '19107|19157|19123',
    county: 'Keokuk',
    county_names_all: 'Keokuk|Poweshiek|Mahaska',
    county_weights: '{"19107": 64.37, "19157": 25.96, "19123": 9.67}',
    density: 2.6,
    imprecise: false,
    latitude: 41.49458,
    longitude: -92.38841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50104',
  },
  {
    city: 'Gilbert',
    county_fips: 19169,
    county_fips_all: '19169',
    county: 'Story',
    county_names_all: 'Story',
    county_weights: '{"19169": 100}',
    density: 63,
    imprecise: false,
    latitude: 42.11754,
    longitude: -93.63912,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50105',
  },
  {
    city: 'Gilman',
    county_fips: 19127,
    county_fips_all: '19127|19099|19171|19157',
    county: 'Marshall',
    county_names_all: 'Marshall|Jasper|Tama|Poweshiek',
    county_weights:
      '{"19127": 51.06, "19099": 23.29, "19171": 20.24, "19157": 5.41}',
    density: 6.6,
    imprecise: false,
    latitude: 41.88213,
    longitude: -92.80749,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50106',
  },
  {
    city: 'Grand Junction',
    county_fips: 19073,
    county_fips_all: '19073|19015',
    county: 'Greene',
    county_names_all: 'Greene|Boone',
    county_weights: '{"19073": 88.16, "19015": 11.84}',
    density: 5.7,
    imprecise: false,
    latitude: 42.03547,
    longitude: -94.2191,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50107',
  },
  {
    city: 'Grand River',
    county_fips: 19053,
    county_fips_all: '19053|19039',
    county: 'Decatur',
    county_names_all: 'Decatur|Clarke',
    county_weights: '{"19053": 88.31, "19039": 11.69}',
    density: 1.8,
    imprecise: false,
    latitude: 40.82479,
    longitude: -93.9577,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50108',
  },
  {
    city: 'Granger',
    county_fips: 19153,
    county_fips_all: '19153|19049',
    county: 'Polk',
    county_names_all: 'Polk|Dallas',
    county_weights: '{"19153": 58.21, "19049": 41.79}',
    density: 66,
    imprecise: false,
    latitude: 41.76802,
    longitude: -93.80775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50109',
  },
  {
    city: 'Gray',
    county_fips: 19009,
    county_fips_all: '19009',
    county: 'Audubon',
    county_names_all: 'Audubon',
    county_weights: '{"19009": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 41.84424,
    longitude: -94.98612,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50110',
  },
  {
    city: 'Grimes',
    county_fips: 19153,
    county_fips_all: '19153|19049',
    county: 'Polk',
    county_names_all: 'Polk|Dallas',
    county_weights: '{"19153": 66.19, "19049": 33.81}',
    density: 259.3,
    imprecise: false,
    latitude: 41.69353,
    longitude: -93.80358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50111',
  },
  {
    city: 'Grinnell',
    county_fips: 19157,
    county_fips_all: '19157|19099',
    county: 'Poweshiek',
    county_names_all: 'Poweshiek|Jasper',
    county_weights: '{"19157": 74.03, "19099": 25.97}',
    density: 25.1,
    imprecise: false,
    latitude: 41.7319,
    longitude: -92.71591,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50112',
  },
  {
    city: 'Guthrie Center',
    county_fips: 19077,
    county_fips_all: '19077',
    county: 'Guthrie',
    county_names_all: 'Guthrie',
    county_weights: '{"19077": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 41.68765,
    longitude: -94.55501,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50115',
  },
  {
    city: 'Hamilton',
    county_fips: 19125,
    county_fips_all: '19125',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"19125": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 41.17812,
    longitude: -92.98247,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50116',
  },
  {
    city: 'Hamlin',
    county_fips: 19009,
    county_fips_all: '19009',
    county: 'Audubon',
    county_names_all: 'Audubon',
    county_weights: '{"19009": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 41.66903,
    longitude: -94.85419,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50117',
  },
  {
    city: 'Hartford',
    county_fips: 19181,
    county_fips_all: '19181',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"19181": 100}',
    density: 31.4,
    imprecise: false,
    latitude: 41.45957,
    longitude: -93.37673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50118',
  },
  {
    city: 'Harvey',
    county_fips: 19125,
    county_fips_all: '19125',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"19125": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 41.31089,
    longitude: -92.94587,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50119',
  },
  {
    city: 'Haverhill',
    county_fips: 19127,
    county_fips_all: '19127',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"19127": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 41.93373,
    longitude: -92.9828,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50120',
  },
  {
    city: 'Hubbard',
    county_fips: 19083,
    county_fips_all: '19083',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"19083": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 42.30218,
    longitude: -93.3087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50122',
  },
  {
    city: 'Humeston',
    county_fips: 19185,
    county_fips_all: '19185|19117|19053|19039',
    county: 'Wayne',
    county_names_all: 'Wayne|Lucas|Decatur|Clarke',
    county_weights:
      '{"19185": 79.52, "19117": 11.16, "19053": 6.9, "19039": 2.42}',
    density: 4.1,
    imprecise: false,
    latitude: 40.83938,
    longitude: -93.50634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50123',
  },
  {
    city: 'Huxley',
    county_fips: 19169,
    county_fips_all: '19169|19153',
    county: 'Story',
    county_names_all: 'Story|Polk',
    county_weights: '{"19169": 73.99, "19153": 26.01}',
    density: 90.4,
    imprecise: false,
    latitude: 41.88516,
    longitude: -93.60446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50124',
  },
  {
    city: 'Indianola',
    county_fips: 19181,
    county_fips_all: '19181',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"19181": 100}',
    density: 47.8,
    imprecise: false,
    latitude: 41.33286,
    longitude: -93.57957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50125',
  },
  {
    city: 'Iowa Falls',
    county_fips: 19083,
    county_fips_all: '19083|19069',
    county: 'Hardin',
    county_names_all: 'Hardin|Franklin',
    county_weights: '{"19083": 74.32, "19069": 25.68}',
    density: 18,
    imprecise: false,
    latitude: 42.50875,
    longitude: -93.24815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50126',
  },
  {
    city: 'Ira',
    county_fips: 19099,
    county_fips_all: '19099',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"19099": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 41.78122,
    longitude: -93.21129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50127',
  },
  {
    city: 'Jamaica',
    county_fips: 19077,
    county_fips_all: '19077|19073|19049',
    county: 'Guthrie',
    county_names_all: 'Guthrie|Greene|Dallas',
    county_weights: '{"19077": 48.47, "19073": 39.09, "19049": 12.44}',
    density: 4.5,
    imprecise: false,
    latitude: 41.85173,
    longitude: -94.29853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50128',
  },
  {
    city: 'Jefferson',
    county_fips: 19073,
    county_fips_all: '19073|19077',
    county: 'Greene',
    county_names_all: 'Greene|Guthrie',
    county_weights: '{"19073": 99.84, "19077": 0.16}',
    density: 11.7,
    imprecise: false,
    latitude: 42.01335,
    longitude: -94.3764,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50129',
  },
  {
    city: 'Jewell',
    county_fips: 19079,
    county_fips_all: '19079',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"19079": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 42.30074,
    longitude: -93.67331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50130',
  },
  {
    city: 'Johnston',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 400.7,
    imprecise: false,
    latitude: 41.69749,
    longitude: -93.72021,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50131',
  },
  {
    city: 'Kamrar',
    county_fips: 19079,
    county_fips_all: '19079',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"19079": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 42.39392,
    longitude: -93.68256,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50132',
  },
  {
    city: 'Kellerton',
    county_fips: 19159,
    county_fips_all: '19159|19053',
    county: 'Ringgold',
    county_names_all: 'Ringgold|Decatur',
    county_weights: '{"19159": 97.86, "19053": 2.14}',
    density: 2.9,
    imprecise: false,
    latitude: 40.71592,
    longitude: -94.07576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50133',
  },
  {
    city: 'Kelley',
    county_fips: 19169,
    county_fips_all: '19169|19015',
    county: 'Story',
    county_names_all: 'Story|Boone',
    county_weights: '{"19169": 73.23, "19015": 26.77}',
    density: 15.3,
    imprecise: false,
    latitude: 41.93992,
    longitude: -93.67429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50134',
  },
  {
    city: 'Kellogg',
    county_fips: 19099,
    county_fips_all: '19099',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"19099": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 41.7475,
    longitude: -92.89096,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50135',
  },
  {
    city: 'Keswick',
    county_fips: 19107,
    county_fips_all: '19107|19095',
    county: 'Keokuk',
    county_names_all: 'Keokuk|Iowa',
    county_weights: '{"19107": 94.35, "19095": 5.65}',
    density: 3.6,
    imprecise: false,
    latitude: 41.46984,
    longitude: -92.28927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50136',
  },
  {
    city: 'Killduff',
    county_fips: 19099,
    county_fips_all: '19099',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"19099": 100}',
    density: 21.3,
    imprecise: false,
    latitude: 41.60872,
    longitude: -92.92126,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50137',
  },
  {
    city: 'Knoxville',
    county_fips: 19125,
    county_fips_all: '19125',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"19125": 100}',
    density: 25.5,
    imprecise: false,
    latitude: 41.30246,
    longitude: -93.10534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50138',
  },
  {
    city: 'Lacona',
    county_fips: 19181,
    county_fips_all: '19181|19125|19117',
    county: 'Warren',
    county_names_all: 'Warren|Marion|Lucas',
    county_weights: '{"19181": 52.8, "19125": 24.83, "19117": 22.37}',
    density: 4.6,
    imprecise: false,
    latitude: 41.19237,
    longitude: -93.36683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50139',
  },
  {
    city: 'Lamoni',
    county_fips: 19053,
    county_fips_all: '19053|19159',
    county: 'Decatur',
    county_names_all: 'Decatur|Ringgold',
    county_weights: '{"19053": 69.18, "19159": 30.82}',
    density: 11.8,
    imprecise: false,
    latitude: 40.63753,
    longitude: -93.99198,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50140',
  },
  {
    city: 'Laurel',
    county_fips: 19127,
    county_fips_all: '19127|19099',
    county: 'Marshall',
    county_names_all: 'Marshall|Jasper',
    county_weights: '{"19127": 57.13, "19099": 42.87}',
    density: 6.1,
    imprecise: false,
    latitude: 41.86889,
    longitude: -92.95634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50141',
  },
  {
    city: 'Le Grand',
    county_fips: 19127,
    county_fips_all: '19127',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"19127": 100}',
    density: 401.4,
    imprecise: false,
    latitude: 42.0055,
    longitude: -92.77582,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50142',
  },
  {
    city: 'Leighton',
    county_fips: 19123,
    county_fips_all: '19123|19125',
    county: 'Mahaska',
    county_names_all: 'Mahaska|Marion',
    county_weights: '{"19123": 98.57, "19125": 1.43}',
    density: 5.8,
    imprecise: false,
    latitude: 41.34245,
    longitude: -92.79893,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50143',
  },
  {
    city: 'Leon',
    county_fips: 19053,
    county_fips_all: '19053',
    county: 'Decatur',
    county_names_all: 'Decatur',
    county_weights: '{"19053": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 40.73327,
    longitude: -93.73615,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50144',
  },
  {
    city: 'Liberty Center',
    county_fips: 19181,
    county_fips_all: '19181',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"19181": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 41.20387,
    longitude: -93.48515,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50145',
  },
  {
    city: 'Linden',
    county_fips: 19049,
    county_fips_all: '19049|19077',
    county: 'Dallas',
    county_names_all: 'Dallas|Guthrie',
    county_weights: '{"19049": 88.63, "19077": 11.37}',
    density: 6.9,
    imprecise: false,
    latitude: 41.68038,
    longitude: -94.24905,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50146',
  },
  {
    city: 'Lineville',
    county_fips: 19185,
    county_fips_all: '19185|19053',
    county: 'Wayne',
    county_names_all: 'Wayne|Decatur',
    county_weights: '{"19185": 52.77, "19053": 47.23}',
    density: 2.8,
    imprecise: false,
    latitude: 40.62381,
    longitude: -93.54597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50147',
  },
  {
    city: 'Liscomb',
    county_fips: 19127,
    county_fips_all: '19127',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"19127": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 42.18142,
    longitude: -92.99567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50148',
  },
  {
    city: 'Lorimor',
    county_fips: 19121,
    county_fips_all: '19121|19175',
    county: 'Madison',
    county_names_all: 'Madison|Union',
    county_weights: '{"19121": 51.13, "19175": 48.87}',
    density: 4.2,
    imprecise: false,
    latitude: 41.1512,
    longitude: -94.08194,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50149',
  },
  {
    city: 'Lovilia',
    county_fips: 19135,
    county_fips_all: '19135|19125',
    county: 'Monroe',
    county_names_all: 'Monroe|Marion',
    county_weights: '{"19135": 99.21, "19125": 0.79}',
    density: 5.1,
    imprecise: false,
    latitude: 41.12771,
    longitude: -92.97404,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50150',
  },
  {
    city: 'Lucas',
    county_fips: 19117,
    county_fips_all: '19117|19181',
    county: 'Lucas',
    county_names_all: 'Lucas|Warren',
    county_weights: '{"19117": 91.32, "19181": 8.68}',
    density: 3.6,
    imprecise: false,
    latitude: 41.08074,
    longitude: -93.49717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50151',
  },
  {
    city: 'Luther',
    county_fips: 19015,
    county_fips_all: '19015',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"19015": 100}',
    density: 137,
    imprecise: false,
    latitude: 41.96873,
    longitude: -93.81765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50152',
  },
  {
    city: 'Lynnville',
    county_fips: 19099,
    county_fips_all: '19099|19123|19157',
    county: 'Jasper',
    county_names_all: 'Jasper|Mahaska|Poweshiek',
    county_weights: '{"19099": 87.91, "19123": 8.82, "19157": 3.27}',
    density: 10.3,
    imprecise: false,
    latitude: 41.57669,
    longitude: -92.80033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50153',
  },
  {
    city: 'McCallsburg',
    county_fips: 19169,
    county_fips_all: '19169|19083',
    county: 'Story',
    county_names_all: 'Story|Hardin',
    county_weights: '{"19169": 84.35, "19083": 15.65}',
    density: 6.4,
    imprecise: false,
    latitude: 42.17625,
    longitude: -93.39068,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50154',
  },
  {
    city: 'Macksburg',
    county_fips: 19121,
    county_fips_all: '19121|19001',
    county: 'Madison',
    county_names_all: 'Madison|Adair',
    county_weights: '{"19121": 93.49, "19001": 6.51}',
    density: 1.2,
    imprecise: false,
    latitude: 41.21288,
    longitude: -94.19713,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50155',
  },
  {
    city: 'Madrid',
    county_fips: 19015,
    county_fips_all: '19015|19153|19049',
    county: 'Boone',
    county_names_all: 'Boone|Polk|Dallas',
    county_weights: '{"19015": 76.4, "19153": 17.0, "19049": 6.6}',
    density: 20,
    imprecise: false,
    latitude: 41.90349,
    longitude: -93.80001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50156',
  },
  {
    city: 'Malcom',
    county_fips: 19157,
    county_fips_all: '19157',
    county: 'Poweshiek',
    county_names_all: 'Poweshiek',
    county_weights: '{"19157": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 41.74545,
    longitude: -92.56183,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50157',
  },
  {
    city: 'Marshalltown',
    county_fips: 19127,
    county_fips_all: '19127|19171',
    county: 'Marshall',
    county_names_all: 'Marshall|Tama',
    county_weights: '{"19127": 98.63, "19171": 1.37}',
    density: 57.1,
    imprecise: false,
    latitude: 42.05016,
    longitude: -92.90143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50158',
  },
  {
    city: 'Martensdale',
    county_fips: 19181,
    county_fips_all: '19181',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"19181": 100}',
    density: 597.2,
    imprecise: false,
    latitude: 41.37385,
    longitude: -93.7387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50160',
  },
  {
    city: 'Maxwell',
    county_fips: 19153,
    county_fips_all: '19153|19169|19099',
    county: 'Polk',
    county_names_all: 'Polk|Story|Jasper',
    county_weights: '{"19153": 55.74, "19169": 40.94, "19099": 3.32}',
    density: 11.2,
    imprecise: false,
    latitude: 41.84764,
    longitude: -93.39914,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50161',
  },
  {
    city: 'Melbourne',
    county_fips: 19127,
    county_fips_all: '19127|19099',
    county: 'Marshall',
    county_names_all: 'Marshall|Jasper',
    county_weights: '{"19127": 96.36, "19099": 3.64}',
    density: 9,
    imprecise: false,
    latitude: 41.92563,
    longitude: -93.06781,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50162',
  },
  {
    city: 'Melcher Dallas',
    county_fips: 19125,
    county_fips_all: '19125',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"19125": 100}',
    density: 559,
    imprecise: false,
    latitude: 41.2223,
    longitude: -93.24101,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50163',
  },
  {
    city: 'Menlo',
    county_fips: 19077,
    county_fips_all: '19077|19001',
    county: 'Guthrie',
    county_names_all: 'Guthrie|Adair',
    county_weights: '{"19077": 52.36, "19001": 47.64}',
    density: 5.3,
    imprecise: false,
    latitude: 41.49921,
    longitude: -94.42176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50164',
  },
  {
    city: 'Millerton',
    county_fips: 19185,
    county_fips_all: '19185',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"19185": 100}',
    density: 39.8,
    imprecise: false,
    latitude: 40.84808,
    longitude: -93.30937,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50165',
  },
  {
    city: 'Milo',
    county_fips: 19181,
    county_fips_all: '19181',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"19181": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 41.28289,
    longitude: -93.42629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50166',
  },
  {
    city: 'Minburn',
    county_fips: 19049,
    county_fips_all: '19049',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"19049": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 41.74613,
    longitude: -94.04871,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50167',
  },
  {
    city: 'Mingo',
    county_fips: 19099,
    county_fips_all: '19099|19153',
    county: 'Jasper',
    county_names_all: 'Jasper|Polk',
    county_weights: '{"19099": 95.76, "19153": 4.24}',
    density: 8.3,
    imprecise: false,
    latitude: 41.77725,
    longitude: -93.27248,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50168',
  },
  {
    city: 'Mitchellville',
    county_fips: 19153,
    county_fips_all: '19153|19099',
    county: 'Polk',
    county_names_all: 'Polk|Jasper',
    county_weights: '{"19153": 56.08, "19099": 43.92}',
    density: 31,
    imprecise: false,
    latitude: 41.65617,
    longitude: -93.35062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50169',
  },
  {
    city: 'Monroe',
    county_fips: 19099,
    county_fips_all: '19099|19125',
    county: 'Jasper',
    county_names_all: 'Jasper|Marion',
    county_weights: '{"19099": 68.29, "19125": 31.71}',
    density: 14,
    imprecise: false,
    latitude: 41.52911,
    longitude: -93.11546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50170',
  },
  {
    city: 'Montezuma',
    county_fips: 19157,
    county_fips_all: '19157|19123',
    county: 'Poweshiek',
    county_names_all: 'Poweshiek|Mahaska',
    county_weights: '{"19157": 98.35, "19123": 1.65}',
    density: 8.9,
    imprecise: false,
    latitude: 41.58434,
    longitude: -92.52584,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50171',
  },
  {
    city: 'Montour',
    county_fips: 19171,
    county_fips_all: '19171',
    county: 'Tama',
    county_names_all: 'Tama',
    county_weights: '{"19171": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 41.97461,
    longitude: -92.71044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50173',
  },
  {
    city: 'Murray',
    county_fips: 19039,
    county_fips_all: '19039|19175',
    county: 'Clarke',
    county_names_all: 'Clarke|Union',
    county_weights: '{"19039": 91.09, "19175": 8.91}',
    density: 4.7,
    imprecise: false,
    latitude: 41.03723,
    longitude: -93.96167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50174',
  },
  {
    city: 'Nevada',
    county_fips: 19169,
    county_fips_all: '19169',
    county: 'Story',
    county_names_all: 'Story',
    county_weights: '{"19169": 100}',
    density: 27.4,
    imprecise: false,
    latitude: 42.03337,
    longitude: -93.44434,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50201',
  },
  {
    city: 'New Providence',
    county_fips: 19083,
    county_fips_all: '19083|19127|19169',
    county: 'Hardin',
    county_names_all: 'Hardin|Marshall|Story',
    county_weights: '{"19083": 81.17, "19127": 16.15, "19169": 2.68}',
    density: 2.9,
    imprecise: false,
    latitude: 42.25018,
    longitude: -93.18941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50206',
  },
  {
    city: 'New Sharon',
    county_fips: 19123,
    county_fips_all: '19123|19157',
    county: 'Mahaska',
    county_names_all: 'Mahaska|Poweshiek',
    county_weights: '{"19123": 97.61, "19157": 2.39}',
    density: 6.3,
    imprecise: false,
    latitude: 41.43344,
    longitude: -92.6381,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50207',
  },
  {
    city: 'Newton',
    county_fips: 19099,
    county_fips_all: '19099',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"19099": 100}',
    density: 50.2,
    imprecise: false,
    latitude: 41.71129,
    longitude: -93.03924,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50208',
  },
  {
    city: 'New Virginia',
    county_fips: 19181,
    county_fips_all: '19181|19039|19121',
    county: 'Warren',
    county_names_all: 'Warren|Clarke|Madison',
    county_weights: '{"19181": 77.23, "19039": 20.83, "19121": 1.94}',
    density: 7.8,
    imprecise: false,
    latitude: 41.18998,
    longitude: -93.6978,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50210',
  },
  {
    city: 'Norwalk',
    county_fips: 19181,
    county_fips_all: '19181|19121',
    county: 'Warren',
    county_names_all: 'Warren|Madison',
    county_weights: '{"19181": 95.92, "19121": 4.08}',
    density: 110.9,
    imprecise: false,
    latitude: 41.45614,
    longitude: -93.6887,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50211',
  },
  {
    city: 'Ogden',
    county_fips: 19015,
    county_fips_all: '19015',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"19015": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 42.03515,
    longitude: -94.05996,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50212',
  },
  {
    city: 'Osceola',
    county_fips: 19039,
    county_fips_all: '19039',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"19039": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 41.03292,
    longitude: -93.76557,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50213',
  },
  {
    city: 'Otley',
    county_fips: 19125,
    county_fips_all: '19125',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"19125": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 41.46246,
    longitude: -93.05528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50214',
  },
  {
    city: 'Panora',
    county_fips: 19077,
    county_fips_all: '19077',
    county: 'Guthrie',
    county_names_all: 'Guthrie',
    county_weights: '{"19077": 100}',
    density: 20.8,
    imprecise: false,
    latitude: 41.69798,
    longitude: -94.35023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50216',
  },
  {
    city: 'Paton',
    county_fips: 19073,
    county_fips_all: '19073|19015',
    county: 'Greene',
    county_names_all: 'Greene|Boone',
    county_weights: '{"19073": 84.36, "19015": 15.64}',
    density: 3,
    imprecise: false,
    latitude: 42.17206,
    longitude: -94.24984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50217',
  },
  {
    city: 'Patterson',
    county_fips: 19121,
    county_fips_all: '19121',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"19121": 100}',
    density: 298.5,
    imprecise: false,
    latitude: 41.34844,
    longitude: -93.87755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50218',
  },
  {
    city: 'Pella',
    county_fips: 19125,
    county_fips_all: '19125|19123',
    county: 'Marion',
    county_names_all: 'Marion|Mahaska',
    county_weights: '{"19125": 65.25, "19123": 34.75}',
    density: 48.2,
    imprecise: false,
    latitude: 41.42243,
    longitude: -92.90132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50219',
  },
  {
    city: 'Perry',
    county_fips: 19049,
    county_fips_all: '19049|19015|19073',
    county: 'Dallas',
    county_names_all: 'Dallas|Boone|Greene',
    county_weights: '{"19049": 63.5, "19015": 32.77, "19073": 3.73}',
    density: 35.4,
    imprecise: false,
    latitude: 41.8366,
    longitude: -94.12293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50220',
  },
  {
    city: 'Peru',
    county_fips: 19121,
    county_fips_all: '19121|19039',
    county: 'Madison',
    county_names_all: 'Madison|Clarke',
    county_weights: '{"19121": 96.6, "19039": 3.4}',
    density: 3.1,
    imprecise: false,
    latitude: 41.21701,
    longitude: -93.95369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50222',
  },
  {
    city: 'Pilot Mound',
    county_fips: 19015,
    county_fips_all: '19015',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"19015": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 42.17117,
    longitude: -94.02831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50223',
  },
  {
    city: 'Pleasantville',
    county_fips: 19125,
    county_fips_all: '19125|19181',
    county: 'Marion',
    county_names_all: 'Marion|Warren',
    county_weights: '{"19125": 84.59, "19181": 15.41}',
    density: 15.1,
    imprecise: false,
    latitude: 41.3823,
    longitude: -93.27103,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50225',
  },
  {
    city: 'Polk City',
    county_fips: 19153,
    county_fips_all: '19153|19169',
    county: 'Polk',
    county_names_all: 'Polk|Story',
    county_weights: '{"19153": 99.44, "19169": 0.56}',
    density: 82.4,
    imprecise: false,
    latitude: 41.79716,
    longitude: -93.70566,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50226',
  },
  {
    city: 'Popejoy',
    county_fips: 19069,
    county_fips_all: '19069',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"19069": 100}',
    density: 58.5,
    imprecise: false,
    latitude: 42.59388,
    longitude: -93.42818,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50227',
  },
  {
    city: 'Prairie City',
    county_fips: 19099,
    county_fips_all: '19099|19125|19153',
    county: 'Jasper',
    county_names_all: 'Jasper|Marion|Polk',
    county_weights: '{"19099": 89.28, "19125": 9.8, "19153": 0.92}',
    density: 11.8,
    imprecise: false,
    latitude: 41.57008,
    longitude: -93.24154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50228',
  },
  {
    city: 'Prole',
    county_fips: 19181,
    county_fips_all: '19181|19121',
    county: 'Warren',
    county_names_all: 'Warren|Madison',
    county_weights: '{"19181": 51.21, "19121": 48.79}',
    density: 14.6,
    imprecise: false,
    latitude: 41.37416,
    longitude: -93.77906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50229',
  },
  {
    city: 'Radcliffe',
    county_fips: 19083,
    county_fips_all: '19083|19079|19169',
    county: 'Hardin',
    county_names_all: 'Hardin|Hamilton|Story',
    county_weights: '{"19083": 61.02, "19079": 38.43, "19169": 0.55}',
    density: 5,
    imprecise: false,
    latitude: 42.30655,
    longitude: -93.44718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50230',
  },
  {
    city: 'Randall',
    county_fips: 19079,
    county_fips_all: '19079',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"19079": 100}',
    density: 122.6,
    imprecise: false,
    latitude: 42.23765,
    longitude: -93.60257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50231',
  },
  {
    city: 'Reasnor',
    county_fips: 19099,
    county_fips_all: '19099',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"19099": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 41.55761,
    longitude: -92.96868,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50232',
  },
  {
    city: 'Redfield',
    county_fips: 19049,
    county_fips_all: '19049|19077',
    county: 'Dallas',
    county_names_all: 'Dallas|Guthrie',
    county_weights: '{"19049": 82.09, "19077": 17.91}',
    density: 10.8,
    imprecise: false,
    latitude: 41.61221,
    longitude: -94.21095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50233',
  },
  {
    city: 'Rhodes',
    county_fips: 19127,
    county_fips_all: '19127|19099',
    county: 'Marshall',
    county_names_all: 'Marshall|Jasper',
    county_weights: '{"19127": 83.1, "19099": 16.9}',
    density: 7.9,
    imprecise: false,
    latitude: 41.89165,
    longitude: -93.17916,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50234',
  },
  {
    city: 'Rippey',
    county_fips: 19073,
    county_fips_all: '19073|19015|19049',
    county: 'Greene',
    county_names_all: 'Greene|Boone|Dallas',
    county_weights: '{"19073": 85.56, "19015": 10.42, "19049": 4.02}',
    density: 3.5,
    imprecise: false,
    latitude: 41.92974,
    longitude: -94.20873,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50235',
  },
  {
    city: 'Roland',
    county_fips: 19169,
    county_fips_all: '19169',
    county: 'Story',
    county_names_all: 'Story',
    county_weights: '{"19169": 100}',
    density: 20,
    imprecise: false,
    latitude: 42.1675,
    longitude: -93.4834,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50236',
  },
  {
    city: 'Runnells',
    county_fips: 19153,
    county_fips_all: '19153|19099|19125',
    county: 'Polk',
    county_names_all: 'Polk|Jasper|Marion',
    county_weights: '{"19153": 77.96, "19099": 12.94, "19125": 9.1}',
    density: 29,
    imprecise: false,
    latitude: 41.54238,
    longitude: -93.36859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50237',
  },
  {
    city: 'Russell',
    county_fips: 19117,
    county_fips_all: '19117|19185',
    county: 'Lucas',
    county_names_all: 'Lucas|Wayne',
    county_weights: '{"19117": 78.65, "19185": 21.35}',
    density: 4.6,
    imprecise: false,
    latitude: 40.97124,
    longitude: -93.17502,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50238',
  },
  {
    city: 'Saint Anthony',
    county_fips: 19127,
    county_fips_all: '19127|19169',
    county: 'Marshall',
    county_names_all: 'Marshall|Story',
    county_weights: '{"19127": 93.99, "19169": 6.01}',
    density: 6.8,
    imprecise: false,
    latitude: 42.14431,
    longitude: -93.20144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50239',
  },
  {
    city: 'Saint Charles',
    county_fips: 19121,
    county_fips_all: '19121|19181',
    county: 'Madison',
    county_names_all: 'Madison|Warren',
    county_weights: '{"19121": 51.28, "19181": 48.72}',
    density: 12.3,
    imprecise: false,
    latitude: 41.29368,
    longitude: -93.796,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50240',
  },
  {
    city: 'Saint Marys',
    county_fips: 19181,
    county_fips_all: '19181',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"19181": 100}',
    density: 263.4,
    imprecise: false,
    latitude: 41.30771,
    longitude: -93.73368,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50241',
  },
  {
    city: 'Searsboro',
    county_fips: 19157,
    county_fips_all: '19157',
    county: 'Poweshiek',
    county_names_all: 'Poweshiek',
    county_weights: '{"19157": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 41.56332,
    longitude: -92.69428,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50242',
  },
  {
    city: 'Sheldahl',
    county_fips: 19153,
    county_fips_all: '19153|19169|19015',
    county: 'Polk',
    county_names_all: 'Polk|Story|Boone',
    county_weights: '{"19153": 36.69, "19169": 32.01, "19015": 31.31}',
    density: 173.7,
    imprecise: false,
    latitude: 41.86457,
    longitude: -93.6967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50243',
  },
  {
    city: 'Slater',
    county_fips: 19153,
    county_fips_all: '19153|19169|19015',
    county: 'Polk',
    county_names_all: 'Polk|Story|Boone',
    county_weights: '{"19153": 59.82, "19169": 38.01, "19015": 2.17}',
    density: 26.5,
    imprecise: false,
    latitude: 41.85083,
    longitude: -93.65126,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50244',
  },
  {
    city: 'Stanhope',
    county_fips: 19079,
    county_fips_all: '19079',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"19079": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 42.28411,
    longitude: -93.78198,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50246',
  },
  {
    city: 'State Center',
    county_fips: 19127,
    county_fips_all: '19127|19169',
    county: 'Marshall',
    county_names_all: 'Marshall|Story',
    county_weights: '{"19127": 93.36, "19169": 6.64}',
    density: 9.1,
    imprecise: false,
    latitude: 42.01832,
    longitude: -93.1665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50247',
  },
  {
    city: 'Story City',
    county_fips: 19169,
    county_fips_all: '19169|19079|19015',
    county: 'Story',
    county_names_all: 'Story|Hamilton|Boone',
    county_weights: '{"19169": 53.97, "19079": 35.53, "19015": 10.5}',
    density: 19.8,
    imprecise: false,
    latitude: 42.19256,
    longitude: -93.61297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50248',
  },
  {
    city: 'Stratford',
    county_fips: 19079,
    county_fips_all: '19079|19187|19015',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Webster|Boone',
    county_weights: '{"19079": 70.02, "19187": 19.17, "19015": 10.81}',
    density: 6.4,
    imprecise: false,
    latitude: 42.26991,
    longitude: -93.89973,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50249',
  },
  {
    city: 'Stuart',
    county_fips: 19001,
    county_fips_all: '19001|19077',
    county: 'Adair',
    county_names_all: 'Adair|Guthrie',
    county_weights: '{"19001": 65.92, "19077": 34.08}',
    density: 10.1,
    imprecise: false,
    latitude: 41.48088,
    longitude: -94.34062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50250',
  },
  {
    city: 'Sully',
    county_fips: 19099,
    county_fips_all: '19099|19123',
    county: 'Jasper',
    county_names_all: 'Jasper|Mahaska',
    county_weights: '{"19099": 96.79, "19123": 3.21}',
    density: 12.1,
    imprecise: false,
    latitude: 41.56883,
    longitude: -92.87007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50251',
  },
  {
    city: 'Swan',
    county_fips: 19125,
    county_fips_all: '19125|19181',
    county: 'Marion',
    county_names_all: 'Marion|Warren',
    county_weights: '{"19125": 63.28, "19181": 36.72}',
    density: 6.4,
    imprecise: false,
    latitude: 41.45881,
    longitude: -93.31518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50252',
  },
  {
    city: 'Thayer',
    county_fips: 19175,
    county_fips_all: '19175',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"19175": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 40.99045,
    longitude: -94.06917,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50254',
  },
  {
    city: 'Thornburg',
    county_fips: 19107,
    county_fips_all: '19107',
    county: 'Keokuk',
    county_names_all: 'Keokuk',
    county_weights: '{"19107": 100}',
    density: 103.1,
    imprecise: false,
    latitude: 41.45593,
    longitude: -92.33207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50255',
  },
  {
    city: 'Tracy',
    county_fips: 19125,
    county_fips_all: '19125|19123',
    county: 'Marion',
    county_names_all: 'Marion|Mahaska',
    county_weights: '{"19125": 76.57, "19123": 23.43}',
    density: 8.9,
    imprecise: false,
    latitude: 41.2664,
    longitude: -92.91114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50256',
  },
  {
    city: 'Truro',
    county_fips: 19121,
    county_fips_all: '19121|19039|19181',
    county: 'Madison',
    county_names_all: 'Madison|Clarke|Warren',
    county_weights: '{"19121": 75.87, "19039": 20.47, "19181": 3.66}',
    density: 8.1,
    imprecise: false,
    latitude: 41.19092,
    longitude: -93.85048,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50257',
  },
  {
    city: 'Union',
    county_fips: 19083,
    county_fips_all: '19083|19127',
    county: 'Hardin',
    county_names_all: 'Hardin|Marshall',
    county_weights: '{"19083": 71.49, "19127": 28.51}',
    density: 6.9,
    imprecise: false,
    latitude: 42.22781,
    longitude: -93.07788,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50258',
  },
  {
    city: 'Van Meter',
    county_fips: 19121,
    county_fips_all: '19121|19049',
    county: 'Madison',
    county_names_all: 'Madison|Dallas',
    county_weights: '{"19121": 79.52, "19049": 20.48}',
    density: 20.2,
    imprecise: false,
    latitude: 41.47014,
    longitude: -93.92286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50261',
  },
  {
    city: 'Van Wert',
    county_fips: 19053,
    county_fips_all: '19053',
    county: 'Decatur',
    county_names_all: 'Decatur',
    county_weights: '{"19053": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 40.85625,
    longitude: -93.82091,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50262',
  },
  {
    city: 'Waukee',
    county_fips: 19049,
    county_fips_all: '19049',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"19049": 100}',
    density: 416.4,
    imprecise: false,
    latitude: 41.60391,
    longitude: -93.87989,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50263',
  },
  {
    city: 'Weldon',
    county_fips: 19039,
    county_fips_all: '19039|19053',
    county: 'Clarke',
    county_names_all: 'Clarke|Decatur',
    county_weights: '{"19039": 55.25, "19053": 44.75}',
    density: 2.9,
    imprecise: false,
    latitude: 40.89919,
    longitude: -93.70071,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50264',
  },
  {
    city: 'West Des Moines',
    county_fips: 19153,
    county_fips_all: '19153|19181',
    county: 'Polk',
    county_names_all: 'Polk|Warren',
    county_weights: '{"19153": 96.88, "19181": 3.12}',
    density: 670.1,
    imprecise: false,
    latitude: 41.55129,
    longitude: -93.73821,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50265',
  },
  {
    city: 'West Des Moines',
    county_fips: 19049,
    county_fips_all: '19049|19153',
    county: 'Dallas',
    county_names_all: 'Dallas|Polk',
    county_weights: '{"19049": 74.72, "19153": 25.28}',
    density: 649.4,
    imprecise: false,
    latitude: 41.56323,
    longitude: -93.81107,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50266',
  },
  {
    city: 'What Cheer',
    county_fips: 19107,
    county_fips_all: '19107|19123',
    county: 'Keokuk',
    county_names_all: 'Keokuk|Mahaska',
    county_weights: '{"19107": 81.65, "19123": 18.35}',
    density: 7.5,
    imprecise: false,
    latitude: 41.40695,
    longitude: -92.36227,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50268',
  },
  {
    city: 'Whitten',
    county_fips: 19083,
    county_fips_all: '19083',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"19083": 100}',
    density: 102.2,
    imprecise: false,
    latitude: 42.26236,
    longitude: -93.01064,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50269',
  },
  {
    city: 'Williams',
    county_fips: 19079,
    county_fips_all: '19079|19197',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Wright',
    county_weights: '{"19079": 93.58, "19197": 6.42}',
    density: 3.4,
    imprecise: false,
    latitude: 42.48444,
    longitude: -93.54489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50271',
  },
  {
    city: 'Williamson',
    county_fips: 19117,
    county_fips_all: '19117',
    county: 'Lucas',
    county_names_all: 'Lucas',
    county_weights: '{"19117": 100}',
    density: 202,
    imprecise: false,
    latitude: 41.08809,
    longitude: -93.25682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50272',
  },
  {
    city: 'Winterset',
    county_fips: 19121,
    county_fips_all: '19121|19001',
    county: 'Madison',
    county_names_all: 'Madison|Adair',
    county_weights: '{"19121": 98.82, "19001": 1.18}',
    density: 17.7,
    imprecise: false,
    latitude: 41.32838,
    longitude: -94.05606,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50273',
  },
  {
    city: 'Wiota',
    county_fips: 19029,
    county_fips_all: '19029',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"19029": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 41.38261,
    longitude: -94.85756,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50274',
  },
  {
    city: 'Woodburn',
    county_fips: 19039,
    county_fips_all: '19039|19117',
    county: 'Clarke',
    county_names_all: 'Clarke|Lucas',
    county_weights: '{"19039": 94.9, "19117": 5.1}',
    density: 3.6,
    imprecise: false,
    latitude: 41.04375,
    longitude: -93.58852,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50275',
  },
  {
    city: 'Woodward',
    county_fips: 19015,
    county_fips_all: '19015|19049',
    county: 'Boone',
    county_names_all: 'Boone|Dallas',
    county_weights: '{"19015": 50.77, "19049": 49.23}',
    density: 12.5,
    imprecise: false,
    latitude: 41.85997,
    longitude: -93.923,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50276',
  },
  {
    city: 'Yale',
    county_fips: 19077,
    county_fips_all: '19077|19049',
    county: 'Guthrie',
    county_names_all: 'Guthrie|Dallas',
    county_weights: '{"19077": 83.06, "19049": 16.94}',
    density: 5.7,
    imprecise: false,
    latitude: 41.77867,
    longitude: -94.347,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50277',
  },
  {
    city: 'Zearing',
    county_fips: 19169,
    county_fips_all: '19169',
    county: 'Story',
    county_names_all: 'Story',
    county_weights: '{"19169": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 42.1528,
    longitude: -93.29926,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50278',
  },
  {
    city: 'Des Moines',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 1438.5,
    imprecise: false,
    latitude: 41.58448,
    longitude: -93.62152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50309',
  },
  {
    city: 'Des Moines',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 1497.9,
    imprecise: false,
    latitude: 41.62777,
    longitude: -93.67297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50310',
  },
  {
    city: 'Des Moines',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 2205.3,
    imprecise: false,
    latitude: 41.601,
    longitude: -93.67335,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50311',
  },
  {
    city: 'Des Moines',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 1083.7,
    imprecise: false,
    latitude: 41.58064,
    longitude: -93.67622,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50312',
  },
  {
    city: 'Des Moines',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 373,
    imprecise: false,
    latitude: 41.65538,
    longitude: -93.62287,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50313',
  },
  {
    city: 'Des Moines',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 1632.4,
    imprecise: false,
    latitude: 41.6049,
    longitude: -93.63102,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50314',
  },
  {
    city: 'Des Moines',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 1305.3,
    imprecise: false,
    latitude: 41.5449,
    longitude: -93.62063,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50315',
  },
  {
    city: 'Des Moines',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 1808.8,
    imprecise: false,
    latitude: 41.60877,
    longitude: -93.59775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50316',
  },
  {
    city: 'Des Moines',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 637.9,
    imprecise: false,
    latitude: 41.61572,
    longitude: -93.54881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50317',
  },
  {
    city: 'Des Moines',
    county_fips: 19153,
    county_fips_all: '19153|19181',
    county: 'Polk',
    county_names_all: 'Polk|Warren',
    county_weights: '{"19153": 78.48, "19181": 21.52}',
    density: 569.7,
    imprecise: false,
    latitude: 41.53208,
    longitude: -93.57217,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50320',
  },
  {
    city: 'Des Moines',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 269.1,
    imprecise: false,
    latitude: 41.53997,
    longitude: -93.67184,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50321',
  },
  {
    city: 'Urbandale',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 1139,
    imprecise: false,
    latitude: 41.63383,
    longitude: -93.73589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50322',
  },
  {
    city: 'Urbandale',
    county_fips: 19049,
    county_fips_all: '19049|19153',
    county: 'Dallas',
    county_names_all: 'Dallas|Polk',
    county_weights: '{"19049": 60.52, "19153": 39.48}',
    density: 658,
    imprecise: false,
    latitude: 41.63894,
    longitude: -93.8185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50323',
  },
  {
    city: 'Windsor Heights',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 1414.7,
    imprecise: false,
    latitude: 41.60471,
    longitude: -93.71273,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50324',
  },
  {
    city: 'Clive',
    county_fips: 19153,
    county_fips_all: '19153|19049',
    county: 'Polk',
    county_names_all: 'Polk|Dallas',
    county_weights: '{"19153": 60.72, "19049": 39.28}',
    density: 950.2,
    imprecise: false,
    latitude: 41.61475,
    longitude: -93.79864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50325',
  },
  {
    city: 'Pleasant Hill',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 322.6,
    imprecise: false,
    latitude: 41.58402,
    longitude: -93.48856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50327',
  },
  {
    city: 'Mason City',
    county_fips: 19033,
    county_fips_all: '19033',
    county: 'Cerro Gordo',
    county_names_all: 'Cerro Gordo',
    county_weights: '{"19033": 100}',
    density: 74.8,
    imprecise: false,
    latitude: 43.15389,
    longitude: -93.20006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50401',
  },
  {
    city: 'Alexander',
    county_fips: 19069,
    county_fips_all: '19069|19197',
    county: 'Franklin',
    county_names_all: 'Franklin|Wright',
    county_weights: '{"19069": 84.85, "19197": 15.15}',
    density: 3.9,
    imprecise: false,
    latitude: 42.80621,
    longitude: -93.45677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50420',
  },
  {
    city: 'Belmond',
    county_fips: 19197,
    county_fips_all: '19197',
    county: 'Wright',
    county_names_all: 'Wright',
    county_weights: '{"19197": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 42.84246,
    longitude: -93.62148,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50421',
  },
  {
    city: 'Britt',
    county_fips: 19081,
    county_fips_all: '19081',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"19081": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 43.11054,
    longitude: -93.81244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50423',
  },
  {
    city: 'Buffalo Center',
    county_fips: 19189,
    county_fips_all: '19189|19109',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Kossuth',
    county_weights: '{"19189": 62.15, "19109": 37.85}',
    density: 4,
    imprecise: false,
    latitude: 43.40366,
    longitude: -93.94939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50424',
  },
  {
    city: 'Carpenter',
    county_fips: 19131,
    county_fips_all: '19131',
    county: 'Mitchell',
    county_names_all: 'Mitchell',
    county_weights: '{"19131": 100}',
    density: 89.1,
    imprecise: false,
    latitude: 43.41507,
    longitude: -93.01718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50426',
  },
  {
    city: 'Chapin',
    county_fips: 19069,
    county_fips_all: '19069',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"19069": 100}',
    density: 782.9,
    imprecise: false,
    latitude: 42.83557,
    longitude: -93.22116,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50427',
  },
  {
    city: 'Clear Lake',
    county_fips: 19033,
    county_fips_all: '19033',
    county: 'Cerro Gordo',
    county_names_all: 'Cerro Gordo',
    county_weights: '{"19033": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 43.13573,
    longitude: -93.38815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50428',
  },
  {
    city: 'Corwith',
    county_fips: 19081,
    county_fips_all: '19081|19109|19197|19091',
    county: 'Hancock',
    county_names_all: 'Hancock|Kossuth|Wright|Humboldt',
    county_weights:
      '{"19081": 60.44, "19109": 36.55, "19197": 1.84, "19091": 1.17}',
    density: 3.2,
    imprecise: false,
    latitude: 42.97734,
    longitude: -93.95653,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50430',
  },
  {
    city: 'Coulter',
    county_fips: 19069,
    county_fips_all: '19069',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"19069": 100}',
    density: 117.8,
    imprecise: false,
    latitude: 42.73648,
    longitude: -93.36989,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50431',
  },
  {
    city: 'Crystal Lake',
    county_fips: 19081,
    county_fips_all: '19081',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"19081": 100}',
    density: 251.4,
    imprecise: false,
    latitude: 43.22394,
    longitude: -93.79794,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50432',
  },
  {
    city: 'Dougherty',
    county_fips: 19033,
    county_fips_all: '19033|19067|19069|19023',
    county: 'Cerro Gordo',
    county_names_all: 'Cerro Gordo|Floyd|Franklin|Butler',
    county_weights:
      '{"19033": 53.01, "19067": 20.57, "19069": 19.32, "19023": 7.1}',
    density: 1.3,
    imprecise: false,
    latitude: 42.92852,
    longitude: -93.04774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50433',
  },
  {
    city: 'Fertile',
    county_fips: 19195,
    county_fips_all: '19195|19033',
    county: 'Worth',
    county_names_all: 'Worth|Cerro Gordo',
    county_weights: '{"19195": 59.04, "19033": 40.96}',
    density: 15.2,
    imprecise: false,
    latitude: 43.25857,
    longitude: -93.45758,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50434',
  },
  {
    city: 'Floyd',
    county_fips: 19067,
    county_fips_all: '19067',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"19067": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 43.15752,
    longitude: -92.76877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50435',
  },
  {
    city: 'Forest City',
    county_fips: 19189,
    county_fips_all: '19189|19081',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Hancock',
    county_weights: '{"19189": 57.77, "19081": 42.23}',
    density: 16.5,
    imprecise: false,
    latitude: 43.26256,
    longitude: -93.66242,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50436',
  },
  {
    city: 'Garner',
    county_fips: 19081,
    county_fips_all: '19081',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"19081": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 43.11018,
    longitude: -93.61841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50438',
  },
  {
    city: 'Goodell',
    county_fips: 19081,
    county_fips_all: '19081',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"19081": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 42.94578,
    longitude: -93.6345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50439',
  },
  {
    city: 'Grafton',
    county_fips: 19195,
    county_fips_all: '19195',
    county: 'Worth',
    county_names_all: 'Worth',
    county_weights: '{"19195": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 43.33213,
    longitude: -93.06891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50440',
  },
  {
    city: 'Hampton',
    county_fips: 19069,
    county_fips_all: '19069',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"19069": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 42.73938,
    longitude: -93.22146,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50441',
  },
  {
    city: 'Hanlontown',
    county_fips: 19195,
    county_fips_all: '19195|19033',
    county: 'Worth',
    county_names_all: 'Worth|Cerro Gordo',
    county_weights: '{"19195": 94.29, "19033": 5.71}',
    density: 7.2,
    imprecise: false,
    latitude: 43.29258,
    longitude: -93.38601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50444',
  },
  {
    city: 'Joice',
    county_fips: 19195,
    county_fips_all: '19195|19189',
    county: 'Worth',
    county_names_all: 'Worth|Winnebago',
    county_weights: '{"19195": 88.5, "19189": 11.5}',
    density: 4.7,
    imprecise: false,
    latitude: 43.33821,
    longitude: -93.45394,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50446',
  },
  {
    city: 'Kanawha',
    county_fips: 19081,
    county_fips_all: '19081|19197',
    county: 'Hancock',
    county_names_all: 'Hancock|Wright',
    county_weights: '{"19081": 63.99, "19197": 36.01}',
    density: 4.3,
    imprecise: false,
    latitude: 42.92719,
    longitude: -93.80118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50447',
  },
  {
    city: 'Kensett',
    county_fips: 19195,
    county_fips_all: '19195',
    county: 'Worth',
    county_names_all: 'Worth',
    county_weights: '{"19195": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 43.35053,
    longitude: -93.24753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50448',
  },
  {
    city: 'Klemme',
    county_fips: 19081,
    county_fips_all: '19081|19033',
    county: 'Hancock',
    county_names_all: 'Hancock|Cerro Gordo',
    county_weights: '{"19081": 90.12, "19033": 9.88}',
    density: 7.4,
    imprecise: false,
    latitude: 43.00129,
    longitude: -93.55629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50449',
  },
  {
    city: 'Lake Mills',
    county_fips: 19189,
    county_fips_all: '19189|19195',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Worth',
    county_weights: '{"19189": 67.63, "19195": 32.37}',
    density: 13.5,
    imprecise: false,
    latitude: 43.42045,
    longitude: -93.51998,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50450',
  },
  {
    city: 'Lakota',
    county_fips: 19109,
    county_fips_all: '19109',
    county: 'Kossuth',
    county_names_all: 'Kossuth',
    county_weights: '{"19109": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 43.37746,
    longitude: -94.09134,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50451',
  },
  {
    city: 'Latimer',
    county_fips: 19069,
    county_fips_all: '19069',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"19069": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 42.77969,
    longitude: -93.37542,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50452',
  },
  {
    city: 'Leland',
    county_fips: 19189,
    county_fips_all: '19189',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"19189": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 43.3664,
    longitude: -93.65258,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50453',
  },
  {
    city: 'Little Cedar',
    county_fips: 19131,
    county_fips_all: '19131',
    county: 'Mitchell',
    county_names_all: 'Mitchell',
    county_weights: '{"19131": 100}',
    density: 6,
    imprecise: false,
    latitude: 43.38505,
    longitude: -92.73935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50454',
  },
  {
    city: 'McIntire',
    county_fips: 19131,
    county_fips_all: '19131',
    county: 'Mitchell',
    county_names_all: 'Mitchell',
    county_weights: '{"19131": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 43.45695,
    longitude: -92.64981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50455',
  },
  {
    city: 'Manly',
    county_fips: 19195,
    county_fips_all: '19195|19033',
    county: 'Worth',
    county_names_all: 'Worth|Cerro Gordo',
    county_weights: '{"19195": 98.17, "19033": 1.83}',
    density: 13.1,
    imprecise: false,
    latitude: 43.28812,
    longitude: -93.21579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50456',
  },
  {
    city: 'Meservey',
    county_fips: 19081,
    county_fips_all: '19081|19033|19069|19197',
    county: 'Hancock',
    county_names_all: 'Hancock|Cerro Gordo|Franklin|Wright',
    county_weights:
      '{"19081": 30.11, "19033": 29.67, "19069": 27.75, "19197": 12.48}',
    density: 5.3,
    imprecise: false,
    latitude: 42.91418,
    longitude: -93.4928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50457',
  },
  {
    city: 'Nora Springs',
    county_fips: 19067,
    county_fips_all: '19067|19033|19131',
    county: 'Floyd',
    county_names_all: 'Floyd|Cerro Gordo|Mitchell',
    county_weights: '{"19067": 53.29, "19033": 35.68, "19131": 11.03}',
    density: 11.4,
    imprecise: false,
    latitude: 43.15969,
    longitude: -93.00609,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50458',
  },
  {
    city: 'Northwood',
    county_fips: 19195,
    county_fips_all: '19195|19189',
    county: 'Worth',
    county_names_all: 'Worth|Winnebago',
    county_weights: '{"19195": 99.83, "19189": 0.17}',
    density: 8.2,
    imprecise: false,
    latitude: 43.4458,
    longitude: -93.25445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50459',
  },
  {
    city: 'Orchard',
    county_fips: 19131,
    county_fips_all: '19131|19067',
    county: 'Mitchell',
    county_names_all: 'Mitchell|Floyd',
    county_weights: '{"19131": 77.8, "19067": 22.2}',
    density: 7.5,
    imprecise: false,
    latitude: 43.2259,
    longitude: -92.6902,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50460',
  },
  {
    city: 'Osage',
    county_fips: 19131,
    county_fips_all: '19131|19067',
    county: 'Mitchell',
    county_names_all: 'Mitchell|Floyd',
    county_weights: '{"19131": 99.84, "19067": 0.16}',
    density: 11.4,
    imprecise: false,
    latitude: 43.29995,
    longitude: -92.81412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50461',
  },
  {
    city: 'Plymouth',
    county_fips: 19033,
    county_fips_all: '19033|19195|19131',
    county: 'Cerro Gordo',
    county_names_all: 'Cerro Gordo|Worth|Mitchell',
    county_weights: '{"19033": 54.98, "19195": 42.36, "19131": 2.66}',
    density: 10.9,
    imprecise: false,
    latitude: 43.25146,
    longitude: -93.0765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50464',
  },
  {
    city: 'Rake',
    county_fips: 19189,
    county_fips_all: '19189',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"19189": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 43.48703,
    longitude: -93.91056,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50465',
  },
  {
    city: 'Riceville',
    county_fips: 19089,
    county_fips_all: '19089|19131',
    county: 'Howard',
    county_names_all: 'Howard|Mitchell',
    county_weights: '{"19089": 60.36, "19131": 39.64}',
    density: 5.5,
    imprecise: false,
    latitude: 43.38782,
    longitude: -92.53815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50466',
  },
  {
    city: 'Rock Falls',
    county_fips: 19033,
    county_fips_all: '19033',
    county: 'Cerro Gordo',
    county_names_all: 'Cerro Gordo',
    county_weights: '{"19033": 100}',
    density: 21.7,
    imprecise: false,
    latitude: 43.20916,
    longitude: -93.06608,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50467',
  },
  {
    city: 'Rockford',
    county_fips: 19067,
    county_fips_all: '19067|19033',
    county: 'Floyd',
    county_names_all: 'Floyd|Cerro Gordo',
    county_weights: '{"19067": 75.25, "19033": 24.75}',
    density: 6.3,
    imprecise: false,
    latitude: 43.04631,
    longitude: -92.95703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50468',
  },
  {
    city: 'Rockwell',
    county_fips: 19033,
    county_fips_all: '19033',
    county: 'Cerro Gordo',
    county_names_all: 'Cerro Gordo',
    county_weights: '{"19033": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 42.99922,
    longitude: -93.19767,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50469',
  },
  {
    city: 'Rowan',
    county_fips: 19197,
    county_fips_all: '19197|19069',
    county: 'Wright',
    county_names_all: 'Wright|Franklin',
    county_weights: '{"19197": 96.45, "19069": 3.55}',
    density: 4.8,
    imprecise: false,
    latitude: 42.74652,
    longitude: -93.55374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50470',
  },
  {
    city: 'Rudd',
    county_fips: 19067,
    county_fips_all: '19067|19131',
    county: 'Floyd',
    county_names_all: 'Floyd|Mitchell',
    county_weights: '{"19067": 93.99, "19131": 6.01}',
    density: 6.7,
    imprecise: false,
    latitude: 43.16486,
    longitude: -92.87834,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50471',
  },
  {
    city: 'Saint Ansgar',
    county_fips: 19131,
    county_fips_all: '19131|19195',
    county: 'Mitchell',
    county_names_all: 'Mitchell|Worth',
    county_weights: '{"19131": 84.8, "19195": 15.2}',
    density: 8,
    imprecise: false,
    latitude: 43.42265,
    longitude: -92.94644,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50472',
  },
  {
    city: 'Scarville',
    county_fips: 19189,
    county_fips_all: '19189',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"19189": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 43.46402,
    longitude: -93.67429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50473',
  },
  {
    city: 'Sheffield',
    county_fips: 19069,
    county_fips_all: '19069|19033',
    county: 'Franklin',
    county_names_all: 'Franklin|Cerro Gordo',
    county_weights: '{"19069": 76.81, "19033": 23.19}',
    density: 5.9,
    imprecise: false,
    latitude: 42.87902,
    longitude: -93.21852,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50475',
  },
  {
    city: 'Stacyville',
    county_fips: 19131,
    county_fips_all: '19131',
    county: 'Mitchell',
    county_names_all: 'Mitchell',
    county_weights: '{"19131": 100}',
    density: 7,
    imprecise: false,
    latitude: 43.4527,
    longitude: -92.76311,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50476',
  },
  {
    city: 'Swaledale',
    county_fips: 19033,
    county_fips_all: '19033',
    county: 'Cerro Gordo',
    county_names_all: 'Cerro Gordo',
    county_weights: '{"19033": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 42.98743,
    longitude: -93.32731,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50477',
  },
  {
    city: 'Thompson',
    county_fips: 19189,
    county_fips_all: '19189',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"19189": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 43.40377,
    longitude: -93.78448,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50478',
  },
  {
    city: 'Thornton',
    county_fips: 19033,
    county_fips_all: '19033|19069',
    county: 'Cerro Gordo',
    county_names_all: 'Cerro Gordo|Franklin',
    county_weights: '{"19033": 72.51, "19069": 27.49}',
    density: 4.3,
    imprecise: false,
    latitude: 42.94121,
    longitude: -93.4082,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50479',
  },
  {
    city: 'Titonka',
    county_fips: 19109,
    county_fips_all: '19109|19081|19189',
    county: 'Kossuth',
    county_names_all: 'Kossuth|Hancock|Winnebago',
    county_weights: '{"19109": 96.66, "19081": 2.2, "19189": 1.14}',
    density: 4.9,
    imprecise: false,
    latitude: 43.25097,
    longitude: -94.05272,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50480',
  },
  {
    city: 'Ventura',
    county_fips: 19033,
    county_fips_all: '19033|19081',
    county: 'Cerro Gordo',
    county_names_all: 'Cerro Gordo|Hancock',
    county_weights: '{"19033": 79.05, "19081": 20.95}',
    density: 9.6,
    imprecise: false,
    latitude: 43.12356,
    longitude: -93.48167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50482',
  },
  {
    city: 'Wesley',
    county_fips: 19109,
    county_fips_all: '19109|19081',
    county: 'Kossuth',
    county_names_all: 'Kossuth|Hancock',
    county_weights: '{"19109": 70.57, "19081": 29.43}',
    density: 3.2,
    imprecise: false,
    latitude: 43.11174,
    longitude: -93.99719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50483',
  },
  {
    city: 'Woden',
    county_fips: 19081,
    county_fips_all: '19081|19189|19109',
    county: 'Hancock',
    county_names_all: 'Hancock|Winnebago|Kossuth',
    county_weights: '{"19081": 64.65, "19189": 33.02, "19109": 2.33}',
    density: 3.7,
    imprecise: false,
    latitude: 43.23609,
    longitude: -93.91084,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50484',
  },
  {
    city: 'Fort Dodge',
    county_fips: 19187,
    county_fips_all: '19187',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"19187": 100}',
    density: 73.1,
    imprecise: false,
    latitude: 42.49244,
    longitude: -94.18967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50501',
  },
  {
    city: 'Albert City',
    county_fips: 19021,
    county_fips_all: '19021|19151',
    county: 'Buena Vista',
    county_names_all: 'Buena Vista|Pocahontas',
    county_weights: '{"19021": 84.19, "19151": 15.81}',
    density: 4.6,
    imprecise: false,
    latitude: 42.76084,
    longitude: -94.98216,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50510',
  },
  {
    city: 'Algona',
    county_fips: 19109,
    county_fips_all: '19109',
    county: 'Kossuth',
    county_names_all: 'Kossuth',
    county_weights: '{"19109": 100}',
    density: 21.5,
    imprecise: false,
    latitude: 43.07483,
    longitude: -94.21894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50511',
  },
  {
    city: 'Armstrong',
    county_fips: 19063,
    county_fips_all: '19063|19109',
    county: 'Emmet',
    county_names_all: 'Emmet|Kossuth',
    county_weights: '{"19063": 64.73, "19109": 35.27}',
    density: 3.8,
    imprecise: false,
    latitude: 43.41374,
    longitude: -94.47361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50514',
  },
  {
    city: 'Ayrshire',
    county_fips: 19147,
    county_fips_all: '19147|19041',
    county: 'Palo Alto',
    county_names_all: 'Palo Alto|Clay',
    county_weights: '{"19147": 76.73, "19041": 23.27}',
    density: 2.5,
    imprecise: false,
    latitude: 43.01993,
    longitude: -94.87812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50515',
  },
  {
    city: 'Badger',
    county_fips: 19187,
    county_fips_all: '19187|19091',
    county: 'Webster',
    county_names_all: 'Webster|Humboldt',
    county_weights: '{"19187": 76.42, "19091": 23.58}',
    density: 8.8,
    imprecise: false,
    latitude: 42.62566,
    longitude: -94.13545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50516',
  },
  {
    city: 'Bancroft',
    county_fips: 19109,
    county_fips_all: '19109',
    county: 'Kossuth',
    county_names_all: 'Kossuth',
    county_weights: '{"19109": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 43.30099,
    longitude: -94.23452,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50517',
  },
  {
    city: 'Barnum',
    county_fips: 19187,
    county_fips_all: '19187',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"19187": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 42.51212,
    longitude: -94.38241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50518',
  },
  {
    city: 'Bode',
    county_fips: 19091,
    county_fips_all: '19091|19109',
    county: 'Humboldt',
    county_names_all: 'Humboldt|Kossuth',
    county_weights: '{"19091": 54.98, "19109": 45.02}',
    density: 5.5,
    imprecise: false,
    latitude: 42.90314,
    longitude: -94.26542,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50519',
  },
  {
    city: 'Bradgate',
    county_fips: 19091,
    county_fips_all: '19091|19151',
    county: 'Humboldt',
    county_names_all: 'Humboldt|Pocahontas',
    county_weights: '{"19091": 93.43, "19151": 6.57}',
    density: 1.9,
    imprecise: false,
    latitude: 42.80524,
    longitude: -94.39772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50520',
  },
  {
    city: 'Burt',
    county_fips: 19109,
    county_fips_all: '19109',
    county: 'Kossuth',
    county_names_all: 'Kossuth',
    county_weights: '{"19109": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 43.18562,
    longitude: -94.18576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50522',
  },
  {
    city: 'Callender',
    county_fips: 19187,
    county_fips_all: '19187',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"19187": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 42.36783,
    longitude: -94.29357,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50523',
  },
  {
    city: 'Clare',
    county_fips: 19187,
    county_fips_all: '19187|19151',
    county: 'Webster',
    county_names_all: 'Webster|Pocahontas',
    county_weights: '{"19187": 95.69, "19151": 4.31}',
    density: 3,
    imprecise: false,
    latitude: 42.59992,
    longitude: -94.35799,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50524',
  },
  {
    city: 'Clarion',
    county_fips: 19197,
    county_fips_all: '19197',
    county: 'Wright',
    county_names_all: 'Wright',
    county_weights: '{"19197": 100}',
    density: 9,
    imprecise: false,
    latitude: 42.73875,
    longitude: -93.74907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50525',
  },
  {
    city: 'Curlew',
    county_fips: 19147,
    county_fips_all: '19147',
    county: 'Palo Alto',
    county_names_all: 'Palo Alto',
    county_weights: '{"19147": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 42.96899,
    longitude: -94.79288,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50527',
  },
  {
    city: 'Cylinder',
    county_fips: 19147,
    county_fips_all: '19147',
    county: 'Palo Alto',
    county_names_all: 'Palo Alto',
    county_weights: '{"19147": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 43.13717,
    longitude: -94.54023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50528',
  },
  {
    city: 'Dakota City',
    county_fips: 19091,
    county_fips_all: '19091',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"19091": 100}',
    density: 572.5,
    imprecise: false,
    latitude: 42.72216,
    longitude: -94.20101,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50529',
  },
  {
    city: 'Dayton',
    county_fips: 19187,
    county_fips_all: '19187|19015',
    county: 'Webster',
    county_names_all: 'Webster|Boone',
    county_weights: '{"19187": 96.01, "19015": 3.99}',
    density: 6.7,
    imprecise: false,
    latitude: 42.27021,
    longitude: -94.04173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50530',
  },
  {
    city: 'Dolliver',
    county_fips: 19063,
    county_fips_all: '19063',
    county: 'Emmet',
    county_names_all: 'Emmet',
    county_weights: '{"19063": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 43.45841,
    longitude: -94.61417,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50531',
  },
  {
    city: 'Duncombe',
    county_fips: 19187,
    county_fips_all: '19187|19079',
    county: 'Webster',
    county_names_all: 'Webster|Hamilton',
    county_weights: '{"19187": 90.17, "19079": 9.83}',
    density: 4.1,
    imprecise: false,
    latitude: 42.46212,
    longitude: -94.00175,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50532',
  },
  {
    city: 'Eagle Grove',
    county_fips: 19197,
    county_fips_all: '19197|19091|19187',
    county: 'Wright',
    county_names_all: 'Wright|Humboldt|Webster',
    county_weights: '{"19197": 79.57, "19091": 11.07, "19187": 9.36}',
    density: 15.7,
    imprecise: false,
    latitude: 42.65251,
    longitude: -93.91109,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50533',
  },
  {
    city: 'Early',
    county_fips: 19161,
    county_fips_all: '19161',
    county: 'Sac',
    county_names_all: 'Sac',
    county_weights: '{"19161": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 42.45138,
    longitude: -95.16167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50535',
  },
  {
    city: 'Emmetsburg',
    county_fips: 19147,
    county_fips_all: '19147',
    county: 'Palo Alto',
    county_names_all: 'Palo Alto',
    county_weights: '{"19147": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 43.11605,
    longitude: -94.69716,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50536',
  },
  {
    city: 'Farnhamville',
    county_fips: 19025,
    county_fips_all: '19025|19187',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Webster',
    county_weights: '{"19025": 93.03, "19187": 6.97}',
    density: 7.2,
    imprecise: false,
    latitude: 42.28422,
    longitude: -94.43024,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50538',
  },
  {
    city: 'Fenton',
    county_fips: 19109,
    county_fips_all: '19109|19147',
    county: 'Kossuth',
    county_names_all: 'Kossuth|Palo Alto',
    county_weights: '{"19109": 77.73, "19147": 22.27}',
    density: 3.1,
    imprecise: false,
    latitude: 43.23543,
    longitude: -94.41849,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50539',
  },
  {
    city: 'Fonda',
    county_fips: 19151,
    county_fips_all: '19151|19025|19161',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas|Calhoun|Sac',
    county_weights: '{"19151": 72.51, "19025": 24.9, "19161": 2.59}',
    density: 3.6,
    imprecise: false,
    latitude: 42.60019,
    longitude: -94.8407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50540',
  },
  {
    city: 'Gilmore City',
    county_fips: 19151,
    county_fips_all: '19151|19091',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas|Humboldt',
    county_weights: '{"19151": 52.86, "19091": 47.14}',
    density: 4.5,
    imprecise: false,
    latitude: 42.71569,
    longitude: -94.44715,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50541',
  },
  {
    city: 'Goldfield',
    county_fips: 19197,
    county_fips_all: '19197|19091',
    county: 'Wright',
    county_names_all: 'Wright|Humboldt',
    county_weights: '{"19197": 68.54, "19091": 31.46}',
    density: 5,
    imprecise: false,
    latitude: 42.7794,
    longitude: -93.94594,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50542',
  },
  {
    city: 'Gowrie',
    county_fips: 19187,
    county_fips_all: '19187',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"19187": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 42.27434,
    longitude: -94.30666,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50543',
  },
  {
    city: 'Harcourt',
    county_fips: 19187,
    county_fips_all: '19187',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"19187": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 42.2537,
    longitude: -94.17042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50544',
  },
  {
    city: 'Hardy',
    county_fips: 19091,
    county_fips_all: '19091',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"19091": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 42.79651,
    longitude: -94.08111,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50545',
  },
  {
    city: 'Havelock',
    county_fips: 19151,
    county_fips_all: '19151|19147',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas|Palo Alto',
    county_weights: '{"19151": 95.25, "19147": 4.75}',
    density: 2.6,
    imprecise: false,
    latitude: 42.84388,
    longitude: -94.70347,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50546',
  },
  {
    city: 'Humboldt',
    county_fips: 19091,
    county_fips_all: '19091|19187',
    county: 'Humboldt',
    county_names_all: 'Humboldt|Webster',
    county_weights: '{"19091": 92.37, "19187": 7.63}',
    density: 17.8,
    imprecise: false,
    latitude: 42.71275,
    longitude: -94.22645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50548',
  },
  {
    city: 'Jolley',
    county_fips: 19025,
    county_fips_all: '19025',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"19025": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 42.48242,
    longitude: -94.75484,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50551',
  },
  {
    city: 'Laurens',
    county_fips: 19151,
    county_fips_all: '19151|19147|19021',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas|Palo Alto|Buena Vista',
    county_weights: '{"19151": 84.53, "19147": 11.88, "19021": 3.59}',
    density: 6.9,
    imprecise: false,
    latitude: 42.84648,
    longitude: -94.84118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50554',
  },
  {
    city: 'Ledyard',
    county_fips: 19109,
    county_fips_all: '19109',
    county: 'Kossuth',
    county_names_all: 'Kossuth',
    county_weights: '{"19109": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 43.45276,
    longitude: -94.20114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50556',
  },
  {
    city: 'Lehigh',
    county_fips: 19187,
    county_fips_all: '19187',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"19187": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 42.35544,
    longitude: -94.04409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50557',
  },
  {
    city: 'Livermore',
    county_fips: 19091,
    county_fips_all: '19091|19109',
    county: 'Humboldt',
    county_names_all: 'Humboldt|Kossuth',
    county_weights: '{"19091": 82.87, "19109": 17.13}',
    density: 5.1,
    imprecise: false,
    latitude: 42.86717,
    longitude: -94.16607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50558',
  },
  {
    city: 'Lone Rock',
    county_fips: 19109,
    county_fips_all: '19109',
    county: 'Kossuth',
    county_names_all: 'Kossuth',
    county_weights: '{"19109": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 43.20912,
    longitude: -94.32477,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50559',
  },
  {
    city: 'Lu Verne',
    county_fips: 19109,
    county_fips_all: '19109|19091',
    county: 'Kossuth',
    county_names_all: 'Kossuth|Humboldt',
    county_weights: '{"19109": 85.36, "19091": 14.64}',
    density: 3.6,
    imprecise: false,
    latitude: 42.95581,
    longitude: -94.1043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50560',
  },
  {
    city: 'Lytton',
    county_fips: 19025,
    county_fips_all: '19025|19161',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Sac',
    county_weights: '{"19025": 57.65, "19161": 42.35}',
    density: 4.7,
    imprecise: false,
    latitude: 42.42122,
    longitude: -94.84794,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50561',
  },
  {
    city: 'Mallard',
    county_fips: 19147,
    county_fips_all: '19147|19151',
    county: 'Palo Alto',
    county_names_all: 'Palo Alto|Pocahontas',
    county_weights: '{"19147": 92.87, "19151": 7.13}',
    density: 2.3,
    imprecise: false,
    latitude: 42.96158,
    longitude: -94.64173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50562',
  },
  {
    city: 'Manson',
    county_fips: 19025,
    county_fips_all: '19025|19151|19187',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Pocahontas|Webster',
    county_weights: '{"19025": 68.99, "19151": 26.24, "19187": 4.77}',
    density: 9.5,
    imprecise: false,
    latitude: 42.52802,
    longitude: -94.52515,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50563',
  },
  {
    city: 'Marathon',
    county_fips: 19021,
    county_fips_all: '19021|19041',
    county: 'Buena Vista',
    county_names_all: 'Buena Vista|Clay',
    county_weights: '{"19021": 95.37, "19041": 4.63}',
    density: 3.4,
    imprecise: false,
    latitude: 42.86118,
    longitude: -94.99698,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50565',
  },
  {
    city: 'Moorland',
    county_fips: 19187,
    county_fips_all: '19187|19025',
    county: 'Webster',
    county_names_all: 'Webster|Calhoun',
    county_weights: '{"19187": 96.73, "19025": 3.27}',
    density: 3.5,
    imprecise: false,
    latitude: 42.43925,
    longitude: -94.32889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50566',
  },
  {
    city: 'Nemaha',
    county_fips: 19161,
    county_fips_all: '19161',
    county: 'Sac',
    county_names_all: 'Sac',
    county_weights: '{"19161": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 42.52146,
    longitude: -95.08935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50567',
  },
  {
    city: 'Newell',
    county_fips: 19021,
    county_fips_all: '19021|19161',
    county: 'Buena Vista',
    county_names_all: 'Buena Vista|Sac',
    county_weights: '{"19021": 88.26, "19161": 11.74}',
    density: 6.5,
    imprecise: false,
    latitude: 42.62171,
    longitude: -94.99395,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50568',
  },
  {
    city: 'Otho',
    county_fips: 19187,
    county_fips_all: '19187',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"19187": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 42.4032,
    longitude: -94.13841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50569',
  },
  {
    city: 'Ottosen',
    county_fips: 19091,
    county_fips_all: '19091|19109',
    county: 'Humboldt',
    county_names_all: 'Humboldt|Kossuth',
    county_weights: '{"19091": 64.16, "19109": 35.84}',
    density: 1.8,
    imprecise: false,
    latitude: 42.89359,
    longitude: -94.36585,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50570',
  },
  {
    city: 'Palmer',
    county_fips: 19151,
    county_fips_all: '19151',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"19151": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 42.63485,
    longitude: -94.5806,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50571',
  },
  {
    city: 'Plover',
    county_fips: 19151,
    county_fips_all: '19151',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"19151": 100}',
    density: 28.1,
    imprecise: false,
    latitude: 42.8768,
    longitude: -94.62255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50573',
  },
  {
    city: 'Pocahontas',
    county_fips: 19151,
    county_fips_all: '19151',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"19151": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 42.71891,
    longitude: -94.69967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50574',
  },
  {
    city: 'Pomeroy',
    county_fips: 19025,
    county_fips_all: '19025|19151',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Pocahontas',
    county_weights: '{"19025": 53.09, "19151": 46.91}',
    density: 4.3,
    imprecise: false,
    latitude: 42.5588,
    longitude: -94.70065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50575',
  },
  {
    city: 'Rembrandt',
    county_fips: 19021,
    county_fips_all: '19021',
    county: 'Buena Vista',
    county_names_all: 'Buena Vista',
    county_weights: '{"19021": 100}',
    density: 3,
    imprecise: false,
    latitude: 42.80267,
    longitude: -95.17727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50576',
  },
  {
    city: 'Renwick',
    county_fips: 19091,
    county_fips_all: '19091|19197',
    county: 'Humboldt',
    county_names_all: 'Humboldt|Wright',
    county_weights: '{"19091": 57.19, "19197": 42.81}',
    density: 3.4,
    imprecise: false,
    latitude: 42.85774,
    longitude: -93.97902,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50577',
  },
  {
    city: 'Ringsted',
    county_fips: 19063,
    county_fips_all: '19063|19147',
    county: 'Emmet',
    county_names_all: 'Emmet|Palo Alto',
    county_weights: '{"19063": 89.49, "19147": 10.51}',
    density: 3.5,
    imprecise: false,
    latitude: 43.30081,
    longitude: -94.54775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50578',
  },
  {
    city: 'Rockwell City',
    county_fips: 19025,
    county_fips_all: '19025',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"19025": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 42.39356,
    longitude: -94.6345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50579',
  },
  {
    city: 'Rolfe',
    county_fips: 19151,
    county_fips_all: '19151|19147',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas|Palo Alto',
    county_weights: '{"19151": 91.8, "19147": 8.2}',
    density: 3.3,
    imprecise: false,
    latitude: 42.84735,
    longitude: -94.54506,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50581',
  },
  {
    city: 'Rutland',
    county_fips: 19091,
    county_fips_all: '19091',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"19091": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 42.79338,
    longitude: -94.30217,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50582',
  },
  {
    city: 'Sac City',
    county_fips: 19161,
    county_fips_all: '19161|19025',
    county: 'Sac',
    county_names_all: 'Sac|Calhoun',
    county_weights: '{"19161": 97.41, "19025": 2.59}',
    density: 7.6,
    imprecise: false,
    latitude: 42.43049,
    longitude: -94.98595,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50583',
  },
  {
    city: 'Sioux Rapids',
    county_fips: 19021,
    county_fips_all: '19021|19041',
    county: 'Buena Vista',
    county_names_all: 'Buena Vista|Clay',
    county_weights: '{"19021": 51.53, "19041": 48.47}',
    density: 6.2,
    imprecise: false,
    latitude: 42.91154,
    longitude: -95.1407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50585',
  },
  {
    city: 'Somers',
    county_fips: 19025,
    county_fips_all: '19025|19187',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Webster',
    county_weights: '{"19025": 93.12, "19187": 6.88}',
    density: 3.2,
    imprecise: false,
    latitude: 42.40472,
    longitude: -94.43204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50586',
  },
  {
    city: 'Storm Lake',
    county_fips: 19021,
    county_fips_all: '19021|19161',
    county: 'Buena Vista',
    county_names_all: 'Buena Vista|Sac',
    county_weights: '{"19021": 99.37, "19161": 0.63}',
    density: 37.4,
    imprecise: false,
    latitude: 42.65777,
    longitude: -95.16391,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50588',
  },
  {
    city: 'Swea City',
    county_fips: 19109,
    county_fips_all: '19109',
    county: 'Kossuth',
    county_names_all: 'Kossuth',
    county_weights: '{"19109": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 43.40647,
    longitude: -94.30303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50590',
  },
  {
    city: 'Thor',
    county_fips: 19091,
    county_fips_all: '19091|19187',
    county: 'Humboldt',
    county_names_all: 'Humboldt|Webster',
    county_weights: '{"19091": 88.11, "19187": 11.89}',
    density: 5.3,
    imprecise: false,
    latitude: 42.67683,
    longitude: -94.05478,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50591',
  },
  {
    city: 'Truesdale',
    county_fips: 19021,
    county_fips_all: '19021',
    county: 'Buena Vista',
    county_names_all: 'Buena Vista',
    county_weights: '{"19021": 100}',
    density: 494.9,
    imprecise: false,
    latitude: 42.72927,
    longitude: -95.18345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50592',
  },
  {
    city: 'Varina',
    county_fips: 19151,
    county_fips_all: '19151',
    county: 'Pocahontas',
    county_names_all: 'Pocahontas',
    county_weights: '{"19151": 100}',
    density: 59.2,
    imprecise: false,
    latitude: 42.65796,
    longitude: -94.89832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50593',
  },
  {
    city: 'Vincent',
    county_fips: 19187,
    county_fips_all: '19187',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"19187": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 42.58561,
    longitude: -94.03949,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50594',
  },
  {
    city: 'Webster City',
    county_fips: 19079,
    county_fips_all: '19079|19197|19187',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Wright|Webster',
    county_weights: '{"19079": 97.92, "19197": 1.41, "19187": 0.67}',
    density: 22.3,
    imprecise: false,
    latitude: 42.46097,
    longitude: -93.82154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50595',
  },
  {
    city: 'West Bend',
    county_fips: 19147,
    county_fips_all: '19147|19109|19091|19151',
    county: 'Palo Alto',
    county_names_all: 'Palo Alto|Kossuth|Humboldt|Pocahontas',
    county_weights:
      '{"19147": 55.54, "19109": 42.19, "19091": 1.34, "19151": 0.93}',
    density: 6.2,
    imprecise: false,
    latitude: 42.97379,
    longitude: -94.45048,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50597',
  },
  {
    city: 'Whittemore',
    county_fips: 19109,
    county_fips_all: '19109|19147',
    county: 'Kossuth',
    county_names_all: 'Kossuth|Palo Alto',
    county_weights: '{"19109": 70.0, "19147": 30.0}',
    density: 4.6,
    imprecise: false,
    latitude: 43.08023,
    longitude: -94.41841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50598',
  },
  {
    city: 'Woolstock',
    county_fips: 19197,
    county_fips_all: '19197|19079',
    county: 'Wright',
    county_names_all: 'Wright|Hamilton',
    county_weights: '{"19197": 83.68, "19079": 16.32}',
    density: 3.3,
    imprecise: false,
    latitude: 42.58089,
    longitude: -93.81471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50599',
  },
  {
    city: 'Ackley',
    county_fips: 19069,
    county_fips_all: '19069|19083|19023|19075',
    county: 'Franklin',
    county_names_all: 'Franklin|Hardin|Butler|Grundy',
    county_weights:
      '{"19069": 36.48, "19083": 29.82, "19023": 17.74, "19075": 15.97}',
    density: 6.4,
    imprecise: false,
    latitude: 42.56612,
    longitude: -93.05665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50601',
  },
  {
    city: 'Allison',
    county_fips: 19023,
    county_fips_all: '19023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"19023": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 42.74036,
    longitude: -92.80581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50602',
  },
  {
    city: 'Alta Vista',
    county_fips: 19037,
    county_fips_all: '19037|19089',
    county: 'Chickasaw',
    county_names_all: 'Chickasaw|Howard',
    county_weights: '{"19037": 83.24, "19089": 16.76}',
    density: 4.8,
    imprecise: false,
    latitude: 43.18893,
    longitude: -92.45834,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50603',
  },
  {
    city: 'Aplington',
    county_fips: 19023,
    county_fips_all: '19023|19075',
    county: 'Butler',
    county_names_all: 'Butler|Grundy',
    county_weights: '{"19023": 79.53, "19075": 20.47}',
    density: 8.6,
    imprecise: false,
    latitude: 42.60484,
    longitude: -92.90299,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50604',
  },
  {
    city: 'Aredale',
    county_fips: 19069,
    county_fips_all: '19069|19023',
    county: 'Franklin',
    county_names_all: 'Franklin|Butler',
    county_weights: '{"19069": 61.07, "19023": 38.93}',
    density: 1.4,
    imprecise: false,
    latitude: 42.83559,
    longitude: -93.03276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50605',
  },
  {
    city: 'Arlington',
    county_fips: 19065,
    county_fips_all: '19065|19043',
    county: 'Fayette',
    county_names_all: 'Fayette|Clayton',
    county_weights: '{"19065": 95.64, "19043": 4.36}',
    density: 4.6,
    imprecise: false,
    latitude: 42.74669,
    longitude: -91.68299,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50606',
  },
  {
    city: 'Aurora',
    county_fips: 19019,
    county_fips_all: '19019|19065',
    county: 'Buchanan',
    county_names_all: 'Buchanan|Fayette',
    county_weights: '{"19019": 70.37, "19065": 29.63}',
    density: 3.3,
    imprecise: false,
    latitude: 42.60872,
    longitude: -91.74747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50607',
  },
  {
    city: 'Austinville',
    county_fips: 19023,
    county_fips_all: '19023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"19023": 100}',
    density: 41.7,
    imprecise: false,
    latitude: 42.58815,
    longitude: -92.96075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50608',
  },
  {
    city: 'Beaman',
    county_fips: 19075,
    county_fips_all: '19075|19127|19171',
    county: 'Grundy',
    county_names_all: 'Grundy|Marshall|Tama',
    county_weights: '{"19075": 65.84, "19127": 30.65, "19171": 3.51}',
    density: 4.4,
    imprecise: false,
    latitude: 42.23066,
    longitude: -92.81046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50609',
  },
  {
    city: 'Bristow',
    county_fips: 19023,
    county_fips_all: '19023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"19023": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 42.8193,
    longitude: -92.91114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50611',
  },
  {
    city: 'Buckingham',
    county_fips: 19171,
    county_fips_all: '19171|19013',
    county: 'Tama',
    county_names_all: 'Tama|Black Hawk',
    county_weights: '{"19171": 72.6, "19013": 27.4}',
    density: 5.1,
    imprecise: false,
    latitude: 42.28546,
    longitude: -92.38687,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50612',
  },
  {
    city: 'Cedar Falls',
    county_fips: 19013,
    county_fips_all: '19013|19075|19023',
    county: 'Black Hawk',
    county_names_all: 'Black Hawk|Grundy|Butler',
    county_weights: '{"19013": 80.92, "19075": 15.27, "19023": 3.81}',
    density: 132.8,
    imprecise: false,
    latitude: 42.53358,
    longitude: -92.49069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50613',
  },
  {
    city: 'Charles City',
    county_fips: 19067,
    county_fips_all: '19067|19037',
    county: 'Floyd',
    county_names_all: 'Floyd|Chickasaw',
    county_weights: '{"19067": 93.72, "19037": 6.28}',
    density: 20.5,
    imprecise: false,
    latitude: 43.07978,
    longitude: -92.66104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50616',
  },
  {
    city: 'Clarksville',
    county_fips: 19023,
    county_fips_all: '19023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"19023": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 42.79725,
    longitude: -92.66266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50619',
  },
  {
    city: 'Colwell',
    county_fips: 19067,
    county_fips_all: '19067',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"19067": 100}',
    density: 95.6,
    imprecise: false,
    latitude: 43.15712,
    longitude: -92.5912,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50620',
  },
  {
    city: 'Conrad',
    county_fips: 19075,
    county_fips_all: '19075|19127',
    county: 'Grundy',
    county_names_all: 'Grundy|Marshall',
    county_weights: '{"19075": 83.77, "19127": 16.23}',
    density: 9.8,
    imprecise: false,
    latitude: 42.24738,
    longitude: -92.91904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50621',
  },
  {
    city: 'Denver',
    county_fips: 19017,
    county_fips_all: '19017',
    county: 'Bremer',
    county_names_all: 'Bremer',
    county_weights: '{"19017": 100}',
    density: 53.4,
    imprecise: false,
    latitude: 42.67358,
    longitude: -92.33358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50622',
  },
  {
    city: 'Dewar',
    county_fips: 19013,
    county_fips_all: '19013',
    county: 'Black Hawk',
    county_names_all: 'Black Hawk',
    county_weights: '{"19013": 100}',
    density: 28.6,
    imprecise: false,
    latitude: 42.52693,
    longitude: -92.20962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50623',
  },
  {
    city: 'Dike',
    county_fips: 19075,
    county_fips_all: '19075',
    county: 'Grundy',
    county_names_all: 'Grundy',
    county_weights: '{"19075": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 42.46874,
    longitude: -92.65879,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50624',
  },
  {
    city: 'Dumont',
    county_fips: 19023,
    county_fips_all: '19023|19069',
    county: 'Butler',
    county_names_all: 'Butler|Franklin',
    county_weights: '{"19023": 82.78, "19069": 17.22}',
    density: 5.9,
    imprecise: false,
    latitude: 42.75071,
    longitude: -92.98691,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50625',
  },
  {
    city: 'Dunkerton',
    county_fips: 19013,
    county_fips_all: '19013|19019',
    county: 'Black Hawk',
    county_names_all: 'Black Hawk|Buchanan',
    county_weights: '{"19013": 99.58, "19019": 0.42}',
    density: 11.2,
    imprecise: false,
    latitude: 42.58028,
    longitude: -92.17049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50626',
  },
  {
    city: 'Eldora',
    county_fips: 19083,
    county_fips_all: '19083|19075',
    county: 'Hardin',
    county_names_all: 'Hardin|Grundy',
    county_weights: '{"19083": 82.73, "19075": 17.27}',
    density: 12,
    imprecise: false,
    latitude: 42.34982,
    longitude: -93.095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50627',
  },
  {
    city: 'Elma',
    county_fips: 19089,
    county_fips_all: '19089|19131',
    county: 'Howard',
    county_names_all: 'Howard|Mitchell',
    county_weights: '{"19089": 93.05, "19131": 6.95}',
    density: 4.8,
    imprecise: false,
    latitude: 43.26655,
    longitude: -92.39134,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50628',
  },
  {
    city: 'Fairbank',
    county_fips: 19019,
    county_fips_all: '19019|19017|19065|19013',
    county: 'Buchanan',
    county_names_all: 'Buchanan|Bremer|Fayette|Black Hawk',
    county_weights:
      '{"19019": 32.25, "19017": 29.43, "19065": 21.97, "19013": 16.34}',
    density: 10.7,
    imprecise: false,
    latitude: 42.64222,
    longitude: -92.081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50629',
  },
  {
    city: 'Fredericksburg',
    county_fips: 19037,
    county_fips_all: '19037|19017',
    county: 'Chickasaw',
    county_names_all: 'Chickasaw|Bremer',
    county_weights: '{"19037": 89.69, "19017": 10.31}',
    density: 6.3,
    imprecise: false,
    latitude: 42.95651,
    longitude: -92.21346,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50630',
  },
  {
    city: 'Frederika',
    county_fips: 19017,
    county_fips_all: '19017',
    county: 'Bremer',
    county_names_all: 'Bremer',
    county_weights: '{"19017": 100}',
    density: 468.3,
    imprecise: false,
    latitude: 42.88254,
    longitude: -92.30929,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50631',
  },
  {
    city: 'Garwin',
    county_fips: 19171,
    county_fips_all: '19171|19127',
    county: 'Tama',
    county_names_all: 'Tama|Marshall',
    county_weights: '{"19171": 98.68, "19127": 1.32}',
    density: 11,
    imprecise: false,
    latitude: 42.07667,
    longitude: -92.70299,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50632',
  },
  {
    city: 'Geneva',
    county_fips: 19069,
    county_fips_all: '19069',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"19069": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 42.67203,
    longitude: -93.12664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50633',
  },
  {
    city: 'Gilbertville',
    county_fips: 19013,
    county_fips_all: '19013',
    county: 'Black Hawk',
    county_names_all: 'Black Hawk',
    county_weights: '{"19013": 100}',
    density: 820.9,
    imprecise: false,
    latitude: 42.4181,
    longitude: -92.21422,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50634',
  },
  {
    city: 'Gladbrook',
    county_fips: 19171,
    county_fips_all: '19171|19127',
    county: 'Tama',
    county_names_all: 'Tama|Marshall',
    county_weights: '{"19171": 95.96, "19127": 4.04}',
    density: 6.6,
    imprecise: false,
    latitude: 42.19886,
    longitude: -92.69896,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50635',
  },
  {
    city: 'Greene',
    county_fips: 19023,
    county_fips_all: '19023|19067',
    county: 'Butler',
    county_names_all: 'Butler|Floyd',
    county_weights: '{"19023": 62.25, "19067": 37.75}',
    density: 7.2,
    imprecise: false,
    latitude: 42.89439,
    longitude: -92.80745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50636',
  },
  {
    city: 'Grundy Center',
    county_fips: 19075,
    county_fips_all: '19075',
    county: 'Grundy',
    county_names_all: 'Grundy',
    county_weights: '{"19075": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 42.35654,
    longitude: -92.79495,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50638',
  },
  {
    city: 'Hazleton',
    county_fips: 19019,
    county_fips_all: '19019',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"19019": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 42.59746,
    longitude: -91.91961,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50641',
  },
  {
    city: 'Holland',
    county_fips: 19075,
    county_fips_all: '19075',
    county: 'Grundy',
    county_names_all: 'Grundy',
    county_weights: '{"19075": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 42.44024,
    longitude: -92.81243,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50642',
  },
  {
    city: 'Hudson',
    county_fips: 19013,
    county_fips_all: '19013|19075',
    county: 'Black Hawk',
    county_names_all: 'Black Hawk|Grundy',
    county_weights: '{"19013": 90.66, "19075": 9.34}',
    density: 20.3,
    imprecise: false,
    latitude: 42.36413,
    longitude: -92.47402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50643',
  },
  {
    city: 'Independence',
    county_fips: 19019,
    county_fips_all: '19019',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"19019": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 42.47751,
    longitude: -91.89721,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50644',
  },
  {
    city: 'Ionia',
    county_fips: 19037,
    county_fips_all: '19037|19017|19067',
    county: 'Chickasaw',
    county_names_all: 'Chickasaw|Bremer|Floyd',
    county_weights: '{"19037": 90.25, "19017": 6.81, "19067": 2.94}',
    density: 5.4,
    imprecise: false,
    latitude: 43.02174,
    longitude: -92.44952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50645',
  },
  {
    city: 'Janesville',
    county_fips: 19017,
    county_fips_all: '19017|19013',
    county: 'Bremer',
    county_names_all: 'Bremer|Black Hawk',
    county_weights: '{"19017": 61.7, "19013": 38.3}',
    density: 25.1,
    imprecise: false,
    latitude: 42.64787,
    longitude: -92.48026,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50647',
  },
  {
    city: 'Jesup',
    county_fips: 19013,
    county_fips_all: '19013|19019',
    county: 'Black Hawk',
    county_names_all: 'Black Hawk|Buchanan',
    county_weights: '{"19013": 58.35, "19019": 41.65}',
    density: 19.8,
    imprecise: false,
    latitude: 42.45182,
    longitude: -92.09465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50648',
  },
  {
    city: 'Kesley',
    county_fips: 19023,
    county_fips_all: '19023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"19023": 100}',
    density: 161.7,
    imprecise: false,
    latitude: 42.66249,
    longitude: -92.90973,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50649',
  },
  {
    city: 'Lamont',
    county_fips: 19019,
    county_fips_all: '19019|19065',
    county: 'Buchanan',
    county_names_all: 'Buchanan|Fayette',
    county_weights: '{"19019": 69.15, "19065": 30.85}',
    density: 6.1,
    imprecise: false,
    latitude: 42.61915,
    longitude: -91.65429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50650',
  },
  {
    city: 'La Porte City',
    county_fips: 19013,
    county_fips_all: '19013|19011|19171',
    county: 'Black Hawk',
    county_names_all: 'Black Hawk|Benton|Tama',
    county_weights: '{"19013": 71.71, "19011": 25.54, "19171": 2.75}',
    density: 10.6,
    imprecise: false,
    latitude: 42.32271,
    longitude: -92.19993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50651',
  },
  {
    city: 'Lincoln',
    county_fips: 19171,
    county_fips_all: '19171',
    county: 'Tama',
    county_names_all: 'Tama',
    county_weights: '{"19171": 100}',
    density: 116.9,
    imprecise: false,
    latitude: 42.26454,
    longitude: -92.69234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50652',
  },
  {
    city: 'Marble Rock',
    county_fips: 19067,
    county_fips_all: '19067',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"19067": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 42.96737,
    longitude: -92.88927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50653',
  },
  {
    city: 'Masonville',
    county_fips: 19019,
    county_fips_all: '19019|19055',
    county: 'Buchanan',
    county_names_all: 'Buchanan|Delaware',
    county_weights: '{"19019": 52.07, "19055": 47.93}',
    density: 2,
    imprecise: false,
    latitude: 42.45812,
    longitude: -91.60933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50654',
  },
  {
    city: 'Maynard',
    county_fips: 19065,
    county_fips_all: '19065',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"19065": 100}',
    density: 8,
    imprecise: false,
    latitude: 42.77232,
    longitude: -91.9016,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50655',
  },
  {
    city: 'Morrison',
    county_fips: 19075,
    county_fips_all: '19075',
    county: 'Grundy',
    county_names_all: 'Grundy',
    county_weights: '{"19075": 100}',
    density: 244.9,
    imprecise: false,
    latitude: 42.34454,
    longitude: -92.67399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50657',
  },
  {
    city: 'Nashua',
    county_fips: 19037,
    county_fips_all: '19037|19067|19023|19017',
    county: 'Chickasaw',
    county_names_all: 'Chickasaw|Floyd|Butler|Bremer',
    county_weights:
      '{"19037": 55.66, "19067": 33.66, "19023": 6.53, "19017": 4.15}',
    density: 12.1,
    imprecise: false,
    latitude: 42.95024,
    longitude: -92.53782,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50658',
  },
  {
    city: 'New Hampton',
    county_fips: 19037,
    county_fips_all: '19037',
    county: 'Chickasaw',
    county_names_all: 'Chickasaw',
    county_weights: '{"19037": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 43.08749,
    longitude: -92.3221,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50659',
  },
  {
    city: 'New Hartford',
    county_fips: 19023,
    county_fips_all: '19023|19075',
    county: 'Butler',
    county_names_all: 'Butler|Grundy',
    county_weights: '{"19023": 78.92, "19075": 21.08}',
    density: 12.6,
    imprecise: false,
    latitude: 42.58099,
    longitude: -92.63752,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50660',
  },
  {
    city: 'Oelwein',
    county_fips: 19065,
    county_fips_all: '19065|19019',
    county: 'Fayette',
    county_names_all: 'Fayette|Buchanan',
    county_weights: '{"19065": 93.73, "19019": 6.27}',
    density: 36,
    imprecise: false,
    latitude: 42.68748,
    longitude: -91.93396,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50662',
  },
  {
    city: 'Oran',
    county_fips: 19065,
    county_fips_all: '19065',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"19065": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 42.70698,
    longitude: -92.07222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50664',
  },
  {
    city: 'Parkersburg',
    county_fips: 19023,
    county_fips_all: '19023|19075',
    county: 'Butler',
    county_names_all: 'Butler|Grundy',
    county_weights: '{"19023": 64.44, "19075": 35.56}',
    density: 10.5,
    imprecise: false,
    latitude: 42.58078,
    longitude: -92.7717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50665',
  },
  {
    city: 'Plainfield',
    county_fips: 19017,
    county_fips_all: '19017|19023',
    county: 'Bremer',
    county_names_all: 'Bremer|Butler',
    county_weights: '{"19017": 76.21, "19023": 23.79}',
    density: 5.9,
    imprecise: false,
    latitude: 42.85995,
    longitude: -92.50933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50666',
  },
  {
    city: 'Raymond',
    county_fips: 19013,
    county_fips_all: '19013',
    county: 'Black Hawk',
    county_names_all: 'Black Hawk',
    county_weights: '{"19013": 100}',
    density: 182.6,
    imprecise: false,
    latitude: 42.47003,
    longitude: -92.22545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50667',
  },
  {
    city: 'Readlyn',
    county_fips: 19017,
    county_fips_all: '19017',
    county: 'Bremer',
    county_names_all: 'Bremer',
    county_weights: '{"19017": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 42.69087,
    longitude: -92.2265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50668',
  },
  {
    city: 'Reinbeck',
    county_fips: 19075,
    county_fips_all: '19075|19171|19013',
    county: 'Grundy',
    county_names_all: 'Grundy|Tama|Black Hawk',
    county_weights: '{"19075": 69.13, "19171": 29.84, "19013": 1.03}',
    density: 9.7,
    imprecise: false,
    latitude: 42.33309,
    longitude: -92.6124,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50669',
  },
  {
    city: 'Shell Rock',
    county_fips: 19023,
    county_fips_all: '19023|19017|19013',
    county: 'Butler',
    county_names_all: 'Butler|Bremer|Black Hawk',
    county_weights: '{"19023": 97.21, "19017": 1.92, "19013": 0.87}',
    density: 15.9,
    imprecise: false,
    latitude: 42.68425,
    longitude: -92.61586,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50670',
  },
  {
    city: 'Stanley',
    county_fips: 19065,
    county_fips_all: '19065|19019',
    county: 'Fayette',
    county_names_all: 'Fayette|Buchanan',
    county_weights: '{"19065": 60.76, "19019": 39.24}',
    density: 3.2,
    imprecise: false,
    latitude: 42.6523,
    longitude: -91.7997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50671',
  },
  {
    city: 'Steamboat Rock',
    county_fips: 19083,
    county_fips_all: '19083|19075',
    county: 'Hardin',
    county_names_all: 'Hardin|Grundy',
    county_weights: '{"19083": 90.67, "19075": 9.33}',
    density: 6.3,
    imprecise: false,
    latitude: 42.4247,
    longitude: -93.06545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50672',
  },
  {
    city: 'Stout',
    county_fips: 19075,
    county_fips_all: '19075',
    county: 'Grundy',
    county_names_all: 'Grundy',
    county_weights: '{"19075": 100}',
    density: 572.8,
    imprecise: false,
    latitude: 42.52505,
    longitude: -92.7113,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50673',
  },
  {
    city: 'Sumner',
    county_fips: 19017,
    county_fips_all: '19017|19065|19037',
    county: 'Bremer',
    county_names_all: 'Bremer|Fayette|Chickasaw',
    county_weights: '{"19017": 61.82, "19065": 32.18, "19037": 6.0}',
    density: 8.4,
    imprecise: false,
    latitude: 42.84202,
    longitude: -92.11746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50674',
  },
  {
    city: 'Traer',
    county_fips: 19171,
    county_fips_all: '19171|19013',
    county: 'Tama',
    county_names_all: 'Tama|Black Hawk',
    county_weights: '{"19171": 97.77, "19013": 2.23}',
    density: 7.6,
    imprecise: false,
    latitude: 42.19884,
    longitude: -92.4928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50675',
  },
  {
    city: 'Tripoli',
    county_fips: 19017,
    county_fips_all: '19017',
    county: 'Bremer',
    county_names_all: 'Bremer',
    county_weights: '{"19017": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 42.7943,
    longitude: -92.27895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50676',
  },
  {
    city: 'Waverly',
    county_fips: 19017,
    county_fips_all: '19017|19023',
    county: 'Bremer',
    county_names_all: 'Bremer|Butler',
    county_weights: '{"19017": 96.97, "19023": 3.03}',
    density: 38.1,
    imprecise: false,
    latitude: 42.76363,
    longitude: -92.43775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50677',
  },
  {
    city: 'Wellsburg',
    county_fips: 19075,
    county_fips_all: '19075|19083',
    county: 'Grundy',
    county_names_all: 'Grundy|Hardin',
    county_weights: '{"19075": 99.15, "19083": 0.85}',
    density: 6.9,
    imprecise: false,
    latitude: 42.44956,
    longitude: -92.92505,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50680',
  },
  {
    city: 'Westgate',
    county_fips: 19065,
    county_fips_all: '19065',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"19065": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 42.77754,
    longitude: -92.00931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50681',
  },
  {
    city: 'Winthrop',
    county_fips: 19019,
    county_fips_all: '19019',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"19019": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 42.45241,
    longitude: -91.69893,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50682',
  },
  {
    city: 'Waterloo',
    county_fips: 19013,
    county_fips_all: '19013',
    county: 'Black Hawk',
    county_names_all: 'Black Hawk',
    county_weights: '{"19013": 100}',
    density: 147.5,
    imprecise: false,
    latitude: 42.4171,
    longitude: -92.34448,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50701',
  },
  {
    city: 'Waterloo',
    county_fips: 19013,
    county_fips_all: '19013',
    county: 'Black Hawk',
    county_names_all: 'Black Hawk',
    county_weights: '{"19013": 100}',
    density: 824.8,
    imprecise: false,
    latitude: 42.45745,
    longitude: -92.31283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50702',
  },
  {
    city: 'Waterloo',
    county_fips: 19013,
    county_fips_all: '19013',
    county: 'Black Hawk',
    county_names_all: 'Black Hawk',
    county_weights: '{"19013": 100}',
    density: 74.3,
    imprecise: false,
    latitude: 42.54817,
    longitude: -92.28195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50703',
  },
  {
    city: 'Evansdale',
    county_fips: 19013,
    county_fips_all: '19013',
    county: 'Black Hawk',
    county_names_all: 'Black Hawk',
    county_weights: '{"19013": 100}',
    density: 366,
    imprecise: false,
    latitude: 42.4771,
    longitude: -92.27918,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50707',
  },
  {
    city: 'Creston',
    county_fips: 19175,
    county_fips_all: '19175|19003|19001',
    county: 'Union',
    county_names_all: 'Union|Adams|Adair',
    county_weights: '{"19175": 68.72, "19003": 20.52, "19001": 10.76}',
    density: 16.8,
    imprecise: false,
    latitude: 41.07959,
    longitude: -94.39224,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50801',
  },
  {
    city: 'Afton',
    county_fips: 19175,
    county_fips_all: '19175',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"19175": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 41.0242,
    longitude: -94.19037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50830',
  },
  {
    city: 'Arispe',
    county_fips: 19175,
    county_fips_all: '19175',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"19175": 100}',
    density: 37.9,
    imprecise: false,
    latitude: 40.94938,
    longitude: -94.22341,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50831',
  },
  {
    city: 'Bedford',
    county_fips: 19173,
    county_fips_all: '19173',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"19173": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 40.66956,
    longitude: -94.70309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50833',
  },
  {
    city: 'Benton',
    county_fips: 19159,
    county_fips_all: '19159',
    county: 'Ringgold',
    county_names_all: 'Ringgold',
    county_weights: '{"19159": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 40.70769,
    longitude: -94.3675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50835',
  },
  {
    city: 'Blockton',
    county_fips: 19173,
    county_fips_all: '19173|19159',
    county: 'Taylor',
    county_names_all: 'Taylor|Ringgold',
    county_weights: '{"19173": 59.81, "19159": 40.19}',
    density: 1.3,
    imprecise: false,
    latitude: 40.63116,
    longitude: -94.49689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50836',
  },
  {
    city: 'Bridgewater',
    county_fips: 19001,
    county_fips_all: '19001|19029|19003',
    county: 'Adair',
    county_names_all: 'Adair|Cass|Adams',
    county_weights: '{"19001": 70.12, "19029": 16.49, "19003": 13.39}',
    density: 2.1,
    imprecise: false,
    latitude: 41.22878,
    longitude: -94.68367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50837',
  },
  {
    city: 'Carbon',
    county_fips: 19003,
    county_fips_all: '19003',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"19003": 100}',
    density: 35.4,
    imprecise: false,
    latitude: 41.04874,
    longitude: -94.82206,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50839',
  },
  {
    city: 'Clearfield',
    county_fips: 19173,
    county_fips_all: '19173|19159',
    county: 'Taylor',
    county_names_all: 'Taylor|Ringgold',
    county_weights: '{"19173": 60.5, "19159": 39.5}',
    density: 4.6,
    imprecise: false,
    latitude: 40.79378,
    longitude: -94.48413,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50840',
  },
  {
    city: 'Corning',
    county_fips: 19003,
    county_fips_all: '19003|19173',
    county: 'Adams',
    county_names_all: 'Adams|Taylor',
    county_weights: '{"19003": 89.06, "19173": 10.94}',
    density: 4,
    imprecise: false,
    latitude: 41.01147,
    longitude: -94.76342,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50841',
  },
  {
    city: 'Cromwell',
    county_fips: 19175,
    county_fips_all: '19175',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"19175": 100}',
    density: 147.9,
    imprecise: false,
    latitude: 41.03991,
    longitude: -94.4618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50842',
  },
  {
    city: 'Cumberland',
    county_fips: 19029,
    county_fips_all: '19029|19003',
    county: 'Cass',
    county_names_all: 'Cass|Adams',
    county_weights: '{"19029": 92.37, "19003": 7.63}',
    density: 2.9,
    imprecise: false,
    latitude: 41.24057,
    longitude: -94.88913,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50843',
  },
  {
    city: 'Diagonal',
    county_fips: 19159,
    county_fips_all: '19159|19175',
    county: 'Ringgold',
    county_names_all: 'Ringgold|Union',
    county_weights: '{"19159": 91.58, "19175": 8.42}',
    density: 2.9,
    imprecise: false,
    latitude: 40.81683,
    longitude: -94.3523,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50845',
  },
  {
    city: 'Fontanelle',
    county_fips: 19001,
    county_fips_all: '19001',
    county: 'Adair',
    county_names_all: 'Adair',
    county_weights: '{"19001": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 41.31081,
    longitude: -94.56839,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50846',
  },
  {
    city: 'Grant',
    county_fips: 19137,
    county_fips_all: '19137',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"19137": 100}',
    density: 59.3,
    imprecise: false,
    latitude: 41.14168,
    longitude: -94.98405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50847',
  },
  {
    city: 'Gravity',
    county_fips: 19173,
    county_fips_all: '19173',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"19173": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 40.78685,
    longitude: -94.76758,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50848',
  },
  {
    city: 'Greenfield',
    county_fips: 19001,
    county_fips_all: '19001',
    county: 'Adair',
    county_names_all: 'Adair',
    county_weights: '{"19001": 100}',
    density: 8,
    imprecise: false,
    latitude: 41.30004,
    longitude: -94.40176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50849',
  },
  {
    city: 'Lenox',
    county_fips: 19173,
    county_fips_all: '19173|19003|19175|19159',
    county: 'Taylor',
    county_names_all: 'Taylor|Adams|Union|Ringgold',
    county_weights:
      '{"19173": 44.12, "19003": 34.13, "19175": 17.35, "19159": 4.4}',
    density: 6.4,
    imprecise: false,
    latitude: 40.90327,
    longitude: -94.53637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50851',
  },
  {
    city: 'Massena',
    county_fips: 19029,
    county_fips_all: '19029|19003',
    county: 'Cass',
    county_names_all: 'Cass|Adams',
    county_weights: '{"19029": 98.09, "19003": 1.91}',
    density: 3.7,
    imprecise: false,
    latitude: 41.23869,
    longitude: -94.77455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50853',
  },
  {
    city: 'Mount Ayr',
    county_fips: 19159,
    county_fips_all: '19159',
    county: 'Ringgold',
    county_names_all: 'Ringgold',
    county_weights: '{"19159": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 40.69089,
    longitude: -94.21977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50854',
  },
  {
    city: 'Nodaway',
    county_fips: 19003,
    county_fips_all: '19003|19173|19137',
    county: 'Adams',
    county_names_all: 'Adams|Taylor|Montgomery',
    county_weights: '{"19003": 72.7, "19173": 25.89, "19137": 1.41}',
    density: 1.2,
    imprecise: false,
    latitude: 40.94045,
    longitude: -94.88011,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50857',
  },
  {
    city: 'Orient',
    county_fips: 19001,
    county_fips_all: '19001',
    county: 'Adair',
    county_names_all: 'Adair',
    county_weights: '{"19001": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 41.20961,
    longitude: -94.40902,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50858',
  },
  {
    city: 'Prescott',
    county_fips: 19003,
    county_fips_all: '19003|19001',
    county: 'Adams',
    county_names_all: 'Adams|Adair',
    county_weights: '{"19003": 95.38, "19001": 4.62}',
    density: 3.3,
    imprecise: false,
    latitude: 41.06505,
    longitude: -94.60027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50859',
  },
  {
    city: 'Redding',
    county_fips: 19159,
    county_fips_all: '19159',
    county: 'Ringgold',
    county_names_all: 'Ringgold',
    county_weights: '{"19159": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 40.62253,
    longitude: -94.34949,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50860',
  },
  {
    city: 'Shannon City',
    county_fips: 19175,
    county_fips_all: '19175|19159',
    county: 'Union',
    county_names_all: 'Union|Ringgold',
    county_weights: '{"19175": 68.69, "19159": 31.31}',
    density: 3,
    imprecise: false,
    latitude: 40.91163,
    longitude: -94.25685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50861',
  },
  {
    city: 'Sharpsburg',
    county_fips: 19173,
    county_fips_all: '19173',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"19173": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 40.81304,
    longitude: -94.65136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50862',
  },
  {
    city: 'Tingley',
    county_fips: 19159,
    county_fips_all: '19159',
    county: 'Ringgold',
    county_names_all: 'Ringgold',
    county_weights: '{"19159": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 40.84701,
    longitude: -94.17318,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50863',
  },
  {
    city: 'Villisca',
    county_fips: 19137,
    county_fips_all: '19137|19145|19173|19003|19029',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Page|Taylor|Adams|Cass',
    county_weights:
      '{"19137": 65.59, "19145": 19.82, "19173": 8.92, "19003": 3.95, "19029": 1.72}',
    density: 4.3,
    imprecise: false,
    latitude: 40.97648,
    longitude: -94.98009,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50864',
  },
  {
    city: 'Akron',
    county_fips: 19149,
    county_fips_all: '19149|46127',
    county: 'Plymouth',
    county_names_all: 'Plymouth|Union',
    county_weights: '{"19149": 60.2, "46127": 39.8}',
    density: 5.5,
    imprecise: false,
    latitude: 42.83854,
    longitude: -96.54551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51001',
  },
  {
    city: 'Alta',
    county_fips: 19021,
    county_fips_all: '19021|19035',
    county: 'Buena Vista',
    county_names_all: 'Buena Vista|Cherokee',
    county_weights: '{"19021": 98.62, "19035": 1.38}',
    density: 9.8,
    imprecise: false,
    latitude: 42.69859,
    longitude: -95.31863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51002',
  },
  {
    city: 'Alton',
    county_fips: 19167,
    county_fips_all: '19167',
    county: 'Sioux',
    county_names_all: 'Sioux',
    county_weights: '{"19167": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 42.98355,
    longitude: -95.98642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51003',
  },
  {
    city: 'Anthon',
    county_fips: 19193,
    county_fips_all: '19193',
    county: 'Woodbury',
    county_names_all: 'Woodbury',
    county_weights: '{"19193": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 42.3762,
    longitude: -95.916,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51004',
  },
  {
    city: 'Aurelia',
    county_fips: 19035,
    county_fips_all: '19035|19021',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Buena Vista',
    county_weights: '{"19035": 86.14, "19021": 13.86}',
    density: 6.4,
    imprecise: false,
    latitude: 42.72044,
    longitude: -95.42405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51005',
  },
  {
    city: 'Battle Creek',
    county_fips: 19093,
    county_fips_all: '19093|19193|19047',
    county: 'Ida',
    county_names_all: 'Ida|Woodbury|Crawford',
    county_weights: '{"19093": 85.87, "19193": 12.25, "19047": 1.88}',
    density: 6.3,
    imprecise: false,
    latitude: 42.31088,
    longitude: -95.61299,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51006',
  },
  {
    city: 'Bronson',
    county_fips: 19193,
    county_fips_all: '19193',
    county: 'Woodbury',
    county_names_all: 'Woodbury',
    county_weights: '{"19193": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 42.40225,
    longitude: -96.18857,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51007',
  },
  {
    city: 'Brunsville',
    county_fips: 19149,
    county_fips_all: '19149',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"19149": 100}',
    density: 287.7,
    imprecise: false,
    latitude: 42.81127,
    longitude: -96.26724,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51008',
  },
  {
    city: 'Calumet',
    county_fips: 19141,
    county_fips_all: '19141',
    county: "O'Brien",
    county_names_all: "O'Brien",
    county_weights: '{"19141": 100}',
    density: 163.8,
    imprecise: false,
    latitude: 42.94499,
    longitude: -95.55142,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51009',
  },
  {
    city: 'Castana',
    county_fips: 19133,
    county_fips_all: '19133',
    county: 'Monona',
    county_names_all: 'Monona',
    county_weights: '{"19133": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 42.09309,
    longitude: -95.92044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51010',
  },
  {
    city: 'Chatsworth',
    county_fips: 19167,
    county_fips_all: '19167',
    county: 'Sioux',
    county_names_all: 'Sioux',
    county_weights: '{"19167": 100}',
    density: 49.8,
    imprecise: false,
    latitude: 42.91562,
    longitude: -96.51388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51011',
  },
  {
    city: 'Cherokee',
    county_fips: 19035,
    county_fips_all: '19035',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"19035": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 42.74474,
    longitude: -95.56171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51012',
  },
  {
    city: 'Cleghorn',
    county_fips: 19035,
    county_fips_all: '19035',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"19035": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 42.78428,
    longitude: -95.71155,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51014',
  },
  {
    city: 'Climbing Hill',
    county_fips: 19193,
    county_fips_all: '19193',
    county: 'Woodbury',
    county_names_all: 'Woodbury',
    county_weights: '{"19193": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 42.33936,
    longitude: -96.08107,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51015',
  },
  {
    city: 'Correctionville',
    county_fips: 19193,
    county_fips_all: '19193|19093',
    county: 'Woodbury',
    county_names_all: 'Woodbury|Ida',
    county_weights: '{"19193": 90.5, "19093": 9.5}',
    density: 4,
    imprecise: false,
    latitude: 42.46907,
    longitude: -95.80113,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51016',
  },
  {
    city: 'Cushing',
    county_fips: 19093,
    county_fips_all: '19093|19193',
    county: 'Ida',
    county_names_all: 'Ida|Woodbury',
    county_weights: '{"19093": 56.28, "19193": 43.72}',
    density: 6.4,
    imprecise: false,
    latitude: 42.44884,
    longitude: -95.67814,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51018',
  },
  {
    city: 'Danbury',
    county_fips: 19193,
    county_fips_all: '19193|19093|19047|19133',
    county: 'Woodbury',
    county_names_all: 'Woodbury|Ida|Crawford|Monona',
    county_weights:
      '{"19193": 79.21, "19093": 11.76, "19047": 8.25, "19133": 0.78}',
    density: 1.9,
    imprecise: false,
    latitude: 42.2721,
    longitude: -95.72615,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51019',
  },
  {
    city: 'Galva',
    county_fips: 19093,
    county_fips_all: '19093|19161|19035|19021',
    county: 'Ida',
    county_names_all: 'Ida|Sac|Cherokee|Buena Vista',
    county_weights:
      '{"19093": 71.53, "19161": 12.83, "19035": 12.01, "19021": 3.63}',
    density: 4.3,
    imprecise: false,
    latitude: 42.51215,
    longitude: -95.41249,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51020',
  },
  {
    city: 'Granville',
    county_fips: 19141,
    county_fips_all: '19141|19167|19149',
    county: "O'Brien",
    county_names_all: "O'Brien|Sioux|Plymouth",
    county_weights: '{"19141": 58.0, "19167": 39.45, "19149": 2.55}',
    density: 4.9,
    imprecise: false,
    latitude: 42.97819,
    longitude: -95.84722,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51022',
  },
  {
    city: 'Hawarden',
    county_fips: 19167,
    county_fips_all: '19167|46127',
    county: 'Sioux',
    county_names_all: 'Sioux|Union',
    county_weights: '{"19167": 70.36, "46127": 29.64}',
    density: 11.2,
    imprecise: false,
    latitude: 43.00893,
    longitude: -96.46845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51023',
  },
  {
    city: 'Hinton',
    county_fips: 19149,
    county_fips_all: '19149',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"19149": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 42.6201,
    longitude: -96.26564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51024',
  },
  {
    city: 'Holstein',
    county_fips: 19093,
    county_fips_all: '19093|19035',
    county: 'Ida',
    county_names_all: 'Ida|Cherokee',
    county_weights: '{"19093": 87.34, "19035": 12.66}',
    density: 7,
    imprecise: false,
    latitude: 42.4973,
    longitude: -95.55853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51025',
  },
  {
    city: 'Hornick',
    county_fips: 19193,
    county_fips_all: '19193|19133',
    county: 'Woodbury',
    county_names_all: 'Woodbury|Monona',
    county_weights: '{"19193": 64.75, "19133": 35.25}',
    density: 3.2,
    imprecise: false,
    latitude: 42.24857,
    longitude: -96.07592,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51026',
  },
  {
    city: 'Ireton',
    county_fips: 19167,
    county_fips_all: '19167|19149',
    county: 'Sioux',
    county_names_all: 'Sioux|Plymouth',
    county_weights: '{"19167": 83.93, "19149": 16.07}',
    density: 5.5,
    imprecise: false,
    latitude: 42.96575,
    longitude: -96.32791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51027',
  },
  {
    city: 'Kingsley',
    county_fips: 19149,
    county_fips_all: '19149|19193',
    county: 'Plymouth',
    county_names_all: 'Plymouth|Woodbury',
    county_weights: '{"19149": 80.04, "19193": 19.96}',
    density: 6.8,
    imprecise: false,
    latitude: 42.59909,
    longitude: -95.99199,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51028',
  },
  {
    city: 'Larrabee',
    county_fips: 19035,
    county_fips_all: '19035|19141',
    county: 'Cherokee',
    county_names_all: "Cherokee|O'Brien",
    county_weights: '{"19035": 85.16, "19141": 14.84}',
    density: 3.7,
    imprecise: false,
    latitude: 42.88549,
    longitude: -95.5414,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51029',
  },
  {
    city: 'Lawton',
    county_fips: 19193,
    county_fips_all: '19193',
    county: 'Woodbury',
    county_names_all: 'Woodbury',
    county_weights: '{"19193": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 42.49791,
    longitude: -96.19365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51030',
  },
  {
    city: 'Le Mars',
    county_fips: 19149,
    county_fips_all: '19149|19167',
    county: 'Plymouth',
    county_names_all: 'Plymouth|Sioux',
    county_weights: '{"19149": 98.92, "19167": 1.08}',
    density: 21.1,
    imprecise: false,
    latitude: 42.80282,
    longitude: -96.18092,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51031',
  },
  {
    city: 'Linn Grove',
    county_fips: 19041,
    county_fips_all: '19041|19021',
    county: 'Clay',
    county_names_all: 'Clay|Buena Vista',
    county_weights: '{"19041": 50.11, "19021": 49.89}',
    density: 2.6,
    imprecise: false,
    latitude: 42.91653,
    longitude: -95.25324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51033',
  },
  {
    city: 'Mapleton',
    county_fips: 19133,
    county_fips_all: '19133|19193|19047',
    county: 'Monona',
    county_names_all: 'Monona|Woodbury|Crawford',
    county_weights: '{"19133": 80.43, "19193": 15.76, "19047": 3.81}',
    density: 5.5,
    imprecise: false,
    latitude: 42.16241,
    longitude: -95.78947,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51034',
  },
  {
    city: 'Marcus',
    county_fips: 19035,
    county_fips_all: '19035|19149',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Plymouth',
    county_weights: '{"19035": 99.04, "19149": 0.96}',
    density: 5.9,
    imprecise: false,
    latitude: 42.78086,
    longitude: -95.80054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51035',
  },
  {
    city: 'Maurice',
    county_fips: 19167,
    county_fips_all: '19167',
    county: 'Sioux',
    county_names_all: 'Sioux',
    county_weights: '{"19167": 100}',
    density: 4,
    imprecise: false,
    latitude: 42.97074,
    longitude: -96.18938,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51036',
  },
  {
    city: 'Meriden',
    county_fips: 19035,
    county_fips_all: '19035',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"19035": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 42.82567,
    longitude: -95.64269,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51037',
  },
  {
    city: 'Merrill',
    county_fips: 19149,
    county_fips_all: '19149',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"19149": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 42.7056,
    longitude: -96.31569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51038',
  },
  {
    city: 'Moville',
    county_fips: 19193,
    county_fips_all: '19193',
    county: 'Woodbury',
    county_names_all: 'Woodbury',
    county_weights: '{"19193": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 42.45655,
    longitude: -96.05381,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51039',
  },
  {
    city: 'Onawa',
    county_fips: 19133,
    county_fips_all: '19133',
    county: 'Monona',
    county_names_all: 'Monona',
    county_weights: '{"19133": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 42.03073,
    longitude: -96.0706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51040',
  },
  {
    city: 'Orange City',
    county_fips: 19167,
    county_fips_all: '19167',
    county: 'Sioux',
    county_names_all: 'Sioux',
    county_weights: '{"19167": 100}',
    density: 39.9,
    imprecise: false,
    latitude: 43.02443,
    longitude: -96.07701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51041',
  },
  {
    city: 'Oto',
    county_fips: 19193,
    county_fips_all: '19193',
    county: 'Woodbury',
    county_names_all: 'Woodbury',
    county_weights: '{"19193": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 42.30113,
    longitude: -95.91716,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51044',
  },
  {
    city: 'Oyens',
    county_fips: 19149,
    county_fips_all: '19149',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"19149": 100}',
    density: 385.6,
    imprecise: false,
    latitude: 42.82019,
    longitude: -96.05772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51045',
  },
  {
    city: 'Paullina',
    county_fips: 19141,
    county_fips_all: '19141|19035',
    county: "O'Brien",
    county_names_all: "O'Brien|Cherokee",
    county_weights: '{"19141": 94.6, "19035": 5.4}',
    density: 5.5,
    imprecise: false,
    latitude: 42.96621,
    longitude: -95.67949,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51046',
  },
  {
    city: 'Peterson',
    county_fips: 19041,
    county_fips_all: '19041|19021|19035|19141',
    county: 'Clay',
    county_names_all: "Clay|Buena Vista|Cherokee|O'Brien",
    county_weights:
      '{"19041": 55.15, "19021": 26.54, "19035": 13.25, "19141": 5.06}',
    density: 3.5,
    imprecise: false,
    latitude: 42.93523,
    longitude: -95.35752,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51047',
  },
  {
    city: 'Pierson',
    county_fips: 19193,
    county_fips_all: '19193|19035|19149',
    county: 'Woodbury',
    county_names_all: 'Woodbury|Cherokee|Plymouth',
    county_weights: '{"19193": 48.56, "19035": 40.09, "19149": 11.35}',
    density: 4.5,
    imprecise: false,
    latitude: 42.57963,
    longitude: -95.86412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51048',
  },
  {
    city: 'Quimby',
    county_fips: 19035,
    county_fips_all: '19035',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"19035": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 42.63005,
    longitude: -95.64463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51049',
  },
  {
    city: 'Remsen',
    county_fips: 19149,
    county_fips_all: '19149|19167',
    county: 'Plymouth',
    county_names_all: 'Plymouth|Sioux',
    county_weights: '{"19149": 98.55, "19167": 1.45}',
    density: 8.2,
    imprecise: false,
    latitude: 42.79545,
    longitude: -95.94772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51050',
  },
  {
    city: 'Rodney',
    county_fips: 19133,
    county_fips_all: '19133',
    county: 'Monona',
    county_names_all: 'Monona',
    county_weights: '{"19133": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 42.20443,
    longitude: -95.96988,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51051',
  },
  {
    city: 'Salix',
    county_fips: 19193,
    county_fips_all: '19193',
    county: 'Woodbury',
    county_names_all: 'Woodbury',
    county_weights: '{"19193": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 42.31063,
    longitude: -96.26343,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51052',
  },
  {
    city: 'Schaller',
    county_fips: 19161,
    county_fips_all: '19161|19093',
    county: 'Sac',
    county_names_all: 'Sac|Ida',
    county_weights: '{"19161": 89.26, "19093": 10.74}',
    density: 5.3,
    imprecise: false,
    latitude: 42.4938,
    longitude: -95.28842,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51053',
  },
  {
    city: 'Sergeant Bluff',
    county_fips: 19193,
    county_fips_all: '19193',
    county: 'Woodbury',
    county_names_all: 'Woodbury',
    county_weights: '{"19193": 100}',
    density: 55.7,
    imprecise: false,
    latitude: 42.37832,
    longitude: -96.33159,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51054',
  },
  {
    city: 'Sloan',
    county_fips: 19193,
    county_fips_all: '19193|19133',
    county: 'Woodbury',
    county_names_all: 'Woodbury|Monona',
    county_weights: '{"19193": 50.98, "19133": 49.02}',
    density: 8.3,
    imprecise: false,
    latitude: 42.21162,
    longitude: -96.26069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51055',
  },
  {
    city: 'Smithland',
    county_fips: 19193,
    county_fips_all: '19193|19133',
    county: 'Woodbury',
    county_names_all: 'Woodbury|Monona',
    county_weights: '{"19193": 85.24, "19133": 14.76}',
    density: 4,
    imprecise: false,
    latitude: 42.23443,
    longitude: -95.95391,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51056',
  },
  {
    city: 'Sutherland',
    county_fips: 19141,
    county_fips_all: '19141|19035|19041',
    county: "O'Brien",
    county_names_all: "O'Brien|Cherokee|Clay",
    county_weights: '{"19141": 92.62, "19035": 6.19, "19041": 1.19}',
    density: 4.9,
    imprecise: false,
    latitude: 42.98367,
    longitude: -95.46879,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51058',
  },
  {
    city: 'Ute',
    county_fips: 19133,
    county_fips_all: '19133|19047',
    county: 'Monona',
    county_names_all: 'Monona|Crawford',
    county_weights: '{"19133": 76.64, "19047": 23.36}',
    density: 4.6,
    imprecise: false,
    latitude: 42.04189,
    longitude: -95.69844,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51060',
  },
  {
    city: 'Washta',
    county_fips: 19035,
    county_fips_all: '19035|19093',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Ida',
    county_weights: '{"19035": 79.44, "19093": 20.56}',
    density: 3.1,
    imprecise: false,
    latitude: 42.57983,
    longitude: -95.72036,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51061',
  },
  {
    city: 'Westfield',
    county_fips: 19149,
    county_fips_all: '19149',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"19149": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 42.70623,
    longitude: -96.53511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51062',
  },
  {
    city: 'Whiting',
    county_fips: 19133,
    county_fips_all: '19133',
    county: 'Monona',
    county_names_all: 'Monona',
    county_weights: '{"19133": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 42.13103,
    longitude: -96.18611,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51063',
  },
  {
    city: 'Sioux City',
    county_fips: 19193,
    county_fips_all: '19193',
    county: 'Woodbury',
    county_names_all: 'Woodbury',
    county_weights: '{"19193": 100}',
    density: 330.8,
    imprecise: false,
    latitude: 42.49413,
    longitude: -96.39361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51101',
  },
  {
    city: 'Sioux City',
    county_fips: 19193,
    county_fips_all: '19193',
    county: 'Woodbury',
    county_names_all: 'Woodbury',
    county_weights: '{"19193": 100}',
    density: 540.7,
    imprecise: false,
    latitude: 42.52173,
    longitude: -96.44642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51103',
  },
  {
    city: 'Sioux City',
    county_fips: 19193,
    county_fips_all: '19193',
    county: 'Woodbury',
    county_names_all: 'Woodbury',
    county_weights: '{"19193": 100}',
    density: 1198.1,
    imprecise: false,
    latitude: 42.53518,
    longitude: -96.40389,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51104',
  },
  {
    city: 'Sioux City',
    county_fips: 19193,
    county_fips_all: '19193',
    county: 'Woodbury',
    county_names_all: 'Woodbury',
    county_weights: '{"19193": 100}',
    density: 675.6,
    imprecise: false,
    latitude: 42.50808,
    longitude: -96.3671,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51105',
  },
  {
    city: 'Sioux City',
    county_fips: 19193,
    county_fips_all: '19193',
    county: 'Woodbury',
    county_names_all: 'Woodbury',
    county_weights: '{"19193": 100}',
    density: 329.6,
    imprecise: false,
    latitude: 42.46292,
    longitude: -96.32,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51106',
  },
  {
    city: 'Sioux City',
    county_fips: 19149,
    county_fips_all: '19149|19193',
    county: 'Plymouth',
    county_names_all: 'Plymouth|Woodbury',
    county_weights: '{"19149": 53.25, "19193": 46.75}',
    density: 50,
    imprecise: false,
    latitude: 42.56625,
    longitude: -96.34858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51108',
  },
  {
    city: 'Sioux City',
    county_fips: 19149,
    county_fips_all: '19149|19193',
    county: 'Plymouth',
    county_names_all: 'Plymouth|Woodbury',
    county_weights: '{"19149": 88.97, "19193": 11.03}',
    density: 79.1,
    imprecise: false,
    latitude: 42.59873,
    longitude: -96.47804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51109',
  },
  {
    city: 'Sioux City',
    county_fips: 19193,
    county_fips_all: '19193',
    county: 'Woodbury',
    county_names_all: 'Woodbury',
    county_weights: '{"19193": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 42.41129,
    longitude: -96.38606,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51111',
  },
  {
    city: 'Sheldon',
    county_fips: 19167,
    county_fips_all: '19167|19141|19119',
    county: 'Sioux',
    county_names_all: "Sioux|O'Brien|Lyon",
    county_weights: '{"19167": 49.16, "19141": 48.64, "19119": 2.2}',
    density: 21.5,
    imprecise: false,
    latitude: 43.18331,
    longitude: -95.8657,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51201',
  },
  {
    city: 'Alvord',
    county_fips: 19119,
    county_fips_all: '19119',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"19119": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 43.3562,
    longitude: -96.32217,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51230',
  },
  {
    city: 'Archer',
    county_fips: 19141,
    county_fips_all: '19141',
    county: "O'Brien",
    county_names_all: "O'Brien",
    county_weights: '{"19141": 100}',
    density: 9,
    imprecise: false,
    latitude: 43.10567,
    longitude: -95.74131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51231',
  },
  {
    city: 'Ashton',
    county_fips: 19143,
    county_fips_all: '19143|19119|19141',
    county: 'Osceola',
    county_names_all: "Osceola|Lyon|O'Brien",
    county_weights: '{"19143": 72.73, "19119": 25.68, "19141": 1.59}',
    density: 4.2,
    imprecise: false,
    latitude: 43.30097,
    longitude: -95.8162,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51232',
  },
  {
    city: 'Boyden',
    county_fips: 19167,
    county_fips_all: '19167',
    county: 'Sioux',
    county_names_all: 'Sioux',
    county_weights: '{"19167": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 43.19412,
    longitude: -96.01992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51234',
  },
  {
    city: 'Doon',
    county_fips: 19119,
    county_fips_all: '19119|19167',
    county: 'Lyon',
    county_names_all: 'Lyon|Sioux',
    county_weights: '{"19119": 96.88, "19167": 3.12}',
    density: 7.3,
    imprecise: false,
    latitude: 43.29488,
    longitude: -96.21531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51235',
  },
  {
    city: 'George',
    county_fips: 19119,
    county_fips_all: '19119',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"19119": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 43.33885,
    longitude: -96.0005,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51237',
  },
  {
    city: 'Hospers',
    county_fips: 19167,
    county_fips_all: '19167|19141',
    county: 'Sioux',
    county_names_all: "Sioux|O'Brien",
    county_weights: '{"19167": 67.68, "19141": 32.32}',
    density: 11.8,
    imprecise: false,
    latitude: 43.0758,
    longitude: -95.89071,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51238',
  },
  {
    city: 'Hull',
    county_fips: 19167,
    county_fips_all: '19167|19119',
    county: 'Sioux',
    county_names_all: 'Sioux|Lyon',
    county_weights: '{"19167": 92.69, "19119": 7.31}',
    density: 16.6,
    imprecise: false,
    latitude: 43.20238,
    longitude: -96.14522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51239',
  },
  {
    city: 'Inwood',
    county_fips: 19119,
    county_fips_all: '19119|19167',
    county: 'Lyon',
    county_names_all: 'Lyon|Sioux',
    county_weights: '{"19119": 85.42, "19167": 14.58}',
    density: 7.4,
    imprecise: false,
    latitude: 43.30986,
    longitude: -96.45727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51240',
  },
  {
    city: 'Larchwood',
    county_fips: 19119,
    county_fips_all: '19119',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"19119": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 43.44992,
    longitude: -96.46001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51241',
  },
  {
    city: 'Lester',
    county_fips: 19119,
    county_fips_all: '19119',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"19119": 100}',
    density: 26.9,
    imprecise: false,
    latitude: 43.43227,
    longitude: -96.33806,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51242',
  },
  {
    city: 'Little Rock',
    county_fips: 19119,
    county_fips_all: '19119|19143',
    county: 'Lyon',
    county_names_all: 'Lyon|Osceola',
    county_weights: '{"19119": 85.94, "19143": 14.06}',
    density: 5.4,
    imprecise: false,
    latitude: 43.4425,
    longitude: -95.90287,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51243',
  },
  {
    city: 'Matlock',
    county_fips: 19167,
    county_fips_all: '19167',
    county: 'Sioux',
    county_names_all: 'Sioux',
    county_weights: '{"19167": 100}',
    density: 147,
    imprecise: false,
    latitude: 43.2443,
    longitude: -95.93436,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51244',
  },
  {
    city: 'Primghar',
    county_fips: 19141,
    county_fips_all: '19141',
    county: "O'Brien",
    county_names_all: "O'Brien",
    county_weights: '{"19141": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 43.07788,
    longitude: -95.60149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51245',
  },
  {
    city: 'Rock Rapids',
    county_fips: 19119,
    county_fips_all: '19119',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"19119": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 43.42764,
    longitude: -96.16564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51246',
  },
  {
    city: 'Rock Valley',
    county_fips: 19167,
    county_fips_all: '19167|19119',
    county: 'Sioux',
    county_names_all: 'Sioux|Lyon',
    county_weights: '{"19167": 95.46, "19119": 4.54}',
    density: 17.5,
    imprecise: false,
    latitude: 43.19259,
    longitude: -96.33723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51247',
  },
  {
    city: 'Sanborn',
    county_fips: 19141,
    county_fips_all: '19141|19143',
    county: "O'Brien",
    county_names_all: "O'Brien|Osceola",
    county_weights: '{"19141": 89.83, "19143": 10.17}',
    density: 7.5,
    imprecise: false,
    latitude: 43.20445,
    longitude: -95.65911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51248',
  },
  {
    city: 'Sibley',
    county_fips: 19143,
    county_fips_all: '19143',
    county: 'Osceola',
    county_names_all: 'Osceola',
    county_weights: '{"19143": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 43.41068,
    longitude: -95.73203,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51249',
  },
  {
    city: 'Sioux Center',
    county_fips: 19167,
    county_fips_all: '19167',
    county: 'Sioux',
    county_names_all: 'Sioux',
    county_weights: '{"19167": 100}',
    density: 52.5,
    imprecise: false,
    latitude: 43.08437,
    longitude: -96.21232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51250',
  },
  {
    city: 'Spencer',
    county_fips: 19041,
    county_fips_all: '19041',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"19041": 100}',
    density: 30.9,
    imprecise: false,
    latitude: 43.15314,
    longitude: -95.14973,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51301',
  },
  {
    city: 'Arnolds Park',
    county_fips: 19059,
    county_fips_all: '19059',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"19059": 100}',
    density: 225,
    imprecise: false,
    latitude: 43.36431,
    longitude: -95.13028,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51331',
  },
  {
    city: 'Dickens',
    county_fips: 19041,
    county_fips_all: '19041',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"19041": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 43.1324,
    longitude: -95.00437,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51333',
  },
  {
    city: 'Estherville',
    county_fips: 19063,
    county_fips_all: '19063|19059',
    county: 'Emmet',
    county_names_all: 'Emmet|Dickinson',
    county_weights: '{"19063": 89.04, "19059": 10.96}',
    density: 14.4,
    imprecise: false,
    latitude: 43.40379,
    longitude: -94.80698,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51334',
  },
  {
    city: 'Everly',
    county_fips: 19041,
    county_fips_all: '19041|19059',
    county: 'Clay',
    county_names_all: 'Clay|Dickinson',
    county_weights: '{"19041": 79.17, "19059": 20.83}',
    density: 4.5,
    imprecise: false,
    latitude: 43.2065,
    longitude: -95.32378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51338',
  },
  {
    city: 'Fostoria',
    county_fips: 19041,
    county_fips_all: '19041',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"19041": 100}',
    density: 242.1,
    imprecise: false,
    latitude: 43.2404,
    longitude: -95.15613,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 75,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51340',
  },
  {
    city: 'Gillett Grove',
    county_fips: 19041,
    county_fips_all: '19041',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"19041": 100}',
    density: 45.3,
    imprecise: false,
    latitude: 43.01665,
    longitude: -95.04132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51341',
  },
  {
    city: 'Graettinger',
    county_fips: 19147,
    county_fips_all: '19147|19063',
    county: 'Palo Alto',
    county_names_all: 'Palo Alto|Emmet',
    county_weights: '{"19147": 65.97, "19063": 34.03}',
    density: 6.7,
    imprecise: false,
    latitude: 43.24359,
    longitude: -94.73832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51342',
  },
  {
    city: 'Greenville',
    county_fips: 19041,
    county_fips_all: '19041',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"19041": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 43.01804,
    longitude: -95.11445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51343',
  },
  {
    city: 'Harris',
    county_fips: 19143,
    county_fips_all: '19143|19059',
    county: 'Osceola',
    county_names_all: 'Osceola|Dickinson',
    county_weights: '{"19143": 97.27, "19059": 2.73}',
    density: 2.3,
    imprecise: false,
    latitude: 43.4181,
    longitude: -95.43209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51345',
  },
  {
    city: 'Hartley',
    county_fips: 19141,
    county_fips_all: '19141|19143|19041',
    county: "O'Brien",
    county_names_all: "O'Brien|Osceola|Clay",
    county_weights: '{"19141": 71.4, "19143": 20.41, "19041": 8.19}',
    density: 5.9,
    imprecise: false,
    latitude: 43.18638,
    longitude: -95.45927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51346',
  },
  {
    city: 'Lake Park',
    county_fips: 19059,
    county_fips_all: '19059',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"19059": 100}',
    density: 7,
    imprecise: false,
    latitude: 43.42547,
    longitude: -95.31363,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51347',
  },
  {
    city: 'Melvin',
    county_fips: 19143,
    county_fips_all: '19143|19141',
    county: 'Osceola',
    county_names_all: "Osceola|O'Brien",
    county_weights: '{"19143": 93.4, "19141": 6.6}',
    density: 3.3,
    imprecise: false,
    latitude: 43.30752,
    longitude: -95.59827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51350',
  },
  {
    city: 'Milford',
    county_fips: 19059,
    county_fips_all: '19059',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"19059": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 43.31656,
    longitude: -95.18626,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51351',
  },
  {
    city: 'Ocheyedan',
    county_fips: 19143,
    county_fips_all: '19143',
    county: 'Osceola',
    county_names_all: 'Osceola',
    county_weights: '{"19143": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 43.41267,
    longitude: -95.54352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51354',
  },
  {
    city: 'Okoboji',
    county_fips: 19059,
    county_fips_all: '19059',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"19059": 100}',
    density: 159.3,
    imprecise: false,
    latitude: 43.38996,
    longitude: -95.14082,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51355',
  },
  {
    city: 'Royal',
    county_fips: 19041,
    county_fips_all: '19041',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"19041": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 43.06215,
    longitude: -95.28762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51357',
  },
  {
    city: 'Ruthven',
    county_fips: 19147,
    county_fips_all: '19147|19041',
    county: 'Palo Alto',
    county_names_all: 'Palo Alto|Clay',
    county_weights: '{"19147": 63.28, "19041": 36.72}',
    density: 5.8,
    imprecise: false,
    latitude: 43.13033,
    longitude: -94.89579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51358',
  },
  {
    city: 'Spirit Lake',
    county_fips: 19059,
    county_fips_all: '19059|27063',
    county: 'Dickinson',
    county_names_all: 'Dickinson|Jackson',
    county_weights: '{"19059": 97.22, "27063": 2.78}',
    density: 31.8,
    imprecise: false,
    latitude: 43.43626,
    longitude: -95.08556,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51360',
  },
  {
    city: 'Superior',
    county_fips: 19059,
    county_fips_all: '19059',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"19059": 100}',
    density: 101,
    imprecise: false,
    latitude: 43.43363,
    longitude: -94.94678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51363',
  },
  {
    city: 'Terril',
    county_fips: 19059,
    county_fips_all: '19059|19041|19063',
    county: 'Dickinson',
    county_names_all: 'Dickinson|Clay|Emmet',
    county_weights: '{"19059": 75.68, "19041": 12.83, "19063": 11.49}',
    density: 4.9,
    imprecise: false,
    latitude: 43.2993,
    longitude: -94.96293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51364',
  },
  {
    city: 'Wallingford',
    county_fips: 19063,
    county_fips_all: '19063',
    county: 'Emmet',
    county_names_all: 'Emmet',
    county_weights: '{"19063": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 43.30652,
    longitude: -94.7349,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51365',
  },
  {
    city: 'Webb',
    county_fips: 19041,
    county_fips_all: '19041|19021',
    county: 'Clay',
    county_names_all: 'Clay|Buena Vista',
    county_weights: '{"19041": 97.28, "19021": 2.72}',
    density: 1.5,
    imprecise: false,
    latitude: 42.96008,
    longitude: -95.0095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51366',
  },
  {
    city: 'Carroll',
    county_fips: 19027,
    county_fips_all: '19027',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"19027": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 42.06516,
    longitude: -94.87068,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51401',
  },
  {
    city: 'Arcadia',
    county_fips: 19027,
    county_fips_all: '19027',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"19027": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 42.0869,
    longitude: -95.02633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51430',
  },
  {
    city: 'Arthur',
    county_fips: 19093,
    county_fips_all: '19093|19161',
    county: 'Ida',
    county_names_all: 'Ida|Sac',
    county_weights: '{"19093": 89.04, "19161": 10.96}',
    density: 4.4,
    imprecise: false,
    latitude: 42.34446,
    longitude: -95.35146,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51431',
  },
  {
    city: 'Auburn',
    county_fips: 19161,
    county_fips_all: '19161|19025',
    county: 'Sac',
    county_names_all: 'Sac|Calhoun',
    county_weights: '{"19161": 58.33, "19025": 41.67}',
    density: 3.9,
    imprecise: false,
    latitude: 42.27635,
    longitude: -94.87057,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51433',
  },
  {
    city: 'Breda',
    county_fips: 19027,
    county_fips_all: '19027|19047|19161',
    county: 'Carroll',
    county_names_all: 'Carroll|Crawford|Sac',
    county_weights: '{"19027": 68.48, "19047": 18.37, "19161": 13.15}',
    density: 5.2,
    imprecise: false,
    latitude: 42.18254,
    longitude: -95.01247,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51436',
  },
  {
    city: 'Charter Oak',
    county_fips: 19047,
    county_fips_all: '19047',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"19047": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 42.08298,
    longitude: -95.58347,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51439',
  },
  {
    city: 'Dedham',
    county_fips: 19027,
    county_fips_all: '19027',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"19027": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 41.9117,
    longitude: -94.81379,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51440',
  },
  {
    city: 'Deloit',
    county_fips: 19047,
    county_fips_all: '19047',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"19047": 100}',
    density: 9,
    imprecise: false,
    latitude: 42.11784,
    longitude: -95.3157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51441',
  },
  {
    city: 'Denison',
    county_fips: 19047,
    county_fips_all: '19047',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"19047": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 42.02696,
    longitude: -95.35915,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51442',
  },
  {
    city: 'Glidden',
    county_fips: 19027,
    county_fips_all: '19027',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"19027": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 42.07748,
    longitude: -94.70517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51443',
  },
  {
    city: 'Halbur',
    county_fips: 19027,
    county_fips_all: '19027',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"19027": 100}',
    density: 80.8,
    imprecise: false,
    latitude: 42.01228,
    longitude: -94.97352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51444',
  },
  {
    city: 'Ida Grove',
    county_fips: 19093,
    county_fips_all: '19093',
    county: 'Ida',
    county_names_all: 'Ida',
    county_weights: '{"19093": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 42.32719,
    longitude: -95.46724,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51445',
  },
  {
    city: 'Irwin',
    county_fips: 19165,
    county_fips_all: '19165',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"19165": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 41.77663,
    longitude: -95.19277,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51446',
  },
  {
    city: 'Kirkman',
    county_fips: 19165,
    county_fips_all: '19165',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"19165": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 41.72101,
    longitude: -95.19196,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51447',
  },
  {
    city: 'Kiron',
    county_fips: 19047,
    county_fips_all: '19047|19161|19093',
    county: 'Crawford',
    county_names_all: 'Crawford|Sac|Ida',
    county_weights: '{"19047": 61.6, "19161": 19.95, "19093": 18.45}',
    density: 4.1,
    imprecise: false,
    latitude: 42.20238,
    longitude: -95.30839,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51448',
  },
  {
    city: 'Lake City',
    county_fips: 19025,
    county_fips_all: '19025|19027',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Carroll',
    county_weights: '{"19025": 87.71, "19027": 12.29}',
    density: 8.4,
    imprecise: false,
    latitude: 42.26614,
    longitude: -94.73475,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51449',
  },
  {
    city: 'Lake View',
    county_fips: 19161,
    county_fips_all: '19161',
    county: 'Sac',
    county_names_all: 'Sac',
    county_weights: '{"19161": 100}',
    density: 11,
    imprecise: false,
    latitude: 42.31205,
    longitude: -95.02722,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51450',
  },
  {
    city: 'Lanesboro',
    county_fips: 19027,
    county_fips_all: '19027',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"19027": 100}',
    density: 75.9,
    imprecise: false,
    latitude: 42.1846,
    longitude: -94.69471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51451',
  },
  {
    city: 'Lidderdale',
    county_fips: 19027,
    county_fips_all: '19027',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"19027": 100}',
    density: 28.3,
    imprecise: false,
    latitude: 42.12242,
    longitude: -94.78366,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51452',
  },
  {
    city: 'Lohrville',
    county_fips: 19025,
    county_fips_all: '19025|19027|19073',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Carroll|Greene',
    county_weights: '{"19025": 90.63, "19027": 8.15, "19073": 1.22}',
    density: 2.5,
    imprecise: false,
    latitude: 42.26366,
    longitude: -94.55155,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51453',
  },
  {
    city: 'Manilla',
    county_fips: 19047,
    county_fips_all: '19047|19165',
    county: 'Crawford',
    county_names_all: 'Crawford|Shelby',
    county_weights: '{"19047": 57.58, "19165": 42.42}',
    density: 5,
    imprecise: false,
    latitude: 41.8798,
    longitude: -95.2072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51454',
  },
  {
    city: 'Manning',
    county_fips: 19027,
    county_fips_all: '19027|19047|19009|19165',
    county: 'Carroll',
    county_names_all: 'Carroll|Crawford|Audubon|Shelby',
    county_weights:
      '{"19027": 55.78, "19047": 23.48, "19009": 18.23, "19165": 2.51}',
    density: 7.8,
    imprecise: false,
    latitude: 41.90829,
    longitude: -95.0559,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51455',
  },
  {
    city: 'Odebolt',
    county_fips: 19161,
    county_fips_all: '19161',
    county: 'Sac',
    county_names_all: 'Sac',
    county_weights: '{"19161": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 42.32141,
    longitude: -95.23524,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51458',
  },
  {
    city: 'Ralston',
    county_fips: 19027,
    county_fips_all: '19027',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"19027": 100}',
    density: 37.7,
    imprecise: false,
    latitude: 42.04495,
    longitude: -94.63779,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51459',
  },
  {
    city: 'Ricketts',
    county_fips: 19047,
    county_fips_all: '19047',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"19047": 100}',
    density: 40.6,
    imprecise: false,
    latitude: 42.1324,
    longitude: -95.571,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51460',
  },
  {
    city: 'Schleswig',
    county_fips: 19047,
    county_fips_all: '19047|19093',
    county: 'Crawford',
    county_names_all: 'Crawford|Ida',
    county_weights: '{"19047": 92.71, "19093": 7.29}',
    density: 7.8,
    imprecise: false,
    latitude: 42.172,
    longitude: -95.47579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51461',
  },
  {
    city: 'Scranton',
    county_fips: 19073,
    county_fips_all: '19073|19027',
    county: 'Greene',
    county_names_all: 'Greene|Carroll',
    county_weights: '{"19073": 97.41, "19027": 2.59}',
    density: 3.5,
    imprecise: false,
    latitude: 42.01319,
    longitude: -94.55744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51462',
  },
  {
    city: 'Templeton',
    county_fips: 19027,
    county_fips_all: '19027',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"19027": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 41.90743,
    longitude: -94.91265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51463',
  },
  {
    city: 'Vail',
    county_fips: 19047,
    county_fips_all: '19047',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"19047": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 42.08964,
    longitude: -95.19872,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51465',
  },
  {
    city: 'Wall Lake',
    county_fips: 19161,
    county_fips_all: '19161|19047',
    county: 'Sac',
    county_names_all: 'Sac|Crawford',
    county_weights: '{"19161": 98.59, "19047": 1.41}',
    density: 7.7,
    imprecise: false,
    latitude: 42.25302,
    longitude: -95.09837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51466',
  },
  {
    city: 'Westside',
    county_fips: 19047,
    county_fips_all: '19047|19027',
    county: 'Crawford',
    county_names_all: 'Crawford|Carroll',
    county_weights: '{"19047": 70.01, "19027": 29.99}',
    density: 4,
    imprecise: false,
    latitude: 42.07377,
    longitude: -95.10919,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51467',
  },
  {
    city: 'Council Bluffs',
    county_fips: 19155,
    county_fips_all: '19155',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie',
    county_weights: '{"19155": 100}',
    density: 558.2,
    imprecise: false,
    latitude: 41.22828,
    longitude: -95.87889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51501',
  },
  {
    city: 'Council Bluffs',
    county_fips: 19155,
    county_fips_all: '19155|19129',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie|Mills',
    county_weights: '{"19155": 84.5, "19129": 15.5}',
    density: 120.5,
    imprecise: false,
    latitude: 41.2304,
    longitude: -95.77795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51503',
  },
  {
    city: 'Carter Lake',
    county_fips: 19155,
    county_fips_all: '19155',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie',
    county_weights: '{"19155": 100}',
    density: 810.5,
    imprecise: false,
    latitude: 41.28844,
    longitude: -95.91715,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51510',
  },
  {
    city: 'Arion',
    county_fips: 19047,
    county_fips_all: '19047',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"19047": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 41.9692,
    longitude: -95.4593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51520',
  },
  {
    city: 'Avoca',
    county_fips: 19155,
    county_fips_all: '19155|19165',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie|Shelby',
    county_weights: '{"19155": 69.12, "19165": 30.88}',
    density: 8.6,
    imprecise: false,
    latitude: 41.47987,
    longitude: -95.34526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51521',
  },
  {
    city: 'Blencoe',
    county_fips: 19133,
    county_fips_all: '19133|19085',
    county: 'Monona',
    county_names_all: 'Monona|Harrison',
    county_weights: '{"19133": 91.85, "19085": 8.15}',
    density: 2.9,
    imprecise: false,
    latitude: 41.9122,
    longitude: -96.07172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51523',
  },
  {
    city: 'Carson',
    county_fips: 19155,
    county_fips_all: '19155',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie',
    county_weights: '{"19155": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 41.23443,
    longitude: -95.41999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51525',
  },
  {
    city: 'Crescent',
    county_fips: 19155,
    county_fips_all: '19155',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie',
    county_weights: '{"19155": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 41.37186,
    longitude: -95.87818,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51526',
  },
  {
    city: 'Defiance',
    county_fips: 19165,
    county_fips_all: '19165|19047',
    county: 'Shelby',
    county_names_all: 'Shelby|Crawford',
    county_weights: '{"19165": 83.27, "19047": 16.73}',
    density: 3.3,
    imprecise: false,
    latitude: 41.82875,
    longitude: -95.348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51527',
  },
  {
    city: 'Dow City',
    county_fips: 19047,
    county_fips_all: '19047',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"19047": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 41.92724,
    longitude: -95.50185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51528',
  },
  {
    city: 'Dunlap',
    county_fips: 19085,
    county_fips_all: '19085|19047|19133|19165',
    county: 'Harrison',
    county_names_all: 'Harrison|Crawford|Monona|Shelby',
    county_weights:
      '{"19085": 38.22, "19047": 28.13, "19133": 18.18, "19165": 15.47}',
    density: 5.1,
    imprecise: false,
    latitude: 41.8618,
    longitude: -95.62591,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51529',
  },
  {
    city: 'Earling',
    county_fips: 19165,
    county_fips_all: '19165',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"19165": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 41.78247,
    longitude: -95.42613,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51530',
  },
  {
    city: 'Elk Horn',
    county_fips: 19165,
    county_fips_all: '19165|19009',
    county: 'Shelby',
    county_names_all: 'Shelby|Audubon',
    county_weights: '{"19165": 78.56, "19009": 21.44}',
    density: 12.6,
    imprecise: false,
    latitude: 41.58751,
    longitude: -95.08837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51531',
  },
  {
    city: 'Elliott',
    county_fips: 19137,
    county_fips_all: '19137|19155|19029',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Pottawattamie|Cass',
    county_weights: '{"19137": 86.23, "19155": 10.9, "19029": 2.87}',
    density: 4.2,
    imprecise: false,
    latitude: 41.13408,
    longitude: -95.11167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51532',
  },
  {
    city: 'Emerson',
    county_fips: 19137,
    county_fips_all: '19137|19129',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Mills',
    county_weights: '{"19137": 54.78, "19129": 45.22}',
    density: 4.1,
    imprecise: false,
    latitude: 41.03606,
    longitude: -95.37933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51533',
  },
  {
    city: 'Glenwood',
    county_fips: 19129,
    county_fips_all: '19129',
    county: 'Mills',
    county_names_all: 'Mills',
    county_weights: '{"19129": 100}',
    density: 34.1,
    imprecise: false,
    latitude: 41.04092,
    longitude: -95.71853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51534',
  },
  {
    city: 'Griswold',
    county_fips: 19029,
    county_fips_all: '19029|19155',
    county: 'Cass',
    county_names_all: 'Cass|Pottawattamie',
    county_weights: '{"19029": 56.48, "19155": 43.52}',
    density: 4.8,
    imprecise: false,
    latitude: 41.2264,
    longitude: -95.13241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51535',
  },
  {
    city: 'Hancock',
    county_fips: 19155,
    county_fips_all: '19155',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie',
    county_weights: '{"19155": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 41.38385,
    longitude: -95.36025,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51536',
  },
  {
    city: 'Harlan',
    county_fips: 19165,
    county_fips_all: '19165',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"19165": 100}',
    density: 15,
    imprecise: false,
    latitude: 41.64646,
    longitude: -95.29531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51537',
  },
  {
    city: 'Hastings',
    county_fips: 19129,
    county_fips_all: '19129',
    county: 'Mills',
    county_names_all: 'Mills',
    county_weights: '{"19129": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 41.02488,
    longitude: -95.49802,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51540',
  },
  {
    city: 'Henderson',
    county_fips: 19129,
    county_fips_all: '19129|19137|19155',
    county: 'Mills',
    county_names_all: 'Mills|Montgomery|Pottawattamie',
    county_weights: '{"19129": 71.0, "19137": 15.86, "19155": 13.14}',
    density: 2.5,
    imprecise: false,
    latitude: 41.13664,
    longitude: -95.41623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51541',
  },
  {
    city: 'Honey Creek',
    county_fips: 19155,
    county_fips_all: '19155',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie',
    county_weights: '{"19155": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 41.43354,
    longitude: -95.84072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51542',
  },
  {
    city: 'Kimballton',
    county_fips: 19009,
    county_fips_all: '19009|19165',
    county: 'Audubon',
    county_names_all: 'Audubon|Shelby',
    county_weights: '{"19009": 69.77, "19165": 30.23}',
    density: 8.4,
    imprecise: false,
    latitude: 41.65792,
    longitude: -95.07317,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51543',
  },
  {
    city: 'Lewis',
    county_fips: 19029,
    county_fips_all: '19029|19155',
    county: 'Cass',
    county_names_all: 'Cass|Pottawattamie',
    county_weights: '{"19029": 73.98, "19155": 26.02}',
    density: 6.2,
    imprecise: false,
    latitude: 41.31316,
    longitude: -95.10817,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51544',
  },
  {
    city: 'Little Sioux',
    county_fips: 19085,
    county_fips_all: '19085|19133',
    county: 'Harrison',
    county_names_all: 'Harrison|Monona',
    county_weights: '{"19085": 72.66, "19133": 27.34}',
    density: 2.2,
    imprecise: false,
    latitude: 41.83897,
    longitude: -96.02072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51545',
  },
  {
    city: 'Logan',
    county_fips: 19085,
    county_fips_all: '19085',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"19085": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 41.6399,
    longitude: -95.77209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51546',
  },
  {
    city: 'McClelland',
    county_fips: 19155,
    county_fips_all: '19155',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie',
    county_weights: '{"19155": 100}',
    density: 6,
    imprecise: false,
    latitude: 41.31713,
    longitude: -95.63553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51548',
  },
  {
    city: 'Macedonia',
    county_fips: 19155,
    county_fips_all: '19155',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie',
    county_weights: '{"19155": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 41.18253,
    longitude: -95.45445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51549',
  },
  {
    city: 'Malvern',
    county_fips: 19129,
    county_fips_all: '19129',
    county: 'Mills',
    county_names_all: 'Mills',
    county_weights: '{"19129": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 40.99129,
    longitude: -95.58907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51551',
  },
  {
    city: 'Marne',
    county_fips: 19029,
    county_fips_all: '19029|19165',
    county: 'Cass',
    county_names_all: 'Cass|Shelby',
    county_weights: '{"19029": 63.11, "19165": 36.89}',
    density: 2.2,
    imprecise: false,
    latitude: 41.48613,
    longitude: -95.11439,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51552',
  },
  {
    city: 'Minden',
    county_fips: 19155,
    county_fips_all: '19155',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie',
    county_weights: '{"19155": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 41.41577,
    longitude: -95.54638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51553',
  },
  {
    city: 'Mineola',
    county_fips: 19129,
    county_fips_all: '19129',
    county: 'Mills',
    county_names_all: 'Mills',
    county_weights: '{"19129": 100}',
    density: 22.6,
    imprecise: false,
    latitude: 41.14512,
    longitude: -95.68122,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51554',
  },
  {
    city: 'Missouri Valley',
    county_fips: 19085,
    county_fips_all: '19085|19155',
    county: 'Harrison',
    county_names_all: 'Harrison|Pottawattamie',
    county_weights: '{"19085": 81.15, "19155": 18.85}',
    density: 13.1,
    imprecise: false,
    latitude: 41.55937,
    longitude: -95.91398,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51555',
  },
  {
    city: 'Modale',
    county_fips: 19085,
    county_fips_all: '19085',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"19085": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 41.63548,
    longitude: -96.04198,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51556',
  },
  {
    city: 'Mondamin',
    county_fips: 19085,
    county_fips_all: '19085|31021',
    county: 'Harrison',
    county_names_all: 'Harrison|Burt',
    county_weights: '{"19085": 89.2, "31021": 10.8}',
    density: 4.2,
    imprecise: false,
    latitude: 41.72903,
    longitude: -96.00233,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51557',
  },
  {
    city: 'Moorhead',
    county_fips: 19133,
    county_fips_all: '19133|19085',
    county: 'Monona',
    county_names_all: 'Monona|Harrison',
    county_weights: '{"19133": 90.83, "19085": 9.17}',
    density: 2.5,
    imprecise: false,
    latitude: 41.91497,
    longitude: -95.87023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51558',
  },
  {
    city: 'Neola',
    county_fips: 19155,
    county_fips_all: '19155|19085',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie|Harrison',
    county_weights: '{"19155": 84.04, "19085": 15.96}',
    density: 8.3,
    imprecise: false,
    latitude: 41.46034,
    longitude: -95.66049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51559',
  },
  {
    city: 'Oakland',
    county_fips: 19155,
    county_fips_all: '19155',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie',
    county_weights: '{"19155": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 41.31746,
    longitude: -95.39838,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51560',
  },
  {
    city: 'Pacific Junction',
    county_fips: 19129,
    county_fips_all: '19129',
    county: 'Mills',
    county_names_all: 'Mills',
    county_weights: '{"19129": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 41.00571,
    longitude: -95.80992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51561',
  },
  {
    city: 'Panama',
    county_fips: 19165,
    county_fips_all: '19165',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"19165": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 41.72591,
    longitude: -95.50128,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51562',
  },
  {
    city: 'Persia',
    county_fips: 19085,
    county_fips_all: '19085|19165',
    county: 'Harrison',
    county_names_all: 'Harrison|Shelby',
    county_weights: '{"19085": 99.73, "19165": 0.27}',
    density: 4.5,
    imprecise: false,
    latitude: 41.5769,
    longitude: -95.59405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51563',
  },
  {
    city: 'Pisgah',
    county_fips: 19085,
    county_fips_all: '19085',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"19085": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 41.81309,
    longitude: -95.90801,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51564',
  },
  {
    city: 'Portsmouth',
    county_fips: 19165,
    county_fips_all: '19165|19085',
    county: 'Shelby',
    county_names_all: 'Shelby|Harrison',
    county_weights: '{"19165": 74.05, "19085": 25.95}',
    density: 4.4,
    imprecise: false,
    latitude: 41.64555,
    longitude: -95.52391,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51565',
  },
  {
    city: 'Red Oak',
    county_fips: 19137,
    county_fips_all: '19137|19145|19155',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Page|Pottawattamie',
    county_weights: '{"19137": 91.46, "19145": 6.58, "19155": 1.96}',
    density: 15.3,
    imprecise: false,
    latitude: 41.0151,
    longitude: -95.22994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51566',
  },
  {
    city: 'Shelby',
    county_fips: 19165,
    county_fips_all: '19165|19155|19085',
    county: 'Shelby',
    county_names_all: 'Shelby|Pottawattamie|Harrison',
    county_weights: '{"19165": 53.41, "19155": 32.91, "19085": 13.68}',
    density: 6.8,
    imprecise: false,
    latitude: 41.52271,
    longitude: -95.46039,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51570',
  },
  {
    city: 'Silver City',
    county_fips: 19129,
    county_fips_all: '19129|19155',
    county: 'Mills',
    county_names_all: 'Mills|Pottawattamie',
    county_weights: '{"19129": 66.05, "19155": 33.95}',
    density: 7.6,
    imprecise: false,
    latitude: 41.14582,
    longitude: -95.60994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51571',
  },
  {
    city: 'Soldier',
    county_fips: 19133,
    county_fips_all: '19133',
    county: 'Monona',
    county_names_all: 'Monona',
    county_weights: '{"19133": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 41.9896,
    longitude: -95.79053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51572',
  },
  {
    city: 'Stanton',
    county_fips: 19137,
    county_fips_all: '19137',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"19137": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 40.97949,
    longitude: -95.09451,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51573',
  },
  {
    city: 'Treynor',
    county_fips: 19155,
    county_fips_all: '19155',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie',
    county_weights: '{"19155": 100}',
    density: 13,
    imprecise: false,
    latitude: 41.24111,
    longitude: -95.60218,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51575',
  },
  {
    city: 'Underwood',
    county_fips: 19155,
    county_fips_all: '19155',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie',
    county_weights: '{"19155": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 41.3777,
    longitude: -95.70945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51576',
  },
  {
    city: 'Walnut',
    county_fips: 19155,
    county_fips_all: '19155|19165|19029',
    county: 'Pottawattamie',
    county_names_all: 'Pottawattamie|Shelby|Cass',
    county_weights: '{"19155": 66.46, "19165": 31.23, "19029": 2.31}',
    density: 7.2,
    imprecise: false,
    latitude: 41.4644,
    longitude: -95.20296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51577',
  },
  {
    city: 'Westphalia',
    county_fips: 19165,
    county_fips_all: '19165',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"19165": 100}',
    density: 651.6,
    imprecise: false,
    latitude: 41.72002,
    longitude: -95.39508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51578',
  },
  {
    city: 'Woodbine',
    county_fips: 19085,
    county_fips_all: '19085',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"19085": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 41.75171,
    longitude: -95.7069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51579',
  },
  {
    city: 'Shenandoah',
    county_fips: 19145,
    county_fips_all: '19145|19071',
    county: 'Page',
    county_names_all: 'Page|Fremont',
    county_weights: '{"19145": 62.71, "19071": 37.29}',
    density: 21,
    imprecise: false,
    latitude: 40.72938,
    longitude: -95.35037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51601',
  },
  {
    city: 'Blanchard',
    county_fips: 19145,
    county_fips_all: '19145',
    county: 'Page',
    county_names_all: 'Page',
    county_weights: '{"19145": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 40.60101,
    longitude: -95.19427,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51630',
  },
  {
    city: 'Braddyville',
    county_fips: 19145,
    county_fips_all: '19145',
    county: 'Page',
    county_names_all: 'Page',
    county_weights: '{"19145": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 40.60267,
    longitude: -95.00918,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51631',
  },
  {
    city: 'Clarinda',
    county_fips: 19145,
    county_fips_all: '19145|19173',
    county: 'Page',
    county_names_all: 'Page|Taylor',
    county_weights: '{"19145": 98.49, "19173": 1.51}',
    density: 12.1,
    imprecise: false,
    latitude: 40.7478,
    longitude: -95.04939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51632',
  },
  {
    city: 'Coin',
    county_fips: 19145,
    county_fips_all: '19145',
    county: 'Page',
    county_names_all: 'Page',
    county_weights: '{"19145": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 40.66713,
    longitude: -95.23519,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51636',
  },
  {
    city: 'College Springs',
    county_fips: 19145,
    county_fips_all: '19145',
    county: 'Page',
    county_names_all: 'Page',
    county_weights: '{"19145": 100}',
    density: 52.7,
    imprecise: false,
    latitude: 40.62046,
    longitude: -95.11832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51637',
  },
  {
    city: 'Essex',
    county_fips: 19145,
    county_fips_all: '19145|19137',
    county: 'Page',
    county_names_all: 'Page|Montgomery',
    county_weights: '{"19145": 98.02, "19137": 1.98}',
    density: 6,
    imprecise: false,
    latitude: 40.83919,
    longitude: -95.26663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51638',
  },
  {
    city: 'Farragut',
    county_fips: 19071,
    county_fips_all: '19071',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"19071": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 40.71859,
    longitude: -95.47362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51639',
  },
  {
    city: 'Hamburg',
    county_fips: 19071,
    county_fips_all: '19071|29005',
    county: 'Fremont',
    county_names_all: 'Fremont|Atchison',
    county_weights: '{"19071": 81.66, "29005": 18.34}',
    density: 4.6,
    imprecise: false,
    latitude: 40.62262,
    longitude: -95.6634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51640',
  },
  {
    city: 'Imogene',
    county_fips: 19071,
    county_fips_all: '19071|19129|19137|19145',
    county: 'Fremont',
    county_names_all: 'Fremont|Mills|Montgomery|Page',
    county_weights:
      '{"19071": 57.47, "19129": 30.08, "19137": 6.99, "19145": 5.46}',
    density: 3.6,
    imprecise: false,
    latitude: 40.88206,
    longitude: -95.4229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51645',
  },
  {
    city: 'New Market',
    county_fips: 19173,
    county_fips_all: '19173',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"19173": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 40.75315,
    longitude: -94.8725,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51646',
  },
  {
    city: 'Northboro',
    county_fips: 19145,
    county_fips_all: '19145|19071',
    county: 'Page',
    county_names_all: 'Page|Fremont',
    county_weights: '{"19145": 75.24, "19071": 24.76}',
    density: 2.7,
    imprecise: false,
    latitude: 40.60539,
    longitude: -95.34509,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51647',
  },
  {
    city: 'Percival',
    county_fips: 19071,
    county_fips_all: '19071',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"19071": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 40.74215,
    longitude: -95.80325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51648',
  },
  {
    city: 'Randolph',
    county_fips: 19071,
    county_fips_all: '19071',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"19071": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 40.8518,
    longitude: -95.53565,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51649',
  },
  {
    city: 'Riverton',
    county_fips: 19071,
    county_fips_all: '19071',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"19071": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 40.673,
    longitude: -95.5492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51650',
  },
  {
    city: 'Shambaugh',
    county_fips: 19145,
    county_fips_all: '19145',
    county: 'Page',
    county_names_all: 'Page',
    county_weights: '{"19145": 100}',
    density: 170.2,
    imprecise: false,
    latitude: 40.65652,
    longitude: -95.03473,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51651',
  },
  {
    city: 'Sidney',
    county_fips: 19071,
    county_fips_all: '19071',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"19071": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 40.77032,
    longitude: -95.62815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51652',
  },
  {
    city: 'Tabor',
    county_fips: 19071,
    county_fips_all: '19071|19129',
    county: 'Fremont',
    county_names_all: 'Fremont|Mills',
    county_weights: '{"19071": 74.55, "19129": 25.45}',
    density: 15.9,
    imprecise: false,
    latitude: 40.88444,
    longitude: -95.67179,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51653',
  },
  {
    city: 'Thurman',
    county_fips: 19071,
    county_fips_all: '19071',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"19071": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 40.831,
    longitude: -95.76038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51654',
  },
  {
    city: 'Yorktown',
    county_fips: 19145,
    county_fips_all: '19145',
    county: 'Page',
    county_names_all: 'Page',
    county_weights: '{"19145": 100}',
    density: 81.1,
    imprecise: false,
    latitude: 40.73527,
    longitude: -95.15437,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51656',
  },
  {
    city: 'Dubuque',
    county_fips: 19061,
    county_fips_all: '19061',
    county: 'Dubuque',
    county_names_all: 'Dubuque',
    county_weights: '{"19061": 100}',
    density: 637,
    imprecise: false,
    latitude: 42.54819,
    longitude: -90.69348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52001',
  },
  {
    city: 'Dubuque',
    county_fips: 19061,
    county_fips_all: '19061',
    county: 'Dubuque',
    county_names_all: 'Dubuque',
    county_weights: '{"19061": 100}',
    density: 225.1,
    imprecise: false,
    latitude: 42.52481,
    longitude: -90.77184,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52002',
  },
  {
    city: 'Dubuque',
    county_fips: 19061,
    county_fips_all: '19061',
    county: 'Dubuque',
    county_names_all: 'Dubuque',
    county_weights: '{"19061": 100}',
    density: 94.5,
    imprecise: false,
    latitude: 42.43434,
    longitude: -90.67506,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52003',
  },
  {
    city: 'Andrew',
    county_fips: 19097,
    county_fips_all: '19097',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"19097": 100}',
    density: 658.6,
    imprecise: false,
    latitude: 42.15322,
    longitude: -90.59219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52030',
  },
  {
    city: 'Bellevue',
    county_fips: 19097,
    county_fips_all: '19097|19061',
    county: 'Jackson',
    county_names_all: 'Jackson|Dubuque',
    county_weights: '{"19097": 94.87, "19061": 5.13}',
    density: 12.5,
    imprecise: false,
    latitude: 42.24874,
    longitude: -90.48922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52031',
  },
  {
    city: 'Bernard',
    county_fips: 19061,
    county_fips_all: '19061|19097|19105',
    county: 'Dubuque',
    county_names_all: 'Dubuque|Jackson|Jones',
    county_weights: '{"19061": 46.96, "19097": 45.64, "19105": 7.4}',
    density: 4.9,
    imprecise: false,
    latitude: 42.29006,
    longitude: -90.84317,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52032',
  },
  {
    city: 'Cascade',
    county_fips: 19105,
    county_fips_all: '19105|19061',
    county: 'Jones',
    county_names_all: 'Jones|Dubuque',
    county_weights: '{"19105": 57.96, "19061": 42.04}',
    density: 12.9,
    imprecise: false,
    latitude: 42.27941,
    longitude: -91.00177,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52033',
  },
  {
    city: 'Colesburg',
    county_fips: 19043,
    county_fips_all: '19043|19055',
    county: 'Clayton',
    county_names_all: 'Clayton|Delaware',
    county_weights: '{"19043": 62.27, "19055": 37.73}',
    density: 10.3,
    imprecise: false,
    latitude: 42.65996,
    longitude: -91.18784,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52035',
  },
  {
    city: 'Delaware',
    county_fips: 19055,
    county_fips_all: '19055',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"19055": 100}',
    density: 122.1,
    imprecise: false,
    latitude: 42.47285,
    longitude: -91.34086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52036',
  },
  {
    city: 'Delmar',
    county_fips: 19045,
    county_fips_all: '19045|19097',
    county: 'Clinton',
    county_names_all: 'Clinton|Jackson',
    county_weights: '{"19045": 97.77, "19097": 2.23}',
    density: 6.6,
    imprecise: false,
    latitude: 41.96712,
    longitude: -90.62899,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52037',
  },
  {
    city: 'Dundee',
    county_fips: 19055,
    county_fips_all: '19055',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"19055": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 42.58586,
    longitude: -91.55685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52038',
  },
  {
    city: 'Durango',
    county_fips: 19061,
    county_fips_all: '19061',
    county: 'Dubuque',
    county_names_all: 'Dubuque',
    county_weights: '{"19061": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 42.53807,
    longitude: -90.85745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52039',
  },
  {
    city: 'Dyersville',
    county_fips: 19055,
    county_fips_all: '19055|19061',
    county: 'Delaware',
    county_names_all: 'Delaware|Dubuque',
    county_weights: '{"19055": 53.67, "19061": 46.33}',
    density: 34.8,
    imprecise: false,
    latitude: 42.51114,
    longitude: -91.13884,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52040',
  },
  {
    city: 'Earlville',
    county_fips: 19055,
    county_fips_all: '19055',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"19055": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 42.5051,
    longitude: -91.25515,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52041',
  },
  {
    city: 'Edgewood',
    county_fips: 19043,
    county_fips_all: '19043|19055',
    county: 'Clayton',
    county_names_all: 'Clayton|Delaware',
    county_weights: '{"19043": 81.35, "19055": 18.65}',
    density: 11.5,
    imprecise: false,
    latitude: 42.68098,
    longitude: -91.36517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52042',
  },
  {
    city: 'Elkader',
    county_fips: 19043,
    county_fips_all: '19043',
    county: 'Clayton',
    county_names_all: 'Clayton',
    county_weights: '{"19043": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 42.84403,
    longitude: -91.42201,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52043',
  },
  {
    city: 'Elkport',
    county_fips: 19043,
    county_fips_all: '19043',
    county: 'Clayton',
    county_names_all: 'Clayton',
    county_weights: '{"19043": 100}',
    density: 9,
    imprecise: false,
    latitude: 42.76808,
    longitude: -91.32328,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52044',
  },
  {
    city: 'Epworth',
    county_fips: 19061,
    county_fips_all: '19061',
    county: 'Dubuque',
    county_names_all: 'Dubuque',
    county_weights: '{"19061": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 42.45485,
    longitude: -90.93113,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52045',
  },
  {
    city: 'Farley',
    county_fips: 19061,
    county_fips_all: '19061',
    county: 'Dubuque',
    county_names_all: 'Dubuque',
    county_weights: '{"19061": 100}',
    density: 25,
    imprecise: false,
    latitude: 42.44024,
    longitude: -91.0119,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52046',
  },
  {
    city: 'Farmersburg',
    county_fips: 19043,
    county_fips_all: '19043',
    county: 'Clayton',
    county_names_all: 'Clayton',
    county_weights: '{"19043": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 42.96401,
    longitude: -91.34301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52047',
  },
  {
    city: 'Garber',
    county_fips: 19043,
    county_fips_all: '19043',
    county: 'Clayton',
    county_names_all: 'Clayton',
    county_weights: '{"19043": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 42.73735,
    longitude: -91.25584,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52048',
  },
  {
    city: 'Garnavillo',
    county_fips: 19043,
    county_fips_all: '19043',
    county: 'Clayton',
    county_names_all: 'Clayton',
    county_weights: '{"19043": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 42.8823,
    longitude: -91.20521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52049',
  },
  {
    city: 'Greeley',
    county_fips: 19055,
    county_fips_all: '19055|19043',
    county: 'Delaware',
    county_names_all: 'Delaware|Clayton',
    county_weights: '{"19055": 88.26, "19043": 11.74}',
    density: 5.1,
    imprecise: false,
    latitude: 42.60532,
    longitude: -91.33204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52050',
  },
  {
    city: 'Guttenberg',
    county_fips: 19043,
    county_fips_all: '19043|19061',
    county: 'Clayton',
    county_names_all: 'Clayton|Dubuque',
    county_weights: '{"19043": 90.38, "19061": 9.62}',
    density: 12.9,
    imprecise: false,
    latitude: 42.7411,
    longitude: -91.12083,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52052',
  },
  {
    city: 'Holy Cross',
    county_fips: 19061,
    county_fips_all: '19061|19043',
    county: 'Dubuque',
    county_names_all: 'Dubuque|Clayton',
    county_weights: '{"19061": 78.28, "19043": 21.72}',
    density: 7.6,
    imprecise: false,
    latitude: 42.60656,
    longitude: -90.96399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52053',
  },
  {
    city: 'La Motte',
    county_fips: 19097,
    county_fips_all: '19097|19061',
    county: 'Jackson',
    county_names_all: 'Jackson|Dubuque',
    county_weights: '{"19097": 92.97, "19061": 7.03}',
    density: 5.4,
    imprecise: false,
    latitude: 42.30569,
    longitude: -90.62811,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52054',
  },
  {
    city: 'Luxemburg',
    county_fips: 19061,
    county_fips_all: '19061',
    county: 'Dubuque',
    county_names_all: 'Dubuque',
    county_weights: '{"19061": 100}',
    density: 187.4,
    imprecise: false,
    latitude: 42.60401,
    longitude: -91.07257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52056',
  },
  {
    city: 'Manchester',
    county_fips: 19055,
    county_fips_all: '19055',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"19055": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 42.4916,
    longitude: -91.45333,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52057',
  },
  {
    city: 'Maquoketa',
    county_fips: 19097,
    county_fips_all: '19097|19045',
    county: 'Jackson',
    county_names_all: 'Jackson|Clinton',
    county_weights: '{"19097": 88.17, "19045": 11.83}',
    density: 19.4,
    imprecise: false,
    latitude: 42.10217,
    longitude: -90.67961,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52060',
  },
  {
    city: 'Miles',
    county_fips: 19097,
    county_fips_all: '19097|19045',
    county: 'Jackson',
    county_names_all: 'Jackson|Clinton',
    county_weights: '{"19097": 86.06, "19045": 13.94}',
    density: 6.2,
    imprecise: false,
    latitude: 42.08977,
    longitude: -90.31076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52064',
  },
  {
    city: 'New Vienna',
    county_fips: 19061,
    county_fips_all: '19061|19055',
    county: 'Dubuque',
    county_names_all: 'Dubuque|Delaware',
    county_weights: '{"19061": 74.82, "19055": 25.18}',
    density: 5.4,
    imprecise: false,
    latitude: 42.58353,
    longitude: -91.10202,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52065',
  },
  {
    city: 'North Buena Vista',
    county_fips: 19043,
    county_fips_all: '19043',
    county: 'Clayton',
    county_names_all: 'Clayton',
    county_weights: '{"19043": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 42.693,
    longitude: -90.96925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52066',
  },
  {
    city: 'Peosta',
    county_fips: 19061,
    county_fips_all: '19061',
    county: 'Dubuque',
    county_names_all: 'Dubuque',
    county_weights: '{"19061": 100}',
    density: 47.3,
    imprecise: false,
    latitude: 42.42382,
    longitude: -90.81128,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52068',
  },
  {
    city: 'Preston',
    county_fips: 19097,
    county_fips_all: '19097|19045',
    county: 'Jackson',
    county_names_all: 'Jackson|Clinton',
    county_weights: '{"19097": 77.66, "19045": 22.34}',
    density: 13.7,
    imprecise: false,
    latitude: 42.05772,
    longitude: -90.4279,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52069',
  },
  {
    city: 'Sabula',
    county_fips: 19097,
    county_fips_all: '19097|19045',
    county: 'Jackson',
    county_names_all: 'Jackson|Clinton',
    county_weights: '{"19097": 82.1, "19045": 17.9}',
    density: 7.9,
    imprecise: false,
    latitude: 42.08146,
    longitude: -90.21771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52070',
  },
  {
    city: 'Saint Donatus',
    county_fips: 19097,
    county_fips_all: '19097',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"19097": 100}',
    density: 120.9,
    imprecise: false,
    latitude: 42.36245,
    longitude: -90.54234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52071',
  },
  {
    city: 'Saint Olaf',
    county_fips: 19043,
    county_fips_all: '19043',
    county: 'Clayton',
    county_names_all: 'Clayton',
    county_weights: '{"19043": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 42.92022,
    longitude: -91.38025,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52072',
  },
  {
    city: 'Sherrill',
    county_fips: 19061,
    county_fips_all: '19061|19043',
    county: 'Dubuque',
    county_names_all: 'Dubuque|Clayton',
    county_weights: '{"19061": 92.82, "19043": 7.18}',
    density: 11.1,
    imprecise: false,
    latitude: 42.62331,
    longitude: -90.82069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52073',
  },
  {
    city: 'Spragueville',
    county_fips: 19097,
    county_fips_all: '19097',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"19097": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 42.10966,
    longitude: -90.4724,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52074',
  },
  {
    city: 'Springbrook',
    county_fips: 19097,
    county_fips_all: '19097',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"19097": 100}',
    density: 80.2,
    imprecise: false,
    latitude: 42.16577,
    longitude: -90.47916,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52075',
  },
  {
    city: 'Strawberry Point',
    county_fips: 19043,
    county_fips_all: '19043|19055|19065',
    county: 'Clayton',
    county_names_all: 'Clayton|Delaware|Fayette',
    county_weights: '{"19043": 82.72, "19055": 16.61, "19065": 0.67}',
    density: 8.6,
    imprecise: false,
    latitude: 42.69805,
    longitude: -91.50984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52076',
  },
  {
    city: 'Volga',
    county_fips: 19043,
    county_fips_all: '19043',
    county: 'Clayton',
    county_names_all: 'Clayton',
    county_weights: '{"19043": 100}',
    density: 4,
    imprecise: false,
    latitude: 42.82258,
    longitude: -91.55393,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52077',
  },
  {
    city: 'Worthington',
    county_fips: 19061,
    county_fips_all: '19061|19055',
    county: 'Dubuque',
    county_names_all: 'Dubuque|Delaware',
    county_weights: '{"19061": 64.18, "19055": 35.82}',
    density: 8.1,
    imprecise: false,
    latitude: 42.39506,
    longitude: -91.11534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52078',
  },
  {
    city: 'Zwingle',
    county_fips: 19097,
    county_fips_all: '19097|19061',
    county: 'Jackson',
    county_names_all: 'Jackson|Dubuque',
    county_weights: '{"19097": 54.5, "19061": 45.5}',
    density: 6.5,
    imprecise: false,
    latitude: 42.28781,
    longitude: -90.71908,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52079',
  },
  {
    city: 'Decorah',
    county_fips: 19191,
    county_fips_all: '19191|19005',
    county: 'Winneshiek',
    county_names_all: 'Winneshiek|Allamakee',
    county_weights: '{"19191": 97.06, "19005": 2.94}',
    density: 15.5,
    imprecise: false,
    latitude: 43.35741,
    longitude: -91.76494,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52101',
  },
  {
    city: 'Calmar',
    county_fips: 19191,
    county_fips_all: '19191|19089',
    county: 'Winneshiek',
    county_names_all: 'Winneshiek|Howard',
    county_weights: '{"19191": 98.34, "19089": 1.66}',
    density: 11,
    imprecise: false,
    latitude: 43.2067,
    longitude: -91.91881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52132',
  },
  {
    city: 'Castalia',
    county_fips: 19191,
    county_fips_all: '19191|19065',
    county: 'Winneshiek',
    county_names_all: 'Winneshiek|Fayette',
    county_weights: '{"19191": 70.28, "19065": 29.72}',
    density: 5.9,
    imprecise: false,
    latitude: 43.10702,
    longitude: -91.66854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52133',
  },
  {
    city: 'Chester',
    county_fips: 19089,
    county_fips_all: '19089',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"19089": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 43.47156,
    longitude: -92.40078,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52134',
  },
  {
    city: 'Clermont',
    county_fips: 19065,
    county_fips_all: '19065|19043',
    county: 'Fayette',
    county_names_all: 'Fayette|Clayton',
    county_weights: '{"19065": 92.48, "19043": 7.52}',
    density: 11.5,
    imprecise: false,
    latitude: 43.01945,
    longitude: -91.66204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52135',
  },
  {
    city: 'Cresco',
    county_fips: 19089,
    county_fips_all: '19089|19191',
    county: 'Howard',
    county_names_all: 'Howard|Winneshiek',
    county_weights: '{"19089": 66.88, "19191": 33.12}',
    density: 10.7,
    imprecise: false,
    latitude: 43.37139,
    longitude: -92.11289,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52136',
  },
  {
    city: 'Dorchester',
    county_fips: 19005,
    county_fips_all: '19005|19191',
    county: 'Allamakee',
    county_names_all: 'Allamakee|Winneshiek',
    county_weights: '{"19005": 91.07, "19191": 8.93}',
    density: 3.5,
    imprecise: false,
    latitude: 43.44173,
    longitude: -91.53108,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52140',
  },
  {
    city: 'Elgin',
    county_fips: 19065,
    county_fips_all: '19065|19043',
    county: 'Fayette',
    county_names_all: 'Fayette|Clayton',
    county_weights: '{"19065": 58.45, "19043": 41.55}',
    density: 5.8,
    imprecise: false,
    latitude: 42.93924,
    longitude: -91.63007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52141',
  },
  {
    city: 'Fayette',
    county_fips: 19065,
    county_fips_all: '19065',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"19065": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 42.82752,
    longitude: -91.79441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52142',
  },
  {
    city: 'Fort Atkinson',
    county_fips: 19191,
    county_fips_all: '19191|19065',
    county: 'Winneshiek',
    county_names_all: 'Winneshiek|Fayette',
    county_weights: '{"19191": 94.31, "19065": 5.69}',
    density: 5.6,
    imprecise: false,
    latitude: 43.13961,
    longitude: -91.96075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52144',
  },
  {
    city: 'Harpers Ferry',
    county_fips: 19005,
    county_fips_all: '19005',
    county: 'Allamakee',
    county_names_all: 'Allamakee',
    county_weights: '{"19005": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 43.18826,
    longitude: -91.19588,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52146',
  },
  {
    city: 'Hawkeye',
    county_fips: 19065,
    county_fips_all: '19065',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"19065": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 42.94957,
    longitude: -91.96106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52147',
  },
  {
    city: 'Lansing',
    county_fips: 19005,
    county_fips_all: '19005',
    county: 'Allamakee',
    county_names_all: 'Allamakee',
    county_weights: '{"19005": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 43.34706,
    longitude: -91.28013,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52151',
  },
  {
    city: 'Lawler',
    county_fips: 19037,
    county_fips_all: '19037|19089',
    county: 'Chickasaw',
    county_names_all: 'Chickasaw|Howard',
    county_weights: '{"19037": 98.58, "19089": 1.42}',
    density: 3.1,
    imprecise: false,
    latitude: 43.12201,
    longitude: -92.16519,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52154',
  },
  {
    city: 'Lime Springs',
    county_fips: 19089,
    county_fips_all: '19089',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"19089": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 43.41412,
    longitude: -92.29683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52155',
  },
  {
    city: 'Luana',
    county_fips: 19043,
    county_fips_all: '19043|19005',
    county: 'Clayton',
    county_names_all: 'Clayton|Allamakee',
    county_weights: '{"19043": 72.56, "19005": 27.44}',
    density: 6.3,
    imprecise: false,
    latitude: 43.05316,
    longitude: -91.46534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52156',
  },
  {
    city: 'McGregor',
    county_fips: 19043,
    county_fips_all: '19043',
    county: 'Clayton',
    county_names_all: 'Clayton',
    county_weights: '{"19043": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 43.01661,
    longitude: -91.23216,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52157',
  },
  {
    city: 'Marquette',
    county_fips: 19043,
    county_fips_all: '19043',
    county: 'Clayton',
    county_names_all: 'Clayton',
    county_weights: '{"19043": 100}',
    density: 87.4,
    imprecise: false,
    latitude: 43.04388,
    longitude: -91.18647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52158',
  },
  {
    city: 'Monona',
    county_fips: 19005,
    county_fips_all: '19005|19043',
    county: 'Allamakee',
    county_names_all: 'Allamakee|Clayton',
    county_weights: '{"19005": 50.79, "19043": 49.21}',
    density: 12.7,
    imprecise: false,
    latitude: 43.07979,
    longitude: -91.36134,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52159',
  },
  {
    city: 'New Albin',
    county_fips: 19005,
    county_fips_all: '19005',
    county: 'Allamakee',
    county_names_all: 'Allamakee',
    county_weights: '{"19005": 100}',
    density: 7,
    imprecise: false,
    latitude: 43.46733,
    longitude: -91.3521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52160',
  },
  {
    city: 'Ossian',
    county_fips: 19191,
    county_fips_all: '19191|19065',
    county: 'Winneshiek',
    county_names_all: 'Winneshiek|Fayette',
    county_weights: '{"19191": 86.28, "19065": 13.72}',
    density: 11.1,
    imprecise: false,
    latitude: 43.12733,
    longitude: -91.75623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52161',
  },
  {
    city: 'Postville',
    county_fips: 19005,
    county_fips_all: '19005|19043|19191|19065',
    county: 'Allamakee',
    county_names_all: 'Allamakee|Clayton|Winneshiek|Fayette',
    county_weights:
      '{"19005": 59.92, "19043": 27.38, "19191": 9.59, "19065": 3.11}',
    density: 15,
    imprecise: false,
    latitude: 43.11062,
    longitude: -91.55266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52162',
  },
  {
    city: 'Protivin',
    county_fips: 19089,
    county_fips_all: '19089',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"19089": 100}',
    density: 72.6,
    imprecise: false,
    latitude: 43.21976,
    longitude: -92.10315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52163',
  },
  {
    city: 'Randalia',
    county_fips: 19065,
    county_fips_all: '19065',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"19065": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 42.85212,
    longitude: -91.89941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52164',
  },
  {
    city: 'Ridgeway',
    county_fips: 19191,
    county_fips_all: '19191',
    county: 'Winneshiek',
    county_names_all: 'Winneshiek',
    county_weights: '{"19191": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 43.30671,
    longitude: -91.98465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52165',
  },
  {
    city: 'Saint Lucas',
    county_fips: 19065,
    county_fips_all: '19065',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"19065": 100}',
    density: 204.9,
    imprecise: false,
    latitude: 43.06791,
    longitude: -91.93547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52166',
  },
  {
    city: 'Spillville',
    county_fips: 19191,
    county_fips_all: '19191',
    county: 'Winneshiek',
    county_names_all: 'Winneshiek',
    county_weights: '{"19191": 100}',
    density: 362.8,
    imprecise: false,
    latitude: 43.20339,
    longitude: -91.95338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52168',
  },
  {
    city: 'Wadena',
    county_fips: 19065,
    county_fips_all: '19065|19043',
    county: 'Fayette',
    county_names_all: 'Fayette|Clayton',
    county_weights: '{"19065": 94.02, "19043": 5.98}',
    density: 4.2,
    imprecise: false,
    latitude: 42.84739,
    longitude: -91.65971,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52169',
  },
  {
    city: 'Waterville',
    county_fips: 19005,
    county_fips_all: '19005',
    county: 'Allamakee',
    county_names_all: 'Allamakee',
    county_weights: '{"19005": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 43.22886,
    longitude: -91.30485,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52170',
  },
  {
    city: 'Waucoma',
    county_fips: 19065,
    county_fips_all: '19065|19037|19191',
    county: 'Fayette',
    county_names_all: 'Fayette|Chickasaw|Winneshiek',
    county_weights: '{"19065": 50.39, "19037": 31.18, "19191": 18.43}',
    density: 6.2,
    imprecise: false,
    latitude: 43.07451,
    longitude: -92.04808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52171',
  },
  {
    city: 'Waukon',
    county_fips: 19005,
    county_fips_all: '19005|19191',
    county: 'Allamakee',
    county_names_all: 'Allamakee|Winneshiek',
    county_weights: '{"19005": 95.5, "19191": 4.5}',
    density: 14.2,
    imprecise: false,
    latitude: 43.27117,
    longitude: -91.48382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52172',
  },
  {
    city: 'West Union',
    county_fips: 19065,
    county_fips_all: '19065',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"19065": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 42.99372,
    longitude: -91.82389,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52175',
  },
  {
    city: 'Ainsworth',
    county_fips: 19183,
    county_fips_all: '19183',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"19183": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 41.33218,
    longitude: -91.54704,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52201',
  },
  {
    city: 'Alburnett',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 42.15836,
    longitude: -91.63792,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52202',
  },
  {
    city: 'Amana',
    county_fips: 19095,
    county_fips_all: '19095|19103',
    county: 'Iowa',
    county_names_all: 'Iowa|Johnson',
    county_weights: '{"19095": 78.74, "19103": 21.26}',
    density: 16.4,
    imprecise: false,
    latitude: 41.81035,
    longitude: -91.8906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52203',
  },
  {
    city: 'Anamosa',
    county_fips: 19105,
    county_fips_all: '19105|19113',
    county: 'Jones',
    county_names_all: 'Jones|Linn',
    county_weights: '{"19105": 85.19, "19113": 14.81}',
    density: 27,
    imprecise: false,
    latitude: 42.11754,
    longitude: -91.28806,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52205',
  },
  {
    city: 'Atkins',
    county_fips: 19011,
    county_fips_all: '19011',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"19011": 100}',
    density: 34.7,
    imprecise: false,
    latitude: 41.99187,
    longitude: -91.88718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52206',
  },
  {
    city: 'Baldwin',
    county_fips: 19097,
    county_fips_all: '19097|19045',
    county: 'Jackson',
    county_names_all: 'Jackson|Clinton',
    county_weights: '{"19097": 87.22, "19045": 12.78}',
    density: 2.7,
    imprecise: false,
    latitude: 42.09286,
    longitude: -90.83,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52207',
  },
  {
    city: 'Belle Plaine',
    county_fips: 19011,
    county_fips_all: '19011|19095|19171|19157',
    county: 'Benton',
    county_names_all: 'Benton|Iowa|Tama|Poweshiek',
    county_weights:
      '{"19011": 55.8, "19095": 27.33, "19171": 13.45, "19157": 3.42}',
    density: 18.3,
    imprecise: false,
    latitude: 41.88568,
    longitude: -92.26475,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52208',
  },
  {
    city: 'Blairstown',
    county_fips: 19011,
    county_fips_all: '19011|19095',
    county: 'Benton',
    county_names_all: 'Benton|Iowa',
    county_weights: '{"19011": 96.28, "19095": 3.72}',
    density: 11.4,
    imprecise: false,
    latitude: 41.90809,
    longitude: -92.09462,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52209',
  },
  {
    city: 'Brandon',
    county_fips: 19019,
    county_fips_all: '19019|19011',
    county: 'Buchanan',
    county_names_all: 'Buchanan|Benton',
    county_weights: '{"19019": 98.62, "19011": 1.38}',
    density: 10.7,
    imprecise: false,
    latitude: 42.33905,
    longitude: -92.00537,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52210',
  },
  {
    city: 'Brooklyn',
    county_fips: 19157,
    county_fips_all: '19157',
    county: 'Poweshiek',
    county_names_all: 'Poweshiek',
    county_weights: '{"19157": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 41.75978,
    longitude: -92.45062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52211',
  },
  {
    city: 'Center Junction',
    county_fips: 19105,
    county_fips_all: '19105',
    county: 'Jones',
    county_names_all: 'Jones',
    county_weights: '{"19105": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 42.10954,
    longitude: -91.08929,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52212',
  },
  {
    city: 'Center Point',
    county_fips: 19113,
    county_fips_all: '19113|19011',
    county: 'Linn',
    county_names_all: 'Linn|Benton',
    county_weights: '{"19113": 76.16, "19011": 23.84}',
    density: 21.8,
    imprecise: false,
    latitude: 42.1995,
    longitude: -91.77222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52213',
  },
  {
    city: 'Central City',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 42.19056,
    longitude: -91.50704,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52214',
  },
  {
    city: 'Chelsea',
    county_fips: 19171,
    county_fips_all: '19171|19157',
    county: 'Tama',
    county_names_all: 'Tama|Poweshiek',
    county_weights: '{"19171": 81.03, "19157": 18.97}',
    density: 4.6,
    imprecise: false,
    latitude: 41.91018,
    longitude: -92.40106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52215',
  },
  {
    city: 'Clarence',
    county_fips: 19031,
    county_fips_all: '19031|19105',
    county: 'Cedar',
    county_names_all: 'Cedar|Jones',
    county_weights: '{"19031": 85.83, "19105": 14.17}',
    density: 10.3,
    imprecise: false,
    latitude: 41.89321,
    longitude: -91.0431,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52216',
  },
  {
    city: 'Clutier',
    county_fips: 19171,
    county_fips_all: '19171',
    county: 'Tama',
    county_names_all: 'Tama',
    county_weights: '{"19171": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 42.07948,
    longitude: -92.41067,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52217',
  },
  {
    city: 'Coggon',
    county_fips: 19113,
    county_fips_all: '19113|19019|19055',
    county: 'Linn',
    county_names_all: 'Linn|Buchanan|Delaware',
    county_weights: '{"19113": 55.76, "19019": 24.15, "19055": 20.09}',
    density: 7.2,
    imprecise: false,
    latitude: 42.2946,
    longitude: -91.53826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52218',
  },
  {
    city: 'Prairieburg',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 123.2,
    imprecise: false,
    latitude: 42.23758,
    longitude: -91.42576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52219',
  },
  {
    city: 'Conroy',
    county_fips: 19095,
    county_fips_all: '19095',
    county: 'Iowa',
    county_names_all: 'Iowa',
    county_weights: '{"19095": 100}',
    density: 100.8,
    imprecise: false,
    latitude: 41.72661,
    longitude: -91.99853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52220',
  },
  {
    city: 'Guernsey',
    county_fips: 19157,
    county_fips_all: '19157|19095',
    county: 'Poweshiek',
    county_names_all: 'Poweshiek|Iowa',
    county_weights: '{"19157": 84.62, "19095": 15.38}',
    density: 6.1,
    imprecise: false,
    latitude: 41.64151,
    longitude: -92.33215,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52221',
  },
  {
    city: 'Deep River',
    county_fips: 19157,
    county_fips_all: '19157|19095',
    county: 'Poweshiek',
    county_names_all: 'Poweshiek|Iowa',
    county_weights: '{"19157": 70.72, "19095": 29.28}',
    density: 3.2,
    imprecise: false,
    latitude: 41.57623,
    longitude: -92.33693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52222',
  },
  {
    city: 'Delhi',
    county_fips: 19055,
    county_fips_all: '19055',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"19055": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 42.41315,
    longitude: -91.32408,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52223',
  },
  {
    city: 'Dysart',
    county_fips: 19011,
    county_fips_all: '19011|19171',
    county: 'Benton',
    county_names_all: 'Benton|Tama',
    county_weights: '{"19011": 52.18, "19171": 47.82}',
    density: 8.4,
    imprecise: false,
    latitude: 42.16386,
    longitude: -92.29836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52224',
  },
  {
    city: 'Elberon',
    county_fips: 19171,
    county_fips_all: '19171|19011',
    county: 'Tama',
    county_names_all: 'Tama|Benton',
    county_weights: '{"19171": 72.35, "19011": 27.65}',
    density: 3.9,
    imprecise: false,
    latitude: 42.01289,
    longitude: -92.32636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52225',
  },
  {
    city: 'Ely',
    county_fips: 19113,
    county_fips_all: '19113|19103',
    county: 'Linn',
    county_names_all: 'Linn|Johnson',
    county_weights: '{"19113": 93.55, "19103": 6.45}',
    density: 39.3,
    imprecise: false,
    latitude: 41.89647,
    longitude: -91.5626,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52227',
  },
  {
    city: 'Fairfax',
    county_fips: 19113,
    county_fips_all: '19113|19011|19103',
    county: 'Linn',
    county_names_all: 'Linn|Benton|Johnson',
    county_weights: '{"19113": 75.69, "19011": 13.04, "19103": 11.27}',
    density: 39.4,
    imprecise: false,
    latitude: 41.90282,
    longitude: -91.79132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52228',
  },
  {
    city: 'Garrison',
    county_fips: 19011,
    county_fips_all: '19011',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"19011": 100}',
    density: 5,
    imprecise: false,
    latitude: 42.14609,
    longitude: -92.16884,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52229',
  },
  {
    city: 'Harper',
    county_fips: 19107,
    county_fips_all: '19107',
    county: 'Keokuk',
    county_names_all: 'Keokuk',
    county_weights: '{"19107": 100}',
    density: 6,
    imprecise: false,
    latitude: 41.36371,
    longitude: -92.05912,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52231',
  },
  {
    city: 'Hartwick',
    county_fips: 19157,
    county_fips_all: '19157',
    county: 'Poweshiek',
    county_names_all: 'Poweshiek',
    county_weights: '{"19157": 100}',
    density: 5,
    imprecise: false,
    latitude: 41.80128,
    longitude: -92.34043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52232',
  },
  {
    city: 'Hiawatha',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 690.5,
    imprecise: false,
    latitude: 42.04934,
    longitude: -91.68732,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52233',
  },
  {
    city: 'Hills',
    county_fips: 19103,
    county_fips_all: '19103',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"19103": 100}',
    density: 175.3,
    imprecise: false,
    latitude: 41.57024,
    longitude: -91.53281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52235',
  },
  {
    city: 'Homestead',
    county_fips: 19095,
    county_fips_all: '19095',
    county: 'Iowa',
    county_names_all: 'Iowa',
    county_weights: '{"19095": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 41.73143,
    longitude: -91.87647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52236',
  },
  {
    city: 'Hopkinton',
    county_fips: 19055,
    county_fips_all: '19055|19105|19061',
    county: 'Delaware',
    county_names_all: 'Delaware|Jones|Dubuque',
    county_weights: '{"19055": 95.59, "19105": 2.9, "19061": 1.51}',
    density: 8.4,
    imprecise: false,
    latitude: 42.34368,
    longitude: -91.25193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52237',
  },
  {
    city: 'Iowa City',
    county_fips: 19103,
    county_fips_all: '19103',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"19103": 100}',
    density: 95.3,
    imprecise: false,
    latitude: 41.63143,
    longitude: -91.49924,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52240',
  },
  {
    city: 'Coralville',
    county_fips: 19103,
    county_fips_all: '19103',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"19103": 100}',
    density: 664.6,
    imprecise: false,
    latitude: 41.69708,
    longitude: -91.59746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52241',
  },
  {
    city: 'Iowa City',
    county_fips: 19103,
    county_fips_all: '19103',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"19103": 100}',
    density: 1050.9,
    imprecise: false,
    latitude: 41.67071,
    longitude: -91.50666,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52245',
  },
  {
    city: 'Iowa City',
    county_fips: 19103,
    county_fips_all: '19103',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"19103": 100}',
    density: 515.5,
    imprecise: false,
    latitude: 41.64903,
    longitude: -91.59718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52246',
  },
  {
    city: 'Kalona',
    county_fips: 19103,
    county_fips_all: '19103|19183',
    county: 'Johnson',
    county_names_all: 'Johnson|Washington',
    county_weights: '{"19103": 55.02, "19183": 44.98}',
    density: 28.3,
    imprecise: false,
    latitude: 41.51503,
    longitude: -91.71774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52247',
  },
  {
    city: 'Keota',
    county_fips: 19183,
    county_fips_all: '19183|19107',
    county: 'Washington',
    county_names_all: 'Washington|Keokuk',
    county_weights: '{"19183": 51.59, "19107": 48.41}',
    density: 5.8,
    imprecise: false,
    latitude: 41.34386,
    longitude: -91.93891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52248',
  },
  {
    city: 'Keystone',
    county_fips: 19011,
    county_fips_all: '19011',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"19011": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 42.01202,
    longitude: -92.20517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52249',
  },
  {
    city: 'Ladora',
    county_fips: 19095,
    county_fips_all: '19095',
    county: 'Iowa',
    county_names_all: 'Iowa',
    county_weights: '{"19095": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 41.71218,
    longitude: -92.20314,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52251',
  },
  {
    city: 'Langworthy',
    county_fips: 19105,
    county_fips_all: '19105',
    county: 'Jones',
    county_names_all: 'Jones',
    county_weights: '{"19105": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 42.19712,
    longitude: -91.22727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52252',
  },
  {
    city: 'Lisbon',
    county_fips: 19031,
    county_fips_all: '19031|19113|19105|19103',
    county: 'Cedar',
    county_names_all: 'Cedar|Linn|Jones|Johnson',
    county_weights:
      '{"19031": 49.91, "19113": 23.56, "19105": 17.73, "19103": 8.79}',
    density: 21.5,
    imprecise: false,
    latitude: 41.89713,
    longitude: -91.35154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52253',
  },
  {
    city: 'Lost Nation',
    county_fips: 19045,
    county_fips_all: '19045',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"19045": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 41.95232,
    longitude: -90.80538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52254',
  },
  {
    city: 'Lowden',
    county_fips: 19031,
    county_fips_all: '19031',
    county: 'Cedar',
    county_names_all: 'Cedar',
    county_weights: '{"19031": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 41.86294,
    longitude: -90.96129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52255',
  },
  {
    city: 'Luzerne',
    county_fips: 19011,
    county_fips_all: '19011',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"19011": 100}',
    density: 5,
    imprecise: false,
    latitude: 41.91836,
    longitude: -92.17742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52257',
  },
  {
    city: 'Marengo',
    county_fips: 19095,
    county_fips_all: '19095|19011',
    county: 'Iowa',
    county_names_all: 'Iowa|Benton',
    county_weights: '{"19095": 96.43, "19011": 3.57}',
    density: 12.3,
    imprecise: false,
    latitude: 41.78658,
    longitude: -92.09013,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52301',
  },
  {
    city: 'Marion',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 221.8,
    imprecise: false,
    latitude: 42.0656,
    longitude: -91.57091,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52302',
  },
  {
    city: 'Martelle',
    county_fips: 19105,
    county_fips_all: '19105|19113',
    county: 'Jones',
    county_names_all: 'Jones|Linn',
    county_weights: '{"19105": 78.09, "19113": 21.91}',
    density: 13,
    imprecise: false,
    latitude: 42.01801,
    longitude: -91.34207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52305',
  },
  {
    city: 'Mechanicsville',
    county_fips: 19031,
    county_fips_all: '19031|19105',
    county: 'Cedar',
    county_names_all: 'Cedar|Jones',
    county_weights: '{"19031": 79.09, "19105": 20.91}',
    density: 8.4,
    imprecise: false,
    latitude: 41.89729,
    longitude: -91.25296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52306',
  },
  {
    city: 'Middle Amana',
    county_fips: 19095,
    county_fips_all: '19095',
    county: 'Iowa',
    county_names_all: 'Iowa',
    county_weights: '{"19095": 100}',
    density: 45.4,
    imprecise: false,
    latitude: 41.79158,
    longitude: -91.90244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52307',
  },
  {
    city: 'Millersburg',
    county_fips: 19095,
    county_fips_all: '19095',
    county: 'Iowa',
    county_names_all: 'Iowa',
    county_weights: '{"19095": 100}',
    density: 409.6,
    imprecise: false,
    latitude: 41.5733,
    longitude: -92.1592,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52308',
  },
  {
    city: 'Monmouth',
    county_fips: 19097,
    county_fips_all: '19097|19105',
    county: 'Jackson',
    county_names_all: 'Jackson|Jones',
    county_weights: '{"19097": 72.13, "19105": 27.87}',
    density: 5,
    imprecise: false,
    latitude: 42.12415,
    longitude: -90.88733,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52309',
  },
  {
    city: 'Monticello',
    county_fips: 19105,
    county_fips_all: '19105|19113|19055',
    county: 'Jones',
    county_names_all: 'Jones|Linn|Delaware',
    county_weights: '{"19105": 95.34, "19113": 4.16, "19055": 0.5}',
    density: 17.1,
    imprecise: false,
    latitude: 42.21983,
    longitude: -91.19737,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52310',
  },
  {
    city: 'Morley',
    county_fips: 19105,
    county_fips_all: '19105',
    county: 'Jones',
    county_names_all: 'Jones',
    county_weights: '{"19105": 100}',
    density: 247.4,
    imprecise: false,
    latitude: 42.00617,
    longitude: -91.24526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52312',
  },
  {
    city: 'Mount Auburn',
    county_fips: 19011,
    county_fips_all: '19011',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"19011": 100}',
    density: 6,
    imprecise: false,
    latitude: 42.25955,
    longitude: -92.09726,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52313',
  },
  {
    city: 'Mount Vernon',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 40.4,
    imprecise: false,
    latitude: 41.93439,
    longitude: -91.44985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52314',
  },
  {
    city: 'Newhall',
    county_fips: 19011,
    county_fips_all: '19011',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"19011": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 42.00181,
    longitude: -91.96985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52315',
  },
  {
    city: 'North English',
    county_fips: 19095,
    county_fips_all: '19095|19107',
    county: 'Iowa',
    county_names_all: 'Iowa|Keokuk',
    county_weights: '{"19095": 87.15, "19107": 12.85}',
    density: 8.4,
    imprecise: false,
    latitude: 41.53727,
    longitude: -92.09367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52316',
  },
  {
    city: 'North Liberty',
    county_fips: 19103,
    county_fips_all: '19103',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"19103": 100}',
    density: 259.5,
    imprecise: false,
    latitude: 41.76277,
    longitude: -91.63142,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52317',
  },
  {
    city: 'Norway',
    county_fips: 19011,
    county_fips_all: '19011|19095',
    county: 'Benton',
    county_names_all: 'Benton|Iowa',
    county_weights: '{"19011": 81.72, "19095": 18.28}',
    density: 12.1,
    imprecise: false,
    latitude: 41.89012,
    longitude: -91.89656,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52318',
  },
  {
    city: 'Olin',
    county_fips: 19105,
    county_fips_all: '19105|19031',
    county: 'Jones',
    county_names_all: 'Jones|Cedar',
    county_weights: '{"19105": 87.14, "19031": 12.86}',
    density: 9.5,
    imprecise: false,
    latitude: 41.99997,
    longitude: -91.14643,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52320',
  },
  {
    city: 'Onslow',
    county_fips: 19105,
    county_fips_all: '19105',
    county: 'Jones',
    county_names_all: 'Jones',
    county_weights: '{"19105": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 42.14168,
    longitude: -90.98307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52321',
  },
  {
    city: 'Oxford',
    county_fips: 19103,
    county_fips_all: '19103|19095',
    county: 'Johnson',
    county_names_all: 'Johnson|Iowa',
    county_weights: '{"19103": 99.18, "19095": 0.82}',
    density: 10,
    imprecise: false,
    latitude: 41.69221,
    longitude: -91.76284,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52322',
  },
  {
    city: 'Oxford Junction',
    county_fips: 19105,
    county_fips_all: '19105|19045|19031',
    county: 'Jones',
    county_names_all: 'Jones|Clinton|Cedar',
    county_weights: '{"19105": 78.31, "19045": 13.11, "19031": 8.58}',
    density: 7.7,
    imprecise: false,
    latitude: 41.98445,
    longitude: -90.95344,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52323',
  },
  {
    city: 'Palo',
    county_fips: 19113,
    county_fips_all: '19113|19011',
    county: 'Linn',
    county_names_all: 'Linn|Benton',
    county_weights: '{"19113": 81.87, "19011": 18.13}',
    density: 20.4,
    imprecise: false,
    latitude: 42.06421,
    longitude: -91.80583,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52324',
  },
  {
    city: 'Parnell',
    county_fips: 19095,
    county_fips_all: '19095|19103',
    county: 'Iowa',
    county_names_all: 'Iowa|Johnson',
    county_weights: '{"19095": 86.17, "19103": 13.83}',
    density: 4.6,
    imprecise: false,
    latitude: 41.58028,
    longitude: -91.92305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52325',
  },
  {
    city: 'Quasqueton',
    county_fips: 19019,
    county_fips_all: '19019',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"19019": 100}',
    density: 270.2,
    imprecise: false,
    latitude: 42.39513,
    longitude: -91.75641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52326',
  },
  {
    city: 'Riverside',
    county_fips: 19183,
    county_fips_all: '19183|19103|19115',
    county: 'Washington',
    county_names_all: 'Washington|Johnson|Louisa',
    county_weights: '{"19183": 72.67, "19103": 27.2, "19115": 0.13}',
    density: 18.3,
    imprecise: false,
    latitude: 41.477,
    longitude: -91.58046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52327',
  },
  {
    city: 'Robins',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 387.8,
    imprecise: false,
    latitude: 42.07195,
    longitude: -91.66641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52328',
  },
  {
    city: 'Rowley',
    county_fips: 19019,
    county_fips_all: '19019',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"19019": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 42.35894,
    longitude: -91.85405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52329',
  },
  {
    city: 'Ryan',
    county_fips: 19055,
    county_fips_all: '19055',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"19055": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 42.35261,
    longitude: -91.50076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52330',
  },
  {
    city: 'Shellsburg',
    county_fips: 19011,
    county_fips_all: '19011|19113',
    county: 'Benton',
    county_names_all: 'Benton|Linn',
    county_weights: '{"19011": 91.09, "19113": 8.91}',
    density: 15.7,
    imprecise: false,
    latitude: 42.09861,
    longitude: -91.88772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52332',
  },
  {
    city: 'Solon',
    county_fips: 19103,
    county_fips_all: '19103|19031',
    county: 'Johnson',
    county_names_all: 'Johnson|Cedar',
    county_weights: '{"19103": 95.5, "19031": 4.5}',
    density: 32.9,
    imprecise: false,
    latitude: 41.80376,
    longitude: -91.48685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52333',
  },
  {
    city: 'South Amana',
    county_fips: 19095,
    county_fips_all: '19095',
    county: 'Iowa',
    county_names_all: 'Iowa',
    county_weights: '{"19095": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 41.73084,
    longitude: -91.94355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52334',
  },
  {
    city: 'South English',
    county_fips: 19107,
    county_fips_all: '19107',
    county: 'Keokuk',
    county_names_all: 'Keokuk',
    county_weights: '{"19107": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 41.45935,
    longitude: -92.05895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52335',
  },
  {
    city: 'Springville',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 42.0689,
    longitude: -91.44111,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52336',
  },
  {
    city: 'Stanwood',
    county_fips: 19031,
    county_fips_all: '19031',
    county: 'Cedar',
    county_names_all: 'Cedar',
    county_weights: '{"19031": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 41.88217,
    longitude: -91.14282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52337',
  },
  {
    city: 'Swisher',
    county_fips: 19103,
    county_fips_all: '19103|19113',
    county: 'Johnson',
    county_names_all: 'Johnson|Linn',
    county_weights: '{"19103": 93.99, "19113": 6.01}',
    density: 45.5,
    imprecise: false,
    latitude: 41.82904,
    longitude: -91.70858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52338',
  },
  {
    city: 'Tama',
    county_fips: 19171,
    county_fips_all: '19171|19157',
    county: 'Tama',
    county_names_all: 'Tama|Poweshiek',
    county_weights: '{"19171": 97.28, "19157": 2.72}',
    density: 16.9,
    imprecise: false,
    latitude: 41.92313,
    longitude: -92.58307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52339',
  },
  {
    city: 'Tiffin',
    county_fips: 19103,
    county_fips_all: '19103',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"19103": 100}',
    density: 124.2,
    imprecise: false,
    latitude: 41.70615,
    longitude: -91.68019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52340',
  },
  {
    city: 'Toddville',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 39.2,
    imprecise: false,
    latitude: 42.10535,
    longitude: -91.7341,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52341',
  },
  {
    city: 'Toledo',
    county_fips: 19171,
    county_fips_all: '19171',
    county: 'Tama',
    county_names_all: 'Tama',
    county_weights: '{"19171": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 42.05047,
    longitude: -92.55849,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52342',
  },
  {
    city: 'Troy Mills',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 2739.4,
    imprecise: false,
    latitude: 42.29202,
    longitude: -91.68325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 67,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52344',
  },
  {
    city: 'Urbana',
    county_fips: 19011,
    county_fips_all: '19011',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"19011": 100}',
    density: 195.4,
    imprecise: false,
    latitude: 42.22239,
    longitude: -91.89177,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52345',
  },
  {
    city: 'Van Horne',
    county_fips: 19011,
    county_fips_all: '19011',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"19011": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 42.01298,
    longitude: -92.08119,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52346',
  },
  {
    city: 'Victor',
    county_fips: 19095,
    county_fips_all: '19095|19157',
    county: 'Iowa',
    county_names_all: 'Iowa|Poweshiek',
    county_weights: '{"19095": 66.92, "19157": 33.08}',
    density: 8.4,
    imprecise: false,
    latitude: 41.71345,
    longitude: -92.28591,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52347',
  },
  {
    city: 'Vining',
    county_fips: 19171,
    county_fips_all: '19171',
    county: 'Tama',
    county_names_all: 'Tama',
    county_weights: '{"19171": 100}',
    density: 88.3,
    imprecise: false,
    latitude: 41.99331,
    longitude: -92.38597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52348',
  },
  {
    city: 'Vinton',
    county_fips: 19011,
    county_fips_all: '19011',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"19011": 100}',
    density: 20,
    imprecise: false,
    latitude: 42.17246,
    longitude: -92.00566,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52349',
  },
  {
    city: 'Walford',
    county_fips: 19011,
    county_fips_all: '19011|19113|19095',
    county: 'Benton',
    county_names_all: 'Benton|Linn|Iowa',
    county_weights: '{"19011": 67.34, "19113": 32.49, "19095": 0.17}',
    density: 278.2,
    imprecise: false,
    latitude: 41.87496,
    longitude: -91.83529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52351',
  },
  {
    city: 'Walker',
    county_fips: 19113,
    county_fips_all: '19113|19019|19011',
    county: 'Linn',
    county_names_all: 'Linn|Buchanan|Benton',
    county_weights: '{"19113": 47.12, "19019": 36.49, "19011": 16.38}',
    density: 8.8,
    imprecise: false,
    latitude: 42.28706,
    longitude: -91.77897,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52352',
  },
  {
    city: 'Washington',
    county_fips: 19183,
    county_fips_all: '19183',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"19183": 100}',
    density: 22.7,
    imprecise: false,
    latitude: 41.29923,
    longitude: -91.71596,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52353',
  },
  {
    city: 'Watkins',
    county_fips: 19011,
    county_fips_all: '19011',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"19011": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 41.91883,
    longitude: -91.98856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52354',
  },
  {
    city: 'Webster',
    county_fips: 19107,
    county_fips_all: '19107|19095',
    county: 'Keokuk',
    county_names_all: 'Keokuk|Iowa',
    county_weights: '{"19107": 91.83, "19095": 8.17}',
    density: 3.1,
    imprecise: false,
    latitude: 41.4576,
    longitude: -92.18387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52355',
  },
  {
    city: 'Wellman',
    county_fips: 19183,
    county_fips_all: '19183|19095|19103|19107',
    county: 'Washington',
    county_names_all: 'Washington|Iowa|Johnson|Keokuk',
    county_weights:
      '{"19183": 73.71, "19095": 16.85, "19103": 8.16, "19107": 1.28}',
    density: 10.8,
    imprecise: false,
    latitude: 41.4749,
    longitude: -91.84769,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52356',
  },
  {
    city: 'West Branch',
    county_fips: 19031,
    county_fips_all: '19031|19103',
    county: 'Cedar',
    county_names_all: 'Cedar|Johnson',
    county_weights: '{"19031": 82.52, "19103": 17.48}',
    density: 17.7,
    imprecise: false,
    latitude: 41.69644,
    longitude: -91.32097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52358',
  },
  {
    city: 'West Chester',
    county_fips: 19183,
    county_fips_all: '19183',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"19183": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 41.35428,
    longitude: -91.81006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52359',
  },
  {
    city: 'Williamsburg',
    county_fips: 19095,
    county_fips_all: '19095',
    county: 'Iowa',
    county_names_all: 'Iowa',
    county_weights: '{"19095": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 41.6446,
    longitude: -92.0154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52361',
  },
  {
    city: 'Wyoming',
    county_fips: 19105,
    county_fips_all: '19105',
    county: 'Jones',
    county_names_all: 'Jones',
    county_weights: '{"19105": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 42.05881,
    longitude: -91.00258,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52362',
  },
  {
    city: 'Cedar Rapids',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 707.4,
    imprecise: false,
    latitude: 41.97534,
    longitude: -91.65871,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52401',
  },
  {
    city: 'Cedar Rapids',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 1211.3,
    imprecise: false,
    latitude: 42.02272,
    longitude: -91.66001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52402',
  },
  {
    city: 'Cedar Rapids',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 331.2,
    imprecise: false,
    latitude: 41.96813,
    longitude: -91.57964,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52403',
  },
  {
    city: 'Cedar Rapids',
    county_fips: 19113,
    county_fips_all: '19113|19103',
    county: 'Linn',
    county_names_all: 'Linn|Johnson',
    county_weights: '{"19113": 94.99, "19103": 5.01}',
    density: 292.8,
    imprecise: false,
    latitude: 41.92153,
    longitude: -91.69077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52404',
  },
  {
    city: 'Cedar Rapids',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 683.9,
    imprecise: false,
    latitude: 41.98644,
    longitude: -91.74774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52405',
  },
  {
    city: 'Cedar Rapids',
    county_fips: 19113,
    county_fips_all: '19113',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"19113": 100}',
    density: 196.5,
    imprecise: false,
    latitude: 42.05093,
    longitude: -91.72723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52411',
  },
  {
    city: 'Ottumwa',
    county_fips: 19179,
    county_fips_all: '19179|19107|19123',
    county: 'Wapello',
    county_names_all: 'Wapello|Keokuk|Mahaska',
    county_weights: '{"19179": 99.35, "19107": 0.43, "19123": 0.22}',
    density: 52,
    imprecise: false,
    latitude: 41.03828,
    longitude: -92.43252,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52501',
  },
  {
    city: 'Agency',
    county_fips: 19179,
    county_fips_all: '19179',
    county: 'Wapello',
    county_names_all: 'Wapello',
    county_weights: '{"19179": 100}',
    density: 20.7,
    imprecise: false,
    latitude: 40.98953,
    longitude: -92.29492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52530',
  },
  {
    city: 'Albia',
    county_fips: 19135,
    county_fips_all: '19135|19179',
    county: 'Monroe',
    county_names_all: 'Monroe|Wapello',
    county_weights: '{"19135": 99.05, "19179": 0.95}',
    density: 10.5,
    imprecise: false,
    latitude: 41.02684,
    longitude: -92.81562,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52531',
  },
  {
    city: 'Batavia',
    county_fips: 19101,
    county_fips_all: '19101|19179',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Wapello',
    county_weights: '{"19101": 68.91, "19179": 31.09}',
    density: 5.3,
    imprecise: false,
    latitude: 41.01228,
    longitude: -92.15043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52533',
  },
  {
    city: 'Beacon',
    county_fips: 19123,
    county_fips_all: '19123',
    county: 'Mahaska',
    county_names_all: 'Mahaska',
    county_weights: '{"19123": 100}',
    density: 161.3,
    imprecise: false,
    latitude: 41.27342,
    longitude: -92.6806,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52534',
  },
  {
    city: 'Birmingham',
    county_fips: 19177,
    county_fips_all: '19177|19101',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Jefferson',
    county_weights: '{"19177": 82.62, "19101": 17.38}',
    density: 5,
    imprecise: false,
    latitude: 40.86533,
    longitude: -91.96407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52535',
  },
  {
    city: 'Blakesburg',
    county_fips: 19179,
    county_fips_all: '19179|19135',
    county: 'Wapello',
    county_names_all: 'Wapello|Monroe',
    county_weights: '{"19179": 67.55, "19135": 32.45}',
    density: 5.2,
    imprecise: false,
    latitude: 40.95291,
    longitude: -92.61802,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52536',
  },
  {
    city: 'Bloomfield',
    county_fips: 19051,
    county_fips_all: '19051|19179',
    county: 'Davis',
    county_names_all: 'Davis|Wapello',
    county_weights: '{"19051": 95.55, "19179": 4.45}',
    density: 8.1,
    imprecise: false,
    latitude: 40.7355,
    longitude: -92.41426,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52537',
  },
  {
    city: 'Brighton',
    county_fips: 19101,
    county_fips_all: '19101|19183',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Washington',
    county_weights: '{"19101": 52.97, "19183": 47.03}',
    density: 4.4,
    imprecise: false,
    latitude: 41.15769,
    longitude: -91.82281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52540',
  },
  {
    city: 'Cantril',
    county_fips: 19177,
    county_fips_all: '19177|29199',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Scotland',
    county_weights: '{"19177": 80.48, "29199": 19.52}',
    density: 4.8,
    imprecise: false,
    latitude: 40.62712,
    longitude: -92.05164,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52542',
  },
  {
    city: 'Cedar',
    county_fips: 19123,
    county_fips_all: '19123',
    county: 'Mahaska',
    county_names_all: 'Mahaska',
    county_weights: '{"19123": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 41.20065,
    longitude: -92.51773,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52543',
  },
  {
    city: 'Centerville',
    county_fips: 19007,
    county_fips_all: '19007',
    county: 'Appanoose',
    county_names_all: 'Appanoose',
    county_weights: '{"19007": 100}',
    density: 22.7,
    imprecise: false,
    latitude: 40.71774,
    longitude: -92.90831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52544',
  },
  {
    city: 'Chillicothe',
    county_fips: 19179,
    county_fips_all: '19179',
    county: 'Wapello',
    county_names_all: 'Wapello',
    county_weights: '{"19179": 100}',
    density: 163.1,
    imprecise: false,
    latitude: 41.0855,
    longitude: -92.5306,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52548',
  },
  {
    city: 'Cincinnati',
    county_fips: 19007,
    county_fips_all: '19007',
    county: 'Appanoose',
    county_names_all: 'Appanoose',
    county_weights: '{"19007": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 40.61392,
    longitude: -92.94602,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52549',
  },
  {
    city: 'Delta',
    county_fips: 19107,
    county_fips_all: '19107|19123',
    county: 'Keokuk',
    county_names_all: 'Keokuk|Mahaska',
    county_weights: '{"19107": 97.62, "19123": 2.38}',
    density: 5.6,
    imprecise: false,
    latitude: 41.31635,
    longitude: -92.36254,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52550',
  },
  {
    city: 'Douds',
    county_fips: 19177,
    county_fips_all: '19177|19051',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Davis',
    county_weights: '{"19177": 91.99, "19051": 8.01}',
    density: 5.2,
    imprecise: false,
    latitude: 40.81877,
    longitude: -92.1058,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52551',
  },
  {
    city: 'Drakesville',
    county_fips: 19051,
    county_fips_all: '19051|19179',
    county: 'Davis',
    county_names_all: 'Davis|Wapello',
    county_weights: '{"19051": 95.83, "19179": 4.17}',
    density: 6.2,
    imprecise: false,
    latitude: 40.83552,
    longitude: -92.53633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52552',
  },
  {
    city: 'Eddyville',
    county_fips: 19179,
    county_fips_all: '19179|19123|19135',
    county: 'Wapello',
    county_names_all: 'Wapello|Mahaska|Monroe',
    county_weights: '{"19179": 37.08, "19123": 33.85, "19135": 29.07}',
    density: 8.7,
    imprecise: false,
    latitude: 41.14865,
    longitude: -92.65668,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52553',
  },
  {
    city: 'Eldon',
    county_fips: 19179,
    county_fips_all: '19179|19051|19101|19177',
    county: 'Wapello',
    county_names_all: 'Wapello|Davis|Jefferson|Van Buren',
    county_weights:
      '{"19179": 76.41, "19051": 10.44, "19101": 9.1, "19177": 4.05}',
    density: 11,
    imprecise: false,
    latitude: 40.92562,
    longitude: -92.23387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52554',
  },
  {
    city: 'Exline',
    county_fips: 19007,
    county_fips_all: '19007',
    county: 'Appanoose',
    county_names_all: 'Appanoose',
    county_weights: '{"19007": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 40.63905,
    longitude: -92.81046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52555',
  },
  {
    city: 'Fairfield',
    county_fips: 19101,
    county_fips_all: '19101',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"19101": 100}',
    density: 25.2,
    imprecise: false,
    latitude: 41.01842,
    longitude: -91.9264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52556',
  },
  {
    city: 'Floris',
    county_fips: 19051,
    county_fips_all: '19051',
    county: 'Davis',
    county_names_all: 'Davis',
    county_weights: '{"19051": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 40.85491,
    longitude: -92.25312,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52560',
  },
  {
    city: 'Fremont',
    county_fips: 19123,
    county_fips_all: '19123|19107',
    county: 'Mahaska',
    county_names_all: 'Mahaska|Keokuk',
    county_weights: '{"19123": 83.7, "19107": 16.3}',
    density: 11.5,
    imprecise: false,
    latitude: 41.22135,
    longitude: -92.44081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52561',
  },
  {
    city: 'Hayesville',
    county_fips: 19107,
    county_fips_all: '19107',
    county: 'Keokuk',
    county_names_all: 'Keokuk',
    county_weights: '{"19107": 100}',
    density: 106.1,
    imprecise: false,
    latitude: 41.26539,
    longitude: -92.24858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52562',
  },
  {
    city: 'Hedrick',
    county_fips: 19107,
    county_fips_all: '19107|19179|19101',
    county: 'Keokuk',
    county_names_all: 'Keokuk|Wapello|Jefferson',
    county_weights: '{"19107": 58.29, "19179": 38.22, "19101": 3.49}',
    density: 5.7,
    imprecise: false,
    latitude: 41.17295,
    longitude: -92.27765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52563',
  },
  {
    city: 'Keosauqua',
    county_fips: 19177,
    county_fips_all: '19177',
    county: 'Van Buren',
    county_names_all: 'Van Buren',
    county_weights: '{"19177": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 40.74005,
    longitude: -91.94332,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52565',
  },
  {
    city: 'Kirkville',
    county_fips: 19179,
    county_fips_all: '19179',
    county: 'Wapello',
    county_names_all: 'Wapello',
    county_weights: '{"19179": 100}',
    density: 62.1,
    imprecise: false,
    latitude: 41.12887,
    longitude: -92.50547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52566',
  },
  {
    city: 'Libertyville',
    county_fips: 19101,
    county_fips_all: '19101|19177',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Van Buren',
    county_weights: '{"19101": 89.28, "19177": 10.72}',
    density: 7.7,
    imprecise: false,
    latitude: 40.93174,
    longitude: -92.07224,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52567',
  },
  {
    city: 'Martinsburg',
    county_fips: 19107,
    county_fips_all: '19107',
    county: 'Keokuk',
    county_names_all: 'Keokuk',
    county_weights: '{"19107": 100}',
    density: 117.9,
    imprecise: false,
    latitude: 41.1779,
    longitude: -92.25077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52568',
  },
  {
    city: 'Melrose',
    county_fips: 19135,
    county_fips_all: '19135|19007|19185|19117',
    county: 'Monroe',
    county_names_all: 'Monroe|Appanoose|Wayne|Lucas',
    county_weights:
      '{"19135": 80.6, "19007": 7.15, "19185": 6.37, "19117": 5.88}',
    density: 2.1,
    imprecise: false,
    latitude: 40.97968,
    longitude: -93.04939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52569',
  },
  {
    city: 'Milton',
    county_fips: 19177,
    county_fips_all: '19177|19051',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Davis',
    county_weights: '{"19177": 73.62, "19051": 26.38}',
    density: 6.7,
    imprecise: false,
    latitude: 40.68656,
    longitude: -92.14853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52570',
  },
  {
    city: 'Moravia',
    county_fips: 19007,
    county_fips_all: '19007|19135',
    county: 'Appanoose',
    county_names_all: 'Appanoose|Monroe',
    county_weights: '{"19007": 72.52, "19135": 27.48}',
    density: 6.7,
    imprecise: false,
    latitude: 40.87739,
    longitude: -92.83114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52571',
  },
  {
    city: 'Moulton',
    county_fips: 19007,
    county_fips_all: '19007|19051',
    county: 'Appanoose',
    county_names_all: 'Appanoose|Davis',
    county_weights: '{"19007": 84.12, "19051": 15.88}',
    density: 3.3,
    imprecise: false,
    latitude: 40.67795,
    longitude: -92.69163,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52572',
  },
  {
    city: 'Mount Sterling',
    county_fips: 19177,
    county_fips_all: '19177|29045|29199',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Clark|Scotland',
    county_weights: '{"19177": 65.33, "29045": 23.85, "29199": 10.82}',
    density: 1.5,
    imprecise: false,
    latitude: 40.62378,
    longitude: -91.92979,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52573',
  },
  {
    city: 'Mystic',
    county_fips: 19007,
    county_fips_all: '19007',
    county: 'Appanoose',
    county_names_all: 'Appanoose',
    county_weights: '{"19007": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 40.80822,
    longitude: -92.96948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52574',
  },
  {
    city: 'Ollie',
    county_fips: 19107,
    county_fips_all: '19107|19101',
    county: 'Keokuk',
    county_names_all: 'Keokuk|Jefferson',
    county_weights: '{"19107": 98.9, "19101": 1.1}',
    density: 3.1,
    imprecise: false,
    latitude: 41.21337,
    longitude: -92.1125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52576',
  },
  {
    city: 'Oskaloosa',
    county_fips: 19123,
    county_fips_all: '19123',
    county: 'Mahaska',
    county_names_all: 'Mahaska',
    county_weights: '{"19123": 100}',
    density: 35.6,
    imprecise: false,
    latitude: 41.27174,
    longitude: -92.6602,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52577',
  },
  {
    city: 'Packwood',
    county_fips: 19101,
    county_fips_all: '19101|19107',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Keokuk',
    county_weights: '{"19101": 97.57, "19107": 2.43}',
    density: 6.8,
    imprecise: false,
    latitude: 41.12039,
    longitude: -92.09069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52580',
  },
  {
    city: 'Plano',
    county_fips: 19007,
    county_fips_all: '19007|19185',
    county: 'Appanoose',
    county_names_all: 'Appanoose|Wayne',
    county_weights: '{"19007": 96.24, "19185": 3.76}',
    density: 1.7,
    imprecise: false,
    latitude: 40.80504,
    longitude: -93.06265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52581',
  },
  {
    city: 'Promise City',
    county_fips: 19185,
    county_fips_all: '19185',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"19185": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 40.80284,
    longitude: -93.1555,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52583',
  },
  {
    city: 'Pulaski',
    county_fips: 19051,
    county_fips_all: '19051',
    county: 'Davis',
    county_names_all: 'Davis',
    county_weights: '{"19051": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 40.65273,
    longitude: -92.24936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52584',
  },
  {
    city: 'Richland',
    county_fips: 19107,
    county_fips_all: '19107|19101|19183',
    county: 'Keokuk',
    county_names_all: 'Keokuk|Jefferson|Washington',
    county_weights: '{"19107": 60.34, "19101": 29.1, "19183": 10.56}',
    density: 5.9,
    imprecise: false,
    latitude: 41.18902,
    longitude: -91.98863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52585',
  },
  {
    city: 'Rose Hill',
    county_fips: 19123,
    county_fips_all: '19123|19107',
    county: 'Mahaska',
    county_names_all: 'Mahaska|Keokuk',
    county_weights: '{"19123": 96.86, "19107": 3.14}',
    density: 5,
    imprecise: false,
    latitude: 41.34573,
    longitude: -92.46694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52586',
  },
  {
    city: 'Selma',
    county_fips: 19177,
    county_fips_all: '19177|19051|19101',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Davis|Jefferson',
    county_weights: '{"19177": 67.14, "19051": 30.95, "19101": 1.91}',
    density: 2.2,
    imprecise: false,
    latitude: 40.86325,
    longitude: -92.16315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52588',
  },
  {
    city: 'Seymour',
    county_fips: 19185,
    county_fips_all: '19185|19007',
    county: 'Wayne',
    county_names_all: 'Wayne|Appanoose',
    county_weights: '{"19185": 78.9, "19007": 21.1}',
    density: 6.9,
    imprecise: false,
    latitude: 40.6654,
    longitude: -93.13594,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52590',
  },
  {
    city: 'Sigourney',
    county_fips: 19107,
    county_fips_all: '19107',
    county: 'Keokuk',
    county_names_all: 'Keokuk',
    county_weights: '{"19107": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 41.31988,
    longitude: -92.19465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52591',
  },
  {
    city: 'Udell',
    county_fips: 19007,
    county_fips_all: '19007',
    county: 'Appanoose',
    county_names_all: 'Appanoose',
    county_weights: '{"19007": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 40.77363,
    longitude: -92.73955,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52593',
  },
  {
    city: 'Unionville',
    county_fips: 19007,
    county_fips_all: '19007|19051',
    county: 'Appanoose',
    county_names_all: 'Appanoose|Davis',
    county_weights: '{"19007": 61.7, "19051": 38.3}',
    density: 5.5,
    imprecise: false,
    latitude: 40.83561,
    longitude: -92.64957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52594',
  },
  {
    city: 'University Park',
    county_fips: 19123,
    county_fips_all: '19123',
    county: 'Mahaska',
    county_names_all: 'Mahaska',
    county_weights: '{"19123": 100}',
    density: 446,
    imprecise: false,
    latitude: 41.28847,
    longitude: -92.61506,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52595',
  },
  {
    city: 'Burlington',
    county_fips: 19057,
    county_fips_all: '19057',
    county: 'Des Moines',
    county_names_all: 'Des Moines',
    county_weights: '{"19057": 100}',
    density: 96.5,
    imprecise: false,
    latitude: 40.8551,
    longitude: -91.111,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52601',
  },
  {
    city: 'Argyle',
    county_fips: 19111,
    county_fips_all: '19111',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"19111": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 40.5246,
    longitude: -91.56566,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52619',
  },
  {
    city: 'Bonaparte',
    county_fips: 19177,
    county_fips_all: '19177',
    county: 'Van Buren',
    county_names_all: 'Van Buren',
    county_weights: '{"19177": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 40.7032,
    longitude: -91.79563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52620',
  },
  {
    city: 'Crawfordsville',
    county_fips: 19183,
    county_fips_all: '19183|19115',
    county: 'Washington',
    county_names_all: 'Washington|Louisa',
    county_weights: '{"19183": 84.64, "19115": 15.36}',
    density: 5.7,
    imprecise: false,
    latitude: 41.20821,
    longitude: -91.53209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52621',
  },
  {
    city: 'Danville',
    county_fips: 19057,
    county_fips_all: '19057|19087',
    county: 'Des Moines',
    county_names_all: 'Des Moines|Henry',
    county_weights: '{"19057": 77.18, "19087": 22.82}',
    density: 13.6,
    imprecise: false,
    latitude: 40.85569,
    longitude: -91.33998,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52623',
  },
  {
    city: 'Denmark',
    county_fips: 19111,
    county_fips_all: '19111',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"19111": 100}',
    density: 306.6,
    imprecise: false,
    latitude: 40.7348,
    longitude: -91.33609,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52624',
  },
  {
    city: 'Donnellson',
    county_fips: 19111,
    county_fips_all: '19111',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"19111": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 40.66604,
    longitude: -91.57094,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52625',
  },
  {
    city: 'Farmington',
    county_fips: 19111,
    county_fips_all: '19111|19177|29045',
    county: 'Lee',
    county_names_all: 'Lee|Van Buren|Clark',
    county_weights: '{"19111": 54.1, "19177": 24.67, "29045": 21.23}',
    density: 4.8,
    imprecise: false,
    latitude: 40.63201,
    longitude: -91.72119,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52626',
  },
  {
    city: 'Fort Madison',
    county_fips: 19111,
    county_fips_all: '19111',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"19111": 100}',
    density: 76.6,
    imprecise: false,
    latitude: 40.65973,
    longitude: -91.35145,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52627',
  },
  {
    city: 'Hillsboro',
    county_fips: 19111,
    county_fips_all: '19111|19177|19087',
    county: 'Lee',
    county_names_all: 'Lee|Van Buren|Henry',
    county_weights: '{"19111": 38.8, "19177": 33.33, "19087": 27.87}',
    density: 2.2,
    imprecise: false,
    latitude: 40.80375,
    longitude: -91.7038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52630',
  },
  {
    city: 'Houghton',
    county_fips: 19111,
    county_fips_all: '19111',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"19111": 100}',
    density: 124.4,
    imprecise: false,
    latitude: 40.78308,
    longitude: -91.61209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52631',
  },
  {
    city: 'Keokuk',
    county_fips: 19111,
    county_fips_all: '19111',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"19111": 100}',
    density: 87.3,
    imprecise: false,
    latitude: 40.44072,
    longitude: -91.43973,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52632',
  },
  {
    city: 'Lockridge',
    county_fips: 19101,
    county_fips_all: '19101|19087',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Henry',
    county_weights: '{"19101": 93.54, "19087": 6.46}',
    density: 8,
    imprecise: false,
    latitude: 40.99117,
    longitude: -91.75843,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52635',
  },
  {
    city: 'Mediapolis',
    county_fips: 19057,
    county_fips_all: '19057',
    county: 'Des Moines',
    county_names_all: 'Des Moines',
    county_weights: '{"19057": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 41.01949,
    longitude: -91.13774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52637',
  },
  {
    city: 'Middletown',
    county_fips: 19057,
    county_fips_all: '19057',
    county: 'Des Moines',
    county_names_all: 'Des Moines',
    county_weights: '{"19057": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 40.79864,
    longitude: -91.24577,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52638',
  },
  {
    city: 'Montrose',
    county_fips: 19111,
    county_fips_all: '19111',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"19111": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 40.52763,
    longitude: -91.46409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52639',
  },
  {
    city: 'Morning Sun',
    county_fips: 19115,
    county_fips_all: '19115|19057',
    county: 'Louisa',
    county_names_all: 'Louisa|Des Moines',
    county_weights: '{"19115": 66.6, "19057": 33.4}',
    density: 7.2,
    imprecise: false,
    latitude: 41.09649,
    longitude: -91.28205,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52640',
  },
  {
    city: 'Mount Pleasant',
    county_fips: 19087,
    county_fips_all: '19087|19183|19101',
    county: 'Henry',
    county_names_all: 'Henry|Washington|Jefferson',
    county_weights: '{"19087": 96.0, "19183": 2.18, "19101": 1.82}',
    density: 22.7,
    imprecise: false,
    latitude: 40.98799,
    longitude: -91.58531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52641',
  },
  {
    city: 'Mount Union',
    county_fips: 19087,
    county_fips_all: '19087|19057',
    county: 'Henry',
    county_names_all: 'Henry|Des Moines',
    county_weights: '{"19087": 85.12, "19057": 14.88}',
    density: 3.5,
    imprecise: false,
    latitude: 41.03988,
    longitude: -91.41535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52644',
  },
  {
    city: 'New London',
    county_fips: 19087,
    county_fips_all: '19087|19057',
    county: 'Henry',
    county_names_all: 'Henry|Des Moines',
    county_weights: '{"19087": 70.16, "19057": 29.84}',
    density: 19.2,
    imprecise: false,
    latitude: 40.91429,
    longitude: -91.40138,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52645',
  },
  {
    city: 'Oakville',
    county_fips: 19057,
    county_fips_all: '19057|19115',
    county: 'Des Moines',
    county_names_all: 'Des Moines|Louisa',
    county_weights: '{"19057": 53.14, "19115": 46.86}',
    density: 1.8,
    imprecise: false,
    latitude: 41.06706,
    longitude: -91.00072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52646',
  },
  {
    city: 'Olds',
    county_fips: 19087,
    county_fips_all: '19087',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"19087": 100}',
    density: 97.7,
    imprecise: false,
    latitude: 41.1342,
    longitude: -91.54506,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52647',
  },
  {
    city: 'Salem',
    county_fips: 19087,
    county_fips_all: '19087|19111',
    county: 'Henry',
    county_names_all: 'Henry|Lee',
    county_weights: '{"19087": 74.69, "19111": 25.31}',
    density: 8.4,
    imprecise: false,
    latitude: 40.83827,
    longitude: -91.60647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52649',
  },
  {
    city: 'Sperry',
    county_fips: 19057,
    county_fips_all: '19057',
    county: 'Des Moines',
    county_names_all: 'Des Moines',
    county_weights: '{"19057": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 40.94782,
    longitude: -91.15687,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52650',
  },
  {
    city: 'Stockport',
    county_fips: 19177,
    county_fips_all: '19177|19101',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Jefferson',
    county_weights: '{"19177": 89.59, "19101": 10.41}',
    density: 2.4,
    imprecise: false,
    latitude: 40.85819,
    longitude: -91.81323,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52651',
  },
  {
    city: 'Swedesburg',
    county_fips: 19087,
    county_fips_all: '19087',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"19087": 100}',
    density: 44.3,
    imprecise: false,
    latitude: 41.09796,
    longitude: -91.5542,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52652',
  },
  {
    city: 'Wapello',
    county_fips: 19115,
    county_fips_all: '19115',
    county: 'Louisa',
    county_names_all: 'Louisa',
    county_weights: '{"19115": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 41.16642,
    longitude: -91.15597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52653',
  },
  {
    city: 'Wayland',
    county_fips: 19087,
    county_fips_all: '19087|19183|19101',
    county: 'Henry',
    county_names_all: 'Henry|Washington|Jefferson',
    county_weights: '{"19087": 67.2, "19183": 30.48, "19101": 2.32}',
    density: 13.3,
    imprecise: false,
    latitude: 41.13581,
    longitude: -91.66898,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52654',
  },
  {
    city: 'West Burlington',
    county_fips: 19057,
    county_fips_all: '19057',
    county: 'Des Moines',
    county_names_all: 'Des Moines',
    county_weights: '{"19057": 100}',
    density: 95.3,
    imprecise: false,
    latitude: 40.84768,
    longitude: -91.21174,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52655',
  },
  {
    city: 'West Point',
    county_fips: 19111,
    county_fips_all: '19111|19087',
    county: 'Lee',
    county_names_all: 'Lee|Henry',
    county_weights: '{"19111": 98.83, "19087": 1.17}',
    density: 7.2,
    imprecise: false,
    latitude: 40.73844,
    longitude: -91.4611,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52656',
  },
  {
    city: 'Saint Paul',
    county_fips: 19111,
    county_fips_all: '19111',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"19111": 100}',
    density: 66,
    imprecise: false,
    latitude: 40.76784,
    longitude: -91.5164,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52657',
  },
  {
    city: 'Wever',
    county_fips: 19111,
    county_fips_all: '19111|19057',
    county: 'Lee',
    county_names_all: 'Lee|Des Moines',
    county_weights: '{"19111": 98.29, "19057": 1.71}',
    density: 7.6,
    imprecise: false,
    latitude: 40.69998,
    longitude: -91.22657,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52658',
  },
  {
    city: 'Winfield',
    county_fips: 19087,
    county_fips_all: '19087|19115',
    county: 'Henry',
    county_names_all: 'Henry|Louisa',
    county_weights: '{"19087": 70.58, "19115": 29.42}',
    density: 7.7,
    imprecise: false,
    latitude: 41.13285,
    longitude: -91.43658,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52659',
  },
  {
    city: 'Yarmouth',
    county_fips: 19057,
    county_fips_all: '19057',
    county: 'Des Moines',
    county_names_all: 'Des Moines',
    county_weights: '{"19057": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 40.99146,
    longitude: -91.29998,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52660',
  },
  {
    city: 'Andover',
    county_fips: 19045,
    county_fips_all: '19045',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"19045": 100}',
    density: 75.9,
    imprecise: false,
    latitude: 41.98198,
    longitude: -90.24908,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52701',
  },
  {
    city: 'Atalissa',
    county_fips: 19139,
    county_fips_all: '19139|19031',
    county: 'Muscatine',
    county_names_all: 'Muscatine|Cedar',
    county_weights: '{"19139": 63.24, "19031": 36.76}',
    density: 8.9,
    imprecise: false,
    latitude: 41.59064,
    longitude: -91.16578,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52720',
  },
  {
    city: 'Bennett',
    county_fips: 19031,
    county_fips_all: '19031',
    county: 'Cedar',
    county_names_all: 'Cedar',
    county_weights: '{"19031": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 41.75588,
    longitude: -90.9633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52721',
  },
  {
    city: 'Bettendorf',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 605.6,
    imprecise: false,
    latitude: 41.56633,
    longitude: -90.4673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52722',
  },
  {
    city: 'Blue Grass',
    county_fips: 19163,
    county_fips_all: '19163|19139',
    county: 'Scott',
    county_names_all: 'Scott|Muscatine',
    county_weights: '{"19163": 54.71, "19139": 45.29}',
    density: 60.7,
    imprecise: false,
    latitude: 41.50092,
    longitude: -90.78419,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52726',
  },
  {
    city: 'Bryant',
    county_fips: 19045,
    county_fips_all: '19045',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"19045": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 41.95834,
    longitude: -90.33341,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52727',
  },
  {
    city: 'Buffalo',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 123.7,
    imprecise: false,
    latitude: 41.45907,
    longitude: -90.72592,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52728',
  },
  {
    city: 'Calamus',
    county_fips: 19045,
    county_fips_all: '19045|19163',
    county: 'Clinton',
    county_names_all: 'Clinton|Scott',
    county_weights: '{"19045": 98.79, "19163": 1.21}',
    density: 8.6,
    imprecise: false,
    latitude: 41.80063,
    longitude: -90.74312,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52729',
  },
  {
    city: 'Camanche',
    county_fips: 19045,
    county_fips_all: '19045',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"19045": 100}',
    density: 48.6,
    imprecise: false,
    latitude: 41.77366,
    longitude: -90.34364,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52730',
  },
  {
    city: 'Charlotte',
    county_fips: 19045,
    county_fips_all: '19045|19097',
    county: 'Clinton',
    county_names_all: 'Clinton|Jackson',
    county_weights: '{"19045": 98.22, "19097": 1.78}',
    density: 6.4,
    imprecise: false,
    latitude: 41.96637,
    longitude: -90.48551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52731',
  },
  {
    city: 'Clinton',
    county_fips: 19045,
    county_fips_all: '19045',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"19045": 100}',
    density: 91.1,
    imprecise: false,
    latitude: 41.90126,
    longitude: -90.25083,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52732',
  },
  {
    city: 'Columbus City',
    county_fips: 19115,
    county_fips_all: '19115',
    county: 'Louisa',
    county_names_all: 'Louisa',
    county_weights: '{"19115": 100}',
    density: 518.7,
    imprecise: false,
    latitude: 41.25918,
    longitude: -91.37478,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52737',
  },
  {
    city: 'Columbus Junction',
    county_fips: 19115,
    county_fips_all: '19115|19183',
    county: 'Louisa',
    county_names_all: 'Louisa|Washington',
    county_weights: '{"19115": 97.38, "19183": 2.62}',
    density: 10.7,
    imprecise: false,
    latitude: 41.2736,
    longitude: -91.38072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52738',
  },
  {
    city: 'Conesville',
    county_fips: 19115,
    county_fips_all: '19115|19139',
    county: 'Louisa',
    county_names_all: 'Louisa|Muscatine',
    county_weights: '{"19115": 56.6, "19139": 43.4}',
    density: 9.3,
    imprecise: false,
    latitude: 41.3728,
    longitude: -91.36823,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52739',
  },
  {
    city: 'De Witt',
    county_fips: 19045,
    county_fips_all: '19045',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"19045": 100}',
    density: 24,
    imprecise: false,
    latitude: 41.83616,
    longitude: -90.51076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52742',
  },
  {
    city: 'Dixon',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 41.71502,
    longitude: -90.75783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52745',
  },
  {
    city: 'Donahue',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 41.71945,
    longitude: -90.67172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52746',
  },
  {
    city: 'Durant',
    county_fips: 19139,
    county_fips_all: '19139|19031|19163',
    county: 'Muscatine',
    county_names_all: 'Muscatine|Cedar|Scott',
    county_weights: '{"19139": 45.43, "19031": 36.12, "19163": 18.45}',
    density: 27.7,
    imprecise: false,
    latitude: 41.59758,
    longitude: -90.91147,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52747',
  },
  {
    city: 'Eldridge',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 92.1,
    imprecise: false,
    latitude: 41.66471,
    longitude: -90.55713,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52748',
  },
  {
    city: 'Fruitland',
    county_fips: 19139,
    county_fips_all: '19139|19115',
    county: 'Muscatine',
    county_names_all: 'Muscatine|Louisa',
    county_weights: '{"19139": 99.78, "19115": 0.22}',
    density: 188.8,
    imprecise: false,
    latitude: 41.34608,
    longitude: -91.13112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52749',
  },
  {
    city: 'Goose Lake',
    county_fips: 19045,
    county_fips_all: '19045',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"19045": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 41.933,
    longitude: -90.39302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52750',
  },
  {
    city: 'Grand Mound',
    county_fips: 19045,
    county_fips_all: '19045',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"19045": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 41.8519,
    longitude: -90.68398,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52751',
  },
  {
    city: 'Grandview',
    county_fips: 19115,
    county_fips_all: '19115',
    county: 'Louisa',
    county_names_all: 'Louisa',
    county_weights: '{"19115": 100}',
    density: 412.2,
    imprecise: false,
    latitude: 41.27465,
    longitude: -91.1911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52752',
  },
  {
    city: 'Le Claire',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 94,
    imprecise: false,
    latitude: 41.62544,
    longitude: -90.38989,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52753',
  },
  {
    city: 'Letts',
    county_fips: 19139,
    county_fips_all: '19139|19115',
    county: 'Muscatine',
    county_names_all: 'Muscatine|Louisa',
    county_weights: '{"19139": 53.54, "19115": 46.46}',
    density: 8.1,
    imprecise: false,
    latitude: 41.34254,
    longitude: -91.24144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52754',
  },
  {
    city: 'Lone Tree',
    county_fips: 19103,
    county_fips_all: '19103|19115',
    county: 'Johnson',
    county_names_all: 'Johnson|Louisa',
    county_weights: '{"19103": 91.39, "19115": 8.61}',
    density: 14,
    imprecise: false,
    latitude: 41.48015,
    longitude: -91.43349,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52755',
  },
  {
    city: 'Long Grove',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 41.72966,
    longitude: -90.54084,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52756',
  },
  {
    city: 'Low Moor',
    county_fips: 19045,
    county_fips_all: '19045',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"19045": 100}',
    density: 190.6,
    imprecise: false,
    latitude: 41.80337,
    longitude: -90.3552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52757',
  },
  {
    city: 'McCausland',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 137.3,
    imprecise: false,
    latitude: 41.74405,
    longitude: -90.44104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52758',
  },
  {
    city: 'Montpelier',
    county_fips: 19139,
    county_fips_all: '19139',
    county: 'Muscatine',
    county_names_all: 'Muscatine',
    county_weights: '{"19139": 100}',
    density: 274.7,
    imprecise: false,
    latitude: 41.46043,
    longitude: -90.80989,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52759',
  },
  {
    city: 'Moscow',
    county_fips: 19139,
    county_fips_all: '19139|19031',
    county: 'Muscatine',
    county_names_all: 'Muscatine|Cedar',
    county_weights: '{"19139": 58.58, "19031": 41.42}',
    density: 17.5,
    imprecise: false,
    latitude: 41.58255,
    longitude: -91.09853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52760',
  },
  {
    city: 'Muscatine',
    county_fips: 19139,
    county_fips_all: '19139|19115',
    county: 'Muscatine',
    county_names_all: 'Muscatine|Louisa',
    county_weights: '{"19139": 89.99, "19115": 10.01}',
    density: 63.9,
    imprecise: false,
    latitude: 41.43798,
    longitude: -91.05802,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52761',
  },
  {
    city: 'New Liberty',
    county_fips: 19163,
    county_fips_all: '19163|19031',
    county: 'Scott',
    county_names_all: 'Scott|Cedar',
    county_weights: '{"19163": 76.96, "19031": 23.04}',
    density: 5.1,
    imprecise: false,
    latitude: 41.72182,
    longitude: -90.87274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52765',
  },
  {
    city: 'Nichols',
    county_fips: 19139,
    county_fips_all: '19139|19103',
    county: 'Muscatine',
    county_names_all: 'Muscatine|Johnson',
    county_weights: '{"19139": 94.54, "19103": 5.46}',
    density: 5.4,
    imprecise: false,
    latitude: 41.46407,
    longitude: -91.30061,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52766',
  },
  {
    city: 'Pleasant Valley',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 108.8,
    imprecise: false,
    latitude: 41.57356,
    longitude: -90.42326,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52767',
  },
  {
    city: 'Princeton',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 41.69906,
    longitude: -90.38977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52768',
  },
  {
    city: 'Stockton',
    county_fips: 19163,
    county_fips_all: '19163|19139',
    county: 'Scott',
    county_names_all: 'Scott|Muscatine',
    county_weights: '{"19163": 50.88, "19139": 49.12}',
    density: 6.4,
    imprecise: false,
    latitude: 41.60836,
    longitude: -90.8416,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52769',
  },
  {
    city: 'Teeds Grove',
    county_fips: 19045,
    county_fips_all: '19045',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"19045": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 42.01958,
    longitude: -90.25707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52771',
  },
  {
    city: 'Tipton',
    county_fips: 19031,
    county_fips_all: '19031',
    county: 'Cedar',
    county_names_all: 'Cedar',
    county_weights: '{"19031": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 41.75006,
    longitude: -91.14083,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52772',
  },
  {
    city: 'Walcott',
    county_fips: 19163,
    county_fips_all: '19163|19139',
    county: 'Scott',
    county_names_all: 'Scott|Muscatine',
    county_weights: '{"19163": 96.42, "19139": 3.58}',
    density: 16.7,
    imprecise: false,
    latitude: 41.62187,
    longitude: -90.75529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52773',
  },
  {
    city: 'Welton',
    county_fips: 19045,
    county_fips_all: '19045',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"19045": 100}',
    density: 130.5,
    imprecise: false,
    latitude: 41.90743,
    longitude: -90.59596,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52774',
  },
  {
    city: 'West Liberty',
    county_fips: 19139,
    county_fips_all: '19139|19031|19103',
    county: 'Muscatine',
    county_names_all: 'Muscatine|Cedar|Johnson',
    county_weights: '{"19139": 62.39, "19031": 34.31, "19103": 3.3}',
    density: 22.6,
    imprecise: false,
    latitude: 41.5795,
    longitude: -91.275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52776',
  },
  {
    city: 'Wheatland',
    county_fips: 19045,
    county_fips_all: '19045|19031',
    county: 'Clinton',
    county_names_all: 'Clinton|Cedar',
    county_weights: '{"19045": 92.55, "19031": 7.45}',
    density: 9.6,
    imprecise: false,
    latitude: 41.84739,
    longitude: -90.85529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52777',
  },
  {
    city: 'Wilton',
    county_fips: 19031,
    county_fips_all: '19031|19139',
    county: 'Cedar',
    county_names_all: 'Cedar|Muscatine',
    county_weights: '{"19031": 60.33, "19139": 39.67}',
    density: 18.6,
    imprecise: false,
    latitude: 41.61115,
    longitude: -91.00066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52778',
  },
  {
    city: 'Davenport',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 1783,
    imprecise: false,
    latitude: 41.52082,
    longitude: -90.57483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52801',
  },
  {
    city: 'Davenport',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 350.5,
    imprecise: false,
    latitude: 41.49908,
    longitude: -90.63621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52802',
  },
  {
    city: 'Davenport',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 1708.5,
    imprecise: false,
    latitude: 41.53871,
    longitude: -90.55623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52803',
  },
  {
    city: 'Davenport',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 315,
    imprecise: false,
    latitude: 41.53584,
    longitude: -90.68081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52804',
  },
  {
    city: 'Davenport',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 333.8,
    imprecise: false,
    latitude: 41.58918,
    longitude: -90.62553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52806',
  },
  {
    city: 'Davenport',
    county_fips: 19163,
    county_fips_all: '19163',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"19163": 100}',
    density: 210.9,
    imprecise: false,
    latitude: 41.61061,
    longitude: -90.51634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52807',
  },
  {
    city: 'Adell',
    county_fips: 55117,
    county_fips_all: '55117',
    county: 'Sheboygan',
    county_names_all: 'Sheboygan',
    county_weights: '{"55117": 100}',
    density: 23.9,
    imprecise: false,
    latitude: 43.60562,
    longitude: -88.05217,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53001',
  },
  {
    city: 'Allenton',
    county_fips: 55131,
    county_fips_all: '55131|55027',
    county: 'Washington',
    county_names_all: 'Washington|Dodge',
    county_weights: '{"55131": 97.91, "55027": 2.09}',
    density: 29.1,
    imprecise: false,
    latitude: 43.46896,
    longitude: -88.35454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53002',
  },
  {
    city: 'Ashippun',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 303.5,
    imprecise: false,
    latitude: 43.21226,
    longitude: -88.51957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53003',
  },
  {
    city: 'Belgium',
    county_fips: 55089,
    county_fips_all: '55089',
    county: 'Ozaukee',
    county_names_all: 'Ozaukee',
    county_weights: '{"55089": 100}',
    density: 39.9,
    imprecise: false,
    latitude: 43.4995,
    longitude: -87.8805,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53004',
  },
  {
    city: 'Brookfield',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 569.8,
    imprecise: false,
    latitude: 43.0625,
    longitude: -88.0992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53005',
  },
  {
    city: 'Brownsville',
    county_fips: 55027,
    county_fips_all: '55027|55039',
    county: 'Dodge',
    county_names_all: 'Dodge|Fond du Lac',
    county_weights: '{"55027": 73.94, "55039": 26.06}',
    density: 18.4,
    imprecise: false,
    latitude: 43.62103,
    longitude: -88.53534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53006',
  },
  {
    city: 'Butler',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 933,
    imprecise: false,
    latitude: 43.10825,
    longitude: -88.07116,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53007',
  },
  {
    city: 'Campbellsport',
    county_fips: 55039,
    county_fips_all: '55039|55131|55027',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac|Washington|Dodge',
    county_weights: '{"55039": 95.02, "55131": 4.77, "55027": 0.21}',
    density: 27.5,
    imprecise: false,
    latitude: 43.61121,
    longitude: -88.27901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53010',
  },
  {
    city: 'Cascade',
    county_fips: 55117,
    county_fips_all: '55117|55039',
    county: 'Sheboygan',
    county_names_all: 'Sheboygan|Fond du Lac',
    county_weights: '{"55117": 98.66, "55039": 1.34}',
    density: 21.9,
    imprecise: false,
    latitude: 43.65755,
    longitude: -88.08123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53011',
  },
  {
    city: 'Cedarburg',
    county_fips: 55089,
    county_fips_all: '55089|55131',
    county: 'Ozaukee',
    county_names_all: 'Ozaukee|Washington',
    county_weights: '{"55089": 68.62, "55131": 31.38}',
    density: 218.8,
    imprecise: false,
    latitude: 43.31369,
    longitude: -88.03704,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53012',
  },
  {
    city: 'Cedar Grove',
    county_fips: 55117,
    county_fips_all: '55117|55089',
    county: 'Sheboygan',
    county_names_all: 'Sheboygan|Ozaukee',
    county_weights: '{"55117": 81.4, "55089": 18.6}',
    density: 48.2,
    imprecise: false,
    latitude: 43.56585,
    longitude: -87.85172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53013',
  },
  {
    city: 'Chilton',
    county_fips: 55015,
    county_fips_all: '55015|55071|55039',
    county: 'Calumet',
    county_names_all: 'Calumet|Manitowoc|Fond du Lac',
    county_weights: '{"55015": 87.72, "55071": 11.22, "55039": 1.06}',
    density: 23.4,
    imprecise: false,
    latitude: 44.02298,
    longitude: -88.17549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53014',
  },
  {
    city: 'Cleveland',
    county_fips: 55071,
    county_fips_all: '55071|55117',
    county: 'Manitowoc',
    county_names_all: 'Manitowoc|Sheboygan',
    county_weights: '{"55071": 64.74, "55117": 35.26}',
    density: 26.1,
    imprecise: false,
    latitude: 43.90534,
    longitude: -87.79296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53015',
  },
  {
    city: 'Clyman',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 226.3,
    imprecise: false,
    latitude: 43.31104,
    longitude: -88.71794,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53016',
  },
  {
    city: 'Colgate',
    county_fips: 55131,
    county_fips_all: '55131|55133',
    county: 'Washington',
    county_names_all: 'Washington|Waukesha',
    county_weights: '{"55131": 87.54, "55133": 12.46}',
    density: 122.2,
    imprecise: false,
    latitude: 43.2044,
    longitude: -88.2526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53017',
  },
  {
    city: 'Delafield',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 282.2,
    imprecise: false,
    latitude: 43.04809,
    longitude: -88.39278,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53018',
  },
  {
    city: 'Eden',
    county_fips: 55039,
    county_fips_all: '55039',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac',
    county_weights: '{"55039": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 43.69667,
    longitude: -88.30752,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53019',
  },
  {
    city: 'Elkhart Lake',
    county_fips: 55117,
    county_fips_all: '55117|55071|55015',
    county: 'Sheboygan',
    county_names_all: 'Sheboygan|Manitowoc|Calumet',
    county_weights: '{"55117": 95.29, "55071": 2.97, "55015": 1.74}',
    density: 21.1,
    imprecise: false,
    latitude: 43.86231,
    longitude: -88.01364,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53020',
  },
  {
    city: 'Fredonia',
    county_fips: 55089,
    county_fips_all: '55089|55131|55117',
    county: 'Ozaukee',
    county_names_all: 'Ozaukee|Washington|Sheboygan',
    county_weights: '{"55089": 80.88, "55131": 18.28, "55117": 0.84}',
    density: 52.4,
    imprecise: false,
    latitude: 43.49425,
    longitude: -88.00111,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53021',
  },
  {
    city: 'Germantown',
    county_fips: 55131,
    county_fips_all: '55131',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"55131": 100}',
    density: 279.3,
    imprecise: false,
    latitude: 43.23062,
    longitude: -88.11286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53022',
  },
  {
    city: 'Glenbeulah',
    county_fips: 55117,
    county_fips_all: '55117',
    county: 'Sheboygan',
    county_names_all: 'Sheboygan',
    county_weights: '{"55117": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 43.78198,
    longitude: -88.10745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53023',
  },
  {
    city: 'Grafton',
    county_fips: 55089,
    county_fips_all: '55089',
    county: 'Ozaukee',
    county_names_all: 'Ozaukee',
    county_weights: '{"55089": 100}',
    density: 266.3,
    imprecise: false,
    latitude: 43.33233,
    longitude: -87.93299,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53024',
  },
  {
    city: 'Hartford',
    county_fips: 55131,
    county_fips_all: '55131|55027',
    county: 'Washington',
    county_names_all: 'Washington|Dodge',
    county_weights: '{"55131": 82.84, "55027": 17.16}',
    density: 98.1,
    imprecise: false,
    latitude: 43.31697,
    longitude: -88.37356,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53027',
  },
  {
    city: 'Hartland',
    county_fips: 55133,
    county_fips_all: '55133|55131',
    county: 'Waukesha',
    county_names_all: 'Waukesha|Washington',
    county_weights: '{"55133": 97.14, "55131": 2.86}',
    density: 223.6,
    imprecise: false,
    latitude: 43.14381,
    longitude: -88.34624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53029',
  },
  {
    city: 'Hingham',
    county_fips: 55117,
    county_fips_all: '55117',
    county: 'Sheboygan',
    county_names_all: 'Sheboygan',
    county_weights: '{"55117": 100}',
    density: 1098.6,
    imprecise: false,
    latitude: 43.64036,
    longitude: -87.91778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53031',
  },
  {
    city: 'Horicon',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 64,
    imprecise: false,
    latitude: 43.44708,
    longitude: -88.6234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53032',
  },
  {
    city: 'Hubertus',
    county_fips: 55131,
    county_fips_all: '55131',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"55131": 100}',
    density: 152,
    imprecise: false,
    latitude: 43.23716,
    longitude: -88.25634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53033',
  },
  {
    city: 'Hustisford',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 82.6,
    imprecise: false,
    latitude: 43.34014,
    longitude: -88.60746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53034',
  },
  {
    city: 'Iron Ridge',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 43.39135,
    longitude: -88.54355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53035',
  },
  {
    city: 'Ixonia',
    county_fips: 55055,
    county_fips_all: '55055|55027|55133',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Dodge|Waukesha',
    county_weights: '{"55055": 70.41, "55027": 24.76, "55133": 4.83}',
    density: 50.3,
    imprecise: false,
    latitude: 43.17141,
    longitude: -88.57693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53036',
  },
  {
    city: 'Jackson',
    county_fips: 55131,
    county_fips_all: '55131',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"55131": 100}',
    density: 171.4,
    imprecise: false,
    latitude: 43.31255,
    longitude: -88.16108,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53037',
  },
  {
    city: 'Johnson Creek',
    county_fips: 55055,
    county_fips_all: '55055',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"55055": 100}',
    density: 52.3,
    imprecise: false,
    latitude: 43.08592,
    longitude: -88.79031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53038',
  },
  {
    city: 'Juneau',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 43.36931,
    longitude: -88.71148,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53039',
  },
  {
    city: 'Kewaskum',
    county_fips: 55131,
    county_fips_all: '55131|55117|55039',
    county: 'Washington',
    county_names_all: 'Washington|Sheboygan|Fond du Lac',
    county_weights: '{"55131": 76.69, "55117": 12.64, "55039": 10.67}',
    density: 53,
    imprecise: false,
    latitude: 43.52126,
    longitude: -88.19198,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53040',
  },
  {
    city: 'Kiel',
    county_fips: 55071,
    county_fips_all: '55071|55015',
    county: 'Manitowoc',
    county_names_all: 'Manitowoc|Calumet',
    county_weights: '{"55071": 91.06, "55015": 8.94}',
    density: 42.4,
    imprecise: false,
    latitude: 43.95144,
    longitude: -87.98216,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53042',
  },
  {
    city: 'Kohler',
    county_fips: 55117,
    county_fips_all: '55117',
    county: 'Sheboygan',
    county_names_all: 'Sheboygan',
    county_weights: '{"55117": 100}',
    density: 159.8,
    imprecise: false,
    latitude: 43.73793,
    longitude: -87.78327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53044',
  },
  {
    city: 'Brookfield',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 624.9,
    imprecise: false,
    latitude: 43.061,
    longitude: -88.15145,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53045',
  },
  {
    city: 'Lannon',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 231.5,
    imprecise: false,
    latitude: 43.15215,
    longitude: -88.16045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53046',
  },
  {
    city: 'Lebanon',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 82,
    imprecise: false,
    latitude: 43.25904,
    longitude: -88.63002,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 85,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53047',
  },
  {
    city: 'Lomira',
    county_fips: 55027,
    county_fips_all: '55027|55039',
    county: 'Dodge',
    county_names_all: 'Dodge|Fond du Lac',
    county_weights: '{"55027": 96.35, "55039": 3.65}',
    density: 49.1,
    imprecise: false,
    latitude: 43.57935,
    longitude: -88.45554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53048',
  },
  {
    city: 'Malone',
    county_fips: 55039,
    county_fips_all: '55039|55015',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac|Calumet',
    county_weights: '{"55039": 95.55, "55015": 4.45}',
    density: 23.2,
    imprecise: false,
    latitude: 43.8853,
    longitude: -88.28917,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53049',
  },
  {
    city: 'Mayville',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 39.2,
    imprecise: false,
    latitude: 43.50992,
    longitude: -88.54734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53050',
  },
  {
    city: 'Menomonee Falls',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 458.9,
    imprecise: false,
    latitude: 43.14905,
    longitude: -88.12348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53051',
  },
  {
    city: 'Mount Calvary',
    county_fips: 55039,
    county_fips_all: '55039',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac',
    county_weights: '{"55039": 100}',
    density: 23,
    imprecise: false,
    latitude: 43.79099,
    longitude: -88.24671,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53057',
  },
  {
    city: 'Nashotah',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 236.8,
    imprecise: false,
    latitude: 43.11003,
    longitude: -88.40624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53058',
  },
  {
    city: 'Neosho',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 21.3,
    imprecise: false,
    latitude: 43.28954,
    longitude: -88.53012,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53059',
  },
  {
    city: 'New Holstein',
    county_fips: 55015,
    county_fips_all: '55015|55039|55071',
    county: 'Calumet',
    county_names_all: 'Calumet|Fond du Lac|Manitowoc',
    county_weights: '{"55015": 82.03, "55039": 17.02, "55071": 0.95}',
    density: 46.6,
    imprecise: false,
    latitude: 43.94588,
    longitude: -88.11803,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53061',
  },
  {
    city: 'Newton',
    county_fips: 55071,
    county_fips_all: '55071',
    county: 'Manitowoc',
    county_names_all: 'Manitowoc',
    county_weights: '{"55071": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 43.96297,
    longitude: -87.80232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53063',
  },
  {
    city: 'Oakfield',
    county_fips: 55039,
    county_fips_all: '55039|55027',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac|Dodge',
    county_weights: '{"55039": 96.3, "55027": 3.7}',
    density: 21.2,
    imprecise: false,
    latitude: 43.68227,
    longitude: -88.56866,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53065',
  },
  {
    city: 'Oconomowoc',
    county_fips: 55133,
    county_fips_all: '55133|55055|55027|55131',
    county: 'Waukesha',
    county_names_all: 'Waukesha|Jefferson|Dodge|Washington',
    county_weights:
      '{"55133": 71.12, "55055": 15.9, "55027": 12.77, "55131": 0.21}',
    density: 140.6,
    imprecise: false,
    latitude: 43.11451,
    longitude: -88.49068,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53066',
  },
  {
    city: 'Okauchee',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 667.5,
    imprecise: false,
    latitude: 43.1131,
    longitude: -88.43094,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53069',
  },
  {
    city: 'Oostburg',
    county_fips: 55117,
    county_fips_all: '55117',
    county: 'Sheboygan',
    county_names_all: 'Sheboygan',
    county_weights: '{"55117": 100}',
    density: 64.8,
    imprecise: false,
    latitude: 43.62429,
    longitude: -87.80872,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53070',
  },
  {
    city: 'Pewaukee',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 339.2,
    imprecise: false,
    latitude: 43.07989,
    longitude: -88.26638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53072',
  },
  {
    city: 'Plymouth',
    county_fips: 55117,
    county_fips_all: '55117',
    county: 'Sheboygan',
    county_names_all: 'Sheboygan',
    county_weights: '{"55117": 100}',
    density: 73.7,
    imprecise: false,
    latitude: 43.75011,
    longitude: -87.99191,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53073',
  },
  {
    city: 'Port Washington',
    county_fips: 55089,
    county_fips_all: '55089',
    county: 'Ozaukee',
    county_names_all: 'Ozaukee',
    county_weights: '{"55089": 100}',
    density: 174.6,
    imprecise: false,
    latitude: 43.42716,
    longitude: -87.88265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53074',
  },
  {
    city: 'Random Lake',
    county_fips: 55117,
    county_fips_all: '55117|55089|55131',
    county: 'Sheboygan',
    county_names_all: 'Sheboygan|Ozaukee|Washington',
    county_weights: '{"55117": 86.67, "55089": 10.1, "55131": 3.23}',
    density: 36,
    imprecise: false,
    latitude: 43.56318,
    longitude: -87.99559,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53075',
  },
  {
    city: 'Richfield',
    county_fips: 55131,
    county_fips_all: '55131',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"55131": 100}',
    density: 53.5,
    imprecise: false,
    latitude: 43.26966,
    longitude: -88.20905,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53076',
  },
  {
    city: 'Rubicon',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 20,
    imprecise: false,
    latitude: 43.31386,
    longitude: -88.45924,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53078',
  },
  {
    city: 'Saint Cloud',
    county_fips: 55039,
    county_fips_all: '55039|55117',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac|Sheboygan',
    county_weights: '{"55039": 96.39, "55117": 3.61}',
    density: 14.9,
    imprecise: false,
    latitude: 43.81132,
    longitude: -88.1888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53079',
  },
  {
    city: 'Saukville',
    county_fips: 55089,
    county_fips_all: '55089',
    county: 'Ozaukee',
    county_names_all: 'Ozaukee',
    county_weights: '{"55089": 100}',
    density: 68.3,
    imprecise: false,
    latitude: 43.40733,
    longitude: -87.98789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53080',
  },
  {
    city: 'Sheboygan',
    county_fips: 55117,
    county_fips_all: '55117',
    county: 'Sheboygan',
    county_names_all: 'Sheboygan',
    county_weights: '{"55117": 100}',
    density: 718.4,
    imprecise: false,
    latitude: 43.71343,
    longitude: -87.73725,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53081',
  },
  {
    city: 'Sheboygan',
    county_fips: 55117,
    county_fips_all: '55117',
    county: 'Sheboygan',
    county_names_all: 'Sheboygan',
    county_weights: '{"55117": 100}',
    density: 256.3,
    imprecise: false,
    latitude: 43.81511,
    longitude: -87.77108,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53083',
  },
  {
    city: 'Sheboygan Falls',
    county_fips: 55117,
    county_fips_all: '55117',
    county: 'Sheboygan',
    county_names_all: 'Sheboygan',
    county_weights: '{"55117": 100}',
    density: 64.7,
    imprecise: false,
    latitude: 43.73562,
    longitude: -87.85137,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53085',
  },
  {
    city: 'Slinger',
    county_fips: 55131,
    county_fips_all: '55131',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"55131": 100}',
    density: 169.2,
    imprecise: false,
    latitude: 43.32508,
    longitude: -88.27124,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53086',
  },
  {
    city: 'Stockbridge',
    county_fips: 55015,
    county_fips_all: '55015',
    county: 'Calumet',
    county_names_all: 'Calumet',
    county_weights: '{"55015": 100}',
    density: 510.5,
    imprecise: false,
    latitude: 44.07178,
    longitude: -88.29966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53088',
  },
  {
    city: 'Sussex',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 296,
    imprecise: false,
    latitude: 43.14646,
    longitude: -88.23594,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53089',
  },
  {
    city: 'West Bend',
    county_fips: 55131,
    county_fips_all: '55131|55089',
    county: 'Washington',
    county_names_all: 'Washington|Ozaukee',
    county_weights: '{"55131": 96.9, "55089": 3.1}',
    density: 144.3,
    imprecise: false,
    latitude: 43.45685,
    longitude: -88.17985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53090',
  },
  {
    city: 'Theresa',
    county_fips: 55027,
    county_fips_all: '55027|55131',
    county: 'Dodge',
    county_names_all: 'Dodge|Washington',
    county_weights: '{"55027": 96.44, "55131": 3.56}',
    density: 31.9,
    imprecise: false,
    latitude: 43.49667,
    longitude: -88.43674,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53091',
  },
  {
    city: 'Mequon',
    county_fips: 55089,
    county_fips_all: '55089',
    county: 'Ozaukee',
    county_names_all: 'Ozaukee',
    county_weights: '{"55089": 100}',
    density: 397.1,
    imprecise: false,
    latitude: 43.22139,
    longitude: -87.95351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53092',
  },
  {
    city: 'Waldo',
    county_fips: 55117,
    county_fips_all: '55117',
    county: 'Sheboygan',
    county_names_all: 'Sheboygan',
    county_weights: '{"55117": 100}',
    density: 38.4,
    imprecise: false,
    latitude: 43.65348,
    longitude: -87.93894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53093',
  },
  {
    city: 'Watertown',
    county_fips: 55055,
    county_fips_all: '55055',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"55055": 100}',
    density: 78.2,
    imprecise: false,
    latitude: 43.1462,
    longitude: -88.73365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53094',
  },
  {
    city: 'West Bend',
    county_fips: 55131,
    county_fips_all: '55131|55089',
    county: 'Washington',
    county_names_all: 'Washington|Ozaukee',
    county_weights: '{"55131": 94.08, "55089": 5.92}',
    density: 152.5,
    imprecise: false,
    latitude: 43.38838,
    longitude: -88.15895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53095',
  },
  {
    city: 'Mequon',
    county_fips: 55089,
    county_fips_all: '55089',
    county: 'Ozaukee',
    county_names_all: 'Ozaukee',
    county_weights: '{"55089": 100}',
    density: 109.8,
    imprecise: false,
    latitude: 43.24574,
    longitude: -88.0069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53097',
  },
  {
    city: 'Watertown',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 43.1,
    imprecise: false,
    latitude: 43.24955,
    longitude: -88.71461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53098',
  },
  {
    city: 'Woodland',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 21.5,
    imprecise: false,
    latitude: 43.38035,
    longitude: -88.52525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53099',
  },
  {
    city: 'Big Bend',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 119.2,
    imprecise: false,
    latitude: 42.88175,
    longitude: -88.21542,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53103',
  },
  {
    city: 'Bristol',
    county_fips: 55059,
    county_fips_all: '55059',
    county: 'Kenosha',
    county_names_all: 'Kenosha',
    county_weights: '{"55059": 100}',
    density: 65.2,
    imprecise: false,
    latitude: 42.55731,
    longitude: -88.03416,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53104',
  },
  {
    city: 'Burlington',
    county_fips: 55101,
    county_fips_all: '55101|55127|55059',
    county: 'Racine',
    county_names_all: 'Racine|Walworth|Kenosha',
    county_weights: '{"55101": 41.48, "55127": 36.97, "55059": 21.55}',
    density: 69.6,
    imprecise: false,
    latitude: 42.66412,
    longitude: -88.28045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53105',
  },
  {
    city: 'Caledonia',
    county_fips: 55101,
    county_fips_all: '55101',
    county: 'Racine',
    county_names_all: 'Racine',
    county_weights: '{"55101": 100}',
    density: 60.8,
    imprecise: false,
    latitude: 42.82043,
    longitude: -87.94696,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53108',
  },
  {
    city: 'Cudahy',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 1446.6,
    imprecise: false,
    latitude: 42.94671,
    longitude: -87.86403,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53110',
  },
  {
    city: 'Darien',
    county_fips: 55127,
    county_fips_all: '55127|55105',
    county: 'Walworth',
    county_names_all: 'Walworth|Rock',
    county_weights: '{"55127": 75.35, "55105": 24.65}',
    density: 25.5,
    imprecise: false,
    latitude: 42.60721,
    longitude: -88.75089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53114',
  },
  {
    city: 'Delavan',
    county_fips: 55127,
    county_fips_all: '55127',
    county: 'Walworth',
    county_names_all: 'Walworth',
    county_weights: '{"55127": 100}',
    density: 87.9,
    imprecise: false,
    latitude: 42.65443,
    longitude: -88.6713,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53115',
  },
  {
    city: 'Dousman',
    county_fips: 55133,
    county_fips_all: '55133|55055',
    county: 'Waukesha',
    county_names_all: 'Waukesha|Jefferson',
    county_weights: '{"55133": 87.37, "55055": 12.63}',
    density: 74.2,
    imprecise: false,
    latitude: 42.9725,
    longitude: -88.48859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53118',
  },
  {
    city: 'Eagle',
    county_fips: 55133,
    county_fips_all: '55133|55127|55055',
    county: 'Waukesha',
    county_names_all: 'Waukesha|Walworth|Jefferson',
    county_weights: '{"55133": 89.06, "55127": 8.82, "55055": 2.12}',
    density: 56,
    imprecise: false,
    latitude: 42.88356,
    longitude: -88.4862,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53119',
  },
  {
    city: 'East Troy',
    county_fips: 55127,
    county_fips_all: '55127|55101',
    county: 'Walworth',
    county_names_all: 'Walworth|Racine',
    county_weights: '{"55127": 91.34, "55101": 8.66}',
    density: 74.1,
    imprecise: false,
    latitude: 42.80066,
    longitude: -88.41783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53120',
  },
  {
    city: 'Elkhorn',
    county_fips: 55127,
    county_fips_all: '55127',
    county: 'Walworth',
    county_names_all: 'Walworth',
    county_weights: '{"55127": 100}',
    density: 62.6,
    imprecise: false,
    latitude: 42.70989,
    longitude: -88.53028,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53121',
  },
  {
    city: 'Elm Grove',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 768.9,
    imprecise: false,
    latitude: 43.04811,
    longitude: -88.08674,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53122',
  },
  {
    city: 'Fontana',
    county_fips: 55127,
    county_fips_all: '55127',
    county: 'Walworth',
    county_names_all: 'Walworth',
    county_weights: '{"55127": 100}',
    density: 119,
    imprecise: false,
    latitude: 42.54532,
    longitude: -88.56216,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53125',
  },
  {
    city: 'Franksville',
    county_fips: 55101,
    county_fips_all: '55101|55079',
    county: 'Racine',
    county_names_all: 'Racine|Milwaukee',
    county_weights: '{"55101": 99.7, "55079": 0.3}',
    density: 51.9,
    imprecise: false,
    latitude: 42.78848,
    longitude: -87.9966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53126',
  },
  {
    city: 'Genesee Depot',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 37.3,
    imprecise: false,
    latitude: 42.95991,
    longitude: -88.3777,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 79,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53127',
  },
  {
    city: 'Genoa City',
    county_fips: 55127,
    county_fips_all: '55127|55059',
    county: 'Walworth',
    county_names_all: 'Walworth|Kenosha',
    county_weights: '{"55127": 84.13, "55059": 15.87}',
    density: 137.7,
    imprecise: false,
    latitude: 42.52979,
    longitude: -88.33857,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53128',
  },
  {
    city: 'Greendale',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 1092.3,
    imprecise: false,
    latitude: 42.93795,
    longitude: -88.00003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53129',
  },
  {
    city: 'Hales Corners',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 933.6,
    imprecise: false,
    latitude: 42.94092,
    longitude: -88.04909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53130',
  },
  {
    city: 'Franklin',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 394.1,
    imprecise: false,
    latitude: 42.88589,
    longitude: -88.01063,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53132',
  },
  {
    city: 'Helenville',
    county_fips: 55055,
    county_fips_all: '55055',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"55055": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 43.00472,
    longitude: -88.66975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53137',
  },
  {
    city: 'Kansasville',
    county_fips: 55101,
    county_fips_all: '55101|55059',
    county: 'Racine',
    county_names_all: 'Racine|Kenosha',
    county_weights: '{"55101": 65.62, "55059": 34.38}',
    density: 30.6,
    imprecise: false,
    latitude: 42.68795,
    longitude: -88.12,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53139',
  },
  {
    city: 'Kenosha',
    county_fips: 55059,
    county_fips_all: '55059',
    county: 'Kenosha',
    county_names_all: 'Kenosha',
    county_weights: '{"55059": 100}',
    density: 1479,
    imprecise: false,
    latitude: 42.61963,
    longitude: -87.82987,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53140',
  },
  {
    city: 'Kenosha',
    county_fips: 55059,
    county_fips_all: '55059',
    county: 'Kenosha',
    county_names_all: 'Kenosha',
    county_weights: '{"55059": 100}',
    density: 637.3,
    imprecise: false,
    latitude: 42.54464,
    longitude: -87.93765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53142',
  },
  {
    city: 'Kenosha',
    county_fips: 55059,
    county_fips_all: '55059',
    county: 'Kenosha',
    county_names_all: 'Kenosha',
    county_weights: '{"55059": 100}',
    density: 1946.6,
    imprecise: false,
    latitude: 42.56109,
    longitude: -87.83038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53143',
  },
  {
    city: 'Kenosha',
    county_fips: 55059,
    county_fips_all: '55059',
    county: 'Kenosha',
    county_names_all: 'Kenosha',
    county_weights: '{"55059": 100}',
    density: 237.2,
    imprecise: false,
    latitude: 42.61991,
    longitude: -87.92291,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53144',
  },
  {
    city: 'New Berlin',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 153.7,
    imprecise: false,
    latitude: 42.9718,
    longitude: -88.15885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53146',
  },
  {
    city: 'Lake Geneva',
    county_fips: 55127,
    county_fips_all: '55127',
    county: 'Walworth',
    county_names_all: 'Walworth',
    county_weights: '{"55127": 100}',
    density: 103.1,
    imprecise: false,
    latitude: 42.57075,
    longitude: -88.45024,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53147',
  },
  {
    city: 'Mukwonago',
    county_fips: 55133,
    county_fips_all: '55133|55127|55101',
    county: 'Waukesha',
    county_names_all: 'Waukesha|Walworth|Racine',
    county_weights: '{"55133": 84.0, "55127": 9.3, "55101": 6.7}',
    density: 130.8,
    imprecise: false,
    latitude: 42.87436,
    longitude: -88.34077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53149',
  },
  {
    city: 'Muskego',
    county_fips: 55133,
    county_fips_all: '55133|55101',
    county: 'Waukesha',
    county_names_all: 'Waukesha|Racine',
    county_weights: '{"55133": 95.32, "55101": 4.68}',
    density: 296.2,
    imprecise: false,
    latitude: 42.8845,
    longitude: -88.12824,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53150',
  },
  {
    city: 'New Berlin',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 723.2,
    imprecise: false,
    latitude: 42.97467,
    longitude: -88.09845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53151',
  },
  {
    city: 'North Prairie',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 206.2,
    imprecise: false,
    latitude: 42.94056,
    longitude: -88.40237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53153',
  },
  {
    city: 'Oak Creek',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 506.5,
    imprecise: false,
    latitude: 42.8803,
    longitude: -87.90092,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53154',
  },
  {
    city: 'Palmyra',
    county_fips: 55055,
    county_fips_all: '55055',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"55055": 100}',
    density: 40.5,
    imprecise: false,
    latitude: 42.89069,
    longitude: -88.59012,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53156',
  },
  {
    city: 'Pell Lake',
    county_fips: 55127,
    county_fips_all: '55127',
    county: 'Walworth',
    county_names_all: 'Walworth',
    county_weights: '{"55127": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.5377,
    longitude: -88.36855,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53157',
  },
  {
    city: 'Pleasant Prairie',
    county_fips: 55059,
    county_fips_all: '55059',
    county: 'Kenosha',
    county_names_all: 'Kenosha',
    county_weights: '{"55059": 100}',
    density: 235,
    imprecise: false,
    latitude: 42.52418,
    longitude: -87.88869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53158',
  },
  {
    city: 'Rochester',
    county_fips: 55101,
    county_fips_all: '55101',
    county: 'Racine',
    county_names_all: 'Racine',
    county_weights: '{"55101": 100}',
    density: 137.2,
    imprecise: false,
    latitude: 42.73526,
    longitude: -88.22552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53167',
  },
  {
    city: 'Salem',
    county_fips: 55059,
    county_fips_all: '55059',
    county: 'Kenosha',
    county_names_all: 'Kenosha',
    county_weights: '{"55059": 100}',
    density: 107.2,
    imprecise: false,
    latitude: 42.57858,
    longitude: -88.12999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53168',
  },
  {
    city: 'Silver Lake',
    county_fips: 55059,
    county_fips_all: '55059',
    county: 'Kenosha',
    county_names_all: 'Kenosha',
    county_weights: '{"55059": 100}',
    density: 810.9,
    imprecise: false,
    latitude: 42.5519,
    longitude: -88.16149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53170',
  },
  {
    city: 'South Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 1634.6,
    imprecise: false,
    latitude: 42.91197,
    longitude: -87.86266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53172',
  },
  {
    city: 'Springfield',
    county_fips: 55127,
    county_fips_all: '55127',
    county: 'Walworth',
    county_names_all: 'Walworth',
    county_weights: '{"55127": 100}',
    density: 111,
    imprecise: false,
    latitude: 42.64307,
    longitude: -88.41444,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53176',
  },
  {
    city: 'Sturtevant',
    county_fips: 55101,
    county_fips_all: '55101|55059',
    county: 'Racine',
    county_names_all: 'Racine|Kenosha',
    county_weights: '{"55101": 86.95, "55059": 13.05}',
    density: 118.6,
    imprecise: false,
    latitude: 42.70047,
    longitude: -87.93474,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53177',
  },
  {
    city: 'Sullivan',
    county_fips: 55055,
    county_fips_all: '55055',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"55055": 100}',
    density: 30.3,
    imprecise: false,
    latitude: 43.02335,
    longitude: -88.59894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53178',
  },
  {
    city: 'Trevor',
    county_fips: 55059,
    county_fips_all: '55059',
    county: 'Kenosha',
    county_names_all: 'Kenosha',
    county_weights: '{"55059": 100}',
    density: 237.3,
    imprecise: false,
    latitude: 42.5133,
    longitude: -88.13159,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53179',
  },
  {
    city: 'Twin Lakes',
    county_fips: 55059,
    county_fips_all: '55059',
    county: 'Kenosha',
    county_names_all: 'Kenosha',
    county_weights: '{"55059": 100}',
    density: 224.2,
    imprecise: false,
    latitude: 42.51711,
    longitude: -88.24305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53181',
  },
  {
    city: 'Union Grove',
    county_fips: 55101,
    county_fips_all: '55101|55059',
    county: 'Racine',
    county_names_all: 'Racine|Kenosha',
    county_weights: '{"55101": 67.35, "55059": 32.65}',
    density: 68.6,
    imprecise: false,
    latitude: 42.69815,
    longitude: -88.04096,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53182',
  },
  {
    city: 'Wales',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 339.2,
    imprecise: false,
    latitude: 43.00441,
    longitude: -88.3739,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53183',
  },
  {
    city: 'Walworth',
    county_fips: 55127,
    county_fips_all: '55127',
    county: 'Walworth',
    county_names_all: 'Walworth',
    county_weights: '{"55127": 100}',
    density: 52,
    imprecise: false,
    latitude: 42.53075,
    longitude: -88.60945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53184',
  },
  {
    city: 'Waterford',
    county_fips: 55101,
    county_fips_all: '55101|55133',
    county: 'Racine',
    county_names_all: 'Racine|Waukesha',
    county_weights: '{"55101": 99.19, "55133": 0.81}',
    density: 156.8,
    imprecise: false,
    latitude: 42.79519,
    longitude: -88.19313,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53185',
  },
  {
    city: 'Waukesha',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 1023.5,
    imprecise: false,
    latitude: 43.02305,
    longitude: -88.20319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53186',
  },
  {
    city: 'Waukesha',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 502.4,
    imprecise: false,
    latitude: 43.02106,
    longitude: -88.29265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53188',
  },
  {
    city: 'Waukesha',
    county_fips: 55133,
    county_fips_all: '55133',
    county: 'Waukesha',
    county_names_all: 'Waukesha',
    county_weights: '{"55133": 100}',
    density: 216.8,
    imprecise: false,
    latitude: 42.95216,
    longitude: -88.28068,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53189',
  },
  {
    city: 'Whitewater',
    county_fips: 55127,
    county_fips_all: '55127|55105|55055',
    county: 'Walworth',
    county_names_all: 'Walworth|Rock|Jefferson',
    county_weights: '{"55127": 49.54, "55105": 26.94, "55055": 23.52}',
    density: 60.5,
    imprecise: false,
    latitude: 42.80775,
    longitude: -88.73129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53190',
  },
  {
    city: 'Williams Bay',
    county_fips: 55127,
    county_fips_all: '55127',
    county: 'Walworth',
    county_names_all: 'Walworth',
    county_weights: '{"55127": 100}',
    density: 318.2,
    imprecise: false,
    latitude: 42.5776,
    longitude: -88.54574,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53191',
  },
  {
    city: 'Wilmot',
    county_fips: 55059,
    county_fips_all: '55059',
    county: 'Kenosha',
    county_names_all: 'Kenosha',
    county_weights: '{"55059": 100}',
    density: 72.4,
    imprecise: false,
    latitude: 42.51172,
    longitude: -88.18412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53192',
  },
  {
    city: 'Zenda',
    county_fips: 55127,
    county_fips_all: '55127',
    county: 'Walworth',
    county_names_all: 'Walworth',
    county_weights: '{"55127": 100}',
    density: 156.4,
    imprecise: false,
    latitude: 42.51397,
    longitude: -88.49016,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53195',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 4701.6,
    imprecise: false,
    latitude: 43.04561,
    longitude: -87.89893,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53202',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 2047.7,
    imprecise: false,
    latitude: 43.03828,
    longitude: -87.91603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53203',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 4787.7,
    imprecise: false,
    latitude: 43.01806,
    longitude: -87.92552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53204',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 2475.3,
    imprecise: false,
    latitude: 43.05359,
    longitude: -87.93363,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53205',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 2895.6,
    imprecise: false,
    latitude: 43.07524,
    longitude: -87.93349,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53206',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 1331.1,
    imprecise: false,
    latitude: 42.97148,
    longitude: -87.90152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53207',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 2485.8,
    imprecise: false,
    latitude: 43.04556,
    longitude: -87.96556,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53208',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 1601.5,
    imprecise: false,
    latitude: 43.12871,
    longitude: -87.94717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53209',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 3613.4,
    imprecise: false,
    latitude: 43.06889,
    longitude: -87.97381,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53210',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 3333.6,
    imprecise: false,
    latitude: 43.08308,
    longitude: -87.88485,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53211',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 2743.9,
    imprecise: false,
    latitude: 43.07464,
    longitude: -87.90845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53212',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 2653.1,
    imprecise: false,
    latitude: 43.04889,
    longitude: -88.00176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53213',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 1864.2,
    imprecise: false,
    latitude: 43.02061,
    longitude: -88.01634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53214',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 4069.9,
    imprecise: false,
    latitude: 42.99931,
    longitude: -87.94625,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53215',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 2541.4,
    imprecise: false,
    latitude: 43.08634,
    longitude: -87.97636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53216',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079|55089',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee|Ozaukee',
    county_weights: '{"55079": 99.33, "55089": 0.67}',
    density: 821.1,
    imprecise: false,
    latitude: 43.15767,
    longitude: -87.91633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53217',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 2711.9,
    imprecise: false,
    latitude: 43.11469,
    longitude: -87.99301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53218',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 2660.8,
    imprecise: false,
    latitude: 42.99537,
    longitude: -87.99171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53219',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 1931.7,
    imprecise: false,
    latitude: 42.96515,
    longitude: -87.99142,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53220',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 1630.4,
    imprecise: false,
    latitude: 42.95445,
    longitude: -87.94374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53221',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 1763.3,
    imprecise: false,
    latitude: 43.08205,
    longitude: -88.03496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53222',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 1128,
    imprecise: false,
    latitude: 43.16304,
    longitude: -87.98996,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53223',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 808.2,
    imprecise: false,
    latitude: 43.16357,
    longitude: -88.03894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53224',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079|55133',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee|Waukesha',
    county_weights: '{"55079": 98.52, "55133": 1.48}',
    density: 1392.5,
    imprecise: false,
    latitude: 43.11443,
    longitude: -88.042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53225',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 1066.6,
    imprecise: false,
    latitude: 43.04975,
    longitude: -88.04209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53226',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079|55133',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee|Waukesha',
    county_weights: '{"55079": 99.59, "55133": 0.41}',
    density: 1726.6,
    imprecise: false,
    latitude: 42.99562,
    longitude: -88.04264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53227',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 1112.3,
    imprecise: false,
    latitude: 42.96678,
    longitude: -88.04333,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53228',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 3193.6,
    imprecise: false,
    latitude: 43.03694,
    longitude: -87.93364,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53233',
  },
  {
    city: 'Saint Francis',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 1352.7,
    imprecise: false,
    latitude: 42.97161,
    longitude: -87.87298,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53235',
  },
  {
    city: 'Racine',
    county_fips: 55101,
    county_fips_all: '55101',
    county: 'Racine',
    county_names_all: 'Racine',
    county_weights: '{"55101": 100}',
    density: 671.6,
    imprecise: false,
    latitude: 42.7989,
    longitude: -87.82385,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53402',
  },
  {
    city: 'Racine',
    county_fips: 55101,
    county_fips_all: '55101|55059',
    county: 'Racine',
    county_names_all: 'Racine|Kenosha',
    county_weights: '{"55101": 90.77, "55059": 9.23}',
    density: 1027.1,
    imprecise: false,
    latitude: 42.68738,
    longitude: -87.82587,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53403',
  },
  {
    city: 'Racine',
    county_fips: 55101,
    county_fips_all: '55101',
    county: 'Racine',
    county_names_all: 'Racine',
    county_weights: '{"55101": 100}',
    density: 1079.3,
    imprecise: false,
    latitude: 42.7572,
    longitude: -87.81246,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53404',
  },
  {
    city: 'Racine',
    county_fips: 55101,
    county_fips_all: '55101',
    county: 'Racine',
    county_names_all: 'Racine',
    county_weights: '{"55101": 100}',
    density: 1564.5,
    imprecise: false,
    latitude: 42.72712,
    longitude: -87.82588,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53405',
  },
  {
    city: 'Racine',
    county_fips: 55101,
    county_fips_all: '55101',
    county: 'Racine',
    county_names_all: 'Racine',
    county_weights: '{"55101": 100}',
    density: 607.6,
    imprecise: false,
    latitude: 42.73014,
    longitude: -87.86549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53406',
  },
  {
    city: 'Afton',
    county_fips: 55105,
    county_fips_all: '55105',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"55105": 100}',
    density: 139.5,
    imprecise: false,
    latitude: 42.60484,
    longitude: -89.07165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53501',
  },
  {
    city: 'Albany',
    county_fips: 55045,
    county_fips_all: '55045|55105',
    county: 'Green',
    county_names_all: 'Green|Rock',
    county_weights: '{"55045": 98.47, "55105": 1.53}',
    density: 17.8,
    imprecise: false,
    latitude: 42.73219,
    longitude: -89.44071,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53502',
  },
  {
    city: 'Arena',
    county_fips: 55049,
    county_fips_all: '55049',
    county: 'Iowa',
    county_names_all: 'Iowa',
    county_weights: '{"55049": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 43.13935,
    longitude: -89.95623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53503',
  },
  {
    city: 'Argyle',
    county_fips: 55065,
    county_fips_all: '55065|55045',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Green',
    county_weights: '{"55065": 55.66, "55045": 44.34}',
    density: 9.6,
    imprecise: false,
    latitude: 42.70388,
    longitude: -89.85801,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53504',
  },
  {
    city: 'Avalon',
    county_fips: 55105,
    county_fips_all: '55105',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"55105": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 42.66063,
    longitude: -88.8176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53505',
  },
  {
    city: 'Avoca',
    county_fips: 55049,
    county_fips_all: '55049',
    county: 'Iowa',
    county_names_all: 'Iowa',
    county_weights: '{"55049": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 43.15017,
    longitude: -90.28422,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53506',
  },
  {
    city: 'Barneveld',
    county_fips: 55049,
    county_fips_all: '55049|55025',
    county: 'Iowa',
    county_names_all: 'Iowa|Dane',
    county_weights: '{"55049": 99.36, "55025": 0.64}',
    density: 15.3,
    imprecise: false,
    latitude: 43.00153,
    longitude: -89.90173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53507',
  },
  {
    city: 'Belleville',
    county_fips: 55025,
    county_fips_all: '55025|55045',
    county: 'Dane',
    county_names_all: 'Dane|Green',
    county_weights: '{"55025": 66.02, "55045": 33.98}',
    density: 32.1,
    imprecise: false,
    latitude: 42.86783,
    longitude: -89.5618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53508',
  },
  {
    city: 'Belmont',
    county_fips: 55065,
    county_fips_all: '55065',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"55065": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 42.74065,
    longitude: -90.32147,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53510',
  },
  {
    city: 'Beloit',
    county_fips: 55105,
    county_fips_all: '55105',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"55105": 100}',
    density: 163.7,
    imprecise: false,
    latitude: 42.54627,
    longitude: -89.09792,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53511',
  },
  {
    city: 'Black Earth',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 26.1,
    imprecise: false,
    latitude: 43.11708,
    longitude: -89.74915,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53515',
  },
  {
    city: 'Blanchardville',
    county_fips: 55065,
    county_fips_all: '55065|55045|55049|55025',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Green|Iowa|Dane',
    county_weights:
      '{"55065": 47.68, "55045": 35.51, "55049": 13.72, "55025": 3.09}',
    density: 10,
    imprecise: false,
    latitude: 42.80073,
    longitude: -89.8676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53516',
  },
  {
    city: 'Blue Mounds',
    county_fips: 55025,
    county_fips_all: '55025|55049',
    county: 'Dane',
    county_names_all: 'Dane|Iowa',
    county_weights: '{"55025": 60.86, "55049": 39.14}',
    density: 15.1,
    imprecise: false,
    latitude: 43.03686,
    longitude: -89.82967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53517',
  },
  {
    city: 'Blue River',
    county_fips: 55103,
    county_fips_all: '55103|55043|55023',
    county: 'Richland',
    county_names_all: 'Richland|Grant|Crawford',
    county_weights: '{"55103": 78.55, "55043": 17.43, "55023": 4.02}',
    density: 6.9,
    imprecise: false,
    latitude: 43.2458,
    longitude: -90.59108,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53518',
  },
  {
    city: 'Brodhead',
    county_fips: 55105,
    county_fips_all: '55105|55045',
    county: 'Rock',
    county_names_all: 'Rock|Green',
    county_weights: '{"55105": 53.44, "55045": 46.56}',
    density: 21.5,
    imprecise: false,
    latitude: 42.60133,
    longitude: -89.36123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53520',
  },
  {
    city: 'Brooklyn',
    county_fips: 55045,
    county_fips_all: '55045|55025|55105',
    county: 'Green',
    county_names_all: 'Green|Dane|Rock',
    county_weights: '{"55045": 50.32, "55025": 41.19, "55105": 8.49}',
    density: 23.5,
    imprecise: false,
    latitude: 42.84217,
    longitude: -89.40814,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53521',
  },
  {
    city: 'Browntown',
    county_fips: 55045,
    county_fips_all: '55045|55065',
    county: 'Green',
    county_names_all: 'Green|Lafayette',
    county_weights: '{"55045": 94.95, "55065": 5.05}',
    density: 9.3,
    imprecise: false,
    latitude: 42.55674,
    longitude: -89.78983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53522',
  },
  {
    city: 'Cambridge',
    county_fips: 55025,
    county_fips_all: '55025|55055',
    county: 'Dane',
    county_names_all: 'Dane|Jefferson',
    county_weights: '{"55025": 64.32, "55055": 35.68}',
    density: 41.8,
    imprecise: false,
    latitude: 42.98338,
    longitude: -89.03172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53523',
  },
  {
    city: 'Clinton',
    county_fips: 55105,
    county_fips_all: '55105|55127',
    county: 'Rock',
    county_names_all: 'Rock|Walworth',
    county_weights: '{"55105": 94.6, "55127": 5.4}',
    density: 27.5,
    imprecise: false,
    latitude: 42.54579,
    longitude: -88.84907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53525',
  },
  {
    city: 'Cobb',
    county_fips: 55049,
    county_fips_all: '55049',
    county: 'Iowa',
    county_names_all: 'Iowa',
    county_weights: '{"55049": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 42.97433,
    longitude: -90.34438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53526',
  },
  {
    city: 'Cottage Grove',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 128.7,
    imprecise: false,
    latitude: 43.06346,
    longitude: -89.19141,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53527',
  },
  {
    city: 'Cross Plains',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 54.7,
    imprecise: false,
    latitude: 43.11854,
    longitude: -89.63739,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53528',
  },
  {
    city: 'Dane',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 43.24075,
    longitude: -89.52496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53529',
  },
  {
    city: 'Darlington',
    county_fips: 55065,
    county_fips_all: '55065',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"55065": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 42.69356,
    longitude: -90.11163,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53530',
  },
  {
    city: 'Deerfield',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 41.6,
    imprecise: false,
    latitude: 43.05696,
    longitude: -89.10114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53531',
  },
  {
    city: 'Deforest',
    county_fips: 55025,
    county_fips_all: '55025|55021',
    county: 'Dane',
    county_names_all: 'Dane|Columbia',
    county_weights: '{"55025": 85.3, "55021": 14.7}',
    density: 117.7,
    imprecise: false,
    latitude: 43.24881,
    longitude: -89.32547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53532',
  },
  {
    city: 'Dodgeville',
    county_fips: 55049,
    county_fips_all: '55049',
    county: 'Iowa',
    county_names_all: 'Iowa',
    county_weights: '{"55049": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 42.99285,
    longitude: -90.14915,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53533',
  },
  {
    city: 'Edgerton',
    county_fips: 55105,
    county_fips_all: '55105|55025|55055',
    county: 'Rock',
    county_names_all: 'Rock|Dane|Jefferson',
    county_weights: '{"55105": 51.82, "55025": 43.37, "55055": 4.81}',
    density: 55.5,
    imprecise: false,
    latitude: 42.84763,
    longitude: -89.09032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53534',
  },
  {
    city: 'Evansville',
    county_fips: 55105,
    county_fips_all: '55105',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"55105": 100}',
    density: 41.5,
    imprecise: false,
    latitude: 42.76366,
    longitude: -89.26983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53536',
  },
  {
    city: 'Footville',
    county_fips: 55105,
    county_fips_all: '55105',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"55105": 100}',
    density: 333.2,
    imprecise: false,
    latitude: 42.67267,
    longitude: -89.21056,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53537',
  },
  {
    city: 'Fort Atkinson',
    county_fips: 55055,
    county_fips_all: '55055|55105',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Rock',
    county_weights: '{"55055": 98.59, "55105": 1.41}',
    density: 74.8,
    imprecise: false,
    latitude: 42.91697,
    longitude: -88.87194,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53538',
  },
  {
    city: 'Gotham',
    county_fips: 55103,
    county_fips_all: '55103',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"55103": 100}',
    density: 572.2,
    imprecise: false,
    latitude: 43.22173,
    longitude: -90.29356,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53540',
  },
  {
    city: 'Gratiot',
    county_fips: 55065,
    county_fips_all: '55065',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"55065": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 42.56969,
    longitude: -90.02963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53541',
  },
  {
    city: 'Highland',
    county_fips: 55049,
    county_fips_all: '55049|55043',
    county: 'Iowa',
    county_names_all: 'Iowa|Grant',
    county_weights: '{"55049": 82.21, "55043": 17.79}',
    density: 8.8,
    imprecise: false,
    latitude: 43.0556,
    longitude: -90.36233,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53543',
  },
  {
    city: 'Hollandale',
    county_fips: 55049,
    county_fips_all: '55049|55025',
    county: 'Iowa',
    county_names_all: 'Iowa|Dane',
    county_weights: '{"55049": 99.13, "55025": 0.87}',
    density: 7.8,
    imprecise: false,
    latitude: 42.88199,
    longitude: -89.9153,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53544',
  },
  {
    city: 'Janesville',
    county_fips: 55105,
    county_fips_all: '55105',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"55105": 100}',
    density: 423.8,
    imprecise: false,
    latitude: 42.73113,
    longitude: -89.03613,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53545',
  },
  {
    city: 'Janesville',
    county_fips: 55105,
    county_fips_all: '55105',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"55105": 100}',
    density: 142.2,
    imprecise: false,
    latitude: 42.65126,
    longitude: -88.94854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53546',
  },
  {
    city: 'Janesville',
    county_fips: 55105,
    county_fips_all: '55105',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"55105": 100}',
    density: 102.6,
    imprecise: false,
    latitude: 42.68907,
    longitude: -89.13095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53548',
  },
  {
    city: 'Jefferson',
    county_fips: 55055,
    county_fips_all: '55055',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"55055": 100}',
    density: 53.6,
    imprecise: false,
    latitude: 42.99056,
    longitude: -88.77675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53549',
  },
  {
    city: 'Juda',
    county_fips: 55045,
    county_fips_all: '55045',
    county: 'Green',
    county_names_all: 'Green',
    county_weights: '{"55045": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 42.5581,
    longitude: -89.49348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53550',
  },
  {
    city: 'Lake Mills',
    county_fips: 55055,
    county_fips_all: '55055',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"55055": 100}',
    density: 95,
    imprecise: false,
    latitude: 43.07831,
    longitude: -88.91508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53551',
  },
  {
    city: 'Linden',
    county_fips: 55049,
    county_fips_all: '55049',
    county: 'Iowa',
    county_names_all: 'Iowa',
    county_weights: '{"55049": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 42.91235,
    longitude: -90.29693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53553',
  },
  {
    city: 'Livingston',
    county_fips: 55043,
    county_fips_all: '55043|55049',
    county: 'Grant',
    county_names_all: 'Grant|Iowa',
    county_weights: '{"55043": 67.36, "55049": 32.64}',
    density: 8.8,
    imprecise: false,
    latitude: 42.90205,
    longitude: -90.44919,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53554',
  },
  {
    city: 'Lodi',
    county_fips: 55021,
    county_fips_all: '55021|55025',
    county: 'Columbia',
    county_names_all: 'Columbia|Dane',
    county_weights: '{"55021": 79.31, "55025": 20.69}',
    density: 45.6,
    imprecise: false,
    latitude: 43.32163,
    longitude: -89.55625,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53555',
  },
  {
    city: 'Lone Rock',
    county_fips: 55103,
    county_fips_all: '55103|55111',
    county: 'Richland',
    county_names_all: 'Richland|Sauk',
    county_weights: '{"55103": 89.37, "55111": 10.63}',
    density: 19.3,
    imprecise: false,
    latitude: 43.24014,
    longitude: -90.24525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53556',
  },
  {
    city: 'Lowell',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 37.5,
    imprecise: false,
    latitude: 43.33996,
    longitude: -88.79449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53557',
  },
  {
    city: 'Mcfarland',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 292.9,
    imprecise: false,
    latitude: 43.00286,
    longitude: -89.28409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53558',
  },
  {
    city: 'Marshall',
    county_fips: 55025,
    county_fips_all: '55025|55055',
    county: 'Dane',
    county_names_all: 'Dane|Jefferson',
    county_weights: '{"55025": 99.28, "55055": 0.72}',
    density: 35.6,
    imprecise: false,
    latitude: 43.16557,
    longitude: -89.08066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53559',
  },
  {
    city: 'Mazomanie',
    county_fips: 55025,
    county_fips_all: '55025|55049',
    county: 'Dane',
    county_names_all: 'Dane|Iowa',
    county_weights: '{"55025": 91.9, "55049": 8.1}',
    density: 21.9,
    imprecise: false,
    latitude: 43.19418,
    longitude: -89.75413,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53560',
  },
  {
    city: 'Merrimac',
    county_fips: 55111,
    county_fips_all: '55111|55021',
    county: 'Sauk',
    county_names_all: 'Sauk|Columbia',
    county_weights: '{"55111": 71.34, "55021": 28.66}',
    density: 19.8,
    imprecise: false,
    latitude: 43.39594,
    longitude: -89.64414,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53561',
  },
  {
    city: 'Middleton',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 369.7,
    imprecise: false,
    latitude: 43.11592,
    longitude: -89.54188,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53562',
  },
  {
    city: 'Milton',
    county_fips: 55105,
    county_fips_all: '55105|55055',
    county: 'Rock',
    county_names_all: 'Rock|Jefferson',
    county_weights: '{"55105": 97.98, "55055": 2.02}',
    density: 65,
    imprecise: false,
    latitude: 42.78276,
    longitude: -88.93127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53563',
  },
  {
    city: 'Mineral Point',
    county_fips: 55049,
    county_fips_all: '55049|55065',
    county: 'Iowa',
    county_names_all: 'Iowa|Lafayette',
    county_weights: '{"55049": 70.82, "55065": 29.18}',
    density: 9.9,
    imprecise: false,
    latitude: 42.84025,
    longitude: -90.16982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53565',
  },
  {
    city: 'Monroe',
    county_fips: 55045,
    county_fips_all: '55045',
    county: 'Green',
    county_names_all: 'Green',
    county_weights: '{"55045": 100}',
    density: 37.6,
    imprecise: false,
    latitude: 42.60912,
    longitude: -89.64817,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53566',
  },
  {
    city: 'Montfort',
    county_fips: 55043,
    county_fips_all: '55043|55049',
    county: 'Grant',
    county_names_all: 'Grant|Iowa',
    county_weights: '{"55043": 53.95, "55049": 46.05}',
    density: 8.7,
    imprecise: false,
    latitude: 42.98105,
    longitude: -90.42966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53569',
  },
  {
    city: 'Monticello',
    county_fips: 55045,
    county_fips_all: '55045',
    county: 'Green',
    county_names_all: 'Green',
    county_weights: '{"55045": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 42.73857,
    longitude: -89.61966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53570',
  },
  {
    city: 'Morrisonville',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 330,
    imprecise: false,
    latitude: 43.27793,
    longitude: -89.35358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53571',
  },
  {
    city: 'Mount Horeb',
    county_fips: 55025,
    county_fips_all: '55025|55045',
    county: 'Dane',
    county_names_all: 'Dane|Green',
    county_weights: '{"55025": 99.34, "55045": 0.66}',
    density: 40.5,
    imprecise: false,
    latitude: 42.96016,
    longitude: -89.73754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53572',
  },
  {
    city: 'Muscoda',
    county_fips: 55043,
    county_fips_all: '55043|55103|55049',
    county: 'Grant',
    county_names_all: 'Grant|Richland|Iowa',
    county_weights: '{"55043": 41.95, "55103": 41.06, "55049": 17.0}',
    density: 10.5,
    imprecise: false,
    latitude: 43.18196,
    longitude: -90.46326,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53573',
  },
  {
    city: 'New Glarus',
    county_fips: 55045,
    county_fips_all: '55045|55025',
    county: 'Green',
    county_names_all: 'Green|Dane',
    county_weights: '{"55045": 97.41, "55025": 2.59}',
    density: 35.8,
    imprecise: false,
    latitude: 42.81851,
    longitude: -89.65181,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53574',
  },
  {
    city: 'Oregon',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 127.1,
    imprecise: false,
    latitude: 42.93148,
    longitude: -89.38627,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53575',
  },
  {
    city: 'Orfordville',
    county_fips: 55105,
    county_fips_all: '55105',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"55105": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 42.62543,
    longitude: -89.23949,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53576',
  },
  {
    city: 'Plain',
    county_fips: 55111,
    county_fips_all: '55111',
    county: 'Sauk',
    county_names_all: 'Sauk',
    county_weights: '{"55111": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 43.31428,
    longitude: -90.07117,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53577',
  },
  {
    city: 'Prairie Du Sac',
    county_fips: 55111,
    county_fips_all: '55111|55021',
    county: 'Sauk',
    county_names_all: 'Sauk|Columbia',
    county_weights: '{"55111": 80.03, "55021": 19.97}',
    density: 58.3,
    imprecise: false,
    latitude: 43.31356,
    longitude: -89.77408,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53578',
  },
  {
    city: 'Reeseville',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 43.2894,
    longitude: -88.87545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53579',
  },
  {
    city: 'Rewey',
    county_fips: 55049,
    county_fips_all: '55049',
    county: 'Iowa',
    county_names_all: 'Iowa',
    county_weights: '{"55049": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 42.85943,
    longitude: -90.38131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53580',
  },
  {
    city: 'Richland Center',
    county_fips: 55103,
    county_fips_all: '55103',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"55103": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 43.37504,
    longitude: -90.41637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53581',
  },
  {
    city: 'Ridgeway',
    county_fips: 55049,
    county_fips_all: '55049',
    county: 'Iowa',
    county_names_all: 'Iowa',
    county_weights: '{"55049": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 43.01791,
    longitude: -89.99106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53582',
  },
  {
    city: 'Sauk City',
    county_fips: 55111,
    county_fips_all: '55111|55025|55021',
    county: 'Sauk',
    county_names_all: 'Sauk|Dane|Columbia',
    county_weights: '{"55111": 72.35, "55025": 27.44, "55021": 0.21}',
    density: 30.1,
    imprecise: false,
    latitude: 43.25671,
    longitude: -89.81178,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53583',
  },
  {
    city: 'Sextonville',
    county_fips: 55103,
    county_fips_all: '55103',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"55103": 100}',
    density: 76.9,
    imprecise: false,
    latitude: 43.27937,
    longitude: -90.29477,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53584',
  },
  {
    city: 'Sharon',
    county_fips: 55127,
    county_fips_all: '55127|55105',
    county: 'Walworth',
    county_names_all: 'Walworth|Rock',
    county_weights: '{"55127": 95.43, "55105": 4.57}',
    density: 32.1,
    imprecise: false,
    latitude: 42.53049,
    longitude: -88.72056,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53585',
  },
  {
    city: 'Shullsburg',
    county_fips: 55065,
    county_fips_all: '55065',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"55065": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 42.57271,
    longitude: -90.22702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53586',
  },
  {
    city: 'South Wayne',
    county_fips: 55065,
    county_fips_all: '55065',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"55065": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 42.57736,
    longitude: -89.90511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53587',
  },
  {
    city: 'Spring Green',
    county_fips: 55111,
    county_fips_all: '55111|55049|55103',
    county: 'Sauk',
    county_names_all: 'Sauk|Iowa|Richland',
    county_weights: '{"55111": 66.08, "55049": 32.93, "55103": 0.99}',
    density: 10.4,
    imprecise: false,
    latitude: 43.18949,
    longitude: -90.08201,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53588',
  },
  {
    city: 'Stoughton',
    county_fips: 55025,
    county_fips_all: '55025|55105',
    county: 'Dane',
    county_names_all: 'Dane|Rock',
    county_weights: '{"55025": 98.08, "55105": 1.92}',
    density: 88.9,
    imprecise: false,
    latitude: 42.92684,
    longitude: -89.21182,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53589',
  },
  {
    city: 'Sun Prairie',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 267.2,
    imprecise: false,
    latitude: 43.19936,
    longitude: -89.20804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53590',
  },
  {
    city: 'Verona',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 157.5,
    imprecise: false,
    latitude: 42.98533,
    longitude: -89.57992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53593',
  },
  {
    city: 'Waterloo',
    county_fips: 55055,
    county_fips_all: '55055|55027|55025',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Dodge|Dane',
    county_weights: '{"55055": 51.7, "55027": 34.17, "55025": 14.13}',
    density: 27.6,
    imprecise: false,
    latitude: 43.18291,
    longitude: -88.97168,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53594',
  },
  {
    city: 'Waunakee',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 156.2,
    imprecise: false,
    latitude: 43.18258,
    longitude: -89.45726,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53597',
  },
  {
    city: 'Windsor',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 525.8,
    imprecise: false,
    latitude: 43.20641,
    longitude: -89.3387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53598',
  },
  {
    city: 'Woodford',
    county_fips: 55065,
    county_fips_all: '55065',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"55065": 100}',
    density: 120.1,
    imprecise: false,
    latitude: 42.64765,
    longitude: -89.85986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 75,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53599',
  },
  {
    city: 'Madison',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 7861.7,
    imprecise: false,
    latitude: 43.07981,
    longitude: -89.37734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53703',
  },
  {
    city: 'Madison',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 825.5,
    imprecise: false,
    latitude: 43.13633,
    longitude: -89.34684,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53704',
  },
  {
    city: 'Madison',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 1530.1,
    imprecise: false,
    latitude: 43.07427,
    longitude: -89.46246,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53705',
  },
  {
    city: 'Madison',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 3645.4,
    imprecise: false,
    latitude: 43.07505,
    longitude: -89.40987,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53706',
  },
  {
    city: 'Madison',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 762.9,
    imprecise: false,
    latitude: 43.01521,
    longitude: -89.40641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53711',
  },
  {
    city: 'Madison',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 960.4,
    imprecise: false,
    latitude: 43.03743,
    longitude: -89.39254,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53713',
  },
  {
    city: 'Madison',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 1342.9,
    imprecise: false,
    latitude: 43.09884,
    longitude: -89.31287,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53714',
  },
  {
    city: 'Madison',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 4661.9,
    imprecise: false,
    latitude: 43.06038,
    longitude: -89.39861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53715',
  },
  {
    city: 'Madison',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 1132.8,
    imprecise: false,
    latitude: 43.06506,
    longitude: -89.31454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53716',
  },
  {
    city: 'Madison',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 1385.1,
    imprecise: false,
    latitude: 43.07372,
    longitude: -89.51945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53717',
  },
  {
    city: 'Madison',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 351.8,
    imprecise: false,
    latitude: 43.0977,
    longitude: -89.27332,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53718',
  },
  {
    city: 'Madison',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 1294.3,
    imprecise: false,
    latitude: 43.0281,
    longitude: -89.50003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53719',
  },
  {
    city: 'Madison',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 3451.8,
    imprecise: false,
    latitude: 43.07036,
    longitude: -89.4223,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53726',
  },
  {
    city: 'Bagley',
    county_fips: 55043,
    county_fips_all: '55043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"55043": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 42.92505,
    longitude: -91.06959,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53801',
  },
  {
    city: 'Beetown',
    county_fips: 55043,
    county_fips_all: '55043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"55043": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 42.80538,
    longitude: -90.89358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53802',
  },
  {
    city: 'Benton',
    county_fips: 55065,
    county_fips_all: '55065',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"55065": 100}',
    density: 42.4,
    imprecise: false,
    latitude: 42.55915,
    longitude: -90.35508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53803',
  },
  {
    city: 'Bloomington',
    county_fips: 55043,
    county_fips_all: '55043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"55043": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 42.87645,
    longitude: -90.90798,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53804',
  },
  {
    city: 'Boscobel',
    county_fips: 55043,
    county_fips_all: '55043|55023',
    county: 'Grant',
    county_names_all: 'Grant|Crawford',
    county_weights: '{"55043": 63.99, "55023": 36.01}',
    density: 16.3,
    imprecise: false,
    latitude: 43.14236,
    longitude: -90.68445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53805',
  },
  {
    city: 'Cassville',
    county_fips: 55043,
    county_fips_all: '55043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"55043": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 42.73554,
    longitude: -90.92544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53806',
  },
  {
    city: 'Cuba City',
    county_fips: 55043,
    county_fips_all: '55043|55065',
    county: 'Grant',
    county_names_all: 'Grant|Lafayette',
    county_weights: '{"55043": 59.18, "55065": 40.82}',
    density: 15.4,
    imprecise: false,
    latitude: 42.61123,
    longitude: -90.46668,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53807',
  },
  {
    city: 'Dickeyville',
    county_fips: 55043,
    county_fips_all: '55043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"55043": 100}',
    density: 141,
    imprecise: false,
    latitude: 42.63745,
    longitude: -90.59204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53808',
  },
  {
    city: 'Fennimore',
    county_fips: 55043,
    county_fips_all: '55043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"55043": 100}',
    density: 18,
    imprecise: false,
    latitude: 42.99362,
    longitude: -90.63323,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53809',
  },
  {
    city: 'Glen Haven',
    county_fips: 55043,
    county_fips_all: '55043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"55043": 100}',
    density: 4,
    imprecise: false,
    latitude: 42.82144,
    longitude: -90.9984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53810',
  },
  {
    city: 'Hazel Green',
    county_fips: 55043,
    county_fips_all: '55043|55065',
    county: 'Grant',
    county_names_all: 'Grant|Lafayette',
    county_weights: '{"55043": 83.45, "55065": 16.55}',
    density: 25.4,
    imprecise: false,
    latitude: 42.53576,
    longitude: -90.51541,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53811',
  },
  {
    city: 'Kieler',
    county_fips: 55043,
    county_fips_all: '55043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"55043": 100}',
    density: 196,
    imprecise: false,
    latitude: 42.5808,
    longitude: -90.60239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53812',
  },
  {
    city: 'Lancaster',
    county_fips: 55043,
    county_fips_all: '55043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"55043": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 42.84402,
    longitude: -90.71641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53813',
  },
  {
    city: 'Mount Hope',
    county_fips: 55043,
    county_fips_all: '55043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"55043": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 42.97794,
    longitude: -90.85773,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53816',
  },
  {
    city: 'Patch Grove',
    county_fips: 55043,
    county_fips_all: '55043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"55043": 100}',
    density: 231.1,
    imprecise: false,
    latitude: 42.94028,
    longitude: -90.97234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53817',
  },
  {
    city: 'Platteville',
    county_fips: 55043,
    county_fips_all: '55043|55065|55049',
    county: 'Grant',
    county_names_all: 'Grant|Lafayette|Iowa',
    county_weights: '{"55043": 81.1, "55065": 16.8, "55049": 2.1}',
    density: 40.1,
    imprecise: false,
    latitude: 42.74725,
    longitude: -90.49177,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53818',
  },
  {
    city: 'Potosi',
    county_fips: 55043,
    county_fips_all: '55043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"55043": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 42.69649,
    longitude: -90.70984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53820',
  },
  {
    city: 'Prairie Du Chien',
    county_fips: 55023,
    county_fips_all: '55023|55043',
    county: 'Crawford',
    county_names_all: 'Crawford|Grant',
    county_weights: '{"55023": 78.66, "55043": 21.34}',
    density: 31,
    imprecise: false,
    latitude: 43.04769,
    longitude: -91.06569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53821',
  },
  {
    city: 'Stitzer',
    county_fips: 55043,
    county_fips_all: '55043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"55043": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 42.91833,
    longitude: -90.58851,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53825',
  },
  {
    city: 'Wauzeka',
    county_fips: 55023,
    county_fips_all: '55023',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"55023": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 43.12225,
    longitude: -90.91039,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53826',
  },
  {
    city: 'Woodman',
    county_fips: 55043,
    county_fips_all: '55043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"55043": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 43.05049,
    longitude: -90.83702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53827',
  },
  {
    city: 'Portage',
    county_fips: 55021,
    county_fips_all: '55021|55077',
    county: 'Columbia',
    county_names_all: 'Columbia|Marquette',
    county_weights: '{"55021": 98.83, "55077": 1.17}',
    density: 37.5,
    imprecise: false,
    latitude: 43.55606,
    longitude: -89.48606,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53901',
  },
  {
    city: 'Adams',
    county_fips: 55001,
    county_fips_all: '55001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"55001": 100}',
    density: 23.9,
    imprecise: false,
    latitude: 43.89073,
    longitude: -89.80708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53910',
  },
  {
    city: 'Arlington',
    county_fips: 55021,
    county_fips_all: '55021|55025',
    county: 'Columbia',
    county_names_all: 'Columbia|Dane',
    county_weights: '{"55021": 92.24, "55025": 7.76}',
    density: 15.3,
    imprecise: false,
    latitude: 43.3258,
    longitude: -89.36478,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53911',
  },
  {
    city: 'Baraboo',
    county_fips: 55111,
    county_fips_all: '55111|55021',
    county: 'Sauk',
    county_names_all: 'Sauk|Columbia',
    county_weights: '{"55111": 98.66, "55021": 1.34}',
    density: 60.3,
    imprecise: false,
    latitude: 43.49213,
    longitude: -89.72858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53913',
  },
  {
    city: 'Beaver Dam',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 85,
    imprecise: false,
    latitude: 43.45538,
    longitude: -88.85813,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53916',
  },
  {
    city: 'Brandon',
    county_fips: 55039,
    county_fips_all: '55039',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac',
    county_weights: '{"55039": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 43.73462,
    longitude: -88.77564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53919',
  },
  {
    city: 'Briggsville',
    county_fips: 55001,
    county_fips_all: '55001|55077',
    county: 'Adams',
    county_names_all: 'Adams|Marquette',
    county_weights: '{"55001": 50.85, "55077": 49.15}',
    density: 40.5,
    imprecise: false,
    latitude: 43.66579,
    longitude: -89.60364,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53920',
  },
  {
    city: 'Burnett',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 43.51558,
    longitude: -88.70916,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53922',
  },
  {
    city: 'Cambria',
    county_fips: 55021,
    county_fips_all: '55021|55047',
    county: 'Columbia',
    county_names_all: 'Columbia|Green Lake',
    county_weights: '{"55021": 89.95, "55047": 10.05}',
    density: 11.5,
    imprecise: false,
    latitude: 43.57326,
    longitude: -89.13753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53923',
  },
  {
    city: 'Cazenovia',
    county_fips: 55103,
    county_fips_all: '55103|55111',
    county: 'Richland',
    county_names_all: 'Richland|Sauk',
    county_weights: '{"55103": 94.84, "55111": 5.16}',
    density: 7.2,
    imprecise: false,
    latitude: 43.47971,
    longitude: -90.25455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53924',
  },
  {
    city: 'Columbus',
    county_fips: 55021,
    county_fips_all: '55021|55027|55025',
    county: 'Columbia',
    county_names_all: 'Columbia|Dodge|Dane',
    county_weights: '{"55021": 53.87, "55027": 36.12, "55025": 10.01}',
    density: 26.6,
    imprecise: false,
    latitude: 43.3325,
    longitude: -89.05075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53925',
  },
  {
    city: 'Dalton',
    county_fips: 55047,
    county_fips_all: '55047|55077|55021',
    county: 'Green Lake',
    county_names_all: 'Green Lake|Marquette|Columbia',
    county_weights: '{"55047": 55.19, "55077": 26.05, "55021": 18.76}',
    density: 14.6,
    imprecise: false,
    latitude: 43.67164,
    longitude: -89.21497,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53926',
  },
  {
    city: 'Doylestown',
    county_fips: 55021,
    county_fips_all: '55021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"55021": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 43.42051,
    longitude: -89.1547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53928',
  },
  {
    city: 'Elroy',
    county_fips: 55057,
    county_fips_all: '55057|55081|55123',
    county: 'Juneau',
    county_names_all: 'Juneau|Monroe|Vernon',
    county_weights: '{"55057": 72.2, "55081": 16.81, "55123": 10.99}',
    density: 14.6,
    imprecise: false,
    latitude: 43.75415,
    longitude: -90.28376,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53929',
  },
  {
    city: 'Endeavor',
    county_fips: 55077,
    county_fips_all: '55077',
    county: 'Marquette',
    county_names_all: 'Marquette',
    county_weights: '{"55077": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 43.683,
    longitude: -89.49506,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53930',
  },
  {
    city: 'Fairwater',
    county_fips: 55039,
    county_fips_all: '55039',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac',
    county_weights: '{"55039": 100}',
    density: 183.9,
    imprecise: false,
    latitude: 43.74236,
    longitude: -88.86798,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53931',
  },
  {
    city: 'Fall River',
    county_fips: 55021,
    county_fips_all: '55021|55027',
    county: 'Columbia',
    county_names_all: 'Columbia|Dodge',
    county_weights: '{"55021": 91.71, "55027": 8.29}',
    density: 25.3,
    imprecise: false,
    latitude: 43.4202,
    longitude: -89.06543,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53932',
  },
  {
    city: 'Fox Lake',
    county_fips: 55027,
    county_fips_all: '55027',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"55027": 100}',
    density: 43.3,
    imprecise: false,
    latitude: 43.57235,
    longitude: -88.88338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53933',
  },
  {
    city: 'Friendship',
    county_fips: 55001,
    county_fips_all: '55001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"55001": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 43.98044,
    longitude: -89.82184,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53934',
  },
  {
    city: 'Friesland',
    county_fips: 55021,
    county_fips_all: '55021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"55021": 100}',
    density: 114.7,
    imprecise: false,
    latitude: 43.58864,
    longitude: -89.06697,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53935',
  },
  {
    city: 'Grand Marsh',
    county_fips: 55001,
    county_fips_all: '55001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"55001": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 43.87477,
    longitude: -89.71071,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53936',
  },
  {
    city: 'Hillpoint',
    county_fips: 55111,
    county_fips_all: '55111|55103',
    county: 'Sauk',
    county_names_all: 'Sauk|Richland',
    county_weights: '{"55111": 72.26, "55103": 27.74}',
    density: 8.5,
    imprecise: false,
    latitude: 43.38841,
    longitude: -90.15753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53937',
  },
  {
    city: 'Kingston',
    county_fips: 55047,
    county_fips_all: '55047',
    county: 'Green Lake',
    county_names_all: 'Green Lake',
    county_weights: '{"55047": 100}',
    density: 95,
    imprecise: false,
    latitude: 43.69185,
    longitude: -89.13199,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53939',
  },
  {
    city: 'Lake Delton',
    county_fips: 55111,
    county_fips_all: '55111',
    county: 'Sauk',
    county_names_all: 'Sauk',
    county_weights: '{"55111": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.59126,
    longitude: -89.7944,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53940',
  },
  {
    city: 'La Valle',
    county_fips: 55111,
    county_fips_all: '55111|55057|55103',
    county: 'Sauk',
    county_names_all: 'Sauk|Juneau|Richland',
    county_weights: '{"55111": 94.1, "55057": 5.57, "55103": 0.33}',
    density: 15.8,
    imprecise: false,
    latitude: 43.57947,
    longitude: -90.13694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53941',
  },
  {
    city: 'Lime Ridge',
    county_fips: 55111,
    county_fips_all: '55111',
    county: 'Sauk',
    county_names_all: 'Sauk',
    county_weights: '{"55111": 100}',
    density: 68.7,
    imprecise: false,
    latitude: 43.46393,
    longitude: -90.16536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53942',
  },
  {
    city: 'Loganville',
    county_fips: 55111,
    county_fips_all: '55111',
    county: 'Sauk',
    county_names_all: 'Sauk',
    county_weights: '{"55111": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 43.38999,
    longitude: -90.03018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53943',
  },
  {
    city: 'Lyndon Station',
    county_fips: 55057,
    county_fips_all: '55057|55111',
    county: 'Juneau',
    county_names_all: 'Juneau|Sauk',
    county_weights: '{"55057": 83.12, "55111": 16.88}',
    density: 10.9,
    imprecise: false,
    latitude: 43.68759,
    longitude: -89.92791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53944',
  },
  {
    city: 'Markesan',
    county_fips: 55047,
    county_fips_all: '55047|55039|55077|55027',
    county: 'Green Lake',
    county_names_all: 'Green Lake|Fond du Lac|Marquette|Dodge',
    county_weights:
      '{"55047": 93.85, "55039": 4.25, "55077": 1.04, "55027": 0.86}',
    density: 13.1,
    imprecise: false,
    latitude: 43.71822,
    longitude: -89.02189,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53946',
  },
  {
    city: 'Marquette',
    county_fips: 55047,
    county_fips_all: '55047',
    county: 'Green Lake',
    county_names_all: 'Green Lake',
    county_weights: '{"55047": 100}',
    density: 246.5,
    imprecise: false,
    latitude: 43.74676,
    longitude: -89.13769,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53947',
  },
  {
    city: 'Mauston',
    county_fips: 55057,
    county_fips_all: '55057',
    county: 'Juneau',
    county_names_all: 'Juneau',
    county_weights: '{"55057": 100}',
    density: 21,
    imprecise: false,
    latitude: 43.77846,
    longitude: -90.05161,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53948',
  },
  {
    city: 'Montello',
    county_fips: 55077,
    county_fips_all: '55077|55047',
    county: 'Marquette',
    county_names_all: 'Marquette|Green Lake',
    county_weights: '{"55077": 95.87, "55047": 4.13}',
    density: 14.7,
    imprecise: false,
    latitude: 43.78323,
    longitude: -89.33978,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53949',
  },
  {
    city: 'New Lisbon',
    county_fips: 55057,
    county_fips_all: '55057',
    county: 'Juneau',
    county_names_all: 'Juneau',
    county_weights: '{"55057": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 43.90477,
    longitude: -90.13463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53950',
  },
  {
    city: 'North Freedom',
    county_fips: 55111,
    county_fips_all: '55111',
    county: 'Sauk',
    county_names_all: 'Sauk',
    county_weights: '{"55111": 100}',
    density: 13,
    imprecise: false,
    latitude: 43.39087,
    longitude: -89.86633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53951',
  },
  {
    city: 'Oxford',
    county_fips: 55077,
    county_fips_all: '55077|55001',
    county: 'Marquette',
    county_names_all: 'Marquette|Adams',
    county_weights: '{"55077": 50.05, "55001": 49.95}',
    density: 14,
    imprecise: false,
    latitude: 43.78718,
    longitude: -89.5963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53952',
  },
  {
    city: 'Packwaukee',
    county_fips: 55077,
    county_fips_all: '55077',
    county: 'Marquette',
    county_names_all: 'Marquette',
    county_weights: '{"55077": 100}',
    density: 243.6,
    imprecise: false,
    latitude: 43.76606,
    longitude: -89.458,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53953',
  },
  {
    city: 'Pardeeville',
    county_fips: 55021,
    county_fips_all: '55021|55077',
    county: 'Columbia',
    county_names_all: 'Columbia|Marquette',
    county_weights: '{"55021": 90.86, "55077": 9.14}',
    density: 32.6,
    imprecise: false,
    latitude: 43.55518,
    longitude: -89.31325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53954',
  },
  {
    city: 'Poynette',
    county_fips: 55021,
    county_fips_all: '55021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"55021": 100}',
    density: 32.3,
    imprecise: false,
    latitude: 43.40025,
    longitude: -89.40051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53955',
  },
  {
    city: 'Randolph',
    county_fips: 55021,
    county_fips_all: '55021|55027|55047',
    county: 'Columbia',
    county_names_all: 'Columbia|Dodge|Green Lake',
    county_weights: '{"55021": 55.27, "55027": 40.09, "55047": 4.64}',
    density: 17.1,
    imprecise: false,
    latitude: 43.54166,
    longitude: -89.01849,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53956',
  },
  {
    city: 'Reedsburg',
    county_fips: 55111,
    county_fips_all: '55111',
    county: 'Sauk',
    county_names_all: 'Sauk',
    county_weights: '{"55111": 100}',
    density: 50,
    imprecise: false,
    latitude: 43.53407,
    longitude: -89.99702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53959',
  },
  {
    city: 'Rio',
    county_fips: 55021,
    county_fips_all: '55021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"55021": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 43.4224,
    longitude: -89.23212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53960',
  },
  {
    city: 'Rock Springs',
    county_fips: 55111,
    county_fips_all: '55111',
    county: 'Sauk',
    county_names_all: 'Sauk',
    county_weights: '{"55111": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 43.46055,
    longitude: -89.93858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53961',
  },
  {
    city: 'Union Center',
    county_fips: 55057,
    county_fips_all: '55057',
    county: 'Juneau',
    county_names_all: 'Juneau',
    county_weights: '{"55057": 100}',
    density: 396.6,
    imprecise: false,
    latitude: 43.68352,
    longitude: -90.2652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53962',
  },
  {
    city: 'Waupun',
    county_fips: 55039,
    county_fips_all: '55039|55027',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac|Dodge',
    county_weights: '{"55039": 53.65, "55027": 46.35}',
    density: 60,
    imprecise: false,
    latitude: 43.63492,
    longitude: -88.73828,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53963',
  },
  {
    city: 'Westfield',
    county_fips: 55077,
    county_fips_all: '55077|55001|55137',
    county: 'Marquette',
    county_names_all: 'Marquette|Adams|Waushara',
    county_weights: '{"55077": 90.07, "55001": 8.34, "55137": 1.59}',
    density: 12,
    imprecise: false,
    latitude: 43.91253,
    longitude: -89.5025,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53964',
  },
  {
    city: 'Wisconsin Dells',
    county_fips: 55001,
    county_fips_all: '55001|55021|55111|55057',
    county: 'Adams',
    county_names_all: 'Adams|Columbia|Sauk|Juneau',
    county_weights:
      '{"55001": 55.37, "55021": 20.93, "55111": 16.65, "55057": 7.05}',
    density: 24.8,
    imprecise: false,
    latitude: 43.67651,
    longitude: -89.75681,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53965',
  },
  {
    city: 'Wonewoc',
    county_fips: 55057,
    county_fips_all: '55057|55111|55123|55103',
    county: 'Juneau',
    county_names_all: 'Juneau|Sauk|Vernon|Richland',
    county_weights:
      '{"55057": 55.04, "55111": 37.38, "55123": 5.63, "55103": 1.95}',
    density: 12.3,
    imprecise: false,
    latitude: 43.64072,
    longitude: -90.2326,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53968',
  },
  {
    city: 'Wyocena',
    county_fips: 55021,
    county_fips_all: '55021',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"55021": 100}',
    density: 208.4,
    imprecise: false,
    latitude: 43.49567,
    longitude: -89.30176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53969',
  },
  {
    city: 'Amery',
    county_fips: 55095,
    county_fips_all: '55095',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"55095": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 45.33417,
    longitude: -92.38703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54001',
  },
  {
    city: 'Baldwin',
    county_fips: 55109,
    county_fips_all: '55109|55093',
    county: 'St. Croix',
    county_names_all: 'St. Croix|Pierce',
    county_weights: '{"55109": 96.93, "55093": 3.07}',
    density: 34.1,
    imprecise: false,
    latitude: 44.95871,
    longitude: -92.37121,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54002',
  },
  {
    city: 'Beldenville',
    county_fips: 55093,
    county_fips_all: '55093',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"55093": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 44.79019,
    longitude: -92.44218,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54003',
  },
  {
    city: 'Clayton',
    county_fips: 55005,
    county_fips_all: '55005|55095',
    county: 'Barron',
    county_names_all: 'Barron|Polk',
    county_weights: '{"55005": 66.73, "55095": 33.27}',
    density: 10.8,
    imprecise: false,
    latitude: 45.30699,
    longitude: -92.12414,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54004',
  },
  {
    city: 'Clear Lake',
    county_fips: 55095,
    county_fips_all: '55095|55109|55005|55033',
    county: 'Polk',
    county_names_all: 'Polk|St. Croix|Barron|Dunn',
    county_weights:
      '{"55095": 65.03, "55109": 19.64, "55005": 8.46, "55033": 6.87}',
    density: 15.1,
    imprecise: false,
    latitude: 45.23447,
    longitude: -92.23051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54005',
  },
  {
    city: 'Cushing',
    county_fips: 55095,
    county_fips_all: '55095',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"55095": 100}',
    density: 12,
    imprecise: false,
    latitude: 45.58958,
    longitude: -92.64824,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54006',
  },
  {
    city: 'Deer Park',
    county_fips: 55109,
    county_fips_all: '55109|55095',
    county: 'St. Croix',
    county_names_all: 'St. Croix|Polk',
    county_weights: '{"55109": 77.92, "55095": 22.08}',
    density: 10.1,
    imprecise: false,
    latitude: 45.18781,
    longitude: -92.35734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54007',
  },
  {
    city: 'Dresser',
    county_fips: 55095,
    county_fips_all: '55095',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"55095": 100}',
    density: 31.7,
    imprecise: false,
    latitude: 45.35358,
    longitude: -92.57693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54009',
  },
  {
    city: 'Ellsworth',
    county_fips: 55093,
    county_fips_all: '55093',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"55093": 100}',
    density: 26.1,
    imprecise: false,
    latitude: 44.71648,
    longitude: -92.46279,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54011',
  },
  {
    city: 'Glenwood City',
    county_fips: 55109,
    county_fips_all: '55109|55033',
    county: 'St. Croix',
    county_names_all: 'St. Croix|Dunn',
    county_weights: '{"55109": 96.47, "55033": 3.53}',
    density: 12.7,
    imprecise: false,
    latitude: 45.08134,
    longitude: -92.22929,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54013',
  },
  {
    city: 'Hager City',
    county_fips: 55093,
    county_fips_all: '55093',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"55093": 100}',
    density: 18.5,
    imprecise: false,
    latitude: 44.64578,
    longitude: -92.57048,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54014',
  },
  {
    city: 'Hammond',
    county_fips: 55109,
    county_fips_all: '55109',
    county: 'St. Croix',
    county_names_all: 'St. Croix',
    county_weights: '{"55109": 100}',
    density: 45,
    imprecise: false,
    latitude: 44.96899,
    longitude: -92.45419,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54015',
  },
  {
    city: 'Hudson',
    county_fips: 55109,
    county_fips_all: '55109',
    county: 'St. Croix',
    county_names_all: 'St. Croix',
    county_weights: '{"55109": 100}',
    density: 192.2,
    imprecise: false,
    latitude: 44.97949,
    longitude: -92.69305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54016',
  },
  {
    city: 'New Richmond',
    county_fips: 55109,
    county_fips_all: '55109|55095',
    county: 'St. Croix',
    county_names_all: 'St. Croix|Polk',
    county_weights: '{"55109": 96.85, "55095": 3.15}',
    density: 56.5,
    imprecise: false,
    latitude: 45.11907,
    longitude: -92.52091,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54017',
  },
  {
    city: 'Osceola',
    county_fips: 55095,
    county_fips_all: '55095|55109',
    county: 'Polk',
    county_names_all: 'Polk|St. Croix',
    county_weights: '{"55095": 99.02, "55109": 0.98}',
    density: 40.3,
    imprecise: false,
    latitude: 45.27937,
    longitude: -92.65235,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54020',
  },
  {
    city: 'Prescott',
    county_fips: 55093,
    county_fips_all: '55093',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"55093": 100}',
    density: 65,
    imprecise: false,
    latitude: 44.74048,
    longitude: -92.71144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54021',
  },
  {
    city: 'River Falls',
    county_fips: 55093,
    county_fips_all: '55093|55109',
    county: 'Pierce',
    county_names_all: 'Pierce|St. Croix',
    county_weights: '{"55093": 61.25, "55109": 38.75}',
    density: 69.5,
    imprecise: false,
    latitude: 44.84796,
    longitude: -92.6096,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54022',
  },
  {
    city: 'Roberts',
    county_fips: 55109,
    county_fips_all: '55109',
    county: 'St. Croix',
    county_names_all: 'St. Croix',
    county_weights: '{"55109": 100}',
    density: 39.7,
    imprecise: false,
    latitude: 44.97708,
    longitude: -92.55218,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54023',
  },
  {
    city: 'Saint Croix Falls',
    county_fips: 55095,
    county_fips_all: '55095',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"55095": 100}',
    density: 23.3,
    imprecise: false,
    latitude: 45.49873,
    longitude: -92.64781,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54024',
  },
  {
    city: 'Somerset',
    county_fips: 55109,
    county_fips_all: '55109',
    county: 'St. Croix',
    county_names_all: 'St. Croix',
    county_weights: '{"55109": 100}',
    density: 58.7,
    imprecise: false,
    latitude: 45.14184,
    longitude: -92.68997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54025',
  },
  {
    city: 'Star Prairie',
    county_fips: 55095,
    county_fips_all: '55095|55109',
    county: 'Polk',
    county_names_all: 'Polk|St. Croix',
    county_weights: '{"55095": 75.98, "55109": 24.02}',
    density: 32.8,
    imprecise: false,
    latitude: 45.22688,
    longitude: -92.53459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54026',
  },
  {
    city: 'Wilson',
    county_fips: 55109,
    county_fips_all: '55109',
    county: 'St. Croix',
    county_names_all: 'St. Croix',
    county_weights: '{"55109": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 44.92403,
    longitude: -92.19985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54027',
  },
  {
    city: 'Woodville',
    county_fips: 55109,
    county_fips_all: '55109',
    county: 'St. Croix',
    county_names_all: 'St. Croix',
    county_weights: '{"55109": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 44.95532,
    longitude: -92.28279,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54028',
  },
  {
    city: 'Houlton',
    county_fips: 55109,
    county_fips_all: '55109',
    county: 'St. Croix',
    county_names_all: 'St. Croix',
    county_weights: '{"55109": 100}',
    density: 68.2,
    imprecise: false,
    latitude: 45.0696,
    longitude: -92.75403,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54082',
  },
  {
    city: 'Abrams',
    county_fips: 55083,
    county_fips_all: '55083',
    county: 'Oconto',
    county_names_all: 'Oconto',
    county_weights: '{"55083": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 44.78786,
    longitude: -88.05927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54101',
  },
  {
    city: 'Amberg',
    county_fips: 55075,
    county_fips_all: '55075',
    county: 'Marinette',
    county_names_all: 'Marinette',
    county_weights: '{"55075": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 45.50278,
    longitude: -88.00524,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54102',
  },
  {
    city: 'Armstrong Creek',
    county_fips: 55041,
    county_fips_all: '55041|55075',
    county: 'Forest',
    county_names_all: 'Forest|Marinette',
    county_weights: '{"55041": 96.76, "55075": 3.24}',
    density: 2.7,
    imprecise: false,
    latitude: 45.64972,
    longitude: -88.49885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54103',
  },
  {
    city: 'Athelstane',
    county_fips: 55075,
    county_fips_all: '55075|55041',
    county: 'Marinette',
    county_names_all: 'Marinette|Forest',
    county_weights: '{"55075": 99.17, "55041": 0.83}',
    density: 2.1,
    imprecise: false,
    latitude: 45.44018,
    longitude: -88.26518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54104',
  },
  {
    city: 'Black Creek',
    county_fips: 55087,
    county_fips_all: '55087|55115',
    county: 'Outagamie',
    county_names_all: 'Outagamie|Shawano',
    county_weights: '{"55087": 98.54, "55115": 1.46}',
    density: 22,
    imprecise: false,
    latitude: 44.48172,
    longitude: -88.45551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54106',
  },
  {
    city: 'Bonduel',
    county_fips: 55115,
    county_fips_all: '55115|55087',
    county: 'Shawano',
    county_names_all: 'Shawano|Outagamie',
    county_weights: '{"55115": 97.28, "55087": 2.72}',
    density: 19.4,
    imprecise: false,
    latitude: 44.70068,
    longitude: -88.44436,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54107',
  },
  {
    city: 'Brillion',
    county_fips: 55015,
    county_fips_all: '55015|55071|55009',
    county: 'Calumet',
    county_names_all: 'Calumet|Manitowoc|Brown',
    county_weights: '{"55015": 72.77, "55071": 24.49, "55009": 2.74}',
    density: 33.7,
    imprecise: false,
    latitude: 44.18533,
    longitude: -88.08105,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54110',
  },
  {
    city: 'Cecil',
    county_fips: 55115,
    county_fips_all: '55115|55083',
    county: 'Shawano',
    county_names_all: 'Shawano|Oconto',
    county_weights: '{"55115": 92.71, "55083": 7.29}',
    density: 15.1,
    imprecise: false,
    latitude: 44.81572,
    longitude: -88.37992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54111',
  },
  {
    city: 'Coleman',
    county_fips: 55075,
    county_fips_all: '55075|55083',
    county: 'Marinette',
    county_names_all: 'Marinette|Oconto',
    county_weights: '{"55075": 71.7, "55083": 28.3}',
    density: 17.3,
    imprecise: false,
    latitude: 45.04527,
    longitude: -88.04743,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54112',
  },
  {
    city: 'Combined Locks',
    county_fips: 55087,
    county_fips_all: '55087',
    county: 'Outagamie',
    county_names_all: 'Outagamie',
    county_weights: '{"55087": 100}',
    density: 784,
    imprecise: false,
    latitude: 44.26404,
    longitude: -88.30705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54113',
  },
  {
    city: 'Crivitz',
    county_fips: 55075,
    county_fips_all: '55075|55083',
    county: 'Marinette',
    county_names_all: 'Marinette|Oconto',
    county_weights: '{"55075": 91.77, "55083": 8.23}',
    density: 9.8,
    imprecise: false,
    latitude: 45.25254,
    longitude: -88.12197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54114',
  },
  {
    city: 'De Pere',
    county_fips: 55009,
    county_fips_all: '55009|55087',
    county: 'Brown',
    county_names_all: 'Brown|Outagamie',
    county_weights: '{"55009": 85.18, "55087": 14.82}',
    density: 157,
    imprecise: false,
    latitude: 44.40552,
    longitude: -88.09195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54115',
  },
  {
    city: 'Dunbar',
    county_fips: 55075,
    county_fips_all: '55075',
    county: 'Marinette',
    county_names_all: 'Marinette',
    county_weights: '{"55075": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 45.62488,
    longitude: -88.18285,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54119',
  },
  {
    city: 'Fence',
    county_fips: 55037,
    county_fips_all: '55037|55075',
    county: 'Florence',
    county_names_all: 'Florence|Marinette',
    county_weights: '{"55037": 85.31, "55075": 14.69}',
    density: 0.9,
    imprecise: false,
    latitude: 45.75892,
    longitude: -88.49089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54120',
  },
  {
    city: 'Florence',
    county_fips: 55037,
    county_fips_all: '55037',
    county: 'Florence',
    county_names_all: 'Florence',
    county_weights: '{"55037": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 45.86385,
    longitude: -88.32899,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54121',
  },
  {
    city: 'Forest Junction',
    county_fips: 55015,
    county_fips_all: '55015',
    county: 'Calumet',
    county_names_all: 'Calumet',
    county_weights: '{"55015": 100}',
    density: 107.5,
    imprecise: false,
    latitude: 44.20642,
    longitude: -88.15201,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54123',
  },
  {
    city: 'Gillett',
    county_fips: 55083,
    county_fips_all: '55083|55078|55115',
    county: 'Oconto',
    county_names_all: 'Oconto|Menominee|Shawano',
    county_weights: '{"55083": 91.57, "55078": 8.24, "55115": 0.19}',
    density: 14.2,
    imprecise: false,
    latitude: 44.90701,
    longitude: -88.36616,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54124',
  },
  {
    city: 'Goodman',
    county_fips: 55075,
    county_fips_all: '55075|55041',
    county: 'Marinette',
    county_names_all: 'Marinette|Forest',
    county_weights: '{"55075": 70.66, "55041": 29.34}',
    density: 2,
    imprecise: false,
    latitude: 45.58995,
    longitude: -88.38325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54125',
  },
  {
    city: 'Greenleaf',
    county_fips: 55009,
    county_fips_all: '55009|55071',
    county: 'Brown',
    county_names_all: 'Brown|Manitowoc',
    county_weights: '{"55009": 99.36, "55071": 0.64}',
    density: 20.3,
    imprecise: false,
    latitude: 44.28925,
    longitude: -88.03218,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54126',
  },
  {
    city: 'Green Valley',
    county_fips: 55115,
    county_fips_all: '55115',
    county: 'Shawano',
    county_names_all: 'Shawano',
    county_weights: '{"55115": 100}',
    density: 76.2,
    imprecise: false,
    latitude: 44.79693,
    longitude: -88.26815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54127',
  },
  {
    city: 'Gresham',
    county_fips: 55115,
    county_fips_all: '55115',
    county: 'Shawano',
    county_names_all: 'Shawano',
    county_weights: '{"55115": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 44.86675,
    longitude: -88.80525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54128',
  },
  {
    city: 'Hilbert',
    county_fips: 55015,
    county_fips_all: '55015',
    county: 'Calumet',
    county_names_all: 'Calumet',
    county_weights: '{"55015": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 44.12902,
    longitude: -88.20146,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54129',
  },
  {
    city: 'Kaukauna',
    county_fips: 55087,
    county_fips_all: '55087|55015|55009',
    county: 'Outagamie',
    county_names_all: 'Outagamie|Calumet|Brown',
    county_weights: '{"55087": 79.08, "55015": 10.69, "55009": 10.23}',
    density: 140.4,
    imprecise: false,
    latitude: 44.31194,
    longitude: -88.24301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54130',
  },
  {
    city: 'Keshena',
    county_fips: 55078,
    county_fips_all: '55078',
    county: 'Menominee',
    county_names_all: 'Menominee',
    county_weights: '{"55078": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 44.91468,
    longitude: -88.61209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54135',
  },
  {
    city: 'Kimberly',
    county_fips: 55087,
    county_fips_all: '55087',
    county: 'Outagamie',
    county_names_all: 'Outagamie',
    county_weights: '{"55087": 100}',
    density: 1327.3,
    imprecise: false,
    latitude: 44.26834,
    longitude: -88.33852,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54136',
  },
  {
    city: 'Krakow',
    county_fips: 55115,
    county_fips_all: '55115|55083',
    county: 'Shawano',
    county_names_all: 'Shawano|Oconto',
    county_weights: '{"55115": 58.89, "55083": 41.11}',
    density: 16.8,
    imprecise: false,
    latitude: 44.75843,
    longitude: -88.25605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54137',
  },
  {
    city: 'Lakewood',
    county_fips: 55083,
    county_fips_all: '55083',
    county: 'Oconto',
    county_names_all: 'Oconto',
    county_weights: '{"55083": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 45.33064,
    longitude: -88.42783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54138',
  },
  {
    city: 'Lena',
    county_fips: 55083,
    county_fips_all: '55083|55075',
    county: 'Oconto',
    county_names_all: 'Oconto|Marinette',
    county_weights: '{"55083": 98.46, "55075": 1.54}',
    density: 12.2,
    imprecise: false,
    latitude: 44.9539,
    longitude: -88.07152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54139',
  },
  {
    city: 'Little Chute',
    county_fips: 55087,
    county_fips_all: '55087',
    county: 'Outagamie',
    county_names_all: 'Outagamie',
    county_weights: '{"55087": 100}',
    density: 989.7,
    imprecise: false,
    latitude: 44.28689,
    longitude: -88.31045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54140',
  },
  {
    city: 'Little Suamico',
    county_fips: 55083,
    county_fips_all: '55083|55009',
    county: 'Oconto',
    county_names_all: 'Oconto|Brown',
    county_weights: '{"55083": 99.76, "55009": 0.24}',
    density: 43.4,
    imprecise: false,
    latitude: 44.72753,
    longitude: -88.00567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54141',
  },
  {
    city: 'Marinette',
    county_fips: 55075,
    county_fips_all: '55075',
    county: 'Marinette',
    county_names_all: 'Marinette',
    county_weights: '{"55075": 100}',
    density: 88.1,
    imprecise: false,
    latitude: 45.08708,
    longitude: -87.70045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54143',
  },
  {
    city: 'Mountain',
    county_fips: 55083,
    county_fips_all: '55083',
    county: 'Oconto',
    county_names_all: 'Oconto',
    county_weights: '{"55083": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 45.204,
    longitude: -88.47445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54149',
  },
  {
    city: 'Neopit',
    county_fips: 55078,
    county_fips_all: '55078|55115',
    county: 'Menominee',
    county_names_all: 'Menominee|Shawano',
    county_weights: '{"55078": 97.03, "55115": 2.97}',
    density: 8.3,
    imprecise: false,
    latitude: 44.97237,
    longitude: -88.7906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54150',
  },
  {
    city: 'Niagara',
    county_fips: 55075,
    county_fips_all: '55075|55037',
    county: 'Marinette',
    county_names_all: 'Marinette|Florence',
    county_weights: '{"55075": 71.64, "55037": 28.36}',
    density: 10.2,
    imprecise: false,
    latitude: 45.72352,
    longitude: -87.99752,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54151',
  },
  {
    city: 'Nichols',
    county_fips: 55087,
    county_fips_all: '55087',
    county: 'Outagamie',
    county_names_all: 'Outagamie',
    county_weights: '{"55087": 100}',
    density: 160.4,
    imprecise: false,
    latitude: 44.56645,
    longitude: -88.47049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54152',
  },
  {
    city: 'Oconto',
    county_fips: 55083,
    county_fips_all: '55083',
    county: 'Oconto',
    county_names_all: 'Oconto',
    county_weights: '{"55083": 100}',
    density: 28.7,
    imprecise: false,
    latitude: 44.89939,
    longitude: -87.92516,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54153',
  },
  {
    city: 'Oconto Falls',
    county_fips: 55083,
    county_fips_all: '55083|55115',
    county: 'Oconto',
    county_names_all: 'Oconto|Shawano',
    county_weights: '{"55083": 89.64, "55115": 10.36}',
    density: 27.6,
    imprecise: false,
    latitude: 44.86702,
    longitude: -88.19058,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54154',
  },
  {
    city: 'Oneida',
    county_fips: 55009,
    county_fips_all: '55009|55087',
    county: 'Brown',
    county_names_all: 'Brown|Outagamie',
    county_weights: '{"55009": 50.18, "55087": 49.82}',
    density: 90.6,
    imprecise: false,
    latitude: 44.51979,
    longitude: -88.19038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54155',
  },
  {
    city: 'Pembine',
    county_fips: 55075,
    county_fips_all: '55075',
    county: 'Marinette',
    county_names_all: 'Marinette',
    county_weights: '{"55075": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 45.60099,
    longitude: -87.93963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54156',
  },
  {
    city: 'Peshtigo',
    county_fips: 55075,
    county_fips_all: '55075|55083',
    county: 'Marinette',
    county_names_all: 'Marinette|Oconto',
    county_weights: '{"55075": 98.09, "55083": 1.91}',
    density: 25.6,
    imprecise: false,
    latitude: 45.05001,
    longitude: -87.81217,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54157',
  },
  {
    city: 'Porterfield',
    county_fips: 55075,
    county_fips_all: '55075',
    county: 'Marinette',
    county_names_all: 'Marinette',
    county_weights: '{"55075": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 45.20027,
    longitude: -87.82682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54159',
  },
  {
    city: 'Potter',
    county_fips: 55015,
    county_fips_all: '55015',
    county: 'Calumet',
    county_names_all: 'Calumet',
    county_weights: '{"55015": 100}',
    density: 168.8,
    imprecise: false,
    latitude: 44.12029,
    longitude: -88.09895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54160',
  },
  {
    city: 'Pound',
    county_fips: 55083,
    county_fips_all: '55083|55075',
    county: 'Oconto',
    county_names_all: 'Oconto|Marinette',
    county_weights: '{"55083": 52.34, "55075": 47.66}',
    density: 8,
    imprecise: false,
    latitude: 45.12449,
    longitude: -88.15696,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54161',
  },
  {
    city: 'Pulaski',
    county_fips: 55115,
    county_fips_all: '55115|55009|55083',
    county: 'Shawano',
    county_names_all: 'Shawano|Brown|Oconto',
    county_weights: '{"55115": 61.17, "55009": 22.49, "55083": 16.34}',
    density: 33.2,
    imprecise: false,
    latitude: 44.66417,
    longitude: -88.27689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54162',
  },
  {
    city: 'Seymour',
    county_fips: 55087,
    county_fips_all: '55087|55115|55009',
    county: 'Outagamie',
    county_names_all: 'Outagamie|Shawano|Brown',
    county_weights: '{"55087": 87.73, "55115": 11.15, "55009": 1.12}',
    density: 30.1,
    imprecise: false,
    latitude: 44.52063,
    longitude: -88.31683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54165',
  },
  {
    city: 'Shawano',
    county_fips: 55115,
    county_fips_all: '55115',
    county: 'Shawano',
    county_names_all: 'Shawano',
    county_weights: '{"55115": 100}',
    density: 44.8,
    imprecise: false,
    latitude: 44.77894,
    longitude: -88.63567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54166',
  },
  {
    city: 'Sherwood',
    county_fips: 55015,
    county_fips_all: '55015',
    county: 'Calumet',
    county_names_all: 'Calumet',
    county_weights: '{"55015": 100}',
    density: 336.9,
    imprecise: false,
    latitude: 44.17799,
    longitude: -88.2772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54169',
  },
  {
    city: 'Shiocton',
    county_fips: 55087,
    county_fips_all: '55087|55115|55135',
    county: 'Outagamie',
    county_names_all: 'Outagamie|Shawano|Waupaca',
    county_weights: '{"55087": 74.99, "55115": 21.91, "55135": 3.1}',
    density: 12.4,
    imprecise: false,
    latitude: 44.51783,
    longitude: -88.57241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54170',
  },
  {
    city: 'Sobieski',
    county_fips: 55083,
    county_fips_all: '55083',
    county: 'Oconto',
    county_names_all: 'Oconto',
    county_weights: '{"55083": 100}',
    density: 62.3,
    imprecise: false,
    latitude: 44.71957,
    longitude: -88.12017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54171',
  },
  {
    city: 'Suamico',
    county_fips: 55009,
    county_fips_all: '55009',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"55009": 100}',
    density: 92.2,
    imprecise: false,
    latitude: 44.64228,
    longitude: -88.03212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54173',
  },
  {
    city: 'Suring',
    county_fips: 55083,
    county_fips_all: '55083|55078',
    county: 'Oconto',
    county_names_all: 'Oconto|Menominee',
    county_weights: '{"55083": 64.0, "55078": 36.0}',
    density: 6,
    imprecise: false,
    latitude: 45.03553,
    longitude: -88.43492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54174',
  },
  {
    city: 'Townsend',
    county_fips: 55083,
    county_fips_all: '55083|55067',
    county: 'Oconto',
    county_names_all: 'Oconto|Langlade',
    county_weights: '{"55083": 98.96, "55067": 1.04}',
    density: 7.8,
    imprecise: false,
    latitude: 45.30552,
    longitude: -88.62394,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54175',
  },
  {
    city: 'Wausaukee',
    county_fips: 55075,
    county_fips_all: '55075',
    county: 'Marinette',
    county_names_all: 'Marinette',
    county_weights: '{"55075": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 45.36428,
    longitude: -87.89183,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54177',
  },
  {
    city: 'Wrightstown',
    county_fips: 55009,
    county_fips_all: '55009|55087',
    county: 'Brown',
    county_names_all: 'Brown|Outagamie',
    county_weights: '{"55009": 85.77, "55087": 14.23}',
    density: 220.5,
    imprecise: false,
    latitude: 44.33139,
    longitude: -88.17462,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54180',
  },
  {
    city: 'Algoma',
    county_fips: 55061,
    county_fips_all: '55061|55029',
    county: 'Kewaunee',
    county_names_all: 'Kewaunee|Door',
    county_weights: '{"55061": 91.62, "55029": 8.38}',
    density: 26.6,
    imprecise: false,
    latitude: 44.61987,
    longitude: -87.49399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54201',
  },
  {
    city: 'Baileys Harbor',
    county_fips: 55029,
    county_fips_all: '55029',
    county: 'Door',
    county_names_all: 'Door',
    county_weights: '{"55029": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 45.0779,
    longitude: -87.13837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54202',
  },
  {
    city: 'Brussels',
    county_fips: 55029,
    county_fips_all: '55029',
    county: 'Door',
    county_names_all: 'Door',
    county_weights: '{"55029": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 44.76189,
    longitude: -87.61552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54204',
  },
  {
    city: 'Casco',
    county_fips: 55061,
    county_fips_all: '55061|55029',
    county: 'Kewaunee',
    county_names_all: 'Kewaunee|Door',
    county_weights: '{"55061": 97.81, "55029": 2.19}',
    density: 19.5,
    imprecise: false,
    latitude: 44.60444,
    longitude: -87.62912,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54205',
  },
  {
    city: 'Collins',
    county_fips: 55071,
    county_fips_all: '55071',
    county: 'Manitowoc',
    county_names_all: 'Manitowoc',
    county_weights: '{"55071": 100}',
    density: 60.9,
    imprecise: false,
    latitude: 44.08425,
    longitude: -87.98093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54207',
  },
  {
    city: 'Denmark',
    county_fips: 55009,
    county_fips_all: '55009|55061|55071',
    county: 'Brown',
    county_names_all: 'Brown|Kewaunee|Manitowoc',
    county_weights: '{"55009": 58.68, "55061": 29.58, "55071": 11.74}',
    density: 24.2,
    imprecise: false,
    latitude: 44.36239,
    longitude: -87.79619,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54208',
  },
  {
    city: 'Egg Harbor',
    county_fips: 55029,
    county_fips_all: '55029',
    county: 'Door',
    county_names_all: 'Door',
    county_weights: '{"55029": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 45.01126,
    longitude: -87.27278,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54209',
  },
  {
    city: 'Ellison Bay',
    county_fips: 55029,
    county_fips_all: '55029',
    county: 'Door',
    county_names_all: 'Door',
    county_weights: '{"55029": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 45.2535,
    longitude: -87.0352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54210',
  },
  {
    city: 'Ephraim',
    county_fips: 55029,
    county_fips_all: '55029',
    county: 'Door',
    county_names_all: 'Door',
    county_weights: '{"55029": 100}',
    density: 43.8,
    imprecise: false,
    latitude: 45.15942,
    longitude: -87.16783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54211',
  },
  {
    city: 'Fish Creek',
    county_fips: 55029,
    county_fips_all: '55029',
    county: 'Door',
    county_names_all: 'Door',
    county_weights: '{"55029": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 45.12169,
    longitude: -87.23024,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54212',
  },
  {
    city: 'Forestville',
    county_fips: 55029,
    county_fips_all: '55029|55061',
    county: 'Door',
    county_names_all: 'Door|Kewaunee',
    county_weights: '{"55029": 89.89, "55061": 10.11}',
    density: 14,
    imprecise: false,
    latitude: 44.69926,
    longitude: -87.52114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54213',
  },
  {
    city: 'Francis Creek',
    county_fips: 55071,
    county_fips_all: '55071',
    county: 'Manitowoc',
    county_names_all: 'Manitowoc',
    county_weights: '{"55071": 100}',
    density: 352.5,
    imprecise: false,
    latitude: 44.19893,
    longitude: -87.71441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54214',
  },
  {
    city: 'Kellnersville',
    county_fips: 55071,
    county_fips_all: '55071',
    county: 'Manitowoc',
    county_names_all: 'Manitowoc',
    county_weights: '{"55071": 100}',
    density: 180.2,
    imprecise: false,
    latitude: 44.22608,
    longitude: -87.80357,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54215',
  },
  {
    city: 'Kewaunee',
    county_fips: 55061,
    county_fips_all: '55061',
    county: 'Kewaunee',
    county_names_all: 'Kewaunee',
    county_weights: '{"55061": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 44.43651,
    longitude: -87.58069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54216',
  },
  {
    city: 'Luxemburg',
    county_fips: 55061,
    county_fips_all: '55061|55009|55029',
    county: 'Kewaunee',
    county_names_all: 'Kewaunee|Brown|Door',
    county_weights: '{"55061": 80.25, "55009": 11.81, "55029": 7.94}',
    density: 27.6,
    imprecise: false,
    latitude: 44.54694,
    longitude: -87.71748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54217',
  },
  {
    city: 'Manitowoc',
    county_fips: 55071,
    county_fips_all: '55071',
    county: 'Manitowoc',
    county_names_all: 'Manitowoc',
    county_weights: '{"55071": 100}',
    density: 160.1,
    imprecise: false,
    latitude: 44.09644,
    longitude: -87.73131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54220',
  },
  {
    city: 'Maribel',
    county_fips: 55071,
    county_fips_all: '55071',
    county: 'Manitowoc',
    county_names_all: 'Manitowoc',
    county_weights: '{"55071": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 44.28096,
    longitude: -87.80656,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54227',
  },
  {
    city: 'Mishicot',
    county_fips: 55071,
    county_fips_all: '55071',
    county: 'Manitowoc',
    county_names_all: 'Manitowoc',
    county_weights: '{"55071": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 44.27677,
    longitude: -87.64875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54228',
  },
  {
    city: 'New Franken',
    county_fips: 55009,
    county_fips_all: '55009',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"55009": 100}',
    density: 43.3,
    imprecise: false,
    latitude: 44.56411,
    longitude: -87.82081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54229',
  },
  {
    city: 'Reedsville',
    county_fips: 55071,
    county_fips_all: '55071',
    county: 'Manitowoc',
    county_names_all: 'Manitowoc',
    county_weights: '{"55071": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 44.15749,
    longitude: -87.91202,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54230',
  },
  {
    city: 'Saint Nazianz',
    county_fips: 55071,
    county_fips_all: '55071',
    county: 'Manitowoc',
    county_names_all: 'Manitowoc',
    county_weights: '{"55071": 100}',
    density: 441.3,
    imprecise: false,
    latitude: 44.00668,
    longitude: -87.92462,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54232',
  },
  {
    city: 'Sister Bay',
    county_fips: 55029,
    county_fips_all: '55029',
    county: 'Door',
    county_names_all: 'Door',
    county_weights: '{"55029": 100}',
    density: 35.5,
    imprecise: false,
    latitude: 45.18377,
    longitude: -87.09239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54234',
  },
  {
    city: 'Sturgeon Bay',
    county_fips: 55029,
    county_fips_all: '55029',
    county: 'Door',
    county_names_all: 'Door',
    county_weights: '{"55029": 100}',
    density: 36,
    imprecise: false,
    latitude: 44.84218,
    longitude: -87.37677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54235',
  },
  {
    city: 'Two Rivers',
    county_fips: 55071,
    county_fips_all: '55071',
    county: 'Manitowoc',
    county_names_all: 'Manitowoc',
    county_weights: '{"55071": 100}',
    density: 80.9,
    imprecise: false,
    latitude: 44.21758,
    longitude: -87.59723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54241',
  },
  {
    city: 'Valders',
    county_fips: 55071,
    county_fips_all: '55071',
    county: 'Manitowoc',
    county_names_all: 'Manitowoc',
    county_weights: '{"55071": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 44.02728,
    longitude: -87.8977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54245',
  },
  {
    city: 'Washington Island',
    county_fips: 55029,
    county_fips_all: '55029',
    county: 'Door',
    county_names_all: 'Door',
    county_weights: '{"55029": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 45.37538,
    longitude: -86.89721,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54246',
  },
  {
    city: 'Whitelaw',
    county_fips: 55071,
    county_fips_all: '55071',
    county: 'Manitowoc',
    county_names_all: 'Manitowoc',
    county_weights: '{"55071": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 44.19686,
    longitude: -87.78564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54247',
  },
  {
    city: 'Green Bay',
    county_fips: 55009,
    county_fips_all: '55009',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"55009": 100}',
    density: 1290.9,
    imprecise: false,
    latitude: 44.48193,
    longitude: -88.02029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54301',
  },
  {
    city: 'Green Bay',
    county_fips: 55009,
    county_fips_all: '55009',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"55009": 100}',
    density: 1269.5,
    imprecise: false,
    latitude: 44.50663,
    longitude: -87.97668,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54302',
  },
  {
    city: 'Green Bay',
    county_fips: 55009,
    county_fips_all: '55009',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"55009": 100}',
    density: 945.8,
    imprecise: false,
    latitude: 44.53931,
    longitude: -88.05115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54303',
  },
  {
    city: 'Green Bay',
    county_fips: 55009,
    county_fips_all: '55009',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"55009": 100}',
    density: 943.6,
    imprecise: false,
    latitude: 44.49419,
    longitude: -88.06758,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54304',
  },
  {
    city: 'Green Bay',
    county_fips: 55009,
    county_fips_all: '55009',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"55009": 100}',
    density: 5207.6,
    imprecise: false,
    latitude: 44.47049,
    longitude: -88.0366,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54307',
  },
  {
    city: 'Green Bay',
    county_fips: 55009,
    county_fips_all: '55009',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"55009": 100}',
    density: 214.4,
    imprecise: false,
    latitude: 44.48377,
    longitude: -87.89483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54311',
  },
  {
    city: 'Green Bay',
    county_fips: 55009,
    county_fips_all: '55009|55087',
    county: 'Brown',
    county_names_all: 'Brown|Outagamie',
    county_weights: '{"55009": 98.76, "55087": 1.24}',
    density: 283.2,
    imprecise: false,
    latitude: 44.58923,
    longitude: -88.11088,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54313',
  },
  {
    city: 'Wausau',
    county_fips: 55073,
    county_fips_all: '55073',
    county: 'Marathon',
    county_names_all: 'Marathon',
    county_weights: '{"55073": 100}',
    density: 145.4,
    imprecise: false,
    latitude: 44.96647,
    longitude: -89.70794,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54401',
  },
  {
    city: 'Wausau',
    county_fips: 55073,
    county_fips_all: '55073',
    county: 'Marathon',
    county_names_all: 'Marathon',
    county_weights: '{"55073": 100}',
    density: 72.1,
    imprecise: false,
    latitude: 45.03142,
    longitude: -89.51343,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54403',
  },
  {
    city: 'Abbotsford',
    county_fips: 55073,
    county_fips_all: '55073|55019',
    county: 'Marathon',
    county_names_all: 'Marathon|Clark',
    county_weights: '{"55073": 75.3, "55019": 24.7}',
    density: 35.9,
    imprecise: false,
    latitude: 44.96289,
    longitude: -90.2797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54405',
  },
  {
    city: 'Amherst',
    county_fips: 55097,
    county_fips_all: '55097',
    county: 'Portage',
    county_names_all: 'Portage',
    county_weights: '{"55097": 100}',
    density: 23.5,
    imprecise: false,
    latitude: 44.41122,
    longitude: -89.31211,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54406',
  },
  {
    city: 'Amherst Junction',
    county_fips: 55097,
    county_fips_all: '55097',
    county: 'Portage',
    county_names_all: 'Portage',
    county_weights: '{"55097": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 44.52712,
    longitude: -89.29418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54407',
  },
  {
    city: 'Aniwa',
    county_fips: 55073,
    county_fips_all: '55073|55115|55067',
    county: 'Marathon',
    county_names_all: 'Marathon|Shawano|Langlade',
    county_weights: '{"55073": 86.71, "55115": 9.06, "55067": 4.23}',
    density: 9.7,
    imprecise: false,
    latitude: 45.02861,
    longitude: -89.30922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54408',
  },
  {
    city: 'Antigo',
    county_fips: 55067,
    county_fips_all: '55067|55073|55115',
    county: 'Langlade',
    county_names_all: 'Langlade|Marathon|Shawano',
    county_weights: '{"55067": 87.82, "55073": 8.42, "55115": 3.76}',
    density: 23.6,
    imprecise: false,
    latitude: 45.11928,
    longitude: -89.16909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54409',
  },
  {
    city: 'Arpin',
    county_fips: 55141,
    county_fips_all: '55141',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"55141": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 44.54158,
    longitude: -90.02877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54410',
  },
  {
    city: 'Athens',
    county_fips: 55073,
    county_fips_all: '55073|55119',
    county: 'Marathon',
    county_names_all: 'Marathon|Taylor',
    county_weights: '{"55073": 94.25, "55119": 5.75}',
    density: 10.2,
    imprecise: false,
    latitude: 45.05023,
    longitude: -90.02837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54411',
  },
  {
    city: 'Auburndale',
    county_fips: 55141,
    county_fips_all: '55141|55073',
    county: 'Wood',
    county_names_all: 'Wood|Marathon',
    county_weights: '{"55141": 62.82, "55073": 37.18}',
    density: 11.5,
    imprecise: false,
    latitude: 44.66859,
    longitude: -89.98238,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54412',
  },
  {
    city: 'Babcock',
    county_fips: 55141,
    county_fips_all: '55141',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"55141": 100}',
    density: 2,
    imprecise: false,
    latitude: 44.28363,
    longitude: -90.15185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54413',
  },
  {
    city: 'Birnamwood',
    county_fips: 55115,
    county_fips_all: '55115|55073|55067',
    county: 'Shawano',
    county_names_all: 'Shawano|Marathon|Langlade',
    county_weights: '{"55115": 60.84, "55073": 38.75, "55067": 0.41}',
    density: 9.4,
    imprecise: false,
    latitude: 44.95589,
    longitude: -89.18202,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54414',
  },
  {
    city: 'Bowler',
    county_fips: 55115,
    county_fips_all: '55115',
    county: 'Shawano',
    county_names_all: 'Shawano',
    county_weights: '{"55115": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 44.8822,
    longitude: -88.94153,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54416',
  },
  {
    city: 'Brokaw',
    county_fips: 55073,
    county_fips_all: '55073',
    county: 'Marathon',
    county_names_all: 'Marathon',
    county_weights: '{"55073": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 45.02749,
    longitude: -89.65418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54417',
  },
  {
    city: 'Bryant',
    county_fips: 55067,
    county_fips_all: '55067',
    county: 'Langlade',
    county_names_all: 'Langlade',
    county_weights: '{"55067": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 45.21566,
    longitude: -88.98003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54418',
  },
  {
    city: 'Chili',
    county_fips: 55019,
    county_fips_all: '55019|55141',
    county: 'Clark',
    county_names_all: 'Clark|Wood',
    county_weights: '{"55019": 91.21, "55141": 8.79}',
    density: 12.7,
    imprecise: false,
    latitude: 44.61043,
    longitude: -90.35036,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54420',
  },
  {
    city: 'Colby',
    county_fips: 55073,
    county_fips_all: '55073|55019',
    county: 'Marathon',
    county_names_all: 'Marathon|Clark',
    county_weights: '{"55073": 55.15, "55019": 44.85}',
    density: 19.2,
    imprecise: false,
    latitude: 44.89866,
    longitude: -90.29532,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54421',
  },
  {
    city: 'Curtiss',
    county_fips: 55019,
    county_fips_all: '55019|55119',
    county: 'Clark',
    county_names_all: 'Clark|Taylor',
    county_weights: '{"55019": 77.18, "55119": 22.82}',
    density: 14.7,
    imprecise: false,
    latitude: 44.98279,
    longitude: -90.45264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54422',
  },
  {
    city: 'Custer',
    county_fips: 55097,
    county_fips_all: '55097',
    county: 'Portage',
    county_names_all: 'Portage',
    county_weights: '{"55097": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 44.58049,
    longitude: -89.41642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54423',
  },
  {
    city: 'Deerbrook',
    county_fips: 55067,
    county_fips_all: '55067',
    county: 'Langlade',
    county_names_all: 'Langlade',
    county_weights: '{"55067": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 45.28471,
    longitude: -89.18701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54424',
  },
  {
    city: 'Dorchester',
    county_fips: 55019,
    county_fips_all: '55019|55073|55119',
    county: 'Clark',
    county_names_all: 'Clark|Marathon|Taylor',
    county_weights: '{"55019": 57.6, "55073": 31.26, "55119": 11.14}',
    density: 18.5,
    imprecise: false,
    latitude: 45.0086,
    longitude: -90.34249,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54425',
  },
  {
    city: 'Edgar',
    county_fips: 55073,
    county_fips_all: '55073',
    county: 'Marathon',
    county_names_all: 'Marathon',
    county_weights: '{"55073": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 44.90804,
    longitude: -89.98832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54426',
  },
  {
    city: 'Eland',
    county_fips: 55073,
    county_fips_all: '55073|55115',
    county: 'Marathon',
    county_names_all: 'Marathon|Shawano',
    county_weights: '{"55073": 76.02, "55115": 23.98}',
    density: 10,
    imprecise: false,
    latitude: 44.82401,
    longitude: -89.25789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54427',
  },
  {
    city: 'Elcho',
    county_fips: 55067,
    county_fips_all: '55067|55085',
    county: 'Langlade',
    county_names_all: 'Langlade|Oneida',
    county_weights: '{"55067": 95.72, "55085": 4.28}',
    density: 5.4,
    imprecise: false,
    latitude: 45.43511,
    longitude: -89.17282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54428',
  },
  {
    city: 'Elton',
    county_fips: 55067,
    county_fips_all: '55067|55078',
    county: 'Langlade',
    county_names_all: 'Langlade|Menominee',
    county_weights: '{"55067": 99.74, "55078": 0.26}',
    density: 3.5,
    imprecise: false,
    latitude: 45.1395,
    longitude: -88.8872,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54430',
  },
  {
    city: 'Gilman',
    county_fips: 55119,
    county_fips_all: '55119|55017',
    county: 'Taylor',
    county_names_all: 'Taylor|Chippewa',
    county_weights: '{"55119": 88.93, "55017": 11.07}',
    density: 4.5,
    imprecise: false,
    latitude: 45.20649,
    longitude: -90.81756,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54433',
  },
  {
    city: 'Gleason',
    county_fips: 55069,
    county_fips_all: '55069|55067',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Langlade',
    county_weights: '{"55069": 58.77, "55067": 41.23}',
    density: 4.1,
    imprecise: false,
    latitude: 45.35084,
    longitude: -89.44349,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54435',
  },
  {
    city: 'Granton',
    county_fips: 55019,
    county_fips_all: '55019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"55019": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 44.54149,
    longitude: -90.43101,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54436',
  },
  {
    city: 'Greenwood',
    county_fips: 55019,
    county_fips_all: '55019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"55019": 100}',
    density: 10,
    imprecise: false,
    latitude: 44.77867,
    longitude: -90.63866,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54437',
  },
  {
    city: 'Hatley',
    county_fips: 55073,
    county_fips_all: '55073',
    county: 'Marathon',
    county_names_all: 'Marathon',
    county_weights: '{"55073": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 44.80621,
    longitude: -89.38838,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54440',
  },
  {
    city: 'Hewitt',
    county_fips: 55141,
    county_fips_all: '55141',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"55141": 100}',
    density: 298.1,
    imprecise: false,
    latitude: 44.64202,
    longitude: -90.10604,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54441',
  },
  {
    city: 'Irma',
    county_fips: 55069,
    county_fips_all: '55069',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"55069": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 45.36532,
    longitude: -89.65439,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54442',
  },
  {
    city: 'Junction City',
    county_fips: 55097,
    county_fips_all: '55097|55141|55073',
    county: 'Portage',
    county_names_all: 'Portage|Wood|Marathon',
    county_weights: '{"55097": 99.1, "55141": 0.8, "55073": 0.1}',
    density: 9.3,
    imprecise: false,
    latitude: 44.61243,
    longitude: -89.75264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54443',
  },
  {
    city: 'Loyal',
    county_fips: 55019,
    county_fips_all: '55019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"55019": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 44.7533,
    longitude: -90.47149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54446',
  },
  {
    city: 'Lublin',
    county_fips: 55119,
    county_fips_all: '55119',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"55119": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 45.09061,
    longitude: -90.72911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54447',
  },
  {
    city: 'Marathon',
    county_fips: 55073,
    county_fips_all: '55073',
    county: 'Marathon',
    county_names_all: 'Marathon',
    county_weights: '{"55073": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 44.93094,
    longitude: -89.83422,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54448',
  },
  {
    city: 'Marshfield',
    county_fips: 55141,
    county_fips_all: '55141|55073|55019',
    county: 'Wood',
    county_names_all: 'Wood|Marathon|Clark',
    county_weights: '{"55141": 71.2, "55073": 28.59, "55019": 0.21}',
    density: 58.6,
    imprecise: false,
    latitude: 44.63914,
    longitude: -90.19755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54449',
  },
  {
    city: 'Mattoon',
    county_fips: 55115,
    county_fips_all: '55115',
    county: 'Shawano',
    county_names_all: 'Shawano',
    county_weights: '{"55115": 100}',
    density: 121.1,
    imprecise: false,
    latitude: 45.00367,
    longitude: -89.04172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54450',
  },
  {
    city: 'Medford',
    county_fips: 55119,
    county_fips_all: '55119|55073',
    county: 'Taylor',
    county_names_all: 'Taylor|Marathon',
    county_weights: '{"55119": 98.3, "55073": 1.7}',
    density: 12.9,
    imprecise: false,
    latitude: 45.19131,
    longitude: -90.40172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54451',
  },
  {
    city: 'Merrill',
    county_fips: 55069,
    county_fips_all: '55069|55073',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Marathon',
    county_weights: '{"55069": 89.44, "55073": 10.56}',
    density: 16.7,
    imprecise: false,
    latitude: 45.20879,
    longitude: -89.76743,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54452',
  },
  {
    city: 'Milladore',
    county_fips: 55141,
    county_fips_all: '55141|55097',
    county: 'Wood',
    county_names_all: 'Wood|Portage',
    county_weights: '{"55141": 94.96, "55097": 5.04}',
    density: 10.4,
    imprecise: false,
    latitude: 44.60259,
    longitude: -89.8846,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54454',
  },
  {
    city: 'Mosinee',
    county_fips: 55073,
    county_fips_all: '55073|55097',
    county: 'Marathon',
    county_names_all: 'Marathon|Portage',
    county_weights: '{"55073": 92.64, "55097": 7.36}',
    density: 31.2,
    imprecise: false,
    latitude: 44.7625,
    longitude: -89.68559,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54455',
  },
  {
    city: 'Neillsville',
    county_fips: 55019,
    county_fips_all: '55019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"55019": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 44.54511,
    longitude: -90.63824,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54456',
  },
  {
    city: 'Nekoosa',
    county_fips: 55001,
    county_fips_all: '55001|55141|55057',
    county: 'Adams',
    county_names_all: 'Adams|Wood|Juneau',
    county_weights: '{"55001": 42.83, "55141": 32.36, "55057": 24.82}',
    density: 22.6,
    imprecise: false,
    latitude: 44.22965,
    longitude: -89.89502,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54457',
  },
  {
    city: 'Nelsonville',
    county_fips: 55097,
    county_fips_all: '55097',
    county: 'Portage',
    county_names_all: 'Portage',
    county_weights: '{"55097": 100}',
    density: 115.5,
    imprecise: false,
    latitude: 44.49867,
    longitude: -89.31027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54458',
  },
  {
    city: 'Ogema',
    county_fips: 55099,
    county_fips_all: '55099|55069',
    county: 'Price',
    county_names_all: 'Price|Lincoln',
    county_weights: '{"55099": 98.59, "55069": 1.41}',
    density: 4,
    imprecise: false,
    latitude: 45.42515,
    longitude: -90.26924,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54459',
  },
  {
    city: 'Owen',
    county_fips: 55019,
    county_fips_all: '55019|55119',
    county: 'Clark',
    county_names_all: 'Clark|Taylor',
    county_weights: '{"55019": 81.79, "55119": 18.21}',
    density: 12.1,
    imprecise: false,
    latitude: 44.94703,
    longitude: -90.53728,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54460',
  },
  {
    city: 'Pearson',
    county_fips: 55067,
    county_fips_all: '55067',
    county: 'Langlade',
    county_names_all: 'Langlade',
    county_weights: '{"55067": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 45.39408,
    longitude: -89.00031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54462',
  },
  {
    city: 'Pelican Lake',
    county_fips: 55085,
    county_fips_all: '55085|55067',
    county: 'Oneida',
    county_names_all: 'Oneida|Langlade',
    county_weights: '{"55085": 98.12, "55067": 1.88}',
    density: 3.2,
    imprecise: false,
    latitude: 45.50876,
    longitude: -89.22536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54463',
  },
  {
    city: 'Phlox',
    county_fips: 55067,
    county_fips_all: '55067',
    county: 'Langlade',
    county_names_all: 'Langlade',
    county_weights: '{"55067": 100}',
    density: 148.5,
    imprecise: false,
    latitude: 45.05486,
    longitude: -89.01748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54464',
  },
  {
    city: 'Pickerel',
    county_fips: 55041,
    county_fips_all: '55041|55067',
    county: 'Forest',
    county_names_all: 'Forest|Langlade',
    county_weights: '{"55041": 63.71, "55067": 36.29}',
    density: 7.5,
    imprecise: false,
    latitude: 45.39327,
    longitude: -88.88334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54465',
  },
  {
    city: 'Pittsville',
    county_fips: 55141,
    county_fips_all: '55141|55053|55019',
    county: 'Wood',
    county_names_all: 'Wood|Jackson|Clark',
    county_weights: '{"55141": 53.42, "55053": 42.18, "55019": 4.4}',
    density: 3.2,
    imprecise: false,
    latitude: 44.3855,
    longitude: -90.31687,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54466',
  },
  {
    city: 'Plover',
    county_fips: 55097,
    county_fips_all: '55097',
    county: 'Portage',
    county_names_all: 'Portage',
    county_weights: '{"55097": 100}',
    density: 86.4,
    imprecise: false,
    latitude: 44.41575,
    longitude: -89.54062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54467',
  },
  {
    city: 'Port Edwards',
    county_fips: 55141,
    county_fips_all: '55141',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"55141": 100}',
    density: 267.8,
    imprecise: false,
    latitude: 44.34642,
    longitude: -89.87028,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54469',
  },
  {
    city: 'Rib Lake',
    county_fips: 55119,
    county_fips_all: '55119|55099',
    county: 'Taylor',
    county_names_all: 'Taylor|Price',
    county_weights: '{"55119": 97.64, "55099": 2.36}',
    density: 7.1,
    imprecise: false,
    latitude: 45.29419,
    longitude: -90.13852,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54470',
  },
  {
    city: 'Ringle',
    county_fips: 55073,
    county_fips_all: '55073',
    county: 'Marathon',
    county_names_all: 'Marathon',
    county_weights: '{"55073": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 44.93361,
    longitude: -89.41914,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54471',
  },
  {
    city: 'Rosholt',
    county_fips: 55097,
    county_fips_all: '55097|55073',
    county: 'Portage',
    county_names_all: 'Portage|Marathon',
    county_weights: '{"55097": 76.11, "55073": 23.89}',
    density: 11.3,
    imprecise: false,
    latitude: 44.64984,
    longitude: -89.35634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54473',
  },
  {
    city: 'Rothschild',
    county_fips: 55073,
    county_fips_all: '55073',
    county: 'Marathon',
    county_names_all: 'Marathon',
    county_weights: '{"55073": 100}',
    density: 353.2,
    imprecise: false,
    latitude: 44.87395,
    longitude: -89.62223,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54474',
  },
  {
    city: 'Rudolph',
    county_fips: 55141,
    county_fips_all: '55141|55097',
    county: 'Wood',
    county_names_all: 'Wood|Portage',
    county_weights: '{"55141": 82.39, "55097": 17.61}',
    density: 15,
    imprecise: false,
    latitude: 44.48204,
    longitude: -89.78825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54475',
  },
  {
    city: 'Schofield',
    county_fips: 55073,
    county_fips_all: '55073',
    county: 'Marathon',
    county_names_all: 'Marathon',
    county_weights: '{"55073": 100}',
    density: 178.1,
    imprecise: false,
    latitude: 44.88816,
    longitude: -89.52389,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54476',
  },
  {
    city: 'Spencer',
    county_fips: 55019,
    county_fips_all: '55019|55073',
    county: 'Clark',
    county_names_all: 'Clark|Marathon',
    county_weights: '{"55019": 56.25, "55073": 43.75}',
    density: 18.3,
    imprecise: false,
    latitude: 44.75688,
    longitude: -90.32525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54479',
  },
  {
    city: 'Stetsonville',
    county_fips: 55119,
    county_fips_all: '55119|55073',
    county: 'Taylor',
    county_names_all: 'Taylor|Marathon',
    county_weights: '{"55119": 92.18, "55073": 7.82}',
    density: 15.1,
    imprecise: false,
    latitude: 45.05908,
    longitude: -90.27597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54480',
  },
  {
    city: 'Stevens Point',
    county_fips: 55097,
    county_fips_all: '55097',
    county: 'Portage',
    county_names_all: 'Portage',
    county_weights: '{"55097": 100}',
    density: 166.3,
    imprecise: false,
    latitude: 44.51935,
    longitude: -89.63678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54481',
  },
  {
    city: 'Stevens Point',
    county_fips: 55097,
    county_fips_all: '55097',
    county: 'Portage',
    county_names_all: 'Portage',
    county_weights: '{"55097": 100}',
    density: 38,
    imprecise: false,
    latitude: 44.55174,
    longitude: -89.5092,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54482',
  },
  {
    city: 'Stratford',
    county_fips: 55073,
    county_fips_all: '55073',
    county: 'Marathon',
    county_names_all: 'Marathon',
    county_weights: '{"55073": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 44.79988,
    longitude: -90.07962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54484',
  },
  {
    city: 'Summit Lake',
    county_fips: 55067,
    county_fips_all: '55067',
    county: 'Langlade',
    county_names_all: 'Langlade',
    county_weights: '{"55067": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 45.39373,
    longitude: -89.21894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54485',
  },
  {
    city: 'Tigerton',
    county_fips: 55115,
    county_fips_all: '55115|55135',
    county: 'Shawano',
    county_names_all: 'Shawano|Waupaca',
    county_weights: '{"55115": 81.22, "55135": 18.78}',
    density: 6.8,
    imprecise: false,
    latitude: 44.72595,
    longitude: -89.05124,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54486',
  },
  {
    city: 'Tomahawk',
    county_fips: 55069,
    county_fips_all: '55069|55085',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Oneida',
    county_weights: '{"55069": 73.84, "55085": 26.16}',
    density: 12.7,
    imprecise: false,
    latitude: 45.50429,
    longitude: -89.75114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54487',
  },
  {
    city: 'Unity',
    county_fips: 55019,
    county_fips_all: '55019|55073',
    county: 'Clark',
    county_names_all: 'Clark|Marathon',
    county_weights: '{"55019": 53.65, "55073": 46.35}',
    density: 12.7,
    imprecise: false,
    latitude: 44.84335,
    longitude: -90.33778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54488',
  },
  {
    city: 'Vesper',
    county_fips: 55141,
    county_fips_all: '55141',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"55141": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 44.45445,
    longitude: -90.0075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54489',
  },
  {
    city: 'Westboro',
    county_fips: 55119,
    county_fips_all: '55119|55099',
    county: 'Taylor',
    county_names_all: 'Taylor|Price',
    county_weights: '{"55119": 99.49, "55099": 0.51}',
    density: 3.3,
    imprecise: false,
    latitude: 45.33622,
    longitude: -90.41102,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54490',
  },
  {
    city: 'White Lake',
    county_fips: 55067,
    county_fips_all: '55067|55083',
    county: 'Langlade',
    county_names_all: 'Langlade|Oconto',
    county_weights: '{"55067": 90.95, "55083": 9.05}',
    density: 3.1,
    imprecise: false,
    latitude: 45.2343,
    longitude: -88.76541,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54491',
  },
  {
    city: 'Willard',
    county_fips: 55019,
    county_fips_all: '55019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"55019": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 44.70083,
    longitude: -90.80107,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54493',
  },
  {
    city: 'Wisconsin Rapids',
    county_fips: 55141,
    county_fips_all: '55141|55097|55001',
    county: 'Wood',
    county_names_all: 'Wood|Portage|Adams',
    county_weights: '{"55141": 57.12, "55097": 39.77, "55001": 3.11}',
    density: 85.4,
    imprecise: false,
    latitude: 44.34414,
    longitude: -89.74054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54494',
  },
  {
    city: 'Wisconsin Rapids',
    county_fips: 55141,
    county_fips_all: '55141',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"55141": 100}',
    density: 29.2,
    imprecise: false,
    latitude: 44.39081,
    longitude: -89.95351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54495',
  },
  {
    city: 'Withee',
    county_fips: 55019,
    county_fips_all: '55019|55119',
    county: 'Clark',
    county_names_all: 'Clark|Taylor',
    county_weights: '{"55019": 50.7, "55119": 49.3}',
    density: 8.2,
    imprecise: false,
    latitude: 45.03278,
    longitude: -90.62105,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54498',
  },
  {
    city: 'Wittenberg',
    county_fips: 55115,
    county_fips_all: '55115|55073|55097',
    county: 'Shawano',
    county_names_all: 'Shawano|Marathon|Portage',
    county_weights: '{"55115": 68.59, "55073": 29.9, "55097": 1.51}',
    density: 10,
    imprecise: false,
    latitude: 44.78963,
    longitude: -89.1801,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54499',
  },
  {
    city: 'Rhinelander',
    county_fips: 55085,
    county_fips_all: '55085|55069',
    county: 'Oneida',
    county_names_all: 'Oneida|Lincoln',
    county_weights: '{"55085": 98.0, "55069": 2.0}',
    density: 22.6,
    imprecise: false,
    latitude: 45.65973,
    longitude: -89.34303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54501',
  },
  {
    city: 'Argonne',
    county_fips: 55041,
    county_fips_all: '55041',
    county: 'Forest',
    county_names_all: 'Forest',
    county_weights: '{"55041": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 45.72365,
    longitude: -88.83177,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54511',
  },
  {
    city: 'Boulder Junction',
    county_fips: 55125,
    county_fips_all: '55125',
    county: 'Vilas',
    county_names_all: 'Vilas',
    county_weights: '{"55125": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 46.0957,
    longitude: -89.66748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54512',
  },
  {
    city: 'Brantwood',
    county_fips: 55099,
    county_fips_all: '55099',
    county: 'Price',
    county_names_all: 'Price',
    county_weights: '{"55099": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 45.58246,
    longitude: -90.11986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54513',
  },
  {
    city: 'Butternut',
    county_fips: 55003,
    county_fips_all: '55003|55099|55051',
    county: 'Ashland',
    county_names_all: 'Ashland|Price|Iron',
    county_weights: '{"55003": 80.49, "55099": 13.05, "55051": 6.46}',
    density: 3.1,
    imprecise: false,
    latitude: 46.03761,
    longitude: -90.49378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54514',
  },
  {
    city: 'Catawba',
    county_fips: 55099,
    county_fips_all: '55099',
    county: 'Price',
    county_names_all: 'Price',
    county_weights: '{"55099": 100}',
    density: 3,
    imprecise: false,
    latitude: 45.5146,
    longitude: -90.50217,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54515',
  },
  {
    city: 'Clam Lake',
    county_fips: 55003,
    county_fips_all: '55003|55113|55007',
    county: 'Ashland',
    county_names_all: 'Ashland|Sawyer|Bayfield',
    county_weights: '{"55003": 56.22, "55113": 30.95, "55007": 12.83}',
    density: 0.7,
    imprecise: false,
    latitude: 46.11899,
    longitude: -90.93035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54517',
  },
  {
    city: 'Conover',
    county_fips: 55125,
    county_fips_all: '55125',
    county: 'Vilas',
    county_names_all: 'Vilas',
    county_weights: '{"55125": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 46.05355,
    longitude: -89.26877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54519',
  },
  {
    city: 'Crandon',
    county_fips: 55041,
    county_fips_all: '55041',
    county: 'Forest',
    county_names_all: 'Forest',
    county_weights: '{"55041": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 45.53773,
    longitude: -88.92303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54520',
  },
  {
    city: 'Eagle River',
    county_fips: 55125,
    county_fips_all: '55125|55085|55041',
    county: 'Vilas',
    county_names_all: 'Vilas|Oneida|Forest',
    county_weights: '{"55125": 64.65, "55085": 30.26, "55041": 5.09}',
    density: 17.5,
    imprecise: false,
    latitude: 45.9162,
    longitude: -89.25451,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54521',
  },
  {
    city: 'Fifield',
    county_fips: 55099,
    county_fips_all: '55099',
    county: 'Price',
    county_names_all: 'Price',
    county_weights: '{"55099": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 45.84416,
    longitude: -90.38922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54524',
  },
  {
    city: 'Gile',
    county_fips: 55051,
    county_fips_all: '55051',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"55051": 100}',
    density: 131.4,
    imprecise: false,
    latitude: 46.4335,
    longitude: -90.22603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54525',
  },
  {
    city: 'Glen Flora',
    county_fips: 55107,
    county_fips_all: '55107',
    county: 'Rusk',
    county_names_all: 'Rusk',
    county_weights: '{"55107": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 45.50969,
    longitude: -90.85872,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54526',
  },
  {
    city: 'Glidden',
    county_fips: 55003,
    county_fips_all: '55003',
    county: 'Ashland',
    county_names_all: 'Ashland',
    county_weights: '{"55003": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 46.13543,
    longitude: -90.6366,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54527',
  },
  {
    city: 'Harshaw',
    county_fips: 55085,
    county_fips_all: '55085',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"55085": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 45.67821,
    longitude: -89.66006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54529',
  },
  {
    city: 'Hawkins',
    county_fips: 55107,
    county_fips_all: '55107|55099|55113',
    county: 'Rusk',
    county_names_all: 'Rusk|Price|Sawyer',
    county_weights: '{"55107": 71.32, "55099": 24.1, "55113": 4.58}',
    density: 2.5,
    imprecise: false,
    latitude: 45.53202,
    longitude: -90.71537,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54530',
  },
  {
    city: 'Hazelhurst',
    county_fips: 55085,
    county_fips_all: '55085',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"55085": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 45.74968,
    longitude: -89.78822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54531',
  },
  {
    city: 'Hurley',
    county_fips: 55051,
    county_fips_all: '55051',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"55051": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 46.3545,
    longitude: -90.23769,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54534',
  },
  {
    city: 'Iron Belt',
    county_fips: 55051,
    county_fips_all: '55051',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"55051": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 46.33603,
    longitude: -90.34488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54536',
  },
  {
    city: 'Kennan',
    county_fips: 55099,
    county_fips_all: '55099',
    county: 'Price',
    county_names_all: 'Price',
    county_weights: '{"55099": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 45.53136,
    longitude: -90.60213,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54537',
  },
  {
    city: 'Lac Du Flambeau',
    county_fips: 55125,
    county_fips_all: '55125|55051|55085|55099',
    county: 'Vilas',
    county_names_all: 'Vilas|Iron|Oneida|Price',
    county_weights:
      '{"55125": 78.72, "55051": 10.53, "55085": 9.77, "55099": 0.98}',
    density: 11.1,
    imprecise: false,
    latitude: 45.97244,
    longitude: -89.91484,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54538',
  },
  {
    city: 'Lake Tomahawk',
    county_fips: 55085,
    county_fips_all: '55085',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"55085": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 45.80705,
    longitude: -89.5762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54539',
  },
  {
    city: "Land O'Lakes",
    county_fips: 55125,
    county_fips_all: '55125|26053',
    county: 'Vilas',
    county_names_all: 'Vilas|Gogebic',
    county_weights: '{"55125": 99.35, "26053": 0.65}',
    density: 4.7,
    imprecise: false,
    latitude: 46.15505,
    longitude: -89.38216,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54540',
  },
  {
    city: 'Laona',
    county_fips: 55041,
    county_fips_all: '55041',
    county: 'Forest',
    county_names_all: 'Forest',
    county_weights: '{"55041": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 45.55218,
    longitude: -88.65937,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54541',
  },
  {
    city: 'Long Lake',
    county_fips: 55041,
    county_fips_all: '55041|55037',
    county: 'Forest',
    county_names_all: 'Forest|Florence',
    county_weights: '{"55041": 60.77, "55037": 39.23}',
    density: 1,
    imprecise: false,
    latitude: 45.92127,
    longitude: -88.72536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54542',
  },
  {
    city: 'Manitowish Waters',
    county_fips: 55125,
    county_fips_all: '55125|55051',
    county: 'Vilas',
    county_names_all: 'Vilas|Iron',
    county_weights: '{"55125": 99.9, "55051": 0.1}',
    density: 7.6,
    imprecise: false,
    latitude: 46.1326,
    longitude: -89.85208,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54545',
  },
  {
    city: 'Mellen',
    county_fips: 55003,
    county_fips_all: '55003',
    county: 'Ashland',
    county_names_all: 'Ashland',
    county_weights: '{"55003": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 46.28685,
    longitude: -90.70977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54546',
  },
  {
    city: 'Mercer',
    county_fips: 55051,
    county_fips_all: '55051',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"55051": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 46.18951,
    longitude: -90.0994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54547',
  },
  {
    city: 'Minocqua',
    county_fips: 55085,
    county_fips_all: '55085|55125',
    county: 'Oneida',
    county_names_all: 'Oneida|Vilas',
    county_weights: '{"55085": 78.89, "55125": 21.11}',
    density: 22.1,
    imprecise: false,
    latitude: 45.86218,
    longitude: -89.82663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54548',
  },
  {
    city: 'Montreal',
    county_fips: 55051,
    county_fips_all: '55051',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"55051": 100}',
    density: 11,
    imprecise: false,
    latitude: 46.35775,
    longitude: -90.26409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54550',
  },
  {
    city: 'Park Falls',
    county_fips: 55099,
    county_fips_all: '55099|55051|55113',
    county: 'Price',
    county_names_all: 'Price|Iron|Sawyer',
    county_weights: '{"55099": 69.02, "55051": 28.0, "55113": 2.98}',
    density: 4.6,
    imprecise: false,
    latitude: 45.93615,
    longitude: -90.29081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54552',
  },
  {
    city: 'Phelps',
    county_fips: 55125,
    county_fips_all: '55125',
    county: 'Vilas',
    county_names_all: 'Vilas',
    county_weights: '{"55125": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 46.05481,
    longitude: -89.06138,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54554',
  },
  {
    city: 'Phillips',
    county_fips: 55099,
    county_fips_all: '55099',
    county: 'Price',
    county_names_all: 'Price',
    county_weights: '{"55099": 100}',
    density: 5,
    imprecise: false,
    latitude: 45.71977,
    longitude: -90.36403,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54555',
  },
  {
    city: 'Prentice',
    county_fips: 55099,
    county_fips_all: '55099',
    county: 'Price',
    county_names_all: 'Price',
    county_weights: '{"55099": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 45.53586,
    longitude: -90.31386,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54556',
  },
  {
    city: 'Presque Isle',
    county_fips: 55125,
    county_fips_all: '55125|55051',
    county: 'Vilas',
    county_names_all: 'Vilas|Iron',
    county_weights: '{"55125": 99.01, "55051": 0.99}',
    density: 4.5,
    imprecise: false,
    latitude: 46.22178,
    longitude: -89.75453,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54557',
  },
  {
    city: 'Saint Germain',
    county_fips: 55125,
    county_fips_all: '55125|55085',
    county: 'Vilas',
    county_names_all: 'Vilas|Oneida',
    county_weights: '{"55125": 76.28, "55085": 23.72}',
    density: 20.2,
    imprecise: false,
    latitude: 45.92417,
    longitude: -89.49746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54558',
  },
  {
    city: 'Saxon',
    county_fips: 55051,
    county_fips_all: '55051|55003',
    county: 'Iron',
    county_names_all: 'Iron|Ashland',
    county_weights: '{"55051": 85.35, "55003": 14.65}',
    density: 2.7,
    imprecise: false,
    latitude: 46.49382,
    longitude: -90.47083,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54559',
  },
  {
    city: 'Sayner',
    county_fips: 55125,
    county_fips_all: '55125',
    county: 'Vilas',
    county_names_all: 'Vilas',
    county_weights: '{"55125": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 46.00997,
    longitude: -89.54365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54560',
  },
  {
    city: 'Star Lake',
    county_fips: 55125,
    county_fips_all: '55125',
    county: 'Vilas',
    county_names_all: 'Vilas',
    county_weights: '{"55125": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 46.07102,
    longitude: -89.46451,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54561',
  },
  {
    city: 'Three Lakes',
    county_fips: 55085,
    county_fips_all: '55085|55041',
    county: 'Oneida',
    county_names_all: 'Oneida|Forest',
    county_weights: '{"55085": 65.02, "55041": 34.98}',
    density: 5.4,
    imprecise: false,
    latitude: 45.81081,
    longitude: -89.0813,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54562',
  },
  {
    city: 'Tony',
    county_fips: 55107,
    county_fips_all: '55107',
    county: 'Rusk',
    county_names_all: 'Rusk',
    county_weights: '{"55107": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 45.46448,
    longitude: -90.97428,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54563',
  },
  {
    city: 'Tripoli',
    county_fips: 55085,
    county_fips_all: '55085|55069|55099',
    county: 'Oneida',
    county_names_all: 'Oneida|Lincoln|Price',
    county_weights: '{"55085": 65.26, "55069": 33.37, "55099": 1.37}',
    density: 0.7,
    imprecise: false,
    latitude: 45.6105,
    longitude: -89.97223,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54564',
  },
  {
    city: 'Upson',
    county_fips: 55051,
    county_fips_all: '55051',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"55051": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 46.30474,
    longitude: -90.45182,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54565',
  },
  {
    city: 'Wabeno',
    county_fips: 55041,
    county_fips_all: '55041|55067',
    county: 'Forest',
    county_names_all: 'Forest|Langlade',
    county_weights: '{"55041": 92.15, "55067": 7.85}',
    density: 4.1,
    imprecise: false,
    latitude: 45.42481,
    longitude: -88.63263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54566',
  },
  {
    city: 'Woodruff',
    county_fips: 55125,
    county_fips_all: '55125|55085',
    county: 'Vilas',
    county_names_all: 'Vilas|Oneida',
    county_weights: '{"55125": 86.23, "55085": 13.77}',
    density: 26.3,
    imprecise: false,
    latitude: 45.94876,
    longitude: -89.67546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54568',
  },
  {
    city: 'La Crosse',
    county_fips: 55063,
    county_fips_all: '55063',
    county: 'La Crosse',
    county_names_all: 'La Crosse',
    county_weights: '{"55063": 100}',
    density: 257.9,
    imprecise: false,
    latitude: 43.80199,
    longitude: -91.14559,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54601',
  },
  {
    city: 'La Crosse',
    county_fips: 55063,
    county_fips_all: '55063',
    county: 'La Crosse',
    county_names_all: 'La Crosse',
    county_weights: '{"55063": 100}',
    density: 598.9,
    imprecise: false,
    latitude: 43.85729,
    longitude: -91.24791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54603',
  },
  {
    city: 'Alma',
    county_fips: 55011,
    county_fips_all: '55011',
    county: 'Buffalo',
    county_names_all: 'Buffalo',
    county_weights: '{"55011": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 44.37077,
    longitude: -91.82549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54610',
  },
  {
    city: 'Alma Center',
    county_fips: 55053,
    county_fips_all: '55053',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"55053": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 44.44624,
    longitude: -90.95164,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54611',
  },
  {
    city: 'Arcadia',
    county_fips: 55121,
    county_fips_all: '55121|55011',
    county: 'Trempealeau',
    county_names_all: 'Trempealeau|Buffalo',
    county_weights: '{"55121": 72.31, "55011": 27.69}',
    density: 15.1,
    imprecise: false,
    latitude: 44.24882,
    longitude: -91.50066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54612',
  },
  {
    city: 'Arkdale',
    county_fips: 55001,
    county_fips_all: '55001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"55001": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 44.07549,
    longitude: -89.92131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54613',
  },
  {
    city: 'Bangor',
    county_fips: 55063,
    county_fips_all: '55063',
    county: 'La Crosse',
    county_names_all: 'La Crosse',
    county_weights: '{"55063": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 43.90242,
    longitude: -90.9729,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54614',
  },
  {
    city: 'Black River Falls',
    county_fips: 55053,
    county_fips_all: '55053|55081',
    county: 'Jackson',
    county_names_all: 'Jackson|Monroe',
    county_weights: '{"55053": 97.14, "55081": 2.86}',
    density: 13.8,
    imprecise: false,
    latitude: 44.26158,
    longitude: -90.78049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54615',
  },
  {
    city: 'Blair',
    county_fips: 55121,
    county_fips_all: '55121|55053',
    county: 'Trempealeau',
    county_names_all: 'Trempealeau|Jackson',
    county_weights: '{"55121": 87.19, "55053": 12.81}',
    density: 10.1,
    imprecise: false,
    latitude: 44.30402,
    longitude: -91.2283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54616',
  },
  {
    city: 'Camp Douglas',
    county_fips: 55057,
    county_fips_all: '55057|55081',
    county: 'Juneau',
    county_names_all: 'Juneau|Monroe',
    county_weights: '{"55057": 70.73, "55081": 29.27}',
    density: 9.5,
    imprecise: false,
    latitude: 43.95921,
    longitude: -90.28967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54618',
  },
  {
    city: 'Cashton',
    county_fips: 55081,
    county_fips_all: '55081|55123|55063',
    county: 'Monroe',
    county_names_all: 'Monroe|Vernon|La Crosse',
    county_weights: '{"55081": 73.82, "55123": 22.34, "55063": 3.84}',
    density: 14.1,
    imprecise: false,
    latitude: 43.75562,
    longitude: -90.77968,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54619',
  },
  {
    city: 'Chaseburg',
    county_fips: 55123,
    county_fips_all: '55123',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"55123": 100}',
    density: 14,
    imprecise: false,
    latitude: 43.65632,
    longitude: -91.08199,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54621',
  },
  {
    city: 'Cochrane',
    county_fips: 55011,
    county_fips_all: '55011',
    county: 'Buffalo',
    county_names_all: 'Buffalo',
    county_weights: '{"55011": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 44.26953,
    longitude: -91.76629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54622',
  },
  {
    city: 'Coon Valley',
    county_fips: 55063,
    county_fips_all: '55063|55123',
    county: 'La Crosse',
    county_names_all: 'La Crosse|Vernon',
    county_weights: '{"55063": 57.41, "55123": 42.59}',
    density: 14.7,
    imprecise: false,
    latitude: 43.72894,
    longitude: -91.03065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54623',
  },
  {
    city: 'De Soto',
    county_fips: 55123,
    county_fips_all: '55123|55023',
    county: 'Vernon',
    county_names_all: 'Vernon|Crawford',
    county_weights: '{"55123": 85.86, "55023": 14.14}',
    density: 9.1,
    imprecise: false,
    latitude: 43.46575,
    longitude: -91.14066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54624',
  },
  {
    city: 'Dodge',
    county_fips: 55121,
    county_fips_all: '55121',
    county: 'Trempealeau',
    county_names_all: 'Trempealeau',
    county_weights: '{"55121": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 44.13287,
    longitude: -91.52507,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54625',
  },
  {
    city: 'Eastman',
    county_fips: 55023,
    county_fips_all: '55023',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"55023": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 43.2162,
    longitude: -91.03608,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54626',
  },
  {
    city: 'Ettrick',
    county_fips: 55121,
    county_fips_all: '55121|55053',
    county: 'Trempealeau',
    county_names_all: 'Trempealeau|Jackson',
    county_weights: '{"55121": 88.16, "55053": 11.84}',
    density: 9.2,
    imprecise: false,
    latitude: 44.16873,
    longitude: -91.23634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54627',
  },
  {
    city: 'Ferryville',
    county_fips: 55023,
    county_fips_all: '55023|55123',
    county: 'Crawford',
    county_names_all: 'Crawford|Vernon',
    county_weights: '{"55023": 91.49, "55123": 8.51}',
    density: 4.8,
    imprecise: false,
    latitude: 43.37572,
    longitude: -91.02618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54628',
  },
  {
    city: 'Fountain City',
    county_fips: 55011,
    county_fips_all: '55011',
    county: 'Buffalo',
    county_names_all: 'Buffalo',
    county_weights: '{"55011": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 44.15928,
    longitude: -91.66661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54629',
  },
  {
    city: 'Galesville',
    county_fips: 55121,
    county_fips_all: '55121',
    county: 'Trempealeau',
    county_names_all: 'Trempealeau',
    county_weights: '{"55121": 100}',
    density: 20.3,
    imprecise: false,
    latitude: 44.10339,
    longitude: -91.35881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54630',
  },
  {
    city: 'Gays Mills',
    county_fips: 55023,
    county_fips_all: '55023',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"55023": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 43.28795,
    longitude: -90.8327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54631',
  },
  {
    city: 'Genoa',
    county_fips: 55123,
    county_fips_all: '55123',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"55123": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 43.56249,
    longitude: -91.14695,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54632',
  },
  {
    city: 'Hillsboro',
    county_fips: 55123,
    county_fips_all: '55123|55103|55057',
    county: 'Vernon',
    county_names_all: 'Vernon|Richland|Juneau',
    county_weights: '{"55123": 69.41, "55103": 29.97, "55057": 0.62}',
    density: 12.3,
    imprecise: false,
    latitude: 43.59753,
    longitude: -90.42553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54634',
  },
  {
    city: 'Hixton',
    county_fips: 55053,
    county_fips_all: '55053',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"55053": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 44.40871,
    longitude: -91.04455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54635',
  },
  {
    city: 'Holmen',
    county_fips: 55063,
    county_fips_all: '55063',
    county: 'La Crosse',
    county_names_all: 'La Crosse',
    county_weights: '{"55063": 100}',
    density: 77.8,
    imprecise: false,
    latitude: 44.00732,
    longitude: -91.22682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54636',
  },
  {
    city: 'Hustler',
    county_fips: 55057,
    county_fips_all: '55057',
    county: 'Juneau',
    county_names_all: 'Juneau',
    county_weights: '{"55057": 100}',
    density: 147,
    imprecise: false,
    latitude: 43.87874,
    longitude: -90.27076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54637',
  },
  {
    city: 'Kendall',
    county_fips: 55081,
    county_fips_all: '55081|55123|55057',
    county: 'Monroe',
    county_names_all: 'Monroe|Vernon|Juneau',
    county_weights: '{"55081": 83.99, "55123": 13.26, "55057": 2.75}',
    density: 9.5,
    imprecise: false,
    latitude: 43.79088,
    longitude: -90.3875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54638',
  },
  {
    city: 'La Farge',
    county_fips: 55123,
    county_fips_all: '55123|55103',
    county: 'Vernon',
    county_names_all: 'Vernon|Richland',
    county_weights: '{"55123": 95.93, "55103": 4.07}',
    density: 10.5,
    imprecise: false,
    latitude: 43.60566,
    longitude: -90.62021,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54639',
  },
  {
    city: 'Melrose',
    county_fips: 55053,
    county_fips_all: '55053|55121|55063',
    county: 'Jackson',
    county_names_all: 'Jackson|Trempealeau|La Crosse',
    county_weights: '{"55053": 92.83, "55121": 4.31, "55063": 2.86}',
    density: 9.5,
    imprecise: false,
    latitude: 44.14978,
    longitude: -91.05303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54642',
  },
  {
    city: 'Millston',
    county_fips: 55053,
    county_fips_all: '55053',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"55053": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 44.18758,
    longitude: -90.63432,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54643',
  },
  {
    city: 'Mindoro',
    county_fips: 55063,
    county_fips_all: '55063|55053',
    county: 'La Crosse',
    county_names_all: 'La Crosse|Jackson',
    county_weights: '{"55063": 93.01, "55053": 6.99}',
    density: 7.8,
    imprecise: false,
    latitude: 44.03089,
    longitude: -91.04326,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54644',
  },
  {
    city: 'Mount Sterling',
    county_fips: 55023,
    county_fips_all: '55023',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"55023": 100}',
    density: 54,
    imprecise: false,
    latitude: 43.32084,
    longitude: -90.92901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54645',
  },
  {
    city: 'Necedah',
    county_fips: 55057,
    county_fips_all: '55057',
    county: 'Juneau',
    county_names_all: 'Juneau',
    county_weights: '{"55057": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 44.08807,
    longitude: -90.0912,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54646',
  },
  {
    city: 'Norwalk',
    county_fips: 55081,
    county_fips_all: '55081',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"55081": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 43.83544,
    longitude: -90.63553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54648',
  },
  {
    city: 'Onalaska',
    county_fips: 55063,
    county_fips_all: '55063',
    county: 'La Crosse',
    county_names_all: 'La Crosse',
    county_weights: '{"55063": 100}',
    density: 316.1,
    imprecise: false,
    latitude: 43.9099,
    longitude: -91.22424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54650',
  },
  {
    city: 'Ontario',
    county_fips: 55123,
    county_fips_all: '55123|55081',
    county: 'Vernon',
    county_names_all: 'Vernon|Monroe',
    county_weights: '{"55123": 57.02, "55081": 42.98}',
    density: 9,
    imprecise: false,
    latitude: 43.72368,
    longitude: -90.57004,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54651',
  },
  {
    city: 'Readstown',
    county_fips: 55123,
    county_fips_all: '55123',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"55123": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 43.46133,
    longitude: -90.76825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54652',
  },
  {
    city: 'Rockland',
    county_fips: 55063,
    county_fips_all: '55063|55081',
    county: 'La Crosse',
    county_names_all: 'La Crosse|Monroe',
    county_weights: '{"55063": 60.97, "55081": 39.03}',
    density: 23.9,
    imprecise: false,
    latitude: 43.82586,
    longitude: -90.9129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54653',
  },
  {
    city: 'Seneca',
    county_fips: 55023,
    county_fips_all: '55023',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"55023": 100}',
    density: 176.8,
    imprecise: false,
    latitude: 43.26853,
    longitude: -90.95419,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54654',
  },
  {
    city: 'Soldiers Grove',
    county_fips: 55023,
    county_fips_all: '55023|55103|55123',
    county: 'Crawford',
    county_names_all: 'Crawford|Richland|Vernon',
    county_weights: '{"55023": 82.2, "55103": 15.52, "55123": 2.28}',
    density: 7.7,
    imprecise: false,
    latitude: 43.37877,
    longitude: -90.76423,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54655',
  },
  {
    city: 'Sparta',
    county_fips: 55081,
    county_fips_all: '55081|55063',
    county: 'Monroe',
    county_names_all: 'Monroe|La Crosse',
    county_weights: '{"55081": 99.89, "55063": 0.11}',
    density: 24.8,
    imprecise: false,
    latitude: 44.00291,
    longitude: -90.79601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54656',
  },
  {
    city: 'Steuben',
    county_fips: 55023,
    county_fips_all: '55023',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"55023": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 43.19447,
    longitude: -90.90678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54657',
  },
  {
    city: 'Stoddard',
    county_fips: 55123,
    county_fips_all: '55123|55063',
    county: 'Vernon',
    county_names_all: 'Vernon|La Crosse',
    county_weights: '{"55123": 93.78, "55063": 6.22}',
    density: 25.3,
    imprecise: false,
    latitude: 43.67768,
    longitude: -91.19248,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54658',
  },
  {
    city: 'Taylor',
    county_fips: 55053,
    county_fips_all: '55053|55121',
    county: 'Jackson',
    county_names_all: 'Jackson|Trempealeau',
    county_weights: '{"55053": 97.55, "55121": 2.45}',
    density: 8.3,
    imprecise: false,
    latitude: 44.29704,
    longitude: -91.10065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54659',
  },
  {
    city: 'Tomah',
    county_fips: 55081,
    county_fips_all: '55081',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"55081": 100}',
    density: 35.9,
    imprecise: false,
    latitude: 43.98525,
    longitude: -90.50496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54660',
  },
  {
    city: 'Trempealeau',
    county_fips: 55121,
    county_fips_all: '55121|55063',
    county: 'Trempealeau',
    county_names_all: 'Trempealeau|La Crosse',
    county_weights: '{"55121": 99.76, "55063": 0.24}',
    density: 28.4,
    imprecise: false,
    latitude: 44.05943,
    longitude: -91.47133,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54661',
  },
  {
    city: 'Viola',
    county_fips: 55103,
    county_fips_all: '55103|55123',
    county: 'Richland',
    county_names_all: 'Richland|Vernon',
    county_weights: '{"55103": 65.09, "55123": 34.91}',
    density: 7.4,
    imprecise: false,
    latitude: 43.49912,
    longitude: -90.64076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54664',
  },
  {
    city: 'Viroqua',
    county_fips: 55123,
    county_fips_all: '55123|55023',
    county: 'Vernon',
    county_names_all: 'Vernon|Crawford',
    county_weights: '{"55123": 99.02, "55023": 0.98}',
    density: 18.9,
    imprecise: false,
    latitude: 43.5319,
    longitude: -90.92134,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54665',
  },
  {
    city: 'Warrens',
    county_fips: 55081,
    county_fips_all: '55081|55053|55057',
    county: 'Monroe',
    county_names_all: 'Monroe|Jackson|Juneau',
    county_weights: '{"55081": 45.04, "55053": 43.99, "55057": 10.97}',
    density: 4.3,
    imprecise: false,
    latitude: 44.16201,
    longitude: -90.4399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54666',
  },
  {
    city: 'Westby',
    county_fips: 55123,
    county_fips_all: '55123|55063',
    county: 'Vernon',
    county_names_all: 'Vernon|La Crosse',
    county_weights: '{"55123": 96.66, "55063": 3.34}',
    density: 22.1,
    imprecise: false,
    latitude: 43.66703,
    longitude: -90.86166,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54667',
  },
  {
    city: 'West Salem',
    county_fips: 55063,
    county_fips_all: '55063',
    county: 'La Crosse',
    county_names_all: 'La Crosse',
    county_weights: '{"55063": 100}',
    density: 61.5,
    imprecise: false,
    latitude: 43.91171,
    longitude: -91.09046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54669',
  },
  {
    city: 'Wilton',
    county_fips: 55081,
    county_fips_all: '55081',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"55081": 100}',
    density: 15,
    imprecise: false,
    latitude: 43.83802,
    longitude: -90.48273,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54670',
  },
  {
    city: 'Eau Claire',
    county_fips: 55035,
    county_fips_all: '55035|55033',
    county: 'Eau Claire',
    county_names_all: 'Eau Claire|Dunn',
    county_weights: '{"55035": 95.16, "55033": 4.84}',
    density: 193.1,
    imprecise: false,
    latitude: 44.7432,
    longitude: -91.50899,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54701',
  },
  {
    city: 'Eau Claire',
    county_fips: 55035,
    county_fips_all: '55035|55017|55033',
    county: 'Eau Claire',
    county_names_all: 'Eau Claire|Chippewa|Dunn',
    county_weights: '{"55035": 77.97, "55017": 20.37, "55033": 1.66}',
    density: 210.3,
    imprecise: false,
    latitude: 44.83311,
    longitude: -91.5185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54703',
  },
  {
    city: 'Altoona',
    county_fips: 55035,
    county_fips_all: '55035',
    county: 'Eau Claire',
    county_names_all: 'Eau Claire',
    county_weights: '{"55035": 100}',
    density: 727.6,
    imprecise: false,
    latitude: 44.80511,
    longitude: -91.43646,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54720',
  },
  {
    city: 'Arkansaw',
    county_fips: 55091,
    county_fips_all: '55091|55033|55093',
    county: 'Pepin',
    county_names_all: 'Pepin|Dunn|Pierce',
    county_weights: '{"55091": 85.88, "55033": 11.88, "55093": 2.24}',
    density: 8.1,
    imprecise: false,
    latitude: 44.6304,
    longitude: -92.07098,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54721',
  },
  {
    city: 'Augusta',
    county_fips: 55035,
    county_fips_all: '55035',
    county: 'Eau Claire',
    county_names_all: 'Eau Claire',
    county_weights: '{"55035": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 44.71702,
    longitude: -91.09874,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54722',
  },
  {
    city: 'Bay City',
    county_fips: 55093,
    county_fips_all: '55093',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"55093": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 44.61063,
    longitude: -92.42893,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54723',
  },
  {
    city: 'Bloomer',
    county_fips: 55017,
    county_fips_all: '55017|55033',
    county: 'Chippewa',
    county_names_all: 'Chippewa|Dunn',
    county_weights: '{"55017": 99.43, "55033": 0.57}',
    density: 17.9,
    imprecise: false,
    latitude: 45.10793,
    longitude: -91.48458,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54724',
  },
  {
    city: 'Boyceville',
    county_fips: 55033,
    county_fips_all: '55033',
    county: 'Dunn',
    county_names_all: 'Dunn',
    county_weights: '{"55033": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 45.07103,
    longitude: -92.01062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54725',
  },
  {
    city: 'Boyd',
    county_fips: 55017,
    county_fips_all: '55017|55035',
    county: 'Chippewa',
    county_names_all: 'Chippewa|Eau Claire',
    county_weights: '{"55017": 72.15, "55035": 27.85}',
    density: 8.9,
    imprecise: false,
    latitude: 44.94151,
    longitude: -91.01975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54726',
  },
  {
    city: 'Cadott',
    county_fips: 55017,
    county_fips_all: '55017|55035',
    county: 'Chippewa',
    county_names_all: 'Chippewa|Eau Claire',
    county_weights: '{"55017": 94.5, "55035": 5.5}',
    density: 13,
    imprecise: false,
    latitude: 44.95827,
    longitude: -91.15873,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54727',
  },
  {
    city: 'Chetek',
    county_fips: 55005,
    county_fips_all: '55005|55107|55033',
    county: 'Barron',
    county_names_all: 'Barron|Rusk|Dunn',
    county_weights: '{"55005": 79.95, "55107": 19.28, "55033": 0.77}',
    density: 17.9,
    imprecise: false,
    latitude: 45.30778,
    longitude: -91.6417,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54728',
  },
  {
    city: 'Chippewa Falls',
    county_fips: 55017,
    county_fips_all: '55017|55035',
    county: 'Chippewa',
    county_names_all: 'Chippewa|Eau Claire',
    county_weights: '{"55017": 97.14, "55035": 2.86}',
    density: 80.4,
    imprecise: false,
    latitude: 44.94533,
    longitude: -91.39342,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54729',
  },
  {
    city: 'Colfax',
    county_fips: 55033,
    county_fips_all: '55033|55017',
    county: 'Dunn',
    county_names_all: 'Dunn|Chippewa',
    county_weights: '{"55033": 78.28, "55017": 21.72}',
    density: 15.6,
    imprecise: false,
    latitude: 45.01836,
    longitude: -91.72143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54730',
  },
  {
    city: 'Conrath',
    county_fips: 55107,
    county_fips_all: '55107',
    county: 'Rusk',
    county_names_all: 'Rusk',
    county_weights: '{"55107": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 45.34656,
    longitude: -91.08304,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54731',
  },
  {
    city: 'Cornell',
    county_fips: 55017,
    county_fips_all: '55017',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"55017": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 45.14571,
    longitude: -91.16543,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54732',
  },
  {
    city: 'Dallas',
    county_fips: 55005,
    county_fips_all: '55005',
    county: 'Barron',
    county_names_all: 'Barron',
    county_weights: '{"55005": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 45.28331,
    longitude: -91.85641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54733',
  },
  {
    city: 'Downing',
    county_fips: 55033,
    county_fips_all: '55033|55109',
    county: 'Dunn',
    county_names_all: 'Dunn|St. Croix',
    county_weights: '{"55033": 94.0, "55109": 6.0}',
    density: 9.5,
    imprecise: false,
    latitude: 45.09045,
    longitude: -92.11358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54734',
  },
  {
    city: 'Durand',
    county_fips: 55091,
    county_fips_all: '55091|55011|55033',
    county: 'Pepin',
    county_names_all: 'Pepin|Buffalo|Dunn',
    county_weights: '{"55091": 50.3, "55011": 44.79, "55033": 4.91}',
    density: 12.5,
    imprecise: false,
    latitude: 44.60345,
    longitude: -91.90455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54736',
  },
  {
    city: 'Eau Galle',
    county_fips: 55033,
    county_fips_all: '55033|55091',
    county: 'Dunn',
    county_names_all: 'Dunn|Pepin',
    county_weights: '{"55033": 94.83, "55091": 5.17}',
    density: 10.3,
    imprecise: false,
    latitude: 44.71593,
    longitude: -91.98298,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54737',
  },
  {
    city: 'Eleva',
    county_fips: 55035,
    county_fips_all: '55035|55121|55011',
    county: 'Eau Claire',
    county_names_all: 'Eau Claire|Trempealeau|Buffalo',
    county_weights: '{"55035": 53.46, "55121": 45.46, "55011": 1.08}',
    density: 14.8,
    imprecise: false,
    latitude: 44.59478,
    longitude: -91.47892,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54738',
  },
  {
    city: 'Elk Mound',
    county_fips: 55033,
    county_fips_all: '55033|55017|55035',
    county: 'Dunn',
    county_names_all: 'Dunn|Chippewa|Eau Claire',
    county_weights: '{"55033": 81.86, "55017": 18.0, "55035": 0.14}',
    density: 20.9,
    imprecise: false,
    latitude: 44.86177,
    longitude: -91.70097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54739',
  },
  {
    city: 'Elmwood',
    county_fips: 55093,
    county_fips_all: '55093|55033',
    county: 'Pierce',
    county_names_all: 'Pierce|Dunn',
    county_weights: '{"55093": 57.61, "55033": 42.39}',
    density: 8.2,
    imprecise: false,
    latitude: 44.74427,
    longitude: -92.15853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54740',
  },
  {
    city: 'Fairchild',
    county_fips: 55035,
    county_fips_all: '55035|55053|55019',
    county: 'Eau Claire',
    county_names_all: 'Eau Claire|Jackson|Clark',
    county_weights: '{"55035": 47.93, "55053": 39.22, "55019": 12.85}',
    density: 6.7,
    imprecise: false,
    latitude: 44.61237,
    longitude: -90.98121,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54741',
  },
  {
    city: 'Fall Creek',
    county_fips: 55035,
    county_fips_all: '55035',
    county: 'Eau Claire',
    county_names_all: 'Eau Claire',
    county_weights: '{"55035": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 44.76319,
    longitude: -91.2722,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54742',
  },
  {
    city: 'Holcombe',
    county_fips: 55017,
    county_fips_all: '55017|55107',
    county: 'Chippewa',
    county_names_all: 'Chippewa|Rusk',
    county_weights: '{"55017": 85.18, "55107": 14.82}',
    density: 6.8,
    imprecise: false,
    latitude: 45.24875,
    longitude: -91.13494,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54745',
  },
  {
    city: 'Humbird',
    county_fips: 55019,
    county_fips_all: '55019|55053',
    county: 'Clark',
    county_names_all: 'Clark|Jackson',
    county_weights: '{"55019": 82.78, "55053": 17.22}',
    density: 6.1,
    imprecise: false,
    latitude: 44.54543,
    longitude: -90.87217,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54746',
  },
  {
    city: 'Independence',
    county_fips: 55121,
    county_fips_all: '55121|55011',
    county: 'Trempealeau',
    county_names_all: 'Trempealeau|Buffalo',
    county_weights: '{"55121": 63.24, "55011": 36.76}',
    density: 8.7,
    imprecise: false,
    latitude: 44.39438,
    longitude: -91.5035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54747',
  },
  {
    city: 'Jim Falls',
    county_fips: 55017,
    county_fips_all: '55017',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"55017": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 45.07919,
    longitude: -91.26586,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54748',
  },
  {
    city: 'Knapp',
    county_fips: 55033,
    county_fips_all: '55033|55109',
    county: 'Dunn',
    county_names_all: 'Dunn|St. Croix',
    county_weights: '{"55033": 83.85, "55109": 16.15}',
    density: 13.6,
    imprecise: false,
    latitude: 44.94862,
    longitude: -92.09785,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54749',
  },
  {
    city: 'Maiden Rock',
    county_fips: 55093,
    county_fips_all: '55093',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"55093": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 44.62052,
    longitude: -92.29513,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54750',
  },
  {
    city: 'Menomonie',
    county_fips: 55033,
    county_fips_all: '55033',
    county: 'Dunn',
    county_names_all: 'Dunn',
    county_weights: '{"55033": 100}',
    density: 44.3,
    imprecise: false,
    latitude: 44.84971,
    longitude: -91.92994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54751',
  },
  {
    city: 'Merrillan',
    county_fips: 55053,
    county_fips_all: '55053|55019',
    county: 'Jackson',
    county_names_all: 'Jackson|Clark',
    county_weights: '{"55053": 82.15, "55019": 17.85}',
    density: 6.7,
    imprecise: false,
    latitude: 44.42913,
    longitude: -90.77527,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54754',
  },
  {
    city: 'Mondovi',
    county_fips: 55011,
    county_fips_all: '55011|55033|55091|55035',
    county: 'Buffalo',
    county_names_all: 'Buffalo|Dunn|Pepin|Eau Claire',
    county_weights:
      '{"55011": 60.0, "55033": 14.57, "55091": 13.4, "55035": 12.03}',
    density: 11,
    imprecise: false,
    latitude: 44.57513,
    longitude: -91.67971,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54755',
  },
  {
    city: 'Nelson',
    county_fips: 55011,
    county_fips_all: '55011',
    county: 'Buffalo',
    county_names_all: 'Buffalo',
    county_weights: '{"55011": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 44.46153,
    longitude: -91.94552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54756',
  },
  {
    city: 'New Auburn',
    county_fips: 55017,
    county_fips_all: '55017|55005|55033|55107',
    county: 'Chippewa',
    county_names_all: 'Chippewa|Barron|Dunn|Rusk',
    county_weights:
      '{"55017": 56.89, "55005": 18.79, "55033": 15.62, "55107": 8.7}',
    density: 8.9,
    imprecise: false,
    latitude: 45.23085,
    longitude: -91.52498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54757',
  },
  {
    city: 'Osseo',
    county_fips: 55121,
    county_fips_all: '55121|55053|55035',
    county: 'Trempealeau',
    county_names_all: 'Trempealeau|Jackson|Eau Claire',
    county_weights: '{"55121": 52.8, "55053": 24.54, "55035": 22.66}',
    density: 11.3,
    imprecise: false,
    latitude: 44.54546,
    longitude: -91.2173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54758',
  },
  {
    city: 'Pepin',
    county_fips: 55091,
    county_fips_all: '55091',
    county: 'Pepin',
    county_names_all: 'Pepin',
    county_weights: '{"55091": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 44.48936,
    longitude: -92.1232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54759',
  },
  {
    city: 'Pigeon Falls',
    county_fips: 55121,
    county_fips_all: '55121',
    county: 'Trempealeau',
    county_names_all: 'Trempealeau',
    county_weights: '{"55121": 100}',
    density: 481.5,
    imprecise: false,
    latitude: 44.42412,
    longitude: -91.20626,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54760',
  },
  {
    city: 'Plum City',
    county_fips: 55093,
    county_fips_all: '55093',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"55093": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 44.62667,
    longitude: -92.17908,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54761',
  },
  {
    city: 'Prairie Farm',
    county_fips: 55005,
    county_fips_all: '55005|55033',
    county: 'Barron',
    county_names_all: 'Barron|Dunn',
    county_weights: '{"55005": 86.91, "55033": 13.09}',
    density: 8.9,
    imprecise: false,
    latitude: 45.25107,
    longitude: -91.98967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54762',
  },
  {
    city: 'Ridgeland',
    county_fips: 55033,
    county_fips_all: '55033|55005',
    county: 'Dunn',
    county_names_all: 'Dunn|Barron',
    county_weights: '{"55033": 83.46, "55005": 16.54}',
    density: 7.1,
    imprecise: false,
    latitude: 45.179,
    longitude: -91.87683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54763',
  },
  {
    city: 'Sheldon',
    county_fips: 55119,
    county_fips_all: '55119|55107|55017',
    county: 'Taylor',
    county_names_all: 'Taylor|Rusk|Chippewa',
    county_weights: '{"55119": 51.68, "55107": 38.02, "55017": 10.3}',
    density: 4.9,
    imprecise: false,
    latitude: 45.33667,
    longitude: -90.86566,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54766',
  },
  {
    city: 'Spring Valley',
    county_fips: 55093,
    county_fips_all: '55093|55109|55033',
    county: 'Pierce',
    county_names_all: 'Pierce|St. Croix|Dunn',
    county_weights: '{"55093": 81.97, "55109": 12.64, "55033": 5.39}',
    density: 15.4,
    imprecise: false,
    latitude: 44.82645,
    longitude: -92.25513,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54767',
  },
  {
    city: 'Stanley',
    county_fips: 55017,
    county_fips_all: '55017|55019|55119|55035',
    county: 'Chippewa',
    county_names_all: 'Chippewa|Clark|Taylor|Eau Claire',
    county_weights:
      '{"55017": 45.47, "55019": 32.4, "55119": 12.7, "55035": 9.43}',
    density: 18.9,
    imprecise: false,
    latitude: 44.96312,
    longitude: -90.92761,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54768',
  },
  {
    city: 'Stockholm',
    county_fips: 55091,
    county_fips_all: '55091|55093',
    county: 'Pepin',
    county_names_all: 'Pepin|Pierce',
    county_weights: '{"55091": 79.65, "55093": 20.35}',
    density: 6.1,
    imprecise: false,
    latitude: 44.50897,
    longitude: -92.23304,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54769',
  },
  {
    city: 'Strum',
    county_fips: 55121,
    county_fips_all: '55121|55035',
    county: 'Trempealeau',
    county_names_all: 'Trempealeau|Eau Claire',
    county_weights: '{"55121": 73.51, "55035": 26.49}',
    density: 12.1,
    imprecise: false,
    latitude: 44.55121,
    longitude: -91.37259,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54770',
  },
  {
    city: 'Thorp',
    county_fips: 55019,
    county_fips_all: '55019|55119',
    county: 'Clark',
    county_names_all: 'Clark|Taylor',
    county_weights: '{"55019": 88.19, "55119": 11.81}',
    density: 10.8,
    imprecise: false,
    latitude: 44.92356,
    longitude: -90.80579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54771',
  },
  {
    city: 'Wheeler',
    county_fips: 55033,
    county_fips_all: '55033',
    county: 'Dunn',
    county_names_all: 'Dunn',
    county_weights: '{"55033": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 45.09668,
    longitude: -91.87303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54772',
  },
  {
    city: 'Whitehall',
    county_fips: 55121,
    county_fips_all: '55121',
    county: 'Trempealeau',
    county_names_all: 'Trempealeau',
    county_weights: '{"55121": 100}',
    density: 19.6,
    imprecise: false,
    latitude: 44.39301,
    longitude: -91.3002,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54773',
  },
  {
    city: 'Spooner',
    county_fips: 55129,
    county_fips_all: '55129|55013',
    county: 'Washburn',
    county_names_all: 'Washburn|Burnett',
    county_weights: '{"55129": 78.19, "55013": 21.81}',
    density: 12.3,
    imprecise: false,
    latitude: 45.86711,
    longitude: -91.92266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54801',
  },
  {
    city: 'Almena',
    county_fips: 55005,
    county_fips_all: '55005',
    county: 'Barron',
    county_names_all: 'Barron',
    county_weights: '{"55005": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 45.41465,
    longitude: -92.02311,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54805',
  },
  {
    city: 'Ashland',
    county_fips: 55003,
    county_fips_all: '55003|55007',
    county: 'Ashland',
    county_names_all: 'Ashland|Bayfield',
    county_weights: '{"55003": 66.88, "55007": 33.12}',
    density: 15.6,
    imprecise: false,
    latitude: 46.54784,
    longitude: -90.85061,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54806',
  },
  {
    city: 'Balsam Lake',
    county_fips: 55095,
    county_fips_all: '55095',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"55095": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 45.46126,
    longitude: -92.38403,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54810',
  },
  {
    city: 'Barron',
    county_fips: 55005,
    county_fips_all: '55005',
    county: 'Barron',
    county_names_all: 'Barron',
    county_weights: '{"55005": 100}',
    density: 26,
    imprecise: false,
    latitude: 45.39911,
    longitude: -91.88103,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54812',
  },
  {
    city: 'Barronett',
    county_fips: 55013,
    county_fips_all: '55013|55005|55129',
    county: 'Burnett',
    county_names_all: 'Burnett|Barron|Washburn',
    county_weights: '{"55013": 51.43, "55005": 32.21, "55129": 16.36}',
    density: 4.7,
    imprecise: false,
    latitude: 45.65477,
    longitude: -92.03071,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54813',
  },
  {
    city: 'Bayfield',
    county_fips: 55007,
    county_fips_all: '55007',
    county: 'Bayfield',
    county_names_all: 'Bayfield',
    county_weights: '{"55007": 100}',
    density: 7,
    imprecise: false,
    latitude: 46.85672,
    longitude: -90.91876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54814',
  },
  {
    city: 'Birchwood',
    county_fips: 55129,
    county_fips_all: '55129|55113|55107|55005',
    county: 'Washburn',
    county_names_all: 'Washburn|Sawyer|Rusk|Barron',
    county_weights:
      '{"55129": 35.1, "55113": 32.87, "55107": 18.22, "55005": 13.81}',
    density: 5.5,
    imprecise: false,
    latitude: 45.67056,
    longitude: -91.53942,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54817',
  },
  {
    city: 'Bruce',
    county_fips: 55107,
    county_fips_all: '55107',
    county: 'Rusk',
    county_names_all: 'Rusk',
    county_weights: '{"55107": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 45.47636,
    longitude: -91.30307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54819',
  },
  {
    city: 'Brule',
    county_fips: 55031,
    county_fips_all: '55031|55007',
    county: 'Douglas',
    county_names_all: 'Douglas|Bayfield',
    county_weights: '{"55031": 52.34, "55007": 47.66}',
    density: 2.3,
    imprecise: false,
    latitude: 46.56024,
    longitude: -91.55475,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54820',
  },
  {
    city: 'Cable',
    county_fips: 55007,
    county_fips_all: '55007|55113',
    county: 'Bayfield',
    county_names_all: 'Bayfield|Sawyer',
    county_weights: '{"55007": 97.89, "55113": 2.11}',
    density: 3.4,
    imprecise: false,
    latitude: 46.22428,
    longitude: -91.16508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54821',
  },
  {
    city: 'Cameron',
    county_fips: 55005,
    county_fips_all: '55005',
    county: 'Barron',
    county_names_all: 'Barron',
    county_weights: '{"55005": 100}',
    density: 39.5,
    imprecise: false,
    latitude: 45.3944,
    longitude: -91.69995,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54822',
  },
  {
    city: 'Centuria',
    county_fips: 55095,
    county_fips_all: '55095',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"55095": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 45.4753,
    longitude: -92.54017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54824',
  },
  {
    city: 'Comstock',
    county_fips: 55095,
    county_fips_all: '55095|55005',
    county: 'Polk',
    county_names_all: 'Polk|Barron',
    county_weights: '{"55095": 54.99, "55005": 45.01}',
    density: 7.7,
    imprecise: false,
    latitude: 45.49971,
    longitude: -92.16422,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54826',
  },
  {
    city: 'Cornucopia',
    county_fips: 55007,
    county_fips_all: '55007',
    county: 'Bayfield',
    county_names_all: 'Bayfield',
    county_weights: '{"55007": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 46.80215,
    longitude: -91.10069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54827',
  },
  {
    city: 'Couderay',
    county_fips: 55113,
    county_fips_all: '55113',
    county: 'Sawyer',
    county_names_all: 'Sawyer',
    county_weights: '{"55113": 100}',
    density: 3,
    imprecise: false,
    latitude: 45.84201,
    longitude: -91.2934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54828',
  },
  {
    city: 'Cumberland',
    county_fips: 55005,
    county_fips_all: '55005|55095',
    county: 'Barron',
    county_names_all: 'Barron|Polk',
    county_weights: '{"55005": 75.31, "55095": 24.69}',
    density: 14.7,
    imprecise: false,
    latitude: 45.5592,
    longitude: -92.06603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54829',
  },
  {
    city: 'Danbury',
    county_fips: 55013,
    county_fips_all: '55013|55031|55129',
    county: 'Burnett',
    county_names_all: 'Burnett|Douglas|Washburn',
    county_weights: '{"55013": 63.81, "55031": 36.04, "55129": 0.15}',
    density: 3.9,
    imprecise: false,
    latitude: 46.10571,
    longitude: -92.22305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54830',
  },
  {
    city: 'Drummond',
    county_fips: 55007,
    county_fips_all: '55007',
    county: 'Bayfield',
    county_names_all: 'Bayfield',
    county_weights: '{"55007": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 46.32661,
    longitude: -91.33073,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54832',
  },
  {
    city: 'Exeland',
    county_fips: 55113,
    county_fips_all: '55113|55107',
    county: 'Sawyer',
    county_names_all: 'Sawyer|Rusk',
    county_weights: '{"55113": 82.34, "55107": 17.66}',
    density: 2.5,
    imprecise: false,
    latitude: 45.67974,
    longitude: -91.2522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54835',
  },
  {
    city: 'Foxboro',
    county_fips: 55031,
    county_fips_all: '55031',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"55031": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 46.43238,
    longitude: -92.19225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54836',
  },
  {
    city: 'Frederic',
    county_fips: 55095,
    county_fips_all: '55095|55013',
    county: 'Polk',
    county_names_all: 'Polk|Burnett',
    county_weights: '{"55095": 81.74, "55013": 18.26}',
    density: 8.6,
    imprecise: false,
    latitude: 45.6746,
    longitude: -92.35754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54837',
  },
  {
    city: 'Gordon',
    county_fips: 55031,
    county_fips_all: '55031|55007',
    county: 'Douglas',
    county_names_all: 'Douglas|Bayfield',
    county_weights: '{"55031": 97.98, "55007": 2.02}',
    density: 2.2,
    imprecise: false,
    latitude: 46.24836,
    longitude: -91.79179,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54838',
  },
  {
    city: 'Grand View',
    county_fips: 55007,
    county_fips_all: '55007',
    county: 'Bayfield',
    county_names_all: 'Bayfield',
    county_weights: '{"55007": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 46.35683,
    longitude: -91.14689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54839',
  },
  {
    city: 'Grantsburg',
    county_fips: 55013,
    county_fips_all: '55013|55095',
    county: 'Burnett',
    county_names_all: 'Burnett|Polk',
    county_weights: '{"55013": 88.31, "55095": 11.69}',
    density: 7.2,
    imprecise: false,
    latitude: 45.7556,
    longitude: -92.68928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54840',
  },
  {
    city: 'Haugen',
    county_fips: 55005,
    county_fips_all: '55005',
    county: 'Barron',
    county_names_all: 'Barron',
    county_weights: '{"55005": 100}',
    density: 219.7,
    imprecise: false,
    latitude: 45.60776,
    longitude: -91.77887,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54841',
  },
  {
    city: 'Hawthorne',
    county_fips: 55031,
    county_fips_all: '55031',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"55031": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 46.49891,
    longitude: -91.86234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54842',
  },
  {
    city: 'Hayward',
    county_fips: 55113,
    county_fips_all: '55113|55129',
    county: 'Sawyer',
    county_names_all: 'Sawyer|Washburn',
    county_weights: '{"55113": 92.83, "55129": 7.17}',
    density: 11.8,
    imprecise: false,
    latitude: 46.0251,
    longitude: -91.29494,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54843',
  },
  {
    city: 'Herbster',
    county_fips: 55007,
    county_fips_all: '55007',
    county: 'Bayfield',
    county_names_all: 'Bayfield',
    county_weights: '{"55007": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 46.78649,
    longitude: -91.21441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54844',
  },
  {
    city: 'Hertel',
    county_fips: 55013,
    county_fips_all: '55013',
    county: 'Burnett',
    county_names_all: 'Burnett',
    county_weights: '{"55013": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 45.80724,
    longitude: -92.13786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54845',
  },
  {
    city: 'High Bridge',
    county_fips: 55003,
    county_fips_all: '55003',
    county: 'Ashland',
    county_names_all: 'Ashland',
    county_weights: '{"55003": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 46.37737,
    longitude: -90.72481,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54846',
  },
  {
    city: 'Iron River',
    county_fips: 55007,
    county_fips_all: '55007',
    county: 'Bayfield',
    county_names_all: 'Bayfield',
    county_weights: '{"55007": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 46.57047,
    longitude: -91.40055,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54847',
  },
  {
    city: 'Ladysmith',
    county_fips: 55107,
    county_fips_all: '55107',
    county: 'Rusk',
    county_names_all: 'Rusk',
    county_weights: '{"55107": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 45.51546,
    longitude: -91.10284,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54848',
  },
  {
    city: 'Lake Nebagamon',
    county_fips: 55031,
    county_fips_all: '55031',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"55031": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 46.47881,
    longitude: -91.71642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54849',
  },
  {
    city: 'La Pointe',
    county_fips: 55003,
    county_fips_all: '55003',
    county: 'Ashland',
    county_names_all: 'Ashland',
    county_weights: '{"55003": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 46.92255,
    longitude: -90.62389,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54850',
  },
  {
    city: 'Luck',
    county_fips: 55095,
    county_fips_all: '55095|55013',
    county: 'Polk',
    county_names_all: 'Polk|Burnett',
    county_weights: '{"55095": 96.0, "55013": 4.0}',
    density: 15.4,
    imprecise: false,
    latitude: 45.57106,
    longitude: -92.45211,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54853',
  },
  {
    city: 'Maple',
    county_fips: 55031,
    county_fips_all: '55031',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"55031": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 46.64127,
    longitude: -91.66864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54854',
  },
  {
    city: 'Marengo',
    county_fips: 55003,
    county_fips_all: '55003',
    county: 'Ashland',
    county_names_all: 'Ashland',
    county_weights: '{"55003": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 46.37492,
    longitude: -90.84397,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54855',
  },
  {
    city: 'Mason',
    county_fips: 55007,
    county_fips_all: '55007|55003',
    county: 'Bayfield',
    county_names_all: 'Bayfield|Ashland',
    county_weights: '{"55007": 98.48, "55003": 1.52}',
    density: 3,
    imprecise: false,
    latitude: 46.43401,
    longitude: -91.10279,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54856',
  },
  {
    city: 'Mikana',
    county_fips: 55005,
    county_fips_all: '55005',
    county: 'Barron',
    county_names_all: 'Barron',
    county_weights: '{"55005": 100}',
    density: 158.6,
    imprecise: false,
    latitude: 45.59347,
    longitude: -91.59927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54857',
  },
  {
    city: 'Milltown',
    county_fips: 55095,
    county_fips_all: '55095',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"55095": 100}',
    density: 35.9,
    imprecise: false,
    latitude: 45.51824,
    longitude: -92.46031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54858',
  },
  {
    city: 'Minong',
    county_fips: 55129,
    county_fips_all: '55129|55031|55013',
    county: 'Washburn',
    county_names_all: 'Washburn|Douglas|Burnett',
    county_weights: '{"55129": 80.85, "55031": 15.99, "55013": 3.16}',
    density: 4.8,
    imprecise: false,
    latitude: 46.12121,
    longitude: -91.82337,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54859',
  },
  {
    city: 'Odanah',
    county_fips: 55003,
    county_fips_all: '55003',
    county: 'Ashland',
    county_names_all: 'Ashland',
    county_weights: '{"55003": 100}',
    density: 36,
    imprecise: false,
    latitude: 46.59896,
    longitude: -90.64345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54861',
  },
  {
    city: 'Ojibwa',
    county_fips: 55113,
    county_fips_all: '55113',
    county: 'Sawyer',
    county_names_all: 'Sawyer',
    county_weights: '{"55113": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 45.80385,
    longitude: -91.12132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54862',
  },
  {
    city: 'Poplar',
    county_fips: 55031,
    county_fips_all: '55031',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"55031": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 46.60431,
    longitude: -91.79443,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54864',
  },
  {
    city: 'Port Wing',
    county_fips: 55007,
    county_fips_all: '55007',
    county: 'Bayfield',
    county_names_all: 'Bayfield',
    county_weights: '{"55007": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 46.74787,
    longitude: -91.37517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54865',
  },
  {
    city: 'Radisson',
    county_fips: 55113,
    county_fips_all: '55113',
    county: 'Sawyer',
    county_names_all: 'Sawyer',
    county_weights: '{"55113": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 45.78195,
    longitude: -91.21521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54867',
  },
  {
    city: 'Rice Lake',
    county_fips: 55005,
    county_fips_all: '55005|55107|55129',
    county: 'Barron',
    county_names_all: 'Barron|Rusk|Washburn',
    county_weights: '{"55005": 94.33, "55107": 4.4, "55129": 1.27}',
    density: 29.7,
    imprecise: false,
    latitude: 45.52723,
    longitude: -91.70977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54868',
  },
  {
    city: 'Sarona',
    county_fips: 55129,
    county_fips_all: '55129|55005',
    county: 'Washburn',
    county_names_all: 'Washburn|Barron',
    county_weights: '{"55129": 97.4, "55005": 2.6}',
    density: 8,
    imprecise: false,
    latitude: 45.71205,
    longitude: -91.76967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54870',
  },
  {
    city: 'Shell Lake',
    county_fips: 55129,
    county_fips_all: '55129|55013',
    county: 'Washburn',
    county_names_all: 'Washburn|Burnett',
    county_weights: '{"55129": 59.3, "55013": 40.7}',
    density: 10.9,
    imprecise: false,
    latitude: 45.7412,
    longitude: -92.01503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54871',
  },
  {
    city: 'Siren',
    county_fips: 55013,
    county_fips_all: '55013|55095',
    county: 'Burnett',
    county_names_all: 'Burnett|Polk',
    county_weights: '{"55013": 94.59, "55095": 5.41}',
    density: 15.5,
    imprecise: false,
    latitude: 45.76965,
    longitude: -92.39622,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54872',
  },
  {
    city: 'Solon Springs',
    county_fips: 55031,
    county_fips_all: '55031|55007',
    county: 'Douglas',
    county_names_all: 'Douglas|Bayfield',
    county_weights: '{"55031": 63.13, "55007": 36.87}',
    density: 4.4,
    imprecise: false,
    latitude: 46.3448,
    longitude: -91.69292,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54873',
  },
  {
    city: 'South Range',
    county_fips: 55031,
    county_fips_all: '55031',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"55031": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 46.56911,
    longitude: -91.94304,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54874',
  },
  {
    city: 'Springbrook',
    county_fips: 55129,
    county_fips_all: '55129',
    county: 'Washburn',
    county_names_all: 'Washburn',
    county_weights: '{"55129": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 45.97405,
    longitude: -91.6948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54875',
  },
  {
    city: 'Stone Lake',
    county_fips: 55113,
    county_fips_all: '55113|55129',
    county: 'Sawyer',
    county_names_all: 'Sawyer|Washburn',
    county_weights: '{"55113": 60.55, "55129": 39.45}',
    density: 7.1,
    imprecise: false,
    latitude: 45.82811,
    longitude: -91.51439,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54876',
  },
  {
    city: 'Superior',
    county_fips: 55031,
    county_fips_all: '55031',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"55031": 100}',
    density: 70.5,
    imprecise: false,
    latitude: 46.59342,
    longitude: -92.12701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54880',
  },
  {
    city: 'Trego',
    county_fips: 55129,
    county_fips_all: '55129',
    county: 'Washburn',
    county_names_all: 'Washburn',
    county_weights: '{"55129": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 45.98046,
    longitude: -91.88803,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54888',
  },
  {
    city: 'Turtle Lake',
    county_fips: 55095,
    county_fips_all: '55095|55005',
    county: 'Polk',
    county_names_all: 'Polk|Barron',
    county_weights: '{"55095": 55.03, "55005": 44.97}',
    density: 14.9,
    imprecise: false,
    latitude: 45.41374,
    longitude: -92.17112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54889',
  },
  {
    city: 'Washburn',
    county_fips: 55007,
    county_fips_all: '55007',
    county: 'Bayfield',
    county_names_all: 'Bayfield',
    county_weights: '{"55007": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 46.69727,
    longitude: -90.9688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54891',
  },
  {
    city: 'Webster',
    county_fips: 55013,
    county_fips_all: '55013',
    county: 'Burnett',
    county_names_all: 'Burnett',
    county_weights: '{"55013": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 45.87094,
    longitude: -92.30837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54893',
  },
  {
    city: 'Weyerhaeuser',
    county_fips: 55107,
    county_fips_all: '55107',
    county: 'Rusk',
    county_names_all: 'Rusk',
    county_weights: '{"55107": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 45.44233,
    longitude: -91.44605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54895',
  },
  {
    city: 'Winter',
    county_fips: 55113,
    county_fips_all: '55113',
    county: 'Sawyer',
    county_names_all: 'Sawyer',
    county_weights: '{"55113": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 45.81178,
    longitude: -90.87888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54896',
  },
  {
    city: 'Oshkosh',
    county_fips: 55139,
    county_fips_all: '55139',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"55139": 100}',
    density: 865.4,
    imprecise: false,
    latitude: 44.06265,
    longitude: -88.53335,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54901',
  },
  {
    city: 'Oshkosh',
    county_fips: 55139,
    county_fips_all: '55139',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"55139": 100}',
    density: 245.3,
    imprecise: false,
    latitude: 43.94934,
    longitude: -88.53969,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54902',
  },
  {
    city: 'Oshkosh',
    county_fips: 55139,
    county_fips_all: '55139|55039',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Fond du Lac',
    county_weights: '{"55139": 99.54, "55039": 0.46}',
    density: 110.4,
    imprecise: false,
    latitude: 44.02346,
    longitude: -88.62592,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54904',
  },
  {
    city: 'Almond',
    county_fips: 55097,
    county_fips_all: '55097|55137',
    county: 'Portage',
    county_names_all: 'Portage|Waushara',
    county_weights: '{"55097": 82.52, "55137": 17.48}',
    density: 7.9,
    imprecise: false,
    latitude: 44.28575,
    longitude: -89.35343,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54909',
  },
  {
    city: 'Appleton',
    county_fips: 55087,
    county_fips_all: '55087',
    county: 'Outagamie',
    county_names_all: 'Outagamie',
    county_weights: '{"55087": 100}',
    density: 1159.9,
    imprecise: false,
    latitude: 44.28174,
    longitude: -88.38086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54911',
  },
  {
    city: 'Appleton',
    county_fips: 55087,
    county_fips_all: '55087',
    county: 'Outagamie',
    county_names_all: 'Outagamie',
    county_weights: '{"55087": 100}',
    density: 151.2,
    imprecise: false,
    latitude: 44.34145,
    longitude: -88.40136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54913',
  },
  {
    city: 'Appleton',
    county_fips: 55087,
    county_fips_all: '55087|55139',
    county: 'Outagamie',
    county_names_all: 'Outagamie|Winnebago',
    county_weights: '{"55087": 96.13, "55139": 3.87}',
    density: 639.6,
    imprecise: false,
    latitude: 44.26353,
    longitude: -88.48239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54914',
  },
  {
    city: 'Appleton',
    county_fips: 55015,
    county_fips_all: '55015|55087|55139',
    county: 'Calumet',
    county_names_all: 'Calumet|Outagamie|Winnebago',
    county_weights: '{"55015": 49.11, "55087": 45.09, "55139": 5.81}',
    density: 1138.9,
    imprecise: false,
    latitude: 44.24279,
    longitude: -88.35928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54915',
  },
  {
    city: 'Bancroft',
    county_fips: 55097,
    county_fips_all: '55097|55001',
    county: 'Portage',
    county_names_all: 'Portage|Adams',
    county_weights: '{"55097": 86.38, "55001": 13.62}',
    density: 6.6,
    imprecise: false,
    latitude: 44.30155,
    longitude: -89.57341,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54921',
  },
  {
    city: 'Bear Creek',
    county_fips: 55087,
    county_fips_all: '55087|55135',
    county: 'Outagamie',
    county_names_all: 'Outagamie|Waupaca',
    county_weights: '{"55087": 54.8, "55135": 45.2}',
    density: 9.2,
    imprecise: false,
    latitude: 44.54281,
    longitude: -88.74529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54922',
  },
  {
    city: 'Berlin',
    county_fips: 55137,
    county_fips_all: '55137|55047|55139',
    county: 'Waushara',
    county_names_all: 'Waushara|Green Lake|Winnebago',
    county_weights: '{"55137": 47.89, "55047": 43.73, "55139": 8.38}',
    density: 25,
    imprecise: false,
    latitude: 43.99456,
    longitude: -88.96883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54923',
  },
  {
    city: 'Big Falls',
    county_fips: 55135,
    county_fips_all: '55135',
    county: 'Waupaca',
    county_names_all: 'Waupaca',
    county_weights: '{"55135": 100}',
    density: 153,
    imprecise: false,
    latitude: 44.61553,
    longitude: -89.01823,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54926',
  },
  {
    city: 'Butte Des Morts',
    county_fips: 55139,
    county_fips_all: '55139',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"55139": 100}',
    density: 957.4,
    imprecise: false,
    latitude: 44.10192,
    longitude: -88.6548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54927',
  },
  {
    city: 'Caroline',
    county_fips: 55115,
    county_fips_all: '55115',
    county: 'Shawano',
    county_names_all: 'Shawano',
    county_weights: '{"55115": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 44.73894,
    longitude: -88.88546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54928',
  },
  {
    city: 'Clintonville',
    county_fips: 55135,
    county_fips_all: '55135|55115|55087',
    county: 'Waupaca',
    county_names_all: 'Waupaca|Shawano|Outagamie',
    county_weights: '{"55135": 72.29, "55115": 25.81, "55087": 1.9}',
    density: 27.7,
    imprecise: false,
    latitude: 44.63704,
    longitude: -88.7372,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54929',
  },
  {
    city: 'Coloma',
    county_fips: 55137,
    county_fips_all: '55137|55001|55077',
    county: 'Waushara',
    county_names_all: 'Waushara|Adams|Marquette',
    county_weights: '{"55137": 56.12, "55001": 40.96, "55077": 2.92}',
    density: 7.7,
    imprecise: false,
    latitude: 44.02884,
    longitude: -89.56383,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54930',
  },
  {
    city: 'Dale',
    county_fips: 55087,
    county_fips_all: '55087',
    county: 'Outagamie',
    county_names_all: 'Outagamie',
    county_weights: '{"55087": 100}',
    density: 280.7,
    imprecise: false,
    latitude: 44.2703,
    longitude: -88.66835,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54931',
  },
  {
    city: 'Eldorado',
    county_fips: 55039,
    county_fips_all: '55039',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac',
    county_weights: '{"55039": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 43.83143,
    longitude: -88.61861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54932',
  },
  {
    city: 'Embarrass',
    county_fips: 55135,
    county_fips_all: '55135',
    county: 'Waupaca',
    county_names_all: 'Waupaca',
    county_weights: '{"55135": 100}',
    density: 57.6,
    imprecise: false,
    latitude: 44.66535,
    longitude: -88.70966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54933',
  },
  {
    city: 'Fond Du Lac',
    county_fips: 55039,
    county_fips_all: '55039',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac',
    county_weights: '{"55039": 100}',
    density: 1030.4,
    imprecise: false,
    latitude: 43.77542,
    longitude: -88.43396,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54935',
  },
  {
    city: 'Fond Du Lac',
    county_fips: 55039,
    county_fips_all: '55039',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac',
    county_weights: '{"55039": 100}',
    density: 69.7,
    imprecise: false,
    latitude: 43.75959,
    longitude: -88.43335,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54937',
  },
  {
    city: 'Fremont',
    county_fips: 55139,
    county_fips_all: '55139|55135|55137|55087',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Waupaca|Waushara|Outagamie',
    county_weights:
      '{"55139": 30.34, "55135": 30.04, "55137": 29.92, "55087": 9.7}',
    density: 19.3,
    imprecise: false,
    latitude: 44.22696,
    longitude: -88.84446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54940',
  },
  {
    city: 'Green Lake',
    county_fips: 55047,
    county_fips_all: '55047',
    county: 'Green Lake',
    county_names_all: 'Green Lake',
    county_weights: '{"55047": 100}',
    density: 30.6,
    imprecise: false,
    latitude: 43.85067,
    longitude: -88.99103,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54941',
  },
  {
    city: 'Greenville',
    county_fips: 55087,
    county_fips_all: '55087',
    county: 'Outagamie',
    county_names_all: 'Outagamie',
    county_weights: '{"55087": 100}',
    density: 266.4,
    imprecise: false,
    latitude: 44.29904,
    longitude: -88.54265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54942',
  },
  {
    city: 'Hancock',
    county_fips: 55137,
    county_fips_all: '55137|55001',
    county: 'Waushara',
    county_names_all: 'Waushara|Adams',
    county_weights: '{"55137": 53.39, "55001": 46.61}',
    density: 7.2,
    imprecise: false,
    latitude: 44.12377,
    longitude: -89.58199,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54943',
  },
  {
    city: 'Hortonville',
    county_fips: 55087,
    county_fips_all: '55087',
    county: 'Outagamie',
    county_names_all: 'Outagamie',
    county_weights: '{"55087": 100}',
    density: 52.2,
    imprecise: false,
    latitude: 44.32409,
    longitude: -88.6274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54944',
  },
  {
    city: 'Iola',
    county_fips: 55135,
    county_fips_all: '55135|55097',
    county: 'Waupaca',
    county_names_all: 'Waupaca|Portage',
    county_weights: '{"55135": 98.49, "55097": 1.51}',
    density: 12.5,
    imprecise: false,
    latitude: 44.57604,
    longitude: -89.13739,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54945',
  },
  {
    city: 'King',
    county_fips: 55135,
    county_fips_all: '55135',
    county: 'Waupaca',
    county_names_all: 'Waupaca',
    county_weights: '{"55135": 100}',
    density: 2196.5,
    imprecise: false,
    latitude: 44.33704,
    longitude: -89.14503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54946',
  },
  {
    city: 'Larsen',
    county_fips: 55139,
    county_fips_all: '55139',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"55139": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 44.20003,
    longitude: -88.68995,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54947',
  },
  {
    city: 'Leopolis',
    county_fips: 55115,
    county_fips_all: '55115',
    county: 'Shawano',
    county_names_all: 'Shawano',
    county_weights: '{"55115": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 44.7774,
    longitude: -88.88823,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54948',
  },
  {
    city: 'Manawa',
    county_fips: 55135,
    county_fips_all: '55135',
    county: 'Waupaca',
    county_names_all: 'Waupaca',
    county_weights: '{"55135": 100}',
    density: 21,
    imprecise: false,
    latitude: 44.48561,
    longitude: -88.91416,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54949',
  },
  {
    city: 'Marion',
    county_fips: 55135,
    county_fips_all: '55135|55115',
    county: 'Waupaca',
    county_names_all: 'Waupaca|Shawano',
    county_weights: '{"55135": 67.7, "55115": 32.3}',
    density: 13.2,
    imprecise: false,
    latitude: 44.65408,
    longitude: -88.90614,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54950',
  },
  {
    city: 'Menasha',
    county_fips: 55015,
    county_fips_all: '55015|55139',
    county: 'Calumet',
    county_names_all: 'Calumet|Winnebago',
    county_weights: '{"55015": 71.79, "55139": 28.21}',
    density: 375.5,
    imprecise: false,
    latitude: 44.20086,
    longitude: -88.33719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54952',
  },
  {
    city: 'Neenah',
    county_fips: 55139,
    county_fips_all: '55139|55087',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Outagamie',
    county_weights: '{"55139": 96.53, "55087": 3.47}',
    density: 291.5,
    imprecise: false,
    latitude: 44.18444,
    longitude: -88.52778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54956',
  },
  {
    city: 'Neshkoro',
    county_fips: 55077,
    county_fips_all: '55077|55137|55047',
    county: 'Marquette',
    county_names_all: 'Marquette|Waushara|Green Lake',
    county_weights: '{"55077": 62.05, "55137": 19.23, "55047": 18.72}',
    density: 11.3,
    imprecise: false,
    latitude: 43.94569,
    longitude: -89.22386,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54960',
  },
  {
    city: 'New London',
    county_fips: 55135,
    county_fips_all: '55135|55087',
    county: 'Waupaca',
    county_names_all: 'Waupaca|Outagamie',
    county_weights: '{"55135": 64.13, "55087": 35.87}',
    density: 45.1,
    imprecise: false,
    latitude: 44.41173,
    longitude: -88.7628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54961',
  },
  {
    city: 'Ogdensburg',
    county_fips: 55135,
    county_fips_all: '55135',
    county: 'Waupaca',
    county_names_all: 'Waupaca',
    county_weights: '{"55135": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 44.48059,
    longitude: -89.02486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54962',
  },
  {
    city: 'Omro',
    county_fips: 55139,
    county_fips_all: '55139|55137',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Waushara',
    county_weights: '{"55139": 99.65, "55137": 0.35}',
    density: 36.9,
    imprecise: false,
    latitude: 44.04524,
    longitude: -88.76661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54963',
  },
  {
    city: 'Pickett',
    county_fips: 55139,
    county_fips_all: '55139|55039',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Fond du Lac',
    county_weights: '{"55139": 72.7, "55039": 27.3}',
    density: 10.9,
    imprecise: false,
    latitude: 43.9178,
    longitude: -88.71836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54964',
  },
  {
    city: 'Pine River',
    county_fips: 55137,
    county_fips_all: '55137|55135',
    county: 'Waushara',
    county_names_all: 'Waushara|Waupaca',
    county_weights: '{"55137": 98.69, "55135": 1.31}',
    density: 7.9,
    imprecise: false,
    latitude: 44.16429,
    longitude: -89.0324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54965',
  },
  {
    city: 'Plainfield',
    county_fips: 55137,
    county_fips_all: '55137|55097|55001',
    county: 'Waushara',
    county_names_all: 'Waushara|Portage|Adams',
    county_weights: '{"55137": 73.67, "55097": 18.85, "55001": 7.48}',
    density: 10.4,
    imprecise: false,
    latitude: 44.21276,
    longitude: -89.50579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54966',
  },
  {
    city: 'Poy Sippi',
    county_fips: 55137,
    county_fips_all: '55137',
    county: 'Waushara',
    county_names_all: 'Waushara',
    county_weights: '{"55137": 100}',
    density: 85.5,
    imprecise: false,
    latitude: 44.12954,
    longitude: -88.98487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54967',
  },
  {
    city: 'Princeton',
    county_fips: 55047,
    county_fips_all: '55047|55077',
    county: 'Green Lake',
    county_names_all: 'Green Lake|Marquette',
    county_weights: '{"55047": 81.88, "55077": 18.12}',
    density: 17.4,
    imprecise: false,
    latitude: 43.84872,
    longitude: -89.13255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54968',
  },
  {
    city: 'Redgranite',
    county_fips: 55137,
    county_fips_all: '55137',
    county: 'Waushara',
    county_names_all: 'Waushara',
    county_weights: '{"55137": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 44.07091,
    longitude: -89.09352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54970',
  },
  {
    city: 'Ripon',
    county_fips: 55039,
    county_fips_all: '55039|55139|55047',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac|Winnebago|Green Lake',
    county_weights: '{"55039": 57.52, "55139": 21.9, "55047": 20.58}',
    density: 38,
    imprecise: false,
    latitude: 43.85546,
    longitude: -88.83109,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54971',
  },
  {
    city: 'Rosendale',
    county_fips: 55039,
    county_fips_all: '55039',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac',
    county_weights: '{"55039": 100}',
    density: 20.7,
    imprecise: false,
    latitude: 43.7801,
    longitude: -88.65997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54974',
  },
  {
    city: 'Scandinavia',
    county_fips: 55135,
    county_fips_all: '55135|55097',
    county: 'Waupaca',
    county_names_all: 'Waupaca|Portage',
    county_weights: '{"55135": 88.17, "55097": 11.83}',
    density: 16.1,
    imprecise: false,
    latitude: 44.45696,
    longitude: -89.16471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54977',
  },
  {
    city: 'Tilleda',
    county_fips: 55115,
    county_fips_all: '55115',
    county: 'Shawano',
    county_names_all: 'Shawano',
    county_weights: '{"55115": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 44.79423,
    longitude: -88.91405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54978',
  },
  {
    city: 'Van Dyne',
    county_fips: 55039,
    county_fips_all: '55039|55139',
    county: 'Fond du Lac',
    county_names_all: 'Fond du Lac|Winnebago',
    county_weights: '{"55039": 95.68, "55139": 4.32}',
    density: 29.6,
    imprecise: false,
    latitude: 43.8688,
    longitude: -88.53875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54979',
  },
  {
    city: 'Waukau',
    county_fips: 55139,
    county_fips_all: '55139',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"55139": 100}',
    density: 241.4,
    imprecise: false,
    latitude: 43.98625,
    longitude: -88.76906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54980',
  },
  {
    city: 'Waupaca',
    county_fips: 55135,
    county_fips_all: '55135|55097|55137',
    county: 'Waupaca',
    county_names_all: 'Waupaca|Portage|Waushara',
    county_weights: '{"55135": 91.11, "55097": 4.91, "55137": 3.98}',
    density: 43.6,
    imprecise: false,
    latitude: 44.32733,
    longitude: -89.12558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54981',
  },
  {
    city: 'Wautoma',
    county_fips: 55137,
    county_fips_all: '55137|55077',
    county: 'Waushara',
    county_names_all: 'Waushara|Marquette',
    county_weights: '{"55137": 97.61, "55077": 2.39}',
    density: 21,
    imprecise: false,
    latitude: 44.07007,
    longitude: -89.29223,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54982',
  },
  {
    city: 'Weyauwega',
    county_fips: 55135,
    county_fips_all: '55135|55137',
    county: 'Waupaca',
    county_names_all: 'Waupaca|Waushara',
    county_weights: '{"55135": 93.09, "55137": 6.91}',
    density: 19.4,
    imprecise: false,
    latitude: 44.31651,
    longitude: -88.93614,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54983',
  },
  {
    city: 'Wild Rose',
    county_fips: 55137,
    county_fips_all: '55137|55097',
    county: 'Waushara',
    county_names_all: 'Waushara|Portage',
    county_weights: '{"55137": 97.18, "55097": 2.82}',
    density: 16.7,
    imprecise: false,
    latitude: 44.18728,
    longitude: -89.21967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54984',
  },
  {
    city: 'Winnebago',
    county_fips: 55139,
    county_fips_all: '55139',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"55139": 100}',
    density: 1070,
    imprecise: false,
    latitude: 44.07562,
    longitude: -88.51953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54985',
  },
  {
    city: 'Winneconne',
    county_fips: 55139,
    county_fips_all: '55139|55137',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Waushara',
    county_weights: '{"55139": 99.19, "55137": 0.81}',
    density: 71.7,
    imprecise: false,
    latitude: 44.11981,
    longitude: -88.75127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '54986',
  },
  {
    city: 'Afton',
    county_fips: 27163,
    county_fips_all: '27163',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"27163": 100}',
    density: 43.3,
    imprecise: false,
    latitude: 44.90138,
    longitude: -92.81969,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55001',
  },
  {
    city: 'Bayport',
    county_fips: 27163,
    county_fips_all: '27163',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"27163": 100}',
    density: 725.8,
    imprecise: false,
    latitude: 45.01183,
    longitude: -92.77883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55003',
  },
  {
    city: 'Bethel',
    county_fips: 27003,
    county_fips_all: '27003',
    county: 'Anoka',
    county_names_all: 'Anoka',
    county_weights: '{"27003": 100}',
    density: 89.2,
    imprecise: false,
    latitude: 45.39281,
    longitude: -93.21725,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55005',
  },
  {
    city: 'Braham',
    county_fips: 27065,
    county_fips_all: '27065|27059|27115|27025',
    county: 'Kanabec',
    county_names_all: 'Kanabec|Isanti|Pine|Chisago',
    county_weights:
      '{"27065": 38.18, "27059": 34.51, "27115": 19.61, "27025": 7.71}',
    density: 18.7,
    imprecise: false,
    latitude: 45.74002,
    longitude: -93.20504,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55006',
  },
  {
    city: 'Brook Park',
    county_fips: 27065,
    county_fips_all: '27065|27115',
    county: 'Kanabec',
    county_names_all: 'Kanabec|Pine',
    county_weights: '{"27065": 61.85, "27115": 38.15}',
    density: 7.2,
    imprecise: false,
    latitude: 45.97511,
    longitude: -93.12223,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55007',
  },
  {
    city: 'Cambridge',
    county_fips: 27059,
    county_fips_all: '27059|27025',
    county: 'Isanti',
    county_names_all: 'Isanti|Chisago',
    county_weights: '{"27059": 99.31, "27025": 0.69}',
    density: 64.4,
    imprecise: false,
    latitude: 45.57149,
    longitude: -93.26734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55008',
  },
  {
    city: 'Cannon Falls',
    county_fips: 27049,
    county_fips_all: '27049|27037',
    county: 'Goodhue',
    county_names_all: 'Goodhue|Dakota',
    county_weights: '{"27049": 81.65, "27037": 18.35}',
    density: 25.6,
    imprecise: false,
    latitude: 44.48378,
    longitude: -92.86686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55009',
  },
  {
    city: 'Cedar',
    county_fips: 27003,
    county_fips_all: '27003',
    county: 'Anoka',
    county_names_all: 'Anoka',
    county_weights: '{"27003": 100}',
    density: 96.6,
    imprecise: false,
    latitude: 45.34108,
    longitude: -93.2521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55011',
  },
  {
    city: 'Center City',
    county_fips: 27025,
    county_fips_all: '27025',
    county: 'Chisago',
    county_names_all: 'Chisago',
    county_weights: '{"27025": 100}',
    density: 34,
    imprecise: false,
    latitude: 45.44166,
    longitude: -92.78952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55012',
  },
  {
    city: 'Chisago City',
    county_fips: 27025,
    county_fips_all: '27025',
    county: 'Chisago',
    county_names_all: 'Chisago',
    county_weights: '{"27025": 100}',
    density: 98,
    imprecise: false,
    latitude: 45.35558,
    longitude: -92.89469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55013',
  },
  {
    city: 'Circle Pines',
    county_fips: 27003,
    county_fips_all: '27003',
    county: 'Anoka',
    county_names_all: 'Anoka',
    county_weights: '{"27003": 100}',
    density: 553.4,
    imprecise: false,
    latitude: 45.16802,
    longitude: -93.12431,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55014',
  },
  {
    city: 'Cottage Grove',
    county_fips: 27163,
    county_fips_all: '27163',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"27163": 100}',
    density: 521.9,
    imprecise: false,
    latitude: 44.8172,
    longitude: -92.93373,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55016',
  },
  {
    city: 'Dalbo',
    county_fips: 27059,
    county_fips_all: '27059',
    county: 'Isanti',
    county_names_all: 'Isanti',
    county_weights: '{"27059": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 45.67291,
    longitude: -93.4314,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55017',
  },
  {
    city: 'Dennison',
    county_fips: 27049,
    county_fips_all: '27049|27131',
    county: 'Goodhue',
    county_names_all: 'Goodhue|Rice',
    county_weights: '{"27049": 91.18, "27131": 8.82}',
    density: 8.4,
    imprecise: false,
    latitude: 44.41832,
    longitude: -92.98822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55018',
  },
  {
    city: 'Dundas',
    county_fips: 27131,
    county_fips_all: '27131',
    county: 'Rice',
    county_names_all: 'Rice',
    county_weights: '{"27131": 100}',
    density: 43.5,
    imprecise: false,
    latitude: 44.41318,
    longitude: -93.25016,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55019',
  },
  {
    city: 'Elko New Market',
    county_fips: 27139,
    county_fips_all: '27139',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"27139": 100}',
    density: 66.7,
    imprecise: false,
    latitude: 44.57707,
    longitude: -93.37387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55020',
  },
  {
    city: 'Faribault',
    county_fips: 27131,
    county_fips_all: '27131',
    county: 'Rice',
    county_names_all: 'Rice',
    county_weights: '{"27131": 100}',
    density: 67.4,
    imprecise: false,
    latitude: 44.2973,
    longitude: -93.27414,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55021',
  },
  {
    city: 'Farmington',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 169.2,
    imprecise: false,
    latitude: 44.62738,
    longitude: -93.13605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55024',
  },
  {
    city: 'Forest Lake',
    county_fips: 27003,
    county_fips_all: '27003|27163|27025',
    county: 'Anoka',
    county_names_all: 'Anoka|Washington|Chisago',
    county_weights: '{"27003": 52.25, "27163": 40.78, "27025": 6.97}',
    density: 129.7,
    imprecise: false,
    latitude: 45.26391,
    longitude: -93.0212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55025',
  },
  {
    city: 'Frontenac',
    county_fips: 27049,
    county_fips_all: '27049',
    county: 'Goodhue',
    county_names_all: 'Goodhue',
    county_weights: '{"27049": 100}',
    density: 50.7,
    imprecise: false,
    latitude: 44.52179,
    longitude: -92.3369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55026',
  },
  {
    city: 'Goodhue',
    county_fips: 27049,
    county_fips_all: '27049|27157',
    county: 'Goodhue',
    county_names_all: 'Goodhue|Wabasha',
    county_weights: '{"27049": 99.19, "27157": 0.81}',
    density: 9,
    imprecise: false,
    latitude: 44.40868,
    longitude: -92.62058,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55027',
  },
  {
    city: 'Grandy',
    county_fips: 27059,
    county_fips_all: '27059',
    county: 'Isanti',
    county_names_all: 'Isanti',
    county_weights: '{"27059": 100}',
    density: 46.7,
    imprecise: false,
    latitude: 45.63573,
    longitude: -93.20098,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55029',
  },
  {
    city: 'Grasston',
    county_fips: 27115,
    county_fips_all: '27115|27065',
    county: 'Pine',
    county_names_all: 'Pine|Kanabec',
    county_weights: '{"27115": 79.91, "27065": 20.09}',
    density: 16.9,
    imprecise: false,
    latitude: 45.83911,
    longitude: -93.11493,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55030',
  },
  {
    city: 'Hampton',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 44.60772,
    longitude: -92.96647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55031',
  },
  {
    city: 'Harris',
    county_fips: 27025,
    county_fips_all: '27025',
    county: 'Chisago',
    county_names_all: 'Chisago',
    county_weights: '{"27025": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 45.58851,
    longitude: -92.99279,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55032',
  },
  {
    city: 'Hastings',
    county_fips: 27037,
    county_fips_all: '27037|27163|27049',
    county: 'Dakota',
    county_names_all: 'Dakota|Washington|Goodhue',
    county_weights: '{"27037": 75.38, "27163": 21.47, "27049": 3.15}',
    density: 79.4,
    imprecise: false,
    latitude: 44.71139,
    longitude: -92.8585,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55033',
  },
  {
    city: 'Henriette',
    county_fips: 27115,
    county_fips_all: '27115',
    county: 'Pine',
    county_names_all: 'Pine',
    county_weights: '{"27115": 100}',
    density: 50.9,
    imprecise: false,
    latitude: 45.87114,
    longitude: -93.11999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55036',
  },
  {
    city: 'Hinckley',
    county_fips: 27115,
    county_fips_all: '27115|27065',
    county: 'Pine',
    county_names_all: 'Pine|Kanabec',
    county_weights: '{"27115": 92.98, "27065": 7.02}',
    density: 6.6,
    imprecise: false,
    latitude: 46.01071,
    longitude: -92.78934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55037',
  },
  {
    city: 'Hugo',
    county_fips: 27163,
    county_fips_all: '27163|27003|27123',
    county: 'Washington',
    county_names_all: 'Washington|Anoka|Ramsey',
    county_weights: '{"27163": 68.95, "27003": 30.73, "27123": 0.32}',
    density: 191.6,
    imprecise: false,
    latitude: 45.169,
    longitude: -92.98059,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55038',
  },
  {
    city: 'Isanti',
    county_fips: 27059,
    county_fips_all: '27059',
    county: 'Isanti',
    county_names_all: 'Isanti',
    county_weights: '{"27059": 100}',
    density: 58.4,
    imprecise: false,
    latitude: 45.4678,
    longitude: -93.27951,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55040',
  },
  {
    city: 'Lake City',
    county_fips: 27157,
    county_fips_all: '27157|27049',
    county: 'Wabasha',
    county_names_all: 'Wabasha|Goodhue',
    county_weights: '{"27157": 83.45, "27049": 16.55}',
    density: 20.1,
    imprecise: false,
    latitude: 44.39544,
    longitude: -92.31923,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55041',
  },
  {
    city: 'Lake Elmo',
    county_fips: 27163,
    county_fips_all: '27163',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"27163": 100}',
    density: 212.7,
    imprecise: false,
    latitude: 44.99253,
    longitude: -92.898,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55042',
  },
  {
    city: 'Lakeland',
    county_fips: 27163,
    county_fips_all: '27163',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"27163": 100}',
    density: 351.3,
    imprecise: false,
    latitude: 44.94064,
    longitude: -92.76902,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55043',
  },
  {
    city: 'Lakeville',
    county_fips: 27037,
    county_fips_all: '27037|27139',
    county: 'Dakota',
    county_names_all: 'Dakota|Scott',
    county_weights: '{"27037": 70.38, "27139": 29.62}',
    density: 383.1,
    imprecise: false,
    latitude: 44.64156,
    longitude: -93.27858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55044',
  },
  {
    city: 'Lindstrom',
    county_fips: 27025,
    county_fips_all: '27025',
    county: 'Chisago',
    county_names_all: 'Chisago',
    county_weights: '{"27025": 100}',
    density: 87,
    imprecise: false,
    latitude: 45.39777,
    longitude: -92.83074,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55045',
  },
  {
    city: 'Lonsdale',
    county_fips: 27131,
    county_fips_all: '27131',
    county: 'Rice',
    county_names_all: 'Rice',
    county_weights: '{"27131": 100}',
    density: 53.2,
    imprecise: false,
    latitude: 44.44629,
    longitude: -93.4162,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55046',
  },
  {
    city: 'Marine On Saint Croix',
    county_fips: 27163,
    county_fips_all: '27163',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"27163": 100}',
    density: 29.6,
    imprecise: false,
    latitude: 45.20553,
    longitude: -92.82137,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55047',
  },
  {
    city: 'Medford',
    county_fips: 27147,
    county_fips_all: '27147|27131',
    county: 'Steele',
    county_names_all: 'Steele|Rice',
    county_weights: '{"27147": 90.85, "27131": 9.15}',
    density: 22,
    imprecise: false,
    latitude: 44.17628,
    longitude: -93.24101,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55049',
  },
  {
    city: 'Mora',
    county_fips: 27065,
    county_fips_all: '27065|27095',
    county: 'Kanabec',
    county_names_all: 'Kanabec|Mille Lacs',
    county_weights: '{"27065": 86.48, "27095": 13.52}',
    density: 17.6,
    imprecise: false,
    latitude: 45.93818,
    longitude: -93.33201,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55051',
  },
  {
    city: 'Morristown',
    county_fips: 27131,
    county_fips_all: '27131|27161|27147',
    county: 'Rice',
    county_names_all: 'Rice|Waseca|Steele',
    county_weights: '{"27131": 84.91, "27161": 9.59, "27147": 5.5}',
    density: 18.2,
    imprecise: false,
    latitude: 44.23369,
    longitude: -93.4398,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55052',
  },
  {
    city: 'Nerstrand',
    county_fips: 27131,
    county_fips_all: '27131|27049',
    county: 'Rice',
    county_names_all: 'Rice|Goodhue',
    county_weights: '{"27131": 68.7, "27049": 31.3}',
    density: 7.8,
    imprecise: false,
    latitude: 44.34957,
    longitude: -93.06579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55053',
  },
  {
    city: 'Elko New Market',
    county_fips: 27139,
    county_fips_all: '27139',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"27139": 100}',
    density: 1067.6,
    imprecise: false,
    latitude: 44.57148,
    longitude: -93.35087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55054',
  },
  {
    city: 'Newport',
    county_fips: 27163,
    county_fips_all: '27163',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"27163": 100}',
    density: 506.6,
    imprecise: false,
    latitude: 44.87437,
    longitude: -92.99746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55055',
  },
  {
    city: 'North Branch',
    county_fips: 27025,
    county_fips_all: '27025|27059',
    county: 'Chisago',
    county_names_all: 'Chisago|Isanti',
    county_weights: '{"27025": 69.39, "27059": 30.61}',
    density: 57.2,
    imprecise: false,
    latitude: 45.50915,
    longitude: -92.9543,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55056',
  },
  {
    city: 'Northfield',
    county_fips: 27131,
    county_fips_all: '27131|27037|27049',
    county: 'Rice',
    county_names_all: 'Rice|Dakota|Goodhue',
    county_weights: '{"27131": 53.89, "27037": 45.88, "27049": 0.23}',
    density: 79.4,
    imprecise: false,
    latitude: 44.47281,
    longitude: -93.17939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55057',
  },
  {
    city: 'Owatonna',
    county_fips: 27147,
    county_fips_all: '27147',
    county: 'Steele',
    county_names_all: 'Steele',
    county_weights: '{"27147": 100}',
    density: 56.2,
    imprecise: false,
    latitude: 44.05966,
    longitude: -93.22639,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55060',
  },
  {
    city: 'Pine City',
    county_fips: 27115,
    county_fips_all: '27115',
    county: 'Pine',
    county_names_all: 'Pine',
    county_weights: '{"27115": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 45.83263,
    longitude: -92.90584,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55063',
  },
  {
    city: 'Randolph',
    county_fips: 27037,
    county_fips_all: '27037|27049',
    county: 'Dakota',
    county_names_all: 'Dakota|Goodhue',
    county_weights: '{"27037": 98.36, "27049": 1.64}',
    density: 14.5,
    imprecise: false,
    latitude: 44.54662,
    longitude: -93.01835,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55065',
  },
  {
    city: 'Red Wing',
    county_fips: 27049,
    county_fips_all: '27049',
    county: 'Goodhue',
    county_names_all: 'Goodhue',
    county_weights: '{"27049": 100}',
    density: 61.4,
    imprecise: false,
    latitude: 44.51581,
    longitude: -92.5441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55066',
  },
  {
    city: 'Rosemount',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 278.2,
    imprecise: false,
    latitude: 44.73555,
    longitude: -93.06876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55068',
  },
  {
    city: 'Rush City',
    county_fips: 27025,
    county_fips_all: '27025|27115',
    county: 'Chisago',
    county_names_all: 'Chisago|Pine',
    county_weights: '{"27025": 83.15, "27115": 16.85}',
    density: 30.4,
    imprecise: false,
    latitude: 45.6928,
    longitude: -92.96768,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55069',
  },
  {
    city: 'Saint Francis',
    county_fips: 27003,
    county_fips_all: '27003|27059',
    county: 'Anoka',
    county_names_all: 'Anoka|Isanti',
    county_weights: '{"27003": 63.78, "27059": 36.22}',
    density: 127.9,
    imprecise: false,
    latitude: 45.41413,
    longitude: -93.3849,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55070',
  },
  {
    city: 'Saint Paul Park',
    county_fips: 27163,
    county_fips_all: '27163',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"27163": 100}',
    density: 441.8,
    imprecise: false,
    latitude: 44.82257,
    longitude: -92.99677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55071',
  },
  {
    city: 'Sandstone',
    county_fips: 27115,
    county_fips_all: '27115|27065',
    county: 'Pine',
    county_names_all: 'Pine|Kanabec',
    county_weights: '{"27115": 94.04, "27065": 5.96}',
    density: 4.8,
    imprecise: false,
    latitude: 46.15118,
    longitude: -92.59274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55072',
  },
  {
    city: 'Scandia',
    county_fips: 27163,
    county_fips_all: '27163|27025',
    county: 'Washington',
    county_names_all: 'Washington|Chisago',
    county_weights: '{"27163": 86.47, "27025": 13.53}',
    density: 57.5,
    imprecise: false,
    latitude: 45.27363,
    longitude: -92.82783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55073',
  },
  {
    city: 'Shafer',
    county_fips: 27025,
    county_fips_all: '27025',
    county: 'Chisago',
    county_names_all: 'Chisago',
    county_weights: '{"27025": 100}',
    density: 26.9,
    imprecise: false,
    latitude: 45.38351,
    longitude: -92.73292,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55074',
  },
  {
    city: 'South Saint Paul',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 1430.7,
    imprecise: false,
    latitude: 44.88794,
    longitude: -93.0411,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55075',
  },
  {
    city: 'Inver Grove Heights',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 831.8,
    imprecise: false,
    latitude: 44.83318,
    longitude: -93.0334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55076',
  },
  {
    city: 'Inver Grove Heights',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 308.5,
    imprecise: false,
    latitude: 44.81989,
    longitude: -93.07574,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55077',
  },
  {
    city: 'Stacy',
    county_fips: 27025,
    county_fips_all: '27025|27059|27003',
    county: 'Chisago',
    county_names_all: 'Chisago|Isanti|Anoka',
    county_weights: '{"27025": 42.59, "27059": 30.71, "27003": 26.7}',
    density: 51.6,
    imprecise: false,
    latitude: 45.41385,
    longitude: -93.03117,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55079',
  },
  {
    city: 'Stanchfield',
    county_fips: 27059,
    county_fips_all: '27059|27025',
    county: 'Isanti',
    county_names_all: 'Isanti|Chisago',
    county_weights: '{"27059": 75.36, "27025": 24.64}',
    density: 17.9,
    imprecise: false,
    latitude: 45.66322,
    longitude: -93.21881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55080',
  },
  {
    city: 'Stillwater',
    county_fips: 27163,
    county_fips_all: '27163',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"27163": 100}',
    density: 176.8,
    imprecise: false,
    latitude: 45.07446,
    longitude: -92.84006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55082',
  },
  {
    city: 'Taylors Falls',
    county_fips: 27025,
    county_fips_all: '27025',
    county: 'Chisago',
    county_names_all: 'Chisago',
    county_weights: '{"27025": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 45.46029,
    longitude: -92.70747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55084',
  },
  {
    city: 'Vermillion',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 155.8,
    imprecise: false,
    latitude: 44.6731,
    longitude: -92.96432,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55085',
  },
  {
    city: 'Warsaw',
    county_fips: 27131,
    county_fips_all: '27131',
    county: 'Rice',
    county_names_all: 'Rice',
    county_weights: '{"27131": 100}',
    density: 114.2,
    imprecise: false,
    latitude: 44.23894,
    longitude: -93.40614,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55087',
  },
  {
    city: 'Webster',
    county_fips: 27131,
    county_fips_all: '27131|27139',
    county: 'Rice',
    county_names_all: 'Rice|Scott',
    county_weights: '{"27131": 75.5, "27139": 24.5}',
    density: 19,
    imprecise: false,
    latitude: 44.52945,
    longitude: -93.38479,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55088',
  },
  {
    city: 'Welch',
    county_fips: 27049,
    county_fips_all: '27049|27037',
    county: 'Goodhue',
    county_names_all: 'Goodhue|Dakota',
    county_weights: '{"27049": 97.24, "27037": 2.76}',
    density: 9.3,
    imprecise: false,
    latitude: 44.59296,
    longitude: -92.70223,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55089',
  },
  {
    city: 'Willernie',
    county_fips: 27163,
    county_fips_all: '27163',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"27163": 100}',
    density: 1361.3,
    imprecise: false,
    latitude: 45.05382,
    longitude: -92.9573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55090',
  },
  {
    city: 'Wyoming',
    county_fips: 27003,
    county_fips_all: '27003|27025',
    county: 'Anoka',
    county_names_all: 'Anoka|Chisago',
    county_weights: '{"27003": 67.16, "27025": 32.84}',
    density: 128.6,
    imprecise: false,
    latitude: 45.33647,
    longitude: -93.07214,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55092',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 3926.3,
    imprecise: false,
    latitude: 44.95111,
    longitude: -93.08739,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55101',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 2308.6,
    imprecise: false,
    latitude: 44.93216,
    longitude: -93.12149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55102',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 2567.7,
    imprecise: false,
    latitude: 44.96399,
    longitude: -93.12418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55103',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 2927.9,
    imprecise: false,
    latitude: 44.95423,
    longitude: -93.16283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55104',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 3158.2,
    imprecise: false,
    latitude: 44.93465,
    longitude: -93.16689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55105',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 2324,
    imprecise: false,
    latitude: 44.95743,
    longitude: -93.04679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55106',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 1445,
    imprecise: false,
    latitude: 44.93105,
    longitude: -93.07945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55107',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 1470.7,
    imprecise: false,
    latitude: 44.98095,
    longitude: -93.1749,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55108',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 1105.8,
    imprecise: false,
    latitude: 45.0144,
    longitude: -93.02616,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55109',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123|27163|27003',
    county: 'Ramsey',
    county_names_all: 'Ramsey|Washington|Anoka',
    county_weights: '{"27123": 63.48, "27163": 32.71, "27003": 3.81}',
    density: 582.4,
    imprecise: false,
    latitude: 45.08961,
    longitude: -93.00418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55110',
  },
  {
    city: 'Saint Paul',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 39.3,
    imprecise: false,
    latitude: 44.885,
    longitude: -93.19518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55111',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 1002.6,
    imprecise: false,
    latitude: 45.07443,
    longitude: -93.19169,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55112',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 1061.7,
    imprecise: false,
    latitude: 45.01295,
    longitude: -93.15512,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55113',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 1469.7,
    imprecise: false,
    latitude: 44.9662,
    longitude: -93.19407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55114',
  },
  {
    city: 'Saint Paul',
    county_fips: 27163,
    county_fips_all: '27163',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"27163": 100}',
    density: 567.4,
    imprecise: false,
    latitude: 45.06675,
    longitude: -92.95087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55115',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 1809.4,
    imprecise: false,
    latitude: 44.91001,
    longitude: -93.17033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55116',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 1884.7,
    imprecise: false,
    latitude: 44.99918,
    longitude: -93.09713,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55117',
  },
  {
    city: 'Saint Paul',
    county_fips: 27037,
    county_fips_all: '27037|27123',
    county: 'Dakota',
    county_names_all: 'Dakota|Ramsey',
    county_weights: '{"27037": 99.87, "27123": 0.13}',
    density: 1090.6,
    imprecise: false,
    latitude: 44.8968,
    longitude: -93.10365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55118',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 1303,
    imprecise: false,
    latitude: 44.93972,
    longitude: -93.0066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55119',
  },
  {
    city: 'Saint Paul',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 361.2,
    imprecise: false,
    latitude: 44.87259,
    longitude: -93.14881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55120',
  },
  {
    city: 'Saint Paul',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 369.5,
    imprecise: false,
    latitude: 44.84591,
    longitude: -93.15932,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55121',
  },
  {
    city: 'Saint Paul',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 1156.9,
    imprecise: false,
    latitude: 44.80326,
    longitude: -93.1962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55122',
  },
  {
    city: 'Saint Paul',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 950.5,
    imprecise: false,
    latitude: 44.8043,
    longitude: -93.13699,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55123',
  },
  {
    city: 'Saint Paul',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 1274.3,
    imprecise: false,
    latitude: 44.74566,
    longitude: -93.20042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55124',
  },
  {
    city: 'Saint Paul',
    county_fips: 27163,
    county_fips_all: '27163',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"27163": 100}',
    density: 1111.5,
    imprecise: false,
    latitude: 44.91998,
    longitude: -92.94388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55125',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123|27003',
    county: 'Ramsey',
    county_names_all: 'Ramsey|Anoka',
    county_weights: '{"27123": 96.82, "27003": 3.18}',
    density: 773.2,
    imprecise: false,
    latitude: 45.08614,
    longitude: -93.13581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55126',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 518.7,
    imprecise: false,
    latitude: 45.08394,
    longitude: -93.08243,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55127',
  },
  {
    city: 'Saint Paul',
    county_fips: 27163,
    county_fips_all: '27163',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"27163": 100}',
    density: 1010.3,
    imprecise: false,
    latitude: 44.98812,
    longitude: -92.96405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55128',
  },
  {
    city: 'Saint Paul',
    county_fips: 27163,
    county_fips_all: '27163',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"27163": 100}',
    density: 674.7,
    imprecise: false,
    latitude: 44.89422,
    longitude: -92.90638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55129',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 3399.2,
    imprecise: false,
    latitude: 44.97315,
    longitude: -93.08241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55130',
  },
  {
    city: 'Mendota',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 258.1,
    imprecise: false,
    latitude: 44.88717,
    longitude: -93.16157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55150',
  },
  {
    city: 'Albertville',
    county_fips: 27171,
    county_fips_all: '27171',
    county: 'Wright',
    county_names_all: 'Wright',
    county_weights: '{"27171": 100}',
    density: 636.7,
    imprecise: false,
    latitude: 45.24448,
    longitude: -93.66219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55301',
  },
  {
    city: 'Annandale',
    county_fips: 27171,
    county_fips_all: '27171',
    county: 'Wright',
    county_names_all: 'Wright',
    county_weights: '{"27171": 100}',
    density: 41.7,
    imprecise: false,
    latitude: 45.24464,
    longitude: -94.11638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55302',
  },
  {
    city: 'Anoka',
    county_fips: 27003,
    county_fips_all: '27003',
    county: 'Anoka',
    county_names_all: 'Anoka',
    county_weights: '{"27003": 100}',
    density: 315.6,
    imprecise: false,
    latitude: 45.28872,
    longitude: -93.42333,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55303',
  },
  {
    city: 'Andover',
    county_fips: 27003,
    county_fips_all: '27003',
    county: 'Anoka',
    county_names_all: 'Anoka',
    county_weights: '{"27003": 100}',
    density: 279.9,
    imprecise: false,
    latitude: 45.25583,
    longitude: -93.26455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55304',
  },
  {
    city: 'Hopkins',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 873.7,
    imprecise: false,
    latitude: 44.95477,
    longitude: -93.43229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55305',
  },
  {
    city: 'Burnsville',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 1044.7,
    imprecise: false,
    latitude: 44.73071,
    longitude: -93.29195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55306',
  },
  {
    city: 'Arlington',
    county_fips: 27143,
    county_fips_all: '27143',
    county: 'Sibley',
    county_names_all: 'Sibley',
    county_weights: '{"27143": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 44.59871,
    longitude: -94.10475,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55307',
  },
  {
    city: 'Becker',
    county_fips: 27141,
    county_fips_all: '27141',
    county: 'Sherburne',
    county_names_all: 'Sherburne',
    county_weights: '{"27141": 100}',
    density: 65.9,
    imprecise: false,
    latitude: 45.42944,
    longitude: -93.83561,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55308',
  },
  {
    city: 'Big Lake',
    county_fips: 27141,
    county_fips_all: '27141',
    county: 'Sherburne',
    county_names_all: 'Sherburne',
    county_weights: '{"27141": 100}',
    density: 132.5,
    imprecise: false,
    latitude: 45.37758,
    longitude: -93.74107,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55309',
  },
  {
    city: 'Bird Island',
    county_fips: 27129,
    county_fips_all: '27129',
    county: 'Renville',
    county_names_all: 'Renville',
    county_weights: '{"27129": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 44.75599,
    longitude: -94.87624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55310',
  },
  {
    city: 'Maple Grove',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 904.2,
    imprecise: false,
    latitude: 45.1052,
    longitude: -93.49495,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55311',
  },
  {
    city: 'Brownton',
    county_fips: 27085,
    county_fips_all: '27085|27143',
    county: 'McLeod',
    county_names_all: 'McLeod|Sibley',
    county_weights: '{"27085": 99.26, "27143": 0.74}',
    density: 7.5,
    imprecise: false,
    latitude: 44.70853,
    longitude: -94.34489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55312',
  },
  {
    city: 'Buffalo',
    county_fips: 27171,
    county_fips_all: '27171|27053',
    county: 'Wright',
    county_names_all: 'Wright|Hennepin',
    county_weights: '{"27171": 99.9, "27053": 0.1}',
    density: 89.3,
    imprecise: false,
    latitude: 45.17382,
    longitude: -93.84859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55313',
  },
  {
    city: 'Buffalo Lake',
    county_fips: 27129,
    county_fips_all: '27129|27143',
    county: 'Renville',
    county_names_all: 'Renville|Sibley',
    county_weights: '{"27129": 75.62, "27143": 24.38}',
    density: 6.3,
    imprecise: false,
    latitude: 44.77214,
    longitude: -94.6,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55314',
  },
  {
    city: 'Carver',
    county_fips: 27019,
    county_fips_all: '27019|27139',
    county: 'Carver',
    county_names_all: 'Carver|Scott',
    county_weights: '{"27019": 99.67, "27139": 0.33}',
    density: 100.6,
    imprecise: false,
    latitude: 44.71731,
    longitude: -93.68347,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55315',
  },
  {
    city: 'Champlin',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1103.4,
    imprecise: false,
    latitude: 45.17021,
    longitude: -93.39032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55316',
  },
  {
    city: 'Chanhassen',
    county_fips: 27019,
    county_fips_all: '27019|27053',
    county: 'Carver',
    county_names_all: 'Carver|Hennepin',
    county_weights: '{"27019": 98.36, "27053": 1.64}',
    density: 654.8,
    imprecise: false,
    latitude: 44.85711,
    longitude: -93.55096,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55317',
  },
  {
    city: 'Chaska',
    county_fips: 27019,
    county_fips_all: '27019',
    county: 'Carver',
    county_names_all: 'Carver',
    county_weights: '{"27019": 100}',
    density: 293.7,
    imprecise: false,
    latitude: 44.81169,
    longitude: -93.63703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55318',
  },
  {
    city: 'Clear Lake',
    county_fips: 27141,
    county_fips_all: '27141',
    county: 'Sherburne',
    county_names_all: 'Sherburne',
    county_weights: '{"27141": 100}',
    density: 28.1,
    imprecise: false,
    latitude: 45.47181,
    longitude: -93.94359,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55319',
  },
  {
    city: 'Clearwater',
    county_fips: 27145,
    county_fips_all: '27145|27171|27141',
    county: 'Stearns',
    county_names_all: 'Stearns|Wright|Sherburne',
    county_weights: '{"27145": 58.61, "27171": 41.2, "27141": 0.19}',
    density: 47.5,
    imprecise: false,
    latitude: 45.39613,
    longitude: -94.08366,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55320',
  },
  {
    city: 'Cokato',
    county_fips: 27171,
    county_fips_all: '27171',
    county: 'Wright',
    county_names_all: 'Wright',
    county_weights: '{"27171": 100}',
    density: 26.9,
    imprecise: false,
    latitude: 45.08406,
    longitude: -94.193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55321',
  },
  {
    city: 'Cologne',
    county_fips: 27019,
    county_fips_all: '27019',
    county: 'Carver',
    county_names_all: 'Carver',
    county_weights: '{"27019": 100}',
    density: 25.5,
    imprecise: false,
    latitude: 44.77006,
    longitude: -93.7861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55322',
  },
  {
    city: 'Darwin',
    county_fips: 27093,
    county_fips_all: '27093',
    county: 'Meeker',
    county_names_all: 'Meeker',
    county_weights: '{"27093": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 45.05676,
    longitude: -94.42554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55324',
  },
  {
    city: 'Dassel',
    county_fips: 27093,
    county_fips_all: '27093',
    county: 'Meeker',
    county_names_all: 'Meeker',
    county_weights: '{"27093": 100}',
    density: 24.2,
    imprecise: false,
    latitude: 45.08432,
    longitude: -94.32031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55325',
  },
  {
    city: 'Dayton',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 132.2,
    imprecise: false,
    latitude: 45.19922,
    longitude: -93.4753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55327',
  },
  {
    city: 'Delano',
    county_fips: 27171,
    county_fips_all: '27171|27019|27053',
    county: 'Wright',
    county_names_all: 'Wright|Carver|Hennepin',
    county_weights: '{"27171": 86.34, "27019": 6.84, "27053": 6.82}',
    density: 86.2,
    imprecise: false,
    latitude: 45.03246,
    longitude: -93.80981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55328',
  },
  {
    city: 'Eden Valley',
    county_fips: 27093,
    county_fips_all: '27093|27145',
    county: 'Meeker',
    county_names_all: 'Meeker|Stearns',
    county_weights: '{"27093": 68.41, "27145": 31.59}',
    density: 17,
    imprecise: false,
    latitude: 45.30798,
    longitude: -94.57039,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55329',
  },
  {
    city: 'Elk River',
    county_fips: 27141,
    county_fips_all: '27141|27003|27171',
    county: 'Sherburne',
    county_names_all: 'Sherburne|Anoka|Wright',
    county_weights: '{"27141": 61.97, "27003": 21.21, "27171": 16.82}',
    density: 165.6,
    imprecise: false,
    latitude: 45.33359,
    longitude: -93.5679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55330',
  },
  {
    city: 'Excelsior',
    county_fips: 27053,
    county_fips_all: '27053|27019',
    county: 'Hennepin',
    county_names_all: 'Hennepin|Carver',
    county_weights: '{"27053": 71.48, "27019": 28.52}',
    density: 468.6,
    imprecise: false,
    latitude: 44.90124,
    longitude: -93.60832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55331',
  },
  {
    city: 'Fairfax',
    county_fips: 27129,
    county_fips_all: '27129|27103|27143',
    county: 'Renville',
    county_names_all: 'Renville|Nicollet|Sibley',
    county_weights: '{"27129": 81.85, "27103": 16.58, "27143": 1.57}',
    density: 5.6,
    imprecise: false,
    latitude: 44.51852,
    longitude: -94.70761,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55332',
  },
  {
    city: 'Franklin',
    county_fips: 27129,
    county_fips_all: '27129|27015|27127',
    county: 'Renville',
    county_names_all: 'Renville|Brown|Redwood',
    county_weights: '{"27129": 91.74, "27015": 4.36, "27127": 3.9}',
    density: 3.9,
    imprecise: false,
    latitude: 44.55987,
    longitude: -94.86593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55333',
  },
  {
    city: 'Gaylord',
    county_fips: 27143,
    county_fips_all: '27143|27103|27085',
    county: 'Sibley',
    county_names_all: 'Sibley|Nicollet|McLeod',
    county_weights: '{"27143": 87.92, "27103": 11.4, "27085": 0.68}',
    density: 12.4,
    imprecise: false,
    latitude: 44.53578,
    longitude: -94.20772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55334',
  },
  {
    city: 'Gibbon',
    county_fips: 27143,
    county_fips_all: '27143|27103',
    county: 'Sibley',
    county_names_all: 'Sibley|Nicollet',
    county_weights: '{"27143": 83.71, "27103": 16.29}',
    density: 5.8,
    imprecise: false,
    latitude: 44.52969,
    longitude: -94.54621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55335',
  },
  {
    city: 'Glencoe',
    county_fips: 27085,
    county_fips_all: '27085|27143',
    county: 'McLeod',
    county_names_all: 'McLeod|Sibley',
    county_weights: '{"27085": 79.46, "27143": 20.54}',
    density: 23.6,
    imprecise: false,
    latitude: 44.76627,
    longitude: -94.17803,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55336',
  },
  {
    city: 'Burnsville',
    county_fips: 27037,
    county_fips_all: '27037',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"27037": 100}',
    density: 982.6,
    imprecise: false,
    latitude: 44.77673,
    longitude: -93.27491,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55337',
  },
  {
    city: 'Green Isle',
    county_fips: 27143,
    county_fips_all: '27143',
    county: 'Sibley',
    county_names_all: 'Sibley',
    county_weights: '{"27143": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 44.66996,
    longitude: -93.99688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55338',
  },
  {
    city: 'Hamburg',
    county_fips: 27019,
    county_fips_all: '27019|27143|27085',
    county: 'Carver',
    county_names_all: 'Carver|Sibley|McLeod',
    county_weights: '{"27019": 65.35, "27143": 30.73, "27085": 3.92}',
    density: 15.9,
    imprecise: false,
    latitude: 44.7289,
    longitude: -93.95905,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55339',
  },
  {
    city: 'Hamel',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 110.3,
    imprecise: false,
    latitude: 45.07761,
    longitude: -93.57508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55340',
  },
  {
    city: 'Hanover',
    county_fips: 27171,
    county_fips_all: '27171|27053',
    county: 'Wright',
    county_names_all: 'Wright|Hennepin',
    county_weights: '{"27171": 57.56, "27053": 42.44}',
    density: 283.4,
    imprecise: false,
    latitude: 45.15917,
    longitude: -93.65913,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55341',
  },
  {
    city: 'Hector',
    county_fips: 27129,
    county_fips_all: '27129|27093',
    county: 'Renville',
    county_names_all: 'Renville|Meeker',
    county_weights: '{"27129": 99.73, "27093": 0.27}',
    density: 4.7,
    imprecise: false,
    latitude: 44.74152,
    longitude: -94.72982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55342',
  },
  {
    city: 'Hopkins',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1359.6,
    imprecise: false,
    latitude: 44.91433,
    longitude: -93.41568,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55343',
  },
  {
    city: 'Eden Prairie',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 611.6,
    imprecise: false,
    latitude: 44.86452,
    longitude: -93.43037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55344',
  },
  {
    city: 'Minnetonka',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 706.1,
    imprecise: false,
    latitude: 44.91526,
    longitude: -93.4838,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55345',
  },
  {
    city: 'Eden Prairie',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1061.4,
    imprecise: false,
    latitude: 44.87882,
    longitude: -93.48157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55346',
  },
  {
    city: 'Eden Prairie',
    county_fips: 27053,
    county_fips_all: '27053|27139',
    county: 'Hennepin',
    county_names_all: 'Hennepin|Scott',
    county_weights: '{"27053": 99.67, "27139": 0.33}',
    density: 696.7,
    imprecise: false,
    latitude: 44.82931,
    longitude: -93.46638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55347',
  },
  {
    city: 'Howard Lake',
    county_fips: 27171,
    county_fips_all: '27171',
    county: 'Wright',
    county_names_all: 'Wright',
    county_weights: '{"27171": 100}',
    density: 22,
    imprecise: false,
    latitude: 45.06238,
    longitude: -94.07438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55349',
  },
  {
    city: 'Hutchinson',
    county_fips: 27085,
    county_fips_all: '27085|27093|27129',
    county: 'McLeod',
    county_names_all: 'McLeod|Meeker|Renville',
    county_weights: '{"27085": 86.48, "27093": 11.43, "27129": 2.09}',
    density: 44.9,
    imprecise: false,
    latitude: 44.89743,
    longitude: -94.39195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55350',
  },
  {
    city: 'Jordan',
    county_fips: 27139,
    county_fips_all: '27139|27019',
    county: 'Scott',
    county_names_all: 'Scott|Carver',
    county_weights: '{"27139": 99.85, "27019": 0.15}',
    density: 60.1,
    imprecise: false,
    latitude: 44.65505,
    longitude: -93.5862,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55352',
  },
  {
    city: 'Kimball',
    county_fips: 27145,
    county_fips_all: '27145|27093',
    county: 'Stearns',
    county_names_all: 'Stearns|Meeker',
    county_weights: '{"27145": 67.05, "27093": 32.95}',
    density: 16,
    imprecise: false,
    latitude: 45.32034,
    longitude: -94.31607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55353',
  },
  {
    city: 'Lester Prairie',
    county_fips: 27085,
    county_fips_all: '27085',
    county: 'McLeod',
    county_names_all: 'McLeod',
    county_weights: '{"27085": 100}',
    density: 37.6,
    imprecise: false,
    latitude: 44.88466,
    longitude: -94.0701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55354',
  },
  {
    city: 'Litchfield',
    county_fips: 27093,
    county_fips_all: '27093',
    county: 'Meeker',
    county_names_all: 'Meeker',
    county_weights: '{"27093": 100}',
    density: 21.7,
    imprecise: false,
    latitude: 45.09709,
    longitude: -94.54017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55355',
  },
  {
    city: 'Long Lake',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 168.5,
    imprecise: false,
    latitude: 44.99565,
    longitude: -93.58628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55356',
  },
  {
    city: 'Loretto',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 67.6,
    imprecise: false,
    latitude: 45.09906,
    longitude: -93.65913,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55357',
  },
  {
    city: 'Maple Lake',
    county_fips: 27171,
    county_fips_all: '27171',
    county: 'Wright',
    county_names_all: 'Wright',
    county_weights: '{"27171": 100}',
    density: 35.8,
    imprecise: false,
    latitude: 45.24637,
    longitude: -94.00049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55358',
  },
  {
    city: 'Maple Plain',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 63.2,
    imprecise: false,
    latitude: 45.00464,
    longitude: -93.70112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55359',
  },
  {
    city: 'Mayer',
    county_fips: 27019,
    county_fips_all: '27019',
    county: 'Carver',
    county_names_all: 'Carver',
    county_weights: '{"27019": 100}',
    density: 42.1,
    imprecise: false,
    latitude: 44.91331,
    longitude: -93.92065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55360',
  },
  {
    city: 'Monticello',
    county_fips: 27171,
    county_fips_all: '27171',
    county: 'Wright',
    county_names_all: 'Wright',
    county_weights: '{"27171": 100}',
    density: 122.2,
    imprecise: false,
    latitude: 45.30099,
    longitude: -93.83563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55362',
  },
  {
    city: 'Montrose',
    county_fips: 27171,
    county_fips_all: '27171|27019',
    county: 'Wright',
    county_names_all: 'Wright|Carver',
    county_weights: '{"27171": 99.12, "27019": 0.88}',
    density: 80.2,
    imprecise: false,
    latitude: 45.04385,
    longitude: -93.91352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55363',
  },
  {
    city: 'Mound',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 358.7,
    imprecise: false,
    latitude: 44.93974,
    longitude: -93.67486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55364',
  },
  {
    city: 'New Auburn',
    county_fips: 27143,
    county_fips_all: '27143',
    county: 'Sibley',
    county_names_all: 'Sibley',
    county_weights: '{"27143": 100}',
    density: 342,
    imprecise: false,
    latitude: 44.67233,
    longitude: -94.2346,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55366',
  },
  {
    city: 'New Germany',
    county_fips: 27019,
    county_fips_all: '27019',
    county: 'Carver',
    county_names_all: 'Carver',
    county_weights: '{"27019": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 44.89142,
    longitude: -93.97499,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55367',
  },
  {
    city: 'Norwood Young America',
    county_fips: 27019,
    county_fips_all: '27019',
    county: 'Carver',
    county_names_all: 'Carver',
    county_weights: '{"27019": 100}',
    density: 20.1,
    imprecise: false,
    latitude: 44.7458,
    longitude: -93.89679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55368',
  },
  {
    city: 'Osseo',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 612.9,
    imprecise: false,
    latitude: 45.12834,
    longitude: -93.44837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55369',
  },
  {
    city: 'Plato',
    county_fips: 27085,
    county_fips_all: '27085',
    county: 'McLeod',
    county_names_all: 'McLeod',
    county_weights: '{"27085": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 44.78077,
    longitude: -94.03892,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55370',
  },
  {
    city: 'Princeton',
    county_fips: 27095,
    county_fips_all: '27095|27141|27059|27009',
    county: 'Mille Lacs',
    county_names_all: 'Mille Lacs|Sherburne|Isanti|Benton',
    county_weights:
      '{"27095": 41.02, "27141": 29.64, "27059": 27.09, "27009": 2.24}',
    density: 35.7,
    imprecise: false,
    latitude: 45.57677,
    longitude: -93.59581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55371',
  },
  {
    city: 'Prior Lake',
    county_fips: 27139,
    county_fips_all: '27139',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"27139": 100}',
    density: 229.5,
    imprecise: false,
    latitude: 44.67791,
    longitude: -93.41237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55372',
  },
  {
    city: 'Rockford',
    county_fips: 27053,
    county_fips_all: '27053|27171',
    county: 'Hennepin',
    county_names_all: 'Hennepin|Wright',
    county_weights: '{"27053": 76.78, "27171": 23.22}',
    density: 210.4,
    imprecise: false,
    latitude: 45.08779,
    longitude: -93.72282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55373',
  },
  {
    city: 'Rogers',
    county_fips: 27053,
    county_fips_all: '27053|27171',
    county: 'Hennepin',
    county_names_all: 'Hennepin|Wright',
    county_weights: '{"27053": 95.36, "27171": 4.64}',
    density: 187.9,
    imprecise: false,
    latitude: 45.17715,
    longitude: -93.58035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55374',
  },
  {
    city: 'Saint Bonifacius',
    county_fips: 27053,
    county_fips_all: '27053|27019',
    county: 'Hennepin',
    county_names_all: 'Hennepin|Carver',
    county_weights: '{"27053": 62.04, "27019": 37.96}',
    density: 324.7,
    imprecise: false,
    latitude: 44.89475,
    longitude: -93.73129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55375',
  },
  {
    city: 'Saint Michael',
    county_fips: 27171,
    county_fips_all: '27171',
    county: 'Wright',
    county_names_all: 'Wright',
    county_weights: '{"27171": 100}',
    density: 265.5,
    imprecise: false,
    latitude: 45.21161,
    longitude: -93.68508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55376',
  },
  {
    city: 'Savage',
    county_fips: 27139,
    county_fips_all: '27139',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"27139": 100}',
    density: 867,
    imprecise: false,
    latitude: 44.75685,
    longitude: -93.36209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55378',
  },
  {
    city: 'Shakopee',
    county_fips: 27139,
    county_fips_all: '27139',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"27139": 100}',
    density: 333.8,
    imprecise: false,
    latitude: 44.75492,
    longitude: -93.51713,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55379',
  },
  {
    city: 'Silver Lake',
    county_fips: 27085,
    county_fips_all: '27085',
    county: 'McLeod',
    county_names_all: 'McLeod',
    county_weights: '{"27085": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 44.92763,
    longitude: -94.18623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55381',
  },
  {
    city: 'South Haven',
    county_fips: 27145,
    county_fips_all: '27145|27171|27093',
    county: 'Stearns',
    county_names_all: 'Stearns|Wright|Meeker',
    county_weights: '{"27145": 49.45, "27171": 37.63, "27093": 12.93}',
    density: 18.7,
    imprecise: false,
    latitude: 45.30521,
    longitude: -94.20438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55382',
  },
  {
    city: 'Spring Park',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 2073.5,
    imprecise: false,
    latitude: 44.9364,
    longitude: -93.63201,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55384',
  },
  {
    city: 'Stewart',
    county_fips: 27085,
    county_fips_all: '27085|27129|27143',
    county: 'McLeod',
    county_names_all: 'McLeod|Renville|Sibley',
    county_weights: '{"27085": 52.68, "27129": 29.24, "27143": 18.08}',
    density: 5.3,
    imprecise: false,
    latitude: 44.73732,
    longitude: -94.49281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55385',
  },
  {
    city: 'Victoria',
    county_fips: 27019,
    county_fips_all: '27019',
    county: 'Carver',
    county_names_all: 'Carver',
    county_weights: '{"27019": 100}',
    density: 608.3,
    imprecise: false,
    latitude: 44.85686,
    longitude: -93.66435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55386',
  },
  {
    city: 'Waconia',
    county_fips: 27019,
    county_fips_all: '27019|27053',
    county: 'Carver',
    county_names_all: 'Carver|Hennepin',
    county_weights: '{"27019": 99.36, "27053": 0.64}',
    density: 184,
    imprecise: false,
    latitude: 44.85643,
    longitude: -93.77903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55387',
  },
  {
    city: 'Watertown',
    county_fips: 27019,
    county_fips_all: '27019|27171|27053',
    county: 'Carver',
    county_names_all: 'Carver|Wright|Hennepin',
    county_weights: '{"27019": 80.01, "27171": 15.15, "27053": 4.84}',
    density: 60.4,
    imprecise: false,
    latitude: 44.95,
    longitude: -93.84729,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55388',
  },
  {
    city: 'Watkins',
    county_fips: 27093,
    county_fips_all: '27093|27145',
    county: 'Meeker',
    county_names_all: 'Meeker|Stearns',
    county_weights: '{"27093": 62.98, "27145": 37.02}',
    density: 12.3,
    imprecise: false,
    latitude: 45.2998,
    longitude: -94.43748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55389',
  },
  {
    city: 'Waverly',
    county_fips: 27171,
    county_fips_all: '27171',
    county: 'Wright',
    county_names_all: 'Wright',
    county_weights: '{"27171": 100}',
    density: 36.6,
    imprecise: false,
    latitude: 45.06812,
    longitude: -93.97912,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55390',
  },
  {
    city: 'Wayzata',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 362.3,
    imprecise: false,
    latitude: 44.96009,
    longitude: -93.54225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55391',
  },
  {
    city: 'Winsted',
    county_fips: 27085,
    county_fips_all: '27085|27171|27019',
    county: 'McLeod',
    county_names_all: 'McLeod|Wright|Carver',
    county_weights: '{"27085": 76.98, "27171": 11.9, "27019": 11.12}',
    density: 44,
    imprecise: false,
    latitude: 44.9572,
    longitude: -94.06085,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55395',
  },
  {
    city: 'Winthrop',
    county_fips: 27143,
    county_fips_all: '27143|27085',
    county: 'Sibley',
    county_names_all: 'Sibley|McLeod',
    county_weights: '{"27143": 99.18, "27085": 0.82}',
    density: 8.2,
    imprecise: false,
    latitude: 44.54473,
    longitude: -94.36755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55396',
  },
  {
    city: 'Young America',
    county_fips: 27019,
    county_fips_all: '27019|27085',
    county: 'Carver',
    county_names_all: 'Carver|McLeod',
    county_weights: '{"27019": 96.67, "27085": 3.33}',
    density: 46.5,
    imprecise: false,
    latitude: 44.81712,
    longitude: -93.93452,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55397',
  },
  {
    city: 'Zimmerman',
    county_fips: 27141,
    county_fips_all: '27141|27059',
    county: 'Sherburne',
    county_names_all: 'Sherburne|Isanti',
    county_weights: '{"27141": 82.64, "27059": 17.36}',
    density: 93.4,
    imprecise: false,
    latitude: 45.45787,
    longitude: -93.5903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55398',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 5765.7,
    imprecise: false,
    latitude: 44.98526,
    longitude: -93.26984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55401',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1527.3,
    imprecise: false,
    latitude: 44.97608,
    longitude: -93.27119,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55402',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 5001.3,
    imprecise: false,
    latitude: 44.97023,
    longitude: -93.28588,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55403',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 6183.9,
    imprecise: false,
    latitude: 44.9619,
    longitude: -93.26145,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55404',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 2343.5,
    imprecise: false,
    latitude: 44.97034,
    longitude: -93.30461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55405',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 2821.9,
    imprecise: false,
    latitude: 44.93932,
    longitude: -93.22071,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55406',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 3622.8,
    imprecise: false,
    latitude: 44.93484,
    longitude: -93.25263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55407',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 4527.5,
    imprecise: false,
    latitude: 44.94364,
    longitude: -93.2937,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55408',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 3301.9,
    imprecise: false,
    latitude: 44.93018,
    longitude: -93.28146,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55409',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 2568.6,
    imprecise: false,
    latitude: 44.91364,
    longitude: -93.31725,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55410',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 2659.2,
    imprecise: false,
    latitude: 44.9993,
    longitude: -93.2979,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55411',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 2772.4,
    imprecise: false,
    latitude: 45.02612,
    longitude: -93.29952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55412',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1803.7,
    imprecise: false,
    latitude: 44.99826,
    longitude: -93.24276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55413',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 4327.3,
    imprecise: false,
    latitude: 44.97915,
    longitude: -93.2259,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55414',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 6080.7,
    imprecise: false,
    latitude: 44.97463,
    longitude: -93.2578,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55415',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1842.9,
    imprecise: false,
    latitude: 44.94961,
    longitude: -93.34157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55416',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 2193.7,
    imprecise: false,
    latitude: 44.9059,
    longitude: -93.23534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55417',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053|27123',
    county: 'Hennepin',
    county_names_all: 'Hennepin|Ramsey',
    county_weights: '{"27053": 99.84, "27123": 0.16}',
    density: 1740.6,
    imprecise: false,
    latitude: 45.0208,
    longitude: -93.24244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55418',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 2734.9,
    imprecise: false,
    latitude: 44.90586,
    longitude: -93.28743,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55419',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1417.7,
    imprecise: false,
    latitude: 44.83564,
    longitude: -93.27745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55420',
  },
  {
    city: 'Minneapolis',
    county_fips: 27003,
    county_fips_all: '27003|27123|27053',
    county: 'Anoka',
    county_names_all: 'Anoka|Ramsey|Hennepin',
    county_weights: '{"27003": 91.19, "27123": 8.4, "27053": 0.41}',
    density: 1898.8,
    imprecise: false,
    latitude: 45.05083,
    longitude: -93.25249,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55421',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1295.2,
    imprecise: false,
    latitude: 45.00922,
    longitude: -93.33941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55422',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 2006.8,
    imprecise: false,
    latitude: 44.87663,
    longitude: -93.28144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55423',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1647.6,
    imprecise: false,
    latitude: 44.90509,
    longitude: -93.33978,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55424',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 928.3,
    imprecise: false,
    latitude: 44.84249,
    longitude: -93.23601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55425',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1472,
    imprecise: false,
    latitude: 44.95635,
    longitude: -93.38139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55426',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1320.6,
    imprecise: false,
    latitude: 45.00665,
    longitude: -93.38031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55427',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1548,
    imprecise: false,
    latitude: 45.06354,
    longitude: -93.38094,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55428',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1734.3,
    imprecise: false,
    latitude: 45.06443,
    longitude: -93.34105,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55429',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1495.3,
    imprecise: false,
    latitude: 45.0632,
    longitude: -93.30148,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55430',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 920.9,
    imprecise: false,
    latitude: 44.82607,
    longitude: -93.31195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55431',
  },
  {
    city: 'Minneapolis',
    county_fips: 27003,
    county_fips_all: '27003|27123',
    county: 'Anoka',
    county_names_all: 'Anoka|Ramsey',
    county_weights: '{"27003": 99.47, "27123": 0.53}',
    density: 1316.2,
    imprecise: false,
    latitude: 45.09693,
    longitude: -93.25466,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55432',
  },
  {
    city: 'Minneapolis',
    county_fips: 27003,
    county_fips_all: '27003',
    county: 'Anoka',
    county_names_all: 'Anoka',
    county_weights: '{"27003": 100}',
    density: 1143.5,
    imprecise: false,
    latitude: 45.16132,
    longitude: -93.31638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55433',
  },
  {
    city: 'Minneapolis',
    county_fips: 27003,
    county_fips_all: '27003',
    county: 'Anoka',
    county_names_all: 'Anoka',
    county_weights: '{"27003": 100}',
    density: 1429.2,
    imprecise: false,
    latitude: 45.1681,
    longitude: -93.25069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55434',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1842.8,
    imprecise: false,
    latitude: 44.87343,
    longitude: -93.3347,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55435',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1190.5,
    imprecise: false,
    latitude: 44.90345,
    longitude: -93.37409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55436',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1082.1,
    imprecise: false,
    latitude: 44.82434,
    longitude: -93.34488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55437',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053|27139',
    county: 'Hennepin',
    county_names_all: 'Hennepin|Scott',
    county_weights: '{"27053": 99.81, "27139": 0.19}',
    density: 730.9,
    imprecise: false,
    latitude: 44.82489,
    longitude: -93.37826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55438',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 775.2,
    imprecise: false,
    latitude: 44.87452,
    longitude: -93.37475,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55439',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 807.5,
    imprecise: false,
    latitude: 45.00475,
    longitude: -93.42845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55441',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 925.3,
    imprecise: false,
    latitude: 45.04856,
    longitude: -93.4269,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55442',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1435.3,
    imprecise: false,
    latitude: 45.11894,
    longitude: -93.33802,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55443',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1381.4,
    imprecise: false,
    latitude: 45.10747,
    longitude: -93.30234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55444',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 666.9,
    imprecise: false,
    latitude: 45.12317,
    longitude: -93.3798,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55445',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 1082.4,
    imprecise: false,
    latitude: 45.04427,
    longitude: -93.4878,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55446',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 904.9,
    imprecise: false,
    latitude: 45.00132,
    longitude: -93.48888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55447',
  },
  {
    city: 'Minneapolis',
    county_fips: 27003,
    county_fips_all: '27003',
    county: 'Anoka',
    county_names_all: 'Anoka',
    county_weights: '{"27003": 100}',
    density: 1034.4,
    imprecise: false,
    latitude: 45.1908,
    longitude: -93.30209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55448',
  },
  {
    city: 'Minneapolis',
    county_fips: 27003,
    county_fips_all: '27003|27123',
    county: 'Anoka',
    county_names_all: 'Anoka|Ramsey',
    county_weights: '{"27003": 99.16, "27123": 0.84}',
    density: 620.2,
    imprecise: false,
    latitude: 45.17284,
    longitude: -93.1953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55449',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 44.87901,
    longitude: -93.22549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55450',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 5760.3,
    imprecise: false,
    latitude: 44.97075,
    longitude: -93.24381,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55454',
  },
  {
    city: 'Minneapolis',
    county_fips: 27053,
    county_fips_all: '27053',
    county: 'Hennepin',
    county_names_all: 'Hennepin',
    county_weights: '{"27053": 100}',
    density: 3867.1,
    imprecise: false,
    latitude: 44.97453,
    longitude: -93.23432,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55455',
  },
  {
    city: 'Beaver Bay',
    county_fips: 27075,
    county_fips_all: '27075',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"27075": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 47.23404,
    longitude: -91.36425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55601',
  },
  {
    city: 'Brimson',
    county_fips: 27137,
    county_fips_all: '27137|27075',
    county: 'St. Louis',
    county_names_all: 'St. Louis|Lake',
    county_weights: '{"27137": 92.42, "27075": 7.58}',
    density: 0.6,
    imprecise: false,
    latitude: 47.33207,
    longitude: -91.91047,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55602',
  },
  {
    city: 'Finland',
    county_fips: 27075,
    county_fips_all: '27075',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"27075": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 47.5441,
    longitude: -91.19441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55603',
  },
  {
    city: 'Grand Marais',
    county_fips: 27031,
    county_fips_all: '27031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"27031": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 47.96201,
    longitude: -90.55792,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55604',
  },
  {
    city: 'Grand Portage',
    county_fips: 27031,
    county_fips_all: '27031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"27031": 100}',
    density: 3,
    imprecise: false,
    latitude: 47.96242,
    longitude: -89.75529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55605',
  },
  {
    city: 'Hovland',
    county_fips: 27031,
    county_fips_all: '27031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"27031": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 47.96785,
    longitude: -90.02818,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55606',
  },
  {
    city: 'Isabella',
    county_fips: 27075,
    county_fips_all: '27075',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"27075": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 47.63363,
    longitude: -91.51106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55607',
  },
  {
    city: 'Knife River',
    county_fips: 27075,
    county_fips_all: '27075|27137',
    county: 'Lake',
    county_names_all: 'Lake|St. Louis',
    county_weights: '{"27075": 99.63, "27137": 0.37}',
    density: 20.3,
    imprecise: false,
    latitude: 46.9636,
    longitude: -91.78554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55609',
  },
  {
    city: 'Lutsen',
    county_fips: 27031,
    county_fips_all: '27031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"27031": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 47.77937,
    longitude: -90.70401,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55612',
  },
  {
    city: 'Schroeder',
    county_fips: 27031,
    county_fips_all: '27031|27075',
    county: 'Cook',
    county_names_all: 'Cook|Lake',
    county_weights: '{"27031": 99.86, "27075": 0.14}',
    density: 1.6,
    imprecise: false,
    latitude: 47.57023,
    longitude: -90.97293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55613',
  },
  {
    city: 'Silver Bay',
    county_fips: 27075,
    county_fips_all: '27075',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"27075": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 47.36412,
    longitude: -91.40387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55614',
  },
  {
    city: 'Tofte',
    county_fips: 27031,
    county_fips_all: '27031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"27031": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 47.74561,
    longitude: -90.87695,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55615',
  },
  {
    city: 'Two Harbors',
    county_fips: 27075,
    county_fips_all: '27075|27137',
    county: 'Lake',
    county_names_all: 'Lake|St. Louis',
    county_weights: '{"27075": 91.1, "27137": 8.9}',
    density: 5.8,
    imprecise: false,
    latitude: 47.25095,
    longitude: -91.66982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55616',
  },
  {
    city: 'Alborn',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 46.97121,
    longitude: -92.6448,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55702',
  },
  {
    city: 'Angora',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 47.73932,
    longitude: -92.78119,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55703',
  },
  {
    city: 'Askov',
    county_fips: 27115,
    county_fips_all: '27115',
    county: 'Pine',
    county_names_all: 'Pine',
    county_weights: '{"27115": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 46.2057,
    longitude: -92.76581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55704',
  },
  {
    city: 'Aurora',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 47.46789,
    longitude: -92.24446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55705',
  },
  {
    city: 'Babbitt',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 47.67432,
    longitude: -91.95261,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55706',
  },
  {
    city: 'Barnum',
    county_fips: 27017,
    county_fips_all: '27017',
    county: 'Carlton',
    county_names_all: 'Carlton',
    county_weights: '{"27017": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 46.55076,
    longitude: -92.64655,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55707',
  },
  {
    city: 'Biwabik',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 74.1,
    imprecise: false,
    latitude: 47.53527,
    longitude: -92.34766,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55708',
  },
  {
    city: 'Bovey',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 8,
    imprecise: false,
    latitude: 47.40431,
    longitude: -93.3804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55709',
  },
  {
    city: 'Britt',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 47.64542,
    longitude: -92.69457,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55710',
  },
  {
    city: 'Brookston',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 46.84066,
    longitude: -92.69498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55711',
  },
  {
    city: 'Bruno',
    county_fips: 27115,
    county_fips_all: '27115',
    county: 'Pine',
    county_names_all: 'Pine',
    county_weights: '{"27115": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 46.29398,
    longitude: -92.52513,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55712',
  },
  {
    city: 'Buhl',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 54.6,
    imprecise: false,
    latitude: 47.4894,
    longitude: -92.76583,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55713',
  },
  {
    city: 'Calumet',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 84.8,
    imprecise: false,
    latitude: 47.32169,
    longitude: -93.26432,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55716',
  },
  {
    city: 'Canyon',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 47.05026,
    longitude: -92.38642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55717',
  },
  {
    city: 'Carlton',
    county_fips: 27017,
    county_fips_all: '27017',
    county: 'Carlton',
    county_names_all: 'Carlton',
    county_weights: '{"27017": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 46.6249,
    longitude: -92.48505,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55718',
  },
  {
    city: 'Chisholm',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 47.55408,
    longitude: -92.85807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55719',
  },
  {
    city: 'Cloquet',
    county_fips: 27017,
    county_fips_all: '27017|27137',
    county: 'Carlton',
    county_names_all: 'Carlton|St. Louis',
    county_weights: '{"27017": 58.6, "27137": 41.4}',
    density: 43.1,
    imprecise: false,
    latitude: 46.75138,
    longitude: -92.5399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55720',
  },
  {
    city: 'Cohasset',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 47.21837,
    longitude: -93.68841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55721',
  },
  {
    city: 'Coleraine',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 304.3,
    imprecise: false,
    latitude: 47.28253,
    longitude: -93.4338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55722',
  },
  {
    city: 'Cook',
    county_fips: 27137,
    county_fips_all: '27137|27061',
    county: 'St. Louis',
    county_names_all: 'St. Louis|Itasca',
    county_weights: '{"27137": 73.31, "27061": 26.69}',
    density: 1.9,
    imprecise: false,
    latitude: 47.83764,
    longitude: -92.86715,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55723',
  },
  {
    city: 'Cotton',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 47.17874,
    longitude: -92.37277,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55724',
  },
  {
    city: 'Crane Lake',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.33849,
    longitude: -92.5811,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55725',
  },
  {
    city: 'Cromwell',
    county_fips: 27017,
    county_fips_all: '27017',
    county: 'Carlton',
    county_names_all: 'Carlton',
    county_weights: '{"27017": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 46.67027,
    longitude: -92.83209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55726',
  },
  {
    city: 'Ely',
    county_fips: 27075,
    county_fips_all: '27075|27137',
    county: 'Lake',
    county_names_all: 'Lake|St. Louis',
    county_weights: '{"27075": 51.07, "27137": 48.93}',
    density: 1.3,
    imprecise: false,
    latitude: 47.98832,
    longitude: -91.7489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55731',
  },
  {
    city: 'Embarrass',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 47.6791,
    longitude: -92.22125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55732',
  },
  {
    city: 'Esko',
    county_fips: 27017,
    county_fips_all: '27017|27137',
    county: 'Carlton',
    county_names_all: 'Carlton|St. Louis',
    county_weights: '{"27017": 99.22, "27137": 0.78}',
    density: 56.1,
    imprecise: false,
    latitude: 46.71141,
    longitude: -92.36297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55733',
  },
  {
    city: 'Eveleth',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 30.9,
    imprecise: false,
    latitude: 47.38274,
    longitude: -92.4938,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55734',
  },
  {
    city: 'Finlayson',
    county_fips: 27115,
    county_fips_all: '27115|27001',
    county: 'Pine',
    county_names_all: 'Pine|Aitkin',
    county_weights: '{"27115": 66.12, "27001": 33.88}',
    density: 5.6,
    imprecise: false,
    latitude: 46.21756,
    longitude: -93.01688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55735',
  },
  {
    city: 'Floodwood',
    county_fips: 27137,
    county_fips_all: '27137|27061',
    county: 'St. Louis',
    county_names_all: 'St. Louis|Itasca',
    county_weights: '{"27137": 92.94, "27061": 7.06}',
    density: 1.5,
    imprecise: false,
    latitude: 46.97542,
    longitude: -92.92136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55736',
  },
  {
    city: 'Forbes',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 47.27342,
    longitude: -92.65826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55738',
  },
  {
    city: 'Gilbert',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 47.4582,
    longitude: -92.38683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55741',
  },
  {
    city: 'Goodland',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 47.17195,
    longitude: -93.14076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55742',
  },
  {
    city: 'Grand Rapids',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 32.7,
    imprecise: false,
    latitude: 47.23306,
    longitude: -93.51299,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55744',
  },
  {
    city: 'Hibbing',
    county_fips: 27137,
    county_fips_all: '27137|27061',
    county: 'St. Louis',
    county_names_all: 'St. Louis|Itasca',
    county_weights: '{"27137": 92.46, "27061": 7.54}',
    density: 18.6,
    imprecise: false,
    latitude: 47.35766,
    longitude: -92.95698,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55746',
  },
  {
    city: 'Hill City',
    county_fips: 27001,
    county_fips_all: '27001|27061',
    county: 'Aitkin',
    county_names_all: 'Aitkin|Itasca',
    county_weights: '{"27001": 64.64, "27061": 35.36}',
    density: 3.5,
    imprecise: false,
    latitude: 46.99372,
    longitude: -93.59693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55748',
  },
  {
    city: 'Holyoke',
    county_fips: 27017,
    county_fips_all: '27017|27115',
    county: 'Carlton',
    county_names_all: 'Carlton|Pine',
    county_weights: '{"27017": 80.17, "27115": 19.83}',
    density: 2.4,
    imprecise: false,
    latitude: 46.44701,
    longitude: -92.43128,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55749',
  },
  {
    city: 'Hoyt Lakes',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 47.53251,
    longitude: -91.99517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55750',
  },
  {
    city: 'Iron',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 47.39283,
    longitude: -92.66815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55751',
  },
  {
    city: 'Jacobson',
    county_fips: 27001,
    county_fips_all: '27001|27061|27137',
    county: 'Aitkin',
    county_names_all: 'Aitkin|Itasca|St. Louis',
    county_weights: '{"27001": 98.19, "27061": 1.64, "27137": 0.17}',
    density: 1,
    imprecise: false,
    latitude: 46.95494,
    longitude: -93.25323,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55752',
  },
  {
    city: 'Keewatin',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 533.1,
    imprecise: false,
    latitude: 47.39692,
    longitude: -93.07991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55753',
  },
  {
    city: 'Kerrick',
    county_fips: 27115,
    county_fips_all: '27115|27017',
    county: 'Pine',
    county_names_all: 'Pine|Carlton',
    county_weights: '{"27115": 85.36, "27017": 14.64}',
    density: 2.6,
    imprecise: false,
    latitude: 46.37535,
    longitude: -92.60128,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55756',
  },
  {
    city: 'Kettle River',
    county_fips: 27017,
    county_fips_all: '27017',
    county: 'Carlton',
    county_names_all: 'Carlton',
    county_weights: '{"27017": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 46.51594,
    longitude: -92.93475,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55757',
  },
  {
    city: 'Kinney',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 47.50823,
    longitude: -92.72141,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55758',
  },
  {
    city: 'Mcgregor',
    county_fips: 27001,
    county_fips_all: '27001',
    county: 'Aitkin',
    county_names_all: 'Aitkin',
    county_weights: '{"27001": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 46.62491,
    longitude: -93.27049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55760',
  },
  {
    city: 'Makinen',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 47.33127,
    longitude: -92.22262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55763',
  },
  {
    city: 'Marble',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 56.3,
    imprecise: false,
    latitude: 47.33041,
    longitude: -93.29298,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55764',
  },
  {
    city: 'Meadowlands',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 47.10057,
    longitude: -92.74545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55765',
  },
  {
    city: 'Moose Lake',
    county_fips: 27017,
    county_fips_all: '27017|27115',
    county: 'Carlton',
    county_names_all: 'Carlton|Pine',
    county_weights: '{"27017": 95.83, "27115": 4.17}',
    density: 31.3,
    imprecise: false,
    latitude: 46.45236,
    longitude: -92.76536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55767',
  },
  {
    city: 'Mountain Iron',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 47.51444,
    longitude: -92.67263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55768',
  },
  {
    city: 'Nashwauk',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 47.47994,
    longitude: -93.18579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55769',
  },
  {
    city: 'Orr',
    county_fips: 27137,
    county_fips_all: '27137|27071',
    county: 'St. Louis',
    county_names_all: 'St. Louis|Koochiching',
    county_weights: '{"27137": 72.43, "27071": 27.57}',
    density: 0.5,
    imprecise: false,
    latitude: 48.12398,
    longitude: -92.93101,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55771',
  },
  {
    city: 'Nett Lake',
    county_fips: 27071,
    county_fips_all: '27071|27137',
    county: 'Koochiching',
    county_names_all: 'Koochiching|St. Louis',
    county_weights: '{"27071": 94.45, "27137": 5.55}',
    density: 144.6,
    imprecise: false,
    latitude: 48.11019,
    longitude: -93.10032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55772',
  },
  {
    city: 'Pengilly',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 47.30588,
    longitude: -93.1646,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55775',
  },
  {
    city: 'Saginaw',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 46.90915,
    longitude: -92.4548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55779',
  },
  {
    city: 'Sawyer',
    county_fips: 27017,
    county_fips_all: '27017',
    county: 'Carlton',
    county_names_all: 'Carlton',
    county_weights: '{"27017": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 46.67505,
    longitude: -92.68321,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55780',
  },
  {
    city: 'Side Lake',
    county_fips: 27061,
    county_fips_all: '27061|27137',
    county: 'Itasca',
    county_names_all: 'Itasca|St. Louis',
    county_weights: '{"27061": 54.03, "27137": 45.97}',
    density: 3.9,
    imprecise: false,
    latitude: 47.67587,
    longitude: -93.06524,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55781',
  },
  {
    city: 'Soudan',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 15,
    imprecise: false,
    latitude: 47.82314,
    longitude: -92.20524,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55782',
  },
  {
    city: 'Sturgeon Lake',
    county_fips: 27115,
    county_fips_all: '27115|27001|27017',
    county: 'Pine',
    county_names_all: 'Pine|Aitkin|Carlton',
    county_weights: '{"27115": 62.17, "27001": 26.07, "27017": 11.76}',
    density: 7.4,
    imprecise: false,
    latitude: 46.40836,
    longitude: -92.92625,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55783',
  },
  {
    city: 'Swan River',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 47.05306,
    longitude: -93.18769,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55784',
  },
  {
    city: 'Swatara',
    county_fips: 27001,
    county_fips_all: '27001|27021',
    county: 'Aitkin',
    county_names_all: 'Aitkin|Cass',
    county_weights: '{"27001": 74.15, "27021": 25.85}',
    density: 0.9,
    imprecise: false,
    latitude: 46.92332,
    longitude: -93.74591,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55785',
  },
  {
    city: 'Taconite',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 47.31916,
    longitude: -93.38227,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55786',
  },
  {
    city: 'Tamarack',
    county_fips: 27001,
    county_fips_all: '27001|27017|27137',
    county: 'Aitkin',
    county_names_all: 'Aitkin|Carlton|St. Louis',
    county_weights: '{"27001": 88.38, "27017": 11.52, "27137": 0.1}',
    density: 1.8,
    imprecise: false,
    latitude: 46.73707,
    longitude: -93.11756,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55787',
  },
  {
    city: 'Tower',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 5,
    imprecise: false,
    latitude: 47.8288,
    longitude: -92.37596,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55790',
  },
  {
    city: 'Virginia',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 39,
    imprecise: false,
    latitude: 47.60027,
    longitude: -92.48261,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55792',
  },
  {
    city: 'Warba',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 47.11585,
    longitude: -93.28442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55793',
  },
  {
    city: 'Willow River',
    county_fips: 27115,
    county_fips_all: '27115',
    county: 'Pine',
    county_names_all: 'Pine',
    county_weights: '{"27115": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 46.31337,
    longitude: -92.87031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55795',
  },
  {
    city: 'Winton',
    county_fips: 27075,
    county_fips_all: '27075|27137',
    county: 'Lake',
    county_names_all: 'Lake|St. Louis',
    county_weights: '{"27075": 56.68, "27137": 43.32}',
    density: 237.8,
    imprecise: false,
    latitude: 47.92905,
    longitude: -91.79732,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55796',
  },
  {
    city: 'Wrenshall',
    county_fips: 27017,
    county_fips_all: '27017',
    county: 'Carlton',
    county_names_all: 'Carlton',
    county_weights: '{"27017": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 46.56978,
    longitude: -92.36431,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55797',
  },
  {
    city: 'Wright',
    county_fips: 27017,
    county_fips_all: '27017|27137|27001',
    county: 'Carlton',
    county_names_all: 'Carlton|St. Louis|Aitkin',
    county_weights: '{"27017": 72.16, "27137": 18.02, "27001": 9.82}',
    density: 2.3,
    imprecise: false,
    latitude: 46.72138,
    longitude: -92.97907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55798',
  },
  {
    city: 'Duluth',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 357.7,
    imprecise: false,
    latitude: 46.75267,
    longitude: -92.08197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55802',
  },
  {
    city: 'Duluth',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 47.03398,
    longitude: -92.07104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55803',
  },
  {
    city: 'Duluth',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 65.4,
    imprecise: false,
    latitude: 46.9381,
    longitude: -91.93089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55804',
  },
  {
    city: 'Duluth',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 2836.2,
    imprecise: false,
    latitude: 46.80065,
    longitude: -92.09552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55805',
  },
  {
    city: 'Duluth',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 1055.5,
    imprecise: false,
    latitude: 46.76826,
    longitude: -92.12835,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55806',
  },
  {
    city: 'Duluth',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 651.2,
    imprecise: false,
    latitude: 46.73508,
    longitude: -92.1686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55807',
  },
  {
    city: 'Duluth',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 182.7,
    imprecise: false,
    latitude: 46.6792,
    longitude: -92.23686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55808',
  },
  {
    city: 'Duluth',
    county_fips: 27137,
    county_fips_all: '27137|27017',
    county: 'St. Louis',
    county_names_all: 'St. Louis|Carlton',
    county_weights: '{"27137": 93.95, "27017": 6.05}',
    density: 67.6,
    imprecise: false,
    latitude: 46.75894,
    longitude: -92.27445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55810',
  },
  {
    city: 'Duluth',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 168.3,
    imprecise: false,
    latitude: 46.83767,
    longitude: -92.21993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55811',
  },
  {
    city: 'Duluth',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 2165.9,
    imprecise: false,
    latitude: 46.81236,
    longitude: -92.07564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55812',
  },
  {
    city: 'Rochester',
    county_fips: 27109,
    county_fips_all: '27109',
    county: 'Olmsted',
    county_names_all: 'Olmsted',
    county_weights: '{"27109": 100}',
    density: 682.8,
    imprecise: false,
    latitude: 44.07679,
    longitude: -92.5018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55901',
  },
  {
    city: 'Rochester',
    county_fips: 27109,
    county_fips_all: '27109',
    county: 'Olmsted',
    county_names_all: 'Olmsted',
    county_weights: '{"27109": 100}',
    density: 248.3,
    imprecise: false,
    latitude: 43.9671,
    longitude: -92.51584,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55902',
  },
  {
    city: 'Rochester',
    county_fips: 27109,
    county_fips_all: '27109',
    county: 'Olmsted',
    county_names_all: 'Olmsted',
    county_weights: '{"27109": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.02391,
    longitude: -92.43657,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55903',
  },
  {
    city: 'Rochester',
    county_fips: 27109,
    county_fips_all: '27109',
    county: 'Olmsted',
    county_names_all: 'Olmsted',
    county_weights: '{"27109": 100}',
    density: 190.3,
    imprecise: false,
    latitude: 43.96204,
    longitude: -92.39931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55904',
  },
  {
    city: 'Rochester',
    county_fips: 27109,
    county_fips_all: '27109|27157',
    county: 'Olmsted',
    county_names_all: 'Olmsted|Wabasha',
    county_weights: '{"27109": 91.93, "27157": 8.07}',
    density: 128.3,
    imprecise: false,
    latitude: 44.10751,
    longitude: -92.40142,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55906',
  },
  {
    city: 'Adams',
    county_fips: 27099,
    county_fips_all: '27099',
    county: 'Mower',
    county_names_all: 'Mower',
    county_weights: '{"27099": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 43.56312,
    longitude: -92.73461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55909',
  },
  {
    city: 'Altura',
    county_fips: 27169,
    county_fips_all: '27169|27157',
    county: 'Winona',
    county_names_all: 'Winona|Wabasha',
    county_weights: '{"27169": 87.62, "27157": 12.38}',
    density: 5.1,
    imprecise: false,
    latitude: 44.13285,
    longitude: -91.97285,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55910',
  },
  {
    city: 'Austin',
    county_fips: 27099,
    county_fips_all: '27099|27047',
    county: 'Mower',
    county_names_all: 'Mower|Freeborn',
    county_weights: '{"27099": 75.65, "27047": 24.35}',
    density: 60.9,
    imprecise: false,
    latitude: 43.6827,
    longitude: -92.99148,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55912',
  },
  {
    city: 'Blooming Prairie',
    county_fips: 27147,
    county_fips_all: '27147|27039|27047|27099',
    county: 'Steele',
    county_names_all: 'Steele|Dodge|Freeborn|Mower',
    county_weights:
      '{"27147": 44.33, "27039": 27.53, "27047": 15.98, "27099": 12.17}',
    density: 9.9,
    imprecise: false,
    latitude: 43.88164,
    longitude: -93.0716,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55917',
  },
  {
    city: 'Brownsdale',
    county_fips: 27099,
    county_fips_all: '27099',
    county: 'Mower',
    county_names_all: 'Mower',
    county_weights: '{"27099": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 43.74236,
    longitude: -92.84673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55918',
  },
  {
    city: 'Brownsville',
    county_fips: 27055,
    county_fips_all: '27055',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"27055": 100}',
    density: 9,
    imprecise: false,
    latitude: 43.61443,
    longitude: -91.2941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55919',
  },
  {
    city: 'Byron',
    county_fips: 27109,
    county_fips_all: '27109',
    county: 'Olmsted',
    county_names_all: 'Olmsted',
    county_weights: '{"27109": 100}',
    density: 52.1,
    imprecise: false,
    latitude: 44.01246,
    longitude: -92.62111,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55920',
  },
  {
    city: 'Caledonia',
    county_fips: 27055,
    county_fips_all: '27055',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"27055": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 43.62265,
    longitude: -91.46388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55921',
  },
  {
    city: 'Canton',
    county_fips: 27045,
    county_fips_all: '27045',
    county: 'Fillmore',
    county_names_all: 'Fillmore',
    county_weights: '{"27045": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 43.5621,
    longitude: -91.89562,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55922',
  },
  {
    city: 'Chatfield',
    county_fips: 27045,
    county_fips_all: '27045|27109|27169',
    county: 'Fillmore',
    county_names_all: 'Fillmore|Olmsted|Winona',
    county_weights: '{"27045": 50.38, "27109": 46.37, "27169": 3.25}',
    density: 13.4,
    imprecise: false,
    latitude: 43.8494,
    longitude: -92.18315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55923',
  },
  {
    city: 'Claremont',
    county_fips: 27039,
    county_fips_all: '27039|27147',
    county: 'Dodge',
    county_names_all: 'Dodge|Steele',
    county_weights: '{"27039": 69.67, "27147": 30.33}',
    density: 5.9,
    imprecise: false,
    latitude: 44.0354,
    longitude: -93.01838,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55924',
  },
  {
    city: 'Dakota',
    county_fips: 27169,
    county_fips_all: '27169',
    county: 'Winona',
    county_names_all: 'Winona',
    county_weights: '{"27169": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 43.90962,
    longitude: -91.46503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55925',
  },
  {
    city: 'Dexter',
    county_fips: 27099,
    county_fips_all: '27099',
    county: 'Mower',
    county_names_all: 'Mower',
    county_weights: '{"27099": 100}',
    density: 5,
    imprecise: false,
    latitude: 43.74279,
    longitude: -92.70689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55926',
  },
  {
    city: 'Dodge Center',
    county_fips: 27039,
    county_fips_all: '27039',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"27039": 100}',
    density: 20.7,
    imprecise: false,
    latitude: 44.0335,
    longitude: -92.87291,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55927',
  },
  {
    city: 'Dover',
    county_fips: 27109,
    county_fips_all: '27109',
    county: 'Olmsted',
    county_names_all: 'Olmsted',
    county_weights: '{"27109": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 43.97765,
    longitude: -92.14412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55929',
  },
  {
    city: 'Eitzen',
    county_fips: 27055,
    county_fips_all: '27055',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"27055": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 43.51424,
    longitude: -91.39703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55931',
  },
  {
    city: 'Elgin',
    county_fips: 27109,
    county_fips_all: '27109|27157',
    county: 'Olmsted',
    county_names_all: 'Olmsted|Wabasha',
    county_weights: '{"27109": 52.15, "27157": 47.85}',
    density: 14.7,
    imprecise: false,
    latitude: 44.13804,
    longitude: -92.30081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55932',
  },
  {
    city: 'Elkton',
    county_fips: 27099,
    county_fips_all: '27099',
    county: 'Mower',
    county_names_all: 'Mower',
    county_weights: '{"27099": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 43.64787,
    longitude: -92.68504,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55933',
  },
  {
    city: 'Eyota',
    county_fips: 27109,
    county_fips_all: '27109',
    county: 'Olmsted',
    county_names_all: 'Olmsted',
    county_weights: '{"27109": 100}',
    density: 17,
    imprecise: false,
    latitude: 44.00388,
    longitude: -92.26573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55934',
  },
  {
    city: 'Fountain',
    county_fips: 27045,
    county_fips_all: '27045',
    county: 'Fillmore',
    county_names_all: 'Fillmore',
    county_weights: '{"27045": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 43.74737,
    longitude: -92.12734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55935',
  },
  {
    city: 'Grand Meadow',
    county_fips: 27099,
    county_fips_all: '27099',
    county: 'Mower',
    county_names_all: 'Mower',
    county_weights: '{"27099": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 43.70943,
    longitude: -92.58524,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55936',
  },
  {
    city: 'Harmony',
    county_fips: 27045,
    county_fips_all: '27045',
    county: 'Fillmore',
    county_names_all: 'Fillmore',
    county_weights: '{"27045": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 43.54682,
    longitude: -92.08144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55939',
  },
  {
    city: 'Hayfield',
    county_fips: 27039,
    county_fips_all: '27039|27109|27099',
    county: 'Dodge',
    county_names_all: 'Dodge|Olmsted|Mower',
    county_weights: '{"27039": 90.08, "27109": 8.63, "27099": 1.29}',
    density: 11.6,
    imprecise: false,
    latitude: 43.89417,
    longitude: -92.80775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55940',
  },
  {
    city: 'Hokah',
    county_fips: 27055,
    county_fips_all: '27055',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"27055": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 43.72558,
    longitude: -91.35382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55941',
  },
  {
    city: 'Houston',
    county_fips: 27055,
    county_fips_all: '27055|27169',
    county: 'Houston',
    county_names_all: 'Houston|Winona',
    county_weights: '{"27055": 80.5, "27169": 19.5}',
    density: 7.3,
    imprecise: false,
    latitude: 43.7903,
    longitude: -91.58343,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55943',
  },
  {
    city: 'Kasson',
    county_fips: 27039,
    county_fips_all: '27039|27109',
    county: 'Dodge',
    county_names_all: 'Dodge|Olmsted',
    county_weights: '{"27039": 93.76, "27109": 6.24}',
    density: 53.1,
    imprecise: false,
    latitude: 43.98754,
    longitude: -92.73758,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55944',
  },
  {
    city: 'Kellogg',
    county_fips: 27157,
    county_fips_all: '27157',
    county: 'Wabasha',
    county_names_all: 'Wabasha',
    county_weights: '{"27157": 100}',
    density: 5,
    imprecise: false,
    latitude: 44.26788,
    longitude: -92.05591,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55945',
  },
  {
    city: 'Kenyon',
    county_fips: 27049,
    county_fips_all: '27049|27131|27039|27147',
    county: 'Goodhue',
    county_names_all: 'Goodhue|Rice|Dodge|Steele',
    county_weights:
      '{"27049": 76.09, "27131": 16.13, "27039": 5.6, "27147": 2.18}',
    density: 10,
    imprecise: false,
    latitude: 44.26129,
    longitude: -92.95998,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55946',
  },
  {
    city: 'La Crescent',
    county_fips: 27055,
    county_fips_all: '27055|27169',
    county: 'Houston',
    county_names_all: 'Houston|Winona',
    county_weights: '{"27055": 65.11, "27169": 34.89}',
    density: 39,
    imprecise: false,
    latitude: 43.82412,
    longitude: -91.35666,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55947',
  },
  {
    city: 'Lanesboro',
    county_fips: 27045,
    county_fips_all: '27045',
    county: 'Fillmore',
    county_names_all: 'Fillmore',
    county_weights: '{"27045": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 43.71156,
    longitude: -91.94032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55949',
  },
  {
    city: 'Lansing',
    county_fips: 27099,
    county_fips_all: '27099',
    county: 'Mower',
    county_names_all: 'Mower',
    county_weights: '{"27099": 100}',
    density: 156.9,
    imprecise: false,
    latitude: 43.74341,
    longitude: -92.96618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55950',
  },
  {
    city: 'Le Roy',
    county_fips: 27099,
    county_fips_all: '27099|27045',
    county: 'Mower',
    county_names_all: 'Mower|Fillmore',
    county_weights: '{"27099": 65.37, "27045": 34.63}',
    density: 7.3,
    imprecise: false,
    latitude: 43.53529,
    longitude: -92.48414,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55951',
  },
  {
    city: 'Lewiston',
    county_fips: 27169,
    county_fips_all: '27169',
    county: 'Winona',
    county_names_all: 'Winona',
    county_weights: '{"27169": 100}',
    density: 15,
    imprecise: false,
    latitude: 43.94399,
    longitude: -91.84337,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55952',
  },
  {
    city: 'Lyle',
    county_fips: 27099,
    county_fips_all: '27099|27047',
    county: 'Mower',
    county_names_all: 'Mower|Freeborn',
    county_weights: '{"27099": 93.24, "27047": 6.76}',
    density: 9.8,
    imprecise: false,
    latitude: 43.52772,
    longitude: -92.96521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55953',
  },
  {
    city: 'Mabel',
    county_fips: 27045,
    county_fips_all: '27045|27055',
    county: 'Fillmore',
    county_names_all: 'Fillmore|Houston',
    county_weights: '{"27045": 87.57, "27055": 12.43}',
    density: 7.1,
    imprecise: false,
    latitude: 43.56422,
    longitude: -91.78455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55954',
  },
  {
    city: 'Mantorville',
    county_fips: 27039,
    county_fips_all: '27039|27109',
    county: 'Dodge',
    county_names_all: 'Dodge|Olmsted',
    county_weights: '{"27039": 96.87, "27109": 3.13}',
    density: 29.4,
    imprecise: false,
    latitude: 44.09179,
    longitude: -92.73985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55955',
  },
  {
    city: 'Mazeppa',
    county_fips: 27157,
    county_fips_all: '27157|27049|27109',
    county: 'Wabasha',
    county_names_all: 'Wabasha|Goodhue|Olmsted',
    county_weights: '{"27157": 71.45, "27049": 26.28, "27109": 2.27}',
    density: 15.5,
    imprecise: false,
    latitude: 44.28382,
    longitude: -92.53068,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55956',
  },
  {
    city: 'Millville',
    county_fips: 27157,
    county_fips_all: '27157',
    county: 'Wabasha',
    county_names_all: 'Wabasha',
    county_weights: '{"27157": 100}',
    density: 7,
    imprecise: false,
    latitude: 44.25494,
    longitude: -92.28373,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55957',
  },
  {
    city: 'Minnesota City',
    county_fips: 27169,
    county_fips_all: '27169',
    county: 'Winona',
    county_names_all: 'Winona',
    county_weights: '{"27169": 100}',
    density: 20,
    imprecise: false,
    latitude: 44.11287,
    longitude: -91.78365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55959',
  },
  {
    city: 'Oronoco',
    county_fips: 27109,
    county_fips_all: '27109',
    county: 'Olmsted',
    county_names_all: 'Olmsted',
    county_weights: '{"27109": 100}',
    density: 37.2,
    imprecise: false,
    latitude: 44.14226,
    longitude: -92.53564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55960',
  },
  {
    city: 'Ostrander',
    county_fips: 27099,
    county_fips_all: '27099|27045',
    county: 'Mower',
    county_names_all: 'Mower|Fillmore',
    county_weights: '{"27099": 74.25, "27045": 25.75}',
    density: 6.8,
    imprecise: false,
    latitude: 43.60541,
    longitude: -92.47544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55961',
  },
  {
    city: 'Peterson',
    county_fips: 27045,
    county_fips_all: '27045|27169',
    county: 'Fillmore',
    county_names_all: 'Fillmore|Winona',
    county_weights: '{"27045": 95.48, "27169": 4.52}',
    density: 4.6,
    imprecise: false,
    latitude: 43.76213,
    longitude: -91.84219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55962',
  },
  {
    city: 'Pine Island',
    county_fips: 27049,
    county_fips_all: '27049|27109|27039',
    county: 'Goodhue',
    county_names_all: 'Goodhue|Olmsted|Dodge',
    county_weights: '{"27049": 46.07, "27109": 34.14, "27039": 19.79}',
    density: 25.1,
    imprecise: false,
    latitude: 44.18784,
    longitude: -92.66227,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55963',
  },
  {
    city: 'Plainview',
    county_fips: 27157,
    county_fips_all: '27157|27109|27169',
    county: 'Wabasha',
    county_names_all: 'Wabasha|Olmsted|Winona',
    county_weights: '{"27157": 78.98, "27109": 10.52, "27169": 10.5}',
    density: 19.1,
    imprecise: false,
    latitude: 44.16448,
    longitude: -92.15483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55964',
  },
  {
    city: 'Preston',
    county_fips: 27045,
    county_fips_all: '27045',
    county: 'Fillmore',
    county_names_all: 'Fillmore',
    county_weights: '{"27045": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 43.62913,
    longitude: -92.13282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55965',
  },
  {
    city: 'Racine',
    county_fips: 27099,
    county_fips_all: '27099',
    county: 'Mower',
    county_names_all: 'Mower',
    county_weights: '{"27099": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 43.79343,
    longitude: -92.51354,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55967',
  },
  {
    city: 'Reads Landing',
    county_fips: 27157,
    county_fips_all: '27157',
    county: 'Wabasha',
    county_names_all: 'Wabasha',
    county_weights: '{"27157": 100}',
    density: 36.4,
    imprecise: false,
    latitude: 44.39793,
    longitude: -92.0898,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55968',
  },
  {
    city: 'Rollingstone',
    county_fips: 27169,
    county_fips_all: '27169',
    county: 'Winona',
    county_names_all: 'Winona',
    county_weights: '{"27169": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 44.08263,
    longitude: -91.87658,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55969',
  },
  {
    city: 'Rose Creek',
    county_fips: 27099,
    county_fips_all: '27099',
    county: 'Mower',
    county_names_all: 'Mower',
    county_weights: '{"27099": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 43.59681,
    longitude: -92.83118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55970',
  },
  {
    city: 'Rushford',
    county_fips: 27045,
    county_fips_all: '27045|27169|27055',
    county: 'Fillmore',
    county_names_all: 'Fillmore|Winona|Houston',
    county_weights: '{"27045": 43.81, "27169": 38.03, "27055": 18.17}',
    density: 13.8,
    imprecise: false,
    latitude: 43.81968,
    longitude: -91.75527,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55971',
  },
  {
    city: 'Saint Charles',
    county_fips: 27169,
    county_fips_all: '27169|27109',
    county: 'Winona',
    county_names_all: 'Winona|Olmsted',
    county_weights: '{"27169": 73.67, "27109": 26.33}',
    density: 23.8,
    imprecise: false,
    latitude: 43.99396,
    longitude: -92.05092,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55972',
  },
  {
    city: 'Sargeant',
    county_fips: 27099,
    county_fips_all: '27099|27039',
    county: 'Mower',
    county_names_all: 'Mower|Dodge',
    county_weights: '{"27099": 96.57, "27039": 3.43}',
    density: 3.3,
    imprecise: false,
    latitude: 43.80794,
    longitude: -92.772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55973',
  },
  {
    city: 'Spring Grove',
    county_fips: 27055,
    county_fips_all: '27055|27045',
    county: 'Houston',
    county_names_all: 'Houston|Fillmore',
    county_weights: '{"27055": 96.03, "27045": 3.97}',
    density: 8.9,
    imprecise: false,
    latitude: 43.57968,
    longitude: -91.64382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55974',
  },
  {
    city: 'Spring Valley',
    county_fips: 27045,
    county_fips_all: '27045|27099',
    county: 'Fillmore',
    county_names_all: 'Fillmore|Mower',
    county_weights: '{"27045": 88.07, "27099": 11.93}',
    density: 10.7,
    imprecise: false,
    latitude: 43.67569,
    longitude: -92.37296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55975',
  },
  {
    city: 'Stewartville',
    county_fips: 27109,
    county_fips_all: '27109|27045|27099',
    county: 'Olmsted',
    county_names_all: 'Olmsted|Fillmore|Mower',
    county_weights: '{"27109": 83.01, "27045": 15.39, "27099": 1.6}',
    density: 36.1,
    imprecise: false,
    latitude: 43.86378,
    longitude: -92.48394,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55976',
  },
  {
    city: 'Taopi',
    county_fips: 27099,
    county_fips_all: '27099',
    county: 'Mower',
    county_names_all: 'Mower',
    county_weights: '{"27099": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 43.55371,
    longitude: -92.64792,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55977',
  },
  {
    city: 'Utica',
    county_fips: 27169,
    county_fips_all: '27169|27045',
    county: 'Winona',
    county_names_all: 'Winona|Fillmore',
    county_weights: '{"27169": 92.27, "27045": 7.73}',
    density: 6.9,
    imprecise: false,
    latitude: 43.92312,
    longitude: -91.95132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55979',
  },
  {
    city: 'Wabasha',
    county_fips: 27157,
    county_fips_all: '27157',
    county: 'Wabasha',
    county_names_all: 'Wabasha',
    county_weights: '{"27157": 100}',
    density: 30,
    imprecise: false,
    latitude: 44.35375,
    longitude: -92.06518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55981',
  },
  {
    city: 'Waltham',
    county_fips: 27099,
    county_fips_all: '27099',
    county: 'Mower',
    county_names_all: 'Mower',
    county_weights: '{"27099": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 43.81582,
    longitude: -92.886,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55982',
  },
  {
    city: 'Wanamingo',
    county_fips: 27049,
    county_fips_all: '27049',
    county: 'Goodhue',
    county_names_all: 'Goodhue',
    county_weights: '{"27049": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 44.29344,
    longitude: -92.80827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55983',
  },
  {
    city: 'West Concord',
    county_fips: 27039,
    county_fips_all: '27039|27049|27147',
    county: 'Dodge',
    county_names_all: 'Dodge|Goodhue|Steele',
    county_weights: '{"27039": 89.16, "27049": 6.5, "27147": 4.34}',
    density: 8.5,
    imprecise: false,
    latitude: 44.15669,
    longitude: -92.90259,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55985',
  },
  {
    city: 'Winona',
    county_fips: 27169,
    county_fips_all: '27169',
    county: 'Winona',
    county_names_all: 'Winona',
    county_weights: '{"27169": 100}',
    density: 83.7,
    imprecise: false,
    latitude: 43.98469,
    longitude: -91.63143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55987',
  },
  {
    city: 'Wykoff',
    county_fips: 27045,
    county_fips_all: '27045',
    county: 'Fillmore',
    county_names_all: 'Fillmore',
    county_weights: '{"27045": 100}',
    density: 8,
    imprecise: false,
    latitude: 43.7285,
    longitude: -92.2591,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55990',
  },
  {
    city: 'Zumbro Falls',
    county_fips: 27157,
    county_fips_all: '27157|27109',
    county: 'Wabasha',
    county_names_all: 'Wabasha|Olmsted',
    county_weights: '{"27157": 99.1, "27109": 0.9}',
    density: 10,
    imprecise: false,
    latitude: 44.25903,
    longitude: -92.41986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55991',
  },
  {
    city: 'Zumbrota',
    county_fips: 27049,
    county_fips_all: '27049',
    county: 'Goodhue',
    county_names_all: 'Goodhue',
    county_weights: '{"27049": 100}',
    density: 29.4,
    imprecise: false,
    latitude: 44.30557,
    longitude: -92.6827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55992',
  },
  {
    city: 'Mankato',
    county_fips: 27013,
    county_fips_all: '27013',
    county: 'Blue Earth',
    county_names_all: 'Blue Earth',
    county_weights: '{"27013": 100}',
    density: 173.9,
    imprecise: false,
    latitude: 44.13193,
    longitude: -93.97789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56001',
  },
  {
    city: 'Mankato',
    county_fips: 27103,
    county_fips_all: '27103|27013',
    county: 'Nicollet',
    county_names_all: 'Nicollet|Blue Earth',
    county_weights: '{"27103": 99.69, "27013": 0.31}',
    density: 133.9,
    imprecise: false,
    latitude: 44.21273,
    longitude: -94.08877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56003',
  },
  {
    city: 'Albert Lea',
    county_fips: 27047,
    county_fips_all: '27047',
    county: 'Freeborn',
    county_names_all: 'Freeborn',
    county_weights: '{"27047": 100}',
    density: 48.8,
    imprecise: false,
    latitude: 43.66085,
    longitude: -93.3238,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56007',
  },
  {
    city: 'Alden',
    county_fips: 27047,
    county_fips_all: '27047|27043',
    county: 'Freeborn',
    county_names_all: 'Freeborn|Faribault',
    county_weights: '{"27047": 98.48, "27043": 1.52}',
    density: 6.1,
    imprecise: false,
    latitude: 43.66125,
    longitude: -93.55904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56009',
  },
  {
    city: 'Amboy',
    county_fips: 27013,
    county_fips_all: '27013',
    county: 'Blue Earth',
    county_names_all: 'Blue Earth',
    county_weights: '{"27013": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 43.89112,
    longitude: -94.17869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56010',
  },
  {
    city: 'Belle Plaine',
    county_fips: 27139,
    county_fips_all: '27139|27143|27019|27079',
    county: 'Scott',
    county_names_all: 'Scott|Sibley|Carver|Le Sueur',
    county_weights:
      '{"27139": 67.13, "27143": 16.87, "27019": 9.4, "27079": 6.6}',
    density: 37.5,
    imprecise: false,
    latitude: 44.60344,
    longitude: -93.777,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56011',
  },
  {
    city: 'Blue Earth',
    county_fips: 27043,
    county_fips_all: '27043|27091',
    county: 'Faribault',
    county_names_all: 'Faribault|Martin',
    county_weights: '{"27043": 90.04, "27091": 9.96}',
    density: 10.3,
    imprecise: false,
    latitude: 43.62142,
    longitude: -94.10734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56013',
  },
  {
    city: 'Bricelyn',
    county_fips: 27043,
    county_fips_all: '27043',
    county: 'Faribault',
    county_names_all: 'Faribault',
    county_weights: '{"27043": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 43.58363,
    longitude: -93.82568,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56014',
  },
  {
    city: 'Clarks Grove',
    county_fips: 27047,
    county_fips_all: '27047',
    county: 'Freeborn',
    county_names_all: 'Freeborn',
    county_weights: '{"27047": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 43.76378,
    longitude: -93.34855,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56016',
  },
  {
    city: 'Cleveland',
    county_fips: 27079,
    county_fips_all: '27079',
    county: 'Le Sueur',
    county_names_all: 'Le Sueur',
    county_weights: '{"27079": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 44.30535,
    longitude: -93.81915,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56017',
  },
  {
    city: 'Comfrey',
    county_fips: 27015,
    county_fips_all: '27015|27033|27165',
    county: 'Brown',
    county_names_all: 'Brown|Cottonwood|Watonwan',
    county_weights: '{"27015": 58.56, "27033": 33.3, "27165": 8.14}',
    density: 3.1,
    imprecise: false,
    latitude: 44.11476,
    longitude: -94.89016,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56019',
  },
  {
    city: 'Conger',
    county_fips: 27047,
    county_fips_all: '27047',
    county: 'Freeborn',
    county_names_all: 'Freeborn',
    county_weights: '{"27047": 100}',
    density: 453.8,
    imprecise: false,
    latitude: 43.6146,
    longitude: -93.53019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56020',
  },
  {
    city: 'Courtland',
    county_fips: 27103,
    county_fips_all: '27103',
    county: 'Nicollet',
    county_names_all: 'Nicollet',
    county_weights: '{"27103": 100}',
    density: 12,
    imprecise: false,
    latitude: 44.28339,
    longitude: -94.31391,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56021',
  },
  {
    city: 'Darfur',
    county_fips: 27165,
    county_fips_all: '27165',
    county: 'Watonwan',
    county_names_all: 'Watonwan',
    county_weights: '{"27165": 100}',
    density: 177.4,
    imprecise: false,
    latitude: 44.05264,
    longitude: -94.83869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56022',
  },
  {
    city: 'Delavan',
    county_fips: 27043,
    county_fips_all: '27043',
    county: 'Faribault',
    county_names_all: 'Faribault',
    county_weights: '{"27043": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 43.77224,
    longitude: -94.01402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56023',
  },
  {
    city: 'Eagle Lake',
    county_fips: 27013,
    county_fips_all: '27013',
    county: 'Blue Earth',
    county_names_all: 'Blue Earth',
    county_weights: '{"27013": 100}',
    density: 75.9,
    imprecise: false,
    latitude: 44.14768,
    longitude: -93.84419,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56024',
  },
  {
    city: 'Easton',
    county_fips: 27043,
    county_fips_all: '27043',
    county: 'Faribault',
    county_names_all: 'Faribault',
    county_weights: '{"27043": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 43.7516,
    longitude: -93.90877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56025',
  },
  {
    city: 'Ellendale',
    county_fips: 27147,
    county_fips_all: '27147|27047|27161',
    county: 'Steele',
    county_names_all: 'Steele|Freeborn|Waseca',
    county_weights: '{"27147": 60.45, "27047": 38.9, "27161": 0.65}',
    density: 7.9,
    imprecise: false,
    latitude: 43.87485,
    longitude: -93.29124,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56026',
  },
  {
    city: 'Elmore',
    county_fips: 27043,
    county_fips_all: '27043|19109|27091',
    county: 'Faribault',
    county_names_all: 'Faribault|Kossuth|Martin',
    county_weights: '{"27043": 77.15, "19109": 13.35, "27091": 9.5}',
    density: 4.2,
    imprecise: false,
    latitude: 43.51935,
    longitude: -94.12432,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56027',
  },
  {
    city: 'Elysian',
    county_fips: 27079,
    county_fips_all: '27079|27161',
    county: 'Le Sueur',
    county_names_all: 'Le Sueur|Waseca',
    county_weights: '{"27079": 90.94, "27161": 9.06}',
    density: 22,
    imprecise: false,
    latitude: 44.22435,
    longitude: -93.71052,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56028',
  },
  {
    city: 'Emmons',
    county_fips: 27047,
    county_fips_all: '27047',
    county: 'Freeborn',
    county_names_all: 'Freeborn',
    county_weights: '{"27047": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 43.52519,
    longitude: -93.53003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56029',
  },
  {
    city: 'Essig',
    county_fips: 27015,
    county_fips_all: '27015',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"27015": 100}',
    density: 609,
    imprecise: false,
    latitude: 44.32485,
    longitude: -94.60485,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56030',
  },
  {
    city: 'Fairmont',
    county_fips: 27091,
    county_fips_all: '27091',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"27091": 100}',
    density: 28.8,
    imprecise: false,
    latitude: 43.62246,
    longitude: -94.46757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56031',
  },
  {
    city: 'Freeborn',
    county_fips: 27047,
    county_fips_all: '27047',
    county: 'Freeborn',
    county_names_all: 'Freeborn',
    county_weights: '{"27047": 100}',
    density: 51.1,
    imprecise: false,
    latitude: 43.77583,
    longitude: -93.56078,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56032',
  },
  {
    city: 'Frost',
    county_fips: 27043,
    county_fips_all: '27043',
    county: 'Faribault',
    county_names_all: 'Faribault',
    county_weights: '{"27043": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 43.55926,
    longitude: -93.93118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56033',
  },
  {
    city: 'Garden City',
    county_fips: 27013,
    county_fips_all: '27013',
    county: 'Blue Earth',
    county_names_all: 'Blue Earth',
    county_weights: '{"27013": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 44.03036,
    longitude: -94.18285,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56034',
  },
  {
    city: 'Geneva',
    county_fips: 27047,
    county_fips_all: '27047',
    county: 'Freeborn',
    county_names_all: 'Freeborn',
    county_weights: '{"27047": 100}',
    density: 274.7,
    imprecise: false,
    latitude: 43.82187,
    longitude: -93.26875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56035',
  },
  {
    city: 'Glenville',
    county_fips: 27047,
    county_fips_all: '27047',
    county: 'Freeborn',
    county_names_all: 'Freeborn',
    county_weights: '{"27047": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 43.5513,
    longitude: -93.22152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56036',
  },
  {
    city: 'Good Thunder',
    county_fips: 27013,
    county_fips_all: '27013',
    county: 'Blue Earth',
    county_names_all: 'Blue Earth',
    county_weights: '{"27013": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 44.0172,
    longitude: -94.0465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56037',
  },
  {
    city: 'Granada',
    county_fips: 27091,
    county_fips_all: '27091|27043',
    county: 'Martin',
    county_names_all: 'Martin|Faribault',
    county_weights: '{"27091": 98.06, "27043": 1.94}',
    density: 3.7,
    imprecise: false,
    latitude: 43.66246,
    longitude: -94.32287,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56039',
  },
  {
    city: 'Hanska',
    county_fips: 27015,
    county_fips_all: '27015|27013',
    county: 'Brown',
    county_names_all: 'Brown|Blue Earth',
    county_weights: '{"27015": 99.01, "27013": 0.99}',
    density: 5.5,
    imprecise: false,
    latitude: 44.15514,
    longitude: -94.52238,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56041',
  },
  {
    city: 'Hartland',
    county_fips: 27047,
    county_fips_all: '27047',
    county: 'Freeborn',
    county_names_all: 'Freeborn',
    county_weights: '{"27047": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 43.80408,
    longitude: -93.48387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56042',
  },
  {
    city: 'Hayward',
    county_fips: 27047,
    county_fips_all: '27047',
    county: 'Freeborn',
    county_names_all: 'Freeborn',
    county_weights: '{"27047": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 43.65236,
    longitude: -93.22809,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56043',
  },
  {
    city: 'Henderson',
    county_fips: 27143,
    county_fips_all: '27143|27079',
    county: 'Sibley',
    county_names_all: 'Sibley|Le Sueur',
    county_weights: '{"27143": 83.41, "27079": 16.59}',
    density: 11,
    imprecise: false,
    latitude: 44.56173,
    longitude: -93.93539,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56044',
  },
  {
    city: 'Hollandale',
    county_fips: 27047,
    county_fips_all: '27047',
    county: 'Freeborn',
    county_names_all: 'Freeborn',
    county_weights: '{"27047": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 43.75977,
    longitude: -93.20948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56045',
  },
  {
    city: 'Hope',
    county_fips: 27147,
    county_fips_all: '27147',
    county: 'Steele',
    county_names_all: 'Steele',
    county_weights: '{"27147": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 43.9678,
    longitude: -93.26889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56046',
  },
  {
    city: 'Janesville',
    county_fips: 27161,
    county_fips_all: '27161|27013',
    county: 'Waseca',
    county_names_all: 'Waseca|Blue Earth',
    county_weights: '{"27161": 76.34, "27013": 23.66}',
    density: 12.7,
    imprecise: false,
    latitude: 44.09478,
    longitude: -93.71589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56048',
  },
  {
    city: 'Kasota',
    county_fips: 27079,
    county_fips_all: '27079|27013',
    county: 'Le Sueur',
    county_names_all: 'Le Sueur|Blue Earth',
    county_weights: '{"27079": 88.2, "27013": 11.8}',
    density: 21.8,
    imprecise: false,
    latitude: 44.26006,
    longitude: -93.94706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56050',
  },
  {
    city: 'Kiester',
    county_fips: 27043,
    county_fips_all: '27043',
    county: 'Faribault',
    county_names_all: 'Faribault',
    county_weights: '{"27043": 100}',
    density: 8,
    imprecise: false,
    latitude: 43.53649,
    longitude: -93.70868,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56051',
  },
  {
    city: 'Kilkenny',
    county_fips: 27079,
    county_fips_all: '27079|27131',
    county: 'Le Sueur',
    county_names_all: 'Le Sueur|Rice',
    county_weights: '{"27079": 71.06, "27131": 28.94}',
    density: 5.7,
    imprecise: false,
    latitude: 44.32158,
    longitude: -93.5576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56052',
  },
  {
    city: 'Lafayette',
    county_fips: 27103,
    county_fips_all: '27103|27143',
    county: 'Nicollet',
    county_names_all: 'Nicollet|Sibley',
    county_weights: '{"27103": 83.53, "27143": 16.47}',
    density: 6.1,
    imprecise: false,
    latitude: 44.4357,
    longitude: -94.37043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56054',
  },
  {
    city: 'Lake Crystal',
    county_fips: 27013,
    county_fips_all: '27013',
    county: 'Blue Earth',
    county_names_all: 'Blue Earth',
    county_weights: '{"27013": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 44.12693,
    longitude: -94.24531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56055',
  },
  {
    city: 'La Salle',
    county_fips: 27165,
    county_fips_all: '27165',
    county: 'Watonwan',
    county_names_all: 'Watonwan',
    county_weights: '{"27165": 100}',
    density: 20.8,
    imprecise: false,
    latitude: 44.07278,
    longitude: -94.57945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56056',
  },
  {
    city: 'Le Center',
    county_fips: 27079,
    county_fips_all: '27079',
    county: 'Le Sueur',
    county_names_all: 'Le Sueur',
    county_weights: '{"27079": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 44.3954,
    longitude: -93.72045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56057',
  },
  {
    city: 'Le Sueur',
    county_fips: 27079,
    county_fips_all: '27079|27143|27103',
    county: 'Le Sueur',
    county_names_all: 'Le Sueur|Sibley|Nicollet',
    county_weights: '{"27079": 63.23, "27143": 25.51, "27103": 11.26}',
    density: 18.5,
    imprecise: false,
    latitude: 44.44424,
    longitude: -93.91441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56058',
  },
  {
    city: 'Lewisville',
    county_fips: 27165,
    county_fips_all: '27165|27013',
    county: 'Watonwan',
    county_names_all: 'Watonwan|Blue Earth',
    county_weights: '{"27165": 94.09, "27013": 5.91}',
    density: 4.3,
    imprecise: false,
    latitude: 43.93221,
    longitude: -94.43691,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56060',
  },
  {
    city: 'Madelia',
    county_fips: 27165,
    county_fips_all: '27165|27013|27015',
    county: 'Watonwan',
    county_names_all: 'Watonwan|Blue Earth|Brown',
    county_weights: '{"27165": 64.1, "27013": 28.76, "27015": 7.14}',
    density: 10,
    imprecise: false,
    latitude: 44.0483,
    longitude: -94.41469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56062',
  },
  {
    city: 'Madison Lake',
    county_fips: 27013,
    county_fips_all: '27013|27079|27161',
    county: 'Blue Earth',
    county_names_all: 'Blue Earth|Le Sueur|Waseca',
    county_weights: '{"27013": 60.2, "27079": 34.08, "27161": 5.72}',
    density: 31.1,
    imprecise: false,
    latitude: 44.218,
    longitude: -93.81791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56063',
  },
  {
    city: 'Mapleton',
    county_fips: 27013,
    county_fips_all: '27013|27043|27161',
    county: 'Blue Earth',
    county_names_all: 'Blue Earth|Faribault|Waseca',
    county_weights: '{"27013": 96.96, "27043": 2.18, "27161": 0.86}',
    density: 9.2,
    imprecise: false,
    latitude: 43.93376,
    longitude: -93.91799,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56065',
  },
  {
    city: 'Minnesota Lake',
    county_fips: 27013,
    county_fips_all: '27013|27043|27161',
    county: 'Blue Earth',
    county_names_all: 'Blue Earth|Faribault|Waseca',
    county_weights: '{"27013": 39.84, "27043": 35.77, "27161": 24.39}',
    density: 6.2,
    imprecise: false,
    latitude: 43.86303,
    longitude: -93.80601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56068',
  },
  {
    city: 'Montgomery',
    county_fips: 27079,
    county_fips_all: '27079|27131',
    county: 'Le Sueur',
    county_names_all: 'Le Sueur|Rice',
    county_weights: '{"27079": 63.78, "27131": 36.22}',
    density: 27.1,
    imprecise: false,
    latitude: 44.41801,
    longitude: -93.54988,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56069',
  },
  {
    city: 'New Prague',
    county_fips: 27079,
    county_fips_all: '27079|27139|27131',
    county: 'Le Sueur',
    county_names_all: 'Le Sueur|Scott|Rice',
    county_weights: '{"27079": 46.07, "27139": 42.07, "27131": 11.86}',
    density: 59.1,
    imprecise: false,
    latitude: 44.53459,
    longitude: -93.58209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56071',
  },
  {
    city: 'New Richland',
    county_fips: 27161,
    county_fips_all: '27161|27147|27047|27043',
    county: 'Waseca',
    county_names_all: 'Waseca|Steele|Freeborn|Faribault',
    county_weights:
      '{"27161": 77.62, "27147": 14.16, "27047": 7.97, "27043": 0.25}',
    density: 7.1,
    imprecise: false,
    latitude: 43.89677,
    longitude: -93.5125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56072',
  },
  {
    city: 'New Ulm',
    county_fips: 27015,
    county_fips_all: '27015|27103|27013',
    county: 'Brown',
    county_names_all: 'Brown|Nicollet|Blue Earth',
    county_weights: '{"27015": 55.35, "27103": 38.64, "27013": 6.01}',
    density: 33.4,
    imprecise: false,
    latitude: 44.30757,
    longitude: -94.46878,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56073',
  },
  {
    city: 'Nicollet',
    county_fips: 27103,
    county_fips_all: '27103',
    county: 'Nicollet',
    county_names_all: 'Nicollet',
    county_weights: '{"27103": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 44.32344,
    longitude: -94.20181,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56074',
  },
  {
    city: 'Northrop',
    county_fips: 27091,
    county_fips_all: '27091',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"27091": 100}',
    density: 1270.4,
    imprecise: false,
    latitude: 43.73516,
    longitude: -94.43663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56075',
  },
  {
    city: 'Pemberton',
    county_fips: 27013,
    county_fips_all: '27013|27161',
    county: 'Blue Earth',
    county_names_all: 'Blue Earth|Waseca',
    county_weights: '{"27013": 50.19, "27161": 49.81}',
    density: 6.8,
    imprecise: false,
    latitude: 44.00525,
    longitude: -93.76757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56078',
  },
  {
    city: 'Saint Clair',
    county_fips: 27013,
    county_fips_all: '27013',
    county: 'Blue Earth',
    county_names_all: 'Blue Earth',
    county_weights: '{"27013": 100}',
    density: 587.1,
    imprecise: false,
    latitude: 44.08166,
    longitude: -93.85781,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56080',
  },
  {
    city: 'Saint James',
    county_fips: 27165,
    county_fips_all: '27165|27015',
    county: 'Watonwan',
    county_names_all: 'Watonwan|Brown',
    county_weights: '{"27165": 95.93, "27015": 4.07}',
    density: 13.4,
    imprecise: false,
    latitude: 43.99345,
    longitude: -94.63062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56081',
  },
  {
    city: 'Saint Peter',
    county_fips: 27103,
    county_fips_all: '27103|27079',
    county: 'Nicollet',
    county_names_all: 'Nicollet|Le Sueur',
    county_weights: '{"27103": 86.69, "27079": 13.31}',
    density: 45.4,
    imprecise: false,
    latitude: 44.35217,
    longitude: -94.03329,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56082',
  },
  {
    city: 'Sanborn',
    county_fips: 27127,
    county_fips_all: '27127|27033|27015',
    county: 'Redwood',
    county_names_all: 'Redwood|Cottonwood|Brown',
    county_weights: '{"27127": 45.41, "27033": 34.57, "27015": 20.02}',
    density: 2.9,
    imprecise: false,
    latitude: 44.20734,
    longitude: -95.13434,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56083',
  },
  {
    city: 'Sleepy Eye',
    county_fips: 27015,
    county_fips_all: '27015|27127',
    county: 'Brown',
    county_names_all: 'Brown|Redwood',
    county_weights: '{"27015": 95.76, "27127": 4.24}',
    density: 9.5,
    imprecise: false,
    latitude: 44.29279,
    longitude: -94.73547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56085',
  },
  {
    city: 'Springfield',
    county_fips: 27015,
    county_fips_all: '27015|27127',
    county: 'Brown',
    county_names_all: 'Brown|Redwood',
    county_weights: '{"27015": 75.03, "27127": 24.97}',
    density: 8.2,
    imprecise: false,
    latitude: 44.24012,
    longitude: -94.97538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56087',
  },
  {
    city: 'Truman',
    county_fips: 27091,
    county_fips_all: '27091|27165|27013',
    county: 'Martin',
    county_names_all: 'Martin|Watonwan|Blue Earth',
    county_weights: '{"27091": 68.34, "27165": 23.83, "27013": 7.83}',
    density: 6.4,
    imprecise: false,
    latitude: 43.82647,
    longitude: -94.45031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56088',
  },
  {
    city: 'Twin Lakes',
    county_fips: 27047,
    county_fips_all: '27047',
    county: 'Freeborn',
    county_names_all: 'Freeborn',
    county_weights: '{"27047": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 43.55631,
    longitude: -93.4508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56089',
  },
  {
    city: 'Vernon Center',
    county_fips: 27013,
    county_fips_all: '27013',
    county: 'Blue Earth',
    county_names_all: 'Blue Earth',
    county_weights: '{"27013": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 43.9584,
    longitude: -94.23303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56090',
  },
  {
    city: 'Waldorf',
    county_fips: 27161,
    county_fips_all: '27161',
    county: 'Waseca',
    county_names_all: 'Waseca',
    county_weights: '{"27161": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 43.91813,
    longitude: -93.68831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56091',
  },
  {
    city: 'Waseca',
    county_fips: 27161,
    county_fips_all: '27161|27147|27131',
    county: 'Waseca',
    county_names_all: 'Waseca|Steele|Rice',
    county_weights: '{"27161": 93.16, "27147": 6.08, "27131": 0.76}',
    density: 27.1,
    imprecise: false,
    latitude: 44.06342,
    longitude: -93.51683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56093',
  },
  {
    city: 'Waterville',
    county_fips: 27079,
    county_fips_all: '27079|27131|27161',
    county: 'Le Sueur',
    county_names_all: 'Le Sueur|Rice|Waseca',
    county_weights: '{"27079": 79.56, "27131": 11.55, "27161": 8.89}',
    density: 20.5,
    imprecise: false,
    latitude: 44.24393,
    longitude: -93.60097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56096',
  },
  {
    city: 'Wells',
    county_fips: 27043,
    county_fips_all: '27043|27047|27161',
    county: 'Faribault',
    county_names_all: 'Faribault|Freeborn|Waseca',
    county_weights: '{"27043": 82.0, "27047": 15.27, "27161": 2.73}',
    density: 7.7,
    imprecise: false,
    latitude: 43.72261,
    longitude: -93.71593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56097',
  },
  {
    city: 'Winnebago',
    county_fips: 27043,
    county_fips_all: '27043|27091',
    county: 'Faribault',
    county_names_all: 'Faribault|Martin',
    county_weights: '{"27043": 80.87, "27091": 19.13}',
    density: 6.7,
    imprecise: false,
    latitude: 43.77565,
    longitude: -94.18528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56098',
  },
  {
    city: 'Windom',
    county_fips: 27033,
    county_fips_all: '27033|27063',
    county: 'Cottonwood',
    county_names_all: 'Cottonwood|Jackson',
    county_weights: '{"27033": 63.53, "27063": 36.47}',
    density: 13.8,
    imprecise: false,
    latitude: 43.88404,
    longitude: -95.13991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56101',
  },
  {
    city: 'Adrian',
    county_fips: 27105,
    county_fips_all: '27105',
    county: 'Nobles',
    county_names_all: 'Nobles',
    county_weights: '{"27105": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 43.62115,
    longitude: -95.94093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56110',
  },
  {
    city: 'Alpha',
    county_fips: 27063,
    county_fips_all: '27063|27091',
    county: 'Jackson',
    county_names_all: 'Jackson|Martin',
    county_weights: '{"27063": 93.62, "27091": 6.38}',
    density: 2.6,
    imprecise: false,
    latitude: 43.64155,
    longitude: -94.8799,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56111',
  },
  {
    city: 'Arco',
    county_fips: 27081,
    county_fips_all: '27081|27083',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Lyon',
    county_weights: '{"27081": 93.91, "27083": 6.09}',
    density: 2,
    imprecise: false,
    latitude: 44.40218,
    longitude: -96.14904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56113',
  },
  {
    city: 'Avoca',
    county_fips: 27101,
    county_fips_all: '27101',
    county: 'Murray',
    county_names_all: 'Murray',
    county_weights: '{"27101": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 43.97897,
    longitude: -95.59345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56114',
  },
  {
    city: 'Balaton',
    county_fips: 27083,
    county_fips_all: '27083|27101',
    county: 'Lyon',
    county_names_all: 'Lyon|Murray',
    county_weights: '{"27083": 62.59, "27101": 37.41}',
    density: 3.5,
    imprecise: false,
    latitude: 44.21514,
    longitude: -95.90038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56115',
  },
  {
    city: 'Beaver Creek',
    county_fips: 27133,
    county_fips_all: '27133',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"27133": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 43.61782,
    longitude: -96.37893,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56116',
  },
  {
    city: 'Bigelow',
    county_fips: 27105,
    county_fips_all: '27105',
    county: 'Nobles',
    county_names_all: 'Nobles',
    county_weights: '{"27105": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 43.52662,
    longitude: -95.68607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56117',
  },
  {
    city: 'Bingham Lake',
    county_fips: 27033,
    county_fips_all: '27033|27063',
    county: 'Cottonwood',
    county_names_all: 'Cottonwood|Jackson',
    county_weights: '{"27033": 90.85, "27063": 9.15}',
    density: 3.3,
    imprecise: false,
    latitude: 43.93616,
    longitude: -95.03555,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56118',
  },
  {
    city: 'Brewster',
    county_fips: 27105,
    county_fips_all: '27105|27063',
    county: 'Nobles',
    county_names_all: 'Nobles|Jackson',
    county_weights: '{"27105": 59.15, "27063": 40.85}',
    density: 4.9,
    imprecise: false,
    latitude: 43.71159,
    longitude: -95.46702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56119',
  },
  {
    city: 'Butterfield',
    county_fips: 27165,
    county_fips_all: '27165',
    county: 'Watonwan',
    county_names_all: 'Watonwan',
    county_weights: '{"27165": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 43.96083,
    longitude: -94.79139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56120',
  },
  {
    city: 'Ceylon',
    county_fips: 27091,
    county_fips_all: '27091',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"27091": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 43.53858,
    longitude: -94.61051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56121',
  },
  {
    city: 'Chandler',
    county_fips: 27101,
    county_fips_all: '27101|27105',
    county: 'Murray',
    county_names_all: 'Murray|Nobles',
    county_weights: '{"27101": 90.18, "27105": 9.82}',
    density: 4.7,
    imprecise: false,
    latitude: 43.89729,
    longitude: -95.95026,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56122',
  },
  {
    city: 'Currie',
    county_fips: 27101,
    county_fips_all: '27101',
    county: 'Murray',
    county_names_all: 'Murray',
    county_weights: '{"27101": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 44.08467,
    longitude: -95.59624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56123',
  },
  {
    city: 'Dovray',
    county_fips: 27101,
    county_fips_all: '27101',
    county: 'Murray',
    county_names_all: 'Murray',
    county_weights: '{"27101": 100}',
    density: 63.6,
    imprecise: false,
    latitude: 44.05452,
    longitude: -95.54774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56125',
  },
  {
    city: 'Dunnell',
    county_fips: 27091,
    county_fips_all: '27091',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"27091": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 43.54892,
    longitude: -94.77261,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56127',
  },
  {
    city: 'Edgerton',
    county_fips: 27117,
    county_fips_all: '27117|27133|27101|27105',
    county: 'Pipestone',
    county_names_all: 'Pipestone|Rock|Murray|Nobles',
    county_weights:
      '{"27117": 58.81, "27133": 19.67, "27101": 12.34, "27105": 9.18}',
    density: 5.9,
    imprecise: false,
    latitude: 43.88199,
    longitude: -96.11579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56128',
  },
  {
    city: 'Ellsworth',
    county_fips: 27105,
    county_fips_all: '27105|27133',
    county: 'Nobles',
    county_names_all: 'Nobles|Rock',
    county_weights: '{"27105": 52.83, "27133": 47.17}',
    density: 6.2,
    imprecise: false,
    latitude: 43.52775,
    longitude: -96.04327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56129',
  },
  {
    city: 'Fulda',
    county_fips: 27101,
    county_fips_all: '27101|27105|27033|27063',
    county: 'Murray',
    county_names_all: 'Murray|Nobles|Cottonwood|Jackson',
    county_weights:
      '{"27101": 44.82, "27105": 39.65, "27033": 15.06, "27063": 0.48}',
    density: 5,
    imprecise: false,
    latitude: 43.86305,
    longitude: -95.57219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56131',
  },
  {
    city: 'Garvin',
    county_fips: 27083,
    county_fips_all: '27083|27101',
    county: 'Lyon',
    county_names_all: 'Lyon|Murray',
    county_weights: '{"27083": 53.86, "27101": 46.14}',
    density: 3,
    imprecise: false,
    latitude: 44.20196,
    longitude: -95.75792,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56132',
  },
  {
    city: 'Hardwick',
    county_fips: 27133,
    county_fips_all: '27133',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"27133": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 43.78956,
    longitude: -96.23126,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56134',
  },
  {
    city: 'Hendricks',
    county_fips: 27081,
    county_fips_all: '27081|46011',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Brookings',
    county_weights: '{"27081": 77.68, "46011": 22.32}',
    density: 4.1,
    imprecise: false,
    latitude: 44.50187,
    longitude: -96.41645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56136',
  },
  {
    city: 'Heron Lake',
    county_fips: 27063,
    county_fips_all: '27063|27033',
    county: 'Jackson',
    county_names_all: 'Jackson|Cottonwood',
    county_weights: '{"27063": 65.52, "27033": 34.48}',
    density: 3.6,
    imprecise: false,
    latitude: 43.83246,
    longitude: -95.32424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56137',
  },
  {
    city: 'Hills',
    county_fips: 27133,
    county_fips_all: '27133',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"27133": 100}',
    density: 11,
    imprecise: false,
    latitude: 43.53279,
    longitude: -96.38348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56138',
  },
  {
    city: 'Holland',
    county_fips: 27117,
    county_fips_all: '27117',
    county: 'Pipestone',
    county_names_all: 'Pipestone',
    county_weights: '{"27117": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 44.10368,
    longitude: -96.1757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56139',
  },
  {
    city: 'Iona',
    county_fips: 27101,
    county_fips_all: '27101|27105',
    county: 'Murray',
    county_names_all: 'Murray|Nobles',
    county_weights: '{"27101": 91.61, "27105": 8.39}',
    density: 3.4,
    imprecise: false,
    latitude: 43.88184,
    longitude: -95.78962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56141',
  },
  {
    city: 'Ivanhoe',
    county_fips: 27081,
    county_fips_all: '27081',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"27081": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 44.4711,
    longitude: -96.2327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56142',
  },
  {
    city: 'Jackson',
    county_fips: 27063,
    county_fips_all: '27063',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"27063": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 43.62803,
    longitude: -95.00759,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56143',
  },
  {
    city: 'Jasper',
    county_fips: 27133,
    county_fips_all: '27133|27117|46101',
    county: 'Rock',
    county_names_all: 'Rock|Pipestone|Moody',
    county_weights: '{"27133": 47.95, "27117": 38.93, "46101": 13.12}',
    density: 3.7,
    imprecise: false,
    latitude: 43.84078,
    longitude: -96.38702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56144',
  },
  {
    city: 'Jeffers',
    county_fips: 27033,
    county_fips_all: '27033',
    county: 'Cottonwood',
    county_names_all: 'Cottonwood',
    county_weights: '{"27033": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 44.05577,
    longitude: -95.17384,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56145',
  },
  {
    city: 'Kanaranzi',
    county_fips: 27133,
    county_fips_all: '27133',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"27133": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 43.58006,
    longitude: -96.10343,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56146',
  },
  {
    city: 'Kenneth',
    county_fips: 27133,
    county_fips_all: '27133|27105',
    county: 'Rock',
    county_names_all: 'Rock|Nobles',
    county_weights: '{"27133": 53.53, "27105": 46.47}',
    density: 1.7,
    imprecise: false,
    latitude: 43.75726,
    longitude: -96.05985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56147',
  },
  {
    city: 'Lake Benton',
    county_fips: 27081,
    county_fips_all: '27081|27117',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Pipestone',
    county_weights: '{"27081": 95.83, "27117": 4.17}',
    density: 4.6,
    imprecise: false,
    latitude: 44.30059,
    longitude: -96.30454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56149',
  },
  {
    city: 'Lakefield',
    county_fips: 27063,
    county_fips_all: '27063',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"27063": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 43.63469,
    longitude: -95.21266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56150',
  },
  {
    city: 'Lake Wilson',
    county_fips: 27101,
    county_fips_all: '27101',
    county: 'Murray',
    county_names_all: 'Murray',
    county_weights: '{"27101": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 44.03304,
    longitude: -95.92833,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56151',
  },
  {
    city: 'Lamberton',
    county_fips: 27127,
    county_fips_all: '27127|27033',
    county: 'Redwood',
    county_names_all: 'Redwood|Cottonwood',
    county_weights: '{"27127": 62.47, "27033": 37.53}',
    density: 4,
    imprecise: false,
    latitude: 44.22702,
    longitude: -95.2733,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56152',
  },
  {
    city: 'Leota',
    county_fips: 27105,
    county_fips_all: '27105',
    county: 'Nobles',
    county_names_all: 'Nobles',
    county_weights: '{"27105": 100}',
    density: 24.5,
    imprecise: false,
    latitude: 43.83012,
    longitude: -96.01506,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56153',
  },
  {
    city: 'Lismore',
    county_fips: 27105,
    county_fips_all: '27105',
    county: 'Nobles',
    county_names_all: 'Nobles',
    county_weights: '{"27105": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 43.76707,
    longitude: -95.94117,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56155',
  },
  {
    city: 'Luverne',
    county_fips: 27133,
    county_fips_all: '27133',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"27133": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 43.66196,
    longitude: -96.22466,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56156',
  },
  {
    city: 'Lynd',
    county_fips: 27083,
    county_fips_all: '27083',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"27083": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 44.39702,
    longitude: -95.94805,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56157',
  },
  {
    city: 'Magnolia',
    county_fips: 27133,
    county_fips_all: '27133|27105',
    county: 'Rock',
    county_names_all: 'Rock|Nobles',
    county_weights: '{"27133": 75.57, "27105": 24.43}',
    density: 3.3,
    imprecise: false,
    latitude: 43.6337,
    longitude: -96.07465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56158',
  },
  {
    city: 'Mountain Lake',
    county_fips: 27033,
    county_fips_all: '27033|27063',
    county: 'Cottonwood',
    county_names_all: 'Cottonwood|Jackson',
    county_weights: '{"27033": 86.03, "27063": 13.97}',
    density: 8.1,
    imprecise: false,
    latitude: 43.94363,
    longitude: -94.93598,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56159',
  },
  {
    city: 'Odin',
    county_fips: 27091,
    county_fips_all: '27091|27063|27165',
    county: 'Martin',
    county_names_all: 'Martin|Jackson|Watonwan',
    county_weights: '{"27091": 50.77, "27063": 29.33, "27165": 19.9}',
    density: 4.2,
    imprecise: false,
    latitude: 43.83311,
    longitude: -94.81041,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56160',
  },
  {
    city: 'Okabena',
    county_fips: 27063,
    county_fips_all: '27063',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"27063": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 43.70637,
    longitude: -95.32519,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56161',
  },
  {
    city: 'Ormsby',
    county_fips: 27091,
    county_fips_all: '27091|27165',
    county: 'Martin',
    county_names_all: 'Martin|Watonwan',
    county_weights: '{"27091": 64.19, "27165": 35.81}',
    density: 5.2,
    imprecise: false,
    latitude: 43.84034,
    longitude: -94.66736,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56162',
  },
  {
    city: 'Pipestone',
    county_fips: 27117,
    county_fips_all: '27117|27081|46101',
    county: 'Pipestone',
    county_names_all: 'Pipestone|Lincoln|Moody',
    county_weights: '{"27117": 87.29, "27081": 9.35, "46101": 3.36}',
    density: 8.9,
    imprecise: false,
    latitude: 44.04936,
    longitude: -96.33361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56164',
  },
  {
    city: 'Reading',
    county_fips: 27105,
    county_fips_all: '27105',
    county: 'Nobles',
    county_names_all: 'Nobles',
    county_weights: '{"27105": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 43.7251,
    longitude: -95.7097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56165',
  },
  {
    city: 'Revere',
    county_fips: 27127,
    county_fips_all: '27127|27033',
    county: 'Redwood',
    county_names_all: 'Redwood|Cottonwood',
    county_weights: '{"27127": 51.37, "27033": 48.63}',
    density: 2.1,
    imprecise: false,
    latitude: 44.20248,
    longitude: -95.37401,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56166',
  },
  {
    city: 'Round Lake',
    county_fips: 27063,
    county_fips_all: '27063|27105',
    county: 'Jackson',
    county_names_all: 'Jackson|Nobles',
    county_weights: '{"27063": 79.99, "27105": 20.01}',
    density: 4.1,
    imprecise: false,
    latitude: 43.55082,
    longitude: -95.40524,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56167',
  },
  {
    city: 'Rushmore',
    county_fips: 27105,
    county_fips_all: '27105',
    county: 'Nobles',
    county_names_all: 'Nobles',
    county_weights: '{"27105": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 43.61552,
    longitude: -95.80358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56168',
  },
  {
    city: 'Russell',
    county_fips: 27083,
    county_fips_all: '27083',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"27083": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 44.33136,
    longitude: -96.00555,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56169',
  },
  {
    city: 'Ruthton',
    county_fips: 27117,
    county_fips_all: '27117|27101|27083|27081',
    county: 'Pipestone',
    county_names_all: 'Pipestone|Murray|Lyon|Lincoln',
    county_weights:
      '{"27117": 49.45, "27101": 37.84, "27083": 7.9, "27081": 4.81}',
    density: 3.4,
    imprecise: false,
    latitude: 44.16694,
    longitude: -96.08647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56170',
  },
  {
    city: 'Sherburn',
    county_fips: 27091,
    county_fips_all: '27091',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"27091": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 43.66902,
    longitude: -94.75925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56171',
  },
  {
    city: 'Slayton',
    county_fips: 27101,
    county_fips_all: '27101',
    county: 'Murray',
    county_names_all: 'Murray',
    county_weights: '{"27101": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 44.01212,
    longitude: -95.7702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2987,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56172',
  },
  {
    city: 'Steen',
    county_fips: 27133,
    county_fips_all: '27133',
    county: 'Rock',
    county_names_all: 'Rock',
    county_weights: '{"27133": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 43.52505,
    longitude: -96.24186,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56173',
  },
  {
    city: 'Storden',
    county_fips: 27033,
    county_fips_all: '27033',
    county: 'Cottonwood',
    county_names_all: 'Cottonwood',
    county_weights: '{"27033": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 44.01525,
    longitude: -95.30466,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56174',
  },
  {
    city: 'Tracy',
    county_fips: 27083,
    county_fips_all: '27083|27101|27127',
    county: 'Lyon',
    county_names_all: 'Lyon|Murray|Redwood',
    county_weights: '{"27083": 53.91, "27101": 24.05, "27127": 22.04}',
    density: 8.5,
    imprecise: false,
    latitude: 44.25595,
    longitude: -95.63733,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56175',
  },
  {
    city: 'Trimont',
    county_fips: 27091,
    county_fips_all: '27091',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"27091": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 43.78319,
    longitude: -94.72835,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56176',
  },
  {
    city: 'Tyler',
    county_fips: 27081,
    county_fips_all: '27081|27083',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Lyon',
    county_weights: '{"27081": 85.62, "27083": 14.38}',
    density: 7.7,
    imprecise: false,
    latitude: 44.28593,
    longitude: -96.12997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56178',
  },
  {
    city: 'Walnut Grove',
    county_fips: 27127,
    county_fips_all: '27127|27101|27033',
    county: 'Redwood',
    county_names_all: 'Redwood|Murray|Cottonwood',
    county_weights: '{"27127": 71.44, "27101": 15.88, "27033": 12.68}',
    density: 4.2,
    imprecise: false,
    latitude: 44.24424,
    longitude: -95.46655,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56180',
  },
  {
    city: 'Welcome',
    county_fips: 27091,
    county_fips_all: '27091',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"27091": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 43.67951,
    longitude: -94.61549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56181',
  },
  {
    city: 'Westbrook',
    county_fips: 27033,
    county_fips_all: '27033|27101',
    county: 'Cottonwood',
    county_names_all: 'Cottonwood|Murray',
    county_weights: '{"27033": 73.6, "27101": 26.4}',
    density: 5,
    imprecise: false,
    latitude: 44.03404,
    longitude: -95.42334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56183',
  },
  {
    city: 'Wilmont',
    county_fips: 27105,
    county_fips_all: '27105',
    county: 'Nobles',
    county_names_all: 'Nobles',
    county_weights: '{"27105": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 43.7932,
    longitude: -95.82659,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56185',
  },
  {
    city: 'Woodstock',
    county_fips: 27117,
    county_fips_all: '27117|27101',
    county: 'Pipestone',
    county_names_all: 'Pipestone|Murray',
    county_weights: '{"27117": 60.56, "27101": 39.44}',
    density: 2.8,
    imprecise: false,
    latitude: 44.02823,
    longitude: -96.08131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56186',
  },
  {
    city: 'Worthington',
    county_fips: 27105,
    county_fips_all: '27105|27063',
    county: 'Nobles',
    county_names_all: 'Nobles|Jackson',
    county_weights: '{"27105": 92.55, "27063": 7.45}',
    density: 34.8,
    imprecise: false,
    latitude: 43.62357,
    longitude: -95.58507,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56187',
  },
  {
    city: 'Willmar',
    county_fips: 27067,
    county_fips_all: '27067',
    county: 'Kandiyohi',
    county_names_all: 'Kandiyohi',
    county_weights: '{"27067": 100}',
    density: 82.2,
    imprecise: false,
    latitude: 45.10181,
    longitude: -95.04226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56201',
  },
  {
    city: 'Alberta',
    county_fips: 27149,
    county_fips_all: '27149|27151',
    county: 'Stevens',
    county_names_all: 'Stevens|Swift',
    county_weights: '{"27149": 94.16, "27151": 5.84}',
    density: 1.7,
    imprecise: false,
    latitude: 45.50266,
    longitude: -96.0708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56207',
  },
  {
    city: 'Appleton',
    county_fips: 27151,
    county_fips_all: '27151|27073|27011|27023',
    county: 'Swift',
    county_names_all: 'Swift|Lac qui Parle|Big Stone|Chippewa',
    county_weights:
      '{"27151": 81.38, "27073": 12.05, "27011": 4.46, "27023": 2.11}',
    density: 4.2,
    imprecise: false,
    latitude: 45.24422,
    longitude: -96.00961,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56208',
  },
  {
    city: 'Atwater',
    county_fips: 27067,
    county_fips_all: '27067|27093',
    county: 'Kandiyohi',
    county_names_all: 'Kandiyohi|Meeker',
    county_weights: '{"27067": 81.14, "27093": 18.86}',
    density: 9.8,
    imprecise: false,
    latitude: 45.124,
    longitude: -94.79931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56209',
  },
  {
    city: 'Barry',
    county_fips: 27011,
    county_fips_all: '27011',
    county: 'Big Stone',
    county_names_all: 'Big Stone',
    county_weights: '{"27011": 100}',
    density: 34.3,
    imprecise: false,
    latitude: 45.55739,
    longitude: -96.55958,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56210',
  },
  {
    city: 'Beardsley',
    county_fips: 27011,
    county_fips_all: '27011|27155',
    county: 'Big Stone',
    county_names_all: 'Big Stone|Traverse',
    county_weights: '{"27011": 54.12, "27155": 45.88}',
    density: 1.8,
    imprecise: false,
    latitude: 45.58641,
    longitude: -96.6828,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56211',
  },
  {
    city: 'Bellingham',
    county_fips: 27073,
    county_fips_all: '27073',
    county: 'Lac qui Parle',
    county_names_all: 'Lac qui Parle',
    county_weights: '{"27073": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 45.13499,
    longitude: -96.32459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56212',
  },
  {
    city: 'Belview',
    county_fips: 27127,
    county_fips_all: '27127|27173',
    county: 'Redwood',
    county_names_all: 'Redwood|Yellow Medicine',
    county_weights: '{"27127": 84.52, "27173": 15.48}',
    density: 3.9,
    imprecise: false,
    latitude: 44.60804,
    longitude: -95.32943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56214',
  },
  {
    city: 'Benson',
    county_fips: 27151,
    county_fips_all: '27151|27121',
    county: 'Swift',
    county_names_all: 'Swift|Pope',
    county_weights: '{"27151": 92.5, "27121": 7.5}',
    density: 8.6,
    imprecise: false,
    latitude: 45.31077,
    longitude: -95.57233,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56215',
  },
  {
    city: 'Blomkest',
    county_fips: 27067,
    county_fips_all: '27067',
    county: 'Kandiyohi',
    county_names_all: 'Kandiyohi',
    county_weights: '{"27067": 100}',
    density: 6,
    imprecise: false,
    latitude: 44.93886,
    longitude: -95.05532,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56216',
  },
  {
    city: 'Boyd',
    county_fips: 27073,
    county_fips_all: '27073|27173',
    county: 'Lac qui Parle',
    county_names_all: 'Lac qui Parle|Yellow Medicine',
    county_weights: '{"27073": 61.71, "27173": 38.29}',
    density: 1.7,
    imprecise: false,
    latitude: 44.82642,
    longitude: -95.94363,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56218',
  },
  {
    city: 'Browns Valley',
    county_fips: 46109,
    county_fips_all: '46109|27155|27011',
    county: 'Roberts',
    county_names_all: 'Roberts|Traverse|Big Stone',
    county_weights: '{"46109": 55.12, "27155": 36.6, "27011": 8.28}',
    density: 3,
    imprecise: false,
    latitude: 45.5977,
    longitude: -96.81913,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56219',
  },
  {
    city: 'Canby',
    county_fips: 27173,
    county_fips_all: '27173|27073|27081|46039',
    county: 'Yellow Medicine',
    county_names_all: 'Yellow Medicine|Lac qui Parle|Lincoln|Deuel',
    county_weights:
      '{"27173": 68.07, "27073": 19.36, "27081": 12.35, "46039": 0.22}',
    density: 3.7,
    imprecise: false,
    latitude: 44.73125,
    longitude: -96.29339,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56220',
  },
  {
    city: 'Chokio',
    county_fips: 27149,
    county_fips_all: '27149|27011|27155',
    county: 'Stevens',
    county_names_all: 'Stevens|Big Stone|Traverse',
    county_weights: '{"27149": 87.8, "27011": 10.1, "27155": 2.1}',
    density: 2,
    imprecise: false,
    latitude: 45.55583,
    longitude: -96.1938,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56221',
  },
  {
    city: 'Clara City',
    county_fips: 27023,
    county_fips_all: '27023',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"27023": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 44.98586,
    longitude: -95.36229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56222',
  },
  {
    city: 'Clarkfield',
    county_fips: 27173,
    county_fips_all: '27173',
    county: 'Yellow Medicine',
    county_names_all: 'Yellow Medicine',
    county_weights: '{"27173": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 44.76259,
    longitude: -95.81691,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56223',
  },
  {
    city: 'Clements',
    county_fips: 27127,
    county_fips_all: '27127',
    county: 'Redwood',
    county_names_all: 'Redwood',
    county_weights: '{"27127": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 44.37628,
    longitude: -95.05854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56224',
  },
  {
    city: 'Clinton',
    county_fips: 27011,
    county_fips_all: '27011',
    county: 'Big Stone',
    county_names_all: 'Big Stone',
    county_weights: '{"27011": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 45.45325,
    longitude: -96.4482,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56225',
  },
  {
    city: 'Clontarf',
    county_fips: 27121,
    county_fips_all: '27121|27151',
    county: 'Pope',
    county_names_all: 'Pope|Swift',
    county_weights: '{"27121": 50.65, "27151": 49.35}',
    density: 2.3,
    imprecise: false,
    latitude: 45.41065,
    longitude: -95.67705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56226',
  },
  {
    city: 'Correll',
    county_fips: 27011,
    county_fips_all: '27011|27151',
    county: 'Big Stone',
    county_names_all: 'Big Stone|Swift',
    county_weights: '{"27011": 99.9, "27151": 0.1}',
    density: 1.5,
    imprecise: false,
    latitude: 45.29436,
    longitude: -96.16938,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56227',
  },
  {
    city: 'Cosmos',
    county_fips: 27093,
    county_fips_all: '27093|27129',
    county: 'Meeker',
    county_names_all: 'Meeker|Renville',
    county_weights: '{"27093": 93.01, "27129": 6.99}',
    density: 6.2,
    imprecise: false,
    latitude: 44.93619,
    longitude: -94.67715,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56228',
  },
  {
    city: 'Cottonwood',
    county_fips: 27083,
    county_fips_all: '27083|27173',
    county: 'Lyon',
    county_names_all: 'Lyon|Yellow Medicine',
    county_weights: '{"27083": 78.33, "27173": 21.67}',
    density: 6.3,
    imprecise: false,
    latitude: 44.59385,
    longitude: -95.72398,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56229',
  },
  {
    city: 'Danube',
    county_fips: 27129,
    county_fips_all: '27129',
    county: 'Renville',
    county_names_all: 'Renville',
    county_weights: '{"27129": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 44.79284,
    longitude: -95.09288,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56230',
  },
  {
    city: 'Danvers',
    county_fips: 27151,
    county_fips_all: '27151',
    county: 'Swift',
    county_names_all: 'Swift',
    county_weights: '{"27151": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 45.2788,
    longitude: -95.76381,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56231',
  },
  {
    city: 'Dawson',
    county_fips: 27073,
    county_fips_all: '27073',
    county: 'Lac qui Parle',
    county_names_all: 'Lac qui Parle',
    county_weights: '{"27073": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 44.92836,
    longitude: -96.03968,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56232',
  },
  {
    city: 'Donnelly',
    county_fips: 27149,
    county_fips_all: '27149',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"27149": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 45.70588,
    longitude: -96.01079,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56235',
  },
  {
    city: 'Dumont',
    county_fips: 27155,
    county_fips_all: '27155|27011',
    county: 'Traverse',
    county_names_all: 'Traverse|Big Stone',
    county_weights: '{"27155": 93.94, "27011": 6.06}',
    density: 1.8,
    imprecise: false,
    latitude: 45.66341,
    longitude: -96.40312,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56236',
  },
  {
    city: 'Echo',
    county_fips: 27173,
    county_fips_all: '27173',
    county: 'Yellow Medicine',
    county_names_all: 'Yellow Medicine',
    county_weights: '{"27173": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 44.61956,
    longitude: -95.43489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56237',
  },
  {
    city: 'Ghent',
    county_fips: 27083,
    county_fips_all: '27083',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"27083": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 44.50416,
    longitude: -95.91079,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56239',
  },
  {
    city: 'Graceville',
    county_fips: 27011,
    county_fips_all: '27011|27155',
    county: 'Big Stone',
    county_names_all: 'Big Stone|Traverse',
    county_weights: '{"27011": 64.45, "27155": 35.55}',
    density: 2.1,
    imprecise: false,
    latitude: 45.56327,
    longitude: -96.47475,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56240',
  },
  {
    city: 'Granite Falls',
    county_fips: 27173,
    county_fips_all: '27173|27023|27129',
    county: 'Yellow Medicine',
    county_names_all: 'Yellow Medicine|Chippewa|Renville',
    county_weights: '{"27173": 67.79, "27023": 22.51, "27129": 9.7}',
    density: 10.4,
    imprecise: false,
    latitude: 44.79654,
    longitude: -95.57944,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56241',
  },
  {
    city: 'Grove City',
    county_fips: 27093,
    county_fips_all: '27093',
    county: 'Meeker',
    county_names_all: 'Meeker',
    county_weights: '{"27093": 100}',
    density: 8,
    imprecise: false,
    latitude: 45.16868,
    longitude: -94.6799,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56243',
  },
  {
    city: 'Hancock',
    county_fips: 27149,
    county_fips_all: '27149|27121|27151',
    county: 'Stevens',
    county_names_all: 'Stevens|Pope|Swift',
    county_weights: '{"27149": 59.39, "27121": 34.28, "27151": 6.33}',
    density: 5.4,
    imprecise: false,
    latitude: 45.48372,
    longitude: -95.77963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56244',
  },
  {
    city: 'Hanley Falls',
    county_fips: 27173,
    county_fips_all: '27173',
    county: 'Yellow Medicine',
    county_names_all: 'Yellow Medicine',
    county_weights: '{"27173": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 44.68508,
    longitude: -95.67574,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56245',
  },
  {
    city: 'Herman',
    county_fips: 27051,
    county_fips_all: '27051|27149|27155',
    county: 'Grant',
    county_names_all: 'Grant|Stevens|Traverse',
    county_weights: '{"27051": 69.16, "27149": 17.31, "27155": 13.53}',
    density: 2.1,
    imprecise: false,
    latitude: 45.79317,
    longitude: -96.13677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56248',
  },
  {
    city: 'Holloway',
    county_fips: 27151,
    county_fips_all: '27151',
    county: 'Swift',
    county_names_all: 'Swift',
    county_weights: '{"27151": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 45.31795,
    longitude: -95.89899,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56249',
  },
  {
    city: 'Kandiyohi',
    county_fips: 27067,
    county_fips_all: '27067',
    county: 'Kandiyohi',
    county_names_all: 'Kandiyohi',
    county_weights: '{"27067": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 45.14046,
    longitude: -94.9198,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56251',
  },
  {
    city: 'Kerkhoven',
    county_fips: 27151,
    county_fips_all: '27151|27023|27067',
    county: 'Swift',
    county_names_all: 'Swift|Chippewa|Kandiyohi',
    county_weights: '{"27151": 59.72, "27023": 32.1, "27067": 8.18}',
    density: 6.8,
    imprecise: false,
    latitude: 45.17785,
    longitude: -95.30397,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56252',
  },
  {
    city: 'Lake Lillian',
    county_fips: 27067,
    county_fips_all: '27067',
    county: 'Kandiyohi',
    county_names_all: 'Kandiyohi',
    county_weights: '{"27067": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 44.9628,
    longitude: -94.87889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56253',
  },
  {
    city: 'Lucan',
    county_fips: 27127,
    county_fips_all: '27127',
    county: 'Redwood',
    county_names_all: 'Redwood',
    county_weights: '{"27127": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 44.39426,
    longitude: -95.41707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56255',
  },
  {
    city: 'Madison',
    county_fips: 27073,
    county_fips_all: '27073',
    county: 'Lac qui Parle',
    county_names_all: 'Lac qui Parle',
    county_weights: '{"27073": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 45.02306,
    longitude: -96.19986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56256',
  },
  {
    city: 'Marietta',
    county_fips: 27073,
    county_fips_all: '27073|46039',
    county: 'Lac qui Parle',
    county_names_all: 'Lac qui Parle|Deuel',
    county_weights: '{"27073": 95.08, "46039": 4.92}',
    density: 1.6,
    imprecise: false,
    latitude: 44.9684,
    longitude: -96.40275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56257',
  },
  {
    city: 'Marshall',
    county_fips: 27083,
    county_fips_all: '27083|27127',
    county: 'Lyon',
    county_names_all: 'Lyon|Redwood',
    county_weights: '{"27083": 96.02, "27127": 3.98}',
    density: 31.7,
    imprecise: false,
    latitude: 44.44121,
    longitude: -95.75906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56258',
  },
  {
    city: 'Maynard',
    county_fips: 27023,
    county_fips_all: '27023|27129',
    county: 'Chippewa',
    county_names_all: 'Chippewa|Renville',
    county_weights: '{"27023": 87.39, "27129": 12.61}',
    density: 3.6,
    imprecise: false,
    latitude: 44.96338,
    longitude: -95.48571,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56260',
  },
  {
    city: 'Milan',
    county_fips: 27023,
    county_fips_all: '27023|27151',
    county: 'Chippewa',
    county_names_all: 'Chippewa|Swift',
    county_weights: '{"27023": 80.37, "27151": 19.63}',
    density: 4.9,
    imprecise: false,
    latitude: 45.12276,
    longitude: -95.86843,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56262',
  },
  {
    city: 'Milroy',
    county_fips: 27127,
    county_fips_all: '27127|27083',
    county: 'Redwood',
    county_names_all: 'Redwood|Lyon',
    county_weights: '{"27127": 83.85, "27083": 16.15}',
    density: 3.4,
    imprecise: false,
    latitude: 44.41577,
    longitude: -95.54086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56263',
  },
  {
    city: 'Minneota',
    county_fips: 27083,
    county_fips_all: '27083|27173|27081',
    county: 'Lyon',
    county_names_all: 'Lyon|Yellow Medicine|Lincoln',
    county_weights: '{"27083": 69.91, "27173": 25.8, "27081": 4.29}',
    density: 6.8,
    imprecise: false,
    latitude: 44.57529,
    longitude: -95.98001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56264',
  },
  {
    city: 'Montevideo',
    county_fips: 27023,
    county_fips_all: '27023|27073|27173',
    county: 'Chippewa',
    county_names_all: 'Chippewa|Lac qui Parle|Yellow Medicine',
    county_weights: '{"27023": 75.15, "27073": 18.9, "27173": 5.95}',
    density: 10.6,
    imprecise: false,
    latitude: 45.0064,
    longitude: -95.70098,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56265',
  },
  {
    city: 'Morgan',
    county_fips: 27127,
    county_fips_all: '27127|27015',
    county: 'Redwood',
    county_names_all: 'Redwood|Brown',
    county_weights: '{"27127": 75.6, "27015": 24.4}',
    density: 6.1,
    imprecise: false,
    latitude: 44.41637,
    longitude: -94.9133,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56266',
  },
  {
    city: 'Morris',
    county_fips: 27149,
    county_fips_all: '27149',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"27149": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 45.58512,
    longitude: -95.9322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56267',
  },
  {
    city: 'Morton',
    county_fips: 27129,
    county_fips_all: '27129|27127',
    county: 'Renville',
    county_names_all: 'Renville|Redwood',
    county_weights: '{"27129": 62.98, "27127": 37.02}',
    density: 8.6,
    imprecise: false,
    latitude: 44.56013,
    longitude: -94.97962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56270',
  },
  {
    city: 'Murdock',
    county_fips: 27151,
    county_fips_all: '27151|27023',
    county: 'Swift',
    county_names_all: 'Swift|Chippewa',
    county_weights: '{"27151": 82.04, "27023": 17.96}',
    density: 3.4,
    imprecise: false,
    latitude: 45.24125,
    longitude: -95.41288,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56271',
  },
  {
    city: 'New London',
    county_fips: 27067,
    county_fips_all: '27067',
    county: 'Kandiyohi',
    county_names_all: 'Kandiyohi',
    county_weights: '{"27067": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 45.32163,
    longitude: -94.96777,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56273',
  },
  {
    city: 'Norcross',
    county_fips: 27051,
    county_fips_all: '27051|27155',
    county: 'Grant',
    county_names_all: 'Grant|Traverse',
    county_weights: '{"27051": 62.59, "27155": 37.41}',
    density: 0.8,
    imprecise: false,
    latitude: 45.90145,
    longitude: -96.2383,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56274',
  },
  {
    city: 'Odessa',
    county_fips: 27073,
    county_fips_all: '27073|27011',
    county: 'Lac qui Parle',
    county_names_all: 'Lac qui Parle|Big Stone',
    county_weights: '{"27073": 51.84, "27011": 48.16}',
    density: 1.8,
    imprecise: false,
    latitude: 45.24134,
    longitude: -96.31249,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56276',
  },
  {
    city: 'Olivia',
    county_fips: 27129,
    county_fips_all: '27129',
    county: 'Renville',
    county_names_all: 'Renville',
    county_weights: '{"27129": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 44.76742,
    longitude: -94.99036,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56277',
  },
  {
    city: 'Ortonville',
    county_fips: 27011,
    county_fips_all: '27011|27073',
    county: 'Big Stone',
    county_names_all: 'Big Stone|Lac qui Parle',
    county_weights: '{"27011": 90.19, "27073": 9.81}',
    density: 7.7,
    imprecise: false,
    latitude: 45.345,
    longitude: -96.37718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56278',
  },
  {
    city: 'Pennock',
    county_fips: 27067,
    county_fips_all: '27067',
    county: 'Kandiyohi',
    county_names_all: 'Kandiyohi',
    county_weights: '{"27067": 100}',
    density: 7,
    imprecise: false,
    latitude: 45.21651,
    longitude: -95.17585,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56279',
  },
  {
    city: 'Porter',
    county_fips: 27081,
    county_fips_all: '27081|27173',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Yellow Medicine',
    county_weights: '{"27081": 50.32, "27173": 49.68}',
    density: 3,
    imprecise: false,
    latitude: 44.63212,
    longitude: -96.16719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56280',
  },
  {
    city: 'Prinsburg',
    county_fips: 27067,
    county_fips_all: '27067',
    county: 'Kandiyohi',
    county_names_all: 'Kandiyohi',
    county_weights: '{"27067": 100}',
    density: 23.5,
    imprecise: false,
    latitude: 44.94833,
    longitude: -95.16479,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56281',
  },
  {
    city: 'Raymond',
    county_fips: 27067,
    county_fips_all: '27067|27023',
    county: 'Kandiyohi',
    county_names_all: 'Kandiyohi|Chippewa',
    county_weights: '{"27067": 67.29, "27023": 32.71}',
    density: 5.3,
    imprecise: false,
    latitude: 45.03089,
    longitude: -95.21862,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56282',
  },
  {
    city: 'Redwood Falls',
    county_fips: 27127,
    county_fips_all: '27127|27129',
    county: 'Redwood',
    county_names_all: 'Redwood|Renville',
    county_weights: '{"27127": 83.96, "27129": 16.04}',
    density: 14,
    imprecise: false,
    latitude: 44.53208,
    longitude: -95.14225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56283',
  },
  {
    city: 'Renville',
    county_fips: 27129,
    county_fips_all: '27129|27067|27127',
    county: 'Renville',
    county_names_all: 'Renville|Kandiyohi|Redwood',
    county_weights: '{"27129": 87.82, "27067": 9.02, "27127": 3.16}',
    density: 6.2,
    imprecise: false,
    latitude: 44.77729,
    longitude: -95.20204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56284',
  },
  {
    city: 'Sacred Heart',
    county_fips: 27129,
    county_fips_all: '27129',
    county: 'Renville',
    county_names_all: 'Renville',
    county_weights: '{"27129": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 44.78837,
    longitude: -95.34797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56285',
  },
  {
    city: 'Seaforth',
    county_fips: 27127,
    county_fips_all: '27127',
    county: 'Redwood',
    county_names_all: 'Redwood',
    county_weights: '{"27127": 100}',
    density: 85.3,
    imprecise: false,
    latitude: 44.47537,
    longitude: -95.3262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 98,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56287',
  },
  {
    city: 'Spicer',
    county_fips: 27067,
    county_fips_all: '27067',
    county: 'Kandiyohi',
    county_names_all: 'Kandiyohi',
    county_weights: '{"27067": 100}',
    density: 37.2,
    imprecise: false,
    latitude: 45.24218,
    longitude: -94.94847,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56288',
  },
  {
    city: 'Sunburg',
    county_fips: 27067,
    county_fips_all: '27067|27151',
    county: 'Kandiyohi',
    county_names_all: 'Kandiyohi|Swift',
    county_weights: '{"27067": 70.36, "27151": 29.64}',
    density: 4.5,
    imprecise: false,
    latitude: 45.33334,
    longitude: -95.2236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56289',
  },
  {
    city: 'Taunton',
    county_fips: 27173,
    county_fips_all: '27173|27083|27081',
    county: 'Yellow Medicine',
    county_names_all: 'Yellow Medicine|Lyon|Lincoln',
    county_weights: '{"27173": 42.43, "27083": 31.42, "27081": 26.15}',
    density: 2.3,
    imprecise: false,
    latitude: 44.62254,
    longitude: -96.06933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56291',
  },
  {
    city: 'Vesta',
    county_fips: 27127,
    county_fips_all: '27127|27173',
    county: 'Redwood',
    county_names_all: 'Redwood|Yellow Medicine',
    county_weights: '{"27127": 96.48, "27173": 3.52}',
    density: 3.9,
    imprecise: false,
    latitude: 44.49734,
    longitude: -95.44863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56292',
  },
  {
    city: 'Wabasso',
    county_fips: 27127,
    county_fips_all: '27127',
    county: 'Redwood',
    county_names_all: 'Redwood',
    county_weights: '{"27127": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 44.41598,
    longitude: -95.26559,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56293',
  },
  {
    city: 'Wanda',
    county_fips: 27127,
    county_fips_all: '27127',
    county: 'Redwood',
    county_names_all: 'Redwood',
    county_weights: '{"27127": 100}',
    density: 155,
    imprecise: false,
    latitude: 44.31481,
    longitude: -95.21313,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56294',
  },
  {
    city: 'Watson',
    county_fips: 27023,
    county_fips_all: '27023',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"27023": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 45.0437,
    longitude: -95.84292,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56295',
  },
  {
    city: 'Wheaton',
    county_fips: 27155,
    county_fips_all: '27155',
    county: 'Traverse',
    county_names_all: 'Traverse',
    county_weights: '{"27155": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 45.82981,
    longitude: -96.46953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56296',
  },
  {
    city: 'Wood Lake',
    county_fips: 27173,
    county_fips_all: '27173|27127',
    county: 'Yellow Medicine',
    county_names_all: 'Yellow Medicine|Redwood',
    county_weights: '{"27173": 94.06, "27127": 5.94}',
    density: 4.6,
    imprecise: false,
    latitude: 44.63005,
    longitude: -95.54428,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56297',
  },
  {
    city: 'Saint Cloud',
    county_fips: 27145,
    county_fips_all: '27145|27141',
    county: 'Stearns',
    county_names_all: 'Stearns|Sherburne',
    county_weights: '{"27145": 99.83, "27141": 0.17}',
    density: 179.4,
    imprecise: false,
    latitude: 45.48718,
    longitude: -94.24307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56301',
  },
  {
    city: 'Saint Cloud',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 909.8,
    imprecise: false,
    latitude: 45.57422,
    longitude: -94.21117,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56303',
  },
  {
    city: 'Saint Cloud',
    county_fips: 27141,
    county_fips_all: '27141|27009',
    county: 'Sherburne',
    county_names_all: 'Sherburne|Benton',
    county_weights: '{"27141": 86.81, "27009": 13.19}',
    density: 111.2,
    imprecise: false,
    latitude: 45.52512,
    longitude: -94.05199,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56304',
  },
  {
    city: 'Albany',
    county_fips: 27145,
    county_fips_all: '27145|27097',
    county: 'Stearns',
    county_names_all: 'Stearns|Morrison',
    county_weights: '{"27145": 99.31, "27097": 0.69}',
    density: 19.7,
    imprecise: false,
    latitude: 45.62666,
    longitude: -94.58769,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56307',
  },
  {
    city: 'Alexandria',
    county_fips: 27041,
    county_fips_all: '27041|27121',
    county: 'Douglas',
    county_names_all: 'Douglas|Pope',
    county_weights: '{"27041": 96.15, "27121": 3.85}',
    density: 66.9,
    imprecise: false,
    latitude: 45.87047,
    longitude: -95.38985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56308',
  },
  {
    city: 'Ashby',
    county_fips: 27051,
    county_fips_all: '27051|27111|27041',
    county: 'Grant',
    county_names_all: 'Grant|Otter Tail|Douglas',
    county_weights: '{"27051": 59.93, "27111": 34.85, "27041": 5.22}',
    density: 8.7,
    imprecise: false,
    latitude: 46.08035,
    longitude: -95.80202,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56309',
  },
  {
    city: 'Avon',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 45.63399,
    longitude: -94.44352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56310',
  },
  {
    city: 'Barrett',
    county_fips: 27051,
    county_fips_all: '27051',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"27051": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 45.89756,
    longitude: -95.89852,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56311',
  },
  {
    city: 'Belgrade',
    county_fips: 27145,
    county_fips_all: '27145|27067',
    county: 'Stearns',
    county_names_all: 'Stearns|Kandiyohi',
    county_weights: '{"27145": 74.47, "27067": 25.53}',
    density: 5.1,
    imprecise: false,
    latitude: 45.46285,
    longitude: -94.95323,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56312',
  },
  {
    city: 'Bock',
    county_fips: 27095,
    county_fips_all: '27095',
    county: 'Mille Lacs',
    county_names_all: 'Mille Lacs',
    county_weights: '{"27095": 100}',
    density: 131,
    imprecise: false,
    latitude: 45.78403,
    longitude: -93.55273,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56313',
  },
  {
    city: 'Bowlus',
    county_fips: 27097,
    county_fips_all: '27097|27145',
    county: 'Morrison',
    county_names_all: 'Morrison|Stearns',
    county_weights: '{"27097": 90.31, "27145": 9.69}',
    density: 12.7,
    imprecise: false,
    latitude: 45.81139,
    longitude: -94.43189,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56314',
  },
  {
    city: 'Brandon',
    county_fips: 27041,
    county_fips_all: '27041|27111',
    county: 'Douglas',
    county_names_all: 'Douglas|Otter Tail',
    county_weights: '{"27041": 96.83, "27111": 3.17}',
    density: 10.1,
    imprecise: false,
    latitude: 45.97996,
    longitude: -95.59211,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56315',
  },
  {
    city: 'Brooten',
    county_fips: 27121,
    county_fips_all: '27121|27145|27067',
    county: 'Pope',
    county_names_all: 'Pope|Stearns|Kandiyohi',
    county_weights: '{"27121": 52.28, "27145": 36.29, "27067": 11.43}',
    density: 4.2,
    imprecise: false,
    latitude: 45.49959,
    longitude: -95.14992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56316',
  },
  {
    city: 'Burtrum',
    county_fips: 27153,
    county_fips_all: '27153|27097',
    county: 'Todd',
    county_names_all: 'Todd|Morrison',
    county_weights: '{"27153": 68.14, "27097": 31.86}',
    density: 11.5,
    imprecise: false,
    latitude: 45.85332,
    longitude: -94.67085,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56318',
  },
  {
    city: 'Carlos',
    county_fips: 27041,
    county_fips_all: '27041|27153',
    county: 'Douglas',
    county_names_all: 'Douglas|Todd',
    county_weights: '{"27041": 80.76, "27153": 19.24}',
    density: 12.3,
    imprecise: false,
    latitude: 46.00488,
    longitude: -95.22322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56319',
  },
  {
    city: 'Cold Spring',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 64.1,
    imprecise: false,
    latitude: 45.4629,
    longitude: -94.4171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56320',
  },
  {
    city: 'Collegeville',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 929.7,
    imprecise: false,
    latitude: 45.57969,
    longitude: -94.39288,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56321',
  },
  {
    city: 'Cyrus',
    county_fips: 27121,
    county_fips_all: '27121|27149',
    county: 'Pope',
    county_names_all: 'Pope|Stevens',
    county_weights: '{"27121": 79.94, "27149": 20.06}',
    density: 5.5,
    imprecise: false,
    latitude: 45.63321,
    longitude: -95.72586,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56323',
  },
  {
    city: 'Dalton',
    county_fips: 27111,
    county_fips_all: '27111|27051',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail|Grant',
    county_weights: '{"27111": 98.23, "27051": 1.77}',
    density: 6.8,
    imprecise: false,
    latitude: 46.16385,
    longitude: -95.90766,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56324',
  },
  {
    city: 'Elrosa',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 525.1,
    imprecise: false,
    latitude: 45.56303,
    longitude: -94.94732,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56325',
  },
  {
    city: 'Evansville',
    county_fips: 27041,
    county_fips_all: '27041|27111|27051',
    county: 'Douglas',
    county_names_all: 'Douglas|Otter Tail|Grant',
    county_weights: '{"27041": 89.2, "27111": 8.69, "27051": 2.11}',
    density: 7,
    imprecise: false,
    latitude: 46.02506,
    longitude: -95.68596,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56326',
  },
  {
    city: 'Farwell',
    county_fips: 27121,
    county_fips_all: '27121|27041',
    county: 'Pope',
    county_names_all: 'Pope|Douglas',
    county_weights: '{"27121": 53.38, "27041": 46.62}',
    density: 5.8,
    imprecise: false,
    latitude: 45.75893,
    longitude: -95.61336,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56327',
  },
  {
    city: 'Flensburg',
    county_fips: 27097,
    county_fips_all: '27097',
    county: 'Morrison',
    county_names_all: 'Morrison',
    county_weights: '{"27097": 100}',
    density: 26.8,
    imprecise: false,
    latitude: 45.9519,
    longitude: -94.52147,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56328',
  },
  {
    city: 'Foley',
    county_fips: 27009,
    county_fips_all: '27009|27097|27141',
    county: 'Benton',
    county_names_all: 'Benton|Morrison|Sherburne',
    county_weights: '{"27009": 88.02, "27097": 11.63, "27141": 0.35}',
    density: 15.6,
    imprecise: false,
    latitude: 45.70934,
    longitude: -93.90577,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56329',
  },
  {
    city: 'Foreston',
    county_fips: 27095,
    county_fips_all: '27095|27009',
    county: 'Mille Lacs',
    county_names_all: 'Mille Lacs|Benton',
    county_weights: '{"27095": 62.62, "27009": 37.38}',
    density: 20.5,
    imprecise: false,
    latitude: 45.75018,
    longitude: -93.75117,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56330',
  },
  {
    city: 'Freeport',
    county_fips: 27145,
    county_fips_all: '27145|27097',
    county: 'Stearns',
    county_names_all: 'Stearns|Morrison',
    county_weights: '{"27145": 98.89, "27097": 1.11}',
    density: 11.5,
    imprecise: false,
    latitude: 45.67926,
    longitude: -94.6742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56331',
  },
  {
    city: 'Garfield',
    county_fips: 27041,
    county_fips_all: '27041',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"27041": 100}',
    density: 12,
    imprecise: false,
    latitude: 45.96993,
    longitude: -95.50554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56332',
  },
  {
    city: 'Glenwood',
    county_fips: 27121,
    county_fips_all: '27121|27041',
    county: 'Pope',
    county_names_all: 'Pope|Douglas',
    county_weights: '{"27121": 98.76, "27041": 1.24}',
    density: 10.9,
    imprecise: false,
    latitude: 45.58402,
    longitude: -95.34765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56334',
  },
  {
    city: 'Greenwald',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 146.3,
    imprecise: false,
    latitude: 45.60137,
    longitude: -94.85941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56335',
  },
  {
    city: 'Grey Eagle',
    county_fips: 27153,
    county_fips_all: '27153|27145',
    county: 'Todd',
    county_names_all: 'Todd|Stearns',
    county_weights: '{"27153": 97.0, "27145": 3.0}',
    density: 12.4,
    imprecise: false,
    latitude: 45.82349,
    longitude: -94.76175,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56336',
  },
  {
    city: 'Hillman',
    county_fips: 27097,
    county_fips_all: '27097|27035',
    county: 'Morrison',
    county_names_all: 'Morrison|Crow Wing',
    county_weights: '{"27097": 94.17, "27035": 5.83}',
    density: 3.7,
    imprecise: false,
    latitude: 46.00631,
    longitude: -93.88089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56338',
  },
  {
    city: 'Hoffman',
    county_fips: 27051,
    county_fips_all: '27051|27041',
    county: 'Grant',
    county_names_all: 'Grant|Douglas',
    county_weights: '{"27051": 85.72, "27041": 14.28}',
    density: 7.1,
    imprecise: false,
    latitude: 45.8258,
    longitude: -95.82129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56339',
  },
  {
    city: 'Holdingford',
    county_fips: 27145,
    county_fips_all: '27145|27097',
    county: 'Stearns',
    county_names_all: 'Stearns|Morrison',
    county_weights: '{"27145": 71.58, "27097": 28.42}',
    density: 17.5,
    imprecise: false,
    latitude: 45.75534,
    longitude: -94.44871,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56340',
  },
  {
    city: 'Isle',
    county_fips: 27001,
    county_fips_all: '27001|27065|27095',
    county: 'Aitkin',
    county_names_all: 'Aitkin|Kanabec|Mille Lacs',
    county_weights: '{"27001": 39.71, "27065": 34.63, "27095": 25.66}',
    density: 5.6,
    imprecise: false,
    latitude: 46.18347,
    longitude: -93.40392,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56342',
  },
  {
    city: 'Kensington',
    county_fips: 27041,
    county_fips_all: '27041|27121|27149|27051',
    county: 'Douglas',
    county_names_all: 'Douglas|Pope|Stevens|Grant',
    county_weights:
      '{"27041": 67.74, "27121": 16.78, "27149": 10.2, "27051": 5.28}',
    density: 4.2,
    imprecise: false,
    latitude: 45.79088,
    longitude: -95.69765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56343',
  },
  {
    city: 'Little Falls',
    county_fips: 27097,
    county_fips_all: '27097',
    county: 'Morrison',
    county_names_all: 'Morrison',
    county_weights: '{"27097": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 46.00748,
    longitude: -94.38032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56345',
  },
  {
    city: 'Long Prairie',
    county_fips: 27153,
    county_fips_all: '27153|27097',
    county: 'Todd',
    county_names_all: 'Todd|Morrison',
    county_weights: '{"27153": 96.65, "27097": 3.35}',
    density: 15.9,
    imprecise: false,
    latitude: 45.96978,
    longitude: -94.86155,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56347',
  },
  {
    city: 'Lowry',
    county_fips: 27121,
    county_fips_all: '27121|27041',
    county: 'Pope',
    county_names_all: 'Pope|Douglas',
    county_weights: '{"27121": 87.37, "27041": 12.63}',
    density: 7.7,
    imprecise: false,
    latitude: 45.72373,
    longitude: -95.52456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56349',
  },
  {
    city: 'McGrath',
    county_fips: 27001,
    county_fips_all: '27001',
    county: 'Aitkin',
    county_names_all: 'Aitkin',
    county_weights: '{"27001": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 46.31101,
    longitude: -93.23922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56350',
  },
  {
    city: 'Melrose',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 21.5,
    imprecise: false,
    latitude: 45.65078,
    longitude: -94.80076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56352',
  },
  {
    city: 'Milaca',
    county_fips: 27095,
    county_fips_all: '27095|27059|27065|27097',
    county: 'Mille Lacs',
    county_names_all: 'Mille Lacs|Isanti|Kanabec|Morrison',
    county_weights:
      '{"27095": 94.59, "27059": 2.69, "27065": 2.6, "27097": 0.12}',
    density: 19.4,
    imprecise: false,
    latitude: 45.79667,
    longitude: -93.62587,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56353',
  },
  {
    city: 'Miltona',
    county_fips: 27041,
    county_fips_all: '27041',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"27041": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 46.06034,
    longitude: -95.27496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56354',
  },
  {
    city: 'Nelson',
    county_fips: 27041,
    county_fips_all: '27041',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"27041": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 45.94007,
    longitude: -95.24031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56355',
  },
  {
    city: 'New Munich',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 62.2,
    imprecise: false,
    latitude: 45.63334,
    longitude: -94.73332,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56356',
  },
  {
    city: 'Oak Park',
    county_fips: 27009,
    county_fips_all: '27009|27095',
    county: 'Benton',
    county_names_all: 'Benton|Mille Lacs',
    county_weights: '{"27009": 79.37, "27095": 20.63}',
    density: 13,
    imprecise: false,
    latitude: 45.69684,
    longitude: -93.8007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56357',
  },
  {
    city: 'Ogilvie',
    county_fips: 27065,
    county_fips_all: '27065|27095|27059',
    county: 'Kanabec',
    county_names_all: 'Kanabec|Mille Lacs|Isanti',
    county_weights: '{"27065": 82.21, "27095": 13.16, "27059": 4.63}',
    density: 9.6,
    imprecise: false,
    latitude: 45.84069,
    longitude: -93.4488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56358',
  },
  {
    city: 'Onamia',
    county_fips: 27095,
    county_fips_all: '27095',
    county: 'Mille Lacs',
    county_names_all: 'Mille Lacs',
    county_weights: '{"27095": 100}',
    density: 8,
    imprecise: false,
    latitude: 46.08979,
    longitude: -93.67786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56359',
  },
  {
    city: 'Osakis',
    county_fips: 27153,
    county_fips_all: '27153|27041',
    county: 'Todd',
    county_names_all: 'Todd|Douglas',
    county_weights: '{"27153": 55.04, "27041": 44.96}',
    density: 10.8,
    imprecise: false,
    latitude: 45.87482,
    longitude: -95.12686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56360',
  },
  {
    city: 'Parkers Prairie',
    county_fips: 27111,
    county_fips_all: '27111|27041',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail|Douglas',
    county_weights: '{"27111": 83.55, "27041": 16.45}',
    density: 6.3,
    imprecise: false,
    latitude: 46.16146,
    longitude: -95.3351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56361',
  },
  {
    city: 'Paynesville',
    county_fips: 27145,
    county_fips_all: '27145|27093|27067',
    county: 'Stearns',
    county_names_all: 'Stearns|Meeker|Kandiyohi',
    county_weights: '{"27145": 76.84, "27093": 13.57, "27067": 9.59}',
    density: 14.9,
    imprecise: false,
    latitude: 45.40524,
    longitude: -94.71525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56362',
  },
  {
    city: 'Pease',
    county_fips: 27095,
    county_fips_all: '27095',
    county: 'Mille Lacs',
    county_names_all: 'Mille Lacs',
    county_weights: '{"27095": 100}',
    density: 82.6,
    imprecise: false,
    latitude: 45.69627,
    longitude: -93.65409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56363',
  },
  {
    city: 'Pierz',
    county_fips: 27097,
    county_fips_all: '27097|27035',
    county: 'Morrison',
    county_names_all: 'Morrison|Crow Wing',
    county_weights: '{"27097": 95.43, "27035": 4.57}',
    density: 9.2,
    imprecise: false,
    latitude: 46.01605,
    longitude: -94.06704,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56364',
  },
  {
    city: 'Rice',
    county_fips: 27009,
    county_fips_all: '27009|27145',
    county: 'Benton',
    county_names_all: 'Benton|Stearns',
    county_weights: '{"27009": 82.48, "27145": 17.52}',
    density: 27.4,
    imprecise: false,
    latitude: 45.76107,
    longitude: -94.17026,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56367',
  },
  {
    city: 'Richmond',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 23.3,
    imprecise: false,
    latitude: 45.45158,
    longitude: -94.5392,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56368',
  },
  {
    city: 'Rockville',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 396.5,
    imprecise: false,
    latitude: 45.46904,
    longitude: -94.3359,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56369',
  },
  {
    city: 'Roscoe',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 75.9,
    imprecise: false,
    latitude: 45.43333,
    longitude: -94.63707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 95,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56371',
  },
  {
    city: 'Royalton',
    county_fips: 27097,
    county_fips_all: '27097|27009',
    county: 'Morrison',
    county_names_all: 'Morrison|Benton',
    county_weights: '{"27097": 90.35, "27009": 9.65}',
    density: 12.9,
    imprecise: false,
    latitude: 45.85456,
    longitude: -94.23789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56373',
  },
  {
    city: 'Saint Joseph',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 58.3,
    imprecise: false,
    latitude: 45.60381,
    longitude: -94.33816,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56374',
  },
  {
    city: 'Saint Stephen',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 71,
    imprecise: false,
    latitude: 45.70122,
    longitude: -94.27458,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56375',
  },
  {
    city: 'Saint Martin',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 156.9,
    imprecise: false,
    latitude: 45.50241,
    longitude: -94.66731,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56376',
  },
  {
    city: 'Sartell',
    county_fips: 27145,
    county_fips_all: '27145|27009',
    county: 'Stearns',
    county_names_all: 'Stearns|Benton',
    county_weights: '{"27145": 96.51, "27009": 3.49}',
    density: 363.6,
    imprecise: false,
    latitude: 45.6405,
    longitude: -94.23033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56377',
  },
  {
    city: 'Sauk Centre',
    county_fips: 27145,
    county_fips_all: '27145|27153',
    county: 'Stearns',
    county_names_all: 'Stearns|Todd',
    county_weights: '{"27145": 71.23, "27153": 28.77}',
    density: 16.5,
    imprecise: false,
    latitude: 45.72308,
    longitude: -94.97982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56378',
  },
  {
    city: 'Sauk Rapids',
    county_fips: 27009,
    county_fips_all: '27009|27141',
    county: 'Benton',
    county_names_all: 'Benton|Sherburne',
    county_weights: '{"27009": 99.51, "27141": 0.49}',
    density: 76,
    imprecise: false,
    latitude: 45.63966,
    longitude: -94.08394,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56379',
  },
  {
    city: 'Starbuck',
    county_fips: 27121,
    county_fips_all: '27121',
    county: 'Pope',
    county_names_all: 'Pope',
    county_weights: '{"27121": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 45.55523,
    longitude: -95.54669,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56381',
  },
  {
    city: 'Swanville',
    county_fips: 27097,
    county_fips_all: '27097|27153',
    county: 'Morrison',
    county_names_all: 'Morrison|Todd',
    county_weights: '{"27097": 76.2, "27153": 23.8}',
    density: 7.8,
    imprecise: false,
    latitude: 45.9146,
    longitude: -94.611,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56382',
  },
  {
    city: 'Upsala',
    county_fips: 27097,
    county_fips_all: '27097',
    county: 'Morrison',
    county_names_all: 'Morrison',
    county_weights: '{"27097": 100}',
    density: 116,
    imprecise: false,
    latitude: 45.8099,
    longitude: -94.56759,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56384',
  },
  {
    city: 'Villard',
    county_fips: 27121,
    county_fips_all: '27121|27145|27041',
    county: 'Pope',
    county_names_all: 'Pope|Stearns|Douglas',
    county_weights: '{"27121": 83.52, "27145": 13.85, "27041": 2.63}',
    density: 4.8,
    imprecise: false,
    latitude: 45.70349,
    longitude: -95.20681,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56385',
  },
  {
    city: 'Wahkon',
    county_fips: 27095,
    county_fips_all: '27095',
    county: 'Mille Lacs',
    county_names_all: 'Mille Lacs',
    county_weights: '{"27095": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 46.11402,
    longitude: -93.52176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56386',
  },
  {
    city: 'Waite Park',
    county_fips: 27145,
    county_fips_all: '27145',
    county: 'Stearns',
    county_names_all: 'Stearns',
    county_weights: '{"27145": 100}',
    density: 334.7,
    imprecise: false,
    latitude: 45.53215,
    longitude: -94.24141,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56387',
  },
  {
    city: 'West Union',
    county_fips: 27153,
    county_fips_all: '27153',
    county: 'Todd',
    county_names_all: 'Todd',
    county_weights: '{"27153": 100}',
    density: 41.3,
    imprecise: false,
    latitude: 45.79961,
    longitude: -95.08832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56389',
  },
  {
    city: 'Brainerd',
    county_fips: 27035,
    county_fips_all: '27035|27021',
    county: 'Crow Wing',
    county_names_all: 'Crow Wing|Cass',
    county_weights: '{"27035": 91.78, "27021": 8.22}',
    density: 38.1,
    imprecise: false,
    latitude: 46.32259,
    longitude: -94.11974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56401',
  },
  {
    city: 'Baxter',
    county_fips: 27035,
    county_fips_all: '27035',
    county: 'Crow Wing',
    county_names_all: 'Crow Wing',
    county_weights: '{"27035": 100}',
    density: 188.9,
    imprecise: false,
    latitude: 46.34162,
    longitude: -94.28308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56425',
  },
  {
    city: 'Aitkin',
    county_fips: 27001,
    county_fips_all: '27001|27035',
    county: 'Aitkin',
    county_names_all: 'Aitkin|Crow Wing',
    county_weights: '{"27001": 87.08, "27035": 12.92}',
    density: 7.8,
    imprecise: false,
    latitude: 46.4828,
    longitude: -93.64356,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56431',
  },
  {
    city: 'Akeley',
    county_fips: 27057,
    county_fips_all: '27057|27021',
    county: 'Hubbard',
    county_names_all: 'Hubbard|Cass',
    county_weights: '{"27057": 69.63, "27021": 30.37}',
    density: 5.7,
    imprecise: false,
    latitude: 46.9598,
    longitude: -94.68519,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56433',
  },
  {
    city: 'Aldrich',
    county_fips: 27153,
    county_fips_all: '27153|27159',
    county: 'Todd',
    county_names_all: 'Todd|Wadena',
    county_weights: '{"27153": 83.73, "27159": 16.27}',
    density: 4.7,
    imprecise: false,
    latitude: 46.33797,
    longitude: -94.93437,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56434',
  },
  {
    city: 'Backus',
    county_fips: 27021,
    county_fips_all: '27021|27035',
    county: 'Cass',
    county_names_all: 'Cass|Crow Wing',
    county_weights: '{"27021": 99.08, "27035": 0.92}',
    density: 6.8,
    imprecise: false,
    latitude: 46.80872,
    longitude: -94.53089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56435',
  },
  {
    city: 'Bertha',
    county_fips: 27153,
    county_fips_all: '27153|27111',
    county: 'Todd',
    county_names_all: 'Todd|Otter Tail',
    county_weights: '{"27153": 88.49, "27111": 11.51}',
    density: 8.2,
    imprecise: false,
    latitude: 46.25049,
    longitude: -95.05654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56437',
  },
  {
    city: 'Browerville',
    county_fips: 27153,
    county_fips_all: '27153',
    county: 'Todd',
    county_names_all: 'Todd',
    county_weights: '{"27153": 100}',
    density: 8,
    imprecise: false,
    latitude: 46.13873,
    longitude: -94.80874,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56438',
  },
  {
    city: 'Clarissa',
    county_fips: 27153,
    county_fips_all: '27153',
    county: 'Todd',
    county_names_all: 'Todd',
    county_weights: '{"27153": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 46.14658,
    longitude: -94.9573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56440',
  },
  {
    city: 'Crosby',
    county_fips: 27035,
    county_fips_all: '27035',
    county: 'Crow Wing',
    county_names_all: 'Crow Wing',
    county_weights: '{"27035": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 46.58625,
    longitude: -93.9865,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56441',
  },
  {
    city: 'Crosslake',
    county_fips: 27035,
    county_fips_all: '27035',
    county: 'Crow Wing',
    county_names_all: 'Crow Wing',
    county_weights: '{"27035": 100}',
    density: 30.3,
    imprecise: false,
    latitude: 46.67629,
    longitude: -94.09726,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56442',
  },
  {
    city: 'Cushing',
    county_fips: 27097,
    county_fips_all: '27097|27153',
    county: 'Morrison',
    county_names_all: 'Morrison|Todd',
    county_weights: '{"27097": 69.31, "27153": 30.69}',
    density: 4.6,
    imprecise: false,
    latitude: 46.1916,
    longitude: -94.57565,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56443',
  },
  {
    city: 'Deerwood',
    county_fips: 27035,
    county_fips_all: '27035',
    county: 'Crow Wing',
    county_names_all: 'Crow Wing',
    county_weights: '{"27035": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 46.4175,
    longitude: -93.87804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56444',
  },
  {
    city: 'Eagle Bend',
    county_fips: 27153,
    county_fips_all: '27153|27111|27041',
    county: 'Todd',
    county_names_all: 'Todd|Otter Tail|Douglas',
    county_weights: '{"27153": 82.86, "27111": 12.5, "27041": 4.64}',
    density: 5.7,
    imprecise: false,
    latitude: 46.12448,
    longitude: -95.08966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56446',
  },
  {
    city: 'Emily',
    county_fips: 27035,
    county_fips_all: '27035',
    county: 'Crow Wing',
    county_names_all: 'Crow Wing',
    county_weights: '{"27035": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 46.74151,
    longitude: -93.90262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56447',
  },
  {
    city: 'Fifty Lakes',
    county_fips: 27035,
    county_fips_all: '27035|27021',
    county: 'Crow Wing',
    county_names_all: 'Crow Wing|Cass',
    county_weights: '{"27035": 65.25, "27021": 34.75}',
    density: 4,
    imprecise: false,
    latitude: 46.78604,
    longitude: -94.09014,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56448',
  },
  {
    city: 'Fort Ripley',
    county_fips: 27035,
    county_fips_all: '27035|27097',
    county: 'Crow Wing',
    county_names_all: 'Crow Wing|Morrison',
    county_weights: '{"27035": 66.83, "27097": 33.17}',
    density: 7.4,
    imprecise: false,
    latitude: 46.17436,
    longitude: -94.27214,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56449',
  },
  {
    city: 'Garrison',
    county_fips: 27035,
    county_fips_all: '27035|27095',
    county: 'Crow Wing',
    county_names_all: 'Crow Wing|Mille Lacs',
    county_weights: '{"27035": 89.16, "27095": 10.84}',
    density: 14.4,
    imprecise: false,
    latitude: 46.23341,
    longitude: -93.8361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56450',
  },
  {
    city: 'Hackensack',
    county_fips: 27021,
    county_fips_all: '27021',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"27021": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 46.94808,
    longitude: -94.46123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56452',
  },
  {
    city: 'Hewitt',
    county_fips: 27111,
    county_fips_all: '27111|27153',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail|Todd',
    county_weights: '{"27111": 59.12, "27153": 40.88}',
    density: 6.1,
    imprecise: false,
    latitude: 46.31374,
    longitude: -95.16161,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56453',
  },
  {
    city: 'Ironton',
    county_fips: 27035,
    county_fips_all: '27035',
    county: 'Crow Wing',
    county_names_all: 'Crow Wing',
    county_weights: '{"27035": 100}',
    density: 26.6,
    imprecise: false,
    latitude: 46.44953,
    longitude: -94.00681,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56455',
  },
  {
    city: 'Lake George',
    county_fips: 27057,
    county_fips_all: '27057',
    county: 'Hubbard',
    county_names_all: 'Hubbard',
    county_weights: '{"27057": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 47.19924,
    longitude: -94.99341,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56458',
  },
  {
    city: 'Laporte',
    county_fips: 27057,
    county_fips_all: '27057|27021',
    county: 'Hubbard',
    county_names_all: 'Hubbard|Cass',
    county_weights: '{"27057": 97.14, "27021": 2.86}',
    density: 4.5,
    imprecise: false,
    latitude: 47.22817,
    longitude: -94.85877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56461',
  },
  {
    city: 'Menahga',
    county_fips: 27159,
    county_fips_all: '27159|27005|27057|27111|27021',
    county: 'Wadena',
    county_names_all: 'Wadena|Becker|Hubbard|Otter Tail|Cass',
    county_weights:
      '{"27159": 46.93, "27005": 33.56, "27057": 14.42, "27111": 4.23, "27021": 0.86}',
    density: 7.6,
    imprecise: false,
    latitude: 46.76538,
    longitude: -95.10382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56464',
  },
  {
    city: 'Merrifield',
    county_fips: 27035,
    county_fips_all: '27035',
    county: 'Crow Wing',
    county_names_all: 'Crow Wing',
    county_weights: '{"27035": 100}',
    density: 24.8,
    imprecise: false,
    latitude: 46.53459,
    longitude: -94.11381,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56465',
  },
  {
    city: 'Motley',
    county_fips: 27021,
    county_fips_all: '27021|27097|27153',
    county: 'Cass',
    county_names_all: 'Cass|Morrison|Todd',
    county_weights: '{"27021": 69.91, "27097": 19.43, "27153": 10.66}',
    density: 6.6,
    imprecise: false,
    latitude: 46.41522,
    longitude: -94.63137,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56466',
  },
  {
    city: 'Nevis',
    county_fips: 27057,
    county_fips_all: '27057',
    county: 'Hubbard',
    county_names_all: 'Hubbard',
    county_weights: '{"27057": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 46.97714,
    longitude: -94.83753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56467',
  },
  {
    city: 'Nisswa',
    county_fips: 27035,
    county_fips_all: '27035|27021',
    county: 'Crow Wing',
    county_names_all: 'Crow Wing|Cass',
    county_weights: '{"27035": 61.12, "27021": 38.88}',
    density: 35,
    imprecise: false,
    latitude: 46.49141,
    longitude: -94.29856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56468',
  },
  {
    city: 'Palisade',
    county_fips: 27001,
    county_fips_all: '27001',
    county: 'Aitkin',
    county_names_all: 'Aitkin',
    county_weights: '{"27001": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 46.77701,
    longitude: -93.5463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56469',
  },
  {
    city: 'Park Rapids',
    county_fips: 27057,
    county_fips_all: '27057|27005|27029|27159',
    county: 'Hubbard',
    county_names_all: 'Hubbard|Becker|Clearwater|Wadena',
    county_weights:
      '{"27057": 67.13, "27005": 22.15, "27029": 10.12, "27159": 0.6}',
    density: 11.3,
    imprecise: false,
    latitude: 47.02368,
    longitude: -95.09433,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56470',
  },
  {
    city: 'Pequot Lakes',
    county_fips: 27021,
    county_fips_all: '27021|27035',
    county: 'Cass',
    county_names_all: 'Cass|Crow Wing',
    county_weights: '{"27021": 54.66, "27035": 45.34}',
    density: 22,
    imprecise: false,
    latitude: 46.57507,
    longitude: -94.34884,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56472',
  },
  {
    city: 'Pillager',
    county_fips: 27021,
    county_fips_all: '27021|27097',
    county: 'Cass',
    county_names_all: 'Cass|Morrison',
    county_weights: '{"27021": 80.53, "27097": 19.47}',
    density: 15.1,
    imprecise: false,
    latitude: 46.35649,
    longitude: -94.48355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56473',
  },
  {
    city: 'Pine River',
    county_fips: 27021,
    county_fips_all: '27021|27035',
    county: 'Cass',
    county_names_all: 'Cass|Crow Wing',
    county_weights: '{"27021": 70.47, "27035": 29.53}',
    density: 7.5,
    imprecise: false,
    latitude: 46.72238,
    longitude: -94.39597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56474',
  },
  {
    city: 'Randall',
    county_fips: 27097,
    county_fips_all: '27097',
    county: 'Morrison',
    county_names_all: 'Morrison',
    county_weights: '{"27097": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 46.08361,
    longitude: -94.53985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56475',
  },
  {
    city: 'Sebeka',
    county_fips: 27159,
    county_fips_all: '27159|27111|27021',
    county: 'Wadena',
    county_names_all: 'Wadena|Otter Tail|Cass',
    county_weights: '{"27159": 67.55, "27111": 21.03, "27021": 11.42}',
    density: 4,
    imprecise: false,
    latitude: 46.64363,
    longitude: -94.99653,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56477',
  },
  {
    city: 'Staples',
    county_fips: 27153,
    county_fips_all: '27153|27159|27021',
    county: 'Todd',
    county_names_all: 'Todd|Wadena|Cass',
    county_weights: '{"27153": 36.22, "27159": 32.16, "27021": 31.62}',
    density: 9.7,
    imprecise: false,
    latitude: 46.43719,
    longitude: -94.78939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56479',
  },
  {
    city: 'Verndale',
    county_fips: 27159,
    county_fips_all: '27159|27153|27021',
    county: 'Wadena',
    county_names_all: 'Wadena|Todd|Cass',
    county_weights: '{"27159": 74.19, "27153": 18.18, "27021": 7.63}',
    density: 6.2,
    imprecise: false,
    latitude: 46.46706,
    longitude: -94.93446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56481',
  },
  {
    city: 'Wadena',
    county_fips: 27159,
    county_fips_all: '27159|27111|27153',
    county: 'Wadena',
    county_names_all: 'Wadena|Otter Tail|Todd',
    county_weights: '{"27159": 54.41, "27111": 44.49, "27153": 1.1}',
    density: 21.6,
    imprecise: false,
    latitude: 46.46555,
    longitude: -95.14307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56482',
  },
  {
    city: 'Walker',
    county_fips: 27021,
    county_fips_all: '27021|27057',
    county: 'Cass',
    county_names_all: 'Cass|Hubbard',
    county_weights: '{"27021": 99.7, "27057": 0.3}',
    density: 13.7,
    imprecise: false,
    latitude: 47.09744,
    longitude: -94.47416,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56484',
  },
  {
    city: 'Detroit Lakes',
    county_fips: 27005,
    county_fips_all: '27005|27111',
    county: 'Becker',
    county_names_all: 'Becker|Otter Tail',
    county_weights: '{"27005": 92.04, "27111": 7.96}',
    density: 37.2,
    imprecise: false,
    latitude: 46.83665,
    longitude: -95.82233,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56501',
  },
  {
    city: 'Ada',
    county_fips: 27107,
    county_fips_all: '27107',
    county: 'Norman',
    county_names_all: 'Norman',
    county_weights: '{"27107": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 47.35811,
    longitude: -96.52316,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56510',
  },
  {
    city: 'Audubon',
    county_fips: 27005,
    county_fips_all: '27005',
    county: 'Becker',
    county_names_all: 'Becker',
    county_weights: '{"27005": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 46.8532,
    longitude: -96.00763,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56511',
  },
  {
    city: 'Barnesville',
    county_fips: 27027,
    county_fips_all: '27027|27167|27111',
    county: 'Clay',
    county_names_all: 'Clay|Wilkin|Otter Tail',
    county_weights: '{"27027": 61.86, "27167": 35.7, "27111": 2.44}',
    density: 7.3,
    imprecise: false,
    latitude: 46.64892,
    longitude: -96.43486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56514',
  },
  {
    city: 'Battle Lake',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 46.29444,
    longitude: -95.708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56515',
  },
  {
    city: 'Bejou',
    county_fips: 27087,
    county_fips_all: '27087|27107',
    county: 'Mahnomen',
    county_names_all: 'Mahnomen|Norman',
    county_weights: '{"27087": 88.15, "27107": 11.85}',
    density: 1.6,
    imprecise: false,
    latitude: 47.44368,
    longitude: -95.96663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56516',
  },
  {
    city: 'Beltrami',
    county_fips: 27119,
    county_fips_all: '27119|27107',
    county: 'Polk',
    county_names_all: 'Polk|Norman',
    county_weights: '{"27119": 95.63, "27107": 4.37}',
    density: 1,
    imprecise: false,
    latitude: 47.55474,
    longitude: -96.53825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56517',
  },
  {
    city: 'Bluffton',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 46.48926,
    longitude: -95.24506,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56518',
  },
  {
    city: 'Borup',
    county_fips: 27107,
    county_fips_all: '27107|27027',
    county: 'Norman',
    county_names_all: 'Norman|Clay',
    county_weights: '{"27107": 60.15, "27027": 39.85}',
    density: 1.1,
    imprecise: false,
    latitude: 47.15914,
    longitude: -96.4877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56519',
  },
  {
    city: 'Breckenridge',
    county_fips: 27167,
    county_fips_all: '27167',
    county: 'Wilkin',
    county_names_all: 'Wilkin',
    county_weights: '{"27167": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 46.28645,
    longitude: -96.50361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56520',
  },
  {
    city: 'Callaway',
    county_fips: 27005,
    county_fips_all: '27005',
    county: 'Becker',
    county_names_all: 'Becker',
    county_weights: '{"27005": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 46.99691,
    longitude: -95.89783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56521',
  },
  {
    city: 'Campbell',
    county_fips: 27167,
    county_fips_all: '27167|27111',
    county: 'Wilkin',
    county_names_all: 'Wilkin|Otter Tail',
    county_weights: '{"27167": 87.63, "27111": 12.37}',
    density: 1.6,
    imprecise: false,
    latitude: 46.1352,
    longitude: -96.3887,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56522',
  },
  {
    city: 'Climax',
    county_fips: 27119,
    county_fips_all: '27119',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"27119": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 47.63838,
    longitude: -96.80871,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56523',
  },
  {
    city: 'Clitherall',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 6,
    imprecise: false,
    latitude: 46.21115,
    longitude: -95.606,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56524',
  },
  {
    city: 'Comstock',
    county_fips: 27027,
    county_fips_all: '27027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"27027": 100}',
    density: 33,
    imprecise: false,
    latitude: 46.6716,
    longitude: -96.75195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56525',
  },
  {
    city: 'Deer Creek',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 46.37383,
    longitude: -95.31806,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56527',
  },
  {
    city: 'Dent',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 46.53066,
    longitude: -95.80983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56528',
  },
  {
    city: 'Dilworth',
    county_fips: 27027,
    county_fips_all: '27027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"27027": 100}',
    density: 493,
    imprecise: false,
    latitude: 46.88027,
    longitude: -96.69754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56529',
  },
  {
    city: 'Elbow Lake',
    county_fips: 27051,
    county_fips_all: '27051',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"27051": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 45.98967,
    longitude: -95.98376,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56531',
  },
  {
    city: 'Elizabeth',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 46.40393,
    longitude: -96.15144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56533',
  },
  {
    city: 'Erhard',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 46.46325,
    longitude: -96.01431,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56534',
  },
  {
    city: 'Erskine',
    county_fips: 27119,
    county_fips_all: '27119|27125',
    county: 'Polk',
    county_names_all: 'Polk|Red Lake',
    county_weights: '{"27119": 88.11, "27125": 11.89}',
    density: 5.7,
    imprecise: false,
    latitude: 47.67541,
    longitude: -96.04611,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56535',
  },
  {
    city: 'Felton',
    county_fips: 27027,
    county_fips_all: '27027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"27027": 100}',
    density: 2,
    imprecise: false,
    latitude: 47.04596,
    longitude: -96.53173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56536',
  },
  {
    city: 'Fergus Falls',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 27.1,
    imprecise: false,
    latitude: 46.27697,
    longitude: -96.08977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56537',
  },
  {
    city: 'Fertile',
    county_fips: 27119,
    county_fips_all: '27119|27107',
    county: 'Polk',
    county_names_all: 'Polk|Norman',
    county_weights: '{"27119": 73.87, "27107": 26.13}',
    density: 4.2,
    imprecise: false,
    latitude: 47.54255,
    longitude: -96.27671,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56540',
  },
  {
    city: 'Flom',
    county_fips: 27107,
    county_fips_all: '27107',
    county: 'Norman',
    county_names_all: 'Norman',
    county_weights: '{"27107": 100}',
    density: 3,
    imprecise: false,
    latitude: 47.16606,
    longitude: -96.13081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56541',
  },
  {
    city: 'Fosston',
    county_fips: 27119,
    county_fips_all: '27119|27087',
    county: 'Polk',
    county_names_all: 'Polk|Mahnomen',
    county_weights: '{"27119": 80.23, "27087": 19.77}',
    density: 5.3,
    imprecise: false,
    latitude: 47.56679,
    longitude: -95.72331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56542',
  },
  {
    city: 'Foxhome',
    county_fips: 27167,
    county_fips_all: '27167',
    county: 'Wilkin',
    county_names_all: 'Wilkin',
    county_weights: '{"27167": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 46.28541,
    longitude: -96.33654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56543',
  },
  {
    city: 'Frazee',
    county_fips: 27005,
    county_fips_all: '27005|27111',
    county: 'Becker',
    county_names_all: 'Becker|Otter Tail',
    county_weights: '{"27005": 76.81, "27111": 23.19}',
    density: 11.2,
    imprecise: false,
    latitude: 46.75894,
    longitude: -95.59693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56544',
  },
  {
    city: 'Gary',
    county_fips: 27107,
    county_fips_all: '27107',
    county: 'Norman',
    county_names_all: 'Norman',
    county_weights: '{"27107": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 47.38527,
    longitude: -96.2399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56545',
  },
  {
    city: 'Georgetown',
    county_fips: 27027,
    county_fips_all: '27027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"27027": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 47.10107,
    longitude: -96.73038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56546',
  },
  {
    city: 'Glyndon',
    county_fips: 27027,
    county_fips_all: '27027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"27027": 100}',
    density: 7,
    imprecise: false,
    latitude: 46.89068,
    longitude: -96.55043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56547',
  },
  {
    city: 'Halstad',
    county_fips: 27107,
    county_fips_all: '27107',
    county: 'Norman',
    county_names_all: 'Norman',
    county_weights: '{"27107": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 47.37025,
    longitude: -96.75392,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56548',
  },
  {
    city: 'Hawley',
    county_fips: 27027,
    county_fips_all: '27027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"27027": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 46.85287,
    longitude: -96.31285,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56549',
  },
  {
    city: 'Hendrum',
    county_fips: 27107,
    county_fips_all: '27107',
    county: 'Norman',
    county_names_all: 'Norman',
    county_weights: '{"27107": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 47.2697,
    longitude: -96.74867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56550',
  },
  {
    city: 'Henning',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 46.31856,
    longitude: -95.45081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56551',
  },
  {
    city: 'Hitterdal',
    county_fips: 27027,
    county_fips_all: '27027|27005',
    county: 'Clay',
    county_names_all: 'Clay|Becker',
    county_weights: '{"27027": 73.3, "27005": 26.7}',
    density: 4.4,
    imprecise: false,
    latitude: 46.9814,
    longitude: -96.21602,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56552',
  },
  {
    city: 'Kent',
    county_fips: 27167,
    county_fips_all: '27167',
    county: 'Wilkin',
    county_names_all: 'Wilkin',
    county_weights: '{"27167": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 46.42946,
    longitude: -96.61757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56553',
  },
  {
    city: 'Lake Park',
    county_fips: 27005,
    county_fips_all: '27005|27027',
    county: 'Becker',
    county_names_all: 'Becker|Clay',
    county_weights: '{"27005": 92.09, "27027": 7.91}',
    density: 9.2,
    imprecise: false,
    latitude: 46.88408,
    longitude: -96.11483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56554',
  },
  {
    city: 'Mcintosh',
    county_fips: 27119,
    county_fips_all: '27119',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"27119": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 47.66403,
    longitude: -95.88349,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56556',
  },
  {
    city: 'Mahnomen',
    county_fips: 27087,
    county_fips_all: '27087|27107|27029',
    county: 'Mahnomen',
    county_names_all: 'Mahnomen|Norman|Clearwater',
    county_weights: '{"27087": 93.42, "27107": 3.9, "27029": 2.68}',
    density: 4.5,
    imprecise: false,
    latitude: 47.32422,
    longitude: -95.837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56557',
  },
  {
    city: 'Moorhead',
    county_fips: 27027,
    county_fips_all: '27027|27167',
    county: 'Clay',
    county_names_all: 'Clay|Wilkin',
    county_weights: '{"27027": 98.76, "27167": 1.24}',
    density: 109,
    imprecise: false,
    latitude: 46.83637,
    longitude: -96.73467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56560',
  },
  {
    city: 'Nashua',
    county_fips: 27167,
    county_fips_all: '27167|27051',
    county: 'Wilkin',
    county_names_all: 'Wilkin|Grant',
    county_weights: '{"27167": 75.03, "27051": 24.97}',
    density: 1,
    imprecise: false,
    latitude: 46.04861,
    longitude: -96.31511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56565',
  },
  {
    city: 'Naytahwaush',
    county_fips: 27087,
    county_fips_all: '27087',
    county: 'Mahnomen',
    county_names_all: 'Mahnomen',
    county_weights: '{"27087": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 47.24724,
    longitude: -95.61322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56566',
  },
  {
    city: 'New York Mills',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 46.54896,
    longitude: -95.36707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56567',
  },
  {
    city: 'Nielsville',
    county_fips: 27119,
    county_fips_all: '27119|27107',
    county: 'Polk',
    county_names_all: 'Polk|Norman',
    county_weights: '{"27119": 93.33, "27107": 6.67}',
    density: 1.8,
    imprecise: false,
    latitude: 47.5292,
    longitude: -96.77925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56568',
  },
  {
    city: 'Ogema',
    county_fips: 27005,
    county_fips_all: '27005',
    county: 'Becker',
    county_names_all: 'Becker',
    county_weights: '{"27005": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 47.07482,
    longitude: -95.81956,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56569',
  },
  {
    city: 'Osage',
    county_fips: 27005,
    county_fips_all: '27005',
    county: 'Becker',
    county_names_all: 'Becker',
    county_weights: '{"27005": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 46.91051,
    longitude: -95.35552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56570',
  },
  {
    city: 'Ottertail',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 46.43856,
    longitude: -95.53939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56571',
  },
  {
    city: 'Pelican Rapids',
    county_fips: 27111,
    county_fips_all: '27111|27027|27005|27167',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail|Clay|Becker|Wilkin',
    county_weights:
      '{"27111": 92.13, "27027": 3.94, "27005": 3.43, "27167": 0.5}',
    density: 13.1,
    imprecise: false,
    latitude: 46.60485,
    longitude: -96.08682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56572',
  },
  {
    city: 'Perham',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 20.3,
    imprecise: false,
    latitude: 46.61443,
    longitude: -95.55216,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56573',
  },
  {
    city: 'Perley',
    county_fips: 27107,
    county_fips_all: '27107|27027',
    county: 'Norman',
    county_names_all: 'Norman|Clay',
    county_weights: '{"27107": 98.56, "27027": 1.44}',
    density: 1.5,
    imprecise: false,
    latitude: 47.20085,
    longitude: -96.70242,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56574',
  },
  {
    city: 'Ponsford',
    county_fips: 27005,
    county_fips_all: '27005',
    county: 'Becker',
    county_names_all: 'Becker',
    county_weights: '{"27005": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 47.03827,
    longitude: -95.43146,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56575',
  },
  {
    city: 'Richville',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 46.47164,
    longitude: -95.70537,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56576',
  },
  {
    city: 'Rochert',
    county_fips: 27005,
    county_fips_all: '27005',
    county: 'Becker',
    county_names_all: 'Becker',
    county_weights: '{"27005": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 46.9264,
    longitude: -95.65563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56578',
  },
  {
    city: 'Rothsay',
    county_fips: 27167,
    county_fips_all: '27167|27111',
    county: 'Wilkin',
    county_names_all: 'Wilkin|Otter Tail',
    county_weights: '{"27167": 73.05, "27111": 26.95}',
    density: 2.1,
    imprecise: false,
    latitude: 46.4688,
    longitude: -96.34229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56579',
  },
  {
    city: 'Sabin',
    county_fips: 27027,
    county_fips_all: '27027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"27027": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 46.73944,
    longitude: -96.61004,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56580',
  },
  {
    city: 'Shelly',
    county_fips: 27107,
    county_fips_all: '27107',
    county: 'Norman',
    county_names_all: 'Norman',
    county_weights: '{"27107": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 47.45725,
    longitude: -96.76141,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56581',
  },
  {
    city: 'Tintah',
    county_fips: 27155,
    county_fips_all: '27155|27167',
    county: 'Traverse',
    county_names_all: 'Traverse|Wilkin',
    county_weights: '{"27155": 71.7, "27167": 28.3}',
    density: 0.8,
    imprecise: false,
    latitude: 46.00332,
    longitude: -96.40667,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56583',
  },
  {
    city: 'Twin Valley',
    county_fips: 27107,
    county_fips_all: '27107',
    county: 'Norman',
    county_names_all: 'Norman',
    county_weights: '{"27107": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 47.23087,
    longitude: -96.23496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56584',
  },
  {
    city: 'Ulen',
    county_fips: 27027,
    county_fips_all: '27027|27005|27107',
    county: 'Clay',
    county_names_all: 'Clay|Becker|Norman',
    county_weights: '{"27027": 66.79, "27005": 32.43, "27107": 0.78}',
    density: 3.3,
    imprecise: false,
    latitude: 47.08896,
    longitude: -96.24492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56585',
  },
  {
    city: 'Underwood',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 46.32324,
    longitude: -95.84,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56586',
  },
  {
    city: 'Vergas',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 46.63721,
    longitude: -95.8628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56587',
  },
  {
    city: 'Vining',
    county_fips: 27111,
    county_fips_all: '27111',
    county: 'Otter Tail',
    county_names_all: 'Otter Tail',
    county_weights: '{"27111": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 46.22028,
    longitude: -95.5006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56588',
  },
  {
    city: 'Waubun',
    county_fips: 27087,
    county_fips_all: '27087|27005|27029',
    county: 'Mahnomen',
    county_names_all: 'Mahnomen|Becker|Clearwater',
    county_weights: '{"27087": 59.89, "27005": 26.2, "27029": 13.91}',
    density: 2.8,
    imprecise: false,
    latitude: 47.17959,
    longitude: -95.71984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56589',
  },
  {
    city: 'Wendell',
    county_fips: 27051,
    county_fips_all: '27051|27111',
    county: 'Grant',
    county_names_all: 'Grant|Otter Tail',
    county_weights: '{"27051": 99.4, "27111": 0.6}',
    density: 1.7,
    imprecise: false,
    latitude: 46.03514,
    longitude: -96.16093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56590',
  },
  {
    city: 'White Earth',
    county_fips: 27005,
    county_fips_all: '27005',
    county: 'Becker',
    county_names_all: 'Becker',
    county_weights: '{"27005": 100}',
    density: 61.7,
    imprecise: false,
    latitude: 47.09968,
    longitude: -95.84357,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56591',
  },
  {
    city: 'Winger',
    county_fips: 27119,
    county_fips_all: '27119|27087',
    county: 'Polk',
    county_names_all: 'Polk|Mahnomen',
    county_weights: '{"27119": 89.96, "27087": 10.04}',
    density: 3.6,
    imprecise: false,
    latitude: 47.53542,
    longitude: -96.00769,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56592',
  },
  {
    city: 'Wolverton',
    county_fips: 27167,
    county_fips_all: '27167',
    county: 'Wilkin',
    county_names_all: 'Wilkin',
    county_weights: '{"27167": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 46.54906,
    longitude: -96.64493,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56594',
  },
  {
    city: 'Bemidji',
    county_fips: 27007,
    county_fips_all: '27007|27057',
    county: 'Beltrami',
    county_names_all: 'Beltrami|Hubbard',
    county_weights: '{"27007": 83.98, "27057": 16.02}',
    density: 36.2,
    imprecise: false,
    latitude: 47.50985,
    longitude: -94.84921,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56601',
  },
  {
    city: 'Bagley',
    county_fips: 27029,
    county_fips_all: '27029|27119|27087',
    county: 'Clearwater',
    county_names_all: 'Clearwater|Polk|Mahnomen',
    county_weights: '{"27029": 98.02, "27119": 1.69, "27087": 0.29}',
    density: 5.2,
    imprecise: false,
    latitude: 47.40975,
    longitude: -95.41597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56621',
  },
  {
    city: 'Baudette',
    county_fips: 27077,
    county_fips_all: '27077|27071',
    county: 'Lake of the Woods',
    county_names_all: 'Lake of the Woods|Koochiching',
    county_weights: '{"27077": 82.75, "27071": 17.25}',
    density: 2.4,
    imprecise: false,
    latitude: 48.59722,
    longitude: -94.56913,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56623',
  },
  {
    city: 'Bena',
    county_fips: 27021,
    county_fips_all: '27021',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"27021": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 47.36404,
    longitude: -94.18421,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56626',
  },
  {
    city: 'Big Falls',
    county_fips: 27071,
    county_fips_all: '27071',
    county: 'Koochiching',
    county_names_all: 'Koochiching',
    county_weights: '{"27071": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 48.1953,
    longitude: -94.04118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56627',
  },
  {
    city: 'Bigfork',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 47.69575,
    longitude: -93.5215,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56628',
  },
  {
    city: 'Birchdale',
    county_fips: 27071,
    county_fips_all: '27071',
    county: 'Koochiching',
    county_names_all: 'Koochiching',
    county_weights: '{"27071": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.51494,
    longitude: -94.12546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56629',
  },
  {
    city: 'Blackduck',
    county_fips: 27007,
    county_fips_all: '27007|27061',
    county: 'Beltrami',
    county_names_all: 'Beltrami|Itasca',
    county_weights: '{"27007": 71.09, "27061": 28.91}',
    density: 2.7,
    imprecise: false,
    latitude: 47.74432,
    longitude: -94.49852,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56630',
  },
  {
    city: 'Cass Lake',
    county_fips: 27021,
    county_fips_all: '27021|27007|27057',
    county: 'Cass',
    county_names_all: 'Cass|Beltrami|Hubbard',
    county_weights: '{"27021": 80.27, "27007": 13.57, "27057": 6.16}',
    density: 8.6,
    imprecise: false,
    latitude: 47.31957,
    longitude: -94.50911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56633',
  },
  {
    city: 'Clearbrook',
    county_fips: 27029,
    county_fips_all: '27029',
    county: 'Clearwater',
    county_names_all: 'Clearwater',
    county_weights: '{"27029": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 47.68577,
    longitude: -95.40169,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56634',
  },
  {
    city: 'Deer River',
    county_fips: 27061,
    county_fips_all: '27061|27021',
    county: 'Itasca',
    county_names_all: 'Itasca|Cass',
    county_weights: '{"27061": 74.49, "27021": 25.51}',
    density: 4.1,
    imprecise: false,
    latitude: 47.40283,
    longitude: -93.86518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56636',
  },
  {
    city: 'Talmoon',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 47.61872,
    longitude: -93.83941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56637',
  },
  {
    city: 'Effie',
    county_fips: 27061,
    county_fips_all: '27061|27071',
    county: 'Itasca',
    county_names_all: 'Itasca|Koochiching',
    county_weights: '{"27061": 52.82, "27071": 47.18}',
    density: 0.4,
    imprecise: false,
    latitude: 47.90275,
    longitude: -93.53399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56639',
  },
  {
    city: 'Federal Dam',
    county_fips: 27021,
    county_fips_all: '27021',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"27021": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 47.19848,
    longitude: -94.25804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56641',
  },
  {
    city: 'Gonvick',
    county_fips: 27029,
    county_fips_all: '27029|27119',
    county: 'Clearwater',
    county_names_all: 'Clearwater|Polk',
    county_weights: '{"27029": 95.07, "27119": 4.93}',
    density: 3.3,
    imprecise: false,
    latitude: 47.78095,
    longitude: -95.51263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56644',
  },
  {
    city: 'Gully',
    county_fips: 27119,
    county_fips_all: '27119|27029',
    county: 'Polk',
    county_names_all: 'Polk|Clearwater',
    county_weights: '{"27119": 91.61, "27029": 8.39}',
    density: 1.4,
    imprecise: false,
    latitude: 47.78925,
    longitude: -95.62865,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56646',
  },
  {
    city: 'Hines',
    county_fips: 27007,
    county_fips_all: '27007',
    county: 'Beltrami',
    county_names_all: 'Beltrami',
    county_weights: '{"27007": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 47.68782,
    longitude: -94.62187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56647',
  },
  {
    city: 'International Falls',
    county_fips: 27071,
    county_fips_all: '27071|27137',
    county: 'Koochiching',
    county_names_all: 'Koochiching|St. Louis',
    county_weights: '{"27071": 54.86, "27137": 45.14}',
    density: 11.9,
    imprecise: false,
    latitude: 48.53122,
    longitude: -93.13224,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56649',
  },
  {
    city: 'Kelliher',
    county_fips: 27007,
    county_fips_all: '27007',
    county: 'Beltrami',
    county_names_all: 'Beltrami',
    county_weights: '{"27007": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 47.9979,
    longitude: -94.56351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56650',
  },
  {
    city: 'Lengby',
    county_fips: 27087,
    county_fips_all: '27087|27119',
    county: 'Mahnomen',
    county_names_all: 'Mahnomen|Polk',
    county_weights: '{"27087": 82.59, "27119": 17.41}',
    density: 3.6,
    imprecise: false,
    latitude: 47.43883,
    longitude: -95.6172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56651',
  },
  {
    city: 'Leonard',
    county_fips: 27029,
    county_fips_all: '27029|27007',
    county: 'Clearwater',
    county_names_all: 'Clearwater|Beltrami',
    county_weights: '{"27029": 88.41, "27007": 11.59}',
    density: 2.6,
    imprecise: false,
    latitude: 47.71104,
    longitude: -95.23721,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56652',
  },
  {
    city: 'Littlefork',
    county_fips: 27071,
    county_fips_all: '27071',
    county: 'Koochiching',
    county_names_all: 'Koochiching',
    county_weights: '{"27071": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 48.28327,
    longitude: -93.58558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56653',
  },
  {
    city: 'Loman',
    county_fips: 27071,
    county_fips_all: '27071',
    county: 'Koochiching',
    county_names_all: 'Koochiching',
    county_weights: '{"27071": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.47285,
    longitude: -93.94153,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56654',
  },
  {
    city: 'Longville',
    county_fips: 27021,
    county_fips_all: '27021',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"27021": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 46.98292,
    longitude: -94.23014,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56655',
  },
  {
    city: 'Marcell',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 47.57237,
    longitude: -93.61544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56657',
  },
  {
    city: 'Margie',
    county_fips: 27071,
    county_fips_all: '27071',
    county: 'Koochiching',
    county_names_all: 'Koochiching',
    county_weights: '{"27071": 100}',
    density: 0,
    imprecise: false,
    latitude: 48.11248,
    longitude: -93.93302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56658',
  },
  {
    city: 'Max',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 47.62116,
    longitude: -94.01899,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56659',
  },
  {
    city: 'Mizpah',
    county_fips: 27071,
    county_fips_all: '27071',
    county: 'Koochiching',
    county_names_all: 'Koochiching',
    county_weights: '{"27071": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 47.96653,
    longitude: -94.17022,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56660',
  },
  {
    city: 'Northome',
    county_fips: 27071,
    county_fips_all: '27071|27061|27007',
    county: 'Koochiching',
    county_names_all: 'Koochiching|Itasca|Beltrami',
    county_weights: '{"27071": 49.63, "27061": 43.96, "27007": 6.41}',
    density: 0.9,
    imprecise: false,
    latitude: 47.84302,
    longitude: -94.13856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56661',
  },
  {
    city: 'Outing',
    county_fips: 27021,
    county_fips_all: '27021',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"27021": 100}',
    density: 4,
    imprecise: false,
    latitude: 46.84524,
    longitude: -93.89926,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56662',
  },
  {
    city: 'Pennington',
    county_fips: 27007,
    county_fips_all: '27007',
    county: 'Beltrami',
    county_names_all: 'Beltrami',
    county_weights: '{"27007": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 47.49997,
    longitude: -94.45431,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56663',
  },
  {
    city: 'Ponemah',
    county_fips: 27007,
    county_fips_all: '27007',
    county: 'Beltrami',
    county_names_all: 'Beltrami',
    county_weights: '{"27007": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 48.03391,
    longitude: -94.8365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56666',
  },
  {
    city: 'Puposky',
    county_fips: 27007,
    county_fips_all: '27007',
    county: 'Beltrami',
    county_names_all: 'Beltrami',
    county_weights: '{"27007": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 47.73569,
    longitude: -94.94199,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56667',
  },
  {
    city: 'Ranier',
    county_fips: 27071,
    county_fips_all: '27071',
    county: 'Koochiching',
    county_names_all: 'Koochiching',
    county_weights: '{"27071": 100}',
    density: 409.1,
    imprecise: false,
    latitude: 48.61454,
    longitude: -93.3467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56668',
  },
  {
    city: 'Kabetogama',
    county_fips: 27071,
    county_fips_all: '27071|27137',
    county: 'Koochiching',
    county_names_all: 'Koochiching|St. Louis',
    county_weights: '{"27071": 86.14, "27137": 13.86}',
    density: 0.4,
    imprecise: false,
    latitude: 48.37718,
    longitude: -93.22655,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56669',
  },
  {
    city: 'Redby',
    county_fips: 27007,
    county_fips_all: '27007',
    county: 'Beltrami',
    county_names_all: 'Beltrami',
    county_weights: '{"27007": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 47.85001,
    longitude: -94.86912,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56670',
  },
  {
    city: 'Red Lake',
    county_fips: 27029,
    county_fips_all: '27029|27007',
    county: 'Clearwater',
    county_names_all: 'Clearwater|Beltrami',
    county_weights: '{"27029": 58.14, "27007": 41.86}',
    density: 3.6,
    imprecise: false,
    latitude: 47.94006,
    longitude: -95.31791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56671',
  },
  {
    city: 'Remer',
    county_fips: 27021,
    county_fips_all: '27021',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"27021": 100}',
    density: 2,
    imprecise: false,
    latitude: 47.0734,
    longitude: -94.02267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56672',
  },
  {
    city: 'Roosevelt',
    county_fips: 27077,
    county_fips_all: '27077|27135',
    county: 'Lake of the Woods',
    county_names_all: 'Lake of the Woods|Roseau',
    county_weights: '{"27077": 81.18, "27135": 18.82}',
    density: 1.2,
    imprecise: false,
    latitude: 48.74365,
    longitude: -95.13896,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56673',
  },
  {
    city: 'Shevlin',
    county_fips: 27029,
    county_fips_all: '27029|27007',
    county: 'Clearwater',
    county_names_all: 'Clearwater|Beltrami',
    county_weights: '{"27029": 61.51, "27007": 38.49}',
    density: 3.2,
    imprecise: false,
    latitude: 47.52188,
    longitude: -95.19877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56676',
  },
  {
    city: 'Solway',
    county_fips: 27007,
    county_fips_all: '27007|27057|27029',
    county: 'Beltrami',
    county_names_all: 'Beltrami|Hubbard|Clearwater',
    county_weights: '{"27007": 52.43, "27057": 43.0, "27029": 4.57}',
    density: 5.3,
    imprecise: false,
    latitude: 47.4298,
    longitude: -95.11768,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56678',
  },
  {
    city: 'Spring Lake',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 47.6456,
    longitude: -93.96124,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56680',
  },
  {
    city: 'Squaw Lake',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 47.5488,
    longitude: -94.25132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56681',
  },
  {
    city: 'Tenstrike',
    county_fips: 27007,
    county_fips_all: '27007',
    county: 'Beltrami',
    county_names_all: 'Beltrami',
    county_weights: '{"27007": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 47.72124,
    longitude: -94.7512,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56683',
  },
  {
    city: 'Trail',
    county_fips: 27119,
    county_fips_all: '27119|27113|27125',
    county: 'Polk',
    county_names_all: 'Polk|Pennington|Red Lake',
    county_weights: '{"27119": 62.13, "27113": 33.0, "27125": 4.87}',
    density: 0.9,
    imprecise: false,
    latitude: 47.87109,
    longitude: -95.70401,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56684',
  },
  {
    city: 'Waskish',
    county_fips: 27007,
    county_fips_all: '27007|27071',
    county: 'Beltrami',
    county_names_all: 'Beltrami|Koochiching',
    county_weights: '{"27007": 99.84, "27071": 0.16}',
    density: 0.3,
    imprecise: false,
    latitude: 48.23841,
    longitude: -94.51997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56685',
  },
  {
    city: 'Williams',
    county_fips: 27077,
    county_fips_all: '27077',
    county: 'Lake of the Woods',
    county_names_all: 'Lake of the Woods',
    county_weights: '{"27077": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 48.78595,
    longitude: -94.91001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56686',
  },
  {
    city: 'Wirt',
    county_fips: 27061,
    county_fips_all: '27061',
    county: 'Itasca',
    county_names_all: 'Itasca',
    county_weights: '{"27061": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 47.7699,
    longitude: -93.89172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56688',
  },
  {
    city: 'Thief River Falls',
    county_fips: 27113,
    county_fips_all: '27113|27089|27119',
    county: 'Pennington',
    county_names_all: 'Pennington|Marshall|Polk',
    county_weights: '{"27113": 74.4, "27089": 23.76, "27119": 1.84}',
    density: 12.8,
    imprecise: false,
    latitude: 48.12021,
    longitude: -96.1994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56701',
  },
  {
    city: 'Alvarado',
    county_fips: 27089,
    county_fips_all: '27089|27119',
    county: 'Marshall',
    county_names_all: 'Marshall|Polk',
    county_weights: '{"27089": 81.42, "27119": 18.58}',
    density: 4.2,
    imprecise: false,
    latitude: 48.2182,
    longitude: -96.99776,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56710',
  },
  {
    city: 'Angle Inlet',
    county_fips: 27077,
    county_fips_all: '27077',
    county: 'Lake of the Woods',
    county_names_all: 'Lake of the Woods',
    county_weights: '{"27077": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 49.09907,
    longitude: -94.97591,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 85,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56711',
  },
  {
    city: 'Argyle',
    county_fips: 27089,
    county_fips_all: '27089',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"27089": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 48.3487,
    longitude: -96.81717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56713',
  },
  {
    city: 'Badger',
    county_fips: 27135,
    county_fips_all: '27135',
    county: 'Roseau',
    county_names_all: 'Roseau',
    county_weights: '{"27135": 100}',
    density: 2,
    imprecise: false,
    latitude: 48.78845,
    longitude: -96.00529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56714',
  },
  {
    city: 'Brooks',
    county_fips: 27125,
    county_fips_all: '27125|27119',
    county: 'Red Lake',
    county_names_all: 'Red Lake|Polk',
    county_weights: '{"27125": 95.85, "27119": 4.15}',
    density: 2.2,
    imprecise: false,
    latitude: 47.80636,
    longitude: -95.94904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56715',
  },
  {
    city: 'Crookston',
    county_fips: 27119,
    county_fips_all: '27119|27125',
    county: 'Polk',
    county_names_all: 'Polk|Red Lake',
    county_weights: '{"27119": 98.5, "27125": 1.5}',
    density: 10.6,
    imprecise: false,
    latitude: 47.74189,
    longitude: -96.55522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56716',
  },
  {
    city: 'Donaldson',
    county_fips: 27069,
    county_fips_all: '27069',
    county: 'Kittson',
    county_names_all: 'Kittson',
    county_weights: '{"27069": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 48.56788,
    longitude: -96.90632,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56720',
  },
  {
    city: 'East Grand Forks',
    county_fips: 27119,
    county_fips_all: '27119',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"27119": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 47.97108,
    longitude: -96.94336,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56721',
  },
  {
    city: 'Euclid',
    county_fips: 27119,
    county_fips_all: '27119',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"27119": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 47.9825,
    longitude: -96.64644,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56722',
  },
  {
    city: 'Fisher',
    county_fips: 27119,
    county_fips_all: '27119',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"27119": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 47.80493,
    longitude: -96.8059,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56723',
  },
  {
    city: 'Gatzke',
    county_fips: 27089,
    county_fips_all: '27089|27135',
    county: 'Marshall',
    county_names_all: 'Marshall|Roseau',
    county_weights: '{"27089": 98.38, "27135": 1.62}',
    density: 0.3,
    imprecise: false,
    latitude: 48.44534,
    longitude: -95.73473,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56724',
  },
  {
    city: 'Goodridge',
    county_fips: 27113,
    county_fips_all: '27113|27089|27007',
    county: 'Pennington',
    county_names_all: 'Pennington|Marshall|Beltrami',
    county_weights: '{"27113": 42.41, "27089": 30.14, "27007": 27.45}',
    density: 0.9,
    imprecise: false,
    latitude: 48.1477,
    longitude: -95.70485,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56725',
  },
  {
    city: 'Greenbush',
    county_fips: 27135,
    county_fips_all: '27135',
    county: 'Roseau',
    county_names_all: 'Roseau',
    county_weights: '{"27135": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 48.7258,
    longitude: -96.22712,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56726',
  },
  {
    city: 'Grygla',
    county_fips: 27007,
    county_fips_all: '27007|27089',
    county: 'Beltrami',
    county_names_all: 'Beltrami|Marshall',
    county_weights: '{"27007": 85.35, "27089": 14.65}',
    density: 0.5,
    imprecise: false,
    latitude: 48.34945,
    longitude: -95.38946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56727',
  },
  {
    city: 'Hallock',
    county_fips: 27069,
    county_fips_all: '27069',
    county: 'Kittson',
    county_names_all: 'Kittson',
    county_weights: '{"27069": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 48.78736,
    longitude: -96.99149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56728',
  },
  {
    city: 'Halma',
    county_fips: 27069,
    county_fips_all: '27069',
    county: 'Kittson',
    county_names_all: 'Kittson',
    county_weights: '{"27069": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 48.66558,
    longitude: -96.59438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56729',
  },
  {
    city: 'Humboldt',
    county_fips: 27069,
    county_fips_all: '27069',
    county: 'Kittson',
    county_names_all: 'Kittson',
    county_weights: '{"27069": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 48.90771,
    longitude: -97.07475,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56731',
  },
  {
    city: 'Karlstad',
    county_fips: 27069,
    county_fips_all: '27069|27089|27135',
    county: 'Kittson',
    county_names_all: 'Kittson|Marshall|Roseau',
    county_weights: '{"27069": 70.59, "27089": 18.09, "27135": 11.32}',
    density: 2.3,
    imprecise: false,
    latitude: 48.5863,
    longitude: -96.49276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56732',
  },
  {
    city: 'Kennedy',
    county_fips: 27069,
    county_fips_all: '27069',
    county: 'Kittson',
    county_names_all: 'Kittson',
    county_weights: '{"27069": 100}',
    density: 1,
    imprecise: false,
    latitude: 48.63342,
    longitude: -96.89149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56733',
  },
  {
    city: 'Lake Bronson',
    county_fips: 27069,
    county_fips_all: '27069',
    county: 'Kittson',
    county_names_all: 'Kittson',
    county_weights: '{"27069": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 48.76776,
    longitude: -96.58134,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56734',
  },
  {
    city: 'Lancaster',
    county_fips: 27069,
    county_fips_all: '27069|27135',
    county: 'Kittson',
    county_names_all: 'Kittson|Roseau',
    county_weights: '{"27069": 81.23, "27135": 18.77}',
    density: 0.7,
    imprecise: false,
    latitude: 48.91328,
    longitude: -96.63659,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56735',
  },
  {
    city: 'Mentor',
    county_fips: 27119,
    county_fips_all: '27119|27125',
    county: 'Polk',
    county_names_all: 'Polk|Red Lake',
    county_weights: '{"27119": 84.95, "27125": 15.05}',
    density: 2.4,
    imprecise: false,
    latitude: 47.71212,
    longitude: -96.20567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56736',
  },
  {
    city: 'Middle River',
    county_fips: 27089,
    county_fips_all: '27089',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"27089": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 48.41144,
    longitude: -96.01081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56737',
  },
  {
    city: 'Newfolden',
    county_fips: 27089,
    county_fips_all: '27089',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"27089": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 48.34448,
    longitude: -96.33456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56738',
  },
  {
    city: 'Oklee',
    county_fips: 27125,
    county_fips_all: '27125|27113|27119',
    county: 'Red Lake',
    county_names_all: 'Red Lake|Pennington|Polk',
    county_weights: '{"27125": 68.8, "27113": 27.15, "27119": 4.05}',
    density: 2.6,
    imprecise: false,
    latitude: 47.92728,
    longitude: -95.82076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56742',
  },
  {
    city: 'Oslo',
    county_fips: 27089,
    county_fips_all: '27089|27119|38099|38035',
    county: 'Marshall',
    county_names_all: 'Marshall|Polk|Walsh|Grand Forks',
    county_weights:
      '{"27089": 49.96, "27119": 23.26, "38099": 23.11, "38035": 3.67}',
    density: 2.3,
    imprecise: false,
    latitude: 48.23456,
    longitude: -97.1089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56744',
  },
  {
    city: 'Plummer',
    county_fips: 27125,
    county_fips_all: '27125|27113',
    county: 'Red Lake',
    county_names_all: 'Red Lake|Pennington',
    county_weights: '{"27125": 80.5, "27113": 19.5}',
    density: 2.9,
    imprecise: false,
    latitude: 47.92066,
    longitude: -96.00743,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56748',
  },
  {
    city: 'Red Lake Falls',
    county_fips: 27125,
    county_fips_all: '27125|27113|27119',
    county: 'Red Lake',
    county_names_all: 'Red Lake|Pennington|Polk',
    county_weights: '{"27125": 79.33, "27113": 13.89, "27119": 6.78}',
    density: 3.8,
    imprecise: false,
    latitude: 47.89027,
    longitude: -96.30172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56750',
  },
  {
    city: 'Roseau',
    county_fips: 27135,
    county_fips_all: '27135',
    county: 'Roseau',
    county_names_all: 'Roseau',
    county_weights: '{"27135": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 48.80929,
    longitude: -95.76035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56751',
  },
  {
    city: 'Saint Hilaire',
    county_fips: 27113,
    county_fips_all: '27113|27125',
    county: 'Pennington',
    county_names_all: 'Pennington|Red Lake',
    county_weights: '{"27113": 91.0, "27125": 9.0}',
    density: 4.9,
    imprecise: false,
    latitude: 47.99065,
    longitude: -96.18199,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56754',
  },
  {
    city: 'Saint Vincent',
    county_fips: 27069,
    county_fips_all: '27069',
    county: 'Kittson',
    county_names_all: 'Kittson',
    county_weights: '{"27069": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 48.97141,
    longitude: -97.1152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 82,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56755',
  },
  {
    city: 'Salol',
    county_fips: 27135,
    county_fips_all: '27135',
    county: 'Roseau',
    county_names_all: 'Roseau',
    county_weights: '{"27135": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 48.90302,
    longitude: -95.56388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56756',
  },
  {
    city: 'Stephen',
    county_fips: 27089,
    county_fips_all: '27089|27069',
    county: 'Marshall',
    county_names_all: 'Marshall|Kittson',
    county_weights: '{"27089": 94.98, "27069": 5.02}',
    density: 1.4,
    imprecise: false,
    latitude: 48.47641,
    longitude: -96.90596,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56757',
  },
  {
    city: 'Strandquist',
    county_fips: 27089,
    county_fips_all: '27089',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"27089": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 48.46201,
    longitude: -96.51891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56758',
  },
  {
    city: 'Strathcona',
    county_fips: 27135,
    county_fips_all: '27135|27089',
    county: 'Roseau',
    county_names_all: 'Roseau|Marshall',
    county_weights: '{"27135": 63.75, "27089": 36.25}',
    density: 1,
    imprecise: false,
    latitude: 48.55188,
    longitude: -96.08011,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56759',
  },
  {
    city: 'Viking',
    county_fips: 27089,
    county_fips_all: '27089',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"27089": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 48.24037,
    longitude: -96.44586,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56760',
  },
  {
    city: 'Wannaska',
    county_fips: 27135,
    county_fips_all: '27135',
    county: 'Roseau',
    county_names_all: 'Roseau',
    county_weights: '{"27135": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 48.60862,
    longitude: -95.69725,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56761',
  },
  {
    city: 'Warren',
    county_fips: 27119,
    county_fips_all: '27119|27089',
    county: 'Polk',
    county_names_all: 'Polk|Marshall',
    county_weights: '{"27119": 51.75, "27089": 48.25}',
    density: 2.8,
    imprecise: false,
    latitude: 48.1688,
    longitude: -96.7415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56762',
  },
  {
    city: 'Warroad',
    county_fips: 27135,
    county_fips_all: '27135',
    county: 'Roseau',
    county_names_all: 'Roseau',
    county_weights: '{"27135": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 48.80879,
    longitude: -95.34167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56763',
  },
  {
    city: 'Alcester',
    county_fips: 46127,
    county_fips_all: '46127|46083',
    county: 'Union',
    county_names_all: 'Union|Lincoln',
    county_weights: '{"46127": 93.43, "46083": 6.57}',
    density: 6,
    imprecise: false,
    latitude: 42.9981,
    longitude: -96.65492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57001',
  },
  {
    city: 'Aurora',
    county_fips: 46011,
    county_fips_all: '46011|46101',
    county: 'Brookings',
    county_names_all: 'Brookings|Moody',
    county_weights: '{"46011": 92.4, "46101": 7.6}',
    density: 10.1,
    imprecise: false,
    latitude: 44.28785,
    longitude: -96.67752,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57002',
  },
  {
    city: 'Baltic',
    county_fips: 46099,
    county_fips_all: '46099',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha',
    county_weights: '{"46099": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 43.73705,
    longitude: -96.75784,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57003',
  },
  {
    city: 'Beresford',
    county_fips: 46083,
    county_fips_all: '46083|46127|46027',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Union|Clay',
    county_weights: '{"46083": 47.03, "46127": 26.52, "46027": 26.46}',
    density: 7.6,
    imprecise: false,
    latitude: 43.07571,
    longitude: -96.79376,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57004',
  },
  {
    city: 'Brandon',
    county_fips: 46099,
    county_fips_all: '46099',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha',
    county_weights: '{"46099": 100}',
    density: 97,
    imprecise: false,
    latitude: 43.59281,
    longitude: -96.58728,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57005',
  },
  {
    city: 'Brookings',
    county_fips: 46011,
    county_fips_all: '46011|46101',
    county: 'Brookings',
    county_names_all: 'Brookings|Moody',
    county_weights: '{"46011": 88.81, "46101": 11.19}',
    density: 61.5,
    imprecise: false,
    latitude: 44.31588,
    longitude: -96.79518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57006',
  },
  {
    city: 'Burbank',
    county_fips: 46027,
    county_fips_all: '46027|46127',
    county: 'Clay',
    county_names_all: 'Clay|Union',
    county_weights: '{"46027": 69.56, "46127": 30.44}',
    density: 4.7,
    imprecise: false,
    latitude: 42.8119,
    longitude: -96.82403,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57010',
  },
  {
    city: 'Canistota',
    county_fips: 46087,
    county_fips_all: '46087',
    county: 'McCook',
    county_names_all: 'McCook',
    county_weights: '{"46087": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 43.59683,
    longitude: -97.27986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57012',
  },
  {
    city: 'Canton',
    county_fips: 46083,
    county_fips_all: '46083',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"46083": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 43.28595,
    longitude: -96.62178,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57013',
  },
  {
    city: 'Centerville',
    county_fips: 46125,
    county_fips_all: '46125|46027|46083',
    county: 'Turner',
    county_names_all: 'Turner|Clay|Lincoln',
    county_weights: '{"46125": 42.52, "46027": 32.96, "46083": 24.52}',
    density: 4.7,
    imprecise: false,
    latitude: 43.11238,
    longitude: -96.95347,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57014',
  },
  {
    city: 'Chancellor',
    county_fips: 46125,
    county_fips_all: '46125|46099',
    county: 'Turner',
    county_names_all: 'Turner|Minnehaha',
    county_weights: '{"46125": 97.97, "46099": 2.03}',
    density: 6.2,
    imprecise: false,
    latitude: 43.42182,
    longitude: -96.98006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57015',
  },
  {
    city: 'Chester',
    county_fips: 46079,
    county_fips_all: '46079',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"46079": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 43.88874,
    longitude: -96.96139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57016',
  },
  {
    city: 'Colman',
    county_fips: 46101,
    county_fips_all: '46101|46079',
    county: 'Moody',
    county_names_all: 'Moody|Lake',
    county_weights: '{"46101": 99.07, "46079": 0.93}',
    density: 5.8,
    imprecise: false,
    latitude: 44.02246,
    longitude: -96.82788,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57017',
  },
  {
    city: 'Colton',
    county_fips: 46099,
    county_fips_all: '46099|46079',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha|Lake',
    county_weights: '{"46099": 96.5, "46079": 3.5}',
    density: 6.8,
    imprecise: false,
    latitude: 43.79995,
    longitude: -96.97901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57018',
  },
  {
    city: 'Crooks',
    county_fips: 46099,
    county_fips_all: '46099',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha',
    county_weights: '{"46099": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 43.67796,
    longitude: -96.82665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57020',
  },
  {
    city: 'Davis',
    county_fips: 46125,
    county_fips_all: '46125',
    county: 'Turner',
    county_names_all: 'Turner',
    county_weights: '{"46125": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 43.2723,
    longitude: -96.97797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57021',
  },
  {
    city: 'Dell Rapids',
    county_fips: 46099,
    county_fips_all: '46099|46101|46079',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha|Moody|Lake',
    county_weights: '{"46099": 51.2, "46101": 45.92, "46079": 2.88}',
    density: 14.6,
    imprecise: false,
    latitude: 43.85081,
    longitude: -96.7327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57022',
  },
  {
    city: 'Egan',
    county_fips: 46101,
    county_fips_all: '46101',
    county: 'Moody',
    county_names_all: 'Moody',
    county_weights: '{"46101": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 43.98538,
    longitude: -96.68146,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57024',
  },
  {
    city: 'Elk Point',
    county_fips: 46127,
    county_fips_all: '46127',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"46127": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 42.71718,
    longitude: -96.68894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57025',
  },
  {
    city: 'Elkton',
    county_fips: 46011,
    county_fips_all: '46011|46101|27081|27117',
    county: 'Brookings',
    county_names_all: 'Brookings|Moody|Lincoln|Pipestone',
    county_weights:
      '{"46011": 56.79, "46101": 19.92, "27081": 13.62, "27117": 9.67}',
    density: 3.3,
    imprecise: false,
    latitude: 44.24996,
    longitude: -96.50149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57026',
  },
  {
    city: 'Fairview',
    county_fips: 46083,
    county_fips_all: '46083',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"46083": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 43.19461,
    longitude: -96.50933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57027',
  },
  {
    city: 'Flandreau',
    county_fips: 46101,
    county_fips_all: '46101',
    county: 'Moody',
    county_names_all: 'Moody',
    county_weights: '{"46101": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 44.05766,
    longitude: -96.60443,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57028',
  },
  {
    city: 'Freeman',
    county_fips: 46067,
    county_fips_all: '46067|46125',
    county: 'Hutchinson',
    county_names_all: 'Hutchinson|Turner',
    county_weights: '{"46067": 76.79, "46125": 23.21}',
    density: 4.4,
    imprecise: false,
    latitude: 43.33696,
    longitude: -97.47936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57029',
  },
  {
    city: 'Garretson',
    county_fips: 46099,
    county_fips_all: '46099|27133',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha|Rock',
    county_weights: '{"46099": 89.97, "27133": 10.03}',
    density: 7.3,
    imprecise: false,
    latitude: 43.73435,
    longitude: -96.53549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57030',
  },
  {
    city: 'Gayville',
    county_fips: 46135,
    county_fips_all: '46135|46027',
    county: 'Yankton',
    county_names_all: 'Yankton|Clay',
    county_weights: '{"46135": 77.43, "46027": 22.57}',
    density: 7.7,
    imprecise: false,
    latitude: 42.87058,
    longitude: -97.18655,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57031',
  },
  {
    city: 'Harrisburg',
    county_fips: 46083,
    county_fips_all: '46083',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"46083": 100}',
    density: 82.7,
    imprecise: false,
    latitude: 43.42326,
    longitude: -96.68708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57032',
  },
  {
    city: 'Hartford',
    county_fips: 46099,
    county_fips_all: '46099',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha',
    county_weights: '{"46099": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 43.61613,
    longitude: -96.96037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57033',
  },
  {
    city: 'Hudson',
    county_fips: 46083,
    county_fips_all: '46083|46127|19167',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Union|Sioux',
    county_weights: '{"46083": 83.55, "46127": 8.73, "19167": 7.72}',
    density: 3.3,
    imprecise: false,
    latitude: 43.12493,
    longitude: -96.54575,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57034',
  },
  {
    city: 'Humboldt',
    county_fips: 46099,
    county_fips_all: '46099|46087',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha|McCook',
    county_weights: '{"46099": 92.3, "46087": 7.7}',
    density: 7.2,
    imprecise: false,
    latitude: 43.64651,
    longitude: -97.07627,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57035',
  },
  {
    city: 'Hurley',
    county_fips: 46125,
    county_fips_all: '46125',
    county: 'Turner',
    county_names_all: 'Turner',
    county_weights: '{"46125": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 43.27067,
    longitude: -97.14364,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57036',
  },
  {
    city: 'Irene',
    county_fips: 46135,
    county_fips_all: '46135|46125|46027',
    county: 'Yankton',
    county_names_all: 'Yankton|Turner|Clay',
    county_weights: '{"46135": 82.13, "46125": 11.07, "46027": 6.8}',
    density: 3.4,
    imprecise: false,
    latitude: 43.10146,
    longitude: -97.25318,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57037',
  },
  {
    city: 'Jefferson',
    county_fips: 46127,
    county_fips_all: '46127',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"46127": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 42.57924,
    longitude: -96.57957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57038',
  },
  {
    city: 'Lennox',
    county_fips: 46083,
    county_fips_all: '46083|46125',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Turner',
    county_weights: '{"46083": 92.11, "46125": 7.89}',
    density: 15.2,
    imprecise: false,
    latitude: 43.33659,
    longitude: -96.86755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57039',
  },
  {
    city: 'Lesterville',
    county_fips: 46135,
    county_fips_all: '46135|46009',
    county: 'Yankton',
    county_names_all: 'Yankton|Bon Homme',
    county_weights: '{"46135": 96.52, "46009": 3.48}',
    density: 1.2,
    imprecise: false,
    latitude: 43.06206,
    longitude: -97.58582,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57040',
  },
  {
    city: 'Lyons',
    county_fips: 46099,
    county_fips_all: '46099',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha',
    county_weights: '{"46099": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 43.72184,
    longitude: -96.88415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57041',
  },
  {
    city: 'Madison',
    county_fips: 46079,
    county_fips_all: '46079|46087',
    county: 'Lake',
    county_names_all: 'Lake|McCook',
    county_weights: '{"46079": 99.22, "46087": 0.78}',
    density: 15.5,
    imprecise: false,
    latitude: 43.97744,
    longitude: -97.15133,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57042',
  },
  {
    city: 'Marion',
    county_fips: 46125,
    county_fips_all: '46125|46087|46067',
    county: 'Turner',
    county_names_all: 'Turner|McCook|Hutchinson',
    county_weights: '{"46125": 85.47, "46087": 11.1, "46067": 3.43}',
    density: 5.5,
    imprecise: false,
    latitude: 43.41954,
    longitude: -97.30889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57043',
  },
  {
    city: 'Menno',
    county_fips: 46067,
    county_fips_all: '46067|46135|46125',
    county: 'Hutchinson',
    county_names_all: 'Hutchinson|Yankton|Turner',
    county_weights: '{"46067": 69.3, "46135": 28.53, "46125": 2.17}',
    density: 3.7,
    imprecise: false,
    latitude: 43.20051,
    longitude: -97.52425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57045',
  },
  {
    city: 'Mission Hill',
    county_fips: 46135,
    county_fips_all: '46135',
    county: 'Yankton',
    county_names_all: 'Yankton',
    county_weights: '{"46135": 100}',
    density: 4,
    imprecise: false,
    latitude: 42.9563,
    longitude: -97.30113,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57046',
  },
  {
    city: 'Monroe',
    county_fips: 46087,
    county_fips_all: '46087|46125',
    county: 'McCook',
    county_names_all: 'McCook|Turner',
    county_weights: '{"46087": 77.04, "46125": 22.96}',
    density: 10.2,
    imprecise: false,
    latitude: 43.51755,
    longitude: -97.21525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57047',
  },
  {
    city: 'Montrose',
    county_fips: 46087,
    county_fips_all: '46087|46099',
    county: 'McCook',
    county_names_all: 'McCook|Minnehaha',
    county_weights: '{"46087": 90.15, "46099": 9.85}',
    density: 3.7,
    imprecise: false,
    latitude: 43.74081,
    longitude: -97.20034,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57048',
  },
  {
    city: 'North Sioux City',
    county_fips: 46127,
    county_fips_all: '46127',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"46127": 100}',
    density: 216.9,
    imprecise: false,
    latitude: 42.52486,
    longitude: -96.50732,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57049',
  },
  {
    city: 'Nunda',
    county_fips: 46079,
    county_fips_all: '46079',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"46079": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 44.15725,
    longitude: -97.01467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57050',
  },
  {
    city: 'Oldham',
    county_fips: 46077,
    county_fips_all: '46077|46097|46079',
    county: 'Kingsbury',
    county_names_all: 'Kingsbury|Miner|Lake',
    county_weights: '{"46077": 77.72, "46097": 17.63, "46079": 4.65}',
    density: 0.8,
    imprecise: false,
    latitude: 44.21741,
    longitude: -97.35066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57051',
  },
  {
    city: 'Olivet',
    county_fips: 46067,
    county_fips_all: '46067',
    county: 'Hutchinson',
    county_names_all: 'Hutchinson',
    county_weights: '{"46067": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 43.29471,
    longitude: -97.7054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57052',
  },
  {
    city: 'Parker',
    county_fips: 46125,
    county_fips_all: '46125|46087|46099',
    county: 'Turner',
    county_names_all: 'Turner|McCook|Minnehaha',
    county_weights: '{"46125": 92.03, "46087": 5.85, "46099": 2.12}',
    density: 6,
    imprecise: false,
    latitude: 43.40963,
    longitude: -97.13716,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57053',
  },
  {
    city: 'Ramona',
    county_fips: 46079,
    county_fips_all: '46079|46097',
    county: 'Lake',
    county_names_all: 'Lake|Miner',
    county_weights: '{"46079": 99.14, "46097": 0.86}',
    density: 2.3,
    imprecise: false,
    latitude: 44.12162,
    longitude: -97.25799,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57054',
  },
  {
    city: 'Renner',
    county_fips: 46099,
    county_fips_all: '46099',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha',
    county_weights: '{"46099": 100}',
    density: 32.2,
    imprecise: false,
    latitude: 43.66638,
    longitude: -96.73973,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57055',
  },
  {
    city: 'Rutland',
    county_fips: 46079,
    county_fips_all: '46079|46101',
    county: 'Lake',
    county_names_all: 'Lake|Moody',
    county_weights: '{"46079": 93.98, "46101": 6.02}',
    density: 2.4,
    imprecise: false,
    latitude: 44.10261,
    longitude: -96.95717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57057',
  },
  {
    city: 'Salem',
    county_fips: 46087,
    county_fips_all: '46087|46079|46097',
    county: 'McCook',
    county_names_all: 'McCook|Lake|Miner',
    county_weights: '{"46087": 95.58, "46079": 2.54, "46097": 1.88}',
    density: 4.6,
    imprecise: false,
    latitude: 43.74602,
    longitude: -97.40468,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57058',
  },
  {
    city: 'Scotland',
    county_fips: 46009,
    county_fips_all: '46009|46067',
    county: 'Bon Homme',
    county_names_all: 'Bon Homme|Hutchinson',
    county_weights: '{"46009": 78.48, "46067": 21.52}',
    density: 3.2,
    imprecise: false,
    latitude: 43.12476,
    longitude: -97.76365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57059',
  },
  {
    city: 'Sinai',
    county_fips: 46011,
    county_fips_all: '46011',
    county: 'Brookings',
    county_names_all: 'Brookings',
    county_weights: '{"46011": 100}',
    density: 225.7,
    imprecise: false,
    latitude: 44.24452,
    longitude: -97.04399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57061',
  },
  {
    city: 'Springfield',
    county_fips: 46009,
    county_fips_all: '46009',
    county: 'Bon Homme',
    county_names_all: 'Bon Homme',
    county_weights: '{"46009": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 42.85046,
    longitude: -97.95327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57062',
  },
  {
    city: 'Tabor',
    county_fips: 46009,
    county_fips_all: '46009|46135',
    county: 'Bon Homme',
    county_names_all: 'Bon Homme|Yankton',
    county_weights: '{"46009": 79.93, "46135": 20.07}',
    density: 3.7,
    imprecise: false,
    latitude: 42.92483,
    longitude: -97.68668,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57063',
  },
  {
    city: 'Tea',
    county_fips: 46083,
    county_fips_all: '46083|46125',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Turner',
    county_weights: '{"46083": 85.67, "46125": 14.33}',
    density: 121.1,
    imprecise: false,
    latitude: 43.45563,
    longitude: -96.87489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57064',
  },
  {
    city: 'Trent',
    county_fips: 46101,
    county_fips_all: '46101',
    county: 'Moody',
    county_names_all: 'Moody',
    county_weights: '{"46101": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 43.90041,
    longitude: -96.60631,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57065',
  },
  {
    city: 'Tyndall',
    county_fips: 46009,
    county_fips_all: '46009',
    county: 'Bon Homme',
    county_names_all: 'Bon Homme',
    county_weights: '{"46009": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 42.98874,
    longitude: -97.86703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57066',
  },
  {
    city: 'Utica',
    county_fips: 46135,
    county_fips_all: '46135',
    county: 'Yankton',
    county_names_all: 'Yankton',
    county_weights: '{"46135": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 43.04095,
    longitude: -97.47169,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57067',
  },
  {
    city: 'Valley Springs',
    county_fips: 46099,
    county_fips_all: '46099|27133',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha|Rock',
    county_weights: '{"46099": 93.22, "27133": 6.78}',
    density: 13.4,
    imprecise: false,
    latitude: 43.57435,
    longitude: -96.49361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57068',
  },
  {
    city: 'Vermillion',
    county_fips: 46027,
    county_fips_all: '46027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"46027": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 42.84348,
    longitude: -96.98774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57069',
  },
  {
    city: 'Viborg',
    county_fips: 46125,
    county_fips_all: '46125|46135',
    county: 'Turner',
    county_names_all: 'Turner|Yankton',
    county_weights: '{"46125": 88.06, "46135": 11.94}',
    density: 6.4,
    imprecise: false,
    latitude: 43.182,
    longitude: -97.1702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57070',
  },
  {
    city: 'Volga',
    county_fips: 46011,
    county_fips_all: '46011|46079|46101',
    county: 'Brookings',
    county_names_all: 'Brookings|Lake|Moody',
    county_weights: '{"46011": 92.03, "46079": 6.39, "46101": 1.58}',
    density: 10.2,
    imprecise: false,
    latitude: 44.26986,
    longitude: -96.95934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57071',
  },
  {
    city: 'Volin',
    county_fips: 46135,
    county_fips_all: '46135|46027',
    county: 'Yankton',
    county_names_all: 'Yankton|Clay',
    county_weights: '{"46135": 72.07, "46027": 27.93}',
    density: 2.3,
    imprecise: false,
    latitude: 42.98747,
    longitude: -97.20363,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57072',
  },
  {
    city: 'Wakonda',
    county_fips: 46027,
    county_fips_all: '46027|46125',
    county: 'Clay',
    county_names_all: 'Clay|Turner',
    county_weights: '{"46027": 95.58, "46125": 4.42}',
    density: 3.1,
    imprecise: false,
    latitude: 43.00227,
    longitude: -97.05754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57073',
  },
  {
    city: 'Wentworth',
    county_fips: 46079,
    county_fips_all: '46079|46101',
    county: 'Lake',
    county_names_all: 'Lake|Moody',
    county_weights: '{"46079": 97.8, "46101": 2.2}',
    density: 6.3,
    imprecise: false,
    latitude: 43.99605,
    longitude: -96.96749,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57075',
  },
  {
    city: 'Winfred',
    county_fips: 46079,
    county_fips_all: '46079|46097',
    county: 'Lake',
    county_names_all: 'Lake|Miner',
    county_weights: '{"46079": 53.38, "46097": 46.62}',
    density: 1.2,
    imprecise: false,
    latitude: 43.97673,
    longitude: -97.35307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57076',
  },
  {
    city: 'Worthing',
    county_fips: 46083,
    county_fips_all: '46083',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"46083": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 43.31574,
    longitude: -96.75699,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57077',
  },
  {
    city: 'Yankton',
    county_fips: 46135,
    county_fips_all: '46135',
    county: 'Yankton',
    county_names_all: 'Yankton',
    county_weights: '{"46135": 100}',
    density: 70.7,
    imprecise: false,
    latitude: 42.91782,
    longitude: -97.44702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57078',
  },
  {
    city: 'Sioux Falls',
    county_fips: 46099,
    county_fips_all: '46099',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha',
    county_weights: '{"46099": 100}',
    density: 1451.5,
    imprecise: false,
    latitude: 43.538,
    longitude: -96.69241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57103',
  },
  {
    city: 'Sioux Falls',
    county_fips: 46099,
    county_fips_all: '46099',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha',
    county_weights: '{"46099": 100}',
    density: 342.6,
    imprecise: false,
    latitude: 43.6041,
    longitude: -96.70442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57104',
  },
  {
    city: 'Sioux Falls',
    county_fips: 46099,
    county_fips_all: '46099',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha',
    county_weights: '{"46099": 100}',
    density: 1195.8,
    imprecise: false,
    latitude: 43.52125,
    longitude: -96.73587,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57105',
  },
  {
    city: 'Sioux Falls',
    county_fips: 46099,
    county_fips_all: '46099|46083',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha|Lincoln',
    county_weights: '{"46099": 66.7, "46083": 33.3}',
    density: 662.1,
    imprecise: false,
    latitude: 43.50953,
    longitude: -96.83919,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57106',
  },
  {
    city: 'Sioux Falls',
    county_fips: 46099,
    county_fips_all: '46099',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha',
    county_weights: '{"46099": 100}',
    density: 104.1,
    imprecise: false,
    latitude: 43.59468,
    longitude: -96.81962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57107',
  },
  {
    city: 'Sioux Falls',
    county_fips: 46083,
    county_fips_all: '46083|46099',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Minnehaha',
    county_weights: '{"46083": 98.68, "46099": 1.32}',
    density: 431.4,
    imprecise: false,
    latitude: 43.47776,
    longitude: -96.70571,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57108',
  },
  {
    city: 'Sioux Falls',
    county_fips: 46099,
    county_fips_all: '46099',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha',
    county_weights: '{"46099": 100}',
    density: 431,
    imprecise: false,
    latitude: 43.54445,
    longitude: -96.63812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57110',
  },
  {
    city: 'Sioux Falls',
    county_fips: 46099,
    county_fips_all: '46099',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha',
    county_weights: '{"46099": 100}',
    density: 217.8,
    imprecise: false,
    latitude: 43.53124,
    longitude: -96.75497,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57117',
  },
  {
    city: 'Watertown',
    county_fips: 46029,
    county_fips_all: '46029|46057',
    county: 'Codington',
    county_names_all: 'Codington|Hamlin',
    county_weights: '{"46029": 99.1, "46057": 0.9}',
    density: 32.4,
    imprecise: false,
    latitude: 44.93412,
    longitude: -97.09424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57201',
  },
  {
    city: 'Arlington',
    county_fips: 46077,
    county_fips_all: '46077|46011|46057|46079',
    county: 'Kingsbury',
    county_names_all: 'Kingsbury|Brookings|Hamlin|Lake',
    county_weights:
      '{"46077": 53.94, "46011": 41.71, "46057": 3.54, "46079": 0.81}',
    density: 3.1,
    imprecise: false,
    latitude: 44.38111,
    longitude: -97.14344,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57212',
  },
  {
    city: 'Astoria',
    county_fips: 46039,
    county_fips_all: '46039|46011',
    county: 'Deuel',
    county_names_all: 'Deuel|Brookings',
    county_weights: '{"46039": 76.01, "46011": 23.99}',
    density: 4.1,
    imprecise: false,
    latitude: 44.57112,
    longitude: -96.5323,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57213',
  },
  {
    city: 'Badger',
    county_fips: 46077,
    county_fips_all: '46077',
    county: 'Kingsbury',
    county_names_all: 'Kingsbury',
    county_weights: '{"46077": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 44.47764,
    longitude: -97.19575,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57214',
  },
  {
    city: 'Big Stone City',
    county_fips: 46051,
    county_fips_all: '46051|46109',
    county: 'Grant',
    county_names_all: 'Grant|Roberts',
    county_weights: '{"46051": 63.64, "46109": 36.36}',
    density: 10,
    imprecise: false,
    latitude: 45.30041,
    longitude: -96.52471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57216',
  },
  {
    city: 'Bradley',
    county_fips: 46025,
    county_fips_all: '46025',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"46025": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 45.0845,
    longitude: -97.67004,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57217',
  },
  {
    city: 'Brandt',
    county_fips: 46039,
    county_fips_all: '46039',
    county: 'Deuel',
    county_names_all: 'Deuel',
    county_weights: '{"46039": 100}',
    density: 1,
    imprecise: false,
    latitude: 44.65787,
    longitude: -96.59624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57218',
  },
  {
    city: 'Bristol',
    county_fips: 46037,
    county_fips_all: '46037',
    county: 'Day',
    county_names_all: 'Day',
    county_weights: '{"46037": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 45.2877,
    longitude: -97.801,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57219',
  },
  {
    city: 'Bruce',
    county_fips: 46011,
    county_fips_all: '46011',
    county: 'Brookings',
    county_names_all: 'Brookings',
    county_weights: '{"46011": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 44.45927,
    longitude: -96.92022,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57220',
  },
  {
    city: 'Bryant',
    county_fips: 46057,
    county_fips_all: '46057|46025',
    county: 'Hamlin',
    county_names_all: 'Hamlin|Clark',
    county_weights: '{"46057": 73.24, "46025": 26.76}',
    density: 3.8,
    imprecise: false,
    latitude: 44.60654,
    longitude: -97.44853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57221',
  },
  {
    city: 'Castlewood',
    county_fips: 46057,
    county_fips_all: '46057|46039',
    county: 'Hamlin',
    county_names_all: 'Hamlin|Deuel',
    county_weights: '{"46057": 97.69, "46039": 2.31}',
    density: 4.4,
    imprecise: false,
    latitude: 44.71019,
    longitude: -97.00567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57223',
  },
  {
    city: 'Claire City',
    county_fips: 46109,
    county_fips_all: '46109',
    county: 'Roberts',
    county_names_all: 'Roberts',
    county_weights: '{"46109": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 45.81332,
    longitude: -97.15672,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57224',
  },
  {
    city: 'Clark',
    county_fips: 46025,
    county_fips_all: '46025',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"46025": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 44.88359,
    longitude: -97.72676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57225',
  },
  {
    city: 'Clear Lake',
    county_fips: 46039,
    county_fips_all: '46039|46057',
    county: 'Deuel',
    county_names_all: 'Deuel|Hamlin',
    county_weights: '{"46039": 96.42, "46057": 3.58}',
    density: 3.9,
    imprecise: false,
    latitude: 44.78565,
    longitude: -96.72368,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57226',
  },
  {
    city: 'Corona',
    county_fips: 46109,
    county_fips_all: '46109|46051',
    county: 'Roberts',
    county_names_all: 'Roberts|Grant',
    county_weights: '{"46109": 93.0, "46051": 7.0}',
    density: 4.9,
    imprecise: false,
    latitude: 45.36184,
    longitude: -96.72105,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57227',
  },
  {
    city: 'De Smet',
    county_fips: 46077,
    county_fips_all: '46077',
    county: 'Kingsbury',
    county_names_all: 'Kingsbury',
    county_weights: '{"46077": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 44.3749,
    longitude: -97.58243,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57231',
  },
  {
    city: 'Eden',
    county_fips: 46091,
    county_fips_all: '46091',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"46091": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 45.61752,
    longitude: -97.38393,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57232',
  },
  {
    city: 'Erwin',
    county_fips: 46077,
    county_fips_all: '46077',
    county: 'Kingsbury',
    county_names_all: 'Kingsbury',
    county_weights: '{"46077": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 44.50992,
    longitude: -97.3993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57233',
  },
  {
    city: 'Estelline',
    county_fips: 46039,
    county_fips_all: '46039|46057|46011',
    county: 'Deuel',
    county_names_all: 'Deuel|Hamlin|Brookings',
    county_weights: '{"46039": 47.98, "46057": 45.94, "46011": 6.07}',
    density: 5.1,
    imprecise: false,
    latitude: 44.59719,
    longitude: -96.89929,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57234',
  },
  {
    city: 'Florence',
    county_fips: 46029,
    county_fips_all: '46029|46037',
    county: 'Codington',
    county_names_all: 'Codington|Day',
    county_weights: '{"46029": 94.95, "46037": 5.05}',
    density: 2.3,
    imprecise: false,
    latitude: 45.06896,
    longitude: -97.31338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57235',
  },
  {
    city: 'Garden City',
    county_fips: 46025,
    county_fips_all: '46025',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"46025": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 44.98724,
    longitude: -97.59033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57236',
  },
  {
    city: 'Gary',
    county_fips: 46039,
    county_fips_all: '46039',
    county: 'Deuel',
    county_names_all: 'Deuel',
    county_weights: '{"46039": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 44.79323,
    longitude: -96.51991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57237',
  },
  {
    city: 'Goodwin',
    county_fips: 46039,
    county_fips_all: '46039|46029|46057',
    county: 'Deuel',
    county_names_all: 'Deuel|Codington|Hamlin',
    county_weights: '{"46039": 64.03, "46029": 31.23, "46057": 4.74}',
    density: 1.7,
    imprecise: false,
    latitude: 44.87287,
    longitude: -96.86231,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57238',
  },
  {
    city: 'Grenville',
    county_fips: 46037,
    county_fips_all: '46037',
    county: 'Day',
    county_names_all: 'Day',
    county_weights: '{"46037": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 45.51223,
    longitude: -97.30938,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57239',
  },
  {
    city: 'Hayti',
    county_fips: 46057,
    county_fips_all: '46057',
    county: 'Hamlin',
    county_names_all: 'Hamlin',
    county_weights: '{"46057": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 44.69742,
    longitude: -97.21747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57241',
  },
  {
    city: 'Hazel',
    county_fips: 46057,
    county_fips_all: '46057|46029',
    county: 'Hamlin',
    county_names_all: 'Hamlin|Codington',
    county_weights: '{"46057": 79.66, "46029": 20.34}',
    density: 1.4,
    imprecise: false,
    latitude: 44.77352,
    longitude: -97.35902,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57242',
  },
  {
    city: 'Henry',
    county_fips: 46029,
    county_fips_all: '46029|46025|46057',
    county: 'Codington',
    county_names_all: 'Codington|Clark|Hamlin',
    county_weights: '{"46029": 87.53, "46025": 10.89, "46057": 1.58}',
    density: 1.8,
    imprecise: false,
    latitude: 44.91177,
    longitude: -97.42072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57243',
  },
  {
    city: 'Kranzburg',
    county_fips: 46029,
    county_fips_all: '46029',
    county: 'Codington',
    county_names_all: 'Codington',
    county_weights: '{"46029": 100}',
    density: 234.6,
    imprecise: false,
    latitude: 44.89365,
    longitude: -96.91835,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57245',
  },
  {
    city: 'Labolt',
    county_fips: 46051,
    county_fips_all: '46051',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"46051": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 45.05639,
    longitude: -96.66914,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57246',
  },
  {
    city: 'Lake City',
    county_fips: 46091,
    county_fips_all: '46091',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"46091": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 45.71675,
    longitude: -97.45817,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57247',
  },
  {
    city: 'Lake Norden',
    county_fips: 46057,
    county_fips_all: '46057|46077',
    county: 'Hamlin',
    county_names_all: 'Hamlin|Kingsbury',
    county_weights: '{"46057": 83.26, "46077": 16.74}',
    density: 7.4,
    imprecise: false,
    latitude: 44.58063,
    longitude: -97.19328,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57248',
  },
  {
    city: 'Lake Preston',
    county_fips: 46077,
    county_fips_all: '46077',
    county: 'Kingsbury',
    county_names_all: 'Kingsbury',
    county_weights: '{"46077": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 44.37111,
    longitude: -97.3646,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57249',
  },
  {
    city: 'Marvin',
    county_fips: 46051,
    county_fips_all: '46051',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"46051": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 45.27717,
    longitude: -96.93677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57251',
  },
  {
    city: 'Milbank',
    county_fips: 46051,
    county_fips_all: '46051|46109',
    county: 'Grant',
    county_names_all: 'Grant|Roberts',
    county_weights: '{"46051": 96.38, "46109": 3.62}',
    density: 11.4,
    imprecise: false,
    latitude: 45.20507,
    longitude: -96.61053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57252',
  },
  {
    city: 'New Effington',
    county_fips: 46109,
    county_fips_all: '46109|38077',
    county: 'Roberts',
    county_names_all: 'Roberts|Richland',
    county_weights: '{"46109": 95.48, "38077": 4.52}',
    density: 1.8,
    imprecise: false,
    latitude: 45.86702,
    longitude: -96.94985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57255',
  },
  {
    city: 'Ortley',
    county_fips: 46051,
    county_fips_all: '46051|46109|46037|46029',
    county: 'Grant',
    county_names_all: 'Grant|Roberts|Day|Codington',
    county_weights:
      '{"46051": 62.22, "46109": 20.12, "46037": 12.97, "46029": 4.69}',
    density: 2.1,
    imprecise: false,
    latitude: 45.24918,
    longitude: -97.20156,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57256',
  },
  {
    city: 'Peever',
    county_fips: 46109,
    county_fips_all: '46109',
    county: 'Roberts',
    county_names_all: 'Roberts',
    county_weights: '{"46109": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 45.49975,
    longitude: -97.02982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57257',
  },
  {
    city: 'Raymond',
    county_fips: 46025,
    county_fips_all: '46025|46115',
    county: 'Clark',
    county_names_all: 'Clark|Spink',
    county_weights: '{"46025": 93.39, "46115": 6.61}',
    density: 1.7,
    imprecise: false,
    latitude: 44.88434,
    longitude: -97.9246,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57258',
  },
  {
    city: 'Revillo',
    county_fips: 46051,
    county_fips_all: '46051|46039',
    county: 'Grant',
    county_names_all: 'Grant|Deuel',
    county_weights: '{"46051": 61.31, "46039": 38.69}',
    density: 1.4,
    imprecise: false,
    latitude: 45.00047,
    longitude: -96.56786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57259',
  },
  {
    city: 'Rosholt',
    county_fips: 46109,
    county_fips_all: '46109',
    county: 'Roberts',
    county_names_all: 'Roberts',
    county_weights: '{"46109": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 45.83641,
    longitude: -96.7172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57260',
  },
  {
    city: 'Roslyn',
    county_fips: 46037,
    county_fips_all: '46037',
    county: 'Day',
    county_names_all: 'Day',
    county_weights: '{"46037": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 45.54051,
    longitude: -97.49412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57261',
  },
  {
    city: 'Sisseton',
    county_fips: 46109,
    county_fips_all: '46109|46091',
    county: 'Roberts',
    county_names_all: 'Roberts|Marshall',
    county_weights: '{"46109": 91.15, "46091": 8.85}',
    density: 5.9,
    imprecise: false,
    latitude: 45.67288,
    longitude: -97.06641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57262',
  },
  {
    city: 'South Shore',
    county_fips: 46029,
    county_fips_all: '46029|46051',
    county: 'Codington',
    county_names_all: 'Codington|Grant',
    county_weights: '{"46029": 65.67, "46051": 34.33}',
    density: 1.3,
    imprecise: false,
    latitude: 45.14106,
    longitude: -97.00589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57263',
  },
  {
    city: 'Stockholm',
    county_fips: 46051,
    county_fips_all: '46051',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"46051": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 45.10863,
    longitude: -96.80254,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57264',
  },
  {
    city: 'Strandburg',
    county_fips: 46051,
    county_fips_all: '46051|46039|46029',
    county: 'Grant',
    county_names_all: 'Grant|Deuel|Codington',
    county_weights: '{"46051": 58.57, "46039": 38.01, "46029": 3.42}',
    density: 0.9,
    imprecise: false,
    latitude: 44.98866,
    longitude: -96.79591,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57265',
  },
  {
    city: 'Summit',
    county_fips: 46051,
    county_fips_all: '46051|46109',
    county: 'Grant',
    county_names_all: 'Grant|Roberts',
    county_weights: '{"46051": 51.59, "46109": 48.41}',
    density: 1.9,
    imprecise: false,
    latitude: 45.28619,
    longitude: -97.08985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57266',
  },
  {
    city: 'Toronto',
    county_fips: 46039,
    county_fips_all: '46039|46011',
    county: 'Deuel',
    county_names_all: 'Deuel|Brookings',
    county_weights: '{"46039": 77.94, "46011": 22.06}',
    density: 2.6,
    imprecise: false,
    latitude: 44.56885,
    longitude: -96.68781,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57268',
  },
  {
    city: 'Twin Brooks',
    county_fips: 46051,
    county_fips_all: '46051',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"46051": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 45.22273,
    longitude: -96.80182,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57269',
  },
  {
    city: 'Veblen',
    county_fips: 46091,
    county_fips_all: '46091|46109',
    county: 'Marshall',
    county_names_all: 'Marshall|Roberts',
    county_weights: '{"46091": 86.85, "46109": 13.15}',
    density: 1.8,
    imprecise: false,
    latitude: 45.84824,
    longitude: -97.32999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57270',
  },
  {
    city: 'Vienna',
    county_fips: 46025,
    county_fips_all: '46025|46057',
    county: 'Clark',
    county_names_all: 'Clark|Hamlin',
    county_weights: '{"46025": 83.01, "46057": 16.99}',
    density: 1.5,
    imprecise: false,
    latitude: 44.75179,
    longitude: -97.55161,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57271',
  },
  {
    city: 'Wallace',
    county_fips: 46029,
    county_fips_all: '46029|46025',
    county: 'Codington',
    county_names_all: 'Codington|Clark',
    county_weights: '{"46029": 60.59, "46025": 39.41}',
    density: 1.8,
    imprecise: false,
    latitude: 45.09564,
    longitude: -97.48002,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57272',
  },
  {
    city: 'Waubay',
    county_fips: 46037,
    county_fips_all: '46037|46109',
    county: 'Day',
    county_names_all: 'Day|Roberts',
    county_weights: '{"46037": 77.42, "46109": 22.58}',
    density: 2.6,
    imprecise: false,
    latitude: 45.33334,
    longitude: -97.27574,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57273',
  },
  {
    city: 'Webster',
    county_fips: 46037,
    county_fips_all: '46037|46025',
    county: 'Day',
    county_names_all: 'Day|Clark',
    county_weights: '{"46037": 92.63, "46025": 7.37}',
    density: 2.7,
    imprecise: false,
    latitude: 45.30943,
    longitude: -97.55533,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57274',
  },
  {
    city: 'White',
    county_fips: 46011,
    county_fips_all: '46011',
    county: 'Brookings',
    county_names_all: 'Brookings',
    county_weights: '{"46011": 100}',
    density: 3,
    imprecise: false,
    latitude: 44.43308,
    longitude: -96.61983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57276',
  },
  {
    city: 'Willow Lake',
    county_fips: 46025,
    county_fips_all: '46025',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"46025": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 44.64689,
    longitude: -97.68227,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57278',
  },
  {
    city: 'Wilmot',
    county_fips: 46109,
    county_fips_all: '46109',
    county: 'Roberts',
    county_names_all: 'Roberts',
    county_weights: '{"46109": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 45.41816,
    longitude: -96.87274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57279',
  },
  {
    city: 'Mitchell',
    county_fips: 46035,
    county_fips_all: '46035|46061',
    county: 'Davison',
    county_names_all: 'Davison|Hanson',
    county_weights: '{"46035": 77.51, "46061": 22.49}',
    density: 30.9,
    imprecise: false,
    latitude: 43.71136,
    longitude: -98.04155,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57301',
  },
  {
    city: 'Alexandria',
    county_fips: 46061,
    county_fips_all: '46061|46067',
    county: 'Hanson',
    county_names_all: 'Hanson|Hutchinson',
    county_weights: '{"46061": 99.04, "46067": 0.96}',
    density: 2.8,
    imprecise: false,
    latitude: 43.65112,
    longitude: -97.76483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57311',
  },
  {
    city: 'Alpena',
    county_fips: 46005,
    county_fips_all: '46005|46073|46111',
    county: 'Beadle',
    county_names_all: 'Beadle|Jerauld|Sanborn',
    county_weights: '{"46005": 54.32, "46073": 42.59, "46111": 3.09}',
    density: 1.8,
    imprecise: false,
    latitude: 44.19646,
    longitude: -98.38564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57312',
  },
  {
    city: 'Armour',
    county_fips: 46043,
    county_fips_all: '46043|46023',
    county: 'Douglas',
    county_names_all: 'Douglas|Charles Mix',
    county_weights: '{"46043": 65.91, "46023": 34.09}',
    density: 2.6,
    imprecise: false,
    latitude: 43.31085,
    longitude: -98.36327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57313',
  },
  {
    city: 'Artesian',
    county_fips: 46111,
    county_fips_all: '46111',
    county: 'Sanborn',
    county_names_all: 'Sanborn',
    county_weights: '{"46111": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 44.0509,
    longitude: -97.98904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57314',
  },
  {
    city: 'Avon',
    county_fips: 46009,
    county_fips_all: '46009|46023',
    county: 'Bon Homme',
    county_names_all: 'Bon Homme|Charles Mix',
    county_weights: '{"46009": 96.02, "46023": 3.98}',
    density: 3.3,
    imprecise: false,
    latitude: 42.99391,
    longitude: -98.04852,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57315',
  },
  {
    city: 'Bonesteel',
    county_fips: 46053,
    county_fips_all: '46053',
    county: 'Gregory',
    county_names_all: 'Gregory',
    county_weights: '{"46053": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 43.13153,
    longitude: -98.97891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57317',
  },
  {
    city: 'Bridgewater',
    county_fips: 46087,
    county_fips_all: '46087|46067|46125',
    county: 'McCook',
    county_names_all: 'McCook|Hutchinson|Turner',
    county_weights: '{"46087": 70.62, "46067": 26.05, "46125": 3.33}',
    density: 2.3,
    imprecise: false,
    latitude: 43.53853,
    longitude: -97.48353,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57319',
  },
  {
    city: 'Canova',
    county_fips: 46097,
    county_fips_all: '46097|46087|46061',
    county: 'Miner',
    county_names_all: 'Miner|McCook|Hanson',
    county_weights: '{"46097": 76.29, "46087": 17.05, "46061": 6.66}',
    density: 1.4,
    imprecise: false,
    latitude: 43.87294,
    longitude: -97.54864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57321',
  },
  {
    city: 'Carpenter',
    county_fips: 46005,
    county_fips_all: '46005|46025|46115',
    county: 'Beadle',
    county_names_all: 'Beadle|Clark|Spink',
    county_weights: '{"46005": 43.69, "46025": 36.14, "46115": 20.17}',
    density: 0.9,
    imprecise: false,
    latitude: 44.63498,
    longitude: -97.96129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57322',
  },
  {
    city: 'Carthage',
    county_fips: 46097,
    county_fips_all: '46097|46077|46111',
    county: 'Miner',
    county_names_all: 'Miner|Kingsbury|Sanborn',
    county_weights: '{"46097": 73.94, "46077": 22.78, "46111": 3.28}',
    density: 0.4,
    imprecise: false,
    latitude: 44.16259,
    longitude: -97.72115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57323',
  },
  {
    city: 'Cavour',
    county_fips: 46005,
    county_fips_all: '46005',
    county: 'Beadle',
    county_names_all: 'Beadle',
    county_weights: '{"46005": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 44.30154,
    longitude: -98.04535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57324',
  },
  {
    city: 'Chamberlain',
    county_fips: 46015,
    county_fips_all: '46015|46017',
    county: 'Brule',
    county_names_all: 'Brule|Buffalo',
    county_weights: '{"46015": 65.53, "46017": 34.47}',
    density: 4.5,
    imprecise: false,
    latitude: 43.83961,
    longitude: -99.31144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57325',
  },
  {
    city: 'Corsica',
    county_fips: 46043,
    county_fips_all: '46043|46003',
    county: 'Douglas',
    county_names_all: 'Douglas|Aurora',
    county_weights: '{"46043": 97.57, "46003": 2.43}',
    density: 3.1,
    imprecise: false,
    latitude: 43.43413,
    longitude: -98.44207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57328',
  },
  {
    city: 'Dante',
    county_fips: 46023,
    county_fips_all: '46023',
    county: 'Charles Mix',
    county_names_all: 'Charles Mix',
    county_weights: '{"46023": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 42.97814,
    longitude: -98.1522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57329',
  },
  {
    city: 'Delmont',
    county_fips: 46043,
    county_fips_all: '46043|46023|46067',
    county: 'Douglas',
    county_names_all: 'Douglas|Charles Mix|Hutchinson',
    county_weights: '{"46043": 60.67, "46023": 25.92, "46067": 13.41}',
    density: 2,
    imprecise: false,
    latitude: 43.26147,
    longitude: -98.16082,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57330',
  },
  {
    city: 'Dimock',
    county_fips: 46067,
    county_fips_all: '46067|46043|46035',
    county: 'Hutchinson',
    county_names_all: 'Hutchinson|Douglas|Davison',
    county_weights: '{"46067": 65.81, "46043": 23.26, "46035": 10.93}',
    density: 1.3,
    imprecise: false,
    latitude: 43.47337,
    longitude: -98.04619,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57331',
  },
  {
    city: 'Emery',
    county_fips: 46061,
    county_fips_all: '46061|46067|46087',
    county: 'Hanson',
    county_names_all: 'Hanson|Hutchinson|McCook',
    county_weights: '{"46061": 51.22, "46067": 32.58, "46087": 16.2}',
    density: 3.5,
    imprecise: false,
    latitude: 43.5465,
    longitude: -97.64762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57332',
  },
  {
    city: 'Ethan',
    county_fips: 46035,
    county_fips_all: '46035|46061|46067',
    county: 'Davison',
    county_names_all: 'Davison|Hanson|Hutchinson',
    county_weights: '{"46035": 51.59, "46061": 35.66, "46067": 12.75}',
    density: 3.9,
    imprecise: false,
    latitude: 43.54199,
    longitude: -97.99492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57334',
  },
  {
    city: 'Fairfax',
    county_fips: 46053,
    county_fips_all: '46053',
    county: 'Gregory',
    county_names_all: 'Gregory',
    county_weights: '{"46053": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 43.06005,
    longitude: -98.77255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57335',
  },
  {
    city: 'Fedora',
    county_fips: 46097,
    county_fips_all: '46097|46111',
    county: 'Miner',
    county_names_all: 'Miner|Sanborn',
    county_weights: '{"46097": 94.49, "46111": 5.51}',
    density: 0.6,
    imprecise: false,
    latitude: 44.00108,
    longitude: -97.79048,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57337',
  },
  {
    city: 'Fort Thompson',
    county_fips: 46017,
    county_fips_all: '46017',
    county: 'Buffalo',
    county_names_all: 'Buffalo',
    county_weights: '{"46017": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 44.11233,
    longitude: -99.47862,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57339',
  },
  {
    city: 'Fulton',
    county_fips: 46061,
    county_fips_all: '46061|46097',
    county: 'Hanson',
    county_names_all: 'Hanson|Miner',
    county_weights: '{"46061": 83.95, "46097": 16.05}',
    density: 1.3,
    imprecise: false,
    latitude: 43.79392,
    longitude: -97.85036,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57340',
  },
  {
    city: 'Gann Valley',
    county_fips: 46017,
    county_fips_all: '46017|46015',
    county: 'Buffalo',
    county_names_all: 'Buffalo|Brule',
    county_weights: '{"46017": 96.15, "46015": 3.85}',
    density: 0.1,
    imprecise: false,
    latitude: 44.08077,
    longitude: -99.08974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 79,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57341',
  },
  {
    city: 'Geddes',
    county_fips: 46023,
    county_fips_all: '46023',
    county: 'Charles Mix',
    county_names_all: 'Charles Mix',
    county_weights: '{"46023": 100}',
    density: 1,
    imprecise: false,
    latitude: 43.24561,
    longitude: -98.70054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57342',
  },
  {
    city: 'Harrison',
    county_fips: 46043,
    county_fips_all: '46043',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"46043": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 43.45575,
    longitude: -98.61796,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57344',
  },
  {
    city: 'Highmore',
    county_fips: 46069,
    county_fips_all: '46069',
    county: 'Hyde',
    county_names_all: 'Hyde',
    county_weights: '{"46069": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 44.5687,
    longitude: -99.45009,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57345',
  },
  {
    city: 'Stephan',
    county_fips: 46069,
    county_fips_all: '46069',
    county: 'Hyde',
    county_names_all: 'Hyde',
    county_weights: '{"46069": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 44.24818,
    longitude: -99.45756,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57346',
  },
  {
    city: 'Hitchcock',
    county_fips: 46005,
    county_fips_all: '46005|46115',
    county: 'Beadle',
    county_names_all: 'Beadle|Spink',
    county_weights: '{"46005": 58.29, "46115": 41.71}',
    density: 1.1,
    imprecise: false,
    latitude: 44.62147,
    longitude: -98.36483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57348',
  },
  {
    city: 'Howard',
    county_fips: 46097,
    county_fips_all: '46097',
    county: 'Miner',
    county_names_all: 'Miner',
    county_weights: '{"46097": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 44.02671,
    longitude: -97.57521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57349',
  },
  {
    city: 'Huron',
    county_fips: 46005,
    county_fips_all: '46005|46111',
    county: 'Beadle',
    county_names_all: 'Beadle|Sanborn',
    county_weights: '{"46005": 99.24, "46111": 0.76}',
    density: 21.4,
    imprecise: false,
    latitude: 44.3948,
    longitude: -98.20037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57350',
  },
  {
    city: 'Iroquois',
    county_fips: 46077,
    county_fips_all: '46077|46005|46025',
    county: 'Kingsbury',
    county_names_all: 'Kingsbury|Beadle|Clark',
    county_weights: '{"46077": 55.78, "46005": 41.21, "46025": 3.01}',
    density: 1,
    imprecise: false,
    latitude: 44.36944,
    longitude: -97.83438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57353',
  },
  {
    city: 'Kaylor',
    county_fips: 46067,
    county_fips_all: '46067',
    county: 'Hutchinson',
    county_names_all: 'Hutchinson',
    county_weights: '{"46067": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 43.19099,
    longitude: -97.84236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 86,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57354',
  },
  {
    city: 'Kimball',
    county_fips: 46015,
    county_fips_all: '46015|46073|46017',
    county: 'Brule',
    county_names_all: 'Brule|Jerauld|Buffalo',
    county_weights: '{"46015": 88.81, "46073": 7.15, "46017": 4.04}',
    density: 1.1,
    imprecise: false,
    latitude: 43.7747,
    longitude: -98.95045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57355',
  },
  {
    city: 'Lake Andes',
    county_fips: 46023,
    county_fips_all: '46023',
    county: 'Charles Mix',
    county_names_all: 'Charles Mix',
    county_weights: '{"46023": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 43.1468,
    longitude: -98.51803,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57356',
  },
  {
    city: 'Lane',
    county_fips: 46073,
    county_fips_all: '46073',
    county: 'Jerauld',
    county_names_all: 'Jerauld',
    county_weights: '{"46073": 100}',
    density: 6,
    imprecise: false,
    latitude: 44.07521,
    longitude: -98.42201,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57358',
  },
  {
    city: 'Letcher',
    county_fips: 46111,
    county_fips_all: '46111|46003|46035',
    county: 'Sanborn',
    county_names_all: 'Sanborn|Aurora|Davison',
    county_weights: '{"46111": 76.21, "46003": 14.94, "46035": 8.85}',
    density: 1.6,
    imprecise: false,
    latitude: 43.90105,
    longitude: -98.15589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57359',
  },
  {
    city: 'Marty',
    county_fips: 46023,
    county_fips_all: '46023',
    county: 'Charles Mix',
    county_names_all: 'Charles Mix',
    county_weights: '{"46023": 100}',
    density: 43.3,
    imprecise: false,
    latitude: 42.99459,
    longitude: -98.43463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57361',
  },
  {
    city: 'Miller',
    county_fips: 46059,
    county_fips_all: '46059|46017',
    county: 'Hand',
    county_names_all: 'Hand|Buffalo',
    county_weights: '{"46059": 96.96, "46017": 3.04}',
    density: 1.6,
    imprecise: false,
    latitude: 44.47488,
    longitude: -99.06447,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57362',
  },
  {
    city: 'Mount Vernon',
    county_fips: 46035,
    county_fips_all: '46035|46111|46003',
    county: 'Davison',
    county_names_all: 'Davison|Sanborn|Aurora',
    county_weights: '{"46035": 91.21, "46111": 6.31, "46003": 2.48}',
    density: 1.8,
    imprecise: false,
    latitude: 43.68723,
    longitude: -98.25491,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57363',
  },
  {
    city: 'New Holland',
    county_fips: 46043,
    county_fips_all: '46043',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"46043": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 43.43442,
    longitude: -98.61786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57364',
  },
  {
    city: 'Oacoma',
    county_fips: 46085,
    county_fips_all: '46085',
    county: 'Lyman',
    county_names_all: 'Lyman',
    county_weights: '{"46085": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 43.81148,
    longitude: -99.41723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57365',
  },
  {
    city: 'Parkston',
    county_fips: 46067,
    county_fips_all: '46067|46043',
    county: 'Hutchinson',
    county_names_all: 'Hutchinson|Douglas',
    county_weights: '{"46067": 88.89, "46043": 11.11}',
    density: 4.6,
    imprecise: false,
    latitude: 43.3855,
    longitude: -97.94306,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57366',
  },
  {
    city: 'Pickstown',
    county_fips: 46023,
    county_fips_all: '46023',
    county: 'Charles Mix',
    county_names_all: 'Charles Mix',
    county_weights: '{"46023": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 43.06348,
    longitude: -98.5133,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57367',
  },
  {
    city: 'Plankinton',
    county_fips: 46003,
    county_fips_all: '46003',
    county: 'Aurora',
    county_names_all: 'Aurora',
    county_weights: '{"46003": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 43.75117,
    longitude: -98.47593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57368',
  },
  {
    city: 'Platte',
    county_fips: 46023,
    county_fips_all: '46023|46015|46043|46003',
    county: 'Charles Mix',
    county_names_all: 'Charles Mix|Brule|Douglas|Aurora',
    county_weights:
      '{"46023": 75.13, "46015": 21.88, "46043": 2.07, "46003": 0.92}',
    density: 2.2,
    imprecise: false,
    latitude: 43.42544,
    longitude: -98.94606,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57369',
  },
  {
    city: 'Pukwana',
    county_fips: 46015,
    county_fips_all: '46015|46017',
    county: 'Brule',
    county_names_all: 'Brule|Buffalo',
    county_weights: '{"46015": 78.7, "46017": 21.3}',
    density: 1.6,
    imprecise: false,
    latitude: 43.80508,
    longitude: -99.17211,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57370',
  },
  {
    city: 'Ree Heights',
    county_fips: 46059,
    county_fips_all: '46059|46069',
    county: 'Hand',
    county_names_all: 'Hand|Hyde',
    county_weights: '{"46059": 97.48, "46069": 2.52}',
    density: 0.4,
    imprecise: false,
    latitude: 44.43146,
    longitude: -99.23104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57371',
  },
  {
    city: 'Saint Lawrence',
    county_fips: 46059,
    county_fips_all: '46059',
    county: 'Hand',
    county_names_all: 'Hand',
    county_weights: '{"46059": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 44.52936,
    longitude: -98.86987,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57373',
  },
  {
    city: 'Spencer',
    county_fips: 46087,
    county_fips_all: '46087|46061',
    county: 'McCook',
    county_names_all: 'McCook|Hanson',
    county_weights: '{"46087": 54.05, "46061": 45.95}',
    density: 1.4,
    imprecise: false,
    latitude: 43.75582,
    longitude: -97.60361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57374',
  },
  {
    city: 'Stickney',
    county_fips: 46003,
    county_fips_all: '46003|46035',
    county: 'Aurora',
    county_names_all: 'Aurora|Davison',
    county_weights: '{"46003": 98.57, "46035": 1.43}',
    density: 1.6,
    imprecise: false,
    latitude: 43.56222,
    longitude: -98.47877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57375',
  },
  {
    city: 'Tripp',
    county_fips: 46067,
    county_fips_all: '46067|46009',
    county: 'Hutchinson',
    county_names_all: 'Hutchinson|Bon Homme',
    county_weights: '{"46067": 78.14, "46009": 21.86}',
    density: 2.4,
    imprecise: false,
    latitude: 43.21948,
    longitude: -97.94176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57376',
  },
  {
    city: 'Virgil',
    county_fips: 46005,
    county_fips_all: '46005',
    county: 'Beadle',
    county_names_all: 'Beadle',
    county_weights: '{"46005": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 44.26428,
    longitude: -98.53795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57379',
  },
  {
    city: 'Wagner',
    county_fips: 46023,
    county_fips_all: '46023',
    county: 'Charles Mix',
    county_names_all: 'Charles Mix',
    county_weights: '{"46023": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 43.03387,
    longitude: -98.28916,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57380',
  },
  {
    city: 'Wessington',
    county_fips: 46059,
    county_fips_all: '46059|46005',
    county: 'Hand',
    county_names_all: 'Hand|Beadle',
    county_weights: '{"46059": 61.42, "46005": 38.58}',
    density: 0.6,
    imprecise: false,
    latitude: 44.38717,
    longitude: -98.73267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57381',
  },
  {
    city: 'Wessington Springs',
    county_fips: 46073,
    county_fips_all: '46073|46003|46005',
    county: 'Jerauld',
    county_names_all: 'Jerauld|Aurora|Beadle',
    county_weights: '{"46073": 85.0, "46003": 11.69, "46005": 3.31}',
    density: 1,
    imprecise: false,
    latitude: 44.05561,
    longitude: -98.67303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57382',
  },
  {
    city: 'White Lake',
    county_fips: 46003,
    county_fips_all: '46003|46015',
    county: 'Aurora',
    county_names_all: 'Aurora|Brule',
    county_weights: '{"46003": 95.49, "46015": 4.51}',
    density: 1.4,
    imprecise: false,
    latitude: 43.7177,
    longitude: -98.71382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57383',
  },
  {
    city: 'Wolsey',
    county_fips: 46005,
    county_fips_all: '46005',
    county: 'Beadle',
    county_names_all: 'Beadle',
    county_weights: '{"46005": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 44.42044,
    longitude: -98.48477,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57384',
  },
  {
    city: 'Woonsocket',
    county_fips: 46111,
    county_fips_all: '46111|46073|46003',
    county: 'Sanborn',
    county_names_all: 'Sanborn|Jerauld|Aurora',
    county_weights: '{"46111": 65.84, "46073": 30.38, "46003": 3.78}',
    density: 2.3,
    imprecise: false,
    latitude: 44.04433,
    longitude: -98.29507,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57385',
  },
  {
    city: 'Yale',
    county_fips: 46005,
    county_fips_all: '46005',
    county: 'Beadle',
    county_names_all: 'Beadle',
    county_weights: '{"46005": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 44.50908,
    longitude: -97.99845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57386',
  },
  {
    city: 'Aberdeen',
    county_fips: 46013,
    county_fips_all: '46013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"46013": 100}',
    density: 44.2,
    imprecise: false,
    latitude: 45.4753,
    longitude: -98.53042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57401',
  },
  {
    city: 'Akaska',
    county_fips: 46129,
    county_fips_all: '46129',
    county: 'Walworth',
    county_names_all: 'Walworth',
    county_weights: '{"46129": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 45.2852,
    longitude: -100.14319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57420',
  },
  {
    city: 'Amherst',
    county_fips: 46091,
    county_fips_all: '46091',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"46091": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 45.75045,
    longitude: -97.90618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 75,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57421',
  },
  {
    city: 'Andover',
    county_fips: 46037,
    county_fips_all: '46037|46013',
    county: 'Day',
    county_names_all: 'Day|Brown',
    county_weights: '{"46037": 95.55, "46013": 4.45}',
    density: 0.6,
    imprecise: false,
    latitude: 45.42288,
    longitude: -97.92199,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57422',
  },
  {
    city: 'Ashton',
    county_fips: 46115,
    county_fips_all: '46115|46049',
    county: 'Spink',
    county_names_all: 'Spink|Faulk',
    county_weights: '{"46115": 92.97, "46049": 7.03}',
    density: 1,
    imprecise: false,
    latitude: 45.02012,
    longitude: -98.53101,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57424',
  },
  {
    city: 'Barnard',
    county_fips: 46013,
    county_fips_all: '46013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"46013": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 45.73485,
    longitude: -98.4936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57426',
  },
  {
    city: 'Bath',
    county_fips: 46013,
    county_fips_all: '46013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"46013": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 45.48109,
    longitude: -98.31786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57427',
  },
  {
    city: 'Bowdle',
    county_fips: 46045,
    county_fips_all: '46045|46129',
    county: 'Edmunds',
    county_names_all: 'Edmunds|Walworth',
    county_weights: '{"46045": 62.98, "46129": 37.02}',
    density: 1.1,
    imprecise: false,
    latitude: 45.44984,
    longitude: -99.67922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57428',
  },
  {
    city: 'Brentford',
    county_fips: 46115,
    county_fips_all: '46115',
    county: 'Spink',
    county_names_all: 'Spink',
    county_weights: '{"46115": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 45.16116,
    longitude: -98.3005,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57429',
  },
  {
    city: 'Britton',
    county_fips: 46091,
    county_fips_all: '46091|38081',
    county: 'Marshall',
    county_names_all: 'Marshall|Sargent',
    county_weights: '{"46091": 99.13, "38081": 0.87}',
    density: 2,
    imprecise: false,
    latitude: 45.82203,
    longitude: -97.72205,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57430',
  },
  {
    city: 'Claremont',
    county_fips: 46013,
    county_fips_all: '46013|46091',
    county: 'Brown',
    county_names_all: 'Brown|Marshall',
    county_weights: '{"46013": 75.93, "46091": 24.07}',
    density: 1.8,
    imprecise: false,
    latitude: 45.6839,
    longitude: -98.02453,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57432',
  },
  {
    city: 'Columbia',
    county_fips: 46013,
    county_fips_all: '46013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"46013": 100}',
    density: 1,
    imprecise: false,
    latitude: 45.64311,
    longitude: -98.32104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57433',
  },
  {
    city: 'Conde',
    county_fips: 46115,
    county_fips_all: '46115|46025|46013|46037',
    county: 'Spink',
    county_names_all: 'Spink|Clark|Brown|Day',
    county_weights:
      '{"46115": 56.28, "46025": 17.55, "46013": 17.37, "46037": 8.8}',
    density: 0.7,
    imprecise: false,
    latitude: 45.16669,
    longitude: -98.07049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57434',
  },
  {
    city: 'Cresbard',
    county_fips: 46049,
    county_fips_all: '46049|46045',
    county: 'Faulk',
    county_names_all: 'Faulk|Edmunds',
    county_weights: '{"46049": 76.73, "46045": 23.27}',
    density: 0.8,
    imprecise: false,
    latitude: 45.16916,
    longitude: -98.90975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57435',
  },
  {
    city: 'Doland',
    county_fips: 46115,
    county_fips_all: '46115',
    county: 'Spink',
    county_names_all: 'Spink',
    county_weights: '{"46115": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 44.84864,
    longitude: -98.09131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57436',
  },
  {
    city: 'Eureka',
    county_fips: 46089,
    county_fips_all: '46089|46021',
    county: 'McPherson',
    county_names_all: 'McPherson|Campbell',
    county_weights: '{"46089": 69.15, "46021": 30.85}',
    density: 0.8,
    imprecise: false,
    latitude: 45.78368,
    longitude: -99.618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57437',
  },
  {
    city: 'Faulkton',
    county_fips: 46049,
    county_fips_all: '46049',
    county: 'Faulk',
    county_names_all: 'Faulk',
    county_weights: '{"46049": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 45.06899,
    longitude: -99.15462,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57438',
  },
  {
    city: 'Ferney',
    county_fips: 46013,
    county_fips_all: '46013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"46013": 100}',
    density: 0,
    imprecise: false,
    latitude: 45.33464,
    longitude: -98.10007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57439',
  },
  {
    city: 'Frankfort',
    county_fips: 46115,
    county_fips_all: '46115',
    county: 'Spink',
    county_names_all: 'Spink',
    county_weights: '{"46115": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 44.8502,
    longitude: -98.25956,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57440',
  },
  {
    city: 'Frederick',
    county_fips: 46013,
    county_fips_all: '46013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"46013": 100}',
    density: 1,
    imprecise: false,
    latitude: 45.82275,
    longitude: -98.51474,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57441',
  },
  {
    city: 'Gettysburg',
    county_fips: 46107,
    county_fips_all: '46107|46041|46119',
    county: 'Potter',
    county_names_all: 'Potter|Dewey|Sully',
    county_weights: '{"46107": 82.85, "46041": 15.18, "46119": 1.97}',
    density: 1.2,
    imprecise: false,
    latitude: 45.05721,
    longitude: -100.14997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57442',
  },
  {
    city: 'Groton',
    county_fips: 46013,
    county_fips_all: '46013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"46013": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 45.45828,
    longitude: -98.12094,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57445',
  },
  {
    city: 'Hecla',
    county_fips: 46013,
    county_fips_all: '46013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"46013": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 45.86698,
    longitude: -98.15423,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57446',
  },
  {
    city: 'Hosmer',
    county_fips: 46089,
    county_fips_all: '46089|46045',
    county: 'McPherson',
    county_names_all: 'McPherson|Edmunds',
    county_weights: '{"46089": 58.41, "46045": 41.59}',
    density: 0.9,
    imprecise: false,
    latitude: 45.61196,
    longitude: -99.41859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57448',
  },
  {
    city: 'Houghton',
    county_fips: 46013,
    county_fips_all: '46013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"46013": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 45.73101,
    longitude: -98.17553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57449',
  },
  {
    city: 'Hoven',
    county_fips: 46107,
    county_fips_all: '46107|46129',
    county: 'Potter',
    county_names_all: 'Potter|Walworth',
    county_weights: '{"46107": 64.42, "46129": 35.58}',
    density: 1.2,
    imprecise: false,
    latitude: 45.21599,
    longitude: -99.83696,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57450',
  },
  {
    city: 'Ipswich',
    county_fips: 46045,
    county_fips_all: '46045|46013',
    county: 'Edmunds',
    county_names_all: 'Edmunds|Brown',
    county_weights: '{"46045": 92.48, "46013": 7.52}',
    density: 2.2,
    imprecise: false,
    latitude: 45.43488,
    longitude: -98.93473,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57451',
  },
  {
    city: 'Java',
    county_fips: 46129,
    county_fips_all: '46129|46021',
    county: 'Walworth',
    county_names_all: 'Walworth|Campbell',
    county_weights: '{"46129": 70.76, "46021": 29.24}',
    density: 0.3,
    imprecise: false,
    latitude: 45.52873,
    longitude: -99.87334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57452',
  },
  {
    city: 'Langford',
    county_fips: 46091,
    county_fips_all: '46091|46037',
    county: 'Marshall',
    county_names_all: 'Marshall|Day',
    county_weights: '{"46091": 69.85, "46037": 30.15}',
    density: 1.9,
    imprecise: false,
    latitude: 45.61058,
    longitude: -97.77286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57454',
  },
  {
    city: 'Lebanon',
    county_fips: 46107,
    county_fips_all: '46107',
    county: 'Potter',
    county_names_all: 'Potter',
    county_weights: '{"46107": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 44.99301,
    longitude: -99.74011,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57455',
  },
  {
    city: 'Leola',
    county_fips: 46089,
    county_fips_all: '46089|46045',
    county: 'McPherson',
    county_names_all: 'McPherson|Edmunds',
    county_weights: '{"46089": 97.26, "46045": 2.74}',
    density: 0.7,
    imprecise: false,
    latitude: 45.72104,
    longitude: -98.99589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57456',
  },
  {
    city: 'Long Lake',
    county_fips: 46089,
    county_fips_all: '46089',
    county: 'McPherson',
    county_names_all: 'McPherson',
    county_weights: '{"46089": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 45.87281,
    longitude: -99.15812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57457',
  },
  {
    city: 'Mansfield',
    county_fips: 46013,
    county_fips_all: '46013|46045|46115|46049',
    county: 'Brown',
    county_names_all: 'Brown|Edmunds|Spink|Faulk',
    county_weights:
      '{"46013": 58.07, "46045": 21.16, "46115": 10.93, "46049": 9.84}',
    density: 0.8,
    imprecise: false,
    latitude: 45.27323,
    longitude: -98.66585,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57460',
  },
  {
    city: 'Mellette',
    county_fips: 46115,
    county_fips_all: '46115|46013',
    county: 'Spink',
    county_names_all: 'Spink|Brown',
    county_weights: '{"46115": 98.16, "46013": 1.84}',
    density: 1.1,
    imprecise: false,
    latitude: 45.16085,
    longitude: -98.43327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57461',
  },
  {
    city: 'Northville',
    county_fips: 46115,
    county_fips_all: '46115|46049',
    county: 'Spink',
    county_names_all: 'Spink|Faulk',
    county_weights: '{"46115": 60.22, "46049": 39.78}',
    density: 1.1,
    imprecise: false,
    latitude: 45.14443,
    longitude: -98.68573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57465',
  },
  {
    city: 'Onaka',
    county_fips: 46049,
    county_fips_all: '46049|46045',
    county: 'Faulk',
    county_names_all: 'Faulk|Edmunds',
    county_weights: '{"46049": 76.24, "46045": 23.76}',
    density: 0.5,
    imprecise: false,
    latitude: 45.20045,
    longitude: -99.45885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57466',
  },
  {
    city: 'Orient',
    county_fips: 46059,
    county_fips_all: '46059|46049',
    county: 'Hand',
    county_names_all: 'Hand|Faulk',
    county_weights: '{"46059": 90.05, "46049": 9.95}',
    density: 0.8,
    imprecise: false,
    latitude: 44.82754,
    longitude: -99.14221,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57467',
  },
  {
    city: 'Pierpont',
    county_fips: 46037,
    county_fips_all: '46037',
    county: 'Day',
    county_names_all: 'Day',
    county_weights: '{"46037": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 45.49797,
    longitude: -97.75318,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57468',
  },
  {
    city: 'Redfield',
    county_fips: 46115,
    county_fips_all: '46115|46059|46049',
    county: 'Spink',
    county_names_all: 'Spink|Hand|Faulk',
    county_weights: '{"46115": 77.12, "46059": 16.92, "46049": 5.96}',
    density: 3.7,
    imprecise: false,
    latitude: 44.85858,
    longitude: -98.57535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57469',
  },
  {
    city: 'Rockham',
    county_fips: 46059,
    county_fips_all: '46059|46049',
    county: 'Hand',
    county_names_all: 'Hand|Faulk',
    county_weights: '{"46059": 59.36, "46049": 40.64}',
    density: 0.6,
    imprecise: false,
    latitude: 44.87726,
    longitude: -98.86709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57470',
  },
  {
    city: 'Roscoe',
    county_fips: 46045,
    county_fips_all: '46045|46089',
    county: 'Edmunds',
    county_names_all: 'Edmunds|McPherson',
    county_weights: '{"46045": 96.31, "46089": 3.69}',
    density: 0.6,
    imprecise: false,
    latitude: 45.40967,
    longitude: -99.31359,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57471',
  },
  {
    city: 'Selby',
    county_fips: 46129,
    county_fips_all: '46129|46021',
    county: 'Walworth',
    county_names_all: 'Walworth|Campbell',
    county_weights: '{"46129": 99.31, "46021": 0.69}',
    density: 1.6,
    imprecise: false,
    latitude: 45.4284,
    longitude: -100.10393,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57472',
  },
  {
    city: 'Seneca',
    county_fips: 46049,
    county_fips_all: '46049|46107',
    county: 'Faulk',
    county_names_all: 'Faulk|Potter',
    county_weights: '{"46049": 81.76, "46107": 18.24}',
    density: 0.5,
    imprecise: false,
    latitude: 44.98993,
    longitude: -99.483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57473',
  },
  {
    city: 'Stratford',
    county_fips: 46013,
    county_fips_all: '46013|46115',
    county: 'Brown',
    county_names_all: 'Brown|Spink',
    county_weights: '{"46013": 82.15, "46115": 17.85}',
    density: 1.1,
    imprecise: false,
    latitude: 45.28577,
    longitude: -98.27526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57474',
  },
  {
    city: 'Tolstoy',
    county_fips: 46107,
    county_fips_all: '46107|46045',
    county: 'Potter',
    county_names_all: 'Potter|Edmunds',
    county_weights: '{"46107": 51.32, "46045": 48.68}',
    density: 0.3,
    imprecise: false,
    latitude: 45.22843,
    longitude: -99.62031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57475',
  },
  {
    city: 'Tulare',
    county_fips: 46115,
    county_fips_all: '46115|46059',
    county: 'Spink',
    county_names_all: 'Spink|Hand',
    county_weights: '{"46115": 75.97, "46059": 24.03}',
    density: 0.9,
    imprecise: false,
    latitude: 44.71277,
    longitude: -98.62127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57476',
  },
  {
    city: 'Turton',
    county_fips: 46115,
    county_fips_all: '46115',
    county: 'Spink',
    county_names_all: 'Spink',
    county_weights: '{"46115": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 45.03363,
    longitude: -98.15024,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57477',
  },
  {
    city: 'Warner',
    county_fips: 46013,
    county_fips_all: '46013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"46013": 100}',
    density: 5,
    imprecise: false,
    latitude: 45.30415,
    longitude: -98.4382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57479',
  },
  {
    city: 'Westport',
    county_fips: 46013,
    county_fips_all: '46013|46089|46045',
    county: 'Brown',
    county_names_all: 'Brown|McPherson|Edmunds',
    county_weights: '{"46013": 56.47, "46089": 31.28, "46045": 12.25}',
    density: 0.6,
    imprecise: false,
    latitude: 45.65279,
    longitude: -98.66821,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57481',
  },
  {
    city: 'Pierre',
    county_fips: 46065,
    county_fips_all: '46065|46119',
    county: 'Hughes',
    county_names_all: 'Hughes|Sully',
    county_weights: '{"46065": 55.15, "46119": 44.85}',
    density: 11.9,
    imprecise: false,
    latitude: 44.53525,
    longitude: -100.31906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57501',
  },
  {
    city: 'Agar',
    county_fips: 46119,
    county_fips_all: '46119',
    county: 'Sully',
    county_names_all: 'Sully',
    county_weights: '{"46119": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 44.84159,
    longitude: -100.16447,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57520',
  },
  {
    city: 'Belvidere',
    county_fips: 46095,
    county_fips_all: '46095|46071',
    county: 'Mellette',
    county_names_all: 'Mellette|Jackson',
    county_weights: '{"46095": 50.16, "46071": 49.84}',
    density: 0.3,
    imprecise: false,
    latitude: 43.79349,
    longitude: -101.18682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57521',
  },
  {
    city: 'Blunt',
    county_fips: 46065,
    county_fips_all: '46065|46119',
    county: 'Hughes',
    county_names_all: 'Hughes|Sully',
    county_weights: '{"46065": 69.14, "46119": 30.86}',
    density: 1.2,
    imprecise: false,
    latitude: 44.51014,
    longitude: -99.96352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57522',
  },
  {
    city: 'Burke',
    county_fips: 46053,
    county_fips_all: '46053',
    county: 'Gregory',
    county_names_all: 'Gregory',
    county_weights: '{"46053": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 43.24437,
    longitude: -99.23795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57523',
  },
  {
    city: 'Colome',
    county_fips: 46123,
    county_fips_all: '46123',
    county: 'Tripp',
    county_names_all: 'Tripp',
    county_weights: '{"46123": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 43.17814,
    longitude: -99.75901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57528',
  },
  {
    city: 'Dallas',
    county_fips: 46123,
    county_fips_all: '46123|46053',
    county: 'Tripp',
    county_names_all: 'Tripp|Gregory',
    county_weights: '{"46123": 70.14, "46053": 29.86}',
    density: 0.4,
    imprecise: false,
    latitude: 43.22931,
    longitude: -99.57019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57529',
  },
  {
    city: 'Draper',
    county_fips: 46075,
    county_fips_all: '46075|46117',
    county: 'Jones',
    county_names_all: 'Jones|Stanley',
    county_weights: '{"46075": 97.98, "46117": 2.02}',
    density: 0.2,
    imprecise: false,
    latitude: 43.98038,
    longitude: -100.48601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57531',
  },
  {
    city: 'Fort Pierre',
    county_fips: 46117,
    county_fips_all: '46117|46085',
    county: 'Stanley',
    county_names_all: 'Stanley|Lyman',
    county_weights: '{"46117": 85.3, "46085": 14.7}',
    density: 0.9,
    imprecise: false,
    latitude: 44.36129,
    longitude: -100.56405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57532',
  },
  {
    city: 'Gregory',
    county_fips: 46053,
    county_fips_all: '46053|46085|46123',
    county: 'Gregory',
    county_names_all: 'Gregory|Lyman|Tripp',
    county_weights: '{"46053": 71.14, "46085": 27.84, "46123": 1.02}',
    density: 1.7,
    imprecise: false,
    latitude: 43.3463,
    longitude: -99.41692,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57533',
  },
  {
    city: 'Hamill',
    county_fips: 46123,
    county_fips_all: '46123|46085',
    county: 'Tripp',
    county_names_all: 'Tripp|Lyman',
    county_weights: '{"46123": 79.65, "46085": 20.35}',
    density: 0.2,
    imprecise: false,
    latitude: 43.5709,
    longitude: -99.65975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57534',
  },
  {
    city: 'Harrold',
    county_fips: 46065,
    county_fips_all: '46065|46119',
    county: 'Hughes',
    county_names_all: 'Hughes|Sully',
    county_weights: '{"46065": 72.59, "46119": 27.41}',
    density: 0.3,
    imprecise: false,
    latitude: 44.41502,
    longitude: -99.76694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57536',
  },
  {
    city: 'Hayes',
    county_fips: 46117,
    county_fips_all: '46117|46055',
    county: 'Stanley',
    county_names_all: 'Stanley|Haakon',
    county_weights: '{"46117": 83.6, "46055": 16.4}',
    density: 0,
    imprecise: false,
    latitude: 44.58366,
    longitude: -101.07399,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57537',
  },
  {
    city: 'Herrick',
    county_fips: 46053,
    county_fips_all: '46053',
    county: 'Gregory',
    county_names_all: 'Gregory',
    county_weights: '{"46053": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 43.12167,
    longitude: -99.15551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57538',
  },
  {
    city: 'Holabird',
    county_fips: 46069,
    county_fips_all: '46069',
    county: 'Hyde',
    county_names_all: 'Hyde',
    county_weights: '{"46069": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 44.46477,
    longitude: -99.60377,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57540',
  },
  {
    city: 'Ideal',
    county_fips: 46123,
    county_fips_all: '46123',
    county: 'Tripp',
    county_names_all: 'Tripp',
    county_weights: '{"46123": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 43.60001,
    longitude: -99.90895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57541',
  },
  {
    city: 'Kadoka',
    county_fips: 46071,
    county_fips_all: '46071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"46071": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 43.74785,
    longitude: -101.52268,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57543',
  },
  {
    city: 'Kennebec',
    county_fips: 46085,
    county_fips_all: '46085|46123',
    county: 'Lyman',
    county_names_all: 'Lyman|Tripp',
    county_weights: '{"46085": 93.88, "46123": 6.12}',
    density: 0.6,
    imprecise: false,
    latitude: 43.88374,
    longitude: -99.83647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57544',
  },
  {
    city: 'Long Valley',
    county_fips: 46071,
    county_fips_all: '46071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"46071": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 43.48337,
    longitude: -101.44054,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57547',
  },
  {
    city: 'Lower Brule',
    county_fips: 46085,
    county_fips_all: '46085',
    county: 'Lyman',
    county_names_all: 'Lyman',
    county_weights: '{"46085": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 44.08429,
    longitude: -99.62373,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57548',
  },
  {
    city: 'Martin',
    county_fips: 46007,
    county_fips_all: '46007',
    county: 'Bennett',
    county_names_all: 'Bennett',
    county_weights: '{"46007": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 43.18087,
    longitude: -101.70012,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57551',
  },
  {
    city: 'Midland',
    county_fips: 46055,
    county_fips_all: '46055|46117|46075|46071',
    county: 'Haakon',
    county_names_all: 'Haakon|Stanley|Jones|Jackson',
    county_weights:
      '{"46055": 71.5, "46117": 14.57, "46075": 10.28, "46071": 3.65}',
    density: 0.3,
    imprecise: false,
    latitude: 44.25903,
    longitude: -101.20833,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57552',
  },
  {
    city: 'Milesville',
    county_fips: 46055,
    county_fips_all: '46055',
    county: 'Haakon',
    county_names_all: 'Haakon',
    county_weights: '{"46055": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 44.48547,
    longitude: -101.64489,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57553',
  },
  {
    city: 'Mission',
    county_fips: 46121,
    county_fips_all: '46121',
    county: 'Todd',
    county_names_all: 'Todd',
    county_weights: '{"46121": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 43.29828,
    longitude: -100.6601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57555',
  },
  {
    city: 'Murdo',
    county_fips: 46075,
    county_fips_all: '46075|46095',
    county: 'Jones',
    county_names_all: 'Jones|Mellette',
    county_weights: '{"46075": 99.17, "46095": 0.83}',
    density: 0.7,
    imprecise: false,
    latitude: 43.93654,
    longitude: -100.72054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57559',
  },
  {
    city: 'Norris',
    county_fips: 46095,
    county_fips_all: '46095|46007|46071',
    county: 'Mellette',
    county_names_all: 'Mellette|Bennett|Jackson',
    county_weights: '{"46095": 56.28, "46007": 24.97, "46071": 18.75}',
    density: 0.9,
    imprecise: false,
    latitude: 43.44006,
    longitude: -101.21226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57560',
  },
  {
    city: 'Okaton',
    county_fips: 46075,
    county_fips_all: '46075',
    county: 'Jones',
    county_names_all: 'Jones',
    county_weights: '{"46075": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 43.89962,
    longitude: -100.95816,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57562',
  },
  {
    city: 'Okreek',
    county_fips: 46121,
    county_fips_all: '46121',
    county: 'Todd',
    county_names_all: 'Todd',
    county_weights: '{"46121": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 43.36039,
    longitude: -100.40149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57563',
  },
  {
    city: 'Onida',
    county_fips: 46119,
    county_fips_all: '46119|46069',
    county: 'Sully',
    county_names_all: 'Sully|Hyde',
    county_weights: '{"46119": 97.75, "46069": 2.25}',
    density: 0.8,
    imprecise: false,
    latitude: 44.72401,
    longitude: -100.0121,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57564',
  },
  {
    city: 'Parmelee',
    county_fips: 46121,
    county_fips_all: '46121|46095',
    county: 'Todd',
    county_names_all: 'Todd|Mellette',
    county_weights: '{"46121": 90.69, "46095": 9.31}',
    density: 3,
    imprecise: false,
    latitude: 43.31237,
    longitude: -101.10019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57566',
  },
  {
    city: 'Philip',
    county_fips: 46055,
    county_fips_all: '46055|46071',
    county: 'Haakon',
    county_names_all: 'Haakon|Jackson',
    county_weights: '{"46055": 74.01, "46071": 25.99}',
    density: 0.4,
    imprecise: false,
    latitude: 44.13519,
    longitude: -101.7152,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57567',
  },
  {
    city: 'Presho',
    county_fips: 46085,
    county_fips_all: '46085',
    county: 'Lyman',
    county_names_all: 'Lyman',
    county_weights: '{"46085": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 43.88498,
    longitude: -100.08857,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57568',
  },
  {
    city: 'Reliance',
    county_fips: 46085,
    county_fips_all: '46085',
    county: 'Lyman',
    county_names_all: 'Lyman',
    county_weights: '{"46085": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 43.8605,
    longitude: -99.57582,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57569',
  },
  {
    city: 'Rosebud',
    county_fips: 46121,
    county_fips_all: '46121',
    county: 'Todd',
    county_names_all: 'Todd',
    county_weights: '{"46121": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 43.24284,
    longitude: -100.87127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57570',
  },
  {
    city: 'Saint Charles',
    county_fips: 46053,
    county_fips_all: '46053',
    county: 'Gregory',
    county_names_all: 'Gregory',
    county_weights: '{"46053": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 43.04152,
    longitude: -99.09042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57571',
  },
  {
    city: 'Saint Francis',
    county_fips: 46121,
    county_fips_all: '46121',
    county: 'Todd',
    county_names_all: 'Todd',
    county_weights: '{"46121": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 43.12009,
    longitude: -101.08491,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57572',
  },
  {
    city: 'Tuthill',
    county_fips: 46007,
    county_fips_all: '46007',
    county: 'Bennett',
    county_names_all: 'Bennett',
    county_weights: '{"46007": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 43.10954,
    longitude: -101.36238,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57574',
  },
  {
    city: 'Vivian',
    county_fips: 46085,
    county_fips_all: '46085|46075',
    county: 'Lyman',
    county_names_all: 'Lyman|Jones',
    county_weights: '{"46085": 91.33, "46075": 8.67}',
    density: 0.4,
    imprecise: false,
    latitude: 43.90804,
    longitude: -100.29411,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57576',
  },
  {
    city: 'Wanblee',
    county_fips: 46071,
    county_fips_all: '46071|46007',
    county: 'Jackson',
    county_names_all: 'Jackson|Bennett',
    county_weights: '{"46071": 96.09, "46007": 3.91}',
    density: 1.7,
    imprecise: false,
    latitude: 43.52353,
    longitude: -101.66029,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57577',
  },
  {
    city: 'White River',
    county_fips: 46095,
    county_fips_all: '46095',
    county: 'Mellette',
    county_names_all: 'Mellette',
    county_weights: '{"46095": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 43.57484,
    longitude: -100.78578,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57579',
  },
  {
    city: 'Winner',
    county_fips: 46123,
    county_fips_all: '46123|46121|46095',
    county: 'Tripp',
    county_names_all: 'Tripp|Todd|Mellette',
    county_weights: '{"46123": 79.66, "46121": 17.1, "46095": 3.24}',
    density: 1.6,
    imprecise: false,
    latitude: 43.28987,
    longitude: -100.05772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57580',
  },
  {
    city: 'Witten',
    county_fips: 46123,
    county_fips_all: '46123',
    county: 'Tripp',
    county_names_all: 'Tripp',
    county_weights: '{"46123": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 43.49115,
    longitude: -100.06382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57584',
  },
  {
    city: 'Wood',
    county_fips: 46095,
    county_fips_all: '46095',
    county: 'Mellette',
    county_names_all: 'Mellette',
    county_weights: '{"46095": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 43.55508,
    longitude: -100.39752,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57585',
  },
  {
    city: 'Mobridge',
    county_fips: 46041,
    county_fips_all: '46041|46031|46129',
    county: 'Dewey',
    county_names_all: 'Dewey|Corson|Walworth',
    county_weights: '{"46041": 84.06, "46031": 9.4, "46129": 6.54}',
    density: 3.1,
    imprecise: false,
    latitude: 45.36646,
    longitude: -100.51108,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57601',
  },
  {
    city: 'Bison',
    county_fips: 46105,
    county_fips_all: '46105',
    county: 'Perkins',
    county_names_all: 'Perkins',
    county_weights: '{"46105": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 45.38425,
    longitude: -102.53897,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57620',
  },
  {
    city: 'Bullhead',
    county_fips: 46031,
    county_fips_all: '46031',
    county: 'Corson',
    county_names_all: 'Corson',
    county_weights: '{"46031": 100}',
    density: 37,
    imprecise: false,
    latitude: 45.76891,
    longitude: -101.0808,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57621',
  },
  {
    city: 'Cherry Creek',
    county_fips: 46137,
    county_fips_all: '46137',
    county: 'Ziebach',
    county_names_all: 'Ziebach',
    county_weights: '{"46137": 100}',
    density: 1,
    imprecise: false,
    latitude: 44.65177,
    longitude: -101.54572,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57622',
  },
  {
    city: 'Dupree',
    county_fips: 46137,
    county_fips_all: '46137',
    county: 'Ziebach',
    county_names_all: 'Ziebach',
    county_weights: '{"46137": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 45.01587,
    longitude: -101.65925,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57623',
  },
  {
    city: 'Eagle Butte',
    county_fips: 46041,
    county_fips_all: '46041|46137',
    county: 'Dewey',
    county_names_all: 'Dewey|Ziebach',
    county_weights: '{"46041": 78.65, "46137": 21.35}',
    density: 1.1,
    imprecise: false,
    latitude: 44.95738,
    longitude: -101.00369,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57625',
  },
  {
    city: 'Faith',
    county_fips: 46105,
    county_fips_all: '46105|46093|46137',
    county: 'Perkins',
    county_names_all: 'Perkins|Meade|Ziebach',
    county_weights: '{"46105": 39.2, "46093": 32.91, "46137": 27.88}',
    density: 0.3,
    imprecise: false,
    latitude: 44.99662,
    longitude: -102.17571,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57626',
  },
  {
    city: 'Glencross',
    county_fips: 46041,
    county_fips_all: '46041',
    county: 'Dewey',
    county_names_all: 'Dewey',
    county_weights: '{"46041": 100}',
    density: 0,
    imprecise: false,
    latitude: 45.36358,
    longitude: -100.89192,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57630',
  },
  {
    city: 'Glenham',
    county_fips: 46129,
    county_fips_all: '46129|46021',
    county: 'Walworth',
    county_names_all: 'Walworth|Campbell',
    county_weights: '{"46129": 50.59, "46021": 49.41}',
    density: 1.1,
    imprecise: false,
    latitude: 45.58195,
    longitude: -100.28779,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57631',
  },
  {
    city: 'Herreid',
    county_fips: 46021,
    county_fips_all: '46021',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"46021": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 45.82924,
    longitude: -100.04927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57632',
  },
  {
    city: 'Isabel',
    county_fips: 46031,
    county_fips_all: '46031|46137|46041',
    county: 'Corson',
    county_names_all: 'Corson|Ziebach|Dewey',
    county_weights: '{"46031": 44.39, "46137": 34.43, "46041": 21.18}',
    density: 0.2,
    imprecise: false,
    latitude: 45.44584,
    longitude: -101.50046,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57633',
  },
  {
    city: 'Keldron',
    county_fips: 46031,
    county_fips_all: '46031',
    county: 'Corson',
    county_names_all: 'Corson',
    county_weights: '{"46031": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 45.75231,
    longitude: -101.87895,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57634',
  },
  {
    city: 'Lantry',
    county_fips: 46041,
    county_fips_all: '46041',
    county: 'Dewey',
    county_names_all: 'Dewey',
    county_weights: '{"46041": 100}',
    density: 2,
    imprecise: false,
    latitude: 45.02905,
    longitude: -101.45414,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57636',
  },
  {
    city: 'Lemmon',
    county_fips: 46105,
    county_fips_all: '46105|38001|38037|38085|46031',
    county: 'Perkins',
    county_names_all: 'Perkins|Adams|Grant|Sioux|Corson',
    county_weights:
      '{"46105": 60.42, "38001": 25.18, "38037": 5.1, "38085": 4.66, "46031": 4.64}',
    density: 0.7,
    imprecise: false,
    latitude: 45.86899,
    longitude: -102.20758,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57638',
  },
  {
    city: 'Little Eagle',
    county_fips: 46031,
    county_fips_all: '46031',
    county: 'Corson',
    county_names_all: 'Corson',
    county_weights: '{"46031": 100}',
    density: 56.6,
    imprecise: false,
    latitude: 45.679,
    longitude: -100.80324,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57639',
  },
  {
    city: 'Lodgepole',
    county_fips: 46105,
    county_fips_all: '46105',
    county: 'Perkins',
    county_names_all: 'Perkins',
    county_weights: '{"46105": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 45.7656,
    longitude: -102.70435,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57640',
  },
  {
    city: 'McIntosh',
    county_fips: 46031,
    county_fips_all: '46031|38085|38037',
    county: 'Corson',
    county_names_all: 'Corson|Sioux|Grant',
    county_weights: '{"46031": 62.47, "38085": 27.78, "38037": 9.75}',
    density: 0.2,
    imprecise: false,
    latitude: 45.89317,
    longitude: -101.30624,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57641',
  },
  {
    city: 'McLaughlin',
    county_fips: 46031,
    county_fips_all: '46031|38085',
    county: 'Corson',
    county_names_all: 'Corson|Sioux',
    county_weights: '{"46031": 97.17, "38085": 2.83}',
    density: 1.1,
    imprecise: false,
    latitude: 45.78609,
    longitude: -100.72458,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57642',
  },
  {
    city: 'Meadow',
    county_fips: 46105,
    county_fips_all: '46105|46031|46137',
    county: 'Perkins',
    county_names_all: 'Perkins|Corson|Ziebach',
    county_weights: '{"46105": 63.31, "46031": 20.74, "46137": 15.95}',
    density: 0.2,
    imprecise: false,
    latitude: 45.45155,
    longitude: -102.08224,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57644',
  },
  {
    city: 'Morristown',
    county_fips: 46031,
    county_fips_all: '46031|38037|38085',
    county: 'Corson',
    county_names_all: 'Corson|Grant|Sioux',
    county_weights: '{"46031": 51.85, "38037": 26.84, "38085": 21.31}',
    density: 0.2,
    imprecise: false,
    latitude: 45.9119,
    longitude: -101.71855,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57645',
  },
  {
    city: 'Mound City',
    county_fips: 46021,
    county_fips_all: '46021',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"46021": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 45.68753,
    longitude: -100.05395,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57646',
  },
  {
    city: 'Pollock',
    county_fips: 46021,
    county_fips_all: '46021|38029',
    county: 'Campbell',
    county_names_all: 'Campbell|Emmons',
    county_weights: '{"46021": 52.61, "38029": 47.39}',
    density: 0.8,
    imprecise: false,
    latitude: 45.92722,
    longitude: -100.31755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57648',
  },
  {
    city: 'Prairie City',
    county_fips: 46105,
    county_fips_all: '46105|46063',
    county: 'Perkins',
    county_names_all: 'Perkins|Harding',
    county_weights: '{"46105": 75.72, "46063": 24.28}',
    density: 0.2,
    imprecise: false,
    latitude: 45.48999,
    longitude: -102.86149,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57649',
  },
  {
    city: 'Ralph',
    county_fips: 46063,
    county_fips_all: '46063',
    county: 'Harding',
    county_names_all: 'Harding',
    county_weights: '{"46063": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 45.8346,
    longitude: -103.03033,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57650',
  },
  {
    city: 'Reva',
    county_fips: 46063,
    county_fips_all: '46063|46105',
    county: 'Harding',
    county_names_all: 'Harding|Perkins',
    county_weights: '{"46063": 84.92, "46105": 15.08}',
    density: 0.2,
    imprecise: false,
    latitude: 45.48394,
    longitude: -103.07746,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57651',
  },
  {
    city: 'Ridgeview',
    county_fips: 46041,
    county_fips_all: '46041',
    county: 'Dewey',
    county_names_all: 'Dewey',
    county_weights: '{"46041": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 45.13787,
    longitude: -100.68883,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57652',
  },
  {
    city: 'Timber Lake',
    county_fips: 46041,
    county_fips_all: '46041|46031',
    county: 'Dewey',
    county_names_all: 'Dewey|Corson',
    county_weights: '{"46041": 63.29, "46031": 36.71}',
    density: 1,
    imprecise: false,
    latitude: 45.42387,
    longitude: -101.10696,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57656',
  },
  {
    city: 'Trail City',
    county_fips: 46031,
    county_fips_all: '46031|46041',
    county: 'Corson',
    county_names_all: 'Corson|Dewey',
    county_weights: '{"46031": 77.87, "46041": 22.13}',
    density: 0.5,
    imprecise: false,
    latitude: 45.51599,
    longitude: -100.7776,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57657',
  },
  {
    city: 'Wakpala',
    county_fips: 46031,
    county_fips_all: '46031',
    county: 'Corson',
    county_names_all: 'Corson',
    county_weights: '{"46031": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 45.65744,
    longitude: -100.55835,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57658',
  },
  {
    city: 'Walker',
    county_fips: 46031,
    county_fips_all: '46031',
    county: 'Corson',
    county_names_all: 'Corson',
    county_weights: '{"46031": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 45.8958,
    longitude: -101.09808,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57659',
  },
  {
    city: 'Watauga',
    county_fips: 46031,
    county_fips_all: '46031|38085',
    county: 'Corson',
    county_names_all: 'Corson|Sioux',
    county_weights: '{"46031": 87.99, "38085": 12.01}',
    density: 0.2,
    imprecise: false,
    latitude: 45.83052,
    longitude: -101.53311,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57660',
  },
  {
    city: 'Whitehorse',
    county_fips: 46041,
    county_fips_all: '46041',
    county: 'Dewey',
    county_names_all: 'Dewey',
    county_weights: '{"46041": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 45.27005,
    longitude: -100.96433,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57661',
  },
  {
    city: 'Rapid City',
    county_fips: 46103,
    county_fips_all: '46103|46093',
    county: 'Pennington',
    county_names_all: 'Pennington|Meade',
    county_weights: '{"46103": 64.26, "46093": 35.74}',
    density: 338.6,
    imprecise: false,
    latitude: 44.1209,
    longitude: -103.20562,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 45795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57701',
  },
  {
    city: 'Rapid City',
    county_fips: 46103,
    county_fips_all: '46103|46093',
    county: 'Pennington',
    county_names_all: 'Pennington|Meade',
    county_weights: '{"46103": 94.34, "46093": 5.66}',
    density: 48.1,
    imprecise: false,
    latitude: 44.03085,
    longitude: -103.38433,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57702',
  },
  {
    city: 'Rapid City',
    county_fips: 46103,
    county_fips_all: '46103',
    county: 'Pennington',
    county_names_all: 'Pennington',
    county_weights: '{"46103": 100}',
    density: 53.6,
    imprecise: false,
    latitude: 44.00331,
    longitude: -103.04528,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57703',
  },
  {
    city: 'Ellsworth Afb',
    county_fips: 46093,
    county_fips_all: '46093|46103',
    county: 'Meade',
    county_names_all: 'Meade|Pennington',
    county_weights: '{"46093": 93.42, "46103": 6.58}',
    density: 175.4,
    imprecise: false,
    latitude: 44.1564,
    longitude: -103.09561,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57706',
  },
  {
    city: 'Allen',
    county_fips: 46007,
    county_fips_all: '46007|46071',
    county: 'Bennett',
    county_names_all: 'Bennett|Jackson',
    county_weights: '{"46007": 92.96, "46071": 7.04}',
    density: 2.7,
    imprecise: false,
    latitude: 43.32689,
    longitude: -101.91843,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57714',
  },
  {
    city: 'Batesland',
    county_fips: 46102,
    county_fips_all: '46102|46007',
    county: 'Oglala Lakota',
    county_names_all: 'Oglala Lakota|Bennett',
    county_weights: '{"46102": 92.26, "46007": 7.74}',
    density: 0.5,
    imprecise: false,
    latitude: 43.07753,
    longitude: -102.2179,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57716',
  },
  {
    city: 'Belle Fourche',
    county_fips: 46019,
    county_fips_all: '46019|56011|30011|46063|46081',
    county: 'Butte',
    county_names_all: 'Butte|Crook|Carter|Harding|Lawrence',
    county_weights:
      '{"46019": 65.59, "56011": 15.05, "30011": 10.15, "46063": 8.65, "46081": 0.56}',
    density: 2.5,
    imprecise: false,
    latitude: 44.96667,
    longitude: -103.92396,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57717',
  },
  {
    city: 'Black Hawk',
    county_fips: 46093,
    county_fips_all: '46093|46103',
    county: 'Meade',
    county_names_all: 'Meade|Pennington',
    county_weights: '{"46093": 98.69, "46103": 1.31}',
    density: 115.3,
    imprecise: false,
    latitude: 44.17925,
    longitude: -103.36801,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57718',
  },
  {
    city: 'Box Elder',
    county_fips: 46093,
    county_fips_all: '46093|46103',
    county: 'Meade',
    county_names_all: 'Meade|Pennington',
    county_weights: '{"46093": 76.57, "46103": 23.43}',
    density: 28.2,
    imprecise: false,
    latitude: 44.23059,
    longitude: -102.98312,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57719',
  },
  {
    city: 'Buffalo',
    county_fips: 46063,
    county_fips_all: '46063',
    county: 'Harding',
    county_names_all: 'Harding',
    county_weights: '{"46063": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.5497,
    longitude: -103.60655,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57720',
  },
  {
    city: 'Buffalo Gap',
    county_fips: 46102,
    county_fips_all: '46102|46033|46047',
    county: 'Oglala Lakota',
    county_names_all: 'Oglala Lakota|Custer|Fall River',
    county_weights: '{"46102": 54.46, "46033": 31.26, "46047": 14.28}',
    density: 0.1,
    imprecise: false,
    latitude: 43.45722,
    longitude: -102.98149,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57722',
  },
  {
    city: 'Camp Crook',
    county_fips: 46063,
    county_fips_all: '46063|30011',
    county: 'Harding',
    county_names_all: 'Harding|Carter',
    county_weights: '{"46063": 62.72, "30011": 37.28}',
    density: 0.2,
    imprecise: false,
    latitude: 45.66696,
    longitude: -104.06056,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57724',
  },
  {
    city: 'Caputa',
    county_fips: 46103,
    county_fips_all: '46103',
    county: 'Pennington',
    county_names_all: 'Pennington',
    county_weights: '{"46103": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 43.93723,
    longitude: -102.80324,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57725',
  },
  {
    city: 'Custer',
    county_fips: 46033,
    county_fips_all: '46033|46103',
    county: 'Custer',
    county_names_all: 'Custer|Pennington',
    county_weights: '{"46033": 91.64, "46103": 8.36}',
    density: 4.2,
    imprecise: false,
    latitude: 43.72561,
    longitude: -103.63733,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57730',
  },
  {
    city: 'Deadwood',
    county_fips: 46081,
    county_fips_all: '46081|46103',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Pennington',
    county_weights: '{"46081": 89.79, "46103": 10.21}',
    density: 5.3,
    imprecise: false,
    latitude: 44.23782,
    longitude: -103.64335,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57732',
  },
  {
    city: 'Edgemont',
    county_fips: 46047,
    county_fips_all: '46047|46033|31165',
    county: 'Fall River',
    county_names_all: 'Fall River|Custer|Sioux',
    county_weights: '{"46047": 77.35, "46033": 20.78, "31165": 1.87}',
    density: 0.7,
    imprecise: false,
    latitude: 43.29086,
    longitude: -103.85626,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57735',
  },
  {
    city: 'Enning',
    county_fips: 46093,
    county_fips_all: '46093',
    county: 'Meade',
    county_names_all: 'Meade',
    county_weights: '{"46093": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 44.55618,
    longitude: -102.52096,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57737',
  },
  {
    city: 'Fairburn',
    county_fips: 46033,
    county_fips_all: '46033',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"46033": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 43.66281,
    longitude: -103.13024,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57738',
  },
  {
    city: 'Fort Meade',
    county_fips: 46093,
    county_fips_all: '46093',
    county: 'Meade',
    county_names_all: 'Meade',
    county_weights: '{"46093": 100}',
    density: 331.2,
    imprecise: false,
    latitude: 44.41044,
    longitude: -103.47273,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57741',
  },
  {
    city: 'Hermosa',
    county_fips: 46033,
    county_fips_all: '46033|46103|46102',
    county: 'Custer',
    county_names_all: 'Custer|Pennington|Oglala Lakota',
    county_weights: '{"46033": 63.68, "46103": 21.53, "46102": 14.79}',
    density: 2,
    imprecise: false,
    latitude: 43.7773,
    longitude: -103.02415,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57744',
  },
  {
    city: 'Hill City',
    county_fips: 46103,
    county_fips_all: '46103',
    county: 'Pennington',
    county_names_all: 'Pennington',
    county_weights: '{"46103": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 44.01304,
    longitude: -103.78616,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57745',
  },
  {
    city: 'Hot Springs',
    county_fips: 46047,
    county_fips_all: '46047|46033',
    county: 'Fall River',
    county_names_all: 'Fall River|Custer',
    county_weights: '{"46047": 73.27, "46033": 26.73}',
    density: 4.4,
    imprecise: false,
    latitude: 43.37973,
    longitude: -103.5231,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57747',
  },
  {
    city: 'Howes',
    county_fips: 46093,
    county_fips_all: '46093|46137',
    county: 'Meade',
    county_names_all: 'Meade|Ziebach',
    county_weights: '{"46093": 55.59, "46137": 44.41}',
    density: 0.4,
    imprecise: false,
    latitude: 44.58484,
    longitude: -102.01082,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57748',
  },
  {
    city: 'Interior',
    county_fips: 46071,
    county_fips_all: '46071|46103',
    county: 'Jackson',
    county_names_all: 'Jackson|Pennington',
    county_weights: '{"46071": 97.99, "46103": 2.01}',
    density: 0.4,
    imprecise: false,
    latitude: 43.60109,
    longitude: -101.94858,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57750',
  },
  {
    city: 'Keystone',
    county_fips: 46103,
    county_fips_all: '46103|46033',
    county: 'Pennington',
    county_names_all: 'Pennington|Custer',
    county_weights: '{"46103": 66.74, "46033": 33.26}',
    density: 7.8,
    imprecise: false,
    latitude: 43.86767,
    longitude: -103.42346,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57751',
  },
  {
    city: 'Kyle',
    county_fips: 46102,
    county_fips_all: '46102|46071|46007',
    county: 'Oglala Lakota',
    county_names_all: 'Oglala Lakota|Jackson|Bennett',
    county_weights: '{"46102": 82.76, "46071": 13.95, "46007": 3.29}',
    density: 1.4,
    imprecise: false,
    latitude: 43.43593,
    longitude: -102.20738,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57752',
  },
  {
    city: 'Lead',
    county_fips: 46081,
    county_fips_all: '46081',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"46081": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 44.26193,
    longitude: -103.87478,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57754',
  },
  {
    city: 'Ludlow',
    county_fips: 46063,
    county_fips_all: '46063',
    county: 'Harding',
    county_names_all: 'Harding',
    county_weights: '{"46063": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.83763,
    longitude: -103.35784,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57755',
  },
  {
    city: 'Manderson',
    county_fips: 46102,
    county_fips_all: '46102',
    county: 'Oglala Lakota',
    county_names_all: 'Oglala Lakota',
    county_weights: '{"46102": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 43.23729,
    longitude: -102.47544,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57756',
  },
  {
    city: 'Mud Butte',
    county_fips: 46093,
    county_fips_all: '46093|46019|46105',
    county: 'Meade',
    county_names_all: 'Meade|Butte|Perkins',
    county_weights: '{"46093": 63.27, "46019": 18.88, "46105": 17.85}',
    density: 0,
    imprecise: false,
    latitude: 44.98737,
    longitude: -102.75985,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57758',
  },
  {
    city: 'Nemo',
    county_fips: 46081,
    county_fips_all: '46081',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"46081": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 44.2202,
    longitude: -103.55373,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57759',
  },
  {
    city: 'Newell',
    county_fips: 46019,
    county_fips_all: '46019|46063',
    county: 'Butte',
    county_names_all: 'Butte|Harding',
    county_weights: '{"46019": 98.21, "46063": 1.79}',
    density: 0.4,
    imprecise: false,
    latitude: 44.93063,
    longitude: -103.30329,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57760',
  },
  {
    city: 'New Underwood',
    county_fips: 46093,
    county_fips_all: '46093|46103',
    county: 'Meade',
    county_names_all: 'Meade|Pennington',
    county_weights: '{"46093": 66.89, "46103": 33.11}',
    density: 1,
    imprecise: false,
    latitude: 44.21858,
    longitude: -102.75943,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57761',
  },
  {
    city: 'Nisland',
    county_fips: 46019,
    county_fips_all: '46019',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"46019": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 44.75285,
    longitude: -103.60902,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57762',
  },
  {
    city: 'Oelrichs',
    county_fips: 46047,
    county_fips_all: '46047',
    county: 'Fall River',
    county_names_all: 'Fall River',
    county_weights: '{"46047": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 43.12,
    longitude: -103.24944,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57763',
  },
  {
    city: 'Oglala',
    county_fips: 46102,
    county_fips_all: '46102',
    county: 'Oglala Lakota',
    county_names_all: 'Oglala Lakota',
    county_weights: '{"46102": 100}',
    density: 2,
    imprecise: false,
    latitude: 43.23676,
    longitude: -102.75539,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57764',
  },
  {
    city: 'Oral',
    county_fips: 46047,
    county_fips_all: '46047',
    county: 'Fall River',
    county_names_all: 'Fall River',
    county_weights: '{"46047": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 43.35772,
    longitude: -103.18252,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57766',
  },
  {
    city: 'Owanka',
    county_fips: 46093,
    county_fips_all: '46093|46103',
    county: 'Meade',
    county_names_all: 'Meade|Pennington',
    county_weights: '{"46093": 50.68, "46103": 49.32}',
    density: 0.6,
    imprecise: false,
    latitude: 44.13841,
    longitude: -102.5721,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57767',
  },
  {
    city: 'Piedmont',
    county_fips: 46093,
    county_fips_all: '46093',
    county: 'Meade',
    county_names_all: 'Meade',
    county_weights: '{"46093": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 44.24326,
    longitude: -103.29704,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57769',
  },
  {
    city: 'Pine Ridge',
    county_fips: 46102,
    county_fips_all: '46102',
    county: 'Oglala Lakota',
    county_names_all: 'Oglala Lakota',
    county_weights: '{"46102": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 43.07579,
    longitude: -102.6258,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57770',
  },
  {
    city: 'Porcupine',
    county_fips: 46102,
    county_fips_all: '46102',
    county: 'Oglala Lakota',
    county_names_all: 'Oglala Lakota',
    county_weights: '{"46102": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 43.48182,
    longitude: -102.51903,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57772',
  },
  {
    city: 'Pringle',
    county_fips: 46033,
    county_fips_all: '46033',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"46033": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 43.59443,
    longitude: -103.59246,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57773',
  },
  {
    city: 'Quinn',
    county_fips: 46103,
    county_fips_all: '46103|46055|46071',
    county: 'Pennington',
    county_names_all: 'Pennington|Haakon|Jackson',
    county_weights: '{"46103": 45.53, "46055": 40.35, "46071": 14.13}',
    density: 0.3,
    imprecise: false,
    latitude: 44.08368,
    longitude: -102.00607,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57775',
  },
  {
    city: 'Redig',
    county_fips: 46063,
    county_fips_all: '46063',
    county: 'Harding',
    county_names_all: 'Harding',
    county_weights: '{"46063": 100}',
    density: 0,
    imprecise: false,
    latitude: 45.24878,
    longitude: -103.51704,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57776',
  },
  {
    city: 'Saint Onge',
    county_fips: 46081,
    county_fips_all: '46081|46019',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Butte',
    county_weights: '{"46081": 96.32, "46019": 3.68}',
    density: 3.3,
    imprecise: false,
    latitude: 44.56449,
    longitude: -103.75969,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57779',
  },
  {
    city: 'Scenic',
    county_fips: 46103,
    county_fips_all: '46103|46102',
    county: 'Pennington',
    county_names_all: 'Pennington|Oglala Lakota',
    county_weights: '{"46103": 91.11, "46102": 8.89}',
    density: 0.1,
    imprecise: false,
    latitude: 43.7773,
    longitude: -102.45844,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57780',
  },
  {
    city: 'Smithwick',
    county_fips: 46047,
    county_fips_all: '46047',
    county: 'Fall River',
    county_names_all: 'Fall River',
    county_weights: '{"46047": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 43.25182,
    longitude: -103.1844,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 58,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57782',
  },
  {
    city: 'Spearfish',
    county_fips: 46081,
    county_fips_all: '46081|46019',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Butte',
    county_weights: '{"46081": 96.26, "46019": 3.74}',
    density: 31.2,
    imprecise: false,
    latitude: 44.47106,
    longitude: -103.9219,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 17248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57783',
  },
  {
    city: 'Sturgis',
    county_fips: 46093,
    county_fips_all: '46093|46081',
    county: 'Meade',
    county_names_all: 'Meade|Lawrence',
    county_weights: '{"46093": 94.09, "46081": 5.91}',
    density: 7.4,
    imprecise: false,
    latitude: 44.41905,
    longitude: -103.21534,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57785',
  },
  {
    city: 'Union Center',
    county_fips: 46093,
    county_fips_all: '46093',
    county: 'Meade',
    county_names_all: 'Meade',
    county_weights: '{"46093": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 44.6643,
    longitude: -102.66097,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57787',
  },
  {
    city: 'Vale',
    county_fips: 46019,
    county_fips_all: '46019|46093',
    county: 'Butte',
    county_names_all: 'Butte|Meade',
    county_weights: '{"46019": 59.13, "46093": 40.87}',
    density: 1,
    imprecise: false,
    latitude: 44.61855,
    longitude: -103.2167,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57788',
  },
  {
    city: 'Wall',
    county_fips: 46103,
    county_fips_all: '46103|46071',
    county: 'Pennington',
    county_names_all: 'Pennington|Jackson',
    county_weights: '{"46103": 98.06, "46071": 1.94}',
    density: 0.6,
    imprecise: false,
    latitude: 44.10378,
    longitude: -102.20683,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57790',
  },
  {
    city: 'Wasta',
    county_fips: 46093,
    county_fips_all: '46093|46103',
    county: 'Meade',
    county_names_all: 'Meade|Pennington',
    county_weights: '{"46093": 70.73, "46103": 29.27}',
    density: 0.1,
    imprecise: false,
    latitude: 44.24388,
    longitude: -102.46514,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57791',
  },
  {
    city: 'White Owl',
    county_fips: 46093,
    county_fips_all: '46093',
    county: 'Meade',
    county_names_all: 'Meade',
    county_weights: '{"46093": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 44.59559,
    longitude: -102.36376,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57792',
  },
  {
    city: 'Whitewood',
    county_fips: 46081,
    county_fips_all: '46081|46093|46019',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Meade|Butte',
    county_weights: '{"46081": 54.19, "46093": 38.6, "46019": 7.21}',
    density: 5.5,
    imprecise: false,
    latitude: 44.51824,
    longitude: -103.581,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57793',
  },
  {
    city: 'Wounded Knee',
    county_fips: 46102,
    county_fips_all: '46102',
    county: 'Oglala Lakota',
    county_names_all: 'Oglala Lakota',
    county_weights: '{"46102": 100}',
    density: 9,
    imprecise: false,
    latitude: 43.12071,
    longitude: -102.40695,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57794',
  },
  {
    city: 'Abercrombie',
    county_fips: 38077,
    county_fips_all: '38077',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"38077": 100}',
    density: 63.3,
    imprecise: false,
    latitude: 46.44837,
    longitude: -96.74134,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58001',
  },
  {
    city: 'Absaraka',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 2,
    imprecise: false,
    latitude: 46.97562,
    longitude: -97.40785,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58002',
  },
  {
    city: 'Amenia',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 47.02713,
    longitude: -97.26212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58004',
  },
  {
    city: 'Argusville',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 47.05261,
    longitude: -96.951,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58005',
  },
  {
    city: 'Arthur',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 47.09682,
    longitude: -97.20359,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58006',
  },
  {
    city: 'Ayr',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 47.02519,
    longitude: -97.45724,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58007',
  },
  {
    city: 'Barney',
    county_fips: 38077,
    county_fips_all: '38077',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"38077": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 46.30816,
    longitude: -97.00237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58008',
  },
  {
    city: 'Blanchard',
    county_fips: 38097,
    county_fips_all: '38097',
    county: 'Traill',
    county_names_all: 'Traill',
    county_weights: '{"38097": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 47.32658,
    longitude: -97.24435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58009',
  },
  {
    city: 'Buffalo',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 46.92711,
    longitude: -97.54465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58011',
  },
  {
    city: 'Casselton',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 16.1,
    imprecise: false,
    latitude: 46.93639,
    longitude: -97.16113,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58012',
  },
  {
    city: 'Cayuga',
    county_fips: 38081,
    county_fips_all: '38081',
    county: 'Sargent',
    county_names_all: 'Sargent',
    county_weights: '{"38081": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 46.06037,
    longitude: -97.35877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58013',
  },
  {
    city: 'Christine',
    county_fips: 38077,
    county_fips_all: '38077',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"38077": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 46.59225,
    longitude: -96.81544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58015',
  },
  {
    city: 'Clifford',
    county_fips: 38097,
    county_fips_all: '38097|38091',
    county: 'Traill',
    county_names_all: 'Traill|Steele',
    county_weights: '{"38097": 54.6, "38091": 45.4}',
    density: 1,
    imprecise: false,
    latitude: 47.36609,
    longitude: -97.46293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58016',
  },
  {
    city: 'Cogswell',
    county_fips: 38081,
    county_fips_all: '38081',
    county: 'Sargent',
    county_names_all: 'Sargent',
    county_weights: '{"38081": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 46.04157,
    longitude: -97.84535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58017',
  },
  {
    city: 'Colfax',
    county_fips: 38077,
    county_fips_all: '38077',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"38077": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 46.43458,
    longitude: -96.8887,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58018',
  },
  {
    city: 'Davenport',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 46.73837,
    longitude: -97.08102,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58021',
  },
  {
    city: 'Enderlin',
    county_fips: 38073,
    county_fips_all: '38073|38017|38003',
    county: 'Ransom',
    county_names_all: 'Ransom|Cass|Barnes',
    county_weights: '{"38073": 44.5, "38017": 41.51, "38003": 13.99}',
    density: 3.2,
    imprecise: false,
    latitude: 46.63217,
    longitude: -97.61816,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58027',
  },
  {
    city: 'Erie',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 47.11726,
    longitude: -97.39001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 88,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58029',
  },
  {
    city: 'Fairmount',
    county_fips: 38077,
    county_fips_all: '38077|27167',
    county: 'Richland',
    county_names_all: 'Richland|Wilkin',
    county_weights: '{"38077": 98.67, "27167": 1.33}',
    density: 1.7,
    imprecise: false,
    latitude: 46.03035,
    longitude: -96.66818,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58030',
  },
  {
    city: 'Fingal',
    county_fips: 38017,
    county_fips_all: '38017|38003',
    county: 'Cass',
    county_names_all: 'Cass|Barnes',
    county_weights: '{"38017": 53.78, "38003": 46.22}',
    density: 0.8,
    imprecise: false,
    latitude: 46.76222,
    longitude: -97.6686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58031',
  },
  {
    city: 'Forman',
    county_fips: 38081,
    county_fips_all: '38081',
    county: 'Sargent',
    county_names_all: 'Sargent',
    county_weights: '{"38081": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 46.07071,
    longitude: -97.64413,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58032',
  },
  {
    city: 'Fort Ransom',
    county_fips: 38073,
    county_fips_all: '38073',
    county: 'Ransom',
    county_names_all: 'Ransom',
    county_weights: '{"38073": 100}',
    density: 1,
    imprecise: false,
    latitude: 46.44019,
    longitude: -97.92628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58033',
  },
  {
    city: 'Galesburg',
    county_fips: 38097,
    county_fips_all: '38097|38017|38091',
    county: 'Traill',
    county_names_all: 'Traill|Cass|Steele',
    county_weights: '{"38097": 42.33, "38017": 33.66, "38091": 24.01}',
    density: 0.9,
    imprecise: false,
    latitude: 47.25599,
    longitude: -97.41589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58035',
  },
  {
    city: 'Gardner',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 47.15463,
    longitude: -96.96318,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58036',
  },
  {
    city: 'Grandin',
    county_fips: 38097,
    county_fips_all: '38097|38017',
    county: 'Traill',
    county_names_all: 'Traill|Cass',
    county_weights: '{"38097": 59.94, "38017": 40.06}',
    density: 0.8,
    imprecise: false,
    latitude: 47.24505,
    longitude: -96.99484,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58038',
  },
  {
    city: 'Gwinner',
    county_fips: 38081,
    county_fips_all: '38081',
    county: 'Sargent',
    county_names_all: 'Sargent',
    county_weights: '{"38081": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 46.21618,
    longitude: -97.75204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58040',
  },
  {
    city: 'Hankinson',
    county_fips: 38077,
    county_fips_all: '38077|46109',
    county: 'Richland',
    county_names_all: 'Richland|Roberts',
    county_weights: '{"38077": 99.24, "46109": 0.76}',
    density: 2.7,
    imprecise: false,
    latitude: 46.04775,
    longitude: -96.91006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58041',
  },
  {
    city: 'Harwood',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 12,
    imprecise: false,
    latitude: 46.96952,
    longitude: -96.95719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58042',
  },
  {
    city: 'Havana',
    county_fips: 38081,
    county_fips_all: '38081|46091',
    county: 'Sargent',
    county_names_all: 'Sargent|Marshall',
    county_weights: '{"38081": 95.17, "46091": 4.83}',
    density: 1.1,
    imprecise: false,
    latitude: 45.97356,
    longitude: -97.53205,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58043',
  },
  {
    city: 'Hillsboro',
    county_fips: 38097,
    county_fips_all: '38097',
    county: 'Traill',
    county_names_all: 'Traill',
    county_weights: '{"38097": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 47.38241,
    longitude: -97.02686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58045',
  },
  {
    city: 'Hope',
    county_fips: 38091,
    county_fips_all: '38091|38003|38017',
    county: 'Steele',
    county_names_all: 'Steele|Barnes|Cass',
    county_weights: '{"38091": 85.35, "38003": 12.99, "38017": 1.66}',
    density: 1,
    imprecise: false,
    latitude: 47.32203,
    longitude: -97.72747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58046',
  },
  {
    city: 'Horace',
    county_fips: 38017,
    county_fips_all: '38017|38077',
    county: 'Cass',
    county_names_all: 'Cass|Richland',
    county_weights: '{"38017": 97.37, "38077": 2.63}',
    density: 31,
    imprecise: false,
    latitude: 46.7159,
    longitude: -96.87946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58047',
  },
  {
    city: 'Hunter',
    county_fips: 38017,
    county_fips_all: '38017|38097',
    county: 'Cass',
    county_names_all: 'Cass|Traill',
    county_weights: '{"38017": 76.12, "38097": 23.88}',
    density: 1.7,
    imprecise: false,
    latitude: 47.19882,
    longitude: -97.22742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58048',
  },
  {
    city: 'Kathryn',
    county_fips: 38003,
    county_fips_all: '38003|38073|38045',
    county: 'Barnes',
    county_names_all: 'Barnes|Ransom|LaMoure',
    county_weights: '{"38003": 69.78, "38073": 22.68, "38045": 7.54}',
    density: 0.7,
    imprecise: false,
    latitude: 46.66291,
    longitude: -98.00054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58049',
  },
  {
    city: 'Kindred',
    county_fips: 38017,
    county_fips_all: '38017|38077',
    county: 'Cass',
    county_names_all: 'Cass|Richland',
    county_weights: '{"38017": 59.32, "38077": 40.68}',
    density: 6.9,
    imprecise: false,
    latitude: 46.63952,
    longitude: -97.0302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58051',
  },
  {
    city: 'Leonard',
    county_fips: 38017,
    county_fips_all: '38017|38077|38073',
    county: 'Cass',
    county_names_all: 'Cass|Richland|Ransom',
    county_weights: '{"38017": 55.98, "38077": 32.91, "38073": 11.11}',
    density: 1.3,
    imprecise: false,
    latitude: 46.63552,
    longitude: -97.28011,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58052',
  },
  {
    city: 'Lidgerwood',
    county_fips: 38077,
    county_fips_all: '38077|38081|46109|46091',
    county: 'Richland',
    county_names_all: 'Richland|Sargent|Roberts|Marshall',
    county_weights:
      '{"38077": 71.39, "38081": 20.86, "46109": 5.8, "46091": 1.95}',
    density: 2.3,
    imprecise: false,
    latitude: 46.05058,
    longitude: -97.18007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58053',
  },
  {
    city: 'Lisbon',
    county_fips: 38073,
    county_fips_all: '38073',
    county: 'Ransom',
    county_names_all: 'Ransom',
    county_weights: '{"38073": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 46.42622,
    longitude: -97.66845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58054',
  },
  {
    city: 'Luverne',
    county_fips: 38003,
    county_fips_all: '38003|38091|38039',
    county: 'Barnes',
    county_names_all: 'Barnes|Steele|Griggs',
    county_weights: '{"38003": 43.57, "38091": 43.43, "38039": 13.0}',
    density: 1,
    imprecise: false,
    latitude: 47.23868,
    longitude: -97.93621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58056',
  },
  {
    city: 'Mcleod',
    county_fips: 38077,
    county_fips_all: '38077|38073',
    county: 'Richland',
    county_names_all: 'Richland|Ransom',
    county_weights: '{"38077": 58.57, "38073": 41.43}',
    density: 1,
    imprecise: false,
    latitude: 46.42548,
    longitude: -97.26747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58057',
  },
  {
    city: 'Mantador',
    county_fips: 38077,
    county_fips_all: '38077',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"38077": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 46.1806,
    longitude: -96.97159,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58058',
  },
  {
    city: 'Mapleton',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 46.83825,
    longitude: -97.11812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58059',
  },
  {
    city: 'Milnor',
    county_fips: 38081,
    county_fips_all: '38081|38073|38077',
    county: 'Sargent',
    county_names_all: 'Sargent|Ransom|Richland',
    county_weights: '{"38081": 58.47, "38073": 41.16, "38077": 0.37}',
    density: 1.8,
    imprecise: false,
    latitude: 46.26745,
    longitude: -97.43423,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58060',
  },
  {
    city: 'Mooreton',
    county_fips: 38077,
    county_fips_all: '38077',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"38077": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 46.27721,
    longitude: -96.89564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58061',
  },
  {
    city: 'Nome',
    county_fips: 38003,
    county_fips_all: '38003|38073',
    county: 'Barnes',
    county_names_all: 'Barnes|Ransom',
    county_weights: '{"38003": 58.86, "38073": 41.14}',
    density: 0.8,
    imprecise: false,
    latitude: 46.64361,
    longitude: -97.82937,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58062',
  },
  {
    city: 'Oriska',
    county_fips: 38003,
    county_fips_all: '38003',
    county: 'Barnes',
    county_names_all: 'Barnes',
    county_weights: '{"38003": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 46.96773,
    longitude: -97.80471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58063',
  },
  {
    city: 'Page',
    county_fips: 38017,
    county_fips_all: '38017|38003|38091',
    county: 'Cass',
    county_names_all: 'Cass|Barnes|Steele',
    county_weights: '{"38017": 74.42, "38003": 23.88, "38091": 1.7}',
    density: 0.7,
    imprecise: false,
    latitude: 47.15036,
    longitude: -97.62761,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58064',
  },
  {
    city: 'Pillsbury',
    county_fips: 38003,
    county_fips_all: '38003',
    county: 'Barnes',
    county_names_all: 'Barnes',
    county_weights: '{"38003": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 47.20035,
    longitude: -97.76612,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58065',
  },
  {
    city: 'Rutland',
    county_fips: 38081,
    county_fips_all: '38081',
    county: 'Sargent',
    county_names_all: 'Sargent',
    county_weights: '{"38081": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 46.06826,
    longitude: -97.48906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58067',
  },
  {
    city: 'Sheldon',
    county_fips: 38073,
    county_fips_all: '38073|38017',
    county: 'Ransom',
    county_names_all: 'Ransom|Cass',
    county_weights: '{"38073": 98.22, "38017": 1.78}',
    density: 0.5,
    imprecise: false,
    latitude: 46.54619,
    longitude: -97.40896,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58068',
  },
  {
    city: 'Stirum',
    county_fips: 38081,
    county_fips_all: '38081|38073',
    county: 'Sargent',
    county_names_all: 'Sargent|Ransom',
    county_weights: '{"38081": 95.56, "38073": 4.44}',
    density: 0.9,
    imprecise: false,
    latitude: 46.24102,
    longitude: -97.83194,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58069',
  },
  {
    city: 'Tower City',
    county_fips: 38017,
    county_fips_all: '38017|38003',
    county: 'Cass',
    county_names_all: 'Cass|Barnes',
    county_weights: '{"38017": 56.03, "38003": 43.97}',
    density: 1.7,
    imprecise: false,
    latitude: 46.9436,
    longitude: -97.68278,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58071',
  },
  {
    city: 'Valley City',
    county_fips: 38003,
    county_fips_all: '38003',
    county: 'Barnes',
    county_names_all: 'Barnes',
    county_weights: '{"38003": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 46.92731,
    longitude: -98.00791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58072',
  },
  {
    city: 'Wahpeton',
    county_fips: 38077,
    county_fips_all: '38077',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"38077": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 46.21807,
    longitude: -96.87603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58074',
  },
  {
    city: 'Wahpeton',
    county_fips: 38077,
    county_fips_all: '38077',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"38077": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 46.27426,
    longitude: -96.72211,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58075',
  },
  {
    city: 'Walcott',
    county_fips: 38077,
    county_fips_all: '38077',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"38077": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 46.52457,
    longitude: -96.97593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58077',
  },
  {
    city: 'West Fargo',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 393.9,
    imprecise: false,
    latitude: 46.86276,
    longitude: -96.93125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58078',
  },
  {
    city: 'Wheatland',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 46.86816,
    longitude: -97.34827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58079',
  },
  {
    city: 'Wyndmere',
    county_fips: 38077,
    county_fips_all: '38077|38081',
    county: 'Richland',
    county_names_all: 'Richland|Sargent',
    county_weights: '{"38077": 99.72, "38081": 0.28}',
    density: 1.9,
    imprecise: false,
    latitude: 46.31392,
    longitude: -97.14378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58081',
  },
  {
    city: 'Fargo',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 401.7,
    imprecise: false,
    latitude: 46.9207,
    longitude: -96.83175,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58102',
  },
  {
    city: 'Fargo',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 1644.7,
    imprecise: false,
    latitude: 46.85639,
    longitude: -96.82234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58103',
  },
  {
    city: 'Fargo',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 676.8,
    imprecise: false,
    latitude: 46.79371,
    longitude: -96.83838,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58104',
  },
  {
    city: 'Fargo',
    county_fips: 38017,
    county_fips_all: '38017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"38017": 100}',
    density: 4591.6,
    imprecise: false,
    latitude: 46.89586,
    longitude: -96.80363,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58105',
  },
  {
    city: 'Grand Forks',
    county_fips: 38035,
    county_fips_all: '38035',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks',
    county_weights: '{"38035": 100}',
    density: 236.9,
    imprecise: false,
    latitude: 47.86938,
    longitude: -97.14013,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58201',
  },
  {
    city: 'Grand Forks',
    county_fips: 38035,
    county_fips_all: '38035',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks',
    county_weights: '{"38035": 100}',
    density: 92.6,
    imprecise: false,
    latitude: 47.97181,
    longitude: -97.15425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58203',
  },
  {
    city: 'Grand Forks Afb',
    county_fips: 38035,
    county_fips_all: '38035',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks',
    county_weights: '{"38035": 100}',
    density: 581,
    imprecise: false,
    latitude: 47.96046,
    longitude: -97.37079,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58204',
  },
  {
    city: 'Adams',
    county_fips: 38099,
    county_fips_all: '38099',
    county: 'Walsh',
    county_names_all: 'Walsh',
    county_weights: '{"38099": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 48.4081,
    longitude: -98.11446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58210',
  },
  {
    city: 'Aneta',
    county_fips: 38063,
    county_fips_all: '38063|38039|38035|38091',
    county: 'Nelson',
    county_names_all: 'Nelson|Griggs|Grand Forks|Steele',
    county_weights:
      '{"38063": 47.33, "38039": 34.0, "38035": 12.32, "38091": 6.35}',
    density: 0.6,
    imprecise: false,
    latitude: 47.6987,
    longitude: -97.99541,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58212',
  },
  {
    city: 'Arvilla',
    county_fips: 38035,
    county_fips_all: '38035',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks',
    county_weights: '{"38035": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 47.92694,
    longitude: -97.49747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58214',
  },
  {
    city: 'Bathgate',
    county_fips: 38067,
    county_fips_all: '38067',
    county: 'Pembina',
    county_names_all: 'Pembina',
    county_weights: '{"38067": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 48.87937,
    longitude: -97.4429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58216',
  },
  {
    city: 'Buxton',
    county_fips: 38097,
    county_fips_all: '38097',
    county: 'Traill',
    county_names_all: 'Traill',
    county_weights: '{"38097": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 47.59689,
    longitude: -97.05412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58218',
  },
  {
    city: 'Caledonia',
    county_fips: 38097,
    county_fips_all: '38097',
    county: 'Traill',
    county_names_all: 'Traill',
    county_weights: '{"38097": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 47.47606,
    longitude: -96.87831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58219',
  },
  {
    city: 'Cavalier',
    county_fips: 38067,
    county_fips_all: '38067|38019',
    county: 'Pembina',
    county_names_all: 'Pembina|Cavalier',
    county_weights: '{"38067": 91.8, "38019": 8.2}',
    density: 5,
    imprecise: false,
    latitude: 48.79446,
    longitude: -97.73789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58220',
  },
  {
    city: 'Crystal',
    county_fips: 38067,
    county_fips_all: '38067',
    county: 'Pembina',
    county_names_all: 'Pembina',
    county_weights: '{"38067": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 48.61853,
    longitude: -97.68221,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58222',
  },
  {
    city: 'Cummings',
    county_fips: 38097,
    county_fips_all: '38097',
    county: 'Traill',
    county_names_all: 'Traill',
    county_weights: '{"38097": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 47.51384,
    longitude: -97.02573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58223',
  },
  {
    city: 'Dahlen',
    county_fips: 38063,
    county_fips_all: '38063',
    county: 'Nelson',
    county_names_all: 'Nelson',
    county_weights: '{"38063": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 48.16777,
    longitude: -97.94307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58224',
  },
  {
    city: 'Drayton',
    county_fips: 38067,
    county_fips_all: '38067|38099|27069',
    county: 'Pembina',
    county_names_all: 'Pembina|Walsh|Kittson',
    county_weights: '{"38067": 65.71, "38099": 22.91, "27069": 11.38}',
    density: 1.7,
    imprecise: false,
    latitude: 48.61208,
    longitude: -97.21753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58225',
  },
  {
    city: 'Edinburg',
    county_fips: 38099,
    county_fips_all: '38099|38067|38019',
    county: 'Walsh',
    county_names_all: 'Walsh|Pembina|Cavalier',
    county_weights: '{"38099": 49.25, "38067": 39.53, "38019": 11.23}',
    density: 1.6,
    imprecise: false,
    latitude: 48.55247,
    longitude: -97.90549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58227',
  },
  {
    city: 'Emerado',
    county_fips: 38035,
    county_fips_all: '38035',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks',
    county_weights: '{"38035": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 47.87394,
    longitude: -97.34278,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58228',
  },
  {
    city: 'Fairdale',
    county_fips: 38099,
    county_fips_all: '38099|38019|38071',
    county: 'Walsh',
    county_names_all: 'Walsh|Cavalier|Ramsey',
    county_weights: '{"38099": 60.65, "38019": 32.92, "38071": 6.43}',
    density: 0.4,
    imprecise: false,
    latitude: 48.5182,
    longitude: -98.25087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58229',
  },
  {
    city: 'Finley',
    county_fips: 38091,
    county_fips_all: '38091',
    county: 'Steele',
    county_names_all: 'Steele',
    county_weights: '{"38091": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 47.49097,
    longitude: -97.82622,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58230',
  },
  {
    city: 'Fordville',
    county_fips: 38099,
    county_fips_all: '38099|38035',
    county: 'Walsh',
    county_names_all: 'Walsh|Grand Forks',
    county_weights: '{"38099": 59.82, "38035": 40.18}',
    density: 1.5,
    imprecise: false,
    latitude: 48.20208,
    longitude: -97.82544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58231',
  },
  {
    city: 'Forest River',
    county_fips: 38099,
    county_fips_all: '38099|38035',
    county: 'Walsh',
    county_names_all: 'Walsh|Grand Forks',
    county_weights: '{"38099": 61.6, "38035": 38.4}',
    density: 1,
    imprecise: false,
    latitude: 48.20253,
    longitude: -97.54982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58233',
  },
  {
    city: 'Gilby',
    county_fips: 38035,
    county_fips_all: '38035',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks',
    county_weights: '{"38035": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 48.09007,
    longitude: -97.48307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58235',
  },
  {
    city: 'Glasston',
    county_fips: 38067,
    county_fips_all: '38067',
    county: 'Pembina',
    county_names_all: 'Pembina',
    county_weights: '{"38067": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 48.71848,
    longitude: -97.50479,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58236',
  },
  {
    city: 'Grafton',
    county_fips: 38099,
    county_fips_all: '38099',
    county: 'Walsh',
    county_names_all: 'Walsh',
    county_weights: '{"38099": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 48.41522,
    longitude: -97.40086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58237',
  },
  {
    city: 'Hamilton',
    county_fips: 38067,
    county_fips_all: '38067',
    county: 'Pembina',
    county_names_all: 'Pembina',
    county_weights: '{"38067": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 48.77953,
    longitude: -97.39791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58238',
  },
  {
    city: 'Hannah',
    county_fips: 38019,
    county_fips_all: '38019',
    county: 'Cavalier',
    county_names_all: 'Cavalier',
    county_weights: '{"38019": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.93842,
    longitude: -98.70877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58239',
  },
  {
    city: 'Hatton',
    county_fips: 38091,
    county_fips_all: '38091|38097|38035',
    county: 'Steele',
    county_names_all: 'Steele|Traill|Grand Forks',
    county_weights: '{"38091": 47.77, "38097": 33.02, "38035": 19.22}',
    density: 2.7,
    imprecise: false,
    latitude: 47.63491,
    longitude: -97.47675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58240',
  },
  {
    city: 'Hensel',
    county_fips: 38067,
    county_fips_all: '38067',
    county: 'Pembina',
    county_names_all: 'Pembina',
    county_weights: '{"38067": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 48.70442,
    longitude: -97.69772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58241',
  },
  {
    city: 'Hoople',
    county_fips: 38099,
    county_fips_all: '38099|38067',
    county: 'Walsh',
    county_names_all: 'Walsh|Pembina',
    county_weights: '{"38099": 79.48, "38067": 20.52}',
    density: 2.3,
    imprecise: false,
    latitude: 48.51423,
    longitude: -97.67956,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58243',
  },
  {
    city: 'Inkster',
    county_fips: 38035,
    county_fips_all: '38035',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks',
    county_weights: '{"38035": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 48.11035,
    longitude: -97.65752,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58244',
  },
  {
    city: 'Langdon',
    county_fips: 38019,
    county_fips_all: '38019',
    county: 'Cavalier',
    county_names_all: 'Cavalier',
    county_weights: '{"38019": 100}',
    density: 2,
    imprecise: false,
    latitude: 48.82113,
    longitude: -98.32514,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58249',
  },
  {
    city: 'Lankin',
    county_fips: 38099,
    county_fips_all: '38099',
    county: 'Walsh',
    county_names_all: 'Walsh',
    county_weights: '{"38099": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 48.27496,
    longitude: -98.02897,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58250',
  },
  {
    city: 'Larimore',
    county_fips: 38035,
    county_fips_all: '38035',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks',
    county_weights: '{"38035": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 47.94945,
    longitude: -97.6906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58251',
  },
  {
    city: 'Mcville',
    county_fips: 38063,
    county_fips_all: '38063',
    county: 'Nelson',
    county_names_all: 'Nelson',
    county_weights: '{"38063": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 47.77111,
    longitude: -98.14748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58254',
  },
  {
    city: 'Maida',
    county_fips: 38019,
    county_fips_all: '38019',
    county: 'Cavalier',
    county_names_all: 'Cavalier',
    county_weights: '{"38019": 100}',
    density: 0,
    imprecise: false,
    latitude: 48.99683,
    longitude: -98.35392,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58255',
  },
  {
    city: 'Manvel',
    county_fips: 38035,
    county_fips_all: '38035',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks',
    county_weights: '{"38035": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 48.08739,
    longitude: -97.20203,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58256',
  },
  {
    city: 'Mayville',
    county_fips: 38097,
    county_fips_all: '38097',
    county: 'Traill',
    county_names_all: 'Traill',
    county_weights: '{"38097": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 47.49033,
    longitude: -97.28505,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58257',
  },
  {
    city: 'Mekinock',
    county_fips: 38035,
    county_fips_all: '38035',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks',
    county_weights: '{"38035": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 48.01142,
    longitude: -97.33984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58258',
  },
  {
    city: 'Michigan',
    county_fips: 38063,
    county_fips_all: '38063',
    county: 'Nelson',
    county_names_all: 'Nelson',
    county_weights: '{"38063": 100}',
    density: 1,
    imprecise: false,
    latitude: 48.02053,
    longitude: -98.12168,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58259',
  },
  {
    city: 'Milton',
    county_fips: 38019,
    county_fips_all: '38019|38099',
    county: 'Cavalier',
    county_names_all: 'Cavalier|Walsh',
    county_weights: '{"38019": 98.32, "38099": 1.68}',
    density: 0.8,
    imprecise: false,
    latitude: 48.63254,
    longitude: -98.04709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58260',
  },
  {
    city: 'Minto',
    county_fips: 38099,
    county_fips_all: '38099|38035',
    county: 'Walsh',
    county_names_all: 'Walsh|Grand Forks',
    county_weights: '{"38099": 63.94, "38035": 36.06}',
    density: 3.3,
    imprecise: false,
    latitude: 48.22385,
    longitude: -97.31663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58261',
  },
  {
    city: 'Mountain',
    county_fips: 38067,
    county_fips_all: '38067',
    county: 'Pembina',
    county_names_all: 'Pembina',
    county_weights: '{"38067": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 48.681,
    longitude: -97.87759,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58262',
  },
  {
    city: 'Neche',
    county_fips: 38067,
    county_fips_all: '38067',
    county: 'Pembina',
    county_names_all: 'Pembina',
    county_weights: '{"38067": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 48.95321,
    longitude: -97.5959,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58265',
  },
  {
    city: 'Niagara',
    county_fips: 38035,
    county_fips_all: '38035|38063',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks|Nelson',
    county_weights: '{"38035": 71.88, "38063": 28.12}',
    density: 0.2,
    imprecise: false,
    latitude: 48.00127,
    longitude: -97.84967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58266',
  },
  {
    city: 'Northwood',
    county_fips: 38035,
    county_fips_all: '38035|38091',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks|Steele',
    county_weights: '{"38035": 96.31, "38091": 3.69}',
    density: 2.6,
    imprecise: false,
    latitude: 47.75614,
    longitude: -97.62651,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58267',
  },
  {
    city: 'Osnabrock',
    county_fips: 38019,
    county_fips_all: '38019',
    county: 'Cavalier',
    county_names_all: 'Cavalier',
    county_weights: '{"38019": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 48.70158,
    longitude: -98.15518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58269',
  },
  {
    city: 'Park River',
    county_fips: 38099,
    county_fips_all: '38099',
    county: 'Walsh',
    county_names_all: 'Walsh',
    county_weights: '{"38099": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 48.39336,
    longitude: -97.78848,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58270',
  },
  {
    city: 'Pembina',
    county_fips: 38067,
    county_fips_all: '38067',
    county: 'Pembina',
    county_names_all: 'Pembina',
    county_weights: '{"38067": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 48.90905,
    longitude: -97.28932,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58271',
  },
  {
    city: 'Petersburg',
    county_fips: 38063,
    county_fips_all: '38063',
    county: 'Nelson',
    county_names_all: 'Nelson',
    county_weights: '{"38063": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 48.00868,
    longitude: -97.9854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58272',
  },
  {
    city: 'Pisek',
    county_fips: 38099,
    county_fips_all: '38099',
    county: 'Walsh',
    county_names_all: 'Walsh',
    county_weights: '{"38099": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 48.29747,
    longitude: -97.66275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58273',
  },
  {
    city: 'Portland',
    county_fips: 38091,
    county_fips_all: '38091|38097',
    county: 'Steele',
    county_names_all: 'Steele|Traill',
    county_weights: '{"38091": 54.45, "38097": 45.55}',
    density: 2.7,
    imprecise: false,
    latitude: 47.49158,
    longitude: -97.48989,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58274',
  },
  {
    city: 'Reynolds',
    county_fips: 38035,
    county_fips_all: '38035|38097',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks|Traill',
    county_weights: '{"38035": 70.48, "38097": 29.52}',
    density: 2.4,
    imprecise: false,
    latitude: 47.68956,
    longitude: -97.10609,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58275',
  },
  {
    city: 'Saint Thomas',
    county_fips: 38067,
    county_fips_all: '38067',
    county: 'Pembina',
    county_names_all: 'Pembina',
    county_weights: '{"38067": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 48.62239,
    longitude: -97.45675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58276',
  },
  {
    city: 'Sharon',
    county_fips: 38091,
    county_fips_all: '38091',
    county: 'Steele',
    county_names_all: 'Steele',
    county_weights: '{"38091": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 47.61403,
    longitude: -97.83176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58277',
  },
  {
    city: 'Thompson',
    county_fips: 38035,
    county_fips_all: '38035',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks',
    county_weights: '{"38035": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 47.77761,
    longitude: -97.13084,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58278',
  },
  {
    city: 'Wales',
    county_fips: 38019,
    county_fips_all: '38019',
    county: 'Cavalier',
    county_names_all: 'Cavalier',
    county_weights: '{"38019": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.85941,
    longitude: -98.61086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58281',
  },
  {
    city: 'Walhalla',
    county_fips: 38067,
    county_fips_all: '38067|38019',
    county: 'Pembina',
    county_names_all: 'Pembina|Cavalier',
    county_weights: '{"38067": 55.81, "38019": 44.19}',
    density: 2.3,
    imprecise: false,
    latitude: 48.90897,
    longitude: -97.93252,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58282',
  },
  {
    city: 'Devils Lake',
    county_fips: 38071,
    county_fips_all: '38071|38005',
    county: 'Ramsey',
    county_names_all: 'Ramsey|Benson',
    county_weights: '{"38071": 92.56, "38005": 7.44}',
    density: 14.2,
    imprecise: false,
    latitude: 48.13015,
    longitude: -98.88798,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58301',
  },
  {
    city: 'Agate',
    county_fips: 38079,
    county_fips_all: '38079|38095',
    county: 'Rolette',
    county_names_all: 'Rolette|Towner',
    county_weights: '{"38079": 93.05, "38095": 6.95}',
    density: 0.5,
    imprecise: false,
    latitude: 48.57485,
    longitude: -99.5307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58310',
  },
  {
    city: 'Alsen',
    county_fips: 38019,
    county_fips_all: '38019',
    county: 'Cavalier',
    county_names_all: 'Cavalier',
    county_weights: '{"38019": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.65111,
    longitude: -98.57312,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58311',
  },
  {
    city: 'Balta',
    county_fips: 38069,
    county_fips_all: '38069',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"38069": 100}',
    density: 83.9,
    imprecise: false,
    latitude: 48.16615,
    longitude: -100.03685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58313',
  },
  {
    city: 'Belcourt',
    county_fips: 38079,
    county_fips_all: '38079',
    county: 'Rolette',
    county_names_all: 'Rolette',
    county_weights: '{"38079": 100}',
    density: 22.6,
    imprecise: false,
    latitude: 48.83532,
    longitude: -99.78207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58316',
  },
  {
    city: 'Bisbee',
    county_fips: 38095,
    county_fips_all: '38095|38079',
    county: 'Towner',
    county_names_all: 'Towner|Rolette',
    county_weights: '{"38095": 95.21, "38079": 4.79}',
    density: 0.5,
    imprecise: false,
    latitude: 48.62576,
    longitude: -99.38679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58317',
  },
  {
    city: 'Bottineau',
    county_fips: 38009,
    county_fips_all: '38009',
    county: 'Bottineau',
    county_names_all: 'Bottineau',
    county_weights: '{"38009": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 48.85121,
    longitude: -100.40303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58318',
  },
  {
    city: 'Brocket',
    county_fips: 38071,
    county_fips_all: '38071|38063|38099',
    county: 'Ramsey',
    county_names_all: 'Ramsey|Nelson|Walsh',
    county_weights: '{"38071": 45.59, "38063": 37.9, "38099": 16.51}',
    density: 0.4,
    imprecise: false,
    latitude: 48.2025,
    longitude: -98.32707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58321',
  },
  {
    city: 'Calvin',
    county_fips: 38019,
    county_fips_all: '38019|38095',
    county: 'Cavalier',
    county_names_all: 'Cavalier|Towner',
    county_weights: '{"38019": 81.58, "38095": 18.42}',
    density: 0.4,
    imprecise: false,
    latitude: 48.84252,
    longitude: -98.91923,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58323',
  },
  {
    city: 'Cando',
    county_fips: 38095,
    county_fips_all: '38095|38005',
    county: 'Towner',
    county_names_all: 'Towner|Benson',
    county_weights: '{"38095": 99.1, "38005": 0.9}',
    density: 2.1,
    imprecise: false,
    latitude: 48.48213,
    longitude: -99.21931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58324',
  },
  {
    city: 'Churchs Ferry',
    county_fips: 38071,
    county_fips_all: '38071|38005',
    county: 'Ramsey',
    county_names_all: 'Ramsey|Benson',
    county_weights: '{"38071": 70.28, "38005": 29.72}',
    density: 0.4,
    imprecise: false,
    latitude: 48.28613,
    longitude: -99.15569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58325',
  },
  {
    city: 'Crary',
    county_fips: 38071,
    county_fips_all: '38071',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"38071": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 48.10137,
    longitude: -98.5731,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58327',
  },
  {
    city: 'Dunseith',
    county_fips: 38079,
    county_fips_all: '38079|38009',
    county: 'Rolette',
    county_names_all: 'Rolette|Bottineau',
    county_weights: '{"38079": 86.38, "38009": 13.62}',
    density: 5.3,
    imprecise: false,
    latitude: 48.8682,
    longitude: -100.08927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58329',
  },
  {
    city: 'Edmore',
    county_fips: 38071,
    county_fips_all: '38071|38019',
    county: 'Ramsey',
    county_names_all: 'Ramsey|Cavalier',
    county_weights: '{"38071": 97.67, "38019": 2.33}',
    density: 0.9,
    imprecise: false,
    latitude: 48.44208,
    longitude: -98.48275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58330',
  },
  {
    city: 'Egeland',
    county_fips: 38095,
    county_fips_all: '38095',
    county: 'Towner',
    county_names_all: 'Towner',
    county_weights: '{"38095": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 48.64014,
    longitude: -99.09293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58331',
  },
  {
    city: 'Esmond',
    county_fips: 38005,
    county_fips_all: '38005|38069',
    county: 'Benson',
    county_names_all: 'Benson|Pierce',
    county_weights: '{"38005": 76.91, "38069": 23.09}',
    density: 0.3,
    imprecise: false,
    latitude: 48.04596,
    longitude: -99.76725,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58332',
  },
  {
    city: 'Fort Totten',
    county_fips: 38005,
    county_fips_all: '38005',
    county: 'Benson',
    county_names_all: 'Benson',
    county_weights: '{"38005": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 47.97229,
    longitude: -99.00412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58335',
  },
  {
    city: 'Hampden',
    county_fips: 38071,
    county_fips_all: '38071|38019',
    county: 'Ramsey',
    county_names_all: 'Ramsey|Cavalier',
    county_weights: '{"38071": 54.02, "38019": 45.98}',
    density: 0.5,
    imprecise: false,
    latitude: 48.52879,
    longitude: -98.6313,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58338',
  },
  {
    city: 'Hansboro',
    county_fips: 38095,
    county_fips_all: '38095',
    county: 'Towner',
    county_names_all: 'Towner',
    county_weights: '{"38095": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 48.97175,
    longitude: -99.32709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58339',
  },
  {
    city: 'Harvey',
    county_fips: 38103,
    county_fips_all: '38103|38069|38005|38083',
    county: 'Wells',
    county_names_all: 'Wells|Pierce|Benson|Sheridan',
    county_weights:
      '{"38103": 73.74, "38069": 20.88, "38005": 2.73, "38083": 2.65}',
    density: 2.3,
    imprecise: false,
    latitude: 47.77117,
    longitude: -99.85599,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58341',
  },
  {
    city: 'Knox',
    county_fips: 38005,
    county_fips_all: '38005',
    county: 'Benson',
    county_names_all: 'Benson',
    county_weights: '{"38005": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 48.29643,
    longitude: -99.72583,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 67,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58343',
  },
  {
    city: 'Lakota',
    county_fips: 38063,
    county_fips_all: '38063|38071',
    county: 'Nelson',
    county_names_all: 'Nelson|Ramsey',
    county_weights: '{"38063": 93.35, "38071": 6.65}',
    density: 2.1,
    imprecise: false,
    latitude: 48.01471,
    longitude: -98.33857,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58344',
  },
  {
    city: 'Lawton',
    county_fips: 38071,
    county_fips_all: '38071|38099',
    county: 'Ramsey',
    county_names_all: 'Ramsey|Walsh',
    county_weights: '{"38071": 64.86, "38099": 35.14}',
    density: 0.4,
    imprecise: false,
    latitude: 48.30564,
    longitude: -98.37436,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58345',
  },
  {
    city: 'Leeds',
    county_fips: 38005,
    county_fips_all: '38005|38095|38069',
    county: 'Benson',
    county_names_all: 'Benson|Towner|Pierce',
    county_weights: '{"38005": 86.07, "38095": 12.44, "38069": 1.49}',
    density: 1.2,
    imprecise: false,
    latitude: 48.28953,
    longitude: -99.42218,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58346',
  },
  {
    city: 'Maddock',
    county_fips: 38005,
    county_fips_all: '38005|38103',
    county: 'Benson',
    county_names_all: 'Benson|Wells',
    county_weights: '{"38005": 89.49, "38103": 10.51}',
    density: 1.2,
    imprecise: false,
    latitude: 47.95509,
    longitude: -99.52365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58348',
  },
  {
    city: 'Minnewaukan',
    county_fips: 38005,
    county_fips_all: '38005',
    county: 'Benson',
    county_names_all: 'Benson',
    county_weights: '{"38005": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 48.10218,
    longitude: -99.31394,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58351',
  },
  {
    city: 'Munich',
    county_fips: 38019,
    county_fips_all: '38019|38095',
    county: 'Cavalier',
    county_names_all: 'Cavalier|Towner',
    county_weights: '{"38019": 88.24, "38095": 11.76}',
    density: 0.8,
    imprecise: false,
    latitude: 48.70188,
    longitude: -98.86099,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58352',
  },
  {
    city: 'Mylo',
    county_fips: 38079,
    county_fips_all: '38079',
    county: 'Rolette',
    county_names_all: 'Rolette',
    county_weights: '{"38079": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 48.64005,
    longitude: -99.59928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58353',
  },
  {
    city: 'Nekoma',
    county_fips: 38019,
    county_fips_all: '38019',
    county: 'Cavalier',
    county_names_all: 'Cavalier',
    county_weights: '{"38019": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.57504,
    longitude: -98.38528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58355',
  },
  {
    city: 'New Rockford',
    county_fips: 38027,
    county_fips_all: '38027|38103|38031',
    county: 'Eddy',
    county_names_all: 'Eddy|Wells|Foster',
    county_weights: '{"38027": 81.29, "38103": 12.72, "38031": 5.99}',
    density: 2.3,
    imprecise: false,
    latitude: 47.67103,
    longitude: -99.07804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58356',
  },
  {
    city: 'Oberon',
    county_fips: 38005,
    county_fips_all: '38005',
    county: 'Benson',
    county_names_all: 'Benson',
    county_weights: '{"38005": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 47.94429,
    longitude: -99.21831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58357',
  },
  {
    city: 'Pekin',
    county_fips: 38063,
    county_fips_all: '38063',
    county: 'Nelson',
    county_names_all: 'Nelson',
    county_weights: '{"38063": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 47.75841,
    longitude: -98.35458,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58361',
  },
  {
    city: 'Penn',
    county_fips: 38071,
    county_fips_all: '38071',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"38071": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 48.23099,
    longitude: -99.0554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58362',
  },
  {
    city: 'Perth',
    county_fips: 38095,
    county_fips_all: '38095|38079',
    county: 'Towner',
    county_names_all: 'Towner|Rolette',
    county_weights: '{"38095": 81.19, "38079": 18.81}',
    density: 0.4,
    imprecise: false,
    latitude: 48.76417,
    longitude: -99.46669,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58363',
  },
  {
    city: 'Rocklake',
    county_fips: 38095,
    county_fips_all: '38095',
    county: 'Towner',
    county_names_all: 'Towner',
    county_weights: '{"38095": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.83655,
    longitude: -99.23626,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58365',
  },
  {
    city: 'Rolette',
    county_fips: 38079,
    county_fips_all: '38079|38069',
    county: 'Rolette',
    county_names_all: 'Rolette|Pierce',
    county_weights: '{"38079": 93.46, "38069": 6.54}',
    density: 1,
    imprecise: false,
    latitude: 48.65242,
    longitude: -99.86654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58366',
  },
  {
    city: 'Rolla',
    county_fips: 38079,
    county_fips_all: '38079|38095',
    county: 'Rolette',
    county_names_all: 'Rolette|Towner',
    county_weights: '{"38079": 62.63, "38095": 37.37}',
    density: 2.9,
    imprecise: false,
    latitude: 48.88179,
    longitude: -99.55163,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58367',
  },
  {
    city: 'Rugby',
    county_fips: 38069,
    county_fips_all: '38069|38049|38005',
    county: 'Pierce',
    county_names_all: 'Pierce|McHenry|Benson',
    county_weights: '{"38069": 88.06, "38049": 6.82, "38005": 5.12}',
    density: 2.1,
    imprecise: false,
    latitude: 48.25124,
    longitude: -100.04105,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58368',
  },
  {
    city: 'Saint John',
    county_fips: 38079,
    county_fips_all: '38079',
    county: 'Rolette',
    county_names_all: 'Rolette',
    county_weights: '{"38079": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 48.95257,
    longitude: -99.83603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58369',
  },
  {
    city: 'Saint Michael',
    county_fips: 38005,
    county_fips_all: '38005',
    county: 'Benson',
    county_names_all: 'Benson',
    county_weights: '{"38005": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 47.9842,
    longitude: -98.85977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58370',
  },
  {
    city: 'Sarles',
    county_fips: 38095,
    county_fips_all: '38095|38019',
    county: 'Towner',
    county_names_all: 'Towner|Cavalier',
    county_weights: '{"38095": 56.88, "38019": 43.12}',
    density: 0.4,
    imprecise: false,
    latitude: 48.93906,
    longitude: -99.00628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58372',
  },
  {
    city: 'Sheyenne',
    county_fips: 38027,
    county_fips_all: '38027|38005|38103',
    county: 'Eddy',
    county_names_all: 'Eddy|Benson|Wells',
    county_weights: '{"38027": 52.39, "38005": 35.6, "38103": 12.01}',
    density: 1.1,
    imprecise: false,
    latitude: 47.82865,
    longitude: -99.09171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58374',
  },
  {
    city: 'Starkweather',
    county_fips: 38071,
    county_fips_all: '38071|38095|38019',
    county: 'Ramsey',
    county_names_all: 'Ramsey|Towner|Cavalier',
    county_weights: '{"38071": 68.02, "38095": 17.47, "38019": 14.51}',
    density: 0.3,
    imprecise: false,
    latitude: 48.46481,
    longitude: -98.87416,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58377',
  },
  {
    city: 'Tokio',
    county_fips: 38005,
    county_fips_all: '38005',
    county: 'Benson',
    county_names_all: 'Benson',
    county_weights: '{"38005": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 47.90707,
    longitude: -98.81907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58379',
  },
  {
    city: 'Tolna',
    county_fips: 38063,
    county_fips_all: '38063|38027|38005',
    county: 'Nelson',
    county_names_all: 'Nelson|Eddy|Benson',
    county_weights: '{"38063": 51.46, "38027": 34.6, "38005": 13.94}',
    density: 1.1,
    imprecise: false,
    latitude: 47.82872,
    longitude: -98.52029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58380',
  },
  {
    city: 'Warwick',
    county_fips: 38027,
    county_fips_all: '38027|38005',
    county: 'Eddy',
    county_names_all: 'Eddy|Benson',
    county_weights: '{"38027": 60.45, "38005": 39.55}',
    density: 1.1,
    imprecise: false,
    latitude: 47.82731,
    longitude: -98.74476,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58381',
  },
  {
    city: 'Webster',
    county_fips: 38071,
    county_fips_all: '38071',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"38071": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.31727,
    longitude: -98.79252,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58382',
  },
  {
    city: 'Willow City',
    county_fips: 38009,
    county_fips_all: '38009|38049|38069|38079',
    county: 'Bottineau',
    county_names_all: 'Bottineau|McHenry|Pierce|Rolette',
    county_weights:
      '{"38009": 42.77, "38049": 22.36, "38069": 20.75, "38079": 14.11}',
    density: 0.4,
    imprecise: false,
    latitude: 48.59401,
    longitude: -100.26465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58384',
  },
  {
    city: 'Wolford',
    county_fips: 38069,
    county_fips_all: '38069|38079',
    county: 'Pierce',
    county_names_all: 'Pierce|Rolette',
    county_weights: '{"38069": 95.58, "38079": 4.42}',
    density: 0.6,
    imprecise: false,
    latitude: 48.47945,
    longitude: -99.65989,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58385',
  },
  {
    city: 'York',
    county_fips: 38005,
    county_fips_all: '38005|38069',
    county: 'Benson',
    county_names_all: 'Benson|Pierce',
    county_weights: '{"38005": 67.33, "38069": 32.67}',
    density: 0.2,
    imprecise: false,
    latitude: 48.31696,
    longitude: -99.59227,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58386',
  },
  {
    city: 'Jamestown',
    county_fips: 38093,
    county_fips_all: '38093',
    county: 'Stutsman',
    county_names_all: 'Stutsman',
    county_weights: '{"38093": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 46.88145,
    longitude: -98.76883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58401',
  },
  {
    city: 'Jamestown',
    county_fips: 38093,
    county_fips_all: '38093',
    county: 'Stutsman',
    county_names_all: 'Stutsman',
    county_weights: '{"38093": 100}',
    density: 855.2,
    imprecise: false,
    latitude: 46.88191,
    longitude: -98.68755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58402',
  },
  {
    city: 'Ashley',
    county_fips: 38051,
    county_fips_all: '38051|38021|46089',
    county: 'McIntosh',
    county_names_all: 'McIntosh|Dickey|McPherson',
    county_weights: '{"38051": 85.08, "38021": 8.35, "46089": 6.57}',
    density: 0.8,
    imprecise: false,
    latitude: 46.02963,
    longitude: -99.34235,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58413',
  },
  {
    city: 'Berlin',
    county_fips: 38045,
    county_fips_all: '38045',
    county: 'LaMoure',
    county_names_all: 'LaMoure',
    county_weights: '{"38045": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 46.36602,
    longitude: -98.48587,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58415',
  },
  {
    city: 'Binford',
    county_fips: 38039,
    county_fips_all: '38039',
    county: 'Griggs',
    county_names_all: 'Griggs',
    county_weights: '{"38039": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 47.54767,
    longitude: -98.35694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58416',
  },
  {
    city: 'Bowdon',
    county_fips: 38103,
    county_fips_all: '38103|38043',
    county: 'Wells',
    county_names_all: 'Wells|Kidder',
    county_weights: '{"38103": 82.27, "38043": 17.73}',
    density: 0.4,
    imprecise: false,
    latitude: 47.41493,
    longitude: -99.63524,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58418',
  },
  {
    city: 'Buchanan',
    county_fips: 38093,
    county_fips_all: '38093',
    county: 'Stutsman',
    county_names_all: 'Stutsman',
    county_weights: '{"38093": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 47.06072,
    longitude: -98.86734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58420',
  },
  {
    city: 'Carrington',
    county_fips: 38031,
    county_fips_all: '38031|38093|38103|38027',
    county: 'Foster',
    county_names_all: 'Foster|Stutsman|Wells|Eddy',
    county_weights:
      '{"38031": 82.9, "38093": 8.08, "38103": 5.63, "38027": 3.39}',
    density: 2.9,
    imprecise: false,
    latitude: 47.43974,
    longitude: -99.06968,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58421',
  },
  {
    city: 'Cathay',
    county_fips: 38103,
    county_fips_all: '38103',
    county: 'Wells',
    county_names_all: 'Wells',
    county_weights: '{"38103": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 47.59853,
    longitude: -99.39531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58422',
  },
  {
    city: 'Chaseley',
    county_fips: 38103,
    county_fips_all: '38103|38043',
    county: 'Wells',
    county_names_all: 'Wells|Kidder',
    county_weights: '{"38103": 73.55, "38043": 26.45}',
    density: 0.8,
    imprecise: false,
    latitude: 47.41899,
    longitude: -99.82951,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58423',
  },
  {
    city: 'Cleveland',
    county_fips: 38093,
    county_fips_all: '38093',
    county: 'Stutsman',
    county_names_all: 'Stutsman',
    county_weights: '{"38093": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 46.87554,
    longitude: -99.10217,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58424',
  },
  {
    city: 'Cooperstown',
    county_fips: 38039,
    county_fips_all: '38039|38091',
    county: 'Griggs',
    county_names_all: 'Griggs|Steele',
    county_weights: '{"38039": 98.65, "38091": 1.35}',
    density: 2.6,
    imprecise: false,
    latitude: 47.45391,
    longitude: -98.12378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58425',
  },
  {
    city: 'Courtenay',
    county_fips: 38093,
    county_fips_all: '38093|38031',
    county: 'Stutsman',
    county_names_all: 'Stutsman|Foster',
    county_weights: '{"38093": 95.52, "38031": 4.48}',
    density: 0.5,
    imprecise: false,
    latitude: 47.21972,
    longitude: -98.58075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58426',
  },
  {
    city: 'Dawson',
    county_fips: 38043,
    county_fips_all: '38043',
    county: 'Kidder',
    county_names_all: 'Kidder',
    county_weights: '{"38043": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 46.81162,
    longitude: -99.75809,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58428',
  },
  {
    city: 'Dazey',
    county_fips: 38003,
    county_fips_all: '38003|38039',
    county: 'Barnes',
    county_names_all: 'Barnes|Griggs',
    county_weights: '{"38003": 97.71, "38039": 2.29}',
    density: 1,
    imprecise: false,
    latitude: 47.18768,
    longitude: -98.16282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58429',
  },
  {
    city: 'Denhoff',
    county_fips: 38083,
    county_fips_all: '38083',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"38083": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 47.50831,
    longitude: -100.25954,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58430',
  },
  {
    city: 'Dickey',
    county_fips: 38045,
    county_fips_all: '38045',
    county: 'LaMoure',
    county_names_all: 'LaMoure',
    county_weights: '{"38045": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 46.50522,
    longitude: -98.49658,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58431',
  },
  {
    city: 'Edgeley',
    county_fips: 38045,
    county_fips_all: '38045|38021',
    county: 'LaMoure',
    county_names_all: 'LaMoure|Dickey',
    county_weights: '{"38045": 80.27, "38021": 19.73}',
    density: 1.4,
    imprecise: false,
    latitude: 46.36989,
    longitude: -98.72157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58433',
  },
  {
    city: 'Ellendale',
    county_fips: 38021,
    county_fips_all: '38021|46013',
    county: 'Dickey',
    county_names_all: 'Dickey|Brown',
    county_weights: '{"38021": 95.42, "46013": 4.58}',
    density: 2,
    imprecise: false,
    latitude: 46.08203,
    longitude: -98.58773,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58436',
  },
  {
    city: 'Fessenden',
    county_fips: 38103,
    county_fips_all: '38103',
    county: 'Wells',
    county_names_all: 'Wells',
    county_weights: '{"38103": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 47.66247,
    longitude: -99.57983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58438',
  },
  {
    city: 'Forbes',
    county_fips: 38021,
    county_fips_all: '38021|46089|46013',
    county: 'Dickey',
    county_names_all: 'Dickey|McPherson|Brown',
    county_weights: '{"38021": 62.89, "46089": 34.85, "46013": 2.26}',
    density: 0.8,
    imprecise: false,
    latitude: 45.96738,
    longitude: -98.82994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58439',
  },
  {
    city: 'Fredonia',
    county_fips: 38047,
    county_fips_all: '38047|38051',
    county: 'Logan',
    county_names_all: 'Logan|McIntosh',
    county_weights: '{"38047": 53.73, "38051": 46.27}',
    density: 0.4,
    imprecise: false,
    latitude: 46.27941,
    longitude: -99.16324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58440',
  },
  {
    city: 'Fullerton',
    county_fips: 38021,
    county_fips_all: '38021',
    county: 'Dickey',
    county_names_all: 'Dickey',
    county_weights: '{"38021": 100}',
    density: 1,
    imprecise: false,
    latitude: 46.17119,
    longitude: -98.37844,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58441',
  },
  {
    city: 'Gackle',
    county_fips: 38047,
    county_fips_all: '38047|38093',
    county: 'Logan',
    county_names_all: 'Logan|Stutsman',
    county_weights: '{"38047": 79.45, "38093": 20.55}',
    density: 0.7,
    imprecise: false,
    latitude: 46.56518,
    longitude: -99.18184,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58442',
  },
  {
    city: 'Glenfield',
    county_fips: 38031,
    county_fips_all: '38031',
    county: 'Foster',
    county_names_all: 'Foster',
    county_weights: '{"38031": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 47.46374,
    longitude: -98.67239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58443',
  },
  {
    city: 'Goodrich',
    county_fips: 38083,
    county_fips_all: '38083',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"38083": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 47.48278,
    longitude: -100.13156,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58444',
  },
  {
    city: 'Grace City',
    county_fips: 38031,
    county_fips_all: '38031|38027',
    county: 'Foster',
    county_names_all: 'Foster|Eddy',
    county_weights: '{"38031": 65.44, "38027": 34.56}',
    density: 0.8,
    imprecise: false,
    latitude: 47.57036,
    longitude: -98.78869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58445',
  },
  {
    city: 'Hannaford',
    county_fips: 38039,
    county_fips_all: '38039|38003',
    county: 'Griggs',
    county_names_all: 'Griggs|Barnes',
    county_weights: '{"38039": 99.4, "38003": 0.6}',
    density: 0.8,
    imprecise: false,
    latitude: 47.30944,
    longitude: -98.21451,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58448',
  },
  {
    city: 'Hurdsfield',
    county_fips: 38103,
    county_fips_all: '38103',
    county: 'Wells',
    county_names_all: 'Wells',
    county_weights: '{"38103": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 47.45167,
    longitude: -99.95275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58451',
  },
  {
    city: 'Jessie',
    county_fips: 38039,
    county_fips_all: '38039',
    county: 'Griggs',
    county_names_all: 'Griggs',
    county_weights: '{"38039": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 47.54019,
    longitude: -98.22911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58452',
  },
  {
    city: 'Jud',
    county_fips: 38045,
    county_fips_all: '38045|38093',
    county: 'LaMoure',
    county_names_all: 'LaMoure|Stutsman',
    county_weights: '{"38045": 63.84, "38093": 36.16}',
    density: 0.7,
    imprecise: false,
    latitude: 46.5978,
    longitude: -98.94038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58454',
  },
  {
    city: 'Kensal',
    county_fips: 38093,
    county_fips_all: '38093|38031',
    county: 'Stutsman',
    county_names_all: 'Stutsman|Foster',
    county_weights: '{"38093": 59.28, "38031": 40.72}',
    density: 0.8,
    imprecise: false,
    latitude: 47.30094,
    longitude: -98.72667,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58455',
  },
  {
    city: 'Kulm',
    county_fips: 38021,
    county_fips_all: '38021|38045|38051',
    county: 'Dickey',
    county_names_all: 'Dickey|LaMoure|McIntosh',
    county_weights: '{"38021": 44.06, "38045": 37.06, "38051": 18.89}',
    density: 1.2,
    imprecise: false,
    latitude: 46.25674,
    longitude: -98.95475,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58456',
  },
  {
    city: 'Lamoure',
    county_fips: 38045,
    county_fips_all: '38045|38021',
    county: 'LaMoure',
    county_names_all: 'LaMoure|Dickey',
    county_weights: '{"38045": 93.7, "38021": 6.3}',
    density: 2.1,
    imprecise: false,
    latitude: 46.36921,
    longitude: -98.29257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58458',
  },
  {
    city: 'Lehr',
    county_fips: 38047,
    county_fips_all: '38047|38051',
    county: 'Logan',
    county_names_all: 'Logan|McIntosh',
    county_weights: '{"38047": 59.55, "38051": 40.45}',
    density: 0.2,
    imprecise: false,
    latitude: 46.30991,
    longitude: -99.31907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58460',
  },
  {
    city: 'Litchville',
    county_fips: 38003,
    county_fips_all: '38003|38045',
    county: 'Barnes',
    county_names_all: 'Barnes|LaMoure',
    county_weights: '{"38003": 55.75, "38045": 44.25}',
    density: 0.8,
    imprecise: false,
    latitude: 46.64958,
    longitude: -98.19248,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58461',
  },
  {
    city: 'Mcclusky',
    county_fips: 38083,
    county_fips_all: '38083',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"38083": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 47.49662,
    longitude: -100.46281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58463',
  },
  {
    city: 'Mchenry',
    county_fips: 38027,
    county_fips_all: '38027|38031|38039',
    county: 'Eddy',
    county_names_all: 'Eddy|Foster|Griggs',
    county_weights: '{"38027": 54.97, "38031": 35.36, "38039": 9.67}',
    density: 0.7,
    imprecise: false,
    latitude: 47.60786,
    longitude: -98.58849,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58464',
  },
  {
    city: 'Marion',
    county_fips: 38045,
    county_fips_all: '38045|38003|38093',
    county: 'LaMoure',
    county_names_all: 'LaMoure|Barnes|Stutsman',
    county_weights: '{"38045": 61.63, "38003": 35.93, "38093": 2.44}',
    density: 1.1,
    imprecise: false,
    latitude: 46.61489,
    longitude: -98.36493,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58466',
  },
  {
    city: 'Medina',
    county_fips: 38093,
    county_fips_all: '38093|38043',
    county: 'Stutsman',
    county_names_all: 'Stutsman|Kidder',
    county_weights: '{"38093": 83.93, "38043": 16.07}',
    density: 0.8,
    imprecise: false,
    latitude: 46.8746,
    longitude: -99.34103,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58467',
  },
  {
    city: 'Montpelier',
    county_fips: 38093,
    county_fips_all: '38093|38045',
    county: 'Stutsman',
    county_names_all: 'Stutsman|LaMoure',
    county_weights: '{"38093": 63.29, "38045": 36.71}',
    density: 1.2,
    imprecise: false,
    latitude: 46.64135,
    longitude: -98.66055,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58472',
  },
  {
    city: 'Oakes',
    county_fips: 38021,
    county_fips_all: '38021|38081|38045',
    county: 'Dickey',
    county_names_all: 'Dickey|Sargent|LaMoure',
    county_weights: '{"38021": 86.67, "38081": 12.6, "38045": 0.73}',
    density: 2.6,
    imprecise: false,
    latitude: 46.09588,
    longitude: -98.13574,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58474',
  },
  {
    city: 'Pettibone',
    county_fips: 38043,
    county_fips_all: '38043|38093',
    county: 'Kidder',
    county_names_all: 'Kidder|Stutsman',
    county_weights: '{"38043": 79.24, "38093": 20.76}',
    density: 0.2,
    imprecise: false,
    latitude: 47.14118,
    longitude: -99.53717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 75,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58475',
  },
  {
    city: 'Pingree',
    county_fips: 38093,
    county_fips_all: '38093',
    county: 'Stutsman',
    county_names_all: 'Stutsman',
    county_weights: '{"38093": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 47.19398,
    longitude: -99.00263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58476',
  },
  {
    city: 'Regan',
    county_fips: 38015,
    county_fips_all: '38015',
    county: 'Burleigh',
    county_names_all: 'Burleigh',
    county_weights: '{"38015": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 47.2208,
    longitude: -100.52294,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58477',
  },
  {
    city: 'Robinson',
    county_fips: 38043,
    county_fips_all: '38043',
    county: 'Kidder',
    county_names_all: 'Kidder',
    county_weights: '{"38043": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 47.16008,
    longitude: -99.74543,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58478',
  },
  {
    city: 'Rogers',
    county_fips: 38003,
    county_fips_all: '38003',
    county: 'Barnes',
    county_names_all: 'Barnes',
    county_weights: '{"38003": 100}',
    density: 1,
    imprecise: false,
    latitude: 47.09254,
    longitude: -98.19948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58479',
  },
  {
    city: 'Sanborn',
    county_fips: 38003,
    county_fips_all: '38003',
    county: 'Barnes',
    county_names_all: 'Barnes',
    county_weights: '{"38003": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 46.94707,
    longitude: -98.25685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58480',
  },
  {
    city: 'Spiritwood',
    county_fips: 38003,
    county_fips_all: '38003|38093',
    county: 'Barnes',
    county_names_all: 'Barnes|Stutsman',
    county_weights: '{"38003": 65.22, "38093": 34.78}',
    density: 0.4,
    imprecise: false,
    latitude: 46.9346,
    longitude: -98.42814,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58481',
  },
  {
    city: 'Steele',
    county_fips: 38043,
    county_fips_all: '38043',
    county: 'Kidder',
    county_names_all: 'Kidder',
    county_weights: '{"38043": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 46.86669,
    longitude: -99.90465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58482',
  },
  {
    city: 'Streeter',
    county_fips: 38093,
    county_fips_all: '38093|38043|38047',
    county: 'Stutsman',
    county_names_all: 'Stutsman|Kidder|Logan',
    county_weights: '{"38093": 41.07, "38043": 30.7, "38047": 28.23}',
    density: 0.7,
    imprecise: false,
    latitude: 46.66176,
    longitude: -99.42186,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58483',
  },
  {
    city: 'Sutton',
    county_fips: 38039,
    county_fips_all: '38039|38031',
    county: 'Griggs',
    county_names_all: 'Griggs|Foster',
    county_weights: '{"38039": 73.3, "38031": 26.7}',
    density: 0.6,
    imprecise: false,
    latitude: 47.37821,
    longitude: -98.4687,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58484',
  },
  {
    city: 'Sykeston',
    county_fips: 38103,
    county_fips_all: '38103|38093',
    county: 'Wells',
    county_names_all: 'Wells|Stutsman',
    county_weights: '{"38103": 79.88, "38093": 20.12}',
    density: 0.5,
    imprecise: false,
    latitude: 47.39421,
    longitude: -99.39279,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58486',
  },
  {
    city: 'Tappen',
    county_fips: 38043,
    county_fips_all: '38043',
    county: 'Kidder',
    county_names_all: 'Kidder',
    county_weights: '{"38043": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 46.85278,
    longitude: -99.60283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58487',
  },
  {
    city: 'Tuttle',
    county_fips: 38043,
    county_fips_all: '38043',
    county: 'Kidder',
    county_names_all: 'Kidder',
    county_weights: '{"38043": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 47.17552,
    longitude: -99.99709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58488',
  },
  {
    city: 'Verona',
    county_fips: 38045,
    county_fips_all: '38045|38073',
    county: 'LaMoure',
    county_names_all: 'LaMoure|Ransom',
    county_weights: '{"38045": 70.46, "38073": 29.54}',
    density: 0.9,
    imprecise: false,
    latitude: 46.38137,
    longitude: -98.06063,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58490',
  },
  {
    city: 'Wimbledon',
    county_fips: 38003,
    county_fips_all: '38003|38093|38039',
    county: 'Barnes',
    county_names_all: 'Barnes|Stutsman|Griggs',
    county_weights: '{"38003": 54.65, "38093": 28.96, "38039": 16.39}',
    density: 1,
    imprecise: false,
    latitude: 47.15793,
    longitude: -98.43787,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58492',
  },
  {
    city: 'Wing',
    county_fips: 38015,
    county_fips_all: '38015',
    county: 'Burleigh',
    county_names_all: 'Burleigh',
    county_weights: '{"38015": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 47.16306,
    longitude: -100.2744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58494',
  },
  {
    city: 'Wishek',
    county_fips: 38051,
    county_fips_all: '38051|38047',
    county: 'McIntosh',
    county_names_all: 'McIntosh|Logan',
    county_weights: '{"38051": 60.35, "38047": 39.65}',
    density: 1.2,
    imprecise: false,
    latitude: 46.27202,
    longitude: -99.60077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58495',
  },
  {
    city: 'Woodworth',
    county_fips: 38093,
    county_fips_all: '38093',
    county: 'Stutsman',
    county_names_all: 'Stutsman',
    county_weights: '{"38093": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 47.14063,
    longitude: -99.30794,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58496',
  },
  {
    city: 'Ypsilanti',
    county_fips: 38093,
    county_fips_all: '38093|38003',
    county: 'Stutsman',
    county_names_all: 'Stutsman|Barnes',
    county_weights: '{"38093": 92.1, "38003": 7.9}',
    density: 0.9,
    imprecise: false,
    latitude: 46.76738,
    longitude: -98.54076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58497',
  },
  {
    city: 'Bismarck',
    county_fips: 38015,
    county_fips_all: '38015',
    county: 'Burleigh',
    county_names_all: 'Burleigh',
    county_weights: '{"38015": 100}',
    density: 497.8,
    imprecise: false,
    latitude: 46.8189,
    longitude: -100.70234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58501',
  },
  {
    city: 'Bismarck',
    county_fips: 38015,
    county_fips_all: '38015',
    county: 'Burleigh',
    county_names_all: 'Burleigh',
    county_weights: '{"38015": 100}',
    density: 107.3,
    imprecise: false,
    latitude: 46.90587,
    longitude: -100.75262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58503',
  },
  {
    city: 'Bismarck',
    county_fips: 38015,
    county_fips_all: '38015',
    county: 'Burleigh',
    county_names_all: 'Burleigh',
    county_weights: '{"38015": 100}',
    density: 112.9,
    imprecise: false,
    latitude: 46.7273,
    longitude: -100.6808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58504',
  },
  {
    city: 'Almont',
    county_fips: 38059,
    county_fips_all: '38059|38037',
    county: 'Morton',
    county_names_all: 'Morton|Grant',
    county_weights: '{"38059": 68.85, "38037": 31.15}',
    density: 0.5,
    imprecise: false,
    latitude: 46.6758,
    longitude: -101.5409,
    militaryZip: false,
    timezone: 'America/North_Dakota/New_Salem',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58520',
  },
  {
    city: 'Baldwin',
    county_fips: 38015,
    county_fips_all: '38015',
    county: 'Burleigh',
    county_names_all: 'Burleigh',
    county_weights: '{"38015": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 47.0269,
    longitude: -100.66963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58521',
  },
  {
    city: 'Beulah',
    county_fips: 38057,
    county_fips_all: '38057|38065',
    county: 'Mercer',
    county_names_all: 'Mercer|Oliver',
    county_weights: '{"38057": 72.5, "38065": 27.5}',
    density: 5.1,
    imprecise: false,
    latitude: 47.26581,
    longitude: -101.78138,
    militaryZip: false,
    timezone: 'America/North_Dakota/Beulah',
    population: 3280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58523',
  },
  {
    city: 'Braddock',
    county_fips: 38029,
    county_fips_all: '38029|38043|38015',
    county: 'Emmons',
    county_names_all: 'Emmons|Kidder|Burleigh',
    county_weights: '{"38029": 56.65, "38043": 24.99, "38015": 18.36}',
    density: 0.2,
    imprecise: false,
    latitude: 46.61297,
    longitude: -100.07506,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58524',
  },
  {
    city: 'Cannon Ball',
    county_fips: 38085,
    county_fips_all: '38085',
    county: 'Sioux',
    county_names_all: 'Sioux',
    county_weights: '{"38085": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 46.34174,
    longitude: -100.62751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58528',
  },
  {
    city: 'Carson',
    county_fips: 38037,
    county_fips_all: '38037',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"38037": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 46.30116,
    longitude: -101.56952,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58529',
  },
  {
    city: 'Center',
    county_fips: 38065,
    county_fips_all: '38065|38057',
    county: 'Oliver',
    county_names_all: 'Oliver|Mercer',
    county_weights: '{"38065": 99.64, "38057": 0.36}',
    density: 1.3,
    imprecise: false,
    latitude: 47.13357,
    longitude: -101.15257,
    militaryZip: false,
    timezone: 'America/North_Dakota/Center',
    population: 1144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58530',
  },
  {
    city: 'Coleharbor',
    county_fips: 38055,
    county_fips_all: '38055',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"38055": 100}',
    density: 1,
    imprecise: false,
    latitude: 47.58387,
    longitude: -101.20289,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58531',
  },
  {
    city: 'Driscoll',
    county_fips: 38015,
    county_fips_all: '38015|38043',
    county: 'Burleigh',
    county_names_all: 'Burleigh|Kidder',
    county_weights: '{"38015": 61.44, "38043": 38.56}',
    density: 0.4,
    imprecise: false,
    latitude: 46.84571,
    longitude: -100.10631,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58532',
  },
  {
    city: 'Elgin',
    county_fips: 38037,
    county_fips_all: '38037',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"38037": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 46.39433,
    longitude: -101.79598,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58533',
  },
  {
    city: 'Flasher',
    county_fips: 38059,
    county_fips_all: '38059|38037',
    county: 'Morton',
    county_names_all: 'Morton|Grant',
    county_weights: '{"38059": 62.74, "38037": 37.26}',
    density: 0.6,
    imprecise: false,
    latitude: 46.48724,
    longitude: -101.24558,
    militaryZip: false,
    timezone: 'America/North_Dakota/New_Salem',
    population: 500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58535',
  },
  {
    city: 'Fort Yates',
    county_fips: 38085,
    county_fips_all: '38085',
    county: 'Sioux',
    county_names_all: 'Sioux',
    county_weights: '{"38085": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 46.08833,
    longitude: -100.66983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58538',
  },
  {
    city: 'Garrison',
    county_fips: 38055,
    county_fips_all: '38055',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"38055": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 47.62427,
    longitude: -101.72538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58540',
  },
  {
    city: 'Golden Valley',
    county_fips: 38057,
    county_fips_all: '38057',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"38057": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 47.33929,
    longitude: -102.05177,
    militaryZip: false,
    timezone: 'America/North_Dakota/Beulah',
    population: 467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58541',
  },
  {
    city: 'Hague',
    county_fips: 38029,
    county_fips_all: '38029',
    county: 'Emmons',
    county_names_all: 'Emmons',
    county_weights: '{"38029": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 46.04976,
    longitude: -100.00269,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58542',
  },
  {
    city: 'Hazelton',
    county_fips: 38029,
    county_fips_all: '38029',
    county: 'Emmons',
    county_names_all: 'Emmons',
    county_weights: '{"38029": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 46.49833,
    longitude: -100.37062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58544',
  },
  {
    city: 'Hazen',
    county_fips: 38057,
    county_fips_all: '38057|38065',
    county: 'Mercer',
    county_names_all: 'Mercer|Oliver',
    county_weights: '{"38057": 77.68, "38065": 22.32}',
    density: 4.1,
    imprecise: false,
    latitude: 47.34916,
    longitude: -101.58921,
    militaryZip: false,
    timezone: 'America/North_Dakota/Beulah',
    population: 3313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58545',
  },
  {
    city: 'Kintyre',
    county_fips: 38029,
    county_fips_all: '38029|38047|38043',
    county: 'Emmons',
    county_names_all: 'Emmons|Logan|Kidder',
    county_weights: '{"38029": 56.91, "38047": 40.05, "38043": 3.04}',
    density: 0.4,
    imprecise: false,
    latitude: 46.46853,
    longitude: -99.93305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58549',
  },
  {
    city: 'Linton',
    county_fips: 38029,
    county_fips_all: '38029',
    county: 'Emmons',
    county_names_all: 'Emmons',
    county_weights: '{"38029": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 46.26042,
    longitude: -100.29955,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58552',
  },
  {
    city: 'Mandan',
    county_fips: 38059,
    county_fips_all: '38059|38065',
    county: 'Morton',
    county_names_all: 'Morton|Oliver',
    county_weights: '{"38059": 94.46, "38065": 5.54}',
    density: 19.9,
    imprecise: false,
    latitude: 46.75148,
    longitude: -100.95036,
    militaryZip: false,
    timezone: 'America/North_Dakota/New_Salem',
    population: 29479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58554',
  },
  {
    city: 'Menoken',
    county_fips: 38015,
    county_fips_all: '38015',
    county: 'Burleigh',
    county_names_all: 'Burleigh',
    county_weights: '{"38015": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 46.82106,
    longitude: -100.52127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58558',
  },
  {
    city: 'Mercer',
    county_fips: 38055,
    county_fips_all: '38055|38083',
    county: 'McLean',
    county_names_all: 'McLean|Sheridan',
    county_weights: '{"38055": 73.37, "38083": 26.63}',
    density: 0.9,
    imprecise: false,
    latitude: 47.4849,
    longitude: -100.71295,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58559',
  },
  {
    city: 'Moffit',
    county_fips: 38015,
    county_fips_all: '38015|38029',
    county: 'Burleigh',
    county_names_all: 'Burleigh|Emmons',
    county_weights: '{"38015": 64.16, "38029": 35.84}',
    density: 1,
    imprecise: false,
    latitude: 46.65182,
    longitude: -100.32407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58560',
  },
  {
    city: 'Napoleon',
    county_fips: 38047,
    county_fips_all: '38047',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"38047": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 46.49706,
    longitude: -99.68118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58561',
  },
  {
    city: 'New Leipzig',
    county_fips: 38037,
    county_fips_all: '38037|38041|38001',
    county: 'Grant',
    county_names_all: 'Grant|Hettinger|Adams',
    county_weights: '{"38037": 62.96, "38041": 28.66, "38001": 8.38}',
    density: 0.5,
    imprecise: false,
    latitude: 46.36354,
    longitude: -102.01095,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58562',
  },
  {
    city: 'New Salem',
    county_fips: 38059,
    county_fips_all: '38059|38065|38037',
    county: 'Morton',
    county_names_all: 'Morton|Oliver|Grant',
    county_weights: '{"38059": 68.14, "38065": 30.17, "38037": 1.69}',
    density: 1.3,
    imprecise: false,
    latitude: 46.90178,
    longitude: -101.43257,
    militaryZip: false,
    timezone: 'America/North_Dakota/New_Salem',
    population: 1961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58563',
  },
  {
    city: 'Raleigh',
    county_fips: 38037,
    county_fips_all: '38037',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"38037": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 46.26252,
    longitude: -101.35,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58564',
  },
  {
    city: 'Riverdale',
    county_fips: 38055,
    county_fips_all: '38055',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"38055": 100}',
    density: 45,
    imprecise: false,
    latitude: 47.49639,
    longitude: -101.37148,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58565',
  },
  {
    city: 'Saint Anthony',
    county_fips: 38059,
    county_fips_all: '38059',
    county: 'Morton',
    county_names_all: 'Morton',
    county_weights: '{"38059": 100}',
    density: 1,
    imprecise: false,
    latitude: 46.57835,
    longitude: -100.90673,
    militaryZip: false,
    timezone: 'America/North_Dakota/New_Salem',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58566',
  },
  {
    city: 'Selfridge',
    county_fips: 38085,
    county_fips_all: '38085|46031',
    county: 'Sioux',
    county_names_all: 'Sioux|Corson',
    county_weights: '{"38085": 99.62, "46031": 0.38}',
    density: 0.5,
    imprecise: false,
    latitude: 46.09274,
    longitude: -101.01538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58568',
  },
  {
    city: 'Shields',
    county_fips: 38037,
    county_fips_all: '38037',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"38037": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 46.25777,
    longitude: -101.19276,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58569',
  },
  {
    city: 'Solen',
    county_fips: 38059,
    county_fips_all: '38059|38085',
    county: 'Morton',
    county_names_all: 'Morton|Sioux',
    county_weights: '{"38059": 51.53, "38085": 48.47}',
    density: 0.5,
    imprecise: false,
    latitude: 46.37243,
    longitude: -100.87237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58570',
  },
  {
    city: 'Stanton',
    county_fips: 38057,
    county_fips_all: '38057|38065',
    county: 'Mercer',
    county_names_all: 'Mercer|Oliver',
    county_weights: '{"38057": 70.38, "38065": 29.62}',
    density: 2.5,
    imprecise: false,
    latitude: 47.29134,
    longitude: -101.41043,
    militaryZip: false,
    timezone: 'America/North_Dakota/Beulah',
    population: 754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58571',
  },
  {
    city: 'Sterling',
    county_fips: 38015,
    county_fips_all: '38015',
    county: 'Burleigh',
    county_names_all: 'Burleigh',
    county_weights: '{"38015": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 46.86455,
    longitude: -100.34313,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58572',
  },
  {
    city: 'Strasburg',
    county_fips: 38029,
    county_fips_all: '38029',
    county: 'Emmons',
    county_names_all: 'Emmons',
    county_weights: '{"38029": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 46.12542,
    longitude: -100.20709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58573',
  },
  {
    city: 'Turtle Lake',
    county_fips: 38055,
    county_fips_all: '38055',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"38055": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 47.55749,
    longitude: -100.89971,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58575',
  },
  {
    city: 'Underwood',
    county_fips: 38055,
    county_fips_all: '38055',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"38055": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 47.4406,
    longitude: -101.21597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58576',
  },
  {
    city: 'Washburn',
    county_fips: 38055,
    county_fips_all: '38055',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"38055": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 47.31983,
    longitude: -101.05319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58577',
  },
  {
    city: 'Wilton',
    county_fips: 38015,
    county_fips_all: '38015|38055',
    county: 'Burleigh',
    county_names_all: 'Burleigh|McLean',
    county_weights: '{"38015": 69.52, "38055": 30.48}',
    density: 1.6,
    imprecise: false,
    latitude: 47.18059,
    longitude: -100.74422,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58579',
  },
  {
    city: 'Zap',
    county_fips: 38057,
    county_fips_all: '38057',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"38057": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 47.2665,
    longitude: -101.93301,
    militaryZip: false,
    timezone: 'America/North_Dakota/Beulah',
    population: 566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58580',
  },
  {
    city: 'Zeeland',
    county_fips: 38051,
    county_fips_all: '38051',
    county: 'McIntosh',
    county_names_all: 'McIntosh',
    county_weights: '{"38051": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 46.04646,
    longitude: -99.7983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58581',
  },
  {
    city: 'Dickinson',
    county_fips: 38089,
    county_fips_all: '38089|38025',
    county: 'Stark',
    county_names_all: 'Stark|Dunn',
    county_weights: '{"38089": 66.22, "38025": 33.78}',
    density: 20.2,
    imprecise: false,
    latitude: 46.90964,
    longitude: -102.82766,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 29916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58601',
  },
  {
    city: 'Amidon',
    county_fips: 38087,
    county_fips_all: '38087|38007',
    county: 'Slope',
    county_names_all: 'Slope|Billings',
    county_weights: '{"38087": 98.5, "38007": 1.5}',
    density: 0.2,
    imprecise: false,
    latitude: 46.49732,
    longitude: -103.3551,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58620',
  },
  {
    city: 'Beach',
    county_fips: 38033,
    county_fips_all: '38033|30109|38053|38007',
    county: 'Golden Valley',
    county_names_all: 'Golden Valley|Wibaux|McKenzie|Billings',
    county_weights:
      '{"38033": 90.64, "30109": 4.38, "38053": 2.85, "38007": 2.13}',
    density: 1,
    imprecise: false,
    latitude: 47.09771,
    longitude: -103.92652,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58621',
  },
  {
    city: 'Belfield',
    county_fips: 38007,
    county_fips_all: '38007|38089|38087',
    county: 'Billings',
    county_names_all: 'Billings|Stark|Slope',
    county_weights: '{"38007": 70.96, "38089": 28.6, "38087": 0.44}',
    density: 1.2,
    imprecise: false,
    latitude: 46.88035,
    longitude: -103.24434,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58622',
  },
  {
    city: 'Bowman',
    county_fips: 38011,
    county_fips_all: '38011|38087|46063',
    county: 'Bowman',
    county_names_all: 'Bowman|Slope|Harding',
    county_weights: '{"38011": 72.6, "38087": 25.46, "46063": 1.94}',
    density: 1.4,
    imprecise: false,
    latitude: 46.16001,
    longitude: -103.42168,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58623',
  },
  {
    city: 'Dodge',
    county_fips: 38025,
    county_fips_all: '38025|38057',
    county: 'Dunn',
    county_names_all: 'Dunn|Mercer',
    county_weights: '{"38025": 72.39, "38057": 27.61}',
    density: 0.9,
    imprecise: false,
    latitude: 47.28146,
    longitude: -102.19748,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58625',
  },
  {
    city: 'Dunn Center',
    county_fips: 38025,
    county_fips_all: '38025',
    county: 'Dunn',
    county_names_all: 'Dunn',
    county_weights: '{"38025": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 47.37739,
    longitude: -102.60575,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58626',
  },
  {
    city: 'Fairfield',
    county_fips: 38007,
    county_fips_all: '38007',
    county: 'Billings',
    county_names_all: 'Billings',
    county_weights: '{"38007": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 47.23532,
    longitude: -103.29713,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58627',
  },
  {
    city: 'Gladstone',
    county_fips: 38089,
    county_fips_all: '38089|38025',
    county: 'Stark',
    county_names_all: 'Stark|Dunn',
    county_weights: '{"38089": 62.3, "38025": 37.7}',
    density: 0.8,
    imprecise: false,
    latitude: 46.91981,
    longitude: -102.57603,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58630',
  },
  {
    city: 'Glen Ullin',
    county_fips: 38059,
    county_fips_all: '38059|38037|38057',
    county: 'Morton',
    county_names_all: 'Morton|Grant|Mercer',
    county_weights: '{"38059": 61.46, "38037": 29.73, "38057": 8.81}',
    density: 1,
    imprecise: false,
    latitude: 46.7969,
    longitude: -101.82156,
    militaryZip: false,
    timezone: 'America/North_Dakota/New_Salem',
    population: 953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58631',
  },
  {
    city: 'Golva',
    county_fips: 38033,
    county_fips_all: '38033',
    county: 'Golden Valley',
    county_names_all: 'Golden Valley',
    county_weights: '{"38033": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 46.68316,
    longitude: -103.95078,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58632',
  },
  {
    city: 'Grassy Butte',
    county_fips: 38053,
    county_fips_all: '38053|38007',
    county: 'McKenzie',
    county_names_all: 'McKenzie|Billings',
    county_weights: '{"38053": 97.61, "38007": 2.39}',
    density: 0.4,
    imprecise: false,
    latitude: 47.43683,
    longitude: -103.35647,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58634',
  },
  {
    city: 'Halliday',
    county_fips: 38025,
    county_fips_all: '38025|38057',
    county: 'Dunn',
    county_names_all: 'Dunn|Mercer',
    county_weights: '{"38025": 94.09, "38057": 5.91}',
    density: 0.9,
    imprecise: false,
    latitude: 47.38924,
    longitude: -102.35351,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58636',
  },
  {
    city: 'Hebron',
    county_fips: 38059,
    county_fips_all: '38059|38057|38089|38037|38025',
    county: 'Morton',
    county_names_all: 'Morton|Mercer|Stark|Grant|Dunn',
    county_weights:
      '{"38059": 42.59, "38057": 30.26, "38089": 16.44, "38037": 6.63, "38025": 4.08}',
    density: 1,
    imprecise: false,
    latitude: 46.92201,
    longitude: -102.04867,
    militaryZip: false,
    timezone: 'America/North_Dakota/New_Salem',
    population: 874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58638',
  },
  {
    city: 'Hettinger',
    county_fips: 38001,
    county_fips_all: '38001|46105',
    county: 'Adams',
    county_names_all: 'Adams|Perkins',
    county_weights: '{"38001": 78.81, "46105": 21.19}',
    density: 1.2,
    imprecise: false,
    latitude: 46.04056,
    longitude: -102.63905,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58639',
  },
  {
    city: 'Killdeer',
    county_fips: 38025,
    county_fips_all: '38025|38007|38053',
    county: 'Dunn',
    county_names_all: 'Dunn|Billings|McKenzie',
    county_weights: '{"38025": 97.96, "38007": 1.18, "38053": 0.86}',
    density: 1.2,
    imprecise: false,
    latitude: 47.44409,
    longitude: -102.89681,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58640',
  },
  {
    city: 'Lefor',
    county_fips: 38089,
    county_fips_all: '38089',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"38089": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 46.66732,
    longitude: -102.48551,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58641',
  },
  {
    city: 'Manning',
    county_fips: 38025,
    county_fips_all: '38025|38007',
    county: 'Dunn',
    county_names_all: 'Dunn|Billings',
    county_weights: '{"38025": 94.63, "38007": 5.37}',
    density: 0.9,
    imprecise: false,
    latitude: 47.20145,
    longitude: -102.83667,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58642',
  },
  {
    city: 'Marmarth',
    county_fips: 38011,
    county_fips_all: '38011|38087',
    county: 'Bowman',
    county_names_all: 'Bowman|Slope',
    county_weights: '{"38011": 70.28, "38087": 29.72}',
    density: 0.3,
    imprecise: false,
    latitude: 46.22974,
    longitude: -103.95091,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58643',
  },
  {
    city: 'Marshall',
    county_fips: 38025,
    county_fips_all: '38025',
    county: 'Dunn',
    county_names_all: 'Dunn',
    county_weights: '{"38025": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 47.14095,
    longitude: -102.35867,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58644',
  },
  {
    city: 'Medora',
    county_fips: 38007,
    county_fips_all: '38007|38033',
    county: 'Billings',
    county_names_all: 'Billings|Golden Valley',
    county_weights: '{"38007": 92.08, "38033": 7.92}',
    density: 0.3,
    imprecise: false,
    latitude: 46.95845,
    longitude: -103.52945,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58645',
  },
  {
    city: 'Mott',
    county_fips: 38041,
    county_fips_all: '38041|38001|38089',
    county: 'Hettinger',
    county_names_all: 'Hettinger|Adams|Stark',
    county_weights: '{"38041": 89.66, "38001": 8.94, "38089": 1.4}',
    density: 0.8,
    imprecise: false,
    latitude: 46.39826,
    longitude: -102.28782,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58646',
  },
  {
    city: 'New England',
    county_fips: 38087,
    county_fips_all: '38087|38041|38089',
    county: 'Slope',
    county_names_all: 'Slope|Hettinger|Stark',
    county_weights: '{"38087": 47.37, "38041": 44.44, "38089": 8.19}',
    density: 0.8,
    imprecise: false,
    latitude: 46.51695,
    longitude: -102.93466,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58647',
  },
  {
    city: 'Reeder',
    county_fips: 38001,
    county_fips_all: '38001|38041|46063|38011|38087',
    county: 'Adams',
    county_names_all: 'Adams|Hettinger|Harding|Bowman|Slope',
    county_weights:
      '{"38001": 72.68, "38041": 11.1, "46063": 9.4, "38011": 4.71, "38087": 2.11}',
    density: 0.5,
    imprecise: false,
    latitude: 46.13762,
    longitude: -102.90857,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58649',
  },
  {
    city: 'Regent',
    county_fips: 38041,
    county_fips_all: '38041|38001',
    county: 'Hettinger',
    county_names_all: 'Hettinger|Adams',
    county_weights: '{"38041": 93.08, "38001": 6.92}',
    density: 0.6,
    imprecise: false,
    latitude: 46.43241,
    longitude: -102.59033,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58650',
  },
  {
    city: 'Rhame',
    county_fips: 38011,
    county_fips_all: '38011|38087',
    county: 'Bowman',
    county_names_all: 'Bowman|Slope',
    county_weights: '{"38011": 55.01, "38087": 44.99}',
    density: 0.3,
    imprecise: false,
    latitude: 46.26201,
    longitude: -103.74228,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58651',
  },
  {
    city: 'Richardton',
    county_fips: 38089,
    county_fips_all: '38089|38025',
    county: 'Stark',
    county_names_all: 'Stark|Dunn',
    county_weights: '{"38089": 72.43, "38025": 27.57}',
    density: 1.2,
    imprecise: false,
    latitude: 46.88854,
    longitude: -102.27037,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58652',
  },
  {
    city: 'Scranton',
    county_fips: 38011,
    county_fips_all: '38011|46063|38087',
    county: 'Bowman',
    county_names_all: 'Bowman|Harding|Slope',
    county_weights: '{"38011": 71.3, "46063": 14.58, "38087": 14.12}',
    density: 0.7,
    imprecise: false,
    latitude: 46.09645,
    longitude: -103.12946,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58653',
  },
  {
    city: 'Sentinel Butte',
    county_fips: 38033,
    county_fips_all: '38033|38087',
    county: 'Golden Valley',
    county_names_all: 'Golden Valley|Slope',
    county_weights: '{"38033": 79.91, "38087": 20.09}',
    density: 0.1,
    imprecise: false,
    latitude: 46.77817,
    longitude: -103.81757,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58654',
  },
  {
    city: 'South Heart',
    county_fips: 38089,
    county_fips_all: '38089',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"38089": 100}',
    density: 2,
    imprecise: false,
    latitude: 46.77921,
    longitude: -103.03163,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58655',
  },
  {
    city: 'Taylor',
    county_fips: 38089,
    county_fips_all: '38089|38025',
    county: 'Stark',
    county_names_all: 'Stark|Dunn',
    county_weights: '{"38089": 63.42, "38025": 36.58}',
    density: 0.8,
    imprecise: false,
    latitude: 46.95207,
    longitude: -102.46801,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58656',
  },
  {
    city: 'Minot',
    county_fips: 38101,
    county_fips_all: '38101',
    county: 'Ward',
    county_names_all: 'Ward',
    county_weights: '{"38101": 100}',
    density: 54.2,
    imprecise: false,
    latitude: 48.14027,
    longitude: -101.32406,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58701',
  },
  {
    city: 'Minot',
    county_fips: 38101,
    county_fips_all: '38101',
    county: 'Ward',
    county_names_all: 'Ward',
    county_weights: '{"38101": 100}',
    density: 54.7,
    imprecise: false,
    latitude: 48.32646,
    longitude: -101.31637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58703',
  },
  {
    city: 'Minot Afb',
    county_fips: 38101,
    county_fips_all: '38101',
    county: 'Ward',
    county_names_all: 'Ward',
    county_weights: '{"38101": 100}',
    density: 376.7,
    imprecise: false,
    latitude: 48.4232,
    longitude: -101.33152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58704',
  },
  {
    city: 'Anamoose',
    county_fips: 38049,
    county_fips_all: '38049|38083|38069',
    county: 'McHenry',
    county_names_all: 'McHenry|Sheridan|Pierce',
    county_weights: '{"38049": 40.06, "38083": 38.32, "38069": 21.63}',
    density: 1,
    imprecise: false,
    latitude: 47.86959,
    longitude: -100.23912,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58710',
  },
  {
    city: 'Antler',
    county_fips: 38009,
    county_fips_all: '38009',
    county: 'Bottineau',
    county_names_all: 'Bottineau',
    county_weights: '{"38009": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 48.93262,
    longitude: -101.2752,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58711',
  },
  {
    city: 'Balfour',
    county_fips: 38049,
    county_fips_all: '38049',
    county: 'McHenry',
    county_names_all: 'McHenry',
    county_weights: '{"38049": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 47.96799,
    longitude: -100.54559,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58712',
  },
  {
    city: 'Bantry',
    county_fips: 38049,
    county_fips_all: '38049',
    county: 'McHenry',
    county_names_all: 'McHenry',
    county_weights: '{"38049": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 48.51876,
    longitude: -100.60497,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58713',
  },
  {
    city: 'Benedict',
    county_fips: 38055,
    county_fips_all: '38055|38101',
    county: 'McLean',
    county_names_all: 'McLean|Ward',
    county_weights: '{"38055": 61.42, "38101": 38.58}',
    density: 1.5,
    imprecise: false,
    latitude: 47.80049,
    longitude: -101.06003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58716',
  },
  {
    city: 'Berthold',
    county_fips: 38101,
    county_fips_all: '38101|38061|38075',
    county: 'Ward',
    county_names_all: 'Ward|Mountrail|Renville',
    county_weights: '{"38101": 63.98, "38061": 31.91, "38075": 4.11}',
    density: 0.8,
    imprecise: false,
    latitude: 48.31128,
    longitude: -101.82989,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58718',
  },
  {
    city: 'Bowbells',
    county_fips: 38013,
    county_fips_all: '38013|38101',
    county: 'Burke',
    county_names_all: 'Burke|Ward',
    county_weights: '{"38013": 94.69, "38101": 5.31}',
    density: 1,
    imprecise: false,
    latitude: 48.82069,
    longitude: -102.25667,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58721',
  },
  {
    city: 'Burlington',
    county_fips: 38101,
    county_fips_all: '38101',
    county: 'Ward',
    county_names_all: 'Ward',
    county_weights: '{"38101": 100}',
    density: 8,
    imprecise: false,
    latitude: 48.25238,
    longitude: -101.50079,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58722',
  },
  {
    city: 'Butte',
    county_fips: 38055,
    county_fips_all: '38055|38083|38049',
    county: 'McLean',
    county_names_all: 'McLean|Sheridan|McHenry',
    county_weights: '{"38055": 54.59, "38083": 44.45, "38049": 0.96}',
    density: 0.5,
    imprecise: false,
    latitude: 47.75433,
    longitude: -100.60281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58723',
  },
  {
    city: 'Carpio',
    county_fips: 38075,
    county_fips_all: '38075|38101',
    county: 'Renville',
    county_names_all: 'Renville|Ward',
    county_weights: '{"38075": 61.1, "38101": 38.9}',
    density: 1.1,
    imprecise: false,
    latitude: 48.48699,
    longitude: -101.68361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58725',
  },
  {
    city: 'Columbus',
    county_fips: 38013,
    county_fips_all: '38013',
    county: 'Burke',
    county_names_all: 'Burke',
    county_weights: '{"38013": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.85542,
    longitude: -102.80479,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58727',
  },
  {
    city: 'Crosby',
    county_fips: 38023,
    county_fips_all: '38023',
    county: 'Divide',
    county_names_all: 'Divide',
    county_weights: '{"38023": 100}',
    density: 2,
    imprecise: false,
    latitude: 48.86171,
    longitude: -103.30652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58730',
  },
  {
    city: 'Deering',
    county_fips: 38049,
    county_fips_all: '38049|38101',
    county: 'McHenry',
    county_names_all: 'McHenry|Ward',
    county_weights: '{"38049": 89.97, "38101": 10.03}',
    density: 1,
    imprecise: false,
    latitude: 48.44752,
    longitude: -100.98029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58731',
  },
  {
    city: 'Des Lacs',
    county_fips: 38101,
    county_fips_all: '38101',
    county: 'Ward',
    county_names_all: 'Ward',
    county_weights: '{"38101": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 48.16911,
    longitude: -101.59463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58733',
  },
  {
    city: 'Donnybrook',
    county_fips: 38101,
    county_fips_all: '38101|38061|38075',
    county: 'Ward',
    county_names_all: 'Ward|Mountrail|Renville',
    county_weights: '{"38101": 41.04, "38061": 37.58, "38075": 21.38}',
    density: 0.4,
    imprecise: false,
    latitude: 48.51508,
    longitude: -101.95757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58734',
  },
  {
    city: 'Douglas',
    county_fips: 38101,
    county_fips_all: '38101|38055',
    county: 'Ward',
    county_names_all: 'Ward|McLean',
    county_weights: '{"38101": 59.86, "38055": 40.14}',
    density: 1.1,
    imprecise: false,
    latitude: 47.87771,
    longitude: -101.48366,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58735',
  },
  {
    city: 'Drake',
    county_fips: 38049,
    county_fips_all: '38049|38083',
    county: 'McHenry',
    county_names_all: 'McHenry|Sheridan',
    county_weights: '{"38049": 72.86, "38083": 27.14}',
    density: 1.1,
    imprecise: false,
    latitude: 47.92804,
    longitude: -100.38732,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58736',
  },
  {
    city: 'Flaxton',
    county_fips: 38013,
    county_fips_all: '38013',
    county: 'Burke',
    county_names_all: 'Burke',
    county_weights: '{"38013": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.90743,
    longitude: -102.39392,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58737',
  },
  {
    city: 'Glenburn',
    county_fips: 38075,
    county_fips_all: '38075|38101|38009|38049',
    county: 'Renville',
    county_names_all: 'Renville|Ward|Bottineau|McHenry',
    county_weights:
      '{"38075": 58.3, "38101": 37.01, "38009": 2.38, "38049": 2.31}',
    density: 1.5,
    imprecise: false,
    latitude: 48.4711,
    longitude: -101.22744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58740',
  },
  {
    city: 'Granville',
    county_fips: 38049,
    county_fips_all: '38049',
    county: 'McHenry',
    county_names_all: 'McHenry',
    county_weights: '{"38049": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 48.27336,
    longitude: -100.83352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58741',
  },
  {
    city: 'Karlsruhe',
    county_fips: 38049,
    county_fips_all: '38049',
    county: 'McHenry',
    county_names_all: 'McHenry',
    county_weights: '{"38049": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 48.12073,
    longitude: -100.58774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58744',
  },
  {
    city: 'Kenmare',
    county_fips: 38101,
    county_fips_all: '38101|38013|38075',
    county: 'Ward',
    county_names_all: 'Ward|Burke|Renville',
    county_weights: '{"38101": 46.76, "38013": 33.79, "38075": 19.45}',
    density: 1.3,
    imprecise: false,
    latitude: 48.71921,
    longitude: -102.10115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58746',
  },
  {
    city: 'Kramer',
    county_fips: 38009,
    county_fips_all: '38009|38049',
    county: 'Bottineau',
    county_names_all: 'Bottineau|McHenry',
    county_weights: '{"38009": 78.81, "38049": 21.19}',
    density: 0.5,
    imprecise: false,
    latitude: 48.66895,
    longitude: -100.64487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58748',
  },
  {
    city: 'Lansford',
    county_fips: 38009,
    county_fips_all: '38009|38075',
    county: 'Bottineau',
    county_names_all: 'Bottineau|Renville',
    county_weights: '{"38009": 59.97, "38075": 40.03}',
    density: 1,
    imprecise: false,
    latitude: 48.6166,
    longitude: -101.39941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58750',
  },
  {
    city: 'Lignite',
    county_fips: 38013,
    county_fips_all: '38013',
    county: 'Burke',
    county_names_all: 'Burke',
    county_weights: '{"38013": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 48.82146,
    longitude: -102.59927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58752',
  },
  {
    city: 'Mcgregor',
    county_fips: 38105,
    county_fips_all: '38105|38023|38013',
    county: 'Williams',
    county_names_all: 'Williams|Divide|Burke',
    county_weights: '{"38105": 43.89, "38023": 43.04, "38013": 13.07}',
    density: 0.6,
    imprecise: false,
    latitude: 48.62857,
    longitude: -102.94666,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58755',
  },
  {
    city: 'Makoti',
    county_fips: 38101,
    county_fips_all: '38101|38061|38055',
    county: 'Ward',
    county_names_all: 'Ward|Mountrail|McLean',
    county_weights: '{"38101": 75.41, "38061": 20.87, "38055": 3.72}',
    density: 0.6,
    imprecise: false,
    latitude: 47.96746,
    longitude: -101.81431,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58756',
  },
  {
    city: 'Mandaree',
    county_fips: 38025,
    county_fips_all: '38025|38053',
    county: 'Dunn',
    county_names_all: 'Dunn|McKenzie',
    county_weights: '{"38025": 82.01, "38053": 17.99}',
    density: 1.1,
    imprecise: false,
    latitude: 47.67643,
    longitude: -102.54685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58757',
  },
  {
    city: 'Martin',
    county_fips: 38083,
    county_fips_all: '38083|38103|38069',
    county: 'Sheridan',
    county_names_all: 'Sheridan|Wells|Pierce',
    county_weights: '{"38083": 67.53, "38103": 17.32, "38069": 15.15}',
    density: 1,
    imprecise: false,
    latitude: 47.76643,
    longitude: -100.10424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58758',
  },
  {
    city: 'Max',
    county_fips: 38055,
    county_fips_all: '38055|38101',
    county: 'McLean',
    county_names_all: 'McLean|Ward',
    county_weights: '{"38055": 52.87, "38101": 47.13}',
    density: 1.2,
    imprecise: false,
    latitude: 47.84776,
    longitude: -101.25026,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58759',
  },
  {
    city: 'Maxbass',
    county_fips: 38009,
    county_fips_all: '38009',
    county: 'Bottineau',
    county_names_all: 'Bottineau',
    county_weights: '{"38009": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 48.69854,
    longitude: -101.14158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58760',
  },
  {
    city: 'Mohall',
    county_fips: 38075,
    county_fips_all: '38075|38009',
    county: 'Renville',
    county_names_all: 'Renville|Bottineau',
    county_weights: '{"38075": 60.46, "38009": 39.54}',
    density: 1.2,
    imprecise: false,
    latitude: 48.78736,
    longitude: -101.53019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58761',
  },
  {
    city: 'Newburg',
    county_fips: 38009,
    county_fips_all: '38009|38049',
    county: 'Bottineau',
    county_names_all: 'Bottineau|McHenry',
    county_weights: '{"38009": 76.85, "38049": 23.15}',
    density: 0.8,
    imprecise: false,
    latitude: 48.67409,
    longitude: -100.94225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58762',
  },
  {
    city: 'New Town',
    county_fips: 38061,
    county_fips_all: '38061|38053',
    county: 'Mountrail',
    county_names_all: 'Mountrail|McKenzie',
    county_weights: '{"38061": 61.28, "38053": 38.72}',
    density: 3.2,
    imprecise: false,
    latitude: 47.98362,
    longitude: -102.58401,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58763',
  },
  {
    city: 'Noonan',
    county_fips: 38023,
    county_fips_all: '38023',
    county: 'Divide',
    county_names_all: 'Divide',
    county_weights: '{"38023": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 48.87261,
    longitude: -103.03805,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58765',
  },
  {
    city: 'Norwich',
    county_fips: 38049,
    county_fips_all: '38049|38101',
    county: 'McHenry',
    county_names_all: 'McHenry|Ward',
    county_weights: '{"38049": 50.06, "38101": 49.94}',
    density: 1.2,
    imprecise: false,
    latitude: 48.25115,
    longitude: -101.01456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58768',
  },
  {
    city: 'Palermo',
    county_fips: 38061,
    county_fips_all: '38061',
    county: 'Mountrail',
    county_names_all: 'Mountrail',
    county_weights: '{"38061": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.30082,
    longitude: -102.22721,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58769',
  },
  {
    city: 'Parshall',
    county_fips: 38061,
    county_fips_all: '38061|38055',
    county: 'Mountrail',
    county_names_all: 'Mountrail|McLean',
    county_weights: '{"38061": 55.27, "38055": 44.73}',
    density: 2,
    imprecise: false,
    latitude: 47.86531,
    longitude: -102.16251,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58770',
  },
  {
    city: 'Plaza',
    county_fips: 38061,
    county_fips_all: '38061|38101|38055',
    county: 'Mountrail',
    county_names_all: 'Mountrail|Ward|McLean',
    county_weights: '{"38061": 76.19, "38101": 20.52, "38055": 3.29}',
    density: 0.9,
    imprecise: false,
    latitude: 48.08711,
    longitude: -101.98534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58771',
  },
  {
    city: 'Portal',
    county_fips: 38013,
    county_fips_all: '38013',
    county: 'Burke',
    county_names_all: 'Burke',
    county_weights: '{"38013": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 48.96035,
    longitude: -102.61236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58772',
  },
  {
    city: 'Powers Lake',
    county_fips: 38013,
    county_fips_all: '38013|38061',
    county: 'Burke',
    county_names_all: 'Burke|Mountrail',
    county_weights: '{"38013": 68.91, "38061": 31.09}',
    density: 1.3,
    imprecise: false,
    latitude: 48.58631,
    longitude: -102.66852,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58773',
  },
  {
    city: 'Roseglen',
    county_fips: 38055,
    county_fips_all: '38055',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"38055": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 47.71424,
    longitude: -101.85203,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58775',
  },
  {
    city: 'Ross',
    county_fips: 38061,
    county_fips_all: '38061',
    county: 'Mountrail',
    county_names_all: 'Mountrail',
    county_weights: '{"38061": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 48.25079,
    longitude: -102.61543,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58776',
  },
  {
    city: 'Ruso',
    county_fips: 38055,
    county_fips_all: '38055|38049',
    county: 'McLean',
    county_names_all: 'McLean|McHenry',
    county_weights: '{"38055": 92.19, "38049": 7.81}',
    density: 0.6,
    imprecise: false,
    latitude: 47.78307,
    longitude: -100.91268,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58778',
  },
  {
    city: 'Ryder',
    county_fips: 38055,
    county_fips_all: '38055|38101',
    county: 'McLean',
    county_names_all: 'McLean|Ward',
    county_weights: '{"38055": 53.27, "38101": 46.73}',
    density: 0.5,
    imprecise: false,
    latitude: 47.85507,
    longitude: -101.7621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58779',
  },
  {
    city: 'Sawyer',
    county_fips: 38101,
    county_fips_all: '38101',
    county: 'Ward',
    county_names_all: 'Ward',
    county_weights: '{"38101": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 48.02451,
    longitude: -101.13468,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58781',
  },
  {
    city: 'Sherwood',
    county_fips: 38075,
    county_fips_all: '38075|38009',
    county: 'Renville',
    county_names_all: 'Renville|Bottineau',
    county_weights: '{"38075": 92.68, "38009": 7.32}',
    density: 1,
    imprecise: false,
    latitude: 48.94055,
    longitude: -101.71325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58782',
  },
  {
    city: 'Souris',
    county_fips: 38009,
    county_fips_all: '38009',
    county: 'Bottineau',
    county_names_all: 'Bottineau',
    county_weights: '{"38009": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 48.88375,
    longitude: -100.75035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58783',
  },
  {
    city: 'Stanley',
    county_fips: 38061,
    county_fips_all: '38061|38013',
    county: 'Mountrail',
    county_names_all: 'Mountrail|Burke',
    county_weights: '{"38061": 89.78, "38013": 10.22}',
    density: 3,
    imprecise: false,
    latitude: 48.36212,
    longitude: -102.42273,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58784',
  },
  {
    city: 'Surrey',
    county_fips: 38101,
    county_fips_all: '38101',
    county: 'Ward',
    county_names_all: 'Ward',
    county_weights: '{"38101": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 48.31121,
    longitude: -101.09706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58785',
  },
  {
    city: 'Tolley',
    county_fips: 38075,
    county_fips_all: '38075',
    county: 'Renville',
    county_names_all: 'Renville',
    county_weights: '{"38075": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.76057,
    longitude: -101.80832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58787',
  },
  {
    city: 'Towner',
    county_fips: 38049,
    county_fips_all: '38049|38069',
    county: 'McHenry',
    county_names_all: 'McHenry|Pierce',
    county_weights: '{"38049": 96.88, "38069": 3.12}',
    density: 0.7,
    imprecise: false,
    latitude: 48.33198,
    longitude: -100.48045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58788',
  },
  {
    city: 'Upham',
    county_fips: 38049,
    county_fips_all: '38049|38009',
    county: 'McHenry',
    county_names_all: 'McHenry|Bottineau',
    county_weights: '{"38049": 90.31, "38009": 9.69}',
    density: 1.1,
    imprecise: false,
    latitude: 48.54778,
    longitude: -100.81898,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58789',
  },
  {
    city: 'Velva',
    county_fips: 38049,
    county_fips_all: '38049|38101',
    county: 'McHenry',
    county_names_all: 'McHenry|Ward',
    county_weights: '{"38049": 78.72, "38101": 21.28}',
    density: 3.4,
    imprecise: false,
    latitude: 48.03071,
    longitude: -100.93952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58790',
  },
  {
    city: 'Voltaire',
    county_fips: 38049,
    county_fips_all: '38049',
    county: 'McHenry',
    county_names_all: 'McHenry',
    county_weights: '{"38049": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 47.97385,
    longitude: -100.7424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58792',
  },
  {
    city: 'Westhope',
    county_fips: 38009,
    county_fips_all: '38009',
    county: 'Bottineau',
    county_names_all: 'Bottineau',
    county_weights: '{"38009": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 48.86442,
    longitude: -101.05424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58793',
  },
  {
    city: 'White Earth',
    county_fips: 38061,
    county_fips_all: '38061',
    county: 'Mountrail',
    county_names_all: 'Mountrail',
    county_weights: '{"38061": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 48.25916,
    longitude: -102.76683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58794',
  },
  {
    city: 'Wildrose',
    county_fips: 38023,
    county_fips_all: '38023|38105',
    county: 'Divide',
    county_names_all: 'Divide|Williams',
    county_weights: '{"38023": 53.85, "38105": 46.15}',
    density: 0.9,
    imprecise: false,
    latitude: 48.64198,
    longitude: -103.15094,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58795',
  },
  {
    city: 'Williston',
    county_fips: 38105,
    county_fips_all: '38105',
    county: 'Williams',
    county_names_all: 'Williams',
    county_weights: '{"38105": 100}',
    density: 18.5,
    imprecise: false,
    latitude: 48.23522,
    longitude: -103.76747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58801',
  },
  {
    city: 'Alamo',
    county_fips: 38105,
    county_fips_all: '38105|38023',
    county: 'Williams',
    county_names_all: 'Williams|Divide',
    county_weights: '{"38105": 59.81, "38023": 40.19}',
    density: 0.1,
    imprecise: false,
    latitude: 48.60272,
    longitude: -103.46608,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58830',
  },
  {
    city: 'Alexander',
    county_fips: 38053,
    county_fips_all: '38053',
    county: 'McKenzie',
    county_names_all: 'McKenzie',
    county_weights: '{"38053": 100}',
    density: 1,
    imprecise: false,
    latitude: 47.84878,
    longitude: -103.65843,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58831',
  },
  {
    city: 'Ambrose',
    county_fips: 38023,
    county_fips_all: '38023',
    county: 'Divide',
    county_names_all: 'Divide',
    county_weights: '{"38023": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.89186,
    longitude: -103.52517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 67,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58833',
  },
  {
    city: 'Arnegard',
    county_fips: 38053,
    county_fips_all: '38053',
    county: 'McKenzie',
    county_names_all: 'McKenzie',
    county_weights: '{"38053": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 47.7328,
    longitude: -103.45268,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58835',
  },
  {
    city: 'Cartwright',
    county_fips: 38053,
    county_fips_all: '38053',
    county: 'McKenzie',
    county_names_all: 'McKenzie',
    county_weights: '{"38053": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 47.7721,
    longitude: -103.90289,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58838',
  },
  {
    city: 'Epping',
    county_fips: 38105,
    county_fips_all: '38105',
    county: 'Williams',
    county_names_all: 'Williams',
    county_weights: '{"38105": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 48.23141,
    longitude: -103.38142,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58843',
  },
  {
    city: 'Fortuna',
    county_fips: 38023,
    county_fips_all: '38023',
    county: 'Divide',
    county_names_all: 'Divide',
    county_weights: '{"38023": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.89167,
    longitude: -103.74304,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58844',
  },
  {
    city: 'Grenora',
    county_fips: 38105,
    county_fips_all: '38105|38023',
    county: 'Williams',
    county_names_all: 'Williams|Divide',
    county_weights: '{"38105": 50.29, "38023": 49.71}',
    density: 0.9,
    imprecise: false,
    latitude: 48.63928,
    longitude: -103.92207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58845',
  },
  {
    city: 'Keene',
    county_fips: 38053,
    county_fips_all: '38053',
    county: 'McKenzie',
    county_names_all: 'McKenzie',
    county_weights: '{"38053": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 47.89012,
    longitude: -102.90094,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58847',
  },
  {
    city: 'Ray',
    county_fips: 38105,
    county_fips_all: '38105',
    county: 'Williams',
    county_names_all: 'Williams',
    county_weights: '{"38105": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 48.30906,
    longitude: -103.15697,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58849',
  },
  {
    city: 'Tioga',
    county_fips: 38105,
    county_fips_all: '38105|38061',
    county: 'Williams',
    county_names_all: 'Williams|Mountrail',
    county_weights: '{"38105": 78.94, "38061": 21.06}',
    density: 2.6,
    imprecise: false,
    latitude: 48.38037,
    longitude: -102.93276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58852',
  },
  {
    city: 'Trenton',
    county_fips: 38105,
    county_fips_all: '38105',
    county: 'Williams',
    county_names_all: 'Williams',
    county_weights: '{"38105": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 48.06237,
    longitude: -103.78588,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58853',
  },
  {
    city: 'Watford City',
    county_fips: 38053,
    county_fips_all: '38053|38025',
    county: 'McKenzie',
    county_names_all: 'McKenzie|Dunn',
    county_weights: '{"38053": 92.35, "38025": 7.65}',
    density: 5.4,
    imprecise: false,
    latitude: 47.81412,
    longitude: -103.15229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58854',
  },
  {
    city: 'Zahl',
    county_fips: 38105,
    county_fips_all: '38105|38023',
    county: 'Williams',
    county_names_all: 'Williams|Divide',
    county_weights: '{"38105": 66.32, "38023": 33.68}',
    density: 0.4,
    imprecise: false,
    latitude: 48.59123,
    longitude: -103.72546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58856',
  },
  {
    city: 'Absarokee',
    county_fips: 30095,
    county_fips_all: '30095|30009',
    county: 'Stillwater',
    county_names_all: 'Stillwater|Carbon',
    county_weights: '{"30095": 94.29, "30009": 5.71}',
    density: 3.8,
    imprecise: false,
    latitude: 45.52952,
    longitude: -109.54022,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59001',
  },
  {
    city: 'Acton',
    county_fips: 30111,
    county_fips_all: '30111',
    county: 'Yellowstone',
    county_names_all: 'Yellowstone',
    county_weights: '{"30111": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 45.99832,
    longitude: -108.6649,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59002',
  },
  {
    city: 'Ashland',
    county_fips: 30075,
    county_fips_all: '30075|30087',
    county: 'Powder River',
    county_names_all: 'Powder River|Rosebud',
    county_weights: '{"30075": 61.44, "30087": 38.56}',
    density: 0.7,
    imprecise: false,
    latitude: 45.48179,
    longitude: -106.20153,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59003',
  },
  {
    city: 'Ballantine',
    county_fips: 30111,
    county_fips_all: '30111',
    county: 'Yellowstone',
    county_names_all: 'Yellowstone',
    county_weights: '{"30111": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 45.90755,
    longitude: -108.08535,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59006',
  },
  {
    city: 'Bearcreek',
    county_fips: 30009,
    county_fips_all: '30009',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"30009": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 45.15555,
    longitude: -109.15805,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59007',
  },
  {
    city: 'Belfry',
    county_fips: 30009,
    county_fips_all: '30009',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"30009": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 45.07982,
    longitude: -109.07496,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59008',
  },
  {
    city: 'Bighorn',
    county_fips: 30103,
    county_fips_all: '30103|30003',
    county: 'Treasure',
    county_names_all: 'Treasure|Big Horn',
    county_weights: '{"30103": 54.95, "30003": 45.05}',
    density: 0.2,
    imprecise: false,
    latitude: 45.97505,
    longitude: -107.3037,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59010',
  },
  {
    city: 'Big Timber',
    county_fips: 30097,
    county_fips_all: '30097',
    county: 'Sweet Grass',
    county_names_all: 'Sweet Grass',
    county_weights: '{"30097": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 45.92453,
    longitude: -109.97244,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59011',
  },
  {
    city: 'Birney',
    county_fips: 30087,
    county_fips_all: '30087',
    county: 'Rosebud',
    county_names_all: 'Rosebud',
    county_weights: '{"30087": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 45.29922,
    longitude: -106.6006,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59012',
  },
  {
    city: 'Boyd',
    county_fips: 30009,
    county_fips_all: '30009',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"30009": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 45.46131,
    longitude: -109.08054,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59013',
  },
  {
    city: 'Bridger',
    county_fips: 30009,
    county_fips_all: '30009',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"30009": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 45.15351,
    longitude: -108.66421,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59014',
  },
  {
    city: 'Broadview',
    county_fips: 30111,
    county_fips_all: '30111|30095|30065',
    county: 'Yellowstone',
    county_names_all: 'Yellowstone|Stillwater|Musselshell',
    county_weights: '{"30111": 51.75, "30095": 28.84, "30065": 19.41}',
    density: 0.6,
    imprecise: false,
    latitude: 46.08464,
    longitude: -108.83464,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59015',
  },
  {
    city: 'Busby',
    county_fips: 30003,
    county_fips_all: '30003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"30003": 100}',
    density: 1,
    imprecise: false,
    latitude: 45.41871,
    longitude: -106.93872,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59016',
  },
  {
    city: 'Clyde Park',
    county_fips: 30067,
    county_fips_all: '30067',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"30067": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 45.85791,
    longitude: -110.62326,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59018',
  },
  {
    city: 'Columbus',
    county_fips: 30095,
    county_fips_all: '30095|30009',
    county: 'Stillwater',
    county_names_all: 'Stillwater|Carbon',
    county_weights: '{"30095": 97.83, "30009": 2.17}',
    density: 5.6,
    imprecise: false,
    latitude: 45.62995,
    longitude: -109.24208,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59019',
  },
  {
    city: 'Cooke City',
    county_fips: 30067,
    county_fips_all: '30067',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"30067": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.08831,
    longitude: -110.01499,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59020',
  },
  {
    city: 'Crow Agency',
    county_fips: 30003,
    county_fips_all: '30003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"30003": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 45.57541,
    longitude: -107.26756,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59022',
  },
  {
    city: 'Custer',
    county_fips: 30111,
    county_fips_all: '30111|30003',
    county: 'Yellowstone',
    county_names_all: 'Yellowstone|Big Horn',
    county_weights: '{"30111": 92.12, "30003": 7.88}',
    density: 0.3,
    imprecise: false,
    latitude: 46.20549,
    longitude: -107.71464,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59024',
  },
  {
    city: 'Decker',
    county_fips: 30003,
    county_fips_all: '30003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"30003": 100}',
    density: 0,
    imprecise: false,
    latitude: 45.09503,
    longitude: -106.7178,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 53,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59025',
  },
  {
    city: 'Edgar',
    county_fips: 30009,
    county_fips_all: '30009',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"30009": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 45.46385,
    longitude: -108.78392,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59026',
  },
  {
    city: 'Emigrant',
    county_fips: 30067,
    county_fips_all: '30067',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"30067": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 45.26118,
    longitude: -110.90674,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59027',
  },
  {
    city: 'Fishtail',
    county_fips: 30095,
    county_fips_all: '30095',
    county: 'Stillwater',
    county_names_all: 'Stillwater',
    county_weights: '{"30095": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 45.32093,
    longitude: -109.7434,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59028',
  },
  {
    city: 'Fromberg',
    county_fips: 30009,
    county_fips_all: '30009',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"30009": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 45.4085,
    longitude: -108.80467,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59029',
  },
  {
    city: 'Gardiner',
    county_fips: 30067,
    county_fips_all: '30067',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"30067": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 45.08882,
    longitude: -110.59376,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59030',
  },
  {
    city: 'Garryowen',
    county_fips: 30003,
    county_fips_all: '30003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"30003": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 45.50005,
    longitude: -107.37964,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59031',
  },
  {
    city: 'Grass Range',
    county_fips: 30027,
    county_fips_all: '30027|30069',
    county: 'Fergus',
    county_names_all: 'Fergus|Petroleum',
    county_weights: '{"30027": 76.55, "30069": 23.45}',
    density: 0.3,
    imprecise: false,
    latitude: 47.0106,
    longitude: -108.75808,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59032',
  },
  {
    city: 'Greycliff',
    county_fips: 30097,
    county_fips_all: '30097',
    county: 'Sweet Grass',
    county_names_all: 'Sweet Grass',
    county_weights: '{"30097": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 45.72296,
    longitude: -109.73246,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59033',
  },
  {
    city: 'Hardin',
    county_fips: 30003,
    county_fips_all: '30003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"30003": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 45.70121,
    longitude: -107.7078,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59034',
  },
  {
    city: 'Fort Smith',
    county_fips: 30003,
    county_fips_all: '30003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"30003": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 45.29814,
    longitude: -107.96042,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59035',
  },
  {
    city: 'Harlowton',
    county_fips: 30107,
    county_fips_all: '30107',
    county: 'Wheatland',
    county_names_all: 'Wheatland',
    county_weights: '{"30107": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 46.46606,
    longitude: -109.89035,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59036',
  },
  {
    city: 'Huntley',
    county_fips: 30111,
    county_fips_all: '30111|30003',
    county: 'Yellowstone',
    county_names_all: 'Yellowstone|Big Horn',
    county_weights: '{"30111": 92.76, "30003": 7.24}',
    density: 7.3,
    imprecise: false,
    latitude: 45.852,
    longitude: -108.20927,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59037',
  },
  {
    city: 'Hysham',
    county_fips: 30103,
    county_fips_all: '30103|30003',
    county: 'Treasure',
    county_names_all: 'Treasure|Big Horn',
    county_weights: '{"30103": 87.24, "30003": 12.76}',
    density: 0.3,
    imprecise: false,
    latitude: 46.18917,
    longitude: -107.23069,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59038',
  },
  {
    city: 'Ingomar',
    county_fips: 30087,
    county_fips_all: '30087',
    county: 'Rosebud',
    county_names_all: 'Rosebud',
    county_weights: '{"30087": 100}',
    density: 0,
    imprecise: false,
    latitude: 46.68533,
    longitude: -107.28458,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 13,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59039',
  },
  {
    city: 'Joliet',
    county_fips: 30009,
    county_fips_all: '30009|30111',
    county: 'Carbon',
    county_names_all: 'Carbon|Yellowstone',
    county_weights: '{"30009": 97.37, "30111": 2.63}',
    density: 4.6,
    imprecise: false,
    latitude: 45.50239,
    longitude: -108.9663,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59041',
  },
  {
    city: 'Lame Deer',
    county_fips: 30087,
    county_fips_all: '30087|30003',
    county: 'Rosebud',
    county_names_all: 'Rosebud|Big Horn',
    county_weights: '{"30087": 70.0, "30003": 30.0}',
    density: 3.1,
    imprecise: false,
    latitude: 45.53266,
    longitude: -106.6568,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59043',
  },
  {
    city: 'Laurel',
    county_fips: 30111,
    county_fips_all: '30111|30009',
    county: 'Yellowstone',
    county_names_all: 'Yellowstone|Carbon',
    county_weights: '{"30111": 91.0, "30009": 9.0}',
    density: 27.1,
    imprecise: false,
    latitude: 45.64251,
    longitude: -108.74975,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59044',
  },
  {
    city: 'Lavina',
    county_fips: 30037,
    county_fips_all: '30037|30065',
    county: 'Golden Valley',
    county_names_all: 'Golden Valley|Musselshell',
    county_weights: '{"30037": 91.74, "30065": 8.26}',
    density: 0.4,
    imprecise: false,
    latitude: 46.39147,
    longitude: -108.98604,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59046',
  },
  {
    city: 'Livingston',
    county_fips: 30067,
    county_fips_all: '30067',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"30067": 100}',
    density: 7,
    imprecise: false,
    latitude: 45.56852,
    longitude: -110.55174,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 14092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59047',
  },
  {
    city: 'Lodge Grass',
    county_fips: 30003,
    county_fips_all: '30003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"30003": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 45.25013,
    longitude: -107.47849,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59050',
  },
  {
    city: 'McLeod',
    county_fips: 30097,
    county_fips_all: '30097|30067',
    county: 'Sweet Grass',
    county_names_all: 'Sweet Grass|Park',
    county_weights: '{"30097": 58.83, "30067": 41.17}',
    density: 0.1,
    imprecise: false,
    latitude: 45.43651,
    longitude: -110.18676,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59052',
  },
  {
    city: 'Martinsdale',
    county_fips: 30059,
    county_fips_all: '30059|30107',
    county: 'Meagher',
    county_names_all: 'Meagher|Wheatland',
    county_weights: '{"30059": 96.81, "30107": 3.19}',
    density: 0.3,
    imprecise: false,
    latitude: 46.45713,
    longitude: -110.43492,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59053',
  },
  {
    city: 'Melstone',
    county_fips: 30087,
    county_fips_all: '30087|30065',
    county: 'Rosebud',
    county_names_all: 'Rosebud|Musselshell',
    county_weights: '{"30087": 57.73, "30065": 42.27}',
    density: 0.2,
    imprecise: false,
    latitude: 46.66809,
    longitude: -107.7691,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59054',
  },
  {
    city: 'Melville',
    county_fips: 30097,
    county_fips_all: '30097',
    county: 'Sweet Grass',
    county_names_all: 'Sweet Grass',
    county_weights: '{"30097": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 46.10282,
    longitude: -109.78662,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 40,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59055',
  },
  {
    city: 'Molt',
    county_fips: 30095,
    county_fips_all: '30095|30111',
    county: 'Stillwater',
    county_names_all: 'Stillwater|Yellowstone',
    county_weights: '{"30095": 68.46, "30111": 31.54}',
    density: 1.1,
    imprecise: false,
    latitude: 45.85358,
    longitude: -108.95377,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59057',
  },
  {
    city: 'Mosby',
    county_fips: 30033,
    county_fips_all: '30033|30069',
    county: 'Garfield',
    county_names_all: 'Garfield|Petroleum',
    county_weights: '{"30033": 74.43, "30069": 25.57}',
    density: 0,
    imprecise: false,
    latitude: 46.98517,
    longitude: -107.79652,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59058',
  },
  {
    city: 'Musselshell',
    county_fips: 30065,
    county_fips_all: '30065',
    county: 'Musselshell',
    county_names_all: 'Musselshell',
    county_weights: '{"30065": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 46.51161,
    longitude: -108.088,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59059',
  },
  {
    city: 'Nye',
    county_fips: 30095,
    county_fips_all: '30095',
    county: 'Stillwater',
    county_names_all: 'Stillwater',
    county_weights: '{"30095": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 45.39634,
    longitude: -109.87728,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59061',
  },
  {
    city: 'Otter',
    county_fips: 30075,
    county_fips_all: '30075|30087',
    county: 'Powder River',
    county_names_all: 'Powder River|Rosebud',
    county_weights: '{"30075": 69.03, "30087": 30.97}',
    density: 0.1,
    imprecise: false,
    latitude: 45.15773,
    longitude: -106.20895,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59062',
  },
  {
    city: 'Park City',
    county_fips: 30095,
    county_fips_all: '30095|30111',
    county: 'Stillwater',
    county_names_all: 'Stillwater|Yellowstone',
    county_weights: '{"30095": 99.5, "30111": 0.5}',
    density: 13.1,
    imprecise: false,
    latitude: 45.65079,
    longitude: -108.97028,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59063',
  },
  {
    city: 'Pompeys Pillar',
    county_fips: 30003,
    county_fips_all: '30003|30111',
    county: 'Big Horn',
    county_names_all: 'Big Horn|Yellowstone',
    county_weights: '{"30003": 71.23, "30111": 28.77}',
    density: 0.4,
    imprecise: false,
    latitude: 45.88011,
    longitude: -107.87245,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59064',
  },
  {
    city: 'Pray',
    county_fips: 30067,
    county_fips_all: '30067',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"30067": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 45.26883,
    longitude: -110.6784,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59065',
  },
  {
    city: 'Pryor',
    county_fips: 30003,
    county_fips_all: '30003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"30003": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 45.33907,
    longitude: -108.49718,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59066',
  },
  {
    city: 'Rapelje',
    county_fips: 30095,
    county_fips_all: '30095',
    county: 'Stillwater',
    county_names_all: 'Stillwater',
    county_weights: '{"30095": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.96827,
    longitude: -109.23433,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59067',
  },
  {
    city: 'Red Lodge',
    county_fips: 30009,
    county_fips_all: '30009',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"30009": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 45.15929,
    longitude: -109.45626,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59068',
  },
  {
    city: 'Reed Point',
    county_fips: 30095,
    county_fips_all: '30095|30097',
    county: 'Stillwater',
    county_names_all: 'Stillwater|Sweet Grass',
    county_weights: '{"30095": 50.66, "30097": 49.34}',
    density: 0.4,
    imprecise: false,
    latitude: 45.72204,
    longitude: -109.57945,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59069',
  },
  {
    city: 'Roberts',
    county_fips: 30009,
    county_fips_all: '30009',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"30009": 100}',
    density: 3,
    imprecise: false,
    latitude: 45.36289,
    longitude: -109.17961,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59070',
  },
  {
    city: 'Roscoe',
    county_fips: 30009,
    county_fips_all: '30009',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"30009": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.26582,
    longitude: -109.57003,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59071',
  },
  {
    city: 'Roundup',
    county_fips: 30065,
    county_fips_all: '30065|30069',
    county: 'Musselshell',
    county_names_all: 'Musselshell|Petroleum',
    county_weights: '{"30065": 93.07, "30069": 6.93}',
    density: 1.4,
    imprecise: false,
    latitude: 46.51839,
    longitude: -108.54969,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59072',
  },
  {
    city: 'Ryegate',
    county_fips: 30037,
    county_fips_all: '30037|30095|30107',
    county: 'Golden Valley',
    county_names_all: 'Golden Valley|Stillwater|Wheatland',
    county_weights: '{"30037": 91.48, "30095": 6.76, "30107": 1.76}',
    density: 0.3,
    imprecise: false,
    latitude: 46.36062,
    longitude: -109.30181,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59074',
  },
  {
    city: 'Saint Xavier',
    county_fips: 30003,
    county_fips_all: '30003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"30003": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.40457,
    longitude: -107.85051,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59075',
  },
  {
    city: 'Sanders',
    county_fips: 30103,
    county_fips_all: '30103',
    county: 'Treasure',
    county_names_all: 'Treasure',
    county_weights: '{"30103": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 46.28252,
    longitude: -107.06847,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59076',
  },
  {
    city: 'Sand Springs',
    county_fips: 30033,
    county_fips_all: '30033',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"30033": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 47.22224,
    longitude: -107.58999,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59077',
  },
  {
    city: 'Shawmut',
    county_fips: 30107,
    county_fips_all: '30107|30037|30097',
    county: 'Wheatland',
    county_names_all: 'Wheatland|Golden Valley|Sweet Grass',
    county_weights: '{"30107": 69.81, "30037": 22.1, "30097": 8.09}',
    density: 0.2,
    imprecise: false,
    latitude: 46.32585,
    longitude: -109.5442,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59078',
  },
  {
    city: 'Shepherd',
    county_fips: 30111,
    county_fips_all: '30111',
    county: 'Yellowstone',
    county_names_all: 'Yellowstone',
    county_weights: '{"30111": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 46.0607,
    longitude: -108.36718,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59079',
  },
  {
    city: 'Silver Gate',
    county_fips: 30067,
    county_fips_all: '30067',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"30067": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 45.01979,
    longitude: -109.98295,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59081',
  },
  {
    city: 'Springdale',
    county_fips: 30067,
    county_fips_all: '30067|30097',
    county: 'Park',
    county_names_all: 'Park|Sweet Grass',
    county_weights: '{"30067": 65.8, "30097": 34.2}',
    density: 0,
    imprecise: false,
    latitude: 45.84041,
    longitude: -110.29227,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59082',
  },
  {
    city: 'Sumatra',
    county_fips: 30087,
    county_fips_all: '30087',
    county: 'Rosebud',
    county_names_all: 'Rosebud',
    county_weights: '{"30087": 100}',
    density: 0,
    imprecise: false,
    latitude: 46.55133,
    longitude: -107.56312,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59083',
  },
  {
    city: 'Two Dot',
    county_fips: 30107,
    county_fips_all: '30107',
    county: 'Wheatland',
    county_names_all: 'Wheatland',
    county_weights: '{"30107": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 46.36172,
    longitude: -110.14019,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59085',
  },
  {
    city: 'Wilsall',
    county_fips: 30067,
    county_fips_all: '30067|30031|30059',
    county: 'Park',
    county_names_all: 'Park|Gallatin|Meagher',
    county_weights: '{"30067": 66.28, "30031": 31.45, "30059": 2.27}',
    density: 0.5,
    imprecise: false,
    latitude: 46.05608,
    longitude: -110.65293,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59086',
  },
  {
    city: 'Winnett',
    county_fips: 30069,
    county_fips_all: '30069',
    county: 'Petroleum',
    county_names_all: 'Petroleum',
    county_weights: '{"30069": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 47.16806,
    longitude: -108.22779,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59087',
  },
  {
    city: 'Worden',
    county_fips: 30111,
    county_fips_all: '30111',
    county: 'Yellowstone',
    county_names_all: 'Yellowstone',
    county_weights: '{"30111": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 46.13006,
    longitude: -108.02933,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59088',
  },
  {
    city: 'Wyola',
    county_fips: 30003,
    county_fips_all: '30003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"30003": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 45.09259,
    longitude: -107.34476,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59089',
  },
  {
    city: 'Billings',
    county_fips: 30111,
    county_fips_all: '30111|30003',
    county: 'Yellowstone',
    county_names_all: 'Yellowstone|Big Horn',
    county_weights: '{"30111": 97.71, "30003": 2.29}',
    density: 27.6,
    imprecise: false,
    latitude: 45.63013,
    longitude: -108.36445,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 42250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59101',
  },
  {
    city: 'Billings',
    county_fips: 30111,
    county_fips_all: '30111',
    county: 'Yellowstone',
    county_names_all: 'Yellowstone',
    county_weights: '{"30111": 100}',
    density: 1231.8,
    imprecise: false,
    latitude: 45.77479,
    longitude: -108.58133,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 47977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59102',
  },
  {
    city: 'Billings',
    county_fips: 30111,
    county_fips_all: '30111',
    county: 'Yellowstone',
    county_names_all: 'Yellowstone',
    county_weights: '{"30111": 100}',
    density: 142.9,
    imprecise: false,
    latitude: 45.87708,
    longitude: -108.50145,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59105',
  },
  {
    city: 'Billings',
    county_fips: 30111,
    county_fips_all: '30111',
    county: 'Yellowstone',
    county_names_all: 'Yellowstone',
    county_weights: '{"30111": 100}',
    density: 73.8,
    imprecise: false,
    latitude: 45.80637,
    longitude: -108.6948,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 21417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59106',
  },
  {
    city: 'Wolf Point',
    county_fips: 30085,
    county_fips_all: '30085|30055|30105',
    county: 'Roosevelt',
    county_names_all: 'Roosevelt|McCone|Valley',
    county_weights: '{"30085": 54.22, "30055": 37.76, "30105": 8.02}',
    density: 1.5,
    imprecise: false,
    latitude: 48.15981,
    longitude: -105.64647,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59201',
  },
  {
    city: 'Antelope',
    county_fips: 30091,
    county_fips_all: '30091',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"30091": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 48.69582,
    longitude: -104.35493,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59211',
  },
  {
    city: 'Bainville',
    county_fips: 30085,
    county_fips_all: '30085',
    county: 'Roosevelt',
    county_names_all: 'Roosevelt',
    county_weights: '{"30085": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 48.19231,
    longitude: -104.16968,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59212',
  },
  {
    city: 'Brockton',
    county_fips: 30085,
    county_fips_all: '30085|30083',
    county: 'Roosevelt',
    county_names_all: 'Roosevelt|Richland',
    county_weights: '{"30085": 56.62, "30083": 43.38}',
    density: 0.8,
    imprecise: false,
    latitude: 48.17553,
    longitude: -104.85612,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59213',
  },
  {
    city: 'Brockway',
    county_fips: 30055,
    county_fips_all: '30055|30079|30033',
    county: 'McCone',
    county_names_all: 'McCone|Prairie|Garfield',
    county_weights: '{"30055": 83.91, "30079": 11.03, "30033": 5.06}',
    density: 0,
    imprecise: false,
    latitude: 47.28325,
    longitude: -106.02221,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59214',
  },
  {
    city: 'Circle',
    county_fips: 30055,
    county_fips_all: '30055|30021',
    county: 'McCone',
    county_names_all: 'McCone|Dawson',
    county_weights: '{"30055": 90.95, "30021": 9.05}',
    density: 0.3,
    imprecise: false,
    latitude: 47.50431,
    longitude: -105.74543,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59215',
  },
  {
    city: 'Crane',
    county_fips: 30083,
    county_fips_all: '30083',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"30083": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 47.58449,
    longitude: -104.24455,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59217',
  },
  {
    city: 'Culbertson',
    county_fips: 30085,
    county_fips_all: '30085|30083',
    county: 'Roosevelt',
    county_names_all: 'Roosevelt|Richland',
    county_weights: '{"30085": 50.16, "30083": 49.84}',
    density: 0.9,
    imprecise: false,
    latitude: 48.09993,
    longitude: -104.52361,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59218',
  },
  {
    city: 'Dagmar',
    county_fips: 30091,
    county_fips_all: '30091',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"30091": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.5579,
    longitude: -104.15541,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59219',
  },
  {
    city: 'Fairview',
    county_fips: 30083,
    county_fips_all: '30083|38053',
    county: 'Richland',
    county_names_all: 'Richland|McKenzie',
    county_weights: '{"30083": 84.02, "38053": 15.98}',
    density: 2.9,
    imprecise: false,
    latitude: 47.91952,
    longitude: -104.1816,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59221',
  },
  {
    city: 'Flaxville',
    county_fips: 30019,
    county_fips_all: '30019|30085',
    county: 'Daniels',
    county_names_all: 'Daniels|Roosevelt',
    county_weights: '{"30019": 98.4, "30085": 1.6}',
    density: 0.3,
    imprecise: false,
    latitude: 48.7007,
    longitude: -105.1557,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59222',
  },
  {
    city: 'Fort Peck',
    county_fips: 30055,
    county_fips_all: '30055|30033|30105',
    county: 'McCone',
    county_names_all: 'McCone|Garfield|Valley',
    county_weights: '{"30055": 88.84, "30033": 8.68, "30105": 2.48}',
    density: 0,
    imprecise: false,
    latitude: 47.90319,
    longitude: -106.19348,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59223',
  },
  {
    city: 'Frazer',
    county_fips: 30105,
    county_fips_all: '30105',
    county: 'Valley',
    county_names_all: 'Valley',
    county_weights: '{"30105": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 48.27723,
    longitude: -105.97413,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59225',
  },
  {
    city: 'Froid',
    county_fips: 30085,
    county_fips_all: '30085|30091',
    county: 'Roosevelt',
    county_names_all: 'Roosevelt|Sheridan',
    county_weights: '{"30085": 86.95, "30091": 13.05}',
    density: 0.8,
    imprecise: false,
    latitude: 48.34283,
    longitude: -104.51545,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59226',
  },
  {
    city: 'Glasgow',
    county_fips: 30105,
    county_fips_all: '30105',
    county: 'Valley',
    county_names_all: 'Valley',
    county_weights: '{"30105": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 48.09992,
    longitude: -106.80196,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59230',
  },
  {
    city: 'Saint Marie',
    county_fips: 30105,
    county_fips_all: '30105',
    county: 'Valley',
    county_names_all: 'Valley',
    county_weights: '{"30105": 100}',
    density: 212.7,
    imprecise: false,
    latitude: 48.40395,
    longitude: -106.54411,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59231',
  },
  {
    city: 'Glentana',
    county_fips: 30105,
    county_fips_all: '30105',
    county: 'Valley',
    county_names_all: 'Valley',
    county_weights: '{"30105": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.84222,
    longitude: -106.24046,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59240',
  },
  {
    city: 'Hinsdale',
    county_fips: 30105,
    county_fips_all: '30105',
    county: 'Valley',
    county_names_all: 'Valley',
    county_weights: '{"30105": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 48.46125,
    longitude: -107.04602,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59241',
  },
  {
    city: 'Homestead',
    county_fips: 30091,
    county_fips_all: '30091|30085',
    county: 'Sheridan',
    county_names_all: 'Sheridan|Roosevelt',
    county_weights: '{"30091": 64.29, "30085": 35.71}',
    density: 0.2,
    imprecise: false,
    latitude: 48.4387,
    longitude: -104.55787,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59242',
  },
  {
    city: 'Lambert',
    county_fips: 30083,
    county_fips_all: '30083',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"30083": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 47.76062,
    longitude: -104.67387,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59243',
  },
  {
    city: 'Larslan',
    county_fips: 30105,
    county_fips_all: '30105',
    county: 'Valley',
    county_names_all: 'Valley',
    county_weights: '{"30105": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 48.62832,
    longitude: -106.30945,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59244',
  },
  {
    city: 'Medicine Lake',
    county_fips: 30091,
    county_fips_all: '30091',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"30091": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 48.51848,
    longitude: -104.52209,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59247',
  },
  {
    city: 'Nashua',
    county_fips: 30105,
    county_fips_all: '30105',
    county: 'Valley',
    county_names_all: 'Valley',
    county_weights: '{"30105": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 48.27555,
    longitude: -106.25841,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59248',
  },
  {
    city: 'Opheim',
    county_fips: 30105,
    county_fips_all: '30105',
    county: 'Valley',
    county_names_all: 'Valley',
    county_weights: '{"30105": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.86715,
    longitude: -106.63905,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59250',
  },
  {
    city: 'Outlook',
    county_fips: 30091,
    county_fips_all: '30091',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"30091": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 48.92728,
    longitude: -104.82152,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59252',
  },
  {
    city: 'Peerless',
    county_fips: 30019,
    county_fips_all: '30019|30105',
    county: 'Daniels',
    county_names_all: 'Daniels|Valley',
    county_weights: '{"30019": 98.03, "30105": 1.97}',
    density: 0.1,
    imprecise: false,
    latitude: 48.70422,
    longitude: -105.83496,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 59,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59253',
  },
  {
    city: 'Plentywood',
    county_fips: 30091,
    county_fips_all: '30091',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"30091": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 48.75753,
    longitude: -104.61123,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59254',
  },
  {
    city: 'Poplar',
    county_fips: 30085,
    county_fips_all: '30085|30083|30055',
    county: 'Roosevelt',
    county_names_all: 'Roosevelt|Richland|McCone',
    county_weights: '{"30085": 77.55, "30083": 19.44, "30055": 3.01}',
    density: 1.7,
    imprecise: false,
    latitude: 48.23115,
    longitude: -105.16825,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59255',
  },
  {
    city: 'Raymond',
    county_fips: 30091,
    county_fips_all: '30091',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"30091": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 48.91919,
    longitude: -104.54965,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59256',
  },
  {
    city: 'Redstone',
    county_fips: 30091,
    county_fips_all: '30091',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"30091": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.75364,
    longitude: -104.94239,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59257',
  },
  {
    city: 'Reserve',
    county_fips: 30091,
    county_fips_all: '30091|30085',
    county: 'Sheridan',
    county_names_all: 'Sheridan|Roosevelt',
    county_weights: '{"30091": 64.42, "30085": 35.58}',
    density: 0.3,
    imprecise: false,
    latitude: 48.57025,
    longitude: -104.735,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59258',
  },
  {
    city: 'Richey',
    county_fips: 30021,
    county_fips_all: '30021|30083',
    county: 'Dawson',
    county_names_all: 'Dawson|Richland',
    county_weights: '{"30021": 54.37, "30083": 45.63}',
    density: 0.2,
    imprecise: false,
    latitude: 47.69109,
    longitude: -105.08416,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59259',
  },
  {
    city: 'Richland',
    county_fips: 30105,
    county_fips_all: '30105|30019',
    county: 'Valley',
    county_names_all: 'Valley|Daniels',
    county_weights: '{"30105": 60.82, "30019": 39.18}',
    density: 0.1,
    imprecise: false,
    latitude: 48.84027,
    longitude: -106.10217,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59260',
  },
  {
    city: 'Saco',
    county_fips: 30071,
    county_fips_all: '30071|30105',
    county: 'Phillips',
    county_names_all: 'Phillips|Valley',
    county_weights: '{"30071": 79.05, "30105": 20.95}',
    density: 0.3,
    imprecise: false,
    latitude: 48.53327,
    longitude: -107.3599,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59261',
  },
  {
    city: 'Savage',
    county_fips: 30083,
    county_fips_all: '30083|30021',
    county: 'Richland',
    county_names_all: 'Richland|Dawson',
    county_weights: '{"30083": 57.49, "30021": 42.51}',
    density: 0.9,
    imprecise: false,
    latitude: 47.49341,
    longitude: -104.50518,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59262',
  },
  {
    city: 'Scobey',
    county_fips: 30019,
    county_fips_all: '30019|30085',
    county: 'Daniels',
    county_names_all: 'Daniels|Roosevelt',
    county_weights: '{"30019": 98.01, "30085": 1.99}',
    density: 0.8,
    imprecise: false,
    latitude: 48.78921,
    longitude: -105.51838,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59263',
  },
  {
    city: 'Sidney',
    county_fips: 30083,
    county_fips_all: '30083|38053',
    county: 'Richland',
    county_names_all: 'Richland|McKenzie',
    county_weights: '{"30083": 60.71, "38053": 39.29}',
    density: 3.7,
    imprecise: false,
    latitude: 47.57233,
    longitude: -104.08264,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59270',
  },
  {
    city: 'Vandalia',
    county_fips: 30105,
    county_fips_all: '30105',
    county: 'Valley',
    county_names_all: 'Valley',
    county_weights: '{"30105": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 48.29491,
    longitude: -106.93589,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59273',
  },
  {
    city: 'Vida',
    county_fips: 30055,
    county_fips_all: '30055',
    county: 'McCone',
    county_names_all: 'McCone',
    county_weights: '{"30055": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 47.83944,
    longitude: -105.42204,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59274',
  },
  {
    city: 'Westby',
    county_fips: 30091,
    county_fips_all: '30091|38023',
    county: 'Sheridan',
    county_names_all: 'Sheridan|Divide',
    county_weights: '{"30091": 75.76, "38023": 24.24}',
    density: 0.4,
    imprecise: false,
    latitude: 48.87415,
    longitude: -104.17865,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59275',
  },
  {
    city: 'Whitetail',
    county_fips: 30019,
    county_fips_all: '30019',
    county: 'Daniels',
    county_names_all: 'Daniels',
    county_weights: '{"30019": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 48.92979,
    longitude: -105.20108,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59276',
  },
  {
    city: 'Miles City',
    county_fips: 30017,
    county_fips_all: '30017|30087|30033|30075|30079',
    county: 'Custer',
    county_names_all: 'Custer|Rosebud|Garfield|Powder River|Prairie',
    county_weights:
      '{"30017": 81.19, "30087": 10.07, "30033": 5.1, "30075": 2.26, "30079": 1.38}',
    density: 1.6,
    imprecise: false,
    latitude: 46.36022,
    longitude: -105.85055,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 11643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59301',
  },
  {
    city: 'Alzada',
    county_fips: 30011,
    county_fips_all: '30011',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"30011": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 45.16944,
    longitude: -104.53017,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59311',
  },
  {
    city: 'Angela',
    county_fips: 30033,
    county_fips_all: '30033',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"30033": 100}',
    density: 0,
    imprecise: false,
    latitude: 47.0541,
    longitude: -106.26872,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59312',
  },
  {
    city: 'Baker',
    county_fips: 30025,
    county_fips_all: '30025|30011',
    county: 'Fallon',
    county_names_all: 'Fallon|Carter',
    county_weights: '{"30025": 93.63, "30011": 6.37}',
    density: 0.9,
    imprecise: false,
    latitude: 46.27497,
    longitude: -104.25016,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59313',
  },
  {
    city: 'Biddle',
    county_fips: 30075,
    county_fips_all: '30075',
    county: 'Powder River',
    county_names_all: 'Powder River',
    county_weights: '{"30075": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.07847,
    longitude: -105.43933,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59314',
  },
  {
    city: 'Bloomfield',
    county_fips: 30021,
    county_fips_all: '30021',
    county: 'Dawson',
    county_names_all: 'Dawson',
    county_weights: '{"30021": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 47.44241,
    longitude: -104.87483,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59315',
  },
  {
    city: 'Boyes',
    county_fips: 30075,
    county_fips_all: '30075|30011',
    county: 'Powder River',
    county_names_all: 'Powder River|Carter',
    county_weights: '{"30075": 70.33, "30011": 29.67}',
    density: 0,
    imprecise: false,
    latitude: 45.33726,
    longitude: -105.04973,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59316',
  },
  {
    city: 'Broadus',
    county_fips: 30075,
    county_fips_all: '30075',
    county: 'Powder River',
    county_names_all: 'Powder River',
    county_weights: '{"30075": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 45.33477,
    longitude: -105.52106,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59317',
  },
  {
    city: 'Brusett',
    county_fips: 30033,
    county_fips_all: '30033',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"30033": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 47.48955,
    longitude: -107.4784,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59318',
  },
  {
    city: 'Capitol',
    county_fips: 30011,
    county_fips_all: '30011',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"30011": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 45.40696,
    longitude: -104.17379,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 40,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59319',
  },
  {
    city: 'Cohagen',
    county_fips: 30033,
    county_fips_all: '30033',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"30033": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 47.03521,
    longitude: -106.64069,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59322',
  },
  {
    city: 'Colstrip',
    county_fips: 30087,
    county_fips_all: '30087',
    county: 'Rosebud',
    county_names_all: 'Rosebud',
    county_weights: '{"30087": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 45.91234,
    longitude: -106.7032,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59323',
  },
  {
    city: 'Ekalaka',
    county_fips: 30011,
    county_fips_all: '30011',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"30011": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.76652,
    longitude: -104.58732,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59324',
  },
  {
    city: 'Fallon',
    county_fips: 30079,
    county_fips_all: '30079|30021',
    county: 'Prairie',
    county_names_all: 'Prairie|Dawson',
    county_weights: '{"30079": 87.37, "30021": 12.63}',
    density: 0.2,
    imprecise: false,
    latitude: 46.77178,
    longitude: -104.85183,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59326',
  },
  {
    city: 'Forsyth',
    county_fips: 30087,
    county_fips_all: '30087',
    county: 'Rosebud',
    county_names_all: 'Rosebud',
    county_weights: '{"30087": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 46.2389,
    longitude: -106.7082,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59327',
  },
  {
    city: 'Glendive',
    county_fips: 30021,
    county_fips_all: '30021|30079',
    county: 'Dawson',
    county_names_all: 'Dawson|Prairie',
    county_weights: '{"30021": 96.85, "30079": 3.15}',
    density: 3.1,
    imprecise: false,
    latitude: 47.11812,
    longitude: -104.76469,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59330',
  },
  {
    city: 'Hammond',
    county_fips: 30011,
    county_fips_all: '30011',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"30011": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 45.37589,
    longitude: -104.72542,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59332',
  },
  {
    city: 'Hathaway',
    county_fips: 30087,
    county_fips_all: '30087',
    county: 'Rosebud',
    county_names_all: 'Rosebud',
    county_weights: '{"30087": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 46.28123,
    longitude: -106.24765,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59333',
  },
  {
    city: 'Ismay',
    county_fips: 30017,
    county_fips_all: '30017|30025|30011|30079',
    county: 'Custer',
    county_names_all: 'Custer|Fallon|Carter|Prairie',
    county_weights:
      '{"30017": 65.46, "30025": 28.19, "30011": 5.66, "30079": 0.69}',
    density: 0.1,
    imprecise: false,
    latitude: 46.342,
    longitude: -104.95063,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59336',
  },
  {
    city: 'Jordan',
    county_fips: 30033,
    county_fips_all: '30033',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"30033": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 47.39098,
    longitude: -106.81486,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59337',
  },
  {
    city: 'Kinsey',
    county_fips: 30017,
    county_fips_all: '30017',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"30017": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 46.63392,
    longitude: -105.65584,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59338',
  },
  {
    city: 'Lindsay',
    county_fips: 30021,
    county_fips_all: '30021|30079',
    county: 'Dawson',
    county_names_all: 'Dawson|Prairie',
    county_weights: '{"30021": 98.9, "30079": 1.1}',
    density: 0.2,
    imprecise: false,
    latitude: 47.22587,
    longitude: -105.19934,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59339',
  },
  {
    city: 'Olive',
    county_fips: 30075,
    county_fips_all: '30075',
    county: 'Powder River',
    county_names_all: 'Powder River',
    county_weights: '{"30075": 100}',
    density: 0,
    imprecise: false,
    latitude: 45.65602,
    longitude: -105.43296,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 21,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59343',
  },
  {
    city: 'Plevna',
    county_fips: 30025,
    county_fips_all: '30025|30011',
    county: 'Fallon',
    county_names_all: 'Fallon|Carter',
    county_weights: '{"30025": 93.98, "30011": 6.02}',
    density: 0.4,
    imprecise: false,
    latitude: 46.3516,
    longitude: -104.5713,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59344',
  },
  {
    city: 'Powderville',
    county_fips: 30017,
    county_fips_all: '30017|30075',
    county: 'Custer',
    county_names_all: 'Custer|Powder River',
    county_weights: '{"30017": 68.15, "30075": 31.85}',
    density: 0,
    imprecise: false,
    latitude: 45.85367,
    longitude: -105.20436,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59345',
  },
  {
    city: 'Rosebud',
    county_fips: 30087,
    county_fips_all: '30087|30017',
    county: 'Rosebud',
    county_names_all: 'Rosebud|Custer',
    county_weights: '{"30087": 92.43, "30017": 7.57}',
    density: 0.1,
    imprecise: false,
    latitude: 46.45434,
    longitude: -106.34614,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59347',
  },
  {
    city: 'Terry',
    county_fips: 30079,
    county_fips_all: '30079|30017',
    county: 'Prairie',
    county_names_all: 'Prairie|Custer',
    county_weights: '{"30079": 98.63, "30017": 1.37}',
    density: 0.3,
    imprecise: false,
    latitude: 46.87278,
    longitude: -105.48388,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59349',
  },
  {
    city: 'Volborg',
    county_fips: 30075,
    county_fips_all: '30075|30017',
    county: 'Powder River',
    county_names_all: 'Powder River|Custer',
    county_weights: '{"30075": 60.37, "30017": 39.63}',
    density: 0.1,
    imprecise: false,
    latitude: 45.7633,
    longitude: -105.70844,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59351',
  },
  {
    city: 'Wibaux',
    county_fips: 30109,
    county_fips_all: '30109|30021|30025',
    county: 'Wibaux',
    county_names_all: 'Wibaux|Dawson|Fallon',
    county_weights: '{"30109": 83.91, "30021": 13.92, "30025": 2.17}',
    density: 0.4,
    imprecise: false,
    latitude: 46.96394,
    longitude: -104.28218,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59353',
  },
  {
    city: 'Willard',
    county_fips: 30025,
    county_fips_all: '30025',
    county: 'Fallon',
    county_names_all: 'Fallon',
    county_weights: '{"30025": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 46.18924,
    longitude: -104.41939,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59354',
  },
  {
    city: 'Great Falls',
    county_fips: 30013,
    county_fips_all: '30013',
    county: 'Cascade',
    county_names_all: 'Cascade',
    county_weights: '{"30013": 100}',
    density: 1727.9,
    imprecise: false,
    latitude: 47.51083,
    longitude: -111.27691,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 13255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59401',
  },
  {
    city: 'Great Falls',
    county_fips: 30013,
    county_fips_all: '30013|30015',
    county: 'Cascade',
    county_names_all: 'Cascade|Chouteau',
    county_weights: '{"30013": 71.68, "30015": 28.32}',
    density: 33.6,
    imprecise: false,
    latitude: 47.63197,
    longitude: -111.34807,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 28822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59404',
  },
  {
    city: 'Great Falls',
    county_fips: 30013,
    county_fips_all: '30013|30015',
    county: 'Cascade',
    county_names_all: 'Cascade|Chouteau',
    county_weights: '{"30013": 98.85, "30015": 1.15}',
    density: 26.9,
    imprecise: false,
    latitude: 47.28102,
    longitude: -111.25937,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 33350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59405',
  },
  {
    city: 'Augusta',
    county_fips: 30049,
    county_fips_all: '30049|30099',
    county: 'Lewis and Clark',
    county_names_all: 'Lewis and Clark|Teton',
    county_weights: '{"30049": 97.51, "30099": 2.49}',
    density: 0.2,
    imprecise: false,
    latitude: 47.49442,
    longitude: -112.64299,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59410',
  },
  {
    city: 'Babb',
    county_fips: 30035,
    county_fips_all: '30035',
    county: 'Glacier',
    county_names_all: 'Glacier',
    county_weights: '{"30035": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 48.88965,
    longitude: -113.41403,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59411',
  },
  {
    city: 'Belt',
    county_fips: 30013,
    county_fips_all: '30013|30045',
    county: 'Cascade',
    county_names_all: 'Cascade|Judith Basin',
    county_weights: '{"30013": 96.88, "30045": 3.12}',
    density: 1.7,
    imprecise: false,
    latitude: 47.32538,
    longitude: -110.8762,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59412',
  },
  {
    city: 'Black Eagle',
    county_fips: 30013,
    county_fips_all: '30013',
    county: 'Cascade',
    county_names_all: 'Cascade',
    county_weights: '{"30013": 100}',
    density: 172.9,
    imprecise: false,
    latitude: 47.5276,
    longitude: -111.26871,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59414',
  },
  {
    city: 'Brady',
    county_fips: 30073,
    county_fips_all: '30073|30015|30099|30051',
    county: 'Pondera',
    county_names_all: 'Pondera|Chouteau|Teton|Liberty',
    county_weights:
      '{"30073": 56.25, "30015": 41.1, "30099": 1.52, "30051": 1.13}',
    density: 0.4,
    imprecise: false,
    latitude: 48.04059,
    longitude: -111.52359,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59416',
  },
  {
    city: 'Browning',
    county_fips: 30035,
    county_fips_all: '30035',
    county: 'Glacier',
    county_names_all: 'Glacier',
    county_weights: '{"30035": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 48.54483,
    longitude: -113.0086,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59417',
  },
  {
    city: 'Buffalo',
    county_fips: 30045,
    county_fips_all: '30045|30027',
    county: 'Judith Basin',
    county_names_all: 'Judith Basin|Fergus',
    county_weights: '{"30045": 76.86, "30027": 23.14}',
    density: 0.4,
    imprecise: false,
    latitude: 46.80258,
    longitude: -109.87849,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59418',
  },
  {
    city: 'Bynum',
    county_fips: 30099,
    county_fips_all: '30099',
    county: 'Teton',
    county_names_all: 'Teton',
    county_weights: '{"30099": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.00641,
    longitude: -112.40855,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59419',
  },
  {
    city: 'Carter',
    county_fips: 30015,
    county_fips_all: '30015',
    county: 'Chouteau',
    county_names_all: 'Chouteau',
    county_weights: '{"30015": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 47.89688,
    longitude: -111.04034,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59420',
  },
  {
    city: 'Cascade',
    county_fips: 30013,
    county_fips_all: '30013|30049',
    county: 'Cascade',
    county_names_all: 'Cascade|Lewis and Clark',
    county_weights: '{"30013": 95.54, "30049": 4.46}',
    density: 1.1,
    imprecise: false,
    latitude: 47.20179,
    longitude: -111.72,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59421',
  },
  {
    city: 'Choteau',
    county_fips: 30099,
    county_fips_all: '30099',
    county: 'Teton',
    county_names_all: 'Teton',
    county_weights: '{"30099": 100}',
    density: 1,
    imprecise: false,
    latitude: 47.83957,
    longitude: -112.48266,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59422',
  },
  {
    city: 'Coffee Creek',
    county_fips: 30027,
    county_fips_all: '30027|30045',
    county: 'Fergus',
    county_names_all: 'Fergus|Judith Basin',
    county_weights: '{"30027": 66.71, "30045": 33.29}',
    density: 0.5,
    imprecise: false,
    latitude: 47.34929,
    longitude: -110.1022,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59424',
  },
  {
    city: 'Conrad',
    county_fips: 30073,
    county_fips_all: '30073|30099',
    county: 'Pondera',
    county_names_all: 'Pondera|Teton',
    county_weights: '{"30073": 91.09, "30099": 8.91}',
    density: 2.6,
    imprecise: false,
    latitude: 48.18641,
    longitude: -111.88738,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59425',
  },
  {
    city: 'Cut Bank',
    county_fips: 30035,
    county_fips_all: '30035|30101',
    county: 'Glacier',
    county_names_all: 'Glacier|Toole',
    county_weights: '{"30035": 97.28, "30101": 2.72}',
    density: 1.4,
    imprecise: false,
    latitude: 48.77357,
    longitude: -112.61639,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59427',
  },
  {
    city: 'Denton',
    county_fips: 30027,
    county_fips_all: '30027|30045',
    county: 'Fergus',
    county_names_all: 'Fergus|Judith Basin',
    county_weights: '{"30027": 94.67, "30045": 5.33}',
    density: 0.3,
    imprecise: false,
    latitude: 47.43089,
    longitude: -109.83434,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59430',
  },
  {
    city: 'Dupuyer',
    county_fips: 30073,
    county_fips_all: '30073|30099',
    county: 'Pondera',
    county_names_all: 'Pondera|Teton',
    county_weights: '{"30073": 73.19, "30099": 26.81}',
    density: 0.4,
    imprecise: false,
    latitude: 48.14595,
    longitude: -112.58853,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59432',
  },
  {
    city: 'Dutton',
    county_fips: 30099,
    county_fips_all: '30099|30073',
    county: 'Teton',
    county_names_all: 'Teton|Pondera',
    county_weights: '{"30099": 99.68, "30073": 0.32}',
    density: 0.5,
    imprecise: false,
    latitude: 47.89565,
    longitude: -111.68483,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59433',
  },
  {
    city: 'East Glacier Park',
    county_fips: 30035,
    county_fips_all: '30035',
    county: 'Glacier',
    county_names_all: 'Glacier',
    county_weights: '{"30035": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.68682,
    longitude: -113.55678,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59434',
  },
  {
    city: 'Ethridge',
    county_fips: 30101,
    county_fips_all: '30101',
    county: 'Toole',
    county_names_all: 'Toole',
    county_weights: '{"30101": 100}',
    density: 0,
    imprecise: false,
    latitude: 48.5616,
    longitude: -112.06059,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59435',
  },
  {
    city: 'Fairfield',
    county_fips: 30099,
    county_fips_all: '30099|30013',
    county: 'Teton',
    county_names_all: 'Teton|Cascade',
    county_weights: '{"30099": 99.6, "30013": 0.4}',
    density: 3.2,
    imprecise: false,
    latitude: 47.6135,
    longitude: -112.0907,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59436',
  },
  {
    city: 'Floweree',
    county_fips: 30015,
    county_fips_all: '30015|30013',
    county: 'Chouteau',
    county_names_all: 'Chouteau|Cascade',
    county_weights: '{"30015": 67.52, "30013": 32.48}',
    density: 0.9,
    imprecise: false,
    latitude: 47.72489,
    longitude: -111.14261,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59440',
  },
  {
    city: 'Forest Grove',
    county_fips: 30027,
    county_fips_all: '30027',
    county: 'Fergus',
    county_names_all: 'Fergus',
    county_weights: '{"30027": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 46.852,
    longitude: -108.98933,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59441',
  },
  {
    city: 'Fort Benton',
    county_fips: 30015,
    county_fips_all: '30015',
    county: 'Chouteau',
    county_names_all: 'Chouteau',
    county_weights: '{"30015": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 47.93005,
    longitude: -110.64697,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59442',
  },
  {
    city: 'Fort Shaw',
    county_fips: 30013,
    county_fips_all: '30013|30099',
    county: 'Cascade',
    county_names_all: 'Cascade|Teton',
    county_weights: '{"30013": 93.5, "30099": 6.5}',
    density: 4.7,
    imprecise: false,
    latitude: 47.5621,
    longitude: -111.82647,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59443',
  },
  {
    city: 'Galata',
    county_fips: 30101,
    county_fips_all: '30101|30051',
    county: 'Toole',
    county_names_all: 'Toole|Liberty',
    county_weights: '{"30101": 80.5, "30051": 19.5}',
    density: 0.2,
    imprecise: false,
    latitude: 48.65227,
    longitude: -111.34881,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59444',
  },
  {
    city: 'Geraldine',
    county_fips: 30015,
    county_fips_all: '30015',
    county: 'Chouteau',
    county_names_all: 'Chouteau',
    county_weights: '{"30015": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 47.64083,
    longitude: -110.17894,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59446',
  },
  {
    city: 'Geyser',
    county_fips: 30045,
    county_fips_all: '30045|30015',
    county: 'Judith Basin',
    county_names_all: 'Judith Basin|Chouteau',
    county_weights: '{"30045": 96.99, "30015": 3.01}',
    density: 0.3,
    imprecise: false,
    latitude: 47.28116,
    longitude: -110.45955,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59447',
  },
  {
    city: 'Heart Butte',
    county_fips: 30073,
    county_fips_all: '30073|30035',
    county: 'Pondera',
    county_names_all: 'Pondera|Glacier',
    county_weights: '{"30073": 99.14, "30035": 0.86}',
    density: 3.2,
    imprecise: false,
    latitude: 48.25789,
    longitude: -112.86703,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59448',
  },
  {
    city: 'Highwood',
    county_fips: 30015,
    county_fips_all: '30015',
    county: 'Chouteau',
    county_names_all: 'Chouteau',
    county_weights: '{"30015": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 47.5992,
    longitude: -110.73923,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59450',
  },
  {
    city: 'Hilger',
    county_fips: 30027,
    county_fips_all: '30027',
    county: 'Fergus',
    county_names_all: 'Fergus',
    county_weights: '{"30027": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 47.38984,
    longitude: -109.39779,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59451',
  },
  {
    city: 'Hobson',
    county_fips: 30045,
    county_fips_all: '30045',
    county: 'Judith Basin',
    county_names_all: 'Judith Basin',
    county_weights: '{"30045": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 46.86946,
    longitude: -110.09831,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59452',
  },
  {
    city: 'Judith Gap',
    county_fips: 30107,
    county_fips_all: '30107|30027|30045',
    county: 'Wheatland',
    county_names_all: 'Wheatland|Fergus|Judith Basin',
    county_weights: '{"30107": 76.59, "30027": 18.54, "30045": 4.87}',
    density: 0.4,
    imprecise: false,
    latitude: 46.65903,
    longitude: -109.66996,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59453',
  },
  {
    city: 'Kevin',
    county_fips: 30101,
    county_fips_all: '30101',
    county: 'Toole',
    county_names_all: 'Toole',
    county_weights: '{"30101": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 48.74481,
    longitude: -111.97769,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59454',
  },
  {
    city: 'Ledger',
    county_fips: 30051,
    county_fips_all: '30051|30101|30073',
    county: 'Liberty',
    county_names_all: 'Liberty|Toole|Pondera',
    county_weights: '{"30051": 52.28, "30101": 38.35, "30073": 9.37}',
    density: 0.4,
    imprecise: false,
    latitude: 48.27221,
    longitude: -111.35432,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59456',
  },
  {
    city: 'Lewistown',
    county_fips: 30027,
    county_fips_all: '30027',
    county: 'Fergus',
    county_names_all: 'Fergus',
    county_weights: '{"30027": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 47.08027,
    longitude: -109.38656,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59457',
  },
  {
    city: 'Loma',
    county_fips: 30015,
    county_fips_all: '30015',
    county: 'Chouteau',
    county_names_all: 'Chouteau',
    county_weights: '{"30015": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.07682,
    longitude: -110.50908,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59460',
  },
  {
    city: 'Lothair',
    county_fips: 30051,
    county_fips_all: '30051',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"30051": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.4894,
    longitude: -111.19985,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 23,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59461',
  },
  {
    city: 'Moccasin',
    county_fips: 30045,
    county_fips_all: '30045',
    county: 'Judith Basin',
    county_names_all: 'Judith Basin',
    county_weights: '{"30045": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 47.10833,
    longitude: -109.88513,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59462',
  },
  {
    city: 'Monarch',
    county_fips: 30013,
    county_fips_all: '30013|30045',
    county: 'Cascade',
    county_names_all: 'Cascade|Judith Basin',
    county_weights: '{"30013": 94.01, "30045": 5.99}',
    density: 0.3,
    imprecise: false,
    latitude: 47.0489,
    longitude: -110.86668,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59463',
  },
  {
    city: 'Moore',
    county_fips: 30027,
    county_fips_all: '30027|30045',
    county: 'Fergus',
    county_names_all: 'Fergus|Judith Basin',
    county_weights: '{"30027": 94.58, "30045": 5.42}',
    density: 1,
    imprecise: false,
    latitude: 46.87409,
    longitude: -109.60589,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59464',
  },
  {
    city: 'Neihart',
    county_fips: 30013,
    county_fips_all: '30013',
    county: 'Cascade',
    county_names_all: 'Cascade',
    county_weights: '{"30013": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 46.93777,
    longitude: -110.70788,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59465',
  },
  {
    city: 'Oilmont',
    county_fips: 30101,
    county_fips_all: '30101',
    county: 'Toole',
    county_names_all: 'Toole',
    county_weights: '{"30101": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.78746,
    longitude: -111.69124,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59466',
  },
  {
    city: 'Pendroy',
    county_fips: 30099,
    county_fips_all: '30099',
    county: 'Teton',
    county_names_all: 'Teton',
    county_weights: '{"30099": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 48.07149,
    longitude: -112.37794,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59467',
  },
  {
    city: 'Power',
    county_fips: 30099,
    county_fips_all: '30099|30013',
    county: 'Teton',
    county_names_all: 'Teton|Cascade',
    county_weights: '{"30099": 71.24, "30013": 28.76}',
    density: 1.3,
    imprecise: false,
    latitude: 47.71253,
    longitude: -111.62842,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59468',
  },
  {
    city: 'Raynesford',
    county_fips: 30045,
    county_fips_all: '30045',
    county: 'Judith Basin',
    county_names_all: 'Judith Basin',
    county_weights: '{"30045": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 47.19087,
    longitude: -110.68378,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59469',
  },
  {
    city: 'Roy',
    county_fips: 30027,
    county_fips_all: '30027',
    county: 'Fergus',
    county_names_all: 'Fergus',
    county_weights: '{"30027": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 47.4161,
    longitude: -108.77191,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59471',
  },
  {
    city: 'Sand Coulee',
    county_fips: 30013,
    county_fips_all: '30013',
    county: 'Cascade',
    county_names_all: 'Cascade',
    county_weights: '{"30013": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 47.37939,
    longitude: -111.17095,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59472',
  },
  {
    city: 'Shelby',
    county_fips: 30101,
    county_fips_all: '30101',
    county: 'Toole',
    county_names_all: 'Toole',
    county_weights: '{"30101": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 48.53314,
    longitude: -111.69254,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59474',
  },
  {
    city: 'Simms',
    county_fips: 30013,
    county_fips_all: '30013',
    county: 'Cascade',
    county_names_all: 'Cascade',
    county_weights: '{"30013": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 47.44467,
    longitude: -111.97419,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59477',
  },
  {
    city: 'Stanford',
    county_fips: 30045,
    county_fips_all: '30045',
    county: 'Judith Basin',
    county_names_all: 'Judith Basin',
    county_weights: '{"30045": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 47.016,
    longitude: -110.33696,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59479',
  },
  {
    city: 'Stockett',
    county_fips: 30013,
    county_fips_all: '30013',
    county: 'Cascade',
    county_names_all: 'Cascade',
    county_weights: '{"30013": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 47.22696,
    longitude: -111.12013,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59480',
  },
  {
    city: 'Sunburst',
    county_fips: 30101,
    county_fips_all: '30101',
    county: 'Toole',
    county_names_all: 'Toole',
    county_weights: '{"30101": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 48.88446,
    longitude: -111.86622,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59482',
  },
  {
    city: 'Sun River',
    county_fips: 30013,
    county_fips_all: '30013',
    county: 'Cascade',
    county_names_all: 'Cascade',
    county_weights: '{"30013": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 47.47212,
    longitude: -111.72261,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59483',
  },
  {
    city: 'Sweet Grass',
    county_fips: 30101,
    county_fips_all: '30101',
    county: 'Toole',
    county_names_all: 'Toole',
    county_weights: '{"30101": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.95074,
    longitude: -111.76795,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59484',
  },
  {
    city: 'Ulm',
    county_fips: 30013,
    county_fips_all: '30013',
    county: 'Cascade',
    county_names_all: 'Cascade',
    county_weights: '{"30013": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 47.43264,
    longitude: -111.56667,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59485',
  },
  {
    city: 'Valier',
    county_fips: 30073,
    county_fips_all: '30073',
    county: 'Pondera',
    county_names_all: 'Pondera',
    county_weights: '{"30073": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 48.33709,
    longitude: -112.35552,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59486',
  },
  {
    city: 'Vaughn',
    county_fips: 30013,
    county_fips_all: '30013|30099',
    county: 'Cascade',
    county_names_all: 'Cascade|Teton',
    county_weights: '{"30013": 92.35, "30099": 7.65}',
    density: 10.9,
    imprecise: false,
    latitude: 47.58393,
    longitude: -111.64592,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59487',
  },
  {
    city: 'Winifred',
    county_fips: 30027,
    county_fips_all: '30027',
    county: 'Fergus',
    county_names_all: 'Fergus',
    county_weights: '{"30027": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 47.64007,
    longitude: -109.25586,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59489',
  },
  {
    city: 'Havre',
    county_fips: 30041,
    county_fips_all: '30041|30005',
    county: 'Hill',
    county_names_all: 'Hill|Blaine',
    county_weights: '{"30041": 95.74, "30005": 4.26}',
    density: 3.5,
    imprecise: false,
    latitude: 48.69591,
    longitude: -109.78556,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59501',
  },
  {
    city: 'Big Sandy',
    county_fips: 30015,
    county_fips_all: '30015|30005|30041',
    county: 'Chouteau',
    county_names_all: 'Chouteau|Blaine|Hill',
    county_weights: '{"30015": 97.14, "30005": 2.33, "30041": 0.53}',
    density: 0.4,
    imprecise: false,
    latitude: 48.03822,
    longitude: -109.93749,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59520',
  },
  {
    city: 'Box Elder',
    county_fips: 30041,
    county_fips_all: '30041|30015',
    county: 'Hill',
    county_names_all: 'Hill|Chouteau',
    county_weights: '{"30041": 81.61, "30015": 18.39}',
    density: 4.8,
    imprecise: false,
    latitude: 48.30489,
    longitude: -109.972,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59521',
  },
  {
    city: 'Chester',
    county_fips: 30051,
    county_fips_all: '30051',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"30051": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 48.56497,
    longitude: -110.98827,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59522',
  },
  {
    city: 'Chinook',
    county_fips: 30005,
    county_fips_all: '30005|30041',
    county: 'Blaine',
    county_names_all: 'Blaine|Hill',
    county_weights: '{"30005": 98.86, "30041": 1.14}',
    density: 0.6,
    imprecise: false,
    latitude: 48.52013,
    longitude: -109.20829,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59523',
  },
  {
    city: 'Dodson',
    county_fips: 30071,
    county_fips_all: '30071|30005',
    county: 'Phillips',
    county_names_all: 'Phillips|Blaine',
    county_weights: '{"30071": 88.09, "30005": 11.91}',
    density: 0.2,
    imprecise: false,
    latitude: 48.12273,
    longitude: -108.40374,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59524',
  },
  {
    city: 'Gildford',
    county_fips: 30041,
    county_fips_all: '30041',
    county: 'Hill',
    county_names_all: 'Hill',
    county_weights: '{"30041": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 48.6524,
    longitude: -110.27405,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59525',
  },
  {
    city: 'Harlem',
    county_fips: 30005,
    county_fips_all: '30005',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"30005": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 48.4414,
    longitude: -108.67155,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59526',
  },
  {
    city: 'Hays',
    county_fips: 30005,
    county_fips_all: '30005',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"30005": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 48.04527,
    longitude: -108.74677,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59527',
  },
  {
    city: 'Hingham',
    county_fips: 30041,
    county_fips_all: '30041',
    county: 'Hill',
    county_names_all: 'Hill',
    county_weights: '{"30041": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 48.6233,
    longitude: -110.42628,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59528',
  },
  {
    city: 'Hogeland',
    county_fips: 30005,
    county_fips_all: '30005',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"30005": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.79655,
    longitude: -108.69059,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59529',
  },
  {
    city: 'Inverness',
    county_fips: 30041,
    county_fips_all: '30041',
    county: 'Hill',
    county_names_all: 'Hill',
    county_weights: '{"30041": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.60212,
    longitude: -110.68802,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59530',
  },
  {
    city: 'Joplin',
    county_fips: 30051,
    county_fips_all: '30051|30041',
    county: 'Liberty',
    county_names_all: 'Liberty|Hill',
    county_weights: '{"30051": 72.93, "30041": 27.07}',
    density: 0.5,
    imprecise: false,
    latitude: 48.77294,
    longitude: -110.78334,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59531',
  },
  {
    city: 'Kremlin',
    county_fips: 30041,
    county_fips_all: '30041',
    county: 'Hill',
    county_names_all: 'Hill',
    county_weights: '{"30041": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.58837,
    longitude: -110.08515,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59532',
  },
  {
    city: 'Lloyd',
    county_fips: 30005,
    county_fips_all: '30005',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"30005": 100}',
    density: 0,
    imprecise: false,
    latitude: 47.94123,
    longitude: -109.26059,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59535',
  },
  {
    city: 'Loring',
    county_fips: 30071,
    county_fips_all: '30071',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"30071": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.84762,
    longitude: -107.93725,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59537',
  },
  {
    city: 'Malta',
    county_fips: 30071,
    county_fips_all: '30071',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"30071": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 48.02231,
    longitude: -107.8657,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59538',
  },
  {
    city: 'Rudyard',
    county_fips: 30041,
    county_fips_all: '30041|30015',
    county: 'Hill',
    county_names_all: 'Hill|Chouteau',
    county_weights: '{"30041": 96.17, "30015": 3.83}',
    density: 0.4,
    imprecise: false,
    latitude: 48.60665,
    longitude: -110.56418,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59540',
  },
  {
    city: 'Turner',
    county_fips: 30005,
    county_fips_all: '30005|30071',
    county: 'Blaine',
    county_names_all: 'Blaine|Phillips',
    county_weights: '{"30005": 65.31, "30071": 34.69}',
    density: 0.3,
    imprecise: false,
    latitude: 48.81907,
    longitude: -108.33693,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59542',
  },
  {
    city: 'Whitewater',
    county_fips: 30071,
    county_fips_all: '30071',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"30071": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.81294,
    longitude: -107.59147,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59544',
  },
  {
    city: 'Whitlash',
    county_fips: 30051,
    county_fips_all: '30051|30101',
    county: 'Liberty',
    county_names_all: 'Liberty|Toole',
    county_weights: '{"30051": 67.98, "30101": 32.02}',
    density: 0.2,
    imprecise: false,
    latitude: 48.94067,
    longitude: -111.21768,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59545',
  },
  {
    city: 'Zortman',
    county_fips: 30071,
    county_fips_all: '30071',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"30071": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 47.88208,
    longitude: -108.55654,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59546',
  },
  {
    city: 'Zurich',
    county_fips: 30005,
    county_fips_all: '30005',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"30005": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.70576,
    longitude: -108.98747,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59547',
  },
  {
    city: 'Helena',
    county_fips: 30049,
    county_fips_all: '30049',
    county: 'Lewis and Clark',
    county_names_all: 'Lewis and Clark',
    county_weights: '{"30049": 100}',
    density: 94.1,
    imprecise: false,
    latitude: 46.54199,
    longitude: -112.17474,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 31728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59601',
  },
  {
    city: 'Helena',
    county_fips: 30049,
    county_fips_all: '30049',
    county: 'Lewis and Clark',
    county_names_all: 'Lewis and Clark',
    county_weights: '{"30049": 100}',
    density: 22.6,
    imprecise: false,
    latitude: 46.73577,
    longitude: -111.90753,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 30754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59602',
  },
  {
    city: 'Basin',
    county_fips: 30043,
    county_fips_all: '30043',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"30043": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 46.29168,
    longitude: -112.38687,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59631',
  },
  {
    city: 'Boulder',
    county_fips: 30043,
    county_fips_all: '30043',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"30043": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 46.16522,
    longitude: -111.99918,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59632',
  },
  {
    city: 'Canyon Creek',
    county_fips: 30049,
    county_fips_all: '30049',
    county: 'Lewis and Clark',
    county_names_all: 'Lewis and Clark',
    county_weights: '{"30049": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 46.82338,
    longitude: -112.36362,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59633',
  },
  {
    city: 'Clancy',
    county_fips: 30043,
    county_fips_all: '30043',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"30043": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 46.43583,
    longitude: -112.00986,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59634',
  },
  {
    city: 'East Helena',
    county_fips: 30049,
    county_fips_all: '30049|30043|30007',
    county: 'Lewis and Clark',
    county_names_all: 'Lewis and Clark|Jefferson|Broadwater',
    county_weights: '{"30049": 38.18, "30043": 36.1, "30007": 25.72}',
    density: 40.3,
    imprecise: false,
    latitude: 46.5546,
    longitude: -111.81749,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59635',
  },
  {
    city: 'Fort Harrison',
    county_fips: 30049,
    county_fips_all: '30049',
    county: 'Lewis and Clark',
    county_names_all: 'Lewis and Clark',
    county_weights: '{"30049": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 46.61614,
    longitude: -112.11399,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59636',
  },
  {
    city: 'Jefferson City',
    county_fips: 30043,
    county_fips_all: '30043',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"30043": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 46.3579,
    longitude: -112.02772,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59638',
  },
  {
    city: 'Lincoln',
    county_fips: 30049,
    county_fips_all: '30049',
    county: 'Lewis and Clark',
    county_names_all: 'Lewis and Clark',
    county_weights: '{"30049": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 47.09436,
    longitude: -112.69371,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59639',
  },
  {
    city: 'Marysville',
    county_fips: 30049,
    county_fips_all: '30049',
    county: 'Lewis and Clark',
    county_names_all: 'Lewis and Clark',
    county_weights: '{"30049": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 46.76814,
    longitude: -112.34922,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59640',
  },
  {
    city: 'Ringling',
    county_fips: 30059,
    county_fips_all: '30059',
    county: 'Meagher',
    county_names_all: 'Meagher',
    county_weights: '{"30059": 100}',
    density: 0,
    imprecise: false,
    latitude: 46.28045,
    longitude: -110.75624,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59642',
  },
  {
    city: 'Toston',
    county_fips: 30007,
    county_fips_all: '30007',
    county: 'Broadwater',
    county_names_all: 'Broadwater',
    county_weights: '{"30007": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 46.13283,
    longitude: -111.57884,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59643',
  },
  {
    city: 'Townsend',
    county_fips: 30007,
    county_fips_all: '30007',
    county: 'Broadwater',
    county_names_all: 'Broadwater',
    county_weights: '{"30007": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 46.419,
    longitude: -111.43885,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59644',
  },
  {
    city: 'White Sulphur Springs',
    county_fips: 30059,
    county_fips_all: '30059|30007',
    county: 'Meagher',
    county_names_all: 'Meagher|Broadwater',
    county_weights: '{"30059": 98.62, "30007": 1.38}',
    density: 0.4,
    imprecise: false,
    latitude: 46.69476,
    longitude: -111.04729,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59645',
  },
  {
    city: 'Winston',
    county_fips: 30007,
    county_fips_all: '30007',
    county: 'Broadwater',
    county_names_all: 'Broadwater',
    county_weights: '{"30007": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 46.46726,
    longitude: -111.65138,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59647',
  },
  {
    city: 'Wolf Creek',
    county_fips: 30049,
    county_fips_all: '30049',
    county: 'Lewis and Clark',
    county_names_all: 'Lewis and Clark',
    county_weights: '{"30049": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 47.07221,
    longitude: -112.14059,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59648',
  },
  {
    city: 'Butte',
    county_fips: 30093,
    county_fips_all: '30093|30043|30023',
    county: 'Silver Bow',
    county_names_all: 'Silver Bow|Jefferson|Deer Lodge',
    county_weights: '{"30093": 48.47, "30043": 46.89, "30023": 4.64}',
    density: 25.9,
    imprecise: false,
    latitude: 46.03497,
    longitude: -112.46087,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 34232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59701',
  },
  {
    city: 'Alder',
    county_fips: 30057,
    county_fips_all: '30057',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"30057": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 45.06801,
    longitude: -112.08613,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59710',
  },
  {
    city: 'Anaconda',
    county_fips: 30023,
    county_fips_all: '30023|30039|30093',
    county: 'Deer Lodge',
    county_names_all: 'Deer Lodge|Granite|Silver Bow',
    county_weights: '{"30023": 63.44, "30039": 25.76, "30093": 10.8}',
    density: 6.6,
    imprecise: false,
    latitude: 46.09734,
    longitude: -113.10317,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59711',
  },
  {
    city: 'Avon',
    county_fips: 30077,
    county_fips_all: '30077',
    county: 'Powell',
    county_names_all: 'Powell',
    county_weights: '{"30077": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 46.67973,
    longitude: -112.61228,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59713',
  },
  {
    city: 'Belgrade',
    county_fips: 30031,
    county_fips_all: '30031',
    county: 'Gallatin',
    county_names_all: 'Gallatin',
    county_weights: '{"30031": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 45.97538,
    longitude: -111.13112,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 24282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59714',
  },
  {
    city: 'Bozeman',
    county_fips: 30031,
    county_fips_all: '30031|30067',
    county: 'Gallatin',
    county_names_all: 'Gallatin|Park',
    county_weights: '{"30031": 91.82, "30067": 8.18}',
    density: 51.9,
    imprecise: false,
    latitude: 45.6928,
    longitude: -110.9065,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 39643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59715',
  },
  {
    city: 'Big Sky',
    county_fips: 30057,
    county_fips_all: '30057|30031',
    county: 'Madison',
    county_names_all: 'Madison|Gallatin',
    county_weights: '{"30057": 55.87, "30031": 44.13}',
    density: 10.7,
    imprecise: false,
    latitude: 45.28578,
    longitude: -111.3873,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59716',
  },
  {
    city: 'Bozeman',
    county_fips: 30031,
    county_fips_all: '30031',
    county: 'Gallatin',
    county_names_all: 'Gallatin',
    county_weights: '{"30031": 100}',
    density: 104.7,
    imprecise: false,
    latitude: 45.63999,
    longitude: -111.16978,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59718',
  },
  {
    city: 'Cameron',
    county_fips: 30057,
    county_fips_all: '30057',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"30057": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 44.95821,
    longitude: -111.59366,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59720',
  },
  {
    city: 'Cardwell',
    county_fips: 30043,
    county_fips_all: '30043|30057',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Madison',
    county_weights: '{"30043": 61.65, "30057": 38.35}',
    density: 0.8,
    imprecise: false,
    latitude: 45.85189,
    longitude: -111.88177,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59721',
  },
  {
    city: 'Deer Lodge',
    county_fips: 30077,
    county_fips_all: '30077|30023',
    county: 'Powell',
    county_names_all: 'Powell|Deer Lodge',
    county_weights: '{"30077": 85.75, "30023": 14.25}',
    density: 5.7,
    imprecise: false,
    latitude: 46.35143,
    longitude: -112.75684,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59722',
  },
  {
    city: 'Dell',
    county_fips: 30001,
    county_fips_all: '30001',
    county: 'Beaverhead',
    county_names_all: 'Beaverhead',
    county_weights: '{"30001": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 44.67716,
    longitude: -112.79359,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59724',
  },
  {
    city: 'Dillon',
    county_fips: 30001,
    county_fips_all: '30001|30057',
    county: 'Beaverhead',
    county_names_all: 'Beaverhead|Madison',
    county_weights: '{"30001": 96.05, "30057": 3.95}',
    density: 1.6,
    imprecise: false,
    latitude: 45.06267,
    longitude: -112.85714,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59725',
  },
  {
    city: 'Divide',
    county_fips: 30093,
    county_fips_all: '30093|30001',
    county: 'Silver Bow',
    county_names_all: 'Silver Bow|Beaverhead',
    county_weights: '{"30093": 79.64, "30001": 20.36}',
    density: 0.4,
    imprecise: false,
    latitude: 45.78797,
    longitude: -112.79394,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59727',
  },
  {
    city: 'Elliston',
    county_fips: 30077,
    county_fips_all: '30077',
    county: 'Powell',
    county_names_all: 'Powell',
    county_weights: '{"30077": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 46.50487,
    longitude: -112.41135,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59728',
  },
  {
    city: 'Ennis',
    county_fips: 30057,
    county_fips_all: '30057',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"30057": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 45.31343,
    longitude: -111.64827,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59729',
  },
  {
    city: 'Gallatin Gateway',
    county_fips: 30031,
    county_fips_all: '30031|30057',
    county: 'Gallatin',
    county_names_all: 'Gallatin|Madison',
    county_weights: '{"30031": 94.04, "30057": 5.96}',
    density: 1.4,
    imprecise: false,
    latitude: 45.30988,
    longitude: -111.19025,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59730',
  },
  {
    city: 'Garrison',
    county_fips: 30077,
    county_fips_all: '30077',
    county: 'Powell',
    county_names_all: 'Powell',
    county_weights: '{"30077": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 46.58455,
    longitude: -112.76326,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59731',
  },
  {
    city: 'Glen',
    county_fips: 30001,
    county_fips_all: '30001|30057',
    county: 'Beaverhead',
    county_names_all: 'Beaverhead|Madison',
    county_weights: '{"30001": 58.45, "30057": 41.55}',
    density: 0.4,
    imprecise: false,
    latitude: 45.48899,
    longitude: -112.69457,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59732',
  },
  {
    city: 'Gold Creek',
    county_fips: 30077,
    county_fips_all: '30077',
    county: 'Powell',
    county_names_all: 'Powell',
    county_weights: '{"30077": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 46.54922,
    longitude: -112.94987,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59733',
  },
  {
    city: 'Harrison',
    county_fips: 30057,
    county_fips_all: '30057',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"30057": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 45.65775,
    longitude: -111.84615,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59735',
  },
  {
    city: 'Jackson',
    county_fips: 30001,
    county_fips_all: '30001',
    county: 'Beaverhead',
    county_names_all: 'Beaverhead',
    county_weights: '{"30001": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.34242,
    longitude: -113.3458,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59736',
  },
  {
    city: 'Lima',
    county_fips: 30001,
    county_fips_all: '30001',
    county: 'Beaverhead',
    county_names_all: 'Beaverhead',
    county_weights: '{"30001": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 44.65378,
    longitude: -112.16963,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59739',
  },
  {
    city: 'McAllister',
    county_fips: 30057,
    county_fips_all: '30057',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"30057": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 45.49871,
    longitude: -111.81159,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59740',
  },
  {
    city: 'Manhattan',
    county_fips: 30031,
    county_fips_all: '30031',
    county: 'Gallatin',
    county_names_all: 'Gallatin',
    county_weights: '{"30031": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 45.77265,
    longitude: -111.3638,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59741',
  },
  {
    city: 'Melrose',
    county_fips: 30001,
    county_fips_all: '30001|30057|30093',
    county: 'Beaverhead',
    county_names_all: 'Beaverhead|Madison|Silver Bow',
    county_weights: '{"30001": 62.75, "30057": 27.89, "30093": 9.36}',
    density: 0.3,
    imprecise: false,
    latitude: 45.60068,
    longitude: -112.74964,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59743',
  },
  {
    city: 'Norris',
    county_fips: 30057,
    county_fips_all: '30057',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"30057": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.5941,
    longitude: -111.60658,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 98,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59745',
  },
  {
    city: 'Polaris',
    county_fips: 30001,
    county_fips_all: '30001',
    county: 'Beaverhead',
    county_names_all: 'Beaverhead',
    county_weights: '{"30001": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.37137,
    longitude: -113.05332,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59746',
  },
  {
    city: 'Pony',
    county_fips: 30057,
    county_fips_all: '30057',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"30057": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 45.69862,
    longitude: -111.93281,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59747',
  },
  {
    city: 'Ramsay',
    county_fips: 30093,
    county_fips_all: '30093',
    county: 'Silver Bow',
    county_names_all: 'Silver Bow',
    county_weights: '{"30093": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 46.04611,
    longitude: -112.69601,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59748',
  },
  {
    city: 'Sheridan',
    county_fips: 30057,
    county_fips_all: '30057',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"30057": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 45.44332,
    longitude: -112.09548,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59749',
  },
  {
    city: 'Butte',
    county_fips: 30093,
    county_fips_all: '30093',
    county: 'Silver Bow',
    county_names_all: 'Silver Bow',
    county_weights: '{"30093": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 45.91857,
    longitude: -112.68323,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59750',
  },
  {
    city: 'Silver Star',
    county_fips: 30057,
    county_fips_all: '30057',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"30057": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 45.69001,
    longitude: -112.29755,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59751',
  },
  {
    city: 'Three Forks',
    county_fips: 30031,
    county_fips_all: '30031|30043|30007',
    county: 'Gallatin',
    county_names_all: 'Gallatin|Jefferson|Broadwater',
    county_weights: '{"30031": 62.21, "30043": 19.43, "30007": 18.36}',
    density: 5.2,
    imprecise: false,
    latitude: 45.92412,
    longitude: -111.52577,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59752',
  },
  {
    city: 'Twin Bridges',
    county_fips: 30057,
    county_fips_all: '30057',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"30057": 100}',
    density: 1,
    imprecise: false,
    latitude: 45.52435,
    longitude: -112.35339,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59754',
  },
  {
    city: 'Virginia City',
    county_fips: 30057,
    county_fips_all: '30057',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"30057": 100}',
    density: 1,
    imprecise: false,
    latitude: 45.27174,
    longitude: -111.94274,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59755',
  },
  {
    city: 'Warm Springs',
    county_fips: 30023,
    county_fips_all: '30023',
    county: 'Deer Lodge',
    county_names_all: 'Deer Lodge',
    county_weights: '{"30023": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 46.17418,
    longitude: -112.83453,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59756',
  },
  {
    city: 'West Yellowstone',
    county_fips: 30031,
    county_fips_all: '30031',
    county: 'Gallatin',
    county_names_all: 'Gallatin',
    county_weights: '{"30031": 100}',
    density: 2,
    imprecise: false,
    latitude: 44.78962,
    longitude: -111.19348,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59758',
  },
  {
    city: 'Whitehall',
    county_fips: 30043,
    county_fips_all: '30043|30057|30093',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Madison|Silver Bow',
    county_weights: '{"30043": 61.27, "30057": 32.24, "30093": 6.49}',
    density: 3.2,
    imprecise: false,
    latitude: 45.83972,
    longitude: -112.16233,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59759',
  },
  {
    city: 'Willow Creek',
    county_fips: 30031,
    county_fips_all: '30031',
    county: 'Gallatin',
    county_names_all: 'Gallatin',
    county_weights: '{"30031": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 45.76267,
    longitude: -111.60386,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59760',
  },
  {
    city: 'Wisdom',
    county_fips: 30001,
    county_fips_all: '30001',
    county: 'Beaverhead',
    county_names_all: 'Beaverhead',
    county_weights: '{"30001": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 45.60427,
    longitude: -113.52661,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59761',
  },
  {
    city: 'Wise River',
    county_fips: 30023,
    county_fips_all: '30023|30001',
    county: 'Deer Lodge',
    county_names_all: 'Deer Lodge|Beaverhead',
    county_weights: '{"30023": 56.11, "30001": 43.89}',
    density: 0.2,
    imprecise: false,
    latitude: 45.82231,
    longitude: -113.15271,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59762',
  },
  {
    city: 'Missoula',
    county_fips: 30063,
    county_fips_all: '30063',
    county: 'Missoula',
    county_names_all: 'Missoula',
    county_weights: '{"30063": 100}',
    density: 1548.1,
    imprecise: false,
    latitude: 46.85505,
    longitude: -114.01009,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 30916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59801',
  },
  {
    city: 'Missoula',
    county_fips: 30063,
    county_fips_all: '30063',
    county: 'Missoula',
    county_names_all: 'Missoula',
    county_weights: '{"30063": 100}',
    density: 169,
    imprecise: false,
    latitude: 46.90569,
    longitude: -113.92077,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 19864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59802',
  },
  {
    city: 'Missoula',
    county_fips: 30063,
    county_fips_all: '30063',
    county: 'Missoula',
    county_names_all: 'Missoula',
    county_weights: '{"30063": 100}',
    density: 73.3,
    imprecise: false,
    latitude: 46.77781,
    longitude: -113.95826,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59803',
  },
  {
    city: 'Missoula',
    county_fips: 30063,
    county_fips_all: '30063',
    county: 'Missoula',
    county_names_all: 'Missoula',
    county_weights: '{"30063": 100}',
    density: 24.8,
    imprecise: false,
    latitude: 46.90084,
    longitude: -114.25066,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59804',
  },
  {
    city: 'Missoula',
    county_fips: 30063,
    county_fips_all: '30063',
    county: 'Missoula',
    county_names_all: 'Missoula',
    county_weights: '{"30063": 100}',
    density: 58,
    imprecise: false,
    latitude: 46.97984,
    longitude: -114.064,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 23574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59808',
  },
  {
    city: 'Alberton',
    county_fips: 30061,
    county_fips_all: '30061|30063',
    county: 'Mineral',
    county_names_all: 'Mineral|Missoula',
    county_weights: '{"30061": 72.05, "30063": 27.95}',
    density: 1.9,
    imprecise: false,
    latitude: 46.89803,
    longitude: -114.61474,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59820',
  },
  {
    city: 'Arlee',
    county_fips: 30063,
    county_fips_all: '30063|30047|30089',
    county: 'Missoula',
    county_names_all: 'Missoula|Lake|Sanders',
    county_weights: '{"30063": 43.96, "30047": 37.18, "30089": 18.85}',
    density: 3.6,
    imprecise: false,
    latitude: 47.17603,
    longitude: -114.00431,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59821',
  },
  {
    city: 'Bonner',
    county_fips: 30063,
    county_fips_all: '30063',
    county: 'Missoula',
    county_names_all: 'Missoula',
    county_weights: '{"30063": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 46.96334,
    longitude: -113.59753,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59823',
  },
  {
    city: 'Charlo',
    county_fips: 30047,
    county_fips_all: '30047',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"30047": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 47.41817,
    longitude: -114.20362,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59824',
  },
  {
    city: 'Clinton',
    county_fips: 30039,
    county_fips_all: '30039|30063',
    county: 'Granite',
    county_names_all: 'Granite|Missoula',
    county_weights: '{"30039": 61.49, "30063": 38.51}',
    density: 2.3,
    imprecise: false,
    latitude: 46.66009,
    longitude: -113.66421,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59825',
  },
  {
    city: 'Condon',
    county_fips: 30063,
    county_fips_all: '30063',
    county: 'Missoula',
    county_names_all: 'Missoula',
    county_weights: '{"30063": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 47.46339,
    longitude: -113.69827,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59826',
  },
  {
    city: 'Conner',
    county_fips: 30081,
    county_fips_all: '30081',
    county: 'Ravalli',
    county_names_all: 'Ravalli',
    county_weights: '{"30081": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 45.88649,
    longitude: -114.08346,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59827',
  },
  {
    city: 'Corvallis',
    county_fips: 30081,
    county_fips_all: '30081',
    county: 'Ravalli',
    county_names_all: 'Ravalli',
    county_weights: '{"30081": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 46.33478,
    longitude: -113.96444,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59828',
  },
  {
    city: 'Darby',
    county_fips: 30081,
    county_fips_all: '30081',
    county: 'Ravalli',
    county_names_all: 'Ravalli',
    county_weights: '{"30081": 100}',
    density: 1,
    imprecise: false,
    latitude: 45.79814,
    longitude: -114.2614,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59829',
  },
  {
    city: 'De Borgia',
    county_fips: 30061,
    county_fips_all: '30061',
    county: 'Mineral',
    county_names_all: 'Mineral',
    county_weights: '{"30061": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 47.43419,
    longitude: -115.45896,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59830',
  },
  {
    city: 'Dixon',
    county_fips: 30089,
    county_fips_all: '30089',
    county: 'Sanders',
    county_names_all: 'Sanders',
    county_weights: '{"30089": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 47.27732,
    longitude: -114.36296,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59831',
  },
  {
    city: 'Drummond',
    county_fips: 30039,
    county_fips_all: '30039',
    county: 'Granite',
    county_names_all: 'Granite',
    county_weights: '{"30039": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 46.67864,
    longitude: -113.22904,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59832',
  },
  {
    city: 'Florence',
    county_fips: 30081,
    county_fips_all: '30081|30063',
    county: 'Ravalli',
    county_names_all: 'Ravalli|Missoula',
    county_weights: '{"30081": 70.2, "30063": 29.8}',
    density: 15.9,
    imprecise: false,
    latitude: 46.64437,
    longitude: -114.07678,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59833',
  },
  {
    city: 'Frenchtown',
    county_fips: 30063,
    county_fips_all: '30063',
    county: 'Missoula',
    county_names_all: 'Missoula',
    county_weights: '{"30063": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 47.06979,
    longitude: -114.2221,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59834',
  },
  {
    city: 'Hall',
    county_fips: 30039,
    county_fips_all: '30039',
    county: 'Granite',
    county_names_all: 'Granite',
    county_weights: '{"30039": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 46.53898,
    longitude: -113.27688,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59837',
  },
  {
    city: 'Hamilton',
    county_fips: 30081,
    county_fips_all: '30081',
    county: 'Ravalli',
    county_names_all: 'Ravalli',
    county_weights: '{"30081": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 46.17558,
    longitude: -114.11674,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59840',
  },
  {
    city: 'Pinesdale',
    county_fips: 30081,
    county_fips_all: '30081',
    county: 'Ravalli',
    county_names_all: 'Ravalli',
    county_weights: '{"30081": 100}',
    density: 246.7,
    imprecise: false,
    latitude: 46.33384,
    longitude: -114.22319,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59841',
  },
  {
    city: 'Haugan',
    county_fips: 30061,
    county_fips_all: '30061',
    county: 'Mineral',
    county_names_all: 'Mineral',
    county_weights: '{"30061": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 47.32526,
    longitude: -115.40107,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59842',
  },
  {
    city: 'Helmville',
    county_fips: 30077,
    county_fips_all: '30077',
    county: 'Powell',
    county_names_all: 'Powell',
    county_weights: '{"30077": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 46.84897,
    longitude: -113.01114,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59843',
  },
  {
    city: 'Heron',
    county_fips: 30089,
    county_fips_all: '30089',
    county: 'Sanders',
    county_names_all: 'Sanders',
    county_weights: '{"30089": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 48.00803,
    longitude: -115.9707,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59844',
  },
  {
    city: 'Hot Springs',
    county_fips: 30089,
    county_fips_all: '30089|30047|30029',
    county: 'Sanders',
    county_names_all: 'Sanders|Lake|Flathead',
    county_weights: '{"30089": 66.97, "30047": 17.32, "30029": 15.71}',
    density: 1.1,
    imprecise: false,
    latitude: 47.65892,
    longitude: -114.54734,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59845',
  },
  {
    city: 'Huson',
    county_fips: 30063,
    county_fips_all: '30063',
    county: 'Missoula',
    county_names_all: 'Missoula',
    county_weights: '{"30063": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 47.14899,
    longitude: -114.50615,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59846',
  },
  {
    city: 'Lolo',
    county_fips: 30063,
    county_fips_all: '30063|16049',
    county: 'Missoula',
    county_names_all: 'Missoula|Idaho',
    county_weights: '{"30063": 94.85, "16049": 5.15}',
    density: 7.7,
    imprecise: false,
    latitude: 46.73105,
    longitude: -114.37782,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59847',
  },
  {
    city: 'Lonepine',
    county_fips: 30089,
    county_fips_all: '30089',
    county: 'Sanders',
    county_names_all: 'Sanders',
    county_weights: '{"30089": 100}',
    density: 1,
    imprecise: false,
    latitude: 47.71526,
    longitude: -114.68162,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59848',
  },
  {
    city: 'Milltown',
    county_fips: 30063,
    county_fips_all: '30063',
    county: 'Missoula',
    county_names_all: 'Missoula',
    county_weights: '{"30063": 100}',
    density: 158.8,
    imprecise: false,
    latitude: 46.87215,
    longitude: -113.87348,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59851',
  },
  {
    city: 'Noxon',
    county_fips: 30089,
    county_fips_all: '30089',
    county: 'Sanders',
    county_names_all: 'Sanders',
    county_weights: '{"30089": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 48.0571,
    longitude: -115.81522,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59853',
  },
  {
    city: 'Ovando',
    county_fips: 30077,
    county_fips_all: '30077',
    county: 'Powell',
    county_names_all: 'Powell',
    county_weights: '{"30077": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 47.26481,
    longitude: -113.18997,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59854',
  },
  {
    city: 'Pablo',
    county_fips: 30047,
    county_fips_all: '30047',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"30047": 100}',
    density: 458.4,
    imprecise: false,
    latitude: 47.60032,
    longitude: -114.11787,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59855',
  },
  {
    city: 'Paradise',
    county_fips: 30089,
    county_fips_all: '30089',
    county: 'Sanders',
    county_names_all: 'Sanders',
    county_weights: '{"30089": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 47.38237,
    longitude: -114.73627,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59856',
  },
  {
    city: 'Philipsburg',
    county_fips: 30039,
    county_fips_all: '30039',
    county: 'Granite',
    county_names_all: 'Granite',
    county_weights: '{"30039": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 46.29584,
    longitude: -113.48371,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59858',
  },
  {
    city: 'Plains',
    county_fips: 30089,
    county_fips_all: '30089',
    county: 'Sanders',
    county_names_all: 'Sanders',
    county_weights: '{"30089": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 47.5205,
    longitude: -114.80396,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59859',
  },
  {
    city: 'Polson',
    county_fips: 30047,
    county_fips_all: '30047',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"30047": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 47.71314,
    longitude: -114.17832,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 11897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59860',
  },
  {
    city: 'Ravalli',
    county_fips: 30047,
    county_fips_all: '30047',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"30047": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 47.29397,
    longitude: -114.17637,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59863',
  },
  {
    city: 'Ronan',
    county_fips: 30047,
    county_fips_all: '30047',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"30047": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 47.53324,
    longitude: -114.11741,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59864',
  },
  {
    city: 'Saint Ignatius',
    county_fips: 30047,
    county_fips_all: '30047',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"30047": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 47.33184,
    longitude: -114.0045,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59865',
  },
  {
    city: 'Saint Regis',
    county_fips: 30061,
    county_fips_all: '30061|30089',
    county: 'Mineral',
    county_names_all: 'Mineral|Sanders',
    county_weights: '{"30061": 90.51, "30089": 9.49}',
    density: 2,
    imprecise: false,
    latitude: 47.32207,
    longitude: -115.12329,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59866',
  },
  {
    city: 'Saltese',
    county_fips: 30061,
    county_fips_all: '30061',
    county: 'Mineral',
    county_names_all: 'Mineral',
    county_weights: '{"30061": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 47.4028,
    longitude: -115.54993,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 85,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59867',
  },
  {
    city: 'Seeley Lake',
    county_fips: 30063,
    county_fips_all: '30063|30077',
    county: 'Missoula',
    county_names_all: 'Missoula|Powell',
    county_weights: '{"30063": 95.82, "30077": 4.18}',
    density: 2.7,
    imprecise: false,
    latitude: 47.21401,
    longitude: -113.53535,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59868',
  },
  {
    city: 'Stevensville',
    county_fips: 30081,
    county_fips_all: '30081',
    county: 'Ravalli',
    county_names_all: 'Ravalli',
    county_weights: '{"30081": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 46.51596,
    longitude: -114.0618,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59870',
  },
  {
    city: 'Sula',
    county_fips: 30081,
    county_fips_all: '30081',
    county: 'Ravalli',
    county_names_all: 'Ravalli',
    county_weights: '{"30081": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 45.89666,
    longitude: -113.81366,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59871',
  },
  {
    city: 'Superior',
    county_fips: 30061,
    county_fips_all: '30061',
    county: 'Mineral',
    county_names_all: 'Mineral',
    county_weights: '{"30061": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 47.10282,
    longitude: -114.90339,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59872',
  },
  {
    city: 'Thompson Falls',
    county_fips: 30089,
    county_fips_all: '30089',
    county: 'Sanders',
    county_names_all: 'Sanders',
    county_weights: '{"30089": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 47.6972,
    longitude: -115.27357,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59873',
  },
  {
    city: 'Trout Creek',
    county_fips: 30089,
    county_fips_all: '30089',
    county: 'Sanders',
    county_names_all: 'Sanders',
    county_weights: '{"30089": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 47.80675,
    longitude: -115.60749,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59874',
  },
  {
    city: 'Victor',
    county_fips: 30081,
    county_fips_all: '30081',
    county: 'Ravalli',
    county_names_all: 'Ravalli',
    county_weights: '{"30081": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 46.40793,
    longitude: -114.26151,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59875',
  },
  {
    city: 'Kalispell',
    county_fips: 30029,
    county_fips_all: '30029',
    county: 'Flathead',
    county_names_all: 'Flathead',
    county_weights: '{"30029": 100}',
    density: 52,
    imprecise: false,
    latitude: 48.22873,
    longitude: -114.40564,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 63161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59901',
  },
  {
    city: 'Big Arm',
    county_fips: 30047,
    county_fips_all: '30047',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"30047": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 47.82409,
    longitude: -114.23271,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59910',
  },
  {
    city: 'Bigfork',
    county_fips: 30047,
    county_fips_all: '30047|30029',
    county: 'Lake',
    county_names_all: 'Lake|Flathead',
    county_weights: '{"30047": 83.62, "30029": 16.38}',
    density: 7.5,
    imprecise: false,
    latitude: 47.86041,
    longitude: -113.88552,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59911',
  },
  {
    city: 'Columbia Falls',
    county_fips: 30029,
    county_fips_all: '30029',
    county: 'Flathead',
    county_names_all: 'Flathead',
    county_weights: '{"30029": 100}',
    density: 32.2,
    imprecise: false,
    latitude: 48.43879,
    longitude: -114.16898,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59912',
  },
  {
    city: 'Coram',
    county_fips: 30029,
    county_fips_all: '30029',
    county: 'Flathead',
    county_names_all: 'Flathead',
    county_weights: '{"30029": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 48.41391,
    longitude: -113.95045,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59913',
  },
  {
    city: 'Dayton',
    county_fips: 30047,
    county_fips_all: '30047',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"30047": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 47.86878,
    longitude: -114.29546,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59914',
  },
  {
    city: 'Elmo',
    county_fips: 30047,
    county_fips_all: '30047',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"30047": 100}',
    density: 3,
    imprecise: false,
    latitude: 47.82025,
    longitude: -114.41124,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59915',
  },
  {
    city: 'Essex',
    county_fips: 30029,
    county_fips_all: '30029',
    county: 'Flathead',
    county_names_all: 'Flathead',
    county_weights: '{"30029": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 48.31716,
    longitude: -113.65779,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59916',
  },
  {
    city: 'Eureka',
    county_fips: 30053,
    county_fips_all: '30053',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"30053": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 48.90614,
    longitude: -114.91359,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59917',
  },
  {
    city: 'Fortine',
    county_fips: 30053,
    county_fips_all: '30053',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"30053": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 48.75766,
    longitude: -114.8077,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59918',
  },
  {
    city: 'Hungry Horse',
    county_fips: 30029,
    county_fips_all: '30029',
    county: 'Flathead',
    county_names_all: 'Flathead',
    county_weights: '{"30029": 100}',
    density: 115.4,
    imprecise: false,
    latitude: 48.3776,
    longitude: -114.05645,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59919',
  },
  {
    city: 'Kila',
    county_fips: 30029,
    county_fips_all: '30029',
    county: 'Flathead',
    county_names_all: 'Flathead',
    county_weights: '{"30029": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 48.06412,
    longitude: -114.53464,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59920',
  },
  {
    city: 'Lakeside',
    county_fips: 30029,
    county_fips_all: '30029|30047',
    county: 'Flathead',
    county_names_all: 'Flathead|Lake',
    county_weights: '{"30029": 93.2, "30047": 6.8}',
    density: 23.6,
    imprecise: false,
    latitude: 47.99962,
    longitude: -114.22227,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59922',
  },
  {
    city: 'Libby',
    county_fips: 30053,
    county_fips_all: '30053',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"30053": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 48.26996,
    longitude: -115.31073,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59923',
  },
  {
    city: 'Marion',
    county_fips: 30029,
    county_fips_all: '30029',
    county: 'Flathead',
    county_names_all: 'Flathead',
    county_weights: '{"30029": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 48.04732,
    longitude: -114.83045,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59925',
  },
  {
    city: 'Martin City',
    county_fips: 30029,
    county_fips_all: '30029',
    county: 'Flathead',
    county_names_all: 'Flathead',
    county_weights: '{"30029": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 48.36294,
    longitude: -114.00459,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59926',
  },
  {
    city: 'Olney',
    county_fips: 30029,
    county_fips_all: '30029',
    county: 'Flathead',
    county_names_all: 'Flathead',
    county_weights: '{"30029": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 48.56021,
    longitude: -114.717,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59927',
  },
  {
    city: 'Polebridge',
    county_fips: 30029,
    county_fips_all: '30029',
    county: 'Flathead',
    county_names_all: 'Flathead',
    county_weights: '{"30029": 100}',
    density: 0,
    imprecise: false,
    latitude: 48.79745,
    longitude: -114.29117,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 86,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59928',
  },
  {
    city: 'Proctor',
    county_fips: 30047,
    county_fips_all: '30047',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"30047": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 47.92365,
    longitude: -114.40272,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59929',
  },
  {
    city: 'Rexford',
    county_fips: 30053,
    county_fips_all: '30053',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"30053": 100}',
    density: 5,
    imprecise: false,
    latitude: 48.86277,
    longitude: -115.14514,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59930',
  },
  {
    city: 'Rollins',
    county_fips: 30047,
    county_fips_all: '30047',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"30047": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 47.9208,
    longitude: -114.25486,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59931',
  },
  {
    city: 'Somers',
    county_fips: 30029,
    county_fips_all: '30029',
    county: 'Flathead',
    county_names_all: 'Flathead',
    county_weights: '{"30029": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 48.0502,
    longitude: -114.24624,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59932',
  },
  {
    city: 'Stryker',
    county_fips: 30053,
    county_fips_all: '30053',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"30053": 100}',
    density: 0,
    imprecise: false,
    latitude: 48.70858,
    longitude: -114.76694,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59933',
  },
  {
    city: 'Trego',
    county_fips: 30053,
    county_fips_all: '30053',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"30053": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 48.63437,
    longitude: -114.94446,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59934',
  },
  {
    city: 'Troy',
    county_fips: 30053,
    county_fips_all: '30053',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"30053": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 48.64726,
    longitude: -115.83505,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59935',
  },
  {
    city: 'West Glacier',
    county_fips: 30029,
    county_fips_all: '30029',
    county: 'Flathead',
    county_names_all: 'Flathead',
    county_weights: '{"30029": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.17178,
    longitude: -113.46357,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59936',
  },
  {
    city: 'Whitefish',
    county_fips: 30029,
    county_fips_all: '30029',
    county: 'Flathead',
    county_names_all: 'Flathead',
    county_weights: '{"30029": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 48.43893,
    longitude: -114.49769,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59937',
  },
  {
    city: 'Antioch',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 280.8,
    imprecise: false,
    latitude: 42.4674,
    longitude: -88.09419,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60002',
  },
  {
    city: 'Arlington Heights',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1800.2,
    imprecise: false,
    latitude: 42.11206,
    longitude: -87.97895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60004',
  },
  {
    city: 'Arlington Heights',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1695.1,
    imprecise: false,
    latitude: 42.06518,
    longitude: -87.98676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60005',
  },
  {
    city: 'Elk Grove Village',
    county_fips: 17031,
    county_fips_all: '17031|17043',
    county: 'Cook',
    county_names_all: 'Cook|DuPage',
    county_weights: '{"17031": 96.01, "17043": 3.99}',
    density: 694.9,
    imprecise: false,
    latitude: 42.01431,
    longitude: -87.99828,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60007',
  },
  {
    city: 'Rolling Meadows',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1716.8,
    imprecise: false,
    latitude: 42.0739,
    longitude: -88.0229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60008',
  },
  {
    city: 'Barrington',
    county_fips: 17031,
    county_fips_all: '17031|17097|17111|17089',
    county: 'Cook',
    county_names_all: 'Cook|Lake|McHenry|Kane',
    county_weights:
      '{"17031": 50.63, "17097": 38.48, "17111": 9.24, "17089": 1.65}',
    density: 238.4,
    imprecise: false,
    latitude: 42.15255,
    longitude: -88.16519,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60010',
  },
  {
    city: 'Crystal Lake',
    county_fips: 17111,
    county_fips_all: '17111',
    county: 'McHenry',
    county_names_all: 'McHenry',
    county_weights: '{"17111": 100}',
    density: 276,
    imprecise: false,
    latitude: 42.27199,
    longitude: -88.31157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60012',
  },
  {
    city: 'Cary',
    county_fips: 17111,
    county_fips_all: '17111|17097',
    county: 'McHenry',
    county_names_all: 'McHenry|Lake',
    county_weights: '{"17111": 89.39, "17097": 10.61}',
    density: 712.6,
    imprecise: false,
    latitude: 42.22027,
    longitude: -88.23568,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60013',
  },
  {
    city: 'Crystal Lake',
    county_fips: 17111,
    county_fips_all: '17111',
    county: 'McHenry',
    county_names_all: 'McHenry',
    county_weights: '{"17111": 100}',
    density: 747.4,
    imprecise: false,
    latitude: 42.23126,
    longitude: -88.32679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60014',
  },
  {
    city: 'Deerfield',
    county_fips: 17097,
    county_fips_all: '17097|17031',
    county: 'Lake',
    county_names_all: 'Lake|Cook',
    county_weights: '{"17097": 96.28, "17031": 3.72}',
    density: 795.7,
    imprecise: false,
    latitude: 42.17239,
    longitude: -87.87486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60015',
  },
  {
    city: 'Des Plaines',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1939.5,
    imprecise: false,
    latitude: 42.05232,
    longitude: -87.8899,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 60898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60016',
  },
  {
    city: 'Des Plaines',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 650.9,
    imprecise: false,
    latitude: 41.99629,
    longitude: -87.89846,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60018',
  },
  {
    city: 'Fox Lake',
    county_fips: 17097,
    county_fips_all: '17097|17111',
    county: 'Lake',
    county_names_all: 'Lake|McHenry',
    county_weights: '{"17097": 99.5, "17111": 0.5}',
    density: 899.1,
    imprecise: false,
    latitude: 42.39543,
    longitude: -88.17349,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60020',
  },
  {
    city: 'Fox River Grove',
    county_fips: 17111,
    county_fips_all: '17111|17097',
    county: 'McHenry',
    county_names_all: 'McHenry|Lake',
    county_weights: '{"17111": 94.19, "17097": 5.81}',
    density: 941.9,
    imprecise: false,
    latitude: 42.19511,
    longitude: -88.21768,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60021',
  },
  {
    city: 'Glencoe',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 850.3,
    imprecise: false,
    latitude: 42.13637,
    longitude: -87.7664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60022',
  },
  {
    city: 'Glenview',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1534.4,
    imprecise: false,
    latitude: 42.07466,
    longitude: -87.81204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60025',
  },
  {
    city: 'Glenview',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1332.6,
    imprecise: false,
    latitude: 42.09221,
    longitude: -87.83789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60026',
  },
  {
    city: 'Golf',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 446,
    imprecise: false,
    latitude: 42.05857,
    longitude: -87.78496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60029',
  },
  {
    city: 'Grayslake',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 516.4,
    imprecise: false,
    latitude: 42.33536,
    longitude: -88.04519,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60030',
  },
  {
    city: 'Gurnee',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 753.3,
    imprecise: false,
    latitude: 42.37494,
    longitude: -87.94119,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60031',
  },
  {
    city: 'Harvard',
    county_fips: 17111,
    county_fips_all: '17111|17007',
    county: 'McHenry',
    county_names_all: 'McHenry|Boone',
    county_weights: '{"17111": 94.07, "17007": 5.93}',
    density: 42.7,
    imprecise: false,
    latitude: 42.42333,
    longitude: -88.61104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60033',
  },
  {
    city: 'Hebron',
    county_fips: 17111,
    county_fips_all: '17111',
    county: 'McHenry',
    county_names_all: 'McHenry',
    county_weights: '{"17111": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 42.45869,
    longitude: -88.42665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60034',
  },
  {
    city: 'Highland Park',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 926.6,
    imprecise: false,
    latitude: 42.18358,
    longitude: -87.8106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60035',
  },
  {
    city: 'Highwood',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 2673.8,
    imprecise: false,
    latitude: 42.20652,
    longitude: -87.81274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60040',
  },
  {
    city: 'Ingleside',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 364.7,
    imprecise: false,
    latitude: 42.36939,
    longitude: -88.15309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60041',
  },
  {
    city: 'Island Lake',
    county_fips: 17097,
    county_fips_all: '17097|17111',
    county: 'Lake',
    county_names_all: 'Lake|McHenry',
    county_weights: '{"17097": 56.76, "17111": 43.24}',
    density: 705.7,
    imprecise: false,
    latitude: 42.27913,
    longitude: -88.19777,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60042',
  },
  {
    city: 'Kenilworth',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1591,
    imprecise: false,
    latitude: 42.08882,
    longitude: -87.71445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60043',
  },
  {
    city: 'Lake Bluff',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 586.7,
    imprecise: false,
    latitude: 42.2842,
    longitude: -87.86392,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60044',
  },
  {
    city: 'Lake Forest',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 381.8,
    imprecise: false,
    latitude: 42.23807,
    longitude: -87.87006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60045',
  },
  {
    city: 'Lake Villa',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 582.2,
    imprecise: false,
    latitude: 42.41572,
    longitude: -88.06094,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60046',
  },
  {
    city: 'Lake Zurich',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 489.8,
    imprecise: false,
    latitude: 42.20202,
    longitude: -88.04522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60047',
  },
  {
    city: 'Libertyville',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 396,
    imprecise: false,
    latitude: 42.29494,
    longitude: -87.9466,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60048',
  },
  {
    city: 'Mchenry',
    county_fips: 17111,
    county_fips_all: '17111|17097',
    county: 'McHenry',
    county_names_all: 'McHenry|Lake',
    county_weights: '{"17111": 99.49, "17097": 0.51}',
    density: 464.3,
    imprecise: false,
    latitude: 42.32915,
    longitude: -88.29363,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60050',
  },
  {
    city: 'Mchenry',
    county_fips: 17111,
    county_fips_all: '17111|17097',
    county: 'McHenry',
    county_names_all: 'McHenry|Lake',
    county_weights: '{"17111": 82.13, "17097": 17.87}',
    density: 286.5,
    imprecise: false,
    latitude: 42.35099,
    longitude: -88.22412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60051',
  },
  {
    city: 'Morton Grove',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1879.5,
    imprecise: false,
    latitude: 42.04224,
    longitude: -87.78895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60053',
  },
  {
    city: 'Mount Prospect',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1983.5,
    imprecise: false,
    latitude: 42.06618,
    longitude: -87.93473,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60056',
  },
  {
    city: 'Mundelein',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 620.8,
    imprecise: false,
    latitude: 42.26945,
    longitude: -88.03997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60060',
  },
  {
    city: 'Vernon Hills',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 1292.5,
    imprecise: false,
    latitude: 42.2334,
    longitude: -87.96046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60061',
  },
  {
    city: 'Northbrook',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 845.7,
    imprecise: false,
    latitude: 42.12663,
    longitude: -87.84235,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60062',
  },
  {
    city: 'North Chicago',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 1086.8,
    imprecise: false,
    latitude: 42.3237,
    longitude: -87.86122,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60064',
  },
  {
    city: 'Palatine',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1133.7,
    imprecise: false,
    latitude: 42.10773,
    longitude: -88.06478,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60067',
  },
  {
    city: 'Park Ridge',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2041,
    imprecise: false,
    latitude: 42.01276,
    longitude: -87.84435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60068',
  },
  {
    city: 'Lincolnshire',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 553.6,
    imprecise: false,
    latitude: 42.19588,
    longitude: -87.92439,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60069',
  },
  {
    city: 'Prospect Heights',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1505,
    imprecise: false,
    latitude: 42.10406,
    longitude: -87.92768,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60070',
  },
  {
    city: 'Richmond',
    county_fips: 17111,
    county_fips_all: '17111',
    county: 'McHenry',
    county_names_all: 'McHenry',
    county_weights: '{"17111": 100}',
    density: 59.9,
    imprecise: false,
    latitude: 42.46403,
    longitude: -88.30975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60071',
  },
  {
    city: 'Ringwood',
    county_fips: 17111,
    county_fips_all: '17111',
    county: 'McHenry',
    county_names_all: 'McHenry',
    county_weights: '{"17111": 100}',
    density: 34.7,
    imprecise: false,
    latitude: 42.40647,
    longitude: -88.30637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60072',
  },
  {
    city: 'Round Lake',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 1314.1,
    imprecise: false,
    latitude: 42.3516,
    longitude: -88.10597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 62868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60073',
  },
  {
    city: 'Palatine',
    county_fips: 17031,
    county_fips_all: '17031|17097',
    county: 'Cook',
    county_names_all: 'Cook|Lake',
    county_weights: '{"17031": 94.79, "17097": 5.21}',
    density: 1981.8,
    imprecise: false,
    latitude: 42.13179,
    longitude: -88.02658,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60074',
  },
  {
    city: 'Russell',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 307.8,
    imprecise: false,
    latitude: 42.49245,
    longitude: -87.91205,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60075',
  },
  {
    city: 'Skokie',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2477.7,
    imprecise: false,
    latitude: 42.03412,
    longitude: -87.72943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60076',
  },
  {
    city: 'Skokie',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2601,
    imprecise: false,
    latitude: 42.03617,
    longitude: -87.75633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60077',
  },
  {
    city: 'Spring Grove',
    county_fips: 17111,
    county_fips_all: '17111|17097',
    county: 'McHenry',
    county_names_all: 'McHenry|Lake',
    county_weights: '{"17111": 80.81, "17097": 19.19}',
    density: 177.9,
    imprecise: false,
    latitude: 42.45115,
    longitude: -88.22173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60081',
  },
  {
    city: 'Wadsworth',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 146,
    imprecise: false,
    latitude: 42.43716,
    longitude: -87.94663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60083',
  },
  {
    city: 'Wauconda',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 472.6,
    imprecise: false,
    latitude: 42.26807,
    longitude: -88.13856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60084',
  },
  {
    city: 'Waukegan',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 1889.1,
    imprecise: false,
    latitude: 42.35498,
    longitude: -87.86467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 72341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60085',
  },
  {
    city: 'Waukegan',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 812.9,
    imprecise: false,
    latitude: 42.40444,
    longitude: -87.85631,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60087',
  },
  {
    city: 'Great Lakes',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 2319.8,
    imprecise: false,
    latitude: 42.30685,
    longitude: -87.85232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60088',
  },
  {
    city: 'Buffalo Grove',
    county_fips: 17097,
    county_fips_all: '17097|17031',
    county: 'Lake',
    county_names_all: 'Lake|Cook',
    county_weights: '{"17097": 78.4, "17031": 21.6}',
    density: 1681.4,
    imprecise: false,
    latitude: 42.16736,
    longitude: -87.96076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60089',
  },
  {
    city: 'Wheeling',
    county_fips: 17031,
    county_fips_all: '17031|17097',
    county: 'Cook',
    county_names_all: 'Cook|Lake',
    county_weights: '{"17031": 99.55, "17097": 0.45}',
    density: 1646.1,
    imprecise: false,
    latitude: 42.13031,
    longitude: -87.92268,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60090',
  },
  {
    city: 'Wilmette',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1975.5,
    imprecise: false,
    latitude: 42.07693,
    longitude: -87.72812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60091',
  },
  {
    city: 'Winnetka',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 915.9,
    imprecise: false,
    latitude: 42.10333,
    longitude: -87.75826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60093',
  },
  {
    city: 'Winthrop Harbor',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 531.9,
    imprecise: false,
    latitude: 42.48091,
    longitude: -87.82978,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60096',
  },
  {
    city: 'Wonder Lake',
    county_fips: 17111,
    county_fips_all: '17111',
    county: 'McHenry',
    county_names_all: 'McHenry',
    county_weights: '{"17111": 100}',
    density: 288.3,
    imprecise: false,
    latitude: 42.39343,
    longitude: -88.36164,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60097',
  },
  {
    city: 'Woodstock',
    county_fips: 17111,
    county_fips_all: '17111',
    county: 'McHenry',
    county_names_all: 'McHenry',
    county_weights: '{"17111": 100}',
    density: 122.1,
    imprecise: false,
    latitude: 42.32468,
    longitude: -88.45672,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60098',
  },
  {
    city: 'Zion',
    county_fips: 17097,
    county_fips_all: '17097',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"17097": 100}',
    density: 527.9,
    imprecise: false,
    latitude: 42.46053,
    longitude: -87.86901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60099',
  },
  {
    city: 'Addison',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1269.5,
    imprecise: false,
    latitude: 41.931,
    longitude: -88.01072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60101',
  },
  {
    city: 'Algonquin',
    county_fips: 17111,
    county_fips_all: '17111|17089',
    county: 'McHenry',
    county_names_all: 'McHenry|Kane',
    county_weights: '{"17111": 77.53, "17089": 22.47}',
    density: 790.9,
    imprecise: false,
    latitude: 42.16406,
    longitude: -88.30928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60102',
  },
  {
    city: 'Bartlett',
    county_fips: 17043,
    county_fips_all: '17043|17031|17089',
    county: 'DuPage',
    county_names_all: 'DuPage|Cook|Kane',
    county_weights: '{"17043": 65.81, "17031": 33.59, "17089": 0.6}',
    density: 870.6,
    imprecise: false,
    latitude: 41.97816,
    longitude: -88.20511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60103',
  },
  {
    city: 'Bellwood',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3085.8,
    imprecise: false,
    latitude: 41.88256,
    longitude: -87.87646,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60104',
  },
  {
    city: 'Bensenville',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 836.4,
    imprecise: false,
    latitude: 41.9611,
    longitude: -87.94194,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60106',
  },
  {
    city: 'Streamwood',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1948.8,
    imprecise: false,
    latitude: 42.02148,
    longitude: -88.1783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60107',
  },
  {
    city: 'Bloomingdale',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1233.5,
    imprecise: false,
    latitude: 41.94905,
    longitude: -88.09232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60108',
  },
  {
    city: 'Burlington',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 33.5,
    imprecise: false,
    latitude: 42.04448,
    longitude: -88.56261,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60109',
  },
  {
    city: 'Carpentersville',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 1774.6,
    imprecise: false,
    latitude: 42.12296,
    longitude: -88.2883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60110',
  },
  {
    city: 'Clare',
    county_fips: 17037,
    county_fips_all: '17037',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"17037": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 42.00721,
    longitude: -88.83114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60111',
  },
  {
    city: 'Cortland',
    county_fips: 17037,
    county_fips_all: '17037',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"17037": 100}',
    density: 488.1,
    imprecise: false,
    latitude: 41.92391,
    longitude: -88.68994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60112',
  },
  {
    city: 'Creston',
    county_fips: 17141,
    county_fips_all: '17141',
    county: 'Ogle',
    county_names_all: 'Ogle',
    county_weights: '{"17141": 100}',
    density: 1239.1,
    imprecise: false,
    latitude: 41.93142,
    longitude: -88.96421,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60113',
  },
  {
    city: 'Dekalb',
    county_fips: 17037,
    county_fips_all: '17037',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"17037": 100}',
    density: 202.7,
    imprecise: false,
    latitude: 41.90109,
    longitude: -88.75469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60115',
  },
  {
    city: 'Dundee',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 293.1,
    imprecise: false,
    latitude: 42.10793,
    longitude: -88.30614,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60118',
  },
  {
    city: 'Elburn',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 88.7,
    imprecise: false,
    latitude: 41.86154,
    longitude: -88.47702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60119',
  },
  {
    city: 'Elgin',
    county_fips: 17031,
    county_fips_all: '17031|17089',
    county: 'Cook',
    county_names_all: 'Cook|Kane',
    county_weights: '{"17031": 72.02, "17089": 27.98}',
    density: 1135,
    imprecise: false,
    latitude: 42.03317,
    longitude: -88.2374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60120',
  },
  {
    city: 'Elgin',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 1337.4,
    imprecise: false,
    latitude: 42.04011,
    longitude: -88.31166,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60123',
  },
  {
    city: 'Elgin',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 247.8,
    imprecise: false,
    latitude: 42.02621,
    longitude: -88.39691,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60124',
  },
  {
    city: 'Elmhurst',
    county_fips: 17043,
    county_fips_all: '17043|17031',
    county: 'DuPage',
    county_names_all: 'DuPage|Cook',
    county_weights: '{"17043": 97.32, "17031": 2.68}',
    density: 1637.2,
    imprecise: false,
    latitude: 41.89627,
    longitude: -87.94194,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60126',
  },
  {
    city: 'Esmond',
    county_fips: 17141,
    county_fips_all: '17141|17037',
    county: 'Ogle',
    county_names_all: 'Ogle|DeKalb',
    county_weights: '{"17141": 72.65, "17037": 27.35}',
    density: 5.5,
    imprecise: false,
    latitude: 42.02963,
    longitude: -88.95371,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60129',
  },
  {
    city: 'Forest Park',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1910.5,
    imprecise: false,
    latitude: 41.86704,
    longitude: -87.81795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60130',
  },
  {
    city: 'Franklin Park',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1282.2,
    imprecise: false,
    latitude: 41.9378,
    longitude: -87.88304,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60131',
  },
  {
    city: 'Hanover Park',
    county_fips: 17043,
    county_fips_all: '17043|17031',
    county: 'DuPage',
    county_names_all: 'DuPage|Cook',
    county_weights: '{"17043": 65.43, "17031": 34.57}',
    density: 1691.6,
    imprecise: false,
    latitude: 41.97805,
    longitude: -88.14291,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60133',
  },
  {
    city: 'Geneva',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 788.2,
    imprecise: false,
    latitude: 41.8784,
    longitude: -88.34189,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60134',
  },
  {
    city: 'Genoa',
    county_fips: 17037,
    county_fips_all: '17037|17111|17007',
    county: 'DeKalb',
    county_names_all: 'DeKalb|McHenry|Boone',
    county_weights: '{"17037": 96.2, "17111": 2.17, "17007": 1.63}',
    density: 60,
    imprecise: false,
    latitude: 42.11265,
    longitude: -88.67867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60135',
  },
  {
    city: 'Gilberts',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 457.9,
    imprecise: false,
    latitude: 42.1053,
    longitude: -88.37808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60136',
  },
  {
    city: 'Glen Ellyn',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1362.1,
    imprecise: false,
    latitude: 41.86539,
    longitude: -88.06225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60137',
  },
  {
    city: 'Glendale Heights',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 2293,
    imprecise: false,
    latitude: 41.91916,
    longitude: -88.07735,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60139',
  },
  {
    city: 'Hampshire',
    county_fips: 17089,
    county_fips_all: '17089|17037|17111',
    county: 'Kane',
    county_names_all: 'Kane|DeKalb|McHenry',
    county_weights: '{"17089": 94.55, "17037": 4.19, "17111": 1.26}',
    density: 108.1,
    imprecise: false,
    latitude: 42.08003,
    longitude: -88.5086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60140',
  },
  {
    city: 'Hines',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 179.3,
    imprecise: false,
    latitude: 41.85834,
    longitude: -87.8379,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60141',
  },
  {
    city: 'Huntley',
    county_fips: 17111,
    county_fips_all: '17111|17089',
    county: 'McHenry',
    county_names_all: 'McHenry|Kane',
    county_weights: '{"17111": 72.41, "17089": 27.59}',
    density: 294.8,
    imprecise: false,
    latitude: 42.17517,
    longitude: -88.44486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60142',
  },
  {
    city: 'Itasca',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 627.4,
    imprecise: false,
    latitude: 41.97351,
    longitude: -88.02071,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60143',
  },
  {
    city: 'Kaneville',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 521.2,
    imprecise: false,
    latitude: 41.83507,
    longitude: -88.51984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60144',
  },
  {
    city: 'Kingston',
    county_fips: 17037,
    county_fips_all: '17037|17007',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Boone',
    county_weights: '{"17037": 94.63, "17007": 5.37}',
    density: 28.1,
    imprecise: false,
    latitude: 42.09396,
    longitude: -88.77719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60145',
  },
  {
    city: 'Kirkland',
    county_fips: 17037,
    county_fips_all: '17037|17007|17141',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Boone|Ogle',
    county_weights: '{"17037": 88.08, "17007": 9.98, "17141": 1.94}',
    density: 16.5,
    imprecise: false,
    latitude: 42.10091,
    longitude: -88.88019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60146',
  },
  {
    city: 'Lombard',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1469.2,
    imprecise: false,
    latitude: 41.87505,
    longitude: -88.01859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60148',
  },
  {
    city: 'Malta',
    county_fips: 17037,
    county_fips_all: '17037',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"17037": 100}',
    density: 12,
    imprecise: false,
    latitude: 41.92106,
    longitude: -88.88982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60150',
  },
  {
    city: 'Maple Park',
    county_fips: 17089,
    county_fips_all: '17089|17037',
    county: 'Kane',
    county_names_all: 'Kane|DeKalb',
    county_weights: '{"17089": 75.39, "17037": 24.61}',
    density: 18.2,
    imprecise: false,
    latitude: 41.9172,
    longitude: -88.56613,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60151',
  },
  {
    city: 'Marengo',
    county_fips: 17111,
    county_fips_all: '17111|17037',
    county: 'McHenry',
    county_names_all: 'McHenry|DeKalb',
    county_weights: '{"17111": 97.99, "17037": 2.01}',
    density: 50.3,
    imprecise: false,
    latitude: 42.23882,
    longitude: -88.62597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60152',
  },
  {
    city: 'Maywood',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3155.1,
    imprecise: false,
    latitude: 41.87984,
    longitude: -87.84389,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60153',
  },
  {
    city: 'Westchester',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1455.1,
    imprecise: false,
    latitude: 41.84923,
    longitude: -87.88986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60154',
  },
  {
    city: 'Broadview',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1644.8,
    imprecise: false,
    latitude: 41.8578,
    longitude: -87.85631,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60155',
  },
  {
    city: 'Lake In The Hills',
    county_fips: 17111,
    county_fips_all: '17111',
    county: 'McHenry',
    county_names_all: 'McHenry',
    county_weights: '{"17111": 100}',
    density: 1048.2,
    imprecise: false,
    latitude: 42.19121,
    longitude: -88.34788,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60156',
  },
  {
    city: 'Medinah',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 643.4,
    imprecise: false,
    latitude: 41.974,
    longitude: -88.05476,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60157',
  },
  {
    city: 'Melrose Park',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2082.3,
    imprecise: false,
    latitude: 41.90348,
    longitude: -87.86176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60160',
  },
  {
    city: 'Hillside',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 983.3,
    imprecise: false,
    latitude: 41.86753,
    longitude: -87.90196,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60162',
  },
  {
    city: 'Berkeley',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1593.5,
    imprecise: false,
    latitude: 41.88794,
    longitude: -87.90948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60163',
  },
  {
    city: 'Melrose Park',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1640.7,
    imprecise: false,
    latitude: 41.91667,
    longitude: -87.90112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60164',
  },
  {
    city: 'Stone Park',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 5067.1,
    imprecise: false,
    latitude: 41.90328,
    longitude: -87.88056,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60165',
  },
  {
    city: 'Hoffman Estates',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1682.9,
    imprecise: false,
    latitude: 42.05192,
    longitude: -88.11656,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60169',
  },
  {
    city: 'River Grove',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1792,
    imprecise: false,
    latitude: 41.92504,
    longitude: -87.83832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60171',
  },
  {
    city: 'Roselle',
    county_fips: 17043,
    county_fips_all: '17043|17031',
    county: 'DuPage',
    county_names_all: 'DuPage|Cook',
    county_weights: '{"17043": 82.76, "17031": 17.24}',
    density: 1332.4,
    imprecise: false,
    latitude: 41.97976,
    longitude: -88.08937,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60172',
  },
  {
    city: 'Schaumburg',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 820.9,
    imprecise: false,
    latitude: 42.05287,
    longitude: -88.0526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60173',
  },
  {
    city: 'Saint Charles',
    county_fips: 17089,
    county_fips_all: '17089|17043',
    county: 'Kane',
    county_names_all: 'Kane|DuPage',
    county_weights: '{"17089": 98.67, "17043": 1.33}',
    density: 883.7,
    imprecise: false,
    latitude: 41.92759,
    longitude: -88.29906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60174',
  },
  {
    city: 'Saint Charles',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 294.3,
    imprecise: false,
    latitude: 41.94695,
    longitude: -88.3913,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60175',
  },
  {
    city: 'Schiller Park',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1734.1,
    imprecise: false,
    latitude: 41.9583,
    longitude: -87.8697,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60176',
  },
  {
    city: 'South Elgin',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 1061.6,
    imprecise: false,
    latitude: 41.98931,
    longitude: -88.30987,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60177',
  },
  {
    city: 'Sycamore',
    county_fips: 17037,
    county_fips_all: '17037|17089',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Kane',
    county_weights: '{"17037": 93.3, "17089": 6.7}',
    density: 127.7,
    imprecise: false,
    latitude: 42.00625,
    longitude: -88.67205,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60178',
  },
  {
    city: 'Union',
    county_fips: 17111,
    county_fips_all: '17111',
    county: 'McHenry',
    county_names_all: 'McHenry',
    county_weights: '{"17111": 100}',
    density: 33.7,
    imprecise: false,
    latitude: 42.22342,
    longitude: -88.52023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60180',
  },
  {
    city: 'Villa Park',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1800.4,
    imprecise: false,
    latitude: 41.87795,
    longitude: -87.97626,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60181',
  },
  {
    city: 'Wasco',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 18,
    imprecise: false,
    latitude: 41.94019,
    longitude: -88.40908,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60183',
  },
  {
    city: 'Wayne',
    county_fips: 17043,
    county_fips_all: '17043|17089',
    county: 'DuPage',
    county_names_all: 'DuPage|Kane',
    county_weights: '{"17043": 65.75, "17089": 34.25}',
    density: 117.2,
    imprecise: false,
    latitude: 41.95208,
    longitude: -88.25323,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60184',
  },
  {
    city: 'West Chicago',
    county_fips: 17043,
    county_fips_all: '17043|17089',
    county: 'DuPage',
    county_names_all: 'DuPage|Kane',
    county_weights: '{"17043": 96.46, "17089": 3.54}',
    density: 421.6,
    imprecise: false,
    latitude: 41.89308,
    longitude: -88.21498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60185',
  },
  {
    city: 'Wheaton',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1678.1,
    imprecise: false,
    latitude: 41.87231,
    longitude: -88.1126,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60187',
  },
  {
    city: 'Carol Stream',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1625.3,
    imprecise: false,
    latitude: 41.91562,
    longitude: -88.12958,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60188',
  },
  {
    city: 'Wheaton',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1148.3,
    imprecise: false,
    latitude: 41.83957,
    longitude: -88.12128,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60189',
  },
  {
    city: 'Winfield',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 936.4,
    imprecise: false,
    latitude: 41.87319,
    longitude: -88.1576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60190',
  },
  {
    city: 'Wood Dale',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1066.5,
    imprecise: false,
    latitude: 41.9647,
    longitude: -87.98087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60191',
  },
  {
    city: 'Hoffman Estates',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 570.2,
    imprecise: false,
    latitude: 42.07265,
    longitude: -88.16797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60192',
  },
  {
    city: 'Schaumburg',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1759.6,
    imprecise: false,
    latitude: 42.01195,
    longitude: -88.09552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60193',
  },
  {
    city: 'Schaumburg',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2067.5,
    imprecise: false,
    latitude: 42.03339,
    longitude: -88.11125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60194',
  },
  {
    city: 'Schaumburg',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1006.3,
    imprecise: false,
    latitude: 42.06541,
    longitude: -88.08657,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60195',
  },
  {
    city: 'Evanston',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3744,
    imprecise: false,
    latitude: 42.05665,
    longitude: -87.69827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60201',
  },
  {
    city: 'Evanston',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 4087.2,
    imprecise: false,
    latitude: 42.03043,
    longitude: -87.68958,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60202',
  },
  {
    city: 'Evanston',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2641.4,
    imprecise: false,
    latitude: 42.04905,
    longitude: -87.71748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60203',
  },
  {
    city: 'Oak Park',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 6887.6,
    imprecise: false,
    latitude: 41.88865,
    longitude: -87.79648,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60301',
  },
  {
    city: 'Oak Park',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 4293.2,
    imprecise: false,
    latitude: 41.8948,
    longitude: -87.78983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60302',
  },
  {
    city: 'Oak Park',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 4224.5,
    imprecise: false,
    latitude: 41.87249,
    longitude: -87.78933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60304',
  },
  {
    city: 'River Forest',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1869.2,
    imprecise: false,
    latitude: 41.89501,
    longitude: -87.81943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60305',
  },
  {
    city: 'Beecher',
    county_fips: 17197,
    county_fips_all: '17197|17091',
    county: 'Will',
    county_names_all: 'Will|Kankakee',
    county_weights: '{"17197": 98.03, "17091": 1.97}',
    density: 52.1,
    imprecise: false,
    latitude: 41.34683,
    longitude: -87.61306,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60401',
  },
  {
    city: 'Berwyn',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 4289.2,
    imprecise: false,
    latitude: 41.83237,
    longitude: -87.78983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60402',
  },
  {
    city: 'Crest Hill',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 1450.6,
    imprecise: false,
    latitude: 41.56696,
    longitude: -88.12438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60403',
  },
  {
    city: 'Shorewood',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 500.2,
    imprecise: false,
    latitude: 41.50864,
    longitude: -88.22269,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60404',
  },
  {
    city: 'Blue Island',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1676.9,
    imprecise: false,
    latitude: 41.65509,
    longitude: -87.68184,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60406',
  },
  {
    city: 'Braceville',
    county_fips: 17063,
    county_fips_all: '17063|17197',
    county: 'Grundy',
    county_names_all: 'Grundy|Will',
    county_weights: '{"17063": 79.56, "17197": 20.44}',
    density: 51.8,
    imprecise: false,
    latitude: 41.23037,
    longitude: -88.26415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60407',
  },
  {
    city: 'Braidwood',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 322.1,
    imprecise: false,
    latitude: 41.26684,
    longitude: -88.21733,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60408',
  },
  {
    city: 'Calumet City',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1749.4,
    imprecise: false,
    latitude: 41.61303,
    longitude: -87.55142,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60409',
  },
  {
    city: 'Channahon',
    county_fips: 17197,
    county_fips_all: '17197|17063',
    county: 'Will',
    county_names_all: 'Will|Grundy',
    county_weights: '{"17197": 83.12, "17063": 16.88}',
    density: 228.5,
    imprecise: false,
    latitude: 41.42119,
    longitude: -88.2171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60410',
  },
  {
    city: 'Chicago Heights',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 656.4,
    imprecise: false,
    latitude: 41.50791,
    longitude: -87.59031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60411',
  },
  {
    city: 'Chicago Ridge',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2402.1,
    imprecise: false,
    latitude: 41.70341,
    longitude: -87.77953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60415',
  },
  {
    city: 'Coal City',
    county_fips: 17063,
    county_fips_all: '17063|17197',
    county: 'Grundy',
    county_names_all: 'Grundy|Will',
    county_weights: '{"17063": 96.26, "17197": 3.74}',
    density: 161.6,
    imprecise: false,
    latitude: 41.29357,
    longitude: -88.28197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60416',
  },
  {
    city: 'Crete',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 155.1,
    imprecise: false,
    latitude: 41.43056,
    longitude: -87.59268,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60417',
  },
  {
    city: 'Crestwood',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1379.2,
    imprecise: false,
    latitude: 41.64568,
    longitude: -87.74084,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60418',
  },
  {
    city: 'Dolton',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1893.7,
    imprecise: false,
    latitude: 41.62752,
    longitude: -87.59871,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60419',
  },
  {
    city: 'Dwight',
    county_fips: 17105,
    county_fips_all: '17105|17063',
    county: 'Livingston',
    county_names_all: 'Livingston|Grundy',
    county_weights: '{"17105": 71.59, "17063": 28.41}',
    density: 18.7,
    imprecise: false,
    latitude: 41.08795,
    longitude: -88.42127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60420',
  },
  {
    city: 'Elwood',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 41.40851,
    longitude: -88.08936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60421',
  },
  {
    city: 'Flossmoor',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 925.1,
    imprecise: false,
    latitude: 41.53861,
    longitude: -87.68443,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60422',
  },
  {
    city: 'Frankfort',
    county_fips: 17197,
    county_fips_all: '17197|17031',
    county: 'Will',
    county_names_all: 'Will|Cook',
    county_weights: '{"17197": 94.66, "17031": 5.34}',
    density: 334.7,
    imprecise: false,
    latitude: 41.47922,
    longitude: -87.83961,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60423',
  },
  {
    city: 'Gardner',
    county_fips: 17063,
    county_fips_all: '17063|17091',
    county: 'Grundy',
    county_names_all: 'Grundy|Kankakee',
    county_weights: '{"17063": 93.99, "17091": 6.01}',
    density: 15.8,
    imprecise: false,
    latitude: 41.16604,
    longitude: -88.32941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60424',
  },
  {
    city: 'Glenwood',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 597.8,
    imprecise: false,
    latitude: 41.54343,
    longitude: -87.61073,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60425',
  },
  {
    city: 'Harvey',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1193.2,
    imprecise: false,
    latitude: 41.61026,
    longitude: -87.65309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60426',
  },
  {
    city: 'Markham',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 831.4,
    imprecise: false,
    latitude: 41.5998,
    longitude: -87.69062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60428',
  },
  {
    city: 'Hazel Crest',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1408.6,
    imprecise: false,
    latitude: 41.5737,
    longitude: -87.68331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60429',
  },
  {
    city: 'Homewood',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1113,
    imprecise: false,
    latitude: 41.5584,
    longitude: -87.66214,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60430',
  },
  {
    city: 'Joliet',
    county_fips: 17197,
    county_fips_all: '17197|17093',
    county: 'Will',
    county_names_all: 'Will|Kendall',
    county_weights: '{"17197": 73.78, "17093": 26.22}',
    density: 815.9,
    imprecise: false,
    latitude: 41.53355,
    longitude: -88.20568,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60431',
  },
  {
    city: 'Joliet',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 927.7,
    imprecise: false,
    latitude: 41.54087,
    longitude: -88.0406,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60432',
  },
  {
    city: 'Joliet',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 466.4,
    imprecise: false,
    latitude: 41.49895,
    longitude: -88.04248,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60433',
  },
  {
    city: 'Joliet',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 1717.3,
    imprecise: false,
    latitude: 41.54492,
    longitude: -88.1288,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60435',
  },
  {
    city: 'Joliet',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 416.8,
    imprecise: false,
    latitude: 41.48973,
    longitude: -88.12392,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60436',
  },
  {
    city: 'Kinsman',
    county_fips: 17063,
    county_fips_all: '17063|17105',
    county: 'Grundy',
    county_names_all: 'Grundy|Livingston',
    county_weights: '{"17063": 99.83, "17105": 0.17}',
    density: 2.4,
    imprecise: false,
    latitude: 41.16168,
    longitude: -88.54981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60437',
  },
  {
    city: 'Lansing',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1379.6,
    imprecise: false,
    latitude: 41.56625,
    longitude: -87.55065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60438',
  },
  {
    city: 'Lemont',
    county_fips: 17031,
    county_fips_all: '17031|17043|17197',
    county: 'Cook',
    county_names_all: 'Cook|DuPage|Will',
    county_weights: '{"17031": 66.84, "17043": 24.85, "17197": 8.31}',
    density: 314.4,
    imprecise: false,
    latitude: 41.67692,
    longitude: -87.97623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60439',
  },
  {
    city: 'Bolingbrook',
    county_fips: 17197,
    county_fips_all: '17197|17043',
    county: 'Will',
    county_names_all: 'Will|DuPage',
    county_weights: '{"17197": 98.06, "17043": 1.94}',
    density: 1329.9,
    imprecise: false,
    latitude: 41.70125,
    longitude: -88.07572,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60440',
  },
  {
    city: 'Lockport',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 505.4,
    imprecise: false,
    latitude: 41.59238,
    longitude: -88.05106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60441',
  },
  {
    city: 'Manhattan',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 79.2,
    imprecise: false,
    latitude: 41.39189,
    longitude: -87.96062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60442',
  },
  {
    city: 'Matteson',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 708.6,
    imprecise: false,
    latitude: 41.50369,
    longitude: -87.74637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60443',
  },
  {
    city: 'Mazon',
    county_fips: 17063,
    county_fips_all: '17063',
    county: 'Grundy',
    county_names_all: 'Grundy',
    county_weights: '{"17063": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 41.24246,
    longitude: -88.40403,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60444',
  },
  {
    city: 'Midlothian',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1283.4,
    imprecise: false,
    latitude: 41.62833,
    longitude: -87.73542,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60445',
  },
  {
    city: 'Romeoville',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 824.8,
    imprecise: false,
    latitude: 41.63304,
    longitude: -88.09855,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60446',
  },
  {
    city: 'Minooka',
    county_fips: 17093,
    county_fips_all: '17093|17063|17197',
    county: 'Kendall',
    county_names_all: 'Kendall|Grundy|Will',
    county_weights: '{"17093": 72.89, "17063": 21.37, "17197": 5.74}',
    density: 91.9,
    imprecise: false,
    latitude: 41.48796,
    longitude: -88.32498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60447',
  },
  {
    city: 'Mokena',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 514.6,
    imprecise: false,
    latitude: 41.53821,
    longitude: -87.89396,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60448',
  },
  {
    city: 'Monee',
    county_fips: 17197,
    county_fips_all: '17197|17031',
    county: 'Will',
    county_names_all: 'Will|Cook',
    county_weights: '{"17197": 98.74, "17031": 1.26}',
    density: 74.3,
    imprecise: false,
    latitude: 41.41392,
    longitude: -87.76978,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60449',
  },
  {
    city: 'Morris',
    county_fips: 17063,
    county_fips_all: '17063|17093',
    county: 'Grundy',
    county_names_all: 'Grundy|Kendall',
    county_weights: '{"17063": 97.91, "17093": 2.09}',
    density: 50.9,
    imprecise: false,
    latitude: 41.37011,
    longitude: -88.43417,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60450',
  },
  {
    city: 'New Lenox',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 573.4,
    imprecise: false,
    latitude: 41.50717,
    longitude: -87.96088,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60451',
  },
  {
    city: 'Oak Forest',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1202.2,
    imprecise: false,
    latitude: 41.60851,
    longitude: -87.75434,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60452',
  },
  {
    city: 'Oak Lawn',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2584.6,
    imprecise: false,
    latitude: 41.71412,
    longitude: -87.75278,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60453',
  },
  {
    city: 'Bridgeview',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1536.4,
    imprecise: false,
    latitude: 41.74102,
    longitude: -87.8068,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60455',
  },
  {
    city: 'Hometown',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3398.3,
    imprecise: false,
    latitude: 41.73125,
    longitude: -87.73111,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60456',
  },
  {
    city: 'Hickory Hills',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1786.7,
    imprecise: false,
    latitude: 41.72475,
    longitude: -87.82987,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60457',
  },
  {
    city: 'Justice',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1879.7,
    imprecise: false,
    latitude: 41.74892,
    longitude: -87.83484,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60458',
  },
  {
    city: 'Burbank',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2653.1,
    imprecise: false,
    latitude: 41.74436,
    longitude: -87.76872,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60459',
  },
  {
    city: 'Odell',
    county_fips: 17105,
    county_fips_all: '17105',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"17105": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 40.9997,
    longitude: -88.53393,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60460',
  },
  {
    city: 'Olympia Fields',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 546,
    imprecise: false,
    latitude: 41.51752,
    longitude: -87.69148,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60461',
  },
  {
    city: 'Orland Park',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1001.7,
    imprecise: false,
    latitude: 41.62527,
    longitude: -87.83548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60462',
  },
  {
    city: 'Palos Heights',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1006.3,
    imprecise: false,
    latitude: 41.66084,
    longitude: -87.79033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60463',
  },
  {
    city: 'Palos Park',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 286.7,
    imprecise: false,
    latitude: 41.67088,
    longitude: -87.86869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60464',
  },
  {
    city: 'Palos Hills',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1621.8,
    imprecise: false,
    latitude: 41.69878,
    longitude: -87.8267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60465',
  },
  {
    city: 'Park Forest',
    county_fips: 17031,
    county_fips_all: '17031|17197',
    county: 'Cook',
    county_names_all: 'Cook|Will',
    county_weights: '{"17031": 72.89, "17197": 27.11}',
    density: 1311.9,
    imprecise: false,
    latitude: 41.47966,
    longitude: -87.68276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60466',
  },
  {
    city: 'Orland Park',
    county_fips: 17031,
    county_fips_all: '17031|17197',
    county: 'Cook',
    county_names_all: 'Cook|Will',
    county_weights: '{"17031": 94.05, "17197": 5.95}',
    density: 637.8,
    imprecise: false,
    latitude: 41.59855,
    longitude: -87.88848,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60467',
  },
  {
    city: 'Peotone',
    county_fips: 17197,
    county_fips_all: '17197|17091',
    county: 'Will',
    county_names_all: 'Will|Kankakee',
    county_weights: '{"17197": 95.26, "17091": 4.74}',
    density: 32.2,
    imprecise: false,
    latitude: 41.33636,
    longitude: -87.80991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60468',
  },
  {
    city: 'Posen',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1772.7,
    imprecise: false,
    latitude: 41.62871,
    longitude: -87.68634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60469',
  },
  {
    city: 'Ransom',
    county_fips: 17099,
    county_fips_all: '17099|17105|17063',
    county: 'LaSalle',
    county_names_all: 'LaSalle|Livingston|Grundy',
    county_weights: '{"17099": 91.7, "17105": 4.35, "17063": 3.95}',
    density: 3.2,
    imprecise: false,
    latitude: 41.16592,
    longitude: -88.63876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60470',
  },
  {
    city: 'Richton Park',
    county_fips: 17031,
    county_fips_all: '17031|17197',
    county: 'Cook',
    county_names_all: 'Cook|Will',
    county_weights: '{"17031": 95.64, "17197": 4.36}',
    density: 1250,
    imprecise: false,
    latitude: 41.48009,
    longitude: -87.72981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60471',
  },
  {
    city: 'Robbins',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1042.6,
    imprecise: false,
    latitude: 41.6437,
    longitude: -87.70836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60472',
  },
  {
    city: 'South Holland',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1044.7,
    imprecise: false,
    latitude: 41.59733,
    longitude: -87.60115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60473',
  },
  {
    city: 'South Wilmington',
    county_fips: 17063,
    county_fips_all: '17063',
    county: 'Grundy',
    county_names_all: 'Grundy',
    county_weights: '{"17063": 100}',
    density: 47.7,
    imprecise: false,
    latitude: 41.1765,
    longitude: -88.26983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60474',
  },
  {
    city: 'Steger',
    county_fips: 17031,
    county_fips_all: '17031|17197',
    county: 'Cook',
    county_names_all: 'Cook|Will',
    county_weights: '{"17031": 68.23, "17197": 31.77}',
    density: 804.1,
    imprecise: false,
    latitude: 41.47193,
    longitude: -87.6283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60475',
  },
  {
    city: 'Thornton',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 226.2,
    imprecise: false,
    latitude: 41.5694,
    longitude: -87.60562,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60476',
  },
  {
    city: 'Tinley Park',
    county_fips: 17031,
    county_fips_all: '17031|17197',
    county: 'Cook',
    county_names_all: 'Cook|Will',
    county_weights: '{"17031": 96.35, "17197": 3.65}',
    density: 976.8,
    imprecise: false,
    latitude: 41.57347,
    longitude: -87.78597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60477',
  },
  {
    city: 'Country Club Hills',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 646.7,
    imprecise: false,
    latitude: 41.55381,
    longitude: -87.73588,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60478',
  },
  {
    city: 'Verona',
    county_fips: 17063,
    county_fips_all: '17063',
    county: 'Grundy',
    county_names_all: 'Grundy',
    county_weights: '{"17063": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 41.23174,
    longitude: -88.52078,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60479',
  },
  {
    city: 'Willow Springs',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 185.1,
    imprecise: false,
    latitude: 41.71909,
    longitude: -87.87675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60480',
  },
  {
    city: 'Wilmington',
    county_fips: 17197,
    county_fips_all: '17197|17091|17063',
    county: 'Will',
    county_names_all: 'Will|Kankakee|Grundy',
    county_weights: '{"17197": 97.06, "17091": 2.32, "17063": 0.62}',
    density: 35,
    imprecise: false,
    latitude: 41.28795,
    longitude: -88.12952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60481',
  },
  {
    city: 'Worth',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1802.9,
    imprecise: false,
    latitude: 41.68737,
    longitude: -87.79239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60482',
  },
  {
    city: 'University Park',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 346.8,
    imprecise: false,
    latitude: 41.44317,
    longitude: -87.70948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60484',
  },
  {
    city: 'Tinley Park',
    county_fips: 17031,
    county_fips_all: '17031|17197',
    county: 'Cook',
    county_names_all: 'Cook|Will',
    county_weights: '{"17031": 58.99, "17197": 41.01}',
    density: 1345,
    imprecise: false,
    latitude: 41.56236,
    longitude: -87.83095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60487',
  },
  {
    city: 'Bolingbrook',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 884.6,
    imprecise: false,
    latitude: 41.67575,
    longitude: -88.14118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60490',
  },
  {
    city: 'Homer Glen',
    county_fips: 17197,
    county_fips_all: '17197',
    county: 'Will',
    county_names_all: 'Will',
    county_weights: '{"17197": 100}',
    density: 343.4,
    imprecise: false,
    latitude: 41.60313,
    longitude: -87.9595,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60491',
  },
  {
    city: 'Summit Argo',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1013.4,
    imprecise: false,
    latitude: 41.77979,
    longitude: -87.82393,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60501',
  },
  {
    city: 'Aurora',
    county_fips: 17043,
    county_fips_all: '17043|17089',
    county: 'DuPage',
    county_names_all: 'DuPage|Kane',
    county_weights: '{"17043": 59.64, "17089": 40.36}',
    density: 805.7,
    imprecise: false,
    latitude: 41.78911,
    longitude: -88.25952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60502',
  },
  {
    city: 'Aurora',
    county_fips: 17197,
    county_fips_all: '17197|17093',
    county: 'Will',
    county_names_all: 'Will|Kendall',
    county_weights: '{"17197": 72.42, "17093": 27.58}',
    density: 1516.4,
    imprecise: false,
    latitude: 41.7079,
    longitude: -88.25475,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60503',
  },
  {
    city: 'Aurora',
    county_fips: 17043,
    county_fips_all: '17043|17089|17093',
    county: 'DuPage',
    county_names_all: 'DuPage|Kane|Kendall',
    county_weights: '{"17043": 80.05, "17089": 19.15, "17093": 0.8}',
    density: 1730.4,
    imprecise: false,
    latitude: 41.74649,
    longitude: -88.23957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60504',
  },
  {
    city: 'Aurora',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 2177.8,
    imprecise: false,
    latitude: 41.76527,
    longitude: -88.29576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60505',
  },
  {
    city: 'Aurora',
    county_fips: 17089,
    county_fips_all: '17089|17093',
    county: 'Kane',
    county_names_all: 'Kane|Kendall',
    county_weights: '{"17089": 99.23, "17093": 0.77}',
    density: 909.3,
    imprecise: false,
    latitude: 41.76176,
    longitude: -88.37125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60506',
  },
  {
    city: 'Batavia',
    county_fips: 17089,
    county_fips_all: '17089|17043',
    county: 'Kane',
    county_names_all: 'Kane|DuPage',
    county_weights: '{"17089": 82.67, "17043": 17.33}',
    density: 459.7,
    imprecise: false,
    latitude: 41.84283,
    longitude: -88.31189,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60510',
  },
  {
    city: 'Big Rock',
    county_fips: 17089,
    county_fips_all: '17089|17037',
    county: 'Kane',
    county_names_all: 'Kane|DeKalb',
    county_weights: '{"17089": 96.14, "17037": 3.86}',
    density: 26.8,
    imprecise: false,
    latitude: 41.75778,
    longitude: -88.55601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60511',
  },
  {
    city: 'Bristol',
    county_fips: 17093,
    county_fips_all: '17093',
    county: 'Kendall',
    county_names_all: 'Kendall',
    county_weights: '{"17093": 100}',
    density: 64.2,
    imprecise: false,
    latitude: 41.70134,
    longitude: -88.43986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60512',
  },
  {
    city: 'Brookfield',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2367.5,
    imprecise: false,
    latitude: 41.82459,
    longitude: -87.8469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60513',
  },
  {
    city: 'Clarendon Hills',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1879.1,
    imprecise: false,
    latitude: 41.79655,
    longitude: -87.95683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60514',
  },
  {
    city: 'Downers Grove',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 972.4,
    imprecise: false,
    latitude: 41.80991,
    longitude: -88.0247,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60515',
  },
  {
    city: 'Downers Grove',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1430.1,
    imprecise: false,
    latitude: 41.76327,
    longitude: -88.01314,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60516',
  },
  {
    city: 'Woodridge',
    county_fips: 17043,
    county_fips_all: '17043|17197',
    county: 'DuPage',
    county_names_all: 'DuPage|Will',
    county_weights: '{"17043": 90.54, "17197": 9.46}',
    density: 1372.7,
    imprecise: false,
    latitude: 41.73913,
    longitude: -88.04161,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60517',
  },
  {
    city: 'Earlville',
    county_fips: 17099,
    county_fips_all: '17099|17037|17103',
    county: 'LaSalle',
    county_names_all: 'LaSalle|DeKalb|Lee',
    county_weights: '{"17099": 66.02, "17037": 25.27, "17103": 8.71}',
    density: 9.6,
    imprecise: false,
    latitude: 41.59997,
    longitude: -88.92215,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60518',
  },
  {
    city: 'Eola',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 452.9,
    imprecise: false,
    latitude: 41.77724,
    longitude: -88.24255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60519',
  },
  {
    city: 'Hinckley',
    county_fips: 17037,
    county_fips_all: '17037',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"17037": 100}',
    density: 25.5,
    imprecise: false,
    latitude: 41.7826,
    longitude: -88.65808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60520',
  },
  {
    city: 'Hinsdale',
    county_fips: 17043,
    county_fips_all: '17043|17031',
    county: 'DuPage',
    county_names_all: 'DuPage|Cook',
    county_weights: '{"17043": 83.39, "17031": 16.61}',
    density: 1474,
    imprecise: false,
    latitude: 41.80019,
    longitude: -87.92883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60521',
  },
  {
    city: 'Oak Brook',
    county_fips: 17043,
    county_fips_all: '17043|17031',
    county: 'DuPage',
    county_names_all: 'DuPage|Cook',
    county_weights: '{"17043": 99.84, "17031": 0.16}',
    density: 437.4,
    imprecise: false,
    latitude: 41.83713,
    longitude: -87.95406,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60523',
  },
  {
    city: 'La Grange',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 926.3,
    imprecise: false,
    latitude: 41.78371,
    longitude: -87.86778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60525',
  },
  {
    city: 'La Grange Park',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1338.5,
    imprecise: false,
    latitude: 41.83002,
    longitude: -87.8836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60526',
  },
  {
    city: 'Willowbrook',
    county_fips: 17043,
    county_fips_all: '17043|17031',
    county: 'DuPage',
    county_names_all: 'DuPage|Cook',
    county_weights: '{"17043": 79.56, "17031": 20.44}',
    density: 778.4,
    imprecise: false,
    latitude: 41.74472,
    longitude: -87.93383,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60527',
  },
  {
    city: 'Lee',
    county_fips: 17103,
    county_fips_all: '17103|17037',
    county: 'Lee',
    county_names_all: 'Lee|DeKalb',
    county_weights: '{"17103": 68.29, "17037": 31.71}',
    density: 13.7,
    imprecise: false,
    latitude: 41.79613,
    longitude: -88.95988,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60530',
  },
  {
    city: 'Leland',
    county_fips: 17099,
    county_fips_all: '17099|17037',
    county: 'LaSalle',
    county_names_all: 'LaSalle|DeKalb',
    county_weights: '{"17099": 62.11, "17037": 37.89}',
    density: 11.8,
    imprecise: false,
    latitude: 41.61563,
    longitude: -88.78639,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60531',
  },
  {
    city: 'Lisle',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1290,
    imprecise: false,
    latitude: 41.79153,
    longitude: -88.08576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60532',
  },
  {
    city: 'Lyons',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2129.7,
    imprecise: false,
    latitude: 41.81311,
    longitude: -87.82066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60534',
  },
  {
    city: 'Millbrook',
    county_fips: 17093,
    county_fips_all: '17093',
    county: 'Kendall',
    county_names_all: 'Kendall',
    county_weights: '{"17093": 100}',
    density: 178.5,
    imprecise: false,
    latitude: 41.59853,
    longitude: -88.55212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60536',
  },
  {
    city: 'Millington',
    county_fips: 17099,
    county_fips_all: '17099|17093',
    county: 'LaSalle',
    county_names_all: 'LaSalle|Kendall',
    county_weights: '{"17099": 71.17, "17093": 28.83}',
    density: 339.3,
    imprecise: false,
    latitude: 41.56158,
    longitude: -88.60246,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60537',
  },
  {
    city: 'Montgomery',
    county_fips: 17093,
    county_fips_all: '17093|17089',
    county: 'Kendall',
    county_names_all: 'Kendall|Kane',
    county_weights: '{"17093": 53.49, "17089": 46.51}',
    density: 1214.2,
    imprecise: false,
    latitude: 41.72165,
    longitude: -88.35637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60538',
  },
  {
    city: 'Mooseheart',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 139.2,
    imprecise: false,
    latitude: 41.825,
    longitude: -88.33529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60539',
  },
  {
    city: 'Naperville',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1234,
    imprecise: false,
    latitude: 41.76361,
    longitude: -88.14476,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60540',
  },
  {
    city: 'Newark',
    county_fips: 17093,
    county_fips_all: '17093|17063|17099',
    county: 'Kendall',
    county_names_all: 'Kendall|Grundy|LaSalle',
    county_weights: '{"17093": 89.79, "17063": 9.3, "17099": 0.91}',
    density: 15.5,
    imprecise: false,
    latitude: 41.5193,
    longitude: -88.52552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60541',
  },
  {
    city: 'North Aurora',
    county_fips: 17089,
    county_fips_all: '17089',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"17089": 100}',
    density: 771.8,
    imprecise: false,
    latitude: 41.80878,
    longitude: -88.3489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60542',
  },
  {
    city: 'Oswego',
    county_fips: 17093,
    county_fips_all: '17093|17197|17089',
    county: 'Kendall',
    county_names_all: 'Kendall|Will|Kane',
    county_weights: '{"17093": 99.25, "17197": 0.59, "17089": 0.16}',
    density: 396.2,
    imprecise: false,
    latitude: 41.66537,
    longitude: -88.32442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60543',
  },
  {
    city: 'Plainfield',
    county_fips: 17197,
    county_fips_all: '17197|17093',
    county: 'Will',
    county_names_all: 'Will|Kendall',
    county_weights: '{"17197": 75.84, "17093": 24.16}',
    density: 435.5,
    imprecise: false,
    latitude: 41.61393,
    longitude: -88.21777,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60544',
  },
  {
    city: 'Plano',
    county_fips: 17093,
    county_fips_all: '17093',
    county: 'Kendall',
    county_names_all: 'Kendall',
    county_weights: '{"17093": 100}',
    density: 151.8,
    imprecise: false,
    latitude: 41.67815,
    longitude: -88.53587,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60545',
  },
  {
    city: 'Riverside',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1581.2,
    imprecise: false,
    latitude: 41.83834,
    longitude: -87.82132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60546',
  },
  {
    city: 'Sandwich',
    county_fips: 17037,
    county_fips_all: '17037|17099|17093',
    county: 'DeKalb',
    county_names_all: 'DeKalb|LaSalle|Kendall',
    county_weights: '{"17037": 53.93, "17099": 34.23, "17093": 11.84}',
    density: 109.4,
    imprecise: false,
    latitude: 41.64811,
    longitude: -88.63471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60548',
  },
  {
    city: 'Serena',
    county_fips: 17099,
    county_fips_all: '17099',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"17099": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 41.4908,
    longitude: -88.74251,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60549',
  },
  {
    city: 'Shabbona',
    county_fips: 17037,
    county_fips_all: '17037',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"17037": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 41.77708,
    longitude: -88.87777,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60550',
  },
  {
    city: 'Sheridan',
    county_fips: 17099,
    county_fips_all: '17099',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"17099": 100}',
    density: 32.9,
    imprecise: false,
    latitude: 41.52463,
    longitude: -88.68992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60551',
  },
  {
    city: 'Somonauk',
    county_fips: 17037,
    county_fips_all: '17037|17099',
    county: 'DeKalb',
    county_names_all: 'DeKalb|LaSalle',
    county_weights: '{"17037": 80.76, "17099": 19.24}',
    density: 62.2,
    imprecise: false,
    latitude: 41.66144,
    longitude: -88.70343,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60552',
  },
  {
    city: 'Steward',
    county_fips: 17103,
    county_fips_all: '17103',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"17103": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 41.82399,
    longitude: -89.02806,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60553',
  },
  {
    city: 'Sugar Grove',
    county_fips: 17089,
    county_fips_all: '17089|17093',
    county: 'Kane',
    county_names_all: 'Kane|Kendall',
    county_weights: '{"17089": 98.22, "17093": 1.78}',
    density: 131.3,
    imprecise: false,
    latitude: 41.77852,
    longitude: -88.45838,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60554',
  },
  {
    city: 'Warrenville',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 731.5,
    imprecise: false,
    latitude: 41.82261,
    longitude: -88.18854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60555',
  },
  {
    city: 'Waterman',
    county_fips: 17037,
    county_fips_all: '17037',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"17037": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 41.76507,
    longitude: -88.77373,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60556',
  },
  {
    city: 'Wedron',
    county_fips: 17099,
    county_fips_all: '17099',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"17099": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.44383,
    longitude: -88.76654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60557',
  },
  {
    city: 'Western Springs',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1825.3,
    imprecise: false,
    latitude: 41.80207,
    longitude: -87.90076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60558',
  },
  {
    city: 'Westmont',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1992.5,
    imprecise: false,
    latitude: 41.79496,
    longitude: -87.97464,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60559',
  },
  {
    city: 'Yorkville',
    county_fips: 17093,
    county_fips_all: '17093',
    county: 'Kendall',
    county_names_all: 'Kendall',
    county_weights: '{"17093": 100}',
    density: 140.1,
    imprecise: false,
    latitude: 41.60799,
    longitude: -88.42841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60560',
  },
  {
    city: 'Darien',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1340.4,
    imprecise: false,
    latitude: 41.74518,
    longitude: -87.98174,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60561',
  },
  {
    city: 'Naperville',
    county_fips: 17043,
    county_fips_all: '17043',
    county: 'DuPage',
    county_names_all: 'DuPage',
    county_weights: '{"17043": 100}',
    density: 1042.6,
    imprecise: false,
    latitude: 41.79933,
    longitude: -88.16884,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60563',
  },
  {
    city: 'Naperville',
    county_fips: 17197,
    county_fips_all: '17197|17043',
    county: 'Will',
    county_names_all: 'Will|DuPage',
    county_weights: '{"17197": 74.92, "17043": 25.08}',
    density: 1133.2,
    imprecise: false,
    latitude: 41.70901,
    longitude: -88.19961,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60564',
  },
  {
    city: 'Naperville',
    county_fips: 17043,
    county_fips_all: '17043|17197',
    county: 'DuPage',
    county_names_all: 'DuPage|Will',
    county_weights: '{"17043": 62.98, "17197": 37.02}',
    density: 1213.6,
    imprecise: false,
    latitude: 41.7297,
    longitude: -88.12312,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60565',
  },
  {
    city: 'Plainfield',
    county_fips: 17197,
    county_fips_all: '17197|17093',
    county: 'Will',
    county_names_all: 'Will|Kendall',
    county_weights: '{"17197": 88.19, "17093": 11.81}',
    density: 673.4,
    imprecise: false,
    latitude: 41.65864,
    longitude: -88.22339,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60585',
  },
  {
    city: 'Plainfield',
    county_fips: 17197,
    county_fips_all: '17197|17093',
    county: 'Will',
    county_names_all: 'Will|Kendall',
    county_weights: '{"17197": 73.61, "17093": 26.39}',
    density: 1057.9,
    imprecise: false,
    latitude: 41.57036,
    longitude: -88.23162,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60586',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 15135.1,
    imprecise: false,
    latitude: 41.88527,
    longitude: -87.62197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60601',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 6934.4,
    imprecise: false,
    latitude: 41.88304,
    longitude: -87.62906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60602',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 4224.4,
    imprecise: false,
    latitude: 41.88018,
    longitude: -87.6274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60603',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3079.4,
    imprecise: false,
    latitude: 41.87799,
    longitude: -87.62928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60604',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 9773.8,
    imprecise: false,
    latitude: 41.86644,
    longitude: -87.61956,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60605',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 6388.9,
    imprecise: false,
    latitude: 41.88178,
    longitude: -87.63724,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60606',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 5406.3,
    imprecise: false,
    latitude: 41.87467,
    longitude: -87.65175,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60607',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 4990.3,
    imprecise: false,
    latitude: 41.84887,
    longitude: -87.67139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 80737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60608',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3090.4,
    imprecise: false,
    latitude: 41.81263,
    longitude: -87.65559,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 62028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60609',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 15580,
    imprecise: false,
    latitude: 41.90388,
    longitude: -87.63738,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60610',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 18359.9,
    imprecise: false,
    latitude: 41.89483,
    longitude: -87.61944,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60611',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3711.1,
    imprecise: false,
    latitude: 41.8805,
    longitude: -87.68783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60612',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 8664.4,
    imprecise: false,
    latitude: 41.9558,
    longitude: -87.65706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60613',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 8471,
    imprecise: false,
    latitude: 41.92267,
    longitude: -87.6506,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 70693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60614',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 7580.9,
    imprecise: false,
    latitude: 41.80226,
    longitude: -87.60293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60615',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 5517.9,
    imprecise: false,
    latitude: 41.84502,
    longitude: -87.62745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60616',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2112,
    imprecise: false,
    latitude: 41.71337,
    longitude: -87.55618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60617',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 7105.2,
    imprecise: false,
    latitude: 41.94694,
    longitude: -87.70263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 91901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60618',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3751.9,
    imprecise: false,
    latitude: 41.74346,
    longitude: -87.60532,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 59503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60619',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3579.5,
    imprecise: false,
    latitude: 41.74096,
    longitude: -87.65257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60620',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2910.6,
    imprecise: false,
    latitude: 41.77624,
    longitude: -87.63955,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60621',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 8434.3,
    imprecise: false,
    latitude: 41.90267,
    longitude: -87.68355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60622',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 5836.4,
    imprecise: false,
    latitude: 41.84793,
    longitude: -87.71753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 81277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60623',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3838.3,
    imprecise: false,
    latitude: 41.88045,
    longitude: -87.72366,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60624',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 7875,
    imprecise: false,
    latitude: 41.97318,
    longitude: -87.69963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 76760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60625',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 11171.1,
    imprecise: false,
    latitude: 42.00904,
    longitude: -87.66955,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60626',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2125.4,
    imprecise: false,
    latitude: 41.69165,
    longitude: -87.61828,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 60431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60628',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 5933.9,
    imprecise: false,
    latitude: 41.7754,
    longitude: -87.71239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 108324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60629',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 4518.4,
    imprecise: false,
    latitude: 41.97222,
    longitude: -87.75758,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60630',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3187.1,
    imprecise: false,
    latitude: 41.99473,
    longitude: -87.8131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60631',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 4618.4,
    imprecise: false,
    latitude: 41.81141,
    longitude: -87.71348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 89107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60632',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 494.1,
    imprecise: false,
    latitude: 41.66315,
    longitude: -87.56044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60633',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 4012.6,
    imprecise: false,
    latitude: 41.94627,
    longitude: -87.80639,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 73885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60634',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3177.4,
    imprecise: false,
    latitude: 41.77578,
    longitude: -87.66909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60636',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 4495.9,
    imprecise: false,
    latitude: 41.78156,
    longitude: -87.6032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60637',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1991.6,
    imprecise: false,
    latitude: 41.78175,
    longitude: -87.77057,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60638',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 6554.3,
    imprecise: false,
    latitude: 41.9206,
    longitude: -87.75593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 84240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60639',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 10701,
    imprecise: false,
    latitude: 41.97253,
    longitude: -87.66372,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 65445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60640',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 6605.9,
    imprecise: false,
    latitude: 41.94667,
    longitude: -87.74693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 68894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60641',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 5044.6,
    imprecise: false,
    latitude: 41.90193,
    longitude: -87.65804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60642',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2411.6,
    imprecise: false,
    latitude: 41.70026,
    longitude: -87.663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60643',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 5191.9,
    imprecise: false,
    latitude: 41.88013,
    longitude: -87.75756,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60644',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 8362.1,
    imprecise: false,
    latitude: 42.00859,
    longitude: -87.69457,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60645',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2504,
    imprecise: false,
    latitude: 41.99365,
    longitude: -87.76128,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60646',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 8257.3,
    imprecise: false,
    latitude: 41.92074,
    longitude: -87.702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 84749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60647',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 5125.7,
    imprecise: false,
    latitude: 41.75885,
    longitude: -87.56368,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60649',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 7061.6,
    imprecise: false,
    latitude: 41.90202,
    longitude: -87.74104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60651',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3278,
    imprecise: false,
    latitude: 41.74744,
    longitude: -87.71445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60652',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 5462.6,
    imprecise: false,
    latitude: 41.81924,
    longitude: -87.61017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60653',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 18353.9,
    imprecise: false,
    latitude: 41.89209,
    longitude: -87.63673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60654',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2490.6,
    imprecise: false,
    latitude: 41.69479,
    longitude: -87.70374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60655',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3523.4,
    imprecise: false,
    latitude: 41.97424,
    longitude: -87.82709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60656',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 12767.1,
    imprecise: false,
    latitude: 41.93965,
    longitude: -87.65495,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 71904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60657',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 6827.8,
    imprecise: false,
    latitude: 41.98946,
    longitude: -87.70668,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60659',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 12950.2,
    imprecise: false,
    latitude: 41.99113,
    longitude: -87.66609,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60660',
  },
  {
    city: 'Chicago',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 14401.3,
    imprecise: false,
    latitude: 41.88291,
    longitude: -87.64409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60661',
  },
  {
    city: 'Harwood Heights',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 3039.1,
    imprecise: false,
    latitude: 41.96384,
    longitude: -87.81672,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60706',
  },
  {
    city: 'Elmwood Park',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 4436.9,
    imprecise: false,
    latitude: 41.92175,
    longitude: -87.80744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60707',
  },
  {
    city: 'Lincolnwood',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1880.8,
    imprecise: false,
    latitude: 42.00543,
    longitude: -87.73296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60712',
  },
  {
    city: 'Niles',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1863.4,
    imprecise: false,
    latitude: 42.02834,
    longitude: -87.81131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60714',
  },
  {
    city: 'Alsip',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1100.6,
    imprecise: false,
    latitude: 41.67233,
    longitude: -87.73652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60803',
  },
  {
    city: 'Cicero',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 4492.8,
    imprecise: false,
    latitude: 41.84005,
    longitude: -87.75925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 82797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60804',
  },
  {
    city: 'Evergreen Park',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 2200.1,
    imprecise: false,
    latitude: 41.72201,
    longitude: -87.70243,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60805',
  },
  {
    city: 'Riverdale',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 1357.9,
    imprecise: false,
    latitude: 41.64967,
    longitude: -87.63013,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60827',
  },
  {
    city: 'Kankakee',
    county_fips: 17091,
    county_fips_all: '17091',
    county: 'Kankakee',
    county_names_all: 'Kankakee',
    county_weights: '{"17091": 100}',
    density: 131.4,
    imprecise: false,
    latitude: 41.11029,
    longitude: -87.90049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60901',
  },
  {
    city: 'Aroma Park',
    county_fips: 17091,
    county_fips_all: '17091',
    county: 'Kankakee',
    county_names_all: 'Kankakee',
    county_weights: '{"17091": 100}',
    density: 93.4,
    imprecise: false,
    latitude: 41.06426,
    longitude: -87.79991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60910',
  },
  {
    city: 'Ashkum',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 40.87856,
    longitude: -87.98059,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60911',
  },
  {
    city: 'Beaverville',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 5,
    imprecise: false,
    latitude: 40.97252,
    longitude: -87.60245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60912',
  },
  {
    city: 'Bonfield',
    county_fips: 17091,
    county_fips_all: '17091',
    county: 'Kankakee',
    county_names_all: 'Kankakee',
    county_weights: '{"17091": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 41.14835,
    longitude: -88.06206,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60913',
  },
  {
    city: 'Bourbonnais',
    county_fips: 17091,
    county_fips_all: '17091',
    county: 'Kankakee',
    county_names_all: 'Kankakee',
    county_weights: '{"17091": 100}',
    density: 226.3,
    imprecise: false,
    latitude: 41.18706,
    longitude: -87.86194,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60914',
  },
  {
    city: 'Bradley',
    county_fips: 17091,
    county_fips_all: '17091',
    county: 'Kankakee',
    county_names_all: 'Kankakee',
    county_weights: '{"17091": 100}',
    density: 1125.2,
    imprecise: false,
    latitude: 41.14758,
    longitude: -87.86039,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60915',
  },
  {
    city: 'Buckingham',
    county_fips: 17091,
    county_fips_all: '17091|17105|17053',
    county: 'Kankakee',
    county_names_all: 'Kankakee|Livingston|Ford',
    county_weights: '{"17091": 79.54, "17105": 16.3, "17053": 4.16}',
    density: 4.8,
    imprecise: false,
    latitude: 41.04644,
    longitude: -88.19179,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60917',
  },
  {
    city: 'Buckley',
    county_fips: 17075,
    county_fips_all: '17075|17053',
    county: 'Iroquois',
    county_names_all: 'Iroquois|Ford',
    county_weights: '{"17075": 98.01, "17053": 1.99}',
    density: 5.7,
    imprecise: false,
    latitude: 40.59681,
    longitude: -88.02968,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60918',
  },
  {
    city: 'Cabery',
    county_fips: 17053,
    county_fips_all: '17053|17105|17091',
    county: 'Ford',
    county_names_all: 'Ford|Livingston|Kankakee',
    county_weights: '{"17053": 44.21, "17105": 41.54, "17091": 14.25}',
    density: 5.7,
    imprecise: false,
    latitude: 40.98753,
    longitude: -88.24012,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60919',
  },
  {
    city: 'Campus',
    county_fips: 17105,
    county_fips_all: '17105',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"17105": 100}',
    density: 37,
    imprecise: false,
    latitude: 41.03021,
    longitude: -88.30378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60920',
  },
  {
    city: 'Chatsworth',
    county_fips: 17105,
    county_fips_all: '17105|17053',
    county: 'Livingston',
    county_names_all: 'Livingston|Ford',
    county_weights: '{"17105": 96.76, "17053": 3.24}',
    density: 7.9,
    imprecise: false,
    latitude: 40.73513,
    longitude: -88.28894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60921',
  },
  {
    city: 'Chebanse',
    county_fips: 17091,
    county_fips_all: '17091|17075',
    county: 'Kankakee',
    county_names_all: 'Kankakee|Iroquois',
    county_weights: '{"17091": 51.43, "17075": 48.57}',
    density: 14.7,
    imprecise: false,
    latitude: 41.00394,
    longitude: -87.92184,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60922',
  },
  {
    city: 'Cissna Park',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 40.55855,
    longitude: -87.88454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60924',
  },
  {
    city: 'Claytonville',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 40.56937,
    longitude: -87.81208,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60926',
  },
  {
    city: 'Clifton',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 40.93933,
    longitude: -87.96744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60927',
  },
  {
    city: 'Crescent City',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 40.74568,
    longitude: -87.85078,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60928',
  },
  {
    city: 'Cullom',
    county_fips: 17105,
    county_fips_all: '17105|17053',
    county: 'Livingston',
    county_names_all: 'Livingston|Ford',
    county_weights: '{"17105": 88.65, "17053": 11.35}',
    density: 5.9,
    imprecise: false,
    latitude: 40.87601,
    longitude: -88.29242,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60929',
  },
  {
    city: 'Danforth',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 40.83231,
    longitude: -88.00286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60930',
  },
  {
    city: 'Donovan',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 40.8919,
    longitude: -87.58654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60931',
  },
  {
    city: 'East Lynn',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 439.9,
    imprecise: false,
    latitude: 40.46513,
    longitude: -87.80013,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60932',
  },
  {
    city: 'Elliott',
    county_fips: 17053,
    county_fips_all: '17053',
    county: 'Ford',
    county_names_all: 'Ford',
    county_weights: '{"17053": 100}',
    density: 39.5,
    imprecise: false,
    latitude: 40.46258,
    longitude: -88.27381,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60933',
  },
  {
    city: 'Emington',
    county_fips: 17105,
    county_fips_all: '17105',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"17105": 100}',
    density: 3,
    imprecise: false,
    latitude: 40.96119,
    longitude: -88.34862,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60934',
  },
  {
    city: 'Essex',
    county_fips: 17091,
    county_fips_all: '17091',
    county: 'Kankakee',
    county_names_all: 'Kankakee',
    county_weights: '{"17091": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 41.17165,
    longitude: -88.16853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60935',
  },
  {
    city: 'Gibson City',
    county_fips: 17053,
    county_fips_all: '17053|17113|17019',
    county: 'Ford',
    county_names_all: 'Ford|McLean|Champaign',
    county_weights: '{"17053": 92.87, "17113": 5.32, "17019": 1.81}',
    density: 16.9,
    imprecise: false,
    latitude: 40.46456,
    longitude: -88.36103,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60936',
  },
  {
    city: 'Gilman',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 40.77456,
    longitude: -87.98355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60938',
  },
  {
    city: 'Goodwine',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.56696,
    longitude: -87.77714,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60939',
  },
  {
    city: 'Grant Park',
    county_fips: 17091,
    county_fips_all: '17091|17197',
    county: 'Kankakee',
    county_names_all: 'Kankakee|Will',
    county_weights: '{"17091": 97.55, "17197": 2.45}',
    density: 16.7,
    imprecise: false,
    latitude: 41.25188,
    longitude: -87.64259,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60940',
  },
  {
    city: 'Herscher',
    county_fips: 17091,
    county_fips_all: '17091|17075|17053',
    county: 'Kankakee',
    county_names_all: 'Kankakee|Iroquois|Ford',
    county_weights: '{"17091": 84.37, "17075": 11.72, "17053": 3.91}',
    density: 12.2,
    imprecise: false,
    latitude: 41.03865,
    longitude: -88.0859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60941',
  },
  {
    city: 'Hoopeston',
    county_fips: 17183,
    county_fips_all: '17183|17075',
    county: 'Vermilion',
    county_names_all: 'Vermilion|Iroquois',
    county_weights: '{"17183": 68.39, "17075": 31.61}',
    density: 18.9,
    imprecise: false,
    latitude: 40.46678,
    longitude: -87.66134,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60942',
  },
  {
    city: 'Iroquois',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 40.8315,
    longitude: -87.59236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60945',
  },
  {
    city: 'Kempton',
    county_fips: 17053,
    county_fips_all: '17053|17105',
    county: 'Ford',
    county_names_all: 'Ford|Livingston',
    county_weights: '{"17053": 82.39, "17105": 17.61}',
    density: 3.6,
    imprecise: false,
    latitude: 40.91307,
    longitude: -88.20072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60946',
  },
  {
    city: 'Loda',
    county_fips: 17075,
    county_fips_all: '17075|17053',
    county: 'Iroquois',
    county_names_all: 'Iroquois|Ford',
    county_weights: '{"17075": 70.27, "17053": 29.73}',
    density: 12.9,
    imprecise: false,
    latitude: 40.52413,
    longitude: -88.07698,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60948',
  },
  {
    city: 'Ludlow',
    county_fips: 17019,
    county_fips_all: '17019|17053',
    county: 'Champaign',
    county_names_all: 'Champaign|Ford',
    county_weights: '{"17019": 93.11, "17053": 6.89}',
    density: 9.5,
    imprecise: false,
    latitude: 40.38042,
    longitude: -88.10239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60949',
  },
  {
    city: 'Manteno',
    county_fips: 17091,
    county_fips_all: '17091|17197',
    county: 'Kankakee',
    county_names_all: 'Kankakee|Will',
    county_weights: '{"17091": 93.5, "17197": 6.5}',
    density: 60.3,
    imprecise: false,
    latitude: 41.25135,
    longitude: -87.88494,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60950',
  },
  {
    city: 'Martinton',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 40.91721,
    longitude: -87.74757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60951',
  },
  {
    city: 'Melvin',
    county_fips: 17053,
    county_fips_all: '17053|17105',
    county: 'Ford',
    county_names_all: 'Ford|Livingston',
    county_weights: '{"17053": 94.18, "17105": 5.82}',
    density: 6.3,
    imprecise: false,
    latitude: 40.56373,
    longitude: -88.25142,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60952',
  },
  {
    city: 'Milford',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 40.62854,
    longitude: -87.6894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60953',
  },
  {
    city: 'Momence',
    county_fips: 17091,
    county_fips_all: '17091',
    county: 'Kankakee',
    county_names_all: 'Kankakee',
    county_weights: '{"17091": 100}',
    density: 33.5,
    imprecise: false,
    latitude: 41.15446,
    longitude: -87.62827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60954',
  },
  {
    city: 'Onarga',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 40.7004,
    longitude: -87.98008,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60955',
  },
  {
    city: 'Papineau',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 244,
    imprecise: false,
    latitude: 40.96775,
    longitude: -87.7163,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60956',
  },
  {
    city: 'Paxton',
    county_fips: 17053,
    county_fips_all: '17053|17019',
    county: 'Ford',
    county_names_all: 'Ford|Champaign',
    county_weights: '{"17053": 85.44, "17019": 14.56}',
    density: 20.6,
    imprecise: false,
    latitude: 40.44037,
    longitude: -88.13977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60957',
  },
  {
    city: 'Pembroke Township',
    county_fips: 17091,
    county_fips_all: '17091',
    county: 'Kankakee',
    county_names_all: 'Kankakee',
    county_weights: '{"17091": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 41.06523,
    longitude: -87.5916,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60958',
  },
  {
    city: 'Piper City',
    county_fips: 17053,
    county_fips_all: '17053|17105',
    county: 'Ford',
    county_names_all: 'Ford|Livingston',
    county_weights: '{"17053": 95.08, "17105": 4.92}',
    density: 6.3,
    imprecise: false,
    latitude: 40.7895,
    longitude: -88.1832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60959',
  },
  {
    city: 'Rankin',
    county_fips: 17183,
    county_fips_all: '17183|17053|17075|17019',
    county: 'Vermilion',
    county_names_all: 'Vermilion|Ford|Iroquois|Champaign',
    county_weights:
      '{"17183": 66.57, "17053": 22.35, "17075": 8.9, "17019": 2.18}',
    density: 4.4,
    imprecise: false,
    latitude: 40.43879,
    longitude: -87.89132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60960',
  },
  {
    city: 'Reddick',
    county_fips: 17091,
    county_fips_all: '17091|17105|17063',
    county: 'Kankakee',
    county_names_all: 'Kankakee|Livingston|Grundy',
    county_weights: '{"17091": 68.54, "17105": 26.03, "17063": 5.43}',
    density: 7.5,
    imprecise: false,
    latitude: 41.10611,
    longitude: -88.23098,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60961',
  },
  {
    city: 'Roberts',
    county_fips: 17053,
    county_fips_all: '17053',
    county: 'Ford',
    county_names_all: 'Ford',
    county_weights: '{"17053": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 40.62248,
    longitude: -88.18442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60962',
  },
  {
    city: 'Rossville',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 40.36848,
    longitude: -87.65115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60963',
  },
  {
    city: 'Saint Anne',
    county_fips: 17091,
    county_fips_all: '17091|17075',
    county: 'Kankakee',
    county_names_all: 'Kankakee|Iroquois',
    county_weights: '{"17091": 72.11, "17075": 27.89}',
    density: 24.7,
    imprecise: false,
    latitude: 41.03401,
    longitude: -87.7418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60964',
  },
  {
    city: 'Sheldon',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 40.75144,
    longitude: -87.58321,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60966',
  },
  {
    city: 'Stockland',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 40.6241,
    longitude: -87.58123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60967',
  },
  {
    city: 'Thawville',
    county_fips: 17075,
    county_fips_all: '17075|17053|17105',
    county: 'Iroquois',
    county_names_all: 'Iroquois|Ford|Livingston',
    county_weights: '{"17075": 52.29, "17053": 45.6, "17105": 2.11}',
    density: 3,
    imprecise: false,
    latitude: 40.6746,
    longitude: -88.12049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60968',
  },
  {
    city: 'Union Hill',
    county_fips: 17091,
    county_fips_all: '17091',
    county: 'Kankakee',
    county_names_all: 'Kankakee',
    county_weights: '{"17091": 100}',
    density: 110.5,
    imprecise: false,
    latitude: 41.11101,
    longitude: -88.14975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60969',
  },
  {
    city: 'Watseka',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 40.79221,
    longitude: -87.74039,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60970',
  },
  {
    city: 'Wellington',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 40.53654,
    longitude: -87.66265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60973',
  },
  {
    city: 'Woodland',
    county_fips: 17075,
    county_fips_all: '17075',
    county: 'Iroquois',
    county_names_all: 'Iroquois',
    county_weights: '{"17075": 100}',
    density: 94.8,
    imprecise: false,
    latitude: 40.71807,
    longitude: -87.73588,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60974',
  },
  {
    city: 'Apple River',
    county_fips: 17085,
    county_fips_all: '17085',
    county: 'Jo Daviess',
    county_names_all: 'Jo Daviess',
    county_weights: '{"17085": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 42.4612,
    longitude: -90.12226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61001',
  },
  {
    city: 'Ashton',
    county_fips: 17103,
    county_fips_all: '17103|17141',
    county: 'Lee',
    county_names_all: 'Lee|Ogle',
    county_weights: '{"17103": 73.34, "17141": 26.66}',
    density: 8.5,
    imprecise: false,
    latitude: 41.86078,
    longitude: -89.20836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61006',
  },
  {
    city: 'Baileyville',
    county_fips: 17141,
    county_fips_all: '17141|17177',
    county: 'Ogle',
    county_names_all: 'Ogle|Stephenson',
    county_weights: '{"17141": 56.72, "17177": 43.28}',
    density: 3.1,
    imprecise: false,
    latitude: 42.19941,
    longitude: -89.59109,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61007',
  },
  {
    city: 'Belvidere',
    county_fips: 17007,
    county_fips_all: '17007|17201',
    county: 'Boone',
    county_names_all: 'Boone|Winnebago',
    county_weights: '{"17007": 99.9, "17201": 0.1}',
    density: 153.8,
    imprecise: false,
    latitude: 42.24579,
    longitude: -88.83949,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61008',
  },
  {
    city: 'Byron',
    county_fips: 17141,
    county_fips_all: '17141',
    county: 'Ogle',
    county_names_all: 'Ogle',
    county_weights: '{"17141": 100}',
    density: 75.8,
    imprecise: false,
    latitude: 42.136,
    longitude: -89.26751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61010',
  },
  {
    city: 'Caledonia',
    county_fips: 17007,
    county_fips_all: '17007|17201',
    county: 'Boone',
    county_names_all: 'Boone|Winnebago',
    county_weights: '{"17007": 81.84, "17201": 18.16}',
    density: 26.8,
    imprecise: false,
    latitude: 42.38926,
    longitude: -88.91266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61011',
  },
  {
    city: 'Capron',
    county_fips: 17007,
    county_fips_all: '17007',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"17007": 100}',
    density: 24.2,
    imprecise: false,
    latitude: 42.40749,
    longitude: -88.75446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61012',
  },
  {
    city: 'Cedarville',
    county_fips: 17177,
    county_fips_all: '17177',
    county: 'Stephenson',
    county_names_all: 'Stephenson',
    county_weights: '{"17177": 100}',
    density: 566.3,
    imprecise: false,
    latitude: 42.37544,
    longitude: -89.63623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61013',
  },
  {
    city: 'Chadwick',
    county_fips: 17015,
    county_fips_all: '17015|17195',
    county: 'Carroll',
    county_names_all: 'Carroll|Whiteside',
    county_weights: '{"17015": 85.02, "17195": 14.98}',
    density: 6.5,
    imprecise: false,
    latitude: 41.97501,
    longitude: -89.8865,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61014',
  },
  {
    city: 'Chana',
    county_fips: 17141,
    county_fips_all: '17141',
    county: 'Ogle',
    county_names_all: 'Ogle',
    county_weights: '{"17141": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 41.99443,
    longitude: -89.20011,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61015',
  },
  {
    city: 'Cherry Valley',
    county_fips: 17201,
    county_fips_all: '17201|17007',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Boone',
    county_weights: '{"17201": 57.39, "17007": 42.61}',
    density: 74.7,
    imprecise: false,
    latitude: 42.19761,
    longitude: -88.94704,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61016',
  },
  {
    city: 'Dakota',
    county_fips: 17177,
    county_fips_all: '17177',
    county: 'Stephenson',
    county_names_all: 'Stephenson',
    county_weights: '{"17177": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 42.41599,
    longitude: -89.55558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61018',
  },
  {
    city: 'Davis',
    county_fips: 17177,
    county_fips_all: '17177|17201',
    county: 'Stephenson',
    county_names_all: 'Stephenson|Winnebago',
    county_weights: '{"17177": 61.66, "17201": 38.34}',
    density: 35.7,
    imprecise: false,
    latitude: 42.44093,
    longitude: -89.40863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61019',
  },
  {
    city: 'Davis Junction',
    county_fips: 17141,
    county_fips_all: '17141|17201',
    county: 'Ogle',
    county_names_all: 'Ogle|Winnebago',
    county_weights: '{"17141": 90.55, "17201": 9.45}',
    density: 38.6,
    imprecise: false,
    latitude: 42.11035,
    longitude: -89.09807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61020',
  },
  {
    city: 'Dixon',
    county_fips: 17103,
    county_fips_all: '17103|17141',
    county: 'Lee',
    county_names_all: 'Lee|Ogle',
    county_weights: '{"17103": 89.0, "17141": 11.0}',
    density: 57.4,
    imprecise: false,
    latitude: 41.82908,
    longitude: -89.47764,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61021',
  },
  {
    city: 'Durand',
    county_fips: 17201,
    county_fips_all: '17201',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"17201": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 42.43629,
    longitude: -89.29183,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61024',
  },
  {
    city: 'East Dubuque',
    county_fips: 17085,
    county_fips_all: '17085',
    county: 'Jo Daviess',
    county_names_all: 'Jo Daviess',
    county_weights: '{"17085": 100}',
    density: 46.6,
    imprecise: false,
    latitude: 42.46958,
    longitude: -90.55904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61025',
  },
  {
    city: 'Eleroy',
    county_fips: 17177,
    county_fips_all: '17177',
    county: 'Stephenson',
    county_names_all: 'Stephenson',
    county_weights: '{"17177": 100}',
    density: 25.3,
    imprecise: false,
    latitude: 42.3333,
    longitude: -89.75553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61027',
  },
  {
    city: 'Elizabeth',
    county_fips: 17085,
    county_fips_all: '17085|17015',
    county: 'Jo Daviess',
    county_names_all: 'Jo Daviess|Carroll',
    county_weights: '{"17085": 99.71, "17015": 0.29}',
    density: 5.7,
    imprecise: false,
    latitude: 42.29366,
    longitude: -90.16935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61028',
  },
  {
    city: 'Forreston',
    county_fips: 17141,
    county_fips_all: '17141',
    county: 'Ogle',
    county_names_all: 'Ogle',
    county_weights: '{"17141": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 42.11578,
    longitude: -89.58898,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61030',
  },
  {
    city: 'Franklin Grove',
    county_fips: 17103,
    county_fips_all: '17103|17141',
    county: 'Lee',
    county_names_all: 'Lee|Ogle',
    county_weights: '{"17103": 95.07, "17141": 4.93}',
    density: 12.8,
    imprecise: false,
    latitude: 41.83263,
    longitude: -89.31626,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61031',
  },
  {
    city: 'Freeport',
    county_fips: 17177,
    county_fips_all: '17177',
    county: 'Stephenson',
    county_names_all: 'Stephenson',
    county_weights: '{"17177": 100}',
    density: 75.4,
    imprecise: false,
    latitude: 42.31509,
    longitude: -89.63598,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61032',
  },
  {
    city: 'Galena',
    county_fips: 17085,
    county_fips_all: '17085',
    county: 'Jo Daviess',
    county_names_all: 'Jo Daviess',
    county_weights: '{"17085": 100}',
    density: 28.7,
    imprecise: false,
    latitude: 42.4172,
    longitude: -90.39816,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61036',
  },
  {
    city: 'Galt',
    county_fips: 17195,
    county_fips_all: '17195',
    county: 'Whiteside',
    county_names_all: 'Whiteside',
    county_weights: '{"17195": 100}',
    density: 412.1,
    imprecise: false,
    latitude: 41.7882,
    longitude: -89.75978,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61037',
  },
  {
    city: 'Garden Prairie',
    county_fips: 17007,
    county_fips_all: '17007|17111',
    county: 'Boone',
    county_names_all: 'Boone|McHenry',
    county_weights: '{"17007": 92.73, "17111": 7.27}',
    density: 11.5,
    imprecise: false,
    latitude: 42.26344,
    longitude: -88.73586,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61038',
  },
  {
    city: 'German Valley',
    county_fips: 17177,
    county_fips_all: '17177|17141',
    county: 'Stephenson',
    county_names_all: 'Stephenson|Ogle',
    county_weights: '{"17177": 61.94, "17141": 38.06}',
    density: 11.1,
    imprecise: false,
    latitude: 42.20805,
    longitude: -89.46931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61039',
  },
  {
    city: 'Hanover',
    county_fips: 17085,
    county_fips_all: '17085',
    county: 'Jo Daviess',
    county_names_all: 'Jo Daviess',
    county_weights: '{"17085": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 42.272,
    longitude: -90.3202,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61041',
  },
  {
    city: 'Harmon',
    county_fips: 17103,
    county_fips_all: '17103',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"17103": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 41.68819,
    longitude: -89.56015,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61042',
  },
  {
    city: 'Holcomb',
    county_fips: 17141,
    county_fips_all: '17141',
    county: 'Ogle',
    county_names_all: 'Ogle',
    county_weights: '{"17141": 100}',
    density: 114.9,
    imprecise: false,
    latitude: 42.06676,
    longitude: -89.10499,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61043',
  },
  {
    city: 'Kent',
    county_fips: 17177,
    county_fips_all: '17177|17085',
    county: 'Stephenson',
    county_names_all: 'Stephenson|Jo Daviess',
    county_weights: '{"17177": 65.68, "17085": 34.32}',
    density: 6.7,
    imprecise: false,
    latitude: 42.32336,
    longitude: -89.9099,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61044',
  },
  {
    city: 'Lanark',
    county_fips: 17015,
    county_fips_all: '17015',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"17015": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 42.10404,
    longitude: -89.81329,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61046',
  },
  {
    city: 'Leaf River',
    county_fips: 17141,
    county_fips_all: '17141|17201|17177',
    county: 'Ogle',
    county_names_all: 'Ogle|Winnebago|Stephenson',
    county_weights: '{"17141": 92.31, "17201": 6.01, "17177": 1.68}',
    density: 9.4,
    imprecise: false,
    latitude: 42.15305,
    longitude: -89.39597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61047',
  },
  {
    city: 'Lena',
    county_fips: 17177,
    county_fips_all: '17177|17085',
    county: 'Stephenson',
    county_names_all: 'Stephenson|Jo Daviess',
    county_weights: '{"17177": 91.24, "17085": 8.76}',
    density: 17.9,
    imprecise: false,
    latitude: 42.38524,
    longitude: -89.83526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61048',
  },
  {
    city: 'Lindenwood',
    county_fips: 17141,
    county_fips_all: '17141',
    county: 'Ogle',
    county_names_all: 'Ogle',
    county_weights: '{"17141": 100}',
    density: 11,
    imprecise: false,
    latitude: 42.04417,
    longitude: -89.00753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61049',
  },
  {
    city: 'McConnell',
    county_fips: 17177,
    county_fips_all: '17177',
    county: 'Stephenson',
    county_names_all: 'Stephenson',
    county_weights: '{"17177": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 42.43932,
    longitude: -89.7319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61050',
  },
  {
    city: 'Milledgeville',
    county_fips: 17015,
    county_fips_all: '17015|17141',
    county: 'Carroll',
    county_names_all: 'Carroll|Ogle',
    county_weights: '{"17015": 96.18, "17141": 3.82}',
    density: 11.2,
    imprecise: false,
    latitude: 41.98289,
    longitude: -89.7619,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61051',
  },
  {
    city: 'Monroe Center',
    county_fips: 17141,
    county_fips_all: '17141',
    county: 'Ogle',
    county_names_all: 'Ogle',
    county_weights: '{"17141": 100}',
    density: 16,
    imprecise: false,
    latitude: 42.11146,
    longitude: -89.00011,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61052',
  },
  {
    city: 'Mount Carroll',
    county_fips: 17015,
    county_fips_all: '17015|17085',
    county: 'Carroll',
    county_names_all: 'Carroll|Jo Daviess',
    county_weights: '{"17015": 90.26, "17085": 9.74}',
    density: 9.3,
    imprecise: false,
    latitude: 42.11506,
    longitude: -89.98335,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61053',
  },
  {
    city: 'Mount Morris',
    county_fips: 17141,
    county_fips_all: '17141',
    county: 'Ogle',
    county_names_all: 'Ogle',
    county_weights: '{"17141": 100}',
    density: 33.4,
    imprecise: false,
    latitude: 42.05573,
    longitude: -89.44548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61054',
  },
  {
    city: 'Nachusa',
    county_fips: 17103,
    county_fips_all: '17103',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"17103": 100}',
    density: 18,
    imprecise: false,
    latitude: 41.83357,
    longitude: -89.38401,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61057',
  },
  {
    city: 'Nora',
    county_fips: 17085,
    county_fips_all: '17085|17177',
    county: 'Jo Daviess',
    county_names_all: 'Jo Daviess|Stephenson',
    county_weights: '{"17085": 99.73, "17177": 0.27}',
    density: 60.2,
    imprecise: false,
    latitude: 42.45465,
    longitude: -89.94084,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61059',
  },
  {
    city: 'Orangeville',
    county_fips: 17177,
    county_fips_all: '17177',
    county: 'Stephenson',
    county_names_all: 'Stephenson',
    county_weights: '{"17177": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 42.47876,
    longitude: -89.61819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61060',
  },
  {
    city: 'Oregon',
    county_fips: 17141,
    county_fips_all: '17141',
    county: 'Ogle',
    county_names_all: 'Ogle',
    county_weights: '{"17141": 100}',
    density: 24.8,
    imprecise: false,
    latitude: 41.99851,
    longitude: -89.33819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61061',
  },
  {
    city: 'Pearl City',
    county_fips: 17177,
    county_fips_all: '17177|17085|17015',
    county: 'Stephenson',
    county_names_all: 'Stephenson|Jo Daviess|Carroll',
    county_weights: '{"17177": 91.15, "17085": 6.59, "17015": 2.26}',
    density: 9.5,
    imprecise: false,
    latitude: 42.25254,
    longitude: -89.84263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61062',
  },
  {
    city: 'Pecatonica',
    county_fips: 17201,
    county_fips_all: '17201|17177',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Stephenson',
    county_weights: '{"17201": 83.74, "17177": 16.26}',
    density: 20.8,
    imprecise: false,
    latitude: 42.31305,
    longitude: -89.34691,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61063',
  },
  {
    city: 'Polo',
    county_fips: 17141,
    county_fips_all: '17141|17015|17103|17195',
    county: 'Ogle',
    county_names_all: 'Ogle|Carroll|Lee|Whiteside',
    county_weights:
      '{"17141": 93.9, "17015": 4.35, "17103": 1.03, "17195": 0.72}',
    density: 13.3,
    imprecise: false,
    latitude: 41.9893,
    longitude: -89.5873,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61064',
  },
  {
    city: 'Poplar Grove',
    county_fips: 17007,
    county_fips_all: '17007',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"17007": 100}',
    density: 80.1,
    imprecise: false,
    latitude: 42.40786,
    longitude: -88.82747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61065',
  },
  {
    city: 'Ridott',
    county_fips: 17177,
    county_fips_all: '17177',
    county: 'Stephenson',
    county_names_all: 'Stephenson',
    county_weights: '{"17177": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 42.30472,
    longitude: -89.47454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61067',
  },
  {
    city: 'Rochelle',
    county_fips: 17141,
    county_fips_all: '17141|17103|17037',
    county: 'Ogle',
    county_names_all: 'Ogle|Lee|DeKalb',
    county_weights: '{"17141": 88.77, "17103": 10.01, "17037": 1.22}',
    density: 47.3,
    imprecise: false,
    latitude: 41.94928,
    longitude: -89.0652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61068',
  },
  {
    city: 'Rock City',
    county_fips: 17177,
    county_fips_all: '17177',
    county: 'Stephenson',
    county_names_all: 'Stephenson',
    county_weights: '{"17177": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 42.41571,
    longitude: -89.47177,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61070',
  },
  {
    city: 'Rock Falls',
    county_fips: 17195,
    county_fips_all: '17195|17103',
    county: 'Whiteside',
    county_names_all: 'Whiteside|Lee',
    county_weights: '{"17195": 88.77, "17103": 11.23}',
    density: 72.3,
    imprecise: false,
    latitude: 41.72599,
    longitude: -89.70006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61071',
  },
  {
    city: 'Rockton',
    county_fips: 17201,
    county_fips_all: '17201',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"17201": 100}',
    density: 83.2,
    imprecise: false,
    latitude: 42.44661,
    longitude: -89.14109,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61072',
  },
  {
    city: 'Roscoe',
    county_fips: 17201,
    county_fips_all: '17201|17007',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Boone',
    county_weights: '{"17201": 95.9, "17007": 4.1}',
    density: 279.1,
    imprecise: false,
    latitude: 42.42434,
    longitude: -88.99346,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61073',
  },
  {
    city: 'Savanna',
    county_fips: 17015,
    county_fips_all: '17015|17085',
    county: 'Carroll',
    county_names_all: 'Carroll|Jo Daviess',
    county_weights: '{"17015": 98.18, "17085": 1.82}',
    density: 20.8,
    imprecise: false,
    latitude: 42.12615,
    longitude: -90.13061,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61074',
  },
  {
    city: 'Scales Mound',
    county_fips: 17085,
    county_fips_all: '17085',
    county: 'Jo Daviess',
    county_names_all: 'Jo Daviess',
    county_weights: '{"17085": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 42.46546,
    longitude: -90.26444,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61075',
  },
  {
    city: 'Seward',
    county_fips: 17201,
    county_fips_all: '17201',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"17201": 100}',
    density: 47.2,
    imprecise: false,
    latitude: 42.24012,
    longitude: -89.34806,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61077',
  },
  {
    city: 'Shannon',
    county_fips: 17015,
    county_fips_all: '17015|17177|17141',
    county: 'Carroll',
    county_names_all: 'Carroll|Stephenson|Ogle',
    county_weights: '{"17015": 66.2, "17177": 17.54, "17141": 16.26}',
    density: 10.2,
    imprecise: false,
    latitude: 42.16729,
    longitude: -89.73062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61078',
  },
  {
    city: 'Shirland',
    county_fips: 17201,
    county_fips_all: '17201',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"17201": 100}',
    density: 21,
    imprecise: false,
    latitude: 42.44681,
    longitude: -89.20955,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61079',
  },
  {
    city: 'South Beloit',
    county_fips: 17201,
    county_fips_all: '17201|17007',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Boone',
    county_weights: '{"17201": 71.6, "17007": 28.4}',
    density: 168.8,
    imprecise: false,
    latitude: 42.47992,
    longitude: -88.98989,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61080',
  },
  {
    city: 'Sterling',
    county_fips: 17195,
    county_fips_all: '17195|17103',
    county: 'Whiteside',
    county_names_all: 'Whiteside|Lee',
    county_weights: '{"17195": 94.54, "17103": 5.46}',
    density: 64.7,
    imprecise: false,
    latitude: 41.84425,
    longitude: -89.73613,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61081',
  },
  {
    city: 'Stillman Valley',
    county_fips: 17141,
    county_fips_all: '17141|17201',
    county: 'Ogle',
    county_names_all: 'Ogle|Winnebago',
    county_weights: '{"17141": 93.12, "17201": 6.88}',
    density: 35.5,
    imprecise: false,
    latitude: 42.11843,
    longitude: -89.18867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61084',
  },
  {
    city: 'Stockton',
    county_fips: 17085,
    county_fips_all: '17085',
    county: 'Jo Daviess',
    county_names_all: 'Jo Daviess',
    county_weights: '{"17085": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 42.34268,
    longitude: -90.03077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61085',
  },
  {
    city: 'Warren',
    county_fips: 17085,
    county_fips_all: '17085|17177',
    county: 'Jo Daviess',
    county_names_all: 'Jo Daviess|Stephenson',
    county_weights: '{"17085": 93.06, "17177": 6.94}',
    density: 22.6,
    imprecise: false,
    latitude: 42.48046,
    longitude: -89.99351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61087',
  },
  {
    city: 'Winnebago',
    county_fips: 17201,
    county_fips_all: '17201|17141',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Ogle',
    county_weights: '{"17201": 99.77, "17141": 0.23}',
    density: 42.1,
    imprecise: false,
    latitude: 42.26995,
    longitude: -89.25509,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61088',
  },
  {
    city: 'Winslow',
    county_fips: 17177,
    county_fips_all: '17177|17085',
    county: 'Stephenson',
    county_names_all: 'Stephenson|Jo Daviess',
    county_weights: '{"17177": 96.02, "17085": 3.98}',
    density: 4.6,
    imprecise: false,
    latitude: 42.47349,
    longitude: -89.82335,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61089',
  },
  {
    city: 'Woosung',
    county_fips: 17141,
    county_fips_all: '17141',
    county: 'Ogle',
    county_names_all: 'Ogle',
    county_weights: '{"17141": 100}',
    density: 38,
    imprecise: false,
    latitude: 41.90818,
    longitude: -89.55234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61091',
  },
  {
    city: 'Rockford',
    county_fips: 17201,
    county_fips_all: '17201',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"17201": 100}',
    density: 179.6,
    imprecise: false,
    latitude: 42.33727,
    longitude: -89.14725,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61101',
  },
  {
    city: 'Rockford',
    county_fips: 17201,
    county_fips_all: '17201|17141',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Ogle',
    county_weights: '{"17201": 87.9, "17141": 12.1}',
    density: 180.4,
    imprecise: false,
    latitude: 42.22995,
    longitude: -89.15632,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61102',
  },
  {
    city: 'Rockford',
    county_fips: 17201,
    county_fips_all: '17201',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"17201": 100}',
    density: 540.5,
    imprecise: false,
    latitude: 42.3453,
    longitude: -89.08271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61103',
  },
  {
    city: 'Rockford',
    county_fips: 17201,
    county_fips_all: '17201',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"17201": 100}',
    density: 1477.6,
    imprecise: false,
    latitude: 42.25186,
    longitude: -89.07911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61104',
  },
  {
    city: 'Rockford',
    county_fips: 17201,
    county_fips_all: '17201|17007',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Boone',
    county_weights: '{"17201": 94.27, "17007": 5.73}',
    density: 796.2,
    imprecise: false,
    latitude: 42.28344,
    longitude: -89.00348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61107',
  },
  {
    city: 'Rockford',
    county_fips: 17201,
    county_fips_all: '17201',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"17201": 100}',
    density: 1073.6,
    imprecise: false,
    latitude: 42.25515,
    longitude: -89.00236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61108',
  },
  {
    city: 'Rockford',
    county_fips: 17201,
    county_fips_all: '17201|17141',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Ogle',
    county_weights: '{"17201": 96.75, "17141": 3.25}',
    density: 268.3,
    imprecise: false,
    latitude: 42.1924,
    longitude: -89.05392,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61109',
  },
  {
    city: 'Loves Park',
    county_fips: 17201,
    county_fips_all: '17201|17007',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Boone',
    county_weights: '{"17201": 95.79, "17007": 4.21}',
    density: 631.9,
    imprecise: false,
    latitude: 42.33538,
    longitude: -89.00369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61111',
  },
  {
    city: 'Rockford',
    county_fips: 17201,
    county_fips_all: '17201',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"17201": 100}',
    density: 74.3,
    imprecise: false,
    latitude: 42.24193,
    longitude: -88.97523,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61112',
  },
  {
    city: 'Rockford',
    county_fips: 17201,
    county_fips_all: '17201|17007',
    county: 'Winnebago',
    county_names_all: 'Winnebago|Boone',
    county_weights: '{"17201": 87.76, "17007": 12.24}',
    density: 726.6,
    imprecise: false,
    latitude: 42.30854,
    longitude: -88.9892,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61114',
  },
  {
    city: 'Machesney Park',
    county_fips: 17201,
    county_fips_all: '17201',
    county: 'Winnebago',
    county_names_all: 'Winnebago',
    county_weights: '{"17201": 100}',
    density: 810.9,
    imprecise: false,
    latitude: 42.36365,
    longitude: -89.02869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61115',
  },
  {
    city: 'Rock Island',
    county_fips: 17161,
    county_fips_all: '17161',
    county: 'Rock Island',
    county_names_all: 'Rock Island',
    county_weights: '{"17161": 100}',
    density: 794.2,
    imprecise: false,
    latitude: 41.47799,
    longitude: -90.57608,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61201',
  },
  {
    city: 'Albany',
    county_fips: 17195,
    county_fips_all: '17195',
    county: 'Whiteside',
    county_names_all: 'Whiteside',
    county_weights: '{"17195": 100}',
    density: 20.8,
    imprecise: false,
    latitude: 41.74074,
    longitude: -90.21447,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61230',
  },
  {
    city: 'Aledo',
    county_fips: 17131,
    county_fips_all: '17131',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"17131": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 41.2128,
    longitude: -90.72294,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61231',
  },
  {
    city: 'Andalusia',
    county_fips: 17161,
    county_fips_all: '17161',
    county: 'Rock Island',
    county_names_all: 'Rock Island',
    county_weights: '{"17161": 100}',
    density: 175.7,
    imprecise: false,
    latitude: 41.43168,
    longitude: -90.72734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61232',
  },
  {
    city: 'Andover',
    county_fips: 17073,
    county_fips_all: '17073',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"17073": 100}',
    density: 150.7,
    imprecise: false,
    latitude: 41.29464,
    longitude: -90.29129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61233',
  },
  {
    city: 'Annawan',
    county_fips: 17073,
    county_fips_all: '17073',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"17073": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 41.41804,
    longitude: -89.91947,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61234',
  },
  {
    city: 'Atkinson',
    county_fips: 17073,
    county_fips_all: '17073',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"17073": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 41.39972,
    longitude: -90.0237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61235',
  },
  {
    city: 'Barstow',
    county_fips: 17161,
    county_fips_all: '17161',
    county: 'Rock Island',
    county_names_all: 'Rock Island',
    county_weights: '{"17161": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 41.51242,
    longitude: -90.35586,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61236',
  },
  {
    city: 'Buffalo Prairie',
    county_fips: 17161,
    county_fips_all: '17161',
    county: 'Rock Island',
    county_names_all: 'Rock Island',
    county_weights: '{"17161": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.34175,
    longitude: -90.86221,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61237',
  },
  {
    city: 'Cambridge',
    county_fips: 17073,
    county_fips_all: '17073',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"17073": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 41.28727,
    longitude: -90.17647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61238',
  },
  {
    city: 'Carbon Cliff',
    county_fips: 17161,
    county_fips_all: '17161',
    county: 'Rock Island',
    county_names_all: 'Rock Island',
    county_weights: '{"17161": 100}',
    density: 580.5,
    imprecise: false,
    latitude: 41.49479,
    longitude: -90.38966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61239',
  },
  {
    city: 'Coal Valley',
    county_fips: 17161,
    county_fips_all: '17161|17073',
    county: 'Rock Island',
    county_names_all: 'Rock Island|Henry',
    county_weights: '{"17161": 54.02, "17073": 45.98}',
    density: 61.4,
    imprecise: false,
    latitude: 41.42579,
    longitude: -90.4325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61240',
  },
  {
    city: 'Colona',
    county_fips: 17073,
    county_fips_all: '17073',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"17073": 100}',
    density: 133,
    imprecise: false,
    latitude: 41.48782,
    longitude: -90.31997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61241',
  },
  {
    city: 'Cordova',
    county_fips: 17161,
    county_fips_all: '17161',
    county: 'Rock Island',
    county_names_all: 'Rock Island',
    county_weights: '{"17161": 100}',
    density: 14,
    imprecise: false,
    latitude: 41.70363,
    longitude: -90.27858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61242',
  },
  {
    city: 'Deer Grove',
    county_fips: 17195,
    county_fips_all: '17195|17103',
    county: 'Whiteside',
    county_names_all: 'Whiteside|Lee',
    county_weights: '{"17195": 95.34, "17103": 4.66}',
    density: 2.3,
    imprecise: false,
    latitude: 41.61849,
    longitude: -89.6784,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61243',
  },
  {
    city: 'East Moline',
    county_fips: 17161,
    county_fips_all: '17161',
    county: 'Rock Island',
    county_names_all: 'Rock Island',
    county_weights: '{"17161": 100}',
    density: 334,
    imprecise: false,
    latitude: 41.52138,
    longitude: -90.39424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61244',
  },
  {
    city: 'Erie',
    county_fips: 17195,
    county_fips_all: '17195|17073',
    county: 'Whiteside',
    county_names_all: 'Whiteside|Henry',
    county_weights: '{"17195": 94.25, "17073": 5.75}',
    density: 12.3,
    imprecise: false,
    latitude: 41.65884,
    longitude: -90.10081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61250',
  },
  {
    city: 'Fenton',
    county_fips: 17195,
    county_fips_all: '17195',
    county: 'Whiteside',
    county_names_all: 'Whiteside',
    county_weights: '{"17195": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 41.72909,
    longitude: -90.07291,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61251',
  },
  {
    city: 'Fulton',
    county_fips: 17195,
    county_fips_all: '17195',
    county: 'Whiteside',
    county_names_all: 'Whiteside',
    county_weights: '{"17195": 100}',
    density: 35.7,
    imprecise: false,
    latitude: 41.8435,
    longitude: -90.12272,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61252',
  },
  {
    city: 'Geneseo',
    county_fips: 17073,
    county_fips_all: '17073|17195',
    county: 'Henry',
    county_names_all: 'Henry|Whiteside',
    county_weights: '{"17073": 99.4, "17195": 0.6}',
    density: 28.1,
    imprecise: false,
    latitude: 41.46692,
    longitude: -90.15551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61254',
  },
  {
    city: 'Hampton',
    county_fips: 17161,
    county_fips_all: '17161',
    county: 'Rock Island',
    county_names_all: 'Rock Island',
    county_weights: '{"17161": 100}',
    density: 501.1,
    imprecise: false,
    latitude: 41.56017,
    longitude: -90.40151,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61256',
  },
  {
    city: 'Hillsdale',
    county_fips: 17161,
    county_fips_all: '17161',
    county: 'Rock Island',
    county_names_all: 'Rock Island',
    county_weights: '{"17161": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 41.59025,
    longitude: -90.22322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61257',
  },
  {
    city: 'Hooppole',
    county_fips: 17073,
    county_fips_all: '17073',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"17073": 100}',
    density: 189,
    imprecise: false,
    latitude: 41.52185,
    longitude: -89.91396,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61258',
  },
  {
    city: 'Illinois City',
    county_fips: 17161,
    county_fips_all: '17161|17131',
    county: 'Rock Island',
    county_names_all: 'Rock Island|Mercer',
    county_weights: '{"17161": 97.1, "17131": 2.9}',
    density: 5.3,
    imprecise: false,
    latitude: 41.38839,
    longitude: -90.92733,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61259',
  },
  {
    city: 'Joy',
    county_fips: 17131,
    county_fips_all: '17131',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"17131": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 41.24141,
    longitude: -90.88407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61260',
  },
  {
    city: 'Lyndon',
    county_fips: 17195,
    county_fips_all: '17195',
    county: 'Whiteside',
    county_names_all: 'Whiteside',
    county_weights: '{"17195": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 41.72928,
    longitude: -89.91166,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61261',
  },
  {
    city: 'Lynn Center',
    county_fips: 17073,
    county_fips_all: '17073|17131',
    county: 'Henry',
    county_names_all: 'Henry|Mercer',
    county_weights: '{"17073": 94.51, "17131": 5.49}',
    density: 9,
    imprecise: false,
    latitude: 41.27799,
    longitude: -90.35699,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61262',
  },
  {
    city: 'Matherville',
    county_fips: 17131,
    county_fips_all: '17131',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"17131": 100}',
    density: 185.6,
    imprecise: false,
    latitude: 41.26409,
    longitude: -90.59878,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61263',
  },
  {
    city: 'Milan',
    county_fips: 17161,
    county_fips_all: '17161|17131',
    county: 'Rock Island',
    county_names_all: 'Rock Island|Mercer',
    county_weights: '{"17161": 98.05, "17131": 1.95}',
    density: 56.5,
    imprecise: false,
    latitude: 41.39765,
    longitude: -90.59452,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61264',
  },
  {
    city: 'Moline',
    county_fips: 17161,
    county_fips_all: '17161',
    county: 'Rock Island',
    county_names_all: 'Rock Island',
    county_weights: '{"17161": 100}',
    density: 878.8,
    imprecise: false,
    latitude: 41.48195,
    longitude: -90.48895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61265',
  },
  {
    city: 'Morrison',
    county_fips: 17195,
    county_fips_all: '17195|17015',
    county: 'Whiteside',
    county_names_all: 'Whiteside|Carroll',
    county_weights: '{"17195": 98.97, "17015": 1.03}',
    density: 17.7,
    imprecise: false,
    latitude: 41.82971,
    longitude: -89.9656,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61270',
  },
  {
    city: 'New Boston',
    county_fips: 17131,
    county_fips_all: '17131|17161',
    county: 'Mercer',
    county_names_all: 'Mercer|Rock Island',
    county_weights: '{"17131": 97.06, "17161": 2.94}',
    density: 6.2,
    imprecise: false,
    latitude: 41.24817,
    longitude: -91.00865,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61272',
  },
  {
    city: 'Orion',
    county_fips: 17073,
    county_fips_all: '17073|17161|17131',
    county: 'Henry',
    county_names_all: 'Henry|Rock Island|Mercer',
    county_weights: '{"17073": 75.59, "17161": 24.06, "17131": 0.35}',
    density: 26.3,
    imprecise: false,
    latitude: 41.36426,
    longitude: -90.39907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61273',
  },
  {
    city: 'Osco',
    county_fips: 17073,
    county_fips_all: '17073',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"17073": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 41.37031,
    longitude: -90.27666,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61274',
  },
  {
    city: 'Port Byron',
    county_fips: 17161,
    county_fips_all: '17161',
    county: 'Rock Island',
    county_names_all: 'Rock Island',
    county_weights: '{"17161": 100}',
    density: 49.4,
    imprecise: false,
    latitude: 41.60016,
    longitude: -90.29781,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61275',
  },
  {
    city: 'Preemption',
    county_fips: 17131,
    county_fips_all: '17131',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"17131": 100}',
    density: 100.3,
    imprecise: false,
    latitude: 41.31667,
    longitude: -90.57638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 88,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61276',
  },
  {
    city: 'Prophetstown',
    county_fips: 17195,
    county_fips_all: '17195|17073',
    county: 'Whiteside',
    county_names_all: 'Whiteside|Henry',
    county_weights: '{"17195": 60.14, "17073": 39.86}',
    density: 8.8,
    imprecise: false,
    latitude: 41.60425,
    longitude: -89.93251,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61277',
  },
  {
    city: 'Rapids City',
    county_fips: 17161,
    county_fips_all: '17161',
    county: 'Rock Island',
    county_names_all: 'Rock Island',
    county_weights: '{"17161": 100}',
    density: 168.8,
    imprecise: false,
    latitude: 41.57938,
    longitude: -90.34138,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61278',
  },
  {
    city: 'Reynolds',
    county_fips: 17131,
    county_fips_all: '17131|17161',
    county: 'Mercer',
    county_names_all: 'Mercer|Rock Island',
    county_weights: '{"17131": 53.09, "17161": 46.91}',
    density: 10,
    imprecise: false,
    latitude: 41.32574,
    longitude: -90.72863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61279',
  },
  {
    city: 'Sherrard',
    county_fips: 17131,
    county_fips_all: '17131|17161',
    county: 'Mercer',
    county_names_all: 'Mercer|Rock Island',
    county_weights: '{"17131": 83.05, "17161": 16.95}',
    density: 24.2,
    imprecise: false,
    latitude: 41.3009,
    longitude: -90.51992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61281',
  },
  {
    city: 'Silvis',
    county_fips: 17161,
    county_fips_all: '17161',
    county: 'Rock Island',
    county_names_all: 'Rock Island',
    county_weights: '{"17161": 100}',
    density: 1031.6,
    imprecise: false,
    latitude: 41.49673,
    longitude: -90.41172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61282',
  },
  {
    city: 'Tampico',
    county_fips: 17195,
    county_fips_all: '17195|17011|17073',
    county: 'Whiteside',
    county_names_all: 'Whiteside|Bureau|Henry',
    county_weights: '{"17195": 50.68, "17011": 46.93, "17073": 2.39}',
    density: 5.9,
    imprecise: false,
    latitude: 41.59094,
    longitude: -89.78854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61283',
  },
  {
    city: 'Taylor Ridge',
    county_fips: 17161,
    county_fips_all: '17161',
    county: 'Rock Island',
    county_names_all: 'Rock Island',
    county_weights: '{"17161": 100}',
    density: 22.6,
    imprecise: false,
    latitude: 41.3927,
    longitude: -90.74874,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61284',
  },
  {
    city: 'Thomson',
    county_fips: 17015,
    county_fips_all: '17015',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"17015": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 41.98307,
    longitude: -90.0811,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61285',
  },
  {
    city: 'La Salle',
    county_fips: 17099,
    county_fips_all: '17099',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"17099": 100}',
    density: 95,
    imprecise: false,
    latitude: 41.39368,
    longitude: -89.07827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61301',
  },
  {
    city: 'Amboy',
    county_fips: 17103,
    county_fips_all: '17103',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"17103": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 41.69815,
    longitude: -89.34769,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61310',
  },
  {
    city: 'Ancona',
    county_fips: 17105,
    county_fips_all: '17105',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"17105": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 41.04018,
    longitude: -88.86219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61311',
  },
  {
    city: 'Arlington',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 41.43403,
    longitude: -89.22544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61312',
  },
  {
    city: 'Blackstone',
    county_fips: 17105,
    county_fips_all: '17105',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"17105": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 41.07237,
    longitude: -88.66993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61313',
  },
  {
    city: 'Buda',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 41.29745,
    longitude: -89.67474,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61314',
  },
  {
    city: 'Bureau',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 81.8,
    imprecise: false,
    latitude: 41.2865,
    longitude: -89.36477,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61315',
  },
  {
    city: 'Cedar Point',
    county_fips: 17099,
    county_fips_all: '17099',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"17099": 100}',
    density: 76.8,
    imprecise: false,
    latitude: 41.25718,
    longitude: -89.12538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61316',
  },
  {
    city: 'Cherry',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 197.4,
    imprecise: false,
    latitude: 41.43201,
    longitude: -89.20813,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61317',
  },
  {
    city: 'Compton',
    county_fips: 17103,
    county_fips_all: '17103',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"17103": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 41.71202,
    longitude: -89.08039,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61318',
  },
  {
    city: 'Cornell',
    county_fips: 17105,
    county_fips_all: '17105',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"17105": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 41.01291,
    longitude: -88.73942,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61319',
  },
  {
    city: 'Dalzell',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 328.9,
    imprecise: false,
    latitude: 41.3553,
    longitude: -89.17047,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61320',
  },
  {
    city: 'Dana',
    county_fips: 17099,
    county_fips_all: '17099|17123',
    county: 'LaSalle',
    county_names_all: 'LaSalle|Marshall',
    county_weights: '{"17099": 96.79, "17123": 3.21}',
    density: 3,
    imprecise: false,
    latitude: 40.96754,
    longitude: -88.97621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61321',
  },
  {
    city: 'Depue',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 165,
    imprecise: false,
    latitude: 41.3185,
    longitude: -89.30566,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61322',
  },
  {
    city: 'Dover',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 379.8,
    imprecise: false,
    latitude: 41.43544,
    longitude: -89.39605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61323',
  },
  {
    city: 'Eldena',
    county_fips: 17103,
    county_fips_all: '17103',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"17103": 100}',
    density: 182.2,
    imprecise: false,
    latitude: 41.76994,
    longitude: -89.4136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61324',
  },
  {
    city: 'Grand Ridge',
    county_fips: 17099,
    county_fips_all: '17099',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"17099": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 41.23673,
    longitude: -88.80973,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61325',
  },
  {
    city: 'Granville',
    county_fips: 17155,
    county_fips_all: '17155',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"17155": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 41.25276,
    longitude: -89.22083,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61326',
  },
  {
    city: 'Hennepin',
    county_fips: 17155,
    county_fips_all: '17155',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"17155": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 41.22827,
    longitude: -89.30876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61327',
  },
  {
    city: 'Kasbeer',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 41.50924,
    longitude: -89.459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61328',
  },
  {
    city: 'Ladd',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 245.6,
    imprecise: false,
    latitude: 41.37709,
    longitude: -89.20791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61329',
  },
  {
    city: 'La Moille',
    county_fips: 17011,
    county_fips_all: '17011|17103',
    county: 'Bureau',
    county_names_all: 'Bureau|Lee',
    county_weights: '{"17011": 91.84, "17103": 8.16}',
    density: 6.2,
    imprecise: false,
    latitude: 41.53602,
    longitude: -89.27756,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61330',
  },
  {
    city: 'Lee Center',
    county_fips: 17103,
    county_fips_all: '17103',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"17103": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.74771,
    longitude: -89.27754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61331',
  },
  {
    city: 'Leonore',
    county_fips: 17099,
    county_fips_all: '17099',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"17099": 100}',
    density: 54.1,
    imprecise: false,
    latitude: 41.18884,
    longitude: -88.98456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61332',
  },
  {
    city: 'Long Point',
    county_fips: 17105,
    county_fips_all: '17105',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"17105": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 40.98845,
    longitude: -88.88931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61333',
  },
  {
    city: 'Lostant',
    county_fips: 17099,
    county_fips_all: '17099|17155',
    county: 'LaSalle',
    county_names_all: 'LaSalle|Putnam',
    county_weights: '{"17099": 99.29, "17155": 0.71}',
    density: 7.3,
    imprecise: false,
    latitude: 41.14731,
    longitude: -89.09935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61334',
  },
  {
    city: 'McNabb',
    county_fips: 17155,
    county_fips_all: '17155',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"17155": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 41.16141,
    longitude: -89.23228,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61335',
  },
  {
    city: 'Magnolia',
    county_fips: 17155,
    county_fips_all: '17155|17123',
    county: 'Putnam',
    county_names_all: 'Putnam|Marshall',
    county_weights: '{"17155": 56.9, "17123": 43.1}',
    density: 7.2,
    imprecise: false,
    latitude: 41.1073,
    longitude: -89.21727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61336',
  },
  {
    city: 'Malden',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 30.1,
    imprecise: false,
    latitude: 41.43827,
    longitude: -89.3171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61337',
  },
  {
    city: 'Manlius',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 41.47014,
    longitude: -89.66517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61338',
  },
  {
    city: 'Mark',
    county_fips: 17155,
    county_fips_all: '17155',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"17155": 100}',
    density: 241.4,
    imprecise: false,
    latitude: 41.26396,
    longitude: -89.25123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61340',
  },
  {
    city: 'Marseilles',
    county_fips: 17099,
    county_fips_all: '17099',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"17099": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 41.34015,
    longitude: -88.69246,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61341',
  },
  {
    city: 'Mendota',
    county_fips: 17099,
    county_fips_all: '17099|17011|17103',
    county: 'LaSalle',
    county_names_all: 'LaSalle|Bureau|Lee',
    county_weights: '{"17099": 86.87, "17011": 8.11, "17103": 5.02}',
    density: 30.5,
    imprecise: false,
    latitude: 41.54089,
    longitude: -89.0938,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61342',
  },
  {
    city: 'Mineral',
    county_fips: 17011,
    county_fips_all: '17011|17073',
    county: 'Bureau',
    county_names_all: 'Bureau|Henry',
    county_weights: '{"17011": 94.89, "17073": 5.11}',
    density: 4.7,
    imprecise: false,
    latitude: 41.41245,
    longitude: -89.8344,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61344',
  },
  {
    city: 'Neponset',
    county_fips: 17011,
    county_fips_all: '17011|17175',
    county: 'Bureau',
    county_names_all: 'Bureau|Stark',
    county_weights: '{"17011": 91.97, "17175": 8.03}',
    density: 6.3,
    imprecise: false,
    latitude: 41.27981,
    longitude: -89.78878,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61345',
  },
  {
    city: 'New Bedford',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 30.6,
    imprecise: false,
    latitude: 41.50659,
    longitude: -89.7199,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61346',
  },
  {
    city: 'Oglesby',
    county_fips: 17099,
    county_fips_all: '17099',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"17099": 100}',
    density: 43,
    imprecise: false,
    latitude: 41.2812,
    longitude: -89.03685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61348',
  },
  {
    city: 'Ohio',
    county_fips: 17011,
    county_fips_all: '17011|17103',
    county: 'Bureau',
    county_names_all: 'Bureau|Lee',
    county_weights: '{"17011": 73.23, "17103": 26.77}',
    density: 7.2,
    imprecise: false,
    latitude: 41.55295,
    longitude: -89.44192,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61349',
  },
  {
    city: 'Ottawa',
    county_fips: 17099,
    county_fips_all: '17099',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"17099": 100}',
    density: 60,
    imprecise: false,
    latitude: 41.37152,
    longitude: -88.86157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61350',
  },
  {
    city: 'Paw Paw',
    county_fips: 17103,
    county_fips_all: '17103',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"17103": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 41.6967,
    longitude: -88.99623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61353',
  },
  {
    city: 'Peru',
    county_fips: 17099,
    county_fips_all: '17099|17011',
    county: 'LaSalle',
    county_names_all: 'LaSalle|Bureau',
    county_weights: '{"17099": 91.98, "17011": 8.02}',
    density: 93.3,
    imprecise: false,
    latitude: 41.33158,
    longitude: -89.14281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61354',
  },
  {
    city: 'Princeton',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 22,
    imprecise: false,
    latitude: 41.38914,
    longitude: -89.43406,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61356',
  },
  {
    city: 'Rutland',
    county_fips: 17099,
    county_fips_all: '17099|17123',
    county: 'LaSalle',
    county_names_all: 'LaSalle|Marshall',
    county_weights: '{"17099": 53.61, "17123": 46.39}',
    density: 6.7,
    imprecise: false,
    latitude: 40.98166,
    longitude: -89.04299,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61358',
  },
  {
    city: 'Seatonville',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 192.9,
    imprecise: false,
    latitude: 41.36341,
    longitude: -89.26962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61359',
  },
  {
    city: 'Seneca',
    county_fips: 17099,
    county_fips_all: '17099|17063',
    county: 'LaSalle',
    county_names_all: 'LaSalle|Grundy',
    county_weights: '{"17099": 78.79, "17063": 21.21}',
    density: 29.4,
    imprecise: false,
    latitude: 41.33439,
    longitude: -88.60522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61360',
  },
  {
    city: 'Sheffield',
    county_fips: 17011,
    county_fips_all: '17011|17073',
    county: 'Bureau',
    county_names_all: 'Bureau|Henry',
    county_weights: '{"17011": 90.37, "17073": 9.63}',
    density: 6.2,
    imprecise: false,
    latitude: 41.40913,
    longitude: -89.76778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61361',
  },
  {
    city: 'Spring Valley',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 87.6,
    imprecise: false,
    latitude: 41.35138,
    longitude: -89.22819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61362',
  },
  {
    city: 'Standard',
    county_fips: 17155,
    county_fips_all: '17155',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"17155": 100}',
    density: 187.6,
    imprecise: false,
    latitude: 41.25425,
    longitude: -89.18248,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61363',
  },
  {
    city: 'Streator',
    county_fips: 17099,
    county_fips_all: '17099|17105',
    county: 'LaSalle',
    county_names_all: 'LaSalle|Livingston',
    county_weights: '{"17099": 78.21, "17105": 21.79}',
    density: 44.1,
    imprecise: false,
    latitude: 41.12822,
    longitude: -88.85097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61364',
  },
  {
    city: 'Sublette',
    county_fips: 17103,
    county_fips_all: '17103',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"17103": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 41.62611,
    longitude: -89.26221,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61367',
  },
  {
    city: 'Tiskilwa',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 41.26113,
    longitude: -89.51981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61368',
  },
  {
    city: 'Toluca',
    county_fips: 17123,
    county_fips_all: '17123',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"17123": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 40.9827,
    longitude: -89.15397,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61369',
  },
  {
    city: 'Tonica',
    county_fips: 17099,
    county_fips_all: '17099',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"17099": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 41.20854,
    longitude: -89.03476,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61370',
  },
  {
    city: 'Triumph',
    county_fips: 17099,
    county_fips_all: '17099',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"17099": 100}',
    density: 215.3,
    imprecise: false,
    latitude: 41.49936,
    longitude: -89.01986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61371',
  },
  {
    city: 'Troy Grove',
    county_fips: 17099,
    county_fips_all: '17099',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"17099": 100}',
    density: 183.3,
    imprecise: false,
    latitude: 41.46582,
    longitude: -89.08239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61372',
  },
  {
    city: 'Utica',
    county_fips: 17099,
    county_fips_all: '17099',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"17099": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 41.4004,
    longitude: -88.99456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61373',
  },
  {
    city: 'Van Orin',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 41.5473,
    longitude: -89.35759,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61374',
  },
  {
    city: 'Varna',
    county_fips: 17123,
    county_fips_all: '17123',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"17123": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 41.03254,
    longitude: -89.24688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61375',
  },
  {
    city: 'Walnut',
    county_fips: 17011,
    county_fips_all: '17011|17103',
    county: 'Bureau',
    county_names_all: 'Bureau|Lee',
    county_weights: '{"17011": 85.55, "17103": 14.45}',
    density: 7.5,
    imprecise: false,
    latitude: 41.54065,
    longitude: -89.60726,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61376',
  },
  {
    city: 'Wenona',
    county_fips: 17099,
    county_fips_all: '17099|17123',
    county: 'LaSalle',
    county_names_all: 'LaSalle|Marshall',
    county_weights: '{"17099": 50.17, "17123": 49.83}',
    density: 10.9,
    imprecise: false,
    latitude: 41.05847,
    longitude: -89.04444,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61377',
  },
  {
    city: 'West Brooklyn',
    county_fips: 17103,
    county_fips_all: '17103',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"17103": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 41.72614,
    longitude: -89.158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61378',
  },
  {
    city: 'Wyanet',
    county_fips: 17011,
    county_fips_all: '17011',
    county: 'Bureau',
    county_names_all: 'Bureau',
    county_weights: '{"17011": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 41.38144,
    longitude: -89.61077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61379',
  },
  {
    city: 'Galesburg',
    county_fips: 17095,
    county_fips_all: '17095|17187',
    county: 'Knox',
    county_names_all: 'Knox|Warren',
    county_weights: '{"17095": 79.73, "17187": 20.27}',
    density: 96.1,
    imprecise: false,
    latitude: 40.94451,
    longitude: -90.38888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61401',
  },
  {
    city: 'Galesburg',
    county_fips: 17095,
    county_fips_all: '17095',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"17095": 100}',
    density: 7509.6,
    imprecise: false,
    latitude: 40.93993,
    longitude: -90.40627,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61402',
  },
  {
    city: 'Abingdon',
    county_fips: 17095,
    county_fips_all: '17095|17187',
    county: 'Knox',
    county_names_all: 'Knox|Warren',
    county_weights: '{"17095": 72.37, "17187": 27.63}',
    density: 32.9,
    imprecise: false,
    latitude: 40.79779,
    longitude: -90.40703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61410',
  },
  {
    city: 'Adair',
    county_fips: 17109,
    county_fips_all: '17109',
    county: 'McDonough',
    county_names_all: 'McDonough',
    county_weights: '{"17109": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 40.40105,
    longitude: -90.50544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61411',
  },
  {
    city: 'Alexis',
    county_fips: 17131,
    county_fips_all: '17131|17187',
    county: 'Mercer',
    county_names_all: 'Mercer|Warren',
    county_weights: '{"17131": 54.85, "17187": 45.15}',
    density: 6.7,
    imprecise: false,
    latitude: 41.07092,
    longitude: -90.58853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61412',
  },
  {
    city: 'Alpha',
    county_fips: 17073,
    county_fips_all: '17073',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"17073": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 41.19135,
    longitude: -90.37227,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61413',
  },
  {
    city: 'Altona',
    county_fips: 17095,
    county_fips_all: '17095|17073',
    county: 'Knox',
    county_names_all: 'Knox|Henry',
    county_weights: '{"17095": 78.52, "17073": 21.48}',
    density: 4.9,
    imprecise: false,
    latitude: 41.12597,
    longitude: -90.15495,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61414',
  },
  {
    city: 'Avon',
    county_fips: 17057,
    county_fips_all: '17057|17187',
    county: 'Fulton',
    county_names_all: 'Fulton|Warren',
    county_weights: '{"17057": 62.61, "17187": 37.39}',
    density: 5.2,
    imprecise: false,
    latitude: 40.65425,
    longitude: -90.42801,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61415',
  },
  {
    city: 'Bardolph',
    county_fips: 17109,
    county_fips_all: '17109',
    county: 'McDonough',
    county_names_all: 'McDonough',
    county_weights: '{"17109": 100}',
    density: 127.6,
    imprecise: false,
    latitude: 40.49592,
    longitude: -90.56308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61416',
  },
  {
    city: 'Berwick',
    county_fips: 17187,
    county_fips_all: '17187',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"17187": 100}',
    density: 3,
    imprecise: false,
    latitude: 40.77222,
    longitude: -90.54413,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61417',
  },
  {
    city: 'Biggsville',
    county_fips: 17071,
    county_fips_all: '17071',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"17071": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 40.84714,
    longitude: -90.86492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61418',
  },
  {
    city: 'Bishop Hill',
    county_fips: 17073,
    county_fips_all: '17073',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"17073": 100}',
    density: 97.3,
    imprecise: false,
    latitude: 41.19982,
    longitude: -90.11751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61419',
  },
  {
    city: 'Blandinsville',
    county_fips: 17109,
    county_fips_all: '17109|17067',
    county: 'McDonough',
    county_names_all: 'McDonough|Hancock',
    county_weights: '{"17109": 81.14, "17067": 18.86}',
    density: 5.5,
    imprecise: false,
    latitude: 40.5491,
    longitude: -90.86679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61420',
  },
  {
    city: 'Bradford',
    county_fips: 17175,
    county_fips_all: '17175|17011|17123',
    county: 'Stark',
    county_names_all: 'Stark|Bureau|Marshall',
    county_weights: '{"17175": 54.56, "17011": 36.36, "17123": 9.08}',
    density: 4.8,
    imprecise: false,
    latitude: 41.1792,
    longitude: -89.65083,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61421',
  },
  {
    city: 'Bushnell',
    county_fips: 17109,
    county_fips_all: '17109',
    county: 'McDonough',
    county_names_all: 'McDonough',
    county_weights: '{"17109": 100}',
    density: 26.8,
    imprecise: false,
    latitude: 40.55084,
    longitude: -90.53113,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61422',
  },
  {
    city: 'Cameron',
    county_fips: 17187,
    county_fips_all: '17187',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"17187": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 40.8855,
    longitude: -90.50232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61423',
  },
  {
    city: 'Camp Grove',
    county_fips: 17123,
    county_fips_all: '17123',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"17123": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 41.07671,
    longitude: -89.63513,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61424',
  },
  {
    city: 'Carman',
    county_fips: 17071,
    county_fips_all: '17071',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"17071": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 40.76297,
    longitude: -91.04575,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61425',
  },
  {
    city: 'Castleton',
    county_fips: 17175,
    county_fips_all: '17175',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"17175": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 41.11964,
    longitude: -89.70601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61426',
  },
  {
    city: 'Cuba',
    county_fips: 17057,
    county_fips_all: '17057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"17057": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 40.49823,
    longitude: -90.19319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61427',
  },
  {
    city: 'Dahinda',
    county_fips: 17095,
    county_fips_all: '17095',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"17095": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 40.93262,
    longitude: -90.10977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61428',
  },
  {
    city: 'East Galesburg',
    county_fips: 17095,
    county_fips_all: '17095',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"17095": 100}',
    density: 186,
    imprecise: false,
    latitude: 40.94393,
    longitude: -90.31135,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61430',
  },
  {
    city: 'Ellisville',
    county_fips: 17057,
    county_fips_all: '17057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"17057": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 40.60315,
    longitude: -90.2776,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61431',
  },
  {
    city: 'Fairview',
    county_fips: 17057,
    county_fips_all: '17057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"17057": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 40.65055,
    longitude: -90.16086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61432',
  },
  {
    city: 'Fiatt',
    county_fips: 17057,
    county_fips_all: '17057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"17057": 100}',
    density: 8,
    imprecise: false,
    latitude: 40.55749,
    longitude: -90.16866,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61433',
  },
  {
    city: 'Galva',
    county_fips: 17073,
    county_fips_all: '17073|17095|17175',
    county: 'Henry',
    county_names_all: 'Henry|Knox|Stark',
    county_weights: '{"17073": 74.36, "17095": 24.84, "17175": 0.8}',
    density: 14.6,
    imprecise: false,
    latitude: 41.17387,
    longitude: -90.03598,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61434',
  },
  {
    city: 'Gerlaw',
    county_fips: 17187,
    county_fips_all: '17187',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"17187": 100}',
    density: 6,
    imprecise: false,
    latitude: 40.99559,
    longitude: -90.5686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61435',
  },
  {
    city: 'Gilson',
    county_fips: 17095,
    county_fips_all: '17095',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"17095": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 40.86067,
    longitude: -90.21739,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61436',
  },
  {
    city: 'Gladstone',
    county_fips: 17071,
    county_fips_all: '17071',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"17071": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 40.84911,
    longitude: -90.98905,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61437',
  },
  {
    city: 'Good Hope',
    county_fips: 17109,
    county_fips_all: '17109',
    county: 'McDonough',
    county_names_all: 'McDonough',
    county_weights: '{"17109": 100}',
    density: 7,
    imprecise: false,
    latitude: 40.58538,
    longitude: -90.64942,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61438',
  },
  {
    city: 'Henderson',
    county_fips: 17095,
    county_fips_all: '17095',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"17095": 100}',
    density: 92.4,
    imprecise: false,
    latitude: 41.02923,
    longitude: -90.35019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61439',
  },
  {
    city: 'Industry',
    county_fips: 17109,
    county_fips_all: '17109|17169',
    county: 'McDonough',
    county_names_all: 'McDonough|Schuyler',
    county_weights: '{"17109": 82.92, "17169": 17.08}',
    density: 6.7,
    imprecise: false,
    latitude: 40.3079,
    longitude: -90.59786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61440',
  },
  {
    city: 'Ipava',
    county_fips: 17057,
    county_fips_all: '17057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"17057": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 40.33957,
    longitude: -90.29336,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61441',
  },
  {
    city: 'Keithsburg',
    county_fips: 17131,
    county_fips_all: '17131|17071',
    county: 'Mercer',
    county_names_all: 'Mercer|Henderson',
    county_weights: '{"17131": 78.7, "17071": 21.3}',
    density: 6.8,
    imprecise: false,
    latitude: 41.10237,
    longitude: -90.92303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61442',
  },
  {
    city: 'Kewanee',
    county_fips: 17073,
    county_fips_all: '17073|17175|17011',
    county: 'Henry',
    county_names_all: 'Henry|Stark|Bureau',
    county_weights: '{"17073": 93.96, "17175": 3.5, "17011": 2.54}',
    density: 51.7,
    imprecise: false,
    latitude: 41.25972,
    longitude: -89.94242,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61443',
  },
  {
    city: 'Kirkwood',
    county_fips: 17187,
    county_fips_all: '17187|17071',
    county: 'Warren',
    county_names_all: 'Warren|Henderson',
    county_weights: '{"17187": 68.88, "17071": 31.12}',
    density: 9.3,
    imprecise: false,
    latitude: 40.87105,
    longitude: -90.76674,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61447',
  },
  {
    city: 'Knoxville',
    county_fips: 17095,
    county_fips_all: '17095',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"17095": 100}',
    density: 37.3,
    imprecise: false,
    latitude: 40.93385,
    longitude: -90.24374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61448',
  },
  {
    city: 'La Fayette',
    county_fips: 17175,
    county_fips_all: '17175|17095',
    county: 'Stark',
    county_names_all: 'Stark|Knox',
    county_weights: '{"17175": 69.02, "17095": 30.98}',
    density: 3.6,
    imprecise: false,
    latitude: 41.08926,
    longitude: -89.97051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61449',
  },
  {
    city: 'La Harpe',
    county_fips: 17067,
    county_fips_all: '17067|17071|17109',
    county: 'Hancock',
    county_names_all: 'Hancock|Henderson|McDonough',
    county_weights: '{"17067": 89.11, "17071": 7.19, "17109": 3.7}',
    density: 9.2,
    imprecise: false,
    latitude: 40.57629,
    longitude: -90.98088,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61450',
  },
  {
    city: 'Laura',
    county_fips: 17143,
    county_fips_all: '17143|17175',
    county: 'Peoria',
    county_names_all: 'Peoria|Stark',
    county_weights: '{"17143": 99.9, "17175": 0.1}',
    density: 4.9,
    imprecise: false,
    latitude: 40.94117,
    longitude: -89.93555,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61451',
  },
  {
    city: 'Littleton',
    county_fips: 17169,
    county_fips_all: '17169|17109',
    county: 'Schuyler',
    county_names_all: 'Schuyler|McDonough',
    county_weights: '{"17169": 95.73, "17109": 4.27}',
    density: 2,
    imprecise: false,
    latitude: 40.23836,
    longitude: -90.66022,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61452',
  },
  {
    city: 'Little York',
    county_fips: 17187,
    county_fips_all: '17187|17071',
    county: 'Warren',
    county_names_all: 'Warren|Henderson',
    county_weights: '{"17187": 58.31, "17071": 41.69}',
    density: 4.6,
    imprecise: false,
    latitude: 41.01345,
    longitude: -90.76322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61453',
  },
  {
    city: 'Lomax',
    county_fips: 17071,
    county_fips_all: '17071',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"17071": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 40.68152,
    longitude: -91.04535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61454',
  },
  {
    city: 'Macomb',
    county_fips: 17109,
    county_fips_all: '17109',
    county: 'McDonough',
    county_names_all: 'McDonough',
    county_weights: '{"17109": 100}',
    density: 41.1,
    imprecise: false,
    latitude: 40.44047,
    longitude: -90.65115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61455',
  },
  {
    city: 'Maquon',
    county_fips: 17095,
    county_fips_all: '17095',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"17095": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 40.78027,
    longitude: -90.18107,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61458',
  },
  {
    city: 'Marietta',
    county_fips: 17057,
    county_fips_all: '17057|17109',
    county: 'Fulton',
    county_names_all: 'Fulton|McDonough',
    county_weights: '{"17057": 84.68, "17109": 15.32}',
    density: 4.5,
    imprecise: false,
    latitude: 40.50497,
    longitude: -90.41453,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61459',
  },
  {
    city: 'Media',
    county_fips: 17071,
    county_fips_all: '17071',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"17071": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 40.72159,
    longitude: -90.82774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61460',
  },
  {
    city: 'Monmouth',
    county_fips: 17187,
    county_fips_all: '17187|17071',
    county: 'Warren',
    county_names_all: 'Warren|Henderson',
    county_weights: '{"17187": 96.09, "17071": 3.91}',
    density: 28.4,
    imprecise: false,
    latitude: 40.91014,
    longitude: -90.65176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61462',
  },
  {
    city: 'New Windsor',
    county_fips: 17131,
    county_fips_all: '17131|17073',
    county: 'Mercer',
    county_names_all: 'Mercer|Henry',
    county_weights: '{"17131": 84.29, "17073": 15.71}',
    density: 11.4,
    imprecise: false,
    latitude: 41.20618,
    longitude: -90.46744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61465',
  },
  {
    city: 'North Henderson',
    county_fips: 17131,
    county_fips_all: '17131',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"17131": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 41.11103,
    longitude: -90.48222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61466',
  },
  {
    city: 'Oneida',
    county_fips: 17095,
    county_fips_all: '17095',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"17095": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 41.07115,
    longitude: -90.24338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61467',
  },
  {
    city: 'Ophiem',
    county_fips: 17073,
    county_fips_all: '17073',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"17073": 100}',
    density: 29.6,
    imprecise: false,
    latitude: 41.2565,
    longitude: -90.38751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61468',
  },
  {
    city: 'Oquawka',
    county_fips: 17071,
    county_fips_all: '17071',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"17071": 100}',
    density: 17,
    imprecise: false,
    latitude: 40.96262,
    longitude: -90.91066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61469',
  },
  {
    city: 'Prairie City',
    county_fips: 17109,
    county_fips_all: '17109',
    county: 'McDonough',
    county_names_all: 'McDonough',
    county_weights: '{"17109": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 40.60613,
    longitude: -90.50623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61470',
  },
  {
    city: 'Raritan',
    county_fips: 17071,
    county_fips_all: '17071',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"17071": 100}',
    density: 544.3,
    imprecise: false,
    latitude: 40.69583,
    longitude: -90.82507,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61471',
  },
  {
    city: 'Rio',
    county_fips: 17095,
    county_fips_all: '17095|17131',
    county: 'Knox',
    county_names_all: 'Knox|Mercer',
    county_weights: '{"17095": 98.72, "17131": 1.28}',
    density: 4.5,
    imprecise: false,
    latitude: 41.10327,
    longitude: -90.38345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61472',
  },
  {
    city: 'Roseville',
    county_fips: 17187,
    county_fips_all: '17187',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"17187": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 40.70914,
    longitude: -90.64975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61473',
  },
  {
    city: 'Saint Augustine',
    county_fips: 17095,
    county_fips_all: '17095|17187|17057',
    county: 'Knox',
    county_names_all: 'Knox|Warren|Fulton',
    county_weights: '{"17095": 76.16, "17187": 17.35, "17057": 6.49}',
    density: 3.3,
    imprecise: false,
    latitude: 40.73419,
    longitude: -90.39724,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61474',
  },
  {
    city: 'Sciota',
    county_fips: 17109,
    county_fips_all: '17109|17187|17071',
    county: 'McDonough',
    county_names_all: 'McDonough|Warren|Henderson',
    county_weights: '{"17109": 86.03, "17187": 12.03, "17071": 1.94}',
    density: 2.1,
    imprecise: false,
    latitude: 40.5969,
    longitude: -90.7527,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61475',
  },
  {
    city: 'Seaton',
    county_fips: 17131,
    county_fips_all: '17131|17071',
    county: 'Mercer',
    county_names_all: 'Mercer|Henderson',
    county_weights: '{"17131": 71.89, "17071": 28.11}',
    density: 4.8,
    imprecise: false,
    latitude: 41.09191,
    longitude: -90.83259,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61476',
  },
  {
    city: 'Smithfield',
    county_fips: 17057,
    county_fips_all: '17057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"17057": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 40.4945,
    longitude: -90.31402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61477',
  },
  {
    city: 'Smithshire',
    county_fips: 17187,
    county_fips_all: '17187|17071',
    county: 'Warren',
    county_names_all: 'Warren|Henderson',
    county_weights: '{"17187": 85.95, "17071": 14.05}',
    density: 4.7,
    imprecise: false,
    latitude: 40.75633,
    longitude: -90.76035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61478',
  },
  {
    city: 'Speer',
    county_fips: 17123,
    county_fips_all: '17123|17175',
    county: 'Marshall',
    county_names_all: 'Marshall|Stark',
    county_weights: '{"17123": 51.06, "17175": 48.94}',
    density: 3.2,
    imprecise: false,
    latitude: 41.00192,
    longitude: -89.63939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 95,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61479',
  },
  {
    city: 'Stronghurst',
    county_fips: 17071,
    county_fips_all: '17071',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"17071": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 40.72323,
    longitude: -90.91827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61480',
  },
  {
    city: 'Table Grove',
    county_fips: 17057,
    county_fips_all: '17057|17109',
    county: 'Fulton',
    county_names_all: 'Fulton|McDonough',
    county_weights: '{"17057": 88.25, "17109": 11.75}',
    density: 3.7,
    imprecise: false,
    latitude: 40.39362,
    longitude: -90.40766,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61482',
  },
  {
    city: 'Toulon',
    county_fips: 17175,
    county_fips_all: '17175',
    county: 'Stark',
    county_names_all: 'Stark',
    county_weights: '{"17175": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 41.08157,
    longitude: -89.87186,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61483',
  },
  {
    city: 'Vermont',
    county_fips: 17057,
    county_fips_all: '17057|17109|17169',
    county: 'Fulton',
    county_names_all: 'Fulton|McDonough|Schuyler',
    county_weights: '{"17057": 54.17, "17109": 41.28, "17169": 4.55}',
    density: 6,
    imprecise: false,
    latitude: 40.29696,
    longitude: -90.44153,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61484',
  },
  {
    city: 'Victoria',
    county_fips: 17095,
    county_fips_all: '17095',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"17095": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 41.01677,
    longitude: -90.09764,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61485',
  },
  {
    city: 'Viola',
    county_fips: 17131,
    county_fips_all: '17131',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"17131": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 41.19609,
    longitude: -90.57614,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61486',
  },
  {
    city: 'Wataga',
    county_fips: 17095,
    county_fips_all: '17095',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"17095": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 41.03004,
    longitude: -90.32071,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61488',
  },
  {
    city: 'Williamsfield',
    county_fips: 17095,
    county_fips_all: '17095|17143',
    county: 'Knox',
    county_names_all: 'Knox|Peoria',
    county_weights: '{"17095": 96.58, "17143": 3.42}',
    density: 6.7,
    imprecise: false,
    latitude: 40.93462,
    longitude: -90.02664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61489',
  },
  {
    city: 'Woodhull',
    county_fips: 17073,
    county_fips_all: '17073|17095',
    county: 'Henry',
    county_names_all: 'Henry|Knox',
    county_weights: '{"17073": 86.9, "17095": 13.1}',
    density: 10.9,
    imprecise: false,
    latitude: 41.18263,
    longitude: -90.26518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61490',
  },
  {
    city: 'Wyoming',
    county_fips: 17175,
    county_fips_all: '17175|17123',
    county: 'Stark',
    county_names_all: 'Stark|Marshall',
    county_weights: '{"17175": 89.23, "17123": 10.77}',
    density: 9,
    imprecise: false,
    latitude: 41.05982,
    longitude: -89.72525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61491',
  },
  {
    city: 'Astoria',
    county_fips: 17057,
    county_fips_all: '17057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"17057": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 40.22797,
    longitude: -90.31233,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61501',
  },
  {
    city: 'Benson',
    county_fips: 17203,
    county_fips_all: '17203',
    county: 'Woodford',
    county_names_all: 'Woodford',
    county_weights: '{"17203": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 40.85555,
    longitude: -89.13197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61516',
  },
  {
    city: 'Brimfield',
    county_fips: 17143,
    county_fips_all: '17143',
    county: 'Peoria',
    county_names_all: 'Peoria',
    county_weights: '{"17143": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 40.823,
    longitude: -89.85155,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61517',
  },
  {
    city: 'Bryant',
    county_fips: 17057,
    county_fips_all: '17057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"17057": 100}',
    density: 28.9,
    imprecise: false,
    latitude: 40.46463,
    longitude: -90.09309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61519',
  },
  {
    city: 'Canton',
    county_fips: 17057,
    county_fips_all: '17057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"17057": 100}',
    density: 41.4,
    imprecise: false,
    latitude: 40.54197,
    longitude: -90.02156,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61520',
  },
  {
    city: 'Chillicothe',
    county_fips: 17143,
    county_fips_all: '17143|17123|17203',
    county: 'Peoria',
    county_names_all: 'Peoria|Marshall|Woodford',
    county_weights: '{"17143": 93.47, "17123": 6.12, "17203": 0.41}',
    density: 74,
    imprecise: false,
    latitude: 40.91751,
    longitude: -89.53562,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61523',
  },
  {
    city: 'Dunfermline',
    county_fips: 17057,
    county_fips_all: '17057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"17057": 100}',
    density: 465.5,
    imprecise: false,
    latitude: 40.49125,
    longitude: -90.03468,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61524',
  },
  {
    city: 'Dunlap',
    county_fips: 17143,
    county_fips_all: '17143',
    county: 'Peoria',
    county_names_all: 'Peoria',
    county_weights: '{"17143": 100}',
    density: 145.8,
    imprecise: false,
    latitude: 40.84776,
    longitude: -89.67047,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61525',
  },
  {
    city: 'Edelstein',
    county_fips: 17143,
    county_fips_all: '17143|17123',
    county: 'Peoria',
    county_names_all: 'Peoria|Marshall',
    county_weights: '{"17143": 91.8, "17123": 8.2}',
    density: 14,
    imprecise: false,
    latitude: 40.92899,
    longitude: -89.62599,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61526',
  },
  {
    city: 'Edwards',
    county_fips: 17143,
    county_fips_all: '17143',
    county: 'Peoria',
    county_names_all: 'Peoria',
    county_weights: '{"17143": 100}',
    density: 66.9,
    imprecise: false,
    latitude: 40.7757,
    longitude: -89.7227,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61528',
  },
  {
    city: 'Elmwood',
    county_fips: 17143,
    county_fips_all: '17143|17095',
    county: 'Peoria',
    county_names_all: 'Peoria|Knox',
    county_weights: '{"17143": 97.55, "17095": 2.45}',
    density: 16.5,
    imprecise: false,
    latitude: 40.7809,
    longitude: -89.93673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61529',
  },
  {
    city: 'Eureka',
    county_fips: 17203,
    county_fips_all: '17203|17179',
    county: 'Woodford',
    county_names_all: 'Woodford|Tazewell',
    county_weights: '{"17203": 95.9, "17179": 4.1}',
    density: 39.2,
    imprecise: false,
    latitude: 40.71146,
    longitude: -89.26287,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61530',
  },
  {
    city: 'Farmington',
    county_fips: 17057,
    county_fips_all: '17057|17095|17143',
    county: 'Fulton',
    county_names_all: 'Fulton|Knox|Peoria',
    county_weights: '{"17057": 62.59, "17095": 23.75, "17143": 13.66}',
    density: 20.6,
    imprecise: false,
    latitude: 40.68291,
    longitude: -90.03482,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61531',
  },
  {
    city: 'Forest City',
    county_fips: 17125,
    county_fips_all: '17125',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"17125": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 40.34851,
    longitude: -89.80692,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61532',
  },
  {
    city: 'Glasford',
    county_fips: 17143,
    county_fips_all: '17143|17057|17179',
    county: 'Peoria',
    county_names_all: 'Peoria|Fulton|Tazewell',
    county_weights: '{"17143": 83.1, "17057": 16.79, "17179": 0.11}',
    density: 23.2,
    imprecise: false,
    latitude: 40.58736,
    longitude: -89.84029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61533',
  },
  {
    city: 'Green Valley',
    county_fips: 17179,
    county_fips_all: '17179',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"17179": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 40.41499,
    longitude: -89.66464,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61534',
  },
  {
    city: 'Groveland',
    county_fips: 17179,
    county_fips_all: '17179',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"17179": 100}',
    density: 90.8,
    imprecise: false,
    latitude: 40.58578,
    longitude: -89.52316,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61535',
  },
  {
    city: 'Hanna City',
    county_fips: 17143,
    county_fips_all: '17143',
    county: 'Peoria',
    county_names_all: 'Peoria',
    county_weights: '{"17143": 100}',
    density: 33.1,
    imprecise: false,
    latitude: 40.69051,
    longitude: -89.78688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61536',
  },
  {
    city: 'Henry',
    county_fips: 17123,
    county_fips_all: '17123|17011',
    county: 'Marshall',
    county_names_all: 'Marshall|Bureau',
    county_weights: '{"17123": 94.82, "17011": 5.18}',
    density: 18.5,
    imprecise: false,
    latitude: 41.11607,
    longitude: -89.47035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61537',
  },
  {
    city: 'Kingston Mines',
    county_fips: 17143,
    county_fips_all: '17143|17179',
    county: 'Peoria',
    county_names_all: 'Peoria|Tazewell',
    county_weights: '{"17143": 99.2, "17179": 0.8}',
    density: 51,
    imprecise: false,
    latitude: 40.55375,
    longitude: -89.77561,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61539',
  },
  {
    city: 'Lacon',
    county_fips: 17123,
    county_fips_all: '17123',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"17123": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 41.01856,
    longitude: -89.36867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61540',
  },
  {
    city: 'La Rose',
    county_fips: 17123,
    county_fips_all: '17123',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"17123": 100}',
    density: 228.2,
    imprecise: false,
    latitude: 40.98039,
    longitude: -89.23497,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61541',
  },
  {
    city: 'Lewistown',
    county_fips: 17057,
    county_fips_all: '17057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"17057": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 40.38487,
    longitude: -90.13402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61542',
  },
  {
    city: 'Liverpool',
    county_fips: 17057,
    county_fips_all: '17057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"17057": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 40.42213,
    longitude: -89.96842,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61543',
  },
  {
    city: 'London Mills',
    county_fips: 17057,
    county_fips_all: '17057|17095',
    county: 'Fulton',
    county_names_all: 'Fulton|Knox',
    county_weights: '{"17057": 70.28, "17095": 29.72}',
    density: 7.6,
    imprecise: false,
    latitude: 40.69753,
    longitude: -90.24273,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61544',
  },
  {
    city: 'Lowpoint',
    county_fips: 17203,
    county_fips_all: '17203',
    county: 'Woodford',
    county_names_all: 'Woodford',
    county_weights: '{"17203": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 40.86837,
    longitude: -89.35253,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61545',
  },
  {
    city: 'Manito',
    county_fips: 17179,
    county_fips_all: '17179|17125',
    county: 'Tazewell',
    county_names_all: 'Tazewell|Mason',
    county_weights: '{"17179": 62.09, "17125": 37.91}',
    density: 15.7,
    imprecise: false,
    latitude: 40.45212,
    longitude: -89.80172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61546',
  },
  {
    city: 'Mapleton',
    county_fips: 17143,
    county_fips_all: '17143|17179',
    county: 'Peoria',
    county_names_all: 'Peoria|Tazewell',
    county_weights: '{"17143": 99.8, "17179": 0.2}',
    density: 62.6,
    imprecise: false,
    latitude: 40.60962,
    longitude: -89.73847,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61547',
  },
  {
    city: 'Metamora',
    county_fips: 17203,
    county_fips_all: '17203',
    county: 'Woodford',
    county_names_all: 'Woodford',
    county_weights: '{"17203": 100}',
    density: 61.4,
    imprecise: false,
    latitude: 40.80887,
    longitude: -89.41311,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61548',
  },
  {
    city: 'Morton',
    county_fips: 17179,
    county_fips_all: '17179',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"17179": 100}',
    density: 176,
    imprecise: false,
    latitude: 40.61054,
    longitude: -89.44049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61550',
  },
  {
    city: 'Mossville',
    county_fips: 17143,
    county_fips_all: '17143',
    county: 'Peoria',
    county_names_all: 'Peoria',
    county_weights: '{"17143": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 40.82133,
    longitude: -89.56496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61552',
  },
  {
    city: 'Norris',
    county_fips: 17057,
    county_fips_all: '17057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"17057": 100}',
    density: 111.7,
    imprecise: false,
    latitude: 40.62136,
    longitude: -90.02686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61553',
  },
  {
    city: 'Pekin',
    county_fips: 17179,
    county_fips_all: '17179',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"17179": 100}',
    density: 212.3,
    imprecise: false,
    latitude: 40.54441,
    longitude: -89.62181,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61554',
  },
  {
    city: 'Princeville',
    county_fips: 17143,
    county_fips_all: '17143|17175',
    county: 'Peoria',
    county_names_all: 'Peoria|Stark',
    county_weights: '{"17143": 90.83, "17175": 9.17}',
    density: 14.3,
    imprecise: false,
    latitude: 40.92101,
    longitude: -89.77438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61559',
  },
  {
    city: 'Putnam',
    county_fips: 17155,
    county_fips_all: '17155|17123|17011',
    county: 'Putnam',
    county_names_all: 'Putnam|Marshall|Bureau',
    county_weights: '{"17155": 92.84, "17123": 4.07, "17011": 3.09}',
    density: 5.3,
    imprecise: false,
    latitude: 41.18581,
    longitude: -89.40077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61560',
  },
  {
    city: 'Roanoke',
    county_fips: 17203,
    county_fips_all: '17203',
    county: 'Woodford',
    county_names_all: 'Woodford',
    county_weights: '{"17203": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 40.80582,
    longitude: -89.20475,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61561',
  },
  {
    city: 'Rome',
    county_fips: 17143,
    county_fips_all: '17143',
    county: 'Peoria',
    county_names_all: 'Peoria',
    county_weights: '{"17143": 100}',
    density: 331.5,
    imprecise: false,
    latitude: 40.88102,
    longitude: -89.50144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61562',
  },
  {
    city: 'Saint David',
    county_fips: 17057,
    county_fips_all: '17057',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"17057": 100}',
    density: 387.4,
    imprecise: false,
    latitude: 40.4931,
    longitude: -90.05108,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61563',
  },
  {
    city: 'South Pekin',
    county_fips: 17179,
    county_fips_all: '17179',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"17179": 100}',
    density: 370,
    imprecise: false,
    latitude: 40.49848,
    longitude: -89.65624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61564',
  },
  {
    city: 'Sparland',
    county_fips: 17123,
    county_fips_all: '17123|17143',
    county: 'Marshall',
    county_names_all: 'Marshall|Peoria',
    county_weights: '{"17123": 98.98, "17143": 1.02}',
    density: 7.4,
    imprecise: false,
    latitude: 41.032,
    longitude: -89.50718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61565',
  },
  {
    city: 'Topeka',
    county_fips: 17125,
    county_fips_all: '17125',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"17125": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 40.35077,
    longitude: -89.89899,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61567',
  },
  {
    city: 'Tremont',
    county_fips: 17179,
    county_fips_all: '17179',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"17179": 100}',
    density: 25.5,
    imprecise: false,
    latitude: 40.50484,
    longitude: -89.47876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61568',
  },
  {
    city: 'Trivoli',
    county_fips: 17143,
    county_fips_all: '17143|17057',
    county: 'Peoria',
    county_names_all: 'Peoria|Fulton',
    county_weights: '{"17143": 98.34, "17057": 1.66}',
    density: 10,
    imprecise: false,
    latitude: 40.67788,
    longitude: -89.89324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61569',
  },
  {
    city: 'Washburn',
    county_fips: 17203,
    county_fips_all: '17203|17123|17143',
    county: 'Woodford',
    county_names_all: 'Woodford|Marshall|Peoria',
    county_weights: '{"17203": 58.27, "17123": 41.54, "17143": 0.19}',
    density: 8.4,
    imprecise: false,
    latitude: 40.91933,
    longitude: -89.31578,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61570',
  },
  {
    city: 'Washington',
    county_fips: 17179,
    county_fips_all: '17179',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"17179": 100}',
    density: 176.7,
    imprecise: false,
    latitude: 40.70506,
    longitude: -89.42294,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61571',
  },
  {
    city: 'Yates City',
    county_fips: 17095,
    county_fips_all: '17095',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"17095": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 40.79768,
    longitude: -90.0343,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61572',
  },
  {
    city: 'Peoria',
    county_fips: 17143,
    county_fips_all: '17143|17179',
    county: 'Peoria',
    county_names_all: 'Peoria|Tazewell',
    county_weights: '{"17143": 99.76, "17179": 0.24}',
    density: 402.9,
    imprecise: false,
    latitude: 40.68005,
    longitude: -89.60395,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61602',
  },
  {
    city: 'Peoria',
    county_fips: 17143,
    county_fips_all: '17143|17179',
    county: 'Peoria',
    county_names_all: 'Peoria|Tazewell',
    county_weights: '{"17143": 99.47, "17179": 0.53}',
    density: 1403.4,
    imprecise: false,
    latitude: 40.7122,
    longitude: -89.57465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61603',
  },
  {
    city: 'Peoria',
    county_fips: 17143,
    county_fips_all: '17143',
    county: 'Peoria',
    county_names_all: 'Peoria',
    county_weights: '{"17143": 100}',
    density: 719.5,
    imprecise: false,
    latitude: 40.70525,
    longitude: -89.65297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61604',
  },
  {
    city: 'Peoria',
    county_fips: 17143,
    county_fips_all: '17143',
    county: 'Peoria',
    county_names_all: 'Peoria',
    county_weights: '{"17143": 100}',
    density: 1183.8,
    imprecise: false,
    latitude: 40.6765,
    longitude: -89.63317,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61605',
  },
  {
    city: 'Peoria',
    county_fips: 17143,
    county_fips_all: '17143',
    county: 'Peoria',
    county_names_all: 'Peoria',
    county_weights: '{"17143": 100}',
    density: 2107.9,
    imprecise: false,
    latitude: 40.70011,
    longitude: -89.61187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61606',
  },
  {
    city: 'Peoria',
    county_fips: 17143,
    county_fips_all: '17143|17179',
    county: 'Peoria',
    county_names_all: 'Peoria|Tazewell',
    county_weights: '{"17143": 99.66, "17179": 0.34}',
    density: 121.6,
    imprecise: false,
    latitude: 40.62895,
    longitude: -89.68627,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61607',
  },
  {
    city: 'Creve Coeur',
    county_fips: 17179,
    county_fips_all: '17179',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"17179": 100}',
    density: 431,
    imprecise: false,
    latitude: 40.64294,
    longitude: -89.59882,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61610',
  },
  {
    city: 'East Peoria',
    county_fips: 17179,
    county_fips_all: '17179|17203|17143',
    county: 'Tazewell',
    county_names_all: 'Tazewell|Woodford|Peoria',
    county_weights: '{"17179": 64.3, "17203": 34.9, "17143": 0.8}',
    density: 226.6,
    imprecise: false,
    latitude: 40.71185,
    longitude: -89.53469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61611',
  },
  {
    city: 'Peoria',
    county_fips: 17143,
    county_fips_all: '17143',
    county: 'Peoria',
    county_names_all: 'Peoria',
    county_weights: '{"17143": 100}',
    density: 878.6,
    imprecise: false,
    latitude: 40.75872,
    longitude: -89.60486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61614',
  },
  {
    city: 'Peoria',
    county_fips: 17143,
    county_fips_all: '17143|17203',
    county: 'Peoria',
    county_names_all: 'Peoria|Woodford',
    county_weights: '{"17143": 98.59, "17203": 1.41}',
    density: 306.6,
    imprecise: false,
    latitude: 40.78088,
    longitude: -89.63102,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61615',
  },
  {
    city: 'Peoria Heights',
    county_fips: 17143,
    county_fips_all: '17143|17203',
    county: 'Peoria',
    county_names_all: 'Peoria|Woodford',
    county_weights: '{"17143": 99.75, "17203": 0.25}',
    density: 884.9,
    imprecise: false,
    latitude: 40.74682,
    longitude: -89.57195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61616',
  },
  {
    city: 'Bloomington',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 1230.2,
    imprecise: false,
    latitude: 40.47697,
    longitude: -88.99278,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61701',
  },
  {
    city: 'Bloomington',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 755.8,
    imprecise: false,
    latitude: 40.46951,
    longitude: -88.94281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61704',
  },
  {
    city: 'Bloomington',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 58.7,
    imprecise: false,
    latitude: 40.46099,
    longitude: -88.99981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61705',
  },
  {
    city: 'Anchor',
    county_fips: 17113,
    county_fips_all: '17113|17053',
    county: 'McLean',
    county_names_all: 'McLean|Ford',
    county_weights: '{"17113": 87.22, "17053": 12.78}',
    density: 4.8,
    imprecise: false,
    latitude: 40.55228,
    longitude: -88.50498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61720',
  },
  {
    city: 'Armington',
    county_fips: 17179,
    county_fips_all: '17179|17107',
    county: 'Tazewell',
    county_names_all: 'Tazewell|Logan',
    county_weights: '{"17179": 85.67, "17107": 14.33}',
    density: 6.2,
    imprecise: false,
    latitude: 40.35349,
    longitude: -89.32238,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61721',
  },
  {
    city: 'Arrowsmith',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 40.42018,
    longitude: -88.63049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61722',
  },
  {
    city: 'Atlanta',
    county_fips: 17107,
    county_fips_all: '17107|17113',
    county: 'Logan',
    county_names_all: 'Logan|McLean',
    county_weights: '{"17107": 91.84, "17113": 8.16}',
    density: 12.2,
    imprecise: false,
    latitude: 40.26139,
    longitude: -89.26703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61723',
  },
  {
    city: 'Bellflower',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 40.33418,
    longitude: -88.52654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61724',
  },
  {
    city: 'Carlock',
    county_fips: 17203,
    county_fips_all: '17203|17113',
    county: 'Woodford',
    county_names_all: 'Woodford|McLean',
    county_weights: '{"17203": 52.66, "17113": 47.34}',
    density: 12.5,
    imprecise: false,
    latitude: 40.61201,
    longitude: -89.11717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61725',
  },
  {
    city: 'Chenoa',
    county_fips: 17113,
    county_fips_all: '17113|17105',
    county: 'McLean',
    county_names_all: 'McLean|Livingston',
    county_weights: '{"17113": 64.51, "17105": 35.49}',
    density: 10.4,
    imprecise: false,
    latitude: 40.74013,
    longitude: -88.70014,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61726',
  },
  {
    city: 'Clinton',
    county_fips: 17039,
    county_fips_all: '17039',
    county: 'De Witt',
    county_names_all: 'De Witt',
    county_weights: '{"17039": 100}',
    density: 27.4,
    imprecise: false,
    latitude: 40.14701,
    longitude: -88.95245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61727',
  },
  {
    city: 'Colfax',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 40.57546,
    longitude: -88.62539,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61728',
  },
  {
    city: 'Congerville',
    county_fips: 17203,
    county_fips_all: '17203|17113',
    county: 'Woodford',
    county_names_all: 'Woodford|McLean',
    county_weights: '{"17203": 93.94, "17113": 6.06}',
    density: 26.3,
    imprecise: false,
    latitude: 40.62799,
    longitude: -89.22393,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61729',
  },
  {
    city: 'Cooksville',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 40.53262,
    longitude: -88.73437,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61730',
  },
  {
    city: 'Cropsey',
    county_fips: 17113,
    county_fips_all: '17113|17105|17053',
    county: 'McLean',
    county_names_all: 'McLean|Livingston|Ford',
    county_weights: '{"17113": 46.36, "17105": 41.32, "17053": 12.31}',
    density: 1.3,
    imprecise: false,
    latitude: 40.61255,
    longitude: -88.48386,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61731',
  },
  {
    city: 'Danvers',
    county_fips: 17113,
    county_fips_all: '17113|17179',
    county: 'McLean',
    county_names_all: 'McLean|Tazewell',
    county_weights: '{"17113": 91.2, "17179": 8.8}',
    density: 13,
    imprecise: false,
    latitude: 40.53123,
    longitude: -89.20646,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61732',
  },
  {
    city: 'Deer Creek',
    county_fips: 17179,
    county_fips_all: '17179|17203',
    county: 'Tazewell',
    county_names_all: 'Tazewell|Woodford',
    county_weights: '{"17179": 83.92, "17203": 16.08}',
    density: 17,
    imprecise: false,
    latitude: 40.62421,
    longitude: -89.33573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61733',
  },
  {
    city: 'Delavan',
    county_fips: 17179,
    county_fips_all: '17179',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"17179": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 40.37431,
    longitude: -89.52549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61734',
  },
  {
    city: 'Dewitt',
    county_fips: 17039,
    county_fips_all: '17039',
    county: 'De Witt',
    county_names_all: 'De Witt',
    county_weights: '{"17039": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 40.20561,
    longitude: -88.81072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61735',
  },
  {
    city: 'Downs',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 29.8,
    imprecise: false,
    latitude: 40.40335,
    longitude: -88.83804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61736',
  },
  {
    city: 'Ellsworth',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 40.45646,
    longitude: -88.73331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61737',
  },
  {
    city: 'El Paso',
    county_fips: 17203,
    county_fips_all: '17203|17113',
    county: 'Woodford',
    county_names_all: 'Woodford|McLean',
    county_weights: '{"17203": 94.0, "17113": 6.0}',
    density: 18.4,
    imprecise: false,
    latitude: 40.74925,
    longitude: -89.02821,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61738',
  },
  {
    city: 'Fairbury',
    county_fips: 17105,
    county_fips_all: '17105|17113',
    county: 'Livingston',
    county_names_all: 'Livingston|McLean',
    county_weights: '{"17105": 95.35, "17113": 4.65}',
    density: 16.8,
    imprecise: false,
    latitude: 40.73342,
    longitude: -88.51938,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61739',
  },
  {
    city: 'Flanagan',
    county_fips: 17105,
    county_fips_all: '17105',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"17105": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 40.88779,
    longitude: -88.86397,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61740',
  },
  {
    city: 'Forrest',
    county_fips: 17105,
    county_fips_all: '17105',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"17105": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 40.76045,
    longitude: -88.40057,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61741',
  },
  {
    city: 'Goodfield',
    county_fips: 17203,
    county_fips_all: '17203|17179',
    county: 'Woodford',
    county_names_all: 'Woodford|Tazewell',
    county_weights: '{"17203": 95.48, "17179": 4.52}',
    density: 96.6,
    imprecise: false,
    latitude: 40.63341,
    longitude: -89.27322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61742',
  },
  {
    city: 'Graymont',
    county_fips: 17105,
    county_fips_all: '17105',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"17105": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 40.87805,
    longitude: -88.78142,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61743',
  },
  {
    city: 'Gridley',
    county_fips: 17113,
    county_fips_all: '17113|17105|17203',
    county: 'McLean',
    county_names_all: 'McLean|Livingston|Woodford',
    county_weights: '{"17113": 59.5, "17105": 37.9, "17203": 2.6}',
    density: 10.7,
    imprecise: false,
    latitude: 40.74377,
    longitude: -88.88118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61744',
  },
  {
    city: 'Heyworth',
    county_fips: 17113,
    county_fips_all: '17113|17039',
    county: 'McLean',
    county_names_all: 'McLean|De Witt',
    county_weights: '{"17113": 82.36, "17039": 17.64}',
    density: 23.6,
    imprecise: false,
    latitude: 40.32152,
    longitude: -88.96684,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61745',
  },
  {
    city: 'Hopedale',
    county_fips: 17179,
    county_fips_all: '17179',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"17179": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 40.4174,
    longitude: -89.43295,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61747',
  },
  {
    city: 'Hudson',
    county_fips: 17113,
    county_fips_all: '17113|17203',
    county: 'McLean',
    county_names_all: 'McLean|Woodford',
    county_weights: '{"17113": 96.08, "17203": 3.92}',
    density: 23.7,
    imprecise: false,
    latitude: 40.61483,
    longitude: -88.98898,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61748',
  },
  {
    city: 'Kenney',
    county_fips: 17039,
    county_fips_all: '17039|17115|17107',
    county: 'De Witt',
    county_names_all: 'De Witt|Macon|Logan',
    county_weights: '{"17039": 79.86, "17115": 10.8, "17107": 9.34}',
    density: 7.1,
    imprecise: false,
    latitude: 40.09209,
    longitude: -89.10943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61749',
  },
  {
    city: 'Lane',
    county_fips: 17039,
    county_fips_all: '17039',
    county: 'De Witt',
    county_names_all: 'De Witt',
    county_weights: '{"17039": 100}',
    density: 461.2,
    imprecise: false,
    latitude: 40.12251,
    longitude: -88.8557,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61750',
  },
  {
    city: 'Lawndale',
    county_fips: 17107,
    county_fips_all: '17107',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"17107": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 40.21455,
    longitude: -89.29926,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61751',
  },
  {
    city: 'Le Roy',
    county_fips: 17113,
    county_fips_all: '17113|17039',
    county: 'McLean',
    county_names_all: 'McLean|De Witt',
    county_weights: '{"17113": 94.84, "17039": 5.16}',
    density: 19.4,
    imprecise: false,
    latitude: 40.33703,
    longitude: -88.76168,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61752',
  },
  {
    city: 'Lexington',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 40.63568,
    longitude: -88.78883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61753',
  },
  {
    city: 'McLean',
    county_fips: 17113,
    county_fips_all: '17113|17039|17107',
    county: 'McLean',
    county_names_all: 'McLean|De Witt|Logan',
    county_weights: '{"17113": 87.32, "17039": 7.82, "17107": 4.86}',
    density: 5.6,
    imprecise: false,
    latitude: 40.3287,
    longitude: -89.15744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61754',
  },
  {
    city: 'Mackinaw',
    county_fips: 17179,
    county_fips_all: '17179',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"17179": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 40.52661,
    longitude: -89.33909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61755',
  },
  {
    city: 'Maroa',
    county_fips: 17115,
    county_fips_all: '17115|17039',
    county: 'Macon',
    county_names_all: 'Macon|De Witt',
    county_weights: '{"17115": 70.25, "17039": 29.75}',
    density: 11.7,
    imprecise: false,
    latitude: 40.03311,
    longitude: -88.96368,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61756',
  },
  {
    city: 'Minier',
    county_fips: 17179,
    county_fips_all: '17179',
    county: 'Tazewell',
    county_names_all: 'Tazewell',
    county_weights: '{"17179": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 40.4347,
    longitude: -89.32418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61759',
  },
  {
    city: 'Minonk',
    county_fips: 17203,
    county_fips_all: '17203|17123',
    county: 'Woodford',
    county_names_all: 'Woodford|Marshall',
    county_weights: '{"17203": 92.2, "17123": 7.8}',
    density: 12.3,
    imprecise: false,
    latitude: 40.88713,
    longitude: -89.03263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61760',
  },
  {
    city: 'Normal',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 490.5,
    imprecise: false,
    latitude: 40.52503,
    longitude: -88.95152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61761',
  },
  {
    city: 'Pontiac',
    county_fips: 17105,
    county_fips_all: '17105',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"17105": 100}',
    density: 34.2,
    imprecise: false,
    latitude: 40.88343,
    longitude: -88.6263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61764',
  },
  {
    city: 'Saunemin',
    county_fips: 17105,
    county_fips_all: '17105',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"17105": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 40.88106,
    longitude: -88.39804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61769',
  },
  {
    city: 'Saybrook',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 40.43965,
    longitude: -88.52457,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61770',
  },
  {
    city: 'Secor',
    county_fips: 17203,
    county_fips_all: '17203',
    county: 'Woodford',
    county_names_all: 'Woodford',
    county_weights: '{"17203": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 40.70725,
    longitude: -89.14184,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61771',
  },
  {
    city: 'Shirley',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 40.386,
    longitude: -89.06351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61772',
  },
  {
    city: 'Sibley',
    county_fips: 17053,
    county_fips_all: '17053',
    county: 'Ford',
    county_names_all: 'Ford',
    county_weights: '{"17053": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 40.57209,
    longitude: -88.37605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61773',
  },
  {
    city: 'Stanford',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 40.42945,
    longitude: -89.20145,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61774',
  },
  {
    city: 'Strawn',
    county_fips: 17105,
    county_fips_all: '17105',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"17105": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 40.64971,
    longitude: -88.37069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61775',
  },
  {
    city: 'Towanda',
    county_fips: 17113,
    county_fips_all: '17113',
    county: 'McLean',
    county_names_all: 'McLean',
    county_weights: '{"17113": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 40.5713,
    longitude: -88.86706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61776',
  },
  {
    city: 'Wapella',
    county_fips: 17039,
    county_fips_all: '17039',
    county: 'De Witt',
    county_names_all: 'De Witt',
    county_weights: '{"17039": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 40.243,
    longitude: -88.93948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61777',
  },
  {
    city: 'Waynesville',
    county_fips: 17039,
    county_fips_all: '17039',
    county: 'De Witt',
    county_names_all: 'De Witt',
    county_weights: '{"17039": 100}',
    density: 7,
    imprecise: false,
    latitude: 40.22575,
    longitude: -89.09104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61778',
  },
  {
    city: 'Urbana',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 1994,
    imprecise: false,
    latitude: 40.10937,
    longitude: -88.21175,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61801',
  },
  {
    city: 'Urbana',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 95.5,
    imprecise: false,
    latitude: 40.12288,
    longitude: -88.14863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61802',
  },
  {
    city: 'Allerton',
    county_fips: 17183,
    county_fips_all: '17183|17045|17019',
    county: 'Vermilion',
    county_names_all: 'Vermilion|Edgar|Champaign',
    county_weights: '{"17183": 58.08, "17045": 21.94, "17019": 19.98}',
    density: 4.3,
    imprecise: false,
    latitude: 39.91019,
    longitude: -87.91837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61810',
  },
  {
    city: 'Alvin',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 40.29531,
    longitude: -87.62162,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61811',
  },
  {
    city: 'Armstrong',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 40.25869,
    longitude: -87.88989,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61812',
  },
  {
    city: 'Bement',
    county_fips: 17147,
    county_fips_all: '17147',
    county: 'Piatt',
    county_names_all: 'Piatt',
    county_weights: '{"17147": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 39.90933,
    longitude: -88.55796,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61813',
  },
  {
    city: 'Bismarck',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 40.23191,
    longitude: -87.57018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61814',
  },
  {
    city: 'Bondville',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 561,
    imprecise: false,
    latitude: 40.11075,
    longitude: -88.3679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61815',
  },
  {
    city: 'Broadlands',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 39.92444,
    longitude: -88.00398,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61816',
  },
  {
    city: 'Catlin',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 40.03088,
    longitude: -87.71991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61817',
  },
  {
    city: 'Cerro Gordo',
    county_fips: 17147,
    county_fips_all: '17147|17115',
    county: 'Piatt',
    county_names_all: 'Piatt|Macon',
    county_weights: '{"17147": 85.57, "17115": 14.43}',
    density: 15.4,
    imprecise: false,
    latitude: 39.88455,
    longitude: -88.71798,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61818',
  },
  {
    city: 'Champaign',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 2642.2,
    imprecise: false,
    latitude: 40.112,
    longitude: -88.24423,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61820',
  },
  {
    city: 'Champaign',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 1435.9,
    imprecise: false,
    latitude: 40.11041,
    longitude: -88.27611,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61821',
  },
  {
    city: 'Champaign',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 99.6,
    imprecise: false,
    latitude: 40.13693,
    longitude: -88.30453,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61822',
  },
  {
    city: 'Cisco',
    county_fips: 17147,
    county_fips_all: '17147|17115',
    county: 'Piatt',
    county_names_all: 'Piatt|Macon',
    county_weights: '{"17147": 72.04, "17115": 27.96}',
    density: 5.9,
    imprecise: false,
    latitude: 40.01122,
    longitude: -88.72926,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61830',
  },
  {
    city: 'Collison',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 40.22623,
    longitude: -87.79705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61831',
  },
  {
    city: 'Danville',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 458.5,
    imprecise: false,
    latitude: 40.13186,
    longitude: -87.63256,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61832',
  },
  {
    city: 'Tilton',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 438.6,
    imprecise: false,
    latitude: 40.09914,
    longitude: -87.64718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61833',
  },
  {
    city: 'Danville',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 28.2,
    imprecise: false,
    latitude: 40.16428,
    longitude: -87.64028,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61834',
  },
  {
    city: 'De Land',
    county_fips: 17147,
    county_fips_all: '17147',
    county: 'Piatt',
    county_names_all: 'Piatt',
    county_weights: '{"17147": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 40.13184,
    longitude: -88.63694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61839',
  },
  {
    city: 'Dewey',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 40.29663,
    longitude: -88.30187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61840',
  },
  {
    city: 'Fairmount',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 40.02775,
    longitude: -87.82459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61841',
  },
  {
    city: 'Farmer City',
    county_fips: 17039,
    county_fips_all: '17039|17147|17113',
    county: 'De Witt',
    county_names_all: 'De Witt|Piatt|McLean',
    county_weights: '{"17039": 63.69, "17147": 18.53, "17113": 17.78}',
    density: 9.2,
    imprecise: false,
    latitude: 40.23889,
    longitude: -88.66411,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61842',
  },
  {
    city: 'Fisher',
    county_fips: 17019,
    county_fips_all: '17019|17113',
    county: 'Champaign',
    county_names_all: 'Champaign|McLean',
    county_weights: '{"17019": 94.46, "17113": 5.54}',
    density: 20.3,
    imprecise: false,
    latitude: 40.31593,
    longitude: -88.38053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61843',
  },
  {
    city: 'Fithian',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 40.14431,
    longitude: -87.8711,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61844',
  },
  {
    city: 'Foosland',
    county_fips: 17019,
    county_fips_all: '17019|17053',
    county: 'Champaign',
    county_names_all: 'Champaign|Ford',
    county_weights: '{"17019": 90.04, "17053": 9.96}',
    density: 2.9,
    imprecise: false,
    latitude: 40.37308,
    longitude: -88.40076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61845',
  },
  {
    city: 'Georgetown',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 40.1,
    imprecise: false,
    latitude: 39.97601,
    longitude: -87.61222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61846',
  },
  {
    city: 'Gifford',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 40.31148,
    longitude: -88.01581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61847',
  },
  {
    city: 'Henning',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 89.8,
    imprecise: false,
    latitude: 40.30694,
    longitude: -87.70096,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61848',
  },
  {
    city: 'Homer',
    county_fips: 17019,
    county_fips_all: '17019|17183',
    county: 'Champaign',
    county_names_all: 'Champaign|Vermilion',
    county_weights: '{"17019": 66.32, "17183": 33.68}',
    density: 13,
    imprecise: false,
    latitude: 40.01145,
    longitude: -87.96185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61849',
  },
  {
    city: 'Indianola',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 39.9301,
    longitude: -87.74346,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61850',
  },
  {
    city: 'Ivesdale',
    county_fips: 17019,
    county_fips_all: '17019|17147',
    county: 'Champaign',
    county_names_all: 'Champaign|Piatt',
    county_weights: '{"17019": 89.3, "17147": 10.7}',
    density: 3.2,
    imprecise: false,
    latitude: 39.96507,
    longitude: -88.43544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61851',
  },
  {
    city: 'Longview',
    county_fips: 17019,
    county_fips_all: '17019|17041',
    county: 'Champaign',
    county_names_all: 'Champaign|Douglas',
    county_weights: '{"17019": 78.92, "17041": 21.08}',
    density: 3.6,
    imprecise: false,
    latitude: 39.89951,
    longitude: -88.07277,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61852',
  },
  {
    city: 'Mahomet',
    county_fips: 17019,
    county_fips_all: '17019|17147',
    county: 'Champaign',
    county_names_all: 'Champaign|Piatt',
    county_weights: '{"17019": 92.04, "17147": 7.96}',
    density: 119.4,
    imprecise: false,
    latitude: 40.22344,
    longitude: -88.41555,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61853',
  },
  {
    city: 'Mansfield',
    county_fips: 17147,
    county_fips_all: '17147|17113',
    county: 'Piatt',
    county_names_all: 'Piatt|McLean',
    county_weights: '{"17147": 94.65, "17113": 5.35}',
    density: 8.9,
    imprecise: false,
    latitude: 40.20654,
    longitude: -88.52129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61854',
  },
  {
    city: 'Milmine',
    county_fips: 17147,
    county_fips_all: '17147',
    county: 'Piatt',
    county_names_all: 'Piatt',
    county_weights: '{"17147": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 39.92438,
    longitude: -88.66056,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61855',
  },
  {
    city: 'Monticello',
    county_fips: 17147,
    county_fips_all: '17147',
    county: 'Piatt',
    county_names_all: 'Piatt',
    county_weights: '{"17147": 100}',
    density: 29.4,
    imprecise: false,
    latitude: 40.02838,
    longitude: -88.58211,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61856',
  },
  {
    city: 'Muncie',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 100.5,
    imprecise: false,
    latitude: 40.11862,
    longitude: -87.84337,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61857',
  },
  {
    city: 'Oakwood',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 35.3,
    imprecise: false,
    latitude: 40.13166,
    longitude: -87.76438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61858',
  },
  {
    city: 'Ogden',
    county_fips: 17019,
    county_fips_all: '17019|17183',
    county: 'Champaign',
    county_names_all: 'Champaign|Vermilion',
    county_weights: '{"17019": 85.42, "17183": 14.58}',
    density: 15.6,
    imprecise: false,
    latitude: 40.15065,
    longitude: -87.96163,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61859',
  },
  {
    city: 'Penfield',
    county_fips: 17019,
    county_fips_all: '17019|17183',
    county: 'Champaign',
    county_names_all: 'Champaign|Vermilion',
    county_weights: '{"17019": 81.69, "17183": 18.31}',
    density: 5.6,
    imprecise: false,
    latitude: 40.30474,
    longitude: -87.95103,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61862',
  },
  {
    city: 'Pesotum',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 39.90575,
    longitude: -88.28194,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61863',
  },
  {
    city: 'Philo',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 33.8,
    imprecise: false,
    latitude: 39.97989,
    longitude: -88.14437,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61864',
  },
  {
    city: 'Potomac',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 40.30362,
    longitude: -87.80047,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61865',
  },
  {
    city: 'Rantoul',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 65,
    imprecise: false,
    latitude: 40.31148,
    longitude: -88.15837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61866',
  },
  {
    city: 'Ridge Farm',
    county_fips: 17183,
    county_fips_all: '17183|17045',
    county: 'Vermilion',
    county_names_all: 'Vermilion|Edgar',
    county_weights: '{"17183": 85.66, "17045": 14.34}',
    density: 10.3,
    imprecise: false,
    latitude: 39.90325,
    longitude: -87.61562,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61870',
  },
  {
    city: 'Royal',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 71.4,
    imprecise: false,
    latitude: 40.19118,
    longitude: -87.97925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61871',
  },
  {
    city: 'Sadorus',
    county_fips: 17019,
    county_fips_all: '17019|17041',
    county: 'Champaign',
    county_names_all: 'Champaign|Douglas',
    county_weights: '{"17019": 90.25, "17041": 9.75}',
    density: 6.5,
    imprecise: false,
    latitude: 39.93586,
    longitude: -88.38018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61872',
  },
  {
    city: 'Saint Joseph',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 35,
    imprecise: false,
    latitude: 40.14069,
    longitude: -88.03817,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61873',
  },
  {
    city: 'Savoy',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 557.1,
    imprecise: false,
    latitude: 40.05062,
    longitude: -88.26078,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61874',
  },
  {
    city: 'Seymour',
    county_fips: 17019,
    county_fips_all: '17019|17147',
    county: 'Champaign',
    county_names_all: 'Champaign|Piatt',
    county_weights: '{"17019": 98.73, "17147": 1.27}',
    density: 10.6,
    imprecise: false,
    latitude: 40.10421,
    longitude: -88.42267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61875',
  },
  {
    city: 'Sidell',
    county_fips: 17183,
    county_fips_all: '17183|17045',
    county: 'Vermilion',
    county_names_all: 'Vermilion|Edgar',
    county_weights: '{"17183": 75.36, "17045": 24.64}',
    density: 6.6,
    imprecise: false,
    latitude: 39.90534,
    longitude: -87.8398,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61876',
  },
  {
    city: 'Sidney',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 39.99456,
    longitude: -88.07764,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61877',
  },
  {
    city: 'Thomasboro',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 40.23953,
    longitude: -88.14945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61878',
  },
  {
    city: 'Tolono',
    county_fips: 17019,
    county_fips_all: '17019',
    county: 'Champaign',
    county_names_all: 'Champaign',
    county_weights: '{"17019": 100}',
    density: 27.3,
    imprecise: false,
    latitude: 39.97482,
    longitude: -88.2458,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61880',
  },
  {
    city: 'Weldon',
    county_fips: 17039,
    county_fips_all: '17039|17147|17115',
    county: 'De Witt',
    county_names_all: 'De Witt|Piatt|Macon',
    county_weights: '{"17039": 90.43, "17147": 7.08, "17115": 2.49}',
    density: 7.8,
    imprecise: false,
    latitude: 40.11203,
    longitude: -88.75969,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61882',
  },
  {
    city: 'Westville',
    county_fips: 17183,
    county_fips_all: '17183',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"17183": 100}',
    density: 82.3,
    imprecise: false,
    latitude: 40.03494,
    longitude: -87.63992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61883',
  },
  {
    city: 'White Heath',
    county_fips: 17147,
    county_fips_all: '17147|17019',
    county: 'Piatt',
    county_names_all: 'Piatt|Champaign',
    county_weights: '{"17147": 79.41, "17019": 20.59}',
    density: 15.6,
    imprecise: false,
    latitude: 40.09115,
    longitude: -88.48266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61884',
  },
  {
    city: 'Arcola',
    county_fips: 17041,
    county_fips_all: '17041|17029',
    county: 'Douglas',
    county_names_all: 'Douglas|Coles',
    county_weights: '{"17041": 67.28, "17029": 32.72}',
    density: 18,
    imprecise: false,
    latitude: 39.67283,
    longitude: -88.30035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61910',
  },
  {
    city: 'Arthur',
    county_fips: 17139,
    county_fips_all: '17139|17041|17029',
    county: 'Moultrie',
    county_names_all: 'Moultrie|Douglas|Coles',
    county_weights: '{"17139": 47.06, "17041": 41.27, "17029": 11.67}',
    density: 27.4,
    imprecise: false,
    latitude: 39.70452,
    longitude: -88.47068,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61911',
  },
  {
    city: 'Ashmore',
    county_fips: 17029,
    county_fips_all: '17029',
    county: 'Coles',
    county_names_all: 'Coles',
    county_weights: '{"17029": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 39.52825,
    longitude: -88.03357,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61912',
  },
  {
    city: 'Atwood',
    county_fips: 17147,
    county_fips_all: '17147|17041|17139',
    county: 'Piatt',
    county_names_all: 'Piatt|Douglas|Moultrie',
    county_weights: '{"17147": 48.18, "17041": 47.85, "17139": 3.97}',
    density: 12.2,
    imprecise: false,
    latitude: 39.82657,
    longitude: -88.47156,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61913',
  },
  {
    city: 'Bethany',
    county_fips: 17139,
    county_fips_all: '17139|17173|17115',
    county: 'Moultrie',
    county_names_all: 'Moultrie|Shelby|Macon',
    county_weights: '{"17139": 75.98, "17173": 20.71, "17115": 3.31}',
    density: 11.3,
    imprecise: false,
    latitude: 39.63409,
    longitude: -88.76783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61914',
  },
  {
    city: 'Brocton',
    county_fips: 17045,
    county_fips_all: '17045|17041',
    county: 'Edgar',
    county_names_all: 'Edgar|Douglas',
    county_weights: '{"17045": 93.59, "17041": 6.41}',
    density: 2.3,
    imprecise: false,
    latitude: 39.71746,
    longitude: -87.8941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61917',
  },
  {
    city: 'Camargo',
    county_fips: 17041,
    county_fips_all: '17041',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"17041": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 39.7789,
    longitude: -88.13727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61919',
  },
  {
    city: 'Charleston',
    county_fips: 17029,
    county_fips_all: '17029',
    county: 'Coles',
    county_names_all: 'Coles',
    county_weights: '{"17029": 100}',
    density: 54.5,
    imprecise: false,
    latitude: 39.50415,
    longitude: -88.16448,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61920',
  },
  {
    city: 'Chrisman',
    county_fips: 17045,
    county_fips_all: '17045',
    county: 'Edgar',
    county_names_all: 'Edgar',
    county_weights: '{"17045": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 39.79269,
    longitude: -87.6506,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61924',
  },
  {
    city: 'Dalton City',
    county_fips: 17115,
    county_fips_all: '17115|17139',
    county: 'Macon',
    county_names_all: 'Macon|Moultrie',
    county_weights: '{"17115": 74.77, "17139": 25.23}',
    density: 10.4,
    imprecise: false,
    latitude: 39.72444,
    longitude: -88.83548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61925',
  },
  {
    city: 'Gays',
    county_fips: 17139,
    county_fips_all: '17139|17173|17029',
    county: 'Moultrie',
    county_names_all: 'Moultrie|Shelby|Coles',
    county_weights: '{"17139": 62.06, "17173": 31.96, "17029": 5.98}',
    density: 9.7,
    imprecise: false,
    latitude: 39.45524,
    longitude: -88.50284,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61928',
  },
  {
    city: 'Hammond',
    county_fips: 17147,
    county_fips_all: '17147|17139',
    county: 'Piatt',
    county_names_all: 'Piatt|Moultrie',
    county_weights: '{"17147": 99.46, "17139": 0.54}',
    density: 6.6,
    imprecise: false,
    latitude: 39.82338,
    longitude: -88.62271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61929',
  },
  {
    city: 'Hindsboro',
    county_fips: 17041,
    county_fips_all: '17041|17029',
    county: 'Douglas',
    county_names_all: 'Douglas|Coles',
    county_weights: '{"17041": 76.42, "17029": 23.58}',
    density: 7.6,
    imprecise: false,
    latitude: 39.67935,
    longitude: -88.12899,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61930',
  },
  {
    city: 'Humboldt',
    county_fips: 17029,
    county_fips_all: '17029',
    county: 'Coles',
    county_names_all: 'Coles',
    county_weights: '{"17029": 100}',
    density: 16,
    imprecise: false,
    latitude: 39.59067,
    longitude: -88.35883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61931',
  },
  {
    city: 'Hume',
    county_fips: 17045,
    county_fips_all: '17045',
    county: 'Edgar',
    county_names_all: 'Edgar',
    county_weights: '{"17045": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 39.79968,
    longitude: -87.87493,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61932',
  },
  {
    city: 'Kansas',
    county_fips: 17045,
    county_fips_all: '17045|17023|17029',
    county: 'Edgar',
    county_names_all: 'Edgar|Clark|Coles',
    county_weights: '{"17045": 92.7, "17023": 6.31, "17029": 0.99}',
    density: 8.5,
    imprecise: false,
    latitude: 39.55099,
    longitude: -87.91502,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61933',
  },
  {
    city: 'La Place',
    county_fips: 17147,
    county_fips_all: '17147',
    county: 'Piatt',
    county_names_all: 'Piatt',
    county_weights: '{"17147": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 39.80319,
    longitude: -88.72684,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61936',
  },
  {
    city: 'Lovington',
    county_fips: 17139,
    county_fips_all: '17139|17115',
    county: 'Moultrie',
    county_names_all: 'Moultrie|Macon',
    county_weights: '{"17139": 92.76, "17115": 7.24}',
    density: 7.2,
    imprecise: false,
    latitude: 39.73872,
    longitude: -88.65542,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61937',
  },
  {
    city: 'Mattoon',
    county_fips: 17029,
    county_fips_all: '17029|17035',
    county: 'Coles',
    county_names_all: 'Coles|Cumberland',
    county_weights: '{"17029": 98.74, "17035": 1.26}',
    density: 62.1,
    imprecise: false,
    latitude: 39.48004,
    longitude: -88.37571,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61938',
  },
  {
    city: 'Metcalf',
    county_fips: 17045,
    county_fips_all: '17045',
    county: 'Edgar',
    county_names_all: 'Edgar',
    county_weights: '{"17045": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 39.80395,
    longitude: -87.81249,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61940',
  },
  {
    city: 'Murdock',
    county_fips: 17041,
    county_fips_all: '17041',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"17041": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 39.80457,
    longitude: -88.07505,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61941',
  },
  {
    city: 'Newman',
    county_fips: 17041,
    county_fips_all: '17041|17045',
    county: 'Douglas',
    county_names_all: 'Douglas|Edgar',
    county_weights: '{"17041": 90.52, "17045": 9.48}',
    density: 6.4,
    imprecise: false,
    latitude: 39.81515,
    longitude: -88.00818,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61942',
  },
  {
    city: 'Oakland',
    county_fips: 17029,
    county_fips_all: '17029|17041|17045',
    county: 'Coles',
    county_names_all: 'Coles|Douglas|Edgar',
    county_weights: '{"17029": 57.87, "17041": 34.26, "17045": 7.87}',
    density: 7.2,
    imprecise: false,
    latitude: 39.6608,
    longitude: -88.0248,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61943',
  },
  {
    city: 'Paris',
    county_fips: 17045,
    county_fips_all: '17045|17023',
    county: 'Edgar',
    county_names_all: 'Edgar|Clark',
    county_weights: '{"17045": 99.21, "17023": 0.79}',
    density: 16.5,
    imprecise: false,
    latitude: 39.59969,
    longitude: -87.70146,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61944',
  },
  {
    city: 'Redmon',
    county_fips: 17045,
    county_fips_all: '17045',
    county: 'Edgar',
    county_names_all: 'Edgar',
    county_weights: '{"17045": 100}',
    density: 59,
    imprecise: false,
    latitude: 39.65753,
    longitude: -87.85844,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61949',
  },
  {
    city: 'Sullivan',
    county_fips: 17139,
    county_fips_all: '17139|17029',
    county: 'Moultrie',
    county_names_all: 'Moultrie|Coles',
    county_weights: '{"17139": 97.75, "17029": 2.25}',
    density: 22.8,
    imprecise: false,
    latitude: 39.59118,
    longitude: -88.5865,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61951',
  },
  {
    city: 'Tuscola',
    county_fips: 17041,
    county_fips_all: '17041',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"17041": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 39.79803,
    longitude: -88.28991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61953',
  },
  {
    city: 'Vermilion',
    county_fips: 17045,
    county_fips_all: '17045',
    county: 'Edgar',
    county_names_all: 'Edgar',
    county_weights: '{"17045": 100}',
    density: 197.9,
    imprecise: false,
    latitude: 39.58162,
    longitude: -87.5875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61955',
  },
  {
    city: 'Villa Grove',
    county_fips: 17041,
    county_fips_all: '17041|17019',
    county: 'Douglas',
    county_names_all: 'Douglas|Champaign',
    county_weights: '{"17041": 77.07, "17019": 22.93}',
    density: 33.6,
    imprecise: false,
    latitude: 39.8537,
    longitude: -88.14433,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61956',
  },
  {
    city: 'Windsor',
    county_fips: 17173,
    county_fips_all: '17173|17139',
    county: 'Shelby',
    county_names_all: 'Shelby|Moultrie',
    county_weights: '{"17173": 87.66, "17139": 12.34}',
    density: 8.1,
    imprecise: false,
    latitude: 39.4397,
    longitude: -88.60495,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61957',
  },
  {
    city: 'Alhambra',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 38.87971,
    longitude: -89.74562,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62001',
  },
  {
    city: 'Alton',
    county_fips: 17119,
    county_fips_all: '17119|17117',
    county: 'Madison',
    county_names_all: 'Madison|Macoupin',
    county_weights: '{"17119": 92.97, "17117": 7.03}',
    density: 276.3,
    imprecise: false,
    latitude: 38.93988,
    longitude: -90.12829,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62002',
  },
  {
    city: 'Batchtown',
    county_fips: 17013,
    county_fips_all: '17013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"17013": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 39.06433,
    longitude: -90.66714,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62006',
  },
  {
    city: 'Benld',
    county_fips: 17117,
    county_fips_all: '17117',
    county: 'Macoupin',
    county_names_all: 'Macoupin',
    county_weights: '{"17117": 100}',
    density: 231.4,
    imprecise: false,
    latitude: 39.09351,
    longitude: -89.79856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62009',
  },
  {
    city: 'Bethalto',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 200.5,
    imprecise: false,
    latitude: 38.91944,
    longitude: -90.04789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62010',
  },
  {
    city: 'Bingham',
    county_fips: 17051,
    county_fips_all: '17051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"17051": 100}',
    density: 3,
    imprecise: false,
    latitude: 39.12862,
    longitude: -89.21755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62011',
  },
  {
    city: 'Brighton',
    county_fips: 17083,
    county_fips_all: '17083|17117|17119',
    county: 'Jersey',
    county_names_all: 'Jersey|Macoupin|Madison',
    county_weights: '{"17083": 49.9, "17117": 44.71, "17119": 5.39}',
    density: 42.7,
    imprecise: false,
    latitude: 39.04225,
    longitude: -90.15027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62012',
  },
  {
    city: 'Brussels',
    county_fips: 17013,
    county_fips_all: '17013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"17013": 100}',
    density: 10,
    imprecise: false,
    latitude: 38.96421,
    longitude: -90.56518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62013',
  },
  {
    city: 'Bunker Hill',
    county_fips: 17117,
    county_fips_all: '17117',
    county: 'Macoupin',
    county_names_all: 'Macoupin',
    county_weights: '{"17117": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 39.04313,
    longitude: -89.94999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62014',
  },
  {
    city: 'Butler',
    county_fips: 17135,
    county_fips_all: '17135',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"17135": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 39.22011,
    longitude: -89.54203,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62015',
  },
  {
    city: 'Carrollton',
    county_fips: 17061,
    county_fips_all: '17061',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"17061": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 39.29517,
    longitude: -90.41462,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62016',
  },
  {
    city: 'Coffeen',
    county_fips: 17135,
    county_fips_all: '17135|17005',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Bond',
    county_weights: '{"17135": 93.97, "17005": 6.03}',
    density: 12.3,
    imprecise: false,
    latitude: 39.06597,
    longitude: -89.36945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62017',
  },
  {
    city: 'Cottage Hills',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 370,
    imprecise: false,
    latitude: 38.90847,
    longitude: -90.08574,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62018',
  },
  {
    city: 'Donnellson',
    county_fips: 17005,
    county_fips_all: '17005|17135',
    county: 'Bond',
    county_names_all: 'Bond|Montgomery',
    county_weights: '{"17005": 65.06, "17135": 34.94}',
    density: 4.2,
    imprecise: false,
    latitude: 39.01598,
    longitude: -89.45195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62019',
  },
  {
    city: 'Dorsey',
    county_fips: 17119,
    county_fips_all: '17119|17117',
    county: 'Madison',
    county_names_all: 'Madison|Macoupin',
    county_weights: '{"17119": 97.68, "17117": 2.32}',
    density: 16.6,
    imprecise: false,
    latitude: 38.97797,
    longitude: -89.981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62021',
  },
  {
    city: 'Dow',
    county_fips: 17083,
    county_fips_all: '17083',
    county: 'Jersey',
    county_names_all: 'Jersey',
    county_weights: '{"17083": 100}',
    density: 20.6,
    imprecise: false,
    latitude: 39.00139,
    longitude: -90.32972,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62022',
  },
  {
    city: 'Eagarville',
    county_fips: 17117,
    county_fips_all: '17117',
    county: 'Macoupin',
    county_names_all: 'Macoupin',
    county_weights: '{"17117": 100}',
    density: 68.6,
    imprecise: false,
    latitude: 39.10794,
    longitude: -89.78278,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62023',
  },
  {
    city: 'East Alton',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 684.1,
    imprecise: false,
    latitude: 38.88343,
    longitude: -90.08879,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62024',
  },
  {
    city: 'Edwardsville',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 122.2,
    imprecise: false,
    latitude: 38.83004,
    longitude: -89.93298,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62025',
  },
  {
    city: 'Eldred',
    county_fips: 17061,
    county_fips_all: '17061',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"17061": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 39.24686,
    longitude: -90.55725,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62027',
  },
  {
    city: 'Elsah',
    county_fips: 17083,
    county_fips_all: '17083',
    county: 'Jersey',
    county_names_all: 'Jersey',
    county_weights: '{"17083": 100}',
    density: 89.3,
    imprecise: false,
    latitude: 38.95932,
    longitude: -90.35353,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62028',
  },
  {
    city: 'Fidelity',
    county_fips: 17083,
    county_fips_all: '17083',
    county: 'Jersey',
    county_names_all: 'Jersey',
    county_weights: '{"17083": 100}',
    density: 270.6,
    imprecise: false,
    latitude: 39.15463,
    longitude: -90.16445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62030',
  },
  {
    city: 'Fieldon',
    county_fips: 17083,
    county_fips_all: '17083|17061',
    county: 'Jersey',
    county_names_all: 'Jersey|Greene',
    county_weights: '{"17083": 99.77, "17061": 0.23}',
    density: 3.3,
    imprecise: false,
    latitude: 39.1123,
    longitude: -90.53355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62031',
  },
  {
    city: 'Fillmore',
    county_fips: 17135,
    county_fips_all: '17135|17051',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Fayette',
    county_weights: '{"17135": 97.05, "17051": 2.95}',
    density: 6.3,
    imprecise: false,
    latitude: 39.1158,
    longitude: -89.28833,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62032',
  },
  {
    city: 'Gillespie',
    county_fips: 17117,
    county_fips_all: '17117',
    county: 'Macoupin',
    county_names_all: 'Macoupin',
    county_weights: '{"17117": 100}',
    density: 35.4,
    imprecise: false,
    latitude: 39.13561,
    longitude: -89.84447,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62033',
  },
  {
    city: 'Glen Carbon',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 419.1,
    imprecise: false,
    latitude: 38.75639,
    longitude: -89.96897,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62034',
  },
  {
    city: 'Godfrey',
    county_fips: 17119,
    county_fips_all: '17119|17083',
    county: 'Madison',
    county_names_all: 'Madison|Jersey',
    county_weights: '{"17119": 68.23, "17083": 31.77}',
    density: 140.2,
    imprecise: false,
    latitude: 38.96375,
    longitude: -90.23917,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62035',
  },
  {
    city: 'Golden Eagle',
    county_fips: 17013,
    county_fips_all: '17013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"17013": 100}',
    density: 7,
    imprecise: false,
    latitude: 38.91866,
    longitude: -90.59079,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62036',
  },
  {
    city: 'Grafton',
    county_fips: 17083,
    county_fips_all: '17083',
    county: 'Jersey',
    county_names_all: 'Jersey',
    county_weights: '{"17083": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 39.00826,
    longitude: -90.4664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62037',
  },
  {
    city: 'Granite City',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 391.1,
    imprecise: false,
    latitude: 38.71592,
    longitude: -90.10078,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62040',
  },
  {
    city: 'Greenfield',
    county_fips: 17061,
    county_fips_all: '17061|17117',
    county: 'Greene',
    county_names_all: 'Greene|Macoupin',
    county_weights: '{"17061": 80.74, "17117": 19.26}',
    density: 7.4,
    imprecise: false,
    latitude: 39.36618,
    longitude: -90.20907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62044',
  },
  {
    city: 'Hamburg',
    county_fips: 17013,
    county_fips_all: '17013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"17013": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 39.26297,
    longitude: -90.70921,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62045',
  },
  {
    city: 'Hamel',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 400.3,
    imprecise: false,
    latitude: 38.88935,
    longitude: -89.84397,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62046',
  },
  {
    city: 'Hardin',
    county_fips: 17013,
    county_fips_all: '17013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"17013": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 39.13314,
    longitude: -90.62273,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62047',
  },
  {
    city: 'Hartford',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 38.77004,
    longitude: -90.13895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62048',
  },
  {
    city: 'Hillsboro',
    county_fips: 17135,
    county_fips_all: '17135',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"17135": 100}',
    density: 37,
    imprecise: false,
    latitude: 39.1295,
    longitude: -89.48572,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62049',
  },
  {
    city: 'Hillview',
    county_fips: 17061,
    county_fips_all: '17061',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"17061": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 39.43734,
    longitude: -90.55544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62050',
  },
  {
    city: 'Irving',
    county_fips: 17135,
    county_fips_all: '17135',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"17135": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 39.20309,
    longitude: -89.40244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62051',
  },
  {
    city: 'Jerseyville',
    county_fips: 17083,
    county_fips_all: '17083|17061',
    county: 'Jersey',
    county_names_all: 'Jersey|Greene',
    county_weights: '{"17083": 98.81, "17061": 1.19}',
    density: 33,
    imprecise: false,
    latitude: 39.11179,
    longitude: -90.32004,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62052',
  },
  {
    city: 'Kampsville',
    county_fips: 17013,
    county_fips_all: '17013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"17013": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 39.31572,
    longitude: -90.65763,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62053',
  },
  {
    city: 'Kane',
    county_fips: 17061,
    county_fips_all: '17061|17083',
    county: 'Greene',
    county_names_all: 'Greene|Jersey',
    county_weights: '{"17061": 65.77, "17083": 34.23}',
    density: 3.5,
    imprecise: false,
    latitude: 39.2012,
    longitude: -90.34693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62054',
  },
  {
    city: 'Litchfield',
    county_fips: 17135,
    county_fips_all: '17135|17117',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Macoupin',
    county_weights: '{"17135": 72.38, "17117": 27.62}',
    density: 30.7,
    imprecise: false,
    latitude: 39.1765,
    longitude: -89.67165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62056',
  },
  {
    city: 'Livingston',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 321.2,
    imprecise: false,
    latitude: 38.96793,
    longitude: -89.76491,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62058',
  },
  {
    city: 'Lovejoy',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 428.5,
    imprecise: false,
    latitude: 38.65434,
    longitude: -90.17097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62059',
  },
  {
    city: 'Madison',
    county_fips: 17119,
    county_fips_all: '17119|17163',
    county: 'Madison',
    county_names_all: 'Madison|St. Clair',
    county_weights: '{"17119": 95.76, "17163": 4.24}',
    density: 388.9,
    imprecise: false,
    latitude: 38.67664,
    longitude: -90.14686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62060',
  },
  {
    city: 'Marine',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 24.8,
    imprecise: false,
    latitude: 38.79077,
    longitude: -89.77624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62061',
  },
  {
    city: 'Maryville',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 506.3,
    imprecise: false,
    latitude: 38.72719,
    longitude: -89.96253,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62062',
  },
  {
    city: 'Medora',
    county_fips: 17083,
    county_fips_all: '17083|17117|17061',
    county: 'Jersey',
    county_names_all: 'Jersey|Macoupin|Greene',
    county_weights: '{"17083": 51.73, "17117": 47.76, "17061": 0.51}',
    density: 5.9,
    imprecise: false,
    latitude: 39.1982,
    longitude: -90.14836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62063',
  },
  {
    city: 'Moro',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 48.9,
    imprecise: false,
    latitude: 38.92961,
    longitude: -89.98837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62067',
  },
  {
    city: 'Mount Olive',
    county_fips: 17117,
    county_fips_all: '17117|17135',
    county: 'Macoupin',
    county_names_all: 'Macoupin|Montgomery',
    county_weights: '{"17117": 97.3, "17135": 2.7}',
    density: 38.4,
    imprecise: false,
    latitude: 39.08892,
    longitude: -89.74044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62069',
  },
  {
    city: 'New Douglas',
    county_fips: 17119,
    county_fips_all: '17119|17005|17117|17135',
    county: 'Madison',
    county_names_all: 'Madison|Bond|Macoupin|Montgomery',
    county_weights:
      '{"17119": 75.04, "17005": 13.27, "17117": 7.99, "17135": 3.7}',
    density: 10.9,
    imprecise: false,
    latitude: 38.95594,
    longitude: -89.68338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62074',
  },
  {
    city: 'Nokomis',
    county_fips: 17135,
    county_fips_all: '17135|17021|17051',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Christian|Fayette',
    county_weights: '{"17135": 81.01, "17021": 18.45, "17051": 0.54}',
    density: 12,
    imprecise: false,
    latitude: 39.30143,
    longitude: -89.29676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62075',
  },
  {
    city: 'Ohlman',
    county_fips: 17135,
    county_fips_all: '17135',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"17135": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 39.34186,
    longitude: -89.23383,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 59,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62076',
  },
  {
    city: 'Panama',
    county_fips: 17135,
    county_fips_all: '17135|17005',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Bond',
    county_weights: '{"17135": 54.82, "17005": 45.18}',
    density: 65.8,
    imprecise: false,
    latitude: 39.03133,
    longitude: -89.51605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62077',
  },
  {
    city: 'Patterson',
    county_fips: 17061,
    county_fips_all: '17061',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"17061": 100}',
    density: 53.3,
    imprecise: false,
    latitude: 39.47984,
    longitude: -90.48686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62078',
  },
  {
    city: 'Piasa',
    county_fips: 17117,
    county_fips_all: '17117|17083',
    county: 'Macoupin',
    county_names_all: 'Macoupin|Jersey',
    county_weights: '{"17117": 81.44, "17083": 18.56}',
    density: 10.2,
    imprecise: false,
    latitude: 39.11457,
    longitude: -90.12642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62079',
  },
  {
    city: 'Ramsey',
    county_fips: 17051,
    county_fips_all: '17051|17135|17173',
    county: 'Fayette',
    county_names_all: 'Fayette|Montgomery|Shelby',
    county_weights: '{"17051": 94.17, "17135": 3.93, "17173": 1.9}',
    density: 10.6,
    imprecise: false,
    latitude: 39.14115,
    longitude: -89.10569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62080',
  },
  {
    city: 'Rockbridge',
    county_fips: 17061,
    county_fips_all: '17061',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"17061": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 39.26262,
    longitude: -90.23452,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62081',
  },
  {
    city: 'Roodhouse',
    county_fips: 17061,
    county_fips_all: '17061|17171|17137',
    county: 'Greene',
    county_names_all: 'Greene|Scott|Morgan',
    county_weights: '{"17061": 82.96, "17171": 16.21, "17137": 0.83}',
    density: 8.3,
    imprecise: false,
    latitude: 39.49392,
    longitude: -90.32157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62082',
  },
  {
    city: 'Rosamond',
    county_fips: 17021,
    county_fips_all: '17021|17135',
    county: 'Christian',
    county_names_all: 'Christian|Montgomery',
    county_weights: '{"17021": 61.76, "17135": 38.24}',
    density: 2.6,
    imprecise: false,
    latitude: 39.35122,
    longitude: -89.19842,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62083',
  },
  {
    city: 'Roxana',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 136.4,
    imprecise: false,
    latitude: 38.84082,
    longitude: -90.06365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62084',
  },
  {
    city: 'Sawyerville',
    county_fips: 17117,
    county_fips_all: '17117',
    county: 'Macoupin',
    county_names_all: 'Macoupin',
    county_weights: '{"17117": 100}',
    density: 83.2,
    imprecise: false,
    latitude: 39.07839,
    longitude: -89.80308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62085',
  },
  {
    city: 'Sorento',
    county_fips: 17005,
    county_fips_all: '17005|17135|17119',
    county: 'Bond',
    county_names_all: 'Bond|Montgomery|Madison',
    county_weights: '{"17005": 76.26, "17135": 20.82, "17119": 2.92}',
    density: 10.5,
    imprecise: false,
    latitude: 38.98302,
    longitude: -89.58556,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62086',
  },
  {
    city: 'South Roxana',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 239.9,
    imprecise: false,
    latitude: 38.81754,
    longitude: -90.06767,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62087',
  },
  {
    city: 'Staunton',
    county_fips: 17117,
    county_fips_all: '17117|17119',
    county: 'Macoupin',
    county_names_all: 'Macoupin|Madison',
    county_weights: '{"17117": 63.58, "17119": 36.42}',
    density: 56.3,
    imprecise: false,
    latitude: 39.01318,
    longitude: -89.79764,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62088',
  },
  {
    city: 'Taylor Springs',
    county_fips: 17135,
    county_fips_all: '17135',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"17135": 100}',
    density: 82.9,
    imprecise: false,
    latitude: 39.12111,
    longitude: -89.48673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62089',
  },
  {
    city: 'Venice',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 268.1,
    imprecise: false,
    latitude: 38.66925,
    longitude: -90.17044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62090',
  },
  {
    city: 'Walshville',
    county_fips: 17135,
    county_fips_all: '17135',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"17135": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 39.05594,
    longitude: -89.61222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62091',
  },
  {
    city: 'White Hall',
    county_fips: 17061,
    county_fips_all: '17061',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"17061": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 39.41839,
    longitude: -90.41291,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62092',
  },
  {
    city: 'Wilsonville',
    county_fips: 17117,
    county_fips_all: '17117',
    county: 'Macoupin',
    county_names_all: 'Macoupin',
    county_weights: '{"17117": 100}',
    density: 84.5,
    imprecise: false,
    latitude: 39.06858,
    longitude: -89.84573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62093',
  },
  {
    city: 'Witt',
    county_fips: 17135,
    county_fips_all: '17135',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"17135": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 39.2441,
    longitude: -89.34871,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62094',
  },
  {
    city: 'Wood River',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 582.8,
    imprecise: false,
    latitude: 38.86307,
    longitude: -90.07545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62095',
  },
  {
    city: 'Worden',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 27.9,
    imprecise: false,
    latitude: 38.93719,
    longitude: -89.85507,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62097',
  },
  {
    city: 'East Saint Louis',
    county_fips: 17163,
    county_fips_all: '17163|17119',
    county: 'St. Clair',
    county_names_all: 'St. Clair|Madison',
    county_weights: '{"17163": 96.15, "17119": 3.85}',
    density: 157.8,
    imprecise: false,
    latitude: 38.63567,
    longitude: -90.14162,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62201',
  },
  {
    city: 'East Saint Louis',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 373.5,
    imprecise: false,
    latitude: 38.60223,
    longitude: -90.07534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62203',
  },
  {
    city: 'East Saint Louis',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 339,
    imprecise: false,
    latitude: 38.63033,
    longitude: -90.09642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62204',
  },
  {
    city: 'East Saint Louis',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 392.3,
    imprecise: false,
    latitude: 38.60259,
    longitude: -90.11469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62205',
  },
  {
    city: 'East Saint Louis',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 344.1,
    imprecise: false,
    latitude: 38.56796,
    longitude: -90.16981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62206',
  },
  {
    city: 'East Saint Louis',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 434.9,
    imprecise: false,
    latitude: 38.58327,
    longitude: -90.12544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62207',
  },
  {
    city: 'Fairview Heights',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 484.9,
    imprecise: false,
    latitude: 38.59641,
    longitude: -90.00528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62208',
  },
  {
    city: 'Addieville',
    county_fips: 17189,
    county_fips_all: '17189',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"17189": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 38.37682,
    longitude: -89.60529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62214',
  },
  {
    city: 'Albers',
    county_fips: 17027,
    county_fips_all: '17027',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"17027": 100}',
    density: 66.8,
    imprecise: false,
    latitude: 38.50672,
    longitude: -89.60515,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62215',
  },
  {
    city: 'Aviston',
    county_fips: 17027,
    county_fips_all: '17027|17119',
    county: 'Clinton',
    county_names_all: 'Clinton|Madison',
    county_weights: '{"17027": 91.9, "17119": 8.1}',
    density: 50.8,
    imprecise: false,
    latitude: 38.62559,
    longitude: -89.60313,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62216',
  },
  {
    city: 'Baldwin',
    county_fips: 17157,
    county_fips_all: '17157',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"17157": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 38.1732,
    longitude: -89.83954,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62217',
  },
  {
    city: 'Bartelso',
    county_fips: 17027,
    county_fips_all: '17027',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"17027": 100}',
    density: 17,
    imprecise: false,
    latitude: 38.52069,
    longitude: -89.47738,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62218',
  },
  {
    city: 'Beckemeyer',
    county_fips: 17027,
    county_fips_all: '17027',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"17027": 100}',
    density: 450.1,
    imprecise: false,
    latitude: 38.60371,
    longitude: -89.43698,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62219',
  },
  {
    city: 'Belleville',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 256,
    imprecise: false,
    latitude: 38.47247,
    longitude: -89.98704,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62220',
  },
  {
    city: 'Belleville',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 329.8,
    imprecise: false,
    latitude: 38.51187,
    longitude: -89.89922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62221',
  },
  {
    city: 'Belleville',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 244.6,
    imprecise: false,
    latitude: 38.53491,
    longitude: -90.06027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62223',
  },
  {
    city: 'Scott Air Force Base',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 385.7,
    imprecise: false,
    latitude: 38.54065,
    longitude: -89.85503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62225',
  },
  {
    city: 'Belleville',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 786.3,
    imprecise: false,
    latitude: 38.53634,
    longitude: -90.00057,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62226',
  },
  {
    city: 'Breese',
    county_fips: 17027,
    county_fips_all: '17027',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"17027": 100}',
    density: 47.8,
    imprecise: false,
    latitude: 38.63855,
    longitude: -89.52742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62230',
  },
  {
    city: 'Carlyle',
    county_fips: 17027,
    county_fips_all: '17027',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"17027": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 38.64402,
    longitude: -89.32642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62231',
  },
  {
    city: 'Caseyville',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 212.6,
    imprecise: false,
    latitude: 38.63266,
    longitude: -90.00509,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62232',
  },
  {
    city: 'Chester',
    county_fips: 17157,
    county_fips_all: '17157',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"17157": 100}',
    density: 47.1,
    imprecise: false,
    latitude: 37.93719,
    longitude: -89.78842,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62233',
  },
  {
    city: 'Collinsville',
    county_fips: 17119,
    county_fips_all: '17119|17163',
    county: 'Madison',
    county_names_all: 'Madison|St. Clair',
    county_weights: '{"17119": 83.6, "17163": 16.4}',
    density: 327.9,
    imprecise: false,
    latitude: 38.68214,
    longitude: -89.9815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62234',
  },
  {
    city: 'Columbia',
    county_fips: 17133,
    county_fips_all: '17133|17163',
    county: 'Monroe',
    county_names_all: 'Monroe|St. Clair',
    county_weights: '{"17133": 82.69, "17163": 17.31}',
    density: 90.6,
    imprecise: false,
    latitude: 38.43391,
    longitude: -90.21141,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62236',
  },
  {
    city: 'Coulterville',
    county_fips: 17145,
    county_fips_all: '17145|17189|17157',
    county: 'Perry',
    county_names_all: 'Perry|Washington|Randolph',
    county_weights: '{"17145": 49.24, "17189": 25.52, "17157": 25.24}',
    density: 9.9,
    imprecise: false,
    latitude: 38.1916,
    longitude: -89.57046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62237',
  },
  {
    city: 'Cutler',
    county_fips: 17145,
    county_fips_all: '17145',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"17145": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 38.04499,
    longitude: -89.5319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62238',
  },
  {
    city: 'Dupo',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 191.2,
    imprecise: false,
    latitude: 38.528,
    longitude: -90.1803,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62239',
  },
  {
    city: 'East Carondelet',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 46.6,
    imprecise: false,
    latitude: 38.52084,
    longitude: -90.21011,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62240',
  },
  {
    city: 'Ellis Grove',
    county_fips: 17157,
    county_fips_all: '17157',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"17157": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 38.01474,
    longitude: -89.88845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62241',
  },
  {
    city: 'Evansville',
    county_fips: 17157,
    county_fips_all: '17157',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"17157": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 38.09257,
    longitude: -89.94339,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62242',
  },
  {
    city: 'Freeburg',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 47.9,
    imprecise: false,
    latitude: 38.41841,
    longitude: -89.88978,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62243',
  },
  {
    city: 'Fults',
    county_fips: 17133,
    county_fips_all: '17133',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"17133": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 38.19142,
    longitude: -90.1965,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62244',
  },
  {
    city: 'Germantown',
    county_fips: 17027,
    county_fips_all: '17027',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"17027": 100}',
    density: 39.1,
    imprecise: false,
    latitude: 38.54783,
    longitude: -89.57446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62245',
  },
  {
    city: 'Greenville',
    county_fips: 17005,
    county_fips_all: '17005',
    county: 'Bond',
    county_names_all: 'Bond',
    county_weights: '{"17005": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 38.88834,
    longitude: -89.42533,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62246',
  },
  {
    city: 'Hecker',
    county_fips: 17133,
    county_fips_all: '17133',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"17133": 100}',
    density: 798.8,
    imprecise: false,
    latitude: 38.30543,
    longitude: -89.99341,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62248',
  },
  {
    city: 'Highland',
    county_fips: 17119,
    county_fips_all: '17119|17027|17005',
    county: 'Madison',
    county_names_all: 'Madison|Clinton|Bond',
    county_weights: '{"17119": 90.38, "17027": 7.35, "17005": 2.27}',
    density: 70.5,
    imprecise: false,
    latitude: 38.75469,
    longitude: -89.66436,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62249',
  },
  {
    city: 'Hoffman',
    county_fips: 17027,
    county_fips_all: '17027',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"17027": 100}',
    density: 461.3,
    imprecise: false,
    latitude: 38.54042,
    longitude: -89.26436,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62250',
  },
  {
    city: 'Keyesport',
    county_fips: 17005,
    county_fips_all: '17005|17051|17027',
    county: 'Bond',
    county_names_all: 'Bond|Fayette|Clinton',
    county_weights: '{"17005": 80.1, "17051": 12.94, "17027": 6.96}',
    density: 11.5,
    imprecise: false,
    latitude: 38.77554,
    longitude: -89.29738,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62253',
  },
  {
    city: 'Lebanon',
    county_fips: 17163,
    county_fips_all: '17163|17119',
    county: 'St. Clair',
    county_names_all: 'St. Clair|Madison',
    county_weights: '{"17163": 98.27, "17119": 1.73}',
    density: 63.4,
    imprecise: false,
    latitude: 38.6098,
    longitude: -89.81901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62254',
  },
  {
    city: 'Lenzburg',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 15.9,
    imprecise: false,
    latitude: 38.31244,
    longitude: -89.77842,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62255',
  },
  {
    city: 'Maeystown',
    county_fips: 17133,
    county_fips_all: '17133',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"17133": 100}',
    density: 114.8,
    imprecise: false,
    latitude: 38.22623,
    longitude: -90.23152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62256',
  },
  {
    city: 'Marissa',
    county_fips: 17163,
    county_fips_all: '17163|17189|17157',
    county: 'St. Clair',
    county_names_all: 'St. Clair|Washington|Randolph',
    county_weights: '{"17163": 57.41, "17189": 35.25, "17157": 7.34}',
    density: 9.8,
    imprecise: false,
    latitude: 38.28048,
    longitude: -89.73262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62257',
  },
  {
    city: 'Mascoutah',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 53.5,
    imprecise: false,
    latitude: 38.46014,
    longitude: -89.77287,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62258',
  },
  {
    city: 'Millstadt',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 58.7,
    imprecise: false,
    latitude: 38.46097,
    longitude: -90.09891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62260',
  },
  {
    city: 'Modoc',
    county_fips: 17157,
    county_fips_all: '17157',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"17157": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 38.01218,
    longitude: -89.99774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62261',
  },
  {
    city: 'Mulberry Grove',
    county_fips: 17005,
    county_fips_all: '17005|17051',
    county: 'Bond',
    county_names_all: 'Bond|Fayette',
    county_weights: '{"17005": 60.62, "17051": 39.38}',
    density: 11.4,
    imprecise: false,
    latitude: 38.9371,
    longitude: -89.26916,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62262',
  },
  {
    city: 'Nashville',
    county_fips: 17189,
    county_fips_all: '17189|17145',
    county: 'Washington',
    county_names_all: 'Washington|Perry',
    county_weights: '{"17189": 99.24, "17145": 0.76}',
    density: 12.6,
    imprecise: false,
    latitude: 38.33168,
    longitude: -89.39706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62263',
  },
  {
    city: 'New Athens',
    county_fips: 17163,
    county_fips_all: '17163|17133',
    county: 'St. Clair',
    county_names_all: 'St. Clair|Monroe',
    county_weights: '{"17163": 94.43, "17133": 5.57}',
    density: 18.2,
    imprecise: false,
    latitude: 38.31612,
    longitude: -89.90721,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62264',
  },
  {
    city: 'New Baden',
    county_fips: 17027,
    county_fips_all: '17027|17163',
    county: 'Clinton',
    county_names_all: 'Clinton|St. Clair',
    county_weights: '{"17027": 86.38, "17163": 13.62}',
    density: 52.3,
    imprecise: false,
    latitude: 38.50808,
    longitude: -89.67797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62265',
  },
  {
    city: 'New Memphis',
    county_fips: 17027,
    county_fips_all: '17027',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"17027": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 38.47481,
    longitude: -89.64988,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62266',
  },
  {
    city: 'Oakdale',
    county_fips: 17189,
    county_fips_all: '17189|17145',
    county: 'Washington',
    county_names_all: 'Washington|Perry',
    county_weights: '{"17189": 95.21, "17145": 4.79}',
    density: 5.5,
    imprecise: false,
    latitude: 38.27208,
    longitude: -89.52612,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62268',
  },
  {
    city: "O'Fallon",
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 464.9,
    imprecise: false,
    latitude: 38.59844,
    longitude: -89.91294,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62269',
  },
  {
    city: 'Okawville',
    county_fips: 17189,
    county_fips_all: '17189',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"17189": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 38.44028,
    longitude: -89.52209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62271',
  },
  {
    city: 'Percy',
    county_fips: 17157,
    county_fips_all: '17157|17145|17077',
    county: 'Randolph',
    county_names_all: 'Randolph|Perry|Jackson',
    county_weights: '{"17157": 81.89, "17145": 16.97, "17077": 1.14}',
    density: 18.2,
    imprecise: false,
    latitude: 38.00241,
    longitude: -89.61562,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62272',
  },
  {
    city: 'Pierron',
    county_fips: 17005,
    county_fips_all: '17005',
    county: 'Bond',
    county_names_all: 'Bond',
    county_weights: '{"17005": 100}',
    density: 87.3,
    imprecise: false,
    latitude: 38.78673,
    longitude: -89.58389,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62273',
  },
  {
    city: 'Pinckneyville',
    county_fips: 17145,
    county_fips_all: '17145|17077',
    county: 'Perry',
    county_names_all: 'Perry|Jackson',
    county_weights: '{"17145": 99.08, "17077": 0.92}',
    density: 21.7,
    imprecise: false,
    latitude: 38.09312,
    longitude: -89.40064,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62274',
  },
  {
    city: 'Pocahontas',
    county_fips: 17005,
    county_fips_all: '17005|17119|17027',
    county: 'Bond',
    county_names_all: 'Bond|Madison|Clinton',
    county_weights: '{"17005": 76.13, "17119": 17.45, "17027": 6.42}',
    density: 11.7,
    imprecise: false,
    latitude: 38.81507,
    longitude: -89.54496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62275',
  },
  {
    city: 'Prairie Du Rocher',
    county_fips: 17157,
    county_fips_all: '17157|17133',
    county: 'Randolph',
    county_names_all: 'Randolph|Monroe',
    county_weights: '{"17157": 62.0, "17133": 38.0}',
    density: 5.6,
    imprecise: false,
    latitude: 38.09844,
    longitude: -90.11081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62277',
  },
  {
    city: 'Red Bud',
    county_fips: 17133,
    county_fips_all: '17133|17157',
    county: 'Monroe',
    county_names_all: 'Monroe|Randolph',
    county_weights: '{"17133": 53.82, "17157": 46.18}',
    density: 23.1,
    imprecise: false,
    latitude: 38.20528,
    longitude: -89.99116,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62278',
  },
  {
    city: 'Renault',
    county_fips: 17133,
    county_fips_all: '17133',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"17133": 100}',
    density: 26.2,
    imprecise: false,
    latitude: 38.13796,
    longitude: -90.13695,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62279',
  },
  {
    city: 'Rockwood',
    county_fips: 17077,
    county_fips_all: '17077|17157',
    county: 'Jackson',
    county_names_all: 'Jackson|Randolph',
    county_weights: '{"17077": 55.27, "17157": 44.73}',
    density: 3.1,
    imprecise: false,
    latitude: 37.83179,
    longitude: -89.65952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62280',
  },
  {
    city: 'Saint Jacob',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 35.4,
    imprecise: false,
    latitude: 38.70405,
    longitude: -89.78288,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62281',
  },
  {
    city: 'Saint Libory',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 113.2,
    imprecise: false,
    latitude: 38.35644,
    longitude: -89.71334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62282',
  },
  {
    city: 'Smithboro',
    county_fips: 17005,
    county_fips_all: '17005',
    county: 'Bond',
    county_names_all: 'Bond',
    county_weights: '{"17005": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 38.86867,
    longitude: -89.31107,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62284',
  },
  {
    city: 'Smithton',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 100.8,
    imprecise: false,
    latitude: 38.38845,
    longitude: -90.00773,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62285',
  },
  {
    city: 'Sparta',
    county_fips: 17157,
    county_fips_all: '17157',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"17157": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 38.11756,
    longitude: -89.7154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62286',
  },
  {
    city: 'Steeleville',
    county_fips: 17157,
    county_fips_all: '17157',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"17157": 100}',
    density: 29.6,
    imprecise: false,
    latitude: 37.99267,
    longitude: -89.69106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62288',
  },
  {
    city: 'Summerfield',
    county_fips: 17163,
    county_fips_all: '17163',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"17163": 100}',
    density: 70.4,
    imprecise: false,
    latitude: 38.59788,
    longitude: -89.75096,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62289',
  },
  {
    city: 'Tilden',
    county_fips: 17157,
    county_fips_all: '17157',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"17157": 100}',
    density: 174.2,
    imprecise: false,
    latitude: 38.21299,
    longitude: -89.68261,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62292',
  },
  {
    city: 'Trenton',
    county_fips: 17027,
    county_fips_all: '17027|17163|17119',
    county: 'Clinton',
    county_names_all: 'Clinton|St. Clair|Madison',
    county_weights: '{"17027": 46.37, "17163": 37.14, "17119": 16.5}',
    density: 32.9,
    imprecise: false,
    latitude: 38.61838,
    longitude: -89.69748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62293',
  },
  {
    city: 'Troy',
    county_fips: 17119,
    county_fips_all: '17119|17163',
    county: 'Madison',
    county_names_all: 'Madison|St. Clair',
    county_weights: '{"17119": 97.2, "17163": 2.8}',
    density: 200.6,
    imprecise: false,
    latitude: 38.70374,
    longitude: -89.87242,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62294',
  },
  {
    city: 'Valmeyer',
    county_fips: 17133,
    county_fips_all: '17133',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"17133": 100}',
    density: 8,
    imprecise: false,
    latitude: 38.27126,
    longitude: -90.30895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62295',
  },
  {
    city: 'Walsh',
    county_fips: 17157,
    county_fips_all: '17157',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"17157": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 38.04938,
    longitude: -89.81239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62297',
  },
  {
    city: 'Waterloo',
    county_fips: 17133,
    county_fips_all: '17133|17163',
    county: 'Monroe',
    county_names_all: 'Monroe|St. Clair',
    county_weights: '{"17133": 90.87, "17163": 9.13}',
    density: 49.2,
    imprecise: false,
    latitude: 38.30906,
    longitude: -90.15132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62298',
  },
  {
    city: 'Quincy',
    county_fips: 17001,
    county_fips_all: '17001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"17001": 100}',
    density: 1062.7,
    imprecise: false,
    latitude: 39.93139,
    longitude: -91.38741,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62301',
  },
  {
    city: 'Quincy',
    county_fips: 17001,
    county_fips_all: '17001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"17001": 100}',
    density: 52.8,
    imprecise: false,
    latitude: 39.92915,
    longitude: -91.34441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62305',
  },
  {
    city: 'Augusta',
    county_fips: 17067,
    county_fips_all: '17067|17169|17001',
    county: 'Hancock',
    county_names_all: 'Hancock|Schuyler|Adams',
    county_weights: '{"17067": 48.57, "17169": 39.9, "17001": 11.53}',
    density: 6.9,
    imprecise: false,
    latitude: 40.22195,
    longitude: -90.9212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62311',
  },
  {
    city: 'Barry',
    county_fips: 17149,
    county_fips_all: '17149|17001',
    county: 'Pike',
    county_names_all: 'Pike|Adams',
    county_weights: '{"17149": 77.49, "17001": 22.51}',
    density: 8,
    imprecise: false,
    latitude: 39.71035,
    longitude: -91.02518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62312',
  },
  {
    city: 'Basco',
    county_fips: 17067,
    county_fips_all: '17067',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"17067": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 40.31782,
    longitude: -91.2251,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62313',
  },
  {
    city: 'Baylis',
    county_fips: 17149,
    county_fips_all: '17149|17001',
    county: 'Pike',
    county_names_all: 'Pike|Adams',
    county_weights: '{"17149": 84.57, "17001": 15.43}',
    density: 3.2,
    imprecise: false,
    latitude: 39.76967,
    longitude: -90.89204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62314',
  },
  {
    city: 'Bowen',
    county_fips: 17067,
    county_fips_all: '17067|17001',
    county: 'Hancock',
    county_names_all: 'Hancock|Adams',
    county_weights: '{"17067": 89.08, "17001": 10.92}',
    density: 6.1,
    imprecise: false,
    latitude: 40.23341,
    longitude: -91.05495,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62316',
  },
  {
    city: 'Camden',
    county_fips: 17169,
    county_fips_all: '17169',
    county: 'Schuyler',
    county_names_all: 'Schuyler',
    county_weights: '{"17169": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 40.15293,
    longitude: -90.72997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62319',
  },
  {
    city: 'Camp Point',
    county_fips: 17001,
    county_fips_all: '17001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"17001": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 40.02343,
    longitude: -91.08295,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62320',
  },
  {
    city: 'Carthage',
    county_fips: 17067,
    county_fips_all: '17067',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"17067": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 40.40948,
    longitude: -91.10606,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62321',
  },
  {
    city: 'Chambersburg',
    county_fips: 17149,
    county_fips_all: '17149|17009',
    county: 'Pike',
    county_names_all: 'Pike|Brown',
    county_weights: '{"17149": 98.21, "17009": 1.79}',
    density: 1.8,
    imprecise: false,
    latitude: 39.81306,
    longitude: -90.68607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62323',
  },
  {
    city: 'Clayton',
    county_fips: 17001,
    county_fips_all: '17001|17009',
    county: 'Adams',
    county_names_all: 'Adams|Brown',
    county_weights: '{"17001": 92.85, "17009": 7.15}',
    density: 4.9,
    imprecise: false,
    latitude: 39.9901,
    longitude: -90.96302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62324',
  },
  {
    city: 'Coatsburg',
    county_fips: 17001,
    county_fips_all: '17001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"17001": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 40.05307,
    longitude: -91.16564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62325',
  },
  {
    city: 'Colchester',
    county_fips: 17109,
    county_fips_all: '17109|17067',
    county: 'McDonough',
    county_names_all: 'McDonough|Hancock',
    county_weights: '{"17109": 95.04, "17067": 4.96}',
    density: 11.2,
    imprecise: false,
    latitude: 40.42248,
    longitude: -90.81501,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62326',
  },
  {
    city: 'Dallas City',
    county_fips: 17067,
    county_fips_all: '17067|17071',
    county: 'Hancock',
    county_names_all: 'Hancock|Henderson',
    county_weights: '{"17067": 90.09, "17071": 9.91}',
    density: 6.6,
    imprecise: false,
    latitude: 40.57217,
    longitude: -91.12187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62330',
  },
  {
    city: 'Elvaston',
    county_fips: 17067,
    county_fips_all: '17067',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"17067": 100}',
    density: 77.5,
    imprecise: false,
    latitude: 40.39598,
    longitude: -91.24912,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62334',
  },
  {
    city: 'Ferris',
    county_fips: 17067,
    county_fips_all: '17067',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"17067": 100}',
    density: 205.3,
    imprecise: false,
    latitude: 40.46759,
    longitude: -91.17333,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62336',
  },
  {
    city: 'Fowler',
    county_fips: 17001,
    county_fips_all: '17001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"17001": 100}',
    density: 12,
    imprecise: false,
    latitude: 39.99309,
    longitude: -91.23889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62338',
  },
  {
    city: 'Golden',
    county_fips: 17001,
    county_fips_all: '17001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"17001": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 40.12898,
    longitude: -91.04196,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62339',
  },
  {
    city: 'Griggsville',
    county_fips: 17149,
    county_fips_all: '17149',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"17149": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 39.7228,
    longitude: -90.72588,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62340',
  },
  {
    city: 'Hamilton',
    county_fips: 17067,
    county_fips_all: '17067',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"17067": 100}',
    density: 28.5,
    imprecise: false,
    latitude: 40.42566,
    longitude: -91.30555,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62341',
  },
  {
    city: 'Hull',
    county_fips: 17149,
    county_fips_all: '17149|17001',
    county: 'Pike',
    county_names_all: 'Pike|Adams',
    county_weights: '{"17149": 94.71, "17001": 5.29}',
    density: 3.1,
    imprecise: false,
    latitude: 39.70275,
    longitude: -91.2418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62343',
  },
  {
    city: 'Huntsville',
    county_fips: 17169,
    county_fips_all: '17169',
    county: 'Schuyler',
    county_names_all: 'Schuyler',
    county_weights: '{"17169": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 40.1799,
    longitude: -90.82497,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62344',
  },
  {
    city: 'Kinderhook',
    county_fips: 17149,
    county_fips_all: '17149',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"17149": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 39.70655,
    longitude: -91.12758,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62345',
  },
  {
    city: 'La Prairie',
    county_fips: 17001,
    county_fips_all: '17001|17169',
    county: 'Adams',
    county_names_all: 'Adams|Schuyler',
    county_weights: '{"17001": 61.97, "17169": 38.03}',
    density: 1.5,
    imprecise: false,
    latitude: 40.14367,
    longitude: -90.93418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62346',
  },
  {
    city: 'Liberty',
    county_fips: 17001,
    county_fips_all: '17001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"17001": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 39.86648,
    longitude: -91.08905,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62347',
  },
  {
    city: 'Lima',
    county_fips: 17001,
    county_fips_all: '17001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"17001": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 40.18836,
    longitude: -91.37126,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62348',
  },
  {
    city: 'Loraine',
    county_fips: 17001,
    county_fips_all: '17001|17067',
    county: 'Adams',
    county_names_all: 'Adams|Hancock',
    county_weights: '{"17001": 90.47, "17067": 9.53}',
    density: 4.3,
    imprecise: false,
    latitude: 40.16958,
    longitude: -91.19986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62349',
  },
  {
    city: 'Mendon',
    county_fips: 17001,
    county_fips_all: '17001|17067',
    county: 'Adams',
    county_names_all: 'Adams|Hancock',
    county_weights: '{"17001": 95.13, "17067": 4.87}',
    density: 10.2,
    imprecise: false,
    latitude: 40.11374,
    longitude: -91.26751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62351',
  },
  {
    city: 'Milton',
    county_fips: 17149,
    county_fips_all: '17149',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"17149": 100}',
    density: 83.6,
    imprecise: false,
    latitude: 39.56818,
    longitude: -90.65455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62352',
  },
  {
    city: 'Mount Sterling',
    county_fips: 17009,
    county_fips_all: '17009|17149|17169',
    county: 'Brown',
    county_names_all: 'Brown|Pike|Schuyler',
    county_weights: '{"17009": 98.1, "17149": 1.21, "17169": 0.69}',
    density: 10.3,
    imprecise: false,
    latitude: 39.97277,
    longitude: -90.75735,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62353',
  },
  {
    city: 'Nauvoo',
    county_fips: 17067,
    county_fips_all: '17067',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"17067": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 40.52087,
    longitude: -91.33305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62354',
  },
  {
    city: 'Nebo',
    county_fips: 17149,
    county_fips_all: '17149|17013',
    county: 'Pike',
    county_names_all: 'Pike|Calhoun',
    county_weights: '{"17149": 52.04, "17013": 47.96}',
    density: 4.5,
    imprecise: false,
    latitude: 39.40963,
    longitude: -90.77936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62355',
  },
  {
    city: 'New Canton',
    county_fips: 17149,
    county_fips_all: '17149',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"17149": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 39.60092,
    longitude: -91.08508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62356',
  },
  {
    city: 'New Salem',
    county_fips: 17149,
    county_fips_all: '17149',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"17149": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 39.68671,
    longitude: -90.86374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62357',
  },
  {
    city: 'Niota',
    county_fips: 17067,
    county_fips_all: '17067',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"17067": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 40.58527,
    longitude: -91.26113,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62358',
  },
  {
    city: 'Paloma',
    county_fips: 17001,
    county_fips_all: '17001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"17001": 100}',
    density: 20.3,
    imprecise: false,
    latitude: 40.03239,
    longitude: -91.20851,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62359',
  },
  {
    city: 'Payson',
    county_fips: 17001,
    county_fips_all: '17001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"17001": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 39.81731,
    longitude: -91.26143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62360',
  },
  {
    city: 'Pearl',
    county_fips: 17149,
    county_fips_all: '17149',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"17149": 100}',
    density: 2,
    imprecise: false,
    latitude: 39.48734,
    longitude: -90.64191,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62361',
  },
  {
    city: 'Perry',
    county_fips: 17149,
    county_fips_all: '17149',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"17149": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 39.77618,
    longitude: -90.76429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62362',
  },
  {
    city: 'Pittsfield',
    county_fips: 17149,
    county_fips_all: '17149',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"17149": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 39.59163,
    longitude: -90.7784,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62363',
  },
  {
    city: 'Plainville',
    county_fips: 17001,
    county_fips_all: '17001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"17001": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 39.79559,
    longitude: -91.16018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62365',
  },
  {
    city: 'Pleasant Hill',
    county_fips: 17149,
    county_fips_all: '17149',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"17149": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 39.46253,
    longitude: -90.89402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62366',
  },
  {
    city: 'Plymouth',
    county_fips: 17067,
    county_fips_all: '17067|17109|17169',
    county: 'Hancock',
    county_names_all: 'Hancock|McDonough|Schuyler',
    county_weights: '{"17067": 37.69, "17109": 34.51, "17169": 27.8}',
    density: 4,
    imprecise: false,
    latitude: 40.30325,
    longitude: -90.86687,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62367',
  },
  {
    city: 'Rockport',
    county_fips: 17149,
    county_fips_all: '17149',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"17149": 100}',
    density: 2,
    imprecise: false,
    latitude: 39.51818,
    longitude: -90.99881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62370',
  },
  {
    city: 'Sutter',
    county_fips: 17067,
    county_fips_all: '17067|17001',
    county: 'Hancock',
    county_names_all: 'Hancock|Adams',
    county_weights: '{"17067": 96.52, "17001": 3.48}',
    density: 1.8,
    imprecise: false,
    latitude: 40.23643,
    longitude: -91.35863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62373',
  },
  {
    city: 'Tennessee',
    county_fips: 17067,
    county_fips_all: '17067|17109',
    county: 'Hancock',
    county_names_all: 'Hancock|McDonough',
    county_weights: '{"17067": 50.93, "17109": 49.07}',
    density: 3.5,
    imprecise: false,
    latitude: 40.40765,
    longitude: -90.91052,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62374',
  },
  {
    city: 'Timewell',
    county_fips: 17009,
    county_fips_all: '17009',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"17009": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 39.99782,
    longitude: -90.87176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62375',
  },
  {
    city: 'Ursa',
    county_fips: 17001,
    county_fips_all: '17001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"17001": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 40.1148,
    longitude: -91.40662,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62376',
  },
  {
    city: 'Versailles',
    county_fips: 17009,
    county_fips_all: '17009',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"17009": 100}',
    density: 5,
    imprecise: false,
    latitude: 39.89602,
    longitude: -90.63652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62378',
  },
  {
    city: 'Warsaw',
    county_fips: 17067,
    county_fips_all: '17067|17001',
    county: 'Hancock',
    county_names_all: 'Hancock|Adams',
    county_weights: '{"17067": 77.2, "17001": 22.8}',
    density: 7.3,
    imprecise: false,
    latitude: 40.26867,
    longitude: -91.4061,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62379',
  },
  {
    city: 'West Point',
    county_fips: 17067,
    county_fips_all: '17067',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"17067": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 40.24249,
    longitude: -91.19174,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62380',
  },
  {
    city: 'Effingham',
    county_fips: 17049,
    county_fips_all: '17049|17173',
    county: 'Effingham',
    county_names_all: 'Effingham|Shelby',
    county_weights: '{"17049": 97.24, "17173": 2.76}',
    density: 71.6,
    imprecise: false,
    latitude: 39.11843,
    longitude: -88.56467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62401',
  },
  {
    city: 'Allendale',
    county_fips: 17185,
    county_fips_all: '17185',
    county: 'Wabash',
    county_names_all: 'Wabash',
    county_weights: '{"17185": 100}',
    density: 12,
    imprecise: false,
    latitude: 38.53254,
    longitude: -87.72783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62410',
  },
  {
    city: 'Altamont',
    county_fips: 17049,
    county_fips_all: '17049|17051',
    county: 'Effingham',
    county_names_all: 'Effingham|Fayette',
    county_weights: '{"17049": 96.63, "17051": 3.37}',
    density: 19.2,
    imprecise: false,
    latitude: 39.06865,
    longitude: -88.72936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62411',
  },
  {
    city: 'Annapolis',
    county_fips: 17033,
    county_fips_all: '17033|17023',
    county: 'Crawford',
    county_names_all: 'Crawford|Clark',
    county_weights: '{"17033": 91.0, "17023": 9.0}',
    density: 3.9,
    imprecise: false,
    latitude: 39.14081,
    longitude: -87.84012,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62413',
  },
  {
    city: 'Beecher City',
    county_fips: 17051,
    county_fips_all: '17051|17049|17173',
    county: 'Fayette',
    county_names_all: 'Fayette|Effingham|Shelby',
    county_weights: '{"17051": 54.42, "17049": 26.53, "17173": 19.05}',
    density: 9.1,
    imprecise: false,
    latitude: 39.17277,
    longitude: -88.82611,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62414',
  },
  {
    city: 'Bridgeport',
    county_fips: 17101,
    county_fips_all: '17101',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"17101": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 38.70304,
    longitude: -87.76779,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62417',
  },
  {
    city: 'Brownstown',
    county_fips: 17051,
    county_fips_all: '17051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"17051": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 39.02009,
    longitude: -88.97463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62418',
  },
  {
    city: 'Calhoun',
    county_fips: 17159,
    county_fips_all: '17159',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"17159": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 38.62201,
    longitude: -87.98425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62419',
  },
  {
    city: 'Casey',
    county_fips: 17023,
    county_fips_all: '17023|17035|17029|17079',
    county: 'Clark',
    county_names_all: 'Clark|Cumberland|Coles|Jasper',
    county_weights:
      '{"17023": 56.86, "17035": 36.11, "17029": 5.49, "17079": 1.54}',
    density: 13.5,
    imprecise: false,
    latitude: 39.29065,
    longitude: -88.0005,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62420',
  },
  {
    city: 'Claremont',
    county_fips: 17159,
    county_fips_all: '17159|17033|17101',
    county: 'Richland',
    county_names_all: 'Richland|Crawford|Lawrence',
    county_weights: '{"17159": 92.53, "17033": 6.01, "17101": 1.46}',
    density: 2.6,
    imprecise: false,
    latitude: 38.75219,
    longitude: -87.94345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62421',
  },
  {
    city: 'Cowden',
    county_fips: 17173,
    county_fips_all: '17173|17051',
    county: 'Shelby',
    county_names_all: 'Shelby|Fayette',
    county_weights: '{"17173": 64.91, "17051": 35.09}',
    density: 7.8,
    imprecise: false,
    latitude: 39.23327,
    longitude: -88.88855,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62422',
  },
  {
    city: 'Dennison',
    county_fips: 17023,
    county_fips_all: '17023|17045',
    county: 'Clark',
    county_names_all: 'Clark|Edgar',
    county_weights: '{"17023": 66.56, "17045": 33.44}',
    density: 8.7,
    imprecise: false,
    latitude: 39.46208,
    longitude: -87.5819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62423',
  },
  {
    city: 'Dieterich',
    county_fips: 17049,
    county_fips_all: '17049|17079|17025',
    county: 'Effingham',
    county_names_all: 'Effingham|Jasper|Clay',
    county_weights: '{"17049": 91.21, "17079": 7.54, "17025": 1.25}',
    density: 11.2,
    imprecise: false,
    latitude: 38.98784,
    longitude: -88.42124,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62424',
  },
  {
    city: 'Dundas',
    county_fips: 17159,
    county_fips_all: '17159|17079',
    county: 'Richland',
    county_names_all: 'Richland|Jasper',
    county_weights: '{"17159": 83.13, "17079": 16.87}',
    density: 8,
    imprecise: false,
    latitude: 38.83363,
    longitude: -88.10383,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62425',
  },
  {
    city: 'Edgewood',
    county_fips: 17025,
    county_fips_all: '17025|17049|17051',
    county: 'Clay',
    county_names_all: 'Clay|Effingham|Fayette',
    county_weights: '{"17025": 55.79, "17049": 31.93, "17051": 12.28}',
    density: 7.4,
    imprecise: false,
    latitude: 38.8999,
    longitude: -88.66639,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62426',
  },
  {
    city: 'Flat Rock',
    county_fips: 17033,
    county_fips_all: '17033|17101',
    county: 'Crawford',
    county_names_all: 'Crawford|Lawrence',
    county_weights: '{"17033": 76.26, "17101": 23.74}',
    density: 7.9,
    imprecise: false,
    latitude: 38.87301,
    longitude: -87.65891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62427',
  },
  {
    city: 'Greenup',
    county_fips: 17035,
    county_fips_all: '17035',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"17035": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 39.26396,
    longitude: -88.1302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62428',
  },
  {
    city: 'Herrick',
    county_fips: 17173,
    county_fips_all: '17173|17051',
    county: 'Shelby',
    county_names_all: 'Shelby|Fayette',
    county_weights: '{"17173": 62.27, "17051": 37.73}',
    density: 5,
    imprecise: false,
    latitude: 39.22981,
    longitude: -88.99382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62431',
  },
  {
    city: 'Hidalgo',
    county_fips: 17079,
    county_fips_all: '17079|17035',
    county: 'Jasper',
    county_names_all: 'Jasper|Cumberland',
    county_weights: '{"17079": 99.72, "17035": 0.28}',
    density: 5.6,
    imprecise: false,
    latitude: 39.13353,
    longitude: -88.14176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62432',
  },
  {
    city: 'Hutsonville',
    county_fips: 17033,
    county_fips_all: '17033',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"17033": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 39.11276,
    longitude: -87.70514,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62433',
  },
  {
    city: 'Ingraham',
    county_fips: 17025,
    county_fips_all: '17025|17079',
    county: 'Clay',
    county_names_all: 'Clay|Jasper',
    county_weights: '{"17025": 61.3, "17079": 38.7}',
    density: 2.5,
    imprecise: false,
    latitude: 38.84217,
    longitude: -88.3253,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62434',
  },
  {
    city: 'Jewett',
    county_fips: 17035,
    county_fips_all: '17035|17079',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Jasper',
    county_weights: '{"17035": 61.86, "17079": 38.14}',
    density: 9.6,
    imprecise: false,
    latitude: 39.18247,
    longitude: -88.25613,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62436',
  },
  {
    city: 'Lakewood',
    county_fips: 17173,
    county_fips_all: '17173',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"17173": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 39.32553,
    longitude: -88.87005,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62438',
  },
  {
    city: 'Lawrenceville',
    county_fips: 17101,
    county_fips_all: '17101',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"17101": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 38.74668,
    longitude: -87.63754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62439',
  },
  {
    city: 'Lerna',
    county_fips: 17029,
    county_fips_all: '17029|17035',
    county: 'Coles',
    county_names_all: 'Coles|Cumberland',
    county_weights: '{"17029": 73.84, "17035": 26.16}',
    density: 10.6,
    imprecise: false,
    latitude: 39.39433,
    longitude: -88.26325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62440',
  },
  {
    city: 'Marshall',
    county_fips: 17023,
    county_fips_all: '17023|17045',
    county: 'Clark',
    county_names_all: 'Clark|Edgar',
    county_weights: '{"17023": 96.37, "17045": 3.63}',
    density: 15.3,
    imprecise: false,
    latitude: 39.39392,
    longitude: -87.69795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62441',
  },
  {
    city: 'Martinsville',
    county_fips: 17023,
    county_fips_all: '17023|17033',
    county: 'Clark',
    county_names_all: 'Clark|Crawford',
    county_weights: '{"17023": 97.92, "17033": 2.08}',
    density: 7.4,
    imprecise: false,
    latitude: 39.31269,
    longitude: -87.85602,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62442',
  },
  {
    city: 'Mason',
    county_fips: 17049,
    county_fips_all: '17049|17025',
    county: 'Effingham',
    county_names_all: 'Effingham|Clay',
    county_weights: '{"17049": 89.41, "17025": 10.59}',
    density: 8,
    imprecise: false,
    latitude: 38.95397,
    longitude: -88.62902,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62443',
  },
  {
    city: 'Mode',
    county_fips: 17173,
    county_fips_all: '17173',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"17173": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 39.27853,
    longitude: -88.73474,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62444',
  },
  {
    city: 'Montrose',
    county_fips: 17079,
    county_fips_all: '17079|17035|17049',
    county: 'Jasper',
    county_names_all: 'Jasper|Cumberland|Effingham',
    county_weights: '{"17079": 46.86, "17035": 42.56, "17049": 10.58}',
    density: 8.3,
    imprecise: false,
    latitude: 39.16687,
    longitude: -88.32322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62445',
  },
  {
    city: 'Mount Erie',
    county_fips: 17191,
    county_fips_all: '17191',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"17191": 100}',
    density: 2,
    imprecise: false,
    latitude: 38.49115,
    longitude: -88.21478,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62446',
  },
  {
    city: 'Neoga',
    county_fips: 17035,
    county_fips_all: '17035|17173',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Shelby',
    county_weights: '{"17035": 68.75, "17173": 31.25}',
    density: 20.3,
    imprecise: false,
    latitude: 39.31303,
    longitude: -88.44456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62447',
  },
  {
    city: 'Newton',
    county_fips: 17079,
    county_fips_all: '17079|17159|17025',
    county: 'Jasper',
    county_names_all: 'Jasper|Richland|Clay',
    county_weights: '{"17079": 96.63, "17159": 2.28, "17025": 1.09}',
    density: 10.1,
    imprecise: false,
    latitude: 38.96741,
    longitude: -88.17988,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62448',
  },
  {
    city: 'Oblong',
    county_fips: 17033,
    county_fips_all: '17033|17079|17023',
    county: 'Crawford',
    county_names_all: 'Crawford|Jasper|Clark',
    county_weights: '{"17033": 81.46, "17079": 17.54, "17023": 1.0}',
    density: 9.5,
    imprecise: false,
    latitude: 39.00419,
    longitude: -87.91069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62449',
  },
  {
    city: 'Olney',
    county_fips: 17159,
    county_fips_all: '17159|17191',
    county: 'Richland',
    county_names_all: 'Richland|Wayne',
    county_weights: '{"17159": 99.46, "17191": 0.54}',
    density: 30.3,
    imprecise: false,
    latitude: 38.71436,
    longitude: -88.08777,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62450',
  },
  {
    city: 'Palestine',
    county_fips: 17033,
    county_fips_all: '17033',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"17033": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 38.99394,
    longitude: -87.6066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62451',
  },
  {
    city: 'Parkersburg',
    county_fips: 17159,
    county_fips_all: '17159',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"17159": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 38.58715,
    longitude: -88.01774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62452',
  },
  {
    city: 'Robinson',
    county_fips: 17033,
    county_fips_all: '17033',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"17033": 100}',
    density: 32.8,
    imprecise: false,
    latitude: 38.99725,
    longitude: -87.75767,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62454',
  },
  {
    city: 'Saint Elmo',
    county_fips: 17051,
    county_fips_all: '17051|17049',
    county: 'Fayette',
    county_names_all: 'Fayette|Effingham',
    county_weights: '{"17051": 87.75, "17049": 12.25}',
    density: 14.1,
    imprecise: false,
    latitude: 39.02531,
    longitude: -88.85441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62458',
  },
  {
    city: 'Sainte Marie',
    county_fips: 17079,
    county_fips_all: '17079',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"17079": 100}',
    density: 98.8,
    imprecise: false,
    latitude: 38.92997,
    longitude: -88.0278,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62459',
  },
  {
    city: 'Saint Francisville',
    county_fips: 17101,
    county_fips_all: '17101|17185',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Wabash',
    county_weights: '{"17101": 98.21, "17185": 1.79}',
    density: 10.7,
    imprecise: false,
    latitude: 38.60661,
    longitude: -87.69639,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62460',
  },
  {
    city: 'Shumway',
    county_fips: 17049,
    county_fips_all: '17049|17173',
    county: 'Effingham',
    county_names_all: 'Effingham|Shelby',
    county_weights: '{"17049": 70.69, "17173": 29.31}',
    density: 5.8,
    imprecise: false,
    latitude: 39.20067,
    longitude: -88.6759,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62461',
  },
  {
    city: 'Sigel',
    county_fips: 17173,
    county_fips_all: '17173|17035|17049',
    county: 'Shelby',
    county_names_all: 'Shelby|Cumberland|Effingham',
    county_weights: '{"17173": 49.93, "17035": 49.76, "17049": 0.31}',
    density: 9.4,
    imprecise: false,
    latitude: 39.23291,
    longitude: -88.47066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62462',
  },
  {
    city: 'Stewardson',
    county_fips: 17173,
    county_fips_all: '17173',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"17173": 100}',
    density: 11,
    imprecise: false,
    latitude: 39.27519,
    longitude: -88.59683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62463',
  },
  {
    city: 'Stoy',
    county_fips: 17033,
    county_fips_all: '17033',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"17033": 100}',
    density: 25,
    imprecise: false,
    latitude: 38.99793,
    longitude: -87.82385,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62464',
  },
  {
    city: 'Strasburg',
    county_fips: 17173,
    county_fips_all: '17173',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"17173": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 39.34614,
    longitude: -88.63827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62465',
  },
  {
    city: 'Sumner',
    county_fips: 17101,
    county_fips_all: '17101|17033|17159',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Crawford|Richland',
    county_weights: '{"17101": 88.88, "17033": 8.75, "17159": 2.37}',
    density: 11.1,
    imprecise: false,
    latitude: 38.72707,
    longitude: -87.84957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62466',
  },
  {
    city: 'Teutopolis',
    county_fips: 17049,
    county_fips_all: '17049|17079|17035',
    county: 'Effingham',
    county_names_all: 'Effingham|Jasper|Cumberland',
    county_weights: '{"17049": 80.37, "17079": 10.48, "17035": 9.15}',
    density: 24.7,
    imprecise: false,
    latitude: 39.12809,
    longitude: -88.43543,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62467',
  },
  {
    city: 'Toledo',
    county_fips: 17035,
    county_fips_all: '17035',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"17035": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 39.27779,
    longitude: -88.27155,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62468',
  },
  {
    city: 'Trilla',
    county_fips: 17035,
    county_fips_all: '17035|17029',
    county: 'Cumberland',
    county_names_all: 'Cumberland|Coles',
    county_weights: '{"17035": 84.96, "17029": 15.04}',
    density: 10.4,
    imprecise: false,
    latitude: 39.34843,
    longitude: -88.33911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62469',
  },
  {
    city: 'Vandalia',
    county_fips: 17051,
    county_fips_all: '17051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"17051": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 38.95859,
    longitude: -89.13257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62471',
  },
  {
    city: 'Watson',
    county_fips: 17049,
    county_fips_all: '17049',
    county: 'Effingham',
    county_names_all: 'Effingham',
    county_weights: '{"17049": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 39.01986,
    longitude: -88.56556,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62473',
  },
  {
    city: 'Westfield',
    county_fips: 17023,
    county_fips_all: '17023|17029',
    county: 'Clark',
    county_names_all: 'Clark|Coles',
    county_weights: '{"17023": 63.55, "17029": 36.45}',
    density: 6.7,
    imprecise: false,
    latitude: 39.43526,
    longitude: -87.99462,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62474',
  },
  {
    city: 'West Liberty',
    county_fips: 17079,
    county_fips_all: '17079',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"17079": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 38.88441,
    longitude: -88.04645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62475',
  },
  {
    city: 'West Salem',
    county_fips: 17047,
    county_fips_all: '17047|17185|17101|17159',
    county: 'Edwards',
    county_names_all: 'Edwards|Wabash|Lawrence|Richland',
    county_weights:
      '{"17047": 68.66, "17185": 29.31, "17101": 1.27, "17159": 0.76}',
    density: 6.1,
    imprecise: false,
    latitude: 38.53412,
    longitude: -88.00509,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62476',
  },
  {
    city: 'West Union',
    county_fips: 17023,
    county_fips_all: '17023',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"17023": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 39.23369,
    longitude: -87.66024,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62477',
  },
  {
    city: 'West York',
    county_fips: 17023,
    county_fips_all: '17023|17033',
    county: 'Clark',
    county_names_all: 'Clark|Crawford',
    county_weights: '{"17023": 53.69, "17033": 46.31}',
    density: 4.4,
    imprecise: false,
    latitude: 39.17874,
    longitude: -87.74367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62478',
  },
  {
    city: 'Wheeler',
    county_fips: 17079,
    county_fips_all: '17079|17049',
    county: 'Jasper',
    county_names_all: 'Jasper|Effingham',
    county_weights: '{"17079": 98.1, "17049": 1.9}',
    density: 5.1,
    imprecise: false,
    latitude: 39.03731,
    longitude: -88.31239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62479',
  },
  {
    city: 'Willow Hill',
    county_fips: 17079,
    county_fips_all: '17079',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"17079": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 38.99864,
    longitude: -88.00129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62480',
  },
  {
    city: 'Yale',
    county_fips: 17079,
    county_fips_all: '17079',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"17079": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 39.12657,
    longitude: -88.02293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62481',
  },
  {
    city: 'Argenta',
    county_fips: 17115,
    county_fips_all: '17115',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"17115": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 39.92973,
    longitude: -88.80528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62501',
  },
  {
    city: 'Assumption',
    county_fips: 17021,
    county_fips_all: '17021|17173',
    county: 'Christian',
    county_names_all: 'Christian|Shelby',
    county_weights: '{"17021": 51.26, "17173": 48.74}',
    density: 8.5,
    imprecise: false,
    latitude: 39.5315,
    longitude: -89.02706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62510',
  },
  {
    city: 'Beason',
    county_fips: 17107,
    county_fips_all: '17107|17039',
    county: 'Logan',
    county_names_all: 'Logan|De Witt',
    county_weights: '{"17107": 97.8, "17039": 2.2}',
    density: 3.7,
    imprecise: false,
    latitude: 40.14601,
    longitude: -89.20312,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62512',
  },
  {
    city: 'Blue Mound',
    county_fips: 17021,
    county_fips_all: '17021|17115',
    county: 'Christian',
    county_names_all: 'Christian|Macon',
    county_weights: '{"17021": 52.19, "17115": 47.81}',
    density: 7.9,
    imprecise: false,
    latitude: 39.72341,
    longitude: -89.15296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62513',
  },
  {
    city: 'Boody',
    county_fips: 17115,
    county_fips_all: '17115',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"17115": 100}',
    density: 121.1,
    imprecise: false,
    latitude: 39.76753,
    longitude: -89.04508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62514',
  },
  {
    city: 'Buffalo',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 39.8561,
    longitude: -89.36622,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62515',
  },
  {
    city: 'Bulpitt',
    county_fips: 17021,
    county_fips_all: '17021',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"17021": 100}',
    density: 148.5,
    imprecise: false,
    latitude: 39.59365,
    longitude: -89.43285,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62517',
  },
  {
    city: 'Chestnut',
    county_fips: 17107,
    county_fips_all: '17107',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"17107": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 40.05154,
    longitude: -89.19037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62518',
  },
  {
    city: 'Cornland',
    county_fips: 17107,
    county_fips_all: '17107',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"17107": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 39.92879,
    longitude: -89.3953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62519',
  },
  {
    city: 'Dawson',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 24.7,
    imprecise: false,
    latitude: 39.82185,
    longitude: -89.45904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62520',
  },
  {
    city: 'Decatur',
    county_fips: 17115,
    county_fips_all: '17115',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"17115": 100}',
    density: 191.2,
    imprecise: false,
    latitude: 39.81435,
    longitude: -88.93086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62521',
  },
  {
    city: 'Decatur',
    county_fips: 17115,
    county_fips_all: '17115',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"17115": 100}',
    density: 244.9,
    imprecise: false,
    latitude: 39.83008,
    longitude: -89.04743,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62522',
  },
  {
    city: 'Decatur',
    county_fips: 17115,
    county_fips_all: '17115',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"17115": 100}',
    density: 611,
    imprecise: false,
    latitude: 39.84372,
    longitude: -88.95289,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62523',
  },
  {
    city: 'Decatur',
    county_fips: 17115,
    county_fips_all: '17115',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"17115": 100}',
    density: 178.5,
    imprecise: false,
    latitude: 39.90322,
    longitude: -88.9902,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62526',
  },
  {
    city: 'Divernon',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 22.6,
    imprecise: false,
    latitude: 39.56206,
    longitude: -89.65626,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62530',
  },
  {
    city: 'Edinburg',
    county_fips: 17021,
    county_fips_all: '17021',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"17021": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 39.66754,
    longitude: -89.37395,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62531',
  },
  {
    city: 'Elwin',
    county_fips: 17115,
    county_fips_all: '17115',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"17115": 100}',
    density: 18.5,
    imprecise: false,
    latitude: 39.77633,
    longitude: -88.97781,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62532',
  },
  {
    city: 'Farmersville',
    county_fips: 17135,
    county_fips_all: '17135',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"17135": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 39.44483,
    longitude: -89.626,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62533',
  },
  {
    city: 'Findlay',
    county_fips: 17173,
    county_fips_all: '17173|17139',
    county: 'Shelby',
    county_names_all: 'Shelby|Moultrie',
    county_weights: '{"17173": 99.75, "17139": 0.25}',
    density: 7.2,
    imprecise: false,
    latitude: 39.53519,
    longitude: -88.79603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62534',
  },
  {
    city: 'Forsyth',
    county_fips: 17115,
    county_fips_all: '17115',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"17115": 100}',
    density: 371.7,
    imprecise: false,
    latitude: 39.92549,
    longitude: -88.96604,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62535',
  },
  {
    city: 'Glenarm',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 52.8,
    imprecise: false,
    latitude: 39.63022,
    longitude: -89.65023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62536',
  },
  {
    city: 'Harristown',
    county_fips: 17115,
    county_fips_all: '17115',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"17115": 100}',
    density: 95.6,
    imprecise: false,
    latitude: 39.85263,
    longitude: -89.09324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62537',
  },
  {
    city: 'Harvel',
    county_fips: 17135,
    county_fips_all: '17135|17021',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Christian',
    county_weights: '{"17135": 80.7, "17021": 19.3}',
    density: 3.9,
    imprecise: false,
    latitude: 39.35631,
    longitude: -89.52051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62538',
  },
  {
    city: 'Illiopolis',
    county_fips: 17167,
    county_fips_all: '17167|17115',
    county: 'Sangamon',
    county_names_all: 'Sangamon|Macon',
    county_weights: '{"17167": 76.85, "17115": 23.15}',
    density: 11.8,
    imprecise: false,
    latitude: 39.86681,
    longitude: -89.24914,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62539',
  },
  {
    city: 'Kincaid',
    county_fips: 17021,
    county_fips_all: '17021',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"17021": 100}',
    density: 235.6,
    imprecise: false,
    latitude: 39.58496,
    longitude: -89.41938,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62540',
  },
  {
    city: 'Lake Fork',
    county_fips: 17107,
    county_fips_all: '17107',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"17107": 100}',
    density: 9,
    imprecise: false,
    latitude: 39.95657,
    longitude: -89.37085,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62541',
  },
  {
    city: 'Latham',
    county_fips: 17107,
    county_fips_all: '17107|17115',
    county: 'Logan',
    county_names_all: 'Logan|Macon',
    county_weights: '{"17107": 65.12, "17115": 34.88}',
    density: 8.9,
    imprecise: false,
    latitude: 39.97084,
    longitude: -89.1518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62543',
  },
  {
    city: 'Macon',
    county_fips: 17115,
    county_fips_all: '17115',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"17115": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 39.70854,
    longitude: -88.97375,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62544',
  },
  {
    city: 'Mechanicsburg',
    county_fips: 17167,
    county_fips_all: '17167|17021',
    county: 'Sangamon',
    county_names_all: 'Sangamon|Christian',
    county_weights: '{"17167": 64.68, "17021": 35.32}',
    density: 15.8,
    imprecise: false,
    latitude: 39.7661,
    longitude: -89.38737,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62545',
  },
  {
    city: 'Morrisonville',
    county_fips: 17021,
    county_fips_all: '17021|17135',
    county: 'Christian',
    county_names_all: 'Christian|Montgomery',
    county_weights: '{"17021": 89.39, "17135": 10.61}',
    density: 5.2,
    imprecise: false,
    latitude: 39.43042,
    longitude: -89.44281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62546',
  },
  {
    city: 'Mount Auburn',
    county_fips: 17021,
    county_fips_all: '17021|17115',
    county: 'Christian',
    county_names_all: 'Christian|Macon',
    county_weights: '{"17021": 96.26, "17115": 3.74}',
    density: 5.3,
    imprecise: false,
    latitude: 39.76883,
    longitude: -89.24929,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62547',
  },
  {
    city: 'Mount Pulaski',
    county_fips: 17107,
    county_fips_all: '17107|17167',
    county: 'Logan',
    county_names_all: 'Logan|Sangamon',
    county_weights: '{"17107": 98.69, "17167": 1.31}',
    density: 9.5,
    imprecise: false,
    latitude: 39.97849,
    longitude: -89.27988,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62548',
  },
  {
    city: 'Mt Zion',
    county_fips: 17115,
    county_fips_all: '17115',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"17115": 100}',
    density: 308.2,
    imprecise: false,
    latitude: 39.76985,
    longitude: -88.8657,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62549',
  },
  {
    city: 'Moweaqua',
    county_fips: 17173,
    county_fips_all: '17173|17021|17115',
    county: 'Shelby',
    county_names_all: 'Shelby|Christian|Macon',
    county_weights: '{"17173": 59.59, "17021": 33.84, "17115": 6.57}',
    density: 12.4,
    imprecise: false,
    latitude: 39.61154,
    longitude: -88.99283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62550',
  },
  {
    city: 'Niantic',
    county_fips: 17115,
    county_fips_all: '17115',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"17115": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 39.85357,
    longitude: -89.15631,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62551',
  },
  {
    city: 'Oconee',
    county_fips: 17173,
    county_fips_all: '17173|17135',
    county: 'Shelby',
    county_names_all: 'Shelby|Montgomery',
    county_weights: '{"17173": 80.47, "17135": 19.53}',
    density: 3.4,
    imprecise: false,
    latitude: 39.27182,
    longitude: -89.10509,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62553',
  },
  {
    city: 'Oreana',
    county_fips: 17115,
    county_fips_all: '17115',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"17115": 100}',
    density: 39.1,
    imprecise: false,
    latitude: 39.94976,
    longitude: -88.87107,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62554',
  },
  {
    city: 'Owaneco',
    county_fips: 17021,
    county_fips_all: '17021',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"17021": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 39.46755,
    longitude: -89.21982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62555',
  },
  {
    city: 'Palmer',
    county_fips: 17021,
    county_fips_all: '17021',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"17021": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 39.46674,
    longitude: -89.37049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62556',
  },
  {
    city: 'Pana',
    county_fips: 17021,
    county_fips_all: '17021|17173|17135',
    county: 'Christian',
    county_names_all: 'Christian|Shelby|Montgomery',
    county_weights: '{"17021": 73.64, "17173": 21.36, "17135": 5.0}',
    density: 22.7,
    imprecise: false,
    latitude: 39.39974,
    longitude: -89.10503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62557',
  },
  {
    city: 'Pawnee',
    county_fips: 17167,
    county_fips_all: '17167|17021|17135',
    county: 'Sangamon',
    county_names_all: 'Sangamon|Christian|Montgomery',
    county_weights: '{"17167": 51.25, "17021": 39.88, "17135": 8.87}',
    density: 15,
    imprecise: false,
    latitude: 39.58967,
    longitude: -89.54239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62558',
  },
  {
    city: 'Raymond',
    county_fips: 17135,
    county_fips_all: '17135|17117',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Macoupin',
    county_weights: '{"17135": 88.79, "17117": 11.21}',
    density: 8.6,
    imprecise: false,
    latitude: 39.3005,
    longitude: -89.60377,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62560',
  },
  {
    city: 'Riverton',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 80.7,
    imprecise: false,
    latitude: 39.86754,
    longitude: -89.50498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62561',
  },
  {
    city: 'Rochester',
    county_fips: 17167,
    county_fips_all: '17167|17021',
    county: 'Sangamon',
    county_names_all: 'Sangamon|Christian',
    county_weights: '{"17167": 95.87, "17021": 4.13}',
    density: 37.4,
    imprecise: false,
    latitude: 39.71675,
    longitude: -89.50017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62563',
  },
  {
    city: 'Shelbyville',
    county_fips: 17173,
    county_fips_all: '17173',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"17173": 100}',
    density: 23,
    imprecise: false,
    latitude: 39.41334,
    longitude: -88.8026,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62565',
  },
  {
    city: 'Stonington',
    county_fips: 17021,
    county_fips_all: '17021',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"17021": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 39.64668,
    longitude: -89.19082,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62567',
  },
  {
    city: 'Taylorville',
    county_fips: 17021,
    county_fips_all: '17021',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"17021": 100}',
    density: 49.4,
    imprecise: false,
    latitude: 39.55974,
    longitude: -89.29016,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62568',
  },
  {
    city: 'Tovey',
    county_fips: 17021,
    county_fips_all: '17021',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"17021": 100}',
    density: 169.6,
    imprecise: false,
    latitude: 39.58023,
    longitude: -89.45107,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62570',
  },
  {
    city: 'Tower Hill',
    county_fips: 17173,
    county_fips_all: '17173',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"17173": 100}',
    density: 7,
    imprecise: false,
    latitude: 39.38155,
    longitude: -88.95998,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62571',
  },
  {
    city: 'Waggoner',
    county_fips: 17135,
    county_fips_all: '17135|17117',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Macoupin',
    county_weights: '{"17135": 50.91, "17117": 49.09}',
    density: 4,
    imprecise: false,
    latitude: 39.35908,
    longitude: -89.69778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62572',
  },
  {
    city: 'Warrensburg',
    county_fips: 17115,
    county_fips_all: '17115',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"17115": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 39.94551,
    longitude: -89.07264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62573',
  },
  {
    city: 'Alexander',
    county_fips: 17137,
    county_fips_all: '17137',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"17137": 100}',
    density: 3,
    imprecise: false,
    latitude: 39.75032,
    longitude: -90.03904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62601',
  },
  {
    city: 'Alsey',
    county_fips: 17171,
    county_fips_all: '17171',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"17171": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 39.5526,
    longitude: -90.42708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62610',
  },
  {
    city: 'Arenzville',
    county_fips: 17017,
    county_fips_all: '17017|17137',
    county: 'Cass',
    county_names_all: 'Cass|Morgan',
    county_weights: '{"17017": 66.36, "17137": 33.64}',
    density: 5.6,
    imprecise: false,
    latitude: 39.88493,
    longitude: -90.39984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62611',
  },
  {
    city: 'Ashland',
    county_fips: 17017,
    county_fips_all: '17017|17137',
    county: 'Cass',
    county_names_all: 'Cass|Morgan',
    county_weights: '{"17017": 61.88, "17137": 38.12}',
    density: 5.8,
    imprecise: false,
    latitude: 39.89864,
    longitude: -90.0683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62612',
  },
  {
    city: 'Athens',
    county_fips: 17129,
    county_fips_all: '17129|17167|17107',
    county: 'Menard',
    county_names_all: 'Menard|Sangamon|Logan',
    county_weights: '{"17129": 85.44, "17167": 7.32, "17107": 7.24}',
    density: 22,
    imprecise: false,
    latitude: 39.99009,
    longitude: -89.67036,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62613',
  },
  {
    city: 'Auburn',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 40.6,
    imprecise: false,
    latitude: 39.58568,
    longitude: -89.75406,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62615',
  },
  {
    city: 'Bath',
    county_fips: 17125,
    county_fips_all: '17125',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"17125": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 40.14948,
    longitude: -90.18109,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62617',
  },
  {
    city: 'Beardstown',
    county_fips: 17017,
    county_fips_all: '17017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"17017": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 40.00534,
    longitude: -90.39542,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62618',
  },
  {
    city: 'Bluffs',
    county_fips: 17171,
    county_fips_all: '17171|17137',
    county: 'Scott',
    county_names_all: 'Scott|Morgan',
    county_weights: '{"17171": 92.99, "17137": 7.01}',
    density: 8.8,
    imprecise: false,
    latitude: 39.73174,
    longitude: -90.5309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62621',
  },
  {
    city: 'Bluff Springs',
    county_fips: 17017,
    county_fips_all: '17017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"17017": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 39.97786,
    longitude: -90.34302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62622',
  },
  {
    city: 'Browning',
    county_fips: 17169,
    county_fips_all: '17169',
    county: 'Schuyler',
    county_names_all: 'Schuyler',
    county_weights: '{"17169": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 40.14993,
    longitude: -90.34478,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62624',
  },
  {
    city: 'Cantrall',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 39.90424,
    longitude: -89.70185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62625',
  },
  {
    city: 'Carlinville',
    county_fips: 17117,
    county_fips_all: '17117',
    county: 'Macoupin',
    county_names_all: 'Macoupin',
    county_weights: '{"17117": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 39.28459,
    longitude: -89.88362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62626',
  },
  {
    city: 'Chandlerville',
    county_fips: 17017,
    county_fips_all: '17017|17125',
    county: 'Cass',
    county_names_all: 'Cass|Mason',
    county_weights: '{"17017": 61.15, "17125": 38.85}',
    density: 4.6,
    imprecise: false,
    latitude: 40.05425,
    longitude: -90.12887,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62627',
  },
  {
    city: 'Chapin',
    county_fips: 17137,
    county_fips_all: '17137|17171',
    county: 'Morgan',
    county_names_all: 'Morgan|Scott',
    county_weights: '{"17137": 87.23, "17171": 12.77}',
    density: 9.1,
    imprecise: false,
    latitude: 39.7794,
    longitude: -90.40199,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62628',
  },
  {
    city: 'Chatham',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 170.5,
    imprecise: false,
    latitude: 39.67858,
    longitude: -89.71978,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62629',
  },
  {
    city: 'Chesterfield',
    county_fips: 17117,
    county_fips_all: '17117|17061',
    county: 'Macoupin',
    county_names_all: 'Macoupin|Greene',
    county_weights: '{"17117": 94.45, "17061": 5.55}',
    density: 8.8,
    imprecise: false,
    latitude: 39.26255,
    longitude: -90.08315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62630',
  },
  {
    city: 'Concord',
    county_fips: 17137,
    county_fips_all: '17137',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"17137": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 39.82531,
    longitude: -90.36122,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62631',
  },
  {
    city: 'Easton',
    county_fips: 17125,
    county_fips_all: '17125',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"17125": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 40.22577,
    longitude: -89.8763,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62633',
  },
  {
    city: 'Elkhart',
    county_fips: 17107,
    county_fips_all: '17107',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"17107": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 40.0166,
    longitude: -89.45107,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62634',
  },
  {
    city: 'Emden',
    county_fips: 17107,
    county_fips_all: '17107|17179',
    county: 'Logan',
    county_names_all: 'Logan|Tazewell',
    county_weights: '{"17107": 91.17, "17179": 8.83}',
    density: 6.2,
    imprecise: false,
    latitude: 40.29653,
    longitude: -89.46573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62635',
  },
  {
    city: 'Franklin',
    county_fips: 17137,
    county_fips_all: '17137|17117',
    county: 'Morgan',
    county_names_all: 'Morgan|Macoupin',
    county_weights: '{"17137": 95.68, "17117": 4.32}',
    density: 8.5,
    imprecise: false,
    latitude: 39.60714,
    longitude: -90.08226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62638',
  },
  {
    city: 'Frederick',
    county_fips: 17169,
    county_fips_all: '17169',
    county: 'Schuyler',
    county_names_all: 'Schuyler',
    county_weights: '{"17169": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 40.0435,
    longitude: -90.48753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62639',
  },
  {
    city: 'Girard',
    county_fips: 17117,
    county_fips_all: '17117|17135',
    county: 'Macoupin',
    county_names_all: 'Macoupin|Montgomery',
    county_weights: '{"17117": 96.93, "17135": 3.07}',
    density: 17.5,
    imprecise: false,
    latitude: 39.43183,
    longitude: -89.80746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62640',
  },
  {
    city: 'Greenview',
    county_fips: 17129,
    county_fips_all: '17129',
    county: 'Menard',
    county_names_all: 'Menard',
    county_weights: '{"17129": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 40.09022,
    longitude: -89.71303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62642',
  },
  {
    city: 'Hartsburg',
    county_fips: 17107,
    county_fips_all: '17107',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"17107": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 40.24154,
    longitude: -89.45774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62643',
  },
  {
    city: 'Havana',
    county_fips: 17125,
    county_fips_all: '17125|17057',
    county: 'Mason',
    county_names_all: 'Mason|Fulton',
    county_weights: '{"17125": 69.73, "17057": 30.27}',
    density: 18.5,
    imprecise: false,
    latitude: 40.28553,
    longitude: -90.06022,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62644',
  },
  {
    city: 'Hettick',
    county_fips: 17117,
    county_fips_all: '17117',
    county: 'Macoupin',
    county_names_all: 'Macoupin',
    county_weights: '{"17117": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 39.36451,
    longitude: -90.0664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62649',
  },
  {
    city: 'Jacksonville',
    county_fips: 17137,
    county_fips_all: '17137|17171',
    county: 'Morgan',
    county_names_all: 'Morgan|Scott',
    county_weights: '{"17137": 98.17, "17171": 1.83}',
    density: 48.4,
    imprecise: false,
    latitude: 39.73799,
    longitude: -90.22027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62650',
  },
  {
    city: 'Kilbourne',
    county_fips: 17125,
    county_fips_all: '17125',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"17125": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 40.16523,
    longitude: -89.99515,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62655',
  },
  {
    city: 'Lincoln',
    county_fips: 17107,
    county_fips_all: '17107',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"17107": 100}',
    density: 49.3,
    imprecise: false,
    latitude: 40.13948,
    longitude: -89.36622,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62656',
  },
  {
    city: 'Loami',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 39.66513,
    longitude: -89.84057,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62661',
  },
  {
    city: 'Manchester',
    county_fips: 17171,
    county_fips_all: '17171',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"17171": 100}',
    density: 110.4,
    imprecise: false,
    latitude: 39.54106,
    longitude: -90.32748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62663',
  },
  {
    city: 'Mason City',
    county_fips: 17125,
    county_fips_all: '17125',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"17125": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 40.21106,
    longitude: -89.72629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62664',
  },
  {
    city: 'Meredosia',
    county_fips: 17137,
    county_fips_all: '17137|17171',
    county: 'Morgan',
    county_names_all: 'Morgan|Scott',
    county_weights: '{"17137": 75.1, "17171": 24.9}',
    density: 10.5,
    imprecise: false,
    latitude: 39.81627,
    longitude: -90.53462,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62665',
  },
  {
    city: 'Middletown',
    county_fips: 17107,
    county_fips_all: '17107|17129',
    county: 'Logan',
    county_names_all: 'Logan|Menard',
    county_weights: '{"17107": 76.84, "17129": 23.16}',
    density: 5.9,
    imprecise: false,
    latitude: 40.08384,
    longitude: -89.54364,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62666',
  },
  {
    city: 'Modesto',
    county_fips: 17117,
    county_fips_all: '17117|17137',
    county: 'Macoupin',
    county_names_all: 'Macoupin|Morgan',
    county_weights: '{"17117": 94.89, "17137": 5.11}',
    density: 6,
    imprecise: false,
    latitude: 39.49372,
    longitude: -89.99016,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62667',
  },
  {
    city: 'Murrayville',
    county_fips: 17137,
    county_fips_all: '17137|17171',
    county: 'Morgan',
    county_names_all: 'Morgan|Scott',
    county_weights: '{"17137": 87.12, "17171": 12.88}',
    density: 6.9,
    imprecise: false,
    latitude: 39.57474,
    longitude: -90.23667,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62668',
  },
  {
    city: 'New Berlin',
    county_fips: 17167,
    county_fips_all: '17167|17137',
    county: 'Sangamon',
    county_names_all: 'Sangamon|Morgan',
    county_weights: '{"17167": 92.09, "17137": 7.91}',
    density: 11.3,
    imprecise: false,
    latitude: 39.74431,
    longitude: -89.89601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62670',
  },
  {
    city: 'New Holland',
    county_fips: 17107,
    county_fips_all: '17107|17125',
    county: 'Logan',
    county_names_all: 'Logan|Mason',
    county_weights: '{"17107": 89.55, "17125": 10.45}',
    density: 2.8,
    imprecise: false,
    latitude: 40.16707,
    longitude: -89.55755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62671',
  },
  {
    city: 'Nilwood',
    county_fips: 17117,
    county_fips_all: '17117',
    county: 'Macoupin',
    county_names_all: 'Macoupin',
    county_weights: '{"17117": 100}',
    density: 79.5,
    imprecise: false,
    latitude: 39.39802,
    longitude: -89.80444,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62672',
  },
  {
    city: 'Oakford',
    county_fips: 17129,
    county_fips_all: '17129|17017',
    county: 'Menard',
    county_names_all: 'Menard|Cass',
    county_weights: '{"17129": 69.33, "17017": 30.67}',
    density: 5,
    imprecise: false,
    latitude: 40.09586,
    longitude: -89.9674,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62673',
  },
  {
    city: 'Palmyra',
    county_fips: 17117,
    county_fips_all: '17117',
    county: 'Macoupin',
    county_names_all: 'Macoupin',
    county_weights: '{"17117": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 39.43486,
    longitude: -90.02952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62674',
  },
  {
    city: 'Petersburg',
    county_fips: 17129,
    county_fips_all: '17129|17017',
    county: 'Menard',
    county_names_all: 'Menard|Cass',
    county_weights: '{"17129": 98.03, "17017": 1.97}',
    density: 20.7,
    imprecise: false,
    latitude: 40.02109,
    longitude: -89.86146,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62675',
  },
  {
    city: 'Pleasant Plains',
    county_fips: 17167,
    county_fips_all: '17167|17129',
    county: 'Sangamon',
    county_names_all: 'Sangamon|Menard',
    county_weights: '{"17167": 98.28, "17129": 1.72}',
    density: 9.3,
    imprecise: false,
    latitude: 39.85168,
    longitude: -89.87694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62677',
  },
  {
    city: 'Rushville',
    county_fips: 17169,
    county_fips_all: '17169',
    county: 'Schuyler',
    county_names_all: 'Schuyler',
    county_weights: '{"17169": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 40.13841,
    longitude: -90.55885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62681',
  },
  {
    city: 'San Jose',
    county_fips: 17125,
    county_fips_all: '17125|17107|17179',
    county: 'Mason',
    county_names_all: 'Mason|Logan|Tazewell',
    county_weights: '{"17125": 56.14, "17107": 30.06, "17179": 13.8}',
    density: 5.8,
    imprecise: false,
    latitude: 40.29487,
    longitude: -89.63541,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62682',
  },
  {
    city: 'Sherman',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 85.8,
    imprecise: false,
    latitude: 39.91019,
    longitude: -89.58474,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62684',
  },
  {
    city: 'Shipman',
    county_fips: 17117,
    county_fips_all: '17117',
    county: 'Macoupin',
    county_names_all: 'Macoupin',
    county_weights: '{"17117": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 39.14209,
    longitude: -89.99689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62685',
  },
  {
    city: 'Tallula',
    county_fips: 17129,
    county_fips_all: '17129',
    county: 'Menard',
    county_names_all: 'Menard',
    county_weights: '{"17129": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 39.945,
    longitude: -89.92415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62688',
  },
  {
    city: 'Thayer',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 182.7,
    imprecise: false,
    latitude: 39.53402,
    longitude: -89.76555,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62689',
  },
  {
    city: 'Virden',
    county_fips: 17117,
    county_fips_all: '17117|17135|17167',
    county: 'Macoupin',
    county_names_all: 'Macoupin|Montgomery|Sangamon',
    county_weights: '{"17117": 62.72, "17135": 21.05, "17167": 16.23}',
    density: 26.4,
    imprecise: false,
    latitude: 39.50572,
    longitude: -89.76662,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62690',
  },
  {
    city: 'Virginia',
    county_fips: 17017,
    county_fips_all: '17017',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"17017": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 39.95731,
    longitude: -90.22246,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62691',
  },
  {
    city: 'Waverly',
    county_fips: 17137,
    county_fips_all: '17137|17167',
    county: 'Morgan',
    county_names_all: 'Morgan|Sangamon',
    county_weights: '{"17137": 52.3, "17167": 47.7}',
    density: 8.9,
    imprecise: false,
    latitude: 39.5832,
    longitude: -89.93936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62692',
  },
  {
    city: 'Williamsville',
    county_fips: 17167,
    county_fips_all: '17167|17107|17129',
    county: 'Sangamon',
    county_names_all: 'Sangamon|Logan|Menard',
    county_weights: '{"17167": 60.57, "17107": 36.51, "17129": 2.92}',
    density: 12.7,
    imprecise: false,
    latitude: 39.95761,
    longitude: -89.52041,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62693',
  },
  {
    city: 'Winchester',
    county_fips: 17171,
    county_fips_all: '17171|17137',
    county: 'Scott',
    county_names_all: 'Scott|Morgan',
    county_weights: '{"17171": 97.68, "17137": 2.32}',
    density: 7.4,
    imprecise: false,
    latitude: 39.62463,
    longitude: -90.47274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62694',
  },
  {
    city: 'Woodson',
    county_fips: 17137,
    county_fips_all: '17137',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"17137": 100}',
    density: 235.2,
    imprecise: false,
    latitude: 39.61943,
    longitude: -90.22418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62695',
  },
  {
    city: 'Springfield',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 1196,
    imprecise: false,
    latitude: 39.80063,
    longitude: -89.64902,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62701',
  },
  {
    city: 'Springfield',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 779.8,
    imprecise: false,
    latitude: 39.82377,
    longitude: -89.64286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62702',
  },
  {
    city: 'Springfield',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 748.6,
    imprecise: false,
    latitude: 39.76276,
    longitude: -89.63106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62703',
  },
  {
    city: 'Springfield',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 1264.7,
    imprecise: false,
    latitude: 39.77358,
    longitude: -89.68503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62704',
  },
  {
    city: 'Springfield',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 68.9,
    imprecise: false,
    latitude: 39.85506,
    longitude: -89.64989,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62707',
  },
  {
    city: 'Springfield',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 231.8,
    imprecise: false,
    latitude: 39.76662,
    longitude: -89.73195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62711',
  },
  {
    city: 'Springfield',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 162.3,
    imprecise: false,
    latitude: 39.74883,
    longitude: -89.58344,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62712',
  },
  {
    city: 'Centralia',
    county_fips: 17121,
    county_fips_all: '17121|17027|17189|17081',
    county: 'Marion',
    county_names_all: 'Marion|Clinton|Washington|Jefferson',
    county_weights:
      '{"17121": 37.65, "17027": 33.01, "17189": 15.69, "17081": 13.65}',
    density: 56.9,
    imprecise: false,
    latitude: 38.51097,
    longitude: -89.1412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62801',
  },
  {
    city: 'Hoyleton',
    county_fips: 17189,
    county_fips_all: '17189',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"17189": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 38.45461,
    longitude: -89.29822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62803',
  },
  {
    city: 'Albion',
    county_fips: 17047,
    county_fips_all: '17047',
    county: 'Edwards',
    county_names_all: 'Edwards',
    county_weights: '{"17047": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 38.38405,
    longitude: -88.07492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62806',
  },
  {
    city: 'Alma',
    county_fips: 17121,
    county_fips_all: '17121',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"17121": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 38.74767,
    longitude: -88.93412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62807',
  },
  {
    city: 'Ashley',
    county_fips: 17189,
    county_fips_all: '17189|17081',
    county: 'Washington',
    county_names_all: 'Washington|Jefferson',
    county_weights: '{"17189": 68.44, "17081": 31.56}',
    density: 8.2,
    imprecise: false,
    latitude: 38.30328,
    longitude: -89.1884,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62808',
  },
  {
    city: 'Barnhill',
    county_fips: 17191,
    county_fips_all: '17191',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"17191": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 38.28023,
    longitude: -88.33756,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62809',
  },
  {
    city: 'Belle Rive',
    county_fips: 17081,
    county_fips_all: '17081|17191|17065',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Wayne|Hamilton',
    county_weights: '{"17081": 85.69, "17191": 9.78, "17065": 4.53}',
    density: 7.3,
    imprecise: false,
    latitude: 38.20515,
    longitude: -88.74388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62810',
  },
  {
    city: 'Bellmont',
    county_fips: 17185,
    county_fips_all: '17185',
    county: 'Wabash',
    county_names_all: 'Wabash',
    county_weights: '{"17185": 100}',
    density: 70.4,
    imprecise: false,
    latitude: 38.38739,
    longitude: -87.90361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62811',
  },
  {
    city: 'Benton',
    county_fips: 17055,
    county_fips_all: '17055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"17055": 100}',
    density: 45.4,
    imprecise: false,
    latitude: 38.00487,
    longitude: -88.92249,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62812',
  },
  {
    city: 'Bluford',
    county_fips: 17081,
    county_fips_all: '17081|17191',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Wayne',
    county_weights: '{"17081": 82.1, "17191": 17.9}',
    density: 9,
    imprecise: false,
    latitude: 38.37641,
    longitude: -88.73054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62814',
  },
  {
    city: 'Bone Gap',
    county_fips: 17047,
    county_fips_all: '17047',
    county: 'Edwards',
    county_names_all: 'Edwards',
    county_weights: '{"17047": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 38.45707,
    longitude: -87.98698,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62815',
  },
  {
    city: 'Bonnie',
    county_fips: 17081,
    county_fips_all: '17081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"17081": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 38.18156,
    longitude: -88.92473,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62816',
  },
  {
    city: 'Broughton',
    county_fips: 17065,
    county_fips_all: '17065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"17065": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 37.9545,
    longitude: -88.47762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62817',
  },
  {
    city: 'Browns',
    county_fips: 17047,
    county_fips_all: '17047|17185',
    county: 'Edwards',
    county_names_all: 'Edwards|Wabash',
    county_weights: '{"17047": 50.08, "17185": 49.92}',
    density: 6.1,
    imprecise: false,
    latitude: 38.37772,
    longitude: -87.96749,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62818',
  },
  {
    city: 'Buckner',
    county_fips: 17055,
    county_fips_all: '17055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"17055": 100}',
    density: 28.7,
    imprecise: false,
    latitude: 37.97507,
    longitude: -89.00283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62819',
  },
  {
    city: 'Burnt Prairie',
    county_fips: 17193,
    county_fips_all: '17193|17191',
    county: 'White',
    county_names_all: 'White|Wayne',
    county_weights: '{"17193": 59.63, "17191": 40.37}',
    density: 1.7,
    imprecise: false,
    latitude: 38.24873,
    longitude: -88.23561,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62820',
  },
  {
    city: 'Carmi',
    county_fips: 17193,
    county_fips_all: '17193',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"17193": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 38.07301,
    longitude: -88.13357,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62821',
  },
  {
    city: 'Christopher',
    county_fips: 17055,
    county_fips_all: '17055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"17055": 100}',
    density: 451.6,
    imprecise: false,
    latitude: 37.97473,
    longitude: -89.05358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62822',
  },
  {
    city: 'Cisne',
    county_fips: 17191,
    county_fips_all: '17191',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"17191": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 38.51864,
    longitude: -88.43816,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62823',
  },
  {
    city: 'Clay City',
    county_fips: 17025,
    county_fips_all: '17025|17191',
    county: 'Clay',
    county_names_all: 'Clay|Wayne',
    county_weights: '{"17025": 84.64, "17191": 15.36}',
    density: 5.7,
    imprecise: false,
    latitude: 38.67076,
    longitude: -88.34686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62824',
  },
  {
    city: 'Coello',
    county_fips: 17055,
    county_fips_all: '17055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"17055": 100}',
    density: 139.4,
    imprecise: false,
    latitude: 37.99832,
    longitude: -89.06474,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62825',
  },
  {
    city: 'Crossville',
    county_fips: 17193,
    county_fips_all: '17193',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"17193": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 38.16573,
    longitude: -88.04157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62827',
  },
  {
    city: 'Dahlgren',
    county_fips: 17065,
    county_fips_all: '17065|17191',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Wayne',
    county_weights: '{"17065": 97.14, "17191": 2.86}',
    density: 8.4,
    imprecise: false,
    latitude: 38.19536,
    longitude: -88.60864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62828',
  },
  {
    city: 'Dix',
    county_fips: 17081,
    county_fips_all: '17081|17121',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Marion',
    county_weights: '{"17081": 95.9, "17121": 4.1}',
    density: 18.8,
    imprecise: false,
    latitude: 38.44559,
    longitude: -88.96424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62830',
  },
  {
    city: 'Du Bois',
    county_fips: 17189,
    county_fips_all: '17189|17145',
    county: 'Washington',
    county_names_all: 'Washington|Perry',
    county_weights: '{"17189": 76.92, "17145": 23.08}',
    density: 3.2,
    imprecise: false,
    latitude: 38.23042,
    longitude: -89.22167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62831',
  },
  {
    city: 'Du Quoin',
    county_fips: 17145,
    county_fips_all: '17145|17077',
    county: 'Perry',
    county_names_all: 'Perry|Jackson',
    county_weights: '{"17145": 94.83, "17077": 5.17}',
    density: 35,
    imprecise: false,
    latitude: 38.01001,
    longitude: -89.24969,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62832',
  },
  {
    city: 'Ellery',
    county_fips: 17191,
    county_fips_all: '17191|17047',
    county: 'Wayne',
    county_names_all: 'Wayne|Edwards',
    county_weights: '{"17191": 70.71, "17047": 29.29}',
    density: 2.2,
    imprecise: false,
    latitude: 38.34071,
    longitude: -88.16355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62833',
  },
  {
    city: 'Enfield',
    county_fips: 17193,
    county_fips_all: '17193|17065',
    county: 'White',
    county_names_all: 'White|Hamilton',
    county_weights: '{"17193": 82.13, "17065": 17.87}',
    density: 7.2,
    imprecise: false,
    latitude: 38.10573,
    longitude: -88.32406,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62835',
  },
  {
    city: 'Ewing',
    county_fips: 17055,
    county_fips_all: '17055|17081',
    county: 'Franklin',
    county_names_all: 'Franklin|Jefferson',
    county_weights: '{"17055": 93.16, "17081": 6.84}',
    density: 9,
    imprecise: false,
    latitude: 38.0973,
    longitude: -88.80568,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62836',
  },
  {
    city: 'Fairfield',
    county_fips: 17191,
    county_fips_all: '17191',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"17191": 100}',
    density: 18.5,
    imprecise: false,
    latitude: 38.36608,
    longitude: -88.35999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62837',
  },
  {
    city: 'Farina',
    county_fips: 17051,
    county_fips_all: '17051|17025|17121|17049',
    county: 'Fayette',
    county_names_all: 'Fayette|Clay|Marion|Effingham',
    county_weights:
      '{"17051": 61.48, "17025": 29.16, "17121": 7.91, "17049": 1.45}',
    density: 5.6,
    imprecise: false,
    latitude: 38.86855,
    longitude: -88.74889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62838',
  },
  {
    city: 'Flora',
    county_fips: 17025,
    county_fips_all: '17025',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"17025": 100}',
    density: 33.5,
    imprecise: false,
    latitude: 38.66403,
    longitude: -88.49689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62839',
  },
  {
    city: 'Freeman Spur',
    county_fips: 17199,
    county_fips_all: '17199',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"17199": 100}',
    density: 149.2,
    imprecise: false,
    latitude: 37.8588,
    longitude: -88.99639,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62841',
  },
  {
    city: 'Geff',
    county_fips: 17191,
    county_fips_all: '17191',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"17191": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 38.47038,
    longitude: -88.38007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62842',
  },
  {
    city: 'Golden Gate',
    county_fips: 17191,
    county_fips_all: '17191',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"17191": 100}',
    density: 6,
    imprecise: false,
    latitude: 38.3828,
    longitude: -88.19893,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62843',
  },
  {
    city: 'Grayville',
    county_fips: 17193,
    county_fips_all: '17193|17047',
    county: 'White',
    county_names_all: 'White|Edwards',
    county_weights: '{"17193": 62.49, "17047": 37.51}',
    density: 16,
    imprecise: false,
    latitude: 38.25525,
    longitude: -88.05018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62844',
  },
  {
    city: 'Ina',
    county_fips: 17081,
    county_fips_all: '17081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"17081": 100}',
    density: 42.3,
    imprecise: false,
    latitude: 38.15042,
    longitude: -88.85485,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62846',
  },
  {
    city: 'Irvington',
    county_fips: 17189,
    county_fips_all: '17189',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"17189": 100}',
    density: 104.9,
    imprecise: false,
    latitude: 38.43794,
    longitude: -89.16665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62848',
  },
  {
    city: 'Iuka',
    county_fips: 17121,
    county_fips_all: '17121',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"17121": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 38.58803,
    longitude: -88.77221,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62849',
  },
  {
    city: 'Johnsonville',
    county_fips: 17191,
    county_fips_all: '17191',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"17191": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 38.49552,
    longitude: -88.58841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62850',
  },
  {
    city: 'Keenes',
    county_fips: 17191,
    county_fips_all: '17191|17081|17121',
    county: 'Wayne',
    county_names_all: 'Wayne|Jefferson|Marion',
    county_weights: '{"17191": 89.94, "17081": 7.67, "17121": 2.39}',
    density: 4.8,
    imprecise: false,
    latitude: 38.42185,
    longitude: -88.66237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62851',
  },
  {
    city: 'Keensburg',
    county_fips: 17185,
    county_fips_all: '17185',
    county: 'Wabash',
    county_names_all: 'Wabash',
    county_weights: '{"17185": 100}',
    density: 437,
    imprecise: false,
    latitude: 38.34992,
    longitude: -87.86676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62852',
  },
  {
    city: 'Kell',
    county_fips: 17121,
    county_fips_all: '17121',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"17121": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 38.51734,
    longitude: -88.91571,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62853',
  },
  {
    city: 'Kinmundy',
    county_fips: 17121,
    county_fips_all: '17121|17025|17051',
    county: 'Marion',
    county_names_all: 'Marion|Clay|Fayette',
    county_weights: '{"17121": 98.25, "17025": 1.07, "17051": 0.68}',
    density: 7.6,
    imprecise: false,
    latitude: 38.76458,
    longitude: -88.81172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62854',
  },
  {
    city: 'Logan',
    county_fips: 17055,
    county_fips_all: '17055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"17055": 100}',
    density: 84.8,
    imprecise: false,
    latitude: 37.95246,
    longitude: -88.83549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62856',
  },
  {
    city: 'Louisville',
    county_fips: 17025,
    county_fips_all: '17025|17049',
    county: 'Clay',
    county_names_all: 'Clay|Effingham',
    county_weights: '{"17025": 98.83, "17049": 1.17}',
    density: 9,
    imprecise: false,
    latitude: 38.81271,
    longitude: -88.49353,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62858',
  },
  {
    city: 'McLeansboro',
    county_fips: 17065,
    county_fips_all: '17065|17055',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Franklin',
    county_weights: '{"17065": 99.54, "17055": 0.46}',
    density: 9.9,
    imprecise: false,
    latitude: 38.07094,
    longitude: -88.54289,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62859',
  },
  {
    city: 'Macedonia',
    county_fips: 17055,
    county_fips_all: '17055|17065',
    county: 'Franklin',
    county_names_all: 'Franklin|Hamilton',
    county_weights: '{"17055": 71.92, "17065": 28.08}',
    density: 4.2,
    imprecise: false,
    latitude: 38.04022,
    longitude: -88.72921,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62860',
  },
  {
    city: 'Maunie',
    county_fips: 17193,
    county_fips_all: '17193',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"17193": 100}',
    density: 138.7,
    imprecise: false,
    latitude: 38.03543,
    longitude: -88.04569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62861',
  },
  {
    city: 'Mill Shoals',
    county_fips: 17193,
    county_fips_all: '17193',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"17193": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 38.2166,
    longitude: -88.29685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62862',
  },
  {
    city: 'Mount Carmel',
    county_fips: 17185,
    county_fips_all: '17185',
    county: 'Wabash',
    county_names_all: 'Wabash',
    county_weights: '{"17185": 100}',
    density: 24.6,
    imprecise: false,
    latitude: 38.41575,
    longitude: -87.85526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62863',
  },
  {
    city: 'Mount Vernon',
    county_fips: 17081,
    county_fips_all: '17081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"17081": 100}',
    density: 61.5,
    imprecise: false,
    latitude: 38.33041,
    longitude: -88.90272,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62864',
  },
  {
    city: 'Mulkeytown',
    county_fips: 17055,
    county_fips_all: '17055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"17055": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 37.97528,
    longitude: -89.08351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62865',
  },
  {
    city: 'New Haven',
    county_fips: 17193,
    county_fips_all: '17193|17059',
    county: 'White',
    county_names_all: 'White|Gallatin',
    county_weights: '{"17193": 64.35, "17059": 35.65}',
    density: 5.4,
    imprecise: false,
    latitude: 37.90503,
    longitude: -88.10091,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62867',
  },
  {
    city: 'Noble',
    county_fips: 17159,
    county_fips_all: '17159|17025|17191',
    county: 'Richland',
    county_names_all: 'Richland|Clay|Wayne',
    county_weights: '{"17159": 67.01, "17025": 16.77, "17191": 16.22}',
    density: 5.4,
    imprecise: false,
    latitude: 38.68073,
    longitude: -88.22939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62868',
  },
  {
    city: 'Norris City',
    county_fips: 17193,
    county_fips_all: '17193|17065|17165|17059',
    county: 'White',
    county_names_all: 'White|Hamilton|Saline|Gallatin',
    county_weights:
      '{"17193": 93.71, "17065": 3.53, "17165": 2.19, "17059": 0.57}',
    density: 11.6,
    imprecise: false,
    latitude: 37.96608,
    longitude: -88.28336,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62869',
  },
  {
    city: 'Odin',
    county_fips: 17121,
    county_fips_all: '17121',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"17121": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 38.63463,
    longitude: -89.05063,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62870',
  },
  {
    city: 'Omaha',
    county_fips: 17059,
    county_fips_all: '17059|17193',
    county: 'Gallatin',
    county_names_all: 'Gallatin|White',
    county_weights: '{"17059": 98.88, "17193": 1.12}',
    density: 6.1,
    imprecise: false,
    latitude: 37.8757,
    longitude: -88.26499,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62871',
  },
  {
    city: 'Opdyke',
    county_fips: 17081,
    county_fips_all: '17081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"17081": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 38.26776,
    longitude: -88.8032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62872',
  },
  {
    city: 'Orient',
    county_fips: 17055,
    county_fips_all: '17055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"17055": 100}',
    density: 105.7,
    imprecise: false,
    latitude: 37.91767,
    longitude: -88.97802,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62874',
  },
  {
    city: 'Patoka',
    county_fips: 17121,
    county_fips_all: '17121|17051|17027',
    county: 'Marion',
    county_names_all: 'Marion|Fayette|Clinton',
    county_weights: '{"17121": 52.77, "17051": 40.63, "17027": 6.6}',
    density: 5.6,
    imprecise: false,
    latitude: 38.75789,
    longitude: -89.12482,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62875',
  },
  {
    city: 'Radom',
    county_fips: 17189,
    county_fips_all: '17189',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"17189": 100}',
    density: 20.3,
    imprecise: false,
    latitude: 38.27713,
    longitude: -89.19487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62876',
  },
  {
    city: 'Richview',
    county_fips: 17189,
    county_fips_all: '17189|17081',
    county: 'Washington',
    county_names_all: 'Washington|Jefferson',
    county_weights: '{"17189": 93.54, "17081": 6.46}',
    density: 5.3,
    imprecise: false,
    latitude: 38.38983,
    longitude: -89.2057,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62877',
  },
  {
    city: 'Rinard',
    county_fips: 17191,
    county_fips_all: '17191',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"17191": 100}',
    density: 2,
    imprecise: false,
    latitude: 38.57718,
    longitude: -88.49378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62878',
  },
  {
    city: 'Sailor Springs',
    county_fips: 17025,
    county_fips_all: '17025',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"17025": 100}',
    density: 87.1,
    imprecise: false,
    latitude: 38.7651,
    longitude: -88.35907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62879',
  },
  {
    city: 'Saint Peter',
    county_fips: 17051,
    county_fips_all: '17051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"17051": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 38.86751,
    longitude: -88.88593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62880',
  },
  {
    city: 'Salem',
    county_fips: 17121,
    county_fips_all: '17121',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"17121": 100}',
    density: 43.1,
    imprecise: false,
    latitude: 38.63544,
    longitude: -88.9288,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62881',
  },
  {
    city: 'Sandoval',
    county_fips: 17121,
    county_fips_all: '17121|17027',
    county: 'Marion',
    county_names_all: 'Marion|Clinton',
    county_weights: '{"17121": 82.79, "17027": 17.21}',
    density: 25.2,
    imprecise: false,
    latitude: 38.63474,
    longitude: -89.1197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62882',
  },
  {
    city: 'Scheller',
    county_fips: 17081,
    county_fips_all: '17081|17145|17055',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Perry|Franklin',
    county_weights: '{"17081": 70.45, "17145": 16.02, "17055": 13.53}',
    density: 6.3,
    imprecise: false,
    latitude: 38.162,
    longitude: -89.11192,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62883',
  },
  {
    city: 'Sesser',
    county_fips: 17055,
    county_fips_all: '17055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"17055": 100}',
    density: 35.2,
    imprecise: false,
    latitude: 38.08482,
    longitude: -89.04196,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62884',
  },
  {
    city: 'Shobonier',
    county_fips: 17051,
    county_fips_all: '17051',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"17051": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 38.86289,
    longitude: -89.06286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62885',
  },
  {
    city: 'Sims',
    county_fips: 17191,
    county_fips_all: '17191',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"17191": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 38.37486,
    longitude: -88.53572,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62886',
  },
  {
    city: 'Springerton',
    county_fips: 17193,
    county_fips_all: '17193|17065',
    county: 'White',
    county_names_all: 'White|Hamilton',
    county_weights: '{"17193": 52.41, "17065": 47.59}',
    density: 1.6,
    imprecise: false,
    latitude: 38.18478,
    longitude: -88.36871,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62887',
  },
  {
    city: 'Tamaroa',
    county_fips: 17145,
    county_fips_all: '17145',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"17145": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 38.12665,
    longitude: -89.22828,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62888',
  },
  {
    city: 'Texico',
    county_fips: 17081,
    county_fips_all: '17081|17121',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Marion',
    county_weights: '{"17081": 67.75, "17121": 32.25}',
    density: 12.9,
    imprecise: false,
    latitude: 38.46011,
    longitude: -88.82893,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62889',
  },
  {
    city: 'Thompsonville',
    county_fips: 17055,
    county_fips_all: '17055|17199|17065|17165',
    county: 'Franklin',
    county_names_all: 'Franklin|Williamson|Hamilton|Saline',
    county_weights:
      '{"17055": 52.69, "17199": 23.06, "17065": 16.22, "17165": 8.03}',
    density: 8.9,
    imprecise: false,
    latitude: 37.90574,
    longitude: -88.73944,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62890',
  },
  {
    city: 'Valier',
    county_fips: 17055,
    county_fips_all: '17055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"17055": 100}',
    density: 314.1,
    imprecise: false,
    latitude: 38.01569,
    longitude: -89.04067,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62891',
  },
  {
    city: 'Vernon',
    county_fips: 17121,
    county_fips_all: '17121|17051',
    county: 'Marion',
    county_names_all: 'Marion|Fayette',
    county_weights: '{"17121": 90.28, "17051": 9.72}',
    density: 2.6,
    imprecise: false,
    latitude: 38.80623,
    longitude: -89.0771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62892',
  },
  {
    city: 'Walnut Hill',
    county_fips: 17081,
    county_fips_all: '17081|17121',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Marion',
    county_weights: '{"17081": 54.97, "17121": 45.03}',
    density: 17.8,
    imprecise: false,
    latitude: 38.46776,
    longitude: -89.03087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62893',
  },
  {
    city: 'Waltonville',
    county_fips: 17081,
    county_fips_all: '17081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"17081": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 38.20952,
    longitude: -89.03931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62894',
  },
  {
    city: 'Wayne City',
    county_fips: 17191,
    county_fips_all: '17191|17065',
    county: 'Wayne',
    county_names_all: 'Wayne|Hamilton',
    county_weights: '{"17191": 75.64, "17065": 24.36}',
    density: 6.9,
    imprecise: false,
    latitude: 38.30364,
    longitude: -88.54702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62895',
  },
  {
    city: 'West Frankfort',
    county_fips: 17055,
    county_fips_all: '17055|17199',
    county: 'Franklin',
    county_names_all: 'Franklin|Williamson',
    county_weights: '{"17055": 91.0, "17199": 9.0}',
    density: 67.9,
    imprecise: false,
    latitude: 37.89287,
    longitude: -88.91183,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62896',
  },
  {
    city: 'Whittington',
    county_fips: 17055,
    county_fips_all: '17055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"17055": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 38.09763,
    longitude: -88.91504,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62897',
  },
  {
    city: 'Woodlawn',
    county_fips: 17081,
    county_fips_all: '17081',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"17081": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 38.35041,
    longitude: -89.06209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62898',
  },
  {
    city: 'Xenia',
    county_fips: 17025,
    county_fips_all: '17025|17191',
    county: 'Clay',
    county_names_all: 'Clay|Wayne',
    county_weights: '{"17025": 59.17, "17191": 40.83}',
    density: 7.2,
    imprecise: false,
    latitude: 38.63032,
    longitude: -88.64367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62899',
  },
  {
    city: 'Carbondale',
    county_fips: 17077,
    county_fips_all: '17077|17199',
    county: 'Jackson',
    county_names_all: 'Jackson|Williamson',
    county_weights: '{"17077": 88.5, "17199": 11.5}',
    density: 327.4,
    imprecise: false,
    latitude: 37.74003,
    longitude: -89.20946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62901',
  },
  {
    city: 'Carbondale',
    county_fips: 17199,
    county_fips_all: '17199|17077|17181',
    county: 'Williamson',
    county_names_all: 'Williamson|Jackson|Union',
    county_weights: '{"17199": 67.11, "17077": 31.55, "17181": 1.34}',
    density: 24.8,
    imprecise: false,
    latitude: 37.67199,
    longitude: -89.11509,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62902',
  },
  {
    city: 'Carbondale',
    county_fips: 17077,
    county_fips_all: '17077',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"17077": 100}',
    density: 50.9,
    imprecise: false,
    latitude: 37.67162,
    longitude: -89.27568,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62903',
  },
  {
    city: 'Alto Pass',
    county_fips: 17181,
    county_fips_all: '17181|17077',
    county: 'Union',
    county_names_all: 'Union|Jackson',
    county_weights: '{"17181": 81.39, "17077": 18.61}',
    density: 9.1,
    imprecise: false,
    latitude: 37.57381,
    longitude: -89.35867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62905',
  },
  {
    city: 'Anna',
    county_fips: 17181,
    county_fips_all: '17181',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"17181": 100}',
    density: 46.9,
    imprecise: false,
    latitude: 37.45746,
    longitude: -89.18899,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62906',
  },
  {
    city: 'Ava',
    county_fips: 17077,
    county_fips_all: '17077|17157',
    county: 'Jackson',
    county_names_all: 'Jackson|Randolph',
    county_weights: '{"17077": 99.06, "17157": 0.94}',
    density: 8.2,
    imprecise: false,
    latitude: 37.86503,
    longitude: -89.50009,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62907',
  },
  {
    city: 'Belknap',
    county_fips: 17127,
    county_fips_all: '17127|17087',
    county: 'Massac',
    county_names_all: 'Massac|Johnson',
    county_weights: '{"17127": 64.81, "17087": 35.19}',
    density: 3.4,
    imprecise: false,
    latitude: 37.30827,
    longitude: -88.86603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62908',
  },
  {
    city: 'Brookport',
    county_fips: 17127,
    county_fips_all: '17127|17151',
    county: 'Massac',
    county_names_all: 'Massac|Pope',
    county_weights: '{"17127": 55.03, "17151": 44.97}',
    density: 7.2,
    imprecise: false,
    latitude: 37.1562,
    longitude: -88.53075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62910',
  },
  {
    city: 'Buncombe',
    county_fips: 17087,
    county_fips_all: '17087|17181',
    county: 'Johnson',
    county_names_all: 'Johnson|Union',
    county_weights: '{"17087": 59.36, "17181": 40.64}',
    density: 11.2,
    imprecise: false,
    latitude: 37.47598,
    longitude: -89.0388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62912',
  },
  {
    city: 'Cairo',
    county_fips: 17003,
    county_fips_all: '17003',
    county: 'Alexander',
    county_names_all: 'Alexander',
    county_weights: '{"17003": 100}',
    density: 34.2,
    imprecise: false,
    latitude: 37.04076,
    longitude: -89.20329,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62914',
  },
  {
    city: 'Cambria',
    county_fips: 17199,
    county_fips_all: '17199',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"17199": 100}',
    density: 467.3,
    imprecise: false,
    latitude: 37.78413,
    longitude: -89.12238,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62915',
  },
  {
    city: 'Campbell Hill',
    county_fips: 17077,
    county_fips_all: '17077|17145|17157',
    county: 'Jackson',
    county_names_all: 'Jackson|Perry|Randolph',
    county_weights: '{"17077": 47.41, "17145": 30.36, "17157": 22.23}',
    density: 7.7,
    imprecise: false,
    latitude: 37.93722,
    longitude: -89.56947,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62916',
  },
  {
    city: 'Carrier Mills',
    county_fips: 17165,
    county_fips_all: '17165|17199',
    county: 'Saline',
    county_names_all: 'Saline|Williamson',
    county_weights: '{"17165": 78.47, "17199": 21.53}',
    density: 29.9,
    imprecise: false,
    latitude: 37.69752,
    longitude: -88.64882,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62917',
  },
  {
    city: 'Carterville',
    county_fips: 17199,
    county_fips_all: '17199',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"17199": 100}',
    density: 109.7,
    imprecise: false,
    latitude: 37.78561,
    longitude: -89.08641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62918',
  },
  {
    city: 'Cave In Rock',
    county_fips: 17069,
    county_fips_all: '17069',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"17069": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 37.52057,
    longitude: -88.14653,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62919',
  },
  {
    city: 'Cobden',
    county_fips: 17181,
    county_fips_all: '17181|17077',
    county: 'Union',
    county_names_all: 'Union|Jackson',
    county_weights: '{"17181": 95.73, "17077": 4.27}',
    density: 16.1,
    imprecise: false,
    latitude: 37.55095,
    longitude: -89.23208,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62920',
  },
  {
    city: 'Colp',
    county_fips: 17199,
    county_fips_all: '17199',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"17199": 100}',
    density: 168,
    imprecise: false,
    latitude: 37.80217,
    longitude: -89.08215,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62921',
  },
  {
    city: 'Creal Springs',
    county_fips: 17199,
    county_fips_all: '17199|17087',
    county: 'Williamson',
    county_names_all: 'Williamson|Johnson',
    county_weights: '{"17199": 73.75, "17087": 26.25}',
    density: 15.9,
    imprecise: false,
    latitude: 37.6215,
    longitude: -88.81531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62922',
  },
  {
    city: 'Cypress',
    county_fips: 17087,
    county_fips_all: '17087|17181|17153',
    county: 'Johnson',
    county_names_all: 'Johnson|Union|Pulaski',
    county_weights: '{"17087": 59.62, "17181": 21.52, "17153": 18.86}',
    density: 7.3,
    imprecise: false,
    latitude: 37.33709,
    longitude: -89.03671,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62923',
  },
  {
    city: 'De Soto',
    county_fips: 17077,
    county_fips_all: '17077|17199',
    county: 'Jackson',
    county_names_all: 'Jackson|Williamson',
    county_weights: '{"17077": 87.82, "17199": 12.18}',
    density: 30.8,
    imprecise: false,
    latitude: 37.82112,
    longitude: -89.20448,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62924',
  },
  {
    city: 'Dongola',
    county_fips: 17181,
    county_fips_all: '17181|17153',
    county: 'Union',
    county_names_all: 'Union|Pulaski',
    county_weights: '{"17181": 77.84, "17153": 22.16}',
    density: 9.9,
    imprecise: false,
    latitude: 37.3692,
    longitude: -89.13589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62926',
  },
  {
    city: 'Dowell',
    county_fips: 17077,
    county_fips_all: '17077',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"17077": 100}',
    density: 71.6,
    imprecise: false,
    latitude: 37.94129,
    longitude: -89.24837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62927',
  },
  {
    city: 'Eddyville',
    county_fips: 17151,
    county_fips_all: '17151',
    county: 'Pope',
    county_names_all: 'Pope',
    county_weights: '{"17151": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 37.47959,
    longitude: -88.5668,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62928',
  },
  {
    city: 'Eldorado',
    county_fips: 17165,
    county_fips_all: '17165|17059|17065',
    county: 'Saline',
    county_names_all: 'Saline|Gallatin|Hamilton',
    county_weights: '{"17165": 91.61, "17059": 4.82, "17065": 3.57}',
    density: 31.6,
    imprecise: false,
    latitude: 37.84379,
    longitude: -88.44139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62930',
  },
  {
    city: 'Elizabethtown',
    county_fips: 17069,
    county_fips_all: '17069|17059',
    county: 'Hardin',
    county_names_all: 'Hardin|Gallatin',
    county_weights: '{"17069": 91.68, "17059": 8.32}',
    density: 5.3,
    imprecise: false,
    latitude: 37.52813,
    longitude: -88.27953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62931',
  },
  {
    city: 'Elkville',
    county_fips: 17077,
    county_fips_all: '17077|17055',
    county: 'Jackson',
    county_names_all: 'Jackson|Franklin',
    county_weights: '{"17077": 98.5, "17055": 1.5}',
    density: 11,
    imprecise: false,
    latitude: 37.89878,
    longitude: -89.21048,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62932',
  },
  {
    city: 'Energy',
    county_fips: 17199,
    county_fips_all: '17199',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"17199": 100}',
    density: 176.3,
    imprecise: false,
    latitude: 37.77363,
    longitude: -89.02003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62933',
  },
  {
    city: 'Equality',
    county_fips: 17059,
    county_fips_all: '17059|17165',
    county: 'Gallatin',
    county_names_all: 'Gallatin|Saline',
    county_weights: '{"17059": 66.06, "17165": 33.94}',
    density: 4.6,
    imprecise: false,
    latitude: 37.70876,
    longitude: -88.36175,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62934',
  },
  {
    city: 'Galatia',
    county_fips: 17165,
    county_fips_all: '17165|17065|17199',
    county: 'Saline',
    county_names_all: 'Saline|Hamilton|Williamson',
    county_weights: '{"17165": 91.47, "17065": 7.74, "17199": 0.79}',
    density: 13.6,
    imprecise: false,
    latitude: 37.84281,
    longitude: -88.63194,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62935',
  },
  {
    city: 'Golconda',
    county_fips: 17151,
    county_fips_all: '17151|17069|17127',
    county: 'Pope',
    county_names_all: 'Pope|Hardin|Massac',
    county_weights: '{"17151": 93.99, "17069": 4.19, "17127": 1.82}',
    density: 6,
    imprecise: false,
    latitude: 37.38249,
    longitude: -88.54676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62938',
  },
  {
    city: 'Goreville',
    county_fips: 17087,
    county_fips_all: '17087|17181|17199',
    county: 'Johnson',
    county_names_all: 'Johnson|Union|Williamson',
    county_weights: '{"17087": 89.65, "17181": 6.39, "17199": 3.96}',
    density: 25.5,
    imprecise: false,
    latitude: 37.5489,
    longitude: -88.98088,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62939',
  },
  {
    city: 'Gorham',
    county_fips: 17077,
    county_fips_all: '17077',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"17077": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 37.7292,
    longitude: -89.46279,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62940',
  },
  {
    city: 'Grand Chain',
    county_fips: 17153,
    county_fips_all: '17153|17127',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Massac',
    county_weights: '{"17153": 73.5, "17127": 26.5}',
    density: 8.1,
    imprecise: false,
    latitude: 37.24142,
    longitude: -88.97186,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62941',
  },
  {
    city: 'Grand Tower',
    county_fips: 17077,
    county_fips_all: '17077',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"17077": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 37.6348,
    longitude: -89.47681,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62942',
  },
  {
    city: 'Grantsburg',
    county_fips: 17087,
    county_fips_all: '17087|17127|17151',
    county: 'Johnson',
    county_names_all: 'Johnson|Massac|Pope',
    county_weights: '{"17087": 60.49, "17127": 24.51, "17151": 15.0}',
    density: 4.4,
    imprecise: false,
    latitude: 37.35586,
    longitude: -88.74669,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62943',
  },
  {
    city: 'Harrisburg',
    county_fips: 17165,
    county_fips_all: '17165|17151',
    county: 'Saline',
    county_names_all: 'Saline|Pope',
    county_weights: '{"17165": 94.85, "17151": 5.15}',
    density: 29.8,
    imprecise: false,
    latitude: 37.7028,
    longitude: -88.52887,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62946',
  },
  {
    city: 'Herod',
    county_fips: 17151,
    county_fips_all: '17151|17069|17165',
    county: 'Pope',
    county_names_all: 'Pope|Hardin|Saline',
    county_weights: '{"17151": 58.03, "17069": 33.91, "17165": 8.06}',
    density: 2.1,
    imprecise: false,
    latitude: 37.55676,
    longitude: -88.4348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62947',
  },
  {
    city: 'Herrin',
    county_fips: 17199,
    county_fips_all: '17199',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"17199": 100}',
    density: 245.7,
    imprecise: false,
    latitude: 37.8204,
    longitude: -89.02542,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62948',
  },
  {
    city: 'Hurst',
    county_fips: 17199,
    county_fips_all: '17199',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"17199": 100}',
    density: 162.1,
    imprecise: false,
    latitude: 37.8278,
    longitude: -89.14409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62949',
  },
  {
    city: 'Jacob',
    county_fips: 17077,
    county_fips_all: '17077',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"17077": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 37.75184,
    longitude: -89.55573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62950',
  },
  {
    city: 'Johnston City',
    county_fips: 17199,
    county_fips_all: '17199',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"17199": 100}',
    density: 74.6,
    imprecise: false,
    latitude: 37.82637,
    longitude: -88.92609,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62951',
  },
  {
    city: 'Jonesboro',
    county_fips: 17181,
    county_fips_all: '17181|17003',
    county: 'Union',
    county_names_all: 'Union|Alexander',
    county_weights: '{"17181": 97.6, "17003": 2.4}',
    density: 11.7,
    imprecise: false,
    latitude: 37.42065,
    longitude: -89.33187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62952',
  },
  {
    city: 'Joppa',
    county_fips: 17127,
    county_fips_all: '17127',
    county: 'Massac',
    county_names_all: 'Massac',
    county_weights: '{"17127": 100}',
    density: 185.9,
    imprecise: false,
    latitude: 37.20684,
    longitude: -88.84533,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62953',
  },
  {
    city: 'Junction',
    county_fips: 17059,
    county_fips_all: '17059',
    county: 'Gallatin',
    county_names_all: 'Gallatin',
    county_weights: '{"17059": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 37.69462,
    longitude: -88.27428,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62954',
  },
  {
    city: 'Karnak',
    county_fips: 17127,
    county_fips_all: '17127|17153',
    county: 'Massac',
    county_names_all: 'Massac|Pulaski',
    county_weights: '{"17127": 51.65, "17153": 48.35}',
    density: 16.8,
    imprecise: false,
    latitude: 37.27805,
    longitude: -88.93127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62956',
  },
  {
    city: 'McClure',
    county_fips: 17003,
    county_fips_all: '17003|17181',
    county: 'Alexander',
    county_names_all: 'Alexander|Union',
    county_weights: '{"17003": 77.19, "17181": 22.81}',
    density: 5.3,
    imprecise: false,
    latitude: 37.31355,
    longitude: -89.42669,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62957',
  },
  {
    city: 'Makanda',
    county_fips: 17077,
    county_fips_all: '17077|17181|17199',
    county: 'Jackson',
    county_names_all: 'Jackson|Union|Williamson',
    county_weights: '{"17077": 38.46, "17181": 35.31, "17199": 26.23}',
    density: 16.6,
    imprecise: false,
    latitude: 37.60389,
    longitude: -89.14917,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62958',
  },
  {
    city: 'Marion',
    county_fips: 17199,
    county_fips_all: '17199',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"17199": 100}',
    density: 75,
    imprecise: false,
    latitude: 37.71442,
    longitude: -88.91463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62959',
  },
  {
    city: 'Metropolis',
    county_fips: 17127,
    county_fips_all: '17127|17151',
    county: 'Massac',
    county_names_all: 'Massac|Pope',
    county_weights: '{"17127": 98.34, "17151": 1.66}',
    density: 36.9,
    imprecise: false,
    latitude: 37.22515,
    longitude: -88.71097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62960',
  },
  {
    city: 'Millcreek',
    county_fips: 17181,
    county_fips_all: '17181|17003',
    county: 'Union',
    county_names_all: 'Union|Alexander',
    county_weights: '{"17181": 99.86, "17003": 0.14}',
    density: 41.7,
    imprecise: false,
    latitude: 37.34063,
    longitude: -89.25378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62961',
  },
  {
    city: 'Miller City',
    county_fips: 17003,
    county_fips_all: '17003',
    county: 'Alexander',
    county_names_all: 'Alexander',
    county_weights: '{"17003": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.07431,
    longitude: -89.33537,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62962',
  },
  {
    city: 'Mound City',
    county_fips: 17153,
    county_fips_all: '17153',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"17153": 100}',
    density: 65.9,
    imprecise: false,
    latitude: 37.0933,
    longitude: -89.16263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62963',
  },
  {
    city: 'Mounds',
    county_fips: 17153,
    county_fips_all: '17153',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"17153": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 37.12705,
    longitude: -89.21526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62964',
  },
  {
    city: 'Muddy',
    county_fips: 17165,
    county_fips_all: '17165',
    county: 'Saline',
    county_names_all: 'Saline',
    county_weights: '{"17165": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 37.76753,
    longitude: -88.5177,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 79,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62965',
  },
  {
    city: 'Murphysboro',
    county_fips: 17077,
    county_fips_all: '17077',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"17077": 100}',
    density: 48.5,
    imprecise: false,
    latitude: 37.7693,
    longitude: -89.35198,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62966',
  },
  {
    city: 'New Burnside',
    county_fips: 17087,
    county_fips_all: '17087|17199',
    county: 'Johnson',
    county_names_all: 'Johnson|Williamson',
    county_weights: '{"17087": 96.34, "17199": 3.66}',
    density: 18.3,
    imprecise: false,
    latitude: 37.58092,
    longitude: -88.75089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62967',
  },
  {
    city: 'Olive Branch',
    county_fips: 17003,
    county_fips_all: '17003',
    county: 'Alexander',
    county_names_all: 'Alexander',
    county_weights: '{"17003": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 37.15181,
    longitude: -89.34674,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62969',
  },
  {
    city: 'Olmsted',
    county_fips: 17153,
    county_fips_all: '17153',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"17153": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 37.21362,
    longitude: -89.10119,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62970',
  },
  {
    city: 'Ozark',
    county_fips: 17087,
    county_fips_all: '17087|17151',
    county: 'Johnson',
    county_names_all: 'Johnson|Pope',
    county_weights: '{"17087": 91.19, "17151": 8.81}',
    density: 7.6,
    imprecise: false,
    latitude: 37.5419,
    longitude: -88.8162,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62972',
  },
  {
    city: 'Pittsburg',
    county_fips: 17199,
    county_fips_all: '17199',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"17199": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 37.78158,
    longitude: -88.79094,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62974',
  },
  {
    city: 'Pomona',
    county_fips: 17077,
    county_fips_all: '17077',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"17077": 100}',
    density: 3,
    imprecise: false,
    latitude: 37.64307,
    longitude: -89.37274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62975',
  },
  {
    city: 'Pulaski',
    county_fips: 17153,
    county_fips_all: '17153',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"17153": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 37.21954,
    longitude: -89.2095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62976',
  },
  {
    city: 'Raleigh',
    county_fips: 17165,
    county_fips_all: '17165',
    county: 'Saline',
    county_names_all: 'Saline',
    county_weights: '{"17165": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 37.85179,
    longitude: -88.54384,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62977',
  },
  {
    city: 'Ridgway',
    county_fips: 17059,
    county_fips_all: '17059',
    county: 'Gallatin',
    county_names_all: 'Gallatin',
    county_weights: '{"17059": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 37.80813,
    longitude: -88.2365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62979',
  },
  {
    city: 'Rosiclare',
    county_fips: 17069,
    county_fips_all: '17069',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"17069": 100}',
    density: 50.4,
    imprecise: false,
    latitude: 37.42808,
    longitude: -88.35967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62982',
  },
  {
    city: 'Royalton',
    county_fips: 17055,
    county_fips_all: '17055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"17055": 100}',
    density: 28.7,
    imprecise: false,
    latitude: 37.90208,
    longitude: -89.10883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62983',
  },
  {
    city: 'Shawneetown',
    county_fips: 17059,
    county_fips_all: '17059',
    county: 'Gallatin',
    county_names_all: 'Gallatin',
    county_weights: '{"17059": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 37.73152,
    longitude: -88.14903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62984',
  },
  {
    city: 'Simpson',
    county_fips: 17151,
    county_fips_all: '17151|17087',
    county: 'Pope',
    county_names_all: 'Pope|Johnson',
    county_weights: '{"17151": 63.67, "17087": 36.33}',
    density: 5.9,
    imprecise: false,
    latitude: 37.46768,
    longitude: -88.68933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62985',
  },
  {
    city: 'Stonefort',
    county_fips: 17151,
    county_fips_all: '17151|17165|17199',
    county: 'Pope',
    county_names_all: 'Pope|Saline|Williamson',
    county_weights: '{"17151": 42.19, "17165": 39.72, "17199": 18.09}',
    density: 7.3,
    imprecise: false,
    latitude: 37.61114,
    longitude: -88.65695,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62987',
  },
  {
    city: 'Tamms',
    county_fips: 17003,
    county_fips_all: '17003',
    county: 'Alexander',
    county_names_all: 'Alexander',
    county_weights: '{"17003": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 37.23184,
    longitude: -89.29629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62988',
  },
  {
    city: 'Thebes',
    county_fips: 17003,
    county_fips_all: '17003',
    county: 'Alexander',
    county_names_all: 'Alexander',
    county_weights: '{"17003": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 37.22924,
    longitude: -89.40493,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62990',
  },
  {
    city: 'Ullin',
    county_fips: 17153,
    county_fips_all: '17153|17003',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Alexander',
    county_weights: '{"17153": 82.16, "17003": 17.84}',
    density: 6.4,
    imprecise: false,
    latitude: 37.27855,
    longitude: -89.1556,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62992',
  },
  {
    city: 'Vergennes',
    county_fips: 17077,
    county_fips_all: '17077',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"17077": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 37.90593,
    longitude: -89.34664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62994',
  },
  {
    city: 'Vienna',
    county_fips: 17087,
    county_fips_all: '17087',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"17087": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 37.41945,
    longitude: -88.88244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62995',
  },
  {
    city: 'Villa Ridge',
    county_fips: 17153,
    county_fips_all: '17153',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"17153": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 37.16624,
    longitude: -89.15984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62996',
  },
  {
    city: 'Willisville',
    county_fips: 17145,
    county_fips_all: '17145',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"17145": 100}',
    density: 459.5,
    imprecise: false,
    latitude: 37.98357,
    longitude: -89.59013,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62997',
  },
  {
    city: 'Wolf Lake',
    county_fips: 17181,
    county_fips_all: '17181',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"17181": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 37.51649,
    longitude: -89.44698,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62998',
  },
  {
    city: 'Zeigler',
    county_fips: 17055,
    county_fips_all: '17055',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"17055": 100}',
    density: 226.7,
    imprecise: false,
    latitude: 37.89122,
    longitude: -89.05275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62999',
  },
  {
    city: 'Chesterfield',
    county_fips: 29189,
    county_fips_all: '29189|29071',
    county: 'St. Louis',
    county_names_all: 'St. Louis|Franklin',
    county_weights: '{"29189": 97.47, "29071": 2.53}',
    density: 209.2,
    imprecise: false,
    latitude: 38.64306,
    longitude: -90.64982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63005',
  },
  {
    city: 'Arnold',
    county_fips: 29099,
    county_fips_all: '29099|29189',
    county: 'Jefferson',
    county_names_all: 'Jefferson|St. Louis',
    county_weights: '{"29099": 99.74, "29189": 0.26}',
    density: 617.6,
    imprecise: false,
    latitude: 38.42964,
    longitude: -90.3932,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63010',
  },
  {
    city: 'Ballwin',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 972.1,
    imprecise: false,
    latitude: 38.60337,
    longitude: -90.55847,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63011',
  },
  {
    city: 'Barnhart',
    county_fips: 29099,
    county_fips_all: '29099',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"29099": 100}',
    density: 158.4,
    imprecise: false,
    latitude: 38.33532,
    longitude: -90.44832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63012',
  },
  {
    city: 'Beaufort',
    county_fips: 29071,
    county_fips_all: '29071',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"29071": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 38.41776,
    longitude: -91.15182,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63013',
  },
  {
    city: 'Berger',
    county_fips: 29071,
    county_fips_all: '29071|29073',
    county: 'Franklin',
    county_names_all: 'Franklin|Gasconade',
    county_weights: '{"29071": 97.62, "29073": 2.38}',
    density: 4.4,
    imprecise: false,
    latitude: 38.64892,
    longitude: -91.31566,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63014',
  },
  {
    city: 'Catawissa',
    county_fips: 29071,
    county_fips_all: '29071|29099',
    county: 'Franklin',
    county_names_all: 'Franklin|Jefferson',
    county_weights: '{"29071": 65.01, "29099": 34.99}',
    density: 46.4,
    imprecise: false,
    latitude: 38.39633,
    longitude: -90.75274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63015',
  },
  {
    city: 'Cedar Hill',
    county_fips: 29099,
    county_fips_all: '29099',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"29099": 100}',
    density: 89.6,
    imprecise: false,
    latitude: 38.35692,
    longitude: -90.65014,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63016',
  },
  {
    city: 'Chesterfield',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 866.9,
    imprecise: false,
    latitude: 38.65143,
    longitude: -90.53722,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63017',
  },
  {
    city: 'Crystal City',
    county_fips: 29099,
    county_fips_all: '29099',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"29099": 100}',
    density: 515.1,
    imprecise: false,
    latitude: 38.229,
    longitude: -90.37684,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63019',
  },
  {
    city: 'De Soto',
    county_fips: 29099,
    county_fips_all: '29099|29221',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Washington',
    county_weights: '{"29099": 93.57, "29221": 6.43}',
    density: 52,
    imprecise: false,
    latitude: 38.10706,
    longitude: -90.5718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63020',
  },
  {
    city: 'Ballwin',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 984.9,
    imprecise: false,
    latitude: 38.5689,
    longitude: -90.54564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63021',
  },
  {
    city: 'Dittmer',
    county_fips: 29099,
    county_fips_all: '29099',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"29099": 100}',
    density: 30,
    imprecise: false,
    latitude: 38.2659,
    longitude: -90.71292,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63023',
  },
  {
    city: 'Eureka',
    county_fips: 29189,
    county_fips_all: '29189|29099',
    county: 'St. Louis',
    county_names_all: 'St. Louis|Jefferson',
    county_weights: '{"29189": 57.35, "29099": 42.65}',
    density: 180.7,
    imprecise: false,
    latitude: 38.4896,
    longitude: -90.61666,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63025',
  },
  {
    city: 'Fenton',
    county_fips: 29189,
    county_fips_all: '29189|29099',
    county: 'St. Louis',
    county_names_all: 'St. Louis|Jefferson',
    county_weights: '{"29189": 50.17, "29099": 49.83}',
    density: 691.9,
    imprecise: false,
    latitude: 38.50195,
    longitude: -90.45995,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63026',
  },
  {
    city: 'Festus',
    county_fips: 29099,
    county_fips_all: '29099|29186|29187',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Ste. Genevieve|St. Francois',
    county_weights: '{"29099": 83.4, "29186": 16.06, "29187": 0.54}',
    density: 87.3,
    imprecise: false,
    latitude: 38.14545,
    longitude: -90.39423,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63028',
  },
  {
    city: 'Fletcher',
    county_fips: 29221,
    county_fips_all: '29221|29099',
    county: 'Washington',
    county_names_all: 'Washington|Jefferson',
    county_weights: '{"29221": 93.78, "29099": 6.22}',
    density: 26.9,
    imprecise: false,
    latitude: 38.14321,
    longitude: -90.7522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63030',
  },
  {
    city: 'Florissant',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 1286.9,
    imprecise: false,
    latitude: 38.81392,
    longitude: -90.35224,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63031',
  },
  {
    city: 'Florissant',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 1366.4,
    imprecise: false,
    latitude: 38.7958,
    longitude: -90.27786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63033',
  },
  {
    city: 'Florissant',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 389.8,
    imprecise: false,
    latitude: 38.84795,
    longitude: -90.28692,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63034',
  },
  {
    city: 'French Village',
    county_fips: 29187,
    county_fips_all: '29187|29186',
    county: 'St. Francois',
    county_names_all: 'St. Francois|Ste. Genevieve',
    county_weights: '{"29187": 75.19, "29186": 24.81}',
    density: 15.8,
    imprecise: false,
    latitude: 37.9817,
    longitude: -90.372,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63036',
  },
  {
    city: 'Gerald',
    county_fips: 29071,
    county_fips_all: '29071|29073',
    county: 'Franklin',
    county_names_all: 'Franklin|Gasconade',
    county_weights: '{"29071": 98.55, "29073": 1.45}',
    density: 14.3,
    imprecise: false,
    latitude: 38.42497,
    longitude: -91.3165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63037',
  },
  {
    city: 'Wildwood',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 131.6,
    imprecise: false,
    latitude: 38.58071,
    longitude: -90.67037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63038',
  },
  {
    city: 'Gray Summit',
    county_fips: 29071,
    county_fips_all: '29071',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"29071": 100}',
    density: 85.7,
    imprecise: false,
    latitude: 38.49532,
    longitude: -90.83527,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63039',
  },
  {
    city: 'Wildwood',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 745.5,
    imprecise: false,
    latitude: 38.57298,
    longitude: -90.63512,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63040',
  },
  {
    city: 'Grubville',
    county_fips: 29071,
    county_fips_all: '29071|29099',
    county: 'Franklin',
    county_names_all: 'Franklin|Jefferson',
    county_weights: '{"29071": 97.45, "29099": 2.55}',
    density: 9.2,
    imprecise: false,
    latitude: 38.2522,
    longitude: -90.79059,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63041',
  },
  {
    city: 'Hazelwood',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 664.2,
    imprecise: false,
    latitude: 38.78133,
    longitude: -90.37909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63042',
  },
  {
    city: 'Maryland Heights',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 674.7,
    imprecise: false,
    latitude: 38.72962,
    longitude: -90.45659,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63043',
  },
  {
    city: 'Bridgeton',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 238.7,
    imprecise: false,
    latitude: 38.77455,
    longitude: -90.42825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63044',
  },
  {
    city: 'Hematite',
    county_fips: 29099,
    county_fips_all: '29099',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"29099": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.1954,
    longitude: -90.48763,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63047',
  },
  {
    city: 'Herculaneum',
    county_fips: 29099,
    county_fips_all: '29099',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"29099": 100}',
    density: 450.8,
    imprecise: false,
    latitude: 38.25924,
    longitude: -90.39194,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63048',
  },
  {
    city: 'High Ridge',
    county_fips: 29099,
    county_fips_all: '29099|29189',
    county: 'Jefferson',
    county_names_all: 'Jefferson|St. Louis',
    county_weights: '{"29099": 80.37, "29189": 19.63}',
    density: 257,
    imprecise: false,
    latitude: 38.47795,
    longitude: -90.52867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63049',
  },
  {
    city: 'Hillsboro',
    county_fips: 29099,
    county_fips_all: '29099',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"29099": 100}',
    density: 78.7,
    imprecise: false,
    latitude: 38.25977,
    longitude: -90.57628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63050',
  },
  {
    city: 'House Springs',
    county_fips: 29099,
    county_fips_all: '29099',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"29099": 100}',
    density: 120.6,
    imprecise: false,
    latitude: 38.39886,
    longitude: -90.57303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63051',
  },
  {
    city: 'Imperial',
    county_fips: 29099,
    county_fips_all: '29099',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"29099": 100}',
    density: 335,
    imprecise: false,
    latitude: 38.38983,
    longitude: -90.4358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63052',
  },
  {
    city: 'Kimmswick',
    county_fips: 29099,
    county_fips_all: '29099',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"29099": 100}',
    density: 756.9,
    imprecise: false,
    latitude: 38.36651,
    longitude: -90.36402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63053',
  },
  {
    city: 'Labadie',
    county_fips: 29071,
    county_fips_all: '29071',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"29071": 100}',
    density: 24.2,
    imprecise: false,
    latitude: 38.53254,
    longitude: -90.8382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63055',
  },
  {
    city: 'Leslie',
    county_fips: 29071,
    county_fips_all: '29071',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"29071": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 38.38964,
    longitude: -91.22072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63056',
  },
  {
    city: 'Lonedell',
    county_fips: 29071,
    county_fips_all: '29071',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"29071": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 38.25656,
    longitude: -90.86815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63060',
  },
  {
    city: 'New Haven',
    county_fips: 29071,
    county_fips_all: '29071|29073',
    county: 'Franklin',
    county_names_all: 'Franklin|Gasconade',
    county_weights: '{"29071": 96.24, "29073": 3.76}',
    density: 26.1,
    imprecise: false,
    latitude: 38.55747,
    longitude: -91.24761,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63068',
  },
  {
    city: 'Pacific',
    county_fips: 29071,
    county_fips_all: '29071|29189|29099',
    county: 'Franklin',
    county_names_all: 'Franklin|St. Louis|Jefferson',
    county_weights: '{"29071": 43.01, "29189": 33.1, "29099": 23.89}',
    density: 88.4,
    imprecise: false,
    latitude: 38.48286,
    longitude: -90.7292,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63069',
  },
  {
    city: 'Pevely',
    county_fips: 29099,
    county_fips_all: '29099',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"29099": 100}',
    density: 216.3,
    imprecise: false,
    latitude: 38.28625,
    longitude: -90.41822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63070',
  },
  {
    city: 'Richwoods',
    county_fips: 29221,
    county_fips_all: '29221',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"29221": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 38.15635,
    longitude: -90.82558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63071',
  },
  {
    city: 'Robertsville',
    county_fips: 29071,
    county_fips_all: '29071|29099',
    county: 'Franklin',
    county_names_all: 'Franklin|Jefferson',
    county_weights: '{"29071": 96.96, "29099": 3.04}',
    density: 32.6,
    imprecise: false,
    latitude: 38.36635,
    longitude: -90.81354,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63072',
  },
  {
    city: 'Saint Albans',
    county_fips: 29071,
    county_fips_all: '29071',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"29071": 100}',
    density: 29.8,
    imprecise: false,
    latitude: 38.58367,
    longitude: -90.76933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63073',
  },
  {
    city: 'Saint Ann',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 1556.7,
    imprecise: false,
    latitude: 38.72637,
    longitude: -90.38895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63074',
  },
  {
    city: 'Saint Clair',
    county_fips: 29071,
    county_fips_all: '29071',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"29071": 100}',
    density: 50.2,
    imprecise: false,
    latitude: 38.32648,
    longitude: -90.98537,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63077',
  },
  {
    city: 'Stanton',
    county_fips: 29071,
    county_fips_all: '29071',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"29071": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 38.26632,
    longitude: -91.1001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63079',
  },
  {
    city: 'Sullivan',
    county_fips: 29071,
    county_fips_all: '29071|29221|29055',
    county: 'Franklin',
    county_names_all: 'Franklin|Washington|Crawford',
    county_weights: '{"29071": 56.65, "29221": 39.32, "29055": 4.03}',
    density: 20.4,
    imprecise: false,
    latitude: 38.20828,
    longitude: -91.08802,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63080',
  },
  {
    city: 'Union',
    county_fips: 29071,
    county_fips_all: '29071',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"29071": 100}',
    density: 104.8,
    imprecise: false,
    latitude: 38.41749,
    longitude: -91.01438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63084',
  },
  {
    city: 'Valles Mines',
    county_fips: 29187,
    county_fips_all: '29187|29099',
    county: 'St. Francois',
    county_names_all: 'St. Francois|Jefferson',
    county_weights: '{"29187": 91.17, "29099": 8.83}',
    density: 25.2,
    imprecise: false,
    latitude: 38.00888,
    longitude: -90.45835,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63087',
  },
  {
    city: 'Valley Park',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 660.8,
    imprecise: false,
    latitude: 38.54862,
    longitude: -90.50111,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63088',
  },
  {
    city: 'Villa Ridge',
    county_fips: 29071,
    county_fips_all: '29071',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"29071": 100}',
    density: 59.1,
    imprecise: false,
    latitude: 38.45846,
    longitude: -90.88286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63089',
  },
  {
    city: 'Washington',
    county_fips: 29071,
    county_fips_all: '29071',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"29071": 100}',
    density: 110.1,
    imprecise: false,
    latitude: 38.53176,
    longitude: -91.05047,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63090',
  },
  {
    city: 'Rosebud',
    county_fips: 29073,
    county_fips_all: '29073|29071',
    county: 'Gasconade',
    county_names_all: 'Gasconade|Franklin',
    county_weights: '{"29073": 79.67, "29071": 20.33}',
    density: 10.9,
    imprecise: false,
    latitude: 38.36581,
    longitude: -91.39013,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63091',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 3338.4,
    imprecise: false,
    latitude: 38.63127,
    longitude: -90.19275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63101',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 785.8,
    imprecise: false,
    latitude: 38.63453,
    longitude: -90.18627,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63102',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 1542.6,
    imprecise: false,
    latitude: 38.62986,
    longitude: -90.217,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63103',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 2181.6,
    imprecise: false,
    latitude: 38.61078,
    longitude: -90.21276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63104',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189|29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis|St. Louis',
    county_weights: '{"29189": 95.71, "29510": 4.29}',
    density: 2898.4,
    imprecise: false,
    latitude: 38.64427,
    longitude: -90.32812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63105',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 1169.4,
    imprecise: false,
    latitude: 38.64445,
    longitude: -90.20795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63106',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 1467.4,
    imprecise: false,
    latitude: 38.66373,
    longitude: -90.21201,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63107',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 3673.9,
    imprecise: false,
    latitude: 38.64485,
    longitude: -90.25337,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63108',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 2755.4,
    imprecise: false,
    latitude: 38.58483,
    longitude: -90.29563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63109',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 1037.1,
    imprecise: false,
    latitude: 38.62538,
    longitude: -90.26645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63110',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 2266.6,
    imprecise: false,
    latitude: 38.55845,
    longitude: -90.24993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63111',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 2186.7,
    imprecise: false,
    latitude: 38.66,
    longitude: -90.28331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63112',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 1529.8,
    imprecise: false,
    latitude: 38.65797,
    longitude: -90.2475,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63113',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 1484.7,
    imprecise: false,
    latitude: 38.70218,
    longitude: -90.36224,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63114',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 1303.7,
    imprecise: false,
    latitude: 38.68211,
    longitude: -90.23994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63115',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 3014.5,
    imprecise: false,
    latitude: 38.57999,
    longitude: -90.26501,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63116',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189|29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis|St. Louis',
    county_weights: '{"29189": 94.46, "29510": 5.54}',
    density: 1511.1,
    imprecise: false,
    latitude: 38.63077,
    longitude: -90.33037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63117',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 2942.4,
    imprecise: false,
    latitude: 38.59237,
    longitude: -90.22534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63118',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189|29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis|St. Louis',
    county_weights: '{"29189": 99.01, "29510": 0.99}',
    density: 1574.6,
    imprecise: false,
    latitude: 38.58868,
    longitude: -90.35104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63119',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510|29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis|St. Louis',
    county_weights: '{"29510": 93.33, "29189": 6.67}',
    density: 1099.3,
    imprecise: false,
    latitude: 38.69061,
    longitude: -90.26211,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63120',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 1426,
    imprecise: false,
    latitude: 38.70739,
    longitude: -90.30023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63121',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 1110,
    imprecise: false,
    latitude: 38.57853,
    longitude: -90.42133,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63122',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189|29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis|St. Louis',
    county_weights: '{"29189": 94.39, "29510": 5.61}',
    density: 1521.5,
    imprecise: false,
    latitude: 38.54949,
    longitude: -90.32739,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63123',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 468.7,
    imprecise: false,
    latitude: 38.63832,
    longitude: -90.38023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63124',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189|29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis|St. Louis',
    county_weights: '{"29189": 98.65, "29510": 1.35}',
    density: 1292.8,
    imprecise: false,
    latitude: 38.51867,
    longitude: -90.29269,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63125',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 1297.3,
    imprecise: false,
    latitude: 38.5496,
    longitude: -90.37868,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63126',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 351.3,
    imprecise: false,
    latitude: 38.53544,
    longitude: -90.41297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63127',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 756.2,
    imprecise: false,
    latitude: 38.49369,
    longitude: -90.38306,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63128',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 952.1,
    imprecise: false,
    latitude: 38.45654,
    longitude: -90.32202,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63129',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189|29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis|St. Louis',
    county_weights: '{"29189": 98.06, "29510": 1.94}',
    density: 2215.4,
    imprecise: false,
    latitude: 38.66491,
    longitude: -90.32495,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63130',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 508.1,
    imprecise: false,
    latitude: 38.6172,
    longitude: -90.44365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63131',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 1060.4,
    imprecise: false,
    latitude: 38.67607,
    longitude: -90.37745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63132',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189|29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis|St. Louis',
    county_weights: '{"29189": 99.33, "29510": 0.67}',
    density: 779.3,
    imprecise: false,
    latitude: 38.68226,
    longitude: -90.30677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63133',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 608.3,
    imprecise: false,
    latitude: 38.74319,
    longitude: -90.34549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63134',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 1143.6,
    imprecise: false,
    latitude: 38.75012,
    longitude: -90.29934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63135',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189|29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis|St. Louis',
    county_weights: '{"29189": 96.0, "29510": 4.0}',
    density: 1448,
    imprecise: false,
    latitude: 38.74418,
    longitude: -90.25979,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63136',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189|29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis|St. Louis',
    county_weights: '{"29189": 73.05, "29510": 26.95}',
    density: 1073.6,
    imprecise: false,
    latitude: 38.74974,
    longitude: -90.21297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63137',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189|29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis|St. Louis',
    county_weights: '{"29189": 97.98, "29510": 2.02}',
    density: 379.8,
    imprecise: false,
    latitude: 38.79904,
    longitude: -90.1822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63138',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 2187.6,
    imprecise: false,
    latitude: 38.61041,
    longitude: -90.29191,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63139',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 550.1,
    imprecise: false,
    latitude: 38.65751,
    longitude: -90.45904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63141',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189|29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis|St. Louis',
    county_weights: '{"29189": 74.49, "29510": 25.51}',
    density: 1690.8,
    imprecise: false,
    latitude: 38.61169,
    longitude: -90.32017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63143',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 1611.9,
    imprecise: false,
    latitude: 38.61943,
    longitude: -90.3482,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63144',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 763.3,
    imprecise: false,
    latitude: 38.70135,
    longitude: -90.47634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63146',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 531.5,
    imprecise: false,
    latitude: 38.69567,
    longitude: -90.21589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63147',
  },
  {
    city: 'Saint Charles',
    county_fips: 29183,
    county_fips_all: '29183',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"29183": 100}',
    density: 241.1,
    imprecise: false,
    latitude: 38.86159,
    longitude: -90.47207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63301',
  },
  {
    city: 'Saint Charles',
    county_fips: 29183,
    county_fips_all: '29183',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"29183": 100}',
    density: 900.8,
    imprecise: false,
    latitude: 38.74013,
    longitude: -90.54266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63303',
  },
  {
    city: 'Saint Charles',
    county_fips: 29183,
    county_fips_all: '29183',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"29183": 100}',
    density: 302.7,
    imprecise: false,
    latitude: 38.70583,
    longitude: -90.68666,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63304',
  },
  {
    city: 'Annada',
    county_fips: 29163,
    county_fips_all: '29163',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"29163": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 39.26151,
    longitude: -90.79214,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63330',
  },
  {
    city: 'Augusta',
    county_fips: 29183,
    county_fips_all: '29183',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"29183": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 38.60137,
    longitude: -90.89195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63332',
  },
  {
    city: 'Bellflower',
    county_fips: 29139,
    county_fips_all: '29139|29113',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Lincoln',
    county_weights: '{"29139": 92.78, "29113": 7.22}',
    density: 5.6,
    imprecise: false,
    latitude: 39.0351,
    longitude: -91.32014,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63333',
  },
  {
    city: 'Bowling Green',
    county_fips: 29163,
    county_fips_all: '29163|29113',
    county: 'Pike',
    county_names_all: 'Pike|Lincoln',
    county_weights: '{"29163": 94.91, "29113": 5.09}',
    density: 17.6,
    imprecise: false,
    latitude: 39.30747,
    longitude: -91.18838,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63334',
  },
  {
    city: 'Clarksville',
    county_fips: 29163,
    county_fips_all: '29163',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"29163": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 39.33335,
    longitude: -90.9388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63336',
  },
  {
    city: 'Curryville',
    county_fips: 29163,
    county_fips_all: '29163',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"29163": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 39.33673,
    longitude: -91.36384,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63339',
  },
  {
    city: 'Defiance',
    county_fips: 29183,
    county_fips_all: '29183',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"29183": 100}',
    density: 34.9,
    imprecise: false,
    latitude: 38.66493,
    longitude: -90.81783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63341',
  },
  {
    city: 'Elsberry',
    county_fips: 29113,
    county_fips_all: '29113|29163',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Pike',
    county_weights: '{"29113": 92.87, "29163": 7.13}',
    density: 15.2,
    imprecise: false,
    latitude: 39.15775,
    longitude: -90.82815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63343',
  },
  {
    city: 'Eolia',
    county_fips: 29163,
    county_fips_all: '29163|29113',
    county: 'Pike',
    county_names_all: 'Pike|Lincoln',
    county_weights: '{"29163": 53.11, "29113": 46.89}',
    density: 6.8,
    imprecise: false,
    latitude: 39.23078,
    longitude: -91.01115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63344',
  },
  {
    city: 'Farber',
    county_fips: 29007,
    county_fips_all: '29007',
    county: 'Audrain',
    county_names_all: 'Audrain',
    county_weights: '{"29007": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 39.27599,
    longitude: -91.57311,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63345',
  },
  {
    city: 'Foley',
    county_fips: 29113,
    county_fips_all: '29113',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"29113": 100}',
    density: 33.2,
    imprecise: false,
    latitude: 39.0708,
    longitude: -90.76352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63347',
  },
  {
    city: 'Foristell',
    county_fips: 29183,
    county_fips_all: '29183|29219|29113',
    county: 'St. Charles',
    county_names_all: 'St. Charles|Warren|Lincoln',
    county_weights: '{"29183": 77.92, "29219": 19.96, "29113": 2.12}',
    density: 71.8,
    imprecise: false,
    latitude: 38.78969,
    longitude: -90.94131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63348',
  },
  {
    city: 'Hawk Point',
    county_fips: 29113,
    county_fips_all: '29113|29219',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Warren',
    county_weights: '{"29113": 90.83, "29219": 9.17}',
    density: 24.9,
    imprecise: false,
    latitude: 38.97979,
    longitude: -91.15083,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63349',
  },
  {
    city: 'High Hill',
    county_fips: 29139,
    county_fips_all: '29139',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"29139": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 38.90243,
    longitude: -91.35686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63350',
  },
  {
    city: 'Jonesburg',
    county_fips: 29219,
    county_fips_all: '29219|29139',
    county: 'Warren',
    county_names_all: 'Warren|Montgomery',
    county_weights: '{"29219": 54.94, "29139": 45.06}',
    density: 9.7,
    imprecise: false,
    latitude: 38.86041,
    longitude: -91.31186,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63351',
  },
  {
    city: 'Laddonia',
    county_fips: 29007,
    county_fips_all: '29007|29173',
    county: 'Audrain',
    county_names_all: 'Audrain|Ralls',
    county_weights: '{"29007": 89.61, "29173": 10.39}',
    density: 3.7,
    imprecise: false,
    latitude: 39.25097,
    longitude: -91.65526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63352',
  },
  {
    city: 'Louisiana',
    county_fips: 29163,
    county_fips_all: '29163',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"29163": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 39.44375,
    longitude: -91.12,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63353',
  },
  {
    city: 'Marthasville',
    county_fips: 29219,
    county_fips_all: '29219|29183',
    county: 'Warren',
    county_names_all: 'Warren|St. Charles',
    county_weights: '{"29219": 96.36, "29183": 3.64}',
    density: 20.5,
    imprecise: false,
    latitude: 38.65518,
    longitude: -91.0947,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63357',
  },
  {
    city: 'Middletown',
    county_fips: 29163,
    county_fips_all: '29163|29139|29007|29113',
    county: 'Pike',
    county_names_all: 'Pike|Montgomery|Audrain|Lincoln',
    county_weights:
      '{"29163": 52.57, "29139": 36.32, "29007": 8.21, "29113": 2.9}',
    density: 4.3,
    imprecise: false,
    latitude: 39.1564,
    longitude: -91.34652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63359',
  },
  {
    city: 'Montgomery City',
    county_fips: 29139,
    county_fips_all: '29139|29027',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Callaway',
    county_weights: '{"29139": 76.0, "29027": 24.0}',
    density: 10.7,
    imprecise: false,
    latitude: 38.95802,
    longitude: -91.56056,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63361',
  },
  {
    city: 'Moscow Mills',
    county_fips: 29113,
    county_fips_all: '29113',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"29113": 100}',
    density: 100.9,
    imprecise: false,
    latitude: 38.93276,
    longitude: -90.88227,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63362',
  },
  {
    city: 'New Florence',
    county_fips: 29139,
    county_fips_all: '29139|29219',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Warren',
    county_weights: '{"29139": 96.15, "29219": 3.85}',
    density: 4.2,
    imprecise: false,
    latitude: 38.88187,
    longitude: -91.45755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63363',
  },
  {
    city: 'New Melle',
    county_fips: 29183,
    county_fips_all: '29183',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"29183": 100}',
    density: 59.8,
    imprecise: false,
    latitude: 38.70961,
    longitude: -90.87334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63365',
  },
  {
    city: "O'Fallon",
    county_fips: 29183,
    county_fips_all: '29183',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"29183": 100}',
    density: 305.2,
    imprecise: false,
    latitude: 38.85918,
    longitude: -90.71964,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63366',
  },
  {
    city: 'Lake Saint Louis',
    county_fips: 29183,
    county_fips_all: '29183',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"29183": 100}',
    density: 886.2,
    imprecise: false,
    latitude: 38.77805,
    longitude: -90.79536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63367',
  },
  {
    city: "O'Fallon",
    county_fips: 29183,
    county_fips_all: '29183',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"29183": 100}',
    density: 1118.3,
    imprecise: false,
    latitude: 38.7516,
    longitude: -90.72895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63368',
  },
  {
    city: 'Old Monroe',
    county_fips: 29113,
    county_fips_all: '29113',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"29113": 100}',
    density: 38,
    imprecise: false,
    latitude: 38.93758,
    longitude: -90.77766,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63369',
  },
  {
    city: 'Portage Des Sioux',
    county_fips: 29183,
    county_fips_all: '29183',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"29183": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 38.92776,
    longitude: -90.39563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63373',
  },
  {
    city: 'Saint Peters',
    county_fips: 29183,
    county_fips_all: '29183',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"29183": 100}',
    density: 721.1,
    imprecise: false,
    latitude: 38.80022,
    longitude: -90.61636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63376',
  },
  {
    city: 'Silex',
    county_fips: 29113,
    county_fips_all: '29113',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"29113": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 39.11016,
    longitude: -91.10053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63377',
  },
  {
    city: 'Troy',
    county_fips: 29113,
    county_fips_all: '29113',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"29113": 100}',
    density: 78.8,
    imprecise: false,
    latitude: 38.99817,
    longitude: -90.99037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63379',
  },
  {
    city: 'Truesdale',
    county_fips: 29219,
    county_fips_all: '29219',
    county: 'Warren',
    county_names_all: 'Warren',
    county_weights: '{"29219": 100}',
    density: 308.9,
    imprecise: false,
    latitude: 38.81262,
    longitude: -91.12205,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63380',
  },
  {
    city: 'Truxton',
    county_fips: 29219,
    county_fips_all: '29219|29139|29113',
    county: 'Warren',
    county_names_all: 'Warren|Montgomery|Lincoln',
    county_weights: '{"29219": 34.36, "29139": 32.84, "29113": 32.8}',
    density: 8.5,
    imprecise: false,
    latitude: 38.98237,
    longitude: -91.25429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63381',
  },
  {
    city: 'Vandalia',
    county_fips: 29007,
    county_fips_all: '29007|29173|29163',
    county: 'Audrain',
    county_names_all: 'Audrain|Ralls|Pike',
    county_weights: '{"29007": 47.54, "29173": 41.09, "29163": 11.37}',
    density: 12.4,
    imprecise: false,
    latitude: 39.31104,
    longitude: -91.49042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63382',
  },
  {
    city: 'Warrenton',
    county_fips: 29219,
    county_fips_all: '29219|29113',
    county: 'Warren',
    county_names_all: 'Warren|Lincoln',
    county_weights: '{"29219": 97.34, "29113": 2.66}',
    density: 40.8,
    imprecise: false,
    latitude: 38.80726,
    longitude: -91.19319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63383',
  },
  {
    city: 'Wellsville',
    county_fips: 29139,
    county_fips_all: '29139|29007|29027',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Audrain|Callaway',
    county_weights: '{"29139": 82.27, "29007": 13.26, "29027": 4.47}',
    density: 9.5,
    imprecise: false,
    latitude: 39.08678,
    longitude: -91.56349,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63384',
  },
  {
    city: 'Wentzville',
    county_fips: 29183,
    county_fips_all: '29183',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"29183": 100}',
    density: 296.7,
    imprecise: false,
    latitude: 38.79732,
    longitude: -90.85649,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63385',
  },
  {
    city: 'West Alton',
    county_fips: 29183,
    county_fips_all: '29183',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"29183": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 38.87104,
    longitude: -90.22009,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63386',
  },
  {
    city: 'Whiteside',
    county_fips: 29113,
    county_fips_all: '29113',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"29113": 100}',
    density: 445.8,
    imprecise: false,
    latitude: 39.18415,
    longitude: -91.01677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63387',
  },
  {
    city: 'Williamsburg',
    county_fips: 29027,
    county_fips_all: '29027',
    county: 'Callaway',
    county_names_all: 'Callaway',
    county_weights: '{"29027": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 38.88816,
    longitude: -91.74995,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63388',
  },
  {
    city: 'Winfield',
    county_fips: 29113,
    county_fips_all: '29113',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"29113": 100}',
    density: 66.5,
    imprecise: false,
    latitude: 38.99969,
    longitude: -90.76875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63389',
  },
  {
    city: 'Wright City',
    county_fips: 29219,
    county_fips_all: '29219|29113',
    county: 'Warren',
    county_names_all: 'Warren|Lincoln',
    county_weights: '{"29219": 87.99, "29113": 12.01}',
    density: 54.1,
    imprecise: false,
    latitude: 38.80499,
    longitude: -91.0413,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63390',
  },
  {
    city: 'Hannibal',
    county_fips: 29127,
    county_fips_all: '29127|29173',
    county: 'Marion',
    county_names_all: 'Marion|Ralls',
    county_weights: '{"29127": 50.13, "29173": 49.87}',
    density: 74.8,
    imprecise: false,
    latitude: 39.69046,
    longitude: -91.45986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63401',
  },
  {
    city: 'Alexandria',
    county_fips: 29045,
    county_fips_all: '29045',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"29045": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 40.38972,
    longitude: -91.53958,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63430',
  },
  {
    city: 'Arbela',
    county_fips: 29199,
    county_fips_all: '29199|29045',
    county: 'Scotland',
    county_names_all: 'Scotland|Clark',
    county_weights: '{"29199": 87.62, "29045": 12.38}',
    density: 1.7,
    imprecise: false,
    latitude: 40.50058,
    longitude: -91.99551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63432',
  },
  {
    city: 'Ashburn',
    county_fips: 29163,
    county_fips_all: '29163',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"29163": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.51838,
    longitude: -91.11816,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63433',
  },
  {
    city: 'Bethel',
    county_fips: 29205,
    county_fips_all: '29205',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"29205": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 39.90591,
    longitude: -91.9507,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63434',
  },
  {
    city: 'Canton',
    county_fips: 29111,
    county_fips_all: '29111|29045',
    county: 'Lewis',
    county_names_all: 'Lewis|Clark',
    county_weights: '{"29111": 68.22, "29045": 31.78}',
    density: 11.5,
    imprecise: false,
    latitude: 40.20299,
    longitude: -91.58267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63435',
  },
  {
    city: 'Center',
    county_fips: 29173,
    county_fips_all: '29173',
    county: 'Ralls',
    county_names_all: 'Ralls',
    county_weights: '{"29173": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 39.50093,
    longitude: -91.54524,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63436',
  },
  {
    city: 'Clarence',
    county_fips: 29205,
    county_fips_all: '29205|29137|29121',
    county: 'Shelby',
    county_names_all: 'Shelby|Monroe|Macon',
    county_weights: '{"29205": 86.85, "29137": 8.46, "29121": 4.69}',
    density: 4.8,
    imprecise: false,
    latitude: 39.72576,
    longitude: -92.23679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63437',
  },
  {
    city: 'Durham',
    county_fips: 29111,
    county_fips_all: '29111|29127',
    county: 'Lewis',
    county_names_all: 'Lewis|Marion',
    county_weights: '{"29111": 67.35, "29127": 32.65}',
    density: 6.8,
    imprecise: false,
    latitude: 39.96084,
    longitude: -91.68828,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63438',
  },
  {
    city: 'Emden',
    county_fips: 29205,
    county_fips_all: '29205|29127',
    county: 'Shelby',
    county_names_all: 'Shelby|Marion',
    county_weights: '{"29205": 72.32, "29127": 27.68}',
    density: 3.3,
    imprecise: false,
    latitude: 39.80382,
    longitude: -91.85963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63439',
  },
  {
    city: 'Ewing',
    county_fips: 29111,
    county_fips_all: '29111|29127|29205',
    county: 'Lewis',
    county_names_all: 'Lewis|Marion|Shelby',
    county_weights: '{"29111": 72.07, "29127": 25.61, "29205": 2.32}',
    density: 5,
    imprecise: false,
    latitude: 39.97551,
    longitude: -91.75376,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63440',
  },
  {
    city: 'Frankford',
    county_fips: 29163,
    county_fips_all: '29163|29173',
    county: 'Pike',
    county_names_all: 'Pike|Ralls',
    county_weights: '{"29163": 90.04, "29173": 9.96}',
    density: 4.5,
    imprecise: false,
    latitude: 39.4766,
    longitude: -91.31575,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63441',
  },
  {
    city: 'Hunnewell',
    county_fips: 29137,
    county_fips_all: '29137|29205|29127',
    county: 'Monroe',
    county_names_all: 'Monroe|Shelby|Marion',
    county_weights: '{"29137": 48.68, "29205": 33.6, "29127": 17.72}',
    density: 3,
    imprecise: false,
    latitude: 39.66222,
    longitude: -91.86697,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63443',
  },
  {
    city: 'Kahoka',
    county_fips: 29045,
    county_fips_all: '29045',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"29045": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 40.39681,
    longitude: -91.72044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63445',
  },
  {
    city: 'Knox City',
    county_fips: 29103,
    county_fips_all: '29103|29111',
    county: 'Knox',
    county_names_all: 'Knox|Lewis',
    county_weights: '{"29103": 91.88, "29111": 8.12}',
    density: 1.8,
    imprecise: false,
    latitude: 40.13972,
    longitude: -92.0055,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63446',
  },
  {
    city: 'La Belle',
    county_fips: 29111,
    county_fips_all: '29111|29103',
    county: 'Lewis',
    county_names_all: 'Lewis|Knox',
    county_weights: '{"29111": 95.54, "29103": 4.46}',
    density: 4.5,
    imprecise: false,
    latitude: 40.09251,
    longitude: -91.90494,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63447',
  },
  {
    city: 'La Grange',
    county_fips: 29111,
    county_fips_all: '29111',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"29111": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 40.02168,
    longitude: -91.55416,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63448',
  },
  {
    city: 'Lentner',
    county_fips: 29205,
    county_fips_all: '29205|29137',
    county: 'Shelby',
    county_names_all: 'Shelby|Monroe',
    county_weights: '{"29205": 56.4, "29137": 43.6}',
    density: 2.2,
    imprecise: false,
    latitude: 39.66808,
    longitude: -92.14857,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63450',
  },
  {
    city: 'Leonard',
    county_fips: 29205,
    county_fips_all: '29205|29103',
    county: 'Shelby',
    county_names_all: 'Shelby|Knox',
    county_weights: '{"29205": 90.34, "29103": 9.66}',
    density: 1,
    imprecise: false,
    latitude: 39.91135,
    longitude: -92.19728,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63451',
  },
  {
    city: 'Lewistown',
    county_fips: 29111,
    county_fips_all: '29111',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"29111": 100}',
    density: 4,
    imprecise: false,
    latitude: 40.09316,
    longitude: -91.78551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63452',
  },
  {
    city: 'Luray',
    county_fips: 29045,
    county_fips_all: '29045',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"29045": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 40.49511,
    longitude: -91.86495,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63453',
  },
  {
    city: 'Maywood',
    county_fips: 29127,
    county_fips_all: '29127|29111',
    county: 'Marion',
    county_names_all: 'Marion|Lewis',
    county_weights: '{"29127": 71.65, "29111": 28.35}',
    density: 10.2,
    imprecise: false,
    latitude: 39.92389,
    longitude: -91.64897,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63454',
  },
  {
    city: 'Monroe City',
    county_fips: 29127,
    county_fips_all: '29127|29173|29137',
    county: 'Marion',
    county_names_all: 'Marion|Ralls|Monroe',
    county_weights: '{"29127": 38.24, "29173": 35.11, "29137": 26.64}',
    density: 10.1,
    imprecise: false,
    latitude: 39.65364,
    longitude: -91.72693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63456',
  },
  {
    city: 'Monticello',
    county_fips: 29111,
    county_fips_all: '29111',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"29111": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 40.17272,
    longitude: -91.70115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63457',
  },
  {
    city: 'Newark',
    county_fips: 29103,
    county_fips_all: '29103',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"29103": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 39.98751,
    longitude: -92.01745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63458',
  },
  {
    city: 'New London',
    county_fips: 29173,
    county_fips_all: '29173|29163',
    county: 'Ralls',
    county_names_all: 'Ralls|Pike',
    county_weights: '{"29173": 91.45, "29163": 8.55}',
    density: 12.3,
    imprecise: false,
    latitude: 39.58392,
    longitude: -91.3795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63459',
  },
  {
    city: 'Novelty',
    county_fips: 29103,
    county_fips_all: '29103',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"29103": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 40.00237,
    longitude: -92.21002,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63460',
  },
  {
    city: 'Palmyra',
    county_fips: 29127,
    county_fips_all: '29127',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"29127": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 39.79757,
    longitude: -91.55577,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63461',
  },
  {
    city: 'Perry',
    county_fips: 29173,
    county_fips_all: '29173|29137',
    county: 'Ralls',
    county_names_all: 'Ralls|Monroe',
    county_weights: '{"29173": 58.58, "29137": 41.42}',
    density: 4.1,
    imprecise: false,
    latitude: 39.42279,
    longitude: -91.69977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63462',
  },
  {
    city: 'Philadelphia',
    county_fips: 29127,
    county_fips_all: '29127',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"29127": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 39.84533,
    longitude: -91.75976,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63463',
  },
  {
    city: 'Revere',
    county_fips: 29045,
    county_fips_all: '29045',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"29045": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 40.52307,
    longitude: -91.6898,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63465',
  },
  {
    city: 'Saint Patrick',
    county_fips: 29045,
    county_fips_all: '29045',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"29045": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.26627,
    longitude: -91.61751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63466',
  },
  {
    city: 'Saverton',
    county_fips: 29173,
    county_fips_all: '29173',
    county: 'Ralls',
    county_names_all: 'Ralls',
    county_weights: '{"29173": 100}',
    density: 24,
    imprecise: false,
    latitude: 39.64849,
    longitude: -91.26655,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63467',
  },
  {
    city: 'Shelbina',
    county_fips: 29205,
    county_fips_all: '29205|29137',
    county: 'Shelby',
    county_names_all: 'Shelby|Monroe',
    county_weights: '{"29205": 62.08, "29137": 37.92}',
    density: 6.1,
    imprecise: false,
    latitude: 39.67857,
    longitude: -92.01267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63468',
  },
  {
    city: 'Shelbyville',
    county_fips: 29205,
    county_fips_all: '29205|29103',
    county: 'Shelby',
    county_names_all: 'Shelby|Knox',
    county_weights: '{"29205": 97.04, "29103": 2.96}',
    density: 2.7,
    imprecise: false,
    latitude: 39.8323,
    longitude: -92.04401,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63469',
  },
  {
    city: 'Taylor',
    county_fips: 29127,
    county_fips_all: '29127|29111',
    county: 'Marion',
    county_names_all: 'Marion|Lewis',
    county_weights: '{"29127": 77.73, "29111": 22.27}',
    density: 6.4,
    imprecise: false,
    latitude: 39.92511,
    longitude: -91.50652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63471',
  },
  {
    city: 'Wayland',
    county_fips: 29045,
    county_fips_all: '29045',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"29045": 100}',
    density: 203.1,
    imprecise: false,
    latitude: 40.4053,
    longitude: -91.57734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63472',
  },
  {
    city: 'Williamstown',
    county_fips: 29111,
    county_fips_all: '29111|29045',
    county: 'Lewis',
    county_names_all: 'Lewis|Clark',
    county_weights: '{"29111": 52.04, "29045": 47.96}',
    density: 2.3,
    imprecise: false,
    latitude: 40.25263,
    longitude: -91.77803,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63473',
  },
  {
    city: 'Wyaconda',
    county_fips: 29045,
    county_fips_all: '29045|29199|29111',
    county: 'Clark',
    county_names_all: 'Clark|Scotland|Lewis',
    county_weights: '{"29045": 93.81, "29199": 4.3, "29111": 1.89}',
    density: 2.2,
    imprecise: false,
    latitude: 40.3473,
    longitude: -91.89674,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63474',
  },
  {
    city: 'Kirksville',
    county_fips: 29001,
    county_fips_all: '29001',
    county: 'Adair',
    county_names_all: 'Adair',
    county_weights: '{"29001": 100}',
    density: 39.7,
    imprecise: false,
    latitude: 40.16745,
    longitude: -92.59078,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63501',
  },
  {
    city: 'Atlanta',
    county_fips: 29121,
    county_fips_all: '29121',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"29121": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 39.90732,
    longitude: -92.45037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63530',
  },
  {
    city: 'Baring',
    county_fips: 29103,
    county_fips_all: '29103|29199',
    county: 'Knox',
    county_names_all: 'Knox|Scotland',
    county_weights: '{"29103": 53.65, "29199": 46.35}',
    density: 1.8,
    imprecise: false,
    latitude: 40.30002,
    longitude: -92.25248,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63531',
  },
  {
    city: 'Bevier',
    county_fips: 29121,
    county_fips_all: '29121',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"29121": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 39.7677,
    longitude: -92.57434,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63532',
  },
  {
    city: 'Brashear',
    county_fips: 29001,
    county_fips_all: '29001|29103',
    county: 'Adair',
    county_names_all: 'Adair|Knox',
    county_weights: '{"29001": 91.18, "29103": 8.82}',
    density: 7,
    imprecise: false,
    latitude: 40.20471,
    longitude: -92.39608,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63533',
  },
  {
    city: 'Callao',
    county_fips: 29121,
    county_fips_all: '29121|29175',
    county: 'Macon',
    county_names_all: 'Macon|Randolph',
    county_weights: '{"29121": 98.1, "29175": 1.9}',
    density: 3.4,
    imprecise: false,
    latitude: 39.74061,
    longitude: -92.64838,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63534',
  },
  {
    city: 'Coatsville',
    county_fips: 29197,
    county_fips_all: '29197|29171',
    county: 'Schuyler',
    county_names_all: 'Schuyler|Putnam',
    county_weights: '{"29197": 68.32, "29171": 31.68}',
    density: 0.3,
    imprecise: false,
    latitude: 40.57244,
    longitude: -92.67946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63535',
  },
  {
    city: 'Downing',
    county_fips: 29197,
    county_fips_all: '29197|29199',
    county: 'Schuyler',
    county_names_all: 'Schuyler|Scotland',
    county_weights: '{"29197": 55.07, "29199": 44.93}',
    density: 3.9,
    imprecise: false,
    latitude: 40.48423,
    longitude: -92.3574,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63536',
  },
  {
    city: 'Edina',
    county_fips: 29103,
    county_fips_all: '29103',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"29103": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 40.14776,
    longitude: -92.16172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63537',
  },
  {
    city: 'Elmer',
    county_fips: 29121,
    county_fips_all: '29121',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"29121": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 39.9526,
    longitude: -92.67327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63538',
  },
  {
    city: 'Ethel',
    county_fips: 29121,
    county_fips_all: '29121',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"29121": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 39.9279,
    longitude: -92.76781,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63539',
  },
  {
    city: 'Gibbs',
    county_fips: 29001,
    county_fips_all: '29001',
    county: 'Adair',
    county_names_all: 'Adair',
    county_weights: '{"29001": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 40.09782,
    longitude: -92.40792,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63540',
  },
  {
    city: 'Glenwood',
    county_fips: 29197,
    county_fips_all: '29197',
    county: 'Schuyler',
    county_names_all: 'Schuyler',
    county_weights: '{"29197": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 40.50355,
    longitude: -92.63331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63541',
  },
  {
    city: 'Gorin',
    county_fips: 29199,
    county_fips_all: '29199',
    county: 'Scotland',
    county_names_all: 'Scotland',
    county_weights: '{"29199": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 40.35765,
    longitude: -92.00976,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63543',
  },
  {
    city: 'Green Castle',
    county_fips: 29001,
    county_fips_all: '29001|29211|29171',
    county: 'Adair',
    county_names_all: 'Adair|Sullivan|Putnam',
    county_weights: '{"29001": 45.0, "29211": 42.94, "29171": 12.06}',
    density: 3.2,
    imprecise: false,
    latitude: 40.24603,
    longitude: -92.84943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63544',
  },
  {
    city: 'Green City',
    county_fips: 29211,
    county_fips_all: '29211',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"29211": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 40.26721,
    longitude: -92.9677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63545',
  },
  {
    city: 'Greentop',
    county_fips: 29001,
    county_fips_all: '29001|29197|29199',
    county: 'Adair',
    county_names_all: 'Adair|Schuyler|Scotland',
    county_weights: '{"29001": 64.99, "29197": 32.95, "29199": 2.06}',
    density: 4.6,
    imprecise: false,
    latitude: 40.33129,
    longitude: -92.50882,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63546',
  },
  {
    city: 'Hurdland',
    county_fips: 29103,
    county_fips_all: '29103|29001',
    county: 'Knox',
    county_names_all: 'Knox|Adair',
    county_weights: '{"29103": 89.0, "29001": 11.0}',
    density: 2.1,
    imprecise: false,
    latitude: 40.13492,
    longitude: -92.30651,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63547',
  },
  {
    city: 'Lancaster',
    county_fips: 29197,
    county_fips_all: '29197',
    county: 'Schuyler',
    county_names_all: 'Schuyler',
    county_weights: '{"29197": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 40.53405,
    longitude: -92.4953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63548',
  },
  {
    city: 'La Plata',
    county_fips: 29121,
    county_fips_all: '29121|29001|29103',
    county: 'Macon',
    county_names_all: 'Macon|Adair|Knox',
    county_weights: '{"29121": 68.49, "29001": 29.19, "29103": 2.32}',
    density: 6.7,
    imprecise: false,
    latitude: 40.0167,
    longitude: -92.49172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63549',
  },
  {
    city: 'Livonia',
    county_fips: 29171,
    county_fips_all: '29171',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"29171": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 40.49921,
    longitude: -92.74252,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63551',
  },
  {
    city: 'Macon',
    county_fips: 29121,
    county_fips_all: '29121',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"29121": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 39.75349,
    longitude: -92.45075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63552',
  },
  {
    city: 'Memphis',
    county_fips: 29199,
    county_fips_all: '29199',
    county: 'Scotland',
    county_names_all: 'Scotland',
    county_weights: '{"29199": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 40.48458,
    longitude: -92.18698,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63555',
  },
  {
    city: 'Milan',
    county_fips: 29211,
    county_fips_all: '29211',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"29211": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 40.18251,
    longitude: -93.11723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63556',
  },
  {
    city: 'New Boston',
    county_fips: 29115,
    county_fips_all: '29115|29121|29001|29211',
    county: 'Linn',
    county_names_all: 'Linn|Macon|Adair|Sullivan',
    county_weights:
      '{"29115": 66.37, "29121": 21.28, "29001": 9.19, "29211": 3.16}',
    density: 1.2,
    imprecise: false,
    latitude: 39.98297,
    longitude: -92.88045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63557',
  },
  {
    city: 'New Cambria',
    county_fips: 29121,
    county_fips_all: '29121|29041',
    county: 'Macon',
    county_names_all: 'Macon|Chariton',
    county_weights: '{"29121": 68.71, "29041": 31.29}',
    density: 2.1,
    imprecise: false,
    latitude: 39.74168,
    longitude: -92.75244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63558',
  },
  {
    city: 'Novinger',
    county_fips: 29001,
    county_fips_all: '29001|29171',
    county: 'Adair',
    county_names_all: 'Adair|Putnam',
    county_weights: '{"29001": 88.31, "29171": 11.69}',
    density: 4.4,
    imprecise: false,
    latitude: 40.22674,
    longitude: -92.74528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63559',
  },
  {
    city: 'Pollock',
    county_fips: 29211,
    county_fips_all: '29211|29171',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Putnam',
    county_weights: '{"29211": 87.21, "29171": 12.79}',
    density: 0.6,
    imprecise: false,
    latitude: 40.3574,
    longitude: -93.12291,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63560',
  },
  {
    city: 'Queen City',
    county_fips: 29197,
    county_fips_all: '29197',
    county: 'Schuyler',
    county_names_all: 'Schuyler',
    county_weights: '{"29197": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 40.41408,
    longitude: -92.54317,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63561',
  },
  {
    city: 'Rutledge',
    county_fips: 29103,
    county_fips_all: '29103|29199',
    county: 'Knox',
    county_names_all: 'Knox|Scotland',
    county_weights: '{"29103": 51.96, "29199": 48.04}',
    density: 2.6,
    imprecise: false,
    latitude: 40.30387,
    longitude: -92.07439,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63563',
  },
  {
    city: 'Unionville',
    county_fips: 29171,
    county_fips_all: '29171|29211',
    county: 'Putnam',
    county_names_all: 'Putnam|Sullivan',
    county_weights: '{"29171": 98.28, "29211": 1.72}',
    density: 5.6,
    imprecise: false,
    latitude: 40.48263,
    longitude: -92.95447,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63565',
  },
  {
    city: 'Winigan',
    county_fips: 29115,
    county_fips_all: '29115|29211',
    county: 'Linn',
    county_names_all: 'Linn|Sullivan',
    county_weights: '{"29115": 60.91, "29211": 39.09}',
    density: 1.4,
    imprecise: false,
    latitude: 40.03139,
    longitude: -92.94793,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63566',
  },
  {
    city: 'Worthington',
    county_fips: 29171,
    county_fips_all: '29171|29197',
    county: 'Putnam',
    county_names_all: 'Putnam|Schuyler',
    county_weights: '{"29171": 99.84, "29197": 0.16}',
    density: 3.8,
    imprecise: false,
    latitude: 40.41332,
    longitude: -92.70461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63567',
  },
  {
    city: 'Park Hills',
    county_fips: 29187,
    county_fips_all: '29187',
    county: 'St. Francois',
    county_names_all: 'St. Francois',
    county_weights: '{"29187": 100}',
    density: 106,
    imprecise: false,
    latitude: 37.8212,
    longitude: -90.5439,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63601',
  },
  {
    city: 'Annapolis',
    county_fips: 29093,
    county_fips_all: '29093|29123|29179',
    county: 'Iron',
    county_names_all: 'Iron|Madison|Reynolds',
    county_weights: '{"29093": 68.36, "29123": 20.92, "29179": 10.72}',
    density: 2.1,
    imprecise: false,
    latitude: 37.40101,
    longitude: -90.6521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63620',
  },
  {
    city: 'Arcadia',
    county_fips: 29093,
    county_fips_all: '29093|29123',
    county: 'Iron',
    county_names_all: 'Iron|Madison',
    county_weights: '{"29093": 68.87, "29123": 31.13}',
    density: 8.2,
    imprecise: false,
    latitude: 37.48225,
    longitude: -90.57916,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63621',
  },
  {
    city: 'Belgrade',
    county_fips: 29221,
    county_fips_all: '29221',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"29221": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 37.78901,
    longitude: -90.90584,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63622',
  },
  {
    city: 'Belleview',
    county_fips: 29093,
    county_fips_all: '29093',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"29093": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 37.67532,
    longitude: -90.8941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63623',
  },
  {
    city: 'Bismarck',
    county_fips: 29187,
    county_fips_all: '29187|29221|29093',
    county: 'St. Francois',
    county_names_all: 'St. Francois|Washington|Iron',
    county_weights: '{"29187": 54.84, "29221": 28.94, "29093": 16.22}',
    density: 21.8,
    imprecise: false,
    latitude: 37.7531,
    longitude: -90.63923,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63624',
  },
  {
    city: 'Black',
    county_fips: 29179,
    county_fips_all: '29179|29093',
    county: 'Reynolds',
    county_names_all: 'Reynolds|Iron',
    county_weights: '{"29179": 81.94, "29093": 18.06}',
    density: 1.8,
    imprecise: false,
    latitude: 37.56374,
    longitude: -90.98734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63625',
  },
  {
    city: 'Blackwell',
    county_fips: 29221,
    county_fips_all: '29221|29187',
    county: 'Washington',
    county_names_all: 'Washington|St. Francois',
    county_weights: '{"29221": 81.63, "29187": 18.37}',
    density: 10.7,
    imprecise: false,
    latitude: 38.07721,
    longitude: -90.71471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63626',
  },
  {
    city: 'Bloomsdale',
    county_fips: 29186,
    county_fips_all: '29186|29099',
    county: 'Ste. Genevieve',
    county_names_all: 'Ste. Genevieve|Jefferson',
    county_weights: '{"29186": 94.4, "29099": 5.6}',
    density: 14.7,
    imprecise: false,
    latitude: 38.03625,
    longitude: -90.25317,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63627',
  },
  {
    city: 'Bonne Terre',
    county_fips: 29187,
    county_fips_all: '29187|29186|29221|29099',
    county: 'St. Francois',
    county_names_all: 'St. Francois|Ste. Genevieve|Washington|Jefferson',
    county_weights:
      '{"29187": 84.03, "29186": 7.71, "29221": 6.3, "29099": 1.96}',
    density: 52.7,
    imprecise: false,
    latitude: 37.9392,
    longitude: -90.52466,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63628',
  },
  {
    city: 'Bunker',
    county_fips: 29203,
    county_fips_all: '29203|29179|29065',
    county: 'Shannon',
    county_names_all: 'Shannon|Reynolds|Dent',
    county_weights: '{"29203": 47.8, "29179": 32.9, "29065": 19.3}',
    density: 1.3,
    imprecise: false,
    latitude: 37.39847,
    longitude: -91.23861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63629',
  },
  {
    city: 'Cadet',
    county_fips: 29221,
    county_fips_all: '29221|29187',
    county: 'Washington',
    county_names_all: 'Washington|St. Francois',
    county_weights: '{"29221": 93.32, "29187": 6.68}',
    density: 22.9,
    imprecise: false,
    latitude: 38.01874,
    longitude: -90.72727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63630',
  },
  {
    city: 'Caledonia',
    county_fips: 29221,
    county_fips_all: '29221|29093',
    county: 'Washington',
    county_names_all: 'Washington|Iron',
    county_weights: '{"29221": 64.5, "29093": 35.5}',
    density: 5.1,
    imprecise: false,
    latitude: 37.74912,
    longitude: -90.78873,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63631',
  },
  {
    city: 'Centerville',
    county_fips: 29179,
    county_fips_all: '29179',
    county: 'Reynolds',
    county_names_all: 'Reynolds',
    county_weights: '{"29179": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 37.41993,
    longitude: -91.01082,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63633',
  },
  {
    city: 'Des Arc',
    county_fips: 29093,
    county_fips_all: '29093|29223|29123',
    county: 'Iron',
    county_names_all: 'Iron|Wayne|Madison',
    county_weights: '{"29093": 45.93, "29223": 30.55, "29123": 23.52}',
    density: 3.9,
    imprecise: false,
    latitude: 37.29542,
    longitude: -90.57549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63636',
  },
  {
    city: 'Doe Run',
    county_fips: 29187,
    county_fips_all: '29187',
    county: 'St. Francois',
    county_names_all: 'St. Francois',
    county_weights: '{"29187": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 37.70511,
    longitude: -90.51875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63637',
  },
  {
    city: 'Ellington',
    county_fips: 29179,
    county_fips_all: '29179|29203',
    county: 'Reynolds',
    county_names_all: 'Reynolds|Shannon',
    county_weights: '{"29179": 82.04, "29203": 17.96}',
    density: 3.3,
    imprecise: false,
    latitude: 37.21727,
    longitude: -91.01135,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63638',
  },
  {
    city: 'Farmington',
    county_fips: 29187,
    county_fips_all: '29187|29186',
    county: 'St. Francois',
    county_names_all: 'St. Francois|Ste. Genevieve',
    county_weights: '{"29187": 66.06, "29186": 33.94}',
    density: 54,
    imprecise: false,
    latitude: 37.75446,
    longitude: -90.36525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63640',
  },
  {
    city: 'Fredericktown',
    county_fips: 29123,
    county_fips_all: '29123|29187|29186',
    county: 'Madison',
    county_names_all: 'Madison|St. Francois|Ste. Genevieve',
    county_weights: '{"29123": 87.49, "29187": 8.25, "29186": 4.26}',
    density: 12.4,
    imprecise: false,
    latitude: 37.54204,
    longitude: -90.32428,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63645',
  },
  {
    city: 'Irondale',
    county_fips: 29221,
    county_fips_all: '29221|29187',
    county: 'Washington',
    county_names_all: 'Washington|St. Francois',
    county_weights: '{"29221": 92.61, "29187": 7.39}',
    density: 22.9,
    imprecise: false,
    latitude: 37.8187,
    longitude: -90.69878,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63648',
  },
  {
    city: 'Ironton',
    county_fips: 29093,
    county_fips_all: '29093|29187|29123',
    county: 'Iron',
    county_names_all: 'Iron|St. Francois|Madison',
    county_weights: '{"29093": 75.31, "29187": 21.61, "29123": 3.08}',
    density: 12.4,
    imprecise: false,
    latitude: 37.6103,
    longitude: -90.62994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63650',
  },
  {
    city: 'Leadwood',
    county_fips: 29187,
    county_fips_all: '29187',
    county: 'St. Francois',
    county_names_all: 'St. Francois',
    county_weights: '{"29187": 100}',
    density: 420.8,
    imprecise: false,
    latitude: 37.86139,
    longitude: -90.58789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63653',
  },
  {
    city: 'Lesterville',
    county_fips: 29179,
    county_fips_all: '29179|29093',
    county: 'Reynolds',
    county_names_all: 'Reynolds|Iron',
    county_weights: '{"29179": 98.79, "29093": 1.21}',
    density: 4.1,
    imprecise: false,
    latitude: 37.45941,
    longitude: -90.85156,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63654',
  },
  {
    city: 'Marquand',
    county_fips: 29123,
    county_fips_all: '29123|29017|29223',
    county: 'Madison',
    county_names_all: 'Madison|Bollinger|Wayne',
    county_weights: '{"29123": 65.75, "29017": 22.26, "29223": 11.99}',
    density: 4.2,
    imprecise: false,
    latitude: 37.39312,
    longitude: -90.20552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63655',
  },
  {
    city: 'Middle Brook',
    county_fips: 29093,
    county_fips_all: '29093|29179',
    county: 'Iron',
    county_names_all: 'Iron|Reynolds',
    county_weights: '{"29093": 50.71, "29179": 49.29}',
    density: 3.2,
    imprecise: false,
    latitude: 37.59664,
    longitude: -90.79483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63656',
  },
  {
    city: 'Mineral Point',
    county_fips: 29221,
    county_fips_all: '29221',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"29221": 100}',
    density: 30.6,
    imprecise: false,
    latitude: 37.91241,
    longitude: -90.70241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63660',
  },
  {
    city: 'Patton',
    county_fips: 29017,
    county_fips_all: '29017',
    county: 'Bollinger',
    county_names_all: 'Bollinger',
    county_weights: '{"29017": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 37.53782,
    longitude: -90.05321,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63662',
  },
  {
    city: 'Pilot Knob',
    county_fips: 29093,
    county_fips_all: '29093',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"29093": 100}',
    density: 319.3,
    imprecise: false,
    latitude: 37.62446,
    longitude: -90.64638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63663',
  },
  {
    city: 'Potosi',
    county_fips: 29221,
    county_fips_all: '29221',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"29221": 100}',
    density: 13,
    imprecise: false,
    latitude: 37.92161,
    longitude: -90.91661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63664',
  },
  {
    city: 'Redford',
    county_fips: 29179,
    county_fips_all: '29179',
    county: 'Reynolds',
    county_names_all: 'Reynolds',
    county_weights: '{"29179": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 37.29055,
    longitude: -90.84087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63665',
  },
  {
    city: 'Sainte Genevieve',
    county_fips: 29186,
    county_fips_all: '29186',
    county: 'Ste. Genevieve',
    county_names_all: 'Ste. Genevieve',
    county_weights: '{"29186": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 37.89667,
    longitude: -90.16245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63670',
  },
  {
    city: 'Saint Mary',
    county_fips: 29186,
    county_fips_all: '29186|29157|17157',
    county: 'Ste. Genevieve',
    county_names_all: 'Ste. Genevieve|Perry|Randolph',
    county_weights: '{"29186": 48.82, "29157": 29.54, "17157": 21.64}',
    density: 7.8,
    imprecise: false,
    latitude: 37.83641,
    longitude: -89.98861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63673',
  },
  {
    city: 'Tiff',
    county_fips: 29221,
    county_fips_all: '29221',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"29221": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 38.03126,
    longitude: -90.65933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63674',
  },
  {
    city: 'Vulcan',
    county_fips: 29093,
    county_fips_all: '29093',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"29093": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 37.30112,
    longitude: -90.697,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63675',
  },
  {
    city: 'Cape Girardeau',
    county_fips: 29031,
    county_fips_all: '29031',
    county: 'Cape Girardeau',
    county_names_all: 'Cape Girardeau',
    county_weights: '{"29031": 100}',
    density: 114.5,
    imprecise: false,
    latitude: 37.33522,
    longitude: -89.58043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63701',
  },
  {
    city: 'Cape Girardeau',
    county_fips: 29031,
    county_fips_all: '29031',
    county: 'Cape Girardeau',
    county_names_all: 'Cape Girardeau',
    county_weights: '{"29031": 100}',
    density: 245.1,
    imprecise: false,
    latitude: 37.27373,
    longitude: -89.53981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63703',
  },
  {
    city: 'Advance',
    county_fips: 29207,
    county_fips_all: '29207|29017|29031',
    county: 'Stoddard',
    county_names_all: 'Stoddard|Bollinger|Cape Girardeau',
    county_weights: '{"29207": 54.56, "29017": 33.9, "29031": 11.54}',
    density: 11.6,
    imprecise: false,
    latitude: 37.09496,
    longitude: -89.91841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63730',
  },
  {
    city: 'Altenburg',
    county_fips: 29157,
    county_fips_all: '29157|29031',
    county: 'Perry',
    county_names_all: 'Perry|Cape Girardeau',
    county_weights: '{"29157": 62.29, "29031": 37.71}',
    density: 9.9,
    imprecise: false,
    latitude: 37.59428,
    longitude: -89.59123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63732',
  },
  {
    city: 'Bell City',
    county_fips: 29207,
    county_fips_all: '29207|29201',
    county: 'Stoddard',
    county_names_all: 'Stoddard|Scott',
    county_weights: '{"29207": 89.44, "29201": 10.56}',
    density: 4.8,
    imprecise: false,
    latitude: 36.98015,
    longitude: -89.78139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63735',
  },
  {
    city: 'Benton',
    county_fips: 29201,
    county_fips_all: '29201',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"29201": 100}',
    density: 23.9,
    imprecise: false,
    latitude: 37.08033,
    longitude: -89.52072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63736',
  },
  {
    city: 'Brownwood',
    county_fips: 29207,
    county_fips_all: '29207',
    county: 'Stoddard',
    county_names_all: 'Stoddard',
    county_weights: '{"29207": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.08936,
    longitude: -89.95729,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63738',
  },
  {
    city: 'Burfordville',
    county_fips: 29031,
    county_fips_all: '29031',
    county: 'Cape Girardeau',
    county_names_all: 'Cape Girardeau',
    county_weights: '{"29031": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 37.35686,
    longitude: -89.80216,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63739',
  },
  {
    city: 'Chaffee',
    county_fips: 29201,
    county_fips_all: '29201|29031',
    county: 'Scott',
    county_names_all: 'Scott|Cape Girardeau',
    county_weights: '{"29201": 50.36, "29031": 49.64}',
    density: 22.7,
    imprecise: false,
    latitude: 37.17564,
    longitude: -89.68557,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63740',
  },
  {
    city: 'Daisy',
    county_fips: 29031,
    county_fips_all: '29031',
    county: 'Cape Girardeau',
    county_names_all: 'Cape Girardeau',
    county_weights: '{"29031": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 37.51886,
    longitude: -89.83261,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63743',
  },
  {
    city: 'Delta',
    county_fips: 29031,
    county_fips_all: '29031',
    county: 'Cape Girardeau',
    county_names_all: 'Cape Girardeau',
    county_weights: '{"29031": 100}',
    density: 40.1,
    imprecise: false,
    latitude: 37.19331,
    longitude: -89.71831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63744',
  },
  {
    city: 'Farrar',
    county_fips: 29157,
    county_fips_all: '29157',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"29157": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 37.70783,
    longitude: -89.69484,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63746',
  },
  {
    city: 'Friedheim',
    county_fips: 29031,
    county_fips_all: '29031',
    county: 'Cape Girardeau',
    county_names_all: 'Cape Girardeau',
    county_weights: '{"29031": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 37.55993,
    longitude: -89.81121,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63747',
  },
  {
    city: 'Frohna',
    county_fips: 29157,
    county_fips_all: '29157',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"29157": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 37.66912,
    longitude: -89.61282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63748',
  },
  {
    city: 'Gipsy',
    county_fips: 29017,
    county_fips_all: '29017',
    county: 'Bollinger',
    county_names_all: 'Bollinger',
    county_weights: '{"29017": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 37.1508,
    longitude: -90.16917,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63750',
  },
  {
    city: 'Glenallen',
    county_fips: 29017,
    county_fips_all: '29017',
    county: 'Bollinger',
    county_names_all: 'Bollinger',
    county_weights: '{"29017": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 37.2742,
    longitude: -90.12404,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63751',
  },
  {
    city: 'Jackson',
    county_fips: 29031,
    county_fips_all: '29031',
    county: 'Cape Girardeau',
    county_names_all: 'Cape Girardeau',
    county_weights: '{"29031": 100}',
    density: 60.2,
    imprecise: false,
    latitude: 37.44351,
    longitude: -89.64193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63755',
  },
  {
    city: 'Kelso',
    county_fips: 29201,
    county_fips_all: '29201',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"29201": 100}',
    density: 912.4,
    imprecise: false,
    latitude: 37.19212,
    longitude: -89.55064,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63758',
  },
  {
    city: 'Leopold',
    county_fips: 29017,
    county_fips_all: '29017',
    county: 'Bollinger',
    county_names_all: 'Bollinger',
    county_weights: '{"29017": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 37.25084,
    longitude: -89.90374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63760',
  },
  {
    city: 'McGee',
    county_fips: 29223,
    county_fips_all: '29223',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"29223": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 37.05885,
    longitude: -90.18058,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 98,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63763',
  },
  {
    city: 'Marble Hill',
    county_fips: 29017,
    county_fips_all: '29017|29031',
    county: 'Bollinger',
    county_names_all: 'Bollinger|Cape Girardeau',
    county_weights: '{"29017": 97.66, "29031": 2.34}',
    density: 10.7,
    imprecise: false,
    latitude: 37.32944,
    longitude: -89.9837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63764',
  },
  {
    city: 'Millersville',
    county_fips: 29031,
    county_fips_all: '29031|29017',
    county: 'Cape Girardeau',
    county_names_all: 'Cape Girardeau|Bollinger',
    county_weights: '{"29031": 67.41, "29017": 32.59}',
    density: 13.7,
    imprecise: false,
    latitude: 37.43558,
    longitude: -89.84424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63766',
  },
  {
    city: 'Morley',
    county_fips: 29201,
    county_fips_all: '29201',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"29201": 100}',
    density: 225.5,
    imprecise: false,
    latitude: 37.04356,
    longitude: -89.61038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63767',
  },
  {
    city: 'Oak Ridge',
    county_fips: 29031,
    county_fips_all: '29031',
    county: 'Cape Girardeau',
    county_names_all: 'Cape Girardeau',
    county_weights: '{"29031": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 37.52312,
    longitude: -89.74203,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63769',
  },
  {
    city: 'Old Appleton',
    county_fips: 29157,
    county_fips_all: '29157|29031',
    county: 'Perry',
    county_names_all: 'Perry|Cape Girardeau',
    county_weights: '{"29157": 53.67, "29031": 46.33}',
    density: 28.9,
    imprecise: false,
    latitude: 37.59456,
    longitude: -89.70049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63770',
  },
  {
    city: 'Oran',
    county_fips: 29201,
    county_fips_all: '29201|29207|29031',
    county: 'Scott',
    county_names_all: 'Scott|Stoddard|Cape Girardeau',
    county_weights: '{"29201": 73.28, "29207": 24.98, "29031": 1.74}',
    density: 8.6,
    imprecise: false,
    latitude: 37.07431,
    longitude: -89.71299,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63771',
  },
  {
    city: 'Perkins',
    county_fips: 29201,
    county_fips_all: '29201',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"29201": 100}',
    density: 248,
    imprecise: false,
    latitude: 37.09424,
    longitude: -89.77469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63774',
  },
  {
    city: 'Perryville',
    county_fips: 29157,
    county_fips_all: '29157|29017|29031',
    county: 'Perry',
    county_names_all: 'Perry|Bollinger|Cape Girardeau',
    county_weights: '{"29157": 97.6, "29017": 1.25, "29031": 1.15}',
    density: 18.4,
    imprecise: false,
    latitude: 37.71051,
    longitude: -89.87919,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63775',
  },
  {
    city: 'Scott City',
    county_fips: 29201,
    county_fips_all: '29201|29031',
    county: 'Scott',
    county_names_all: 'Scott|Cape Girardeau',
    county_weights: '{"29201": 96.94, "29031": 3.06}',
    density: 38.5,
    imprecise: false,
    latitude: 37.17797,
    longitude: -89.50138,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63780',
  },
  {
    city: 'Sedgewickville',
    county_fips: 29017,
    county_fips_all: '29017|29157',
    county: 'Bollinger',
    county_names_all: 'Bollinger|Perry',
    county_weights: '{"29017": 99.01, "29157": 0.99}',
    density: 8.8,
    imprecise: false,
    latitude: 37.5329,
    longitude: -89.93078,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63781',
  },
  {
    city: 'Sturdivant',
    county_fips: 29017,
    county_fips_all: '29017',
    county: 'Bollinger',
    county_names_all: 'Bollinger',
    county_weights: '{"29017": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 37.11369,
    longitude: -90.02788,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63782',
  },
  {
    city: 'Uniontown',
    county_fips: 29157,
    county_fips_all: '29157',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"29157": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 37.60958,
    longitude: -89.6823,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63783',
  },
  {
    city: 'Vanduser',
    county_fips: 29201,
    county_fips_all: '29201',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"29201": 100}',
    density: 59.3,
    imprecise: false,
    latitude: 36.99497,
    longitude: -89.69601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63784',
  },
  {
    city: 'Whitewater',
    county_fips: 29031,
    county_fips_all: '29031|29017',
    county: 'Cape Girardeau',
    county_names_all: 'Cape Girardeau|Bollinger',
    county_weights: '{"29031": 97.42, "29017": 2.58}',
    density: 9.9,
    imprecise: false,
    latitude: 37.26336,
    longitude: -89.81554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63785',
  },
  {
    city: 'Zalma',
    county_fips: 29017,
    county_fips_all: '29017|29223',
    county: 'Bollinger',
    county_names_all: 'Bollinger|Wayne',
    county_weights: '{"29017": 95.29, "29223": 4.71}',
    density: 3.5,
    imprecise: false,
    latitude: 37.12284,
    longitude: -90.12263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63787',
  },
  {
    city: 'Sikeston',
    county_fips: 29201,
    county_fips_all: '29201|29143|29207|29133',
    county: 'Scott',
    county_names_all: 'Scott|New Madrid|Stoddard|Mississippi',
    county_weights:
      '{"29201": 57.9, "29143": 29.76, "29207": 11.01, "29133": 1.33}',
    density: 40,
    imprecise: false,
    latitude: 36.89698,
    longitude: -89.60672,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63801',
  },
  {
    city: 'Anniston',
    county_fips: 29133,
    county_fips_all: '29133',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"29133": 100}',
    density: 197.2,
    imprecise: false,
    latitude: 36.82427,
    longitude: -89.32564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63820',
  },
  {
    city: 'Arbyrd',
    county_fips: 29069,
    county_fips_all: '29069',
    county: 'Dunklin',
    county_names_all: 'Dunklin',
    county_weights: '{"29069": 100}',
    density: 6,
    imprecise: false,
    latitude: 36.04878,
    longitude: -90.23963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63821',
  },
  {
    city: 'Bernie',
    county_fips: 29207,
    county_fips_all: '29207|29069',
    county: 'Stoddard',
    county_names_all: 'Stoddard|Dunklin',
    county_weights: '{"29207": 92.18, "29069": 7.82}',
    density: 13.6,
    imprecise: false,
    latitude: 36.65904,
    longitude: -90.00103,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63822',
  },
  {
    city: 'Bertrand',
    county_fips: 29133,
    county_fips_all: '29133|29201',
    county: 'Mississippi',
    county_names_all: 'Mississippi|Scott',
    county_weights: '{"29133": 82.16, "29201": 17.84}',
    density: 14.1,
    imprecise: false,
    latitude: 36.89628,
    longitude: -89.45367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63823',
  },
  {
    city: 'Blodgett',
    county_fips: 29201,
    county_fips_all: '29201',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"29201": 100}',
    density: 600.7,
    imprecise: false,
    latitude: 37.00513,
    longitude: -89.52638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63824',
  },
  {
    city: 'Bloomfield',
    county_fips: 29207,
    county_fips_all: '29207',
    county: 'Stoddard',
    county_names_all: 'Stoddard',
    county_weights: '{"29207": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 36.93033,
    longitude: -89.94432,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63825',
  },
  {
    city: 'Braggadocio',
    county_fips: 29155,
    county_fips_all: '29155',
    county: 'Pemiscot',
    county_names_all: 'Pemiscot',
    county_weights: '{"29155": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 36.18361,
    longitude: -89.84486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63826',
  },
  {
    city: 'Bragg City',
    county_fips: 29155,
    county_fips_all: '29155',
    county: 'Pemiscot',
    county_names_all: 'Pemiscot',
    county_weights: '{"29155": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 36.26133,
    longitude: -89.89226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63827',
  },
  {
    city: 'Canalou',
    county_fips: 29143,
    county_fips_all: '29143',
    county: 'New Madrid',
    county_names_all: 'New Madrid',
    county_weights: '{"29143": 100}',
    density: 69.8,
    imprecise: false,
    latitude: 36.75038,
    longitude: -89.69182,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63828',
  },
  {
    city: 'Cardwell',
    county_fips: 29069,
    county_fips_all: '29069',
    county: 'Dunklin',
    county_names_all: 'Dunklin',
    county_weights: '{"29069": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 36.03652,
    longitude: -90.31173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63829',
  },
  {
    city: 'Caruthersville',
    county_fips: 29155,
    county_fips_all: '29155',
    county: 'Pemiscot',
    county_names_all: 'Pemiscot',
    county_weights: '{"29155": 100}',
    density: 38,
    imprecise: false,
    latitude: 36.14065,
    longitude: -89.6871,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63830',
  },
  {
    city: 'Catron',
    county_fips: 29143,
    county_fips_all: '29143|29207',
    county: 'New Madrid',
    county_names_all: 'New Madrid|Stoddard',
    county_weights: '{"29143": 53.08, "29207": 46.92}',
    density: 0.7,
    imprecise: false,
    latitude: 36.64779,
    longitude: -89.73023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63833',
  },
  {
    city: 'Charleston',
    county_fips: 29133,
    county_fips_all: '29133|29201',
    county: 'Mississippi',
    county_names_all: 'Mississippi|Scott',
    county_weights: '{"29133": 85.25, "29201": 14.75}',
    density: 8,
    imprecise: false,
    latitude: 36.91989,
    longitude: -89.27885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63834',
  },
  {
    city: 'Clarkton',
    county_fips: 29069,
    county_fips_all: '29069|29143',
    county: 'Dunklin',
    county_names_all: 'Dunklin|New Madrid',
    county_weights: '{"29069": 72.32, "29143": 27.68}',
    density: 17,
    imprecise: false,
    latitude: 36.44907,
    longitude: -89.98023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63837',
  },
  {
    city: 'Cooter',
    county_fips: 29155,
    county_fips_all: '29155',
    county: 'Pemiscot',
    county_names_all: 'Pemiscot',
    county_weights: '{"29155": 100}',
    density: 131.2,
    imprecise: false,
    latitude: 36.04748,
    longitude: -89.8097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63839',
  },
  {
    city: 'Deering',
    county_fips: 29155,
    county_fips_all: '29155',
    county: 'Pemiscot',
    county_names_all: 'Pemiscot',
    county_weights: '{"29155": 100}',
    density: 96.7,
    imprecise: false,
    latitude: 36.19113,
    longitude: -89.88426,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63840',
  },
  {
    city: 'Dexter',
    county_fips: 29207,
    county_fips_all: '29207',
    county: 'Stoddard',
    county_names_all: 'Stoddard',
    county_weights: '{"29207": 100}',
    density: 39.4,
    imprecise: false,
    latitude: 36.77198,
    longitude: -89.98169,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63841',
  },
  {
    city: 'East Prairie',
    county_fips: 29133,
    county_fips_all: '29133|29143',
    county: 'Mississippi',
    county_names_all: 'Mississippi|New Madrid',
    county_weights: '{"29133": 86.87, "29143": 13.13}',
    density: 10.8,
    imprecise: false,
    latitude: 36.70944,
    longitude: -89.31505,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63845',
  },
  {
    city: 'Essex',
    county_fips: 29207,
    county_fips_all: '29207',
    county: 'Stoddard',
    county_names_all: 'Stoddard',
    county_weights: '{"29207": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 36.82229,
    longitude: -89.80199,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63846',
  },
  {
    city: 'Gibson',
    county_fips: 29069,
    county_fips_all: '29069',
    county: 'Dunklin',
    county_names_all: 'Dunklin',
    county_weights: '{"29069": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 36.44271,
    longitude: -90.03474,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63847',
  },
  {
    city: 'Gideon',
    county_fips: 29143,
    county_fips_all: '29143|29155',
    county: 'New Madrid',
    county_names_all: 'New Madrid|Pemiscot',
    county_weights: '{"29143": 83.34, "29155": 16.66}',
    density: 4.3,
    imprecise: false,
    latitude: 36.44053,
    longitude: -89.88219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63848',
  },
  {
    city: 'Gobler',
    county_fips: 29069,
    county_fips_all: '29069|29155',
    county: 'Dunklin',
    county_names_all: 'Dunklin|Pemiscot',
    county_weights: '{"29069": 84.73, "29155": 15.27}',
    density: 3.1,
    imprecise: false,
    latitude: 36.13287,
    longitude: -89.99109,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63849',
  },
  {
    city: 'Grayridge',
    county_fips: 29207,
    county_fips_all: '29207',
    county: 'Stoddard',
    county_names_all: 'Stoddard',
    county_weights: '{"29207": 100}',
    density: 266.5,
    imprecise: false,
    latitude: 36.82227,
    longitude: -89.78214,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63850',
  },
  {
    city: 'Hayti',
    county_fips: 29155,
    county_fips_all: '29155',
    county: 'Pemiscot',
    county_names_all: 'Pemiscot',
    county_weights: '{"29155": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 36.25762,
    longitude: -89.72352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63851',
  },
  {
    city: 'Holcomb',
    county_fips: 29069,
    county_fips_all: '29069|29155',
    county: 'Dunklin',
    county_names_all: 'Dunklin|Pemiscot',
    county_weights: '{"29069": 86.85, "29155": 13.15}',
    density: 9.3,
    imprecise: false,
    latitude: 36.36748,
    longitude: -90.01435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63852',
  },
  {
    city: 'Holland',
    county_fips: 29155,
    county_fips_all: '29155',
    county: 'Pemiscot',
    county_names_all: 'Pemiscot',
    county_weights: '{"29155": 100}',
    density: 181.7,
    imprecise: false,
    latitude: 36.05834,
    longitude: -89.86738,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63853',
  },
  {
    city: 'Hornersville',
    county_fips: 29069,
    county_fips_all: '29069',
    county: 'Dunklin',
    county_names_all: 'Dunklin',
    county_weights: '{"29069": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 36.05332,
    longitude: -90.07123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63855',
  },
  {
    city: 'Kennett',
    county_fips: 29069,
    county_fips_all: '29069|29155',
    county: 'Dunklin',
    county_names_all: 'Dunklin|Pemiscot',
    county_weights: '{"29069": 97.11, "29155": 2.89}',
    density: 43.4,
    imprecise: false,
    latitude: 36.22402,
    longitude: -90.04612,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63857',
  },
  {
    city: 'Kewanee',
    county_fips: 29143,
    county_fips_all: '29143',
    county: 'New Madrid',
    county_names_all: 'New Madrid',
    county_weights: '{"29143": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 36.67462,
    longitude: -89.59449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63860',
  },
  {
    city: 'Lilbourn',
    county_fips: 29143,
    county_fips_all: '29143',
    county: 'New Madrid',
    county_names_all: 'New Madrid',
    county_weights: '{"29143": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 36.58974,
    longitude: -89.67345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63862',
  },
  {
    city: 'Malden',
    county_fips: 29069,
    county_fips_all: '29069|29143',
    county: 'Dunklin',
    county_names_all: 'Dunklin|New Madrid',
    county_weights: '{"29069": 72.03, "29143": 27.97}',
    density: 36.5,
    imprecise: false,
    latitude: 36.56282,
    longitude: -89.97671,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63863',
  },
  {
    city: 'Marston',
    county_fips: 29143,
    county_fips_all: '29143',
    county: 'New Madrid',
    county_names_all: 'New Madrid',
    county_weights: '{"29143": 100}',
    density: 40.8,
    imprecise: false,
    latitude: 36.52606,
    longitude: -89.60654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63866',
  },
  {
    city: 'Matthews',
    county_fips: 29143,
    county_fips_all: '29143',
    county: 'New Madrid',
    county_names_all: 'New Madrid',
    county_weights: '{"29143": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 36.74475,
    longitude: -89.5465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63867',
  },
  {
    city: 'Morehouse',
    county_fips: 29143,
    county_fips_all: '29143',
    county: 'New Madrid',
    county_names_all: 'New Madrid',
    county_weights: '{"29143": 100}',
    density: 255.2,
    imprecise: false,
    latitude: 36.84579,
    longitude: -89.68971,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63868',
  },
  {
    city: 'New Madrid',
    county_fips: 29143,
    county_fips_all: '29143',
    county: 'New Madrid',
    county_names_all: 'New Madrid',
    county_weights: '{"29143": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 36.60768,
    longitude: -89.48111,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63869',
  },
  {
    city: 'Parma',
    county_fips: 29143,
    county_fips_all: '29143|29207',
    county: 'New Madrid',
    county_names_all: 'New Madrid|Stoddard',
    county_weights: '{"29143": 64.17, "29207": 35.83}',
    density: 4.9,
    imprecise: false,
    latitude: 36.61942,
    longitude: -89.84471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63870',
  },
  {
    city: 'Portageville',
    county_fips: 29143,
    county_fips_all: '29143|29155',
    county: 'New Madrid',
    county_names_all: 'New Madrid|Pemiscot',
    county_weights: '{"29143": 68.98, "29155": 31.02}',
    density: 8.1,
    imprecise: false,
    latitude: 36.42791,
    longitude: -89.65965,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63873',
  },
  {
    city: 'Risco',
    county_fips: 29143,
    county_fips_all: '29143',
    county: 'New Madrid',
    county_names_all: 'New Madrid',
    county_weights: '{"29143": 100}',
    density: 114.8,
    imprecise: false,
    latitude: 36.55566,
    longitude: -89.81645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63874',
  },
  {
    city: 'Senath',
    county_fips: 29069,
    county_fips_all: '29069',
    county: 'Dunklin',
    county_names_all: 'Dunklin',
    county_weights: '{"29069": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 36.13206,
    longitude: -90.16487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63876',
  },
  {
    city: 'Steele',
    county_fips: 29155,
    county_fips_all: '29155|29069',
    county: 'Pemiscot',
    county_names_all: 'Pemiscot|Dunklin',
    county_weights: '{"29155": 94.16, "29069": 5.84}',
    density: 7.3,
    imprecise: false,
    latitude: 36.07377,
    longitude: -89.85118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63877',
  },
  {
    city: 'Tallapoosa',
    county_fips: 29143,
    county_fips_all: '29143',
    county: 'New Madrid',
    county_names_all: 'New Madrid',
    county_weights: '{"29143": 100}',
    density: 66.3,
    imprecise: false,
    latitude: 36.50302,
    longitude: -89.82234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63878',
  },
  {
    city: 'Wardell',
    county_fips: 29155,
    county_fips_all: '29155',
    county: 'Pemiscot',
    county_names_all: 'Pemiscot',
    county_weights: '{"29155": 100}',
    density: 12,
    imprecise: false,
    latitude: 36.35752,
    longitude: -89.80945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63879',
  },
  {
    city: 'Whiteoak',
    county_fips: 29069,
    county_fips_all: '29069',
    county: 'Dunklin',
    county_names_all: 'Dunklin',
    county_weights: '{"29069": 100}',
    density: 528.7,
    imprecise: false,
    latitude: 36.32986,
    longitude: -90.02585,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63880',
  },
  {
    city: 'Wyatt',
    county_fips: 29133,
    county_fips_all: '29133',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"29133": 100}',
    density: 182.7,
    imprecise: false,
    latitude: 36.91639,
    longitude: -89.21974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63882',
  },
  {
    city: 'Poplar Bluff',
    county_fips: 29023,
    county_fips_all: '29023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"29023": 100}',
    density: 47.9,
    imprecise: false,
    latitude: 36.77168,
    longitude: -90.45012,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63901',
  },
  {
    city: 'Broseley',
    county_fips: 29023,
    county_fips_all: '29023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"29023": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 36.6879,
    longitude: -90.24533,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63932',
  },
  {
    city: 'Campbell',
    county_fips: 29069,
    county_fips_all: '29069',
    county: 'Dunklin',
    county_names_all: 'Dunklin',
    county_weights: '{"29069": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 36.52102,
    longitude: -90.10876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63933',
  },
  {
    city: 'Clubb',
    county_fips: 29223,
    county_fips_all: '29223',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"29223": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 37.20014,
    longitude: -90.37254,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63934',
  },
  {
    city: 'Doniphan',
    county_fips: 29181,
    county_fips_all: '29181|29149|29035',
    county: 'Ripley',
    county_names_all: 'Ripley|Oregon|Carter',
    county_weights: '{"29181": 92.49, "29149": 6.73, "29035": 0.78}',
    density: 6.7,
    imprecise: false,
    latitude: 36.67053,
    longitude: -90.92055,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63935',
  },
  {
    city: 'Dudley',
    county_fips: 29207,
    county_fips_all: '29207',
    county: 'Stoddard',
    county_names_all: 'Stoddard',
    county_weights: '{"29207": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 36.80731,
    longitude: -90.12979,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63936',
  },
  {
    city: 'Ellsinore',
    county_fips: 29035,
    county_fips_all: '29035|29023|29223',
    county: 'Carter',
    county_names_all: 'Carter|Butler|Wayne',
    county_weights: '{"29035": 78.52, "29023": 14.12, "29223": 7.36}',
    density: 6,
    imprecise: false,
    latitude: 36.94403,
    longitude: -90.74907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63937',
  },
  {
    city: 'Fairdealing',
    county_fips: 29181,
    county_fips_all: '29181',
    county: 'Ripley',
    county_names_all: 'Ripley',
    county_weights: '{"29181": 100}',
    density: 7,
    imprecise: false,
    latitude: 36.68456,
    longitude: -90.68253,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63939',
  },
  {
    city: 'Fisk',
    county_fips: 29023,
    county_fips_all: '29023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"29023": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 36.77218,
    longitude: -90.22892,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63940',
  },
  {
    city: 'Fremont',
    county_fips: 29035,
    county_fips_all: '29035|29149|29181',
    county: 'Carter',
    county_names_all: 'Carter|Oregon|Ripley',
    county_weights: '{"29035": 66.37, "29149": 32.91, "29181": 0.72}',
    density: 0.6,
    imprecise: false,
    latitude: 36.8711,
    longitude: -91.16607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63941',
  },
  {
    city: 'Gatewood',
    county_fips: 29181,
    county_fips_all: '29181|29149',
    county: 'Ripley',
    county_names_all: 'Ripley|Oregon',
    county_weights: '{"29181": 71.47, "29149": 28.53}',
    density: 2.1,
    imprecise: false,
    latitude: 36.55434,
    longitude: -91.07821,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63942',
  },
  {
    city: 'Grandin',
    county_fips: 29035,
    county_fips_all: '29035|29181',
    county: 'Carter',
    county_names_all: 'Carter|Ripley',
    county_weights: '{"29035": 71.82, "29181": 28.18}',
    density: 3.8,
    imprecise: false,
    latitude: 36.84046,
    longitude: -90.79995,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63943',
  },
  {
    city: 'Greenville',
    county_fips: 29223,
    county_fips_all: '29223',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"29223": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 37.10876,
    longitude: -90.36286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63944',
  },
  {
    city: 'Harviell',
    county_fips: 29023,
    county_fips_all: '29023|29181',
    county: 'Butler',
    county_names_all: 'Butler|Ripley',
    county_weights: '{"29023": 89.65, "29181": 10.35}',
    density: 11.4,
    imprecise: false,
    latitude: 36.6381,
    longitude: -90.5524,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63945',
  },
  {
    city: 'Lodi',
    county_fips: 29223,
    county_fips_all: '29223',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"29223": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.26924,
    longitude: -90.43474,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63950',
  },
  {
    city: 'Lowndes',
    county_fips: 29223,
    county_fips_all: '29223',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"29223": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 37.10875,
    longitude: -90.26055,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63951',
  },
  {
    city: 'Mill Spring',
    county_fips: 29223,
    county_fips_all: '29223',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"29223": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 37.00828,
    longitude: -90.64916,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63952',
  },
  {
    city: 'Naylor',
    county_fips: 29181,
    county_fips_all: '29181|29023',
    county: 'Ripley',
    county_names_all: 'Ripley|Butler',
    county_weights: '{"29181": 82.18, "29023": 17.82}',
    density: 5.2,
    imprecise: false,
    latitude: 36.59134,
    longitude: -90.62995,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63953',
  },
  {
    city: 'Neelyville',
    county_fips: 29023,
    county_fips_all: '29023|29181',
    county: 'Butler',
    county_names_all: 'Butler|Ripley',
    county_weights: '{"29023": 93.63, "29181": 6.37}',
    density: 3.4,
    imprecise: false,
    latitude: 36.56365,
    longitude: -90.47337,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63954',
  },
  {
    city: 'Oxly',
    county_fips: 29181,
    county_fips_all: '29181',
    county: 'Ripley',
    county_names_all: 'Ripley',
    county_weights: '{"29181": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 36.60211,
    longitude: -90.67864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63955',
  },
  {
    city: 'Patterson',
    county_fips: 29223,
    county_fips_all: '29223',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"29223": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 37.21741,
    longitude: -90.51665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63956',
  },
  {
    city: 'Piedmont',
    county_fips: 29223,
    county_fips_all: '29223|29179',
    county: 'Wayne',
    county_names_all: 'Wayne|Reynolds',
    county_weights: '{"29223": 75.72, "29179": 24.28}',
    density: 9.8,
    imprecise: false,
    latitude: 37.14218,
    longitude: -90.68903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63957',
  },
  {
    city: 'Puxico',
    county_fips: 29207,
    county_fips_all: '29207|29017',
    county: 'Stoddard',
    county_names_all: 'Stoddard|Bollinger',
    county_weights: '{"29207": 90.91, "29017": 9.09}',
    density: 10.6,
    imprecise: false,
    latitude: 36.96074,
    longitude: -90.12434,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63960',
  },
  {
    city: 'Qulin',
    county_fips: 29023,
    county_fips_all: '29023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"29023": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 36.56848,
    longitude: -90.2749,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63961',
  },
  {
    city: 'Rombauer',
    county_fips: 29023,
    county_fips_all: '29023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"29023": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.84406,
    longitude: -90.28149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63962',
  },
  {
    city: 'Silva',
    county_fips: 29223,
    county_fips_all: '29223|29123',
    county: 'Wayne',
    county_names_all: 'Wayne|Madison',
    county_weights: '{"29223": 95.32, "29123": 4.68}',
    density: 4.1,
    imprecise: false,
    latitude: 37.23954,
    longitude: -90.39662,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63964',
  },
  {
    city: 'Van Buren',
    county_fips: 29035,
    county_fips_all: '29035|29179',
    county: 'Carter',
    county_names_all: 'Carter|Reynolds',
    county_weights: '{"29035": 97.18, "29179": 2.82}',
    density: 4.5,
    imprecise: false,
    latitude: 36.97391,
    longitude: -91.02294,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63965',
  },
  {
    city: 'Wappapello',
    county_fips: 29223,
    county_fips_all: '29223|29023',
    county: 'Wayne',
    county_names_all: 'Wayne|Butler',
    county_weights: '{"29223": 79.62, "29023": 20.38}',
    density: 13.6,
    imprecise: false,
    latitude: 36.96956,
    longitude: -90.26216,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63966',
  },
  {
    city: 'Williamsville',
    county_fips: 29223,
    county_fips_all: '29223|29023',
    county: 'Wayne',
    county_names_all: 'Wayne|Butler',
    county_weights: '{"29223": 70.24, "29023": 29.76}',
    density: 4.1,
    imprecise: false,
    latitude: 36.94867,
    longitude: -90.47721,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63967',
  },
  {
    city: 'Alma',
    county_fips: 29107,
    county_fips_all: '29107',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"29107": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 39.10464,
    longitude: -93.53683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64001',
  },
  {
    city: 'Bates City',
    county_fips: 29107,
    county_fips_all: '29107|29101',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Johnson',
    county_weights: '{"29107": 79.38, "29101": 20.62}',
    density: 41.9,
    imprecise: false,
    latitude: 38.95963,
    longitude: -94.06688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64011',
  },
  {
    city: 'Belton',
    county_fips: 29037,
    county_fips_all: '29037',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"29037": 100}',
    density: 239.7,
    imprecise: false,
    latitude: 38.78906,
    longitude: -94.55204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64012',
  },
  {
    city: 'Blue Springs',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 993,
    imprecise: false,
    latitude: 39.00893,
    longitude: -94.25533,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64014',
  },
  {
    city: 'Blue Springs',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 636.5,
    imprecise: false,
    latitude: 39.02099,
    longitude: -94.3006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64015',
  },
  {
    city: 'Buckner',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 54.8,
    imprecise: false,
    latitude: 39.11642,
    longitude: -94.21385,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64016',
  },
  {
    city: 'Camden',
    county_fips: 29177,
    county_fips_all: '29177|29107',
    county: 'Ray',
    county_names_all: 'Ray|Lafayette',
    county_weights: '{"29177": 58.17, "29107": 41.83}',
    density: 6.1,
    imprecise: false,
    latitude: 39.199,
    longitude: -94.02951,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64017',
  },
  {
    city: 'Camden Point',
    county_fips: 29165,
    county_fips_all: '29165',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"29165": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 39.45052,
    longitude: -94.73329,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64018',
  },
  {
    city: 'Centerview',
    county_fips: 29101,
    county_fips_all: '29101',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"29101": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 38.77543,
    longitude: -93.86665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64019',
  },
  {
    city: 'Concordia',
    county_fips: 29107,
    county_fips_all: '29107|29101|29195',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Johnson|Saline',
    county_weights: '{"29107": 73.51, "29101": 22.28, "29195": 4.21}',
    density: 10.8,
    imprecise: false,
    latitude: 38.96795,
    longitude: -93.59098,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64020',
  },
  {
    city: 'Corder',
    county_fips: 29107,
    county_fips_all: '29107',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"29107": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 39.11498,
    longitude: -93.624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64021',
  },
  {
    city: 'Dover',
    county_fips: 29107,
    county_fips_all: '29107',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"29107": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 39.20191,
    longitude: -93.67836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64022',
  },
  {
    city: 'Excelsior Springs',
    county_fips: 29047,
    county_fips_all: '29047|29177',
    county: 'Clay',
    county_names_all: 'Clay|Ray',
    county_weights: '{"29047": 62.8, "29177": 37.2}',
    density: 85.4,
    imprecise: false,
    latitude: 39.32523,
    longitude: -94.22707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64024',
  },
  {
    city: 'Farley',
    county_fips: 29165,
    county_fips_all: '29165',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"29165": 100}',
    density: 46.3,
    imprecise: false,
    latitude: 39.29658,
    longitude: -94.82153,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64028',
  },
  {
    city: 'Grain Valley',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 266.4,
    imprecise: false,
    latitude: 39.00634,
    longitude: -94.21473,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64029',
  },
  {
    city: 'Grandview',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 702.6,
    imprecise: false,
    latitude: 38.87996,
    longitude: -94.52312,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64030',
  },
  {
    city: 'Greenwood',
    county_fips: 29095,
    county_fips_all: '29095|29037',
    county: 'Jackson',
    county_names_all: 'Jackson|Cass',
    county_weights: '{"29095": 79.12, "29037": 20.88}',
    density: 152.4,
    imprecise: false,
    latitude: 38.85052,
    longitude: -94.30203,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64034',
  },
  {
    city: 'Hardin',
    county_fips: 29177,
    county_fips_all: '29177|29033',
    county: 'Ray',
    county_names_all: 'Ray|Carroll',
    county_weights: '{"29177": 96.1, "29033": 3.9}',
    density: 7.1,
    imprecise: false,
    latitude: 39.28796,
    longitude: -93.81972,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64035',
  },
  {
    city: 'Henrietta',
    county_fips: 29177,
    county_fips_all: '29177',
    county: 'Ray',
    county_names_all: 'Ray',
    county_weights: '{"29177": 100}',
    density: 11,
    imprecise: false,
    latitude: 39.20047,
    longitude: -93.937,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64036',
  },
  {
    city: 'Higginsville',
    county_fips: 29107,
    county_fips_all: '29107|29101',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Johnson',
    county_weights: '{"29107": 97.21, "29101": 2.79}',
    density: 23.1,
    imprecise: false,
    latitude: 39.05116,
    longitude: -93.73386,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64037',
  },
  {
    city: 'Holden',
    county_fips: 29101,
    county_fips_all: '29101|29037',
    county: 'Johnson',
    county_names_all: 'Johnson|Cass',
    county_weights: '{"29101": 99.07, "29037": 0.93}',
    density: 14.9,
    imprecise: false,
    latitude: 38.71928,
    longitude: -93.98725,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64040',
  },
  {
    city: 'Holt',
    county_fips: 29047,
    county_fips_all: '29047|29049',
    county: 'Clay',
    county_names_all: 'Clay|Clinton',
    county_weights: '{"29047": 63.23, "29049": 36.77}',
    density: 37,
    imprecise: false,
    latitude: 39.44439,
    longitude: -94.3634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64048',
  },
  {
    city: 'Independence',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 632.8,
    imprecise: false,
    latitude: 39.11424,
    longitude: -94.40641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64050',
  },
  {
    city: 'Independence',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 1354.5,
    imprecise: false,
    latitude: 39.07355,
    longitude: -94.45082,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64052',
  },
  {
    city: 'Independence',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 965.6,
    imprecise: false,
    latitude: 39.10791,
    longitude: -94.46735,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64053',
  },
  {
    city: 'Independence',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 445.3,
    imprecise: false,
    latitude: 39.11627,
    longitude: -94.44003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64054',
  },
  {
    city: 'Independence',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 1110.9,
    imprecise: false,
    latitude: 39.05061,
    longitude: -94.39848,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64055',
  },
  {
    city: 'Independence',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 341.4,
    imprecise: false,
    latitude: 39.11114,
    longitude: -94.32008,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64056',
  },
  {
    city: 'Independence',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 376.8,
    imprecise: false,
    latitude: 39.0692,
    longitude: -94.32203,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64057',
  },
  {
    city: 'Independence',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 77.2,
    imprecise: false,
    latitude: 39.17805,
    longitude: -94.31408,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64058',
  },
  {
    city: 'Kearney',
    county_fips: 29047,
    county_fips_all: '29047',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"29047": 100}',
    density: 108.6,
    imprecise: false,
    latitude: 39.37134,
    longitude: -94.36821,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64060',
  },
  {
    city: 'Kingsville',
    county_fips: 29101,
    county_fips_all: '29101|29037|29095',
    county: 'Johnson',
    county_names_all: 'Johnson|Cass|Jackson',
    county_weights: '{"29101": 84.04, "29037": 15.34, "29095": 0.62}',
    density: 19.6,
    imprecise: false,
    latitude: 38.77981,
    longitude: -94.0885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64061',
  },
  {
    city: 'Lawson',
    county_fips: 29177,
    county_fips_all: '29177|29047|29049|29025',
    county: 'Ray',
    county_names_all: 'Ray|Clay|Clinton|Caldwell',
    county_weights:
      '{"29177": 73.07, "29047": 13.61, "29049": 11.0, "29025": 2.32}',
    density: 31.2,
    imprecise: false,
    latitude: 39.45533,
    longitude: -94.17244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64062',
  },
  {
    city: 'Lees Summit',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 1381.7,
    imprecise: false,
    latitude: 38.91224,
    longitude: -94.35341,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64063',
  },
  {
    city: 'Lees Summit',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 408.3,
    imprecise: false,
    latitude: 38.98222,
    longitude: -94.34284,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64064',
  },
  {
    city: 'Levasy',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 36.4,
    imprecise: false,
    latitude: 39.13961,
    longitude: -94.13857,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 98,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64066',
  },
  {
    city: 'Lexington',
    county_fips: 29107,
    county_fips_all: '29107',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"29107": 100}',
    density: 31.6,
    imprecise: false,
    latitude: 39.15594,
    longitude: -93.83747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64067',
  },
  {
    city: 'Liberty',
    county_fips: 29047,
    county_fips_all: '29047',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"29047": 100}',
    density: 172,
    imprecise: false,
    latitude: 39.25924,
    longitude: -94.39042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64068',
  },
  {
    city: 'Lone Jack',
    county_fips: 29095,
    county_fips_all: '29095|29101',
    county: 'Jackson',
    county_names_all: 'Jackson|Johnson',
    county_weights: '{"29095": 82.34, "29101": 17.66}',
    density: 35.5,
    imprecise: false,
    latitude: 38.8897,
    longitude: -94.14863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64070',
  },
  {
    city: 'Mayview',
    county_fips: 29107,
    county_fips_all: '29107',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"29107": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 39.02961,
    longitude: -93.83379,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64071',
  },
  {
    city: 'Missouri City',
    county_fips: 29047,
    county_fips_all: '29047',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"29047": 100}',
    density: 71.6,
    imprecise: false,
    latitude: 39.23286,
    longitude: -94.30021,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64072',
  },
  {
    city: 'Napoleon',
    county_fips: 29107,
    county_fips_all: '29107',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"29107": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 39.08106,
    longitude: -94.07658,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64074',
  },
  {
    city: 'Oak Grove',
    county_fips: 29095,
    county_fips_all: '29095|29107',
    county: 'Jackson',
    county_names_all: 'Jackson|Lafayette',
    county_weights: '{"29095": 90.86, "29107": 9.14}',
    density: 94.9,
    imprecise: false,
    latitude: 38.99751,
    longitude: -94.14544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64075',
  },
  {
    city: 'Odessa',
    county_fips: 29107,
    county_fips_all: '29107|29101',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Johnson',
    county_weights: '{"29107": 89.8, "29101": 10.2}',
    density: 29.9,
    imprecise: false,
    latitude: 38.98145,
    longitude: -93.94536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64076',
  },
  {
    city: 'Orrick',
    county_fips: 29177,
    county_fips_all: '29177|29047',
    county: 'Ray',
    county_names_all: 'Ray|Clay',
    county_weights: '{"29177": 89.64, "29047": 10.36}',
    density: 9.4,
    imprecise: false,
    latitude: 39.2224,
    longitude: -94.13887,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64077',
  },
  {
    city: 'Peculiar',
    county_fips: 29037,
    county_fips_all: '29037',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"29037": 100}',
    density: 71.3,
    imprecise: false,
    latitude: 38.70711,
    longitude: -94.46375,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64078',
  },
  {
    city: 'Platte City',
    county_fips: 29165,
    county_fips_all: '29165',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"29165": 100}',
    density: 61.7,
    imprecise: false,
    latitude: 39.36267,
    longitude: -94.79351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64079',
  },
  {
    city: 'Pleasant Hill',
    county_fips: 29037,
    county_fips_all: '29037|29095|29101',
    county: 'Cass',
    county_names_all: 'Cass|Jackson|Johnson',
    county_weights: '{"29037": 97.06, "29095": 2.55, "29101": 0.39}',
    density: 44.5,
    imprecise: false,
    latitude: 38.7691,
    longitude: -94.25639,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64080',
  },
  {
    city: 'Lees Summit',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 750.9,
    imprecise: false,
    latitude: 38.90971,
    longitude: -94.40953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64081',
  },
  {
    city: 'Lees Summit',
    county_fips: 29095,
    county_fips_all: '29095|29037',
    county: 'Jackson',
    county_names_all: 'Jackson|Cass',
    county_weights: '{"29095": 89.86, "29037": 10.14}',
    density: 377.6,
    imprecise: false,
    latitude: 38.86601,
    longitude: -94.4039,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64082',
  },
  {
    city: 'Raymore',
    county_fips: 29037,
    county_fips_all: '29037',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"29037": 100}',
    density: 394,
    imprecise: false,
    latitude: 38.80082,
    longitude: -94.4483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64083',
  },
  {
    city: 'Rayville',
    county_fips: 29177,
    county_fips_all: '29177',
    county: 'Ray',
    county_names_all: 'Ray',
    county_weights: '{"29177": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 39.38697,
    longitude: -94.0653,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64084',
  },
  {
    city: 'Richmond',
    county_fips: 29177,
    county_fips_all: '29177',
    county: 'Ray',
    county_names_all: 'Ray',
    county_weights: '{"29177": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 39.33838,
    longitude: -93.95158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64085',
  },
  {
    city: 'Lees Summit',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 241.2,
    imprecise: false,
    latitude: 38.91181,
    longitude: -94.29293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64086',
  },
  {
    city: 'Sibley',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 39.16173,
    longitude: -94.1848,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64088',
  },
  {
    city: 'Smithville',
    county_fips: 29047,
    county_fips_all: '29047|29165',
    county: 'Clay',
    county_names_all: 'Clay|Platte',
    county_weights: '{"29047": 75.47, "29165": 24.53}',
    density: 91.1,
    imprecise: false,
    latitude: 39.39007,
    longitude: -94.56483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64089',
  },
  {
    city: 'Strasburg',
    county_fips: 29037,
    county_fips_all: '29037',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"29037": 100}',
    density: 347.3,
    imprecise: false,
    latitude: 38.75991,
    longitude: -94.16387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64090',
  },
  {
    city: 'Waldron',
    county_fips: 29165,
    county_fips_all: '29165',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"29165": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.22248,
    longitude: -94.8088,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64092',
  },
  {
    city: 'Warrensburg',
    county_fips: 29101,
    county_fips_all: '29101',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"29101": 100}',
    density: 57.2,
    imprecise: false,
    latitude: 38.79057,
    longitude: -93.73206,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64093',
  },
  {
    city: 'Waverly',
    county_fips: 29107,
    county_fips_all: '29107|29195',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Saline',
    county_weights: '{"29107": 93.95, "29195": 6.05}',
    density: 10.2,
    imprecise: false,
    latitude: 39.20176,
    longitude: -93.55611,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64096',
  },
  {
    city: 'Wellington',
    county_fips: 29107,
    county_fips_all: '29107',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"29107": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 39.11237,
    longitude: -93.99146,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64097',
  },
  {
    city: 'Weston',
    county_fips: 29165,
    county_fips_all: '29165',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"29165": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 39.45661,
    longitude: -94.89456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64098',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 64.3,
    imprecise: false,
    latitude: 39.09433,
    longitude: -94.60329,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64102',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095|29047',
    county: 'Jackson',
    county_names_all: 'Jackson|Clay',
    county_weights: '{"29095": 99.73, "29047": 0.27}',
    density: 3046.3,
    imprecise: false,
    latitude: 39.10599,
    longitude: -94.58985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64105',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 2722.2,
    imprecise: false,
    latitude: 39.10526,
    longitude: -94.57013,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64106',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 1110,
    imprecise: false,
    latitude: 39.08413,
    longitude: -94.58449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64108',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 1814.4,
    imprecise: false,
    latitude: 39.06646,
    longitude: -94.56709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64109',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 2181.8,
    imprecise: false,
    latitude: 39.03445,
    longitude: -94.57265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64110',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 2406.5,
    imprecise: false,
    latitude: 39.05707,
    longitude: -94.59393,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64111',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 2173.8,
    imprecise: false,
    latitude: 39.03599,
    longitude: -94.59529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64112',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 1890.3,
    imprecise: false,
    latitude: 39.01414,
    longitude: -94.5956,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64113',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 1322.1,
    imprecise: false,
    latitude: 38.9581,
    longitude: -94.59715,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64114',
  },
  {
    city: 'Kansas City',
    county_fips: 29047,
    county_fips_all: '29047',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"29047": 100}',
    density: 642.9,
    imprecise: false,
    latitude: 39.14875,
    longitude: -94.57444,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64116',
  },
  {
    city: 'Kansas City',
    county_fips: 29047,
    county_fips_all: '29047',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"29047": 100}',
    density: 953.7,
    imprecise: false,
    latitude: 39.16522,
    longitude: -94.52251,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64117',
  },
  {
    city: 'Kansas City',
    county_fips: 29047,
    county_fips_all: '29047|29165',
    county: 'Clay',
    county_names_all: 'Clay|Platte',
    county_weights: '{"29047": 98.87, "29165": 1.13}',
    density: 1268.8,
    imprecise: false,
    latitude: 39.21301,
    longitude: -94.57497,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64118',
  },
  {
    city: 'Kansas City',
    county_fips: 29047,
    county_fips_all: '29047',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"29047": 100}',
    density: 883.9,
    imprecise: false,
    latitude: 39.21137,
    longitude: -94.5186,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64119',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 26.9,
    imprecise: false,
    latitude: 39.13142,
    longitude: -94.51489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64120',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 2541.7,
    imprecise: false,
    latitude: 39.11436,
    longitude: -94.52167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64123',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 2503.7,
    imprecise: false,
    latitude: 39.10718,
    longitude: -94.5391,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64124',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 621.5,
    imprecise: false,
    latitude: 39.1065,
    longitude: -94.49388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64125',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 1026.4,
    imprecise: false,
    latitude: 39.09095,
    longitude: -94.49581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64126',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 1632.5,
    imprecise: false,
    latitude: 39.08912,
    longitude: -94.53837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64127',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 1530,
    imprecise: false,
    latitude: 39.06555,
    longitude: -94.53484,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64128',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 345.9,
    imprecise: false,
    latitude: 39.04935,
    longitude: -94.49682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64129',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 1070.6,
    imprecise: false,
    latitude: 39.03345,
    longitude: -94.54119,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64130',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 991.9,
    imprecise: false,
    latitude: 38.95723,
    longitude: -94.57449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64131',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 433.2,
    imprecise: false,
    latitude: 38.98551,
    longitude: -94.5396,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64132',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 823.9,
    imprecise: false,
    latitude: 39.01406,
    longitude: -94.45689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64133',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 744.4,
    imprecise: false,
    latitude: 38.9308,
    longitude: -94.48667,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64134',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 144.4,
    imprecise: false,
    latitude: 39.01361,
    longitude: -94.40181,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64136',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 630.4,
    imprecise: false,
    latitude: 38.93196,
    longitude: -94.54287,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64137',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 689.7,
    imprecise: false,
    latitude: 38.96852,
    longitude: -94.47088,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64138',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 225.6,
    imprecise: false,
    latitude: 38.96832,
    longitude: -94.40677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64139',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 344.7,
    imprecise: false,
    latitude: 38.88046,
    longitude: -94.59652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64145',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 92.6,
    imprecise: false,
    latitude: 38.87888,
    longitude: -94.57436,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64146',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095|29037',
    county: 'Jackson',
    county_names_all: 'Jackson|Cass',
    county_weights: '{"29095": 90.18, "29037": 9.82}',
    density: 51.7,
    imprecise: false,
    latitude: 38.85387,
    longitude: -94.54688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64147',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 38.86524,
    longitude: -94.46666,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64149',
  },
  {
    city: 'Riverside',
    county_fips: 29165,
    county_fips_all: '29165|29047',
    county: 'Platte',
    county_names_all: 'Platte|Clay',
    county_weights: '{"29165": 99.79, "29047": 0.21}',
    density: 306.3,
    imprecise: false,
    latitude: 39.17052,
    longitude: -94.6303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64150',
  },
  {
    city: 'Kansas City',
    county_fips: 29165,
    county_fips_all: '29165|29047',
    county: 'Platte',
    county_names_all: 'Platte|Clay',
    county_weights: '{"29165": 99.84, "29047": 0.16}',
    density: 839.6,
    imprecise: false,
    latitude: 39.21494,
    longitude: -94.63115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64151',
  },
  {
    city: 'Kansas City',
    county_fips: 29165,
    county_fips_all: '29165',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"29165": 100}',
    density: 394.3,
    imprecise: false,
    latitude: 39.21278,
    longitude: -94.72271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64152',
  },
  {
    city: 'Kansas City',
    county_fips: 29165,
    county_fips_all: '29165',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"29165": 100}',
    density: 70.5,
    imprecise: false,
    latitude: 39.27999,
    longitude: -94.73148,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64153',
  },
  {
    city: 'Kansas City',
    county_fips: 29165,
    county_fips_all: '29165',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"29165": 100}',
    density: 413.3,
    imprecise: false,
    latitude: 39.27653,
    longitude: -94.62967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64154',
  },
  {
    city: 'Kansas City',
    county_fips: 29047,
    county_fips_all: '29047|29165',
    county: 'Clay',
    county_names_all: 'Clay|Platte',
    county_weights: '{"29047": 99.58, "29165": 0.42}',
    density: 762.3,
    imprecise: false,
    latitude: 39.28031,
    longitude: -94.56801,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64155',
  },
  {
    city: 'Kansas City',
    county_fips: 29047,
    county_fips_all: '29047',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"29047": 100}',
    density: 283.4,
    imprecise: false,
    latitude: 39.2762,
    longitude: -94.5195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64156',
  },
  {
    city: 'Kansas City',
    county_fips: 29047,
    county_fips_all: '29047',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"29047": 100}',
    density: 822.7,
    imprecise: false,
    latitude: 39.27657,
    longitude: -94.47103,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64157',
  },
  {
    city: 'Kansas City',
    county_fips: 29047,
    county_fips_all: '29047',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"29047": 100}',
    density: 1230.3,
    imprecise: false,
    latitude: 39.23493,
    longitude: -94.47839,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64158',
  },
  {
    city: 'Kansas City',
    county_fips: 29047,
    county_fips_all: '29047',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"29047": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 39.16184,
    longitude: -94.44943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64161',
  },
  {
    city: 'Kansas City',
    county_fips: 29165,
    county_fips_all: '29165',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"29165": 100}',
    density: 50.6,
    imprecise: false,
    latitude: 39.33674,
    longitude: -94.68922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64163',
  },
  {
    city: 'Kansas City',
    county_fips: 29165,
    county_fips_all: '29165',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"29165": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 39.32988,
    longitude: -94.63113,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64164',
  },
  {
    city: 'Kansas City',
    county_fips: 29047,
    county_fips_all: '29047',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"29047": 100}',
    density: 20.6,
    imprecise: false,
    latitude: 39.32081,
    longitude: -94.57749,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64165',
  },
  {
    city: 'Kansas City',
    county_fips: 29047,
    county_fips_all: '29047',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"29047": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 39.32215,
    longitude: -94.52301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64166',
  },
  {
    city: 'Kansas City',
    county_fips: 29047,
    county_fips_all: '29047',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"29047": 100}',
    density: 54.1,
    imprecise: false,
    latitude: 39.31939,
    longitude: -94.48187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64167',
  },
  {
    city: 'Agency',
    county_fips: 29021,
    county_fips_all: '29021',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"29021": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 39.63452,
    longitude: -94.71522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64401',
  },
  {
    city: 'Albany',
    county_fips: 29075,
    county_fips_all: '29075',
    county: 'Gentry',
    county_names_all: 'Gentry',
    county_weights: '{"29075": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 40.25201,
    longitude: -94.32276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64402',
  },
  {
    city: 'Allendale',
    county_fips: 29227,
    county_fips_all: '29227',
    county: 'Worth',
    county_names_all: 'Worth',
    county_weights: '{"29227": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 40.48645,
    longitude: -94.2892,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64420',
  },
  {
    city: 'Amazonia',
    county_fips: 29003,
    county_fips_all: '29003',
    county: 'Andrew',
    county_names_all: 'Andrew',
    county_weights: '{"29003": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 39.9082,
    longitude: -94.92779,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64421',
  },
  {
    city: 'Amity',
    county_fips: 29063,
    county_fips_all: '29063',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"29063": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 39.90022,
    longitude: -94.4941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64422',
  },
  {
    city: 'Barnard',
    county_fips: 29147,
    county_fips_all: '29147|29003',
    county: 'Nodaway',
    county_names_all: 'Nodaway|Andrew',
    county_weights: '{"29147": 97.92, "29003": 2.08}',
    density: 4.2,
    imprecise: false,
    latitude: 40.18695,
    longitude: -94.8552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64423',
  },
  {
    city: 'Bethany',
    county_fips: 29081,
    county_fips_all: '29081',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"29081": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 40.26453,
    longitude: -94.03242,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64424',
  },
  {
    city: 'Blythedale',
    county_fips: 29081,
    county_fips_all: '29081',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"29081": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 40.51747,
    longitude: -93.86158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64426',
  },
  {
    city: 'Bolckow',
    county_fips: 29003,
    county_fips_all: '29003|29147',
    county: 'Andrew',
    county_names_all: 'Andrew|Nodaway',
    county_weights: '{"29003": 82.33, "29147": 17.67}',
    density: 3.6,
    imprecise: false,
    latitude: 40.10828,
    longitude: -94.84136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64427',
  },
  {
    city: 'Burlington Junction',
    county_fips: 29147,
    county_fips_all: '29147|29005',
    county: 'Nodaway',
    county_names_all: 'Nodaway|Atchison',
    county_weights: '{"29147": 86.55, "29005": 13.45}',
    density: 2.6,
    imprecise: false,
    latitude: 40.4418,
    longitude: -95.08836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64428',
  },
  {
    city: 'Cameron',
    county_fips: 29063,
    county_fips_all: '29063|29025|29049|29061',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Caldwell|Clinton|Daviess',
    county_weights:
      '{"29063": 32.98, "29025": 30.87, "29049": 30.54, "29061": 5.61}',
    density: 29.3,
    imprecise: false,
    latitude: 39.73895,
    longitude: -94.2285,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64429',
  },
  {
    city: 'Clarksdale',
    county_fips: 29063,
    county_fips_all: '29063|29003',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Andrew',
    county_weights: '{"29063": 84.54, "29003": 15.46}',
    density: 7.2,
    imprecise: false,
    latitude: 39.83771,
    longitude: -94.56924,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64430',
  },
  {
    city: 'Clearmont',
    county_fips: 29147,
    county_fips_all: '29147',
    county: 'Nodaway',
    county_names_all: 'Nodaway',
    county_weights: '{"29147": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 40.53046,
    longitude: -94.99357,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64431',
  },
  {
    city: 'Clyde',
    county_fips: 29147,
    county_fips_all: '29147',
    county: 'Nodaway',
    county_names_all: 'Nodaway',
    county_weights: '{"29147": 100}',
    density: 42.5,
    imprecise: false,
    latitude: 40.26399,
    longitude: -94.66119,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64432',
  },
  {
    city: 'Conception',
    county_fips: 29147,
    county_fips_all: '29147',
    county: 'Nodaway',
    county_names_all: 'Nodaway',
    county_weights: '{"29147": 100}',
    density: 104,
    imprecise: false,
    latitude: 40.24107,
    longitude: -94.68053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64433',
  },
  {
    city: 'Conception Junction',
    county_fips: 29147,
    county_fips_all: '29147',
    county: 'Nodaway',
    county_names_all: 'Nodaway',
    county_weights: '{"29147": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 40.2584,
    longitude: -94.73615,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64434',
  },
  {
    city: 'Cosby',
    county_fips: 29003,
    county_fips_all: '29003|29021',
    county: 'Andrew',
    county_names_all: 'Andrew|Buchanan',
    county_weights: '{"29003": 99.85, "29021": 0.15}',
    density: 11,
    imprecise: false,
    latitude: 39.85362,
    longitude: -94.69034,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64436',
  },
  {
    city: 'Craig',
    county_fips: 29087,
    county_fips_all: '29087|29005',
    county: 'Holt',
    county_names_all: 'Holt|Atchison',
    county_weights: '{"29087": 99.58, "29005": 0.42}',
    density: 1.4,
    imprecise: false,
    latitude: 40.14292,
    longitude: -95.35546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64437',
  },
  {
    city: 'Darlington',
    county_fips: 29075,
    county_fips_all: '29075',
    county: 'Gentry',
    county_names_all: 'Gentry',
    county_weights: '{"29075": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 40.16106,
    longitude: -94.41091,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64438',
  },
  {
    city: 'Dearborn',
    county_fips: 29165,
    county_fips_all: '29165|29021',
    county: 'Platte',
    county_names_all: 'Platte|Buchanan',
    county_weights: '{"29165": 58.5, "29021": 41.5}',
    density: 11,
    imprecise: false,
    latitude: 39.52371,
    longitude: -94.74986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64439',
  },
  {
    city: 'De Kalb',
    county_fips: 29021,
    county_fips_all: '29021|29165',
    county: 'Buchanan',
    county_names_all: 'Buchanan|Platte',
    county_weights: '{"29021": 90.66, "29165": 9.34}',
    density: 9.6,
    imprecise: false,
    latitude: 39.57849,
    longitude: -94.91841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64440',
  },
  {
    city: 'Denver',
    county_fips: 29227,
    county_fips_all: '29227|29075',
    county: 'Worth',
    county_names_all: 'Worth|Gentry',
    county_weights: '{"29227": 61.73, "29075": 38.27}',
    density: 0.8,
    imprecise: false,
    latitude: 40.39883,
    longitude: -94.2642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64441',
  },
  {
    city: 'Eagleville',
    county_fips: 29081,
    county_fips_all: '29081',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"29081": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 40.49935,
    longitude: -94.00645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64442',
  },
  {
    city: 'Easton',
    county_fips: 29021,
    county_fips_all: '29021',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"29021": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 39.74724,
    longitude: -94.65205,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64443',
  },
  {
    city: 'Edgerton',
    county_fips: 29165,
    county_fips_all: '29165|29021|29049',
    county: 'Platte',
    county_names_all: 'Platte|Buchanan|Clinton',
    county_weights: '{"29165": 76.85, "29021": 18.96, "29049": 4.19}',
    density: 11.7,
    imprecise: false,
    latitude: 39.48334,
    longitude: -94.63856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64444',
  },
  {
    city: 'Elmo',
    county_fips: 29147,
    county_fips_all: '29147',
    county: 'Nodaway',
    county_names_all: 'Nodaway',
    county_weights: '{"29147": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 40.53533,
    longitude: -95.13881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64445',
  },
  {
    city: 'Fairfax',
    county_fips: 29005,
    county_fips_all: '29005',
    county: 'Atchison',
    county_names_all: 'Atchison',
    county_weights: '{"29005": 100}',
    density: 3,
    imprecise: false,
    latitude: 40.32176,
    longitude: -95.40297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64446',
  },
  {
    city: 'Faucett',
    county_fips: 29021,
    county_fips_all: '29021',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"29021": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 39.60258,
    longitude: -94.81856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64448',
  },
  {
    city: 'Fillmore',
    county_fips: 29003,
    county_fips_all: '29003',
    county: 'Andrew',
    county_names_all: 'Andrew',
    county_weights: '{"29003": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 40.04135,
    longitude: -94.97754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64449',
  },
  {
    city: 'Forest City',
    county_fips: 29087,
    county_fips_all: '29087',
    county: 'Holt',
    county_names_all: 'Holt',
    county_weights: '{"29087": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 39.99067,
    longitude: -95.20664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64451',
  },
  {
    city: 'Gentry',
    county_fips: 29075,
    county_fips_all: '29075|29227',
    county: 'Gentry',
    county_names_all: 'Gentry|Worth',
    county_weights: '{"29075": 99.85, "29227": 0.15}',
    density: 1.3,
    imprecise: false,
    latitude: 40.34471,
    longitude: -94.46947,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64453',
  },
  {
    city: 'Gower',
    county_fips: 29049,
    county_fips_all: '29049|29021',
    county: 'Clinton',
    county_names_all: 'Clinton|Buchanan',
    county_weights: '{"29049": 55.8, "29021": 44.2}',
    density: 15.8,
    imprecise: false,
    latitude: 39.60771,
    longitude: -94.59423,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64454',
  },
  {
    city: 'Graham',
    county_fips: 29147,
    county_fips_all: '29147|29003',
    county: 'Nodaway',
    county_names_all: 'Nodaway|Andrew',
    county_weights: '{"29147": 91.04, "29003": 8.96}',
    density: 2,
    imprecise: false,
    latitude: 40.18592,
    longitude: -95.00594,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64455',
  },
  {
    city: 'Grant City',
    county_fips: 29227,
    county_fips_all: '29227|29081',
    county: 'Worth',
    county_names_all: 'Worth|Harrison',
    county_weights: '{"29227": 93.9, "29081": 6.1}',
    density: 3.2,
    imprecise: false,
    latitude: 40.49433,
    longitude: -94.38733,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64456',
  },
  {
    city: 'Guilford',
    county_fips: 29147,
    county_fips_all: '29147|29003',
    county: 'Nodaway',
    county_names_all: 'Nodaway|Andrew',
    county_weights: '{"29147": 85.47, "29003": 14.53}',
    density: 3,
    imprecise: false,
    latitude: 40.15886,
    longitude: -94.68368,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64457',
  },
  {
    city: 'Hatfield',
    county_fips: 29081,
    county_fips_all: '29081|29227',
    county: 'Harrison',
    county_names_all: 'Harrison|Worth',
    county_weights: '{"29081": 95.11, "29227": 4.89}',
    density: 1,
    imprecise: false,
    latitude: 40.52246,
    longitude: -94.14491,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64458',
  },
  {
    city: 'Helena',
    county_fips: 29003,
    county_fips_all: '29003',
    county: 'Andrew',
    county_names_all: 'Andrew',
    county_weights: '{"29003": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 39.93129,
    longitude: -94.65017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64459',
  },
  {
    city: 'Hopkins',
    county_fips: 29147,
    county_fips_all: '29147',
    county: 'Nodaway',
    county_names_all: 'Nodaway',
    county_weights: '{"29147": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 40.52459,
    longitude: -94.81063,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64461',
  },
  {
    city: 'King City',
    county_fips: 29075,
    county_fips_all: '29075|29063|29003',
    county: 'Gentry',
    county_names_all: 'Gentry|DeKalb|Andrew',
    county_weights: '{"29075": 66.11, "29063": 26.22, "29003": 7.67}',
    density: 3.8,
    imprecise: false,
    latitude: 40.06526,
    longitude: -94.4869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64463',
  },
  {
    city: 'Lathrop',
    county_fips: 29049,
    county_fips_all: '29049|29025',
    county: 'Clinton',
    county_names_all: 'Clinton|Caldwell',
    county_weights: '{"29049": 86.28, "29025": 13.72}',
    density: 16.2,
    imprecise: false,
    latitude: 39.54853,
    longitude: -94.29525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64465',
  },
  {
    city: 'Maitland',
    county_fips: 29087,
    county_fips_all: '29087',
    county: 'Holt',
    county_names_all: 'Holt',
    county_weights: '{"29087": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 40.16865,
    longitude: -95.1067,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64466',
  },
  {
    city: 'Martinsville',
    county_fips: 29081,
    county_fips_all: '29081',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"29081": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 40.39772,
    longitude: -94.16236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64467',
  },
  {
    city: 'Maryville',
    county_fips: 29147,
    county_fips_all: '29147',
    county: 'Nodaway',
    county_names_all: 'Nodaway',
    county_weights: '{"29147": 100}',
    density: 38.1,
    imprecise: false,
    latitude: 40.34241,
    longitude: -94.8811,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64468',
  },
  {
    city: 'Maysville',
    county_fips: 29063,
    county_fips_all: '29063|29075',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Gentry',
    county_weights: '{"29063": 98.33, "29075": 1.67}',
    density: 7.1,
    imprecise: false,
    latitude: 39.93085,
    longitude: -94.35762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64469',
  },
  {
    city: 'Mound City',
    county_fips: 29087,
    county_fips_all: '29087',
    county: 'Holt',
    county_names_all: 'Holt',
    county_weights: '{"29087": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 40.17036,
    longitude: -95.22138,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64470',
  },
  {
    city: 'New Hampton',
    county_fips: 29081,
    county_fips_all: '29081|29075',
    county: 'Harrison',
    county_names_all: 'Harrison|Gentry',
    county_weights: '{"29081": 79.07, "29075": 20.93}',
    density: 2.8,
    imprecise: false,
    latitude: 40.26548,
    longitude: -94.1936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64471',
  },
  {
    city: 'Oregon',
    county_fips: 29087,
    county_fips_all: '29087',
    county: 'Holt',
    county_names_all: 'Holt',
    county_weights: '{"29087": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 39.97606,
    longitude: -95.08446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64473',
  },
  {
    city: 'Osborn',
    county_fips: 29063,
    county_fips_all: '29063|29049',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Clinton',
    county_weights: '{"29063": 57.94, "29049": 42.06}',
    density: 5.7,
    imprecise: false,
    latitude: 39.75829,
    longitude: -94.38103,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64474',
  },
  {
    city: 'Parnell',
    county_fips: 29147,
    county_fips_all: '29147|29227|29075',
    county: 'Nodaway',
    county_names_all: 'Nodaway|Worth|Gentry',
    county_weights: '{"29147": 60.05, "29227": 37.99, "29075": 1.96}',
    density: 2.2,
    imprecise: false,
    latitude: 40.43561,
    longitude: -94.63049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64475',
  },
  {
    city: 'Pickering',
    county_fips: 29147,
    county_fips_all: '29147',
    county: 'Nodaway',
    county_names_all: 'Nodaway',
    county_weights: '{"29147": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 40.45115,
    longitude: -94.83034,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64476',
  },
  {
    city: 'Plattsburg',
    county_fips: 29049,
    county_fips_all: '29049',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"29049": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 39.57872,
    longitude: -94.45289,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64477',
  },
  {
    city: 'Ravenwood',
    county_fips: 29147,
    county_fips_all: '29147|29075',
    county: 'Nodaway',
    county_names_all: 'Nodaway|Gentry',
    county_weights: '{"29147": 84.26, "29075": 15.74}',
    density: 6.4,
    imprecise: false,
    latitude: 40.34853,
    longitude: -94.66636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64479',
  },
  {
    city: 'Rea',
    county_fips: 29003,
    county_fips_all: '29003',
    county: 'Andrew',
    county_names_all: 'Andrew',
    county_weights: '{"29003": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 40.06102,
    longitude: -94.70826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64480',
  },
  {
    city: 'Ridgeway',
    county_fips: 29081,
    county_fips_all: '29081',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"29081": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 40.35622,
    longitude: -93.8957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64481',
  },
  {
    city: 'Rock Port',
    county_fips: 29005,
    county_fips_all: '29005',
    county: 'Atchison',
    county_names_all: 'Atchison',
    county_weights: '{"29005": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 40.45345,
    longitude: -95.54329,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64482',
  },
  {
    city: 'Rosendale',
    county_fips: 29003,
    county_fips_all: '29003',
    county: 'Andrew',
    county_names_all: 'Andrew',
    county_weights: '{"29003": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 40.04335,
    longitude: -94.83471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64483',
  },
  {
    city: 'Rushville',
    county_fips: 29021,
    county_fips_all: '29021|29165',
    county: 'Buchanan',
    county_names_all: 'Buchanan|Platte',
    county_weights: '{"29021": 65.72, "29165": 34.28}',
    density: 5,
    imprecise: false,
    latitude: 39.55638,
    longitude: -95.01974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64484',
  },
  {
    city: 'Savannah',
    county_fips: 29003,
    county_fips_all: '29003',
    county: 'Andrew',
    county_names_all: 'Andrew',
    county_weights: '{"29003": 100}',
    density: 28.5,
    imprecise: false,
    latitude: 39.95325,
    longitude: -94.8184,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64485',
  },
  {
    city: 'Sheridan',
    county_fips: 29227,
    county_fips_all: '29227|29147',
    county: 'Worth',
    county_names_all: 'Worth|Nodaway',
    county_weights: '{"29227": 60.76, "29147": 39.24}',
    density: 2,
    imprecise: false,
    latitude: 40.52951,
    longitude: -94.61471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64486',
  },
  {
    city: 'Skidmore',
    county_fips: 29147,
    county_fips_all: '29147|29005|29087',
    county: 'Nodaway',
    county_names_all: 'Nodaway|Atchison|Holt',
    county_weights: '{"29147": 75.08, "29005": 16.26, "29087": 8.66}',
    density: 1.7,
    imprecise: false,
    latitude: 40.31218,
    longitude: -95.10293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64487',
  },
  {
    city: 'Stanberry',
    county_fips: 29075,
    county_fips_all: '29075|29147',
    county: 'Gentry',
    county_names_all: 'Gentry|Nodaway',
    county_weights: '{"29075": 77.47, "29147": 22.53}',
    density: 6.5,
    imprecise: false,
    latitude: 40.23543,
    longitude: -94.54969,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64489',
  },
  {
    city: 'Stewartsville',
    county_fips: 29049,
    county_fips_all: '29049|29063|29021',
    county: 'Clinton',
    county_names_all: 'Clinton|DeKalb|Buchanan',
    county_weights: '{"29049": 59.63, "29063": 40.19, "29021": 0.18}',
    density: 8.6,
    imprecise: false,
    latitude: 39.73837,
    longitude: -94.50984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64490',
  },
  {
    city: 'Tarkio',
    county_fips: 29005,
    county_fips_all: '29005',
    county: 'Atchison',
    county_names_all: 'Atchison',
    county_weights: '{"29005": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 40.44868,
    longitude: -95.34499,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64491',
  },
  {
    city: 'Trimble',
    county_fips: 29049,
    county_fips_all: '29049|29047|29165',
    county: 'Clinton',
    county_names_all: 'Clinton|Clay|Platte',
    county_weights: '{"29049": 72.66, "29047": 21.73, "29165": 5.61}',
    density: 18.5,
    imprecise: false,
    latitude: 39.48067,
    longitude: -94.53363,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64492',
  },
  {
    city: 'Turney',
    county_fips: 29049,
    county_fips_all: '29049',
    county: 'Clinton',
    county_names_all: 'Clinton',
    county_weights: '{"29049": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 39.63058,
    longitude: -94.30454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64493',
  },
  {
    city: 'Union Star',
    county_fips: 29003,
    county_fips_all: '29003|29063',
    county: 'Andrew',
    county_names_all: 'Andrew|DeKalb',
    county_weights: '{"29003": 53.27, "29063": 46.73}',
    density: 7.9,
    imprecise: false,
    latitude: 39.99234,
    longitude: -94.61465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64494',
  },
  {
    city: 'Watson',
    county_fips: 29005,
    county_fips_all: '29005',
    county: 'Atchison',
    county_names_all: 'Atchison',
    county_weights: '{"29005": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 40.49563,
    longitude: -95.62372,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64496',
  },
  {
    city: 'Weatherby',
    county_fips: 29063,
    county_fips_all: '29063|29061',
    county: 'DeKalb',
    county_names_all: 'DeKalb|Daviess',
    county_weights: '{"29063": 65.98, "29061": 34.02}',
    density: 4.6,
    imprecise: false,
    latitude: 39.92929,
    longitude: -94.22275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64497',
  },
  {
    city: 'Westboro',
    county_fips: 29005,
    county_fips_all: '29005',
    county: 'Atchison',
    county_names_all: 'Atchison',
    county_weights: '{"29005": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 40.54023,
    longitude: -95.31255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64498',
  },
  {
    city: 'Worth',
    county_fips: 29227,
    county_fips_all: '29227|29075',
    county: 'Worth',
    county_names_all: 'Worth|Gentry',
    county_weights: '{"29227": 70.19, "29075": 29.81}',
    density: 2,
    imprecise: false,
    latitude: 40.39707,
    longitude: -94.41521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64499',
  },
  {
    city: 'Saint Joseph',
    county_fips: 29021,
    county_fips_all: '29021',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"29021": 100}',
    density: 1111.5,
    imprecise: false,
    latitude: 39.76584,
    longitude: -94.84448,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64501',
  },
  {
    city: 'Saint Joseph',
    county_fips: 29021,
    county_fips_all: '29021',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"29021": 100}',
    density: 318.8,
    imprecise: false,
    latitude: 39.74973,
    longitude: -94.84545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64503',
  },
  {
    city: 'Saint Joseph',
    county_fips: 29021,
    county_fips_all: '29021',
    county: 'Buchanan',
    county_names_all: 'Buchanan',
    county_weights: '{"29021": 100}',
    density: 82.8,
    imprecise: false,
    latitude: 39.68605,
    longitude: -94.91264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64504',
  },
  {
    city: 'Saint Joseph',
    county_fips: 29003,
    county_fips_all: '29003|29021',
    county: 'Andrew',
    county_names_all: 'Andrew|Buchanan',
    county_weights: '{"29003": 76.81, "29021": 23.19}',
    density: 119.3,
    imprecise: false,
    latitude: 39.84431,
    longitude: -94.83354,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64505',
  },
  {
    city: 'Saint Joseph',
    county_fips: 29021,
    county_fips_all: '29021|29003',
    county: 'Buchanan',
    county_names_all: 'Buchanan|Andrew',
    county_weights: '{"29021": 95.96, "29003": 4.04}',
    density: 826.4,
    imprecise: false,
    latitude: 39.79048,
    longitude: -94.80277,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64506',
  },
  {
    city: 'Saint Joseph',
    county_fips: 29021,
    county_fips_all: '29021|29003',
    county: 'Buchanan',
    county_names_all: 'Buchanan|Andrew',
    county_weights: '{"29021": 98.94, "29003": 1.06}',
    density: 96.8,
    imprecise: false,
    latitude: 39.73324,
    longitude: -94.75735,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64507',
  },
  {
    city: 'Chillicothe',
    county_fips: 29117,
    county_fips_all: '29117|29061',
    county: 'Livingston',
    county_names_all: 'Livingston|Daviess',
    county_weights: '{"29117": 99.7, "29061": 0.3}',
    density: 19.7,
    imprecise: false,
    latitude: 39.8044,
    longitude: -93.57334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64601',
  },
  {
    city: 'Altamont',
    county_fips: 29061,
    county_fips_all: '29061',
    county: 'Daviess',
    county_names_all: 'Daviess',
    county_weights: '{"29061": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 39.89617,
    longitude: -94.09094,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64620',
  },
  {
    city: 'Bogard',
    county_fips: 29033,
    county_fips_all: '29033',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"29033": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 39.49535,
    longitude: -93.54569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64622',
  },
  {
    city: 'Bosworth',
    county_fips: 29033,
    county_fips_all: '29033',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"29033": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 39.47,
    longitude: -93.33344,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64623',
  },
  {
    city: 'Braymer',
    county_fips: 29025,
    county_fips_all: '29025|29033|29177|29117',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Carroll|Ray|Livingston',
    county_weights:
      '{"29025": 49.65, "29033": 26.17, "29177": 18.35, "29117": 5.83}',
    density: 4.8,
    imprecise: false,
    latitude: 39.57189,
    longitude: -93.7848,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64624',
  },
  {
    city: 'Breckenridge',
    county_fips: 29025,
    county_fips_all: '29025|29061|29117',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Daviess|Livingston',
    county_weights: '{"29025": 66.59, "29061": 22.93, "29117": 10.48}',
    density: 4.4,
    imprecise: false,
    latitude: 39.74378,
    longitude: -93.80527,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64625',
  },
  {
    city: 'Brookfield',
    county_fips: 29115,
    county_fips_all: '29115|29041',
    county: 'Linn',
    county_names_all: 'Linn|Chariton',
    county_weights: '{"29115": 86.85, "29041": 13.15}',
    density: 14.6,
    imprecise: false,
    latitude: 39.79711,
    longitude: -93.05002,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64628',
  },
  {
    city: 'Browning',
    county_fips: 29211,
    county_fips_all: '29211|29115',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Linn',
    county_weights: '{"29211": 52.66, "29115": 47.34}',
    density: 1.8,
    imprecise: false,
    latitude: 40.03726,
    longitude: -93.15435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64630',
  },
  {
    city: 'Bucklin',
    county_fips: 29115,
    county_fips_all: '29115|29121',
    county: 'Linn',
    county_names_all: 'Linn|Macon',
    county_weights: '{"29115": 68.8, "29121": 31.2}',
    density: 3.6,
    imprecise: false,
    latitude: 39.82018,
    longitude: -92.88213,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64631',
  },
  {
    city: 'Cainsville',
    county_fips: 29129,
    county_fips_all: '29129|29081',
    county: 'Mercer',
    county_names_all: 'Mercer|Harrison',
    county_weights: '{"29129": 58.46, "29081": 41.54}',
    density: 1.5,
    imprecise: false,
    latitude: 40.46915,
    longitude: -93.76862,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64632',
  },
  {
    city: 'Carrollton',
    county_fips: 29033,
    county_fips_all: '29033',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"29033": 100}',
    density: 7,
    imprecise: false,
    latitude: 39.35951,
    longitude: -93.48171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64633',
  },
  {
    city: 'Chula',
    county_fips: 29117,
    county_fips_all: '29117|29115|29079',
    county: 'Livingston',
    county_names_all: 'Livingston|Linn|Grundy',
    county_weights: '{"29117": 74.47, "29115": 15.46, "29079": 10.07}',
    density: 3.2,
    imprecise: false,
    latitude: 39.93943,
    longitude: -93.43632,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64635',
  },
  {
    city: 'Coffey',
    county_fips: 29061,
    county_fips_all: '29061|29081',
    county: 'Daviess',
    county_names_all: 'Daviess|Harrison',
    county_weights: '{"29061": 74.29, "29081": 25.71}',
    density: 3.8,
    imprecise: false,
    latitude: 40.11989,
    longitude: -93.98769,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64636',
  },
  {
    city: 'Cowgill',
    county_fips: 29025,
    county_fips_all: '29025|29177',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Ray',
    county_weights: '{"29025": 76.61, "29177": 23.39}',
    density: 2.6,
    imprecise: false,
    latitude: 39.57439,
    longitude: -93.91573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64637',
  },
  {
    city: 'Dawn',
    county_fips: 29117,
    county_fips_all: '29117|29033',
    county: 'Livingston',
    county_names_all: 'Livingston|Carroll',
    county_weights: '{"29117": 59.09, "29033": 40.91}',
    density: 2.7,
    imprecise: false,
    latitude: 39.61894,
    longitude: -93.61498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64638',
  },
  {
    city: 'De Witt',
    county_fips: 29033,
    county_fips_all: '29033',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"29033": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 39.3962,
    longitude: -93.22276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64639',
  },
  {
    city: 'Gallatin',
    county_fips: 29061,
    county_fips_all: '29061',
    county: 'Daviess',
    county_names_all: 'Daviess',
    county_weights: '{"29061": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 39.90172,
    longitude: -93.94542,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64640',
  },
  {
    city: 'Galt',
    county_fips: 29079,
    county_fips_all: '29079|29211',
    county: 'Grundy',
    county_names_all: 'Grundy|Sullivan',
    county_weights: '{"29079": 78.47, "29211": 21.53}',
    density: 3.1,
    imprecise: false,
    latitude: 40.16221,
    longitude: -93.3992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64641',
  },
  {
    city: 'Gilman City',
    county_fips: 29081,
    county_fips_all: '29081|29061|29079',
    county: 'Harrison',
    county_names_all: 'Harrison|Daviess|Grundy',
    county_weights: '{"29081": 64.5, "29061": 23.76, "29079": 11.74}',
    density: 2.8,
    imprecise: false,
    latitude: 40.16979,
    longitude: -93.83574,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64642',
  },
  {
    city: 'Hale',
    county_fips: 29033,
    county_fips_all: '29033|29117',
    county: 'Carroll',
    county_names_all: 'Carroll|Livingston',
    county_weights: '{"29033": 53.96, "29117": 46.04}',
    density: 3.9,
    imprecise: false,
    latitude: 39.61366,
    longitude: -93.36883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64643',
  },
  {
    city: 'Hamilton',
    county_fips: 29025,
    county_fips_all: '29025|29061',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Daviess',
    county_weights: '{"29025": 80.41, "29061": 19.59}',
    density: 10.5,
    imprecise: false,
    latitude: 39.7418,
    longitude: -93.97384,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64644',
  },
  {
    city: 'Harris',
    county_fips: 29211,
    county_fips_all: '29211|29129',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Mercer',
    county_weights: '{"29211": 70.8, "29129": 29.2}',
    density: 1,
    imprecise: false,
    latitude: 40.29834,
    longitude: -93.32575,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64645',
  },
  {
    city: 'Humphreys',
    county_fips: 29211,
    county_fips_all: '29211|29115',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Linn',
    county_weights: '{"29211": 87.79, "29115": 12.21}',
    density: 3.7,
    imprecise: false,
    latitude: 40.10456,
    longitude: -93.30819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64646',
  },
  {
    city: 'Jameson',
    county_fips: 29061,
    county_fips_all: '29061',
    county: 'Daviess',
    county_names_all: 'Daviess',
    county_weights: '{"29061": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 40.03016,
    longitude: -93.96862,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64647',
  },
  {
    city: 'Jamesport',
    county_fips: 29061,
    county_fips_all: '29061|29079|29117',
    county: 'Daviess',
    county_names_all: 'Daviess|Grundy|Livingston',
    county_weights: '{"29061": 78.16, "29079": 14.86, "29117": 6.98}',
    density: 7.9,
    imprecise: false,
    latitude: 39.98517,
    longitude: -93.79922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64648',
  },
  {
    city: 'Kidder',
    county_fips: 29025,
    county_fips_all: '29025|29061',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Daviess',
    county_weights: '{"29025": 57.97, "29061": 42.03}',
    density: 8.7,
    imprecise: false,
    latitude: 39.77428,
    longitude: -94.09183,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64649',
  },
  {
    city: 'Kingston',
    county_fips: 29025,
    county_fips_all: '29025',
    county: 'Caldwell',
    county_names_all: 'Caldwell',
    county_weights: '{"29025": 100}',
    density: 6,
    imprecise: false,
    latitude: 39.63716,
    longitude: -94.0548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64650',
  },
  {
    city: 'Laclede',
    county_fips: 29115,
    county_fips_all: '29115',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"29115": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 39.7759,
    longitude: -93.1797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64651',
  },
  {
    city: 'Laredo',
    county_fips: 29079,
    county_fips_all: '29079|29211|29115',
    county: 'Grundy',
    county_names_all: 'Grundy|Sullivan|Linn',
    county_weights: '{"29079": 96.79, "29211": 2.28, "29115": 0.93}',
    density: 3,
    imprecise: false,
    latitude: 40.01979,
    longitude: -93.42103,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64652',
  },
  {
    city: 'Linneus',
    county_fips: 29115,
    county_fips_all: '29115',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"29115": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 39.89403,
    longitude: -93.20403,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64653',
  },
  {
    city: 'Lucerne',
    county_fips: 29171,
    county_fips_all: '29171',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"29171": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 40.44017,
    longitude: -93.23684,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64655',
  },
  {
    city: 'Ludlow',
    county_fips: 29117,
    county_fips_all: '29117',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"29117": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 39.67803,
    longitude: -93.69375,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64656',
  },
  {
    city: 'McFall',
    county_fips: 29075,
    county_fips_all: '29075|29081|29061',
    county: 'Gentry',
    county_names_all: 'Gentry|Harrison|Daviess',
    county_weights: '{"29075": 53.92, "29081": 35.86, "29061": 10.22}',
    density: 1.5,
    imprecise: false,
    latitude: 40.13269,
    longitude: -94.21292,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64657',
  },
  {
    city: 'Marceline',
    county_fips: 29041,
    county_fips_all: '29041|29115|29121',
    county: 'Chariton',
    county_names_all: 'Chariton|Linn|Macon',
    county_weights: '{"29041": 75.06, "29115": 22.27, "29121": 2.67}',
    density: 13,
    imprecise: false,
    latitude: 39.66124,
    longitude: -92.92181,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64658',
  },
  {
    city: 'Meadville',
    county_fips: 29115,
    county_fips_all: '29115',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"29115": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 39.78138,
    longitude: -93.29224,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64659',
  },
  {
    city: 'Mendon',
    county_fips: 29041,
    county_fips_all: '29041',
    county: 'Chariton',
    county_names_all: 'Chariton',
    county_weights: '{"29041": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 39.57226,
    longitude: -93.08923,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64660',
  },
  {
    city: 'Mercer',
    county_fips: 29129,
    county_fips_all: '29129',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"29129": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 40.53031,
    longitude: -93.51901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64661',
  },
  {
    city: 'Mooresville',
    county_fips: 29117,
    county_fips_all: '29117',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"29117": 100}',
    density: 2,
    imprecise: false,
    latitude: 39.74601,
    longitude: -93.66027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64664',
  },
  {
    city: 'Newtown',
    county_fips: 29211,
    county_fips_all: '29211|29129|29171',
    county: 'Sullivan',
    county_names_all: 'Sullivan|Mercer|Putnam',
    county_weights: '{"29211": 38.35, "29129": 34.54, "29171": 27.11}',
    density: 1.3,
    imprecise: false,
    latitude: 40.39434,
    longitude: -93.33618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64667',
  },
  {
    city: 'Norborne',
    county_fips: 29033,
    county_fips_all: '29033|29177',
    county: 'Carroll',
    county_names_all: 'Carroll|Ray',
    county_weights: '{"29033": 80.21, "29177": 19.79}',
    density: 3.1,
    imprecise: false,
    latitude: 39.35226,
    longitude: -93.70704,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64668',
  },
  {
    city: 'Pattonsburg',
    county_fips: 29061,
    county_fips_all: '29061|29063|29075|29081',
    county: 'Daviess',
    county_names_all: 'Daviess|DeKalb|Gentry|Harrison',
    county_weights:
      '{"29061": 78.04, "29063": 12.11, "29075": 5.16, "29081": 4.69}',
    density: 3,
    imprecise: false,
    latitude: 40.04986,
    longitude: -94.13833,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64670',
  },
  {
    city: 'Polo',
    county_fips: 29025,
    county_fips_all: '29025|29177',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Ray',
    county_weights: '{"29025": 60.94, "29177": 39.06}',
    density: 8.3,
    imprecise: false,
    latitude: 39.53655,
    longitude: -94.0518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64671',
  },
  {
    city: 'Powersville',
    county_fips: 29171,
    county_fips_all: '29171|29129',
    county: 'Putnam',
    county_names_all: 'Putnam|Mercer',
    county_weights: '{"29171": 95.78, "29129": 4.22}',
    density: 0.9,
    imprecise: false,
    latitude: 40.53869,
    longitude: -93.26015,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64672',
  },
  {
    city: 'Princeton',
    county_fips: 29129,
    county_fips_all: '29129',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"29129": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 40.38001,
    longitude: -93.59094,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64673',
  },
  {
    city: 'Purdin',
    county_fips: 29115,
    county_fips_all: '29115',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"29115": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 39.96491,
    longitude: -93.15884,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64674',
  },
  {
    city: 'Rothville',
    county_fips: 29041,
    county_fips_all: '29041',
    county: 'Chariton',
    county_names_all: 'Chariton',
    county_weights: '{"29041": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 39.6471,
    longitude: -93.03729,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64676',
  },
  {
    city: 'Spickard',
    county_fips: 29079,
    county_fips_all: '29079|29129',
    county: 'Grundy',
    county_names_all: 'Grundy|Mercer',
    county_weights: '{"29079": 88.02, "29129": 11.98}',
    density: 3.7,
    imprecise: false,
    latitude: 40.23246,
    longitude: -93.58181,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64679',
  },
  {
    city: 'Sumner',
    county_fips: 29041,
    county_fips_all: '29041|29115',
    county: 'Chariton',
    county_names_all: 'Chariton|Linn',
    county_weights: '{"29041": 94.08, "29115": 5.92}',
    density: 1.2,
    imprecise: false,
    latitude: 39.64706,
    longitude: -93.21375,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64681',
  },
  {
    city: 'Tina',
    county_fips: 29033,
    county_fips_all: '29033',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"29033": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 39.55251,
    longitude: -93.49132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64682',
  },
  {
    city: 'Trenton',
    county_fips: 29079,
    county_fips_all: '29079|29117',
    county: 'Grundy',
    county_names_all: 'Grundy|Livingston',
    county_weights: '{"29079": 92.15, "29117": 7.85}',
    density: 12.9,
    imprecise: false,
    latitude: 40.07395,
    longitude: -93.60346,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64683',
  },
  {
    city: 'Utica',
    county_fips: 29117,
    county_fips_all: '29117',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"29117": 100}',
    density: 52.2,
    imprecise: false,
    latitude: 39.75005,
    longitude: -93.62449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64686',
  },
  {
    city: 'Wheeling',
    county_fips: 29117,
    county_fips_all: '29117|29115',
    county: 'Livingston',
    county_names_all: 'Livingston|Linn',
    county_weights: '{"29117": 74.33, "29115": 25.67}',
    density: 4.1,
    imprecise: false,
    latitude: 39.8139,
    longitude: -93.37664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64688',
  },
  {
    city: 'Winston',
    county_fips: 29061,
    county_fips_all: '29061',
    county: 'Daviess',
    county_names_all: 'Daviess',
    county_weights: '{"29061": 100}',
    density: 5,
    imprecise: false,
    latitude: 39.87461,
    longitude: -94.152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64689',
  },
  {
    city: 'Harrisonville',
    county_fips: 29037,
    county_fips_all: '29037',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"29037": 100}',
    density: 45.9,
    imprecise: false,
    latitude: 38.62053,
    longitude: -94.3378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64701',
  },
  {
    city: 'Adrian',
    county_fips: 29013,
    county_fips_all: '29013',
    county: 'Bates',
    county_names_all: 'Bates',
    county_weights: '{"29013": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 38.40533,
    longitude: -94.33742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64720',
  },
  {
    city: 'Amoret',
    county_fips: 29013,
    county_fips_all: '29013',
    county: 'Bates',
    county_names_all: 'Bates',
    county_weights: '{"29013": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 38.27388,
    longitude: -94.55188,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64722',
  },
  {
    city: 'Amsterdam',
    county_fips: 29013,
    county_fips_all: '29013',
    county: 'Bates',
    county_names_all: 'Bates',
    county_weights: '{"29013": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 38.3615,
    longitude: -94.55298,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64723',
  },
  {
    city: 'Appleton City',
    county_fips: 29185,
    county_fips_all: '29185|29013|29083',
    county: 'St. Clair',
    county_names_all: 'St. Clair|Bates|Henry',
    county_weights: '{"29185": 63.09, "29013": 35.46, "29083": 1.45}',
    density: 6.1,
    imprecise: false,
    latitude: 38.15188,
    longitude: -94.01025,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64724',
  },
  {
    city: 'Archie',
    county_fips: 29037,
    county_fips_all: '29037|29013',
    county: 'Cass',
    county_names_all: 'Cass|Bates',
    county_weights: '{"29037": 81.73, "29013": 18.27}',
    density: 15.1,
    imprecise: false,
    latitude: 38.49482,
    longitude: -94.36609,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64725',
  },
  {
    city: 'Blairstown',
    county_fips: 29083,
    county_fips_all: '29083|29101',
    county: 'Henry',
    county_names_all: 'Henry|Johnson',
    county_weights: '{"29083": 92.13, "29101": 7.87}',
    density: 2.3,
    imprecise: false,
    latitude: 38.52921,
    longitude: -93.92492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64726',
  },
  {
    city: 'Bronaugh',
    county_fips: 29217,
    county_fips_all: '29217',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"29217": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 37.70217,
    longitude: -94.5174,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64728',
  },
  {
    city: 'Butler',
    county_fips: 29013,
    county_fips_all: '29013',
    county: 'Bates',
    county_names_all: 'Bates',
    county_weights: '{"29013": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 38.25789,
    longitude: -94.29236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64730',
  },
  {
    city: 'Chilhowee',
    county_fips: 29101,
    county_fips_all: '29101|29083',
    county: 'Johnson',
    county_names_all: 'Johnson|Henry',
    county_weights: '{"29101": 65.87, "29083": 34.13}',
    density: 5.8,
    imprecise: false,
    latitude: 38.58016,
    longitude: -93.8283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64733',
  },
  {
    city: 'Cleveland',
    county_fips: 29037,
    county_fips_all: '29037',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"29037": 100}',
    density: 21.7,
    imprecise: false,
    latitude: 38.64888,
    longitude: -94.57405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64734',
  },
  {
    city: 'Clinton',
    county_fips: 29083,
    county_fips_all: '29083|29015',
    county: 'Henry',
    county_names_all: 'Henry|Benton',
    county_weights: '{"29083": 97.88, "29015": 2.12}',
    density: 20.6,
    imprecise: false,
    latitude: 38.36612,
    longitude: -93.73644,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64735',
  },
  {
    city: 'Collins',
    county_fips: 29185,
    county_fips_all: '29185',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"29185": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 37.90098,
    longitude: -93.65987,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64738',
  },
  {
    city: 'Creighton',
    county_fips: 29037,
    county_fips_all: '29037|29083',
    county: 'Cass',
    county_names_all: 'Cass|Henry',
    county_weights: '{"29037": 71.48, "29083": 28.52}',
    density: 7.9,
    imprecise: false,
    latitude: 38.51139,
    longitude: -94.09389,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64739',
  },
  {
    city: 'Deepwater',
    county_fips: 29083,
    county_fips_all: '29083|29185',
    county: 'Henry',
    county_names_all: 'Henry|St. Clair',
    county_weights: '{"29083": 70.06, "29185": 29.94}',
    density: 5.4,
    imprecise: false,
    latitude: 38.22349,
    longitude: -93.71204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64740',
  },
  {
    city: 'Deerfield',
    county_fips: 29217,
    county_fips_all: '29217',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"29217": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 37.81671,
    longitude: -94.5629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64741',
  },
  {
    city: 'Drexel',
    county_fips: 29037,
    county_fips_all: '29037|29013',
    county: 'Cass',
    county_names_all: 'Cass|Bates',
    county_weights: '{"29037": 68.88, "29013": 31.12}',
    density: 10.9,
    imprecise: false,
    latitude: 38.50034,
    longitude: -94.54329,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64742',
  },
  {
    city: 'East Lynne',
    county_fips: 29037,
    county_fips_all: '29037',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"29037": 100}',
    density: 45.9,
    imprecise: false,
    latitude: 38.66596,
    longitude: -94.21827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64743',
  },
  {
    city: 'El Dorado Springs',
    county_fips: 29039,
    county_fips_all: '29039|29185|29217',
    county: 'Cedar',
    county_names_all: 'Cedar|St. Clair|Vernon',
    county_weights: '{"29039": 57.08, "29185": 27.94, "29217": 14.98}',
    density: 12.7,
    imprecise: false,
    latitude: 37.84963,
    longitude: -93.97755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64744',
  },
  {
    city: 'Foster',
    county_fips: 29013,
    county_fips_all: '29013',
    county: 'Bates',
    county_names_all: 'Bates',
    county_weights: '{"29013": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 38.15662,
    longitude: -94.50384,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64745',
  },
  {
    city: 'Freeman',
    county_fips: 29037,
    county_fips_all: '29037',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"29037": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 38.61054,
    longitude: -94.49304,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64746',
  },
  {
    city: 'Garden City',
    county_fips: 29037,
    county_fips_all: '29037|29101',
    county: 'Cass',
    county_names_all: 'Cass|Johnson',
    county_weights: '{"29037": 80.72, "29101": 19.28}',
    density: 12.9,
    imprecise: false,
    latitude: 38.57353,
    longitude: -94.17399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64747',
  },
  {
    city: 'Golden City',
    county_fips: 29011,
    county_fips_all: '29011|29057|29097|29109',
    county: 'Barton',
    county_names_all: 'Barton|Dade|Jasper|Lawrence',
    county_weights:
      '{"29011": 45.74, "29057": 28.65, "29097": 18.77, "29109": 6.85}',
    density: 3.9,
    imprecise: false,
    latitude: 37.36497,
    longitude: -94.10017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64748',
  },
  {
    city: 'Harwood',
    county_fips: 29217,
    county_fips_all: '29217|29185',
    county: 'Vernon',
    county_names_all: 'Vernon|St. Clair',
    county_weights: '{"29217": 89.39, "29185": 10.61}',
    density: 5.7,
    imprecise: false,
    latitude: 37.93033,
    longitude: -94.11427,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64750',
  },
  {
    city: 'Hume',
    county_fips: 29217,
    county_fips_all: '29217|29013',
    county: 'Vernon',
    county_names_all: 'Vernon|Bates',
    county_weights: '{"29217": 52.3, "29013": 47.7}',
    density: 3.1,
    imprecise: false,
    latitude: 38.0689,
    longitude: -94.56862,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64752',
  },
  {
    city: 'Jasper',
    county_fips: 29097,
    county_fips_all: '29097|29011',
    county: 'Jasper',
    county_names_all: 'Jasper|Barton',
    county_weights: '{"29097": 65.24, "29011": 34.76}',
    density: 6.1,
    imprecise: false,
    latitude: 37.33685,
    longitude: -94.31112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64755',
  },
  {
    city: 'Jerico Springs',
    county_fips: 29039,
    county_fips_all: '29039|29057',
    county: 'Cedar',
    county_names_all: 'Cedar|Dade',
    county_weights: '{"29039": 76.66, "29057": 23.34}',
    density: 4.3,
    imprecise: false,
    latitude: 37.61931,
    longitude: -94.01462,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64756',
  },
  {
    city: 'Lamar',
    county_fips: 29011,
    county_fips_all: '29011|29057',
    county: 'Barton',
    county_names_all: 'Barton|Dade',
    county_weights: '{"29011": 99.0, "29057": 1.0}',
    density: 12.1,
    imprecise: false,
    latitude: 37.52655,
    longitude: -94.26775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64759',
  },
  {
    city: 'Leeton',
    county_fips: 29101,
    county_fips_all: '29101|29083',
    county: 'Johnson',
    county_names_all: 'Johnson|Henry',
    county_weights: '{"29101": 79.59, "29083": 20.41}',
    density: 8.8,
    imprecise: false,
    latitude: 38.59463,
    longitude: -93.68657,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64761',
  },
  {
    city: 'Liberal',
    county_fips: 29011,
    county_fips_all: '29011',
    county: 'Barton',
    county_names_all: 'Barton',
    county_weights: '{"29011": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 37.54628,
    longitude: -94.50176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64762',
  },
  {
    city: 'Lowry City',
    county_fips: 29185,
    county_fips_all: '29185',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"29185": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 38.14354,
    longitude: -93.71573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64763',
  },
  {
    city: 'Metz',
    county_fips: 29217,
    county_fips_all: '29217',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"29217": 100}',
    density: 21.3,
    imprecise: false,
    latitude: 37.9965,
    longitude: -94.44297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64765',
  },
  {
    city: 'Milo',
    county_fips: 29217,
    county_fips_all: '29217',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"29217": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 37.7499,
    longitude: -94.1997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64767',
  },
  {
    city: 'Mindenmines',
    county_fips: 29011,
    county_fips_all: '29011',
    county: 'Barton',
    county_names_all: 'Barton',
    county_weights: '{"29011": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 37.48028,
    longitude: -94.56688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64769',
  },
  {
    city: 'Montrose',
    county_fips: 29083,
    county_fips_all: '29083|29013|29185',
    county: 'Henry',
    county_names_all: 'Henry|Bates|St. Clair',
    county_weights: '{"29083": 84.01, "29013": 11.38, "29185": 4.61}',
    density: 4.1,
    imprecise: false,
    latitude: 38.27528,
    longitude: -93.98662,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64770',
  },
  {
    city: 'Moundville',
    county_fips: 29217,
    county_fips_all: '29217',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"29217": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 37.77091,
    longitude: -94.45967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64771',
  },
  {
    city: 'Nevada',
    county_fips: 29217,
    county_fips_all: '29217',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"29217": 100}',
    density: 38.4,
    imprecise: false,
    latitude: 37.82712,
    longitude: -94.33355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64772',
  },
  {
    city: 'Osceola',
    county_fips: 29185,
    county_fips_all: '29185|29015',
    county: 'St. Clair',
    county_names_all: 'St. Clair|Benton',
    county_weights: '{"29185": 94.55, "29015": 5.45}',
    density: 5.5,
    imprecise: false,
    latitude: 38.04242,
    longitude: -93.67469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64776',
  },
  {
    city: 'Richards',
    county_fips: 29217,
    county_fips_all: '29217',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"29217": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 37.92283,
    longitude: -94.4841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64778',
  },
  {
    city: 'Rich Hill',
    county_fips: 29013,
    county_fips_all: '29013|29217',
    county: 'Bates',
    county_names_all: 'Bates|Vernon',
    county_weights: '{"29013": 72.81, "29217": 27.19}',
    density: 5.2,
    imprecise: false,
    latitude: 38.09214,
    longitude: -94.40152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64779',
  },
  {
    city: 'Rockville',
    county_fips: 29185,
    county_fips_all: '29185|29013',
    county: 'St. Clair',
    county_names_all: 'St. Clair|Bates',
    county_weights: '{"29185": 58.09, "29013": 41.91}',
    density: 1.5,
    imprecise: false,
    latitude: 38.06246,
    longitude: -94.04276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64780',
  },
  {
    city: 'Roscoe',
    county_fips: 29185,
    county_fips_all: '29185',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"29185": 100}',
    density: 38.6,
    imprecise: false,
    latitude: 37.97837,
    longitude: -93.81242,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64781',
  },
  {
    city: 'Schell City',
    county_fips: 29217,
    county_fips_all: '29217|29185',
    county: 'Vernon',
    county_names_all: 'Vernon|St. Clair',
    county_weights: '{"29217": 72.79, "29185": 27.21}',
    density: 3.6,
    imprecise: false,
    latitude: 37.99972,
    longitude: -94.10688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64783',
  },
  {
    city: 'Sheldon',
    county_fips: 29217,
    county_fips_all: '29217|29011|29039',
    county: 'Vernon',
    county_names_all: 'Vernon|Barton|Cedar',
    county_weights: '{"29217": 74.41, "29011": 24.06, "29039": 1.53}',
    density: 4.7,
    imprecise: false,
    latitude: 37.66624,
    longitude: -94.23131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64784',
  },
  {
    city: 'Urich',
    county_fips: 29083,
    county_fips_all: '29083|29013',
    county: 'Henry',
    county_names_all: 'Henry|Bates',
    county_weights: '{"29083": 74.69, "29013": 25.31}',
    density: 5.4,
    imprecise: false,
    latitude: 38.42868,
    longitude: -94.02045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64788',
  },
  {
    city: 'Walker',
    county_fips: 29217,
    county_fips_all: '29217',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"29217": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 37.92924,
    longitude: -94.22969,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64790',
  },
  {
    city: 'Joplin',
    county_fips: 29097,
    county_fips_all: '29097',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"29097": 100}',
    density: 243.6,
    imprecise: false,
    latitude: 37.11056,
    longitude: -94.4974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64801',
  },
  {
    city: 'Joplin',
    county_fips: 29145,
    county_fips_all: '29145|29097',
    county: 'Newton',
    county_names_all: 'Newton|Jasper',
    county_weights: '{"29145": 81.39, "29097": 18.61}',
    density: 156.3,
    imprecise: false,
    latitude: 37.01955,
    longitude: -94.51137,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64804',
  },
  {
    city: 'Alba',
    county_fips: 29097,
    county_fips_all: '29097',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"29097": 100}',
    density: 158.1,
    imprecise: false,
    latitude: 37.2308,
    longitude: -94.41053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64830',
  },
  {
    city: 'Anderson',
    county_fips: 29119,
    county_fips_all: '29119',
    county: 'McDonald',
    county_names_all: 'McDonald',
    county_weights: '{"29119": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 36.65598,
    longitude: -94.4541,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64831',
  },
  {
    city: 'Asbury',
    county_fips: 29097,
    county_fips_all: '29097|29011',
    county: 'Jasper',
    county_names_all: 'Jasper|Barton',
    county_weights: '{"29097": 60.1, "29011": 39.9}',
    density: 7.1,
    imprecise: false,
    latitude: 37.33951,
    longitude: -94.57264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64832',
  },
  {
    city: 'Avilla',
    county_fips: 29097,
    county_fips_all: '29097',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"29097": 100}',
    density: 138.3,
    imprecise: false,
    latitude: 37.1938,
    longitude: -94.12982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64833',
  },
  {
    city: 'Carl Junction',
    county_fips: 29097,
    county_fips_all: '29097',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"29097": 100}',
    density: 126.9,
    imprecise: false,
    latitude: 37.18714,
    longitude: -94.56865,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64834',
  },
  {
    city: 'Carterville',
    county_fips: 29097,
    county_fips_all: '29097',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"29097": 100}',
    density: 372.4,
    imprecise: false,
    latitude: 37.14749,
    longitude: -94.43824,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64835',
  },
  {
    city: 'Carthage',
    county_fips: 29097,
    county_fips_all: '29097',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"29097": 100}',
    density: 55.7,
    imprecise: false,
    latitude: 37.18886,
    longitude: -94.28898,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64836',
  },
  {
    city: 'Diamond',
    county_fips: 29145,
    county_fips_all: '29145|29097',
    county: 'Newton',
    county_names_all: 'Newton|Jasper',
    county_weights: '{"29145": 87.25, "29097": 12.75}',
    density: 24.7,
    imprecise: false,
    latitude: 37.01826,
    longitude: -94.33536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64840',
  },
  {
    city: 'Duenweg',
    county_fips: 29097,
    county_fips_all: '29097',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"29097": 100}',
    density: 1272.2,
    imprecise: false,
    latitude: 37.07873,
    longitude: -94.41101,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64841',
  },
  {
    city: 'Fairview',
    county_fips: 29145,
    county_fips_all: '29145|29009',
    county: 'Newton',
    county_names_all: 'Newton|Barry',
    county_weights: '{"29145": 94.43, "29009": 5.57}',
    density: 13.7,
    imprecise: false,
    latitude: 36.7914,
    longitude: -94.10427,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64842',
  },
  {
    city: 'Goodman',
    county_fips: 29119,
    county_fips_all: '29119|29145',
    county: 'McDonald',
    county_names_all: 'McDonald|Newton',
    county_weights: '{"29119": 86.34, "29145": 13.66}',
    density: 21.1,
    imprecise: false,
    latitude: 36.73345,
    longitude: -94.45319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64843',
  },
  {
    city: 'Granby',
    county_fips: 29145,
    county_fips_all: '29145',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"29145": 100}',
    density: 28.1,
    imprecise: false,
    latitude: 36.91388,
    longitude: -94.24038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64844',
  },
  {
    city: 'Lanagan',
    county_fips: 29119,
    county_fips_all: '29119',
    county: 'McDonald',
    county_names_all: 'McDonald',
    county_weights: '{"29119": 100}',
    density: 42.4,
    imprecise: false,
    latitude: 36.59217,
    longitude: -94.43863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64847',
  },
  {
    city: 'La Russell',
    county_fips: 29109,
    county_fips_all: '29109|29097',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Jasper',
    county_weights: '{"29109": 98.78, "29097": 1.22}',
    density: 5.6,
    imprecise: false,
    latitude: 37.18061,
    longitude: -93.99523,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64848',
  },
  {
    city: 'Neck City',
    county_fips: 29097,
    county_fips_all: '29097',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"29097": 100}',
    density: 207.8,
    imprecise: false,
    latitude: 37.2544,
    longitude: -94.44529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64849',
  },
  {
    city: 'Neosho',
    county_fips: 29145,
    county_fips_all: '29145|29119',
    county: 'Newton',
    county_names_all: 'Newton|McDonald',
    county_weights: '{"29145": 96.14, "29119": 3.86}',
    density: 47.7,
    imprecise: false,
    latitude: 36.86008,
    longitude: -94.3975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64850',
  },
  {
    city: 'Noel',
    county_fips: 29119,
    county_fips_all: '29119',
    county: 'McDonald',
    county_names_all: 'McDonald',
    county_weights: '{"29119": 100}',
    density: 25.5,
    imprecise: false,
    latitude: 36.54369,
    longitude: -94.44144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64854',
  },
  {
    city: 'Oronogo',
    county_fips: 29097,
    county_fips_all: '29097|29011',
    county: 'Jasper',
    county_names_all: 'Jasper|Barton',
    county_weights: '{"29097": 86.97, "29011": 13.03}',
    density: 27.6,
    imprecise: false,
    latitude: 37.29548,
    longitude: -94.48637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64855',
  },
  {
    city: 'Pineville',
    county_fips: 29119,
    county_fips_all: '29119',
    county: 'McDonald',
    county_names_all: 'McDonald',
    county_weights: '{"29119": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 36.5652,
    longitude: -94.26346,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64856',
  },
  {
    city: 'Purcell',
    county_fips: 29097,
    county_fips_all: '29097',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"29097": 100}',
    density: 255.2,
    imprecise: false,
    latitude: 37.24587,
    longitude: -94.43861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64857',
  },
  {
    city: 'Racine',
    county_fips: 29145,
    county_fips_all: '29145',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"29145": 100}',
    density: 665,
    imprecise: false,
    latitude: 36.89981,
    longitude: -94.52888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64858',
  },
  {
    city: 'Reeds',
    county_fips: 29097,
    county_fips_all: '29097',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"29097": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 37.15822,
    longitude: -94.14703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64859',
  },
  {
    city: 'Rocky Comfort',
    county_fips: 29119,
    county_fips_all: '29119|29145',
    county: 'McDonald',
    county_names_all: 'McDonald|Newton',
    county_weights: '{"29119": 96.07, "29145": 3.93}',
    density: 8.8,
    imprecise: false,
    latitude: 36.6953,
    longitude: -94.14864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64861',
  },
  {
    city: 'Sarcoxie',
    county_fips: 29097,
    county_fips_all: '29097|29145|29109',
    county: 'Jasper',
    county_names_all: 'Jasper|Newton|Lawrence',
    county_weights: '{"29097": 60.84, "29145": 25.02, "29109": 14.14}',
    density: 13.5,
    imprecise: false,
    latitude: 37.10128,
    longitude: -94.11469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64862',
  },
  {
    city: 'South West City',
    county_fips: 29119,
    county_fips_all: '29119',
    county: 'McDonald',
    county_names_all: 'McDonald',
    county_weights: '{"29119": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 36.55511,
    longitude: -94.58444,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64863',
  },
  {
    city: 'Seneca',
    county_fips: 29145,
    county_fips_all: '29145|29119',
    county: 'Newton',
    county_names_all: 'Newton|McDonald',
    county_weights: '{"29145": 84.32, "29119": 15.68}',
    density: 29.3,
    imprecise: false,
    latitude: 36.84253,
    longitude: -94.57797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64865',
  },
  {
    city: 'Stark City',
    county_fips: 29145,
    county_fips_all: '29145',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"29145": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 36.8677,
    longitude: -94.14317,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64866',
  },
  {
    city: 'Stella',
    county_fips: 29119,
    county_fips_all: '29119|29145',
    county: 'McDonald',
    county_names_all: 'McDonald|Newton',
    county_weights: '{"29119": 62.79, "29145": 37.21}',
    density: 7.2,
    imprecise: false,
    latitude: 36.73023,
    longitude: -94.23316,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64867',
  },
  {
    city: 'Tiff City',
    county_fips: 29119,
    county_fips_all: '29119',
    county: 'McDonald',
    county_names_all: 'McDonald',
    county_weights: '{"29119": 100}',
    density: 34.6,
    imprecise: false,
    latitude: 36.68742,
    longitude: -94.61285,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64868',
  },
  {
    city: 'Webb City',
    county_fips: 29097,
    county_fips_all: '29097',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"29097": 100}',
    density: 185.7,
    imprecise: false,
    latitude: 37.18474,
    longitude: -94.48136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64870',
  },
  {
    city: 'Wentworth',
    county_fips: 29109,
    county_fips_all: '29109|29145',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Newton',
    county_weights: '{"29109": 53.54, "29145": 46.46}',
    density: 12.1,
    imprecise: false,
    latitude: 37.01565,
    longitude: -94.05358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64873',
  },
  {
    city: 'Wheaton',
    county_fips: 29009,
    county_fips_all: '29009',
    county: 'Barry',
    county_names_all: 'Barry',
    county_weights: '{"29009": 100}',
    density: 107.7,
    imprecise: false,
    latitude: 36.75617,
    longitude: -94.05444,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64874',
  },
  {
    city: 'Argyle',
    county_fips: 29125,
    county_fips_all: '29125|29151',
    county: 'Maries',
    county_names_all: 'Maries|Osage',
    county_weights: '{"29125": 73.22, "29151": 26.78}',
    density: 2.8,
    imprecise: false,
    latitude: 38.27141,
    longitude: -92.00077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65001',
  },
  {
    city: 'Ashland',
    county_fips: 29019,
    county_fips_all: '29019',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"29019": 100}',
    density: 45.8,
    imprecise: false,
    latitude: 38.78757,
    longitude: -92.24301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65010',
  },
  {
    city: 'Barnett',
    county_fips: 29141,
    county_fips_all: '29141|29135',
    county: 'Morgan',
    county_names_all: 'Morgan|Moniteau',
    county_weights: '{"29141": 87.28, "29135": 12.72}',
    density: 11.1,
    imprecise: false,
    latitude: 38.39493,
    longitude: -92.70815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65011',
  },
  {
    city: 'Belle',
    county_fips: 29125,
    county_fips_all: '29125|29151',
    county: 'Maries',
    county_names_all: 'Maries|Osage',
    county_weights: '{"29125": 61.28, "29151": 38.72}',
    density: 9.3,
    imprecise: false,
    latitude: 38.26868,
    longitude: -91.75493,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65013',
  },
  {
    city: 'Bland',
    county_fips: 29073,
    county_fips_all: '29073|29151|29125',
    county: 'Gasconade',
    county_names_all: 'Gasconade|Osage|Maries',
    county_weights: '{"29073": 69.32, "29151": 27.4, "29125": 3.28}',
    density: 6.1,
    imprecise: false,
    latitude: 38.32184,
    longitude: -91.6247,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65014',
  },
  {
    city: 'Bonnots Mill',
    county_fips: 29151,
    county_fips_all: '29151',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"29151": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 38.56167,
    longitude: -91.91896,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65016',
  },
  {
    city: 'Brumley',
    county_fips: 29131,
    county_fips_all: '29131|29029',
    county: 'Miller',
    county_names_all: 'Miller|Camden',
    county_weights: '{"29131": 98.59, "29029": 1.41}',
    density: 7.4,
    imprecise: false,
    latitude: 38.09185,
    longitude: -92.49548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65017',
  },
  {
    city: 'California',
    county_fips: 29135,
    county_fips_all: '29135|29053',
    county: 'Moniteau',
    county_names_all: 'Moniteau|Cooper',
    county_weights: '{"29135": 92.81, "29053": 7.19}',
    density: 19.1,
    imprecise: false,
    latitude: 38.62038,
    longitude: -92.56314,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65018',
  },
  {
    city: 'Camdenton',
    county_fips: 29029,
    county_fips_all: '29029|29105',
    county: 'Camden',
    county_names_all: 'Camden|Laclede',
    county_weights: '{"29029": 99.51, "29105": 0.49}',
    density: 46,
    imprecise: false,
    latitude: 38.00517,
    longitude: -92.78193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65020',
  },
  {
    city: 'Centertown',
    county_fips: 29051,
    county_fips_all: '29051|29135',
    county: 'Cole',
    county_names_all: 'Cole|Moniteau',
    county_weights: '{"29051": 75.6, "29135": 24.4}',
    density: 11,
    imprecise: false,
    latitude: 38.65274,
    longitude: -92.39915,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65023',
  },
  {
    city: 'Chamois',
    county_fips: 29151,
    county_fips_all: '29151',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"29151": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 38.62444,
    longitude: -91.75712,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65024',
  },
  {
    city: 'Clarksburg',
    county_fips: 29135,
    county_fips_all: '29135|29053',
    county: 'Moniteau',
    county_names_all: 'Moniteau|Cooper',
    county_weights: '{"29135": 60.88, "29053": 39.12}',
    density: 5.7,
    imprecise: false,
    latitude: 38.66618,
    longitude: -92.68119,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65025',
  },
  {
    city: 'Eldon',
    county_fips: 29131,
    county_fips_all: '29131|29141',
    county: 'Miller',
    county_names_all: 'Miller|Morgan',
    county_weights: '{"29131": 97.84, "29141": 2.16}',
    density: 31.3,
    imprecise: false,
    latitude: 38.32105,
    longitude: -92.57099,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65026',
  },
  {
    city: 'Eugene',
    county_fips: 29131,
    county_fips_all: '29131|29051',
    county: 'Miller',
    county_names_all: 'Miller|Cole',
    county_weights: '{"29131": 68.48, "29051": 31.52}',
    density: 9.9,
    imprecise: false,
    latitude: 38.34024,
    longitude: -92.37942,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65032',
  },
  {
    city: 'Fortuna',
    county_fips: 29141,
    county_fips_all: '29141|29135',
    county: 'Morgan',
    county_names_all: 'Morgan|Moniteau',
    county_weights: '{"29141": 75.03, "29135": 24.97}',
    density: 6.6,
    imprecise: false,
    latitude: 38.55637,
    longitude: -92.82183,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65034',
  },
  {
    city: 'Freeburg',
    county_fips: 29151,
    county_fips_all: '29151',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"29151": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 38.36338,
    longitude: -91.93585,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65035',
  },
  {
    city: 'Gravois Mills',
    county_fips: 29141,
    county_fips_all: '29141|29029',
    county: 'Morgan',
    county_names_all: 'Morgan|Camden',
    county_weights: '{"29141": 85.53, "29029": 14.47}',
    density: 25.6,
    imprecise: false,
    latitude: 38.23845,
    longitude: -92.85749,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65037',
  },
  {
    city: 'Hartsburg',
    county_fips: 29019,
    county_fips_all: '29019|29027',
    county: 'Boone',
    county_names_all: 'Boone|Callaway',
    county_weights: '{"29019": 92.2, "29027": 7.8}',
    density: 20.1,
    imprecise: false,
    latitude: 38.71388,
    longitude: -92.2984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65039',
  },
  {
    city: 'Henley',
    county_fips: 29051,
    county_fips_all: '29051|29131',
    county: 'Cole',
    county_names_all: 'Cole|Miller',
    county_weights: '{"29051": 83.53, "29131": 16.47}',
    density: 13.9,
    imprecise: false,
    latitude: 38.36367,
    longitude: -92.31252,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65040',
  },
  {
    city: 'Hermann',
    county_fips: 29073,
    county_fips_all: '29073|29139|29219',
    county: 'Gasconade',
    county_names_all: 'Gasconade|Montgomery|Warren',
    county_weights: '{"29073": 70.79, "29139": 17.64, "29219": 11.57}',
    density: 9.1,
    imprecise: false,
    latitude: 38.64088,
    longitude: -91.47712,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65041',
  },
  {
    city: 'Holts Summit',
    county_fips: 29027,
    county_fips_all: '29027',
    county: 'Callaway',
    county_names_all: 'Callaway',
    county_weights: '{"29027": 100}',
    density: 67.2,
    imprecise: false,
    latitude: 38.62563,
    longitude: -92.10774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65043',
  },
  {
    city: 'Jamestown',
    county_fips: 29135,
    county_fips_all: '29135',
    county: 'Moniteau',
    county_names_all: 'Moniteau',
    county_weights: '{"29135": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 38.77658,
    longitude: -92.47889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65046',
  },
  {
    city: 'Kaiser',
    county_fips: 29131,
    county_fips_all: '29131|29029',
    county: 'Miller',
    county_names_all: 'Miller|Camden',
    county_weights: '{"29131": 76.44, "29029": 23.56}',
    density: 18.2,
    imprecise: false,
    latitude: 38.15483,
    longitude: -92.57774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65047',
  },
  {
    city: 'Koeltztown',
    county_fips: 29151,
    county_fips_all: '29151',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"29151": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 38.35745,
    longitude: -92.0365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65048',
  },
  {
    city: 'Lake Ozark',
    county_fips: 29029,
    county_fips_all: '29029|29131',
    county: 'Camden',
    county_names_all: 'Camden|Miller',
    county_weights: '{"29029": 58.06, "29131": 41.94}',
    density: 148.4,
    imprecise: false,
    latitude: 38.20127,
    longitude: -92.67067,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65049',
  },
  {
    city: 'Latham',
    county_fips: 29135,
    county_fips_all: '29135',
    county: 'Moniteau',
    county_names_all: 'Moniteau',
    county_weights: '{"29135": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 38.5305,
    longitude: -92.68867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65050',
  },
  {
    city: 'Linn',
    county_fips: 29151,
    county_fips_all: '29151|29073',
    county: 'Osage',
    county_names_all: 'Osage|Gasconade',
    county_weights: '{"29151": 99.43, "29073": 0.57}',
    density: 13.7,
    imprecise: false,
    latitude: 38.46519,
    longitude: -91.79758,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65051',
  },
  {
    city: 'Linn Creek',
    county_fips: 29029,
    county_fips_all: '29029',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"29029": 100}',
    density: 30.9,
    imprecise: false,
    latitude: 38.05068,
    longitude: -92.65568,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65052',
  },
  {
    city: 'Lohman',
    county_fips: 29051,
    county_fips_all: '29051',
    county: 'Cole',
    county_names_all: 'Cole',
    county_weights: '{"29051": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 38.54132,
    longitude: -92.36966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65053',
  },
  {
    city: 'Loose Creek',
    county_fips: 29151,
    county_fips_all: '29151',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"29151": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 38.49103,
    longitude: -91.95003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65054',
  },
  {
    city: 'Meta',
    county_fips: 29125,
    county_fips_all: '29125|29151|29131|29051',
    county: 'Maries',
    county_names_all: 'Maries|Osage|Miller|Cole',
    county_weights:
      '{"29125": 68.93, "29151": 18.89, "29131": 11.69, "29051": 0.49}',
    density: 5,
    imprecise: false,
    latitude: 38.25777,
    longitude: -92.12946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65058',
  },
  {
    city: 'Mokane',
    county_fips: 29027,
    county_fips_all: '29027',
    county: 'Callaway',
    county_names_all: 'Callaway',
    county_weights: '{"29027": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 38.70365,
    longitude: -91.88447,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65059',
  },
  {
    city: 'Morrison',
    county_fips: 29073,
    county_fips_all: '29073|29151',
    county: 'Gasconade',
    county_names_all: 'Gasconade|Osage',
    county_weights: '{"29073": 53.64, "29151": 46.36}',
    density: 5,
    imprecise: false,
    latitude: 38.59773,
    longitude: -91.638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65061',
  },
  {
    city: 'Mount Sterling',
    county_fips: 29151,
    county_fips_all: '29151|29073',
    county: 'Osage',
    county_names_all: 'Osage|Gasconade',
    county_weights: '{"29151": 65.38, "29073": 34.62}',
    density: 1.9,
    imprecise: false,
    latitude: 38.49486,
    longitude: -91.65059,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65062',
  },
  {
    city: 'New Bloomfield',
    county_fips: 29027,
    county_fips_all: '29027',
    county: 'Callaway',
    county_names_all: 'Callaway',
    county_weights: '{"29027": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 38.72635,
    longitude: -92.08743,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65063',
  },
  {
    city: 'Olean',
    county_fips: 29131,
    county_fips_all: '29131|29135',
    county: 'Miller',
    county_names_all: 'Miller|Moniteau',
    county_weights: '{"29131": 98.94, "29135": 1.06}',
    density: 16.5,
    imprecise: false,
    latitude: 38.40634,
    longitude: -92.47664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65064',
  },
  {
    city: 'Osage Beach',
    county_fips: 29029,
    county_fips_all: '29029|29131',
    county: 'Camden',
    county_names_all: 'Camden|Miller',
    county_weights: '{"29029": 90.79, "29131": 9.21}',
    density: 168.2,
    imprecise: false,
    latitude: 38.13462,
    longitude: -92.66593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65065',
  },
  {
    city: 'Owensville',
    county_fips: 29073,
    county_fips_all: '29073|29055',
    county: 'Gasconade',
    county_names_all: 'Gasconade|Crawford',
    county_weights: '{"29073": 90.08, "29055": 9.92}',
    density: 13.6,
    imprecise: false,
    latitude: 38.3454,
    longitude: -91.48898,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65066',
  },
  {
    city: 'Portland',
    county_fips: 29027,
    county_fips_all: '29027',
    county: 'Callaway',
    county_names_all: 'Callaway',
    county_weights: '{"29027": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 38.75365,
    longitude: -91.72369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65067',
  },
  {
    city: 'Prairie Home',
    county_fips: 29053,
    county_fips_all: '29053|29135',
    county: 'Cooper',
    county_names_all: 'Cooper|Moniteau',
    county_weights: '{"29053": 95.07, "29135": 4.93}',
    density: 7,
    imprecise: false,
    latitude: 38.82757,
    longitude: -92.59909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65068',
  },
  {
    city: 'Rhineland',
    county_fips: 29139,
    county_fips_all: '29139|29027',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Callaway',
    county_weights: '{"29139": 84.0, "29027": 16.0}',
    density: 2.8,
    imprecise: false,
    latitude: 38.75573,
    longitude: -91.5966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65069',
  },
  {
    city: 'Rocky Mount',
    county_fips: 29141,
    county_fips_all: '29141|29131',
    county: 'Morgan',
    county_names_all: 'Morgan|Miller',
    county_weights: '{"29141": 90.16, "29131": 9.84}',
    density: 39.1,
    imprecise: false,
    latitude: 38.26635,
    longitude: -92.72178,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65072',
  },
  {
    city: 'Russellville',
    county_fips: 29135,
    county_fips_all: '29135|29051|29131',
    county: 'Moniteau',
    county_names_all: 'Moniteau|Cole|Miller',
    county_weights: '{"29135": 49.45, "29051": 48.56, "29131": 1.99}',
    density: 12,
    imprecise: false,
    latitude: 38.47967,
    longitude: -92.47306,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65074',
  },
  {
    city: 'Saint Elizabeth',
    county_fips: 29131,
    county_fips_all: '29131',
    county: 'Miller',
    county_names_all: 'Miller',
    county_weights: '{"29131": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 38.24849,
    longitude: -92.26388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65075',
  },
  {
    city: 'Saint Thomas',
    county_fips: 29051,
    county_fips_all: '29051|29151',
    county: 'Cole',
    county_names_all: 'Cole|Osage',
    county_weights: '{"29051": 67.86, "29151": 32.14}',
    density: 7.8,
    imprecise: false,
    latitude: 38.37064,
    longitude: -92.20376,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65076',
  },
  {
    city: 'Steedman',
    county_fips: 29027,
    county_fips_all: '29027',
    county: 'Callaway',
    county_names_all: 'Callaway',
    county_weights: '{"29027": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 38.7691,
    longitude: -91.80305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65077',
  },
  {
    city: 'Stover',
    county_fips: 29141,
    county_fips_all: '29141|29015',
    county: 'Morgan',
    county_names_all: 'Morgan|Benton',
    county_weights: '{"29141": 93.7, "29015": 6.3}',
    density: 8.9,
    imprecise: false,
    latitude: 38.38473,
    longitude: -93.01085,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65078',
  },
  {
    city: 'Sunrise Beach',
    county_fips: 29029,
    county_fips_all: '29029|29141',
    county: 'Camden',
    county_names_all: 'Camden|Morgan',
    county_weights: '{"29029": 97.14, "29141": 2.86}',
    density: 53.2,
    imprecise: false,
    latitude: 38.15283,
    longitude: -92.75225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65079',
  },
  {
    city: 'Tebbetts',
    county_fips: 29027,
    county_fips_all: '29027',
    county: 'Callaway',
    county_names_all: 'Callaway',
    county_weights: '{"29027": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 38.63231,
    longitude: -91.97713,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65080',
  },
  {
    city: 'Tipton',
    county_fips: 29135,
    county_fips_all: '29135|29053|29141',
    county: 'Moniteau',
    county_names_all: 'Moniteau|Cooper|Morgan',
    county_weights: '{"29135": 70.27, "29053": 21.41, "29141": 8.32}',
    density: 23.1,
    imprecise: false,
    latitude: 38.64086,
    longitude: -92.78424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65081',
  },
  {
    city: 'Tuscumbia',
    county_fips: 29131,
    county_fips_all: '29131',
    county: 'Miller',
    county_names_all: 'Miller',
    county_weights: '{"29131": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 38.22243,
    longitude: -92.42632,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65082',
  },
  {
    city: 'Ulman',
    county_fips: 29131,
    county_fips_all: '29131',
    county: 'Miller',
    county_names_all: 'Miller',
    county_weights: '{"29131": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 38.14318,
    longitude: -92.44089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65083',
  },
  {
    city: 'Versailles',
    county_fips: 29141,
    county_fips_all: '29141|29135',
    county: 'Morgan',
    county_names_all: 'Morgan|Moniteau',
    county_weights: '{"29141": 98.75, "29135": 1.25}',
    density: 17.2,
    imprecise: false,
    latitude: 38.43574,
    longitude: -92.85119,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65084',
  },
  {
    city: 'Westphalia',
    county_fips: 29151,
    county_fips_all: '29151',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"29151": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 38.40304,
    longitude: -92.07272,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65085',
  },
  {
    city: 'Jefferson City',
    county_fips: 29051,
    county_fips_all: '29051|29151|29027',
    county: 'Cole',
    county_names_all: 'Cole|Osage|Callaway',
    county_weights: '{"29051": 89.25, "29151": 5.88, "29027": 4.87}',
    density: 84.9,
    imprecise: false,
    latitude: 38.49143,
    longitude: -92.15009,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65101',
  },
  {
    city: 'Jefferson City',
    county_fips: 29051,
    county_fips_all: '29051',
    county: 'Cole',
    county_names_all: 'Cole',
    county_weights: '{"29051": 100}',
    density: 196.8,
    imprecise: false,
    latitude: 38.57365,
    longitude: -92.27791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65109',
  },
  {
    city: 'Columbia',
    county_fips: 29019,
    county_fips_all: '29019|29027',
    county: 'Boone',
    county_names_all: 'Boone|Callaway',
    county_weights: '{"29019": 98.09, "29027": 1.91}',
    density: 221.1,
    imprecise: false,
    latitude: 38.89595,
    longitude: -92.24365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65201',
  },
  {
    city: 'Columbia',
    county_fips: 29019,
    county_fips_all: '29019|29027',
    county: 'Boone',
    county_names_all: 'Boone|Callaway',
    county_weights: '{"29019": 90.67, "29027": 9.33}',
    density: 129.3,
    imprecise: false,
    latitude: 39.01721,
    longitude: -92.29822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65202',
  },
  {
    city: 'Columbia',
    county_fips: 29019,
    county_fips_all: '29019',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"29019": 100}',
    density: 318.2,
    imprecise: false,
    latitude: 38.89497,
    longitude: -92.39928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 61539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65203',
  },
  {
    city: 'Armstrong',
    county_fips: 29089,
    county_fips_all: '29089|29175',
    county: 'Howard',
    county_names_all: 'Howard|Randolph',
    county_weights: '{"29089": 78.67, "29175": 21.33}',
    density: 3.5,
    imprecise: false,
    latitude: 39.28715,
    longitude: -92.69218,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65230',
  },
  {
    city: 'Auxvasse',
    county_fips: 29027,
    county_fips_all: '29027|29007',
    county: 'Callaway',
    county_names_all: 'Callaway|Audrain',
    county_weights: '{"29027": 97.51, "29007": 2.49}',
    density: 9.7,
    imprecise: false,
    latitude: 39.01773,
    longitude: -91.90803,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65231',
  },
  {
    city: 'Benton City',
    county_fips: 29007,
    county_fips_all: '29007',
    county: 'Audrain',
    county_names_all: 'Audrain',
    county_weights: '{"29007": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 39.15901,
    longitude: -91.75516,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65232',
  },
  {
    city: 'Boonville',
    county_fips: 29053,
    county_fips_all: '29053',
    county: 'Cooper',
    county_names_all: 'Cooper',
    county_weights: '{"29053": 100}',
    density: 28.9,
    imprecise: false,
    latitude: 38.91528,
    longitude: -92.72035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65233',
  },
  {
    city: 'Brunswick',
    county_fips: 29041,
    county_fips_all: '29041',
    county: 'Chariton',
    county_names_all: 'Chariton',
    county_weights: '{"29041": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 39.44596,
    longitude: -93.08305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65236',
  },
  {
    city: 'Bunceton',
    county_fips: 29053,
    county_fips_all: '29053',
    county: 'Cooper',
    county_names_all: 'Cooper',
    county_weights: '{"29053": 100}',
    density: 3,
    imprecise: false,
    latitude: 38.78078,
    longitude: -92.78438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65237',
  },
  {
    city: 'Cairo',
    county_fips: 29175,
    county_fips_all: '29175',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"29175": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 39.53312,
    longitude: -92.42334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65239',
  },
  {
    city: 'Centralia',
    county_fips: 29007,
    county_fips_all: '29007|29019|29137|29027',
    county: 'Audrain',
    county_names_all: 'Audrain|Boone|Monroe|Callaway',
    county_weights:
      '{"29007": 58.47, "29019": 36.68, "29137": 3.41, "29027": 1.44}',
    density: 18.9,
    imprecise: false,
    latitude: 39.22085,
    longitude: -92.13026,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65240',
  },
  {
    city: 'Clark',
    county_fips: 29175,
    county_fips_all: '29175|29019|29007|29089|29137',
    county: 'Randolph',
    county_names_all: 'Randolph|Boone|Audrain|Howard|Monroe',
    county_weights:
      '{"29175": 41.58, "29019": 25.9, "29007": 24.26, "29089": 5.43, "29137": 2.83}',
    density: 11.7,
    imprecise: false,
    latitude: 39.27654,
    longitude: -92.35207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65243',
  },
  {
    city: 'Clifton Hill',
    county_fips: 29175,
    county_fips_all: '29175',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"29175": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 39.4807,
    longitude: -92.65982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65244',
  },
  {
    city: 'Dalton',
    county_fips: 29041,
    county_fips_all: '29041',
    county: 'Chariton',
    county_names_all: 'Chariton',
    county_weights: '{"29041": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 39.37725,
    longitude: -93.00059,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65246',
  },
  {
    city: 'Excello',
    county_fips: 29121,
    county_fips_all: '29121',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"29121": 100}',
    density: 7,
    imprecise: false,
    latitude: 39.63502,
    longitude: -92.47296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65247',
  },
  {
    city: 'Fayette',
    county_fips: 29089,
    county_fips_all: '29089',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"29089": 100}',
    density: 10,
    imprecise: false,
    latitude: 39.13952,
    longitude: -92.65894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65248',
  },
  {
    city: 'Franklin',
    county_fips: 29089,
    county_fips_all: '29089',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"29089": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 39.03524,
    longitude: -92.83991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65250',
  },
  {
    city: 'Fulton',
    county_fips: 29027,
    county_fips_all: '29027',
    county: 'Callaway',
    county_names_all: 'Callaway',
    county_weights: '{"29027": 100}',
    density: 40.9,
    imprecise: false,
    latitude: 38.84902,
    longitude: -91.97911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65251',
  },
  {
    city: 'Glasgow',
    county_fips: 29089,
    county_fips_all: '29089|29041',
    county: 'Howard',
    county_names_all: 'Howard|Chariton',
    county_weights: '{"29089": 67.26, "29041": 32.74}',
    density: 6.9,
    imprecise: false,
    latitude: 39.21228,
    longitude: -92.85351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65254',
  },
  {
    city: 'Hallsville',
    county_fips: 29019,
    county_fips_all: '29019',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"29019": 100}',
    density: 35.7,
    imprecise: false,
    latitude: 39.09632,
    longitude: -92.23463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65255',
  },
  {
    city: 'Harrisburg',
    county_fips: 29019,
    county_fips_all: '29019|29089',
    county: 'Boone',
    county_names_all: 'Boone|Howard',
    county_weights: '{"29019": 76.87, "29089": 23.13}',
    density: 14,
    imprecise: false,
    latitude: 39.12713,
    longitude: -92.45568,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65256',
  },
  {
    city: 'Higbee',
    county_fips: 29175,
    county_fips_all: '29175|29089',
    county: 'Randolph',
    county_names_all: 'Randolph|Howard',
    county_weights: '{"29175": 60.47, "29089": 39.53}',
    density: 6.6,
    imprecise: false,
    latitude: 39.28404,
    longitude: -92.53112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65257',
  },
  {
    city: 'Holliday',
    county_fips: 29137,
    county_fips_all: '29137',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"29137": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 39.52339,
    longitude: -92.13706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65258',
  },
  {
    city: 'Huntsville',
    county_fips: 29175,
    county_fips_all: '29175',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"29175": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 39.47122,
    longitude: -92.56536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65259',
  },
  {
    city: 'Jacksonville',
    county_fips: 29175,
    county_fips_all: '29175|29121|29137',
    county: 'Randolph',
    county_names_all: 'Randolph|Macon|Monroe',
    county_weights: '{"29175": 69.04, "29121": 19.07, "29137": 11.89}',
    density: 3,
    imprecise: false,
    latitude: 39.58806,
    longitude: -92.40227,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65260',
  },
  {
    city: 'Keytesville',
    county_fips: 29041,
    county_fips_all: '29041',
    county: 'Chariton',
    county_names_all: 'Chariton',
    county_weights: '{"29041": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 39.47542,
    longitude: -92.92388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65261',
  },
  {
    city: 'Kingdom City',
    county_fips: 29027,
    county_fips_all: '29027',
    county: 'Callaway',
    county_names_all: 'Callaway',
    county_weights: '{"29027": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 38.9548,
    longitude: -91.95285,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65262',
  },
  {
    city: 'Madison',
    county_fips: 29137,
    county_fips_all: '29137|29175',
    county: 'Monroe',
    county_names_all: 'Monroe|Randolph',
    county_weights: '{"29137": 97.09, "29175": 2.91}',
    density: 5.2,
    imprecise: false,
    latitude: 39.45244,
    longitude: -92.22062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65263',
  },
  {
    city: 'Martinsburg',
    county_fips: 29007,
    county_fips_all: '29007|29027|29139',
    county: 'Audrain',
    county_names_all: 'Audrain|Callaway|Montgomery',
    county_weights: '{"29007": 71.2, "29027": 24.34, "29139": 4.46}',
    density: 5.7,
    imprecise: false,
    latitude: 39.08852,
    longitude: -91.69544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65264',
  },
  {
    city: 'Mexico',
    county_fips: 29007,
    county_fips_all: '29007|29137',
    county: 'Audrain',
    county_names_all: 'Audrain|Monroe',
    county_weights: '{"29007": 94.34, "29137": 5.66}',
    density: 26.2,
    imprecise: false,
    latitude: 39.20531,
    longitude: -91.88728,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65265',
  },
  {
    city: 'Moberly',
    county_fips: 29175,
    county_fips_all: '29175|29137',
    county: 'Randolph',
    county_names_all: 'Randolph|Monroe',
    county_weights: '{"29175": 94.07, "29137": 5.93}',
    density: 56.6,
    imprecise: false,
    latitude: 39.41552,
    longitude: -92.39917,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65270',
  },
  {
    city: 'New Franklin',
    county_fips: 29089,
    county_fips_all: '29089',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"29089": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 39.01342,
    longitude: -92.68321,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65274',
  },
  {
    city: 'Paris',
    county_fips: 29137,
    county_fips_all: '29137',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"29137": 100}',
    density: 6,
    imprecise: false,
    latitude: 39.45935,
    longitude: -91.99414,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65275',
  },
  {
    city: 'Pilot Grove',
    county_fips: 29053,
    county_fips_all: '29053',
    county: 'Cooper',
    county_names_all: 'Cooper',
    county_weights: '{"29053": 100}',
    density: 7,
    imprecise: false,
    latitude: 38.84581,
    longitude: -92.95498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65276',
  },
  {
    city: 'Renick',
    county_fips: 29175,
    county_fips_all: '29175',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"29175": 100}',
    density: 117.1,
    imprecise: false,
    latitude: 39.34217,
    longitude: -92.41251,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65278',
  },
  {
    city: 'Rocheport',
    county_fips: 29019,
    county_fips_all: '29019|29089',
    county: 'Boone',
    county_names_all: 'Boone|Howard',
    county_weights: '{"29019": 75.09, "29089": 24.91}',
    density: 14.4,
    imprecise: false,
    latitude: 39.01284,
    longitude: -92.52062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65279',
  },
  {
    city: 'Rush Hill',
    county_fips: 29007,
    county_fips_all: '29007',
    county: 'Audrain',
    county_names_all: 'Audrain',
    county_weights: '{"29007": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 39.23487,
    longitude: -91.75048,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65280',
  },
  {
    city: 'Salisbury',
    county_fips: 29041,
    county_fips_all: '29041|29089|29175',
    county: 'Chariton',
    county_names_all: 'Chariton|Howard|Randolph',
    county_weights: '{"29041": 98.4, "29089": 1.3, "29175": 0.3}',
    density: 6,
    imprecise: false,
    latitude: 39.46431,
    longitude: -92.79099,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65281',
  },
  {
    city: 'Santa Fe',
    county_fips: 29137,
    county_fips_all: '29137',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"29137": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 39.38975,
    longitude: -91.83302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65282',
  },
  {
    city: 'Stoutsville',
    county_fips: 29137,
    county_fips_all: '29137',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"29137": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 39.50811,
    longitude: -91.83449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65283',
  },
  {
    city: 'Sturgeon',
    county_fips: 29019,
    county_fips_all: '29019|29007',
    county: 'Boone',
    county_names_all: 'Boone|Audrain',
    county_weights: '{"29019": 85.67, "29007": 14.33}',
    density: 14.8,
    imprecise: false,
    latitude: 39.19658,
    longitude: -92.30361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65284',
  },
  {
    city: 'Thompson',
    county_fips: 29007,
    county_fips_all: '29007',
    county: 'Audrain',
    county_names_all: 'Audrain',
    county_weights: '{"29007": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 39.2067,
    longitude: -92.02056,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65285',
  },
  {
    city: 'Triplett',
    county_fips: 29041,
    county_fips_all: '29041',
    county: 'Chariton',
    county_names_all: 'Chariton',
    county_weights: '{"29041": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 39.50616,
    longitude: -93.22059,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65286',
  },
  {
    city: 'Wooldridge',
    county_fips: 29135,
    county_fips_all: '29135|29053',
    county: 'Moniteau',
    county_names_all: 'Moniteau|Cooper',
    county_weights: '{"29135": 54.88, "29053": 45.12}',
    density: 5.2,
    imprecise: false,
    latitude: 38.88443,
    longitude: -92.51953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65287',
  },
  {
    city: 'Sedalia',
    county_fips: 29159,
    county_fips_all: '29159|29053',
    county: 'Pettis',
    county_names_all: 'Pettis|Cooper',
    county_weights: '{"29159": 99.34, "29053": 0.66}',
    density: 60.6,
    imprecise: false,
    latitude: 38.69922,
    longitude: -93.22104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65301',
  },
  {
    city: 'Whiteman Air Force Base',
    county_fips: 29101,
    county_fips_all: '29101',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"29101": 100}',
    density: 232.2,
    imprecise: false,
    latitude: 38.72944,
    longitude: -93.55446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65305',
  },
  {
    city: 'Arrow Rock',
    county_fips: 29195,
    county_fips_all: '29195',
    county: 'Saline',
    county_names_all: 'Saline',
    county_weights: '{"29195": 100}',
    density: 47,
    imprecise: false,
    latitude: 39.06606,
    longitude: -92.94415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65320',
  },
  {
    city: 'Blackburn',
    county_fips: 29195,
    county_fips_all: '29195|29107',
    county: 'Saline',
    county_names_all: 'Saline|Lafayette',
    county_weights: '{"29195": 86.26, "29107": 13.74}',
    density: 4,
    imprecise: false,
    latitude: 39.08604,
    longitude: -93.4526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65321',
  },
  {
    city: 'Blackwater',
    county_fips: 29053,
    county_fips_all: '29053',
    county: 'Cooper',
    county_names_all: 'Cooper',
    county_weights: '{"29053": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 38.9729,
    longitude: -92.95535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65322',
  },
  {
    city: 'Calhoun',
    county_fips: 29083,
    county_fips_all: '29083',
    county: 'Henry',
    county_names_all: 'Henry',
    county_weights: '{"29083": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 38.45289,
    longitude: -93.6212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65323',
  },
  {
    city: 'Climax Springs',
    county_fips: 29029,
    county_fips_all: '29029',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"29029": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 38.11104,
    longitude: -92.99997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65324',
  },
  {
    city: 'Cole Camp',
    county_fips: 29015,
    county_fips_all: '29015|29159|29141',
    county: 'Benton',
    county_names_all: 'Benton|Pettis|Morgan',
    county_weights: '{"29015": 98.63, "29159": 1.02, "29141": 0.35}',
    density: 8.2,
    imprecise: false,
    latitude: 38.43239,
    longitude: -93.18535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65325',
  },
  {
    city: 'Edwards',
    county_fips: 29015,
    county_fips_all: '29015|29029|29085',
    county: 'Benton',
    county_names_all: 'Benton|Camden|Hickory',
    county_weights: '{"29015": 81.19, "29029": 16.83, "29085": 1.98}',
    density: 4.9,
    imprecise: false,
    latitude: 38.16271,
    longitude: -93.1458,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65326',
  },
  {
    city: 'Emma',
    county_fips: 29195,
    county_fips_all: '29195|29107',
    county: 'Saline',
    county_names_all: 'Saline|Lafayette',
    county_weights: '{"29195": 74.45, "29107": 25.55}',
    density: 97.6,
    imprecise: false,
    latitude: 38.97525,
    longitude: -93.48909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65327',
  },
  {
    city: 'Florence',
    county_fips: 29141,
    county_fips_all: '29141',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"29141": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 38.60937,
    longitude: -92.96132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65329',
  },
  {
    city: 'Gilliam',
    county_fips: 29195,
    county_fips_all: '29195',
    county: 'Saline',
    county_names_all: 'Saline',
    county_weights: '{"29195": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 39.22096,
    longitude: -92.94945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65330',
  },
  {
    city: 'Green Ridge',
    county_fips: 29159,
    county_fips_all: '29159|29101',
    county: 'Pettis',
    county_names_all: 'Pettis|Johnson',
    county_weights: '{"29159": 97.07, "29101": 2.93}',
    density: 9,
    imprecise: false,
    latitude: 38.61973,
    longitude: -93.41324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65332',
  },
  {
    city: 'Houstonia',
    county_fips: 29159,
    county_fips_all: '29159|29195',
    county: 'Pettis',
    county_names_all: 'Pettis|Saline',
    county_weights: '{"29159": 85.06, "29195": 14.94}',
    density: 3.8,
    imprecise: false,
    latitude: 38.90687,
    longitude: -93.30724,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65333',
  },
  {
    city: 'Hughesville',
    county_fips: 29159,
    county_fips_all: '29159',
    county: 'Pettis',
    county_names_all: 'Pettis',
    county_weights: '{"29159": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 38.8348,
    longitude: -93.24558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65334',
  },
  {
    city: 'Ionia',
    county_fips: 29159,
    county_fips_all: '29159|29015',
    county: 'Pettis',
    county_names_all: 'Pettis|Benton',
    county_weights: '{"29159": 54.74, "29015": 45.26}',
    density: 3.8,
    imprecise: false,
    latitude: 38.51338,
    longitude: -93.32667,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65335',
  },
  {
    city: 'Knob Noster',
    county_fips: 29101,
    county_fips_all: '29101|29159',
    county: 'Johnson',
    county_names_all: 'Johnson|Pettis',
    county_weights: '{"29101": 93.38, "29159": 6.62}',
    density: 21.5,
    imprecise: false,
    latitude: 38.78169,
    longitude: -93.56241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65336',
  },
  {
    city: 'La Monte',
    county_fips: 29159,
    county_fips_all: '29159',
    county: 'Pettis',
    county_names_all: 'Pettis',
    county_weights: '{"29159": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 38.79202,
    longitude: -93.42573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65337',
  },
  {
    city: 'Lincoln',
    county_fips: 29015,
    county_fips_all: '29015',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"29015": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 38.36227,
    longitude: -93.29523,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65338',
  },
  {
    city: 'Malta Bend',
    county_fips: 29195,
    county_fips_all: '29195',
    county: 'Saline',
    county_names_all: 'Saline',
    county_weights: '{"29195": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 39.19407,
    longitude: -93.37671,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65339',
  },
  {
    city: 'Marshall',
    county_fips: 29195,
    county_fips_all: '29195|29159',
    county: 'Saline',
    county_names_all: 'Saline|Pettis',
    county_weights: '{"29195": 96.15, "29159": 3.85}',
    density: 24.4,
    imprecise: false,
    latitude: 39.09149,
    longitude: -93.18041,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65340',
  },
  {
    city: 'Miami',
    county_fips: 29195,
    county_fips_all: '29195',
    county: 'Saline',
    county_names_all: 'Saline',
    county_weights: '{"29195": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 39.31174,
    longitude: -93.1976,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65344',
  },
  {
    city: 'Mora',
    county_fips: 29015,
    county_fips_all: '29015|29159|29141',
    county: 'Benton',
    county_names_all: 'Benton|Pettis|Morgan',
    county_weights: '{"29015": 42.21, "29159": 39.77, "29141": 18.02}',
    density: 3.6,
    imprecise: false,
    latitude: 38.54111,
    longitude: -93.1254,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65345',
  },
  {
    city: 'Nelson',
    county_fips: 29195,
    county_fips_all: '29195|29159|29053',
    county: 'Saline',
    county_names_all: 'Saline|Pettis|Cooper',
    county_weights: '{"29195": 71.53, "29159": 22.97, "29053": 5.5}',
    density: 4.2,
    imprecise: false,
    latitude: 38.98453,
    longitude: -93.0495,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65347',
  },
  {
    city: 'Otterville',
    county_fips: 29053,
    county_fips_all: '29053|29141|29159',
    county: 'Cooper',
    county_names_all: 'Cooper|Morgan|Pettis',
    county_weights: '{"29053": 70.37, "29141": 26.62, "29159": 3.01}',
    density: 7.7,
    imprecise: false,
    latitude: 38.70963,
    longitude: -92.98344,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65348',
  },
  {
    city: 'Slater',
    county_fips: 29195,
    county_fips_all: '29195',
    county: 'Saline',
    county_names_all: 'Saline',
    county_weights: '{"29195": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 39.22863,
    longitude: -93.05581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65349',
  },
  {
    city: 'Smithton',
    county_fips: 29159,
    county_fips_all: '29159|29141|29053',
    county: 'Pettis',
    county_names_all: 'Pettis|Morgan|Cooper',
    county_weights: '{"29159": 86.46, "29141": 13.19, "29053": 0.35}',
    density: 8.8,
    imprecise: false,
    latitude: 38.65557,
    longitude: -93.10038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65350',
  },
  {
    city: 'Sweet Springs',
    county_fips: 29195,
    county_fips_all: '29195|29159|29101',
    county: 'Saline',
    county_names_all: 'Saline|Pettis|Johnson',
    county_weights: '{"29195": 82.51, "29159": 16.0, "29101": 1.49}',
    density: 7.7,
    imprecise: false,
    latitude: 38.98445,
    longitude: -93.38628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65351',
  },
  {
    city: 'Syracuse',
    county_fips: 29141,
    county_fips_all: '29141|29053',
    county: 'Morgan',
    county_names_all: 'Morgan|Cooper',
    county_weights: '{"29141": 85.89, "29053": 14.11}',
    density: 10.9,
    imprecise: false,
    latitude: 38.64841,
    longitude: -92.88786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65354',
  },
  {
    city: 'Warsaw',
    county_fips: 29015,
    county_fips_all: '29015|29185|29085',
    county: 'Benton',
    county_names_all: 'Benton|St. Clair|Hickory',
    county_weights: '{"29015": 98.48, "29185": 0.91, "29085": 0.61}',
    density: 20.4,
    imprecise: false,
    latitude: 38.22137,
    longitude: -93.37144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65355',
  },
  {
    city: 'Windsor',
    county_fips: 29083,
    county_fips_all: '29083|29015|29159|29101',
    county: 'Henry',
    county_names_all: 'Henry|Benton|Pettis|Johnson',
    county_weights:
      '{"29083": 32.44, "29015": 25.41, "29159": 21.28, "29101": 20.86}',
    density: 11.3,
    imprecise: false,
    latitude: 38.51989,
    longitude: -93.51334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65360',
  },
  {
    city: 'Rolla',
    county_fips: 29161,
    county_fips_all: '29161|29065|29125',
    county: 'Phelps',
    county_names_all: 'Phelps|Dent|Maries',
    county_weights: '{"29161": 83.01, "29065": 12.72, "29125": 4.27}',
    density: 48.8,
    imprecise: false,
    latitude: 37.90691,
    longitude: -91.76374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65401',
  },
  {
    city: 'Beulah',
    county_fips: 29161,
    county_fips_all: '29161|29215',
    county: 'Phelps',
    county_names_all: 'Phelps|Texas',
    county_weights: '{"29161": 95.23, "29215": 4.77}',
    density: 0.4,
    imprecise: false,
    latitude: 37.62239,
    longitude: -91.9726,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65436',
  },
  {
    city: 'Birch Tree',
    county_fips: 29203,
    county_fips_all: '29203|29149',
    county: 'Shannon',
    county_names_all: 'Shannon|Oregon',
    county_weights: '{"29203": 67.19, "29149": 32.81}',
    density: 3.1,
    imprecise: false,
    latitude: 36.9375,
    longitude: -91.50739,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65438',
  },
  {
    city: 'Bixby',
    county_fips: 29093,
    county_fips_all: '29093',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"29093": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 37.65718,
    longitude: -91.09535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65439',
  },
  {
    city: 'Boss',
    county_fips: 29065,
    county_fips_all: '29065|29179|29093',
    county: 'Dent',
    county_names_all: 'Dent|Reynolds|Iron',
    county_weights: '{"29065": 54.45, "29179": 40.2, "29093": 5.35}',
    density: 0.7,
    imprecise: false,
    latitude: 37.60388,
    longitude: -91.18539,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65440',
  },
  {
    city: 'Bourbon',
    county_fips: 29055,
    county_fips_all: '29055|29221|29071',
    county: 'Crawford',
    county_names_all: 'Crawford|Washington|Franklin',
    county_weights: '{"29055": 72.63, "29221": 26.01, "29071": 1.36}',
    density: 11.4,
    imprecise: false,
    latitude: 38.09394,
    longitude: -91.15842,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65441',
  },
  {
    city: 'Brinktown',
    county_fips: 29125,
    county_fips_all: '29125',
    county: 'Maries',
    county_names_all: 'Maries',
    county_weights: '{"29125": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 38.13089,
    longitude: -92.0918,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65443',
  },
  {
    city: 'Bucyrus',
    county_fips: 29215,
    county_fips_all: '29215',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"29215": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 37.37772,
    longitude: -92.06308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65444',
  },
  {
    city: 'Cherryville',
    county_fips: 29055,
    county_fips_all: '29055',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"29055": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 37.80902,
    longitude: -91.26999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65446',
  },
  {
    city: 'Cook Sta',
    county_fips: 29055,
    county_fips_all: '29055|29161',
    county: 'Crawford',
    county_names_all: 'Crawford|Phelps',
    county_weights: '{"29055": 91.52, "29161": 8.48}',
    density: 1.4,
    imprecise: false,
    latitude: 37.84745,
    longitude: -91.48722,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65449',
  },
  {
    city: 'Crocker',
    county_fips: 29169,
    county_fips_all: '29169|29131',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Miller',
    county_weights: '{"29169": 93.25, "29131": 6.75}',
    density: 10.6,
    imprecise: false,
    latitude: 37.96271,
    longitude: -92.26702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65452',
  },
  {
    city: 'Cuba',
    county_fips: 29055,
    county_fips_all: '29055|29073',
    county: 'Crawford',
    county_names_all: 'Crawford|Gasconade',
    county_weights: '{"29055": 88.57, "29073": 11.43}',
    density: 22,
    imprecise: false,
    latitude: 38.10706,
    longitude: -91.42509,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65453',
  },
  {
    city: 'Davisville',
    county_fips: 29055,
    county_fips_all: '29055',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"29055": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 37.78048,
    longitude: -91.20267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65456',
  },
  {
    city: 'Devils Elbow',
    county_fips: 29169,
    county_fips_all: '29169',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"29169": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 37.82647,
    longitude: -92.05047,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65457',
  },
  {
    city: 'Dixon',
    county_fips: 29125,
    county_fips_all: '29125|29169|29161|29131',
    county: 'Maries',
    county_names_all: 'Maries|Pulaski|Phelps|Miller',
    county_weights:
      '{"29125": 53.27, "29169": 35.8, "29161": 5.57, "29131": 5.36}',
    density: 14.3,
    imprecise: false,
    latitude: 38.02919,
    longitude: -92.08337,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65459',
  },
  {
    city: 'Duke',
    county_fips: 29169,
    county_fips_all: '29169|29161',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Phelps',
    county_weights: '{"29169": 51.32, "29161": 48.68}',
    density: 1.4,
    imprecise: false,
    latitude: 37.68406,
    longitude: -92.02379,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65461',
  },
  {
    city: 'Edgar Springs',
    county_fips: 29161,
    county_fips_all: '29161|29065',
    county: 'Phelps',
    county_names_all: 'Phelps|Dent',
    county_weights: '{"29161": 84.78, "29065": 15.22}',
    density: 5.1,
    imprecise: false,
    latitude: 37.68654,
    longitude: -91.86417,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65462',
  },
  {
    city: 'Eldridge',
    county_fips: 29105,
    county_fips_all: '29105|29029|29059',
    county: 'Laclede',
    county_names_all: 'Laclede|Camden|Dallas',
    county_weights: '{"29105": 92.77, "29029": 3.84, "29059": 3.39}',
    density: 6.8,
    imprecise: false,
    latitude: 37.84536,
    longitude: -92.7811,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65463',
  },
  {
    city: 'Elk Creek',
    county_fips: 29215,
    county_fips_all: '29215',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"29215": 100}',
    density: 2,
    imprecise: false,
    latitude: 37.18353,
    longitude: -91.89236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65464',
  },
  {
    city: 'Eminence',
    county_fips: 29203,
    county_fips_all: '29203',
    county: 'Shannon',
    county_names_all: 'Shannon',
    county_weights: '{"29203": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 37.2113,
    longitude: -91.38645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65466',
  },
  {
    city: 'Eunice',
    county_fips: 29215,
    county_fips_all: '29215',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"29215": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 37.25434,
    longitude: -91.79824,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 78,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65468',
  },
  {
    city: 'Falcon',
    county_fips: 29105,
    county_fips_all: '29105|29229',
    county: 'Laclede',
    county_names_all: 'Laclede|Wright',
    county_weights: '{"29105": 88.02, "29229": 11.98}',
    density: 3,
    imprecise: false,
    latitude: 37.54872,
    longitude: -92.40287,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65470',
  },
  {
    city: 'Fort Leonard Wood',
    county_fips: 29169,
    county_fips_all: '29169',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"29169": 100}',
    density: 56.5,
    imprecise: false,
    latitude: 37.71215,
    longitude: -92.14811,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65473',
  },
  {
    city: 'Hartshorn',
    county_fips: 29203,
    county_fips_all: '29203|29215',
    county: 'Shannon',
    county_names_all: 'Shannon|Texas',
    county_weights: '{"29203": 60.54, "29215": 39.46}',
    density: 1.3,
    imprecise: false,
    latitude: 37.3368,
    longitude: -91.63382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65479',
  },
  {
    city: 'Houston',
    county_fips: 29215,
    county_fips_all: '29215',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"29215": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 37.30463,
    longitude: -91.94911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65483',
  },
  {
    city: 'Huggins',
    county_fips: 29215,
    county_fips_all: '29215',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"29215": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 37.36348,
    longitude: -92.22052,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65484',
  },
  {
    city: 'Iberia',
    county_fips: 29131,
    county_fips_all: '29131',
    county: 'Miller',
    county_names_all: 'Miller',
    county_weights: '{"29131": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 38.10007,
    longitude: -92.3107,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65486',
  },
  {
    city: 'Jadwin',
    county_fips: 29065,
    county_fips_all: '29065',
    county: 'Dent',
    county_names_all: 'Dent',
    county_weights: '{"29065": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 37.47319,
    longitude: -91.5549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65501',
  },
  {
    city: 'Jerome',
    county_fips: 29161,
    county_fips_all: '29161',
    county: 'Phelps',
    county_names_all: 'Phelps',
    county_weights: '{"29161": 100}',
    density: 52.4,
    imprecise: false,
    latitude: 37.92912,
    longitude: -91.98926,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65529',
  },
  {
    city: 'Laquey',
    county_fips: 29169,
    county_fips_all: '29169|29105',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Laclede',
    county_weights: '{"29169": 78.94, "29105": 21.06}',
    density: 5.1,
    imprecise: false,
    latitude: 37.70236,
    longitude: -92.27656,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65534',
  },
  {
    city: 'Leasburg',
    county_fips: 29055,
    county_fips_all: '29055',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"29055": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 38.07194,
    longitude: -91.2752,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65535',
  },
  {
    city: 'Lebanon',
    county_fips: 29105,
    county_fips_all: '29105|29059|29029',
    county: 'Laclede',
    county_names_all: 'Laclede|Dallas|Camden',
    county_weights: '{"29105": 93.86, "29059": 4.66, "29029": 1.48}',
    density: 28.7,
    imprecise: false,
    latitude: 37.68942,
    longitude: -92.64974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65536',
  },
  {
    city: 'Lenox',
    county_fips: 29065,
    county_fips_all: '29065',
    county: 'Dent',
    county_names_all: 'Dent',
    county_weights: '{"29065": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 37.64401,
    longitude: -91.75624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65541',
  },
  {
    city: 'Licking',
    county_fips: 29215,
    county_fips_all: '29215|29065|29161',
    county: 'Texas',
    county_names_all: 'Texas|Dent|Phelps',
    county_weights: '{"29215": 91.4, "29065": 7.65, "29161": 0.95}',
    density: 12.6,
    imprecise: false,
    latitude: 37.50497,
    longitude: -91.88432,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65542',
  },
  {
    city: 'Lynchburg',
    county_fips: 29229,
    county_fips_all: '29229|29105',
    county: 'Wright',
    county_names_all: 'Wright|Laclede',
    county_weights: '{"29229": 53.35, "29105": 46.65}',
    density: 4.2,
    imprecise: false,
    latitude: 37.47172,
    longitude: -92.3045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65543',
  },
  {
    city: 'Mountain View',
    county_fips: 29091,
    county_fips_all: '29091|29203|29215',
    county: 'Howell',
    county_names_all: 'Howell|Shannon|Texas',
    county_weights: '{"29091": 60.54, "29203": 31.7, "29215": 7.76}',
    density: 13.2,
    imprecise: false,
    latitude: 37.00545,
    longitude: -91.71131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65548',
  },
  {
    city: 'Newburg',
    county_fips: 29161,
    county_fips_all: '29161|29169',
    county: 'Phelps',
    county_names_all: 'Phelps|Pulaski',
    county_weights: '{"29161": 92.19, "29169": 7.81}',
    density: 7.1,
    imprecise: false,
    latitude: 37.84425,
    longitude: -91.9433,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65550',
  },
  {
    city: 'Plato',
    county_fips: 29215,
    county_fips_all: '29215|29169|29105',
    county: 'Texas',
    county_names_all: 'Texas|Pulaski|Laclede',
    county_weights: '{"29215": 77.69, "29169": 12.18, "29105": 10.13}',
    density: 6.4,
    imprecise: false,
    latitude: 37.53842,
    longitude: -92.16701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65552',
  },
  {
    city: 'Raymondville',
    county_fips: 29215,
    county_fips_all: '29215',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"29215": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 37.35906,
    longitude: -91.77723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65555',
  },
  {
    city: 'Richland',
    county_fips: 29169,
    county_fips_all: '29169|29029|29105',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Camden|Laclede',
    county_weights: '{"29169": 44.2, "29029": 29.05, "29105": 26.75}',
    density: 8.4,
    imprecise: false,
    latitude: 37.83582,
    longitude: -92.40541,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65556',
  },
  {
    city: 'Roby',
    county_fips: 29215,
    county_fips_all: '29215',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"29215": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 37.51778,
    longitude: -92.14024,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65557',
  },
  {
    city: 'Saint James',
    county_fips: 29161,
    county_fips_all: '29161|29125|29055|29073',
    county: 'Phelps',
    county_names_all: 'Phelps|Maries|Crawford|Gasconade',
    county_weights:
      '{"29161": 78.8, "29125": 17.84, "29055": 2.78, "29073": 0.58}',
    density: 18.9,
    imprecise: false,
    latitude: 38.0181,
    longitude: -91.60664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65559',
  },
  {
    city: 'Salem',
    county_fips: 29065,
    county_fips_all: '29065|29203|29055|29161|29215',
    county: 'Dent',
    county_names_all: 'Dent|Shannon|Crawford|Phelps|Texas',
    county_weights:
      '{"29065": 79.15, "29203": 12.34, "29055": 5.95, "29161": 1.76, "29215": 0.8}',
    density: 8,
    imprecise: false,
    latitude: 37.59609,
    longitude: -91.49943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65560',
  },
  {
    city: 'Solo',
    county_fips: 29215,
    county_fips_all: '29215',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"29215": 100}',
    density: 1,
    imprecise: false,
    latitude: 37.23476,
    longitude: -91.95781,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65564',
  },
  {
    city: 'Steelville',
    county_fips: 29055,
    county_fips_all: '29055|29221|29093',
    county: 'Crawford',
    county_names_all: 'Crawford|Washington|Iron',
    county_weights: '{"29055": 81.51, "29221": 10.68, "29093": 7.81}',
    density: 6.8,
    imprecise: false,
    latitude: 37.90573,
    longitude: -91.23841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65565',
  },
  {
    city: 'Viburnum',
    county_fips: 29055,
    county_fips_all: '29055|29093',
    county: 'Crawford',
    county_names_all: 'Crawford|Iron',
    county_weights: '{"29055": 64.38, "29093": 35.62}',
    density: 29.1,
    imprecise: false,
    latitude: 37.76618,
    longitude: -91.14689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65566',
  },
  {
    city: 'Stoutland',
    county_fips: 29029,
    county_fips_all: '29029|29105',
    county: 'Camden',
    county_names_all: 'Camden|Laclede',
    county_weights: '{"29029": 79.47, "29105": 20.53}',
    density: 8.8,
    imprecise: false,
    latitude: 37.85594,
    longitude: -92.53699,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65567',
  },
  {
    city: 'Success',
    county_fips: 29215,
    county_fips_all: '29215',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"29215": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 37.45702,
    longitude: -92.10115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65570',
  },
  {
    city: 'Summersville',
    county_fips: 29215,
    county_fips_all: '29215|29203',
    county: 'Texas',
    county_names_all: 'Texas|Shannon',
    county_weights: '{"29215": 51.2, "29203": 48.8}',
    density: 3.7,
    imprecise: false,
    latitude: 37.18501,
    longitude: -91.64546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65571',
  },
  {
    city: 'Vichy',
    county_fips: 29125,
    county_fips_all: '29125',
    county: 'Maries',
    county_names_all: 'Maries',
    county_weights: '{"29125": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 38.11656,
    longitude: -91.78617,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65580',
  },
  {
    city: 'Vienna',
    county_fips: 29125,
    county_fips_all: '29125|29151',
    county: 'Maries',
    county_names_all: 'Maries|Osage',
    county_weights: '{"29125": 97.39, "29151": 2.61}',
    density: 5.4,
    imprecise: false,
    latitude: 38.19177,
    longitude: -91.92463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65582',
  },
  {
    city: 'Waynesville',
    county_fips: 29169,
    county_fips_all: '29169',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"29169": 100}',
    density: 89.8,
    imprecise: false,
    latitude: 37.82171,
    longitude: -92.2541,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65583',
  },
  {
    city: 'Saint Robert',
    county_fips: 29169,
    county_fips_all: '29169',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"29169": 100}',
    density: 167.6,
    imprecise: false,
    latitude: 37.82901,
    longitude: -92.13086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65584',
  },
  {
    city: 'Wesco',
    county_fips: 29055,
    county_fips_all: '29055',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"29055": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 37.86483,
    longitude: -91.43294,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65586',
  },
  {
    city: 'Winona',
    county_fips: 29203,
    county_fips_all: '29203|29149',
    county: 'Shannon',
    county_names_all: 'Shannon|Oregon',
    county_weights: '{"29203": 67.58, "29149": 32.42}',
    density: 3.7,
    imprecise: false,
    latitude: 36.96196,
    longitude: -91.29987,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65588',
  },
  {
    city: 'Yukon',
    county_fips: 29215,
    county_fips_all: '29215',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"29215": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 37.23729,
    longitude: -91.82747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65589',
  },
  {
    city: 'Long Lane',
    county_fips: 29059,
    county_fips_all: '29059',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"29059": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 37.61687,
    longitude: -92.95008,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65590',
  },
  {
    city: 'Montreal',
    county_fips: 29029,
    county_fips_all: '29029',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"29029": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 37.97941,
    longitude: -92.59076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65591',
  },
  {
    city: 'Aldrich',
    county_fips: 29167,
    county_fips_all: '29167|29057|29039',
    county: 'Polk',
    county_names_all: 'Polk|Dade|Cedar',
    county_weights: '{"29167": 64.64, "29057": 34.68, "29039": 0.68}',
    density: 4.2,
    imprecise: false,
    latitude: 37.53155,
    longitude: -93.5869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65601',
  },
  {
    city: 'Arcola',
    county_fips: 29057,
    county_fips_all: '29057',
    county: 'Dade',
    county_names_all: 'Dade',
    county_weights: '{"29057": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 37.54574,
    longitude: -93.86072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65603',
  },
  {
    city: 'Ash Grove',
    county_fips: 29077,
    county_fips_all: '29077|29109|29057',
    county: 'Greene',
    county_names_all: 'Greene|Lawrence|Dade',
    county_weights: '{"29077": 59.15, "29109": 33.06, "29057": 7.79}',
    density: 17.1,
    imprecise: false,
    latitude: 37.27348,
    longitude: -93.60367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65604',
  },
  {
    city: 'Aurora',
    county_fips: 29009,
    county_fips_all: '29009|29109|29209',
    county: 'Barry',
    county_names_all: 'Barry|Lawrence|Stone',
    county_weights: '{"29009": 56.64, "29109": 42.17, "29209": 1.19}',
    density: 27.3,
    imprecise: false,
    latitude: 36.88408,
    longitude: -93.69132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65605',
  },
  {
    city: 'Alton',
    county_fips: 29149,
    county_fips_all: '29149',
    county: 'Oregon',
    county_names_all: 'Oregon',
    county_weights: '{"29149": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 36.69634,
    longitude: -91.3586,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65606',
  },
  {
    city: 'Ava',
    county_fips: 29067,
    county_fips_all: '29067|29213|29153',
    county: 'Douglas',
    county_names_all: 'Douglas|Taney|Ozark',
    county_weights: '{"29067": 92.97, "29213": 3.6, "29153": 3.43}',
    density: 8.1,
    imprecise: false,
    latitude: 36.90456,
    longitude: -92.66662,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65608',
  },
  {
    city: 'Bakersfield',
    county_fips: 29153,
    county_fips_all: '29153|29091',
    county: 'Ozark',
    county_names_all: 'Ozark|Howell',
    county_weights: '{"29153": 71.58, "29091": 28.42}',
    density: 8.9,
    imprecise: false,
    latitude: 36.52593,
    longitude: -92.1609,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65609',
  },
  {
    city: 'Billings',
    county_fips: 29043,
    county_fips_all: '29043|29209|29077|29109',
    county: 'Christian',
    county_names_all: 'Christian|Stone|Greene|Lawrence',
    county_weights:
      '{"29043": 61.21, "29209": 23.97, "29077": 13.93, "29109": 0.89}',
    density: 24.8,
    imprecise: false,
    latitude: 37.03897,
    longitude: -93.52986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65610',
  },
  {
    city: 'Blue Eye',
    county_fips: 29209,
    county_fips_all: '29209|29213',
    county: 'Stone',
    county_names_all: 'Stone|Taney',
    county_weights: '{"29209": 99.32, "29213": 0.68}',
    density: 26.5,
    imprecise: false,
    latitude: 36.54339,
    longitude: -93.36127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65611',
  },
  {
    city: 'Bois D Arc',
    county_fips: 29077,
    county_fips_all: '29077|29109',
    county: 'Greene',
    county_names_all: 'Greene|Lawrence',
    county_weights: '{"29077": 89.92, "29109": 10.08}',
    density: 22.1,
    imprecise: false,
    latitude: 37.21897,
    longitude: -93.54694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65612',
  },
  {
    city: 'Bolivar',
    county_fips: 29167,
    county_fips_all: '29167',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"29167": 100}',
    density: 36.9,
    imprecise: false,
    latitude: 37.63557,
    longitude: -93.39205,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65613',
  },
  {
    city: 'Bradleyville',
    county_fips: 29213,
    county_fips_all: '29213|29043',
    county: 'Taney',
    county_names_all: 'Taney|Christian',
    county_weights: '{"29213": 92.81, "29043": 7.19}',
    density: 2,
    imprecise: false,
    latitude: 36.73739,
    longitude: -92.88684,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65614',
  },
  {
    city: 'Branson',
    county_fips: 29213,
    county_fips_all: '29213|29209',
    county: 'Taney',
    county_names_all: 'Taney|Stone',
    county_weights: '{"29213": 87.73, "29209": 12.27}',
    density: 143.7,
    imprecise: false,
    latitude: 36.67133,
    longitude: -93.24887,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65616',
  },
  {
    city: 'Brighton',
    county_fips: 29167,
    county_fips_all: '29167|29077',
    county: 'Polk',
    county_names_all: 'Polk|Greene',
    county_weights: '{"29167": 63.79, "29077": 36.21}',
    density: 20.4,
    imprecise: false,
    latitude: 37.4376,
    longitude: -93.34063,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65617',
  },
  {
    city: 'Brixey',
    county_fips: 29153,
    county_fips_all: '29153',
    county: 'Ozark',
    county_names_all: 'Ozark',
    county_weights: '{"29153": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 36.75157,
    longitude: -92.38641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65618',
  },
  {
    city: 'Brookline',
    county_fips: 29077,
    county_fips_all: '29077|29043',
    county: 'Greene',
    county_names_all: 'Greene|Christian',
    county_weights: '{"29077": 82.55, "29043": 17.45}',
    density: 189.9,
    imprecise: false,
    latitude: 37.12312,
    longitude: -93.38864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65619',
  },
  {
    city: 'Bruner',
    county_fips: 29043,
    county_fips_all: '29043',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"29043": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 37.02045,
    longitude: -92.95594,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65620',
  },
  {
    city: 'Buffalo',
    county_fips: 29059,
    county_fips_all: '29059|29167',
    county: 'Dallas',
    county_names_all: 'Dallas|Polk',
    county_weights: '{"29059": 89.57, "29167": 10.43}',
    density: 22.2,
    imprecise: false,
    latitude: 37.6337,
    longitude: -93.10775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65622',
  },
  {
    city: 'Cape Fair',
    county_fips: 29209,
    county_fips_all: '29209|29009',
    county: 'Stone',
    county_names_all: 'Stone|Barry',
    county_weights: '{"29209": 54.21, "29009": 45.79}',
    density: 11.8,
    imprecise: false,
    latitude: 36.73276,
    longitude: -93.56241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65624',
  },
  {
    city: 'Cassville',
    county_fips: 29009,
    county_fips_all: '29009',
    county: 'Barry',
    county_names_all: 'Barry',
    county_weights: '{"29009": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 36.67635,
    longitude: -93.8174,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65625',
  },
  {
    city: 'Caulfield',
    county_fips: 29153,
    county_fips_all: '29153|29091',
    county: 'Ozark',
    county_names_all: 'Ozark|Howell',
    county_weights: '{"29153": 50.43, "29091": 49.57}',
    density: 5.2,
    imprecise: false,
    latitude: 36.59088,
    longitude: -92.11697,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65626',
  },
  {
    city: 'Cedarcreek',
    county_fips: 29213,
    county_fips_all: '29213',
    county: 'Taney',
    county_names_all: 'Taney',
    county_weights: '{"29213": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 36.56247,
    longitude: -93.00613,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65627',
  },
  {
    city: 'Chadwick',
    county_fips: 29043,
    county_fips_all: '29043',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"29043": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 36.89371,
    longitude: -93.00294,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65629',
  },
  {
    city: 'Chestnutridge',
    county_fips: 29043,
    county_fips_all: '29043|29213',
    county: 'Christian',
    county_names_all: 'Christian|Taney',
    county_weights: '{"29043": 97.92, "29213": 2.08}',
    density: 21.3,
    imprecise: false,
    latitude: 36.83463,
    longitude: -93.2204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65630',
  },
  {
    city: 'Clever',
    county_fips: 29043,
    county_fips_all: '29043|29209',
    county: 'Christian',
    county_names_all: 'Christian|Stone',
    county_weights: '{"29043": 66.85, "29209": 33.15}',
    density: 56.7,
    imprecise: false,
    latitude: 37.00594,
    longitude: -93.4232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65631',
  },
  {
    city: 'Conway',
    county_fips: 29105,
    county_fips_all: '29105|29225|29059',
    county: 'Laclede',
    county_names_all: 'Laclede|Webster|Dallas',
    county_weights: '{"29105": 46.82, "29225": 30.09, "29059": 23.09}',
    density: 10.5,
    imprecise: false,
    latitude: 37.49961,
    longitude: -92.81612,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65632',
  },
  {
    city: 'Crane',
    county_fips: 29209,
    county_fips_all: '29209|29009',
    county: 'Stone',
    county_names_all: 'Stone|Barry',
    county_weights: '{"29209": 81.13, "29009": 18.87}',
    density: 18.2,
    imprecise: false,
    latitude: 36.89841,
    longitude: -93.5346,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65633',
  },
  {
    city: 'Cross Timbers',
    county_fips: 29085,
    county_fips_all: '29085|29015|29029',
    county: 'Hickory',
    county_names_all: 'Hickory|Benton|Camden',
    county_weights: '{"29085": 97.56, "29015": 2.07, "29029": 0.37}',
    density: 3.2,
    imprecise: false,
    latitude: 38.02355,
    longitude: -93.18827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65634',
  },
  {
    city: 'Dadeville',
    county_fips: 29057,
    county_fips_all: '29057|29039',
    county: 'Dade',
    county_names_all: 'Dade|Cedar',
    county_weights: '{"29057": 72.78, "29039": 27.22}',
    density: 7.2,
    imprecise: false,
    latitude: 37.53487,
    longitude: -93.71812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65635',
  },
  {
    city: 'Dora',
    county_fips: 29153,
    county_fips_all: '29153|29067|29091',
    county: 'Ozark',
    county_names_all: 'Ozark|Douglas|Howell',
    county_weights: '{"29153": 61.95, "29067": 28.68, "29091": 9.37}',
    density: 4.8,
    imprecise: false,
    latitude: 36.76964,
    longitude: -92.20371,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65637',
  },
  {
    city: 'Drury',
    county_fips: 29067,
    county_fips_all: '29067|29153',
    county: 'Douglas',
    county_names_all: 'Douglas|Ozark',
    county_weights: '{"29067": 80.64, "29153": 19.36}',
    density: 4.6,
    imprecise: false,
    latitude: 36.84319,
    longitude: -92.32418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65638',
  },
  {
    city: 'Dunnegan',
    county_fips: 29167,
    county_fips_all: '29167|29039',
    county: 'Polk',
    county_names_all: 'Polk|Cedar',
    county_weights: '{"29167": 74.17, "29039": 25.83}',
    density: 15,
    imprecise: false,
    latitude: 37.69956,
    longitude: -93.57165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65640',
  },
  {
    city: 'Eagle Rock',
    county_fips: 29009,
    county_fips_all: '29009',
    county: 'Barry',
    county_names_all: 'Barry',
    county_weights: '{"29009": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 36.5481,
    longitude: -93.76198,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65641',
  },
  {
    city: 'Elkland',
    county_fips: 29059,
    county_fips_all: '29059|29225',
    county: 'Dallas',
    county_names_all: 'Dallas|Webster',
    county_weights: '{"29059": 65.19, "29225": 34.81}',
    density: 9.8,
    imprecise: false,
    latitude: 37.50999,
    longitude: -93.03625,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65644',
  },
  {
    city: 'Everton',
    county_fips: 29057,
    county_fips_all: '29057|29109',
    county: 'Dade',
    county_names_all: 'Dade|Lawrence',
    county_weights: '{"29057": 75.6, "29109": 24.4}',
    density: 7.4,
    imprecise: false,
    latitude: 37.33511,
    longitude: -93.7039,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65646',
  },
  {
    city: 'Exeter',
    county_fips: 29009,
    county_fips_all: '29009|29119',
    county: 'Barry',
    county_names_all: 'Barry|McDonald',
    county_weights: '{"29009": 93.11, "29119": 6.89}',
    density: 21.8,
    imprecise: false,
    latitude: 36.68968,
    longitude: -94.00624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65647',
  },
  {
    city: 'Fair Grove',
    county_fips: 29077,
    county_fips_all: '29077|29059|29225|29167',
    county: 'Greene',
    county_names_all: 'Greene|Dallas|Webster|Polk',
    county_weights:
      '{"29077": 58.22, "29059": 26.1, "29225": 8.11, "29167": 7.57}',
    density: 28.8,
    imprecise: false,
    latitude: 37.40297,
    longitude: -93.15402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65648',
  },
  {
    city: 'Fair Play',
    county_fips: 29167,
    county_fips_all: '29167|29039',
    county: 'Polk',
    county_names_all: 'Polk|Cedar',
    county_weights: '{"29167": 50.32, "29039": 49.68}',
    density: 11.1,
    imprecise: false,
    latitude: 37.621,
    longitude: -93.61839,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65649',
  },
  {
    city: 'Flemington',
    county_fips: 29085,
    county_fips_all: '29085|29167',
    county: 'Hickory',
    county_names_all: 'Hickory|Polk',
    county_weights: '{"29085": 53.58, "29167": 46.42}',
    density: 7.3,
    imprecise: false,
    latitude: 37.81388,
    longitude: -93.44749,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65650',
  },
  {
    city: 'Fordland',
    county_fips: 29225,
    county_fips_all: '29225|29043|29067',
    county: 'Webster',
    county_names_all: 'Webster|Christian|Douglas',
    county_weights: '{"29225": 84.87, "29043": 13.49, "29067": 1.64}',
    density: 25.2,
    imprecise: false,
    latitude: 37.14264,
    longitude: -92.94642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65652',
  },
  {
    city: 'Forsyth',
    county_fips: 29213,
    county_fips_all: '29213|29043',
    county: 'Taney',
    county_names_all: 'Taney|Christian',
    county_weights: '{"29213": 59.0, "29043": 41.0}',
    density: 35.8,
    imprecise: false,
    latitude: 36.78118,
    longitude: -93.11631,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65653',
  },
  {
    city: 'Freistatt',
    county_fips: 29109,
    county_fips_all: '29109',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"29109": 100}',
    density: 459,
    imprecise: false,
    latitude: 37.02164,
    longitude: -93.8975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65654',
  },
  {
    city: 'Gainesville',
    county_fips: 29153,
    county_fips_all: '29153',
    county: 'Ozark',
    county_names_all: 'Ozark',
    county_weights: '{"29153": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 36.60262,
    longitude: -92.42379,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65655',
  },
  {
    city: 'Galena',
    county_fips: 29209,
    county_fips_all: '29209|29009',
    county: 'Stone',
    county_names_all: 'Stone|Barry',
    county_weights: '{"29209": 97.52, "29009": 2.48}',
    density: 17,
    imprecise: false,
    latitude: 36.79552,
    longitude: -93.46626,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65656',
  },
  {
    city: 'Garrison',
    county_fips: 29043,
    county_fips_all: '29043',
    county: 'Christian',
    county_names_all: 'Christian',
    county_weights: '{"29043": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 36.83934,
    longitude: -93.01952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65657',
  },
  {
    city: 'Golden',
    county_fips: 29009,
    county_fips_all: '29009',
    county: 'Barry',
    county_names_all: 'Barry',
    county_weights: '{"29009": 100}',
    density: 24.5,
    imprecise: false,
    latitude: 36.5426,
    longitude: -93.63984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65658',
  },
  {
    city: 'Graff',
    county_fips: 29229,
    county_fips_all: '29229|29215',
    county: 'Wright',
    county_names_all: 'Wright|Texas',
    county_weights: '{"29229": 81.68, "29215": 18.32}',
    density: 4.2,
    imprecise: false,
    latitude: 37.32624,
    longitude: -92.26998,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65660',
  },
  {
    city: 'Greenfield',
    county_fips: 29057,
    county_fips_all: '29057',
    county: 'Dade',
    county_names_all: 'Dade',
    county_weights: '{"29057": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 37.46095,
    longitude: -93.82722,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65661',
  },
  {
    city: 'Grovespring',
    county_fips: 29229,
    county_fips_all: '29229|29105',
    county: 'Wright',
    county_names_all: 'Wright|Laclede',
    county_weights: '{"29229": 77.36, "29105": 22.64}',
    density: 5.8,
    imprecise: false,
    latitude: 37.43421,
    longitude: -92.5698,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65662',
  },
  {
    city: 'Half Way',
    county_fips: 29167,
    county_fips_all: '29167',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"29167": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 37.62732,
    longitude: -93.24486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65663',
  },
  {
    city: 'Halltown',
    county_fips: 29109,
    county_fips_all: '29109',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"29109": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 37.19728,
    longitude: -93.61732,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65664',
  },
  {
    city: 'Hardenville',
    county_fips: 29153,
    county_fips_all: '29153',
    county: 'Ozark',
    county_names_all: 'Ozark',
    county_weights: '{"29153": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.57829,
    longitude: -92.36065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65666',
  },
  {
    city: 'Hartville',
    county_fips: 29229,
    county_fips_all: '29229',
    county: 'Wright',
    county_names_all: 'Wright',
    county_weights: '{"29229": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 37.30574,
    longitude: -92.51435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65667',
  },
  {
    city: 'Hermitage',
    county_fips: 29085,
    county_fips_all: '29085',
    county: 'Hickory',
    county_names_all: 'Hickory',
    county_weights: '{"29085": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 37.9364,
    longitude: -93.29177,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65668',
  },
  {
    city: 'Highlandville',
    county_fips: 29043,
    county_fips_all: '29043|29209',
    county: 'Christian',
    county_names_all: 'Christian|Stone',
    county_weights: '{"29043": 76.07, "29209": 23.93}',
    density: 26.1,
    imprecise: false,
    latitude: 36.91339,
    longitude: -93.30137,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65669',
  },
  {
    city: 'Hollister',
    county_fips: 29213,
    county_fips_all: '29213',
    county: 'Taney',
    county_names_all: 'Taney',
    county_weights: '{"29213": 100}',
    density: 57.2,
    imprecise: false,
    latitude: 36.56446,
    longitude: -93.21351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65672',
  },
  {
    city: 'Humansville',
    county_fips: 29167,
    county_fips_all: '29167|29039|29085|29185',
    county: 'Polk',
    county_names_all: 'Polk|Cedar|Hickory|St. Clair',
    county_weights:
      '{"29167": 42.95, "29039": 38.19, "29085": 11.33, "29185": 7.53}',
    density: 11.7,
    imprecise: false,
    latitude: 37.78872,
    longitude: -93.61018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65674',
  },
  {
    city: 'Hurley',
    county_fips: 29209,
    county_fips_all: '29209',
    county: 'Stone',
    county_names_all: 'Stone',
    county_weights: '{"29209": 100}',
    density: 113.4,
    imprecise: false,
    latitude: 36.93101,
    longitude: -93.49245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65675',
  },
  {
    city: 'Isabella',
    county_fips: 29153,
    county_fips_all: '29153',
    county: 'Ozark',
    county_names_all: 'Ozark',
    county_weights: '{"29153": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 36.58187,
    longitude: -92.60531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65676',
  },
  {
    city: 'Kirbyville',
    county_fips: 29213,
    county_fips_all: '29213',
    county: 'Taney',
    county_names_all: 'Taney',
    county_weights: '{"29213": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 36.57738,
    longitude: -93.10407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65679',
  },
  {
    city: 'Kissee Mills',
    county_fips: 29213,
    county_fips_all: '29213',
    county: 'Taney',
    county_names_all: 'Taney',
    county_weights: '{"29213": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 36.64518,
    longitude: -92.98551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65680',
  },
  {
    city: 'Lampe',
    county_fips: 29209,
    county_fips_all: '29209',
    county: 'Stone',
    county_names_all: 'Stone',
    county_weights: '{"29209": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 36.55211,
    longitude: -93.46658,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65681',
  },
  {
    city: 'Lockwood',
    county_fips: 29057,
    county_fips_all: '29057|29109',
    county: 'Dade',
    county_names_all: 'Dade|Lawrence',
    county_weights: '{"29057": 94.57, "29109": 5.43}',
    density: 5,
    imprecise: false,
    latitude: 37.41722,
    longitude: -93.97293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65682',
  },
  {
    city: 'Louisburg',
    county_fips: 29059,
    county_fips_all: '29059|29167',
    county: 'Dallas',
    county_names_all: 'Dallas|Polk',
    county_weights: '{"29059": 80.38, "29167": 19.62}',
    density: 8.6,
    imprecise: false,
    latitude: 37.75642,
    longitude: -93.1511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65685',
  },
  {
    city: 'Kimberling City',
    county_fips: 29209,
    county_fips_all: '29209',
    county: 'Stone',
    county_names_all: 'Stone',
    county_weights: '{"29209": 100}',
    density: 168.1,
    imprecise: false,
    latitude: 36.62275,
    longitude: -93.43625,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65686',
  },
  {
    city: 'Brandsville',
    county_fips: 29091,
    county_fips_all: '29091',
    county: 'Howell',
    county_names_all: 'Howell',
    county_weights: '{"29091": 100}',
    density: 62.8,
    imprecise: false,
    latitude: 36.64928,
    longitude: -91.69328,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65688',
  },
  {
    city: 'Cabool',
    county_fips: 29215,
    county_fips_all: '29215|29067|29091',
    county: 'Texas',
    county_names_all: 'Texas|Douglas|Howell',
    county_weights: '{"29215": 76.22, "29067": 18.9, "29091": 4.88}',
    density: 9.8,
    imprecise: false,
    latitude: 37.13665,
    longitude: -92.09794,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65689',
  },
  {
    city: 'Couch',
    county_fips: 29149,
    county_fips_all: '29149',
    county: 'Oregon',
    county_names_all: 'Oregon',
    county_weights: '{"29149": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 36.5856,
    longitude: -91.26657,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65690',
  },
  {
    city: 'Koshkonong',
    county_fips: 29149,
    county_fips_all: '29149|29091',
    county: 'Oregon',
    county_names_all: 'Oregon|Howell',
    county_weights: '{"29149": 58.44, "29091": 41.56}',
    density: 4,
    imprecise: false,
    latitude: 36.61801,
    longitude: -91.65592,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65692',
  },
  {
    city: 'Macomb',
    county_fips: 29067,
    county_fips_all: '29067|29229',
    county: 'Douglas',
    county_names_all: 'Douglas|Wright',
    county_weights: '{"29067": 55.47, "29229": 44.53}',
    density: 4.7,
    imprecise: false,
    latitude: 37.05726,
    longitude: -92.488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65702',
  },
  {
    city: 'Mansfield',
    county_fips: 29229,
    county_fips_all: '29229|29067',
    county: 'Wright',
    county_names_all: 'Wright|Douglas',
    county_weights: '{"29229": 74.87, "29067": 25.13}',
    density: 16.7,
    imprecise: false,
    latitude: 37.12657,
    longitude: -92.58323,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65704',
  },
  {
    city: 'Marionville',
    county_fips: 29109,
    county_fips_all: '29109|29209',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Stone',
    county_weights: '{"29109": 70.96, "29209": 29.04}',
    density: 46,
    imprecise: false,
    latitude: 37.02607,
    longitude: -93.60835,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65705',
  },
  {
    city: 'Marshfield',
    county_fips: 29225,
    county_fips_all: '29225|29077',
    county: 'Webster',
    county_names_all: 'Webster|Greene',
    county_weights: '{"29225": 99.85, "29077": 0.15}',
    density: 36.7,
    imprecise: false,
    latitude: 37.3224,
    longitude: -92.89421,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65706',
  },
  {
    city: 'Miller',
    county_fips: 29109,
    county_fips_all: '29109',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"29109": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 37.22862,
    longitude: -93.84574,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65707',
  },
  {
    city: 'Monett',
    county_fips: 29009,
    county_fips_all: '29009|29109',
    county: 'Barry',
    county_names_all: 'Barry|Lawrence',
    county_weights: '{"29009": 69.04, "29109": 30.96}',
    density: 57.6,
    imprecise: false,
    latitude: 36.91048,
    longitude: -93.90899,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65708',
  },
  {
    city: 'Morrisville',
    county_fips: 29167,
    county_fips_all: '29167',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"29167": 100}',
    density: 20,
    imprecise: false,
    latitude: 37.48707,
    longitude: -93.42099,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65710',
  },
  {
    city: 'Mountain Grove',
    county_fips: 29229,
    county_fips_all: '29229|29215|29067',
    county: 'Wright',
    county_names_all: 'Wright|Texas|Douglas',
    county_weights: '{"29229": 51.68, "29215": 27.79, "29067": 20.53}',
    density: 10.7,
    imprecise: false,
    latitude: 37.17355,
    longitude: -92.27747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65711',
  },
  {
    city: 'Mount Vernon',
    county_fips: 29109,
    county_fips_all: '29109',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"29109": 100}',
    density: 28.9,
    imprecise: false,
    latitude: 37.10964,
    longitude: -93.80645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65712',
  },
  {
    city: 'Niangua',
    county_fips: 29225,
    county_fips_all: '29225|29229',
    county: 'Webster',
    county_names_all: 'Webster|Wright',
    county_weights: '{"29225": 72.57, "29229": 27.43}',
    density: 7,
    imprecise: false,
    latitude: 37.40403,
    longitude: -92.73971,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65713',
  },
  {
    city: 'Nixa',
    county_fips: 29043,
    county_fips_all: '29043|29209',
    county: 'Christian',
    county_names_all: 'Christian|Stone',
    county_weights: '{"29043": 93.75, "29209": 6.25}',
    density: 279.5,
    imprecise: false,
    latitude: 37.03801,
    longitude: -93.31976,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65714',
  },
  {
    city: 'Noble',
    county_fips: 29153,
    county_fips_all: '29153',
    county: 'Ozark',
    county_names_all: 'Ozark',
    county_weights: '{"29153": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 36.73192,
    longitude: -92.57631,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65715',
  },
  {
    city: 'Norwood',
    county_fips: 29229,
    county_fips_all: '29229|29067',
    county: 'Wright',
    county_names_all: 'Wright|Douglas',
    county_weights: '{"29229": 52.69, "29067": 47.31}',
    density: 7.5,
    imprecise: false,
    latitude: 37.06017,
    longitude: -92.41472,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65717',
  },
  {
    city: 'Oldfield',
    county_fips: 29043,
    county_fips_all: '29043|29067',
    county: 'Christian',
    county_names_all: 'Christian|Douglas',
    county_weights: '{"29043": 76.95, "29067": 23.05}',
    density: 5.1,
    imprecise: false,
    latitude: 36.95513,
    longitude: -92.95998,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65720',
  },
  {
    city: 'Ozark',
    county_fips: 29043,
    county_fips_all: '29043|29077',
    county: 'Christian',
    county_names_all: 'Christian|Greene',
    county_weights: '{"29043": 97.96, "29077": 2.04}',
    density: 134.7,
    imprecise: false,
    latitude: 36.9805,
    longitude: -93.21045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65721',
  },
  {
    city: 'Phillipsburg',
    county_fips: 29105,
    county_fips_all: '29105|29059',
    county: 'Laclede',
    county_names_all: 'Laclede|Dallas',
    county_weights: '{"29105": 74.37, "29059": 25.63}',
    density: 10.9,
    imprecise: false,
    latitude: 37.58694,
    longitude: -92.79967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65722',
  },
  {
    city: 'Pierce City',
    county_fips: 29109,
    county_fips_all: '29109|29145|29009',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Newton|Barry',
    county_weights: '{"29109": 46.72, "29145": 35.24, "29009": 18.04}',
    density: 13.4,
    imprecise: false,
    latitude: 36.95635,
    longitude: -94.04648,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65723',
  },
  {
    city: 'Pittsburg',
    county_fips: 29085,
    county_fips_all: '29085|29167',
    county: 'Hickory',
    county_names_all: 'Hickory|Polk',
    county_weights: '{"29085": 92.29, "29167": 7.71}',
    density: 26.2,
    imprecise: false,
    latitude: 37.83924,
    longitude: -93.31488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65724',
  },
  {
    city: 'Pleasant Hope',
    county_fips: 29167,
    county_fips_all: '29167|29077',
    county: 'Polk',
    county_names_all: 'Polk|Greene',
    county_weights: '{"29167": 61.95, "29077": 38.05}',
    density: 30.8,
    imprecise: false,
    latitude: 37.42986,
    longitude: -93.27424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65725',
  },
  {
    city: 'Point Lookout',
    county_fips: 29213,
    county_fips_all: '29213',
    county: 'Taney',
    county_names_all: 'Taney',
    county_weights: '{"29213": 100}',
    density: 1208.7,
    imprecise: false,
    latitude: 36.61947,
    longitude: -93.2427,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65726',
  },
  {
    city: 'Polk',
    county_fips: 29167,
    county_fips_all: '29167|29085',
    county: 'Polk',
    county_names_all: 'Polk|Hickory',
    county_weights: '{"29167": 99.43, "29085": 0.57}',
    density: 3.9,
    imprecise: false,
    latitude: 37.76266,
    longitude: -93.28889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65727',
  },
  {
    city: 'Ponce De Leon',
    county_fips: 29043,
    county_fips_all: '29043|29209',
    county: 'Christian',
    county_names_all: 'Christian|Stone',
    county_weights: '{"29043": 72.59, "29209": 27.41}',
    density: 0,
    imprecise: false,
    latitude: 36.87712,
    longitude: -93.33533,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65728',
  },
  {
    city: 'Pontiac',
    county_fips: 29153,
    county_fips_all: '29153|05089',
    county: 'Ozark',
    county_names_all: 'Ozark|Marion',
    county_weights: '{"29153": 89.37, "05089": 10.63}',
    density: 2.4,
    imprecise: false,
    latitude: 36.53842,
    longitude: -92.55661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65729',
  },
  {
    city: 'Powell',
    county_fips: 29119,
    county_fips_all: '29119',
    county: 'McDonald',
    county_names_all: 'McDonald',
    county_weights: '{"29119": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 36.61549,
    longitude: -94.17001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65730',
  },
  {
    city: 'Powersite',
    county_fips: 29213,
    county_fips_all: '29213',
    county: 'Taney',
    county_names_all: 'Taney',
    county_weights: '{"29213": 100}',
    density: 35.6,
    imprecise: false,
    latitude: 36.65458,
    longitude: -93.12222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65731',
  },
  {
    city: 'Preston',
    county_fips: 29085,
    county_fips_all: '29085',
    county: 'Hickory',
    county_names_all: 'Hickory',
    county_weights: '{"29085": 100}',
    density: 9,
    imprecise: false,
    latitude: 37.93938,
    longitude: -93.16763,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65732',
  },
  {
    city: 'Protem',
    county_fips: 29213,
    county_fips_all: '29213|05089|05009|29153',
    county: 'Taney',
    county_names_all: 'Taney|Marion|Boone|Ozark',
    county_weights:
      '{"29213": 77.89, "05089": 11.67, "05009": 7.22, "29153": 3.22}',
    density: 4.8,
    imprecise: false,
    latitude: 36.53157,
    longitude: -92.85077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65733',
  },
  {
    city: 'Purdy',
    county_fips: 29009,
    county_fips_all: '29009|29145',
    county: 'Barry',
    county_names_all: 'Barry|Newton',
    county_weights: '{"29009": 99.59, "29145": 0.41}',
    density: 18.7,
    imprecise: false,
    latitude: 36.79841,
    longitude: -93.95233,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65734',
  },
  {
    city: 'Quincy',
    county_fips: 29085,
    county_fips_all: '29085|29185|29015',
    county: 'Hickory',
    county_names_all: 'Hickory|St. Clair|Benton',
    county_weights: '{"29085": 63.81, "29185": 20.12, "29015": 16.07}',
    density: 2.6,
    imprecise: false,
    latitude: 38.03728,
    longitude: -93.48391,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65735',
  },
  {
    city: 'Reeds Spring',
    county_fips: 29209,
    county_fips_all: '29209|29213|29043',
    county: 'Stone',
    county_names_all: 'Stone|Taney|Christian',
    county_weights: '{"29209": 85.24, "29213": 12.73, "29043": 2.03}',
    density: 40,
    imprecise: false,
    latitude: 36.7146,
    longitude: -93.35796,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65737',
  },
  {
    city: 'Republic',
    county_fips: 29077,
    county_fips_all: '29077|29043|29109',
    county: 'Greene',
    county_names_all: 'Greene|Christian|Lawrence',
    county_weights: '{"29077": 85.53, "29043": 13.08, "29109": 1.39}',
    density: 152.6,
    imprecise: false,
    latitude: 37.13503,
    longitude: -93.49424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65738',
  },
  {
    city: 'Ridgedale',
    county_fips: 29213,
    county_fips_all: '29213',
    county: 'Taney',
    county_names_all: 'Taney',
    county_weights: '{"29213": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 36.51925,
    longitude: -93.26864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65739',
  },
  {
    city: 'Rockaway Beach',
    county_fips: 29213,
    county_fips_all: '29213',
    county: 'Taney',
    county_names_all: 'Taney',
    county_weights: '{"29213": 100}',
    density: 332.8,
    imprecise: false,
    latitude: 36.71288,
    longitude: -93.16169,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65740',
  },
  {
    city: 'Rockbridge',
    county_fips: 29153,
    county_fips_all: '29153|29067',
    county: 'Ozark',
    county_names_all: 'Ozark|Douglas',
    county_weights: '{"29153": 99.9, "29067": 0.1}',
    density: 0,
    imprecise: false,
    latitude: 36.79545,
    longitude: -92.40127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65741',
  },
  {
    city: 'Rogersville',
    county_fips: 29077,
    county_fips_all: '29077|29225|29043',
    county: 'Greene',
    county_names_all: 'Greene|Webster|Christian',
    county_weights: '{"29077": 41.75, "29225": 30.7, "29043": 27.55}',
    density: 46.2,
    imprecise: false,
    latitude: 37.12543,
    longitude: -93.08001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65742',
  },
  {
    city: 'Rueter',
    county_fips: 29213,
    county_fips_all: '29213',
    county: 'Taney',
    county_names_all: 'Taney',
    county_weights: '{"29213": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 36.62449,
    longitude: -92.89337,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65744',
  },
  {
    city: 'Seligman',
    county_fips: 29009,
    county_fips_all: '29009|29119',
    county: 'Barry',
    county_names_all: 'Barry|McDonald',
    county_weights: '{"29009": 81.16, "29119": 18.84}',
    density: 19.3,
    imprecise: false,
    latitude: 36.52928,
    longitude: -93.97917,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65745',
  },
  {
    city: 'Seymour',
    county_fips: 29225,
    county_fips_all: '29225|29067|29229',
    county: 'Webster',
    county_names_all: 'Webster|Douglas|Wright',
    county_weights: '{"29225": 77.09, "29067": 14.16, "29229": 8.75}',
    density: 19.4,
    imprecise: false,
    latitude: 37.14278,
    longitude: -92.78144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65746',
  },
  {
    city: 'Shell Knob',
    county_fips: 29209,
    county_fips_all: '29209|29009',
    county: 'Stone',
    county_names_all: 'Stone|Barry',
    county_weights: '{"29209": 54.94, "29009": 45.06}',
    density: 20.2,
    imprecise: false,
    latitude: 36.60248,
    longitude: -93.57971,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65747',
  },
  {
    city: 'South Greenfield',
    county_fips: 29057,
    county_fips_all: '29057|29109',
    county: 'Dade',
    county_names_all: 'Dade|Lawrence',
    county_weights: '{"29057": 92.13, "29109": 7.87}',
    density: 2.8,
    imprecise: false,
    latitude: 37.32742,
    longitude: -93.83842,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65752',
  },
  {
    city: 'Sparta',
    county_fips: 29043,
    county_fips_all: '29043|29067',
    county: 'Christian',
    county_names_all: 'Christian|Douglas',
    county_weights: '{"29043": 93.18, "29067": 6.82}',
    density: 30.4,
    imprecise: false,
    latitude: 36.9955,
    longitude: -93.05386,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65753',
  },
  {
    city: 'Spokane',
    county_fips: 29043,
    county_fips_all: '29043|29209',
    county: 'Christian',
    county_names_all: 'Christian|Stone',
    county_weights: '{"29043": 99.38, "29209": 0.62}',
    density: 12.9,
    imprecise: false,
    latitude: 36.85032,
    longitude: -93.29595,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65754',
  },
  {
    city: 'Squires',
    county_fips: 29067,
    county_fips_all: '29067|29153',
    county: 'Douglas',
    county_names_all: 'Douglas|Ozark',
    county_weights: '{"29067": 56.26, "29153": 43.74}',
    density: 6.3,
    imprecise: false,
    latitude: 36.7996,
    longitude: -92.62858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65755',
  },
  {
    city: 'Stotts City',
    county_fips: 29109,
    county_fips_all: '29109',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"29109": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 37.0981,
    longitude: -93.96315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65756',
  },
  {
    city: 'Strafford',
    county_fips: 29077,
    county_fips_all: '29077|29225',
    county: 'Greene',
    county_names_all: 'Greene|Webster',
    county_weights: '{"29077": 71.57, "29225": 28.43}',
    density: 39.7,
    imprecise: false,
    latitude: 37.2838,
    longitude: -93.09861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65757',
  },
  {
    city: 'Taneyville',
    county_fips: 29213,
    county_fips_all: '29213|29043',
    county: 'Taney',
    county_names_all: 'Taney|Christian',
    county_weights: '{"29213": 97.67, "29043": 2.33}',
    density: 6.5,
    imprecise: false,
    latitude: 36.75762,
    longitude: -93.03167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65759',
  },
  {
    city: 'Tecumseh',
    county_fips: 29153,
    county_fips_all: '29153',
    county: 'Ozark',
    county_names_all: 'Ozark',
    county_weights: '{"29153": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 36.62236,
    longitude: -92.27943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65760',
  },
  {
    city: 'Theodosia',
    county_fips: 29153,
    county_fips_all: '29153|29213|05089',
    county: 'Ozark',
    county_names_all: 'Ozark|Taney|Marion',
    county_weights: '{"29153": 61.58, "29213": 20.52, "05089": 17.9}',
    density: 4.5,
    imprecise: false,
    latitude: 36.56974,
    longitude: -92.72561,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65761',
  },
  {
    city: 'Thornfield',
    county_fips: 29153,
    county_fips_all: '29153',
    county: 'Ozark',
    county_names_all: 'Ozark',
    county_weights: '{"29153": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 36.68613,
    longitude: -92.65634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65762',
  },
  {
    city: 'Tunas',
    county_fips: 29059,
    county_fips_all: '29059',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"29059": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 37.82189,
    longitude: -92.95682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65764',
  },
  {
    city: 'Udall',
    county_fips: 29153,
    county_fips_all: '29153',
    county: 'Ozark',
    county_names_all: 'Ozark',
    county_weights: '{"29153": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 36.53933,
    longitude: -92.25948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65766',
  },
  {
    city: 'Urbana',
    county_fips: 29059,
    county_fips_all: '29059|29085|29167',
    county: 'Dallas',
    county_names_all: 'Dallas|Hickory|Polk',
    county_weights: '{"29059": 66.55, "29085": 29.43, "29167": 4.02}',
    density: 9.5,
    imprecise: false,
    latitude: 37.84495,
    longitude: -93.1529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65767',
  },
  {
    city: 'Vanzant',
    county_fips: 29067,
    county_fips_all: '29067',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"29067": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 36.92072,
    longitude: -92.26456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65768',
  },
  {
    city: 'Verona',
    county_fips: 29009,
    county_fips_all: '29009|29109',
    county: 'Barry',
    county_names_all: 'Barry|Lawrence',
    county_weights: '{"29009": 51.74, "29109": 48.26}',
    density: 10.6,
    imprecise: false,
    latitude: 36.91676,
    longitude: -93.79511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65769',
  },
  {
    city: 'Walnut Grove',
    county_fips: 29077,
    county_fips_all: '29077|29167|29057',
    county: 'Greene',
    county_names_all: 'Greene|Polk|Dade',
    county_weights: '{"29077": 48.39, "29167": 37.69, "29057": 13.92}',
    density: 10.5,
    imprecise: false,
    latitude: 37.42165,
    longitude: -93.5456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65770',
  },
  {
    city: 'Walnut Shade',
    county_fips: 29213,
    county_fips_all: '29213|29043',
    county: 'Taney',
    county_names_all: 'Taney|Christian',
    county_weights: '{"29213": 99.83, "29043": 0.17}',
    density: 15,
    imprecise: false,
    latitude: 36.77484,
    longitude: -93.2042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65771',
  },
  {
    city: 'Washburn',
    county_fips: 29009,
    county_fips_all: '29009|29119',
    county: 'Barry',
    county_names_all: 'Barry|McDonald',
    county_weights: '{"29009": 69.06, "29119": 30.94}',
    density: 10.2,
    imprecise: false,
    latitude: 36.59624,
    longitude: -94.03479,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65772',
  },
  {
    city: 'Wasola',
    county_fips: 29153,
    county_fips_all: '29153',
    county: 'Ozark',
    county_names_all: 'Ozark',
    county_weights: '{"29153": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 36.75551,
    longitude: -92.51332,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65773',
  },
  {
    city: 'Weaubleau',
    county_fips: 29085,
    county_fips_all: '29085|29185',
    county: 'Hickory',
    county_names_all: 'Hickory|St. Clair',
    county_weights: '{"29085": 78.71, "29185": 21.29}',
    density: 6.9,
    imprecise: false,
    latitude: 37.92806,
    longitude: -93.49529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65774',
  },
  {
    city: 'West Plains',
    county_fips: 29091,
    county_fips_all: '29091|29149|29067',
    county: 'Howell',
    county_names_all: 'Howell|Oregon|Douglas',
    county_weights: '{"29091": 91.05, "29149": 5.39, "29067": 3.56}',
    density: 22.5,
    imprecise: false,
    latitude: 36.6995,
    longitude: -91.85999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65775',
  },
  {
    city: 'Moody',
    county_fips: 29091,
    county_fips_all: '29091',
    county: 'Howell',
    county_names_all: 'Howell',
    county_weights: '{"29091": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 36.51768,
    longitude: -91.98356,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65777',
  },
  {
    city: 'Myrtle',
    county_fips: 29149,
    county_fips_all: '29149',
    county: 'Oregon',
    county_names_all: 'Oregon',
    county_weights: '{"29149": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 36.52846,
    longitude: -91.2719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65778',
  },
  {
    city: 'Wheatland',
    county_fips: 29085,
    county_fips_all: '29085|29015',
    county: 'Hickory',
    county_names_all: 'Hickory|Benton',
    county_weights: '{"29085": 97.03, "29015": 2.97}',
    density: 5.2,
    imprecise: false,
    latitude: 37.9789,
    longitude: -93.38561,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65779',
  },
  {
    city: 'Willard',
    county_fips: 29077,
    county_fips_all: '29077|29167',
    county: 'Greene',
    county_names_all: 'Greene|Polk',
    county_weights: '{"29077": 89.42, "29167": 10.58}',
    density: 52.3,
    imprecise: false,
    latitude: 37.35035,
    longitude: -93.41778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65781',
  },
  {
    city: 'Windyville',
    county_fips: 29059,
    county_fips_all: '29059',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"29059": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 37.7153,
    longitude: -92.91623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65783',
  },
  {
    city: 'Zanoni',
    county_fips: 29153,
    county_fips_all: '29153',
    county: 'Ozark',
    county_names_all: 'Ozark',
    county_weights: '{"29153": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 36.72588,
    longitude: -92.31538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65784',
  },
  {
    city: 'Stockton',
    county_fips: 29039,
    county_fips_all: '29039|29185|29057',
    county: 'Cedar',
    county_names_all: 'Cedar|St. Clair|Dade',
    county_weights: '{"29039": 90.16, "29185": 6.09, "29057": 3.75}',
    density: 10.6,
    imprecise: false,
    latitude: 37.70296,
    longitude: -93.82338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65785',
  },
  {
    city: 'Macks Creek',
    county_fips: 29029,
    county_fips_all: '29029|29059',
    county: 'Camden',
    county_names_all: 'Camden|Dallas',
    county_weights: '{"29029": 96.43, "29059": 3.57}',
    density: 7.6,
    imprecise: false,
    latitude: 37.96715,
    longitude: -92.96516,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65786',
  },
  {
    city: 'Roach',
    county_fips: 29029,
    county_fips_all: '29029',
    county: 'Camden',
    county_names_all: 'Camden',
    county_weights: '{"29029": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 38.07306,
    longitude: -92.89213,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65787',
  },
  {
    city: 'Peace Valley',
    county_fips: 29091,
    county_fips_all: '29091|29149',
    county: 'Howell',
    county_names_all: 'Howell|Oregon',
    county_weights: '{"29091": 91.48, "29149": 8.52}',
    density: 5,
    imprecise: false,
    latitude: 36.81442,
    longitude: -91.69626,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65788',
  },
  {
    city: 'Pomona',
    county_fips: 29091,
    county_fips_all: '29091',
    county: 'Howell',
    county_names_all: 'Howell',
    county_weights: '{"29091": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 36.85719,
    longitude: -91.88968,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65789',
  },
  {
    city: 'Pottersville',
    county_fips: 29091,
    county_fips_all: '29091|29153',
    county: 'Howell',
    county_names_all: 'Howell|Ozark',
    county_weights: '{"29091": 51.76, "29153": 48.24}',
    density: 5.8,
    imprecise: false,
    latitude: 36.69784,
    longitude: -92.11326,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65790',
  },
  {
    city: 'Thayer',
    county_fips: 29149,
    county_fips_all: '29149',
    county: 'Oregon',
    county_names_all: 'Oregon',
    county_weights: '{"29149": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 36.56651,
    longitude: -91.49583,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65791',
  },
  {
    city: 'Willow Springs',
    county_fips: 29091,
    county_fips_all: '29091|29215|29067',
    county: 'Howell',
    county_names_all: 'Howell|Texas|Douglas',
    county_weights: '{"29091": 57.67, "29215": 28.24, "29067": 14.09}',
    density: 8.9,
    imprecise: false,
    latitude: 36.98975,
    longitude: -91.9787,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65793',
  },
  {
    city: 'Springfield',
    county_fips: 29077,
    county_fips_all: '29077',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"29077": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.21421,
    longitude: -93.29521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65801',
  },
  {
    city: 'Springfield',
    county_fips: 29077,
    county_fips_all: '29077',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"29077": 100}',
    density: 293.8,
    imprecise: false,
    latitude: 37.21048,
    longitude: -93.35167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65802',
  },
  {
    city: 'Springfield',
    county_fips: 29077,
    county_fips_all: '29077',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"29077": 100}',
    density: 177.4,
    imprecise: false,
    latitude: 37.28464,
    longitude: -93.29036,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65803',
  },
  {
    city: 'Springfield',
    county_fips: 29077,
    county_fips_all: '29077',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"29077": 100}',
    density: 849.7,
    imprecise: false,
    latitude: 37.14822,
    longitude: -93.25294,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65804',
  },
  {
    city: 'Springfield',
    county_fips: 29077,
    county_fips_all: '29077',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"29077": 100}',
    density: 2475.7,
    imprecise: false,
    latitude: 37.20567,
    longitude: -93.29847,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65806',
  },
  {
    city: 'Springfield',
    county_fips: 29077,
    county_fips_all: '29077',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"29077": 100}',
    density: 1040.9,
    imprecise: false,
    latitude: 37.166,
    longitude: -93.32483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65807',
  },
  {
    city: 'Springfield',
    county_fips: 29077,
    county_fips_all: '29077',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"29077": 100}',
    density: 258.4,
    imprecise: false,
    latitude: 37.17071,
    longitude: -93.1936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65809',
  },
  {
    city: 'Springfield',
    county_fips: 29077,
    county_fips_all: '29077',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"29077": 100}',
    density: 714.1,
    imprecise: false,
    latitude: 37.1174,
    longitude: -93.31707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65810',
  },
  {
    city: 'Atchison',
    county_fips: 20005,
    county_fips_all: '20005|20043|20087|20103',
    county: 'Atchison',
    county_names_all: 'Atchison|Doniphan|Jefferson|Leavenworth',
    county_weights:
      '{"20005": 73.65, "20043": 17.47, "20087": 4.81, "20103": 4.07}',
    density: 27.1,
    imprecise: false,
    latitude: 39.5488,
    longitude: -95.13881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66002',
  },
  {
    city: 'Baldwin City',
    county_fips: 20045,
    county_fips_all: '20045|20059',
    county: 'Douglas',
    county_names_all: 'Douglas|Franklin',
    county_weights: '{"20045": 94.6, "20059": 5.4}',
    density: 28.5,
    imprecise: false,
    latitude: 38.79433,
    longitude: -95.23936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66006',
  },
  {
    city: 'Basehor',
    county_fips: 20103,
    county_fips_all: '20103',
    county: 'Leavenworth',
    county_names_all: 'Leavenworth',
    county_weights: '{"20103": 100}',
    density: 124.9,
    imprecise: false,
    latitude: 39.1405,
    longitude: -94.94548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66007',
  },
  {
    city: 'Bendena',
    county_fips: 20043,
    county_fips_all: '20043',
    county: 'Doniphan',
    county_names_all: 'Doniphan',
    county_weights: '{"20043": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 39.71283,
    longitude: -95.17564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66008',
  },
  {
    city: 'Blue Mound',
    county_fips: 20107,
    county_fips_all: '20107|20011',
    county: 'Linn',
    county_names_all: 'Linn|Bourbon',
    county_weights: '{"20107": 93.66, "20011": 6.34}',
    density: 2.7,
    imprecise: false,
    latitude: 38.09231,
    longitude: -94.98853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66010',
  },
  {
    city: 'Bonner Springs',
    county_fips: 20103,
    county_fips_all: '20103|20209',
    county: 'Leavenworth',
    county_names_all: 'Leavenworth|Wyandotte',
    county_weights: '{"20103": 55.31, "20209": 44.69}',
    density: 101.4,
    imprecise: false,
    latitude: 39.06091,
    longitude: -94.91658,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66012',
  },
  {
    city: 'Bucyrus',
    county_fips: 20121,
    county_fips_all: '20121|20091',
    county: 'Miami',
    county_names_all: 'Miami|Johnson',
    county_weights: '{"20121": 58.19, "20091": 41.81}',
    density: 23.5,
    imprecise: false,
    latitude: 38.73428,
    longitude: -94.68948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66013',
  },
  {
    city: 'Centerville',
    county_fips: 20107,
    county_fips_all: '20107|20003',
    county: 'Linn',
    county_names_all: 'Linn|Anderson',
    county_weights: '{"20107": 96.28, "20003": 3.72}',
    density: 3.4,
    imprecise: false,
    latitude: 38.22305,
    longitude: -94.98371,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66014',
  },
  {
    city: 'Colony',
    county_fips: 20003,
    county_fips_all: '20003|20001',
    county: 'Anderson',
    county_names_all: 'Anderson|Allen',
    county_weights: '{"20003": 76.9, "20001": 23.1}',
    density: 2.9,
    imprecise: false,
    latitude: 38.06786,
    longitude: -95.40395,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66015',
  },
  {
    city: 'Cummings',
    county_fips: 20005,
    county_fips_all: '20005',
    county: 'Atchison',
    county_names_all: 'Atchison',
    county_weights: '{"20005": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 39.47038,
    longitude: -95.23158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66016',
  },
  {
    city: 'Denton',
    county_fips: 20043,
    county_fips_all: '20043|20013',
    county: 'Doniphan',
    county_names_all: 'Doniphan|Brown',
    county_weights: '{"20043": 93.33, "20013": 6.67}',
    density: 2,
    imprecise: false,
    latitude: 39.70599,
    longitude: -95.27591,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66017',
  },
  {
    city: 'De Soto',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 109.5,
    imprecise: false,
    latitude: 38.96524,
    longitude: -94.97232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66018',
  },
  {
    city: 'Easton',
    county_fips: 20103,
    county_fips_all: '20103',
    county: 'Leavenworth',
    county_names_all: 'Leavenworth',
    county_weights: '{"20103": 100}',
    density: 11,
    imprecise: false,
    latitude: 39.34142,
    longitude: -95.10779,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66020',
  },
  {
    city: 'Edgerton',
    county_fips: 20091,
    county_fips_all: '20091|20121|20045',
    county: 'Johnson',
    county_names_all: 'Johnson|Miami|Douglas',
    county_weights: '{"20091": 60.09, "20121": 31.16, "20045": 8.75}',
    density: 21.2,
    imprecise: false,
    latitude: 38.75939,
    longitude: -95.00692,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66021',
  },
  {
    city: 'Effingham',
    county_fips: 20005,
    county_fips_all: '20005',
    county: 'Atchison',
    county_names_all: 'Atchison',
    county_weights: '{"20005": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 39.51375,
    longitude: -95.40005,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66023',
  },
  {
    city: 'Elwood',
    county_fips: 20043,
    county_fips_all: '20043',
    county: 'Doniphan',
    county_names_all: 'Doniphan',
    county_weights: '{"20043": 100}',
    density: 221.7,
    imprecise: false,
    latitude: 39.76211,
    longitude: -94.87719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66024',
  },
  {
    city: 'Eudora',
    county_fips: 20045,
    county_fips_all: '20045|20091',
    county: 'Douglas',
    county_names_all: 'Douglas|Johnson',
    county_weights: '{"20045": 69.34, "20091": 30.66}',
    density: 41.9,
    imprecise: false,
    latitude: 38.89824,
    longitude: -95.07863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66025',
  },
  {
    city: 'Fontana',
    county_fips: 20121,
    county_fips_all: '20121|20107',
    county: 'Miami',
    county_names_all: 'Miami|Linn',
    county_weights: '{"20121": 50.02, "20107": 49.98}',
    density: 6.7,
    imprecise: false,
    latitude: 38.39047,
    longitude: -94.86056,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66026',
  },
  {
    city: 'Fort Leavenworth',
    county_fips: 20103,
    county_fips_all: '20103',
    county: 'Leavenworth',
    county_names_all: 'Leavenworth',
    county_weights: '{"20103": 100}',
    density: 306,
    imprecise: false,
    latitude: 39.36454,
    longitude: -94.91708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66027',
  },
  {
    city: 'Gardner',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 219,
    imprecise: false,
    latitude: 38.81519,
    longitude: -94.94114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66030',
  },
  {
    city: 'New Century',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 77.5,
    imprecise: false,
    latitude: 38.82975,
    longitude: -94.89142,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66031',
  },
  {
    city: 'Garnett',
    county_fips: 20003,
    county_fips_all: '20003',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"20003": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 38.2806,
    longitude: -95.27237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66032',
  },
  {
    city: 'Greeley',
    county_fips: 20003,
    county_fips_all: '20003|20059|20107',
    county: 'Anderson',
    county_names_all: 'Anderson|Franklin|Linn',
    county_weights: '{"20003": 78.24, "20059": 14.94, "20107": 6.82}',
    density: 5,
    imprecise: false,
    latitude: 38.35855,
    longitude: -95.12842,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66033',
  },
  {
    city: 'Highland',
    county_fips: 20043,
    county_fips_all: '20043',
    county: 'Doniphan',
    county_names_all: 'Doniphan',
    county_weights: '{"20043": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 39.87693,
    longitude: -95.26054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66035',
  },
  {
    city: 'Kincaid',
    county_fips: 20003,
    county_fips_all: '20003|20001',
    county: 'Anderson',
    county_names_all: 'Anderson|Allen',
    county_weights: '{"20003": 93.22, "20001": 6.78}',
    density: 2.9,
    imprecise: false,
    latitude: 38.0987,
    longitude: -95.17011,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66039',
  },
  {
    city: 'La Cygne',
    county_fips: 20107,
    county_fips_all: '20107|20121',
    county: 'Linn',
    county_names_all: 'Linn|Miami',
    county_weights: '{"20107": 71.27, "20121": 28.73}',
    density: 10.5,
    imprecise: false,
    latitude: 38.35396,
    longitude: -94.73949,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66040',
  },
  {
    city: 'Lancaster',
    county_fips: 20005,
    county_fips_all: '20005|20043|20013',
    county: 'Atchison',
    county_names_all: 'Atchison|Doniphan|Brown',
    county_weights: '{"20005": 86.87, "20043": 9.25, "20013": 3.88}',
    density: 4.4,
    imprecise: false,
    latitude: 39.59618,
    longitude: -95.30623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66041',
  },
  {
    city: 'Lane',
    county_fips: 20059,
    county_fips_all: '20059|20121',
    county: 'Franklin',
    county_names_all: 'Franklin|Miami',
    county_weights: '{"20059": 62.16, "20121": 37.84}',
    density: 12.1,
    imprecise: false,
    latitude: 38.43368,
    longitude: -95.08032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66042',
  },
  {
    city: 'Lansing',
    county_fips: 20103,
    county_fips_all: '20103',
    county: 'Leavenworth',
    county_names_all: 'Leavenworth',
    county_weights: '{"20103": 100}',
    density: 591.6,
    imprecise: false,
    latitude: 39.24967,
    longitude: -94.90193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66043',
  },
  {
    city: 'Lawrence',
    county_fips: 20045,
    county_fips_all: '20045|20087|20103',
    county: 'Douglas',
    county_names_all: 'Douglas|Jefferson|Leavenworth',
    county_weights: '{"20045": 38.61, "20087": 32.7, "20103": 28.69}',
    density: 173.4,
    imprecise: false,
    latitude: 39.03187,
    longitude: -95.20991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66044',
  },
  {
    city: 'Lawrence',
    county_fips: 20045,
    county_fips_all: '20045',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"20045": 100}',
    density: 185.8,
    imprecise: false,
    latitude: 38.909,
    longitude: -95.21061,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66046',
  },
  {
    city: 'Lawrence',
    county_fips: 20045,
    county_fips_all: '20045',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"20045": 100}',
    density: 135.9,
    imprecise: false,
    latitude: 38.88484,
    longitude: -95.35096,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66047',
  },
  {
    city: 'Leavenworth',
    county_fips: 20103,
    county_fips_all: '20103',
    county: 'Leavenworth',
    county_names_all: 'Leavenworth',
    county_weights: '{"20103": 100}',
    density: 101.8,
    imprecise: false,
    latitude: 39.27891,
    longitude: -94.98527,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66048',
  },
  {
    city: 'Lawrence',
    county_fips: 20045,
    county_fips_all: '20045',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"20045": 100}',
    density: 273.5,
    imprecise: false,
    latitude: 38.97773,
    longitude: -95.34729,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66049',
  },
  {
    city: 'Lecompton',
    county_fips: 20045,
    county_fips_all: '20045|20177',
    county: 'Douglas',
    county_names_all: 'Douglas|Shawnee',
    county_weights: '{"20045": 99.21, "20177": 0.79}',
    density: 16.8,
    imprecise: false,
    latitude: 39.01961,
    longitude: -95.43697,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66050',
  },
  {
    city: 'Linwood',
    county_fips: 20103,
    county_fips_all: '20103',
    county: 'Leavenworth',
    county_names_all: 'Leavenworth',
    county_weights: '{"20103": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 39.00998,
    longitude: -95.04678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66052',
  },
  {
    city: 'Louisburg',
    county_fips: 20121,
    county_fips_all: '20121',
    county: 'Miami',
    county_names_all: 'Miami',
    county_weights: '{"20121": 100}',
    density: 29.1,
    imprecise: false,
    latitude: 38.57753,
    longitude: -94.67029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66053',
  },
  {
    city: 'McLouth',
    county_fips: 20087,
    county_fips_all: '20087|20103',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Leavenworth',
    county_weights: '{"20087": 63.76, "20103": 36.24}',
    density: 13.8,
    imprecise: false,
    latitude: 39.2055,
    longitude: -95.19518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66054',
  },
  {
    city: 'Mound City',
    county_fips: 20107,
    county_fips_all: '20107',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"20107": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 38.1509,
    longitude: -94.84705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66056',
  },
  {
    city: 'Muscotah',
    county_fips: 20005,
    county_fips_all: '20005',
    county: 'Atchison',
    county_names_all: 'Atchison',
    county_weights: '{"20005": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 39.54018,
    longitude: -95.51894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66058',
  },
  {
    city: 'Nortonville',
    county_fips: 20087,
    county_fips_all: '20087|20005',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Atchison',
    county_weights: '{"20087": 51.58, "20005": 48.42}',
    density: 8.6,
    imprecise: false,
    latitude: 39.41866,
    longitude: -95.3325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66060',
  },
  {
    city: 'Olathe',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 414.6,
    imprecise: false,
    latitude: 38.89633,
    longitude: -94.88029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 67967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66061',
  },
  {
    city: 'Olathe',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 723.6,
    imprecise: false,
    latitude: 38.83677,
    longitude: -94.78455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 78841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66062',
  },
  {
    city: 'Osawatomie',
    county_fips: 20121,
    county_fips_all: '20121|20059',
    county: 'Miami',
    county_names_all: 'Miami|Franklin',
    county_weights: '{"20121": 96.52, "20059": 3.48}',
    density: 31.3,
    imprecise: false,
    latitude: 38.47829,
    longitude: -94.98688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66064',
  },
  {
    city: 'Oskaloosa',
    county_fips: 20087,
    county_fips_all: '20087',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"20087": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 39.20359,
    longitude: -95.33142,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66066',
  },
  {
    city: 'Ottawa',
    county_fips: 20059,
    county_fips_all: '20059',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"20059": 100}',
    density: 38.4,
    imprecise: false,
    latitude: 38.61877,
    longitude: -95.27566,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66067',
  },
  {
    city: 'Ozawkie',
    county_fips: 20087,
    county_fips_all: '20087',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"20087": 100}',
    density: 24.5,
    imprecise: false,
    latitude: 39.21135,
    longitude: -95.45132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66070',
  },
  {
    city: 'Paola',
    county_fips: 20121,
    county_fips_all: '20121',
    county: 'Miami',
    county_names_all: 'Miami',
    county_weights: '{"20121": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 38.57367,
    longitude: -94.86575,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66071',
  },
  {
    city: 'Parker',
    county_fips: 20107,
    county_fips_all: '20107|20121',
    county: 'Linn',
    county_names_all: 'Linn|Miami',
    county_weights: '{"20107": 96.6, "20121": 3.4}',
    density: 6.2,
    imprecise: false,
    latitude: 38.31772,
    longitude: -94.9741,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66072',
  },
  {
    city: 'Perry',
    county_fips: 20087,
    county_fips_all: '20087',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"20087": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 39.09208,
    longitude: -95.38144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66073',
  },
  {
    city: 'Pleasanton',
    county_fips: 20107,
    county_fips_all: '20107',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"20107": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 38.20362,
    longitude: -94.69272,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66075',
  },
  {
    city: 'Pomona',
    county_fips: 20059,
    county_fips_all: '20059',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"20059": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 38.62811,
    longitude: -95.43917,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66076',
  },
  {
    city: 'Princeton',
    county_fips: 20059,
    county_fips_all: '20059',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"20059": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 38.48321,
    longitude: -95.2621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66078',
  },
  {
    city: 'Rantoul',
    county_fips: 20059,
    county_fips_all: '20059',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"20059": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 38.53828,
    longitude: -95.11371,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66079',
  },
  {
    city: 'Richmond',
    county_fips: 20059,
    county_fips_all: '20059|20003',
    county: 'Franklin',
    county_names_all: 'Franklin|Anderson',
    county_weights: '{"20059": 67.52, "20003": 32.48}',
    density: 6.4,
    imprecise: false,
    latitude: 38.4053,
    longitude: -95.25646,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66080',
  },
  {
    city: 'Spring Hill',
    county_fips: 20121,
    county_fips_all: '20121|20091',
    county: 'Miami',
    county_names_all: 'Miami|Johnson',
    county_weights: '{"20121": 57.64, "20091": 42.36}',
    density: 81,
    imprecise: false,
    latitude: 38.73518,
    longitude: -94.83397,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66083',
  },
  {
    city: 'Stilwell',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 183.3,
    imprecise: false,
    latitude: 38.80069,
    longitude: -94.64729,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66085',
  },
  {
    city: 'Tonganoxie',
    county_fips: 20103,
    county_fips_all: '20103|20087',
    county: 'Leavenworth',
    county_names_all: 'Leavenworth|Jefferson',
    county_weights: '{"20103": 98.91, "20087": 1.09}',
    density: 44.3,
    imprecise: false,
    latitude: 39.11578,
    longitude: -95.08043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66086',
  },
  {
    city: 'Troy',
    county_fips: 20043,
    county_fips_all: '20043',
    county: 'Doniphan',
    county_names_all: 'Doniphan',
    county_weights: '{"20043": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 39.80641,
    longitude: -95.1378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66087',
  },
  {
    city: 'Valley Falls',
    county_fips: 20087,
    county_fips_all: '20087|20005',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Atchison',
    county_weights: '{"20087": 97.05, "20005": 2.95}',
    density: 8.7,
    imprecise: false,
    latitude: 39.3416,
    longitude: -95.4563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66088',
  },
  {
    city: 'Wathena',
    county_fips: 20043,
    county_fips_all: '20043',
    county: 'Doniphan',
    county_names_all: 'Doniphan',
    county_weights: '{"20043": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 39.78391,
    longitude: -94.97041,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66090',
  },
  {
    city: 'Welda',
    county_fips: 20003,
    county_fips_all: '20003',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"20003": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 38.16952,
    longitude: -95.32701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66091',
  },
  {
    city: 'Wellsville',
    county_fips: 20059,
    county_fips_all: '20059|20121|20045',
    county: 'Franklin',
    county_names_all: 'Franklin|Miami|Douglas',
    county_weights: '{"20059": 64.92, "20121": 20.49, "20045": 14.59}',
    density: 19,
    imprecise: false,
    latitude: 38.69305,
    longitude: -95.10548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66092',
  },
  {
    city: 'Westphalia',
    county_fips: 20003,
    county_fips_all: '20003|20031',
    county: 'Anderson',
    county_names_all: 'Anderson|Coffey',
    county_weights: '{"20003": 60.39, "20031": 39.61}',
    density: 2,
    imprecise: false,
    latitude: 38.21003,
    longitude: -95.49771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66093',
  },
  {
    city: 'White Cloud',
    county_fips: 20013,
    county_fips_all: '20013|20043',
    county: 'Brown',
    county_names_all: 'Brown|Doniphan',
    county_weights: '{"20013": 52.28, "20043": 47.72}',
    density: 3.6,
    imprecise: false,
    latitude: 39.95912,
    longitude: -95.34298,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66094',
  },
  {
    city: 'Williamsburg',
    county_fips: 20059,
    county_fips_all: '20059|20003',
    county: 'Franklin',
    county_names_all: 'Franklin|Anderson',
    county_weights: '{"20059": 92.99, "20003": 7.01}',
    density: 3.2,
    imprecise: false,
    latitude: 38.44631,
    longitude: -95.43015,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66095',
  },
  {
    city: 'Winchester',
    county_fips: 20087,
    county_fips_all: '20087|20103',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Leavenworth',
    county_weights: '{"20087": 95.97, "20103": 4.03}',
    density: 7.7,
    imprecise: false,
    latitude: 39.32966,
    longitude: -95.23992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66097',
  },
  {
    city: 'Kansas City',
    county_fips: 20209,
    county_fips_all: '20209',
    county: 'Wyandotte',
    county_names_all: 'Wyandotte',
    county_weights: '{"20209": 100}',
    density: 1498,
    imprecise: false,
    latitude: 39.11871,
    longitude: -94.62592,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66101',
  },
  {
    city: 'Kansas City',
    county_fips: 20209,
    county_fips_all: '20209',
    county: 'Wyandotte',
    county_names_all: 'Wyandotte',
    county_weights: '{"20209": 100}',
    density: 989.9,
    imprecise: false,
    latitude: 39.11246,
    longitude: -94.68842,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66102',
  },
  {
    city: 'Kansas City',
    county_fips: 20209,
    county_fips_all: '20209',
    county: 'Wyandotte',
    county_names_all: 'Wyandotte',
    county_weights: '{"20209": 100}',
    density: 1053.3,
    imprecise: false,
    latitude: 39.06045,
    longitude: -94.62707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66103',
  },
  {
    city: 'Kansas City',
    county_fips: 20209,
    county_fips_all: '20209',
    county: 'Wyandotte',
    county_names_all: 'Wyandotte',
    county_weights: '{"20209": 100}',
    density: 645.9,
    imprecise: false,
    latitude: 39.15043,
    longitude: -94.68861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66104',
  },
  {
    city: 'Kansas City',
    county_fips: 20209,
    county_fips_all: '20209',
    county: 'Wyandotte',
    county_names_all: 'Wyandotte',
    county_weights: '{"20209": 100}',
    density: 334.9,
    imprecise: false,
    latitude: 39.08593,
    longitude: -94.63646,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66105',
  },
  {
    city: 'Kansas City',
    county_fips: 20209,
    county_fips_all: '20209',
    county: 'Wyandotte',
    county_names_all: 'Wyandotte',
    county_weights: '{"20209": 100}',
    density: 494.2,
    imprecise: false,
    latitude: 39.06631,
    longitude: -94.70384,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66106',
  },
  {
    city: 'Kansas City',
    county_fips: 20209,
    county_fips_all: '20209|20103',
    county: 'Wyandotte',
    county_names_all: 'Wyandotte|Leavenworth',
    county_weights: '{"20209": 93.33, "20103": 6.67}',
    density: 238.8,
    imprecise: false,
    latitude: 39.16367,
    longitude: -94.8283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66109',
  },
  {
    city: 'Kansas City',
    county_fips: 20209,
    county_fips_all: '20209',
    county: 'Wyandotte',
    county_names_all: 'Wyandotte',
    county_weights: '{"20209": 100}',
    density: 166.5,
    imprecise: false,
    latitude: 39.08529,
    longitude: -94.79621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66111',
  },
  {
    city: 'Kansas City',
    county_fips: 20209,
    county_fips_all: '20209',
    county: 'Wyandotte',
    county_names_all: 'Wyandotte',
    county_weights: '{"20209": 100}',
    density: 905.6,
    imprecise: false,
    latitude: 39.11494,
    longitude: -94.7701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66112',
  },
  {
    city: 'Kansas City',
    county_fips: 20209,
    county_fips_all: '20209',
    county: 'Wyandotte',
    county_names_all: 'Wyandotte',
    county_weights: '{"20209": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.14402,
    longitude: -94.61104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66115',
  },
  {
    city: 'Kansas City',
    county_fips: 20209,
    county_fips_all: '20209',
    county: 'Wyandotte',
    county_names_all: 'Wyandotte',
    county_weights: '{"20209": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.09946,
    longitude: -94.61348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66118',
  },
  {
    city: 'Mission',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 1277.1,
    imprecise: false,
    latitude: 39.02392,
    longitude: -94.66909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66202',
  },
  {
    city: 'Shawnee',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 1198.3,
    imprecise: false,
    latitude: 39.0216,
    longitude: -94.70558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66203',
  },
  {
    city: 'Overland Park',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 1399.5,
    imprecise: false,
    latitude: 38.99282,
    longitude: -94.67741,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66204',
  },
  {
    city: 'Mission',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 1451.4,
    imprecise: false,
    latitude: 39.03122,
    longitude: -94.6307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66205',
  },
  {
    city: 'Leawood',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 1162.6,
    imprecise: false,
    latitude: 38.95851,
    longitude: -94.61923,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66206',
  },
  {
    city: 'Overland Park',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 1329.4,
    imprecise: false,
    latitude: 38.95625,
    longitude: -94.64439,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66207',
  },
  {
    city: 'Prairie Village',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 1281.5,
    imprecise: false,
    latitude: 38.99936,
    longitude: -94.62998,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66208',
  },
  {
    city: 'Leawood',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 1221.6,
    imprecise: false,
    latitude: 38.89874,
    longitude: -94.63778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66209',
  },
  {
    city: 'Overland Park',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 1298.1,
    imprecise: false,
    latitude: 38.92372,
    longitude: -94.70483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66210',
  },
  {
    city: 'Leawood',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 520.1,
    imprecise: false,
    latitude: 38.92422,
    longitude: -94.6363,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66211',
  },
  {
    city: 'Overland Park',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 1672.3,
    imprecise: false,
    latitude: 38.9563,
    longitude: -94.68154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66212',
  },
  {
    city: 'Overland Park',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 1508.5,
    imprecise: false,
    latitude: 38.89885,
    longitude: -94.70517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66213',
  },
  {
    city: 'Overland Park',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 1237.4,
    imprecise: false,
    latitude: 38.96356,
    longitude: -94.71397,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66214',
  },
  {
    city: 'Lenexa',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 1233.3,
    imprecise: false,
    latitude: 38.95649,
    longitude: -94.74304,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66215',
  },
  {
    city: 'Shawnee',
    county_fips: 20091,
    county_fips_all: '20091|20209',
    county: 'Johnson',
    county_names_all: 'Johnson|Wyandotte',
    county_weights: '{"20091": 99.73, "20209": 0.27}',
    density: 1216.8,
    imprecise: false,
    latitude: 39.01405,
    longitude: -94.74136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66216',
  },
  {
    city: 'Shawnee',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 280.3,
    imprecise: false,
    latitude: 39.01148,
    longitude: -94.77741,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66217',
  },
  {
    city: 'Shawnee',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 324.9,
    imprecise: false,
    latitude: 39.01239,
    longitude: -94.81647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66218',
  },
  {
    city: 'Lenexa',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 630.4,
    imprecise: false,
    latitude: 38.95124,
    longitude: -94.77807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66219',
  },
  {
    city: 'Lenexa',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 516.6,
    imprecise: false,
    latitude: 38.96187,
    longitude: -94.8218,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66220',
  },
  {
    city: 'Overland Park',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 812.9,
    imprecise: false,
    latitude: 38.84786,
    longitude: -94.71437,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66221',
  },
  {
    city: 'Overland Park',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 1530.1,
    imprecise: false,
    latitude: 38.86176,
    longitude: -94.66831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66223',
  },
  {
    city: 'Overland Park',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 734.6,
    imprecise: false,
    latitude: 38.86213,
    longitude: -94.62866,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66224',
  },
  {
    city: 'Shawnee',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 543.3,
    imprecise: false,
    latitude: 39.03039,
    longitude: -94.8603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66226',
  },
  {
    city: 'Lenexa',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 278,
    imprecise: false,
    latitude: 38.97248,
    longitude: -94.87446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66227',
  },
  {
    city: 'Alma',
    county_fips: 20197,
    county_fips_all: '20197',
    county: 'Wabaunsee',
    county_names_all: 'Wabaunsee',
    county_weights: '{"20197": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 38.96894,
    longitude: -96.30539,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66401',
  },
  {
    city: 'Auburn',
    county_fips: 20177,
    county_fips_all: '20177|20139',
    county: 'Shawnee',
    county_names_all: 'Shawnee|Osage',
    county_weights: '{"20177": 97.27, "20139": 2.73}',
    density: 26.7,
    imprecise: false,
    latitude: 38.91782,
    longitude: -95.84926,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66402',
  },
  {
    city: 'Axtell',
    county_fips: 20117,
    county_fips_all: '20117|20131',
    county: 'Marshall',
    county_names_all: 'Marshall|Nemaha',
    county_weights: '{"20117": 75.25, "20131": 24.75}',
    density: 3.5,
    imprecise: false,
    latitude: 39.89424,
    longitude: -96.27166,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66403',
  },
  {
    city: 'Baileyville',
    county_fips: 20131,
    county_fips_all: '20131|20117',
    county: 'Nemaha',
    county_names_all: 'Nemaha|Marshall',
    county_weights: '{"20131": 98.09, "20117": 1.91}',
    density: 3,
    imprecise: false,
    latitude: 39.86786,
    longitude: -96.17804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66404',
  },
  {
    city: 'Beattie',
    county_fips: 20117,
    county_fips_all: '20117',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"20117": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 39.8927,
    longitude: -96.42014,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66406',
  },
  {
    city: 'Belvue',
    county_fips: 20149,
    county_fips_all: '20149|20197',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie|Wabaunsee',
    county_weights: '{"20149": 59.05, "20197": 40.95}',
    density: 2,
    imprecise: false,
    latitude: 39.22517,
    longitude: -96.19218,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66407',
  },
  {
    city: 'Bern',
    county_fips: 20131,
    county_fips_all: '20131',
    county: 'Nemaha',
    county_names_all: 'Nemaha',
    county_weights: '{"20131": 100}',
    density: 3,
    imprecise: false,
    latitude: 39.95306,
    longitude: -95.97607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66408',
  },
  {
    city: 'Berryton',
    county_fips: 20177,
    county_fips_all: '20177|20045|20139',
    county: 'Shawnee',
    county_names_all: 'Shawnee|Douglas|Osage',
    county_weights: '{"20177": 73.56, "20045": 24.19, "20139": 2.25}',
    density: 17.4,
    imprecise: false,
    latitude: 38.92508,
    longitude: -95.55589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66409',
  },
  {
    city: 'Blue Rapids',
    county_fips: 20117,
    county_fips_all: '20117|20161',
    county: 'Marshall',
    county_names_all: 'Marshall|Riley',
    county_weights: '{"20117": 83.92, "20161": 16.08}',
    density: 3.8,
    imprecise: false,
    latitude: 39.64083,
    longitude: -96.63948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66411',
  },
  {
    city: 'Bremen',
    county_fips: 20117,
    county_fips_all: '20117|20201',
    county: 'Marshall',
    county_names_all: 'Marshall|Washington',
    county_weights: '{"20117": 83.61, "20201": 16.39}',
    density: 4.9,
    imprecise: false,
    latitude: 39.90837,
    longitude: -96.77794,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66412',
  },
  {
    city: 'Burlingame',
    county_fips: 20139,
    county_fips_all: '20139|20111|20197',
    county: 'Osage',
    county_names_all: 'Osage|Lyon|Wabaunsee',
    county_weights: '{"20139": 88.32, "20111": 8.05, "20197": 3.63}',
    density: 6.5,
    imprecise: false,
    latitude: 38.77375,
    longitude: -95.88305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66413',
  },
  {
    city: 'Carbondale',
    county_fips: 20139,
    county_fips_all: '20139',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"20139": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 38.82631,
    longitude: -95.68563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66414',
  },
  {
    city: 'Centralia',
    county_fips: 20131,
    county_fips_all: '20131',
    county: 'Nemaha',
    county_names_all: 'Nemaha',
    county_weights: '{"20131": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 39.69193,
    longitude: -96.14381,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66415',
  },
  {
    city: 'Circleville',
    county_fips: 20085,
    county_fips_all: '20085|20131',
    county: 'Jackson',
    county_names_all: 'Jackson|Nemaha',
    county_weights: '{"20085": 90.73, "20131": 9.27}',
    density: 5.8,
    imprecise: false,
    latitude: 39.52944,
    longitude: -95.86353,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66416',
  },
  {
    city: 'Corning',
    county_fips: 20131,
    county_fips_all: '20131',
    county: 'Nemaha',
    county_names_all: 'Nemaha',
    county_weights: '{"20131": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 39.65524,
    longitude: -96.03824,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66417',
  },
  {
    city: 'Delia',
    county_fips: 20085,
    county_fips_all: '20085',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"20085": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 39.28861,
    longitude: -95.93528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66418',
  },
  {
    city: 'Denison',
    county_fips: 20085,
    county_fips_all: '20085|20087',
    county: 'Jackson',
    county_names_all: 'Jackson|Jefferson',
    county_weights: '{"20085": 69.69, "20087": 30.31}',
    density: 11.5,
    imprecise: false,
    latitude: 39.35643,
    longitude: -95.59908,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66419',
  },
  {
    city: 'Emmett',
    county_fips: 20149,
    county_fips_all: '20149|20085',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie|Jackson',
    county_weights: '{"20149": 77.2, "20085": 22.8}',
    density: 8.5,
    imprecise: false,
    latitude: 39.33317,
    longitude: -96.08496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66422',
  },
  {
    city: 'Eskridge',
    county_fips: 20197,
    county_fips_all: '20197',
    county: 'Wabaunsee',
    county_names_all: 'Wabaunsee',
    county_weights: '{"20197": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 38.8492,
    longitude: -96.12934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66423',
  },
  {
    city: 'Everest',
    county_fips: 20013,
    county_fips_all: '20013|20005',
    county: 'Brown',
    county_names_all: 'Brown|Atchison',
    county_weights: '{"20013": 68.14, "20005": 31.86}',
    density: 3.6,
    imprecise: false,
    latitude: 39.67789,
    longitude: -95.40072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66424',
  },
  {
    city: 'Fairview',
    county_fips: 20013,
    county_fips_all: '20013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"20013": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 39.81099,
    longitude: -95.72225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66425',
  },
  {
    city: 'Frankfort',
    county_fips: 20117,
    county_fips_all: '20117|20149',
    county: 'Marshall',
    county_names_all: 'Marshall|Pottawatomie',
    county_weights: '{"20117": 89.85, "20149": 10.15}',
    density: 2.4,
    imprecise: false,
    latitude: 39.66261,
    longitude: -96.449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66427',
  },
  {
    city: 'Goff',
    county_fips: 20131,
    county_fips_all: '20131',
    county: 'Nemaha',
    county_names_all: 'Nemaha',
    county_weights: '{"20131": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 39.67687,
    longitude: -95.92504,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66428',
  },
  {
    city: 'Grantville',
    county_fips: 20087,
    county_fips_all: '20087',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"20087": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 39.0989,
    longitude: -95.53725,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66429',
  },
  {
    city: 'Harveyville',
    county_fips: 20197,
    county_fips_all: '20197|20177',
    county: 'Wabaunsee',
    county_names_all: 'Wabaunsee|Shawnee',
    county_weights: '{"20197": 91.65, "20177": 8.35}',
    density: 4.6,
    imprecise: false,
    latitude: 38.80851,
    longitude: -96.00241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66431',
  },
  {
    city: 'Havensville',
    county_fips: 20149,
    county_fips_all: '20149|20085|20131',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie|Jackson|Nemaha',
    county_weights: '{"20149": 76.9, "20085": 11.84, "20131": 11.26}',
    density: 3,
    imprecise: false,
    latitude: 39.48768,
    longitude: -96.07348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66432',
  },
  {
    city: 'Hiawatha',
    county_fips: 20013,
    county_fips_all: '20013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"20013": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 39.86731,
    longitude: -95.54679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66434',
  },
  {
    city: 'Holton',
    county_fips: 20085,
    county_fips_all: '20085|20005|20087',
    county: 'Jackson',
    county_names_all: 'Jackson|Atchison|Jefferson',
    county_weights: '{"20085": 84.87, "20005": 13.76, "20087": 1.37}',
    density: 11.6,
    imprecise: false,
    latitude: 39.4655,
    longitude: -95.70278,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66436',
  },
  {
    city: 'Home',
    county_fips: 20117,
    county_fips_all: '20117',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"20117": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 39.83335,
    longitude: -96.50165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66438',
  },
  {
    city: 'Horton',
    county_fips: 20013,
    county_fips_all: '20013|20005|20085',
    county: 'Brown',
    county_names_all: 'Brown|Atchison|Jackson',
    county_weights: '{"20013": 57.77, "20005": 38.5, "20085": 3.73}',
    density: 11.4,
    imprecise: false,
    latitude: 39.65518,
    longitude: -95.54327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66439',
  },
  {
    city: 'Hoyt',
    county_fips: 20085,
    county_fips_all: '20085',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"20085": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 39.26326,
    longitude: -95.68168,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66440',
  },
  {
    city: 'Junction City',
    county_fips: 20061,
    county_fips_all: '20061|20041|20161',
    county: 'Geary',
    county_names_all: 'Geary|Dickinson|Riley',
    county_weights: '{"20061": 93.83, "20041": 4.74, "20161": 1.43}',
    density: 43,
    imprecise: false,
    latitude: 38.98199,
    longitude: -96.80289,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66441',
  },
  {
    city: 'Fort Riley',
    county_fips: 20161,
    county_fips_all: '20161|20061',
    county: 'Riley',
    county_names_all: 'Riley|Geary',
    county_weights: '{"20161": 60.48, "20061": 39.52}',
    density: 191.9,
    imprecise: false,
    latitude: 39.09302,
    longitude: -96.78963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66442',
  },
  {
    city: 'Leonardville',
    county_fips: 20161,
    county_fips_all: '20161',
    county: 'Riley',
    county_names_all: 'Riley',
    county_weights: '{"20161": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 39.38833,
    longitude: -96.86007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66449',
  },
  {
    city: 'Lyndon',
    county_fips: 20139,
    county_fips_all: '20139',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"20139": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 38.60841,
    longitude: -95.67236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66451',
  },
  {
    city: 'McFarland',
    county_fips: 20197,
    county_fips_all: '20197',
    county: 'Wabaunsee',
    county_names_all: 'Wabaunsee',
    county_weights: '{"20197": 100}',
    density: 402.5,
    imprecise: false,
    latitude: 39.05279,
    longitude: -96.23688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66501',
  },
  {
    city: 'Manhattan',
    county_fips: 20161,
    county_fips_all: '20161|20149|20061|20197',
    county: 'Riley',
    county_names_all: 'Riley|Pottawatomie|Geary|Wabaunsee',
    county_weights:
      '{"20161": 60.13, "20149": 20.73, "20061": 15.37, "20197": 3.77}',
    density: 76.1,
    imprecise: false,
    latitude: 39.14146,
    longitude: -96.52906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66502',
  },
  {
    city: 'Manhattan',
    county_fips: 20161,
    county_fips_all: '20161|20149',
    county: 'Riley',
    county_names_all: 'Riley|Pottawatomie',
    county_weights: '{"20161": 99.77, "20149": 0.23}',
    density: 80.2,
    imprecise: false,
    latitude: 39.26287,
    longitude: -96.68663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66503',
  },
  {
    city: 'Maple Hill',
    county_fips: 20197,
    county_fips_all: '20197',
    county: 'Wabaunsee',
    county_names_all: 'Wabaunsee',
    county_weights: '{"20197": 100}',
    density: 6,
    imprecise: false,
    latitude: 39.04712,
    longitude: -96.03942,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66507',
  },
  {
    city: 'Marysville',
    county_fips: 20117,
    county_fips_all: '20117',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"20117": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 39.85803,
    longitude: -96.64287,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3987,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66508',
  },
  {
    city: 'Mayetta',
    county_fips: 20085,
    county_fips_all: '20085',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"20085": 100}',
    density: 6,
    imprecise: false,
    latitude: 39.33239,
    longitude: -95.78097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66509',
  },
  {
    city: 'Melvern',
    county_fips: 20139,
    county_fips_all: '20139',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"20139": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 38.49297,
    longitude: -95.6104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66510',
  },
  {
    city: 'Meriden',
    county_fips: 20087,
    county_fips_all: '20087|20085|20177',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Jackson|Shawnee',
    county_weights: '{"20087": 84.11, "20085": 11.12, "20177": 4.77}',
    density: 21.3,
    imprecise: false,
    latitude: 39.20255,
    longitude: -95.54701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66512',
  },
  {
    city: 'Milford',
    county_fips: 20061,
    county_fips_all: '20061',
    county: 'Geary',
    county_names_all: 'Geary',
    county_weights: '{"20061": 100}',
    density: 31,
    imprecise: false,
    latitude: 39.12635,
    longitude: -96.87826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66514',
  },
  {
    city: 'Morrill',
    county_fips: 20013,
    county_fips_all: '20013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"20013": 100}',
    density: 4,
    imprecise: false,
    latitude: 39.94181,
    longitude: -95.70681,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66515',
  },
  {
    city: 'Netawaka',
    county_fips: 20085,
    county_fips_all: '20085|20013',
    county: 'Jackson',
    county_names_all: 'Jackson|Brown',
    county_weights: '{"20085": 70.37, "20013": 29.63}',
    density: 3.2,
    imprecise: false,
    latitude: 39.62193,
    longitude: -95.7195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66516',
  },
  {
    city: 'Ogden',
    county_fips: 20161,
    county_fips_all: '20161',
    county: 'Riley',
    county_names_all: 'Riley',
    county_weights: '{"20161": 100}',
    density: 357.6,
    imprecise: false,
    latitude: 39.11253,
    longitude: -96.70465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66517',
  },
  {
    city: 'Oketo',
    county_fips: 20117,
    county_fips_all: '20117',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"20117": 100}',
    density: 2,
    imprecise: false,
    latitude: 39.97008,
    longitude: -96.55533,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66518',
  },
  {
    city: 'Olsburg',
    county_fips: 20149,
    county_fips_all: '20149|20161',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie|Riley',
    county_weights: '{"20149": 99.74, "20161": 0.26}',
    density: 2.3,
    imprecise: false,
    latitude: 39.40963,
    longitude: -96.61617,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66520',
  },
  {
    city: 'Onaga',
    county_fips: 20149,
    county_fips_all: '20149|20131',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie|Nemaha',
    county_weights: '{"20149": 91.59, "20131": 8.41}',
    density: 3.1,
    imprecise: false,
    latitude: 39.47668,
    longitude: -96.22128,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66521',
  },
  {
    city: 'Oneida',
    county_fips: 20131,
    county_fips_all: '20131',
    county: 'Nemaha',
    county_names_all: 'Nemaha',
    county_weights: '{"20131": 100}',
    density: 388.4,
    imprecise: false,
    latitude: 39.86609,
    longitude: -95.93826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66522',
  },
  {
    city: 'Osage City',
    county_fips: 20139,
    county_fips_all: '20139|20111',
    county: 'Osage',
    county_names_all: 'Osage|Lyon',
    county_weights: '{"20139": 96.27, "20111": 3.73}',
    density: 9.9,
    imprecise: false,
    latitude: 38.60993,
    longitude: -95.83791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66523',
  },
  {
    city: 'Overbrook',
    county_fips: 20139,
    county_fips_all: '20139|20045|20177|20059',
    county: 'Osage',
    county_names_all: 'Osage|Douglas|Shawnee|Franklin',
    county_weights:
      '{"20139": 50.49, "20045": 44.17, "20177": 3.05, "20059": 2.29}',
    density: 7.3,
    imprecise: false,
    latitude: 38.78948,
    longitude: -95.50695,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66524',
  },
  {
    city: 'Paxico',
    county_fips: 20197,
    county_fips_all: '20197',
    county: 'Wabaunsee',
    county_names_all: 'Wabaunsee',
    county_weights: '{"20197": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 39.06349,
    longitude: -96.15567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66526',
  },
  {
    city: 'Powhattan',
    county_fips: 20013,
    county_fips_all: '20013',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"20013": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 39.74499,
    longitude: -95.67744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66527',
  },
  {
    city: 'Quenemo',
    county_fips: 20139,
    county_fips_all: '20139|20059',
    county: 'Osage',
    county_names_all: 'Osage|Franklin',
    county_weights: '{"20139": 82.01, "20059": 17.99}',
    density: 4.4,
    imprecise: false,
    latitude: 38.59711,
    longitude: -95.5344,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66528',
  },
  {
    city: 'Riley',
    county_fips: 20161,
    county_fips_all: '20161',
    county: 'Riley',
    county_names_all: 'Riley',
    county_weights: '{"20161": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 39.31146,
    longitude: -96.83416,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66531',
  },
  {
    city: 'Robinson',
    county_fips: 20013,
    county_fips_all: '20013|20043',
    county: 'Brown',
    county_names_all: 'Brown|Doniphan',
    county_weights: '{"20013": 78.6, "20043": 21.4}',
    density: 2.4,
    imprecise: false,
    latitude: 39.82656,
    longitude: -95.37597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66532',
  },
  {
    city: 'Rossville',
    county_fips: 20177,
    county_fips_all: '20177|20085',
    county: 'Shawnee',
    county_names_all: 'Shawnee|Jackson',
    county_weights: '{"20177": 96.2, "20085": 3.8}',
    density: 11.5,
    imprecise: false,
    latitude: 39.16097,
    longitude: -95.95045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66533',
  },
  {
    city: 'Sabetha',
    county_fips: 20131,
    county_fips_all: '20131|20013',
    county: 'Nemaha',
    county_names_all: 'Nemaha|Brown',
    county_weights: '{"20131": 80.0, "20013": 20.0}',
    density: 8.9,
    imprecise: false,
    latitude: 39.87782,
    longitude: -95.83635,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66534',
  },
  {
    city: 'Saint George',
    county_fips: 20149,
    county_fips_all: '20149',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie',
    county_weights: '{"20149": 100}',
    density: 32.9,
    imprecise: false,
    latitude: 39.26169,
    longitude: -96.43896,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66535',
  },
  {
    city: 'Saint Marys',
    county_fips: 20149,
    county_fips_all: '20149|20177|20085|20197',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie|Shawnee|Jackson|Wabaunsee',
    county_weights:
      '{"20149": 74.1, "20177": 10.36, "20085": 8.26, "20197": 7.28}',
    density: 24.8,
    imprecise: false,
    latitude: 39.2247,
    longitude: -96.07396,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66536',
  },
  {
    city: 'Scranton',
    county_fips: 20139,
    county_fips_all: '20139',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"20139": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 38.75118,
    longitude: -95.72255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66537',
  },
  {
    city: 'Seneca',
    county_fips: 20131,
    county_fips_all: '20131',
    county: 'Nemaha',
    county_names_all: 'Nemaha',
    county_weights: '{"20131": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 39.84942,
    longitude: -96.04591,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66538',
  },
  {
    city: 'Silver Lake',
    county_fips: 20177,
    county_fips_all: '20177|20085',
    county: 'Shawnee',
    county_names_all: 'Shawnee|Jackson',
    county_weights: '{"20177": 96.39, "20085": 3.61}',
    density: 28.8,
    imprecise: false,
    latitude: 39.14937,
    longitude: -95.84707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66539',
  },
  {
    city: 'Soldier',
    county_fips: 20085,
    county_fips_all: '20085|20131|20149',
    county: 'Jackson',
    county_names_all: 'Jackson|Nemaha|Pottawatomie',
    county_weights: '{"20085": 86.8, "20131": 12.64, "20149": 0.56}',
    density: 2.5,
    imprecise: false,
    latitude: 39.48484,
    longitude: -95.97332,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66540',
  },
  {
    city: 'Summerfield',
    county_fips: 20117,
    county_fips_all: '20117|31133',
    county: 'Marshall',
    county_names_all: 'Marshall|Pawnee',
    county_weights: '{"20117": 71.72, "31133": 28.28}',
    density: 1.8,
    imprecise: false,
    latitude: 39.97891,
    longitude: -96.34781,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66541',
  },
  {
    city: 'Tecumseh',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 35.9,
    imprecise: false,
    latitude: 39.01273,
    longitude: -95.54442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66542',
  },
  {
    city: 'Vassar',
    county_fips: 20139,
    county_fips_all: '20139',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"20139": 100}',
    density: 42.7,
    imprecise: false,
    latitude: 38.64175,
    longitude: -95.60029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66543',
  },
  {
    city: 'Vermillion',
    county_fips: 20117,
    county_fips_all: '20117|20131',
    county: 'Marshall',
    county_names_all: 'Marshall|Nemaha',
    county_weights: '{"20117": 84.03, "20131": 15.97}',
    density: 1.2,
    imprecise: false,
    latitude: 39.68807,
    longitude: -96.27783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66544',
  },
  {
    city: 'Wakarusa',
    county_fips: 20177,
    county_fips_all: '20177|20139',
    county: 'Shawnee',
    county_names_all: 'Shawnee|Osage',
    county_weights: '{"20177": 91.4, "20139": 8.6}',
    density: 11.5,
    imprecise: false,
    latitude: 38.8941,
    longitude: -95.72589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66546',
  },
  {
    city: 'Wamego',
    county_fips: 20149,
    county_fips_all: '20149|20197',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie|Wabaunsee',
    county_weights: '{"20149": 77.06, "20197": 22.94}',
    density: 24.9,
    imprecise: false,
    latitude: 39.23469,
    longitude: -96.30384,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66547',
  },
  {
    city: 'Waterville',
    county_fips: 20117,
    county_fips_all: '20117|20201|20161',
    county: 'Marshall',
    county_names_all: 'Marshall|Washington|Riley',
    county_weights: '{"20117": 95.17, "20201": 2.49, "20161": 2.34}',
    density: 4.7,
    imprecise: false,
    latitude: 39.67551,
    longitude: -96.76146,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66548',
  },
  {
    city: 'Westmoreland',
    county_fips: 20149,
    county_fips_all: '20149',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie',
    county_weights: '{"20149": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 39.42978,
    longitude: -96.43045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66549',
  },
  {
    city: 'Wetmore',
    county_fips: 20131,
    county_fips_all: '20131|20085|20013',
    county: 'Nemaha',
    county_names_all: 'Nemaha|Jackson|Brown',
    county_weights: '{"20131": 78.75, "20085": 10.93, "20013": 10.32}',
    density: 3.2,
    imprecise: false,
    latitude: 39.65537,
    longitude: -95.82113,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66550',
  },
  {
    city: 'Whiting',
    county_fips: 20085,
    county_fips_all: '20085',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"20085": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 39.58736,
    longitude: -95.621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66552',
  },
  {
    city: 'Randolph',
    county_fips: 20161,
    county_fips_all: '20161',
    county: 'Riley',
    county_names_all: 'Riley',
    county_weights: '{"20161": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 39.48899,
    longitude: -96.78445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66554',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 790.1,
    imprecise: false,
    latitude: 39.05742,
    longitude: -95.67539,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66603',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 1314.2,
    imprecise: false,
    latitude: 39.03875,
    longitude: -95.72623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66604',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 806.5,
    imprecise: false,
    latitude: 39.01167,
    longitude: -95.63283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66605',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 659.5,
    imprecise: false,
    latitude: 39.06191,
    longitude: -95.72296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66606',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 550.9,
    imprecise: false,
    latitude: 39.0422,
    longitude: -95.63502,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66607',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 374.4,
    imprecise: false,
    latitude: 39.07984,
    longitude: -95.66708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66608',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 233.1,
    imprecise: false,
    latitude: 38.98193,
    longitude: -95.66974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66609',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177|20197',
    county: 'Shawnee',
    county_names_all: 'Shawnee|Wabaunsee',
    county_weights: '{"20177": 92.35, "20197": 7.65}',
    density: 86.3,
    imprecise: false,
    latitude: 38.97277,
    longitude: -95.84718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66610',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 1147.8,
    imprecise: false,
    latitude: 39.01526,
    longitude: -95.69601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66611',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 636,
    imprecise: false,
    latitude: 39.04026,
    longitude: -95.68037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66612',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177|20197',
    county: 'Shawnee',
    county_names_all: 'Shawnee|Wabaunsee',
    county_weights: '{"20177": 83.86, "20197": 16.14}',
    density: 522.1,
    imprecise: false,
    latitude: 39.01362,
    longitude: -95.84115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66614',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177|20197',
    county: 'Shawnee',
    county_names_all: 'Shawnee|Wabaunsee',
    county_weights: '{"20177": 77.98, "20197": 22.02}',
    density: 25.3,
    imprecise: false,
    latitude: 39.05214,
    longitude: -95.89491,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66615',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 392.2,
    imprecise: false,
    latitude: 39.06845,
    longitude: -95.62388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66616',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177|20087|20085',
    county: 'Shawnee',
    county_names_all: 'Shawnee|Jefferson|Jackson',
    county_weights: '{"20177": 81.73, "20087": 17.09, "20085": 1.18}',
    density: 79.3,
    imprecise: false,
    latitude: 39.13876,
    longitude: -95.625,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66617',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 54,
    imprecise: false,
    latitude: 39.14188,
    longitude: -95.74997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66618',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 146.6,
    imprecise: false,
    latitude: 38.94661,
    longitude: -95.68993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66619',
  },
  {
    city: 'Fort Scott',
    county_fips: 20011,
    county_fips_all: '20011|20037',
    county: 'Bourbon',
    county_names_all: 'Bourbon|Crawford',
    county_weights: '{"20011": 97.78, "20037": 2.22}',
    density: 15.5,
    imprecise: false,
    latitude: 37.82862,
    longitude: -94.75999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66701',
  },
  {
    city: 'Altoona',
    county_fips: 20205,
    county_fips_all: '20205',
    county: 'Wilson',
    county_names_all: 'Wilson',
    county_weights: '{"20205": 100}',
    density: 5,
    imprecise: false,
    latitude: 37.55301,
    longitude: -95.63104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66710',
  },
  {
    city: 'Arcadia',
    county_fips: 20037,
    county_fips_all: '20037|20011',
    county: 'Crawford',
    county_names_all: 'Crawford|Bourbon',
    county_weights: '{"20037": 88.53, "20011": 11.47}',
    density: 3.5,
    imprecise: false,
    latitude: 37.63974,
    longitude: -94.691,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66711',
  },
  {
    city: 'Arma',
    county_fips: 20037,
    county_fips_all: '20037',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"20037": 100}',
    density: 29,
    imprecise: false,
    latitude: 37.5636,
    longitude: -94.71657,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66712',
  },
  {
    city: 'Baxter Springs',
    county_fips: 20021,
    county_fips_all: '20021',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"20021": 100}',
    density: 36.9,
    imprecise: false,
    latitude: 37.03323,
    longitude: -94.78637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66713',
  },
  {
    city: 'Benedict',
    county_fips: 20205,
    county_fips_all: '20205',
    county: 'Wilson',
    county_names_all: 'Wilson',
    county_weights: '{"20205": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 37.63369,
    longitude: -95.70484,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66714',
  },
  {
    city: 'Bronson',
    county_fips: 20011,
    county_fips_all: '20011|20001',
    county: 'Bourbon',
    county_names_all: 'Bourbon|Allen',
    county_weights: '{"20011": 83.33, "20001": 16.67}',
    density: 3.8,
    imprecise: false,
    latitude: 37.93923,
    longitude: -95.04001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66716',
  },
  {
    city: 'Buffalo',
    county_fips: 20205,
    county_fips_all: '20205|20207',
    county: 'Wilson',
    county_names_all: 'Wilson|Woodson',
    county_weights: '{"20205": 99.39, "20207": 0.61}',
    density: 4.1,
    imprecise: false,
    latitude: 37.69671,
    longitude: -95.68672,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66717',
  },
  {
    city: 'Chanute',
    county_fips: 20133,
    county_fips_all: '20133|20205|20001|20207',
    county: 'Neosho',
    county_names_all: 'Neosho|Wilson|Allen|Woodson',
    county_weights:
      '{"20133": 71.58, "20205": 24.14, "20001": 3.03, "20207": 1.25}',
    density: 20.7,
    imprecise: false,
    latitude: 37.64631,
    longitude: -95.459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66720',
  },
  {
    city: 'Cherokee',
    county_fips: 20037,
    county_fips_all: '20037|20021',
    county: 'Crawford',
    county_names_all: 'Crawford|Cherokee',
    county_weights: '{"20037": 63.11, "20021": 36.89}',
    density: 10.3,
    imprecise: false,
    latitude: 37.34891,
    longitude: -94.86333,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66724',
  },
  {
    city: 'Columbus',
    county_fips: 20021,
    county_fips_all: '20021',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"20021": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 37.15906,
    longitude: -94.88892,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66725',
  },
  {
    city: 'Elsmore',
    county_fips: 20001,
    county_fips_all: '20001',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"20001": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 37.80097,
    longitude: -95.1947,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66732',
  },
  {
    city: 'Erie',
    county_fips: 20133,
    county_fips_all: '20133',
    county: 'Neosho',
    county_names_all: 'Neosho',
    county_weights: '{"20133": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 37.59014,
    longitude: -95.25282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66733',
  },
  {
    city: 'Farlington',
    county_fips: 20037,
    county_fips_all: '20037',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"20037": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 37.61534,
    longitude: -94.82172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66734',
  },
  {
    city: 'Franklin',
    county_fips: 20037,
    county_fips_all: '20037',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"20037": 100}',
    density: 58.1,
    imprecise: false,
    latitude: 37.52091,
    longitude: -94.71313,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66735',
  },
  {
    city: 'Fredonia',
    county_fips: 20205,
    county_fips_all: '20205|20049|20207|20073|20125',
    county: 'Wilson',
    county_names_all: 'Wilson|Elk|Woodson|Greenwood|Montgomery',
    county_weights:
      '{"20205": 88.16, "20049": 9.95, "20207": 0.82, "20073": 0.54, "20125": 0.53}',
    density: 4.7,
    imprecise: false,
    latitude: 37.55335,
    longitude: -95.86381,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66736',
  },
  {
    city: 'Fulton',
    county_fips: 20011,
    county_fips_all: '20011|20107',
    county: 'Bourbon',
    county_names_all: 'Bourbon|Linn',
    county_weights: '{"20011": 85.93, "20107": 14.07}',
    density: 1.6,
    imprecise: false,
    latitude: 38.01473,
    longitude: -94.7162,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66738',
  },
  {
    city: 'Galena',
    county_fips: 20021,
    county_fips_all: '20021',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"20021": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 37.12084,
    longitude: -94.66595,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66739',
  },
  {
    city: 'Galesburg',
    county_fips: 20133,
    county_fips_all: '20133',
    county: 'Neosho',
    county_names_all: 'Neosho',
    county_weights: '{"20133": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 37.4621,
    longitude: -95.36641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66740',
  },
  {
    city: 'Garland',
    county_fips: 20011,
    county_fips_all: '20011',
    county: 'Bourbon',
    county_names_all: 'Bourbon',
    county_weights: '{"20011": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 37.71745,
    longitude: -94.66467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66741',
  },
  {
    city: 'Gas',
    county_fips: 20001,
    county_fips_all: '20001',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"20001": 100}',
    density: 123.5,
    imprecise: false,
    latitude: 37.92023,
    longitude: -95.34755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66742',
  },
  {
    city: 'Girard',
    county_fips: 20037,
    county_fips_all: '20037',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"20037": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 37.50551,
    longitude: -94.88786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66743',
  },
  {
    city: 'Hepler',
    county_fips: 20037,
    county_fips_all: '20037|20011',
    county: 'Crawford',
    county_names_all: 'Crawford|Bourbon',
    county_weights: '{"20037": 57.07, "20011": 42.93}',
    density: 1.8,
    imprecise: false,
    latitude: 37.6708,
    longitude: -94.95317,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66746',
  },
  {
    city: 'Humboldt',
    county_fips: 20001,
    county_fips_all: '20001|20207|20133',
    county: 'Allen',
    county_names_all: 'Allen|Woodson|Neosho',
    county_weights: '{"20001": 81.48, "20207": 15.59, "20133": 2.93}',
    density: 9.5,
    imprecise: false,
    latitude: 37.79882,
    longitude: -95.43577,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66748',
  },
  {
    city: 'Iola',
    county_fips: 20001,
    county_fips_all: '20001',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"20001": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 37.93597,
    longitude: -95.41069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66749',
  },
  {
    city: 'La Harpe',
    county_fips: 20001,
    county_fips_all: '20001',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"20001": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 37.93421,
    longitude: -95.28466,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66751',
  },
  {
    city: 'McCune',
    county_fips: 20037,
    county_fips_all: '20037|20021|20099|20133',
    county: 'Crawford',
    county_names_all: 'Crawford|Cherokee|Labette|Neosho',
    county_weights:
      '{"20037": 54.24, "20021": 35.38, "20099": 7.83, "20133": 2.55}',
    density: 2.6,
    imprecise: false,
    latitude: 37.36529,
    longitude: -95.01444,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66753',
  },
  {
    city: 'Mapleton',
    county_fips: 20011,
    county_fips_all: '20011|20107',
    county: 'Bourbon',
    county_names_all: 'Bourbon|Linn',
    county_weights: '{"20011": 92.53, "20107": 7.47}',
    density: 2.8,
    imprecise: false,
    latitude: 38.00377,
    longitude: -94.88848,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66754',
  },
  {
    city: 'Moran',
    county_fips: 20001,
    county_fips_all: '20001|20011',
    county: 'Allen',
    county_names_all: 'Allen|Bourbon',
    county_weights: '{"20001": 93.65, "20011": 6.35}',
    density: 2.7,
    imprecise: false,
    latitude: 37.91211,
    longitude: -95.16727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66755',
  },
  {
    city: 'Mulberry',
    county_fips: 20037,
    county_fips_all: '20037',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"20037": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 37.53928,
    longitude: -94.64869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66756',
  },
  {
    city: 'Neodesha',
    county_fips: 20205,
    county_fips_all: '20205|20125',
    county: 'Wilson',
    county_names_all: 'Wilson|Montgomery',
    county_weights: '{"20205": 75.94, "20125": 24.06}',
    density: 11.3,
    imprecise: false,
    latitude: 37.41602,
    longitude: -95.69874,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66757',
  },
  {
    city: 'Neosho Falls',
    county_fips: 20207,
    county_fips_all: '20207|20031|20003|20001',
    county: 'Woodson',
    county_names_all: 'Woodson|Coffey|Anderson|Allen',
    county_weights:
      '{"20207": 71.34, "20031": 16.42, "20003": 6.39, "20001": 5.85}',
    density: 1.8,
    imprecise: false,
    latitude: 38.01862,
    longitude: -95.59602,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66758',
  },
  {
    city: 'Opolis',
    county_fips: 20037,
    county_fips_all: '20037|20021',
    county: 'Crawford',
    county_names_all: 'Crawford|Cherokee',
    county_weights: '{"20037": 99.82, "20021": 0.18}',
    density: 19.7,
    imprecise: false,
    latitude: 37.34487,
    longitude: -94.6245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66760',
  },
  {
    city: 'Piqua',
    county_fips: 20207,
    county_fips_all: '20207',
    county: 'Woodson',
    county_names_all: 'Woodson',
    county_weights: '{"20207": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 37.91469,
    longitude: -95.56694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66761',
  },
  {
    city: 'Pittsburg',
    county_fips: 20037,
    county_fips_all: '20037|20021',
    county: 'Crawford',
    county_names_all: 'Crawford|Cherokee',
    county_weights: '{"20037": 82.73, "20021": 17.27}',
    density: 71.8,
    imprecise: false,
    latitude: 37.39443,
    longitude: -94.71092,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66762',
  },
  {
    city: 'Frontenac',
    county_fips: 20037,
    county_fips_all: '20037',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"20037": 100}',
    density: 209,
    imprecise: false,
    latitude: 37.46063,
    longitude: -94.6965,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66763',
  },
  {
    city: 'Prescott',
    county_fips: 20107,
    county_fips_all: '20107',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"20107": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 38.07741,
    longitude: -94.71159,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66767',
  },
  {
    city: 'Redfield',
    county_fips: 20011,
    county_fips_all: '20011',
    county: 'Bourbon',
    county_names_all: 'Bourbon',
    county_weights: '{"20011": 100}',
    density: 4,
    imprecise: false,
    latitude: 37.85317,
    longitude: -94.89379,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66769',
  },
  {
    city: 'Riverton',
    county_fips: 20021,
    county_fips_all: '20021',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"20021": 100}',
    density: 57.2,
    imprecise: false,
    latitude: 37.08014,
    longitude: -94.71601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66770',
  },
  {
    city: 'Saint Paul',
    county_fips: 20133,
    county_fips_all: '20133',
    county: 'Neosho',
    county_names_all: 'Neosho',
    county_weights: '{"20133": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 37.49211,
    longitude: -95.14883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66771',
  },
  {
    city: 'Savonburg',
    county_fips: 20001,
    county_fips_all: '20001|20011|20133',
    county: 'Allen',
    county_names_all: 'Allen|Bourbon|Neosho',
    county_weights: '{"20001": 67.43, "20011": 17.3, "20133": 15.27}',
    density: 2.2,
    imprecise: false,
    latitude: 37.74559,
    longitude: -95.18813,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66772',
  },
  {
    city: 'Scammon',
    county_fips: 20021,
    county_fips_all: '20021',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"20021": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 37.26599,
    longitude: -94.81262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66773',
  },
  {
    city: 'Stark',
    county_fips: 20133,
    county_fips_all: '20133',
    county: 'Neosho',
    county_names_all: 'Neosho',
    county_weights: '{"20133": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 37.69957,
    longitude: -95.14855,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66775',
  },
  {
    city: 'Thayer',
    county_fips: 20133,
    county_fips_all: '20133|20205|20099|20125',
    county: 'Neosho',
    county_names_all: 'Neosho|Wilson|Labette|Montgomery',
    county_weights:
      '{"20133": 68.73, "20205": 27.52, "20099": 2.84, "20125": 0.91}',
    density: 5.3,
    imprecise: false,
    latitude: 37.46848,
    longitude: -95.48893,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66776',
  },
  {
    city: 'Toronto',
    county_fips: 20073,
    county_fips_all: '20073|20207|20205',
    county: 'Greenwood',
    county_names_all: 'Greenwood|Woodson|Wilson',
    county_weights: '{"20073": 50.02, "20207": 44.01, "20205": 5.97}',
    density: 1.4,
    imprecise: false,
    latitude: 37.79087,
    longitude: -95.9684,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66777',
  },
  {
    city: 'Uniontown',
    county_fips: 20011,
    county_fips_all: '20011',
    county: 'Bourbon',
    county_names_all: 'Bourbon',
    county_weights: '{"20011": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 37.83751,
    longitude: -94.97867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66779',
  },
  {
    city: 'Walnut',
    county_fips: 20037,
    county_fips_all: '20037|20133|20011',
    county: 'Crawford',
    county_names_all: 'Crawford|Neosho|Bourbon',
    county_weights: '{"20037": 62.91, "20133": 27.24, "20011": 9.85}',
    density: 2.5,
    imprecise: false,
    latitude: 37.60895,
    longitude: -95.05881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66780',
  },
  {
    city: 'Weir',
    county_fips: 20021,
    county_fips_all: '20021|20037',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Crawford',
    county_weights: '{"20021": 94.51, "20037": 5.49}',
    density: 10,
    imprecise: false,
    latitude: 37.29114,
    longitude: -94.72806,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66781',
  },
  {
    city: 'West Mineral',
    county_fips: 20021,
    county_fips_all: '20021',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"20021": 100}',
    density: 208,
    imprecise: false,
    latitude: 37.28493,
    longitude: -94.92609,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66782',
  },
  {
    city: 'Yates Center',
    county_fips: 20207,
    county_fips_all: '20207',
    county: 'Woodson',
    county_names_all: 'Woodson',
    county_weights: '{"20207": 100}',
    density: 3,
    imprecise: false,
    latitude: 37.87682,
    longitude: -95.73322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66783',
  },
  {
    city: 'Emporia',
    county_fips: 20111,
    county_fips_all: '20111|20017',
    county: 'Lyon',
    county_names_all: 'Lyon|Chase',
    county_weights: '{"20111": 84.62, "20017": 15.38}',
    density: 35.4,
    imprecise: false,
    latitude: 38.41105,
    longitude: -96.2221,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66801',
  },
  {
    city: 'Admire',
    county_fips: 20111,
    county_fips_all: '20111',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"20111": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 38.59733,
    longitude: -96.08755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66830',
  },
  {
    city: 'Allen',
    county_fips: 20111,
    county_fips_all: '20111',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"20111": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 38.67694,
    longitude: -96.18374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66833',
  },
  {
    city: 'Alta Vista',
    county_fips: 20197,
    county_fips_all: '20197|20061|20127',
    county: 'Wabaunsee',
    county_names_all: 'Wabaunsee|Geary|Morris',
    county_weights: '{"20197": 56.03, "20061": 23.88, "20127": 20.09}',
    density: 2,
    imprecise: false,
    latitude: 38.86528,
    longitude: -96.44822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66834',
  },
  {
    city: 'Americus',
    county_fips: 20111,
    county_fips_all: '20111|20127',
    county: 'Lyon',
    county_names_all: 'Lyon|Morris',
    county_weights: '{"20111": 98.91, "20127": 1.09}',
    density: 7.9,
    imprecise: false,
    latitude: 38.53458,
    longitude: -96.26266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66835',
  },
  {
    city: 'Burdick',
    county_fips: 20127,
    county_fips_all: '20127|20115|20017',
    county: 'Morris',
    county_names_all: 'Morris|Marion|Chase',
    county_weights: '{"20127": 94.38, "20115": 3.23, "20017": 2.39}',
    density: 0.6,
    imprecise: false,
    latitude: 38.56207,
    longitude: -96.79665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66838',
  },
  {
    city: 'Burlington',
    county_fips: 20031,
    county_fips_all: '20031',
    county: 'Coffey',
    county_names_all: 'Coffey',
    county_weights: '{"20031": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 38.21655,
    longitude: -95.75371,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66839',
  },
  {
    city: 'Burns',
    county_fips: 20015,
    county_fips_all: '20015|20115|20017',
    county: 'Butler',
    county_names_all: 'Butler|Marion|Chase',
    county_weights: '{"20015": 53.59, "20115": 25.26, "20017": 21.15}',
    density: 1,
    imprecise: false,
    latitude: 38.07283,
    longitude: -96.8719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66840',
  },
  {
    city: 'Cassoday',
    county_fips: 20015,
    county_fips_all: '20015',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"20015": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 38.0236,
    longitude: -96.65836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66842',
  },
  {
    city: 'Cedar Point',
    county_fips: 20017,
    county_fips_all: '20017|20115',
    county: 'Chase',
    county_names_all: 'Chase|Marion',
    county_weights: '{"20017": 97.74, "20115": 2.26}',
    density: 0.3,
    imprecise: false,
    latitude: 38.22846,
    longitude: -96.74329,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66843',
  },
  {
    city: 'Cottonwood Falls',
    county_fips: 20017,
    county_fips_all: '20017',
    county: 'Chase',
    county_names_all: 'Chase',
    county_weights: '{"20017": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 38.29546,
    longitude: -96.50762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66845',
  },
  {
    city: 'Council Grove',
    county_fips: 20127,
    county_fips_all: '20127|20111|20017|20197',
    county: 'Morris',
    county_names_all: 'Morris|Lyon|Chase|Wabaunsee',
    county_weights:
      '{"20127": 84.07, "20111": 10.9, "20017": 4.36, "20197": 0.67}',
    density: 4.3,
    imprecise: false,
    latitude: 38.64383,
    longitude: -96.47187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66846',
  },
  {
    city: 'Dwight',
    county_fips: 20127,
    county_fips_all: '20127|20061',
    county: 'Morris',
    county_names_all: 'Morris|Geary',
    county_weights: '{"20127": 51.03, "20061": 48.97}',
    density: 3.2,
    imprecise: false,
    latitude: 38.87427,
    longitude: -96.59789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66849',
  },
  {
    city: 'Elmdale',
    county_fips: 20017,
    county_fips_all: '20017',
    county: 'Chase',
    county_names_all: 'Chase',
    county_weights: '{"20017": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 38.40648,
    longitude: -96.71764,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66850',
  },
  {
    city: 'Florence',
    county_fips: 20115,
    county_fips_all: '20115',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"20115": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 38.22463,
    longitude: -96.92084,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66851',
  },
  {
    city: 'Gridley',
    county_fips: 20031,
    county_fips_all: '20031|20207|20073',
    county: 'Coffey',
    county_names_all: 'Coffey|Woodson|Greenwood',
    county_weights: '{"20031": 58.04, "20207": 23.82, "20073": 18.14}',
    density: 1.5,
    imprecise: false,
    latitude: 38.0716,
    longitude: -95.89874,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66852',
  },
  {
    city: 'Hamilton',
    county_fips: 20073,
    county_fips_all: '20073',
    county: 'Greenwood',
    county_names_all: 'Greenwood',
    county_weights: '{"20073": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 38.00653,
    longitude: -96.24232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66853',
  },
  {
    city: 'Hartford',
    county_fips: 20111,
    county_fips_all: '20111|20031',
    county: 'Lyon',
    county_names_all: 'Lyon|Coffey',
    county_weights: '{"20111": 70.81, "20031": 29.19}',
    density: 4,
    imprecise: false,
    latitude: 38.25872,
    longitude: -95.98735,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66854',
  },
  {
    city: 'Lebo',
    county_fips: 20031,
    county_fips_all: '20031|20139',
    county: 'Coffey',
    county_names_all: 'Coffey|Osage',
    county_weights: '{"20031": 66.67, "20139": 33.33}',
    density: 4.3,
    imprecise: false,
    latitude: 38.39853,
    longitude: -95.81838,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66856',
  },
  {
    city: 'Le Roy',
    county_fips: 20031,
    county_fips_all: '20031',
    county: 'Coffey',
    county_names_all: 'Coffey',
    county_weights: '{"20031": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 38.10202,
    longitude: -95.63526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66857',
  },
  {
    city: 'Lincolnville',
    county_fips: 20115,
    county_fips_all: '20115|20017',
    county: 'Marion',
    county_names_all: 'Marion|Chase',
    county_weights: '{"20115": 92.02, "20017": 7.98}',
    density: 2.2,
    imprecise: false,
    latitude: 38.47462,
    longitude: -96.9207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66858',
  },
  {
    city: 'Lost Springs',
    county_fips: 20115,
    county_fips_all: '20115|20127',
    county: 'Marion',
    county_names_all: 'Marion|Morris',
    county_weights: '{"20115": 81.05, "20127": 18.95}',
    density: 1.5,
    imprecise: false,
    latitude: 38.55653,
    longitude: -96.96315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66859',
  },
  {
    city: 'Madison',
    county_fips: 20073,
    county_fips_all: '20073|20111',
    county: 'Greenwood',
    county_names_all: 'Greenwood|Lyon',
    county_weights: '{"20073": 81.54, "20111": 18.46}',
    density: 2.8,
    imprecise: false,
    latitude: 38.12775,
    longitude: -96.1652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66860',
  },
  {
    city: 'Marion',
    county_fips: 20115,
    county_fips_all: '20115',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"20115": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 38.36415,
    longitude: -97.00617,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66861',
  },
  {
    city: 'Matfield Green',
    county_fips: 20017,
    county_fips_all: '20017',
    county: 'Chase',
    county_names_all: 'Chase',
    county_weights: '{"20017": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 38.15532,
    longitude: -96.55403,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 68,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66862',
  },
  {
    city: 'Neal',
    county_fips: 20073,
    county_fips_all: '20073',
    county: 'Greenwood',
    county_names_all: 'Greenwood',
    county_weights: '{"20073": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 37.83368,
    longitude: -96.07633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66863',
  },
  {
    city: 'Neosho Rapids',
    county_fips: 20111,
    county_fips_all: '20111|20031',
    county: 'Lyon',
    county_names_all: 'Lyon|Coffey',
    county_weights: '{"20111": 69.36, "20031": 30.64}',
    density: 3.9,
    imprecise: false,
    latitude: 38.36132,
    longitude: -95.98207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66864',
  },
  {
    city: 'Olpe',
    county_fips: 20111,
    county_fips_all: '20111|20017',
    county: 'Lyon',
    county_names_all: 'Lyon|Chase',
    county_weights: '{"20111": 66.62, "20017": 33.38}',
    density: 2.9,
    imprecise: false,
    latitude: 38.2181,
    longitude: -96.27993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66865',
  },
  {
    city: 'Peabody',
    county_fips: 20115,
    county_fips_all: '20115|20079',
    county: 'Marion',
    county_names_all: 'Marion|Harvey',
    county_weights: '{"20115": 90.64, "20079": 9.36}',
    density: 4.9,
    imprecise: false,
    latitude: 38.17438,
    longitude: -97.10385,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66866',
  },
  {
    city: 'Reading',
    county_fips: 20111,
    county_fips_all: '20111|20139|20031',
    county: 'Lyon',
    county_names_all: 'Lyon|Osage|Coffey',
    county_weights: '{"20111": 77.85, "20139": 20.56, "20031": 1.59}',
    density: 1.9,
    imprecise: false,
    latitude: 38.54284,
    longitude: -95.98387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66868',
  },
  {
    city: 'Strong City',
    county_fips: 20017,
    county_fips_all: '20017',
    county: 'Chase',
    county_names_all: 'Chase',
    county_weights: '{"20017": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 38.4548,
    longitude: -96.54444,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66869',
  },
  {
    city: 'Virgil',
    county_fips: 20073,
    county_fips_all: '20073|20207',
    county: 'Greenwood',
    county_names_all: 'Greenwood|Woodson',
    county_weights: '{"20073": 80.05, "20207": 19.95}',
    density: 0.5,
    imprecise: false,
    latitude: 37.93809,
    longitude: -95.99316,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66870',
  },
  {
    city: 'Waverly',
    county_fips: 20031,
    county_fips_all: '20031|20139',
    county: 'Coffey',
    county_names_all: 'Coffey|Osage',
    county_weights: '{"20031": 94.84, "20139": 5.16}',
    density: 3.9,
    imprecise: false,
    latitude: 38.35941,
    longitude: -95.61815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66871',
  },
  {
    city: 'White City',
    county_fips: 20127,
    county_fips_all: '20127|20061',
    county: 'Morris',
    county_names_all: 'Morris|Geary',
    county_weights: '{"20127": 94.03, "20061": 5.97}',
    density: 2.2,
    imprecise: false,
    latitude: 38.79878,
    longitude: -96.76147,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66872',
  },
  {
    city: 'Wilsey',
    county_fips: 20127,
    county_fips_all: '20127',
    county: 'Morris',
    county_names_all: 'Morris',
    county_weights: '{"20127": 100}',
    density: 1,
    imprecise: false,
    latitude: 38.61747,
    longitude: -96.66774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66873',
  },
  {
    city: 'Concordia',
    county_fips: 20029,
    county_fips_all: '20029|20157',
    county: 'Cloud',
    county_names_all: 'Cloud|Republic',
    county_weights: '{"20029": 88.95, "20157": 11.05}',
    density: 9.2,
    imprecise: false,
    latitude: 39.55618,
    longitude: -97.64317,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66901',
  },
  {
    city: 'Agenda',
    county_fips: 20157,
    county_fips_all: '20157',
    county: 'Republic',
    county_names_all: 'Republic',
    county_weights: '{"20157": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 39.71137,
    longitude: -97.48553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66930',
  },
  {
    city: 'Athol',
    county_fips: 20183,
    county_fips_all: '20183',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"20183": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 39.77925,
    longitude: -98.93227,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66932',
  },
  {
    city: 'Barnes',
    county_fips: 20201,
    county_fips_all: '20201|20161',
    county: 'Washington',
    county_names_all: 'Washington|Riley',
    county_weights: '{"20201": 94.99, "20161": 5.01}',
    density: 1.5,
    imprecise: false,
    latitude: 39.67124,
    longitude: -96.86706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66933',
  },
  {
    city: 'Belleville',
    county_fips: 20157,
    county_fips_all: '20157',
    county: 'Republic',
    county_names_all: 'Republic',
    county_weights: '{"20157": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 39.82694,
    longitude: -97.63538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66935',
  },
  {
    city: 'Burr Oak',
    county_fips: 20089,
    county_fips_all: '20089',
    county: 'Jewell',
    county_names_all: 'Jewell',
    county_weights: '{"20089": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 39.9213,
    longitude: -98.30091,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66936',
  },
  {
    city: 'Clifton',
    county_fips: 20201,
    county_fips_all: '20201|20027',
    county: 'Washington',
    county_names_all: 'Washington|Clay',
    county_weights: '{"20201": 53.3, "20027": 46.7}',
    density: 1.9,
    imprecise: false,
    latitude: 39.58959,
    longitude: -97.26493,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66937',
  },
  {
    city: 'Clyde',
    county_fips: 20029,
    county_fips_all: '20029|20201|20157|20027',
    county: 'Cloud',
    county_names_all: 'Cloud|Washington|Republic|Clay',
    county_weights:
      '{"20029": 67.32, "20201": 18.98, "20157": 9.01, "20027": 4.69}',
    density: 3.7,
    imprecise: false,
    latitude: 39.58018,
    longitude: -97.41081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66938',
  },
  {
    city: 'Courtland',
    county_fips: 20157,
    county_fips_all: '20157|20089',
    county: 'Republic',
    county_names_all: 'Republic|Jewell',
    county_weights: '{"20157": 82.51, "20089": 17.49}',
    density: 1.2,
    imprecise: false,
    latitude: 39.85179,
    longitude: -97.89754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66939',
  },
  {
    city: 'Cuba',
    county_fips: 20157,
    county_fips_all: '20157',
    county: 'Republic',
    county_names_all: 'Republic',
    county_weights: '{"20157": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 39.80343,
    longitude: -97.45381,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66940',
  },
  {
    city: 'Esbon',
    county_fips: 20089,
    county_fips_all: '20089',
    county: 'Jewell',
    county_names_all: 'Jewell',
    county_weights: '{"20089": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 39.83135,
    longitude: -98.44777,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66941',
  },
  {
    city: 'Formoso',
    county_fips: 20089,
    county_fips_all: '20089|20157',
    county: 'Jewell',
    county_names_all: 'Jewell|Republic',
    county_weights: '{"20089": 98.07, "20157": 1.93}',
    density: 1.2,
    imprecise: false,
    latitude: 39.79278,
    longitude: -98.00448,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66942',
  },
  {
    city: 'Greenleaf',
    county_fips: 20201,
    county_fips_all: '20201',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"20201": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 39.67209,
    longitude: -96.97313,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66943',
  },
  {
    city: 'Haddam',
    county_fips: 20201,
    county_fips_all: '20201',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"20201": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 39.84007,
    longitude: -97.29354,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66944',
  },
  {
    city: 'Hanover',
    county_fips: 20201,
    county_fips_all: '20201|20117',
    county: 'Washington',
    county_names_all: 'Washington|Marshall',
    county_weights: '{"20201": 99.04, "20117": 0.96}',
    density: 4.1,
    imprecise: false,
    latitude: 39.88601,
    longitude: -96.87761,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66945',
  },
  {
    city: 'Hollenberg',
    county_fips: 20201,
    county_fips_all: '20201',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"20201": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 39.96684,
    longitude: -97.00192,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66946',
  },
  {
    city: 'Jamestown',
    county_fips: 20029,
    county_fips_all: '20029|20157|20089',
    county: 'Cloud',
    county_names_all: 'Cloud|Republic|Jewell',
    county_weights: '{"20029": 77.44, "20157": 21.77, "20089": 0.79}',
    density: 1.8,
    imprecise: false,
    latitude: 39.59743,
    longitude: -97.85141,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66948',
  },
  {
    city: 'Jewell',
    county_fips: 20089,
    county_fips_all: '20089',
    county: 'Jewell',
    county_names_all: 'Jewell',
    county_weights: '{"20089": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 39.646,
    longitude: -98.19755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66949',
  },
  {
    city: 'Kensington',
    county_fips: 20183,
    county_fips_all: '20183|20147',
    county: 'Smith',
    county_names_all: 'Smith|Phillips',
    county_weights: '{"20183": 73.87, "20147": 26.13}',
    density: 1.9,
    imprecise: false,
    latitude: 39.86239,
    longitude: -99.03072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66951',
  },
  {
    city: 'Lebanon',
    county_fips: 20183,
    county_fips_all: '20183|20089',
    county: 'Smith',
    county_names_all: 'Smith|Jewell',
    county_weights: '{"20183": 98.67, "20089": 1.33}',
    density: 0.6,
    imprecise: false,
    latitude: 39.84269,
    longitude: -98.60214,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66952',
  },
  {
    city: 'Linn',
    county_fips: 20201,
    county_fips_all: '20201',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"20201": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 39.67877,
    longitude: -97.11934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66953',
  },
  {
    city: 'Mahaska',
    county_fips: 20201,
    county_fips_all: '20201|31169',
    county: 'Washington',
    county_names_all: 'Washington|Thayer',
    county_weights: '{"20201": 77.84, "31169": 22.16}',
    density: 0.3,
    imprecise: false,
    latitude: 39.97984,
    longitude: -97.31715,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66955',
  },
  {
    city: 'Mankato',
    county_fips: 20089,
    county_fips_all: '20089',
    county: 'Jewell',
    county_names_all: 'Jewell',
    county_weights: '{"20089": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 39.79625,
    longitude: -98.21581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66956',
  },
  {
    city: 'Morrowville',
    county_fips: 20201,
    county_fips_all: '20201',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"20201": 100}',
    density: 1,
    imprecise: false,
    latitude: 39.88657,
    longitude: -97.1787,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66958',
  },
  {
    city: 'Munden',
    county_fips: 20157,
    county_fips_all: '20157',
    county: 'Republic',
    county_names_all: 'Republic',
    county_weights: '{"20157": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 39.92276,
    longitude: -97.53551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66959',
  },
  {
    city: 'Narka',
    county_fips: 20157,
    county_fips_all: '20157|20201',
    county: 'Republic',
    county_names_all: 'Republic|Washington',
    county_weights: '{"20157": 95.46, "20201": 4.54}',
    density: 0.8,
    imprecise: false,
    latitude: 39.93042,
    longitude: -97.42134,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66960',
  },
  {
    city: 'Norway',
    county_fips: 20157,
    county_fips_all: '20157',
    county: 'Republic',
    county_names_all: 'Republic',
    county_weights: '{"20157": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 39.69337,
    longitude: -97.77559,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66961',
  },
  {
    city: 'Palmer',
    county_fips: 20201,
    county_fips_all: '20201|20027',
    county: 'Washington',
    county_names_all: 'Washington|Clay',
    county_weights: '{"20201": 78.41, "20027": 21.59}',
    density: 2.1,
    imprecise: false,
    latitude: 39.59928,
    longitude: -97.12547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66962',
  },
  {
    city: 'Randall',
    county_fips: 20089,
    county_fips_all: '20089',
    county: 'Jewell',
    county_names_all: 'Jewell',
    county_weights: '{"20089": 100}',
    density: 1,
    imprecise: false,
    latitude: 39.64133,
    longitude: -98.01064,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66963',
  },
  {
    city: 'Republic',
    county_fips: 20157,
    county_fips_all: '20157',
    county: 'Republic',
    county_names_all: 'Republic',
    county_weights: '{"20157": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 39.93465,
    longitude: -97.80004,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66964',
  },
  {
    city: 'Scandia',
    county_fips: 20157,
    county_fips_all: '20157',
    county: 'Republic',
    county_names_all: 'Republic',
    county_weights: '{"20157": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 39.7793,
    longitude: -97.76206,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66966',
  },
  {
    city: 'Smith Center',
    county_fips: 20183,
    county_fips_all: '20183',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"20183": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 39.82571,
    longitude: -98.79366,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66967',
  },
  {
    city: 'Washington',
    county_fips: 20201,
    county_fips_all: '20201',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"20201": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 39.8294,
    longitude: -97.06524,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66968',
  },
  {
    city: 'Webber',
    county_fips: 20089,
    county_fips_all: '20089',
    county: 'Jewell',
    county_names_all: 'Jewell',
    county_weights: '{"20089": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 39.94533,
    longitude: -98.02336,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66970',
  },
  {
    city: 'Andale',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 42.4,
    imprecise: false,
    latitude: 37.76069,
    longitude: -97.62953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67001',
  },
  {
    city: 'Andover',
    county_fips: 20015,
    county_fips_all: '20015',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"20015": 100}',
    density: 177.4,
    imprecise: false,
    latitude: 37.69575,
    longitude: -97.10725,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67002',
  },
  {
    city: 'Anthony',
    county_fips: 20077,
    county_fips_all: '20077',
    county: 'Harper',
    county_names_all: 'Harper',
    county_weights: '{"20077": 100}',
    density: 4,
    imprecise: false,
    latitude: 37.1109,
    longitude: -98.06319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67003',
  },
  {
    city: 'Argonia',
    county_fips: 20191,
    county_fips_all: '20191|20077',
    county: 'Sumner',
    county_names_all: 'Sumner|Harper',
    county_weights: '{"20191": 71.9, "20077": 28.1}',
    density: 2.9,
    imprecise: false,
    latitude: 37.28317,
    longitude: -97.76401,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67004',
  },
  {
    city: 'Arkansas City',
    county_fips: 20035,
    county_fips_all: '20035',
    county: 'Cowley',
    county_names_all: 'Cowley',
    county_weights: '{"20035": 100}',
    density: 40,
    imprecise: false,
    latitude: 37.06722,
    longitude: -96.99645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67005',
  },
  {
    city: 'Atlanta',
    county_fips: 20035,
    county_fips_all: '20035|20015',
    county: 'Cowley',
    county_names_all: 'Cowley|Butler',
    county_weights: '{"20035": 56.47, "20015": 43.53}',
    density: 1.7,
    imprecise: false,
    latitude: 37.47796,
    longitude: -96.76983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67008',
  },
  {
    city: 'Attica',
    county_fips: 20077,
    county_fips_all: '20077',
    county: 'Harper',
    county_names_all: 'Harper',
    county_weights: '{"20077": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 37.22153,
    longitude: -98.26369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67009',
  },
  {
    city: 'Augusta',
    county_fips: 20015,
    county_fips_all: '20015',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"20015": 100}',
    density: 51.8,
    imprecise: false,
    latitude: 37.66099,
    longitude: -96.97388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67010',
  },
  {
    city: 'Beaumont',
    county_fips: 20015,
    county_fips_all: '20015',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"20015": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 37.66175,
    longitude: -96.54701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67012',
  },
  {
    city: 'Belle Plaine',
    county_fips: 20191,
    county_fips_all: '20191',
    county: 'Sumner',
    county_names_all: 'Sumner',
    county_weights: '{"20191": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 37.37904,
    longitude: -97.27378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67013',
  },
  {
    city: 'Bentley',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 307.8,
    imprecise: false,
    latitude: 37.88882,
    longitude: -97.51812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67016',
  },
  {
    city: 'Benton',
    county_fips: 20015,
    county_fips_all: '20015|20173',
    county: 'Butler',
    county_names_all: 'Butler|Sedgwick',
    county_weights: '{"20015": 89.51, "20173": 10.49}',
    density: 13.7,
    imprecise: false,
    latitude: 37.82778,
    longitude: -97.11165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67017',
  },
  {
    city: 'Bluff City',
    county_fips: 20077,
    county_fips_all: '20077|20191',
    county: 'Harper',
    county_names_all: 'Harper|Sumner',
    county_weights: '{"20077": 91.98, "20191": 8.02}',
    density: 0.4,
    imprecise: false,
    latitude: 37.07108,
    longitude: -97.85872,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67018',
  },
  {
    city: 'Burden',
    county_fips: 20035,
    county_fips_all: '20035',
    county: 'Cowley',
    county_names_all: 'Cowley',
    county_weights: '{"20035": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 37.31225,
    longitude: -96.78174,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67019',
  },
  {
    city: 'Burrton',
    county_fips: 20079,
    county_fips_all: '20079|20155|20173',
    county: 'Harvey',
    county_names_all: 'Harvey|Reno|Sedgwick',
    county_weights: '{"20079": 65.24, "20155": 29.07, "20173": 5.69}',
    density: 4.9,
    imprecise: false,
    latitude: 38.00881,
    longitude: -97.66903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67020',
  },
  {
    city: 'Byers',
    county_fips: 20151,
    county_fips_all: '20151',
    county: 'Pratt',
    county_names_all: 'Pratt',
    county_weights: '{"20151": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 37.77615,
    longitude: -98.91045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67021',
  },
  {
    city: 'Caldwell',
    county_fips: 20191,
    county_fips_all: '20191',
    county: 'Sumner',
    county_names_all: 'Sumner',
    county_weights: '{"20191": 100}',
    density: 3,
    imprecise: false,
    latitude: 37.07352,
    longitude: -97.63347,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67022',
  },
  {
    city: 'Cambridge',
    county_fips: 20035,
    county_fips_all: '20035',
    county: 'Cowley',
    county_names_all: 'Cowley',
    county_weights: '{"20035": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 37.33467,
    longitude: -96.61288,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67023',
  },
  {
    city: 'Cedar Vale',
    county_fips: 20019,
    county_fips_all: '20019|20035',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua|Cowley',
    county_weights: '{"20019": 62.65, "20035": 37.35}',
    density: 1.6,
    imprecise: false,
    latitude: 37.11397,
    longitude: -96.49164,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67024',
  },
  {
    city: 'Cheney',
    county_fips: 20173,
    county_fips_all: '20173|20095|20155',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick|Kingman|Reno',
    county_weights: '{"20173": 61.44, "20095": 36.77, "20155": 1.79}',
    density: 13.5,
    imprecise: false,
    latitude: 37.64146,
    longitude: -97.78789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67025',
  },
  {
    city: 'Clearwater',
    county_fips: 20173,
    county_fips_all: '20173|20191',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick|Sumner',
    county_weights: '{"20173": 72.46, "20191": 27.54}',
    density: 22.8,
    imprecise: false,
    latitude: 37.51047,
    longitude: -97.49239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67026',
  },
  {
    city: 'Coats',
    county_fips: 20097,
    county_fips_all: '20097|20151|20007',
    county: 'Kiowa',
    county_names_all: 'Kiowa|Pratt|Barber',
    county_weights: '{"20097": 42.17, "20151": 38.14, "20007": 19.7}',
    density: 0.4,
    imprecise: false,
    latitude: 37.47226,
    longitude: -98.96561,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67028',
  },
  {
    city: 'Coldwater',
    county_fips: 20033,
    county_fips_all: '20033|20097',
    county: 'Comanche',
    county_names_all: 'Comanche|Kiowa',
    county_weights: '{"20033": 97.88, "20097": 2.12}',
    density: 0.9,
    imprecise: false,
    latitude: 37.16925,
    longitude: -99.28026,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67029',
  },
  {
    city: 'Colwich',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 28.8,
    imprecise: false,
    latitude: 37.78548,
    longitude: -97.54661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67030',
  },
  {
    city: 'Conway Springs',
    county_fips: 20191,
    county_fips_all: '20191|20173',
    county: 'Sumner',
    county_names_all: 'Sumner|Sedgwick',
    county_weights: '{"20191": 93.96, "20173": 6.04}',
    density: 8.3,
    imprecise: false,
    latitude: 37.40444,
    longitude: -97.63848,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67031',
  },
  {
    city: 'Cunningham',
    county_fips: 20095,
    county_fips_all: '20095|20151|20155',
    county: 'Kingman',
    county_names_all: 'Kingman|Pratt|Reno',
    county_weights: '{"20095": 65.68, "20151": 25.32, "20155": 9.0}',
    density: 1.5,
    imprecise: false,
    latitude: 37.64845,
    longitude: -98.39338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67035',
  },
  {
    city: 'Danville',
    county_fips: 20077,
    county_fips_all: '20077',
    county: 'Harper',
    county_names_all: 'Harper',
    county_weights: '{"20077": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 37.28987,
    longitude: -97.88262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67036',
  },
  {
    city: 'Derby',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 218.1,
    imprecise: false,
    latitude: 37.56646,
    longitude: -97.22095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67037',
  },
  {
    city: 'Dexter',
    county_fips: 20035,
    county_fips_all: '20035',
    county: 'Cowley',
    county_names_all: 'Cowley',
    county_weights: '{"20035": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 37.11702,
    longitude: -96.70905,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67038',
  },
  {
    city: 'Douglass',
    county_fips: 20015,
    county_fips_all: '20015|20035',
    county: 'Butler',
    county_names_all: 'Butler|Cowley',
    county_weights: '{"20015": 95.69, "20035": 4.31}',
    density: 10.7,
    imprecise: false,
    latitude: 37.52163,
    longitude: -96.97322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67039',
  },
  {
    city: 'Elbing',
    county_fips: 20015,
    county_fips_all: '20015',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"20015": 100}',
    density: 805.8,
    imprecise: false,
    latitude: 38.05404,
    longitude: -97.12755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67041',
  },
  {
    city: 'El Dorado',
    county_fips: 20015,
    county_fips_all: '20015',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"20015": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 37.84868,
    longitude: -96.79809,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67042',
  },
  {
    city: 'Eureka',
    county_fips: 20073,
    county_fips_all: '20073|20015',
    county: 'Greenwood',
    county_names_all: 'Greenwood|Butler',
    county_weights: '{"20073": 99.25, "20015": 0.75}',
    density: 2.9,
    imprecise: false,
    latitude: 37.85131,
    longitude: -96.33863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67045',
  },
  {
    city: 'Fall River',
    county_fips: 20073,
    county_fips_all: '20073|20049|20205',
    county: 'Greenwood',
    county_names_all: 'Greenwood|Elk|Wilson',
    county_weights: '{"20073": 63.52, "20049": 26.44, "20205": 10.04}',
    density: 1.3,
    imprecise: false,
    latitude: 37.63921,
    longitude: -96.05327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67047',
  },
  {
    city: 'Freeport',
    county_fips: 20077,
    county_fips_all: '20077|20191',
    county: 'Harper',
    county_names_all: 'Harper|Sumner',
    county_weights: '{"20077": 88.86, "20191": 11.14}',
    density: 0.1,
    imprecise: false,
    latitude: 37.17059,
    longitude: -97.84646,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67049',
  },
  {
    city: 'Garden Plain',
    county_fips: 20173,
    county_fips_all: '20173|20155',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick|Reno',
    county_weights: '{"20173": 97.78, "20155": 2.22}',
    density: 15.7,
    imprecise: false,
    latitude: 37.675,
    longitude: -97.6769,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67050',
  },
  {
    city: 'Geuda Springs',
    county_fips: 20191,
    county_fips_all: '20191|20035',
    county: 'Sumner',
    county_names_all: 'Sumner|Cowley',
    county_weights: '{"20191": 88.95, "20035": 11.05}',
    density: 2,
    imprecise: false,
    latitude: 37.08932,
    longitude: -97.19399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67051',
  },
  {
    city: 'Goddard',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 69,
    imprecise: false,
    latitude: 37.65812,
    longitude: -97.57357,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67052',
  },
  {
    city: 'Goessel',
    county_fips: 20115,
    county_fips_all: '20115',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"20115": 100}',
    density: 612,
    imprecise: false,
    latitude: 38.24728,
    longitude: -97.34545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67053',
  },
  {
    city: 'Greensburg',
    county_fips: 20097,
    county_fips_all: '20097|20047',
    county: 'Kiowa',
    county_names_all: 'Kiowa|Edwards',
    county_weights: '{"20097": 96.36, "20047": 3.64}',
    density: 2.2,
    imprecise: false,
    latitude: 37.57658,
    longitude: -99.31884,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67054',
  },
  {
    city: 'Greenwich',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 188.2,
    imprecise: false,
    latitude: 37.78325,
    longitude: -97.2037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67055',
  },
  {
    city: 'Halstead',
    county_fips: 20079,
    county_fips_all: '20079',
    county: 'Harvey',
    county_names_all: 'Harvey',
    county_weights: '{"20079": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 38.01936,
    longitude: -97.52345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67056',
  },
  {
    city: 'Hardtner',
    county_fips: 20007,
    county_fips_all: '20007',
    county: 'Barber',
    county_names_all: 'Barber',
    county_weights: '{"20007": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 37.05954,
    longitude: -98.77864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67057',
  },
  {
    city: 'Harper',
    county_fips: 20077,
    county_fips_all: '20077|20095',
    county: 'Harper',
    county_names_all: 'Harper|Kingman',
    county_weights: '{"20077": 85.75, "20095": 14.25}',
    density: 3.3,
    imprecise: false,
    latitude: 37.32006,
    longitude: -98.06493,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67058',
  },
  {
    city: 'Haviland',
    county_fips: 20097,
    county_fips_all: '20097|20047|20151',
    county: 'Kiowa',
    county_names_all: 'Kiowa|Edwards|Pratt',
    county_weights: '{"20097": 71.49, "20047": 15.69, "20151": 12.82}',
    density: 1.4,
    imprecise: false,
    latitude: 37.65102,
    longitude: -99.10046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67059',
  },
  {
    city: 'Haysville',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 194.5,
    imprecise: false,
    latitude: 37.54601,
    longitude: -97.35952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67060',
  },
  {
    city: 'Hazelton',
    county_fips: 20007,
    county_fips_all: '20007|20077',
    county: 'Barber',
    county_names_all: 'Barber|Harper',
    county_weights: '{"20007": 66.84, "20077": 33.16}',
    density: 0.8,
    imprecise: false,
    latitude: 37.08593,
    longitude: -98.37673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67061',
  },
  {
    city: 'Hesston',
    county_fips: 20079,
    county_fips_all: '20079|20113|20115',
    county: 'Harvey',
    county_names_all: 'Harvey|McPherson|Marion',
    county_weights: '{"20079": 89.89, "20113": 7.25, "20115": 2.86}',
    density: 48.8,
    imprecise: false,
    latitude: 38.1431,
    longitude: -97.43296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67062',
  },
  {
    city: 'Hillsboro',
    county_fips: 20115,
    county_fips_all: '20115',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"20115": 100}',
    density: 10,
    imprecise: false,
    latitude: 38.34244,
    longitude: -97.23019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67063',
  },
  {
    city: 'Isabel',
    county_fips: 20151,
    county_fips_all: '20151|20007|20095',
    county: 'Pratt',
    county_names_all: 'Pratt|Barber|Kingman',
    county_weights: '{"20151": 56.47, "20007": 40.85, "20095": 2.68}',
    density: 0.8,
    imprecise: false,
    latitude: 37.48295,
    longitude: -98.52989,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67065',
  },
  {
    city: 'Iuka',
    county_fips: 20151,
    county_fips_all: '20151',
    county: 'Pratt',
    county_names_all: 'Pratt',
    county_weights: '{"20151": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 37.77374,
    longitude: -98.75798,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67066',
  },
  {
    city: 'Kechi',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 189.7,
    imprecise: false,
    latitude: 37.7951,
    longitude: -97.27044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67067',
  },
  {
    city: 'Kingman',
    county_fips: 20095,
    county_fips_all: '20095|20155',
    county: 'Kingman',
    county_names_all: 'Kingman|Reno',
    county_weights: '{"20095": 91.51, "20155": 8.49}',
    density: 5.4,
    imprecise: false,
    latitude: 37.61991,
    longitude: -98.11473,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67068',
  },
  {
    city: 'Kiowa',
    county_fips: 20007,
    county_fips_all: '20007',
    county: 'Barber',
    county_names_all: 'Barber',
    county_weights: '{"20007": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 37.0696,
    longitude: -98.53204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67070',
  },
  {
    city: 'Lake City',
    county_fips: 20007,
    county_fips_all: '20007',
    county: 'Barber',
    county_names_all: 'Barber',
    county_weights: '{"20007": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.21423,
    longitude: -98.88522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67071',
  },
  {
    city: 'Latham',
    county_fips: 20015,
    county_fips_all: '20015|20035',
    county: 'Butler',
    county_names_all: 'Butler|Cowley',
    county_weights: '{"20015": 90.57, "20035": 9.43}',
    density: 1,
    imprecise: false,
    latitude: 37.5445,
    longitude: -96.61632,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67072',
  },
  {
    city: 'Lehigh',
    county_fips: 20115,
    county_fips_all: '20115',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"20115": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 38.39167,
    longitude: -97.32624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67073',
  },
  {
    city: 'Leon',
    county_fips: 20015,
    county_fips_all: '20015',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"20015": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 37.67038,
    longitude: -96.72945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67074',
  },
  {
    city: 'Maize',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 176.5,
    imprecise: false,
    latitude: 37.78489,
    longitude: -97.46356,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67101',
  },
  {
    city: 'Mayfield',
    county_fips: 20191,
    county_fips_all: '20191',
    county: 'Sumner',
    county_names_all: 'Sumner',
    county_weights: '{"20191": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 37.26439,
    longitude: -97.55977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67103',
  },
  {
    city: 'Medicine Lodge',
    county_fips: 20007,
    county_fips_all: '20007',
    county: 'Barber',
    county_names_all: 'Barber',
    county_weights: '{"20007": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 37.27286,
    longitude: -98.65223,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67104',
  },
  {
    city: 'Milan',
    county_fips: 20191,
    county_fips_all: '20191',
    county: 'Sumner',
    county_names_all: 'Sumner',
    county_weights: '{"20191": 100}',
    density: 1,
    imprecise: false,
    latitude: 37.22001,
    longitude: -97.67825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67105',
  },
  {
    city: 'Milton',
    county_fips: 20191,
    county_fips_all: '20191|20173|20095',
    county: 'Sumner',
    county_names_all: 'Sumner|Sedgwick|Kingman',
    county_weights: '{"20191": 55.77, "20173": 41.33, "20095": 2.9}',
    density: 4.4,
    imprecise: false,
    latitude: 37.46335,
    longitude: -97.75804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67106',
  },
  {
    city: 'Moundridge',
    county_fips: 20113,
    county_fips_all: '20113|20079',
    county: 'McPherson',
    county_names_all: 'McPherson|Harvey',
    county_weights: '{"20113": 69.78, "20079": 30.22}',
    density: 8.2,
    imprecise: false,
    latitude: 38.19496,
    longitude: -97.53911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67107',
  },
  {
    city: 'Mount Hope',
    county_fips: 20173,
    county_fips_all: '20173|20155',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick|Reno',
    county_weights: '{"20173": 61.35, "20155": 38.65}',
    density: 7.5,
    imprecise: false,
    latitude: 37.81428,
    longitude: -97.68621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67108',
  },
  {
    city: 'Mullinville',
    county_fips: 20097,
    county_fips_all: '20097',
    county: 'Kiowa',
    county_names_all: 'Kiowa',
    county_weights: '{"20097": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 37.56448,
    longitude: -99.47914,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67109',
  },
  {
    city: 'Mulvane',
    county_fips: 20191,
    county_fips_all: '20191|20173|20035',
    county: 'Sumner',
    county_names_all: 'Sumner|Sedgwick|Cowley',
    county_weights: '{"20191": 52.82, "20173": 44.13, "20035": 3.05}',
    density: 62.1,
    imprecise: false,
    latitude: 37.47022,
    longitude: -97.22425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67110',
  },
  {
    city: 'Murdock',
    county_fips: 20095,
    county_fips_all: '20095',
    county: 'Kingman',
    county_names_all: 'Kingman',
    county_weights: '{"20095": 100}',
    density: 2,
    imprecise: false,
    latitude: 37.6151,
    longitude: -97.93453,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67111',
  },
  {
    city: 'Nashville',
    county_fips: 20095,
    county_fips_all: '20095|20007',
    county: 'Kingman',
    county_names_all: 'Kingman|Barber',
    county_weights: '{"20095": 80.84, "20007": 19.16}',
    density: 1.2,
    imprecise: false,
    latitude: 37.44915,
    longitude: -98.41941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67112',
  },
  {
    city: 'Newton',
    county_fips: 20079,
    county_fips_all: '20079|20115|20015|20113',
    county: 'Harvey',
    county_names_all: 'Harvey|Marion|Butler|McPherson',
    county_weights:
      '{"20079": 71.96, "20115": 13.59, "20015": 13.08, "20113": 1.37}',
    density: 34.1,
    imprecise: false,
    latitude: 38.07034,
    longitude: -97.28359,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67114',
  },
  {
    city: 'North Newton',
    county_fips: 20079,
    county_fips_all: '20079',
    county: 'Harvey',
    county_names_all: 'Harvey',
    county_weights: '{"20079": 100}',
    density: 620.2,
    imprecise: false,
    latitude: 38.07416,
    longitude: -97.34544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67117',
  },
  {
    city: 'Norwich',
    county_fips: 20095,
    county_fips_all: '20095|20173|20077|20191',
    county: 'Kingman',
    county_names_all: 'Kingman|Sedgwick|Harper|Sumner',
    county_weights:
      '{"20095": 90.38, "20173": 5.55, "20077": 2.24, "20191": 1.83}',
    density: 3.4,
    imprecise: false,
    latitude: 37.47829,
    longitude: -97.8605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67118',
  },
  {
    city: 'Oxford',
    county_fips: 20191,
    county_fips_all: '20191|20035',
    county: 'Sumner',
    county_names_all: 'Sumner|Cowley',
    county_weights: '{"20191": 73.02, "20035": 26.98}',
    density: 6.5,
    imprecise: false,
    latitude: 37.24202,
    longitude: -97.18152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67119',
  },
  {
    city: 'Peck',
    county_fips: 20191,
    county_fips_all: '20191|20173',
    county: 'Sumner',
    county_names_all: 'Sumner|Sedgwick',
    county_weights: '{"20191": 61.35, "20173": 38.65}',
    density: 5.7,
    imprecise: false,
    latitude: 37.46591,
    longitude: -97.37592,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67120',
  },
  {
    city: 'Piedmont',
    county_fips: 20073,
    county_fips_all: '20073|20049',
    county: 'Greenwood',
    county_names_all: 'Greenwood|Elk',
    county_weights: '{"20073": 57.85, "20049": 42.15}',
    density: 0.9,
    imprecise: false,
    latitude: 37.62015,
    longitude: -96.42392,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67122',
  },
  {
    city: 'Potwin',
    county_fips: 20015,
    county_fips_all: '20015',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"20015": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 37.94676,
    longitude: -96.99352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67123',
  },
  {
    city: 'Pratt',
    county_fips: 20151,
    county_fips_all: '20151',
    county: 'Pratt',
    county_names_all: 'Pratt',
    county_weights: '{"20151": 100}',
    density: 11,
    imprecise: false,
    latitude: 37.63644,
    longitude: -98.77236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67124',
  },
  {
    city: 'Protection',
    county_fips: 20033,
    county_fips_all: '20033|20025',
    county: 'Comanche',
    county_names_all: 'Comanche|Clark',
    county_weights: '{"20033": 88.44, "20025": 11.56}',
    density: 1.5,
    imprecise: false,
    latitude: 37.16009,
    longitude: -99.49057,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67127',
  },
  {
    city: 'Rock',
    county_fips: 20035,
    county_fips_all: '20035',
    county: 'Cowley',
    county_names_all: 'Cowley',
    county_weights: '{"20035": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 37.43261,
    longitude: -96.94958,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67131',
  },
  {
    city: 'Rosalia',
    county_fips: 20015,
    county_fips_all: '20015',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"20015": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 37.8504,
    longitude: -96.58385,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67132',
  },
  {
    city: 'Rose Hill',
    county_fips: 20015,
    county_fips_all: '20015|20173',
    county: 'Butler',
    county_names_all: 'Butler|Sedgwick',
    county_weights: '{"20015": 99.4, "20173": 0.6}',
    density: 63.9,
    imprecise: false,
    latitude: 37.57677,
    longitude: -97.10451,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67133',
  },
  {
    city: 'Sawyer',
    county_fips: 20151,
    county_fips_all: '20151|20007',
    county: 'Pratt',
    county_names_all: 'Pratt|Barber',
    county_weights: '{"20151": 64.72, "20007": 35.28}',
    density: 1.6,
    imprecise: false,
    latitude: 37.48474,
    longitude: -98.6824,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67134',
  },
  {
    city: 'Sedgwick',
    county_fips: 20079,
    county_fips_all: '20079|20173',
    county: 'Harvey',
    county_names_all: 'Harvey|Sedgwick',
    county_weights: '{"20079": 51.73, "20173": 48.27}',
    density: 13.7,
    imprecise: false,
    latitude: 37.91362,
    longitude: -97.45942,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67135',
  },
  {
    city: 'Severy',
    county_fips: 20073,
    county_fips_all: '20073|20049',
    county: 'Greenwood',
    county_names_all: 'Greenwood|Elk',
    county_weights: '{"20073": 71.45, "20049": 28.55}',
    density: 1.7,
    imprecise: false,
    latitude: 37.63145,
    longitude: -96.22196,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67137',
  },
  {
    city: 'Sharon',
    county_fips: 20007,
    county_fips_all: '20007',
    county: 'Barber',
    county_names_all: 'Barber',
    county_weights: '{"20007": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 37.25996,
    longitude: -98.41858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67138',
  },
  {
    city: 'South Haven',
    county_fips: 20191,
    county_fips_all: '20191',
    county: 'Sumner',
    county_names_all: 'Sumner',
    county_weights: '{"20191": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 37.07992,
    longitude: -97.35748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67140',
  },
  {
    city: 'Spivey',
    county_fips: 20095,
    county_fips_all: '20095',
    county: 'Kingman',
    county_names_all: 'Kingman',
    county_weights: '{"20095": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 37.45655,
    longitude: -98.1094,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67142',
  },
  {
    city: 'Sun City',
    county_fips: 20007,
    county_fips_all: '20007',
    county: 'Barber',
    county_names_all: 'Barber',
    county_weights: '{"20007": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 37.33284,
    longitude: -98.94434,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67143',
  },
  {
    city: 'Towanda',
    county_fips: 20015,
    county_fips_all: '20015',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"20015": 100}',
    density: 22.2,
    imprecise: false,
    latitude: 37.81673,
    longitude: -97.00539,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67144',
  },
  {
    city: 'Udall',
    county_fips: 20035,
    county_fips_all: '20035|20191',
    county: 'Cowley',
    county_names_all: 'Cowley|Sumner',
    county_weights: '{"20035": 86.13, "20191": 13.87}',
    density: 9.3,
    imprecise: false,
    latitude: 37.39016,
    longitude: -97.10398,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67146',
  },
  {
    city: 'Valley Center',
    county_fips: 20173,
    county_fips_all: '20173|20079',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick|Harvey',
    county_weights: '{"20173": 92.34, "20079": 7.66}',
    density: 40.2,
    imprecise: false,
    latitude: 37.86062,
    longitude: -97.3058,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67147',
  },
  {
    city: 'Viola',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 37.54243,
    longitude: -97.62915,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67149',
  },
  {
    city: 'Waldron',
    county_fips: 20077,
    county_fips_all: '20077',
    county: 'Harper',
    county_names_all: 'Harper',
    county_weights: '{"20077": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 37.03207,
    longitude: -98.20187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67150',
  },
  {
    city: 'Walton',
    county_fips: 20079,
    county_fips_all: '20079|20115',
    county: 'Harvey',
    county_names_all: 'Harvey|Marion',
    county_weights: '{"20079": 84.63, "20115": 15.37}',
    density: 4.8,
    imprecise: false,
    latitude: 38.14499,
    longitude: -97.24934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67151',
  },
  {
    city: 'Wellington',
    county_fips: 20191,
    county_fips_all: '20191',
    county: 'Sumner',
    county_names_all: 'Sumner',
    county_weights: '{"20191": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 37.2623,
    longitude: -97.41104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67152',
  },
  {
    city: 'Whitewater',
    county_fips: 20015,
    county_fips_all: '20015|20079',
    county: 'Butler',
    county_names_all: 'Butler|Harvey',
    county_weights: '{"20015": 69.73, "20079": 30.27}',
    density: 6.8,
    imprecise: false,
    latitude: 37.97079,
    longitude: -97.12117,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67154',
  },
  {
    city: 'Wilmore',
    county_fips: 20033,
    county_fips_all: '20033|20097',
    county: 'Comanche',
    county_names_all: 'Comanche|Kiowa',
    county_weights: '{"20033": 87.07, "20097": 12.93}',
    density: 0.1,
    imprecise: false,
    latitude: 37.28171,
    longitude: -99.13233,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67155',
  },
  {
    city: 'Winfield',
    county_fips: 20035,
    county_fips_all: '20035',
    county: 'Cowley',
    county_names_all: 'Cowley',
    county_weights: '{"20035": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 37.25099,
    longitude: -96.96503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67156',
  },
  {
    city: 'Zenda',
    county_fips: 20095,
    county_fips_all: '20095|20077',
    county: 'Kingman',
    county_names_all: 'Kingman|Harper',
    county_weights: '{"20095": 68.68, "20077": 31.32}',
    density: 0.9,
    imprecise: false,
    latitude: 37.42053,
    longitude: -98.30948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67159',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 818.1,
    imprecise: false,
    latitude: 37.68668,
    longitude: -97.33521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67202',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 1655.5,
    imprecise: false,
    latitude: 37.70402,
    longitude: -97.36497,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67203',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 541.1,
    imprecise: false,
    latitude: 37.77167,
    longitude: -97.36341,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67204',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 459.9,
    imprecise: false,
    latitude: 37.75012,
    longitude: -97.42317,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67205',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 639.7,
    imprecise: false,
    latitude: 37.70363,
    longitude: -97.22461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67206',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 1015.9,
    imprecise: false,
    latitude: 37.66567,
    longitude: -97.22923,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67207',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 1468.9,
    imprecise: false,
    latitude: 37.70449,
    longitude: -97.27928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67208',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 417.4,
    imprecise: false,
    latitude: 37.6639,
    longitude: -97.43463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67209',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 281.2,
    imprecise: false,
    latitude: 37.62944,
    longitude: -97.24604,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67210',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 1455.2,
    imprecise: false,
    latitude: 37.66708,
    longitude: -97.31706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67211',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 1322.8,
    imprecise: false,
    latitude: 37.70247,
    longitude: -97.43658,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67212',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 1157.9,
    imprecise: false,
    latitude: 37.66722,
    longitude: -97.36498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67213',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 1101,
    imprecise: false,
    latitude: 37.70661,
    longitude: -97.31755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67214',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 160.2,
    imprecise: false,
    latitude: 37.61637,
    longitude: -97.42707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67215',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 733.1,
    imprecise: false,
    latitude: 37.6089,
    longitude: -97.3143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67216',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 872.5,
    imprecise: false,
    latitude: 37.61535,
    longitude: -97.36239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67217',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 1812.6,
    imprecise: false,
    latitude: 37.66851,
    longitude: -97.28039,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67218',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 335.8,
    imprecise: false,
    latitude: 37.76931,
    longitude: -97.31643,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67219',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 873.7,
    imprecise: false,
    latitude: 37.75191,
    longitude: -97.27909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67220',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 90.1,
    imprecise: false,
    latitude: 37.74195,
    longitude: -97.49797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67223',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 338,
    imprecise: false,
    latitude: 37.76898,
    longitude: -97.21915,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67226',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 37.62693,
    longitude: -97.50109,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67227',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 75.3,
    imprecise: false,
    latitude: 37.77749,
    longitude: -97.17274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67228',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173|20015',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick|Butler',
    county_weights: '{"20173": 99.4, "20015": 0.6}',
    density: 474,
    imprecise: false,
    latitude: 37.68655,
    longitude: -97.17087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67230',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 76.2,
    imprecise: false,
    latitude: 37.6368,
    longitude: -97.16802,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67232',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 534.9,
    imprecise: false,
    latitude: 37.68951,
    longitude: -97.49929,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67235',
  },
  {
    city: 'Independence',
    county_fips: 20125,
    county_fips_all: '20125',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"20125": 100}',
    density: 23.3,
    imprecise: false,
    latitude: 37.21092,
    longitude: -95.75224,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67301',
  },
  {
    city: 'Altamont',
    county_fips: 20099,
    county_fips_all: '20099',
    county: 'Labette',
    county_names_all: 'Labette',
    county_weights: '{"20099": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 37.163,
    longitude: -95.31238,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67330',
  },
  {
    city: 'Bartlett',
    county_fips: 20099,
    county_fips_all: '20099',
    county: 'Labette',
    county_names_all: 'Labette',
    county_weights: '{"20099": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 37.04345,
    longitude: -95.23281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67332',
  },
  {
    city: 'Caney',
    county_fips: 20125,
    county_fips_all: '20125',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"20125": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 37.04695,
    longitude: -95.87253,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67333',
  },
  {
    city: 'Chautauqua',
    county_fips: 20019,
    county_fips_all: '20019',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"20019": 100}',
    density: 82.8,
    imprecise: false,
    latitude: 37.0241,
    longitude: -96.17736,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67334',
  },
  {
    city: 'Cherryvale',
    county_fips: 20125,
    county_fips_all: '20125|20099|20205',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Labette|Wilson',
    county_weights: '{"20125": 56.95, "20099": 41.0, "20205": 2.05}',
    density: 9.9,
    imprecise: false,
    latitude: 37.28005,
    longitude: -95.53381,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67335',
  },
  {
    city: 'Chetopa',
    county_fips: 20021,
    county_fips_all: '20021|20099',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Labette',
    county_weights: '{"20021": 55.71, "20099": 44.29}',
    density: 4.9,
    imprecise: false,
    latitude: 37.05385,
    longitude: -95.07489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67336',
  },
  {
    city: 'Coffeyville',
    county_fips: 20125,
    county_fips_all: '20125|20099',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Labette',
    county_weights: '{"20125": 71.82, "20099": 28.18}',
    density: 28.5,
    imprecise: false,
    latitude: 37.05486,
    longitude: -95.5993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67337',
  },
  {
    city: 'Dearing',
    county_fips: 20125,
    county_fips_all: '20125',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"20125": 100}',
    density: 100.2,
    imprecise: false,
    latitude: 37.05948,
    longitude: -95.71207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67340',
  },
  {
    city: 'Dennis',
    county_fips: 20099,
    county_fips_all: '20099',
    county: 'Labette',
    county_names_all: 'Labette',
    county_weights: '{"20099": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 37.34406,
    longitude: -95.42963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67341',
  },
  {
    city: 'Edna',
    county_fips: 20099,
    county_fips_all: '20099',
    county: 'Labette',
    county_names_all: 'Labette',
    county_weights: '{"20099": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 37.05877,
    longitude: -95.35513,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67342',
  },
  {
    city: 'Elk City',
    county_fips: 20125,
    county_fips_all: '20125|20019|20049',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Chautauqua|Elk',
    county_weights: '{"20125": 54.71, "20019": 32.72, "20049": 12.57}',
    density: 1.7,
    imprecise: false,
    latitude: 37.28875,
    longitude: -95.9514,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67344',
  },
  {
    city: 'Elk Falls',
    county_fips: 20049,
    county_fips_all: '20049',
    county: 'Elk',
    county_names_all: 'Elk',
    county_weights: '{"20049": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 37.37122,
    longitude: -96.20075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67345',
  },
  {
    city: 'Grenola',
    county_fips: 20049,
    county_fips_all: '20049|20019',
    county: 'Elk',
    county_names_all: 'Elk|Chautauqua',
    county_weights: '{"20049": 55.5, "20019": 44.5}',
    density: 0.9,
    imprecise: false,
    latitude: 37.31774,
    longitude: -96.44511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67346',
  },
  {
    city: 'Havana',
    county_fips: 20125,
    county_fips_all: '20125|20019',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Chautauqua',
    county_weights: '{"20125": 60.67, "20019": 39.33}',
    density: 3.2,
    imprecise: false,
    latitude: 37.12559,
    longitude: -95.95188,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67347',
  },
  {
    city: 'Howard',
    county_fips: 20049,
    county_fips_all: '20049',
    county: 'Elk',
    county_names_all: 'Elk',
    county_weights: '{"20049": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 37.48811,
    longitude: -96.28066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67349',
  },
  {
    city: 'Liberty',
    county_fips: 20125,
    county_fips_all: '20125|20099',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Labette',
    county_weights: '{"20125": 80.21, "20099": 19.79}',
    density: 2.9,
    imprecise: false,
    latitude: 37.14066,
    longitude: -95.56698,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67351',
  },
  {
    city: 'Longton',
    county_fips: 20049,
    county_fips_all: '20049|20019',
    county: 'Elk',
    county_names_all: 'Elk|Chautauqua',
    county_weights: '{"20049": 77.98, "20019": 22.02}',
    density: 1.7,
    imprecise: false,
    latitude: 37.3574,
    longitude: -96.08154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67352',
  },
  {
    city: 'Moline',
    county_fips: 20049,
    county_fips_all: '20049|20019',
    county: 'Elk',
    county_names_all: 'Elk|Chautauqua',
    county_weights: '{"20049": 60.61, "20019": 39.39}',
    density: 2.4,
    imprecise: false,
    latitude: 37.31371,
    longitude: -96.31151,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67353',
  },
  {
    city: 'Mound Valley',
    county_fips: 20099,
    county_fips_all: '20099',
    county: 'Labette',
    county_names_all: 'Labette',
    county_weights: '{"20099": 100}',
    density: 5,
    imprecise: false,
    latitude: 37.20727,
    longitude: -95.41126,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67354',
  },
  {
    city: 'Niotaze',
    county_fips: 20019,
    county_fips_all: '20019',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"20019": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 37.03275,
    longitude: -96.00974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67355',
  },
  {
    city: 'Oswego',
    county_fips: 20099,
    county_fips_all: '20099|20021',
    county: 'Labette',
    county_names_all: 'Labette|Cherokee',
    county_weights: '{"20099": 92.32, "20021": 7.68}',
    density: 8.7,
    imprecise: false,
    latitude: 37.17886,
    longitude: -95.14161,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67356',
  },
  {
    city: 'Parsons',
    county_fips: 20099,
    county_fips_all: '20099|20133',
    county: 'Labette',
    county_names_all: 'Labette|Neosho',
    county_weights: '{"20099": 73.44, "20133": 26.56}',
    density: 23.2,
    imprecise: false,
    latitude: 37.33951,
    longitude: -95.25261,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67357',
  },
  {
    city: 'Peru',
    county_fips: 20019,
    county_fips_all: '20019',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"20019": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 37.05148,
    longitude: -96.09702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67360',
  },
  {
    city: 'Sedan',
    county_fips: 20019,
    county_fips_all: '20019',
    county: 'Chautauqua',
    county_names_all: 'Chautauqua',
    county_weights: '{"20019": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 37.13733,
    longitude: -96.21714,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67361',
  },
  {
    city: 'Sycamore',
    county_fips: 20125,
    county_fips_all: '20125',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"20125": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.32934,
    longitude: -95.71819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67363',
  },
  {
    city: 'Tyro',
    county_fips: 20125,
    county_fips_all: '20125',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"20125": 100}',
    density: 164.6,
    imprecise: false,
    latitude: 37.03683,
    longitude: -95.82184,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67364',
  },
  {
    city: 'Salina',
    county_fips: 20169,
    county_fips_all: '20169|20143',
    county: 'Saline',
    county_names_all: 'Saline|Ottawa',
    county_weights: '{"20169": 95.54, "20143": 4.46}',
    density: 76.9,
    imprecise: false,
    latitude: 38.83554,
    longitude: -97.64621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67401',
  },
  {
    city: 'Abilene',
    county_fips: 20041,
    county_fips_all: '20041|20027',
    county: 'Dickinson',
    county_names_all: 'Dickinson|Clay',
    county_weights: '{"20041": 99.45, "20027": 0.55}',
    density: 12.3,
    imprecise: false,
    latitude: 38.95632,
    longitude: -97.22104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67410',
  },
  {
    city: 'Assaria',
    county_fips: 20169,
    county_fips_all: '20169|20113',
    county: 'Saline',
    county_names_all: 'Saline|McPherson',
    county_weights: '{"20169": 87.37, "20113": 12.63}',
    density: 5.3,
    imprecise: false,
    latitude: 38.66505,
    longitude: -97.5718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67416',
  },
  {
    city: 'Aurora',
    county_fips: 20029,
    county_fips_all: '20029',
    county: 'Cloud',
    county_names_all: 'Cloud',
    county_weights: '{"20029": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 39.43382,
    longitude: -97.55015,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67417',
  },
  {
    city: 'Barnard',
    county_fips: 20105,
    county_fips_all: '20105|20123',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Mitchell',
    county_weights: '{"20105": 75.37, "20123": 24.63}',
    density: 0.6,
    imprecise: false,
    latitude: 39.18692,
    longitude: -98.05214,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67418',
  },
  {
    city: 'Beloit',
    county_fips: 20123,
    county_fips_all: '20123|20029|20089',
    county: 'Mitchell',
    county_names_all: 'Mitchell|Cloud|Jewell',
    county_weights: '{"20123": 93.49, "20029": 5.79, "20089": 0.72}',
    density: 3.5,
    imprecise: false,
    latitude: 39.40035,
    longitude: -98.08527,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67420',
  },
  {
    city: 'Bennington',
    county_fips: 20143,
    county_fips_all: '20143',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"20143": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 39.03127,
    longitude: -97.59849,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67422',
  },
  {
    city: 'Beverly',
    county_fips: 20105,
    county_fips_all: '20105',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"20105": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 38.97018,
    longitude: -97.98058,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67423',
  },
  {
    city: 'Brookville',
    county_fips: 20169,
    county_fips_all: '20169|20053',
    county: 'Saline',
    county_names_all: 'Saline|Ellsworth',
    county_weights: '{"20169": 55.19, "20053": 44.81}',
    density: 1.1,
    imprecise: false,
    latitude: 38.77991,
    longitude: -97.92492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67425',
  },
  {
    city: 'Bushton',
    county_fips: 20159,
    county_fips_all: '20159|20053',
    county: 'Rice',
    county_names_all: 'Rice|Ellsworth',
    county_weights: '{"20159": 68.6, "20053": 31.4}',
    density: 2.1,
    imprecise: false,
    latitude: 38.50364,
    longitude: -98.39977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67427',
  },
  {
    city: 'Canton',
    county_fips: 20113,
    county_fips_all: '20113|20115',
    county: 'McPherson',
    county_names_all: 'McPherson|Marion',
    county_weights: '{"20113": 86.55, "20115": 13.45}',
    density: 4,
    imprecise: false,
    latitude: 38.3832,
    longitude: -97.41405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67428',
  },
  {
    city: 'Cawker City',
    county_fips: 20089,
    county_fips_all: '20089|20123|20183|20141',
    county: 'Jewell',
    county_names_all: 'Jewell|Mitchell|Smith|Osborne',
    county_weights:
      '{"20089": 51.38, "20123": 39.73, "20183": 5.99, "20141": 2.9}',
    density: 1.8,
    imprecise: false,
    latitude: 39.57571,
    longitude: -98.44193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67430',
  },
  {
    city: 'Chapman',
    county_fips: 20041,
    county_fips_all: '20041',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"20041": 100}',
    density: 7,
    imprecise: false,
    latitude: 38.95833,
    longitude: -97.01179,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67431',
  },
  {
    city: 'Clay Center',
    county_fips: 20027,
    county_fips_all: '20027|20143|20161',
    county: 'Clay',
    county_names_all: 'Clay|Ottawa|Riley',
    county_weights: '{"20027": 90.24, "20143": 9.37, "20161": 0.39}',
    density: 6,
    imprecise: false,
    latitude: 39.33503,
    longitude: -97.17997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67432',
  },
  {
    city: 'Delphos',
    county_fips: 20143,
    county_fips_all: '20143|20029',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Cloud',
    county_weights: '{"20143": 75.15, "20029": 24.85}',
    density: 1.9,
    imprecise: false,
    latitude: 39.28071,
    longitude: -97.72454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67436',
  },
  {
    city: 'Downs',
    county_fips: 20141,
    county_fips_all: '20141|20183',
    county: 'Osborne',
    county_names_all: 'Osborne|Smith',
    county_weights: '{"20141": 77.3, "20183": 22.7}',
    density: 3.1,
    imprecise: false,
    latitude: 39.50705,
    longitude: -98.55857,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67437',
  },
  {
    city: 'Durham',
    county_fips: 20115,
    county_fips_all: '20115',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"20115": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 38.50366,
    longitude: -97.27861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67438',
  },
  {
    city: 'Ellsworth',
    county_fips: 20053,
    county_fips_all: '20053|20105',
    county: 'Ellsworth',
    county_names_all: 'Ellsworth|Lincoln',
    county_weights: '{"20053": 95.39, "20105": 4.61}',
    density: 5.9,
    imprecise: false,
    latitude: 38.76169,
    longitude: -98.2201,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67439',
  },
  {
    city: 'Enterprise',
    county_fips: 20041,
    county_fips_all: '20041',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"20041": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 38.87712,
    longitude: -97.10399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67441',
  },
  {
    city: 'Falun',
    county_fips: 20169,
    county_fips_all: '20169',
    county: 'Saline',
    county_names_all: 'Saline',
    county_weights: '{"20169": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 38.64939,
    longitude: -97.78073,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67442',
  },
  {
    city: 'Galva',
    county_fips: 20113,
    county_fips_all: '20113',
    county: 'McPherson',
    county_names_all: 'McPherson',
    county_weights: '{"20113": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 38.37801,
    longitude: -97.5208,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67443',
  },
  {
    city: 'Geneseo',
    county_fips: 20053,
    county_fips_all: '20053|20159',
    county: 'Ellsworth',
    county_names_all: 'Ellsworth|Rice',
    county_weights: '{"20053": 61.06, "20159": 38.94}',
    density: 1.5,
    imprecise: false,
    latitude: 38.54759,
    longitude: -98.12702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67444',
  },
  {
    city: 'Glasco',
    county_fips: 20029,
    county_fips_all: '20029|20143',
    county: 'Cloud',
    county_names_all: 'Cloud|Ottawa',
    county_weights: '{"20029": 89.88, "20143": 10.12}',
    density: 1.9,
    imprecise: false,
    latitude: 39.37789,
    longitude: -97.8172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67445',
  },
  {
    city: 'Glen Elder',
    county_fips: 20123,
    county_fips_all: '20123|20089',
    county: 'Mitchell',
    county_names_all: 'Mitchell|Jewell',
    county_weights: '{"20123": 85.17, "20089": 14.83}',
    density: 1.9,
    imprecise: false,
    latitude: 39.47442,
    longitude: -98.32363,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67446',
  },
  {
    city: 'Green',
    county_fips: 20027,
    county_fips_all: '20027|20161',
    county: 'Clay',
    county_names_all: 'Clay|Riley',
    county_weights: '{"20027": 58.94, "20161": 41.06}',
    density: 1,
    imprecise: false,
    latitude: 39.48048,
    longitude: -96.97153,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67447',
  },
  {
    city: 'Gypsum',
    county_fips: 20169,
    county_fips_all: '20169|20041|20113',
    county: 'Saline',
    county_names_all: 'Saline|Dickinson|McPherson',
    county_weights: '{"20169": 45.29, "20041": 29.56, "20113": 25.15}',
    density: 2.3,
    imprecise: false,
    latitude: 38.65826,
    longitude: -97.40756,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67448',
  },
  {
    city: 'Herington',
    county_fips: 20127,
    county_fips_all: '20127|20041',
    county: 'Morris',
    county_names_all: 'Morris|Dickinson',
    county_weights: '{"20127": 64.3, "20041": 35.7}',
    density: 6.8,
    imprecise: false,
    latitude: 38.68214,
    longitude: -96.89569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67449',
  },
  {
    city: 'Holyrood',
    county_fips: 20053,
    county_fips_all: '20053|20009',
    county: 'Ellsworth',
    county_names_all: 'Ellsworth|Barton',
    county_weights: '{"20053": 69.87, "20009": 30.13}',
    density: 3.3,
    imprecise: false,
    latitude: 38.62746,
    longitude: -98.45788,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67450',
  },
  {
    city: 'Hope',
    county_fips: 20041,
    county_fips_all: '20041|20115',
    county: 'Dickinson',
    county_names_all: 'Dickinson|Marion',
    county_weights: '{"20041": 98.79, "20115": 1.21}',
    density: 2.3,
    imprecise: false,
    latitude: 38.70094,
    longitude: -97.13157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67451',
  },
  {
    city: 'Hunter',
    county_fips: 20123,
    county_fips_all: '20123|20105',
    county: 'Mitchell',
    county_names_all: 'Mitchell|Lincoln',
    county_weights: '{"20123": 55.65, "20105": 44.35}',
    density: 1.1,
    imprecise: false,
    latitude: 39.23549,
    longitude: -98.36935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67452',
  },
  {
    city: 'Kanopolis',
    county_fips: 20053,
    county_fips_all: '20053',
    county: 'Ellsworth',
    county_names_all: 'Ellsworth',
    county_weights: '{"20053": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 38.69808,
    longitude: -98.11308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67454',
  },
  {
    city: 'Lincoln',
    county_fips: 20105,
    county_fips_all: '20105',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"20105": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 39.02765,
    longitude: -98.16478,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67455',
  },
  {
    city: 'Lindsborg',
    county_fips: 20113,
    county_fips_all: '20113|20169',
    county: 'McPherson',
    county_names_all: 'McPherson|Saline',
    county_weights: '{"20113": 68.54, "20169": 31.46}',
    density: 13.4,
    imprecise: false,
    latitude: 38.5949,
    longitude: -97.6769,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67456',
  },
  {
    city: 'Little River',
    county_fips: 20159,
    county_fips_all: '20159',
    county: 'Rice',
    county_names_all: 'Rice',
    county_weights: '{"20159": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 38.38746,
    longitude: -97.99143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67457',
  },
  {
    city: 'Longford',
    county_fips: 20027,
    county_fips_all: '20027|20143',
    county: 'Clay',
    county_names_all: 'Clay|Ottawa',
    county_weights: '{"20027": 76.21, "20143": 23.79}',
    density: 2.1,
    imprecise: false,
    latitude: 39.16595,
    longitude: -97.30441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67458',
  },
  {
    city: 'Lorraine',
    county_fips: 20053,
    county_fips_all: '20053',
    county: 'Ellsworth',
    county_names_all: 'Ellsworth',
    county_weights: '{"20053": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 38.60781,
    longitude: -98.33913,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67459',
  },
  {
    city: 'Mcpherson',
    county_fips: 20113,
    county_fips_all: '20113',
    county: 'McPherson',
    county_names_all: 'McPherson',
    county_weights: '{"20113": 100}',
    density: 27.8,
    imprecise: false,
    latitude: 38.38431,
    longitude: -97.69719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67460',
  },
  {
    city: 'Marquette',
    county_fips: 20113,
    county_fips_all: '20113|20053',
    county: 'McPherson',
    county_names_all: 'McPherson|Ellsworth',
    county_weights: '{"20113": 57.77, "20053": 42.23}',
    density: 3.6,
    imprecise: false,
    latitude: 38.56537,
    longitude: -97.90143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67464',
  },
  {
    city: 'Miltonvale',
    county_fips: 20029,
    county_fips_all: '20029|20143|20027',
    county: 'Cloud',
    county_names_all: 'Cloud|Ottawa|Clay',
    county_weights: '{"20029": 58.61, "20143": 31.64, "20027": 9.75}',
    density: 1.9,
    imprecise: false,
    latitude: 39.32787,
    longitude: -97.47905,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67466',
  },
  {
    city: 'Minneapolis',
    county_fips: 20143,
    county_fips_all: '20143|20105',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Lincoln',
    county_weights: '{"20143": 99.64, "20105": 0.36}',
    density: 4,
    imprecise: false,
    latitude: 39.14639,
    longitude: -97.69907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67467',
  },
  {
    city: 'Morganville',
    county_fips: 20027,
    county_fips_all: '20027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"20027": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 39.45791,
    longitude: -97.25697,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67468',
  },
  {
    city: 'New Cambria',
    county_fips: 20169,
    county_fips_all: '20169|20143',
    county: 'Saline',
    county_names_all: 'Saline|Ottawa',
    county_weights: '{"20169": 86.24, "20143": 13.76}',
    density: 1.9,
    imprecise: false,
    latitude: 38.91077,
    longitude: -97.49513,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67470',
  },
  {
    city: 'Osborne',
    county_fips: 20141,
    county_fips_all: '20141',
    county: 'Osborne',
    county_names_all: 'Osborne',
    county_weights: '{"20141": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 39.37567,
    longitude: -98.73356,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67473',
  },
  {
    city: 'Portis',
    county_fips: 20183,
    county_fips_all: '20183|20141',
    county: 'Smith',
    county_names_all: 'Smith|Osborne',
    county_weights: '{"20183": 53.94, "20141": 46.06}',
    density: 0.4,
    imprecise: false,
    latitude: 39.58523,
    longitude: -98.70771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67474',
  },
  {
    city: 'Ramona',
    county_fips: 20115,
    county_fips_all: '20115|20041',
    county: 'Marion',
    county_names_all: 'Marion|Dickinson',
    county_weights: '{"20115": 78.05, "20041": 21.95}',
    density: 1.7,
    imprecise: false,
    latitude: 38.58761,
    longitude: -97.05853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67475',
  },
  {
    city: 'Roxbury',
    county_fips: 20113,
    county_fips_all: '20113',
    county: 'McPherson',
    county_names_all: 'McPherson',
    county_weights: '{"20113": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.54867,
    longitude: -97.43047,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67476',
  },
  {
    city: 'Simpson',
    county_fips: 20123,
    county_fips_all: '20123',
    county: 'Mitchell',
    county_names_all: 'Mitchell',
    county_weights: '{"20123": 100}',
    density: 33.2,
    imprecise: false,
    latitude: 39.38572,
    longitude: -97.94988,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67478',
  },
  {
    city: 'Solomon',
    county_fips: 20143,
    county_fips_all: '20143|20041|20169',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Dickinson|Saline',
    county_weights: '{"20143": 47.29, "20041": 32.7, "20169": 20.01}',
    density: 3.3,
    imprecise: false,
    latitude: 38.97073,
    longitude: -97.40282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67480',
  },
  {
    city: 'Sylvan Grove',
    county_fips: 20105,
    county_fips_all: '20105|20167',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Russell',
    county_weights: '{"20105": 97.66, "20167": 2.34}',
    density: 1.6,
    imprecise: false,
    latitude: 39.01244,
    longitude: -98.38903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67481',
  },
  {
    city: 'Talmage',
    county_fips: 20041,
    county_fips_all: '20041',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"20041": 100}',
    density: 173.1,
    imprecise: false,
    latitude: 39.02686,
    longitude: -97.25976,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67482',
  },
  {
    city: 'Tampa',
    county_fips: 20115,
    county_fips_all: '20115',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"20115": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 38.55322,
    longitude: -97.19856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67483',
  },
  {
    city: 'Tescott',
    county_fips: 20143,
    county_fips_all: '20143|20169|20105',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Saline|Lincoln',
    county_weights: '{"20143": 67.17, "20169": 24.1, "20105": 8.73}',
    density: 2.4,
    imprecise: false,
    latitude: 38.99603,
    longitude: -97.83617,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67484',
  },
  {
    city: 'Tipton',
    county_fips: 20141,
    county_fips_all: '20141|20123',
    county: 'Osborne',
    county_names_all: 'Osborne|Mitchell',
    county_weights: '{"20141": 51.54, "20123": 48.46}',
    density: 1.3,
    imprecise: false,
    latitude: 39.31474,
    longitude: -98.49492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67485',
  },
  {
    city: 'Wakefield',
    county_fips: 20027,
    county_fips_all: '20027|20041|20061',
    county: 'Clay',
    county_names_all: 'Clay|Dickinson|Geary',
    county_weights: '{"20027": 81.25, "20041": 12.93, "20061": 5.82}',
    density: 6,
    imprecise: false,
    latitude: 39.17628,
    longitude: -97.06653,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67487',
  },
  {
    city: 'Wilson',
    county_fips: 20053,
    county_fips_all: '20053|20167|20105',
    county: 'Ellsworth',
    county_names_all: 'Ellsworth|Russell|Lincoln',
    county_weights: '{"20053": 59.45, "20167": 32.44, "20105": 8.11}',
    density: 2.6,
    imprecise: false,
    latitude: 38.79223,
    longitude: -98.44722,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67490',
  },
  {
    city: 'Windom',
    county_fips: 20113,
    county_fips_all: '20113|20159',
    county: 'McPherson',
    county_names_all: 'McPherson|Rice',
    county_weights: '{"20113": 78.88, "20159": 21.12}',
    density: 2,
    imprecise: false,
    latitude: 38.38837,
    longitude: -97.90051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67491',
  },
  {
    city: 'Woodbine',
    county_fips: 20041,
    county_fips_all: '20041',
    county: 'Dickinson',
    county_names_all: 'Dickinson',
    county_weights: '{"20041": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 38.81558,
    longitude: -96.96418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67492',
  },
  {
    city: 'Hutchinson',
    county_fips: 20155,
    county_fips_all: '20155',
    county: 'Reno',
    county_names_all: 'Reno',
    county_weights: '{"20155": 100}',
    density: 50.5,
    imprecise: false,
    latitude: 37.97989,
    longitude: -97.9309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67501',
  },
  {
    city: 'Hutchinson',
    county_fips: 20155,
    county_fips_all: '20155|20159',
    county: 'Reno',
    county_names_all: 'Reno|Rice',
    county_weights: '{"20155": 98.65, "20159": 1.35}',
    density: 121.6,
    imprecise: false,
    latitude: 38.12146,
    longitude: -97.92673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67502',
  },
  {
    city: 'South Hutchinson',
    county_fips: 20155,
    county_fips_all: '20155',
    county: 'Reno',
    county_names_all: 'Reno',
    county_weights: '{"20155": 100}',
    density: 386.9,
    imprecise: false,
    latitude: 38.02855,
    longitude: -97.94333,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67505',
  },
  {
    city: 'Abbyville',
    county_fips: 20155,
    county_fips_all: '20155',
    county: 'Reno',
    county_names_all: 'Reno',
    county_weights: '{"20155": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 37.99839,
    longitude: -98.21127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67510',
  },
  {
    city: 'Albert',
    county_fips: 20165,
    county_fips_all: '20165|20009',
    county: 'Rush',
    county_names_all: 'Rush|Barton',
    county_weights: '{"20165": 64.07, "20009": 35.93}',
    density: 0.8,
    imprecise: false,
    latitude: 38.43365,
    longitude: -99.05058,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67511',
  },
  {
    city: 'Alden',
    county_fips: 20159,
    county_fips_all: '20159|20155',
    county: 'Rice',
    county_names_all: 'Rice|Reno',
    county_weights: '{"20159": 96.02, "20155": 3.98}',
    density: 1.8,
    imprecise: false,
    latitude: 38.23289,
    longitude: -98.32645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67512',
  },
  {
    city: 'Alexander',
    county_fips: 20165,
    county_fips_all: '20165',
    county: 'Rush',
    county_names_all: 'Rush',
    county_weights: '{"20165": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 38.43892,
    longitude: -99.53846,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67513',
  },
  {
    city: 'Arlington',
    county_fips: 20155,
    county_fips_all: '20155',
    county: 'Reno',
    county_names_all: 'Reno',
    county_weights: '{"20155": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 37.86278,
    longitude: -98.19714,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67514',
  },
  {
    city: 'Arnold',
    county_fips: 20135,
    county_fips_all: '20135',
    county: 'Ness',
    county_names_all: 'Ness',
    county_weights: '{"20135": 100}',
    density: 1,
    imprecise: false,
    latitude: 38.59935,
    longitude: -100.06518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 59,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67515',
  },
  {
    city: 'Bazine',
    county_fips: 20135,
    county_fips_all: '20135',
    county: 'Ness',
    county_names_all: 'Ness',
    county_weights: '{"20135": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 38.38768,
    longitude: -99.68486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67516',
  },
  {
    city: 'Beeler',
    county_fips: 20135,
    county_fips_all: '20135|20101',
    county: 'Ness',
    county_names_all: 'Ness|Lane',
    county_weights: '{"20135": 92.55, "20101": 7.45}',
    density: 0.1,
    imprecise: false,
    latitude: 38.40403,
    longitude: -100.17343,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67518',
  },
  {
    city: 'Belpre',
    county_fips: 20047,
    county_fips_all: '20047|20145',
    county: 'Edwards',
    county_names_all: 'Edwards|Pawnee',
    county_weights: '{"20047": 87.46, "20145": 12.54}',
    density: 0.8,
    imprecise: false,
    latitude: 37.93573,
    longitude: -99.10292,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67519',
  },
  {
    city: 'Bison',
    county_fips: 20165,
    county_fips_all: '20165',
    county: 'Rush',
    county_names_all: 'Rush',
    county_weights: '{"20165": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 38.58781,
    longitude: -99.18302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67520',
  },
  {
    city: 'Brownell',
    county_fips: 20135,
    county_fips_all: '20135|20195',
    county: 'Ness',
    county_names_all: 'Ness|Trego',
    county_weights: '{"20135": 78.22, "20195": 21.78}',
    density: 0.3,
    imprecise: false,
    latitude: 38.62575,
    longitude: -99.72253,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67521',
  },
  {
    city: 'Buhler',
    county_fips: 20155,
    county_fips_all: '20155|20079',
    county: 'Reno',
    county_names_all: 'Reno|Harvey',
    county_weights: '{"20155": 78.3, "20079": 21.7}',
    density: 14.6,
    imprecise: false,
    latitude: 38.12294,
    longitude: -97.74608,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67522',
  },
  {
    city: 'Burdett',
    county_fips: 20145,
    county_fips_all: '20145|20083',
    county: 'Pawnee',
    county_names_all: 'Pawnee|Hodgeman',
    county_weights: '{"20145": 65.75, "20083": 34.25}',
    density: 1.3,
    imprecise: false,
    latitude: 38.19687,
    longitude: -99.55256,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67523',
  },
  {
    city: 'Chase',
    county_fips: 20159,
    county_fips_all: '20159',
    county: 'Rice',
    county_names_all: 'Rice',
    county_weights: '{"20159": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 38.37797,
    longitude: -98.37398,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67524',
  },
  {
    city: 'Claflin',
    county_fips: 20009,
    county_fips_all: '20009|20159',
    county: 'Barton',
    county_names_all: 'Barton|Rice',
    county_weights: '{"20009": 97.56, "20159": 2.44}',
    density: 2.1,
    imprecise: false,
    latitude: 38.57205,
    longitude: -98.57111,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67525',
  },
  {
    city: 'Ellinwood',
    county_fips: 20009,
    county_fips_all: '20009|20185|20159',
    county: 'Barton',
    county_names_all: 'Barton|Stafford|Rice',
    county_weights: '{"20009": 57.11, "20185": 36.2, "20159": 6.69}',
    density: 4.7,
    imprecise: false,
    latitude: 38.29764,
    longitude: -98.54711,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67526',
  },
  {
    city: 'Garfield',
    county_fips: 20145,
    county_fips_all: '20145',
    county: 'Pawnee',
    county_names_all: 'Pawnee',
    county_weights: '{"20145": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 38.0728,
    longitude: -99.25436,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67529',
  },
  {
    city: 'Great Bend',
    county_fips: 20009,
    county_fips_all: '20009|20185',
    county: 'Barton',
    county_names_all: 'Barton|Stafford',
    county_weights: '{"20009": 90.9, "20185": 9.1}',
    density: 28.9,
    imprecise: false,
    latitude: 38.35149,
    longitude: -98.79678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67530',
  },
  {
    city: 'Haven',
    county_fips: 20155,
    county_fips_all: '20155',
    county: 'Reno',
    county_names_all: 'Reno',
    county_weights: '{"20155": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 37.88346,
    longitude: -97.79511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67543',
  },
  {
    city: 'Hoisington',
    county_fips: 20009,
    county_fips_all: '20009',
    county: 'Barton',
    county_names_all: 'Barton',
    county_weights: '{"20009": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 38.57584,
    longitude: -98.75456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67544',
  },
  {
    city: 'Hudson',
    county_fips: 20185,
    county_fips_all: '20185',
    county: 'Stafford',
    county_names_all: 'Stafford',
    county_weights: '{"20185": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 38.17644,
    longitude: -98.6417,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67545',
  },
  {
    city: 'Inman',
    county_fips: 20113,
    county_fips_all: '20113|20159|20155|20079',
    county: 'McPherson',
    county_names_all: 'McPherson|Rice|Reno|Harvey',
    county_weights:
      '{"20113": 79.79, "20159": 16.41, "20155": 3.11, "20079": 0.69}',
    density: 7.2,
    imprecise: false,
    latitude: 38.22811,
    longitude: -97.82116,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67546',
  },
  {
    city: 'Kinsley',
    county_fips: 20047,
    county_fips_all: '20047|20083',
    county: 'Edwards',
    county_names_all: 'Edwards|Hodgeman',
    county_weights: '{"20047": 84.53, "20083": 15.47}',
    density: 2.1,
    imprecise: false,
    latitude: 37.93926,
    longitude: -99.46526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67547',
  },
  {
    city: 'La Crosse',
    county_fips: 20165,
    county_fips_all: '20165',
    county: 'Rush',
    county_names_all: 'Rush',
    county_weights: '{"20165": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 38.59299,
    longitude: -99.33579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67548',
  },
  {
    city: 'Larned',
    county_fips: 20145,
    county_fips_all: '20145|20185',
    county: 'Pawnee',
    county_names_all: 'Pawnee|Stafford',
    county_weights: '{"20145": 99.35, "20185": 0.65}',
    density: 6.5,
    imprecise: false,
    latitude: 38.18121,
    longitude: -99.12487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67550',
  },
  {
    city: 'Lewis',
    county_fips: 20047,
    county_fips_all: '20047',
    county: 'Edwards',
    county_names_all: 'Edwards',
    county_weights: '{"20047": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 37.8606,
    longitude: -99.23651,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67552',
  },
  {
    city: 'Liebenthal',
    county_fips: 20165,
    county_fips_all: '20165',
    county: 'Rush',
    county_names_all: 'Rush',
    county_weights: '{"20165": 100}',
    density: 299.1,
    imprecise: false,
    latitude: 38.65444,
    longitude: -99.32017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67553',
  },
  {
    city: 'Lyons',
    county_fips: 20159,
    county_fips_all: '20159',
    county: 'Rice',
    county_names_all: 'Rice',
    county_weights: '{"20159": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 38.37489,
    longitude: -98.1858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67554',
  },
  {
    city: 'McCracken',
    county_fips: 20165,
    county_fips_all: '20165|20135|20051',
    county: 'Rush',
    county_names_all: 'Rush|Ness|Ellis',
    county_weights: '{"20165": 64.13, "20135": 23.16, "20051": 12.71}',
    density: 0.6,
    imprecise: false,
    latitude: 38.60719,
    longitude: -99.52436,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67556',
  },
  {
    city: 'Macksville',
    county_fips: 20185,
    county_fips_all: '20185|20145|20151|20047',
    county: 'Stafford',
    county_names_all: 'Stafford|Pawnee|Pratt|Edwards',
    county_weights:
      '{"20185": 58.39, "20145": 18.45, "20151": 14.63, "20047": 8.53}',
    density: 2,
    imprecise: false,
    latitude: 37.91557,
    longitude: -98.96678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67557',
  },
  {
    city: 'Nekoma',
    county_fips: 20165,
    county_fips_all: '20165|20145',
    county: 'Rush',
    county_names_all: 'Rush|Pawnee',
    county_weights: '{"20165": 65.93, "20145": 34.07}',
    density: 0.3,
    imprecise: false,
    latitude: 38.37645,
    longitude: -99.44966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67559',
  },
  {
    city: 'Ness City',
    county_fips: 20135,
    county_fips_all: '20135',
    county: 'Ness',
    county_names_all: 'Ness',
    county_weights: '{"20135": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 38.39781,
    longitude: -99.94818,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67560',
  },
  {
    city: 'Nickerson',
    county_fips: 20155,
    county_fips_all: '20155',
    county: 'Reno',
    county_names_all: 'Reno',
    county_weights: '{"20155": 100}',
    density: 9,
    imprecise: false,
    latitude: 38.10427,
    longitude: -98.09921,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67561',
  },
  {
    city: 'Offerle',
    county_fips: 20047,
    county_fips_all: '20047|20057|20083',
    county: 'Edwards',
    county_names_all: 'Edwards|Ford|Hodgeman',
    county_weights: '{"20047": 51.98, "20057": 40.39, "20083": 7.63}',
    density: 1.2,
    imprecise: false,
    latitude: 37.84627,
    longitude: -99.55931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67563',
  },
  {
    city: 'Olmitz',
    county_fips: 20009,
    county_fips_all: '20009',
    county: 'Barton',
    county_names_all: 'Barton',
    county_weights: '{"20009": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 38.52855,
    longitude: -98.92845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67564',
  },
  {
    city: 'Otis',
    county_fips: 20165,
    county_fips_all: '20165|20009|20051',
    county: 'Rush',
    county_names_all: 'Rush|Barton|Ellis',
    county_weights: '{"20165": 58.88, "20009": 40.12, "20051": 1.0}',
    density: 1.7,
    imprecise: false,
    latitude: 38.60428,
    longitude: -99.04439,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67565',
  },
  {
    city: 'Partridge',
    county_fips: 20155,
    county_fips_all: '20155',
    county: 'Reno',
    county_names_all: 'Reno',
    county_weights: '{"20155": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 37.944,
    longitude: -98.09938,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67566',
  },
  {
    city: 'Pawnee Rock',
    county_fips: 20145,
    county_fips_all: '20145|20009|20185|20165',
    county: 'Pawnee',
    county_names_all: 'Pawnee|Barton|Stafford|Rush',
    county_weights:
      '{"20145": 44.9, "20009": 39.4, "20185": 12.53, "20165": 3.18}',
    density: 2.6,
    imprecise: false,
    latitude: 38.26632,
    longitude: -98.97241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67567',
  },
  {
    city: 'Plevna',
    county_fips: 20155,
    county_fips_all: '20155',
    county: 'Reno',
    county_names_all: 'Reno',
    county_weights: '{"20155": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 38.01729,
    longitude: -98.30888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67568',
  },
  {
    city: 'Pretty Prairie',
    county_fips: 20155,
    county_fips_all: '20155|20095',
    county: 'Reno',
    county_names_all: 'Reno|Kingman',
    county_weights: '{"20155": 90.32, "20095": 9.68}',
    density: 4.4,
    imprecise: false,
    latitude: 37.78686,
    longitude: -97.968,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67570',
  },
  {
    city: 'Ransom',
    county_fips: 20135,
    county_fips_all: '20135|20195',
    county: 'Ness',
    county_names_all: 'Ness|Trego',
    county_weights: '{"20135": 51.86, "20195": 48.14}',
    density: 0.8,
    imprecise: false,
    latitude: 38.68663,
    longitude: -99.90825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67572',
  },
  {
    city: 'Raymond',
    county_fips: 20159,
    county_fips_all: '20159',
    county: 'Rice',
    county_names_all: 'Rice',
    county_weights: '{"20159": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 38.26215,
    longitude: -98.41518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67573',
  },
  {
    city: 'Rozel',
    county_fips: 20145,
    county_fips_all: '20145',
    county: 'Pawnee',
    county_names_all: 'Pawnee',
    county_weights: '{"20145": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 38.22045,
    longitude: -99.39185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67574',
  },
  {
    city: 'Rush Center',
    county_fips: 20165,
    county_fips_all: '20165|20145',
    county: 'Rush',
    county_names_all: 'Rush|Pawnee',
    county_weights: '{"20165": 85.16, "20145": 14.84}',
    density: 1,
    imprecise: false,
    latitude: 38.40711,
    longitude: -99.25681,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67575',
  },
  {
    city: 'St John',
    county_fips: 20185,
    county_fips_all: '20185|20151',
    county: 'Stafford',
    county_names_all: 'Stafford|Pratt',
    county_weights: '{"20185": 99.75, "20151": 0.25}',
    density: 2.2,
    imprecise: false,
    latitude: 38.03228,
    longitude: -98.79343,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67576',
  },
  {
    city: 'Stafford',
    county_fips: 20185,
    county_fips_all: '20185',
    county: 'Stafford',
    county_names_all: 'Stafford',
    county_weights: '{"20185": 100}',
    density: 2,
    imprecise: false,
    latitude: 37.96922,
    longitude: -98.59105,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67578',
  },
  {
    city: 'Sterling',
    county_fips: 20159,
    county_fips_all: '20159|20155',
    county: 'Rice',
    county_names_all: 'Rice|Reno',
    county_weights: '{"20159": 59.61, "20155": 40.39}',
    density: 5.9,
    imprecise: false,
    latitude: 38.18615,
    longitude: -98.20861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67579',
  },
  {
    city: 'Sylvia',
    county_fips: 20155,
    county_fips_all: '20155',
    county: 'Reno',
    county_names_all: 'Reno',
    county_weights: '{"20155": 100}',
    density: 1,
    imprecise: false,
    latitude: 37.99316,
    longitude: -98.41068,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67581',
  },
  {
    city: 'Turon',
    county_fips: 20155,
    county_fips_all: '20155|20151|20185',
    county: 'Reno',
    county_names_all: 'Reno|Pratt|Stafford',
    county_weights: '{"20155": 47.26, "20151": 43.24, "20185": 9.5}',
    density: 1.4,
    imprecise: false,
    latitude: 37.79997,
    longitude: -98.4714,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67583',
  },
  {
    city: 'Utica',
    county_fips: 20135,
    county_fips_all: '20135|20195|20063|20101',
    county: 'Ness',
    county_names_all: 'Ness|Trego|Gove|Lane',
    county_weights:
      '{"20135": 45.4, "20195": 25.47, "20063": 21.08, "20101": 8.05}',
    density: 0.3,
    imprecise: false,
    latitude: 38.6847,
    longitude: -100.16072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67584',
  },
  {
    city: 'Hays',
    county_fips: 20051,
    county_fips_all: '20051',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"20051": 100}',
    density: 26.1,
    imprecise: false,
    latitude: 38.873,
    longitude: -99.34032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67601',
  },
  {
    city: 'Agra',
    county_fips: 20147,
    county_fips_all: '20147',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"20147": 100}',
    density: 2,
    imprecise: false,
    latitude: 39.82866,
    longitude: -99.12891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67621',
  },
  {
    city: 'Almena',
    county_fips: 20137,
    county_fips_all: '20137|20147',
    county: 'Norton',
    county_names_all: 'Norton|Phillips',
    county_weights: '{"20137": 96.35, "20147": 3.65}',
    density: 2,
    imprecise: false,
    latitude: 39.89983,
    longitude: -99.72522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67622',
  },
  {
    city: 'Alton',
    county_fips: 20141,
    county_fips_all: '20141|20183',
    county: 'Osborne',
    county_names_all: 'Osborne|Smith',
    county_weights: '{"20141": 95.5, "20183": 4.5}',
    density: 0.5,
    imprecise: false,
    latitude: 39.45363,
    longitude: -98.95627,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67623',
  },
  {
    city: 'Bogue',
    county_fips: 20065,
    county_fips_all: '20065',
    county: 'Graham',
    county_names_all: 'Graham',
    county_weights: '{"20065": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 39.39145,
    longitude: -99.68293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67625',
  },
  {
    city: 'Bunker Hill',
    county_fips: 20167,
    county_fips_all: '20167',
    county: 'Russell',
    county_names_all: 'Russell',
    county_weights: '{"20167": 100}',
    density: 1,
    imprecise: false,
    latitude: 38.88375,
    longitude: -98.70808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67626',
  },
  {
    city: 'Catharine',
    county_fips: 20051,
    county_fips_all: '20051',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"20051": 100}',
    density: 91.4,
    imprecise: false,
    latitude: 38.92224,
    longitude: -99.21343,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67627',
  },
  {
    city: 'Cedar',
    county_fips: 20183,
    county_fips_all: '20183',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"20183": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 39.62741,
    longitude: -98.99598,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67628',
  },
  {
    city: 'Clayton',
    county_fips: 20137,
    county_fips_all: '20137|20039',
    county: 'Norton',
    county_names_all: 'Norton|Decatur',
    county_weights: '{"20137": 53.64, "20039": 46.36}',
    density: 0.1,
    imprecise: false,
    latitude: 39.70199,
    longitude: -100.18031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67629',
  },
  {
    city: 'Collyer',
    county_fips: 20195,
    county_fips_all: '20195|20065|20179',
    county: 'Trego',
    county_names_all: 'Trego|Graham|Sheridan',
    county_weights: '{"20195": 85.5, "20065": 13.29, "20179": 1.21}',
    density: 0.2,
    imprecise: false,
    latitude: 39.00837,
    longitude: -100.08569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67631',
  },
  {
    city: 'Damar',
    county_fips: 20163,
    county_fips_all: '20163|20065',
    county: 'Rooks',
    county_names_all: 'Rooks|Graham',
    county_weights: '{"20163": 64.58, "20065": 35.42}',
    density: 1.2,
    imprecise: false,
    latitude: 39.33557,
    longitude: -99.58362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67632',
  },
  {
    city: 'Dorrance',
    county_fips: 20167,
    county_fips_all: '20167',
    county: 'Russell',
    county_names_all: 'Russell',
    county_weights: '{"20167": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 38.82654,
    longitude: -98.6073,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67634',
  },
  {
    city: 'Dresden',
    county_fips: 20039,
    county_fips_all: '20039|20179',
    county: 'Decatur',
    county_names_all: 'Decatur|Sheridan',
    county_weights: '{"20039": 69.76, "20179": 30.24}',
    density: 0.5,
    imprecise: false,
    latitude: 39.60025,
    longitude: -100.45484,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67635',
  },
  {
    city: 'Ellis',
    county_fips: 20051,
    county_fips_all: '20051|20195|20065',
    county: 'Ellis',
    county_names_all: 'Ellis|Trego|Graham',
    county_weights: '{"20051": 50.23, "20195": 48.6, "20065": 1.17}',
    density: 3,
    imprecise: false,
    latitude: 38.94008,
    longitude: -99.59197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67637',
  },
  {
    city: 'Gaylord',
    county_fips: 20183,
    county_fips_all: '20183',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"20183": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 39.63418,
    longitude: -98.8534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67638',
  },
  {
    city: 'Glade',
    county_fips: 20147,
    county_fips_all: '20147|20163',
    county: 'Phillips',
    county_names_all: 'Phillips|Rooks',
    county_weights: '{"20147": 95.91, "20163": 4.09}',
    density: 1,
    imprecise: false,
    latitude: 39.62649,
    longitude: -99.32133,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67639',
  },
  {
    city: 'Gorham',
    county_fips: 20051,
    county_fips_all: '20051|20167',
    county: 'Ellis',
    county_names_all: 'Ellis|Russell',
    county_weights: '{"20051": 55.27, "20167": 44.73}',
    density: 2,
    imprecise: false,
    latitude: 38.89853,
    longitude: -99.04925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67640',
  },
  {
    city: 'Hill City',
    county_fips: 20065,
    county_fips_all: '20065',
    county: 'Graham',
    county_names_all: 'Graham',
    county_weights: '{"20065": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 39.36989,
    longitude: -99.8315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67642',
  },
  {
    city: 'Jennings',
    county_fips: 20039,
    county_fips_all: '20039|20179',
    county: 'Decatur',
    county_names_all: 'Decatur|Sheridan',
    county_weights: '{"20039": 75.91, "20179": 24.09}',
    density: 0.4,
    imprecise: false,
    latitude: 39.6406,
    longitude: -100.29135,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67643',
  },
  {
    city: 'Kirwin',
    county_fips: 20147,
    county_fips_all: '20147|20163',
    county: 'Phillips',
    county_names_all: 'Phillips|Rooks',
    county_weights: '{"20147": 93.86, "20163": 6.14}',
    density: 0.8,
    imprecise: false,
    latitude: 39.63104,
    longitude: -99.15993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67644',
  },
  {
    city: 'Lenora',
    county_fips: 20137,
    county_fips_all: '20137|20065',
    county: 'Norton',
    county_names_all: 'Norton|Graham',
    county_weights: '{"20137": 70.35, "20065": 29.65}',
    density: 0.7,
    imprecise: false,
    latitude: 39.60144,
    longitude: -99.89604,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67645',
  },
  {
    city: 'Logan',
    county_fips: 20147,
    county_fips_all: '20147|20137|20163|20065',
    county: 'Phillips',
    county_names_all: 'Phillips|Norton|Rooks|Graham',
    county_weights:
      '{"20147": 55.58, "20137": 25.81, "20163": 12.9, "20065": 5.71}',
    density: 1.4,
    imprecise: false,
    latitude: 39.63921,
    longitude: -99.58654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67646',
  },
  {
    city: 'Long Island',
    county_fips: 20147,
    county_fips_all: '20147',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"20147": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 39.93794,
    longitude: -99.53162,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67647',
  },
  {
    city: 'Lucas',
    county_fips: 20167,
    county_fips_all: '20167|20141|20105',
    county: 'Russell',
    county_names_all: 'Russell|Osborne|Lincoln',
    county_weights: '{"20167": 67.5, "20141": 27.96, "20105": 4.54}',
    density: 1.1,
    imprecise: false,
    latitude: 39.07746,
    longitude: -98.57278,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67648',
  },
  {
    city: 'Luray',
    county_fips: 20167,
    county_fips_all: '20167|20141',
    county: 'Russell',
    county_names_all: 'Russell|Osborne',
    county_weights: '{"20167": 50.61, "20141": 49.39}',
    density: 0.8,
    imprecise: false,
    latitude: 39.13404,
    longitude: -98.69232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67649',
  },
  {
    city: 'Morland',
    county_fips: 20065,
    county_fips_all: '20065',
    county: 'Graham',
    county_names_all: 'Graham',
    county_weights: '{"20065": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 39.37477,
    longitude: -100.09925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67650',
  },
  {
    city: 'Natoma',
    county_fips: 20141,
    county_fips_all: '20141|20163|20051|20167',
    county: 'Osborne',
    county_names_all: 'Osborne|Rooks|Ellis|Russell',
    county_weights:
      '{"20141": 42.2, "20163": 40.29, "20051": 13.19, "20167": 4.33}',
    density: 1,
    imprecise: false,
    latitude: 39.20926,
    longitude: -99.03969,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67651',
  },
  {
    city: 'Norcatur',
    county_fips: 20039,
    county_fips_all: '20039|20137',
    county: 'Decatur',
    county_names_all: 'Decatur|Norton',
    county_weights: '{"20039": 61.58, "20137": 38.42}',
    density: 0.5,
    imprecise: false,
    latitude: 39.90873,
    longitude: -100.20554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67653',
  },
  {
    city: 'Norton',
    county_fips: 20137,
    county_fips_all: '20137',
    county: 'Norton',
    county_names_all: 'Norton',
    county_weights: '{"20137": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 39.83067,
    longitude: -99.95573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67654',
  },
  {
    city: 'Ogallah',
    county_fips: 20195,
    county_fips_all: '20195|20065',
    county: 'Trego',
    county_names_all: 'Trego|Graham',
    county_weights: '{"20195": 88.78, "20065": 11.22}',
    density: 0.7,
    imprecise: false,
    latitude: 38.98565,
    longitude: -99.75549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67656',
  },
  {
    city: 'Palco',
    county_fips: 20163,
    county_fips_all: '20163|20065|20195',
    county: 'Rooks',
    county_names_all: 'Rooks|Graham|Trego',
    county_weights: '{"20163": 50.32, "20065": 48.57, "20195": 1.11}',
    density: 1.1,
    imprecise: false,
    latitude: 39.21126,
    longitude: -99.60811,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67657',
  },
  {
    city: 'Paradise',
    county_fips: 20167,
    county_fips_all: '20167|20141',
    county: 'Russell',
    county_names_all: 'Russell|Osborne',
    county_weights: '{"20167": 64.21, "20141": 35.79}',
    density: 0.5,
    imprecise: false,
    latitude: 39.11524,
    longitude: -98.92786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67658',
  },
  {
    city: 'Penokee',
    county_fips: 20065,
    county_fips_all: '20065',
    county: 'Graham',
    county_names_all: 'Graham',
    county_weights: '{"20065": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 39.31804,
    longitude: -100.00496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67659',
  },
  {
    city: 'Pfeifer',
    county_fips: 20051,
    county_fips_all: '20051',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"20051": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 38.71752,
    longitude: -99.14806,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67660',
  },
  {
    city: 'Phillipsburg',
    county_fips: 20147,
    county_fips_all: '20147',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"20147": 100}',
    density: 3,
    imprecise: false,
    latitude: 39.82546,
    longitude: -99.33039,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67661',
  },
  {
    city: 'Plainville',
    county_fips: 20163,
    county_fips_all: '20163|20051',
    county: 'Rooks',
    county_names_all: 'Rooks|Ellis',
    county_weights: '{"20163": 76.7, "20051": 23.3}',
    density: 2.7,
    imprecise: false,
    latitude: 39.20597,
    longitude: -99.34222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67663',
  },
  {
    city: 'Prairie View',
    county_fips: 20147,
    county_fips_all: '20147|20137',
    county: 'Phillips',
    county_names_all: 'Phillips|Norton',
    county_weights: '{"20147": 69.01, "20137": 30.99}',
    density: 1.2,
    imprecise: false,
    latitude: 39.81609,
    longitude: -99.5875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67664',
  },
  {
    city: 'Russell',
    county_fips: 20167,
    county_fips_all: '20167|20009',
    county: 'Russell',
    county_names_all: 'Russell|Barton',
    county_weights: '{"20167": 93.73, "20009": 6.27}',
    density: 5.8,
    imprecise: false,
    latitude: 38.847,
    longitude: -98.88022,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67665',
  },
  {
    city: 'Schoenchen',
    county_fips: 20051,
    county_fips_all: '20051',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"20051": 100}',
    density: 562,
    imprecise: false,
    latitude: 38.71304,
    longitude: -99.33249,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67667',
  },
  {
    city: 'Stockton',
    county_fips: 20163,
    county_fips_all: '20163',
    county: 'Rooks',
    county_names_all: 'Rooks',
    county_weights: '{"20163": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 39.45631,
    longitude: -99.34914,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67669',
  },
  {
    city: 'Victoria',
    county_fips: 20051,
    county_fips_all: '20051',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"20051": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 38.87559,
    longitude: -99.14432,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67671',
  },
  {
    city: 'Wakeeney',
    county_fips: 20195,
    county_fips_all: '20195|20065',
    county: 'Trego',
    county_names_all: 'Trego|Graham',
    county_weights: '{"20195": 84.32, "20065": 15.68}',
    density: 2.7,
    imprecise: false,
    latitude: 38.99882,
    longitude: -99.90746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67672',
  },
  {
    city: 'Waldo',
    county_fips: 20141,
    county_fips_all: '20141|20167',
    county: 'Osborne',
    county_names_all: 'Osborne|Russell',
    county_weights: '{"20141": 58.5, "20167": 41.5}',
    density: 0.2,
    imprecise: false,
    latitude: 39.14708,
    longitude: -98.80714,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67673',
  },
  {
    city: 'Walker',
    county_fips: 20051,
    county_fips_all: '20051',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"20051": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 38.87446,
    longitude: -99.08197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67674',
  },
  {
    city: 'Woodston',
    county_fips: 20163,
    county_fips_all: '20163|20141',
    county: 'Rooks',
    county_names_all: 'Rooks|Osborne',
    county_weights: '{"20163": 96.79, "20141": 3.21}',
    density: 0.5,
    imprecise: false,
    latitude: 39.42612,
    longitude: -99.09994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67675',
  },
  {
    city: 'Colby',
    county_fips: 20193,
    county_fips_all: '20193|20153',
    county: 'Thomas',
    county_names_all: 'Thomas|Rawlins',
    county_weights: '{"20193": 87.16, "20153": 12.84}',
    density: 5.3,
    imprecise: false,
    latitude: 39.39509,
    longitude: -101.05034,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67701',
  },
  {
    city: 'Atwood',
    county_fips: 20153,
    county_fips_all: '20153',
    county: 'Rawlins',
    county_names_all: 'Rawlins',
    county_weights: '{"20153": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 39.80366,
    longitude: -101.11624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67730',
  },
  {
    city: 'Bird City',
    county_fips: 20023,
    county_fips_all: '20023|20153',
    county: 'Cheyenne',
    county_names_all: 'Cheyenne|Rawlins',
    county_weights: '{"20023": 99.7, "20153": 0.3}',
    density: 1.1,
    imprecise: false,
    latitude: 39.76277,
    longitude: -101.53858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67731',
  },
  {
    city: 'Brewster',
    county_fips: 20193,
    county_fips_all: '20193|20181|20109|20153',
    county: 'Thomas',
    county_names_all: 'Thomas|Sherman|Logan|Rawlins',
    county_weights:
      '{"20193": 50.04, "20181": 27.32, "20109": 12.96, "20153": 9.68}',
    density: 0.8,
    imprecise: false,
    latitude: 39.37333,
    longitude: -101.3708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67732',
  },
  {
    city: 'Edson',
    county_fips: 20181,
    county_fips_all: '20181',
    county: 'Sherman',
    county_names_all: 'Sherman',
    county_weights: '{"20181": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 39.32998,
    longitude: -101.50653,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67733',
  },
  {
    city: 'Gem',
    county_fips: 20193,
    county_fips_all: '20193|20153',
    county: 'Thomas',
    county_names_all: 'Thomas|Rawlins',
    county_weights: '{"20193": 58.84, "20153": 41.16}',
    density: 0.7,
    imprecise: false,
    latitude: 39.54241,
    longitude: -100.89298,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67734',
  },
  {
    city: 'Goodland',
    county_fips: 20181,
    county_fips_all: '20181|20023',
    county: 'Sherman',
    county_names_all: 'Sherman|Cheyenne',
    county_weights: '{"20181": 98.72, "20023": 1.28}',
    density: 3.2,
    imprecise: false,
    latitude: 39.35119,
    longitude: -101.76646,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67735',
  },
  {
    city: 'Gove',
    county_fips: 20063,
    county_fips_all: '20063',
    county: 'Gove',
    county_names_all: 'Gove',
    county_weights: '{"20063": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 38.85492,
    longitude: -100.44715,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67736',
  },
  {
    city: 'Grainfield',
    county_fips: 20063,
    county_fips_all: '20063|20179',
    county: 'Gove',
    county_names_all: 'Gove|Sheridan',
    county_weights: '{"20063": 62.64, "20179": 37.36}',
    density: 1,
    imprecise: false,
    latitude: 39.08798,
    longitude: -100.49367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67737',
  },
  {
    city: 'Grinnell',
    county_fips: 20063,
    county_fips_all: '20063|20179',
    county: 'Gove',
    county_names_all: 'Gove|Sheridan',
    county_weights: '{"20063": 78.4, "20179": 21.6}',
    density: 0.8,
    imprecise: false,
    latitude: 39.0027,
    longitude: -100.65348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67738',
  },
  {
    city: 'Herndon',
    county_fips: 20153,
    county_fips_all: '20153|20039',
    county: 'Rawlins',
    county_names_all: 'Rawlins|Decatur',
    county_weights: '{"20153": 95.81, "20039": 4.19}',
    density: 0.9,
    imprecise: false,
    latitude: 39.8848,
    longitude: -100.80581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67739',
  },
  {
    city: 'Hoxie',
    county_fips: 20179,
    county_fips_all: '20179|20065',
    county: 'Sheridan',
    county_names_all: 'Sheridan|Graham',
    county_weights: '{"20179": 96.94, "20065": 3.06}',
    density: 1.5,
    imprecise: false,
    latitude: 39.35576,
    longitude: -100.36089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67740',
  },
  {
    city: 'Kanorado',
    county_fips: 20181,
    county_fips_all: '20181|20023',
    county: 'Sherman',
    county_names_all: 'Sherman|Cheyenne',
    county_weights: '{"20181": 87.58, "20023": 12.42}',
    density: 0.7,
    imprecise: false,
    latitude: 39.38269,
    longitude: -102.00822,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67741',
  },
  {
    city: 'Levant',
    county_fips: 20193,
    county_fips_all: '20193|20153',
    county: 'Thomas',
    county_names_all: 'Thomas|Rawlins',
    county_weights: '{"20193": 90.12, "20153": 9.88}',
    density: 0.5,
    imprecise: false,
    latitude: 39.38826,
    longitude: -101.24121,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67743',
  },
  {
    city: 'Ludell',
    county_fips: 20153,
    county_fips_all: '20153',
    county: 'Rawlins',
    county_names_all: 'Rawlins',
    county_weights: '{"20153": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 39.85952,
    longitude: -100.94095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67744',
  },
  {
    city: 'McDonald',
    county_fips: 20153,
    county_fips_all: '20153|20023',
    county: 'Rawlins',
    county_names_all: 'Rawlins|Cheyenne',
    county_weights: '{"20153": 83.85, "20023": 16.15}',
    density: 0.6,
    imprecise: false,
    latitude: 39.8147,
    longitude: -101.34795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67745',
  },
  {
    city: 'Monument',
    county_fips: 20109,
    county_fips_all: '20109|20193',
    county: 'Logan',
    county_names_all: 'Logan|Thomas',
    county_weights: '{"20109": 92.84, "20193": 7.16}',
    density: 0.4,
    imprecise: false,
    latitude: 39.04208,
    longitude: -101.06099,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67747',
  },
  {
    city: 'Oakley',
    county_fips: 20109,
    county_fips_all: '20109|20193|20063|20179',
    county: 'Logan',
    county_names_all: 'Logan|Thomas|Gove|Sheridan',
    county_weights:
      '{"20109": 41.41, "20193": 33.79, "20063": 23.12, "20179": 1.68}',
    density: 2.4,
    imprecise: false,
    latitude: 39.06507,
    longitude: -100.85643,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67748',
  },
  {
    city: 'Oberlin',
    county_fips: 20039,
    county_fips_all: '20039|20153',
    county: 'Decatur',
    county_names_all: 'Decatur|Rawlins',
    county_weights: '{"20039": 93.93, "20153": 6.07}',
    density: 1.9,
    imprecise: false,
    latitude: 39.83214,
    longitude: -100.56728,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67749',
  },
  {
    city: 'Park',
    county_fips: 20063,
    county_fips_all: '20063|20179',
    county: 'Gove',
    county_names_all: 'Gove|Sheridan',
    county_weights: '{"20063": 54.98, "20179": 45.02}',
    density: 0.9,
    imprecise: false,
    latitude: 39.11799,
    longitude: -100.35572,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67751',
  },
  {
    city: 'Quinter',
    county_fips: 20063,
    county_fips_all: '20063|20179',
    county: 'Gove',
    county_names_all: 'Gove|Sheridan',
    county_weights: '{"20063": 84.69, "20179": 15.31}',
    density: 2.4,
    imprecise: false,
    latitude: 38.9924,
    longitude: -100.23145,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67752',
  },
  {
    city: 'Rexford',
    county_fips: 20193,
    county_fips_all: '20193|20179|20153',
    county: 'Thomas',
    county_names_all: 'Thomas|Sheridan|Rawlins',
    county_weights: '{"20193": 52.72, "20179": 32.08, "20153": 15.2}',
    density: 0.6,
    imprecise: false,
    latitude: 39.43164,
    longitude: -100.74805,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67753',
  },
  {
    city: 'Saint Francis',
    county_fips: 20023,
    county_fips_all: '20023',
    county: 'Cheyenne',
    county_names_all: 'Cheyenne',
    county_weights: '{"20023": 100}',
    density: 1,
    imprecise: false,
    latitude: 39.79815,
    longitude: -101.84265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67756',
  },
  {
    city: 'Selden',
    county_fips: 20179,
    county_fips_all: '20179|20039',
    county: 'Sheridan',
    county_names_all: 'Sheridan|Decatur',
    county_weights: '{"20179": 61.06, "20039": 38.94}',
    density: 0.9,
    imprecise: false,
    latitude: 39.54527,
    longitude: -100.60881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67757',
  },
  {
    city: 'Sharon Springs',
    county_fips: 20199,
    county_fips_all: '20199',
    county: 'Wallace',
    county_names_all: 'Wallace',
    county_weights: '{"20199": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 38.89658,
    longitude: -101.7842,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67758',
  },
  {
    city: 'Wallace',
    county_fips: 20199,
    county_fips_all: '20199|20109',
    county: 'Wallace',
    county_names_all: 'Wallace|Logan',
    county_weights: '{"20199": 66.35, "20109": 33.65}',
    density: 0.2,
    imprecise: false,
    latitude: 38.95066,
    longitude: -101.52523,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67761',
  },
  {
    city: 'Weskan',
    county_fips: 20199,
    county_fips_all: '20199|20071',
    county: 'Wallace',
    county_names_all: 'Wallace|Greeley',
    county_weights: '{"20199": 80.96, "20071": 19.04}',
    density: 0.5,
    imprecise: false,
    latitude: 38.84166,
    longitude: -101.98611,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67762',
  },
  {
    city: 'Winona',
    county_fips: 20109,
    county_fips_all: '20109|20193',
    county: 'Logan',
    county_names_all: 'Logan|Thomas',
    county_weights: '{"20109": 94.07, "20193": 5.93}',
    density: 0.3,
    imprecise: false,
    latitude: 38.89135,
    longitude: -101.15041,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67764',
  },
  {
    city: 'Dodge City',
    county_fips: 20057,
    county_fips_all: '20057|20083',
    county: 'Ford',
    county_names_all: 'Ford|Hodgeman',
    county_weights: '{"20057": 98.65, "20083": 1.35}',
    density: 32.5,
    imprecise: false,
    latitude: 37.72961,
    longitude: -100.05406,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67801',
  },
  {
    city: 'Ashland',
    county_fips: 20025,
    county_fips_all: '20025',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"20025": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 37.17956,
    longitude: -99.8018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67831',
  },
  {
    city: 'Bucklin',
    county_fips: 20057,
    county_fips_all: '20057|20025|20097',
    county: 'Ford',
    county_names_all: 'Ford|Clark|Kiowa',
    county_weights: '{"20057": 66.64, "20025": 27.88, "20097": 5.48}',
    density: 1.7,
    imprecise: false,
    latitude: 37.53174,
    longitude: -99.61886,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67834',
  },
  {
    city: 'Cimarron',
    county_fips: 20069,
    county_fips_all: '20069|20055|20083',
    county: 'Gray',
    county_names_all: 'Gray|Finney|Hodgeman',
    county_weights: '{"20069": 49.28, "20055": 43.04, "20083": 7.68}',
    density: 2.2,
    imprecise: false,
    latitude: 37.98071,
    longitude: -100.31746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67835',
  },
  {
    city: 'Coolidge',
    county_fips: 20075,
    county_fips_all: '20075',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"20075": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 38.03977,
    longitude: -101.9942,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67836',
  },
  {
    city: 'Copeland',
    county_fips: 20081,
    county_fips_all: '20081|20069|20119',
    county: 'Haskell',
    county_names_all: 'Haskell|Gray|Meade',
    county_weights: '{"20081": 58.6, "20069": 32.63, "20119": 8.77}',
    density: 1.6,
    imprecise: false,
    latitude: 37.55615,
    longitude: -100.66289,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67837',
  },
  {
    city: 'Deerfield',
    county_fips: 20093,
    county_fips_all: '20093|20055',
    county: 'Kearny',
    county_names_all: 'Kearny|Finney',
    county_weights: '{"20093": 85.47, "20055": 14.53}',
    density: 4.7,
    imprecise: false,
    latitude: 38.05641,
    longitude: -101.13086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67838',
  },
  {
    city: 'Dighton',
    county_fips: 20101,
    county_fips_all: '20101|20063',
    county: 'Lane',
    county_names_all: 'Lane|Gove',
    county_weights: '{"20101": 92.81, "20063": 7.19}',
    density: 0.7,
    imprecise: false,
    latitude: 38.47911,
    longitude: -100.43961,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67839',
  },
  {
    city: 'Englewood',
    county_fips: 20025,
    county_fips_all: '20025',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"20025": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 37.0736,
    longitude: -100.01097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67840',
  },
  {
    city: 'Ensign',
    county_fips: 20069,
    county_fips_all: '20069|20057',
    county: 'Gray',
    county_names_all: 'Gray|Ford',
    county_weights: '{"20069": 60.85, "20057": 39.15}',
    density: 1.3,
    imprecise: false,
    latitude: 37.62997,
    longitude: -100.22878,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67841',
  },
  {
    city: 'Ford',
    county_fips: 20057,
    county_fips_all: '20057|20025',
    county: 'Ford',
    county_names_all: 'Ford|Clark',
    county_weights: '{"20057": 75.28, "20025": 24.72}',
    density: 0.9,
    imprecise: false,
    latitude: 37.54766,
    longitude: -99.77138,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67842',
  },
  {
    city: 'Fort Dodge',
    county_fips: 20057,
    county_fips_all: '20057',
    county: 'Ford',
    county_names_all: 'Ford',
    county_weights: '{"20057": 100}',
    density: 173.8,
    imprecise: false,
    latitude: 37.73027,
    longitude: -99.93728,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67843',
  },
  {
    city: 'Fowler',
    county_fips: 20119,
    county_fips_all: '20119|20057|20069',
    county: 'Meade',
    county_names_all: 'Meade|Ford|Gray',
    county_weights: '{"20119": 82.16, "20057": 10.02, "20069": 7.82}',
    density: 1.3,
    imprecise: false,
    latitude: 37.37798,
    longitude: -100.19562,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67844',
  },
  {
    city: 'Garden City',
    county_fips: 20055,
    county_fips_all: '20055|20069|20101',
    county: 'Finney',
    county_names_all: 'Finney|Gray|Lane',
    county_weights: '{"20055": 96.15, "20069": 2.32, "20101": 1.53}',
    density: 17,
    imprecise: false,
    latitude: 38.02311,
    longitude: -100.77756,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67846',
  },
  {
    city: 'Hanston',
    county_fips: 20083,
    county_fips_all: '20083|20135',
    county: 'Hodgeman',
    county_names_all: 'Hodgeman|Ness',
    county_weights: '{"20083": 94.82, "20135": 5.18}',
    density: 0.8,
    imprecise: false,
    latitude: 38.15061,
    longitude: -99.71725,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67849',
  },
  {
    city: 'Healy',
    county_fips: 20101,
    county_fips_all: '20101|20063|20171',
    county: 'Lane',
    county_names_all: 'Lane|Gove|Scott',
    county_weights: '{"20101": 59.86, "20063": 22.22, "20171": 17.92}',
    density: 1,
    imprecise: false,
    latitude: 38.6315,
    longitude: -100.63896,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67850',
  },
  {
    city: 'Holcomb',
    county_fips: 20055,
    county_fips_all: '20055|20171',
    county: 'Finney',
    county_names_all: 'Finney|Scott',
    county_weights: '{"20055": 96.1, "20171": 3.9}',
    density: 5.9,
    imprecise: false,
    latitude: 38.08796,
    longitude: -101.01972,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67851',
  },
  {
    city: 'Ingalls',
    county_fips: 20069,
    county_fips_all: '20069|20055',
    county: 'Gray',
    county_names_all: 'Gray|Finney',
    county_weights: '{"20069": 83.97, "20055": 16.03}',
    density: 1.1,
    imprecise: false,
    latitude: 37.88416,
    longitude: -100.51616,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67853',
  },
  {
    city: 'Jetmore',
    county_fips: 20083,
    county_fips_all: '20083',
    county: 'Hodgeman',
    county_names_all: 'Hodgeman',
    county_weights: '{"20083": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 38.09034,
    longitude: -100.0023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67854',
  },
  {
    city: 'Johnson',
    county_fips: 20187,
    county_fips_all: '20187|20129|20067',
    county: 'Stanton',
    county_names_all: 'Stanton|Morton|Grant',
    county_weights: '{"20187": 89.18, "20129": 9.7, "20067": 1.12}',
    density: 1.4,
    imprecise: false,
    latitude: 37.54551,
    longitude: -101.69477,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67855',
  },
  {
    city: 'Kendall',
    county_fips: 20075,
    county_fips_all: '20075|20093',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Kearny',
    county_weights: '{"20075": 52.97, "20093": 47.03}',
    density: 0.2,
    imprecise: false,
    latitude: 37.99598,
    longitude: -101.55154,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67857',
  },
  {
    city: 'Kismet',
    county_fips: 20175,
    county_fips_all: '20175',
    county: 'Seward',
    county_names_all: 'Seward',
    county_weights: '{"20175": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 37.23636,
    longitude: -100.77421,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67859',
  },
  {
    city: 'Lakin',
    county_fips: 20093,
    county_fips_all: '20093',
    county: 'Kearny',
    county_names_all: 'Kearny',
    county_weights: '{"20093": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 38.0185,
    longitude: -101.29831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67860',
  },
  {
    city: 'Leoti',
    county_fips: 20203,
    county_fips_all: '20203|20109|20199',
    county: 'Wichita',
    county_names_all: 'Wichita|Logan|Wallace',
    county_weights: '{"20203": 93.82, "20109": 5.92, "20199": 0.26}',
    density: 1.2,
    imprecise: false,
    latitude: 38.46768,
    longitude: -101.38914,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67861',
  },
  {
    city: 'Manter',
    county_fips: 20187,
    county_fips_all: '20187|20129',
    county: 'Stanton',
    county_names_all: 'Stanton|Morton',
    county_weights: '{"20187": 74.1, "20129": 25.9}',
    density: 0.3,
    imprecise: false,
    latitude: 37.47961,
    longitude: -101.95409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67862',
  },
  {
    city: 'Marienthal',
    county_fips: 20203,
    county_fips_all: '20203|20171',
    county: 'Wichita',
    county_names_all: 'Wichita|Scott',
    county_weights: '{"20203": 90.74, "20171": 9.26}',
    density: 0.6,
    imprecise: false,
    latitude: 38.56533,
    longitude: -101.20829,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67863',
  },
  {
    city: 'Meade',
    county_fips: 20119,
    county_fips_all: '20119',
    county: 'Meade',
    county_names_all: 'Meade',
    county_weights: '{"20119": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 37.17178,
    longitude: -100.31807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67864',
  },
  {
    city: 'Minneola',
    county_fips: 20025,
    county_fips_all: '20025|20057',
    county: 'Clark',
    county_names_all: 'Clark|Ford',
    county_weights: '{"20025": 62.88, "20057": 37.12}',
    density: 1.4,
    imprecise: false,
    latitude: 37.4368,
    longitude: -99.96506,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67865',
  },
  {
    city: 'Montezuma',
    county_fips: 20069,
    county_fips_all: '20069|20119',
    county: 'Gray',
    county_names_all: 'Gray|Meade',
    county_weights: '{"20069": 84.63, "20119": 15.37}',
    density: 2.7,
    imprecise: false,
    latitude: 37.56812,
    longitude: -100.45804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67867',
  },
  {
    city: 'Plains',
    county_fips: 20119,
    county_fips_all: '20119|20175',
    county: 'Meade',
    county_names_all: 'Meade|Seward',
    county_weights: '{"20119": 83.53, "20175": 16.47}',
    density: 1.6,
    imprecise: false,
    latitude: 37.24489,
    longitude: -100.57358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67869',
  },
  {
    city: 'Satanta',
    county_fips: 20081,
    county_fips_all: '20081|20175|20067',
    county: 'Haskell',
    county_names_all: 'Haskell|Seward|Grant',
    county_weights: '{"20081": 75.45, "20175": 13.4, "20067": 11.15}',
    density: 1.9,
    imprecise: false,
    latitude: 37.53255,
    longitude: -101.01829,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67870',
  },
  {
    city: 'Scott City',
    county_fips: 20171,
    county_fips_all: '20171|20063|20109|20055|20203',
    county: 'Scott',
    county_names_all: 'Scott|Gove|Logan|Finney|Wichita',
    county_weights:
      '{"20171": 87.63, "20063": 4.93, "20109": 3.25, "20055": 3.16, "20203": 1.03}',
    density: 2.6,
    imprecise: false,
    latitude: 38.49162,
    longitude: -100.91145,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67871',
  },
  {
    city: 'Spearville',
    county_fips: 20057,
    county_fips_all: '20057|20083',
    county: 'Ford',
    county_names_all: 'Ford|Hodgeman',
    county_weights: '{"20057": 68.63, "20083": 31.37}',
    density: 2.5,
    imprecise: false,
    latitude: 37.86154,
    longitude: -99.73654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67876',
  },
  {
    city: 'Sublette',
    county_fips: 20081,
    county_fips_all: '20081|20175',
    county: 'Haskell',
    county_names_all: 'Haskell|Seward',
    county_weights: '{"20081": 92.85, "20175": 7.15}',
    density: 3.3,
    imprecise: false,
    latitude: 37.54887,
    longitude: -100.84342,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67877',
  },
  {
    city: 'Syracuse',
    county_fips: 20075,
    county_fips_all: '20075|20187',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Stanton',
    county_weights: '{"20075": 95.72, "20187": 4.28}',
    density: 1.2,
    imprecise: false,
    latitude: 38.00218,
    longitude: -101.80824,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67878',
  },
  {
    city: 'Tribune',
    county_fips: 20071,
    county_fips_all: '20071',
    county: 'Greeley',
    county_names_all: 'Greeley',
    county_weights: '{"20071": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 38.47091,
    longitude: -101.79459,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67879',
  },
  {
    city: 'Ulysses',
    county_fips: 20067,
    county_fips_all: '20067|20093|20075',
    county: 'Grant',
    county_names_all: 'Grant|Kearny|Hamilton',
    county_weights: '{"20067": 80.43, "20093": 18.06, "20075": 1.51}',
    density: 4.2,
    imprecise: false,
    latitude: 37.60489,
    longitude: -101.32384,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67880',
  },
  {
    city: 'Wright',
    county_fips: 20057,
    county_fips_all: '20057',
    county: 'Ford',
    county_names_all: 'Ford',
    county_weights: '{"20057": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 37.8019,
    longitude: -99.88505,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67882',
  },
  {
    city: 'Liberal',
    county_fips: 20175,
    county_fips_all: '20175|20189',
    county: 'Seward',
    county_names_all: 'Seward|Stevens',
    county_weights: '{"20175": 93.65, "20189": 6.35}',
    density: 26,
    imprecise: false,
    latitude: 37.0943,
    longitude: -100.89864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67901',
  },
  {
    city: 'Elkhart',
    county_fips: 20129,
    county_fips_all: '20129',
    county: 'Morton',
    county_names_all: 'Morton',
    county_weights: '{"20129": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 37.06277,
    longitude: -101.86765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67950',
  },
  {
    city: 'Hugoton',
    county_fips: 20189,
    county_fips_all: '20189',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"20189": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 37.1639,
    longitude: -101.33486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67951',
  },
  {
    city: 'Moscow',
    county_fips: 20189,
    county_fips_all: '20189|20175',
    county: 'Stevens',
    county_names_all: 'Stevens|Seward',
    county_weights: '{"20189": 73.04, "20175": 26.96}',
    density: 0.9,
    imprecise: false,
    latitude: 37.29886,
    longitude: -101.13934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67952',
  },
  {
    city: 'Richfield',
    county_fips: 20129,
    county_fips_all: '20129',
    county: 'Morton',
    county_names_all: 'Morton',
    county_weights: '{"20129": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 37.22653,
    longitude: -101.86093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67953',
  },
  {
    city: 'Rolla',
    county_fips: 20129,
    county_fips_all: '20129|20189',
    county: 'Morton',
    county_names_all: 'Morton|Stevens',
    county_weights: '{"20129": 79.08, "20189": 20.92}',
    density: 1.1,
    imprecise: false,
    latitude: 37.17999,
    longitude: -101.61179,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67954',
  },
  {
    city: 'Abie',
    county_fips: 31023,
    county_fips_all: '31023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"31023": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 41.33369,
    longitude: -96.95489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 59,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68001',
  },
  {
    city: 'Arlington',
    county_fips: 31177,
    county_fips_all: '31177',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"31177": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 41.50163,
    longitude: -96.33975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68002',
  },
  {
    city: 'Ashland',
    county_fips: 31155,
    county_fips_all: '31155|31025',
    county: 'Saunders',
    county_names_all: 'Saunders|Cass',
    county_weights: '{"31155": 73.97, "31025": 26.03}',
    density: 18.2,
    imprecise: false,
    latitude: 41.07161,
    longitude: -96.38013,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68003',
  },
  {
    city: 'Bancroft',
    county_fips: 31039,
    county_fips_all: '31039|31021',
    county: 'Cuming',
    county_names_all: 'Cuming|Burt',
    county_weights: '{"31039": 99.08, "31021": 0.92}',
    density: 4.6,
    imprecise: false,
    latitude: 42.00888,
    longitude: -96.62978,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68004',
  },
  {
    city: 'Bellevue',
    county_fips: 31153,
    county_fips_all: '31153',
    county: 'Sarpy',
    county_names_all: 'Sarpy',
    county_weights: '{"31153": 100}',
    density: 455.1,
    imprecise: false,
    latitude: 41.14161,
    longitude: -95.89394,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68005',
  },
  {
    city: 'Bennington',
    county_fips: 31055,
    county_fips_all: '31055|31177',
    county: 'Douglas',
    county_names_all: 'Douglas|Washington',
    county_weights: '{"31055": 74.08, "31177": 25.92}',
    density: 200.2,
    imprecise: false,
    latitude: 41.37184,
    longitude: -96.19524,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68007',
  },
  {
    city: 'Blair',
    county_fips: 31177,
    county_fips_all: '31177',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"31177": 100}',
    density: 39.9,
    imprecise: false,
    latitude: 41.54573,
    longitude: -96.17421,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68008',
  },
  {
    city: 'Boys Town',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 226.2,
    imprecise: false,
    latitude: 41.25616,
    longitude: -96.13352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68010',
  },
  {
    city: 'Bruno',
    county_fips: 31023,
    county_fips_all: '31023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"31023": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 41.28219,
    longitude: -96.96458,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68014',
  },
  {
    city: 'Cedar Bluffs',
    county_fips: 31155,
    county_fips_all: '31155',
    county: 'Saunders',
    county_names_all: 'Saunders',
    county_weights: '{"31155": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 41.38351,
    longitude: -96.64737,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68015',
  },
  {
    city: 'Cedar Creek',
    county_fips: 31025,
    county_fips_all: '31025',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"31025": 100}',
    density: 38.4,
    imprecise: false,
    latitude: 41.02518,
    longitude: -96.1063,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68016',
  },
  {
    city: 'Ceresco',
    county_fips: 31155,
    county_fips_all: '31155|31109',
    county: 'Saunders',
    county_names_all: 'Saunders|Lancaster',
    county_weights: '{"31155": 68.55, "31109": 31.45}',
    density: 10.3,
    imprecise: false,
    latitude: 41.05938,
    longitude: -96.66179,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68017',
  },
  {
    city: 'Colon',
    county_fips: 31155,
    county_fips_all: '31155',
    county: 'Saunders',
    county_names_all: 'Saunders',
    county_weights: '{"31155": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 41.30207,
    longitude: -96.61573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68018',
  },
  {
    city: 'Craig',
    county_fips: 31021,
    county_fips_all: '31021|31177|31053',
    county: 'Burt',
    county_names_all: 'Burt|Washington|Dodge',
    county_weights: '{"31021": 96.92, "31177": 1.89, "31053": 1.19}',
    density: 1.9,
    imprecise: false,
    latitude: 41.77965,
    longitude: -96.37323,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68019',
  },
  {
    city: 'Decatur',
    county_fips: 31021,
    county_fips_all: '31021|31173',
    county: 'Burt',
    county_names_all: 'Burt|Thurston',
    county_weights: '{"31021": 86.69, "31173": 13.31}',
    density: 3.2,
    imprecise: false,
    latitude: 41.9762,
    longitude: -96.25627,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68020',
  },
  {
    city: 'Elkhorn',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 371.6,
    imprecise: false,
    latitude: 41.27744,
    longitude: -96.24558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68022',
  },
  {
    city: 'Fort Calhoun',
    county_fips: 31177,
    county_fips_all: '31177',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"31177": 100}',
    density: 25.9,
    imprecise: false,
    latitude: 41.46191,
    longitude: -96.02226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68023',
  },
  {
    city: 'Fremont',
    county_fips: 31053,
    county_fips_all: '31053|31155|31177',
    county: 'Dodge',
    county_names_all: 'Dodge|Saunders|Washington',
    county_weights: '{"31053": 73.6, "31155": 26.27, "31177": 0.13}',
    density: 98.6,
    imprecise: false,
    latitude: 41.43749,
    longitude: -96.49158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68025',
  },
  {
    city: 'Gretna',
    county_fips: 31153,
    county_fips_all: '31153',
    county: 'Sarpy',
    county_names_all: 'Sarpy',
    county_weights: '{"31153": 100}',
    density: 107.4,
    imprecise: false,
    latitude: 41.10513,
    longitude: -96.26098,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68028',
  },
  {
    city: 'Herman',
    county_fips: 31177,
    county_fips_all: '31177|31021',
    county: 'Washington',
    county_names_all: 'Washington|Burt',
    county_weights: '{"31177": 78.02, "31021": 21.98}',
    density: 4.5,
    imprecise: false,
    latitude: 41.65873,
    longitude: -96.27394,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68029',
  },
  {
    city: 'Homer',
    county_fips: 31043,
    county_fips_all: '31043',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"31043": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 42.3184,
    longitude: -96.45057,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68030',
  },
  {
    city: 'Hooper',
    county_fips: 31053,
    county_fips_all: '31053|31177',
    county: 'Dodge',
    county_names_all: 'Dodge|Washington',
    county_weights: '{"31053": 89.9, "31177": 10.1}',
    density: 6,
    imprecise: false,
    latitude: 41.64041,
    longitude: -96.53046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68031',
  },
  {
    city: 'Ithaca',
    county_fips: 31155,
    county_fips_all: '31155',
    county: 'Saunders',
    county_names_all: 'Saunders',
    county_weights: '{"31155": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 41.12933,
    longitude: -96.52425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68033',
  },
  {
    city: 'Kennard',
    county_fips: 31177,
    county_fips_all: '31177',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"31177": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 41.45558,
    longitude: -96.2203,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68034',
  },
  {
    city: 'Linwood',
    county_fips: 31023,
    county_fips_all: '31023|31155',
    county: 'Butler',
    county_names_all: 'Butler|Saunders',
    county_weights: '{"31023": 77.57, "31155": 22.43}',
    density: 2.1,
    imprecise: false,
    latitude: 41.39031,
    longitude: -96.95086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68036',
  },
  {
    city: 'Louisville',
    county_fips: 31025,
    county_fips_all: '31025',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"31025": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 40.9844,
    longitude: -96.12673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68037',
  },
  {
    city: 'Lyons',
    county_fips: 31021,
    county_fips_all: '31021|31039|31173',
    county: 'Burt',
    county_names_all: 'Burt|Cuming|Thurston',
    county_weights: '{"31021": 94.85, "31039": 2.8, "31173": 2.35}',
    density: 5.1,
    imprecise: false,
    latitude: 41.95458,
    longitude: -96.4432,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68038',
  },
  {
    city: 'Macy',
    county_fips: 31173,
    county_fips_all: '31173',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"31173": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 42.112,
    longitude: -96.34397,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68039',
  },
  {
    city: 'Malmo',
    county_fips: 31155,
    county_fips_all: '31155',
    county: 'Saunders',
    county_names_all: 'Saunders',
    county_weights: '{"31155": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 41.28555,
    longitude: -96.73815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68040',
  },
  {
    city: 'Mead',
    county_fips: 31155,
    county_fips_all: '31155',
    county: 'Saunders',
    county_names_all: 'Saunders',
    county_weights: '{"31155": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 41.23633,
    longitude: -96.48793,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68041',
  },
  {
    city: 'Memphis',
    county_fips: 31155,
    county_fips_all: '31155',
    county: 'Saunders',
    county_names_all: 'Saunders',
    county_weights: '{"31155": 100}',
    density: 58.5,
    imprecise: false,
    latitude: 41.09426,
    longitude: -96.43683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68042',
  },
  {
    city: 'Nickerson',
    county_fips: 31053,
    county_fips_all: '31053|31177',
    county: 'Dodge',
    county_names_all: 'Dodge|Washington',
    county_weights: '{"31053": 54.57, "31177": 45.43}',
    density: 7.7,
    imprecise: false,
    latitude: 41.54798,
    longitude: -96.44871,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68044',
  },
  {
    city: 'Oakland',
    county_fips: 31021,
    county_fips_all: '31021|31039|31053',
    county: 'Burt',
    county_names_all: 'Burt|Cuming|Dodge',
    county_weights: '{"31021": 79.06, "31039": 19.87, "31053": 1.07}',
    density: 8,
    imprecise: false,
    latitude: 41.8273,
    longitude: -96.49523,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68045',
  },
  {
    city: 'Papillion',
    county_fips: 31153,
    county_fips_all: '31153',
    county: 'Sarpy',
    county_names_all: 'Sarpy',
    county_weights: '{"31153": 100}',
    density: 483.1,
    imprecise: false,
    latitude: 41.12206,
    longitude: -96.06138,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68046',
  },
  {
    city: 'Pender',
    county_fips: 31173,
    county_fips_all: '31173|31039|31179',
    county: 'Thurston',
    county_names_all: 'Thurston|Cuming|Wayne',
    county_weights: '{"31173": 55.75, "31039": 32.54, "31179": 11.71}',
    density: 6.4,
    imprecise: false,
    latitude: 42.10592,
    longitude: -96.7325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68047',
  },
  {
    city: 'Plattsmouth',
    county_fips: 31025,
    county_fips_all: '31025',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"31025": 100}',
    density: 54.9,
    imprecise: false,
    latitude: 40.98304,
    longitude: -95.9345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68048',
  },
  {
    city: 'Prague',
    county_fips: 31155,
    county_fips_all: '31155',
    county: 'Saunders',
    county_names_all: 'Saunders',
    county_weights: '{"31155": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 41.30593,
    longitude: -96.84303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68050',
  },
  {
    city: 'Rosalie',
    county_fips: 31173,
    county_fips_all: '31173',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"31173": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 42.05747,
    longitude: -96.47192,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68055',
  },
  {
    city: 'Scribner',
    county_fips: 31053,
    county_fips_all: '31053|31039',
    county: 'Dodge',
    county_names_all: 'Dodge|Cuming',
    county_weights: '{"31053": 98.99, "31039": 1.01}',
    density: 4.1,
    imprecise: false,
    latitude: 41.65888,
    longitude: -96.71893,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68057',
  },
  {
    city: 'South Bend',
    county_fips: 31025,
    county_fips_all: '31025',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"31025": 100}',
    density: 224.1,
    imprecise: false,
    latitude: 41.00842,
    longitude: -96.2483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68058',
  },
  {
    city: 'Springfield',
    county_fips: 31153,
    county_fips_all: '31153',
    county: 'Sarpy',
    county_names_all: 'Sarpy',
    county_weights: '{"31153": 100}',
    density: 27.3,
    imprecise: false,
    latitude: 41.06673,
    longitude: -96.1595,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68059',
  },
  {
    city: 'Tekamah',
    county_fips: 31021,
    county_fips_all: '31021',
    county: 'Burt',
    county_names_all: 'Burt',
    county_weights: '{"31021": 100}',
    density: 6,
    imprecise: false,
    latitude: 41.80078,
    longitude: -96.21165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68061',
  },
  {
    city: 'Thurston',
    county_fips: 31173,
    county_fips_all: '31173',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"31173": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 42.19538,
    longitude: -96.6743,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68062',
  },
  {
    city: 'Uehling',
    county_fips: 31053,
    county_fips_all: '31053',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"31053": 100}',
    density: 28.9,
    imprecise: false,
    latitude: 41.72124,
    longitude: -96.49345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68063',
  },
  {
    city: 'Valley',
    county_fips: 31055,
    county_fips_all: '31055|31155|31053',
    county: 'Douglas',
    county_names_all: 'Douglas|Saunders|Dodge',
    county_weights: '{"31055": 89.75, "31155": 9.32, "31053": 0.93}',
    density: 30.6,
    imprecise: false,
    latitude: 41.34925,
    longitude: -96.35545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68064',
  },
  {
    city: 'Valparaiso',
    county_fips: 31155,
    county_fips_all: '31155|31109|31159|31023',
    county: 'Saunders',
    county_names_all: 'Saunders|Lancaster|Seward|Butler',
    county_weights:
      '{"31155": 64.07, "31109": 23.36, "31159": 6.83, "31023": 5.74}',
    density: 6.4,
    imprecise: false,
    latitude: 41.0766,
    longitude: -96.84854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68065',
  },
  {
    city: 'Wahoo',
    county_fips: 31155,
    county_fips_all: '31155',
    county: 'Saunders',
    county_names_all: 'Saunders',
    county_weights: '{"31155": 100}',
    density: 25.5,
    imprecise: false,
    latitude: 41.18451,
    longitude: -96.61996,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68066',
  },
  {
    city: 'Walthill',
    county_fips: 31173,
    county_fips_all: '31173',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"31173": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 42.1519,
    longitude: -96.48603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68067',
  },
  {
    city: 'Washington',
    county_fips: 31177,
    county_fips_all: '31177',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"31177": 100}',
    density: 373.4,
    imprecise: false,
    latitude: 41.39759,
    longitude: -96.20741,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68068',
  },
  {
    city: 'Waterloo',
    county_fips: 31055,
    county_fips_all: '31055|31153',
    county: 'Douglas',
    county_names_all: 'Douglas|Sarpy',
    county_weights: '{"31055": 88.65, "31153": 11.35}',
    density: 41.5,
    imprecise: false,
    latitude: 41.24166,
    longitude: -96.31542,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68069',
  },
  {
    city: 'Weston',
    county_fips: 31155,
    county_fips_all: '31155',
    county: 'Saunders',
    county_names_all: 'Saunders',
    county_weights: '{"31155": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 41.1924,
    longitude: -96.79973,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68070',
  },
  {
    city: 'Winnebago',
    county_fips: 31173,
    county_fips_all: '31173',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"31173": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 42.23605,
    longitude: -96.47446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68071',
  },
  {
    city: 'Winslow',
    county_fips: 31053,
    county_fips_all: '31053',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"31053": 100}',
    density: 184.3,
    imprecise: false,
    latitude: 41.61016,
    longitude: -96.50473,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68072',
  },
  {
    city: 'Yutan',
    county_fips: 31155,
    county_fips_all: '31155',
    county: 'Saunders',
    county_names_all: 'Saunders',
    county_weights: '{"31155": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 41.23931,
    longitude: -96.40931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68073',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 2117.3,
    imprecise: false,
    latitude: 41.26231,
    longitude: -95.93224,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68102',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 2146.4,
    imprecise: false,
    latitude: 41.29525,
    longitude: -96.00104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68104',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 2454.7,
    imprecise: false,
    latitude: 41.2406,
    longitude: -95.96429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68105',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1590.4,
    imprecise: false,
    latitude: 41.23885,
    longitude: -96.00244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68106',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1848.1,
    imprecise: false,
    latitude: 41.20888,
    longitude: -95.95126,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68107',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1714.5,
    imprecise: false,
    latitude: 41.23753,
    longitude: -95.93118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68108',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 419,
    imprecise: false,
    latitude: 41.29867,
    longitude: -95.91143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68110',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1788,
    imprecise: false,
    latitude: 41.29564,
    longitude: -95.96395,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68111',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055|31177',
    county: 'Douglas',
    county_names_all: 'Douglas|Washington',
    county_weights: '{"31055": 58.85, "31177": 41.15}',
    density: 257.9,
    imprecise: false,
    latitude: 41.38183,
    longitude: -95.95804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68112',
  },
  {
    city: 'Offutt Afb',
    county_fips: 31153,
    county_fips_all: '31153',
    county: 'Sarpy',
    county_names_all: 'Sarpy',
    county_weights: '{"31153": 100}',
    density: 106,
    imprecise: false,
    latitude: 41.11745,
    longitude: -95.90889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68113',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1174.1,
    imprecise: false,
    latitude: 41.26318,
    longitude: -96.05208,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68114',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1567,
    imprecise: false,
    latitude: 41.29842,
    longitude: -96.16629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68116',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 650.4,
    imprecise: false,
    latitude: 41.2062,
    longitude: -96.00138,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68117',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 890.1,
    imprecise: false,
    latitude: 41.263,
    longitude: -96.1772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68118',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055|31177',
    county: 'Douglas',
    county_names_all: 'Douglas|Washington',
    county_weights: '{"31055": 80.13, "31177": 19.87}',
    density: 293.5,
    imprecise: false,
    latitude: 41.36451,
    longitude: -96.05036,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68122',
  },
  {
    city: 'Bellevue',
    county_fips: 31153,
    county_fips_all: '31153',
    county: 'Sarpy',
    county_names_all: 'Sarpy',
    county_weights: '{"31153": 100}',
    density: 523.4,
    imprecise: false,
    latitude: 41.10108,
    longitude: -95.94774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68123',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1063,
    imprecise: false,
    latitude: 41.23515,
    longitude: -96.0522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68124',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1239.6,
    imprecise: false,
    latitude: 41.2061,
    longitude: -96.05245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68127',
  },
  {
    city: 'La Vista',
    county_fips: 31153,
    county_fips_all: '31153',
    county: 'Sarpy',
    county_names_all: 'Sarpy',
    county_weights: '{"31153": 100}',
    density: 1091.2,
    imprecise: false,
    latitude: 41.17972,
    longitude: -96.07081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68128',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1106.5,
    imprecise: false,
    latitude: 41.23394,
    longitude: -96.19613,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68130',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 2764.9,
    imprecise: false,
    latitude: 41.26435,
    longitude: -95.96479,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68131',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 2096.4,
    imprecise: false,
    latitude: 41.26506,
    longitude: -96.00153,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68132',
  },
  {
    city: 'Papillion',
    county_fips: 31153,
    county_fips_all: '31153',
    county: 'Sarpy',
    county_names_all: 'Sarpy',
    county_weights: '{"31153": 100}',
    density: 369.8,
    imprecise: false,
    latitude: 41.11754,
    longitude: -96.00292,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68133',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1349,
    imprecise: false,
    latitude: 41.29776,
    longitude: -96.0503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68134',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1498.3,
    imprecise: false,
    latitude: 41.2052,
    longitude: -96.19576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68135',
  },
  {
    city: 'Omaha',
    county_fips: 31153,
    county_fips_all: '31153',
    county: 'Sarpy',
    county_names_all: 'Sarpy',
    county_weights: '{"31153": 100}',
    density: 981.8,
    imprecise: false,
    latitude: 41.16932,
    longitude: -96.18783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68136',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1122,
    imprecise: false,
    latitude: 41.20595,
    longitude: -96.11924,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68137',
  },
  {
    city: 'Omaha',
    county_fips: 31153,
    county_fips_all: '31153',
    county: 'Sarpy',
    county_names_all: 'Sarpy',
    county_weights: '{"31153": 100}',
    density: 407,
    imprecise: false,
    latitude: 41.15661,
    longitude: -96.13891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68138',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055|31177',
    county: 'Douglas',
    county_names_all: 'Douglas|Washington',
    county_weights: '{"31055": 73.2, "31177": 26.8}',
    density: 86.4,
    imprecise: false,
    latitude: 41.37012,
    longitude: -96.10276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68142',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1355.4,
    imprecise: false,
    latitude: 41.23473,
    longitude: -96.11909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68144',
  },
  {
    city: 'Bellevue',
    county_fips: 31153,
    county_fips_all: '31153|31055',
    county: 'Sarpy',
    county_names_all: 'Sarpy|Douglas',
    county_weights: '{"31153": 99.33, "31055": 0.67}',
    density: 983.9,
    imprecise: false,
    latitude: 41.17655,
    longitude: -95.95678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68147',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055|31177',
    county: 'Douglas',
    county_names_all: 'Douglas|Washington',
    county_weights: '{"31055": 84.92, "31177": 15.08}',
    density: 195.4,
    imprecise: false,
    latitude: 41.36282,
    longitude: -95.99995,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68152',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1367.6,
    imprecise: false,
    latitude: 41.26408,
    longitude: -96.11665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68154',
  },
  {
    city: 'Omaha',
    county_fips: 31153,
    county_fips_all: '31153|31055',
    county: 'Sarpy',
    county_names_all: 'Sarpy|Douglas',
    county_weights: '{"31153": 99.72, "31055": 0.28}',
    density: 787.6,
    imprecise: false,
    latitude: 41.17902,
    longitude: -95.99536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68157',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1248.1,
    imprecise: false,
    latitude: 41.29886,
    longitude: -96.10949,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68164',
  },
  {
    city: 'Adams',
    county_fips: 31067,
    county_fips_all: '31067|31109|31131',
    county: 'Gage',
    county_names_all: 'Gage|Lancaster|Otoe',
    county_weights: '{"31067": 76.76, "31109": 17.11, "31131": 6.13}',
    density: 5.6,
    imprecise: false,
    latitude: 40.46847,
    longitude: -96.52244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68301',
  },
  {
    city: 'Alexandria',
    county_fips: 31169,
    county_fips_all: '31169|31095',
    county: 'Thayer',
    county_names_all: 'Thayer|Jefferson',
    county_weights: '{"31169": 85.01, "31095": 14.99}',
    density: 1.4,
    imprecise: false,
    latitude: 40.25753,
    longitude: -97.41033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68303',
  },
  {
    city: 'Alvo',
    county_fips: 31025,
    county_fips_all: '31025',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"31025": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 40.88971,
    longitude: -96.38781,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68304',
  },
  {
    city: 'Auburn',
    county_fips: 31127,
    county_fips_all: '31127',
    county: 'Nemaha',
    county_names_all: 'Nemaha',
    county_weights: '{"31127": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 40.36392,
    longitude: -95.85788,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68305',
  },
  {
    city: 'Avoca',
    county_fips: 31025,
    county_fips_all: '31025|31131',
    county: 'Cass',
    county_names_all: 'Cass|Otoe',
    county_weights: '{"31025": 54.14, "31131": 45.86}',
    density: 3.1,
    imprecise: false,
    latitude: 40.78769,
    longitude: -96.14054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68307',
  },
  {
    city: 'Barneston',
    county_fips: 31067,
    county_fips_all: '31067',
    county: 'Gage',
    county_names_all: 'Gage',
    county_weights: '{"31067": 100}',
    density: 202.8,
    imprecise: false,
    latitude: 40.04907,
    longitude: -96.57285,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68309',
  },
  {
    city: 'Beatrice',
    county_fips: 31067,
    county_fips_all: '31067|31095',
    county: 'Gage',
    county_names_all: 'Gage|Jefferson',
    county_weights: '{"31067": 97.38, "31095": 2.62}',
    density: 25.2,
    imprecise: false,
    latitude: 40.24957,
    longitude: -96.74943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68310',
  },
  {
    city: 'Beaver Crossing',
    county_fips: 31159,
    county_fips_all: '31159|31185',
    county: 'Seward',
    county_names_all: 'Seward|York',
    county_weights: '{"31159": 98.69, "31185": 1.31}',
    density: 3.8,
    imprecise: false,
    latitude: 40.78142,
    longitude: -97.27193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68313',
  },
  {
    city: 'Bee',
    county_fips: 31159,
    county_fips_all: '31159|31023',
    county: 'Seward',
    county_names_all: 'Seward|Butler',
    county_weights: '{"31159": 94.78, "31023": 5.22}',
    density: 4.4,
    imprecise: false,
    latitude: 41.01643,
    longitude: -97.0248,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68314',
  },
  {
    city: 'Belvidere',
    county_fips: 31169,
    county_fips_all: '31169',
    county: 'Thayer',
    county_names_all: 'Thayer',
    county_weights: '{"31169": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 40.24605,
    longitude: -97.53841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68315',
  },
  {
    city: 'Benedict',
    county_fips: 31185,
    county_fips_all: '31185|31143',
    county: 'York',
    county_names_all: 'York|Polk',
    county_weights: '{"31185": 87.81, "31143": 12.19}',
    density: 3.2,
    imprecise: false,
    latitude: 41.01688,
    longitude: -97.61577,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68316',
  },
  {
    city: 'Bennet',
    county_fips: 31109,
    county_fips_all: '31109|31131',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Otoe',
    county_weights: '{"31109": 87.74, "31131": 12.26}',
    density: 16.7,
    imprecise: false,
    latitude: 40.67325,
    longitude: -96.50451,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68317',
  },
  {
    city: 'Blue Springs',
    county_fips: 31067,
    county_fips_all: '31067',
    county: 'Gage',
    county_names_all: 'Gage',
    county_weights: '{"31067": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 40.15598,
    longitude: -96.64439,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68318',
  },
  {
    city: 'Bradshaw',
    county_fips: 31185,
    county_fips_all: '31185|31081',
    county: 'York',
    county_names_all: 'York|Hamilton',
    county_weights: '{"31185": 98.57, "31081": 1.43}',
    density: 3.5,
    imprecise: false,
    latitude: 40.93656,
    longitude: -97.75817,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68319',
  },
  {
    city: 'Brock',
    county_fips: 31127,
    county_fips_all: '31127',
    county: 'Nemaha',
    county_names_all: 'Nemaha',
    county_weights: '{"31127": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 40.48148,
    longitude: -95.9533,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68320',
  },
  {
    city: 'Brownville',
    county_fips: 31127,
    county_fips_all: '31127',
    county: 'Nemaha',
    county_names_all: 'Nemaha',
    county_weights: '{"31127": 100}',
    density: 7,
    imprecise: false,
    latitude: 40.39491,
    longitude: -95.69371,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68321',
  },
  {
    city: 'Bruning',
    county_fips: 31169,
    county_fips_all: '31169|31059',
    county: 'Thayer',
    county_names_all: 'Thayer|Fillmore',
    county_weights: '{"31169": 70.69, "31059": 29.31}',
    density: 3.2,
    imprecise: false,
    latitude: 40.3346,
    longitude: -97.55356,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68322',
  },
  {
    city: 'Burchard',
    county_fips: 31133,
    county_fips_all: '31133',
    county: 'Pawnee',
    county_names_all: 'Pawnee',
    county_weights: '{"31133": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 40.13197,
    longitude: -96.37034,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68323',
  },
  {
    city: 'Burr',
    county_fips: 31131,
    county_fips_all: '31131|31097',
    county: 'Otoe',
    county_names_all: 'Otoe|Johnson',
    county_weights: '{"31131": 90.5, "31097": 9.5}',
    density: 2.2,
    imprecise: false,
    latitude: 40.55407,
    longitude: -96.29014,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68324',
  },
  {
    city: 'Byron',
    county_fips: 31169,
    county_fips_all: '31169|20157',
    county: 'Thayer',
    county_names_all: 'Thayer|Republic',
    county_weights: '{"31169": 55.18, "20157": 44.82}',
    density: 1,
    imprecise: false,
    latitude: 40.0131,
    longitude: -97.75156,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68325',
  },
  {
    city: 'Carleton',
    county_fips: 31169,
    county_fips_all: '31169|31059',
    county: 'Thayer',
    county_names_all: 'Thayer|Fillmore',
    county_weights: '{"31169": 94.5, "31059": 5.5}',
    density: 2.4,
    imprecise: false,
    latitude: 40.28569,
    longitude: -97.68243,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68326',
  },
  {
    city: 'Chester',
    county_fips: 31169,
    county_fips_all: '31169|20157',
    county: 'Thayer',
    county_names_all: 'Thayer|Republic',
    county_weights: '{"31169": 66.07, "20157": 33.93}',
    density: 3.1,
    imprecise: false,
    latitude: 40.01079,
    longitude: -97.62113,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68327',
  },
  {
    city: 'Clatonia',
    county_fips: 31067,
    county_fips_all: '31067',
    county: 'Gage',
    county_names_all: 'Gage',
    county_weights: '{"31067": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 40.47694,
    longitude: -96.8384,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68328',
  },
  {
    city: 'Cook',
    county_fips: 31097,
    county_fips_all: '31097|31131',
    county: 'Johnson',
    county_names_all: 'Johnson|Otoe',
    county_weights: '{"31097": 72.02, "31131": 27.98}',
    density: 3.5,
    imprecise: false,
    latitude: 40.50089,
    longitude: -96.16772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68329',
  },
  {
    city: 'Cordova',
    county_fips: 31159,
    county_fips_all: '31159',
    county: 'Seward',
    county_names_all: 'Seward',
    county_weights: '{"31159": 100}',
    density: 25.3,
    imprecise: false,
    latitude: 40.70651,
    longitude: -97.34041,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68330',
  },
  {
    city: 'Cortland',
    county_fips: 31067,
    county_fips_all: '31067',
    county: 'Gage',
    county_names_all: 'Gage',
    county_weights: '{"31067": 100}',
    density: 8,
    imprecise: false,
    latitude: 40.4712,
    longitude: -96.70863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68331',
  },
  {
    city: 'Crab Orchard',
    county_fips: 31097,
    county_fips_all: '31097',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"31097": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 40.32829,
    longitude: -96.41123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68332',
  },
  {
    city: 'Crete',
    county_fips: 31151,
    county_fips_all: '31151|31109',
    county: 'Saline',
    county_names_all: 'Saline|Lancaster',
    county_weights: '{"31151": 66.8, "31109": 33.2}',
    density: 32.6,
    imprecise: false,
    latitude: 40.62126,
    longitude: -96.94901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68333',
  },
  {
    city: 'Davenport',
    county_fips: 31169,
    county_fips_all: '31169|31129|31059',
    county: 'Thayer',
    county_names_all: 'Thayer|Nuckolls|Fillmore',
    county_weights: '{"31169": 56.9, "31129": 33.36, "31059": 9.74}',
    density: 1.7,
    imprecise: false,
    latitude: 40.28243,
    longitude: -97.803,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68335',
  },
  {
    city: 'Davey',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 40.9615,
    longitude: -96.68405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68336',
  },
  {
    city: 'Dawson',
    county_fips: 31147,
    county_fips_all: '31147',
    county: 'Richardson',
    county_names_all: 'Richardson',
    county_weights: '{"31147": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 40.09504,
    longitude: -95.83418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68337',
  },
  {
    city: 'Daykin',
    county_fips: 31095,
    county_fips_all: '31095',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"31095": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 40.31865,
    longitude: -97.24863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68338',
  },
  {
    city: 'Denton',
    county_fips: 31109,
    county_fips_all: '31109|31159|31151',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Seward|Saline',
    county_weights: '{"31109": 86.75, "31159": 8.8, "31151": 4.45}',
    density: 9.9,
    imprecise: false,
    latitude: 40.73214,
    longitude: -96.86696,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68339',
  },
  {
    city: 'Deshler',
    county_fips: 31169,
    county_fips_all: '31169',
    county: 'Thayer',
    county_names_all: 'Thayer',
    county_weights: '{"31169": 100}',
    density: 7,
    imprecise: false,
    latitude: 40.12525,
    longitude: -97.74126,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68340',
  },
  {
    city: 'De Witt',
    county_fips: 31067,
    county_fips_all: '31067|31151|31095',
    county: 'Gage',
    county_names_all: 'Gage|Saline|Jefferson',
    county_weights: '{"31067": 51.87, "31151": 45.02, "31095": 3.11}',
    density: 3.3,
    imprecise: false,
    latitude: 40.3855,
    longitude: -96.91378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68341',
  },
  {
    city: 'Diller',
    county_fips: 31095,
    county_fips_all: '31095|31067',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Gage',
    county_weights: '{"31095": 73.7, "31067": 26.3}',
    density: 2.6,
    imprecise: false,
    latitude: 40.1034,
    longitude: -96.94496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68342',
  },
  {
    city: 'Dorchester',
    county_fips: 31151,
    county_fips_all: '31151|31159',
    county: 'Saline',
    county_names_all: 'Saline|Seward',
    county_weights: '{"31151": 94.9, "31159": 5.1}',
    density: 4.3,
    imprecise: false,
    latitude: 40.61989,
    longitude: -97.13194,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68343',
  },
  {
    city: 'Douglas',
    county_fips: 31131,
    county_fips_all: '31131',
    county: 'Otoe',
    county_names_all: 'Otoe',
    county_weights: '{"31131": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 40.57159,
    longitude: -96.39544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68344',
  },
  {
    city: 'Du Bois',
    county_fips: 31133,
    county_fips_all: '31133|31147',
    county: 'Pawnee',
    county_names_all: 'Pawnee|Richardson',
    county_weights: '{"31133": 65.12, "31147": 34.88}',
    density: 2.1,
    imprecise: false,
    latitude: 40.03692,
    longitude: -96.01928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68345',
  },
  {
    city: 'Dunbar',
    county_fips: 31131,
    county_fips_all: '31131',
    county: 'Otoe',
    county_names_all: 'Otoe',
    county_weights: '{"31131": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 40.66195,
    longitude: -96.03066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68346',
  },
  {
    city: 'Eagle',
    county_fips: 31025,
    county_fips_all: '31025|31131',
    county: 'Cass',
    county_names_all: 'Cass|Otoe',
    county_weights: '{"31025": 65.91, "31131": 34.09}',
    density: 30.8,
    imprecise: false,
    latitude: 40.80347,
    longitude: -96.42274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68347',
  },
  {
    city: 'Elk Creek',
    county_fips: 31097,
    county_fips_all: '31097|31133|31127',
    county: 'Johnson',
    county_names_all: 'Johnson|Pawnee|Nemaha',
    county_weights: '{"31097": 75.38, "31133": 13.3, "31127": 11.32}',
    density: 3,
    imprecise: false,
    latitude: 40.29569,
    longitude: -96.12208,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68348',
  },
  {
    city: 'Elmwood',
    county_fips: 31025,
    county_fips_all: '31025',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"31025": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 40.82962,
    longitude: -96.30028,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68349',
  },
  {
    city: 'Endicott',
    county_fips: 31095,
    county_fips_all: '31095',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"31095": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 40.03961,
    longitude: -97.09166,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68350',
  },
  {
    city: 'Exeter',
    county_fips: 31059,
    county_fips_all: '31059|31185',
    county: 'Fillmore',
    county_names_all: 'Fillmore|York',
    county_weights: '{"31059": 73.99, "31185": 26.01}',
    density: 3.6,
    imprecise: false,
    latitude: 40.65393,
    longitude: -97.43015,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68351',
  },
  {
    city: 'Fairbury',
    county_fips: 31095,
    county_fips_all: '31095',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"31095": 100}',
    density: 7,
    imprecise: false,
    latitude: 40.15255,
    longitude: -97.21931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68352',
  },
  {
    city: 'Fairmont',
    county_fips: 31059,
    county_fips_all: '31059|31185',
    county: 'Fillmore',
    county_names_all: 'Fillmore|York',
    county_weights: '{"31059": 86.86, "31185": 13.14}',
    density: 3.2,
    imprecise: false,
    latitude: 40.63935,
    longitude: -97.58032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68354',
  },
  {
    city: 'Falls City',
    county_fips: 31147,
    county_fips_all: '31147',
    county: 'Richardson',
    county_names_all: 'Richardson',
    county_weights: '{"31147": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 40.11677,
    longitude: -95.56702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68355',
  },
  {
    city: 'Filley',
    county_fips: 31067,
    county_fips_all: '31067|31097',
    county: 'Gage',
    county_names_all: 'Gage|Johnson',
    county_weights: '{"31067": 98.92, "31097": 1.08}',
    density: 2.7,
    imprecise: false,
    latitude: 40.31541,
    longitude: -96.54658,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68357',
  },
  {
    city: 'Firth',
    county_fips: 31109,
    county_fips_all: '31109|31067',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Gage',
    county_weights: '{"31109": 67.45, "31067": 32.55}',
    density: 14.5,
    imprecise: false,
    latitude: 40.53321,
    longitude: -96.60973,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68358',
  },
  {
    city: 'Friend',
    county_fips: 31151,
    county_fips_all: '31151|31159|31059',
    county: 'Saline',
    county_names_all: 'Saline|Seward|Fillmore',
    county_weights: '{"31151": 85.42, "31159": 14.16, "31059": 0.42}',
    density: 5,
    imprecise: false,
    latitude: 40.63059,
    longitude: -97.28333,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68359',
  },
  {
    city: 'Garland',
    county_fips: 31159,
    county_fips_all: '31159',
    county: 'Seward',
    county_names_all: 'Seward',
    county_weights: '{"31159": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 40.94613,
    longitude: -96.95661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68360',
  },
  {
    city: 'Geneva',
    county_fips: 31059,
    county_fips_all: '31059',
    county: 'Fillmore',
    county_names_all: 'Fillmore',
    county_weights: '{"31059": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 40.50756,
    longitude: -97.60146,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68361',
  },
  {
    city: 'Gilead',
    county_fips: 31169,
    county_fips_all: '31169',
    county: 'Thayer',
    county_names_all: 'Thayer',
    county_weights: '{"31169": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 40.15323,
    longitude: -97.42553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68362',
  },
  {
    city: 'Goehner',
    county_fips: 31159,
    county_fips_all: '31159',
    county: 'Seward',
    county_names_all: 'Seward',
    county_weights: '{"31159": 100}',
    density: 119.7,
    imprecise: false,
    latitude: 40.83656,
    longitude: -97.22563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68364',
  },
  {
    city: 'Grafton',
    county_fips: 31059,
    county_fips_all: '31059|31185',
    county: 'Fillmore',
    county_names_all: 'Fillmore|York',
    county_weights: '{"31059": 97.33, "31185": 2.67}',
    density: 2.2,
    imprecise: false,
    latitude: 40.61565,
    longitude: -97.73065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68365',
  },
  {
    city: 'Greenwood',
    county_fips: 31025,
    county_fips_all: '31025|31109|31155',
    county: 'Cass',
    county_names_all: 'Cass|Lancaster|Saunders',
    county_weights: '{"31025": 62.32, "31109": 32.58, "31155": 5.1}',
    density: 6.8,
    imprecise: false,
    latitude: 40.98215,
    longitude: -96.44222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68366',
  },
  {
    city: 'Gresham',
    county_fips: 31143,
    county_fips_all: '31143|31185|31159',
    county: 'Polk',
    county_names_all: 'Polk|York|Seward',
    county_weights: '{"31143": 36.37, "31185": 32.92, "31159": 30.71}',
    density: 2.2,
    imprecise: false,
    latitude: 41.03807,
    longitude: -97.40128,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68367',
  },
  {
    city: 'Hallam',
    county_fips: 31109,
    county_fips_all: '31109|31067',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Gage',
    county_weights: '{"31109": 89.67, "31067": 10.33}',
    density: 4.9,
    imprecise: false,
    latitude: 40.55598,
    longitude: -96.81665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68368',
  },
  {
    city: 'Hebron',
    county_fips: 31169,
    county_fips_all: '31169',
    county: 'Thayer',
    county_names_all: 'Thayer',
    county_weights: '{"31169": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 40.14148,
    longitude: -97.55567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68370',
  },
  {
    city: 'Henderson',
    county_fips: 31185,
    county_fips_all: '31185|31081',
    county: 'York',
    county_names_all: 'York|Hamilton',
    county_weights: '{"31185": 76.91, "31081": 23.09}',
    density: 6.5,
    imprecise: false,
    latitude: 40.77304,
    longitude: -97.78417,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68371',
  },
  {
    city: 'Hickman',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 44.4,
    imprecise: false,
    latitude: 40.60498,
    longitude: -96.60539,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68372',
  },
  {
    city: 'Hubbell',
    county_fips: 31169,
    county_fips_all: '31169',
    county: 'Thayer',
    county_names_all: 'Thayer',
    county_weights: '{"31169": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 40.03939,
    longitude: -97.48826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68375',
  },
  {
    city: 'Humboldt',
    county_fips: 31147,
    county_fips_all: '31147|31127|31133',
    county: 'Richardson',
    county_names_all: 'Richardson|Nemaha|Pawnee',
    county_weights: '{"31147": 82.47, "31127": 10.33, "31133": 7.2}',
    density: 3.1,
    imprecise: false,
    latitude: 40.171,
    longitude: -95.93809,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68376',
  },
  {
    city: 'Jansen',
    county_fips: 31095,
    county_fips_all: '31095',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"31095": 100}',
    density: 3,
    imprecise: false,
    latitude: 40.217,
    longitude: -97.02303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68377',
  },
  {
    city: 'Johnson',
    county_fips: 31127,
    county_fips_all: '31127|31097',
    county: 'Nemaha',
    county_names_all: 'Nemaha|Johnson',
    county_weights: '{"31127": 85.37, "31097": 14.63}',
    density: 4.8,
    imprecise: false,
    latitude: 40.39355,
    longitude: -96.02615,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68378',
  },
  {
    city: 'Julian',
    county_fips: 31131,
    county_fips_all: '31131|31127',
    county: 'Otoe',
    county_names_all: 'Otoe|Nemaha',
    county_weights: '{"31131": 92.63, "31127": 7.37}',
    density: 13,
    imprecise: false,
    latitude: 40.52908,
    longitude: -95.86979,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68379',
  },
  {
    city: 'Lewiston',
    county_fips: 31133,
    county_fips_all: '31133|31097',
    county: 'Pawnee',
    county_names_all: 'Pawnee|Johnson',
    county_weights: '{"31133": 99.9, "31097": 0.1}',
    density: 2.5,
    imprecise: false,
    latitude: 40.24283,
    longitude: -96.4059,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68380',
  },
  {
    city: 'Liberty',
    county_fips: 31067,
    county_fips_all: '31067|31133',
    county: 'Gage',
    county_names_all: 'Gage|Pawnee',
    county_weights: '{"31067": 71.33, "31133": 28.67}',
    density: 1.1,
    imprecise: false,
    latitude: 40.07979,
    longitude: -96.48176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68381',
  },
  {
    city: 'Lorton',
    county_fips: 31131,
    county_fips_all: '31131',
    county: 'Otoe',
    county_names_all: 'Otoe',
    county_weights: '{"31131": 100}',
    density: 652.6,
    imprecise: false,
    latitude: 40.59724,
    longitude: -96.02425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68382',
  },
  {
    city: 'McCool Junction',
    county_fips: 31185,
    county_fips_all: '31185',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"31185": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 40.74233,
    longitude: -97.58569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68401',
  },
  {
    city: 'Malcolm',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 40.90829,
    longitude: -96.8571,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68402',
  },
  {
    city: 'Manley',
    county_fips: 31025,
    county_fips_all: '31025',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"31025": 100}',
    density: 107.4,
    imprecise: false,
    latitude: 40.92045,
    longitude: -96.16707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68403',
  },
  {
    city: 'Martell',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 8,
    imprecise: false,
    latitude: 40.619,
    longitude: -96.75566,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68404',
  },
  {
    city: 'Milford',
    county_fips: 31159,
    county_fips_all: '31159|31151',
    county: 'Seward',
    county_names_all: 'Seward|Saline',
    county_weights: '{"31159": 99.04, "31151": 0.96}',
    density: 17.4,
    imprecise: false,
    latitude: 40.76522,
    longitude: -97.07315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68405',
  },
  {
    city: 'Milligan',
    county_fips: 31059,
    county_fips_all: '31059|31151',
    county: 'Fillmore',
    county_names_all: 'Fillmore|Saline',
    county_weights: '{"31059": 61.55, "31151": 38.45}',
    density: 3.4,
    imprecise: false,
    latitude: 40.50566,
    longitude: -97.37874,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68406',
  },
  {
    city: 'Murdock',
    county_fips: 31025,
    county_fips_all: '31025',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"31025": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 40.921,
    longitude: -96.26263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68407',
  },
  {
    city: 'Murray',
    county_fips: 31025,
    county_fips_all: '31025',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"31025": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 40.90906,
    longitude: -95.95074,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68409',
  },
  {
    city: 'Nebraska City',
    county_fips: 31131,
    county_fips_all: '31131',
    county: 'Otoe',
    county_names_all: 'Otoe',
    county_weights: '{"31131": 100}',
    density: 24.2,
    imprecise: false,
    latitude: 40.63729,
    longitude: -95.88584,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68410',
  },
  {
    city: 'Nehawka',
    county_fips: 31025,
    county_fips_all: '31025|31131',
    county: 'Cass',
    county_names_all: 'Cass|Otoe',
    county_weights: '{"31025": 85.49, "31131": 14.51}',
    density: 3.9,
    imprecise: false,
    latitude: 40.83775,
    longitude: -96.01053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68413',
  },
  {
    city: 'Nemaha',
    county_fips: 31127,
    county_fips_all: '31127',
    county: 'Nemaha',
    county_names_all: 'Nemaha',
    county_weights: '{"31127": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 40.31966,
    longitude: -95.6991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68414',
  },
  {
    city: 'Odell',
    county_fips: 31067,
    county_fips_all: '31067',
    county: 'Gage',
    county_names_all: 'Gage',
    county_weights: '{"31067": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 40.06249,
    longitude: -96.82157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68415',
  },
  {
    city: 'Ohiowa',
    county_fips: 31059,
    county_fips_all: '31059',
    county: 'Fillmore',
    county_names_all: 'Fillmore',
    county_weights: '{"31059": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 40.41093,
    longitude: -97.46185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68416',
  },
  {
    city: 'Otoe',
    county_fips: 31131,
    county_fips_all: '31131',
    county: 'Otoe',
    county_names_all: 'Otoe',
    county_weights: '{"31131": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 40.7359,
    longitude: -96.09199,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68417',
  },
  {
    city: 'Palmyra',
    county_fips: 31131,
    county_fips_all: '31131|31025',
    county: 'Otoe',
    county_names_all: 'Otoe|Cass',
    county_weights: '{"31131": 97.12, "31025": 2.88}',
    density: 6.2,
    imprecise: false,
    latitude: 40.69568,
    longitude: -96.38435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68418',
  },
  {
    city: 'Panama',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 92.8,
    imprecise: false,
    latitude: 40.60297,
    longitude: -96.51129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68419',
  },
  {
    city: 'Pawnee City',
    county_fips: 31133,
    county_fips_all: '31133|20131',
    county: 'Pawnee',
    county_names_all: 'Pawnee|Nemaha',
    county_weights: '{"31133": 97.66, "20131": 2.34}',
    density: 3.7,
    imprecise: false,
    latitude: 40.08556,
    longitude: -96.19125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68420',
  },
  {
    city: 'Peru',
    county_fips: 31127,
    county_fips_all: '31127|31131',
    county: 'Nemaha',
    county_names_all: 'Nemaha|Otoe',
    county_weights: '{"31127": 94.21, "31131": 5.79}',
    density: 7.7,
    imprecise: false,
    latitude: 40.492,
    longitude: -95.74426,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 987,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68421',
  },
  {
    city: 'Pickrell',
    county_fips: 31067,
    county_fips_all: '31067',
    county: 'Gage',
    county_names_all: 'Gage',
    county_weights: '{"31067": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 40.38863,
    longitude: -96.69755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68422',
  },
  {
    city: 'Pleasant Dale',
    county_fips: 31159,
    county_fips_all: '31159|31109|31151',
    county: 'Seward',
    county_names_all: 'Seward|Lancaster|Saline',
    county_weights: '{"31159": 96.26, "31109": 2.82, "31151": 0.92}',
    density: 4.8,
    imprecise: false,
    latitude: 40.80112,
    longitude: -96.95117,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68423',
  },
  {
    city: 'Plymouth',
    county_fips: 31095,
    county_fips_all: '31095|31067',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Gage',
    county_weights: '{"31095": 98.57, "31067": 1.43}',
    density: 4.3,
    imprecise: false,
    latitude: 40.30111,
    longitude: -97.01818,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68424',
  },
  {
    city: 'Raymond',
    county_fips: 31109,
    county_fips_all: '31109|31159',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Seward',
    county_weights: '{"31109": 95.75, "31159": 4.25}',
    density: 9,
    imprecise: false,
    latitude: 40.97244,
    longitude: -96.79624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68428',
  },
  {
    city: 'Reynolds',
    county_fips: 31095,
    county_fips_all: '31095|31169',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Thayer',
    county_weights: '{"31095": 52.11, "31169": 47.89}',
    density: 1.2,
    imprecise: false,
    latitude: 40.06406,
    longitude: -97.37437,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 59,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68429',
  },
  {
    city: 'Roca',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 40.66599,
    longitude: -96.66012,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68430',
  },
  {
    city: 'Rulo',
    county_fips: 31147,
    county_fips_all: '31147',
    county: 'Richardson',
    county_names_all: 'Richardson',
    county_weights: '{"31147": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 40.0677,
    longitude: -95.43402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68431',
  },
  {
    city: 'Salem',
    county_fips: 31147,
    county_fips_all: '31147',
    county: 'Richardson',
    county_names_all: 'Richardson',
    county_weights: '{"31147": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 40.05251,
    longitude: -95.73969,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68433',
  },
  {
    city: 'Seward',
    county_fips: 31159,
    county_fips_all: '31159',
    county: 'Seward',
    county_names_all: 'Seward',
    county_weights: '{"31159": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 40.90947,
    longitude: -97.11675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68434',
  },
  {
    city: 'Shickley',
    county_fips: 31059,
    county_fips_all: '31059|31035',
    county: 'Fillmore',
    county_names_all: 'Fillmore|Clay',
    county_weights: '{"31059": 95.59, "31035": 4.41}',
    density: 2.5,
    imprecise: false,
    latitude: 40.43357,
    longitude: -97.74427,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68436',
  },
  {
    city: 'Shubert',
    county_fips: 31147,
    county_fips_all: '31147|31127',
    county: 'Richardson',
    county_names_all: 'Richardson|Nemaha',
    county_weights: '{"31147": 61.45, "31127": 38.55}',
    density: 2.1,
    imprecise: false,
    latitude: 40.2513,
    longitude: -95.63534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68437',
  },
  {
    city: 'Sprague',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 674.3,
    imprecise: false,
    latitude: 40.62656,
    longitude: -96.74463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68438',
  },
  {
    city: 'Staplehurst',
    county_fips: 31159,
    county_fips_all: '31159',
    county: 'Seward',
    county_names_all: 'Seward',
    county_weights: '{"31159": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 40.99937,
    longitude: -97.21136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68439',
  },
  {
    city: 'Steele City',
    county_fips: 31095,
    county_fips_all: '31095',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"31095": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 40.05266,
    longitude: -97.01168,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68440',
  },
  {
    city: 'Steinauer',
    county_fips: 31133,
    county_fips_all: '31133|31097',
    county: 'Pawnee',
    county_names_all: 'Pawnee|Johnson',
    county_weights: '{"31133": 89.47, "31097": 10.53}',
    density: 0.8,
    imprecise: false,
    latitude: 40.22581,
    longitude: -96.25461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68441',
  },
  {
    city: 'Stella',
    county_fips: 31147,
    county_fips_all: '31147|31127',
    county: 'Richardson',
    county_names_all: 'Richardson|Nemaha',
    county_weights: '{"31147": 80.09, "31127": 19.91}',
    density: 2.3,
    imprecise: false,
    latitude: 40.239,
    longitude: -95.7729,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68442',
  },
  {
    city: 'Sterling',
    county_fips: 31097,
    county_fips_all: '31097|31131',
    county: 'Johnson',
    county_names_all: 'Johnson|Otoe',
    county_weights: '{"31097": 98.41, "31131": 1.59}',
    density: 4.8,
    imprecise: false,
    latitude: 40.45627,
    longitude: -96.36758,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68443',
  },
  {
    city: 'Strang',
    county_fips: 31059,
    county_fips_all: '31059',
    county: 'Fillmore',
    county_names_all: 'Fillmore',
    county_weights: '{"31059": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 40.41117,
    longitude: -97.5847,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68444',
  },
  {
    city: 'Swanton',
    county_fips: 31151,
    county_fips_all: '31151',
    county: 'Saline',
    county_names_all: 'Saline',
    county_weights: '{"31151": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 40.40146,
    longitude: -97.08662,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68445',
  },
  {
    city: 'Syracuse',
    county_fips: 31131,
    county_fips_all: '31131',
    county: 'Otoe',
    county_names_all: 'Otoe',
    county_weights: '{"31131": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 40.65002,
    longitude: -96.17535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68446',
  },
  {
    city: 'Table Rock',
    county_fips: 31133,
    county_fips_all: '31133|31127|31097',
    county: 'Pawnee',
    county_names_all: 'Pawnee|Nemaha|Johnson',
    county_weights: '{"31133": 89.24, "31127": 6.87, "31097": 3.89}',
    density: 3.7,
    imprecise: false,
    latitude: 40.20044,
    longitude: -96.07366,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68447',
  },
  {
    city: 'Talmage',
    county_fips: 31131,
    county_fips_all: '31131|31127|31097',
    county: 'Otoe',
    county_names_all: 'Otoe|Nemaha|Johnson',
    county_weights: '{"31131": 80.61, "31127": 10.77, "31097": 8.62}',
    density: 1.9,
    imprecise: false,
    latitude: 40.54429,
    longitude: -96.035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68448',
  },
  {
    city: 'Tecumseh',
    county_fips: 31097,
    county_fips_all: '31097',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"31097": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 40.36197,
    longitude: -96.22383,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68450',
  },
  {
    city: 'Ong',
    county_fips: 31035,
    county_fips_all: '31035',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"31035": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 40.39755,
    longitude: -97.85036,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 67,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68452',
  },
  {
    city: 'Tobias',
    county_fips: 31151,
    county_fips_all: '31151|31059|31095|31169',
    county: 'Saline',
    county_names_all: 'Saline|Fillmore|Jefferson|Thayer',
    county_weights:
      '{"31151": 69.8, "31059": 19.63, "31095": 6.75, "31169": 3.82}',
    density: 1.5,
    imprecise: false,
    latitude: 40.40774,
    longitude: -97.33455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68453',
  },
  {
    city: 'Unadilla',
    county_fips: 31131,
    county_fips_all: '31131|31025',
    county: 'Otoe',
    county_names_all: 'Otoe|Cass',
    county_weights: '{"31131": 98.25, "31025": 1.75}',
    density: 5.3,
    imprecise: false,
    latitude: 40.69275,
    longitude: -96.28686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68454',
  },
  {
    city: 'Union',
    county_fips: 31025,
    county_fips_all: '31025|31131',
    county: 'Cass',
    county_names_all: 'Cass|Otoe',
    county_weights: '{"31025": 92.99, "31131": 7.01}',
    density: 8.5,
    imprecise: false,
    latitude: 40.82286,
    longitude: -95.90123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68455',
  },
  {
    city: 'Utica',
    county_fips: 31159,
    county_fips_all: '31159',
    county: 'Seward',
    county_names_all: 'Seward',
    county_weights: '{"31159": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 40.91278,
    longitude: -97.31007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68456',
  },
  {
    city: 'Verdon',
    county_fips: 31147,
    county_fips_all: '31147',
    county: 'Richardson',
    county_names_all: 'Richardson',
    county_weights: '{"31147": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 40.15618,
    longitude: -95.71095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68457',
  },
  {
    city: 'Virginia',
    county_fips: 31067,
    county_fips_all: '31067|31133|31097',
    county: 'Gage',
    county_names_all: 'Gage|Pawnee|Johnson',
    county_weights: '{"31067": 74.15, "31133": 17.23, "31097": 8.62}',
    density: 2.6,
    imprecise: false,
    latitude: 40.23107,
    longitude: -96.48742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68458',
  },
  {
    city: 'Waco',
    county_fips: 31185,
    county_fips_all: '31185|31159',
    county: 'York',
    county_names_all: 'York|Seward',
    county_weights: '{"31185": 96.79, "31159": 3.21}',
    density: 2.1,
    imprecise: false,
    latitude: 40.89596,
    longitude: -97.43169,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68460',
  },
  {
    city: 'Walton',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 40.76682,
    longitude: -96.51419,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68461',
  },
  {
    city: 'Waverly',
    county_fips: 31109,
    county_fips_all: '31109|31025',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Cass',
    county_weights: '{"31109": 94.66, "31025": 5.34}',
    density: 34.4,
    imprecise: false,
    latitude: 40.94804,
    longitude: -96.52806,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68462',
  },
  {
    city: 'Weeping Water',
    county_fips: 31025,
    county_fips_all: '31025',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"31025": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 40.8759,
    longitude: -96.13518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68463',
  },
  {
    city: 'Western',
    county_fips: 31151,
    county_fips_all: '31151|31095',
    county: 'Saline',
    county_names_all: 'Saline|Jefferson',
    county_weights: '{"31151": 97.72, "31095": 2.28}',
    density: 1.9,
    imprecise: false,
    latitude: 40.42232,
    longitude: -97.1955,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68464',
  },
  {
    city: 'Wilber',
    county_fips: 31151,
    county_fips_all: '31151|31067|31109',
    county: 'Saline',
    county_names_all: 'Saline|Gage|Lancaster',
    county_weights: '{"31151": 91.29, "31067": 6.01, "31109": 2.7}',
    density: 9.6,
    imprecise: false,
    latitude: 40.49248,
    longitude: -97.01987,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68465',
  },
  {
    city: 'Wymore',
    county_fips: 31067,
    county_fips_all: '31067',
    county: 'Gage',
    county_names_all: 'Gage',
    county_weights: '{"31067": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 40.07109,
    longitude: -96.63773,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68466',
  },
  {
    city: 'York',
    county_fips: 31185,
    county_fips_all: '31185',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"31185": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 40.86528,
    longitude: -97.59778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68467',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 1495.6,
    imprecise: false,
    latitude: 40.78361,
    longitude: -96.70083,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68502',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 2099.3,
    imprecise: false,
    latitude: 40.82447,
    longitude: -96.67387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68503',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 953.8,
    imprecise: false,
    latitude: 40.85451,
    longitude: -96.66104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68504',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 1681.9,
    imprecise: false,
    latitude: 40.82446,
    longitude: -96.61562,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68505',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 1519.9,
    imprecise: false,
    latitude: 40.78422,
    longitude: -96.63959,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68506',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 556.5,
    imprecise: false,
    latitude: 40.85954,
    longitude: -96.61172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68507',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 2365.3,
    imprecise: false,
    latitude: 40.81831,
    longitude: -96.70621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68508',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 1645.2,
    imprecise: false,
    latitude: 40.80654,
    longitude: -96.64835,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68510',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 584.5,
    imprecise: false,
    latitude: 40.73746,
    longitude: -96.70567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68512',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 24,
    imprecise: false,
    latitude: 40.93408,
    longitude: -96.65076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68514',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 998.1,
    imprecise: false,
    latitude: 40.73493,
    longitude: -96.6428,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68516',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 40.93341,
    longitude: -96.60487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68517',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 93.1,
    imprecise: false,
    latitude: 40.79827,
    longitude: -96.55313,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68520',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 1085.8,
    imprecise: false,
    latitude: 40.8618,
    longitude: -96.71519,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68521',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 540.9,
    imprecise: false,
    latitude: 40.78941,
    longitude: -96.76214,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68522',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 49.8,
    imprecise: false,
    latitude: 40.73555,
    longitude: -96.75708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68523',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 82.8,
    imprecise: false,
    latitude: 40.87145,
    longitude: -96.80264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68524',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 252.8,
    imprecise: false,
    latitude: 40.7324,
    longitude: -96.58269,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68526',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109|31025',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Cass',
    county_weights: '{"31109": 93.71, "31025": 6.29}',
    density: 30.3,
    imprecise: false,
    latitude: 40.84573,
    longitude: -96.51753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68527',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109|31159',
    county: 'Lancaster',
    county_names_all: 'Lancaster|Seward',
    county_weights: '{"31109": 99.06, "31159": 0.94}',
    density: 170.7,
    imprecise: false,
    latitude: 40.82244,
    longitude: -96.81762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68528',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 40.90211,
    longitude: -96.71415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68531',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 26.9,
    imprecise: false,
    latitude: 40.79544,
    longitude: -96.84332,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68532',
  },
  {
    city: 'Lincoln',
    county_fips: 31109,
    county_fips_all: '31109',
    county: 'Lancaster',
    county_names_all: 'Lancaster',
    county_weights: '{"31109": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.82482,
    longitude: -96.69644,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68588',
  },
  {
    city: 'Columbus',
    county_fips: 31141,
    county_fips_all: '31141|31037|31143|31023',
    county: 'Platte',
    county_names_all: 'Platte|Colfax|Polk|Butler',
    county_weights:
      '{"31141": 73.92, "31037": 13.31, "31143": 10.68, "31023": 2.09}',
    density: 41.7,
    imprecise: false,
    latitude: 41.45205,
    longitude: -97.39477,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68601',
  },
  {
    city: 'Albion',
    county_fips: 31011,
    county_fips_all: '31011',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"31011": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 41.72452,
    longitude: -98.05814,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68620',
  },
  {
    city: 'Ames',
    county_fips: 31053,
    county_fips_all: '31053',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"31053": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 41.48963,
    longitude: -96.63911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68621',
  },
  {
    city: 'Bartlett',
    county_fips: 31183,
    county_fips_all: '31183',
    county: 'Wheeler',
    county_names_all: 'Wheeler',
    county_weights: '{"31183": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 41.92209,
    longitude: -98.53311,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68622',
  },
  {
    city: 'Belgrade',
    county_fips: 31125,
    county_fips_all: '31125|31011',
    county: 'Nance',
    county_names_all: 'Nance|Boone',
    county_weights: '{"31125": 93.04, "31011": 6.96}',
    density: 2.1,
    imprecise: false,
    latitude: 41.44327,
    longitude: -98.11602,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68623',
  },
  {
    city: 'Bellwood',
    county_fips: 31023,
    county_fips_all: '31023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"31023": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 41.34974,
    longitude: -97.22858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68624',
  },
  {
    city: 'Brainard',
    county_fips: 31023,
    county_fips_all: '31023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"31023": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 41.16821,
    longitude: -96.9921,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68626',
  },
  {
    city: 'Cedar Rapids',
    county_fips: 31011,
    county_fips_all: '31011|31125|31077',
    county: 'Boone',
    county_names_all: 'Boone|Nance|Greeley',
    county_weights: '{"31011": 84.75, "31125": 10.73, "31077": 4.52}',
    density: 2.1,
    imprecise: false,
    latitude: 41.54445,
    longitude: -98.17041,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68627',
  },
  {
    city: 'Clarks',
    county_fips: 31121,
    county_fips_all: '31121|31143|31081',
    county: 'Merrick',
    county_names_all: 'Merrick|Polk|Hamilton',
    county_weights: '{"31121": 76.55, "31143": 18.8, "31081": 4.65}',
    density: 3,
    imprecise: false,
    latitude: 41.21694,
    longitude: -97.84355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68628',
  },
  {
    city: 'Clarkson',
    county_fips: 31037,
    county_fips_all: '31037|31167',
    county: 'Colfax',
    county_names_all: 'Colfax|Stanton',
    county_weights: '{"31037": 63.7, "31167": 36.3}',
    density: 3.6,
    imprecise: false,
    latitude: 41.71336,
    longitude: -97.12936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68629',
  },
  {
    city: 'Creston',
    county_fips: 31141,
    county_fips_all: '31141|31167',
    county: 'Platte',
    county_names_all: 'Platte|Stanton',
    county_weights: '{"31141": 87.69, "31167": 12.31}',
    density: 3.4,
    imprecise: false,
    latitude: 41.68753,
    longitude: -97.35074,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68631',
  },
  {
    city: 'David City',
    county_fips: 31023,
    county_fips_all: '31023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"31023": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 41.24266,
    longitude: -97.13288,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68632',
  },
  {
    city: 'Dodge',
    county_fips: 31053,
    county_fips_all: '31053|31039|31037',
    county: 'Dodge',
    county_names_all: 'Dodge|Cuming|Colfax',
    county_weights: '{"31053": 48.01, "31039": 32.22, "31037": 19.78}',
    density: 3.7,
    imprecise: false,
    latitude: 41.70585,
    longitude: -96.89668,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68633',
  },
  {
    city: 'Duncan',
    county_fips: 31141,
    county_fips_all: '31141',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"31141": 100}',
    density: 36.8,
    imprecise: false,
    latitude: 41.39073,
    longitude: -97.50659,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68634',
  },
  {
    city: 'Dwight',
    county_fips: 31023,
    county_fips_all: '31023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"31023": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 41.08544,
    longitude: -97.02298,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68635',
  },
  {
    city: 'Elgin',
    county_fips: 31003,
    county_fips_all: '31003|31183',
    county: 'Antelope',
    county_names_all: 'Antelope|Wheeler',
    county_weights: '{"31003": 93.73, "31183": 6.27}',
    density: 2.3,
    imprecise: false,
    latitude: 42.00494,
    longitude: -98.15674,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68636',
  },
  {
    city: 'Ericson',
    county_fips: 31183,
    county_fips_all: '31183|31071|31077',
    county: 'Wheeler',
    county_names_all: 'Wheeler|Garfield|Greeley',
    county_weights: '{"31183": 55.37, "31071": 25.16, "31077": 19.47}',
    density: 0.8,
    imprecise: false,
    latitude: 41.78778,
    longitude: -98.68997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68637',
  },
  {
    city: 'Fullerton',
    county_fips: 31125,
    county_fips_all: '31125|31121',
    county: 'Nance',
    county_names_all: 'Nance|Merrick',
    county_weights: '{"31125": 97.93, "31121": 2.07}',
    density: 4.2,
    imprecise: false,
    latitude: 41.36848,
    longitude: -97.98977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68638',
  },
  {
    city: 'Genoa',
    county_fips: 31125,
    county_fips_all: '31125|31141',
    county: 'Nance',
    county_names_all: 'Nance|Platte',
    county_weights: '{"31125": 75.59, "31141": 24.41}',
    density: 3.7,
    imprecise: false,
    latitude: 41.46111,
    longitude: -97.77237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68640',
  },
  {
    city: 'Howells',
    county_fips: 31037,
    county_fips_all: '31037|31167|31039',
    county: 'Colfax',
    county_names_all: 'Colfax|Stanton|Cuming',
    county_weights: '{"31037": 52.16, "31167": 25.65, "31039": 22.19}',
    density: 3.7,
    imprecise: false,
    latitude: 41.73452,
    longitude: -97.00829,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68641',
  },
  {
    city: 'Humphrey',
    county_fips: 31141,
    county_fips_all: '31141|31119',
    county: 'Platte',
    county_names_all: 'Platte|Madison',
    county_weights: '{"31141": 83.46, "31119": 16.54}',
    density: 4.9,
    imprecise: false,
    latitude: 41.68717,
    longitude: -97.51232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68642',
  },
  {
    city: 'Leigh',
    county_fips: 31141,
    county_fips_all: '31141|31167|31037',
    county: 'Platte',
    county_names_all: 'Platte|Stanton|Colfax',
    county_weights: '{"31141": 34.54, "31167": 34.03, "31037": 31.43}',
    density: 4,
    imprecise: false,
    latitude: 41.70231,
    longitude: -97.25918,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68643',
  },
  {
    city: 'Lindsay',
    county_fips: 31141,
    county_fips_all: '31141|31119',
    county: 'Platte',
    county_names_all: 'Platte|Madison',
    county_weights: '{"31141": 71.19, "31119": 28.81}',
    density: 3.2,
    imprecise: false,
    latitude: 41.7079,
    longitude: -97.67579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68644',
  },
  {
    city: 'Monroe',
    county_fips: 31141,
    county_fips_all: '31141',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"31141": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 41.51971,
    longitude: -97.62021,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68647',
  },
  {
    city: 'Morse Bluff',
    county_fips: 31155,
    county_fips_all: '31155',
    county: 'Saunders',
    county_names_all: 'Saunders',
    county_weights: '{"31155": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 41.40482,
    longitude: -96.78949,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68648',
  },
  {
    city: 'North Bend',
    county_fips: 31053,
    county_fips_all: '31053',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"31053": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 41.50784,
    longitude: -96.78896,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68649',
  },
  {
    city: 'Osceola',
    county_fips: 31143,
    county_fips_all: '31143',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"31143": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 41.22443,
    longitude: -97.57472,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68651',
  },
  {
    city: 'Petersburg',
    county_fips: 31011,
    county_fips_all: '31011',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"31011": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 41.86174,
    longitude: -98.08906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68652',
  },
  {
    city: 'Platte Center',
    county_fips: 31141,
    county_fips_all: '31141',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"31141": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 41.55551,
    longitude: -97.4888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68653',
  },
  {
    city: 'Polk',
    county_fips: 31143,
    county_fips_all: '31143|31185|31081',
    county: 'Polk',
    county_names_all: 'Polk|York|Hamilton',
    county_weights: '{"31143": 62.88, "31185": 28.27, "31081": 8.85}',
    density: 3.9,
    imprecise: false,
    latitude: 41.06791,
    longitude: -97.7772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68654',
  },
  {
    city: 'Primrose',
    county_fips: 31011,
    county_fips_all: '31011|31077',
    county: 'Boone',
    county_names_all: 'Boone|Greeley',
    county_weights: '{"31011": 83.08, "31077": 16.92}',
    density: 1.1,
    imprecise: false,
    latitude: 41.64881,
    longitude: -98.26222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68655',
  },
  {
    city: 'Rising City',
    county_fips: 31023,
    county_fips_all: '31023|31143',
    county: 'Butler',
    county_names_all: 'Butler|Polk',
    county_weights: '{"31023": 98.63, "31143": 1.37}',
    density: 3.2,
    imprecise: false,
    latitude: 41.19971,
    longitude: -97.2937,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68658',
  },
  {
    city: 'Rogers',
    county_fips: 31037,
    county_fips_all: '31037',
    county: 'Colfax',
    county_names_all: 'Colfax',
    county_weights: '{"31037": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 41.54388,
    longitude: -96.94438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68659',
  },
  {
    city: 'Saint Edward',
    county_fips: 31011,
    county_fips_all: '31011|31141|31125',
    county: 'Boone',
    county_names_all: 'Boone|Platte|Nance',
    county_weights: '{"31011": 56.16, "31141": 28.15, "31125": 15.69}',
    density: 2.6,
    imprecise: false,
    latitude: 41.57398,
    longitude: -97.86792,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68660',
  },
  {
    city: 'Schuyler',
    county_fips: 31037,
    county_fips_all: '31037',
    county: 'Colfax',
    county_names_all: 'Colfax',
    county_weights: '{"31037": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 41.49559,
    longitude: -97.08347,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68661',
  },
  {
    city: 'Shelby',
    county_fips: 31143,
    county_fips_all: '31143|31023',
    county: 'Polk',
    county_names_all: 'Polk|Butler',
    county_weights: '{"31143": 93.8, "31023": 6.2}',
    density: 4.5,
    imprecise: false,
    latitude: 41.20698,
    longitude: -97.41535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68662',
  },
  {
    city: 'Silver Creek',
    county_fips: 31121,
    county_fips_all: '31121|31143|31125',
    county: 'Merrick',
    county_names_all: 'Merrick|Polk|Nance',
    county_weights: '{"31121": 45.78, "31143": 30.06, "31125": 24.16}',
    density: 3,
    imprecise: false,
    latitude: 41.31193,
    longitude: -97.69927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68663',
  },
  {
    city: 'Snyder',
    county_fips: 31053,
    county_fips_all: '31053',
    county: 'Dodge',
    county_names_all: 'Dodge',
    county_weights: '{"31053": 100}',
    density: 233.1,
    imprecise: false,
    latitude: 41.70453,
    longitude: -96.78694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68664',
  },
  {
    city: 'Spalding',
    county_fips: 31077,
    county_fips_all: '31077|31183',
    county: 'Greeley',
    county_names_all: 'Greeley|Wheeler',
    county_weights: '{"31077": 67.01, "31183": 32.99}',
    density: 1.4,
    imprecise: false,
    latitude: 41.70543,
    longitude: -98.41445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68665',
  },
  {
    city: 'Stromsburg',
    county_fips: 31143,
    county_fips_all: '31143|31185',
    county: 'Polk',
    county_names_all: 'Polk|York',
    county_weights: '{"31143": 97.53, "31185": 2.47}',
    density: 6.8,
    imprecise: false,
    latitude: 41.10775,
    longitude: -97.61369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68666',
  },
  {
    city: 'Surprise',
    county_fips: 31023,
    county_fips_all: '31023',
    county: 'Butler',
    county_names_all: 'Butler',
    county_weights: '{"31023": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 41.11231,
    longitude: -97.30278,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68667',
  },
  {
    city: 'Ulysses',
    county_fips: 31023,
    county_fips_all: '31023|31159',
    county: 'Butler',
    county_names_all: 'Butler|Seward',
    county_weights: '{"31023": 90.02, "31159": 9.98}',
    density: 3.1,
    imprecise: false,
    latitude: 41.07789,
    longitude: -97.23612,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68669',
  },
  {
    city: 'Norfolk',
    county_fips: 31119,
    county_fips_all: '31119|31167|31139',
    county: 'Madison',
    county_names_all: 'Madison|Stanton|Pierce',
    county_weights: '{"31119": 68.93, "31167": 18.85, "31139": 12.22}',
    density: 64.3,
    imprecise: false,
    latitude: 42.02024,
    longitude: -97.44099,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68701',
  },
  {
    city: 'Allen',
    county_fips: 31051,
    county_fips_all: '31051',
    county: 'Dixon',
    county_names_all: 'Dixon',
    county_weights: '{"31051": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 42.439,
    longitude: -96.84784,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68710',
  },
  {
    city: 'Amelia',
    county_fips: 31089,
    county_fips_all: '31089',
    county: 'Holt',
    county_names_all: 'Holt',
    county_weights: '{"31089": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 42.2034,
    longitude: -99.02407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68711',
  },
  {
    city: 'Atkinson',
    county_fips: 31089,
    county_fips_all: '31089',
    county: 'Holt',
    county_names_all: 'Holt',
    county_weights: '{"31089": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 42.54061,
    longitude: -98.9718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68713',
  },
  {
    city: 'Bassett',
    county_fips: 31149,
    county_fips_all: '31149|31115|31017',
    county: 'Rock',
    county_names_all: 'Rock|Loup|Brown',
    county_weights: '{"31149": 86.25, "31115": 11.65, "31017": 2.1}',
    density: 0.5,
    imprecise: false,
    latitude: 42.36957,
    longitude: -99.50258,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68714',
  },
  {
    city: 'Battle Creek',
    county_fips: 31119,
    county_fips_all: '31119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"31119": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 41.97003,
    longitude: -97.60883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68715',
  },
  {
    city: 'Beemer',
    county_fips: 31039,
    county_fips_all: '31039',
    county: 'Cuming',
    county_names_all: 'Cuming',
    county_weights: '{"31039": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 41.9314,
    longitude: -96.82337,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68716',
  },
  {
    city: 'Belden',
    county_fips: 31027,
    county_fips_all: '31027',
    county: 'Cedar',
    county_names_all: 'Cedar',
    county_weights: '{"31027": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 42.38962,
    longitude: -97.2192,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68717',
  },
  {
    city: 'Bloomfield',
    county_fips: 31107,
    county_fips_all: '31107',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"31107": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 42.6619,
    longitude: -97.69844,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68718',
  },
  {
    city: 'Bristow',
    county_fips: 31015,
    county_fips_all: '31015|46053',
    county: 'Boyd',
    county_names_all: 'Boyd|Gregory',
    county_weights: '{"31015": 60.08, "46053": 39.92}',
    density: 1.2,
    imprecise: false,
    latitude: 42.96446,
    longitude: -98.57426,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68719',
  },
  {
    city: 'Brunswick',
    county_fips: 31003,
    county_fips_all: '31003',
    county: 'Antelope',
    county_names_all: 'Antelope',
    county_weights: '{"31003": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 42.34659,
    longitude: -98.01418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68720',
  },
  {
    city: 'Butte',
    county_fips: 31015,
    county_fips_all: '31015',
    county: 'Boyd',
    county_names_all: 'Boyd',
    county_weights: '{"31015": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 42.92074,
    longitude: -98.87123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68722',
  },
  {
    city: 'Carroll',
    county_fips: 31179,
    county_fips_all: '31179',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"31179": 100}',
    density: 4,
    imprecise: false,
    latitude: 42.28759,
    longitude: -97.21456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68723',
  },
  {
    city: 'Center',
    county_fips: 31107,
    county_fips_all: '31107',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"31107": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 42.6276,
    longitude: -97.88496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68724',
  },
  {
    city: 'Chambers',
    county_fips: 31089,
    county_fips_all: '31089|31183',
    county: 'Holt',
    county_names_all: 'Holt|Wheeler',
    county_weights: '{"31089": 97.4, "31183": 2.6}',
    density: 1.4,
    imprecise: false,
    latitude: 42.20118,
    longitude: -98.77703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68725',
  },
  {
    city: 'Clearwater',
    county_fips: 31003,
    county_fips_all: '31003|31089',
    county: 'Antelope',
    county_names_all: 'Antelope|Holt',
    county_weights: '{"31003": 92.97, "31089": 7.03}',
    density: 2.1,
    imprecise: false,
    latitude: 42.17877,
    longitude: -98.19954,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68726',
  },
  {
    city: 'Coleridge',
    county_fips: 31027,
    county_fips_all: '31027',
    county: 'Cedar',
    county_names_all: 'Cedar',
    county_weights: '{"31027": 100}',
    density: 4,
    imprecise: false,
    latitude: 42.5116,
    longitude: -97.20596,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68727',
  },
  {
    city: 'Concord',
    county_fips: 31051,
    county_fips_all: '31051',
    county: 'Dixon',
    county_names_all: 'Dixon',
    county_weights: '{"31051": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 42.38085,
    longitude: -96.93641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68728',
  },
  {
    city: 'Creighton',
    county_fips: 31107,
    county_fips_all: '31107|31003',
    county: 'Knox',
    county_names_all: 'Knox|Antelope',
    county_weights: '{"31107": 82.02, "31003": 17.98}',
    density: 4,
    imprecise: false,
    latitude: 42.47479,
    longitude: -97.90784,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68729',
  },
  {
    city: 'Crofton',
    county_fips: 31107,
    county_fips_all: '31107|31027',
    county: 'Knox',
    county_names_all: 'Knox|Cedar',
    county_weights: '{"31107": 69.84, "31027": 30.16}',
    density: 5.6,
    imprecise: false,
    latitude: 42.76688,
    longitude: -97.53488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68730',
  },
  {
    city: 'Dakota City',
    county_fips: 31043,
    county_fips_all: '31043',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"31043": 100}',
    density: 36.8,
    imprecise: false,
    latitude: 42.40993,
    longitude: -96.48341,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68731',
  },
  {
    city: 'Dixon',
    county_fips: 31051,
    county_fips_all: '31051',
    county: 'Dixon',
    county_names_all: 'Dixon',
    county_weights: '{"31051": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 42.48176,
    longitude: -96.97387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68732',
  },
  {
    city: 'Emerson',
    county_fips: 31173,
    county_fips_all: '31173|31051|31043',
    county: 'Thurston',
    county_names_all: 'Thurston|Dixon|Dakota',
    county_weights: '{"31173": 42.16, "31051": 31.0, "31043": 26.84}',
    density: 4.6,
    imprecise: false,
    latitude: 42.28278,
    longitude: -96.72245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68733',
  },
  {
    city: 'Emmet',
    county_fips: 31089,
    county_fips_all: '31089',
    county: 'Holt',
    county_names_all: 'Holt',
    county_weights: '{"31089": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 42.42528,
    longitude: -98.8044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68734',
  },
  {
    city: 'Ewing',
    county_fips: 31089,
    county_fips_all: '31089|31183|31003',
    county: 'Holt',
    county_names_all: 'Holt|Wheeler|Antelope',
    county_weights: '{"31089": 64.83, "31183": 30.34, "31003": 4.83}',
    density: 0.9,
    imprecise: false,
    latitude: 42.14911,
    longitude: -98.45402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68735',
  },
  {
    city: 'Fordyce',
    county_fips: 31027,
    county_fips_all: '31027',
    county: 'Cedar',
    county_names_all: 'Cedar',
    county_weights: '{"31027": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 42.74481,
    longitude: -97.37136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68736',
  },
  {
    city: 'Hartington',
    county_fips: 31027,
    county_fips_all: '31027|31051',
    county: 'Cedar',
    county_names_all: 'Cedar|Dixon',
    county_weights: '{"31027": 98.74, "31051": 1.26}',
    density: 4.6,
    imprecise: false,
    latitude: 42.6284,
    longitude: -97.26265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68739',
  },
  {
    city: 'Hoskins',
    county_fips: 31179,
    county_fips_all: '31179|31167',
    county: 'Wayne',
    county_names_all: 'Wayne|Stanton',
    county_weights: '{"31179": 93.46, "31167": 6.54}',
    density: 5.3,
    imprecise: false,
    latitude: 42.14561,
    longitude: -97.29245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68740',
  },
  {
    city: 'Hubbard',
    county_fips: 31043,
    county_fips_all: '31043',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"31043": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 42.35711,
    longitude: -96.59375,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68741',
  },
  {
    city: 'Inman',
    county_fips: 31089,
    county_fips_all: '31089',
    county: 'Holt',
    county_names_all: 'Holt',
    county_weights: '{"31089": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 42.3572,
    longitude: -98.51459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68742',
  },
  {
    city: 'Jackson',
    county_fips: 31043,
    county_fips_all: '31043',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"31043": 100}',
    density: 6,
    imprecise: false,
    latitude: 42.47271,
    longitude: -96.62586,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68743',
  },
  {
    city: 'Laurel',
    county_fips: 31027,
    county_fips_all: '31027|31179|31051',
    county: 'Cedar',
    county_names_all: 'Cedar|Wayne|Dixon',
    county_weights: '{"31027": 88.19, "31179": 6.08, "31051": 5.73}',
    density: 5.1,
    imprecise: false,
    latitude: 42.44662,
    longitude: -97.08781,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68745',
  },
  {
    city: 'Lynch',
    county_fips: 31015,
    county_fips_all: '31015|31089',
    county: 'Boyd',
    county_names_all: 'Boyd|Holt',
    county_weights: '{"31015": 62.21, "31089": 37.79}',
    density: 0.4,
    imprecise: false,
    latitude: 42.80726,
    longitude: -98.4354,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68746',
  },
  {
    city: 'Mclean',
    county_fips: 31139,
    county_fips_all: '31139|31027',
    county: 'Pierce',
    county_names_all: 'Pierce|Cedar',
    county_weights: '{"31139": 96.11, "31027": 3.89}',
    density: 2.9,
    imprecise: false,
    latitude: 42.39398,
    longitude: -97.48873,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68747',
  },
  {
    city: 'Madison',
    county_fips: 31119,
    county_fips_all: '31119|31167',
    county: 'Madison',
    county_names_all: 'Madison|Stanton',
    county_weights: '{"31119": 82.71, "31167": 17.29}',
    density: 6.1,
    imprecise: false,
    latitude: 41.83883,
    longitude: -97.47638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68748',
  },
  {
    city: 'Magnet',
    county_fips: 31027,
    county_fips_all: '31027',
    county: 'Cedar',
    county_names_all: 'Cedar',
    county_weights: '{"31027": 100}',
    density: 23.3,
    imprecise: false,
    latitude: 42.46032,
    longitude: -97.47531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68749',
  },
  {
    city: 'Maskell',
    county_fips: 31051,
    county_fips_all: '31051',
    county: 'Dixon',
    county_names_all: 'Dixon',
    county_weights: '{"31051": 100}',
    density: 211.7,
    imprecise: false,
    latitude: 42.69035,
    longitude: -96.98138,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68751',
  },
  {
    city: 'Meadow Grove',
    county_fips: 31119,
    county_fips_all: '31119|31139',
    county: 'Madison',
    county_names_all: 'Madison|Pierce',
    county_weights: '{"31119": 75.87, "31139": 24.13}',
    density: 1.6,
    imprecise: false,
    latitude: 42.02269,
    longitude: -97.7154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68752',
  },
  {
    city: 'Mills',
    county_fips: 31103,
    county_fips_all: '31103',
    county: 'Keya Paha',
    county_names_all: 'Keya Paha',
    county_weights: '{"31103": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 42.84464,
    longitude: -99.45588,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68753',
  },
  {
    city: 'Naper',
    county_fips: 31015,
    county_fips_all: '31015|46053',
    county: 'Boyd',
    county_names_all: 'Boyd|Gregory',
    county_weights: '{"31015": 99.57, "46053": 0.43}',
    density: 1.1,
    imprecise: false,
    latitude: 42.92329,
    longitude: -99.12963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68755',
  },
  {
    city: 'Neligh',
    county_fips: 31003,
    county_fips_all: '31003',
    county: 'Antelope',
    county_names_all: 'Antelope',
    county_weights: '{"31003": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 42.18544,
    longitude: -97.97985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68756',
  },
  {
    city: 'Newcastle',
    county_fips: 31051,
    county_fips_all: '31051|31027',
    county: 'Dixon',
    county_names_all: 'Dixon|Cedar',
    county_weights: '{"31051": 91.91, "31027": 8.09}',
    density: 2.4,
    imprecise: false,
    latitude: 42.65247,
    longitude: -96.92554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68757',
  },
  {
    city: 'Newman Grove',
    county_fips: 31119,
    county_fips_all: '31119|31141|31011',
    county: 'Madison',
    county_names_all: 'Madison|Platte|Boone',
    county_weights: '{"31119": 56.41, "31141": 24.53, "31011": 19.06}',
    density: 4.1,
    imprecise: false,
    latitude: 41.7829,
    longitude: -97.78863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68758',
  },
  {
    city: 'Newport',
    county_fips: 31149,
    county_fips_all: '31149|31103',
    county: 'Rock',
    county_names_all: 'Rock|Keya Paha',
    county_weights: '{"31149": 56.05, "31103": 43.95}',
    density: 0.4,
    imprecise: false,
    latitude: 42.75096,
    longitude: -99.33762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68759',
  },
  {
    city: 'Niobrara',
    county_fips: 31107,
    county_fips_all: '31107',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"31107": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 42.76616,
    longitude: -98.03831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68760',
  },
  {
    city: 'Oakdale',
    county_fips: 31003,
    county_fips_all: '31003',
    county: 'Antelope',
    county_names_all: 'Antelope',
    county_weights: '{"31003": 100}',
    density: 3,
    imprecise: false,
    latitude: 42.02287,
    longitude: -97.9601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68761',
  },
  {
    city: 'Oneill',
    county_fips: 31089,
    county_fips_all: '31089|31107',
    county: 'Holt',
    county_names_all: 'Holt|Knox',
    county_weights: '{"31089": 98.58, "31107": 1.42}',
    density: 3.2,
    imprecise: false,
    latitude: 42.51809,
    longitude: -98.58254,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68763',
  },
  {
    city: 'Orchard',
    county_fips: 31003,
    county_fips_all: '31003|31107|31089',
    county: 'Antelope',
    county_names_all: 'Antelope|Knox|Holt',
    county_weights: '{"31003": 55.32, "31107": 35.96, "31089": 8.72}',
    density: 2.4,
    imprecise: false,
    latitude: 42.39881,
    longitude: -98.23177,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68764',
  },
  {
    city: 'Osmond',
    county_fips: 31139,
    county_fips_all: '31139',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"31139": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 42.33397,
    longitude: -97.6232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68765',
  },
  {
    city: 'Page',
    county_fips: 31089,
    county_fips_all: '31089',
    county: 'Holt',
    county_names_all: 'Holt',
    county_weights: '{"31089": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 42.42375,
    longitude: -98.40321,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68766',
  },
  {
    city: 'Pierce',
    county_fips: 31139,
    county_fips_all: '31139|31179',
    county: 'Pierce',
    county_names_all: 'Pierce|Wayne',
    county_weights: '{"31139": 98.85, "31179": 1.15}',
    density: 6.8,
    imprecise: false,
    latitude: 42.1969,
    longitude: -97.53622,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68767',
  },
  {
    city: 'Pilger',
    county_fips: 31167,
    county_fips_all: '31167|31179|31039',
    county: 'Stanton',
    county_names_all: 'Stanton|Wayne|Cuming',
    county_weights: '{"31167": 92.46, "31179": 5.19, "31039": 2.35}',
    density: 3.8,
    imprecise: false,
    latitude: 41.99871,
    longitude: -97.06871,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68768',
  },
  {
    city: 'Plainview',
    county_fips: 31139,
    county_fips_all: '31139|31003|31107',
    county: 'Pierce',
    county_names_all: 'Pierce|Antelope|Knox',
    county_weights: '{"31139": 64.04, "31003": 35.48, "31107": 0.48}',
    density: 4.2,
    imprecise: false,
    latitude: 42.3158,
    longitude: -97.81636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68769',
  },
  {
    city: 'Ponca',
    county_fips: 31051,
    county_fips_all: '31051|31043',
    county: 'Dixon',
    county_names_all: 'Dixon|Dakota',
    county_weights: '{"31051": 94.5, "31043": 5.5}',
    density: 5.5,
    imprecise: false,
    latitude: 42.56287,
    longitude: -96.76898,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68770',
  },
  {
    city: 'Randolph',
    county_fips: 31027,
    county_fips_all: '31027|31139|31179',
    county: 'Cedar',
    county_names_all: 'Cedar|Pierce|Wayne',
    county_weights: '{"31027": 49.36, "31139": 30.95, "31179": 19.69}',
    density: 3.6,
    imprecise: false,
    latitude: 42.38419,
    longitude: -97.35706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68771',
  },
  {
    city: 'Royal',
    county_fips: 31003,
    county_fips_all: '31003',
    county: 'Antelope',
    county_names_all: 'Antelope',
    county_weights: '{"31003": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 42.36245,
    longitude: -98.1199,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68773',
  },
  {
    city: 'Saint Helena',
    county_fips: 31027,
    county_fips_all: '31027',
    county: 'Cedar',
    county_names_all: 'Cedar',
    county_weights: '{"31027": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 42.81403,
    longitude: -97.27747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68774',
  },
  {
    city: 'South Sioux City',
    county_fips: 31043,
    county_fips_all: '31043',
    county: 'Dakota',
    county_names_all: 'Dakota',
    county_weights: '{"31043": 100}',
    density: 267.6,
    imprecise: false,
    latitude: 42.4601,
    longitude: -96.44424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68776',
  },
  {
    city: 'Spencer',
    county_fips: 31015,
    county_fips_all: '31015|31089',
    county: 'Boyd',
    county_names_all: 'Boyd|Holt',
    county_weights: '{"31015": 71.99, "31089": 28.01}',
    density: 1.3,
    imprecise: false,
    latitude: 42.86088,
    longitude: -98.68504,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68777',
  },
  {
    city: 'Springview',
    county_fips: 31103,
    county_fips_all: '31103',
    county: 'Keya Paha',
    county_names_all: 'Keya Paha',
    county_weights: '{"31103": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 42.86963,
    longitude: -99.79483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68778',
  },
  {
    city: 'Stanton',
    county_fips: 31167,
    county_fips_all: '31167',
    county: 'Stanton',
    county_names_all: 'Stanton',
    county_weights: '{"31167": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 41.9516,
    longitude: -97.21175,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68779',
  },
  {
    city: 'Stuart',
    county_fips: 31089,
    county_fips_all: '31089',
    county: 'Holt',
    county_names_all: 'Holt',
    county_weights: '{"31089": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 42.64621,
    longitude: -99.14062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68780',
  },
  {
    city: 'Tilden',
    county_fips: 31003,
    county_fips_all: '31003|31119|31139|31011',
    county: 'Antelope',
    county_names_all: 'Antelope|Madison|Pierce|Boone',
    county_weights:
      '{"31003": 54.51, "31119": 27.25, "31139": 12.42, "31011": 5.82}',
    density: 4,
    imprecise: false,
    latitude: 42.02743,
    longitude: -97.84561,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68781',
  },
  {
    city: 'Verdigre',
    county_fips: 31107,
    county_fips_all: '31107',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"31107": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 42.62523,
    longitude: -98.14612,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68783',
  },
  {
    city: 'Wakefield',
    county_fips: 31051,
    county_fips_all: '31051|31179|31173',
    county: 'Dixon',
    county_names_all: 'Dixon|Wayne|Thurston',
    county_weights: '{"31051": 52.49, "31179": 44.74, "31173": 2.77}',
    density: 5.9,
    imprecise: false,
    latitude: 42.25763,
    longitude: -96.88657,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68784',
  },
  {
    city: 'Waterbury',
    county_fips: 31051,
    county_fips_all: '31051|31043',
    county: 'Dixon',
    county_names_all: 'Dixon|Dakota',
    county_weights: '{"31051": 51.43, "31043": 48.57}',
    density: 3.1,
    imprecise: false,
    latitude: 42.42796,
    longitude: -96.7224,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68785',
  },
  {
    city: 'Wausa',
    county_fips: 31107,
    county_fips_all: '31107|31027|31139',
    county: 'Knox',
    county_names_all: 'Knox|Cedar|Pierce',
    county_weights: '{"31107": 78.67, "31027": 17.24, "31139": 4.09}',
    density: 3.3,
    imprecise: false,
    latitude: 42.50351,
    longitude: -97.55855,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68786',
  },
  {
    city: 'Wayne',
    county_fips: 31179,
    county_fips_all: '31179|31051',
    county: 'Wayne',
    county_names_all: 'Wayne|Dixon',
    county_weights: '{"31179": 93.7, "31051": 6.3}',
    density: 18.3,
    imprecise: false,
    latitude: 42.21372,
    longitude: -97.03351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68787',
  },
  {
    city: 'West Point',
    county_fips: 31039,
    county_fips_all: '31039|31053',
    county: 'Cuming',
    county_names_all: 'Cuming|Dodge',
    county_weights: '{"31039": 99.88, "31053": 0.12}',
    density: 9.5,
    imprecise: false,
    latitude: 41.8387,
    longitude: -96.72571,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68788',
  },
  {
    city: 'Winnetoon',
    county_fips: 31107,
    county_fips_all: '31107',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"31107": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 42.53642,
    longitude: -97.99182,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68789',
  },
  {
    city: 'Winside',
    county_fips: 31179,
    county_fips_all: '31179',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"31179": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 42.17384,
    longitude: -97.18616,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68790',
  },
  {
    city: 'Wisner',
    county_fips: 31039,
    county_fips_all: '31039|31179|31167',
    county: 'Cuming',
    county_names_all: 'Cuming|Wayne|Stanton',
    county_weights: '{"31039": 94.25, "31179": 4.34, "31167": 1.41}',
    density: 5.7,
    imprecise: false,
    latitude: 41.99103,
    longitude: -96.93245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68791',
  },
  {
    city: 'Wynot',
    county_fips: 31027,
    county_fips_all: '31027',
    county: 'Cedar',
    county_names_all: 'Cedar',
    county_weights: '{"31027": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 42.73323,
    longitude: -97.11427,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68792',
  },
  {
    city: 'Grand Island',
    county_fips: 31079,
    county_fips_all: '31079|31121',
    county: 'Hall',
    county_names_all: 'Hall|Merrick',
    county_weights: '{"31079": 59.7, "31121": 40.3}',
    density: 132.3,
    imprecise: false,
    latitude: 40.94949,
    longitude: -98.29295,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68801',
  },
  {
    city: 'Grand Island',
    county_fips: 31079,
    county_fips_all: '31079',
    county: 'Hall',
    county_names_all: 'Hall',
    county_weights: '{"31079": 100}',
    density: 113.5,
    imprecise: false,
    latitude: 40.95357,
    longitude: -98.41593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68803',
  },
  {
    city: 'Alda',
    county_fips: 31079,
    county_fips_all: '31079',
    county: 'Hall',
    county_names_all: 'Hall',
    county_weights: '{"31079": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 40.86238,
    longitude: -98.4675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68810',
  },
  {
    city: 'Amherst',
    county_fips: 31019,
    county_fips_all: '31019',
    county: 'Buffalo',
    county_names_all: 'Buffalo',
    county_weights: '{"31019": 100}',
    density: 2,
    imprecise: false,
    latitude: 40.9051,
    longitude: -99.279,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68812',
  },
  {
    city: 'Anselmo',
    county_fips: 31041,
    county_fips_all: '31041|31009|31115',
    county: 'Custer',
    county_names_all: 'Custer|Blaine|Loup',
    county_weights: '{"31041": 63.84, "31009": 25.34, "31115": 10.82}',
    density: 0.4,
    imprecise: false,
    latitude: 41.70477,
    longitude: -99.8355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68813',
  },
  {
    city: 'Ansley',
    county_fips: 31041,
    county_fips_all: '31041',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"31041": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 41.3086,
    longitude: -99.4102,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68814',
  },
  {
    city: 'Arcadia',
    county_fips: 31175,
    county_fips_all: '31175|31041|31163',
    county: 'Valley',
    county_names_all: 'Valley|Custer|Sherman',
    county_weights: '{"31175": 55.55, "31041": 25.97, "31163": 18.48}',
    density: 1.5,
    imprecise: false,
    latitude: 41.42941,
    longitude: -99.16045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68815',
  },
  {
    city: 'Archer',
    county_fips: 31121,
    county_fips_all: '31121',
    county: 'Merrick',
    county_names_all: 'Merrick',
    county_weights: '{"31121": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 41.17484,
    longitude: -98.13373,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68816',
  },
  {
    city: 'Ashton',
    county_fips: 31163,
    county_fips_all: '31163|31093',
    county: 'Sherman',
    county_names_all: 'Sherman|Howard',
    county_weights: '{"31163": 85.77, "31093": 14.23}',
    density: 1.6,
    imprecise: false,
    latitude: 41.26125,
    longitude: -98.7937,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68817',
  },
  {
    city: 'Aurora',
    county_fips: 31081,
    county_fips_all: '31081|31035',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Clay',
    county_weights: '{"31081": 94.01, "31035": 5.99}',
    density: 12.1,
    imprecise: false,
    latitude: 40.82211,
    longitude: -98.01036,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68818',
  },
  {
    city: 'Boelus',
    county_fips: 31093,
    county_fips_all: '31093',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"31093": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 41.1066,
    longitude: -98.70056,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68820',
  },
  {
    city: 'Brewster',
    county_fips: 31009,
    county_fips_all: '31009',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"31009": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 42.00177,
    longitude: -99.81628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68821',
  },
  {
    city: 'Broken Bow',
    county_fips: 31041,
    county_fips_all: '31041',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"31041": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 41.38899,
    longitude: -99.62766,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68822',
  },
  {
    city: 'Burwell',
    county_fips: 31071,
    county_fips_all: '31071|31115|31149|31175|31089|31041',
    county: 'Garfield',
    county_names_all: 'Garfield|Loup|Rock|Valley|Holt|Custer',
    county_weights:
      '{"31071": 54.91, "31115": 23.82, "31149": 10.17, "31175": 5.96, "31089": 2.93, "31041": 2.21}',
    density: 0.8,
    imprecise: false,
    latitude: 41.93653,
    longitude: -99.13255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68823',
  },
  {
    city: 'Cairo',
    county_fips: 31079,
    county_fips_all: '31079|31093',
    county: 'Hall',
    county_names_all: 'Hall|Howard',
    county_weights: '{"31079": 85.72, "31093": 14.28}',
    density: 6.7,
    imprecise: false,
    latitude: 41.00535,
    longitude: -98.61402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68824',
  },
  {
    city: 'Callaway',
    county_fips: 31041,
    county_fips_all: '31041',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"31041": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 41.27347,
    longitude: -99.95758,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68825',
  },
  {
    city: 'Central City',
    county_fips: 31121,
    county_fips_all: '31121',
    county: 'Merrick',
    county_names_all: 'Merrick',
    county_weights: '{"31121": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 41.16341,
    longitude: -98.0191,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68826',
  },
  {
    city: 'Chapman',
    county_fips: 31121,
    county_fips_all: '31121',
    county: 'Merrick',
    county_names_all: 'Merrick',
    county_weights: '{"31121": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 41.04247,
    longitude: -98.1811,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68827',
  },
  {
    city: 'Comstock',
    county_fips: 31041,
    county_fips_all: '31041|31175',
    county: 'Custer',
    county_names_all: 'Custer|Valley',
    county_weights: '{"31041": 72.84, "31175": 27.16}',
    density: 1,
    imprecise: false,
    latitude: 41.55626,
    longitude: -99.24776,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68828',
  },
  {
    city: 'Dannebrog',
    county_fips: 31093,
    county_fips_all: '31093|31079',
    county: 'Howard',
    county_names_all: 'Howard|Hall',
    county_weights: '{"31093": 96.0, "31079": 4.0}',
    density: 3.8,
    imprecise: false,
    latitude: 41.10937,
    longitude: -98.54661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68831',
  },
  {
    city: 'Doniphan',
    county_fips: 31079,
    county_fips_all: '31079|31081',
    county: 'Hall',
    county_names_all: 'Hall|Hamilton',
    county_weights: '{"31079": 88.36, "31081": 11.64}',
    density: 8.2,
    imprecise: false,
    latitude: 40.76963,
    longitude: -98.36608,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68832',
  },
  {
    city: 'Dunning',
    county_fips: 31009,
    county_fips_all: '31009|31041|31113',
    county: 'Blaine',
    county_names_all: 'Blaine|Custer|Logan',
    county_weights: '{"31009": 69.67, "31041": 23.74, "31113": 6.59}',
    density: 0.1,
    imprecise: false,
    latitude: 41.80281,
    longitude: -100.09433,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68833',
  },
  {
    city: 'Eddyville',
    county_fips: 31047,
    county_fips_all: '31047|31041',
    county: 'Dawson',
    county_names_all: 'Dawson|Custer',
    county_weights: '{"31047": 68.93, "31041": 31.07}',
    density: 0.8,
    imprecise: false,
    latitude: 41.01834,
    longitude: -99.65049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68834',
  },
  {
    city: 'Elba',
    county_fips: 31093,
    county_fips_all: '31093|31077',
    county: 'Howard',
    county_names_all: 'Howard|Greeley',
    county_weights: '{"31093": 90.88, "31077": 9.12}',
    density: 1.8,
    imprecise: false,
    latitude: 41.33326,
    longitude: -98.61769,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68835',
  },
  {
    city: 'Elm Creek',
    county_fips: 31019,
    county_fips_all: '31019|31137|31047',
    county: 'Buffalo',
    county_names_all: 'Buffalo|Phelps|Dawson',
    county_weights: '{"31019": 52.82, "31137": 31.93, "31047": 15.25}',
    density: 5,
    imprecise: false,
    latitude: 40.70709,
    longitude: -99.37865,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68836',
  },
  {
    city: 'Elyria',
    county_fips: 31175,
    county_fips_all: '31175',
    county: 'Valley',
    county_names_all: 'Valley',
    county_weights: '{"31175": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 41.66139,
    longitude: -99.06063,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68837',
  },
  {
    city: 'Farwell',
    county_fips: 31093,
    county_fips_all: '31093',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"31093": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 41.2156,
    longitude: -98.66755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68838',
  },
  {
    city: 'Gibbon',
    county_fips: 31019,
    county_fips_all: '31019|31099',
    county: 'Buffalo',
    county_names_all: 'Buffalo|Kearney',
    county_weights: '{"31019": 88.56, "31099": 11.44}',
    density: 6.7,
    imprecise: false,
    latitude: 40.75728,
    longitude: -98.88027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68840',
  },
  {
    city: 'Giltner',
    county_fips: 31081,
    county_fips_all: '31081',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"31081": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 40.76316,
    longitude: -98.16677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68841',
  },
  {
    city: 'Greeley',
    county_fips: 31077,
    county_fips_all: '31077',
    county: 'Greeley',
    county_names_all: 'Greeley',
    county_weights: '{"31077": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 41.58068,
    longitude: -98.53462,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68842',
  },
  {
    city: 'Hampton',
    county_fips: 31081,
    county_fips_all: '31081|31185',
    county: 'Hamilton',
    county_names_all: 'Hamilton|York',
    county_weights: '{"31081": 96.33, "31185": 3.67}',
    density: 5,
    imprecise: false,
    latitude: 40.90334,
    longitude: -97.88018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68843',
  },
  {
    city: 'Hazard',
    county_fips: 31163,
    county_fips_all: '31163|31019',
    county: 'Sherman',
    county_names_all: 'Sherman|Buffalo',
    county_weights: '{"31163": 64.13, "31019": 35.87}',
    density: 2.7,
    imprecise: false,
    latitude: 41.05659,
    longitude: -99.05938,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68844',
  },
  {
    city: 'Kearney',
    county_fips: 31019,
    county_fips_all: '31019|31099|31137',
    county: 'Buffalo',
    county_names_all: 'Buffalo|Kearney|Phelps',
    county_weights: '{"31019": 78.83, "31099": 12.29, "31137": 8.88}',
    density: 64.1,
    imprecise: false,
    latitude: 40.71583,
    longitude: -99.17059,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68845',
  },
  {
    city: 'Hordville',
    county_fips: 31081,
    county_fips_all: '31081',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"31081": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 41.06499,
    longitude: -97.88533,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68846',
  },
  {
    city: 'Kearney',
    county_fips: 31019,
    county_fips_all: '31019|31099',
    county: 'Buffalo',
    county_names_all: 'Buffalo|Kearney',
    county_weights: '{"31019": 80.34, "31099": 19.66}',
    density: 64.6,
    imprecise: false,
    latitude: 40.73465,
    longitude: -99.02272,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68847',
  },
  {
    city: 'Lexington',
    county_fips: 31047,
    county_fips_all: '31047|31073',
    county: 'Dawson',
    county_names_all: 'Dawson|Gosper',
    county_weights: '{"31047": 93.2, "31073": 6.8}',
    density: 18,
    imprecise: false,
    latitude: 40.82548,
    longitude: -99.73574,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68850',
  },
  {
    city: 'Litchfield',
    county_fips: 31163,
    county_fips_all: '31163|31041',
    county: 'Sherman',
    county_names_all: 'Sherman|Custer',
    county_weights: '{"31163": 86.55, "31041": 13.45}',
    density: 1.8,
    imprecise: false,
    latitude: 41.1672,
    longitude: -99.14628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68852',
  },
  {
    city: 'Loup City',
    county_fips: 31163,
    county_fips_all: '31163',
    county: 'Sherman',
    county_names_all: 'Sherman',
    county_weights: '{"31163": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 41.28975,
    longitude: -98.98616,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68853',
  },
  {
    city: 'Marquette',
    county_fips: 31081,
    county_fips_all: '31081',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"31081": 100}',
    density: 4,
    imprecise: false,
    latitude: 41.00798,
    longitude: -98.00239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68854',
  },
  {
    city: 'Mason City',
    county_fips: 31041,
    county_fips_all: '31041',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"31041": 100}',
    density: 1,
    imprecise: false,
    latitude: 41.16248,
    longitude: -99.32635,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68855',
  },
  {
    city: 'Merna',
    county_fips: 31041,
    county_fips_all: '31041',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"31041": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 41.50167,
    longitude: -99.8168,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68856',
  },
  {
    city: 'Miller',
    county_fips: 31019,
    county_fips_all: '31019|31041',
    county: 'Buffalo',
    county_names_all: 'Buffalo|Custer',
    county_weights: '{"31019": 95.68, "31041": 4.32}',
    density: 2,
    imprecise: false,
    latitude: 40.96171,
    longitude: -99.37797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68858',
  },
  {
    city: 'North Loup',
    county_fips: 31175,
    county_fips_all: '31175|31163',
    county: 'Valley',
    county_names_all: 'Valley|Sherman',
    county_weights: '{"31175": 88.4, "31163": 11.6}',
    density: 1.4,
    imprecise: false,
    latitude: 41.46103,
    longitude: -98.81931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68859',
  },
  {
    city: 'Oconto',
    county_fips: 31041,
    county_fips_all: '31041|31047',
    county: 'Custer',
    county_names_all: 'Custer|Dawson',
    county_weights: '{"31041": 96.82, "31047": 3.18}',
    density: 0.6,
    imprecise: false,
    latitude: 41.13378,
    longitude: -99.79167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68860',
  },
  {
    city: 'Odessa',
    county_fips: 31019,
    county_fips_all: '31019',
    county: 'Buffalo',
    county_names_all: 'Buffalo',
    county_weights: '{"31019": 100}',
    density: 60.6,
    imprecise: false,
    latitude: 40.69892,
    longitude: -99.2639,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68861',
  },
  {
    city: 'Ord',
    county_fips: 31175,
    county_fips_all: '31175|31071',
    county: 'Valley',
    county_names_all: 'Valley|Garfield',
    county_weights: '{"31175": 94.94, "31071": 5.06}',
    density: 3.8,
    imprecise: false,
    latitude: 41.60362,
    longitude: -98.93841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68862',
  },
  {
    city: 'Overton',
    county_fips: 31047,
    county_fips_all: '31047|31137',
    county: 'Dawson',
    county_names_all: 'Dawson|Phelps',
    county_weights: '{"31047": 87.13, "31137": 12.87}',
    density: 4.8,
    imprecise: false,
    latitude: 40.76628,
    longitude: -99.5252,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68863',
  },
  {
    city: 'Palmer',
    county_fips: 31121,
    county_fips_all: '31121|31125|31093',
    county: 'Merrick',
    county_names_all: 'Merrick|Nance|Howard',
    county_weights: '{"31121": 38.05, "31125": 37.37, "31093": 24.57}',
    density: 2.1,
    imprecise: false,
    latitude: 41.2608,
    longitude: -98.24046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68864',
  },
  {
    city: 'Phillips',
    county_fips: 31081,
    county_fips_all: '31081',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"31081": 100}',
    density: 6,
    imprecise: false,
    latitude: 40.89337,
    longitude: -98.187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68865',
  },
  {
    city: 'Pleasanton',
    county_fips: 31019,
    county_fips_all: '31019|31041',
    county: 'Buffalo',
    county_names_all: 'Buffalo|Custer',
    county_weights: '{"31019": 94.41, "31041": 5.59}',
    density: 4.1,
    imprecise: false,
    latitude: 40.96873,
    longitude: -99.12297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68866',
  },
  {
    city: 'Ravenna',
    county_fips: 31019,
    county_fips_all: '31019|31163',
    county: 'Buffalo',
    county_names_all: 'Buffalo|Sherman',
    county_weights: '{"31019": 73.32, "31163": 26.68}',
    density: 4,
    imprecise: false,
    latitude: 40.99944,
    longitude: -98.88325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68869',
  },
  {
    city: 'Riverdale',
    county_fips: 31019,
    county_fips_all: '31019',
    county: 'Buffalo',
    county_names_all: 'Buffalo',
    county_weights: '{"31019": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 40.8453,
    longitude: -99.15835,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68870',
  },
  {
    city: 'Rockville',
    county_fips: 31163,
    county_fips_all: '31163',
    county: 'Sherman',
    county_names_all: 'Sherman',
    county_weights: '{"31163": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 41.14039,
    longitude: -98.84788,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68871',
  },
  {
    city: 'Saint Libory',
    county_fips: 31093,
    county_fips_all: '31093|31121',
    county: 'Howard',
    county_names_all: 'Howard|Merrick',
    county_weights: '{"31093": 73.57, "31121": 26.43}',
    density: 6.1,
    imprecise: false,
    latitude: 41.09286,
    longitude: -98.33216,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68872',
  },
  {
    city: 'Saint Paul',
    county_fips: 31093,
    county_fips_all: '31093',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"31093": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 41.24696,
    longitude: -98.45149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68873',
  },
  {
    city: 'Sargent',
    county_fips: 31041,
    county_fips_all: '31041|31115',
    county: 'Custer',
    county_names_all: 'Custer|Loup',
    county_weights: '{"31041": 95.27, "31115": 4.73}',
    density: 1.2,
    imprecise: false,
    latitude: 41.63368,
    longitude: -99.42635,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68874',
  },
  {
    city: 'Scotia',
    county_fips: 31077,
    county_fips_all: '31077|31093',
    county: 'Greeley',
    county_names_all: 'Greeley|Howard',
    county_weights: '{"31077": 95.92, "31093": 4.08}',
    density: 2.1,
    imprecise: false,
    latitude: 41.51328,
    longitude: -98.68197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68875',
  },
  {
    city: 'Shelton',
    county_fips: 31019,
    county_fips_all: '31019|31079',
    county: 'Buffalo',
    county_names_all: 'Buffalo|Hall',
    county_weights: '{"31019": 72.37, "31079": 27.63}',
    density: 8.1,
    imprecise: false,
    latitude: 40.82492,
    longitude: -98.74663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68876',
  },
  {
    city: 'Sumner',
    county_fips: 31047,
    county_fips_all: '31047|31041',
    county: 'Dawson',
    county_names_all: 'Dawson|Custer',
    county_weights: '{"31047": 78.36, "31041": 21.64}',
    density: 1.5,
    imprecise: false,
    latitude: 40.98623,
    longitude: -99.50567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68878',
  },
  {
    city: 'Taylor',
    county_fips: 31115,
    county_fips_all: '31115',
    county: 'Loup',
    county_names_all: 'Loup',
    county_weights: '{"31115": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 41.87411,
    longitude: -99.50104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68879',
  },
  {
    city: 'Westerville',
    county_fips: 31041,
    county_fips_all: '31041',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"31041": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 41.43472,
    longitude: -99.35957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68881',
  },
  {
    city: 'Wolbach',
    county_fips: 31077,
    county_fips_all: '31077|31093|31125',
    county: 'Greeley',
    county_names_all: 'Greeley|Howard|Nance',
    county_weights: '{"31077": 67.68, "31093": 24.77, "31125": 7.55}',
    density: 1.2,
    imprecise: false,
    latitude: 41.42362,
    longitude: -98.40366,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68882',
  },
  {
    city: 'Wood River',
    county_fips: 31079,
    county_fips_all: '31079|31001',
    county: 'Hall',
    county_names_all: 'Hall|Adams',
    county_weights: '{"31079": 95.27, "31001": 4.73}',
    density: 5.2,
    imprecise: false,
    latitude: 40.81823,
    longitude: -98.58558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68883',
  },
  {
    city: 'Hastings',
    county_fips: 31001,
    county_fips_all: '31001|31035|31079',
    county: 'Adams',
    county_names_all: 'Adams|Clay|Hall',
    county_weights: '{"31001": 83.28, "31035": 14.3, "31079": 2.42}',
    density: 67.5,
    imprecise: false,
    latitude: 40.59092,
    longitude: -98.36599,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68901',
  },
  {
    city: 'Alma',
    county_fips: 31083,
    county_fips_all: '31083',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"31083": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 40.15482,
    longitude: -99.33521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68920',
  },
  {
    city: 'Arapahoe',
    county_fips: 31065,
    county_fips_all: '31065|31073',
    county: 'Furnas',
    county_names_all: 'Furnas|Gosper',
    county_weights: '{"31065": 53.55, "31073": 46.45}',
    density: 3.1,
    imprecise: false,
    latitude: 40.33653,
    longitude: -99.89976,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68922',
  },
  {
    city: 'Atlanta',
    county_fips: 31137,
    county_fips_all: '31137',
    county: 'Phelps',
    county_names_all: 'Phelps',
    county_weights: '{"31137": 100}',
    density: 217.5,
    imprecise: false,
    latitude: 40.36835,
    longitude: -99.47314,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68923',
  },
  {
    city: 'Axtell',
    county_fips: 31099,
    county_fips_all: '31099|31137',
    county: 'Kearney',
    county_names_all: 'Kearney|Phelps',
    county_weights: '{"31099": 89.0, "31137": 11.0}',
    density: 4.9,
    imprecise: false,
    latitude: 40.49557,
    longitude: -99.12469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68924',
  },
  {
    city: 'Ayr',
    county_fips: 31001,
    county_fips_all: '31001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"31001": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 40.42366,
    longitude: -98.43821,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68925',
  },
  {
    city: 'Beaver City',
    county_fips: 31065,
    county_fips_all: '31065',
    county: 'Furnas',
    county_names_all: 'Furnas',
    county_weights: '{"31065": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 40.09311,
    longitude: -99.85139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68926',
  },
  {
    city: 'Bertrand',
    county_fips: 31137,
    county_fips_all: '31137|31073',
    county: 'Phelps',
    county_names_all: 'Phelps|Gosper',
    county_weights: '{"31137": 64.91, "31073": 35.09}',
    density: 2.9,
    imprecise: false,
    latitude: 40.51146,
    longitude: -99.62665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68927',
  },
  {
    city: 'Bladen',
    county_fips: 31181,
    county_fips_all: '31181|31001',
    county: 'Webster',
    county_names_all: 'Webster|Adams',
    county_weights: '{"31181": 82.66, "31001": 17.34}',
    density: 1.2,
    imprecise: false,
    latitude: 40.2874,
    longitude: -98.60728,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68928',
  },
  {
    city: 'Bloomington',
    county_fips: 31061,
    county_fips_all: '31061',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"31061": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 40.15245,
    longitude: -99.07124,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68929',
  },
  {
    city: 'Blue Hill',
    county_fips: 31181,
    county_fips_all: '31181|31001',
    county: 'Webster',
    county_names_all: 'Webster|Adams',
    county_weights: '{"31181": 80.75, "31001": 19.25}',
    density: 3.1,
    imprecise: false,
    latitude: 40.28514,
    longitude: -98.41846,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68930',
  },
  {
    city: 'Campbell',
    county_fips: 31061,
    county_fips_all: '31061|31181|31099|31001',
    county: 'Franklin',
    county_names_all: 'Franklin|Webster|Kearney|Adams',
    county_weights:
      '{"31061": 41.95, "31181": 32.56, "31099": 12.76, "31001": 12.74}',
    density: 1.5,
    imprecise: false,
    latitude: 40.30258,
    longitude: -98.73851,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68932',
  },
  {
    city: 'Clay Center',
    county_fips: 31035,
    county_fips_all: '31035',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"31035": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 40.51786,
    longitude: -98.04211,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68933',
  },
  {
    city: 'Deweese',
    county_fips: 31129,
    county_fips_all: '31129|31035',
    county: 'Nuckolls',
    county_names_all: 'Nuckolls|Clay',
    county_weights: '{"31129": 68.84, "31035": 31.16}',
    density: 0.9,
    imprecise: false,
    latitude: 40.33831,
    longitude: -98.15962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68934',
  },
  {
    city: 'Edgar',
    county_fips: 31035,
    county_fips_all: '31035|31129',
    county: 'Clay',
    county_names_all: 'Clay|Nuckolls',
    county_weights: '{"31035": 63.84, "31129": 36.16}',
    density: 2.3,
    imprecise: false,
    latitude: 40.38058,
    longitude: -97.95859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68935',
  },
  {
    city: 'Edison',
    county_fips: 31065,
    county_fips_all: '31065|31073',
    county: 'Furnas',
    county_names_all: 'Furnas|Gosper',
    county_weights: '{"31065": 63.94, "31073": 36.06}',
    density: 0.8,
    imprecise: false,
    latitude: 40.31655,
    longitude: -99.77868,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68936',
  },
  {
    city: 'Elwood',
    county_fips: 31073,
    county_fips_all: '31073|31047|31063',
    county: 'Gosper',
    county_names_all: 'Gosper|Dawson|Frontier',
    county_weights: '{"31073": 92.65, "31047": 3.99, "31063": 3.36}',
    density: 3.5,
    imprecise: false,
    latitude: 40.57262,
    longitude: -99.85494,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68937',
  },
  {
    city: 'Fairfield',
    county_fips: 31035,
    county_fips_all: '31035',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"31035": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 40.42093,
    longitude: -98.12344,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68938',
  },
  {
    city: 'Franklin',
    county_fips: 31061,
    county_fips_all: '31061',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"31061": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 40.10977,
    longitude: -98.96169,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68939',
  },
  {
    city: 'Funk',
    county_fips: 31137,
    county_fips_all: '31137',
    county: 'Phelps',
    county_names_all: 'Phelps',
    county_weights: '{"31137": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 40.53815,
    longitude: -99.25086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68940',
  },
  {
    city: 'Glenvil',
    county_fips: 31035,
    county_fips_all: '31035|31001',
    county: 'Clay',
    county_names_all: 'Clay|Adams',
    county_weights: '{"31035": 58.74, "31001": 41.26}',
    density: 2.8,
    imprecise: false,
    latitude: 40.46882,
    longitude: -98.26792,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68941',
  },
  {
    city: 'Guide Rock',
    county_fips: 31181,
    county_fips_all: '31181|31129',
    county: 'Webster',
    county_names_all: 'Webster|Nuckolls',
    county_weights: '{"31181": 72.93, "31129": 27.07}',
    density: 1.6,
    imprecise: false,
    latitude: 40.09552,
    longitude: -98.31143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68942',
  },
  {
    city: 'Hardy',
    county_fips: 31129,
    county_fips_all: '31129|20157|31169',
    county: 'Nuckolls',
    county_names_all: 'Nuckolls|Republic|Thayer',
    county_weights: '{"31129": 84.06, "20157": 11.82, "31169": 4.12}',
    density: 1.6,
    imprecise: false,
    latitude: 40.03916,
    longitude: -97.88589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68943',
  },
  {
    city: 'Harvard',
    county_fips: 31035,
    county_fips_all: '31035|31081',
    county: 'Clay',
    county_names_all: 'Clay|Hamilton',
    county_weights: '{"31035": 89.34, "31081": 10.66}',
    density: 4.5,
    imprecise: false,
    latitude: 40.63741,
    longitude: -98.0949,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68944',
  },
  {
    city: 'Heartwell',
    county_fips: 31099,
    county_fips_all: '31099|31001',
    county: 'Kearney',
    county_names_all: 'Kearney|Adams',
    county_weights: '{"31099": 97.85, "31001": 2.15}',
    density: 1.3,
    imprecise: false,
    latitude: 40.56098,
    longitude: -98.77327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68945',
  },
  {
    city: 'Hendley',
    county_fips: 31065,
    county_fips_all: '31065',
    county: 'Furnas',
    county_names_all: 'Furnas',
    county_weights: '{"31065": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 40.1067,
    longitude: -99.99048,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68946',
  },
  {
    city: 'Hildreth',
    county_fips: 31061,
    county_fips_all: '31061|31099',
    county: 'Franklin',
    county_names_all: 'Franklin|Kearney',
    county_weights: '{"31061": 79.21, "31099": 20.79}',
    density: 2.7,
    imprecise: false,
    latitude: 40.30139,
    longitude: -99.05188,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68947',
  },
  {
    city: 'Holbrook',
    county_fips: 31065,
    county_fips_all: '31065|31073|31063',
    county: 'Furnas',
    county_names_all: 'Furnas|Gosper|Frontier',
    county_weights: '{"31065": 48.64, "31073": 30.84, "31063": 20.52}',
    density: 1.1,
    imprecise: false,
    latitude: 40.34151,
    longitude: -100.02639,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68948',
  },
  {
    city: 'Holdrege',
    county_fips: 31137,
    county_fips_all: '31137|31083',
    county: 'Phelps',
    county_names_all: 'Phelps|Harlan',
    county_weights: '{"31137": 85.04, "31083": 14.96}',
    density: 11.8,
    imprecise: false,
    latitude: 40.43193,
    longitude: -99.39481,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68949',
  },
  {
    city: 'Holstein',
    county_fips: 31001,
    county_fips_all: '31001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"31001": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 40.45586,
    longitude: -98.66413,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68950',
  },
  {
    city: 'Inavale',
    county_fips: 31181,
    county_fips_all: '31181',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"31181": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 40.08443,
    longitude: -98.67587,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68952',
  },
  {
    city: 'Inland',
    county_fips: 31035,
    county_fips_all: '31035',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"31035": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 40.61215,
    longitude: -98.23512,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68954',
  },
  {
    city: 'Juniata',
    county_fips: 31001,
    county_fips_all: '31001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"31001": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 40.59288,
    longitude: -98.53966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68955',
  },
  {
    city: 'Kenesaw',
    county_fips: 31001,
    county_fips_all: '31001|31099|31079|31019',
    county: 'Adams',
    county_names_all: 'Adams|Kearney|Hall|Buffalo',
    county_weights:
      '{"31001": 71.42, "31099": 20.24, "31079": 6.51, "31019": 1.83}',
    density: 4.6,
    imprecise: false,
    latitude: 40.63088,
    longitude: -98.6891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68956',
  },
  {
    city: 'Lawrence',
    county_fips: 31129,
    county_fips_all: '31129|31181|31001|31035',
    county: 'Nuckolls',
    county_names_all: 'Nuckolls|Webster|Adams|Clay',
    county_weights:
      '{"31129": 68.42, "31181": 26.98, "31001": 2.75, "31035": 1.85}',
    density: 2.1,
    imprecise: false,
    latitude: 40.26745,
    longitude: -98.24176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68957',
  },
  {
    city: 'Loomis',
    county_fips: 31137,
    county_fips_all: '31137',
    county: 'Phelps',
    county_names_all: 'Phelps',
    county_weights: '{"31137": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 40.52772,
    longitude: -99.50394,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68958',
  },
  {
    city: 'Minden',
    county_fips: 31099,
    county_fips_all: '31099',
    county: 'Kearney',
    county_names_all: 'Kearney',
    county_weights: '{"31099": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 40.49009,
    longitude: -98.91487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68959',
  },
  {
    city: 'Naponee',
    county_fips: 31061,
    county_fips_all: '31061|31083',
    county: 'Franklin',
    county_names_all: 'Franklin|Harlan',
    county_weights: '{"31061": 98.16, "31083": 1.84}',
    density: 1.5,
    imprecise: false,
    latitude: 40.08549,
    longitude: -99.13866,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68960',
  },
  {
    city: 'Nelson',
    county_fips: 31129,
    county_fips_all: '31129',
    county: 'Nuckolls',
    county_names_all: 'Nuckolls',
    county_weights: '{"31129": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 40.20679,
    longitude: -98.03502,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68961',
  },
  {
    city: 'Oak',
    county_fips: 31129,
    county_fips_all: '31129|31169',
    county: 'Nuckolls',
    county_names_all: 'Nuckolls|Thayer',
    county_weights: '{"31129": 96.65, "31169": 3.35}',
    density: 1.9,
    imprecise: false,
    latitude: 40.23541,
    longitude: -97.90207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68964',
  },
  {
    city: 'Orleans',
    county_fips: 31083,
    county_fips_all: '31083',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"31083": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 40.15765,
    longitude: -99.46262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68966',
  },
  {
    city: 'Oxford',
    county_fips: 31065,
    county_fips_all: '31065|31083|31073',
    county: 'Furnas',
    county_names_all: 'Furnas|Harlan|Gosper',
    county_weights: '{"31065": 48.82, "31083": 47.6, "31073": 3.58}',
    density: 1.8,
    imprecise: false,
    latitude: 40.25263,
    longitude: -99.63085,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68967',
  },
  {
    city: 'Red Cloud',
    county_fips: 31181,
    county_fips_all: '31181',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"31181": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 40.10157,
    longitude: -98.52292,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68970',
  },
  {
    city: 'Republican City',
    county_fips: 31083,
    county_fips_all: '31083',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"31083": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 40.11931,
    longitude: -99.24478,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68971',
  },
  {
    city: 'Riverton',
    county_fips: 31061,
    county_fips_all: '31061|31181',
    county: 'Franklin',
    county_names_all: 'Franklin|Webster',
    county_weights: '{"31061": 99.27, "31181": 0.73}',
    density: 0.7,
    imprecise: false,
    latitude: 40.10361,
    longitude: -98.80258,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68972',
  },
  {
    city: 'Roseland',
    county_fips: 31001,
    county_fips_all: '31001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"31001": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 40.45014,
    longitude: -98.55962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68973',
  },
  {
    city: 'Ruskin',
    county_fips: 31129,
    county_fips_all: '31129|31169',
    county: 'Nuckolls',
    county_names_all: 'Nuckolls|Thayer',
    county_weights: '{"31129": 88.99, "31169": 11.01}',
    density: 2.9,
    imprecise: false,
    latitude: 40.13235,
    longitude: -97.86457,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68974',
  },
  {
    city: 'Saronville',
    county_fips: 31035,
    county_fips_all: '31035',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"31035": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 40.61705,
    longitude: -97.95483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 88,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68975',
  },
  {
    city: 'Smithfield',
    county_fips: 31073,
    county_fips_all: '31073',
    county: 'Gosper',
    county_names_all: 'Gosper',
    county_weights: '{"31073": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 40.6023,
    longitude: -99.70918,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68976',
  },
  {
    city: 'Stamford',
    county_fips: 31083,
    county_fips_all: '31083|31065',
    county: 'Harlan',
    county_names_all: 'Harlan|Furnas',
    county_weights: '{"31083": 50.9, "31065": 49.1}',
    density: 0.9,
    imprecise: false,
    latitude: 40.06697,
    longitude: -99.63045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68977',
  },
  {
    city: 'Superior',
    county_fips: 31129,
    county_fips_all: '31129|20089',
    county: 'Nuckolls',
    county_names_all: 'Nuckolls|Jewell',
    county_weights: '{"31129": 84.65, "20089": 15.35}',
    density: 5.8,
    imprecise: false,
    latitude: 40.06339,
    longitude: -98.09379,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68978',
  },
  {
    city: 'Sutton',
    county_fips: 31035,
    county_fips_all: '31035|31059|31081|31185',
    county: 'Clay',
    county_names_all: 'Clay|Fillmore|Hamilton|York',
    county_weights:
      '{"31035": 64.26, "31059": 29.08, "31081": 5.19, "31185": 1.47}',
    density: 4.5,
    imprecise: false,
    latitude: 40.59717,
    longitude: -97.85319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68979',
  },
  {
    city: 'Trumbull',
    county_fips: 31035,
    county_fips_all: '31035|31001|31081|31079',
    county: 'Clay',
    county_names_all: 'Clay|Adams|Hamilton|Hall',
    county_weights:
      '{"31035": 46.5, "31001": 26.64, "31081": 18.87, "31079": 7.99}',
    density: 5.8,
    imprecise: false,
    latitude: 40.68213,
    longitude: -98.25814,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68980',
  },
  {
    city: 'Upland',
    county_fips: 31061,
    county_fips_all: '31061|31099',
    county: 'Franklin',
    county_names_all: 'Franklin|Kearney',
    county_weights: '{"31061": 89.67, "31099": 10.33}',
    density: 0.7,
    imprecise: false,
    latitude: 40.28601,
    longitude: -98.89237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68981',
  },
  {
    city: 'Wilcox',
    county_fips: 31061,
    county_fips_all: '31061|31083|31137|31099',
    county: 'Franklin',
    county_names_all: 'Franklin|Harlan|Phelps|Kearney',
    county_weights:
      '{"31061": 30.4, "31083": 29.69, "31137": 27.39, "31099": 12.52}',
    density: 2.6,
    imprecise: false,
    latitude: 40.33081,
    longitude: -99.19521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68982',
  },
  {
    city: 'McCook',
    county_fips: 31145,
    county_fips_all: '31145|31063|31085|31087',
    county: 'Red Willow',
    county_names_all: 'Red Willow|Frontier|Hayes|Hitchcock',
    county_weights:
      '{"31145": 66.11, "31063": 25.57, "31085": 5.36, "31087": 2.96}',
    density: 7.5,
    imprecise: false,
    latitude: 40.25232,
    longitude: -100.65782,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69001',
  },
  {
    city: 'Bartley',
    county_fips: 31145,
    county_fips_all: '31145|31063',
    county: 'Red Willow',
    county_names_all: 'Red Willow|Frontier',
    county_weights: '{"31145": 82.97, "31063": 17.03}',
    density: 1.9,
    imprecise: false,
    latitude: 40.23522,
    longitude: -100.31448,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69020',
  },
  {
    city: 'Benkelman',
    county_fips: 31057,
    county_fips_all: '31057',
    county: 'Dundy',
    county_names_all: 'Dundy',
    county_weights: '{"31057": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 40.13945,
    longitude: -101.53594,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69021',
  },
  {
    city: 'Cambridge',
    county_fips: 31063,
    county_fips_all: '31063|31065|31145',
    county: 'Frontier',
    county_names_all: 'Frontier|Furnas|Red Willow',
    county_weights: '{"31063": 47.03, "31065": 35.52, "31145": 17.44}',
    density: 2,
    imprecise: false,
    latitude: 40.33938,
    longitude: -100.18413,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69022',
  },
  {
    city: 'Champion',
    county_fips: 31029,
    county_fips_all: '31029',
    county: 'Chase',
    county_names_all: 'Chase',
    county_weights: '{"31029": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 40.48132,
    longitude: -101.89668,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69023',
  },
  {
    city: 'Culbertson',
    county_fips: 31087,
    county_fips_all: '31087|31085|31145|31063',
    county: 'Hitchcock',
    county_names_all: 'Hitchcock|Hayes|Red Willow|Frontier',
    county_weights:
      '{"31087": 76.17, "31085": 19.59, "31145": 2.75, "31063": 1.49}',
    density: 1.4,
    imprecise: false,
    latitude: 40.23918,
    longitude: -100.856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69024',
  },
  {
    city: 'Curtis',
    county_fips: 31063,
    county_fips_all: '31063|31111',
    county: 'Frontier',
    county_names_all: 'Frontier|Lincoln',
    county_weights: '{"31063": 74.41, "31111": 25.59}',
    density: 1.5,
    imprecise: false,
    latitude: 40.61957,
    longitude: -100.50814,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69025',
  },
  {
    city: 'Danbury',
    county_fips: 31145,
    county_fips_all: '31145|20039',
    county: 'Red Willow',
    county_names_all: 'Red Willow|Decatur',
    county_weights: '{"31145": 64.33, "20039": 35.67}',
    density: 0.7,
    imprecise: false,
    latitude: 40.01975,
    longitude: -100.41332,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69026',
  },
  {
    city: 'Enders',
    county_fips: 31029,
    county_fips_all: '31029|31057',
    county: 'Chase',
    county_names_all: 'Chase|Dundy',
    county_weights: '{"31029": 92.75, "31057": 7.25}',
    density: 0.2,
    imprecise: false,
    latitude: 40.49841,
    longitude: -101.52638,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69027',
  },
  {
    city: 'Eustis',
    county_fips: 31063,
    county_fips_all: '31063|31047|31073',
    county: 'Frontier',
    county_names_all: 'Frontier|Dawson|Gosper',
    county_weights: '{"31063": 67.21, "31047": 25.03, "31073": 7.76}',
    density: 1.9,
    imprecise: false,
    latitude: 40.64107,
    longitude: -100.04708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69028',
  },
  {
    city: 'Farnam',
    county_fips: 31063,
    county_fips_all: '31063|31111|31047',
    county: 'Frontier',
    county_names_all: 'Frontier|Lincoln|Dawson',
    county_weights: '{"31063": 52.53, "31111": 29.02, "31047": 18.45}',
    density: 0.7,
    imprecise: false,
    latitude: 40.68537,
    longitude: -100.24277,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69029',
  },
  {
    city: 'Haigler',
    county_fips: 31057,
    county_fips_all: '31057|31029',
    county: 'Dundy',
    county_names_all: 'Dundy|Chase',
    county_weights: '{"31057": 88.58, "31029": 11.42}',
    density: 0.3,
    imprecise: false,
    latitude: 40.20318,
    longitude: -101.92592,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69030',
  },
  {
    city: 'Hayes Center',
    county_fips: 31085,
    county_fips_all: '31085',
    county: 'Hayes',
    county_names_all: 'Hayes',
    county_weights: '{"31085": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 40.56766,
    longitude: -101.0471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69032',
  },
  {
    city: 'Imperial',
    county_fips: 31029,
    county_fips_all: '31029|31135',
    county: 'Chase',
    county_names_all: 'Chase|Perkins',
    county_weights: '{"31029": 96.09, "31135": 3.91}',
    density: 3,
    imprecise: false,
    latitude: 40.56447,
    longitude: -101.68679,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69033',
  },
  {
    city: 'Indianola',
    county_fips: 31145,
    county_fips_all: '31145|31063',
    county: 'Red Willow',
    county_names_all: 'Red Willow|Frontier',
    county_weights: '{"31145": 78.73, "31063": 21.27}',
    density: 1.8,
    imprecise: false,
    latitude: 40.24929,
    longitude: -100.43866,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69034',
  },
  {
    city: 'Lebanon',
    county_fips: 31145,
    county_fips_all: '31145',
    county: 'Red Willow',
    county_names_all: 'Red Willow',
    county_weights: '{"31145": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 40.02788,
    longitude: -100.29782,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69036',
  },
  {
    city: 'Max',
    county_fips: 31057,
    county_fips_all: '31057',
    county: 'Dundy',
    county_names_all: 'Dundy',
    county_weights: '{"31057": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 40.17759,
    longitude: -101.40394,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69037',
  },
  {
    city: 'Maywood',
    county_fips: 31063,
    county_fips_all: '31063|31085',
    county: 'Frontier',
    county_names_all: 'Frontier|Hayes',
    county_weights: '{"31063": 64.32, "31085": 35.68}',
    density: 0.8,
    imprecise: false,
    latitude: 40.60932,
    longitude: -100.73703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69038',
  },
  {
    city: 'Moorefield',
    county_fips: 31111,
    county_fips_all: '31111|31063',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Frontier',
    county_weights: '{"31111": 54.33, "31063": 45.67}',
    density: 0.4,
    imprecise: false,
    latitude: 40.7013,
    longitude: -100.38529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69039',
  },
  {
    city: 'Palisade',
    county_fips: 31085,
    county_fips_all: '31085|31087',
    county: 'Hayes',
    county_names_all: 'Hayes|Hitchcock',
    county_weights: '{"31085": 51.53, "31087": 48.47}',
    density: 1.1,
    imprecise: false,
    latitude: 40.35565,
    longitude: -101.12027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69040',
  },
  {
    city: 'Parks',
    county_fips: 31057,
    county_fips_all: '31057',
    county: 'Dundy',
    county_names_all: 'Dundy',
    county_weights: '{"31057": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 40.17288,
    longitude: -101.73415,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 88,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69041',
  },
  {
    city: 'Stockville',
    county_fips: 31063,
    county_fips_all: '31063',
    county: 'Frontier',
    county_names_all: 'Frontier',
    county_weights: '{"31063": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 40.47547,
    longitude: -100.37903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69042',
  },
  {
    city: 'Stratton',
    county_fips: 31087,
    county_fips_all: '31087|31057',
    county: 'Hitchcock',
    county_names_all: 'Hitchcock|Dundy',
    county_weights: '{"31087": 95.35, "31057": 4.65}',
    density: 1.1,
    imprecise: false,
    latitude: 40.13493,
    longitude: -101.23754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69043',
  },
  {
    city: 'Trenton',
    county_fips: 31087,
    county_fips_all: '31087',
    county: 'Hitchcock',
    county_names_all: 'Hitchcock',
    county_weights: '{"31087": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 40.13171,
    longitude: -101.02837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69044',
  },
  {
    city: 'Wauneta',
    county_fips: 31029,
    county_fips_all: '31029|31085|31057|31087',
    county: 'Chase',
    county_names_all: 'Chase|Hayes|Dundy|Hitchcock',
    county_weights:
      '{"31029": 42.5, "31085": 34.37, "31057": 20.31, "31087": 2.83}',
    density: 0.9,
    imprecise: false,
    latitude: 40.44582,
    longitude: -101.36639,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69045',
  },
  {
    city: 'Wilsonville',
    county_fips: 31065,
    county_fips_all: '31065|31145',
    county: 'Furnas',
    county_names_all: 'Furnas|Red Willow',
    county_weights: '{"31065": 88.34, "31145": 11.66}',
    density: 0.6,
    imprecise: false,
    latitude: 40.06821,
    longitude: -100.10403,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69046',
  },
  {
    city: 'North Platte',
    county_fips: 31111,
    county_fips_all: '31111|31117',
    county: 'Lincoln',
    county_names_all: 'Lincoln|McPherson',
    county_weights: '{"31111": 94.1, "31117": 5.9}',
    density: 17.9,
    imprecise: false,
    latitude: 41.1502,
    longitude: -100.80319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69101',
  },
  {
    city: 'Arnold',
    county_fips: 31041,
    county_fips_all: '31041|31113|31111',
    county: 'Custer',
    county_names_all: 'Custer|Logan|Lincoln',
    county_weights: '{"31041": 54.91, "31113": 24.59, "31111": 20.5}',
    density: 1.3,
    imprecise: false,
    latitude: 41.42592,
    longitude: -100.23384,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69120',
  },
  {
    city: 'Arthur',
    county_fips: 31005,
    county_fips_all: '31005',
    county: 'Arthur',
    county_names_all: 'Arthur',
    county_weights: '{"31005": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 41.56631,
    longitude: -101.71983,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69121',
  },
  {
    city: 'Big Springs',
    county_fips: 31049,
    county_fips_all: '31049|31101|31135',
    county: 'Deuel',
    county_names_all: 'Deuel|Keith|Perkins',
    county_weights: '{"31049": 59.71, "31101": 23.83, "31135": 16.46}',
    density: 1.1,
    imprecise: false,
    latitude: 41.09713,
    longitude: -102.08834,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69122',
  },
  {
    city: 'Brady',
    county_fips: 31111,
    county_fips_all: '31111',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"31111": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 41.04981,
    longitude: -100.36627,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69123',
  },
  {
    city: 'Broadwater',
    county_fips: 31123,
    county_fips_all: '31123',
    county: 'Morrill',
    county_names_all: 'Morrill',
    county_weights: '{"31123": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 41.59087,
    longitude: -102.85835,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69125',
  },
  {
    city: 'Brule',
    county_fips: 31101,
    county_fips_all: '31101|31135',
    county: 'Keith',
    county_names_all: 'Keith|Perkins',
    county_weights: '{"31101": 83.6, "31135": 16.4}',
    density: 1.7,
    imprecise: false,
    latitude: 41.10231,
    longitude: -101.90774,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69127',
  },
  {
    city: 'Bushnell',
    county_fips: 31105,
    county_fips_all: '31105|31007',
    county: 'Kimball',
    county_names_all: 'Kimball|Banner',
    county_weights: '{"31105": 88.79, "31007": 11.21}',
    density: 0.4,
    imprecise: false,
    latitude: 41.23252,
    longitude: -103.90613,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69128',
  },
  {
    city: 'Chappell',
    county_fips: 31049,
    county_fips_all: '31049|31069',
    county: 'Deuel',
    county_names_all: 'Deuel|Garden',
    county_weights: '{"31049": 80.38, "31069": 19.62}',
    density: 1.4,
    imprecise: false,
    latitude: 41.14089,
    longitude: -102.37823,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69129',
  },
  {
    city: 'Cozad',
    county_fips: 31047,
    county_fips_all: '31047|31041',
    county: 'Dawson',
    county_names_all: 'Dawson|Custer',
    county_weights: '{"31047": 93.05, "31041": 6.95}',
    density: 7.6,
    imprecise: false,
    latitude: 40.89924,
    longitude: -99.96628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69130',
  },
  {
    city: 'Dalton',
    county_fips: 31033,
    county_fips_all: '31033|31123',
    county: 'Cheyenne',
    county_names_all: 'Cheyenne|Morrill',
    county_weights: '{"31033": 63.03, "31123": 36.97}',
    density: 1.1,
    imprecise: false,
    latitude: 41.4216,
    longitude: -103.00047,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69131',
  },
  {
    city: 'Dickens',
    county_fips: 31111,
    county_fips_all: '31111',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"31111": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 40.81495,
    longitude: -101.00664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 88,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69132',
  },
  {
    city: 'Dix',
    county_fips: 31105,
    county_fips_all: '31105',
    county: 'Kimball',
    county_names_all: 'Kimball',
    county_weights: '{"31105": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 41.21975,
    longitude: -103.47178,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69133',
  },
  {
    city: 'Elsie',
    county_fips: 31135,
    county_fips_all: '31135|31029|31085',
    county: 'Perkins',
    county_names_all: 'Perkins|Chase|Hayes',
    county_weights: '{"31135": 78.72, "31029": 11.09, "31085": 10.18}',
    density: 0.5,
    imprecise: false,
    latitude: 40.80733,
    longitude: -101.36968,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69134',
  },
  {
    city: 'Elsmere',
    county_fips: 31031,
    county_fips_all: '31031',
    county: 'Cherry',
    county_names_all: 'Cherry',
    county_weights: '{"31031": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 42.21111,
    longitude: -100.31028,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69135',
  },
  {
    city: 'Gothenburg',
    county_fips: 31047,
    county_fips_all: '31047|31041|31111',
    county: 'Dawson',
    county_names_all: 'Dawson|Custer|Lincoln',
    county_weights: '{"31047": 42.38, "31041": 33.38, "31111": 24.24}',
    density: 5.1,
    imprecise: false,
    latitude: 40.99923,
    longitude: -100.17684,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69138',
  },
  {
    city: 'Grant',
    county_fips: 31135,
    county_fips_all: '31135',
    county: 'Perkins',
    county_names_all: 'Perkins',
    county_weights: '{"31135": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 40.84129,
    longitude: -101.7724,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69140',
  },
  {
    city: 'Gurley',
    county_fips: 31033,
    county_fips_all: '31033',
    county: 'Cheyenne',
    county_names_all: 'Cheyenne',
    county_weights: '{"31033": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 41.30409,
    longitude: -102.93602,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69141',
  },
  {
    city: 'Halsey',
    county_fips: 31171,
    county_fips_all: '31171',
    county: 'Thomas',
    county_names_all: 'Thomas',
    county_weights: '{"31171": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 41.91585,
    longitude: -100.31719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69142',
  },
  {
    city: 'Hershey',
    county_fips: 31111,
    county_fips_all: '31111',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"31111": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 41.19184,
    longitude: -101.01934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69143',
  },
  {
    city: 'Keystone',
    county_fips: 31101,
    county_fips_all: '31101|31005',
    county: 'Keith',
    county_names_all: 'Keith|Arthur',
    county_weights: '{"31101": 88.6, "31005": 11.4}',
    density: 0.4,
    imprecise: false,
    latitude: 41.317,
    longitude: -101.60261,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69144',
  },
  {
    city: 'Kimball',
    county_fips: 31105,
    county_fips_all: '31105|31007',
    county: 'Kimball',
    county_names_all: 'Kimball|Banner',
    county_weights: '{"31105": 82.06, "31007": 17.94}',
    density: 2.4,
    imprecise: false,
    latitude: 41.24913,
    longitude: -103.67097,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69145',
  },
  {
    city: 'Lemoyne',
    county_fips: 31101,
    county_fips_all: '31101|31005',
    county: 'Keith',
    county_names_all: 'Keith|Arthur',
    county_weights: '{"31101": 67.43, "31005": 32.57}',
    density: 0.6,
    imprecise: false,
    latitude: 41.34986,
    longitude: -101.82892,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69146',
  },
  {
    city: 'Lewellen',
    county_fips: 31069,
    county_fips_all: '31069|31101|31005',
    county: 'Garden',
    county_names_all: 'Garden|Keith|Arthur',
    county_weights: '{"31069": 86.16, "31101": 12.34, "31005": 1.5}',
    density: 0.7,
    imprecise: false,
    latitude: 41.51514,
    longitude: -102.08813,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69147',
  },
  {
    city: 'Lisco',
    county_fips: 31069,
    county_fips_all: '31069|31123',
    county: 'Garden',
    county_names_all: 'Garden|Morrill',
    county_weights: '{"31069": 75.08, "31123": 24.92}',
    density: 0.1,
    imprecise: false,
    latitude: 41.61329,
    longitude: -102.58773,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69148',
  },
  {
    city: 'Lodgepole',
    county_fips: 31033,
    county_fips_all: '31033|31069|31049',
    county: 'Cheyenne',
    county_names_all: 'Cheyenne|Garden|Deuel',
    county_weights: '{"31033": 77.16, "31069": 18.56, "31049": 4.28}',
    density: 0.9,
    imprecise: false,
    latitude: 41.22416,
    longitude: -102.66362,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69149',
  },
  {
    city: 'Madrid',
    county_fips: 31135,
    county_fips_all: '31135',
    county: 'Perkins',
    county_names_all: 'Perkins',
    county_weights: '{"31135": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 40.82763,
    longitude: -101.54599,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69150',
  },
  {
    city: 'Maxwell',
    county_fips: 31111,
    county_fips_all: '31111',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"31111": 100}',
    density: 1,
    imprecise: false,
    latitude: 41.10153,
    longitude: -100.52011,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69151',
  },
  {
    city: 'Mullen',
    county_fips: 31091,
    county_fips_all: '31091|31031',
    county: 'Hooker',
    county_names_all: 'Hooker|Cherry',
    county_weights: '{"31091": 50.94, "31031": 49.06}',
    density: 0.2,
    imprecise: false,
    latitude: 42.08697,
    longitude: -101.12216,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69152',
  },
  {
    city: 'Ogallala',
    county_fips: 31101,
    county_fips_all: '31101|31135',
    county: 'Keith',
    county_names_all: 'Keith|Perkins',
    county_weights: '{"31101": 85.18, "31135": 14.82}',
    density: 9.3,
    imprecise: false,
    latitude: 41.08018,
    longitude: -101.67866,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69153',
  },
  {
    city: 'Oshkosh',
    county_fips: 31069,
    county_fips_all: '31069',
    county: 'Garden',
    county_names_all: 'Garden',
    county_weights: '{"31069": 100}',
    density: 1,
    imprecise: false,
    latitude: 41.4642,
    longitude: -102.35349,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69154',
  },
  {
    city: 'Paxton',
    county_fips: 31101,
    county_fips_all: '31101|31135|31117|31005',
    county: 'Keith',
    county_names_all: 'Keith|Perkins|McPherson|Arthur',
    county_weights:
      '{"31101": 93.13, "31135": 5.19, "31117": 1.17, "31005": 0.51}',
    density: 1,
    imprecise: false,
    latitude: 41.18974,
    longitude: -101.39008,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69155',
  },
  {
    city: 'Potter',
    county_fips: 31033,
    county_fips_all: '31033|31007|31105',
    county: 'Cheyenne',
    county_names_all: 'Cheyenne|Banner|Kimball',
    county_weights: '{"31033": 62.25, "31007": 23.55, "31105": 14.2}',
    density: 0.7,
    imprecise: false,
    latitude: 41.27689,
    longitude: -103.34587,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69156',
  },
  {
    city: 'Purdum',
    county_fips: 31009,
    county_fips_all: '31009|31017|31031',
    county: 'Blaine',
    county_names_all: 'Blaine|Brown|Cherry',
    county_weights: '{"31009": 71.33, "31017": 20.62, "31031": 8.06}',
    density: 0.2,
    imprecise: false,
    latitude: 42.02451,
    longitude: -100.14824,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69157',
  },
  {
    city: 'Seneca',
    county_fips: 31031,
    county_fips_all: '31031|31171',
    county: 'Cherry',
    county_names_all: 'Cherry|Thomas',
    county_weights: '{"31031": 65.06, "31171": 34.94}',
    density: 0.1,
    imprecise: false,
    latitude: 42.12034,
    longitude: -100.76679,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 53,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69161',
  },
  {
    city: 'Sidney',
    county_fips: 31033,
    county_fips_all: '31033',
    county: 'Cheyenne',
    county_names_all: 'Cheyenne',
    county_weights: '{"31033": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 41.13001,
    longitude: -103.02815,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69162',
  },
  {
    city: 'Stapleton',
    county_fips: 31113,
    county_fips_all: '31113|31171|31111|31117',
    county: 'Logan',
    county_names_all: 'Logan|Thomas|Lincoln|McPherson',
    county_weights:
      '{"31113": 62.63, "31171": 19.68, "31111": 12.46, "31117": 5.23}',
    density: 0.5,
    imprecise: false,
    latitude: 41.59328,
    longitude: -100.56795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69163',
  },
  {
    city: 'Sutherland',
    county_fips: 31111,
    county_fips_all: '31111|31117|31005',
    county: 'Lincoln',
    county_names_all: 'Lincoln|McPherson|Arthur',
    county_weights: '{"31111": 50.33, "31117": 31.69, "31005": 17.98}',
    density: 1.3,
    imprecise: false,
    latitude: 41.35102,
    longitude: -101.27268,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69165',
  },
  {
    city: 'Thedford',
    county_fips: 31171,
    county_fips_all: '31171|31031',
    county: 'Thomas',
    county_names_all: 'Thomas|Cherry',
    county_weights: '{"31171": 52.1, "31031": 47.9}',
    density: 0.3,
    imprecise: false,
    latitude: 42.0791,
    longitude: -100.56581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69166',
  },
  {
    city: 'Tryon',
    county_fips: 31117,
    county_fips_all: '31117',
    county: 'McPherson',
    county_names_all: 'McPherson',
    county_weights: '{"31117": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 41.58758,
    longitude: -101.02296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69167',
  },
  {
    city: 'Venango',
    county_fips: 31135,
    county_fips_all: '31135|31029|08115',
    county: 'Perkins',
    county_names_all: 'Perkins|Chase|Sedgwick',
    county_weights: '{"31135": 61.36, "31029": 34.21, "08115": 4.43}',
    density: 0.8,
    imprecise: false,
    latitude: 40.74817,
    longitude: -101.98129,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69168',
  },
  {
    city: 'Wallace',
    county_fips: 31111,
    county_fips_all: '31111|31135|31085',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Perkins|Hayes',
    county_weights: '{"31111": 77.68, "31135": 16.37, "31085": 5.95}',
    density: 0.8,
    imprecise: false,
    latitude: 40.82144,
    longitude: -101.17663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69169',
  },
  {
    city: 'Wellfleet',
    county_fips: 31111,
    county_fips_all: '31111',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"31111": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 40.79563,
    longitude: -100.74068,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69170',
  },
  {
    city: 'Willow Island',
    county_fips: 31047,
    county_fips_all: '31047',
    county: 'Dawson',
    county_names_all: 'Dawson',
    county_weights: '{"31047": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.89065,
    longitude: -100.06814,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69171',
  },
  {
    city: 'Valentine',
    county_fips: 31031,
    county_fips_all: '31031|46121',
    county: 'Cherry',
    county_names_all: 'Cherry|Todd',
    county_weights: '{"31031": 83.23, "46121": 16.77}',
    density: 1,
    imprecise: false,
    latitude: 42.70004,
    longitude: -100.59663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69201',
  },
  {
    city: 'Ainsworth',
    county_fips: 31017,
    county_fips_all: '31017',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"31017": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 42.39766,
    longitude: -99.84932,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69210',
  },
  {
    city: 'Cody',
    county_fips: 31031,
    county_fips_all: '31031',
    county: 'Cherry',
    county_names_all: 'Cherry',
    county_weights: '{"31031": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 42.83965,
    longitude: -101.31068,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69211',
  },
  {
    city: 'Crookston',
    county_fips: 31031,
    county_fips_all: '31031|46121',
    county: 'Cherry',
    county_names_all: 'Cherry|Todd',
    county_weights: '{"31031": 57.03, "46121": 42.97}',
    density: 0.5,
    imprecise: false,
    latitude: 42.98729,
    longitude: -100.80438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69212',
  },
  {
    city: 'Johnstown',
    county_fips: 31017,
    county_fips_all: '31017|31031',
    county: 'Brown',
    county_names_all: 'Brown|Cherry',
    county_weights: '{"31017": 94.19, "31031": 5.81}',
    density: 0.1,
    imprecise: false,
    latitude: 42.49121,
    longitude: -100.07914,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69214',
  },
  {
    city: 'Kilgore',
    county_fips: 31031,
    county_fips_all: '31031|46121',
    county: 'Cherry',
    county_names_all: 'Cherry|Todd',
    county_weights: '{"31031": 70.8, "46121": 29.2}',
    density: 0.4,
    imprecise: false,
    latitude: 42.94069,
    longitude: -100.96897,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69216',
  },
  {
    city: 'Long Pine',
    county_fips: 31017,
    county_fips_all: '31017|31149',
    county: 'Brown',
    county_names_all: 'Brown|Rock',
    county_weights: '{"31017": 85.29, "31149": 14.71}',
    density: 1.2,
    imprecise: false,
    latitude: 42.42045,
    longitude: -99.71314,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69217',
  },
  {
    city: 'Merriman',
    county_fips: 31031,
    county_fips_all: '31031',
    county: 'Cherry',
    county_names_all: 'Cherry',
    county_weights: '{"31031": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 42.78005,
    longitude: -101.63227,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69218',
  },
  {
    city: 'Nenzel',
    county_fips: 31031,
    county_fips_all: '31031',
    county: 'Cherry',
    county_names_all: 'Cherry',
    county_weights: '{"31031": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 42.70144,
    longitude: -101.0886,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 40,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69219',
  },
  {
    city: 'Sparks',
    county_fips: 31103,
    county_fips_all: '31103|31031',
    county: 'Keya Paha',
    county_names_all: 'Keya Paha|Cherry',
    county_weights: '{"31103": 66.08, "31031": 33.92}',
    density: 0.2,
    imprecise: false,
    latitude: 42.92256,
    longitude: -100.17198,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69220',
  },
  {
    city: 'Wood Lake',
    county_fips: 31031,
    county_fips_all: '31031',
    county: 'Cherry',
    county_names_all: 'Cherry',
    county_weights: '{"31031": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 42.63515,
    longitude: -100.3104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69221',
  },
  {
    city: 'Alliance',
    county_fips: 31013,
    county_fips_all: '31013|31161|31123',
    county: 'Box Butte',
    county_names_all: 'Box Butte|Sheridan|Morrill',
    county_weights: '{"31013": 59.46, "31161": 23.5, "31123": 17.04}',
    density: 3.6,
    imprecise: false,
    latitude: 42.12297,
    longitude: -102.88593,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69301',
  },
  {
    city: 'Angora',
    county_fips: 31123,
    county_fips_all: '31123',
    county: 'Morrill',
    county_names_all: 'Morrill',
    county_weights: '{"31123": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.85235,
    longitude: -102.96047,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 25,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69331',
  },
  {
    city: 'Ashby',
    county_fips: 31075,
    county_fips_all: '31075|31031|31069|31161',
    county: 'Grant',
    county_names_all: 'Grant|Cherry|Garden|Sheridan',
    county_weights:
      '{"31075": 42.58, "31031": 40.47, "31069": 16.42, "31161": 0.53}',
    density: 0.2,
    imprecise: false,
    latitude: 42.04483,
    longitude: -101.96962,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69333',
  },
  {
    city: 'Bayard',
    county_fips: 31123,
    county_fips_all: '31123|31157|31007',
    county: 'Morrill',
    county_names_all: 'Morrill|Scotts Bluff|Banner',
    county_weights: '{"31123": 83.04, "31157": 11.05, "31007": 5.91}',
    density: 3,
    imprecise: false,
    latitude: 41.82364,
    longitude: -103.2842,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69334',
  },
  {
    city: 'Bingham',
    county_fips: 31161,
    county_fips_all: '31161|31069',
    county: 'Sheridan',
    county_names_all: 'Sheridan|Garden',
    county_weights: '{"31161": 61.39, "31069": 38.61}',
    density: 0.1,
    imprecise: false,
    latitude: 42.02418,
    longitude: -102.13908,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69335',
  },
  {
    city: 'Bridgeport',
    county_fips: 31123,
    county_fips_all: '31123|31007',
    county: 'Morrill',
    county_names_all: 'Morrill|Banner',
    county_weights: '{"31123": 97.13, "31007": 2.87}',
    density: 1.9,
    imprecise: false,
    latitude: 41.61845,
    longitude: -103.15152,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69336',
  },
  {
    city: 'Chadron',
    county_fips: 31045,
    county_fips_all: '31045|46102|31161|46047',
    county: 'Dawes',
    county_names_all: 'Dawes|Oglala Lakota|Sheridan|Fall River',
    county_weights:
      '{"31045": 78.95, "46102": 11.41, "31161": 6.53, "46047": 3.11}',
    density: 3.2,
    imprecise: false,
    latitude: 42.86566,
    longitude: -102.99513,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69337',
  },
  {
    city: 'Crawford',
    county_fips: 31045,
    county_fips_all: '31045|31165',
    county: 'Dawes',
    county_names_all: 'Dawes|Sioux',
    county_weights: '{"31045": 67.38, "31165": 32.62}',
    density: 1.4,
    imprecise: false,
    latitude: 42.60649,
    longitude: -103.42939,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69339',
  },
  {
    city: 'Ellsworth',
    county_fips: 31161,
    county_fips_all: '31161|31069|31031',
    county: 'Sheridan',
    county_names_all: 'Sheridan|Garden|Cherry',
    county_weights: '{"31161": 76.21, "31069": 17.27, "31031": 6.52}',
    density: 0.2,
    imprecise: false,
    latitude: 42.15192,
    longitude: -102.21378,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69340',
  },
  {
    city: 'Gering',
    county_fips: 31157,
    county_fips_all: '31157|31007',
    county: 'Scotts Bluff',
    county_names_all: 'Scotts Bluff|Banner',
    county_weights: '{"31157": 81.56, "31007": 18.44}',
    density: 19.6,
    imprecise: false,
    latitude: 41.74154,
    longitude: -103.67937,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69341',
  },
  {
    city: 'Gordon',
    county_fips: 31031,
    county_fips_all: '31031|31161',
    county: 'Cherry',
    county_names_all: 'Cherry|Sheridan',
    county_weights: '{"31031": 59.95, "31161": 40.05}',
    density: 0.7,
    imprecise: false,
    latitude: 42.66842,
    longitude: -101.94084,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69343',
  },
  {
    city: 'Harrisburg',
    county_fips: 31007,
    county_fips_all: '31007',
    county: 'Banner',
    county_names_all: 'Banner',
    county_weights: '{"31007": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 41.58164,
    longitude: -103.7234,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69345',
  },
  {
    city: 'Harrison',
    county_fips: 31165,
    county_fips_all: '31165',
    county: 'Sioux',
    county_names_all: 'Sioux',
    county_weights: '{"31165": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 42.66459,
    longitude: -103.80651,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69346',
  },
  {
    city: 'Hay Springs',
    county_fips: 31161,
    county_fips_all: '31161|31045',
    county: 'Sheridan',
    county_names_all: 'Sheridan|Dawes',
    county_weights: '{"31161": 82.35, "31045": 17.65}',
    density: 1.1,
    imprecise: false,
    latitude: 42.59693,
    longitude: -102.6753,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69347',
  },
  {
    city: 'Hemingford',
    county_fips: 31013,
    county_fips_all: '31013|31045|31165',
    county: 'Box Butte',
    county_names_all: 'Box Butte|Dawes|Sioux',
    county_weights: '{"31013": 70.05, "31045": 15.96, "31165": 13.99}',
    density: 0.9,
    imprecise: false,
    latitude: 42.3299,
    longitude: -103.18777,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69348',
  },
  {
    city: 'Hyannis',
    county_fips: 31075,
    county_fips_all: '31075|31031|31005',
    county: 'Grant',
    county_names_all: 'Grant|Cherry|Arthur',
    county_weights: '{"31075": 63.45, "31031": 30.75, "31005": 5.8}',
    density: 0.3,
    imprecise: false,
    latitude: 41.98667,
    longitude: -101.73311,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69350',
  },
  {
    city: 'Lakeside',
    county_fips: 31161,
    county_fips_all: '31161|31069',
    county: 'Sheridan',
    county_names_all: 'Sheridan|Garden',
    county_weights: '{"31161": 59.72, "31069": 40.28}',
    density: 0.1,
    imprecise: false,
    latitude: 42.1171,
    longitude: -102.42096,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69351',
  },
  {
    city: 'Lyman',
    county_fips: 31157,
    county_fips_all: '31157',
    county: 'Scotts Bluff',
    county_names_all: 'Scotts Bluff',
    county_weights: '{"31157": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 41.80396,
    longitude: -103.97174,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69352',
  },
  {
    city: 'Mcgrew',
    county_fips: 31157,
    county_fips_all: '31157',
    county: 'Scotts Bluff',
    county_names_all: 'Scotts Bluff',
    county_weights: '{"31157": 100}',
    density: 220.3,
    imprecise: false,
    latitude: 41.74703,
    longitude: -103.41898,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69353',
  },
  {
    city: 'Marsland',
    county_fips: 31165,
    county_fips_all: '31165|31045|31013',
    county: 'Sioux',
    county_names_all: 'Sioux|Dawes|Box Butte',
    county_weights: '{"31165": 49.79, "31045": 34.71, "31013": 15.49}',
    density: 0.1,
    imprecise: false,
    latitude: 42.40812,
    longitude: -103.42469,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69354',
  },
  {
    city: 'Melbeta',
    county_fips: 31157,
    county_fips_all: '31157',
    county: 'Scotts Bluff',
    county_names_all: 'Scotts Bluff',
    county_weights: '{"31157": 100}',
    density: 587,
    imprecise: false,
    latitude: 41.78192,
    longitude: -103.51709,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69355',
  },
  {
    city: 'Minatare',
    county_fips: 31157,
    county_fips_all: '31157',
    county: 'Scotts Bluff',
    county_names_all: 'Scotts Bluff',
    county_weights: '{"31157": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 41.89318,
    longitude: -103.45074,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69356',
  },
  {
    city: 'Mitchell',
    county_fips: 31165,
    county_fips_all: '31165|31157',
    county: 'Sioux',
    county_names_all: 'Sioux|Scotts Bluff',
    county_weights: '{"31165": 68.56, "31157": 31.44}',
    density: 3.9,
    imprecise: false,
    latitude: 42.0776,
    longitude: -103.79553,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69357',
  },
  {
    city: 'Morrill',
    county_fips: 31165,
    county_fips_all: '31165|31157',
    county: 'Sioux',
    county_names_all: 'Sioux|Scotts Bluff',
    county_weights: '{"31165": 71.89, "31157": 28.11}',
    density: 4.1,
    imprecise: false,
    latitude: 42.07503,
    longitude: -103.96617,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69358',
  },
  {
    city: 'Rushville',
    county_fips: 31161,
    county_fips_all: '31161',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"31161": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 42.74359,
    longitude: -102.48979,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69360',
  },
  {
    city: 'Scottsbluff',
    county_fips: 31165,
    county_fips_all: '31165|31157',
    county: 'Sioux',
    county_names_all: 'Sioux|Scotts Bluff',
    county_weights: '{"31165": 56.59, "31157": 43.41}',
    density: 27.9,
    imprecise: false,
    latitude: 42.01254,
    longitude: -103.56802,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 17187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69361',
  },
  {
    city: 'Whiteclay',
    county_fips: 31161,
    county_fips_all: '31161',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"31161": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 42.94744,
    longitude: -102.46095,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69365',
  },
  {
    city: 'Whitman',
    county_fips: 31031,
    county_fips_all: '31031|31075|31005',
    county: 'Cherry',
    county_names_all: 'Cherry|Grant|Arthur',
    county_weights: '{"31031": 58.32, "31075": 39.42, "31005": 2.26}',
    density: 0.2,
    imprecise: false,
    latitude: 42.13175,
    longitude: -101.5421,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69366',
  },
  {
    city: 'Whitney',
    county_fips: 31045,
    county_fips_all: '31045',
    county: 'Dawes',
    county_names_all: 'Dawes',
    county_weights: '{"31045": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 42.81651,
    longitude: -103.32332,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '69367',
  },
  {
    city: 'Metairie',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 2321.5,
    imprecise: false,
    latitude: 29.98272,
    longitude: -90.16881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70001',
  },
  {
    city: 'Metairie',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 2324.8,
    imprecise: false,
    latitude: 30.0102,
    longitude: -90.16241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70002',
  },
  {
    city: 'Metairie',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 2183.2,
    imprecise: false,
    latitude: 29.99874,
    longitude: -90.21418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70003',
  },
  {
    city: 'Metairie',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 2215.6,
    imprecise: false,
    latitude: 30.00024,
    longitude: -90.13422,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70005',
  },
  {
    city: 'Metairie',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 2378,
    imprecise: false,
    latitude: 30.01393,
    longitude: -90.19171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70006',
  },
  {
    city: 'Des Allemands',
    county_fips: 22089,
    county_fips_all: '22089|22057',
    county: 'St. Charles',
    county_names_all: 'St. Charles|Lafourche',
    county_weights: '{"22089": 82.98, "22057": 17.02}',
    density: 59,
    imprecise: false,
    latitude: 29.81635,
    longitude: -90.43526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70030',
  },
  {
    city: 'Ama',
    county_fips: 22089,
    county_fips_all: '22089',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"22089": 100}',
    density: 163.5,
    imprecise: false,
    latitude: 29.94401,
    longitude: -90.29666,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70031',
  },
  {
    city: 'Arabi',
    county_fips: 22087,
    county_fips_all: '22087',
    county: 'St. Bernard',
    county_names_all: 'St. Bernard',
    county_weights: '{"22087": 100}',
    density: 874,
    imprecise: false,
    latitude: 29.95128,
    longitude: -89.9958,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70032',
  },
  {
    city: 'Barataria',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 26.7,
    imprecise: false,
    latitude: 29.69855,
    longitude: -90.12667,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70036',
  },
  {
    city: 'Belle Chasse',
    county_fips: 22075,
    county_fips_all: '22075',
    county: 'Plaquemines',
    county_names_all: 'Plaquemines',
    county_weights: '{"22075": 100}',
    density: 128.7,
    imprecise: false,
    latitude: 29.78669,
    longitude: -90.01523,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70037',
  },
  {
    city: 'Boothville',
    county_fips: 22075,
    county_fips_all: '22075',
    county: 'Plaquemines',
    county_names_all: 'Plaquemines',
    county_weights: '{"22075": 100}',
    density: 192.2,
    imprecise: false,
    latitude: 29.33105,
    longitude: -89.4007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70038',
  },
  {
    city: 'Boutte',
    county_fips: 22089,
    county_fips_all: '22089',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"22089": 100}',
    density: 57.4,
    imprecise: false,
    latitude: 29.88274,
    longitude: -90.37925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70039',
  },
  {
    city: 'Braithwaite',
    county_fips: 22075,
    county_fips_all: '22075|22087',
    county: 'Plaquemines',
    county_names_all: 'Plaquemines|St. Bernard',
    county_weights: '{"22075": 99.15, "22087": 0.85}',
    density: 4.3,
    imprecise: false,
    latitude: 29.75806,
    longitude: -89.92327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70040',
  },
  {
    city: 'Buras',
    county_fips: 22075,
    county_fips_all: '22075',
    county: 'Plaquemines',
    county_names_all: 'Plaquemines',
    county_weights: '{"22075": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 29.33194,
    longitude: -89.46978,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70041',
  },
  {
    city: 'Chalmette',
    county_fips: 22087,
    county_fips_all: '22087',
    county: 'St. Bernard',
    county_names_all: 'St. Bernard',
    county_weights: '{"22087": 100}',
    density: 957,
    imprecise: false,
    latitude: 29.9571,
    longitude: -89.96481,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70043',
  },
  {
    city: 'Destrehan',
    county_fips: 22089,
    county_fips_all: '22089',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"22089": 100}',
    density: 419.5,
    imprecise: false,
    latitude: 29.96686,
    longitude: -90.36552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70047',
  },
  {
    city: 'Edgard',
    county_fips: 22095,
    county_fips_all: '22095',
    county: 'St. John the Baptist',
    county_names_all: 'St. John the Baptist',
    county_weights: '{"22095": 100}',
    density: 35,
    imprecise: false,
    latitude: 30.03062,
    longitude: -90.55911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70049',
  },
  {
    city: 'Empire',
    county_fips: 22075,
    county_fips_all: '22075',
    county: 'Plaquemines',
    county_names_all: 'Plaquemines',
    county_weights: '{"22075": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.38351,
    longitude: -89.59601,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70050',
  },
  {
    city: 'Garyville',
    county_fips: 22095,
    county_fips_all: '22095',
    county: 'St. John the Baptist',
    county_names_all: 'St. John the Baptist',
    county_weights: '{"22095": 100}',
    density: 89.8,
    imprecise: false,
    latitude: 30.07356,
    longitude: -90.63999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70051',
  },
  {
    city: 'Gramercy',
    county_fips: 22093,
    county_fips_all: '22093',
    county: 'St. James',
    county_names_all: 'St. James',
    county_weights: '{"22093": 100}',
    density: 158.9,
    imprecise: false,
    latitude: 30.07103,
    longitude: -90.68731,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70052',
  },
  {
    city: 'Gretna',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 1874.4,
    imprecise: false,
    latitude: 29.91456,
    longitude: -90.05318,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70053',
  },
  {
    city: 'Gretna',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 2303,
    imprecise: false,
    latitude: 29.88848,
    longitude: -90.03028,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70056',
  },
  {
    city: 'Hahnville',
    county_fips: 22089,
    county_fips_all: '22089',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"22089": 100}',
    density: 35.8,
    imprecise: false,
    latitude: 29.95949,
    longitude: -90.45897,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70057',
  },
  {
    city: 'Harvey',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 1197.3,
    imprecise: false,
    latitude: 29.8701,
    longitude: -90.06708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70058',
  },
  {
    city: 'Kenner',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 973.1,
    imprecise: false,
    latitude: 29.98924,
    longitude: -90.25579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70062',
  },
  {
    city: 'Kenner',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 2349.8,
    imprecise: false,
    latitude: 30.02767,
    longitude: -90.25405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70065',
  },
  {
    city: 'Lafitte',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 105.2,
    imprecise: false,
    latitude: 29.72008,
    longitude: -90.10383,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70067',
  },
  {
    city: 'La Place',
    county_fips: 22095,
    county_fips_all: '22095|22089',
    county: 'St. John the Baptist',
    county_names_all: 'St. John the Baptist|St. Charles',
    county_weights: '{"22095": 92.76, "22089": 7.24}',
    density: 256.3,
    imprecise: false,
    latitude: 30.14113,
    longitude: -90.43502,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70068',
  },
  {
    city: 'Luling',
    county_fips: 22089,
    county_fips_all: '22089',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"22089": 100}',
    density: 59,
    imprecise: false,
    latitude: 29.83302,
    longitude: -90.3052,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70070',
  },
  {
    city: 'Lutcher',
    county_fips: 22093,
    county_fips_all: '22093',
    county: 'St. James',
    county_names_all: 'St. James',
    county_weights: '{"22093": 100}',
    density: 584,
    imprecise: false,
    latitude: 30.05123,
    longitude: -90.70291,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70071',
  },
  {
    city: 'Marrero',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 414.8,
    imprecise: false,
    latitude: 29.83012,
    longitude: -90.12724,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70072',
  },
  {
    city: 'Meraux',
    county_fips: 22087,
    county_fips_all: '22087|22071',
    county: 'St. Bernard',
    county_names_all: 'St. Bernard|Orleans',
    county_weights: '{"22087": 99.87, "22071": 0.13}',
    density: 610.7,
    imprecise: false,
    latitude: 29.93158,
    longitude: -89.92081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70075',
  },
  {
    city: 'Mount Airy',
    county_fips: 22095,
    county_fips_all: '22095',
    county: 'St. John the Baptist',
    county_names_all: 'St. John the Baptist',
    county_weights: '{"22095": 100}',
    density: 33.8,
    imprecise: false,
    latitude: 30.04945,
    longitude: -90.63678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70076',
  },
  {
    city: 'Norco',
    county_fips: 22089,
    county_fips_all: '22089',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"22089": 100}',
    density: 582.2,
    imprecise: false,
    latitude: 30.00172,
    longitude: -90.41218,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70079',
  },
  {
    city: 'Paradis',
    county_fips: 22089,
    county_fips_all: '22089',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"22089": 100}',
    density: 23.5,
    imprecise: false,
    latitude: 29.8743,
    longitude: -90.43227,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70080',
  },
  {
    city: 'Pointe A La Hache',
    county_fips: 22075,
    county_fips_all: '22075',
    county: 'Plaquemines',
    county_names_all: 'Plaquemines',
    county_weights: '{"22075": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 29.5658,
    longitude: -89.75677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70082',
  },
  {
    city: 'Port Sulphur',
    county_fips: 22075,
    county_fips_all: '22075',
    county: 'Plaquemines',
    county_names_all: 'Plaquemines',
    county_weights: '{"22075": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 29.52342,
    longitude: -89.85211,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70083',
  },
  {
    city: 'Reserve',
    county_fips: 22095,
    county_fips_all: '22095',
    county: 'St. John the Baptist',
    county_names_all: 'St. John the Baptist',
    county_weights: '{"22095": 100}',
    density: 120,
    imprecise: false,
    latitude: 30.07242,
    longitude: -90.57251,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70084',
  },
  {
    city: 'Saint Bernard',
    county_fips: 22087,
    county_fips_all: '22087',
    county: 'St. Bernard',
    county_names_all: 'St. Bernard',
    county_weights: '{"22087": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 29.81629,
    longitude: -89.76127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70085',
  },
  {
    city: 'Saint James',
    county_fips: 22093,
    county_fips_all: '22093',
    county: 'St. James',
    county_names_all: 'St. James',
    county_weights: '{"22093": 100}',
    density: 18,
    imprecise: false,
    latitude: 30.02628,
    longitude: -90.88198,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70086',
  },
  {
    city: 'Saint Rose',
    county_fips: 22089,
    county_fips_all: '22089',
    county: 'St. Charles',
    county_names_all: 'St. Charles',
    county_weights: '{"22089": 100}',
    density: 226.3,
    imprecise: false,
    latitude: 29.98092,
    longitude: -90.31264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70087',
  },
  {
    city: 'Vacherie',
    county_fips: 22093,
    county_fips_all: '22093|22095',
    county: 'St. James',
    county_names_all: 'St. James|St. John the Baptist',
    county_weights: '{"22093": 61.12, "22095": 38.88}',
    density: 31.5,
    imprecise: false,
    latitude: 29.96725,
    longitude: -90.6934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70090',
  },
  {
    city: 'Venice',
    county_fips: 22075,
    county_fips_all: '22075',
    county: 'Plaquemines',
    county_names_all: 'Plaquemines',
    county_weights: '{"22075": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 29.17723,
    longitude: -89.23204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70091',
  },
  {
    city: 'Violet',
    county_fips: 22087,
    county_fips_all: '22087',
    county: 'St. Bernard',
    county_names_all: 'St. Bernard',
    county_weights: '{"22087": 100}',
    density: 621.9,
    imprecise: false,
    latitude: 29.90026,
    longitude: -89.89598,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70092',
  },
  {
    city: 'Westwego',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 343.1,
    imprecise: false,
    latitude: 29.91162,
    longitude: -90.20876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70094',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 1371.3,
    imprecise: false,
    latitude: 29.95608,
    longitude: -90.07733,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70112',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 3959.3,
    imprecise: false,
    latitude: 29.9422,
    longitude: -90.08382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70113',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 1731.2,
    imprecise: false,
    latitude: 29.93704,
    longitude: -90.0321,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70114',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 3130.2,
    imprecise: false,
    latitude: 29.92375,
    longitude: -90.10219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70115',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 3170.2,
    imprecise: false,
    latitude: 29.96697,
    longitude: -90.06448,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70116',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 1799.4,
    imprecise: false,
    latitude: 29.9685,
    longitude: -90.03004,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70117',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 3011.4,
    imprecise: false,
    latitude: 29.9451,
    longitude: -90.1257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70118',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 3183.9,
    imprecise: false,
    latitude: 29.97567,
    longitude: -90.08729,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70119',
  },
  {
    city: 'New Orleans',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 1244,
    imprecise: false,
    latitude: 29.9608,
    longitude: -90.15881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70121',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 2171.2,
    imprecise: false,
    latitude: 30.00835,
    longitude: -90.06467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70122',
  },
  {
    city: 'New Orleans',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 1394.8,
    imprecise: false,
    latitude: 29.951,
    longitude: -90.20501,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70123',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 1259.4,
    imprecise: false,
    latitude: 30.00747,
    longitude: -90.10378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70124',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 2938.6,
    imprecise: false,
    latitude: 29.95202,
    longitude: -90.10338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70125',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 864.8,
    imprecise: false,
    latitude: 30.01948,
    longitude: -90.01739,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70126',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 1631,
    imprecise: false,
    latitude: 30.02966,
    longitude: -89.9761,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70127',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 1860.7,
    imprecise: false,
    latitude: 30.04896,
    longitude: -89.95398,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70128',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 41.5,
    imprecise: false,
    latitude: 30.08239,
    longitude: -89.81617,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70129',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 2272.7,
    imprecise: false,
    latitude: 29.93671,
    longitude: -90.06949,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70130',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 829.2,
    imprecise: false,
    latitude: 29.9081,
    longitude: -89.96044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70131',
  },
  {
    city: 'Thibodaux',
    county_fips: 22057,
    county_fips_all: '22057|22007|22109',
    county: 'Lafourche',
    county_names_all: 'Lafourche|Assumption|Terrebonne',
    county_weights: '{"22057": 97.51, "22007": 1.66, "22109": 0.83}',
    density: 68.1,
    imprecise: false,
    latitude: 29.81431,
    longitude: -90.7411,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70301',
  },
  {
    city: 'Pierre Part',
    county_fips: 22007,
    county_fips_all: '22007|22099',
    county: 'Assumption',
    county_names_all: 'Assumption|St. Martin',
    county_weights: '{"22007": 89.79, "22099": 10.21}',
    density: 34,
    imprecise: false,
    latitude: 29.92987,
    longitude: -91.18357,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70339',
  },
  {
    city: 'Amelia',
    county_fips: 22101,
    county_fips_all: '22101',
    county: 'St. Mary',
    county_names_all: 'St. Mary',
    county_weights: '{"22101": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.66974,
    longitude: -91.1043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70340',
  },
  {
    city: 'Belle Rose',
    county_fips: 22007,
    county_fips_all: '22007',
    county: 'Assumption',
    county_names_all: 'Assumption',
    county_weights: '{"22007": 100}',
    density: 31.6,
    imprecise: false,
    latitude: 30.02579,
    longitude: -91.08267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70341',
  },
  {
    city: 'Berwick',
    county_fips: 22101,
    county_fips_all: '22101',
    county: 'St. Mary',
    county_names_all: 'St. Mary',
    county_weights: '{"22101": 100}',
    density: 238.4,
    imprecise: false,
    latitude: 29.69486,
    longitude: -91.23772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70342',
  },
  {
    city: 'Bourg',
    county_fips: 22057,
    county_fips_all: '22057|22109',
    county: 'Lafourche',
    county_names_all: 'Lafourche|Terrebonne',
    county_weights: '{"22057": 50.84, "22109": 49.16}',
    density: 89.1,
    imprecise: false,
    latitude: 29.55308,
    longitude: -90.56402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70343',
  },
  {
    city: 'Chauvin',
    county_fips: 22109,
    county_fips_all: '22109',
    county: 'Terrebonne',
    county_names_all: 'Terrebonne',
    county_weights: '{"22109": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 29.39711,
    longitude: -90.63777,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70344',
  },
  {
    city: 'Cut Off',
    county_fips: 22057,
    county_fips_all: '22057',
    county: 'Lafourche',
    county_names_all: 'Lafourche',
    county_weights: '{"22057": 100}',
    density: 25,
    imprecise: false,
    latitude: 29.51815,
    longitude: -90.23763,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70345',
  },
  {
    city: 'Donaldsonville',
    county_fips: 22005,
    county_fips_all: '22005|22007',
    county: 'Ascension',
    county_names_all: 'Ascension|Assumption',
    county_weights: '{"22005": 80.62, "22007": 19.38}',
    density: 59,
    imprecise: false,
    latitude: 30.10774,
    longitude: -91.02061,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70346',
  },
  {
    city: 'Dulac',
    county_fips: 22109,
    county_fips_all: '22109',
    county: 'Terrebonne',
    county_names_all: 'Terrebonne',
    county_weights: '{"22109": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 29.36598,
    longitude: -90.70554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70353',
  },
  {
    city: 'Galliano',
    county_fips: 22057,
    county_fips_all: '22057',
    county: 'Lafourche',
    county_names_all: 'Lafourche',
    county_weights: '{"22057": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 29.43136,
    longitude: -90.34336,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70354',
  },
  {
    city: 'Gibson',
    county_fips: 22109,
    county_fips_all: '22109',
    county: 'Terrebonne',
    county_names_all: 'Terrebonne',
    county_weights: '{"22109": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 29.64142,
    longitude: -90.95953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70356',
  },
  {
    city: 'Golden Meadow',
    county_fips: 22057,
    county_fips_all: '22057',
    county: 'Lafourche',
    county_names_all: 'Lafourche',
    county_weights: '{"22057": 100}',
    density: 5,
    imprecise: false,
    latitude: 29.28451,
    longitude: -90.17463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70357',
  },
  {
    city: 'Grand Isle',
    county_fips: 22051,
    county_fips_all: '22051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"22051": 100}',
    density: 37.2,
    imprecise: false,
    latitude: 29.21367,
    longitude: -90.0306,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70358',
  },
  {
    city: 'Gray',
    county_fips: 22109,
    county_fips_all: '22109|22057',
    county: 'Terrebonne',
    county_names_all: 'Terrebonne|Lafourche',
    county_weights: '{"22109": 80.44, "22057": 19.56}',
    density: 269.1,
    imprecise: false,
    latitude: 29.68649,
    longitude: -90.77859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70359',
  },
  {
    city: 'Houma',
    county_fips: 22109,
    county_fips_all: '22109',
    county: 'Terrebonne',
    county_names_all: 'Terrebonne',
    county_weights: '{"22109": 100}',
    density: 183.5,
    imprecise: false,
    latitude: 29.58396,
    longitude: -90.81001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70360',
  },
  {
    city: 'Houma',
    county_fips: 22109,
    county_fips_all: '22109',
    county: 'Terrebonne',
    county_names_all: 'Terrebonne',
    county_weights: '{"22109": 100}',
    density: 118.8,
    imprecise: false,
    latitude: 29.51516,
    longitude: -90.70404,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70363',
  },
  {
    city: 'Houma',
    county_fips: 22109,
    county_fips_all: '22109|22057',
    county: 'Terrebonne',
    county_names_all: 'Terrebonne|Lafourche',
    county_weights: '{"22109": 58.38, "22057": 41.62}',
    density: 262.9,
    imprecise: false,
    latitude: 29.63419,
    longitude: -90.68752,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70364',
  },
  {
    city: 'Labadieville',
    county_fips: 22007,
    county_fips_all: '22007',
    county: 'Assumption',
    county_names_all: 'Assumption',
    county_weights: '{"22007": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 29.78249,
    longitude: -90.9889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70372',
  },
  {
    city: 'Larose',
    county_fips: 22057,
    county_fips_all: '22057',
    county: 'Lafourche',
    county_names_all: 'Lafourche',
    county_weights: '{"22057": 100}',
    density: 38.9,
    imprecise: false,
    latitude: 29.61335,
    longitude: -90.31919,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70373',
  },
  {
    city: 'Lockport',
    county_fips: 22057,
    county_fips_all: '22057',
    county: 'Lafourche',
    county_names_all: 'Lafourche',
    county_weights: '{"22057": 100}',
    density: 51.4,
    imprecise: false,
    latitude: 29.59924,
    longitude: -90.50319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70374',
  },
  {
    city: 'Mathews',
    county_fips: 22057,
    county_fips_all: '22057',
    county: 'Lafourche',
    county_names_all: 'Lafourche',
    county_weights: '{"22057": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 29.69491,
    longitude: -90.53257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70375',
  },
  {
    city: 'Montegut',
    county_fips: 22109,
    county_fips_all: '22109|22057',
    county: 'Terrebonne',
    county_names_all: 'Terrebonne|Lafourche',
    county_weights: '{"22109": 63.24, "22057": 36.76}',
    density: 14,
    imprecise: false,
    latitude: 29.45808,
    longitude: -90.51361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70377',
  },
  {
    city: 'Morgan City',
    county_fips: 22101,
    county_fips_all: '22101|22099|22007',
    county: 'St. Mary',
    county_names_all: 'St. Mary|St. Martin|Assumption',
    county_weights: '{"22101": 34.56, "22099": 33.81, "22007": 31.63}',
    density: 102.1,
    imprecise: false,
    latitude: 29.71944,
    longitude: -91.12634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70380',
  },
  {
    city: 'Napoleonville',
    county_fips: 22007,
    county_fips_all: '22007',
    county: 'Assumption',
    county_names_all: 'Assumption',
    county_weights: '{"22007": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 29.89068,
    longitude: -91.03616,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70390',
  },
  {
    city: 'Paincourtville',
    county_fips: 22007,
    county_fips_all: '22007',
    county: 'Assumption',
    county_names_all: 'Assumption',
    county_weights: '{"22007": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.99516,
    longitude: -91.06029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70391',
  },
  {
    city: 'Patterson',
    county_fips: 22101,
    county_fips_all: '22101',
    county: 'St. Mary',
    county_names_all: 'St. Mary',
    county_weights: '{"22101": 100}',
    density: 85.8,
    imprecise: false,
    latitude: 29.69847,
    longitude: -91.32164,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70392',
  },
  {
    city: 'Plattenville',
    county_fips: 22007,
    county_fips_all: '22007',
    county: 'Assumption',
    county_names_all: 'Assumption',
    county_weights: '{"22007": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 29.9959,
    longitude: -90.99897,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70393',
  },
  {
    city: 'Raceland',
    county_fips: 22057,
    county_fips_all: '22057',
    county: 'Lafourche',
    county_names_all: 'Lafourche',
    county_weights: '{"22057": 100}',
    density: 61.8,
    imprecise: false,
    latitude: 29.69448,
    longitude: -90.61399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70394',
  },
  {
    city: 'Schriever',
    county_fips: 22109,
    county_fips_all: '22109',
    county: 'Terrebonne',
    county_names_all: 'Terrebonne',
    county_weights: '{"22109": 100}',
    density: 34.9,
    imprecise: false,
    latitude: 29.69309,
    longitude: -90.8513,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70395',
  },
  {
    city: 'Theriot',
    county_fips: 22109,
    county_fips_all: '22109',
    county: 'Terrebonne',
    county_names_all: 'Terrebonne',
    county_weights: '{"22109": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 29.38444,
    longitude: -90.823,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70397',
  },
  {
    city: 'Hammond',
    county_fips: 22105,
    county_fips_all: '22105',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa',
    county_weights: '{"22105": 100}',
    density: 236.1,
    imprecise: false,
    latitude: 30.5281,
    longitude: -90.45472,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70401',
  },
  {
    city: 'Hammond',
    county_fips: 22105,
    county_fips_all: '22105|22063',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa|Livingston',
    county_weights: '{"22105": 86.13, "22063": 13.87}',
    density: 275.3,
    imprecise: false,
    latitude: 30.47989,
    longitude: -90.48639,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70403',
  },
  {
    city: 'Abita Springs',
    county_fips: 22103,
    county_fips_all: '22103',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany',
    county_weights: '{"22103": 100}',
    density: 48.1,
    imprecise: false,
    latitude: 30.48767,
    longitude: -89.95907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70420',
  },
  {
    city: 'Amite',
    county_fips: 22105,
    county_fips_all: '22105|22091|22063',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa|St. Helena|Livingston',
    county_weights: '{"22105": 63.92, "22091": 35.68, "22063": 0.4}',
    density: 37.8,
    imprecise: false,
    latitude: 30.73699,
    longitude: -90.491,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70422',
  },
  {
    city: 'Angie',
    county_fips: 22117,
    county_fips_all: '22117',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"22117": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 30.93142,
    longitude: -89.85807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70426',
  },
  {
    city: 'Bogalusa',
    county_fips: 22117,
    county_fips_all: '22117|22103',
    county: 'Washington',
    county_names_all: 'Washington|St. Tammany',
    county_weights: '{"22117": 90.01, "22103": 9.99}',
    density: 48.1,
    imprecise: false,
    latitude: 30.74587,
    longitude: -89.9125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70427',
  },
  {
    city: 'Bush',
    county_fips: 22103,
    county_fips_all: '22103|22117',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany|Washington',
    county_weights: '{"22103": 93.7, "22117": 6.3}',
    density: 32.1,
    imprecise: false,
    latitude: 30.61211,
    longitude: -89.97215,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70431',
  },
  {
    city: 'Covington',
    county_fips: 22103,
    county_fips_all: '22103|22105',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany|Tangipahoa',
    county_weights: '{"22103": 93.35, "22105": 6.65}',
    density: 332.2,
    imprecise: false,
    latitude: 30.46184,
    longitude: -90.13796,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70433',
  },
  {
    city: 'Covington',
    county_fips: 22103,
    county_fips_all: '22103|22105',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany|Tangipahoa',
    county_weights: '{"22103": 96.03, "22105": 3.97}',
    density: 83.3,
    imprecise: false,
    latitude: 30.55955,
    longitude: -90.101,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70435',
  },
  {
    city: 'Fluker',
    county_fips: 22105,
    county_fips_all: '22105',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa',
    county_weights: '{"22105": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 30.83057,
    longitude: -90.53315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70436',
  },
  {
    city: 'Folsom',
    county_fips: 22103,
    county_fips_all: '22103|22105',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany|Tangipahoa',
    county_weights: '{"22103": 76.11, "22105": 23.89}',
    density: 35.9,
    imprecise: false,
    latitude: 30.60909,
    longitude: -90.20928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70437',
  },
  {
    city: 'Franklinton',
    county_fips: 22117,
    county_fips_all: '22117|22103|22105',
    county: 'Washington',
    county_names_all: 'Washington|St. Tammany|Tangipahoa',
    county_weights: '{"22117": 96.35, "22103": 2.83, "22105": 0.82}',
    density: 21.5,
    imprecise: false,
    latitude: 30.84139,
    longitude: -90.11186,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70438',
  },
  {
    city: 'Greensburg',
    county_fips: 22091,
    county_fips_all: '22091',
    county: 'St. Helena',
    county_names_all: 'St. Helena',
    county_weights: '{"22091": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 30.85987,
    longitude: -90.7489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70441',
  },
  {
    city: 'Husser',
    county_fips: 22105,
    county_fips_all: '22105',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa',
    county_weights: '{"22105": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 30.70307,
    longitude: -90.33433,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70442',
  },
  {
    city: 'Independence',
    county_fips: 22105,
    county_fips_all: '22105|22063|22091',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa|Livingston|St. Helena',
    county_weights: '{"22105": 57.39, "22063": 32.87, "22091": 9.74}',
    density: 45.6,
    imprecise: false,
    latitude: 30.62885,
    longitude: -90.54257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70443',
  },
  {
    city: 'Kentwood',
    county_fips: 22105,
    county_fips_all: '22105|22091|22117',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa|St. Helena|Washington',
    county_weights: '{"22105": 71.37, "22091": 27.58, "22117": 1.05}',
    density: 13.7,
    imprecise: false,
    latitude: 30.90833,
    longitude: -90.48707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70444',
  },
  {
    city: 'Lacombe',
    county_fips: 22103,
    county_fips_all: '22103',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany',
    county_weights: '{"22103": 100}',
    density: 33.1,
    imprecise: false,
    latitude: 30.36352,
    longitude: -89.91265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70445',
  },
  {
    city: 'Loranger',
    county_fips: 22105,
    county_fips_all: '22105',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa',
    county_weights: '{"22105": 100}',
    density: 33.5,
    imprecise: false,
    latitude: 30.63612,
    longitude: -90.35159,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70446',
  },
  {
    city: 'Madisonville',
    county_fips: 22103,
    county_fips_all: '22103',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany',
    county_weights: '{"22103": 100}',
    density: 223.2,
    imprecise: false,
    latitude: 30.42144,
    longitude: -90.20257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70447',
  },
  {
    city: 'Mandeville',
    county_fips: 22103,
    county_fips_all: '22103',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany',
    county_weights: '{"22103": 100}',
    density: 463.5,
    imprecise: false,
    latitude: 30.36278,
    longitude: -90.03943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70448',
  },
  {
    city: 'Maurepas',
    county_fips: 22063,
    county_fips_all: '22063|22005',
    county: 'Livingston',
    county_names_all: 'Livingston|Ascension',
    county_weights: '{"22063": 99.47, "22005": 0.53}',
    density: 20.3,
    imprecise: false,
    latitude: 30.26363,
    longitude: -90.66345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70449',
  },
  {
    city: 'Mount Hermon',
    county_fips: 22117,
    county_fips_all: '22117',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"22117": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 30.93667,
    longitude: -90.26755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70450',
  },
  {
    city: 'Natalbany',
    county_fips: 22105,
    county_fips_all: '22105',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa',
    county_weights: '{"22105": 100}',
    density: 111,
    imprecise: false,
    latitude: 30.54964,
    longitude: -90.48111,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70451',
  },
  {
    city: 'Pearl River',
    county_fips: 22103,
    county_fips_all: '22103',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany',
    county_weights: '{"22103": 100}',
    density: 49.2,
    imprecise: false,
    latitude: 30.41424,
    longitude: -89.76048,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70452',
  },
  {
    city: 'Pine Grove',
    county_fips: 22091,
    county_fips_all: '22091|22063',
    county: 'St. Helena',
    county_names_all: 'St. Helena|Livingston',
    county_weights: '{"22091": 94.46, "22063": 5.54}',
    density: 12.1,
    imprecise: false,
    latitude: 30.69385,
    longitude: -90.76918,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70453',
  },
  {
    city: 'Ponchatoula',
    county_fips: 22105,
    county_fips_all: '22105',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa',
    county_weights: '{"22105": 100}',
    density: 76.5,
    imprecise: false,
    latitude: 30.39525,
    longitude: -90.3682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70454',
  },
  {
    city: 'Robert',
    county_fips: 22105,
    county_fips_all: '22105',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa',
    county_weights: '{"22105": 100}',
    density: 37.4,
    imprecise: false,
    latitude: 30.52438,
    longitude: -90.31883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70455',
  },
  {
    city: 'Roseland',
    county_fips: 22105,
    county_fips_all: '22105',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa',
    county_weights: '{"22105": 100}',
    density: 37.4,
    imprecise: false,
    latitude: 30.79332,
    longitude: -90.50702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70456',
  },
  {
    city: 'Saint Benedict',
    county_fips: 22103,
    county_fips_all: '22103',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany',
    county_weights: '{"22103": 100}',
    density: 1173.8,
    imprecise: false,
    latitude: 30.52743,
    longitude: -90.11332,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70457',
  },
  {
    city: 'Slidell',
    county_fips: 22103,
    county_fips_all: '22103',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany',
    county_weights: '{"22103": 100}',
    density: 721.7,
    imprecise: false,
    latitude: 30.25864,
    longitude: -89.79441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70458',
  },
  {
    city: 'Slidell',
    county_fips: 22103,
    county_fips_all: '22103',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany',
    county_weights: '{"22103": 100}',
    density: 217.7,
    imprecise: false,
    latitude: 30.29925,
    longitude: -89.83455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70460',
  },
  {
    city: 'Slidell',
    county_fips: 22103,
    county_fips_all: '22103',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany',
    county_weights: '{"22103": 100}',
    density: 251.2,
    imprecise: false,
    latitude: 30.2326,
    longitude: -89.70931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70461',
  },
  {
    city: 'Springfield',
    county_fips: 22063,
    county_fips_all: '22063|22105',
    county: 'Livingston',
    county_names_all: 'Livingston|Tangipahoa',
    county_weights: '{"22063": 99.3, "22105": 0.7}',
    density: 27.1,
    imprecise: false,
    latitude: 30.3656,
    longitude: -90.58368,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70462',
  },
  {
    city: 'Sun',
    county_fips: 22103,
    county_fips_all: '22103',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany',
    county_weights: '{"22103": 100}',
    density: 44.1,
    imprecise: false,
    latitude: 30.6551,
    longitude: -89.90162,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70463',
  },
  {
    city: 'Talisheek',
    county_fips: 22103,
    county_fips_all: '22103',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany',
    county_weights: '{"22103": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 30.54416,
    longitude: -89.89221,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70464',
  },
  {
    city: 'Tangipahoa',
    county_fips: 22105,
    county_fips_all: '22105',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa',
    county_weights: '{"22105": 100}',
    density: 200.6,
    imprecise: false,
    latitude: 30.87577,
    longitude: -90.51384,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70465',
  },
  {
    city: 'Tickfaw',
    county_fips: 22105,
    county_fips_all: '22105|22063',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa|Livingston',
    county_weights: '{"22105": 95.26, "22063": 4.74}',
    density: 114.1,
    imprecise: false,
    latitude: 30.5685,
    longitude: -90.50195,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70466',
  },
  {
    city: 'Mandeville',
    county_fips: 22103,
    county_fips_all: '22103',
    county: 'St. Tammany',
    county_names_all: 'St. Tammany',
    county_weights: '{"22103": 100}',
    density: 323.3,
    imprecise: false,
    latitude: 30.407,
    longitude: -90.06346,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70471',
  },
  {
    city: 'Lafayette',
    county_fips: 22055,
    county_fips_all: '22055',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"22055": 100}',
    density: 667.4,
    imprecise: false,
    latitude: 30.2391,
    longitude: -91.99122,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70501',
  },
  {
    city: 'Lafayette',
    county_fips: 22055,
    county_fips_all: '22055',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"22055": 100}',
    density: 976.6,
    imprecise: false,
    latitude: 30.17353,
    longitude: -92.05901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70503',
  },
  {
    city: 'Lafayette',
    county_fips: 22055,
    county_fips_all: '22055',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"22055": 100}',
    density: 787,
    imprecise: false,
    latitude: 30.19586,
    longitude: -92.08075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70506',
  },
  {
    city: 'Lafayette',
    county_fips: 22055,
    county_fips_all: '22055',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"22055": 100}',
    density: 362.1,
    imprecise: false,
    latitude: 30.28293,
    longitude: -92.02825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70507',
  },
  {
    city: 'Lafayette',
    county_fips: 22055,
    county_fips_all: '22055',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"22055": 100}',
    density: 644.9,
    imprecise: false,
    latitude: 30.15627,
    longitude: -92.02913,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70508',
  },
  {
    city: 'Abbeville',
    county_fips: 22113,
    county_fips_all: '22113',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"22113": 100}',
    density: 40,
    imprecise: false,
    latitude: 29.89493,
    longitude: -92.19569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70510',
  },
  {
    city: 'Arnaudville',
    county_fips: 22097,
    county_fips_all: '22097|22099',
    county: 'St. Landry',
    county_names_all: 'St. Landry|St. Martin',
    county_weights: '{"22097": 61.16, "22099": 38.84}',
    density: 42.4,
    imprecise: false,
    latitude: 30.41333,
    longitude: -91.92337,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70512',
  },
  {
    city: 'Avery Island',
    county_fips: 22045,
    county_fips_all: '22045',
    county: 'Iberia',
    county_names_all: 'Iberia',
    county_weights: '{"22045": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 29.90272,
    longitude: -91.90106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70513',
  },
  {
    city: 'Baldwin',
    county_fips: 22101,
    county_fips_all: '22101',
    county: 'St. Mary',
    county_names_all: 'St. Mary',
    county_weights: '{"22101": 100}',
    density: 160.4,
    imprecise: false,
    latitude: 29.8452,
    longitude: -91.55301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70514',
  },
  {
    city: 'Basile',
    county_fips: 22001,
    county_fips_all: '22001|22039',
    county: 'Acadia',
    county_names_all: 'Acadia|Evangeline',
    county_weights: '{"22001": 56.47, "22039": 43.53}',
    density: 21.3,
    imprecise: false,
    latitude: 30.44843,
    longitude: -92.57154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70515',
  },
  {
    city: 'Branch',
    county_fips: 22001,
    county_fips_all: '22001',
    county: 'Acadia',
    county_names_all: 'Acadia',
    county_weights: '{"22001": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 30.3674,
    longitude: -92.30289,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70516',
  },
  {
    city: 'Breaux Bridge',
    county_fips: 22099,
    county_fips_all: '22099|22055',
    county: 'St. Martin',
    county_names_all: 'St. Martin|Lafayette',
    county_weights: '{"22099": 98.96, "22055": 1.04}',
    density: 59.6,
    imprecise: false,
    latitude: 30.28421,
    longitude: -91.79615,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70517',
  },
  {
    city: 'Broussard',
    county_fips: 22055,
    county_fips_all: '22055|22099|22045',
    county: 'Lafayette',
    county_names_all: 'Lafayette|St. Martin|Iberia',
    county_weights: '{"22055": 51.37, "22099": 45.44, "22045": 3.19}',
    density: 159.7,
    imprecise: false,
    latitude: 30.13503,
    longitude: -91.92922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70518',
  },
  {
    city: 'Cade',
    county_fips: 22099,
    county_fips_all: '22099',
    county: 'St. Martin',
    county_names_all: 'St. Martin',
    county_weights: '{"22099": 100}',
    density: 41.9,
    imprecise: false,
    latitude: 30.08178,
    longitude: -91.90705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70519',
  },
  {
    city: 'Carencro',
    county_fips: 22055,
    county_fips_all: '22055|22097',
    county: 'Lafayette',
    county_names_all: 'Lafayette|St. Landry',
    county_weights: '{"22055": 96.73, "22097": 3.27}',
    density: 202.7,
    imprecise: false,
    latitude: 30.33265,
    longitude: -92.03619,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70520',
  },
  {
    city: 'Centerville',
    county_fips: 22101,
    county_fips_all: '22101',
    county: 'St. Mary',
    county_names_all: 'St. Mary',
    county_weights: '{"22101": 100}',
    density: 244.6,
    imprecise: false,
    latitude: 29.74949,
    longitude: -91.43287,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70522',
  },
  {
    city: 'Charenton',
    county_fips: 22101,
    county_fips_all: '22101',
    county: 'St. Mary',
    county_names_all: 'St. Mary',
    county_weights: '{"22101": 100}',
    density: 133.1,
    imprecise: false,
    latitude: 29.87383,
    longitude: -91.52956,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70523',
  },
  {
    city: 'Chataignier',
    county_fips: 22039,
    county_fips_all: '22039',
    county: 'Evangeline',
    county_names_all: 'Evangeline',
    county_weights: '{"22039": 100}',
    density: 34.5,
    imprecise: false,
    latitude: 30.55737,
    longitude: -92.31859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70524',
  },
  {
    city: 'Church Point',
    county_fips: 22001,
    county_fips_all: '22001|22097|22055',
    county: 'Acadia',
    county_names_all: 'Acadia|St. Landry|Lafayette',
    county_weights: '{"22001": 60.95, "22097": 38.22, "22055": 0.83}',
    density: 55.1,
    imprecise: false,
    latitude: 30.40765,
    longitude: -92.21761,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70525',
  },
  {
    city: 'Crowley',
    county_fips: 22001,
    county_fips_all: '22001|22113',
    county: 'Acadia',
    county_names_all: 'Acadia|Vermilion',
    county_weights: '{"22001": 98.79, "22113": 1.21}',
    density: 50.8,
    imprecise: false,
    latitude: 30.21051,
    longitude: -92.37951,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70526',
  },
  {
    city: 'Delcambre',
    county_fips: 22045,
    county_fips_all: '22045|22113',
    county: 'Iberia',
    county_names_all: 'Iberia|Vermilion',
    county_weights: '{"22045": 89.69, "22113": 10.31}',
    density: 66.4,
    imprecise: false,
    latitude: 29.89766,
    longitude: -91.96692,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70528',
  },
  {
    city: 'Duson',
    county_fips: 22055,
    county_fips_all: '22055|22001|22113',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Acadia|Vermilion',
    county_weights: '{"22055": 97.07, "22001": 2.17, "22113": 0.76}',
    density: 137.4,
    imprecise: false,
    latitude: 30.19593,
    longitude: -92.16327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70529',
  },
  {
    city: 'Egan',
    county_fips: 22001,
    county_fips_all: '22001',
    county: 'Acadia',
    county_names_all: 'Acadia',
    county_weights: '{"22001": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 30.23101,
    longitude: -92.49678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70531',
  },
  {
    city: 'Elton',
    county_fips: 22053,
    county_fips_all: '22053|22003',
    county: 'Jefferson Davis',
    county_names_all: 'Jefferson Davis|Allen',
    county_weights: '{"22053": 63.93, "22003": 36.07}',
    density: 9.9,
    imprecise: false,
    latitude: 30.4705,
    longitude: -92.6993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70532',
  },
  {
    city: 'Erath',
    county_fips: 22113,
    county_fips_all: '22113|22045',
    county: 'Vermilion',
    county_names_all: 'Vermilion|Iberia',
    county_weights: '{"22113": 98.76, "22045": 1.24}',
    density: 36.9,
    imprecise: false,
    latitude: 29.90439,
    longitude: -92.03536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70533',
  },
  {
    city: 'Estherwood',
    county_fips: 22001,
    county_fips_all: '22001',
    county: 'Acadia',
    county_names_all: 'Acadia',
    county_weights: '{"22001": 100}',
    density: 37.9,
    imprecise: false,
    latitude: 30.16564,
    longitude: -92.45499,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70534',
  },
  {
    city: 'Eunice',
    county_fips: 22001,
    county_fips_all: '22001|22097|22039',
    county: 'Acadia',
    county_names_all: 'Acadia|St. Landry|Evangeline',
    county_weights: '{"22001": 52.5, "22097": 26.36, "22039": 21.14}',
    density: 44.4,
    imprecise: false,
    latitude: 30.47999,
    longitude: -92.42367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70535',
  },
  {
    city: 'Evangeline',
    county_fips: 22001,
    county_fips_all: '22001',
    county: 'Acadia',
    county_names_all: 'Acadia',
    county_weights: '{"22001": 100}',
    density: 25.1,
    imprecise: false,
    latitude: 30.25747,
    longitude: -92.56642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70537',
  },
  {
    city: 'Franklin',
    county_fips: 22101,
    county_fips_all: '22101',
    county: 'St. Mary',
    county_names_all: 'St. Mary',
    county_weights: '{"22101": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 29.74051,
    longitude: -91.54092,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70538',
  },
  {
    city: 'Grand Coteau',
    county_fips: 22097,
    county_fips_all: '22097',
    county: 'St. Landry',
    county_names_all: 'St. Landry',
    county_weights: '{"22097": 100}',
    density: 161.3,
    imprecise: false,
    latitude: 30.42062,
    longitude: -92.0426,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70541',
  },
  {
    city: 'Gueydan',
    county_fips: 22113,
    county_fips_all: '22113|22023',
    county: 'Vermilion',
    county_names_all: 'Vermilion|Cameron',
    county_weights: '{"22113": 68.73, "22023": 31.27}',
    density: 6.4,
    imprecise: false,
    latitude: 30.00442,
    longitude: -92.5886,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70542',
  },
  {
    city: 'Iota',
    county_fips: 22001,
    county_fips_all: '22001',
    county: 'Acadia',
    county_names_all: 'Acadia',
    county_weights: '{"22001": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 30.33532,
    longitude: -92.5014,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70543',
  },
  {
    city: 'Jeanerette',
    county_fips: 22045,
    county_fips_all: '22045|22101',
    county: 'Iberia',
    county_names_all: 'Iberia|St. Mary',
    county_weights: '{"22045": 52.48, "22101": 47.52}',
    density: 38.6,
    imprecise: false,
    latitude: 29.9059,
    longitude: -91.6575,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70544',
  },
  {
    city: 'Jennings',
    county_fips: 22053,
    county_fips_all: '22053|22001',
    county: 'Jefferson Davis',
    county_names_all: 'Jefferson Davis|Acadia',
    county_weights: '{"22053": 88.65, "22001": 11.35}',
    density: 38.5,
    imprecise: false,
    latitude: 30.26756,
    longitude: -92.66747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70546',
  },
  {
    city: 'Kaplan',
    county_fips: 22113,
    county_fips_all: '22113',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"22113": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 29.79733,
    longitude: -92.41875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70548',
  },
  {
    city: 'Lake Arthur',
    county_fips: 22053,
    county_fips_all: '22053|22023|22019',
    county: 'Jefferson Davis',
    county_names_all: 'Jefferson Davis|Cameron|Calcasieu',
    county_weights: '{"22053": 60.24, "22023": 39.38, "22019": 0.38}',
    density: 9.3,
    imprecise: false,
    latitude: 30.04988,
    longitude: -92.83139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70549',
  },
  {
    city: 'Lawtell',
    county_fips: 22097,
    county_fips_all: '22097',
    county: 'St. Landry',
    county_names_all: 'St. Landry',
    county_weights: '{"22097": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 30.5157,
    longitude: -92.18966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70550',
  },
  {
    city: 'Leonville',
    county_fips: 22097,
    county_fips_all: '22097',
    county: 'St. Landry',
    county_names_all: 'St. Landry',
    county_weights: '{"22097": 100}',
    density: 330.1,
    imprecise: false,
    latitude: 30.46675,
    longitude: -91.98028,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70551',
  },
  {
    city: 'Loreauville',
    county_fips: 22045,
    county_fips_all: '22045',
    county: 'Iberia',
    county_names_all: 'Iberia',
    county_weights: '{"22045": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 30.0617,
    longitude: -91.66641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70552',
  },
  {
    city: 'Mamou',
    county_fips: 22039,
    county_fips_all: '22039',
    county: 'Evangeline',
    county_names_all: 'Evangeline',
    county_weights: '{"22039": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 30.63633,
    longitude: -92.48885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70554',
  },
  {
    city: 'Maurice',
    county_fips: 22113,
    county_fips_all: '22113|22055',
    county: 'Vermilion',
    county_names_all: 'Vermilion|Lafayette',
    county_weights: '{"22113": 97.07, "22055": 2.93}',
    density: 71.7,
    imprecise: false,
    latitude: 30.08188,
    longitude: -92.14123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70555',
  },
  {
    city: 'Mermentau',
    county_fips: 22001,
    county_fips_all: '22001',
    county: 'Acadia',
    county_names_all: 'Acadia',
    county_weights: '{"22001": 100}',
    density: 136.8,
    imprecise: false,
    latitude: 30.19072,
    longitude: -92.58325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70556',
  },
  {
    city: 'Milton',
    county_fips: 22055,
    county_fips_all: '22055',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"22055": 100}',
    density: 77.9,
    imprecise: false,
    latitude: 30.10042,
    longitude: -92.07573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70558',
  },
  {
    city: 'Morse',
    county_fips: 22001,
    county_fips_all: '22001',
    county: 'Acadia',
    county_names_all: 'Acadia',
    county_weights: '{"22001": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 30.12876,
    longitude: -92.50903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70559',
  },
  {
    city: 'New Iberia',
    county_fips: 22045,
    county_fips_all: '22045|22099|22113|22055',
    county: 'Iberia',
    county_names_all: 'Iberia|St. Martin|Vermilion|Lafayette',
    county_weights:
      '{"22045": 98.13, "22099": 1.02, "22113": 0.7, "22055": 0.15}',
    density: 81.1,
    imprecise: false,
    latitude: 29.93965,
    longitude: -91.8642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70560',
  },
  {
    city: 'New Iberia',
    county_fips: 22045,
    county_fips_all: '22045',
    county: 'Iberia',
    county_names_all: 'Iberia',
    county_weights: '{"22045": 100}',
    density: 124.2,
    imprecise: false,
    latitude: 30.02454,
    longitude: -91.73053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70563',
  },
  {
    city: 'Opelousas',
    county_fips: 22097,
    county_fips_all: '22097',
    county: 'St. Landry',
    county_names_all: 'St. Landry',
    county_weights: '{"22097": 100}',
    density: 84.4,
    imprecise: false,
    latitude: 30.5315,
    longitude: -92.10852,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70570',
  },
  {
    city: 'Perry',
    county_fips: 22113,
    county_fips_all: '22113',
    county: 'Vermilion',
    county_names_all: 'Vermilion',
    county_weights: '{"22113": 100}',
    density: 880.9,
    imprecise: false,
    latitude: 29.94892,
    longitude: -92.15808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70575',
  },
  {
    city: 'Pine Prairie',
    county_fips: 22039,
    county_fips_all: '22039',
    county: 'Evangeline',
    county_names_all: 'Evangeline',
    county_weights: '{"22039": 100}',
    density: 311.7,
    imprecise: false,
    latitude: 30.78097,
    longitude: -92.41826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70576',
  },
  {
    city: 'Port Barre',
    county_fips: 22097,
    county_fips_all: '22097',
    county: 'St. Landry',
    county_names_all: 'St. Landry',
    county_weights: '{"22097": 100}',
    density: 20,
    imprecise: false,
    latitude: 30.54848,
    longitude: -91.92018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70577',
  },
  {
    city: 'Rayne',
    county_fips: 22001,
    county_fips_all: '22001|22055|22113',
    county: 'Acadia',
    county_names_all: 'Acadia|Lafayette|Vermilion',
    county_weights: '{"22001": 67.91, "22055": 18.18, "22113": 13.91}',
    density: 55.2,
    imprecise: false,
    latitude: 30.2291,
    longitude: -92.26261,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70578',
  },
  {
    city: 'Reddell',
    county_fips: 22039,
    county_fips_all: '22039',
    county: 'Evangeline',
    county_names_all: 'Evangeline',
    county_weights: '{"22039": 100}',
    density: 936.4,
    imprecise: false,
    latitude: 30.67551,
    longitude: -92.4284,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70580',
  },
  {
    city: 'Roanoke',
    county_fips: 22053,
    county_fips_all: '22053',
    county: 'Jefferson Davis',
    county_names_all: 'Jefferson Davis',
    county_weights: '{"22053": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 30.25496,
    longitude: -92.73588,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70581',
  },
  {
    city: 'Saint Martinville',
    county_fips: 22099,
    county_fips_all: '22099|22045',
    county: 'St. Martin',
    county_names_all: 'St. Martin|Iberia',
    county_weights: '{"22099": 94.59, "22045": 5.41}',
    density: 50.1,
    imprecise: false,
    latitude: 30.15961,
    longitude: -91.7854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70582',
  },
  {
    city: 'Scott',
    county_fips: 22055,
    county_fips_all: '22055|22001',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Acadia',
    county_weights: '{"22055": 85.52, "22001": 14.48}',
    density: 114.1,
    imprecise: false,
    latitude: 30.25846,
    longitude: -92.12204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70583',
  },
  {
    city: 'Sunset',
    county_fips: 22097,
    county_fips_all: '22097',
    county: 'St. Landry',
    county_names_all: 'St. Landry',
    county_weights: '{"22097": 100}',
    density: 83.4,
    imprecise: false,
    latitude: 30.38856,
    longitude: -92.10193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70584',
  },
  {
    city: 'Turkey Creek',
    county_fips: 22039,
    county_fips_all: '22039',
    county: 'Evangeline',
    county_names_all: 'Evangeline',
    county_weights: '{"22039": 100}',
    density: 188.2,
    imprecise: false,
    latitude: 30.87832,
    longitude: -92.4077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70585',
  },
  {
    city: 'Ville Platte',
    county_fips: 22039,
    county_fips_all: '22039|22097',
    county: 'Evangeline',
    county_names_all: 'Evangeline|St. Landry',
    county_weights: '{"22039": 98.3, "22097": 1.7}',
    density: 24,
    imprecise: false,
    latitude: 30.74504,
    longitude: -92.34151,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70586',
  },
  {
    city: 'Washington',
    county_fips: 22097,
    county_fips_all: '22097|22039',
    county: 'St. Landry',
    county_names_all: 'St. Landry|Evangeline',
    county_weights: '{"22097": 97.01, "22039": 2.99}',
    density: 9.4,
    imprecise: false,
    latitude: 30.68584,
    longitude: -92.04098,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70589',
  },
  {
    city: 'Welsh',
    county_fips: 22053,
    county_fips_all: '22053',
    county: 'Jefferson Davis',
    county_names_all: 'Jefferson Davis',
    county_weights: '{"22053": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 30.25604,
    longitude: -92.8397,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70591',
  },
  {
    city: 'Youngsville',
    county_fips: 22055,
    county_fips_all: '22055|22113|22045',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Vermilion|Iberia',
    county_weights: '{"22055": 74.36, "22113": 23.74, "22045": 1.9}',
    density: 292.4,
    imprecise: false,
    latitude: 30.08024,
    longitude: -92.01338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70592',
  },
  {
    city: 'Lake Charles',
    county_fips: 22019,
    county_fips_all: '22019',
    county: 'Calcasieu',
    county_names_all: 'Calcasieu',
    county_weights: '{"22019": 100}',
    density: 739.5,
    imprecise: false,
    latitude: 30.22627,
    longitude: -93.21525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70601',
  },
  {
    city: 'Lake Charles',
    county_fips: 22019,
    county_fips_all: '22019',
    county: 'Calcasieu',
    county_names_all: 'Calcasieu',
    county_weights: '{"22019": 100}',
    density: 363.8,
    imprecise: false,
    latitude: 30.13048,
    longitude: -93.27418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70605',
  },
  {
    city: 'Lake Charles',
    county_fips: 22023,
    county_fips_all: '22023|22019',
    county: 'Cameron',
    county_names_all: 'Cameron|Calcasieu',
    county_weights: '{"22023": 53.27, "22019": 46.73}',
    density: 90.6,
    imprecise: false,
    latitude: 30.04982,
    longitude: -93.20606,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70607',
  },
  {
    city: 'Lake Charles',
    county_fips: 22019,
    county_fips_all: '22019',
    county: 'Calcasieu',
    county_names_all: 'Calcasieu',
    county_weights: '{"22019": 100}',
    density: 104.5,
    imprecise: false,
    latitude: 30.34594,
    longitude: -93.20156,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70611',
  },
  {
    city: 'Lake Charles',
    county_fips: 22019,
    county_fips_all: '22019',
    county: 'Calcasieu',
    county_names_all: 'Calcasieu',
    county_weights: '{"22019": 100}',
    density: 109.1,
    imprecise: false,
    latitude: 30.25609,
    longitude: -93.12346,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70615',
  },
  {
    city: 'Bell City',
    county_fips: 22023,
    county_fips_all: '22023|22019',
    county: 'Cameron',
    county_names_all: 'Cameron|Calcasieu',
    county_weights: '{"22023": 59.28, "22019": 40.72}',
    density: 4.1,
    imprecise: false,
    latitude: 30.02723,
    longitude: -93.04966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70630',
  },
  {
    city: 'Cameron',
    county_fips: 22023,
    county_fips_all: '22023',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"22023": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 29.86692,
    longitude: -93.55404,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70631',
  },
  {
    city: 'Creole',
    county_fips: 22023,
    county_fips_all: '22023',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"22023": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 29.86747,
    longitude: -92.87987,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70632',
  },
  {
    city: 'Dequincy',
    county_fips: 22019,
    county_fips_all: '22019|22011',
    county: 'Calcasieu',
    county_names_all: 'Calcasieu|Beauregard',
    county_weights: '{"22019": 58.41, "22011": 41.59}',
    density: 18.4,
    imprecise: false,
    latitude: 30.42762,
    longitude: -93.3925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70633',
  },
  {
    city: 'Deridder',
    county_fips: 22011,
    county_fips_all: '22011|22115',
    county: 'Beauregard',
    county_names_all: 'Beauregard|Vernon',
    county_weights: '{"22011": 79.65, "22115": 20.35}',
    density: 21.9,
    imprecise: false,
    latitude: 30.80142,
    longitude: -93.24309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70634',
  },
  {
    city: 'Dry Creek',
    county_fips: 22003,
    county_fips_all: '22003|22011',
    county: 'Allen',
    county_names_all: 'Allen|Beauregard',
    county_weights: '{"22003": 51.83, "22011": 48.17}',
    density: 7.4,
    imprecise: false,
    latitude: 30.70508,
    longitude: -92.97207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70637',
  },
  {
    city: 'Elizabeth',
    county_fips: 22003,
    county_fips_all: '22003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"22003": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 30.84948,
    longitude: -92.78436,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70638',
  },
  {
    city: 'Evans',
    county_fips: 22115,
    county_fips_all: '22115',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"22115": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 30.98235,
    longitude: -93.49793,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70639',
  },
  {
    city: 'Fenton',
    county_fips: 22053,
    county_fips_all: '22053',
    county: 'Jefferson Davis',
    county_names_all: 'Jefferson Davis',
    county_weights: '{"22053": 100}',
    density: 355.8,
    imprecise: false,
    latitude: 30.36587,
    longitude: -92.91652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70640',
  },
  {
    city: 'Grand Chenier',
    county_fips: 22023,
    county_fips_all: '22023',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"22023": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 29.73649,
    longitude: -92.7939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70643',
  },
  {
    city: 'Grant',
    county_fips: 22003,
    county_fips_all: '22003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"22003": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 30.79078,
    longitude: -92.94924,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70644',
  },
  {
    city: 'Hackberry',
    county_fips: 22023,
    county_fips_all: '22023',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"22023": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 29.96154,
    longitude: -93.40854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70645',
  },
  {
    city: 'Hayes',
    county_fips: 22019,
    county_fips_all: '22019',
    county: 'Calcasieu',
    county_names_all: 'Calcasieu',
    county_weights: '{"22019": 100}',
    density: 34.8,
    imprecise: false,
    latitude: 30.10767,
    longitude: -92.92938,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70646',
  },
  {
    city: 'Iowa',
    county_fips: 22019,
    county_fips_all: '22019|22053',
    county: 'Calcasieu',
    county_names_all: 'Calcasieu|Jefferson Davis',
    county_weights: '{"22019": 51.85, "22053": 48.15}',
    density: 27.5,
    imprecise: false,
    latitude: 30.24752,
    longitude: -93.01605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70647',
  },
  {
    city: 'Kinder',
    county_fips: 22003,
    county_fips_all: '22003|22053',
    county: 'Allen',
    county_names_all: 'Allen|Jefferson Davis',
    county_weights: '{"22003": 72.61, "22053": 27.39}',
    density: 13,
    imprecise: false,
    latitude: 30.50568,
    longitude: -92.88387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70648',
  },
  {
    city: 'Lacassine',
    county_fips: 22053,
    county_fips_all: '22053',
    county: 'Jefferson Davis',
    county_names_all: 'Jefferson Davis',
    county_weights: '{"22053": 100}',
    density: 49.8,
    imprecise: false,
    latitude: 30.23376,
    longitude: -92.92067,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70650',
  },
  {
    city: 'Leblanc',
    county_fips: 22003,
    county_fips_all: '22003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"22003": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 30.54333,
    longitude: -92.95127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70651',
  },
  {
    city: 'Longville',
    county_fips: 22011,
    county_fips_all: '22011',
    county: 'Beauregard',
    county_names_all: 'Beauregard',
    county_weights: '{"22011": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 30.60547,
    longitude: -93.24646,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70652',
  },
  {
    city: 'Merryville',
    county_fips: 22011,
    county_fips_all: '22011',
    county: 'Beauregard',
    county_names_all: 'Beauregard',
    county_weights: '{"22011": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 30.66744,
    longitude: -93.55994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70653',
  },
  {
    city: 'Mittie',
    county_fips: 22003,
    county_fips_all: '22003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"22003": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.69212,
    longitude: -92.88075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70654',
  },
  {
    city: 'Oberlin',
    county_fips: 22003,
    county_fips_all: '22003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"22003": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 30.63022,
    longitude: -92.70234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70655',
  },
  {
    city: 'Pitkin',
    county_fips: 22115,
    county_fips_all: '22115|22003|22079',
    county: 'Vernon',
    county_names_all: 'Vernon|Allen|Rapides',
    county_weights: '{"22115": 63.96, "22003": 23.54, "22079": 12.5}',
    density: 4.9,
    imprecise: false,
    latitude: 30.91647,
    longitude: -92.94272,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70656',
  },
  {
    city: 'Ragley',
    county_fips: 22011,
    county_fips_all: '22011|22003|22053|22019',
    county: 'Beauregard',
    county_names_all: 'Beauregard|Allen|Jefferson Davis|Calcasieu',
    county_weights:
      '{"22011": 67.06, "22003": 25.24, "22053": 7.4, "22019": 0.3}',
    density: 12.8,
    imprecise: false,
    latitude: 30.5004,
    longitude: -93.14279,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70657',
  },
  {
    city: 'Reeves',
    county_fips: 22003,
    county_fips_all: '22003',
    county: 'Allen',
    county_names_all: 'Allen',
    county_weights: '{"22003": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 30.52324,
    longitude: -93.03297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70658',
  },
  {
    city: 'Rosepine',
    county_fips: 22115,
    county_fips_all: '22115',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"22115": 100}',
    density: 240.1,
    imprecise: false,
    latitude: 30.92161,
    longitude: -93.284,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70659',
  },
  {
    city: 'Singer',
    county_fips: 22011,
    county_fips_all: '22011',
    county: 'Beauregard',
    county_names_all: 'Beauregard',
    county_weights: '{"22011": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 30.575,
    longitude: -93.44478,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70660',
  },
  {
    city: 'Starks',
    county_fips: 22019,
    county_fips_all: '22019|22011',
    county: 'Calcasieu',
    county_names_all: 'Calcasieu|Beauregard',
    county_weights: '{"22019": 68.51, "22011": 31.49}',
    density: 3.9,
    imprecise: false,
    latitude: 30.36683,
    longitude: -93.64833,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70661',
  },
  {
    city: 'Sugartown',
    county_fips: 22011,
    county_fips_all: '22011|22003',
    county: 'Beauregard',
    county_names_all: 'Beauregard|Allen',
    county_weights: '{"22011": 94.73, "22003": 5.27}',
    density: 6.7,
    imprecise: false,
    latitude: 30.80072,
    longitude: -92.99834,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70662',
  },
  {
    city: 'Sulphur',
    county_fips: 22019,
    county_fips_all: '22019',
    county: 'Calcasieu',
    county_names_all: 'Calcasieu',
    county_weights: '{"22019": 100}',
    density: 109.8,
    imprecise: false,
    latitude: 30.2772,
    longitude: -93.39086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70663',
  },
  {
    city: 'Sulphur',
    county_fips: 22019,
    county_fips_all: '22019',
    county: 'Calcasieu',
    county_names_all: 'Calcasieu',
    county_weights: '{"22019": 100}',
    density: 33.4,
    imprecise: false,
    latitude: 30.12756,
    longitude: -93.44555,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70665',
  },
  {
    city: 'Vinton',
    county_fips: 22019,
    county_fips_all: '22019',
    county: 'Calcasieu',
    county_names_all: 'Calcasieu',
    county_weights: '{"22019": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 30.17678,
    longitude: -93.60488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70668',
  },
  {
    city: 'Westlake',
    county_fips: 22019,
    county_fips_all: '22019',
    county: 'Calcasieu',
    county_names_all: 'Calcasieu',
    county_weights: '{"22019": 100}',
    density: 126.2,
    imprecise: false,
    latitude: 30.24216,
    longitude: -93.27731,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70669',
  },
  {
    city: 'Denham Springs',
    county_fips: 22063,
    county_fips_all: '22063|22091',
    county: 'Livingston',
    county_names_all: 'Livingston|St. Helena',
    county_weights: '{"22063": 72.86, "22091": 27.14}',
    density: 159.3,
    imprecise: false,
    latitude: 30.61453,
    longitude: -90.90086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70706',
  },
  {
    city: 'Addis',
    county_fips: 22121,
    county_fips_all: '22121',
    county: 'West Baton Rouge',
    county_names_all: 'West Baton Rouge',
    county_weights: '{"22121": 100}',
    density: 349.5,
    imprecise: false,
    latitude: 30.3559,
    longitude: -91.26773,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70710',
  },
  {
    city: 'Albany',
    county_fips: 22063,
    county_fips_all: '22063',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"22063": 100}',
    density: 117.9,
    imprecise: false,
    latitude: 30.53065,
    longitude: -90.60229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70711',
  },
  {
    city: 'Angola',
    county_fips: 22125,
    county_fips_all: '22125',
    county: 'West Feliciana',
    county_names_all: 'West Feliciana',
    county_weights: '{"22125": 100}',
    density: 90.2,
    imprecise: false,
    latitude: 30.96574,
    longitude: -91.58573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70712',
  },
  {
    city: 'Baker',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 194.4,
    imprecise: false,
    latitude: 30.58634,
    longitude: -91.12812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70714',
  },
  {
    city: 'Batchelor',
    county_fips: 22077,
    county_fips_all: '22077',
    county: 'Pointe Coupee',
    county_names_all: 'Pointe Coupee',
    county_weights: '{"22077": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 30.81204,
    longitude: -91.66262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70715',
  },
  {
    city: 'Brusly',
    county_fips: 22121,
    county_fips_all: '22121',
    county: 'West Baton Rouge',
    county_names_all: 'West Baton Rouge',
    county_weights: '{"22121": 100}',
    density: 120.6,
    imprecise: false,
    latitude: 30.37734,
    longitude: -91.29077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70719',
  },
  {
    city: 'Carville',
    county_fips: 22047,
    county_fips_all: '22047',
    county: 'Iberville',
    county_names_all: 'Iberville',
    county_weights: '{"22047": 100}',
    density: 48.2,
    imprecise: false,
    latitude: 30.21639,
    longitude: -91.09301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70721',
  },
  {
    city: 'Clinton',
    county_fips: 22037,
    county_fips_all: '22037|22033',
    county: 'East Feliciana',
    county_names_all: 'East Feliciana|East Baton Rouge',
    county_weights: '{"22037": 96.25, "22033": 3.75}',
    density: 9.7,
    imprecise: false,
    latitude: 30.84337,
    longitude: -90.93244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70722',
  },
  {
    city: 'Convent',
    county_fips: 22093,
    county_fips_all: '22093',
    county: 'St. James',
    county_names_all: 'St. James',
    county_weights: '{"22093": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 30.06379,
    longitude: -90.84111,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70723',
  },
  {
    city: 'Darrow',
    county_fips: 22005,
    county_fips_all: '22005',
    county: 'Ascension',
    county_names_all: 'Ascension',
    county_weights: '{"22005": 100}',
    density: 42.3,
    imprecise: false,
    latitude: 30.13652,
    longitude: -90.97255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70725',
  },
  {
    city: 'Denham Springs',
    county_fips: 22063,
    county_fips_all: '22063',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"22063": 100}',
    density: 278.3,
    imprecise: false,
    latitude: 30.42994,
    longitude: -90.90361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70726',
  },
  {
    city: 'Erwinville',
    county_fips: 22121,
    county_fips_all: '22121|22077',
    county: 'West Baton Rouge',
    county_names_all: 'West Baton Rouge|Pointe Coupee',
    county_weights: '{"22121": 77.82, "22077": 22.18}',
    density: 22.5,
    imprecise: false,
    latitude: 30.58891,
    longitude: -91.34671,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70729',
  },
  {
    city: 'Ethel',
    county_fips: 22037,
    county_fips_all: '22037',
    county: 'East Feliciana',
    county_names_all: 'East Feliciana',
    county_weights: '{"22037": 100}',
    density: 21.3,
    imprecise: false,
    latitude: 30.81588,
    longitude: -91.10869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70730',
  },
  {
    city: 'Fordoche',
    county_fips: 22077,
    county_fips_all: '22077',
    county: 'Pointe Coupee',
    county_names_all: 'Pointe Coupee',
    county_weights: '{"22077": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 30.6322,
    longitude: -91.60678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70732',
  },
  {
    city: 'French Settlement',
    county_fips: 22063,
    county_fips_all: '22063',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"22063": 100}',
    density: 59.3,
    imprecise: false,
    latitude: 30.30437,
    longitude: -90.79487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70733',
  },
  {
    city: 'Geismar',
    county_fips: 22005,
    county_fips_all: '22005',
    county: 'Ascension',
    county_names_all: 'Ascension',
    county_weights: '{"22005": 100}',
    density: 128.2,
    imprecise: false,
    latitude: 30.20812,
    longitude: -91.00095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70734',
  },
  {
    city: 'Glynn',
    county_fips: 22077,
    county_fips_all: '22077',
    county: 'Pointe Coupee',
    county_names_all: 'Pointe Coupee',
    county_weights: '{"22077": 100}',
    density: 25.5,
    imprecise: false,
    latitude: 30.63748,
    longitude: -91.33915,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70736',
  },
  {
    city: 'Gonzales',
    county_fips: 22005,
    county_fips_all: '22005',
    county: 'Ascension',
    county_names_all: 'Ascension',
    county_weights: '{"22005": 100}',
    density: 351,
    imprecise: false,
    latitude: 30.22587,
    longitude: -90.92271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70737',
  },
  {
    city: 'Greenwell Springs',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 121.3,
    imprecise: false,
    latitude: 30.60107,
    longitude: -90.9684,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70739',
  },
  {
    city: 'Grosse Tete',
    county_fips: 22047,
    county_fips_all: '22047',
    county: 'Iberville',
    county_names_all: 'Iberville',
    county_weights: '{"22047": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 30.33777,
    longitude: -91.43311,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70740',
  },
  {
    city: 'Hester',
    county_fips: 22093,
    county_fips_all: '22093',
    county: 'St. James',
    county_names_all: 'St. James',
    county_weights: '{"22093": 100}',
    density: 86.8,
    imprecise: false,
    latitude: 30.02655,
    longitude: -90.7729,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70743',
  },
  {
    city: 'Holden',
    county_fips: 22063,
    county_fips_all: '22063|22091',
    county: 'Livingston',
    county_names_all: 'Livingston|St. Helena',
    county_weights: '{"22063": 85.35, "22091": 14.65}',
    density: 22.8,
    imprecise: false,
    latitude: 30.56173,
    longitude: -90.67689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70744',
  },
  {
    city: 'Innis',
    county_fips: 22077,
    county_fips_all: '22077',
    county: 'Pointe Coupee',
    county_names_all: 'Pointe Coupee',
    county_weights: '{"22077": 100}',
    density: 42.5,
    imprecise: false,
    latitude: 30.87291,
    longitude: -91.68245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70747',
  },
  {
    city: 'Jackson',
    county_fips: 22037,
    county_fips_all: '22037|22033',
    county: 'East Feliciana',
    county_names_all: 'East Feliciana|East Baton Rouge',
    county_weights: '{"22037": 98.75, "22033": 1.25}',
    density: 36,
    imprecise: false,
    latitude: 30.8164,
    longitude: -91.20613,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70748',
  },
  {
    city: 'Jarreau',
    county_fips: 22077,
    county_fips_all: '22077',
    county: 'Pointe Coupee',
    county_names_all: 'Pointe Coupee',
    county_weights: '{"22077": 100}',
    density: 48.1,
    imprecise: false,
    latitude: 30.6326,
    longitude: -91.40985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70749',
  },
  {
    city: 'Krotz Springs',
    county_fips: 22097,
    county_fips_all: '22097',
    county: 'St. Landry',
    county_names_all: 'St. Landry',
    county_weights: '{"22097": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 30.46433,
    longitude: -91.7865,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70750',
  },
  {
    city: 'Lakeland',
    county_fips: 22077,
    county_fips_all: '22077',
    county: 'Pointe Coupee',
    county_names_all: 'Pointe Coupee',
    county_weights: '{"22077": 100}',
    density: 28.8,
    imprecise: false,
    latitude: 30.57986,
    longitude: -91.41915,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70752',
  },
  {
    city: 'Lettsworth',
    county_fips: 22077,
    county_fips_all: '22077',
    county: 'Pointe Coupee',
    county_names_all: 'Pointe Coupee',
    county_weights: '{"22077": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 30.7999,
    longitude: -91.72106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70753',
  },
  {
    city: 'Livingston',
    county_fips: 22063,
    county_fips_all: '22063',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"22063": 100}',
    density: 35.3,
    imprecise: false,
    latitude: 30.40542,
    longitude: -90.74462,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70754',
  },
  {
    city: 'Livonia',
    county_fips: 22077,
    county_fips_all: '22077',
    county: 'Pointe Coupee',
    county_names_all: 'Pointe Coupee',
    county_weights: '{"22077": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 30.59473,
    longitude: -91.52981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70755',
  },
  {
    city: 'Lottie',
    county_fips: 22077,
    county_fips_all: '22077',
    county: 'Pointe Coupee',
    county_names_all: 'Pointe Coupee',
    county_weights: '{"22077": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 30.53256,
    longitude: -91.64705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70756',
  },
  {
    city: 'Maringouin',
    county_fips: 22047,
    county_fips_all: '22047|22077',
    county: 'Iberville',
    county_names_all: 'Iberville|Pointe Coupee',
    county_weights: '{"22047": 82.48, "22077": 17.52}',
    density: 8.6,
    imprecise: false,
    latitude: 30.37204,
    longitude: -91.53468,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70757',
  },
  {
    city: 'Morganza',
    county_fips: 22077,
    county_fips_all: '22077',
    county: 'Pointe Coupee',
    county_names_all: 'Pointe Coupee',
    county_weights: '{"22077": 100}',
    density: 15,
    imprecise: false,
    latitude: 30.71346,
    longitude: -91.58762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70759',
  },
  {
    city: 'New Roads',
    county_fips: 22077,
    county_fips_all: '22077',
    county: 'Pointe Coupee',
    county_names_all: 'Pointe Coupee',
    county_weights: '{"22077": 100}',
    density: 49.1,
    imprecise: false,
    latitude: 30.69839,
    longitude: -91.48085,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70760',
  },
  {
    city: 'Norwood',
    county_fips: 22037,
    county_fips_all: '22037',
    county: 'East Feliciana',
    county_names_all: 'East Feliciana',
    county_weights: '{"22037": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 30.97429,
    longitude: -91.03129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70761',
  },
  {
    city: 'Oscar',
    county_fips: 22077,
    county_fips_all: '22077',
    county: 'Pointe Coupee',
    county_names_all: 'Pointe Coupee',
    county_weights: '{"22077": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 30.57843,
    longitude: -91.46695,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70762',
  },
  {
    city: 'Paulina',
    county_fips: 22093,
    county_fips_all: '22093',
    county: 'St. James',
    county_names_all: 'St. James',
    county_weights: '{"22093": 100}',
    density: 110.9,
    imprecise: false,
    latitude: 30.04929,
    longitude: -90.73736,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70763',
  },
  {
    city: 'Plaquemine',
    county_fips: 22047,
    county_fips_all: '22047|22121',
    county: 'Iberville',
    county_names_all: 'Iberville|West Baton Rouge',
    county_weights: '{"22047": 94.1, "22121": 5.9}',
    density: 30.2,
    imprecise: false,
    latitude: 30.22505,
    longitude: -91.30656,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70764',
  },
  {
    city: 'Port Allen',
    county_fips: 22121,
    county_fips_all: '22121|22077',
    county: 'West Baton Rouge',
    county_names_all: 'West Baton Rouge|Pointe Coupee',
    county_weights: '{"22121": 96.12, "22077": 3.88}',
    density: 37.7,
    imprecise: false,
    latitude: 30.47737,
    longitude: -91.32787,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70767',
  },
  {
    city: 'Prairieville',
    county_fips: 22005,
    county_fips_all: '22005|22063',
    county: 'Ascension',
    county_names_all: 'Ascension|Livingston',
    county_weights: '{"22005": 99.64, "22063": 0.36}',
    density: 397.5,
    imprecise: false,
    latitude: 30.30802,
    longitude: -90.93967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70769',
  },
  {
    city: 'Pride',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 68.7,
    imprecise: false,
    latitude: 30.65134,
    longitude: -90.99316,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70770',
  },
  {
    city: 'Rosedale',
    county_fips: 22047,
    county_fips_all: '22047',
    county: 'Iberville',
    county_names_all: 'Iberville',
    county_weights: '{"22047": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 30.43748,
    longitude: -91.46484,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70772',
  },
  {
    city: 'Rougon',
    county_fips: 22077,
    county_fips_all: '22077',
    county: 'Pointe Coupee',
    county_names_all: 'Pointe Coupee',
    county_weights: '{"22077": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 30.59678,
    longitude: -91.37333,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70773',
  },
  {
    city: 'Saint Amant',
    county_fips: 22005,
    county_fips_all: '22005|22063',
    county: 'Ascension',
    county_names_all: 'Ascension|Livingston',
    county_weights: '{"22005": 80.24, "22063": 19.76}',
    density: 73.8,
    imprecise: false,
    latitude: 30.22741,
    longitude: -90.78815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70774',
  },
  {
    city: 'Saint Francisville',
    county_fips: 22125,
    county_fips_all: '22125|22037',
    county: 'West Feliciana',
    county_names_all: 'West Feliciana|East Feliciana',
    county_weights: '{"22125": 99.83, "22037": 0.17}',
    density: 12.3,
    imprecise: false,
    latitude: 30.85982,
    longitude: -91.36847,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70775',
  },
  {
    city: 'Saint Gabriel',
    county_fips: 22047,
    county_fips_all: '22047',
    county: 'Iberville',
    county_names_all: 'Iberville',
    county_weights: '{"22047": 100}',
    density: 78.5,
    imprecise: false,
    latitude: 30.26051,
    longitude: -91.08923,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70776',
  },
  {
    city: 'Slaughter',
    county_fips: 22037,
    county_fips_all: '22037|22033',
    county: 'East Feliciana',
    county_names_all: 'East Feliciana|East Baton Rouge',
    county_weights: '{"22037": 87.41, "22033": 12.59}',
    density: 26.1,
    imprecise: false,
    latitude: 30.73898,
    longitude: -91.07319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70777',
  },
  {
    city: 'Sorrento',
    county_fips: 22005,
    county_fips_all: '22005',
    county: 'Ascension',
    county_names_all: 'Ascension',
    county_weights: '{"22005": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 30.16085,
    longitude: -90.81777,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70778',
  },
  {
    city: 'Sunshine',
    county_fips: 22047,
    county_fips_all: '22047',
    county: 'Iberville',
    county_names_all: 'Iberville',
    county_weights: '{"22047": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 30.29538,
    longitude: -91.16993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70780',
  },
  {
    city: 'Tunica',
    county_fips: 22125,
    county_fips_all: '22125',
    county: 'West Feliciana',
    county_names_all: 'West Feliciana',
    county_weights: '{"22125": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 30.94378,
    longitude: -91.51856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70782',
  },
  {
    city: 'Ventress',
    county_fips: 22077,
    county_fips_all: '22077',
    county: 'Pointe Coupee',
    county_names_all: 'Pointe Coupee',
    county_weights: '{"22077": 100}',
    density: 37.4,
    imprecise: false,
    latitude: 30.67032,
    longitude: -91.4087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70783',
  },
  {
    city: 'Walker',
    county_fips: 22063,
    county_fips_all: '22063',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"22063": 100}',
    density: 99,
    imprecise: false,
    latitude: 30.55621,
    longitude: -90.81858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70785',
  },
  {
    city: 'Watson',
    county_fips: 22063,
    county_fips_all: '22063',
    county: 'Livingston',
    county_names_all: 'Livingston',
    county_weights: '{"22063": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.58236,
    longitude: -90.95429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70786',
  },
  {
    city: 'Weyanoke',
    county_fips: 22125,
    county_fips_all: '22125',
    county: 'West Feliciana',
    county_names_all: 'West Feliciana',
    county_weights: '{"22125": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 30.9629,
    longitude: -91.44342,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70787',
  },
  {
    city: 'White Castle',
    county_fips: 22047,
    county_fips_all: '22047',
    county: 'Iberville',
    county_names_all: 'Iberville',
    county_weights: '{"22047": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 30.13618,
    longitude: -91.17939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70788',
  },
  {
    city: 'Wilson',
    county_fips: 22037,
    county_fips_all: '22037',
    county: 'East Feliciana',
    county_names_all: 'East Feliciana',
    county_weights: '{"22037": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 30.92973,
    longitude: -91.07109,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70789',
  },
  {
    city: 'Zachary',
    county_fips: 22033,
    county_fips_all: '22033|22037',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge|East Feliciana',
    county_weights: '{"22033": 96.46, "22037": 3.54}',
    density: 98.5,
    imprecise: false,
    latitude: 30.65013,
    longitude: -91.15734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70791',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 691.8,
    imprecise: false,
    latitude: 30.44954,
    longitude: -91.18608,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70801',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 1371.7,
    imprecise: false,
    latitude: 30.44691,
    longitude: -91.17554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70802',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 791.1,
    imprecise: false,
    latitude: 30.48831,
    longitude: -91.15951,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70805',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 1226.1,
    imprecise: false,
    latitude: 30.44879,
    longitude: -91.1247,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70806',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 233.6,
    imprecise: false,
    latitude: 30.5425,
    longitude: -91.2068,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70807',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 1155.2,
    imprecise: false,
    latitude: 30.4057,
    longitude: -91.14236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70808',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 690.7,
    imprecise: false,
    latitude: 30.39408,
    longitude: -91.07063,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70809',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 628.5,
    imprecise: false,
    latitude: 30.34637,
    longitude: -91.07998,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70810',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 414.8,
    imprecise: false,
    latitude: 30.53122,
    longitude: -91.11617,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70811',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 947.9,
    imprecise: false,
    latitude: 30.50018,
    longitude: -91.11051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70812',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 516.1,
    imprecise: false,
    latitude: 30.48502,
    longitude: -91.06164,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70814',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 1267.1,
    imprecise: false,
    latitude: 30.45537,
    longitude: -91.06648,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70815',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 1084.3,
    imprecise: false,
    latitude: 30.4288,
    longitude: -91.02144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70816',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 509.4,
    imprecise: false,
    latitude: 30.37558,
    longitude: -90.98026,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70817',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 245.1,
    imprecise: false,
    latitude: 30.54233,
    longitude: -91.05006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70818',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 363.3,
    imprecise: false,
    latitude: 30.47133,
    longitude: -91.00748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70819',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 438.4,
    imprecise: false,
    latitude: 30.36812,
    longitude: -91.18279,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70820',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 365,
    imprecise: false,
    latitude: 30.38758,
    longitude: -91.08357,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70836',
  },
  {
    city: 'Arcadia',
    county_fips: 22013,
    county_fips_all: '22013|22027|22061',
    county: 'Bienville',
    county_names_all: 'Bienville|Claiborne|Lincoln',
    county_weights: '{"22013": 44.98, "22027": 30.66, "22061": 24.36}',
    density: 10.9,
    imprecise: false,
    latitude: 32.59188,
    longitude: -92.90028,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71001',
  },
  {
    city: 'Ashland',
    county_fips: 22069,
    county_fips_all: '22069',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches',
    county_weights: '{"22069": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 32.11675,
    longitude: -93.116,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71002',
  },
  {
    city: 'Athens',
    county_fips: 22027,
    county_fips_all: '22027',
    county: 'Claiborne',
    county_names_all: 'Claiborne',
    county_weights: '{"22027": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 32.62969,
    longitude: -93.02787,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71003',
  },
  {
    city: 'Belcher',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 32.74403,
    longitude: -93.85843,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71004',
  },
  {
    city: 'Benton',
    county_fips: 22015,
    county_fips_all: '22015',
    county: 'Bossier',
    county_names_all: 'Bossier',
    county_weights: '{"22015": 100}',
    density: 31,
    imprecise: false,
    latitude: 32.72871,
    longitude: -93.63511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71006',
  },
  {
    city: 'Bethany',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 32.36854,
    longitude: -94.00502,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71007',
  },
  {
    city: 'Bienville',
    county_fips: 22013,
    county_fips_all: '22013',
    county: 'Bienville',
    county_names_all: 'Bienville',
    county_weights: '{"22013": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 32.33318,
    longitude: -92.96396,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71008',
  },
  {
    city: 'Blanchard',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 90.3,
    imprecise: false,
    latitude: 32.57793,
    longitude: -93.89185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71009',
  },
  {
    city: 'Castor',
    county_fips: 22013,
    county_fips_all: '22013',
    county: 'Bienville',
    county_names_all: 'Bienville',
    county_weights: '{"22013": 100}',
    density: 6,
    imprecise: false,
    latitude: 32.22899,
    longitude: -93.10818,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71016',
  },
  {
    city: 'Cotton Valley',
    county_fips: 22119,
    county_fips_all: '22119|22015',
    county: 'Webster',
    county_names_all: 'Webster|Bossier',
    county_weights: '{"22119": 67.18, "22015": 32.82}',
    density: 5.8,
    imprecise: false,
    latitude: 32.82178,
    longitude: -93.42972,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71018',
  },
  {
    city: 'Coushatta',
    county_fips: 22081,
    county_fips_all: '22081|22069',
    county: 'Red River',
    county_names_all: 'Red River|Natchitoches',
    county_weights: '{"22081": 86.55, "22069": 13.45}',
    density: 8.4,
    imprecise: false,
    latitude: 32.03951,
    longitude: -93.30701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71019',
  },
  {
    city: 'Cullen',
    county_fips: 22119,
    county_fips_all: '22119',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"22119": 100}',
    density: 291.1,
    imprecise: false,
    latitude: 32.96721,
    longitude: -93.44597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71021',
  },
  {
    city: 'Doyline',
    county_fips: 22119,
    county_fips_all: '22119|22015',
    county: 'Webster',
    county_names_all: 'Webster|Bossier',
    county_weights: '{"22119": 73.75, "22015": 26.25}',
    density: 26.7,
    imprecise: false,
    latitude: 32.4662,
    longitude: -93.40797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71023',
  },
  {
    city: 'Dubberly',
    county_fips: 22119,
    county_fips_all: '22119|22013',
    county: 'Webster',
    county_names_all: 'Webster|Bienville',
    county_weights: '{"22119": 65.36, "22013": 34.64}',
    density: 5.5,
    imprecise: false,
    latitude: 32.47897,
    longitude: -93.20336,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71024',
  },
  {
    city: 'Frierson',
    county_fips: 22031,
    county_fips_all: '22031',
    county: 'De Soto',
    county_names_all: 'De Soto',
    county_weights: '{"22031": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 32.24953,
    longitude: -93.68698,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71027',
  },
  {
    city: 'Gibsland',
    county_fips: 22013,
    county_fips_all: '22013',
    county: 'Bienville',
    county_names_all: 'Bienville',
    county_weights: '{"22013": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 32.48961,
    longitude: -93.07315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71028',
  },
  {
    city: 'Gilliam',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 32.83733,
    longitude: -93.83446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71029',
  },
  {
    city: 'Gloster',
    county_fips: 22031,
    county_fips_all: '22031',
    county: 'De Soto',
    county_names_all: 'De Soto',
    county_weights: '{"22031": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 32.19267,
    longitude: -93.78932,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71030',
  },
  {
    city: 'Goldonna',
    county_fips: 22127,
    county_fips_all: '22127|22069',
    county: 'Winn',
    county_names_all: 'Winn|Natchitoches',
    county_weights: '{"22127": 52.51, "22069": 47.49}',
    density: 2.6,
    imprecise: false,
    latitude: 32.01097,
    longitude: -92.89372,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71031',
  },
  {
    city: 'Grand Cane',
    county_fips: 22031,
    county_fips_all: '22031',
    county: 'De Soto',
    county_names_all: 'De Soto',
    county_weights: '{"22031": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 32.09383,
    longitude: -93.79247,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71032',
  },
  {
    city: 'Greenwood',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 43,
    imprecise: false,
    latitude: 32.44121,
    longitude: -94.00364,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71033',
  },
  {
    city: 'Hall Summit',
    county_fips: 22081,
    county_fips_all: '22081',
    county: 'Red River',
    county_names_all: 'Red River',
    county_weights: '{"22081": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 32.18442,
    longitude: -93.30553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71034',
  },
  {
    city: 'Haughton',
    county_fips: 22015,
    county_fips_all: '22015',
    county: 'Bossier',
    county_names_all: 'Bossier',
    county_weights: '{"22015": 100}',
    density: 63.5,
    imprecise: false,
    latitude: 32.56359,
    longitude: -93.52804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71037',
  },
  {
    city: 'Haynesville',
    county_fips: 22027,
    county_fips_all: '22027|22119',
    county: 'Claiborne',
    county_names_all: 'Claiborne|Webster',
    county_weights: '{"22027": 99.51, "22119": 0.49}',
    density: 6.9,
    imprecise: false,
    latitude: 32.94372,
    longitude: -93.0699,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71038',
  },
  {
    city: 'Heflin',
    county_fips: 22119,
    county_fips_all: '22119|22013',
    county: 'Webster',
    county_names_all: 'Webster|Bienville',
    county_weights: '{"22119": 65.28, "22013": 34.72}',
    density: 10.4,
    imprecise: false,
    latitude: 32.4265,
    longitude: -93.29064,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71039',
  },
  {
    city: 'Homer',
    county_fips: 22027,
    county_fips_all: '22027',
    county: 'Claiborne',
    county_names_all: 'Claiborne',
    county_weights: '{"22027": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 32.78564,
    longitude: -93.01238,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71040',
  },
  {
    city: 'Hosston',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 32.88789,
    longitude: -93.88906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71043',
  },
  {
    city: 'Ida',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 32.96662,
    longitude: -93.88083,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71044',
  },
  {
    city: 'Jamestown',
    county_fips: 22013,
    county_fips_all: '22013',
    county: 'Bienville',
    county_names_all: 'Bienville',
    county_weights: '{"22013": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 32.3461,
    longitude: -93.16595,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71045',
  },
  {
    city: 'Keatchie',
    county_fips: 22031,
    county_fips_all: '22031|22017',
    county: 'De Soto',
    county_names_all: 'De Soto|Caddo',
    county_weights: '{"22031": 87.32, "22017": 12.68}',
    density: 4.6,
    imprecise: false,
    latitude: 32.16647,
    longitude: -93.94589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71046',
  },
  {
    city: 'Keithville',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 35.7,
    imprecise: false,
    latitude: 32.29972,
    longitude: -93.91673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71047',
  },
  {
    city: 'Lisbon',
    county_fips: 22027,
    county_fips_all: '22027',
    county: 'Claiborne',
    county_names_all: 'Claiborne',
    county_weights: '{"22027": 100}',
    density: 2,
    imprecise: false,
    latitude: 32.83597,
    longitude: -92.85071,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71048',
  },
  {
    city: 'Logansport',
    county_fips: 22031,
    county_fips_all: '22031',
    county: 'De Soto',
    county_names_all: 'De Soto',
    county_weights: '{"22031": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 32.01603,
    longitude: -93.96663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71049',
  },
  {
    city: 'Elm Grove',
    county_fips: 22015,
    county_fips_all: '22015|22017',
    county: 'Bossier',
    county_names_all: 'Bossier|Caddo',
    county_weights: '{"22015": 99.03, "22017": 0.97}',
    density: 9.4,
    imprecise: false,
    latitude: 32.3417,
    longitude: -93.49639,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71051',
  },
  {
    city: 'Mansfield',
    county_fips: 22031,
    county_fips_all: '22031|22081',
    county: 'De Soto',
    county_names_all: 'De Soto|Red River',
    county_weights: '{"22031": 95.71, "22081": 4.29}',
    density: 11,
    imprecise: false,
    latitude: 32.01814,
    longitude: -93.66243,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71052',
  },
  {
    city: 'Minden',
    county_fips: 22119,
    county_fips_all: '22119|22027|22013',
    county: 'Webster',
    county_names_all: 'Webster|Claiborne|Bienville',
    county_weights: '{"22119": 87.82, "22027": 11.34, "22013": 0.84}',
    density: 26.4,
    imprecise: false,
    latitude: 32.67335,
    longitude: -93.29713,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71055',
  },
  {
    city: 'Mooringsport',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 32.63933,
    longitude: -93.987,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71060',
  },
  {
    city: 'Oil City',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 37.6,
    imprecise: false,
    latitude: 32.75342,
    longitude: -93.97742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71061',
  },
  {
    city: 'Pelican',
    county_fips: 22031,
    county_fips_all: '22031',
    county: 'De Soto',
    county_names_all: 'De Soto',
    county_weights: '{"22031": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 31.91051,
    longitude: -93.51569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71063',
  },
  {
    city: 'Plain Dealing',
    county_fips: 22015,
    county_fips_all: '22015',
    county: 'Bossier',
    county_names_all: 'Bossier',
    county_weights: '{"22015": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 32.91356,
    longitude: -93.68761,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71064',
  },
  {
    city: 'Pleasant Hill',
    county_fips: 22085,
    county_fips_all: '22085|22069|22031',
    county: 'Sabine',
    county_names_all: 'Sabine|Natchitoches|De Soto',
    county_weights: '{"22085": 84.06, "22069": 15.35, "22031": 0.59}',
    density: 6.2,
    imprecise: false,
    latitude: 31.81028,
    longitude: -93.49957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71065',
  },
  {
    city: 'Powhatan',
    county_fips: 22069,
    county_fips_all: '22069',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches',
    county_weights: '{"22069": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.87478,
    longitude: -93.19829,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71066',
  },
  {
    city: 'Princeton',
    county_fips: 22015,
    county_fips_all: '22015|22119',
    county: 'Bossier',
    county_names_all: 'Bossier|Webster',
    county_weights: '{"22015": 92.26, "22119": 7.74}',
    density: 24.4,
    imprecise: false,
    latitude: 32.59836,
    longitude: -93.49118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71067',
  },
  {
    city: 'Ringgold',
    county_fips: 22013,
    county_fips_all: '22013|22081',
    county: 'Bienville',
    county_names_all: 'Bienville|Red River',
    county_weights: '{"22013": 75.15, "22081": 24.85}',
    density: 9.4,
    imprecise: false,
    latitude: 32.28464,
    longitude: -93.32186,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71068',
  },
  {
    city: 'Rodessa',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 32.9726,
    longitude: -93.9887,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71069',
  },
  {
    city: 'Saline',
    county_fips: 22069,
    county_fips_all: '22069|22013',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches|Bienville',
    county_weights: '{"22069": 70.4, "22013": 29.6}',
    density: 3.3,
    imprecise: false,
    latitude: 32.08629,
    longitude: -92.99618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71070',
  },
  {
    city: 'Sarepta',
    county_fips: 22119,
    county_fips_all: '22119|22015',
    county: 'Webster',
    county_names_all: 'Webster|Bossier',
    county_weights: '{"22119": 80.74, "22015": 19.26}',
    density: 15.8,
    imprecise: false,
    latitude: 32.91747,
    longitude: -93.45099,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71071',
  },
  {
    city: 'Shongaloo',
    county_fips: 22119,
    county_fips_all: '22119',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"22119": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 32.9373,
    longitude: -93.31141,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71072',
  },
  {
    city: 'Sibley',
    county_fips: 22119,
    county_fips_all: '22119',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"22119": 100}',
    density: 34.3,
    imprecise: false,
    latitude: 32.5241,
    longitude: -93.30547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71073',
  },
  {
    city: 'Springhill',
    county_fips: 22119,
    county_fips_all: '22119|22015',
    county: 'Webster',
    county_names_all: 'Webster|Bossier',
    county_weights: '{"22119": 71.39, "22015": 28.61}',
    density: 59.4,
    imprecise: false,
    latitude: 32.99349,
    longitude: -93.49199,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71075',
  },
  {
    city: 'Stonewall',
    county_fips: 22031,
    county_fips_all: '22031',
    county: 'De Soto',
    county_names_all: 'De Soto',
    county_weights: '{"22031": 100}',
    density: 73.2,
    imprecise: false,
    latitude: 32.27721,
    longitude: -93.7976,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71078',
  },
  {
    city: 'Summerfield',
    county_fips: 22027,
    county_fips_all: '22027',
    county: 'Claiborne',
    county_names_all: 'Claiborne',
    county_weights: '{"22027": 100}',
    density: 3,
    imprecise: false,
    latitude: 32.94811,
    longitude: -92.81941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71079',
  },
  {
    city: 'Vivian',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 18,
    imprecise: false,
    latitude: 32.84389,
    longitude: -93.97763,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71082',
  },
  {
    city: 'Shreveport',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 588.4,
    imprecise: false,
    latitude: 32.5062,
    longitude: -93.74822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71101',
  },
  {
    city: 'Shreveport',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 627.2,
    imprecise: false,
    latitude: 32.49154,
    longitude: -93.7717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71103',
  },
  {
    city: 'Shreveport',
    county_fips: 22017,
    county_fips_all: '22017|22015',
    county: 'Caddo',
    county_names_all: 'Caddo|Bossier',
    county_weights: '{"22017": 95.12, "22015": 4.88}',
    density: 1278.1,
    imprecise: false,
    latitude: 32.48525,
    longitude: -93.73171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71104',
  },
  {
    city: 'Shreveport',
    county_fips: 22017,
    county_fips_all: '22017|22015',
    county: 'Caddo',
    county_names_all: 'Caddo|Bossier',
    county_weights: '{"22017": 95.39, "22015": 4.61}',
    density: 823.3,
    imprecise: false,
    latitude: 32.45512,
    longitude: -93.71012,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71105',
  },
  {
    city: 'Shreveport',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 396.8,
    imprecise: false,
    latitude: 32.38507,
    longitude: -93.73558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71106',
  },
  {
    city: 'Shreveport',
    county_fips: 22017,
    county_fips_all: '22017|22015',
    county: 'Caddo',
    county_names_all: 'Caddo|Bossier',
    county_weights: '{"22017": 99.23, "22015": 0.77}',
    density: 89.3,
    imprecise: false,
    latitude: 32.59509,
    longitude: -93.85909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71107',
  },
  {
    city: 'Shreveport',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 823.5,
    imprecise: false,
    latitude: 32.44236,
    longitude: -93.78881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71108',
  },
  {
    city: 'Shreveport',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 526.2,
    imprecise: false,
    latitude: 32.46859,
    longitude: -93.814,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71109',
  },
  {
    city: 'Barksdale Afb',
    county_fips: 22015,
    county_fips_all: '22015',
    county: 'Bossier',
    county_names_all: 'Bossier',
    county_weights: '{"22015": 100}',
    density: 56.7,
    imprecise: false,
    latitude: 32.50289,
    longitude: -93.63027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71110',
  },
  {
    city: 'Bossier City',
    county_fips: 22015,
    county_fips_all: '22015',
    county: 'Bossier',
    county_names_all: 'Bossier',
    county_weights: '{"22015": 100}',
    density: 374.9,
    imprecise: false,
    latitude: 32.57904,
    longitude: -93.70379,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71111',
  },
  {
    city: 'Bossier City',
    county_fips: 22015,
    county_fips_all: '22015',
    county: 'Bossier',
    county_names_all: 'Bossier',
    county_weights: '{"22015": 100}',
    density: 310.7,
    imprecise: false,
    latitude: 32.44373,
    longitude: -93.63874,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71112',
  },
  {
    city: 'Shreveport',
    county_fips: 22017,
    county_fips_all: '22017|22081',
    county: 'Caddo',
    county_names_all: 'Caddo|Red River',
    county_weights: '{"22017": 58.62, "22081": 41.38}',
    density: 47.9,
    imprecise: false,
    latitude: 32.26472,
    longitude: -93.56247,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71115',
  },
  {
    city: 'Shreveport',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 685.7,
    imprecise: false,
    latitude: 32.39262,
    longitude: -93.80498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71118',
  },
  {
    city: 'Shreveport',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 96.1,
    imprecise: false,
    latitude: 32.48542,
    longitude: -93.92296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71119',
  },
  {
    city: 'Shreveport',
    county_fips: 22017,
    county_fips_all: '22017',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"22017": 100}',
    density: 116.1,
    imprecise: false,
    latitude: 32.38697,
    longitude: -93.92685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71129',
  },
  {
    city: 'Monroe',
    county_fips: 22073,
    county_fips_all: '22073',
    county: 'Ouachita',
    county_names_all: 'Ouachita',
    county_weights: '{"22073": 100}',
    density: 565.2,
    imprecise: false,
    latitude: 32.53915,
    longitude: -92.1069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71201',
  },
  {
    city: 'Monroe',
    county_fips: 22073,
    county_fips_all: '22073',
    county: 'Ouachita',
    county_names_all: 'Ouachita',
    county_weights: '{"22073": 100}',
    density: 85.1,
    imprecise: false,
    latitude: 32.39549,
    longitude: -92.05663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71202',
  },
  {
    city: 'Monroe',
    county_fips: 22073,
    county_fips_all: '22073',
    county: 'Ouachita',
    county_names_all: 'Ouachita',
    county_weights: '{"22073": 100}',
    density: 124.9,
    imprecise: false,
    latitude: 32.58398,
    longitude: -92.01351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71203',
  },
  {
    city: 'Archibald',
    county_fips: 22083,
    county_fips_all: '22083',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"22083": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.35081,
    longitude: -91.78739,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71218',
  },
  {
    city: 'Baskin',
    county_fips: 22041,
    county_fips_all: '22041',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"22041": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 32.32344,
    longitude: -91.6842,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71219',
  },
  {
    city: 'Bastrop',
    county_fips: 22067,
    county_fips_all: '22067|22073',
    county: 'Morehouse',
    county_names_all: 'Morehouse|Ouachita',
    county_weights: '{"22067": 99.06, "22073": 0.94}',
    density: 21.1,
    imprecise: false,
    latitude: 32.8622,
    longitude: -91.91236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71220',
  },
  {
    city: 'Bernice',
    county_fips: 22111,
    county_fips_all: '22111|22027',
    county: 'Union',
    county_names_all: 'Union|Claiborne',
    county_weights: '{"22111": 73.72, "22027": 26.28}',
    density: 7.7,
    imprecise: false,
    latitude: 32.82859,
    longitude: -92.65918,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71222',
  },
  {
    city: 'Bonita',
    county_fips: 22067,
    county_fips_all: '22067',
    county: 'Morehouse',
    county_names_all: 'Morehouse',
    county_weights: '{"22067": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 32.90084,
    longitude: -91.67443,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71223',
  },
  {
    city: 'Calhoun',
    county_fips: 22073,
    county_fips_all: '22073',
    county: 'Ouachita',
    county_names_all: 'Ouachita',
    county_weights: '{"22073": 100}',
    density: 41,
    imprecise: false,
    latitude: 32.50784,
    longitude: -92.3477,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71225',
  },
  {
    city: 'Chatham',
    county_fips: 22049,
    county_fips_all: '22049',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"22049": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 32.24729,
    longitude: -92.44234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71226',
  },
  {
    city: 'Choudrant',
    county_fips: 22061,
    county_fips_all: '22061|22049|22073',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Jackson|Ouachita',
    county_weights: '{"22061": 60.38, "22049": 36.81, "22073": 2.81}',
    density: 12.7,
    imprecise: false,
    latitude: 32.52866,
    longitude: -92.48353,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71227',
  },
  {
    city: 'Collinston',
    county_fips: 22067,
    county_fips_all: '22067|22073',
    county: 'Morehouse',
    county_names_all: 'Morehouse|Ouachita',
    county_weights: '{"22067": 90.58, "22073": 9.42}',
    density: 9.4,
    imprecise: false,
    latitude: 32.6374,
    longitude: -91.89251,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71229',
  },
  {
    city: 'Crowville',
    county_fips: 22041,
    county_fips_all: '22041',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"22041": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.2403,
    longitude: -91.59269,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71230',
  },
  {
    city: 'Delhi',
    county_fips: 22065,
    county_fips_all: '22065|22083|22041',
    county: 'Madison',
    county_names_all: 'Madison|Richland|Franklin',
    county_weights: '{"22065": 45.64, "22083": 32.31, "22041": 22.04}',
    density: 9,
    imprecise: false,
    latitude: 32.41554,
    longitude: -91.493,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71232',
  },
  {
    city: 'Delta',
    county_fips: 22065,
    county_fips_all: '22065',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"22065": 100}',
    density: 114.1,
    imprecise: false,
    latitude: 32.32509,
    longitude: -90.93177,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71233',
  },
  {
    city: 'Downsville',
    county_fips: 22111,
    county_fips_all: '22111|22073|22061',
    county: 'Union',
    county_names_all: 'Union|Ouachita|Lincoln',
    county_weights: '{"22111": 86.22, "22073": 7.47, "22061": 6.31}',
    density: 17.8,
    imprecise: false,
    latitude: 32.64306,
    longitude: -92.33954,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71234',
  },
  {
    city: 'Dubach',
    county_fips: 22061,
    county_fips_all: '22061|22111|22027',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Union|Claiborne',
    county_weights: '{"22061": 95.55, "22111": 3.23, "22027": 1.22}',
    density: 9.6,
    imprecise: false,
    latitude: 32.68988,
    longitude: -92.6726,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71235',
  },
  {
    city: 'Epps',
    county_fips: 22123,
    county_fips_all: '22123|22035|22083|22065',
    county: 'West Carroll',
    county_names_all: 'West Carroll|East Carroll|Richland|Madison',
    county_weights:
      '{"22123": 48.16, "22035": 25.95, "22083": 16.67, "22065": 9.22}',
    density: 4.9,
    imprecise: false,
    latitude: 32.58413,
    longitude: -91.48024,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71237',
  },
  {
    city: 'Eros',
    county_fips: 22049,
    county_fips_all: '22049|22073',
    county: 'Jackson',
    county_names_all: 'Jackson|Ouachita',
    county_weights: '{"22049": 64.81, "22073": 35.19}',
    density: 8.5,
    imprecise: false,
    latitude: 32.36716,
    longitude: -92.38139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71238',
  },
  {
    city: 'Farmerville',
    county_fips: 22111,
    county_fips_all: '22111',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"22111": 100}',
    density: 17,
    imprecise: false,
    latitude: 32.77107,
    longitude: -92.36531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71241',
  },
  {
    city: 'Forest',
    county_fips: 22123,
    county_fips_all: '22123',
    county: 'West Carroll',
    county_names_all: 'West Carroll',
    county_weights: '{"22123": 100}',
    density: 1359.6,
    imprecise: false,
    latitude: 32.79223,
    longitude: -91.41291,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71242',
  },
  {
    city: 'Fort Necessity',
    county_fips: 22041,
    county_fips_all: '22041',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"22041": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 31.96055,
    longitude: -91.80745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71243',
  },
  {
    city: 'Grambling',
    county_fips: 22061,
    county_fips_all: '22061',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"22061": 100}',
    density: 316.2,
    imprecise: false,
    latitude: 32.52697,
    longitude: -92.7145,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71245',
  },
  {
    city: 'Hodge',
    county_fips: 22049,
    county_fips_all: '22049',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"22049": 100}',
    density: 318.8,
    imprecise: false,
    latitude: 32.27255,
    longitude: -92.72077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71247',
  },
  {
    city: 'Jones',
    county_fips: 22067,
    county_fips_all: '22067',
    county: 'Morehouse',
    county_names_all: 'Morehouse',
    county_weights: '{"22067": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 32.95983,
    longitude: -91.57327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71250',
  },
  {
    city: 'Jonesboro',
    county_fips: 22049,
    county_fips_all: '22049|22013',
    county: 'Jackson',
    county_names_all: 'Jackson|Bienville',
    county_weights: '{"22049": 86.5, "22013": 13.5}',
    density: 16.7,
    imprecise: false,
    latitude: 32.21891,
    longitude: -92.67162,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71251',
  },
  {
    city: 'Kilbourne',
    county_fips: 22123,
    county_fips_all: '22123',
    county: 'West Carroll',
    county_names_all: 'West Carroll',
    county_weights: '{"22123": 100}',
    density: 149.8,
    imprecise: false,
    latitude: 32.99597,
    longitude: -91.31576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71253',
  },
  {
    city: 'Lake Providence',
    county_fips: 22035,
    county_fips_all: '22035',
    county: 'East Carroll',
    county_names_all: 'East Carroll',
    county_weights: '{"22035": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 32.79429,
    longitude: -91.23914,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71254',
  },
  {
    city: 'Lillie',
    county_fips: 22111,
    county_fips_all: '22111|22027',
    county: 'Union',
    county_names_all: 'Union|Claiborne',
    county_weights: '{"22111": 61.64, "22027": 38.36}',
    density: 5,
    imprecise: false,
    latitude: 32.94852,
    longitude: -92.71471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71256',
  },
  {
    city: 'Mangham',
    county_fips: 22083,
    county_fips_all: '22083',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"22083": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 32.2713,
    longitude: -91.84558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71259',
  },
  {
    city: 'Marion',
    county_fips: 22111,
    county_fips_all: '22111',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"22111": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 32.90615,
    longitude: -92.23793,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71260',
  },
  {
    city: 'Mer Rouge',
    county_fips: 22067,
    county_fips_all: '22067',
    county: 'Morehouse',
    county_names_all: 'Morehouse',
    county_weights: '{"22067": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 32.77802,
    longitude: -91.69515,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71261',
  },
  {
    city: 'Oak Grove',
    county_fips: 22123,
    county_fips_all: '22123',
    county: 'West Carroll',
    county_names_all: 'West Carroll',
    county_weights: '{"22123": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 32.87497,
    longitude: -91.428,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71263',
  },
  {
    city: 'Oak Ridge',
    county_fips: 22067,
    county_fips_all: '22067|22083',
    county: 'Morehouse',
    county_names_all: 'Morehouse|Richland',
    county_weights: '{"22067": 80.63, "22083": 19.37}',
    density: 3.9,
    imprecise: false,
    latitude: 32.6029,
    longitude: -91.7734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71264',
  },
  {
    city: 'Pioneer',
    county_fips: 22123,
    county_fips_all: '22123',
    county: 'West Carroll',
    county_names_all: 'West Carroll',
    county_weights: '{"22123": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 32.70359,
    longitude: -91.48362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71266',
  },
  {
    city: 'Quitman',
    county_fips: 22049,
    county_fips_all: '22049|22013',
    county: 'Jackson',
    county_names_all: 'Jackson|Bienville',
    county_weights: '{"22049": 57.53, "22013": 42.47}',
    density: 7.7,
    imprecise: false,
    latitude: 32.34696,
    longitude: -92.74418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71268',
  },
  {
    city: 'Rayville',
    county_fips: 22083,
    county_fips_all: '22083',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"22083": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 32.44592,
    longitude: -91.78718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71269',
  },
  {
    city: 'Ruston',
    county_fips: 22061,
    county_fips_all: '22061|22049',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Jackson',
    county_weights: '{"22061": 61.36, "22049": 38.64}',
    density: 61.4,
    imprecise: false,
    latitude: 32.49378,
    longitude: -92.64139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71270',
  },
  {
    city: 'Simsboro',
    county_fips: 22061,
    county_fips_all: '22061|22013',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Bienville',
    county_weights: '{"22061": 76.95, "22013": 23.05}',
    density: 9.4,
    imprecise: false,
    latitude: 32.51276,
    longitude: -92.81991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71275',
  },
  {
    city: 'Sondheimer',
    county_fips: 22035,
    county_fips_all: '22035',
    county: 'East Carroll',
    county_names_all: 'East Carroll',
    county_weights: '{"22035": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 32.57727,
    longitude: -91.16277,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71276',
  },
  {
    city: 'Spearsville',
    county_fips: 22111,
    county_fips_all: '22111',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"22111": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 32.94902,
    longitude: -92.55554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71277',
  },
  {
    city: 'Start',
    county_fips: 22083,
    county_fips_all: '22083',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"22083": 100}',
    density: 255.9,
    imprecise: false,
    latitude: 32.48667,
    longitude: -91.85671,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71279',
  },
  {
    city: 'Sterlington',
    county_fips: 22111,
    county_fips_all: '22111|22073|22067',
    county: 'Union',
    county_names_all: 'Union|Ouachita|Morehouse',
    county_weights: '{"22111": 71.15, "22073": 22.63, "22067": 6.22}',
    density: 34.2,
    imprecise: false,
    latitude: 32.72344,
    longitude: -92.10389,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71280',
  },
  {
    city: 'Tallulah',
    county_fips: 22065,
    county_fips_all: '22065|22107',
    county: 'Madison',
    county_names_all: 'Madison|Tensas',
    county_weights: '{"22065": 99.13, "22107": 0.87}',
    density: 6.8,
    imprecise: false,
    latitude: 32.35662,
    longitude: -91.20042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71282',
  },
  {
    city: 'Transylvania',
    county_fips: 22035,
    county_fips_all: '22035',
    county: 'East Carroll',
    county_names_all: 'East Carroll',
    county_weights: '{"22035": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 32.65244,
    longitude: -91.23397,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71286',
  },
  {
    city: 'West Monroe',
    county_fips: 22073,
    county_fips_all: '22073',
    county: 'Ouachita',
    county_names_all: 'Ouachita',
    county_weights: '{"22073": 100}',
    density: 208,
    imprecise: false,
    latitude: 32.56977,
    longitude: -92.18277,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71291',
  },
  {
    city: 'West Monroe',
    county_fips: 22073,
    county_fips_all: '22073',
    county: 'Ouachita',
    county_names_all: 'Ouachita',
    county_weights: '{"22073": 100}',
    density: 57.6,
    imprecise: false,
    latitude: 32.40147,
    longitude: -92.21569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71292',
  },
  {
    city: 'Winnsboro',
    county_fips: 22041,
    county_fips_all: '22041',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"22041": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 32.14565,
    longitude: -91.70795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71295',
  },
  {
    city: 'Alexandria',
    county_fips: 22079,
    county_fips_all: '22079',
    county: 'Rapides',
    county_names_all: 'Rapides',
    county_weights: '{"22079": 100}',
    density: 526.8,
    imprecise: false,
    latitude: 31.27446,
    longitude: -92.46864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71301',
  },
  {
    city: 'Alexandria',
    county_fips: 22079,
    county_fips_all: '22079',
    county: 'Rapides',
    county_names_all: 'Rapides',
    county_weights: '{"22079": 100}',
    density: 90.7,
    imprecise: false,
    latitude: 31.2053,
    longitude: -92.36667,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71302',
  },
  {
    city: 'Alexandria',
    county_fips: 22079,
    county_fips_all: '22079',
    county: 'Rapides',
    county_names_all: 'Rapides',
    county_weights: '{"22079": 100}',
    density: 153,
    imprecise: false,
    latitude: 31.28081,
    longitude: -92.54308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71303',
  },
  {
    city: 'Acme',
    county_fips: 22029,
    county_fips_all: '22029',
    county: 'Concordia',
    county_names_all: 'Concordia',
    county_weights: '{"22029": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 31.27665,
    longitude: -91.76231,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71316',
  },
  {
    city: 'Bordelonville',
    county_fips: 22009,
    county_fips_all: '22009',
    county: 'Avoyelles',
    county_names_all: 'Avoyelles',
    county_weights: '{"22009": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 31.09114,
    longitude: -91.76985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71320',
  },
  {
    city: 'Bunkie',
    county_fips: 22009,
    county_fips_all: '22009|22097|22079',
    county: 'Avoyelles',
    county_names_all: 'Avoyelles|St. Landry|Rapides',
    county_weights: '{"22009": 49.56, "22097": 44.14, "22079": 6.31}',
    density: 10.6,
    imprecise: false,
    latitude: 30.86731,
    longitude: -92.15188,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71322',
  },
  {
    city: 'Center Point',
    county_fips: 22009,
    county_fips_all: '22009|22079',
    county: 'Avoyelles',
    county_names_all: 'Avoyelles|Rapides',
    county_weights: '{"22009": 94.85, "22079": 5.15}',
    density: 19.2,
    imprecise: false,
    latitude: 31.26656,
    longitude: -92.21037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71323',
  },
  {
    city: 'Cheneyville',
    county_fips: 22079,
    county_fips_all: '22079|22039',
    county: 'Rapides',
    county_names_all: 'Rapides|Evangeline',
    county_weights: '{"22079": 71.1, "22039": 28.9}',
    density: 7.4,
    imprecise: false,
    latitude: 31.01153,
    longitude: -92.32434,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71325',
  },
  {
    city: 'Clayton',
    county_fips: 22025,
    county_fips_all: '22025|22029',
    county: 'Catahoula',
    county_names_all: 'Catahoula|Concordia',
    county_weights: '{"22025": 73.7, "22029": 26.3}',
    density: 4.9,
    imprecise: false,
    latitude: 31.77363,
    longitude: -91.58702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71326',
  },
  {
    city: 'Cottonport',
    county_fips: 22009,
    county_fips_all: '22009',
    county: 'Avoyelles',
    county_names_all: 'Avoyelles',
    county_weights: '{"22009": 100}',
    density: 47.3,
    imprecise: false,
    latitude: 30.97895,
    longitude: -92.03863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71327',
  },
  {
    city: 'Deville',
    county_fips: 22079,
    county_fips_all: '22079|22009',
    county: 'Rapides',
    county_names_all: 'Rapides|Avoyelles',
    county_weights: '{"22079": 82.6, "22009": 17.4}',
    density: 24.9,
    imprecise: false,
    latitude: 31.35276,
    longitude: -92.19097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71328',
  },
  {
    city: 'Echo',
    county_fips: 22079,
    county_fips_all: '22079',
    county: 'Rapides',
    county_names_all: 'Rapides',
    county_weights: '{"22079": 100}',
    density: 115.7,
    imprecise: false,
    latitude: 31.11002,
    longitude: -92.24145,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71330',
  },
  {
    city: 'Effie',
    county_fips: 22009,
    county_fips_all: '22009',
    county: 'Avoyelles',
    county_names_all: 'Avoyelles',
    county_weights: '{"22009": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 31.2578,
    longitude: -92.07969,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71331',
  },
  {
    city: 'Evergreen',
    county_fips: 22009,
    county_fips_all: '22009',
    county: 'Avoyelles',
    county_names_all: 'Avoyelles',
    county_weights: '{"22009": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 30.90315,
    longitude: -92.0754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71333',
  },
  {
    city: 'Ferriday',
    county_fips: 22029,
    county_fips_all: '22029',
    county: 'Concordia',
    county_names_all: 'Concordia',
    county_weights: '{"22029": 100}',
    density: 25.2,
    imprecise: false,
    latitude: 31.66978,
    longitude: -91.56864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71334',
  },
  {
    city: 'Gilbert',
    county_fips: 22041,
    county_fips_all: '22041',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"22041": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 32.02126,
    longitude: -91.5935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71336',
  },
  {
    city: 'Hamburg',
    county_fips: 22009,
    county_fips_all: '22009',
    county: 'Avoyelles',
    county_names_all: 'Avoyelles',
    county_weights: '{"22009": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.0058,
    longitude: -91.93637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71339',
  },
  {
    city: 'Harrisonburg',
    county_fips: 22025,
    county_fips_all: '22025',
    county: 'Catahoula',
    county_names_all: 'Catahoula',
    county_weights: '{"22025": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 31.7553,
    longitude: -91.80696,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71340',
  },
  {
    city: 'Hessmer',
    county_fips: 22009,
    county_fips_all: '22009',
    county: 'Avoyelles',
    county_names_all: 'Avoyelles',
    county_weights: '{"22009": 100}',
    density: 43.1,
    imprecise: false,
    latitude: 31.05969,
    longitude: -92.16267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71341',
  },
  {
    city: 'Jena',
    county_fips: 22059,
    county_fips_all: '22059',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"22059": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 31.60042,
    longitude: -92.1403,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71342',
  },
  {
    city: 'Jonesville',
    county_fips: 22025,
    county_fips_all: '22025|22059|22029',
    county: 'Catahoula',
    county_names_all: 'Catahoula|LaSalle|Concordia',
    county_weights: '{"22025": 63.23, "22059": 19.39, "22029": 17.38}',
    density: 4.9,
    imprecise: false,
    latitude: 31.51117,
    longitude: -91.90723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71343',
  },
  {
    city: 'Lebeau',
    county_fips: 22097,
    county_fips_all: '22097',
    county: 'St. Landry',
    county_names_all: 'St. Landry',
    county_weights: '{"22097": 100}',
    density: 90.3,
    imprecise: false,
    latitude: 30.72867,
    longitude: -91.97531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71345',
  },
  {
    city: 'Lecompte',
    county_fips: 22079,
    county_fips_all: '22079',
    county: 'Rapides',
    county_names_all: 'Rapides',
    county_weights: '{"22079": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 31.11686,
    longitude: -92.38446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71346',
  },
  {
    city: 'Mansura',
    county_fips: 22009,
    county_fips_all: '22009',
    county: 'Avoyelles',
    county_names_all: 'Avoyelles',
    county_weights: '{"22009": 100}',
    density: 52.7,
    imprecise: false,
    latitude: 31.06871,
    longitude: -92.06053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71350',
  },
  {
    city: 'Marksville',
    county_fips: 22009,
    county_fips_all: '22009|22079',
    county: 'Avoyelles',
    county_names_all: 'Avoyelles|Rapides',
    county_weights: '{"22009": 99.25, "22079": 0.75}',
    density: 19.7,
    imprecise: false,
    latitude: 31.17227,
    longitude: -91.9604,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71351',
  },
  {
    city: 'Melville',
    county_fips: 22097,
    county_fips_all: '22097',
    county: 'St. Landry',
    county_names_all: 'St. Landry',
    county_weights: '{"22097": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 30.67949,
    longitude: -91.79664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71353',
  },
  {
    city: 'Monterey',
    county_fips: 22029,
    county_fips_all: '22029',
    county: 'Concordia',
    county_names_all: 'Concordia',
    county_weights: '{"22029": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 31.38364,
    longitude: -91.73548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71354',
  },
  {
    city: 'Moreauville',
    county_fips: 22009,
    county_fips_all: '22009',
    county: 'Avoyelles',
    county_names_all: 'Avoyelles',
    county_weights: '{"22009": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 31.05257,
    longitude: -91.88531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71355',
  },
  {
    city: 'Morrow',
    county_fips: 22097,
    county_fips_all: '22097|22009',
    county: 'St. Landry',
    county_names_all: 'St. Landry|Avoyelles',
    county_weights: '{"22097": 87.47, "22009": 12.53}',
    density: 11.7,
    imprecise: false,
    latitude: 30.83423,
    longitude: -92.02988,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71356',
  },
  {
    city: 'Newellton',
    county_fips: 22107,
    county_fips_all: '22107',
    county: 'Tensas',
    county_names_all: 'Tensas',
    county_weights: '{"22107": 100}',
    density: 2,
    imprecise: false,
    latitude: 32.1084,
    longitude: -91.29717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71357',
  },
  {
    city: 'Palmetto',
    county_fips: 22097,
    county_fips_all: '22097',
    county: 'St. Landry',
    county_names_all: 'St. Landry',
    county_weights: '{"22097": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 30.72631,
    longitude: -91.87553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71358',
  },
  {
    city: 'Pineville',
    county_fips: 22079,
    county_fips_all: '22079|22009|22043',
    county: 'Rapides',
    county_names_all: 'Rapides|Avoyelles|Grant',
    county_weights: '{"22079": 88.19, "22009": 10.7, "22043": 1.11}',
    density: 69.3,
    imprecise: false,
    latitude: 31.31597,
    longitude: -92.34593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71360',
  },
  {
    city: 'Plaucheville',
    county_fips: 22009,
    county_fips_all: '22009|22097',
    county: 'Avoyelles',
    county_names_all: 'Avoyelles|St. Landry',
    county_weights: '{"22009": 77.86, "22097": 22.14}',
    density: 12.3,
    imprecise: false,
    latitude: 30.88839,
    longitude: -91.95225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71362',
  },
  {
    city: 'Saint Joseph',
    county_fips: 22107,
    county_fips_all: '22107',
    county: 'Tensas',
    county_names_all: 'Tensas',
    county_weights: '{"22107": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 31.95051,
    longitude: -91.35591,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71366',
  },
  {
    city: 'Saint Landry',
    county_fips: 22039,
    county_fips_all: '22039|22079',
    county: 'Evangeline',
    county_names_all: 'Evangeline|Rapides',
    county_weights: '{"22039": 93.53, "22079": 6.47}',
    density: 11,
    imprecise: false,
    latitude: 30.88784,
    longitude: -92.29426,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71367',
  },
  {
    city: 'Sicily Island',
    county_fips: 22025,
    county_fips_all: '22025',
    county: 'Catahoula',
    county_names_all: 'Catahoula',
    county_weights: '{"22025": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 31.86392,
    longitude: -91.68494,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71368',
  },
  {
    city: 'Simmesport',
    county_fips: 22009,
    county_fips_all: '22009',
    county: 'Avoyelles',
    county_names_all: 'Avoyelles',
    county_weights: '{"22009": 100}',
    density: 16,
    imprecise: false,
    latitude: 30.92949,
    longitude: -91.85605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71369',
  },
  {
    city: 'Trout',
    county_fips: 22059,
    county_fips_all: '22059',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"22059": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 31.67542,
    longitude: -92.2587,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71371',
  },
  {
    city: 'Vidalia',
    county_fips: 22029,
    county_fips_all: '22029',
    county: 'Concordia',
    county_names_all: 'Concordia',
    county_weights: '{"22029": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 31.35934,
    longitude: -91.58607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71373',
  },
  {
    city: 'Waterproof',
    county_fips: 22107,
    county_fips_all: '22107',
    county: 'Tensas',
    county_names_all: 'Tensas',
    county_weights: '{"22107": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 31.84632,
    longitude: -91.47226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71375',
  },
  {
    city: 'Wisner',
    county_fips: 22041,
    county_fips_all: '22041',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"22041": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 31.95481,
    longitude: -91.71211,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71378',
  },
  {
    city: 'Aimwell',
    county_fips: 22025,
    county_fips_all: '22025',
    county: 'Catahoula',
    county_names_all: 'Catahoula',
    county_weights: '{"22025": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 31.79477,
    longitude: -91.94461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71401',
  },
  {
    city: 'Anacoco',
    county_fips: 22115,
    county_fips_all: '22115|22085',
    county: 'Vernon',
    county_names_all: 'Vernon|Sabine',
    county_weights: '{"22115": 93.11, "22085": 6.89}',
    density: 11.7,
    imprecise: false,
    latitude: 31.21047,
    longitude: -93.44061,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71403',
  },
  {
    city: 'Atlanta',
    county_fips: 22127,
    county_fips_all: '22127|22043',
    county: 'Winn',
    county_names_all: 'Winn|Grant',
    county_weights: '{"22127": 75.05, "22043": 24.95}',
    density: 2.3,
    imprecise: false,
    latitude: 31.75404,
    longitude: -92.75257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71404',
  },
  {
    city: 'Ball',
    county_fips: 22079,
    county_fips_all: '22079',
    county: 'Rapides',
    county_names_all: 'Rapides',
    county_weights: '{"22079": 100}',
    density: 126.9,
    imprecise: false,
    latitude: 31.40971,
    longitude: -92.39771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71405',
  },
  {
    city: 'Belmont',
    county_fips: 22085,
    county_fips_all: '22085',
    county: 'Sabine',
    county_names_all: 'Sabine',
    county_weights: '{"22085": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 31.73425,
    longitude: -93.50536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71406',
  },
  {
    city: 'Bentley',
    county_fips: 22043,
    county_fips_all: '22043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"22043": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 31.51837,
    longitude: -92.48402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71407',
  },
  {
    city: 'Boyce',
    county_fips: 22079,
    county_fips_all: '22079',
    county: 'Rapides',
    county_names_all: 'Rapides',
    county_weights: '{"22079": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 31.31287,
    longitude: -92.69954,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71409',
  },
  {
    city: 'Calvin',
    county_fips: 22127,
    county_fips_all: '22127',
    county: 'Winn',
    county_names_all: 'Winn',
    county_weights: '{"22127": 100}',
    density: 40.9,
    imprecise: false,
    latitude: 31.96419,
    longitude: -92.77125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71410',
  },
  {
    city: 'Campti',
    county_fips: 22069,
    county_fips_all: '22069',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches',
    county_weights: '{"22069": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 31.90466,
    longitude: -93.08894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71411',
  },
  {
    city: 'Clarence',
    county_fips: 22069,
    county_fips_all: '22069',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches',
    county_weights: '{"22069": 100}',
    density: 118.1,
    imprecise: false,
    latitude: 31.82593,
    longitude: -93.02515,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71414',
  },
  {
    city: 'Clarks',
    county_fips: 22021,
    county_fips_all: '22021',
    county: 'Caldwell',
    county_names_all: 'Caldwell',
    county_weights: '{"22021": 100}',
    density: 331.5,
    imprecise: false,
    latitude: 32.0253,
    longitude: -92.14241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71415',
  },
  {
    city: 'Cloutierville',
    county_fips: 22069,
    county_fips_all: '22069',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches',
    county_weights: '{"22069": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 31.53875,
    longitude: -92.89558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71416',
  },
  {
    city: 'Colfax',
    county_fips: 22043,
    county_fips_all: '22043',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"22043": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 31.51611,
    longitude: -92.65361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71417',
  },
  {
    city: 'Columbia',
    county_fips: 22021,
    county_fips_all: '22021|22083|22025|22073|22041',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Richland|Catahoula|Ouachita|Franklin',
    county_weights:
      '{"22021": 83.74, "22083": 7.06, "22025": 6.09, "22073": 2.92, "22041": 0.19}',
    density: 5.7,
    imprecise: false,
    latitude: 32.13405,
    longitude: -92.04589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71418',
  },
  {
    city: 'Converse',
    county_fips: 22085,
    county_fips_all: '22085|22031',
    county: 'Sabine',
    county_names_all: 'Sabine|De Soto',
    county_weights: '{"22085": 79.06, "22031": 20.94}',
    density: 5.3,
    imprecise: false,
    latitude: 31.80188,
    longitude: -93.72614,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71419',
  },
  {
    city: 'Dodson',
    county_fips: 22127,
    county_fips_all: '22127',
    county: 'Winn',
    county_names_all: 'Winn',
    county_weights: '{"22127": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 32.07653,
    longitude: -92.65767,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71422',
  },
  {
    city: 'Dry Prong',
    county_fips: 22043,
    county_fips_all: '22043|22079',
    county: 'Grant',
    county_names_all: 'Grant|Rapides',
    county_weights: '{"22043": 96.5, "22079": 3.5}',
    density: 14.7,
    imprecise: false,
    latitude: 31.60012,
    longitude: -92.56341,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71423',
  },
  {
    city: 'Elmer',
    county_fips: 22079,
    county_fips_all: '22079',
    county: 'Rapides',
    county_names_all: 'Rapides',
    county_weights: '{"22079": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 31.17976,
    longitude: -92.69207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71424',
  },
  {
    city: 'Enterprise',
    county_fips: 22025,
    county_fips_all: '22025',
    county: 'Catahoula',
    county_names_all: 'Catahoula',
    county_weights: '{"22025": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 31.89017,
    longitude: -91.89786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 78,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71425',
  },
  {
    city: 'Fisher',
    county_fips: 22085,
    county_fips_all: '22085',
    county: 'Sabine',
    county_names_all: 'Sabine',
    county_weights: '{"22085": 100}',
    density: 147.1,
    imprecise: false,
    latitude: 31.49182,
    longitude: -93.46165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71426',
  },
  {
    city: 'Flatwoods',
    county_fips: 22079,
    county_fips_all: '22079|22069',
    county: 'Rapides',
    county_names_all: 'Rapides|Natchitoches',
    county_weights: '{"22079": 60.48, "22069": 39.52}',
    density: 3.7,
    imprecise: false,
    latitude: 31.38879,
    longitude: -92.89388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71427',
  },
  {
    city: 'Flora',
    county_fips: 22069,
    county_fips_all: '22069',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches',
    county_weights: '{"22069": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.60921,
    longitude: -93.08855,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71428',
  },
  {
    city: 'Florien',
    county_fips: 22085,
    county_fips_all: '22085|22115',
    county: 'Sabine',
    county_names_all: 'Sabine|Vernon',
    county_weights: '{"22085": 98.0, "22115": 2.0}',
    density: 4.4,
    imprecise: false,
    latitude: 31.39843,
    longitude: -93.43218,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71429',
  },
  {
    city: 'Forest Hill',
    county_fips: 22079,
    county_fips_all: '22079',
    county: 'Rapides',
    county_names_all: 'Rapides',
    county_weights: '{"22079": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 31.06764,
    longitude: -92.53135,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71430',
  },
  {
    city: 'Georgetown',
    county_fips: 22043,
    county_fips_all: '22043|22127',
    county: 'Grant',
    county_names_all: 'Grant|Winn',
    county_weights: '{"22043": 95.08, "22127": 4.92}',
    density: 3,
    imprecise: false,
    latitude: 31.75368,
    longitude: -92.47435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71432',
  },
  {
    city: 'Glenmora',
    county_fips: 22079,
    county_fips_all: '22079',
    county: 'Rapides',
    county_names_all: 'Rapides',
    county_weights: '{"22079": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 31.00208,
    longitude: -92.64803,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71433',
  },
  {
    city: 'Gorum',
    county_fips: 22069,
    county_fips_all: '22069',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches',
    county_weights: '{"22069": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 31.44618,
    longitude: -92.944,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71434',
  },
  {
    city: 'Grayson',
    county_fips: 22021,
    county_fips_all: '22021|22025|22059|22127',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Catahoula|LaSalle|Winn',
    county_weights:
      '{"22021": 83.76, "22025": 13.43, "22059": 2.33, "22127": 0.48}',
    density: 6.4,
    imprecise: false,
    latitude: 32.02456,
    longitude: -92.1539,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71435',
  },
  {
    city: 'Hineston',
    county_fips: 22115,
    county_fips_all: '22115|22079',
    county: 'Vernon',
    county_names_all: 'Vernon|Rapides',
    county_weights: '{"22115": 70.28, "22079": 29.72}',
    density: 3,
    imprecise: false,
    latitude: 31.10092,
    longitude: -92.87511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71438',
  },
  {
    city: 'Hornbeck',
    county_fips: 22115,
    county_fips_all: '22115|22085',
    county: 'Vernon',
    county_names_all: 'Vernon|Sabine',
    county_weights: '{"22115": 66.95, "22085": 33.05}',
    density: 12,
    imprecise: false,
    latitude: 31.33707,
    longitude: -93.36597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71439',
  },
  {
    city: 'Kelly',
    county_fips: 22021,
    county_fips_all: '22021|22059',
    county: 'Caldwell',
    county_names_all: 'Caldwell|LaSalle',
    county_weights: '{"22021": 69.07, "22059": 30.93}',
    density: 5.9,
    imprecise: false,
    latitude: 31.94706,
    longitude: -92.13805,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71441',
  },
  {
    city: 'Leesville',
    county_fips: 22115,
    county_fips_all: '22115',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"22115": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 31.15585,
    longitude: -93.17187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71446',
  },
  {
    city: 'Lena',
    county_fips: 22079,
    county_fips_all: '22079|22069|22115',
    county: 'Rapides',
    county_names_all: 'Rapides|Natchitoches|Vernon',
    county_weights: '{"22079": 58.15, "22069": 41.39, "22115": 0.46}',
    density: 2.8,
    imprecise: false,
    latitude: 31.43202,
    longitude: -92.8073,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71447',
  },
  {
    city: 'Many',
    county_fips: 22085,
    county_fips_all: '22085',
    county: 'Sabine',
    county_names_all: 'Sabine',
    county_weights: '{"22085": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 31.5153,
    longitude: -93.54383,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71449',
  },
  {
    city: 'Marthaville',
    county_fips: 22069,
    county_fips_all: '22069|22085',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches|Sabine',
    county_weights: '{"22069": 78.87, "22085": 21.13}',
    density: 5.2,
    imprecise: false,
    latitude: 31.78137,
    longitude: -93.40367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71450',
  },
  {
    city: 'Melrose',
    county_fips: 22069,
    county_fips_all: '22069',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches',
    county_weights: '{"22069": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 31.58021,
    longitude: -92.9414,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71452',
  },
  {
    city: 'Montgomery',
    county_fips: 22043,
    county_fips_all: '22043|22127',
    county: 'Grant',
    county_names_all: 'Grant|Winn',
    county_weights: '{"22043": 61.86, "22127": 38.14}',
    density: 9.3,
    imprecise: false,
    latitude: 31.69334,
    longitude: -92.86131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71454',
  },
  {
    city: 'Mora',
    county_fips: 22069,
    county_fips_all: '22069|22079',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches|Rapides',
    county_weights: '{"22069": 85.05, "22079": 14.95}',
    density: 2.3,
    imprecise: false,
    latitude: 31.40125,
    longitude: -92.98074,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71455',
  },
  {
    city: 'Natchez',
    county_fips: 22069,
    county_fips_all: '22069',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches',
    county_weights: '{"22069": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 31.63534,
    longitude: -92.97429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71456',
  },
  {
    city: 'Natchitoches',
    county_fips: 22069,
    county_fips_all: '22069|22127',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches|Winn',
    county_weights: '{"22069": 95.97, "22127": 4.03}',
    density: 34.9,
    imprecise: false,
    latitude: 31.74045,
    longitude: -93.09375,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71457',
  },
  {
    city: 'Fort Johnson',
    county_fips: 22115,
    county_fips_all: '22115',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"22115": 100}',
    density: 354.9,
    imprecise: false,
    latitude: 31.07854,
    longitude: -93.21723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71459',
  },
  {
    city: 'New Llano',
    county_fips: 22115,
    county_fips_all: '22115',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"22115": 100}',
    density: 328.6,
    imprecise: false,
    latitude: 31.12099,
    longitude: -93.29775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71461',
  },
  {
    city: 'Noble',
    county_fips: 22085,
    county_fips_all: '22085',
    county: 'Sabine',
    county_names_all: 'Sabine',
    county_weights: '{"22085": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 31.66625,
    longitude: -93.7324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71462',
  },
  {
    city: 'Oakdale',
    county_fips: 22003,
    county_fips_all: '22003|22039|22079',
    county: 'Allen',
    county_names_all: 'Allen|Evangeline|Rapides',
    county_weights: '{"22003": 59.92, "22039": 29.58, "22079": 10.5}',
    density: 13.1,
    imprecise: false,
    latitude: 30.80854,
    longitude: -92.64853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71463',
  },
  {
    city: 'Olla',
    county_fips: 22059,
    county_fips_all: '22059|22127|22021|22025',
    county: 'LaSalle',
    county_names_all: 'LaSalle|Winn|Caldwell|Catahoula',
    county_weights:
      '{"22059": 73.2, "22127": 17.25, "22021": 7.26, "22025": 2.29}',
    density: 4.8,
    imprecise: false,
    latitude: 31.86499,
    longitude: -92.19408,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71465',
  },
  {
    city: 'Otis',
    county_fips: 22079,
    county_fips_all: '22079',
    county: 'Rapides',
    county_names_all: 'Rapides',
    county_weights: '{"22079": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 31.21593,
    longitude: -92.74886,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71466',
  },
  {
    city: 'Pollock',
    county_fips: 22043,
    county_fips_all: '22043|22079',
    county: 'Grant',
    county_names_all: 'Grant|Rapides',
    county_weights: '{"22043": 99.2, "22079": 0.8}',
    density: 18.3,
    imprecise: false,
    latitude: 31.55789,
    longitude: -92.39338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71467',
  },
  {
    city: 'Provencal',
    county_fips: 22069,
    county_fips_all: '22069',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches',
    county_weights: '{"22069": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 31.48086,
    longitude: -93.14518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71468',
  },
  {
    city: 'Robeline',
    county_fips: 22069,
    county_fips_all: '22069|22085',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches|Sabine',
    county_weights: '{"22069": 84.33, "22085": 15.67}',
    density: 5.3,
    imprecise: false,
    latitude: 31.67755,
    longitude: -93.2671,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71469',
  },
  {
    city: 'Sieper',
    county_fips: 22079,
    county_fips_all: '22079',
    county: 'Rapides',
    county_names_all: 'Rapides',
    county_weights: '{"22079": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 31.19834,
    longitude: -92.79216,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71472',
  },
  {
    city: 'Sikes',
    county_fips: 22127,
    county_fips_all: '22127',
    county: 'Winn',
    county_names_all: 'Winn',
    county_weights: '{"22127": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 32.06989,
    longitude: -92.42748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71473',
  },
  {
    city: 'Simpson',
    county_fips: 22115,
    county_fips_all: '22115',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"22115": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 31.27724,
    longitude: -93.01394,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71474',
  },
  {
    city: 'Slagle',
    county_fips: 22115,
    county_fips_all: '22115',
    county: 'Vernon',
    county_names_all: 'Vernon',
    county_weights: '{"22115": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.20123,
    longitude: -93.12461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71475',
  },
  {
    city: 'Tullos',
    county_fips: 22127,
    county_fips_all: '22127|22059',
    county: 'Winn',
    county_names_all: 'Winn|LaSalle',
    county_weights: '{"22127": 68.83, "22059": 31.17}',
    density: 2.4,
    imprecise: false,
    latitude: 31.85129,
    longitude: -92.36106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71479',
  },
  {
    city: 'Urania',
    county_fips: 22059,
    county_fips_all: '22059',
    county: 'LaSalle',
    county_names_all: 'LaSalle',
    county_weights: '{"22059": 100}',
    density: 121.7,
    imprecise: false,
    latitude: 31.86661,
    longitude: -92.28415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71480',
  },
  {
    city: 'Winnfield',
    county_fips: 22127,
    county_fips_all: '22127',
    county: 'Winn',
    county_names_all: 'Winn',
    county_weights: '{"22127": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 31.89482,
    longitude: -92.66373,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71483',
  },
  {
    city: 'Woodworth',
    county_fips: 22079,
    county_fips_all: '22079',
    county: 'Rapides',
    county_names_all: 'Rapides',
    county_weights: '{"22079": 100}',
    density: 24.2,
    imprecise: false,
    latitude: 31.17811,
    longitude: -92.53186,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71485',
  },
  {
    city: 'Zwolle',
    county_fips: 22085,
    county_fips_all: '22085',
    county: 'Sabine',
    county_names_all: 'Sabine',
    county_weights: '{"22085": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 31.62679,
    longitude: -93.65876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71486',
  },
  {
    city: 'Pine Bluff',
    county_fips: 5069,
    county_fips_all: '05069|05079',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Lincoln',
    county_weights: '{"05069": 99.53, "05079": 0.47}',
    density: 44.7,
    imprecise: false,
    latitude: 34.17409,
    longitude: -91.89811,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71601',
  },
  {
    city: 'White Hall',
    county_fips: 5069,
    county_fips_all: '05069|05053',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Grant',
    county_weights: '{"05069": 83.31, "05053": 16.69}',
    density: 44.2,
    imprecise: false,
    latitude: 34.27463,
    longitude: -92.13302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71602',
  },
  {
    city: 'Pine Bluff',
    county_fips: 5069,
    county_fips_all: '05069|05079|05025|05053',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Lincoln|Cleveland|Grant',
    county_weights:
      '{"05069": 84.61, "05079": 7.69, "05025": 5.22, "05053": 2.48}',
    density: 68.1,
    imprecise: false,
    latitude: 34.12881,
    longitude: -92.08492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71603',
  },
  {
    city: 'Arkansas City',
    county_fips: 5041,
    county_fips_all: '05041',
    county: 'Desha',
    county_names_all: 'Desha',
    county_weights: '{"05041": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 33.61827,
    longitude: -91.23004,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71630',
  },
  {
    city: 'Banks',
    county_fips: 5011,
    county_fips_all: '05011',
    county: 'Bradley',
    county_names_all: 'Bradley',
    county_weights: '{"05011": 100}',
    density: 1,
    imprecise: false,
    latitude: 33.58205,
    longitude: -92.26415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71631',
  },
  {
    city: 'Crossett',
    county_fips: 5003,
    county_fips_all: '05003|05011',
    county: 'Ashley',
    county_names_all: 'Ashley|Bradley',
    county_weights: '{"05003": 99.84, "05011": 0.16}',
    density: 17.9,
    imprecise: false,
    latitude: 33.1369,
    longitude: -92.00133,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71635',
  },
  {
    city: 'Dermott',
    county_fips: 5043,
    county_fips_all: '05043|05017|05041',
    county: 'Drew',
    county_names_all: 'Drew|Chicot|Desha',
    county_weights: '{"05043": 66.04, "05017": 25.43, "05041": 8.53}',
    density: 4.5,
    imprecise: false,
    latitude: 33.52008,
    longitude: -91.47927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71638',
  },
  {
    city: 'Dumas',
    county_fips: 5079,
    county_fips_all: '05079|05041',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Desha',
    county_weights: '{"05079": 52.26, "05041": 47.74}',
    density: 10.6,
    imprecise: false,
    latitude: 33.89143,
    longitude: -91.54414,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71639',
  },
  {
    city: 'Eudora',
    county_fips: 5017,
    county_fips_all: '05017',
    county: 'Chicot',
    county_names_all: 'Chicot',
    county_weights: '{"05017": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 33.1253,
    longitude: -91.24753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71640',
  },
  {
    city: 'Fountain Hill',
    county_fips: 5003,
    county_fips_all: '05003|05043',
    county: 'Ashley',
    county_names_all: 'Ashley|Drew',
    county_weights: '{"05003": 57.96, "05043": 42.04}',
    density: 4.2,
    imprecise: false,
    latitude: 33.38842,
    longitude: -91.8788,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71642',
  },
  {
    city: 'Gould',
    county_fips: 5079,
    county_fips_all: '05079|05041',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Desha',
    county_weights: '{"05079": 92.81, "05041": 7.19}',
    density: 14.3,
    imprecise: false,
    latitude: 34.01953,
    longitude: -91.57945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71643',
  },
  {
    city: 'Grady',
    county_fips: 5079,
    county_fips_all: '05079|05069',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Jefferson',
    county_weights: '{"05079": 69.06, "05069": 30.94}',
    density: 3,
    imprecise: false,
    latitude: 34.11045,
    longitude: -91.71213,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71644',
  },
  {
    city: 'Hamburg',
    county_fips: 5003,
    county_fips_all: '05003|05043',
    county: 'Ashley',
    county_names_all: 'Ashley|Drew',
    county_weights: '{"05003": 96.31, "05043": 3.69}',
    density: 6.7,
    imprecise: false,
    latitude: 33.20444,
    longitude: -91.77837,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71646',
  },
  {
    city: 'Hermitage',
    county_fips: 5011,
    county_fips_all: '05011',
    county: 'Bradley',
    county_names_all: 'Bradley',
    county_weights: '{"05011": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 33.36678,
    longitude: -92.12219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71647',
  },
  {
    city: 'Jersey',
    county_fips: 5011,
    county_fips_all: '05011',
    county: 'Bradley',
    county_names_all: 'Bradley',
    county_weights: '{"05011": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 33.31472,
    longitude: -92.28377,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71651',
  },
  {
    city: 'Kingsland',
    county_fips: 5025,
    county_fips_all: '05025',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"05025": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 33.89338,
    longitude: -92.31562,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71652',
  },
  {
    city: 'Lake Village',
    county_fips: 5017,
    county_fips_all: '05017',
    county: 'Chicot',
    county_names_all: 'Chicot',
    county_weights: '{"05017": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 33.36919,
    longitude: -91.27676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71653',
  },
  {
    city: 'McGehee',
    county_fips: 5041,
    county_fips_all: '05041',
    county: 'Desha',
    county_names_all: 'Desha',
    county_weights: '{"05041": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 33.62476,
    longitude: -91.37234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71654',
  },
  {
    city: 'Monticello',
    county_fips: 5043,
    county_fips_all: '05043|05079',
    county: 'Drew',
    county_names_all: 'Drew|Lincoln',
    county_weights: '{"05043": 99.32, "05079": 0.68}',
    density: 14.8,
    imprecise: false,
    latitude: 33.62874,
    longitude: -91.7486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71655',
  },
  {
    city: 'Montrose',
    county_fips: 5003,
    county_fips_all: '05003|05043',
    county: 'Ashley',
    county_names_all: 'Ashley|Drew',
    county_weights: '{"05003": 97.36, "05043": 2.64}',
    density: 1.3,
    imprecise: false,
    latitude: 33.32018,
    longitude: -91.57635,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71658',
  },
  {
    city: 'Moscow',
    county_fips: 5069,
    county_fips_all: '05069',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"05069": 100}',
    density: 23,
    imprecise: false,
    latitude: 34.13505,
    longitude: -91.78071,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71659',
  },
  {
    city: 'New Edinburg',
    county_fips: 5025,
    county_fips_all: '05025|05011',
    county: 'Cleveland',
    county_names_all: 'Cleveland|Bradley',
    county_weights: '{"05025": 99.62, "05011": 0.38}',
    density: 2.8,
    imprecise: false,
    latitude: 33.7627,
    longitude: -92.19728,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71660',
  },
  {
    city: 'Parkdale',
    county_fips: 5003,
    county_fips_all: '05003|05017',
    county: 'Ashley',
    county_names_all: 'Ashley|Chicot',
    county_weights: '{"05003": 75.8, "05017": 24.2}',
    density: 0.5,
    imprecise: false,
    latitude: 33.14338,
    longitude: -91.51333,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71661',
  },
  {
    city: 'Pickens',
    county_fips: 5041,
    county_fips_all: '05041',
    county: 'Desha',
    county_names_all: 'Desha',
    county_weights: '{"05041": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 33.82355,
    longitude: -91.50391,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71662',
  },
  {
    city: 'Portland',
    county_fips: 5017,
    county_fips_all: '05017|05003',
    county: 'Chicot',
    county_names_all: 'Chicot|Ashley',
    county_weights: '{"05017": 63.95, "05003": 36.05}',
    density: 2.7,
    imprecise: false,
    latitude: 33.22755,
    longitude: -91.42665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71663',
  },
  {
    city: 'Rison',
    county_fips: 5025,
    county_fips_all: '05025|05069',
    county: 'Cleveland',
    county_names_all: 'Cleveland|Jefferson',
    county_weights: '{"05025": 97.25, "05069": 2.75}',
    density: 6,
    imprecise: false,
    latitude: 33.93812,
    longitude: -92.13163,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71665',
  },
  {
    city: 'Rohwer',
    county_fips: 5041,
    county_fips_all: '05041',
    county: 'Desha',
    county_names_all: 'Desha',
    county_weights: '{"05041": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 33.7372,
    longitude: -91.24736,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71666',
  },
  {
    city: 'Star City',
    county_fips: 5079,
    county_fips_all: '05079|05025',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Cleveland',
    county_weights: '{"05079": 94.73, "05025": 5.27}',
    density: 9.9,
    imprecise: false,
    latitude: 33.93588,
    longitude: -91.84412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71667',
  },
  {
    city: 'Tillar',
    county_fips: 5041,
    county_fips_all: '05041|05043',
    county: 'Desha',
    county_names_all: 'Desha|Drew',
    county_weights: '{"05041": 70.25, "05043": 29.75}',
    density: 1.9,
    imprecise: false,
    latitude: 33.74439,
    longitude: -91.40974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71670',
  },
  {
    city: 'Warren',
    county_fips: 5011,
    county_fips_all: '05011|05025|05043',
    county: 'Bradley',
    county_names_all: 'Bradley|Cleveland|Drew',
    county_weights: '{"05011": 92.99, "05025": 3.98, "05043": 3.03}',
    density: 18.4,
    imprecise: false,
    latitude: 33.60652,
    longitude: -92.10006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8601,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71671',
  },
  {
    city: 'Watson',
    county_fips: 5041,
    county_fips_all: '05041',
    county: 'Desha',
    county_names_all: 'Desha',
    county_weights: '{"05041": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 33.82694,
    longitude: -91.18261,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71674',
  },
  {
    city: 'Wilmar',
    county_fips: 5043,
    county_fips_all: '05043|05011|05079',
    county: 'Drew',
    county_names_all: 'Drew|Bradley|Lincoln',
    county_weights: '{"05043": 83.71, "05011": 10.34, "05079": 5.95}',
    density: 4,
    imprecise: false,
    latitude: 33.60424,
    longitude: -91.93805,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71675',
  },
  {
    city: 'Wilmot',
    county_fips: 5003,
    county_fips_all: '05003|05017',
    county: 'Ashley',
    county_names_all: 'Ashley|Chicot',
    county_weights: '{"05003": 86.8, "05017": 13.2}',
    density: 2.2,
    imprecise: false,
    latitude: 33.05156,
    longitude: -91.56023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71676',
  },
  {
    city: 'Winchester',
    county_fips: 5043,
    county_fips_all: '05043',
    county: 'Drew',
    county_names_all: 'Drew',
    county_weights: '{"05043": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 33.76572,
    longitude: -91.4884,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71677',
  },
  {
    city: 'Yorktown',
    county_fips: 5079,
    county_fips_all: '05079',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"05079": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 34.0254,
    longitude: -91.81548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71678',
  },
  {
    city: 'Camden',
    county_fips: 5103,
    county_fips_all: '05103|05013',
    county: 'Ouachita',
    county_names_all: 'Ouachita|Calhoun',
    county_weights: '{"05103": 81.16, "05013": 18.84}',
    density: 22.6,
    imprecise: false,
    latitude: 33.57837,
    longitude: -92.81309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71701',
  },
  {
    city: 'Bearden',
    county_fips: 5103,
    county_fips_all: '05103|05039|05013',
    county: 'Ouachita',
    county_names_all: 'Ouachita|Dallas|Calhoun',
    county_weights: '{"05103": 54.21, "05039": 39.86, "05013": 5.93}',
    density: 6.8,
    imprecise: false,
    latitude: 33.79075,
    longitude: -92.64163,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71720',
  },
  {
    city: 'Beirne',
    county_fips: 5019,
    county_fips_all: '05019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"05019": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.89091,
    longitude: -93.20635,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71721',
  },
  {
    city: 'Bluff City',
    county_fips: 5099,
    county_fips_all: '05099',
    county: 'Nevada',
    county_names_all: 'Nevada',
    county_weights: '{"05099": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 33.71045,
    longitude: -93.15537,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71722',
  },
  {
    city: 'Calion',
    county_fips: 5139,
    county_fips_all: '05139',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"05139": 100}',
    density: 31.4,
    imprecise: false,
    latitude: 33.326,
    longitude: -92.54053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71724',
  },
  {
    city: 'Carthage',
    county_fips: 5039,
    county_fips_all: '05039|05025',
    county: 'Dallas',
    county_names_all: 'Dallas|Cleveland',
    county_weights: '{"05039": 84.24, "05025": 15.76}',
    density: 0.5,
    imprecise: false,
    latitude: 34.03791,
    longitude: -92.53252,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71725',
  },
  {
    city: 'Chidester',
    county_fips: 5103,
    county_fips_all: '05103|05099',
    county: 'Ouachita',
    county_names_all: 'Ouachita|Nevada',
    county_weights: '{"05103": 99.0, "05099": 1.0}',
    density: 2.2,
    imprecise: false,
    latitude: 33.68016,
    longitude: -92.99584,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71726',
  },
  {
    city: 'Curtis',
    county_fips: 5019,
    county_fips_all: '05019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"05019": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 34.0089,
    longitude: -93.1053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71728',
  },
  {
    city: 'El Dorado',
    county_fips: 5139,
    county_fips_all: '05139',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"05139": 100}',
    density: 25.1,
    imprecise: false,
    latitude: 33.20303,
    longitude: -92.63458,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71730',
  },
  {
    city: 'Emerson',
    county_fips: 5027,
    county_fips_all: '05027',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"05027": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 33.08121,
    longitude: -93.16268,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71740',
  },
  {
    city: 'Fordyce',
    county_fips: 5039,
    county_fips_all: '05039|05013',
    county: 'Dallas',
    county_names_all: 'Dallas|Calhoun',
    county_weights: '{"05039": 68.66, "05013": 31.34}',
    density: 9.9,
    imprecise: false,
    latitude: 33.83435,
    longitude: -92.44545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71742',
  },
  {
    city: 'Gurdon',
    county_fips: 5019,
    county_fips_all: '05019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"05019": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 33.88674,
    longitude: -93.11724,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71743',
  },
  {
    city: 'Hampton',
    county_fips: 5013,
    county_fips_all: '05013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"05013": 100}',
    density: 3,
    imprecise: false,
    latitude: 33.49201,
    longitude: -92.47536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71744',
  },
  {
    city: 'Harrell',
    county_fips: 5013,
    county_fips_all: '05013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"05013": 100}',
    density: 42.4,
    imprecise: false,
    latitude: 33.4997,
    longitude: -92.39496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71745',
  },
  {
    city: 'Huttig',
    county_fips: 5139,
    county_fips_all: '05139',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"05139": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 33.05892,
    longitude: -92.22238,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71747',
  },
  {
    city: 'Ivan',
    county_fips: 5039,
    county_fips_all: '05039',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"05039": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 33.90296,
    longitude: -92.43322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71748',
  },
  {
    city: 'Junction City',
    county_fips: 5139,
    county_fips_all: '05139|22027|22111',
    county: 'Union',
    county_names_all: 'Union|Claiborne|Union',
    county_weights: '{"05139": 98.24, "22027": 1.63, "22111": 0.13}',
    density: 6.7,
    imprecise: false,
    latitude: 33.07049,
    longitude: -92.81964,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71749',
  },
  {
    city: 'Louann',
    county_fips: 5103,
    county_fips_all: '05103',
    county: 'Ouachita',
    county_names_all: 'Ouachita',
    county_weights: '{"05103": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 33.40835,
    longitude: -92.77252,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71751',
  },
  {
    city: 'McNeil',
    county_fips: 5027,
    county_fips_all: '05027|05099',
    county: 'Columbia',
    county_names_all: 'Columbia|Nevada',
    county_weights: '{"05027": 98.6, "05099": 1.4}',
    density: 6.5,
    imprecise: false,
    latitude: 33.40061,
    longitude: -93.19454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71752',
  },
  {
    city: 'Magnolia',
    county_fips: 5027,
    county_fips_all: '05027|05139',
    county: 'Columbia',
    county_names_all: 'Columbia|Union',
    county_weights: '{"05027": 95.91, "05139": 4.09}',
    density: 19.2,
    imprecise: false,
    latitude: 33.22974,
    longitude: -93.18461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71753',
  },
  {
    city: 'Mount Holly',
    county_fips: 5139,
    county_fips_all: '05139',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"05139": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 33.30899,
    longitude: -92.91435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71758',
  },
  {
    city: 'Norphlet',
    county_fips: 5139,
    county_fips_all: '05139',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"05139": 100}',
    density: 106,
    imprecise: false,
    latitude: 33.31506,
    longitude: -92.65967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71759',
  },
  {
    city: 'Smackover',
    county_fips: 5139,
    county_fips_all: '05139|05103',
    county: 'Union',
    county_names_all: 'Union|Ouachita',
    county_weights: '{"05139": 90.7, "05103": 9.3}',
    density: 18.8,
    imprecise: false,
    latitude: 33.33668,
    longitude: -92.76767,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71762',
  },
  {
    city: 'Sparkman',
    county_fips: 5039,
    county_fips_all: '05039|05103|05019',
    county: 'Dallas',
    county_names_all: 'Dallas|Ouachita|Clark',
    county_weights: '{"05039": 85.21, "05103": 11.03, "05019": 3.76}',
    density: 2.6,
    imprecise: false,
    latitude: 33.90885,
    longitude: -92.80648,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71763',
  },
  {
    city: 'Stephens',
    county_fips: 5103,
    county_fips_all: '05103|05027|05099|05139',
    county: 'Ouachita',
    county_names_all: 'Ouachita|Columbia|Nevada|Union',
    county_weights:
      '{"05103": 63.16, "05027": 23.27, "05099": 13.05, "05139": 0.52}',
    density: 3.6,
    imprecise: false,
    latitude: 33.43041,
    longitude: -93.04475,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71764',
  },
  {
    city: 'Strong',
    county_fips: 5139,
    county_fips_all: '05139',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"05139": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 33.13358,
    longitude: -92.33628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71765',
  },
  {
    city: 'Thornton',
    county_fips: 5013,
    county_fips_all: '05013',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"05013": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 33.7362,
    longitude: -92.50205,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71766',
  },
  {
    city: 'Waldo',
    county_fips: 5027,
    county_fips_all: '05027|05099',
    county: 'Columbia',
    county_names_all: 'Columbia|Nevada',
    county_weights: '{"05027": 73.53, "05099": 26.47}',
    density: 8.5,
    imprecise: false,
    latitude: 33.38847,
    longitude: -93.31607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71770',
  },
  {
    city: 'Whelen Springs',
    county_fips: 5019,
    county_fips_all: '05019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"05019": 100}',
    density: 36.8,
    imprecise: false,
    latitude: 33.83379,
    longitude: -93.12646,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71772',
  },
  {
    city: 'Hope',
    county_fips: 5057,
    county_fips_all: '05057|05073',
    county: 'Hempstead',
    county_names_all: 'Hempstead|Lafayette',
    county_weights: '{"05057": 97.91, "05073": 2.09}',
    density: 19.3,
    imprecise: false,
    latitude: 33.63306,
    longitude: -93.59833,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71801',
  },
  {
    city: 'Alleene',
    county_fips: 5081,
    county_fips_all: '05081',
    county: 'Little River',
    county_names_all: 'Little River',
    county_weights: '{"05081": 100}',
    density: 5,
    imprecise: false,
    latitude: 33.78886,
    longitude: -94.24421,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71820',
  },
  {
    city: 'Ashdown',
    county_fips: 5081,
    county_fips_all: '05081',
    county: 'Little River',
    county_names_all: 'Little River',
    county_weights: '{"05081": 100}',
    density: 12,
    imprecise: false,
    latitude: 33.66946,
    longitude: -94.14755,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71822',
  },
  {
    city: 'Ben Lomond',
    county_fips: 5133,
    county_fips_all: '05133',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"05133": 100}',
    density: 43.9,
    imprecise: false,
    latitude: 33.83101,
    longitude: -94.12547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71823',
  },
  {
    city: 'Blevins',
    county_fips: 5057,
    county_fips_all: '05057',
    county: 'Hempstead',
    county_names_all: 'Hempstead',
    county_weights: '{"05057": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 33.87554,
    longitude: -93.56489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71825',
  },
  {
    city: 'Bradley',
    county_fips: 5073,
    county_fips_all: '05073',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"05073": 100}',
    density: 3,
    imprecise: false,
    latitude: 33.08994,
    longitude: -93.72536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71826',
  },
  {
    city: 'Buckner',
    county_fips: 5073,
    county_fips_all: '05073|05099',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Nevada',
    county_weights: '{"05073": 63.35, "05099": 36.65}',
    density: 5,
    imprecise: false,
    latitude: 33.41186,
    longitude: -93.41463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71827',
  },
  {
    city: 'Columbus',
    county_fips: 5061,
    county_fips_all: '05061|05057',
    county: 'Howard',
    county_names_all: 'Howard|Hempstead',
    county_weights: '{"05061": 81.35, "05057": 18.65}',
    density: 2.5,
    imprecise: false,
    latitude: 33.7762,
    longitude: -93.85971,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71831',
  },
  {
    city: 'De Queen',
    county_fips: 5133,
    county_fips_all: '05133',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"05133": 100}',
    density: 21.5,
    imprecise: false,
    latitude: 34.0397,
    longitude: -94.34791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71832',
  },
  {
    city: 'Dierks',
    county_fips: 5061,
    county_fips_all: '05061|05133',
    county: 'Howard',
    county_names_all: 'Howard|Sevier',
    county_weights: '{"05061": 89.46, "05133": 10.54}',
    density: 4.9,
    imprecise: false,
    latitude: 34.13409,
    longitude: -94.02665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71833',
  },
  {
    city: 'Doddridge',
    county_fips: 5091,
    county_fips_all: '05091',
    county: 'Miller',
    county_names_all: 'Miller',
    county_weights: '{"05091": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 33.11552,
    longitude: -93.9577,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71834',
  },
  {
    city: 'Emmet',
    county_fips: 5099,
    county_fips_all: '05099|05057',
    county: 'Nevada',
    county_names_all: 'Nevada|Hempstead',
    county_weights: '{"05099": 81.66, "05057": 18.34}',
    density: 5.1,
    imprecise: false,
    latitude: 33.66724,
    longitude: -93.4425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71835',
  },
  {
    city: 'Foreman',
    county_fips: 5081,
    county_fips_all: '05081',
    county: 'Little River',
    county_names_all: 'Little River',
    county_weights: '{"05081": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 33.71297,
    longitude: -94.39584,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71836',
  },
  {
    city: 'Fouke',
    county_fips: 5091,
    county_fips_all: '05091',
    county: 'Miller',
    county_names_all: 'Miller',
    county_weights: '{"05091": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 33.25543,
    longitude: -93.85693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71837',
  },
  {
    city: 'Fulton',
    county_fips: 5057,
    county_fips_all: '05057|05091',
    county: 'Hempstead',
    county_names_all: 'Hempstead|Miller',
    county_weights: '{"05057": 94.05, "05091": 5.95}',
    density: 3.2,
    imprecise: false,
    latitude: 33.64916,
    longitude: -93.79753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71838',
  },
  {
    city: 'Garland City',
    county_fips: 5091,
    county_fips_all: '05091',
    county: 'Miller',
    county_names_all: 'Miller',
    county_weights: '{"05091": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 33.30619,
    longitude: -93.73891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71839',
  },
  {
    city: 'Gillham',
    county_fips: 5133,
    county_fips_all: '05133|05113',
    county: 'Sevier',
    county_names_all: 'Sevier|Polk',
    county_weights: '{"05133": 87.35, "05113": 12.65}',
    density: 3.5,
    imprecise: false,
    latitude: 34.1639,
    longitude: -94.34718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71841',
  },
  {
    city: 'Horatio',
    county_fips: 5133,
    county_fips_all: '05133',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"05133": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 33.90051,
    longitude: -94.29297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71842',
  },
  {
    city: 'Lewisville',
    county_fips: 5073,
    county_fips_all: '05073',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"05073": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 33.32005,
    longitude: -93.63365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71845',
  },
  {
    city: 'Lockesburg',
    county_fips: 5133,
    county_fips_all: '05133|05081',
    county: 'Sevier',
    county_names_all: 'Sevier|Little River',
    county_weights: '{"05133": 95.91, "05081": 4.09}',
    density: 5,
    imprecise: false,
    latitude: 33.9265,
    longitude: -94.12367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71846',
  },
  {
    city: 'McCaskill',
    county_fips: 5057,
    county_fips_all: '05057',
    county: 'Hempstead',
    county_names_all: 'Hempstead',
    county_weights: '{"05057": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 33.92616,
    longitude: -93.63361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71847',
  },
  {
    city: 'Mineral Springs',
    county_fips: 5061,
    county_fips_all: '05061',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"05061": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 33.85728,
    longitude: -93.94658,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71851',
  },
  {
    city: 'Nashville',
    county_fips: 5061,
    county_fips_all: '05061|05109|05057',
    county: 'Howard',
    county_names_all: 'Howard|Pike|Hempstead',
    county_weights: '{"05061": 62.82, "05109": 18.89, "05057": 18.29}',
    density: 14.3,
    imprecise: false,
    latitude: 33.99489,
    longitude: -93.85831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71852',
  },
  {
    city: 'Ogden',
    county_fips: 5081,
    county_fips_all: '05081',
    county: 'Little River',
    county_names_all: 'Little River',
    county_weights: '{"05081": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 33.59442,
    longitude: -93.95635,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71853',
  },
  {
    city: 'Texarkana',
    county_fips: 5091,
    county_fips_all: '05091',
    county: 'Miller',
    county_names_all: 'Miller',
    county_weights: '{"05091": 100}',
    density: 51.1,
    imprecise: false,
    latitude: 33.44445,
    longitude: -93.90504,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71854',
  },
  {
    city: 'Ozan',
    county_fips: 5057,
    county_fips_all: '05057',
    county: 'Hempstead',
    county_names_all: 'Hempstead',
    county_weights: '{"05057": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 33.86612,
    longitude: -93.74351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71855',
  },
  {
    city: 'Prescott',
    county_fips: 5099,
    county_fips_all: '05099|05057',
    county: 'Nevada',
    county_names_all: 'Nevada|Hempstead',
    county_weights: '{"05099": 86.83, "05057": 13.17}',
    density: 8.1,
    imprecise: false,
    latitude: 33.80422,
    longitude: -93.34795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71857',
  },
  {
    city: 'Rosston',
    county_fips: 5099,
    county_fips_all: '05099',
    county: 'Nevada',
    county_names_all: 'Nevada',
    county_weights: '{"05099": 100}',
    density: 3,
    imprecise: false,
    latitude: 33.58543,
    longitude: -93.26706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71858',
  },
  {
    city: 'Saratoga',
    county_fips: 5057,
    county_fips_all: '05057|05061',
    county: 'Hempstead',
    county_names_all: 'Hempstead|Howard',
    county_weights: '{"05057": 81.64, "05061": 18.36}',
    density: 2.3,
    imprecise: false,
    latitude: 33.7143,
    longitude: -93.92379,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71859',
  },
  {
    city: 'Stamps',
    county_fips: 5073,
    county_fips_all: '05073|05027|05099',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Columbia|Nevada',
    county_weights: '{"05073": 74.66, "05027": 22.99, "05099": 2.35}',
    density: 6.7,
    imprecise: false,
    latitude: 33.307,
    longitude: -93.49286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71860',
  },
  {
    city: 'Taylor',
    county_fips: 5073,
    county_fips_all: '05073|05027',
    county: 'Lafayette',
    county_names_all: 'Lafayette|Columbia',
    county_weights: '{"05073": 55.47, "05027": 44.53}',
    density: 5.5,
    imprecise: false,
    latitude: 33.1039,
    longitude: -93.4941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71861',
  },
  {
    city: 'Washington',
    county_fips: 5057,
    county_fips_all: '05057',
    county: 'Hempstead',
    county_names_all: 'Hempstead',
    county_weights: '{"05057": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 33.76814,
    longitude: -93.72321,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71862',
  },
  {
    city: 'Willisville',
    county_fips: 5099,
    county_fips_all: '05099',
    county: 'Nevada',
    county_names_all: 'Nevada',
    county_weights: '{"05099": 100}',
    density: 25.9,
    imprecise: false,
    latitude: 33.50997,
    longitude: -93.28868,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 90,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71864',
  },
  {
    city: 'Wilton',
    county_fips: 5081,
    county_fips_all: '05081',
    county: 'Little River',
    county_names_all: 'Little River',
    county_weights: '{"05081": 100}',
    density: 96.3,
    imprecise: false,
    latitude: 33.74169,
    longitude: -94.14598,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71865',
  },
  {
    city: 'Winthrop',
    county_fips: 5081,
    county_fips_all: '05081|05133',
    county: 'Little River',
    county_names_all: 'Little River|Sevier',
    county_weights: '{"05081": 99.81, "05133": 0.19}',
    density: 2.8,
    imprecise: false,
    latitude: 33.86738,
    longitude: -94.38042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71866',
  },
  {
    city: 'Hot Springs National Park',
    county_fips: 5051,
    county_fips_all: '05051|05059',
    county: 'Garland',
    county_names_all: 'Garland|Hot Spring',
    county_weights: '{"05051": 99.41, "05059": 0.59}',
    density: 109.6,
    imprecise: false,
    latitude: 34.52682,
    longitude: -92.97247,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71901',
  },
  {
    city: 'Hot Springs Village',
    county_fips: 5051,
    county_fips_all: '05051|05125',
    county: 'Garland',
    county_names_all: 'Garland|Saline',
    county_weights: '{"05051": 72.3, "05125": 27.7}',
    density: 89.8,
    imprecise: false,
    latitude: 34.64106,
    longitude: -92.99608,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71909',
  },
  {
    city: 'Hot Springs National Park',
    county_fips: 5051,
    county_fips_all: '05051|05059',
    county: 'Garland',
    county_names_all: 'Garland|Hot Spring',
    county_weights: '{"05051": 77.56, "05059": 22.44}',
    density: 136.6,
    imprecise: false,
    latitude: 34.44677,
    longitude: -93.09981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71913',
  },
  {
    city: 'Amity',
    county_fips: 5019,
    county_fips_all: '05019|05109|05059',
    county: 'Clark',
    county_names_all: 'Clark|Pike|Hot Spring',
    county_weights: '{"05019": 69.8, "05109": 21.6, "05059": 8.6}',
    density: 6.6,
    imprecise: false,
    latitude: 34.25435,
    longitude: -93.40109,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71921',
  },
  {
    city: 'Antoine',
    county_fips: 5109,
    county_fips_all: '05109',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"05109": 100}',
    density: 29.8,
    imprecise: false,
    latitude: 34.02444,
    longitude: -93.41943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71922',
  },
  {
    city: 'Arkadelphia',
    county_fips: 5019,
    county_fips_all: '05019|05059|05039',
    county: 'Clark',
    county_names_all: 'Clark|Hot Spring|Dallas',
    county_weights: '{"05019": 89.04, "05059": 6.77, "05039": 4.19}',
    density: 15,
    imprecise: false,
    latitude: 34.08424,
    longitude: -93.05551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71923',
  },
  {
    city: 'Bismarck',
    county_fips: 5059,
    county_fips_all: '05059|05019',
    county: 'Hot Spring',
    county_names_all: 'Hot Spring|Clark',
    county_weights: '{"05059": 97.65, "05019": 2.35}',
    density: 17.9,
    imprecise: false,
    latitude: 34.30527,
    longitude: -93.1553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71929',
  },
  {
    city: 'Bonnerdale',
    county_fips: 5051,
    county_fips_all: '05051|05097|05059',
    county: 'Garland',
    county_names_all: 'Garland|Montgomery|Hot Spring',
    county_weights: '{"05051": 37.39, "05097": 34.96, "05059": 27.65}',
    density: 5.3,
    imprecise: false,
    latitude: 34.41037,
    longitude: -93.39124,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71933',
  },
  {
    city: 'Caddo Gap',
    county_fips: 5097,
    county_fips_all: '05097',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"05097": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 34.39338,
    longitude: -93.75009,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71935',
  },
  {
    city: 'Cove',
    county_fips: 5113,
    county_fips_all: '05113|40089',
    county: 'Polk',
    county_names_all: 'Polk|McCurtain',
    county_weights: '{"05113": 93.78, "40089": 6.22}',
    density: 10,
    imprecise: false,
    latitude: 34.40177,
    longitude: -94.38751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71937',
  },
  {
    city: 'Delight',
    county_fips: 5109,
    county_fips_all: '05109',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"05109": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 34.01527,
    longitude: -93.50705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71940',
  },
  {
    city: 'Donaldson',
    county_fips: 5059,
    county_fips_all: '05059',
    county: 'Hot Spring',
    county_names_all: 'Hot Spring',
    county_weights: '{"05059": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 34.2487,
    longitude: -92.95312,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71941',
  },
  {
    city: 'Friendship',
    county_fips: 5059,
    county_fips_all: '05059',
    county: 'Hot Spring',
    county_names_all: 'Hot Spring',
    county_weights: '{"05059": 100}',
    density: 41.1,
    imprecise: false,
    latitude: 34.22124,
    longitude: -92.99429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71942',
  },
  {
    city: 'Glenwood',
    county_fips: 5109,
    county_fips_all: '05109|05097|05059',
    county: 'Pike',
    county_names_all: 'Pike|Montgomery|Hot Spring',
    county_weights: '{"05109": 64.73, "05097": 32.81, "05059": 2.46}',
    density: 12.2,
    imprecise: false,
    latitude: 34.33488,
    longitude: -93.60633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71943',
  },
  {
    city: 'Grannis',
    county_fips: 5113,
    county_fips_all: '05113',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"05113": 100}',
    density: 11,
    imprecise: false,
    latitude: 34.23922,
    longitude: -94.32517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71944',
  },
  {
    city: 'Hatfield',
    county_fips: 5113,
    county_fips_all: '05113',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"05113": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 34.49826,
    longitude: -94.38492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71945',
  },
  {
    city: 'Jessieville',
    county_fips: 5051,
    county_fips_all: '05051',
    county: 'Garland',
    county_names_all: 'Garland',
    county_weights: '{"05051": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 34.68938,
    longitude: -93.21552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71949',
  },
  {
    city: 'Kirby',
    county_fips: 5109,
    county_fips_all: '05109',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"05109": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 34.25072,
    longitude: -93.72767,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71950',
  },
  {
    city: 'Langley',
    county_fips: 5109,
    county_fips_all: '05109|05097',
    county: 'Pike',
    county_names_all: 'Pike|Montgomery',
    county_weights: '{"05109": 99.88, "05097": 0.12}',
    density: 1,
    imprecise: false,
    latitude: 34.31067,
    longitude: -93.84992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71952',
  },
  {
    city: 'Mena',
    county_fips: 5113,
    county_fips_all: '05113|05127|40079',
    county: 'Polk',
    county_names_all: 'Polk|Scott|Le Flore',
    county_weights: '{"05113": 75.39, "05127": 19.48, "40079": 5.13}',
    density: 7.6,
    imprecise: false,
    latitude: 34.61291,
    longitude: -94.2118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71953',
  },
  {
    city: 'Mountain Pine',
    county_fips: 5051,
    county_fips_all: '05051',
    county: 'Garland',
    county_names_all: 'Garland',
    county_weights: '{"05051": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 34.60129,
    longitude: -93.14977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71956',
  },
  {
    city: 'Mount Ida',
    county_fips: 5097,
    county_fips_all: '05097',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"05097": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 34.55799,
    longitude: -93.59682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71957',
  },
  {
    city: 'Murfreesboro',
    county_fips: 5109,
    county_fips_all: '05109',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"05109": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 34.1114,
    longitude: -93.6556,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71958',
  },
  {
    city: 'Newhope',
    county_fips: 5109,
    county_fips_all: '05109|05061',
    county: 'Pike',
    county_names_all: 'Pike|Howard',
    county_weights: '{"05109": 50.36, "05061": 49.64}',
    density: 3.5,
    imprecise: false,
    latitude: 34.25081,
    longitude: -93.92633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71959',
  },
  {
    city: 'Norman',
    county_fips: 5097,
    county_fips_all: '05097',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"05097": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 34.47408,
    longitude: -93.69281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71960',
  },
  {
    city: 'Oden',
    county_fips: 5097,
    county_fips_all: '05097',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"05097": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 34.59722,
    longitude: -93.84676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71961',
  },
  {
    city: 'Okolona',
    county_fips: 5019,
    county_fips_all: '05019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"05019": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 34.03756,
    longitude: -93.33288,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71962',
  },
  {
    city: 'Pearcy',
    county_fips: 5051,
    county_fips_all: '05051|05059',
    county: 'Garland',
    county_names_all: 'Garland|Hot Spring',
    county_weights: '{"05051": 81.5, "05059": 18.5}',
    density: 56.8,
    imprecise: false,
    latitude: 34.42252,
    longitude: -93.24451,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71964',
  },
  {
    city: 'Pencil Bluff',
    county_fips: 5097,
    county_fips_all: '05097',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"05097": 100}',
    density: 7,
    imprecise: false,
    latitude: 34.65506,
    longitude: -93.74053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71965',
  },
  {
    city: 'Royal',
    county_fips: 5051,
    county_fips_all: '05051',
    county: 'Garland',
    county_names_all: 'Garland',
    county_weights: '{"05051": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 34.52719,
    longitude: -93.29767,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71968',
  },
  {
    city: 'Sims',
    county_fips: 5097,
    county_fips_all: '05097',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"05097": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 34.66671,
    longitude: -93.63442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71969',
  },
  {
    city: 'Story',
    county_fips: 5097,
    county_fips_all: '05097',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"05097": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 34.66686,
    longitude: -93.49024,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71970',
  },
  {
    city: 'Umpire',
    county_fips: 5061,
    county_fips_all: '05061|05109',
    county: 'Howard',
    county_names_all: 'Howard|Pike',
    county_weights: '{"05061": 83.4, "05109": 16.6}',
    density: 4.1,
    imprecise: false,
    latitude: 34.30411,
    longitude: -94.0313,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71971',
  },
  {
    city: 'Vandervoort',
    county_fips: 5113,
    county_fips_all: '05113',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"05113": 100}',
    density: 4,
    imprecise: false,
    latitude: 34.39447,
    longitude: -94.24695,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71972',
  },
  {
    city: 'Wickes',
    county_fips: 5113,
    county_fips_all: '05113|05061',
    county: 'Polk',
    county_names_all: 'Polk|Howard',
    county_weights: '{"05113": 61.38, "05061": 38.62}',
    density: 4.4,
    imprecise: false,
    latitude: 34.28755,
    longitude: -94.30523,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71973',
  },
  {
    city: 'Adona',
    county_fips: 5105,
    county_fips_all: '05105|05029',
    county: 'Perry',
    county_names_all: 'Perry|Conway',
    county_weights: '{"05105": 54.07, "05029": 45.93}',
    density: 6.8,
    imprecise: false,
    latitude: 35.07225,
    longitude: -92.87602,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72001',
  },
  {
    city: 'Alexander',
    county_fips: 5125,
    county_fips_all: '05125|05119',
    county: 'Saline',
    county_names_all: 'Saline|Pulaski',
    county_weights: '{"05125": 92.72, "05119": 7.28}',
    density: 126,
    imprecise: false,
    latitude: 34.6646,
    longitude: -92.5362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72002',
  },
  {
    city: 'Almyra',
    county_fips: 5001,
    county_fips_all: '05001',
    county: 'Arkansas',
    county_names_all: 'Arkansas',
    county_weights: '{"05001": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 34.38276,
    longitude: -91.40754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72003',
  },
  {
    city: 'Altheimer',
    county_fips: 5069,
    county_fips_all: '05069|05001',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Arkansas',
    county_weights: '{"05069": 97.67, "05001": 2.33}',
    density: 1.4,
    imprecise: false,
    latitude: 34.29722,
    longitude: -91.7856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72004',
  },
  {
    city: 'Amagon',
    county_fips: 5067,
    county_fips_all: '05067',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"05067": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 35.53911,
    longitude: -91.07271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72005',
  },
  {
    city: 'Augusta',
    county_fips: 5147,
    county_fips_all: '05147',
    county: 'Woodruff',
    county_names_all: 'Woodruff',
    county_weights: '{"05147": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 35.24602,
    longitude: -91.34495,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72006',
  },
  {
    city: 'Austin',
    county_fips: 5085,
    county_fips_all: '05085',
    county: 'Lonoke',
    county_names_all: 'Lonoke',
    county_weights: '{"05085": 100}',
    density: 89,
    imprecise: false,
    latitude: 35.0004,
    longitude: -91.97902,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72007',
  },
  {
    city: 'Bald Knob',
    county_fips: 5145,
    county_fips_all: '05145',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"05145": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 35.30555,
    longitude: -91.52112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72010',
  },
  {
    city: 'Bauxite',
    county_fips: 5125,
    county_fips_all: '05125|05053',
    county: 'Saline',
    county_names_all: 'Saline|Grant',
    county_weights: '{"05125": 95.63, "05053": 4.37}',
    density: 30.7,
    imprecise: false,
    latitude: 34.50967,
    longitude: -92.46628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72011',
  },
  {
    city: 'Beebe',
    county_fips: 5145,
    county_fips_all: '05145',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"05145": 100}',
    density: 54.2,
    imprecise: false,
    latitude: 35.10199,
    longitude: -91.91789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72012',
  },
  {
    city: 'Bee Branch',
    county_fips: 5141,
    county_fips_all: '05141|05029',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Conway',
    county_weights: '{"05141": 93.73, "05029": 6.27}',
    density: 6.6,
    imprecise: false,
    latitude: 35.45709,
    longitude: -92.3644,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72013',
  },
  {
    city: 'Beedeville',
    county_fips: 5067,
    county_fips_all: '05067',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"05067": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 35.43029,
    longitude: -91.11213,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72014',
  },
  {
    city: 'Benton',
    county_fips: 5125,
    county_fips_all: '05125|05053',
    county: 'Saline',
    county_names_all: 'Saline|Grant',
    county_weights: '{"05125": 76.2, "05053": 23.8}',
    density: 130.5,
    imprecise: false,
    latitude: 34.49298,
    longitude: -92.58974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72015',
  },
  {
    city: 'Bigelow',
    county_fips: 5105,
    county_fips_all: '05105|05119',
    county: 'Perry',
    county_names_all: 'Perry|Pulaski',
    county_weights: '{"05105": 77.83, "05119": 22.17}',
    density: 15,
    imprecise: false,
    latitude: 34.97702,
    longitude: -92.62763,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72016',
  },
  {
    city: 'Biscoe',
    county_fips: 5117,
    county_fips_all: '05117',
    county: 'Prairie',
    county_names_all: 'Prairie',
    county_weights: '{"05117": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 34.89215,
    longitude: -91.40714,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72017',
  },
  {
    city: 'Benton',
    county_fips: 5125,
    county_fips_all: '05125',
    county: 'Saline',
    county_names_all: 'Saline',
    county_weights: '{"05125": 100}',
    density: 67,
    imprecise: false,
    latitude: 34.63498,
    longitude: -92.69926,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72019',
  },
  {
    city: 'Bradford',
    county_fips: 5067,
    county_fips_all: '05067|05145|05063',
    county: 'Jackson',
    county_names_all: 'Jackson|White|Independence',
    county_weights: '{"05067": 50.27, "05145": 31.69, "05063": 18.04}',
    density: 7.6,
    imprecise: false,
    latitude: 35.48054,
    longitude: -91.47669,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72020',
  },
  {
    city: 'Brinkley',
    county_fips: 5095,
    county_fips_all: '05095|05147|05123',
    county: 'Monroe',
    county_names_all: 'Monroe|Woodruff|St. Francis',
    county_weights: '{"05095": 88.51, "05147": 9.48, "05123": 2.01}',
    density: 6.9,
    imprecise: false,
    latitude: 34.85953,
    longitude: -91.21193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72021',
  },
  {
    city: 'Bryant',
    county_fips: 5125,
    county_fips_all: '05125',
    county: 'Saline',
    county_names_all: 'Saline',
    county_weights: '{"05125": 100}',
    density: 533.9,
    imprecise: false,
    latitude: 34.60859,
    longitude: -92.49651,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72022',
  },
  {
    city: 'Cabot',
    county_fips: 5085,
    county_fips_all: '05085|05119|05045',
    county: 'Lonoke',
    county_names_all: 'Lonoke|Pulaski|Faulkner',
    county_weights: '{"05085": 68.99, "05119": 27.06, "05045": 3.95}',
    density: 147.2,
    imprecise: false,
    latitude: 34.95909,
    longitude: -92.05925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72023',
  },
  {
    city: 'Carlisle',
    county_fips: 5085,
    county_fips_all: '05085|05117',
    county: 'Lonoke',
    county_names_all: 'Lonoke|Prairie',
    county_weights: '{"05085": 93.29, "05117": 6.71}',
    density: 8.1,
    imprecise: false,
    latitude: 34.75168,
    longitude: -91.74902,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72024',
  },
  {
    city: 'Casa',
    county_fips: 5105,
    county_fips_all: '05105|05029|05149',
    county: 'Perry',
    county_names_all: 'Perry|Conway|Yell',
    county_weights: '{"05105": 69.16, "05029": 23.87, "05149": 6.97}',
    density: 5.3,
    imprecise: false,
    latitude: 35.0551,
    longitude: -92.99604,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72025',
  },
  {
    city: 'Casscoe',
    county_fips: 5001,
    county_fips_all: '05001',
    county: 'Arkansas',
    county_names_all: 'Arkansas',
    county_weights: '{"05001": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 34.51397,
    longitude: -91.31687,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72026',
  },
  {
    city: 'Center Ridge',
    county_fips: 5029,
    county_fips_all: '05029',
    county: 'Conway',
    county_names_all: 'Conway',
    county_weights: '{"05029": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 35.37021,
    longitude: -92.57494,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72027',
  },
  {
    city: 'Choctaw',
    county_fips: 5141,
    county_fips_all: '05141',
    county: 'Van Buren',
    county_names_all: 'Van Buren',
    county_weights: '{"05141": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 35.53771,
    longitude: -92.43266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72028',
  },
  {
    city: 'Clarendon',
    county_fips: 5095,
    county_fips_all: '05095',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"05095": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 34.71029,
    longitude: -91.27679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72029',
  },
  {
    city: 'Cleveland',
    county_fips: 5029,
    county_fips_all: '05029|05141',
    county: 'Conway',
    county_names_all: 'Conway|Van Buren',
    county_weights: '{"05029": 77.42, "05141": 22.58}',
    density: 4.6,
    imprecise: false,
    latitude: 35.43428,
    longitude: -92.68003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72030',
  },
  {
    city: 'Clinton',
    county_fips: 5141,
    county_fips_all: '05141|05137|05029',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Stone|Conway',
    county_weights: '{"05141": 90.63, "05137": 4.81, "05029": 4.56}',
    density: 8.7,
    imprecise: false,
    latitude: 35.60717,
    longitude: -92.52904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72031',
  },
  {
    city: 'Conway',
    county_fips: 5045,
    county_fips_all: '05045',
    county: 'Faulkner',
    county_names_all: 'Faulkner',
    county_weights: '{"05045": 100}',
    density: 116.3,
    imprecise: false,
    latitude: 35.07393,
    longitude: -92.36451,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72032',
  },
  {
    city: 'Conway',
    county_fips: 5045,
    county_fips_all: '05045',
    county: 'Faulkner',
    county_names_all: 'Faulkner',
    county_weights: '{"05045": 100}',
    density: 405.1,
    imprecise: false,
    latitude: 35.05405,
    longitude: -92.47945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72034',
  },
  {
    city: 'Cotton Plant',
    county_fips: 5147,
    county_fips_all: '05147|05095',
    county: 'Woodruff',
    county_names_all: 'Woodruff|Monroe',
    county_weights: '{"05147": 80.65, "05095": 19.35}',
    density: 2,
    imprecise: false,
    latitude: 35.00673,
    longitude: -91.27205,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72036',
  },
  {
    city: 'Crocketts Bluff',
    county_fips: 5001,
    county_fips_all: '05001',
    county: 'Arkansas',
    county_names_all: 'Arkansas',
    county_weights: '{"05001": 100}',
    density: 1,
    imprecise: false,
    latitude: 34.44606,
    longitude: -91.2349,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72038',
  },
  {
    city: 'Damascus',
    county_fips: 5045,
    county_fips_all: '05045|05141',
    county: 'Faulkner',
    county_names_all: 'Faulkner|Van Buren',
    county_weights: '{"05045": 53.98, "05141": 46.02}',
    density: 12.5,
    imprecise: false,
    latitude: 35.35636,
    longitude: -92.40338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72039',
  },
  {
    city: 'Des Arc',
    county_fips: 5117,
    county_fips_all: '05117|05147',
    county: 'Prairie',
    county_names_all: 'Prairie|Woodruff',
    county_weights: '{"05117": 92.81, "05147": 7.19}',
    density: 5.3,
    imprecise: false,
    latitude: 34.96957,
    longitude: -91.52129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72040',
  },
  {
    city: 'De Valls Bluff',
    county_fips: 5117,
    county_fips_all: '05117',
    county: 'Prairie',
    county_names_all: 'Prairie',
    county_weights: '{"05117": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 34.73348,
    longitude: -91.46812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72041',
  },
  {
    city: 'De Witt',
    county_fips: 5001,
    county_fips_all: '05001',
    county: 'Arkansas',
    county_names_all: 'Arkansas',
    county_weights: '{"05001": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 34.26937,
    longitude: -91.31567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72042',
  },
  {
    city: 'Edgemont',
    county_fips: 5023,
    county_fips_all: '05023|05137',
    county: 'Cleburne',
    county_names_all: 'Cleburne|Stone',
    county_weights: '{"05023": 72.83, "05137": 27.17}',
    density: 6.3,
    imprecise: false,
    latitude: 35.67688,
    longitude: -92.16243,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72044',
  },
  {
    city: 'El Paso',
    county_fips: 5145,
    county_fips_all: '05145',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"05145": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 35.12618,
    longitude: -92.05483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72045',
  },
  {
    city: 'England',
    county_fips: 5085,
    county_fips_all: '05085|05119|05069',
    county: 'Lonoke',
    county_names_all: 'Lonoke|Pulaski|Jefferson',
    county_weights: '{"05085": 70.85, "05119": 16.71, "05069": 12.44}',
    density: 6.4,
    imprecise: false,
    latitude: 34.55542,
    longitude: -91.9403,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72046',
  },
  {
    city: 'Enola',
    county_fips: 5045,
    county_fips_all: '05045',
    county: 'Faulkner',
    county_names_all: 'Faulkner',
    county_weights: '{"05045": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 35.22809,
    longitude: -92.21055,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72047',
  },
  {
    city: 'Ethel',
    county_fips: 5001,
    county_fips_all: '05001',
    county: 'Arkansas',
    county_names_all: 'Arkansas',
    county_weights: '{"05001": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 34.23436,
    longitude: -91.12433,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 59,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72048',
  },
  {
    city: 'Fox',
    county_fips: 5137,
    county_fips_all: '05137',
    county: 'Stone',
    county_names_all: 'Stone',
    county_weights: '{"05137": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 35.79475,
    longitude: -92.31501,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72051',
  },
  {
    city: 'Garner',
    county_fips: 5145,
    county_fips_all: '05145',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"05145": 100}',
    density: 109.3,
    imprecise: false,
    latitude: 35.13965,
    longitude: -91.78097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72052',
  },
  {
    city: 'College Station',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 34.70579,
    longitude: -92.22852,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72053',
  },
  {
    city: 'Gillett',
    county_fips: 5001,
    county_fips_all: '05001',
    county: 'Arkansas',
    county_names_all: 'Arkansas',
    county_weights: '{"05001": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 34.10391,
    longitude: -91.36196,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72055',
  },
  {
    city: 'Grapevine',
    county_fips: 5053,
    county_fips_all: '05053',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"05053": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 34.14417,
    longitude: -92.31507,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72057',
  },
  {
    city: 'Greenbrier',
    county_fips: 5045,
    county_fips_all: '05045',
    county: 'Faulkner',
    county_names_all: 'Faulkner',
    county_weights: '{"05045": 100}',
    density: 46.3,
    imprecise: false,
    latitude: 35.24273,
    longitude: -92.36998,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72058',
  },
  {
    city: 'Gregory',
    county_fips: 5147,
    county_fips_all: '05147',
    county: 'Woodruff',
    county_names_all: 'Woodruff',
    county_weights: '{"05147": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.15455,
    longitude: -91.34209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72059',
  },
  {
    city: 'Griffithville',
    county_fips: 5145,
    county_fips_all: '05145|05117',
    county: 'White',
    county_names_all: 'White|Prairie',
    county_weights: '{"05145": 58.74, "05117": 41.26}',
    density: 2.6,
    imprecise: false,
    latitude: 35.07609,
    longitude: -91.57779,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72060',
  },
  {
    city: 'Guy',
    county_fips: 5045,
    county_fips_all: '05045',
    county: 'Faulkner',
    county_names_all: 'Faulkner',
    county_weights: '{"05045": 100}',
    density: 35.7,
    imprecise: false,
    latitude: 35.32437,
    longitude: -92.28992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72061',
  },
  {
    city: 'Hattieville',
    county_fips: 5029,
    county_fips_all: '05029|05115',
    county: 'Conway',
    county_names_all: 'Conway|Pope',
    county_weights: '{"05029": 97.77, "05115": 2.23}',
    density: 9.2,
    imprecise: false,
    latitude: 35.32205,
    longitude: -92.77249,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72063',
  },
  {
    city: 'Hazen',
    county_fips: 5117,
    county_fips_all: '05117',
    county: 'Prairie',
    county_names_all: 'Prairie',
    county_weights: '{"05117": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 34.79457,
    longitude: -91.61226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72064',
  },
  {
    city: 'Hensley',
    county_fips: 5125,
    county_fips_all: '05125|05119|05053',
    county: 'Saline',
    county_names_all: 'Saline|Pulaski|Grant',
    county_weights: '{"05125": 57.57, "05119": 26.07, "05053": 16.36}',
    density: 33.7,
    imprecise: false,
    latitude: 34.52102,
    longitude: -92.28648,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72065',
  },
  {
    city: 'Hickory Plains',
    county_fips: 5117,
    county_fips_all: '05117',
    county: 'Prairie',
    county_names_all: 'Prairie',
    county_weights: '{"05117": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 34.98141,
    longitude: -91.7171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72066',
  },
  {
    city: 'Higden',
    county_fips: 5023,
    county_fips_all: '05023|05141',
    county: 'Cleburne',
    county_names_all: 'Cleburne|Van Buren',
    county_weights: '{"05023": 83.79, "05141": 16.21}',
    density: 22.6,
    imprecise: false,
    latitude: 35.56369,
    longitude: -92.16589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72067',
  },
  {
    city: 'Higginson',
    county_fips: 5145,
    county_fips_all: '05145',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"05145": 100}',
    density: 77.7,
    imprecise: false,
    latitude: 35.15766,
    longitude: -91.71547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72068',
  },
  {
    city: 'Holly Grove',
    county_fips: 5095,
    county_fips_all: '05095|05107',
    county: 'Monroe',
    county_names_all: 'Monroe|Phillips',
    county_weights: '{"05095": 92.42, "05107": 7.58}',
    density: 1.2,
    imprecise: false,
    latitude: 34.53904,
    longitude: -91.13242,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72069',
  },
  {
    city: 'Houston',
    county_fips: 5105,
    county_fips_all: '05105',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"05105": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 35.01346,
    longitude: -92.6995,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72070',
  },
  {
    city: 'Humnoke',
    county_fips: 5085,
    county_fips_all: '05085|05069',
    county: 'Lonoke',
    county_names_all: 'Lonoke|Jefferson',
    county_weights: '{"05085": 74.07, "05069": 25.93}',
    density: 2.5,
    imprecise: false,
    latitude: 34.51279,
    longitude: -91.75802,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72072',
  },
  {
    city: 'Humphrey',
    county_fips: 5001,
    county_fips_all: '05001|05069',
    county: 'Arkansas',
    county_names_all: 'Arkansas|Jefferson',
    county_weights: '{"05001": 90.89, "05069": 9.11}',
    density: 2.8,
    imprecise: false,
    latitude: 34.36529,
    longitude: -91.65251,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72073',
  },
  {
    city: 'Hunter',
    county_fips: 5147,
    county_fips_all: '05147',
    county: 'Woodruff',
    county_names_all: 'Woodruff',
    county_weights: '{"05147": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 35.06919,
    longitude: -91.10538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72074',
  },
  {
    city: 'Jacksonport',
    county_fips: 5067,
    county_fips_all: '05067',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"05067": 100}',
    density: 93.4,
    imprecise: false,
    latitude: 35.64084,
    longitude: -91.31089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72075',
  },
  {
    city: 'Jacksonville',
    county_fips: 5119,
    county_fips_all: '05119|05085|05045',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Lonoke|Faulkner',
    county_weights: '{"05119": 84.76, "05085": 10.79, "05045": 4.45}',
    density: 204.1,
    imprecise: false,
    latitude: 34.91072,
    longitude: -92.14303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72076',
  },
  {
    city: 'Jefferson',
    county_fips: 5069,
    county_fips_all: '05069|05053',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Grant',
    county_weights: '{"05069": 65.5, "05053": 34.5}',
    density: 7.2,
    imprecise: false,
    latitude: 34.38958,
    longitude: -92.19919,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72079',
  },
  {
    city: 'Jerusalem',
    county_fips: 5141,
    county_fips_all: '05141|05029|05115',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Conway|Pope',
    county_weights: '{"05141": 44.91, "05029": 33.86, "05115": 21.23}',
    density: 2.3,
    imprecise: false,
    latitude: 35.52604,
    longitude: -92.80909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72080',
  },
  {
    city: 'Judsonia',
    county_fips: 5145,
    county_fips_all: '05145|05063',
    county: 'White',
    county_names_all: 'White|Independence',
    county_weights: '{"05145": 99.11, "05063": 0.89}',
    density: 30.5,
    imprecise: false,
    latitude: 35.37827,
    longitude: -91.66947,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72081',
  },
  {
    city: 'Kensett',
    county_fips: 5145,
    county_fips_all: '05145',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"05145": 100}',
    density: 181.2,
    imprecise: false,
    latitude: 35.23713,
    longitude: -91.66963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72082',
  },
  {
    city: 'Keo',
    county_fips: 5085,
    county_fips_all: '05085',
    county: 'Lonoke',
    county_names_all: 'Lonoke',
    county_weights: '{"05085": 100}',
    density: 32.5,
    imprecise: false,
    latitude: 34.6049,
    longitude: -92.01189,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72083',
  },
  {
    city: 'Leola',
    county_fips: 5039,
    county_fips_all: '05039|05053|05059',
    county: 'Dallas',
    county_names_all: 'Dallas|Grant|Hot Spring',
    county_weights: '{"05039": 57.88, "05053": 30.15, "05059": 11.97}',
    density: 2.2,
    imprecise: false,
    latitude: 34.13687,
    longitude: -92.6887,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72084',
  },
  {
    city: 'Letona',
    county_fips: 5145,
    county_fips_all: '05145',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"05145": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 35.36665,
    longitude: -91.82772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72085',
  },
  {
    city: 'Lonoke',
    county_fips: 5085,
    county_fips_all: '05085|05117',
    county: 'Lonoke',
    county_names_all: 'Lonoke|Prairie',
    county_weights: '{"05085": 96.18, "05117": 3.82}',
    density: 27.6,
    imprecise: false,
    latitude: 34.80418,
    longitude: -91.90619,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72086',
  },
  {
    city: 'Lonsdale',
    county_fips: 5125,
    county_fips_all: '05125|05051',
    county: 'Saline',
    county_names_all: 'Saline|Garland',
    county_weights: '{"05125": 63.81, "05051": 36.19}',
    density: 10.8,
    imprecise: false,
    latitude: 34.59877,
    longitude: -92.83391,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72087',
  },
  {
    city: 'Fairfield Bay',
    county_fips: 5141,
    county_fips_all: '05141|05023',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Cleburne',
    county_weights: '{"05141": 78.71, "05023": 21.29}',
    density: 67.6,
    imprecise: false,
    latitude: 35.59803,
    longitude: -92.26239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72088',
  },
  {
    city: 'McCrory',
    county_fips: 5147,
    county_fips_all: '05147|05067|05037',
    county: 'Woodruff',
    county_names_all: 'Woodruff|Jackson|Cross',
    county_weights: '{"05147": 88.92, "05067": 10.65, "05037": 0.43}',
    density: 4.3,
    imprecise: false,
    latitude: 35.23228,
    longitude: -91.15242,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72101',
  },
  {
    city: 'McRae',
    county_fips: 5145,
    county_fips_all: '05145',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"05145": 100}',
    density: 20.7,
    imprecise: false,
    latitude: 35.14556,
    longitude: -91.83352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72102',
  },
  {
    city: 'Mabelvale',
    county_fips: 5125,
    county_fips_all: '05125|05119',
    county: 'Saline',
    county_names_all: 'Saline|Pulaski',
    county_weights: '{"05125": 77.19, "05119": 22.81}',
    density: 198.7,
    imprecise: false,
    latitude: 34.59133,
    longitude: -92.38316,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72103',
  },
  {
    city: 'Malvern',
    county_fips: 5059,
    county_fips_all: '05059|05051|05125|05053',
    county: 'Hot Spring',
    county_names_all: 'Hot Spring|Garland|Saline|Grant',
    county_weights:
      '{"05059": 95.29, "05051": 2.72, "05125": 1.31, "05053": 0.68}',
    density: 27.9,
    imprecise: false,
    latitude: 34.34774,
    longitude: -92.81814,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72104',
  },
  {
    city: 'Mayflower',
    county_fips: 5045,
    county_fips_all: '05045|05119',
    county: 'Faulkner',
    county_names_all: 'Faulkner|Pulaski',
    county_weights: '{"05045": 98.37, "05119": 1.63}',
    density: 45.8,
    imprecise: false,
    latitude: 34.96997,
    longitude: -92.48727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72106',
  },
  {
    city: 'Menifee',
    county_fips: 5029,
    county_fips_all: '05029',
    county: 'Conway',
    county_names_all: 'Conway',
    county_weights: '{"05029": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 35.14255,
    longitude: -92.53844,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72107',
  },
  {
    city: 'Monroe',
    county_fips: 5095,
    county_fips_all: '05095',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"05095": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.72803,
    longitude: -91.10349,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72108',
  },
  {
    city: 'Morrilton',
    county_fips: 5029,
    county_fips_all: '05029',
    county: 'Conway',
    county_names_all: 'Conway',
    county_weights: '{"05029": 100}',
    density: 37.2,
    imprecise: false,
    latitude: 35.15514,
    longitude: -92.77273,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72110',
  },
  {
    city: 'Mount Vernon',
    county_fips: 5045,
    county_fips_all: '05045|05145',
    county: 'Faulkner',
    county_names_all: 'Faulkner|White',
    county_weights: '{"05045": 72.58, "05145": 27.42}',
    density: 8.6,
    imprecise: false,
    latitude: 35.23688,
    longitude: -92.13307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72111',
  },
  {
    city: 'Newport',
    county_fips: 5067,
    county_fips_all: '05067|05147|05063',
    county: 'Jackson',
    county_names_all: 'Jackson|Woodruff|Independence',
    county_weights: '{"05067": 92.8, "05147": 4.72, "05063": 2.48}',
    density: 13.2,
    imprecise: false,
    latitude: 35.57383,
    longitude: -91.22918,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72112',
  },
  {
    city: 'Maumelle',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 376.1,
    imprecise: false,
    latitude: 34.85926,
    longitude: -92.39875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72113',
  },
  {
    city: 'North Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 508.2,
    imprecise: false,
    latitude: 34.7645,
    longitude: -92.26024,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72114',
  },
  {
    city: 'North Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 1336.3,
    imprecise: false,
    latitude: 34.80025,
    longitude: -92.24505,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72116',
  },
  {
    city: 'North Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 95.4,
    imprecise: false,
    latitude: 34.78076,
    longitude: -92.14548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72117',
  },
  {
    city: 'North Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 320,
    imprecise: false,
    latitude: 34.83872,
    longitude: -92.32694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72118',
  },
  {
    city: 'North Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.8369,
    longitude: -92.29505,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72119',
  },
  {
    city: 'Sherwood',
    county_fips: 5119,
    county_fips_all: '05119|05045',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Faulkner',
    county_weights: '{"05119": 69.07, "05045": 30.93}',
    density: 244.8,
    imprecise: false,
    latitude: 34.89776,
    longitude: -92.24431,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72120',
  },
  {
    city: 'Pangburn',
    county_fips: 5145,
    county_fips_all: '05145|05023',
    county: 'White',
    county_names_all: 'White|Cleburne',
    county_weights: '{"05145": 80.54, "05023": 19.46}',
    density: 19.8,
    imprecise: false,
    latitude: 35.45561,
    longitude: -91.78525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72121',
  },
  {
    city: 'Paron',
    county_fips: 5125,
    county_fips_all: '05125|05119',
    county: 'Saline',
    county_names_all: 'Saline|Pulaski',
    county_weights: '{"05125": 89.97, "05119": 10.03}',
    density: 4.5,
    imprecise: false,
    latitude: 34.77955,
    longitude: -92.77549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72122',
  },
  {
    city: 'Patterson',
    county_fips: 5147,
    county_fips_all: '05147',
    county: 'Woodruff',
    county_names_all: 'Woodruff',
    county_weights: '{"05147": 100}',
    density: 134.1,
    imprecise: false,
    latitude: 35.25774,
    longitude: -91.23675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72123',
  },
  {
    city: 'Perry',
    county_fips: 5105,
    county_fips_all: '05105|05029',
    county: 'Perry',
    county_names_all: 'Perry|Conway',
    county_weights: '{"05105": 61.96, "05029": 38.04}',
    density: 13.2,
    imprecise: false,
    latitude: 35.06421,
    longitude: -92.794,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72125',
  },
  {
    city: 'Perryville',
    county_fips: 5105,
    county_fips_all: '05105|05119',
    county: 'Perry',
    county_names_all: 'Perry|Pulaski',
    county_weights: '{"05105": 95.58, "05119": 4.42}',
    density: 6.2,
    imprecise: false,
    latitude: 34.9376,
    longitude: -92.91024,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72126',
  },
  {
    city: 'Plumerville',
    county_fips: 5029,
    county_fips_all: '05029',
    county: 'Conway',
    county_names_all: 'Conway',
    county_weights: '{"05029": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 35.16237,
    longitude: -92.59419,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72127',
  },
  {
    city: 'Poyen',
    county_fips: 5053,
    county_fips_all: '05053',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"05053": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 34.31535,
    longitude: -92.63846,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72128',
  },
  {
    city: 'Prattsville',
    county_fips: 5053,
    county_fips_all: '05053',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"05053": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 34.31215,
    longitude: -92.55406,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72129',
  },
  {
    city: 'Prim',
    county_fips: 5023,
    county_fips_all: '05023',
    county: 'Cleburne',
    county_names_all: 'Cleburne',
    county_weights: '{"05023": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 35.6673,
    longitude: -92.06997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72130',
  },
  {
    city: 'Quitman',
    county_fips: 5023,
    county_fips_all: '05023|05045|05141',
    county: 'Cleburne',
    county_names_all: 'Cleburne|Faulkner|Van Buren',
    county_weights: '{"05023": 66.87, "05045": 25.85, "05141": 7.28}',
    density: 13.8,
    imprecise: false,
    latitude: 35.40792,
    longitude: -92.19362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72131',
  },
  {
    city: 'Redfield',
    county_fips: 5069,
    county_fips_all: '05069|05053',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Grant',
    county_weights: '{"05069": 57.5, "05053": 42.5}',
    density: 20.3,
    imprecise: false,
    latitude: 34.44,
    longitude: -92.19468,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72132',
  },
  {
    city: 'Reydell',
    county_fips: 5069,
    county_fips_all: '05069',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"05069": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.10821,
    longitude: -91.53718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72133',
  },
  {
    city: 'Roe',
    county_fips: 5095,
    county_fips_all: '05095|05001',
    county: 'Monroe',
    county_names_all: 'Monroe|Arkansas',
    county_weights: '{"05095": 91.72, "05001": 8.28}',
    density: 3.2,
    imprecise: false,
    latitude: 34.61189,
    longitude: -91.37247,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72134',
  },
  {
    city: 'Roland',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 17,
    imprecise: false,
    latitude: 34.87698,
    longitude: -92.56087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72135',
  },
  {
    city: 'Romance',
    county_fips: 5145,
    county_fips_all: '05145',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"05145": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 35.23538,
    longitude: -92.02129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72136',
  },
  {
    city: 'Rose Bud',
    county_fips: 5145,
    county_fips_all: '05145|05023',
    county: 'White',
    county_names_all: 'White|Cleburne',
    county_weights: '{"05145": 77.02, "05023": 22.98}',
    density: 13,
    imprecise: false,
    latitude: 35.33756,
    longitude: -92.02933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72137',
  },
  {
    city: 'Russell',
    county_fips: 5145,
    county_fips_all: '05145',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"05145": 100}',
    density: 412,
    imprecise: false,
    latitude: 35.36212,
    longitude: -91.50997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72139',
  },
  {
    city: 'Saint Charles',
    county_fips: 5001,
    county_fips_all: '05001',
    county: 'Arkansas',
    county_names_all: 'Arkansas',
    county_weights: '{"05001": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 34.36052,
    longitude: -91.1549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72140',
  },
  {
    city: 'Scotland',
    county_fips: 5141,
    county_fips_all: '05141',
    county: 'Van Buren',
    county_names_all: 'Van Buren',
    county_weights: '{"05141": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 35.51824,
    longitude: -92.69158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72141',
  },
  {
    city: 'Scott',
    county_fips: 5085,
    county_fips_all: '05085|05119',
    county: 'Lonoke',
    county_names_all: 'Lonoke|Pulaski',
    county_weights: '{"05085": 58.32, "05119": 41.68}',
    density: 9.4,
    imprecise: false,
    latitude: 34.67681,
    longitude: -92.07488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72142',
  },
  {
    city: 'Searcy',
    county_fips: 5145,
    county_fips_all: '05145|05023',
    county: 'White',
    county_names_all: 'White|Cleburne',
    county_weights: '{"05145": 97.49, "05023": 2.51}',
    density: 44.7,
    imprecise: false,
    latitude: 35.2279,
    longitude: -91.73613,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72143',
  },
  {
    city: 'Sheridan',
    county_fips: 5053,
    county_fips_all: '05053|05069',
    county: 'Grant',
    county_names_all: 'Grant|Jefferson',
    county_weights: '{"05053": 99.28, "05069": 0.72}',
    density: 16.2,
    imprecise: false,
    latitude: 34.30999,
    longitude: -92.39642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72150',
  },
  {
    city: 'Sherrill',
    county_fips: 5069,
    county_fips_all: '05069',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"05069": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 34.35194,
    longitude: -91.98009,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72152',
  },
  {
    city: 'Shirley',
    county_fips: 5141,
    county_fips_all: '05141|05137|05023',
    county: 'Van Buren',
    county_names_all: 'Van Buren|Stone|Cleburne',
    county_weights: '{"05141": 78.65, "05137": 15.13, "05023": 6.22}',
    density: 16.1,
    imprecise: false,
    latitude: 35.65651,
    longitude: -92.31988,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72153',
  },
  {
    city: 'Solgohachia',
    county_fips: 5029,
    county_fips_all: '05029',
    county: 'Conway',
    county_names_all: 'Conway',
    county_weights: '{"05029": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 35.28595,
    longitude: -92.68331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72156',
  },
  {
    city: 'Springfield',
    county_fips: 5029,
    county_fips_all: '05029',
    county: 'Conway',
    county_names_all: 'Conway',
    county_weights: '{"05029": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 35.2714,
    longitude: -92.56412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72157',
  },
  {
    city: 'Stuttgart',
    county_fips: 5001,
    county_fips_all: '05001|05117|05069|05085',
    county: 'Arkansas',
    county_names_all: 'Arkansas|Prairie|Jefferson|Lonoke',
    county_weights:
      '{"05001": 59.71, "05117": 28.82, "05069": 10.53, "05085": 0.94}',
    density: 11,
    imprecise: false,
    latitude: 34.44284,
    longitude: -91.53136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72160',
  },
  {
    city: 'Thida',
    county_fips: 5063,
    county_fips_all: '05063',
    county: 'Independence',
    county_names_all: 'Independence',
    county_weights: '{"05063": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 35.57657,
    longitude: -91.46647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72165',
  },
  {
    city: 'Tichnor',
    county_fips: 5001,
    county_fips_all: '05001',
    county: 'Arkansas',
    county_names_all: 'Arkansas',
    county_weights: '{"05001": 100}',
    density: 1,
    imprecise: false,
    latitude: 34.04821,
    longitude: -91.23711,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72166',
  },
  {
    city: 'Traskwood',
    county_fips: 5125,
    county_fips_all: '05125|05053|05059',
    county: 'Saline',
    county_names_all: 'Saline|Grant|Hot Spring',
    county_weights: '{"05125": 46.1, "05053": 35.04, "05059": 18.86}',
    density: 12.5,
    imprecise: false,
    latitude: 34.42223,
    longitude: -92.65477,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72167',
  },
  {
    city: 'Tucker',
    county_fips: 5069,
    county_fips_all: '05069',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"05069": 100}',
    density: 21.6,
    imprecise: false,
    latitude: 34.43719,
    longitude: -91.96771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72168',
  },
  {
    city: 'Tupelo',
    county_fips: 5067,
    county_fips_all: '05067',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"05067": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 35.3946,
    longitude: -91.22703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72169',
  },
  {
    city: 'Ulm',
    county_fips: 5117,
    county_fips_all: '05117',
    county: 'Prairie',
    county_names_all: 'Prairie',
    county_weights: '{"05117": 100}',
    density: 13,
    imprecise: false,
    latitude: 34.57819,
    longitude: -91.42655,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72170',
  },
  {
    city: 'Vilonia',
    county_fips: 5045,
    county_fips_all: '05045',
    county: 'Faulkner',
    county_names_all: 'Faulkner',
    county_weights: '{"05045": 100}',
    density: 40.6,
    imprecise: false,
    latitude: 35.10001,
    longitude: -92.20807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72173',
  },
  {
    city: 'Wabbaseka',
    county_fips: 5069,
    county_fips_all: '05069|05001',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Arkansas',
    county_weights: '{"05069": 95.94, "05001": 4.06}',
    density: 3.3,
    imprecise: false,
    latitude: 34.33792,
    longitude: -91.75495,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72175',
  },
  {
    city: 'Ward',
    county_fips: 5085,
    county_fips_all: '05085|05117',
    county: 'Lonoke',
    county_names_all: 'Lonoke|Prairie',
    county_weights: '{"05085": 67.06, "05117": 32.94}',
    density: 47.6,
    imprecise: false,
    latitude: 35.00279,
    longitude: -91.84212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72176',
  },
  {
    city: 'West Point',
    county_fips: 5145,
    county_fips_all: '05145',
    county: 'White',
    county_names_all: 'White',
    county_weights: '{"05145": 100}',
    density: 84,
    imprecise: false,
    latitude: 35.20381,
    longitude: -91.61265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72178',
  },
  {
    city: 'Wilburn',
    county_fips: 5023,
    county_fips_all: '05023',
    county: 'Cleburne',
    county_names_all: 'Cleburne',
    county_weights: '{"05023": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 35.49773,
    longitude: -91.86565,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72179',
  },
  {
    city: 'Woodson',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 298.9,
    imprecise: false,
    latitude: 34.53104,
    longitude: -92.21495,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72180',
  },
  {
    city: 'Wooster',
    county_fips: 5045,
    county_fips_all: '05045',
    county: 'Faulkner',
    county_names_all: 'Faulkner',
    county_weights: '{"05045": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 35.16237,
    longitude: -92.44503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72181',
  },
  {
    city: 'Wright',
    county_fips: 5069,
    county_fips_all: '05069',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"05069": 100}',
    density: 2,
    imprecise: false,
    latitude: 34.43161,
    longitude: -92.08721,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72182',
  },
  {
    city: 'Wrightsville',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 2042.7,
    imprecise: false,
    latitude: 34.60002,
    longitude: -92.19305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72183',
  },
  {
    city: 'Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 250.5,
    imprecise: false,
    latitude: 34.74725,
    longitude: -92.28053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72201',
  },
  {
    city: 'Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 529.4,
    imprecise: false,
    latitude: 34.74626,
    longitude: -92.27016,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72202',
  },
  {
    city: 'Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 777.4,
    imprecise: false,
    latitude: 34.71739,
    longitude: -92.3582,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72204',
  },
  {
    city: 'Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 1107.4,
    imprecise: false,
    latitude: 34.74948,
    longitude: -92.3524,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72205',
  },
  {
    city: 'Little Rock',
    county_fips: 5119,
    county_fips_all: '05119|05125',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Saline',
    county_weights: '{"05119": 94.91, "05125": 5.09}',
    density: 78.4,
    imprecise: false,
    latitude: 34.63042,
    longitude: -92.23833,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72206',
  },
  {
    city: 'Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 1084.5,
    imprecise: false,
    latitude: 34.77493,
    longitude: -92.34271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72207',
  },
  {
    city: 'Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 668.2,
    imprecise: false,
    latitude: 34.6805,
    longitude: -92.33974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72209',
  },
  {
    city: 'Little Rock',
    county_fips: 5119,
    county_fips_all: '05119|05125',
    county: 'Pulaski',
    county_names_all: 'Pulaski|Saline',
    county_weights: '{"05119": 72.84, "05125": 27.16}',
    density: 121.9,
    imprecise: false,
    latitude: 34.71506,
    longitude: -92.50378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72210',
  },
  {
    city: 'Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 1037.9,
    imprecise: false,
    latitude: 34.74792,
    longitude: -92.41675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72211',
  },
  {
    city: 'Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 869,
    imprecise: false,
    latitude: 34.78498,
    longitude: -92.4141,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72212',
  },
  {
    city: 'Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 214.8,
    imprecise: false,
    latitude: 34.79251,
    longitude: -92.49091,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72223',
  },
  {
    city: 'Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 1157.8,
    imprecise: false,
    latitude: 34.7782,
    longitude: -92.37498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72227',
  },
  {
    city: 'West Memphis',
    county_fips: 5035,
    county_fips_all: '05035',
    county: 'Crittenden',
    county_names_all: 'Crittenden',
    county_weights: '{"05035": 100}',
    density: 313.2,
    imprecise: false,
    latitude: 35.13363,
    longitude: -90.17883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72301',
  },
  {
    city: 'Aubrey',
    county_fips: 5077,
    county_fips_all: '05077',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"05077": 100}',
    density: 148.8,
    imprecise: false,
    latitude: 34.72072,
    longitude: -90.89688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72311',
  },
  {
    city: 'Bassett',
    county_fips: 5093,
    county_fips_all: '05093',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"05093": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.53077,
    longitude: -90.13952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72313',
  },
  {
    city: 'Blytheville',
    county_fips: 5093,
    county_fips_all: '05093',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"05093": 100}',
    density: 30.4,
    imprecise: false,
    latitude: 35.90093,
    longitude: -89.9029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72315',
  },
  {
    city: 'Brickeys',
    county_fips: 5077,
    county_fips_all: '05077',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"05077": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 34.81439,
    longitude: -90.5411,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72320',
  },
  {
    city: 'Caldwell',
    county_fips: 5123,
    county_fips_all: '05123',
    county: 'St. Francis',
    county_names_all: 'St. Francis',
    county_weights: '{"05123": 100}',
    density: 128,
    imprecise: false,
    latitude: 35.0688,
    longitude: -90.808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72322',
  },
  {
    city: 'Cherry Valley',
    county_fips: 5037,
    county_fips_all: '05037|05111',
    county: 'Cross',
    county_names_all: 'Cross|Poinsett',
    county_weights: '{"05037": 96.48, "05111": 3.52}',
    density: 6.1,
    imprecise: false,
    latitude: 35.38872,
    longitude: -90.78116,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72324',
  },
  {
    city: 'Clarkedale',
    county_fips: 5035,
    county_fips_all: '05035',
    county: 'Crittenden',
    county_names_all: 'Crittenden',
    county_weights: '{"05035": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 35.33067,
    longitude: -90.25395,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72325',
  },
  {
    city: 'Colt',
    county_fips: 5123,
    county_fips_all: '05123|05037',
    county: 'St. Francis',
    county_names_all: 'St. Francis|Cross',
    county_weights: '{"05123": 93.23, "05037": 6.77}',
    density: 8,
    imprecise: false,
    latitude: 35.11183,
    longitude: -90.89333,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72326',
  },
  {
    city: 'Crawfordsville',
    county_fips: 5035,
    county_fips_all: '05035',
    county: 'Crittenden',
    county_names_all: 'Crittenden',
    county_weights: '{"05035": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 35.2401,
    longitude: -90.32783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72327',
  },
  {
    city: 'Crumrod',
    county_fips: 5041,
    county_fips_all: '05041|05107',
    county: 'Desha',
    county_names_all: 'Desha|Phillips',
    county_weights: '{"05041": 72.88, "05107": 27.12}',
    density: 0.3,
    imprecise: false,
    latitude: 34.0684,
    longitude: -91.0057,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72328',
  },
  {
    city: 'Dyess',
    county_fips: 5093,
    county_fips_all: '05093',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"05093": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 35.59136,
    longitude: -90.20184,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72330',
  },
  {
    city: 'Earle',
    county_fips: 5035,
    county_fips_all: '05035|05037',
    county: 'Crittenden',
    county_names_all: 'Crittenden|Cross',
    county_weights: '{"05035": 66.69, "05037": 33.31}',
    density: 6,
    imprecise: false,
    latitude: 35.28537,
    longitude: -90.46733,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72331',
  },
  {
    city: 'Edmondson',
    county_fips: 5035,
    county_fips_all: '05035',
    county: 'Crittenden',
    county_names_all: 'Crittenden',
    county_weights: '{"05035": 100}',
    density: 169.4,
    imprecise: false,
    latitude: 35.10117,
    longitude: -90.30238,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72332',
  },
  {
    city: 'Elaine',
    county_fips: 5107,
    county_fips_all: '05107',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"05107": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 34.29004,
    longitude: -90.86971,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72333',
  },
  {
    city: 'Forrest City',
    county_fips: 5123,
    county_fips_all: '05123|05077',
    county: 'St. Francis',
    county_names_all: 'St. Francis|Lee',
    county_weights: '{"05123": 95.71, "05077": 4.29}',
    density: 39.8,
    imprecise: false,
    latitude: 34.99042,
    longitude: -90.75645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72335',
  },
  {
    city: 'Frenchmans Bayou',
    county_fips: 47167,
    county_fips_all: '47167|05093',
    county: 'Tipton',
    county_names_all: 'Tipton|Mississippi',
    county_weights: '{"47167": 66.75, "05093": 33.25}',
    density: 0.1,
    imprecise: false,
    latitude: 35.43657,
    longitude: -90.13863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72338',
  },
  {
    city: 'Gilmore',
    county_fips: 5035,
    county_fips_all: '05035',
    county: 'Crittenden',
    county_names_all: 'Crittenden',
    county_weights: '{"05035": 100}',
    density: 57.4,
    imprecise: false,
    latitude: 35.41606,
    longitude: -90.26492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72339',
  },
  {
    city: 'Goodwin',
    county_fips: 5123,
    county_fips_all: '05123',
    county: 'St. Francis',
    county_names_all: 'St. Francis',
    county_weights: '{"05123": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 34.95687,
    longitude: -91.03202,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72340',
  },
  {
    city: 'Haynes',
    county_fips: 5077,
    county_fips_all: '05077',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"05077": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 34.88746,
    longitude: -90.7705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72341',
  },
  {
    city: 'Helena',
    county_fips: 5107,
    county_fips_all: '05107',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"05107": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 34.44492,
    longitude: -90.67733,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72342',
  },
  {
    city: 'Heth',
    county_fips: 5123,
    county_fips_all: '05123|05035|05037',
    county: 'St. Francis',
    county_names_all: 'St. Francis|Crittenden|Cross',
    county_weights: '{"05123": 90.79, "05035": 6.7, "05037": 2.51}',
    density: 2.3,
    imprecise: false,
    latitude: 35.08462,
    longitude: -90.48198,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72346',
  },
  {
    city: 'Hickory Ridge',
    county_fips: 5037,
    county_fips_all: '05037|05067',
    county: 'Cross',
    county_names_all: 'Cross|Jackson',
    county_weights: '{"05037": 76.9, "05067": 23.1}',
    density: 2.9,
    imprecise: false,
    latitude: 35.38415,
    longitude: -90.99892,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72347',
  },
  {
    city: 'Hughes',
    county_fips: 5035,
    county_fips_all: '05035|05123|05077',
    county: 'Crittenden',
    county_names_all: 'Crittenden|St. Francis|Lee',
    county_weights: '{"05035": 50.64, "05123": 38.22, "05077": 11.14}',
    density: 4.8,
    imprecise: false,
    latitude: 34.93739,
    longitude: -90.42016,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72348',
  },
  {
    city: 'Joiner',
    county_fips: 5093,
    county_fips_all: '05093',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"05093": 100}',
    density: 5,
    imprecise: false,
    latitude: 35.50181,
    longitude: -90.11782,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72350',
  },
  {
    city: 'Keiser',
    county_fips: 5093,
    county_fips_all: '05093',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"05093": 100}',
    density: 56.5,
    imprecise: false,
    latitude: 35.67595,
    longitude: -90.09771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72351',
  },
  {
    city: 'La Grange',
    county_fips: 5077,
    county_fips_all: '05077',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"05077": 100}',
    density: 69,
    imprecise: false,
    latitude: 34.65562,
    longitude: -90.7344,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72352',
  },
  {
    city: 'Lambrook',
    county_fips: 5107,
    county_fips_all: '05107',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"05107": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 34.3162,
    longitude: -91.00708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72353',
  },
  {
    city: 'Lepanto',
    county_fips: 5111,
    county_fips_all: '05111|05093',
    county: 'Poinsett',
    county_names_all: 'Poinsett|Mississippi',
    county_weights: '{"05111": 77.88, "05093": 22.12}',
    density: 15.7,
    imprecise: false,
    latitude: 35.63118,
    longitude: -90.31797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72354',
  },
  {
    city: 'Lexa',
    county_fips: 5107,
    county_fips_all: '05107|05077',
    county: 'Phillips',
    county_names_all: 'Phillips|Lee',
    county_weights: '{"05107": 92.61, "05077": 7.39}',
    density: 5.8,
    imprecise: false,
    latitude: 34.53902,
    longitude: -90.77789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72355',
  },
  {
    city: 'Luxora',
    county_fips: 5093,
    county_fips_all: '05093',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"05093": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 35.79446,
    longitude: -89.87723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72358',
  },
  {
    city: 'Madison',
    county_fips: 5123,
    county_fips_all: '05123',
    county: 'St. Francis',
    county_names_all: 'St. Francis',
    county_weights: '{"05123": 100}',
    density: 80.5,
    imprecise: false,
    latitude: 35.01422,
    longitude: -90.7239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72359',
  },
  {
    city: 'Marianna',
    county_fips: 5077,
    county_fips_all: '05077',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"05077": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 34.75352,
    longitude: -90.78875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72360',
  },
  {
    city: 'Marion',
    county_fips: 5035,
    county_fips_all: '05035',
    county: 'Crittenden',
    county_names_all: 'Crittenden',
    county_weights: '{"05035": 100}',
    density: 77.4,
    imprecise: false,
    latitude: 35.2126,
    longitude: -90.18573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72364',
  },
  {
    city: 'Marked Tree',
    county_fips: 5111,
    county_fips_all: '05111',
    county: 'Poinsett',
    county_names_all: 'Poinsett',
    county_weights: '{"05111": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 35.56181,
    longitude: -90.41857,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72365',
  },
  {
    city: 'Marvell',
    county_fips: 5107,
    county_fips_all: '05107|05095|05077',
    county: 'Phillips',
    county_names_all: 'Phillips|Monroe|Lee',
    county_weights: '{"05107": 93.6, "05095": 3.83, "05077": 2.57}',
    density: 5.7,
    imprecise: false,
    latitude: 34.52612,
    longitude: -90.95307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72366',
  },
  {
    city: 'Mellwood',
    county_fips: 5107,
    county_fips_all: '05107',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"05107": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.1891,
    longitude: -91.02567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72367',
  },
  {
    city: 'Moro',
    county_fips: 5077,
    county_fips_all: '05077|05095',
    county: 'Lee',
    county_names_all: 'Lee|Monroe',
    county_weights: '{"05077": 85.48, "05095": 14.52}',
    density: 3.2,
    imprecise: false,
    latitude: 34.81146,
    longitude: -91.01996,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72368',
  },
  {
    city: 'Oneida',
    county_fips: 5107,
    county_fips_all: '05107',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"05107": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.45522,
    longitude: -90.78954,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72369',
  },
  {
    city: 'Osceola',
    county_fips: 5093,
    county_fips_all: '05093',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"05093": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 35.68443,
    longitude: -90.07734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72370',
  },
  {
    city: 'Palestine',
    county_fips: 5123,
    county_fips_all: '05123|05077',
    county: 'St. Francis',
    county_names_all: 'St. Francis|Lee',
    county_weights: '{"05123": 79.84, "05077": 20.16}',
    density: 5,
    imprecise: false,
    latitude: 34.96623,
    longitude: -90.94726,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72372',
  },
  {
    city: 'Parkin',
    county_fips: 5037,
    county_fips_all: '05037',
    county: 'Cross',
    county_names_all: 'Cross',
    county_weights: '{"05037": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 35.28861,
    longitude: -90.60269,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72373',
  },
  {
    city: 'Poplar Grove',
    county_fips: 5107,
    county_fips_all: '05107|05077',
    county: 'Phillips',
    county_names_all: 'Phillips|Lee',
    county_weights: '{"05107": 98.28, "05077": 1.72}',
    density: 5.2,
    imprecise: false,
    latitude: 34.56126,
    longitude: -90.83996,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72374',
  },
  {
    city: 'Proctor',
    county_fips: 5035,
    county_fips_all: '05035|05123',
    county: 'Crittenden',
    county_names_all: 'Crittenden|St. Francis',
    county_weights: '{"05035": 97.01, "05123": 2.99}',
    density: 6.7,
    imprecise: false,
    latitude: 35.0883,
    longitude: -90.30625,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72376',
  },
  {
    city: 'Rivervale',
    county_fips: 5111,
    county_fips_all: '05111',
    county: 'Poinsett',
    county_names_all: 'Poinsett',
    county_weights: '{"05111": 100}',
    density: 190.7,
    imprecise: false,
    latitude: 35.67392,
    longitude: -90.34158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72377',
  },
  {
    city: 'Snow Lake',
    county_fips: 5041,
    county_fips_all: '05041|05107',
    county: 'Desha',
    county_names_all: 'Desha|Phillips',
    county_weights: '{"05041": 99.87, "05107": 0.13}',
    density: 0.2,
    imprecise: false,
    latitude: 34.07479,
    longitude: -91.05019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72379',
  },
  {
    city: 'Turner',
    county_fips: 5107,
    county_fips_all: '05107',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"05107": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 34.49117,
    longitude: -91.03962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72383',
  },
  {
    city: 'Turrell',
    county_fips: 5035,
    county_fips_all: '05035',
    county: 'Crittenden',
    county_names_all: 'Crittenden',
    county_weights: '{"05035": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 35.37487,
    longitude: -90.21825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72384',
  },
  {
    city: 'Tyronza',
    county_fips: 5111,
    county_fips_all: '05111|05035|05093',
    county: 'Poinsett',
    county_names_all: 'Poinsett|Crittenden|Mississippi',
    county_weights: '{"05111": 41.91, "05035": 35.34, "05093": 22.75}',
    density: 4.4,
    imprecise: false,
    latitude: 35.45548,
    longitude: -90.36183,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72386',
  },
  {
    city: 'Vanndale',
    county_fips: 5037,
    county_fips_all: '05037',
    county: 'Cross',
    county_names_all: 'Cross',
    county_weights: '{"05037": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.31572,
    longitude: -90.77274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72387',
  },
  {
    city: 'Wabash',
    county_fips: 5107,
    county_fips_all: '05107',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"05107": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 34.36985,
    longitude: -90.88596,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72389',
  },
  {
    city: 'West Helena',
    county_fips: 5107,
    county_fips_all: '05107',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"05107": 100}',
    density: 76.1,
    imprecise: false,
    latitude: 34.55426,
    longitude: -90.67756,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72390',
  },
  {
    city: 'West Ridge',
    county_fips: 5093,
    county_fips_all: '05093',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"05093": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 35.6765,
    longitude: -90.26953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72391',
  },
  {
    city: 'Wheatley',
    county_fips: 5123,
    county_fips_all: '05123|05147|05095',
    county: 'St. Francis',
    county_names_all: 'St. Francis|Woodruff|Monroe',
    county_weights: '{"05123": 88.27, "05147": 7.47, "05095": 4.26}',
    density: 4,
    imprecise: false,
    latitude: 34.95551,
    longitude: -91.09466,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72392',
  },
  {
    city: 'Widener',
    county_fips: 5123,
    county_fips_all: '05123',
    county: 'St. Francis',
    county_names_all: 'St. Francis',
    county_weights: '{"05123": 100}',
    density: 2,
    imprecise: false,
    latitude: 35.05271,
    longitude: -90.61599,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72394',
  },
  {
    city: 'Wilson',
    county_fips: 5093,
    county_fips_all: '05093',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"05093": 100}',
    density: 7,
    imprecise: false,
    latitude: 35.59149,
    longitude: -90.02036,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72395',
  },
  {
    city: 'Wynne',
    county_fips: 5037,
    county_fips_all: '05037|05123',
    county: 'Cross',
    county_names_all: 'Cross|St. Francis',
    county_weights: '{"05037": 94.76, "05123": 5.24}',
    density: 20.3,
    imprecise: false,
    latitude: 35.22966,
    longitude: -90.83559,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72396',
  },
  {
    city: 'Jonesboro',
    county_fips: 5031,
    county_fips_all: '05031|05055',
    county: 'Craighead',
    county_names_all: 'Craighead|Greene',
    county_weights: '{"05031": 90.71, "05055": 9.29}',
    density: 185.9,
    imprecise: false,
    latitude: 35.86835,
    longitude: -90.66193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72401',
  },
  {
    city: 'Jonesboro',
    county_fips: 5031,
    county_fips_all: '05031',
    county: 'Craighead',
    county_names_all: 'Craighead',
    county_weights: '{"05031": 100}',
    density: 90.4,
    imprecise: false,
    latitude: 35.77656,
    longitude: -90.78356,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72404',
  },
  {
    city: 'Jonesboro',
    county_fips: 5031,
    county_fips_all: '05031',
    county: 'Craighead',
    county_names_all: 'Craighead',
    county_weights: '{"05031": 100}',
    density: 200.9,
    imprecise: false,
    latitude: 35.90446,
    longitude: -90.64869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72405',
  },
  {
    city: 'Alicia',
    county_fips: 5075,
    county_fips_all: '05075',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"05075": 100}',
    density: 2,
    imprecise: false,
    latitude: 35.93854,
    longitude: -91.09432,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72410',
  },
  {
    city: 'Bay',
    county_fips: 5031,
    county_fips_all: '05031',
    county: 'Craighead',
    county_names_all: 'Craighead',
    county_weights: '{"05031": 100}',
    density: 32,
    imprecise: false,
    latitude: 35.74165,
    longitude: -90.58019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72411',
  },
  {
    city: 'Beech Grove',
    county_fips: 5055,
    county_fips_all: '05055',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"05055": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 36.12572,
    longitude: -90.69172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72412',
  },
  {
    city: 'Biggers',
    county_fips: 5121,
    county_fips_all: '05121|05021',
    county: 'Randolph',
    county_names_all: 'Randolph|Clay',
    county_weights: '{"05121": 80.42, "05021": 19.58}',
    density: 3.6,
    imprecise: false,
    latitude: 36.30564,
    longitude: -90.81251,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72413',
  },
  {
    city: 'Black Oak',
    county_fips: 5031,
    county_fips_all: '05031',
    county: 'Craighead',
    county_names_all: 'Craighead',
    county_weights: '{"05031": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 35.82288,
    longitude: -90.368,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72414',
  },
  {
    city: 'Black Rock',
    county_fips: 5075,
    county_fips_all: '05075',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"05075": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 36.12643,
    longitude: -91.17745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72415',
  },
  {
    city: 'Bono',
    county_fips: 5031,
    county_fips_all: '05031|05055',
    county: 'Craighead',
    county_names_all: 'Craighead|Greene',
    county_weights: '{"05031": 55.15, "05055": 44.85}',
    density: 24.6,
    imprecise: false,
    latitude: 35.95731,
    longitude: -90.79699,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72416',
  },
  {
    city: 'Brookland',
    county_fips: 5031,
    county_fips_all: '05031',
    county: 'Craighead',
    county_names_all: 'Craighead',
    county_weights: '{"05031": 100}',
    density: 53.3,
    imprecise: false,
    latitude: 35.91994,
    longitude: -90.54791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72417',
  },
  {
    city: 'Caraway',
    county_fips: 5031,
    county_fips_all: '05031|05111',
    county: 'Craighead',
    county_names_all: 'Craighead|Poinsett',
    county_weights: '{"05031": 95.01, "05111": 4.99}',
    density: 10.6,
    imprecise: false,
    latitude: 35.74158,
    longitude: -90.35544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72419',
  },
  {
    city: 'Cash',
    county_fips: 5031,
    county_fips_all: '05031|05111',
    county: 'Craighead',
    county_names_all: 'Craighead|Poinsett',
    county_weights: '{"05031": 92.32, "05111": 7.68}',
    density: 3,
    imprecise: false,
    latitude: 35.77851,
    longitude: -90.97869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72421',
  },
  {
    city: 'Corning',
    county_fips: 5021,
    county_fips_all: '05021',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"05021": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 36.41893,
    longitude: -90.54385,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72422',
  },
  {
    city: 'Datto',
    county_fips: 5021,
    county_fips_all: '05021',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"05021": 100}',
    density: 46.1,
    imprecise: false,
    latitude: 36.39185,
    longitude: -90.72874,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 67,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72424',
  },
  {
    city: 'Delaplaine',
    county_fips: 5055,
    county_fips_all: '05055|05121',
    county: 'Greene',
    county_names_all: 'Greene|Randolph',
    county_weights: '{"05055": 82.19, "05121": 17.81}',
    density: 2.1,
    imprecise: false,
    latitude: 36.22138,
    longitude: -90.74308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72425',
  },
  {
    city: 'Dell',
    county_fips: 5093,
    county_fips_all: '05093',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"05093": 100}',
    density: 168,
    imprecise: false,
    latitude: 35.85608,
    longitude: -90.04159,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72426',
  },
  {
    city: 'Egypt',
    county_fips: 5031,
    county_fips_all: '05031',
    county: 'Craighead',
    county_names_all: 'Craighead',
    county_weights: '{"05031": 100}',
    density: 73.1,
    imprecise: false,
    latitude: 35.86872,
    longitude: -90.94901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72427',
  },
  {
    city: 'Etowah',
    county_fips: 5093,
    county_fips_all: '05093',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"05093": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 35.7414,
    longitude: -90.21672,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72428',
  },
  {
    city: 'Fisher',
    county_fips: 5111,
    county_fips_all: '05111',
    county: 'Poinsett',
    county_names_all: 'Poinsett',
    county_weights: '{"05111": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 35.48895,
    longitude: -90.93972,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72429',
  },
  {
    city: 'Greenway',
    county_fips: 5021,
    county_fips_all: '05021',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"05021": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 36.336,
    longitude: -90.17366,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72430',
  },
  {
    city: 'Grubbs',
    county_fips: 5067,
    county_fips_all: '05067',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"05067": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 35.63396,
    longitude: -91.08184,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72431',
  },
  {
    city: 'Harrisburg',
    county_fips: 5111,
    county_fips_all: '05111',
    county: 'Poinsett',
    county_names_all: 'Poinsett',
    county_weights: '{"05111": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 35.55438,
    longitude: -90.72457,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72432',
  },
  {
    city: 'Hoxie',
    county_fips: 5075,
    county_fips_all: '05075',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"05075": 100}',
    density: 20.7,
    imprecise: false,
    latitude: 36.02582,
    longitude: -91.04446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72433',
  },
  {
    city: 'Imboden',
    county_fips: 5121,
    county_fips_all: '05121|05075',
    county: 'Randolph',
    county_names_all: 'Randolph|Lawrence',
    county_weights: '{"05121": 68.13, "05075": 31.87}',
    density: 8.4,
    imprecise: false,
    latitude: 36.21847,
    longitude: -91.16025,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72434',
  },
  {
    city: 'Knobel',
    county_fips: 5021,
    county_fips_all: '05021',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"05021": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 36.31177,
    longitude: -90.54593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72435',
  },
  {
    city: 'Lafe',
    county_fips: 5055,
    county_fips_all: '05055|05021',
    county: 'Greene',
    county_names_all: 'Greene|Clay',
    county_weights: '{"05055": 70.61, "05021": 29.39}',
    density: 11.1,
    imprecise: false,
    latitude: 36.23574,
    longitude: -90.48281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72436',
  },
  {
    city: 'Lake City',
    county_fips: 5031,
    county_fips_all: '05031',
    county: 'Craighead',
    county_names_all: 'Craighead',
    county_weights: '{"05031": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 35.8343,
    longitude: -90.45401,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72437',
  },
  {
    city: 'Leachville',
    county_fips: 5093,
    county_fips_all: '05093|05031',
    county: 'Mississippi',
    county_names_all: 'Mississippi|Craighead',
    county_weights: '{"05093": 92.95, "05031": 7.05}',
    density: 14.6,
    imprecise: false,
    latitude: 35.94375,
    longitude: -90.22787,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72438',
  },
  {
    city: 'Lynn',
    county_fips: 5075,
    county_fips_all: '05075',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"05075": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 35.9924,
    longitude: -91.26466,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72440',
  },
  {
    city: 'McDougal',
    county_fips: 5021,
    county_fips_all: '05021',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"05021": 100}',
    density: 143.9,
    imprecise: false,
    latitude: 36.4355,
    longitude: -90.38944,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72441',
  },
  {
    city: 'Manila',
    county_fips: 5093,
    county_fips_all: '05093',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"05093": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 35.82458,
    longitude: -90.17948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72442',
  },
  {
    city: 'Marmaduke',
    county_fips: 5055,
    county_fips_all: '05055',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"05055": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 36.1812,
    longitude: -90.41037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72443',
  },
  {
    city: 'Maynard',
    county_fips: 5121,
    county_fips_all: '05121',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"05121": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 36.4266,
    longitude: -90.86106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72444',
  },
  {
    city: 'Minturn',
    county_fips: 5075,
    county_fips_all: '05075',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"05075": 100}',
    density: 80.8,
    imprecise: false,
    latitude: 35.97812,
    longitude: -91.02669,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72445',
  },
  {
    city: 'Monette',
    county_fips: 5031,
    county_fips_all: '05031',
    county: 'Craighead',
    county_names_all: 'Craighead',
    county_weights: '{"05031": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 35.9102,
    longitude: -90.33428,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72447',
  },
  {
    city: "O'Kean",
    county_fips: 5121,
    county_fips_all: '05121|05055',
    county: 'Randolph',
    county_names_all: 'Randolph|Greene',
    county_weights: '{"05121": 99.82, "05055": 0.18}',
    density: 50.4,
    imprecise: false,
    latitude: 36.16662,
    longitude: -90.81719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72449',
  },
  {
    city: 'Paragould',
    county_fips: 5055,
    county_fips_all: '05055|05031',
    county: 'Greene',
    county_names_all: 'Greene|Craighead',
    county_weights: '{"05055": 98.29, "05031": 1.71}',
    density: 55.2,
    imprecise: false,
    latitude: 36.0784,
    longitude: -90.51695,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72450',
  },
  {
    city: 'Peach Orchard',
    county_fips: 5021,
    county_fips_all: '05021|05055',
    county: 'Clay',
    county_names_all: 'Clay|Greene',
    county_weights: '{"05021": 99.15, "05055": 0.85}',
    density: 1.8,
    imprecise: false,
    latitude: 36.30909,
    longitude: -90.67887,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72453',
  },
  {
    city: 'Piggott',
    county_fips: 5021,
    county_fips_all: '05021',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"05021": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 36.40083,
    longitude: -90.20623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72454',
  },
  {
    city: 'Pocahontas',
    county_fips: 5121,
    county_fips_all: '05121',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"05121": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 36.3229,
    longitude: -91.04909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72455',
  },
  {
    city: 'Pollard',
    county_fips: 5021,
    county_fips_all: '05021',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"05021": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 36.45362,
    longitude: -90.32217,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72456',
  },
  {
    city: 'Portia',
    county_fips: 5075,
    county_fips_all: '05075',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"05075": 100}',
    density: 698.2,
    imprecise: false,
    latitude: 36.08545,
    longitude: -91.06827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72457',
  },
  {
    city: 'Powhatan',
    county_fips: 5075,
    county_fips_all: '05075',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"05075": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 36.06844,
    longitude: -91.15619,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72458',
  },
  {
    city: 'Ravenden',
    county_fips: 5121,
    county_fips_all: '05121|05075|05135',
    county: 'Randolph',
    county_names_all: 'Randolph|Lawrence|Sharp',
    county_weights: '{"05121": 39.31, "05075": 36.56, "05135": 24.13}',
    density: 4.6,
    imprecise: false,
    latitude: 36.27904,
    longitude: -91.29976,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72459',
  },
  {
    city: 'Ravenden Springs',
    county_fips: 5121,
    county_fips_all: '05121',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"05121": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 36.35792,
    longitude: -91.15967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72460',
  },
  {
    city: 'Rector',
    county_fips: 5021,
    county_fips_all: '05021|05055',
    county: 'Clay',
    county_names_all: 'Clay|Greene',
    county_weights: '{"05021": 82.93, "05055": 17.07}',
    density: 8.2,
    imprecise: false,
    latitude: 36.26679,
    longitude: -90.28254,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72461',
  },
  {
    city: 'Reyno',
    county_fips: 5121,
    county_fips_all: '05121|05021',
    county: 'Randolph',
    county_names_all: 'Randolph|Clay',
    county_weights: '{"05121": 99.73, "05021": 0.27}',
    density: 31.4,
    imprecise: false,
    latitude: 36.38243,
    longitude: -90.75916,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72462',
  },
  {
    city: 'Saint Francis',
    county_fips: 5021,
    county_fips_all: '05021',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"05021": 100}',
    density: 146.1,
    imprecise: false,
    latitude: 36.45405,
    longitude: -90.1434,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72464',
  },
  {
    city: 'Smithville',
    county_fips: 5075,
    county_fips_all: '05075|05135',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Sharp',
    county_weights: '{"05075": 59.14, "05135": 40.86}',
    density: 4.7,
    imprecise: false,
    latitude: 36.05121,
    longitude: -91.32157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72466',
  },
  {
    city: 'State University',
    county_fips: 5031,
    county_fips_all: '05031',
    county: 'Craighead',
    county_names_all: 'Craighead',
    county_weights: '{"05031": 100}',
    density: 1426.9,
    imprecise: false,
    latitude: 35.84223,
    longitude: -90.6776,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72467',
  },
  {
    city: 'Strawberry',
    county_fips: 5075,
    county_fips_all: '05075|05135',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Sharp',
    county_weights: '{"05075": 75.51, "05135": 24.49}',
    density: 5.4,
    imprecise: false,
    latitude: 35.95367,
    longitude: -91.29949,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72469',
  },
  {
    city: 'Success',
    county_fips: 5021,
    county_fips_all: '05021',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"05021": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 36.4668,
    longitude: -90.70309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72470',
  },
  {
    city: 'Swifton',
    county_fips: 5067,
    county_fips_all: '05067',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"05067": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 35.82591,
    longitude: -91.11996,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72471',
  },
  {
    city: 'Trumann',
    county_fips: 5111,
    county_fips_all: '05111',
    county: 'Poinsett',
    county_names_all: 'Poinsett',
    county_weights: '{"05111": 100}',
    density: 21.5,
    imprecise: false,
    latitude: 35.59264,
    longitude: -90.54459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72472',
  },
  {
    city: 'Tuckerman',
    county_fips: 5067,
    county_fips_all: '05067',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"05067": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 35.73531,
    longitude: -91.17356,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72473',
  },
  {
    city: 'Walnut Ridge',
    county_fips: 5075,
    county_fips_all: '05075|05121|05031|05055',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Randolph|Craighead|Greene',
    county_weights:
      '{"05075": 82.64, "05121": 8.92, "05031": 6.17, "05055": 2.27}',
    density: 12.7,
    imprecise: false,
    latitude: 36.04533,
    longitude: -90.91692,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72476',
  },
  {
    city: 'Warm Springs',
    county_fips: 5121,
    county_fips_all: '05121',
    county: 'Randolph',
    county_names_all: 'Randolph',
    county_weights: '{"05121": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 36.46249,
    longitude: -91.05373,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72478',
  },
  {
    city: 'Weiner',
    county_fips: 5111,
    county_fips_all: '05111|05067|05031',
    county: 'Poinsett',
    county_names_all: 'Poinsett|Jackson|Craighead',
    county_weights: '{"05111": 87.86, "05067": 6.63, "05031": 5.51}',
    density: 2.3,
    imprecise: false,
    latitude: 35.62924,
    longitude: -90.90535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72479',
  },
  {
    city: 'Williford',
    county_fips: 5135,
    county_fips_all: '05135|05075',
    county: 'Sharp',
    county_names_all: 'Sharp|Lawrence',
    county_weights: '{"05135": 99.72, "05075": 0.28}',
    density: 6.6,
    imprecise: false,
    latitude: 36.26933,
    longitude: -91.36402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72482',
  },
  {
    city: 'Batesville',
    county_fips: 5063,
    county_fips_all: '05063|05065',
    county: 'Independence',
    county_names_all: 'Independence|Izard',
    county_weights: '{"05063": 99.25, "05065": 0.75}',
    density: 33.3,
    imprecise: false,
    latitude: 35.79167,
    longitude: -91.65399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72501',
  },
  {
    city: 'Horseshoe Bend',
    county_fips: 5065,
    county_fips_all: '05065|05049',
    county: 'Izard',
    county_names_all: 'Izard|Fulton',
    county_weights: '{"05065": 99.47, "05049": 0.53}',
    density: 45,
    imprecise: false,
    latitude: 36.22326,
    longitude: -91.7514,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72512',
  },
  {
    city: 'Ash Flat',
    county_fips: 5135,
    county_fips_all: '05135|05049|05065',
    county: 'Sharp',
    county_names_all: 'Sharp|Fulton|Izard',
    county_weights: '{"05135": 50.46, "05049": 36.54, "05065": 13.0}',
    density: 11.3,
    imprecise: false,
    latitude: 36.23118,
    longitude: -91.64722,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72513',
  },
  {
    city: 'Bexar',
    county_fips: 5049,
    county_fips_all: '05049|05065',
    county: 'Fulton',
    county_names_all: 'Fulton|Izard',
    county_weights: '{"05049": 99.8, "05065": 0.2}',
    density: 0,
    imprecise: false,
    latitude: 36.27634,
    longitude: -92.05644,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72515',
  },
  {
    city: 'Brockwell',
    county_fips: 5065,
    county_fips_all: '05065',
    county: 'Izard',
    county_names_all: 'Izard',
    county_weights: '{"05065": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 36.1463,
    longitude: -91.95403,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 86,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72517',
  },
  {
    city: 'Calico Rock',
    county_fips: 5005,
    county_fips_all: '05005|05137|05065|05049',
    county: 'Baxter',
    county_names_all: 'Baxter|Stone|Izard|Fulton',
    county_weights:
      '{"05005": 38.67, "05137": 29.64, "05065": 28.83, "05049": 2.87}',
    density: 7.1,
    imprecise: false,
    latitude: 36.11876,
    longitude: -92.17802,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72519',
  },
  {
    city: 'Camp',
    county_fips: 5049,
    county_fips_all: '05049',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"05049": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 36.39816,
    longitude: -91.72476,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72520',
  },
  {
    city: 'Cave City',
    county_fips: 5135,
    county_fips_all: '05135|05063',
    county: 'Sharp',
    county_names_all: 'Sharp|Independence',
    county_weights: '{"05135": 67.99, "05063": 32.01}',
    density: 16,
    imprecise: false,
    latitude: 35.95196,
    longitude: -91.54522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72521',
  },
  {
    city: 'Charlotte',
    county_fips: 5063,
    county_fips_all: '05063',
    county: 'Independence',
    county_names_all: 'Independence',
    county_weights: '{"05063": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 35.80471,
    longitude: -91.46683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72522',
  },
  {
    city: 'Concord',
    county_fips: 5023,
    county_fips_all: '05023|05063',
    county: 'Cleburne',
    county_names_all: 'Cleburne|Independence',
    county_weights: '{"05023": 80.5, "05063": 19.5}',
    density: 8.9,
    imprecise: false,
    latitude: 35.64808,
    longitude: -91.83632,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72523',
  },
  {
    city: 'Cord',
    county_fips: 5063,
    county_fips_all: '05063',
    county: 'Independence',
    county_names_all: 'Independence',
    county_weights: '{"05063": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 35.83551,
    longitude: -91.30318,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72524',
  },
  {
    city: 'Cushman',
    county_fips: 5063,
    county_fips_all: '05063',
    county: 'Independence',
    county_names_all: 'Independence',
    county_weights: '{"05063": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 35.87762,
    longitude: -91.76623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72526',
  },
  {
    city: 'Desha',
    county_fips: 5063,
    county_fips_all: '05063',
    county: 'Independence',
    county_names_all: 'Independence',
    county_weights: '{"05063": 100}',
    density: 63.9,
    imprecise: false,
    latitude: 35.74038,
    longitude: -91.68323,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72527',
  },
  {
    city: 'Dolph',
    county_fips: 5065,
    county_fips_all: '05065|05005',
    county: 'Izard',
    county_names_all: 'Izard|Baxter',
    county_weights: '{"05065": 99.9, "05005": 0.1}',
    density: 7.3,
    imprecise: false,
    latitude: 36.23816,
    longitude: -92.115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72528',
  },
  {
    city: 'Cherokee Village',
    county_fips: 5135,
    county_fips_all: '05135|05049',
    county: 'Sharp',
    county_names_all: 'Sharp|Fulton',
    county_weights: '{"05135": 55.49, "05049": 44.51}',
    density: 95.2,
    imprecise: false,
    latitude: 36.29696,
    longitude: -91.56676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72529',
  },
  {
    city: 'Drasco',
    county_fips: 5023,
    county_fips_all: '05023|05137',
    county: 'Cleburne',
    county_names_all: 'Cleburne|Stone',
    county_weights: '{"05023": 94.28, "05137": 5.72}',
    density: 6.2,
    imprecise: false,
    latitude: 35.61381,
    longitude: -91.95715,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72530',
  },
  {
    city: 'Elizabeth',
    county_fips: 5049,
    county_fips_all: '05049|05005',
    county: 'Fulton',
    county_names_all: 'Fulton|Baxter',
    county_weights: '{"05049": 55.18, "05005": 44.82}',
    density: 6.7,
    imprecise: false,
    latitude: 36.32052,
    longitude: -92.15121,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72531',
  },
  {
    city: 'Evening Shade',
    county_fips: 5135,
    county_fips_all: '05135|05065',
    county: 'Sharp',
    county_names_all: 'Sharp|Izard',
    county_weights: '{"05135": 83.67, "05065": 16.33}',
    density: 6.4,
    imprecise: false,
    latitude: 36.09905,
    longitude: -91.59508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72532',
  },
  {
    city: 'Fifty Six',
    county_fips: 5137,
    county_fips_all: '05137',
    county: 'Stone',
    county_names_all: 'Stone',
    county_weights: '{"05137": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 35.97921,
    longitude: -92.24513,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72533',
  },
  {
    city: 'Floral',
    county_fips: 5063,
    county_fips_all: '05063|05023',
    county: 'Independence',
    county_names_all: 'Independence|Cleburne',
    county_weights: '{"05063": 81.22, "05023": 18.78}',
    density: 8,
    imprecise: false,
    latitude: 35.59272,
    longitude: -91.73265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72534',
  },
  {
    city: 'Franklin',
    county_fips: 5065,
    county_fips_all: '05065',
    county: 'Izard',
    county_names_all: 'Izard',
    county_weights: '{"05065": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 36.14673,
    longitude: -91.76115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72536',
  },
  {
    city: 'Gamaliel',
    county_fips: 5005,
    county_fips_all: '05005',
    county: 'Baxter',
    county_names_all: 'Baxter',
    county_weights: '{"05005": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 36.45018,
    longitude: -92.23371,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72537',
  },
  {
    city: 'Gepp',
    county_fips: 5049,
    county_fips_all: '05049',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"05049": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 36.43622,
    longitude: -92.10612,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72538',
  },
  {
    city: 'Glencoe',
    county_fips: 5049,
    county_fips_all: '05049',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"05049": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 36.33015,
    longitude: -91.72259,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72539',
  },
  {
    city: 'Guion',
    county_fips: 5065,
    county_fips_all: '05065',
    county: 'Izard',
    county_names_all: 'Izard',
    county_weights: '{"05065": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 35.93355,
    longitude: -91.9096,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72540',
  },
  {
    city: 'Hardy',
    county_fips: 5135,
    county_fips_all: '05135|05049',
    county: 'Sharp',
    county_names_all: 'Sharp|Fulton',
    county_weights: '{"05135": 81.53, "05049": 18.47}',
    density: 10.2,
    imprecise: false,
    latitude: 36.29656,
    longitude: -91.46925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72542',
  },
  {
    city: 'Heber Springs',
    county_fips: 5023,
    county_fips_all: '05023',
    county: 'Cleburne',
    county_names_all: 'Cleburne',
    county_weights: '{"05023": 100}',
    density: 41.9,
    imprecise: false,
    latitude: 35.45528,
    longitude: -91.99407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72543',
  },
  {
    city: 'Henderson',
    county_fips: 5005,
    county_fips_all: '05005',
    county: 'Baxter',
    county_names_all: 'Baxter',
    county_weights: '{"05005": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 36.40395,
    longitude: -92.19022,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72544',
  },
  {
    city: 'Ida',
    county_fips: 5023,
    county_fips_all: '05023',
    county: 'Cleburne',
    county_names_all: 'Cleburne',
    county_weights: '{"05023": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.57711,
    longitude: -91.94487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72546',
  },
  {
    city: 'Locust Grove',
    county_fips: 5063,
    county_fips_all: '05063|05023|05137',
    county: 'Independence',
    county_names_all: 'Independence|Cleburne|Stone',
    county_weights: '{"05063": 69.01, "05023": 18.49, "05137": 12.5}',
    density: 5.2,
    imprecise: false,
    latitude: 35.70836,
    longitude: -91.78387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72550',
  },
  {
    city: 'Magness',
    county_fips: 5063,
    county_fips_all: '05063',
    county: 'Independence',
    county_names_all: 'Independence',
    county_weights: '{"05063": 100}',
    density: 105.2,
    imprecise: false,
    latitude: 35.70093,
    longitude: -91.48212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72553',
  },
  {
    city: 'Mammoth Spring',
    county_fips: 5049,
    county_fips_all: '05049|05135',
    county: 'Fulton',
    county_names_all: 'Fulton|Sharp',
    county_weights: '{"05049": 82.02, "05135": 17.98}',
    density: 6.9,
    imprecise: false,
    latitude: 36.43902,
    longitude: -91.55668,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72554',
  },
  {
    city: 'Marcella',
    county_fips: 5137,
    county_fips_all: '05137',
    county: 'Stone',
    county_names_all: 'Stone',
    county_weights: '{"05137": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 35.77165,
    longitude: -91.88287,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72555',
  },
  {
    city: 'Melbourne',
    county_fips: 5065,
    county_fips_all: '05065',
    county: 'Izard',
    county_names_all: 'Izard',
    county_weights: '{"05065": 100}',
    density: 9,
    imprecise: false,
    latitude: 36.02472,
    longitude: -91.95831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72556',
  },
  {
    city: 'Mountain View',
    county_fips: 5137,
    county_fips_all: '05137|05065',
    county: 'Stone',
    county_names_all: 'Stone|Izard',
    county_weights: '{"05137": 99.29, "05065": 0.71}',
    density: 9.8,
    imprecise: false,
    latitude: 35.84023,
    longitude: -92.08032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72560',
  },
  {
    city: 'Mount Pleasant',
    county_fips: 5065,
    county_fips_all: '05065',
    county: 'Izard',
    county_names_all: 'Izard',
    county_weights: '{"05065": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 35.9428,
    longitude: -91.81093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72561',
  },
  {
    city: 'Newark',
    county_fips: 5063,
    county_fips_all: '05063',
    county: 'Independence',
    county_names_all: 'Independence',
    county_weights: '{"05063": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 35.73074,
    longitude: -91.39514,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72562',
  },
  {
    city: 'Oil Trough',
    county_fips: 5063,
    county_fips_all: '05063',
    county: 'Independence',
    county_names_all: 'Independence',
    county_weights: '{"05063": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 35.60034,
    longitude: -91.45585,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72564',
  },
  {
    city: 'Oxford',
    county_fips: 5065,
    county_fips_all: '05065',
    county: 'Izard',
    county_names_all: 'Izard',
    county_weights: '{"05065": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 36.21871,
    longitude: -91.90686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72565',
  },
  {
    city: 'Pineville',
    county_fips: 5065,
    county_fips_all: '05065',
    county: 'Izard',
    county_names_all: 'Izard',
    county_weights: '{"05065": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 36.20792,
    longitude: -92.06468,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72566',
  },
  {
    city: 'Pleasant Grove',
    county_fips: 5137,
    county_fips_all: '05137',
    county: 'Stone',
    county_names_all: 'Stone',
    county_weights: '{"05137": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 35.81742,
    longitude: -91.91975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72567',
  },
  {
    city: 'Pleasant Plains',
    county_fips: 5063,
    county_fips_all: '05063|05145',
    county: 'Independence',
    county_names_all: 'Independence|White',
    county_weights: '{"05063": 92.52, "05145": 7.48}',
    density: 16.8,
    imprecise: false,
    latitude: 35.56676,
    longitude: -91.62147,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72568',
  },
  {
    city: 'Poughkeepsie',
    county_fips: 5135,
    county_fips_all: '05135',
    county: 'Sharp',
    county_names_all: 'Sharp',
    county_weights: '{"05135": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 36.08121,
    longitude: -91.45817,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72569',
  },
  {
    city: 'Rosie',
    county_fips: 5063,
    county_fips_all: '05063',
    county: 'Independence',
    county_names_all: 'Independence',
    county_weights: '{"05063": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 35.64059,
    longitude: -91.53568,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72571',
  },
  {
    city: 'Saffell',
    county_fips: 5075,
    county_fips_all: '05075|05063',
    county: 'Lawrence',
    county_names_all: 'Lawrence|Independence',
    county_weights: '{"05075": 75.46, "05063": 24.54}',
    density: 10.5,
    imprecise: false,
    latitude: 35.89762,
    longitude: -91.29173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72572',
  },
  {
    city: 'Sage',
    county_fips: 5065,
    county_fips_all: '05065',
    county: 'Izard',
    county_names_all: 'Izard',
    county_weights: '{"05065": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 36.07442,
    longitude: -91.79624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72573',
  },
  {
    city: 'Salem',
    county_fips: 5049,
    county_fips_all: '05049|05065',
    county: 'Fulton',
    county_names_all: 'Fulton|Izard',
    county_weights: '{"05049": 99.8, "05065": 0.2}',
    density: 10.6,
    imprecise: false,
    latitude: 36.35004,
    longitude: -91.85081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72576',
  },
  {
    city: 'Sidney',
    county_fips: 5065,
    county_fips_all: '05065|05135',
    county: 'Izard',
    county_names_all: 'Izard|Sharp',
    county_weights: '{"05065": 64.76, "05135": 35.24}',
    density: 6.5,
    imprecise: false,
    latitude: 36.03094,
    longitude: -91.71379,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72577',
  },
  {
    city: 'Sturkie',
    county_fips: 5049,
    county_fips_all: '05049',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"05049": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 36.45734,
    longitude: -91.87894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72578',
  },
  {
    city: 'Sulphur Rock',
    county_fips: 5063,
    county_fips_all: '05063|05135',
    county: 'Independence',
    county_names_all: 'Independence|Sharp',
    county_weights: '{"05063": 78.63, "05135": 21.37}',
    density: 12.4,
    imprecise: false,
    latitude: 35.84458,
    longitude: -91.44428,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72579',
  },
  {
    city: 'Tumbling Shoals',
    county_fips: 5023,
    county_fips_all: '05023',
    county: 'Cleburne',
    county_names_all: 'Cleburne',
    county_weights: '{"05023": 100}',
    density: 23.5,
    imprecise: false,
    latitude: 35.54722,
    longitude: -91.97035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72581',
  },
  {
    city: 'Viola',
    county_fips: 5049,
    county_fips_all: '05049',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"05049": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 36.40646,
    longitude: -91.98797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72583',
  },
  {
    city: 'Violet Hill',
    county_fips: 5065,
    county_fips_all: '05065',
    county: 'Izard',
    county_names_all: 'Izard',
    county_weights: '{"05065": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 36.14421,
    longitude: -91.84427,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72584',
  },
  {
    city: 'Wideman',
    county_fips: 5065,
    county_fips_all: '05065',
    county: 'Izard',
    county_names_all: 'Izard',
    county_weights: '{"05065": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 36.17861,
    longitude: -92.01454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72585',
  },
  {
    city: 'Wiseman',
    county_fips: 5065,
    county_fips_all: '05065',
    county: 'Izard',
    county_names_all: 'Izard',
    county_weights: '{"05065": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.21977,
    longitude: -91.8173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72587',
  },
  {
    city: 'Harrison',
    county_fips: 5009,
    county_fips_all: '05009|05101|05089',
    county: 'Boone',
    county_names_all: 'Boone|Newton|Marion',
    county_weights: '{"05009": 91.52, "05101": 5.75, "05089": 2.73}',
    density: 33.1,
    imprecise: false,
    latitude: 36.23669,
    longitude: -93.09181,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72601',
  },
  {
    city: 'Alpena',
    county_fips: 5015,
    county_fips_all: '05015|05009|05101',
    county: 'Carroll',
    county_names_all: 'Carroll|Boone|Newton',
    county_weights: '{"05015": 66.72, "05009": 30.11, "05101": 3.17}',
    density: 7.2,
    imprecise: false,
    latitude: 36.24532,
    longitude: -93.32705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72611',
  },
  {
    city: 'Bergman',
    county_fips: 5009,
    county_fips_all: '05009',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"05009": 100}',
    density: 160.1,
    imprecise: false,
    latitude: 36.31532,
    longitude: -93.01207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72615',
  },
  {
    city: 'Berryville',
    county_fips: 5015,
    county_fips_all: '05015',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"05015": 100}',
    density: 20.7,
    imprecise: false,
    latitude: 36.35047,
    longitude: -93.55736,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72616',
  },
  {
    city: 'Big Flat',
    county_fips: 5005,
    county_fips_all: '05005|05137',
    county: 'Baxter',
    county_names_all: 'Baxter|Stone',
    county_weights: '{"05005": 97.68, "05137": 2.32}',
    density: 4.4,
    imprecise: false,
    latitude: 36.0208,
    longitude: -92.36566,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72617',
  },
  {
    city: 'Bull Shoals',
    county_fips: 5089,
    county_fips_all: '05089',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"05089": 100}',
    density: 134.5,
    imprecise: false,
    latitude: 36.3781,
    longitude: -92.58517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72619',
  },
  {
    city: 'Clarkridge',
    county_fips: 5005,
    county_fips_all: '05005',
    county: 'Baxter',
    county_names_all: 'Baxter',
    county_weights: '{"05005": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 36.46386,
    longitude: -92.3172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72623',
  },
  {
    city: 'Compton',
    county_fips: 5101,
    county_fips_all: '05101|05015',
    county: 'Newton',
    county_names_all: 'Newton|Carroll',
    county_weights: '{"05101": 85.2, "05015": 14.8}',
    density: 2.1,
    imprecise: false,
    latitude: 36.08208,
    longitude: -93.35655,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72624',
  },
  {
    city: 'Cotter',
    county_fips: 5005,
    county_fips_all: '05005',
    county: 'Baxter',
    county_names_all: 'Baxter',
    county_weights: '{"05005": 100}',
    density: 89.7,
    imprecise: false,
    latitude: 36.30451,
    longitude: -92.53994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72626',
  },
  {
    city: 'Deer',
    county_fips: 5101,
    county_fips_all: '05101',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"05101": 100}',
    density: 2,
    imprecise: false,
    latitude: 35.82717,
    longitude: -93.28785,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72628',
  },
  {
    city: 'Dennard',
    county_fips: 5141,
    county_fips_all: '05141',
    county: 'Van Buren',
    county_names_all: 'Van Buren',
    county_weights: '{"05141": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 35.73615,
    longitude: -92.56625,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72629',
  },
  {
    city: 'Diamond City',
    county_fips: 5009,
    county_fips_all: '05009',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"05009": 100}',
    density: 305.8,
    imprecise: false,
    latitude: 36.45856,
    longitude: -92.92032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72630',
  },
  {
    city: 'Eureka Springs',
    county_fips: 5015,
    county_fips_all: '05015',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"05015": 100}',
    density: 34.1,
    imprecise: false,
    latitude: 36.45146,
    longitude: -93.79131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72631',
  },
  {
    city: 'Eureka Springs',
    county_fips: 5015,
    county_fips_all: '05015|05087',
    county: 'Carroll',
    county_names_all: 'Carroll|Madison',
    county_weights: '{"05015": 97.81, "05087": 2.19}',
    density: 20.4,
    imprecise: false,
    latitude: 36.37248,
    longitude: -93.74355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72632',
  },
  {
    city: 'Everton',
    county_fips: 5089,
    county_fips_all: '05089|05009|05129',
    county: 'Marion',
    county_names_all: 'Marion|Boone|Searcy',
    county_weights: '{"05089": 52.28, "05009": 31.53, "05129": 16.19}',
    density: 6.2,
    imprecise: false,
    latitude: 36.14023,
    longitude: -92.87572,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72633',
  },
  {
    city: 'Flippin',
    county_fips: 5089,
    county_fips_all: '05089',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"05089": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 36.23693,
    longitude: -92.54891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72634',
  },
  {
    city: 'Gassville',
    county_fips: 5005,
    county_fips_all: '05005',
    county: 'Baxter',
    county_names_all: 'Baxter',
    county_weights: '{"05005": 100}',
    density: 41.9,
    imprecise: false,
    latitude: 36.31637,
    longitude: -92.48484,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72635',
  },
  {
    city: 'Gilbert',
    county_fips: 5129,
    county_fips_all: '05129',
    county: 'Searcy',
    county_names_all: 'Searcy',
    county_weights: '{"05129": 100}',
    density: 39.4,
    imprecise: false,
    latitude: 35.99121,
    longitude: -92.71651,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72636',
  },
  {
    city: 'Green Forest',
    county_fips: 5015,
    county_fips_all: '05015|05101',
    county: 'Carroll',
    county_names_all: 'Carroll|Newton',
    county_weights: '{"05015": 95.18, "05101": 4.82}',
    density: 14.8,
    imprecise: false,
    latitude: 36.3245,
    longitude: -93.40496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72638',
  },
  {
    city: 'Harriet',
    county_fips: 5129,
    county_fips_all: '05129|05089',
    county: 'Searcy',
    county_names_all: 'Searcy|Marion',
    county_weights: '{"05129": 90.61, "05089": 9.39}',
    density: 4.3,
    imprecise: false,
    latitude: 36.01948,
    longitude: -92.48937,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72639',
  },
  {
    city: 'Hasty',
    county_fips: 5101,
    county_fips_all: '05101',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"05101": 100}',
    density: 11,
    imprecise: false,
    latitude: 36.00708,
    longitude: -93.05061,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72640',
  },
  {
    city: 'Jasper',
    county_fips: 5101,
    county_fips_all: '05101',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"05101": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 35.98829,
    longitude: -93.21978,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72641',
  },
  {
    city: 'Lakeview',
    county_fips: 5005,
    county_fips_all: '05005',
    county: 'Baxter',
    county_names_all: 'Baxter',
    county_weights: '{"05005": 100}',
    density: 72.2,
    imprecise: false,
    latitude: 36.37013,
    longitude: -92.54347,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72642',
  },
  {
    city: 'Lead Hill',
    county_fips: 5009,
    county_fips_all: '05009|05089|29213',
    county: 'Boone',
    county_names_all: 'Boone|Marion|Taney',
    county_weights: '{"05009": 91.75, "05089": 7.05, "29213": 1.2}',
    density: 10.4,
    imprecise: false,
    latitude: 36.42477,
    longitude: -92.96673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72644',
  },
  {
    city: 'Leslie',
    county_fips: 5129,
    county_fips_all: '05129|05141|05137',
    county: 'Searcy',
    county_names_all: 'Searcy|Van Buren|Stone',
    county_weights: '{"05129": 66.35, "05141": 19.29, "05137": 14.36}',
    density: 3.3,
    imprecise: false,
    latitude: 35.80249,
    longitude: -92.55778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72645',
  },
  {
    city: 'Marble Falls',
    county_fips: 5101,
    county_fips_all: '05101',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"05101": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 36.07516,
    longitude: -93.14399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72648',
  },
  {
    city: 'Marshall',
    county_fips: 5129,
    county_fips_all: '05129|05137',
    county: 'Searcy',
    county_names_all: 'Searcy|Stone',
    county_weights: '{"05129": 97.05, "05137": 2.95}',
    density: 6.7,
    imprecise: false,
    latitude: 35.87938,
    longitude: -92.69308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72650',
  },
  {
    city: 'Midway',
    county_fips: 5005,
    county_fips_all: '05005',
    county: 'Baxter',
    county_names_all: 'Baxter',
    county_weights: '{"05005": 100}',
    density: 62.4,
    imprecise: false,
    latitude: 36.388,
    longitude: -92.47661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72651',
  },
  {
    city: 'Mountain Home',
    county_fips: 5005,
    county_fips_all: '05005|05089',
    county: 'Baxter',
    county_names_all: 'Baxter|Marion',
    county_weights: '{"05005": 97.11, "05089": 2.89}',
    density: 51.7,
    imprecise: false,
    latitude: 36.34292,
    longitude: -92.38603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72653',
  },
  {
    city: 'Mount Judea',
    county_fips: 5101,
    county_fips_all: '05101',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"05101": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 35.89346,
    longitude: -93.03421,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72655',
  },
  {
    city: 'Norfork',
    county_fips: 5005,
    county_fips_all: '05005',
    county: 'Baxter',
    county_names_all: 'Baxter',
    county_weights: '{"05005": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 36.15468,
    longitude: -92.32301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72658',
  },
  {
    city: 'Oak Grove',
    county_fips: 5015,
    county_fips_all: '05015',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"05015": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 36.48115,
    longitude: -93.37454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72660',
  },
  {
    city: 'Oakland',
    county_fips: 5089,
    county_fips_all: '05089',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"05089": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 36.45195,
    longitude: -92.58963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72661',
  },
  {
    city: 'Omaha',
    county_fips: 5009,
    county_fips_all: '05009|05015',
    county: 'Boone',
    county_names_all: 'Boone|Carroll',
    county_weights: '{"05009": 98.59, "05015": 1.41}',
    density: 9.7,
    imprecise: false,
    latitude: 36.43184,
    longitude: -93.18297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72662',
  },
  {
    city: 'Onia',
    county_fips: 5137,
    county_fips_all: '05137',
    county: 'Stone',
    county_names_all: 'Stone',
    county_weights: '{"05137": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 35.93617,
    longitude: -92.33192,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72663',
  },
  {
    city: 'Parthenon',
    county_fips: 5101,
    county_fips_all: '05101',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"05101": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 35.94876,
    longitude: -93.28706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72666',
  },
  {
    city: 'Peel',
    county_fips: 5089,
    county_fips_all: '05089',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"05089": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 36.41914,
    longitude: -92.77163,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72668',
  },
  {
    city: 'Pindall',
    county_fips: 5129,
    county_fips_all: '05129',
    county: 'Searcy',
    county_names_all: 'Searcy',
    county_weights: '{"05129": 100}',
    density: 48,
    imprecise: false,
    latitude: 36.06477,
    longitude: -92.87359,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72669',
  },
  {
    city: 'Ponca',
    county_fips: 5101,
    county_fips_all: '05101',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"05101": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 35.98726,
    longitude: -93.37775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72670',
  },
  {
    city: 'Pyatt',
    county_fips: 5089,
    county_fips_all: '05089',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"05089": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 36.27725,
    longitude: -92.83685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72672',
  },
  {
    city: 'Saint Joe',
    county_fips: 5129,
    county_fips_all: '05129|05089',
    county: 'Searcy',
    county_names_all: 'Searcy|Marion',
    county_weights: '{"05129": 86.58, "05089": 13.42}',
    density: 2.1,
    imprecise: false,
    latitude: 36.00711,
    longitude: -92.79283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72675',
  },
  {
    city: 'Summit',
    county_fips: 5089,
    county_fips_all: '05089',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"05089": 100}',
    density: 63.2,
    imprecise: false,
    latitude: 36.26442,
    longitude: -92.70074,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72677',
  },
  {
    city: 'Tilly',
    county_fips: 5129,
    county_fips_all: '05129|05141|05115',
    county: 'Searcy',
    county_names_all: 'Searcy|Van Buren|Pope',
    county_weights: '{"05129": 84.95, "05141": 11.02, "05115": 4.03}',
    density: 2.1,
    imprecise: false,
    latitude: 35.73555,
    longitude: -92.80206,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72679',
  },
  {
    city: 'Timbo',
    county_fips: 5137,
    county_fips_all: '05137|05129',
    county: 'Stone',
    county_names_all: 'Stone|Searcy',
    county_weights: '{"05137": 91.13, "05129": 8.87}',
    density: 10.7,
    imprecise: false,
    latitude: 35.88286,
    longitude: -92.32986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72680',
  },
  {
    city: 'Valley Springs',
    county_fips: 5089,
    county_fips_all: '05089',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"05089": 100}',
    density: 5,
    imprecise: false,
    latitude: 36.13405,
    longitude: -92.72911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72682',
  },
  {
    city: 'Vendor',
    county_fips: 5101,
    county_fips_all: '05101',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"05101": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 35.93102,
    longitude: -93.11629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72683',
  },
  {
    city: 'Western Grove',
    county_fips: 5101,
    county_fips_all: '05101|05129|05009',
    county: 'Newton',
    county_names_all: 'Newton|Searcy|Boone',
    county_weights: '{"05101": 81.19, "05129": 16.88, "05009": 1.93}',
    density: 10.5,
    imprecise: false,
    latitude: 36.05539,
    longitude: -92.98194,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72685',
  },
  {
    city: 'Witts Springs',
    county_fips: 5115,
    county_fips_all: '05115|05129',
    county: 'Pope',
    county_names_all: 'Pope|Searcy',
    county_weights: '{"05115": 57.71, "05129": 42.29}',
    density: 0.5,
    imprecise: false,
    latitude: 35.70352,
    longitude: -92.918,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72686',
  },
  {
    city: 'Yellville',
    county_fips: 5089,
    county_fips_all: '05089|05009',
    county: 'Marion',
    county_names_all: 'Marion|Boone',
    county_weights: '{"05089": 99.68, "05009": 0.32}',
    density: 8.8,
    imprecise: false,
    latitude: 36.25628,
    longitude: -92.68679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72687',
  },
  {
    city: 'Fayetteville',
    county_fips: 5143,
    county_fips_all: '05143',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"05143": 100}',
    density: 152.7,
    imprecise: false,
    latitude: 35.9873,
    longitude: -94.08179,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72701',
  },
  {
    city: 'Fayetteville',
    county_fips: 5143,
    county_fips_all: '05143|05087',
    county: 'Washington',
    county_names_all: 'Washington|Madison',
    county_weights: '{"05143": 95.27, "05087": 4.73}',
    density: 344.7,
    imprecise: false,
    latitude: 36.1155,
    longitude: -94.04897,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72703',
  },
  {
    city: 'Fayetteville',
    county_fips: 5143,
    county_fips_all: '05143|05007',
    county: 'Washington',
    county_names_all: 'Washington|Benton',
    county_weights: '{"05143": 98.57, "05007": 1.43}',
    density: 162.9,
    imprecise: false,
    latitude: 36.10475,
    longitude: -94.29539,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72704',
  },
  {
    city: 'Bentonville',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 288.2,
    imprecise: false,
    latitude: 36.39837,
    longitude: -94.22196,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72712',
  },
  {
    city: 'Bentonville',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 230.8,
    imprecise: false,
    latitude: 36.30036,
    longitude: -94.28372,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72713',
  },
  {
    city: 'Bella Vista',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 302.8,
    imprecise: false,
    latitude: 36.46841,
    longitude: -94.21649,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72714',
  },
  {
    city: 'Bella Vista',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 231.3,
    imprecise: false,
    latitude: 36.46505,
    longitude: -94.30545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72715',
  },
  {
    city: 'Canehill',
    county_fips: 5143,
    county_fips_all: '05143',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"05143": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 35.84054,
    longitude: -94.42503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72717',
  },
  {
    city: 'Cave Springs',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 390.1,
    imprecise: false,
    latitude: 36.26347,
    longitude: -94.22147,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72718',
  },
  {
    city: 'Centerton',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 829.7,
    imprecise: false,
    latitude: 36.36837,
    longitude: -94.29551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72719',
  },
  {
    city: 'Combs',
    county_fips: 5087,
    county_fips_all: '05087|05047',
    county: 'Madison',
    county_names_all: 'Madison|Franklin',
    county_weights: '{"05087": 51.66, "05047": 48.34}',
    density: 5.2,
    imprecise: false,
    latitude: 35.78383,
    longitude: -93.78402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72721',
  },
  {
    city: 'Decatur',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 28.2,
    imprecise: false,
    latitude: 36.34042,
    longitude: -94.46397,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72722',
  },
  {
    city: 'Elkins',
    county_fips: 5087,
    county_fips_all: '05087|05143|05047',
    county: 'Madison',
    county_names_all: 'Madison|Washington|Franklin',
    county_weights: '{"05087": 63.13, "05143": 32.38, "05047": 4.49}',
    density: 16.6,
    imprecise: false,
    latitude: 35.91456,
    longitude: -93.92612,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72727',
  },
  {
    city: 'Evansville',
    county_fips: 5143,
    county_fips_all: '05143',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"05143": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 35.78992,
    longitude: -94.46338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72729',
  },
  {
    city: 'Farmington',
    county_fips: 5143,
    county_fips_all: '05143',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"05143": 100}',
    density: 215,
    imprecise: false,
    latitude: 36.03057,
    longitude: -94.26588,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72730',
  },
  {
    city: 'Garfield',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 24,
    imprecise: false,
    latitude: 36.43187,
    longitude: -93.95968,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72732',
  },
  {
    city: 'Gentry',
    county_fips: 5007,
    county_fips_all: '05007|05143',
    county: 'Benton',
    county_names_all: 'Benton|Washington',
    county_weights: '{"05007": 98.78, "05143": 1.22}',
    density: 41.2,
    imprecise: false,
    latitude: 36.27217,
    longitude: -94.45355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72734',
  },
  {
    city: 'Gravette',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 30.9,
    imprecise: false,
    latitude: 36.41402,
    longitude: -94.46548,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72736',
  },
  {
    city: 'Hindsville',
    county_fips: 5087,
    county_fips_all: '05087|05143|05007',
    county: 'Madison',
    county_names_all: 'Madison|Washington|Benton',
    county_weights: '{"05087": 79.05, "05143": 13.81, "05007": 7.14}',
    density: 12.2,
    imprecise: false,
    latitude: 36.16258,
    longitude: -93.885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72738',
  },
  {
    city: 'Hiwasse',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 40.4,
    imprecise: false,
    latitude: 36.42715,
    longitude: -94.32801,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72739',
  },
  {
    city: 'Huntsville',
    county_fips: 5087,
    county_fips_all: '05087|05015|05101',
    county: 'Madison',
    county_names_all: 'Madison|Carroll|Newton',
    county_weights: '{"05087": 90.5, "05015": 7.67, "05101": 1.83}',
    density: 10.4,
    imprecise: false,
    latitude: 36.10889,
    longitude: -93.67599,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72740',
  },
  {
    city: 'Kingston',
    county_fips: 5087,
    county_fips_all: '05087|05101',
    county: 'Madison',
    county_names_all: 'Madison|Newton',
    county_weights: '{"05087": 84.81, "05101": 15.19}',
    density: 2.3,
    imprecise: false,
    latitude: 35.98159,
    longitude: -93.49528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72742',
  },
  {
    city: 'Lincoln',
    county_fips: 5143,
    county_fips_all: '05143',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"05143": 100}',
    density: 27,
    imprecise: false,
    latitude: 35.96287,
    longitude: -94.43851,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72744',
  },
  {
    city: 'Lowell',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 187.3,
    imprecise: false,
    latitude: 36.2477,
    longitude: -94.10046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72745',
  },
  {
    city: 'Maysville',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 36.37023,
    longitude: -94.5807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72747',
  },
  {
    city: 'Morrow',
    county_fips: 5143,
    county_fips_all: '05143',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"05143": 100}',
    density: 98.1,
    imprecise: false,
    latitude: 35.86712,
    longitude: -94.43932,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72749',
  },
  {
    city: 'Pea Ridge',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 160.1,
    imprecise: false,
    latitude: 36.46255,
    longitude: -94.11825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72751',
  },
  {
    city: 'Pettigrew',
    county_fips: 5087,
    county_fips_all: '05087|05101|05071',
    county: 'Madison',
    county_names_all: 'Madison|Newton|Johnson',
    county_weights: '{"05087": 49.25, "05101": 30.97, "05071": 19.77}',
    density: 1.3,
    imprecise: false,
    latitude: 35.82077,
    longitude: -93.56357,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72752',
  },
  {
    city: 'Prairie Grove',
    county_fips: 5143,
    county_fips_all: '05143',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"05143": 100}',
    density: 46.5,
    imprecise: false,
    latitude: 35.93477,
    longitude: -94.32607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72753',
  },
  {
    city: 'Rogers',
    county_fips: 5007,
    county_fips_all: '05007|05087',
    county: 'Benton',
    county_names_all: 'Benton|Madison',
    county_weights: '{"05007": 90.28, "05087": 9.72}',
    density: 124.2,
    imprecise: false,
    latitude: 36.32214,
    longitude: -93.9922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72756',
  },
  {
    city: 'Rogers',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 594.8,
    imprecise: false,
    latitude: 36.29898,
    longitude: -94.14099,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72758',
  },
  {
    city: 'Saint Paul',
    county_fips: 5087,
    county_fips_all: '05087',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"05087": 100}',
    density: 4,
    imprecise: false,
    latitude: 35.82898,
    longitude: -93.69804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72760',
  },
  {
    city: 'Siloam Springs',
    county_fips: 5007,
    county_fips_all: '05007|05143',
    county: 'Benton',
    county_names_all: 'Benton|Washington',
    county_weights: '{"05007": 95.38, "05143": 4.62}',
    density: 83.8,
    imprecise: false,
    latitude: 36.17074,
    longitude: -94.45778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72761',
  },
  {
    city: 'Springdale',
    county_fips: 5143,
    county_fips_all: '05143|05007',
    county: 'Washington',
    county_names_all: 'Washington|Benton',
    county_weights: '{"05143": 78.67, "05007": 21.33}',
    density: 306.1,
    imprecise: false,
    latitude: 36.18747,
    longitude: -94.22794,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72762',
  },
  {
    city: 'Springdale',
    county_fips: 5143,
    county_fips_all: '05143|05007',
    county: 'Washington',
    county_names_all: 'Washington|Benton',
    county_weights: '{"05143": 91.43, "05007": 8.57}',
    density: 342.6,
    imprecise: false,
    latitude: 36.17746,
    longitude: -94.051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72764',
  },
  {
    city: 'Sulphur Springs',
    county_fips: 5007,
    county_fips_all: '05007',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"05007": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 36.47884,
    longitude: -94.4938,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72768',
  },
  {
    city: 'Summers',
    county_fips: 5143,
    county_fips_all: '05143',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"05143": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 36.0347,
    longitude: -94.49702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72769',
  },
  {
    city: 'Wesley',
    county_fips: 5087,
    county_fips_all: '05087|05143',
    county: 'Madison',
    county_names_all: 'Madison|Washington',
    county_weights: '{"05087": 97.02, "05143": 2.98}',
    density: 11,
    imprecise: false,
    latitude: 36.01409,
    longitude: -93.84723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72773',
  },
  {
    city: 'West Fork',
    county_fips: 5143,
    county_fips_all: '05143',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"05143": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 35.87777,
    longitude: -94.21533,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72774',
  },
  {
    city: 'Witter',
    county_fips: 5087,
    county_fips_all: '05087',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"05087": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 35.90913,
    longitude: -93.67307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72776',
  },
  {
    city: 'Russellville',
    county_fips: 5115,
    county_fips_all: '05115',
    county: 'Pope',
    county_names_all: 'Pope',
    county_weights: '{"05115": 100}',
    density: 916.6,
    imprecise: false,
    latitude: 35.28057,
    longitude: -93.14161,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72801',
  },
  {
    city: 'Russellville',
    county_fips: 5115,
    county_fips_all: '05115',
    county: 'Pope',
    county_names_all: 'Pope',
    county_weights: '{"05115": 100}',
    density: 65.3,
    imprecise: false,
    latitude: 35.31334,
    longitude: -93.06726,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72802',
  },
  {
    city: 'Altus',
    county_fips: 5047,
    county_fips_all: '05047|05071',
    county: 'Franklin',
    county_names_all: 'Franklin|Johnson',
    county_weights: '{"05047": 64.83, "05071": 35.17}',
    density: 23.8,
    imprecise: false,
    latitude: 35.4545,
    longitude: -93.72024,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72821',
  },
  {
    city: 'Atkins',
    county_fips: 5115,
    county_fips_all: '05115|05029|05149',
    county: 'Pope',
    county_names_all: 'Pope|Conway|Yell',
    county_weights: '{"05115": 77.64, "05029": 21.99, "05149": 0.37}',
    density: 18.4,
    imprecise: false,
    latitude: 35.25213,
    longitude: -92.89847,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72823',
  },
  {
    city: 'Belleville',
    county_fips: 5149,
    county_fips_all: '05149',
    county: 'Yell',
    county_names_all: 'Yell',
    county_weights: '{"05149": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 35.12768,
    longitude: -93.41146,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72824',
  },
  {
    city: 'Blue Mountain',
    county_fips: 5083,
    county_fips_all: '05083',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"05083": 100}',
    density: 74.6,
    imprecise: false,
    latitude: 35.13,
    longitude: -93.71025,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72826',
  },
  {
    city: 'Bluffton',
    county_fips: 5149,
    county_fips_all: '05149|05127',
    county: 'Yell',
    county_names_all: 'Yell|Scott',
    county_weights: '{"05149": 84.42, "05127": 15.58}',
    density: 0.8,
    imprecise: false,
    latitude: 34.87758,
    longitude: -93.61948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 78,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72827',
  },
  {
    city: 'Briggsville',
    county_fips: 5149,
    county_fips_all: '05149',
    county: 'Yell',
    county_names_all: 'Yell',
    county_weights: '{"05149": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 34.92613,
    longitude: -93.53951,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72828',
  },
  {
    city: 'Centerville',
    county_fips: 5149,
    county_fips_all: '05149',
    county: 'Yell',
    county_names_all: 'Yell',
    county_weights: '{"05149": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.10351,
    longitude: -93.1753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72829',
  },
  {
    city: 'Clarksville',
    county_fips: 5071,
    county_fips_all: '05071',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"05071": 100}',
    density: 43.6,
    imprecise: false,
    latitude: 35.51685,
    longitude: -93.50859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72830',
  },
  {
    city: 'Coal Hill',
    county_fips: 5071,
    county_fips_all: '05071',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"05071": 100}',
    density: 73.6,
    imprecise: false,
    latitude: 35.42748,
    longitude: -93.67043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72832',
  },
  {
    city: 'Danville',
    county_fips: 5149,
    county_fips_all: '05149|05127',
    county: 'Yell',
    county_names_all: 'Yell|Scott',
    county_weights: '{"05149": 87.12, "05127": 12.88}',
    density: 6.3,
    imprecise: false,
    latitude: 35.01845,
    longitude: -93.49748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72833',
  },
  {
    city: 'Dardanelle',
    county_fips: 5149,
    county_fips_all: '05149|05083',
    county: 'Yell',
    county_names_all: 'Yell|Logan',
    county_weights: '{"05149": 97.15, "05083": 2.85}',
    density: 22.9,
    imprecise: false,
    latitude: 35.17202,
    longitude: -93.19401,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72834',
  },
  {
    city: 'Delaware',
    county_fips: 5083,
    county_fips_all: '05083|05149',
    county: 'Logan',
    county_names_all: 'Logan|Yell',
    county_weights: '{"05083": 99.79, "05149": 0.21}',
    density: 6.1,
    imprecise: false,
    latitude: 35.27634,
    longitude: -93.3425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72835',
  },
  {
    city: 'Dover',
    county_fips: 5115,
    county_fips_all: '05115',
    county: 'Pope',
    county_names_all: 'Pope',
    county_weights: '{"05115": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 35.51387,
    longitude: -93.10709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72837',
  },
  {
    city: 'Gravelly',
    county_fips: 5149,
    county_fips_all: '05149|05127',
    county: 'Yell',
    county_names_all: 'Yell|Scott',
    county_weights: '{"05149": 83.88, "05127": 16.12}',
    density: 4.4,
    imprecise: false,
    latitude: 34.88926,
    longitude: -93.68009,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72838',
  },
  {
    city: 'Hagarville',
    county_fips: 5071,
    county_fips_all: '05071|05115|05101',
    county: 'Johnson',
    county_names_all: 'Johnson|Pope|Newton',
    county_weights: '{"05071": 87.72, "05115": 11.06, "05101": 1.22}',
    density: 0.8,
    imprecise: false,
    latitude: 35.65131,
    longitude: -93.26384,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72839',
  },
  {
    city: 'Hartman',
    county_fips: 5071,
    county_fips_all: '05071',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"05071": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 35.46164,
    longitude: -93.61442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72840',
  },
  {
    city: 'Harvey',
    county_fips: 5127,
    county_fips_all: '05127|05149',
    county: 'Scott',
    county_names_all: 'Scott|Yell',
    county_weights: '{"05127": 96.05, "05149": 3.95}',
    density: 2.9,
    imprecise: false,
    latitude: 34.86736,
    longitude: -93.78515,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72841',
  },
  {
    city: 'Havana',
    county_fips: 5149,
    county_fips_all: '05149',
    county: 'Yell',
    county_names_all: 'Yell',
    county_weights: '{"05149": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 35.09626,
    longitude: -93.59664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72842',
  },
  {
    city: 'Hector',
    county_fips: 5115,
    county_fips_all: '05115',
    county: 'Pope',
    county_names_all: 'Pope',
    county_weights: '{"05115": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 35.55608,
    longitude: -92.91932,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72843',
  },
  {
    city: 'Knoxville',
    county_fips: 5071,
    county_fips_all: '05071',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"05071": 100}',
    density: 37.1,
    imprecise: false,
    latitude: 35.36262,
    longitude: -93.37619,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72845',
  },
  {
    city: 'Lamar',
    county_fips: 5071,
    county_fips_all: '05071|05115',
    county: 'Johnson',
    county_names_all: 'Johnson|Pope',
    county_weights: '{"05071": 86.58, "05115": 13.42}',
    density: 15,
    imprecise: false,
    latitude: 35.48166,
    longitude: -93.31885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72846',
  },
  {
    city: 'London',
    county_fips: 5115,
    county_fips_all: '05115|05071',
    county: 'Pope',
    county_names_all: 'Pope|Johnson',
    county_weights: '{"05115": 71.48, "05071": 28.52}',
    density: 30,
    imprecise: false,
    latitude: 35.37043,
    longitude: -93.27749,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72847',
  },
  {
    city: 'New Blaine',
    county_fips: 5083,
    county_fips_all: '05083',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"05083": 100}',
    density: 6,
    imprecise: false,
    latitude: 35.26092,
    longitude: -93.45693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72851',
  },
  {
    city: 'Oark',
    county_fips: 5071,
    county_fips_all: '05071|05101|05087',
    county: 'Johnson',
    county_names_all: 'Johnson|Newton|Madison',
    county_weights: '{"05071": 83.57, "05101": 15.81, "05087": 0.62}',
    density: 0.9,
    imprecise: false,
    latitude: 35.68243,
    longitude: -93.56684,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72852',
  },
  {
    city: 'Ola',
    county_fips: 5149,
    county_fips_all: '05149|05105',
    county: 'Yell',
    county_names_all: 'Yell|Perry',
    county_weights: '{"05149": 87.27, "05105": 12.73}',
    density: 9.9,
    imprecise: false,
    latitude: 35.01146,
    longitude: -93.23358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72853',
  },
  {
    city: 'Ozone',
    county_fips: 5071,
    county_fips_all: '05071|05101',
    county: 'Johnson',
    county_names_all: 'Johnson|Newton',
    county_weights: '{"05071": 64.14, "05101": 35.86}',
    density: 2.3,
    imprecise: false,
    latitude: 35.69644,
    longitude: -93.43491,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72854',
  },
  {
    city: 'Paris',
    county_fips: 5083,
    county_fips_all: '05083|05047',
    county: 'Logan',
    county_names_all: 'Logan|Franklin',
    county_weights: '{"05083": 98.78, "05047": 1.22}',
    density: 13.2,
    imprecise: false,
    latitude: 35.25249,
    longitude: -93.67553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72855',
  },
  {
    city: 'Pelsor',
    county_fips: 5101,
    county_fips_all: '05101|05115',
    county: 'Newton',
    county_names_all: 'Newton|Pope',
    county_weights: '{"05101": 83.83, "05115": 16.17}',
    density: 1.7,
    imprecise: false,
    latitude: 35.76773,
    longitude: -93.05658,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72856',
  },
  {
    city: 'Plainview',
    county_fips: 5149,
    county_fips_all: '05149|05105',
    county: 'Yell',
    county_names_all: 'Yell|Perry',
    county_weights: '{"05149": 61.9, "05105": 38.1}',
    density: 1.9,
    imprecise: false,
    latitude: 34.86217,
    longitude: -93.33826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72857',
  },
  {
    city: 'Pottsville',
    county_fips: 5115,
    county_fips_all: '05115',
    county: 'Pope',
    county_names_all: 'Pope',
    county_weights: '{"05115": 100}',
    density: 35.2,
    imprecise: false,
    latitude: 35.20582,
    longitude: -93.04433,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72858',
  },
  {
    city: 'Rover',
    county_fips: 5149,
    county_fips_all: '05149',
    county: 'Yell',
    county_names_all: 'Yell',
    county_weights: '{"05149": 100}',
    density: 4,
    imprecise: false,
    latitude: 34.94556,
    longitude: -93.43144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72860',
  },
  {
    city: 'Scranton',
    county_fips: 5083,
    county_fips_all: '05083',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"05083": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 35.36642,
    longitude: -93.50878,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72863',
  },
  {
    city: 'Subiaco',
    county_fips: 5083,
    county_fips_all: '05083',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"05083": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 35.31143,
    longitude: -93.5673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72865',
  },
  {
    city: 'Fort Smith',
    county_fips: 5131,
    county_fips_all: '05131',
    county: 'Sebastian',
    county_names_all: 'Sebastian',
    county_weights: '{"05131": 100}',
    density: 875.9,
    imprecise: false,
    latitude: 35.3652,
    longitude: -94.4155,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72901',
  },
  {
    city: 'Fort Smith',
    county_fips: 5131,
    county_fips_all: '05131',
    county: 'Sebastian',
    county_names_all: 'Sebastian',
    county_weights: '{"05131": 100}',
    density: 649.1,
    imprecise: false,
    latitude: 35.35241,
    longitude: -94.36042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72903',
  },
  {
    city: 'Fort Smith',
    county_fips: 5131,
    county_fips_all: '05131',
    county: 'Sebastian',
    county_names_all: 'Sebastian',
    county_weights: '{"05131": 100}',
    density: 600.7,
    imprecise: false,
    latitude: 35.4151,
    longitude: -94.38338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72904',
  },
  {
    city: 'Fort Smith',
    county_fips: 5131,
    county_fips_all: '05131',
    county: 'Sebastian',
    county_names_all: 'Sebastian',
    county_weights: '{"05131": 100}',
    density: 719.1,
    imprecise: false,
    latitude: 35.30595,
    longitude: -94.4099,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72908',
  },
  {
    city: 'Fort Smith',
    county_fips: 5131,
    county_fips_all: '05131',
    county: 'Sebastian',
    county_names_all: 'Sebastian',
    county_weights: '{"05131": 100}',
    density: 120,
    imprecise: false,
    latitude: 35.27236,
    longitude: -94.37256,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72916',
  },
  {
    city: 'Alma',
    county_fips: 5033,
    county_fips_all: '05033|05131',
    county: 'Crawford',
    county_names_all: 'Crawford|Sebastian',
    county_weights: '{"05033": 99.89, "05131": 0.11}',
    density: 56,
    imprecise: false,
    latitude: 35.46953,
    longitude: -94.19686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72921',
  },
  {
    city: 'Barling',
    county_fips: 5131,
    county_fips_all: '05131',
    county: 'Sebastian',
    county_names_all: 'Sebastian',
    county_weights: '{"05131": 100}',
    density: 116.9,
    imprecise: false,
    latitude: 35.30904,
    longitude: -94.28954,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72923',
  },
  {
    city: 'Boles',
    county_fips: 5127,
    county_fips_all: '05127',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"05127": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 34.72909,
    longitude: -94.0376,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72926',
  },
  {
    city: 'Booneville',
    county_fips: 5083,
    county_fips_all: '05083|05127|05131',
    county: 'Logan',
    county_names_all: 'Logan|Scott|Sebastian',
    county_weights: '{"05083": 67.97, "05127": 29.51, "05131": 2.52}',
    density: 9.5,
    imprecise: false,
    latitude: 35.07254,
    longitude: -93.94333,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72927',
  },
  {
    city: 'Branch',
    county_fips: 5047,
    county_fips_all: '05047',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"05047": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 35.29127,
    longitude: -93.93206,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72928',
  },
  {
    city: 'Cecil',
    county_fips: 5047,
    county_fips_all: '05047|05131',
    county: 'Franklin',
    county_names_all: 'Franklin|Sebastian',
    county_weights: '{"05047": 73.77, "05131": 26.23}',
    density: 2.1,
    imprecise: false,
    latitude: 35.43248,
    longitude: -94.00737,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72930',
  },
  {
    city: 'Cedarville',
    county_fips: 5033,
    county_fips_all: '05033',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"05033": 100}',
    density: 35.4,
    imprecise: false,
    latitude: 35.60479,
    longitude: -94.37682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72932',
  },
  {
    city: 'Charleston',
    county_fips: 5047,
    county_fips_all: '05047|05131|05083',
    county: 'Franklin',
    county_names_all: 'Franklin|Sebastian|Logan',
    county_weights: '{"05047": 83.71, "05131": 11.68, "05083": 4.61}',
    density: 18,
    imprecise: false,
    latitude: 35.33408,
    longitude: -94.01432,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72933',
  },
  {
    city: 'Chester',
    county_fips: 5033,
    county_fips_all: '05033',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"05033": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 35.68957,
    longitude: -94.2703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72934',
  },
  {
    city: 'Dyer',
    county_fips: 5033,
    county_fips_all: '05033',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"05033": 100}',
    density: 100.7,
    imprecise: false,
    latitude: 35.49431,
    longitude: -94.13277,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72935',
  },
  {
    city: 'Greenwood',
    county_fips: 5131,
    county_fips_all: '05131',
    county: 'Sebastian',
    county_names_all: 'Sebastian',
    county_weights: '{"05131": 100}',
    density: 67.1,
    imprecise: false,
    latitude: 35.1896,
    longitude: -94.23069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72936',
  },
  {
    city: 'Hackett',
    county_fips: 5131,
    county_fips_all: '05131',
    county: 'Sebastian',
    county_names_all: 'Sebastian',
    county_weights: '{"05131": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 35.13764,
    longitude: -94.39545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72937',
  },
  {
    city: 'Hartford',
    county_fips: 5131,
    county_fips_all: '05131',
    county: 'Sebastian',
    county_names_all: 'Sebastian',
    county_weights: '{"05131": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 35.00665,
    longitude: -94.38097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72938',
  },
  {
    city: 'Huntington',
    county_fips: 5131,
    county_fips_all: '05131',
    county: 'Sebastian',
    county_names_all: 'Sebastian',
    county_weights: '{"05131": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 35.11488,
    longitude: -94.26427,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72940',
  },
  {
    city: 'Lavaca',
    county_fips: 5131,
    county_fips_all: '05131',
    county: 'Sebastian',
    county_names_all: 'Sebastian',
    county_weights: '{"05131": 100}',
    density: 45.7,
    imprecise: false,
    latitude: 35.35018,
    longitude: -94.16214,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72941',
  },
  {
    city: 'Magazine',
    county_fips: 5083,
    county_fips_all: '05083|05149|05047',
    county: 'Logan',
    county_names_all: 'Logan|Yell|Franklin',
    county_weights: '{"05083": 94.96, "05149": 4.71, "05047": 0.33}',
    density: 10.3,
    imprecise: false,
    latitude: 35.18326,
    longitude: -93.78721,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72943',
  },
  {
    city: 'Mansfield',
    county_fips: 5131,
    county_fips_all: '05131|05127',
    county: 'Sebastian',
    county_names_all: 'Sebastian|Scott',
    county_weights: '{"05131": 67.81, "05127": 32.19}',
    density: 13.6,
    imprecise: false,
    latitude: 35.03366,
    longitude: -94.24173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72944',
  },
  {
    city: 'Midland',
    county_fips: 5131,
    county_fips_all: '05131',
    county: 'Sebastian',
    county_names_all: 'Sebastian',
    county_weights: '{"05131": 100}',
    density: 142.5,
    imprecise: false,
    latitude: 35.09559,
    longitude: -94.36297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72945',
  },
  {
    city: 'Mountainburg',
    county_fips: 5033,
    county_fips_all: '05033|05047',
    county: 'Crawford',
    county_names_all: 'Crawford|Franklin',
    county_weights: '{"05033": 88.24, "05047": 11.76}',
    density: 15.7,
    imprecise: false,
    latitude: 35.65254,
    longitude: -94.13706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72946',
  },
  {
    city: 'Mulberry',
    county_fips: 5047,
    county_fips_all: '05047|05033',
    county: 'Franklin',
    county_names_all: 'Franklin|Crawford',
    county_weights: '{"05047": 53.66, "05033": 46.34}',
    density: 15.2,
    imprecise: false,
    latitude: 35.54706,
    longitude: -94.04021,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72947',
  },
  {
    city: 'Natural Dam',
    county_fips: 5033,
    county_fips_all: '05033|05143',
    county: 'Crawford',
    county_names_all: 'Crawford|Washington',
    county_weights: '{"05033": 96.59, "05143": 3.41}',
    density: 2,
    imprecise: false,
    latitude: 35.70692,
    longitude: -94.4154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72948',
  },
  {
    city: 'Ozark',
    county_fips: 5047,
    county_fips_all: '05047|05071|05083',
    county: 'Franklin',
    county_names_all: 'Franklin|Johnson|Logan',
    county_weights: '{"05047": 87.8, "05071": 10.12, "05083": 2.08}',
    density: 11.5,
    imprecise: false,
    latitude: 35.55755,
    longitude: -93.80813,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72949',
  },
  {
    city: 'Parks',
    county_fips: 5127,
    county_fips_all: '05127',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"05127": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 34.79317,
    longitude: -93.91077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72950',
  },
  {
    city: 'Ratcliff',
    county_fips: 5083,
    county_fips_all: '05083|05047',
    county: 'Logan',
    county_names_all: 'Logan|Franklin',
    county_weights: '{"05083": 53.32, "05047": 46.68}',
    density: 18.5,
    imprecise: false,
    latitude: 35.31812,
    longitude: -93.87593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72951',
  },
  {
    city: 'Rudy',
    county_fips: 5033,
    county_fips_all: '05033',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"05033": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 35.56861,
    longitude: -94.30139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72952',
  },
  {
    city: 'Uniontown',
    county_fips: 5033,
    county_fips_all: '05033',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"05033": 100}',
    density: 20,
    imprecise: false,
    latitude: 35.6081,
    longitude: -94.44445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72955',
  },
  {
    city: 'Van Buren',
    county_fips: 5033,
    county_fips_all: '05033|05131',
    county: 'Crawford',
    county_names_all: 'Crawford|Sebastian',
    county_weights: '{"05033": 99.85, "05131": 0.15}',
    density: 128.5,
    imprecise: false,
    latitude: 35.46895,
    longitude: -94.3489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72956',
  },
  {
    city: 'Waldron',
    county_fips: 5127,
    county_fips_all: '05127',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"05127": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 34.90173,
    longitude: -94.14659,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72958',
  },
  {
    city: 'Winslow',
    county_fips: 5143,
    county_fips_all: '05143|05033|05047',
    county: 'Washington',
    county_names_all: 'Washington|Crawford|Franklin',
    county_weights: '{"05143": 59.17, "05033": 25.37, "05047": 15.46}',
    density: 5.7,
    imprecise: false,
    latitude: 35.77157,
    longitude: -94.06686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72959',
  },
  {
    city: 'Albert',
    county_fips: 40015,
    county_fips_all: '40015',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"40015": 100}',
    density: 6,
    imprecise: false,
    latitude: 35.2262,
    longitude: -98.41654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73001',
  },
  {
    city: 'Alex',
    county_fips: 40051,
    county_fips_all: '40051|40087',
    county: 'Grady',
    county_names_all: 'Grady|McClain',
    county_weights: '{"40051": 99.33, "40087": 0.67}',
    density: 12.8,
    imprecise: false,
    latitude: 34.96402,
    longitude: -97.73237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73002',
  },
  {
    city: 'Edmond',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1209.9,
    imprecise: false,
    latitude: 35.66952,
    longitude: -97.49693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73003',
  },
  {
    city: 'Amber',
    county_fips: 40051,
    county_fips_all: '40051',
    county: 'Grady',
    county_names_all: 'Grady',
    county_weights: '{"40051": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 35.14362,
    longitude: -97.83875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73004',
  },
  {
    city: 'Anadarko',
    county_fips: 40015,
    county_fips_all: '40015',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"40015": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 35.05439,
    longitude: -98.23762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73005',
  },
  {
    city: 'Apache',
    county_fips: 40015,
    county_fips_all: '40015|40031',
    county: 'Caddo',
    county_names_all: 'Caddo|Comanche',
    county_weights: '{"40015": 80.36, "40031": 19.64}',
    density: 5.4,
    imprecise: false,
    latitude: 34.90587,
    longitude: -98.40583,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73006',
  },
  {
    city: 'Arcadia',
    county_fips: 40109,
    county_fips_all: '40109|40083',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma|Logan',
    county_weights: '{"40109": 84.02, "40083": 15.98}',
    density: 31.8,
    imprecise: false,
    latitude: 35.69001,
    longitude: -97.32009,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73007',
  },
  {
    city: 'Bethany',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1102,
    imprecise: false,
    latitude: 35.51383,
    longitude: -97.64536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73008',
  },
  {
    city: 'Binger',
    county_fips: 40015,
    county_fips_all: '40015',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"40015": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 35.28544,
    longitude: -98.37016,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73009',
  },
  {
    city: 'Blanchard',
    county_fips: 40051,
    county_fips_all: '40051|40087',
    county: 'Grady',
    county_names_all: 'Grady|McClain',
    county_weights: '{"40051": 51.74, "40087": 48.26}',
    density: 47.6,
    imprecise: false,
    latitude: 35.09989,
    longitude: -97.67197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73010',
  },
  {
    city: 'Bradley',
    county_fips: 40051,
    county_fips_all: '40051',
    county: 'Grady',
    county_names_all: 'Grady',
    county_weights: '{"40051": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 34.84378,
    longitude: -97.74498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73011',
  },
  {
    city: 'Edmond',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 532.5,
    imprecise: false,
    latitude: 35.66815,
    longitude: -97.59315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73012',
  },
  {
    city: 'Edmond',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 685.4,
    imprecise: false,
    latitude: 35.62149,
    longitude: -97.49614,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73013',
  },
  {
    city: 'Calumet',
    county_fips: 40017,
    county_fips_all: '40017',
    county: 'Canadian',
    county_names_all: 'Canadian',
    county_weights: '{"40017": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 35.58152,
    longitude: -98.1409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73014',
  },
  {
    city: 'Carnegie',
    county_fips: 40015,
    county_fips_all: '40015|40075|40149',
    county: 'Caddo',
    county_names_all: 'Caddo|Kiowa|Washita',
    county_weights: '{"40015": 74.17, "40075": 14.56, "40149": 11.27}',
    density: 4.1,
    imprecise: false,
    latitude: 35.07648,
    longitude: -98.59016,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73015',
  },
  {
    city: 'Cashion',
    county_fips: 40073,
    county_fips_all: '40073|40083',
    county: 'Kingfisher',
    county_names_all: 'Kingfisher|Logan',
    county_weights: '{"40073": 62.99, "40083": 37.01}',
    density: 15.3,
    imprecise: false,
    latitude: 35.79778,
    longitude: -97.68831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73016',
  },
  {
    city: 'Cement',
    county_fips: 40015,
    county_fips_all: '40015|40051|40031',
    county: 'Caddo',
    county_names_all: 'Caddo|Grady|Comanche',
    county_weights: '{"40015": 48.26, "40051": 47.64, "40031": 4.09}',
    density: 6.5,
    imprecise: false,
    latitude: 34.92651,
    longitude: -98.09546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73017',
  },
  {
    city: 'Chickasha',
    county_fips: 40051,
    county_fips_all: '40051',
    county: 'Grady',
    county_names_all: 'Grady',
    county_weights: '{"40051": 100}',
    density: 51,
    imprecise: false,
    latitude: 35.0484,
    longitude: -97.93839,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73018',
  },
  {
    city: 'Choctaw',
    county_fips: 40109,
    county_fips_all: '40109|40027',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma|Cleveland',
    county_weights: '{"40109": 94.38, "40027": 5.62}',
    density: 160.8,
    imprecise: false,
    latitude: 35.45588,
    longitude: -97.2619,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73020',
  },
  {
    city: 'Colony',
    county_fips: 40149,
    county_fips_all: '40149|40015',
    county: 'Washita',
    county_names_all: 'Washita|Caddo',
    county_weights: '{"40149": 78.27, "40015": 21.73}',
    density: 1.3,
    imprecise: false,
    latitude: 35.33802,
    longitude: -98.67007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73021',
  },
  {
    city: 'Concho',
    county_fips: 40017,
    county_fips_all: '40017',
    county: 'Canadian',
    county_names_all: 'Canadian',
    county_weights: '{"40017": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.61692,
    longitude: -97.99224,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73022',
  },
  {
    city: 'Corn',
    county_fips: 40149,
    county_fips_all: '40149',
    county: 'Washita',
    county_names_all: 'Washita',
    county_weights: '{"40149": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 35.36608,
    longitude: -98.81508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73024',
  },
  {
    city: 'Edmond',
    county_fips: 40083,
    county_fips_all: '40083|40109',
    county: 'Logan',
    county_names_all: 'Logan|Oklahoma',
    county_weights: '{"40083": 57.66, "40109": 42.34}',
    density: 124,
    imprecise: false,
    latitude: 35.73199,
    longitude: -97.5727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73025',
  },
  {
    city: 'Norman',
    county_fips: 40027,
    county_fips_all: '40027',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"40027": 100}',
    density: 39.9,
    imprecise: false,
    latitude: 35.23433,
    longitude: -97.2791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73026',
  },
  {
    city: 'Coyle',
    county_fips: 40083,
    county_fips_all: '40083|40119',
    county: 'Logan',
    county_names_all: 'Logan|Payne',
    county_weights: '{"40083": 50.89, "40119": 49.11}',
    density: 5.2,
    imprecise: false,
    latitude: 35.97102,
    longitude: -97.24455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73027',
  },
  {
    city: 'Crescent',
    county_fips: 40083,
    county_fips_all: '40083|40073',
    county: 'Logan',
    county_names_all: 'Logan|Kingfisher',
    county_weights: '{"40083": 79.04, "40073": 20.96}',
    density: 9.2,
    imprecise: false,
    latitude: 35.9771,
    longitude: -97.62418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73028',
  },
  {
    city: 'Cyril',
    county_fips: 40015,
    county_fips_all: '40015',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"40015": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 34.89999,
    longitude: -98.21016,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73029',
  },
  {
    city: 'Davis',
    county_fips: 40099,
    county_fips_all: '40099|40049',
    county: 'Murray',
    county_names_all: 'Murray|Garvin',
    county_weights: '{"40099": 89.04, "40049": 10.96}',
    density: 8.3,
    imprecise: false,
    latitude: 34.47142,
    longitude: -97.18584,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73030',
  },
  {
    city: 'Dibble',
    county_fips: 40087,
    county_fips_all: '40087',
    county: 'McClain',
    county_names_all: 'McClain',
    county_weights: '{"40087": 100}',
    density: 118,
    imprecise: false,
    latitude: 35.03376,
    longitude: -97.63139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73031',
  },
  {
    city: 'Dougherty',
    county_fips: 40099,
    county_fips_all: '40099',
    county: 'Murray',
    county_names_all: 'Murray',
    county_weights: '{"40099": 100}',
    density: 233.7,
    imprecise: false,
    latitude: 34.40051,
    longitude: -97.05137,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73032',
  },
  {
    city: 'Eakly',
    county_fips: 40015,
    county_fips_all: '40015',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"40015": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 35.30709,
    longitude: -98.55502,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73033',
  },
  {
    city: 'Edmond',
    county_fips: 40109,
    county_fips_all: '40109|40083',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma|Logan',
    county_weights: '{"40109": 69.99, "40083": 30.01}',
    density: 364.9,
    imprecise: false,
    latitude: 35.69877,
    longitude: -97.42665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73034',
  },
  {
    city: 'El Reno',
    county_fips: 40017,
    county_fips_all: '40017',
    county: 'Canadian',
    county_names_all: 'Canadian',
    county_weights: '{"40017": 100}',
    density: 44.9,
    imprecise: false,
    latitude: 35.50752,
    longitude: -97.95771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73036',
  },
  {
    city: 'Fort Cobb',
    county_fips: 40015,
    county_fips_all: '40015',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"40015": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 35.1214,
    longitude: -98.44306,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73038',
  },
  {
    city: 'Geary',
    county_fips: 40011,
    county_fips_all: '40011|40017',
    county: 'Blaine',
    county_names_all: 'Blaine|Canadian',
    county_weights: '{"40011": 68.88, "40017": 31.12}',
    density: 2.1,
    imprecise: false,
    latitude: 35.64442,
    longitude: -98.37861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73040',
  },
  {
    city: 'Gotebo',
    county_fips: 40075,
    county_fips_all: '40075|40149',
    county: 'Kiowa',
    county_names_all: 'Kiowa|Washita',
    county_weights: '{"40075": 79.73, "40149": 20.27}',
    density: 1.1,
    imprecise: false,
    latitude: 35.03594,
    longitude: -98.88064,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73041',
  },
  {
    city: 'Gracemont',
    county_fips: 40015,
    county_fips_all: '40015',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"40015": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 35.23019,
    longitude: -98.25151,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73042',
  },
  {
    city: 'Greenfield',
    county_fips: 40011,
    county_fips_all: '40011',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"40011": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 35.73609,
    longitude: -98.3939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73043',
  },
  {
    city: 'Guthrie',
    county_fips: 40083,
    county_fips_all: '40083',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"40083": 100}',
    density: 37,
    imprecise: false,
    latitude: 35.86664,
    longitude: -97.43476,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73044',
  },
  {
    city: 'Harrah',
    county_fips: 40109,
    county_fips_all: '40109|40081|40125',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma|Lincoln|Pottawatomie',
    county_weights: '{"40109": 58.61, "40081": 39.47, "40125": 1.92}',
    density: 68.4,
    imprecise: false,
    latitude: 35.51201,
    longitude: -97.1414,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73045',
  },
  {
    city: 'Hinton',
    county_fips: 40015,
    county_fips_all: '40015|40017',
    county: 'Caddo',
    county_names_all: 'Caddo|Canadian',
    county_weights: '{"40015": 55.93, "40017": 44.07}',
    density: 17.6,
    imprecise: false,
    latitude: 35.45658,
    longitude: -98.31553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73047',
  },
  {
    city: 'Hydro',
    county_fips: 40015,
    county_fips_all: '40015|40011|40039',
    county: 'Caddo',
    county_names_all: 'Caddo|Blaine|Custer',
    county_weights: '{"40015": 71.55, "40011": 21.49, "40039": 6.96}',
    density: 4.4,
    imprecise: false,
    latitude: 35.48929,
    longitude: -98.55378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73048',
  },
  {
    city: 'Jones',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 44.6,
    imprecise: false,
    latitude: 35.58617,
    longitude: -97.29695,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73049',
  },
  {
    city: 'Langston',
    county_fips: 40083,
    county_fips_all: '40083',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"40083": 100}',
    density: 319.1,
    imprecise: false,
    latitude: 35.93825,
    longitude: -97.25595,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73050',
  },
  {
    city: 'Lexington',
    county_fips: 40027,
    county_fips_all: '40027|40125',
    county: 'Cleveland',
    county_names_all: 'Cleveland|Pottawatomie',
    county_weights: '{"40027": 99.53, "40125": 0.47}',
    density: 31.3,
    imprecise: false,
    latitude: 35.03175,
    longitude: -97.24629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73051',
  },
  {
    city: 'Lindsay',
    county_fips: 40049,
    county_fips_all: '40049|40087|40051',
    county: 'Garvin',
    county_names_all: 'Garvin|McClain|Grady',
    county_weights: '{"40049": 51.68, "40087": 38.09, "40051": 10.23}',
    density: 11.8,
    imprecise: false,
    latitude: 34.83359,
    longitude: -97.59526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73052',
  },
  {
    city: 'Lookeba',
    county_fips: 40015,
    county_fips_all: '40015',
    county: 'Caddo',
    county_names_all: 'Caddo',
    county_weights: '{"40015": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 35.36248,
    longitude: -98.41841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73053',
  },
  {
    city: 'Luther',
    county_fips: 40109,
    county_fips_all: '40109|40083|40081',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma|Logan|Lincoln',
    county_weights: '{"40109": 71.29, "40083": 19.49, "40081": 9.22}',
    density: 20.2,
    imprecise: false,
    latitude: 35.67508,
    longitude: -97.19487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73054',
  },
  {
    city: 'Marlow',
    county_fips: 40137,
    county_fips_all: '40137|40051|40031',
    county: 'Stephens',
    county_names_all: 'Stephens|Grady|Comanche',
    county_weights: '{"40137": 75.26, "40051": 23.13, "40031": 1.61}',
    density: 15.2,
    imprecise: false,
    latitude: 34.64301,
    longitude: -97.91624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73055',
  },
  {
    city: 'Marshall',
    county_fips: 40047,
    county_fips_all: '40047|40083|40073',
    county: 'Garfield',
    county_names_all: 'Garfield|Logan|Kingfisher',
    county_weights: '{"40047": 52.38, "40083": 36.05, "40073": 11.57}',
    density: 1.6,
    imprecise: false,
    latitude: 36.17036,
    longitude: -97.62097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73056',
  },
  {
    city: 'Maysville',
    county_fips: 40049,
    county_fips_all: '40049|40087',
    county: 'Garvin',
    county_names_all: 'Garvin|McClain',
    county_weights: '{"40049": 66.2, "40087": 33.8}',
    density: 10.1,
    imprecise: false,
    latitude: 34.82998,
    longitude: -97.43176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73057',
  },
  {
    city: 'Meridian',
    county_fips: 40083,
    county_fips_all: '40083',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"40083": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 35.8175,
    longitude: -97.22571,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73058',
  },
  {
    city: 'Minco',
    county_fips: 40051,
    county_fips_all: '40051|40015|40017',
    county: 'Grady',
    county_names_all: 'Grady|Caddo|Canadian',
    county_weights: '{"40051": 59.01, "40015": 28.04, "40017": 12.95}',
    density: 6.6,
    imprecise: false,
    latitude: 35.3251,
    longitude: -98.05431,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73059',
  },
  {
    city: 'Morrison',
    county_fips: 40103,
    county_fips_all: '40103|40117',
    county: 'Noble',
    county_names_all: 'Noble|Pawnee',
    county_weights: '{"40103": 58.43, "40117": 41.57}',
    density: 6,
    imprecise: false,
    latitude: 36.34904,
    longitude: -97.01765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73061',
  },
  {
    city: 'Mountain View',
    county_fips: 40075,
    county_fips_all: '40075|40149',
    county: 'Kiowa',
    county_names_all: 'Kiowa|Washita',
    county_weights: '{"40075": 75.24, "40149": 24.76}',
    density: 1.8,
    imprecise: false,
    latitude: 35.02929,
    longitude: -98.73478,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73062',
  },
  {
    city: 'Mulhall',
    county_fips: 40083,
    county_fips_all: '40083|40119',
    county: 'Logan',
    county_names_all: 'Logan|Payne',
    county_weights: '{"40083": 77.35, "40119": 22.65}',
    density: 2.6,
    imprecise: false,
    latitude: 36.06195,
    longitude: -97.41832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73063',
  },
  {
    city: 'Mustang',
    county_fips: 40017,
    county_fips_all: '40017',
    county: 'Canadian',
    county_names_all: 'Canadian',
    county_weights: '{"40017": 100}',
    density: 207.8,
    imprecise: false,
    latitude: 35.37377,
    longitude: -97.75275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73064',
  },
  {
    city: 'Newcastle',
    county_fips: 40087,
    county_fips_all: '40087',
    county: 'McClain',
    county_names_all: 'McClain',
    county_weights: '{"40087": 100}',
    density: 87.1,
    imprecise: false,
    latitude: 35.25008,
    longitude: -97.61209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73065',
  },
  {
    city: 'Nicoma Park',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 209.9,
    imprecise: false,
    latitude: 35.50167,
    longitude: -97.32832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73066',
  },
  {
    city: 'Ninnekah',
    county_fips: 40051,
    county_fips_all: '40051',
    county: 'Grady',
    county_names_all: 'Grady',
    county_weights: '{"40051": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 34.90315,
    longitude: -97.90612,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73067',
  },
  {
    city: 'Noble',
    county_fips: 40027,
    county_fips_all: '40027',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"40027": 100}',
    density: 73.3,
    imprecise: false,
    latitude: 35.1384,
    longitude: -97.28264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73068',
  },
  {
    city: 'Norman',
    county_fips: 40027,
    county_fips_all: '40027',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"40027": 100}',
    density: 698.4,
    imprecise: false,
    latitude: 35.25028,
    longitude: -97.4633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73069',
  },
  {
    city: 'Norman',
    county_fips: 40027,
    county_fips_all: '40027',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"40027": 100}',
    density: 463.9,
    imprecise: false,
    latitude: 35.22763,
    longitude: -97.42729,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 97,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73070',
  },
  {
    city: 'Norman',
    county_fips: 40027,
    county_fips_all: '40027',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"40027": 100}',
    density: 725.2,
    imprecise: false,
    latitude: 35.23728,
    longitude: -97.4131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73071',
  },
  {
    city: 'Norman',
    county_fips: 40027,
    county_fips_all: '40027|40087',
    county: 'Cleveland',
    county_names_all: 'Cleveland|McClain',
    county_weights: '{"40027": 66.34, "40087": 33.66}',
    density: 376.3,
    imprecise: false,
    latitude: 35.21106,
    longitude: -97.50518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73072',
  },
  {
    city: 'Orlando',
    county_fips: 40103,
    county_fips_all: '40103|40119|40083|40047',
    county: 'Noble',
    county_names_all: 'Noble|Payne|Logan|Garfield',
    county_weights:
      '{"40103": 30.67, "40119": 25.89, "40083": 25.79, "40047": 17.65}',
    density: 2.3,
    imprecise: false,
    latitude: 36.16302,
    longitude: -97.39614,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73073',
  },
  {
    city: 'Paoli',
    county_fips: 40049,
    county_fips_all: '40049|40087',
    county: 'Garvin',
    county_names_all: 'Garvin|McClain',
    county_weights: '{"40049": 78.19, "40087": 21.81}',
    density: 11,
    imprecise: false,
    latitude: 34.83269,
    longitude: -97.27917,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73074',
  },
  {
    city: 'Pauls Valley',
    county_fips: 40049,
    county_fips_all: '40049',
    county: 'Garvin',
    county_names_all: 'Garvin',
    county_weights: '{"40049": 100}',
    density: 26,
    imprecise: false,
    latitude: 34.75187,
    longitude: -97.23428,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73075',
  },
  {
    city: 'Perry',
    county_fips: 40103,
    county_fips_all: '40103',
    county: 'Noble',
    county_names_all: 'Noble',
    county_weights: '{"40103": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 36.30428,
    longitude: -97.26981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73077',
  },
  {
    city: 'Piedmont',
    county_fips: 40017,
    county_fips_all: '40017|40109',
    county: 'Canadian',
    county_names_all: 'Canadian|Oklahoma',
    county_weights: '{"40017": 99.83, "40109": 0.17}',
    density: 77.4,
    imprecise: false,
    latitude: 35.66867,
    longitude: -97.75304,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73078',
  },
  {
    city: 'Pocasset',
    county_fips: 40051,
    county_fips_all: '40051|40015',
    county: 'Grady',
    county_names_all: 'Grady|Caddo',
    county_weights: '{"40051": 79.2, "40015": 20.8}',
    density: 3.2,
    imprecise: false,
    latitude: 35.20941,
    longitude: -98.01397,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73079',
  },
  {
    city: 'Purcell',
    county_fips: 40087,
    county_fips_all: '40087',
    county: 'McClain',
    county_names_all: 'McClain',
    county_weights: '{"40087": 100}',
    density: 41.5,
    imprecise: false,
    latitude: 35.00725,
    longitude: -97.452,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73080',
  },
  {
    city: 'Rush Springs',
    county_fips: 40051,
    county_fips_all: '40051|40031',
    county: 'Grady',
    county_names_all: 'Grady|Comanche',
    county_weights: '{"40051": 97.51, "40031": 2.49}',
    density: 6.6,
    imprecise: false,
    latitude: 34.77266,
    longitude: -97.90385,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73082',
  },
  {
    city: 'Spencer',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 142.8,
    imprecise: false,
    latitude: 35.52567,
    longitude: -97.34645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73084',
  },
  {
    city: 'Sulphur',
    county_fips: 40099,
    county_fips_all: '40099|40069',
    county: 'Murray',
    county_names_all: 'Murray|Johnston',
    county_weights: '{"40099": 98.43, "40069": 1.57}',
    density: 20.4,
    imprecise: false,
    latitude: 34.48915,
    longitude: -96.97251,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73086',
  },
  {
    city: 'Tuttle',
    county_fips: 40051,
    county_fips_all: '40051',
    county: 'Grady',
    county_names_all: 'Grady',
    county_weights: '{"40051": 100}',
    density: 51.7,
    imprecise: false,
    latitude: 35.2661,
    longitude: -97.79638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73089',
  },
  {
    city: 'Union City',
    county_fips: 40017,
    county_fips_all: '40017',
    county: 'Canadian',
    county_names_all: 'Canadian',
    county_weights: '{"40017": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 35.39706,
    longitude: -97.96116,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73090',
  },
  {
    city: 'Verden',
    county_fips: 40051,
    county_fips_all: '40051|40015',
    county: 'Grady',
    county_names_all: 'Grady|Caddo',
    county_weights: '{"40051": 53.02, "40015": 46.98}',
    density: 5.3,
    imprecise: false,
    latitude: 35.1238,
    longitude: -98.08735,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73092',
  },
  {
    city: 'Washington',
    county_fips: 40087,
    county_fips_all: '40087',
    county: 'McClain',
    county_names_all: 'McClain',
    county_weights: '{"40087": 100}',
    density: 25,
    imprecise: false,
    latitude: 35.10321,
    longitude: -97.4966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73093',
  },
  {
    city: 'Wayne',
    county_fips: 40087,
    county_fips_all: '40087',
    county: 'McClain',
    county_names_all: 'McClain',
    county_weights: '{"40087": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 34.90677,
    longitude: -97.28423,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73095',
  },
  {
    city: 'Weatherford',
    county_fips: 40039,
    county_fips_all: '40039|40149|40011',
    county: 'Custer',
    county_names_all: 'Custer|Washita|Blaine',
    county_weights: '{"40039": 69.38, "40149": 29.59, "40011": 1.03}',
    density: 28.7,
    imprecise: false,
    latitude: 35.51305,
    longitude: -98.7295,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73096',
  },
  {
    city: 'Wheatland',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 69.3,
    imprecise: false,
    latitude: 35.39893,
    longitude: -97.64501,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73097',
  },
  {
    city: 'Wynnewood',
    county_fips: 40049,
    county_fips_all: '40049|40099',
    county: 'Garvin',
    county_names_all: 'Garvin|Murray',
    county_weights: '{"40049": 80.98, "40099": 19.02}',
    density: 9.5,
    imprecise: false,
    latitude: 34.62753,
    longitude: -97.16537,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73098',
  },
  {
    city: 'Yukon',
    county_fips: 40017,
    county_fips_all: '40017',
    county: 'Canadian',
    county_names_all: 'Canadian',
    county_weights: '{"40017": 100}',
    density: 281.8,
    imprecise: false,
    latitude: 35.52583,
    longitude: -97.76343,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 91014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73099',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1845.5,
    imprecise: false,
    latitude: 35.47065,
    longitude: -97.5191,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73102',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1801.9,
    imprecise: false,
    latitude: 35.48906,
    longitude: -97.51897,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73103',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 908.4,
    imprecise: false,
    latitude: 35.47508,
    longitude: -97.5038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73104',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 507,
    imprecise: false,
    latitude: 35.51919,
    longitude: -97.50331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73105',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1543.5,
    imprecise: false,
    latitude: 35.4823,
    longitude: -97.53662,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73106',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1315,
    imprecise: false,
    latitude: 35.48201,
    longitude: -97.5744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73107',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 754,
    imprecise: false,
    latitude: 35.45034,
    longitude: -97.56774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73108',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1527.6,
    imprecise: false,
    latitude: 35.43279,
    longitude: -97.52452,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73109',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 808,
    imprecise: false,
    latitude: 35.44808,
    longitude: -97.3945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73110',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 482.2,
    imprecise: false,
    latitude: 35.51889,
    longitude: -97.47722,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73111',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1538.6,
    imprecise: false,
    latitude: 35.51823,
    longitude: -97.5745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73112',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 719.1,
    imprecise: false,
    latitude: 35.57916,
    longitude: -97.51784,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73114',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1322.3,
    imprecise: false,
    latitude: 35.44232,
    longitude: -97.44153,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73115',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 714.2,
    imprecise: false,
    latitude: 35.54684,
    longitude: -97.56519,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73116',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 373.4,
    imprecise: false,
    latitude: 35.47474,
    longitude: -97.45961,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73117',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1137.1,
    imprecise: false,
    latitude: 35.51788,
    longitude: -97.53007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73118',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1725.4,
    imprecise: false,
    latitude: 35.4215,
    longitude: -97.56896,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73119',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1242.7,
    imprecise: false,
    latitude: 35.58049,
    longitude: -97.57248,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73120',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 122.2,
    imprecise: false,
    latitude: 35.52181,
    longitude: -97.44236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73121',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1435.9,
    imprecise: false,
    latitude: 35.5202,
    longitude: -97.61391,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73122',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109|40017',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma|Canadian',
    county_weights: '{"40109": 75.79, "40017": 24.21}',
    density: 880,
    imprecise: false,
    latitude: 35.47785,
    longitude: -97.64836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73127',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109|40017',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma|Canadian',
    county_weights: '{"40109": 76.49, "40017": 23.51}',
    density: 330.2,
    imprecise: false,
    latitude: 35.44899,
    longitude: -97.64595,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73128',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 616.3,
    imprecise: false,
    latitude: 35.43165,
    longitude: -97.48433,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73129',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 831.6,
    imprecise: false,
    latitude: 35.45879,
    longitude: -97.34586,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73130',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 123.3,
    imprecise: false,
    latitude: 35.57653,
    longitude: -97.46465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73131',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1413.5,
    imprecise: false,
    latitude: 35.54984,
    longitude: -97.64074,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73132',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 662.7,
    imprecise: false,
    latitude: 35.6151,
    longitude: -97.56935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73134',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109|40027',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma|Cleveland',
    county_weights: '{"40109": 97.26, "40027": 2.74}',
    density: 774.7,
    imprecise: false,
    latitude: 35.39644,
    longitude: -97.42692,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73135',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109|40027',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma|Cleveland',
    county_weights: '{"40109": 67.43, "40027": 32.57}',
    density: 1571.1,
    imprecise: false,
    latitude: 35.38457,
    longitude: -97.52572,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73139',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 127,
    imprecise: false,
    latitude: 35.51702,
    longitude: -97.39876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73141',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 869.4,
    imprecise: false,
    latitude: 35.60937,
    longitude: -97.63895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73142',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1015.7,
    imprecise: false,
    latitude: 35.42427,
    longitude: -97.41403,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73145',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109|40027',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma|Cleveland',
    county_weights: '{"40109": 93.08, "40027": 6.92}',
    density: 429.9,
    imprecise: false,
    latitude: 35.3892,
    longitude: -97.48908,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73149',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109|40027',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma|Cleveland',
    county_weights: '{"40109": 98.12, "40027": 1.88}',
    density: 117.2,
    imprecise: false,
    latitude: 35.40059,
    longitude: -97.33214,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73150',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 291.3,
    imprecise: false,
    latitude: 35.56783,
    longitude: -97.41049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73151',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109|40027',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma|Cleveland',
    county_weights: '{"40109": 68.43, "40027": 31.57}',
    density: 887.3,
    imprecise: false,
    latitude: 35.38563,
    longitude: -97.5794,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73159',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40027,
    county_fips_all: '40027',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"40027": 100}',
    density: 1129.9,
    imprecise: false,
    latitude: 35.33574,
    longitude: -97.47651,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 62690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73160',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma',
    county_weights: '{"40109": 100}',
    density: 1573.1,
    imprecise: false,
    latitude: 35.58095,
    longitude: -97.6415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73162',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40027,
    county_fips_all: '40027',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"40027": 100}',
    density: 78.8,
    imprecise: false,
    latitude: 35.34181,
    longitude: -97.36138,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73165',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109|40027',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma|Cleveland',
    county_weights: '{"40109": 60.51, "40027": 39.49}',
    density: 160,
    imprecise: false,
    latitude: 35.3815,
    longitude: -97.64538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73169',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40027,
    county_fips_all: '40027',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"40027": 100}',
    density: 762.4,
    imprecise: false,
    latitude: 35.32743,
    longitude: -97.55068,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73170',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40027,
    county_fips_all: '40027',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"40027": 100}',
    density: 136.2,
    imprecise: false,
    latitude: 35.34033,
    longitude: -97.62463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73173',
  },
  {
    city: 'Oklahoma City',
    county_fips: 40109,
    county_fips_all: '40109|40017',
    county: 'Oklahoma',
    county_names_all: 'Oklahoma|Canadian',
    county_weights: '{"40109": 83.0, "40017": 17.0}',
    density: 279.3,
    imprecise: false,
    latitude: 35.4231,
    longitude: -97.64521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73179',
  },
  {
    city: 'Ardmore',
    county_fips: 40019,
    county_fips_all: '40019|40085|40069',
    county: 'Carter',
    county_names_all: 'Carter|Love|Johnston',
    county_weights: '{"40019": 96.86, "40085": 2.82, "40069": 0.32}',
    density: 40.5,
    imprecise: false,
    latitude: 34.21045,
    longitude: -97.11434,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73401',
  },
  {
    city: 'Countyline',
    county_fips: 40137,
    county_fips_all: '40137|40019',
    county: 'Stephens',
    county_names_all: 'Stephens|Carter',
    county_weights: '{"40137": 52.76, "40019": 47.24}',
    density: 16.4,
    imprecise: false,
    latitude: 34.45838,
    longitude: -97.56239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73425',
  },
  {
    city: 'Burneyville',
    county_fips: 40085,
    county_fips_all: '40085',
    county: 'Love',
    county_names_all: 'Love',
    county_weights: '{"40085": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 33.91,
    longitude: -97.36106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73430',
  },
  {
    city: 'Coleman',
    county_fips: 40069,
    county_fips_all: '40069|40005',
    county: 'Johnston',
    county_names_all: 'Johnston|Atoka',
    county_weights: '{"40069": 67.23, "40005": 32.77}',
    density: 5.6,
    imprecise: false,
    latitude: 34.25605,
    longitude: -96.42311,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73432',
  },
  {
    city: 'Elmore City',
    county_fips: 40049,
    county_fips_all: '40049',
    county: 'Garvin',
    county_names_all: 'Garvin',
    county_weights: '{"40049": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 34.62352,
    longitude: -97.40868,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73433',
  },
  {
    city: 'Foster',
    county_fips: 40137,
    county_fips_all: '40137|40049',
    county: 'Stephens',
    county_names_all: 'Stephens|Garvin',
    county_weights: '{"40137": 55.21, "40049": 44.79}',
    density: 2.3,
    imprecise: false,
    latitude: 34.62083,
    longitude: -97.58286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73434',
  },
  {
    city: 'Fox',
    county_fips: 40019,
    county_fips_all: '40019',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"40019": 100}',
    density: 42.4,
    imprecise: false,
    latitude: 34.36008,
    longitude: -97.49281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73435',
  },
  {
    city: 'Gene Autry',
    county_fips: 40019,
    county_fips_all: '40019',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"40019": 100}',
    density: 208.9,
    imprecise: false,
    latitude: 34.28406,
    longitude: -97.03856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73436',
  },
  {
    city: 'Graham',
    county_fips: 40019,
    county_fips_all: '40019',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"40019": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 34.36193,
    longitude: -97.41558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73437',
  },
  {
    city: 'Healdton',
    county_fips: 40019,
    county_fips_all: '40019',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"40019": 100}',
    density: 16.1,
    imprecise: false,
    latitude: 34.27967,
    longitude: -97.49808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73438',
  },
  {
    city: 'Kingston',
    county_fips: 40095,
    county_fips_all: '40095',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"40095": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 33.93643,
    longitude: -96.74708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73439',
  },
  {
    city: 'Lebanon',
    county_fips: 40095,
    county_fips_all: '40095',
    county: 'Marshall',
    county_names_all: 'Marshall',
    county_weights: '{"40095": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 33.95163,
    longitude: -96.89635,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73440',
  },
  {
    city: 'Leon',
    county_fips: 40085,
    county_fips_all: '40085',
    county: 'Love',
    county_names_all: 'Love',
    county_weights: '{"40085": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 33.8674,
    longitude: -97.44021,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73441',
  },
  {
    city: 'Loco',
    county_fips: 40137,
    county_fips_all: '40137|40067',
    county: 'Stephens',
    county_names_all: 'Stephens|Jefferson',
    county_weights: '{"40137": 83.15, "40067": 16.85}',
    density: 1,
    imprecise: false,
    latitude: 34.31982,
    longitude: -97.69569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73442',
  },
  {
    city: 'Lone Grove',
    county_fips: 40019,
    county_fips_all: '40019',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"40019": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 34.16258,
    longitude: -97.29081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73443',
  },
  {
    city: 'Hennepin',
    county_fips: 40019,
    county_fips_all: '40019|40099|40049',
    county: 'Carter',
    county_names_all: 'Carter|Murray|Garvin',
    county_weights: '{"40019": 86.23, "40099": 12.76, "40049": 1.01}',
    density: 2.6,
    imprecise: false,
    latitude: 34.4875,
    longitude: -97.38256,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73444',
  },
  {
    city: 'Madill',
    county_fips: 40095,
    county_fips_all: '40095|40019',
    county: 'Marshall',
    county_names_all: 'Marshall|Carter',
    county_weights: '{"40095": 99.66, "40019": 0.34}',
    density: 14,
    imprecise: false,
    latitude: 34.0891,
    longitude: -96.77806,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73446',
  },
  {
    city: 'Mannsville',
    county_fips: 40069,
    county_fips_all: '40069',
    county: 'Johnston',
    county_names_all: 'Johnston',
    county_weights: '{"40069": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 34.22463,
    longitude: -96.84616,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73447',
  },
  {
    city: 'Marietta',
    county_fips: 40085,
    county_fips_all: '40085',
    county: 'Love',
    county_names_all: 'Love',
    county_weights: '{"40085": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 33.94813,
    longitude: -97.10581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73448',
  },
  {
    city: 'Mead',
    county_fips: 40013,
    county_fips_all: '40013',
    county: 'Bryan',
    county_names_all: 'Bryan',
    county_weights: '{"40013": 100}',
    density: 32.7,
    imprecise: false,
    latitude: 33.99471,
    longitude: -96.54114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73449',
  },
  {
    city: 'Milburn',
    county_fips: 40069,
    county_fips_all: '40069',
    county: 'Johnston',
    county_names_all: 'Johnston',
    county_weights: '{"40069": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 34.26689,
    longitude: -96.53801,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73450',
  },
  {
    city: 'Overbrook',
    county_fips: 40085,
    county_fips_all: '40085|40019',
    county: 'Love',
    county_names_all: 'Love|Carter',
    county_weights: '{"40085": 98.83, "40019": 1.17}',
    density: 3.7,
    imprecise: false,
    latitude: 34.03473,
    longitude: -97.27046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73453',
  },
  {
    city: 'Ravia',
    county_fips: 40069,
    county_fips_all: '40069',
    county: 'Johnston',
    county_names_all: 'Johnston',
    county_weights: '{"40069": 100}',
    density: 29.5,
    imprecise: false,
    latitude: 34.22651,
    longitude: -96.75997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73455',
  },
  {
    city: 'Ringling',
    county_fips: 40067,
    county_fips_all: '40067|40085|40019',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Love|Carter',
    county_weights: '{"40067": 79.29, "40085": 10.88, "40019": 9.83}',
    density: 2.6,
    imprecise: false,
    latitude: 34.12211,
    longitude: -97.62412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73456',
  },
  {
    city: 'Springer',
    county_fips: 40019,
    county_fips_all: '40019',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"40019": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 34.35818,
    longitude: -97.29782,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73458',
  },
  {
    city: 'Thackerville',
    county_fips: 40085,
    county_fips_all: '40085',
    county: 'Love',
    county_names_all: 'Love',
    county_weights: '{"40085": 100}',
    density: 17,
    imprecise: false,
    latitude: 33.77534,
    longitude: -97.14213,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73459',
  },
  {
    city: 'Tishomingo',
    county_fips: 40069,
    county_fips_all: '40069',
    county: 'Johnston',
    county_names_all: 'Johnston',
    county_weights: '{"40069": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 34.28789,
    longitude: -96.66689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73460',
  },
  {
    city: 'Wapanucka',
    county_fips: 40069,
    county_fips_all: '40069|40005',
    county: 'Johnston',
    county_names_all: 'Johnston|Atoka',
    county_weights: '{"40069": 66.17, "40005": 33.83}',
    density: 3.8,
    imprecise: false,
    latitude: 34.35726,
    longitude: -96.43418,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73461',
  },
  {
    city: 'Wilson',
    county_fips: 40019,
    county_fips_all: '40019|40085',
    county: 'Carter',
    county_names_all: 'Carter|Love',
    county_weights: '{"40019": 68.06, "40085": 31.94}',
    density: 7.2,
    imprecise: false,
    latitude: 34.11584,
    longitude: -97.42905,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73463',
  },
  {
    city: 'Ratliff City',
    county_fips: 40019,
    county_fips_all: '40019|40137|40049',
    county: 'Carter',
    county_names_all: 'Carter|Stephens|Garvin',
    county_weights: '{"40019": 74.14, "40137": 17.02, "40049": 8.84}',
    density: 4.2,
    imprecise: false,
    latitude: 34.42229,
    longitude: -97.51955,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73481',
  },
  {
    city: 'Tatums',
    county_fips: 40019,
    county_fips_all: '40019',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"40019": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 34.47327,
    longitude: -97.4428,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73487',
  },
  {
    city: 'Tussy',
    county_fips: 40019,
    county_fips_all: '40019',
    county: 'Carter',
    county_names_all: 'Carter',
    county_weights: '{"40019": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 34.49502,
    longitude: -97.54724,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73488',
  },
  {
    city: 'Velma',
    county_fips: 40137,
    county_fips_all: '40137',
    county: 'Stephens',
    county_names_all: 'Stephens',
    county_weights: '{"40137": 100}',
    density: 29.4,
    imprecise: false,
    latitude: 34.4637,
    longitude: -97.65845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73491',
  },
  {
    city: 'Lawton',
    county_fips: 40031,
    county_fips_all: '40031',
    county: 'Comanche',
    county_names_all: 'Comanche',
    county_weights: '{"40031": 100}',
    density: 75,
    imprecise: false,
    latitude: 34.56211,
    longitude: -98.2864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73501',
  },
  {
    city: 'Fort Sill',
    county_fips: 40031,
    county_fips_all: '40031',
    county: 'Comanche',
    county_names_all: 'Comanche',
    county_weights: '{"40031": 100}',
    density: 59.7,
    imprecise: false,
    latitude: 34.67348,
    longitude: -98.49649,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73503',
  },
  {
    city: 'Lawton',
    county_fips: 40031,
    county_fips_all: '40031',
    county: 'Comanche',
    county_names_all: 'Comanche',
    county_weights: '{"40031": 100}',
    density: 285.6,
    imprecise: false,
    latitude: 34.5718,
    longitude: -98.4834,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73505',
  },
  {
    city: 'Lawton',
    county_fips: 40031,
    county_fips_all: '40031',
    county: 'Comanche',
    county_names_all: 'Comanche',
    county_weights: '{"40031": 100}',
    density: 33.3,
    imprecise: false,
    latitude: 34.74802,
    longitude: -98.50201,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73507',
  },
  {
    city: 'Addington',
    county_fips: 40067,
    county_fips_all: '40067',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"40067": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 34.26148,
    longitude: -97.97856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73520',
  },
  {
    city: 'Altus',
    county_fips: 40065,
    county_fips_all: '40065',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"40065": 100}',
    density: 41.9,
    imprecise: false,
    latitude: 34.63547,
    longitude: -99.31538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73521',
  },
  {
    city: 'Blair',
    county_fips: 40065,
    county_fips_all: '40065|40055',
    county: 'Jackson',
    county_names_all: 'Jackson|Greer',
    county_weights: '{"40065": 85.21, "40055": 14.79}',
    density: 9.9,
    imprecise: false,
    latitude: 34.79244,
    longitude: -99.26704,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73526',
  },
  {
    city: 'Cache',
    county_fips: 40031,
    county_fips_all: '40031',
    county: 'Comanche',
    county_names_all: 'Comanche',
    county_weights: '{"40031": 100}',
    density: 25.9,
    imprecise: false,
    latitude: 34.5724,
    longitude: -98.62704,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73527',
  },
  {
    city: 'Chattanooga',
    county_fips: 40033,
    county_fips_all: '40033|40141|40031',
    county: 'Cotton',
    county_names_all: 'Cotton|Tillman|Comanche',
    county_weights: '{"40033": 47.37, "40141": 39.74, "40031": 12.89}',
    density: 2.3,
    imprecise: false,
    latitude: 34.4033,
    longitude: -98.6452,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73528',
  },
  {
    city: 'Comanche',
    county_fips: 40137,
    county_fips_all: '40137|40067|40033',
    county: 'Stephens',
    county_names_all: 'Stephens|Jefferson|Cotton',
    county_weights: '{"40137": 74.86, "40067": 23.47, "40033": 1.67}',
    density: 7.9,
    imprecise: false,
    latitude: 34.34146,
    longitude: -97.94619,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73529',
  },
  {
    city: 'Davidson',
    county_fips: 40141,
    county_fips_all: '40141',
    county: 'Tillman',
    county_names_all: 'Tillman',
    county_weights: '{"40141": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 34.25845,
    longitude: -99.05664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73530',
  },
  {
    city: 'Devol',
    county_fips: 40033,
    county_fips_all: '40033',
    county: 'Cotton',
    county_names_all: 'Cotton',
    county_weights: '{"40033": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 34.18845,
    longitude: -98.52703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73531',
  },
  {
    city: 'Duke',
    county_fips: 40065,
    county_fips_all: '40065|40057',
    county: 'Jackson',
    county_names_all: 'Jackson|Harmon',
    county_weights: '{"40065": 87.74, "40057": 12.26}',
    density: 1.1,
    imprecise: false,
    latitude: 34.62768,
    longitude: -99.59637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73532',
  },
  {
    city: 'Duncan',
    county_fips: 40137,
    county_fips_all: '40137|40033',
    county: 'Stephens',
    county_names_all: 'Stephens|Cotton',
    county_weights: '{"40137": 99.69, "40033": 0.31}',
    density: 32.4,
    imprecise: false,
    latitude: 34.49484,
    longitude: -97.84774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73533',
  },
  {
    city: 'Eldorado',
    county_fips: 40065,
    county_fips_all: '40065|40057',
    county: 'Jackson',
    county_names_all: 'Jackson|Harmon',
    county_weights: '{"40065": 80.25, "40057": 19.75}',
    density: 1.4,
    imprecise: false,
    latitude: 34.46994,
    longitude: -99.67189,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73537',
  },
  {
    city: 'Elgin',
    county_fips: 40031,
    county_fips_all: '40031',
    county: 'Comanche',
    county_names_all: 'Comanche',
    county_weights: '{"40031": 100}',
    density: 34,
    imprecise: false,
    latitude: 34.74056,
    longitude: -98.30743,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73538',
  },
  {
    city: 'Elmer',
    county_fips: 40065,
    county_fips_all: '40065',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"40065": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 34.45202,
    longitude: -99.27649,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73539',
  },
  {
    city: 'Faxon',
    county_fips: 40031,
    county_fips_all: '40031|40033',
    county: 'Comanche',
    county_names_all: 'Comanche|Cotton',
    county_weights: '{"40031": 96.65, "40033": 3.35}',
    density: 2.1,
    imprecise: false,
    latitude: 34.47099,
    longitude: -98.55756,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73540',
  },
  {
    city: 'Fletcher',
    county_fips: 40031,
    county_fips_all: '40031',
    county: 'Comanche',
    county_names_all: 'Comanche',
    county_weights: '{"40031": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 34.78716,
    longitude: -98.1788,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73541',
  },
  {
    city: 'Frederick',
    county_fips: 40141,
    county_fips_all: '40141',
    county: 'Tillman',
    county_names_all: 'Tillman',
    county_weights: '{"40141": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 34.4024,
    longitude: -98.93893,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73542',
  },
  {
    city: 'Geronimo',
    county_fips: 40031,
    county_fips_all: '40031|40033',
    county: 'Comanche',
    county_names_all: 'Comanche|Cotton',
    county_weights: '{"40031": 71.56, "40033": 28.44}',
    density: 11.5,
    imprecise: false,
    latitude: 34.46389,
    longitude: -98.38385,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73543',
  },
  {
    city: 'Gould',
    county_fips: 40057,
    county_fips_all: '40057',
    county: 'Harmon',
    county_names_all: 'Harmon',
    county_weights: '{"40057": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 34.65379,
    longitude: -99.75016,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73544',
  },
  {
    city: 'Grandfield',
    county_fips: 40141,
    county_fips_all: '40141|40033',
    county: 'Tillman',
    county_names_all: 'Tillman|Cotton',
    county_weights: '{"40141": 92.08, "40033": 7.92}',
    density: 2.6,
    imprecise: false,
    latitude: 34.22336,
    longitude: -98.73053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73546',
  },
  {
    city: 'Granite',
    county_fips: 40055,
    county_fips_all: '40055',
    county: 'Greer',
    county_names_all: 'Greer',
    county_weights: '{"40055": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 34.98651,
    longitude: -99.40507,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73547',
  },
  {
    city: 'Hastings',
    county_fips: 40033,
    county_fips_all: '40033|40067|40137',
    county: 'Cotton',
    county_names_all: 'Cotton|Jefferson|Stephens',
    county_weights: '{"40033": 46.0, "40067": 43.54, "40137": 10.45}',
    density: 2.7,
    imprecise: false,
    latitude: 34.21427,
    longitude: -98.13818,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73548',
  },
  {
    city: 'Headrick',
    county_fips: 40065,
    county_fips_all: '40065',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"40065": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 34.65222,
    longitude: -99.15607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73549',
  },
  {
    city: 'Hollis',
    county_fips: 40057,
    county_fips_all: '40057',
    county: 'Harmon',
    county_names_all: 'Harmon',
    county_weights: '{"40057": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 34.7101,
    longitude: -99.89631,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73550',
  },
  {
    city: 'Hollister',
    county_fips: 40141,
    county_fips_all: '40141',
    county: 'Tillman',
    county_names_all: 'Tillman',
    county_weights: '{"40141": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 34.30754,
    longitude: -98.87487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73551',
  },
  {
    city: 'Indiahoma',
    county_fips: 40031,
    county_fips_all: '40031|40075',
    county: 'Comanche',
    county_names_all: 'Comanche|Kiowa',
    county_weights: '{"40031": 98.38, "40075": 1.62}',
    density: 5,
    imprecise: false,
    latitude: 34.62709,
    longitude: -98.75631,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73552',
  },
  {
    city: 'Loveland',
    county_fips: 40141,
    county_fips_all: '40141',
    county: 'Tillman',
    county_names_all: 'Tillman',
    county_weights: '{"40141": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 34.33066,
    longitude: -98.70295,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73553',
  },
  {
    city: 'Mangum',
    county_fips: 40055,
    county_fips_all: '40055|40057|40065',
    county: 'Greer',
    county_names_all: 'Greer|Harmon|Jackson',
    county_weights: '{"40055": 85.55, "40057": 13.42, "40065": 1.03}',
    density: 3.6,
    imprecise: false,
    latitude: 34.85562,
    longitude: -99.60118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73554',
  },
  {
    city: 'Manitou',
    county_fips: 40141,
    county_fips_all: '40141',
    county: 'Tillman',
    county_names_all: 'Tillman',
    county_weights: '{"40141": 100}',
    density: 5,
    imprecise: false,
    latitude: 34.50539,
    longitude: -98.9639,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73555',
  },
  {
    city: 'Martha',
    county_fips: 40065,
    county_fips_all: '40065',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"40065": 100}',
    density: 205.2,
    imprecise: false,
    latitude: 34.72617,
    longitude: -99.38673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73556',
  },
  {
    city: 'Medicine Park',
    county_fips: 40031,
    county_fips_all: '40031',
    county: 'Comanche',
    county_names_all: 'Comanche',
    county_weights: '{"40031": 100}',
    density: 110.4,
    imprecise: false,
    latitude: 34.73072,
    longitude: -98.50022,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73557',
  },
  {
    city: 'Mountain Park',
    county_fips: 40075,
    county_fips_all: '40075|40031',
    county: 'Kiowa',
    county_names_all: 'Kiowa|Comanche',
    county_weights: '{"40075": 85.56, "40031": 14.44}',
    density: 1,
    imprecise: false,
    latitude: 34.73473,
    longitude: -98.94317,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73559',
  },
  {
    city: 'Olustee',
    county_fips: 40065,
    county_fips_all: '40065',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"40065": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 34.54307,
    longitude: -99.45024,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73560',
  },
  {
    city: 'Randlett',
    county_fips: 40033,
    county_fips_all: '40033',
    county: 'Cotton',
    county_names_all: 'Cotton',
    county_weights: '{"40033": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 34.19469,
    longitude: -98.41203,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 535,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73562',
  },
  {
    city: 'Roosevelt',
    county_fips: 40075,
    county_fips_all: '40075',
    county: 'Kiowa',
    county_names_all: 'Kiowa',
    county_weights: '{"40075": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 34.84444,
    longitude: -99.00729,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73564',
  },
  {
    city: 'Ryan',
    county_fips: 40067,
    county_fips_all: '40067',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"40067": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 34.02326,
    longitude: -97.8751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73565',
  },
  {
    city: 'Snyder',
    county_fips: 40075,
    county_fips_all: '40075|40141',
    county: 'Kiowa',
    county_names_all: 'Kiowa|Tillman',
    county_weights: '{"40075": 57.35, "40141": 42.65}',
    density: 5.1,
    imprecise: false,
    latitude: 34.61647,
    longitude: -98.94258,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73566',
  },
  {
    city: 'Sterling',
    county_fips: 40031,
    county_fips_all: '40031',
    county: 'Comanche',
    county_names_all: 'Comanche',
    county_weights: '{"40031": 100}',
    density: 244.6,
    imprecise: false,
    latitude: 34.7474,
    longitude: -98.17093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73567',
  },
  {
    city: 'Temple',
    county_fips: 40033,
    county_fips_all: '40033',
    county: 'Cotton',
    county_names_all: 'Cotton',
    county_weights: '{"40033": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 34.26327,
    longitude: -98.21629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73568',
  },
  {
    city: 'Terral',
    county_fips: 40067,
    county_fips_all: '40067',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"40067": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 33.93772,
    longitude: -97.80363,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73569',
  },
  {
    city: 'Tipton',
    county_fips: 40141,
    county_fips_all: '40141',
    county: 'Tillman',
    county_names_all: 'Tillman',
    county_weights: '{"40141": 100}',
    density: 3,
    imprecise: false,
    latitude: 34.50988,
    longitude: -99.1071,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73570',
  },
  {
    city: 'Vinson',
    county_fips: 40057,
    county_fips_all: '40057',
    county: 'Harmon',
    county_names_all: 'Harmon',
    county_weights: '{"40057": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 34.9325,
    longitude: -99.92476,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73571',
  },
  {
    city: 'Walters',
    county_fips: 40033,
    county_fips_all: '40033|40031',
    county: 'Cotton',
    county_names_all: 'Cotton|Comanche',
    county_weights: '{"40033": 96.22, "40031": 3.78}',
    density: 4.8,
    imprecise: false,
    latitude: 34.37318,
    longitude: -98.32638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73572',
  },
  {
    city: 'Waurika',
    county_fips: 40067,
    county_fips_all: '40067|40137',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Stephens',
    county_weights: '{"40067": 99.7, "40137": 0.3}',
    density: 4.8,
    imprecise: false,
    latitude: 34.1556,
    longitude: -97.95412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73573',
  },
  {
    city: 'Clinton',
    county_fips: 40039,
    county_fips_all: '40039|40149',
    county: 'Custer',
    county_names_all: 'Custer|Washita',
    county_weights: '{"40039": 73.55, "40149": 26.45}',
    density: 26.9,
    imprecise: false,
    latitude: 35.49859,
    longitude: -98.94694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73601',
  },
  {
    city: 'Arapaho',
    county_fips: 40039,
    county_fips_all: '40039',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"40039": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 35.61387,
    longitude: -99.02278,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73620',
  },
  {
    city: 'Bessie',
    county_fips: 40149,
    county_fips_all: '40149',
    county: 'Washita',
    county_names_all: 'Washita',
    county_weights: '{"40149": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 35.39518,
    longitude: -98.99791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73622',
  },
  {
    city: 'Burns Flat',
    county_fips: 40149,
    county_fips_all: '40149',
    county: 'Washita',
    county_names_all: 'Washita',
    county_weights: '{"40149": 100}',
    density: 143.7,
    imprecise: false,
    latitude: 35.35969,
    longitude: -99.1719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73624',
  },
  {
    city: 'Butler',
    county_fips: 40039,
    county_fips_all: '40039',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"40039": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 35.6964,
    longitude: -99.19698,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73625',
  },
  {
    city: 'Canute',
    county_fips: 40149,
    county_fips_all: '40149|40039',
    county: 'Washita',
    county_names_all: 'Washita|Custer',
    county_weights: '{"40149": 54.78, "40039": 45.22}',
    density: 3.7,
    imprecise: false,
    latitude: 35.43965,
    longitude: -99.27941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73626',
  },
  {
    city: 'Carter',
    county_fips: 40009,
    county_fips_all: '40009|40149',
    county: 'Beckham',
    county_names_all: 'Beckham|Washita',
    county_weights: '{"40009": 98.05, "40149": 1.95}',
    density: 2,
    imprecise: false,
    latitude: 35.20169,
    longitude: -99.45218,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73627',
  },
  {
    city: 'Cheyenne',
    county_fips: 40129,
    county_fips_all: '40129',
    county: 'Roger Mills',
    county_names_all: 'Roger Mills',
    county_weights: '{"40129": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 35.62668,
    longitude: -99.68783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73628',
  },
  {
    city: 'Cordell',
    county_fips: 40149,
    county_fips_all: '40149',
    county: 'Washita',
    county_names_all: 'Washita',
    county_weights: '{"40149": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 35.27036,
    longitude: -98.90853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73632',
  },
  {
    city: 'Crawford',
    county_fips: 40129,
    county_fips_all: '40129',
    county: 'Roger Mills',
    county_names_all: 'Roger Mills',
    county_weights: '{"40129": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 35.86532,
    longitude: -99.79059,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73638',
  },
  {
    city: 'Custer City',
    county_fips: 40039,
    county_fips_all: '40039',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"40039": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 35.72666,
    longitude: -98.95578,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73639',
  },
  {
    city: 'Dill City',
    county_fips: 40149,
    county_fips_all: '40149',
    county: 'Washita',
    county_names_all: 'Washita',
    county_weights: '{"40149": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 35.26875,
    longitude: -99.20252,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73641',
  },
  {
    city: 'Durham',
    county_fips: 40129,
    county_fips_all: '40129',
    county: 'Roger Mills',
    county_names_all: 'Roger Mills',
    county_weights: '{"40129": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 35.81909,
    longitude: -99.90887,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73642',
  },
  {
    city: 'Elk City',
    county_fips: 40009,
    county_fips_all: '40009|40149|40129|40039',
    county: 'Beckham',
    county_names_all: 'Beckham|Washita|Roger Mills|Custer',
    county_weights:
      '{"40009": 80.3, "40149": 14.8, "40129": 2.79, "40039": 2.11}',
    density: 29.3,
    imprecise: false,
    latitude: 35.40327,
    longitude: -99.42718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73644',
  },
  {
    city: 'Erick',
    county_fips: 40009,
    county_fips_all: '40009',
    county: 'Beckham',
    county_names_all: 'Beckham',
    county_weights: '{"40009": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 35.16954,
    longitude: -99.87038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73645',
  },
  {
    city: 'Fay',
    county_fips: 40011,
    county_fips_all: '40011|40043|40039',
    county: 'Blaine',
    county_names_all: 'Blaine|Dewey|Custer',
    county_weights: '{"40011": 61.3, "40043": 29.31, "40039": 9.39}',
    density: 1.3,
    imprecise: false,
    latitude: 35.82624,
    longitude: -98.61928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73646',
  },
  {
    city: 'Foss',
    county_fips: 40149,
    county_fips_all: '40149|40039',
    county: 'Washita',
    county_names_all: 'Washita|Custer',
    county_weights: '{"40149": 59.77, "40039": 40.23}',
    density: 1.9,
    imprecise: false,
    latitude: 35.44786,
    longitude: -99.16124,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73647',
  },
  {
    city: 'Hammon',
    county_fips: 40129,
    county_fips_all: '40129|40039',
    county: 'Roger Mills',
    county_names_all: 'Roger Mills|Custer',
    county_weights: '{"40129": 69.36, "40039": 30.64}',
    density: 1.7,
    imprecise: false,
    latitude: 35.64173,
    longitude: -99.41729,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73650',
  },
  {
    city: 'Hobart',
    county_fips: 40075,
    county_fips_all: '40075',
    county: 'Kiowa',
    county_names_all: 'Kiowa',
    county_weights: '{"40075": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 35.02479,
    longitude: -99.06957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73651',
  },
  {
    city: 'Leedey',
    county_fips: 40129,
    county_fips_all: '40129|40043|40039',
    county: 'Roger Mills',
    county_names_all: 'Roger Mills|Dewey|Custer',
    county_weights: '{"40129": 49.45, "40043": 36.18, "40039": 14.37}',
    density: 0.8,
    imprecise: false,
    latitude: 35.85908,
    longitude: -99.37483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73654',
  },
  {
    city: 'Lone Wolf',
    county_fips: 40075,
    county_fips_all: '40075|40149',
    county: 'Kiowa',
    county_names_all: 'Kiowa|Washita',
    county_weights: '{"40075": 97.26, "40149": 2.74}',
    density: 1.8,
    imprecise: false,
    latitude: 34.98189,
    longitude: -99.25267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73655',
  },
  {
    city: 'Oakwood',
    county_fips: 40043,
    county_fips_all: '40043|40011',
    county: 'Dewey',
    county_names_all: 'Dewey|Blaine',
    county_weights: '{"40043": 95.21, "40011": 4.79}',
    density: 1,
    imprecise: false,
    latitude: 35.94776,
    longitude: -98.71784,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73658',
  },
  {
    city: 'Putnam',
    county_fips: 40043,
    county_fips_all: '40043',
    county: 'Dewey',
    county_names_all: 'Dewey',
    county_weights: '{"40043": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 35.87337,
    longitude: -98.94582,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73659',
  },
  {
    city: 'Reydon',
    county_fips: 40129,
    county_fips_all: '40129',
    county: 'Roger Mills',
    county_names_all: 'Roger Mills',
    county_weights: '{"40129": 100}',
    density: 1,
    imprecise: false,
    latitude: 35.62561,
    longitude: -99.91688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73660',
  },
  {
    city: 'Rocky',
    county_fips: 40149,
    county_fips_all: '40149',
    county: 'Washita',
    county_names_all: 'Washita',
    county_weights: '{"40149": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 35.17033,
    longitude: -99.0176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73661',
  },
  {
    city: 'Sayre',
    county_fips: 40009,
    county_fips_all: '40009|40129',
    county: 'Beckham',
    county_names_all: 'Beckham|Roger Mills',
    county_weights: '{"40009": 90.22, "40129": 9.78}',
    density: 7.6,
    imprecise: false,
    latitude: 35.31533,
    longitude: -99.66273,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73662',
  },
  {
    city: 'Seiling',
    county_fips: 40043,
    county_fips_all: '40043|40093|40153',
    county: 'Dewey',
    county_names_all: 'Dewey|Major|Woodward',
    county_weights: '{"40043": 94.54, "40093": 3.27, "40153": 2.19}',
    density: 3.2,
    imprecise: false,
    latitude: 36.10622,
    longitude: -98.90291,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73663',
  },
  {
    city: 'Sentinel',
    county_fips: 40149,
    county_fips_all: '40149',
    county: 'Washita',
    county_names_all: 'Washita',
    county_weights: '{"40149": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 35.17475,
    longitude: -99.2369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73664',
  },
  {
    city: 'Sweetwater',
    county_fips: 40129,
    county_fips_all: '40129|40009',
    county: 'Roger Mills',
    county_names_all: 'Roger Mills|Beckham',
    county_weights: '{"40129": 53.34, "40009": 46.66}',
    density: 0.9,
    imprecise: false,
    latitude: 35.42036,
    longitude: -99.92412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73666',
  },
  {
    city: 'Taloga',
    county_fips: 40043,
    county_fips_all: '40043',
    county: 'Dewey',
    county_names_all: 'Dewey',
    county_weights: '{"40043": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 36.00523,
    longitude: -99.03062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73667',
  },
  {
    city: 'Texola',
    county_fips: 40009,
    county_fips_all: '40009',
    county: 'Beckham',
    county_names_all: 'Beckham',
    county_weights: '{"40009": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 35.22329,
    longitude: -99.9802,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73668',
  },
  {
    city: 'Thomas',
    county_fips: 40039,
    county_fips_all: '40039|40043|40011',
    county: 'Custer',
    county_names_all: 'Custer|Dewey|Blaine',
    county_weights: '{"40039": 75.88, "40043": 18.47, "40011": 5.65}',
    density: 4.1,
    imprecise: false,
    latitude: 35.75095,
    longitude: -98.74281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73669',
  },
  {
    city: 'Willow',
    county_fips: 40055,
    county_fips_all: '40055|40009',
    county: 'Greer',
    county_names_all: 'Greer|Beckham',
    county_weights: '{"40055": 90.98, "40009": 9.02}',
    density: 0.5,
    imprecise: false,
    latitude: 35.04649,
    longitude: -99.63762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73673',
  },
  {
    city: 'Enid',
    county_fips: 40047,
    county_fips_all: '40047',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"40047": 100}',
    density: 65.1,
    imprecise: false,
    latitude: 36.42323,
    longitude: -97.78833,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73701',
  },
  {
    city: 'Enid',
    county_fips: 40047,
    county_fips_all: '40047|40053',
    county: 'Garfield',
    county_names_all: 'Garfield|Grant',
    county_weights: '{"40047": 96.48, "40053": 3.52}',
    density: 103.4,
    imprecise: false,
    latitude: 36.44022,
    longitude: -97.9634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73703',
  },
  {
    city: 'Enid',
    county_fips: 40047,
    county_fips_all: '40047',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"40047": 100}',
    density: 278.1,
    imprecise: false,
    latitude: 36.33918,
    longitude: -97.90208,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73705',
  },
  {
    city: 'Aline',
    county_fips: 40151,
    county_fips_all: '40151|40003|40093',
    county: 'Woods',
    county_names_all: 'Woods|Alfalfa|Major',
    county_weights: '{"40151": 57.45, "40003": 34.37, "40093": 8.18}',
    density: 1,
    imprecise: false,
    latitude: 36.48417,
    longitude: -98.55316,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73716',
  },
  {
    city: 'Alva',
    county_fips: 40151,
    county_fips_all: '40151|40003',
    county: 'Woods',
    county_names_all: 'Woods|Alfalfa',
    county_weights: '{"40151": 94.51, "40003": 5.49}',
    density: 3.9,
    imprecise: false,
    latitude: 36.84161,
    longitude: -98.77807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73717',
  },
  {
    city: 'Ames',
    county_fips: 40093,
    county_fips_all: '40093|40073|40047',
    county: 'Major',
    county_names_all: 'Major|Kingfisher|Garfield',
    county_weights: '{"40093": 76.27, "40073": 16.75, "40047": 6.98}',
    density: 2.3,
    imprecise: false,
    latitude: 36.20799,
    longitude: -98.16898,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73718',
  },
  {
    city: 'Amorita',
    county_fips: 40003,
    county_fips_all: '40003',
    county: 'Alfalfa',
    county_names_all: 'Alfalfa',
    county_weights: '{"40003": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 36.96026,
    longitude: -98.26746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73719',
  },
  {
    city: 'Bison',
    county_fips: 40047,
    county_fips_all: '40047',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"40047": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 36.1973,
    longitude: -97.87038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73720',
  },
  {
    city: 'Burlington',
    county_fips: 40003,
    county_fips_all: '40003',
    county: 'Alfalfa',
    county_names_all: 'Alfalfa',
    county_weights: '{"40003": 100}',
    density: 1,
    imprecise: false,
    latitude: 36.90196,
    longitude: -98.36445,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73722',
  },
  {
    city: 'Canton',
    county_fips: 40043,
    county_fips_all: '40043|40011',
    county: 'Dewey',
    county_names_all: 'Dewey|Blaine',
    county_weights: '{"40043": 56.47, "40011": 43.53}',
    density: 2.3,
    imprecise: false,
    latitude: 36.03757,
    longitude: -98.67235,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73724',
  },
  {
    city: 'Carmen',
    county_fips: 40003,
    county_fips_all: '40003|40151',
    county: 'Alfalfa',
    county_names_all: 'Alfalfa|Woods',
    county_weights: '{"40003": 60.11, "40151": 39.89}',
    density: 1.7,
    imprecise: false,
    latitude: 36.58022,
    longitude: -98.50405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73726',
  },
  {
    city: 'Carrier',
    county_fips: 40047,
    county_fips_all: '40047',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"40047": 100}',
    density: 2,
    imprecise: false,
    latitude: 36.48309,
    longitude: -98.03839,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73727',
  },
  {
    city: 'Cherokee',
    county_fips: 40003,
    county_fips_all: '40003',
    county: 'Alfalfa',
    county_names_all: 'Alfalfa',
    county_weights: '{"40003": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 36.73508,
    longitude: -98.39376,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73728',
  },
  {
    city: 'Cleo Springs',
    county_fips: 40093,
    county_fips_all: '40093|40151',
    county: 'Major',
    county_names_all: 'Major|Woods',
    county_weights: '{"40093": 84.25, "40151": 15.75}',
    density: 3.4,
    imprecise: false,
    latitude: 36.39723,
    longitude: -98.45256,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73729',
  },
  {
    city: 'Covington',
    county_fips: 40047,
    county_fips_all: '40047',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"40047": 100}',
    density: 4,
    imprecise: false,
    latitude: 36.31754,
    longitude: -97.54765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73730',
  },
  {
    city: 'Dacoma',
    county_fips: 40151,
    county_fips_all: '40151',
    county: 'Woods',
    county_names_all: 'Woods',
    county_weights: '{"40151": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 36.64397,
    longitude: -98.59915,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73731',
  },
  {
    city: 'Douglas',
    county_fips: 40047,
    county_fips_all: '40047',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"40047": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 36.2497,
    longitude: -97.69104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73733',
  },
  {
    city: 'Dover',
    county_fips: 40073,
    county_fips_all: '40073',
    county: 'Kingfisher',
    county_names_all: 'Kingfisher',
    county_weights: '{"40073": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 35.98453,
    longitude: -97.8534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73734',
  },
  {
    city: 'Drummond',
    county_fips: 40047,
    county_fips_all: '40047|40093',
    county: 'Garfield',
    county_names_all: 'Garfield|Major',
    county_weights: '{"40047": 96.27, "40093": 3.73}',
    density: 5.9,
    imprecise: false,
    latitude: 36.27594,
    longitude: -98.05132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73735',
  },
  {
    city: 'Fairmont',
    county_fips: 40047,
    county_fips_all: '40047',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"40047": 100}',
    density: 3,
    imprecise: false,
    latitude: 36.34607,
    longitude: -97.68751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73736',
  },
  {
    city: 'Fairview',
    county_fips: 40093,
    county_fips_all: '40093',
    county: 'Major',
    county_names_all: 'Major',
    county_weights: '{"40093": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 36.29133,
    longitude: -98.58517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73737',
  },
  {
    city: 'Garber',
    county_fips: 40047,
    county_fips_all: '40047',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"40047": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 36.44463,
    longitude: -97.55315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73738',
  },
  {
    city: 'Goltry',
    county_fips: 40003,
    county_fips_all: '40003|40047',
    county: 'Alfalfa',
    county_names_all: 'Alfalfa|Garfield',
    county_weights: '{"40003": 76.94, "40047": 23.06}',
    density: 3.2,
    imprecise: false,
    latitude: 36.51999,
    longitude: -98.13697,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73739',
  },
  {
    city: 'Helena',
    county_fips: 40003,
    county_fips_all: '40003',
    county: 'Alfalfa',
    county_names_all: 'Alfalfa',
    county_weights: '{"40003": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 36.55071,
    longitude: -98.26619,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73741',
  },
  {
    city: 'Hennessey',
    county_fips: 40073,
    county_fips_all: '40073',
    county: 'Kingfisher',
    county_names_all: 'Kingfisher',
    county_weights: '{"40073": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 36.09632,
    longitude: -97.91907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73742',
  },
  {
    city: 'Hillsdale',
    county_fips: 40047,
    county_fips_all: '40047',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"40047": 100}',
    density: 99.2,
    imprecise: false,
    latitude: 36.56324,
    longitude: -97.9927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73743',
  },
  {
    city: 'Hitchcock',
    county_fips: 40011,
    county_fips_all: '40011|40073',
    county: 'Blaine',
    county_names_all: 'Blaine|Kingfisher',
    county_weights: '{"40011": 95.28, "40073": 4.72}',
    density: 0.8,
    imprecise: false,
    latitude: 35.94912,
    longitude: -98.29643,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73744',
  },
  {
    city: 'Hopeton',
    county_fips: 40151,
    county_fips_all: '40151',
    county: 'Woods',
    county_names_all: 'Woods',
    county_weights: '{"40151": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 36.6882,
    longitude: -98.66202,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73746',
  },
  {
    city: 'Isabella',
    county_fips: 40093,
    county_fips_all: '40093',
    county: 'Major',
    county_names_all: 'Major',
    county_weights: '{"40093": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 36.23358,
    longitude: -98.33964,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73747',
  },
  {
    city: 'Jet',
    county_fips: 40003,
    county_fips_all: '40003',
    county: 'Alfalfa',
    county_names_all: 'Alfalfa',
    county_weights: '{"40003": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 36.70566,
    longitude: -98.16283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73749',
  },
  {
    city: 'Kingfisher',
    county_fips: 40073,
    county_fips_all: '40073',
    county: 'Kingfisher',
    county_names_all: 'Kingfisher',
    county_weights: '{"40073": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 35.8534,
    longitude: -97.94435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73750',
  },
  {
    city: 'Kremlin',
    county_fips: 40047,
    county_fips_all: '40047',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"40047": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 36.55277,
    longitude: -97.86976,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73753',
  },
  {
    city: 'Lahoma',
    county_fips: 40047,
    county_fips_all: '40047|40093|40003',
    county: 'Garfield',
    county_names_all: 'Garfield|Major|Alfalfa',
    county_weights: '{"40047": 61.87, "40093": 36.07, "40003": 2.06}',
    density: 8.3,
    imprecise: false,
    latitude: 36.39016,
    longitude: -98.09455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73754',
  },
  {
    city: 'Longdale',
    county_fips: 40011,
    county_fips_all: '40011|40093|40043',
    county: 'Blaine',
    county_names_all: 'Blaine|Major|Dewey',
    county_weights: '{"40011": 57.82, "40093": 26.31, "40043": 15.87}',
    density: 3.3,
    imprecise: false,
    latitude: 36.13717,
    longitude: -98.5889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73755',
  },
  {
    city: 'Loyal',
    county_fips: 40073,
    county_fips_all: '40073',
    county: 'Kingfisher',
    county_names_all: 'Kingfisher',
    county_weights: '{"40073": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 35.97507,
    longitude: -98.11439,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73756',
  },
  {
    city: 'Lucien',
    county_fips: 40103,
    county_fips_all: '40103|40047',
    county: 'Noble',
    county_names_all: 'Noble|Garfield',
    county_weights: '{"40103": 73.16, "40047": 26.84}',
    density: 1.6,
    imprecise: false,
    latitude: 36.27601,
    longitude: -97.44935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73757',
  },
  {
    city: 'Manchester',
    county_fips: 40053,
    county_fips_all: '40053|40003',
    county: 'Grant',
    county_names_all: 'Grant|Alfalfa',
    county_weights: '{"40053": 59.46, "40003": 40.54}',
    density: 0.9,
    imprecise: false,
    latitude: 36.93239,
    longitude: -98.0875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73758',
  },
  {
    city: 'Medford',
    county_fips: 40053,
    county_fips_all: '40053',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"40053": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 36.85815,
    longitude: -97.71362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73759',
  },
  {
    city: 'Meno',
    county_fips: 40093,
    county_fips_all: '40093|40003',
    county: 'Major',
    county_names_all: 'Major|Alfalfa',
    county_weights: '{"40093": 95.25, "40003": 4.75}',
    density: 2,
    imprecise: false,
    latitude: 36.38658,
    longitude: -98.1693,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73760',
  },
  {
    city: 'Nash',
    county_fips: 40053,
    county_fips_all: '40053|40047',
    county: 'Grant',
    county_names_all: 'Grant|Garfield',
    county_weights: '{"40053": 90.01, "40047": 9.99}',
    density: 1.2,
    imprecise: false,
    latitude: 36.68452,
    longitude: -98.03647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73761',
  },
  {
    city: 'Okarche',
    county_fips: 40017,
    county_fips_all: '40017|40073',
    county: 'Canadian',
    county_names_all: 'Canadian|Kingfisher',
    county_weights: '{"40017": 55.64, "40073": 44.36}',
    density: 5,
    imprecise: false,
    latitude: 35.71197,
    longitude: -97.97442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73762',
  },
  {
    city: 'Okeene',
    county_fips: 40011,
    county_fips_all: '40011|40073|40093',
    county: 'Blaine',
    county_names_all: 'Blaine|Kingfisher|Major',
    county_weights: '{"40011": 74.7, "40073": 13.52, "40093": 11.78}',
    density: 3.7,
    imprecise: false,
    latitude: 36.10302,
    longitude: -98.3201,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73763',
  },
  {
    city: 'Omega',
    county_fips: 40073,
    county_fips_all: '40073|40011',
    county: 'Kingfisher',
    county_names_all: 'Kingfisher|Blaine',
    county_weights: '{"40073": 58.35, "40011": 41.65}',
    density: 1.4,
    imprecise: false,
    latitude: 35.85738,
    longitude: -98.20307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73764',
  },
  {
    city: 'Pond Creek',
    county_fips: 40053,
    county_fips_all: '40053',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"40053": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 36.65004,
    longitude: -97.83846,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73766',
  },
  {
    city: 'Ringwood',
    county_fips: 40093,
    county_fips_all: '40093|40003',
    county: 'Major',
    county_names_all: 'Major|Alfalfa',
    county_weights: '{"40093": 98.19, "40003": 1.81}',
    density: 5.2,
    imprecise: false,
    latitude: 36.36265,
    longitude: -98.27907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73768',
  },
  {
    city: 'Southard',
    county_fips: 40011,
    county_fips_all: '40011',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"40011": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 36.05406,
    longitude: -98.49791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73770',
  },
  {
    city: 'Wakita',
    county_fips: 40053,
    county_fips_all: '40053',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"40053": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 36.87533,
    longitude: -97.95653,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73771',
  },
  {
    city: 'Watonga',
    county_fips: 40011,
    county_fips_all: '40011',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"40011": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 35.86327,
    longitude: -98.42369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73772',
  },
  {
    city: 'Waukomis',
    county_fips: 40047,
    county_fips_all: '40047',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"40047": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 36.25804,
    longitude: -97.91922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73773',
  },
  {
    city: 'Woodward',
    county_fips: 40153,
    county_fips_all: '40153|40059',
    county: 'Woodward',
    county_names_all: 'Woodward|Harper',
    county_weights: '{"40153": 78.37, "40059": 21.63}',
    density: 12.5,
    imprecise: false,
    latitude: 36.4733,
    longitude: -99.4307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73801',
  },
  {
    city: 'Arnett',
    county_fips: 40045,
    county_fips_all: '40045|40153',
    county: 'Ellis',
    county_names_all: 'Ellis|Woodward',
    county_weights: '{"40045": 92.5, "40153": 7.5}',
    density: 0.7,
    imprecise: false,
    latitude: 36.05298,
    longitude: -99.65687,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73832',
  },
  {
    city: 'Buffalo',
    county_fips: 40059,
    county_fips_all: '40059',
    county: 'Harper',
    county_names_all: 'Harper',
    county_weights: '{"40059": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 36.84807,
    longitude: -99.57156,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73834',
  },
  {
    city: 'Camargo',
    county_fips: 40043,
    county_fips_all: '40043',
    county: 'Dewey',
    county_names_all: 'Dewey',
    county_weights: '{"40043": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 35.97327,
    longitude: -99.21279,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73835',
  },
  {
    city: 'Chester',
    county_fips: 40093,
    county_fips_all: '40093|40153',
    county: 'Major',
    county_names_all: 'Major|Woodward',
    county_weights: '{"40093": 82.74, "40153": 17.26}',
    density: 1.3,
    imprecise: false,
    latitude: 36.24575,
    longitude: -98.87579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73838',
  },
  {
    city: 'Fargo',
    county_fips: 40045,
    county_fips_all: '40045|40153',
    county: 'Ellis',
    county_names_all: 'Ellis|Woodward',
    county_weights: '{"40045": 74.37, "40153": 25.63}',
    density: 1.4,
    imprecise: false,
    latitude: 36.39436,
    longitude: -99.64581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73840',
  },
  {
    city: 'Fort Supply',
    county_fips: 40045,
    county_fips_all: '40045|40153',
    county: 'Ellis',
    county_names_all: 'Ellis|Woodward',
    county_weights: '{"40045": 59.22, "40153": 40.78}',
    density: 7.7,
    imprecise: false,
    latitude: 36.54799,
    longitude: -99.61924,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73841',
  },
  {
    city: 'Freedom',
    county_fips: 40151,
    county_fips_all: '40151|40153|40059',
    county: 'Woods',
    county_names_all: 'Woods|Woodward|Harper',
    county_weights: '{"40151": 66.9, "40153": 24.59, "40059": 8.51}',
    density: 0.3,
    imprecise: false,
    latitude: 36.8212,
    longitude: -99.21452,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73842',
  },
  {
    city: 'Gage',
    county_fips: 40045,
    county_fips_all: '40045|40007',
    county: 'Ellis',
    county_names_all: 'Ellis|Beaver',
    county_weights: '{"40045": 93.77, "40007": 6.23}',
    density: 0.9,
    imprecise: false,
    latitude: 36.39805,
    longitude: -99.83566,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73843',
  },
  {
    city: 'Gate',
    county_fips: 40007,
    county_fips_all: '40007|40059',
    county: 'Beaver',
    county_names_all: 'Beaver|Harper',
    county_weights: '{"40007": 89.39, "40059": 10.61}',
    density: 0.3,
    imprecise: false,
    latitude: 36.89715,
    longitude: -100.16763,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73844',
  },
  {
    city: 'Laverne',
    county_fips: 40007,
    county_fips_all: '40007|40059',
    county: 'Beaver',
    county_names_all: 'Beaver|Harper',
    county_weights: '{"40007": 56.65, "40059": 43.35}',
    density: 1.1,
    imprecise: false,
    latitude: 36.64843,
    longitude: -100.023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73848',
  },
  {
    city: 'May',
    county_fips: 40045,
    county_fips_all: '40045|40059',
    county: 'Ellis',
    county_names_all: 'Ellis|Harper',
    county_weights: '{"40045": 69.23, "40059": 30.77}',
    density: 0.5,
    imprecise: false,
    latitude: 36.57298,
    longitude: -99.78406,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73851',
  },
  {
    city: 'Mooreland',
    county_fips: 40153,
    county_fips_all: '40153|40093',
    county: 'Woodward',
    county_names_all: 'Woodward|Major',
    county_weights: '{"40153": 98.37, "40093": 1.63}',
    density: 2.4,
    imprecise: false,
    latitude: 36.4873,
    longitude: -99.10798,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73852',
  },
  {
    city: 'Mutual',
    county_fips: 40153,
    county_fips_all: '40153|40043',
    county: 'Woodward',
    county_names_all: 'Woodward|Dewey',
    county_weights: '{"40153": 98.71, "40043": 1.29}',
    density: 1.4,
    imprecise: false,
    latitude: 36.24333,
    longitude: -99.15664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73853',
  },
  {
    city: 'Rosston',
    county_fips: 40059,
    county_fips_all: '40059',
    county: 'Harper',
    county_names_all: 'Harper',
    county_weights: '{"40059": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 36.88481,
    longitude: -99.85877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73855',
  },
  {
    city: 'Sharon',
    county_fips: 40153,
    county_fips_all: '40153',
    county: 'Woodward',
    county_names_all: 'Woodward',
    county_weights: '{"40153": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 36.27223,
    longitude: -99.33235,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73857',
  },
  {
    city: 'Shattuck',
    county_fips: 40045,
    county_fips_all: '40045',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"40045": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 36.17037,
    longitude: -99.92442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73858',
  },
  {
    city: 'Vici',
    county_fips: 40043,
    county_fips_all: '40043|40153|40045',
    county: 'Dewey',
    county_names_all: 'Dewey|Woodward|Ellis',
    county_weights: '{"40043": 64.09, "40153": 24.4, "40045": 11.51}',
    density: 3.9,
    imprecise: false,
    latitude: 36.13309,
    longitude: -99.2797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73859',
  },
  {
    city: 'Waynoka',
    county_fips: 40151,
    county_fips_all: '40151|40093',
    county: 'Woods',
    county_names_all: 'Woods|Major',
    county_weights: '{"40151": 61.49, "40093": 38.51}',
    density: 1.4,
    imprecise: false,
    latitude: 36.53573,
    longitude: -98.86265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73860',
  },
  {
    city: 'Adams',
    county_fips: 40139,
    county_fips_all: '40139',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"40139": 100}',
    density: 78.8,
    imprecise: false,
    latitude: 36.75458,
    longitude: -101.07517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73901',
  },
  {
    city: 'Balko',
    county_fips: 40007,
    county_fips_all: '40007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"40007": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 36.60097,
    longitude: -100.80329,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73931',
  },
  {
    city: 'Beaver',
    county_fips: 40007,
    county_fips_all: '40007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"40007": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 36.7,
    longitude: -100.51914,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73932',
  },
  {
    city: 'Boise City',
    county_fips: 40025,
    county_fips_all: '40025',
    county: 'Cimarron',
    county_names_all: 'Cimarron',
    county_weights: '{"40025": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 36.7436,
    longitude: -102.58198,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73933',
  },
  {
    city: 'Felt',
    county_fips: 40025,
    county_fips_all: '40025',
    county: 'Cimarron',
    county_names_all: 'Cimarron',
    county_weights: '{"40025": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 36.5642,
    longitude: -102.76703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73937',
  },
  {
    city: 'Forgan',
    county_fips: 40007,
    county_fips_all: '40007',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"40007": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 36.92585,
    longitude: -100.58497,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73938',
  },
  {
    city: 'Goodwell',
    county_fips: 40139,
    county_fips_all: '40139',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"40139": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 36.76824,
    longitude: -101.78344,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73939',
  },
  {
    city: 'Guymon',
    county_fips: 40139,
    county_fips_all: '40139',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"40139": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 36.74452,
    longitude: -101.49555,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73942',
  },
  {
    city: 'Hardesty',
    county_fips: 40139,
    county_fips_all: '40139',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"40139": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 36.58511,
    longitude: -101.10339,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73944',
  },
  {
    city: 'Hooker',
    county_fips: 40139,
    county_fips_all: '40139',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"40139": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 36.8321,
    longitude: -101.22474,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73945',
  },
  {
    city: 'Kenton',
    county_fips: 40025,
    county_fips_all: '40025',
    county: 'Cimarron',
    county_names_all: 'Cimarron',
    county_weights: '{"40025": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.92316,
    longitude: -102.81258,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73946',
  },
  {
    city: 'Keyes',
    county_fips: 40025,
    county_fips_all: '40025|40139',
    county: 'Cimarron',
    county_names_all: 'Cimarron|Texas',
    county_weights: '{"40025": 92.87, "40139": 7.13}',
    density: 0.5,
    imprecise: false,
    latitude: 36.84672,
    longitude: -102.17316,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73947',
  },
  {
    city: 'Texhoma',
    county_fips: 40139,
    county_fips_all: '40139|40025|48421',
    county: 'Texas',
    county_names_all: 'Texas|Cimarron|Sherman',
    county_weights: '{"40139": 59.05, "40025": 27.32, "48421": 13.63}',
    density: 1.4,
    imprecise: false,
    latitude: 36.5929,
    longitude: -101.98559,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73949',
  },
  {
    city: 'Turpin',
    county_fips: 40007,
    county_fips_all: '40007|40139',
    county: 'Beaver',
    county_names_all: 'Beaver|Texas',
    county_weights: '{"40007": 80.07, "40139": 19.93}',
    density: 2.3,
    imprecise: false,
    latitude: 36.85193,
    longitude: -100.88621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73950',
  },
  {
    city: 'Tyrone',
    county_fips: 40139,
    county_fips_all: '40139',
    county: 'Texas',
    county_names_all: 'Texas',
    county_weights: '{"40139": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 36.95004,
    longitude: -101.05463,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73951',
  },
  {
    city: 'Texhoma',
    county_fips: 48421,
    county_fips_all: '48421',
    county: 'Sherman',
    county_names_all: 'Sherman',
    county_weights: '{"48421": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 36.49167,
    longitude: -101.79265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '73960',
  },
  {
    city: 'Avant',
    county_fips: 40113,
    county_fips_all: '40113',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"40113": 100}',
    density: 158,
    imprecise: false,
    latitude: 36.48857,
    longitude: -96.0625,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74001',
  },
  {
    city: 'Barnsdall',
    county_fips: 40113,
    county_fips_all: '40113',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"40113": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 36.5613,
    longitude: -96.14528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74002',
  },
  {
    city: 'Bartlesville',
    county_fips: 40113,
    county_fips_all: '40113|40147',
    county: 'Osage',
    county_names_all: 'Osage|Washington',
    county_weights: '{"40113": 84.76, "40147": 15.24}',
    density: 41.7,
    imprecise: false,
    latitude: 36.73107,
    longitude: -96.06675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74003',
  },
  {
    city: 'Bartlesville',
    county_fips: 40147,
    county_fips_all: '40147',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"40147": 100}',
    density: 117.9,
    imprecise: false,
    latitude: 36.71507,
    longitude: -95.89391,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74006',
  },
  {
    city: 'Bixby',
    county_fips: 40143,
    county_fips_all: '40143|40145',
    county: 'Tulsa',
    county_names_all: 'Tulsa|Wagoner',
    county_weights: '{"40143": 95.98, "40145": 4.02}',
    density: 176.6,
    imprecise: false,
    latitude: 35.92614,
    longitude: -95.87575,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74008',
  },
  {
    city: 'Bristow',
    county_fips: 40037,
    county_fips_all: '40037|40107',
    county: 'Creek',
    county_names_all: 'Creek|Okfuskee',
    county_weights: '{"40037": 99.15, "40107": 0.85}',
    density: 12.3,
    imprecise: false,
    latitude: 35.80945,
    longitude: -96.36101,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74010',
  },
  {
    city: 'Broken Arrow',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 548.8,
    imprecise: false,
    latitude: 35.98154,
    longitude: -95.81007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74011',
  },
  {
    city: 'Broken Arrow',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1011.9,
    imprecise: false,
    latitude: 36.05381,
    longitude: -95.80509,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 65060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74012',
  },
  {
    city: 'Broken Arrow',
    county_fips: 40145,
    county_fips_all: '40145',
    county: 'Wagoner',
    county_names_all: 'Wagoner',
    county_weights: '{"40145": 100}',
    density: 166.3,
    imprecise: false,
    latitude: 36.05538,
    longitude: -95.66819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74014',
  },
  {
    city: 'Catoosa',
    county_fips: 40131,
    county_fips_all: '40131|40145|40143',
    county: 'Rogers',
    county_names_all: 'Rogers|Wagoner|Tulsa',
    county_weights: '{"40131": 69.39, "40145": 30.37, "40143": 0.24}',
    density: 55.5,
    imprecise: false,
    latitude: 36.18012,
    longitude: -95.70952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74015',
  },
  {
    city: 'Chelsea',
    county_fips: 40131,
    county_fips_all: '40131|40097|40105|40035',
    county: 'Rogers',
    county_names_all: 'Rogers|Mayes|Nowata|Craig',
    county_weights:
      '{"40131": 61.48, "40097": 15.88, "40105": 11.94, "40035": 10.7}',
    density: 15.8,
    imprecise: false,
    latitude: 36.54093,
    longitude: -95.45283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74016',
  },
  {
    city: 'Claremore',
    county_fips: 40131,
    county_fips_all: '40131',
    county: 'Rogers',
    county_names_all: 'Rogers',
    county_weights: '{"40131": 100}',
    density: 80.3,
    imprecise: false,
    latitude: 36.39359,
    longitude: -95.57986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74017',
  },
  {
    city: 'Claremore',
    county_fips: 40131,
    county_fips_all: '40131',
    county: 'Rogers',
    county_names_all: 'Rogers',
    county_weights: '{"40131": 100}',
    density: 71,
    imprecise: false,
    latitude: 36.28326,
    longitude: -95.60684,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74019',
  },
  {
    city: 'Cleveland',
    county_fips: 40117,
    county_fips_all: '40117',
    county: 'Pawnee',
    county_names_all: 'Pawnee',
    county_weights: '{"40117": 100}',
    density: 43.3,
    imprecise: false,
    latitude: 36.24562,
    longitude: -96.41934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74020',
  },
  {
    city: 'Collinsville',
    county_fips: 40143,
    county_fips_all: '40143|40131|40147',
    county: 'Tulsa',
    county_names_all: 'Tulsa|Rogers|Washington',
    county_weights: '{"40143": 66.23, "40131": 18.92, "40147": 14.85}',
    density: 136.1,
    imprecise: false,
    latitude: 36.37915,
    longitude: -95.84758,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74021',
  },
  {
    city: 'Copan',
    county_fips: 40147,
    county_fips_all: '40147|40113',
    county: 'Washington',
    county_names_all: 'Washington|Osage',
    county_weights: '{"40147": 57.49, "40113": 42.51}',
    density: 5.8,
    imprecise: false,
    latitude: 36.93055,
    longitude: -95.98054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74022',
  },
  {
    city: 'Cushing',
    county_fips: 40119,
    county_fips_all: '40119|40081',
    county: 'Payne',
    county_names_all: 'Payne|Lincoln',
    county_weights: '{"40119": 59.16, "40081": 40.84}',
    density: 26.2,
    imprecise: false,
    latitude: 35.95708,
    longitude: -96.74963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74023',
  },
  {
    city: 'Davenport',
    county_fips: 40081,
    county_fips_all: '40081',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"40081": 100}',
    density: 33.1,
    imprecise: false,
    latitude: 35.72266,
    longitude: -96.78282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74026',
  },
  {
    city: 'Delaware',
    county_fips: 40105,
    county_fips_all: '40105',
    county: 'Nowata',
    county_names_all: 'Nowata',
    county_weights: '{"40105": 100}',
    density: 3,
    imprecise: false,
    latitude: 36.80285,
    longitude: -95.58628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74027',
  },
  {
    city: 'Depew',
    county_fips: 40037,
    county_fips_all: '40037|40081',
    county: 'Creek',
    county_names_all: 'Creek|Lincoln',
    county_weights: '{"40037": 99.42, "40081": 0.58}',
    density: 5.8,
    imprecise: false,
    latitude: 35.79554,
    longitude: -96.52259,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74028',
  },
  {
    city: 'Dewey',
    county_fips: 40147,
    county_fips_all: '40147',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"40147": 100}',
    density: 45,
    imprecise: false,
    latitude: 36.82558,
    longitude: -95.88172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74029',
  },
  {
    city: 'Drumright',
    county_fips: 40037,
    county_fips_all: '40037|40119',
    county: 'Creek',
    county_names_all: 'Creek|Payne',
    county_weights: '{"40037": 91.65, "40119": 8.35}',
    density: 16.8,
    imprecise: false,
    latitude: 35.98508,
    longitude: -96.5673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74030',
  },
  {
    city: 'Glencoe',
    county_fips: 40119,
    county_fips_all: '40119|40117|40103',
    county: 'Payne',
    county_names_all: 'Payne|Pawnee|Noble',
    county_weights: '{"40119": 71.58, "40117": 19.32, "40103": 9.1}',
    density: 6.3,
    imprecise: false,
    latitude: 36.2115,
    longitude: -96.90402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74032',
  },
  {
    city: 'Glenpool',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 429.8,
    imprecise: false,
    latitude: 35.94711,
    longitude: -96.00636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74033',
  },
  {
    city: 'Hallett',
    county_fips: 40117,
    county_fips_all: '40117',
    county: 'Pawnee',
    county_names_all: 'Pawnee',
    county_weights: '{"40117": 100}',
    density: 30.1,
    imprecise: false,
    latitude: 36.23266,
    longitude: -96.56288,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74034',
  },
  {
    city: 'Hominy',
    county_fips: 40113,
    county_fips_all: '40113',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"40113": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 36.40368,
    longitude: -96.37607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4021,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74035',
  },
  {
    city: 'Inola',
    county_fips: 40131,
    county_fips_all: '40131|40097|40145',
    county: 'Rogers',
    county_names_all: 'Rogers|Mayes|Wagoner',
    county_weights: '{"40131": 80.61, "40097": 10.55, "40145": 8.84}',
    density: 23.5,
    imprecise: false,
    latitude: 36.15713,
    longitude: -95.50497,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74036',
  },
  {
    city: 'Jenks',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 586.3,
    imprecise: false,
    latitude: 36.00149,
    longitude: -95.98171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74037',
  },
  {
    city: 'Jennings',
    county_fips: 40037,
    county_fips_all: '40037|40117',
    county: 'Creek',
    county_names_all: 'Creek|Pawnee',
    county_weights: '{"40037": 51.59, "40117": 48.41}',
    density: 8.1,
    imprecise: false,
    latitude: 36.1552,
    longitude: -96.56151,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74038',
  },
  {
    city: 'Kellyville',
    county_fips: 40037,
    county_fips_all: '40037',
    county: 'Creek',
    county_names_all: 'Creek',
    county_weights: '{"40037": 100}',
    density: 21.8,
    imprecise: false,
    latitude: 35.89822,
    longitude: -96.22842,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74039',
  },
  {
    city: 'Kiefer',
    county_fips: 40037,
    county_fips_all: '40037',
    county: 'Creek',
    county_names_all: 'Creek',
    county_weights: '{"40037": 100}',
    density: 135.2,
    imprecise: false,
    latitude: 35.93808,
    longitude: -96.05545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74041',
  },
  {
    city: 'Lenapah',
    county_fips: 40105,
    county_fips_all: '40105',
    county: 'Nowata',
    county_names_all: 'Nowata',
    county_weights: '{"40105": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 36.88381,
    longitude: -95.55223,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74042',
  },
  {
    city: 'Mannford',
    county_fips: 40037,
    county_fips_all: '40037|40117',
    county: 'Creek',
    county_names_all: 'Creek|Pawnee',
    county_weights: '{"40037": 89.88, "40117": 10.12}',
    density: 35.9,
    imprecise: false,
    latitude: 36.08964,
    longitude: -96.38117,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74044',
  },
  {
    city: 'Maramec',
    county_fips: 40117,
    county_fips_all: '40117|40119',
    county: 'Pawnee',
    county_names_all: 'Pawnee|Payne',
    county_weights: '{"40117": 99.71, "40119": 0.29}',
    density: 2.2,
    imprecise: false,
    latitude: 36.22153,
    longitude: -96.70049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74045',
  },
  {
    city: 'Milfay',
    county_fips: 40037,
    county_fips_all: '40037',
    county: 'Creek',
    county_names_all: 'Creek',
    county_weights: '{"40037": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 35.75455,
    longitude: -96.56969,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74046',
  },
  {
    city: 'Mounds',
    county_fips: 40111,
    county_fips_all: '40111|40143|40037',
    county: 'Okmulgee',
    county_names_all: 'Okmulgee|Tulsa|Creek',
    county_weights: '{"40111": 55.65, "40143": 24.44, "40037": 19.91}',
    density: 28.3,
    imprecise: false,
    latitude: 35.85522,
    longitude: -96.02583,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74047',
  },
  {
    city: 'Nowata',
    county_fips: 40105,
    county_fips_all: '40105|40147',
    county: 'Nowata',
    county_names_all: 'Nowata|Washington',
    county_weights: '{"40105": 99.58, "40147": 0.42}',
    density: 10.1,
    imprecise: false,
    latitude: 36.69265,
    longitude: -95.65192,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74048',
  },
  {
    city: 'Oakhurst',
    county_fips: 40037,
    county_fips_all: '40037|40143',
    county: 'Creek',
    county_names_all: 'Creek|Tulsa',
    county_weights: '{"40037": 90.52, "40143": 9.48}',
    density: 438.4,
    imprecise: false,
    latitude: 36.07221,
    longitude: -96.06546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74050',
  },
  {
    city: 'Ochelata',
    county_fips: 40147,
    county_fips_all: '40147|40113',
    county: 'Washington',
    county_names_all: 'Washington|Osage',
    county_weights: '{"40147": 90.16, "40113": 9.84}',
    density: 22.1,
    imprecise: false,
    latitude: 36.61412,
    longitude: -95.96532,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74051',
  },
  {
    city: 'Oilton',
    county_fips: 40037,
    county_fips_all: '40037',
    county: 'Creek',
    county_names_all: 'Creek',
    county_weights: '{"40037": 100}',
    density: 46.6,
    imprecise: false,
    latitude: 36.07076,
    longitude: -96.5738,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74052',
  },
  {
    city: 'Oologah',
    county_fips: 40131,
    county_fips_all: '40131',
    county: 'Rogers',
    county_names_all: 'Rogers',
    county_weights: '{"40131": 100}',
    density: 50.1,
    imprecise: false,
    latitude: 36.43419,
    longitude: -95.73282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74053',
  },
  {
    city: 'Osage',
    county_fips: 40113,
    county_fips_all: '40113',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"40113": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 36.27299,
    longitude: -96.32962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74054',
  },
  {
    city: 'Owasso',
    county_fips: 40143,
    county_fips_all: '40143|40131',
    county: 'Tulsa',
    county_names_all: 'Tulsa|Rogers',
    county_weights: '{"40143": 54.46, "40131": 45.54}',
    density: 389.4,
    imprecise: false,
    latitude: 36.27735,
    longitude: -95.81998,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74055',
  },
  {
    city: 'Pawhuska',
    county_fips: 40113,
    county_fips_all: '40113',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"40113": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 36.79706,
    longitude: -96.33873,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74056',
  },
  {
    city: 'Pawnee',
    county_fips: 40117,
    county_fips_all: '40117|40113',
    county: 'Pawnee',
    county_names_all: 'Pawnee|Osage',
    county_weights: '{"40117": 99.77, "40113": 0.23}',
    density: 5.4,
    imprecise: false,
    latitude: 36.35499,
    longitude: -96.75909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74058',
  },
  {
    city: 'Perkins',
    county_fips: 40119,
    county_fips_all: '40119|40081|40083',
    county: 'Payne',
    county_names_all: 'Payne|Lincoln|Logan',
    county_weights: '{"40119": 63.49, "40081": 28.45, "40083": 8.06}',
    density: 19.4,
    imprecise: false,
    latitude: 35.95736,
    longitude: -97.06255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74059',
  },
  {
    city: 'Prue',
    county_fips: 40113,
    county_fips_all: '40113',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"40113": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 36.2472,
    longitude: -96.25434,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74060',
  },
  {
    city: 'Ramona',
    county_fips: 40147,
    county_fips_all: '40147',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"40147": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 36.53814,
    longitude: -95.89974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74061',
  },
  {
    city: 'Ripley',
    county_fips: 40119,
    county_fips_all: '40119',
    county: 'Payne',
    county_names_all: 'Payne',
    county_weights: '{"40119": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 36.03481,
    longitude: -96.89727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74062',
  },
  {
    city: 'Sand Springs',
    county_fips: 40143,
    county_fips_all: '40143|40113|40037',
    county: 'Tulsa',
    county_names_all: 'Tulsa|Osage|Creek',
    county_weights: '{"40143": 49.42, "40113": 41.56, "40037": 9.02}',
    density: 93.3,
    imprecise: false,
    latitude: 36.15201,
    longitude: -96.19206,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74063',
  },
  {
    city: 'Sapulpa',
    county_fips: 40037,
    county_fips_all: '40037',
    county: 'Creek',
    county_names_all: 'Creek',
    county_weights: '{"40037": 100}',
    density: 100.9,
    imprecise: false,
    latitude: 35.99379,
    longitude: -96.1676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74066',
  },
  {
    city: 'Shamrock',
    county_fips: 40037,
    county_fips_all: '40037',
    county: 'Creek',
    county_names_all: 'Creek',
    county_weights: '{"40037": 100}',
    density: 48.8,
    imprecise: false,
    latitude: 35.90829,
    longitude: -96.57498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74068',
  },
  {
    city: 'Skiatook',
    county_fips: 40113,
    county_fips_all: '40113|40143|40147',
    county: 'Osage',
    county_names_all: 'Osage|Tulsa|Washington',
    county_weights: '{"40113": 75.44, "40143": 16.41, "40147": 8.15}',
    density: 30.4,
    imprecise: false,
    latitude: 36.3881,
    longitude: -96.07253,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74070',
  },
  {
    city: 'Slick',
    county_fips: 40037,
    county_fips_all: '40037',
    county: 'Creek',
    county_names_all: 'Creek',
    county_weights: '{"40037": 100}',
    density: 21.7,
    imprecise: false,
    latitude: 35.77835,
    longitude: -96.26467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74071',
  },
  {
    city: 'S Coffeyville',
    county_fips: 40105,
    county_fips_all: '40105|40035',
    county: 'Nowata',
    county_names_all: 'Nowata|Craig',
    county_weights: '{"40105": 88.01, "40035": 11.99}',
    density: 5.7,
    imprecise: false,
    latitude: 36.94209,
    longitude: -95.54436,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74072',
  },
  {
    city: 'Sperry',
    county_fips: 40113,
    county_fips_all: '40113|40143',
    county: 'Osage',
    county_names_all: 'Osage|Tulsa',
    county_weights: '{"40113": 60.09, "40143": 39.91}',
    density: 48.6,
    imprecise: false,
    latitude: 36.29818,
    longitude: -96.01326,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74073',
  },
  {
    city: 'Stillwater',
    county_fips: 40119,
    county_fips_all: '40119',
    county: 'Payne',
    county_names_all: 'Payne',
    county_weights: '{"40119": 100}',
    density: 98.3,
    imprecise: false,
    latitude: 36.07832,
    longitude: -97.06452,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74074',
  },
  {
    city: 'Stillwater',
    county_fips: 40119,
    county_fips_all: '40119|40103',
    county: 'Payne',
    county_names_all: 'Payne|Noble',
    county_weights: '{"40119": 88.58, "40103": 11.42}',
    density: 107.7,
    imprecise: false,
    latitude: 36.17151,
    longitude: -97.0774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74075',
  },
  {
    city: 'Stroud',
    county_fips: 40081,
    county_fips_all: '40081|40037|40107',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Creek|Okfuskee',
    county_weights: '{"40081": 69.74, "40037": 29.12, "40107": 1.14}',
    density: 9.2,
    imprecise: false,
    latitude: 35.74368,
    longitude: -96.65592,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74079',
  },
  {
    city: 'Talala',
    county_fips: 40131,
    county_fips_all: '40131|40147',
    county: 'Rogers',
    county_names_all: 'Rogers|Washington',
    county_weights: '{"40131": 87.06, "40147": 12.94}',
    density: 11.7,
    imprecise: false,
    latitude: 36.52849,
    longitude: -95.74192,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74080',
  },
  {
    city: 'Terlton',
    county_fips: 40117,
    county_fips_all: '40117|40037',
    county: 'Pawnee',
    county_names_all: 'Pawnee|Creek',
    county_weights: '{"40117": 67.43, "40037": 32.57}',
    density: 20.1,
    imprecise: false,
    latitude: 36.17536,
    longitude: -96.45875,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74081',
  },
  {
    city: 'Vera',
    county_fips: 40147,
    county_fips_all: '40147',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"40147": 100}',
    density: 290.2,
    imprecise: false,
    latitude: 36.44889,
    longitude: -95.88091,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74082',
  },
  {
    city: 'Wann',
    county_fips: 40105,
    county_fips_all: '40105|40147',
    county: 'Nowata',
    county_names_all: 'Nowata|Washington',
    county_weights: '{"40105": 69.73, "40147": 30.27}',
    density: 2.8,
    imprecise: false,
    latitude: 36.91504,
    longitude: -95.77093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74083',
  },
  {
    city: 'Wynona',
    county_fips: 40113,
    county_fips_all: '40113',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"40113": 100}',
    density: 3,
    imprecise: false,
    latitude: 36.52849,
    longitude: -96.33325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74084',
  },
  {
    city: 'Yale',
    county_fips: 40119,
    county_fips_all: '40119|40117|40037',
    county: 'Payne',
    county_names_all: 'Payne|Pawnee|Creek',
    county_weights: '{"40119": 86.9, "40117": 8.23, "40037": 4.87}',
    density: 9.7,
    imprecise: false,
    latitude: 36.10795,
    longitude: -96.715,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74085',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1447,
    imprecise: false,
    latitude: 36.15617,
    longitude: -95.9957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74103',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1824.5,
    imprecise: false,
    latitude: 36.14627,
    longitude: -95.9542,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74104',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1431.8,
    imprecise: false,
    latitude: 36.0975,
    longitude: -95.9641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74105',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143|40113',
    county: 'Tulsa',
    county_names_all: 'Tulsa|Osage',
    county_weights: '{"40143": 99.14, "40113": 0.86}',
    density: 791.4,
    imprecise: false,
    latitude: 36.19191,
    longitude: -95.98416,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74106',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 289.3,
    imprecise: false,
    latitude: 36.10737,
    longitude: -96.04095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74107',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143|40145',
    county: 'Tulsa',
    county_names_all: 'Tulsa|Wagoner',
    county_weights: '{"40143": 86.12, "40145": 13.88}',
    density: 325.4,
    imprecise: false,
    latitude: 36.14723,
    longitude: -95.79154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74108',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1001.4,
    imprecise: false,
    latitude: 36.18856,
    longitude: -95.95377,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74110',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1211.2,
    imprecise: false,
    latitude: 36.14696,
    longitude: -95.90437,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74112',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1274.3,
    imprecise: false,
    latitude: 36.12696,
    longitude: -95.94661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74114',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 585.5,
    imprecise: false,
    latitude: 36.1923,
    longitude: -95.90903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74115',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143|40131',
    county: 'Tulsa',
    county_names_all: 'Tulsa|Rogers',
    county_weights: '{"40143": 80.77, "40131": 19.23}',
    density: 77.7,
    imprecise: false,
    latitude: 36.18814,
    longitude: -95.83621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74116',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 36.24146,
    longitude: -95.89854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74117',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1816.6,
    imprecise: false,
    latitude: 36.14205,
    longitude: -95.9894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74119',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 953.1,
    imprecise: false,
    latitude: 36.1504,
    longitude: -95.97689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74120',
  },
  {
    city: 'Tulsa',
    county_fips: 40113,
    county_fips_all: '40113|40143',
    county: 'Osage',
    county_names_all: 'Osage|Tulsa',
    county_weights: '{"40113": 74.37, "40143": 25.63}',
    density: 159.2,
    imprecise: false,
    latitude: 36.23502,
    longitude: -96.0331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74126',
  },
  {
    city: 'Tulsa',
    county_fips: 40113,
    county_fips_all: '40113|40143',
    county: 'Osage',
    county_names_all: 'Osage|Tulsa',
    county_weights: '{"40113": 70.56, "40143": 29.44}',
    density: 295.6,
    imprecise: false,
    latitude: 36.17462,
    longitude: -96.04511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74127',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1477.4,
    imprecise: false,
    latitude: 36.1472,
    longitude: -95.85089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74128',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1780.7,
    imprecise: false,
    latitude: 36.12669,
    longitude: -95.8701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74129',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 206.5,
    imprecise: false,
    latitude: 36.24172,
    longitude: -95.95536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74130',
  },
  {
    city: 'Tulsa',
    county_fips: 40037,
    county_fips_all: '40037|40143',
    county: 'Creek',
    county_names_all: 'Creek|Tulsa',
    county_weights: '{"40037": 99.88, "40143": 0.12}',
    density: 98.2,
    imprecise: false,
    latitude: 36.05172,
    longitude: -96.07291,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74131',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143|40037',
    county: 'Tulsa',
    county_names_all: 'Tulsa|Creek',
    county_weights: '{"40143": 75.06, "40037": 24.94}',
    density: 332.5,
    imprecise: false,
    latitude: 36.04869,
    longitude: -96.01315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74132',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1375.8,
    imprecise: false,
    latitude: 36.04113,
    longitude: -95.87955,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74133',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 745.9,
    imprecise: false,
    latitude: 36.1106,
    longitude: -95.80156,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74134',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1265,
    imprecise: false,
    latitude: 36.09725,
    longitude: -95.92315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74135',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1568.2,
    imprecise: false,
    latitude: 36.06188,
    longitude: -95.9419,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74136',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1059.3,
    imprecise: false,
    latitude: 36.02038,
    longitude: -95.92932,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74137',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1182.1,
    imprecise: false,
    latitude: 36.09728,
    longitude: -95.88731,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74145',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 1240.7,
    imprecise: false,
    latitude: 36.09784,
    longitude: -95.85344,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74146',
  },
  {
    city: 'Vinita',
    county_fips: 40035,
    county_fips_all: '40035|40097|40105',
    county: 'Craig',
    county_names_all: 'Craig|Mayes|Nowata',
    county_weights: '{"40035": 93.76, "40097": 3.74, "40105": 2.5}',
    density: 11.1,
    imprecise: false,
    latitude: 36.68157,
    longitude: -95.23687,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74301',
  },
  {
    city: 'Adair',
    county_fips: 40097,
    county_fips_all: '40097|40035',
    county: 'Mayes',
    county_names_all: 'Mayes|Craig',
    county_weights: '{"40097": 94.89, "40035": 5.11}',
    density: 9.4,
    imprecise: false,
    latitude: 36.4404,
    longitude: -95.26851,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74330',
  },
  {
    city: 'Afton',
    county_fips: 40041,
    county_fips_all: '40041|40115|40035',
    county: 'Delaware',
    county_names_all: 'Delaware|Ottawa|Craig',
    county_weights: '{"40041": 57.75, "40115": 28.11, "40035": 14.14}',
    density: 22,
    imprecise: false,
    latitude: 36.64683,
    longitude: -94.9459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74331',
  },
  {
    city: 'Big Cabin',
    county_fips: 40035,
    county_fips_all: '40035|40097|40131',
    county: 'Craig',
    county_names_all: 'Craig|Mayes|Rogers',
    county_weights: '{"40035": 43.57, "40097": 35.84, "40131": 20.59}',
    density: 9.3,
    imprecise: false,
    latitude: 36.52111,
    longitude: -95.23864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74332',
  },
  {
    city: 'Bluejacket',
    county_fips: 40035,
    county_fips_all: '40035|40115',
    county: 'Craig',
    county_names_all: 'Craig|Ottawa',
    county_weights: '{"40035": 87.94, "40115": 12.06}',
    density: 4.5,
    imprecise: false,
    latitude: 36.79386,
    longitude: -95.08408,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74333',
  },
  {
    city: 'Chouteau',
    county_fips: 40097,
    county_fips_all: '40097|40145',
    county: 'Mayes',
    county_names_all: 'Mayes|Wagoner',
    county_weights: '{"40097": 88.22, "40145": 11.78}',
    density: 20.5,
    imprecise: false,
    latitude: 36.14122,
    longitude: -95.33505,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74337',
  },
  {
    city: 'Colcord',
    county_fips: 40041,
    county_fips_all: '40041|40001',
    county: 'Delaware',
    county_names_all: 'Delaware|Adair',
    county_weights: '{"40041": 99.74, "40001": 0.26}',
    density: 13.9,
    imprecise: false,
    latitude: 36.26234,
    longitude: -94.71572,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74338',
  },
  {
    city: 'Commerce',
    county_fips: 40115,
    county_fips_all: '40115',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"40115": 100}',
    density: 253.8,
    imprecise: false,
    latitude: 36.934,
    longitude: -94.87975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74339',
  },
  {
    city: 'Disney',
    county_fips: 40097,
    county_fips_all: '40097',
    county: 'Mayes',
    county_names_all: 'Mayes',
    county_weights: '{"40097": 100}',
    density: 61.7,
    imprecise: false,
    latitude: 36.4777,
    longitude: -95.01944,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74340',
  },
  {
    city: 'Eucha',
    county_fips: 40041,
    county_fips_all: '40041|40097',
    county: 'Delaware',
    county_names_all: 'Delaware|Mayes',
    county_weights: '{"40041": 97.0, "40097": 3.0}',
    density: 10.5,
    imprecise: false,
    latitude: 36.42227,
    longitude: -94.94113,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74342',
  },
  {
    city: 'Fairland',
    county_fips: 40115,
    county_fips_all: '40115',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"40115": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 36.74287,
    longitude: -94.825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74343',
  },
  {
    city: 'Grove',
    county_fips: 40041,
    county_fips_all: '40041|40115',
    county: 'Delaware',
    county_names_all: 'Delaware|Ottawa',
    county_weights: '{"40041": 97.77, "40115": 2.23}',
    density: 64.1,
    imprecise: false,
    latitude: 36.59604,
    longitude: -94.73845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74344',
  },
  {
    city: 'Jay',
    county_fips: 40041,
    county_fips_all: '40041',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"40041": 100}',
    density: 14,
    imprecise: false,
    latitude: 36.43427,
    longitude: -94.75066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74346',
  },
  {
    city: 'Kansas',
    county_fips: 40041,
    county_fips_all: '40041|40001|40021',
    county: 'Delaware',
    county_names_all: 'Delaware|Adair|Cherokee',
    county_weights: '{"40041": 79.37, "40001": 12.79, "40021": 7.84}',
    density: 20.3,
    imprecise: false,
    latitude: 36.19573,
    longitude: -94.78525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74347',
  },
  {
    city: 'Ketchum',
    county_fips: 40035,
    county_fips_all: '40035|40097',
    county: 'Craig',
    county_names_all: 'Craig|Mayes',
    county_weights: '{"40035": 53.38, "40097": 46.62}',
    density: 54.9,
    imprecise: false,
    latitude: 36.51234,
    longitude: -95.02557,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74349',
  },
  {
    city: 'Langley',
    county_fips: 40097,
    county_fips_all: '40097',
    county: 'Mayes',
    county_names_all: 'Mayes',
    county_weights: '{"40097": 100}',
    density: 44,
    imprecise: false,
    latitude: 36.46643,
    longitude: -95.04776,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74350',
  },
  {
    city: 'Locust Grove',
    county_fips: 40097,
    county_fips_all: '40097|40145|40021',
    county: 'Mayes',
    county_names_all: 'Mayes|Wagoner|Cherokee',
    county_weights: '{"40097": 78.81, "40145": 15.23, "40021": 5.96}',
    density: 18.3,
    imprecise: false,
    latitude: 36.13693,
    longitude: -95.18783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74352',
  },
  {
    city: 'Miami',
    county_fips: 40115,
    county_fips_all: '40115|40035',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Craig',
    county_weights: '{"40115": 96.79, "40035": 3.21}',
    density: 36.1,
    imprecise: false,
    latitude: 36.88962,
    longitude: -94.88096,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74354',
  },
  {
    city: 'North Miami',
    county_fips: 40115,
    county_fips_all: '40115',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"40115": 100}',
    density: 639.3,
    imprecise: false,
    latitude: 36.91798,
    longitude: -94.88052,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74358',
  },
  {
    city: 'Oaks',
    county_fips: 40041,
    county_fips_all: '40041|40021',
    county: 'Delaware',
    county_names_all: 'Delaware|Cherokee',
    county_weights: '{"40041": 94.64, "40021": 5.36}',
    density: 54.3,
    imprecise: false,
    latitude: 36.16846,
    longitude: -94.85218,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74359',
  },
  {
    city: 'Picher',
    county_fips: 40115,
    county_fips_all: '40115',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"40115": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 36.9801,
    longitude: -94.83636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74360',
  },
  {
    city: 'Pryor',
    county_fips: 40097,
    county_fips_all: '40097',
    county: 'Mayes',
    county_names_all: 'Mayes',
    county_weights: '{"40097": 100}',
    density: 41.6,
    imprecise: false,
    latitude: 36.30914,
    longitude: -95.30732,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74361',
  },
  {
    city: 'Quapaw',
    county_fips: 40115,
    county_fips_all: '40115',
    county: 'Ottawa',
    county_names_all: 'Ottawa',
    county_weights: '{"40115": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 36.95341,
    longitude: -94.70965,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74363',
  },
  {
    city: 'Rose',
    county_fips: 40041,
    county_fips_all: '40041|40021|40097',
    county: 'Delaware',
    county_names_all: 'Delaware|Cherokee|Mayes',
    county_weights: '{"40041": 66.05, "40021": 21.03, "40097": 12.92}',
    density: 7.6,
    imprecise: false,
    latitude: 36.19915,
    longitude: -94.95683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74364',
  },
  {
    city: 'Salina',
    county_fips: 40097,
    county_fips_all: '40097|40041',
    county: 'Mayes',
    county_names_all: 'Mayes|Delaware',
    county_weights: '{"40097": 74.89, "40041": 25.11}',
    density: 20.1,
    imprecise: false,
    latitude: 36.29072,
    longitude: -95.05461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74365',
  },
  {
    city: 'Spavinaw',
    county_fips: 40097,
    county_fips_all: '40097|40041',
    county: 'Mayes',
    county_names_all: 'Mayes|Delaware',
    county_weights: '{"40097": 89.94, "40041": 10.06}',
    density: 13.8,
    imprecise: false,
    latitude: 36.37887,
    longitude: -95.04449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74366',
  },
  {
    city: 'Strang',
    county_fips: 40097,
    county_fips_all: '40097',
    county: 'Mayes',
    county_names_all: 'Mayes',
    county_weights: '{"40097": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 36.4222,
    longitude: -95.10674,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74367',
  },
  {
    city: 'Twin Oaks',
    county_fips: 40041,
    county_fips_all: '40041',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"40041": 100}',
    density: 22.2,
    imprecise: false,
    latitude: 36.20725,
    longitude: -94.84822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74368',
  },
  {
    city: 'Welch',
    county_fips: 40035,
    county_fips_all: '40035',
    county: 'Craig',
    county_names_all: 'Craig',
    county_weights: '{"40035": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 36.92237,
    longitude: -95.19776,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74369',
  },
  {
    city: 'Wyandotte',
    county_fips: 40115,
    county_fips_all: '40115|40041',
    county: 'Ottawa',
    county_names_all: 'Ottawa|Delaware',
    county_weights: '{"40115": 92.49, "40041": 7.51}',
    density: 13.1,
    imprecise: false,
    latitude: 36.76429,
    longitude: -94.68017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74370',
  },
  {
    city: 'Muskogee',
    county_fips: 40101,
    county_fips_all: '40101',
    county: 'Muskogee',
    county_names_all: 'Muskogee',
    county_weights: '{"40101": 100}',
    density: 55.5,
    imprecise: false,
    latitude: 35.72304,
    longitude: -95.45431,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74401',
  },
  {
    city: 'Muskogee',
    county_fips: 40101,
    county_fips_all: '40101|40145',
    county: 'Muskogee',
    county_names_all: 'Muskogee|Wagoner',
    county_weights: '{"40101": 94.75, "40145": 5.25}',
    density: 102.8,
    imprecise: false,
    latitude: 35.67427,
    longitude: -95.305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74403',
  },
  {
    city: 'Beggs',
    county_fips: 40111,
    county_fips_all: '40111|40037',
    county: 'Okmulgee',
    county_names_all: 'Okmulgee|Creek',
    county_weights: '{"40111": 98.63, "40037": 1.37}',
    density: 12.8,
    imprecise: false,
    latitude: 35.75928,
    longitude: -96.03615,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74421',
  },
  {
    city: 'Boynton',
    county_fips: 40101,
    county_fips_all: '40101|40111',
    county: 'Muskogee',
    county_names_all: 'Muskogee|Okmulgee',
    county_weights: '{"40101": 57.3, "40111": 42.7}',
    density: 4,
    imprecise: false,
    latitude: 35.64156,
    longitude: -95.69143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74422',
  },
  {
    city: 'Braggs',
    county_fips: 40101,
    county_fips_all: '40101',
    county: 'Muskogee',
    county_names_all: 'Muskogee',
    county_weights: '{"40101": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 35.64251,
    longitude: -95.22339,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74423',
  },
  {
    city: 'Canadian',
    county_fips: 40121,
    county_fips_all: '40121',
    county: 'Pittsburg',
    county_names_all: 'Pittsburg',
    county_weights: '{"40121": 100}',
    density: 44.3,
    imprecise: false,
    latitude: 35.17184,
    longitude: -95.62299,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74425',
  },
  {
    city: 'Checotah',
    county_fips: 40091,
    county_fips_all: '40091|40101',
    county: 'McIntosh',
    county_names_all: 'McIntosh|Muskogee',
    county_weights: '{"40091": 99.84, "40101": 0.16}',
    density: 17,
    imprecise: false,
    latitude: 35.44553,
    longitude: -95.52759,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74426',
  },
  {
    city: 'Cookson',
    county_fips: 40021,
    county_fips_all: '40021',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"40021": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 35.68638,
    longitude: -94.91056,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74427',
  },
  {
    city: 'Council Hill',
    county_fips: 40091,
    county_fips_all: '40091|40101',
    county: 'McIntosh',
    county_names_all: 'McIntosh|Muskogee',
    county_weights: '{"40091": 53.44, "40101": 46.56}',
    density: 5.7,
    imprecise: false,
    latitude: 35.54835,
    longitude: -95.64683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74428',
  },
  {
    city: 'Coweta',
    county_fips: 40145,
    county_fips_all: '40145',
    county: 'Wagoner',
    county_names_all: 'Wagoner',
    county_weights: '{"40145": 100}',
    density: 76.2,
    imprecise: false,
    latitude: 35.94872,
    longitude: -95.63065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74429',
  },
  {
    city: 'Crowder',
    county_fips: 40121,
    county_fips_all: '40121',
    county: 'Pittsburg',
    county_names_all: 'Pittsburg',
    county_weights: '{"40121": 100}',
    density: 30.1,
    imprecise: false,
    latitude: 35.13175,
    longitude: -95.64826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74430',
  },
  {
    city: 'Dewar',
    county_fips: 40111,
    county_fips_all: '40111',
    county: 'Okmulgee',
    county_names_all: 'Okmulgee',
    county_weights: '{"40111": 100}',
    density: 78.6,
    imprecise: false,
    latitude: 35.45743,
    longitude: -95.93934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74431',
  },
  {
    city: 'Eufaula',
    county_fips: 40091,
    county_fips_all: '40091|40121',
    county: 'McIntosh',
    county_names_all: 'McIntosh|Pittsburg',
    county_weights: '{"40091": 79.37, "40121": 20.63}',
    density: 17.8,
    imprecise: false,
    latitude: 35.28371,
    longitude: -95.64911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74432',
  },
  {
    city: 'Fort Gibson',
    county_fips: 40101,
    county_fips_all: '40101|40021|40145',
    county: 'Muskogee',
    county_names_all: 'Muskogee|Cherokee|Wagoner',
    county_weights: '{"40101": 61.35, "40021": 26.04, "40145": 12.61}',
    density: 30.1,
    imprecise: false,
    latitude: 35.78174,
    longitude: -95.20027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74434',
  },
  {
    city: 'Gore',
    county_fips: 40135,
    county_fips_all: '40135|40101',
    county: 'Sequoyah',
    county_names_all: 'Sequoyah|Muskogee',
    county_weights: '{"40135": 74.39, "40101": 25.61}',
    density: 18.7,
    imprecise: false,
    latitude: 35.57862,
    longitude: -95.09405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74435',
  },
  {
    city: 'Haskell',
    county_fips: 40101,
    county_fips_all: '40101|40145|40111',
    county: 'Muskogee',
    county_names_all: 'Muskogee|Wagoner|Okmulgee',
    county_weights: '{"40101": 64.05, "40145": 21.27, "40111": 14.68}',
    density: 13.7,
    imprecise: false,
    latitude: 35.80034,
    longitude: -95.70175,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74436',
  },
  {
    city: 'Henryetta',
    county_fips: 40111,
    county_fips_all: '40111|40091|40107',
    county: 'Okmulgee',
    county_names_all: 'Okmulgee|McIntosh|Okfuskee',
    county_weights: '{"40111": 67.18, "40091": 26.37, "40107": 6.45}',
    density: 18.1,
    imprecise: false,
    latitude: 35.44825,
    longitude: -95.94417,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74437',
  },
  {
    city: 'Hitchita',
    county_fips: 40091,
    county_fips_all: '40091',
    county: 'McIntosh',
    county_names_all: 'McIntosh',
    county_weights: '{"40091": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 35.51382,
    longitude: -95.75935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74438',
  },
  {
    city: 'Hulbert',
    county_fips: 40021,
    county_fips_all: '40021',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"40021": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 35.97458,
    longitude: -95.14613,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74441',
  },
  {
    city: 'Indianola',
    county_fips: 40121,
    county_fips_all: '40121',
    county: 'Pittsburg',
    county_names_all: 'Pittsburg',
    county_weights: '{"40121": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 35.12983,
    longitude: -95.8151,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74442',
  },
  {
    city: 'Morris',
    county_fips: 40111,
    county_fips_all: '40111|40091',
    county: 'Okmulgee',
    county_names_all: 'Okmulgee|McIntosh',
    county_weights: '{"40111": 97.68, "40091": 2.32}',
    density: 14.5,
    imprecise: false,
    latitude: 35.62729,
    longitude: -95.82605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74445',
  },
  {
    city: 'Okay',
    county_fips: 40145,
    county_fips_all: '40145',
    county: 'Wagoner',
    county_names_all: 'Wagoner',
    county_weights: '{"40145": 100}',
    density: 126.3,
    imprecise: false,
    latitude: 35.85117,
    longitude: -95.32264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74446',
  },
  {
    city: 'Okmulgee',
    county_fips: 40111,
    county_fips_all: '40111',
    county: 'Okmulgee',
    county_names_all: 'Okmulgee',
    county_weights: '{"40111": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 35.64975,
    longitude: -96.00628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74447',
  },
  {
    city: 'Oktaha',
    county_fips: 40101,
    county_fips_all: '40101',
    county: 'Muskogee',
    county_names_all: 'Muskogee',
    county_weights: '{"40101": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 35.59714,
    longitude: -95.47541,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74450',
  },
  {
    city: 'Park Hill',
    county_fips: 40021,
    county_fips_all: '40021',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"40021": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 35.72886,
    longitude: -95.00166,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74451',
  },
  {
    city: 'Peggs',
    county_fips: 40021,
    county_fips_all: '40021|40097',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Mayes',
    county_weights: '{"40021": 91.79, "40097": 8.21}',
    density: 4.2,
    imprecise: false,
    latitude: 36.12137,
    longitude: -95.06829,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74452',
  },
  {
    city: 'Porter',
    county_fips: 40145,
    county_fips_all: '40145',
    county: 'Wagoner',
    county_names_all: 'Wagoner',
    county_weights: '{"40145": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 35.85464,
    longitude: -95.51253,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74454',
  },
  {
    city: 'Porum',
    county_fips: 40101,
    county_fips_all: '40101|40091',
    county: 'Muskogee',
    county_names_all: 'Muskogee|McIntosh',
    county_weights: '{"40101": 86.92, "40091": 13.08}',
    density: 7.8,
    imprecise: false,
    latitude: 35.36238,
    longitude: -95.26867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74455',
  },
  {
    city: 'Preston',
    county_fips: 40111,
    county_fips_all: '40111',
    county: 'Okmulgee',
    county_names_all: 'Okmulgee',
    county_weights: '{"40111": 100}',
    density: 121.5,
    imprecise: false,
    latitude: 35.71083,
    longitude: -95.99262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 78,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74456',
  },
  {
    city: 'Proctor',
    county_fips: 40021,
    county_fips_all: '40021|40001',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Adair',
    county_weights: '{"40021": 62.08, "40001": 37.92}',
    density: 2.4,
    imprecise: false,
    latitude: 36.03063,
    longitude: -94.82065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74457',
  },
  {
    city: 'Redbird',
    county_fips: 40145,
    county_fips_all: '40145',
    county: 'Wagoner',
    county_names_all: 'Wagoner',
    county_weights: '{"40145": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 35.88231,
    longitude: -95.58786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74458',
  },
  {
    city: 'Rentiesville',
    county_fips: 40091,
    county_fips_all: '40091',
    county: 'McIntosh',
    county_names_all: 'McIntosh',
    county_weights: '{"40091": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 35.51878,
    longitude: -95.49217,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74459',
  },
  {
    city: 'Schulter',
    county_fips: 40111,
    county_fips_all: '40111',
    county: 'Okmulgee',
    county_names_all: 'Okmulgee',
    county_weights: '{"40111": 100}',
    density: 69.2,
    imprecise: false,
    latitude: 35.50473,
    longitude: -95.96452,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74460',
  },
  {
    city: 'Stigler',
    county_fips: 40061,
    county_fips_all: '40061|40121',
    county: 'Haskell',
    county_names_all: 'Haskell|Pittsburg',
    county_weights: '{"40061": 96.71, "40121": 3.29}',
    density: 10.3,
    imprecise: false,
    latitude: 35.28328,
    longitude: -95.15041,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74462',
  },
  {
    city: 'Taft',
    county_fips: 40101,
    county_fips_all: '40101',
    county: 'Muskogee',
    county_names_all: 'Muskogee',
    county_weights: '{"40101": 100}',
    density: 147.7,
    imprecise: false,
    latitude: 35.76943,
    longitude: -95.54843,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74463',
  },
  {
    city: 'Tahlequah',
    county_fips: 40021,
    county_fips_all: '40021',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"40021": 100}',
    density: 47.3,
    imprecise: false,
    latitude: 35.94419,
    longitude: -94.97365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74464',
  },
  {
    city: 'Wagoner',
    county_fips: 40145,
    county_fips_all: '40145',
    county: 'Wagoner',
    county_names_all: 'Wagoner',
    county_weights: '{"40145": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 35.96681,
    longitude: -95.39181,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74467',
  },
  {
    city: 'Wainwright',
    county_fips: 40101,
    county_fips_all: '40101',
    county: 'Muskogee',
    county_names_all: 'Muskogee',
    county_weights: '{"40101": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 35.62121,
    longitude: -95.59025,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74468',
  },
  {
    city: 'Warner',
    county_fips: 40101,
    county_fips_all: '40101|40091',
    county: 'Muskogee',
    county_names_all: 'Muskogee|McIntosh',
    county_weights: '{"40101": 88.45, "40091": 11.55}',
    density: 16.1,
    imprecise: false,
    latitude: 35.5083,
    longitude: -95.31545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74469',
  },
  {
    city: 'Webbers Falls',
    county_fips: 40101,
    county_fips_all: '40101',
    county: 'Muskogee',
    county_names_all: 'Muskogee',
    county_weights: '{"40101": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 35.47906,
    longitude: -95.16879,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74470',
  },
  {
    city: 'Welling',
    county_fips: 40021,
    county_fips_all: '40021',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"40021": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 35.82749,
    longitude: -94.86454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74471',
  },
  {
    city: 'Whitefield',
    county_fips: 40061,
    county_fips_all: '40061',
    county: 'Haskell',
    county_names_all: 'Haskell',
    county_weights: '{"40061": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 35.25028,
    longitude: -95.263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74472',
  },
  {
    city: 'Wagoner',
    county_fips: 40145,
    county_fips_all: '40145',
    county: 'Wagoner',
    county_names_all: 'Wagoner',
    county_weights: '{"40145": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.00394,
    longitude: -95.26644,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74477',
  },
  {
    city: 'Mcalester',
    county_fips: 40121,
    county_fips_all: '40121',
    county: 'Pittsburg',
    county_names_all: 'Pittsburg',
    county_weights: '{"40121": 100}',
    density: 20.1,
    imprecise: false,
    latitude: 34.98501,
    longitude: -95.78597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74501',
  },
  {
    city: 'Albion',
    county_fips: 40127,
    county_fips_all: '40127',
    county: 'Pushmataha',
    county_names_all: 'Pushmataha',
    county_weights: '{"40127": 100}',
    density: 88.4,
    imprecise: false,
    latitude: 34.66222,
    longitude: -95.09934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74521',
  },
  {
    city: 'Alderson',
    county_fips: 40121,
    county_fips_all: '40121',
    county: 'Pittsburg',
    county_names_all: 'Pittsburg',
    county_weights: '{"40121": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 34.88253,
    longitude: -95.6767,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74522',
  },
  {
    city: 'Antlers',
    county_fips: 40127,
    county_fips_all: '40127|40023|40005',
    county: 'Pushmataha',
    county_names_all: 'Pushmataha|Choctaw|Atoka',
    county_weights: '{"40127": 92.76, "40023": 5.56, "40005": 1.68}',
    density: 8.3,
    imprecise: false,
    latitude: 34.25171,
    longitude: -95.60018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74523',
  },
  {
    city: 'Atoka',
    county_fips: 40005,
    county_fips_all: '40005|40029',
    county: 'Atoka',
    county_names_all: 'Atoka|Coal',
    county_weights: '{"40005": 99.15, "40029": 0.85}',
    density: 9.3,
    imprecise: false,
    latitude: 34.33441,
    longitude: -96.05563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74525',
  },
  {
    city: 'Blanco',
    county_fips: 40121,
    county_fips_all: '40121',
    county: 'Pittsburg',
    county_names_all: 'Pittsburg',
    county_weights: '{"40121": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 34.71644,
    longitude: -95.723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74528',
  },
  {
    city: 'Bromide',
    county_fips: 40069,
    county_fips_all: '40069|40029',
    county: 'Johnston',
    county_names_all: 'Johnston|Coal',
    county_weights: '{"40069": 65.19, "40029": 34.81}',
    density: 3,
    imprecise: false,
    latitude: 34.42677,
    longitude: -96.5152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74530',
  },
  {
    city: 'Calvin',
    county_fips: 40063,
    county_fips_all: '40063|40029',
    county: 'Hughes',
    county_names_all: 'Hughes|Coal',
    county_weights: '{"40063": 94.75, "40029": 5.25}',
    density: 3.1,
    imprecise: false,
    latitude: 34.8777,
    longitude: -96.24035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74531',
  },
  {
    city: 'Caney',
    county_fips: 40005,
    county_fips_all: '40005',
    county: 'Atoka',
    county_names_all: 'Atoka',
    county_weights: '{"40005": 100}',
    density: 8,
    imprecise: false,
    latitude: 34.20521,
    longitude: -96.18893,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74533',
  },
  {
    city: 'Centrahoma',
    county_fips: 40029,
    county_fips_all: '40029',
    county: 'Coal',
    county_names_all: 'Coal',
    county_weights: '{"40029": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 34.61965,
    longitude: -96.36634,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74534',
  },
  {
    city: 'Clarita',
    county_fips: 40029,
    county_fips_all: '40029',
    county: 'Coal',
    county_names_all: 'Coal',
    county_weights: '{"40029": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 34.48384,
    longitude: -96.44202,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74535',
  },
  {
    city: 'Clayton',
    county_fips: 40127,
    county_fips_all: '40127|40077|40121',
    county: 'Pushmataha',
    county_names_all: 'Pushmataha|Latimer|Pittsburg',
    county_weights: '{"40127": 90.32, "40077": 6.42, "40121": 3.26}',
    density: 1.7,
    imprecise: false,
    latitude: 34.55697,
    longitude: -95.45955,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74536',
  },
  {
    city: 'Coalgate',
    county_fips: 40029,
    county_fips_all: '40029|40005',
    county: 'Coal',
    county_names_all: 'Coal|Atoka',
    county_weights: '{"40029": 99.11, "40005": 0.89}',
    density: 4.2,
    imprecise: false,
    latitude: 34.57453,
    longitude: -96.25575,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74538',
  },
  {
    city: 'Daisy',
    county_fips: 40005,
    county_fips_all: '40005|40127',
    county: 'Atoka',
    county_names_all: 'Atoka|Pushmataha',
    county_weights: '{"40005": 79.65, "40127": 20.35}',
    density: 1.7,
    imprecise: false,
    latitude: 34.55776,
    longitude: -95.70167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74540',
  },
  {
    city: 'Finley',
    county_fips: 40127,
    county_fips_all: '40127',
    county: 'Pushmataha',
    county_names_all: 'Pushmataha',
    county_weights: '{"40127": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 34.35927,
    longitude: -95.37907,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74543',
  },
  {
    city: 'Haileyville',
    county_fips: 40121,
    county_fips_all: '40121',
    county: 'Pittsburg',
    county_names_all: 'Pittsburg',
    county_weights: '{"40121": 100}',
    density: 99,
    imprecise: false,
    latitude: 34.85186,
    longitude: -95.58001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74546',
  },
  {
    city: 'Hartshorne',
    county_fips: 40121,
    county_fips_all: '40121|40077',
    county: 'Pittsburg',
    county_names_all: 'Pittsburg|Latimer',
    county_weights: '{"40121": 96.16, "40077": 3.84}',
    density: 10.4,
    imprecise: false,
    latitude: 34.81019,
    longitude: -95.59782,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74547',
  },
  {
    city: 'Honobia',
    county_fips: 40079,
    county_fips_all: '40079|40127',
    county: 'Le Flore',
    county_names_all: 'Le Flore|Pushmataha',
    county_weights: '{"40079": 65.41, "40127": 34.59}',
    density: 0.7,
    imprecise: false,
    latitude: 34.57483,
    longitude: -94.90993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74549',
  },
  {
    city: 'Kinta',
    county_fips: 40061,
    county_fips_all: '40061|40121',
    county: 'Haskell',
    county_names_all: 'Haskell|Pittsburg',
    county_weights: '{"40061": 99.23, "40121": 0.77}',
    density: 4.3,
    imprecise: false,
    latitude: 35.11282,
    longitude: -95.24734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74552',
  },
  {
    city: 'Kiowa',
    county_fips: 40121,
    county_fips_all: '40121|40005',
    county: 'Pittsburg',
    county_names_all: 'Pittsburg|Atoka',
    county_weights: '{"40121": 69.89, "40005": 30.11}',
    density: 6.8,
    imprecise: false,
    latitude: 34.70808,
    longitude: -95.91859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74553',
  },
  {
    city: 'Krebs',
    county_fips: 40121,
    county_fips_all: '40121',
    county: 'Pittsburg',
    county_names_all: 'Pittsburg',
    county_weights: '{"40121": 100}',
    density: 255.5,
    imprecise: false,
    latitude: 34.92552,
    longitude: -95.7203,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74554',
  },
  {
    city: 'Lane',
    county_fips: 40005,
    county_fips_all: '40005',
    county: 'Atoka',
    county_names_all: 'Atoka',
    county_weights: '{"40005": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 34.2459,
    longitude: -95.96944,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74555',
  },
  {
    city: 'Lehigh',
    county_fips: 40029,
    county_fips_all: '40029',
    county: 'Coal',
    county_names_all: 'Coal',
    county_weights: '{"40029": 100}',
    density: 17,
    imprecise: false,
    latitude: 34.46102,
    longitude: -96.19878,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74556',
  },
  {
    city: 'Moyers',
    county_fips: 40127,
    county_fips_all: '40127',
    county: 'Pushmataha',
    county_names_all: 'Pushmataha',
    county_weights: '{"40127": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 34.40355,
    longitude: -95.69344,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74557',
  },
  {
    city: 'Nashoba',
    county_fips: 40127,
    county_fips_all: '40127',
    county: 'Pushmataha',
    county_names_all: 'Pushmataha',
    county_weights: '{"40127": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 34.49174,
    longitude: -95.15081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74558',
  },
  {
    city: 'Pittsburg',
    county_fips: 40121,
    county_fips_all: '40121|40005',
    county: 'Pittsburg',
    county_names_all: 'Pittsburg|Atoka',
    county_weights: '{"40121": 79.5, "40005": 20.5}',
    density: 0.8,
    imprecise: false,
    latitude: 34.64717,
    longitude: -95.74679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74560',
  },
  {
    city: 'Quinton',
    county_fips: 40121,
    county_fips_all: '40121|40061',
    county: 'Pittsburg',
    county_names_all: 'Pittsburg|Haskell',
    county_weights: '{"40121": 75.77, "40061": 24.23}',
    density: 5.8,
    imprecise: false,
    latitude: 35.12489,
    longitude: -95.42929,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74561',
  },
  {
    city: 'Rattan',
    county_fips: 40127,
    county_fips_all: '40127',
    county: 'Pushmataha',
    county_names_all: 'Pushmataha',
    county_weights: '{"40127": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 34.29683,
    longitude: -95.29637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74562',
  },
  {
    city: 'Red Oak',
    county_fips: 40077,
    county_fips_all: '40077|40079',
    county: 'Latimer',
    county_names_all: 'Latimer|Le Flore',
    county_weights: '{"40077": 93.69, "40079": 6.31}',
    density: 3.6,
    imprecise: false,
    latitude: 34.97903,
    longitude: -95.07556,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74563',
  },
  {
    city: 'Savanna',
    county_fips: 40121,
    county_fips_all: '40121',
    county: 'Pittsburg',
    county_names_all: 'Pittsburg',
    county_weights: '{"40121": 100}',
    density: 24.4,
    imprecise: false,
    latitude: 34.82222,
    longitude: -95.83301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74565',
  },
  {
    city: 'Snow',
    county_fips: 40127,
    county_fips_all: '40127',
    county: 'Pushmataha',
    county_names_all: 'Pushmataha',
    county_weights: '{"40127": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 34.44871,
    longitude: -95.35575,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 79,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74567',
  },
  {
    city: 'Stringtown',
    county_fips: 40005,
    county_fips_all: '40005',
    county: 'Atoka',
    county_names_all: 'Atoka',
    county_weights: '{"40005": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 34.47921,
    longitude: -95.90315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74569',
  },
  {
    city: 'Stuart',
    county_fips: 40063,
    county_fips_all: '40063|40121',
    county: 'Hughes',
    county_names_all: 'Hughes|Pittsburg',
    county_weights: '{"40063": 59.57, "40121": 40.43}',
    density: 3.3,
    imprecise: false,
    latitude: 34.86574,
    longitude: -96.10432,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74570',
  },
  {
    city: 'Talihina',
    county_fips: 40077,
    county_fips_all: '40077|40079|40127',
    county: 'Latimer',
    county_names_all: 'Latimer|Le Flore|Pushmataha',
    county_weights: '{"40077": 42.91, "40079": 41.35, "40127": 15.74}',
    density: 5.2,
    imprecise: false,
    latitude: 34.71915,
    longitude: -95.04948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74571',
  },
  {
    city: 'Tupelo',
    county_fips: 40029,
    county_fips_all: '40029|40123',
    county: 'Coal',
    county_names_all: 'Coal|Pontotoc',
    county_weights: '{"40029": 83.23, "40123": 16.77}',
    density: 7.1,
    imprecise: false,
    latitude: 34.63831,
    longitude: -96.42594,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74572',
  },
  {
    city: 'Tuskahoma',
    county_fips: 40127,
    county_fips_all: '40127|40077',
    county: 'Pushmataha',
    county_names_all: 'Pushmataha|Latimer',
    county_weights: '{"40127": 56.89, "40077": 43.11}',
    density: 3,
    imprecise: false,
    latitude: 34.67885,
    longitude: -95.27335,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74574',
  },
  {
    city: 'Wardville',
    county_fips: 40005,
    county_fips_all: '40005|40121',
    county: 'Atoka',
    county_names_all: 'Atoka|Pittsburg',
    county_weights: '{"40005": 55.05, "40121": 44.95}',
    density: 1.4,
    imprecise: false,
    latitude: 34.67046,
    longitude: -96.04259,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74576',
  },
  {
    city: 'Whitesboro',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 34.71967,
    longitude: -94.85689,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74577',
  },
  {
    city: 'Wilburton',
    county_fips: 40077,
    county_fips_all: '40077',
    county: 'Latimer',
    county_names_all: 'Latimer',
    county_weights: '{"40077": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 34.90045,
    longitude: -95.34872,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74578',
  },
  {
    city: 'Ponca City',
    county_fips: 40071,
    county_fips_all: '40071|40103',
    county: 'Kay',
    county_names_all: 'Kay|Noble',
    county_weights: '{"40071": 95.7, "40103": 4.3}',
    density: 45.5,
    imprecise: false,
    latitude: 36.70436,
    longitude: -97.14604,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74601',
  },
  {
    city: 'Ponca City',
    county_fips: 40071,
    county_fips_all: '40071|40113',
    county: 'Kay',
    county_names_all: 'Kay|Osage',
    county_weights: '{"40071": 50.73, "40113": 49.27}',
    density: 35.1,
    imprecise: false,
    latitude: 36.69672,
    longitude: -96.98132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74604',
  },
  {
    city: 'Billings',
    county_fips: 40103,
    county_fips_all: '40103|40047',
    county: 'Noble',
    county_names_all: 'Noble|Garfield',
    county_weights: '{"40103": 73.31, "40047": 26.69}',
    density: 2.8,
    imprecise: false,
    latitude: 36.49736,
    longitude: -97.4296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74630',
  },
  {
    city: 'Blackwell',
    county_fips: 40071,
    county_fips_all: '40071',
    county: 'Kay',
    county_names_all: 'Kay',
    county_weights: '{"40071": 100}',
    density: 25,
    imprecise: false,
    latitude: 36.79858,
    longitude: -97.30585,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74631',
  },
  {
    city: 'Braman',
    county_fips: 40071,
    county_fips_all: '40071',
    county: 'Kay',
    county_names_all: 'Kay',
    county_weights: '{"40071": 100}',
    density: 2,
    imprecise: false,
    latitude: 36.93958,
    longitude: -97.34144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74632',
  },
  {
    city: 'Burbank',
    county_fips: 40113,
    county_fips_all: '40113',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"40113": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 36.70478,
    longitude: -96.79216,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74633',
  },
  {
    city: 'Deer Creek',
    county_fips: 40053,
    county_fips_all: '40053',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"40053": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 36.82257,
    longitude: -97.52222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74636',
  },
  {
    city: 'Fairfax',
    county_fips: 40113,
    county_fips_all: '40113',
    county: 'Osage',
    county_names_all: 'Osage',
    county_weights: '{"40113": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 36.59083,
    longitude: -96.68172,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74637',
  },
  {
    city: 'Hunter',
    county_fips: 40047,
    county_fips_all: '40047|40053',
    county: 'Garfield',
    county_names_all: 'Garfield|Grant',
    county_weights: '{"40047": 74.26, "40053": 25.74}',
    density: 1.3,
    imprecise: false,
    latitude: 36.56589,
    longitude: -97.65032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74640',
  },
  {
    city: 'Kaw City',
    county_fips: 40071,
    county_fips_all: '40071',
    county: 'Kay',
    county_names_all: 'Kay',
    county_weights: '{"40071": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 36.8181,
    longitude: -96.85709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74641',
  },
  {
    city: 'Lamont',
    county_fips: 40053,
    county_fips_all: '40053|40071',
    county: 'Grant',
    county_names_all: 'Grant|Kay',
    county_weights: '{"40053": 93.15, "40071": 6.85}',
    density: 1.7,
    imprecise: false,
    latitude: 36.68457,
    longitude: -97.55379,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74643',
  },
  {
    city: 'Marland',
    county_fips: 40103,
    county_fips_all: '40103',
    county: 'Noble',
    county_names_all: 'Noble',
    county_weights: '{"40103": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 36.55713,
    longitude: -97.09768,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74644',
  },
  {
    city: 'Nardin',
    county_fips: 40071,
    county_fips_all: '40071|40053',
    county: 'Kay',
    county_names_all: 'Kay|Grant',
    county_weights: '{"40071": 76.87, "40053": 23.13}',
    density: 2.1,
    imprecise: false,
    latitude: 36.82498,
    longitude: -97.43993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74646',
  },
  {
    city: 'Newkirk',
    county_fips: 40071,
    county_fips_all: '40071',
    county: 'Kay',
    county_names_all: 'Kay',
    county_weights: '{"40071": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 36.91601,
    longitude: -97.00272,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74647',
  },
  {
    city: 'Ralston',
    county_fips: 40113,
    county_fips_all: '40113|40117',
    county: 'Osage',
    county_names_all: 'Osage|Pawnee',
    county_weights: '{"40113": 75.6, "40117": 24.4}',
    density: 1.4,
    imprecise: false,
    latitude: 36.47993,
    longitude: -96.72282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74650',
  },
  {
    city: 'Red Rock',
    county_fips: 40103,
    county_fips_all: '40103|40117',
    county: 'Noble',
    county_names_all: 'Noble|Pawnee',
    county_weights: '{"40103": 95.33, "40117": 4.67}',
    density: 2.2,
    imprecise: false,
    latitude: 36.46985,
    longitude: -97.17197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74651',
  },
  {
    city: 'Shidler',
    county_fips: 40113,
    county_fips_all: '40113|40071',
    county: 'Osage',
    county_names_all: 'Osage|Kay',
    county_weights: '{"40113": 89.13, "40071": 10.87}',
    density: 1.2,
    imprecise: false,
    latitude: 36.85639,
    longitude: -96.65438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74652',
  },
  {
    city: 'Tonkawa',
    county_fips: 40071,
    county_fips_all: '40071|40103',
    county: 'Kay',
    county_names_all: 'Kay|Noble',
    county_weights: '{"40071": 90.47, "40103": 9.53}',
    density: 12.8,
    imprecise: false,
    latitude: 36.64683,
    longitude: -97.3442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74653',
  },
  {
    city: 'Durant',
    county_fips: 40013,
    county_fips_all: '40013',
    county: 'Bryan',
    county_names_all: 'Bryan',
    county_weights: '{"40013": 100}',
    density: 60.1,
    imprecise: false,
    latitude: 34.00974,
    longitude: -96.3769,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74701',
  },
  {
    city: 'Achille',
    county_fips: 40013,
    county_fips_all: '40013',
    county: 'Bryan',
    county_names_all: 'Bryan',
    county_weights: '{"40013": 100}',
    density: 86.1,
    imprecise: false,
    latitude: 33.83141,
    longitude: -96.37768,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74720',
  },
  {
    city: 'Albany',
    county_fips: 40013,
    county_fips_all: '40013',
    county: 'Bryan',
    county_names_all: 'Bryan',
    county_weights: '{"40013": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.87977,
    longitude: -96.16266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74721',
  },
  {
    city: 'Battiest',
    county_fips: 40089,
    county_fips_all: '40089',
    county: 'McCurtain',
    county_names_all: 'McCurtain',
    county_weights: '{"40089": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 34.38938,
    longitude: -94.91671,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74722',
  },
  {
    city: 'Bennington',
    county_fips: 40013,
    county_fips_all: '40013',
    county: 'Bryan',
    county_names_all: 'Bryan',
    county_weights: '{"40013": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 33.98958,
    longitude: -96.0233,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74723',
  },
  {
    city: 'Bethel',
    county_fips: 40089,
    county_fips_all: '40089',
    county: 'McCurtain',
    county_names_all: 'McCurtain',
    county_weights: '{"40089": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 34.33926,
    longitude: -94.85833,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74724',
  },
  {
    city: 'Bokchito',
    county_fips: 40013,
    county_fips_all: '40013',
    county: 'Bryan',
    county_names_all: 'Bryan',
    county_weights: '{"40013": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 33.94966,
    longitude: -96.18135,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74726',
  },
  {
    city: 'Boswell',
    county_fips: 40023,
    county_fips_all: '40023|40013|40005',
    county: 'Choctaw',
    county_names_all: 'Choctaw|Bryan|Atoka',
    county_weights: '{"40023": 75.53, "40013": 14.38, "40005": 10.09}',
    density: 3.8,
    imprecise: false,
    latitude: 34.01907,
    longitude: -95.86018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74727',
  },
  {
    city: 'Broken Bow',
    county_fips: 40089,
    county_fips_all: '40089|40127',
    county: 'McCurtain',
    county_names_all: 'McCurtain|Pushmataha',
    county_weights: '{"40089": 89.39, "40127": 10.61}',
    density: 10.6,
    imprecise: false,
    latitude: 34.15411,
    longitude: -94.81959,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74728',
  },
  {
    city: 'Caddo',
    county_fips: 40013,
    county_fips_all: '40013|40005',
    county: 'Bryan',
    county_names_all: 'Bryan|Atoka',
    county_weights: '{"40013": 64.87, "40005": 35.13}',
    density: 6.7,
    imprecise: false,
    latitude: 34.14674,
    longitude: -96.25289,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74729',
  },
  {
    city: 'Calera',
    county_fips: 40013,
    county_fips_all: '40013',
    county: 'Bryan',
    county_names_all: 'Bryan',
    county_weights: '{"40013": 100}',
    density: 35.2,
    imprecise: false,
    latitude: 33.90466,
    longitude: -96.43361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74730',
  },
  {
    city: 'Cartwright',
    county_fips: 40013,
    county_fips_all: '40013',
    county: 'Bryan',
    county_names_all: 'Bryan',
    county_weights: '{"40013": 100}',
    density: 48.9,
    imprecise: false,
    latitude: 33.8753,
    longitude: -96.57313,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74731',
  },
  {
    city: 'Colbert',
    county_fips: 40013,
    county_fips_all: '40013',
    county: 'Bryan',
    county_names_all: 'Bryan',
    county_weights: '{"40013": 100}',
    density: 22.7,
    imprecise: false,
    latitude: 33.83053,
    longitude: -96.47546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74733',
  },
  {
    city: 'Eagletown',
    county_fips: 40089,
    county_fips_all: '40089',
    county: 'McCurtain',
    county_names_all: 'McCurtain',
    county_weights: '{"40089": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 34.0888,
    longitude: -94.54786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74734',
  },
  {
    city: 'Fort Towson',
    county_fips: 40023,
    county_fips_all: '40023|40127',
    county: 'Choctaw',
    county_names_all: 'Choctaw|Pushmataha',
    county_weights: '{"40023": 66.38, "40127": 33.62}',
    density: 3.8,
    imprecise: false,
    latitude: 34.10142,
    longitude: -95.25595,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74735',
  },
  {
    city: 'Garvin',
    county_fips: 40089,
    county_fips_all: '40089',
    county: 'McCurtain',
    county_names_all: 'McCurtain',
    county_weights: '{"40089": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 33.92436,
    longitude: -94.98772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74736',
  },
  {
    city: 'Golden',
    county_fips: 40089,
    county_fips_all: '40089',
    county: 'McCurtain',
    county_names_all: 'McCurtain',
    county_weights: '{"40089": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 34.0311,
    longitude: -94.8995,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74737',
  },
  {
    city: 'Grant',
    county_fips: 40023,
    county_fips_all: '40023',
    county: 'Choctaw',
    county_names_all: 'Choctaw',
    county_weights: '{"40023": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 33.90131,
    longitude: -95.444,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74738',
  },
  {
    city: 'Haworth',
    county_fips: 40089,
    county_fips_all: '40089',
    county: 'McCurtain',
    county_names_all: 'McCurtain',
    county_weights: '{"40089": 100}',
    density: 3,
    imprecise: false,
    latitude: 33.7938,
    longitude: -94.59614,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74740',
  },
  {
    city: 'Hendrix',
    county_fips: 40013,
    county_fips_all: '40013',
    county: 'Bryan',
    county_names_all: 'Bryan',
    county_weights: '{"40013": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 33.79571,
    longitude: -96.29281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74741',
  },
  {
    city: 'Hugo',
    county_fips: 40023,
    county_fips_all: '40023',
    county: 'Choctaw',
    county_names_all: 'Choctaw',
    county_weights: '{"40023": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 34.00647,
    longitude: -95.5107,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74743',
  },
  {
    city: 'Idabel',
    county_fips: 40089,
    county_fips_all: '40089',
    county: 'McCurtain',
    county_names_all: 'McCurtain',
    county_weights: '{"40089": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 33.86017,
    longitude: -94.81319,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74745',
  },
  {
    city: 'Kemp',
    county_fips: 40013,
    county_fips_all: '40013',
    county: 'Bryan',
    county_names_all: 'Bryan',
    county_weights: '{"40013": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 33.75491,
    longitude: -96.31612,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74747',
  },
  {
    city: 'Kenefic',
    county_fips: 40069,
    county_fips_all: '40069|40005|40013',
    county: 'Johnston',
    county_names_all: 'Johnston|Atoka|Bryan',
    county_weights: '{"40069": 46.15, "40005": 35.35, "40013": 18.49}',
    density: 4.7,
    imprecise: false,
    latitude: 34.16082,
    longitude: -96.44879,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74748',
  },
  {
    city: 'Millerton',
    county_fips: 40089,
    county_fips_all: '40089',
    county: 'McCurtain',
    county_names_all: 'McCurtain',
    county_weights: '{"40089": 100}',
    density: 86.4,
    imprecise: false,
    latitude: 33.98514,
    longitude: -95.01175,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74750',
  },
  {
    city: 'Platter',
    county_fips: 40013,
    county_fips_all: '40013',
    county: 'Bryan',
    county_names_all: 'Bryan',
    county_weights: '{"40013": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.90777,
    longitude: -96.53496,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74753',
  },
  {
    city: 'Ringold',
    county_fips: 40089,
    county_fips_all: '40089|40127|40023',
    county: 'McCurtain',
    county_names_all: 'McCurtain|Pushmataha|Choctaw',
    county_weights: '{"40089": 64.7, "40127": 32.59, "40023": 2.71}',
    density: 4,
    imprecise: false,
    latitude: 34.19367,
    longitude: -95.12231,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74754',
  },
  {
    city: 'Rufe',
    county_fips: 40089,
    county_fips_all: '40089|40023',
    county: 'McCurtain',
    county_names_all: 'McCurtain|Choctaw',
    county_weights: '{"40089": 65.63, "40023": 34.37}',
    density: 6.6,
    imprecise: false,
    latitude: 34.11799,
    longitude: -95.14196,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74755',
  },
  {
    city: 'Sawyer',
    county_fips: 40023,
    county_fips_all: '40023',
    county: 'Choctaw',
    county_names_all: 'Choctaw',
    county_weights: '{"40023": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 34.07049,
    longitude: -95.37367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74756',
  },
  {
    city: 'Soper',
    county_fips: 40023,
    county_fips_all: '40023',
    county: 'Choctaw',
    county_names_all: 'Choctaw',
    county_weights: '{"40023": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 34.06088,
    longitude: -95.71278,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74759',
  },
  {
    city: 'Spencerville',
    county_fips: 40127,
    county_fips_all: '40127|40023',
    county: 'Pushmataha',
    county_names_all: 'Pushmataha|Choctaw',
    county_weights: '{"40127": 55.03, "40023": 44.97}',
    density: 3.8,
    imprecise: false,
    latitude: 34.15996,
    longitude: -95.3612,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74760',
  },
  {
    city: 'Swink',
    county_fips: 40023,
    county_fips_all: '40023',
    county: 'Choctaw',
    county_names_all: 'Choctaw',
    county_weights: '{"40023": 100}',
    density: 19.1,
    imprecise: false,
    latitude: 34.00938,
    longitude: -95.20134,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74761',
  },
  {
    city: 'Valliant',
    county_fips: 40089,
    county_fips_all: '40089|40023',
    county: 'McCurtain',
    county_names_all: 'McCurtain|Choctaw',
    county_weights: '{"40089": 93.11, "40023": 6.89}',
    density: 7.5,
    imprecise: false,
    latitude: 34.09405,
    longitude: -95.05512,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74764',
  },
  {
    city: 'Wright City',
    county_fips: 40089,
    county_fips_all: '40089',
    county: 'McCurtain',
    county_names_all: 'McCurtain',
    county_weights: '{"40089": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 34.08597,
    longitude: -94.97271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74766',
  },
  {
    city: 'Shawnee',
    county_fips: 40125,
    county_fips_all: '40125',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie',
    county_weights: '{"40125": 100}',
    density: 114.5,
    imprecise: false,
    latitude: 35.31749,
    longitude: -96.96824,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74801',
  },
  {
    city: 'Shawnee',
    county_fips: 40125,
    county_fips_all: '40125',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie',
    county_weights: '{"40125": 100}',
    density: 89.5,
    imprecise: false,
    latitude: 35.39358,
    longitude: -96.92399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74804',
  },
  {
    city: 'Ada',
    county_fips: 40123,
    county_fips_all: '40123|40125',
    county: 'Pontotoc',
    county_names_all: 'Pontotoc|Pottawatomie',
    county_weights: '{"40123": 99.8, "40125": 0.2}',
    density: 43.2,
    imprecise: false,
    latitude: 34.80691,
    longitude: -96.71348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74820',
  },
  {
    city: 'Agra',
    county_fips: 40081,
    county_fips_all: '40081|40119',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Payne',
    county_weights: '{"40081": 91.63, "40119": 8.37}',
    density: 14.1,
    imprecise: false,
    latitude: 35.8873,
    longitude: -96.87358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74824',
  },
  {
    city: 'Allen',
    county_fips: 40123,
    county_fips_all: '40123|40063|40029',
    county: 'Pontotoc',
    county_names_all: 'Pontotoc|Hughes|Coal',
    county_weights: '{"40123": 47.93, "40063": 33.1, "40029": 18.97}',
    density: 4.5,
    imprecise: false,
    latitude: 34.80591,
    longitude: -96.4028,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74825',
  },
  {
    city: 'Asher',
    county_fips: 40125,
    county_fips_all: '40125',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie',
    county_weights: '{"40125": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 35.01735,
    longitude: -96.90606,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74826',
  },
  {
    city: 'Atwood',
    county_fips: 40063,
    county_fips_all: '40063',
    county: 'Hughes',
    county_names_all: 'Hughes',
    county_weights: '{"40063": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 34.94101,
    longitude: -96.34208,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74827',
  },
  {
    city: 'Boley',
    county_fips: 40107,
    county_fips_all: '40107',
    county: 'Okfuskee',
    county_names_all: 'Okfuskee',
    county_weights: '{"40107": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 35.51332,
    longitude: -96.47392,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74829',
  },
  {
    city: 'Bowlegs',
    county_fips: 40133,
    county_fips_all: '40133',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"40133": 100}',
    density: 49.7,
    imprecise: false,
    latitude: 35.14452,
    longitude: -96.66464,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74830',
  },
  {
    city: 'Byars',
    county_fips: 40087,
    county_fips_all: '40087|40123|40049',
    county: 'McClain',
    county_names_all: 'McClain|Pontotoc|Garvin',
    county_weights: '{"40087": 86.85, "40123": 7.45, "40049": 5.7}',
    density: 4.1,
    imprecise: false,
    latitude: 34.89841,
    longitude: -97.04298,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74831',
  },
  {
    city: 'Carney',
    county_fips: 40081,
    county_fips_all: '40081',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"40081": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 35.82534,
    longitude: -97.01077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74832',
  },
  {
    city: 'Castle',
    county_fips: 40107,
    county_fips_all: '40107',
    county: 'Okfuskee',
    county_names_all: 'Okfuskee',
    county_weights: '{"40107": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 35.58262,
    longitude: -96.41193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74833',
  },
  {
    city: 'Chandler',
    county_fips: 40081,
    county_fips_all: '40081',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"40081": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 35.6961,
    longitude: -96.87902,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74834',
  },
  {
    city: 'Connerville',
    county_fips: 40069,
    county_fips_all: '40069',
    county: 'Johnston',
    county_names_all: 'Johnston',
    county_weights: '{"40069": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 34.44436,
    longitude: -96.62581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74836',
  },
  {
    city: 'Cromwell',
    county_fips: 40133,
    county_fips_all: '40133',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"40133": 100}',
    density: 182.5,
    imprecise: false,
    latitude: 35.34321,
    longitude: -96.4561,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74837',
  },
  {
    city: 'Dustin',
    county_fips: 40063,
    county_fips_all: '40063|40107|40091',
    county: 'Hughes',
    county_names_all: 'Hughes|Okfuskee|McIntosh',
    county_weights: '{"40063": 66.52, "40107": 18.64, "40091": 14.84}',
    density: 2.4,
    imprecise: false,
    latitude: 35.2413,
    longitude: -96.04642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74839',
  },
  {
    city: 'Earlsboro',
    county_fips: 40133,
    county_fips_all: '40133|40125',
    county: 'Seminole',
    county_names_all: 'Seminole|Pottawatomie',
    county_weights: '{"40133": 58.62, "40125": 41.38}',
    density: 11.6,
    imprecise: false,
    latitude: 35.30488,
    longitude: -96.7665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74840',
  },
  {
    city: 'Fittstown',
    county_fips: 40123,
    county_fips_all: '40123',
    county: 'Pontotoc',
    county_names_all: 'Pontotoc',
    county_weights: '{"40123": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 34.6166,
    longitude: -96.61456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74842',
  },
  {
    city: 'Fitzhugh',
    county_fips: 40123,
    county_fips_all: '40123',
    county: 'Pontotoc',
    county_names_all: 'Pontotoc',
    county_weights: '{"40123": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 34.65763,
    longitude: -96.7125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74843',
  },
  {
    city: 'Francis',
    county_fips: 40123,
    county_fips_all: '40123',
    county: 'Pontotoc',
    county_names_all: 'Pontotoc',
    county_weights: '{"40123": 100}',
    density: 142,
    imprecise: false,
    latitude: 34.87421,
    longitude: -96.58869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74844',
  },
  {
    city: 'Hanna',
    county_fips: 40091,
    county_fips_all: '40091',
    county: 'McIntosh',
    county_names_all: 'McIntosh',
    county_weights: '{"40091": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 35.25856,
    longitude: -95.88302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74845',
  },
  {
    city: 'Holdenville',
    county_fips: 40063,
    county_fips_all: '40063|40133',
    county: 'Hughes',
    county_names_all: 'Hughes|Seminole',
    county_weights: '{"40063": 97.48, "40133": 2.52}',
    density: 12,
    imprecise: false,
    latitude: 35.08197,
    longitude: -96.34804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74848',
  },
  {
    city: 'Konawa',
    county_fips: 40133,
    county_fips_all: '40133|40125',
    county: 'Seminole',
    county_names_all: 'Seminole|Pottawatomie',
    county_weights: '{"40133": 71.72, "40125": 28.28}',
    density: 8.3,
    imprecise: false,
    latitude: 34.9846,
    longitude: -96.73597,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74849',
  },
  {
    city: 'Lamar',
    county_fips: 40063,
    county_fips_all: '40063',
    county: 'Hughes',
    county_names_all: 'Hughes',
    county_weights: '{"40063": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 35.11169,
    longitude: -96.09045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74850',
  },
  {
    city: 'Mcloud',
    county_fips: 40125,
    county_fips_all: '40125|40081|40027',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie|Lincoln|Cleveland',
    county_weights: '{"40125": 58.4, "40081": 34.15, "40027": 7.45}',
    density: 52.8,
    imprecise: false,
    latitude: 35.42653,
    longitude: -97.08072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74851',
  },
  {
    city: 'Macomb',
    county_fips: 40125,
    county_fips_all: '40125|40027',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie|Cleveland',
    county_weights: '{"40125": 98.16, "40027": 1.84}',
    density: 7.8,
    imprecise: false,
    latitude: 35.12844,
    longitude: -97.01301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74852',
  },
  {
    city: 'Maud',
    county_fips: 40133,
    county_fips_all: '40133|40125',
    county: 'Seminole',
    county_names_all: 'Seminole|Pottawatomie',
    county_weights: '{"40133": 50.17, "40125": 49.83}',
    density: 9.3,
    imprecise: false,
    latitude: 35.11527,
    longitude: -96.762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74854',
  },
  {
    city: 'Meeker',
    county_fips: 40081,
    county_fips_all: '40081|40125',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Pottawatomie',
    county_weights: '{"40081": 90.42, "40125": 9.58}',
    density: 15.6,
    imprecise: false,
    latitude: 35.51911,
    longitude: -96.90376,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74855',
  },
  {
    city: 'Mill Creek',
    county_fips: 40069,
    county_fips_all: '40069|40099',
    county: 'Johnston',
    county_names_all: 'Johnston|Murray',
    county_weights: '{"40069": 83.58, "40099": 16.42}',
    density: 1.7,
    imprecise: false,
    latitude: 34.39853,
    longitude: -96.81829,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74856',
  },
  {
    city: 'Newalla',
    county_fips: 40027,
    county_fips_all: '40027|40109|40125',
    county: 'Cleveland',
    county_names_all: 'Cleveland|Oklahoma|Pottawatomie',
    county_weights: '{"40027": 70.07, "40109": 26.31, "40125": 3.62}',
    density: 65.8,
    imprecise: false,
    latitude: 35.34132,
    longitude: -97.19576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74857',
  },
  {
    city: 'Okemah',
    county_fips: 40107,
    county_fips_all: '40107|40133',
    county: 'Okfuskee',
    county_names_all: 'Okfuskee|Seminole',
    county_weights: '{"40107": 88.81, "40133": 11.19}',
    density: 7.2,
    imprecise: false,
    latitude: 35.46237,
    longitude: -96.31792,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74859',
  },
  {
    city: 'Paden',
    county_fips: 40107,
    county_fips_all: '40107',
    county: 'Okfuskee',
    county_names_all: 'Okfuskee',
    county_weights: '{"40107": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 35.52788,
    longitude: -96.56913,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74860',
  },
  {
    city: 'Prague',
    county_fips: 40081,
    county_fips_all: '40081|40125|40107',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Pottawatomie|Okfuskee',
    county_weights: '{"40081": 62.34, "40125": 36.03, "40107": 1.63}',
    density: 15.9,
    imprecise: false,
    latitude: 35.4921,
    longitude: -96.70269,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74864',
  },
  {
    city: 'Roff',
    county_fips: 40123,
    county_fips_all: '40123|40099|40049',
    county: 'Pontotoc',
    county_names_all: 'Pontotoc|Murray|Garvin',
    county_weights: '{"40123": 88.32, "40099": 9.13, "40049": 2.55}',
    density: 4.6,
    imprecise: false,
    latitude: 34.60599,
    longitude: -96.80922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74865',
  },
  {
    city: 'Saint Louis',
    county_fips: 40125,
    county_fips_all: '40125',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie',
    county_weights: '{"40125": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 35.06647,
    longitude: -96.84691,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74866',
  },
  {
    city: 'Sasakwa',
    county_fips: 40133,
    county_fips_all: '40133|40063',
    county: 'Seminole',
    county_names_all: 'Seminole|Hughes',
    county_weights: '{"40133": 87.73, "40063": 12.27}',
    density: 2.5,
    imprecise: false,
    latitude: 34.96335,
    longitude: -96.54663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74867',
  },
  {
    city: 'Seminole',
    county_fips: 40133,
    county_fips_all: '40133',
    county: 'Seminole',
    county_names_all: 'Seminole',
    county_weights: '{"40133": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 35.26699,
    longitude: -96.64193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74868',
  },
  {
    city: 'Sparks',
    county_fips: 40081,
    county_fips_all: '40081',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"40081": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 35.59117,
    longitude: -96.75763,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74869',
  },
  {
    city: 'Stonewall',
    county_fips: 40123,
    county_fips_all: '40123|40029|40069',
    county: 'Pontotoc',
    county_names_all: 'Pontotoc|Coal|Johnston',
    county_weights: '{"40123": 67.93, "40029": 17.67, "40069": 14.4}',
    density: 5,
    imprecise: false,
    latitude: 34.59942,
    longitude: -96.5528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74871',
  },
  {
    city: 'Stratford',
    county_fips: 40049,
    county_fips_all: '40049|40123|40087',
    county: 'Garvin',
    county_names_all: 'Garvin|Pontotoc|McClain',
    county_weights: '{"40049": 73.64, "40123": 23.71, "40087": 2.65}',
    density: 7.6,
    imprecise: false,
    latitude: 34.77989,
    longitude: -96.97913,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74872',
  },
  {
    city: 'Tecumseh',
    county_fips: 40125,
    county_fips_all: '40125',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie',
    county_weights: '{"40125": 100}',
    density: 30.8,
    imprecise: false,
    latitude: 35.22396,
    longitude: -96.97975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74873',
  },
  {
    city: 'Tryon',
    county_fips: 40081,
    county_fips_all: '40081',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"40081": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 35.8751,
    longitude: -96.95877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74875',
  },
  {
    city: 'Wanette',
    county_fips: 40125,
    county_fips_all: '40125|40027',
    county: 'Pottawatomie',
    county_names_all: 'Pottawatomie|Cleveland',
    county_weights: '{"40125": 93.85, "40027": 6.15}',
    density: 6,
    imprecise: false,
    latitude: 35.00768,
    longitude: -97.06999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74878',
  },
  {
    city: 'Weleetka',
    county_fips: 40107,
    county_fips_all: '40107|40111',
    county: 'Okfuskee',
    county_names_all: 'Okfuskee|Okmulgee',
    county_weights: '{"40107": 91.48, "40111": 8.52}',
    density: 6.8,
    imprecise: false,
    latitude: 35.38039,
    longitude: -96.1212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74880',
  },
  {
    city: 'Wellston',
    county_fips: 40081,
    county_fips_all: '40081|40083',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Logan',
    county_weights: '{"40081": 87.56, "40083": 12.44}',
    density: 12.6,
    imprecise: false,
    latitude: 35.72136,
    longitude: -97.08264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74881',
  },
  {
    city: 'Wetumka',
    county_fips: 40063,
    county_fips_all: '40063|40107',
    county: 'Hughes',
    county_names_all: 'Hughes|Okfuskee',
    county_weights: '{"40063": 83.61, "40107": 16.39}',
    density: 5.4,
    imprecise: false,
    latitude: 35.22766,
    longitude: -96.24346,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74883',
  },
  {
    city: 'Wewoka',
    county_fips: 40133,
    county_fips_all: '40133|40063',
    county: 'Seminole',
    county_names_all: 'Seminole|Hughes',
    county_weights: '{"40133": 98.16, "40063": 1.84}',
    density: 16,
    imprecise: false,
    latitude: 35.18635,
    longitude: -96.51882,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74884',
  },
  {
    city: 'Arkoma',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 38.9,
    imprecise: false,
    latitude: 35.32798,
    longitude: -94.47166,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74901',
  },
  {
    city: 'Pocola',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 56.6,
    imprecise: false,
    latitude: 35.24568,
    longitude: -94.47715,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74902',
  },
  {
    city: 'Bokoshe',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 10,
    imprecise: false,
    latitude: 35.18409,
    longitude: -94.77573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74930',
  },
  {
    city: 'Bunch',
    county_fips: 40001,
    county_fips_all: '40001|40021|40135',
    county: 'Adair',
    county_names_all: 'Adair|Cherokee|Sequoyah',
    county_weights: '{"40001": 67.68, "40021": 25.2, "40135": 7.12}',
    density: 4.3,
    imprecise: false,
    latitude: 35.69226,
    longitude: -94.76459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74931',
  },
  {
    city: 'Cameron',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 35.14701,
    longitude: -94.53501,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74932',
  },
  {
    city: 'Fanshawe',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 34.95433,
    longitude: -94.89687,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74935',
  },
  {
    city: 'Gans',
    county_fips: 40135,
    county_fips_all: '40135',
    county: 'Sequoyah',
    county_names_all: 'Sequoyah',
    county_weights: '{"40135": 100}',
    density: 20.3,
    imprecise: false,
    latitude: 35.39042,
    longitude: -94.72772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74936',
  },
  {
    city: 'Heavener',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 10,
    imprecise: false,
    latitude: 34.83303,
    longitude: -94.58321,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74937',
  },
  {
    city: 'Hodgen',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 4,
    imprecise: false,
    latitude: 34.70875,
    longitude: -94.63843,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74939',
  },
  {
    city: 'Howe',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 34.94979,
    longitude: -94.63167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74940',
  },
  {
    city: 'Keota',
    county_fips: 40061,
    county_fips_all: '40061|40079',
    county: 'Haskell',
    county_names_all: 'Haskell|Le Flore',
    county_weights: '{"40061": 75.42, "40079": 24.58}',
    density: 8.3,
    imprecise: false,
    latitude: 35.26453,
    longitude: -94.87854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74941',
  },
  {
    city: 'Leflore',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 40.7,
    imprecise: false,
    latitude: 34.89799,
    longitude: -94.97661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74942',
  },
  {
    city: 'Lequire',
    county_fips: 40061,
    county_fips_all: '40061',
    county: 'Haskell',
    county_names_all: 'Haskell',
    county_weights: '{"40061": 100}',
    density: 35.8,
    imprecise: false,
    latitude: 35.1007,
    longitude: -95.106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74943',
  },
  {
    city: 'Mccurtain',
    county_fips: 40061,
    county_fips_all: '40061|40079',
    county: 'Haskell',
    county_names_all: 'Haskell|Le Flore',
    county_weights: '{"40061": 82.13, "40079": 17.87}',
    density: 3.6,
    imprecise: false,
    latitude: 35.12421,
    longitude: -95.00779,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74944',
  },
  {
    city: 'Marble City',
    county_fips: 40135,
    county_fips_all: '40135',
    county: 'Sequoyah',
    county_names_all: 'Sequoyah',
    county_weights: '{"40135": 100}',
    density: 156.8,
    imprecise: false,
    latitude: 35.58232,
    longitude: -94.81864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74945',
  },
  {
    city: 'Moffett',
    county_fips: 40135,
    county_fips_all: '40135',
    county: 'Sequoyah',
    county_names_all: 'Sequoyah',
    county_weights: '{"40135": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 35.39613,
    longitude: -94.45093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74946',
  },
  {
    city: 'Monroe',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 82.4,
    imprecise: false,
    latitude: 34.99149,
    longitude: -94.51589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74947',
  },
  {
    city: 'Muldrow',
    county_fips: 40135,
    county_fips_all: '40135|40001',
    county: 'Sequoyah',
    county_names_all: 'Sequoyah|Adair',
    county_weights: '{"40135": 97.69, "40001": 2.31}',
    density: 22,
    imprecise: false,
    latitude: 35.46207,
    longitude: -94.56284,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74948',
  },
  {
    city: 'Muse',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 34.68324,
    longitude: -94.7739,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74949',
  },
  {
    city: 'Panama',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 129.9,
    imprecise: false,
    latitude: 35.17099,
    longitude: -94.66482,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74951',
  },
  {
    city: 'Poteau',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 40.2,
    imprecise: false,
    latitude: 35.03931,
    longitude: -94.57156,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74953',
  },
  {
    city: 'Roland',
    county_fips: 40135,
    county_fips_all: '40135',
    county: 'Sequoyah',
    county_names_all: 'Sequoyah',
    county_weights: '{"40135": 100}',
    density: 94.6,
    imprecise: false,
    latitude: 35.41596,
    longitude: -94.49043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74954',
  },
  {
    city: 'Sallisaw',
    county_fips: 40135,
    county_fips_all: '40135',
    county: 'Sequoyah',
    county_names_all: 'Sequoyah',
    county_weights: '{"40135": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 35.50213,
    longitude: -94.75547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74955',
  },
  {
    city: 'Shady Point',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 35.09487,
    longitude: -94.77334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74956',
  },
  {
    city: 'Smithville',
    county_fips: 40079,
    county_fips_all: '40079|40089',
    county: 'Le Flore',
    county_names_all: 'Le Flore|McCurtain',
    county_weights: '{"40079": 68.04, "40089": 31.96}',
    density: 1.4,
    imprecise: false,
    latitude: 34.52522,
    longitude: -94.65558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74957',
  },
  {
    city: 'Spiro',
    county_fips: 40079,
    county_fips_all: '40079',
    county: 'Le Flore',
    county_names_all: 'Le Flore',
    county_weights: '{"40079": 100}',
    density: 26.6,
    imprecise: false,
    latitude: 35.26288,
    longitude: -94.63326,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74959',
  },
  {
    city: 'Stilwell',
    county_fips: 40001,
    county_fips_all: '40001|40021',
    county: 'Adair',
    county_names_all: 'Adair|Cherokee',
    county_weights: '{"40001": 95.71, "40021": 4.29}',
    density: 15.4,
    imprecise: false,
    latitude: 35.80995,
    longitude: -94.65027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74960',
  },
  {
    city: 'Vian',
    county_fips: 40135,
    county_fips_all: '40135|40021',
    county: 'Sequoyah',
    county_names_all: 'Sequoyah|Cherokee',
    county_weights: '{"40135": 97.36, "40021": 2.64}',
    density: 11,
    imprecise: false,
    latitude: 35.53703,
    longitude: -94.94717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74962',
  },
  {
    city: 'Watson',
    county_fips: 40089,
    county_fips_all: '40089',
    county: 'McCurtain',
    county_names_all: 'McCurtain',
    county_weights: '{"40089": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 34.41424,
    longitude: -94.56322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74963',
  },
  {
    city: 'Watts',
    county_fips: 40001,
    county_fips_all: '40001|40041|40021',
    county: 'Adair',
    county_names_all: 'Adair|Delaware|Cherokee',
    county_weights: '{"40001": 93.36, "40041": 5.7, "40021": 0.94}',
    density: 10.9,
    imprecise: false,
    latitude: 36.11493,
    longitude: -94.6665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74964',
  },
  {
    city: 'Westville',
    county_fips: 40001,
    county_fips_all: '40001',
    county: 'Adair',
    county_names_all: 'Adair',
    county_weights: '{"40001": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 35.99605,
    longitude: -94.62553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74965',
  },
  {
    city: 'Wister',
    county_fips: 40079,
    county_fips_all: '40079|40077',
    county: 'Le Flore',
    county_names_all: 'Le Flore|Latimer',
    county_weights: '{"40079": 92.89, "40077": 7.11}',
    density: 5,
    imprecise: false,
    latitude: 34.89556,
    longitude: -94.86894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74966',
  },
  {
    city: 'Addison',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1736,
    imprecise: false,
    latitude: 32.96015,
    longitude: -96.83808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16872,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75001',
  },
  {
    city: 'Allen',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 771.1,
    imprecise: false,
    latitude: 33.08946,
    longitude: -96.60639,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 75057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75002',
  },
  {
    city: 'Carrollton',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1081.2,
    imprecise: false,
    latitude: 32.96165,
    longitude: -96.89717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75006',
  },
  {
    city: 'Carrollton',
    county_fips: 48121,
    county_fips_all: '48121|48113|48085',
    county: 'Denton',
    county_names_all: 'Denton|Dallas|Collin',
    county_weights: '{"48121": 90.42, "48113": 8.52, "48085": 1.06}',
    density: 1772.1,
    imprecise: false,
    latitude: 33.00498,
    longitude: -96.8959,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75007',
  },
  {
    city: 'Celina',
    county_fips: 48085,
    county_fips_all: '48085|48121',
    county: 'Collin',
    county_names_all: 'Collin|Denton',
    county_weights: '{"48085": 93.14, "48121": 6.86}',
    density: 134,
    imprecise: false,
    latitude: 33.3384,
    longitude: -96.75185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75009',
  },
  {
    city: 'Carrollton',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 1888.8,
    imprecise: false,
    latitude: 33.03058,
    longitude: -96.90148,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75010',
  },
  {
    city: 'Allen',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 1278.1,
    imprecise: false,
    latitude: 33.11463,
    longitude: -96.69413,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75013',
  },
  {
    city: 'Coppell',
    county_fips: 48113,
    county_fips_all: '48113|48121',
    county: 'Dallas',
    county_names_all: 'Dallas|Denton',
    county_weights: '{"48113": 98.16, "48121": 1.84}',
    density: 1009.1,
    imprecise: false,
    latitude: 32.96183,
    longitude: -96.984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75019',
  },
  {
    city: 'Denison',
    county_fips: 48181,
    county_fips_all: '48181',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"48181": 100}',
    density: 157.1,
    imprecise: false,
    latitude: 33.77264,
    longitude: -96.60391,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75020',
  },
  {
    city: 'Denison',
    county_fips: 48181,
    county_fips_all: '48181',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"48181": 100}',
    density: 60.6,
    imprecise: false,
    latitude: 33.72686,
    longitude: -96.47552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75021',
  },
  {
    city: 'Flower Mound',
    county_fips: 48121,
    county_fips_all: '48121|48439',
    county: 'Denton',
    county_names_all: 'Denton|Tarrant',
    county_weights: '{"48121": 92.59, "48439": 7.41}',
    density: 515.4,
    imprecise: false,
    latitude: 33.02554,
    longitude: -97.11871,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75022',
  },
  {
    city: 'Plano',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 2066.3,
    imprecise: false,
    latitude: 33.05657,
    longitude: -96.73286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75023',
  },
  {
    city: 'Plano',
    county_fips: 48085,
    county_fips_all: '48085|48121',
    county: 'Collin',
    county_names_all: 'Collin|Denton',
    county_weights: '{"48085": 87.52, "48121": 12.48}',
    density: 1360.8,
    imprecise: false,
    latitude: 33.07712,
    longitude: -96.80826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75024',
  },
  {
    city: 'Plano',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 2150.1,
    imprecise: false,
    latitude: 33.09057,
    longitude: -96.74061,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75025',
  },
  {
    city: 'Flower Mound',
    county_fips: 48121,
    county_fips_all: '48121|48439',
    county: 'Denton',
    county_names_all: 'Denton|Tarrant',
    county_weights: '{"48121": 97.8, "48439": 2.2}',
    density: 1218.3,
    imprecise: false,
    latitude: 33.03382,
    longitude: -97.0629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75028',
  },
  {
    city: 'Rockwall',
    county_fips: 48397,
    county_fips_all: '48397',
    county: 'Rockwall',
    county_names_all: 'Rockwall',
    county_weights: '{"48397": 100}',
    density: 319.8,
    imprecise: false,
    latitude: 32.85756,
    longitude: -96.42858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75032',
  },
  {
    city: 'Frisco',
    county_fips: 48121,
    county_fips_all: '48121|48085',
    county: 'Denton',
    county_names_all: 'Denton|Collin',
    county_weights: '{"48121": 54.57, "48085": 45.43}',
    density: 929.8,
    imprecise: false,
    latitude: 33.18471,
    longitude: -96.84404,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75033',
  },
  {
    city: 'Frisco',
    county_fips: 48085,
    county_fips_all: '48085|48121',
    county: 'Collin',
    county_names_all: 'Collin|Denton',
    county_weights: '{"48085": 55.89, "48121": 44.11}',
    density: 1303.3,
    imprecise: false,
    latitude: 33.12084,
    longitude: -96.83778,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75034',
  },
  {
    city: 'Frisco',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 1390.5,
    imprecise: false,
    latitude: 33.15814,
    longitude: -96.7734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 89682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75035',
  },
  {
    city: 'Frisco',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 1193.2,
    imprecise: false,
    latitude: 33.13339,
    longitude: -96.91453,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75036',
  },
  {
    city: 'Irving',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1655.7,
    imprecise: false,
    latitude: 32.87231,
    longitude: -96.97946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75038',
  },
  {
    city: 'Irving',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1641.4,
    imprecise: false,
    latitude: 32.88592,
    longitude: -96.94042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75039',
  },
  {
    city: 'Garland',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1589.1,
    imprecise: false,
    latitude: 32.92797,
    longitude: -96.62006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75040',
  },
  {
    city: 'Garland',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1605.2,
    imprecise: false,
    latitude: 32.88101,
    longitude: -96.65149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75041',
  },
  {
    city: 'Garland',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1928,
    imprecise: false,
    latitude: 32.91401,
    longitude: -96.67466,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75042',
  },
  {
    city: 'Garland',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1662.5,
    imprecise: false,
    latitude: 32.8571,
    longitude: -96.57986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75043',
  },
  {
    city: 'Garland',
    county_fips: 48113,
    county_fips_all: '48113|48085',
    county: 'Dallas',
    county_names_all: 'Dallas|Collin',
    county_weights: '{"48113": 99.62, "48085": 0.38}',
    density: 1738.4,
    imprecise: false,
    latitude: 32.96299,
    longitude: -96.6531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75044',
  },
  {
    city: 'Sachse',
    county_fips: 48113,
    county_fips_all: '48113|48085',
    county: 'Dallas',
    county_names_all: 'Dallas|Collin',
    county_weights: '{"48113": 80.79, "48085": 19.21}',
    density: 1229.7,
    imprecise: false,
    latitude: 32.9704,
    longitude: -96.58139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75048',
  },
  {
    city: 'Grand Prairie',
    county_fips: 48113,
    county_fips_all: '48113|48439',
    county: 'Dallas',
    county_names_all: 'Dallas|Tarrant',
    county_weights: '{"48113": 78.86, "48439": 21.14}',
    density: 671.1,
    imprecise: false,
    latitude: 32.77428,
    longitude: -97.0037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75050',
  },
  {
    city: 'Grand Prairie',
    county_fips: 48113,
    county_fips_all: '48113|48439',
    county: 'Dallas',
    county_names_all: 'Dallas|Tarrant',
    county_weights: '{"48113": 89.34, "48439": 10.66}',
    density: 1250.3,
    imprecise: false,
    latitude: 32.72635,
    longitude: -96.99375,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75051',
  },
  {
    city: 'Grand Prairie',
    county_fips: 48113,
    county_fips_all: '48113|48439',
    county: 'Dallas',
    county_names_all: 'Dallas|Tarrant',
    county_weights: '{"48113": 57.89, "48439": 42.11}',
    density: 1420.3,
    imprecise: false,
    latitude: 32.66455,
    longitude: -97.02809,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 97278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75052',
  },
  {
    city: 'Grand Prairie',
    county_fips: 48113,
    county_fips_all: '48113|48439',
    county: 'Dallas',
    county_names_all: 'Dallas|Tarrant',
    county_weights: '{"48113": 53.41, "48439": 46.59}',
    density: 1199.9,
    imprecise: false,
    latitude: 32.60036,
    longitude: -97.03409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75054',
  },
  {
    city: 'The Colony',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 1137.7,
    imprecise: false,
    latitude: 33.07541,
    longitude: -96.90978,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 69628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75056',
  },
  {
    city: 'Lewisville',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 520.3,
    imprecise: false,
    latitude: 33.05012,
    longitude: -96.9772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75057',
  },
  {
    city: 'Gunter',
    county_fips: 48181,
    county_fips_all: '48181',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"48181": 100}',
    density: 26,
    imprecise: false,
    latitude: 33.4473,
    longitude: -96.73546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75058',
  },
  {
    city: 'Irving',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1520.3,
    imprecise: false,
    latitude: 32.79774,
    longitude: -96.95295,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75060',
  },
  {
    city: 'Irving',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1862.4,
    imprecise: false,
    latitude: 32.82607,
    longitude: -96.96563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75061',
  },
  {
    city: 'Irving',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1899.8,
    imprecise: false,
    latitude: 32.847,
    longitude: -96.95813,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75062',
  },
  {
    city: 'Irving',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 875.1,
    imprecise: false,
    latitude: 32.90797,
    longitude: -96.9961,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75063',
  },
  {
    city: 'Lake Dallas',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 637.6,
    imprecise: false,
    latitude: 33.11108,
    longitude: -97.01277,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75065',
  },
  {
    city: 'Lewisville',
    county_fips: 48121,
    county_fips_all: '48121|48113',
    county: 'Denton',
    county_names_all: 'Denton|Dallas',
    county_weights: '{"48121": 96.18, "48113": 3.82}',
    density: 1915.1,
    imprecise: false,
    latitude: 33.01416,
    longitude: -97.00268,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 66913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75067',
  },
  {
    city: 'Little Elm',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 1007.4,
    imprecise: false,
    latitude: 33.17713,
    longitude: -96.95228,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 72710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75068',
  },
  {
    city: 'Mckinney',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 459,
    imprecise: false,
    latitude: 33.16805,
    longitude: -96.59671,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75069',
  },
  {
    city: 'Mckinney',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 2192.8,
    imprecise: false,
    latitude: 33.15587,
    longitude: -96.69742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75070',
  },
  {
    city: 'Mckinney',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 380,
    imprecise: false,
    latitude: 33.24558,
    longitude: -96.62951,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 72964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75071',
  },
  {
    city: 'Mckinney',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 1763.8,
    imprecise: false,
    latitude: 33.1875,
    longitude: -96.70099,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75072',
  },
  {
    city: 'Plano',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 1301.2,
    imprecise: false,
    latitude: 33.03298,
    longitude: -96.67304,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75074',
  },
  {
    city: 'Plano',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 1517.9,
    imprecise: false,
    latitude: 33.02163,
    longitude: -96.74043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75075',
  },
  {
    city: 'Pottsboro',
    county_fips: 48181,
    county_fips_all: '48181',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"48181": 100}',
    density: 61.3,
    imprecise: false,
    latitude: 33.79608,
    longitude: -96.71913,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75076',
  },
  {
    city: 'Lewisville',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 1176.5,
    imprecise: false,
    latitude: 33.07921,
    longitude: -97.06401,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75077',
  },
  {
    city: 'Prosper',
    county_fips: 48085,
    county_fips_all: '48085|48121',
    county: 'Collin',
    county_names_all: 'Collin|Denton',
    county_weights: '{"48085": 70.28, "48121": 29.72}',
    density: 648.3,
    imprecise: false,
    latitude: 33.24526,
    longitude: -96.80791,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75078',
  },
  {
    city: 'Richardson',
    county_fips: 48113,
    county_fips_all: '48113|48085',
    county: 'Dallas',
    county_names_all: 'Dallas|Collin',
    county_weights: '{"48113": 70.89, "48085": 29.11}',
    density: 1794.3,
    imprecise: false,
    latitude: 32.97382,
    longitude: -96.7416,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75080',
  },
  {
    city: 'Richardson',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1565.4,
    imprecise: false,
    latitude: 32.94969,
    longitude: -96.70899,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75081',
  },
  {
    city: 'Richardson',
    county_fips: 48085,
    county_fips_all: '48085|48113',
    county: 'Collin',
    county_names_all: 'Collin|Dallas',
    county_weights: '{"48085": 84.56, "48113": 15.44}',
    density: 1394.8,
    imprecise: false,
    latitude: 32.99208,
    longitude: -96.66536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75082',
  },
  {
    city: 'Rockwall',
    county_fips: 48397,
    county_fips_all: '48397|48085',
    county: 'Rockwall',
    county_names_all: 'Rockwall|Collin',
    county_weights: '{"48397": 94.59, "48085": 5.41}',
    density: 581.2,
    imprecise: false,
    latitude: 32.94581,
    longitude: -96.44136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75087',
  },
  {
    city: 'Rowlett',
    county_fips: 48113,
    county_fips_all: '48113|48397',
    county: 'Dallas',
    county_names_all: 'Dallas|Rockwall',
    county_weights: '{"48113": 72.14, "48397": 27.86}',
    density: 1168.6,
    imprecise: false,
    latitude: 32.89368,
    longitude: -96.53929,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75088',
  },
  {
    city: 'Rowlett',
    county_fips: 48113,
    county_fips_all: '48113|48397',
    county: 'Dallas',
    county_names_all: 'Dallas|Rockwall',
    county_weights: '{"48113": 86.17, "48397": 13.83}',
    density: 1136.4,
    imprecise: false,
    latitude: 32.93195,
    longitude: -96.54435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75089',
  },
  {
    city: 'Sherman',
    county_fips: 48181,
    county_fips_all: '48181',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"48181": 100}',
    density: 130.7,
    imprecise: false,
    latitude: 33.6054,
    longitude: -96.54657,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75090',
  },
  {
    city: 'Sherman',
    county_fips: 48181,
    county_fips_all: '48181',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"48181": 100}',
    density: 96,
    imprecise: false,
    latitude: 33.64869,
    longitude: -96.70011,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75092',
  },
  {
    city: 'Plano',
    county_fips: 48085,
    county_fips_all: '48085|48121',
    county: 'Collin',
    county_names_all: 'Collin|Denton',
    county_weights: '{"48085": 90.27, "48121": 9.73}',
    density: 1296.4,
    imprecise: false,
    latitude: 33.03521,
    longitude: -96.80943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75093',
  },
  {
    city: 'Plano',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 1303.7,
    imprecise: false,
    latitude: 33.01871,
    longitude: -96.61481,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75094',
  },
  {
    city: 'Wylie',
    county_fips: 48085,
    county_fips_all: '48085|48397|48113',
    county: 'Collin',
    county_names_all: 'Collin|Rockwall|Dallas',
    county_weights: '{"48085": 82.66, "48397": 8.8, "48113": 8.54}',
    density: 836.2,
    imprecise: false,
    latitude: 33.01432,
    longitude: -96.53531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 69325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75098',
  },
  {
    city: 'Bardwell',
    county_fips: 48139,
    county_fips_all: '48139',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"48139": 100}',
    density: 449.9,
    imprecise: false,
    latitude: 32.27003,
    longitude: -96.70239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75101',
  },
  {
    city: 'Barry',
    county_fips: 48349,
    county_fips_all: '48349',
    county: 'Navarro',
    county_names_all: 'Navarro',
    county_weights: '{"48349": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 32.08274,
    longitude: -96.63999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75102',
  },
  {
    city: 'Canton',
    county_fips: 48467,
    county_fips_all: '48467',
    county: 'Van Zandt',
    county_names_all: 'Van Zandt',
    county_weights: '{"48467": 100}',
    density: 33.1,
    imprecise: false,
    latitude: 32.51201,
    longitude: -95.88363,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75103',
  },
  {
    city: 'Cedar Hill',
    county_fips: 48113,
    county_fips_all: '48113|48139',
    county: 'Dallas',
    county_names_all: 'Dallas|Ellis',
    county_weights: '{"48113": 94.22, "48139": 5.78}',
    density: 515.1,
    imprecise: false,
    latitude: 32.58295,
    longitude: -96.96712,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75104',
  },
  {
    city: 'Chatfield',
    county_fips: 48349,
    county_fips_all: '48349',
    county: 'Navarro',
    county_names_all: 'Navarro',
    county_weights: '{"48349": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 32.26717,
    longitude: -96.36682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75105',
  },
  {
    city: 'Corsicana',
    county_fips: 48349,
    county_fips_all: '48349',
    county: 'Navarro',
    county_names_all: 'Navarro',
    county_weights: '{"48349": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 32.04246,
    longitude: -96.35622,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75109',
  },
  {
    city: 'Corsicana',
    county_fips: 48349,
    county_fips_all: '48349',
    county: 'Navarro',
    county_names_all: 'Navarro',
    county_weights: '{"48349": 100}',
    density: 88.6,
    imprecise: false,
    latitude: 32.08071,
    longitude: -96.52344,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75110',
  },
  {
    city: 'Crandall',
    county_fips: 48257,
    county_fips_all: '48257',
    county: 'Kaufman',
    county_names_all: 'Kaufman',
    county_weights: '{"48257": 100}',
    density: 83.8,
    imprecise: false,
    latitude: 32.60769,
    longitude: -96.44322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75114',
  },
  {
    city: 'Desoto',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1031.1,
    imprecise: false,
    latitude: 32.59831,
    longitude: -96.86433,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75115',
  },
  {
    city: 'Duncanville',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1510.1,
    imprecise: false,
    latitude: 32.66013,
    longitude: -96.91402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75116',
  },
  {
    city: 'Edgewood',
    county_fips: 48467,
    county_fips_all: '48467',
    county: 'Van Zandt',
    county_names_all: 'Van Zandt',
    county_weights: '{"48467": 100}',
    density: 39.9,
    imprecise: false,
    latitude: 32.71005,
    longitude: -95.85268,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75117',
  },
  {
    city: 'Ennis',
    county_fips: 48139,
    county_fips_all: '48139|48349',
    county: 'Ellis',
    county_names_all: 'Ellis|Navarro',
    county_weights: '{"48139": 94.48, "48349": 5.52}',
    density: 46.6,
    imprecise: false,
    latitude: 32.32293,
    longitude: -96.59107,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75119',
  },
  {
    city: 'Eustace',
    county_fips: 48213,
    county_fips_all: '48213|48467',
    county: 'Henderson',
    county_names_all: 'Henderson|Van Zandt',
    county_weights: '{"48213": 73.19, "48467": 26.81}',
    density: 25.9,
    imprecise: false,
    latitude: 32.32579,
    longitude: -95.96932,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75124',
  },
  {
    city: 'Ferris',
    county_fips: 48139,
    county_fips_all: '48139|48113',
    county: 'Ellis',
    county_names_all: 'Ellis|Dallas',
    county_weights: '{"48139": 71.42, "48113": 28.58}',
    density: 40.4,
    imprecise: false,
    latitude: 32.52983,
    longitude: -96.61563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75125',
  },
  {
    city: 'Forney',
    county_fips: 48257,
    county_fips_all: '48257|48397',
    county: 'Kaufman',
    county_names_all: 'Kaufman|Rockwall',
    county_weights: '{"48257": 97.33, "48397": 2.67}',
    density: 401.1,
    imprecise: false,
    latitude: 32.74361,
    longitude: -96.45289,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 84799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75126',
  },
  {
    city: 'Fruitvale',
    county_fips: 48467,
    county_fips_all: '48467',
    county: 'Van Zandt',
    county_names_all: 'Van Zandt',
    county_weights: '{"48467": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 32.6926,
    longitude: -95.79262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75127',
  },
  {
    city: 'Fate',
    county_fips: 48397,
    county_fips_all: '48397',
    county: 'Rockwall',
    county_names_all: 'Rockwall',
    county_weights: '{"48397": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.93865,
    longitude: -96.38046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75132',
  },
  {
    city: 'Lancaster',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 693.8,
    imprecise: false,
    latitude: 32.62308,
    longitude: -96.78007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75134',
  },
  {
    city: 'Caddo Mills',
    county_fips: 48231,
    county_fips_all: '48231',
    county: 'Hunt',
    county_names_all: 'Hunt',
    county_weights: '{"48231": 100}',
    density: 66.4,
    imprecise: false,
    latitude: 33.06666,
    longitude: -96.22567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75135',
  },
  {
    city: 'Duncanville',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1268.3,
    imprecise: false,
    latitude: 32.63421,
    longitude: -96.91224,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75137',
  },
  {
    city: 'Grand Saline',
    county_fips: 48467,
    county_fips_all: '48467|48423',
    county: 'Van Zandt',
    county_names_all: 'Van Zandt|Smith',
    county_weights: '{"48467": 98.16, "48423": 1.84}',
    density: 28.1,
    imprecise: false,
    latitude: 32.64485,
    longitude: -95.68854,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75140',
  },
  {
    city: 'Hutchins',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 188.4,
    imprecise: false,
    latitude: 32.63984,
    longitude: -96.69257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75141',
  },
  {
    city: 'Kaufman',
    county_fips: 48257,
    county_fips_all: '48257',
    county: 'Kaufman',
    county_names_all: 'Kaufman',
    county_weights: '{"48257": 100}',
    density: 48.6,
    imprecise: false,
    latitude: 32.57004,
    longitude: -96.24637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75142',
  },
  {
    city: 'Kemp',
    county_fips: 48257,
    county_fips_all: '48257|48213',
    county: 'Kaufman',
    county_names_all: 'Kaufman|Henderson',
    county_weights: '{"48257": 54.16, "48213": 45.84}',
    density: 31.2,
    imprecise: false,
    latitude: 32.36334,
    longitude: -96.24929,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75143',
  },
  {
    city: 'Kerens',
    county_fips: 48349,
    county_fips_all: '48349',
    county: 'Navarro',
    county_names_all: 'Navarro',
    county_weights: '{"48349": 100}',
    density: 8,
    imprecise: false,
    latitude: 32.11157,
    longitude: -96.20954,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75144',
  },
  {
    city: 'Lancaster',
    county_fips: 48113,
    county_fips_all: '48113|48139',
    county: 'Dallas',
    county_names_all: 'Dallas|Ellis',
    county_weights: '{"48113": 99.42, "48139": 0.58}',
    density: 279.3,
    imprecise: false,
    latitude: 32.57608,
    longitude: -96.75137,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75146',
  },
  {
    city: 'Mabank',
    county_fips: 48467,
    county_fips_all: '48467|48257|48213',
    county: 'Van Zandt',
    county_names_all: 'Van Zandt|Kaufman|Henderson',
    county_weights: '{"48467": 53.96, "48257": 41.84, "48213": 4.2}',
    density: 41.1,
    imprecise: false,
    latitude: 32.42256,
    longitude: -96.06517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75147',
  },
  {
    city: 'Malakoff',
    county_fips: 48213,
    county_fips_all: '48213',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"48213": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 32.12491,
    longitude: -96.01173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75148',
  },
  {
    city: 'Mesquite',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1403.8,
    imprecise: false,
    latitude: 32.76994,
    longitude: -96.6151,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75149',
  },
  {
    city: 'Mesquite',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1928.6,
    imprecise: false,
    latitude: 32.81545,
    longitude: -96.6308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 62738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75150',
  },
  {
    city: 'Palmer',
    county_fips: 48139,
    county_fips_all: '48139',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"48139": 100}',
    density: 50,
    imprecise: false,
    latitude: 32.43598,
    longitude: -96.67444,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75152',
  },
  {
    city: 'Powell',
    county_fips: 48349,
    county_fips_all: '48349',
    county: 'Navarro',
    county_names_all: 'Navarro',
    county_weights: '{"48349": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 32.17149,
    longitude: -96.35331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75153',
  },
  {
    city: 'Red Oak',
    county_fips: 48139,
    county_fips_all: '48139|48113',
    county: 'Ellis',
    county_names_all: 'Ellis|Dallas',
    county_weights: '{"48139": 87.53, "48113": 12.47}',
    density: 424,
    imprecise: false,
    latitude: 32.52319,
    longitude: -96.80885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75154',
  },
  {
    city: 'Rice',
    county_fips: 48349,
    county_fips_all: '48349',
    county: 'Navarro',
    county_names_all: 'Navarro',
    county_weights: '{"48349": 100}',
    density: 27.6,
    imprecise: false,
    latitude: 32.2232,
    longitude: -96.46906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75155',
  },
  {
    city: 'Mabank',
    county_fips: 48213,
    county_fips_all: '48213',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"48213": 100}',
    density: 196.6,
    imprecise: false,
    latitude: 32.28759,
    longitude: -96.09999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75156',
  },
  {
    city: 'Rosser',
    county_fips: 48257,
    county_fips_all: '48257',
    county: 'Kaufman',
    county_names_all: 'Kaufman',
    county_weights: '{"48257": 100}',
    density: 65.2,
    imprecise: false,
    latitude: 32.46168,
    longitude: -96.44914,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75157',
  },
  {
    city: 'Scurry',
    county_fips: 48257,
    county_fips_all: '48257',
    county: 'Kaufman',
    county_names_all: 'Kaufman',
    county_weights: '{"48257": 100}',
    density: 27,
    imprecise: false,
    latitude: 32.46694,
    longitude: -96.39315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75158',
  },
  {
    city: 'Seagoville',
    county_fips: 48113,
    county_fips_all: '48113|48257',
    county: 'Dallas',
    county_names_all: 'Dallas|Kaufman',
    county_weights: '{"48113": 63.48, "48257": 36.52}',
    density: 152.7,
    imprecise: false,
    latitude: 32.60652,
    longitude: -96.53939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75159',
  },
  {
    city: 'Terrell',
    county_fips: 48257,
    county_fips_all: '48257|48231',
    county: 'Kaufman',
    county_names_all: 'Kaufman|Hunt',
    county_weights: '{"48257": 82.87, "48231": 17.13}',
    density: 92.1,
    imprecise: false,
    latitude: 32.76466,
    longitude: -96.29835,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75160',
  },
  {
    city: 'Terrell',
    county_fips: 48257,
    county_fips_all: '48257',
    county: 'Kaufman',
    county_names_all: 'Kaufman',
    county_weights: '{"48257": 100}',
    density: 27.5,
    imprecise: false,
    latitude: 32.73609,
    longitude: -96.17129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75161',
  },
  {
    city: 'Trinidad',
    county_fips: 48213,
    county_fips_all: '48213',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"48213": 100}',
    density: 27.8,
    imprecise: false,
    latitude: 32.1672,
    longitude: -96.10999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75163',
  },
  {
    city: 'Josephine',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 342.7,
    imprecise: false,
    latitude: 33.06963,
    longitude: -96.3041,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75164',
  },
  {
    city: 'Waxahachie',
    county_fips: 48139,
    county_fips_all: '48139',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"48139": 100}',
    density: 175.2,
    imprecise: false,
    latitude: 32.36687,
    longitude: -96.79677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75165',
  },
  {
    city: 'Lavon',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 208.7,
    imprecise: false,
    latitude: 33.01671,
    longitude: -96.4495,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75166',
  },
  {
    city: 'Waxahachie',
    county_fips: 48139,
    county_fips_all: '48139',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"48139": 100}',
    density: 56,
    imprecise: false,
    latitude: 32.36123,
    longitude: -96.91547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75167',
  },
  {
    city: 'Wills Point',
    county_fips: 48467,
    county_fips_all: '48467|48257|48231',
    county: 'Van Zandt',
    county_names_all: 'Van Zandt|Kaufman|Hunt',
    county_weights: '{"48467": 86.33, "48257": 8.7, "48231": 4.97}',
    density: 28.8,
    imprecise: false,
    latitude: 32.70335,
    longitude: -95.99754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75169',
  },
  {
    city: 'Wilmer',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 198.2,
    imprecise: false,
    latitude: 32.60369,
    longitude: -96.67458,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75172',
  },
  {
    city: 'Nevada',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 125.9,
    imprecise: false,
    latitude: 33.05986,
    longitude: -96.38673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75173',
  },
  {
    city: 'Balch Springs',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1313.8,
    imprecise: false,
    latitude: 32.71937,
    longitude: -96.61841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75180',
  },
  {
    city: 'Mesquite',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 663.6,
    imprecise: false,
    latitude: 32.72696,
    longitude: -96.555,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75181',
  },
  {
    city: 'Sunnyvale',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 181,
    imprecise: false,
    latitude: 32.80033,
    longitude: -96.55425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75182',
  },
  {
    city: 'Royse City',
    county_fips: 48397,
    county_fips_all: '48397|48231|48085',
    county: 'Rockwall',
    county_names_all: 'Rockwall|Hunt|Collin',
    county_weights: '{"48397": 42.32, "48231": 38.22, "48085": 19.46}',
    density: 171.3,
    imprecise: false,
    latitude: 32.94821,
    longitude: -96.30941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75189',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 5146.8,
    imprecise: false,
    latitude: 32.78826,
    longitude: -96.79953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75201',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1670.5,
    imprecise: false,
    latitude: 32.77843,
    longitude: -96.8037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75202',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1271.8,
    imprecise: false,
    latitude: 32.74439,
    longitude: -96.80206,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75203',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 5230.1,
    imprecise: false,
    latitude: 32.80216,
    longitude: -96.78885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75204',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 2347.7,
    imprecise: false,
    latitude: 32.83657,
    longitude: -96.79617,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75205',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 3547.2,
    imprecise: false,
    latitude: 32.83161,
    longitude: -96.77032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75206',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 829.1,
    imprecise: false,
    latitude: 32.78693,
    longitude: -96.82181,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75207',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1853.1,
    imprecise: false,
    latitude: 32.75409,
    longitude: -96.83943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75208',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1567.7,
    imprecise: false,
    latitude: 32.8487,
    longitude: -96.8257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75209',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1304.5,
    imprecise: false,
    latitude: 32.77141,
    longitude: -96.74618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75210',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1651.8,
    imprecise: false,
    latitude: 32.73649,
    longitude: -96.90214,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 73534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75211',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1094.3,
    imprecise: false,
    latitude: 32.78203,
    longitude: -96.87853,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75212',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1811.1,
    imprecise: false,
    latitude: 32.82899,
    longitude: -96.74348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75214',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 953.2,
    imprecise: false,
    latitude: 32.75259,
    longitude: -96.76075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75215',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1454.5,
    imprecise: false,
    latitude: 32.71158,
    longitude: -96.78256,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75216',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1182.7,
    imprecise: false,
    latitude: 32.71291,
    longitude: -96.68243,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 85028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75217',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1261.7,
    imprecise: false,
    latitude: 32.84136,
    longitude: -96.70357,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75218',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 4036.8,
    imprecise: false,
    latitude: 32.81087,
    longitude: -96.81315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75219',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1373.2,
    imprecise: false,
    latitude: 32.86692,
    longitude: -96.87571,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75220',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1494.1,
    imprecise: false,
    latitude: 32.79255,
    longitude: -96.74556,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75223',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 2361.1,
    imprecise: false,
    latitude: 32.71117,
    longitude: -96.83953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75224',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1840,
    imprecise: false,
    latitude: 32.86511,
    longitude: -96.79109,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75225',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1863.1,
    imprecise: false,
    latitude: 32.78315,
    longitude: -96.77654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75226',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1947.9,
    imprecise: false,
    latitude: 32.77044,
    longitude: -96.68831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75227',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 2285.6,
    imprecise: false,
    latitude: 32.82456,
    longitude: -96.6805,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 67714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75228',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1044.1,
    imprecise: false,
    latitude: 32.8939,
    longitude: -96.86517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75229',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1502.3,
    imprecise: false,
    latitude: 32.90202,
    longitude: -96.79226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75230',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 2687.1,
    imprecise: false,
    latitude: 32.87695,
    longitude: -96.74967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75231',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1442.6,
    imprecise: false,
    latitude: 32.65878,
    longitude: -96.83968,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75232',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1607.8,
    imprecise: false,
    latitude: 32.70444,
    longitude: -96.87271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75233',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1241.8,
    imprecise: false,
    latitude: 32.92423,
    longitude: -96.88904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75234',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1138.7,
    imprecise: false,
    latitude: 32.83219,
    longitude: -96.84798,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75235',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 548.6,
    imprecise: false,
    latitude: 32.6866,
    longitude: -96.93455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75236',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1057.7,
    imprecise: false,
    latitude: 32.66489,
    longitude: -96.87238,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75237',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1947.5,
    imprecise: false,
    latitude: 32.87855,
    longitude: -96.70785,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75238',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 2584.2,
    imprecise: false,
    latitude: 32.93194,
    longitude: -96.78924,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75240',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 517.1,
    imprecise: false,
    latitude: 32.667,
    longitude: -96.75903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75241',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 2661.3,
    imprecise: false,
    latitude: 32.91232,
    longitude: -96.73633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75243',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1118.9,
    imprecise: false,
    latitude: 32.92544,
    longitude: -96.83671,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75244',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1892.8,
    imprecise: false,
    latitude: 32.79296,
    longitude: -96.77322,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75246',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 36.6,
    imprecise: false,
    latitude: 32.81417,
    longitude: -96.87803,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75247',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113|48085',
    county: 'Dallas',
    county_names_all: 'Dallas|Collin',
    county_weights: '{"48113": 99.41, "48085": 0.59}',
    density: 2000.1,
    imprecise: false,
    latitude: 32.96957,
    longitude: -96.79542,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75248',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 1155.9,
    imprecise: false,
    latitude: 32.6449,
    longitude: -96.96257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75249',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 2289.5,
    imprecise: false,
    latitude: 32.91984,
    longitude: -96.77308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75251',
  },
  {
    city: 'Dallas',
    county_fips: 48085,
    county_fips_all: '48085|48113',
    county: 'Collin',
    county_names_all: 'Collin|Dallas',
    county_weights: '{"48085": 92.3, "48113": 7.7}',
    density: 2153.3,
    imprecise: false,
    latitude: 32.99696,
    longitude: -96.78983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75252',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 630.3,
    imprecise: false,
    latitude: 32.67278,
    longitude: -96.61171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75253',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 2980.7,
    imprecise: false,
    latitude: 32.94571,
    longitude: -96.80127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75254',
  },
  {
    city: 'Dallas',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.88568,
    longitude: -97.05419,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75261',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.78126,
    longitude: -96.80192,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75270',
  },
  {
    city: 'Dallas',
    county_fips: 48085,
    county_fips_all: '48085|48121|48113',
    county: 'Collin',
    county_names_all: 'Collin|Denton|Dallas',
    county_weights: '{"48085": 58.42, "48121": 41.3, "48113": 0.28}',
    density: 3762.3,
    imprecise: false,
    latitude: 33.00015,
    longitude: -96.84075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75287',
  },
  {
    city: 'Greenville',
    county_fips: 48231,
    county_fips_all: '48231',
    county: 'Hunt',
    county_names_all: 'Hunt',
    county_weights: '{"48231": 100}',
    density: 81,
    imprecise: false,
    latitude: 33.18506,
    longitude: -96.11556,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75401',
  },
  {
    city: 'Greenville',
    county_fips: 48231,
    county_fips_all: '48231',
    county: 'Hunt',
    county_names_all: 'Hunt',
    county_weights: '{"48231": 100}',
    density: 85.4,
    imprecise: false,
    latitude: 33.06724,
    longitude: -96.08576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75402',
  },
  {
    city: 'Princeton',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 264.2,
    imprecise: false,
    latitude: 33.1512,
    longitude: -96.48808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75407',
  },
  {
    city: 'Anna',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 133.8,
    imprecise: false,
    latitude: 33.35223,
    longitude: -96.52808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75409',
  },
  {
    city: 'Alba',
    county_fips: 48499,
    county_fips_all: '48499|48379',
    county: 'Wood',
    county_names_all: 'Wood|Rains',
    county_weights: '{"48499": 55.98, "48379": 44.02}',
    density: 20.5,
    imprecise: false,
    latitude: 32.7921,
    longitude: -95.63705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75410',
  },
  {
    city: 'Arthur City',
    county_fips: 48277,
    county_fips_all: '48277',
    county: 'Lamar',
    county_names_all: 'Lamar',
    county_weights: '{"48277": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 33.86275,
    longitude: -95.63955,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75411',
  },
  {
    city: 'Bagwell',
    county_fips: 48387,
    county_fips_all: '48387',
    county: 'Red River',
    county_names_all: 'Red River',
    county_weights: '{"48387": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 33.80295,
    longitude: -95.14232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75412',
  },
  {
    city: 'Bailey',
    county_fips: 48147,
    county_fips_all: '48147',
    county: 'Fannin',
    county_names_all: 'Fannin',
    county_weights: '{"48147": 100}',
    density: 180.4,
    imprecise: false,
    latitude: 33.43596,
    longitude: -96.16477,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75413',
  },
  {
    city: 'Bells',
    county_fips: 48181,
    county_fips_all: '48181|48147',
    county: 'Grayson',
    county_names_all: 'Grayson|Fannin',
    county_weights: '{"48181": 99.88, "48147": 0.12}',
    density: 29,
    imprecise: false,
    latitude: 33.62504,
    longitude: -96.43193,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75414',
  },
  {
    city: 'Ben Franklin',
    county_fips: 48119,
    county_fips_all: '48119',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"48119": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 33.4645,
    longitude: -95.74603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75415',
  },
  {
    city: 'Blossom',
    county_fips: 48277,
    county_fips_all: '48277|48387',
    county: 'Lamar',
    county_names_all: 'Lamar|Red River',
    county_weights: '{"48277": 98.83, "48387": 1.17}',
    density: 14.5,
    imprecise: false,
    latitude: 33.67255,
    longitude: -95.35431,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75416',
  },
  {
    city: 'Bogata',
    county_fips: 48387,
    county_fips_all: '48387',
    county: 'Red River',
    county_names_all: 'Red River',
    county_weights: '{"48387": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 33.43827,
    longitude: -95.13114,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75417',
  },
  {
    city: 'Bonham',
    county_fips: 48147,
    county_fips_all: '48147',
    county: 'Fannin',
    county_names_all: 'Fannin',
    county_weights: '{"48147": 100}',
    density: 41.6,
    imprecise: false,
    latitude: 33.57235,
    longitude: -96.1773,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75418',
  },
  {
    city: 'Brashear',
    county_fips: 48223,
    county_fips_all: '48223|48379',
    county: 'Hopkins',
    county_names_all: 'Hopkins|Rains',
    county_weights: '{"48223": 99.1, "48379": 0.9}',
    density: 11.4,
    imprecise: false,
    latitude: 33.05782,
    longitude: -95.72503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75420',
  },
  {
    city: 'Brookston',
    county_fips: 48277,
    county_fips_all: '48277',
    county: 'Lamar',
    county_names_all: 'Lamar',
    county_weights: '{"48277": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 33.6448,
    longitude: -95.71809,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75421',
  },
  {
    city: 'Campbell',
    county_fips: 48231,
    county_fips_all: '48231',
    county: 'Hunt',
    county_names_all: 'Hunt',
    county_weights: '{"48231": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 33.13889,
    longitude: -95.93059,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75422',
  },
  {
    city: 'Celeste',
    county_fips: 48231,
    county_fips_all: '48231|48147',
    county: 'Hunt',
    county_names_all: 'Hunt|Fannin',
    county_weights: '{"48231": 94.22, "48147": 5.78}',
    density: 14.8,
    imprecise: false,
    latitude: 33.29279,
    longitude: -96.19918,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75423',
  },
  {
    city: 'Blue Ridge',
    county_fips: 48085,
    county_fips_all: '48085|48147',
    county: 'Collin',
    county_names_all: 'Collin|Fannin',
    county_weights: '{"48085": 91.96, "48147": 8.04}',
    density: 23,
    imprecise: false,
    latitude: 33.30535,
    longitude: -96.39059,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75424',
  },
  {
    city: 'Clarksville',
    county_fips: 48387,
    county_fips_all: '48387',
    county: 'Red River',
    county_names_all: 'Red River',
    county_weights: '{"48387": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 33.65608,
    longitude: -95.01093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75426',
  },
  {
    city: 'Commerce',
    county_fips: 48231,
    county_fips_all: '48231|48119',
    county: 'Hunt',
    county_names_all: 'Hunt|Delta',
    county_weights: '{"48231": 83.26, "48119": 16.74}',
    density: 47.9,
    imprecise: false,
    latitude: 33.27132,
    longitude: -95.91799,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75428',
  },
  {
    city: 'Commerce',
    county_fips: 48231,
    county_fips_all: '48231',
    county: 'Hunt',
    county_names_all: 'Hunt',
    county_weights: '{"48231": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.27847,
    longitude: -95.89231,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75429',
  },
  {
    city: 'Como',
    county_fips: 48223,
    county_fips_all: '48223|48499',
    county: 'Hopkins',
    county_names_all: 'Hopkins|Wood',
    county_weights: '{"48223": 76.47, "48499": 23.53}',
    density: 12.5,
    imprecise: false,
    latitude: 33.0073,
    longitude: -95.4628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75431',
  },
  {
    city: 'Cooper',
    county_fips: 48119,
    county_fips_all: '48119',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"48119": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 33.38912,
    longitude: -95.66804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75432',
  },
  {
    city: 'Cumby',
    county_fips: 48223,
    county_fips_all: '48223|48231',
    county: 'Hopkins',
    county_names_all: 'Hopkins|Hunt',
    county_weights: '{"48223": 98.08, "48231": 1.92}',
    density: 13.2,
    imprecise: false,
    latitude: 33.10883,
    longitude: -95.80571,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75433',
  },
  {
    city: 'Cunningham',
    county_fips: 48277,
    county_fips_all: '48277',
    county: 'Lamar',
    county_names_all: 'Lamar',
    county_weights: '{"48277": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 33.41258,
    longitude: -95.35171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75434',
  },
  {
    city: 'Deport',
    county_fips: 48277,
    county_fips_all: '48277|48387',
    county: 'Lamar',
    county_names_all: 'Lamar|Red River',
    county_weights: '{"48277": 54.39, "48387": 45.61}',
    density: 6.9,
    imprecise: false,
    latitude: 33.50175,
    longitude: -95.29522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75435',
  },
  {
    city: 'Detroit',
    county_fips: 48387,
    county_fips_all: '48387|48277',
    county: 'Red River',
    county_names_all: 'Red River|Lamar',
    county_weights: '{"48387": 93.63, "48277": 6.37}',
    density: 5.1,
    imprecise: false,
    latitude: 33.73507,
    longitude: -95.24904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75436',
  },
  {
    city: 'Dike',
    county_fips: 48223,
    county_fips_all: '48223',
    county: 'Hopkins',
    county_names_all: 'Hopkins',
    county_weights: '{"48223": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 33.25605,
    longitude: -95.46567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75437',
  },
  {
    city: 'Dodd City',
    county_fips: 48147,
    county_fips_all: '48147',
    county: 'Fannin',
    county_names_all: 'Fannin',
    county_weights: '{"48147": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 33.60701,
    longitude: -96.07462,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75438',
  },
  {
    city: 'Ector',
    county_fips: 48147,
    county_fips_all: '48147',
    county: 'Fannin',
    county_names_all: 'Fannin',
    county_weights: '{"48147": 100}',
    density: 28.3,
    imprecise: false,
    latitude: 33.55261,
    longitude: -96.27796,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75439',
  },
  {
    city: 'Emory',
    county_fips: 48379,
    county_fips_all: '48379|48223|48499',
    county: 'Rains',
    county_names_all: 'Rains|Hopkins|Wood',
    county_weights: '{"48379": 97.7, "48223": 1.6, "48499": 0.7}',
    density: 29.7,
    imprecise: false,
    latitude: 32.87507,
    longitude: -95.75262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75440',
  },
  {
    city: 'Enloe',
    county_fips: 48119,
    county_fips_all: '48119',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"48119": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 33.4296,
    longitude: -95.65456,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 82,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75441',
  },
  {
    city: 'Farmersville',
    county_fips: 48085,
    county_fips_all: '48085|48231',
    county: 'Collin',
    county_names_all: 'Collin|Hunt',
    county_weights: '{"48085": 84.75, "48231": 15.25}',
    density: 38.8,
    imprecise: false,
    latitude: 33.17717,
    longitude: -96.35035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75442',
  },
  {
    city: 'Honey Grove',
    county_fips: 48147,
    county_fips_all: '48147|48277',
    county: 'Fannin',
    county_names_all: 'Fannin|Lamar',
    county_weights: '{"48147": 75.26, "48277": 24.74}',
    density: 8.2,
    imprecise: false,
    latitude: 33.61385,
    longitude: -95.89177,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75446',
  },
  {
    city: 'Ivanhoe',
    county_fips: 48147,
    county_fips_all: '48147',
    county: 'Fannin',
    county_names_all: 'Fannin',
    county_weights: '{"48147": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 33.765,
    longitude: -96.11966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75447',
  },
  {
    city: 'Klondike',
    county_fips: 48119,
    county_fips_all: '48119',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"48119": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 33.31478,
    longitude: -95.79681,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75448',
  },
  {
    city: 'Ladonia',
    county_fips: 48147,
    county_fips_all: '48147|48231',
    county: 'Fannin',
    county_names_all: 'Fannin|Hunt',
    county_weights: '{"48147": 69.38, "48231": 30.62}',
    density: 4.3,
    imprecise: false,
    latitude: 33.423,
    longitude: -95.9493,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75449',
  },
  {
    city: 'Lake Creek',
    county_fips: 48119,
    county_fips_all: '48119',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"48119": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 33.40465,
    longitude: -95.47481,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75450',
  },
  {
    city: 'Leesburg',
    county_fips: 48063,
    county_fips_all: '48063|48499|48459',
    county: 'Camp',
    county_names_all: 'Camp|Wood|Upshur',
    county_weights: '{"48063": 88.35, "48499": 8.51, "48459": 3.14}',
    density: 11.4,
    imprecise: false,
    latitude: 32.96247,
    longitude: -95.11835,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75451',
  },
  {
    city: 'Leonard',
    county_fips: 48147,
    county_fips_all: '48147|48231|48085',
    county: 'Fannin',
    county_names_all: 'Fannin|Hunt|Collin',
    county_weights: '{"48147": 79.65, "48231": 15.24, "48085": 5.11}',
    density: 25.2,
    imprecise: false,
    latitude: 33.39284,
    longitude: -96.24469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75452',
  },
  {
    city: 'Lone Oak',
    county_fips: 48231,
    county_fips_all: '48231|48379|48223',
    county: 'Hunt',
    county_names_all: 'Hunt|Rains|Hopkins',
    county_weights: '{"48231": 74.91, "48379": 15.35, "48223": 9.74}',
    density: 16.9,
    imprecise: false,
    latitude: 33.00025,
    longitude: -95.92817,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75453',
  },
  {
    city: 'Melissa',
    county_fips: 48085,
    county_fips_all: '48085',
    county: 'Collin',
    county_names_all: 'Collin',
    county_weights: '{"48085": 100}',
    density: 414.9,
    imprecise: false,
    latitude: 33.283,
    longitude: -96.56073,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75454',
  },
  {
    city: 'Mount Pleasant',
    county_fips: 48449,
    county_fips_all: '48449|48159',
    county: 'Titus',
    county_names_all: 'Titus|Franklin',
    county_weights: '{"48449": 96.32, "48159": 3.68}',
    density: 33.9,
    imprecise: false,
    latitude: 33.21725,
    longitude: -94.98022,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75455',
  },
  {
    city: 'Mount Vernon',
    county_fips: 48159,
    county_fips_all: '48159',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"48159": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 33.1746,
    longitude: -95.21125,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75457',
  },
  {
    city: 'Howe',
    county_fips: 48181,
    county_fips_all: '48181',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"48181": 100}',
    density: 30.9,
    imprecise: false,
    latitude: 33.52988,
    longitude: -96.6831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75459',
  },
  {
    city: 'Paris',
    county_fips: 48277,
    county_fips_all: '48277',
    county: 'Lamar',
    county_names_all: 'Lamar',
    county_weights: '{"48277": 100}',
    density: 88.8,
    imprecise: false,
    latitude: 33.6627,
    longitude: -95.60296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75460',
  },
  {
    city: 'Paris',
    county_fips: 48277,
    county_fips_all: '48277',
    county: 'Lamar',
    county_names_all: 'Lamar',
    county_weights: '{"48277": 100}',
    density: 24.8,
    imprecise: false,
    latitude: 33.62166,
    longitude: -95.48362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75462',
  },
  {
    city: 'Pattonville',
    county_fips: 48277,
    county_fips_all: '48277',
    county: 'Lamar',
    county_names_all: 'Lamar',
    county_weights: '{"48277": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 33.51175,
    longitude: -95.40747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75468',
  },
  {
    city: 'Pecan Gap',
    county_fips: 48119,
    county_fips_all: '48119|48231',
    county: 'Delta',
    county_names_all: 'Delta|Hunt',
    county_weights: '{"48119": 85.82, "48231": 14.18}',
    density: 4,
    imprecise: false,
    latitude: 33.41269,
    longitude: -95.8248,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75469',
  },
  {
    city: 'Petty',
    county_fips: 48277,
    county_fips_all: '48277',
    county: 'Lamar',
    county_names_all: 'Lamar',
    county_weights: '{"48277": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 33.58341,
    longitude: -95.79836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75470',
  },
  {
    city: 'Pickton',
    county_fips: 48223,
    county_fips_all: '48223|48499',
    county: 'Hopkins',
    county_names_all: 'Hopkins|Wood',
    county_weights: '{"48223": 94.59, "48499": 5.41}',
    density: 11.4,
    imprecise: false,
    latitude: 33.04431,
    longitude: -95.38883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75471',
  },
  {
    city: 'Point',
    county_fips: 48379,
    county_fips_all: '48379|48223',
    county: 'Rains',
    county_names_all: 'Rains|Hopkins',
    county_weights: '{"48379": 99.06, "48223": 0.94}',
    density: 20.2,
    imprecise: false,
    latitude: 32.89177,
    longitude: -95.87239,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75472',
  },
  {
    city: 'Powderly',
    county_fips: 48277,
    county_fips_all: '48277',
    county: 'Lamar',
    county_names_all: 'Lamar',
    county_weights: '{"48277": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 33.81461,
    longitude: -95.48433,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75473',
  },
  {
    city: 'Quinlan',
    county_fips: 48231,
    county_fips_all: '48231|48257',
    county: 'Hunt',
    county_names_all: 'Hunt|Kaufman',
    county_weights: '{"48231": 96.29, "48257": 3.71}',
    density: 64.8,
    imprecise: false,
    latitude: 32.91709,
    longitude: -96.10611,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75474',
  },
  {
    city: 'Randolph',
    county_fips: 48147,
    county_fips_all: '48147',
    county: 'Fannin',
    county_names_all: 'Fannin',
    county_weights: '{"48147": 100}',
    density: 173.5,
    imprecise: false,
    latitude: 33.48593,
    longitude: -96.25757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75475',
  },
  {
    city: 'Ravenna',
    county_fips: 48147,
    county_fips_all: '48147',
    county: 'Fannin',
    county_names_all: 'Fannin',
    county_weights: '{"48147": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 33.70793,
    longitude: -96.24342,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75476',
  },
  {
    city: 'Roxton',
    county_fips: 48277,
    county_fips_all: '48277',
    county: 'Lamar',
    county_names_all: 'Lamar',
    county_weights: '{"48277": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 33.53118,
    longitude: -95.73429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75477',
  },
  {
    city: 'Saltillo',
    county_fips: 48223,
    county_fips_all: '48223|48159',
    county: 'Hopkins',
    county_names_all: 'Hopkins|Franklin',
    county_weights: '{"48223": 91.57, "48159": 8.43}',
    density: 6.3,
    imprecise: false,
    latitude: 33.17276,
    longitude: -95.35226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75478',
  },
  {
    city: 'Savoy',
    county_fips: 48147,
    county_fips_all: '48147|48181',
    county: 'Fannin',
    county_names_all: 'Fannin|Grayson',
    county_weights: '{"48147": 97.06, "48181": 2.94}',
    density: 18.8,
    imprecise: false,
    latitude: 33.63007,
    longitude: -96.3386,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75479',
  },
  {
    city: 'Scroggins',
    county_fips: 48159,
    county_fips_all: '48159|48499',
    county: 'Franklin',
    county_names_all: 'Franklin|Wood',
    county_weights: '{"48159": 97.35, "48499": 2.65}',
    density: 21.6,
    imprecise: false,
    latitude: 33.02129,
    longitude: -95.19159,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75480',
  },
  {
    city: 'Sulphur Bluff',
    county_fips: 48223,
    county_fips_all: '48223|48159',
    county: 'Hopkins',
    county_names_all: 'Hopkins|Franklin',
    county_weights: '{"48223": 92.61, "48159": 7.39}',
    density: 2.7,
    imprecise: false,
    latitude: 33.31751,
    longitude: -95.37485,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75481',
  },
  {
    city: 'Sulphur Springs',
    county_fips: 48223,
    county_fips_all: '48223',
    county: 'Hopkins',
    county_names_all: 'Hopkins',
    county_weights: '{"48223": 100}',
    density: 32.6,
    imprecise: false,
    latitude: 33.16929,
    longitude: -95.60946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75482',
  },
  {
    city: 'Sumner',
    county_fips: 48277,
    county_fips_all: '48277',
    county: 'Lamar',
    county_names_all: 'Lamar',
    county_weights: '{"48277": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 33.75757,
    longitude: -95.74663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75486',
  },
  {
    city: 'Talco',
    county_fips: 48159,
    county_fips_all: '48159|48449',
    county: 'Franklin',
    county_names_all: 'Franklin|Titus',
    county_weights: '{"48159": 66.4, "48449": 33.6}',
    density: 5.6,
    imprecise: false,
    latitude: 33.33584,
    longitude: -95.16567,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75487',
  },
  {
    city: 'Telephone',
    county_fips: 48147,
    county_fips_all: '48147',
    county: 'Fannin',
    county_names_all: 'Fannin',
    county_weights: '{"48147": 100}',
    density: 4,
    imprecise: false,
    latitude: 33.77628,
    longitude: -95.98899,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75488',
  },
  {
    city: 'Tom Bean',
    county_fips: 48181,
    county_fips_all: '48181',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"48181": 100}',
    density: 128.9,
    imprecise: false,
    latitude: 33.5204,
    longitude: -96.48467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75489',
  },
  {
    city: 'Trenton',
    county_fips: 48147,
    county_fips_all: '48147|48181',
    county: 'Fannin',
    county_names_all: 'Fannin|Grayson',
    county_weights: '{"48147": 96.78, "48181": 3.22}',
    density: 37.6,
    imprecise: false,
    latitude: 33.4363,
    longitude: -96.30771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75490',
  },
  {
    city: 'Whitewright',
    county_fips: 48181,
    county_fips_all: '48181|48147|48085',
    county: 'Grayson',
    county_names_all: 'Grayson|Fannin|Collin',
    county_weights: '{"48181": 58.43, "48147": 40.95, "48085": 0.62}',
    density: 21.4,
    imprecise: false,
    latitude: 33.49741,
    longitude: -96.39485,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75491',
  },
  {
    city: 'Windom',
    county_fips: 48147,
    county_fips_all: '48147',
    county: 'Fannin',
    county_names_all: 'Fannin',
    county_weights: '{"48147": 100}',
    density: 2,
    imprecise: false,
    latitude: 33.59139,
    longitude: -96.0004,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75492',
  },
  {
    city: 'Winfield',
    county_fips: 48449,
    county_fips_all: '48449',
    county: 'Titus',
    county_names_all: 'Titus',
    county_weights: '{"48449": 100}',
    density: 61.6,
    imprecise: false,
    latitude: 33.14073,
    longitude: -95.11316,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75493',
  },
  {
    city: 'Winnsboro',
    county_fips: 48499,
    county_fips_all: '48499|48159|48223|48459',
    county: 'Wood',
    county_names_all: 'Wood|Franklin|Hopkins|Upshur',
    county_weights:
      '{"48499": 69.33, "48159": 17.5, "48223": 10.12, "48459": 3.05}',
    density: 19.2,
    imprecise: false,
    latitude: 32.90898,
    longitude: -95.26126,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75494',
  },
  {
    city: 'Van Alstyne',
    county_fips: 48181,
    county_fips_all: '48181|48085',
    county: 'Grayson',
    county_names_all: 'Grayson|Collin',
    county_weights: '{"48181": 94.46, "48085": 5.54}',
    density: 63.4,
    imprecise: false,
    latitude: 33.43246,
    longitude: -96.55041,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75495',
  },
  {
    city: 'Wolfe City',
    county_fips: 48231,
    county_fips_all: '48231|48147',
    county: 'Hunt',
    county_names_all: 'Hunt|Fannin',
    county_weights: '{"48231": 59.08, "48147": 40.92}',
    density: 9.5,
    imprecise: false,
    latitude: 33.36276,
    longitude: -96.06616,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75496',
  },
  {
    city: 'Yantis',
    county_fips: 48499,
    county_fips_all: '48499|48223|48379',
    county: 'Wood',
    county_names_all: 'Wood|Hopkins|Rains',
    county_weights: '{"48499": 80.43, "48223": 19.4, "48379": 0.17}',
    density: 22.6,
    imprecise: false,
    latitude: 32.92098,
    longitude: -95.5764,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75497',
  },
  {
    city: 'Texarkana',
    county_fips: 48037,
    county_fips_all: '48037',
    county: 'Bowie',
    county_names_all: 'Bowie',
    county_weights: '{"48037": 100}',
    density: 139.8,
    imprecise: false,
    latitude: 33.37413,
    longitude: -94.13168,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75501',
  },
  {
    city: 'Texarkana',
    county_fips: 48037,
    county_fips_all: '48037',
    county: 'Bowie',
    county_names_all: 'Bowie',
    county_weights: '{"48037": 100}',
    density: 129.8,
    imprecise: false,
    latitude: 33.51345,
    longitude: -94.13038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75503',
  },
  {
    city: 'Annona',
    county_fips: 48387,
    county_fips_all: '48387',
    county: 'Red River',
    county_names_all: 'Red River',
    county_weights: '{"48387": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 33.49966,
    longitude: -94.88454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75550',
  },
  {
    city: 'Atlanta',
    county_fips: 48067,
    county_fips_all: '48067',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"48067": 100}',
    density: 24.7,
    imprecise: false,
    latitude: 33.11648,
    longitude: -94.20325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75551',
  },
  {
    city: 'Avery',
    county_fips: 48387,
    county_fips_all: '48387|48037',
    county: 'Red River',
    county_names_all: 'Red River|Bowie',
    county_weights: '{"48387": 81.06, "48037": 18.94}',
    density: 5,
    imprecise: false,
    latitude: 33.58534,
    longitude: -94.78563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75554',
  },
  {
    city: 'Bivins',
    county_fips: 48067,
    county_fips_all: '48067|48315',
    county: 'Cass',
    county_names_all: 'Cass|Marion',
    county_weights: '{"48067": 91.2, "48315": 8.8}',
    density: 5.2,
    imprecise: false,
    latitude: 32.94564,
    longitude: -94.13696,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75555',
  },
  {
    city: 'Bloomburg',
    county_fips: 48067,
    county_fips_all: '48067|05091',
    county: 'Cass',
    county_names_all: 'Cass|Miller',
    county_weights: '{"48067": 99.37, "05091": 0.63}',
    density: 19.2,
    imprecise: false,
    latitude: 33.1512,
    longitude: -94.06263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75556',
  },
  {
    city: 'Cookville',
    county_fips: 48449,
    county_fips_all: '48449|48343',
    county: 'Titus',
    county_names_all: 'Titus|Morris',
    county_weights: '{"48449": 99.04, "48343": 0.96}',
    density: 20.3,
    imprecise: false,
    latitude: 33.25017,
    longitude: -94.85564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75558',
  },
  {
    city: 'De Kalb',
    county_fips: 48037,
    county_fips_all: '48037|48387',
    county: 'Bowie',
    county_names_all: 'Bowie|Red River',
    county_weights: '{"48037": 91.92, "48387": 8.08}',
    density: 7.3,
    imprecise: false,
    latitude: 33.49929,
    longitude: -94.63931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75559',
  },
  {
    city: 'Douglassville',
    county_fips: 48067,
    county_fips_all: '48067',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"48067": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 33.1957,
    longitude: -94.36699,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75560',
  },
  {
    city: 'Hooks',
    county_fips: 48037,
    county_fips_all: '48037',
    county: 'Bowie',
    county_names_all: 'Bowie',
    county_weights: '{"48037": 100}',
    density: 41.7,
    imprecise: false,
    latitude: 33.517,
    longitude: -94.27855,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75561',
  },
  {
    city: 'Kildare',
    county_fips: 48067,
    county_fips_all: '48067',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"48067": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 32.93588,
    longitude: -94.25302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75562',
  },
  {
    city: 'Linden',
    county_fips: 48067,
    county_fips_all: '48067',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"48067": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 33.01835,
    longitude: -94.38871,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75563',
  },
  {
    city: 'Lodi',
    county_fips: 48067,
    county_fips_all: '48067',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"48067": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 32.88784,
    longitude: -94.24962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75564',
  },
  {
    city: 'McLeod',
    county_fips: 48067,
    county_fips_all: '48067',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"48067": 100}',
    density: 81.5,
    imprecise: false,
    latitude: 32.95202,
    longitude: -94.07527,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75565',
  },
  {
    city: 'Marietta',
    county_fips: 48067,
    county_fips_all: '48067',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"48067": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 33.15256,
    longitude: -94.49018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75566',
  },
  {
    city: 'Maud',
    county_fips: 48037,
    county_fips_all: '48037',
    county: 'Bowie',
    county_names_all: 'Bowie',
    county_weights: '{"48037": 100}',
    density: 19,
    imprecise: false,
    latitude: 33.31688,
    longitude: -94.31935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75567',
  },
  {
    city: 'Naples',
    county_fips: 48067,
    county_fips_all: '48067|48343',
    county: 'Cass',
    county_names_all: 'Cass|Morris',
    county_weights: '{"48067": 73.75, "48343": 26.25}',
    density: 7.9,
    imprecise: false,
    latitude: 33.19607,
    longitude: -94.59362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75568',
  },
  {
    city: 'Nash',
    county_fips: 48037,
    county_fips_all: '48037',
    county: 'Bowie',
    county_names_all: 'Bowie',
    county_weights: '{"48037": 100}',
    density: 582.3,
    imprecise: false,
    latitude: 33.44127,
    longitude: -94.12292,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75569',
  },
  {
    city: 'New Boston',
    county_fips: 48037,
    county_fips_all: '48037',
    county: 'Bowie',
    county_names_all: 'Bowie',
    county_weights: '{"48037": 100}',
    density: 33.1,
    imprecise: false,
    latitude: 33.4649,
    longitude: -94.4389,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75570',
  },
  {
    city: 'Omaha',
    county_fips: 48343,
    county_fips_all: '48343|48449',
    county: 'Morris',
    county_names_all: 'Morris|Titus',
    county_weights: '{"48343": 92.33, "48449": 7.67}',
    density: 9,
    imprecise: false,
    latitude: 33.20704,
    longitude: -94.76407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75571',
  },
  {
    city: 'Queen City',
    county_fips: 48067,
    county_fips_all: '48067',
    county: 'Cass',
    county_names_all: 'Cass',
    county_weights: '{"48067": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 33.23114,
    longitude: -94.12934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75572',
  },
  {
    city: 'Redwater',
    county_fips: 48037,
    county_fips_all: '48037',
    county: 'Bowie',
    county_names_all: 'Bowie',
    county_weights: '{"48037": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 33.34214,
    longitude: -94.22454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75573',
  },
  {
    city: 'Simms',
    county_fips: 48037,
    county_fips_all: '48037',
    county: 'Bowie',
    county_names_all: 'Bowie',
    county_weights: '{"48037": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 33.32892,
    longitude: -94.55229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75574',
  },
  {
    city: 'Longview',
    county_fips: 48183,
    county_fips_all: '48183|48203',
    county: 'Gregg',
    county_names_all: 'Gregg|Harrison',
    county_weights: '{"48183": 77.9, "48203": 22.1}',
    density: 667.9,
    imprecise: false,
    latitude: 32.5086,
    longitude: -94.72414,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75601',
  },
  {
    city: 'Longview',
    county_fips: 48203,
    county_fips_all: '48203|48183',
    county: 'Harrison',
    county_names_all: 'Harrison|Gregg',
    county_weights: '{"48203": 81.47, "48183": 18.53}',
    density: 153.9,
    imprecise: false,
    latitude: 32.45803,
    longitude: -94.65712,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75602',
  },
  {
    city: 'Longview',
    county_fips: 48183,
    county_fips_all: '48183|48401',
    county: 'Gregg',
    county_names_all: 'Gregg|Rusk',
    county_weights: '{"48183": 87.47, "48401": 12.53}',
    density: 44.1,
    imprecise: false,
    latitude: 32.40448,
    longitude: -94.71754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75603',
  },
  {
    city: 'Longview',
    county_fips: 48183,
    county_fips_all: '48183|48459',
    county: 'Gregg',
    county_names_all: 'Gregg|Upshur',
    county_weights: '{"48183": 97.93, "48459": 2.07}',
    density: 279.3,
    imprecise: false,
    latitude: 32.51374,
    longitude: -94.82919,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75604',
  },
  {
    city: 'Longview',
    county_fips: 48183,
    county_fips_all: '48183|48203|48459',
    county: 'Gregg',
    county_names_all: 'Gregg|Harrison|Upshur',
    county_weights: '{"48183": 58.32, "48203": 40.7, "48459": 0.98}',
    density: 170.3,
    imprecise: false,
    latitude: 32.58385,
    longitude: -94.71554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75605',
  },
  {
    city: 'Avinger',
    county_fips: 48067,
    county_fips_all: '48067|48315',
    county: 'Cass',
    county_names_all: 'Cass|Marion',
    county_weights: '{"48067": 50.82, "48315": 49.18}',
    density: 8.9,
    imprecise: false,
    latitude: 32.87588,
    longitude: -94.5572,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75630',
  },
  {
    city: 'Beckville',
    county_fips: 48365,
    county_fips_all: '48365',
    county: 'Panola',
    county_names_all: 'Panola',
    county_weights: '{"48365": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 32.25343,
    longitude: -94.44957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75631',
  },
  {
    city: 'Carthage',
    county_fips: 48365,
    county_fips_all: '48365',
    county: 'Panola',
    county_names_all: 'Panola',
    county_weights: '{"48365": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 32.12788,
    longitude: -94.28109,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75633',
  },
  {
    city: 'Daingerfield',
    county_fips: 48343,
    county_fips_all: '48343|48067',
    county: 'Morris',
    county_names_all: 'Morris|Cass',
    county_weights: '{"48343": 97.02, "48067": 2.98}',
    density: 23.5,
    imprecise: false,
    latitude: 33.01869,
    longitude: -94.73173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75638',
  },
  {
    city: 'De Berry',
    county_fips: 48365,
    county_fips_all: '48365',
    county: 'Panola',
    county_names_all: 'Panola',
    county_weights: '{"48365": 100}',
    density: 6,
    imprecise: false,
    latitude: 32.28441,
    longitude: -94.16897,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75639',
  },
  {
    city: 'Diana',
    county_fips: 48203,
    county_fips_all: '48203|48459|48315',
    county: 'Harrison',
    county_names_all: 'Harrison|Upshur|Marion',
    county_weights: '{"48203": 57.64, "48459": 36.35, "48315": 6.01}',
    density: 27.3,
    imprecise: false,
    latitude: 32.7152,
    longitude: -94.68133,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75640',
  },
  {
    city: 'Elysian Fields',
    county_fips: 48365,
    county_fips_all: '48365|48203',
    county: 'Panola',
    county_names_all: 'Panola|Harrison',
    county_weights: '{"48365": 65.65, "48203": 34.35}',
    density: 8.1,
    imprecise: false,
    latitude: 32.35818,
    longitude: -94.17821,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 86,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75642',
  },
  {
    city: 'Gary',
    county_fips: 48365,
    county_fips_all: '48365|48419',
    county: 'Panola',
    county_names_all: 'Panola|Shelby',
    county_weights: '{"48365": 87.09, "48419": 12.91}',
    density: 12,
    imprecise: false,
    latitude: 32.01041,
    longitude: -94.35518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75643',
  },
  {
    city: 'Gilmer',
    county_fips: 48459,
    county_fips_all: '48459',
    county: 'Upshur',
    county_names_all: 'Upshur',
    county_weights: '{"48459": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 32.79171,
    longitude: -94.99498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75644',
  },
  {
    city: 'Gilmer',
    county_fips: 48459,
    county_fips_all: '48459|48183',
    county: 'Upshur',
    county_names_all: 'Upshur|Gregg',
    county_weights: '{"48459": 97.84, "48183": 2.16}',
    density: 27.8,
    imprecise: false,
    latitude: 32.68375,
    longitude: -94.87317,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75645',
  },
  {
    city: 'Gladewater',
    county_fips: 48183,
    county_fips_all: '48183|48423|48459',
    county: 'Gregg',
    county_names_all: 'Gregg|Smith|Upshur',
    county_weights: '{"48183": 42.7, "48423": 31.9, "48459": 25.39}',
    density: 58,
    imprecise: false,
    latitude: 32.5167,
    longitude: -94.96429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75647',
  },
  {
    city: 'Hallsville',
    county_fips: 48203,
    county_fips_all: '48203',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"48203": 100}',
    density: 35.2,
    imprecise: false,
    latitude: 32.51529,
    longitude: -94.55358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75650',
  },
  {
    city: 'Harleton',
    county_fips: 48203,
    county_fips_all: '48203|48315',
    county: 'Harrison',
    county_names_all: 'Harrison|Marion',
    county_weights: '{"48203": 90.9, "48315": 9.1}',
    density: 13,
    imprecise: false,
    latitude: 32.67061,
    longitude: -94.53064,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75651',
  },
  {
    city: 'Henderson',
    county_fips: 48401,
    county_fips_all: '48401|48365',
    county: 'Rusk',
    county_names_all: 'Rusk|Panola',
    county_weights: '{"48401": 98.38, "48365": 1.62}',
    density: 34.3,
    imprecise: false,
    latitude: 32.2301,
    longitude: -94.7281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75652',
  },
  {
    city: 'Henderson',
    county_fips: 48401,
    county_fips_all: '48401|48073',
    county: 'Rusk',
    county_names_all: 'Rusk|Cherokee',
    county_weights: '{"48401": 98.94, "48073": 1.06}',
    density: 23.7,
    imprecise: false,
    latitude: 32.08299,
    longitude: -94.82961,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75654',
  },
  {
    city: 'Hughes Springs',
    county_fips: 48067,
    county_fips_all: '48067|48343',
    county: 'Cass',
    county_names_all: 'Cass|Morris',
    county_weights: '{"48067": 91.66, "48343": 8.34}',
    density: 17.5,
    imprecise: false,
    latitude: 33.01471,
    longitude: -94.58686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75656',
  },
  {
    city: 'Jefferson',
    county_fips: 48315,
    county_fips_all: '48315|48067|48203',
    county: 'Marion',
    county_names_all: 'Marion|Cass|Harrison',
    county_weights: '{"48315": 88.02, "48067": 7.17, "48203": 4.81}',
    density: 8.4,
    imprecise: false,
    latitude: 32.79437,
    longitude: -94.30498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75657',
  },
  {
    city: 'Joinerville',
    county_fips: 48401,
    county_fips_all: '48401',
    county: 'Rusk',
    county_names_all: 'Rusk',
    county_weights: '{"48401": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 32.17545,
    longitude: -94.90362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75658',
  },
  {
    city: 'Jonesville',
    county_fips: 48203,
    county_fips_all: '48203',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"48203": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 32.50725,
    longitude: -94.09249,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75659',
  },
  {
    city: 'Karnack',
    county_fips: 48203,
    county_fips_all: '48203',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"48203": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 32.63908,
    longitude: -94.15655,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75661',
  },
  {
    city: 'Kilgore',
    county_fips: 48183,
    county_fips_all: '48183|48401|48423',
    county: 'Gregg',
    county_names_all: 'Gregg|Rusk|Smith',
    county_weights: '{"48183": 52.8, "48401": 39.5, "48423": 7.7}',
    density: 76.2,
    imprecise: false,
    latitude: 32.38076,
    longitude: -94.87503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75662',
  },
  {
    city: 'Laneville',
    county_fips: 48401,
    county_fips_all: '48401',
    county: 'Rusk',
    county_names_all: 'Rusk',
    county_weights: '{"48401": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 31.988,
    longitude: -94.83729,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75667',
  },
  {
    city: 'Lone Star',
    county_fips: 48343,
    county_fips_all: '48343|48315',
    county: 'Morris',
    county_names_all: 'Morris|Marion',
    county_weights: '{"48343": 78.69, "48315": 21.31}',
    density: 38.5,
    imprecise: false,
    latitude: 32.90846,
    longitude: -94.68485,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75668',
  },
  {
    city: 'Long Branch',
    county_fips: 48365,
    county_fips_all: '48365|48401',
    county: 'Panola',
    county_names_all: 'Panola|Rusk',
    county_weights: '{"48365": 83.37, "48401": 16.63}',
    density: 7.3,
    imprecise: false,
    latitude: 32.03348,
    longitude: -94.55678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75669',
  },
  {
    city: 'Marshall',
    county_fips: 48203,
    county_fips_all: '48203',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"48203": 100}',
    density: 56.5,
    imprecise: false,
    latitude: 32.56456,
    longitude: -94.42326,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75670',
  },
  {
    city: 'Marshall',
    county_fips: 48203,
    county_fips_all: '48203',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"48203": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.48907,
    longitude: -94.31494,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75671',
  },
  {
    city: 'Marshall',
    county_fips: 48203,
    county_fips_all: '48203|48365',
    county: 'Harrison',
    county_names_all: 'Harrison|Panola',
    county_weights: '{"48203": 99.74, "48365": 0.26}',
    density: 27.5,
    imprecise: false,
    latitude: 32.47076,
    longitude: -94.29353,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75672',
  },
  {
    city: 'Minden',
    county_fips: 48401,
    county_fips_all: '48401',
    county: 'Rusk',
    county_names_all: 'Rusk',
    county_weights: '{"48401": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.01035,
    longitude: -94.71824,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75680',
  },
  {
    city: 'Mount Enterprise',
    county_fips: 48401,
    county_fips_all: '48401',
    county: 'Rusk',
    county_names_all: 'Rusk',
    county_weights: '{"48401": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 31.93597,
    longitude: -94.685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75681',
  },
  {
    city: 'New London',
    county_fips: 48401,
    county_fips_all: '48401',
    county: 'Rusk',
    county_names_all: 'Rusk',
    county_weights: '{"48401": 100}',
    density: 128.4,
    imprecise: false,
    latitude: 32.25152,
    longitude: -94.94713,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75682',
  },
  {
    city: 'Ore City',
    county_fips: 48459,
    county_fips_all: '48459|48315',
    county: 'Upshur',
    county_names_all: 'Upshur|Marion',
    county_weights: '{"48459": 80.68, "48315": 19.32}',
    density: 21.9,
    imprecise: false,
    latitude: 32.82182,
    longitude: -94.74035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75683',
  },
  {
    city: 'Overton',
    county_fips: 48401,
    county_fips_all: '48401|48423',
    county: 'Rusk',
    county_names_all: 'Rusk|Smith',
    county_weights: '{"48401": 82.69, "48423": 17.31}',
    density: 33.8,
    imprecise: false,
    latitude: 32.27085,
    longitude: -94.93147,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75684',
  },
  {
    city: 'Pittsburg',
    county_fips: 48063,
    county_fips_all: '48063|48459|48449|48343',
    county: 'Camp',
    county_names_all: 'Camp|Upshur|Titus|Morris',
    county_weights:
      '{"48063": 68.14, "48459": 17.72, "48449": 12.87, "48343": 1.27}',
    density: 23.6,
    imprecise: false,
    latitude: 32.96921,
    longitude: -94.94697,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75686',
  },
  {
    city: 'Price',
    county_fips: 48401,
    county_fips_all: '48401',
    county: 'Rusk',
    county_names_all: 'Rusk',
    county_weights: '{"48401": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.10575,
    longitude: -94.96352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75687',
  },
  {
    city: 'Selman City',
    county_fips: 48401,
    county_fips_all: '48401',
    county: 'Rusk',
    county_names_all: 'Rusk',
    county_weights: '{"48401": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 32.18196,
    longitude: -94.95771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 98,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75689',
  },
  {
    city: 'Tatum',
    county_fips: 48401,
    county_fips_all: '48401|48365',
    county: 'Rusk',
    county_names_all: 'Rusk|Panola',
    county_weights: '{"48401": 79.53, "48365": 20.47}',
    density: 16.8,
    imprecise: false,
    latitude: 32.31108,
    longitude: -94.55725,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75691',
  },
  {
    city: 'Waskom',
    county_fips: 48203,
    county_fips_all: '48203|48365',
    county: 'Harrison',
    county_names_all: 'Harrison|Panola',
    county_weights: '{"48203": 93.86, "48365": 6.14}',
    density: 21.6,
    imprecise: false,
    latitude: 32.4718,
    longitude: -94.11936,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75692',
  },
  {
    city: 'White Oak',
    county_fips: 48183,
    county_fips_all: '48183',
    county: 'Gregg',
    county_names_all: 'Gregg',
    county_weights: '{"48183": 100}',
    density: 222.7,
    imprecise: false,
    latitude: 32.53364,
    longitude: -94.86083,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75693',
  },
  {
    city: 'Woodlawn',
    county_fips: 48203,
    county_fips_all: '48203',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"48203": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.6383,
    longitude: -94.34442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75694',
  },
  {
    city: 'Tyler',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 997.5,
    imprecise: false,
    latitude: 32.32297,
    longitude: -95.29679,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75701',
  },
  {
    city: 'Tyler',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 764.8,
    imprecise: false,
    latitude: 32.36403,
    longitude: -95.31207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75702',
  },
  {
    city: 'Tyler',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 322.8,
    imprecise: false,
    latitude: 32.23825,
    longitude: -95.31947,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75703',
  },
  {
    city: 'Tyler',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 51.5,
    imprecise: false,
    latitude: 32.40616,
    longitude: -95.4407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75704',
  },
  {
    city: 'Tyler',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 25.6,
    imprecise: false,
    latitude: 32.35905,
    longitude: -95.10149,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75705',
  },
  {
    city: 'Tyler',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 48.9,
    imprecise: false,
    latitude: 32.46822,
    longitude: -95.30402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75706',
  },
  {
    city: 'Tyler',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 129.2,
    imprecise: false,
    latitude: 32.30479,
    longitude: -95.171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75707',
  },
  {
    city: 'Tyler',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 66.5,
    imprecise: false,
    latitude: 32.41436,
    longitude: -95.20717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75708',
  },
  {
    city: 'Tyler',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 111.5,
    imprecise: false,
    latitude: 32.31323,
    longitude: -95.38904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75709',
  },
  {
    city: 'Tyler',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 3340.9,
    imprecise: false,
    latitude: 32.33698,
    longitude: -95.28382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75711',
  },
  {
    city: 'Arp',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 24.8,
    imprecise: false,
    latitude: 32.27222,
    longitude: -95.07124,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75750',
  },
  {
    city: 'Athens',
    county_fips: 48213,
    county_fips_all: '48213|48001',
    county: 'Henderson',
    county_names_all: 'Henderson|Anderson',
    county_weights: '{"48213": 68.01, "48001": 31.99}',
    density: 39.9,
    imprecise: false,
    latitude: 32.07875,
    longitude: -95.91661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75751',
  },
  {
    city: 'Athens',
    county_fips: 48213,
    county_fips_all: '48213|48467|48001',
    county: 'Henderson',
    county_names_all: 'Henderson|Van Zandt|Anderson',
    county_weights: '{"48213": 89.66, "48467": 9.56, "48001": 0.78}',
    density: 19.3,
    imprecise: false,
    latitude: 32.24239,
    longitude: -95.80751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75752',
  },
  {
    city: 'Ben Wheeler',
    county_fips: 48467,
    county_fips_all: '48467',
    county: 'Van Zandt',
    county_names_all: 'Van Zandt',
    county_weights: '{"48467": 100}',
    density: 24,
    imprecise: false,
    latitude: 32.42431,
    longitude: -95.66462,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75754',
  },
  {
    city: 'Big Sandy',
    county_fips: 48459,
    county_fips_all: '48459|48499',
    county: 'Upshur',
    county_names_all: 'Upshur|Wood',
    county_weights: '{"48459": 95.29, "48499": 4.71}',
    density: 20,
    imprecise: false,
    latitude: 32.63236,
    longitude: -95.08662,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75755',
  },
  {
    city: 'Brownsboro',
    county_fips: 48213,
    county_fips_all: '48213|48467',
    county: 'Henderson',
    county_names_all: 'Henderson|Van Zandt',
    county_weights: '{"48213": 96.84, "48467": 3.16}',
    density: 23.1,
    imprecise: false,
    latitude: 32.30031,
    longitude: -95.59771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75756',
  },
  {
    city: 'Bullard',
    county_fips: 48073,
    county_fips_all: '48073|48423',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Smith',
    county_weights: '{"48073": 68.31, "48423": 31.69}',
    density: 64.2,
    imprecise: false,
    latitude: 32.11584,
    longitude: -95.34933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75757',
  },
  {
    city: 'Chandler',
    county_fips: 48213,
    county_fips_all: '48213|48467',
    county: 'Henderson',
    county_names_all: 'Henderson|Van Zandt',
    county_weights: '{"48213": 85.52, "48467": 14.48}',
    density: 86.9,
    imprecise: false,
    latitude: 32.27375,
    longitude: -95.50484,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75758',
  },
  {
    city: 'Cuney',
    county_fips: 48073,
    county_fips_all: '48073',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"48073": 100}',
    density: 29.4,
    imprecise: false,
    latitude: 32.03617,
    longitude: -95.41573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75759',
  },
  {
    city: 'Cushing',
    county_fips: 48347,
    county_fips_all: '48347|48401',
    county: 'Nacogdoches',
    county_names_all: 'Nacogdoches|Rusk',
    county_weights: '{"48347": 67.97, "48401": 32.03}',
    density: 7,
    imprecise: false,
    latitude: 31.80738,
    longitude: -94.85758,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75760',
  },
  {
    city: 'Flint',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 135.6,
    imprecise: false,
    latitude: 32.21926,
    longitude: -95.41218,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75762',
  },
  {
    city: 'Frankston',
    county_fips: 48001,
    county_fips_all: '48001|48213',
    county: 'Anderson',
    county_names_all: 'Anderson|Henderson',
    county_weights: '{"48001": 66.35, "48213": 33.65}',
    density: 22.3,
    imprecise: false,
    latitude: 32.04154,
    longitude: -95.52231,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75763',
  },
  {
    city: 'Gallatin',
    county_fips: 48073,
    county_fips_all: '48073',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"48073": 100}',
    density: 60.5,
    imprecise: false,
    latitude: 31.89522,
    longitude: -95.14369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75764',
  },
  {
    city: 'Hawkins',
    county_fips: 48499,
    county_fips_all: '48499|48459',
    county: 'Wood',
    county_names_all: 'Wood|Upshur',
    county_weights: '{"48499": 98.96, "48459": 1.04}',
    density: 32.5,
    imprecise: false,
    latitude: 32.64119,
    longitude: -95.2359,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75765',
  },
  {
    city: 'Jacksonville',
    county_fips: 48073,
    county_fips_all: '48073',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"48073": 100}',
    density: 31.4,
    imprecise: false,
    latitude: 31.94592,
    longitude: -95.25181,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75766',
  },
  {
    city: 'Larue',
    county_fips: 48213,
    county_fips_all: '48213',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"48213": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 32.14058,
    longitude: -95.64694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75770',
  },
  {
    city: 'Lindale',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 56.1,
    imprecise: false,
    latitude: 32.53542,
    longitude: -95.43006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75771',
  },
  {
    city: 'Mineola',
    county_fips: 48499,
    county_fips_all: '48499|48423',
    county: 'Wood',
    county_names_all: 'Wood|Smith',
    county_weights: '{"48499": 82.52, "48423": 17.48}',
    density: 31,
    imprecise: false,
    latitude: 32.67969,
    longitude: -95.44654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75773',
  },
  {
    city: 'Murchison',
    county_fips: 48213,
    county_fips_all: '48213|48467',
    county: 'Henderson',
    county_names_all: 'Henderson|Van Zandt',
    county_weights: '{"48213": 86.23, "48467": 13.77}',
    density: 23.1,
    imprecise: false,
    latitude: 32.30239,
    longitude: -95.71367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75778',
  },
  {
    city: 'Neches',
    county_fips: 48001,
    county_fips_all: '48001',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"48001": 100}',
    density: 30.5,
    imprecise: false,
    latitude: 31.86434,
    longitude: -95.48486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75779',
  },
  {
    city: 'New Summerfield',
    county_fips: 48073,
    county_fips_all: '48073',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"48073": 100}',
    density: 107.3,
    imprecise: false,
    latitude: 31.98905,
    longitude: -95.09122,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75780',
  },
  {
    city: 'Poynor',
    county_fips: 48213,
    county_fips_all: '48213',
    county: 'Henderson',
    county_names_all: 'Henderson',
    county_weights: '{"48213": 100}',
    density: 28.6,
    imprecise: false,
    latitude: 32.0693,
    longitude: -95.58777,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75782',
  },
  {
    city: 'Quitman',
    county_fips: 48499,
    county_fips_all: '48499',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"48499": 100}',
    density: 26.6,
    imprecise: false,
    latitude: 32.82227,
    longitude: -95.42386,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75783',
  },
  {
    city: 'Reklaw',
    county_fips: 48401,
    county_fips_all: '48401|48073',
    county: 'Rusk',
    county_names_all: 'Rusk|Cherokee',
    county_weights: '{"48401": 61.64, "48073": 38.36}',
    density: 5.9,
    imprecise: false,
    latitude: 31.87344,
    longitude: -94.96234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75784',
  },
  {
    city: 'Rusk',
    county_fips: 48073,
    county_fips_all: '48073',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"48073": 100}',
    density: 14.3,
    imprecise: false,
    latitude: 31.76641,
    longitude: -95.17446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75785',
  },
  {
    city: 'Sacul',
    county_fips: 48347,
    county_fips_all: '48347',
    county: 'Nacogdoches',
    county_names_all: 'Nacogdoches',
    county_weights: '{"48347": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 31.82252,
    longitude: -94.91617,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75788',
  },
  {
    city: 'Troup',
    county_fips: 48073,
    county_fips_all: '48073|48423|48401',
    county: 'Cherokee',
    county_names_all: 'Cherokee|Smith|Rusk',
    county_weights: '{"48073": 62.93, "48423": 36.55, "48401": 0.52}',
    density: 19,
    imprecise: false,
    latitude: 32.1126,
    longitude: -95.09405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75789',
  },
  {
    city: 'Van',
    county_fips: 48467,
    county_fips_all: '48467|48423',
    county: 'Van Zandt',
    county_names_all: 'Van Zandt|Smith',
    county_weights: '{"48467": 95.4, "48423": 4.6}',
    density: 41.4,
    imprecise: false,
    latitude: 32.52749,
    longitude: -95.64255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75790',
  },
  {
    city: 'Whitehouse',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 154.7,
    imprecise: false,
    latitude: 32.22214,
    longitude: -95.22103,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75791',
  },
  {
    city: 'Winona',
    county_fips: 48423,
    county_fips_all: '48423',
    county: 'Smith',
    county_names_all: 'Smith',
    county_weights: '{"48423": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 32.4679,
    longitude: -95.10623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75792',
  },
  {
    city: 'Palestine',
    county_fips: 48001,
    county_fips_all: '48001',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"48001": 100}',
    density: 35.9,
    imprecise: false,
    latitude: 31.74004,
    longitude: -95.55116,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75801',
  },
  {
    city: 'Palestine',
    county_fips: 48001,
    county_fips_all: '48001|48213',
    county: 'Anderson',
    county_names_all: 'Anderson|Henderson',
    county_weights: '{"48001": 99.65, "48213": 0.35}',
    density: 25.8,
    imprecise: false,
    latitude: 31.87513,
    longitude: -95.66704,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75803',
  },
  {
    city: 'Buffalo',
    county_fips: 48289,
    county_fips_all: '48289|48161',
    county: 'Leon',
    county_names_all: 'Leon|Freestone',
    county_weights: '{"48289": 70.19, "48161": 29.81}',
    density: 7.5,
    imprecise: false,
    latitude: 31.45745,
    longitude: -96.02275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75831',
  },
  {
    city: 'Centerville',
    county_fips: 48289,
    county_fips_all: '48289',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"48289": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 31.26304,
    longitude: -95.83999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75833',
  },
  {
    city: 'Crockett',
    county_fips: 48225,
    county_fips_all: '48225',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"48225": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 31.29758,
    longitude: -95.48834,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75835',
  },
  {
    city: 'Donie',
    county_fips: 48161,
    county_fips_all: '48161|48293',
    county: 'Freestone',
    county_names_all: 'Freestone|Limestone',
    county_weights: '{"48161": 88.9, "48293": 11.1}',
    density: 1.5,
    imprecise: false,
    latitude: 31.47956,
    longitude: -96.22844,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75838',
  },
  {
    city: 'Elkhart',
    county_fips: 48001,
    county_fips_all: '48001|48225',
    county: 'Anderson',
    county_names_all: 'Anderson|Houston',
    county_weights: '{"48001": 96.26, "48225": 3.74}',
    density: 15.5,
    imprecise: false,
    latitude: 31.6181,
    longitude: -95.55738,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75839',
  },
  {
    city: 'Fairfield',
    county_fips: 48161,
    county_fips_all: '48161',
    county: 'Freestone',
    county_names_all: 'Freestone',
    county_weights: '{"48161": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 31.78412,
    longitude: -96.08552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75840',
  },
  {
    city: 'Grapeland',
    county_fips: 48225,
    county_fips_all: '48225|48001',
    county: 'Houston',
    county_names_all: 'Houston|Anderson',
    county_weights: '{"48225": 82.23, "48001": 17.77}',
    density: 5.2,
    imprecise: false,
    latitude: 31.51921,
    longitude: -95.43481,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75844',
  },
  {
    city: 'Groveton',
    county_fips: 48455,
    county_fips_all: '48455',
    county: 'Trinity',
    county_names_all: 'Trinity',
    county_weights: '{"48455": 100}',
    density: 3,
    imprecise: false,
    latitude: 31.09488,
    longitude: -95.08707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75845',
  },
  {
    city: 'Jewett',
    county_fips: 48289,
    county_fips_all: '48289|48293',
    county: 'Leon',
    county_names_all: 'Leon|Limestone',
    county_weights: '{"48289": 79.33, "48293": 20.67}',
    density: 6.9,
    imprecise: false,
    latitude: 31.34683,
    longitude: -96.18118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75846',
  },
  {
    city: 'Kennard',
    county_fips: 48225,
    county_fips_all: '48225|48455',
    county: 'Houston',
    county_names_all: 'Houston|Trinity',
    county_weights: '{"48225": 86.91, "48455": 13.09}',
    density: 2.1,
    imprecise: false,
    latitude: 31.35204,
    longitude: -95.13564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75847',
  },
  {
    city: 'Kirvin',
    county_fips: 48161,
    county_fips_all: '48161',
    county: 'Freestone',
    county_names_all: 'Freestone',
    county_weights: '{"48161": 100}',
    density: 45.1,
    imprecise: false,
    latitude: 31.77281,
    longitude: -96.33408,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75848',
  },
  {
    city: 'Latexo',
    county_fips: 48225,
    county_fips_all: '48225',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"48225": 100}',
    density: 68.1,
    imprecise: false,
    latitude: 31.39624,
    longitude: -95.47618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75849',
  },
  {
    city: 'Leona',
    county_fips: 48289,
    county_fips_all: '48289',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"48289": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 31.13209,
    longitude: -95.91595,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75850',
  },
  {
    city: 'Lovelady',
    county_fips: 48225,
    county_fips_all: '48225|48455',
    county: 'Houston',
    county_names_all: 'Houston|Trinity',
    county_weights: '{"48225": 88.17, "48455": 11.83}',
    density: 6.3,
    imprecise: false,
    latitude: 31.09458,
    longitude: -95.49555,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75851',
  },
  {
    city: 'Midway',
    county_fips: 48313,
    county_fips_all: '48313|48471',
    county: 'Madison',
    county_names_all: 'Madison|Walker',
    county_weights: '{"48313": 77.6, "48471": 22.4}',
    density: 8.7,
    imprecise: false,
    latitude: 30.98723,
    longitude: -95.72023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75852',
  },
  {
    city: 'Montalba',
    county_fips: 48001,
    county_fips_all: '48001|48213',
    county: 'Anderson',
    county_names_all: 'Anderson|Henderson',
    county_weights: '{"48001": 97.81, "48213": 2.19}',
    density: 5.3,
    imprecise: false,
    latitude: 31.93488,
    longitude: -95.80963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75853',
  },
  {
    city: 'Oakwood',
    county_fips: 48289,
    county_fips_all: '48289|48161',
    county: 'Leon',
    county_names_all: 'Leon|Freestone',
    county_weights: '{"48289": 57.9, "48161": 42.1}',
    density: 3.6,
    imprecise: false,
    latitude: 31.5592,
    longitude: -95.85447,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75855',
  },
  {
    city: 'Pennington',
    county_fips: 48225,
    county_fips_all: '48225|48455',
    county: 'Houston',
    county_names_all: 'Houston|Trinity',
    county_weights: '{"48225": 71.01, "48455": 28.99}',
    density: 1,
    imprecise: false,
    latitude: 31.20138,
    longitude: -95.2537,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75856',
  },
  {
    city: 'Ratcliff',
    county_fips: 48225,
    county_fips_all: '48225',
    county: 'Houston',
    county_names_all: 'Houston',
    county_weights: '{"48225": 100}',
    density: 10,
    imprecise: false,
    latitude: 31.38083,
    longitude: -95.13676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75858',
  },
  {
    city: 'Streetman',
    county_fips: 48161,
    county_fips_all: '48161|48349',
    county: 'Freestone',
    county_names_all: 'Freestone|Navarro',
    county_weights: '{"48161": 68.61, "48349": 31.39}',
    density: 6.8,
    imprecise: false,
    latitude: 31.8842,
    longitude: -96.25512,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75859',
  },
  {
    city: 'Teague',
    county_fips: 48161,
    county_fips_all: '48161',
    county: 'Freestone',
    county_names_all: 'Freestone',
    county_weights: '{"48161": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 31.62342,
    longitude: -96.24615,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75860',
  },
  {
    city: 'Tennessee Colony',
    county_fips: 48001,
    county_fips_all: '48001',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"48001": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 31.8524,
    longitude: -95.88771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75861',
  },
  {
    city: 'Trinity',
    county_fips: 48455,
    county_fips_all: '48455|48471',
    county: 'Trinity',
    county_names_all: 'Trinity|Walker',
    county_weights: '{"48455": 79.94, "48471": 20.06}',
    density: 15.9,
    imprecise: false,
    latitude: 30.96193,
    longitude: -95.32951,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75862',
  },
  {
    city: 'Woodlake',
    county_fips: 48455,
    county_fips_all: '48455',
    county: 'Trinity',
    county_names_all: 'Trinity',
    county_weights: '{"48455": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.05808,
    longitude: -94.96228,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75865',
  },
  {
    city: 'Lufkin',
    county_fips: 48005,
    county_fips_all: '48005',
    county: 'Angelina',
    county_names_all: 'Angelina',
    county_weights: '{"48005": 100}',
    density: 68.5,
    imprecise: false,
    latitude: 31.30264,
    longitude: -94.65481,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75901',
  },
  {
    city: 'Lufkin',
    county_fips: 48005,
    county_fips_all: '48005',
    county: 'Angelina',
    county_names_all: 'Angelina',
    county_weights: '{"48005": 100}',
    density: 91.6,
    imprecise: false,
    latitude: 31.37428,
    longitude: -94.74796,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75903',
  },
  {
    city: 'Lufkin',
    county_fips: 48005,
    county_fips_all: '48005|48455',
    county: 'Angelina',
    county_names_all: 'Angelina|Trinity',
    county_weights: '{"48005": 85.07, "48455": 14.93}',
    density: 82.9,
    imprecise: false,
    latitude: 31.33872,
    longitude: -94.83467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75904',
  },
  {
    city: 'Alto',
    county_fips: 48073,
    county_fips_all: '48073',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"48073": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 31.61018,
    longitude: -95.05327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75925',
  },
  {
    city: 'Apple Springs',
    county_fips: 48455,
    county_fips_all: '48455',
    county: 'Trinity',
    county_names_all: 'Trinity',
    county_weights: '{"48455": 100}',
    density: 6,
    imprecise: false,
    latitude: 31.23281,
    longitude: -94.96944,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75926',
  },
  {
    city: 'Bon Wier',
    county_fips: 48351,
    county_fips_all: '48351',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"48351": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 30.67111,
    longitude: -93.7064,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75928',
  },
  {
    city: 'Broaddus',
    county_fips: 48405,
    county_fips_all: '48405',
    county: 'San Augustine',
    county_names_all: 'San Augustine',
    county_weights: '{"48405": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 31.23579,
    longitude: -94.19735,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75929',
  },
  {
    city: 'Bronson',
    county_fips: 48405,
    county_fips_all: '48405|48403',
    county: 'San Augustine',
    county_names_all: 'San Augustine|Sabine',
    county_weights: '{"48405": 59.39, "48403": 40.61}',
    density: 5.6,
    imprecise: false,
    latitude: 31.33641,
    longitude: -94.03522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75930',
  },
  {
    city: 'Brookeland',
    county_fips: 48241,
    county_fips_all: '48241|48403',
    county: 'Jasper',
    county_names_all: 'Jasper|Sabine',
    county_weights: '{"48241": 78.55, "48403": 21.45}',
    density: 10.2,
    imprecise: false,
    latitude: 31.09978,
    longitude: -93.98953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75931',
  },
  {
    city: 'Burkeville',
    county_fips: 48351,
    county_fips_all: '48351',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"48351": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 31.0551,
    longitude: -93.61396,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75932',
  },
  {
    city: 'Call',
    county_fips: 48351,
    county_fips_all: '48351|48241',
    county: 'Newton',
    county_names_all: 'Newton|Jasper',
    county_weights: '{"48351": 91.67, "48241": 8.33}',
    density: 6.4,
    imprecise: false,
    latitude: 30.55314,
    longitude: -93.81608,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75933',
  },
  {
    city: 'Camden',
    county_fips: 48373,
    county_fips_all: '48373',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"48373": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 30.89688,
    longitude: -94.75153,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75934',
  },
  {
    city: 'Center',
    county_fips: 48419,
    county_fips_all: '48419|48405',
    county: 'Shelby',
    county_names_all: 'Shelby|San Augustine',
    county_weights: '{"48419": 89.38, "48405": 10.62}',
    density: 13.7,
    imprecise: false,
    latitude: 31.72999,
    longitude: -94.20077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75935',
  },
  {
    city: 'Chester',
    county_fips: 48457,
    county_fips_all: '48457|48373',
    county: 'Tyler',
    county_names_all: 'Tyler|Polk',
    county_weights: '{"48457": 82.24, "48373": 17.76}',
    density: 2.3,
    imprecise: false,
    latitude: 30.95147,
    longitude: -94.58883,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75936',
  },
  {
    city: 'Chireno',
    county_fips: 48347,
    county_fips_all: '48347',
    county: 'Nacogdoches',
    county_names_all: 'Nacogdoches',
    county_weights: '{"48347": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 31.47805,
    longitude: -94.38259,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75937',
  },
  {
    city: 'Colmesneil',
    county_fips: 48457,
    county_fips_all: '48457',
    county: 'Tyler',
    county_names_all: 'Tyler',
    county_weights: '{"48457": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 30.93436,
    longitude: -94.35605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75938',
  },
  {
    city: 'Corrigan',
    county_fips: 48373,
    county_fips_all: '48373',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"48373": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 31.01496,
    longitude: -94.80501,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75939',
  },
  {
    city: 'Diboll',
    county_fips: 48005,
    county_fips_all: '48005',
    county: 'Angelina',
    county_names_all: 'Angelina',
    county_weights: '{"48005": 100}',
    density: 37.5,
    imprecise: false,
    latitude: 31.18078,
    longitude: -94.76219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75941',
  },
  {
    city: 'Doucette',
    county_fips: 48457,
    county_fips_all: '48457',
    county: 'Tyler',
    county_names_all: 'Tyler',
    county_weights: '{"48457": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.82567,
    longitude: -94.41657,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75942',
  },
  {
    city: 'Douglass',
    county_fips: 48347,
    county_fips_all: '48347',
    county: 'Nacogdoches',
    county_names_all: 'Nacogdoches',
    county_weights: '{"48347": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 31.65451,
    longitude: -94.88935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75943',
  },
  {
    city: 'Etoile',
    county_fips: 48347,
    county_fips_all: '48347',
    county: 'Nacogdoches',
    county_names_all: 'Nacogdoches',
    county_weights: '{"48347": 100}',
    density: 6,
    imprecise: false,
    latitude: 31.34514,
    longitude: -94.38636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75944',
  },
  {
    city: 'Garrison',
    county_fips: 48347,
    county_fips_all: '48347|48401',
    county: 'Nacogdoches',
    county_names_all: 'Nacogdoches|Rusk',
    county_weights: '{"48347": 68.34, "48401": 31.66}',
    density: 11.8,
    imprecise: false,
    latitude: 31.81372,
    longitude: -94.52392,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75946',
  },
  {
    city: 'Hemphill',
    county_fips: 48403,
    county_fips_all: '48403|48351',
    county: 'Sabine',
    county_names_all: 'Sabine|Newton',
    county_weights: '{"48403": 96.85, "48351": 3.15}',
    density: 8.8,
    imprecise: false,
    latitude: 31.29389,
    longitude: -93.77573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75948',
  },
  {
    city: 'Huntington',
    county_fips: 48005,
    county_fips_all: '48005',
    county: 'Angelina',
    county_names_all: 'Angelina',
    county_weights: '{"48005": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 31.22907,
    longitude: -94.51782,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75949',
  },
  {
    city: 'Jasper',
    county_fips: 48241,
    county_fips_all: '48241|48351',
    county: 'Jasper',
    county_names_all: 'Jasper|Newton',
    county_weights: '{"48241": 99.49, "48351": 0.51}',
    density: 15.7,
    imprecise: false,
    latitude: 30.93098,
    longitude: -94.05762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75951',
  },
  {
    city: 'Joaquin',
    county_fips: 48419,
    county_fips_all: '48419|48365',
    county: 'Shelby',
    county_names_all: 'Shelby|Panola',
    county_weights: '{"48419": 88.79, "48365": 11.21}',
    density: 13,
    imprecise: false,
    latitude: 31.92169,
    longitude: -94.05523,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75954',
  },
  {
    city: 'Kirbyville',
    county_fips: 48241,
    county_fips_all: '48241|48351',
    county: 'Jasper',
    county_names_all: 'Jasper|Newton',
    county_weights: '{"48241": 88.21, "48351": 11.79}',
    density: 11.1,
    imprecise: false,
    latitude: 30.6721,
    longitude: -93.96706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75956',
  },
  {
    city: 'Milam',
    county_fips: 48403,
    county_fips_all: '48403',
    county: 'Sabine',
    county_names_all: 'Sabine',
    county_weights: '{"48403": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 31.51021,
    longitude: -93.83994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75959',
  },
  {
    city: 'Moscow',
    county_fips: 48373,
    county_fips_all: '48373',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"48373": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 30.90372,
    longitude: -94.8618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75960',
  },
  {
    city: 'Nacogdoches',
    county_fips: 48347,
    county_fips_all: '48347',
    county: 'Nacogdoches',
    county_names_all: 'Nacogdoches',
    county_weights: '{"48347": 100}',
    density: 21,
    imprecise: false,
    latitude: 31.5576,
    longitude: -94.51098,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75961',
  },
  {
    city: 'Nacogdoches',
    county_fips: 48347,
    county_fips_all: '48347',
    county: 'Nacogdoches',
    county_names_all: 'Nacogdoches',
    county_weights: '{"48347": 100}',
    density: 35.5,
    imprecise: false,
    latitude: 31.63334,
    longitude: -94.75057,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75964',
  },
  {
    city: 'Nacogdoches',
    county_fips: 48347,
    county_fips_all: '48347',
    county: 'Nacogdoches',
    county_names_all: 'Nacogdoches',
    county_weights: '{"48347": 100}',
    density: 91.4,
    imprecise: false,
    latitude: 31.7284,
    longitude: -94.62629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75965',
  },
  {
    city: 'Newton',
    county_fips: 48351,
    county_fips_all: '48351|48241',
    county: 'Newton',
    county_names_all: 'Newton|Jasper',
    county_weights: '{"48351": 98.86, "48241": 1.14}',
    density: 7.2,
    imprecise: false,
    latitude: 30.83783,
    longitude: -93.72611,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75966',
  },
  {
    city: 'Pineland',
    county_fips: 48403,
    county_fips_all: '48403',
    county: 'Sabine',
    county_names_all: 'Sabine',
    county_weights: '{"48403": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 31.25882,
    longitude: -93.95924,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75968',
  },
  {
    city: 'Pollok',
    county_fips: 48005,
    county_fips_all: '48005|48073',
    county: 'Angelina',
    county_names_all: 'Angelina|Cherokee',
    county_weights: '{"48005": 85.57, "48073": 14.43}',
    density: 20.9,
    imprecise: false,
    latitude: 31.44765,
    longitude: -94.89758,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75969',
  },
  {
    city: 'San Augustine',
    county_fips: 48405,
    county_fips_all: '48405|48403|48419',
    county: 'San Augustine',
    county_names_all: 'San Augustine|Sabine|Shelby',
    county_weights: '{"48405": 78.89, "48403": 17.31, "48419": 3.8}',
    density: 6.1,
    imprecise: false,
    latitude: 31.49407,
    longitude: -94.12173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75972',
  },
  {
    city: 'Shelbyville',
    county_fips: 48419,
    county_fips_all: '48419',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"48419": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 31.71977,
    longitude: -93.93259,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75973',
  },
  {
    city: 'Tenaha',
    county_fips: 48419,
    county_fips_all: '48419|48365',
    county: 'Shelby',
    county_names_all: 'Shelby|Panola',
    county_weights: '{"48419": 59.36, "48365": 40.64}',
    density: 9.9,
    imprecise: false,
    latitude: 31.95674,
    longitude: -94.23713,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75974',
  },
  {
    city: 'Timpson',
    county_fips: 48419,
    county_fips_all: '48419|48365|48401',
    county: 'Shelby',
    county_names_all: 'Shelby|Panola|Rusk',
    county_weights: '{"48419": 87.42, "48365": 6.76, "48401": 5.82}',
    density: 10.2,
    imprecise: false,
    latitude: 31.89535,
    longitude: -94.4122,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75975',
  },
  {
    city: 'Wells',
    county_fips: 48073,
    county_fips_all: '48073',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"48073": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 31.51546,
    longitude: -94.93863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75976',
  },
  {
    city: 'Wiergate',
    county_fips: 48351,
    county_fips_all: '48351',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"48351": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 31.05997,
    longitude: -93.78455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75977',
  },
  {
    city: 'Woodville',
    county_fips: 48457,
    county_fips_all: '48457',
    county: 'Tyler',
    county_names_all: 'Tyler',
    county_weights: '{"48457": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 30.77477,
    longitude: -94.4026,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75979',
  },
  {
    city: 'Zavalla',
    county_fips: 48005,
    county_fips_all: '48005|48241',
    county: 'Angelina',
    county_names_all: 'Angelina|Jasper',
    county_weights: '{"48005": 90.63, "48241": 9.37}',
    density: 6.3,
    imprecise: false,
    latitude: 31.12387,
    longitude: -94.34703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75980',
  },
  {
    city: 'Arlington',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1407.1,
    imprecise: false,
    latitude: 32.63076,
    longitude: -97.15408,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76001',
  },
  {
    city: 'Arlington',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1909.4,
    imprecise: false,
    latitude: 32.62233,
    longitude: -97.09265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76002',
  },
  {
    city: 'Arlington',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 819.6,
    imprecise: false,
    latitude: 32.80057,
    longitude: -97.08001,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76005',
  },
  {
    city: 'Arlington',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1184.7,
    imprecise: false,
    latitude: 32.78511,
    longitude: -97.10019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76006',
  },
  {
    city: 'Aledo',
    county_fips: 48367,
    county_fips_all: '48367|48439',
    county: 'Parker',
    county_names_all: 'Parker|Tarrant',
    county_weights: '{"48367": 92.87, "48439": 7.13}',
    density: 119.3,
    imprecise: false,
    latitude: 32.68182,
    longitude: -97.62738,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76008',
  },
  {
    city: 'Alvarado',
    county_fips: 48251,
    county_fips_all: '48251',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"48251": 100}',
    density: 89.8,
    imprecise: false,
    latitude: 32.41635,
    longitude: -97.20115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76009',
  },
  {
    city: 'Arlington',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 2409.5,
    imprecise: false,
    latitude: 32.72271,
    longitude: -97.08065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76010',
  },
  {
    city: 'Arlington',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1080.2,
    imprecise: false,
    latitude: 32.7543,
    longitude: -97.08223,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76011',
  },
  {
    city: 'Arlington',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1318.3,
    imprecise: false,
    latitude: 32.75459,
    longitude: -97.13901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76012',
  },
  {
    city: 'Arlington',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1536.3,
    imprecise: false,
    latitude: 32.72027,
    longitude: -97.15652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76013',
  },
  {
    city: 'Arlington',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 2209.1,
    imprecise: false,
    latitude: 32.69201,
    longitude: -97.08814,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76014',
  },
  {
    city: 'Arlington',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1641.5,
    imprecise: false,
    latitude: 32.69204,
    longitude: -97.13341,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76015',
  },
  {
    city: 'Arlington',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1365.2,
    imprecise: false,
    latitude: 32.68907,
    longitude: -97.18868,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76016',
  },
  {
    city: 'Arlington',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1780.8,
    imprecise: false,
    latitude: 32.66223,
    longitude: -97.16237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76017',
  },
  {
    city: 'Arlington',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1319.4,
    imprecise: false,
    latitude: 32.66074,
    longitude: -97.08967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76018',
  },
  {
    city: 'Azle',
    county_fips: 48367,
    county_fips_all: '48367|48439|48497',
    county: 'Parker',
    county_names_all: 'Parker|Tarrant|Wise',
    county_weights: '{"48367": 62.48, "48439": 33.62, "48497": 3.9}',
    density: 205.8,
    imprecise: false,
    latitude: 32.90102,
    longitude: -97.56483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76020',
  },
  {
    city: 'Bedford',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1881.3,
    imprecise: false,
    latitude: 32.8523,
    longitude: -97.13128,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76021',
  },
  {
    city: 'Bedford',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1969.5,
    imprecise: false,
    latitude: 32.83063,
    longitude: -97.14506,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76022',
  },
  {
    city: 'Boyd',
    county_fips: 48497,
    county_fips_all: '48497|48367',
    county: 'Wise',
    county_names_all: 'Wise|Parker',
    county_weights: '{"48497": 97.17, "48367": 2.83}',
    density: 54.1,
    imprecise: false,
    latitude: 33.04777,
    longitude: -97.60425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76023',
  },
  {
    city: 'Burleson',
    county_fips: 48251,
    county_fips_all: '48251|48439',
    county: 'Johnson',
    county_names_all: 'Johnson|Tarrant',
    county_weights: '{"48251": 77.06, "48439": 22.94}',
    density: 406.5,
    imprecise: false,
    latitude: 32.52603,
    longitude: -97.30491,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 81549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76028',
  },
  {
    city: 'Cleburne',
    county_fips: 48251,
    county_fips_all: '48251',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"48251": 100}',
    density: 100.5,
    imprecise: false,
    latitude: 32.34873,
    longitude: -97.33267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76031',
  },
  {
    city: 'Cleburne',
    county_fips: 48251,
    county_fips_all: '48251|48221|48425',
    county: 'Johnson',
    county_names_all: 'Johnson|Hood|Somervell',
    county_weights: '{"48251": 85.62, "48221": 7.25, "48425": 7.12}',
    density: 64.8,
    imprecise: false,
    latitude: 32.28663,
    longitude: -97.52075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76033',
  },
  {
    city: 'Colleyville',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 771.2,
    imprecise: false,
    latitude: 32.89121,
    longitude: -97.1488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76034',
  },
  {
    city: 'Cresson',
    county_fips: 48367,
    county_fips_all: '48367|48221|48251',
    county: 'Parker',
    county_names_all: 'Parker|Hood|Johnson',
    county_weights: '{"48367": 59.1, "48221": 21.67, "48251": 19.23}',
    density: 18.9,
    imprecise: false,
    latitude: 32.56172,
    longitude: -97.64251,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76035',
  },
  {
    city: 'Crowley',
    county_fips: 48439,
    county_fips_all: '48439|48251',
    county: 'Tarrant',
    county_names_all: 'Tarrant|Johnson',
    county_weights: '{"48439": 77.98, "48251": 22.02}',
    density: 315.8,
    imprecise: false,
    latitude: 32.57366,
    longitude: -97.41434,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76036',
  },
  {
    city: 'Euless',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 2403.4,
    imprecise: false,
    latitude: 32.8592,
    longitude: -97.08422,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76039',
  },
  {
    city: 'Euless',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1559.6,
    imprecise: false,
    latitude: 32.82133,
    longitude: -97.10488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76040',
  },
  {
    city: 'Forreston',
    county_fips: 48139,
    county_fips_all: '48139',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"48139": 100}',
    density: 24.3,
    imprecise: false,
    latitude: 32.23911,
    longitude: -96.85724,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76041',
  },
  {
    city: 'Glen Rose',
    county_fips: 48425,
    county_fips_all: '48425|48035',
    county: 'Somervell',
    county_names_all: 'Somervell|Bosque',
    county_weights: '{"48425": 81.82, "48035": 18.18}',
    density: 24,
    imprecise: false,
    latitude: 32.20039,
    longitude: -97.76129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76043',
  },
  {
    city: 'Godley',
    county_fips: 48251,
    county_fips_all: '48251',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"48251": 100}',
    density: 32.8,
    imprecise: false,
    latitude: 32.42961,
    longitude: -97.54286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76044',
  },
  {
    city: 'Granbury',
    county_fips: 48221,
    county_fips_all: '48221|48425',
    county: 'Hood',
    county_names_all: 'Hood|Somervell',
    county_weights: '{"48221": 91.76, "48425": 8.24}',
    density: 102.5,
    imprecise: false,
    latitude: 32.40791,
    longitude: -97.80117,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76048',
  },
  {
    city: 'Granbury',
    county_fips: 48221,
    county_fips_all: '48221|48367|48251',
    county: 'Hood',
    county_names_all: 'Hood|Parker|Johnson',
    county_weights: '{"48221": 98.06, "48367": 1.14, "48251": 0.8}',
    density: 113.6,
    imprecise: false,
    latitude: 32.46759,
    longitude: -97.70645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76049',
  },
  {
    city: 'Grandview',
    county_fips: 48251,
    county_fips_all: '48251|48217|48139',
    county: 'Johnson',
    county_names_all: 'Johnson|Hill|Ellis',
    county_weights: '{"48251": 63.66, "48217": 18.28, "48139": 18.06}',
    density: 20.2,
    imprecise: false,
    latitude: 32.27262,
    longitude: -97.16326,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76050',
  },
  {
    city: 'Grapevine',
    county_fips: 48439,
    county_fips_all: '48439|48113',
    county: 'Tarrant',
    county_names_all: 'Tarrant|Dallas',
    county_weights: '{"48439": 98.58, "48113": 1.42}',
    density: 876.8,
    imprecise: false,
    latitude: 32.94192,
    longitude: -97.07888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76051',
  },
  {
    city: 'Haslet',
    county_fips: 48439,
    county_fips_all: '48439|48121|48497',
    county: 'Tarrant',
    county_names_all: 'Tarrant|Denton|Wise',
    county_weights: '{"48439": 57.29, "48121": 23.64, "48497": 19.07}',
    density: 319,
    imprecise: false,
    latitude: 32.98205,
    longitude: -97.38037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76052',
  },
  {
    city: 'Hurst',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1531.8,
    imprecise: false,
    latitude: 32.81683,
    longitude: -97.17898,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76053',
  },
  {
    city: 'Hurst',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1191.7,
    imprecise: false,
    latitude: 32.85904,
    longitude: -97.17789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76054',
  },
  {
    city: 'Itasca',
    county_fips: 48217,
    county_fips_all: '48217',
    county: 'Hill',
    county_names_all: 'Hill',
    county_weights: '{"48217": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 32.1596,
    longitude: -97.14812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76055',
  },
  {
    city: 'Joshua',
    county_fips: 48251,
    county_fips_all: '48251',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"48251": 100}',
    density: 165.6,
    imprecise: false,
    latitude: 32.47072,
    longitude: -97.4251,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76058',
  },
  {
    city: 'Keene',
    county_fips: 48251,
    county_fips_all: '48251',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"48251": 100}',
    density: 871.3,
    imprecise: false,
    latitude: 32.3921,
    longitude: -97.32897,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76059',
  },
  {
    city: 'Kennedale',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 487.9,
    imprecise: false,
    latitude: 32.63987,
    longitude: -97.2161,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76060',
  },
  {
    city: 'Lillian',
    county_fips: 48251,
    county_fips_all: '48251',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"48251": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 32.5026,
    longitude: -97.19813,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76061',
  },
  {
    city: 'Mansfield',
    county_fips: 48439,
    county_fips_all: '48439|48251|48139',
    county: 'Tarrant',
    county_names_all: 'Tarrant|Johnson|Ellis',
    county_weights: '{"48439": 74.34, "48251": 24.61, "48139": 1.05}',
    density: 637.6,
    imprecise: false,
    latitude: 32.56913,
    longitude: -97.14376,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 82625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76063',
  },
  {
    city: 'Maypearl',
    county_fips: 48139,
    county_fips_all: '48139',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"48139": 100}',
    density: 44.7,
    imprecise: false,
    latitude: 32.30757,
    longitude: -97.03225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76064',
  },
  {
    city: 'Midlothian',
    county_fips: 48139,
    county_fips_all: '48139|48113',
    county: 'Ellis',
    county_names_all: 'Ellis|Dallas',
    county_weights: '{"48139": 99.8, "48113": 0.2}',
    density: 181.5,
    imprecise: false,
    latitude: 32.47042,
    longitude: -96.98861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76065',
  },
  {
    city: 'Millsap',
    county_fips: 48367,
    county_fips_all: '48367|48363',
    county: 'Parker',
    county_names_all: 'Parker|Palo Pinto',
    county_weights: '{"48367": 97.61, "48363": 2.39}',
    density: 25.7,
    imprecise: false,
    latitude: 32.7058,
    longitude: -97.99913,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76066',
  },
  {
    city: 'Mineral Wells',
    county_fips: 48363,
    county_fips_all: '48363|48367',
    county: 'Palo Pinto',
    county_names_all: 'Palo Pinto|Parker',
    county_weights: '{"48363": 90.78, "48367": 9.22}',
    density: 41.2,
    imprecise: false,
    latitude: 32.80303,
    longitude: -98.1449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76067',
  },
  {
    city: 'Nemo',
    county_fips: 48425,
    county_fips_all: '48425|48251',
    county: 'Somervell',
    county_names_all: 'Somervell|Johnson',
    county_weights: '{"48425": 90.18, "48251": 9.82}',
    density: 19.9,
    imprecise: false,
    latitude: 32.24291,
    longitude: -97.64991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76070',
  },
  {
    city: 'Newark',
    county_fips: 48497,
    county_fips_all: '48497|48439',
    county: 'Wise',
    county_names_all: 'Wise|Tarrant',
    county_weights: '{"48497": 95.08, "48439": 4.92}',
    density: 224.7,
    imprecise: false,
    latitude: 33.00613,
    longitude: -97.47821,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76071',
  },
  {
    city: 'Paradise',
    county_fips: 48497,
    county_fips_all: '48497',
    county: 'Wise',
    county_names_all: 'Wise',
    county_weights: '{"48497": 100}',
    density: 35.2,
    imprecise: false,
    latitude: 33.10416,
    longitude: -97.72571,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76073',
  },
  {
    city: 'Rainbow',
    county_fips: 48425,
    county_fips_all: '48425',
    county: 'Somervell',
    county_names_all: 'Somervell',
    county_weights: '{"48425": 100}',
    density: 41.8,
    imprecise: false,
    latitude: 32.27886,
    longitude: -97.70891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76077',
  },
  {
    city: 'Rhome',
    county_fips: 48497,
    county_fips_all: '48497|48121',
    county: 'Wise',
    county_names_all: 'Wise|Denton',
    county_weights: '{"48497": 99.61, "48121": 0.39}',
    density: 65.1,
    imprecise: false,
    latitude: 33.0896,
    longitude: -97.46647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76078',
  },
  {
    city: 'Springtown',
    county_fips: 48367,
    county_fips_all: '48367|48497',
    county: 'Parker',
    county_names_all: 'Parker|Wise',
    county_weights: '{"48367": 73.79, "48497": 26.21}',
    density: 93.5,
    imprecise: false,
    latitude: 32.97098,
    longitude: -97.71783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76082',
  },
  {
    city: 'Venus',
    county_fips: 48251,
    county_fips_all: '48251|48139',
    county: 'Johnson',
    county_names_all: 'Johnson|Ellis',
    county_weights: '{"48251": 52.2, "48139": 47.8}',
    density: 105,
    imprecise: false,
    latitude: 32.43258,
    longitude: -97.0888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76084',
  },
  {
    city: 'Weatherford',
    county_fips: 48367,
    county_fips_all: '48367',
    county: 'Parker',
    county_names_all: 'Parker',
    county_weights: '{"48367": 100}',
    density: 73,
    imprecise: false,
    latitude: 32.84907,
    longitude: -97.70051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76085',
  },
  {
    city: 'Weatherford',
    county_fips: 48367,
    county_fips_all: '48367',
    county: 'Parker',
    county_names_all: 'Parker',
    county_weights: '{"48367": 100}',
    density: 650.9,
    imprecise: false,
    latitude: 32.75345,
    longitude: -97.78909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76086',
  },
  {
    city: 'Weatherford',
    county_fips: 48367,
    county_fips_all: '48367|48221',
    county: 'Parker',
    county_names_all: 'Parker|Hood',
    county_weights: '{"48367": 95.19, "48221": 4.81}',
    density: 76.6,
    imprecise: false,
    latitude: 32.66995,
    longitude: -97.79065,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76087',
  },
  {
    city: 'Weatherford',
    county_fips: 48367,
    county_fips_all: '48367',
    county: 'Parker',
    county_names_all: 'Parker',
    county_weights: '{"48367": 100}',
    density: 36.5,
    imprecise: false,
    latitude: 32.84554,
    longitude: -97.90345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76088',
  },
  {
    city: 'Southlake',
    county_fips: 48439,
    county_fips_all: '48439|48121',
    county: 'Tarrant',
    county_names_all: 'Tarrant|Denton',
    county_weights: '{"48439": 90.68, "48121": 9.32}',
    density: 537.1,
    imprecise: false,
    latitude: 32.95562,
    longitude: -97.14879,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76092',
  },
  {
    city: 'Rio Vista',
    county_fips: 48251,
    county_fips_all: '48251|48217',
    county: 'Johnson',
    county_names_all: 'Johnson|Hill',
    county_weights: '{"48251": 80.11, "48217": 19.89}',
    density: 47.4,
    imprecise: false,
    latitude: 32.21459,
    longitude: -97.40098,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76093',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1018.5,
    imprecise: false,
    latitude: 32.75799,
    longitude: -97.32858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76102',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1009.7,
    imprecise: false,
    latitude: 32.75282,
    longitude: -97.26627,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76103',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1344.5,
    imprecise: false,
    latitude: 32.72848,
    longitude: -97.31819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76104',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1456.4,
    imprecise: false,
    latitude: 32.72327,
    longitude: -97.26999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76105',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 958.7,
    imprecise: false,
    latitude: 32.81417,
    longitude: -97.35209,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76106',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1116.8,
    imprecise: false,
    latitude: 32.74176,
    longitude: -97.38202,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76107',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439|48367',
    county: 'Tarrant',
    county_names_all: 'Tarrant|Parker',
    county_weights: '{"48439": 73.1, "48367": 26.9}',
    density: 408,
    imprecise: false,
    latitude: 32.77943,
    longitude: -97.51811,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76108',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1229.8,
    imprecise: false,
    latitude: 32.70115,
    longitude: -97.38378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76109',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 2252.7,
    imprecise: false,
    latitude: 32.70678,
    longitude: -97.33843,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76110',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1093.1,
    imprecise: false,
    latitude: 32.7804,
    longitude: -97.30116,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76111',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1516.9,
    imprecise: false,
    latitude: 32.74831,
    longitude: -97.21828,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76112',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1090.5,
    imprecise: false,
    latitude: 32.77365,
    longitude: -97.40417,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76114',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1633.8,
    imprecise: false,
    latitude: 32.67861,
    longitude: -97.33117,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76115',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1567.1,
    imprecise: false,
    latitude: 32.72128,
    longitude: -97.44766,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76116',
  },
  {
    city: 'Haltom City',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1169,
    imprecise: false,
    latitude: 32.80374,
    longitude: -97.26766,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76117',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 719.3,
    imprecise: false,
    latitude: 32.79606,
    longitude: -97.1972,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76118',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1283.6,
    imprecise: false,
    latitude: 32.69026,
    longitude: -97.26176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76119',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1088.8,
    imprecise: false,
    latitude: 32.76742,
    longitude: -97.18286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76120',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1568.1,
    imprecise: false,
    latitude: 32.62298,
    longitude: -97.40262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76123',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439|48367',
    county: 'Tarrant',
    county_names_all: 'Tarrant|Parker',
    county_weights: '{"48439": 74.83, "48367": 25.17}',
    density: 155.7,
    imprecise: false,
    latitude: 32.64374,
    longitude: -97.51767,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76126',
  },
  {
    city: 'Naval Air Station Jrb',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 308.1,
    imprecise: false,
    latitude: 32.77663,
    longitude: -97.43044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76127',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1399.5,
    imprecise: false,
    latitude: 32.88227,
    longitude: -97.34895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76131',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1401.9,
    imprecise: false,
    latitude: 32.66743,
    longitude: -97.41827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76132',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 2234.6,
    imprecise: false,
    latitude: 32.6538,
    longitude: -97.37746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76133',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1344,
    imprecise: false,
    latitude: 32.64331,
    longitude: -97.33103,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76134',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 292.8,
    imprecise: false,
    latitude: 32.83708,
    longitude: -97.46621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76135',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1715.2,
    imprecise: false,
    latitude: 32.85864,
    longitude: -97.29137,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 60352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76137',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 471.1,
    imprecise: false,
    latitude: 32.62012,
    longitude: -97.27036,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76140',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1916.3,
    imprecise: false,
    latitude: 32.86789,
    longitude: -97.25197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76148',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 715.6,
    imprecise: false,
    latitude: 32.82404,
    longitude: -97.04911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76155',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1316,
    imprecise: false,
    latitude: 32.7808,
    longitude: -97.35411,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76164',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439|48121',
    county: 'Tarrant',
    county_names_all: 'Tarrant|Denton',
    county_weights: '{"48439": 67.26, "48121": 32.74}',
    density: 468.8,
    imprecise: false,
    latitude: 32.96999,
    longitude: -97.30611,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76177',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 596.2,
    imprecise: false,
    latitude: 32.91397,
    longitude: -97.43947,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 80090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76179',
  },
  {
    city: 'North Richland Hills',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1592.8,
    imprecise: false,
    latitude: 32.83994,
    longitude: -97.22468,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76180',
  },
  {
    city: 'North Richland Hills',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1348.6,
    imprecise: false,
    latitude: 32.88257,
    longitude: -97.20969,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76182',
  },
  {
    city: 'Denton',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 2202,
    imprecise: false,
    latitude: 33.22122,
    longitude: -97.14715,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76201',
  },
  {
    city: 'Denton',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 881.7,
    imprecise: false,
    latitude: 33.19074,
    longitude: -97.12894,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76205',
  },
  {
    city: 'Denton',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 190.1,
    imprecise: false,
    latitude: 33.22174,
    longitude: -97.18505,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76207',
  },
  {
    city: 'Denton',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 423.5,
    imprecise: false,
    latitude: 33.20917,
    longitude: -97.05786,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76208',
  },
  {
    city: 'Denton',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 1623.7,
    imprecise: false,
    latitude: 33.2315,
    longitude: -97.11,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76209',
  },
  {
    city: 'Denton',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 1140.6,
    imprecise: false,
    latitude: 33.14985,
    longitude: -97.0962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76210',
  },
  {
    city: 'Alvord',
    county_fips: 48497,
    county_fips_all: '48497|48337',
    county: 'Wise',
    county_names_all: 'Wise|Montague',
    county_weights: '{"48497": 99.27, "48337": 0.73}',
    density: 12.8,
    imprecise: false,
    latitude: 33.36616,
    longitude: -97.67345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76225',
  },
  {
    city: 'Argyle',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 338,
    imprecise: false,
    latitude: 33.10775,
    longitude: -97.17196,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76226',
  },
  {
    city: 'Aubrey',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 306,
    imprecise: false,
    latitude: 33.27465,
    longitude: -96.99075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 62127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76227',
  },
  {
    city: 'Bellevue',
    county_fips: 48077,
    county_fips_all: '48077|48337',
    county: 'Clay',
    county_names_all: 'Clay|Montague',
    county_weights: '{"48077": 89.74, "48337": 10.26}',
    density: 2.4,
    imprecise: false,
    latitude: 33.61438,
    longitude: -98.06305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76228',
  },
  {
    city: 'Bowie',
    county_fips: 48337,
    county_fips_all: '48337|48237|48077',
    county: 'Montague',
    county_names_all: 'Montague|Jack|Clay',
    county_weights: '{"48337": 60.92, "48237": 31.33, "48077": 7.75}',
    density: 11.4,
    imprecise: false,
    latitude: 33.52264,
    longitude: -97.94497,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76230',
  },
  {
    city: 'Collinsville',
    county_fips: 48181,
    county_fips_all: '48181|48097',
    county: 'Grayson',
    county_names_all: 'Grayson|Cooke',
    county_weights: '{"48181": 76.53, "48097": 23.47}',
    density: 23.8,
    imprecise: false,
    latitude: 33.54025,
    longitude: -96.89696,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76233',
  },
  {
    city: 'Decatur',
    county_fips: 48497,
    county_fips_all: '48497|48097|48121',
    county: 'Wise',
    county_names_all: 'Wise|Cooke|Denton',
    county_weights: '{"48497": 91.91, "48097": 5.88, "48121": 2.21}',
    density: 26.3,
    imprecise: false,
    latitude: 33.27587,
    longitude: -97.51404,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76234',
  },
  {
    city: 'Era',
    county_fips: 48097,
    county_fips_all: '48097',
    county: 'Cooke',
    county_names_all: 'Cooke',
    county_weights: '{"48097": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 33.4861,
    longitude: -97.34148,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76238',
  },
  {
    city: 'Forestburg',
    county_fips: 48337,
    county_fips_all: '48337|48097',
    county: 'Montague',
    county_names_all: 'Montague|Cooke',
    county_weights: '{"48337": 88.05, "48097": 11.95}',
    density: 4.2,
    imprecise: false,
    latitude: 33.524,
    longitude: -97.57033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76239',
  },
  {
    city: 'Gainesville',
    county_fips: 48097,
    county_fips_all: '48097',
    county: 'Cooke',
    county_names_all: 'Cooke',
    county_weights: '{"48097": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 33.65654,
    longitude: -97.17766,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76240',
  },
  {
    city: 'Gainesville',
    county_fips: 48097,
    county_fips_all: '48097',
    county: 'Cooke',
    county_names_all: 'Cooke',
    county_weights: '{"48097": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.64542,
    longitude: -97.17628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76241',
  },
  {
    city: 'Keller',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 1987.4,
    imprecise: false,
    latitude: 32.93101,
    longitude: -97.28076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 76728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76244',
  },
  {
    city: 'Gordonville',
    county_fips: 48181,
    county_fips_all: '48181',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"48181": 100}',
    density: 28.9,
    imprecise: false,
    latitude: 33.82885,
    longitude: -96.85422,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76245',
  },
  {
    city: 'Justin',
    county_fips: 48121,
    county_fips_all: '48121|48497',
    county: 'Denton',
    county_names_all: 'Denton|Wise',
    county_weights: '{"48121": 96.58, "48497": 3.42}',
    density: 112.8,
    imprecise: false,
    latitude: 33.0965,
    longitude: -97.33154,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76247',
  },
  {
    city: 'Keller',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 998,
    imprecise: false,
    latitude: 32.92988,
    longitude: -97.22972,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76248',
  },
  {
    city: 'Krum',
    county_fips: 48121,
    county_fips_all: '48121|48497',
    county: 'Denton',
    county_names_all: 'Denton|Wise',
    county_weights: '{"48121": 95.5, "48497": 4.5}',
    density: 57.8,
    imprecise: false,
    latitude: 33.27993,
    longitude: -97.3026,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76249',
  },
  {
    city: 'Lindsay',
    county_fips: 48097,
    county_fips_all: '48097',
    county: 'Cooke',
    county_names_all: 'Cooke',
    county_weights: '{"48097": 100}',
    density: 82,
    imprecise: false,
    latitude: 33.63006,
    longitude: -97.24237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76250',
  },
  {
    city: 'Montague',
    county_fips: 48337,
    county_fips_all: '48337',
    county: 'Montague',
    county_names_all: 'Montague',
    county_weights: '{"48337": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 33.65455,
    longitude: -97.69076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76251',
  },
  {
    city: 'Muenster',
    county_fips: 48097,
    county_fips_all: '48097|48337',
    county: 'Cooke',
    county_names_all: 'Cooke|Montague',
    county_weights: '{"48097": 97.82, "48337": 2.18}',
    density: 6,
    imprecise: false,
    latitude: 33.67788,
    longitude: -97.38695,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76252',
  },
  {
    city: 'Myra',
    county_fips: 48097,
    county_fips_all: '48097',
    county: 'Cooke',
    county_names_all: 'Cooke',
    county_weights: '{"48097": 100}',
    density: 220.4,
    imprecise: false,
    latitude: 33.62516,
    longitude: -97.31327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76253',
  },
  {
    city: 'Nocona',
    county_fips: 48337,
    county_fips_all: '48337',
    county: 'Montague',
    county_names_all: 'Montague',
    county_weights: '{"48337": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 33.8179,
    longitude: -97.71625,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76255',
  },
  {
    city: 'Pilot Point',
    county_fips: 48121,
    county_fips_all: '48121|48181|48097',
    county: 'Denton',
    county_names_all: 'Denton|Grayson|Cooke',
    county_weights: '{"48121": 83.25, "48181": 15.38, "48097": 1.37}',
    density: 36.1,
    imprecise: false,
    latitude: 33.37202,
    longitude: -96.9204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76258',
  },
  {
    city: 'Ponder',
    county_fips: 48121,
    county_fips_all: '48121|48497',
    county: 'Denton',
    county_names_all: 'Denton|Wise',
    county_weights: '{"48121": 95.93, "48497": 4.07}',
    density: 49.8,
    imprecise: false,
    latitude: 33.19977,
    longitude: -97.31603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76259',
  },
  {
    city: 'Ringgold',
    county_fips: 48337,
    county_fips_all: '48337|48077',
    county: 'Montague',
    county_names_all: 'Montague|Clay',
    county_weights: '{"48337": 63.53, "48077": 36.47}',
    density: 1.2,
    imprecise: false,
    latitude: 33.80291,
    longitude: -97.96233,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76261',
  },
  {
    city: 'Roanoke',
    county_fips: 48121,
    county_fips_all: '48121|48439',
    county: 'Denton',
    county_names_all: 'Denton|Tarrant',
    county_weights: '{"48121": 73.77, "48439": 26.23}',
    density: 397.8,
    imprecise: false,
    latitude: 33.01137,
    longitude: -97.22101,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76262',
  },
  {
    city: 'Rosston',
    county_fips: 48097,
    county_fips_all: '48097',
    county: 'Cooke',
    county_names_all: 'Cooke',
    county_weights: '{"48097": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 33.50435,
    longitude: -97.43735,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76263',
  },
  {
    city: 'Sadler',
    county_fips: 48181,
    county_fips_all: '48181',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"48181": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 33.74172,
    longitude: -96.83509,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76264',
  },
  {
    city: 'Saint Jo',
    county_fips: 48337,
    county_fips_all: '48337|48097',
    county: 'Montague',
    county_names_all: 'Montague|Cooke',
    county_weights: '{"48337": 83.76, "48097": 16.24}',
    density: 3.5,
    imprecise: false,
    latitude: 33.74079,
    longitude: -97.53922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76265',
  },
  {
    city: 'Sanger',
    county_fips: 48121,
    county_fips_all: '48121|48097',
    county: 'Denton',
    county_names_all: 'Denton|Cooke',
    county_weights: '{"48121": 97.28, "48097": 2.72}',
    density: 57.4,
    imprecise: false,
    latitude: 33.36818,
    longitude: -97.21513,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76266',
  },
  {
    city: 'Slidell',
    county_fips: 48497,
    county_fips_all: '48497',
    county: 'Wise',
    county_names_all: 'Wise',
    county_weights: '{"48497": 100}',
    density: 25,
    imprecise: false,
    latitude: 33.36935,
    longitude: -97.39711,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76267',
  },
  {
    city: 'Southmayd',
    county_fips: 48181,
    county_fips_all: '48181',
    county: 'Grayson',
    county_names_all: 'Grayson',
    county_weights: '{"48181": 100}',
    density: 147.6,
    imprecise: false,
    latitude: 33.62785,
    longitude: -96.76539,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76268',
  },
  {
    city: 'Sunset',
    county_fips: 48337,
    county_fips_all: '48337|48497',
    county: 'Montague',
    county_names_all: 'Montague|Wise',
    county_weights: '{"48337": 71.54, "48497": 28.46}',
    density: 7.4,
    imprecise: false,
    latitude: 33.45471,
    longitude: -97.76247,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76270',
  },
  {
    city: 'Tioga',
    county_fips: 48181,
    county_fips_all: '48181|48097',
    county: 'Grayson',
    county_names_all: 'Grayson|Cooke',
    county_weights: '{"48181": 59.15, "48097": 40.85}',
    density: 16.6,
    imprecise: false,
    latitude: 33.46953,
    longitude: -96.91412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76271',
  },
  {
    city: 'Valley View',
    county_fips: 48097,
    county_fips_all: '48097|48121',
    county: 'Cooke',
    county_names_all: 'Cooke|Denton',
    county_weights: '{"48097": 85.42, "48121": 14.58}',
    density: 21.4,
    imprecise: false,
    latitude: 33.46421,
    longitude: -97.12721,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76272',
  },
  {
    city: 'Whitesboro',
    county_fips: 48181,
    county_fips_all: '48181|48097',
    county: 'Grayson',
    county_names_all: 'Grayson|Cooke',
    county_weights: '{"48181": 52.63, "48097": 47.37}',
    density: 21,
    imprecise: false,
    latitude: 33.74794,
    longitude: -96.93935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76273',
  },
  {
    city: 'Wichita Falls',
    county_fips: 48485,
    county_fips_all: '48485',
    county: 'Wichita',
    county_names_all: 'Wichita',
    county_weights: '{"48485": 100}',
    density: 523.5,
    imprecise: false,
    latitude: 33.90507,
    longitude: -98.48043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76301',
  },
  {
    city: 'Wichita Falls',
    county_fips: 48485,
    county_fips_all: '48485',
    county: 'Wichita',
    county_names_all: 'Wichita',
    county_weights: '{"48485": 100}',
    density: 488.2,
    imprecise: false,
    latitude: 33.86607,
    longitude: -98.48487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76302',
  },
  {
    city: 'Wichita Falls',
    county_fips: 48077,
    county_fips_all: '48077|48485',
    county: 'Clay',
    county_names_all: 'Clay|Wichita',
    county_weights: '{"48077": 68.74, "48485": 31.26}',
    density: 8.8,
    imprecise: false,
    latitude: 33.99979,
    longitude: -98.3909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76305',
  },
  {
    city: 'Wichita Falls',
    county_fips: 48485,
    county_fips_all: '48485',
    county: 'Wichita',
    county_names_all: 'Wichita',
    county_weights: '{"48485": 100}',
    density: 314.5,
    imprecise: false,
    latitude: 33.95237,
    longitude: -98.52745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76306',
  },
  {
    city: 'Wichita Falls',
    county_fips: 48485,
    county_fips_all: '48485|48009',
    county: 'Wichita',
    county_names_all: 'Wichita|Archer',
    county_weights: '{"48485": 85.66, "48009": 14.34}',
    density: 1077.1,
    imprecise: false,
    latitude: 33.85684,
    longitude: -98.5378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76308',
  },
  {
    city: 'Wichita Falls',
    county_fips: 48485,
    county_fips_all: '48485',
    county: 'Wichita',
    county_names_all: 'Wichita',
    county_weights: '{"48485": 100}',
    density: 935.2,
    imprecise: false,
    latitude: 33.89551,
    longitude: -98.544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76309',
  },
  {
    city: 'Wichita Falls',
    county_fips: 48009,
    county_fips_all: '48009|48485|48077',
    county: 'Archer',
    county_names_all: 'Archer|Wichita|Clay',
    county_weights: '{"48009": 46.69, "48485": 26.97, "48077": 26.34}',
    density: 43.1,
    imprecise: false,
    latitude: 33.81115,
    longitude: -98.51178,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76310',
  },
  {
    city: 'Sheppard Afb',
    county_fips: 48485,
    county_fips_all: '48485',
    county: 'Wichita',
    county_names_all: 'Wichita',
    county_weights: '{"48485": 100}',
    density: 1029.4,
    imprecise: false,
    latitude: 33.97324,
    longitude: -98.50823,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76311',
  },
  {
    city: 'Archer City',
    county_fips: 48009,
    county_fips_all: '48009',
    county: 'Archer',
    county_names_all: 'Archer',
    county_weights: '{"48009": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 33.55553,
    longitude: -98.71145,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76351',
  },
  {
    city: 'Burkburnett',
    county_fips: 48485,
    county_fips_all: '48485',
    county: 'Wichita',
    county_names_all: 'Wichita',
    county_weights: '{"48485": 100}',
    density: 56.1,
    imprecise: false,
    latitude: 34.09521,
    longitude: -98.62276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76354',
  },
  {
    city: 'Byers',
    county_fips: 48077,
    county_fips_all: '48077',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"48077": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 34.07875,
    longitude: -98.18512,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76357',
  },
  {
    city: 'Electra',
    county_fips: 48485,
    county_fips_all: '48485|48487|48009|48023',
    county: 'Wichita',
    county_names_all: 'Wichita|Wilbarger|Archer|Baylor',
    county_weights:
      '{"48485": 49.13, "48487": 43.6, "48009": 6.84, "48023": 0.44}',
    density: 2.7,
    imprecise: false,
    latitude: 33.97361,
    longitude: -99.00302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76360',
  },
  {
    city: 'Goree',
    county_fips: 48275,
    county_fips_all: '48275',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"48275": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 33.50762,
    longitude: -99.53122,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76363',
  },
  {
    city: 'Harrold',
    county_fips: 48487,
    county_fips_all: '48487',
    county: 'Wilbarger',
    county_names_all: 'Wilbarger',
    county_weights: '{"48487": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 34.13998,
    longitude: -99.00529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76364',
  },
  {
    city: 'Henrietta',
    county_fips: 48077,
    county_fips_all: '48077|48237',
    county: 'Clay',
    county_names_all: 'Clay|Jack',
    county_weights: '{"48077": 96.93, "48237": 3.07}',
    density: 3.5,
    imprecise: false,
    latitude: 33.754,
    longitude: -98.2076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76365',
  },
  {
    city: 'Holliday',
    county_fips: 48009,
    county_fips_all: '48009',
    county: 'Archer',
    county_names_all: 'Archer',
    county_weights: '{"48009": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 33.71439,
    longitude: -98.77436,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76366',
  },
  {
    city: 'Iowa Park',
    county_fips: 48485,
    county_fips_all: '48485',
    county: 'Wichita',
    county_names_all: 'Wichita',
    county_weights: '{"48485": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 33.97361,
    longitude: -98.7168,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76367',
  },
  {
    city: 'Megargel',
    county_fips: 48009,
    county_fips_all: '48009',
    county: 'Archer',
    county_names_all: 'Archer',
    county_weights: '{"48009": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 33.45624,
    longitude: -98.89407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76370',
  },
  {
    city: 'Munday',
    county_fips: 48275,
    county_fips_all: '48275|48207',
    county: 'Knox',
    county_names_all: 'Knox|Haskell',
    county_weights: '{"48275": 96.69, "48207": 3.31}',
    density: 5,
    imprecise: false,
    latitude: 33.48668,
    longitude: -99.65453,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76371',
  },
  {
    city: 'Newcastle',
    county_fips: 48447,
    county_fips_all: '48447|48503',
    county: 'Throckmorton',
    county_names_all: 'Throckmorton|Young',
    county_weights: '{"48447": 51.11, "48503": 48.89}',
    density: 1.6,
    imprecise: false,
    latitude: 33.25173,
    longitude: -98.93643,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76372',
  },
  {
    city: 'Oklaunion',
    county_fips: 48487,
    county_fips_all: '48487',
    county: 'Wilbarger',
    county_names_all: 'Wilbarger',
    county_weights: '{"48487": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 34.15541,
    longitude: -99.11973,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76373',
  },
  {
    city: 'Olney',
    county_fips: 48503,
    county_fips_all: '48503|48009|48447',
    county: 'Young',
    county_names_all: 'Young|Archer|Throckmorton',
    county_weights: '{"48503": 78.15, "48009": 18.72, "48447": 3.13}',
    density: 5.8,
    imprecise: false,
    latitude: 33.34823,
    longitude: -98.7648,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76374',
  },
  {
    city: 'Petrolia',
    county_fips: 48077,
    county_fips_all: '48077',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"48077": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 34.0101,
    longitude: -98.24191,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76377',
  },
  {
    city: 'Scotland',
    county_fips: 48009,
    county_fips_all: '48009',
    county: 'Archer',
    county_names_all: 'Archer',
    county_weights: '{"48009": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 33.67058,
    longitude: -98.47453,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76379',
  },
  {
    city: 'Seymour',
    county_fips: 48023,
    county_fips_all: '48023|48275',
    county: 'Baylor',
    county_names_all: 'Baylor|Knox',
    county_weights: '{"48023": 92.57, "48275": 7.43}',
    density: 1.6,
    imprecise: false,
    latitude: 33.60434,
    longitude: -99.22305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76380',
  },
  {
    city: 'Vernon',
    county_fips: 48487,
    county_fips_all: '48487|48155',
    county: 'Wilbarger',
    county_names_all: 'Wilbarger|Foard',
    county_weights: '{"48487": 99.57, "48155": 0.43}',
    density: 9.8,
    imprecise: false,
    latitude: 34.14355,
    longitude: -99.32067,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76384',
  },
  {
    city: 'Weinert',
    county_fips: 48207,
    county_fips_all: '48207',
    county: 'Haskell',
    county_names_all: 'Haskell',
    county_weights: '{"48207": 100}',
    density: 1,
    imprecise: false,
    latitude: 33.31785,
    longitude: -99.62931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76388',
  },
  {
    city: 'Windthorst',
    county_fips: 48009,
    county_fips_all: '48009|48077|48237',
    county: 'Archer',
    county_names_all: 'Archer|Clay|Jack',
    county_weights: '{"48009": 71.92, "48077": 21.36, "48237": 6.72}',
    density: 3.5,
    imprecise: false,
    latitude: 33.49713,
    longitude: -98.47568,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76389',
  },
  {
    city: 'Stephenville',
    county_fips: 48143,
    county_fips_all: '48143',
    county: 'Erath',
    county_names_all: 'Erath',
    county_weights: '{"48143": 100}',
    density: 29.5,
    imprecise: false,
    latitude: 32.27918,
    longitude: -98.19994,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76401',
  },
  {
    city: 'Breckenridge',
    county_fips: 48429,
    county_fips_all: '48429|48503',
    county: 'Stephens',
    county_names_all: 'Stephens|Young',
    county_weights: '{"48429": 96.71, "48503": 3.29}',
    density: 6.6,
    imprecise: false,
    latitude: 32.80431,
    longitude: -98.89236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76424',
  },
  {
    city: 'Bridgeport',
    county_fips: 48497,
    county_fips_all: '48497|48237',
    county: 'Wise',
    county_names_all: 'Wise|Jack',
    county_weights: '{"48497": 87.94, "48237": 12.06}',
    density: 34.3,
    imprecise: false,
    latitude: 33.16493,
    longitude: -97.83772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76426',
  },
  {
    city: 'Bryson',
    county_fips: 48237,
    county_fips_all: '48237',
    county: 'Jack',
    county_names_all: 'Jack',
    county_weights: '{"48237": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 33.13145,
    longitude: -98.39271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76427',
  },
  {
    city: 'Caddo',
    county_fips: 48429,
    county_fips_all: '48429|48363',
    county: 'Stephens',
    county_names_all: 'Stephens|Palo Pinto',
    county_weights: '{"48429": 88.8, "48363": 11.2}',
    density: 1.5,
    imprecise: false,
    latitude: 32.74742,
    longitude: -98.67428,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76429',
  },
  {
    city: 'Albany',
    county_fips: 48417,
    county_fips_all: '48417|48447',
    county: 'Shackelford',
    county_names_all: 'Shackelford|Throckmorton',
    county_weights: '{"48417": 97.08, "48447": 2.92}',
    density: 2.8,
    imprecise: false,
    latitude: 32.80303,
    longitude: -99.23519,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76430',
  },
  {
    city: 'Chico',
    county_fips: 48497,
    county_fips_all: '48497|48237',
    county: 'Wise',
    county_names_all: 'Wise|Jack',
    county_weights: '{"48497": 76.28, "48237": 23.72}',
    density: 14.4,
    imprecise: false,
    latitude: 33.31066,
    longitude: -97.86228,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76431',
  },
  {
    city: 'Blanket',
    county_fips: 48049,
    county_fips_all: '48049|48093',
    county: 'Brown',
    county_names_all: 'Brown|Comanche',
    county_weights: '{"48049": 57.93, "48093": 42.07}',
    density: 5.1,
    imprecise: false,
    latitude: 31.83945,
    longitude: -98.78705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76432',
  },
  {
    city: 'Bluff Dale',
    county_fips: 48143,
    county_fips_all: '48143|48425|48221',
    county: 'Erath',
    county_names_all: 'Erath|Somervell|Hood',
    county_weights: '{"48143": 75.15, "48425": 13.13, "48221": 11.72}',
    density: 6.6,
    imprecise: false,
    latitude: 32.30662,
    longitude: -98.01096,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76433',
  },
  {
    city: 'Carbon',
    county_fips: 48133,
    county_fips_all: '48133',
    county: 'Eastland',
    county_names_all: 'Eastland',
    county_weights: '{"48133": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 32.21754,
    longitude: -98.85349,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76435',
  },
  {
    city: 'Carlton',
    county_fips: 48093,
    county_fips_all: '48093|48193|48143',
    county: 'Comanche',
    county_names_all: 'Comanche|Hamilton|Erath',
    county_weights: '{"48093": 85.62, "48193": 11.22, "48143": 3.16}',
    density: 0.9,
    imprecise: false,
    latitude: 31.87404,
    longitude: -98.22271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76436',
  },
  {
    city: 'Cisco',
    county_fips: 48133,
    county_fips_all: '48133|48059|48429',
    county: 'Eastland',
    county_names_all: 'Eastland|Callahan|Stephens',
    county_weights: '{"48133": 69.32, "48059": 15.59, "48429": 15.09}',
    density: 5.7,
    imprecise: false,
    latitude: 32.388,
    longitude: -99.01935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76437',
  },
  {
    city: 'Dennis',
    county_fips: 48367,
    county_fips_all: '48367',
    county: 'Parker',
    county_names_all: 'Parker',
    county_weights: '{"48367": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.6176,
    longitude: -97.92708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76439',
  },
  {
    city: 'Comanche',
    county_fips: 48093,
    county_fips_all: '48093|48333|48193',
    county: 'Comanche',
    county_names_all: 'Comanche|Mills|Hamilton',
    county_weights: '{"48093": 91.02, "48333": 7.51, "48193": 1.47}',
    density: 6.6,
    imprecise: false,
    latitude: 31.89015,
    longitude: -98.61242,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76442',
  },
  {
    city: 'Cross Plains',
    county_fips: 48059,
    county_fips_all: '48059|48049|48083',
    county: 'Callahan',
    county_names_all: 'Callahan|Brown|Coleman',
    county_weights: '{"48059": 72.87, "48049": 22.57, "48083": 4.56}',
    density: 5.5,
    imprecise: false,
    latitude: 32.11907,
    longitude: -99.20174,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76443',
  },
  {
    city: 'De Leon',
    county_fips: 48093,
    county_fips_all: '48093|48143',
    county: 'Comanche',
    county_names_all: 'Comanche|Erath',
    county_weights: '{"48093": 98.89, "48143": 1.11}',
    density: 10.8,
    imprecise: false,
    latitude: 32.11781,
    longitude: -98.5672,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76444',
  },
  {
    city: 'Desdemona',
    county_fips: 48133,
    county_fips_all: '48133|48093|48143',
    county: 'Eastland',
    county_names_all: 'Eastland|Comanche|Erath',
    county_weights: '{"48133": 80.1, "48093": 14.48, "48143": 5.42}',
    density: 1.6,
    imprecise: false,
    latitude: 32.30318,
    longitude: -98.53829,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76445',
  },
  {
    city: 'Dublin',
    county_fips: 48143,
    county_fips_all: '48143|48093',
    county: 'Erath',
    county_names_all: 'Erath|Comanche',
    county_weights: '{"48143": 71.29, "48093": 28.71}',
    density: 7.6,
    imprecise: false,
    latitude: 32.07572,
    longitude: -98.35311,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76446',
  },
  {
    city: 'Eastland',
    county_fips: 48133,
    county_fips_all: '48133',
    county: 'Eastland',
    county_names_all: 'Eastland',
    county_weights: '{"48133": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 32.39257,
    longitude: -98.79541,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76448',
  },
  {
    city: 'Graford',
    county_fips: 48363,
    county_fips_all: '48363|48237',
    county: 'Palo Pinto',
    county_names_all: 'Palo Pinto|Jack',
    county_weights: '{"48363": 99.2, "48237": 0.8}',
    density: 4,
    imprecise: false,
    latitude: 32.91592,
    longitude: -98.32512,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76449',
  },
  {
    city: 'Graham',
    county_fips: 48503,
    county_fips_all: '48503|48429|48363',
    county: 'Young',
    county_names_all: 'Young|Stephens|Palo Pinto',
    county_weights: '{"48503": 84.62, "48429": 9.07, "48363": 6.31}',
    density: 10.3,
    imprecise: false,
    latitude: 33.05968,
    longitude: -98.64152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76450',
  },
  {
    city: 'Energy',
    county_fips: 48093,
    county_fips_all: '48093',
    county: 'Comanche',
    county_names_all: 'Comanche',
    county_weights: '{"48093": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 31.77119,
    longitude: -98.39198,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76452',
  },
  {
    city: 'Gordon',
    county_fips: 48363,
    county_fips_all: '48363|48143',
    county: 'Palo Pinto',
    county_names_all: 'Palo Pinto|Erath',
    county_weights: '{"48363": 80.83, "48143": 19.17}',
    density: 4.5,
    imprecise: false,
    latitude: 32.57202,
    longitude: -98.33908,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76453',
  },
  {
    city: 'Gorman',
    county_fips: 48133,
    county_fips_all: '48133|48093',
    county: 'Eastland',
    county_names_all: 'Eastland|Comanche',
    county_weights: '{"48133": 75.75, "48093": 24.25}',
    density: 4.1,
    imprecise: false,
    latitude: 32.22983,
    longitude: -98.69621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76454',
  },
  {
    city: 'Gustine',
    county_fips: 48093,
    county_fips_all: '48093',
    county: 'Comanche',
    county_names_all: 'Comanche',
    county_weights: '{"48093": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 31.82142,
    longitude: -98.36676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76455',
  },
  {
    city: 'Hico',
    county_fips: 48193,
    county_fips_all: '48193|48143|48035',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Erath|Bosque',
    county_weights: '{"48193": 57.81, "48143": 34.13, "48035": 8.06}',
    density: 5.1,
    imprecise: false,
    latitude: 31.94968,
    longitude: -98.02773,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76457',
  },
  {
    city: 'Jacksboro',
    county_fips: 48237,
    county_fips_all: '48237|48497',
    county: 'Jack',
    county_names_all: 'Jack|Wise',
    county_weights: '{"48237": 99.47, "48497": 0.53}',
    density: 4.1,
    imprecise: false,
    latitude: 33.21518,
    longitude: -98.18944,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76458',
  },
  {
    city: 'Jermyn',
    county_fips: 48237,
    county_fips_all: '48237',
    county: 'Jack',
    county_names_all: 'Jack',
    county_weights: '{"48237": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 33.27395,
    longitude: -98.38972,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76459',
  },
  {
    city: 'Loving',
    county_fips: 48503,
    county_fips_all: '48503',
    county: 'Young',
    county_names_all: 'Young',
    county_weights: '{"48503": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 33.30796,
    longitude: -98.49798,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76460',
  },
  {
    city: 'Lipan',
    county_fips: 48221,
    county_fips_all: '48221|48143|48367|48363',
    county: 'Hood',
    county_names_all: 'Hood|Erath|Parker|Palo Pinto',
    county_weights:
      '{"48221": 36.56, "48143": 25.56, "48367": 24.83, "48363": 13.05}',
    density: 11.5,
    imprecise: false,
    latitude: 32.52316,
    longitude: -98.03421,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76462',
  },
  {
    city: 'Mingus',
    county_fips: 48143,
    county_fips_all: '48143|48363',
    county: 'Erath',
    county_names_all: 'Erath|Palo Pinto',
    county_weights: '{"48143": 89.1, "48363": 10.9}',
    density: 2.9,
    imprecise: false,
    latitude: 32.455,
    longitude: -98.41516,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76463',
  },
  {
    city: 'Moran',
    county_fips: 48417,
    county_fips_all: '48417|48429|48059',
    county: 'Shackelford',
    county_names_all: 'Shackelford|Stephens|Callahan',
    county_weights: '{"48417": 58.18, "48429": 27.72, "48059": 14.1}',
    density: 0.9,
    imprecise: false,
    latitude: 32.57554,
    longitude: -99.1542,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76464',
  },
  {
    city: 'Olden',
    county_fips: 48133,
    county_fips_all: '48133',
    county: 'Eastland',
    county_names_all: 'Eastland',
    county_weights: '{"48133": 100}',
    density: 61.2,
    imprecise: false,
    latitude: 32.42887,
    longitude: -98.7332,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76466',
  },
  {
    city: 'Putnam',
    county_fips: 48059,
    county_fips_all: '48059',
    county: 'Callahan',
    county_names_all: 'Callahan',
    county_weights: '{"48059": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 32.34696,
    longitude: -99.21707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76469',
  },
  {
    city: 'Ranger',
    county_fips: 48133,
    county_fips_all: '48133|48429',
    county: 'Eastland',
    county_names_all: 'Eastland|Stephens',
    county_weights: '{"48133": 54.44, "48429": 45.56}',
    density: 4.6,
    imprecise: false,
    latitude: 32.49977,
    longitude: -98.6686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76470',
  },
  {
    city: 'Rising Star',
    county_fips: 48133,
    county_fips_all: '48133|48049|48093',
    county: 'Eastland',
    county_names_all: 'Eastland|Brown|Comanche',
    county_weights: '{"48133": 64.13, "48049": 27.33, "48093": 8.54}',
    density: 3.5,
    imprecise: false,
    latitude: 32.11117,
    longitude: -98.98499,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76471',
  },
  {
    city: 'Santo',
    county_fips: 48363,
    county_fips_all: '48363',
    county: 'Palo Pinto',
    county_names_all: 'Palo Pinto',
    county_weights: '{"48363": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 32.60631,
    longitude: -98.17095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76472',
  },
  {
    city: 'Sidney',
    county_fips: 48093,
    county_fips_all: '48093|48049',
    county: 'Comanche',
    county_names_all: 'Comanche|Brown',
    county_weights: '{"48093": 96.54, "48049": 3.46}',
    density: 6,
    imprecise: false,
    latitude: 31.97036,
    longitude: -98.79142,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76474',
  },
  {
    city: 'Strawn',
    county_fips: 48363,
    county_fips_all: '48363|48429|48133',
    county: 'Palo Pinto',
    county_names_all: 'Palo Pinto|Stephens|Eastland',
    county_weights: '{"48363": 72.99, "48429": 16.2, "48133": 10.81}',
    density: 1.4,
    imprecise: false,
    latitude: 32.65296,
    longitude: -98.51281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76475',
  },
  {
    city: 'Tolar',
    county_fips: 48221,
    county_fips_all: '48221',
    county: 'Hood',
    county_names_all: 'Hood',
    county_weights: '{"48221": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 32.37055,
    longitude: -97.92017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76476',
  },
  {
    city: 'South Bend',
    county_fips: 48503,
    county_fips_all: '48503',
    county: 'Young',
    county_names_all: 'Young',
    county_weights: '{"48503": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 32.99706,
    longitude: -98.70977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76481',
  },
  {
    city: 'Throckmorton',
    county_fips: 48447,
    county_fips_all: '48447',
    county: 'Throckmorton',
    county_names_all: 'Throckmorton',
    county_weights: '{"48447": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 33.16667,
    longitude: -99.25111,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76483',
  },
  {
    city: 'Palo Pinto',
    county_fips: 48363,
    county_fips_all: '48363',
    county: 'Palo Pinto',
    county_names_all: 'Palo Pinto',
    county_weights: '{"48363": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 32.73147,
    longitude: -98.30551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76484',
  },
  {
    city: 'Perrin',
    county_fips: 48237,
    county_fips_all: '48237|48363|48367',
    county: 'Jack',
    county_names_all: 'Jack|Palo Pinto|Parker',
    county_weights: '{"48237": 66.77, "48363": 17.07, "48367": 16.16}',
    density: 4.7,
    imprecise: false,
    latitude: 33.02138,
    longitude: -98.05618,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76486',
  },
  {
    city: 'Poolville',
    county_fips: 48367,
    county_fips_all: '48367|48497|48237',
    county: 'Parker',
    county_names_all: 'Parker|Wise|Jack',
    county_weights: '{"48367": 66.13, "48497": 23.48, "48237": 10.39}',
    density: 18,
    imprecise: false,
    latitude: 32.97912,
    longitude: -97.88346,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76487',
  },
  {
    city: 'Whitt',
    county_fips: 48367,
    county_fips_all: '48367',
    county: 'Parker',
    county_names_all: 'Parker',
    county_weights: '{"48367": 100}',
    density: 4,
    imprecise: false,
    latitude: 32.95721,
    longitude: -98.04033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76490',
  },
  {
    city: 'Woodson',
    county_fips: 48447,
    county_fips_all: '48447|48429',
    county: 'Throckmorton',
    county_names_all: 'Throckmorton|Stephens',
    county_weights: '{"48447": 98.59, "48429": 1.41}',
    density: 1.9,
    imprecise: false,
    latitude: 33.05754,
    longitude: -99.03834,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76491',
  },
  {
    city: 'Temple',
    county_fips: 48027,
    county_fips_all: '48027',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"48027": 100}',
    density: 58,
    imprecise: false,
    latitude: 31.07555,
    longitude: -97.25469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76501',
  },
  {
    city: 'Temple',
    county_fips: 48027,
    county_fips_all: '48027',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"48027": 100}',
    density: 349,
    imprecise: false,
    latitude: 31.09388,
    longitude: -97.41082,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76502',
  },
  {
    city: 'Temple',
    county_fips: 48027,
    county_fips_all: '48027',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"48027": 100}',
    density: 327.6,
    imprecise: false,
    latitude: 31.14135,
    longitude: -97.37748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76504',
  },
  {
    city: 'Bartlett',
    county_fips: 48027,
    county_fips_all: '48027|48491|48331',
    county: 'Bell',
    county_names_all: 'Bell|Williamson|Milam',
    county_weights: '{"48027": 57.24, "48491": 36.61, "48331": 6.15}',
    density: 12.6,
    imprecise: false,
    latitude: 30.79955,
    longitude: -97.42293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76511',
  },
  {
    city: 'Belton',
    county_fips: 48027,
    county_fips_all: '48027',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"48027": 100}',
    density: 163.7,
    imprecise: false,
    latitude: 31.05777,
    longitude: -97.50369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76513',
  },
  {
    city: 'Buckholts',
    county_fips: 48331,
    county_fips_all: '48331',
    county: 'Milam',
    county_names_all: 'Milam',
    county_weights: '{"48331": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 30.85091,
    longitude: -97.13957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76518',
  },
  {
    city: 'Burlington',
    county_fips: 48331,
    county_fips_all: '48331|48027|48145',
    county: 'Milam',
    county_names_all: 'Milam|Bell|Falls',
    county_weights: '{"48331": 56.92, "48027": 28.49, "48145": 14.59}',
    density: 4.6,
    imprecise: false,
    latitude: 30.98978,
    longitude: -97.03579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76519',
  },
  {
    city: 'Cameron',
    county_fips: 48331,
    county_fips_all: '48331',
    county: 'Milam',
    county_names_all: 'Milam',
    county_weights: '{"48331": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 30.87266,
    longitude: -96.89972,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76520',
  },
  {
    city: 'Copperas Cove',
    county_fips: 48099,
    county_fips_all: '48099|48281',
    county: 'Coryell',
    county_names_all: 'Coryell|Lampasas',
    county_weights: '{"48099": 80.26, "48281": 19.74}',
    density: 141.4,
    imprecise: false,
    latitude: 31.21577,
    longitude: -97.97215,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76522',
  },
  {
    city: 'Davilla',
    county_fips: 48331,
    county_fips_all: '48331|48027',
    county: 'Milam',
    county_names_all: 'Milam|Bell',
    county_weights: '{"48331": 99.76, "48027": 0.24}',
    density: 62.4,
    imprecise: false,
    latitude: 30.80366,
    longitude: -97.27795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76523',
  },
  {
    city: 'Eddy',
    county_fips: 48145,
    county_fips_all: '48145|48309',
    county: 'Falls',
    county_names_all: 'Falls|McLennan',
    county_weights: '{"48145": 80.36, "48309": 19.64}',
    density: 23.2,
    imprecise: false,
    latitude: 31.27445,
    longitude: -97.20736,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76524',
  },
  {
    city: 'Evant',
    county_fips: 48193,
    county_fips_all: '48193|48099|48281',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Coryell|Lampasas',
    county_weights: '{"48193": 51.51, "48099": 27.16, "48281": 21.33}',
    density: 3.1,
    imprecise: false,
    latitude: 31.47643,
    longitude: -98.17321,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76525',
  },
  {
    city: 'Florence',
    county_fips: 48491,
    county_fips_all: '48491|48053|48027',
    county: 'Williamson',
    county_names_all: 'Williamson|Burnet|Bell',
    county_weights: '{"48491": 85.74, "48053": 7.62, "48027": 6.64}',
    density: 15.9,
    imprecise: false,
    latitude: 30.8379,
    longitude: -97.79531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76527',
  },
  {
    city: 'Gatesville',
    county_fips: 48099,
    county_fips_all: '48099|48027',
    county: 'Coryell',
    county_names_all: 'Coryell|Bell',
    county_weights: '{"48099": 98.06, "48027": 1.94}',
    density: 15,
    imprecise: false,
    latitude: 31.43589,
    longitude: -97.7844,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76528',
  },
  {
    city: 'Granger',
    county_fips: 48491,
    county_fips_all: '48491',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"48491": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 30.71357,
    longitude: -97.42434,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76530',
  },
  {
    city: 'Hamilton',
    county_fips: 48193,
    county_fips_all: '48193|48093|48333',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Comanche|Mills',
    county_weights: '{"48193": 96.13, "48093": 2.49, "48333": 1.38}',
    density: 4.7,
    imprecise: false,
    latitude: 31.68423,
    longitude: -98.19058,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76531',
  },
  {
    city: 'Holland',
    county_fips: 48027,
    county_fips_all: '48027|48331',
    county: 'Bell',
    county_names_all: 'Bell|Milam',
    county_weights: '{"48027": 93.28, "48331": 6.72}',
    density: 11.8,
    imprecise: false,
    latitude: 30.88225,
    longitude: -97.36952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76534',
  },
  {
    city: 'Jarrell',
    county_fips: 48491,
    county_fips_all: '48491',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"48491": 100}',
    density: 117.1,
    imprecise: false,
    latitude: 30.81779,
    longitude: -97.60645,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76537',
  },
  {
    city: 'Jonesboro',
    county_fips: 48193,
    county_fips_all: '48193|48099',
    county: 'Hamilton',
    county_names_all: 'Hamilton|Coryell',
    county_weights: '{"48193": 69.09, "48099": 30.91}',
    density: 2.2,
    imprecise: false,
    latitude: 31.64261,
    longitude: -97.8896,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76538',
  },
  {
    city: 'Kempner',
    county_fips: 48281,
    county_fips_all: '48281|48053|48027|48099',
    county: 'Lampasas',
    county_names_all: 'Lampasas|Burnet|Bell|Coryell',
    county_weights:
      '{"48281": 71.24, "48053": 21.94, "48027": 5.06, "48099": 1.76}',
    density: 30,
    imprecise: false,
    latitude: 31.09193,
    longitude: -97.9992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76539',
  },
  {
    city: 'Killeen',
    county_fips: 48027,
    county_fips_all: '48027',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"48027": 100}',
    density: 1500.7,
    imprecise: false,
    latitude: 31.11447,
    longitude: -97.72922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76541',
  },
  {
    city: 'Killeen',
    county_fips: 48027,
    county_fips_all: '48027',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"48027": 100}',
    density: 330.2,
    imprecise: false,
    latitude: 31.00062,
    longitude: -97.7274,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76542',
  },
  {
    city: 'Killeen',
    county_fips: 48027,
    county_fips_all: '48027',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"48027": 100}',
    density: 374,
    imprecise: false,
    latitude: 31.12343,
    longitude: -97.64077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76543',
  },
  {
    city: 'Fort Cavazos',
    county_fips: 48099,
    county_fips_all: '48099|48027',
    county: 'Coryell',
    county_names_all: 'Coryell|Bell',
    county_weights: '{"48099": 79.12, "48027": 20.88}',
    density: 292.7,
    imprecise: false,
    latitude: 31.23134,
    longitude: -97.75867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76544',
  },
  {
    city: 'Harker Heights',
    county_fips: 48027,
    county_fips_all: '48027',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"48027": 100}',
    density: 808.8,
    imprecise: false,
    latitude: 31.05299,
    longitude: -97.64613,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76548',
  },
  {
    city: 'Killeen',
    county_fips: 48027,
    county_fips_all: '48027|48053',
    county: 'Bell',
    county_names_all: 'Bell|Burnet',
    county_weights: '{"48027": 88.61, "48053": 11.39}',
    density: 229.9,
    imprecise: false,
    latitude: 31.01583,
    longitude: -97.82546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76549',
  },
  {
    city: 'Lampasas',
    county_fips: 48281,
    county_fips_all: '48281|48053',
    county: 'Lampasas',
    county_names_all: 'Lampasas|Burnet',
    county_weights: '{"48281": 58.37, "48053": 41.63}',
    density: 9.8,
    imprecise: false,
    latitude: 31.07714,
    longitude: -98.22165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76550',
  },
  {
    city: 'Little River Academy',
    county_fips: 48027,
    county_fips_all: '48027',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"48027": 100}',
    density: 113.1,
    imprecise: false,
    latitude: 30.97583,
    longitude: -97.3677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76554',
  },
  {
    city: 'Milano',
    county_fips: 48331,
    county_fips_all: '48331|48051',
    county: 'Milam',
    county_names_all: 'Milam|Burleson',
    county_weights: '{"48331": 99.24, "48051": 0.76}',
    density: 7.7,
    imprecise: false,
    latitude: 30.69481,
    longitude: -96.84487,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76556',
  },
  {
    city: 'Moody',
    county_fips: 48027,
    county_fips_all: '48027|48309|48099',
    county: 'Bell',
    county_names_all: 'Bell|McLennan|Coryell',
    county_weights: '{"48027": 44.38, "48309": 39.75, "48099": 15.86}',
    density: 17.6,
    imprecise: false,
    latitude: 31.29075,
    longitude: -97.39814,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76557',
  },
  {
    city: 'Nolanville',
    county_fips: 48027,
    county_fips_all: '48027',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"48027": 100}',
    density: 493.2,
    imprecise: false,
    latitude: 31.07987,
    longitude: -97.61079,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76559',
  },
  {
    city: 'Oglesby',
    county_fips: 48099,
    county_fips_all: '48099|48309',
    county: 'Coryell',
    county_names_all: 'Coryell|McLennan',
    county_weights: '{"48099": 89.52, "48309": 10.48}',
    density: 6.5,
    imprecise: false,
    latitude: 31.42531,
    longitude: -97.54098,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76561',
  },
  {
    city: 'Pottsville',
    county_fips: 48193,
    county_fips_all: '48193',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"48193": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.64508,
    longitude: -98.3492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76565',
  },
  {
    city: 'Purmela',
    county_fips: 48099,
    county_fips_all: '48099|48193',
    county: 'Coryell',
    county_names_all: 'Coryell|Hamilton',
    county_weights: '{"48099": 68.38, "48193": 31.62}',
    density: 2,
    imprecise: false,
    latitude: 31.51664,
    longitude: -97.99881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76566',
  },
  {
    city: 'Rockdale',
    county_fips: 48331,
    county_fips_all: '48331|48051',
    county: 'Milam',
    county_names_all: 'Milam|Burleson',
    county_weights: '{"48331": 90.63, "48051": 9.37}',
    density: 16.3,
    imprecise: false,
    latitude: 30.64535,
    longitude: -97.01363,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76567',
  },
  {
    city: 'Rogers',
    county_fips: 48027,
    county_fips_all: '48027|48331',
    county: 'Bell',
    county_names_all: 'Bell|Milam',
    county_weights: '{"48027": 72.62, "48331": 27.38}',
    density: 11.1,
    imprecise: false,
    latitude: 30.93873,
    longitude: -97.21904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76569',
  },
  {
    city: 'Rosebud',
    county_fips: 48145,
    county_fips_all: '48145|48331|48027',
    county: 'Falls',
    county_names_all: 'Falls|Milam|Bell',
    county_weights: '{"48145": 66.65, "48331": 32.93, "48027": 0.42}',
    density: 5,
    imprecise: false,
    latitude: 31.0818,
    longitude: -96.94173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76570',
  },
  {
    city: 'Salado',
    county_fips: 48027,
    county_fips_all: '48027',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"48027": 100}',
    density: 27.8,
    imprecise: false,
    latitude: 30.93305,
    longitude: -97.58448,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76571',
  },
  {
    city: 'Schwertner',
    county_fips: 48491,
    county_fips_all: '48491|48027',
    county: 'Williamson',
    county_names_all: 'Williamson|Bell',
    county_weights: '{"48491": 99.9, "48027": 0.1}',
    density: 0,
    imprecise: false,
    latitude: 30.81864,
    longitude: -97.50226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76573',
  },
  {
    city: 'Taylor',
    county_fips: 48491,
    county_fips_all: '48491|48453',
    county: 'Williamson',
    county_names_all: 'Williamson|Travis',
    county_weights: '{"48491": 99.86, "48453": 0.14}',
    density: 52.5,
    imprecise: false,
    latitude: 30.58297,
    longitude: -97.38967,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76574',
  },
  {
    city: 'Thorndale',
    county_fips: 48331,
    county_fips_all: '48331|48491',
    county: 'Milam',
    county_names_all: 'Milam|Williamson',
    county_weights: '{"48331": 90.27, "48491": 9.73}',
    density: 8.6,
    imprecise: false,
    latitude: 30.62128,
    longitude: -97.1787,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76577',
  },
  {
    city: 'Thrall',
    county_fips: 48491,
    county_fips_all: '48491|48331',
    county: 'Williamson',
    county_names_all: 'Williamson|Milam',
    county_weights: '{"48491": 99.21, "48331": 0.79}',
    density: 10.4,
    imprecise: false,
    latitude: 30.53488,
    longitude: -97.24092,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76578',
  },
  {
    city: 'Troy',
    county_fips: 48027,
    county_fips_all: '48027|48145',
    county: 'Bell',
    county_names_all: 'Bell|Falls',
    county_weights: '{"48027": 85.39, "48145": 14.61}',
    density: 35.3,
    imprecise: false,
    latitude: 31.19894,
    longitude: -97.26046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76579',
  },
  {
    city: 'Abbott',
    county_fips: 48217,
    county_fips_all: '48217|48309',
    county: 'Hill',
    county_names_all: 'Hill|McLennan',
    county_weights: '{"48217": 96.31, "48309": 3.69}',
    density: 6.3,
    imprecise: false,
    latitude: 31.87789,
    longitude: -97.08891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76621',
  },
  {
    city: 'Aquilla',
    county_fips: 48217,
    county_fips_all: '48217|48309',
    county: 'Hill',
    county_names_all: 'Hill|McLennan',
    county_weights: '{"48217": 97.9, "48309": 2.1}',
    density: 10.5,
    imprecise: false,
    latitude: 31.82032,
    longitude: -97.24942,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76622',
  },
  {
    city: 'Avalon',
    county_fips: 48139,
    county_fips_all: '48139',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"48139": 100}',
    density: 31.5,
    imprecise: false,
    latitude: 32.219,
    longitude: -96.78879,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76623',
  },
  {
    city: 'Axtell',
    county_fips: 48309,
    county_fips_all: '48309|48293',
    county: 'McLennan',
    county_names_all: 'McLennan|Limestone',
    county_weights: '{"48309": 87.55, "48293": 12.45}',
    density: 16.2,
    imprecise: false,
    latitude: 31.66671,
    longitude: -96.95099,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76624',
  },
  {
    city: 'Blooming Grove',
    county_fips: 48349,
    county_fips_all: '48349|48139',
    county: 'Navarro',
    county_names_all: 'Navarro|Ellis',
    county_weights: '{"48349": 94.79, "48139": 5.21}',
    density: 8.9,
    imprecise: false,
    latitude: 32.10522,
    longitude: -96.71615,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76626',
  },
  {
    city: 'Blum',
    county_fips: 48217,
    county_fips_all: '48217',
    county: 'Hill',
    county_names_all: 'Hill',
    county_weights: '{"48217": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 32.10511,
    longitude: -97.3881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76627',
  },
  {
    city: 'Brandon',
    county_fips: 48217,
    county_fips_all: '48217',
    county: 'Hill',
    county_names_all: 'Hill',
    county_weights: '{"48217": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 32.03007,
    longitude: -96.97179,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76628',
  },
  {
    city: 'Bremond',
    county_fips: 48395,
    county_fips_all: '48395|48145',
    county: 'Robertson',
    county_names_all: 'Robertson|Falls',
    county_weights: '{"48395": 81.71, "48145": 18.29}',
    density: 5.5,
    imprecise: false,
    latitude: 31.15114,
    longitude: -96.65499,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76629',
  },
  {
    city: 'Bruceville',
    county_fips: 48309,
    county_fips_all: '48309|48145',
    county: 'McLennan',
    county_names_all: 'McLennan|Falls',
    county_weights: '{"48309": 92.55, "48145": 7.45}',
    density: 39.3,
    imprecise: false,
    latitude: 31.33993,
    longitude: -97.22405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76630',
  },
  {
    city: 'Bynum',
    county_fips: 48217,
    county_fips_all: '48217',
    county: 'Hill',
    county_names_all: 'Hill',
    county_weights: '{"48217": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 31.97905,
    longitude: -96.96277,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76631',
  },
  {
    city: 'Chilton',
    county_fips: 48145,
    county_fips_all: '48145',
    county: 'Falls',
    county_names_all: 'Falls',
    county_weights: '{"48145": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 31.29602,
    longitude: -97.06158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76632',
  },
  {
    city: 'China Spring',
    county_fips: 48309,
    county_fips_all: '48309|48035',
    county: 'McLennan',
    county_names_all: 'McLennan|Bosque',
    county_weights: '{"48309": 73.62, "48035": 26.38}',
    density: 43.4,
    imprecise: false,
    latitude: 31.6857,
    longitude: -97.32503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76633',
  },
  {
    city: 'Clifton',
    county_fips: 48035,
    county_fips_all: '48035|48099',
    county: 'Bosque',
    county_names_all: 'Bosque|Coryell',
    county_weights: '{"48035": 97.9, "48099": 2.1}',
    density: 10.2,
    imprecise: false,
    latitude: 31.80953,
    longitude: -97.56866,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76634',
  },
  {
    city: 'Coolidge',
    county_fips: 48293,
    county_fips_all: '48293',
    county: 'Limestone',
    county_names_all: 'Limestone',
    county_weights: '{"48293": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 31.72956,
    longitude: -96.66483,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76635',
  },
  {
    city: 'Covington',
    county_fips: 48217,
    county_fips_all: '48217',
    county: 'Hill',
    county_names_all: 'Hill',
    county_weights: '{"48217": 100}',
    density: 15,
    imprecise: false,
    latitude: 32.17213,
    longitude: -97.28307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76636',
  },
  {
    city: 'Cranfills Gap',
    county_fips: 48035,
    county_fips_all: '48035|48193',
    county: 'Bosque',
    county_names_all: 'Bosque|Hamilton',
    county_weights: '{"48035": 56.83, "48193": 43.17}',
    density: 4.9,
    imprecise: false,
    latitude: 31.76631,
    longitude: -97.81817,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76637',
  },
  {
    city: 'Crawford',
    county_fips: 48309,
    county_fips_all: '48309',
    county: 'McLennan',
    county_names_all: 'McLennan',
    county_weights: '{"48309": 100}',
    density: 19.8,
    imprecise: false,
    latitude: 31.55487,
    longitude: -97.446,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76638',
  },
  {
    city: 'Dawson',
    county_fips: 48349,
    county_fips_all: '48349',
    county: 'Navarro',
    county_names_all: 'Navarro',
    county_weights: '{"48349": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 31.87254,
    longitude: -96.65551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76639',
  },
  {
    city: 'Elm Mott',
    county_fips: 48309,
    county_fips_all: '48309',
    county: 'McLennan',
    county_names_all: 'McLennan',
    county_weights: '{"48309": 100}',
    density: 42.2,
    imprecise: false,
    latitude: 31.69029,
    longitude: -97.07323,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76640',
  },
  {
    city: 'Frost',
    county_fips: 48349,
    county_fips_all: '48349|48139',
    county: 'Navarro',
    county_names_all: 'Navarro|Ellis',
    county_weights: '{"48349": 91.53, "48139": 8.47}',
    density: 13.3,
    imprecise: false,
    latitude: 32.03847,
    longitude: -96.78723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76641',
  },
  {
    city: 'Groesbeck',
    county_fips: 48293,
    county_fips_all: '48293',
    county: 'Limestone',
    county_names_all: 'Limestone',
    county_weights: '{"48293": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 31.50442,
    longitude: -96.53271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76642',
  },
  {
    city: 'Hewitt',
    county_fips: 48309,
    county_fips_all: '48309',
    county: 'McLennan',
    county_names_all: 'McLennan',
    county_weights: '{"48309": 100}',
    density: 834.8,
    imprecise: false,
    latitude: 31.45011,
    longitude: -97.19732,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76643',
  },
  {
    city: 'Hillsboro',
    county_fips: 48217,
    county_fips_all: '48217',
    county: 'Hill',
    county_names_all: 'Hill',
    county_weights: '{"48217": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 32.01224,
    longitude: -97.12816,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76645',
  },
  {
    city: 'Hubbard',
    county_fips: 48217,
    county_fips_all: '48217|48293|48349',
    county: 'Hill',
    county_names_all: 'Hill|Limestone|Navarro',
    county_weights: '{"48217": 74.22, "48293": 14.0, "48349": 11.78}',
    density: 10.4,
    imprecise: false,
    latitude: 31.84942,
    longitude: -96.80659,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76648',
  },
  {
    city: 'Iredell',
    county_fips: 48035,
    county_fips_all: '48035|48143',
    county: 'Bosque',
    county_names_all: 'Bosque|Erath',
    county_weights: '{"48035": 79.19, "48143": 20.81}',
    density: 2.5,
    imprecise: false,
    latitude: 32.00132,
    longitude: -97.87816,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76649',
  },
  {
    city: 'Irene',
    county_fips: 48217,
    county_fips_all: '48217',
    county: 'Hill',
    county_names_all: 'Hill',
    county_weights: '{"48217": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 31.98994,
    longitude: -96.86678,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76650',
  },
  {
    city: 'Italy',
    county_fips: 48139,
    county_fips_all: '48139',
    county: 'Ellis',
    county_names_all: 'Ellis',
    county_weights: '{"48139": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 32.18313,
    longitude: -96.87158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76651',
  },
  {
    city: 'Kopperl',
    county_fips: 48035,
    county_fips_all: '48035',
    county: 'Bosque',
    county_names_all: 'Bosque',
    county_weights: '{"48035": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 32.11331,
    longitude: -97.57648,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76652',
  },
  {
    city: 'Kosse',
    county_fips: 48293,
    county_fips_all: '48293|48145|48395',
    county: 'Limestone',
    county_names_all: 'Limestone|Falls|Robertson',
    county_weights: '{"48293": 57.59, "48145": 32.86, "48395": 9.55}',
    density: 2.7,
    imprecise: false,
    latitude: 31.29963,
    longitude: -96.60536,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76653',
  },
  {
    city: 'Leroy',
    county_fips: 48309,
    county_fips_all: '48309',
    county: 'McLennan',
    county_names_all: 'McLennan',
    county_weights: '{"48309": 100}',
    density: 75.2,
    imprecise: false,
    latitude: 31.72708,
    longitude: -97.01346,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76654',
  },
  {
    city: 'Lorena',
    county_fips: 48309,
    county_fips_all: '48309|48145',
    county: 'McLennan',
    county_names_all: 'McLennan|Falls',
    county_weights: '{"48309": 83.27, "48145": 16.73}',
    density: 52.7,
    imprecise: false,
    latitude: 31.39295,
    longitude: -97.1728,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76655',
  },
  {
    city: 'Lott',
    county_fips: 48145,
    county_fips_all: '48145',
    county: 'Falls',
    county_names_all: 'Falls',
    county_weights: '{"48145": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 31.18555,
    longitude: -97.06161,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76656',
  },
  {
    city: 'Mcgregor',
    county_fips: 48309,
    county_fips_all: '48309|48099',
    county: 'McLennan',
    county_names_all: 'McLennan|Coryell',
    county_weights: '{"48309": 92.49, "48099": 7.51}',
    density: 35.5,
    imprecise: false,
    latitude: 31.43851,
    longitude: -97.39971,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76657',
  },
  {
    city: 'Malone',
    county_fips: 48217,
    county_fips_all: '48217',
    county: 'Hill',
    county_names_all: 'Hill',
    county_weights: '{"48217": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 31.93015,
    longitude: -96.89331,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76660',
  },
  {
    city: 'Marlin',
    county_fips: 48145,
    county_fips_all: '48145',
    county: 'Falls',
    county_names_all: 'Falls',
    county_weights: '{"48145": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 31.30785,
    longitude: -96.84584,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76661',
  },
  {
    city: 'Mart',
    county_fips: 48293,
    county_fips_all: '48293|48309|48145',
    county: 'Limestone',
    county_names_all: 'Limestone|McLennan|Falls',
    county_weights: '{"48293": 64.69, "48309": 28.27, "48145": 7.04}',
    density: 9.4,
    imprecise: false,
    latitude: 31.56202,
    longitude: -96.79552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76664',
  },
  {
    city: 'Meridian',
    county_fips: 48035,
    county_fips_all: '48035',
    county: 'Bosque',
    county_names_all: 'Bosque',
    county_weights: '{"48035": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 31.91784,
    longitude: -97.72049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2771,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76665',
  },
  {
    city: 'Mertens',
    county_fips: 48217,
    county_fips_all: '48217|48349',
    county: 'Hill',
    county_names_all: 'Hill|Navarro',
    county_weights: '{"48217": 63.16, "48349": 36.84}',
    density: 3.6,
    imprecise: false,
    latitude: 32.04653,
    longitude: -96.89178,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76666',
  },
  {
    city: 'Mexia',
    county_fips: 48293,
    county_fips_all: '48293|48161',
    county: 'Limestone',
    county_names_all: 'Limestone|Freestone',
    county_weights: '{"48293": 82.29, "48161": 17.71}',
    density: 26.5,
    imprecise: false,
    latitude: 31.65668,
    longitude: -96.46511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76667',
  },
  {
    city: 'Milford',
    county_fips: 48139,
    county_fips_all: '48139|48217',
    county: 'Ellis',
    county_names_all: 'Ellis|Hill',
    county_weights: '{"48139": 62.55, "48217": 37.45}',
    density: 11.2,
    imprecise: false,
    latitude: 32.12887,
    longitude: -96.98836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76670',
  },
  {
    city: 'Morgan',
    county_fips: 48035,
    county_fips_all: '48035',
    county: 'Bosque',
    county_names_all: 'Bosque',
    county_weights: '{"48035": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 31.99351,
    longitude: -97.52768,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76671',
  },
  {
    city: 'Mount Calm',
    county_fips: 48217,
    county_fips_all: '48217|48293|48309',
    county: 'Hill',
    county_names_all: 'Hill|Limestone|McLennan',
    county_weights: '{"48217": 61.59, "48293": 37.5, "48309": 0.91}',
    density: 5.2,
    imprecise: false,
    latitude: 31.75371,
    longitude: -96.89105,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76673',
  },
  {
    city: 'Penelope',
    county_fips: 48217,
    county_fips_all: '48217',
    county: 'Hill',
    county_names_all: 'Hill',
    county_weights: '{"48217": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 31.87169,
    longitude: -96.95847,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76676',
  },
  {
    city: 'Prairie Hill',
    county_fips: 48293,
    county_fips_all: '48293',
    county: 'Limestone',
    county_names_all: 'Limestone',
    county_weights: '{"48293": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 31.65009,
    longitude: -96.75087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76678',
  },
  {
    city: 'Purdon',
    county_fips: 48349,
    county_fips_all: '48349',
    county: 'Navarro',
    county_names_all: 'Navarro',
    county_weights: '{"48349": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 31.94557,
    longitude: -96.59358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76679',
  },
  {
    city: 'Reagan',
    county_fips: 48145,
    county_fips_all: '48145',
    county: 'Falls',
    county_names_all: 'Falls',
    county_weights: '{"48145": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 31.18798,
    longitude: -96.80383,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76680',
  },
  {
    city: 'Richland',
    county_fips: 48349,
    county_fips_all: '48349',
    county: 'Navarro',
    county_names_all: 'Navarro',
    county_weights: '{"48349": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 31.91071,
    longitude: -96.44006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76681',
  },
  {
    city: 'Riesel',
    county_fips: 48145,
    county_fips_all: '48145|48309',
    county: 'Falls',
    county_names_all: 'Falls|McLennan',
    county_weights: '{"48145": 60.23, "48309": 39.77}',
    density: 11.4,
    imprecise: false,
    latitude: 31.45235,
    longitude: -96.90825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76682',
  },
  {
    city: 'Satin',
    county_fips: 48145,
    county_fips_all: '48145',
    county: 'Falls',
    county_names_all: 'Falls',
    county_weights: '{"48145": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 31.34973,
    longitude: -97.0101,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76685',
  },
  {
    city: 'Tehuacana',
    county_fips: 48293,
    county_fips_all: '48293',
    county: 'Limestone',
    county_names_all: 'Limestone',
    county_weights: '{"48293": 100}',
    density: 73.3,
    imprecise: false,
    latitude: 31.74178,
    longitude: -96.54464,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76686',
  },
  {
    city: 'Thornton',
    county_fips: 48293,
    county_fips_all: '48293|48395|48145',
    county: 'Limestone',
    county_names_all: 'Limestone|Robertson|Falls',
    county_weights: '{"48293": 81.95, "48395": 17.12, "48145": 0.93}',
    density: 5.4,
    imprecise: false,
    latitude: 31.36914,
    longitude: -96.48691,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76687',
  },
  {
    city: 'Valley Mills',
    county_fips: 48035,
    county_fips_all: '48035|48309|48099',
    county: 'Bosque',
    county_names_all: 'Bosque|McLennan|Coryell',
    county_weights: '{"48035": 58.75, "48309": 27.89, "48099": 13.36}',
    density: 7.9,
    imprecise: false,
    latitude: 31.66624,
    longitude: -97.50471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76689',
  },
  {
    city: 'Walnut Springs',
    county_fips: 48035,
    county_fips_all: '48035|48425|48143',
    county: 'Bosque',
    county_names_all: 'Bosque|Somervell|Erath',
    county_weights: '{"48035": 61.87, "48425": 34.82, "48143": 3.31}',
    density: 5.2,
    imprecise: false,
    latitude: 32.1031,
    longitude: -97.79219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76690',
  },
  {
    city: 'West',
    county_fips: 48309,
    county_fips_all: '48309|48217',
    county: 'McLennan',
    county_names_all: 'McLennan|Hill',
    county_weights: '{"48309": 92.6, "48217": 7.4}',
    density: 26.4,
    imprecise: false,
    latitude: 31.77564,
    longitude: -97.09721,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76691',
  },
  {
    city: 'Whitney',
    county_fips: 48217,
    county_fips_all: '48217',
    county: 'Hill',
    county_names_all: 'Hill',
    county_weights: '{"48217": 100}',
    density: 33.6,
    imprecise: false,
    latitude: 31.95902,
    longitude: -97.33382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76692',
  },
  {
    city: 'Wortham',
    county_fips: 48161,
    county_fips_all: '48161|48349|48293',
    county: 'Freestone',
    county_names_all: 'Freestone|Navarro|Limestone',
    county_weights: '{"48161": 52.13, "48349": 37.62, "48293": 10.25}',
    density: 7.1,
    imprecise: false,
    latitude: 31.80977,
    longitude: -96.43843,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76693',
  },
  {
    city: 'Waco',
    county_fips: 48309,
    county_fips_all: '48309',
    county: 'McLennan',
    county_names_all: 'McLennan',
    county_weights: '{"48309": 100}',
    density: 632.2,
    imprecise: false,
    latitude: 31.55201,
    longitude: -97.13852,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76701',
  },
  {
    city: 'Waco',
    county_fips: 48309,
    county_fips_all: '48309',
    county: 'McLennan',
    county_names_all: 'McLennan',
    county_weights: '{"48309": 100}',
    density: 501.5,
    imprecise: false,
    latitude: 31.57558,
    longitude: -97.12417,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76704',
  },
  {
    city: 'Waco',
    county_fips: 48309,
    county_fips_all: '48309',
    county: 'McLennan',
    county_names_all: 'McLennan',
    county_weights: '{"48309": 100}',
    density: 102.9,
    imprecise: false,
    latitude: 31.62448,
    longitude: -97.08814,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76705',
  },
  {
    city: 'Waco',
    county_fips: 48309,
    county_fips_all: '48309|48145',
    county: 'McLennan',
    county_names_all: 'McLennan|Falls',
    county_weights: '{"48309": 95.58, "48145": 4.42}',
    density: 222.3,
    imprecise: false,
    latitude: 31.465,
    longitude: -97.09131,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76706',
  },
  {
    city: 'Waco',
    county_fips: 48309,
    county_fips_all: '48309',
    county: 'McLennan',
    county_names_all: 'McLennan',
    county_weights: '{"48309": 100}',
    density: 1877.7,
    imprecise: false,
    latitude: 31.55365,
    longitude: -97.15829,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76707',
  },
  {
    city: 'Waco',
    county_fips: 48309,
    county_fips_all: '48309',
    county: 'McLennan',
    county_names_all: 'McLennan',
    county_weights: '{"48309": 100}',
    density: 223.3,
    imprecise: false,
    latitude: 31.62749,
    longitude: -97.21186,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76708',
  },
  {
    city: 'Waco',
    county_fips: 48309,
    county_fips_all: '48309',
    county: 'McLennan',
    county_names_all: 'McLennan',
    county_weights: '{"48309": 100}',
    density: 965.3,
    imprecise: false,
    latitude: 31.5387,
    longitude: -97.19554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76710',
  },
  {
    city: 'Waco',
    county_fips: 48309,
    county_fips_all: '48309',
    county: 'McLennan',
    county_names_all: 'McLennan',
    county_weights: '{"48309": 100}',
    density: 934.4,
    imprecise: false,
    latitude: 31.51422,
    longitude: -97.15374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76711',
  },
  {
    city: 'Woodway',
    county_fips: 48309,
    county_fips_all: '48309',
    county: 'McLennan',
    county_names_all: 'McLennan',
    county_weights: '{"48309": 100}',
    density: 214.6,
    imprecise: false,
    latitude: 31.52411,
    longitude: -97.25514,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76712',
  },
  {
    city: 'Brownwood',
    county_fips: 48049,
    county_fips_all: '48049|48083|48333',
    county: 'Brown',
    county_names_all: 'Brown|Coleman|Mills',
    county_weights: '{"48049": 94.87, "48083": 3.0, "48333": 2.13}',
    density: 25.8,
    imprecise: false,
    latitude: 31.75471,
    longitude: -99.05462,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76801',
  },
  {
    city: 'Early',
    county_fips: 48049,
    county_fips_all: '48049',
    county: 'Brown',
    county_names_all: 'Brown',
    county_weights: '{"48049": 100}',
    density: 20.8,
    imprecise: false,
    latitude: 31.7194,
    longitude: -98.8949,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76802',
  },
  {
    city: 'Art',
    county_fips: 48319,
    county_fips_all: '48319',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"48319": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 30.79295,
    longitude: -99.04508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76820',
  },
  {
    city: 'Ballinger',
    county_fips: 48399,
    county_fips_all: '48399',
    county: 'Runnels',
    county_names_all: 'Runnels',
    county_weights: '{"48399": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 31.73862,
    longitude: -99.94963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76821',
  },
  {
    city: 'Bangs',
    county_fips: 48049,
    county_fips_all: '48049|48083',
    county: 'Brown',
    county_names_all: 'Brown|Coleman',
    county_weights: '{"48049": 87.42, "48083": 12.58}',
    density: 11.7,
    imprecise: false,
    latitude: 31.68718,
    longitude: -99.16205,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76823',
  },
  {
    city: 'Bend',
    county_fips: 48411,
    county_fips_all: '48411|48299',
    county: 'San Saba',
    county_names_all: 'San Saba|Llano',
    county_weights: '{"48411": 99.89, "48299": 0.11}',
    density: 0,
    imprecise: false,
    latitude: 30.9411,
    longitude: -98.46339,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76824',
  },
  {
    city: 'Brady',
    county_fips: 48307,
    county_fips_all: '48307|48319',
    county: 'McCulloch',
    county_names_all: 'McCulloch|Mason',
    county_weights: '{"48307": 97.25, "48319": 2.75}',
    density: 5.2,
    imprecise: false,
    latitude: 31.09493,
    longitude: -99.39329,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76825',
  },
  {
    city: 'Brookesmith',
    county_fips: 48049,
    county_fips_all: '48049|48083',
    county: 'Brown',
    county_names_all: 'Brown|Coleman',
    county_weights: '{"48049": 93.12, "48083": 6.88}',
    density: 3.5,
    imprecise: false,
    latitude: 31.52589,
    longitude: -99.13031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76827',
  },
  {
    city: 'Burkett',
    county_fips: 48083,
    county_fips_all: '48083',
    county: 'Coleman',
    county_names_all: 'Coleman',
    county_weights: '{"48083": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 32.00728,
    longitude: -99.28435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76828',
  },
  {
    city: 'Castell',
    county_fips: 48299,
    county_fips_all: '48299|48319',
    county: 'Llano',
    county_names_all: 'Llano|Mason',
    county_weights: '{"48299": 99.85, "48319": 0.15}',
    density: 0,
    imprecise: false,
    latitude: 30.74599,
    longitude: -98.95543,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76831',
  },
  {
    city: 'Cherokee',
    county_fips: 48411,
    county_fips_all: '48411',
    county: 'San Saba',
    county_names_all: 'San Saba',
    county_weights: '{"48411": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 30.97485,
    longitude: -98.74384,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76832',
  },
  {
    city: 'Coleman',
    county_fips: 48083,
    county_fips_all: '48083',
    county: 'Coleman',
    county_names_all: 'Coleman',
    county_weights: '{"48083": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 31.87885,
    longitude: -99.46843,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76834',
  },
  {
    city: 'Doole',
    county_fips: 48307,
    county_fips_all: '48307|48095',
    county: 'McCulloch',
    county_names_all: 'McCulloch|Concho',
    county_weights: '{"48307": 61.23, "48095": 38.77}',
    density: 0.1,
    imprecise: false,
    latitude: 31.42409,
    longitude: -99.59196,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76836',
  },
  {
    city: 'Eden',
    county_fips: 48095,
    county_fips_all: '48095',
    county: 'Concho',
    county_names_all: 'Concho',
    county_weights: '{"48095": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 31.21098,
    longitude: -99.88176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76837',
  },
  {
    city: 'Fort McKavett',
    county_fips: 48413,
    county_fips_all: '48413|48327|48267',
    county: 'Schleicher',
    county_names_all: 'Schleicher|Menard|Kimble',
    county_weights: '{"48413": 67.56, "48327": 31.43, "48267": 1.01}',
    density: 0.4,
    imprecise: false,
    latitude: 30.86695,
    longitude: -100.14226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76841',
  },
  {
    city: 'Fredonia',
    county_fips: 48319,
    county_fips_all: '48319|48411',
    county: 'Mason',
    county_names_all: 'Mason|San Saba',
    county_weights: '{"48319": 59.37, "48411": 40.63}',
    density: 1.4,
    imprecise: false,
    latitude: 30.91888,
    longitude: -99.1023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76842',
  },
  {
    city: 'Goldthwaite',
    county_fips: 48333,
    county_fips_all: '48333|48193|48281',
    county: 'Mills',
    county_names_all: 'Mills|Hamilton|Lampasas',
    county_weights: '{"48333": 95.4, "48193": 3.22, "48281": 1.38}',
    density: 3.4,
    imprecise: false,
    latitude: 31.44387,
    longitude: -98.49348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76844',
  },
  {
    city: 'Gouldbusk',
    county_fips: 48083,
    county_fips_all: '48083',
    county: 'Coleman',
    county_names_all: 'Coleman',
    county_weights: '{"48083": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 31.54305,
    longitude: -99.48192,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76845',
  },
  {
    city: 'Hext',
    county_fips: 48327,
    county_fips_all: '48327',
    county: 'Menard',
    county_names_all: 'Menard',
    county_weights: '{"48327": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 30.83928,
    longitude: -99.5637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76848',
  },
  {
    city: 'Junction',
    county_fips: 48267,
    county_fips_all: '48267|48265',
    county: 'Kimble',
    county_names_all: 'Kimble|Kerr',
    county_weights: '{"48267": 97.0, "48265": 3.0}',
    density: 1.7,
    imprecise: false,
    latitude: 30.45849,
    longitude: -99.83805,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76849',
  },
  {
    city: 'Lohn',
    county_fips: 48307,
    county_fips_all: '48307',
    county: 'McCulloch',
    county_names_all: 'McCulloch',
    county_weights: '{"48307": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 31.35558,
    longitude: -99.44335,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76852',
  },
  {
    city: 'Lometa',
    county_fips: 48281,
    county_fips_all: '48281|48333|48411',
    county: 'Lampasas',
    county_names_all: 'Lampasas|Mills|San Saba',
    county_weights: '{"48281": 87.7, "48333": 11.6, "48411": 0.7}',
    density: 2.2,
    imprecise: false,
    latitude: 31.24774,
    longitude: -98.39047,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76853',
  },
  {
    city: 'London',
    county_fips: 48267,
    county_fips_all: '48267|48327',
    county: 'Kimble',
    county_names_all: 'Kimble|Menard',
    county_weights: '{"48267": 85.78, "48327": 14.22}',
    density: 0.6,
    imprecise: false,
    latitude: 30.57125,
    longitude: -99.53945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76854',
  },
  {
    city: 'Mason',
    county_fips: 48319,
    county_fips_all: '48319',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"48319": 100}',
    density: 2,
    imprecise: false,
    latitude: 30.70296,
    longitude: -99.26668,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76856',
  },
  {
    city: 'May',
    county_fips: 48049,
    county_fips_all: '48049|48093',
    county: 'Brown',
    county_names_all: 'Brown|Comanche',
    county_weights: '{"48049": 95.86, "48093": 4.14}',
    density: 6,
    imprecise: false,
    latitude: 31.93361,
    longitude: -98.93313,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76857',
  },
  {
    city: 'Melvin',
    county_fips: 48095,
    county_fips_all: '48095|48307',
    county: 'Concho',
    county_names_all: 'Concho|McCulloch',
    county_weights: '{"48095": 66.05, "48307": 33.95}',
    density: 0.6,
    imprecise: false,
    latitude: 31.20758,
    longitude: -99.62002,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76858',
  },
  {
    city: 'Menard',
    county_fips: 48327,
    county_fips_all: '48327|48267',
    county: 'Menard',
    county_names_all: 'Menard|Kimble',
    county_weights: '{"48327": 85.69, "48267": 14.31}',
    density: 0.7,
    imprecise: false,
    latitude: 30.87106,
    longitude: -99.83123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76859',
  },
  {
    city: 'Miles',
    county_fips: 48451,
    county_fips_all: '48451|48399',
    county: 'Tom Green',
    county_names_all: 'Tom Green|Runnels',
    county_weights: '{"48451": 59.98, "48399": 40.02}',
    density: 4.9,
    imprecise: false,
    latitude: 31.59216,
    longitude: -100.19637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76861',
  },
  {
    city: 'Millersview',
    county_fips: 48095,
    county_fips_all: '48095',
    county: 'Concho',
    county_names_all: 'Concho',
    county_weights: '{"48095": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 31.4138,
    longitude: -99.70944,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76862',
  },
  {
    city: 'Mullin',
    county_fips: 48333,
    county_fips_all: '48333',
    county: 'Mills',
    county_names_all: 'Mills',
    county_weights: '{"48333": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 31.54561,
    longitude: -98.73637,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76864',
  },
  {
    city: 'Norton',
    county_fips: 48399,
    county_fips_all: '48399',
    county: 'Runnels',
    county_names_all: 'Runnels',
    county_weights: '{"48399": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 31.84944,
    longitude: -100.13663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76865',
  },
  {
    city: 'Paint Rock',
    county_fips: 48095,
    county_fips_all: '48095',
    county: 'Concho',
    county_names_all: 'Concho',
    county_weights: '{"48095": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 31.45181,
    longitude: -99.92922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76866',
  },
  {
    city: 'Pontotoc',
    county_fips: 48411,
    county_fips_all: '48411|48319|48299',
    county: 'San Saba',
    county_names_all: 'San Saba|Mason|Llano',
    county_weights: '{"48411": 39.1, "48319": 37.99, "48299": 22.91}',
    density: 0,
    imprecise: false,
    latitude: 30.90951,
    longitude: -98.97464,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76869',
  },
  {
    city: 'Priddy',
    county_fips: 48333,
    county_fips_all: '48333',
    county: 'Mills',
    county_names_all: 'Mills',
    county_weights: '{"48333": 100}',
    density: 1,
    imprecise: false,
    latitude: 31.60386,
    longitude: -98.53151,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76870',
  },
  {
    city: 'Richland Springs',
    county_fips: 48411,
    county_fips_all: '48411|48307',
    county: 'San Saba',
    county_names_all: 'San Saba|McCulloch',
    county_weights: '{"48411": 90.8, "48307": 9.2}',
    density: 1.2,
    imprecise: false,
    latitude: 31.27333,
    longitude: -98.995,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76871',
  },
  {
    city: 'Rochelle',
    county_fips: 48307,
    county_fips_all: '48307|48411',
    county: 'McCulloch',
    county_names_all: 'McCulloch|San Saba',
    county_weights: '{"48307": 79.33, "48411": 20.67}',
    density: 1,
    imprecise: false,
    latitude: 31.3357,
    longitude: -99.1603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76872',
  },
  {
    city: 'Rockwood',
    county_fips: 48083,
    county_fips_all: '48083',
    county: 'Coleman',
    county_names_all: 'Coleman',
    county_weights: '{"48083": 100}',
    density: 1,
    imprecise: false,
    latitude: 31.50459,
    longitude: -99.3696,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76873',
  },
  {
    city: 'Roosevelt',
    county_fips: 48267,
    county_fips_all: '48267|48435',
    county: 'Kimble',
    county_names_all: 'Kimble|Sutton',
    county_weights: '{"48267": 56.68, "48435": 43.32}',
    density: 0,
    imprecise: false,
    latitude: 30.47693,
    longitude: -100.12271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76874',
  },
  {
    city: 'Rowena',
    county_fips: 48399,
    county_fips_all: '48399|48095',
    county: 'Runnels',
    county_names_all: 'Runnels|Concho',
    county_weights: '{"48399": 62.63, "48095": 37.37}',
    density: 1.3,
    imprecise: false,
    latitude: 31.59928,
    longitude: -100.00749,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76875',
  },
  {
    city: 'San Saba',
    county_fips: 48411,
    county_fips_all: '48411',
    county: 'San Saba',
    county_names_all: 'San Saba',
    county_weights: '{"48411": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 31.15807,
    longitude: -98.75361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76877',
  },
  {
    city: 'Santa Anna',
    county_fips: 48083,
    county_fips_all: '48083',
    county: 'Coleman',
    county_names_all: 'Coleman',
    county_weights: '{"48083": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 31.66659,
    longitude: -99.29611,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76878',
  },
  {
    city: 'Star',
    county_fips: 48333,
    county_fips_all: '48333',
    county: 'Mills',
    county_names_all: 'Mills',
    county_weights: '{"48333": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.44491,
    longitude: -98.3151,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76880',
  },
  {
    city: 'Talpa',
    county_fips: 48399,
    county_fips_all: '48399|48083',
    county: 'Runnels',
    county_names_all: 'Runnels|Coleman',
    county_weights: '{"48399": 54.84, "48083": 45.16}',
    density: 0.6,
    imprecise: false,
    latitude: 31.80059,
    longitude: -99.71448,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76882',
  },
  {
    city: 'Valera',
    county_fips: 48083,
    county_fips_all: '48083',
    county: 'Coleman',
    county_names_all: 'Coleman',
    county_weights: '{"48083": 100}',
    density: 3,
    imprecise: false,
    latitude: 31.69654,
    longitude: -99.56407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76884',
  },
  {
    city: 'Valley Spring',
    county_fips: 48299,
    county_fips_all: '48299',
    county: 'Llano',
    county_names_all: 'Llano',
    county_weights: '{"48299": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 30.87304,
    longitude: -98.85742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76885',
  },
  {
    city: 'Voca',
    county_fips: 48307,
    county_fips_all: '48307',
    county: 'McCulloch',
    county_names_all: 'McCulloch',
    county_weights: '{"48307": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 31.02696,
    longitude: -99.15806,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76887',
  },
  {
    city: 'Voss',
    county_fips: 48083,
    county_fips_all: '48083',
    county: 'Coleman',
    county_names_all: 'Coleman',
    county_weights: '{"48083": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 31.60919,
    longitude: -99.63742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76888',
  },
  {
    city: 'Zephyr',
    county_fips: 48049,
    county_fips_all: '48049|48333|48093',
    county: 'Brown',
    county_names_all: 'Brown|Mills|Comanche',
    county_weights: '{"48049": 78.21, "48333": 19.72, "48093": 2.07}',
    density: 3.8,
    imprecise: false,
    latitude: 31.69229,
    longitude: -98.7649,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76890',
  },
  {
    city: 'San Angelo',
    county_fips: 48451,
    county_fips_all: '48451|48235',
    county: 'Tom Green',
    county_names_all: 'Tom Green|Irion',
    county_weights: '{"48451": 72.83, "48235": 27.17}',
    density: 35.5,
    imprecise: false,
    latitude: 31.52352,
    longitude: -100.63993,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76901',
  },
  {
    city: 'San Angelo',
    county_fips: 48451,
    county_fips_all: '48451',
    county: 'Tom Green',
    county_names_all: 'Tom Green',
    county_weights: '{"48451": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.54439,
    longitude: -100.72459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76902',
  },
  {
    city: 'San Angelo',
    county_fips: 48451,
    county_fips_all: '48451',
    county: 'Tom Green',
    county_names_all: 'Tom Green',
    county_weights: '{"48451": 100}',
    density: 461.7,
    imprecise: false,
    latitude: 31.48168,
    longitude: -100.43787,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76903',
  },
  {
    city: 'San Angelo',
    county_fips: 48451,
    county_fips_all: '48451|48235',
    county: 'Tom Green',
    county_names_all: 'Tom Green|Irion',
    county_weights: '{"48451": 92.26, "48235": 7.74}',
    density: 32.4,
    imprecise: false,
    latitude: 31.28844,
    longitude: -100.41695,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76904',
  },
  {
    city: 'San Angelo',
    county_fips: 48451,
    county_fips_all: '48451',
    county: 'Tom Green',
    county_names_all: 'Tom Green',
    county_weights: '{"48451": 100}',
    density: 30.4,
    imprecise: false,
    latitude: 31.49987,
    longitude: -100.31583,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76905',
  },
  {
    city: 'Goodfellow Afb',
    county_fips: 48451,
    county_fips_all: '48451',
    county: 'Tom Green',
    county_names_all: 'Tom Green',
    county_weights: '{"48451": 100}',
    density: 327.7,
    imprecise: false,
    latitude: 31.43226,
    longitude: -100.40314,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76908',
  },
  {
    city: 'Barnhart',
    county_fips: 48235,
    county_fips_all: '48235|48105',
    county: 'Irion',
    county_names_all: 'Irion|Crockett',
    county_weights: '{"48235": 50.21, "48105": 49.79}',
    density: 0.1,
    imprecise: false,
    latitude: 31.11075,
    longitude: -101.11975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76930',
  },
  {
    city: 'Big Lake',
    county_fips: 48383,
    county_fips_all: '48383|48105',
    county: 'Reagan',
    county_names_all: 'Reagan|Crockett',
    county_weights: '{"48383": 63.1, "48105": 36.9}',
    density: 1.1,
    imprecise: false,
    latitude: 31.19124,
    longitude: -101.54984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76932',
  },
  {
    city: 'Bronte',
    county_fips: 48081,
    county_fips_all: '48081|48399',
    county: 'Coke',
    county_names_all: 'Coke|Runnels',
    county_weights: '{"48081": 69.84, "48399": 30.16}',
    density: 2,
    imprecise: false,
    latitude: 31.87618,
    longitude: -100.28544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76933',
  },
  {
    city: 'Carlsbad',
    county_fips: 48451,
    county_fips_all: '48451',
    county: 'Tom Green',
    county_names_all: 'Tom Green',
    county_weights: '{"48451": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 31.61491,
    longitude: -100.67661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76934',
  },
  {
    city: 'Christoval',
    county_fips: 48413,
    county_fips_all: '48413|48451',
    county: 'Schleicher',
    county_names_all: 'Schleicher|Tom Green',
    county_weights: '{"48413": 51.07, "48451": 48.93}',
    density: 1.8,
    imprecise: false,
    latitude: 31.07744,
    longitude: -100.42261,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76935',
  },
  {
    city: 'Eldorado',
    county_fips: 48413,
    county_fips_all: '48413',
    county: 'Schleicher',
    county_names_all: 'Schleicher',
    county_weights: '{"48413": 100}',
    density: 1,
    imprecise: false,
    latitude: 30.88811,
    longitude: -100.64723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76936',
  },
  {
    city: 'Eola',
    county_fips: 48451,
    county_fips_all: '48451|48095',
    county: 'Tom Green',
    county_names_all: 'Tom Green|Concho',
    county_weights: '{"48451": 80.39, "48095": 19.61}',
    density: 5.7,
    imprecise: false,
    latitude: 31.39109,
    longitude: -100.15025,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76937',
  },
  {
    city: 'Knickerbocker',
    county_fips: 48451,
    county_fips_all: '48451',
    county: 'Tom Green',
    county_names_all: 'Tom Green',
    county_weights: '{"48451": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.26855,
    longitude: -100.59028,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76939',
  },
  {
    city: 'Mereta',
    county_fips: 48451,
    county_fips_all: '48451',
    county: 'Tom Green',
    county_names_all: 'Tom Green',
    county_weights: '{"48451": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 31.43681,
    longitude: -100.12694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76940',
  },
  {
    city: 'Mertzon',
    county_fips: 48235,
    county_fips_all: '48235',
    county: 'Irion',
    county_names_all: 'Irion',
    county_weights: '{"48235": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 31.24731,
    longitude: -100.89845,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76941',
  },
  {
    city: 'Ozona',
    county_fips: 48105,
    county_fips_all: '48105|48465',
    county: 'Crockett',
    county_names_all: 'Crockett|Val Verde',
    county_weights: '{"48105": 74.39, "48465": 25.61}',
    density: 0.5,
    imprecise: false,
    latitude: 30.48057,
    longitude: -101.32623,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76943',
  },
  {
    city: 'Robert Lee',
    county_fips: 48081,
    county_fips_all: '48081|48451|48431',
    county: 'Coke',
    county_names_all: 'Coke|Tom Green|Sterling',
    county_weights: '{"48081": 94.88, "48451": 4.06, "48431": 1.06}',
    density: 1,
    imprecise: false,
    latitude: 31.87297,
    longitude: -100.60292,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76945',
  },
  {
    city: 'Sonora',
    county_fips: 48435,
    county_fips_all: '48435|48137|48465',
    county: 'Sutton',
    county_names_all: 'Sutton|Edwards|Val Verde',
    county_weights: '{"48435": 79.31, "48137": 13.26, "48465": 7.43}',
    density: 0.7,
    imprecise: false,
    latitude: 30.43439,
    longitude: -100.56564,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76950',
  },
  {
    city: 'Sterling City',
    county_fips: 48431,
    county_fips_all: '48431',
    county: 'Sterling',
    county_names_all: 'Sterling',
    county_weights: '{"48431": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 31.81255,
    longitude: -101.04709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76951',
  },
  {
    city: 'Tennyson',
    county_fips: 48081,
    county_fips_all: '48081|48451',
    county: 'Coke',
    county_names_all: 'Coke|Tom Green',
    county_weights: '{"48081": 99.8, "48451": 0.2}',
    density: 0.3,
    imprecise: false,
    latitude: 31.72871,
    longitude: -100.32078,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76953',
  },
  {
    city: 'Vancourt',
    county_fips: 48451,
    county_fips_all: '48451|48095',
    county: 'Tom Green',
    county_names_all: 'Tom Green|Concho',
    county_weights: '{"48451": 74.06, "48095": 25.94}',
    density: 0.4,
    imprecise: false,
    latitude: 31.29919,
    longitude: -100.1389,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76955',
  },
  {
    city: 'Wall',
    county_fips: 48451,
    county_fips_all: '48451',
    county: 'Tom Green',
    county_names_all: 'Tom Green',
    county_weights: '{"48451": 100}',
    density: 73.6,
    imprecise: false,
    latitude: 31.37232,
    longitude: -100.30514,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76957',
  },
  {
    city: 'Water Valley',
    county_fips: 48451,
    county_fips_all: '48451',
    county: 'Tom Green',
    county_names_all: 'Tom Green',
    county_weights: '{"48451": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 31.64467,
    longitude: -100.75515,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76958',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 4119.4,
    imprecise: false,
    latitude: 29.75635,
    longitude: -95.36538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77002',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1435.5,
    imprecise: false,
    latitude: 29.74961,
    longitude: -95.34521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77003',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2651.9,
    imprecise: false,
    latitude: 29.72477,
    longitude: -95.36498,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77004',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2912.2,
    imprecise: false,
    latitude: 29.71824,
    longitude: -95.42413,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28874,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77005',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 4196,
    imprecise: false,
    latitude: 29.74086,
    longitude: -95.39126,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77006',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2458.9,
    imprecise: false,
    latitude: 29.77152,
    longitude: -95.40919,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77007',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2481.1,
    imprecise: false,
    latitude: 29.79856,
    longitude: -95.41766,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77008',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2229.1,
    imprecise: false,
    latitude: 29.79499,
    longitude: -95.36758,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77009',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2321.1,
    imprecise: false,
    latitude: 29.75368,
    longitude: -95.35987,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77010',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1691.4,
    imprecise: false,
    latitude: 29.743,
    longitude: -95.30785,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77011',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1599.2,
    imprecise: false,
    latitude: 29.71904,
    longitude: -95.27449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77012',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 743.3,
    imprecise: false,
    latitude: 29.79516,
    longitude: -95.23895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77013',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1943.7,
    imprecise: false,
    latitude: 29.98025,
    longitude: -95.46363,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77014',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1092.1,
    imprecise: false,
    latitude: 29.76485,
    longitude: -95.17216,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77015',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1162.7,
    imprecise: false,
    latitude: 29.86147,
    longitude: -95.29951,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77016',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1195.5,
    imprecise: false,
    latitude: 29.69153,
    longitude: -95.25093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77017',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1770.4,
    imprecise: false,
    latitude: 29.82703,
    longitude: -95.42571,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77018',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2470.5,
    imprecise: false,
    latitude: 29.75318,
    longitude: -95.41212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77019',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1171.1,
    imprecise: false,
    latitude: 29.76842,
    longitude: -95.30878,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77020',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1661.7,
    imprecise: false,
    latitude: 29.69713,
    longitude: -95.35751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77021',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1705.7,
    imprecise: false,
    latitude: 29.8306,
    longitude: -95.3768,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77022',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1714.8,
    imprecise: false,
    latitude: 29.7216,
    longitude: -95.31827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77023',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1139.7,
    imprecise: false,
    latitude: 29.77073,
    longitude: -95.50869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77024',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2571.1,
    imprecise: false,
    latitude: 29.68584,
    longitude: -95.43512,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77025',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1293.6,
    imprecise: false,
    latitude: 29.80013,
    longitude: -95.32934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77026',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2944.7,
    imprecise: false,
    latitude: 29.73919,
    longitude: -95.44609,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77027',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 809.9,
    imprecise: false,
    latitude: 29.82471,
    longitude: -95.28668,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77028',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 587.5,
    imprecise: false,
    latitude: 29.76382,
    longitude: -95.26326,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77029',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2001.5,
    imprecise: false,
    latitude: 29.70597,
    longitude: -95.40253,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77030',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201|48157',
    county: 'Harris',
    county_names_all: 'Harris|Fort Bend',
    county_weights: '{"48201": 99.14, "48157": 0.86}',
    density: 1856.6,
    imprecise: false,
    latitude: 29.65434,
    longitude: -95.54622,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77031',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 207.3,
    imprecise: false,
    latitude: 29.96523,
    longitude: -95.34004,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77032',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1971.8,
    imprecise: false,
    latitude: 29.66801,
    longitude: -95.33801,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77033',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 991.8,
    imprecise: false,
    latitude: 29.61522,
    longitude: -95.19237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77034',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2465.1,
    imprecise: false,
    latitude: 29.65269,
    longitude: -95.47688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77035',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 3809.2,
    imprecise: false,
    latitude: 29.70119,
    longitude: -95.53659,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 71770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77036',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1191.9,
    imprecise: false,
    latitude: 29.8918,
    longitude: -95.39438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77037',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1299,
    imprecise: false,
    latitude: 29.91906,
    longitude: -95.44121,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77038',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1065.7,
    imprecise: false,
    latitude: 29.90923,
    longitude: -95.34137,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77039',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1421.6,
    imprecise: false,
    latitude: 29.87539,
    longitude: -95.52861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77040',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 682.1,
    imprecise: false,
    latitude: 29.86203,
    longitude: -95.58187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77041',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2424.1,
    imprecise: false,
    latitude: 29.74125,
    longitude: -95.56015,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77042',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 791.9,
    imprecise: false,
    latitude: 29.8112,
    longitude: -95.57981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77043',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 576.2,
    imprecise: false,
    latitude: 29.89808,
    longitude: -95.17685,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77044',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1162.1,
    imprecise: false,
    latitude: 29.63634,
    longitude: -95.43279,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77045',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 6463.3,
    imprecise: false,
    latitude: 29.73438,
    longitude: -95.43301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77046',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 978.8,
    imprecise: false,
    latitude: 29.60843,
    longitude: -95.38662,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34987,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77047',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 708.5,
    imprecise: false,
    latitude: 29.62154,
    longitude: -95.32986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77048',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 644.8,
    imprecise: false,
    latitude: 29.83417,
    longitude: -95.14827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77049',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 369.1,
    imprecise: false,
    latitude: 29.90286,
    longitude: -95.27013,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77050',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1035.3,
    imprecise: false,
    latitude: 29.65586,
    longitude: -95.38023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77051',
  },
  {
    city: 'Houston',
    county_fips: 48157,
    county_fips_all: '48157|48201',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend|Harris',
    county_weights: '{"48157": 68.9, "48201": 31.1}',
    density: 1024.7,
    imprecise: false,
    latitude: 29.58549,
    longitude: -95.45991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77053',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2041.4,
    imprecise: false,
    latitude: 29.68102,
    longitude: -95.40424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77054',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2091.9,
    imprecise: false,
    latitude: 29.79757,
    longitude: -95.4928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77055',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2555.2,
    imprecise: false,
    latitude: 29.74849,
    longitude: -95.46806,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77056',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 4197.4,
    imprecise: false,
    latitude: 29.74522,
    longitude: -95.48885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77057',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201|48167',
    county: 'Harris',
    county_names_all: 'Harris|Galveston',
    county_weights: '{"48201": 99.42, "48167": 0.58}',
    density: 824,
    imprecise: false,
    latitude: 29.56297,
    longitude: -95.09303,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77058',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 784.7,
    imprecise: false,
    latitude: 29.60929,
    longitude: -95.12417,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77059',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2148.2,
    imprecise: false,
    latitude: 29.93567,
    longitude: -95.39697,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77060',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1242,
    imprecise: false,
    latitude: 29.65436,
    longitude: -95.28481,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77061',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1695.2,
    imprecise: false,
    latitude: 29.57584,
    longitude: -95.13406,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77062',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 3686.1,
    imprecise: false,
    latitude: 29.7356,
    longitude: -95.52157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77063',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1302,
    imprecise: false,
    latitude: 29.92279,
    longitude: -95.5467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77064',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1829,
    imprecise: false,
    latitude: 29.92673,
    longitude: -95.60324,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77065',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1757.5,
    imprecise: false,
    latitude: 29.95714,
    longitude: -95.50277,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77066',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2072.5,
    imprecise: false,
    latitude: 29.95283,
    longitude: -95.44719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77067',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1342.2,
    imprecise: false,
    latitude: 30.00628,
    longitude: -95.48694,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77068',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1693.4,
    imprecise: false,
    latitude: 29.98631,
    longitude: -95.52398,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77069',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1723.4,
    imprecise: false,
    latitude: 29.97783,
    longitude: -95.57377,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77070',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2323.8,
    imprecise: false,
    latitude: 29.65265,
    longitude: -95.52046,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77071',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2972.3,
    imprecise: false,
    latitude: 29.70006,
    longitude: -95.58539,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77072',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1222,
    imprecise: false,
    latitude: 29.99849,
    longitude: -95.39804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77073',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2713.8,
    imprecise: false,
    latitude: 29.68821,
    longitude: -95.51633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77074',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1398.9,
    imprecise: false,
    latitude: 29.62119,
    longitude: -95.26749,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77075',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2538.9,
    imprecise: false,
    latitude: 29.86002,
    longitude: -95.38328,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77076',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1402.8,
    imprecise: false,
    latitude: 29.75375,
    longitude: -95.64189,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 60098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77077',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 534.7,
    imprecise: false,
    latitude: 29.8529,
    longitude: -95.25089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77078',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1860.6,
    imprecise: false,
    latitude: 29.77632,
    longitude: -95.6037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77079',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2872.3,
    imprecise: false,
    latitude: 29.81662,
    longitude: -95.52375,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77080',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 5953.8,
    imprecise: false,
    latitude: 29.71219,
    longitude: -95.48026,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77081',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201|48157',
    county: 'Harris',
    county_names_all: 'Harris|Fort Bend',
    county_weights: '{"48201": 99.79, "48157": 0.21}',
    density: 1822.7,
    imprecise: false,
    latitude: 29.72383,
    longitude: -95.6414,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 59412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77082',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201|48157',
    county: 'Harris',
    county_names_all: 'Harris|Fort Bend',
    county_weights: '{"48201": 59.81, "48157": 40.19}',
    density: 2727.8,
    imprecise: false,
    latitude: 29.69316,
    longitude: -95.64858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 73230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77083',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1341,
    imprecise: false,
    latitude: 29.82698,
    longitude: -95.6612,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 110217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77084',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201|48157',
    county: 'Harris',
    county_names_all: 'Harris|Fort Bend',
    county_weights: '{"48201": 96.91, "48157": 3.09}',
    density: 1163.1,
    imprecise: false,
    latitude: 29.62465,
    longitude: -95.48411,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77085',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1619,
    imprecise: false,
    latitude: 29.9186,
    longitude: -95.49064,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77086',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2022.9,
    imprecise: false,
    latitude: 29.68631,
    longitude: -95.3034,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77087',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1984.5,
    imprecise: false,
    latitude: 29.88148,
    longitude: -95.45316,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77088',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1710.4,
    imprecise: false,
    latitude: 29.58698,
    longitude: -95.2257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77089',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1809.2,
    imprecise: false,
    latitude: 30.00845,
    longitude: -95.44317,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77090',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1557.6,
    imprecise: false,
    latitude: 29.85382,
    longitude: -95.43969,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77091',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1760.8,
    imprecise: false,
    latitude: 29.83153,
    longitude: -95.47521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77092',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1491.9,
    imprecise: false,
    latitude: 29.8623,
    longitude: -95.34097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77093',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1170.3,
    imprecise: false,
    latitude: 29.7738,
    longitude: -95.69955,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77094',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1827.3,
    imprecise: false,
    latitude: 29.90834,
    longitude: -95.65492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 69767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77095',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2245.9,
    imprecise: false,
    latitude: 29.67464,
    longitude: -95.47965,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77096',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 3769.6,
    imprecise: false,
    latitude: 29.73482,
    longitude: -95.41526,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77098',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201|48157',
    county: 'Harris',
    county_names_all: 'Harris|Fort Bend',
    county_weights: '{"48201": 95.07, "48157": 4.93}',
    density: 3153.7,
    imprecise: false,
    latitude: 29.67067,
    longitude: -95.58485,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77099',
  },
  {
    city: 'Conroe',
    county_fips: 48339,
    county_fips_all: '48339',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"48339": 100}',
    density: 722.9,
    imprecise: false,
    latitude: 30.30897,
    longitude: -95.43281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77301',
  },
  {
    city: 'Conroe',
    county_fips: 48339,
    county_fips_all: '48339',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"48339": 100}',
    density: 157.3,
    imprecise: false,
    latitude: 30.22626,
    longitude: -95.36014,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77302',
  },
  {
    city: 'Conroe',
    county_fips: 48339,
    county_fips_all: '48339',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"48339": 100}',
    density: 182.9,
    imprecise: false,
    latitude: 30.37569,
    longitude: -95.37937,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77303',
  },
  {
    city: 'Conroe',
    county_fips: 48339,
    county_fips_all: '48339',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"48339": 100}',
    density: 426.5,
    imprecise: false,
    latitude: 30.33097,
    longitude: -95.51538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77304',
  },
  {
    city: 'Conroe',
    county_fips: 48339,
    county_fips_all: '48339',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"48339": 100}',
    density: 170,
    imprecise: false,
    latitude: 30.2799,
    longitude: -95.31337,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77306',
  },
  {
    city: 'Montgomery',
    county_fips: 48339,
    county_fips_all: '48339|48185',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Grimes',
    county_weights: '{"48339": 96.16, "48185": 3.84}',
    density: 103.8,
    imprecise: false,
    latitude: 30.30974,
    longitude: -95.68528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77316',
  },
  {
    city: 'Willis',
    county_fips: 48339,
    county_fips_all: '48339',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"48339": 100}',
    density: 216.7,
    imprecise: false,
    latitude: 30.44709,
    longitude: -95.54364,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77318',
  },
  {
    city: 'Huntsville',
    county_fips: 48471,
    county_fips_all: '48471|48407',
    county: 'Walker',
    county_names_all: 'Walker|San Jacinto',
    county_weights: '{"48471": 91.4, "48407": 8.6}',
    density: 42.9,
    imprecise: false,
    latitude: 30.80672,
    longitude: -95.55687,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77320',
  },
  {
    city: 'Ace',
    county_fips: 48373,
    county_fips_all: '48373',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"48373": 100}',
    density: 41.1,
    imprecise: false,
    latitude: 30.50445,
    longitude: -94.81661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77326',
  },
  {
    city: 'Cleveland',
    county_fips: 48291,
    county_fips_all: '48291',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"48291": 100}',
    density: 48.6,
    imprecise: false,
    latitude: 30.3262,
    longitude: -94.91826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77327',
  },
  {
    city: 'Cleveland',
    county_fips: 48407,
    county_fips_all: '48407|48339|48291',
    county: 'San Jacinto',
    county_names_all: 'San Jacinto|Montgomery|Liberty',
    county_weights: '{"48407": 70.05, "48339": 21.59, "48291": 8.36}',
    density: 36.8,
    imprecise: false,
    latitude: 30.40767,
    longitude: -95.18888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77328',
  },
  {
    city: 'Coldspring',
    county_fips: 48407,
    county_fips_all: '48407',
    county: 'San Jacinto',
    county_names_all: 'San Jacinto',
    county_weights: '{"48407": 100}',
    density: 17,
    imprecise: false,
    latitude: 30.61928,
    longitude: -95.17706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77331',
  },
  {
    city: 'Dodge',
    county_fips: 48471,
    county_fips_all: '48471',
    county: 'Walker',
    county_names_all: 'Walker',
    county_weights: '{"48471": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 30.77996,
    longitude: -95.36465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77334',
  },
  {
    city: 'Goodrich',
    county_fips: 48373,
    county_fips_all: '48373',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"48373": 100}',
    density: 25,
    imprecise: false,
    latitude: 30.58901,
    longitude: -94.92353,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77335',
  },
  {
    city: 'Huffman',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 155.3,
    imprecise: false,
    latitude: 30.06842,
    longitude: -95.10306,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77336',
  },
  {
    city: 'Humble',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 712.2,
    imprecise: false,
    latitude: 30.00858,
    longitude: -95.28351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77338',
  },
  {
    city: 'Kingwood',
    county_fips: 48201,
    county_fips_all: '48201|48339',
    county: 'Harris',
    county_names_all: 'Harris|Montgomery',
    county_weights: '{"48201": 77.11, "48339": 22.89}',
    density: 1070.8,
    imprecise: false,
    latitude: 30.04788,
    longitude: -95.22139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77339',
  },
  {
    city: 'Huntsville',
    county_fips: 48471,
    county_fips_all: '48471',
    county: 'Walker',
    county_names_all: 'Walker',
    county_weights: '{"48471": 100}',
    density: 68,
    imprecise: false,
    latitude: 30.64601,
    longitude: -95.53441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77340',
  },
  {
    city: 'Huntsville',
    county_fips: 48471,
    county_fips_all: '48471',
    county: 'Walker',
    county_names_all: 'Walker',
    county_weights: '{"48471": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.73877,
    longitude: -95.55911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77342',
  },
  {
    city: 'Kingwood',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1285.7,
    imprecise: false,
    latitude: 30.05392,
    longitude: -95.15884,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77345',
  },
  {
    city: 'Humble',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1713.2,
    imprecise: false,
    latitude: 29.99027,
    longitude: -95.17777,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 79538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77346',
  },
  {
    city: 'Leggett',
    county_fips: 48373,
    county_fips_all: '48373',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"48373": 100}',
    density: 21.7,
    imprecise: false,
    latitude: 30.81432,
    longitude: -94.90086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77350',
  },
  {
    city: 'Livingston',
    county_fips: 48373,
    county_fips_all: '48373',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"48373": 100}',
    density: 22.5,
    imprecise: false,
    latitude: 30.70411,
    longitude: -94.81682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77351',
  },
  {
    city: 'Magnolia',
    county_fips: 48339,
    county_fips_all: '48339',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"48339": 100}',
    density: 233.5,
    imprecise: false,
    latitude: 30.21113,
    longitude: -95.65003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77354',
  },
  {
    city: 'Magnolia',
    county_fips: 48339,
    county_fips_all: '48339|48473',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Waller',
    county_weights: '{"48339": 90.13, "48473": 9.87}',
    density: 228.2,
    imprecise: false,
    latitude: 30.1579,
    longitude: -95.75014,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77355',
  },
  {
    city: 'Montgomery',
    county_fips: 48339,
    county_fips_all: '48339|48185',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Grimes',
    county_weights: '{"48339": 97.94, "48185": 2.06}',
    density: 98.9,
    imprecise: false,
    latitude: 30.44807,
    longitude: -95.70358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77356',
  },
  {
    city: 'New Caney',
    county_fips: 48339,
    county_fips_all: '48339|48201|48291',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Harris|Liberty',
    county_weights: '{"48339": 81.84, "48201": 10.54, "48291": 7.62}',
    density: 216.3,
    imprecise: false,
    latitude: 30.15694,
    longitude: -95.18173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77357',
  },
  {
    city: 'New Waverly',
    county_fips: 48471,
    county_fips_all: '48471|48407|48339',
    county: 'Walker',
    county_names_all: 'Walker|San Jacinto|Montgomery',
    county_weights: '{"48471": 72.76, "48407": 20.95, "48339": 6.29}',
    density: 17.7,
    imprecise: false,
    latitude: 30.55061,
    longitude: -95.45419,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77358',
  },
  {
    city: 'Oakhurst',
    county_fips: 48407,
    county_fips_all: '48407',
    county: 'San Jacinto',
    county_names_all: 'San Jacinto',
    county_weights: '{"48407": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 30.76262,
    longitude: -95.30441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77359',
  },
  {
    city: 'Onalaska',
    county_fips: 48373,
    county_fips_all: '48373',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"48373": 100}',
    density: 72.9,
    imprecise: false,
    latitude: 30.8471,
    longitude: -95.11394,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77360',
  },
  {
    city: 'Pinehurst',
    county_fips: 48339,
    county_fips_all: '48339|48201',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Harris',
    county_weights: '{"48339": 99.89, "48201": 0.11}',
    density: 289.4,
    imprecise: false,
    latitude: 30.16003,
    longitude: -95.67237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77362',
  },
  {
    city: 'Plantersville',
    county_fips: 48185,
    county_fips_all: '48185|48473',
    county: 'Grimes',
    county_names_all: 'Grimes|Waller',
    county_weights: '{"48185": 98.13, "48473": 1.87}',
    density: 22.8,
    imprecise: false,
    latitude: 30.3267,
    longitude: -95.85732,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77363',
  },
  {
    city: 'Pointblank',
    county_fips: 48407,
    county_fips_all: '48407',
    county: 'San Jacinto',
    county_names_all: 'San Jacinto',
    county_weights: '{"48407": 100}',
    density: 27.3,
    imprecise: false,
    latitude: 30.76592,
    longitude: -95.22168,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77364',
  },
  {
    city: 'Porter',
    county_fips: 48339,
    county_fips_all: '48339|48201',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Harris',
    county_weights: '{"48339": 96.22, "48201": 3.78}',
    density: 433.2,
    imprecise: false,
    latitude: 30.11638,
    longitude: -95.2747,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77365',
  },
  {
    city: 'Riverside',
    county_fips: 48471,
    county_fips_all: '48471',
    county: 'Walker',
    county_names_all: 'Walker',
    county_weights: '{"48471": 100}',
    density: 201.5,
    imprecise: false,
    latitude: 30.8504,
    longitude: -95.39147,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77367',
  },
  {
    city: 'Romayor',
    county_fips: 48291,
    county_fips_all: '48291',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"48291": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.45114,
    longitude: -94.8407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77368',
  },
  {
    city: 'Rye',
    county_fips: 48291,
    county_fips_all: '48291|48199',
    county: 'Liberty',
    county_names_all: 'Liberty|Hardin',
    county_weights: '{"48291": 97.37, "48199": 2.63}',
    density: 11.5,
    imprecise: false,
    latitude: 30.44296,
    longitude: -94.75084,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77369',
  },
  {
    city: 'Shepherd',
    county_fips: 48407,
    county_fips_all: '48407|48291',
    county: 'San Jacinto',
    county_names_all: 'San Jacinto|Liberty',
    county_weights: '{"48407": 99.84, "48291": 0.16}',
    density: 25.6,
    imprecise: false,
    latitude: 30.49376,
    longitude: -94.98146,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77371',
  },
  {
    city: 'Splendora',
    county_fips: 48339,
    county_fips_all: '48339|48291',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Liberty',
    county_weights: '{"48339": 87.51, "48291": 12.49}',
    density: 107.7,
    imprecise: false,
    latitude: 30.24472,
    longitude: -95.18281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77372',
  },
  {
    city: 'Spring',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1133.2,
    imprecise: false,
    latitude: 30.06143,
    longitude: -95.38423,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 69739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77373',
  },
  {
    city: 'Thicket',
    county_fips: 48199,
    county_fips_all: '48199',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"48199": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 30.38226,
    longitude: -94.63069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77374',
  },
  {
    city: 'Tomball',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 792.4,
    imprecise: false,
    latitude: 30.09393,
    longitude: -95.59095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 72311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77375',
  },
  {
    city: 'Votaw',
    county_fips: 48199,
    county_fips_all: '48199',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"48199": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 30.44422,
    longitude: -94.6779,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77376',
  },
  {
    city: 'Tomball',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 456.7,
    imprecise: false,
    latitude: 30.06141,
    longitude: -95.67608,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77377',
  },
  {
    city: 'Willis',
    county_fips: 48339,
    county_fips_all: '48339|48407',
    county: 'Montgomery',
    county_names_all: 'Montgomery|San Jacinto',
    county_weights: '{"48339": 60.6, "48407": 39.4}',
    density: 76.4,
    imprecise: false,
    latitude: 30.45873,
    longitude: -95.37454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77378',
  },
  {
    city: 'Spring',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1273.8,
    imprecise: false,
    latitude: 30.03966,
    longitude: -95.53305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 85190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77379',
  },
  {
    city: 'Spring',
    county_fips: 48339,
    county_fips_all: '48339',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"48339": 100}',
    density: 974.5,
    imprecise: false,
    latitude: 30.1365,
    longitude: -95.46863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77380',
  },
  {
    city: 'Spring',
    county_fips: 48339,
    county_fips_all: '48339',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"48339": 100}',
    density: 1101,
    imprecise: false,
    latitude: 30.17791,
    longitude: -95.50266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77381',
  },
  {
    city: 'Spring',
    county_fips: 48339,
    county_fips_all: '48339',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"48339": 100}',
    density: 1254.1,
    imprecise: false,
    latitude: 30.19961,
    longitude: -95.5455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77382',
  },
  {
    city: 'Conroe',
    county_fips: 48339,
    county_fips_all: '48339',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"48339": 100}',
    density: 560.6,
    imprecise: false,
    latitude: 30.23453,
    longitude: -95.49675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77384',
  },
  {
    city: 'Conroe',
    county_fips: 48339,
    county_fips_all: '48339',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"48339": 100}',
    density: 500.9,
    imprecise: false,
    latitude: 30.1894,
    longitude: -95.42264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77385',
  },
  {
    city: 'Spring',
    county_fips: 48339,
    county_fips_all: '48339',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"48339": 100}',
    density: 662.9,
    imprecise: false,
    latitude: 30.10153,
    longitude: -95.3561,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 69980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77386',
  },
  {
    city: 'Spring',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1540.8,
    imprecise: false,
    latitude: 30.05957,
    longitude: -95.46764,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77388',
  },
  {
    city: 'Spring',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 829.7,
    imprecise: false,
    latitude: 30.11509,
    longitude: -95.50752,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77389',
  },
  {
    city: 'Humble',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 958.1,
    imprecise: false,
    latitude: 29.94778,
    longitude: -95.26129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 61735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77396',
  },
  {
    city: 'Bellaire',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1825.2,
    imprecise: false,
    latitude: 29.70398,
    longitude: -95.46192,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77401',
  },
  {
    city: 'Richmond',
    county_fips: 48157,
    county_fips_all: '48157',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend',
    county_weights: '{"48157": 100}',
    density: 468.7,
    imprecise: false,
    latitude: 29.64571,
    longitude: -95.79184,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 69918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77406',
  },
  {
    city: 'Richmond',
    county_fips: 48157,
    county_fips_all: '48157',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend',
    county_weights: '{"48157": 100}',
    density: 1705.7,
    imprecise: false,
    latitude: 29.67658,
    longitude: -95.71455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 88319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77407',
  },
  {
    city: 'Altair',
    county_fips: 48089,
    county_fips_all: '48089',
    county: 'Colorado',
    county_names_all: 'Colorado',
    county_weights: '{"48089": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 29.56693,
    longitude: -96.46031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77412',
  },
  {
    city: 'Bay City',
    county_fips: 48321,
    county_fips_all: '48321',
    county: 'Matagorda',
    county_names_all: 'Matagorda',
    county_weights: '{"48321": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 28.90601,
    longitude: -95.8935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77414',
  },
  {
    city: 'Cedar Lane',
    county_fips: 48321,
    county_fips_all: '48321',
    county: 'Matagorda',
    county_names_all: 'Matagorda',
    county_weights: '{"48321": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 28.93425,
    longitude: -95.72035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77415',
  },
  {
    city: 'Beasley',
    county_fips: 48157,
    county_fips_all: '48157',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend',
    county_weights: '{"48157": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 29.46633,
    longitude: -95.9621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77417',
  },
  {
    city: 'Bellville',
    county_fips: 48015,
    county_fips_all: '48015',
    county: 'Austin',
    county_names_all: 'Austin',
    county_weights: '{"48015": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 29.97922,
    longitude: -96.25063,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77418',
  },
  {
    city: 'Blessing',
    county_fips: 48321,
    county_fips_all: '48321',
    county: 'Matagorda',
    county_names_all: 'Matagorda',
    county_weights: '{"48321": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 28.8692,
    longitude: -96.25603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77419',
  },
  {
    city: 'Boling',
    county_fips: 48481,
    county_fips_all: '48481|48321|48157',
    county: 'Wharton',
    county_names_all: 'Wharton|Matagorda|Fort Bend',
    county_weights: '{"48481": 62.12, "48321": 26.09, "48157": 11.79}',
    density: 9.8,
    imprecise: false,
    latitude: 29.23404,
    longitude: -95.91908,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77420',
  },
  {
    city: 'Brazoria',
    county_fips: 48039,
    county_fips_all: '48039',
    county: 'Brazoria',
    county_names_all: 'Brazoria',
    county_weights: '{"48039": 100}',
    density: 32.8,
    imprecise: false,
    latitude: 28.96492,
    longitude: -95.57268,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77422',
  },
  {
    city: 'Brookshire',
    county_fips: 48473,
    county_fips_all: '48473|48157',
    county: 'Waller',
    county_names_all: 'Waller|Fort Bend',
    county_weights: '{"48473": 91.93, "48157": 8.07}',
    density: 48.8,
    imprecise: false,
    latitude: 29.83386,
    longitude: -95.98219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77423',
  },
  {
    city: 'Chappell Hill',
    county_fips: 48477,
    county_fips_all: '48477|48015',
    county: 'Washington',
    county_names_all: 'Washington|Austin',
    county_weights: '{"48477": 78.74, "48015": 21.26}',
    density: 8.6,
    imprecise: false,
    latitude: 30.11633,
    longitude: -96.24721,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77426',
  },
  {
    city: 'Collegeport',
    county_fips: 48321,
    county_fips_all: '48321',
    county: 'Matagorda',
    county_names_all: 'Matagorda',
    county_weights: '{"48321": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 28.67447,
    longitude: -96.15682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77428',
  },
  {
    city: 'Cypress',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 984.2,
    imprecise: false,
    latitude: 29.99068,
    longitude: -95.65808,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 96334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77429',
  },
  {
    city: 'Damon',
    county_fips: 48039,
    county_fips_all: '48039|48157',
    county: 'Brazoria',
    county_names_all: 'Brazoria|Fort Bend',
    county_weights: '{"48039": 79.58, "48157": 20.42}',
    density: 5.5,
    imprecise: false,
    latitude: 29.26487,
    longitude: -95.65616,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77430',
  },
  {
    city: 'Danciger',
    county_fips: 48039,
    county_fips_all: '48039',
    county: 'Brazoria',
    county_names_all: 'Brazoria',
    county_weights: '{"48039": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 29.13239,
    longitude: -95.82309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77431',
  },
  {
    city: 'Danevang',
    county_fips: 48481,
    county_fips_all: '48481',
    county: 'Wharton',
    county_names_all: 'Wharton',
    county_weights: '{"48481": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.05808,
    longitude: -96.21608,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77432',
  },
  {
    city: 'Cypress',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 763.1,
    imprecise: false,
    latitude: 29.9492,
    longitude: -95.73979,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 116550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77433',
  },
  {
    city: 'Eagle Lake',
    county_fips: 48089,
    county_fips_all: '48089|48481',
    county: 'Colorado',
    county_names_all: 'Colorado|Wharton',
    county_weights: '{"48089": 66.22, "48481": 33.78}',
    density: 10.5,
    imprecise: false,
    latitude: 29.52577,
    longitude: -96.31983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77434',
  },
  {
    city: 'East Bernard',
    county_fips: 48481,
    county_fips_all: '48481|48157|48089',
    county: 'Wharton',
    county_names_all: 'Wharton|Fort Bend|Colorado',
    county_weights: '{"48481": 89.67, "48157": 7.29, "48089": 3.04}',
    density: 10.4,
    imprecise: false,
    latitude: 29.51111,
    longitude: -96.12395,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77435',
  },
  {
    city: 'Egypt',
    county_fips: 48481,
    county_fips_all: '48481',
    county: 'Wharton',
    county_names_all: 'Wharton',
    county_weights: '{"48481": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 29.38874,
    longitude: -96.23832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77436',
  },
  {
    city: 'El Campo',
    county_fips: 48481,
    county_fips_all: '48481',
    county: 'Wharton',
    county_names_all: 'Wharton',
    county_weights: '{"48481": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 29.20452,
    longitude: -96.27328,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77437',
  },
  {
    city: 'Elmaton',
    county_fips: 48321,
    county_fips_all: '48321',
    county: 'Matagorda',
    county_names_all: 'Matagorda',
    county_weights: '{"48321": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 28.88819,
    longitude: -96.14603,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77440',
  },
  {
    city: 'Fulshear',
    county_fips: 48157,
    county_fips_all: '48157',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend',
    county_weights: '{"48157": 100}',
    density: 623.9,
    imprecise: false,
    latitude: 29.6955,
    longitude: -95.90896,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77441',
  },
  {
    city: 'Garwood',
    county_fips: 48089,
    county_fips_all: '48089',
    county: 'Colorado',
    county_names_all: 'Colorado',
    county_weights: '{"48089": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 29.43708,
    longitude: -96.49757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77442',
  },
  {
    city: 'Glen Flora',
    county_fips: 48481,
    county_fips_all: '48481',
    county: 'Wharton',
    county_names_all: 'Wharton',
    county_weights: '{"48481": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.35835,
    longitude: -96.18255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77443',
  },
  {
    city: 'Guy',
    county_fips: 48157,
    county_fips_all: '48157|48039',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend|Brazoria',
    county_weights: '{"48157": 50.24, "48039": 49.76}',
    density: 9,
    imprecise: false,
    latitude: 29.29641,
    longitude: -95.77794,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77444',
  },
  {
    city: 'Hempstead',
    county_fips: 48473,
    county_fips_all: '48473',
    county: 'Waller',
    county_names_all: 'Waller',
    county_weights: '{"48473": 100}',
    density: 33.5,
    imprecise: false,
    latitude: 30.09562,
    longitude: -96.06247,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77445',
  },
  {
    city: 'Prairie View',
    county_fips: 48473,
    county_fips_all: '48473',
    county: 'Waller',
    county_names_all: 'Waller',
    county_weights: '{"48473": 100}',
    density: 841,
    imprecise: false,
    latitude: 30.0871,
    longitude: -95.9895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77446',
  },
  {
    city: 'Hockley',
    county_fips: 48201,
    county_fips_all: '48201|48473|48339',
    county: 'Harris',
    county_names_all: 'Harris|Waller|Montgomery',
    county_weights: '{"48201": 66.99, "48473": 28.17, "48339": 4.84}',
    density: 94.2,
    imprecise: false,
    latitude: 30.05178,
    longitude: -95.82868,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77447',
  },
  {
    city: 'Hungerford',
    county_fips: 48481,
    county_fips_all: '48481',
    county: 'Wharton',
    county_names_all: 'Wharton',
    county_weights: '{"48481": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 29.4147,
    longitude: -96.08746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77448',
  },
  {
    city: 'Katy',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1856.7,
    imprecise: false,
    latitude: 29.83674,
    longitude: -95.73547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77449',
  },
  {
    city: 'Katy',
    county_fips: 48201,
    county_fips_all: '48201|48157',
    county: 'Harris',
    county_names_all: 'Harris|Fort Bend',
    county_weights: '{"48201": 64.55, "48157": 35.45}',
    density: 1411,
    imprecise: false,
    latitude: 29.74753,
    longitude: -95.73696,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 71906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77450',
  },
  {
    city: 'Kendleton',
    county_fips: 48157,
    county_fips_all: '48157|48481',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend|Wharton',
    county_weights: '{"48157": 99.9, "48481": 0.1}',
    density: 28.8,
    imprecise: false,
    latitude: 29.46173,
    longitude: -96.02688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77451',
  },
  {
    city: 'Lane City',
    county_fips: 48481,
    county_fips_all: '48481',
    county: 'Wharton',
    county_names_all: 'Wharton',
    county_weights: '{"48481": 100}',
    density: 10,
    imprecise: false,
    latitude: 29.23303,
    longitude: -96.01802,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77453',
  },
  {
    city: 'Lissie',
    county_fips: 48481,
    county_fips_all: '48481',
    county: 'Wharton',
    county_names_all: 'Wharton',
    county_weights: '{"48481": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 29.54304,
    longitude: -96.23044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77454',
  },
  {
    city: 'Louise',
    county_fips: 48481,
    county_fips_all: '48481|48089|48239',
    county: 'Wharton',
    county_names_all: 'Wharton|Colorado|Jackson',
    county_weights: '{"48481": 89.09, "48089": 5.49, "48239": 5.42}',
    density: 3,
    imprecise: false,
    latitude: 29.14017,
    longitude: -96.43782,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77455',
  },
  {
    city: 'Markham',
    county_fips: 48321,
    county_fips_all: '48321',
    county: 'Matagorda',
    county_names_all: 'Matagorda',
    county_weights: '{"48321": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 28.9511,
    longitude: -96.1136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77456',
  },
  {
    city: 'Matagorda',
    county_fips: 48321,
    county_fips_all: '48321',
    county: 'Matagorda',
    county_names_all: 'Matagorda',
    county_weights: '{"48321": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 28.70119,
    longitude: -95.94076,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77457',
  },
  {
    city: 'Midfield',
    county_fips: 48321,
    county_fips_all: '48321',
    county: 'Matagorda',
    county_names_all: 'Matagorda',
    county_weights: '{"48321": 100}',
    density: 0,
    imprecise: false,
    latitude: 28.95409,
    longitude: -96.25489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77458',
  },
  {
    city: 'Missouri City',
    county_fips: 48157,
    county_fips_all: '48157',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend',
    county_weights: '{"48157": 100}',
    density: 1040.1,
    imprecise: false,
    latitude: 29.52691,
    longitude: -95.53407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 84221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77459',
  },
  {
    city: 'Nada',
    county_fips: 48089,
    county_fips_all: '48089',
    county: 'Colorado',
    county_names_all: 'Colorado',
    county_weights: '{"48089": 100}',
    density: 42.2,
    imprecise: false,
    latitude: 29.39744,
    longitude: -96.38451,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77460',
  },
  {
    city: 'Needville',
    county_fips: 48157,
    county_fips_all: '48157',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend',
    county_weights: '{"48157": 100}',
    density: 31.7,
    imprecise: false,
    latitude: 29.39159,
    longitude: -95.77345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77461',
  },
  {
    city: 'Orchard',
    county_fips: 48157,
    county_fips_all: '48157',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend',
    county_weights: '{"48157": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 29.61807,
    longitude: -95.94148,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77464',
  },
  {
    city: 'Palacios',
    county_fips: 48321,
    county_fips_all: '48321|48239|48057',
    county: 'Matagorda',
    county_names_all: 'Matagorda|Jackson|Calhoun',
    county_weights: '{"48321": 82.89, "48239": 15.11, "48057": 2.0}',
    density: 12.8,
    imprecise: false,
    latitude: 28.71152,
    longitude: -96.22545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77465',
  },
  {
    city: 'Pattison',
    county_fips: 48473,
    county_fips_all: '48473',
    county: 'Waller',
    county_names_all: 'Waller',
    county_weights: '{"48473": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 29.80003,
    longitude: -96.01085,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77466',
  },
  {
    city: 'Pierce',
    county_fips: 48481,
    county_fips_all: '48481',
    county: 'Wharton',
    county_names_all: 'Wharton',
    county_weights: '{"48481": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 29.23345,
    longitude: -96.18563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77467',
  },
  {
    city: 'Pledger',
    county_fips: 48321,
    county_fips_all: '48321',
    county: 'Matagorda',
    county_names_all: 'Matagorda',
    county_weights: '{"48321": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.14681,
    longitude: -95.85173,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77468',
  },
  {
    city: 'Richmond',
    county_fips: 48157,
    county_fips_all: '48157',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend',
    county_weights: '{"48157": 100}',
    density: 252.5,
    imprecise: false,
    latitude: 29.49229,
    longitude: -95.70571,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 69826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77469',
  },
  {
    city: 'Rock Island',
    county_fips: 48089,
    county_fips_all: '48089',
    county: 'Colorado',
    county_names_all: 'Colorado',
    county_weights: '{"48089": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 29.52775,
    longitude: -96.55305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77470',
  },
  {
    city: 'Rosenberg',
    county_fips: 48157,
    county_fips_all: '48157',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend',
    county_weights: '{"48157": 100}',
    density: 178.1,
    imprecise: false,
    latitude: 29.55159,
    longitude: -95.86785,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77471',
  },
  {
    city: 'San Felipe',
    county_fips: 48015,
    county_fips_all: '48015',
    county: 'Austin',
    county_names_all: 'Austin',
    county_weights: '{"48015": 100}',
    density: 188.4,
    imprecise: false,
    latitude: 29.79459,
    longitude: -96.1038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77473',
  },
  {
    city: 'Sealy',
    county_fips: 48015,
    county_fips_all: '48015|48089',
    county: 'Austin',
    county_names_all: 'Austin|Colorado',
    county_weights: '{"48015": 98.1, "48089": 1.9}',
    density: 28.3,
    imprecise: false,
    latitude: 29.77583,
    longitude: -96.18518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77474',
  },
  {
    city: 'Sheridan',
    county_fips: 48089,
    county_fips_all: '48089',
    county: 'Colorado',
    county_names_all: 'Colorado',
    county_weights: '{"48089": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 29.50419,
    longitude: -96.66026,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77475',
  },
  {
    city: 'Simonton',
    county_fips: 48157,
    county_fips_all: '48157',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend',
    county_weights: '{"48157": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 29.67551,
    longitude: -95.97105,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77476',
  },
  {
    city: 'Stafford',
    county_fips: 48157,
    county_fips_all: '48157|48201',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend|Harris',
    county_weights: '{"48157": 94.77, "48201": 5.23}',
    density: 1276.9,
    imprecise: false,
    latitude: 29.62625,
    longitude: -95.56718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77477',
  },
  {
    city: 'Sugar Land',
    county_fips: 48157,
    county_fips_all: '48157',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend',
    county_weights: '{"48157": 100}',
    density: 893.2,
    imprecise: false,
    latitude: 29.61896,
    longitude: -95.6077,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77478',
  },
  {
    city: 'Sugar Land',
    county_fips: 48157,
    county_fips_all: '48157',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend',
    county_weights: '{"48157": 100}',
    density: 1089.8,
    imprecise: false,
    latitude: 29.56503,
    longitude: -95.6346,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 92221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77479',
  },
  {
    city: 'Sweeny',
    county_fips: 48039,
    county_fips_all: '48039|48321',
    county: 'Brazoria',
    county_names_all: 'Brazoria|Matagorda',
    county_weights: '{"48039": 81.91, "48321": 18.09}',
    density: 23.6,
    imprecise: false,
    latitude: 29.09388,
    longitude: -95.76692,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77480',
  },
  {
    city: 'Thompsons',
    county_fips: 48157,
    county_fips_all: '48157',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend',
    county_weights: '{"48157": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 29.47053,
    longitude: -95.56975,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 78,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77481',
  },
  {
    city: 'Van Vleck',
    county_fips: 48321,
    county_fips_all: '48321',
    county: 'Matagorda',
    county_names_all: 'Matagorda',
    county_weights: '{"48321": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 29.09351,
    longitude: -95.88411,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77482',
  },
  {
    city: 'Wadsworth',
    county_fips: 48321,
    county_fips_all: '48321',
    county: 'Matagorda',
    county_names_all: 'Matagorda',
    county_weights: '{"48321": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 28.77467,
    longitude: -95.86638,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77483',
  },
  {
    city: 'Waller',
    county_fips: 48473,
    county_fips_all: '48473|48201|48185',
    county: 'Waller',
    county_names_all: 'Waller|Harris|Grimes',
    county_weights: '{"48473": 77.97, "48201": 20.93, "48185": 1.1}',
    density: 36.7,
    imprecise: false,
    latitude: 30.07924,
    longitude: -95.92812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77484',
  },
  {
    city: 'Wallis',
    county_fips: 48015,
    county_fips_all: '48015|48157',
    county: 'Austin',
    county_names_all: 'Austin|Fort Bend',
    county_weights: '{"48015": 59.12, "48157": 40.88}',
    density: 21.9,
    imprecise: false,
    latitude: 29.64118,
    longitude: -96.06236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77485',
  },
  {
    city: 'West Columbia',
    county_fips: 48039,
    county_fips_all: '48039',
    county: 'Brazoria',
    county_names_all: 'Brazoria',
    county_weights: '{"48039": 100}',
    density: 57.6,
    imprecise: false,
    latitude: 29.15495,
    longitude: -95.6805,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77486',
  },
  {
    city: 'Wharton',
    county_fips: 48481,
    county_fips_all: '48481',
    county: 'Wharton',
    county_names_all: 'Wharton',
    county_weights: '{"48481": 100}',
    density: 25,
    imprecise: false,
    latitude: 29.29833,
    longitude: -96.09821,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77488',
  },
  {
    city: 'Missouri City',
    county_fips: 48157,
    county_fips_all: '48157|48201',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend|Harris',
    county_weights: '{"48157": 96.33, "48201": 3.67}',
    density: 1342.8,
    imprecise: false,
    latitude: 29.60068,
    longitude: -95.51605,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77489',
  },
  {
    city: 'Katy',
    county_fips: 48201,
    county_fips_all: '48201|48473|48157',
    county: 'Harris',
    county_names_all: 'Harris|Waller|Fort Bend',
    county_weights: '{"48201": 68.29, "48473": 31.61, "48157": 0.1}',
    density: 446.7,
    imprecise: false,
    latitude: 29.85193,
    longitude: -95.83025,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 71484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77493',
  },
  {
    city: 'Katy',
    county_fips: 48157,
    county_fips_all: '48157|48473|48201',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend|Waller|Harris',
    county_weights: '{"48157": 85.08, "48473": 7.93, "48201": 6.99}',
    density: 1428.4,
    imprecise: false,
    latitude: 29.74566,
    longitude: -95.82302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 140157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77494',
  },
  {
    city: 'Sugar Land',
    county_fips: 48157,
    county_fips_all: '48157',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend',
    county_weights: '{"48157": 100}',
    density: 1265.9,
    imprecise: false,
    latitude: 29.64224,
    longitude: -95.65244,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77498',
  },
  {
    city: 'Pasadena',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2569.5,
    imprecise: false,
    latitude: 29.67984,
    longitude: -95.19953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77502',
  },
  {
    city: 'Pasadena',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1453.2,
    imprecise: false,
    latitude: 29.69078,
    longitude: -95.15781,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77503',
  },
  {
    city: 'Pasadena',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1781,
    imprecise: false,
    latitude: 29.64766,
    longitude: -95.19007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77504',
  },
  {
    city: 'Pasadena',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1066.8,
    imprecise: false,
    latitude: 29.64895,
    longitude: -95.14284,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77505',
  },
  {
    city: 'Pasadena',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1198.4,
    imprecise: false,
    latitude: 29.71786,
    longitude: -95.19018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77506',
  },
  {
    city: 'Pasadena',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 29.62332,
    longitude: -95.06582,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77507',
  },
  {
    city: 'Santa Fe',
    county_fips: 48167,
    county_fips_all: '48167|48039',
    county: 'Galveston',
    county_names_all: 'Galveston|Brazoria',
    county_weights: '{"48167": 93.54, "48039": 6.46}',
    density: 179.6,
    imprecise: false,
    latitude: 29.34788,
    longitude: -95.09089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77510',
  },
  {
    city: 'Alvin',
    county_fips: 48039,
    county_fips_all: '48039|48167',
    county: 'Brazoria',
    county_names_all: 'Brazoria|Galveston',
    county_weights: '{"48039": 86.64, "48167": 13.36}',
    density: 133.5,
    imprecise: false,
    latitude: 29.38638,
    longitude: -95.23769,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77511',
  },
  {
    city: 'Anahuac',
    county_fips: 48071,
    county_fips_all: '48071',
    county: 'Chambers',
    county_names_all: 'Chambers',
    county_weights: '{"48071": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 29.69096,
    longitude: -94.62598,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77514',
  },
  {
    city: 'Angleton',
    county_fips: 48039,
    county_fips_all: '48039',
    county: 'Brazoria',
    county_names_all: 'Brazoria',
    county_weights: '{"48039": 100}',
    density: 64.4,
    imprecise: false,
    latitude: 29.17604,
    longitude: -95.44955,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77515',
  },
  {
    city: 'Santa Fe',
    county_fips: 48167,
    county_fips_all: '48167|48039',
    county: 'Galveston',
    county_names_all: 'Galveston|Brazoria',
    county_weights: '{"48167": 75.18, "48039": 24.82}',
    density: 81.5,
    imprecise: false,
    latitude: 29.36253,
    longitude: -95.1369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77517',
  },
  {
    city: 'Bacliff',
    county_fips: 48167,
    county_fips_all: '48167',
    county: 'Galveston',
    county_names_all: 'Galveston',
    county_weights: '{"48167": 100}',
    density: 1136.7,
    imprecise: false,
    latitude: 29.50544,
    longitude: -94.98664,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77518',
  },
  {
    city: 'Batson',
    county_fips: 48199,
    county_fips_all: '48199',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"48199": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 30.21124,
    longitude: -94.58596,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77519',
  },
  {
    city: 'Baytown',
    county_fips: 48201,
    county_fips_all: '48201|48071',
    county: 'Harris',
    county_names_all: 'Harris|Chambers',
    county_weights: '{"48201": 96.55, "48071": 3.45}',
    density: 667.4,
    imprecise: false,
    latitude: 29.74599,
    longitude: -95.00388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77520',
  },
  {
    city: 'Baytown',
    county_fips: 48201,
    county_fips_all: '48201|48071',
    county: 'Harris',
    county_names_all: 'Harris|Chambers',
    county_weights: '{"48201": 76.7, "48071": 23.3}',
    density: 541,
    imprecise: false,
    latitude: 29.81298,
    longitude: -94.96233,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 69038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77521',
  },
  {
    city: 'Baytown',
    county_fips: 48071,
    county_fips_all: '48071|48201',
    county: 'Chambers',
    county_names_all: 'Chambers|Harris',
    county_weights: '{"48071": 95.22, "48201": 4.78}',
    density: 136.8,
    imprecise: false,
    latitude: 29.77598,
    longitude: -94.8632,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77523',
  },
  {
    city: 'Channelview',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 881.6,
    imprecise: false,
    latitude: 29.78948,
    longitude: -95.11159,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77530',
  },
  {
    city: 'Clute',
    county_fips: 48039,
    county_fips_all: '48039',
    county: 'Brazoria',
    county_names_all: 'Brazoria',
    county_weights: '{"48039": 100}',
    density: 539.1,
    imprecise: false,
    latitude: 29.03895,
    longitude: -95.40071,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77531',
  },
  {
    city: 'Crosby',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 158,
    imprecise: false,
    latitude: 29.93177,
    longitude: -95.05602,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77532',
  },
  {
    city: 'Daisetta',
    county_fips: 48291,
    county_fips_all: '48291',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"48291": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 30.09139,
    longitude: -94.59488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77533',
  },
  {
    city: 'Danbury',
    county_fips: 48039,
    county_fips_all: '48039',
    county: 'Brazoria',
    county_names_all: 'Brazoria',
    county_weights: '{"48039": 100}',
    density: 31.4,
    imprecise: false,
    latitude: 29.21335,
    longitude: -95.30387,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77534',
  },
  {
    city: 'Dayton',
    county_fips: 48291,
    county_fips_all: '48291|48071|48201',
    county: 'Liberty',
    county_names_all: 'Liberty|Chambers|Harris',
    county_weights: '{"48291": 96.63, "48071": 3.13, "48201": 0.24}',
    density: 49.4,
    imprecise: false,
    latitude: 30.05129,
    longitude: -94.91569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77535',
  },
  {
    city: 'Deer Park',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 1304,
    imprecise: false,
    latitude: 29.69021,
    longitude: -95.11891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77536',
  },
  {
    city: 'Devers',
    county_fips: 48291,
    county_fips_all: '48291',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"48291": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 29.99217,
    longitude: -94.53976,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77538',
  },
  {
    city: 'Dickinson',
    county_fips: 48167,
    county_fips_all: '48167',
    county: 'Galveston',
    county_names_all: 'Galveston',
    county_weights: '{"48167": 100}',
    density: 393.8,
    imprecise: false,
    latitude: 29.45578,
    longitude: -95.02723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77539',
  },
  {
    city: 'Freeport',
    county_fips: 48039,
    county_fips_all: '48039',
    county: 'Brazoria',
    county_names_all: 'Brazoria',
    county_weights: '{"48039": 100}',
    density: 46.3,
    imprecise: false,
    latitude: 29.01496,
    longitude: -95.32667,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77541',
  },
  {
    city: 'Fresno',
    county_fips: 48157,
    county_fips_all: '48157|48039',
    county: 'Fort Bend',
    county_names_all: 'Fort Bend|Brazoria',
    county_weights: '{"48157": 99.26, "48039": 0.74}',
    density: 689.8,
    imprecise: false,
    latitude: 29.53729,
    longitude: -95.47242,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77545',
  },
  {
    city: 'Friendswood',
    county_fips: 48167,
    county_fips_all: '48167|48201|48039',
    county: 'Galveston',
    county_names_all: 'Galveston|Harris|Brazoria',
    county_weights: '{"48167": 66.94, "48201": 31.11, "48039": 1.95}',
    density: 778.1,
    imprecise: false,
    latitude: 29.5132,
    longitude: -95.19352,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77546',
  },
  {
    city: 'Galena Park',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 923.5,
    imprecise: false,
    latitude: 29.74018,
    longitude: -95.23836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77547',
  },
  {
    city: 'Galveston',
    county_fips: 48167,
    county_fips_all: '48167',
    county: 'Galveston',
    county_names_all: 'Galveston',
    county_weights: '{"48167": 100}',
    density: 1199.5,
    imprecise: false,
    latitude: 29.31021,
    longitude: -94.77706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77550',
  },
  {
    city: 'Galveston',
    county_fips: 48167,
    county_fips_all: '48167',
    county: 'Galveston',
    county_names_all: 'Galveston',
    county_weights: '{"48167": 100}',
    density: 2118.8,
    imprecise: false,
    latitude: 29.27903,
    longitude: -94.83502,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77551',
  },
  {
    city: 'Galveston',
    county_fips: 48167,
    county_fips_all: '48167',
    county: 'Galveston',
    county_names_all: 'Galveston',
    county_weights: '{"48167": 100}',
    density: 129.3,
    imprecise: false,
    latitude: 29.23187,
    longitude: -94.92544,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77554',
  },
  {
    city: 'Hankamer',
    county_fips: 48071,
    county_fips_all: '48071',
    county: 'Chambers',
    county_names_all: 'Chambers',
    county_weights: '{"48071": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 29.86399,
    longitude: -94.59643,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77560',
  },
  {
    city: 'Hardin',
    county_fips: 48291,
    county_fips_all: '48291',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"48291": 100}',
    density: 37,
    imprecise: false,
    latitude: 30.13459,
    longitude: -94.73551,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77561',
  },
  {
    city: 'Highlands',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 255.4,
    imprecise: false,
    latitude: 29.82917,
    longitude: -95.05473,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77562',
  },
  {
    city: 'Hitchcock',
    county_fips: 48167,
    county_fips_all: '48167',
    county: 'Galveston',
    county_names_all: 'Galveston',
    county_weights: '{"48167": 100}',
    density: 87,
    imprecise: false,
    latitude: 29.31123,
    longitude: -95.01822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77563',
  },
  {
    city: 'Hull',
    county_fips: 48291,
    county_fips_all: '48291|48199',
    county: 'Liberty',
    county_names_all: 'Liberty|Hardin',
    county_weights: '{"48291": 76.29, "48199": 23.71}',
    density: 11.6,
    imprecise: false,
    latitude: 30.21811,
    longitude: -94.65989,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77564',
  },
  {
    city: 'Kemah',
    county_fips: 48167,
    county_fips_all: '48167|48201',
    county: 'Galveston',
    county_names_all: 'Galveston|Harris',
    county_weights: '{"48167": 99.79, "48201": 0.21}',
    density: 753.9,
    imprecise: false,
    latitude: 29.53925,
    longitude: -95.03229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77565',
  },
  {
    city: 'Lake Jackson',
    county_fips: 48039,
    county_fips_all: '48039',
    county: 'Brazoria',
    county_names_all: 'Brazoria',
    county_weights: '{"48039": 100}',
    density: 493.3,
    imprecise: false,
    latitude: 29.04971,
    longitude: -95.47511,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77566',
  },
  {
    city: 'La Marque',
    county_fips: 48167,
    county_fips_all: '48167',
    county: 'Galveston',
    county_names_all: 'Galveston',
    county_weights: '{"48167": 100}',
    density: 608.5,
    imprecise: false,
    latitude: 29.36653,
    longitude: -94.98773,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77568',
  },
  {
    city: 'La Porte',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 401.4,
    imprecise: false,
    latitude: 29.69287,
    longitude: -95.06012,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77571',
  },
  {
    city: 'League City',
    county_fips: 48167,
    county_fips_all: '48167|48201',
    county: 'Galveston',
    county_names_all: 'Galveston|Harris',
    county_weights: '{"48167": 99.83, "48201": 0.17}',
    density: 1271.8,
    imprecise: false,
    latitude: 29.50213,
    longitude: -95.08636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 98109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77573',
  },
  {
    city: 'Liberty',
    county_fips: 48291,
    county_fips_all: '48291|48071',
    county: 'Liberty',
    county_names_all: 'Liberty|Chambers',
    county_weights: '{"48291": 96.67, "48071": 3.33}',
    density: 26.9,
    imprecise: false,
    latitude: 30.07738,
    longitude: -94.73666,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77575',
  },
  {
    city: 'Liverpool',
    county_fips: 48039,
    county_fips_all: '48039',
    county: 'Brazoria',
    county_names_all: 'Brazoria',
    county_weights: '{"48039": 100}',
    density: 21.7,
    imprecise: false,
    latitude: 29.25966,
    longitude: -95.26731,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77577',
  },
  {
    city: 'Manvel',
    county_fips: 48039,
    county_fips_all: '48039',
    county: 'Brazoria',
    county_names_all: 'Brazoria',
    county_weights: '{"48039": 100}',
    density: 303.8,
    imprecise: false,
    latitude: 29.47794,
    longitude: -95.36757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77578',
  },
  {
    city: 'Mont Belvieu',
    county_fips: 48071,
    county_fips_all: '48071',
    county: 'Chambers',
    county_names_all: 'Chambers',
    county_weights: '{"48071": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.85706,
    longitude: -94.88081,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77580',
  },
  {
    city: 'Pearland',
    county_fips: 48039,
    county_fips_all: '48039|48201',
    county: 'Brazoria',
    county_names_all: 'Brazoria|Harris',
    county_weights: '{"48039": 94.23, "48201": 5.77}',
    density: 805,
    imprecise: false,
    latitude: 29.5624,
    longitude: -95.27982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77581',
  },
  {
    city: 'Raywood',
    county_fips: 48291,
    county_fips_all: '48291',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"48291": 100}',
    density: 3,
    imprecise: false,
    latitude: 30.01371,
    longitude: -94.65497,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77582',
  },
  {
    city: 'Rosharon',
    county_fips: 48039,
    county_fips_all: '48039|48157',
    county: 'Brazoria',
    county_names_all: 'Brazoria|Fort Bend',
    county_weights: '{"48039": 91.49, "48157": 8.51}',
    density: 116.9,
    imprecise: false,
    latitude: 29.37763,
    longitude: -95.4585,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77583',
  },
  {
    city: 'Pearland',
    county_fips: 48039,
    county_fips_all: '48039|48157',
    county: 'Brazoria',
    county_names_all: 'Brazoria|Fort Bend',
    county_weights: '{"48039": 95.86, "48157": 4.14}',
    density: 1098.9,
    imprecise: false,
    latitude: 29.54577,
    longitude: -95.35013,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 91065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77584',
  },
  {
    city: 'Saratoga',
    county_fips: 48199,
    county_fips_all: '48199',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"48199": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 30.29949,
    longitude: -94.5294,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77585',
  },
  {
    city: 'Seabrook',
    county_fips: 48201,
    county_fips_all: '48201|48167',
    county: 'Harris',
    county_names_all: 'Harris|Galveston',
    county_weights: '{"48201": 99.79, "48167": 0.21}',
    density: 788.4,
    imprecise: false,
    latitude: 29.58267,
    longitude: -95.03391,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77586',
  },
  {
    city: 'South Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 2016.8,
    imprecise: false,
    latitude: 29.66117,
    longitude: -95.22865,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77587',
  },
  {
    city: 'Texas City',
    county_fips: 48167,
    county_fips_all: '48167',
    county: 'Galveston',
    county_names_all: 'Galveston',
    county_weights: '{"48167": 100}',
    density: 485.1,
    imprecise: false,
    latitude: 29.3804,
    longitude: -94.91759,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77590',
  },
  {
    city: 'Texas City',
    county_fips: 48167,
    county_fips_all: '48167',
    county: 'Galveston',
    county_names_all: 'Galveston',
    county_weights: '{"48167": 100}',
    density: 684.4,
    imprecise: false,
    latitude: 29.39971,
    longitude: -95.00074,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77591',
  },
  {
    city: 'Wallisville',
    county_fips: 48071,
    county_fips_all: '48071',
    county: 'Chambers',
    county_names_all: 'Chambers',
    county_weights: '{"48071": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 29.82811,
    longitude: -94.69521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77597',
  },
  {
    city: 'Webster',
    county_fips: 48201,
    county_fips_all: '48201|48167',
    county: 'Harris',
    county_names_all: 'Harris|Galveston',
    county_weights: '{"48201": 99.9, "48167": 0.1}',
    density: 823.7,
    imprecise: false,
    latitude: 29.53766,
    longitude: -95.13714,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77598',
  },
  {
    city: 'Bridge City',
    county_fips: 48361,
    county_fips_all: '48361',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"48361": 100}',
    density: 201.5,
    imprecise: false,
    latitude: 30.01259,
    longitude: -93.8222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77611',
  },
  {
    city: 'Buna',
    county_fips: 48241,
    county_fips_all: '48241|48351',
    county: 'Jasper',
    county_names_all: 'Jasper|Newton',
    county_weights: '{"48241": 65.28, "48351": 34.72}',
    density: 10,
    imprecise: false,
    latitude: 30.39851,
    longitude: -93.93276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77612',
  },
  {
    city: 'China',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 30.02493,
    longitude: -94.35393,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77613',
  },
  {
    city: 'Deweyville',
    county_fips: 48351,
    county_fips_all: '48351',
    county: 'Newton',
    county_names_all: 'Newton',
    county_weights: '{"48351": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 30.3055,
    longitude: -93.76033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77614',
  },
  {
    city: 'Evadale',
    county_fips: 48241,
    county_fips_all: '48241',
    county: 'Jasper',
    county_names_all: 'Jasper',
    county_weights: '{"48241": 100}',
    density: 78.2,
    imprecise: false,
    latitude: 30.35713,
    longitude: -94.06563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77615',
  },
  {
    city: 'Fred',
    county_fips: 48457,
    county_fips_all: '48457',
    county: 'Tyler',
    county_names_all: 'Tyler',
    county_weights: '{"48457": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 30.56804,
    longitude: -94.2117,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77616',
  },
  {
    city: 'Gilchrist',
    county_fips: 48167,
    county_fips_all: '48167',
    county: 'Galveston',
    county_names_all: 'Galveston',
    county_weights: '{"48167": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 29.51128,
    longitude: -94.51052,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77617',
  },
  {
    city: 'Groves',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 1204.6,
    imprecise: false,
    latitude: 29.94549,
    longitude: -93.9165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77619',
  },
  {
    city: 'Hamshire',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 34.7,
    imprecise: false,
    latitude: 29.85741,
    longitude: -94.29467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77622',
  },
  {
    city: 'High Island',
    county_fips: 48167,
    county_fips_all: '48167',
    county: 'Galveston',
    county_names_all: 'Galveston',
    county_weights: '{"48167": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 29.55957,
    longitude: -94.41621,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77623',
  },
  {
    city: 'Hillister',
    county_fips: 48457,
    county_fips_all: '48457',
    county: 'Tyler',
    county_names_all: 'Tyler',
    county_weights: '{"48457": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 30.68674,
    longitude: -94.2822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77624',
  },
  {
    city: 'Kountze',
    county_fips: 48199,
    county_fips_all: '48199',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"48199": 100}',
    density: 11,
    imprecise: false,
    latitude: 30.37032,
    longitude: -94.3923,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77625',
  },
  {
    city: 'Nederland',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 656.1,
    imprecise: false,
    latitude: 29.99095,
    longitude: -94.00772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77627',
  },
  {
    city: 'Nome',
    county_fips: 48245,
    county_fips_all: '48245|48291',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Liberty',
    county_weights: '{"48245": 72.96, "48291": 27.04}',
    density: 2.6,
    imprecise: false,
    latitude: 29.97476,
    longitude: -94.42727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77629',
  },
  {
    city: 'Orange',
    county_fips: 48361,
    county_fips_all: '48361',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"48361": 100}',
    density: 116.8,
    imprecise: false,
    latitude: 30.06534,
    longitude: -93.86844,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77630',
  },
  {
    city: 'Orange',
    county_fips: 48361,
    county_fips_all: '48361|48351',
    county: 'Orange',
    county_names_all: 'Orange|Newton',
    county_weights: '{"48361": 76.39, "48351": 23.61}',
    density: 68,
    imprecise: false,
    latitude: 30.2014,
    longitude: -93.80477,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77632',
  },
  {
    city: 'Port Arthur',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 177.8,
    imprecise: false,
    latitude: 29.88021,
    longitude: -93.94152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77640',
  },
  {
    city: 'Port Arthur',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 750.9,
    imprecise: false,
    latitude: 29.93917,
    longitude: -93.91606,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77642',
  },
  {
    city: 'Port Bolivar',
    county_fips: 48167,
    county_fips_all: '48167',
    county: 'Galveston',
    county_names_all: 'Galveston',
    county_weights: '{"48167": 100}',
    density: 40.8,
    imprecise: false,
    latitude: 29.42995,
    longitude: -94.68096,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77650',
  },
  {
    city: 'Port Neches',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 480.1,
    imprecise: false,
    latitude: 29.98036,
    longitude: -93.94821,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77651',
  },
  {
    city: 'Sabine Pass',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 29.71338,
    longitude: -93.95306,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77655',
  },
  {
    city: 'Silsbee',
    county_fips: 48199,
    county_fips_all: '48199|48457',
    county: 'Hardin',
    county_names_all: 'Hardin|Tyler',
    county_weights: '{"48199": 86.35, "48457": 13.65}',
    density: 38.6,
    imprecise: false,
    latitude: 30.42866,
    longitude: -94.16887,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77656',
  },
  {
    city: 'Lumberton',
    county_fips: 48199,
    county_fips_all: '48199',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"48199": 100}',
    density: 148.9,
    imprecise: false,
    latitude: 30.22549,
    longitude: -94.18862,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77657',
  },
  {
    city: 'Sour Lake',
    county_fips: 48199,
    county_fips_all: '48199',
    county: 'Hardin',
    county_names_all: 'Hardin',
    county_weights: '{"48199": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 30.15775,
    longitude: -94.43279,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77659',
  },
  {
    city: 'Spurger',
    county_fips: 48457,
    county_fips_all: '48457',
    county: 'Tyler',
    county_names_all: 'Tyler',
    county_weights: '{"48457": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 30.63993,
    longitude: -94.14105,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77660',
  },
  {
    city: 'Stowell',
    county_fips: 48071,
    county_fips_all: '48071',
    county: 'Chambers',
    county_names_all: 'Chambers',
    county_weights: '{"48071": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 29.78021,
    longitude: -94.36861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77661',
  },
  {
    city: 'Vidor',
    county_fips: 48361,
    county_fips_all: '48361|48241',
    county: 'Orange',
    county_names_all: 'Orange|Jasper',
    county_weights: '{"48361": 85.11, "48241": 14.89}',
    density: 69.2,
    imprecise: false,
    latitude: 30.1793,
    longitude: -94.01876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77662',
  },
  {
    city: 'Village Mills',
    county_fips: 48199,
    county_fips_all: '48199|48457',
    county: 'Hardin',
    county_names_all: 'Hardin|Tyler',
    county_weights: '{"48199": 83.42, "48457": 16.58}',
    density: 12.6,
    imprecise: false,
    latitude: 30.51033,
    longitude: -94.4052,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77663',
  },
  {
    city: 'Warren',
    county_fips: 48457,
    county_fips_all: '48457|48199',
    county: 'Tyler',
    county_names_all: 'Tyler|Hardin',
    county_weights: '{"48457": 90.44, "48199": 9.56}',
    density: 5.2,
    imprecise: false,
    latitude: 30.58901,
    longitude: -94.39529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77664',
  },
  {
    city: 'Winnie',
    county_fips: 48071,
    county_fips_all: '48071|48245',
    county: 'Chambers',
    county_names_all: 'Chambers|Jefferson',
    county_weights: '{"48071": 75.33, "48245": 24.67}',
    density: 16.9,
    imprecise: false,
    latitude: 29.78697,
    longitude: -94.40969,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77665',
  },
  {
    city: 'Beaumont',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 697,
    imprecise: false,
    latitude: 30.07321,
    longitude: -94.10579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77701',
  },
  {
    city: 'Beaumont',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 969.9,
    imprecise: false,
    latitude: 30.08624,
    longitude: -94.12825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77702',
  },
  {
    city: 'Beaumont',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 488.7,
    imprecise: false,
    latitude: 30.11522,
    longitude: -94.10906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77703',
  },
  {
    city: 'Beaumont',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 60.9,
    imprecise: false,
    latitude: 29.90652,
    longitude: -94.16961,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77705',
  },
  {
    city: 'Beaumont',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 1164.3,
    imprecise: false,
    latitude: 30.10049,
    longitude: -94.16717,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77706',
  },
  {
    city: 'Beaumont',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 498.6,
    imprecise: false,
    latitude: 30.05323,
    longitude: -94.1748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77707',
  },
  {
    city: 'Beaumont',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 400.3,
    imprecise: false,
    latitude: 30.14747,
    longitude: -94.15128,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77708',
  },
  {
    city: 'Beaumont',
    county_fips: 48245,
    county_fips_all: '48245',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"48245": 100}',
    density: 58.2,
    imprecise: false,
    latitude: 30.06777,
    longitude: -94.25716,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77713',
  },
  {
    city: 'Bryan',
    county_fips: 48041,
    county_fips_all: '48041',
    county: 'Brazos',
    county_names_all: 'Brazos',
    county_weights: '{"48041": 100}',
    density: 1945.9,
    imprecise: false,
    latitude: 30.63968,
    longitude: -96.36451,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77801',
  },
  {
    city: 'Bryan',
    county_fips: 48041,
    county_fips_all: '48041',
    county: 'Brazos',
    county_names_all: 'Brazos',
    county_weights: '{"48041": 100}',
    density: 867.4,
    imprecise: false,
    latitude: 30.6609,
    longitude: -96.32233,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77802',
  },
  {
    city: 'Bryan',
    county_fips: 48041,
    county_fips_all: '48041',
    county: 'Brazos',
    county_names_all: 'Brazos',
    county_weights: '{"48041": 100}',
    density: 896.8,
    imprecise: false,
    latitude: 30.67835,
    longitude: -96.3867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77803',
  },
  {
    city: 'Bryan',
    county_fips: 48041,
    county_fips_all: '48041|48395',
    county: 'Brazos',
    county_names_all: 'Brazos|Robertson',
    county_weights: '{"48041": 85.19, "48395": 14.81}',
    density: 51.9,
    imprecise: false,
    latitude: 30.6783,
    longitude: -96.47982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77807',
  },
  {
    city: 'Bryan',
    county_fips: 48041,
    county_fips_all: '48041|48395',
    county: 'Brazos',
    county_names_all: 'Brazos|Robertson',
    county_weights: '{"48041": 84.27, "48395": 15.73}',
    density: 24,
    imprecise: false,
    latitude: 30.78965,
    longitude: -96.31362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77808',
  },
  {
    city: 'Anderson',
    county_fips: 48185,
    county_fips_all: '48185',
    county: 'Grimes',
    county_names_all: 'Grimes',
    county_weights: '{"48185": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 30.52648,
    longitude: -96.00849,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77830',
  },
  {
    city: 'Bedias',
    county_fips: 48185,
    county_fips_all: '48185|48471|48313',
    county: 'Grimes',
    county_names_all: 'Grimes|Walker|Madison',
    county_weights: '{"48185": 76.53, "48471": 22.23, "48313": 1.24}',
    density: 6.3,
    imprecise: false,
    latitude: 30.73144,
    longitude: -95.90933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77831',
  },
  {
    city: 'Brenham',
    county_fips: 48477,
    county_fips_all: '48477|48015',
    county: 'Washington',
    county_names_all: 'Washington|Austin',
    county_weights: '{"48477": 91.62, "48015": 8.38}',
    density: 36.4,
    imprecise: false,
    latitude: 30.20842,
    longitude: -96.40797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77833',
  },
  {
    city: 'Burton',
    county_fips: 48477,
    county_fips_all: '48477|48015',
    county: 'Washington',
    county_names_all: 'Washington|Austin',
    county_weights: '{"48477": 98.98, "48015": 1.02}',
    density: 9,
    imprecise: false,
    latitude: 30.19439,
    longitude: -96.59257,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77835',
  },
  {
    city: 'Caldwell',
    county_fips: 48051,
    county_fips_all: '48051|48331',
    county: 'Burleson',
    county_names_all: 'Burleson|Milam',
    county_weights: '{"48051": 97.94, "48331": 2.06}',
    density: 11.3,
    imprecise: false,
    latitude: 30.53798,
    longitude: -96.67813,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77836',
  },
  {
    city: 'Calvert',
    county_fips: 48395,
    county_fips_all: '48395',
    county: 'Robertson',
    county_names_all: 'Robertson',
    county_weights: '{"48395": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 31.00704,
    longitude: -96.67718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77837',
  },
  {
    city: 'College Station',
    county_fips: 48041,
    county_fips_all: '48041',
    county: 'Brazos',
    county_names_all: 'Brazos',
    county_weights: '{"48041": 100}',
    density: 2125.7,
    imprecise: false,
    latitude: 30.6115,
    longitude: -96.32332,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77840',
  },
  {
    city: 'College Station',
    county_fips: 48041,
    county_fips_all: '48041',
    county: 'Brazos',
    county_names_all: 'Brazos',
    county_weights: '{"48041": 100}',
    density: 207.9,
    imprecise: false,
    latitude: 30.56212,
    longitude: -96.27607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 76764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77845',
  },
  {
    city: 'Deanville',
    county_fips: 48051,
    county_fips_all: '48051',
    county: 'Burleson',
    county_names_all: 'Burleson',
    county_weights: '{"48051": 100}',
    density: 38.5,
    imprecise: false,
    latitude: 30.42833,
    longitude: -96.7573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77852',
  },
  {
    city: 'Dime Box',
    county_fips: 48287,
    county_fips_all: '48287',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"48287": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 30.3623,
    longitude: -96.84035,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77853',
  },
  {
    city: 'Flynn',
    county_fips: 48289,
    county_fips_all: '48289',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"48289": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 31.14741,
    longitude: -96.11217,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77855',
  },
  {
    city: 'Franklin',
    county_fips: 48395,
    county_fips_all: '48395',
    county: 'Robertson',
    county_names_all: 'Robertson',
    county_weights: '{"48395": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 31.07714,
    longitude: -96.41499,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77856',
  },
  {
    city: 'Gause',
    county_fips: 48331,
    county_fips_all: '48331',
    county: 'Milam',
    county_names_all: 'Milam',
    county_weights: '{"48331": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 30.78246,
    longitude: -96.73927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77857',
  },
  {
    city: 'Hearne',
    county_fips: 48395,
    county_fips_all: '48395|48041',
    county: 'Robertson',
    county_names_all: 'Robertson|Brazos',
    county_weights: '{"48395": 83.48, "48041": 16.52}',
    density: 18.6,
    imprecise: false,
    latitude: 30.88012,
    longitude: -96.51707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77859',
  },
  {
    city: 'Iola',
    county_fips: 48185,
    county_fips_all: '48185',
    county: 'Grimes',
    county_names_all: 'Grimes',
    county_weights: '{"48185": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 30.72477,
    longitude: -96.09908,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77861',
  },
  {
    city: 'Lyons',
    county_fips: 48051,
    county_fips_all: '48051',
    county: 'Burleson',
    county_names_all: 'Burleson',
    county_weights: '{"48051": 100}',
    density: 236.4,
    imprecise: false,
    latitude: 30.39306,
    longitude: -96.55946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77863',
  },
  {
    city: 'Madisonville',
    county_fips: 48313,
    county_fips_all: '48313',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"48313": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 30.96087,
    longitude: -95.89297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77864',
  },
  {
    city: 'Marquez',
    county_fips: 48289,
    county_fips_all: '48289',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"48289": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 31.22275,
    longitude: -96.22553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77865',
  },
  {
    city: 'Millican',
    county_fips: 48041,
    county_fips_all: '48041',
    county: 'Brazos',
    county_names_all: 'Brazos',
    county_weights: '{"48041": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.49356,
    longitude: -96.21034,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77866',
  },
  {
    city: 'Mumford',
    county_fips: 48395,
    county_fips_all: '48395',
    county: 'Robertson',
    county_names_all: 'Robertson',
    county_weights: '{"48395": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 30.74163,
    longitude: -96.56992,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77867',
  },
  {
    city: 'Navasota',
    county_fips: 48185,
    county_fips_all: '48185|48041|48477|48473',
    county: 'Grimes',
    county_names_all: 'Grimes|Brazos|Washington|Waller',
    county_weights:
      '{"48185": 70.12, "48041": 28.41, "48477": 0.78, "48473": 0.69}',
    density: 25.6,
    imprecise: false,
    latitude: 30.36954,
    longitude: -96.05815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77868',
  },
  {
    city: 'Normangee',
    county_fips: 48289,
    county_fips_all: '48289|48313',
    county: 'Leon',
    county_names_all: 'Leon|Madison',
    county_weights: '{"48289": 61.07, "48313": 38.93}',
    density: 5.8,
    imprecise: false,
    latitude: 31.05129,
    longitude: -96.10903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77871',
  },
  {
    city: 'North Zulch',
    county_fips: 48313,
    county_fips_all: '48313|48185',
    county: 'Madison',
    county_names_all: 'Madison|Grimes',
    county_weights: '{"48313": 95.92, "48185": 4.08}',
    density: 8.3,
    imprecise: false,
    latitude: 30.88539,
    longitude: -96.0971,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77872',
  },
  {
    city: 'Richards',
    county_fips: 48339,
    county_fips_all: '48339|48185|48471',
    county: 'Montgomery',
    county_names_all: 'Montgomery|Grimes|Walker',
    county_weights: '{"48339": 43.48, "48185": 35.37, "48471": 21.15}',
    density: 5.9,
    imprecise: false,
    latitude: 30.57489,
    longitude: -95.79934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77873',
  },
  {
    city: 'Roans Prairie',
    county_fips: 48185,
    county_fips_all: '48185',
    county: 'Grimes',
    county_names_all: 'Grimes',
    county_weights: '{"48185": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.58119,
    longitude: -95.94675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77875',
  },
  {
    city: 'Shiro',
    county_fips: 48185,
    county_fips_all: '48185',
    county: 'Grimes',
    county_names_all: 'Grimes',
    county_weights: '{"48185": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 30.60369,
    longitude: -95.85656,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77876',
  },
  {
    city: 'Snook',
    county_fips: 48051,
    county_fips_all: '48051',
    county: 'Burleson',
    county_names_all: 'Burleson',
    county_weights: '{"48051": 100}',
    density: 19,
    imprecise: false,
    latitude: 30.47222,
    longitude: -96.45089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77878',
  },
  {
    city: 'Somerville',
    county_fips: 48051,
    county_fips_all: '48051',
    county: 'Burleson',
    county_names_all: 'Burleson',
    county_weights: '{"48051": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 30.40078,
    longitude: -96.49378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77879',
  },
  {
    city: 'Washington',
    county_fips: 48477,
    county_fips_all: '48477',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"48477": 100}',
    density: 10,
    imprecise: false,
    latitude: 30.28283,
    longitude: -96.1863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77880',
  },
  {
    city: 'Wheelock',
    county_fips: 48395,
    county_fips_all: '48395',
    county: 'Robertson',
    county_names_all: 'Robertson',
    county_weights: '{"48395": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.91139,
    longitude: -96.37909,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77882',
  },
  {
    city: 'Victoria',
    county_fips: 48469,
    county_fips_all: '48469',
    county: 'Victoria',
    county_names_all: 'Victoria',
    county_weights: '{"48469": 100}',
    density: 850,
    imprecise: false,
    latitude: 28.80629,
    longitude: -96.98553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77901',
  },
  {
    city: 'Victoria',
    county_fips: 48469,
    county_fips_all: '48469',
    county: 'Victoria',
    county_names_all: 'Victoria',
    county_weights: '{"48469": 100}',
    density: 105.6,
    imprecise: false,
    latitude: 28.91788,
    longitude: -97.0311,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77904',
  },
  {
    city: 'Victoria',
    county_fips: 48469,
    county_fips_all: '48469|48175',
    county: 'Victoria',
    county_names_all: 'Victoria|Goliad',
    county_weights: '{"48469": 90.1, "48175": 9.9}',
    density: 14.9,
    imprecise: false,
    latitude: 28.72789,
    longitude: -97.0508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77905',
  },
  {
    city: 'Austwell',
    county_fips: 48007,
    county_fips_all: '48007|48391',
    county: 'Aransas',
    county_names_all: 'Aransas|Refugio',
    county_weights: '{"48007": 74.74, "48391": 25.26}',
    density: 0.5,
    imprecise: false,
    latitude: 28.26427,
    longitude: -96.89666,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77950',
  },
  {
    city: 'Bloomington',
    county_fips: 48469,
    county_fips_all: '48469',
    county: 'Victoria',
    county_names_all: 'Victoria',
    county_weights: '{"48469": 100}',
    density: 31.2,
    imprecise: false,
    latitude: 28.63476,
    longitude: -96.91183,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77951',
  },
  {
    city: 'Cuero',
    county_fips: 48123,
    county_fips_all: '48123|48177',
    county: 'DeWitt',
    county_names_all: 'DeWitt|Gonzales',
    county_weights: '{"48123": 95.03, "48177": 4.97}',
    density: 11.6,
    imprecise: false,
    latitude: 29.0966,
    longitude: -97.29533,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77954',
  },
  {
    city: 'Edna',
    county_fips: 48239,
    county_fips_all: '48239',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"48239": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 29.03022,
    longitude: -96.70606,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77957',
  },
  {
    city: 'Fannin',
    county_fips: 48175,
    county_fips_all: '48175',
    county: 'Goliad',
    county_names_all: 'Goliad',
    county_weights: '{"48175": 100}',
    density: 0,
    imprecise: false,
    latitude: 28.65306,
    longitude: -97.2461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77960',
  },
  {
    city: 'Francitas',
    county_fips: 48239,
    county_fips_all: '48239',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"48239": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 28.85684,
    longitude: -96.35947,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77961',
  },
  {
    city: 'Ganado',
    county_fips: 48239,
    county_fips_all: '48239',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"48239": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 29.03253,
    longitude: -96.5023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77962',
  },
  {
    city: 'Goliad',
    county_fips: 48175,
    county_fips_all: '48175',
    county: 'Goliad',
    county_names_all: 'Goliad',
    county_weights: '{"48175": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 28.65589,
    longitude: -97.40093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77963',
  },
  {
    city: 'Hallettsville',
    county_fips: 48285,
    county_fips_all: '48285|48089',
    county: 'Lavaca',
    county_names_all: 'Lavaca|Colorado',
    county_weights: '{"48285": 97.74, "48089": 2.26}',
    density: 5.3,
    imprecise: false,
    latitude: 29.38023,
    longitude: -96.84301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77964',
  },
  {
    city: 'Inez',
    county_fips: 48469,
    county_fips_all: '48469',
    county: 'Victoria',
    county_names_all: 'Victoria',
    county_weights: '{"48469": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 28.90619,
    longitude: -96.84952,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77968',
  },
  {
    city: 'La Salle',
    county_fips: 48239,
    county_fips_all: '48239',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"48239": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 28.77579,
    longitude: -96.64719,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77969',
  },
  {
    city: 'La Ward',
    county_fips: 48239,
    county_fips_all: '48239',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"48239": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 28.84533,
    longitude: -96.43153,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77970',
  },
  {
    city: 'Lolita',
    county_fips: 48239,
    county_fips_all: '48239',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"48239": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 28.83063,
    longitude: -96.52176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77971',
  },
  {
    city: 'Mcfaddin',
    county_fips: 48469,
    county_fips_all: '48469',
    county: 'Victoria',
    county_names_all: 'Victoria',
    county_weights: '{"48469": 100}',
    density: 0,
    imprecise: false,
    latitude: 28.54094,
    longitude: -96.95512,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77973',
  },
  {
    city: 'Meyersville',
    county_fips: 48123,
    county_fips_all: '48123|48469',
    county: 'DeWitt',
    county_names_all: 'DeWitt|Victoria',
    county_weights: '{"48123": 63.49, "48469": 36.51}',
    density: 9.4,
    imprecise: false,
    latitude: 28.89295,
    longitude: -97.29275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77974',
  },
  {
    city: 'Moulton',
    county_fips: 48285,
    county_fips_all: '48285',
    county: 'Lavaca',
    county_names_all: 'Lavaca',
    county_weights: '{"48285": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 29.56843,
    longitude: -97.08818,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77975',
  },
  {
    city: 'Nursery',
    county_fips: 48469,
    county_fips_all: '48469',
    county: 'Victoria',
    county_names_all: 'Victoria',
    county_weights: '{"48469": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 28.94057,
    longitude: -97.1342,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77976',
  },
  {
    city: 'Placedo',
    county_fips: 48469,
    county_fips_all: '48469',
    county: 'Victoria',
    county_names_all: 'Victoria',
    county_weights: '{"48469": 100}',
    density: 15,
    imprecise: false,
    latitude: 28.68082,
    longitude: -96.80183,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77977',
  },
  {
    city: 'Point Comfort',
    county_fips: 48057,
    county_fips_all: '48057',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"48057": 100}',
    density: 69.2,
    imprecise: false,
    latitude: 28.69152,
    longitude: -96.5991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77978',
  },
  {
    city: 'Port Lavaca',
    county_fips: 48057,
    county_fips_all: '48057|48469|48239',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Victoria|Jackson',
    county_weights: '{"48057": 85.64, "48469": 7.65, "48239": 6.71}',
    density: 18.7,
    imprecise: false,
    latitude: 28.60248,
    longitude: -96.6017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77979',
  },
  {
    city: "Port O'Connor",
    county_fips: 48057,
    county_fips_all: '48057',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"48057": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 28.44903,
    longitude: -96.48657,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77982',
  },
  {
    city: 'Seadrift',
    county_fips: 48057,
    county_fips_all: '48057',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"48057": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 28.39874,
    longitude: -96.64049,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77983',
  },
  {
    city: 'Shiner',
    county_fips: 48285,
    county_fips_all: '48285|48177|48123',
    county: 'Lavaca',
    county_names_all: 'Lavaca|Gonzales|DeWitt',
    county_weights: '{"48285": 64.64, "48177": 33.9, "48123": 1.46}',
    density: 11.6,
    imprecise: false,
    latitude: 29.45373,
    longitude: -97.18849,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77984',
  },
  {
    city: 'Sublime',
    county_fips: 48285,
    county_fips_all: '48285',
    county: 'Lavaca',
    county_names_all: 'Lavaca',
    county_weights: '{"48285": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.47661,
    longitude: -96.79607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77986',
  },
  {
    city: 'Sweet Home',
    county_fips: 48285,
    county_fips_all: '48285',
    county: 'Lavaca',
    county_names_all: 'Lavaca',
    county_weights: '{"48285": 100}',
    density: 26.6,
    imprecise: false,
    latitude: 29.34569,
    longitude: -97.08019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77987',
  },
  {
    city: 'Telferner',
    county_fips: 48469,
    county_fips_all: '48469',
    county: 'Victoria',
    county_names_all: 'Victoria',
    county_weights: '{"48469": 100}',
    density: 40.8,
    imprecise: false,
    latitude: 28.84701,
    longitude: -96.87547,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77988',
  },
  {
    city: 'Tivoli',
    county_fips: 48391,
    county_fips_all: '48391|48057',
    county: 'Refugio',
    county_names_all: 'Refugio|Calhoun',
    county_weights: '{"48391": 72.18, "48057": 27.82}',
    density: 1.7,
    imprecise: false,
    latitude: 28.48098,
    longitude: -96.93438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77990',
  },
  {
    city: 'Vanderbilt',
    county_fips: 48239,
    county_fips_all: '48239',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"48239": 100}',
    density: 16,
    imprecise: false,
    latitude: 28.7866,
    longitude: -96.59467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77991',
  },
  {
    city: 'Weesatche',
    county_fips: 48175,
    county_fips_all: '48175|48123',
    county: 'Goliad',
    county_names_all: 'Goliad|DeWitt',
    county_weights: '{"48175": 99.85, "48123": 0.15}',
    density: 7.7,
    imprecise: false,
    latitude: 28.85158,
    longitude: -97.433,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77993',
  },
  {
    city: 'Westhoff',
    county_fips: 48123,
    county_fips_all: '48123|48177',
    county: 'DeWitt',
    county_names_all: 'DeWitt|Gonzales',
    county_weights: '{"48123": 92.42, "48177": 7.58}',
    density: 2.8,
    imprecise: false,
    latitude: 29.17977,
    longitude: -97.46563,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77994',
  },
  {
    city: 'Yoakum',
    county_fips: 48123,
    county_fips_all: '48123|48285|48469',
    county: 'DeWitt',
    county_names_all: 'DeWitt|Lavaca|Victoria',
    county_weights: '{"48123": 48.16, "48285": 43.01, "48469": 8.83}',
    density: 10.7,
    imprecise: false,
    latitude: 29.20384,
    longitude: -97.08814,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77995',
  },
  {
    city: 'Atascosa',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 67.9,
    imprecise: false,
    latitude: 29.28305,
    longitude: -98.73652,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78002',
  },
  {
    city: 'Bandera',
    county_fips: 48019,
    county_fips_all: '48019|48325',
    county: 'Bandera',
    county_names_all: 'Bandera|Medina',
    county_weights: '{"48019": 85.28, "48325": 14.72}',
    density: 17,
    imprecise: false,
    latitude: 29.71092,
    longitude: -99.09823,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78003',
  },
  {
    city: 'Bergheim',
    county_fips: 48259,
    county_fips_all: '48259',
    county: 'Kendall',
    county_names_all: 'Kendall',
    county_weights: '{"48259": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 29.85767,
    longitude: -98.53773,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78004',
  },
  {
    city: 'Bigfoot',
    county_fips: 48163,
    county_fips_all: '48163|48013',
    county: 'Frio',
    county_names_all: 'Frio|Atascosa',
    county_weights: '{"48163": 88.54, "48013": 11.46}',
    density: 4,
    imprecise: false,
    latitude: 28.92848,
    longitude: -98.84668,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78005',
  },
  {
    city: 'Boerne',
    county_fips: 48259,
    county_fips_all: '48259|48029|48091',
    county: 'Kendall',
    county_names_all: 'Kendall|Bexar|Comal',
    county_weights: '{"48259": 92.17, "48029": 6.83, "48091": 1.0}',
    density: 49.7,
    imprecise: false,
    latitude: 29.86869,
    longitude: -98.71368,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78006',
  },
  {
    city: 'Calliham',
    county_fips: 48311,
    county_fips_all: '48311',
    county: 'McMullen',
    county_names_all: 'McMullen',
    county_weights: '{"48311": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 28.48212,
    longitude: -98.40373,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78007',
  },
  {
    city: 'Campbellton',
    county_fips: 48013,
    county_fips_all: '48013|48297',
    county: 'Atascosa',
    county_names_all: 'Atascosa|Live Oak',
    county_weights: '{"48013": 92.54, "48297": 7.46}',
    density: 0.8,
    imprecise: false,
    latitude: 28.72478,
    longitude: -98.25911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78008',
  },
  {
    city: 'Castroville',
    county_fips: 48325,
    county_fips_all: '48325',
    county: 'Medina',
    county_names_all: 'Medina',
    county_weights: '{"48325": 100}',
    density: 50.1,
    imprecise: false,
    latitude: 29.36251,
    longitude: -98.88442,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78009',
  },
  {
    city: 'Center Point',
    county_fips: 48265,
    county_fips_all: '48265',
    county: 'Kerr',
    county_names_all: 'Kerr',
    county_weights: '{"48265": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 29.91122,
    longitude: -99.04698,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78010',
  },
  {
    city: 'Charlotte',
    county_fips: 48013,
    county_fips_all: '48013',
    county: 'Atascosa',
    county_names_all: 'Atascosa',
    county_weights: '{"48013": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 28.80267,
    longitude: -98.73441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78011',
  },
  {
    city: 'Christine',
    county_fips: 48013,
    county_fips_all: '48013',
    county: 'Atascosa',
    county_names_all: 'Atascosa',
    county_weights: '{"48013": 100}',
    density: 5,
    imprecise: false,
    latitude: 28.75792,
    longitude: -98.45578,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78012',
  },
  {
    city: 'Comfort',
    county_fips: 48259,
    county_fips_all: '48259|48265',
    county: 'Kendall',
    county_names_all: 'Kendall|Kerr',
    county_weights: '{"48259": 50.18, "48265": 49.82}',
    density: 8.2,
    imprecise: false,
    latitude: 29.97798,
    longitude: -98.90647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78013',
  },
  {
    city: 'Cotulla',
    county_fips: 48283,
    county_fips_all: '48283|48127',
    county: 'La Salle',
    county_names_all: 'La Salle|Dimmit',
    county_weights: '{"48283": 97.68, "48127": 2.32}',
    density: 2.2,
    imprecise: false,
    latitude: 28.39837,
    longitude: -99.10946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78014',
  },
  {
    city: 'Boerne',
    county_fips: 48259,
    county_fips_all: '48259|48029|48091',
    county: 'Kendall',
    county_names_all: 'Kendall|Bexar|Comal',
    county_weights: '{"48259": 46.81, "48029": 42.81, "48091": 10.38}',
    density: 370.5,
    imprecise: false,
    latitude: 29.7439,
    longitude: -98.64785,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78015',
  },
  {
    city: 'Devine',
    county_fips: 48325,
    county_fips_all: '48325|48163',
    county: 'Medina',
    county_names_all: 'Medina|Frio',
    county_weights: '{"48325": 95.74, "48163": 4.26}',
    density: 28.5,
    imprecise: false,
    latitude: 29.18499,
    longitude: -98.95692,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78016',
  },
  {
    city: 'Dilley',
    county_fips: 48163,
    county_fips_all: '48163|48283',
    county: 'Frio',
    county_names_all: 'Frio|La Salle',
    county_weights: '{"48163": 87.6, "48283": 12.4}',
    density: 5.3,
    imprecise: false,
    latitude: 28.72456,
    longitude: -99.20455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78017',
  },
  {
    city: 'Encinal',
    county_fips: 48479,
    county_fips_all: '48479|48283',
    county: 'Webb',
    county_names_all: 'Webb|La Salle',
    county_weights: '{"48479": 84.16, "48283": 15.84}',
    density: 1,
    imprecise: false,
    latitude: 28.02401,
    longitude: -99.28461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78019',
  },
  {
    city: 'Fowlerton',
    county_fips: 48283,
    county_fips_all: '48283|48311',
    county: 'La Salle',
    county_names_all: 'La Salle|McMullen',
    county_weights: '{"48283": 64.17, "48311": 35.83}',
    density: 0.2,
    imprecise: false,
    latitude: 28.4318,
    longitude: -98.83489,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78021',
  },
  {
    city: 'George West',
    county_fips: 48297,
    county_fips_all: '48297|48311',
    county: 'Live Oak',
    county_names_all: 'Live Oak|McMullen',
    county_weights: '{"48297": 88.64, "48311": 11.36}',
    density: 3.8,
    imprecise: false,
    latitude: 28.24222,
    longitude: -98.16421,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78022',
  },
  {
    city: 'Helotes',
    county_fips: 48029,
    county_fips_all: '48029|48325|48019',
    county: 'Bexar',
    county_names_all: 'Bexar|Medina|Bandera',
    county_weights: '{"48029": 84.85, "48325": 13.64, "48019": 1.51}',
    density: 122.4,
    imprecise: false,
    latitude: 29.61549,
    longitude: -98.75443,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78023',
  },
  {
    city: 'Hunt',
    county_fips: 48265,
    county_fips_all: '48265|48385',
    county: 'Kerr',
    county_names_all: 'Kerr|Real',
    county_weights: '{"48265": 95.37, "48385": 4.63}',
    density: 2.1,
    imprecise: false,
    latitude: 29.9964,
    longitude: -99.48622,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78024',
  },
  {
    city: 'Ingram',
    county_fips: 48265,
    county_fips_all: '48265',
    county: 'Kerr',
    county_names_all: 'Kerr',
    county_weights: '{"48265": 100}',
    density: 35.7,
    imprecise: false,
    latitude: 30.07971,
    longitude: -99.28562,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78025',
  },
  {
    city: 'Jourdanton',
    county_fips: 48013,
    county_fips_all: '48013|48311',
    county: 'Atascosa',
    county_names_all: 'Atascosa|McMullen',
    county_weights: '{"48013": 72.31, "48311": 27.69}',
    density: 7.6,
    imprecise: false,
    latitude: 28.75573,
    longitude: -98.54754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78026',
  },
  {
    city: 'Kendalia',
    county_fips: 48259,
    county_fips_all: '48259',
    county: 'Kendall',
    county_names_all: 'Kendall',
    county_weights: '{"48259": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 29.98193,
    longitude: -98.53868,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78027',
  },
  {
    city: 'Kerrville',
    county_fips: 48265,
    county_fips_all: '48265|48171',
    county: 'Kerr',
    county_names_all: 'Kerr|Gillespie',
    county_weights: '{"48265": 83.83, "48171": 16.17}',
    density: 60.4,
    imprecise: false,
    latitude: 30.04115,
    longitude: -99.16276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78028',
  },
  {
    city: 'Kerrville',
    county_fips: 48265,
    county_fips_all: '48265',
    county: 'Kerr',
    county_names_all: 'Kerr',
    county_weights: '{"48265": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.90078,
    longitude: -99.1898,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78029',
  },
  {
    city: 'La Coste',
    county_fips: 48325,
    county_fips_all: '48325|48029',
    county: 'Medina',
    county_names_all: 'Medina|Bexar',
    county_weights: '{"48325": 70.91, "48029": 29.09}',
    density: 34.6,
    imprecise: false,
    latitude: 29.31324,
    longitude: -98.82528,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78039',
  },
  {
    city: 'Laredo',
    county_fips: 48479,
    county_fips_all: '48479',
    county: 'Webb',
    county_names_all: 'Webb',
    county_weights: '{"48479": 100}',
    density: 2186.7,
    imprecise: false,
    latitude: 27.51349,
    longitude: -99.50232,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78040',
  },
  {
    city: 'Laredo',
    county_fips: 48479,
    county_fips_all: '48479',
    county: 'Webb',
    county_names_all: 'Webb',
    county_weights: '{"48479": 100}',
    density: 1031.8,
    imprecise: false,
    latitude: 27.55489,
    longitude: -99.46889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78041',
  },
  {
    city: 'Laredo',
    county_fips: 48479,
    county_fips_all: '48479',
    county: 'Webb',
    county_names_all: 'Webb',
    county_weights: '{"48479": 100}',
    density: 99.8,
    imprecise: false,
    latitude: 27.54037,
    longitude: -99.27447,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78043',
  },
  {
    city: 'Laredo',
    county_fips: 48479,
    county_fips_all: '48479',
    county: 'Webb',
    county_names_all: 'Webb',
    county_weights: '{"48479": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 27.75613,
    longitude: -99.22748,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78044',
  },
  {
    city: 'Laredo',
    county_fips: 48479,
    county_fips_all: '48479',
    county: 'Webb',
    county_names_all: 'Webb',
    county_weights: '{"48479": 100}',
    density: 39.2,
    imprecise: false,
    latitude: 27.83197,
    longitude: -99.65963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 67333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78045',
  },
  {
    city: 'Laredo',
    county_fips: 48479,
    county_fips_all: '48479',
    county: 'Webb',
    county_names_all: 'Webb',
    county_weights: '{"48479": 100}',
    density: 153.6,
    imprecise: false,
    latitude: 27.38371,
    longitude: -99.36803,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 72951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78046',
  },
  {
    city: 'Leming',
    county_fips: 48013,
    county_fips_all: '48013',
    county: 'Atascosa',
    county_names_all: 'Atascosa',
    county_weights: '{"48013": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 29.08924,
    longitude: -98.50258,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78050',
  },
  {
    city: 'Lytle',
    county_fips: 48013,
    county_fips_all: '48013|48325|48029',
    county: 'Atascosa',
    county_names_all: 'Atascosa|Medina|Bexar',
    county_weights: '{"48013": 76.37, "48325": 16.06, "48029": 7.57}',
    density: 64.2,
    imprecise: false,
    latitude: 29.20582,
    longitude: -98.77427,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78052',
  },
  {
    city: 'Medina',
    county_fips: 48019,
    county_fips_all: '48019|48265',
    county: 'Bandera',
    county_names_all: 'Bandera|Kerr',
    county_weights: '{"48019": 97.58, "48265": 2.42}',
    density: 2.9,
    imprecise: false,
    latitude: 29.8184,
    longitude: -99.31923,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78055',
  },
  {
    city: 'Mico',
    county_fips: 48325,
    county_fips_all: '48325',
    county: 'Medina',
    county_names_all: 'Medina',
    county_weights: '{"48325": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 29.53896,
    longitude: -98.94184,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78056',
  },
  {
    city: 'Moore',
    county_fips: 48163,
    county_fips_all: '48163|48325',
    county: 'Frio',
    county_names_all: 'Frio|Medina',
    county_weights: '{"48163": 83.55, "48325": 16.45}',
    density: 2.2,
    imprecise: false,
    latitude: 29.03924,
    longitude: -99.02185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78057',
  },
  {
    city: 'Mountain Home',
    county_fips: 48265,
    county_fips_all: '48265|48385|48171',
    county: 'Kerr',
    county_names_all: 'Kerr|Real|Gillespie',
    county_weights: '{"48265": 78.53, "48385": 17.94, "48171": 3.53}',
    density: 0.8,
    imprecise: false,
    latitude: 30.13188,
    longitude: -99.59042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78058',
  },
  {
    city: 'Natalia',
    county_fips: 48325,
    county_fips_all: '48325',
    county: 'Medina',
    county_names_all: 'Medina',
    county_weights: '{"48325": 100}',
    density: 67.3,
    imprecise: false,
    latitude: 29.19236,
    longitude: -98.84143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78059',
  },
  {
    city: 'Pearsall',
    county_fips: 48163,
    county_fips_all: '48163',
    county: 'Frio',
    county_names_all: 'Frio',
    county_weights: '{"48163": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 28.90162,
    longitude: -99.13104,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78061',
  },
  {
    city: 'Pipe Creek',
    county_fips: 48019,
    county_fips_all: '48019',
    county: 'Bandera',
    county_names_all: 'Bandera',
    county_weights: '{"48019": 100}',
    density: 34.9,
    imprecise: false,
    latitude: 29.68793,
    longitude: -98.91424,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78063',
  },
  {
    city: 'Pleasanton',
    county_fips: 48013,
    county_fips_all: '48013|48493',
    county: 'Atascosa',
    county_names_all: 'Atascosa|Wilson',
    county_weights: '{"48013": 95.91, "48493": 4.09}',
    density: 22.5,
    imprecise: false,
    latitude: 28.9206,
    longitude: -98.4249,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78064',
  },
  {
    city: 'Poteet',
    county_fips: 48013,
    county_fips_all: '48013',
    county: 'Atascosa',
    county_names_all: 'Atascosa',
    county_weights: '{"48013": 100}',
    density: 26,
    imprecise: false,
    latitude: 29.08152,
    longitude: -98.64437,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78065',
  },
  {
    city: 'Rio Medina',
    county_fips: 48325,
    county_fips_all: '48325',
    county: 'Medina',
    county_names_all: 'Medina',
    county_weights: '{"48325": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 29.49065,
    longitude: -98.89042,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78066',
  },
  {
    city: 'San Ygnacio',
    county_fips: 48505,
    county_fips_all: '48505',
    county: 'Zapata',
    county_names_all: 'Zapata',
    county_weights: '{"48505": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 27.11312,
    longitude: -99.32793,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78067',
  },
  {
    city: 'Somerset',
    county_fips: 48013,
    county_fips_all: '48013|48029',
    county: 'Atascosa',
    county_names_all: 'Atascosa|Bexar',
    county_weights: '{"48013": 72.15, "48029": 27.85}',
    density: 95.4,
    imprecise: false,
    latitude: 29.18973,
    longitude: -98.68045,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78069',
  },
  {
    city: 'Spring Branch',
    county_fips: 48091,
    county_fips_all: '48091|48259|48031',
    county: 'Comal',
    county_names_all: 'Comal|Kendall|Blanco',
    county_weights: '{"48091": 82.36, "48259": 9.89, "48031": 7.75}',
    density: 58.5,
    imprecise: false,
    latitude: 29.89291,
    longitude: -98.40732,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78070',
  },
  {
    city: 'Three Rivers',
    county_fips: 48297,
    county_fips_all: '48297|48311',
    county: 'Live Oak',
    county_names_all: 'Live Oak|McMullen',
    county_weights: '{"48297": 89.55, "48311": 10.45}',
    density: 4.4,
    imprecise: false,
    latitude: 28.47756,
    longitude: -98.19733,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78071',
  },
  {
    city: 'Tilden',
    county_fips: 48311,
    county_fips_all: '48311',
    county: 'McMullen',
    county_names_all: 'McMullen',
    county_weights: '{"48311": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 28.32631,
    longitude: -98.58357,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78072',
  },
  {
    city: 'Von Ormy',
    county_fips: 48029,
    county_fips_all: '48029|48013',
    county: 'Bexar',
    county_names_all: 'Bexar|Atascosa',
    county_weights: '{"48029": 89.57, "48013": 10.43}',
    density: 72.9,
    imprecise: false,
    latitude: 29.24569,
    longitude: -98.6213,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78073',
  },
  {
    city: 'Waring',
    county_fips: 48259,
    county_fips_all: '48259',
    county: 'Kendall',
    county_names_all: 'Kendall',
    county_weights: '{"48259": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.94234,
    longitude: -98.79214,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78074',
  },
  {
    city: 'Whitsett',
    county_fips: 48297,
    county_fips_all: '48297|48311',
    county: 'Live Oak',
    county_names_all: 'Live Oak|McMullen',
    county_weights: '{"48297": 94.81, "48311": 5.19}',
    density: 1.4,
    imprecise: false,
    latitude: 28.58862,
    longitude: -98.26823,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78075',
  },
  {
    city: 'Zapata',
    county_fips: 48505,
    county_fips_all: '48505',
    county: 'Zapata',
    county_names_all: 'Zapata',
    county_weights: '{"48505": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 26.93149,
    longitude: -99.13382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78076',
  },
  {
    city: 'Adkins',
    county_fips: 48029,
    county_fips_all: '48029|48493',
    county: 'Bexar',
    county_names_all: 'Bexar|Wilson',
    county_weights: '{"48029": 52.36, "48493": 47.64}',
    density: 53.1,
    imprecise: false,
    latitude: 29.34444,
    longitude: -98.23316,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78101',
  },
  {
    city: 'Beeville',
    county_fips: 48025,
    county_fips_all: '48025|48297',
    county: 'Bee',
    county_names_all: 'Bee|Live Oak',
    county_weights: '{"48025": 94.24, "48297": 5.76}',
    density: 20.1,
    imprecise: false,
    latitude: 28.4094,
    longitude: -97.71733,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78102',
  },
  {
    city: 'Beeville',
    county_fips: 48025,
    county_fips_all: '48025',
    county: 'Bee',
    county_names_all: 'Bee',
    county_weights: '{"48025": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 28.52361,
    longitude: -97.76197,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78104',
  },
  {
    city: 'Berclair',
    county_fips: 48175,
    county_fips_all: '48175',
    county: 'Goliad',
    county_names_all: 'Goliad',
    county_weights: '{"48175": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 28.57827,
    longitude: -97.59484,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78107',
  },
  {
    city: 'Cibolo',
    county_fips: 48187,
    county_fips_all: '48187|48029|48091',
    county: 'Guadalupe',
    county_names_all: 'Guadalupe|Bexar|Comal',
    county_weights: '{"48187": 87.08, "48029": 10.15, "48091": 2.77}',
    density: 680.7,
    imprecise: false,
    latitude: 29.57354,
    longitude: -98.22068,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78108',
  },
  {
    city: 'Converse',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 874.9,
    imprecise: false,
    latitude: 29.47977,
    longitude: -98.29295,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78109',
  },
  {
    city: 'Ecleto',
    county_fips: 48255,
    county_fips_all: '48255',
    county: 'Karnes',
    county_names_all: 'Karnes',
    county_weights: '{"48255": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.03696,
    longitude: -97.74074,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78111',
  },
  {
    city: 'Elmendorf',
    county_fips: 48029,
    county_fips_all: '48029|48493',
    county: 'Bexar',
    county_names_all: 'Bexar|Wilson',
    county_weights: '{"48029": 98.83, "48493": 1.17}',
    density: 73.4,
    imprecise: false,
    latitude: 29.21353,
    longitude: -98.37266,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78112',
  },
  {
    city: 'Falls City',
    county_fips: 48493,
    county_fips_all: '48493|48013|48255',
    county: 'Wilson',
    county_names_all: 'Wilson|Atascosa|Karnes',
    county_weights: '{"48493": 40.11, "48013": 31.78, "48255": 28.11}',
    density: 3.9,
    imprecise: false,
    latitude: 28.94563,
    longitude: -98.13611,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78113',
  },
  {
    city: 'Floresville',
    county_fips: 48493,
    county_fips_all: '48493|48013',
    county: 'Wilson',
    county_names_all: 'Wilson|Atascosa',
    county_weights: '{"48493": 92.64, "48013": 7.36}',
    density: 26.9,
    imprecise: false,
    latitude: 29.12124,
    longitude: -98.19708,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78114',
  },
  {
    city: 'Gillett',
    county_fips: 48255,
    county_fips_all: '48255',
    county: 'Karnes',
    county_names_all: 'Karnes',
    county_weights: '{"48255": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 29.11275,
    longitude: -97.75677,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78116',
  },
  {
    city: 'Hobson',
    county_fips: 48255,
    county_fips_all: '48255',
    county: 'Karnes',
    county_names_all: 'Karnes',
    county_weights: '{"48255": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 28.95092,
    longitude: -97.95736,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78117',
  },
  {
    city: 'Karnes City',
    county_fips: 48255,
    county_fips_all: '48255|48297|48013',
    county: 'Karnes',
    county_names_all: 'Karnes|Live Oak|Atascosa',
    county_weights: '{"48255": 89.2, "48297": 7.38, "48013": 3.42}',
    density: 9.4,
    imprecise: false,
    latitude: 28.87574,
    longitude: -97.94729,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78118',
  },
  {
    city: 'Kenedy',
    county_fips: 48255,
    county_fips_all: '48255|48025|48297',
    county: 'Karnes',
    county_names_all: 'Karnes|Bee|Live Oak',
    county_weights: '{"48255": 54.89, "48025": 33.5, "48297": 11.61}',
    density: 8.5,
    imprecise: false,
    latitude: 28.71739,
    longitude: -97.91187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78119',
  },
  {
    city: 'La Vernia',
    county_fips: 48493,
    county_fips_all: '48493|48187',
    county: 'Wilson',
    county_names_all: 'Wilson|Guadalupe',
    county_weights: '{"48493": 75.23, "48187": 24.77}',
    density: 60.7,
    imprecise: false,
    latitude: 29.35118,
    longitude: -98.10241,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78121',
  },
  {
    city: 'Leesville',
    county_fips: 48177,
    county_fips_all: '48177',
    county: 'Gonzales',
    county_names_all: 'Gonzales',
    county_weights: '{"48177": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 29.44512,
    longitude: -97.72212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78122',
  },
  {
    city: 'McQueeney',
    county_fips: 48187,
    county_fips_all: '48187',
    county: 'Guadalupe',
    county_names_all: 'Guadalupe',
    county_weights: '{"48187": 100}',
    density: 219.8,
    imprecise: false,
    latitude: 29.60056,
    longitude: -98.04236,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78123',
  },
  {
    city: 'Marion',
    county_fips: 48187,
    county_fips_all: '48187|48029',
    county: 'Guadalupe',
    county_names_all: 'Guadalupe|Bexar',
    county_weights: '{"48187": 87.48, "48029": 12.52}',
    density: 41.8,
    imprecise: false,
    latitude: 29.5585,
    longitude: -98.15176,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78124',
  },
  {
    city: 'Mineral',
    county_fips: 48025,
    county_fips_all: '48025',
    county: 'Bee',
    county_names_all: 'Bee',
    county_weights: '{"48025": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 28.53184,
    longitude: -97.96656,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78125',
  },
  {
    city: 'New Braunfels',
    county_fips: 48187,
    county_fips_all: '48187|48091|48209',
    county: 'Guadalupe',
    county_names_all: 'Guadalupe|Comal|Hays',
    county_weights: '{"48187": 55.98, "48091": 43.52, "48209": 0.5}',
    density: 441.1,
    imprecise: false,
    latitude: 29.69224,
    longitude: -98.06877,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 104009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78130',
  },
  {
    city: 'New Braunfels',
    county_fips: 48091,
    county_fips_all: '48091|48187',
    county: 'Comal',
    county_names_all: 'Comal|Guadalupe',
    county_weights: '{"48091": 99.47, "48187": 0.53}',
    density: 88.2,
    imprecise: false,
    latitude: 29.76299,
    longitude: -98.19,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78132',
  },
  {
    city: 'Canyon Lake',
    county_fips: 48091,
    county_fips_all: '48091',
    county: 'Comal',
    county_names_all: 'Comal',
    county_weights: '{"48091": 100}',
    density: 112.3,
    imprecise: false,
    latitude: 29.88119,
    longitude: -98.24624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78133',
  },
  {
    city: 'Nixon',
    county_fips: 48177,
    county_fips_all: '48177|48493|48187|48255',
    county: 'Gonzales',
    county_names_all: 'Gonzales|Wilson|Guadalupe|Karnes',
    county_weights:
      '{"48177": 67.47, "48493": 27.32, "48187": 3.26, "48255": 1.95}',
    density: 7.7,
    imprecise: false,
    latitude: 29.30758,
    longitude: -97.7619,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78140',
  },
  {
    city: 'Nordheim',
    county_fips: 48123,
    county_fips_all: '48123|48255',
    county: 'DeWitt',
    county_names_all: 'DeWitt|Karnes',
    county_weights: '{"48123": 78.31, "48255": 21.69}',
    density: 4.3,
    imprecise: false,
    latitude: 28.90484,
    longitude: -97.62365,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78141',
  },
  {
    city: 'Normanna',
    county_fips: 48025,
    county_fips_all: '48025',
    county: 'Bee',
    county_names_all: 'Bee',
    county_weights: '{"48025": 100}',
    density: 0,
    imprecise: false,
    latitude: 28.53632,
    longitude: -97.81297,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78142',
  },
  {
    city: 'Pandora',
    county_fips: 48493,
    county_fips_all: '48493',
    county: 'Wilson',
    county_names_all: 'Wilson',
    county_weights: '{"48493": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.26267,
    longitude: -97.86085,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78143',
  },
  {
    city: 'Panna Maria',
    county_fips: 48255,
    county_fips_all: '48255',
    county: 'Karnes',
    county_names_all: 'Karnes',
    county_weights: '{"48255": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 28.95506,
    longitude: -97.88795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78144',
  },
  {
    city: 'Pawnee',
    county_fips: 48025,
    county_fips_all: '48025',
    county: 'Bee',
    county_names_all: 'Bee',
    county_weights: '{"48025": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 28.64539,
    longitude: -97.99248,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78145',
  },
  {
    city: 'Pettus',
    county_fips: 48025,
    county_fips_all: '48025',
    county: 'Bee',
    county_names_all: 'Bee',
    county_weights: '{"48025": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 28.6038,
    longitude: -97.83989,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78146',
  },
  {
    city: 'Poth',
    county_fips: 48493,
    county_fips_all: '48493',
    county: 'Wilson',
    county_names_all: 'Wilson',
    county_weights: '{"48493": 100}',
    density: 170.2,
    imprecise: false,
    latitude: 29.07375,
    longitude: -98.08017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78147',
  },
  {
    city: 'Universal City',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 888.5,
    imprecise: false,
    latitude: 29.54331,
    longitude: -98.29609,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78148',
  },
  {
    city: 'Runge',
    county_fips: 48255,
    county_fips_all: '48255|48123',
    county: 'Karnes',
    county_names_all: 'Karnes|DeWitt',
    county_weights: '{"48255": 95.18, "48123": 4.82}',
    density: 5,
    imprecise: false,
    latitude: 28.86788,
    longitude: -97.70986,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78151',
  },
  {
    city: 'Saint Hedwig',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 48.4,
    imprecise: false,
    latitude: 29.43046,
    longitude: -98.20171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78152',
  },
  {
    city: 'Schertz',
    county_fips: 48029,
    county_fips_all: '48029|48187|48091',
    county: 'Bexar',
    county_names_all: 'Bexar|Guadalupe|Comal',
    county_weights: '{"48029": 56.52, "48187": 31.82, "48091": 11.66}',
    density: 492.5,
    imprecise: false,
    latitude: 29.54774,
    longitude: -98.26574,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78154',
  },
  {
    city: 'Seguin',
    county_fips: 48187,
    county_fips_all: '48187',
    county: 'Guadalupe',
    county_names_all: 'Guadalupe',
    county_weights: '{"48187": 100}',
    density: 60.4,
    imprecise: false,
    latitude: 29.53305,
    longitude: -97.93832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78155',
  },
  {
    city: 'Smiley',
    county_fips: 48177,
    county_fips_all: '48177',
    county: 'Gonzales',
    county_names_all: 'Gonzales',
    county_weights: '{"48177": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 29.23031,
    longitude: -97.58247,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78159',
  },
  {
    city: 'Stockdale',
    county_fips: 48493,
    county_fips_all: '48493',
    county: 'Wilson',
    county_names_all: 'Wilson',
    county_weights: '{"48493": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 29.24182,
    longitude: -97.9285,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78160',
  },
  {
    city: 'Sutherland Springs',
    county_fips: 48493,
    county_fips_all: '48493',
    county: 'Wilson',
    county_names_all: 'Wilson',
    county_weights: '{"48493": 100}',
    density: 20.8,
    imprecise: false,
    latitude: 29.28741,
    longitude: -98.05012,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78161',
  },
  {
    city: 'Tuleta',
    county_fips: 48025,
    county_fips_all: '48025',
    county: 'Bee',
    county_names_all: 'Bee',
    county_weights: '{"48025": 100}',
    density: 8,
    imprecise: false,
    latitude: 28.57816,
    longitude: -97.79447,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78162',
  },
  {
    city: 'Bulverde',
    county_fips: 48091,
    county_fips_all: '48091',
    county: 'Comal',
    county_names_all: 'Comal',
    county_weights: '{"48091": 100}',
    density: 98.9,
    imprecise: false,
    latitude: 29.7663,
    longitude: -98.44514,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78163',
  },
  {
    city: 'Yorktown',
    county_fips: 48123,
    county_fips_all: '48123|48175',
    county: 'DeWitt',
    county_names_all: 'DeWitt|Goliad',
    county_weights: '{"48123": 87.32, "48175": 12.68}',
    density: 4.5,
    imprecise: false,
    latitude: 28.9792,
    longitude: -97.5188,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78164',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 2273.6,
    imprecise: false,
    latitude: 29.46901,
    longitude: -98.52861,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78201',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1711.4,
    imprecise: false,
    latitude: 29.42821,
    longitude: -98.46078,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78202',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1469.1,
    imprecise: false,
    latitude: 29.41513,
    longitude: -98.4593,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78203',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1706.6,
    imprecise: false,
    latitude: 29.40327,
    longitude: -98.50368,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78204',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 506.2,
    imprecise: false,
    latitude: 29.42364,
    longitude: -98.48647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78205',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 2933.9,
    imprecise: false,
    latitude: 29.42223,
    longitude: -98.52545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78207',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1525.9,
    imprecise: false,
    latitude: 29.4399,
    longitude: -98.45823,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78208',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1647.5,
    imprecise: false,
    latitude: 29.48899,
    longitude: -98.45675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78209',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1840.5,
    imprecise: false,
    latitude: 29.39597,
    longitude: -98.46433,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78210',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1166.2,
    imprecise: false,
    latitude: 29.34644,
    longitude: -98.56327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78211',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1529.7,
    imprecise: false,
    latitude: 29.46447,
    longitude: -98.49222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78212',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1947.8,
    imprecise: false,
    latitude: 29.51745,
    longitude: -98.52358,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78213',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1025.7,
    imprecise: false,
    latitude: 29.34944,
    longitude: -98.47971,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78214',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1274.1,
    imprecise: false,
    latitude: 29.4404,
    longitude: -98.48031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78215',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1130.1,
    imprecise: false,
    latitude: 29.53641,
    longitude: -98.48999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78216',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1295.7,
    imprecise: false,
    latitude: 29.54073,
    longitude: -98.42097,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78217',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1362.1,
    imprecise: false,
    latitude: 29.49354,
    longitude: -98.39948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78218',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 440.2,
    imprecise: false,
    latitude: 29.44137,
    longitude: -98.38459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78219',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 971.3,
    imprecise: false,
    latitude: 29.41308,
    longitude: -98.40152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78220',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 448.5,
    imprecise: false,
    latitude: 29.28097,
    longitude: -98.47529,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78221',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 536.4,
    imprecise: false,
    latitude: 29.3679,
    longitude: -98.38334,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78222',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029|48493',
    county: 'Bexar',
    county_names_all: 'Bexar|Wilson',
    county_weights: '{"48029": 91.62, "48493": 8.38}',
    density: 556.7,
    imprecise: false,
    latitude: 29.31102,
    longitude: -98.38675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78223',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 562.8,
    imprecise: false,
    latitude: 29.30831,
    longitude: -98.53751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78224',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 2623.8,
    imprecise: false,
    latitude: 29.38795,
    longitude: -98.52586,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78225',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 356.4,
    imprecise: false,
    latitude: 29.38442,
    longitude: -98.56885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78226',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 890.9,
    imprecise: false,
    latitude: 29.39654,
    longitude: -98.64019,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78227',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1988.6,
    imprecise: false,
    latitude: 29.46072,
    longitude: -98.57201,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78228',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 2381.7,
    imprecise: false,
    latitude: 29.5056,
    longitude: -98.57261,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78229',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1522.8,
    imprecise: false,
    latitude: 29.5455,
    longitude: -98.55571,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78230',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 920.2,
    imprecise: false,
    latitude: 29.57978,
    longitude: -98.54504,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78231',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1189.9,
    imprecise: false,
    latitude: 29.58792,
    longitude: -98.47503,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78232',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1381.4,
    imprecise: false,
    latitude: 29.55483,
    longitude: -98.36323,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78233',
  },
  {
    city: 'Jbsa Ft Sam Houston',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 542.7,
    imprecise: false,
    latitude: 29.46108,
    longitude: -98.43715,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78234',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 467,
    imprecise: false,
    latitude: 29.34244,
    longitude: -98.43934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78235',
  },
  {
    city: 'Jbsa Lackland',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 599.6,
    imprecise: false,
    latitude: 29.3859,
    longitude: -98.62256,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78236',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 2025.7,
    imprecise: false,
    latitude: 29.42079,
    longitude: -98.56832,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78237',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 989.6,
    imprecise: false,
    latitude: 29.47088,
    longitude: -98.61925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78238',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1729.1,
    imprecise: false,
    latitude: 29.51664,
    longitude: -98.3625,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78239',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 2001.7,
    imprecise: false,
    latitude: 29.5244,
    longitude: -98.60813,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78240',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1764.3,
    imprecise: false,
    latitude: 29.35067,
    longitude: -98.60751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78242',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1948.8,
    imprecise: false,
    latitude: 29.47702,
    longitude: -98.35075,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78244',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1051.8,
    imprecise: false,
    latitude: 29.40106,
    longitude: -98.73549,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 96015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78245',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1376.8,
    imprecise: false,
    latitude: 29.58005,
    longitude: -98.41196,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78247',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1451.5,
    imprecise: false,
    latitude: 29.59022,
    longitude: -98.52553,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78248',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1691.3,
    imprecise: false,
    latitude: 29.56752,
    longitude: -98.614,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78249',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 2349.9,
    imprecise: false,
    latitude: 29.50341,
    longitude: -98.66668,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78250',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1531.6,
    imprecise: false,
    latitude: 29.46292,
    longitude: -98.67763,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 59435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78251',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 299.2,
    imprecise: false,
    latitude: 29.34167,
    longitude: -98.69682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78252',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029|48325',
    county: 'Bexar',
    county_names_all: 'Bexar|Medina',
    county_weights: '{"48029": 62.69, "48325": 37.31}',
    density: 498.9,
    imprecise: false,
    latitude: 29.46899,
    longitude: -98.78885,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 69282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78253',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1487.1,
    imprecise: false,
    latitude: 29.53011,
    longitude: -98.72805,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 77893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78254',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 373.9,
    imprecise: false,
    latitude: 29.64814,
    longitude: -98.66405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78255',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 650.1,
    imprecise: false,
    latitude: 29.62272,
    longitude: -98.6262,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78256',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 148.9,
    imprecise: false,
    latitude: 29.64373,
    longitude: -98.57713,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78257',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 1163.4,
    imprecise: false,
    latitude: 29.63574,
    longitude: -98.49282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78258',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 741.8,
    imprecise: false,
    latitude: 29.62512,
    longitude: -98.42031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78259',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 588.2,
    imprecise: false,
    latitude: 29.69737,
    longitude: -98.49212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78260',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 353.4,
    imprecise: false,
    latitude: 29.69189,
    longitude: -98.40072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78261',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 43,
    imprecise: false,
    latitude: 29.35084,
    longitude: -98.31219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78263',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029|48013',
    county: 'Bexar',
    county_names_all: 'Bexar|Atascosa',
    county_weights: '{"48029": 93.59, "48013": 6.41}',
    density: 64.7,
    imprecise: false,
    latitude: 29.19868,
    longitude: -98.50534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78264',
  },
  {
    city: 'San Antonio',
    county_fips: 48091,
    county_fips_all: '48091|48029',
    county: 'Comal',
    county_names_all: 'Comal|Bexar',
    county_weights: '{"48091": 80.34, "48029": 19.66}',
    density: 71.4,
    imprecise: false,
    latitude: 29.65611,
    longitude: -98.3295,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78266',
  },
  {
    city: 'Agua Dulce',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 27.7656,
    longitude: -97.91378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78330',
  },
  {
    city: 'Alice',
    county_fips: 48249,
    county_fips_all: '48249|48131',
    county: 'Jim Wells',
    county_names_all: 'Jim Wells|Duval',
    county_weights: '{"48249": 84.75, "48131": 15.25}',
    density: 21.4,
    imprecise: false,
    latitude: 27.71671,
    longitude: -98.13208,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78332',
  },
  {
    city: 'Aransas Pass',
    county_fips: 48409,
    county_fips_all: '48409|48007|48355',
    county: 'San Patricio',
    county_names_all: 'San Patricio|Aransas|Nueces',
    county_weights: '{"48409": 63.89, "48007": 29.97, "48355": 6.14}',
    density: 80,
    imprecise: false,
    latitude: 27.94356,
    longitude: -97.1862,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78336',
  },
  {
    city: 'Armstrong',
    county_fips: 48261,
    county_fips_all: '48261',
    county: 'Kenedy',
    county_names_all: 'Kenedy',
    county_weights: '{"48261": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 26.86821,
    longitude: -97.73585,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78338',
  },
  {
    city: 'Banquete',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 125.3,
    imprecise: false,
    latitude: 27.80036,
    longitude: -97.7912,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78339',
  },
  {
    city: 'Bayside',
    county_fips: 48391,
    county_fips_all: '48391',
    county: 'Refugio',
    county_names_all: 'Refugio',
    county_weights: '{"48391": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 28.12472,
    longitude: -97.20982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78340',
  },
  {
    city: 'Benavides',
    county_fips: 48131,
    county_fips_all: '48131',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"48131": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 27.57551,
    longitude: -98.46636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78341',
  },
  {
    city: 'Ben Bolt',
    county_fips: 48249,
    county_fips_all: '48249',
    county: 'Jim Wells',
    county_names_all: 'Jim Wells',
    county_weights: '{"48249": 100}',
    density: 87.6,
    imprecise: false,
    latitude: 27.66012,
    longitude: -98.07572,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78342',
  },
  {
    city: 'Bishop',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 27.62163,
    longitude: -97.77216,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78343',
  },
  {
    city: 'Bruni',
    county_fips: 48479,
    county_fips_all: '48479',
    county: 'Webb',
    county_names_all: 'Webb',
    county_weights: '{"48479": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 27.56303,
    longitude: -98.85966,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78344',
  },
  {
    city: 'Chapman Ranch',
    county_fips: 48355,
    county_fips_all: '48355|48273',
    county: 'Nueces',
    county_names_all: 'Nueces|Kleberg',
    county_weights: '{"48355": 99.65, "48273": 0.35}',
    density: 20,
    imprecise: false,
    latitude: 27.57337,
    longitude: -97.48642,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78347',
  },
  {
    city: 'Concepcion',
    county_fips: 48131,
    county_fips_all: '48131',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"48131": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 27.37501,
    longitude: -98.29983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78349',
  },
  {
    city: 'Driscoll',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 197.8,
    imprecise: false,
    latitude: 27.66779,
    longitude: -97.75258,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78351',
  },
  {
    city: 'Edroy',
    county_fips: 48409,
    county_fips_all: '48409',
    county: 'San Patricio',
    county_names_all: 'San Patricio',
    county_weights: '{"48409": 100}',
    density: 5,
    imprecise: false,
    latitude: 27.98154,
    longitude: -97.68978,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78352',
  },
  {
    city: 'Encino',
    county_fips: 48047,
    county_fips_all: '48047',
    county: 'Brooks',
    county_names_all: 'Brooks',
    county_weights: '{"48047": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 26.88621,
    longitude: -98.23927,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78353',
  },
  {
    city: 'Falfurrias',
    county_fips: 48047,
    county_fips_all: '48047|48249|48273',
    county: 'Brooks',
    county_names_all: 'Brooks|Jim Wells|Kleberg',
    county_weights: '{"48047": 84.63, "48249": 11.3, "48273": 4.07}',
    density: 7.4,
    imprecise: false,
    latitude: 27.18855,
    longitude: -98.20304,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78355',
  },
  {
    city: 'Freer',
    county_fips: 48131,
    county_fips_all: '48131',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"48131": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 27.93286,
    longitude: -98.5629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78357',
  },
  {
    city: 'Fulton',
    county_fips: 48007,
    county_fips_all: '48007',
    county: 'Aransas',
    county_names_all: 'Aransas',
    county_weights: '{"48007": 100}',
    density: 223.2,
    imprecise: false,
    latitude: 28.06841,
    longitude: -97.04325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78358',
  },
  {
    city: 'Gregory',
    county_fips: 48409,
    county_fips_all: '48409',
    county: 'San Patricio',
    county_names_all: 'San Patricio',
    county_weights: '{"48409": 100}',
    density: 86.8,
    imprecise: false,
    latitude: 27.93021,
    longitude: -97.30056,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78359',
  },
  {
    city: 'Guerra',
    county_fips: 48247,
    county_fips_all: '48247',
    county: 'Jim Hogg',
    county_names_all: 'Jim Hogg',
    county_weights: '{"48247": 100}',
    density: 0,
    imprecise: false,
    latitude: 26.8605,
    longitude: -98.83204,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78360',
  },
  {
    city: 'Hebbronville',
    county_fips: 48247,
    county_fips_all: '48247|48505|48131',
    county: 'Jim Hogg',
    county_names_all: 'Jim Hogg|Zapata|Duval',
    county_weights: '{"48247": 87.68, "48505": 9.44, "48131": 2.88}',
    density: 2,
    imprecise: false,
    latitude: 27.08457,
    longitude: -98.73973,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78361',
  },
  {
    city: 'Ingleside',
    county_fips: 48409,
    county_fips_all: '48409|48355',
    county: 'San Patricio',
    county_names_all: 'San Patricio|Nueces',
    county_weights: '{"48409": 99.9, "48355": 0.1}',
    density: 228.5,
    imprecise: false,
    latitude: 27.86668,
    longitude: -97.20167,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78362',
  },
  {
    city: 'Kingsville',
    county_fips: 48273,
    county_fips_all: '48273',
    county: 'Kleberg',
    county_names_all: 'Kleberg',
    county_weights: '{"48273": 100}',
    density: 73.4,
    imprecise: false,
    latitude: 27.43836,
    longitude: -97.85532,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78363',
  },
  {
    city: 'Mathis',
    county_fips: 48409,
    county_fips_all: '48409|48297',
    county: 'San Patricio',
    county_names_all: 'San Patricio|Live Oak',
    county_weights: '{"48409": 68.72, "48297": 31.28}',
    density: 17.7,
    imprecise: false,
    latitude: 28.11299,
    longitude: -97.81201,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78368',
  },
  {
    city: 'Mirando City',
    county_fips: 48479,
    county_fips_all: '48479',
    county: 'Webb',
    county_names_all: 'Webb',
    county_weights: '{"48479": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 27.42418,
    longitude: -99.08229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78369',
  },
  {
    city: 'Odem',
    county_fips: 48409,
    county_fips_all: '48409',
    county: 'San Patricio',
    county_names_all: 'San Patricio',
    county_weights: '{"48409": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 27.94238,
    longitude: -97.6033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78370',
  },
  {
    city: 'Oilton',
    county_fips: 48479,
    county_fips_all: '48479',
    county: 'Webb',
    county_names_all: 'Webb',
    county_weights: '{"48479": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 27.5493,
    longitude: -99.04716,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78371',
  },
  {
    city: 'Orange Grove',
    county_fips: 48249,
    county_fips_all: '48249|48297|48131',
    county: 'Jim Wells',
    county_names_all: 'Jim Wells|Live Oak|Duval',
    county_weights: '{"48249": 77.28, "48297": 12.94, "48131": 9.78}',
    density: 8.5,
    imprecise: false,
    latitude: 27.9979,
    longitude: -98.09669,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78372',
  },
  {
    city: 'Port Aransas',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 68.6,
    imprecise: false,
    latitude: 27.78075,
    longitude: -97.11737,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78373',
  },
  {
    city: 'Portland',
    county_fips: 48409,
    county_fips_all: '48409',
    county: 'San Patricio',
    county_names_all: 'San Patricio',
    county_weights: '{"48409": 100}',
    density: 424.6,
    imprecise: false,
    latitude: 27.88849,
    longitude: -97.29366,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78374',
  },
  {
    city: 'Premont',
    county_fips: 48249,
    county_fips_all: '48249',
    county: 'Jim Wells',
    county_names_all: 'Jim Wells',
    county_weights: '{"48249": 100}',
    density: 12,
    imprecise: false,
    latitude: 27.38282,
    longitude: -98.16351,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78375',
  },
  {
    city: 'Realitos',
    county_fips: 48131,
    county_fips_all: '48131',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"48131": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 27.37163,
    longitude: -98.47721,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78376',
  },
  {
    city: 'Refugio',
    county_fips: 48391,
    county_fips_all: '48391',
    county: 'Refugio',
    county_names_all: 'Refugio',
    county_weights: '{"48391": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 28.3418,
    longitude: -97.18051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78377',
  },
  {
    city: 'Riviera',
    county_fips: 48273,
    county_fips_all: '48273',
    county: 'Kleberg',
    county_names_all: 'Kleberg',
    county_weights: '{"48273": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 27.30211,
    longitude: -97.79361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78379',
  },
  {
    city: 'Robstown',
    county_fips: 48355,
    county_fips_all: '48355|48249',
    county: 'Nueces',
    county_names_all: 'Nueces|Jim Wells',
    county_weights: '{"48355": 99.72, "48249": 0.28}',
    density: 26.1,
    imprecise: false,
    latitude: 27.77872,
    longitude: -97.7363,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78380',
  },
  {
    city: 'Rockport',
    county_fips: 48007,
    county_fips_all: '48007',
    county: 'Aransas',
    county_names_all: 'Aransas',
    county_weights: '{"48007": 100}',
    density: 99.4,
    imprecise: false,
    latitude: 28.11489,
    longitude: -97.06342,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78382',
  },
  {
    city: 'Sandia',
    county_fips: 48297,
    county_fips_all: '48297|48249|48355',
    county: 'Live Oak',
    county_names_all: 'Live Oak|Jim Wells|Nueces',
    county_weights: '{"48297": 63.82, "48249": 29.04, "48355": 7.14}',
    density: 11.1,
    imprecise: false,
    latitude: 28.07713,
    longitude: -97.94425,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78383',
  },
  {
    city: 'San Diego',
    county_fips: 48131,
    county_fips_all: '48131|48249',
    county: 'Duval',
    county_names_all: 'Duval|Jim Wells',
    county_weights: '{"48131": 98.61, "48249": 1.39}',
    density: 3.8,
    imprecise: false,
    latitude: 27.73068,
    longitude: -98.4707,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78384',
  },
  {
    city: 'Sarita',
    county_fips: 48261,
    county_fips_all: '48261',
    county: 'Kenedy',
    county_names_all: 'Kenedy',
    county_weights: '{"48261": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 27.1276,
    longitude: -97.8369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78385',
  },
  {
    city: 'Sinton',
    county_fips: 48409,
    county_fips_all: '48409|48025',
    county: 'San Patricio',
    county_names_all: 'San Patricio|Bee',
    county_weights: '{"48409": 79.14, "48025": 20.86}',
    density: 21.6,
    imprecise: false,
    latitude: 28.08224,
    longitude: -97.55255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78387',
  },
  {
    city: 'Skidmore',
    county_fips: 48025,
    county_fips_all: '48025',
    county: 'Bee',
    county_names_all: 'Bee',
    county_weights: '{"48025": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 28.244,
    longitude: -97.66619,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78389',
  },
  {
    city: 'Taft',
    county_fips: 48409,
    county_fips_all: '48409|48007',
    county: 'San Patricio',
    county_names_all: 'San Patricio|Aransas',
    county_weights: '{"48409": 91.7, "48007": 8.3}',
    density: 11.5,
    imprecise: false,
    latitude: 28.00198,
    longitude: -97.35631,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78390',
  },
  {
    city: 'Tynan',
    county_fips: 48025,
    county_fips_all: '48025',
    county: 'Bee',
    county_names_all: 'Bee',
    county_weights: '{"48025": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 28.18297,
    longitude: -97.72743,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78391',
  },
  {
    city: 'Woodsboro',
    county_fips: 48391,
    county_fips_all: '48391',
    county: 'Refugio',
    county_names_all: 'Refugio',
    county_weights: '{"48391": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 28.18097,
    longitude: -97.35427,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78393',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 779.6,
    imprecise: false,
    latitude: 27.79734,
    longitude: -97.40118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78401',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 50.6,
    imprecise: false,
    latitude: 27.82413,
    longitude: -97.4091,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78402',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 1516.6,
    imprecise: false,
    latitude: 27.76798,
    longitude: -97.39946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78404',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 1107,
    imprecise: false,
    latitude: 27.77404,
    longitude: -97.43872,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78405',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 78.9,
    imprecise: false,
    latitude: 27.77197,
    longitude: -97.51543,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78406',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 269.5,
    imprecise: false,
    latitude: 27.80762,
    longitude: -97.44772,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1674,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78407',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 666.2,
    imprecise: false,
    latitude: 27.80081,
    longitude: -97.44339,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78408',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 61.5,
    imprecise: false,
    latitude: 27.81729,
    longitude: -97.51458,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78409',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 498.7,
    imprecise: false,
    latitude: 27.83798,
    longitude: -97.59388,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78410',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 1490.6,
    imprecise: false,
    latitude: 27.7293,
    longitude: -97.38504,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78411',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 1726.9,
    imprecise: false,
    latitude: 27.70364,
    longitude: -97.34264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78412',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 1680.1,
    imprecise: false,
    latitude: 27.68345,
    longitude: -97.40409,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78413',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 1472,
    imprecise: false,
    latitude: 27.65992,
    longitude: -97.369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78414',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 152.4,
    imprecise: false,
    latitude: 27.65437,
    longitude: -97.48712,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78415',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 1451.5,
    imprecise: false,
    latitude: 27.74933,
    longitude: -97.43759,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78416',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 194.9,
    imprecise: false,
    latitude: 27.73753,
    longitude: -97.46771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78417',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48273,
    county_fips_all: '48273|48355',
    county: 'Kleberg',
    county_names_all: 'Kleberg|Nueces',
    county_weights: '{"48273": 53.26, "48355": 46.74}',
    density: 156.8,
    imprecise: false,
    latitude: 27.52732,
    longitude: -97.29313,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78418',
  },
  {
    city: 'Mcallen',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 1464.3,
    imprecise: false,
    latitude: 26.21599,
    longitude: -98.2391,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 58935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78501',
  },
  {
    city: 'Mcallen',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 454.7,
    imprecise: false,
    latitude: 26.16229,
    longitude: -98.25132,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78503',
  },
  {
    city: 'Mcallen',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 1243.3,
    imprecise: false,
    latitude: 26.27758,
    longitude: -98.23728,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 63094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78504',
  },
  {
    city: 'Alamo',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 350.9,
    imprecise: false,
    latitude: 26.14256,
    longitude: -98.11977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78516',
  },
  {
    city: 'Brownsville',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 629.1,
    imprecise: false,
    latitude: 25.96564,
    longitude: -97.55103,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78520',
  },
  {
    city: 'Brownsville',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 359.9,
    imprecise: false,
    latitude: 25.95109,
    longitude: -97.32078,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 87380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78521',
  },
  {
    city: 'Brownsville',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 488.8,
    imprecise: false,
    latitude: 25.99587,
    longitude: -97.44991,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 60012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78526',
  },
  {
    city: 'Combes',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 393.3,
    imprecise: false,
    latitude: 26.24948,
    longitude: -97.73124,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78535',
  },
  {
    city: 'Delmita',
    county_fips: 48427,
    county_fips_all: '48427|48215',
    county: 'Starr',
    county_names_all: 'Starr|Hidalgo',
    county_weights: '{"48427": 98.23, "48215": 1.77}',
    density: 3.3,
    imprecise: false,
    latitude: 26.6432,
    longitude: -98.44369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78536',
  },
  {
    city: 'Donna',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 344.8,
    imprecise: false,
    latitude: 26.17322,
    longitude: -98.05744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78537',
  },
  {
    city: 'Edcouch',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 69,
    imprecise: false,
    latitude: 26.36812,
    longitude: -97.97152,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78538',
  },
  {
    city: 'Edinburg',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 1172.5,
    imprecise: false,
    latitude: 26.28,
    longitude: -98.18311,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78539',
  },
  {
    city: 'Edinburg',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 0,
    imprecise: false,
    latitude: 26.54911,
    longitude: -97.99164,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78540',
  },
  {
    city: 'Edinburg',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 68.8,
    imprecise: false,
    latitude: 26.4528,
    longitude: -98.28632,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78541',
  },
  {
    city: 'Edinburg',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 196.2,
    imprecise: false,
    latitude: 26.44412,
    longitude: -98.09163,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 89401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78542',
  },
  {
    city: 'Elsa',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 510.2,
    imprecise: false,
    latitude: 26.30117,
    longitude: -98.00508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78543',
  },
  {
    city: 'Falcon Heights',
    county_fips: 48505,
    county_fips_all: '48505|48427',
    county: 'Zapata',
    county_names_all: 'Zapata|Starr',
    county_weights: '{"48505": 54.16, "48427": 45.84}',
    density: 6.9,
    imprecise: false,
    latitude: 26.591,
    longitude: -99.13889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78545',
  },
  {
    city: 'Garciasville',
    county_fips: 48427,
    county_fips_all: '48427',
    county: 'Starr',
    county_names_all: 'Starr',
    county_weights: '{"48427": 100}',
    density: 62.8,
    imprecise: false,
    latitude: 26.30868,
    longitude: -98.69723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78547',
  },
  {
    city: 'Grulla',
    county_fips: 48427,
    county_fips_all: '48427',
    county: 'Starr',
    county_names_all: 'Starr',
    county_weights: '{"48427": 100}',
    density: 69.3,
    imprecise: false,
    latitude: 26.27654,
    longitude: -98.65527,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78548',
  },
  {
    city: 'Hargill',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 26.48528,
    longitude: -98.02329,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78549',
  },
  {
    city: 'Harlingen',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 218.6,
    imprecise: false,
    latitude: 26.25469,
    longitude: -97.66406,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78550',
  },
  {
    city: 'Harlingen',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 340.3,
    imprecise: false,
    latitude: 26.19664,
    longitude: -97.75083,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 42332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78552',
  },
  {
    city: 'Hidalgo',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 337.3,
    imprecise: false,
    latitude: 26.10844,
    longitude: -98.25118,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78557',
  },
  {
    city: 'La Blanca',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 361.6,
    imprecise: false,
    latitude: 26.29276,
    longitude: -98.02366,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78558',
  },
  {
    city: 'La Feria',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 129.4,
    imprecise: false,
    latitude: 26.14549,
    longitude: -97.82765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78559',
  },
  {
    city: 'La Joya',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 125.8,
    imprecise: false,
    latitude: 26.25545,
    longitude: -98.49515,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78560',
  },
  {
    city: 'Lasara',
    county_fips: 48489,
    county_fips_all: '48489',
    county: 'Willacy',
    county_names_all: 'Willacy',
    county_weights: '{"48489": 100}',
    density: 532.1,
    imprecise: false,
    latitude: 26.4687,
    longitude: -97.91595,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78561',
  },
  {
    city: 'La Villa',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 57.7,
    imprecise: false,
    latitude: 26.28809,
    longitude: -97.89293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78562',
  },
  {
    city: 'Linn',
    county_fips: 48215,
    county_fips_all: '48215|48427',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo|Starr',
    county_weights: '{"48215": 99.25, "48427": 0.75}',
    density: 0.1,
    imprecise: false,
    latitude: 26.66557,
    longitude: -98.2517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78563',
  },
  {
    city: 'Lopeno',
    county_fips: 48505,
    county_fips_all: '48505',
    county: 'Zapata',
    county_names_all: 'Zapata',
    county_weights: '{"48505": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 26.67801,
    longitude: -99.13171,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78564',
  },
  {
    city: 'Los Ebanos',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 26.24453,
    longitude: -98.561,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78565',
  },
  {
    city: 'Los Fresnos',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 69.8,
    imprecise: false,
    latitude: 26.13543,
    longitude: -97.42184,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78566',
  },
  {
    city: 'Los Indios',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 89.6,
    imprecise: false,
    latitude: 26.04607,
    longitude: -97.73866,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78567',
  },
  {
    city: 'Lyford',
    county_fips: 48489,
    county_fips_all: '48489|48215|48061',
    county: 'Willacy',
    county_names_all: 'Willacy|Hidalgo|Cameron',
    county_weights: '{"48489": 79.67, "48215": 14.69, "48061": 5.64}',
    density: 11,
    imprecise: false,
    latitude: 26.37417,
    longitude: -97.73851,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78569',
  },
  {
    city: 'Mercedes',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 176.4,
    imprecise: false,
    latitude: 26.17149,
    longitude: -97.9112,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78570',
  },
  {
    city: 'Mission',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 561.3,
    imprecise: false,
    latitude: 26.19848,
    longitude: -98.35633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 78024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78572',
  },
  {
    city: 'Mission',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 471.7,
    imprecise: false,
    latitude: 26.29745,
    longitude: -98.30242,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78573',
  },
  {
    city: 'Mission',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 464.9,
    imprecise: false,
    latitude: 26.31118,
    longitude: -98.37293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 62456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78574',
  },
  {
    city: 'Olmito',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 212.1,
    imprecise: false,
    latitude: 26.03234,
    longitude: -97.55083,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78575',
  },
  {
    city: 'Penitas',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 102.7,
    imprecise: false,
    latitude: 26.32584,
    longitude: -98.46799,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78576',
  },
  {
    city: 'Pharr',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 1196,
    imprecise: false,
    latitude: 26.1665,
    longitude: -98.19082,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 80540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78577',
  },
  {
    city: 'Port Isabel',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 67.9,
    imprecise: false,
    latitude: 26.05336,
    longitude: -97.31004,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78578',
  },
  {
    city: 'Progreso',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 138.2,
    imprecise: false,
    latitude: 26.0892,
    longitude: -97.94627,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78579',
  },
  {
    city: 'Raymondville',
    county_fips: 48489,
    county_fips_all: '48489|48261',
    county: 'Willacy',
    county_names_all: 'Willacy|Kenedy',
    county_weights: '{"48489": 92.05, "48261": 7.95}',
    density: 19.5,
    imprecise: false,
    latitude: 26.50065,
    longitude: -97.75087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78580',
  },
  {
    city: 'Rio Grande City',
    county_fips: 48427,
    county_fips_all: '48427',
    county: 'Starr',
    county_names_all: 'Starr',
    county_weights: '{"48427": 100}',
    density: 30.6,
    imprecise: false,
    latitude: 26.53937,
    longitude: -98.73985,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78582',
  },
  {
    city: 'Rio Hondo',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 21.7,
    imprecise: false,
    latitude: 26.28166,
    longitude: -97.4686,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78583',
  },
  {
    city: 'Roma',
    county_fips: 48427,
    county_fips_all: '48427',
    county: 'Starr',
    county_names_all: 'Starr',
    county_weights: '{"48427": 100}',
    density: 33.5,
    imprecise: false,
    latitude: 26.56226,
    longitude: -98.98471,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78584',
  },
  {
    city: 'Salineno',
    county_fips: 48427,
    county_fips_all: '48427',
    county: 'Starr',
    county_names_all: 'Starr',
    county_weights: '{"48427": 100}',
    density: 0,
    imprecise: false,
    latitude: 26.4856,
    longitude: -99.07737,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78585',
  },
  {
    city: 'San Benito',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 129,
    imprecise: false,
    latitude: 26.10715,
    longitude: -97.64576,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78586',
  },
  {
    city: 'San Isidro',
    county_fips: 48427,
    county_fips_all: '48427|48215',
    county: 'Starr',
    county_names_all: 'Starr|Hidalgo',
    county_weights: '{"48427": 99.63, "48215": 0.37}',
    density: 3,
    imprecise: false,
    latitude: 26.73966,
    longitude: -98.39852,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78588',
  },
  {
    city: 'San Juan',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 609.4,
    imprecise: false,
    latitude: 26.15349,
    longitude: -98.15979,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78589',
  },
  {
    city: 'San Perlita',
    county_fips: 48489,
    county_fips_all: '48489',
    county: 'Willacy',
    county_names_all: 'Willacy',
    county_weights: '{"48489": 100}',
    density: 165,
    imprecise: false,
    latitude: 26.50401,
    longitude: -97.63486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78590',
  },
  {
    city: 'Santa Elena',
    county_fips: 48427,
    county_fips_all: '48427',
    county: 'Starr',
    county_names_all: 'Starr',
    county_weights: '{"48427": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 26.65351,
    longitude: -98.53408,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78591',
  },
  {
    city: 'Santa Maria',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 75.6,
    imprecise: false,
    latitude: 26.06516,
    longitude: -97.8461,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78592',
  },
  {
    city: 'Santa Rosa',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 54.9,
    imprecise: false,
    latitude: 26.26999,
    longitude: -97.82187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78593',
  },
  {
    city: 'Sebastian',
    county_fips: 48489,
    county_fips_all: '48489',
    county: 'Willacy',
    county_names_all: 'Willacy',
    county_weights: '{"48489": 100}',
    density: 146.9,
    imprecise: false,
    latitude: 26.34704,
    longitude: -97.8037,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78594',
  },
  {
    city: 'Sullivan City',
    county_fips: 48215,
    county_fips_all: '48215|48427',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo|Starr',
    county_weights: '{"48215": 78.38, "48427": 21.62}',
    density: 77.4,
    imprecise: false,
    latitude: 26.31457,
    longitude: -98.54038,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78595',
  },
  {
    city: 'Weslaco',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 380.4,
    imprecise: false,
    latitude: 26.10668,
    longitude: -97.99856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78596',
  },
  {
    city: 'South Padre Island',
    county_fips: 48061,
    county_fips_all: '48061',
    county: 'Cameron',
    county_names_all: 'Cameron',
    county_weights: '{"48061": 100}',
    density: 128.2,
    imprecise: false,
    latitude: 26.2474,
    longitude: -97.19688,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78597',
  },
  {
    city: 'Weslaco',
    county_fips: 48215,
    county_fips_all: '48215',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"48215": 100}',
    density: 516.1,
    imprecise: false,
    latitude: 26.2181,
    longitude: -97.99087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78599',
  },
  {
    city: 'Bastrop',
    county_fips: 48021,
    county_fips_all: '48021',
    county: 'Bastrop',
    county_names_all: 'Bastrop',
    county_weights: '{"48021": 100}',
    density: 75.5,
    imprecise: false,
    latitude: 30.12735,
    longitude: -97.32801,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78602',
  },
  {
    city: 'Bertram',
    county_fips: 48053,
    county_fips_all: '48053',
    county: 'Burnet',
    county_names_all: 'Burnet',
    county_weights: '{"48053": 100}',
    density: 17,
    imprecise: false,
    latitude: 30.77366,
    longitude: -98.04663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78605',
  },
  {
    city: 'Blanco',
    county_fips: 48031,
    county_fips_all: '48031|48259|48091',
    county: 'Blanco',
    county_names_all: 'Blanco|Kendall|Comal',
    county_weights: '{"48031": 75.21, "48259": 21.29, "48091": 3.5}',
    density: 11.6,
    imprecise: false,
    latitude: 30.09213,
    longitude: -98.45789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78606',
  },
  {
    city: 'Bluffton',
    county_fips: 48299,
    county_fips_all: '48299',
    county: 'Llano',
    county_names_all: 'Llano',
    county_weights: '{"48299": 100}',
    density: 2,
    imprecise: false,
    latitude: 30.81961,
    longitude: -98.488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78607',
  },
  {
    city: 'Briggs',
    county_fips: 48053,
    county_fips_all: '48053',
    county: 'Burnet',
    county_names_all: 'Burnet',
    county_weights: '{"48053": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 30.9341,
    longitude: -97.93255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78608',
  },
  {
    city: 'Buchanan Dam',
    county_fips: 48299,
    county_fips_all: '48299',
    county: 'Llano',
    county_names_all: 'Llano',
    county_weights: '{"48299": 100}',
    density: 48.2,
    imprecise: false,
    latitude: 30.75975,
    longitude: -98.45271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78609',
  },
  {
    city: 'Buda',
    county_fips: 48209,
    county_fips_all: '48209|48453|48055',
    county: 'Hays',
    county_names_all: 'Hays|Travis|Caldwell',
    county_weights: '{"48209": 71.54, "48453": 26.1, "48055": 2.36}',
    density: 192.6,
    imprecise: false,
    latitude: 30.07962,
    longitude: -97.84047,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78610',
  },
  {
    city: 'Burnet',
    county_fips: 48053,
    county_fips_all: '48053|48299',
    county: 'Burnet',
    county_names_all: 'Burnet|Llano',
    county_weights: '{"48053": 97.94, "48299": 2.06}',
    density: 20.5,
    imprecise: false,
    latitude: 30.79188,
    longitude: -98.26663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78611',
  },
  {
    city: 'Cedar Creek',
    county_fips: 48021,
    county_fips_all: '48021|48453',
    county: 'Bastrop',
    county_names_all: 'Bastrop|Travis',
    county_weights: '{"48021": 98.78, "48453": 1.22}',
    density: 77.2,
    imprecise: false,
    latitude: 30.09301,
    longitude: -97.49017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78612',
  },
  {
    city: 'Cedar Park',
    county_fips: 48491,
    county_fips_all: '48491|48453',
    county: 'Williamson',
    county_names_all: 'Williamson|Travis',
    county_weights: '{"48491": 88.67, "48453": 11.33}',
    density: 1254.2,
    imprecise: false,
    latitude: 30.50683,
    longitude: -97.81939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 89956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78613',
  },
  {
    city: 'Cost',
    county_fips: 48177,
    county_fips_all: '48177',
    county: 'Gonzales',
    county_names_all: 'Gonzales',
    county_weights: '{"48177": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 29.41314,
    longitude: -97.59429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78614',
  },
  {
    city: 'Coupland',
    county_fips: 48491,
    county_fips_all: '48491|48453',
    county: 'Williamson',
    county_names_all: 'Williamson|Travis',
    county_weights: '{"48491": 64.22, "48453": 35.78}',
    density: 11.6,
    imprecise: false,
    latitude: 30.46426,
    longitude: -97.39061,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78615',
  },
  {
    city: 'Dale',
    county_fips: 48055,
    county_fips_all: '48055|48021',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Bastrop',
    county_weights: '{"48055": 82.08, "48021": 17.92}',
    density: 34.9,
    imprecise: false,
    latitude: 29.92687,
    longitude: -97.55655,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78616',
  },
  {
    city: 'Del Valle',
    county_fips: 48453,
    county_fips_all: '48453|48021',
    county: 'Travis',
    county_names_all: 'Travis|Bastrop',
    county_weights: '{"48453": 78.51, "48021": 21.49}',
    density: 185.4,
    imprecise: false,
    latitude: 30.1508,
    longitude: -97.59928,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78617',
  },
  {
    city: 'Doss',
    county_fips: 48171,
    county_fips_all: '48171|48319',
    county: 'Gillespie',
    county_names_all: 'Gillespie|Mason',
    county_weights: '{"48171": 61.84, "48319": 38.16}',
    density: 0.8,
    imprecise: false,
    latitude: 30.48624,
    longitude: -99.16794,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78618',
  },
  {
    city: 'Driftwood',
    county_fips: 48209,
    county_fips_all: '48209',
    county: 'Hays',
    county_names_all: 'Hays',
    county_weights: '{"48209": 100}',
    density: 64.7,
    imprecise: false,
    latitude: 30.11215,
    longitude: -98.03101,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78619',
  },
  {
    city: 'Dripping Springs',
    county_fips: 48209,
    county_fips_all: '48209|48453|48031',
    county: 'Hays',
    county_names_all: 'Hays|Travis|Blanco',
    county_weights: '{"48209": 85.37, "48453": 9.64, "48031": 4.99}',
    density: 50.3,
    imprecise: false,
    latitude: 30.22214,
    longitude: -98.13491,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78620',
  },
  {
    city: 'Elgin',
    county_fips: 48021,
    county_fips_all: '48021|48453|48491|48287',
    county: 'Bastrop',
    county_names_all: 'Bastrop|Travis|Williamson|Lee',
    county_weights:
      '{"48021": 62.58, "48453": 14.51, "48491": 14.33, "48287": 8.58}',
    density: 66.1,
    imprecise: false,
    latitude: 30.33737,
    longitude: -97.36053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78621',
  },
  {
    city: 'Fentress',
    county_fips: 48055,
    county_fips_all: '48055',
    county: 'Caldwell',
    county_names_all: 'Caldwell',
    county_weights: '{"48055": 100}',
    density: 31.5,
    imprecise: false,
    latitude: 29.77225,
    longitude: -97.78229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78622',
  },
  {
    city: 'Fischer',
    county_fips: 48091,
    county_fips_all: '48091|48209',
    county: 'Comal',
    county_names_all: 'Comal|Hays',
    county_weights: '{"48091": 92.25, "48209": 7.75}',
    density: 28.4,
    imprecise: false,
    latitude: 29.95973,
    longitude: -98.21933,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78623',
  },
  {
    city: 'Fredericksburg',
    county_fips: 48171,
    county_fips_all: '48171|48259',
    county: 'Gillespie',
    county_names_all: 'Gillespie|Kendall',
    county_weights: '{"48171": 91.34, "48259": 8.66}',
    density: 12.3,
    imprecise: false,
    latitude: 30.29227,
    longitude: -98.87141,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78624',
  },
  {
    city: 'Georgetown',
    county_fips: 48491,
    county_fips_all: '48491',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"48491": 100}',
    density: 209.5,
    imprecise: false,
    latitude: 30.66664,
    longitude: -97.59878,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 48072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78626',
  },
  {
    city: 'Georgetown',
    county_fips: 48491,
    county_fips_all: '48491',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"48491": 100}',
    density: 303.2,
    imprecise: false,
    latitude: 30.63981,
    longitude: -97.74636,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78628',
  },
  {
    city: 'Gonzales',
    county_fips: 48177,
    county_fips_all: '48177|48123',
    county: 'Gonzales',
    county_names_all: 'Gonzales|DeWitt',
    county_weights: '{"48177": 98.14, "48123": 1.86}',
    density: 11.7,
    imprecise: false,
    latitude: 29.47762,
    longitude: -97.45093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78629',
  },
  {
    city: 'Harper',
    county_fips: 48267,
    county_fips_all: '48267|48171|48265',
    county: 'Kimble',
    county_names_all: 'Kimble|Gillespie|Kerr',
    county_weights: '{"48267": 48.77, "48171": 44.33, "48265": 6.9}',
    density: 4.5,
    imprecise: false,
    latitude: 30.34576,
    longitude: -99.31161,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78631',
  },
  {
    city: 'Harwood',
    county_fips: 48177,
    county_fips_all: '48177|48055',
    county: 'Gonzales',
    county_names_all: 'Gonzales|Caldwell',
    county_weights: '{"48177": 59.01, "48055": 40.99}',
    density: 5.2,
    imprecise: false,
    latitude: 29.68866,
    longitude: -97.46858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78632',
  },
  {
    city: 'Georgetown',
    county_fips: 48491,
    county_fips_all: '48491',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"48491": 100}',
    density: 144.2,
    imprecise: false,
    latitude: 30.73803,
    longitude: -97.75465,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78633',
  },
  {
    city: 'Hutto',
    county_fips: 48491,
    county_fips_all: '48491|48453',
    county: 'Williamson',
    county_names_all: 'Williamson|Travis',
    county_weights: '{"48491": 99.56, "48453": 0.44}',
    density: 317.8,
    imprecise: false,
    latitude: 30.56,
    longitude: -97.54404,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78634',
  },
  {
    city: 'Hye',
    county_fips: 48031,
    county_fips_all: '48031',
    county: 'Blanco',
    county_names_all: 'Blanco',
    county_weights: '{"48031": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 30.20824,
    longitude: -98.5485,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78635',
  },
  {
    city: 'Johnson City',
    county_fips: 48031,
    county_fips_all: '48031',
    county: 'Blanco',
    county_names_all: 'Blanco',
    county_weights: '{"48031": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 30.31649,
    longitude: -98.42376,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78636',
  },
  {
    city: 'Kingsbury',
    county_fips: 48187,
    county_fips_all: '48187|48177',
    county: 'Guadalupe',
    county_names_all: 'Guadalupe|Gonzales',
    county_weights: '{"48187": 98.34, "48177": 1.66}',
    density: 7,
    imprecise: false,
    latitude: 29.65821,
    longitude: -97.79595,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78638',
  },
  {
    city: 'Kingsland',
    county_fips: 48299,
    county_fips_all: '48299|48053',
    county: 'Llano',
    county_names_all: 'Llano|Burnet',
    county_weights: '{"48299": 81.82, "48053": 18.18}',
    density: 76.7,
    imprecise: false,
    latitude: 30.65823,
    longitude: -98.45506,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78639',
  },
  {
    city: 'Kyle',
    county_fips: 48209,
    county_fips_all: '48209|48055|48453',
    county: 'Hays',
    county_names_all: 'Hays|Caldwell|Travis',
    county_weights: '{"48209": 83.6, "48055": 15.0, "48453": 1.4}',
    density: 334.2,
    imprecise: false,
    latitude: 29.99619,
    longitude: -97.82355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 77531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78640',
  },
  {
    city: 'Leander',
    county_fips: 48453,
    county_fips_all: '48453|48491',
    county: 'Travis',
    county_names_all: 'Travis|Williamson',
    county_weights: '{"48453": 63.17, "48491": 36.83}',
    density: 310,
    imprecise: false,
    latitude: 30.55851,
    longitude: -97.91473,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 99865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78641',
  },
  {
    city: 'Liberty Hill',
    county_fips: 48491,
    county_fips_all: '48491|48053',
    county: 'Williamson',
    county_names_all: 'Williamson|Burnet',
    county_weights: '{"48491": 92.0, "48053": 8.0}',
    density: 91.8,
    imprecise: false,
    latitude: 30.6946,
    longitude: -97.94087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78642',
  },
  {
    city: 'Llano',
    county_fips: 48299,
    county_fips_all: '48299',
    county: 'Llano',
    county_names_all: 'Llano',
    county_weights: '{"48299": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 30.68161,
    longitude: -98.71281,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78643',
  },
  {
    city: 'Lockhart',
    county_fips: 48055,
    county_fips_all: '48055',
    county: 'Caldwell',
    county_names_all: 'Caldwell',
    county_weights: '{"48055": 100}',
    density: 48,
    imprecise: false,
    latitude: 29.87111,
    longitude: -97.67292,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78644',
  },
  {
    city: 'Leander',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 181.3,
    imprecise: false,
    latitude: 30.4502,
    longitude: -97.96934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78645',
  },
  {
    city: 'Luling',
    county_fips: 48055,
    county_fips_all: '48055|48187|48177',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Guadalupe|Gonzales',
    county_weights: '{"48055": 75.56, "48187": 15.49, "48177": 8.95}',
    density: 22.8,
    imprecise: false,
    latitude: 29.69594,
    longitude: -97.63827,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78648',
  },
  {
    city: 'McDade',
    county_fips: 48021,
    county_fips_all: '48021|48287',
    county: 'Bastrop',
    county_names_all: 'Bastrop|Lee',
    county_weights: '{"48021": 71.02, "48287": 28.98}',
    density: 14.6,
    imprecise: false,
    latitude: 30.30536,
    longitude: -97.21574,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78650',
  },
  {
    city: 'Manchaca',
    county_fips: 48453,
    county_fips_all: '48453|48209',
    county: 'Travis',
    county_names_all: 'Travis|Hays',
    county_weights: '{"48453": 56.47, "48209": 43.53}',
    density: 182.3,
    imprecise: false,
    latitude: 30.13462,
    longitude: -97.8606,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78652',
  },
  {
    city: 'Manor',
    county_fips: 48453,
    county_fips_all: '48453|48021',
    county: 'Travis',
    county_names_all: 'Travis|Bastrop',
    county_weights: '{"48453": 98.86, "48021": 1.14}',
    density: 151.5,
    imprecise: false,
    latitude: 30.33783,
    longitude: -97.52006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 41291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78653',
  },
  {
    city: 'Marble Falls',
    county_fips: 48053,
    county_fips_all: '48053|48453',
    county: 'Burnet',
    county_names_all: 'Burnet|Travis',
    county_weights: '{"48053": 80.41, "48453": 19.59}',
    density: 39.6,
    imprecise: false,
    latitude: 30.57112,
    longitude: -98.20982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78654',
  },
  {
    city: 'Martindale',
    county_fips: 48055,
    county_fips_all: '48055|48187',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Guadalupe',
    county_weights: '{"48055": 59.94, "48187": 40.06}',
    density: 50.2,
    imprecise: false,
    latitude: 29.82346,
    longitude: -97.83517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78655',
  },
  {
    city: 'Maxwell',
    county_fips: 48055,
    county_fips_all: '48055|48209',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Hays',
    county_weights: '{"48055": 97.04, "48209": 2.96}',
    density: 38.7,
    imprecise: false,
    latitude: 29.90275,
    longitude: -97.8089,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78656',
  },
  {
    city: 'Horseshoe Bay',
    county_fips: 48299,
    county_fips_all: '48299|48053',
    county: 'Llano',
    county_names_all: 'Llano|Burnet',
    county_weights: '{"48299": 69.99, "48053": 30.01}',
    density: 75.6,
    imprecise: false,
    latitude: 30.53328,
    longitude: -98.37906,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78657',
  },
  {
    city: 'Ottine',
    county_fips: 48177,
    county_fips_all: '48177',
    county: 'Gonzales',
    county_names_all: 'Gonzales',
    county_weights: '{"48177": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 29.59339,
    longitude: -97.62661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78658',
  },
  {
    city: 'Paige',
    county_fips: 48021,
    county_fips_all: '48021|48287',
    county: 'Bastrop',
    county_names_all: 'Bastrop|Lee',
    county_weights: '{"48021": 79.12, "48287": 20.88}',
    density: 8.8,
    imprecise: false,
    latitude: 30.20667,
    longitude: -97.12624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78659',
  },
  {
    city: 'Pflugerville',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 1080.5,
    imprecise: false,
    latitude: 30.44361,
    longitude: -97.59558,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 124834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78660',
  },
  {
    city: 'Prairie Lea',
    county_fips: 48055,
    county_fips_all: '48055|48187',
    county: 'Caldwell',
    county_names_all: 'Caldwell|Guadalupe',
    county_weights: '{"48055": 99.54, "48187": 0.46}',
    density: 78.2,
    imprecise: false,
    latitude: 29.72925,
    longitude: -97.74212,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78661',
  },
  {
    city: 'Red Rock',
    county_fips: 48021,
    county_fips_all: '48021|48055',
    county: 'Bastrop',
    county_names_all: 'Bastrop|Caldwell',
    county_weights: '{"48021": 81.26, "48055": 18.74}',
    density: 17.3,
    imprecise: false,
    latitude: 29.94316,
    longitude: -97.44231,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78662',
  },
  {
    city: 'Round Mountain',
    county_fips: 48031,
    county_fips_all: '48031|48453|48209|48053',
    county: 'Blanco',
    county_names_all: 'Blanco|Travis|Hays|Burnet',
    county_weights:
      '{"48031": 93.34, "48453": 3.75, "48209": 1.97, "48053": 0.94}',
    density: 1.8,
    imprecise: false,
    latitude: 30.41582,
    longitude: -98.31144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78663',
  },
  {
    city: 'Round Rock',
    county_fips: 48491,
    county_fips_all: '48491|48453',
    county: 'Williamson',
    county_names_all: 'Williamson|Travis',
    county_weights: '{"48491": 85.62, "48453": 14.38}',
    density: 1442.4,
    imprecise: false,
    latitude: 30.50461,
    longitude: -97.64583,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 62060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78664',
  },
  {
    city: 'Round Rock',
    county_fips: 48491,
    county_fips_all: '48491',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"48491": 100}',
    density: 1061.1,
    imprecise: false,
    latitude: 30.55038,
    longitude: -97.63681,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 66171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78665',
  },
  {
    city: 'San Marcos',
    county_fips: 48209,
    county_fips_all: '48209|48187|48091|48055',
    county: 'Hays',
    county_names_all: 'Hays|Guadalupe|Comal|Caldwell',
    county_weights:
      '{"48209": 77.87, "48187": 15.76, "48091": 4.34, "48055": 2.03}',
    density: 177.8,
    imprecise: false,
    latitude: 29.8826,
    longitude: -97.97974,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 88583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78666',
  },
  {
    city: 'Spicewood',
    county_fips: 48453,
    county_fips_all: '48453|48053|48031',
    county: 'Travis',
    county_names_all: 'Travis|Burnet|Blanco',
    county_weights: '{"48453": 45.91, "48053": 36.18, "48031": 17.92}',
    density: 40.1,
    imprecise: false,
    latitude: 30.4347,
    longitude: -98.13066,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78669',
  },
  {
    city: 'Staples',
    county_fips: 48187,
    county_fips_all: '48187',
    county: 'Guadalupe',
    county_names_all: 'Guadalupe',
    county_weights: '{"48187": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 29.76267,
    longitude: -97.84608,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78670',
  },
  {
    city: 'Stonewall',
    county_fips: 48171,
    county_fips_all: '48171',
    county: 'Gillespie',
    county_names_all: 'Gillespie',
    county_weights: '{"48171": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 30.20409,
    longitude: -98.63275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78671',
  },
  {
    city: 'Tow',
    county_fips: 48299,
    county_fips_all: '48299',
    county: 'Llano',
    county_names_all: 'Llano',
    county_weights: '{"48299": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 30.88151,
    longitude: -98.49128,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78672',
  },
  {
    city: 'Weir',
    county_fips: 48491,
    county_fips_all: '48491',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"48491": 100}',
    density: 116.6,
    imprecise: false,
    latitude: 30.67213,
    longitude: -97.59653,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78674',
  },
  {
    city: 'Willow City',
    county_fips: 48171,
    county_fips_all: '48171',
    county: 'Gillespie',
    county_names_all: 'Gillespie',
    county_weights: '{"48171": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 30.4585,
    longitude: -98.70534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78675',
  },
  {
    city: 'Wimberley',
    county_fips: 48209,
    county_fips_all: '48209|48031|48091',
    county: 'Hays',
    county_names_all: 'Hays|Blanco|Comal',
    county_weights: '{"48209": 92.46, "48031": 6.6, "48091": 0.94}',
    density: 36.4,
    imprecise: false,
    latitude: 30.04141,
    longitude: -98.15051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78676',
  },
  {
    city: 'Wrightsboro',
    county_fips: 48177,
    county_fips_all: '48177',
    county: 'Gonzales',
    county_names_all: 'Gonzales',
    county_weights: '{"48177": 100}',
    density: 1,
    imprecise: false,
    latitude: 29.34174,
    longitude: -97.59335,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78677',
  },
  {
    city: 'Round Rock',
    county_fips: 48491,
    county_fips_all: '48491',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"48491": 100}',
    density: 943.9,
    imprecise: false,
    latitude: 30.5355,
    longitude: -97.71981,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78681',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 3026.8,
    imprecise: false,
    latitude: 30.27022,
    longitude: -97.74248,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11824,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78701',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 2004.2,
    imprecise: false,
    latitude: 30.26339,
    longitude: -97.7144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78702',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 1612.6,
    imprecise: false,
    latitude: 30.29385,
    longitude: -97.76554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78703',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 2233,
    imprecise: false,
    latitude: 30.24298,
    longitude: -97.76537,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78704',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 6199.6,
    imprecise: false,
    latitude: 30.2947,
    longitude: -97.739,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78705',
  },
  {
    city: 'Austin',
    county_fips: 48491,
    county_fips_all: '48491',
    county: 'Williamson',
    county_names_all: 'Williamson',
    county_weights: '{"48491": 100}',
    density: 1102.9,
    imprecise: false,
    latitude: 30.48988,
    longitude: -97.75393,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78717',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 35.1,
    imprecise: false,
    latitude: 30.14465,
    longitude: -97.67148,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78719',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 1190.1,
    imprecise: false,
    latitude: 30.27127,
    longitude: -97.68345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78721',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 1927.7,
    imprecise: false,
    latitude: 30.29005,
    longitude: -97.71458,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78722',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 2085.6,
    imprecise: false,
    latitude: 30.30423,
    longitude: -97.68578,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78723',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 481.5,
    imprecise: false,
    latitude: 30.29474,
    longitude: -97.61439,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78724',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 234.8,
    imprecise: false,
    latitude: 30.23554,
    longitude: -97.60859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78725',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 483.5,
    imprecise: false,
    latitude: 30.42898,
    longitude: -97.84254,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78726',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453|48491',
    county: 'Travis',
    county_names_all: 'Travis|Williamson',
    county_weights: '{"48453": 98.18, "48491": 1.82}',
    density: 1488.9,
    imprecise: false,
    latitude: 30.42894,
    longitude: -97.71736,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78727',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453|48491',
    county: 'Travis',
    county_names_all: 'Travis|Williamson',
    county_weights: '{"48453": 78.14, "48491": 21.86}',
    density: 1334.2,
    imprecise: false,
    latitude: 30.45537,
    longitude: -97.68948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78728',
  },
  {
    city: 'Austin',
    county_fips: 48491,
    county_fips_all: '48491|48453',
    county: 'Williamson',
    county_names_all: 'Williamson|Travis',
    county_weights: '{"48491": 88.33, "48453": 11.67}',
    density: 1198.6,
    imprecise: false,
    latitude: 30.45738,
    longitude: -97.75516,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78729',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 234.3,
    imprecise: false,
    latitude: 30.36322,
    longitude: -97.83847,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78730',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 1214.4,
    imprecise: false,
    latitude: 30.34766,
    longitude: -97.7687,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78731',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 634.2,
    imprecise: false,
    latitude: 30.3802,
    longitude: -97.89291,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78732',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 311.3,
    imprecise: false,
    latitude: 30.32338,
    longitude: -97.87762,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78733',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 451.5,
    imprecise: false,
    latitude: 30.38079,
    longitude: -97.94676,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78734',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 401.5,
    imprecise: false,
    latitude: 30.26634,
    longitude: -97.86775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78735',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453|48209',
    county: 'Travis',
    county_names_all: 'Travis|Hays',
    county_weights: '{"48453": 96.72, "48209": 3.28}',
    density: 167.1,
    imprecise: false,
    latitude: 30.24833,
    longitude: -97.94965,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78736',
  },
  {
    city: 'Austin',
    county_fips: 48209,
    county_fips_all: '48209|48453',
    county: 'Hays',
    county_names_all: 'Hays|Travis',
    county_weights: '{"48209": 71.17, "48453": 28.83}',
    density: 286.4,
    imprecise: false,
    latitude: 30.18935,
    longitude: -97.96059,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78737',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 284.5,
    imprecise: false,
    latitude: 30.30668,
    longitude: -97.99002,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78738',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453|48209',
    county: 'Travis',
    county_names_all: 'Travis|Hays',
    county_weights: '{"48453": 92.27, "48209": 7.73}',
    density: 688.3,
    imprecise: false,
    latitude: 30.17596,
    longitude: -97.89087,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78739',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 2277.8,
    imprecise: false,
    latitude: 30.23007,
    longitude: -97.71389,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78741',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 55.3,
    imprecise: false,
    latitude: 30.24375,
    longitude: -97.65869,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78742',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 870.9,
    imprecise: false,
    latitude: 30.18024,
    longitude: -97.72888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 50986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78744',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 1720.7,
    imprecise: false,
    latitude: 30.20743,
    longitude: -97.79822,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 61219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78745',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 475.9,
    imprecise: false,
    latitude: 30.29759,
    longitude: -97.81136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78746',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 385.3,
    imprecise: false,
    latitude: 30.12521,
    longitude: -97.74117,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78747',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 1519.7,
    imprecise: false,
    latitude: 30.16144,
    longitude: -97.8227,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 55631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78748',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 1378.2,
    imprecise: false,
    latitude: 30.21329,
    longitude: -97.85732,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78749',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453|48491',
    county: 'Travis',
    county_names_all: 'Travis|Williamson',
    county_weights: '{"48453": 78.12, "48491": 21.88}',
    density: 958.1,
    imprecise: false,
    latitude: 30.41685,
    longitude: -97.80223,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78750',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 2711.3,
    imprecise: false,
    latitude: 30.3108,
    longitude: -97.72278,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78751',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 2698,
    imprecise: false,
    latitude: 30.33141,
    longitude: -97.70364,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78752',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 1936.7,
    imprecise: false,
    latitude: 30.38353,
    longitude: -97.67335,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78753',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 833.8,
    imprecise: false,
    latitude: 30.35633,
    longitude: -97.63925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78754',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 2125.7,
    imprecise: false,
    latitude: 30.32219,
    longitude: -97.7402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78756',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 1860.3,
    imprecise: false,
    latitude: 30.35164,
    longitude: -97.73267,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78757',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 2108.3,
    imprecise: false,
    latitude: 30.38768,
    longitude: -97.70665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78758',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453|48491',
    county: 'Travis',
    county_names_all: 'Travis|Williamson',
    county_weights: '{"48453": 98.83, "48491": 1.17}',
    density: 1170,
    imprecise: false,
    latitude: 30.4027,
    longitude: -97.76093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78759',
  },
  {
    city: 'Uvalde',
    county_fips: 48463,
    county_fips_all: '48463|48385',
    county: 'Uvalde',
    county_names_all: 'Uvalde|Real',
    county_weights: '{"48463": 97.61, "48385": 2.39}',
    density: 9.8,
    imprecise: false,
    latitude: 29.36407,
    longitude: -99.88476,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 21607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78801',
  },
  {
    city: 'Uvalde',
    county_fips: 48463,
    county_fips_all: '48463',
    county: 'Uvalde',
    county_names_all: 'Uvalde',
    county_weights: '{"48463": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.14481,
    longitude: -99.91983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78802',
  },
  {
    city: 'Asherton',
    county_fips: 48127,
    county_fips_all: '48127',
    county: 'Dimmit',
    county_names_all: 'Dimmit',
    county_weights: '{"48127": 100}',
    density: 4,
    imprecise: false,
    latitude: 28.42865,
    longitude: -99.72393,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78827',
  },
  {
    city: 'Barksdale',
    county_fips: 48385,
    county_fips_all: '48385|48137',
    county: 'Real',
    county_names_all: 'Real|Edwards',
    county_weights: '{"48385": 65.14, "48137": 34.86}',
    density: 0,
    imprecise: false,
    latitude: 29.84372,
    longitude: -99.99375,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78828',
  },
  {
    city: 'Batesville',
    county_fips: 48507,
    county_fips_all: '48507',
    county: 'Zavala',
    county_names_all: 'Zavala',
    county_weights: '{"48507": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 28.89351,
    longitude: -99.57401,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78829',
  },
  {
    city: 'Big Wells',
    county_fips: 48127,
    county_fips_all: '48127',
    county: 'Dimmit',
    county_names_all: 'Dimmit',
    county_weights: '{"48127": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 28.53226,
    longitude: -99.48219,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78830',
  },
  {
    city: 'Brackettville',
    county_fips: 48271,
    county_fips_all: '48271',
    county: 'Kinney',
    county_names_all: 'Kinney',
    county_weights: '{"48271": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 29.39512,
    longitude: -100.4069,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78832',
  },
  {
    city: 'Camp Wood',
    county_fips: 48385,
    county_fips_all: '48385|48137|48463',
    county: 'Real',
    county_names_all: 'Real|Edwards|Uvalde',
    county_weights: '{"48385": 75.99, "48137": 23.87, "48463": 0.14}',
    density: 3.4,
    imprecise: false,
    latitude: 29.69785,
    longitude: -99.97248,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78833',
  },
  {
    city: 'Carrizo Springs',
    county_fips: 48127,
    county_fips_all: '48127|48507',
    county: 'Dimmit',
    county_names_all: 'Dimmit|Zavala',
    county_weights: '{"48127": 89.11, "48507": 10.89}',
    density: 5.3,
    imprecise: false,
    latitude: 28.54776,
    longitude: -99.87286,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78834',
  },
  {
    city: 'Comstock',
    county_fips: 48465,
    county_fips_all: '48465',
    county: 'Val Verde',
    county_names_all: 'Val Verde',
    county_weights: '{"48465": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 29.92708,
    longitude: -101.28057,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78837',
  },
  {
    city: 'Concan',
    county_fips: 48463,
    county_fips_all: '48463',
    county: 'Uvalde',
    county_names_all: 'Uvalde',
    county_weights: '{"48463": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 29.53476,
    longitude: -99.70757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78838',
  },
  {
    city: 'Crystal City',
    county_fips: 48507,
    county_fips_all: '48507|48127',
    county: 'Zavala',
    county_names_all: 'Zavala|Dimmit',
    county_weights: '{"48507": 97.91, "48127": 2.09}',
    density: 11.2,
    imprecise: false,
    latitude: 28.71282,
    longitude: -99.75516,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78839',
  },
  {
    city: 'Del Rio',
    county_fips: 48465,
    county_fips_all: '48465',
    county: 'Val Verde',
    county_names_all: 'Val Verde',
    county_weights: '{"48465": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 29.74499,
    longitude: -100.92362,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 47256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78840',
  },
  {
    city: 'Del Rio',
    county_fips: 48465,
    county_fips_all: '48465',
    county: 'Val Verde',
    county_names_all: 'Val Verde',
    county_weights: '{"48465": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.8459,
    longitude: -101.4653,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78841',
  },
  {
    city: 'Del Rio',
    county_fips: 48465,
    county_fips_all: '48465',
    county: 'Val Verde',
    county_names_all: 'Val Verde',
    county_weights: '{"48465": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.63677,
    longitude: -101.01044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78842',
  },
  {
    city: 'D Hanis',
    county_fips: 48325,
    county_fips_all: '48325',
    county: 'Medina',
    county_names_all: 'Medina',
    county_weights: '{"48325": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 29.27937,
    longitude: -99.33581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78850',
  },
  {
    city: 'Dryden',
    county_fips: 48443,
    county_fips_all: '48443',
    county: 'Terrell',
    county_names_all: 'Terrell',
    county_weights: '{"48443": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.22441,
    longitude: -101.91733,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78851',
  },
  {
    city: 'Eagle Pass',
    county_fips: 48323,
    county_fips_all: '48323',
    county: 'Maverick',
    county_names_all: 'Maverick',
    county_weights: '{"48323": 100}',
    density: 45.9,
    imprecise: false,
    latitude: 28.82698,
    longitude: -100.31543,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 57434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78852',
  },
  {
    city: 'El Indio',
    county_fips: 48323,
    county_fips_all: '48323',
    county: 'Maverick',
    county_names_all: 'Maverick',
    county_weights: '{"48323": 100}',
    density: 0,
    imprecise: false,
    latitude: 28.38168,
    longitude: -100.22962,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78860',
  },
  {
    city: 'Hondo',
    county_fips: 48325,
    county_fips_all: '48325',
    county: 'Medina',
    county_names_all: 'Medina',
    county_weights: '{"48325": 100}',
    density: 11,
    imprecise: false,
    latitude: 29.41778,
    longitude: -99.15663,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78861',
  },
  {
    city: 'Knippa',
    county_fips: 48463,
    county_fips_all: '48463',
    county: 'Uvalde',
    county_names_all: 'Uvalde',
    county_weights: '{"48463": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 29.29829,
    longitude: -99.61255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78870',
  },
  {
    city: 'Langtry',
    county_fips: 48465,
    county_fips_all: '48465',
    county: 'Val Verde',
    county_names_all: 'Val Verde',
    county_weights: '{"48465": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 29.90185,
    longitude: -101.62018,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78871',
  },
  {
    city: 'La Pryor',
    county_fips: 48507,
    county_fips_all: '48507',
    county: 'Zavala',
    county_names_all: 'Zavala',
    county_weights: '{"48507": 100}',
    density: 3,
    imprecise: false,
    latitude: 28.90751,
    longitude: -99.88039,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78872',
  },
  {
    city: 'Leakey',
    county_fips: 48385,
    county_fips_all: '48385',
    county: 'Real',
    county_names_all: 'Real',
    county_weights: '{"48385": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 29.80966,
    longitude: -99.73953,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78873',
  },
  {
    city: 'Quemado',
    county_fips: 48323,
    county_fips_all: '48323',
    county: 'Maverick',
    county_names_all: 'Maverick',
    county_weights: '{"48323": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 28.9533,
    longitude: -100.60429,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78877',
  },
  {
    city: 'Rio Frio',
    county_fips: 48385,
    county_fips_all: '48385|48463',
    county: 'Real',
    county_names_all: 'Real|Uvalde',
    county_weights: '{"48385": 76.73, "48463": 23.27}',
    density: 3.2,
    imprecise: false,
    latitude: 29.6435,
    longitude: -99.71733,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78879',
  },
  {
    city: 'Rocksprings',
    county_fips: 48137,
    county_fips_all: '48137|48385',
    county: 'Edwards',
    county_names_all: 'Edwards|Real',
    county_weights: '{"48137": 97.17, "48385": 2.83}',
    density: 0.2,
    imprecise: false,
    latitude: 29.96486,
    longitude: -100.27779,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78880',
  },
  {
    city: 'Sabinal',
    county_fips: 48463,
    county_fips_all: '48463',
    county: 'Uvalde',
    county_names_all: 'Uvalde',
    county_weights: '{"48463": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 29.39333,
    longitude: -99.50972,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78881',
  },
  {
    city: 'Tarpley',
    county_fips: 48019,
    county_fips_all: '48019',
    county: 'Bandera',
    county_names_all: 'Bandera',
    county_weights: '{"48019": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 29.67707,
    longitude: -99.31851,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78883',
  },
  {
    city: 'Utopia',
    county_fips: 48019,
    county_fips_all: '48019|48463|48325',
    county: 'Bandera',
    county_names_all: 'Bandera|Uvalde|Medina',
    county_weights: '{"48019": 52.68, "48463": 37.04, "48325": 10.28}',
    density: 2.3,
    imprecise: false,
    latitude: 29.63823,
    longitude: -99.49308,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78884',
  },
  {
    city: 'Vanderpool',
    county_fips: 48019,
    county_fips_all: '48019',
    county: 'Bandera',
    county_names_all: 'Bandera',
    county_weights: '{"48019": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 29.82682,
    longitude: -99.54502,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78885',
  },
  {
    city: 'Yancey',
    county_fips: 48325,
    county_fips_all: '48325',
    county: 'Medina',
    county_names_all: 'Medina',
    county_weights: '{"48325": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 29.15453,
    longitude: -99.18749,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78886',
  },
  {
    city: 'Bleiblerville',
    county_fips: 48015,
    county_fips_all: '48015',
    county: 'Austin',
    county_names_all: 'Austin',
    county_weights: '{"48015": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 30.03117,
    longitude: -96.44291,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78931',
  },
  {
    city: 'Carmine',
    county_fips: 48477,
    county_fips_all: '48477|48149',
    county: 'Washington',
    county_names_all: 'Washington|Fayette',
    county_weights: '{"48477": 58.64, "48149": 41.36}',
    density: 3.9,
    imprecise: false,
    latitude: 30.1656,
    longitude: -96.70793,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78932',
  },
  {
    city: 'Cat Spring',
    county_fips: 48089,
    county_fips_all: '48089|48015',
    county: 'Colorado',
    county_names_all: 'Colorado|Austin',
    county_weights: '{"48089": 69.32, "48015": 30.68}',
    density: 4.1,
    imprecise: false,
    latitude: 29.77209,
    longitude: -96.33829,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78933',
  },
  {
    city: 'Columbus',
    county_fips: 48089,
    county_fips_all: '48089',
    county: 'Colorado',
    county_names_all: 'Colorado',
    county_weights: '{"48089": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 29.7023,
    longitude: -96.56741,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78934',
  },
  {
    city: 'Alleyton',
    county_fips: 48089,
    county_fips_all: '48089',
    county: 'Colorado',
    county_names_all: 'Colorado',
    county_weights: '{"48089": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 29.68797,
    longitude: -96.43006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 734,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78935',
  },
  {
    city: 'Ellinger',
    county_fips: 48149,
    county_fips_all: '48149',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"48149": 100}',
    density: 13.3,
    imprecise: false,
    latitude: 29.82757,
    longitude: -96.7041,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78938',
  },
  {
    city: 'Fayetteville',
    county_fips: 48149,
    county_fips_all: '48149|48089|48015',
    county: 'Fayette',
    county_names_all: 'Fayette|Colorado|Austin',
    county_weights: '{"48149": 76.23, "48089": 16.04, "48015": 7.73}',
    density: 6.5,
    imprecise: false,
    latitude: 29.93139,
    longitude: -96.66701,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78940',
  },
  {
    city: 'Flatonia',
    county_fips: 48149,
    county_fips_all: '48149|48177|48021|48285',
    county: 'Fayette',
    county_names_all: 'Fayette|Gonzales|Bastrop|Lavaca',
    county_weights:
      '{"48149": 80.77, "48177": 12.85, "48021": 5.9, "48285": 0.48}',
    density: 8.6,
    imprecise: false,
    latitude: 29.74201,
    longitude: -97.1561,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78941',
  },
  {
    city: 'Giddings',
    county_fips: 48287,
    county_fips_all: '48287|48149|48021',
    county: 'Lee',
    county_names_all: 'Lee|Fayette|Bastrop',
    county_weights: '{"48287": 87.18, "48149": 7.76, "48021": 5.06}',
    density: 19.3,
    imprecise: false,
    latitude: 30.16803,
    longitude: -96.93153,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78942',
  },
  {
    city: 'Glidden',
    county_fips: 48089,
    county_fips_all: '48089',
    county: 'Colorado',
    county_names_all: 'Colorado',
    county_weights: '{"48089": 100}',
    density: 487.8,
    imprecise: false,
    latitude: 29.69721,
    longitude: -96.59538,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78943',
  },
  {
    city: 'Industry',
    county_fips: 48015,
    county_fips_all: '48015',
    county: 'Austin',
    county_names_all: 'Austin',
    county_weights: '{"48015": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 30.00401,
    longitude: -96.48945,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78944',
  },
  {
    city: 'La Grange',
    county_fips: 48149,
    county_fips_all: '48149|48021|48287',
    county: 'Fayette',
    county_names_all: 'Fayette|Bastrop|Lee',
    county_weights: '{"48149": 99.14, "48021": 0.74, "48287": 0.12}',
    density: 16.2,
    imprecise: false,
    latitude: 29.91594,
    longitude: -96.89031,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78945',
  },
  {
    city: 'Ledbetter',
    county_fips: 48287,
    county_fips_all: '48287|48149|48477',
    county: 'Lee',
    county_names_all: 'Lee|Fayette|Washington',
    county_weights: '{"48287": 61.91, "48149": 33.78, "48477": 4.31}',
    density: 4.1,
    imprecise: false,
    latitude: 30.18947,
    longitude: -96.77412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78946',
  },
  {
    city: 'Lexington',
    county_fips: 48287,
    county_fips_all: '48287',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"48287": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 30.42378,
    longitude: -97.04183,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78947',
  },
  {
    city: 'Lincoln',
    county_fips: 48287,
    county_fips_all: '48287',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"48287": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 30.30748,
    longitude: -96.97022,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78948',
  },
  {
    city: 'Muldoon',
    county_fips: 48149,
    county_fips_all: '48149',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"48149": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 29.83681,
    longitude: -97.08062,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78949',
  },
  {
    city: 'New Ulm',
    county_fips: 48015,
    county_fips_all: '48015|48089|48149',
    county: 'Austin',
    county_names_all: 'Austin|Colorado|Fayette',
    county_weights: '{"48015": 69.2, "48089": 28.26, "48149": 2.54}',
    density: 7.7,
    imprecise: false,
    latitude: 29.90735,
    longitude: -96.48518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78950',
  },
  {
    city: 'Oakland',
    county_fips: 48089,
    county_fips_all: '48089|48285',
    county: 'Colorado',
    county_names_all: 'Colorado|Lavaca',
    county_weights: '{"48089": 99.89, "48285": 0.11}',
    density: 0,
    imprecise: false,
    latitude: 29.61361,
    longitude: -96.83746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78951',
  },
  {
    city: 'Rosanky',
    county_fips: 48021,
    county_fips_all: '48021|48055',
    county: 'Bastrop',
    county_names_all: 'Bastrop|Caldwell',
    county_weights: '{"48021": 65.24, "48055": 34.76}',
    density: 3.7,
    imprecise: false,
    latitude: 29.85552,
    longitude: -97.35214,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78953',
  },
  {
    city: 'Round Top',
    county_fips: 48149,
    county_fips_all: '48149|48015',
    county: 'Fayette',
    county_names_all: 'Fayette|Austin',
    county_weights: '{"48149": 91.76, "48015": 8.24}',
    density: 6.2,
    imprecise: false,
    latitude: 30.04507,
    longitude: -96.69774,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78954',
  },
  {
    city: 'Schulenburg',
    county_fips: 48149,
    county_fips_all: '48149|48285',
    county: 'Fayette',
    county_names_all: 'Fayette|Lavaca',
    county_weights: '{"48149": 75.02, "48285": 24.98}',
    density: 12,
    imprecise: false,
    latitude: 29.68322,
    longitude: -96.93454,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78956',
  },
  {
    city: 'Smithville',
    county_fips: 48021,
    county_fips_all: '48021|48149',
    county: 'Bastrop',
    county_names_all: 'Bastrop|Fayette',
    county_weights: '{"48021": 88.84, "48149": 11.16}',
    density: 23,
    imprecise: false,
    latitude: 30.01279,
    longitude: -97.17481,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78957',
  },
  {
    city: 'Waelder',
    county_fips: 48177,
    county_fips_all: '48177|48149|48055|48021',
    county: 'Gonzales',
    county_names_all: 'Gonzales|Fayette|Caldwell|Bastrop',
    county_weights:
      '{"48177": 79.82, "48149": 16.44, "48055": 2.66, "48021": 1.08}',
    density: 3.1,
    imprecise: false,
    latitude: 29.69877,
    longitude: -97.30153,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78959',
  },
  {
    city: 'Weimar',
    county_fips: 48089,
    county_fips_all: '48089|48149',
    county: 'Colorado',
    county_names_all: 'Colorado|Fayette',
    county_weights: '{"48089": 84.64, "48149": 15.36}',
    density: 11.7,
    imprecise: false,
    latitude: 29.66951,
    longitude: -96.73815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78962',
  },
  {
    city: 'West Point',
    county_fips: 48149,
    county_fips_all: '48149',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"48149": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 29.92586,
    longitude: -97.02767,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78963',
  },
  {
    city: 'Adrian',
    county_fips: 48359,
    county_fips_all: '48359|48117',
    county: 'Oldham',
    county_names_all: 'Oldham|Deaf Smith',
    county_weights: '{"48359": 65.32, "48117": 34.68}',
    density: 0.1,
    imprecise: false,
    latitude: 35.2824,
    longitude: -102.8023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79001',
  },
  {
    city: 'Alanreed',
    county_fips: 48179,
    county_fips_all: '48179|48129',
    county: 'Gray',
    county_names_all: 'Gray|Donley',
    county_weights: '{"48179": 99.88, "48129": 0.12}',
    density: 0.9,
    imprecise: false,
    latitude: 35.19819,
    longitude: -100.76956,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79002',
  },
  {
    city: 'Allison',
    county_fips: 48211,
    county_fips_all: '48211|48483',
    county: 'Hemphill',
    county_names_all: 'Hemphill|Wheeler',
    county_weights: '{"48211": 74.6, "48483": 25.4}',
    density: 1.4,
    imprecise: false,
    latitude: 35.63873,
    longitude: -100.0881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79003',
  },
  {
    city: 'Booker',
    county_fips: 48295,
    county_fips_all: '48295|48357',
    county: 'Lipscomb',
    county_names_all: 'Lipscomb|Ochiltree',
    county_weights: '{"48295": 73.95, "48357": 26.05}',
    density: 2.9,
    imprecise: false,
    latitude: 36.3874,
    longitude: -100.50627,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79005',
  },
  {
    city: 'Borger',
    county_fips: 48233,
    county_fips_all: '48233',
    county: 'Hutchinson',
    county_names_all: 'Hutchinson',
    county_weights: '{"48233": 100}',
    density: 120.7,
    imprecise: false,
    latitude: 35.66635,
    longitude: -101.41444,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79007',
  },
  {
    city: 'Borger',
    county_fips: 48233,
    county_fips_all: '48233',
    county: 'Hutchinson',
    county_names_all: 'Hutchinson',
    county_weights: '{"48233": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.69845,
    longitude: -101.42383,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79008',
  },
  {
    city: 'Bovina',
    county_fips: 48369,
    county_fips_all: '48369',
    county: 'Parmer',
    county_names_all: 'Parmer',
    county_weights: '{"48369": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 34.53016,
    longitude: -102.88533,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79009',
  },
  {
    city: 'Boys Ranch',
    county_fips: 48375,
    county_fips_all: '48375|48359',
    county: 'Potter',
    county_names_all: 'Potter|Oldham',
    county_weights: '{"48375": 71.3, "48359": 28.7}',
    density: 1.6,
    imprecise: false,
    latitude: 35.45283,
    longitude: -102.12013,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79010',
  },
  {
    city: 'Briscoe',
    county_fips: 48483,
    county_fips_all: '48483|48211',
    county: 'Wheeler',
    county_names_all: 'Wheeler|Hemphill',
    county_weights: '{"48483": 50.53, "48211": 49.47}',
    density: 0.5,
    imprecise: false,
    latitude: 35.63111,
    longitude: -100.20866,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79011',
  },
  {
    city: 'Bushland',
    county_fips: 48381,
    county_fips_all: '48381',
    county: 'Randall',
    county_names_all: 'Randall',
    county_weights: '{"48381": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.11701,
    longitude: -102.1072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79012',
  },
  {
    city: 'Cactus',
    county_fips: 48341,
    county_fips_all: '48341',
    county: 'Moore',
    county_names_all: 'Moore',
    county_weights: '{"48341": 100}',
    density: 250.5,
    imprecise: false,
    latitude: 36.04183,
    longitude: -101.99335,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79013',
  },
  {
    city: 'Canadian',
    county_fips: 48211,
    county_fips_all: '48211|48295|48393',
    county: 'Hemphill',
    county_names_all: 'Hemphill|Lipscomb|Roberts',
    county_weights: '{"48211": 78.21, "48295": 18.73, "48393": 3.06}',
    density: 1.4,
    imprecise: false,
    latitude: 35.91912,
    longitude: -100.32123,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79014',
  },
  {
    city: 'Canyon',
    county_fips: 48381,
    county_fips_all: '48381',
    county: 'Randall',
    county_names_all: 'Randall',
    county_weights: '{"48381": 100}',
    density: 27.9,
    imprecise: false,
    latitude: 34.95259,
    longitude: -101.89925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79015',
  },
  {
    city: 'Channing',
    county_fips: 48205,
    county_fips_all: '48205|48341|48359',
    county: 'Hartley',
    county_names_all: 'Hartley|Moore|Oldham',
    county_weights: '{"48205": 65.32, "48341": 19.07, "48359": 15.61}',
    density: 0.3,
    imprecise: false,
    latitude: 35.69322,
    longitude: -102.33767,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79018',
  },
  {
    city: 'Claude',
    county_fips: 48011,
    county_fips_all: '48011|48381',
    county: 'Armstrong',
    county_names_all: 'Armstrong|Randall',
    county_weights: '{"48011": 97.05, "48381": 2.95}',
    density: 1.1,
    imprecise: false,
    latitude: 34.98099,
    longitude: -101.39288,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79019',
  },
  {
    city: 'Cotton Center',
    county_fips: 48189,
    county_fips_all: '48189',
    county: 'Hale',
    county_names_all: 'Hale',
    county_weights: '{"48189": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 33.98366,
    longitude: -101.99302,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79021',
  },
  {
    city: 'Dalhart',
    county_fips: 48111,
    county_fips_all: '48111|48205',
    county: 'Dallam',
    county_names_all: 'Dallam|Hartley',
    county_weights: '{"48111": 57.8, "48205": 42.2}',
    density: 2.1,
    imprecise: false,
    latitude: 36.10004,
    longitude: -102.61443,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79022',
  },
  {
    city: 'Darrouzett',
    county_fips: 48295,
    county_fips_all: '48295',
    county: 'Lipscomb',
    county_names_all: 'Lipscomb',
    county_weights: '{"48295": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 36.43877,
    longitude: -100.35188,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79024',
  },
  {
    city: 'Dawn',
    county_fips: 48117,
    county_fips_all: '48117|48381',
    county: 'Deaf Smith',
    county_names_all: 'Deaf Smith|Randall',
    county_weights: '{"48117": 99.29, "48381": 0.71}',
    density: 0,
    imprecise: false,
    latitude: 34.94943,
    longitude: -102.20117,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79025',
  },
  {
    city: 'Dimmitt',
    county_fips: 48069,
    county_fips_all: '48069|48279',
    county: 'Castro',
    county_names_all: 'Castro|Lamb',
    county_weights: '{"48069": 99.26, "48279": 0.74}',
    density: 5.4,
    imprecise: false,
    latitude: 34.49238,
    longitude: -102.3378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79027',
  },
  {
    city: 'Dumas',
    county_fips: 48341,
    county_fips_all: '48341|48205',
    county: 'Moore',
    county_names_all: 'Moore|Hartley',
    county_weights: '{"48341": 97.73, "48205": 2.27}',
    density: 19.6,
    imprecise: false,
    latitude: 35.89513,
    longitude: -102.02756,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79029',
  },
  {
    city: 'Earth',
    county_fips: 48279,
    county_fips_all: '48279|48069',
    county: 'Lamb',
    county_names_all: 'Lamb|Castro',
    county_weights: '{"48279": 93.16, "48069": 6.84}',
    density: 4.3,
    imprecise: false,
    latitude: 34.24501,
    longitude: -102.45225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79031',
  },
  {
    city: 'Edmonson',
    county_fips: 48189,
    county_fips_all: '48189',
    county: 'Hale',
    county_names_all: 'Hale',
    county_weights: '{"48189": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 34.2878,
    longitude: -101.89492,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79032',
  },
  {
    city: 'Farnsworth',
    county_fips: 48357,
    county_fips_all: '48357',
    county: 'Ochiltree',
    county_names_all: 'Ochiltree',
    county_weights: '{"48357": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 36.30684,
    longitude: -100.97661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79033',
  },
  {
    city: 'Follett',
    county_fips: 48295,
    county_fips_all: '48295',
    county: 'Lipscomb',
    county_names_all: 'Lipscomb',
    county_weights: '{"48295": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 36.37524,
    longitude: -100.16581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79034',
  },
  {
    city: 'Friona',
    county_fips: 48369,
    county_fips_all: '48369|48117',
    county: 'Parmer',
    county_names_all: 'Parmer|Deaf Smith',
    county_weights: '{"48369": 69.92, "48117": 30.08}',
    density: 3.1,
    imprecise: false,
    latitude: 34.68301,
    longitude: -102.78573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79035',
  },
  {
    city: 'Fritch',
    county_fips: 48065,
    county_fips_all: '48065|48233|48375|48341',
    county: 'Carson',
    county_names_all: 'Carson|Hutchinson|Potter|Moore',
    county_weights:
      '{"48065": 64.26, "48233": 28.01, "48375": 4.49, "48341": 3.24}',
    density: 24.3,
    imprecise: false,
    latitude: 35.59727,
    longitude: -101.54826,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79036',
  },
  {
    city: 'Groom',
    county_fips: 48065,
    county_fips_all: '48065|48179|48011|48129',
    county: 'Carson',
    county_names_all: 'Carson|Gray|Armstrong|Donley',
    county_weights:
      '{"48065": 52.36, "48179": 35.2, "48011": 7.36, "48129": 5.08}',
    density: 1.3,
    imprecise: false,
    latitude: 35.25237,
    longitude: -101.12206,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79039',
  },
  {
    city: 'Gruver',
    county_fips: 48195,
    county_fips_all: '48195|48421',
    county: 'Hansford',
    county_names_all: 'Hansford|Sherman',
    county_weights: '{"48195": 62.99, "48421": 37.01}',
    density: 1.3,
    imprecise: false,
    latitude: 36.30113,
    longitude: -101.57841,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79040',
  },
  {
    city: 'Hale Center',
    county_fips: 48189,
    county_fips_all: '48189|48279',
    county: 'Hale',
    county_names_all: 'Hale|Lamb',
    county_weights: '{"48189": 96.14, "48279": 3.86}',
    density: 3.9,
    imprecise: false,
    latitude: 34.0376,
    longitude: -101.93466,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79041',
  },
  {
    city: 'Happy',
    county_fips: 48381,
    county_fips_all: '48381|48069|48437|48011',
    county: 'Randall',
    county_names_all: 'Randall|Castro|Swisher|Armstrong',
    county_weights:
      '{"48381": 47.79, "48069": 23.39, "48437": 22.14, "48011": 6.68}',
    density: 1.1,
    imprecise: false,
    latitude: 34.74802,
    longitude: -101.89449,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79042',
  },
  {
    city: 'Hart',
    county_fips: 48069,
    county_fips_all: '48069|48279|48189',
    county: 'Castro',
    county_names_all: 'Castro|Lamb|Hale',
    county_weights: '{"48069": 81.84, "48279": 12.66, "48189": 5.5}',
    density: 3.4,
    imprecise: false,
    latitude: 34.36761,
    longitude: -102.1374,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79043',
  },
  {
    city: 'Hartley',
    county_fips: 48205,
    county_fips_all: '48205',
    county: 'Hartley',
    county_names_all: 'Hartley',
    county_weights: '{"48205": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 35.87456,
    longitude: -102.37903,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79044',
  },
  {
    city: 'Hereford',
    county_fips: 48117,
    county_fips_all: '48117|48069',
    county: 'Deaf Smith',
    county_names_all: 'Deaf Smith|Castro',
    county_weights: '{"48117": 83.75, "48069": 16.25}',
    density: 6.2,
    imprecise: false,
    latitude: 34.89831,
    longitude: -102.51228,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79045',
  },
  {
    city: 'Higgins',
    county_fips: 48295,
    county_fips_all: '48295|48211',
    county: 'Lipscomb',
    county_names_all: 'Lipscomb|Hemphill',
    county_weights: '{"48295": 87.17, "48211": 12.83}',
    density: 1.1,
    imprecise: false,
    latitude: 36.14237,
    longitude: -100.10709,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79046',
  },
  {
    city: 'Kress',
    county_fips: 48437,
    county_fips_all: '48437|48189|48069',
    county: 'Swisher',
    county_names_all: 'Swisher|Hale|Castro',
    county_weights: '{"48437": 88.03, "48189": 8.97, "48069": 3.0}',
    density: 1.8,
    imprecise: false,
    latitude: 34.35869,
    longitude: -101.76276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79052',
  },
  {
    city: 'Lazbuddie',
    county_fips: 48369,
    county_fips_all: '48369',
    county: 'Parmer',
    county_names_all: 'Parmer',
    county_weights: '{"48369": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 34.40284,
    longitude: -102.59106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79053',
  },
  {
    city: 'Lefors',
    county_fips: 48179,
    county_fips_all: '48179',
    county: 'Gray',
    county_names_all: 'Gray',
    county_weights: '{"48179": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 35.42894,
    longitude: -100.78086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79054',
  },
  {
    city: 'Lipscomb',
    county_fips: 48295,
    county_fips_all: '48295',
    county: 'Lipscomb',
    county_names_all: 'Lipscomb',
    county_weights: '{"48295": 100}',
    density: 1,
    imprecise: false,
    latitude: 36.21724,
    longitude: -100.22139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79056',
  },
  {
    city: 'Mclean',
    county_fips: 48179,
    county_fips_all: '48179|48129|48483|48087',
    county: 'Gray',
    county_names_all: 'Gray|Donley|Wheeler|Collingsworth',
    county_weights:
      '{"48179": 44.27, "48129": 35.62, "48483": 13.86, "48087": 6.25}',
    density: 1,
    imprecise: false,
    latitude: 35.20638,
    longitude: -100.62157,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79057',
  },
  {
    city: 'Masterson',
    county_fips: 48375,
    county_fips_all: '48375|48341',
    county: 'Potter',
    county_names_all: 'Potter|Moore',
    county_weights: '{"48375": 69.18, "48341": 30.82}',
    density: 0,
    imprecise: false,
    latitude: 35.59509,
    longitude: -101.94925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79058',
  },
  {
    city: 'Miami',
    county_fips: 48393,
    county_fips_all: '48393|48179',
    county: 'Roberts',
    county_names_all: 'Roberts|Gray',
    county_weights: '{"48393": 89.06, "48179": 10.94}',
    density: 0.6,
    imprecise: false,
    latitude: 35.79825,
    longitude: -100.73531,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79059',
  },
  {
    city: 'Mobeetie',
    county_fips: 48483,
    county_fips_all: '48483|48179',
    county: 'Wheeler',
    county_names_all: 'Wheeler|Gray',
    county_weights: '{"48483": 90.95, "48179": 9.05}',
    density: 0.7,
    imprecise: false,
    latitude: 35.51987,
    longitude: -100.45706,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79061',
  },
  {
    city: 'Morse',
    county_fips: 48233,
    county_fips_all: '48233|48195',
    county: 'Hutchinson',
    county_names_all: 'Hutchinson|Hansford',
    county_weights: '{"48233": 82.66, "48195": 17.34}',
    density: 1.7,
    imprecise: false,
    latitude: 35.99616,
    longitude: -101.52733,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79062',
  },
  {
    city: 'Nazareth',
    county_fips: 48069,
    county_fips_all: '48069',
    county: 'Castro',
    county_names_all: 'Castro',
    county_weights: '{"48069": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 34.51063,
    longitude: -102.115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79063',
  },
  {
    city: 'Olton',
    county_fips: 48279,
    county_fips_all: '48279|48189',
    county: 'Lamb',
    county_names_all: 'Lamb|Hale',
    county_weights: '{"48279": 73.57, "48189": 26.43}',
    density: 5.6,
    imprecise: false,
    latitude: 34.17738,
    longitude: -102.12699,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79064',
  },
  {
    city: 'Pampa',
    county_fips: 48179,
    county_fips_all: '48179|48393',
    county: 'Gray',
    county_names_all: 'Gray|Roberts',
    county_weights: '{"48179": 77.71, "48393": 22.29}',
    density: 14.8,
    imprecise: false,
    latitude: 35.52363,
    longitude: -100.90378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79065',
  },
  {
    city: 'Pampa',
    county_fips: 48179,
    county_fips_all: '48179',
    county: 'Gray',
    county_names_all: 'Gray',
    county_weights: '{"48179": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 35.49929,
    longitude: -101.03423,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79066',
  },
  {
    city: 'Panhandle',
    county_fips: 48065,
    county_fips_all: '48065|48375',
    county: 'Carson',
    county_names_all: 'Carson|Potter',
    county_weights: '{"48065": 99.09, "48375": 0.91}',
    density: 2.7,
    imprecise: false,
    latitude: 35.33633,
    longitude: -101.45226,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79068',
  },
  {
    city: 'Perryton',
    county_fips: 48357,
    county_fips_all: '48357|48393|48295',
    county: 'Ochiltree',
    county_names_all: 'Ochiltree|Roberts|Lipscomb',
    county_weights: '{"48357": 90.18, "48393": 8.51, "48295": 1.31}',
    density: 4.3,
    imprecise: false,
    latitude: 36.25346,
    longitude: -100.80731,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79070',
  },
  {
    city: 'Plainview',
    county_fips: 48189,
    county_fips_all: '48189',
    county: 'Hale',
    county_names_all: 'Hale',
    county_weights: '{"48189": 100}',
    density: 24.8,
    imprecise: false,
    latitude: 34.1719,
    longitude: -101.745,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79072',
  },
  {
    city: 'Plainview',
    county_fips: 48189,
    county_fips_all: '48189',
    county: 'Hale',
    county_names_all: 'Hale',
    county_weights: '{"48189": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.95608,
    longitude: -101.94924,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79073',
  },
  {
    city: 'Sanford',
    county_fips: 48233,
    county_fips_all: '48233',
    county: 'Hutchinson',
    county_names_all: 'Hutchinson',
    county_weights: '{"48233": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 35.69856,
    longitude: -101.55,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79078',
  },
  {
    city: 'Shamrock',
    county_fips: 48483,
    county_fips_all: '48483|48087',
    county: 'Wheeler',
    county_names_all: 'Wheeler|Collingsworth',
    county_weights: '{"48483": 58.78, "48087": 41.22}',
    density: 1.4,
    imprecise: false,
    latitude: 35.20719,
    longitude: -100.24884,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79079',
  },
  {
    city: 'Skellytown',
    county_fips: 48233,
    county_fips_all: '48233|48065',
    county: 'Hutchinson',
    county_names_all: 'Hutchinson|Carson',
    county_weights: '{"48233": 86.06, "48065": 13.94}',
    density: 1.1,
    imprecise: false,
    latitude: 35.70341,
    longitude: -101.21116,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79080',
  },
  {
    city: 'Spearman',
    county_fips: 48195,
    county_fips_all: '48195|48233|48357|48393',
    county: 'Hansford',
    county_names_all: 'Hansford|Hutchinson|Ochiltree|Roberts',
    county_weights:
      '{"48195": 75.03, "48233": 11.97, "48357": 8.58, "48393": 4.42}',
    density: 1.6,
    imprecise: false,
    latitude: 36.21559,
    longitude: -101.21054,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79081',
  },
  {
    city: 'Springlake',
    county_fips: 48279,
    county_fips_all: '48279',
    county: 'Lamb',
    county_names_all: 'Lamb',
    county_weights: '{"48279": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 34.21881,
    longitude: -102.2862,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79082',
  },
  {
    city: 'Stinnett',
    county_fips: 48233,
    county_fips_all: '48233|48341',
    county: 'Hutchinson',
    county_names_all: 'Hutchinson|Moore',
    county_weights: '{"48233": 71.62, "48341": 28.38}',
    density: 1.9,
    imprecise: false,
    latitude: 35.87359,
    longitude: -101.51422,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79083',
  },
  {
    city: 'Stratford',
    county_fips: 48421,
    county_fips_all: '48421|48111',
    county: 'Sherman',
    county_names_all: 'Sherman|Dallam',
    county_weights: '{"48421": 97.29, "48111": 2.71}',
    density: 1.4,
    imprecise: false,
    latitude: 36.25502,
    longitude: -102.01825,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79084',
  },
  {
    city: 'Summerfield',
    county_fips: 48069,
    county_fips_all: '48069',
    county: 'Castro',
    county_names_all: 'Castro',
    county_weights: '{"48069": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.73977,
    longitude: -102.50956,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79085',
  },
  {
    city: 'Sunray',
    county_fips: 48421,
    county_fips_all: '48421|48341',
    county: 'Sherman',
    county_names_all: 'Sherman|Moore',
    county_weights: '{"48421": 58.58, "48341": 41.42}',
    density: 3.9,
    imprecise: false,
    latitude: 36.13538,
    longitude: -101.79255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79086',
  },
  {
    city: 'Texline',
    county_fips: 48111,
    county_fips_all: '48111',
    county: 'Dallam',
    county_names_all: 'Dallam',
    county_weights: '{"48111": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 36.32788,
    longitude: -102.93667,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79087',
  },
  {
    city: 'Tulia',
    county_fips: 48437,
    county_fips_all: '48437|48045|48069',
    county: 'Swisher',
    county_names_all: 'Swisher|Briscoe|Castro',
    county_weights: '{"48437": 85.53, "48045": 12.82, "48069": 1.65}',
    density: 3.4,
    imprecise: false,
    latitude: 34.57463,
    longitude: -101.69315,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79088',
  },
  {
    city: 'Umbarger',
    county_fips: 48381,
    county_fips_all: '48381',
    county: 'Randall',
    county_names_all: 'Randall',
    county_weights: '{"48381": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.87053,
    longitude: -102.11431,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79091',
  },
  {
    city: 'Vega',
    county_fips: 48359,
    county_fips_all: '48359|48117',
    county: 'Oldham',
    county_names_all: 'Oldham|Deaf Smith',
    county_weights: '{"48359": 83.95, "48117": 16.05}',
    density: 1.6,
    imprecise: false,
    latitude: 35.28133,
    longitude: -102.48784,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79092',
  },
  {
    city: 'Waka',
    county_fips: 48357,
    county_fips_all: '48357',
    county: 'Ochiltree',
    county_names_all: 'Ochiltree',
    county_weights: '{"48357": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 36.26637,
    longitude: -101.02997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79093',
  },
  {
    city: 'Wayside',
    county_fips: 48011,
    county_fips_all: '48011',
    county: 'Armstrong',
    county_names_all: 'Armstrong',
    county_weights: '{"48011": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.84546,
    longitude: -101.52493,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79094',
  },
  {
    city: 'Wellington',
    county_fips: 48087,
    county_fips_all: '48087|48075',
    county: 'Collingsworth',
    county_names_all: 'Collingsworth|Childress',
    county_weights: '{"48087": 96.54, "48075": 3.46}',
    density: 2.3,
    imprecise: false,
    latitude: 34.88485,
    longitude: -100.19561,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79095',
  },
  {
    city: 'Wheeler',
    county_fips: 48483,
    county_fips_all: '48483',
    county: 'Wheeler',
    county_names_all: 'Wheeler',
    county_weights: '{"48483": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 35.45133,
    longitude: -100.1984,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79096',
  },
  {
    city: 'White Deer',
    county_fips: 48065,
    county_fips_all: '48065|48179',
    county: 'Carson',
    county_names_all: 'Carson|Gray',
    county_weights: '{"48065": 94.85, "48179": 5.15}',
    density: 4,
    imprecise: false,
    latitude: 35.43104,
    longitude: -101.17405,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79097',
  },
  {
    city: 'Wildorado',
    county_fips: 48117,
    county_fips_all: '48117|48359|48381|48375',
    county: 'Deaf Smith',
    county_names_all: 'Deaf Smith|Oldham|Randall|Potter',
    county_weights:
      '{"48117": 46.37, "48359": 36.42, "48381": 15.02, "48375": 2.2}',
    density: 1.2,
    imprecise: false,
    latitude: 35.15671,
    longitude: -102.21646,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79098',
  },
  {
    city: 'Amarillo',
    county_fips: 48375,
    county_fips_all: '48375',
    county: 'Potter',
    county_names_all: 'Potter',
    county_weights: '{"48375": 100}',
    density: 610.5,
    imprecise: false,
    latitude: 35.20605,
    longitude: -101.83946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79101',
  },
  {
    city: 'Amarillo',
    county_fips: 48375,
    county_fips_all: '48375',
    county: 'Potter',
    county_names_all: 'Potter',
    county_weights: '{"48375": 100}',
    density: 1330.9,
    imprecise: false,
    latitude: 35.19948,
    longitude: -101.84661,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79102',
  },
  {
    city: 'Amarillo',
    county_fips: 48375,
    county_fips_all: '48375|48381',
    county: 'Potter',
    county_names_all: 'Potter|Randall',
    county_weights: '{"48375": 50.04, "48381": 49.96}',
    density: 1021.4,
    imprecise: false,
    latitude: 35.18297,
    longitude: -101.7999,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79103',
  },
  {
    city: 'Amarillo',
    county_fips: 48375,
    county_fips_all: '48375',
    county: 'Potter',
    county_names_all: 'Potter',
    county_weights: '{"48375": 100}',
    density: 834.4,
    imprecise: false,
    latitude: 35.2011,
    longitude: -101.79017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79104',
  },
  {
    city: 'Amarillo',
    county_fips: 48375,
    county_fips_all: '48375|48381',
    county: 'Potter',
    county_names_all: 'Potter|Randall',
    county_weights: '{"48375": 90.3, "48381": 9.7}',
    density: 1175.9,
    imprecise: false,
    latitude: 35.20369,
    longitude: -101.89178,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79106',
  },
  {
    city: 'Amarillo',
    county_fips: 48375,
    county_fips_all: '48375',
    county: 'Potter',
    county_names_all: 'Potter',
    county_weights: '{"48375": 100}',
    density: 721.2,
    imprecise: false,
    latitude: 35.23119,
    longitude: -101.7946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79107',
  },
  {
    city: 'Amarillo',
    county_fips: 48375,
    county_fips_all: '48375|48065',
    county: 'Potter',
    county_names_all: 'Potter|Carson',
    county_weights: '{"48375": 98.75, "48065": 1.25}',
    density: 23.6,
    imprecise: false,
    latitude: 35.37511,
    longitude: -101.80307,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79108',
  },
  {
    city: 'Amarillo',
    county_fips: 48381,
    county_fips_all: '48381|48375',
    county: 'Randall',
    county_names_all: 'Randall|Potter',
    county_weights: '{"48381": 79.05, "48375": 20.95}',
    density: 1631.7,
    imprecise: false,
    latitude: 35.1665,
    longitude: -101.88633,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79109',
  },
  {
    city: 'Amarillo',
    county_fips: 48381,
    county_fips_all: '48381',
    county: 'Randall',
    county_names_all: 'Randall',
    county_weights: '{"48381": 100}',
    density: 1206.7,
    imprecise: false,
    latitude: 35.14946,
    longitude: -101.87109,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79110',
  },
  {
    city: 'Amarillo',
    county_fips: 48375,
    county_fips_all: '48375',
    county: 'Potter',
    county_names_all: 'Potter',
    county_weights: '{"48375": 100}',
    density: 54.3,
    imprecise: false,
    latitude: 35.21934,
    longitude: -101.68957,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79111',
  },
  {
    city: 'Amarillo',
    county_fips: 48381,
    county_fips_all: '48381|48375|48011',
    county: 'Randall',
    county_names_all: 'Randall|Potter|Armstrong',
    county_weights: '{"48381": 92.95, "48375": 6.58, "48011": 0.47}',
    density: 68.1,
    imprecise: false,
    latitude: 35.10103,
    longitude: -101.74863,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79118',
  },
  {
    city: 'Amarillo',
    county_fips: 48381,
    county_fips_all: '48381',
    county: 'Randall',
    county_names_all: 'Randall',
    county_weights: '{"48381": 100}',
    density: 96.7,
    imprecise: false,
    latitude: 35.10876,
    longitude: -102.01968,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79119',
  },
  {
    city: 'Amarillo',
    county_fips: 48381,
    county_fips_all: '48381|48375',
    county: 'Randall',
    county_names_all: 'Randall|Potter',
    county_weights: '{"48381": 83.9, "48375": 16.1}',
    density: 1417.8,
    imprecise: false,
    latitude: 35.17447,
    longitude: -101.92922,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79121',
  },
  {
    city: 'Amarillo',
    county_fips: 48375,
    county_fips_all: '48375|48381',
    county: 'Potter',
    county_names_all: 'Potter|Randall',
    county_weights: '{"48375": 97.44, "48381": 2.56}',
    density: 25.6,
    imprecise: false,
    latitude: 35.26891,
    longitude: -102.02705,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79124',
  },
  {
    city: 'Childress',
    county_fips: 48075,
    county_fips_all: '48075|48101|48191|48345',
    county: 'Childress',
    county_names_all: 'Childress|Cottle|Hall|Motley',
    county_weights:
      '{"48075": 54.66, "48101": 18.38, "48191": 16.4, "48345": 10.56}',
    density: 3,
    imprecise: false,
    latitude: 34.4101,
    longitude: -100.33521,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79201',
  },
  {
    city: 'Afton',
    county_fips: 48125,
    county_fips_all: '48125',
    county: 'Dickens',
    county_names_all: 'Dickens',
    county_weights: '{"48125": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 33.7658,
    longitude: -100.76614,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79220',
  },
  {
    city: 'Chillicothe',
    county_fips: 48197,
    county_fips_all: '48197|48487',
    county: 'Hardeman',
    county_names_all: 'Hardeman|Wilbarger',
    county_weights: '{"48197": 77.02, "48487": 22.98}',
    density: 1.7,
    imprecise: false,
    latitude: 34.25058,
    longitude: -99.50831,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79225',
  },
  {
    city: 'Clarendon',
    county_fips: 48129,
    county_fips_all: '48129|48011|48045|48191',
    county: 'Donley',
    county_names_all: 'Donley|Armstrong|Briscoe|Hall',
    county_weights:
      '{"48129": 60.37, "48011": 23.91, "48045": 13.71, "48191": 2.01}',
    density: 1.4,
    imprecise: false,
    latitude: 34.91965,
    longitude: -100.99229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79226',
  },
  {
    city: 'Crowell',
    county_fips: 48155,
    county_fips_all: '48155|48275',
    county: 'Foard',
    county_names_all: 'Foard|Knox',
    county_weights: '{"48155": 66.14, "48275": 33.86}',
    density: 0.5,
    imprecise: false,
    latitude: 33.87702,
    longitude: -99.74893,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79227',
  },
  {
    city: 'Dickens',
    county_fips: 48125,
    county_fips_all: '48125',
    county: 'Dickens',
    county_names_all: 'Dickens',
    county_weights: '{"48125": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 33.67379,
    longitude: -100.744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79229',
  },
  {
    city: 'Dodson',
    county_fips: 48075,
    county_fips_all: '48075|48087',
    county: 'Childress',
    county_names_all: 'Childress|Collingsworth',
    county_weights: '{"48075": 66.8, "48087": 33.2}',
    density: 0.2,
    imprecise: false,
    latitude: 34.71353,
    longitude: -100.04878,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79230',
  },
  {
    city: 'Dougherty',
    county_fips: 48153,
    county_fips_all: '48153',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"48153": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 33.94164,
    longitude: -101.06579,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79231',
  },
  {
    city: 'Estelline',
    county_fips: 48191,
    county_fips_all: '48191',
    county: 'Hall',
    county_names_all: 'Hall',
    county_weights: '{"48191": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 34.50195,
    longitude: -100.49165,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 90,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79233',
  },
  {
    city: 'Flomot',
    county_fips: 48345,
    county_fips_all: '48345|48153',
    county: 'Motley',
    county_names_all: 'Motley|Floyd',
    county_weights: '{"48345": 81.52, "48153": 18.48}',
    density: 0.2,
    imprecise: false,
    latitude: 34.22108,
    longitude: -100.95509,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 85,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79234',
  },
  {
    city: 'Floydada',
    county_fips: 48153,
    county_fips_all: '48153|48107|48345',
    county: 'Floyd',
    county_names_all: 'Floyd|Crosby|Motley',
    county_weights: '{"48153": 88.1, "48107": 8.4, "48345": 3.5}',
    density: 2.3,
    imprecise: false,
    latitude: 33.94794,
    longitude: -101.26088,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79235',
  },
  {
    city: 'Guthrie',
    county_fips: 48269,
    county_fips_all: '48269|48125',
    county: 'King',
    county_names_all: 'King|Dickens',
    county_weights: '{"48269": 99.78, "48125": 0.22}',
    density: 0.3,
    imprecise: false,
    latitude: 33.5992,
    longitude: -100.28095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79236',
  },
  {
    city: 'Hedley',
    county_fips: 48129,
    county_fips_all: '48129',
    county: 'Donley',
    county_names_all: 'Donley',
    county_weights: '{"48129": 100}',
    density: 1,
    imprecise: false,
    latitude: 34.85566,
    longitude: -100.66588,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79237',
  },
  {
    city: 'Lakeview',
    county_fips: 48191,
    county_fips_all: '48191',
    county: 'Hall',
    county_names_all: 'Hall',
    county_weights: '{"48191": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 34.64837,
    longitude: -100.77015,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79239',
  },
  {
    city: 'Lelia Lake',
    county_fips: 48129,
    county_fips_all: '48129',
    county: 'Donley',
    county_names_all: 'Donley',
    county_weights: '{"48129": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 34.8836,
    longitude: -100.76797,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79240',
  },
  {
    city: 'Lockney',
    county_fips: 48153,
    county_fips_all: '48153|48437',
    county: 'Floyd',
    county_names_all: 'Floyd|Swisher',
    county_weights: '{"48153": 99.3, "48437": 0.7}',
    density: 2.3,
    imprecise: false,
    latitude: 34.18069,
    longitude: -101.38507,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79241',
  },
  {
    city: 'Mcadoo',
    county_fips: 48125,
    county_fips_all: '48125|48107',
    county: 'Dickens',
    county_names_all: 'Dickens|Crosby',
    county_weights: '{"48125": 65.64, "48107": 34.36}',
    density: 0.2,
    imprecise: false,
    latitude: 33.76426,
    longitude: -101.02557,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79243',
  },
  {
    city: 'Matador',
    county_fips: 48345,
    county_fips_all: '48345',
    county: 'Motley',
    county_names_all: 'Motley',
    county_weights: '{"48345": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 34.0383,
    longitude: -100.8059,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79244',
  },
  {
    city: 'Memphis',
    county_fips: 48191,
    county_fips_all: '48191|48075|48087|48129',
    county: 'Hall',
    county_names_all: 'Hall|Childress|Collingsworth|Donley',
    county_weights:
      '{"48191": 50.42, "48075": 32.79, "48087": 12.59, "48129": 4.2}',
    density: 3,
    imprecise: false,
    latitude: 34.68001,
    longitude: -100.47552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79245',
  },
  {
    city: 'Odell',
    county_fips: 48487,
    county_fips_all: '48487',
    county: 'Wilbarger',
    county_names_all: 'Wilbarger',
    county_weights: '{"48487": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 34.39704,
    longitude: -99.3807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79247',
  },
  {
    city: 'Paducah',
    county_fips: 48101,
    county_fips_all: '48101|48269|48155|48125',
    county: 'Cottle',
    county_names_all: 'Cottle|King|Foard|Dickens',
    county_weights:
      '{"48101": 65.42, "48269": 21.16, "48155": 10.7, "48125": 2.72}',
    density: 0.6,
    imprecise: false,
    latitude: 33.94146,
    longitude: -100.22159,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79248',
  },
  {
    city: 'Petersburg',
    county_fips: 48189,
    county_fips_all: '48189|48153|48303|48107',
    county: 'Hale',
    county_names_all: 'Hale|Floyd|Lubbock|Crosby',
    county_weights:
      '{"48189": 58.05, "48153": 19.0, "48303": 11.59, "48107": 11.36}',
    density: 2.3,
    imprecise: false,
    latitude: 33.88134,
    longitude: -101.59881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79250',
  },
  {
    city: 'Quail',
    county_fips: 48087,
    county_fips_all: '48087',
    county: 'Collingsworth',
    county_names_all: 'Collingsworth',
    county_weights: '{"48087": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 34.96174,
    longitude: -100.45441,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79251',
  },
  {
    city: 'Quanah',
    county_fips: 48197,
    county_fips_all: '48197|48101',
    county: 'Hardeman',
    county_names_all: 'Hardeman|Cottle',
    county_weights: '{"48197": 96.77, "48101": 3.23}',
    density: 2,
    imprecise: false,
    latitude: 34.31001,
    longitude: -99.80874,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79252',
  },
  {
    city: 'Quitaque',
    county_fips: 48045,
    county_fips_all: '48045|48153|48345',
    county: 'Briscoe',
    county_names_all: 'Briscoe|Floyd|Motley',
    county_weights: '{"48045": 72.06, "48153": 22.54, "48345": 5.4}',
    density: 0.9,
    imprecise: false,
    latitude: 34.36113,
    longitude: -101.04924,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79255',
  },
  {
    city: 'Roaring Springs',
    county_fips: 48345,
    county_fips_all: '48345|48125',
    county: 'Motley',
    county_names_all: 'Motley|Dickens',
    county_weights: '{"48345": 83.91, "48125": 16.09}',
    density: 0.5,
    imprecise: false,
    latitude: 33.87463,
    longitude: -100.82078,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79256',
  },
  {
    city: 'Silverton',
    county_fips: 48045,
    county_fips_all: '48045|48437',
    county: 'Briscoe',
    county_names_all: 'Briscoe|Swisher',
    county_weights: '{"48045": 97.38, "48437": 2.62}',
    density: 0.9,
    imprecise: false,
    latitude: 34.44868,
    longitude: -101.2995,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79257',
  },
  {
    city: 'South Plains',
    county_fips: 48153,
    county_fips_all: '48153',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"48153": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 34.24344,
    longitude: -101.29647,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79258',
  },
  {
    city: 'Tell',
    county_fips: 48191,
    county_fips_all: '48191|48075',
    county: 'Hall',
    county_names_all: 'Hall|Childress',
    county_weights: '{"48191": 77.41, "48075": 22.59}',
    density: 0.2,
    imprecise: false,
    latitude: 34.36243,
    longitude: -100.45594,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79259',
  },
  {
    city: 'Turkey',
    county_fips: 48191,
    county_fips_all: '48191',
    county: 'Hall',
    county_names_all: 'Hall',
    county_weights: '{"48191": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 34.45525,
    longitude: -100.86876,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79261',
  },
  {
    city: 'Abernathy',
    county_fips: 48189,
    county_fips_all: '48189|48303',
    county: 'Hale',
    county_names_all: 'Hale|Lubbock',
    county_weights: '{"48189": 73.94, "48303": 26.06}',
    density: 7.1,
    imprecise: false,
    latitude: 33.85781,
    longitude: -101.88228,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79311',
  },
  {
    city: 'Amherst',
    county_fips: 48279,
    county_fips_all: '48279',
    county: 'Lamb',
    county_names_all: 'Lamb',
    county_weights: '{"48279": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 34.06218,
    longitude: -102.36794,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79312',
  },
  {
    city: 'Anton',
    county_fips: 48219,
    county_fips_all: '48219|48279|48303',
    county: 'Hockley',
    county_names_all: 'Hockley|Lamb|Lubbock',
    county_weights: '{"48219": 56.24, "48279": 42.88, "48303": 0.88}',
    density: 4,
    imprecise: false,
    latitude: 33.8126,
    longitude: -102.16093,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79313',
  },
  {
    city: 'Bledsoe',
    county_fips: 48079,
    county_fips_all: '48079',
    county: 'Cochran',
    county_names_all: 'Cochran',
    county_weights: '{"48079": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 33.63016,
    longitude: -103.03051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79314',
  },
  {
    city: 'Brownfield',
    county_fips: 48445,
    county_fips_all: '48445',
    county: 'Terry',
    county_names_all: 'Terry',
    county_weights: '{"48445": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 33.13478,
    longitude: -102.3058,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79316',
  },
  {
    city: 'Crosbyton',
    county_fips: 48107,
    county_fips_all: '48107',
    county: 'Crosby',
    county_names_all: 'Crosby',
    county_weights: '{"48107": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 33.65887,
    longitude: -101.19814,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79322',
  },
  {
    city: 'Denver City',
    county_fips: 48165,
    county_fips_all: '48165|48501',
    county: 'Gaines',
    county_names_all: 'Gaines|Yoakum',
    county_weights: '{"48165": 57.86, "48501": 42.14}',
    density: 15.1,
    imprecise: false,
    latitude: 32.94678,
    longitude: -102.89674,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79323',
  },
  {
    city: 'Enochs',
    county_fips: 48017,
    county_fips_all: '48017|48279',
    county: 'Bailey',
    county_names_all: 'Bailey|Lamb',
    county_weights: '{"48017": 99.43, "48279": 0.57}',
    density: 0.6,
    imprecise: false,
    latitude: 33.88759,
    longitude: -102.73534,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79324',
  },
  {
    city: 'Farwell',
    county_fips: 48369,
    county_fips_all: '48369|48017',
    county: 'Parmer',
    county_names_all: 'Parmer|Bailey',
    county_weights: '{"48369": 95.58, "48017": 4.42}',
    density: 4.9,
    imprecise: false,
    latitude: 34.40798,
    longitude: -102.93821,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79325',
  },
  {
    city: 'Fieldton',
    county_fips: 48279,
    county_fips_all: '48279',
    county: 'Lamb',
    county_names_all: 'Lamb',
    county_weights: '{"48279": 100}',
    density: 1,
    imprecise: false,
    latitude: 34.09913,
    longitude: -102.21433,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79326',
  },
  {
    city: 'Idalou',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 33.72503,
    longitude: -101.68807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79329',
  },
  {
    city: 'Justiceburg',
    county_fips: 48169,
    county_fips_all: '48169',
    county: 'Garza',
    county_names_all: 'Garza',
    county_weights: '{"48169": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 33.03072,
    longitude: -101.21727,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79330',
  },
  {
    city: 'Lamesa',
    county_fips: 48115,
    county_fips_all: '48115|48317|48033|48165',
    county: 'Dawson',
    county_names_all: 'Dawson|Martin|Borden|Gaines',
    county_weights:
      '{"48115": 77.58, "48317": 15.32, "48033": 4.1, "48165": 3.0}',
    density: 5.7,
    imprecise: false,
    latitude: 32.66775,
    longitude: -101.97488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79331',
  },
  {
    city: 'Levelland',
    county_fips: 48219,
    county_fips_all: '48219|48079',
    county: 'Hockley',
    county_names_all: 'Hockley|Cochran',
    county_weights: '{"48219": 97.56, "48079": 2.44}',
    density: 12.1,
    imprecise: false,
    latitude: 33.59962,
    longitude: -102.40214,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79336',
  },
  {
    city: 'Littlefield',
    county_fips: 48279,
    county_fips_all: '48279|48219',
    county: 'Lamb',
    county_names_all: 'Lamb|Hockley',
    county_weights: '{"48279": 71.02, "48219": 28.98}',
    density: 7.7,
    imprecise: false,
    latitude: 33.87938,
    longitude: -102.34682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79339',
  },
  {
    city: 'Loop',
    county_fips: 48165,
    county_fips_all: '48165',
    county: 'Gaines',
    county_names_all: 'Gaines',
    county_weights: '{"48165": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 32.90313,
    longitude: -102.33188,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79342',
  },
  {
    city: 'Lorenzo',
    county_fips: 48107,
    county_fips_all: '48107|48303',
    county: 'Crosby',
    county_names_all: 'Crosby|Lubbock',
    county_weights: '{"48107": 63.82, "48303": 36.18}',
    density: 3.7,
    imprecise: false,
    latitude: 33.65096,
    longitude: -101.54459,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79343',
  },
  {
    city: 'Maple',
    county_fips: 48017,
    county_fips_all: '48017',
    county: 'Bailey',
    county_names_all: 'Bailey',
    county_weights: '{"48017": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.85677,
    longitude: -103.0143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79344',
  },
  {
    city: 'Meadow',
    county_fips: 48445,
    county_fips_all: '48445|48305',
    county: 'Terry',
    county_names_all: 'Terry|Lynn',
    county_weights: '{"48445": 94.32, "48305": 5.68}',
    density: 1.9,
    imprecise: false,
    latitude: 33.33611,
    longitude: -102.32789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79345',
  },
  {
    city: 'Morton',
    county_fips: 48079,
    county_fips_all: '48079|48017',
    county: 'Cochran',
    county_names_all: 'Cochran|Bailey',
    county_weights: '{"48079": 93.59, "48017": 6.41}',
    density: 1.4,
    imprecise: false,
    latitude: 33.64805,
    longitude: -102.82309,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79346',
  },
  {
    city: 'Muleshoe',
    county_fips: 48017,
    county_fips_all: '48017|48369|48279|48069',
    county: 'Bailey',
    county_names_all: 'Bailey|Parmer|Lamb|Castro',
    county_weights:
      '{"48017": 77.81, "48369": 15.27, "48279": 4.11, "48069": 2.81}',
    density: 4.1,
    imprecise: false,
    latitude: 34.18804,
    longitude: -102.79682,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79347',
  },
  {
    city: 'New Deal',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 47.6,
    imprecise: false,
    latitude: 33.73115,
    longitude: -101.82296,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79350',
  },
  {
    city: 'Odonnell',
    county_fips: 48115,
    county_fips_all: '48115|48305|48033',
    county: 'Dawson',
    county_names_all: 'Dawson|Lynn|Borden',
    county_weights: '{"48115": 37.04, "48305": 31.89, "48033": 31.07}',
    density: 1.4,
    imprecise: false,
    latitude: 32.93191,
    longitude: -101.78581,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79351',
  },
  {
    city: 'Pep',
    county_fips: 48219,
    county_fips_all: '48219',
    county: 'Hockley',
    county_names_all: 'Hockley',
    county_weights: '{"48219": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 33.78723,
    longitude: -102.58723,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 67,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79353',
  },
  {
    city: 'Plains',
    county_fips: 48501,
    county_fips_all: '48501',
    county: 'Yoakum',
    county_names_all: 'Yoakum',
    county_weights: '{"48501": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 33.16605,
    longitude: -102.89485,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79355',
  },
  {
    city: 'Post',
    county_fips: 48169,
    county_fips_all: '48169|48107|48305',
    county: 'Garza',
    county_names_all: 'Garza|Crosby|Lynn',
    county_weights: '{"48169": 75.82, "48107": 15.42, "48305": 8.76}',
    density: 2.4,
    imprecise: false,
    latitude: 33.2562,
    longitude: -101.33245,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79356',
  },
  {
    city: 'Ralls',
    county_fips: 48107,
    county_fips_all: '48107',
    county: 'Crosby',
    county_names_all: 'Crosby',
    county_weights: '{"48107": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 33.64659,
    longitude: -101.40577,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79357',
  },
  {
    city: 'Ropesville',
    county_fips: 48219,
    county_fips_all: '48219|48303|48445',
    county: 'Hockley',
    county_names_all: 'Hockley|Lubbock|Terry',
    county_weights: '{"48219": 86.46, "48303": 8.49, "48445": 5.05}',
    density: 5,
    imprecise: false,
    latitude: 33.4321,
    longitude: -102.20017,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79358',
  },
  {
    city: 'Seagraves',
    county_fips: 48165,
    county_fips_all: '48165|48501|48445',
    county: 'Gaines',
    county_names_all: 'Gaines|Yoakum|Terry',
    county_weights: '{"48165": 60.91, "48501": 25.33, "48445": 13.76}',
    density: 3.7,
    imprecise: false,
    latitude: 32.92872,
    longitude: -102.54718,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79359',
  },
  {
    city: 'Seminole',
    county_fips: 48165,
    county_fips_all: '48165',
    county: 'Gaines',
    county_names_all: 'Gaines',
    county_weights: '{"48165": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 32.69018,
    longitude: -102.72482,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17342,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79360',
  },
  {
    city: 'Shallowater',
    county_fips: 48303,
    county_fips_all: '48303|48219',
    county: 'Lubbock',
    county_names_all: 'Lubbock|Hockley',
    county_weights: '{"48303": 83.82, "48219": 16.18}',
    density: 20.4,
    imprecise: false,
    latitude: 33.70769,
    longitude: -102.03804,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79363',
  },
  {
    city: 'Slaton',
    county_fips: 48303,
    county_fips_all: '48303|48305|48169|48107',
    county: 'Lubbock',
    county_names_all: 'Lubbock|Lynn|Garza|Crosby',
    county_weights:
      '{"48303": 68.79, "48305": 16.99, "48169": 8.91, "48107": 5.31}',
    density: 13.1,
    imprecise: false,
    latitude: 33.44681,
    longitude: -101.6355,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79364',
  },
  {
    city: 'Ransom Canyon',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 495.1,
    imprecise: false,
    latitude: 33.53016,
    longitude: -101.68367,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79366',
  },
  {
    city: 'Smyer',
    county_fips: 48219,
    county_fips_all: '48219',
    county: 'Hockley',
    county_names_all: 'Hockley',
    county_weights: '{"48219": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 33.58938,
    longitude: -102.16805,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79367',
  },
  {
    city: 'Spade',
    county_fips: 48279,
    county_fips_all: '48279',
    county: 'Lamb',
    county_names_all: 'Lamb',
    county_weights: '{"48279": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 33.94322,
    longitude: -102.15916,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 43,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79369',
  },
  {
    city: 'Spur',
    county_fips: 48125,
    county_fips_all: '48125|48263|48107|48169',
    county: 'Dickens',
    county_names_all: 'Dickens|Kent|Crosby|Garza',
    county_weights:
      '{"48125": 61.94, "48263": 19.36, "48107": 14.16, "48169": 4.54}',
    density: 1,
    imprecise: false,
    latitude: 33.4638,
    longitude: -100.92328,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79370',
  },
  {
    city: 'Sudan',
    county_fips: 48017,
    county_fips_all: '48017|48279',
    county: 'Bailey',
    county_names_all: 'Bailey|Lamb',
    county_weights: '{"48017": 57.82, "48279": 42.18}',
    density: 1.6,
    imprecise: false,
    latitude: 33.97942,
    longitude: -102.69414,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79371',
  },
  {
    city: 'Sundown',
    county_fips: 48219,
    county_fips_all: '48219',
    county: 'Hockley',
    county_names_all: 'Hockley',
    county_weights: '{"48219": 100}',
    density: 33.6,
    imprecise: false,
    latitude: 33.42482,
    longitude: -102.50108,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79372',
  },
  {
    city: 'Tahoka',
    county_fips: 48305,
    county_fips_all: '48305',
    county: 'Lynn',
    county_names_all: 'Lynn',
    county_weights: '{"48305": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 33.15905,
    longitude: -101.83628,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79373',
  },
  {
    city: 'Tokio',
    county_fips: 48501,
    county_fips_all: '48501|48445',
    county: 'Yoakum',
    county_names_all: 'Yoakum|Terry',
    county_weights: '{"48501": 74.56, "48445": 25.44}',
    density: 0,
    imprecise: false,
    latitude: 33.25506,
    longitude: -102.64143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79376',
  },
  {
    city: 'Welch',
    county_fips: 48115,
    county_fips_all: '48115',
    county: 'Dawson',
    county_names_all: 'Dawson',
    county_weights: '{"48115": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 32.9309,
    longitude: -102.13653,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79377',
  },
  {
    city: 'Wellman',
    county_fips: 48445,
    county_fips_all: '48445',
    county: 'Terry',
    county_names_all: 'Terry',
    county_weights: '{"48445": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 33.03075,
    longitude: -102.44482,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79378',
  },
  {
    city: 'Whiteface',
    county_fips: 48079,
    county_fips_all: '48079',
    county: 'Cochran',
    county_names_all: 'Cochran',
    county_weights: '{"48079": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 33.49523,
    longitude: -102.65345,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79379',
  },
  {
    city: 'Whitharral',
    county_fips: 48219,
    county_fips_all: '48219',
    county: 'Hockley',
    county_names_all: 'Hockley',
    county_weights: '{"48219": 100}',
    density: 34.1,
    imprecise: false,
    latitude: 33.73913,
    longitude: -102.32784,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 98,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79380',
  },
  {
    city: 'Wilson',
    county_fips: 48305,
    county_fips_all: '48305',
    county: 'Lynn',
    county_names_all: 'Lynn',
    county_weights: '{"48305": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 33.32312,
    longitude: -101.76982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79381',
  },
  {
    city: 'Wolfforth',
    county_fips: 48303,
    county_fips_all: '48303|48219',
    county: 'Lubbock',
    county_names_all: 'Lubbock|Hockley',
    county_weights: '{"48303": 94.39, "48219": 5.61}',
    density: 79.4,
    imprecise: false,
    latitude: 33.46578,
    longitude: -102.02282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79382',
  },
  {
    city: 'New Home',
    county_fips: 48305,
    county_fips_all: '48305',
    county: 'Lynn',
    county_names_all: 'Lynn',
    county_weights: '{"48305": 100}',
    density: 48.9,
    imprecise: false,
    latitude: 33.32429,
    longitude: -101.90801,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79383',
  },
  {
    city: 'Lubbock',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 1340.7,
    imprecise: false,
    latitude: 33.58683,
    longitude: -101.85179,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79401',
  },
  {
    city: 'Lubbock',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 47.3,
    imprecise: false,
    latitude: 33.6433,
    longitude: -101.76595,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 16089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79403',
  },
  {
    city: 'Lubbock',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 115.4,
    imprecise: false,
    latitude: 33.52651,
    longitude: -101.79856,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79404',
  },
  {
    city: 'Lubbock',
    county_fips: 48219,
    county_fips_all: '48219|48303',
    county: 'Hockley',
    county_names_all: 'Hockley|Lubbock',
    county_weights: '{"48219": 62.38, "48303": 37.62}',
    density: 122.1,
    imprecise: false,
    latitude: 33.56566,
    longitude: -102.08895,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 24000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79407',
  },
  {
    city: 'Lubbock',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 1620.2,
    imprecise: false,
    latitude: 33.56962,
    longitude: -101.89124,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 10137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79410',
  },
  {
    city: 'Lubbock',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 1786.1,
    imprecise: false,
    latitude: 33.57012,
    longitude: -101.85773,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79411',
  },
  {
    city: 'Lubbock',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 1806.3,
    imprecise: false,
    latitude: 33.5464,
    longitude: -101.85765,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79412',
  },
  {
    city: 'Lubbock',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 1924.6,
    imprecise: false,
    latitude: 33.54576,
    longitude: -101.88775,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79413',
  },
  {
    city: 'Lubbock',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 2142.3,
    imprecise: false,
    latitude: 33.54862,
    longitude: -101.91943,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 17596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79414',
  },
  {
    city: 'Lubbock',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 89.9,
    imprecise: false,
    latitude: 33.69863,
    longitude: -101.90497,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79415',
  },
  {
    city: 'Lubbock',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 437.7,
    imprecise: false,
    latitude: 33.60473,
    longitude: -101.97658,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 36442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79416',
  },
  {
    city: 'Lubbock',
    county_fips: 48303,
    county_fips_all: '48303|48305',
    county: 'Lubbock',
    county_names_all: 'Lubbock|Lynn',
    county_weights: '{"48303": 78.95, "48305": 21.05}',
    density: 282.5,
    imprecise: false,
    latitude: 33.43376,
    longitude: -101.84751,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79423',
  },
  {
    city: 'Lubbock',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 496.4,
    imprecise: false,
    latitude: 33.46865,
    longitude: -101.93881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79424',
  },
  {
    city: 'Anson',
    county_fips: 48253,
    county_fips_all: '48253',
    county: 'Jones',
    county_names_all: 'Jones',
    county_weights: '{"48253": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 32.74332,
    longitude: -99.89332,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79501',
  },
  {
    city: 'Aspermont',
    county_fips: 48433,
    county_fips_all: '48433',
    county: 'Stonewall',
    county_names_all: 'Stonewall',
    county_weights: '{"48433": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 33.18305,
    longitude: -100.26499,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79502',
  },
  {
    city: 'Avoca',
    county_fips: 48253,
    county_fips_all: '48253|48207',
    county: 'Jones',
    county_names_all: 'Jones|Haskell',
    county_weights: '{"48253": 86.99, "48207": 13.01}',
    density: 1,
    imprecise: false,
    latitude: 32.89003,
    longitude: -99.69033,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79503',
  },
  {
    city: 'Baird',
    county_fips: 48059,
    county_fips_all: '48059|48417',
    county: 'Callahan',
    county_names_all: 'Callahan|Shackelford',
    county_weights: '{"48059": 94.35, "48417": 5.65}',
    density: 3,
    imprecise: false,
    latitude: 32.31336,
    longitude: -99.35271,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79504',
  },
  {
    city: 'Benjamin',
    county_fips: 48275,
    county_fips_all: '48275',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"48275": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 33.56323,
    longitude: -99.84003,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79505',
  },
  {
    city: 'Blackwell',
    county_fips: 48353,
    county_fips_all: '48353|48081',
    county: 'Nolan',
    county_names_all: 'Nolan|Coke',
    county_weights: '{"48353": 72.61, "48081": 27.39}',
    density: 1.2,
    imprecise: false,
    latitude: 32.11366,
    longitude: -100.32613,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79506',
  },
  {
    city: 'Buffalo Gap',
    county_fips: 48441,
    county_fips_all: '48441',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"48441": 100}',
    density: 43.2,
    imprecise: false,
    latitude: 32.26999,
    longitude: -99.83032,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79508',
  },
  {
    city: 'Clyde',
    county_fips: 48059,
    county_fips_all: '48059|48083',
    county: 'Callahan',
    county_names_all: 'Callahan|Coleman',
    county_weights: '{"48059": 88.61, "48083": 11.39}',
    density: 12.7,
    imprecise: false,
    latitude: 32.26006,
    longitude: -99.52872,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79510',
  },
  {
    city: 'Coahoma',
    county_fips: 48227,
    county_fips_all: '48227|48033',
    county: 'Howard',
    county_names_all: 'Howard|Borden',
    county_weights: '{"48227": 73.18, "48033": 26.82}',
    density: 2.7,
    imprecise: false,
    latitude: 32.42982,
    longitude: -101.26699,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79511',
  },
  {
    city: 'Colorado City',
    county_fips: 48335,
    county_fips_all: '48335|48415',
    county: 'Mitchell',
    county_names_all: 'Mitchell|Scurry',
    county_weights: '{"48335": 96.57, "48415": 3.43}',
    density: 5,
    imprecise: false,
    latitude: 32.32614,
    longitude: -100.92807,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79512',
  },
  {
    city: 'Girard',
    county_fips: 48263,
    county_fips_all: '48263|48125',
    county: 'Kent',
    county_names_all: 'Kent|Dickens',
    county_weights: '{"48263": 99.86, "48125": 0.14}',
    density: 0.2,
    imprecise: false,
    latitude: 33.31644,
    longitude: -100.74382,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79518',
  },
  {
    city: 'Goldsboro',
    county_fips: 48083,
    county_fips_all: '48083|48399|48441',
    county: 'Coleman',
    county_names_all: 'Coleman|Runnels|Taylor',
    county_weights: '{"48083": 63.72, "48399": 30.67, "48441": 5.61}',
    density: 1.2,
    imprecise: false,
    latitude: 32.04926,
    longitude: -99.69857,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79519',
  },
  {
    city: 'Hamlin',
    county_fips: 48253,
    county_fips_all: '48253|48151|48433',
    county: 'Jones',
    county_names_all: 'Jones|Fisher|Stonewall',
    county_weights: '{"48253": 53.48, "48151": 38.64, "48433": 7.88}',
    density: 3.9,
    imprecise: false,
    latitude: 32.87581,
    longitude: -100.13012,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79520',
  },
  {
    city: 'Haskell',
    county_fips: 48207,
    county_fips_all: '48207|48447',
    county: 'Haskell',
    county_names_all: 'Haskell|Throckmorton',
    county_weights: '{"48207": 93.64, "48447": 6.36}',
    density: 4.1,
    imprecise: false,
    latitude: 33.12478,
    longitude: -99.64061,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79521',
  },
  {
    city: 'Hawley',
    county_fips: 48253,
    county_fips_all: '48253',
    county: 'Jones',
    county_names_all: 'Jones',
    county_weights: '{"48253": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 32.62745,
    longitude: -99.82711,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79525',
  },
  {
    city: 'Hermleigh',
    county_fips: 48415,
    county_fips_all: '48415|48151',
    county: 'Scurry',
    county_names_all: 'Scurry|Fisher',
    county_weights: '{"48415": 92.06, "48151": 7.94}',
    density: 2.1,
    imprecise: false,
    latitude: 32.6443,
    longitude: -100.75192,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79526',
  },
  {
    city: 'Ira',
    county_fips: 48415,
    county_fips_all: '48415|48033',
    county: 'Scurry',
    county_names_all: 'Scurry|Borden',
    county_weights: '{"48415": 83.32, "48033": 16.68}',
    density: 1.4,
    imprecise: false,
    latitude: 32.59637,
    longitude: -101.09939,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79527',
  },
  {
    city: 'Jayton',
    county_fips: 48263,
    county_fips_all: '48263|48433',
    county: 'Kent',
    county_names_all: 'Kent|Stonewall',
    county_weights: '{"48263": 75.73, "48433": 24.27}',
    density: 0.7,
    imprecise: false,
    latitude: 33.15936,
    longitude: -100.57982,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79528',
  },
  {
    city: 'Knox City',
    county_fips: 48275,
    county_fips_all: '48275|48207',
    county: 'Knox',
    county_names_all: 'Knox|Haskell',
    county_weights: '{"48275": 84.73, "48207": 15.27}',
    density: 4.6,
    imprecise: false,
    latitude: 33.42911,
    longitude: -99.82915,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79529',
  },
  {
    city: 'Lawn',
    county_fips: 48441,
    county_fips_all: '48441|48399',
    county: 'Taylor',
    county_names_all: 'Taylor|Runnels',
    county_weights: '{"48441": 67.24, "48399": 32.76}',
    density: 2.6,
    imprecise: false,
    latitude: 32.09981,
    longitude: -99.78178,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79530',
  },
  {
    city: 'Loraine',
    county_fips: 48335,
    county_fips_all: '48335|48353|48415',
    county: 'Mitchell',
    county_names_all: 'Mitchell|Nolan|Scurry',
    county_weights: '{"48335": 91.92, "48353": 4.88, "48415": 3.2}',
    density: 3.2,
    imprecise: false,
    latitude: 32.40804,
    longitude: -100.71357,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79532',
  },
  {
    city: 'Lueders',
    county_fips: 48417,
    county_fips_all: '48417|48253|48207|48447',
    county: 'Shackelford',
    county_names_all: 'Shackelford|Jones|Haskell|Throckmorton',
    county_weights:
      '{"48417": 63.09, "48253": 18.02, "48207": 13.53, "48447": 5.36}',
    density: 1,
    imprecise: false,
    latitude: 32.84898,
    longitude: -99.54739,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79533',
  },
  {
    city: 'McCaulley',
    county_fips: 48151,
    county_fips_all: '48151',
    county: 'Fisher',
    county_names_all: 'Fisher',
    county_weights: '{"48151": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 32.75559,
    longitude: -100.22273,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79534',
  },
  {
    city: 'Maryneal',
    county_fips: 48353,
    county_fips_all: '48353|48335',
    county: 'Nolan',
    county_names_all: 'Nolan|Mitchell',
    county_weights: '{"48353": 99.89, "48335": 0.11}',
    density: 0.3,
    imprecise: false,
    latitude: 32.2219,
    longitude: -100.48421,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79535',
  },
  {
    city: 'Merkel',
    county_fips: 48441,
    county_fips_all: '48441|48253|48353',
    county: 'Taylor',
    county_names_all: 'Taylor|Jones|Nolan',
    county_weights: '{"48441": 60.8, "48253": 37.43, "48353": 1.77}',
    density: 6.6,
    imprecise: false,
    latitude: 32.47333,
    longitude: -100.02859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79536',
  },
  {
    city: 'Nolan',
    county_fips: 48353,
    county_fips_all: '48353',
    county: 'Nolan',
    county_names_all: 'Nolan',
    county_weights: '{"48353": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 32.28033,
    longitude: -100.21402,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79537',
  },
  {
    city: 'Novice',
    county_fips: 48083,
    county_fips_all: '48083|48399',
    county: 'Coleman',
    county_names_all: 'Coleman|Runnels',
    county_weights: '{"48083": 65.89, "48399": 34.11}',
    density: 1.3,
    imprecise: false,
    latitude: 31.97891,
    longitude: -99.69177,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79538',
  },
  {
    city: "O'Brien",
    county_fips: 48207,
    county_fips_all: '48207',
    county: 'Haskell',
    county_names_all: 'Haskell',
    county_weights: '{"48207": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 33.36965,
    longitude: -99.89207,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79539',
  },
  {
    city: 'Old Glory',
    county_fips: 48433,
    county_fips_all: '48433',
    county: 'Stonewall',
    county_names_all: 'Stonewall',
    county_weights: '{"48433": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 33.15173,
    longitude: -100.06289,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79540',
  },
  {
    city: 'Ovalo',
    county_fips: 48441,
    county_fips_all: '48441|48059',
    county: 'Taylor',
    county_names_all: 'Taylor|Callahan',
    county_weights: '{"48441": 92.93, "48059": 7.07}',
    density: 4.1,
    imprecise: false,
    latitude: 32.15018,
    longitude: -99.81617,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79541',
  },
  {
    city: 'Roby',
    county_fips: 48151,
    county_fips_all: '48151',
    county: 'Fisher',
    county_names_all: 'Fisher',
    county_weights: '{"48151": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 32.71864,
    longitude: -100.38724,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79543',
  },
  {
    city: 'Rochester',
    county_fips: 48207,
    county_fips_all: '48207|48433',
    county: 'Haskell',
    county_names_all: 'Haskell|Stonewall',
    county_weights: '{"48207": 92.28, "48433": 7.72}',
    density: 1.8,
    imprecise: false,
    latitude: 33.30557,
    longitude: -99.86565,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79544',
  },
  {
    city: 'Roscoe',
    county_fips: 48353,
    county_fips_all: '48353|48151|48415',
    county: 'Nolan',
    county_names_all: 'Nolan|Fisher|Scurry',
    county_weights: '{"48353": 81.51, "48151": 15.34, "48415": 3.15}',
    density: 3,
    imprecise: false,
    latitude: 32.41806,
    longitude: -100.57753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79545',
  },
  {
    city: 'Rotan',
    county_fips: 48151,
    county_fips_all: '48151|48433|48415',
    county: 'Fisher',
    county_names_all: 'Fisher|Stonewall|Scurry',
    county_weights: '{"48151": 77.08, "48433": 19.1, "48415": 3.82}',
    density: 1.6,
    imprecise: false,
    latitude: 32.8792,
    longitude: -100.49136,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79546',
  },
  {
    city: 'Rule',
    county_fips: 48207,
    county_fips_all: '48207|48433',
    county: 'Haskell',
    county_names_all: 'Haskell|Stonewall',
    county_weights: '{"48207": 99.53, "48433": 0.47}',
    density: 4.6,
    imprecise: false,
    latitude: 33.20478,
    longitude: -99.91023,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79547',
  },
  {
    city: 'Rule',
    county_fips: 48207,
    county_fips_all: '48207',
    county: 'Haskell',
    county_names_all: 'Haskell',
    county_weights: '{"48207": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 33.06989,
    longitude: -99.93005,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79548',
  },
  {
    city: 'Snyder',
    county_fips: 48415,
    county_fips_all: '48415|48263|48033',
    county: 'Scurry',
    county_names_all: 'Scurry|Kent|Borden',
    county_weights: '{"48415": 60.33, "48263": 38.67, "48033": 1.0}',
    density: 6.8,
    imprecise: false,
    latitude: 32.90152,
    longitude: -100.90407,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79549',
  },
  {
    city: 'Stamford',
    county_fips: 48253,
    county_fips_all: '48253|48207',
    county: 'Jones',
    county_names_all: 'Jones|Haskell',
    county_weights: '{"48253": 62.35, "48207": 37.65}',
    density: 6.5,
    imprecise: false,
    latitude: 32.93785,
    longitude: -99.84022,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79553',
  },
  {
    city: 'Sweetwater',
    county_fips: 48353,
    county_fips_all: '48353|48151',
    county: 'Nolan',
    county_names_all: 'Nolan|Fisher',
    county_weights: '{"48353": 58.4, "48151": 41.6}',
    density: 12.8,
    imprecise: false,
    latitude: 32.48451,
    longitude: -100.39263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 12532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79556',
  },
  {
    city: 'Sylvester',
    county_fips: 48151,
    county_fips_all: '48151|48253',
    county: 'Fisher',
    county_names_all: 'Fisher|Jones',
    county_weights: '{"48151": 75.19, "48253": 24.81}',
    density: 0.2,
    imprecise: false,
    latitude: 32.67514,
    longitude: -100.2094,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79560',
  },
  {
    city: 'Trent',
    county_fips: 48353,
    county_fips_all: '48353|48151|48441|48253',
    county: 'Nolan',
    county_names_all: 'Nolan|Fisher|Taylor|Jones',
    county_weights:
      '{"48353": 36.31, "48151": 36.24, "48441": 16.05, "48253": 11.4}',
    density: 1.8,
    imprecise: false,
    latitude: 32.51974,
    longitude: -100.18369,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79561',
  },
  {
    city: 'Tuscola',
    county_fips: 48441,
    county_fips_all: '48441',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"48441": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 32.24168,
    longitude: -99.86766,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79562',
  },
  {
    city: 'Tye',
    county_fips: 48441,
    county_fips_all: '48441',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"48441": 100}',
    density: 21,
    imprecise: false,
    latitude: 32.42222,
    longitude: -99.90929,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79563',
  },
  {
    city: 'Westbrook',
    county_fips: 48335,
    county_fips_all: '48335',
    county: 'Mitchell',
    county_names_all: 'Mitchell',
    county_weights: '{"48335": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 32.37637,
    longitude: -101.08415,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79565',
  },
  {
    city: 'Wingate',
    county_fips: 48441,
    county_fips_all: '48441|48399|48353',
    county: 'Taylor',
    county_names_all: 'Taylor|Runnels|Nolan',
    county_weights: '{"48441": 67.99, "48399": 16.9, "48353": 15.11}',
    density: 0.7,
    imprecise: false,
    latitude: 32.15454,
    longitude: -100.1098,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79566',
  },
  {
    city: 'Winters',
    county_fips: 48399,
    county_fips_all: '48399|48441',
    county: 'Runnels',
    county_names_all: 'Runnels|Taylor',
    county_weights: '{"48399": 94.1, "48441": 5.9}',
    density: 3.6,
    imprecise: false,
    latitude: 31.97678,
    longitude: -99.97787,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79567',
  },
  {
    city: 'Abilene',
    county_fips: 48253,
    county_fips_all: '48253|48417|48441|48059',
    county: 'Jones',
    county_names_all: 'Jones|Shackelford|Taylor|Callahan',
    county_weights:
      '{"48253": 47.64, "48417": 23.16, "48441": 17.31, "48059": 11.89}',
    density: 41.2,
    imprecise: false,
    latitude: 32.57226,
    longitude: -99.64921,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79601',
  },
  {
    city: 'Abilene',
    county_fips: 48441,
    county_fips_all: '48441|48059',
    county: 'Taylor',
    county_names_all: 'Taylor|Callahan',
    county_weights: '{"48441": 77.47, "48059": 22.53}',
    density: 87,
    imprecise: false,
    latitude: 32.33568,
    longitude: -99.6699,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79602',
  },
  {
    city: 'Abilene',
    county_fips: 48441,
    county_fips_all: '48441',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"48441": 100}',
    density: 153.6,
    imprecise: false,
    latitude: 32.39904,
    longitude: -99.89222,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 23548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79603',
  },
  {
    city: 'Abilene',
    county_fips: 48441,
    county_fips_all: '48441',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"48441": 100}',
    density: 1000.8,
    imprecise: false,
    latitude: 32.43394,
    longitude: -99.78182,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79605',
  },
  {
    city: 'Abilene',
    county_fips: 48441,
    county_fips_all: '48441',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"48441": 100}',
    density: 162,
    imprecise: false,
    latitude: 32.35477,
    longitude: -99.83139,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79606',
  },
  {
    city: 'Dyess Afb',
    county_fips: 48441,
    county_fips_all: '48441',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"48441": 100}',
    density: 152.7,
    imprecise: false,
    latitude: 32.42289,
    longitude: -99.83904,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79607',
  },
  {
    city: 'Midland',
    county_fips: 48329,
    county_fips_all: '48329',
    county: 'Midland',
    county_names_all: 'Midland',
    county_weights: '{"48329": 100}',
    density: 867.8,
    imprecise: false,
    latitude: 31.99239,
    longitude: -102.08105,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27131,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79701',
  },
  {
    city: 'Midland',
    county_fips: 48329,
    county_fips_all: '48329',
    county: 'Midland',
    county_names_all: 'Midland',
    county_weights: '{"48329": 100}',
    density: 1212.6,
    imprecise: false,
    latitude: 31.97998,
    longitude: -102.13158,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 20419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79703',
  },
  {
    city: 'Midland',
    county_fips: 48317,
    county_fips_all: '48317|48329',
    county: 'Martin',
    county_names_all: 'Martin|Midland',
    county_weights: '{"48317": 51.5, "48329": 48.5}',
    density: 226.8,
    imprecise: false,
    latitude: 32.09619,
    longitude: -102.0508,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 46653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79705',
  },
  {
    city: 'Midland',
    county_fips: 48329,
    county_fips_all: '48329|48173|48461',
    county: 'Midland',
    county_names_all: 'Midland|Glasscock|Upton',
    county_weights: '{"48329": 93.04, "48173": 5.75, "48461": 1.21}',
    density: 19.2,
    imprecise: false,
    latitude: 31.83622,
    longitude: -101.97025,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 34281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79706',
  },
  {
    city: 'Midland',
    county_fips: 48329,
    county_fips_all: '48329',
    county: 'Midland',
    county_names_all: 'Midland',
    county_weights: '{"48329": 100}',
    density: 217.7,
    imprecise: false,
    latitude: 32.03304,
    longitude: -102.21189,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 40010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79707',
  },
  {
    city: 'Ackerly',
    county_fips: 48317,
    county_fips_all: '48317|48115|48227|48033',
    county: 'Martin',
    county_names_all: 'Martin|Dawson|Howard|Borden',
    county_weights:
      '{"48317": 46.11, "48115": 22.01, "48227": 21.76, "48033": 10.11}',
    density: 1.7,
    imprecise: false,
    latitude: 32.49861,
    longitude: -101.74554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79713',
  },
  {
    city: 'Andrews',
    county_fips: 48003,
    county_fips_all: '48003',
    county: 'Andrews',
    county_names_all: 'Andrews',
    county_weights: '{"48003": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 32.32947,
    longitude: -102.71323,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79714',
  },
  {
    city: 'Balmorhea',
    county_fips: 48389,
    county_fips_all: '48389',
    county: 'Reeves',
    county_names_all: 'Reeves',
    county_weights: '{"48389": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 30.99474,
    longitude: -103.73293,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79718',
  },
  {
    city: 'Barstow',
    county_fips: 48475,
    county_fips_all: '48475',
    county: 'Ward',
    county_names_all: 'Ward',
    county_weights: '{"48475": 100}',
    density: 4,
    imprecise: false,
    latitude: 31.46042,
    longitude: -103.4051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79719',
  },
  {
    city: 'Big Spring',
    county_fips: 48227,
    county_fips_all: '48227|48173|48033|48317',
    county: 'Howard',
    county_names_all: 'Howard|Glasscock|Borden|Martin',
    county_weights:
      '{"48227": 55.13, "48173": 35.03, "48033": 5.72, "48317": 4.12}',
    density: 11.7,
    imprecise: false,
    latitude: 32.20171,
    longitude: -101.51395,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 29936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79720',
  },
  {
    city: 'Big Spring',
    county_fips: 48227,
    county_fips_all: '48227',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"48227": 100}',
    density: 3599.3,
    imprecise: false,
    latitude: 32.22491,
    longitude: -101.52737,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79721',
  },
  {
    city: 'Coyanosa',
    county_fips: 48371,
    county_fips_all: '48371',
    county: 'Pecos',
    county_names_all: 'Pecos',
    county_weights: '{"48371": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 31.19335,
    longitude: -103.06396,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79730',
  },
  {
    city: 'Crane',
    county_fips: 48103,
    county_fips_all: '48103',
    county: 'Crane',
    county_names_all: 'Crane',
    county_weights: '{"48103": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 31.4477,
    longitude: -102.56095,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79731',
  },
  {
    city: 'Forsan',
    county_fips: 48227,
    county_fips_all: '48227',
    county: 'Howard',
    county_names_all: 'Howard',
    county_weights: '{"48227": 100}',
    density: 492,
    imprecise: false,
    latitude: 32.11036,
    longitude: -101.36683,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 371,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79733',
  },
  {
    city: 'Fort Davis',
    county_fips: 48243,
    county_fips_all: '48243',
    county: 'Jeff Davis',
    county_names_all: 'Jeff Davis',
    county_weights: '{"48243": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 30.68526,
    longitude: -103.97911,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79734',
  },
  {
    city: 'Fort Stockton',
    county_fips: 48371,
    county_fips_all: '48371',
    county: 'Pecos',
    county_names_all: 'Pecos',
    county_weights: '{"48371": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 30.74837,
    longitude: -102.85518,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 13357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79735',
  },
  {
    city: 'Gail',
    county_fips: 48033,
    county_fips_all: '48033',
    county: 'Borden',
    county_names_all: 'Borden',
    county_weights: '{"48033": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 32.73625,
    longitude: -101.48269,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79738',
  },
  {
    city: 'Garden City',
    county_fips: 48173,
    county_fips_all: '48173|48383',
    county: 'Glasscock',
    county_names_all: 'Glasscock|Reagan',
    county_weights: '{"48173": 91.41, "48383": 8.59}',
    density: 0.7,
    imprecise: false,
    latitude: 31.75515,
    longitude: -101.50668,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79739',
  },
  {
    city: 'Goldsmith',
    county_fips: 48135,
    county_fips_all: '48135',
    county: 'Ector',
    county_names_all: 'Ector',
    county_weights: '{"48135": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 32.00833,
    longitude: -102.65675,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79741',
  },
  {
    city: 'Grandfalls',
    county_fips: 48475,
    county_fips_all: '48475',
    county: 'Ward',
    county_names_all: 'Ward',
    county_weights: '{"48475": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 31.3605,
    longitude: -102.86027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79742',
  },
  {
    city: 'Imperial',
    county_fips: 48371,
    county_fips_all: '48371',
    county: 'Pecos',
    county_names_all: 'Pecos',
    county_weights: '{"48371": 100}',
    density: 1,
    imprecise: false,
    latitude: 31.24911,
    longitude: -102.76766,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79743',
  },
  {
    city: 'Iraan',
    county_fips: 48105,
    county_fips_all: '48105|48371',
    county: 'Crockett',
    county_names_all: 'Crockett|Pecos',
    county_weights: '{"48105": 51.31, "48371": 48.69}',
    density: 1,
    imprecise: false,
    latitude: 30.89083,
    longitude: -101.91305,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79744',
  },
  {
    city: 'Kermit',
    county_fips: 48495,
    county_fips_all: '48495',
    county: 'Winkler',
    county_names_all: 'Winkler',
    county_weights: '{"48495": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 31.85302,
    longitude: -103.03325,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 6034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79745',
  },
  {
    city: 'Knott',
    county_fips: 48227,
    county_fips_all: '48227|48317',
    county: 'Howard',
    county_names_all: 'Howard|Martin',
    county_weights: '{"48227": 62.52, "48317": 37.48}',
    density: 1.8,
    imprecise: false,
    latitude: 32.38784,
    longitude: -101.66889,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79748',
  },
  {
    city: 'Lenorah',
    county_fips: 48317,
    county_fips_all: '48317',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"48317": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 32.25551,
    longitude: -101.83419,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79749',
  },
  {
    city: 'McCamey',
    county_fips: 48461,
    county_fips_all: '48461|48371|48105',
    county: 'Upton',
    county_names_all: 'Upton|Pecos|Crockett',
    county_weights: '{"48461": 58.96, "48371": 21.63, "48105": 19.41}',
    density: 2.7,
    imprecise: false,
    latitude: 31.10993,
    longitude: -102.19225,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79752',
  },
  {
    city: 'Mentone',
    county_fips: 48301,
    county_fips_all: '48301',
    county: 'Loving',
    county_names_all: 'Loving',
    county_weights: '{"48301": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.81735,
    longitude: -103.49163,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79754',
  },
  {
    city: 'Midkiff',
    county_fips: 48461,
    county_fips_all: '48461|48329',
    county: 'Upton',
    county_names_all: 'Upton|Midland',
    county_weights: '{"48461": 98.07, "48329": 1.93}',
    density: 0.1,
    imprecise: false,
    latitude: 31.51298,
    longitude: -101.96934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 67,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79755',
  },
  {
    city: 'Monahans',
    county_fips: 48475,
    county_fips_all: '48475',
    county: 'Ward',
    county_names_all: 'Ward',
    county_weights: '{"48475": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 31.54626,
    longitude: -102.88338,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79756',
  },
  {
    city: 'Gardendale',
    county_fips: 48135,
    county_fips_all: '48135',
    county: 'Ector',
    county_names_all: 'Ector',
    county_weights: '{"48135": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 32.0112,
    longitude: -102.33569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79758',
  },
  {
    city: 'Notrees',
    county_fips: 48135,
    county_fips_all: '48135',
    county: 'Ector',
    county_names_all: 'Ector',
    county_weights: '{"48135": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.80913,
    longitude: -102.69819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79759',
  },
  {
    city: 'Odessa',
    county_fips: 48135,
    county_fips_all: '48135',
    county: 'Ector',
    county_names_all: 'Ector',
    county_weights: '{"48135": 100}',
    density: 1115.7,
    imprecise: false,
    latitude: 31.85603,
    longitude: -102.3485,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 30164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79761',
  },
  {
    city: 'Odessa',
    county_fips: 48135,
    county_fips_all: '48135',
    county: 'Ector',
    county_names_all: 'Ector',
    county_weights: '{"48135": 100}',
    density: 506.1,
    imprecise: false,
    latitude: 31.92573,
    longitude: -102.35502,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79762',
  },
  {
    city: 'Odessa',
    county_fips: 48135,
    county_fips_all: '48135',
    county: 'Ector',
    county_names_all: 'Ector',
    county_weights: '{"48135": 100}',
    density: 269.3,
    imprecise: false,
    latitude: 31.80766,
    longitude: -102.46744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 35174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79763',
  },
  {
    city: 'Odessa',
    county_fips: 48135,
    county_fips_all: '48135',
    county: 'Ector',
    county_names_all: 'Ector',
    county_weights: '{"48135": 100}',
    density: 191.3,
    imprecise: false,
    latitude: 31.88546,
    longitude: -102.47378,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 27013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79764',
  },
  {
    city: 'Odessa',
    county_fips: 48329,
    county_fips_all: '48329|48135',
    county: 'Midland',
    county_names_all: 'Midland|Ector',
    county_weights: '{"48329": 54.85, "48135": 45.15}',
    density: 426.9,
    imprecise: false,
    latitude: 31.92205,
    longitude: -102.29878,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 25904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79765',
  },
  {
    city: 'Odessa',
    county_fips: 48135,
    county_fips_all: '48135|48329|48103',
    county: 'Ector',
    county_names_all: 'Ector|Midland|Crane',
    county_weights: '{"48135": 53.82, "48329": 27.25, "48103": 18.93}',
    density: 14,
    imprecise: false,
    latitude: 31.71014,
    longitude: -102.36185,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79766',
  },
  {
    city: 'Odessa',
    county_fips: 48135,
    county_fips_all: '48135|48103',
    county: 'Ector',
    county_names_all: 'Ector|Crane',
    county_weights: '{"48135": 99.46, "48103": 0.54}',
    density: 0,
    imprecise: false,
    latitude: 31.68212,
    longitude: -102.61973,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79769',
  },
  {
    city: 'Orla',
    county_fips: 48389,
    county_fips_all: '48389',
    county: 'Reeves',
    county_names_all: 'Reeves',
    county_weights: '{"48389": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.85389,
    longitude: -103.90585,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79770',
  },
  {
    city: 'Pecos',
    county_fips: 48389,
    county_fips_all: '48389|48475',
    county: 'Reeves',
    county_names_all: 'Reeves|Ward',
    county_weights: '{"48389": 98.64, "48475": 1.36}',
    density: 4.4,
    imprecise: false,
    latitude: 31.39852,
    longitude: -103.5867,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 11987,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79772',
  },
  {
    city: 'Penwell',
    county_fips: 48135,
    county_fips_all: '48135',
    county: 'Ector',
    county_names_all: 'Ector',
    county_weights: '{"48135": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.77513,
    longitude: -102.55573,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79776',
  },
  {
    city: 'Pyote',
    county_fips: 48475,
    county_fips_all: '48475',
    county: 'Ward',
    county_names_all: 'Ward',
    county_weights: '{"48475": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 31.47772,
    longitude: -103.16337,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79777',
  },
  {
    city: 'Rankin',
    county_fips: 48461,
    county_fips_all: '48461',
    county: 'Upton',
    county_names_all: 'Upton',
    county_weights: '{"48461": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 31.25857,
    longitude: -101.97359,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79778',
  },
  {
    city: 'Saragosa',
    county_fips: 48389,
    county_fips_all: '48389',
    county: 'Reeves',
    county_names_all: 'Reeves',
    county_weights: '{"48389": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 31.03937,
    longitude: -103.65754,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 52,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79780',
  },
  {
    city: 'Sheffield',
    county_fips: 48443,
    county_fips_all: '48443|48105|48371',
    county: 'Terrell',
    county_names_all: 'Terrell|Crockett|Pecos',
    county_weights: '{"48443": 44.35, "48105": 42.0, "48371": 13.65}',
    density: 0.1,
    imprecise: false,
    latitude: 30.60111,
    longitude: -101.75348,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79781',
  },
  {
    city: 'Stanton',
    county_fips: 48317,
    county_fips_all: '48317|48173|48329',
    county: 'Martin',
    county_names_all: 'Martin|Glasscock|Midland',
    county_weights: '{"48317": 84.03, "48173": 8.92, "48329": 7.05}',
    density: 4,
    imprecise: false,
    latitude: 32.18599,
    longitude: -101.88823,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79782',
  },
  {
    city: 'Tarzan',
    county_fips: 48317,
    county_fips_all: '48317',
    county: 'Martin',
    county_names_all: 'Martin',
    county_weights: '{"48317": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 32.3321,
    longitude: -102.05007,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79783',
  },
  {
    city: 'Toyah',
    county_fips: 48389,
    county_fips_all: '48389',
    county: 'Reeves',
    county_names_all: 'Reeves',
    county_weights: '{"48389": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 31.32135,
    longitude: -103.94006,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79785',
  },
  {
    city: 'Wickett',
    county_fips: 48475,
    county_fips_all: '48475',
    county: 'Ward',
    county_names_all: 'Ward',
    county_weights: '{"48475": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 31.60544,
    longitude: -102.98261,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79788',
  },
  {
    city: 'Wink',
    county_fips: 48495,
    county_fips_all: '48495',
    county: 'Winkler',
    county_names_all: 'Winkler',
    county_weights: '{"48495": 100}',
    density: 16.1,
    imprecise: false,
    latitude: 31.75047,
    longitude: -103.1948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79789',
  },
  {
    city: 'Anthony',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 248.5,
    imprecise: false,
    latitude: 31.97677,
    longitude: -106.59822,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79821',
  },
  {
    city: 'Alpine',
    county_fips: 48043,
    county_fips_all: '48043',
    county: 'Brewster',
    county_names_all: 'Brewster',
    county_weights: '{"48043": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 29.89491,
    longitude: -103.49925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79830',
  },
  {
    city: 'Big Bend National Park',
    county_fips: 48043,
    county_fips_all: '48043',
    county: 'Brewster',
    county_names_all: 'Brewster',
    county_weights: '{"48043": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 29.17102,
    longitude: -103.28736,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79834',
  },
  {
    city: 'Canutillo',
    county_fips: 48141,
    county_fips_all: '48141|35013',
    county: 'El Paso',
    county_names_all: 'El Paso|Doña Ana',
    county_weights: '{"48141": 98.45, "35013": 1.55}',
    density: 498.7,
    imprecise: false,
    latitude: 31.93555,
    longitude: -106.59491,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 11440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79835',
  },
  {
    city: 'Clint',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 154.4,
    imprecise: false,
    latitude: 31.56975,
    longitude: -106.2112,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79836',
  },
  {
    city: 'Dell City',
    county_fips: 35035,
    county_fips_all: '35035|48229',
    county: 'Otero',
    county_names_all: 'Otero|Hudspeth',
    county_weights: '{"35035": 81.78, "48229": 18.22}',
    density: 0,
    imprecise: false,
    latitude: 32.11472,
    longitude: -105.22792,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79837',
  },
  {
    city: 'Fabens',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 62.2,
    imprecise: false,
    latitude: 31.49362,
    longitude: -106.17024,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79838',
  },
  {
    city: 'Fort Hancock',
    county_fips: 48229,
    county_fips_all: '48229',
    county: 'Hudspeth',
    county_names_all: 'Hudspeth',
    county_weights: '{"48229": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 31.36476,
    longitude: -105.68693,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79839',
  },
  {
    city: 'Marathon',
    county_fips: 48043,
    county_fips_all: '48043',
    county: 'Brewster',
    county_names_all: 'Brewster',
    county_weights: '{"48043": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 30.0151,
    longitude: -103.02301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79842',
  },
  {
    city: 'Marfa',
    county_fips: 48377,
    county_fips_all: '48377',
    county: 'Presidio',
    county_names_all: 'Presidio',
    county_weights: '{"48377": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 30.11987,
    longitude: -104.30359,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79843',
  },
  {
    city: 'Presidio',
    county_fips: 48377,
    county_fips_all: '48377',
    county: 'Presidio',
    county_names_all: 'Presidio',
    county_weights: '{"48377": 100}',
    density: 7,
    imprecise: false,
    latitude: 29.65332,
    longitude: -104.39724,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79845',
  },
  {
    city: 'Redford',
    county_fips: 48377,
    county_fips_all: '48377',
    county: 'Presidio',
    county_names_all: 'Presidio',
    county_weights: '{"48377": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 29.41684,
    longitude: -103.98559,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79846',
  },
  {
    city: 'Salt Flat',
    county_fips: 48109,
    county_fips_all: '48109|48229',
    county: 'Culberson',
    county_names_all: 'Culberson|Hudspeth',
    county_weights: '{"48109": 54.4, "48229": 45.6}',
    density: 0.1,
    imprecise: false,
    latitude: 31.78975,
    longitude: -104.99032,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79847',
  },
  {
    city: 'Sanderson',
    county_fips: 48443,
    county_fips_all: '48443',
    county: 'Terrell',
    county_names_all: 'Terrell',
    county_weights: '{"48443": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 30.27747,
    longitude: -102.26187,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79848',
  },
  {
    city: 'San Elizario',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 408.2,
    imprecise: false,
    latitude: 31.56449,
    longitude: -106.25275,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 14409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79849',
  },
  {
    city: 'Sierra Blanca',
    county_fips: 48229,
    county_fips_all: '48229',
    county: 'Hudspeth',
    county_names_all: 'Hudspeth',
    county_weights: '{"48229": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 31.2687,
    longitude: -105.26255,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79851',
  },
  {
    city: 'Terlingua',
    county_fips: 48043,
    county_fips_all: '48043',
    county: 'Brewster',
    county_names_all: 'Brewster',
    county_weights: '{"48043": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 29.36484,
    longitude: -103.6029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79852',
  },
  {
    city: 'Tornillo',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 29.8,
    imprecise: false,
    latitude: 31.43559,
    longitude: -106.06493,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79853',
  },
  {
    city: 'Valentine',
    county_fips: 48243,
    county_fips_all: '48243|48377',
    county: 'Jeff Davis',
    county_names_all: 'Jeff Davis|Presidio',
    county_weights: '{"48243": 68.65, "48377": 31.35}',
    density: 0.1,
    imprecise: false,
    latitude: 30.6109,
    longitude: -104.62469,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 86,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79854',
  },
  {
    city: 'Van Horn',
    county_fips: 48109,
    county_fips_all: '48109|48229',
    county: 'Culberson',
    county_names_all: 'Culberson|Hudspeth',
    county_weights: '{"48109": 72.37, "48229": 27.63}',
    density: 1.8,
    imprecise: false,
    latitude: 30.92331,
    longitude: -104.85583,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79855',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 1501.1,
    imprecise: false,
    latitude: 31.7597,
    longitude: -106.48049,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79901',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 1125.1,
    imprecise: false,
    latitude: 31.78431,
    longitude: -106.49768,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 19031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79902',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 1863,
    imprecise: false,
    latitude: 31.78622,
    longitude: -106.44194,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 14715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79903',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 1065.4,
    imprecise: false,
    latitude: 31.85005,
    longitude: -106.45417,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79904',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 1328.3,
    imprecise: false,
    latitude: 31.76665,
    longitude: -106.42523,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 22594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79905',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 506.6,
    imprecise: false,
    latitude: 31.80906,
    longitude: -106.41954,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79906',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 1305.5,
    imprecise: false,
    latitude: 31.7074,
    longitude: -106.32681,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 46365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79907',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 902.4,
    imprecise: false,
    latitude: 31.82974,
    longitude: -106.37763,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79908',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 114.1,
    imprecise: false,
    latitude: 31.9361,
    longitude: -106.53569,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79911',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 1286.8,
    imprecise: false,
    latitude: 31.84839,
    longitude: -106.53272,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 78819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79912',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 1485.6,
    imprecise: false,
    latitude: 31.74593,
    longitude: -106.37245,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 34230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79915',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141|35013',
    county: 'El Paso',
    county_names_all: 'El Paso|Doña Ana',
    county_weights: '{"48141": 83.31, "35013": 16.69}',
    density: 325.8,
    imprecise: false,
    latitude: 31.81126,
    longitude: -106.55823,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79922',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 1882.4,
    imprecise: false,
    latitude: 31.90224,
    longitude: -106.41355,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 60364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79924',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 854,
    imprecise: false,
    latitude: 31.79851,
    longitude: -106.36327,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 38621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79925',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 625.2,
    imprecise: false,
    latitude: 31.64566,
    longitude: -106.27359,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79927',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 159.3,
    imprecise: false,
    latitude: 31.67896,
    longitude: -106.11511,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 86599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79928',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 1243.9,
    imprecise: false,
    latitude: 31.81078,
    longitude: -106.46846,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 24123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79930',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 866.2,
    imprecise: false,
    latitude: 31.87753,
    longitude: -106.6068,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 30786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79932',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 188.5,
    imprecise: false,
    latitude: 31.95206,
    longitude: -106.434,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 28861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79934',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 2085.5,
    imprecise: false,
    latitude: 31.76804,
    longitude: -106.33029,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79935',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 1535.4,
    imprecise: false,
    latitude: 31.77373,
    longitude: -106.29631,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 102991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79936',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141|48229',
    county: 'El Paso',
    county_names_all: 'El Paso|Hudspeth',
    county_weights: '{"48141": 54.48, "48229": 45.52}',
    density: 98.6,
    imprecise: false,
    latitude: 31.85764,
    longitude: -106.03895,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 99621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79938',
  },
  {
    city: 'Arvada',
    county_fips: 8059,
    county_fips_all: '08059|08001',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Adams',
    county_weights: '{"08059": 94.86, "08001": 5.14}',
    density: 1264.2,
    imprecise: false,
    latitude: 39.79405,
    longitude: -105.10845,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 21270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80002',
  },
  {
    city: 'Arvada',
    county_fips: 8059,
    county_fips_all: '08059|08001',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Adams',
    county_weights: '{"08059": 85.1, "08001": 14.9}',
    density: 2110.8,
    imprecise: false,
    latitude: 39.827,
    longitude: -105.06412,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80003',
  },
  {
    city: 'Arvada',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 1819.9,
    imprecise: false,
    latitude: 39.81443,
    longitude: -105.12293,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 33700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80004',
  },
  {
    city: 'Arvada',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 938.6,
    imprecise: false,
    latitude: 39.85053,
    longitude: -105.13031,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 28459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80005',
  },
  {
    city: 'Arvada',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 294.3,
    imprecise: false,
    latitude: 39.8665,
    longitude: -105.19875,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 19078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80007',
  },
  {
    city: 'Aurora',
    county_fips: 8005,
    county_fips_all: '08005|08001',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe|Adams',
    county_weights: '{"08005": 51.06, "08001": 48.94}',
    density: 3188.3,
    imprecise: false,
    latitude: 39.73979,
    longitude: -104.86193,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 42439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80010',
  },
  {
    city: 'Aurora',
    county_fips: 8001,
    county_fips_all: '08001|08005',
    county: 'Adams',
    county_names_all: 'Adams|Arapahoe',
    county_weights: '{"08001": 55.36, "08005": 44.64}',
    density: 1014.9,
    imprecise: false,
    latitude: 39.74393,
    longitude: -104.78994,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 53695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80011',
  },
  {
    city: 'Aurora',
    county_fips: 8005,
    county_fips_all: '08005|08031',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe|Denver',
    county_weights: '{"08005": 99.64, "08031": 0.36}',
    density: 2593.7,
    imprecise: false,
    latitude: 39.69976,
    longitude: -104.83784,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 51052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80012',
  },
  {
    city: 'Aurora',
    county_fips: 8005,
    county_fips_all: '08005',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe',
    county_weights: '{"08005": 100}',
    density: 2027.6,
    imprecise: false,
    latitude: 39.66145,
    longitude: -104.76577,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 73248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80013',
  },
  {
    city: 'Aurora',
    county_fips: 8005,
    county_fips_all: '08005|08031',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe|Denver',
    county_weights: '{"08005": 90.05, "08031": 9.95}',
    density: 2128.6,
    imprecise: false,
    latitude: 39.66353,
    longitude: -104.83781,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 39496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80014',
  },
  {
    city: 'Aurora',
    county_fips: 8005,
    county_fips_all: '08005',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe',
    county_weights: '{"08005": 100}',
    density: 1716.7,
    imprecise: false,
    latitude: 39.62737,
    longitude: -104.79497,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 72316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80015',
  },
  {
    city: 'Aurora',
    county_fips: 8005,
    county_fips_all: '08005|08035',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe|Douglas',
    county_weights: '{"08005": 95.38, "08035": 4.62}',
    density: 816.6,
    imprecise: false,
    latitude: 39.59391,
    longitude: -104.72311,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 68268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80016',
  },
  {
    city: 'Aurora',
    county_fips: 8005,
    county_fips_all: '08005',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe',
    county_weights: '{"08005": 100}',
    density: 1709.2,
    imprecise: false,
    latitude: 39.69914,
    longitude: -104.7735,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 40584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80017',
  },
  {
    city: 'Aurora',
    county_fips: 8005,
    county_fips_all: '08005',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe',
    county_weights: '{"08005": 100}',
    density: 208.1,
    imprecise: false,
    latitude: 39.69071,
    longitude: -104.68096,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 19072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80018',
  },
  {
    city: 'Aurora',
    county_fips: 8001,
    county_fips_all: '08001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"08001": 100}',
    density: 108.7,
    imprecise: false,
    latitude: 39.78653,
    longitude: -104.6972,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80019',
  },
  {
    city: 'Broomfield',
    county_fips: 8014,
    county_fips_all: '08014|08013|08059|08001',
    county: 'Broomfield',
    county_names_all: 'Broomfield|Boulder|Jefferson|Adams',
    county_weights:
      '{"08014": 59.95, "08013": 24.92, "08059": 12.9, "08001": 2.23}',
    density: 1058.8,
    imprecise: false,
    latitude: 39.93121,
    longitude: -105.07407,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 54201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80020',
  },
  {
    city: 'Broomfield',
    county_fips: 8059,
    county_fips_all: '08059|08014',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Broomfield',
    county_weights: '{"08059": 69.22, "08014": 30.78}',
    density: 853.6,
    imprecise: false,
    latitude: 39.89105,
    longitude: -105.11448,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 36555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80021',
  },
  {
    city: 'Commerce City',
    county_fips: 8001,
    county_fips_all: '08001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"08001": 100}',
    density: 298.2,
    imprecise: false,
    latitude: 39.86448,
    longitude: -104.78868,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 61452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80022',
  },
  {
    city: 'Broomfield',
    county_fips: 8014,
    county_fips_all: '08014|08001',
    county: 'Broomfield',
    county_names_all: 'Broomfield|Adams',
    county_weights: '{"08014": 62.88, "08001": 37.12}',
    density: 567.9,
    imprecise: false,
    latitude: 39.97407,
    longitude: -105.01011,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 27143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80023',
  },
  {
    city: 'Dupont',
    county_fips: 8001,
    county_fips_all: '08001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"08001": 100}',
    density: 576.4,
    imprecise: false,
    latitude: 39.84403,
    longitude: -104.91842,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80024',
  },
  {
    city: 'Eldorado Springs',
    county_fips: 8013,
    county_fips_all: '08013|08059',
    county: 'Boulder',
    county_names_all: 'Boulder|Jefferson',
    county_weights: '{"08013": 99.6, "08059": 0.4}',
    density: 13.2,
    imprecise: false,
    latitude: 39.92444,
    longitude: -105.29226,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80025',
  },
  {
    city: 'Lafayette',
    county_fips: 8013,
    county_fips_all: '08013|08014',
    county: 'Boulder',
    county_names_all: 'Boulder|Broomfield',
    county_weights: '{"08013": 99.56, "08014": 0.44}',
    density: 560.9,
    imprecise: false,
    latitude: 40.01188,
    longitude: -105.0985,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80026',
  },
  {
    city: 'Louisville',
    county_fips: 8013,
    county_fips_all: '08013',
    county: 'Boulder',
    county_names_all: 'Boulder',
    county_weights: '{"08013": 100}',
    density: 707.4,
    imprecise: false,
    latitude: 39.9508,
    longitude: -105.16354,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 34127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80027',
  },
  {
    city: 'Westminster',
    county_fips: 8001,
    county_fips_all: '08001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"08001": 100}',
    density: 2260.6,
    imprecise: false,
    latitude: 39.83006,
    longitude: -105.03695,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80030',
  },
  {
    city: 'Westminster',
    county_fips: 8001,
    county_fips_all: '08001|08059',
    county: 'Adams',
    county_names_all: 'Adams|Jefferson',
    county_weights: '{"08001": 89.93, "08059": 10.07}',
    density: 1627.8,
    imprecise: false,
    latitude: 39.87522,
    longitude: -105.04039,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80031',
  },
  {
    city: 'Wheat Ridge',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 1226.3,
    imprecise: false,
    latitude: 39.77315,
    longitude: -105.10222,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 26485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80033',
  },
  {
    city: 'Aurora',
    county_fips: 8001,
    county_fips_all: '08001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"08001": 100}',
    density: 724,
    imprecise: false,
    latitude: 39.74702,
    longitude: -104.83843,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1676,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80045',
  },
  {
    city: 'Agate',
    county_fips: 8039,
    county_fips_all: '08039',
    county: 'Elbert',
    county_names_all: 'Elbert',
    county_weights: '{"08039": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 39.42503,
    longitude: -103.95395,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80101',
  },
  {
    city: 'Bennett',
    county_fips: 8001,
    county_fips_all: '08001|08005|08039',
    county: 'Adams',
    county_names_all: 'Adams|Arapahoe|Elbert',
    county_weights: '{"08001": 48.72, "08005": 36.4, "08039": 14.88}',
    density: 8.8,
    imprecise: false,
    latitude: 39.73237,
    longitude: -104.43874,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80102',
  },
  {
    city: 'Byers',
    county_fips: 8001,
    county_fips_all: '08001|08005',
    county: 'Adams',
    county_names_all: 'Adams|Arapahoe',
    county_weights: '{"08001": 66.6, "08005": 33.4}',
    density: 3.4,
    imprecise: false,
    latitude: 39.78035,
    longitude: -104.09576,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80103',
  },
  {
    city: 'Castle Rock',
    county_fips: 8035,
    county_fips_all: '08035',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"08035": 100}',
    density: 210.2,
    imprecise: false,
    latitude: 39.30213,
    longitude: -104.81967,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 38479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80104',
  },
  {
    city: 'Deer Trail',
    county_fips: 8005,
    county_fips_all: '08005|08039|08001',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe|Elbert|Adams',
    county_weights: '{"08005": 59.35, "08039": 27.9, "08001": 12.75}',
    density: 2.1,
    imprecise: false,
    latitude: 39.62679,
    longitude: -103.96078,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80105',
  },
  {
    city: 'Elbert',
    county_fips: 8039,
    county_fips_all: '08039|08041|08035',
    county: 'Elbert',
    county_names_all: 'Elbert|El Paso|Douglas',
    county_weights: '{"08039": 79.68, "08041": 16.66, "08035": 3.66}',
    density: 10,
    imprecise: false,
    latitude: 39.17646,
    longitude: -104.52975,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80106',
  },
  {
    city: 'Elizabeth',
    county_fips: 8039,
    county_fips_all: '08039|08035',
    county: 'Elbert',
    county_names_all: 'Elbert|Douglas',
    county_weights: '{"08039": 99.73, "08035": 0.27}',
    density: 37.7,
    imprecise: false,
    latitude: 39.41195,
    longitude: -104.57226,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80107',
  },
  {
    city: 'Castle Rock',
    county_fips: 8035,
    county_fips_all: '08035',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"08035": 100}',
    density: 401.8,
    imprecise: false,
    latitude: 39.44441,
    longitude: -104.85321,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 36730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80108',
  },
  {
    city: 'Castle Rock',
    county_fips: 8035,
    county_fips_all: '08035',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"08035": 100}',
    density: 421.9,
    imprecise: false,
    latitude: 39.36473,
    longitude: -104.90056,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 28400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80109',
  },
  {
    city: 'Englewood',
    county_fips: 8005,
    county_fips_all: '08005|08031',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe|Denver',
    county_weights: '{"08005": 97.42, "08031": 2.58}',
    density: 1442.3,
    imprecise: false,
    latitude: 39.64612,
    longitude: -105.00928,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 23825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80110',
  },
  {
    city: 'Englewood',
    county_fips: 8005,
    county_fips_all: '08005',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe',
    county_weights: '{"08005": 100}',
    density: 1118.6,
    imprecise: false,
    latitude: 39.6124,
    longitude: -104.88025,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 31561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80111',
  },
  {
    city: 'Englewood',
    county_fips: 8005,
    county_fips_all: '08005|08035',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe|Douglas',
    county_weights: '{"08005": 73.13, "08035": 26.87}',
    density: 796.4,
    imprecise: false,
    latitude: 39.57288,
    longitude: -104.85854,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 36816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80112',
  },
  {
    city: 'Englewood',
    county_fips: 8005,
    county_fips_all: '08005',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe',
    county_weights: '{"08005": 100}',
    density: 1156.4,
    imprecise: false,
    latitude: 39.64224,
    longitude: -104.96189,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 22976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80113',
  },
  {
    city: 'Franktown',
    county_fips: 8035,
    county_fips_all: '08035',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"08035": 100}',
    density: 21.5,
    imprecise: false,
    latitude: 39.30711,
    longitude: -104.71947,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80116',
  },
  {
    city: 'Kiowa',
    county_fips: 8039,
    county_fips_all: '08039',
    county: 'Elbert',
    county_names_all: 'Elbert',
    county_weights: '{"08039": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 39.37203,
    longitude: -104.39978,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80117',
  },
  {
    city: 'Larkspur',
    county_fips: 8035,
    county_fips_all: '08035',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"08035": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 39.19132,
    longitude: -104.8848,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80118',
  },
  {
    city: 'Littleton',
    county_fips: 8005,
    county_fips_all: '08005|08035',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe|Douglas',
    county_weights: '{"08005": 98.63, "08035": 1.37}',
    density: 1371.9,
    imprecise: false,
    latitude: 39.5929,
    longitude: -105.00949,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 29725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80120',
  },
  {
    city: 'Littleton',
    county_fips: 8005,
    county_fips_all: '08005',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe',
    county_weights: '{"08005": 100}',
    density: 965.2,
    imprecise: false,
    latitude: 39.61045,
    longitude: -104.95421,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80121',
  },
  {
    city: 'Littleton',
    county_fips: 8005,
    county_fips_all: '08005',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe',
    county_weights: '{"08005": 100}',
    density: 1747.3,
    imprecise: false,
    latitude: 39.5806,
    longitude: -104.95573,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80122',
  },
  {
    city: 'Littleton',
    county_fips: 8059,
    county_fips_all: '08059|08005|08031',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Arapahoe|Denver',
    county_weights: '{"08059": 46.54, "08005": 29.29, "08031": 24.17}',
    density: 1430.7,
    imprecise: false,
    latitude: 39.61578,
    longitude: -105.0692,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80123',
  },
  {
    city: 'Lone Tree',
    county_fips: 8035,
    county_fips_all: '08035',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"08035": 100}',
    density: 928,
    imprecise: false,
    latitude: 39.53197,
    longitude: -104.89173,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 22555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80124',
  },
  {
    city: 'Littleton',
    county_fips: 8035,
    county_fips_all: '08035|08059',
    county: 'Douglas',
    county_names_all: 'Douglas|Jefferson',
    county_weights: '{"08035": 99.63, "08059": 0.37}',
    density: 153.9,
    imprecise: false,
    latitude: 39.48546,
    longitude: -105.05737,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80125',
  },
  {
    city: 'Littleton',
    county_fips: 8035,
    county_fips_all: '08035',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"08035": 100}',
    density: 1602,
    imprecise: false,
    latitude: 39.54127,
    longitude: -104.96251,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80126',
  },
  {
    city: 'Littleton',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 253,
    imprecise: false,
    latitude: 39.52249,
    longitude: -105.15773,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 43494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80127',
  },
  {
    city: 'Littleton',
    county_fips: 8059,
    county_fips_all: '08059|08005',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Arapahoe',
    county_weights: '{"08059": 87.29, "08005": 12.71}',
    density: 1128.5,
    imprecise: false,
    latitude: 39.56167,
    longitude: -105.07914,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 36712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80128',
  },
  {
    city: 'Littleton',
    county_fips: 8035,
    county_fips_all: '08035|08005',
    county: 'Douglas',
    county_names_all: 'Douglas|Arapahoe',
    county_weights: '{"08035": 99.49, "08005": 0.51}',
    density: 1657.5,
    imprecise: false,
    latitude: 39.54521,
    longitude: -105.01203,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 30223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80129',
  },
  {
    city: 'Littleton',
    county_fips: 8035,
    county_fips_all: '08035',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"08035": 100}',
    density: 1388.2,
    imprecise: false,
    latitude: 39.52918,
    longitude: -104.92448,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 24719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80130',
  },
  {
    city: 'Louviers',
    county_fips: 8035,
    county_fips_all: '08035',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"08035": 100}',
    density: 192.1,
    imprecise: false,
    latitude: 39.47627,
    longitude: -105.00899,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80131',
  },
  {
    city: 'Monument',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 291.1,
    imprecise: false,
    latitude: 39.09183,
    longitude: -104.8576,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 30073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80132',
  },
  {
    city: 'Palmer Lake',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 315.4,
    imprecise: false,
    latitude: 39.1155,
    longitude: -104.90443,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80133',
  },
  {
    city: 'Parker',
    county_fips: 8035,
    county_fips_all: '08035',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"08035": 100}',
    density: 540.7,
    imprecise: false,
    latitude: 39.48282,
    longitude: -104.77957,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 80302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80134',
  },
  {
    city: 'Sedalia',
    county_fips: 8035,
    county_fips_all: '08035|08059',
    county: 'Douglas',
    county_names_all: 'Douglas|Jefferson',
    county_weights: '{"08035": 82.31, "08059": 17.69}',
    density: 4.3,
    imprecise: false,
    latitude: 39.27763,
    longitude: -105.13494,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80135',
  },
  {
    city: 'Strasburg',
    county_fips: 8001,
    county_fips_all: '08001|08005',
    county: 'Adams',
    county_names_all: 'Adams|Arapahoe',
    county_weights: '{"08001": 68.68, "08005": 31.32}',
    density: 11.2,
    imprecise: false,
    latitude: 39.80729,
    longitude: -104.29613,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80136',
  },
  {
    city: 'Watkins',
    county_fips: 8005,
    county_fips_all: '08005|08001',
    county: 'Arapahoe',
    county_names_all: 'Arapahoe|Adams',
    county_weights: '{"08005": 59.33, "08001": 40.67}',
    density: 6,
    imprecise: false,
    latitude: 39.70901,
    longitude: -104.59235,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80137',
  },
  {
    city: 'Parker',
    county_fips: 8035,
    county_fips_all: '08035|08039',
    county: 'Douglas',
    county_names_all: 'Douglas|Elbert',
    county_weights: '{"08035": 55.79, "08039": 44.21}',
    density: 230.1,
    imprecise: false,
    latitude: 39.51649,
    longitude: -104.67114,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 36895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80138',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 6207.2,
    imprecise: false,
    latitude: 39.75156,
    longitude: -104.99768,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80202',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 7929.1,
    imprecise: false,
    latitude: 39.73142,
    longitude: -104.98274,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 22441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80203',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 2487.9,
    imprecise: false,
    latitude: 39.73476,
    longitude: -105.0207,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80204',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 2873.3,
    imprecise: false,
    latitude: 39.75891,
    longitude: -104.96353,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 34571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80205',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 3799.9,
    imprecise: false,
    latitude: 39.73041,
    longitude: -104.95258,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 24383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80206',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 2122,
    imprecise: false,
    latitude: 39.76137,
    longitude: -104.91674,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 21542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80207',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 3038.3,
    imprecise: false,
    latitude: 39.70608,
    longitude: -104.9656,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 27564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80209',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 2480.2,
    imprecise: false,
    latitude: 39.6781,
    longitude: -104.96275,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 39113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80210',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 3265.4,
    imprecise: false,
    latitude: 39.76715,
    longitude: -105.02006,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 38177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80211',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031|08059|08001',
    county: 'Denver',
    county_names_all: 'Denver|Jefferson|Adams',
    county_weights: '{"08031": 74.66, "08059": 18.07, "08001": 7.27}',
    density: 2248,
    imprecise: false,
    latitude: 39.77174,
    longitude: -105.04819,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 20746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80212',
  },
  {
    city: 'Denver',
    county_fips: 8059,
    county_fips_all: '08059|08031',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Denver',
    county_weights: '{"08059": 99.16, "08031": 0.84}',
    density: 2234.7,
    imprecise: false,
    latitude: 39.74205,
    longitude: -105.07123,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 27022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80214',
  },
  {
    city: 'Denver',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 1403.3,
    imprecise: false,
    latitude: 39.74412,
    longitude: -105.1158,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 19839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80215',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031|08001',
    county: 'Denver',
    county_names_all: 'Denver|Adams',
    county_weights: '{"08031": 71.56, "08001": 28.44}',
    density: 660.4,
    imprecise: false,
    latitude: 39.78659,
    longitude: -104.96187,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 17330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80216',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 4671.3,
    imprecise: false,
    latitude: 39.73119,
    longitude: -104.97073,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 19149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80218',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 3113.5,
    imprecise: false,
    latitude: 39.69496,
    longitude: -105.03432,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 59523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80219',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031|08001|08005',
    county: 'Denver',
    county_names_all: 'Denver|Adams|Arapahoe',
    county_weights: '{"08031": 99.52, "08001": 0.31, "08005": 0.17}',
    density: 2777.9,
    imprecise: false,
    latitude: 39.73375,
    longitude: -104.91648,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 37203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80220',
  },
  {
    city: 'Denver',
    county_fips: 8001,
    county_fips_all: '08001|08031',
    county: 'Adams',
    county_names_all: 'Adams|Denver',
    county_weights: '{"08001": 88.51, "08031": 11.49}',
    density: 1688,
    imprecise: false,
    latitude: 39.81555,
    longitude: -105.0103,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 39718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80221',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031|08005',
    county: 'Denver',
    county_names_all: 'Denver|Arapahoe',
    county_weights: '{"08031": 84.8, "08005": 15.2}',
    density: 2406.4,
    imprecise: false,
    latitude: 39.6713,
    longitude: -104.92828,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 23838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80222',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 1400.4,
    imprecise: false,
    latitude: 39.69646,
    longitude: -105.00216,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 19246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80223',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031|08005',
    county: 'Denver',
    county_names_all: 'Denver|Arapahoe',
    county_weights: '{"08031": 97.42, "08005": 2.58}',
    density: 2279,
    imprecise: false,
    latitude: 39.68803,
    longitude: -104.91161,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 19352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80224',
  },
  {
    city: 'Denver',
    county_fips: 8059,
    county_fips_all: '08059|08031',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Denver',
    county_weights: '{"08059": 99.4, "08031": 0.6}',
    density: 1502.5,
    imprecise: false,
    latitude: 39.71081,
    longitude: -105.09155,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 31573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80226',
  },
  {
    city: 'Denver',
    county_fips: 8059,
    county_fips_all: '08059|08031',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Denver',
    county_weights: '{"08059": 86.12, "08031": 13.88}',
    density: 1246.4,
    imprecise: false,
    latitude: 39.66331,
    longitude: -105.10536,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 34907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80227',
  },
  {
    city: 'Denver',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 1177,
    imprecise: false,
    latitude: 39.69186,
    longitude: -105.15726,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 34942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80228',
  },
  {
    city: 'Denver',
    county_fips: 8001,
    county_fips_all: '08001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"08001": 100}',
    density: 1700.3,
    imprecise: false,
    latitude: 39.85472,
    longitude: -104.95867,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 55092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80229',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031|08005',
    county: 'Denver',
    county_names_all: 'Denver|Arapahoe',
    county_weights: '{"08031": 90.54, "08005": 9.46}',
    density: 1464.5,
    imprecise: false,
    latitude: 39.72032,
    longitude: -104.88933,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80230',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031|08005',
    county: 'Denver',
    county_names_all: 'Denver|Arapahoe',
    county_weights: '{"08031": 58.04, "08005": 41.96}',
    density: 2838,
    imprecise: false,
    latitude: 39.67123,
    longitude: -104.88787,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80231',
  },
  {
    city: 'Denver',
    county_fips: 8059,
    county_fips_all: '08059|08031',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Denver',
    county_weights: '{"08059": 99.29, "08031": 0.71}',
    density: 2291.6,
    imprecise: false,
    latitude: 39.68892,
    longitude: -105.08983,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 23050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80232',
  },
  {
    city: 'Denver',
    county_fips: 8001,
    county_fips_all: '08001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"08001": 100}',
    density: 2046.2,
    imprecise: false,
    latitude: 39.89937,
    longitude: -104.94697,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 48441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80233',
  },
  {
    city: 'Denver',
    county_fips: 8001,
    county_fips_all: '08001|08014',
    county: 'Adams',
    county_names_all: 'Adams|Broomfield',
    county_weights: '{"08001": 97.9, "08014": 2.1}',
    density: 1609.4,
    imprecise: false,
    latitude: 39.91208,
    longitude: -105.00526,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 29356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80234',
  },
  {
    city: 'Denver',
    county_fips: 8059,
    county_fips_all: '08059|08031',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Denver',
    county_weights: '{"08059": 75.04, "08031": 24.96}',
    density: 951.9,
    imprecise: false,
    latitude: 39.64615,
    longitude: -105.08909,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80235',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031|08005',
    county: 'Denver',
    county_names_all: 'Denver|Arapahoe',
    county_weights: '{"08031": 96.39, "08005": 3.61}',
    density: 2027,
    imprecise: false,
    latitude: 39.65169,
    longitude: -105.03966,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80236',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031|08005',
    county: 'Denver',
    county_names_all: 'Denver|Arapahoe',
    county_weights: '{"08031": 99.75, "08005": 0.25}',
    density: 2491.7,
    imprecise: false,
    latitude: 39.63996,
    longitude: -104.90178,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 23384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80237',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 1738,
    imprecise: false,
    latitude: 39.77722,
    longitude: -104.8808,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 30575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80238',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031|08001',
    county: 'Denver',
    county_names_all: 'Denver|Adams',
    county_weights: '{"08031": 79.8, "08001": 20.2}',
    density: 1680,
    imprecise: false,
    latitude: 39.78801,
    longitude: -104.8333,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80239',
  },
  {
    city: 'Thornton',
    county_fips: 8001,
    county_fips_all: '08001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"08001": 100}',
    density: 2001.4,
    imprecise: false,
    latitude: 39.92876,
    longitude: -104.95492,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 34082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80241',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031|08005',
    county: 'Denver',
    county_names_all: 'Denver|Arapahoe',
    county_weights: '{"08031": 65.69, "08005": 34.31}',
    density: 3025.7,
    imprecise: false,
    latitude: 39.70461,
    longitude: -104.9314,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 13097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80246',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031|08005',
    county: 'Denver',
    county_names_all: 'Denver|Arapahoe',
    county_weights: '{"08031": 54.07, "08005": 45.93}',
    density: 3945.2,
    imprecise: false,
    latitude: 39.69684,
    longitude: -104.88127,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 29760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80247',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 336.9,
    imprecise: false,
    latitude: 39.84964,
    longitude: -104.69496,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 41590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80249',
  },
  {
    city: 'Denver',
    county_fips: 8001,
    county_fips_all: '08001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"08001": 100}',
    density: 2810.7,
    imprecise: false,
    latitude: 39.86705,
    longitude: -105.00569,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 34677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80260',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.74248,
    longitude: -104.98548,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80264',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 24321.4,
    imprecise: false,
    latitude: 39.74411,
    longitude: -104.98675,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80290',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.74608,
    longitude: -104.98972,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80293',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.74979,
    longitude: -104.98971,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80294',
  },
  {
    city: 'Boulder',
    county_fips: 8013,
    county_fips_all: '08013',
    county: 'Boulder',
    county_names_all: 'Boulder',
    county_weights: '{"08013": 100}',
    density: 337,
    imprecise: false,
    latitude: 40.04795,
    longitude: -105.19876,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 25007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80301',
  },
  {
    city: 'Boulder',
    county_fips: 8013,
    county_fips_all: '08013',
    county: 'Boulder',
    county_names_all: 'Boulder',
    county_weights: '{"08013": 100}',
    density: 121.6,
    imprecise: false,
    latitude: 40.0306,
    longitude: -105.35542,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 29569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80302',
  },
  {
    city: 'Boulder',
    county_fips: 8013,
    county_fips_all: '08013',
    county: 'Boulder',
    county_names_all: 'Boulder',
    county_weights: '{"08013": 100}',
    density: 441,
    imprecise: false,
    latitude: 39.97422,
    longitude: -105.21206,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 24996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80303',
  },
  {
    city: 'Boulder',
    county_fips: 8013,
    county_fips_all: '08013',
    county: 'Boulder',
    county_names_all: 'Boulder',
    county_weights: '{"08013": 100}',
    density: 1085.7,
    imprecise: false,
    latitude: 40.04557,
    longitude: -105.29006,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 25383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80304',
  },
  {
    city: 'Boulder',
    county_fips: 8013,
    county_fips_all: '08013',
    county: 'Boulder',
    county_names_all: 'Boulder',
    county_weights: '{"08013": 100}',
    density: 1080.7,
    imprecise: false,
    latitude: 39.97733,
    longitude: -105.24877,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80305',
  },
  {
    city: 'Golden',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 344.7,
    imprecise: false,
    latitude: 39.71672,
    longitude: -105.23286,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 43811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80401',
  },
  {
    city: 'Golden',
    county_fips: 8059,
    county_fips_all: '08059|08047|08013',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Gilpin|Boulder',
    county_weights: '{"08059": 82.13, "08047": 12.44, "08013": 5.43}',
    density: 56.4,
    imprecise: false,
    latitude: 39.83229,
    longitude: -105.32013,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 20732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80403',
  },
  {
    city: 'Alma',
    county_fips: 8093,
    county_fips_all: '08093',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"08093": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 39.31451,
    longitude: -106.10553,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80420',
  },
  {
    city: 'Bailey',
    county_fips: 8093,
    county_fips_all: '08093|08059',
    county: 'Park',
    county_names_all: 'Park|Jefferson',
    county_weights: '{"08093": 97.91, "08059": 2.09}',
    density: 31.6,
    imprecise: false,
    latitude: 39.48166,
    longitude: -105.50462,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80421',
  },
  {
    city: 'Black Hawk',
    county_fips: 8047,
    county_fips_all: '08047',
    county: 'Gilpin',
    county_names_all: 'Gilpin',
    county_weights: '{"08047": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 39.8635,
    longitude: -105.53846,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80422',
  },
  {
    city: 'Bond',
    county_fips: 8037,
    county_fips_all: '08037|08049',
    county: 'Eagle',
    county_names_all: 'Eagle|Grand',
    county_weights: '{"08037": 84.94, "08049": 15.06}',
    density: 0.1,
    imprecise: false,
    latitude: 39.84776,
    longitude: -106.55359,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80423',
  },
  {
    city: 'Breckenridge',
    county_fips: 8117,
    county_fips_all: '08117',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"08117": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 39.47089,
    longitude: -106.01685,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80424',
  },
  {
    city: 'Buffalo Creek',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 39.34714,
    longitude: -105.23162,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80425',
  },
  {
    city: 'Burns',
    county_fips: 8037,
    county_fips_all: '08037',
    county: 'Eagle',
    county_names_all: 'Eagle',
    county_weights: '{"08037": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 39.87393,
    longitude: -106.98452,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80426',
  },
  {
    city: 'Central City',
    county_fips: 8047,
    county_fips_all: '08047|08019',
    county: 'Gilpin',
    county_names_all: 'Gilpin|Clear Creek',
    county_weights: '{"08047": 99.9, "08019": 0.1}',
    density: 15.2,
    imprecise: false,
    latitude: 39.79366,
    longitude: -105.52413,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80427',
  },
  {
    city: 'Clark',
    county_fips: 8107,
    county_fips_all: '08107',
    county: 'Routt',
    county_names_all: 'Routt',
    county_weights: '{"08107": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 40.85326,
    longitude: -106.91373,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80428',
  },
  {
    city: 'Coalmont',
    county_fips: 8057,
    county_fips_all: '08057',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"08057": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 40.50925,
    longitude: -106.44688,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80430',
  },
  {
    city: 'Como',
    county_fips: 8093,
    county_fips_all: '08093',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"08093": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 39.22256,
    longitude: -105.82969,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80432',
  },
  {
    city: 'Conifer',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 48.2,
    imprecise: false,
    latitude: 39.49636,
    longitude: -105.29586,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80433',
  },
  {
    city: 'Cowdrey',
    county_fips: 8057,
    county_fips_all: '08057',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"08057": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 40.91209,
    longitude: -106.28228,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80434',
  },
  {
    city: 'Dillon',
    county_fips: 8117,
    county_fips_all: '08117',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"08117": 100}',
    density: 32.3,
    imprecise: false,
    latitude: 39.60161,
    longitude: -105.92452,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80435',
  },
  {
    city: 'Dumont',
    county_fips: 8019,
    county_fips_all: '08019',
    county: 'Clear Creek',
    county_names_all: 'Clear Creek',
    county_weights: '{"08019": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 39.78203,
    longitude: -105.64349,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80436',
  },
  {
    city: 'Empire',
    county_fips: 8019,
    county_fips_all: '08019',
    county: 'Clear Creek',
    county_names_all: 'Clear Creek',
    county_weights: '{"08019": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 39.7602,
    longitude: -105.78356,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80438',
  },
  {
    city: 'Evergreen',
    county_fips: 8019,
    county_fips_all: '08019|08059',
    county: 'Clear Creek',
    county_names_all: 'Clear Creek|Jefferson',
    county_weights: '{"08019": 58.27, "08059": 41.73}',
    density: 56.3,
    imprecise: false,
    latitude: 39.6343,
    longitude: -105.42994,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 24610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80439',
  },
  {
    city: 'Fairplay',
    county_fips: 8093,
    county_fips_all: '08093',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"08093": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 39.13412,
    longitude: -106.04137,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80440',
  },
  {
    city: 'Fraser',
    county_fips: 8049,
    county_fips_all: '08049',
    county: 'Grand',
    county_names_all: 'Grand',
    county_weights: '{"08049": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 39.91633,
    longitude: -105.89813,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80442',
  },
  {
    city: 'Frisco',
    county_fips: 8117,
    county_fips_all: '08117',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"08117": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 39.50165,
    longitude: -106.16673,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80443',
  },
  {
    city: 'Georgetown',
    county_fips: 8019,
    county_fips_all: '08019|08093',
    county: 'Clear Creek',
    county_names_all: 'Clear Creek|Park',
    county_weights: '{"08019": 99.87, "08093": 0.13}',
    density: 10.7,
    imprecise: false,
    latitude: 39.63138,
    longitude: -105.73078,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80444',
  },
  {
    city: 'Granby',
    county_fips: 8049,
    county_fips_all: '08049',
    county: 'Grand',
    county_names_all: 'Grand',
    county_weights: '{"08049": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 40.16335,
    longitude: -105.937,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80446',
  },
  {
    city: 'Grand Lake',
    county_fips: 8049,
    county_fips_all: '08049',
    county: 'Grand',
    county_names_all: 'Grand',
    county_weights: '{"08049": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 40.30116,
    longitude: -105.81712,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80447',
  },
  {
    city: 'Grant',
    county_fips: 8093,
    county_fips_all: '08093',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"08093": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.41769,
    longitude: -105.63747,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80448',
  },
  {
    city: 'Hartsel',
    county_fips: 8093,
    county_fips_all: '08093|08015',
    county: 'Park',
    county_names_all: 'Park|Chaffee',
    county_weights: '{"08093": 97.52, "08015": 2.48}',
    density: 0.8,
    imprecise: false,
    latitude: 38.93059,
    longitude: -105.79169,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80449',
  },
  {
    city: 'Hot Sulphur Springs',
    county_fips: 8049,
    county_fips_all: '08049',
    county: 'Grand',
    county_names_all: 'Grand',
    county_weights: '{"08049": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 40.04007,
    longitude: -106.04456,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80451',
  },
  {
    city: 'Idaho Springs',
    county_fips: 8019,
    county_fips_all: '08019|08047',
    county: 'Clear Creek',
    county_names_all: 'Clear Creek|Gilpin',
    county_weights: '{"08019": 98.1, "08047": 1.9}',
    density: 9.3,
    imprecise: false,
    latitude: 39.70969,
    longitude: -105.59515,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80452',
  },
  {
    city: 'Idledale',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 217.5,
    imprecise: false,
    latitude: 39.66477,
    longitude: -105.24285,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80453',
  },
  {
    city: 'Indian Hills',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 75.6,
    imprecise: false,
    latitude: 39.63109,
    longitude: -105.25204,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 986,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80454',
  },
  {
    city: 'Jamestown',
    county_fips: 8013,
    county_fips_all: '08013',
    county: 'Boulder',
    county_names_all: 'Boulder',
    county_weights: '{"08013": 100}',
    density: 6,
    imprecise: false,
    latitude: 40.11071,
    longitude: -105.39071,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80455',
  },
  {
    city: 'Jefferson',
    county_fips: 8093,
    county_fips_all: '08093',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"08093": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 39.30643,
    longitude: -105.69211,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80456',
  },
  {
    city: 'Kittredge',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 177.7,
    imprecise: false,
    latitude: 39.65091,
    longitude: -105.29972,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80457',
  },
  {
    city: 'Kremmling',
    county_fips: 8049,
    county_fips_all: '08049',
    county: 'Grand',
    county_names_all: 'Grand',
    county_weights: '{"08049": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 40.1843,
    longitude: -106.41877,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80459',
  },
  {
    city: 'Leadville',
    county_fips: 8065,
    county_fips_all: '08065',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"08065": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 39.24244,
    longitude: -106.29016,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80461',
  },
  {
    city: 'McCoy',
    county_fips: 8107,
    county_fips_all: '08107|08037',
    county: 'Routt',
    county_names_all: 'Routt|Eagle',
    county_weights: '{"08107": 75.62, "08037": 24.38}',
    density: 0.3,
    imprecise: false,
    latitude: 39.95523,
    longitude: -106.73888,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80463',
  },
  {
    city: 'Morrison',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 147.5,
    imprecise: false,
    latitude: 39.60437,
    longitude: -105.21521,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80465',
  },
  {
    city: 'Nederland',
    county_fips: 8013,
    county_fips_all: '08013',
    county: 'Boulder',
    county_names_all: 'Boulder',
    county_weights: '{"08013": 100}',
    density: 12,
    imprecise: false,
    latitude: 39.99008,
    longitude: -105.546,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80466',
  },
  {
    city: 'Oak Creek',
    county_fips: 8107,
    county_fips_all: '08107|08103',
    county: 'Routt',
    county_names_all: 'Routt|Rio Blanco',
    county_weights: '{"08107": 93.58, "08103": 6.42}',
    density: 3.1,
    imprecise: false,
    latitude: 40.25692,
    longitude: -106.87326,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80467',
  },
  {
    city: 'Parshall',
    county_fips: 8049,
    county_fips_all: '08049',
    county: 'Grand',
    county_names_all: 'Grand',
    county_weights: '{"08049": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 39.91447,
    longitude: -106.10979,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80468',
  },
  {
    city: 'Phippsburg',
    county_fips: 8107,
    county_fips_all: '08107',
    county: 'Routt',
    county_names_all: 'Routt',
    county_weights: '{"08107": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 40.21448,
    longitude: -106.96797,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80469',
  },
  {
    city: 'Pine',
    county_fips: 8059,
    county_fips_all: '08059|08093',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Park',
    county_weights: '{"08059": 81.35, "08093": 18.65}',
    density: 13.6,
    imprecise: false,
    latitude: 39.40104,
    longitude: -105.34527,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80470',
  },
  {
    city: 'Pinecliffe',
    county_fips: 8013,
    county_fips_all: '08013|08047',
    county: 'Boulder',
    county_names_all: 'Boulder|Gilpin',
    county_weights: '{"08013": 99.63, "08047": 0.37}',
    density: 0,
    imprecise: false,
    latitude: 39.93507,
    longitude: -105.42048,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80471',
  },
  {
    city: 'Rand',
    county_fips: 8057,
    county_fips_all: '08057',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"08057": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 40.45096,
    longitude: -106.1555,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80473',
  },
  {
    city: 'Rollinsville',
    county_fips: 8047,
    county_fips_all: '08047',
    county: 'Gilpin',
    county_names_all: 'Gilpin',
    county_weights: '{"08047": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 39.92353,
    longitude: -105.56404,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80474',
  },
  {
    city: 'Shawnee',
    county_fips: 8093,
    county_fips_all: '08093',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"08093": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 39.43012,
    longitude: -105.59234,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80475',
  },
  {
    city: 'Silver Plume',
    county_fips: 8019,
    county_fips_all: '08019',
    county: 'Clear Creek',
    county_names_all: 'Clear Creek',
    county_weights: '{"08019": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 39.68522,
    longitude: -105.80972,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80476',
  },
  {
    city: 'Tabernash',
    county_fips: 8049,
    county_fips_all: '08049',
    county: 'Grand',
    county_names_all: 'Grand',
    county_weights: '{"08049": 100}',
    density: 14.7,
    imprecise: false,
    latitude: 40.02218,
    longitude: -105.85693,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80478',
  },
  {
    city: 'Toponas',
    county_fips: 8107,
    county_fips_all: '08107',
    county: 'Routt',
    county_names_all: 'Routt',
    county_weights: '{"08107": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 40.02078,
    longitude: -106.86356,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80479',
  },
  {
    city: 'Walden',
    county_fips: 8057,
    county_fips_all: '08057',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"08057": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 40.67188,
    longitude: -106.34175,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80480',
  },
  {
    city: 'Ward',
    county_fips: 8013,
    county_fips_all: '08013',
    county: 'Boulder',
    county_names_all: 'Boulder',
    county_weights: '{"08013": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 40.10351,
    longitude: -105.52253,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80481',
  },
  {
    city: 'Winter Park',
    county_fips: 8049,
    county_fips_all: '08049',
    county: 'Grand',
    county_names_all: 'Grand',
    county_weights: '{"08049": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 39.90429,
    longitude: -105.78404,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80482',
  },
  {
    city: 'Yampa',
    county_fips: 8107,
    county_fips_all: '08107',
    county: 'Routt',
    county_names_all: 'Routt',
    county_weights: '{"08107": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 40.12482,
    longitude: -106.92124,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80483',
  },
  {
    city: 'Steamboat Springs',
    county_fips: 8107,
    county_fips_all: '08107',
    county: 'Routt',
    county_names_all: 'Routt',
    county_weights: '{"08107": 100}',
    density: 9,
    imprecise: false,
    latitude: 40.58803,
    longitude: -106.89321,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80487',
  },
  {
    city: 'Silverthorne',
    county_fips: 8117,
    county_fips_all: '08117|08049',
    county: 'Summit',
    county_names_all: 'Summit|Grand',
    county_weights: '{"08117": 93.82, "08049": 6.18}',
    density: 11.6,
    imprecise: false,
    latitude: 39.7794,
    longitude: -106.22338,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80498',
  },
  {
    city: 'Longmont',
    county_fips: 8013,
    county_fips_all: '08013',
    county: 'Boulder',
    county_names_all: 'Boulder',
    county_weights: '{"08013": 100}',
    density: 1350.9,
    imprecise: false,
    latitude: 40.16479,
    longitude: -105.10208,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80501',
  },
  {
    city: 'Longmont',
    county_fips: 8013,
    county_fips_all: '08013|08069',
    county: 'Boulder',
    county_names_all: 'Boulder|Larimer',
    county_weights: '{"08013": 98.01, "08069": 1.99}',
    density: 150.9,
    imprecise: false,
    latitude: 40.16922,
    longitude: -105.20725,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80503',
  },
  {
    city: 'Longmont',
    county_fips: 8123,
    county_fips_all: '08123|08013|08069',
    county: 'Weld',
    county_names_all: 'Weld|Boulder|Larimer',
    county_weights: '{"08123": 58.58, "08013": 40.81, "08069": 0.61}',
    density: 259.1,
    imprecise: false,
    latitude: 40.16523,
    longitude: -105.03029,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 63451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80504',
  },
  {
    city: 'Allenspark',
    county_fips: 8013,
    county_fips_all: '08013',
    county: 'Boulder',
    county_names_all: 'Boulder',
    county_weights: '{"08013": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 40.20964,
    longitude: -105.57878,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80510',
  },
  {
    city: 'Bellvue',
    county_fips: 8069,
    county_fips_all: '08069',
    county: 'Larimer',
    county_names_all: 'Larimer',
    county_weights: '{"08069": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 40.62989,
    longitude: -105.56828,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80512',
  },
  {
    city: 'Berthoud',
    county_fips: 8069,
    county_fips_all: '08069|08123|08013',
    county: 'Larimer',
    county_names_all: 'Larimer|Weld|Boulder',
    county_weights: '{"08069": 65.51, "08123": 29.5, "08013": 4.99}',
    density: 98.8,
    imprecise: false,
    latitude: 40.29789,
    longitude: -105.10913,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80513',
  },
  {
    city: 'Dacono',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 281.6,
    imprecise: false,
    latitude: 40.07152,
    longitude: -104.95401,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80514',
  },
  {
    city: 'Drake',
    county_fips: 8069,
    county_fips_all: '08069',
    county: 'Larimer',
    county_names_all: 'Larimer',
    county_weights: '{"08069": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 40.45659,
    longitude: -105.37726,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80515',
  },
  {
    city: 'Erie',
    county_fips: 8123,
    county_fips_all: '08123|08013|08014',
    county: 'Weld',
    county_names_all: 'Weld|Boulder|Broomfield',
    county_weights: '{"08123": 76.27, "08013": 14.46, "08014": 9.27}',
    density: 372.7,
    imprecise: false,
    latitude: 40.05333,
    longitude: -105.01869,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 39048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80516',
  },
  {
    city: 'Estes Park',
    county_fips: 8069,
    county_fips_all: '08069',
    county: 'Larimer',
    county_names_all: 'Larimer',
    county_weights: '{"08069": 100}',
    density: 12.5,
    imprecise: false,
    latitude: 40.39731,
    longitude: -105.61165,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80517',
  },
  {
    city: 'Firestone',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 747.4,
    imprecise: false,
    latitude: 40.11387,
    longitude: -104.93347,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80520',
  },
  {
    city: 'Fort Collins',
    county_fips: 8069,
    county_fips_all: '08069',
    county: 'Larimer',
    county_names_all: 'Larimer',
    county_weights: '{"08069": 100}',
    density: 1067.9,
    imprecise: false,
    latitude: 40.59372,
    longitude: -105.1268,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 38776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80521',
  },
  {
    city: 'Fort Collins',
    county_fips: 8069,
    county_fips_all: '08069|08123',
    county: 'Larimer',
    county_names_all: 'Larimer|Weld',
    county_weights: '{"08069": 77.17, "08123": 22.83}',
    density: 126,
    imprecise: false,
    latitude: 40.64814,
    longitude: -105.02155,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 40030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80524',
  },
  {
    city: 'Fort Collins',
    county_fips: 8069,
    county_fips_all: '08069',
    county: 'Larimer',
    county_names_all: 'Larimer',
    county_weights: '{"08069": 100}',
    density: 896.1,
    imprecise: false,
    latitude: 40.52795,
    longitude: -105.04249,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 54211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80525',
  },
  {
    city: 'Fort Collins',
    county_fips: 8069,
    county_fips_all: '08069',
    county: 'Larimer',
    county_names_all: 'Larimer',
    county_weights: '{"08069": 100}',
    density: 535.3,
    imprecise: false,
    latitude: 40.5174,
    longitude: -105.13262,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80526',
  },
  {
    city: 'Fort Collins',
    county_fips: 8069,
    county_fips_all: '08069',
    county: 'Larimer',
    county_names_all: 'Larimer',
    county_weights: '{"08069": 100}',
    density: 521.8,
    imprecise: false,
    latitude: 40.49343,
    longitude: -105.00075,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 24960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80528',
  },
  {
    city: 'Frederick',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 773.6,
    imprecise: false,
    latitude: 40.10153,
    longitude: -104.92302,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80530',
  },
  {
    city: 'Glen Haven',
    county_fips: 8069,
    county_fips_all: '08069',
    county: 'Larimer',
    county_names_all: 'Larimer',
    county_weights: '{"08069": 100}',
    density: 2,
    imprecise: false,
    latitude: 40.4775,
    longitude: -105.46048,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80532',
  },
  {
    city: 'Johnstown',
    county_fips: 8123,
    county_fips_all: '08123|08069',
    county: 'Weld',
    county_names_all: 'Weld|Larimer',
    county_weights: '{"08123": 80.58, "08069": 19.42}',
    density: 164.7,
    imprecise: false,
    latitude: 40.33192,
    longitude: -104.93522,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 20502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80534',
  },
  {
    city: 'Laporte',
    county_fips: 8069,
    county_fips_all: '08069',
    county: 'Larimer',
    county_names_all: 'Larimer',
    county_weights: '{"08069": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 40.73718,
    longitude: -105.19292,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80535',
  },
  {
    city: 'Livermore',
    county_fips: 8069,
    county_fips_all: '08069',
    county: 'Larimer',
    county_names_all: 'Larimer',
    county_weights: '{"08069": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 40.87458,
    longitude: -105.38842,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80536',
  },
  {
    city: 'Loveland',
    county_fips: 8069,
    county_fips_all: '08069|08123',
    county: 'Larimer',
    county_names_all: 'Larimer|Weld',
    county_weights: '{"08069": 97.28, "08123": 2.72}',
    density: 140.1,
    imprecise: false,
    latitude: 40.38304,
    longitude: -105.20277,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80537',
  },
  {
    city: 'Loveland',
    county_fips: 8069,
    county_fips_all: '08069',
    county: 'Larimer',
    county_names_all: 'Larimer',
    county_weights: '{"08069": 100}',
    density: 189.4,
    imprecise: false,
    latitude: 40.48174,
    longitude: -105.16825,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 50110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80538',
  },
  {
    city: 'Lyons',
    county_fips: 8013,
    county_fips_all: '08013|08069',
    county: 'Boulder',
    county_names_all: 'Boulder|Larimer',
    county_weights: '{"08013": 65.41, "08069": 34.59}',
    density: 11.7,
    imprecise: false,
    latitude: 40.23186,
    longitude: -105.39341,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80540',
  },
  {
    city: 'Mead',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 216.3,
    imprecise: false,
    latitude: 40.23431,
    longitude: -104.99882,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80542',
  },
  {
    city: 'Milliken',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 122.1,
    imprecise: false,
    latitude: 40.34645,
    longitude: -104.8532,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80543',
  },
  {
    city: 'Niwot',
    county_fips: 8013,
    county_fips_all: '08013',
    county: 'Boulder',
    county_names_all: 'Boulder',
    county_weights: '{"08013": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.10305,
    longitude: -105.17178,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80544',
  },
  {
    city: 'Red Feather Lakes',
    county_fips: 8069,
    county_fips_all: '08069',
    county: 'Larimer',
    county_names_all: 'Larimer',
    county_weights: '{"08069": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 40.85911,
    longitude: -105.69644,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80545',
  },
  {
    city: 'Severance',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 935.8,
    imprecise: false,
    latitude: 40.52415,
    longitude: -104.84986,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80546',
  },
  {
    city: 'Timnath',
    county_fips: 8069,
    county_fips_all: '08069',
    county: 'Larimer',
    county_names_all: 'Larimer',
    county_weights: '{"08069": 100}',
    density: 600.9,
    imprecise: false,
    latitude: 40.52948,
    longitude: -104.96347,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80547',
  },
  {
    city: 'Wellington',
    county_fips: 8069,
    county_fips_all: '08069|08123',
    county: 'Larimer',
    county_names_all: 'Larimer|Weld',
    county_weights: '{"08069": 94.93, "08123": 5.07}',
    density: 29.6,
    imprecise: false,
    latitude: 40.84341,
    longitude: -105.05499,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 14325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80549',
  },
  {
    city: 'Windsor',
    county_fips: 8123,
    county_fips_all: '08123|08069',
    county: 'Weld',
    county_names_all: 'Weld|Larimer',
    county_weights: '{"08123": 91.04, "08069": 8.96}',
    density: 342.1,
    imprecise: false,
    latitude: 40.48213,
    longitude: -104.90223,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 46456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80550',
  },
  {
    city: 'Brighton',
    county_fips: 8001,
    county_fips_all: '08001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"08001": 100}',
    density: 621,
    imprecise: false,
    latitude: 39.96288,
    longitude: -104.80777,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 42127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80601',
  },
  {
    city: 'Brighton',
    county_fips: 8001,
    county_fips_all: '08001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"08001": 100}',
    density: 562.5,
    imprecise: false,
    latitude: 39.96369,
    longitude: -104.90661,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80602',
  },
  {
    city: 'Brighton',
    county_fips: 8001,
    county_fips_all: '08001|08123',
    county: 'Adams',
    county_names_all: 'Adams|Weld',
    county_weights: '{"08001": 56.13, "08123": 43.87}',
    density: 87.6,
    imprecise: false,
    latitude: 39.9845,
    longitude: -104.74539,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80603',
  },
  {
    city: 'Ault',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 40.66996,
    longitude: -104.58269,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80610',
  },
  {
    city: 'Briggsdale',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 40.62015,
    longitude: -104.24964,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80611',
  },
  {
    city: 'Carr',
    county_fips: 8123,
    county_fips_all: '08123|08069',
    county: 'Weld',
    county_names_all: 'Weld|Larimer',
    county_weights: '{"08123": 84.82, "08069": 15.18}',
    density: 0.7,
    imprecise: false,
    latitude: 40.89924,
    longitude: -104.82287,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80612',
  },
  {
    city: 'Eaton',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 33,
    imprecise: false,
    latitude: 40.5444,
    longitude: -104.64236,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80615',
  },
  {
    city: 'Evans',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 1356.5,
    imprecise: false,
    latitude: 40.37425,
    longitude: -104.71337,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 20798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80620',
  },
  {
    city: 'Fort Lupton',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 45.9,
    imprecise: false,
    latitude: 40.10732,
    longitude: -104.79841,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80621',
  },
  {
    city: 'Galeton',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 40.54235,
    longitude: -104.44732,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80622',
  },
  {
    city: 'Gilcrest',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 591.5,
    imprecise: false,
    latitude: 40.28531,
    longitude: -104.78253,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80623',
  },
  {
    city: 'Gill',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 40.45683,
    longitude: -104.45635,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80624',
  },
  {
    city: 'Greeley',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 200.2,
    imprecise: false,
    latitude: 40.44216,
    longitude: -104.67809,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 53722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80631',
  },
  {
    city: 'Greeley',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 661.3,
    imprecise: false,
    latitude: 40.40075,
    longitude: -104.79222,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 65622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80634',
  },
  {
    city: 'Henderson',
    county_fips: 8001,
    county_fips_all: '08001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"08001": 100}',
    density: 410.1,
    imprecise: false,
    latitude: 39.88536,
    longitude: -104.88202,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 13818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80640',
  },
  {
    city: 'Hudson',
    county_fips: 8123,
    county_fips_all: '08123|08001',
    county: 'Weld',
    county_names_all: 'Weld|Adams',
    county_weights: '{"08123": 70.38, "08001": 29.62}',
    density: 17.4,
    imprecise: false,
    latitude: 40.05353,
    longitude: -104.61565,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80642',
  },
  {
    city: 'Keenesburg',
    county_fips: 8123,
    county_fips_all: '08123|08001',
    county: 'Weld',
    county_names_all: 'Weld|Adams',
    county_weights: '{"08123": 88.68, "08001": 11.32}',
    density: 9.1,
    imprecise: false,
    latitude: 40.11186,
    longitude: -104.47164,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80643',
  },
  {
    city: 'Kersey',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 40.3371,
    longitude: -104.43866,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80644',
  },
  {
    city: 'La Salle',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 40.28409,
    longitude: -104.64731,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80645',
  },
  {
    city: 'Lucerne',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.47537,
    longitude: -104.69761,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80646',
  },
  {
    city: 'Nunn',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 40.76559,
    longitude: -104.72816,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80648',
  },
  {
    city: 'Orchard',
    county_fips: 8123,
    county_fips_all: '08123|08087',
    county: 'Weld',
    county_names_all: 'Weld|Morgan',
    county_weights: '{"08123": 65.66, "08087": 34.34}',
    density: 0.6,
    imprecise: false,
    latitude: 40.37924,
    longitude: -104.17595,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80649',
  },
  {
    city: 'Pierce',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 15,
    imprecise: false,
    latitude: 40.6484,
    longitude: -104.77666,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80650',
  },
  {
    city: 'Platteville',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 19.7,
    imprecise: false,
    latitude: 40.23717,
    longitude: -104.81409,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80651',
  },
  {
    city: 'Roggen',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 40.11048,
    longitude: -104.2751,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80652',
  },
  {
    city: 'Weldona',
    county_fips: 8087,
    county_fips_all: '08087',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"08087": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 40.3931,
    longitude: -103.97685,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80653',
  },
  {
    city: 'Wiggins',
    county_fips: 8087,
    county_fips_all: '08087|08001|08123',
    county: 'Morgan',
    county_names_all: 'Morgan|Adams|Weld',
    county_weights: '{"08087": 83.16, "08001": 9.11, "08123": 7.73}',
    density: 6,
    imprecise: false,
    latitude: 40.13501,
    longitude: -104.07642,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80654',
  },
  {
    city: 'Fort Morgan',
    county_fips: 8087,
    county_fips_all: '08087|08001',
    county: 'Morgan',
    county_names_all: 'Morgan|Adams',
    county_weights: '{"08087": 74.23, "08001": 25.77}',
    density: 10.2,
    imprecise: false,
    latitude: 40.13494,
    longitude: -103.81102,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80701',
  },
  {
    city: 'Log Lane Village',
    county_fips: 8087,
    county_fips_all: '08087',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"08087": 100}',
    density: 1283.3,
    imprecise: false,
    latitude: 40.27116,
    longitude: -103.83428,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80705',
  },
  {
    city: 'Akron',
    county_fips: 8121,
    county_fips_all: '08121',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"08121": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 40.07457,
    longitude: -103.18878,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80720',
  },
  {
    city: 'Amherst',
    county_fips: 8095,
    county_fips_all: '08095',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"08095": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 40.68821,
    longitude: -102.15297,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80721',
  },
  {
    city: 'Atwood',
    county_fips: 8075,
    county_fips_all: '08075',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"08075": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 40.49515,
    longitude: -103.23833,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80722',
  },
  {
    city: 'Brush',
    county_fips: 8087,
    county_fips_all: '08087|08121',
    county: 'Morgan',
    county_names_all: 'Morgan|Washington',
    county_weights: '{"08087": 83.51, "08121": 16.49}',
    density: 10,
    imprecise: false,
    latitude: 40.15981,
    longitude: -103.55046,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80723',
  },
  {
    city: 'Crook',
    county_fips: 8075,
    county_fips_all: '08075',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"08075": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 40.91044,
    longitude: -102.7773,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80726',
  },
  {
    city: 'Eckley',
    county_fips: 8125,
    county_fips_all: '08125',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"08125": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 40.02185,
    longitude: -102.51484,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80727',
  },
  {
    city: 'Fleming',
    county_fips: 8075,
    county_fips_all: '08075',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"08075": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 40.64,
    longitude: -102.87285,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80728',
  },
  {
    city: 'Grover',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 40.87439,
    longitude: -104.22632,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80729',
  },
  {
    city: 'Haxtun',
    county_fips: 8095,
    county_fips_all: '08095|08075|08125|08115',
    county: 'Phillips',
    county_names_all: 'Phillips|Logan|Yuma|Sedgwick',
    county_weights:
      '{"08095": 59.86, "08075": 28.3, "08125": 9.47, "08115": 2.37}',
    density: 1.5,
    imprecise: false,
    latitude: 40.58734,
    longitude: -102.60558,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80731',
  },
  {
    city: 'Hereford',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 40.9884,
    longitude: -104.30525,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80732',
  },
  {
    city: 'Hillrose',
    county_fips: 8087,
    county_fips_all: '08087|08121',
    county: 'Morgan',
    county_names_all: 'Morgan|Washington',
    county_weights: '{"08087": 60.28, "08121": 39.72}',
    density: 10.3,
    imprecise: false,
    latitude: 40.35695,
    longitude: -103.47989,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80733',
  },
  {
    city: 'Holyoke',
    county_fips: 8095,
    county_fips_all: '08095|08125',
    county: 'Phillips',
    county_names_all: 'Phillips|Yuma',
    county_weights: '{"08095": 77.07, "08125": 22.93}',
    density: 2.4,
    imprecise: false,
    latitude: 40.52472,
    longitude: -102.29259,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80734',
  },
  {
    city: 'Idalia',
    county_fips: 8125,
    county_fips_all: '08125',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"08125": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 39.71549,
    longitude: -102.25029,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80735',
  },
  {
    city: 'Iliff',
    county_fips: 8075,
    county_fips_all: '08075',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"08075": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 40.81635,
    longitude: -103.01907,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80736',
  },
  {
    city: 'Julesburg',
    county_fips: 8115,
    county_fips_all: '08115|31049',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick|Deuel',
    county_weights: '{"08115": 96.16, "31049": 3.84}',
    density: 2.2,
    imprecise: false,
    latitude: 40.88974,
    longitude: -102.19267,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80737',
  },
  {
    city: 'Lindon',
    county_fips: 8121,
    county_fips_all: '08121',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"08121": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 39.74256,
    longitude: -103.38744,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80740',
  },
  {
    city: 'Merino',
    county_fips: 8075,
    county_fips_all: '08075|08087|08121',
    county: 'Logan',
    county_names_all: 'Logan|Morgan|Washington',
    county_weights: '{"08075": 76.98, "08087": 14.38, "08121": 8.64}',
    density: 1.6,
    imprecise: false,
    latitude: 40.5598,
    longitude: -103.47339,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80741',
  },
  {
    city: 'New Raymer',
    county_fips: 8123,
    county_fips_all: '08123|08087',
    county: 'Weld',
    county_names_all: 'Weld|Morgan',
    county_weights: '{"08123": 92.74, "08087": 7.26}',
    density: 0.2,
    imprecise: false,
    latitude: 40.74855,
    longitude: -103.81371,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80742',
  },
  {
    city: 'Otis',
    county_fips: 8121,
    county_fips_all: '08121',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"08121": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 40.21588,
    longitude: -102.95679,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80743',
  },
  {
    city: 'Ovid',
    county_fips: 8115,
    county_fips_all: '08115',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"08115": 100}',
    density: 2,
    imprecise: false,
    latitude: 40.87471,
    longitude: -102.38355,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80744',
  },
  {
    city: 'Padroni',
    county_fips: 8075,
    county_fips_all: '08075',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"08075": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 40.88801,
    longitude: -103.40077,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80745',
  },
  {
    city: 'Paoli',
    county_fips: 8095,
    county_fips_all: '08095',
    county: 'Phillips',
    county_names_all: 'Phillips',
    county_weights: '{"08095": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 40.60706,
    longitude: -102.45695,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80746',
  },
  {
    city: 'Peetz',
    county_fips: 8075,
    county_fips_all: '08075',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"08075": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 40.94709,
    longitude: -103.16392,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80747',
  },
  {
    city: 'Sedgwick',
    county_fips: 8115,
    county_fips_all: '08115',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"08115": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 40.87574,
    longitude: -102.55354,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80749',
  },
  {
    city: 'Snyder',
    county_fips: 8087,
    county_fips_all: '08087',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"08087": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 40.41144,
    longitude: -103.60681,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80750',
  },
  {
    city: 'Sterling',
    county_fips: 8075,
    county_fips_all: '08075',
    county: 'Logan',
    county_names_all: 'Logan',
    county_weights: '{"08075": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 40.65263,
    longitude: -103.24504,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80751',
  },
  {
    city: 'Stoneham',
    county_fips: 8123,
    county_fips_all: '08123',
    county: 'Weld',
    county_names_all: 'Weld',
    county_weights: '{"08123": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 40.69052,
    longitude: -103.64694,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80754',
  },
  {
    city: 'Vernon',
    county_fips: 8125,
    county_fips_all: '08125',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"08125": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 39.89966,
    longitude: -102.35155,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80755',
  },
  {
    city: 'Woodrow',
    county_fips: 8121,
    county_fips_all: '08121',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"08121": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 39.79244,
    longitude: -103.58588,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80757',
  },
  {
    city: 'Wray',
    county_fips: 8125,
    county_fips_all: '08125',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"08125": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 40.11998,
    longitude: -102.2122,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80758',
  },
  {
    city: 'Yuma',
    county_fips: 8125,
    county_fips_all: '08125|08121',
    county: 'Yuma',
    county_names_all: 'Yuma|Washington',
    county_weights: '{"08125": 92.07, "08121": 7.93}',
    density: 3,
    imprecise: false,
    latitude: 40.10892,
    longitude: -102.68759,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80759',
  },
  {
    city: 'Anton',
    county_fips: 8121,
    county_fips_all: '08121',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"08121": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 39.73943,
    longitude: -103.11354,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80801',
  },
  {
    city: 'Arapahoe',
    county_fips: 8017,
    county_fips_all: '08017',
    county: 'Cheyenne',
    county_names_all: 'Cheyenne',
    county_weights: '{"08017": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 38.84317,
    longitude: -102.16393,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80802',
  },
  {
    city: 'Arriba',
    county_fips: 8073,
    county_fips_all: '08073',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"08073": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 39.35644,
    longitude: -103.26331,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80804',
  },
  {
    city: 'Bethune',
    county_fips: 8063,
    county_fips_all: '08063',
    county: 'Kit Carson',
    county_names_all: 'Kit Carson',
    county_weights: '{"08063": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 39.29378,
    longitude: -102.44923,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80805',
  },
  {
    city: 'Burlington',
    county_fips: 8063,
    county_fips_all: '08063|08125',
    county: 'Kit Carson',
    county_names_all: 'Kit Carson|Yuma',
    county_weights: '{"08063": 94.53, "08125": 5.47}',
    density: 2.2,
    imprecise: false,
    latitude: 39.31575,
    longitude: -102.23303,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80807',
  },
  {
    city: 'Calhan',
    county_fips: 8041,
    county_fips_all: '08041|08039',
    county: 'El Paso',
    county_names_all: 'El Paso|Elbert',
    county_weights: '{"08041": 83.69, "08039": 16.31}',
    density: 6.4,
    imprecise: false,
    latitude: 39.00043,
    longitude: -104.30638,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80808',
  },
  {
    city: 'Cascade',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 38.86503,
    longitude: -104.99733,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80809',
  },
  {
    city: 'Cheyenne Wells',
    county_fips: 8017,
    county_fips_all: '08017',
    county: 'Cheyenne',
    county_names_all: 'Cheyenne',
    county_weights: '{"08017": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 38.82589,
    longitude: -102.4454,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80810',
  },
  {
    city: 'Cope',
    county_fips: 8121,
    county_fips_all: '08121|08125',
    county: 'Washington',
    county_names_all: 'Washington|Yuma',
    county_weights: '{"08121": 95.54, "08125": 4.46}',
    density: 0.8,
    imprecise: false,
    latitude: 39.67901,
    longitude: -102.89161,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80812',
  },
  {
    city: 'Cripple Creek',
    county_fips: 8119,
    county_fips_all: '08119',
    county: 'Teller',
    county_names_all: 'Teller',
    county_weights: '{"08119": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 38.76307,
    longitude: -105.09278,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80813',
  },
  {
    city: 'Divide',
    county_fips: 8119,
    county_fips_all: '08119',
    county: 'Teller',
    county_names_all: 'Teller',
    county_weights: '{"08119": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 38.94731,
    longitude: -105.17604,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80814',
  },
  {
    city: 'Flagler',
    county_fips: 8063,
    county_fips_all: '08063|08121',
    county: 'Kit Carson',
    county_names_all: 'Kit Carson|Washington',
    county_weights: '{"08063": 73.08, "08121": 26.92}',
    density: 0.7,
    imprecise: false,
    latitude: 39.40174,
    longitude: -103.08191,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80815',
  },
  {
    city: 'Florissant',
    county_fips: 8119,
    county_fips_all: '08119|08093',
    county: 'Teller',
    county_names_all: 'Teller|Park',
    county_weights: '{"08119": 62.65, "08093": 37.35}',
    density: 13.2,
    imprecise: false,
    latitude: 38.85162,
    longitude: -105.31591,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80816',
  },
  {
    city: 'Fountain',
    county_fips: 8041,
    county_fips_all: '08041|08101',
    county: 'El Paso',
    county_names_all: 'El Paso|Pueblo',
    county_weights: '{"08041": 76.48, "08101": 23.52}',
    density: 104.8,
    imprecise: false,
    latitude: 38.58347,
    longitude: -104.67412,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 31241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80817',
  },
  {
    city: 'Genoa',
    county_fips: 8073,
    county_fips_all: '08073|08121',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Washington',
    county_weights: '{"08073": 87.22, "08121": 12.78}',
    density: 0.4,
    imprecise: false,
    latitude: 39.41539,
    longitude: -103.48119,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80818',
  },
  {
    city: 'Green Mountain Falls',
    county_fips: 8041,
    county_fips_all: '08041|08119',
    county: 'El Paso',
    county_names_all: 'El Paso|Teller',
    county_weights: '{"08041": 93.68, "08119": 6.32}',
    density: 42.4,
    imprecise: false,
    latitude: 38.94076,
    longitude: -105.00249,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80819',
  },
  {
    city: 'Guffey',
    county_fips: 8093,
    county_fips_all: '08093',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"08093": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 38.77781,
    longitude: -105.56613,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80820',
  },
  {
    city: 'Hugo',
    county_fips: 8073,
    county_fips_all: '08073',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"08073": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 38.97366,
    longitude: -103.43248,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80821',
  },
  {
    city: 'Joes',
    county_fips: 8125,
    county_fips_all: '08125',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"08125": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 39.67088,
    longitude: -102.67815,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80822',
  },
  {
    city: 'Karval',
    county_fips: 8073,
    county_fips_all: '08073',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"08073": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 38.69026,
    longitude: -103.46738,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80823',
  },
  {
    city: 'Kirk',
    county_fips: 8125,
    county_fips_all: '08125',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"08125": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 39.66302,
    longitude: -102.49943,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80824',
  },
  {
    city: 'Kit Carson',
    county_fips: 8017,
    county_fips_all: '08017',
    county: 'Cheyenne',
    county_names_all: 'Cheyenne',
    county_weights: '{"08017": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 38.81864,
    longitude: -102.80624,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80825',
  },
  {
    city: 'Lake George',
    county_fips: 8093,
    county_fips_all: '08093|08119',
    county: 'Park',
    county_names_all: 'Park|Teller',
    county_weights: '{"08093": 87.73, "08119": 12.27}',
    density: 1.1,
    imprecise: false,
    latitude: 39.05821,
    longitude: -105.46272,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80827',
  },
  {
    city: 'Limon',
    county_fips: 8073,
    county_fips_all: '08073|08039',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Elbert',
    county_weights: '{"08073": 53.55, "08039": 46.45}',
    density: 2.1,
    imprecise: false,
    latitude: 39.26643,
    longitude: -103.70983,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80828',
  },
  {
    city: 'Manitou Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 102,
    imprecise: false,
    latitude: 38.82922,
    longitude: -104.93289,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80829',
  },
  {
    city: 'Matheson',
    county_fips: 8039,
    county_fips_all: '08039',
    county: 'Elbert',
    county_names_all: 'Elbert',
    county_weights: '{"08039": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 39.11313,
    longitude: -103.91139,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80830',
  },
  {
    city: 'Peyton',
    county_fips: 8041,
    county_fips_all: '08041|08039',
    county: 'El Paso',
    county_names_all: 'El Paso|Elbert',
    county_weights: '{"08041": 94.85, "08039": 5.15}',
    density: 69.4,
    imprecise: false,
    latitude: 38.98867,
    longitude: -104.51172,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 33912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80831',
  },
  {
    city: 'Ramah',
    county_fips: 8039,
    county_fips_all: '08039|08041|08073',
    county: 'Elbert',
    county_names_all: 'Elbert|El Paso|Lincoln',
    county_weights: '{"08039": 80.85, "08041": 14.45, "08073": 4.7}',
    density: 1.3,
    imprecise: false,
    latitude: 39.06344,
    longitude: -104.02769,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80832',
  },
  {
    city: 'Rush',
    county_fips: 8073,
    county_fips_all: '08073|08041|08039',
    county: 'Lincoln',
    county_names_all: 'Lincoln|El Paso|Elbert',
    county_weights: '{"08073": 77.5, "08041": 19.95, "08039": 2.55}',
    density: 1,
    imprecise: false,
    latitude: 38.73874,
    longitude: -103.93699,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80833',
  },
  {
    city: 'Seibert',
    county_fips: 8063,
    county_fips_all: '08063',
    county: 'Kit Carson',
    county_names_all: 'Kit Carson',
    county_weights: '{"08063": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 39.29735,
    longitude: -102.88617,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80834',
  },
  {
    city: 'Simla',
    county_fips: 8039,
    county_fips_all: '08039|08041',
    county: 'Elbert',
    county_names_all: 'Elbert|El Paso',
    county_weights: '{"08039": 94.13, "08041": 5.87}',
    density: 1.8,
    imprecise: false,
    latitude: 39.20933,
    longitude: -104.07223,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80835',
  },
  {
    city: 'Stratton',
    county_fips: 8063,
    county_fips_all: '08063|08125',
    county: 'Kit Carson',
    county_names_all: 'Kit Carson|Yuma',
    county_weights: '{"08063": 99.24, "08125": 0.76}',
    density: 1,
    imprecise: false,
    latitude: 39.30518,
    longitude: -102.58239,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80836',
  },
  {
    city: 'Usaf Academy',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 110.3,
    imprecise: false,
    latitude: 39.00041,
    longitude: -104.85446,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80840',
  },
  {
    city: 'Victor',
    county_fips: 8119,
    county_fips_all: '08119',
    county: 'Teller',
    county_names_all: 'Teller',
    county_weights: '{"08119": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 38.69307,
    longitude: -105.09876,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80860',
  },
  {
    city: 'Vona',
    county_fips: 8063,
    county_fips_all: '08063|08125',
    county: 'Kit Carson',
    county_names_all: 'Kit Carson|Yuma',
    county_weights: '{"08063": 99.18, "08125": 0.82}',
    density: 0.4,
    imprecise: false,
    latitude: 39.32645,
    longitude: -102.74844,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80861',
  },
  {
    city: 'Wild Horse',
    county_fips: 8017,
    county_fips_all: '08017',
    county: 'Cheyenne',
    county_names_all: 'Cheyenne',
    county_weights: '{"08017": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 38.90926,
    longitude: -103.06782,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 47,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80862',
  },
  {
    city: 'Woodland Park',
    county_fips: 8119,
    county_fips_all: '08119|08041',
    county: 'Teller',
    county_names_all: 'Teller|El Paso',
    county_weights: '{"08119": 71.15, "08041": 28.85}',
    density: 27.5,
    imprecise: false,
    latitude: 39.03004,
    longitude: -105.07132,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80863',
  },
  {
    city: 'Yoder',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 38.69923,
    longitude: -104.18757,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80864',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 254.5,
    imprecise: false,
    latitude: 38.68683,
    longitude: -104.8127,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 11951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80902',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 1184.1,
    imprecise: false,
    latitude: 38.83249,
    longitude: -104.81342,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80903',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 731.5,
    imprecise: false,
    latitude: 38.86321,
    longitude: -104.87197,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 21158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80904',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 1258.5,
    imprecise: false,
    latitude: 38.81855,
    longitude: -104.83649,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80905',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 317.7,
    imprecise: false,
    latitude: 38.76744,
    longitude: -104.87023,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 37502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80906',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 1091,
    imprecise: false,
    latitude: 38.87912,
    longitude: -104.82137,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 27815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80907',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 103.9,
    imprecise: false,
    latitude: 39.0463,
    longitude: -104.69094,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 25486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80908',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 1727.9,
    imprecise: false,
    latitude: 38.85255,
    longitude: -104.77434,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80909',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 1982.2,
    imprecise: false,
    latitude: 38.81178,
    longitude: -104.7743,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 31368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80910',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 1147.8,
    imprecise: false,
    latitude: 38.75325,
    longitude: -104.71955,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 33027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80911',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 294.1,
    imprecise: false,
    latitude: 38.82401,
    longitude: -104.70546,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80914',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 1173.7,
    imprecise: false,
    latitude: 38.85271,
    longitude: -104.71652,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 23884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80915',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 863,
    imprecise: false,
    latitude: 38.80327,
    longitude: -104.71208,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 41104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80916',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 2090.7,
    imprecise: false,
    latitude: 38.88684,
    longitude: -104.74049,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 30398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80917',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 1611.2,
    imprecise: false,
    latitude: 38.91156,
    longitude: -104.78032,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 50005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80918',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 392,
    imprecise: false,
    latitude: 38.92797,
    longitude: -104.88025,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 27787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80919',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 1148.2,
    imprecise: false,
    latitude: 38.95579,
    longitude: -104.77191,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 36923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80920',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 209.1,
    imprecise: false,
    latitude: 39.02648,
    longitude: -104.88156,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 26551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80921',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 2017.6,
    imprecise: false,
    latitude: 38.88996,
    longitude: -104.70084,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 30453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80922',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 1756.3,
    imprecise: false,
    latitude: 38.92673,
    longitude: -104.71433,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 31772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80923',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 1294.6,
    imprecise: false,
    latitude: 38.96727,
    longitude: -104.72199,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 19619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80924',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 232.3,
    imprecise: false,
    latitude: 38.76156,
    longitude: -104.64441,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 17273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80925',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041|08043',
    county: 'El Paso',
    county_names_all: 'El Paso|Fremont',
    county_weights: '{"08041": 63.47, "08043": 36.53}',
    density: 7.7,
    imprecise: false,
    latitude: 38.64318,
    longitude: -104.92439,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80926',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 690.3,
    imprecise: false,
    latitude: 38.92833,
    longitude: -104.65878,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80927',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041|08101',
    county: 'El Paso',
    county_names_all: 'El Paso|Pueblo',
    county_weights: '{"08041": 99.9, "08101": 0.1}',
    density: 1,
    imprecise: false,
    latitude: 38.64517,
    longitude: -104.44268,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80928',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 38.82453,
    longitude: -104.60833,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80929',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 38.80507,
    longitude: -104.50644,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80930',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 120.8,
    imprecise: false,
    latitude: 38.90157,
    longitude: -104.65926,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80938',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 65.2,
    imprecise: false,
    latitude: 38.87772,
    longitude: -104.67742,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80939',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 688.7,
    imprecise: false,
    latitude: 38.88396,
    longitude: -104.6558,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80951',
  },
  {
    city: 'Pueblo',
    county_fips: 8101,
    county_fips_all: '08101',
    county: 'Pueblo',
    county_names_all: 'Pueblo',
    county_weights: '{"08101": 100}',
    density: 375.9,
    imprecise: false,
    latitude: 38.29525,
    longitude: -104.5378,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 31197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81001',
  },
  {
    city: 'Pueblo',
    county_fips: 8101,
    county_fips_all: '08101',
    county: 'Pueblo',
    county_names_all: 'Pueblo',
    county_weights: '{"08101": 100}',
    density: 480.3,
    imprecise: false,
    latitude: 38.27782,
    longitude: -104.65668,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81003',
  },
  {
    city: 'Pueblo',
    county_fips: 8101,
    county_fips_all: '08101',
    county: 'Pueblo',
    county_names_all: 'Pueblo',
    county_weights: '{"08101": 100}',
    density: 61.8,
    imprecise: false,
    latitude: 38.05121,
    longitude: -104.71595,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 25757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81004',
  },
  {
    city: 'Pueblo',
    county_fips: 8101,
    county_fips_all: '08101',
    county: 'Pueblo',
    county_names_all: 'Pueblo',
    county_weights: '{"08101": 100}',
    density: 63,
    imprecise: false,
    latitude: 38.21054,
    longitude: -104.84608,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81005',
  },
  {
    city: 'Pueblo',
    county_fips: 8101,
    county_fips_all: '08101',
    county: 'Pueblo',
    county_names_all: 'Pueblo',
    county_weights: '{"08101": 100}',
    density: 37.9,
    imprecise: false,
    latitude: 38.24059,
    longitude: -104.47413,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 11029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81006',
  },
  {
    city: 'Pueblo',
    county_fips: 8101,
    county_fips_all: '08101',
    county: 'Pueblo',
    county_names_all: 'Pueblo',
    county_weights: '{"08101": 100}',
    density: 100.9,
    imprecise: false,
    latitude: 38.35858,
    longitude: -104.78472,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81007',
  },
  {
    city: 'Pueblo',
    county_fips: 8101,
    county_fips_all: '08101|08041',
    county: 'Pueblo',
    county_names_all: 'Pueblo|El Paso',
    county_weights: '{"08101": 98.14, "08041": 1.86}',
    density: 43.9,
    imprecise: false,
    latitude: 38.40765,
    longitude: -104.59354,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 11608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81008',
  },
  {
    city: 'Colorado City',
    county_fips: 8101,
    county_fips_all: '08101',
    county: 'Pueblo',
    county_names_all: 'Pueblo',
    county_weights: '{"08101": 100}',
    density: 37.7,
    imprecise: false,
    latitude: 37.94152,
    longitude: -104.83714,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1280,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81019',
  },
  {
    city: 'Aguilar',
    county_fips: 8071,
    county_fips_all: '08071',
    county: 'Las Animas',
    county_names_all: 'Las Animas',
    county_weights: '{"08071": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 37.43821,
    longitude: -104.6253,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81020',
  },
  {
    city: 'Arlington',
    county_fips: 8061,
    county_fips_all: '08061|08073',
    county: 'Kiowa',
    county_names_all: 'Kiowa|Lincoln',
    county_weights: '{"08061": 68.01, "08073": 31.99}',
    density: 0,
    imprecise: false,
    latitude: 38.43332,
    longitude: -103.36732,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81021',
  },
  {
    city: 'Avondale',
    county_fips: 8101,
    county_fips_all: '08101',
    county: 'Pueblo',
    county_names_all: 'Pueblo',
    county_weights: '{"08101": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 38.03279,
    longitude: -104.43768,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81022',
  },
  {
    city: 'Beulah',
    county_fips: 8101,
    county_fips_all: '08101',
    county: 'Pueblo',
    county_names_all: 'Pueblo',
    county_weights: '{"08101": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 38.06352,
    longitude: -104.92966,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81023',
  },
  {
    city: 'Boncarbo',
    county_fips: 8071,
    county_fips_all: '08071',
    county: 'Las Animas',
    county_names_all: 'Las Animas',
    county_weights: '{"08071": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 37.2293,
    longitude: -104.71162,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81024',
  },
  {
    city: 'Boone',
    county_fips: 8101,
    county_fips_all: '08101',
    county: 'Pueblo',
    county_names_all: 'Pueblo',
    county_weights: '{"08101": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 38.34567,
    longitude: -104.26422,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81025',
  },
  {
    city: 'Branson',
    county_fips: 8071,
    county_fips_all: '08071',
    county: 'Las Animas',
    county_names_all: 'Las Animas',
    county_weights: '{"08071": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 37.24687,
    longitude: -103.72308,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81027',
  },
  {
    city: 'Campo',
    county_fips: 8009,
    county_fips_all: '08009',
    county: 'Baca',
    county_names_all: 'Baca',
    county_weights: '{"08009": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 37.08921,
    longitude: -102.48274,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81029',
  },
  {
    city: 'Cheraw',
    county_fips: 8089,
    county_fips_all: '08089',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"08089": 100}',
    density: 155.5,
    imprecise: false,
    latitude: 38.10322,
    longitude: -103.51876,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81030',
  },
  {
    city: 'Crowley',
    county_fips: 8025,
    county_fips_all: '08025',
    county: 'Crowley',
    county_names_all: 'Crowley',
    county_weights: '{"08025": 100}',
    density: 137.3,
    imprecise: false,
    latitude: 38.19575,
    longitude: -103.85557,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81033',
  },
  {
    city: 'Eads',
    county_fips: 8061,
    county_fips_all: '08061',
    county: 'Kiowa',
    county_names_all: 'Kiowa',
    county_weights: '{"08061": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 38.42984,
    longitude: -102.79292,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81036',
  },
  {
    city: 'Fowler',
    county_fips: 8101,
    county_fips_all: '08101|08089|08025',
    county: 'Pueblo',
    county_names_all: 'Pueblo|Otero|Crowley',
    county_weights: '{"08101": 57.12, "08089": 42.28, "08025": 0.6}',
    density: 1,
    imprecise: false,
    latitude: 37.94079,
    longitude: -104.08615,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81039',
  },
  {
    city: 'Gardner',
    county_fips: 8055,
    county_fips_all: '08055',
    county: 'Huerfano',
    county_names_all: 'Huerfano',
    county_weights: '{"08055": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 37.79283,
    longitude: -105.2493,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81040',
  },
  {
    city: 'Granada',
    county_fips: 8099,
    county_fips_all: '08099|08009',
    county: 'Prowers',
    county_names_all: 'Prowers|Baca',
    county_weights: '{"08099": 96.27, "08009": 3.73}',
    density: 0.5,
    imprecise: false,
    latitude: 37.844,
    longitude: -102.3839,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81041',
  },
  {
    city: 'Hartman',
    county_fips: 8099,
    county_fips_all: '08099',
    county: 'Prowers',
    county_names_all: 'Prowers',
    county_weights: '{"08099": 100}',
    density: 33,
    imprecise: false,
    latitude: 38.11982,
    longitude: -102.22312,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81043',
  },
  {
    city: 'Hasty',
    county_fips: 8011,
    county_fips_all: '08011',
    county: 'Bent',
    county_names_all: 'Bent',
    county_weights: '{"08011": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 37.90328,
    longitude: -102.93628,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81044',
  },
  {
    city: 'Haswell',
    county_fips: 8061,
    county_fips_all: '08061|08017|08073',
    county: 'Kiowa',
    county_names_all: 'Kiowa|Cheyenne|Lincoln',
    county_weights: '{"08061": 58.38, "08017": 24.99, "08073": 16.63}',
    density: 0.1,
    imprecise: false,
    latitude: 38.55956,
    longitude: -103.16093,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 59,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81045',
  },
  {
    city: 'Hoehne',
    county_fips: 8071,
    county_fips_all: '08071',
    county: 'Las Animas',
    county_names_all: 'Las Animas',
    county_weights: '{"08071": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 37.29597,
    longitude: -104.36867,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81046',
  },
  {
    city: 'Holly',
    county_fips: 8099,
    county_fips_all: '08099|08061',
    county: 'Prowers',
    county_names_all: 'Prowers|Kiowa',
    county_weights: '{"08099": 96.36, "08061": 3.64}',
    density: 1,
    imprecise: false,
    latitude: 38.03226,
    longitude: -102.19206,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81047',
  },
  {
    city: 'Kim',
    county_fips: 8071,
    county_fips_all: '08071',
    county: 'Las Animas',
    county_names_all: 'Las Animas',
    county_weights: '{"08071": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 37.31338,
    longitude: -103.36308,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81049',
  },
  {
    city: 'La Junta',
    county_fips: 8089,
    county_fips_all: '08089|08011',
    county: 'Otero',
    county_names_all: 'Otero|Bent',
    county_weights: '{"08089": 96.64, "08011": 3.36}',
    density: 7.5,
    imprecise: false,
    latitude: 37.92266,
    longitude: -103.51528,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81050',
  },
  {
    city: 'Lamar',
    county_fips: 8099,
    county_fips_all: '08099|08011',
    county: 'Prowers',
    county_names_all: 'Prowers|Bent',
    county_weights: '{"08099": 75.83, "08011": 24.17}',
    density: 5.2,
    imprecise: false,
    latitude: 37.94242,
    longitude: -102.65625,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81052',
  },
  {
    city: 'Las Animas',
    county_fips: 8011,
    county_fips_all: '08011|08071|08009',
    county: 'Bent',
    county_names_all: 'Bent|Las Animas|Baca',
    county_weights: '{"08011": 84.82, "08071": 7.85, "08009": 7.33}',
    density: 1.9,
    imprecise: false,
    latitude: 37.88583,
    longitude: -103.19493,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81054',
  },
  {
    city: 'La Veta',
    county_fips: 8055,
    county_fips_all: '08055|08023',
    county: 'Huerfano',
    county_names_all: 'Huerfano|Costilla',
    county_weights: '{"08055": 98.79, "08023": 1.21}',
    density: 2.5,
    imprecise: false,
    latitude: 37.47727,
    longitude: -105.06635,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81055',
  },
  {
    city: 'McClave',
    county_fips: 8011,
    county_fips_all: '08011',
    county: 'Bent',
    county_names_all: 'Bent',
    county_weights: '{"08011": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 38.12525,
    longitude: -102.89675,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81057',
  },
  {
    city: 'Manzanola',
    county_fips: 8089,
    county_fips_all: '08089|08025',
    county: 'Otero',
    county_names_all: 'Otero|Crowley',
    county_weights: '{"08089": 70.12, "08025": 29.88}',
    density: 6.8,
    imprecise: false,
    latitude: 38.10727,
    longitude: -103.88161,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81058',
  },
  {
    city: 'Model',
    county_fips: 8071,
    county_fips_all: '08071|08089',
    county: 'Las Animas',
    county_names_all: 'Las Animas|Otero',
    county_weights: '{"08071": 73.77, "08089": 26.23}',
    density: 0,
    imprecise: false,
    latitude: 37.56259,
    longitude: -103.99322,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81059',
  },
  {
    city: 'Olney Springs',
    county_fips: 8025,
    county_fips_all: '08025',
    county: 'Crowley',
    county_names_all: 'Crowley',
    county_weights: '{"08025": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 38.29345,
    longitude: -103.94995,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81062',
  },
  {
    city: 'Ordway',
    county_fips: 8025,
    county_fips_all: '08025|08073',
    county: 'Crowley',
    county_names_all: 'Crowley|Lincoln',
    county_weights: '{"08025": 63.14, "08073": 36.86}',
    density: 2.7,
    imprecise: false,
    latitude: 38.45232,
    longitude: -103.78494,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81063',
  },
  {
    city: 'Pritchett',
    county_fips: 8009,
    county_fips_all: '08009|08071',
    county: 'Baca',
    county_names_all: 'Baca|Las Animas',
    county_weights: '{"08009": 80.62, "08071": 19.38}',
    density: 0.2,
    imprecise: false,
    latitude: 37.24593,
    longitude: -102.99753,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81064',
  },
  {
    city: 'Rocky Ford',
    county_fips: 8089,
    county_fips_all: '08089',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"08089": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 38.01674,
    longitude: -103.72326,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81067',
  },
  {
    city: 'Rye',
    county_fips: 8055,
    county_fips_all: '08055|08101|08027',
    county: 'Huerfano',
    county_names_all: 'Huerfano|Pueblo|Custer',
    county_weights: '{"08055": 48.37, "08101": 36.28, "08027": 15.35}',
    density: 2.2,
    imprecise: false,
    latitude: 37.88998,
    longitude: -104.88951,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81069',
  },
  {
    city: 'Sheridan Lake',
    county_fips: 8061,
    county_fips_all: '08061',
    county: 'Kiowa',
    county_names_all: 'Kiowa',
    county_weights: '{"08061": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 38.44838,
    longitude: -102.2816,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81071',
  },
  {
    city: 'Springfield',
    county_fips: 8009,
    county_fips_all: '08009',
    county: 'Baca',
    county_names_all: 'Baca',
    county_weights: '{"08009": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 37.42414,
    longitude: -102.71496,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81073',
  },
  {
    city: 'Sugar City',
    county_fips: 8025,
    county_fips_all: '08025',
    county: 'Crowley',
    county_names_all: 'Crowley',
    county_weights: '{"08025": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 38.32338,
    longitude: -103.6167,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81076',
  },
  {
    city: 'Swink',
    county_fips: 8089,
    county_fips_all: '08089',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"08089": 100}',
    density: 98.9,
    imprecise: false,
    latitude: 38.01374,
    longitude: -103.60985,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81077',
  },
  {
    city: 'Trinchera',
    county_fips: 8071,
    county_fips_all: '08071',
    county: 'Las Animas',
    county_names_all: 'Las Animas',
    county_weights: '{"08071": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 37.07295,
    longitude: -104.14954,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81081',
  },
  {
    city: 'Trinidad',
    county_fips: 8071,
    county_fips_all: '08071',
    county: 'Las Animas',
    county_names_all: 'Las Animas',
    county_weights: '{"08071": 100}',
    density: 6,
    imprecise: false,
    latitude: 37.20343,
    longitude: -104.41717,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 11842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81082',
  },
  {
    city: 'Two Buttes',
    county_fips: 8009,
    county_fips_all: '08009|08099',
    county: 'Baca',
    county_names_all: 'Baca|Prowers',
    county_weights: '{"08009": 83.65, "08099": 16.35}',
    density: 0.1,
    imprecise: false,
    latitude: 37.57031,
    longitude: -102.41929,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81084',
  },
  {
    city: 'Vilas',
    county_fips: 8009,
    county_fips_all: '08009',
    county: 'Baca',
    county_names_all: 'Baca',
    county_weights: '{"08009": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 37.39168,
    longitude: -102.41277,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81087',
  },
  {
    city: 'Walsenburg',
    county_fips: 8055,
    county_fips_all: '08055|08071',
    county: 'Huerfano',
    county_names_all: 'Huerfano|Las Animas',
    county_weights: '{"08055": 77.99, "08071": 22.01}',
    density: 2,
    imprecise: false,
    latitude: 37.6642,
    longitude: -104.66427,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81089',
  },
  {
    city: 'Walsh',
    county_fips: 8009,
    county_fips_all: '08009',
    county: 'Baca',
    county_names_all: 'Baca',
    county_weights: '{"08009": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 37.36311,
    longitude: -102.22434,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81090',
  },
  {
    city: 'Weston',
    county_fips: 8071,
    county_fips_all: '08071',
    county: 'Las Animas',
    county_names_all: 'Las Animas',
    county_weights: '{"08071": 100}',
    density: 1,
    imprecise: false,
    latitude: 37.14869,
    longitude: -104.97774,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81091',
  },
  {
    city: 'Wiley',
    county_fips: 8011,
    county_fips_all: '08011|08099|08061',
    county: 'Bent',
    county_names_all: 'Bent|Prowers|Kiowa',
    county_weights: '{"08011": 79.24, "08099": 19.18, "08061": 1.58}',
    density: 1.5,
    imprecise: false,
    latitude: 38.20283,
    longitude: -102.86779,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81092',
  },
  {
    city: 'Alamosa',
    county_fips: 8003,
    county_fips_all: '08003|08021',
    county: 'Alamosa',
    county_names_all: 'Alamosa|Conejos',
    county_weights: '{"08003": 94.45, "08021": 5.55}',
    density: 16.3,
    imprecise: false,
    latitude: 37.47197,
    longitude: -105.85243,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81101',
  },
  {
    city: 'Antonito',
    county_fips: 8021,
    county_fips_all: '08021|35039',
    county: 'Conejos',
    county_names_all: 'Conejos|Rio Arriba',
    county_weights: '{"08021": 92.11, "35039": 7.89}',
    density: 0.8,
    imprecise: false,
    latitude: 37.14248,
    longitude: -106.26715,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81120',
  },
  {
    city: 'Arboles',
    county_fips: 8007,
    county_fips_all: '08007',
    county: 'Archuleta',
    county_names_all: 'Archuleta',
    county_weights: '{"08007": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 37.01861,
    longitude: -107.42041,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81121',
  },
  {
    city: 'Bayfield',
    county_fips: 8067,
    county_fips_all: '08067|08007',
    county: 'La Plata',
    county_names_all: 'La Plata|Archuleta',
    county_weights: '{"08067": 60.76, "08007": 39.24}',
    density: 7.1,
    imprecise: false,
    latitude: 37.31839,
    longitude: -107.50574,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81122',
  },
  {
    city: 'Blanca',
    county_fips: 8023,
    county_fips_all: '08023',
    county: 'Costilla',
    county_names_all: 'Costilla',
    county_weights: '{"08023": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 37.40469,
    longitude: -105.5659,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81123',
  },
  {
    city: 'Capulin',
    county_fips: 8021,
    county_fips_all: '08021',
    county: 'Conejos',
    county_names_all: 'Conejos',
    county_weights: '{"08021": 100}',
    density: 34.3,
    imprecise: false,
    latitude: 37.28543,
    longitude: -106.10688,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81124',
  },
  {
    city: 'Center',
    county_fips: 8109,
    county_fips_all: '08109|08105|08003',
    county: 'Saguache',
    county_names_all: 'Saguache|Rio Grande|Alamosa',
    county_weights: '{"08109": 82.0, "08105": 16.45, "08003": 1.55}',
    density: 4.9,
    imprecise: false,
    latitude: 37.81745,
    longitude: -106.06678,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81125',
  },
  {
    city: 'Chromo',
    county_fips: 8007,
    county_fips_all: '08007',
    county: 'Archuleta',
    county_names_all: 'Archuleta',
    county_weights: '{"08007": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 37.06529,
    longitude: -106.65223,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81128',
  },
  {
    city: 'Conejos',
    county_fips: 8021,
    county_fips_all: '08021',
    county: 'Conejos',
    county_names_all: 'Conejos',
    county_weights: '{"08021": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 37.10495,
    longitude: -106.02167,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81129',
  },
  {
    city: 'Creede',
    county_fips: 8079,
    county_fips_all: '08079|08053',
    county: 'Mineral',
    county_names_all: 'Mineral|Hinsdale',
    county_weights: '{"08079": 70.48, "08053": 29.52}',
    density: 0.3,
    imprecise: false,
    latitude: 37.7179,
    longitude: -107.04471,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81130',
  },
  {
    city: 'Crestone',
    county_fips: 8109,
    county_fips_all: '08109',
    county: 'Saguache',
    county_names_all: 'Saguache',
    county_weights: '{"08109": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 37.87706,
    longitude: -105.66651,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81131',
  },
  {
    city: 'Del Norte',
    county_fips: 8105,
    county_fips_all: '08105|08109',
    county: 'Rio Grande',
    county_names_all: 'Rio Grande|Saguache',
    county_weights: '{"08105": 51.24, "08109": 48.76}',
    density: 1.8,
    imprecise: false,
    latitude: 37.71656,
    longitude: -106.41009,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81132',
  },
  {
    city: 'Fort Garland',
    county_fips: 8023,
    county_fips_all: '08023',
    county: 'Costilla',
    county_names_all: 'Costilla',
    county_weights: '{"08023": 100}',
    density: 1,
    imprecise: false,
    latitude: 37.44964,
    longitude: -105.32747,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81133',
  },
  {
    city: 'Hooper',
    county_fips: 8003,
    county_fips_all: '08003|08109',
    county: 'Alamosa',
    county_names_all: 'Alamosa|Saguache',
    county_weights: '{"08003": 80.39, "08109": 19.61}',
    density: 1.4,
    imprecise: false,
    latitude: 37.72672,
    longitude: -105.85355,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81136',
  },
  {
    city: 'Ignacio',
    county_fips: 8067,
    county_fips_all: '08067|35045|08007',
    county: 'La Plata',
    county_names_all: 'La Plata|San Juan|Archuleta',
    county_weights: '{"08067": 77.76, "35045": 19.2, "08007": 3.04}',
    density: 8.3,
    imprecise: false,
    latitude: 37.05555,
    longitude: -107.61596,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81137',
  },
  {
    city: 'Jaroso',
    county_fips: 8023,
    county_fips_all: '08023',
    county: 'Costilla',
    county_names_all: 'Costilla',
    county_weights: '{"08023": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 37.02302,
    longitude: -105.62737,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81138',
  },
  {
    city: 'La Jara',
    county_fips: 8021,
    county_fips_all: '08021',
    county: 'Conejos',
    county_names_all: 'Conejos',
    county_weights: '{"08021": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 37.28692,
    longitude: -106.1543,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1893,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81140',
  },
  {
    city: 'Manassa',
    county_fips: 8021,
    county_fips_all: '08021',
    county: 'Conejos',
    county_names_all: 'Conejos',
    county_weights: '{"08021": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 37.16256,
    longitude: -105.89507,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81141',
  },
  {
    city: 'Moffat',
    county_fips: 8109,
    county_fips_all: '08109',
    county: 'Saguache',
    county_names_all: 'Saguache',
    county_weights: '{"08109": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 38.14477,
    longitude: -105.87112,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81143',
  },
  {
    city: 'Monte Vista',
    county_fips: 8105,
    county_fips_all: '08105|08003',
    county: 'Rio Grande',
    county_names_all: 'Rio Grande|Alamosa',
    county_weights: '{"08105": 91.56, "08003": 8.44}',
    density: 8.8,
    imprecise: false,
    latitude: 37.5516,
    longitude: -106.14851,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81144',
  },
  {
    city: 'Mosca',
    county_fips: 8003,
    county_fips_all: '08003',
    county: 'Alamosa',
    county_names_all: 'Alamosa',
    county_weights: '{"08003": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 37.64616,
    longitude: -105.6776,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 637,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81146',
  },
  {
    city: 'Pagosa Springs',
    county_fips: 8007,
    county_fips_all: '08007|08053|08079',
    county: 'Archuleta',
    county_names_all: 'Archuleta|Hinsdale|Mineral',
    county_weights: '{"08007": 73.81, "08053": 21.98, "08079": 4.21}',
    density: 3.7,
    imprecise: false,
    latitude: 37.28675,
    longitude: -107.08333,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 13091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81147',
  },
  {
    city: 'Romeo',
    county_fips: 8021,
    county_fips_all: '08021',
    county: 'Conejos',
    county_names_all: 'Conejos',
    county_weights: '{"08021": 100}',
    density: 640.2,
    imprecise: false,
    latitude: 37.17183,
    longitude: -105.98542,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81148',
  },
  {
    city: 'Saguache',
    county_fips: 8109,
    county_fips_all: '08109',
    county: 'Saguache',
    county_names_all: 'Saguache',
    county_weights: '{"08109": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 38.1035,
    longitude: -106.33858,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81149',
  },
  {
    city: 'Sanford',
    county_fips: 8023,
    county_fips_all: '08023|08021',
    county: 'Costilla',
    county_names_all: 'Costilla|Conejos',
    county_weights: '{"08023": 56.74, "08021": 43.26}',
    density: 2.3,
    imprecise: false,
    latitude: 37.23376,
    longitude: -105.71506,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81151',
  },
  {
    city: 'San Luis',
    county_fips: 8023,
    county_fips_all: '08023',
    county: 'Costilla',
    county_names_all: 'Costilla',
    county_weights: '{"08023": 100}',
    density: 1,
    imprecise: false,
    latitude: 37.12609,
    longitude: -105.39411,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81152',
  },
  {
    city: 'South Fork',
    county_fips: 8105,
    county_fips_all: '08105|08079',
    county: 'Rio Grande',
    county_names_all: 'Rio Grande|Mineral',
    county_weights: '{"08105": 65.39, "08079": 34.61}',
    density: 1.4,
    imprecise: false,
    latitude: 37.63473,
    longitude: -106.67179,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81154',
  },
  {
    city: 'Villa Grove',
    county_fips: 8109,
    county_fips_all: '08109',
    county: 'Saguache',
    county_names_all: 'Saguache',
    county_weights: '{"08109": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 38.26671,
    longitude: -106.09603,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81155',
  },
  {
    city: 'Salida',
    county_fips: 8015,
    county_fips_all: '08015|08043',
    county: 'Chaffee',
    county_names_all: 'Chaffee|Fremont',
    county_weights: '{"08015": 84.46, "08043": 15.54}',
    density: 9,
    imprecise: false,
    latitude: 38.55129,
    longitude: -106.08157,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81201',
  },
  {
    city: 'Almont',
    county_fips: 8051,
    county_fips_all: '08051',
    county: 'Gunnison',
    county_names_all: 'Gunnison',
    county_weights: '{"08051": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 38.81898,
    longitude: -106.62219,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81210',
  },
  {
    city: 'Buena Vista',
    county_fips: 8015,
    county_fips_all: '08015',
    county: 'Chaffee',
    county_names_all: 'Chaffee',
    county_weights: '{"08015": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 38.89548,
    longitude: -106.24128,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81211',
  },
  {
    city: 'Canon City',
    county_fips: 8043,
    county_fips_all: '08043',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"08043": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 38.54409,
    longitude: -105.42498,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81212',
  },
  {
    city: 'Cimarron',
    county_fips: 8051,
    county_fips_all: '08051|08085',
    county: 'Gunnison',
    county_names_all: 'Gunnison|Montrose',
    county_weights: '{"08051": 74.43, "08085": 25.57}',
    density: 0.4,
    imprecise: false,
    latitude: 38.29861,
    longitude: -107.48414,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81220',
  },
  {
    city: 'Coal Creek',
    county_fips: 8043,
    county_fips_all: '08043',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"08043": 100}',
    density: 109.1,
    imprecise: false,
    latitude: 38.36243,
    longitude: -105.14238,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81221',
  },
  {
    city: 'Coaldale',
    county_fips: 8043,
    county_fips_all: '08043',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"08043": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 38.35492,
    longitude: -105.81612,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81222',
  },
  {
    city: 'Cotopaxi',
    county_fips: 8043,
    county_fips_all: '08043',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"08043": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 38.39372,
    longitude: -105.6031,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81223',
  },
  {
    city: 'Crested Butte',
    county_fips: 8051,
    county_fips_all: '08051',
    county: 'Gunnison',
    county_names_all: 'Gunnison',
    county_weights: '{"08051": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 38.87985,
    longitude: -106.90957,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81224',
  },
  {
    city: 'Crested Butte',
    county_fips: 8051,
    county_fips_all: '08051',
    county: 'Gunnison',
    county_names_all: 'Gunnison',
    county_weights: '{"08051": 100}',
    density: 11,
    imprecise: false,
    latitude: 38.94115,
    longitude: -107.00664,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81225',
  },
  {
    city: 'Florence',
    county_fips: 8043,
    county_fips_all: '08043|08027',
    county: 'Fremont',
    county_names_all: 'Fremont|Custer',
    county_weights: '{"08043": 88.43, "08027": 11.57}',
    density: 22.2,
    imprecise: false,
    latitude: 38.32213,
    longitude: -105.10193,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81226',
  },
  {
    city: 'Granite',
    county_fips: 8015,
    county_fips_all: '08015',
    county: 'Chaffee',
    county_names_all: 'Chaffee',
    county_weights: '{"08015": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.03402,
    longitude: -106.27723,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81228',
  },
  {
    city: 'Gunnison',
    county_fips: 8051,
    county_fips_all: '08051|08109',
    county: 'Gunnison',
    county_names_all: 'Gunnison|Saguache',
    county_weights: '{"08051": 61.49, "08109": 38.51}',
    density: 2.5,
    imprecise: false,
    latitude: 38.40752,
    longitude: -106.98372,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81230',
  },
  {
    city: 'Howard',
    county_fips: 8043,
    county_fips_all: '08043',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"08043": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 38.49244,
    longitude: -105.81369,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81233',
  },
  {
    city: 'Lake City',
    county_fips: 8053,
    county_fips_all: '08053',
    county: 'Hinsdale',
    county_names_all: 'Hinsdale',
    county_weights: '{"08053": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 37.99363,
    longitude: -107.33098,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81235',
  },
  {
    city: 'Nathrop',
    county_fips: 8015,
    county_fips_all: '08015',
    county: 'Chaffee',
    county_names_all: 'Chaffee',
    county_weights: '{"08015": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 38.6955,
    longitude: -106.25424,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81236',
  },
  {
    city: 'Ohio City',
    county_fips: 8051,
    county_fips_all: '08051',
    county: 'Gunnison',
    county_names_all: 'Gunnison',
    county_weights: '{"08051": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 38.62842,
    longitude: -106.59108,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81237',
  },
  {
    city: 'Parlin',
    county_fips: 8051,
    county_fips_all: '08051',
    county: 'Gunnison',
    county_names_all: 'Gunnison',
    county_weights: '{"08051": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 38.53667,
    longitude: -106.60825,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81239',
  },
  {
    city: 'Penrose',
    county_fips: 8043,
    county_fips_all: '08043',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"08043": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 38.4995,
    longitude: -105.03076,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81240',
  },
  {
    city: 'Pitkin',
    county_fips: 8051,
    county_fips_all: '08051',
    county: 'Gunnison',
    county_names_all: 'Gunnison',
    county_weights: '{"08051": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 38.62675,
    longitude: -106.48848,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81241',
  },
  {
    city: 'Poncha Springs',
    county_fips: 8015,
    county_fips_all: '08015|08109',
    county: 'Chaffee',
    county_names_all: 'Chaffee|Saguache',
    county_weights: '{"08015": 99.85, "08109": 0.15}',
    density: 15.2,
    imprecise: false,
    latitude: 38.47181,
    longitude: -106.07288,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81242',
  },
  {
    city: 'Powderhorn',
    county_fips: 8051,
    county_fips_all: '08051',
    county: 'Gunnison',
    county_names_all: 'Gunnison',
    county_weights: '{"08051": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 38.26041,
    longitude: -107.17654,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81243',
  },
  {
    city: 'Rockvale',
    county_fips: 8043,
    county_fips_all: '08043',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"08043": 100}',
    density: 132.7,
    imprecise: false,
    latitude: 38.36393,
    longitude: -105.16495,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81244',
  },
  {
    city: 'Sargents',
    county_fips: 8109,
    county_fips_all: '08109|08051',
    county: 'Saguache',
    county_names_all: 'Saguache|Gunnison',
    county_weights: '{"08109": 65.63, "08051": 34.37}',
    density: 0.3,
    imprecise: false,
    latitude: 38.3991,
    longitude: -106.47763,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81248',
  },
  {
    city: 'Twin Lakes',
    county_fips: 8065,
    county_fips_all: '08065',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"08065": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 39.13482,
    longitude: -106.43723,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81251',
  },
  {
    city: 'Westcliffe',
    county_fips: 8027,
    county_fips_all: '08027',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"08027": 100}',
    density: 3,
    imprecise: false,
    latitude: 38.10891,
    longitude: -105.42143,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81252',
  },
  {
    city: 'Wetmore',
    county_fips: 8027,
    county_fips_all: '08027|08043|08101',
    county: 'Custer',
    county_names_all: 'Custer|Fremont|Pueblo',
    county_weights: '{"08027": 70.02, "08043": 23.75, "08101": 6.23}',
    density: 2.2,
    imprecise: false,
    latitude: 38.18763,
    longitude: -105.07497,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81253',
  },
  {
    city: 'Durango',
    county_fips: 8067,
    county_fips_all: '08067|08111',
    county: 'La Plata',
    county_names_all: 'La Plata|San Juan',
    county_weights: '{"08067": 78.31, "08111": 21.69}',
    density: 15.2,
    imprecise: false,
    latitude: 37.51095,
    longitude: -107.82066,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 29774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81301',
  },
  {
    city: 'Durango',
    county_fips: 8067,
    county_fips_all: '08067',
    county: 'La Plata',
    county_names_all: 'La Plata',
    county_weights: '{"08067": 100}',
    density: 27.2,
    imprecise: false,
    latitude: 37.12903,
    longitude: -107.85677,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81303',
  },
  {
    city: 'Cahone',
    county_fips: 8033,
    county_fips_all: '08033',
    county: 'Dolores',
    county_names_all: 'Dolores',
    county_weights: '{"08033": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 37.70115,
    longitude: -108.72654,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81320',
  },
  {
    city: 'Cortez',
    county_fips: 8083,
    county_fips_all: '08083',
    county: 'Montezuma',
    county_names_all: 'Montezuma',
    county_weights: '{"08083": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 37.31826,
    longitude: -108.76267,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 14236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81321',
  },
  {
    city: 'Dolores',
    county_fips: 8033,
    county_fips_all: '08033|08083',
    county: 'Dolores',
    county_names_all: 'Dolores|Montezuma',
    county_weights: '{"08033": 51.67, "08083": 48.33}',
    density: 2.7,
    imprecise: false,
    latitude: 37.64874,
    longitude: -108.27823,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81323',
  },
  {
    city: 'Dove Creek',
    county_fips: 8033,
    county_fips_all: '08033|49037',
    county: 'Dolores',
    county_names_all: 'Dolores|San Juan',
    county_weights: '{"08033": 52.99, "49037": 47.01}',
    density: 1.6,
    imprecise: false,
    latitude: 37.63734,
    longitude: -109.02911,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81324',
  },
  {
    city: 'Egnar',
    county_fips: 8033,
    county_fips_all: '08033|08113',
    county: 'Dolores',
    county_names_all: 'Dolores|San Miguel',
    county_weights: '{"08033": 51.12, "08113": 48.88}',
    density: 0.1,
    imprecise: false,
    latitude: 37.89605,
    longitude: -108.72011,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 95,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81325',
  },
  {
    city: 'Hesperus',
    county_fips: 8067,
    county_fips_all: '08067',
    county: 'La Plata',
    county_names_all: 'La Plata',
    county_weights: '{"08067": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 37.14635,
    longitude: -108.11525,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81326',
  },
  {
    city: 'Lewis',
    county_fips: 8083,
    county_fips_all: '08083',
    county: 'Montezuma',
    county_names_all: 'Montezuma',
    county_weights: '{"08083": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 37.5155,
    longitude: -108.66488,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81327',
  },
  {
    city: 'Mancos',
    county_fips: 8083,
    county_fips_all: '08083|08067',
    county: 'Montezuma',
    county_names_all: 'Montezuma|La Plata',
    county_weights: '{"08083": 90.91, "08067": 9.09}',
    density: 3.5,
    imprecise: false,
    latitude: 37.30054,
    longitude: -108.3101,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81328',
  },
  {
    city: 'Mesa Verde National Park',
    county_fips: 8083,
    county_fips_all: '08083',
    county: 'Montezuma',
    county_names_all: 'Montezuma',
    county_weights: '{"08083": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 37.23484,
    longitude: -108.47828,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81330',
  },
  {
    city: 'Pleasant View',
    county_fips: 8083,
    county_fips_all: '08083',
    county: 'Montezuma',
    county_names_all: 'Montezuma',
    county_weights: '{"08083": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 37.51387,
    longitude: -108.86252,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81331',
  },
  {
    city: 'Rico',
    county_fips: 8033,
    county_fips_all: '08033',
    county: 'Dolores',
    county_names_all: 'Dolores',
    county_weights: '{"08033": 100}',
    density: 5,
    imprecise: false,
    latitude: 37.69857,
    longitude: -107.99292,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81332',
  },
  {
    city: 'Towaoc',
    county_fips: 8083,
    county_fips_all: '08083',
    county: 'Montezuma',
    county_names_all: 'Montezuma',
    county_weights: '{"08083": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 37.11594,
    longitude: -108.63674,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81334',
  },
  {
    city: 'Yellow Jacket',
    county_fips: 8083,
    county_fips_all: '08083',
    county: 'Montezuma',
    county_names_all: 'Montezuma',
    county_weights: '{"08083": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 37.54381,
    longitude: -108.71978,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81335',
  },
  {
    city: 'Montrose',
    county_fips: 8085,
    county_fips_all: '08085',
    county: 'Montrose',
    county_names_all: 'Montrose',
    county_weights: '{"08085": 100}',
    density: 46.7,
    imprecise: false,
    latitude: 38.51559,
    longitude: -107.78472,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 24228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81401',
  },
  {
    city: 'Montrose',
    county_fips: 8085,
    county_fips_all: '08085|08091',
    county: 'Montrose',
    county_names_all: 'Montrose|Ouray',
    county_weights: '{"08085": 66.88, "08091": 33.12}',
    density: 9.3,
    imprecise: false,
    latitude: 38.32308,
    longitude: -107.92816,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81403',
  },
  {
    city: 'Austin',
    county_fips: 8029,
    county_fips_all: '08029',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"08029": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 38.81261,
    longitude: -107.97595,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81410',
  },
  {
    city: 'Bedrock',
    county_fips: 8085,
    county_fips_all: '08085',
    county: 'Montrose',
    county_names_all: 'Montrose',
    county_weights: '{"08085": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 38.25188,
    longitude: -108.97862,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 24,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81411',
  },
  {
    city: 'Cedaredge',
    county_fips: 8029,
    county_fips_all: '08029',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"08029": 100}',
    density: 13,
    imprecise: false,
    latitude: 38.97171,
    longitude: -107.90845,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81413',
  },
  {
    city: 'Crawford',
    county_fips: 8085,
    county_fips_all: '08085|08029',
    county: 'Montrose',
    county_names_all: 'Montrose|Delta',
    county_weights: '{"08085": 60.44, "08029": 39.56}',
    density: 2.7,
    imprecise: false,
    latitude: 38.64027,
    longitude: -107.6368,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81415',
  },
  {
    city: 'Delta',
    county_fips: 8029,
    county_fips_all: '08029|08085',
    county: 'Delta',
    county_names_all: 'Delta|Montrose',
    county_weights: '{"08029": 56.93, "08085": 43.07}',
    density: 9.6,
    imprecise: false,
    latitude: 38.66482,
    longitude: -108.20403,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 14256,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81416',
  },
  {
    city: 'Eckert',
    county_fips: 8029,
    county_fips_all: '08029',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"08029": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 38.90479,
    longitude: -108.05687,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81418',
  },
  {
    city: 'Hotchkiss',
    county_fips: 8029,
    county_fips_all: '08029',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"08029": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 38.86332,
    longitude: -107.74872,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81419',
  },
  {
    city: 'Naturita',
    county_fips: 8085,
    county_fips_all: '08085',
    county: 'Montrose',
    county_names_all: 'Montrose',
    county_weights: '{"08085": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 38.32039,
    longitude: -108.70843,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81422',
  },
  {
    city: 'Norwood',
    county_fips: 8113,
    county_fips_all: '08113|08085',
    county: 'San Miguel',
    county_names_all: 'San Miguel|Montrose',
    county_weights: '{"08113": 89.97, "08085": 10.03}',
    density: 0.8,
    imprecise: false,
    latitude: 38.03835,
    longitude: -108.45816,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81423',
  },
  {
    city: 'Nucla',
    county_fips: 8085,
    county_fips_all: '08085',
    county: 'Montrose',
    county_names_all: 'Montrose',
    county_weights: '{"08085": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 38.34098,
    longitude: -108.47346,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81424',
  },
  {
    city: 'Olathe',
    county_fips: 8085,
    county_fips_all: '08085',
    county: 'Montrose',
    county_names_all: 'Montrose',
    county_weights: '{"08085": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 38.49363,
    longitude: -108.10469,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81425',
  },
  {
    city: 'Ophir',
    county_fips: 8113,
    county_fips_all: '08113',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"08113": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 37.87339,
    longitude: -107.83191,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81426',
  },
  {
    city: 'Ouray',
    county_fips: 8091,
    county_fips_all: '08091',
    county: 'Ouray',
    county_names_all: 'Ouray',
    county_weights: '{"08091": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 37.99301,
    longitude: -107.64387,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81427',
  },
  {
    city: 'Paonia',
    county_fips: 8029,
    county_fips_all: '08029',
    county: 'Delta',
    county_names_all: 'Delta',
    county_weights: '{"08029": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 38.95928,
    longitude: -107.59899,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81428',
  },
  {
    city: 'Paradox',
    county_fips: 8085,
    county_fips_all: '08085|08113',
    county: 'Montrose',
    county_names_all: 'Montrose|San Miguel',
    county_weights: '{"08085": 99.87, "08113": 0.13}',
    density: 0.2,
    imprecise: false,
    latitude: 38.34121,
    longitude: -108.90732,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81429',
  },
  {
    city: 'Placerville',
    county_fips: 8113,
    county_fips_all: '08113',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"08113": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 38.04013,
    longitude: -108.05764,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81430',
  },
  {
    city: 'Redvale',
    county_fips: 8113,
    county_fips_all: '08113|08085',
    county: 'San Miguel',
    county_names_all: 'San Miguel|Montrose',
    county_weights: '{"08113": 65.09, "08085": 34.91}',
    density: 2.1,
    imprecise: false,
    latitude: 38.13808,
    longitude: -108.51429,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81431',
  },
  {
    city: 'Ridgway',
    county_fips: 8091,
    county_fips_all: '08091|08113',
    county: 'Ouray',
    county_names_all: 'Ouray|San Miguel',
    county_weights: '{"08091": 99.31, "08113": 0.69}',
    density: 4.1,
    imprecise: false,
    latitude: 38.12494,
    longitude: -107.74273,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81432',
  },
  {
    city: 'Silverton',
    county_fips: 8111,
    county_fips_all: '08111',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"08111": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 37.79346,
    longitude: -107.59448,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81433',
  },
  {
    city: 'Somerset',
    county_fips: 8051,
    county_fips_all: '08051|08029',
    county: 'Gunnison',
    county_names_all: 'Gunnison|Delta',
    county_weights: '{"08051": 91.77, "08029": 8.23}',
    density: 0.1,
    imprecise: false,
    latitude: 38.95384,
    longitude: -107.35954,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81434',
  },
  {
    city: 'Telluride',
    county_fips: 8113,
    county_fips_all: '08113',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"08113": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 37.90014,
    longitude: -107.92397,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81435',
  },
  {
    city: 'Grand Junction',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 1068.8,
    imprecise: false,
    latitude: 39.07174,
    longitude: -108.54569,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 24011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81501',
  },
  {
    city: 'Grand Junction',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 290.5,
    imprecise: false,
    latitude: 39.03094,
    longitude: -108.48682,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81503',
  },
  {
    city: 'Grand Junction',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 464.4,
    imprecise: false,
    latitude: 39.1198,
    longitude: -108.49542,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81504',
  },
  {
    city: 'Grand Junction',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 71.2,
    imprecise: false,
    latitude: 39.18593,
    longitude: -108.59997,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 13279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81505',
  },
  {
    city: 'Grand Junction',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 184.1,
    imprecise: false,
    latitude: 39.15785,
    longitude: -108.53454,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 11412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81506',
  },
  {
    city: 'Grand Junction',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 54.9,
    imprecise: false,
    latitude: 39.0079,
    longitude: -108.62644,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81507',
  },
  {
    city: 'Clifton',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 242.2,
    imprecise: false,
    latitude: 39.10962,
    longitude: -108.43561,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81520',
  },
  {
    city: 'Fruita',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 35.3,
    imprecise: false,
    latitude: 39.12529,
    longitude: -108.85049,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81521',
  },
  {
    city: 'Gateway',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.66026,
    longitude: -108.93025,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81522',
  },
  {
    city: 'Glade Park',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 38.93803,
    longitude: -108.87362,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81523',
  },
  {
    city: 'Loma',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 39.2842,
    longitude: -108.73257,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81524',
  },
  {
    city: 'Mack',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 39.26984,
    longitude: -108.95075,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81525',
  },
  {
    city: 'Palisade',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 29.7,
    imprecise: false,
    latitude: 39.07741,
    longitude: -108.33056,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81526',
  },
  {
    city: 'Whitewater',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 38.75758,
    longitude: -108.52466,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81527',
  },
  {
    city: 'Glenwood Springs',
    county_fips: 8045,
    county_fips_all: '08045',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"08045": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 39.59357,
    longitude: -107.32815,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81601',
  },
  {
    city: 'Dinosaur',
    county_fips: 8081,
    county_fips_all: '08081',
    county: 'Moffat',
    county_names_all: 'Moffat',
    county_weights: '{"08081": 100}',
    density: 1,
    imprecise: false,
    latitude: 40.29418,
    longitude: -108.82468,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81610',
  },
  {
    city: 'Aspen',
    county_fips: 8097,
    county_fips_all: '08097',
    county: 'Pitkin',
    county_names_all: 'Pitkin',
    county_weights: '{"08097": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 39.14561,
    longitude: -106.74885,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81611',
  },
  {
    city: 'Aspen',
    county_fips: 8097,
    county_fips_all: '08097',
    county: 'Pitkin',
    county_names_all: 'Pitkin',
    county_weights: '{"08097": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.05048,
    longitude: -106.82335,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81612',
  },
  {
    city: 'Snowmass Village',
    county_fips: 8097,
    county_fips_all: '08097',
    county: 'Pitkin',
    county_names_all: 'Pitkin',
    county_weights: '{"08097": 100}',
    density: 45.3,
    imprecise: false,
    latitude: 39.21437,
    longitude: -106.94172,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81615',
  },
  {
    city: 'Avon',
    county_fips: 8037,
    county_fips_all: '08037',
    county: 'Eagle',
    county_names_all: 'Eagle',
    county_weights: '{"08037": 100}',
    density: 77.7,
    imprecise: false,
    latitude: 39.61485,
    longitude: -106.50555,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81620',
  },
  {
    city: 'Basalt',
    county_fips: 8037,
    county_fips_all: '08037|08097',
    county: 'Eagle',
    county_names_all: 'Eagle|Pitkin',
    county_weights: '{"08037": 64.87, "08097": 35.13}',
    density: 9.8,
    imprecise: false,
    latitude: 39.37803,
    longitude: -106.8772,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81621',
  },
  {
    city: 'Carbondale',
    county_fips: 8097,
    county_fips_all: '08097|08051|08045|08037',
    county: 'Pitkin',
    county_names_all: 'Pitkin|Gunnison|Garfield|Eagle',
    county_weights:
      '{"08097": 53.89, "08051": 23.92, "08045": 16.55, "08037": 5.64}',
    density: 13.4,
    imprecise: false,
    latitude: 39.2451,
    longitude: -107.20921,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81623',
  },
  {
    city: 'Collbran',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 1,
    imprecise: false,
    latitude: 39.24611,
    longitude: -107.77259,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81624',
  },
  {
    city: 'Craig',
    county_fips: 8081,
    county_fips_all: '08081',
    county: 'Moffat',
    county_names_all: 'Moffat',
    county_weights: '{"08081": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 40.70295,
    longitude: -107.74652,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81625',
  },
  {
    city: 'De Beque',
    county_fips: 8045,
    county_fips_all: '08045|08077',
    county: 'Garfield',
    county_names_all: 'Garfield|Mesa',
    county_weights: '{"08045": 76.59, "08077": 23.41}',
    density: 0.3,
    imprecise: false,
    latitude: 39.45769,
    longitude: -108.54627,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81630',
  },
  {
    city: 'Eagle',
    county_fips: 8037,
    county_fips_all: '08037',
    county: 'Eagle',
    county_names_all: 'Eagle',
    county_weights: '{"08037": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 39.63116,
    longitude: -106.77136,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81631',
  },
  {
    city: 'Edwards',
    county_fips: 8037,
    county_fips_all: '08037',
    county: 'Eagle',
    county_names_all: 'Eagle',
    county_weights: '{"08037": 100}',
    density: 36.5,
    imprecise: false,
    latitude: 39.62015,
    longitude: -106.61132,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81632',
  },
  {
    city: 'Parachute',
    county_fips: 8045,
    county_fips_all: '08045|08077',
    county: 'Garfield',
    county_names_all: 'Garfield|Mesa',
    county_weights: '{"08045": 97.09, "08077": 2.91}',
    density: 8.7,
    imprecise: false,
    latitude: 39.53722,
    longitude: -108.06022,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81635',
  },
  {
    city: 'Gypsum',
    county_fips: 8045,
    county_fips_all: '08045|08037',
    county: 'Garfield',
    county_names_all: 'Garfield|Eagle',
    county_weights: '{"08045": 53.99, "08037": 46.01}',
    density: 5.3,
    imprecise: false,
    latitude: 39.77162,
    longitude: -107.10065,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81637',
  },
  {
    city: 'Hamilton',
    county_fips: 8081,
    county_fips_all: '08081|08107',
    county: 'Moffat',
    county_names_all: 'Moffat|Routt',
    county_weights: '{"08081": 77.29, "08107": 22.71}',
    density: 0.1,
    imprecise: false,
    latitude: 40.30589,
    longitude: -107.64205,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81638',
  },
  {
    city: 'Hayden',
    county_fips: 8107,
    county_fips_all: '08107',
    county: 'Routt',
    county_names_all: 'Routt',
    county_weights: '{"08107": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 40.52636,
    longitude: -107.24457,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81639',
  },
  {
    city: 'Maybell',
    county_fips: 8081,
    county_fips_all: '08081',
    county: 'Moffat',
    county_names_all: 'Moffat',
    county_weights: '{"08081": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.69357,
    longitude: -108.51791,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81640',
  },
  {
    city: 'Meeker',
    county_fips: 8103,
    county_fips_all: '08103|08081',
    county: 'Rio Blanco',
    county_names_all: 'Rio Blanco|Moffat',
    county_weights: '{"08103": 83.0, "08081": 17.0}',
    density: 0.8,
    imprecise: false,
    latitude: 40.09112,
    longitude: -107.84699,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81641',
  },
  {
    city: 'Meredith',
    county_fips: 8097,
    county_fips_all: '08097',
    county: 'Pitkin',
    county_names_all: 'Pitkin',
    county_weights: '{"08097": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 39.31202,
    longitude: -106.58448,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81642',
  },
  {
    city: 'Mesa',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 39.11968,
    longitude: -108.15001,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81643',
  },
  {
    city: 'Minturn',
    county_fips: 8037,
    county_fips_all: '08037',
    county: 'Eagle',
    county_names_all: 'Eagle',
    county_weights: '{"08037": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 39.47634,
    longitude: -106.46779,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81645',
  },
  {
    city: 'Molina',
    county_fips: 8077,
    county_fips_all: '08077',
    county: 'Mesa',
    county_names_all: 'Mesa',
    county_weights: '{"08077": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 39.10875,
    longitude: -107.99199,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81646',
  },
  {
    city: 'New Castle',
    county_fips: 8045,
    county_fips_all: '08045',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"08045": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 39.57972,
    longitude: -107.5364,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81647',
  },
  {
    city: 'Rangely',
    county_fips: 8103,
    county_fips_all: '08103',
    county: 'Rio Blanco',
    county_names_all: 'Rio Blanco',
    county_weights: '{"08103": 100}',
    density: 1,
    imprecise: false,
    latitude: 39.95096,
    longitude: -108.78498,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81648',
  },
  {
    city: 'Red Cliff',
    county_fips: 8037,
    county_fips_all: '08037',
    county: 'Eagle',
    county_names_all: 'Eagle',
    county_weights: '{"08037": 100}',
    density: 1,
    imprecise: false,
    latitude: 39.46433,
    longitude: -106.31954,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81649',
  },
  {
    city: 'Rifle',
    county_fips: 8103,
    county_fips_all: '08103|08045',
    county: 'Rio Blanco',
    county_names_all: 'Rio Blanco|Garfield',
    county_weights: '{"08103": 59.93, "08045": 40.07}',
    density: 5.3,
    imprecise: false,
    latitude: 39.75926,
    longitude: -108.11201,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 14083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81650',
  },
  {
    city: 'Silt',
    county_fips: 8045,
    county_fips_all: '08045',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"08045": 100}',
    density: 23,
    imprecise: false,
    latitude: 39.472,
    longitude: -107.67082,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81652',
  },
  {
    city: 'Slater',
    county_fips: 8107,
    county_fips_all: '08107|08081',
    county: 'Routt',
    county_names_all: 'Routt|Moffat',
    county_weights: '{"08107": 87.48, "08081": 12.52}',
    density: 0,
    imprecise: false,
    latitude: 40.9144,
    longitude: -107.2242,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81653',
  },
  {
    city: 'Snowmass',
    county_fips: 8097,
    county_fips_all: '08097',
    county: 'Pitkin',
    county_names_all: 'Pitkin',
    county_weights: '{"08097": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 39.21462,
    longitude: -107.02597,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81654',
  },
  {
    city: 'Wolcott',
    county_fips: 8037,
    county_fips_all: '08037',
    county: 'Eagle',
    county_names_all: 'Eagle',
    county_weights: '{"08037": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 39.7477,
    longitude: -106.67821,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81655',
  },
  {
    city: 'Woody Creek',
    county_fips: 8097,
    county_fips_all: '08097',
    county: 'Pitkin',
    county_names_all: 'Pitkin',
    county_weights: '{"08097": 100}',
    density: 3,
    imprecise: false,
    latitude: 39.27948,
    longitude: -106.78711,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81656',
  },
  {
    city: 'Vail',
    county_fips: 8037,
    county_fips_all: '08037',
    county: 'Eagle',
    county_names_all: 'Eagle',
    county_weights: '{"08037": 100}',
    density: 16,
    imprecise: false,
    latitude: 39.64864,
    longitude: -106.32608,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81657',
  },
  {
    city: 'Cheyenne',
    county_fips: 56021,
    county_fips_all: '56021',
    county: 'Laramie',
    county_names_all: 'Laramie',
    county_weights: '{"56021": 100}',
    density: 267.4,
    imprecise: false,
    latitude: 41.095,
    longitude: -104.93265,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 38168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82001',
  },
  {
    city: 'Cheyenne',
    county_fips: 56021,
    county_fips_all: '56021',
    county: 'Laramie',
    county_names_all: 'Laramie',
    county_weights: '{"56021": 100}',
    density: 43.2,
    imprecise: false,
    latitude: 41.06231,
    longitude: -104.75591,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 21704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82007',
  },
  {
    city: 'Cheyenne',
    county_fips: 56021,
    county_fips_all: '56021',
    county: 'Laramie',
    county_names_all: 'Laramie',
    county_weights: '{"56021": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 41.38431,
    longitude: -104.85415,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82009',
  },
  {
    city: 'Albin',
    county_fips: 56021,
    county_fips_all: '56021',
    county: 'Laramie',
    county_names_all: 'Laramie',
    county_weights: '{"56021": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 41.43517,
    longitude: -104.21477,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82050',
  },
  {
    city: 'Bosler',
    county_fips: 56001,
    county_fips_all: '56001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"56001": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 41.60053,
    longitude: -105.64743,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 50,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82051',
  },
  {
    city: 'Buford',
    county_fips: 56001,
    county_fips_all: '56001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"56001": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.12399,
    longitude: -105.34802,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82052',
  },
  {
    city: 'Burns',
    county_fips: 56021,
    county_fips_all: '56021',
    county: 'Laramie',
    county_names_all: 'Laramie',
    county_weights: '{"56021": 100}',
    density: 3,
    imprecise: false,
    latitude: 41.24392,
    longitude: -104.348,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82053',
  },
  {
    city: 'Carpenter',
    county_fips: 56021,
    county_fips_all: '56021',
    county: 'Laramie',
    county_names_all: 'Laramie',
    county_weights: '{"56021": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 41.0647,
    longitude: -104.35899,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82054',
  },
  {
    city: 'Centennial',
    county_fips: 56001,
    county_fips_all: '56001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"56001": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 41.3483,
    longitude: -106.18191,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82055',
  },
  {
    city: 'Garrett',
    county_fips: 56001,
    county_fips_all: '56001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"56001": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 42.13817,
    longitude: -105.63358,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82058',
  },
  {
    city: 'Granite Canon',
    county_fips: 56021,
    county_fips_all: '56021',
    county: 'Laramie',
    county_names_all: 'Laramie',
    county_weights: '{"56021": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 41.05681,
    longitude: -105.17714,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82059',
  },
  {
    city: 'Hillsdale',
    county_fips: 56021,
    county_fips_all: '56021',
    county: 'Laramie',
    county_names_all: 'Laramie',
    county_weights: '{"56021": 100}',
    density: 5,
    imprecise: false,
    latitude: 41.22526,
    longitude: -104.51505,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82060',
  },
  {
    city: 'Jelm',
    county_fips: 8069,
    county_fips_all: '08069|56001',
    county: 'Larimer',
    county_names_all: 'Larimer|Albany',
    county_weights: '{"08069": 79.7, "56001": 20.3}',
    density: 0.1,
    imprecise: false,
    latitude: 40.87554,
    longitude: -105.9889,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82063',
  },
  {
    city: 'Laramie',
    county_fips: 56001,
    county_fips_all: '56001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"56001": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 41.21404,
    longitude: -105.85037,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 20144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82070',
  },
  {
    city: 'Laramie',
    county_fips: 56001,
    county_fips_all: '56001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"56001": 100}',
    density: 34.6,
    imprecise: false,
    latitude: 41.42557,
    longitude: -105.55849,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82072',
  },
  {
    city: 'Laramie',
    county_fips: 56001,
    county_fips_all: '56001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"56001": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 41.16408,
    longitude: -105.43228,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82073',
  },
  {
    city: 'Meriden',
    county_fips: 56021,
    county_fips_all: '56021',
    county: 'Laramie',
    county_names_all: 'Laramie',
    county_weights: '{"56021": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 41.52319,
    longitude: -104.40653,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 23,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82081',
  },
  {
    city: 'Pine Bluffs',
    county_fips: 56021,
    county_fips_all: '56021|31007|31105|08123',
    county: 'Laramie',
    county_names_all: 'Laramie|Banner|Kimball|Weld',
    county_weights:
      '{"56021": 70.63, "31007": 16.91, "31105": 10.66, "08123": 1.8}',
    density: 2.3,
    imprecise: false,
    latitude: 41.2632,
    longitude: -104.09359,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82082',
  },
  {
    city: 'Rock River',
    county_fips: 56001,
    county_fips_all: '56001|56007',
    county: 'Albany',
    county_names_all: 'Albany|Carbon',
    county_weights: '{"56001": 65.36, "56007": 34.64}',
    density: 0.5,
    imprecise: false,
    latitude: 41.72291,
    longitude: -105.99118,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82083',
  },
  {
    city: 'Tie Siding',
    county_fips: 56001,
    county_fips_all: '56001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"56001": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 41.04764,
    longitude: -105.52494,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82084',
  },
  {
    city: 'Yellowstone National Park',
    county_fips: 56029,
    county_fips_all: '56029|56039',
    county: 'Park',
    county_names_all: 'Park|Teton',
    county_weights: '{"56029": 55.76, "56039": 44.24}',
    density: 0.1,
    imprecise: false,
    latitude: 44.57439,
    longitude: -110.51807,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82190',
  },
  {
    city: 'Wheatland',
    county_fips: 56031,
    county_fips_all: '56031|56001',
    county: 'Platte',
    county_names_all: 'Platte|Albany',
    county_weights: '{"56031": 71.7, "56001": 28.3}',
    density: 1.5,
    imprecise: false,
    latitude: 42.01049,
    longitude: -105.11328,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82201',
  },
  {
    city: 'Chugwater',
    county_fips: 56031,
    county_fips_all: '56031|56015',
    county: 'Platte',
    county_names_all: 'Platte|Goshen',
    county_weights: '{"56031": 74.31, "56015": 25.69}',
    density: 0.4,
    imprecise: false,
    latitude: 41.73214,
    longitude: -104.77981,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82210',
  },
  {
    city: 'Fort Laramie',
    county_fips: 56015,
    county_fips_all: '56015',
    county: 'Goshen',
    county_names_all: 'Goshen',
    county_weights: '{"56015": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 42.26126,
    longitude: -104.51995,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82212',
  },
  {
    city: 'Glendo',
    county_fips: 56031,
    county_fips_all: '56031',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"56031": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 42.50216,
    longitude: -105.00672,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82213',
  },
  {
    city: 'Guernsey',
    county_fips: 56031,
    county_fips_all: '56031',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"56031": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 42.26421,
    longitude: -104.75104,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82214',
  },
  {
    city: 'Hartville',
    county_fips: 56031,
    county_fips_all: '56031',
    county: 'Platte',
    county_names_all: 'Platte',
    county_weights: '{"56031": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 42.39738,
    longitude: -104.71507,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82215',
  },
  {
    city: 'Hawk Springs',
    county_fips: 56015,
    county_fips_all: '56015',
    county: 'Goshen',
    county_names_all: 'Goshen',
    county_weights: '{"56015": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 41.76223,
    longitude: -104.17504,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 79,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82217',
  },
  {
    city: 'Huntley',
    county_fips: 56015,
    county_fips_all: '56015',
    county: 'Goshen',
    county_names_all: 'Goshen',
    county_weights: '{"56015": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 41.93623,
    longitude: -104.14004,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 13,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82218',
  },
  {
    city: 'Jay Em',
    county_fips: 56015,
    county_fips_all: '56015',
    county: 'Goshen',
    county_names_all: 'Goshen',
    county_weights: '{"56015": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 42.4973,
    longitude: -104.50627,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82219',
  },
  {
    city: 'Lagrange',
    county_fips: 56015,
    county_fips_all: '56015|56021',
    county: 'Goshen',
    county_names_all: 'Goshen|Laramie',
    county_weights: '{"56015": 97.94, "56021": 2.06}',
    density: 0.7,
    imprecise: false,
    latitude: 41.63816,
    longitude: -104.34264,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82221',
  },
  {
    city: 'Lance Creek',
    county_fips: 56027,
    county_fips_all: '56027',
    county: 'Niobrara',
    county_names_all: 'Niobrara',
    county_weights: '{"56027": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 43.16311,
    longitude: -104.64988,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82222',
  },
  {
    city: 'Lingle',
    county_fips: 56015,
    county_fips_all: '56015',
    county: 'Goshen',
    county_names_all: 'Goshen',
    county_weights: '{"56015": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 42.12035,
    longitude: -104.38503,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82223',
  },
  {
    city: 'Lost Springs',
    county_fips: 56009,
    county_fips_all: '56009|56027',
    county: 'Converse',
    county_names_all: 'Converse|Niobrara',
    county_weights: '{"56009": 51.8, "56027": 48.2}',
    density: 0,
    imprecise: false,
    latitude: 42.93677,
    longitude: -104.88811,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82224',
  },
  {
    city: 'Lusk',
    county_fips: 56027,
    county_fips_all: '56027|56015',
    county: 'Niobrara',
    county_names_all: 'Niobrara|Goshen',
    county_weights: '{"56027": 94.36, "56015": 5.64}',
    density: 0.6,
    imprecise: false,
    latitude: 42.95428,
    longitude: -104.31385,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82225',
  },
  {
    city: 'Manville',
    county_fips: 56027,
    county_fips_all: '56027',
    county: 'Niobrara',
    county_names_all: 'Niobrara',
    county_weights: '{"56027": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 42.72083,
    longitude: -104.72875,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82227',
  },
  {
    city: 'Shawnee',
    county_fips: 56009,
    county_fips_all: '56009',
    county: 'Converse',
    county_names_all: 'Converse',
    county_weights: '{"56009": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 42.85613,
    longitude: -104.9863,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82229',
  },
  {
    city: 'Torrington',
    county_fips: 56015,
    county_fips_all: '56015',
    county: 'Goshen',
    county_names_all: 'Goshen',
    county_weights: '{"56015": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 42.23064,
    longitude: -104.17824,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82240',
  },
  {
    city: 'Van Tassell',
    county_fips: 56027,
    county_fips_all: '56027|56015',
    county: 'Niobrara',
    county_names_all: 'Niobrara|Goshen',
    county_weights: '{"56027": 87.39, "56015": 12.61}',
    density: 0.6,
    imprecise: false,
    latitude: 42.67694,
    longitude: -104.13886,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82242',
  },
  {
    city: 'Veteran',
    county_fips: 56015,
    county_fips_all: '56015',
    county: 'Goshen',
    county_names_all: 'Goshen',
    county_weights: '{"56015": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 41.99442,
    longitude: -104.41451,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82243',
  },
  {
    city: 'Yoder',
    county_fips: 56015,
    county_fips_all: '56015',
    county: 'Goshen',
    county_names_all: 'Goshen',
    county_weights: '{"56015": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 41.87602,
    longitude: -104.44228,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82244',
  },
  {
    city: 'Rawlins',
    county_fips: 56007,
    county_fips_all: '56007|56037',
    county: 'Carbon',
    county_names_all: 'Carbon|Sweetwater',
    county_weights: '{"56007": 64.34, "56037": 35.66}',
    density: 3.4,
    imprecise: false,
    latitude: 41.98163,
    longitude: -107.47745,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82301',
  },
  {
    city: 'Jeffrey City',
    county_fips: 56013,
    county_fips_all: '56013',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"56013": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.44566,
    longitude: -107.8775,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82310',
  },
  {
    city: 'Baggs',
    county_fips: 56007,
    county_fips_all: '56007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"56007": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 41.15921,
    longitude: -107.69697,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82321',
  },
  {
    city: 'Bairoil',
    county_fips: 56037,
    county_fips_all: '56037|56013',
    county: 'Sweetwater',
    county_names_all: 'Sweetwater|Fremont',
    county_weights: '{"56037": 99.79, "56013": 0.21}',
    density: 10.9,
    imprecise: false,
    latitude: 42.24643,
    longitude: -107.54816,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82322',
  },
  {
    city: 'Dixon',
    county_fips: 56007,
    county_fips_all: '56007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"56007": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 41.0308,
    longitude: -107.52201,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82323',
  },
  {
    city: 'Elk Mountain',
    county_fips: 56007,
    county_fips_all: '56007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"56007": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 41.64509,
    longitude: -106.43721,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82324',
  },
  {
    city: 'Encampment',
    county_fips: 56007,
    county_fips_all: '56007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"56007": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 41.1628,
    longitude: -106.7919,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82325',
  },
  {
    city: 'Hanna',
    county_fips: 56007,
    county_fips_all: '56007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"56007": 100}',
    density: 1,
    imprecise: false,
    latitude: 42.17354,
    longitude: -106.69289,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82327',
  },
  {
    city: 'Medicine Bow',
    county_fips: 56007,
    county_fips_all: '56007|56001',
    county: 'Carbon',
    county_names_all: 'Carbon|Albany',
    county_weights: '{"56007": 57.84, "56001": 42.16}',
    density: 0.6,
    imprecise: false,
    latitude: 42.09073,
    longitude: -106.09959,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82329',
  },
  {
    city: 'Saratoga',
    county_fips: 56007,
    county_fips_all: '56007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"56007": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 41.38607,
    longitude: -106.82252,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82331',
  },
  {
    city: 'Savery',
    county_fips: 56007,
    county_fips_all: '56007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"56007": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 41.06314,
    longitude: -107.3016,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82332',
  },
  {
    city: 'Sinclair',
    county_fips: 56007,
    county_fips_all: '56007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"56007": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 41.92837,
    longitude: -106.9679,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82334',
  },
  {
    city: 'Walcott',
    county_fips: 56007,
    county_fips_all: '56007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"56007": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.76174,
    longitude: -106.82553,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82335',
  },
  {
    city: 'Wamsutter',
    county_fips: 56037,
    county_fips_all: '56037',
    county: 'Sweetwater',
    county_names_all: 'Sweetwater',
    county_weights: '{"56037": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 41.71046,
    longitude: -108.16368,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82336',
  },
  {
    city: 'Worland',
    county_fips: 56043,
    county_fips_all: '56043|56017|56003',
    county: 'Washakie',
    county_names_all: 'Washakie|Hot Springs|Big Horn',
    county_weights: '{"56043": 83.29, "56017": 14.14, "56003": 2.57}',
    density: 4.8,
    imprecise: false,
    latitude: 44.00089,
    longitude: -108.1677,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82401',
  },
  {
    city: 'Basin',
    county_fips: 56003,
    county_fips_all: '56003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"56003": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 44.37297,
    longitude: -108.15093,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82410',
  },
  {
    city: 'Burlington',
    county_fips: 56003,
    county_fips_all: '56003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"56003": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 44.44995,
    longitude: -108.47663,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82411',
  },
  {
    city: 'Byron',
    county_fips: 56003,
    county_fips_all: '56003|56029',
    county: 'Big Horn',
    county_names_all: 'Big Horn|Park',
    county_weights: '{"56003": 99.86, "56029": 0.14}',
    density: 20.4,
    imprecise: false,
    latitude: 44.79014,
    longitude: -108.55286,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82412',
  },
  {
    city: 'Cody',
    county_fips: 56029,
    county_fips_all: '56029',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"56029": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 44.45727,
    longitude: -109.59671,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82414',
  },
  {
    city: 'Cowley',
    county_fips: 56003,
    county_fips_all: '56003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"56003": 100}',
    density: 6,
    imprecise: false,
    latitude: 44.92254,
    longitude: -108.46149,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82420',
  },
  {
    city: 'Deaver',
    county_fips: 56029,
    county_fips_all: '56029|56003',
    county: 'Park',
    county_names_all: 'Park|Big Horn',
    county_weights: '{"56029": 50.02, "56003": 49.98}',
    density: 2,
    imprecise: false,
    latitude: 44.88399,
    longitude: -108.60497,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82421',
  },
  {
    city: 'Emblem',
    county_fips: 56003,
    county_fips_all: '56003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"56003": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 44.49768,
    longitude: -108.37943,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 62,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82422',
  },
  {
    city: 'Frannie',
    county_fips: 56003,
    county_fips_all: '56003|56029',
    county: 'Big Horn',
    county_names_all: 'Big Horn|Park',
    county_weights: '{"56003": 90.11, "56029": 9.89}',
    density: 6.5,
    imprecise: false,
    latitude: 44.98029,
    longitude: -108.58432,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82423',
  },
  {
    city: 'Greybull',
    county_fips: 56003,
    county_fips_all: '56003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"56003": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 44.51595,
    longitude: -108.02938,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82426',
  },
  {
    city: 'Hyattville',
    county_fips: 56003,
    county_fips_all: '56003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"56003": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 44.29866,
    longitude: -107.59032,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82428',
  },
  {
    city: 'Kirby',
    county_fips: 56017,
    county_fips_all: '56017',
    county: 'Hot Springs',
    county_names_all: 'Hot Springs',
    county_weights: '{"56017": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 43.80433,
    longitude: -108.17898,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 77,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82430',
  },
  {
    city: 'Lovell',
    county_fips: 56003,
    county_fips_all: '56003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"56003": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 44.87059,
    longitude: -108.16218,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82431',
  },
  {
    city: 'Manderson',
    county_fips: 56003,
    county_fips_all: '56003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"56003": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 44.23641,
    longitude: -107.88175,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82432',
  },
  {
    city: 'Meeteetse',
    county_fips: 56029,
    county_fips_all: '56029',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"56029": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 44.0616,
    longitude: -109.12558,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82433',
  },
  {
    city: 'Otto',
    county_fips: 56003,
    county_fips_all: '56003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"56003": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 44.34726,
    longitude: -108.30767,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82434',
  },
  {
    city: 'Powell',
    county_fips: 56029,
    county_fips_all: '56029|56003',
    county: 'Park',
    county_names_all: 'Park|Big Horn',
    county_weights: '{"56029": 95.53, "56003": 4.47}',
    density: 6.1,
    imprecise: false,
    latitude: 44.82409,
    longitude: -109.0348,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82435',
  },
  {
    city: 'Ralston',
    county_fips: 56029,
    county_fips_all: '56029',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"56029": 100}',
    density: 43.1,
    imprecise: false,
    latitude: 44.71743,
    longitude: -108.86781,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82440',
  },
  {
    city: 'Shell',
    county_fips: 56003,
    county_fips_all: '56003',
    county: 'Big Horn',
    county_names_all: 'Big Horn',
    county_weights: '{"56003": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 44.58025,
    longitude: -107.60799,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82441',
  },
  {
    city: 'Ten Sleep',
    county_fips: 56043,
    county_fips_all: '56043',
    county: 'Washakie',
    county_names_all: 'Washakie',
    county_weights: '{"56043": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 43.92096,
    longitude: -107.31087,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82442',
  },
  {
    city: 'Thermopolis',
    county_fips: 56017,
    county_fips_all: '56017',
    county: 'Hot Springs',
    county_names_all: 'Hot Springs',
    county_weights: '{"56017": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 43.71794,
    longitude: -108.48023,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82443',
  },
  {
    city: 'Wapiti',
    county_fips: 56029,
    county_fips_all: '56029',
    county: 'Park',
    county_names_all: 'Park',
    county_weights: '{"56029": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 44.50398,
    longitude: -109.43379,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82450',
  },
  {
    city: 'Riverton',
    county_fips: 56013,
    county_fips_all: '56013',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"56013": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 43.03325,
    longitude: -108.24936,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 19413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82501',
  },
  {
    city: 'Arapahoe',
    county_fips: 56013,
    county_fips_all: '56013',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"56013": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 42.99294,
    longitude: -108.6055,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82510',
  },
  {
    city: 'Crowheart',
    county_fips: 56013,
    county_fips_all: '56013',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"56013": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 43.1639,
    longitude: -109.24974,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82512',
  },
  {
    city: 'Dubois',
    county_fips: 56013,
    county_fips_all: '56013',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"56013": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 43.59737,
    longitude: -109.61913,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1627,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82513',
  },
  {
    city: 'Fort Washakie',
    county_fips: 56013,
    county_fips_all: '56013',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"56013": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 43.01997,
    longitude: -109.01,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82514',
  },
  {
    city: 'Hudson',
    county_fips: 56013,
    county_fips_all: '56013',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"56013": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 42.89717,
    longitude: -108.56688,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82515',
  },
  {
    city: 'Kinnear',
    county_fips: 56013,
    county_fips_all: '56013',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"56013": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 43.21485,
    longitude: -108.83195,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82516',
  },
  {
    city: 'Lander',
    county_fips: 56013,
    county_fips_all: '56013',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"56013": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 42.65919,
    longitude: -108.63282,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 13266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82520',
  },
  {
    city: 'Pavillion',
    county_fips: 56013,
    county_fips_all: '56013',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"56013": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 43.41253,
    longitude: -108.85636,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82523',
  },
  {
    city: 'Casper',
    county_fips: 56025,
    county_fips_all: '56025',
    county: 'Natrona',
    county_names_all: 'Natrona',
    county_weights: '{"56025": 100}',
    density: 21.5,
    imprecise: false,
    latitude: 43.0655,
    longitude: -106.34618,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 26721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82601',
  },
  {
    city: 'Casper',
    county_fips: 56025,
    county_fips_all: '56025',
    county: 'Natrona',
    county_names_all: 'Natrona',
    county_weights: '{"56025": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 42.91751,
    longitude: -106.7084,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 27487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82604',
  },
  {
    city: 'Casper',
    county_fips: 56025,
    county_fips_all: '56025',
    county: 'Natrona',
    county_names_all: 'Natrona',
    county_weights: '{"56025": 100}',
    density: 110.8,
    imprecise: false,
    latitude: 42.77773,
    longitude: -106.18937,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82609',
  },
  {
    city: 'Alcova',
    county_fips: 56025,
    county_fips_all: '56025|56007',
    county: 'Natrona',
    county_names_all: 'Natrona|Carbon',
    county_weights: '{"56025": 92.34, "56007": 7.66}',
    density: 0.2,
    imprecise: false,
    latitude: 42.52434,
    longitude: -107.08132,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82620',
  },
  {
    city: 'Arminto',
    county_fips: 56025,
    county_fips_all: '56025',
    county: 'Natrona',
    county_names_all: 'Natrona',
    county_weights: '{"56025": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.33432,
    longitude: -107.25595,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82630',
  },
  {
    city: 'Douglas',
    county_fips: 56009,
    county_fips_all: '56009|56027',
    county: 'Converse',
    county_names_all: 'Converse|Niobrara',
    county_weights: '{"56009": 98.96, "56027": 1.04}',
    density: 1.4,
    imprecise: false,
    latitude: 42.99525,
    longitude: -105.39874,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82633',
  },
  {
    city: 'Edgerton',
    county_fips: 56025,
    county_fips_all: '56025',
    county: 'Natrona',
    county_names_all: 'Natrona',
    county_weights: '{"56025": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 43.4218,
    longitude: -106.21834,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82635',
  },
  {
    city: 'Evansville',
    county_fips: 56025,
    county_fips_all: '56025|56009',
    county: 'Natrona',
    county_names_all: 'Natrona|Converse',
    county_weights: '{"56025": 97.57, "56009": 2.43}',
    density: 12.3,
    imprecise: false,
    latitude: 42.83473,
    longitude: -106.14286,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82636',
  },
  {
    city: 'Glenrock',
    county_fips: 56009,
    county_fips_all: '56009',
    county: 'Converse',
    county_names_all: 'Converse',
    county_weights: '{"56009": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 42.76679,
    longitude: -105.88228,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82637',
  },
  {
    city: 'Hiland',
    county_fips: 56025,
    county_fips_all: '56025',
    county: 'Natrona',
    county_names_all: 'Natrona',
    county_weights: '{"56025": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 43.0667,
    longitude: -107.25585,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82638',
  },
  {
    city: 'Kaycee',
    county_fips: 56019,
    county_fips_all: '56019|56025',
    county: 'Johnson',
    county_names_all: 'Johnson|Natrona',
    county_weights: '{"56019": 94.35, "56025": 5.65}',
    density: 0.3,
    imprecise: false,
    latitude: 43.73555,
    longitude: -106.6978,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82639',
  },
  {
    city: 'Linch',
    county_fips: 56019,
    county_fips_all: '56019|56005',
    county: 'Johnson',
    county_names_all: 'Johnson|Campbell',
    county_weights: '{"56019": 99.8, "56005": 0.2}',
    density: 2.6,
    imprecise: false,
    latitude: 43.55214,
    longitude: -106.11811,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82640',
  },
  {
    city: 'Lysite',
    county_fips: 56013,
    county_fips_all: '56013|56025',
    county: 'Fremont',
    county_names_all: 'Fremont|Natrona',
    county_weights: '{"56013": 86.66, "56025": 13.34}',
    density: 0,
    imprecise: false,
    latitude: 43.2799,
    longitude: -107.65797,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82642',
  },
  {
    city: 'Midwest',
    county_fips: 56025,
    county_fips_all: '56025',
    county: 'Natrona',
    county_names_all: 'Natrona',
    county_weights: '{"56025": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 43.43973,
    longitude: -106.27359,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82643',
  },
  {
    city: 'Mills',
    county_fips: 56025,
    county_fips_all: '56025',
    county: 'Natrona',
    county_names_all: 'Natrona',
    county_weights: '{"56025": 100}',
    density: 996.9,
    imprecise: false,
    latitude: 42.84303,
    longitude: -106.37437,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82644',
  },
  {
    city: 'Natrona',
    county_fips: 56025,
    county_fips_all: '56025',
    county: 'Natrona',
    county_names_all: 'Natrona',
    county_weights: '{"56025": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.96297,
    longitude: -106.79617,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82646',
  },
  {
    city: 'Powder River',
    county_fips: 56025,
    county_fips_all: '56025',
    county: 'Natrona',
    county_names_all: 'Natrona',
    county_weights: '{"56025": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.14749,
    longitude: -107.04194,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 24,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82648',
  },
  {
    city: 'Shoshoni',
    county_fips: 56013,
    county_fips_all: '56013',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"56013": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 43.27229,
    longitude: -108.04155,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82649',
  },
  {
    city: 'Newcastle',
    county_fips: 56045,
    county_fips_all: '56045|56027|56005|46033|46103',
    county: 'Weston',
    county_names_all: 'Weston|Niobrara|Campbell|Custer|Pennington',
    county_weights:
      '{"56045": 76.6, "56027": 9.34, "56005": 6.18, "46033": 4.38, "46103": 3.5}',
    density: 1.2,
    imprecise: false,
    latitude: 43.71185,
    longitude: -104.4451,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82701',
  },
  {
    city: 'Aladdin',
    county_fips: 56011,
    county_fips_all: '56011',
    county: 'Crook',
    county_names_all: 'Crook',
    county_weights: '{"56011": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 44.71488,
    longitude: -104.28465,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82710',
  },
  {
    city: 'Alva',
    county_fips: 56011,
    county_fips_all: '56011',
    county: 'Crook',
    county_names_all: 'Crook',
    county_weights: '{"56011": 100}',
    density: 1,
    imprecise: false,
    latitude: 44.71157,
    longitude: -104.48062,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82711',
  },
  {
    city: 'Beulah',
    county_fips: 56011,
    county_fips_all: '56011',
    county: 'Crook',
    county_names_all: 'Crook',
    county_weights: '{"56011": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 44.52594,
    longitude: -104.12372,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82712',
  },
  {
    city: 'Devils Tower',
    county_fips: 56011,
    county_fips_all: '56011',
    county: 'Crook',
    county_names_all: 'Crook',
    county_weights: '{"56011": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 44.5519,
    longitude: -104.68009,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82714',
  },
  {
    city: 'Gillette',
    county_fips: 56005,
    county_fips_all: '56005',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"56005": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 44.54033,
    longitude: -105.64601,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82716',
  },
  {
    city: 'Gillette',
    county_fips: 56005,
    county_fips_all: '56005',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"56005": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 43.91777,
    longitude: -105.61603,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 26619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82718',
  },
  {
    city: 'Hulett',
    county_fips: 56011,
    county_fips_all: '56011',
    county: 'Crook',
    county_names_all: 'Crook',
    county_weights: '{"56011": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 44.79324,
    longitude: -104.67241,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82720',
  },
  {
    city: 'Moorcroft',
    county_fips: 56011,
    county_fips_all: '56011',
    county: 'Crook',
    county_names_all: 'Crook',
    county_weights: '{"56011": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 44.46199,
    longitude: -104.89808,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82721',
  },
  {
    city: 'Osage',
    county_fips: 56045,
    county_fips_all: '56045',
    county: 'Weston',
    county_names_all: 'Weston',
    county_weights: '{"56045": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 43.98898,
    longitude: -104.42397,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82723',
  },
  {
    city: 'Recluse',
    county_fips: 56005,
    county_fips_all: '56005',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"56005": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 44.87752,
    longitude: -105.70974,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82725',
  },
  {
    city: 'Rozet',
    county_fips: 56005,
    county_fips_all: '56005|56011',
    county: 'Campbell',
    county_names_all: 'Campbell|Crook',
    county_weights: '{"56005": 94.97, "56011": 5.03}',
    density: 1.8,
    imprecise: false,
    latitude: 44.33595,
    longitude: -105.19426,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82727',
  },
  {
    city: 'Sundance',
    county_fips: 56011,
    county_fips_all: '56011|56045',
    county: 'Crook',
    county_names_all: 'Crook|Weston',
    county_weights: '{"56011": 93.81, "56045": 6.19}',
    density: 1.7,
    imprecise: false,
    latitude: 44.36384,
    longitude: -104.38734,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82729',
  },
  {
    city: 'Upton',
    county_fips: 56045,
    county_fips_all: '56045|56011',
    county: 'Weston',
    county_names_all: 'Weston|Crook',
    county_weights: '{"56045": 89.92, "56011": 10.08}',
    density: 0.9,
    imprecise: false,
    latitude: 44.04378,
    longitude: -104.70031,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82730',
  },
  {
    city: 'Wright',
    county_fips: 56005,
    county_fips_all: '56005',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"56005": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 43.725,
    longitude: -105.57871,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82732',
  },
  {
    city: 'Sheridan',
    county_fips: 56033,
    county_fips_all: '56033|30003',
    county: 'Sheridan',
    county_names_all: 'Sheridan|Big Horn',
    county_weights: '{"56033": 97.44, "30003": 2.56}',
    density: 19.3,
    imprecise: false,
    latitude: 44.83618,
    longitude: -106.89258,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 26310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82801',
  },
  {
    city: 'Arvada',
    county_fips: 56005,
    county_fips_all: '56005|56033|56019',
    county: 'Campbell',
    county_names_all: 'Campbell|Sheridan|Johnson',
    county_weights: '{"56005": 34.45, "56033": 33.59, "56019": 31.95}',
    density: 0.1,
    imprecise: false,
    latitude: 44.66424,
    longitude: -106.0669,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82831',
  },
  {
    city: 'Banner',
    county_fips: 56033,
    county_fips_all: '56033|56019',
    county: 'Sheridan',
    county_names_all: 'Sheridan|Johnson',
    county_weights: '{"56033": 79.4, "56019": 20.6}',
    density: 4,
    imprecise: false,
    latitude: 44.59442,
    longitude: -106.75233,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82832',
  },
  {
    city: 'Big Horn',
    county_fips: 56033,
    county_fips_all: '56033',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"56033": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 44.61601,
    longitude: -107.12966,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82833',
  },
  {
    city: 'Buffalo',
    county_fips: 56019,
    county_fips_all: '56019',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"56019": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 44.25386,
    longitude: -106.74481,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82834',
  },
  {
    city: 'Clearmont',
    county_fips: 56033,
    county_fips_all: '56033',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"56033": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 44.75856,
    longitude: -106.36918,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82835',
  },
  {
    city: 'Dayton',
    county_fips: 56033,
    county_fips_all: '56033',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"56033": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 44.83701,
    longitude: -107.57589,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82836',
  },
  {
    city: 'Leiter',
    county_fips: 56033,
    county_fips_all: '56033',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"56033": 100}',
    density: 1,
    imprecise: false,
    latitude: 44.72549,
    longitude: -106.28169,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82837',
  },
  {
    city: 'Parkman',
    county_fips: 56033,
    county_fips_all: '56033',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"56033": 100}',
    density: 1,
    imprecise: false,
    latitude: 44.93793,
    longitude: -107.4839,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82838',
  },
  {
    city: 'Ranchester',
    county_fips: 56033,
    county_fips_all: '56033',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"56033": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 44.92887,
    longitude: -107.15762,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82839',
  },
  {
    city: 'Story',
    county_fips: 56033,
    county_fips_all: '56033',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"56033": 100}',
    density: 24.3,
    imprecise: false,
    latitude: 44.57143,
    longitude: -106.93956,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82842',
  },
  {
    city: 'Wolf',
    county_fips: 56033,
    county_fips_all: '56033',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"56033": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 44.80405,
    longitude: -107.19965,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82844',
  },
  {
    city: 'Wyarno',
    county_fips: 56033,
    county_fips_all: '56033',
    county: 'Sheridan',
    county_names_all: 'Sheridan',
    county_weights: '{"56033": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 44.76416,
    longitude: -106.70382,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82845',
  },
  {
    city: 'Rock Springs',
    county_fips: 56037,
    county_fips_all: '56037',
    county: 'Sweetwater',
    county_names_all: 'Sweetwater',
    county_weights: '{"56037": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 41.38121,
    longitude: -109.02469,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 27198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82901',
  },
  {
    city: 'Bondurant',
    county_fips: 56035,
    county_fips_all: '56035',
    county: 'Sublette',
    county_names_all: 'Sublette',
    county_weights: '{"56035": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 43.13507,
    longitude: -110.43426,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82922',
  },
  {
    city: 'Boulder',
    county_fips: 56035,
    county_fips_all: '56035',
    county: 'Sublette',
    county_names_all: 'Sublette',
    county_weights: '{"56035": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 42.61609,
    longitude: -109.40099,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82923',
  },
  {
    city: 'Cora',
    county_fips: 56035,
    county_fips_all: '56035|56039',
    county: 'Sublette',
    county_names_all: 'Sublette|Teton',
    county_weights: '{"56035": 94.88, "56039": 5.12}',
    density: 0.2,
    imprecise: false,
    latitude: 43.23123,
    longitude: -109.89386,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82925',
  },
  {
    city: 'Evanston',
    county_fips: 49043,
    county_fips_all: '49043|56041',
    county: 'Summit',
    county_names_all: 'Summit|Uinta',
    county_weights: '{"49043": 70.29, "56041": 29.71}',
    density: 5.8,
    imprecise: false,
    latitude: 40.98028,
    longitude: -110.5964,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 14435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82930',
  },
  {
    city: 'Farson',
    county_fips: 56037,
    county_fips_all: '56037',
    county: 'Sweetwater',
    county_names_all: 'Sweetwater',
    county_weights: '{"56037": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 42.1219,
    longitude: -109.38993,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82932',
  },
  {
    city: 'Fort Bridger',
    county_fips: 56041,
    county_fips_all: '56041',
    county: 'Uinta',
    county_names_all: 'Uinta',
    county_weights: '{"56041": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 41.2686,
    longitude: -110.45446,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82933',
  },
  {
    city: 'Granger',
    county_fips: 56037,
    county_fips_all: '56037',
    county: 'Sweetwater',
    county_names_all: 'Sweetwater',
    county_weights: '{"56037": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 41.61247,
    longitude: -109.99564,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82934',
  },
  {
    city: 'Green River',
    county_fips: 56037,
    county_fips_all: '56037',
    county: 'Sweetwater',
    county_names_all: 'Sweetwater',
    county_weights: '{"56037": 100}',
    density: 34.5,
    imprecise: false,
    latitude: 41.67746,
    longitude: -109.66001,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82935',
  },
  {
    city: 'Lonetree',
    county_fips: 56041,
    county_fips_all: '56041',
    county: 'Uinta',
    county_names_all: 'Uinta',
    county_weights: '{"56041": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 41.05725,
    longitude: -110.18239,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82936',
  },
  {
    city: 'Lyman',
    county_fips: 56041,
    county_fips_all: '56041',
    county: 'Uinta',
    county_names_all: 'Uinta',
    county_weights: '{"56041": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 41.3491,
    longitude: -110.2634,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82937',
  },
  {
    city: 'Mountain View',
    county_fips: 56041,
    county_fips_all: '56041',
    county: 'Uinta',
    county_names_all: 'Uinta',
    county_weights: '{"56041": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 41.22068,
    longitude: -110.32357,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82939',
  },
  {
    city: 'Pinedale',
    county_fips: 56035,
    county_fips_all: '56035',
    county: 'Sublette',
    county_names_all: 'Sublette',
    county_weights: '{"56035": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 42.99919,
    longitude: -109.90869,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82941',
  },
  {
    city: 'Point Of Rocks',
    county_fips: 56037,
    county_fips_all: '56037',
    county: 'Sweetwater',
    county_names_all: 'Sweetwater',
    county_weights: '{"56037": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 41.70234,
    longitude: -108.77539,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82942',
  },
  {
    city: 'Reliance',
    county_fips: 56037,
    county_fips_all: '56037',
    county: 'Sweetwater',
    county_names_all: 'Sweetwater',
    county_weights: '{"56037": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 41.70197,
    longitude: -109.18399,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82943',
  },
  {
    city: 'Robertson',
    county_fips: 56041,
    county_fips_all: '56041',
    county: 'Uinta',
    county_names_all: 'Uinta',
    county_weights: '{"56041": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 41.12199,
    longitude: -110.49746,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82944',
  },
  {
    city: 'Superior',
    county_fips: 56037,
    county_fips_all: '56037',
    county: 'Sweetwater',
    county_names_all: 'Sweetwater',
    county_weights: '{"56037": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 41.72007,
    longitude: -108.9389,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82945',
  },
  {
    city: 'Jackson',
    county_fips: 56039,
    county_fips_all: '56039',
    county: 'Teton',
    county_names_all: 'Teton',
    county_weights: '{"56039": 100}',
    density: 14,
    imprecise: false,
    latitude: 43.4094,
    longitude: -110.60884,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 17445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83001',
  },
  {
    city: 'Kelly',
    county_fips: 56039,
    county_fips_all: '56039',
    county: 'Teton',
    county_names_all: 'Teton',
    county_weights: '{"56039": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 43.58837,
    longitude: -110.43192,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83011',
  },
  {
    city: 'Moose',
    county_fips: 56039,
    county_fips_all: '56039',
    county: 'Teton',
    county_names_all: 'Teton',
    county_weights: '{"56039": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 43.7073,
    longitude: -110.75036,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83012',
  },
  {
    city: 'Moran',
    county_fips: 56039,
    county_fips_all: '56039',
    county: 'Teton',
    county_names_all: 'Teton',
    county_weights: '{"56039": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 43.95666,
    longitude: -110.45191,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83013',
  },
  {
    city: 'Wilson',
    county_fips: 56039,
    county_fips_all: '56039',
    county: 'Teton',
    county_names_all: 'Teton',
    county_weights: '{"56039": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 43.458,
    longitude: -110.93746,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3098,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83014',
  },
  {
    city: 'Teton Village',
    county_fips: 56039,
    county_fips_all: '56039',
    county: 'Teton',
    county_names_all: 'Teton',
    county_weights: '{"56039": 100}',
    density: 22.2,
    imprecise: false,
    latitude: 43.59371,
    longitude: -110.82814,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83025',
  },
  {
    city: 'Kemmerer',
    county_fips: 56023,
    county_fips_all: '56023',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"56023": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 41.97455,
    longitude: -110.5468,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83101',
  },
  {
    city: 'Afton',
    county_fips: 56023,
    county_fips_all: '56023',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"56023": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 42.72421,
    longitude: -110.90108,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83110',
  },
  {
    city: 'Auburn',
    county_fips: 56023,
    county_fips_all: '56023',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"56023": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 42.819,
    longitude: -111.01143,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83111',
  },
  {
    city: 'Bedford',
    county_fips: 56023,
    county_fips_all: '56023',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"56023": 100}',
    density: 7,
    imprecise: false,
    latitude: 42.88191,
    longitude: -110.8833,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83112',
  },
  {
    city: 'Big Piney',
    county_fips: 56035,
    county_fips_all: '56035',
    county: 'Sublette',
    county_names_all: 'Sublette',
    county_weights: '{"56035": 100}',
    density: 1,
    imprecise: false,
    latitude: 42.55189,
    longitude: -110.25204,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83113',
  },
  {
    city: 'Cokeville',
    county_fips: 56023,
    county_fips_all: '56023',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"56023": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 42.09736,
    longitude: -110.956,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83114',
  },
  {
    city: 'Daniel',
    county_fips: 56035,
    county_fips_all: '56035',
    county: 'Sublette',
    county_names_all: 'Sublette',
    county_weights: '{"56035": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 42.92003,
    longitude: -110.24036,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83115',
  },
  {
    city: 'Diamondville',
    county_fips: 56023,
    county_fips_all: '56023',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"56023": 100}',
    density: 83.2,
    imprecise: false,
    latitude: 41.76333,
    longitude: -110.54415,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83116',
  },
  {
    city: 'Etna',
    county_fips: 56023,
    county_fips_all: '56023',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"56023": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 43.06638,
    longitude: -110.9246,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83118',
  },
  {
    city: 'Fairview',
    county_fips: 56023,
    county_fips_all: '56023',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"56023": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 42.64394,
    longitude: -110.98828,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83119',
  },
  {
    city: 'Freedom',
    county_fips: 16019,
    county_fips_all: '16019|16029|56023',
    county: 'Bonneville',
    county_names_all: 'Bonneville|Caribou|Lincoln',
    county_weights: '{"16019": 71.13, "16029": 18.82, "56023": 10.05}',
    density: 0.7,
    imprecise: false,
    latitude: 43.06595,
    longitude: -111.13529,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83120',
  },
  {
    city: 'Grover',
    county_fips: 56023,
    county_fips_all: '56023',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"56023": 100}',
    density: 46.5,
    imprecise: false,
    latitude: 42.82175,
    longitude: -110.95843,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83122',
  },
  {
    city: 'La Barge',
    county_fips: 56023,
    county_fips_all: '56023',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"56023": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 42.23985,
    longitude: -110.25947,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83123',
  },
  {
    city: 'Opal',
    county_fips: 56023,
    county_fips_all: '56023',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"56023": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 41.75002,
    longitude: -110.20865,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83124',
  },
  {
    city: 'Smoot',
    county_fips: 56023,
    county_fips_all: '56023',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"56023": 100}',
    density: 28.1,
    imprecise: false,
    latitude: 42.58697,
    longitude: -110.90916,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83126',
  },
  {
    city: 'Thayne',
    county_fips: 56023,
    county_fips_all: '56023|16029',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Caribou',
    county_weights: '{"56023": 52.21, "16029": 47.79}',
    density: 6.4,
    imprecise: false,
    latitude: 42.91815,
    longitude: -110.99756,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83127',
  },
  {
    city: 'Alpine',
    county_fips: 56023,
    county_fips_all: '56023',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"56023": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 43.14762,
    longitude: -110.7918,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83128',
  },
  {
    city: 'Pocatello',
    county_fips: 16005,
    county_fips_all: '16005',
    county: 'Bannock',
    county_names_all: 'Bannock',
    county_weights: '{"16005": 100}',
    density: 450.4,
    imprecise: false,
    latitude: 42.88949,
    longitude: -112.38324,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 39902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83201',
  },
  {
    city: 'Pocatello',
    county_fips: 16005,
    county_fips_all: '16005|16011',
    county: 'Bannock',
    county_names_all: 'Bannock|Bingham',
    county_weights: '{"16005": 90.38, "16011": 9.62}',
    density: 56.7,
    imprecise: false,
    latitude: 42.97057,
    longitude: -112.34734,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 24513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83202',
  },
  {
    city: 'Fort Hall',
    county_fips: 16011,
    county_fips_all: '16011',
    county: 'Bingham',
    county_names_all: 'Bingham',
    county_weights: '{"16011": 100}',
    density: 33.6,
    imprecise: false,
    latitude: 43.0252,
    longitude: -112.42813,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83203',
  },
  {
    city: 'Pocatello',
    county_fips: 16077,
    county_fips_all: '16077|16005',
    county: 'Power',
    county_names_all: 'Power|Bannock',
    county_weights: '{"16077": 59.24, "16005": 40.76}',
    density: 25.6,
    imprecise: false,
    latitude: 42.79219,
    longitude: -112.51877,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 18580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83204',
  },
  {
    city: 'Aberdeen',
    county_fips: 16011,
    county_fips_all: '16011',
    county: 'Bingham',
    county_names_all: 'Bingham',
    county_weights: '{"16011": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 43.02069,
    longitude: -112.86048,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 3843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83210',
  },
  {
    city: 'American Falls',
    county_fips: 16077,
    county_fips_all: '16077|16031|16011',
    county: 'Power',
    county_names_all: 'Power|Cassia|Bingham',
    county_weights: '{"16077": 65.33, "16031": 34.41, "16011": 0.26}',
    density: 3.5,
    imprecise: false,
    latitude: 42.66257,
    longitude: -113.06186,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 6743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83211',
  },
  {
    city: 'Arbon',
    county_fips: 16077,
    county_fips_all: '16077|16071',
    county: 'Power',
    county_names_all: 'Power|Oneida',
    county_weights: '{"16077": 86.01, "16071": 13.99}',
    density: 0.7,
    imprecise: false,
    latitude: 42.50847,
    longitude: -112.54828,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83212',
  },
  {
    city: 'Arco',
    county_fips: 16023,
    county_fips_all: '16023',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"16023": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 43.55171,
    longitude: -113.35809,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83213',
  },
  {
    city: 'Arimo',
    county_fips: 16005,
    county_fips_all: '16005',
    county: 'Bannock',
    county_names_all: 'Bannock',
    county_weights: '{"16005": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 42.54495,
    longitude: -112.29362,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83214',
  },
  {
    city: 'Atomic City',
    county_fips: 16011,
    county_fips_all: '16011',
    county: 'Bingham',
    county_names_all: 'Bingham',
    county_weights: '{"16011": 100}',
    density: 73,
    imprecise: false,
    latitude: 43.44314,
    longitude: -112.81239,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83215',
  },
  {
    city: 'Bancroft',
    county_fips: 16029,
    county_fips_all: '16029',
    county: 'Caribou',
    county_names_all: 'Caribou',
    county_weights: '{"16029": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 42.77525,
    longitude: -111.93559,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83217',
  },
  {
    city: 'Basalt',
    county_fips: 16011,
    county_fips_all: '16011',
    county: 'Bingham',
    county_names_all: 'Bingham',
    county_weights: '{"16011": 100}',
    density: 486.1,
    imprecise: false,
    latitude: 43.31803,
    longitude: -112.16453,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83218',
  },
  {
    city: 'Bern',
    county_fips: 16007,
    county_fips_all: '16007',
    county: 'Bear Lake',
    county_names_all: 'Bear Lake',
    county_weights: '{"16007": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 42.34465,
    longitude: -111.38008,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83220',
  },
  {
    city: 'Blackfoot',
    county_fips: 16011,
    county_fips_all: '16011',
    county: 'Bingham',
    county_names_all: 'Bingham',
    county_weights: '{"16011": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 43.30874,
    longitude: -112.53217,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 29081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83221',
  },
  {
    city: 'Bloomington',
    county_fips: 16007,
    county_fips_all: '16007',
    county: 'Bear Lake',
    county_names_all: 'Bear Lake',
    county_weights: '{"16007": 100}',
    density: 31.7,
    imprecise: false,
    latitude: 42.18249,
    longitude: -111.40327,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83223',
  },
  {
    city: 'Challis',
    county_fips: 16037,
    county_fips_all: '16037|16059',
    county: 'Custer',
    county_names_all: 'Custer|Lemhi',
    county_weights: '{"16037": 87.32, "16059": 12.68}',
    density: 0.4,
    imprecise: false,
    latitude: 44.40775,
    longitude: -114.06951,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 2100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83226',
  },
  {
    city: 'Clayton',
    county_fips: 16037,
    county_fips_all: '16037',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"16037": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 44.16563,
    longitude: -114.49424,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83227',
  },
  {
    city: 'Clifton',
    county_fips: 16041,
    county_fips_all: '16041',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"16041": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 42.19496,
    longitude: -112.03658,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83228',
  },
  {
    city: 'Dayton',
    county_fips: 16041,
    county_fips_all: '16041',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"16041": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 42.13341,
    longitude: -111.97245,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83232',
  },
  {
    city: 'Dingle',
    county_fips: 16007,
    county_fips_all: '16007',
    county: 'Bear Lake',
    county_names_all: 'Bear Lake',
    county_weights: '{"16007": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 42.15664,
    longitude: -111.25256,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83233',
  },
  {
    city: 'Downey',
    county_fips: 16005,
    county_fips_all: '16005',
    county: 'Bannock',
    county_names_all: 'Bannock',
    county_weights: '{"16005": 100}',
    density: 2,
    imprecise: false,
    latitude: 42.41661,
    longitude: -112.09482,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83234',
  },
  {
    city: 'Ellis',
    county_fips: 16037,
    county_fips_all: '16037|16059',
    county: 'Custer',
    county_names_all: 'Custer|Lemhi',
    county_weights: '{"16037": 93.74, "16059": 6.26}',
    density: 0,
    imprecise: false,
    latitude: 44.60163,
    longitude: -114.03404,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83235',
  },
  {
    city: 'Firth',
    county_fips: 16011,
    county_fips_all: '16011',
    county: 'Bingham',
    county_names_all: 'Bingham',
    county_weights: '{"16011": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 43.22819,
    longitude: -111.94894,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83236',
  },
  {
    city: 'Franklin',
    county_fips: 16041,
    county_fips_all: '16041',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"16041": 100}',
    density: 26.1,
    imprecise: false,
    latitude: 42.02737,
    longitude: -111.77626,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83237',
  },
  {
    city: 'Geneva',
    county_fips: 16007,
    county_fips_all: '16007',
    county: 'Bear Lake',
    county_names_all: 'Bear Lake',
    county_weights: '{"16007": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 42.37942,
    longitude: -111.10593,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83238',
  },
  {
    city: 'Georgetown',
    county_fips: 16007,
    county_fips_all: '16007',
    county: 'Bear Lake',
    county_names_all: 'Bear Lake',
    county_weights: '{"16007": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 42.53167,
    longitude: -111.36528,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83239',
  },
  {
    city: 'Grace',
    county_fips: 16029,
    county_fips_all: '16029|16041',
    county: 'Caribou',
    county_names_all: 'Caribou|Franklin',
    county_weights: '{"16029": 99.9, "16041": 0.1}',
    density: 4.9,
    imprecise: false,
    latitude: 42.51527,
    longitude: -111.76214,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 2488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83241',
  },
  {
    city: 'Holbrook',
    county_fips: 16071,
    county_fips_all: '16071',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"16071": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 42.24444,
    longitude: -112.67292,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83243',
  },
  {
    city: 'Howe',
    county_fips: 16023,
    county_fips_all: '16023',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"16023": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 43.94076,
    longitude: -113.11287,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83244',
  },
  {
    city: 'Inkom',
    county_fips: 16005,
    county_fips_all: '16005',
    county: 'Bannock',
    county_names_all: 'Bannock',
    county_weights: '{"16005": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 42.82286,
    longitude: -112.21713,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 2321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83245',
  },
  {
    city: 'Lava Hot Springs',
    county_fips: 16005,
    county_fips_all: '16005',
    county: 'Bannock',
    county_names_all: 'Bannock',
    county_weights: '{"16005": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 42.60616,
    longitude: -112.03051,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83246',
  },
  {
    city: 'Mccammon',
    county_fips: 16005,
    county_fips_all: '16005',
    county: 'Bannock',
    county_names_all: 'Bannock',
    county_weights: '{"16005": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 42.67228,
    longitude: -112.20865,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 2179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83250',
  },
  {
    city: 'Mackay',
    county_fips: 16037,
    county_fips_all: '16037',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"16037": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 43.90738,
    longitude: -113.86425,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83251',
  },
  {
    city: 'Malad City',
    county_fips: 16071,
    county_fips_all: '16071',
    county: 'Oneida',
    county_names_all: 'Oneida',
    county_weights: '{"16071": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 42.18979,
    longitude: -112.38411,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 4707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83252',
  },
  {
    city: 'May',
    county_fips: 16059,
    county_fips_all: '16059|16037',
    county: 'Lemhi',
    county_names_all: 'Lemhi|Custer',
    county_weights: '{"16059": 71.95, "16037": 28.05}',
    density: 0.1,
    imprecise: false,
    latitude: 44.54647,
    longitude: -113.77167,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83253',
  },
  {
    city: 'Montpelier',
    county_fips: 16007,
    county_fips_all: '16007|16029',
    county: 'Bear Lake',
    county_names_all: 'Bear Lake|Caribou',
    county_weights: '{"16007": 82.59, "16029": 17.41}',
    density: 2.6,
    imprecise: false,
    latitude: 42.36403,
    longitude: -111.2655,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 3792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83254',
  },
  {
    city: 'Moore',
    county_fips: 16023,
    county_fips_all: '16023|16037',
    county: 'Butte',
    county_names_all: 'Butte|Custer',
    county_weights: '{"16023": 89.68, "16037": 10.32}',
    density: 2.3,
    imprecise: false,
    latitude: 43.72829,
    longitude: -113.45702,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83255',
  },
  {
    city: 'Paris',
    county_fips: 16007,
    county_fips_all: '16007',
    county: 'Bear Lake',
    county_names_all: 'Bear Lake',
    county_weights: '{"16007": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 42.22112,
    longitude: -111.40661,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83261',
  },
  {
    city: 'Pingree',
    county_fips: 16011,
    county_fips_all: '16011',
    county: 'Bingham',
    county_names_all: 'Bingham',
    county_weights: '{"16011": 100}',
    density: 2,
    imprecise: false,
    latitude: 43.18419,
    longitude: -112.7658,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83262',
  },
  {
    city: 'Preston',
    county_fips: 16041,
    county_fips_all: '16041',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"16041": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 42.17757,
    longitude: -111.76101,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 9940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83263',
  },
  {
    city: 'Rockland',
    county_fips: 16077,
    county_fips_all: '16077',
    county: 'Power',
    county_names_all: 'Power',
    county_weights: '{"16077": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 42.4574,
    longitude: -112.84551,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83271',
  },
  {
    city: 'Saint Charles',
    county_fips: 16007,
    county_fips_all: '16007',
    county: 'Bear Lake',
    county_names_all: 'Bear Lake',
    county_weights: '{"16007": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 42.09156,
    longitude: -111.36835,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83272',
  },
  {
    city: 'Shelley',
    county_fips: 16011,
    county_fips_all: '16011|16019',
    county: 'Bingham',
    county_names_all: 'Bingham|Bonneville',
    county_weights: '{"16011": 99.54, "16019": 0.46}',
    density: 45.8,
    imprecise: false,
    latitude: 43.35049,
    longitude: -112.09904,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 11699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83274',
  },
  {
    city: 'Soda Springs',
    county_fips: 16029,
    county_fips_all: '16029|16007',
    county: 'Caribou',
    county_names_all: 'Caribou|Bear Lake',
    county_weights: '{"16029": 95.67, "16007": 4.33}',
    density: 2.3,
    imprecise: false,
    latitude: 42.75942,
    longitude: -111.44451,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 4155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83276',
  },
  {
    city: 'Springfield',
    county_fips: 16011,
    county_fips_all: '16011',
    county: 'Bingham',
    county_names_all: 'Bingham',
    county_weights: '{"16011": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 43.07429,
    longitude: -112.68127,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83277',
  },
  {
    city: 'Stanley',
    county_fips: 16037,
    county_fips_all: '16037',
    county: 'Custer',
    county_names_all: 'Custer',
    county_weights: '{"16037": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 44.36917,
    longitude: -114.85619,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83278',
  },
  {
    city: 'Swan Lake',
    county_fips: 16005,
    county_fips_all: '16005',
    county: 'Bannock',
    county_names_all: 'Bannock',
    county_weights: '{"16005": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 42.31044,
    longitude: -111.95953,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83281',
  },
  {
    city: 'Thatcher',
    county_fips: 16041,
    county_fips_all: '16041',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"16041": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 42.35709,
    longitude: -111.66445,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83283',
  },
  {
    city: 'Wayan',
    county_fips: 16019,
    county_fips_all: '16019|16029',
    county: 'Bonneville',
    county_names_all: 'Bonneville|Caribou',
    county_weights: '{"16019": 68.44, "16029": 31.56}',
    density: 0.1,
    imprecise: false,
    latitude: 43.061,
    longitude: -111.37199,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83285',
  },
  {
    city: 'Weston',
    county_fips: 16041,
    county_fips_all: '16041',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"16041": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 42.0533,
    longitude: -112.0148,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83286',
  },
  {
    city: 'Fish Haven',
    county_fips: 16007,
    county_fips_all: '16007',
    county: 'Bear Lake',
    county_names_all: 'Bear Lake',
    county_weights: '{"16007": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 42.03671,
    longitude: -111.45894,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83287',
  },
  {
    city: 'Twin Falls',
    county_fips: 16083,
    county_fips_all: '16083|16053',
    county: 'Twin Falls',
    county_names_all: 'Twin Falls|Jerome',
    county_weights: '{"16083": 99.26, "16053": 0.74}',
    density: 83,
    imprecise: false,
    latitude: 42.39472,
    longitude: -114.52203,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 63592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83301',
  },
  {
    city: 'Rogerson',
    county_fips: 16083,
    county_fips_all: '16083|16073',
    county: 'Twin Falls',
    county_names_all: 'Twin Falls|Owyhee',
    county_weights: '{"16083": 74.28, "16073": 25.72}',
    density: 0,
    imprecise: false,
    latitude: 42.10012,
    longitude: -114.82857,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 35,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83302',
  },
  {
    city: 'Albion',
    county_fips: 16031,
    county_fips_all: '16031',
    county: 'Cassia',
    county_names_all: 'Cassia',
    county_weights: '{"16031": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 42.40396,
    longitude: -113.55864,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83311',
  },
  {
    city: 'Almo',
    county_fips: 16031,
    county_fips_all: '16031',
    county: 'Cassia',
    county_names_all: 'Cassia',
    county_weights: '{"16031": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 42.10296,
    longitude: -113.6319,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83312',
  },
  {
    city: 'Bellevue',
    county_fips: 16013,
    county_fips_all: '16013',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"16013": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 43.3586,
    longitude: -114.20511,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 3692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83313',
  },
  {
    city: 'Bliss',
    county_fips: 16047,
    county_fips_all: '16047|16083',
    county: 'Gooding',
    county_names_all: 'Gooding|Twin Falls',
    county_weights: '{"16047": 99.13, "16083": 0.87}',
    density: 2,
    imprecise: false,
    latitude: 42.97376,
    longitude: -114.95228,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83314',
  },
  {
    city: 'Buhl',
    county_fips: 16083,
    county_fips_all: '16083|16073|16047',
    county: 'Twin Falls',
    county_names_all: 'Twin Falls|Owyhee|Gooding',
    county_weights: '{"16083": 84.93, "16073": 14.32, "16047": 0.75}',
    density: 13.8,
    imprecise: false,
    latitude: 42.60622,
    longitude: -114.88507,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 10456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83316',
  },
  {
    city: 'Burley',
    county_fips: 16031,
    county_fips_all: '16031|16067',
    county: 'Cassia',
    county_names_all: 'Cassia|Minidoka',
    county_weights: '{"16031": 99.82, "16067": 0.18}',
    density: 29.6,
    imprecise: false,
    latitude: 42.43434,
    longitude: -113.82007,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 19459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83318',
  },
  {
    city: 'Carey',
    county_fips: 16013,
    county_fips_all: '16013',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"16013": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 43.40515,
    longitude: -113.88309,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83320',
  },
  {
    city: 'Castleford',
    county_fips: 16083,
    county_fips_all: '16083',
    county: 'Twin Falls',
    county_names_all: 'Twin Falls',
    county_weights: '{"16083": 100}',
    density: 1,
    imprecise: false,
    latitude: 42.35955,
    longitude: -114.86312,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83321',
  },
  {
    city: 'Corral',
    county_fips: 16025,
    county_fips_all: '16025',
    county: 'Camas',
    county_names_all: 'Camas',
    county_weights: '{"16025": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 43.31475,
    longitude: -114.96811,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83322',
  },
  {
    city: 'Declo',
    county_fips: 16031,
    county_fips_all: '16031',
    county: 'Cassia',
    county_names_all: 'Cassia',
    county_weights: '{"16031": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 42.46902,
    longitude: -113.4081,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83323',
  },
  {
    city: 'Dietrich',
    county_fips: 16063,
    county_fips_all: '16063',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"16063": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 42.87725,
    longitude: -114.2615,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83324',
  },
  {
    city: 'Eden',
    county_fips: 16053,
    county_fips_all: '16053',
    county: 'Jerome',
    county_names_all: 'Jerome',
    county_weights: '{"16053": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 42.58675,
    longitude: -114.24282,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83325',
  },
  {
    city: 'Fairfield',
    county_fips: 16025,
    county_fips_all: '16025',
    county: 'Camas',
    county_names_all: 'Camas',
    county_weights: '{"16025": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 43.51145,
    longitude: -114.7961,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83327',
  },
  {
    city: 'Filer',
    county_fips: 16083,
    county_fips_all: '16083',
    county: 'Twin Falls',
    county_names_all: 'Twin Falls',
    county_weights: '{"16083": 100}',
    density: 36.3,
    imprecise: false,
    latitude: 42.56962,
    longitude: -114.61665,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 6320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83328',
  },
  {
    city: 'Gooding',
    county_fips: 16047,
    county_fips_all: '16047|16063',
    county: 'Gooding',
    county_names_all: 'Gooding|Lincoln',
    county_weights: '{"16047": 99.05, "16063": 0.95}',
    density: 19.1,
    imprecise: false,
    latitude: 42.94207,
    longitude: -114.69291,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 7347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83330',
  },
  {
    city: 'Hagerman',
    county_fips: 16083,
    county_fips_all: '16083|16047',
    county: 'Twin Falls',
    county_names_all: 'Twin Falls|Gooding',
    county_weights: '{"16083": 60.16, "16047": 39.84}',
    density: 11.3,
    imprecise: false,
    latitude: 42.79758,
    longitude: -114.92962,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 2569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83332',
  },
  {
    city: 'Hailey',
    county_fips: 16013,
    county_fips_all: '16013',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"16013": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 43.57589,
    longitude: -114.2214,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 12682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83333',
  },
  {
    city: 'Hansen',
    county_fips: 16083,
    county_fips_all: '16083',
    county: 'Twin Falls',
    county_names_all: 'Twin Falls',
    county_weights: '{"16083": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 42.4243,
    longitude: -114.29126,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 2227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83334',
  },
  {
    city: 'Hazelton',
    county_fips: 16053,
    county_fips_all: '16053|16067',
    county: 'Jerome',
    county_names_all: 'Jerome|Minidoka',
    county_weights: '{"16053": 99.3, "16067": 0.7}',
    density: 7.9,
    imprecise: false,
    latitude: 42.58726,
    longitude: -114.07347,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 2335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83335',
  },
  {
    city: 'Heyburn',
    county_fips: 16067,
    county_fips_all: '16067',
    county: 'Minidoka',
    county_names_all: 'Minidoka',
    county_weights: '{"16067": 100}',
    density: 66.6,
    imprecise: false,
    latitude: 42.5626,
    longitude: -113.81699,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 6075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83336',
  },
  {
    city: 'Hill City',
    county_fips: 16039,
    county_fips_all: '16039|16025',
    county: 'Elmore',
    county_names_all: 'Elmore|Camas',
    county_weights: '{"16039": 82.44, "16025": 17.56}',
    density: 0.1,
    imprecise: false,
    latitude: 43.21807,
    longitude: -115.1575,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83337',
  },
  {
    city: 'Jerome',
    county_fips: 16053,
    county_fips_all: '16053|16047|16063',
    county: 'Jerome',
    county_names_all: 'Jerome|Gooding|Lincoln',
    county_weights: '{"16053": 95.36, "16047": 3.43, "16063": 1.21}',
    density: 30.7,
    imprecise: false,
    latitude: 42.72501,
    longitude: -114.43273,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 21944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83338',
  },
  {
    city: 'Ketchum',
    county_fips: 16013,
    county_fips_all: '16013',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"16013": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 43.77178,
    longitude: -114.58138,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 5325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83340',
  },
  {
    city: 'Kimberly',
    county_fips: 16083,
    county_fips_all: '16083',
    county: 'Twin Falls',
    county_names_all: 'Twin Falls',
    county_weights: '{"16083": 100}',
    density: 43.2,
    imprecise: false,
    latitude: 42.42875,
    longitude: -114.37052,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 9531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83341',
  },
  {
    city: 'Malta',
    county_fips: 16031,
    county_fips_all: '16031|16071|49003',
    county: 'Cassia',
    county_names_all: 'Cassia|Oneida|Box Elder',
    county_weights: '{"16031": 65.43, "16071": 21.35, "49003": 13.22}',
    density: 0.4,
    imprecise: false,
    latitude: 42.15014,
    longitude: -113.22915,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83342',
  },
  {
    city: 'Murtaugh',
    county_fips: 16031,
    county_fips_all: '16031|16083',
    county: 'Cassia',
    county_names_all: 'Cassia|Twin Falls',
    county_weights: '{"16031": 68.54, "16083": 31.46}',
    density: 2.7,
    imprecise: false,
    latitude: 42.40437,
    longitude: -114.11768,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83344',
  },
  {
    city: 'Oakley',
    county_fips: 16031,
    county_fips_all: '16031',
    county: 'Cassia',
    county_names_all: 'Cassia',
    county_weights: '{"16031": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 42.19491,
    longitude: -113.9046,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83346',
  },
  {
    city: 'Paul',
    county_fips: 16067,
    county_fips_all: '16067|16063|16053',
    county: 'Minidoka',
    county_names_all: 'Minidoka|Lincoln|Jerome',
    county_weights: '{"16067": 44.97, "16063": 37.16, "16053": 17.87}',
    density: 5.9,
    imprecise: false,
    latitude: 42.73812,
    longitude: -113.87705,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 3465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83347',
  },
  {
    city: 'Picabo',
    county_fips: 16013,
    county_fips_all: '16013',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"16013": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 43.28489,
    longitude: -114.10592,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83348',
  },
  {
    city: 'Richfield',
    county_fips: 16063,
    county_fips_all: '16063',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"16063": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 43.10148,
    longitude: -114.17784,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83349',
  },
  {
    city: 'Rupert',
    county_fips: 16067,
    county_fips_all: '16067|16013|16031',
    county: 'Minidoka',
    county_names_all: 'Minidoka|Blaine|Cassia',
    county_weights: '{"16067": 81.9, "16013": 10.93, "16031": 7.17}',
    density: 18.6,
    imprecise: false,
    latitude: 42.70996,
    longitude: -113.59812,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 12671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83350',
  },
  {
    city: 'Shoshone',
    county_fips: 16063,
    county_fips_all: '16063|16025|16013',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Camas|Blaine',
    county_weights: '{"16063": 87.04, "16025": 10.91, "16013": 2.05}',
    density: 5.9,
    imprecise: false,
    latitude: 43.05133,
    longitude: -114.40584,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 3317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83352',
  },
  {
    city: 'Sun Valley',
    county_fips: 16013,
    county_fips_all: '16013',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"16013": 100}',
    density: 62.9,
    imprecise: false,
    latitude: 43.68625,
    longitude: -114.33354,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83353',
  },
  {
    city: 'Sun Valley',
    county_fips: 16013,
    county_fips_all: '16013',
    county: 'Blaine',
    county_names_all: 'Blaine',
    county_weights: '{"16013": 100}',
    density: 195.8,
    imprecise: false,
    latitude: 43.67012,
    longitude: -114.32235,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83354',
  },
  {
    city: 'Wendell',
    county_fips: 16047,
    county_fips_all: '16047',
    county: 'Gooding',
    county_names_all: 'Gooding',
    county_weights: '{"16047": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 42.75515,
    longitude: -114.72676,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 5469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83355',
  },
  {
    city: 'Idaho Falls',
    county_fips: 16019,
    county_fips_all: '16019|16051',
    county: 'Bonneville',
    county_names_all: 'Bonneville|Jefferson',
    county_weights: '{"16019": 99.79, "16051": 0.21}',
    density: 93.9,
    imprecise: false,
    latitude: 43.53222,
    longitude: -111.86516,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 47972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83401',
  },
  {
    city: 'Idaho Falls',
    county_fips: 16019,
    county_fips_all: '16019|16051|16011',
    county: 'Bonneville',
    county_names_all: 'Bonneville|Jefferson|Bingham',
    county_weights: '{"16019": 97.02, "16051": 2.61, "16011": 0.37}',
    density: 67.7,
    imprecise: false,
    latitude: 43.53011,
    longitude: -112.16786,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 29994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83402',
  },
  {
    city: 'Idaho Falls',
    county_fips: 16019,
    county_fips_all: '16019',
    county: 'Bonneville',
    county_names_all: 'Bonneville',
    county_weights: '{"16019": 100}',
    density: 425,
    imprecise: false,
    latitude: 43.42818,
    longitude: -112.01432,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 27500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83404',
  },
  {
    city: 'Idaho Falls',
    county_fips: 16019,
    county_fips_all: '16019',
    county: 'Bonneville',
    county_names_all: 'Bonneville',
    county_weights: '{"16019": 100}',
    density: 237.5,
    imprecise: false,
    latitude: 43.43768,
    longitude: -111.93382,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 19696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83406',
  },
  {
    city: 'Alta',
    county_fips: 56039,
    county_fips_all: '56039',
    county: 'Teton',
    county_names_all: 'Teton',
    county_weights: '{"56039": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 43.88847,
    longitude: -110.94924,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83414',
  },
  {
    city: 'Ashton',
    county_fips: 16043,
    county_fips_all: '16043',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"16043": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 44.06001,
    longitude: -111.32243,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 2580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83420',
  },
  {
    city: 'Chester',
    county_fips: 16043,
    county_fips_all: '16043',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"16043": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 44.00349,
    longitude: -111.54057,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83421',
  },
  {
    city: 'Driggs',
    county_fips: 16081,
    county_fips_all: '16081',
    county: 'Teton',
    county_names_all: 'Teton',
    county_weights: '{"16081": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 43.70463,
    longitude: -111.23914,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 3847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83422',
  },
  {
    city: 'Dubois',
    county_fips: 16033,
    county_fips_all: '16033',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"16033": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 44.33967,
    longitude: -112.33199,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83423',
  },
  {
    city: 'Felt',
    county_fips: 16081,
    county_fips_all: '16081',
    county: 'Teton',
    county_names_all: 'Teton',
    county_weights: '{"16081": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 43.90488,
    longitude: -111.19136,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83424',
  },
  {
    city: 'Hamer',
    county_fips: 16051,
    county_fips_all: '16051|16043',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Fremont',
    county_weights: '{"16051": 93.42, "16043": 6.58}',
    density: 2,
    imprecise: false,
    latitude: 43.93106,
    longitude: -112.21677,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83425',
  },
  {
    city: 'Iona',
    county_fips: 16019,
    county_fips_all: '16019',
    county: 'Bonneville',
    county_names_all: 'Bonneville',
    county_weights: '{"16019": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 43.35936,
    longitude: -111.75064,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 2931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83427',
  },
  {
    city: 'Irwin',
    county_fips: 16019,
    county_fips_all: '16019',
    county: 'Bonneville',
    county_names_all: 'Bonneville',
    county_weights: '{"16019": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 43.3833,
    longitude: -111.16093,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83428',
  },
  {
    city: 'Island Park',
    county_fips: 16043,
    county_fips_all: '16043',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"16043": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 44.48674,
    longitude: -111.37366,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83429',
  },
  {
    city: 'Lewisville',
    county_fips: 16051,
    county_fips_all: '16051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"16051": 100}',
    density: 32.2,
    imprecise: false,
    latitude: 43.68808,
    longitude: -112.03012,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83431',
  },
  {
    city: 'Menan',
    county_fips: 16051,
    county_fips_all: '16051|16065',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Madison',
    county_weights: '{"16051": 72.28, "16065": 27.72}',
    density: 16.2,
    imprecise: false,
    latitude: 43.75636,
    longitude: -112.00758,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83434',
  },
  {
    city: 'Monteview',
    county_fips: 16051,
    county_fips_all: '16051|16033',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Clark',
    county_weights: '{"16051": 81.37, "16033": 18.63}',
    density: 1.3,
    imprecise: false,
    latitude: 43.98469,
    longitude: -112.58043,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83435',
  },
  {
    city: 'Newdale',
    county_fips: 16065,
    county_fips_all: '16065|16081|16043',
    county: 'Madison',
    county_names_all: 'Madison|Teton|Fremont',
    county_weights: '{"16065": 75.94, "16081": 17.53, "16043": 6.53}',
    density: 3,
    imprecise: false,
    latitude: 43.8588,
    longitude: -111.46665,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83436',
  },
  {
    city: 'Parker',
    county_fips: 16043,
    county_fips_all: '16043',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"16043": 100}',
    density: 2361.8,
    imprecise: false,
    latitude: 43.9597,
    longitude: -111.75932,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83438',
  },
  {
    city: 'Rexburg',
    county_fips: 16065,
    county_fips_all: '16065|16043',
    county: 'Madison',
    county_names_all: 'Madison|Fremont',
    county_weights: '{"16065": 96.14, "16043": 3.86}',
    density: 109.3,
    imprecise: false,
    latitude: 43.81092,
    longitude: -111.80779,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 51421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83440',
  },
  {
    city: 'Rigby',
    county_fips: 16051,
    county_fips_all: '16051|16019',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Bonneville',
    county_weights: '{"16051": 71.59, "16019": 28.41}',
    density: 76.4,
    imprecise: false,
    latitude: 43.62931,
    longitude: -111.82507,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 25609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83442',
  },
  {
    city: 'Ririe',
    county_fips: 16019,
    county_fips_all: '16019|16051|16065',
    county: 'Bonneville',
    county_names_all: 'Bonneville|Jefferson|Madison',
    county_weights: '{"16019": 95.1, "16051": 3.69, "16065": 1.21}',
    density: 2.6,
    imprecise: false,
    latitude: 43.50942,
    longitude: -111.56155,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83443',
  },
  {
    city: 'Roberts',
    county_fips: 16051,
    county_fips_all: '16051|16019',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Bonneville',
    county_weights: '{"16051": 99.23, "16019": 0.77}',
    density: 3.1,
    imprecise: false,
    latitude: 43.69748,
    longitude: -112.24406,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83444',
  },
  {
    city: 'Saint Anthony',
    county_fips: 16043,
    county_fips_all: '16043|16065',
    county: 'Fremont',
    county_names_all: 'Fremont|Madison',
    county_weights: '{"16043": 99.73, "16065": 0.27}',
    density: 10.2,
    imprecise: false,
    latitude: 44.07014,
    longitude: -111.73075,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 7975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83445',
  },
  {
    city: 'Spencer',
    county_fips: 16033,
    county_fips_all: '16033',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"16033": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 44.37841,
    longitude: -112.21887,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 24,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83446',
  },
  {
    city: 'Sugar City',
    county_fips: 16065,
    county_fips_all: '16065|16043',
    county: 'Madison',
    county_names_all: 'Madison|Fremont',
    county_weights: '{"16065": 98.03, "16043": 1.97}',
    density: 45.1,
    imprecise: false,
    latitude: 43.85082,
    longitude: -111.70529,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 3365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83448',
  },
  {
    city: 'Swan Valley',
    county_fips: 16019,
    county_fips_all: '16019',
    county: 'Bonneville',
    county_names_all: 'Bonneville',
    county_weights: '{"16019": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 43.42487,
    longitude: -111.35966,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83449',
  },
  {
    city: 'Terreton',
    county_fips: 16051,
    county_fips_all: '16051',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"16051": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 43.8463,
    longitude: -112.41356,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83450',
  },
  {
    city: 'Teton',
    county_fips: 16065,
    county_fips_all: '16065|16043',
    county: 'Madison',
    county_names_all: 'Madison|Fremont',
    county_weights: '{"16065": 66.47, "16043": 33.53}',
    density: 23.1,
    imprecise: false,
    latitude: 43.86595,
    longitude: -111.63489,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83451',
  },
  {
    city: 'Tetonia',
    county_fips: 16081,
    county_fips_all: '16081',
    county: 'Teton',
    county_names_all: 'Teton',
    county_weights: '{"16081": 100}',
    density: 5,
    imprecise: false,
    latitude: 43.83619,
    longitude: -111.21239,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 2237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83452',
  },
  {
    city: 'Ucon',
    county_fips: 16019,
    county_fips_all: '16019',
    county: 'Bonneville',
    county_names_all: 'Bonneville',
    county_weights: '{"16019": 100}',
    density: 975.1,
    imprecise: false,
    latitude: 43.5946,
    longitude: -111.95698,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83454',
  },
  {
    city: 'Victor',
    county_fips: 16081,
    county_fips_all: '16081',
    county: 'Teton',
    county_names_all: 'Teton',
    county_weights: '{"16081": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 43.60638,
    longitude: -111.14077,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 6173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83455',
  },
  {
    city: 'Carmen',
    county_fips: 16059,
    county_fips_all: '16059',
    county: 'Lemhi',
    county_names_all: 'Lemhi',
    county_weights: '{"16059": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 45.30698,
    longitude: -113.81069,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83462',
  },
  {
    city: 'Gibbsonville',
    county_fips: 16059,
    county_fips_all: '16059',
    county: 'Lemhi',
    county_names_all: 'Lemhi',
    county_weights: '{"16059": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.5706,
    longitude: -113.97716,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83463',
  },
  {
    city: 'Leadore',
    county_fips: 16059,
    county_fips_all: '16059|16033',
    county: 'Lemhi',
    county_names_all: 'Lemhi|Clark',
    county_weights: '{"16059": 89.5, "16033": 10.5}',
    density: 0.1,
    imprecise: false,
    latitude: 44.48105,
    longitude: -113.20271,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83464',
  },
  {
    city: 'Lemhi',
    county_fips: 16059,
    county_fips_all: '16059',
    county: 'Lemhi',
    county_names_all: 'Lemhi',
    county_weights: '{"16059": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 44.77581,
    longitude: -113.69949,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83465',
  },
  {
    city: 'North Fork',
    county_fips: 16059,
    county_fips_all: '16059',
    county: 'Lemhi',
    county_names_all: 'Lemhi',
    county_weights: '{"16059": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 45.44184,
    longitude: -114.05549,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83466',
  },
  {
    city: 'Salmon',
    county_fips: 16059,
    county_fips_all: '16059',
    county: 'Lemhi',
    county_names_all: 'Lemhi',
    county_weights: '{"16059": 100}',
    density: 3,
    imprecise: false,
    latitude: 45.02006,
    longitude: -113.89828,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 6590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83467',
  },
  {
    city: 'Tendoy',
    county_fips: 16059,
    county_fips_all: '16059',
    county: 'Lemhi',
    county_names_all: 'Lemhi',
    county_weights: '{"16059": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 44.92444,
    longitude: -113.61293,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83468',
  },
  {
    city: 'Shoup',
    county_fips: 16059,
    county_fips_all: '16059',
    county: 'Lemhi',
    county_names_all: 'Lemhi',
    county_weights: '{"16059": 100}',
    density: 0,
    imprecise: false,
    latitude: 45.1127,
    longitude: -114.47772,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 25,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83469',
  },
  {
    city: 'Lewiston',
    county_fips: 16069,
    county_fips_all: '16069',
    county: 'Nez Perce',
    county_names_all: 'Nez Perce',
    county_weights: '{"16069": 100}',
    density: 59.3,
    imprecise: false,
    latitude: 46.2283,
    longitude: -116.90608,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83501',
  },
  {
    city: 'Ahsahka',
    county_fips: 16035,
    county_fips_all: '16035',
    county: 'Clearwater',
    county_names_all: 'Clearwater',
    county_weights: '{"16035": 100}',
    density: 5,
    imprecise: false,
    latitude: 46.53936,
    longitude: -116.32366,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83520',
  },
  {
    city: 'Cottonwood',
    county_fips: 16049,
    county_fips_all: '16049',
    county: 'Idaho',
    county_names_all: 'Idaho',
    county_weights: '{"16049": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 45.91273,
    longitude: -116.50102,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 2692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83522',
  },
  {
    city: 'Craigmont',
    county_fips: 16061,
    county_fips_all: '16061',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"16061": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 46.22939,
    longitude: -116.47224,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83523',
  },
  {
    city: 'Culdesac',
    county_fips: 16069,
    county_fips_all: '16069|16061',
    county: 'Nez Perce',
    county_names_all: 'Nez Perce|Lewis',
    county_weights: '{"16069": 80.23, "16061": 19.77}',
    density: 3.4,
    imprecise: false,
    latitude: 46.3586,
    longitude: -116.65439,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83524',
  },
  {
    city: 'Elk City',
    county_fips: 16049,
    county_fips_all: '16049',
    county: 'Idaho',
    county_names_all: 'Idaho',
    county_weights: '{"16049": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.73798,
    longitude: -115.39367,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83525',
  },
  {
    city: 'Ferdinand',
    county_fips: 16049,
    county_fips_all: '16049',
    county: 'Idaho',
    county_names_all: 'Idaho',
    county_weights: '{"16049": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 46.14759,
    longitude: -116.4169,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83526',
  },
  {
    city: 'Grangeville',
    county_fips: 16049,
    county_fips_all: '16049',
    county: 'Idaho',
    county_names_all: 'Idaho',
    county_weights: '{"16049": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 45.91516,
    longitude: -116.02117,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83530',
  },
  {
    city: 'Greencreek',
    county_fips: 16049,
    county_fips_all: '16049',
    county: 'Idaho',
    county_names_all: 'Idaho',
    county_weights: '{"16049": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 46.11707,
    longitude: -116.24063,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83533',
  },
  {
    city: 'Juliaetta',
    county_fips: 16069,
    county_fips_all: '16069|16057',
    county: 'Nez Perce',
    county_names_all: 'Nez Perce|Latah',
    county_weights: '{"16069": 70.27, "16057": 29.73}',
    density: 8.4,
    imprecise: false,
    latitude: 46.54011,
    longitude: -116.72599,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83535',
  },
  {
    city: 'Kamiah',
    county_fips: 16049,
    county_fips_all: '16049|16061',
    county: 'Idaho',
    county_names_all: 'Idaho|Lewis',
    county_weights: '{"16049": 91.41, "16061": 8.59}',
    density: 8.4,
    imprecise: false,
    latitude: 46.21794,
    longitude: -116.02665,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83536',
  },
  {
    city: 'Kendrick',
    county_fips: 16057,
    county_fips_all: '16057|16069|16035',
    county: 'Latah',
    county_names_all: 'Latah|Nez Perce|Clearwater',
    county_weights: '{"16057": 52.28, "16069": 27.99, "16035": 19.73}',
    density: 2.5,
    imprecise: false,
    latitude: 46.62877,
    longitude: -116.52348,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83537',
  },
  {
    city: 'Kooskia',
    county_fips: 16049,
    county_fips_all: '16049',
    county: 'Idaho',
    county_names_all: 'Idaho',
    county_weights: '{"16049": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 46.20361,
    longitude: -114.93684,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83539',
  },
  {
    city: 'Lapwai',
    county_fips: 16069,
    county_fips_all: '16069',
    county: 'Nez Perce',
    county_names_all: 'Nez Perce',
    county_weights: '{"16069": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 46.34649,
    longitude: -116.78273,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83540',
  },
  {
    city: 'Lenore',
    county_fips: 16069,
    county_fips_all: '16069|16035',
    county: 'Nez Perce',
    county_names_all: 'Nez Perce|Clearwater',
    county_weights: '{"16069": 74.73, "16035": 25.27}',
    density: 3.5,
    imprecise: false,
    latitude: 46.49297,
    longitude: -116.50156,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83541',
  },
  {
    city: 'Lucile',
    county_fips: 16049,
    county_fips_all: '16049',
    county: 'Idaho',
    county_names_all: 'Idaho',
    county_weights: '{"16049": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 45.55291,
    longitude: -116.3115,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83542',
  },
  {
    city: 'Nezperce',
    county_fips: 16061,
    county_fips_all: '16061',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"16061": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 46.27358,
    longitude: -116.23815,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83543',
  },
  {
    city: 'Orofino',
    county_fips: 16035,
    county_fips_all: '16035|16061',
    county: 'Clearwater',
    county_names_all: 'Clearwater|Lewis',
    county_weights: '{"16035": 97.36, "16061": 2.64}',
    density: 10.8,
    imprecise: false,
    latitude: 46.49365,
    longitude: -116.1525,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83544',
  },
  {
    city: 'Peck',
    county_fips: 16069,
    county_fips_all: '16069',
    county: 'Nez Perce',
    county_names_all: 'Nez Perce',
    county_weights: '{"16069": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 46.42664,
    longitude: -116.4213,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83545',
  },
  {
    city: 'Pierce',
    county_fips: 16035,
    county_fips_all: '16035',
    county: 'Clearwater',
    county_names_all: 'Clearwater',
    county_weights: '{"16035": 100}',
    density: 4,
    imprecise: false,
    latitude: 46.57326,
    longitude: -115.81115,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83546',
  },
  {
    city: 'Pollock',
    county_fips: 16049,
    county_fips_all: '16049',
    county: 'Idaho',
    county_names_all: 'Idaho',
    county_weights: '{"16049": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 45.31165,
    longitude: -116.33062,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83547',
  },
  {
    city: 'Reubens',
    county_fips: 16069,
    county_fips_all: '16069|16061',
    county: 'Nez Perce',
    county_names_all: 'Nez Perce|Lewis',
    county_weights: '{"16069": 85.92, "16061": 14.08}',
    density: 2.2,
    imprecise: false,
    latitude: 46.34878,
    longitude: -116.50843,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83548',
  },
  {
    city: 'Riggins',
    county_fips: 16049,
    county_fips_all: '16049',
    county: 'Idaho',
    county_names_all: 'Idaho',
    county_weights: '{"16049": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 45.36641,
    longitude: -116.2549,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83549',
  },
  {
    city: 'Stites',
    county_fips: 16049,
    county_fips_all: '16049',
    county: 'Idaho',
    county_names_all: 'Idaho',
    county_weights: '{"16049": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 45.9777,
    longitude: -115.93948,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83552',
  },
  {
    city: 'Weippe',
    county_fips: 16035,
    county_fips_all: '16035',
    county: 'Clearwater',
    county_names_all: 'Clearwater',
    county_weights: '{"16035": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 46.38365,
    longitude: -115.9038,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83553',
  },
  {
    city: 'White Bird',
    county_fips: 16049,
    county_fips_all: '16049',
    county: 'Idaho',
    county_names_all: 'Idaho',
    county_weights: '{"16049": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 45.68522,
    longitude: -116.29936,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83554',
  },
  {
    city: 'Winchester',
    county_fips: 16069,
    county_fips_all: '16069|16061',
    county: 'Nez Perce',
    county_names_all: 'Nez Perce|Lewis',
    county_weights: '{"16069": 58.63, "16061": 41.37}',
    density: 1,
    imprecise: false,
    latitude: 46.08662,
    longitude: -116.72221,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83555',
  },
  {
    city: 'Banks',
    county_fips: 16015,
    county_fips_all: '16015',
    county: 'Boise',
    county_names_all: 'Boise',
    county_weights: '{"16015": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.09676,
    longitude: -116.15049,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83602',
  },
  {
    city: 'Bruneau',
    county_fips: 16073,
    county_fips_all: '16073',
    county: 'Owyhee',
    county_names_all: 'Owyhee',
    county_weights: '{"16073": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 42.52727,
    longitude: -115.84966,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83604',
  },
  {
    city: 'Caldwell',
    county_fips: 16027,
    county_fips_all: '16027',
    county: 'Canyon',
    county_names_all: 'Canyon',
    county_weights: '{"16027": 100}',
    density: 647.9,
    imprecise: false,
    latitude: 43.66442,
    longitude: -116.65171,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 41325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83605',
  },
  {
    city: 'Caldwell',
    county_fips: 16027,
    county_fips_all: '16027|16075|16045',
    county: 'Canyon',
    county_names_all: 'Canyon|Payette|Gem',
    county_weights: '{"16027": 70.79, "16075": 19.63, "16045": 9.58}',
    density: 59.6,
    imprecise: false,
    latitude: 43.7116,
    longitude: -116.74362,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 35491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83607',
  },
  {
    city: 'Cambridge',
    county_fips: 16087,
    county_fips_all: '16087|16003',
    county: 'Washington',
    county_names_all: 'Washington|Adams',
    county_weights: '{"16087": 87.36, "16003": 12.64}',
    density: 0.8,
    imprecise: false,
    latitude: 44.70231,
    longitude: -116.78239,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83610',
  },
  {
    city: 'Cascade',
    county_fips: 16085,
    county_fips_all: '16085|16049',
    county: 'Valley',
    county_names_all: 'Valley|Idaho',
    county_weights: '{"16085": 60.26, "16049": 39.74}',
    density: 0.5,
    imprecise: false,
    latitude: 45.03935,
    longitude: -115.24709,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 3329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83611',
  },
  {
    city: 'Council',
    county_fips: 16003,
    county_fips_all: '16003',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"16003": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 44.8438,
    longitude: -116.53296,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 2085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83612',
  },
  {
    city: 'Donnelly',
    county_fips: 16085,
    county_fips_all: '16085',
    county: 'Valley',
    county_names_all: 'Valley',
    county_weights: '{"16085": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 44.70288,
    longitude: -116.0484,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83615',
  },
  {
    city: 'Eagle',
    county_fips: 16001,
    county_fips_all: '16001|16045',
    county: 'Ada',
    county_names_all: 'Ada|Gem',
    county_weights: '{"16001": 64.6, "16045": 35.4}',
    density: 122.8,
    imprecise: false,
    latitude: 43.77667,
    longitude: -116.38977,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 35413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83616',
  },
  {
    city: 'Emmett',
    county_fips: 16045,
    county_fips_all: '16045|16075',
    county: 'Gem',
    county_names_all: 'Gem|Payette',
    county_weights: '{"16045": 99.89, "16075": 0.11}',
    density: 32.9,
    imprecise: false,
    latitude: 43.93303,
    longitude: -116.50368,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 19058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83617',
  },
  {
    city: 'Fruitland',
    county_fips: 16075,
    county_fips_all: '16075',
    county: 'Payette',
    county_names_all: 'Payette',
    county_weights: '{"16075": 100}',
    density: 107.6,
    imprecise: false,
    latitude: 43.96982,
    longitude: -116.91204,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 8823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83619',
  },
  {
    city: 'Garden Valley',
    county_fips: 16015,
    county_fips_all: '16015',
    county: 'Boise',
    county_names_all: 'Boise',
    county_weights: '{"16015": 100}',
    density: 3,
    imprecise: false,
    latitude: 44.1065,
    longitude: -115.88953,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 2132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83622',
  },
  {
    city: 'Glenns Ferry',
    county_fips: 16039,
    county_fips_all: '16039',
    county: 'Elmore',
    county_names_all: 'Elmore',
    county_weights: '{"16039": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 43.04932,
    longitude: -115.39485,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83623',
  },
  {
    city: 'Grand View',
    county_fips: 16073,
    county_fips_all: '16073|16039',
    county: 'Owyhee',
    county_names_all: 'Owyhee|Elmore',
    county_weights: '{"16073": 77.31, "16039": 22.69}',
    density: 2,
    imprecise: false,
    latitude: 42.92441,
    longitude: -116.14266,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83624',
  },
  {
    city: 'Greenleaf',
    county_fips: 16027,
    county_fips_all: '16027',
    county: 'Canyon',
    county_names_all: 'Canyon',
    county_weights: '{"16027": 100}',
    density: 113.2,
    imprecise: false,
    latitude: 43.66876,
    longitude: -116.82815,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83626',
  },
  {
    city: 'Hammett',
    county_fips: 16073,
    county_fips_all: '16073|16039',
    county: 'Owyhee',
    county_names_all: 'Owyhee|Elmore',
    county_weights: '{"16073": 72.37, "16039": 27.63}',
    density: 2.6,
    imprecise: false,
    latitude: 42.91336,
    longitude: -115.53238,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83627',
  },
  {
    city: 'Homedale',
    county_fips: 16073,
    county_fips_all: '16073',
    county: 'Owyhee',
    county_names_all: 'Owyhee',
    county_weights: '{"16073": 100}',
    density: 30.6,
    imprecise: false,
    latitude: 43.57934,
    longitude: -116.96975,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 5006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83628',
  },
  {
    city: 'Horseshoe Bend',
    county_fips: 16015,
    county_fips_all: '16015|16045|16001',
    county: 'Boise',
    county_names_all: 'Boise|Gem|Ada',
    county_weights: '{"16015": 95.23, "16045": 4.67, "16001": 0.1}',
    density: 3.5,
    imprecise: false,
    latitude: 43.91115,
    longitude: -116.16947,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83629',
  },
  {
    city: 'Idaho City',
    county_fips: 16015,
    county_fips_all: '16015',
    county: 'Boise',
    county_names_all: 'Boise',
    county_weights: '{"16015": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 43.88543,
    longitude: -115.77369,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83631',
  },
  {
    city: 'Indian Valley',
    county_fips: 16003,
    county_fips_all: '16003|16087',
    county: 'Adams',
    county_names_all: 'Adams|Washington',
    county_weights: '{"16003": 96.18, "16087": 3.82}',
    density: 2.1,
    imprecise: false,
    latitude: 44.53228,
    longitude: -116.40994,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83632',
  },
  {
    city: 'King Hill',
    county_fips: 16039,
    county_fips_all: '16039',
    county: 'Elmore',
    county_names_all: 'Elmore',
    county_weights: '{"16039": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 43.0297,
    longitude: -115.21253,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83633',
  },
  {
    city: 'Kuna',
    county_fips: 16001,
    county_fips_all: '16001|16027',
    county: 'Ada',
    county_names_all: 'Ada|Canyon',
    county_weights: '{"16001": 95.19, "16027": 4.81}',
    density: 89.7,
    imprecise: false,
    latitude: 43.44824,
    longitude: -116.33287,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 36286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83634',
  },
  {
    city: 'Letha',
    county_fips: 16045,
    county_fips_all: '16045',
    county: 'Gem',
    county_names_all: 'Gem',
    county_weights: '{"16045": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 43.90832,
    longitude: -116.66097,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83636',
  },
  {
    city: 'Lowman',
    county_fips: 16015,
    county_fips_all: '16015',
    county: 'Boise',
    county_names_all: 'Boise',
    county_weights: '{"16015": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 44.13249,
    longitude: -115.29625,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83637',
  },
  {
    city: 'Mccall',
    county_fips: 16085,
    county_fips_all: '16085|16049|16003',
    county: 'Valley',
    county_names_all: 'Valley|Idaho|Adams',
    county_weights: '{"16085": 52.73, "16049": 46.69, "16003": 0.58}',
    density: 4.5,
    imprecise: false,
    latitude: 45.1504,
    longitude: -115.82001,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 7750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83638',
  },
  {
    city: 'Marsing',
    county_fips: 16073,
    county_fips_all: '16073',
    county: 'Owyhee',
    county_names_all: 'Owyhee',
    county_weights: '{"16073": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 43.36878,
    longitude: -116.92472,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 3311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83639',
  },
  {
    city: 'Melba',
    county_fips: 16073,
    county_fips_all: '16073|16027|16001',
    county: 'Owyhee',
    county_names_all: 'Owyhee|Canyon|Ada',
    county_weights: '{"16073": 61.0, "16027": 24.77, "16001": 14.23}',
    density: 6.9,
    imprecise: false,
    latitude: 43.35079,
    longitude: -116.6357,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 4061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83641',
  },
  {
    city: 'Meridian',
    county_fips: 16001,
    county_fips_all: '16001',
    county: 'Ada',
    county_names_all: 'Ada',
    county_weights: '{"16001": 100}',
    density: 579.8,
    imprecise: false,
    latitude: 43.57334,
    longitude: -116.40116,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 62279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83642',
  },
  {
    city: 'Mesa',
    county_fips: 16003,
    county_fips_all: '16003',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"16003": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 44.62983,
    longitude: -116.45439,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83643',
  },
  {
    city: 'Middleton',
    county_fips: 16027,
    county_fips_all: '16027',
    county: 'Canyon',
    county_names_all: 'Canyon',
    county_weights: '{"16027": 100}',
    density: 137.2,
    imprecise: false,
    latitude: 43.74823,
    longitude: -116.58455,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 16293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83644',
  },
  {
    city: 'Midvale',
    county_fips: 16087,
    county_fips_all: '16087',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"16087": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 44.36016,
    longitude: -116.56454,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83645',
  },
  {
    city: 'Meridian',
    county_fips: 16001,
    county_fips_all: '16001',
    county: 'Ada',
    county_names_all: 'Ada',
    county_weights: '{"16001": 100}',
    density: 1076,
    imprecise: false,
    latitude: 43.65,
    longitude: -116.43247,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 76023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83646',
  },
  {
    city: 'Mountain Home',
    county_fips: 16039,
    county_fips_all: '16039|16073',
    county: 'Elmore',
    county_names_all: 'Elmore|Owyhee',
    county_weights: '{"16039": 97.7, "16073": 2.3}',
    density: 5.9,
    imprecise: false,
    latitude: 43.39487,
    longitude: -115.51159,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 22952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83647',
  },
  {
    city: 'Mountain Home Afb',
    county_fips: 16039,
    county_fips_all: '16039',
    county: 'Elmore',
    county_names_all: 'Elmore',
    county_weights: '{"16039": 100}',
    density: 124.6,
    imprecise: false,
    latitude: 43.04962,
    longitude: -115.86554,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 3219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83648',
  },
  {
    city: 'Murphy',
    county_fips: 16073,
    county_fips_all: '16073',
    county: 'Owyhee',
    county_names_all: 'Owyhee',
    county_weights: '{"16073": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 42.87041,
    longitude: -116.65518,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83650',
  },
  {
    city: 'Nampa',
    county_fips: 16027,
    county_fips_all: '16027',
    county: 'Canyon',
    county_names_all: 'Canyon',
    county_weights: '{"16027": 100}',
    density: 923.3,
    imprecise: false,
    latitude: 43.58438,
    longitude: -116.62884,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 38121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83651',
  },
  {
    city: 'New Meadows',
    county_fips: 16003,
    county_fips_all: '16003|16049',
    county: 'Adams',
    county_names_all: 'Adams|Idaho',
    county_weights: '{"16003": 78.92, "16049": 21.08}',
    density: 1.8,
    imprecise: false,
    latitude: 45.13647,
    longitude: -116.39626,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 1763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83654',
  },
  {
    city: 'New Plymouth',
    county_fips: 16075,
    county_fips_all: '16075',
    county: 'Payette',
    county_names_all: 'Payette',
    county_weights: '{"16075": 100}',
    density: 38,
    imprecise: false,
    latitude: 43.95135,
    longitude: -116.79171,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 5748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83655',
  },
  {
    city: 'Notus',
    county_fips: 16027,
    county_fips_all: '16027',
    county: 'Canyon',
    county_names_all: 'Canyon',
    county_weights: '{"16027": 100}',
    density: 841.5,
    imprecise: false,
    latitude: 43.7255,
    longitude: -116.79852,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83656',
  },
  {
    city: 'Ola',
    county_fips: 16045,
    county_fips_all: '16045|16085',
    county: 'Gem',
    county_names_all: 'Gem|Valley',
    county_weights: '{"16045": 97.47, "16085": 2.53}',
    density: 0.4,
    imprecise: false,
    latitude: 44.23554,
    longitude: -116.30057,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83657',
  },
  {
    city: 'Parma',
    county_fips: 16027,
    county_fips_all: '16027|16075',
    county: 'Canyon',
    county_names_all: 'Canyon|Payette',
    county_weights: '{"16027": 71.94, "16075": 28.06}',
    density: 20,
    imprecise: false,
    latitude: 43.80016,
    longitude: -116.9301,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 6434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83660',
  },
  {
    city: 'Payette',
    county_fips: 16075,
    county_fips_all: '16075|16087',
    county: 'Payette',
    county_names_all: 'Payette|Washington',
    county_weights: '{"16075": 78.77, "16087": 21.23}',
    density: 14.5,
    imprecise: false,
    latitude: 44.10617,
    longitude: -116.69337,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 11105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83661',
  },
  {
    city: 'Placerville',
    county_fips: 16015,
    county_fips_all: '16015',
    county: 'Boise',
    county_names_all: 'Boise',
    county_weights: '{"16015": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 43.96157,
    longitude: -115.97398,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83666',
  },
  {
    city: 'Star',
    county_fips: 16001,
    county_fips_all: '16001|16027',
    county: 'Ada',
    county_names_all: 'Ada|Canyon',
    county_weights: '{"16001": 65.88, "16027": 34.12}',
    density: 295.2,
    imprecise: false,
    latitude: 43.71899,
    longitude: -116.50147,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 16827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83669',
  },
  {
    city: 'Sweet',
    county_fips: 16045,
    county_fips_all: '16045|16015',
    county: 'Gem',
    county_names_all: 'Gem|Boise',
    county_weights: '{"16045": 68.98, "16015": 31.02}',
    density: 4.3,
    imprecise: false,
    latitude: 44.0189,
    longitude: -116.30793,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83670',
  },
  {
    city: 'Weiser',
    county_fips: 16087,
    county_fips_all: '16087',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"16087": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 44.38095,
    longitude: -116.97188,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 9176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83672',
  },
  {
    city: 'Wilder',
    county_fips: 16027,
    county_fips_all: '16027',
    county: 'Canyon',
    county_names_all: 'Canyon',
    county_weights: '{"16027": 100}',
    density: 48.3,
    imprecise: false,
    latitude: 43.65743,
    longitude: -116.91156,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 5105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83676',
  },
  {
    city: 'Yellow Pine',
    county_fips: 16085,
    county_fips_all: '16085',
    county: 'Valley',
    county_names_all: 'Valley',
    county_weights: '{"16085": 100}',
    density: 0,
    imprecise: false,
    latitude: 45.03763,
    longitude: -115.38691,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83677',
  },
  {
    city: 'Nampa',
    county_fips: 16027,
    county_fips_all: '16027',
    county: 'Canyon',
    county_names_all: 'Canyon',
    county_weights: '{"16027": 100}',
    density: 268.5,
    imprecise: false,
    latitude: 43.49643,
    longitude: -116.61207,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 60993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83686',
  },
  {
    city: 'Nampa',
    county_fips: 16027,
    county_fips_all: '16027|16001',
    county: 'Canyon',
    county_names_all: 'Canyon|Ada',
    county_weights: '{"16027": 89.66, "16001": 10.34}',
    density: 337,
    imprecise: false,
    latitude: 43.60998,
    longitude: -116.52997,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 43135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83687',
  },
  {
    city: 'Boise',
    county_fips: 16001,
    county_fips_all: '16001|16015',
    county: 'Ada',
    county_names_all: 'Ada|Boise',
    county_weights: '{"16001": 97.27, "16015": 2.73}',
    density: 297.6,
    imprecise: false,
    latitude: 43.66821,
    longitude: -116.16493,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 24163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83702',
  },
  {
    city: 'Boise',
    county_fips: 16001,
    county_fips_all: '16001',
    county: 'Ada',
    county_names_all: 'Ada',
    county_weights: '{"16001": 100}',
    density: 834.7,
    imprecise: false,
    latitude: 43.66189,
    longitude: -116.23906,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 17583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83703',
  },
  {
    city: 'Boise',
    county_fips: 16001,
    county_fips_all: '16001',
    county: 'Ada',
    county_names_all: 'Ada',
    county_weights: '{"16001": 100}',
    density: 1884.7,
    imprecise: false,
    latitude: 43.62765,
    longitude: -116.28716,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 42719,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83704',
  },
  {
    city: 'Boise',
    county_fips: 16001,
    county_fips_all: '16001',
    county: 'Ada',
    county_names_all: 'Ada',
    county_weights: '{"16001": 100}',
    density: 639,
    imprecise: false,
    latitude: 43.55609,
    longitude: -116.22002,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 26830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83705',
  },
  {
    city: 'Boise',
    county_fips: 16001,
    county_fips_all: '16001',
    county: 'Ada',
    county_names_all: 'Ada',
    county_weights: '{"16001": 100}',
    density: 1846.1,
    imprecise: false,
    latitude: 43.59108,
    longitude: -116.19427,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 35524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83706',
  },
  {
    city: 'Boise',
    county_fips: 16001,
    county_fips_all: '16001',
    county: 'Ada',
    county_names_all: 'Ada',
    county_weights: '{"16001": 100}',
    density: 675.1,
    imprecise: false,
    latitude: 43.55212,
    longitude: -116.28847,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 58928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83709',
  },
  {
    city: 'Boise',
    county_fips: 16001,
    county_fips_all: '16001',
    county: 'Ada',
    county_names_all: 'Ada',
    county_weights: '{"16001": 100}',
    density: 152.6,
    imprecise: false,
    latitude: 43.61663,
    longitude: -116.11766,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 9071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83712',
  },
  {
    city: 'Boise',
    county_fips: 16001,
    county_fips_all: '16001',
    county: 'Ada',
    county_names_all: 'Ada',
    county_weights: '{"16001": 100}',
    density: 1844.8,
    imprecise: false,
    latitude: 43.63897,
    longitude: -116.33464,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 31549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83713',
  },
  {
    city: 'Garden City',
    county_fips: 16001,
    county_fips_all: '16001',
    county: 'Ada',
    county_names_all: 'Ada',
    county_weights: '{"16001": 100}',
    density: 196.4,
    imprecise: false,
    latitude: 43.72444,
    longitude: -116.27017,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 27564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83714',
  },
  {
    city: 'Boise',
    county_fips: 16039,
    county_fips_all: '16039|16015|16001',
    county: 'Elmore',
    county_names_all: 'Elmore|Boise|Ada',
    county_weights: '{"16039": 60.34, "16015": 23.82, "16001": 15.84}',
    density: 8,
    imprecise: false,
    latitude: 43.67271,
    longitude: -115.6548,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 21402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83716',
  },
  {
    city: 'Athol',
    county_fips: 16055,
    county_fips_all: '16055|16017',
    county: 'Kootenai',
    county_names_all: 'Kootenai|Bonner',
    county_weights: '{"16055": 60.01, "16017": 39.99}',
    density: 16.7,
    imprecise: false,
    latitude: 47.95631,
    longitude: -116.6434,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83801',
  },
  {
    city: 'Avery',
    county_fips: 16079,
    county_fips_all: '16079',
    county: 'Shoshone',
    county_names_all: 'Shoshone',
    county_weights: '{"16079": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 47.26665,
    longitude: -115.72815,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83802',
  },
  {
    city: 'Bayview',
    county_fips: 16017,
    county_fips_all: '16017|16055',
    county: 'Bonner',
    county_names_all: 'Bonner|Kootenai',
    county_weights: '{"16017": 92.82, "16055": 7.18}',
    density: 2,
    imprecise: false,
    latitude: 48.02261,
    longitude: -116.39878,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83803',
  },
  {
    city: 'Blanchard',
    county_fips: 16017,
    county_fips_all: '16017',
    county: 'Bonner',
    county_names_all: 'Bonner',
    county_weights: '{"16017": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 48.03714,
    longitude: -116.97315,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83804',
  },
  {
    city: 'Bonners Ferry',
    county_fips: 16021,
    county_fips_all: '16021',
    county: 'Boundary',
    county_names_all: 'Boundary',
    county_weights: '{"16021": 100}',
    density: 4,
    imprecise: false,
    latitude: 48.83203,
    longitude: -116.49248,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83805',
  },
  {
    city: 'Bovill',
    county_fips: 16057,
    county_fips_all: '16057',
    county: 'Latah',
    county_names_all: 'Latah',
    county_weights: '{"16057": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 46.88243,
    longitude: -116.37038,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83806',
  },
  {
    city: 'Calder',
    county_fips: 16079,
    county_fips_all: '16079',
    county: 'Shoshone',
    county_names_all: 'Shoshone',
    county_weights: '{"16079": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 47.31276,
    longitude: -116.07659,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83808',
  },
  {
    city: 'Careywood',
    county_fips: 16017,
    county_fips_all: '16017',
    county: 'Bonner',
    county_names_all: 'Bonner',
    county_weights: '{"16017": 100}',
    density: 9,
    imprecise: false,
    latitude: 48.06234,
    longitude: -116.58116,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83809',
  },
  {
    city: 'Cataldo',
    county_fips: 16055,
    county_fips_all: '16055|16079',
    county: 'Kootenai',
    county_names_all: 'Kootenai|Shoshone',
    county_weights: '{"16055": 97.47, "16079": 2.53}',
    density: 3.5,
    imprecise: false,
    latitude: 47.54326,
    longitude: -116.45525,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83810',
  },
  {
    city: 'Clark Fork',
    county_fips: 16017,
    county_fips_all: '16017',
    county: 'Bonner',
    county_names_all: 'Bonner',
    county_weights: '{"16017": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 48.11296,
    longitude: -116.15574,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83811',
  },
  {
    city: 'Clarkia',
    county_fips: 16079,
    county_fips_all: '16079',
    county: 'Shoshone',
    county_names_all: 'Shoshone',
    county_weights: '{"16079": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 47.00311,
    longitude: -116.28295,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83812',
  },
  {
    city: 'Cocolalla',
    county_fips: 16017,
    county_fips_all: '16017',
    county: 'Bonner',
    county_names_all: 'Bonner',
    county_weights: '{"16017": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 48.10462,
    longitude: -116.63734,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83813',
  },
  {
    city: 'Coeur D Alene',
    county_fips: 16055,
    county_fips_all: '16055',
    county: 'Kootenai',
    county_names_all: 'Kootenai',
    county_weights: '{"16055": 100}',
    density: 51.8,
    imprecise: false,
    latitude: 47.63717,
    longitude: -116.75811,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83814',
  },
  {
    city: 'Coeur D Alene',
    county_fips: 16055,
    county_fips_all: '16055',
    county: 'Kootenai',
    county_names_all: 'Kootenai',
    county_weights: '{"16055": 100}',
    density: 1023.7,
    imprecise: false,
    latitude: 47.72498,
    longitude: -116.78732,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83815',
  },
  {
    city: 'Coolin',
    county_fips: 16017,
    county_fips_all: '16017',
    county: 'Bonner',
    county_names_all: 'Bonner',
    county_weights: '{"16017": 100}',
    density: 2,
    imprecise: false,
    latitude: 48.59365,
    longitude: -116.8367,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83821',
  },
  {
    city: 'Oldtown',
    county_fips: 16017,
    county_fips_all: '16017',
    county: 'Bonner',
    county_names_all: 'Bonner',
    county_weights: '{"16017": 100}',
    density: 27.4,
    imprecise: false,
    latitude: 48.16785,
    longitude: -117.0014,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83822',
  },
  {
    city: 'Deary',
    county_fips: 16057,
    county_fips_all: '16057',
    county: 'Latah',
    county_names_all: 'Latah',
    county_weights: '{"16057": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 46.80554,
    longitude: -116.51934,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83823',
  },
  {
    city: 'Desmet',
    county_fips: 16009,
    county_fips_all: '16009|16057',
    county: 'Benewah',
    county_names_all: 'Benewah|Latah',
    county_weights: '{"16009": 73.93, "16057": 26.07}',
    density: 2.4,
    imprecise: false,
    latitude: 47.10638,
    longitude: -116.93901,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83824',
  },
  {
    city: 'Dover',
    county_fips: 16017,
    county_fips_all: '16017',
    county: 'Bonner',
    county_names_all: 'Bonner',
    county_weights: '{"16017": 100}',
    density: 160.9,
    imprecise: false,
    latitude: 48.24694,
    longitude: -116.6076,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83825',
  },
  {
    city: 'Eastport',
    county_fips: 16021,
    county_fips_all: '16021',
    county: 'Boundary',
    county_names_all: 'Boundary',
    county_weights: '{"16021": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 48.98382,
    longitude: -116.15188,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83826',
  },
  {
    city: 'Elk River',
    county_fips: 16035,
    county_fips_all: '16035',
    county: 'Clearwater',
    county_names_all: 'Clearwater',
    county_weights: '{"16035": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 46.78035,
    longitude: -116.17469,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83827',
  },
  {
    city: 'Fernwood',
    county_fips: 16009,
    county_fips_all: '16009|16079',
    county: 'Benewah',
    county_names_all: 'Benewah|Shoshone',
    county_weights: '{"16009": 70.97, "16079": 29.03}',
    density: 0.3,
    imprecise: false,
    latitude: 47.07651,
    longitude: -116.35272,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83830',
  },
  {
    city: 'Genesee',
    county_fips: 16057,
    county_fips_all: '16057|16069',
    county: 'Latah',
    county_names_all: 'Latah|Nez Perce',
    county_weights: '{"16057": 55.17, "16069": 44.83}',
    density: 5,
    imprecise: false,
    latitude: 46.55223,
    longitude: -116.90666,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83832',
  },
  {
    city: 'Harrison',
    county_fips: 16055,
    county_fips_all: '16055|16009',
    county: 'Kootenai',
    county_names_all: 'Kootenai|Benewah',
    county_weights: '{"16055": 99.9, "16009": 0.1}',
    density: 5,
    imprecise: false,
    latitude: 47.51484,
    longitude: -116.73284,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83833',
  },
  {
    city: 'Harvard',
    county_fips: 16057,
    county_fips_all: '16057',
    county: 'Latah',
    county_names_all: 'Latah',
    county_weights: '{"16057": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 46.97566,
    longitude: -116.67484,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83834',
  },
  {
    city: 'Hayden',
    county_fips: 16055,
    county_fips_all: '16055',
    county: 'Kootenai',
    county_names_all: 'Kootenai',
    county_weights: '{"16055": 100}',
    density: 94.1,
    imprecise: false,
    latitude: 47.79557,
    longitude: -116.66843,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83835',
  },
  {
    city: 'Hope',
    county_fips: 16017,
    county_fips_all: '16017',
    county: 'Bonner',
    county_names_all: 'Bonner',
    county_weights: '{"16017": 100}',
    density: 4,
    imprecise: false,
    latitude: 48.27046,
    longitude: -116.24804,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83836',
  },
  {
    city: 'Kellogg',
    county_fips: 16079,
    county_fips_all: '16079',
    county: 'Shoshone',
    county_names_all: 'Shoshone',
    county_weights: '{"16079": 100}',
    density: 20.6,
    imprecise: false,
    latitude: 47.52835,
    longitude: -116.09103,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83837',
  },
  {
    city: 'Kingston',
    county_fips: 16079,
    county_fips_all: '16079',
    county: 'Shoshone',
    county_names_all: 'Shoshone',
    county_weights: '{"16079": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 47.61647,
    longitude: -116.17949,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83839',
  },
  {
    city: 'Kootenai',
    county_fips: 16017,
    county_fips_all: '16017',
    county: 'Bonner',
    county_names_all: 'Bonner',
    county_weights: '{"16017": 100}',
    density: 852.1,
    imprecise: false,
    latitude: 48.31263,
    longitude: -116.51506,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83840',
  },
  {
    city: 'Laclede',
    county_fips: 16017,
    county_fips_all: '16017',
    county: 'Bonner',
    county_names_all: 'Bonner',
    county_weights: '{"16017": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 48.19911,
    longitude: -116.77851,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83841',
  },
  {
    city: 'Medimont',
    county_fips: 16055,
    county_fips_all: '16055',
    county: 'Kootenai',
    county_names_all: 'Kootenai',
    county_weights: '{"16055": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 47.44046,
    longitude: -116.55056,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83842',
  },
  {
    city: 'Moscow',
    county_fips: 16057,
    county_fips_all: '16057',
    county: 'Latah',
    county_names_all: 'Latah',
    county_weights: '{"16057": 100}',
    density: 86.3,
    imprecise: false,
    latitude: 46.72257,
    longitude: -116.94132,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83843',
  },
  {
    city: 'Moyie Springs',
    county_fips: 16021,
    county_fips_all: '16021',
    county: 'Boundary',
    county_names_all: 'Boundary',
    county_weights: '{"16021": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 48.74854,
    longitude: -116.11302,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83845',
  },
  {
    city: 'Mullan',
    county_fips: 16079,
    county_fips_all: '16079',
    county: 'Shoshone',
    county_names_all: 'Shoshone',
    county_weights: '{"16079": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 47.47308,
    longitude: -115.75009,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83846',
  },
  {
    city: 'Naples',
    county_fips: 16021,
    county_fips_all: '16021',
    county: 'Boundary',
    county_names_all: 'Boundary',
    county_weights: '{"16021": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 48.57699,
    longitude: -116.43207,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83847',
  },
  {
    city: 'Nordman',
    county_fips: 16017,
    county_fips_all: '16017',
    county: 'Bonner',
    county_names_all: 'Bonner',
    county_weights: '{"16017": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 48.7067,
    longitude: -116.92766,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83848',
  },
  {
    city: 'Osburn',
    county_fips: 16079,
    county_fips_all: '16079',
    county: 'Shoshone',
    county_names_all: 'Shoshone',
    county_weights: '{"16079": 100}',
    density: 45.5,
    imprecise: false,
    latitude: 47.51723,
    longitude: -115.99531,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83849',
  },
  {
    city: 'Pinehurst',
    county_fips: 16079,
    county_fips_all: '16079',
    county: 'Shoshone',
    county_names_all: 'Shoshone',
    county_weights: '{"16079": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 47.4421,
    longitude: -116.20674,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83850',
  },
  {
    city: 'Plummer',
    county_fips: 16009,
    county_fips_all: '16009',
    county: 'Benewah',
    county_names_all: 'Benewah',
    county_weights: '{"16009": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 47.29899,
    longitude: -116.90513,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83851',
  },
  {
    city: 'Ponderay',
    county_fips: 16017,
    county_fips_all: '16017',
    county: 'Bonner',
    county_names_all: 'Bonner',
    county_weights: '{"16017": 100}',
    density: 234.5,
    imprecise: false,
    latitude: 48.31105,
    longitude: -116.53933,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83852',
  },
  {
    city: 'Post Falls',
    county_fips: 16055,
    county_fips_all: '16055',
    county: 'Kootenai',
    county_names_all: 'Kootenai',
    county_weights: '{"16055": 100}',
    density: 273,
    imprecise: false,
    latitude: 47.7267,
    longitude: -116.97511,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83854',
  },
  {
    city: 'Potlatch',
    county_fips: 16057,
    county_fips_all: '16057',
    county: 'Latah',
    county_names_all: 'Latah',
    county_weights: '{"16057": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 46.97188,
    longitude: -116.92464,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83855',
  },
  {
    city: 'Priest River',
    county_fips: 16017,
    county_fips_all: '16017|53051',
    county: 'Bonner',
    county_names_all: 'Bonner|Pend Oreille',
    county_weights: '{"16017": 91.97, "53051": 8.03}',
    density: 6.7,
    imprecise: false,
    latitude: 48.34228,
    longitude: -116.91058,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83856',
  },
  {
    city: 'Princeton',
    county_fips: 16057,
    county_fips_all: '16057',
    county: 'Latah',
    county_names_all: 'Latah',
    county_weights: '{"16057": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 46.8895,
    longitude: -116.79776,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83857',
  },
  {
    city: 'Rathdrum',
    county_fips: 16055,
    county_fips_all: '16055',
    county: 'Kootenai',
    county_names_all: 'Kootenai',
    county_weights: '{"16055": 100}',
    density: 69.3,
    imprecise: false,
    latitude: 47.85245,
    longitude: -116.90173,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83858',
  },
  {
    city: 'Sagle',
    county_fips: 16017,
    county_fips_all: '16017',
    county: 'Bonner',
    county_names_all: 'Bonner',
    county_weights: '{"16017": 100}',
    density: 25.9,
    imprecise: false,
    latitude: 48.19234,
    longitude: -116.52918,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83860',
  },
  {
    city: 'Saint Maries',
    county_fips: 16009,
    county_fips_all: '16009|16079|16055',
    county: 'Benewah',
    county_names_all: 'Benewah|Shoshone|Kootenai',
    county_weights: '{"16009": 89.23, "16079": 6.0, "16055": 4.77}',
    density: 6.2,
    imprecise: false,
    latitude: 47.2488,
    longitude: -116.57821,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83861',
  },
  {
    city: 'Sandpoint',
    county_fips: 16017,
    county_fips_all: '16017|16021',
    county: 'Bonner',
    county_names_all: 'Bonner|Boundary',
    county_weights: '{"16017": 73.82, "16021": 26.18}',
    density: 19.7,
    imprecise: false,
    latitude: 48.43432,
    longitude: -116.50559,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83864',
  },
  {
    city: 'Santa',
    county_fips: 16009,
    county_fips_all: '16009',
    county: 'Benewah',
    county_names_all: 'Benewah',
    county_weights: '{"16009": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 47.14286,
    longitude: -116.43995,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83866',
  },
  {
    city: 'Silverton',
    county_fips: 16079,
    county_fips_all: '16079',
    county: 'Shoshone',
    county_names_all: 'Shoshone',
    county_weights: '{"16079": 100}',
    density: 59.8,
    imprecise: false,
    latitude: 47.50624,
    longitude: -115.94696,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83867',
  },
  {
    city: 'Smelterville',
    county_fips: 16079,
    county_fips_all: '16079',
    county: 'Shoshone',
    county_names_all: 'Shoshone',
    county_weights: '{"16079": 100}',
    density: 52.4,
    imprecise: false,
    latitude: 47.52441,
    longitude: -116.18439,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83868',
  },
  {
    city: 'Spirit Lake',
    county_fips: 16055,
    county_fips_all: '16055|16017',
    county: 'Kootenai',
    county_names_all: 'Kootenai|Bonner',
    county_weights: '{"16055": 58.1, "16017": 41.9}',
    density: 32.3,
    imprecise: false,
    latitude: 47.98095,
    longitude: -116.89239,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83869',
  },
  {
    city: 'Tensed',
    county_fips: 16009,
    county_fips_all: '16009',
    county: 'Benewah',
    county_names_all: 'Benewah',
    county_weights: '{"16009": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 47.13862,
    longitude: -116.85372,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83870',
  },
  {
    city: 'Troy',
    county_fips: 16057,
    county_fips_all: '16057',
    county: 'Latah',
    county_names_all: 'Latah',
    county_weights: '{"16057": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 46.74589,
    longitude: -116.73865,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83871',
  },
  {
    city: 'Viola',
    county_fips: 16057,
    county_fips_all: '16057',
    county: 'Latah',
    county_names_all: 'Latah',
    county_weights: '{"16057": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 46.85772,
    longitude: -116.97251,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83872',
  },
  {
    city: 'Wallace',
    county_fips: 16079,
    county_fips_all: '16079',
    county: 'Shoshone',
    county_names_all: 'Shoshone',
    county_weights: '{"16079": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 47.5982,
    longitude: -115.90899,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83873',
  },
  {
    city: 'Murray',
    county_fips: 16079,
    county_fips_all: '16079',
    county: 'Shoshone',
    county_names_all: 'Shoshone',
    county_weights: '{"16079": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 47.63563,
    longitude: -115.78882,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83874',
  },
  {
    city: 'Worley',
    county_fips: 16055,
    county_fips_all: '16055',
    county: 'Kootenai',
    county_names_all: 'Kootenai',
    county_weights: '{"16055": 100}',
    density: 5,
    imprecise: false,
    latitude: 47.44842,
    longitude: -116.93161,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83876',
  },
  {
    city: 'Altamont',
    county_fips: 49013,
    county_fips_all: '49013',
    county: 'Duchesne',
    county_names_all: 'Duchesne',
    county_weights: '{"49013": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 40.34525,
    longitude: -110.27241,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84001',
  },
  {
    city: 'Altonah',
    county_fips: 49013,
    county_fips_all: '49013',
    county: 'Duchesne',
    county_names_all: 'Duchesne',
    county_weights: '{"49013": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 40.42467,
    longitude: -110.27784,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84002',
  },
  {
    city: 'American Fork',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 301.3,
    imprecise: false,
    latitude: 40.46629,
    longitude: -111.69334,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 57430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84003',
  },
  {
    city: 'Alpine',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 130,
    imprecise: false,
    latitude: 40.48444,
    longitude: -111.74447,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84004',
  },
  {
    city: 'Eagle Mountain',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 555.5,
    imprecise: false,
    latitude: 40.32277,
    longitude: -111.99942,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 52530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84005',
  },
  {
    city: 'Bingham Canyon',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 15.8,
    imprecise: false,
    latitude: 40.59682,
    longitude: -112.12373,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84006',
  },
  {
    city: 'Bluebell',
    county_fips: 49013,
    county_fips_all: '49013',
    county: 'Duchesne',
    county_names_all: 'Duchesne',
    county_weights: '{"49013": 100}',
    density: 8,
    imprecise: false,
    latitude: 40.34115,
    longitude: -110.21717,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84007',
  },
  {
    city: 'South Jordan',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1595.7,
    imprecise: false,
    latitude: 40.55221,
    longitude: -112.05362,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84009',
  },
  {
    city: 'Bountiful',
    county_fips: 49011,
    county_fips_all: '49011|49029',
    county: 'Davis',
    county_names_all: 'Davis|Morgan',
    county_weights: '{"49011": 99.85, "49029": 0.15}',
    density: 476,
    imprecise: false,
    latitude: 40.87433,
    longitude: -111.83042,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 46871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84010',
  },
  {
    city: 'Cedar Valley',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 40.2958,
    longitude: -112.0913,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84013',
  },
  {
    city: 'Centerville',
    county_fips: 49011,
    county_fips_all: '49011',
    county: 'Davis',
    county_names_all: 'Davis',
    county_weights: '{"49011": 100}',
    density: 500.8,
    imprecise: false,
    latitude: 40.93311,
    longitude: -111.85308,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84014',
  },
  {
    city: 'Clearfield',
    county_fips: 49011,
    county_fips_all: '49011',
    county: 'Davis',
    county_names_all: 'Davis',
    county_weights: '{"49011": 100}',
    density: 1331.4,
    imprecise: false,
    latitude: 41.12073,
    longitude: -112.06129,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 71812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84015',
  },
  {
    city: 'Coalville',
    county_fips: 49043,
    county_fips_all: '49043',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"49043": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 40.9549,
    longitude: -111.20582,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84017',
  },
  {
    city: 'Croydon',
    county_fips: 49029,
    county_fips_all: '49029',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"49029": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 41.20535,
    longitude: -111.42716,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84018',
  },
  {
    city: 'Draper',
    county_fips: 49035,
    county_fips_all: '49035|49049',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake|Utah',
    county_weights: '{"49035": 80.13, "49049": 19.87}',
    density: 714.6,
    imprecise: false,
    latitude: 40.49885,
    longitude: -111.8635,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 50278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84020',
  },
  {
    city: 'Duchesne',
    county_fips: 49013,
    county_fips_all: '49013',
    county: 'Duchesne',
    county_names_all: 'Duchesne',
    county_weights: '{"49013": 100}',
    density: 2,
    imprecise: false,
    latitude: 40.10998,
    longitude: -110.51593,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84021',
  },
  {
    city: 'Dugway',
    county_fips: 49045,
    county_fips_all: '49045|49023',
    county: 'Tooele',
    county_names_all: 'Tooele|Juab',
    county_weights: '{"49045": 75.59, "49023": 24.41}',
    density: 1.4,
    imprecise: false,
    latitude: 40.17921,
    longitude: -112.81371,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84022',
  },
  {
    city: 'Dutch John',
    county_fips: 49009,
    county_fips_all: '49009|49047',
    county: 'Daggett',
    county_names_all: 'Daggett|Uintah',
    county_weights: '{"49009": 99.83, "49047": 0.17}',
    density: 0.2,
    imprecise: false,
    latitude: 40.83781,
    longitude: -109.20665,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84023',
  },
  {
    city: 'Echo',
    county_fips: 49043,
    county_fips_all: '49043',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"49043": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 41.00765,
    longitude: -111.44721,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84024',
  },
  {
    city: 'Farmington',
    county_fips: 49011,
    county_fips_all: '49011',
    county: 'Davis',
    county_names_all: 'Davis',
    county_weights: '{"49011": 100}',
    density: 689,
    imprecise: false,
    latitude: 40.97667,
    longitude: -111.89874,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 25389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84025',
  },
  {
    city: 'Fort Duchesne',
    county_fips: 49047,
    county_fips_all: '49047',
    county: 'Uintah',
    county_names_all: 'Uintah',
    county_weights: '{"49047": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 40.29122,
    longitude: -109.83882,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84026',
  },
  {
    city: 'Fruitland',
    county_fips: 49013,
    county_fips_all: '49013',
    county: 'Duchesne',
    county_names_all: 'Duchesne',
    county_weights: '{"49013": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 40.15643,
    longitude: -110.79453,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84027',
  },
  {
    city: 'Garden City',
    county_fips: 49033,
    county_fips_all: '49033',
    county: 'Rich',
    county_names_all: 'Rich',
    county_weights: '{"49033": 100}',
    density: 5,
    imprecise: false,
    latitude: 41.93107,
    longitude: -111.38267,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84028',
  },
  {
    city: 'Grantsville',
    county_fips: 49045,
    county_fips_all: '49045|49003',
    county: 'Tooele',
    county_names_all: 'Tooele|Box Elder',
    county_weights: '{"49045": 99.64, "49003": 0.36}',
    density: 4.4,
    imprecise: false,
    latitude: 40.6483,
    longitude: -112.98298,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 14869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84029',
  },
  {
    city: 'Hanna',
    county_fips: 49013,
    county_fips_all: '49013',
    county: 'Duchesne',
    county_names_all: 'Duchesne',
    county_weights: '{"49013": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 40.60493,
    longitude: -110.63735,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84031',
  },
  {
    city: 'Heber City',
    county_fips: 49051,
    county_fips_all: '49051',
    county: 'Wasatch',
    county_names_all: 'Wasatch',
    county_weights: '{"49051": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 40.35839,
    longitude: -111.188,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 26111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84032',
  },
  {
    city: 'Henefer',
    county_fips: 49043,
    county_fips_all: '49043',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"49043": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 40.98002,
    longitude: -111.49148,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84033',
  },
  {
    city: 'Ibapah',
    county_fips: 49045,
    county_fips_all: '49045|49023|32033',
    county: 'Tooele',
    county_names_all: 'Tooele|Juab|White Pine',
    county_weights: '{"49045": 69.79, "49023": 21.01, "32033": 9.2}',
    density: 0.2,
    imprecise: false,
    latitude: 39.99427,
    longitude: -113.9575,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84034',
  },
  {
    city: 'Jensen',
    county_fips: 49047,
    county_fips_all: '49047',
    county: 'Uintah',
    county_names_all: 'Uintah',
    county_weights: '{"49047": 100}',
    density: 1,
    imprecise: false,
    latitude: 40.39024,
    longitude: -109.28208,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84035',
  },
  {
    city: 'Kamas',
    county_fips: 49043,
    county_fips_all: '49043|49051',
    county: 'Summit',
    county_names_all: 'Summit|Wasatch',
    county_weights: '{"49043": 71.78, "49051": 28.22}',
    density: 10.8,
    imprecise: false,
    latitude: 40.66022,
    longitude: -111.1093,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84036',
  },
  {
    city: 'Kaysville',
    county_fips: 49011,
    county_fips_all: '49011',
    county: 'Davis',
    county_names_all: 'Davis',
    county_weights: '{"49011": 100}',
    density: 313.1,
    imprecise: false,
    latitude: 40.99281,
    longitude: -111.91444,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 39415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84037',
  },
  {
    city: 'Laketown',
    county_fips: 49033,
    county_fips_all: '49033',
    county: 'Rich',
    county_names_all: 'Rich',
    county_weights: '{"49033": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 41.87926,
    longitude: -111.29692,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84038',
  },
  {
    city: 'Lapoint',
    county_fips: 49047,
    county_fips_all: '49047',
    county: 'Uintah',
    county_names_all: 'Uintah',
    county_weights: '{"49047": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 40.44602,
    longitude: -109.80972,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84039',
  },
  {
    city: 'Layton',
    county_fips: 49011,
    county_fips_all: '49011',
    county: 'Davis',
    county_names_all: 'Davis',
    county_weights: '{"49011": 100}',
    density: 453.9,
    imprecise: false,
    latitude: 41.09121,
    longitude: -111.89674,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 28509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84040',
  },
  {
    city: 'Layton',
    county_fips: 49011,
    county_fips_all: '49011',
    county: 'Davis',
    county_names_all: 'Davis',
    county_weights: '{"49011": 100}',
    density: 1427.1,
    imprecise: false,
    latitude: 41.07137,
    longitude: -111.98416,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 55180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84041',
  },
  {
    city: 'Lindon',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 571,
    imprecise: false,
    latitude: 40.34113,
    longitude: -111.72466,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 11725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84042',
  },
  {
    city: 'Lehi',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 1096,
    imprecise: false,
    latitude: 40.41209,
    longitude: -111.87377,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 88390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84043',
  },
  {
    city: 'Magna',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 158.2,
    imprecise: false,
    latitude: 40.73,
    longitude: -112.1474,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 30031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84044',
  },
  {
    city: 'Saratoga Springs',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 337.7,
    imprecise: false,
    latitude: 40.28574,
    longitude: -111.91384,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 45429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84045',
  },
  {
    city: 'Manila',
    county_fips: 49009,
    county_fips_all: '49009',
    county: 'Daggett',
    county_names_all: 'Daggett',
    county_weights: '{"49009": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 40.95339,
    longitude: -109.82786,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84046',
  },
  {
    city: 'Midvale',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 2262.9,
    imprecise: false,
    latitude: 40.61533,
    longitude: -111.89176,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 37411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84047',
  },
  {
    city: 'Midway',
    county_fips: 49051,
    county_fips_all: '49051',
    county: 'Wasatch',
    county_names_all: 'Wasatch',
    county_weights: '{"49051": 100}',
    density: 35.3,
    imprecise: false,
    latitude: 40.5136,
    longitude: -111.51657,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84049',
  },
  {
    city: 'Morgan',
    county_fips: 49029,
    county_fips_all: '49029',
    county: 'Morgan',
    county_names_all: 'Morgan',
    county_weights: '{"49029": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 41.02244,
    longitude: -111.67229,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84050',
  },
  {
    city: 'Mountain Home',
    county_fips: 49013,
    county_fips_all: '49013',
    county: 'Duchesne',
    county_names_all: 'Duchesne',
    county_weights: '{"49013": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 40.39552,
    longitude: -110.43131,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84051',
  },
  {
    city: 'Myton',
    county_fips: 49013,
    county_fips_all: '49013|49047',
    county: 'Duchesne',
    county_names_all: 'Duchesne|Uintah',
    county_weights: '{"49013": 53.72, "49047": 46.28}',
    density: 2.8,
    imprecise: false,
    latitude: 40.16829,
    longitude: -109.99089,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84052',
  },
  {
    city: 'Neola',
    county_fips: 49013,
    county_fips_all: '49013|49047',
    county: 'Duchesne',
    county_names_all: 'Duchesne|Uintah',
    county_weights: '{"49013": 67.26, "49047": 32.74}',
    density: 7.3,
    imprecise: false,
    latitude: 40.43325,
    longitude: -109.98941,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84053',
  },
  {
    city: 'North Salt Lake',
    county_fips: 49011,
    county_fips_all: '49011',
    county: 'Davis',
    county_names_all: 'Davis',
    county_weights: '{"49011": 100}',
    density: 1007,
    imprecise: false,
    latitude: 40.84078,
    longitude: -111.91754,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 22355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84054',
  },
  {
    city: 'Oakley',
    county_fips: 49043,
    county_fips_all: '49043',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"49043": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 40.71889,
    longitude: -111.16106,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84055',
  },
  {
    city: 'Hill Air Force Base',
    county_fips: 49011,
    county_fips_all: '49011',
    county: 'Davis',
    county_names_all: 'Davis',
    county_weights: '{"49011": 100}',
    density: 152.4,
    imprecise: false,
    latitude: 41.12679,
    longitude: -111.99084,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84056',
  },
  {
    city: 'Orem',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 2311.4,
    imprecise: false,
    latitude: 40.31427,
    longitude: -111.70948,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 36881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84057',
  },
  {
    city: 'Orem',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 1688.1,
    imprecise: false,
    latitude: 40.27474,
    longitude: -111.71468,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84058',
  },
  {
    city: 'Vineyard',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 1273,
    imprecise: false,
    latitude: 40.30353,
    longitude: -111.74853,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 17616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84059',
  },
  {
    city: 'Park City',
    county_fips: 49043,
    county_fips_all: '49043|49051',
    county: 'Summit',
    county_names_all: 'Summit|Wasatch',
    county_weights: '{"49043": 75.57, "49051": 24.43}',
    density: 76,
    imprecise: false,
    latitude: 40.6418,
    longitude: -111.50332,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84060',
  },
  {
    city: 'Peoa',
    county_fips: 49043,
    county_fips_all: '49043',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"49043": 100}',
    density: 3,
    imprecise: false,
    latitude: 40.74721,
    longitude: -111.3417,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84061',
  },
  {
    city: 'Pleasant Grove',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 364.1,
    imprecise: false,
    latitude: 40.38586,
    longitude: -111.68421,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 47813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84062',
  },
  {
    city: 'Randlett',
    county_fips: 49047,
    county_fips_all: '49047',
    county: 'Uintah',
    county_names_all: 'Uintah',
    county_weights: '{"49047": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 40.21007,
    longitude: -109.69285,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84063',
  },
  {
    city: 'Randolph',
    county_fips: 49033,
    county_fips_all: '49033',
    county: 'Rich',
    county_names_all: 'Rich',
    county_weights: '{"49033": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 41.67086,
    longitude: -111.12293,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84064',
  },
  {
    city: 'Riverton',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 949.5,
    imprecise: false,
    latitude: 40.495,
    longitude: -111.9444,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 50768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84065',
  },
  {
    city: 'Roosevelt',
    county_fips: 49013,
    county_fips_all: '49013|49047',
    county: 'Duchesne',
    county_names_all: 'Duchesne|Uintah',
    county_weights: '{"49013": 78.95, "49047": 21.05}',
    density: 24.4,
    imprecise: false,
    latitude: 40.34671,
    longitude: -110.05171,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84066',
  },
  {
    city: 'Roy',
    county_fips: 49057,
    county_fips_all: '49057',
    county: 'Weber',
    county_names_all: 'Weber',
    county_weights: '{"49057": 100}',
    density: 1826.6,
    imprecise: false,
    latitude: 41.17189,
    longitude: -112.04803,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 38794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84067',
  },
  {
    city: 'Rush Valley',
    county_fips: 49045,
    county_fips_all: '49045',
    county: 'Tooele',
    county_names_all: 'Tooele',
    county_weights: '{"49045": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 40.36521,
    longitude: -112.48548,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84069',
  },
  {
    city: 'Sandy',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1603.4,
    imprecise: false,
    latitude: 40.57707,
    longitude: -111.88916,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 30472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84070',
  },
  {
    city: 'Stockton',
    county_fips: 49045,
    county_fips_all: '49045',
    county: 'Tooele',
    county_names_all: 'Tooele',
    county_weights: '{"49045": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 40.4191,
    longitude: -112.32475,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84071',
  },
  {
    city: 'Tabiona',
    county_fips: 49013,
    county_fips_all: '49013',
    county: 'Duchesne',
    county_names_all: 'Duchesne',
    county_weights: '{"49013": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 40.3641,
    longitude: -110.633,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84072',
  },
  {
    city: 'Talmage',
    county_fips: 49013,
    county_fips_all: '49013',
    county: 'Duchesne',
    county_names_all: 'Duchesne',
    county_weights: '{"49013": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 40.3456,
    longitude: -110.41394,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84073',
  },
  {
    city: 'Tooele',
    county_fips: 49045,
    county_fips_all: '49045',
    county: 'Tooele',
    county_names_all: 'Tooele',
    county_weights: '{"49045": 100}',
    density: 132.3,
    imprecise: false,
    latitude: 40.57379,
    longitude: -112.29914,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 59706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84074',
  },
  {
    city: 'Syracuse',
    county_fips: 49011,
    county_fips_all: '49011',
    county: 'Davis',
    county_names_all: 'Davis',
    county_weights: '{"49011": 100}',
    density: 392.7,
    imprecise: false,
    latitude: 41.05975,
    longitude: -112.06933,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84075',
  },
  {
    city: 'Tridell',
    county_fips: 49047,
    county_fips_all: '49047',
    county: 'Uintah',
    county_names_all: 'Uintah',
    county_weights: '{"49047": 100}',
    density: 22.6,
    imprecise: false,
    latitude: 40.44718,
    longitude: -109.84017,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84076',
  },
  {
    city: 'Vernal',
    county_fips: 49047,
    county_fips_all: '49047',
    county: 'Uintah',
    county_names_all: 'Uintah',
    county_weights: '{"49047": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 40.46403,
    longitude: -109.5084,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 30975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84078',
  },
  {
    city: 'Vernon',
    county_fips: 49045,
    county_fips_all: '49045',
    county: 'Tooele',
    county_names_all: 'Tooele',
    county_weights: '{"49045": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 40.02168,
    longitude: -112.44818,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84080',
  },
  {
    city: 'West Jordan',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1305.6,
    imprecise: false,
    latitude: 40.60275,
    longitude: -112.03821,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 52314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84081',
  },
  {
    city: 'Wallsburg',
    county_fips: 49051,
    county_fips_all: '49051',
    county: 'Wasatch',
    county_names_all: 'Wasatch',
    county_weights: '{"49051": 100}',
    density: 2,
    imprecise: false,
    latitude: 40.3404,
    longitude: -111.36184,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84082',
  },
  {
    city: 'Wendover',
    county_fips: 49045,
    county_fips_all: '49045',
    county: 'Tooele',
    county_names_all: 'Tooele',
    county_weights: '{"49045": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 40.84354,
    longitude: -113.6944,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84083',
  },
  {
    city: 'West Jordan',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1834.2,
    imprecise: false,
    latitude: 40.62139,
    longitude: -111.96603,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 31542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84084',
  },
  {
    city: 'Whiterocks',
    county_fips: 49047,
    county_fips_all: '49047',
    county: 'Uintah',
    county_names_all: 'Uintah',
    county_weights: '{"49047": 100}',
    density: 1,
    imprecise: false,
    latitude: 40.58609,
    longitude: -109.92642,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84085',
  },
  {
    city: 'Woodruff',
    county_fips: 49033,
    county_fips_all: '49033',
    county: 'Rich',
    county_names_all: 'Rich',
    county_weights: '{"49033": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 41.41644,
    longitude: -111.20858,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84086',
  },
  {
    city: 'Woods Cross',
    county_fips: 49011,
    county_fips_all: '49011',
    county: 'Davis',
    county_names_all: 'Davis',
    county_weights: '{"49011": 100}',
    density: 468.3,
    imprecise: false,
    latitude: 40.8891,
    longitude: -111.92898,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84087',
  },
  {
    city: 'West Jordan',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1616.6,
    imprecise: false,
    latitude: 40.59507,
    longitude: -111.96077,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 39228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84088',
  },
  {
    city: 'Sandy',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 196.6,
    imprecise: false,
    latitude: 40.55803,
    longitude: -111.74205,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 27651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84092',
  },
  {
    city: 'Sandy',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1672.3,
    imprecise: false,
    latitude: 40.59473,
    longitude: -111.82863,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 23871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84093',
  },
  {
    city: 'Sandy',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 2089.2,
    imprecise: false,
    latitude: 40.57177,
    longitude: -111.86201,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 27507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84094',
  },
  {
    city: 'South Jordan',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1289,
    imprecise: false,
    latitude: 40.55856,
    longitude: -111.94165,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 38532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84095',
  },
  {
    city: 'Herriman',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 405.4,
    imprecise: false,
    latitude: 40.50539,
    longitude: -112.08546,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 74603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84096',
  },
  {
    city: 'Orem',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 1422,
    imprecise: false,
    latitude: 40.3048,
    longitude: -111.67318,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 22217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84097',
  },
  {
    city: 'Park City',
    county_fips: 49043,
    county_fips_all: '49043',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"49043": 100}',
    density: 109.4,
    imprecise: false,
    latitude: 40.73988,
    longitude: -111.53504,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 20357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84098',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1963.7,
    imprecise: false,
    latitude: 40.75628,
    longitude: -111.89996,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84101',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 3753.6,
    imprecise: false,
    latitude: 40.75992,
    longitude: -111.86367,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18777,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84102',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 446.9,
    imprecise: false,
    latitude: 40.8034,
    longitude: -111.84708,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 23749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84103',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 419,
    imprecise: false,
    latitude: 40.74846,
    longitude: -111.98286,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 23420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84104',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 2948.6,
    imprecise: false,
    latitude: 40.73841,
    longitude: -111.85982,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 23491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84105',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 2251.7,
    imprecise: false,
    latitude: 40.70678,
    longitude: -111.85571,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84106',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1959,
    imprecise: false,
    latitude: 40.65799,
    longitude: -111.88447,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 38257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84107',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 119.7,
    imprecise: false,
    latitude: 40.78811,
    longitude: -111.7365,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 22390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84108',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 173,
    imprecise: false,
    latitude: 40.70196,
    longitude: -111.7051,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 25544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84109',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 3627.5,
    imprecise: false,
    latitude: 40.75575,
    longitude: -111.88431,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84111',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1238.9,
    imprecise: false,
    latitude: 40.7652,
    longitude: -111.84123,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84112',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 529.1,
    imprecise: false,
    latitude: 40.76248,
    longitude: -111.83291,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84113',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.77794,
    longitude: -111.88831,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84114',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1836.1,
    imprecise: false,
    latitude: 40.71467,
    longitude: -111.89266,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 28882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84115',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 296.2,
    imprecise: false,
    latitude: 40.83258,
    longitude: -112.01691,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 38625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84116',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1717.3,
    imprecise: false,
    latitude: 40.66167,
    longitude: -111.83561,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 24980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84117',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1274.3,
    imprecise: false,
    latitude: 40.65598,
    longitude: -112.03812,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 42853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84118',
  },
  {
    city: 'West Valley City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1679.2,
    imprecise: false,
    latitude: 40.70289,
    longitude: -111.94591,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 50070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84119',
  },
  {
    city: 'West Valley City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1942.3,
    imprecise: false,
    latitude: 40.69686,
    longitude: -112.00178,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 50799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84120',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 233.1,
    imprecise: false,
    latitude: 40.62557,
    longitude: -111.69864,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 38912,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84121',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1729.4,
    imprecise: false,
    latitude: 40.65837,
    longitude: -111.92177,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 37054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84123',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1131.5,
    imprecise: false,
    latitude: 40.67113,
    longitude: -111.80705,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 22609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84124',
  },
  {
    city: 'West Valley City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 1480.2,
    imprecise: false,
    latitude: 40.70518,
    longitude: -112.04259,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84128',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 2167.8,
    imprecise: false,
    latitude: 40.6536,
    longitude: -111.96209,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 37442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84129',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.76675,
    longitude: -111.88724,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84138',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.77044,
    longitude: -111.9011,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84180',
  },
  {
    city: 'Bear River City',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 121.9,
    imprecise: false,
    latitude: 41.61368,
    longitude: -112.12723,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84301',
  },
  {
    city: 'Brigham City',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 131.4,
    imprecise: false,
    latitude: 41.57956,
    longitude: -112.04769,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 27053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84302',
  },
  {
    city: 'Cache Junction',
    county_fips: 49005,
    county_fips_all: '49005|49003',
    county: 'Cache',
    county_names_all: 'Cache|Box Elder',
    county_weights: '{"49005": 99.86, "49003": 0.14}',
    density: 0.5,
    imprecise: false,
    latitude: 41.82722,
    longitude: -111.99867,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84304',
  },
  {
    city: 'Clarkston',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 41.94388,
    longitude: -112.05804,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84305',
  },
  {
    city: 'Collinston',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 41.78272,
    longitude: -112.06323,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84306',
  },
  {
    city: 'Corinne',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 41.5535,
    longitude: -112.49192,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84307',
  },
  {
    city: 'Cornish',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 41.9656,
    longitude: -111.96681,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84308',
  },
  {
    city: 'Deweyville',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 39.1,
    imprecise: false,
    latitude: 41.71375,
    longitude: -112.09908,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84309',
  },
  {
    city: 'Eden',
    county_fips: 49057,
    county_fips_all: '49057',
    county: 'Weber',
    county_names_all: 'Weber',
    county_weights: '{"49057": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 41.3371,
    longitude: -111.84598,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84310',
  },
  {
    city: 'Fielding',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 43.8,
    imprecise: false,
    latitude: 41.82012,
    longitude: -112.1106,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84311',
  },
  {
    city: 'Garland',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 75.5,
    imprecise: false,
    latitude: 41.77976,
    longitude: -112.15681,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84312',
  },
  {
    city: 'Grouse Creek',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.34615,
    longitude: -113.71268,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84313',
  },
  {
    city: 'Honeyville',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 48,
    imprecise: false,
    latitude: 41.64929,
    longitude: -112.09292,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84314',
  },
  {
    city: 'Hooper',
    county_fips: 49057,
    county_fips_all: '49057|49011',
    county: 'Weber',
    county_names_all: 'Weber|Davis',
    county_weights: '{"49057": 77.87, "49011": 22.13}',
    density: 213.6,
    imprecise: false,
    latitude: 41.16681,
    longitude: -112.13672,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84315',
  },
  {
    city: 'Howell',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 41.77328,
    longitude: -112.44504,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84316',
  },
  {
    city: 'Huntsville',
    county_fips: 49057,
    county_fips_all: '49057',
    county: 'Weber',
    county_names_all: 'Weber',
    county_weights: '{"49057": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 41.30359,
    longitude: -111.62178,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84317',
  },
  {
    city: 'Hyde Park',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 388,
    imprecise: false,
    latitude: 41.80167,
    longitude: -111.80422,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84318',
  },
  {
    city: 'Hyrum',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 41.6,
    imprecise: false,
    latitude: 41.59401,
    longitude: -111.659,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84319',
  },
  {
    city: 'Lewiston',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 41.96011,
    longitude: -111.85252,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84320',
  },
  {
    city: 'Logan',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 90.7,
    imprecise: false,
    latitude: 41.77938,
    longitude: -111.68316,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 51702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84321',
  },
  {
    city: 'Mantua',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 29.4,
    imprecise: false,
    latitude: 41.49253,
    longitude: -111.93868,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84324',
  },
  {
    city: 'Mendon',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 22.7,
    imprecise: false,
    latitude: 41.73869,
    longitude: -111.99303,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84325',
  },
  {
    city: 'Millville',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 210.4,
    imprecise: false,
    latitude: 41.67228,
    longitude: -111.81772,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84326',
  },
  {
    city: 'Newton',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 41.86555,
    longitude: -111.99512,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84327',
  },
  {
    city: 'Paradise',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 41.53937,
    longitude: -111.8444,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1681,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84328',
  },
  {
    city: 'Park Valley',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 41.79229,
    longitude: -113.47079,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84329',
  },
  {
    city: 'Plymouth',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 41.9063,
    longitude: -112.17019,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84330',
  },
  {
    city: 'Portage',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 41.94354,
    longitude: -112.35869,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84331',
  },
  {
    city: 'Providence',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 865.6,
    imprecise: false,
    latitude: 41.70313,
    longitude: -111.81205,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84332',
  },
  {
    city: 'Richmond',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 51.7,
    imprecise: false,
    latitude: 41.91008,
    longitude: -111.79882,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84333',
  },
  {
    city: 'Riverside',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 154.4,
    imprecise: false,
    latitude: 41.78955,
    longitude: -112.15189,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84334',
  },
  {
    city: 'Smithfield',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 95.6,
    imprecise: false,
    latitude: 41.82907,
    longitude: -111.88074,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84335',
  },
  {
    city: 'Snowville',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 41.87159,
    longitude: -112.74697,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84336',
  },
  {
    city: 'Tremonton',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 37.3,
    imprecise: false,
    latitude: 41.69223,
    longitude: -112.28486,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84337',
  },
  {
    city: 'Trenton',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 21.4,
    imprecise: false,
    latitude: 41.91133,
    longitude: -111.93527,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84338',
  },
  {
    city: 'Wellsville',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 39.2,
    imprecise: false,
    latitude: 41.62546,
    longitude: -111.939,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84339',
  },
  {
    city: 'Willard',
    county_fips: 49003,
    county_fips_all: '49003',
    county: 'Box Elder',
    county_names_all: 'Box Elder',
    county_weights: '{"49003": 100}',
    density: 44.9,
    imprecise: false,
    latitude: 41.39312,
    longitude: -112.15705,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84340',
  },
  {
    city: 'Logan',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 923.2,
    imprecise: false,
    latitude: 41.77197,
    longitude: -111.81128,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 25560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84341',
  },
  {
    city: 'Ogden',
    county_fips: 49057,
    county_fips_all: '49057',
    county: 'Weber',
    county_names_all: 'Weber',
    county_weights: '{"49057": 100}',
    density: 608.1,
    imprecise: false,
    latitude: 41.21962,
    longitude: -112.03352,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 48303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84401',
  },
  {
    city: 'Ogden',
    county_fips: 49057,
    county_fips_all: '49057',
    county: 'Weber',
    county_names_all: 'Weber',
    county_weights: '{"49057": 100}',
    density: 428.2,
    imprecise: false,
    latitude: 41.19379,
    longitude: -111.9038,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 37721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84403',
  },
  {
    city: 'Ogden',
    county_fips: 49057,
    county_fips_all: '49057',
    county: 'Weber',
    county_names_all: 'Weber',
    county_weights: '{"49057": 100}',
    density: 267.1,
    imprecise: false,
    latitude: 41.27198,
    longitude: -112.11705,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 66587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84404',
  },
  {
    city: 'Ogden',
    county_fips: 49057,
    county_fips_all: '49057|49011',
    county: 'Weber',
    county_names_all: 'Weber|Davis',
    county_weights: '{"49057": 66.08, "49011": 33.92}',
    density: 726.5,
    imprecise: false,
    latitude: 41.15747,
    longitude: -111.96499,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 34818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84405',
  },
  {
    city: 'Ogden',
    county_fips: 49057,
    county_fips_all: '49057',
    county: 'Weber',
    county_names_all: 'Weber',
    county_weights: '{"49057": 100}',
    density: 610.5,
    imprecise: false,
    latitude: 41.32578,
    longitude: -111.96547,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 34334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84414',
  },
  {
    city: 'Price',
    county_fips: 49007,
    county_fips_all: '49007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"49007": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 39.53214,
    longitude: -110.80393,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 13042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84501',
  },
  {
    city: 'Blanding',
    county_fips: 49037,
    county_fips_all: '49037',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"49037": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 37.52687,
    longitude: -109.42054,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84511',
  },
  {
    city: 'Bluff',
    county_fips: 49037,
    county_fips_all: '49037',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"49037": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 37.16255,
    longitude: -109.55921,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84512',
  },
  {
    city: 'Castle Dale',
    county_fips: 49015,
    county_fips_all: '49015',
    county: 'Emery',
    county_names_all: 'Emery',
    county_weights: '{"49015": 100}',
    density: 36,
    imprecise: false,
    latitude: 39.24932,
    longitude: -111.00912,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84513',
  },
  {
    city: 'Cisco',
    county_fips: 49019,
    county_fips_all: '49019',
    county: 'Grand',
    county_names_all: 'Grand',
    county_weights: '{"49019": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.96824,
    longitude: -109.23876,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84515',
  },
  {
    city: 'Clawson',
    county_fips: 49015,
    county_fips_all: '49015',
    county: 'Emery',
    county_names_all: 'Emery',
    county_weights: '{"49015": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 39.12842,
    longitude: -111.06703,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84516',
  },
  {
    city: 'Cleveland',
    county_fips: 49015,
    county_fips_all: '49015',
    county: 'Emery',
    county_names_all: 'Emery',
    county_weights: '{"49015": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 39.3917,
    longitude: -110.88478,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84518',
  },
  {
    city: 'East Carbon',
    county_fips: 49007,
    county_fips_all: '49007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"49007": 100}',
    density: 48.7,
    imprecise: false,
    latitude: 39.53392,
    longitude: -110.41949,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84520',
  },
  {
    city: 'Elmo',
    county_fips: 49015,
    county_fips_all: '49015',
    county: 'Emery',
    county_names_all: 'Emery',
    county_weights: '{"49015": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 39.4213,
    longitude: -110.78709,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84521',
  },
  {
    city: 'Emery',
    county_fips: 49015,
    county_fips_all: '49015',
    county: 'Emery',
    county_names_all: 'Emery',
    county_weights: '{"49015": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 38.90991,
    longitude: -111.20987,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84522',
  },
  {
    city: 'Ferron',
    county_fips: 49015,
    county_fips_all: '49015',
    county: 'Emery',
    county_names_all: 'Emery',
    county_weights: '{"49015": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 39.0946,
    longitude: -111.2014,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84523',
  },
  {
    city: 'Green River',
    county_fips: 49015,
    county_fips_all: '49015|49019',
    county: 'Emery',
    county_names_all: 'Emery|Grand',
    county_weights: '{"49015": 79.78, "49019": 20.22}',
    density: 0.7,
    imprecise: false,
    latitude: 38.87947,
    longitude: -110.33217,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84525',
  },
  {
    city: 'Helper',
    county_fips: 49007,
    county_fips_all: '49007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"49007": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 39.72395,
    longitude: -111.04571,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84526',
  },
  {
    city: 'Huntington',
    county_fips: 49015,
    county_fips_all: '49015',
    county: 'Emery',
    county_names_all: 'Emery',
    county_weights: '{"49015": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 39.43404,
    longitude: -111.08778,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84528',
  },
  {
    city: 'Kenilworth',
    county_fips: 49007,
    county_fips_all: '49007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"49007": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 39.71151,
    longitude: -110.7733,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84529',
  },
  {
    city: 'La Sal',
    county_fips: 49037,
    county_fips_all: '49037',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"49037": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 38.23736,
    longitude: -109.40846,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84530',
  },
  {
    city: 'Mexican Hat',
    county_fips: 49037,
    county_fips_all: '49037|04001',
    county: 'San Juan',
    county_names_all: 'San Juan|Apache',
    county_weights: '{"49037": 78.79, "04001": 21.21}',
    density: 0.7,
    imprecise: false,
    latitude: 37.0683,
    longitude: -109.86371,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84531',
  },
  {
    city: 'Moab',
    county_fips: 49019,
    county_fips_all: '49019|49037',
    county: 'Grand',
    county_names_all: 'Grand|San Juan',
    county_weights: '{"49019": 55.98, "49037": 44.02}',
    density: 2.6,
    imprecise: false,
    latitude: 38.53898,
    longitude: -109.45916,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84532',
  },
  {
    city: 'Lake Powell',
    county_fips: 49037,
    county_fips_all: '49037|49025',
    county: 'San Juan',
    county_names_all: 'San Juan|Kane',
    county_weights: '{"49037": 68.6, "49025": 31.4}',
    density: 0,
    imprecise: false,
    latitude: 37.40827,
    longitude: -110.56844,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84533',
  },
  {
    city: 'Montezuma Creek',
    county_fips: 49037,
    county_fips_all: '49037',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"49037": 100}',
    density: 2,
    imprecise: false,
    latitude: 37.21283,
    longitude: -109.26826,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84534',
  },
  {
    city: 'Monticello',
    county_fips: 49037,
    county_fips_all: '49037',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"49037": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 37.84244,
    longitude: -109.28673,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84535',
  },
  {
    city: 'Monument Valley',
    county_fips: 49037,
    county_fips_all: '49037|04017',
    county: 'San Juan',
    county_names_all: 'San Juan|Navajo',
    county_weights: '{"49037": 97.26, "04017": 2.74}',
    density: 0.9,
    imprecise: false,
    latitude: 37.14017,
    longitude: -110.23104,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84536',
  },
  {
    city: 'Orangeville',
    county_fips: 49015,
    county_fips_all: '49015',
    county: 'Emery',
    county_names_all: 'Emery',
    county_weights: '{"49015": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 39.29966,
    longitude: -111.17345,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84537',
  },
  {
    city: 'Sunnyside',
    county_fips: 49007,
    county_fips_all: '49007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"49007": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 39.5761,
    longitude: -110.4007,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84539',
  },
  {
    city: 'Thompson',
    county_fips: 49019,
    county_fips_all: '49019',
    county: 'Grand',
    county_names_all: 'Grand',
    county_weights: '{"49019": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.20039,
    longitude: -109.55281,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84540',
  },
  {
    city: 'Wellington',
    county_fips: 49007,
    county_fips_all: '49007',
    county: 'Carbon',
    county_names_all: 'Carbon',
    county_weights: '{"49007": 100}',
    density: 38.2,
    imprecise: false,
    latitude: 39.64433,
    longitude: -110.59916,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84542',
  },
  {
    city: 'Provo',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 938.1,
    imprecise: false,
    latitude: 40.22593,
    longitude: -111.6955,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84601',
  },
  {
    city: 'Provo',
    county_fips: 49049,
    county_fips_all: '49049|49051',
    county: 'Utah',
    county_names_all: 'Utah|Wasatch',
    county_weights: '{"49049": 88.33, "49051": 11.67}',
    density: 182,
    imprecise: false,
    latitude: 40.3313,
    longitude: -111.57284,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84604',
  },
  {
    city: 'Provo',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 1190.3,
    imprecise: false,
    latitude: 40.2149,
    longitude: -111.62619,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 35690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84606',
  },
  {
    city: 'Aurora',
    county_fips: 49041,
    county_fips_all: '49041',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"49041": 100}',
    density: 23.9,
    imprecise: false,
    latitude: 38.92244,
    longitude: -111.92427,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84620',
  },
  {
    city: 'Axtell',
    county_fips: 49039,
    county_fips_all: '49039|49041',
    county: 'Sanpete',
    county_names_all: 'Sanpete|Sevier',
    county_weights: '{"49039": 99.7, "49041": 0.3}',
    density: 8.3,
    imprecise: false,
    latitude: 39.05109,
    longitude: -111.82959,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84621',
  },
  {
    city: 'Centerfield',
    county_fips: 49039,
    county_fips_all: '49039',
    county: 'Sanpete',
    county_names_all: 'Sanpete',
    county_weights: '{"49039": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 39.09816,
    longitude: -111.81353,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84622',
  },
  {
    city: 'Chester',
    county_fips: 49039,
    county_fips_all: '49039',
    county: 'Sanpete',
    county_names_all: 'Sanpete',
    county_weights: '{"49039": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 39.45608,
    longitude: -111.59063,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84623',
  },
  {
    city: 'Delta',
    county_fips: 49027,
    county_fips_all: '49027',
    county: 'Millard',
    county_names_all: 'Millard',
    county_weights: '{"49027": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 39.38429,
    longitude: -112.58756,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84624',
  },
  {
    city: 'Elberta',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 39.93359,
    longitude: -111.98545,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84626',
  },
  {
    city: 'Ephraim',
    county_fips: 49039,
    county_fips_all: '49039',
    county: 'Sanpete',
    county_names_all: 'Sanpete',
    county_weights: '{"49039": 100}',
    density: 55.4,
    imprecise: false,
    latitude: 39.35515,
    longitude: -111.58457,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84627',
  },
  {
    city: 'Eureka',
    county_fips: 49023,
    county_fips_all: '49023|49049',
    county: 'Juab',
    county_names_all: 'Juab|Utah',
    county_weights: '{"49023": 99.9, "49049": 0.1}',
    density: 32.4,
    imprecise: false,
    latitude: 39.93583,
    longitude: -112.13419,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84628',
  },
  {
    city: 'Fairview',
    county_fips: 49039,
    county_fips_all: '49039|49049',
    county: 'Sanpete',
    county_names_all: 'Sanpete|Utah',
    county_weights: '{"49039": 67.22, "49049": 32.78}',
    density: 4.7,
    imprecise: false,
    latitude: 39.76574,
    longitude: -111.44752,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84629',
  },
  {
    city: 'Fayette',
    county_fips: 49039,
    county_fips_all: '49039',
    county: 'Sanpete',
    county_names_all: 'Sanpete',
    county_weights: '{"49039": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 39.31069,
    longitude: -111.8342,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84630',
  },
  {
    city: 'Fillmore',
    county_fips: 49027,
    county_fips_all: '49027',
    county: 'Millard',
    county_names_all: 'Millard',
    county_weights: '{"49027": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 38.99771,
    longitude: -112.39675,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84631',
  },
  {
    city: 'Fountain Green',
    county_fips: 49039,
    county_fips_all: '49039',
    county: 'Sanpete',
    county_names_all: 'Sanpete',
    county_weights: '{"49039": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 39.64498,
    longitude: -111.64649,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84632',
  },
  {
    city: 'Goshen',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 13,
    imprecise: false,
    latitude: 39.94026,
    longitude: -111.89281,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84633',
  },
  {
    city: 'Gunnison',
    county_fips: 49039,
    county_fips_all: '49039',
    county: 'Sanpete',
    county_names_all: 'Sanpete',
    county_weights: '{"49039": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 39.18028,
    longitude: -111.83561,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84634',
  },
  {
    city: 'Hinckley',
    county_fips: 49027,
    county_fips_all: '49027',
    county: 'Millard',
    county_names_all: 'Millard',
    county_weights: '{"49027": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 39.39181,
    longitude: -112.72132,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84635',
  },
  {
    city: 'Holden',
    county_fips: 49027,
    county_fips_all: '49027',
    county: 'Millard',
    county_names_all: 'Millard',
    county_weights: '{"49027": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 39.13961,
    longitude: -112.3389,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84636',
  },
  {
    city: 'Kanosh',
    county_fips: 49027,
    county_fips_all: '49027',
    county: 'Millard',
    county_names_all: 'Millard',
    county_weights: '{"49027": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 38.72183,
    longitude: -112.48706,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84637',
  },
  {
    city: 'Leamington',
    county_fips: 49027,
    county_fips_all: '49027',
    county: 'Millard',
    county_names_all: 'Millard',
    county_weights: '{"49027": 100}',
    density: 3,
    imprecise: false,
    latitude: 39.50192,
    longitude: -112.25773,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84638',
  },
  {
    city: 'Levan',
    county_fips: 49023,
    county_fips_all: '49023',
    county: 'Juab',
    county_names_all: 'Juab',
    county_weights: '{"49023": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 39.51071,
    longitude: -111.90225,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84639',
  },
  {
    city: 'Lynndyl',
    county_fips: 49027,
    county_fips_all: '49027',
    county: 'Millard',
    county_names_all: 'Millard',
    county_weights: '{"49027": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 39.47622,
    longitude: -112.39942,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84640',
  },
  {
    city: 'Manti',
    county_fips: 49039,
    county_fips_all: '49039',
    county: 'Sanpete',
    county_names_all: 'Sanpete',
    county_weights: '{"49039": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 39.20135,
    longitude: -111.60893,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84642',
  },
  {
    city: 'Mayfield',
    county_fips: 49039,
    county_fips_all: '49039',
    county: 'Sanpete',
    county_names_all: 'Sanpete',
    county_weights: '{"49039": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 39.12873,
    longitude: -111.68485,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84643',
  },
  {
    city: 'Meadow',
    county_fips: 49027,
    county_fips_all: '49027',
    county: 'Millard',
    county_names_all: 'Millard',
    county_weights: '{"49027": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 38.87008,
    longitude: -112.37511,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84644',
  },
  {
    city: 'Mona',
    county_fips: 49023,
    county_fips_all: '49023',
    county: 'Juab',
    county_names_all: 'Juab',
    county_weights: '{"49023": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 39.85159,
    longitude: -111.83946,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84645',
  },
  {
    city: 'Moroni',
    county_fips: 49039,
    county_fips_all: '49039',
    county: 'Sanpete',
    county_names_all: 'Sanpete',
    county_weights: '{"49039": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 39.54565,
    longitude: -111.61121,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1882,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84646',
  },
  {
    city: 'Mount Pleasant',
    county_fips: 49039,
    county_fips_all: '49039',
    county: 'Sanpete',
    county_names_all: 'Sanpete',
    county_weights: '{"49039": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 39.52708,
    longitude: -111.40658,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84647',
  },
  {
    city: 'Nephi',
    county_fips: 49023,
    county_fips_all: '49023',
    county: 'Juab',
    county_names_all: 'Juab',
    county_weights: '{"49023": 100}',
    density: 17,
    imprecise: false,
    latitude: 39.68659,
    longitude: -111.86819,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84648',
  },
  {
    city: 'Oak City',
    county_fips: 49027,
    county_fips_all: '49027',
    county: 'Millard',
    county_names_all: 'Millard',
    county_weights: '{"49027": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 39.34661,
    longitude: -112.32992,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84649',
  },
  {
    city: 'Payson',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 89.9,
    imprecise: false,
    latitude: 39.95633,
    longitude: -111.69342,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 29503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84651',
  },
  {
    city: 'Redmond',
    county_fips: 49041,
    county_fips_all: '49041',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"49041": 100}',
    density: 21.8,
    imprecise: false,
    latitude: 39.01706,
    longitude: -111.8785,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84652',
  },
  {
    city: 'Salem',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 313.9,
    imprecise: false,
    latitude: 40.04803,
    longitude: -111.66804,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 13051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84653',
  },
  {
    city: 'Salina',
    county_fips: 49041,
    county_fips_all: '49041',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"49041": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 38.89144,
    longitude: -111.64442,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84654',
  },
  {
    city: 'Santaquin',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 152.5,
    imprecise: false,
    latitude: 39.97427,
    longitude: -111.80716,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84655',
  },
  {
    city: 'Scipio',
    county_fips: 49027,
    county_fips_all: '49027',
    county: 'Millard',
    county_names_all: 'Millard',
    county_weights: '{"49027": 100}',
    density: 47.4,
    imprecise: false,
    latitude: 39.23513,
    longitude: -112.1088,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84656',
  },
  {
    city: 'Sigurd',
    county_fips: 49041,
    county_fips_all: '49041',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"49041": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 38.81817,
    longitude: -111.94022,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84657',
  },
  {
    city: 'Spanish Fork',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 51.8,
    imprecise: false,
    latitude: 40.00724,
    longitude: -111.4268,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 48583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84660',
  },
  {
    city: 'Spring City',
    county_fips: 49039,
    county_fips_all: '49039',
    county: 'Sanpete',
    county_names_all: 'Sanpete',
    county_weights: '{"49039": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 39.43978,
    longitude: -111.48573,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84662',
  },
  {
    city: 'Springville',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 127.5,
    imprecise: false,
    latitude: 40.19266,
    longitude: -111.48917,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 36207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84663',
  },
  {
    city: 'Mapleton',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 503,
    imprecise: false,
    latitude: 40.12627,
    longitude: -111.57712,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 13032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84664',
  },
  {
    city: 'Sterling',
    county_fips: 49039,
    county_fips_all: '49039',
    county: 'Sanpete',
    county_names_all: 'Sanpete',
    county_weights: '{"49039": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 39.19527,
    longitude: -111.66109,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84665',
  },
  {
    city: 'Wales',
    county_fips: 49039,
    county_fips_all: '49039',
    county: 'Sanpete',
    county_names_all: 'Sanpete',
    county_weights: '{"49039": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 39.48926,
    longitude: -111.65115,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84667',
  },
  {
    city: 'Richfield',
    county_fips: 49041,
    county_fips_all: '49041',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"49041": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 38.69586,
    longitude: -111.90474,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84701',
  },
  {
    city: 'Alton',
    county_fips: 49025,
    county_fips_all: '49025',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"49025": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 37.46925,
    longitude: -112.51251,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84710',
  },
  {
    city: 'Annabella',
    county_fips: 49041,
    county_fips_all: '49041',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"49041": 100}',
    density: 61.5,
    imprecise: false,
    latitude: 38.71294,
    longitude: -112.0606,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84711',
  },
  {
    city: 'Antimony',
    county_fips: 49031,
    county_fips_all: '49031|49017',
    county: 'Piute',
    county_names_all: 'Piute|Garfield',
    county_weights: '{"49031": 62.3, "49017": 37.7}',
    density: 0.2,
    imprecise: false,
    latitude: 38.14076,
    longitude: -111.97783,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84712',
  },
  {
    city: 'Beaver',
    county_fips: 49001,
    county_fips_all: '49001',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"49001": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 38.3292,
    longitude: -112.54441,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84713',
  },
  {
    city: 'Beryl',
    county_fips: 49021,
    county_fips_all: '49021',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"49021": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 37.84815,
    longitude: -113.75547,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84714',
  },
  {
    city: 'Bicknell',
    county_fips: 49055,
    county_fips_all: '49055',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"49055": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 38.33221,
    longitude: -111.60317,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84715',
  },
  {
    city: 'Boulder',
    county_fips: 49017,
    county_fips_all: '49017',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"49017": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 37.97152,
    longitude: -111.4493,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84716',
  },
  {
    city: 'Cannonville',
    county_fips: 49017,
    county_fips_all: '49017',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"49017": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 37.57954,
    longitude: -112.08306,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84718',
  },
  {
    city: 'Brian Head',
    county_fips: 49021,
    county_fips_all: '49021|49017',
    county: 'Iron',
    county_names_all: 'Iron|Garfield',
    county_weights: '{"49021": 99.88, "49017": 0.12}',
    density: 0.4,
    imprecise: false,
    latitude: 37.65532,
    longitude: -112.76974,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84719',
  },
  {
    city: 'Cedar City',
    county_fips: 49021,
    county_fips_all: '49021|49053',
    county: 'Iron',
    county_names_all: 'Iron|Washington',
    county_weights: '{"49021": 69.02, "49053": 30.98}',
    density: 29.1,
    imprecise: false,
    latitude: 37.55477,
    longitude: -113.25665,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 25708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84720',
  },
  {
    city: 'Cedar City',
    county_fips: 49021,
    county_fips_all: '49021',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"49021": 100}',
    density: 63.3,
    imprecise: false,
    latitude: 37.77021,
    longitude: -113.13308,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 30641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84721',
  },
  {
    city: 'Central',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 37.48553,
    longitude: -113.57582,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84722',
  },
  {
    city: 'Circleville',
    county_fips: 49031,
    county_fips_all: '49031|49017',
    county: 'Piute',
    county_names_all: 'Piute|Garfield',
    county_weights: '{"49031": 99.69, "49017": 0.31}',
    density: 12.4,
    imprecise: false,
    latitude: 38.17611,
    longitude: -112.2519,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84723',
  },
  {
    city: 'Elsinore',
    county_fips: 49041,
    county_fips_all: '49041',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"49041": 100}',
    density: 113.9,
    imprecise: false,
    latitude: 38.67417,
    longitude: -112.15015,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84724',
  },
  {
    city: 'Enterprise',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 37.53928,
    longitude: -113.78042,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84725',
  },
  {
    city: 'Escalante',
    county_fips: 49017,
    county_fips_all: '49017',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"49017": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 37.7514,
    longitude: -111.57911,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84726',
  },
  {
    city: 'Garrison',
    county_fips: 49027,
    county_fips_all: '49027',
    county: 'Millard',
    county_names_all: 'Millard',
    county_weights: '{"49027": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 39.23887,
    longitude: -113.95719,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84728',
  },
  {
    city: 'Glendale',
    county_fips: 49025,
    county_fips_all: '49025',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"49025": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 37.35858,
    longitude: -112.61527,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84729',
  },
  {
    city: 'Glenwood',
    county_fips: 49041,
    county_fips_all: '49041',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"49041": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 38.74504,
    longitude: -112.00084,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84730',
  },
  {
    city: 'Greenville',
    county_fips: 49001,
    county_fips_all: '49001',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"49001": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 38.19714,
    longitude: -112.76195,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 75,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84731',
  },
  {
    city: 'Greenwich',
    county_fips: 49031,
    county_fips_all: '49031',
    county: 'Piute',
    county_names_all: 'Piute',
    county_weights: '{"49031": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 38.4453,
    longitude: -111.90408,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 21,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84732',
  },
  {
    city: 'Gunlock',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 37.29597,
    longitude: -113.79775,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84733',
  },
  {
    city: 'Hanksville',
    county_fips: 49055,
    county_fips_all: '49055',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"49055": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 38.36353,
    longitude: -110.5658,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84734',
  },
  {
    city: 'Hatch',
    county_fips: 49017,
    county_fips_all: '49017',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"49017": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 37.64627,
    longitude: -112.44997,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84735',
  },
  {
    city: 'Henrieville',
    county_fips: 49017,
    county_fips_all: '49017',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"49017": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 37.63732,
    longitude: -111.7938,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84736',
  },
  {
    city: 'Hurricane',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 37.6,
    imprecise: false,
    latitude: 37.08321,
    longitude: -113.26032,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 24359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84737',
  },
  {
    city: 'Ivins',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 81.8,
    imprecise: false,
    latitude: 37.20987,
    longitude: -113.70888,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84738',
  },
  {
    city: 'Joseph',
    county_fips: 49041,
    county_fips_all: '49041',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"49041": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 38.64204,
    longitude: -112.22299,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84739',
  },
  {
    city: 'Junction',
    county_fips: 49031,
    county_fips_all: '49031',
    county: 'Piute',
    county_names_all: 'Piute',
    county_weights: '{"49031": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 38.27504,
    longitude: -112.26689,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84740',
  },
  {
    city: 'Kanab',
    county_fips: 49025,
    county_fips_all: '49025',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"49025": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 37.19749,
    longitude: -112.25533,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84741',
  },
  {
    city: 'Kanarraville',
    county_fips: 49021,
    county_fips_all: '49021',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"49021": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 37.52102,
    longitude: -113.14592,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84742',
  },
  {
    city: 'Kingston',
    county_fips: 49031,
    county_fips_all: '49031',
    county: 'Piute',
    county_names_all: 'Piute',
    county_weights: '{"49031": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 38.20827,
    longitude: -112.18572,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84743',
  },
  {
    city: 'Koosharem',
    county_fips: 49041,
    county_fips_all: '49041|49031',
    county: 'Sevier',
    county_names_all: 'Sevier|Piute',
    county_weights: '{"49041": 95.98, "49031": 4.02}',
    density: 1.1,
    imprecise: false,
    latitude: 38.64207,
    longitude: -111.93627,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84744',
  },
  {
    city: 'La Verkin',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 345.6,
    imprecise: false,
    latitude: 37.20838,
    longitude: -113.26266,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84745',
  },
  {
    city: 'Leeds',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 37.23867,
    longitude: -113.35055,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84746',
  },
  {
    city: 'Loa',
    county_fips: 49055,
    county_fips_all: '49055',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"49055": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 38.44628,
    longitude: -111.63773,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84747',
  },
  {
    city: 'Lyman',
    county_fips: 49055,
    county_fips_all: '49055',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"49055": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 38.36687,
    longitude: -111.47667,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84749',
  },
  {
    city: 'Marysvale',
    county_fips: 49031,
    county_fips_all: '49031|49041',
    county: 'Piute',
    county_names_all: 'Piute|Sevier',
    county_weights: '{"49031": 99.39, "49041": 0.61}',
    density: 1.5,
    imprecise: false,
    latitude: 38.44205,
    longitude: -112.1947,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84750',
  },
  {
    city: 'Milford',
    county_fips: 49001,
    county_fips_all: '49001|49027',
    county: 'Beaver',
    county_names_all: 'Beaver|Millard',
    county_weights: '{"49001": 90.57, "49027": 9.43}',
    density: 2.4,
    imprecise: false,
    latitude: 38.44392,
    longitude: -113.0618,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84751',
  },
  {
    city: 'Minersville',
    county_fips: 49001,
    county_fips_all: '49001',
    county: 'Beaver',
    county_names_all: 'Beaver',
    county_weights: '{"49001": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 38.24975,
    longitude: -112.88434,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84752',
  },
  {
    city: 'Modena',
    county_fips: 49021,
    county_fips_all: '49021',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"49021": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.95019,
    longitude: -113.87967,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84753',
  },
  {
    city: 'Monroe',
    county_fips: 49041,
    county_fips_all: '49041',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"49041": 100}',
    density: 20.8,
    imprecise: false,
    latitude: 38.60521,
    longitude: -112.11747,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84754',
  },
  {
    city: 'Mount Carmel',
    county_fips: 49025,
    county_fips_all: '49025',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"49025": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 37.22652,
    longitude: -112.78532,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 78,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84755',
  },
  {
    city: 'Newcastle',
    county_fips: 49021,
    county_fips_all: '49021',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"49021": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 37.74249,
    longitude: -113.54772,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84756',
  },
  {
    city: 'New Harmony',
    county_fips: 49053,
    county_fips_all: '49053|49021',
    county: 'Washington',
    county_names_all: 'Washington|Iron',
    county_weights: '{"49053": 96.65, "49021": 3.35}',
    density: 10.7,
    imprecise: false,
    latitude: 37.45227,
    longitude: -113.25166,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84757',
  },
  {
    city: 'Orderville',
    county_fips: 49025,
    county_fips_all: '49025',
    county: 'Kane',
    county_names_all: 'Kane',
    county_weights: '{"49025": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 37.27041,
    longitude: -112.68529,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84758',
  },
  {
    city: 'Panguitch',
    county_fips: 49017,
    county_fips_all: '49017',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"49017": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 37.92238,
    longitude: -112.38423,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84759',
  },
  {
    city: 'Paragonah',
    county_fips: 49021,
    county_fips_all: '49021',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"49021": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 37.96299,
    longitude: -112.68551,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84760',
  },
  {
    city: 'Parowan',
    county_fips: 49021,
    county_fips_all: '49021',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"49021": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 37.84603,
    longitude: -112.87124,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84761',
  },
  {
    city: 'Duck Creek Village',
    county_fips: 49025,
    county_fips_all: '49025|49017',
    county: 'Kane',
    county_names_all: 'Kane|Garfield',
    county_weights: '{"49025": 90.71, "49017": 9.29}',
    density: 0.3,
    imprecise: false,
    latitude: 37.46882,
    longitude: -112.72644,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84762',
  },
  {
    city: 'Rockville',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 7,
    imprecise: false,
    latitude: 37.14667,
    longitude: -113.06947,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84763',
  },
  {
    city: 'Bryce',
    county_fips: 49017,
    county_fips_all: '49017',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"49017": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 37.72035,
    longitude: -112.06689,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84764',
  },
  {
    city: 'Santa Clara',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 65.5,
    imprecise: false,
    latitude: 37.31012,
    longitude: -113.92535,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84765',
  },
  {
    city: 'Sevier',
    county_fips: 49041,
    county_fips_all: '49041',
    county: 'Sevier',
    county_names_all: 'Sevier',
    county_weights: '{"49041": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 38.59762,
    longitude: -112.33567,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84766',
  },
  {
    city: 'Springdale',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 37.20152,
    longitude: -112.9858,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84767',
  },
  {
    city: 'Saint George',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 259.3,
    imprecise: false,
    latitude: 37.13818,
    longitude: -113.6294,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 48397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84770',
  },
  {
    city: 'Summit',
    county_fips: 49021,
    county_fips_all: '49021',
    county: 'Iron',
    county_names_all: 'Iron',
    county_weights: '{"49021": 100}',
    density: 27.4,
    imprecise: false,
    latitude: 37.79706,
    longitude: -112.94168,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84772',
  },
  {
    city: 'Teasdale',
    county_fips: 49055,
    county_fips_all: '49055',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"49055": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 38.24958,
    longitude: -111.47045,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84773',
  },
  {
    city: 'Toquerville',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 35.7,
    imprecise: false,
    latitude: 37.24324,
    longitude: -113.28089,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84774',
  },
  {
    city: 'Torrey',
    county_fips: 49055,
    county_fips_all: '49055|49017',
    county: 'Wayne',
    county_names_all: 'Wayne|Garfield',
    county_weights: '{"49055": 92.36, "49017": 7.64}',
    density: 0.4,
    imprecise: false,
    latitude: 38.28881,
    longitude: -111.04073,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84775',
  },
  {
    city: 'Tropic',
    county_fips: 49017,
    county_fips_all: '49017',
    county: 'Garfield',
    county_names_all: 'Garfield',
    county_weights: '{"49017": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 37.62956,
    longitude: -112.08217,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84776',
  },
  {
    city: 'Virgin',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 37.33381,
    longitude: -113.11869,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84779',
  },
  {
    city: 'Washington',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 202.3,
    imprecise: false,
    latitude: 37.12798,
    longitude: -113.48108,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84780',
  },
  {
    city: 'Pine Valley',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 37.41197,
    longitude: -113.47217,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84781',
  },
  {
    city: 'Veyo',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 37.35939,
    longitude: -113.67522,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84782',
  },
  {
    city: 'Dammeron Valley',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 37.28556,
    longitude: -113.65639,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84783',
  },
  {
    city: 'Hildale',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 125.2,
    imprecise: false,
    latitude: 37.01858,
    longitude: -112.96941,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84784',
  },
  {
    city: 'Saint George',
    county_fips: 49053,
    county_fips_all: '49053',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"49053": 100}',
    density: 446.4,
    imprecise: false,
    latitude: 37.04615,
    longitude: -113.55738,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 55892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84790',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2257.4,
    imprecise: false,
    latitude: 33.45059,
    longitude: -112.07833,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 10875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85003',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2334.1,
    imprecise: false,
    latitude: 33.45159,
    longitude: -112.06988,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 12408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85004',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2132.2,
    imprecise: false,
    latitude: 33.46511,
    longitude: -112.04778,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 21905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85006',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1138.5,
    imprecise: false,
    latitude: 33.44682,
    longitude: -112.09073,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 13575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85007',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2253.6,
    imprecise: false,
    latitude: 33.46355,
    longitude: -111.98746,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 59716,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85008',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1372,
    imprecise: false,
    latitude: 33.44457,
    longitude: -112.12661,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 52064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85009',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1490.8,
    imprecise: false,
    latitude: 33.50719,
    longitude: -112.07024,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 8704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85012',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2356.5,
    imprecise: false,
    latitude: 33.51001,
    longitude: -112.08294,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 22490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85013',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2476.5,
    imprecise: false,
    latitude: 33.50903,
    longitude: -112.05665,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 25911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85014',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 3265.6,
    imprecise: false,
    latitude: 33.50908,
    longitude: -112.10184,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 41490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85015',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1746.5,
    imprecise: false,
    latitude: 33.50953,
    longitude: -112.03041,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 37074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85016',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 3384.3,
    imprecise: false,
    latitude: 33.50898,
    longitude: -112.12381,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 46129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85017',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 954.7,
    imprecise: false,
    latitude: 33.5194,
    longitude: -111.99309,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 37297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85018',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2838.4,
    imprecise: false,
    latitude: 33.50952,
    longitude: -112.14307,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 27429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85019',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1535,
    imprecise: false,
    latitude: 33.56766,
    longitude: -112.05485,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 34916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85020',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2215.2,
    imprecise: false,
    latitude: 33.56046,
    longitude: -112.09442,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 39828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85021',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2210.1,
    imprecise: false,
    latitude: 33.62685,
    longitude: -112.05113,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 53811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85022',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1824.7,
    imprecise: false,
    latitude: 33.63156,
    longitude: -112.09452,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 35034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85023',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 863,
    imprecise: false,
    latitude: 33.69042,
    longitude: -112.04632,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 26199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85024',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1301.3,
    imprecise: false,
    latitude: 33.6771,
    longitude: -112.10206,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 39487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85027',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1056.8,
    imprecise: false,
    latitude: 33.5816,
    longitude: -112.00811,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 18752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85028',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2050.2,
    imprecise: false,
    latitude: 33.59546,
    longitude: -112.11002,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 49683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85029',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2965.1,
    imprecise: false,
    latitude: 33.49491,
    longitude: -112.16835,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 31191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85031',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2212.4,
    imprecise: false,
    latitude: 33.62624,
    longitude: -112.00368,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 70839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85032',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 3634.6,
    imprecise: false,
    latitude: 33.49443,
    longitude: -112.21193,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 57591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85033',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 162,
    imprecise: false,
    latitude: 33.43465,
    longitude: -112.01989,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85034',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 3685.9,
    imprecise: false,
    latitude: 33.47167,
    longitude: -112.19538,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 53424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85035',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2578.3,
    imprecise: false,
    latitude: 33.49038,
    longitude: -112.26487,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 54608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85037',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1303,
    imprecise: false,
    latitude: 33.40585,
    longitude: -112.02658,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 34117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85040',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1542.1,
    imprecise: false,
    latitude: 33.38643,
    longitude: -112.10928,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 63862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85041',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 911.6,
    imprecise: false,
    latitude: 33.35911,
    longitude: -112.04949,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 45903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85042',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 785.8,
    imprecise: false,
    latitude: 33.4323,
    longitude: -112.19744,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 41331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85043',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 920.9,
    imprecise: false,
    latitude: 33.33997,
    longitude: -112.00617,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 39347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85044',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 738.8,
    imprecise: false,
    latitude: 33.29976,
    longitude: -112.1062,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 7600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85045',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1322.5,
    imprecise: false,
    latitude: 33.30362,
    longitude: -112.03192,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 34664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85048',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 858.5,
    imprecise: false,
    latitude: 33.68739,
    longitude: -111.99854,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 33118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85050',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2780.3,
    imprecise: false,
    latitude: 33.55914,
    longitude: -112.13324,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 45768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85051',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2224.9,
    imprecise: false,
    latitude: 33.6296,
    longitude: -112.13184,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 29773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85053',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 466.5,
    imprecise: false,
    latitude: 33.67515,
    longitude: -111.94763,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 10346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85054',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 407.3,
    imprecise: false,
    latitude: 33.74032,
    longitude: -112.16308,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 21022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85083',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 318.6,
    imprecise: false,
    latitude: 33.75637,
    longitude: -112.07426,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 31458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85085',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 272.4,
    imprecise: false,
    latitude: 33.82639,
    longitude: -112.12876,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 43270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85086',
  },
  {
    city: 'New River',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 45,
    imprecise: false,
    latitude: 33.92635,
    longitude: -112.14908,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 10157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85087',
  },
  {
    city: 'Gold Canyon',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 38.8,
    imprecise: false,
    latitude: 33.3737,
    longitude: -111.36545,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 14932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85118',
  },
  {
    city: 'Apache Junction',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 214.5,
    imprecise: false,
    latitude: 33.38682,
    longitude: -111.50824,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 25420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85119',
  },
  {
    city: 'Apache Junction',
    county_fips: 4021,
    county_fips_all: '04021|04013',
    county: 'Pinal',
    county_names_all: 'Pinal|Maricopa',
    county_weights: '{"04021": 93.89, "04013": 6.11}',
    density: 521.6,
    imprecise: false,
    latitude: 33.38706,
    longitude: -111.56311,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 31191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85120',
  },
  {
    city: 'Bapchule',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 33.13751,
    longitude: -111.91316,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85121',
  },
  {
    city: 'Casa Grande',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 421.9,
    imprecise: false,
    latitude: 32.91672,
    longitude: -111.74798,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 61624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85122',
  },
  {
    city: 'Arizona City',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 114.7,
    imprecise: false,
    latitude: 32.70917,
    longitude: -111.6802,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 10003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85123',
  },
  {
    city: 'Coolidge',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 45.1,
    imprecise: false,
    latitude: 32.96468,
    longitude: -111.51028,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 19487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85128',
  },
  {
    city: 'Eloy',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 32.65542,
    longitude: -111.57649,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 18794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85131',
  },
  {
    city: 'Florence',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 24.8,
    imprecise: false,
    latitude: 32.92358,
    longitude: -111.19119,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 38671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85132',
  },
  {
    city: 'Hayden',
    county_fips: 4007,
    county_fips_all: '04007',
    county: 'Gila',
    county_names_all: 'Gila',
    county_weights: '{"04007": 100}',
    density: 88.2,
    imprecise: false,
    latitude: 32.9987,
    longitude: -110.78242,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85135',
  },
  {
    city: 'Kearny',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 4,
    imprecise: false,
    latitude: 33.11275,
    longitude: -110.98353,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85137',
  },
  {
    city: 'Maricopa',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 251.8,
    imprecise: false,
    latitude: 33.0151,
    longitude: -111.98681,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 55260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85138',
  },
  {
    city: 'Maricopa',
    county_fips: 4021,
    county_fips_all: '04021|04013',
    county: 'Pinal',
    county_names_all: 'Pinal|Maricopa',
    county_weights: '{"04021": 52.77, "04013": 47.23}',
    density: 16,
    imprecise: false,
    latitude: 32.92096,
    longitude: -112.21117,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 20784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85139',
  },
  {
    city: 'San Tan Valley',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 240.2,
    imprecise: false,
    latitude: 33.24805,
    longitude: -111.48921,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 51260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85140',
  },
  {
    city: 'Picacho',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 32.64707,
    longitude: -111.42792,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85141',
  },
  {
    city: 'Queen Creek',
    county_fips: 4021,
    county_fips_all: '04021|04013',
    county: 'Pinal',
    county_names_all: 'Pinal|Maricopa',
    county_weights: '{"04021": 67.52, "04013": 32.48}',
    density: 357,
    imprecise: false,
    latitude: 33.19302,
    longitude: -111.66645,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 93700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85142',
  },
  {
    city: 'San Tan Valley',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 548.7,
    imprecise: false,
    latitude: 33.15602,
    longitude: -111.51974,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 44444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85143',
  },
  {
    city: 'Red Rock',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 32.9,
    imprecise: false,
    latitude: 32.54322,
    longitude: -111.39415,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 3277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85145',
  },
  {
    city: 'Sacaton',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 26.8,
    imprecise: false,
    latitude: 33.09454,
    longitude: -111.7209,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85147',
  },
  {
    city: 'Stanfield',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 32.89974,
    longitude: -111.95205,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85172',
  },
  {
    city: 'Superior',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 21,
    imprecise: false,
    latitude: 33.26827,
    longitude: -111.13651,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85173',
  },
  {
    city: 'Valley Farms',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 32.98498,
    longitude: -111.44686,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85191',
  },
  {
    city: 'Winkelman',
    county_fips: 4021,
    county_fips_all: '04021|04007',
    county: 'Pinal',
    county_names_all: 'Pinal|Gila',
    county_weights: '{"04021": 67.65, "04007": 32.35}',
    density: 2.2,
    imprecise: false,
    latitude: 32.96134,
    longitude: -110.66501,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85192',
  },
  {
    city: 'Casa Grande',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 32.79822,
    longitude: -111.82809,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85193',
  },
  {
    city: 'Casa Grande',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 38.6,
    imprecise: false,
    latitude: 32.89675,
    longitude: -111.62439,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 8077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85194',
  },
  {
    city: 'Mesa',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2116.4,
    imprecise: false,
    latitude: 33.4336,
    longitude: -111.84929,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 51400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85201',
  },
  {
    city: 'Mesa',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2399.3,
    imprecise: false,
    latitude: 33.38252,
    longitude: -111.87482,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 38750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85202',
  },
  {
    city: 'Mesa',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1586.1,
    imprecise: false,
    latitude: 33.44997,
    longitude: -111.80403,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 38035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85203',
  },
  {
    city: 'Mesa',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2538.9,
    imprecise: false,
    latitude: 33.39666,
    longitude: -111.78786,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 65155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85204',
  },
  {
    city: 'Mesa',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1719.8,
    imprecise: false,
    latitude: 33.43227,
    longitude: -111.71804,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 45116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85205',
  },
  {
    city: 'Mesa',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1531.5,
    imprecise: false,
    latitude: 33.39685,
    longitude: -111.71758,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 37235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85206',
  },
  {
    city: 'Mesa',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 672.5,
    imprecise: false,
    latitude: 33.45362,
    longitude: -111.63631,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 51178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85207',
  },
  {
    city: 'Mesa',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1765.3,
    imprecise: false,
    latitude: 33.40301,
    longitude: -111.63194,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 37225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85208',
  },
  {
    city: 'Mesa',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1413.3,
    imprecise: false,
    latitude: 33.37877,
    longitude: -111.63476,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 43150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85209',
  },
  {
    city: 'Mesa',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2254.4,
    imprecise: false,
    latitude: 33.38955,
    longitude: -111.84337,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 39015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85210',
  },
  {
    city: 'Mesa',
    county_fips: 4013,
    county_fips_all: '04013|04021',
    county: 'Maricopa',
    county_names_all: 'Maricopa|Pinal',
    county_weights: '{"04013": 92.39, "04021": 7.61}',
    density: 553.3,
    imprecise: false,
    latitude: 33.32064,
    longitude: -111.63088,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 55283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85212',
  },
  {
    city: 'Mesa',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1542.8,
    imprecise: false,
    latitude: 33.44764,
    longitude: -111.76962,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 36836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85213',
  },
  {
    city: 'Mesa',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 78.7,
    imprecise: false,
    latitude: 33.51101,
    longitude: -111.58027,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 16888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85215',
  },
  {
    city: 'Chandler',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1964.6,
    imprecise: false,
    latitude: 33.32351,
    longitude: -111.87616,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 47963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85224',
  },
  {
    city: 'Chandler',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2199.3,
    imprecise: false,
    latitude: 33.31748,
    longitude: -111.83167,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 72297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85225',
  },
  {
    city: 'Chandler',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 424.8,
    imprecise: false,
    latitude: 33.26519,
    longitude: -111.94641,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 42294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85226',
  },
  {
    city: 'Gilbert',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1563.8,
    imprecise: false,
    latitude: 33.35242,
    longitude: -111.8115,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 39077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85233',
  },
  {
    city: 'Gilbert',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1657.8,
    imprecise: false,
    latitude: 33.36479,
    longitude: -111.73924,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 51283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85234',
  },
  {
    city: 'Higley',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.32301,
    longitude: -111.71951,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85236',
  },
  {
    city: 'Chandler',
    county_fips: 4013,
    county_fips_all: '04013|04021',
    county: 'Maricopa',
    county_names_all: 'Maricopa|Pinal',
    county_weights: '{"04013": 63.39, "04021": 36.61}',
    density: 468.8,
    imprecise: false,
    latitude: 33.2145,
    longitude: -111.86667,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 37095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85248',
  },
  {
    city: 'Chandler',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1311.8,
    imprecise: false,
    latitude: 33.22652,
    longitude: -111.79918,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 48746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85249',
  },
  {
    city: 'Scottsdale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 706.9,
    imprecise: false,
    latitude: 33.52986,
    longitude: -111.88991,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 15394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85250',
  },
  {
    city: 'Scottsdale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2179.6,
    imprecise: false,
    latitude: 33.49406,
    longitude: -111.92025,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 40780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85251',
  },
  {
    city: 'Paradise Valley',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 381.8,
    imprecise: false,
    latitude: 33.54479,
    longitude: -111.95873,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 17904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85253',
  },
  {
    city: 'Scottsdale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1282.2,
    imprecise: false,
    latitude: 33.61474,
    longitude: -111.95176,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 45558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85254',
  },
  {
    city: 'Scottsdale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 198.5,
    imprecise: false,
    latitude: 33.6824,
    longitude: -111.8177,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 45346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85255',
  },
  {
    city: 'Scottsdale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 33.50053,
    longitude: -111.83524,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 3504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85256',
  },
  {
    city: 'Scottsdale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1676.6,
    imprecise: false,
    latitude: 33.46354,
    longitude: -111.91486,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 29812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85257',
  },
  {
    city: 'Scottsdale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 956.9,
    imprecise: false,
    latitude: 33.56337,
    longitude: -111.89268,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 25545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85258',
  },
  {
    city: 'Scottsdale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 403.6,
    imprecise: false,
    latitude: 33.60105,
    longitude: -111.80952,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 21670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85259',
  },
  {
    city: 'Scottsdale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1081.6,
    imprecise: false,
    latitude: 33.60943,
    longitude: -111.89113,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 39896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85260',
  },
  {
    city: 'Scottsdale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 35.6,
    imprecise: false,
    latitude: 33.85834,
    longitude: -111.80169,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 14329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85262',
  },
  {
    city: 'Rio Verde',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 33.90026,
    longitude: -111.62412,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 3472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85263',
  },
  {
    city: 'Fort Mcdowell',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 33.69996,
    longitude: -111.50123,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85264',
  },
  {
    city: 'Scottsdale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 246.3,
    imprecise: false,
    latitude: 33.76034,
    longitude: -111.92503,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 12516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85266',
  },
  {
    city: 'Fountain Hills',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 449.6,
    imprecise: false,
    latitude: 33.60717,
    longitude: -111.73999,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 23849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85268',
  },
  {
    city: 'Tempe',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2114.9,
    imprecise: false,
    latitude: 33.42805,
    longitude: -111.93157,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 72762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85281',
  },
  {
    city: 'Tempe',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1865.8,
    imprecise: false,
    latitude: 33.3943,
    longitude: -111.93242,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 53624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85282',
  },
  {
    city: 'Tempe',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2075.3,
    imprecise: false,
    latitude: 33.36461,
    longitude: -111.93196,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 47459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85283',
  },
  {
    city: 'Tempe',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 962.1,
    imprecise: false,
    latitude: 33.33719,
    longitude: -111.93443,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 19492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85284',
  },
  {
    city: 'Chandler',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1228.5,
    imprecise: false,
    latitude: 33.27146,
    longitude: -111.83156,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 50621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85286',
  },
  {
    city: 'Gilbert',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1816.8,
    imprecise: false,
    latitude: 33.30639,
    longitude: -111.73804,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 56744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85295',
  },
  {
    city: 'Gilbert',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1756.2,
    imprecise: false,
    latitude: 33.33554,
    longitude: -111.74006,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 53076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85296',
  },
  {
    city: 'Gilbert',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1348.7,
    imprecise: false,
    latitude: 33.27843,
    longitude: -111.73638,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 37475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85297',
  },
  {
    city: 'Gilbert',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1086.9,
    imprecise: false,
    latitude: 33.23983,
    longitude: -111.72819,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 44114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85298',
  },
  {
    city: 'Glendale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2826.8,
    imprecise: false,
    latitude: 33.53219,
    longitude: -112.17817,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 68178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85301',
  },
  {
    city: 'Glendale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2608.8,
    imprecise: false,
    latitude: 33.56777,
    longitude: -112.17819,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 40612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85302',
  },
  {
    city: 'Glendale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1923.6,
    imprecise: false,
    latitude: 33.53398,
    longitude: -112.22084,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 33663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85303',
  },
  {
    city: 'Glendale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2110.2,
    imprecise: false,
    latitude: 33.59566,
    longitude: -112.17815,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 29861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85304',
  },
  {
    city: 'Glendale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1136.4,
    imprecise: false,
    latitude: 33.52996,
    longitude: -112.25563,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 18043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85305',
  },
  {
    city: 'Glendale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1642.4,
    imprecise: false,
    latitude: 33.62333,
    longitude: -112.17569,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 24911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85306',
  },
  {
    city: 'Glendale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 528,
    imprecise: false,
    latitude: 33.53396,
    longitude: -112.30867,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 14223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85307',
  },
  {
    city: 'Glendale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1487.1,
    imprecise: false,
    latitude: 33.66029,
    longitude: -112.18486,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 65095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85308',
  },
  {
    city: 'Glendale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 839.8,
    imprecise: false,
    latitude: 33.69532,
    longitude: -112.17162,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 19964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85310',
  },
  {
    city: 'Aguila',
    county_fips: 4013,
    county_fips_all: '04013|04012',
    county: 'Maricopa',
    county_names_all: 'Maricopa|La Paz',
    county_weights: '{"04013": 99.84, "04012": 0.16}',
    density: 0.7,
    imprecise: false,
    latitude: 33.83563,
    longitude: -113.23214,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85320',
  },
  {
    city: 'Ajo',
    county_fips: 4019,
    county_fips_all: '04019|04013',
    county: 'Pima',
    county_names_all: 'Pima|Maricopa',
    county_weights: '{"04019": 88.95, "04013": 11.05}',
    density: 1,
    imprecise: false,
    latitude: 32.30062,
    longitude: -112.63169,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 3555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85321',
  },
  {
    city: 'Arlington',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 33.1766,
    longitude: -112.85207,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85322',
  },
  {
    city: 'Avondale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1023.9,
    imprecise: false,
    latitude: 33.41888,
    longitude: -112.32615,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 47043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85323',
  },
  {
    city: 'Black Canyon City',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 34.10456,
    longitude: -112.07094,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85324',
  },
  {
    city: 'Bouse',
    county_fips: 4012,
    county_fips_all: '04012',
    county: 'La Paz',
    county_names_all: 'La Paz',
    county_weights: '{"04012": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 33.98328,
    longitude: -113.84323,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85325',
  },
  {
    city: 'Buckeye',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 60.2,
    imprecise: false,
    latitude: 33.23735,
    longitude: -112.58538,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 75359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85326',
  },
  {
    city: 'Cibola',
    county_fips: 4012,
    county_fips_all: '04012',
    county: 'La Paz',
    county_names_all: 'La Paz',
    county_weights: '{"04012": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 33.22795,
    longitude: -114.63413,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85328',
  },
  {
    city: 'Cashion',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2702.3,
    imprecise: false,
    latitude: 33.43171,
    longitude: -112.2965,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85329',
  },
  {
    city: 'Cave Creek',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 94.1,
    imprecise: false,
    latitude: 33.88685,
    longitude: -111.94276,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 31968,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85331',
  },
  {
    city: 'Congress',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 34.19209,
    longitude: -112.89444,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85332',
  },
  {
    city: 'Dateland',
    county_fips: 4013,
    county_fips_all: '04013|04027',
    county: 'Maricopa',
    county_names_all: 'Maricopa|Yuma',
    county_weights: '{"04013": 55.51, "04027": 44.49}',
    density: 0.3,
    imprecise: false,
    latitude: 32.97896,
    longitude: -113.30714,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85333',
  },
  {
    city: 'Ehrenberg',
    county_fips: 4012,
    county_fips_all: '04012',
    county: 'La Paz',
    county_names_all: 'La Paz',
    county_weights: '{"04012": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 33.60535,
    longitude: -114.4075,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85334',
  },
  {
    city: 'El Mirage',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1163.9,
    imprecise: false,
    latitude: 33.58721,
    longitude: -112.32836,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 36088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85335',
  },
  {
    city: 'San Luis',
    county_fips: 4027,
    county_fips_all: '04027',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"04027": 100}',
    density: 257.1,
    imprecise: false,
    latitude: 32.51904,
    longitude: -114.77977,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 6514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85336',
  },
  {
    city: 'Gila Bend',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 32.97553,
    longitude: -112.866,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85337',
  },
  {
    city: 'Goodyear',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 342.6,
    imprecise: false,
    latitude: 33.37252,
    longitude: -112.40826,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 67451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85338',
  },
  {
    city: 'Laveen',
    county_fips: 4013,
    county_fips_all: '04013|04021',
    county: 'Maricopa',
    county_names_all: 'Maricopa|Pinal',
    county_weights: '{"04013": 56.1, "04021": 43.9}',
    density: 81.7,
    imprecise: false,
    latitude: 33.23985,
    longitude: -112.14322,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 54641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85339',
  },
  {
    city: 'Litchfield Park',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 504.9,
    imprecise: false,
    latitude: 33.5179,
    longitude: -112.42361,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 40919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85340',
  },
  {
    city: 'Lukeville',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 31.9726,
    longitude: -112.71943,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85341',
  },
  {
    city: 'Morristown',
    county_fips: 4025,
    county_fips_all: '04025|04013',
    county: 'Yavapai',
    county_names_all: 'Yavapai|Maricopa',
    county_weights: '{"04025": 56.23, "04013": 43.77}',
    density: 1.9,
    imprecise: false,
    latitude: 33.95308,
    longitude: -112.48358,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85342',
  },
  {
    city: 'Palo Verde',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 33.33774,
    longitude: -112.69087,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85343',
  },
  {
    city: 'Parker',
    county_fips: 4012,
    county_fips_all: '04012',
    county: 'La Paz',
    county_names_all: 'La Paz',
    county_weights: '{"04012": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 33.98527,
    longitude: -114.23267,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 9433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85344',
  },
  {
    city: 'Peoria',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1853.6,
    imprecise: false,
    latitude: 33.57215,
    longitude: -112.24838,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 60918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85345',
  },
  {
    city: 'Quartzsite',
    county_fips: 4012,
    county_fips_all: '04012',
    county: 'La Paz',
    county_names_all: 'La Paz',
    county_weights: '{"04012": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 33.60992,
    longitude: -114.15835,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85346',
  },
  {
    city: 'Roll',
    county_fips: 4027,
    county_fips_all: '04027',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"04027": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 32.78612,
    longitude: -113.80633,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85347',
  },
  {
    city: 'Salome',
    county_fips: 4012,
    county_fips_all: '04012',
    county: 'La Paz',
    county_names_all: 'La Paz',
    county_weights: '{"04012": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 33.69914,
    longitude: -113.66372,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85348',
  },
  {
    city: 'San Luis',
    county_fips: 4027,
    county_fips_all: '04027',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"04027": 100}',
    density: 535.7,
    imprecise: false,
    latitude: 32.47983,
    longitude: -114.69647,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 31316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85349',
  },
  {
    city: 'Somerton',
    county_fips: 4027,
    county_fips_all: '04027',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"04027": 100}',
    density: 90.2,
    imprecise: false,
    latitude: 32.56651,
    longitude: -114.70896,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 19011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85350',
  },
  {
    city: 'Sun City',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 979.2,
    imprecise: false,
    latitude: 33.60638,
    longitude: -112.28213,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 27592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85351',
  },
  {
    city: 'Tacna',
    county_fips: 4027,
    county_fips_all: '04027',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"04027": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 32.69118,
    longitude: -113.8963,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85352',
  },
  {
    city: 'Tolleson',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 884.2,
    imprecise: false,
    latitude: 33.41721,
    longitude: -112.27283,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 49120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85353',
  },
  {
    city: 'Tonopah',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 33.40735,
    longitude: -113.06637,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 8531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85354',
  },
  {
    city: 'Waddell',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 161.3,
    imprecise: false,
    latitude: 33.57519,
    longitude: -112.45374,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 14460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85355',
  },
  {
    city: 'Wellton',
    county_fips: 4027,
    county_fips_all: '04027',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"04027": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 32.68933,
    longitude: -114.1852,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 3840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85356',
  },
  {
    city: 'Wenden',
    county_fips: 4012,
    county_fips_all: '04012',
    county: 'La Paz',
    county_names_all: 'La Paz',
    county_weights: '{"04012": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 34.02498,
    longitude: -113.49055,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85357',
  },
  {
    city: 'Wikieup',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.54833,
    longitude: -113.57275,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85360',
  },
  {
    city: 'Wittmann',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 33.76617,
    longitude: -112.63093,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 7991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85361',
  },
  {
    city: 'Yarnell',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 34.28558,
    longitude: -112.84337,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85362',
  },
  {
    city: 'Youngtown',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1773.3,
    imprecise: false,
    latitude: 33.58458,
    longitude: -112.30489,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 7015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85363',
  },
  {
    city: 'Yuma',
    county_fips: 4027,
    county_fips_all: '04027',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"04027": 100}',
    density: 733.9,
    imprecise: false,
    latitude: 32.70469,
    longitude: -114.65664,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 72960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85364',
  },
  {
    city: 'Yuma',
    county_fips: 4027,
    county_fips_all: '04027',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"04027": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 33.07067,
    longitude: -114.13801,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 54775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85365',
  },
  {
    city: 'Yuma',
    county_fips: 4027,
    county_fips_all: '04027',
    county: 'Yuma',
    county_names_all: 'Yuma',
    county_weights: '{"04027": 100}',
    density: 226.7,
    imprecise: false,
    latitude: 32.66082,
    longitude: -114.39361,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 22074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85367',
  },
  {
    city: 'Poston',
    county_fips: 4012,
    county_fips_all: '04012',
    county: 'La Paz',
    county_names_all: 'La Paz',
    county_weights: '{"04012": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 33.96732,
    longitude: -114.39005,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85371',
  },
  {
    city: 'Sun City',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 694.5,
    imprecise: false,
    latitude: 33.67257,
    longitude: -112.29983,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 20254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85373',
  },
  {
    city: 'Surprise',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1250.9,
    imprecise: false,
    latitude: 33.64449,
    longitude: -112.395,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 41420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85374',
  },
  {
    city: 'Sun City West',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 862.5,
    imprecise: false,
    latitude: 33.6716,
    longitude: -112.3565,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 27680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85375',
  },
  {
    city: 'Carefree',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 154.4,
    imprecise: false,
    latitude: 33.82376,
    longitude: -111.91515,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 3437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85377',
  },
  {
    city: 'Surprise',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1047.2,
    imprecise: false,
    latitude: 33.64162,
    longitude: -112.32012,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 9765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85378',
  },
  {
    city: 'Surprise',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1834.4,
    imprecise: false,
    latitude: 33.60207,
    longitude: -112.3736,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 51035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85379',
  },
  {
    city: 'Peoria',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1600.3,
    imprecise: false,
    latitude: 33.60957,
    longitude: -112.23175,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 27650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85381',
  },
  {
    city: 'Peoria',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1702.3,
    imprecise: false,
    latitude: 33.65548,
    longitude: -112.24771,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 43729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85382',
  },
  {
    city: 'Peoria',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 183.2,
    imprecise: false,
    latitude: 33.80297,
    longitude: -112.31734,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 74390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85383',
  },
  {
    city: 'Surprise',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 144.4,
    imprecise: false,
    latitude: 33.71025,
    longitude: -112.44869,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 22442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85387',
  },
  {
    city: 'Surprise',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1063.1,
    imprecise: false,
    latitude: 33.60743,
    longitude: -112.43413,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 35369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85388',
  },
  {
    city: 'Wickenburg',
    county_fips: 4013,
    county_fips_all: '04013|04025',
    county: 'Maricopa',
    county_names_all: 'Maricopa|Yavapai',
    county_weights: '{"04013": 76.23, "04025": 23.77}',
    density: 8.4,
    imprecise: false,
    latitude: 33.92391,
    longitude: -112.86739,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 10298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85390',
  },
  {
    city: 'Avondale',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 1553.4,
    imprecise: false,
    latitude: 33.47713,
    longitude: -112.30981,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 39079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85392',
  },
  {
    city: 'Goodyear',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 839.5,
    imprecise: false,
    latitude: 33.48208,
    longitude: -112.40518,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 40414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85395',
  },
  {
    city: 'Buckeye',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 163.5,
    imprecise: false,
    latitude: 33.5376,
    longitude: -112.64635,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 42181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85396',
  },
  {
    city: 'Globe',
    county_fips: 4007,
    county_fips_all: '04007',
    county: 'Gila',
    county_names_all: 'Gila',
    county_weights: '{"04007": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 33.54569,
    longitude: -110.74788,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 12395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85501',
  },
  {
    city: 'Bylas',
    county_fips: 4009,
    county_fips_all: '04009',
    county: 'Graham',
    county_names_all: 'Graham',
    county_weights: '{"04009": 100}',
    density: 2,
    imprecise: false,
    latitude: 33.09361,
    longitude: -110.23109,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85530',
  },
  {
    city: 'Central',
    county_fips: 4009,
    county_fips_all: '04009',
    county: 'Graham',
    county_names_all: 'Graham',
    county_weights: '{"04009": 100}',
    density: 56.7,
    imprecise: false,
    latitude: 32.87392,
    longitude: -109.7849,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85531',
  },
  {
    city: 'Claypool',
    county_fips: 4007,
    county_fips_all: '04007',
    county: 'Gila',
    county_names_all: 'Gila',
    county_weights: '{"04007": 100}',
    density: 572.4,
    imprecise: false,
    latitude: 33.40779,
    longitude: -110.8454,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85532',
  },
  {
    city: 'Clifton',
    county_fips: 4011,
    county_fips_all: '04011|04009',
    county: 'Greenlee',
    county_names_all: 'Greenlee|Graham',
    county_weights: '{"04011": 69.87, "04009": 30.13}',
    density: 1.1,
    imprecise: false,
    latitude: 33.29208,
    longitude: -109.40219,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85533',
  },
  {
    city: 'Duncan',
    county_fips: 4011,
    county_fips_all: '04011',
    county: 'Greenlee',
    county_names_all: 'Greenlee',
    county_weights: '{"04011": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 32.72939,
    longitude: -109.14475,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85534',
  },
  {
    city: 'Fort Thomas',
    county_fips: 4009,
    county_fips_all: '04009',
    county: 'Graham',
    county_names_all: 'Graham',
    county_weights: '{"04009": 100}',
    density: 1,
    imprecise: false,
    latitude: 33.14063,
    longitude: -110.00331,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85536',
  },
  {
    city: 'Miami',
    county_fips: 4007,
    county_fips_all: '04007|04021',
    county: 'Gila',
    county_names_all: 'Gila|Pinal',
    county_weights: '{"04007": 75.2, "04021": 24.8}',
    density: 16.9,
    imprecise: false,
    latitude: 33.33282,
    longitude: -110.92883,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 3386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85539',
  },
  {
    city: 'Morenci',
    county_fips: 4011,
    county_fips_all: '04011',
    county: 'Greenlee',
    county_names_all: 'Greenlee',
    county_weights: '{"04011": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 32.9781,
    longitude: -109.35704,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 3992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85540',
  },
  {
    city: 'Payson',
    county_fips: 4007,
    county_fips_all: '04007',
    county: 'Gila',
    county_names_all: 'Gila',
    county_weights: '{"04007": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 34.21921,
    longitude: -111.34387,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 23382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85541',
  },
  {
    city: 'Peridot',
    county_fips: 4009,
    county_fips_all: '04009|04007',
    county: 'Graham',
    county_names_all: 'Graham|Gila',
    county_weights: '{"04009": 83.74, "04007": 16.26}',
    density: 4.4,
    imprecise: false,
    latitude: 33.28633,
    longitude: -110.30145,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85542',
  },
  {
    city: 'Pima',
    county_fips: 4009,
    county_fips_all: '04009',
    county: 'Graham',
    county_names_all: 'Graham',
    county_weights: '{"04009": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 32.9593,
    longitude: -109.90123,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85543',
  },
  {
    city: 'Pine',
    county_fips: 4007,
    county_fips_all: '04007',
    county: 'Gila',
    county_names_all: 'Gila',
    county_weights: '{"04007": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 34.38609,
    longitude: -111.4732,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85544',
  },
  {
    city: 'Roosevelt',
    county_fips: 4007,
    county_fips_all: '04007|04013',
    county: 'Gila',
    county_names_all: 'Gila|Maricopa',
    county_weights: '{"04007": 50.78, "04013": 49.22}',
    density: 0.6,
    imprecise: false,
    latitude: 33.53759,
    longitude: -111.11955,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85545',
  },
  {
    city: 'Safford',
    county_fips: 4009,
    county_fips_all: '04009',
    county: 'Graham',
    county_names_all: 'Graham',
    county_weights: '{"04009": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 32.71743,
    longitude: -109.58175,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 20809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85546',
  },
  {
    city: 'San Carlos',
    county_fips: 4007,
    county_fips_all: '04007',
    county: 'Gila',
    county_names_all: 'Gila',
    county_weights: '{"04007": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 33.54833,
    longitude: -110.51244,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 5696,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85550',
  },
  {
    city: 'Solomon',
    county_fips: 4009,
    county_fips_all: '04009',
    county: 'Graham',
    county_names_all: 'Graham',
    county_weights: '{"04009": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 32.73048,
    longitude: -109.56252,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85551',
  },
  {
    city: 'Thatcher',
    county_fips: 4009,
    county_fips_all: '04009',
    county: 'Graham',
    county_names_all: 'Graham',
    county_weights: '{"04009": 100}',
    density: 90.8,
    imprecise: false,
    latitude: 32.81399,
    longitude: -109.78953,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 6861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85552',
  },
  {
    city: 'Tonto Basin',
    county_fips: 4007,
    county_fips_all: '04007',
    county: 'Gila',
    county_names_all: 'Gila',
    county_weights: '{"04007": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 33.79932,
    longitude: -111.22438,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85553',
  },
  {
    city: 'Young',
    county_fips: 4007,
    county_fips_all: '04007',
    county: 'Gila',
    county_names_all: 'Gila',
    county_weights: '{"04007": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 33.99679,
    longitude: -110.97834,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85554',
  },
  {
    city: 'Arivaca',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 31.58453,
    longitude: -111.33359,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85601',
  },
  {
    city: 'Benson',
    county_fips: 4003,
    county_fips_all: '04003|04019',
    county: 'Cochise',
    county_names_all: 'Cochise|Pima',
    county_weights: '{"04003": 69.45, "04019": 30.55}',
    density: 4.6,
    imprecise: false,
    latitude: 32.17296,
    longitude: -110.3865,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 10019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85602',
  },
  {
    city: 'Bisbee',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 31.43525,
    longitude: -109.91127,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 6699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85603',
  },
  {
    city: 'Bowie',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 32.29784,
    longitude: -109.47644,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85605',
  },
  {
    city: 'Cochise',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 32.01521,
    longitude: -109.93326,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85606',
  },
  {
    city: 'Douglas',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 31.49008,
    longitude: -109.34052,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 17191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85607',
  },
  {
    city: 'Douglas',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 565.7,
    imprecise: false,
    latitude: 31.45624,
    longitude: -109.58635,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85608',
  },
  {
    city: 'Dragoon',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 32.06867,
    longitude: -110.09714,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85609',
  },
  {
    city: 'Elfrida',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 31.73144,
    longitude: -109.65957,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85610',
  },
  {
    city: 'Elgin',
    county_fips: 4023,
    county_fips_all: '04023|04019|04003',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz|Pima|Cochise',
    county_weights: '{"04023": 49.65, "04019": 36.0, "04003": 14.35}',
    density: 1.5,
    imprecise: false,
    latitude: 31.64266,
    longitude: -110.51334,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85611',
  },
  {
    city: 'Fort Huachuca',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 33.8,
    imprecise: false,
    latitude: 31.55393,
    longitude: -110.38305,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85613',
  },
  {
    city: 'Green Valley',
    county_fips: 4019,
    county_fips_all: '04019|04023',
    county: 'Pima',
    county_names_all: 'Pima|Santa Cruz',
    county_weights: '{"04019": 93.09, "04023": 6.91}',
    density: 74.3,
    imprecise: false,
    latitude: 31.81241,
    longitude: -110.92972,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 25381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85614',
  },
  {
    city: 'Hereford',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 31.39678,
    longitude: -110.2108,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 10175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85615',
  },
  {
    city: 'Huachuca City',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 31.70768,
    longitude: -110.32184,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85616',
  },
  {
    city: 'McNeal',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 31.55767,
    longitude: -109.71548,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85617',
  },
  {
    city: 'Mammoth',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 32.77631,
    longitude: -110.69433,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85618',
  },
  {
    city: 'Mount Lemmon',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.39574,
    longitude: -110.73663,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85619',
  },
  {
    city: 'Naco',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 330.6,
    imprecise: false,
    latitude: 31.33835,
    longitude: -109.9431,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85620',
  },
  {
    city: 'Nogales',
    county_fips: 4023,
    county_fips_all: '04023',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"04023": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 31.42345,
    longitude: -111.03764,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 21593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85621',
  },
  {
    city: 'Green Valley',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 32.6,
    imprecise: false,
    latitude: 31.80301,
    longitude: -111.09104,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 6518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85622',
  },
  {
    city: 'Oracle',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 32.65407,
    longitude: -110.78447,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 5558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85623',
  },
  {
    city: 'Patagonia',
    county_fips: 4023,
    county_fips_all: '04023',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"04023": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 31.51768,
    longitude: -110.71039,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85624',
  },
  {
    city: 'Pearce',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 31.88021,
    longitude: -109.66692,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85625',
  },
  {
    city: 'Pirtleville',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 527.4,
    imprecise: false,
    latitude: 31.35932,
    longitude: -109.56827,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85626',
  },
  {
    city: 'Pomerene',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 15,
    imprecise: false,
    latitude: 32.00707,
    longitude: -110.24695,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85627',
  },
  {
    city: 'Sahuarita',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 51.7,
    imprecise: false,
    latitude: 31.91413,
    longitude: -111.01334,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 31668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85629',
  },
  {
    city: 'Saint David',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 31.88335,
    longitude: -110.19447,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85630',
  },
  {
    city: 'San Manuel',
    county_fips: 4021,
    county_fips_all: '04021',
    county: 'Pinal',
    county_names_all: 'Pinal',
    county_weights: '{"04021": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 32.58133,
    longitude: -110.5627,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 3508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85631',
  },
  {
    city: 'San Simon',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 32.05855,
    longitude: -109.18305,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85632',
  },
  {
    city: 'Sasabe',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 31.60632,
    longitude: -111.52827,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85633',
  },
  {
    city: 'Sells',
    county_fips: 4019,
    county_fips_all: '04019|04021',
    county: 'Pima',
    county_names_all: 'Pima|Pinal',
    county_weights: '{"04019": 98.43, "04021": 1.57}',
    density: 0.7,
    imprecise: false,
    latitude: 32.02817,
    longitude: -112.03296,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 5038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85634',
  },
  {
    city: 'Sierra Vista',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 193.9,
    imprecise: false,
    latitude: 31.55322,
    longitude: -110.17304,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 34193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85635',
  },
  {
    city: 'Sonoita',
    county_fips: 4023,
    county_fips_all: '04023|04019',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz|Pima',
    county_weights: '{"04023": 52.53, "04019": 47.47}',
    density: 3.4,
    imprecise: false,
    latitude: 31.72108,
    longitude: -110.69258,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85637',
  },
  {
    city: 'Tombstone',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 2,
    imprecise: false,
    latitude: 31.68588,
    longitude: -110.05887,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85638',
  },
  {
    city: 'Topawa',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 31.77175,
    longitude: -111.68228,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85639',
  },
  {
    city: 'Tumacacori',
    county_fips: 4023,
    county_fips_all: '04023',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"04023": 100}',
    density: 28,
    imprecise: false,
    latitude: 31.56755,
    longitude: -111.04473,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85640',
  },
  {
    city: 'Vail',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 39.1,
    imprecise: false,
    latitude: 32.02125,
    longitude: -110.64617,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 34752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85641',
  },
  {
    city: 'Willcox',
    county_fips: 4009,
    county_fips_all: '04009|04003',
    county: 'Graham',
    county_names_all: 'Graham|Cochise',
    county_weights: '{"04009": 51.49, "04003": 48.51}',
    density: 1.5,
    imprecise: false,
    latitude: 32.43757,
    longitude: -109.98521,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 8476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85643',
  },
  {
    city: 'Amado',
    county_fips: 4019,
    county_fips_all: '04019|04023',
    county: 'Pima',
    county_names_all: 'Pima|Santa Cruz',
    county_weights: '{"04019": 62.02, "04023": 37.98}',
    density: 3,
    imprecise: false,
    latitude: 31.69497,
    longitude: -111.14655,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85645',
  },
  {
    city: 'Tubac',
    county_fips: 4023,
    county_fips_all: '04023',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"04023": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 31.62009,
    longitude: -111.05192,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85646',
  },
  {
    city: 'Rio Rico',
    county_fips: 4023,
    county_fips_all: '04023',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"04023": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 31.51262,
    longitude: -111.00807,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 22118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85648',
  },
  {
    city: 'Sierra Vista',
    county_fips: 4003,
    county_fips_all: '04003',
    county: 'Cochise',
    county_names_all: 'Cochise',
    county_weights: '{"04003": 100}',
    density: 139.1,
    imprecise: false,
    latitude: 31.49759,
    longitude: -110.19906,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 14876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85650',
  },
  {
    city: 'Marana',
    county_fips: 4019,
    county_fips_all: '04019|04021',
    county: 'Pima',
    county_names_all: 'Pima|Pinal',
    county_weights: '{"04019": 94.9, "04021": 5.1}',
    density: 26.5,
    imprecise: false,
    latitude: 32.38979,
    longitude: -111.37908,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 23574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85653',
  },
  {
    city: 'Rillito',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.41529,
    longitude: -111.15467,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85654',
  },
  {
    city: 'Marana',
    county_fips: 4021,
    county_fips_all: '04021|04019',
    county: 'Pinal',
    county_names_all: 'Pinal|Pima',
    county_weights: '{"04021": 64.6, "04019": 35.4}',
    density: 31.8,
    imprecise: false,
    latitude: 32.52455,
    longitude: -111.13603,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 16051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85658',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 1437.4,
    imprecise: false,
    latitude: 32.21702,
    longitude: -110.97138,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 5498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85701',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 746.8,
    imprecise: false,
    latitude: 32.33885,
    longitude: -110.98483,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 35210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85704',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 1550,
    imprecise: false,
    latitude: 32.27119,
    longitude: -110.99172,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 54700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85705',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 1596.8,
    imprecise: false,
    latitude: 32.14783,
    longitude: -110.93541,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 54236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85706',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 576.4,
    imprecise: false,
    latitude: 32.17575,
    longitude: -110.86019,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85708',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 1811.8,
    imprecise: false,
    latitude: 32.21439,
    longitude: -110.82365,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 56125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85710',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 1907.1,
    imprecise: false,
    latitude: 32.21504,
    longitude: -110.88348,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 42558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85711',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 1780.3,
    imprecise: false,
    latitude: 32.25229,
    longitude: -110.88636,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 31571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85712',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 752.3,
    imprecise: false,
    latitude: 32.19525,
    longitude: -111.0151,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 46439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85713',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 993.2,
    imprecise: false,
    latitude: 32.16997,
    longitude: -110.94653,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 14498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85714',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 1131.3,
    imprecise: false,
    latitude: 32.24898,
    longitude: -110.83118,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 19198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85715',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 1768.6,
    imprecise: false,
    latitude: 32.24222,
    longitude: -110.92351,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 32976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85716',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 459.4,
    imprecise: false,
    latitude: 32.31078,
    longitude: -110.91819,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 28125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85718',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 2512.6,
    imprecise: false,
    latitude: 32.2462,
    longitude: -110.94876,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 51833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85719',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.20437,
    longitude: -110.94529,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85726',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 405.4,
    imprecise: false,
    latitude: 32.19064,
    longitude: -110.72976,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 39399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85730',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 1627.1,
    imprecise: false,
    latitude: 32.06761,
    longitude: -110.86717,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4797,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85734',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 32.10389,
    longitude: -111.33437,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 10718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85735',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 31.87623,
    longitude: -111.37472,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85736',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 371.1,
    imprecise: false,
    latitude: 32.41425,
    longitude: -110.94683,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 22785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85737',
  },
  {
    city: 'Tucson',
    county_fips: 4021,
    county_fips_all: '04021|04019',
    county: 'Pinal',
    county_names_all: 'Pinal|Pima',
    county_weights: '{"04021": 86.99, "04019": 13.01}',
    density: 27.9,
    imprecise: false,
    latitude: 32.6137,
    longitude: -111.00758,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 18478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85739',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 1367.8,
    imprecise: false,
    latitude: 32.3364,
    longitude: -111.04077,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 33679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85741',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 547.4,
    imprecise: false,
    latitude: 32.3898,
    longitude: -111.05113,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 31613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85742',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 102.2,
    imprecise: false,
    latitude: 32.30501,
    longitude: -111.18548,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 31300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85743',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 304.1,
    imprecise: false,
    latitude: 32.25014,
    longitude: -111.06253,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 36999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85745',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 142.7,
    imprecise: false,
    latitude: 32.06964,
    longitude: -111.09047,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 42835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85746',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 159.9,
    imprecise: false,
    latitude: 32.09318,
    longitude: -110.7723,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 27753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85747',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 648.9,
    imprecise: false,
    latitude: 32.21904,
    longitude: -110.75205,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 20103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85748',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 150.5,
    imprecise: false,
    latitude: 32.28129,
    longitude: -110.72604,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 18843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85749',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 528.7,
    imprecise: false,
    latitude: 32.29952,
    longitude: -110.84288,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 24886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85750',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 211.7,
    imprecise: false,
    latitude: 32.46836,
    longitude: -110.98152,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 18560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85755',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 155.4,
    imprecise: false,
    latitude: 32.07034,
    longitude: -110.90625,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 37700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85756',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 320.8,
    imprecise: false,
    latitude: 32.12835,
    longitude: -111.12228,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 21259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85757',
  },
  {
    city: 'Show Low',
    county_fips: 4017,
    county_fips_all: '04017|04001',
    county: 'Navajo',
    county_names_all: 'Navajo|Apache',
    county_weights: '{"04017": 89.55, "04001": 10.45}',
    density: 28.7,
    imprecise: false,
    latitude: 34.29348,
    longitude: -109.99878,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 19533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85901',
  },
  {
    city: 'Show Low',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.11509,
    longitude: -110.16233,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85902',
  },
  {
    city: 'Cibecue',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 34.14844,
    longitude: -110.4588,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85911',
  },
  {
    city: 'White Mountain Lake',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 34.41962,
    longitude: -109.91624,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85912',
  },
  {
    city: 'Alpine',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 33.85995,
    longitude: -109.1753,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85920',
  },
  {
    city: 'Blue',
    county_fips: 4011,
    county_fips_all: '04011',
    county: 'Greenlee',
    county_names_all: 'Greenlee',
    county_weights: '{"04011": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 33.49535,
    longitude: -109.18864,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85922',
  },
  {
    city: 'Clay Springs',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 34.32313,
    longitude: -110.34036,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85923',
  },
  {
    city: 'Concho',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 34.5635,
    longitude: -109.67553,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85924',
  },
  {
    city: 'Eagar',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 20.6,
    imprecise: false,
    latitude: 34.0162,
    longitude: -109.3557,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85925',
  },
  {
    city: 'Fort Apache',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 38.2,
    imprecise: false,
    latitude: 33.77507,
    longitude: -109.9788,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85926',
  },
  {
    city: 'Greer',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 33.99572,
    longitude: -109.48079,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85927',
  },
  {
    city: 'Heber',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 34.52276,
    longitude: -110.5506,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85928',
  },
  {
    city: 'Lakeside',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 84.4,
    imprecise: false,
    latitude: 34.16512,
    longitude: -109.95948,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 7451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85929',
  },
  {
    city: 'Mcnary',
    county_fips: 4001,
    county_fips_all: '04001|04017',
    county: 'Apache',
    county_names_all: 'Apache|Navajo',
    county_weights: '{"04001": 88.57, "04017": 11.43}',
    density: 4,
    imprecise: false,
    latitude: 34.02744,
    longitude: -109.77141,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85930',
  },
  {
    city: 'Forest Lakes',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 34.45238,
    longitude: -110.87003,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85931',
  },
  {
    city: 'Nutrioso',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 33.95958,
    longitude: -109.1943,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85932',
  },
  {
    city: 'Overgaard',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 34.36089,
    longitude: -110.50955,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85933',
  },
  {
    city: 'Pinedale',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 34.30251,
    longitude: -110.24432,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85934',
  },
  {
    city: 'Pinetop',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 38.8,
    imprecise: false,
    latitude: 34.14166,
    longitude: -109.90453,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85935',
  },
  {
    city: 'Saint Johns',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 34.60662,
    longitude: -109.29134,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 3909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85936',
  },
  {
    city: 'Snowflake',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 13,
    imprecise: false,
    latitude: 34.56927,
    longitude: -110.01285,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 9760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85937',
  },
  {
    city: 'Springerville',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 34.17814,
    longitude: -109.40089,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85938',
  },
  {
    city: 'Taylor',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 27.6,
    imprecise: false,
    latitude: 34.43729,
    longitude: -110.08754,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 3849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85939',
  },
  {
    city: 'Vernon',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 34.25265,
    longitude: -109.69729,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85940',
  },
  {
    city: 'Whiteriver',
    county_fips: 4007,
    county_fips_all: '04007|04017',
    county: 'Gila',
    county_names_all: 'Gila|Navajo',
    county_weights: '{"04007": 60.25, "04017": 39.75}',
    density: 8.5,
    imprecise: false,
    latitude: 33.88756,
    longitude: -110.0648,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 10459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85941',
  },
  {
    city: 'Woodruff',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.77442,
    longitude: -110.03549,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85942',
  },
  {
    city: 'Flagstaff',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 49.6,
    imprecise: false,
    latitude: 35.35119,
    longitude: -111.75607,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 37312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86001',
  },
  {
    city: 'Flagstaff',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 35.24259,
    longitude: -111.20202,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86003',
  },
  {
    city: 'Flagstaff',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 35.37546,
    longitude: -111.37515,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 36394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86004',
  },
  {
    city: 'Flagstaff',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 45.8,
    imprecise: false,
    latitude: 35.08125,
    longitude: -111.62832,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 17961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86005',
  },
  {
    city: 'Bellemont',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 37.9,
    imprecise: false,
    latitude: 35.22408,
    longitude: -111.80972,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86015',
  },
  {
    city: 'Gray Mountain',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 35.74486,
    longitude: -111.6373,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86016',
  },
  {
    city: 'Munds Park',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 34.91938,
    longitude: -111.66077,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86017',
  },
  {
    city: 'Parks',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 35.24716,
    longitude: -111.96204,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86018',
  },
  {
    city: 'Cameron',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 36.00133,
    longitude: -111.51263,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86020',
  },
  {
    city: 'Colorado City',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 36.92707,
    longitude: -113.10205,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86021',
  },
  {
    city: 'Fredonia',
    county_fips: 4005,
    county_fips_all: '04005|04015',
    county: 'Coconino',
    county_names_all: 'Coconino|Mohave',
    county_weights: '{"04005": 67.58, "04015": 32.42}',
    density: 0.8,
    imprecise: false,
    latitude: 36.7702,
    longitude: -112.5449,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86022',
  },
  {
    city: 'Grand Canyon',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 36.13498,
    longitude: -112.23438,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86023',
  },
  {
    city: 'Happy Jack',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 34.68509,
    longitude: -111.20244,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86024',
  },
  {
    city: 'Holbrook',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 34.90484,
    longitude: -110.08557,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 5226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86025',
  },
  {
    city: 'Petrified Forest Natl Pk',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 35.02873,
    longitude: -109.81056,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 47,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86028',
  },
  {
    city: 'Sun Valley',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 1,
    imprecise: false,
    latitude: 34.96834,
    longitude: -110.01175,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86029',
  },
  {
    city: 'Hotevilla',
    county_fips: 4005,
    county_fips_all: '04005|04017',
    county: 'Coconino',
    county_names_all: 'Coconino|Navajo',
    county_weights: '{"04005": 73.23, "04017": 26.77}',
    density: 1.2,
    imprecise: false,
    latitude: 35.87005,
    longitude: -110.80709,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86030',
  },
  {
    city: 'Indian Wells',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 35.3534,
    longitude: -110.0647,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86031',
  },
  {
    city: 'Joseph City',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 35.04288,
    longitude: -110.32234,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86032',
  },
  {
    city: 'Kayenta',
    county_fips: 4017,
    county_fips_all: '04017|04001',
    county: 'Navajo',
    county_names_all: 'Navajo|Apache',
    county_weights: '{"04017": 95.09, "04001": 4.91}',
    density: 2.4,
    imprecise: false,
    latitude: 36.67692,
    longitude: -110.25536,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86033',
  },
  {
    city: 'Keams Canyon',
    county_fips: 4017,
    county_fips_all: '04017|04001',
    county: 'Navajo',
    county_names_all: 'Navajo|Apache',
    county_weights: '{"04017": 92.61, "04001": 7.39}',
    density: 1.6,
    imprecise: false,
    latitude: 35.77145,
    longitude: -110.138,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86034',
  },
  {
    city: 'Leuppx',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 35.39631,
    longitude: -111.02806,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86035',
  },
  {
    city: 'Marble Canyon',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 36.72434,
    longitude: -111.82083,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86036',
  },
  {
    city: 'Mormon Lake',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 34.9018,
    longitude: -111.49161,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86038',
  },
  {
    city: 'Kykotsmovi Village',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 35.98813,
    longitude: -110.56688,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86039',
  },
  {
    city: 'Page',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 36.66294,
    longitude: -111.3852,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86040',
  },
  {
    city: 'Polacca',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 35.86498,
    longitude: -110.38447,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86042',
  },
  {
    city: 'Second Mesa',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 35.81049,
    longitude: -110.52904,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86043',
  },
  {
    city: 'Tonalea',
    county_fips: 4005,
    county_fips_all: '04005|49037|04017',
    county: 'Coconino',
    county_names_all: 'Coconino|San Juan|Navajo',
    county_weights: '{"04005": 55.31, "49037": 31.59, "04017": 13.1}',
    density: 1,
    imprecise: false,
    latitude: 36.75137,
    longitude: -110.82626,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86044',
  },
  {
    city: 'Tuba City',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 36.14775,
    longitude: -111.13344,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86045',
  },
  {
    city: 'Williams',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 35.43882,
    longitude: -112.17428,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 6574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86046',
  },
  {
    city: 'Winslow',
    county_fips: 4017,
    county_fips_all: '04017|04005',
    county: 'Navajo',
    county_names_all: 'Navajo|Coconino',
    county_weights: '{"04017": 71.59, "04005": 28.41}',
    density: 3.2,
    imprecise: false,
    latitude: 35.18181,
    longitude: -110.63785,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 13899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86047',
  },
  {
    city: 'Kaibeto',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 36.75699,
    longitude: -111.05597,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86053',
  },
  {
    city: 'Shonto',
    county_fips: 4017,
    county_fips_all: '04017|04005',
    county: 'Navajo',
    county_names_all: 'Navajo|Coconino',
    county_weights: '{"04017": 94.09, "04005": 5.91}',
    density: 1.3,
    imprecise: false,
    latitude: 36.67546,
    longitude: -110.61259,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86054',
  },
  {
    city: 'Prescott',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 313,
    imprecise: false,
    latitude: 34.59452,
    longitude: -112.42454,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 27076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86301',
  },
  {
    city: 'Prescott',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 70.1,
    imprecise: false,
    latitude: 34.4894,
    longitude: -112.42897,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 19446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86303',
  },
  {
    city: 'Prescott',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 13,
    imprecise: false,
    latitude: 34.7906,
    longitude: -112.75229,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 19790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86305',
  },
  {
    city: 'Prescott Valley',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 585.6,
    imprecise: false,
    latitude: 34.59823,
    longitude: -112.33079,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 40317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86314',
  },
  {
    city: 'Prescott Valley',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 46.7,
    imprecise: false,
    latitude: 34.67403,
    longitude: -112.2891,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 10684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86315',
  },
  {
    city: 'Ash Fork',
    county_fips: 4005,
    county_fips_all: '04005|04025',
    county: 'Coconino',
    county_names_all: 'Coconino|Yavapai',
    county_weights: '{"04005": 70.43, "04025": 29.57}',
    density: 1.1,
    imprecise: false,
    latitude: 35.36745,
    longitude: -112.63995,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86320',
  },
  {
    city: 'Bagdad',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 34.55367,
    longitude: -113.08895,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 3065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86321',
  },
  {
    city: 'Camp Verde',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 34.47486,
    longitude: -111.80587,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 13020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86322',
  },
  {
    city: 'Chino Valley',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 66.2,
    imprecise: false,
    latitude: 34.76606,
    longitude: -112.40424,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 19666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86323',
  },
  {
    city: 'Clarkdale',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 34.836,
    longitude: -112.1304,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86324',
  },
  {
    city: 'Cornville',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 33.7,
    imprecise: false,
    latitude: 34.73347,
    longitude: -111.89884,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 5363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86325',
  },
  {
    city: 'Cottonwood',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 211.1,
    imprecise: false,
    latitude: 34.69857,
    longitude: -112.01383,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 24852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86326',
  },
  {
    city: 'Dewey',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 34.55682,
    longitude: -112.11089,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 12154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86327',
  },
  {
    city: 'Humboldt',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 30.8,
    imprecise: false,
    latitude: 34.48589,
    longitude: -112.27666,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86329',
  },
  {
    city: 'Jerome',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 34.76009,
    longitude: -112.11704,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86331',
  },
  {
    city: 'Kirkland',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 34.30403,
    longitude: -112.61809,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 2316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86332',
  },
  {
    city: 'Mayer',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 34.32195,
    longitude: -112.08352,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 6781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86333',
  },
  {
    city: 'Paulden',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 34.94847,
    longitude: -112.53946,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86334',
  },
  {
    city: 'Rimrock',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 7,
    imprecise: false,
    latitude: 34.65216,
    longitude: -111.68044,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86335',
  },
  {
    city: 'Sedona',
    county_fips: 4025,
    county_fips_all: '04025|04005',
    county: 'Yavapai',
    county_names_all: 'Yavapai|Coconino',
    county_weights: '{"04025": 72.91, "04005": 27.09}',
    density: 21.6,
    imprecise: false,
    latitude: 34.8902,
    longitude: -111.85157,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 11381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86336',
  },
  {
    city: 'Seligman',
    county_fips: 4025,
    county_fips_all: '04025|04005',
    county: 'Yavapai',
    county_names_all: 'Yavapai|Coconino',
    county_weights: '{"04025": 75.22, "04005": 24.78}',
    density: 0.4,
    imprecise: false,
    latitude: 35.24422,
    longitude: -113.0505,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86337',
  },
  {
    city: 'Skull Valley',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 34.57306,
    longitude: -112.75756,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86338',
  },
  {
    city: 'Crown King',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 34.17937,
    longitude: -112.31236,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86343',
  },
  {
    city: 'Sedona',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 64.9,
    imprecise: false,
    latitude: 34.77846,
    longitude: -111.78514,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 6721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86351',
  },
  {
    city: 'Kingman',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 35.11024,
    longitude: -113.70423,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 30124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86401',
  },
  {
    city: 'Lake Havasu City',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 640.9,
    imprecise: false,
    latitude: 34.47703,
    longitude: -114.34423,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 18295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86403',
  },
  {
    city: 'Lake Havasu City',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 45.9,
    imprecise: false,
    latitude: 34.61156,
    longitude: -114.29452,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 19234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86404',
  },
  {
    city: 'Lake Havasu City',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 34.42269,
    longitude: -114.12418,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 25067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86406',
  },
  {
    city: 'Kingman',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 35.46429,
    longitude: -114.03245,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 30365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86409',
  },
  {
    city: 'Hackberry',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 35.44761,
    longitude: -113.74381,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86411',
  },
  {
    city: 'Golden Valley',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 35.16995,
    longitude: -114.25695,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 13143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86413',
  },
  {
    city: 'Fort Mohave',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 171.1,
    imprecise: false,
    latitude: 35.0134,
    longitude: -114.54968,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 15467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86426',
  },
  {
    city: 'Bullhead City',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 35.28769,
    longitude: -114.51261,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 8619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86429',
  },
  {
    city: 'Chloride',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 35.42521,
    longitude: -114.24738,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 86,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86431',
  },
  {
    city: 'Littlefield',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 36.79085,
    longitude: -113.73783,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 3073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86432',
  },
  {
    city: 'Oatman',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 34.92862,
    longitude: -114.35853,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 74,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86433',
  },
  {
    city: 'Peach Springs',
    county_fips: 4015,
    county_fips_all: '04015|04025|04005',
    county: 'Mohave',
    county_names_all: 'Mohave|Yavapai|Coconino',
    county_weights: '{"04015": 95.14, "04025": 3.92, "04005": 0.94}',
    density: 0.7,
    imprecise: false,
    latitude: 35.65959,
    longitude: -113.58538,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86434',
  },
  {
    city: 'Supai',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.00915,
    longitude: -112.94567,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86435',
  },
  {
    city: 'Topock',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 34.73914,
    longitude: -114.42273,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86436',
  },
  {
    city: 'Valentine',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 35.39511,
    longitude: -113.59784,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86437',
  },
  {
    city: 'Yucca',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 34.68595,
    longitude: -113.98175,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86438',
  },
  {
    city: 'Mohave Valley',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 27.7,
    imprecise: false,
    latitude: 34.88855,
    longitude: -114.54071,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 8853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86440',
  },
  {
    city: 'Dolan Springs',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 35.56205,
    longitude: -114.30384,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86441',
  },
  {
    city: 'Bullhead City',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 476.2,
    imprecise: false,
    latitude: 35.09139,
    longitude: -114.57731,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 34735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86442',
  },
  {
    city: 'Meadview',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 35.90199,
    longitude: -114.05969,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 1528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86444',
  },
  {
    city: 'Willow Beach',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 35.70747,
    longitude: -114.53764,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86445',
  },
  {
    city: 'Chambers',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 35.1212,
    longitude: -109.61705,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86502',
  },
  {
    city: 'Chinle',
    county_fips: 4001,
    county_fips_all: '04001|04017',
    county: 'Apache',
    county_names_all: 'Apache|Navajo',
    county_weights: '{"04001": 95.28, "04017": 4.72}',
    density: 3.9,
    imprecise: false,
    latitude: 36.20258,
    longitude: -109.68224,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86503',
  },
  {
    city: 'Fort Defiance',
    county_fips: 4001,
    county_fips_all: '04001|35031',
    county: 'Apache',
    county_names_all: 'Apache|McKinley',
    county_weights: '{"04001": 98.82, "35031": 1.18}',
    density: 11,
    imprecise: false,
    latitude: 35.86087,
    longitude: -109.13995,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86504',
  },
  {
    city: 'Ganado',
    county_fips: 4001,
    county_fips_all: '04001|04017',
    county: 'Apache',
    county_names_all: 'Apache|Navajo',
    county_weights: '{"04001": 84.25, "04017": 15.75}',
    density: 2.4,
    imprecise: false,
    latitude: 35.61872,
    longitude: -109.71274,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86505',
  },
  {
    city: 'Houck',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 35.35206,
    longitude: -109.25868,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86506',
  },
  {
    city: 'Lukachukai',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 36.41985,
    longitude: -109.28019,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86507',
  },
  {
    city: 'Lupton',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 35.35086,
    longitude: -109.08737,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86508',
  },
  {
    city: 'Pinon',
    county_fips: 4017,
    county_fips_all: '04017',
    county: 'Navajo',
    county_names_all: 'Navajo',
    county_weights: '{"04017": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 36.23061,
    longitude: -110.27182,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86510',
  },
  {
    city: 'Saint Michaels',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 35.66536,
    longitude: -109.26397,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86511',
  },
  {
    city: 'Sanders',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 35.079,
    longitude: -109.24737,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86512',
  },
  {
    city: 'Teec Nos Pos',
    county_fips: 4001,
    county_fips_all: '04001|49037|35045',
    county: 'Apache',
    county_names_all: 'Apache|San Juan|San Juan',
    county_weights: '{"04001": 83.89, "49037": 15.12, "35045": 0.99}',
    density: 1.4,
    imprecise: false,
    latitude: 36.90487,
    longitude: -109.32028,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86514',
  },
  {
    city: 'Window Rock',
    county_fips: 35031,
    county_fips_all: '35031|04001',
    county: 'McKinley',
    county_names_all: 'McKinley|Apache',
    county_weights: '{"35031": 88.14, "04001": 11.86}',
    density: 11.5,
    imprecise: false,
    latitude: 35.70301,
    longitude: -108.99057,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86515',
  },
  {
    city: 'Blue Gap',
    county_fips: 4001,
    county_fips_all: '04001|04017',
    county: 'Apache',
    county_names_all: 'Apache|Navajo',
    county_weights: '{"04001": 78.06, "04017": 21.94}',
    density: 3.1,
    imprecise: false,
    latitude: 36.05891,
    longitude: -109.95208,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86520',
  },
  {
    city: 'Dennehotso',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 36.82372,
    longitude: -109.86199,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86535',
  },
  {
    city: 'Many Farms',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 36.43323,
    longitude: -109.63752,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86538',
  },
  {
    city: 'Nazlini',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 2,
    imprecise: false,
    latitude: 35.93953,
    longitude: -109.44886,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86540',
  },
  {
    city: 'Red Valley',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 36.58162,
    longitude: -109.13818,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86544',
  },
  {
    city: 'Rock Point',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 36.71125,
    longitude: -109.58943,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86545',
  },
  {
    city: 'Round Rock',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 36.52759,
    longitude: -109.46019,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86547',
  },
  {
    city: 'Tsaile',
    county_fips: 4001,
    county_fips_all: '04001',
    county: 'Apache',
    county_names_all: 'Apache',
    county_weights: '{"04001": 100}',
    density: 5,
    imprecise: false,
    latitude: 36.24093,
    longitude: -109.21631,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86556',
  },
  {
    city: 'Algodones',
    county_fips: 35043,
    county_fips_all: '35043',
    county: 'Sandoval',
    county_names_all: 'Sandoval',
    county_weights: '{"35043": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 35.41231,
    longitude: -106.37944,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87001',
  },
  {
    city: 'Belen',
    county_fips: 35061,
    county_fips_all: '35061|35053',
    county: 'Valencia',
    county_names_all: 'Valencia|Socorro',
    county_weights: '{"35061": 99.78, "35053": 0.22}',
    density: 13.7,
    imprecise: false,
    latitude: 34.63619,
    longitude: -106.82517,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 21265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87002',
  },
  {
    city: 'Bernalillo',
    county_fips: 35043,
    county_fips_all: '35043',
    county: 'Sandoval',
    county_names_all: 'Sandoval',
    county_weights: '{"35043": 100}',
    density: 47.9,
    imprecise: false,
    latitude: 35.38555,
    longitude: -106.58493,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 11237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87004',
  },
  {
    city: 'Bluewater',
    county_fips: 35006,
    county_fips_all: '35006',
    county: 'Cibola',
    county_names_all: 'Cibola',
    county_weights: '{"35006": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 35.25669,
    longitude: -107.98867,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87005',
  },
  {
    city: 'Bosque',
    county_fips: 35053,
    county_fips_all: '35053|35061',
    county: 'Socorro',
    county_names_all: 'Socorro|Valencia',
    county_weights: '{"35053": 95.81, "35061": 4.19}',
    density: 8.2,
    imprecise: false,
    latitude: 34.48616,
    longitude: -106.84202,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87006',
  },
  {
    city: 'Casa Blanca',
    county_fips: 35006,
    county_fips_all: '35006',
    county: 'Cibola',
    county_names_all: 'Cibola',
    county_weights: '{"35006": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 34.96582,
    longitude: -107.46717,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87007',
  },
  {
    city: 'Cedar Crest',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 36.5,
    imprecise: false,
    latitude: 35.14779,
    longitude: -106.39133,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87008',
  },
  {
    city: 'Cerrillos',
    county_fips: 35049,
    county_fips_all: '35049',
    county: 'Santa Fe',
    county_names_all: 'Santa Fe',
    county_weights: '{"35049": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 35.40517,
    longitude: -106.13493,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87010',
  },
  {
    city: 'Claunch',
    county_fips: 35053,
    county_fips_all: '35053|35027',
    county: 'Socorro',
    county_names_all: 'Socorro|Lincoln',
    county_weights: '{"35053": 72.29, "35027": 27.71}',
    density: 0,
    imprecise: false,
    latitude: 34.08236,
    longitude: -105.97225,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87011',
  },
  {
    city: 'Coyote',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 36.13341,
    longitude: -106.67312,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87012',
  },
  {
    city: 'Cuba',
    county_fips: 35043,
    county_fips_all: '35043|35031|35039',
    county: 'Sandoval',
    county_names_all: 'Sandoval|McKinley|Rio Arriba',
    county_weights: '{"35043": 55.17, "35031": 44.35, "35039": 0.48}',
    density: 1.8,
    imprecise: false,
    latitude: 35.90014,
    longitude: -107.33509,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87013',
  },
  {
    city: 'Cubero',
    county_fips: 35006,
    county_fips_all: '35006',
    county: 'Cibola',
    county_names_all: 'Cibola',
    county_weights: '{"35006": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 35.1372,
    longitude: -107.45315,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87014',
  },
  {
    city: 'Edgewood',
    county_fips: 35049,
    county_fips_all: '35049|35057|35001',
    county: 'Santa Fe',
    county_names_all: 'Santa Fe|Torrance|Bernalillo',
    county_weights: '{"35049": 62.06, "35057": 20.49, "35001": 17.45}',
    density: 42.4,
    imprecise: false,
    latitude: 35.07535,
    longitude: -106.19123,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 14443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87015',
  },
  {
    city: 'Estancia',
    county_fips: 35057,
    county_fips_all: '35057',
    county: 'Torrance',
    county_names_all: 'Torrance',
    county_weights: '{"35057": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 34.75117,
    longitude: -106.01074,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87016',
  },
  {
    city: 'Gallina',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 36.30624,
    longitude: -106.73759,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87017',
  },
  {
    city: 'Counselor',
    county_fips: 35043,
    county_fips_all: '35043|35039',
    county: 'Sandoval',
    county_names_all: 'Sandoval|Rio Arriba',
    county_weights: '{"35043": 97.64, "35039": 2.36}',
    density: 1.2,
    imprecise: false,
    latitude: 36.11644,
    longitude: -107.51745,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87018',
  },
  {
    city: 'Grants',
    county_fips: 35006,
    county_fips_all: '35006|35031',
    county: 'Cibola',
    county_names_all: 'Cibola|McKinley',
    county_weights: '{"35006": 86.5, "35031": 13.5}',
    density: 5.1,
    imprecise: false,
    latitude: 35.0589,
    longitude: -107.92797,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 11966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87020',
  },
  {
    city: 'Milan',
    county_fips: 35006,
    county_fips_all: '35006',
    county: 'Cibola',
    county_names_all: 'Cibola',
    county_weights: '{"35006": 100}',
    density: 110.5,
    imprecise: false,
    latitude: 35.19673,
    longitude: -107.88621,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87021',
  },
  {
    city: 'Isleta',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 343.5,
    imprecise: false,
    latitude: 34.90986,
    longitude: -106.69501,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87022',
  },
  {
    city: 'Jarales',
    county_fips: 35061,
    county_fips_all: '35061',
    county: 'Valencia',
    county_names_all: 'Valencia',
    county_weights: '{"35061": 100}',
    density: 45.5,
    imprecise: false,
    latitude: 34.59583,
    longitude: -106.7633,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87023',
  },
  {
    city: 'Jemez Pueblo',
    county_fips: 35043,
    county_fips_all: '35043',
    county: 'Sandoval',
    county_names_all: 'Sandoval',
    county_weights: '{"35043": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 35.6765,
    longitude: -106.75031,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87024',
  },
  {
    city: 'Jemez Springs',
    county_fips: 35043,
    county_fips_all: '35043',
    county: 'Sandoval',
    county_names_all: 'Sandoval',
    county_weights: '{"35043": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 35.84308,
    longitude: -106.61862,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87025',
  },
  {
    city: 'Laguna',
    county_fips: 35006,
    county_fips_all: '35006|35061|35001',
    county: 'Cibola',
    county_names_all: 'Cibola|Valencia|Bernalillo',
    county_weights: '{"35006": 49.49, "35061": 28.43, "35001": 22.08}',
    density: 1.5,
    imprecise: false,
    latitude: 34.97119,
    longitude: -107.17556,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87026',
  },
  {
    city: 'La Jara',
    county_fips: 35043,
    county_fips_all: '35043',
    county: 'Sandoval',
    county_names_all: 'Sandoval',
    county_weights: '{"35043": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 36.12734,
    longitude: -106.94737,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87027',
  },
  {
    city: 'La Joya',
    county_fips: 35053,
    county_fips_all: '35053',
    county: 'Socorro',
    county_names_all: 'Socorro',
    county_weights: '{"35053": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 34.35076,
    longitude: -106.78789,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87028',
  },
  {
    city: 'Lindrith',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 36.39394,
    longitude: -107.03949,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87029',
  },
  {
    city: 'Los Lunas',
    county_fips: 35061,
    county_fips_all: '35061',
    county: 'Valencia',
    county_names_all: 'Valencia',
    county_weights: '{"35061": 100}',
    density: 71.8,
    imprecise: false,
    latitude: 34.78007,
    longitude: -106.72649,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 47514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87031',
  },
  {
    city: 'Mcintosh',
    county_fips: 35057,
    county_fips_all: '35057',
    county: 'Torrance',
    county_names_all: 'Torrance',
    county_weights: '{"35057": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 34.86786,
    longitude: -106.04201,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87032',
  },
  {
    city: 'Pueblo Of Acoma',
    county_fips: 35006,
    county_fips_all: '35006',
    county: 'Cibola',
    county_names_all: 'Cibola',
    county_weights: '{"35006": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 34.91939,
    longitude: -107.6559,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87034',
  },
  {
    city: 'Moriarty',
    county_fips: 35057,
    county_fips_all: '35057|35049',
    county: 'Torrance',
    county_names_all: 'Torrance|Santa Fe',
    county_weights: '{"35057": 96.93, "35049": 3.07}',
    density: 8.5,
    imprecise: false,
    latitude: 34.95116,
    longitude: -105.90273,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87035',
  },
  {
    city: 'Mountainair',
    county_fips: 35057,
    county_fips_all: '35057|35053',
    county: 'Torrance',
    county_names_all: 'Torrance|Socorro',
    county_weights: '{"35057": 62.52, "35053": 37.48}',
    density: 0.7,
    imprecise: false,
    latitude: 34.35591,
    longitude: -106.24227,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87036',
  },
  {
    city: 'Nageezi',
    county_fips: 35045,
    county_fips_all: '35045|35039',
    county: 'San Juan',
    county_names_all: 'San Juan|Rio Arriba',
    county_weights: '{"35045": 96.72, "35039": 3.28}',
    density: 1.5,
    imprecise: false,
    latitude: 36.18392,
    longitude: -107.78087,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87037',
  },
  {
    city: 'New Laguna',
    county_fips: 35006,
    county_fips_all: '35006',
    county: 'Cibola',
    county_names_all: 'Cibola',
    county_weights: '{"35006": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 35.0944,
    longitude: -107.43259,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87038',
  },
  {
    city: 'Paguate',
    county_fips: 35006,
    county_fips_all: '35006',
    county: 'Cibola',
    county_names_all: 'Cibola',
    county_weights: '{"35006": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 35.14192,
    longitude: -107.39887,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87040',
  },
  {
    city: 'Pena Blanca',
    county_fips: 35043,
    county_fips_all: '35043',
    county: 'Sandoval',
    county_names_all: 'Sandoval',
    county_weights: '{"35043": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 35.60202,
    longitude: -106.31054,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87041',
  },
  {
    city: 'Peralta',
    county_fips: 35061,
    county_fips_all: '35061',
    county: 'Valencia',
    county_names_all: 'Valencia',
    county_weights: '{"35061": 100}',
    density: 292.7,
    imprecise: false,
    latitude: 34.82827,
    longitude: -106.68619,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87042',
  },
  {
    city: 'Placitas',
    county_fips: 35043,
    county_fips_all: '35043',
    county: 'Sandoval',
    county_names_all: 'Sandoval',
    county_weights: '{"35043": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 35.28978,
    longitude: -106.44418,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87043',
  },
  {
    city: 'Ponderosa',
    county_fips: 35043,
    county_fips_all: '35043',
    county: 'Sandoval',
    county_names_all: 'Sandoval',
    county_weights: '{"35043": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 35.71254,
    longitude: -106.65652,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87044',
  },
  {
    city: 'Prewitt',
    county_fips: 35031,
    county_fips_all: '35031|35006',
    county: 'McKinley',
    county_names_all: 'McKinley|Cibola',
    county_weights: '{"35031": 98.32, "35006": 1.68}',
    density: 6.3,
    imprecise: false,
    latitude: 35.40018,
    longitude: -108.00182,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87045',
  },
  {
    city: 'Regina',
    county_fips: 35039,
    county_fips_all: '35039|35043',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba|Sandoval',
    county_weights: '{"35039": 78.49, "35043": 21.51}',
    density: 0.4,
    imprecise: false,
    latitude: 36.27773,
    longitude: -106.91643,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87046',
  },
  {
    city: 'Sandia Park',
    county_fips: 35043,
    county_fips_all: '35043|35049|35001',
    county: 'Sandoval',
    county_names_all: 'Sandoval|Santa Fe|Bernalillo',
    county_weights: '{"35043": 41.52, "35049": 29.85, "35001": 28.63}',
    density: 15,
    imprecise: false,
    latitude: 35.24866,
    longitude: -106.27629,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87047',
  },
  {
    city: 'Corrales',
    county_fips: 35043,
    county_fips_all: '35043|35001',
    county: 'Sandoval',
    county_names_all: 'Sandoval|Bernalillo',
    county_weights: '{"35043": 98.15, "35001": 1.85}',
    density: 318.6,
    imprecise: false,
    latitude: 35.23624,
    longitude: -106.61977,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87048',
  },
  {
    city: 'San Fidel',
    county_fips: 35006,
    county_fips_all: '35006',
    county: 'Cibola',
    county_names_all: 'Cibola',
    county_weights: '{"35006": 100}',
    density: 1,
    imprecise: false,
    latitude: 35.11699,
    longitude: -107.61026,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 79,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87049',
  },
  {
    city: 'San Rafael',
    county_fips: 35006,
    county_fips_all: '35006',
    county: 'Cibola',
    county_names_all: 'Cibola',
    county_weights: '{"35006": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 35.06188,
    longitude: -107.85426,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87051',
  },
  {
    city: 'Santo Domingo Pueblo',
    county_fips: 35043,
    county_fips_all: '35043',
    county: 'Sandoval',
    county_names_all: 'Sandoval',
    county_weights: '{"35043": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 35.52867,
    longitude: -106.36935,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87052',
  },
  {
    city: 'San Ysidro',
    county_fips: 35043,
    county_fips_all: '35043',
    county: 'Sandoval',
    county_names_all: 'Sandoval',
    county_weights: '{"35043": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 35.57537,
    longitude: -106.87832,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87053',
  },
  {
    city: 'Stanley',
    county_fips: 35049,
    county_fips_all: '35049|35047',
    county: 'Santa Fe',
    county_names_all: 'Santa Fe|San Miguel',
    county_weights: '{"35049": 86.4, "35047": 13.6}',
    density: 1,
    imprecise: false,
    latitude: 35.16197,
    longitude: -105.89566,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87056',
  },
  {
    city: 'Tijeras',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 27.9,
    imprecise: false,
    latitude: 34.99647,
    longitude: -106.29764,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87059',
  },
  {
    city: 'Tome',
    county_fips: 35061,
    county_fips_all: '35061',
    county: 'Valencia',
    county_names_all: 'Valencia',
    county_weights: '{"35061": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 34.74292,
    longitude: -106.73571,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87060',
  },
  {
    city: 'Torreon',
    county_fips: 35057,
    county_fips_all: '35057',
    county: 'Torrance',
    county_names_all: 'Torrance',
    county_weights: '{"35057": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 34.705,
    longitude: -106.38145,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87061',
  },
  {
    city: 'Veguita',
    county_fips: 35053,
    county_fips_all: '35053|35061',
    county: 'Socorro',
    county_names_all: 'Socorro|Valencia',
    county_weights: '{"35053": 99.32, "35061": 0.68}',
    density: 8.7,
    imprecise: false,
    latitude: 34.46187,
    longitude: -106.69719,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1922,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87062',
  },
  {
    city: 'Willard',
    county_fips: 35057,
    county_fips_all: '35057',
    county: 'Torrance',
    county_names_all: 'Torrance',
    county_weights: '{"35057": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 34.49265,
    longitude: -105.85432,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87063',
  },
  {
    city: 'Youngsville',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 36.1849,
    longitude: -106.53923,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87064',
  },
  {
    city: 'Bosque Farms',
    county_fips: 35001,
    county_fips_all: '35001|35061',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo|Valencia',
    county_weights: '{"35001": 53.54, "35061": 46.46}',
    density: 56.4,
    imprecise: false,
    latitude: 34.90354,
    longitude: -106.64321,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87068',
  },
  {
    city: 'Cochiti Pueblo',
    county_fips: 35043,
    county_fips_all: '35043',
    county: 'Sandoval',
    county_names_all: 'Sandoval',
    county_weights: '{"35043": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 35.60828,
    longitude: -106.3955,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87072',
  },
  {
    city: 'Cochiti Lake',
    county_fips: 35043,
    county_fips_all: '35043',
    county: 'Sandoval',
    county_names_all: 'Sandoval',
    county_weights: '{"35043": 100}',
    density: 17,
    imprecise: false,
    latitude: 35.64496,
    longitude: -106.36366,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87083',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 1190.6,
    imprecise: false,
    latitude: 35.08116,
    longitude: -106.64636,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 20123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87102',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 1181,
    imprecise: false,
    latitude: 35.10278,
    longitude: -106.67492,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87104',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 522.6,
    imprecise: false,
    latitude: 34.99512,
    longitude: -106.68644,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 54367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87105',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 290.6,
    imprecise: false,
    latitude: 35.00818,
    longitude: -106.61185,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 26953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87106',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 726.6,
    imprecise: false,
    latitude: 35.13747,
    longitude: -106.64363,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 27566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87107',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 2386.4,
    imprecise: false,
    latitude: 35.07235,
    longitude: -106.57835,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 36331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87108',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 1520.9,
    imprecise: false,
    latitude: 35.15285,
    longitude: -106.57543,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 39324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87109',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 1746.8,
    imprecise: false,
    latitude: 35.10812,
    longitude: -106.57816,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 39685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87110',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 1735.4,
    imprecise: false,
    latitude: 35.13824,
    longitude: -106.51589,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 57085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87111',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 2101.6,
    imprecise: false,
    latitude: 35.10093,
    longitude: -106.51622,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87112',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 417,
    imprecise: false,
    latitude: 35.19249,
    longitude: -106.5708,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87113',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 1293.1,
    imprecise: false,
    latitude: 35.19718,
    longitude: -106.68216,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 70117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87114',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 254.2,
    imprecise: false,
    latitude: 35.05056,
    longitude: -106.56028,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87116',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 442.8,
    imprecise: false,
    latitude: 35.14097,
    longitude: -106.76522,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 66097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87120',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 86.5,
    imprecise: false,
    latitude: 35.01031,
    longitude: -106.87816,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 75510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87121',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001|35043',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo|Sandoval',
    county_weights: '{"35001": 97.27, "35043": 2.73}',
    density: 330.7,
    imprecise: false,
    latitude: 35.18685,
    longitude: -106.48827,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87122',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 565.4,
    imprecise: false,
    latitude: 35.06206,
    longitude: -106.46991,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 42252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87123',
  },
  {
    city: 'Rio Rancho',
    county_fips: 35043,
    county_fips_all: '35043',
    county: 'Sandoval',
    county_names_all: 'Sandoval',
    county_weights: '{"35043": 100}',
    density: 289.8,
    imprecise: false,
    latitude: 35.27144,
    longitude: -106.79627,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 58499,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87124',
  },
  {
    city: 'Rio Rancho',
    county_fips: 35043,
    county_fips_all: '35043',
    county: 'Sandoval',
    county_names_all: 'Sandoval',
    county_weights: '{"35043": 100}',
    density: 199.4,
    imprecise: false,
    latitude: 35.33074,
    longitude: -106.71248,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 51837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87144',
  },
  {
    city: 'Gallup',
    county_fips: 35031,
    county_fips_all: '35031',
    county: 'McKinley',
    county_names_all: 'McKinley',
    county_weights: '{"35031": 100}',
    density: 212.7,
    imprecise: false,
    latitude: 35.52153,
    longitude: -108.76524,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 21755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87301',
  },
  {
    city: 'Gallup',
    county_fips: 35031,
    county_fips_all: '35031',
    county: 'McKinley',
    county_names_all: 'McKinley',
    county_weights: '{"35031": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 35.40327,
    longitude: -108.73151,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87305',
  },
  {
    city: 'Brimhall',
    county_fips: 35031,
    county_fips_all: '35031',
    county: 'McKinley',
    county_names_all: 'McKinley',
    county_weights: '{"35031": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 35.75365,
    longitude: -108.60267,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87310',
  },
  {
    city: 'Church Rock',
    county_fips: 35031,
    county_fips_all: '35031',
    county: 'McKinley',
    county_names_all: 'McKinley',
    county_weights: '{"35031": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 35.60501,
    longitude: -108.50061,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87311',
  },
  {
    city: 'Continental Divide',
    county_fips: 35031,
    county_fips_all: '35031',
    county: 'McKinley',
    county_names_all: 'McKinley',
    county_weights: '{"35031": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 35.4291,
    longitude: -108.34543,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 654,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87312',
  },
  {
    city: 'Crownpoint',
    county_fips: 35031,
    county_fips_all: '35031|35045',
    county: 'McKinley',
    county_names_all: 'McKinley|San Juan',
    county_weights: '{"35031": 88.9, "35045": 11.1}',
    density: 2.8,
    imprecise: false,
    latitude: 35.79538,
    longitude: -108.22129,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87313',
  },
  {
    city: 'Fence Lake',
    county_fips: 35006,
    county_fips_all: '35006',
    county: 'Cibola',
    county_names_all: 'Cibola',
    county_weights: '{"35006": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 34.66247,
    longitude: -108.55075,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87315',
  },
  {
    city: 'Fort Wingate',
    county_fips: 35031,
    county_fips_all: '35031',
    county: 'McKinley',
    county_names_all: 'McKinley',
    county_weights: '{"35031": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 35.48684,
    longitude: -108.53328,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87316',
  },
  {
    city: 'Gamerco',
    county_fips: 35031,
    county_fips_all: '35031',
    county: 'McKinley',
    county_names_all: 'McKinley',
    county_weights: '{"35031": 100}',
    density: 52,
    imprecise: false,
    latitude: 35.58024,
    longitude: -108.75244,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87317',
  },
  {
    city: 'Ramah',
    county_fips: 35006,
    county_fips_all: '35006|35031',
    county: 'Cibola',
    county_names_all: 'Cibola|McKinley',
    county_weights: '{"35006": 70.2, "35031": 29.8}',
    density: 1.7,
    imprecise: false,
    latitude: 35.06791,
    longitude: -108.40638,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87321',
  },
  {
    city: 'Rehoboth',
    county_fips: 35031,
    county_fips_all: '35031',
    county: 'McKinley',
    county_names_all: 'McKinley',
    county_weights: '{"35031": 100}',
    density: 12.6,
    imprecise: false,
    latitude: 35.48531,
    longitude: -108.66253,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87322',
  },
  {
    city: 'Thoreau',
    county_fips: 35031,
    county_fips_all: '35031|35006',
    county: 'McKinley',
    county_names_all: 'McKinley|Cibola',
    county_weights: '{"35031": 85.47, "35006": 14.53}',
    density: 5.6,
    imprecise: false,
    latitude: 35.45214,
    longitude: -108.17531,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87323',
  },
  {
    city: 'Tohatchi',
    county_fips: 35031,
    county_fips_all: '35031|35045',
    county: 'McKinley',
    county_names_all: 'McKinley|San Juan',
    county_weights: '{"35031": 61.43, "35045": 38.57}',
    density: 1.7,
    imprecise: false,
    latitude: 35.97495,
    longitude: -108.58746,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87325',
  },
  {
    city: 'Zuni',
    county_fips: 35031,
    county_fips_all: '35031|35006',
    county: 'McKinley',
    county_names_all: 'McKinley|Cibola',
    county_weights: '{"35031": 86.01, "35006": 13.99}',
    density: 7.3,
    imprecise: false,
    latitude: 35.06529,
    longitude: -108.77813,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87327',
  },
  {
    city: 'Navajo',
    county_fips: 4001,
    county_fips_all: '04001|35031|35045',
    county: 'Apache',
    county_names_all: 'Apache|McKinley|San Juan',
    county_weights: '{"04001": 38.7, "35031": 31.58, "35045": 29.72}',
    density: 3.3,
    imprecise: false,
    latitude: 36.02541,
    longitude: -109.03638,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87328',
  },
  {
    city: 'Jamestown',
    county_fips: 35031,
    county_fips_all: '35031',
    county: 'McKinley',
    county_names_all: 'McKinley',
    county_weights: '{"35031": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 35.38502,
    longitude: -108.47052,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87347',
  },
  {
    city: 'Pinehill',
    county_fips: 35006,
    county_fips_all: '35006',
    county: 'Cibola',
    county_names_all: 'Cibola',
    county_weights: '{"35006": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 34.82644,
    longitude: -108.41435,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87357',
  },
  {
    city: 'Sheep Springs',
    county_fips: 35045,
    county_fips_all: '35045',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"35045": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 36.13538,
    longitude: -108.70875,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87364',
  },
  {
    city: 'Smith Lake',
    county_fips: 35031,
    county_fips_all: '35031',
    county: 'McKinley',
    county_names_all: 'McKinley',
    county_weights: '{"35031": 100}',
    density: 113.9,
    imprecise: false,
    latitude: 35.53585,
    longitude: -108.13796,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87365',
  },
  {
    city: 'Yatahey',
    county_fips: 35031,
    county_fips_all: '35031',
    county: 'McKinley',
    county_names_all: 'McKinley',
    county_weights: '{"35031": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 35.66114,
    longitude: -108.79477,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4481,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87375',
  },
  {
    city: 'Farmington',
    county_fips: 35045,
    county_fips_all: '35045',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"35045": 100}',
    density: 131.5,
    imprecise: false,
    latitude: 36.73824,
    longitude: -108.18377,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 45229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87401',
  },
  {
    city: 'Farmington',
    county_fips: 35045,
    county_fips_all: '35045',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"35045": 100}',
    density: 284,
    imprecise: false,
    latitude: 36.79174,
    longitude: -108.14831,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 11418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87402',
  },
  {
    city: 'Aztec',
    county_fips: 35045,
    county_fips_all: '35045',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"35045": 100}',
    density: 21.8,
    imprecise: false,
    latitude: 36.86708,
    longitude: -107.89433,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87410',
  },
  {
    city: 'Blanco',
    county_fips: 35039,
    county_fips_all: '35039|35045',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba|San Juan',
    county_weights: '{"35039": 72.13, "35045": 27.87}',
    density: 0.6,
    imprecise: false,
    latitude: 36.6569,
    longitude: -107.51956,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87412',
  },
  {
    city: 'Bloomfield',
    county_fips: 35045,
    county_fips_all: '35045',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"35045": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 36.45914,
    longitude: -107.96408,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 14296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87413',
  },
  {
    city: 'Flora Vista',
    county_fips: 35045,
    county_fips_all: '35045',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"35045": 100}',
    density: 51.6,
    imprecise: false,
    latitude: 36.82823,
    longitude: -108.10125,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87415',
  },
  {
    city: 'Fruitland',
    county_fips: 35045,
    county_fips_all: '35045',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"35045": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 36.58687,
    longitude: -108.43897,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87416',
  },
  {
    city: 'Kirtland',
    county_fips: 35045,
    county_fips_all: '35045',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"35045": 100}',
    density: 230.1,
    imprecise: false,
    latitude: 36.74456,
    longitude: -108.34551,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87417',
  },
  {
    city: 'La Plata',
    county_fips: 35045,
    county_fips_all: '35045',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"35045": 100}',
    density: 4,
    imprecise: false,
    latitude: 36.94938,
    longitude: -108.14728,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87418',
  },
  {
    city: 'Navajo Dam',
    county_fips: 35045,
    county_fips_all: '35045|35039',
    county: 'San Juan',
    county_names_all: 'San Juan|Rio Arriba',
    county_weights: '{"35045": 52.86, "35039": 47.14}',
    density: 0.7,
    imprecise: false,
    latitude: 36.88767,
    longitude: -107.55195,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87419',
  },
  {
    city: 'Shiprock',
    county_fips: 35045,
    county_fips_all: '35045',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"35045": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 36.72142,
    longitude: -108.84406,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87420',
  },
  {
    city: 'Waterflow',
    county_fips: 35045,
    county_fips_all: '35045',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"35045": 100}',
    density: 17.3,
    imprecise: false,
    latitude: 36.7772,
    longitude: -108.53676,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87421',
  },
  {
    city: 'Newcomb',
    county_fips: 35045,
    county_fips_all: '35045',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"35045": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 36.27109,
    longitude: -108.71936,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87455',
  },
  {
    city: 'Sanostee',
    county_fips: 35045,
    county_fips_all: '35045',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"35045": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 36.43717,
    longitude: -108.91099,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87461',
  },
  {
    city: 'Farmington',
    county_fips: 35045,
    county_fips_all: '35045',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"35045": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 36.32165,
    longitude: -108.24657,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87499',
  },
  {
    city: 'Santa Fe',
    county_fips: 35049,
    county_fips_all: '35049',
    county: 'Santa Fe',
    county_names_all: 'Santa Fe',
    county_weights: '{"35049": 100}',
    density: 122.1,
    imprecise: false,
    latitude: 35.71273,
    longitude: -105.86523,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87501',
  },
  {
    city: 'Santa Fe',
    county_fips: 35049,
    county_fips_all: '35049',
    county: 'Santa Fe',
    county_names_all: 'Santa Fe',
    county_weights: '{"35049": 100}',
    density: 190.3,
    imprecise: false,
    latitude: 35.62307,
    longitude: -105.86891,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 32092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87505',
  },
  {
    city: 'Santa Fe',
    county_fips: 35049,
    county_fips_all: '35049',
    county: 'Santa Fe',
    county_names_all: 'Santa Fe',
    county_weights: '{"35049": 100}',
    density: 20.5,
    imprecise: false,
    latitude: 35.82119,
    longitude: -105.96802,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87506',
  },
  {
    city: 'Santa Fe',
    county_fips: 35049,
    county_fips_all: '35049',
    county: 'Santa Fe',
    county_names_all: 'Santa Fe',
    county_weights: '{"35049": 100}',
    density: 206.5,
    imprecise: false,
    latitude: 35.621,
    longitude: -106.11061,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 51386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87507',
  },
  {
    city: 'Santa Fe',
    county_fips: 35049,
    county_fips_all: '35049',
    county: 'Santa Fe',
    county_names_all: 'Santa Fe',
    county_weights: '{"35049": 100}',
    density: 42.2,
    imprecise: false,
    latitude: 35.52064,
    longitude: -105.94593,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18518,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87508',
  },
  {
    city: 'Abiquiu',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 36.35906,
    longitude: -106.48312,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87510',
  },
  {
    city: 'Alcalde',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 36.08905,
    longitude: -105.96448,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87511',
  },
  {
    city: 'Amalia',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 36.90885,
    longitude: -105.36515,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87512',
  },
  {
    city: 'Arroyo Hondo',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 8,
    imprecise: false,
    latitude: 36.58367,
    longitude: -105.70121,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87513',
  },
  {
    city: 'Arroyo Seco',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 71.8,
    imprecise: false,
    latitude: 36.52957,
    longitude: -105.60055,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87514',
  },
  {
    city: 'Canjilon',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 36.56257,
    longitude: -106.3696,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87515',
  },
  {
    city: 'Canones',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 36.18116,
    longitude: -106.46149,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 68,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87516',
  },
  {
    city: 'Carson',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 36.39035,
    longitude: -105.79269,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87517',
  },
  {
    city: 'Cebolla',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.51197,
    longitude: -106.54235,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87518',
  },
  {
    city: 'Cerro',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 36.76472,
    longitude: -105.63502,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 798,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87519',
  },
  {
    city: 'Chama',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 36.88419,
    longitude: -106.63552,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87520',
  },
  {
    city: 'Chamisal',
    county_fips: 35039,
    county_fips_all: '35039|35055',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba|Taos',
    county_weights: '{"35039": 66.48, "35055": 33.52}',
    density: 4.8,
    imprecise: false,
    latitude: 36.08506,
    longitude: -105.70477,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87521',
  },
  {
    city: 'Chimayo',
    county_fips: 35049,
    county_fips_all: '35049|35039',
    county: 'Santa Fe',
    county_names_all: 'Santa Fe|Rio Arriba',
    county_weights: '{"35049": 78.94, "35039": 21.06}',
    density: 9.3,
    imprecise: false,
    latitude: 35.96889,
    longitude: -105.84639,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87522',
  },
  {
    city: 'Cordova',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 71.8,
    imprecise: false,
    latitude: 36.01115,
    longitude: -105.86273,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87523',
  },
  {
    city: 'Costilla',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 40.5,
    imprecise: false,
    latitude: 36.96986,
    longitude: -105.5375,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87524',
  },
  {
    city: 'Dixon',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 15,
    imprecise: false,
    latitude: 36.16875,
    longitude: -105.86352,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87527',
  },
  {
    city: 'Dulce',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 36.79432,
    longitude: -106.87989,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87528',
  },
  {
    city: 'El Prado',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 27,
    imprecise: false,
    latitude: 36.45001,
    longitude: -105.66147,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87529',
  },
  {
    city: 'El Rito',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 36.34088,
    longitude: -106.20198,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87530',
  },
  {
    city: 'Embudo',
    county_fips: 35055,
    county_fips_all: '35055|35039',
    county: 'Taos',
    county_names_all: 'Taos|Rio Arriba',
    county_weights: '{"35055": 58.77, "35039": 41.23}',
    density: 1.7,
    imprecise: false,
    latitude: 36.25326,
    longitude: -105.84584,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87531',
  },
  {
    city: 'Espanola',
    county_fips: 35039,
    county_fips_all: '35039|35049',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba|Santa Fe',
    county_weights: '{"35039": 75.12, "35049": 24.88}',
    density: 66.8,
    imprecise: false,
    latitude: 35.97965,
    longitude: -106.1048,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87532',
  },
  {
    city: 'Glorieta',
    county_fips: 35049,
    county_fips_all: '35049|35047',
    county: 'Santa Fe',
    county_names_all: 'Santa Fe|San Miguel',
    county_weights: '{"35049": 92.72, "35047": 7.28}',
    density: 10.8,
    imprecise: false,
    latitude: 35.56675,
    longitude: -105.74719,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87535',
  },
  {
    city: 'Hernandez',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 36.1043,
    longitude: -106.2454,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87537',
  },
  {
    city: 'La Madera',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 36.41192,
    longitude: -106.02393,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87539',
  },
  {
    city: 'Lamy',
    county_fips: 35049,
    county_fips_all: '35049',
    county: 'Santa Fe',
    county_names_all: 'Santa Fe',
    county_weights: '{"35049": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 35.39987,
    longitude: -105.8759,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87540',
  },
  {
    city: 'Los Alamos',
    county_fips: 35043,
    county_fips_all: '35043|35028',
    county: 'Sandoval',
    county_names_all: 'Sandoval|Los Alamos',
    county_weights: '{"35043": 57.73, "35028": 42.27}',
    density: 39.5,
    imprecise: false,
    latitude: 35.7869,
    longitude: -106.31914,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 13598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87544',
  },
  {
    city: 'White Rock',
    county_fips: 35028,
    county_fips_all: '35028',
    county: 'Los Alamos',
    county_names_all: 'Los Alamos',
    county_weights: '{"35028": 100}',
    density: 347.1,
    imprecise: false,
    latitude: 35.81046,
    longitude: -106.20579,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87547',
  },
  {
    city: 'Medanales',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 84.6,
    imprecise: false,
    latitude: 36.1756,
    longitude: -106.18491,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87548',
  },
  {
    city: 'Ojo Caliente',
    county_fips: 35039,
    county_fips_all: '35039|35055',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba|Taos',
    county_weights: '{"35039": 85.0, "35055": 15.0}',
    density: 2.8,
    imprecise: false,
    latitude: 36.23237,
    longitude: -106.0568,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87549',
  },
  {
    city: 'Los Ojos',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 36.6925,
    longitude: -106.66872,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87551',
  },
  {
    city: 'Pecos',
    county_fips: 35047,
    county_fips_all: '35047',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"35047": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 35.67026,
    longitude: -105.61382,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87552',
  },
  {
    city: 'Penasco',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 40.7,
    imprecise: false,
    latitude: 36.20389,
    longitude: -105.72094,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87553',
  },
  {
    city: 'Petaca',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.54573,
    longitude: -106.0633,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87554',
  },
  {
    city: 'Questa',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 4,
    imprecise: false,
    latitude: 36.81848,
    longitude: -105.5575,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3008,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87556',
  },
  {
    city: 'Ranchos De Taos',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 36.28603,
    longitude: -105.6331,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87557',
  },
  {
    city: 'Red River',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 36.67279,
    longitude: -105.40523,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87558',
  },
  {
    city: 'Ribera',
    county_fips: 35047,
    county_fips_all: '35047',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"35047": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 35.22567,
    longitude: -105.50185,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87560',
  },
  {
    city: 'Rowe',
    county_fips: 35047,
    county_fips_all: '35047',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"35047": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 35.40668,
    longitude: -105.65522,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87562',
  },
  {
    city: 'San Cristobal',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 36.61566,
    longitude: -105.61797,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87564',
  },
  {
    city: 'San Jose',
    county_fips: 35047,
    county_fips_all: '35047',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"35047": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 35.4442,
    longitude: -105.49384,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87565',
  },
  {
    city: 'Ohkay Owingeh',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 47.3,
    imprecise: false,
    latitude: 36.07242,
    longitude: -106.07185,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87566',
  },
  {
    city: 'Santa Cruz',
    county_fips: 35049,
    county_fips_all: '35049',
    county: 'Santa Fe',
    county_names_all: 'Santa Fe',
    county_weights: '{"35049": 100}',
    density: 273.3,
    imprecise: false,
    latitude: 35.99401,
    longitude: -106.01872,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87567',
  },
  {
    city: 'Serafina',
    county_fips: 35047,
    county_fips_all: '35047',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"35047": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 35.35026,
    longitude: -105.30509,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87569',
  },
  {
    city: 'Taos',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 28.2,
    imprecise: false,
    latitude: 36.42507,
    longitude: -105.48523,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 11531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87571',
  },
  {
    city: 'Tierra Amarilla',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 36.64203,
    longitude: -106.59341,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87575',
  },
  {
    city: 'Tres Piedras',
    county_fips: 35039,
    county_fips_all: '35039|35055',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba|Taos',
    county_weights: '{"35039": 51.28, "35055": 48.72}',
    density: 0.8,
    imprecise: false,
    latitude: 36.63237,
    longitude: -105.97755,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87577',
  },
  {
    city: 'Truchas',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 36.04392,
    longitude: -105.78539,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87578',
  },
  {
    city: 'Vadito',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 36.12885,
    longitude: -105.56729,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87579',
  },
  {
    city: 'Valdez',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 36.55956,
    longitude: -105.57459,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87580',
  },
  {
    city: 'Vallecitos',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.51531,
    longitude: -106.16017,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87581',
  },
  {
    city: 'Velarde',
    county_fips: 35039,
    county_fips_all: '35039',
    county: 'Rio Arriba',
    county_names_all: 'Rio Arriba',
    county_weights: '{"35039": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 36.15323,
    longitude: -106.00246,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87582',
  },
  {
    city: 'Villanueva',
    county_fips: 35047,
    county_fips_all: '35047',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"35047": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 35.28221,
    longitude: -105.35226,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87583',
  },
  {
    city: 'Las Vegas',
    county_fips: 35047,
    county_fips_all: '35047',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"35047": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 35.53091,
    longitude: -104.94419,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 17339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87701',
  },
  {
    city: 'Angel Fire',
    county_fips: 35007,
    county_fips_all: '35007',
    county: 'Colfax',
    county_names_all: 'Colfax',
    county_weights: '{"35007": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 36.3729,
    longitude: -105.23873,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87710',
  },
  {
    city: 'Anton Chico',
    county_fips: 35047,
    county_fips_all: '35047|35019',
    county: 'San Miguel',
    county_names_all: 'San Miguel|Guadalupe',
    county_weights: '{"35047": 75.32, "35019": 24.68}',
    density: 2.2,
    imprecise: false,
    latitude: 35.22458,
    longitude: -105.14673,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87711',
  },
  {
    city: 'Buena Vista',
    county_fips: 35033,
    county_fips_all: '35033',
    county: 'Mora',
    county_names_all: 'Mora',
    county_weights: '{"35033": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 35.88076,
    longitude: -105.17612,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87712',
  },
  {
    city: 'Chacon',
    county_fips: 35033,
    county_fips_all: '35033',
    county: 'Mora',
    county_names_all: 'Mora',
    county_weights: '{"35033": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 36.1708,
    longitude: -105.36111,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87713',
  },
  {
    city: 'Cimarron',
    county_fips: 35007,
    county_fips_all: '35007',
    county: 'Colfax',
    county_names_all: 'Colfax',
    county_weights: '{"35007": 100}',
    density: 1,
    imprecise: false,
    latitude: 36.4463,
    longitude: -104.99079,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87714',
  },
  {
    city: 'Cleveland',
    county_fips: 35033,
    county_fips_all: '35033',
    county: 'Mora',
    county_names_all: 'Mora',
    county_weights: '{"35033": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 36.01839,
    longitude: -105.42535,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87715',
  },
  {
    city: 'Eagle Nest',
    county_fips: 35007,
    county_fips_all: '35007',
    county: 'Colfax',
    county_names_all: 'Colfax',
    county_weights: '{"35007": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 36.59931,
    longitude: -105.24097,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87718',
  },
  {
    city: 'Guadalupita',
    county_fips: 35033,
    county_fips_all: '35033',
    county: 'Mora',
    county_names_all: 'Mora',
    county_weights: '{"35033": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 36.12837,
    longitude: -105.24424,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87722',
  },
  {
    city: 'Holman',
    county_fips: 35033,
    county_fips_all: '35033',
    county: 'Mora',
    county_names_all: 'Mora',
    county_weights: '{"35033": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 36.05883,
    longitude: -105.37556,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87723',
  },
  {
    city: 'La Loma',
    county_fips: 35019,
    county_fips_all: '35019',
    county: 'Guadalupe',
    county_names_all: 'Guadalupe',
    county_weights: '{"35019": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 35.16044,
    longitude: -104.97133,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87724',
  },
  {
    city: 'Maxwell',
    county_fips: 35007,
    county_fips_all: '35007',
    county: 'Colfax',
    county_names_all: 'Colfax',
    county_weights: '{"35007": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 36.60334,
    longitude: -104.59473,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87728',
  },
  {
    city: 'Mills',
    county_fips: 35021,
    county_fips_all: '35021',
    county: 'Harding',
    county_names_all: 'Harding',
    county_weights: '{"35021": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 36.10704,
    longitude: -104.23485,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87730',
  },
  {
    city: 'Montezuma',
    county_fips: 35047,
    county_fips_all: '35047',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"35047": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 35.70411,
    longitude: -105.39881,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87731',
  },
  {
    city: 'Mora',
    county_fips: 35033,
    county_fips_all: '35033',
    county: 'Mora',
    county_names_all: 'Mora',
    county_weights: '{"35033": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 35.942,
    longitude: -105.47009,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87732',
  },
  {
    city: 'Mosquero',
    county_fips: 35021,
    county_fips_all: '35021',
    county: 'Harding',
    county_names_all: 'Harding',
    county_weights: '{"35021": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 35.77075,
    longitude: -103.82959,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87733',
  },
  {
    city: 'Ocate',
    county_fips: 35033,
    county_fips_all: '35033',
    county: 'Mora',
    county_names_all: 'Mora',
    county_weights: '{"35033": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 36.17323,
    longitude: -105.09363,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87734',
  },
  {
    city: 'Ojo Feliz',
    county_fips: 35033,
    county_fips_all: '35033',
    county: 'Mora',
    county_names_all: 'Mora',
    county_weights: '{"35033": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 36.04867,
    longitude: -105.11978,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87735',
  },
  {
    city: 'Rainsville',
    county_fips: 35033,
    county_fips_all: '35033',
    county: 'Mora',
    county_names_all: 'Mora',
    county_weights: '{"35033": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 35.98431,
    longitude: -105.19238,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87736',
  },
  {
    city: 'Raton',
    county_fips: 35007,
    county_fips_all: '35007',
    county: 'Colfax',
    county_names_all: 'Colfax',
    county_weights: '{"35007": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 36.76707,
    longitude: -104.37953,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87740',
  },
  {
    city: 'Rociada',
    county_fips: 35047,
    county_fips_all: '35047|35033',
    county: 'San Miguel',
    county_names_all: 'San Miguel|Mora',
    county_weights: '{"35047": 58.15, "35033": 41.85}',
    density: 1.8,
    imprecise: false,
    latitude: 35.87161,
    longitude: -105.44427,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87742',
  },
  {
    city: 'Roy',
    county_fips: 35021,
    county_fips_all: '35021',
    county: 'Harding',
    county_names_all: 'Harding',
    county_weights: '{"35021": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 35.96714,
    longitude: -104.01174,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87743',
  },
  {
    city: 'Sapello',
    county_fips: 35047,
    county_fips_all: '35047|35033',
    county: 'San Miguel',
    county_names_all: 'San Miguel|Mora',
    county_weights: '{"35047": 90.45, "35033": 9.55}',
    density: 3.4,
    imprecise: false,
    latitude: 35.7877,
    longitude: -105.26635,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87745',
  },
  {
    city: 'Solano',
    county_fips: 35047,
    county_fips_all: '35047|35021',
    county: 'San Miguel',
    county_names_all: 'San Miguel|Harding',
    county_weights: '{"35047": 94.24, "35021": 5.76}',
    density: 0.1,
    imprecise: false,
    latitude: 35.66271,
    longitude: -104.12715,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87746',
  },
  {
    city: 'Springer',
    county_fips: 35007,
    county_fips_all: '35007',
    county: 'Colfax',
    county_names_all: 'Colfax',
    county_weights: '{"35007": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 36.35856,
    longitude: -104.44472,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87747',
  },
  {
    city: 'Ute Park',
    county_fips: 35007,
    county_fips_all: '35007',
    county: 'Colfax',
    county_names_all: 'Colfax',
    county_weights: '{"35007": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.57827,
    longitude: -105.13028,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87749',
  },
  {
    city: 'Wagon Mound',
    county_fips: 35033,
    county_fips_all: '35033',
    county: 'Mora',
    county_names_all: 'Mora',
    county_weights: '{"35033": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 36.01339,
    longitude: -104.62763,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87752',
  },
  {
    city: 'Watrous',
    county_fips: 35033,
    county_fips_all: '35033',
    county: 'Mora',
    county_names_all: 'Mora',
    county_weights: '{"35033": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 35.85796,
    longitude: -104.95477,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87753',
  },
  {
    city: 'Socorro',
    county_fips: 35053,
    county_fips_all: '35053',
    county: 'Socorro',
    county_names_all: 'Socorro',
    county_weights: '{"35053": 100}',
    density: 20.2,
    imprecise: false,
    latitude: 34.04824,
    longitude: -106.96668,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87801',
  },
  {
    city: 'Aragon',
    county_fips: 35003,
    county_fips_all: '35003',
    county: 'Catron',
    county_names_all: 'Catron',
    county_weights: '{"35003": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 33.90448,
    longitude: -108.55837,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87820',
  },
  {
    city: 'Datil',
    county_fips: 35003,
    county_fips_all: '35003',
    county: 'Catron',
    county_names_all: 'Catron',
    county_weights: '{"35003": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 33.93515,
    longitude: -108.0929,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87821',
  },
  {
    city: 'Lemitar',
    county_fips: 35053,
    county_fips_all: '35053',
    county: 'Socorro',
    county_names_all: 'Socorro',
    county_weights: '{"35053": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 34.18348,
    longitude: -106.95901,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87823',
  },
  {
    city: 'Luna',
    county_fips: 35003,
    county_fips_all: '35003',
    county: 'Catron',
    county_names_all: 'Catron',
    county_weights: '{"35003": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 33.82708,
    longitude: -108.97731,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87824',
  },
  {
    city: 'Magdalena',
    county_fips: 35053,
    county_fips_all: '35053|35003',
    county: 'Socorro',
    county_names_all: 'Socorro|Catron',
    county_weights: '{"35053": 67.6, "35003": 32.4}',
    density: 0.2,
    imprecise: false,
    latitude: 33.94509,
    longitude: -107.6603,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87825',
  },
  {
    city: 'Pie Town',
    county_fips: 35003,
    county_fips_all: '35003',
    county: 'Catron',
    county_names_all: 'Catron',
    county_weights: '{"35003": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 34.36366,
    longitude: -108.12546,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87827',
  },
  {
    city: 'Polvadera',
    county_fips: 35053,
    county_fips_all: '35053',
    county: 'Socorro',
    county_names_all: 'Socorro',
    county_weights: '{"35053": 100}',
    density: 122.4,
    imprecise: false,
    latitude: 34.20567,
    longitude: -106.92056,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87828',
  },
  {
    city: 'Quemado',
    county_fips: 35003,
    county_fips_all: '35003',
    county: 'Catron',
    county_names_all: 'Catron',
    county_weights: '{"35003": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 34.25215,
    longitude: -108.64369,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87829',
  },
  {
    city: 'Reserve',
    county_fips: 35003,
    county_fips_all: '35003',
    county: 'Catron',
    county_names_all: 'Catron',
    county_weights: '{"35003": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 33.70362,
    longitude: -108.73884,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87830',
  },
  {
    city: 'San Acacia',
    county_fips: 35053,
    county_fips_all: '35053',
    county: 'Socorro',
    county_names_all: 'Socorro',
    county_weights: '{"35053": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 34.28303,
    longitude: -106.88722,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87831',
  },
  {
    city: 'San Antonio',
    county_fips: 35053,
    county_fips_all: '35053',
    county: 'Socorro',
    county_names_all: 'Socorro',
    county_weights: '{"35053": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 33.83949,
    longitude: -106.83284,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87832',
  },
  {
    city: 'Truth Or Consequences',
    county_fips: 35051,
    county_fips_all: '35051',
    county: 'Sierra',
    county_names_all: 'Sierra',
    county_weights: '{"35051": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 33.1753,
    longitude: -107.01908,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87901',
  },
  {
    city: 'Arrey',
    county_fips: 35051,
    county_fips_all: '35051',
    county: 'Sierra',
    county_names_all: 'Sierra',
    county_weights: '{"35051": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 32.84962,
    longitude: -107.33762,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87930',
  },
  {
    city: 'Caballo',
    county_fips: 35051,
    county_fips_all: '35051',
    county: 'Sierra',
    county_names_all: 'Sierra',
    county_weights: '{"35051": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 32.93379,
    longitude: -107.33657,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87931',
  },
  {
    city: 'Derry',
    county_fips: 35051,
    county_fips_all: '35051',
    county: 'Sierra',
    county_names_all: 'Sierra',
    county_weights: '{"35051": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.79115,
    longitude: -107.27885,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87933',
  },
  {
    city: 'Elephant Butte',
    county_fips: 35051,
    county_fips_all: '35051',
    county: 'Sierra',
    county_names_all: 'Sierra',
    county_weights: '{"35051": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 33.25423,
    longitude: -107.22903,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87935',
  },
  {
    city: 'Garfield',
    county_fips: 35013,
    county_fips_all: '35013|35051',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana|Sierra',
    county_weights: '{"35013": 86.5, "35051": 13.5}',
    density: 6.1,
    imprecise: false,
    latitude: 32.7544,
    longitude: -107.26284,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87936',
  },
  {
    city: 'Hatch',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 32.60008,
    longitude: -107.1972,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87937',
  },
  {
    city: 'Monticello',
    county_fips: 35051,
    county_fips_all: '35051',
    county: 'Sierra',
    county_names_all: 'Sierra',
    county_weights: '{"35051": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 33.40339,
    longitude: -107.36566,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87939',
  },
  {
    city: 'Rincon',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 32.60986,
    longitude: -106.99465,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87940',
  },
  {
    city: 'Salem',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 48.4,
    imprecise: false,
    latitude: 32.7055,
    longitude: -107.21424,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87941',
  },
  {
    city: 'Williamsburg',
    county_fips: 35051,
    county_fips_all: '35051',
    county: 'Sierra',
    county_names_all: 'Sierra',
    county_weights: '{"35051": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 33.09447,
    longitude: -107.42951,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87942',
  },
  {
    city: 'Winston',
    county_fips: 35051,
    county_fips_all: '35051|35053|35003',
    county: 'Sierra',
    county_names_all: 'Sierra|Socorro|Catron',
    county_weights: '{"35051": 45.18, "35053": 37.19, "35003": 17.64}',
    density: 0,
    imprecise: false,
    latitude: 33.44312,
    longitude: -107.6817,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87943',
  },
  {
    city: 'Las Cruces',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 1312.1,
    imprecise: false,
    latitude: 32.29026,
    longitude: -106.75318,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 37690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88001',
  },
  {
    city: 'White Sands Missile Range',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 32.38275,
    longitude: -106.45804,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88002',
  },
  {
    city: 'Las Cruces',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 314.7,
    imprecise: false,
    latitude: 32.27868,
    longitude: -106.74566,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88003',
  },
  {
    city: 'Las Cruces',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 1973.3,
    imprecise: false,
    latitude: 32.25022,
    longitude: -106.94908,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88004',
  },
  {
    city: 'Las Cruces',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 70.4,
    imprecise: false,
    latitude: 32.22757,
    longitude: -106.99027,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 27509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88005',
  },
  {
    city: 'Las Cruces',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 30.9,
    imprecise: false,
    latitude: 32.37103,
    longitude: -106.9984,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 26254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88007',
  },
  {
    city: 'Santa Teresa',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 60.4,
    imprecise: false,
    latitude: 31.81867,
    longitude: -106.74188,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88008',
  },
  {
    city: 'Las Cruces',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 50.7,
    imprecise: false,
    latitude: 32.39533,
    longitude: -106.58519,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 33064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88011',
  },
  {
    city: 'Las Cruces',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 36.7,
    imprecise: false,
    latitude: 32.58898,
    longitude: -106.77135,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 33158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88012',
  },
  {
    city: 'Animas',
    county_fips: 35023,
    county_fips_all: '35023',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"35023": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 31.78203,
    longitude: -108.82192,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88020',
  },
  {
    city: 'Anthony',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 31.97338,
    longitude: -106.81639,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88021',
  },
  {
    city: 'Bayard',
    county_fips: 35017,
    county_fips_all: '35017',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"35017": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 32.71106,
    longitude: -108.07749,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88023',
  },
  {
    city: 'Buckhorn',
    county_fips: 35017,
    county_fips_all: '35017',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"35017": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 33.10087,
    longitude: -108.71984,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88025',
  },
  {
    city: 'Santa Clara',
    county_fips: 35017,
    county_fips_all: '35017',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"35017": 100}',
    density: 131.4,
    imprecise: false,
    latitude: 32.75833,
    longitude: -108.15741,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88026',
  },
  {
    city: 'Chamberino',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 110.4,
    imprecise: false,
    latitude: 32.03625,
    longitude: -106.68143,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88027',
  },
  {
    city: 'Cliff',
    county_fips: 35017,
    county_fips_all: '35017',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"35017": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 32.95131,
    longitude: -108.67807,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88028',
  },
  {
    city: 'Columbus',
    county_fips: 35029,
    county_fips_all: '35029',
    county: 'Luna',
    county_names_all: 'Luna',
    county_weights: '{"35029": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 31.84339,
    longitude: -107.70225,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88029',
  },
  {
    city: 'Deming',
    county_fips: 35029,
    county_fips_all: '35029',
    county: 'Luna',
    county_names_all: 'Luna',
    county_weights: '{"35029": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 32.19039,
    longitude: -107.72768,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 24413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88030',
  },
  {
    city: 'Faywood',
    county_fips: 35017,
    county_fips_all: '35017|35029',
    county: 'Grant',
    county_names_all: 'Grant|Luna',
    county_weights: '{"35017": 95.45, "35029": 4.55}',
    density: 0.2,
    imprecise: false,
    latitude: 32.58114,
    longitude: -107.96764,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88034',
  },
  {
    city: 'Gila',
    county_fips: 35017,
    county_fips_all: '35017',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"35017": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 33.0722,
    longitude: -108.42625,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88038',
  },
  {
    city: 'Glenwood',
    county_fips: 35003,
    county_fips_all: '35003',
    county: 'Catron',
    county_names_all: 'Catron',
    county_weights: '{"35003": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 33.35081,
    longitude: -108.71909,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88039',
  },
  {
    city: 'Hachita',
    county_fips: 35023,
    county_fips_all: '35023|35017',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo|Grant',
    county_weights: '{"35023": 86.28, "35017": 13.72}',
    density: 0,
    imprecise: false,
    latitude: 31.6197,
    longitude: -108.44025,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88040',
  },
  {
    city: 'Hanover',
    county_fips: 35017,
    county_fips_all: '35017',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"35017": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 32.78367,
    longitude: -107.89654,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88041',
  },
  {
    city: 'Hillsboro',
    county_fips: 35051,
    county_fips_all: '35051',
    county: 'Sierra',
    county_names_all: 'Sierra',
    county_weights: '{"35051": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 32.80979,
    longitude: -107.56385,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88042',
  },
  {
    city: 'Hurley',
    county_fips: 35017,
    county_fips_all: '35017|35029',
    county: 'Grant',
    county_names_all: 'Grant|Luna',
    county_weights: '{"35017": 99.9, "35029": 0.1}',
    density: 6.5,
    imprecise: false,
    latitude: 32.61358,
    longitude: -108.11762,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88043',
  },
  {
    city: 'La Mesa',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 32.01977,
    longitude: -107.08116,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88044',
  },
  {
    city: 'Lordsburg',
    county_fips: 35023,
    county_fips_all: '35023|35017',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo|Grant',
    county_weights: '{"35023": 77.33, "35017": 22.67}',
    density: 0.9,
    imprecise: false,
    latitude: 32.3298,
    longitude: -108.71057,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88045',
  },
  {
    city: 'Mesilla',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 409.4,
    imprecise: false,
    latitude: 32.26797,
    longitude: -106.79674,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88046',
  },
  {
    city: 'Mesilla Park',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 99.4,
    imprecise: false,
    latitude: 32.21444,
    longitude: -106.71556,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88047',
  },
  {
    city: 'Mesquite',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 57.4,
    imprecise: false,
    latitude: 32.14966,
    longitude: -106.6581,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3247,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88048',
  },
  {
    city: 'Mimbres',
    county_fips: 35017,
    county_fips_all: '35017',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"35017": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 33.04814,
    longitude: -108.06782,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88049',
  },
  {
    city: 'Mule Creek',
    county_fips: 35017,
    county_fips_all: '35017',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"35017": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 33.01471,
    longitude: -108.94299,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88051',
  },
  {
    city: 'Organ',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 32.45034,
    longitude: -106.60186,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88052',
  },
  {
    city: 'Rodeo',
    county_fips: 35023,
    county_fips_all: '35023',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"35023": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 31.84062,
    longitude: -109.00295,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88056',
  },
  {
    city: 'Silver City',
    county_fips: 35017,
    county_fips_all: '35017',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"35017": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 32.6211,
    longitude: -108.40888,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 17464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88061',
  },
  {
    city: 'Sunland Park',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 673.7,
    imprecise: false,
    latitude: 31.80715,
    longitude: -106.58259,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88063',
  },
  {
    city: 'Tyrone',
    county_fips: 35017,
    county_fips_all: '35017',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"35017": 100}',
    density: 493.3,
    imprecise: false,
    latitude: 32.71375,
    longitude: -108.30231,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88065',
  },
  {
    city: 'Chaparral',
    county_fips: 35035,
    county_fips_all: '35035|35013',
    county: 'Otero',
    county_names_all: 'Otero|Doña Ana',
    county_weights: '{"35035": 89.75, "35013": 10.25}',
    density: 20.1,
    imprecise: false,
    latitude: 32.24958,
    longitude: -106.28821,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 19663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88081',
  },
  {
    city: 'Clovis',
    county_fips: 35009,
    county_fips_all: '35009|35041',
    county: 'Curry',
    county_names_all: 'Curry|Roosevelt',
    county_weights: '{"35009": 98.89, "35041": 1.11}',
    density: 32.1,
    imprecise: false,
    latitude: 34.50114,
    longitude: -103.26616,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88101',
  },
  {
    city: 'Broadview',
    county_fips: 35009,
    county_fips_all: '35009|35037',
    county: 'Curry',
    county_names_all: 'Curry|Quay',
    county_weights: '{"35009": 66.23, "35037": 33.77}',
    density: 0.4,
    imprecise: false,
    latitude: 34.91023,
    longitude: -103.15863,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88112',
  },
  {
    city: 'Causey',
    county_fips: 35041,
    county_fips_all: '35041',
    county: 'Roosevelt',
    county_names_all: 'Roosevelt',
    county_weights: '{"35041": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 33.81968,
    longitude: -103.08894,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88113',
  },
  {
    city: 'Dora',
    county_fips: 35041,
    county_fips_all: '35041',
    county: 'Roosevelt',
    county_names_all: 'Roosevelt',
    county_weights: '{"35041": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 33.93185,
    longitude: -103.34466,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88115',
  },
  {
    city: 'Elida',
    county_fips: 35041,
    county_fips_all: '35041|35005',
    county: 'Roosevelt',
    county_names_all: 'Roosevelt|Chaves',
    county_weights: '{"35041": 51.26, "35005": 48.74}',
    density: 0.1,
    imprecise: false,
    latitude: 33.89425,
    longitude: -103.82335,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88116',
  },
  {
    city: 'Floyd',
    county_fips: 35041,
    county_fips_all: '35041|35009',
    county: 'Roosevelt',
    county_names_all: 'Roosevelt|Curry',
    county_weights: '{"35041": 82.5, "35009": 17.5}',
    density: 0.7,
    imprecise: false,
    latitude: 34.23626,
    longitude: -103.6645,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88118',
  },
  {
    city: 'Fort Sumner',
    county_fips: 35011,
    county_fips_all: '35011',
    county: 'De Baca',
    county_names_all: 'De Baca',
    county_weights: '{"35011": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 34.34782,
    longitude: -104.40041,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88119',
  },
  {
    city: 'Grady',
    county_fips: 35037,
    county_fips_all: '35037|35009',
    county: 'Quay',
    county_names_all: 'Quay|Curry',
    county_weights: '{"35037": 71.54, "35009": 28.46}',
    density: 0.3,
    imprecise: false,
    latitude: 34.90329,
    longitude: -103.42523,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88120',
  },
  {
    city: 'House',
    county_fips: 35037,
    county_fips_all: '35037',
    county: 'Quay',
    county_names_all: 'Quay',
    county_weights: '{"35037": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 34.67979,
    longitude: -103.97721,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88121',
  },
  {
    city: 'Melrose',
    county_fips: 35009,
    county_fips_all: '35009|35041|35037',
    county: 'Curry',
    county_names_all: 'Curry|Roosevelt|Quay',
    county_weights: '{"35009": 58.24, "35041": 27.72, "35037": 14.04}',
    density: 0.5,
    imprecise: false,
    latitude: 34.52771,
    longitude: -103.6473,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88124',
  },
  {
    city: 'Milnesand',
    county_fips: 35041,
    county_fips_all: '35041',
    county: 'Roosevelt',
    county_names_all: 'Roosevelt',
    county_weights: '{"35041": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.67137,
    longitude: -103.24997,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 5,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88125',
  },
  {
    city: 'Pep',
    county_fips: 35041,
    county_fips_all: '35041',
    county: 'Roosevelt',
    county_names_all: 'Roosevelt',
    county_weights: '{"35041": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.81642,
    longitude: -103.35359,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88126',
  },
  {
    city: 'Portales',
    county_fips: 35041,
    county_fips_all: '35041',
    county: 'Roosevelt',
    county_names_all: 'Roosevelt',
    county_weights: '{"35041": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 34.1285,
    longitude: -103.31825,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 17842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88130',
  },
  {
    city: 'Rogers',
    county_fips: 35041,
    county_fips_all: '35041',
    county: 'Roosevelt',
    county_names_all: 'Roosevelt',
    county_weights: '{"35041": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 33.92382,
    longitude: -103.18855,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88132',
  },
  {
    city: 'Taiban',
    county_fips: 35011,
    county_fips_all: '35011|35041',
    county: 'De Baca',
    county_names_all: 'De Baca|Roosevelt',
    county_weights: '{"35011": 83.72, "35041": 16.28}',
    density: 0.1,
    imprecise: false,
    latitude: 34.37413,
    longitude: -104.00487,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88134',
  },
  {
    city: 'Texico',
    county_fips: 35009,
    county_fips_all: '35009|35041',
    county: 'Curry',
    county_names_all: 'Curry|Roosevelt',
    county_weights: '{"35009": 93.56, "35041": 6.44}',
    density: 4,
    imprecise: false,
    latitude: 34.5623,
    longitude: -103.08204,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88135',
  },
  {
    city: 'Yeso',
    county_fips: 35011,
    county_fips_all: '35011|35027',
    county: 'De Baca',
    county_names_all: 'De Baca|Lincoln',
    county_weights: '{"35011": 67.01, "35027": 32.99}',
    density: 0.1,
    imprecise: false,
    latitude: 34.25356,
    longitude: -104.83347,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88136',
  },
  {
    city: 'Roswell',
    county_fips: 35005,
    county_fips_all: '35005|35027',
    county: 'Chaves',
    county_names_all: 'Chaves|Lincoln',
    county_weights: '{"35005": 86.58, "35027": 13.42}',
    density: 4,
    imprecise: false,
    latitude: 33.66517,
    longitude: -104.48932,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 27524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88201',
  },
  {
    city: 'Roswell',
    county_fips: 35005,
    county_fips_all: '35005',
    county: 'Chaves',
    county_names_all: 'Chaves',
    county_weights: '{"35005": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 33.22169,
    longitude: -104.43904,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 28753,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88203',
  },
  {
    city: 'Artesia',
    county_fips: 35015,
    county_fips_all: '35015',
    county: 'Eddy',
    county_names_all: 'Eddy',
    county_weights: '{"35015": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 32.77272,
    longitude: -104.22567,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88210',
  },
  {
    city: 'Carlsbad',
    county_fips: 35015,
    county_fips_all: '35015',
    county: 'Eddy',
    county_names_all: 'Eddy',
    county_weights: '{"35015": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 32.31421,
    longitude: -104.41732,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 39828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88220',
  },
  {
    city: 'Dexter',
    county_fips: 35005,
    county_fips_all: '35005',
    county: 'Chaves',
    county_names_all: 'Chaves',
    county_weights: '{"35005": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 33.21396,
    longitude: -104.39764,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88230',
  },
  {
    city: 'Eunice',
    county_fips: 35025,
    county_fips_all: '35025',
    county: 'Lea',
    county_names_all: 'Lea',
    county_weights: '{"35025": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 32.42376,
    longitude: -103.26873,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88231',
  },
  {
    city: 'Hagerman',
    county_fips: 35005,
    county_fips_all: '35005',
    county: 'Chaves',
    county_names_all: 'Chaves',
    county_weights: '{"35005": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 33.06398,
    longitude: -104.1568,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88232',
  },
  {
    city: 'Hobbs',
    county_fips: 35025,
    county_fips_all: '35025',
    county: 'Lea',
    county_names_all: 'Lea',
    county_weights: '{"35025": 100}',
    density: 26.7,
    imprecise: false,
    latitude: 32.67285,
    longitude: -103.43454,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 41557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88240',
  },
  {
    city: 'Hobbs',
    county_fips: 35025,
    county_fips_all: '35025',
    county: 'Lea',
    county_names_all: 'Lea',
    county_weights: '{"35025": 100}',
    density: 46.5,
    imprecise: false,
    latitude: 32.81654,
    longitude: -103.16014,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 8472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88242',
  },
  {
    city: 'Hope',
    county_fips: 35005,
    county_fips_all: '35005|35015',
    county: 'Chaves',
    county_names_all: 'Chaves|Eddy',
    county_weights: '{"35005": 65.84, "35015": 34.16}',
    density: 0.1,
    imprecise: false,
    latitude: 32.72882,
    longitude: -104.91851,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88250',
  },
  {
    city: 'Jal',
    county_fips: 35025,
    county_fips_all: '35025',
    county: 'Lea',
    county_names_all: 'Lea',
    county_weights: '{"35025": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 32.16345,
    longitude: -103.39452,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88252',
  },
  {
    city: 'Lake Arthur',
    county_fips: 35005,
    county_fips_all: '35005|35015',
    county: 'Chaves',
    county_names_all: 'Chaves|Eddy',
    county_weights: '{"35005": 74.0, "35015": 26.0}',
    density: 1.6,
    imprecise: false,
    latitude: 32.98767,
    longitude: -104.54852,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88253',
  },
  {
    city: 'Lakewood',
    county_fips: 35015,
    county_fips_all: '35015',
    county: 'Eddy',
    county_names_all: 'Eddy',
    county_weights: '{"35015": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.62876,
    longitude: -104.40779,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88254',
  },
  {
    city: 'Loco Hills',
    county_fips: 35015,
    county_fips_all: '35015',
    county: 'Eddy',
    county_names_all: 'Eddy',
    county_weights: '{"35015": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 32.81091,
    longitude: -103.99923,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88255',
  },
  {
    city: 'Loving',
    county_fips: 35015,
    county_fips_all: '35015',
    county: 'Eddy',
    county_names_all: 'Eddy',
    county_weights: '{"35015": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 32.19543,
    longitude: -103.88924,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88256',
  },
  {
    city: 'Lovington',
    county_fips: 35025,
    county_fips_all: '35025',
    county: 'Lea',
    county_names_all: 'Lea',
    county_weights: '{"35025": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 32.98698,
    longitude: -103.39801,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 15160,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88260',
  },
  {
    city: 'Malaga',
    county_fips: 35015,
    county_fips_all: '35015',
    county: 'Eddy',
    county_names_all: 'Eddy',
    county_weights: '{"35015": 100}',
    density: 1,
    imprecise: false,
    latitude: 32.09091,
    longitude: -104.09006,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88263',
  },
  {
    city: 'Maljamar',
    county_fips: 35025,
    county_fips_all: '35025',
    county: 'Lea',
    county_names_all: 'Lea',
    county_weights: '{"35025": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.86351,
    longitude: -103.70089,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88264',
  },
  {
    city: 'Monument',
    county_fips: 35025,
    county_fips_all: '35025',
    county: 'Lea',
    county_names_all: 'Lea',
    county_weights: '{"35025": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 32.58421,
    longitude: -103.34642,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88265',
  },
  {
    city: 'Tatum',
    county_fips: 35025,
    county_fips_all: '35025',
    county: 'Lea',
    county_names_all: 'Lea',
    county_weights: '{"35025": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 33.30983,
    longitude: -103.39329,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88267',
  },
  {
    city: 'Whites City',
    county_fips: 35015,
    county_fips_all: '35015',
    county: 'Eddy',
    county_names_all: 'Eddy',
    county_weights: '{"35015": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.17632,
    longitude: -104.37939,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88268',
  },
  {
    city: 'Carrizozo',
    county_fips: 35027,
    county_fips_all: '35027|35053',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Socorro',
    county_weights: '{"35027": 97.69, "35053": 2.31}',
    density: 0.5,
    imprecise: false,
    latitude: 33.7494,
    longitude: -105.85191,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88301',
  },
  {
    city: 'Alamogordo',
    county_fips: 35035,
    county_fips_all: '35035',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"35035": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 32.71809,
    longitude: -106.07231,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 36983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88310',
  },
  {
    city: 'Alamogordo',
    county_fips: 35035,
    county_fips_all: '35035',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"35035": 100}',
    density: 79.9,
    imprecise: false,
    latitude: 32.80689,
    longitude: -105.98875,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88311',
  },
  {
    city: 'Alto',
    county_fips: 35027,
    county_fips_all: '35027',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"35027": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 33.43186,
    longitude: -105.64397,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88312',
  },
  {
    city: 'Bent',
    county_fips: 35035,
    county_fips_all: '35035',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"35035": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 33.10061,
    longitude: -105.86725,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88314',
  },
  {
    city: 'Capitan',
    county_fips: 35027,
    county_fips_all: '35027',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"35027": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 33.77306,
    longitude: -105.36895,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88316',
  },
  {
    city: 'Cloudcroft',
    county_fips: 35035,
    county_fips_all: '35035',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"35035": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 32.86081,
    longitude: -105.67442,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88317',
  },
  {
    city: 'Corona',
    county_fips: 35027,
    county_fips_all: '35027|35057',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Torrance',
    county_weights: '{"35027": 69.82, "35057": 30.18}',
    density: 0.1,
    imprecise: false,
    latitude: 34.22491,
    longitude: -105.44166,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88318',
  },
  {
    city: 'Encino',
    county_fips: 35057,
    county_fips_all: '35057|35019|35047',
    county: 'Torrance',
    county_names_all: 'Torrance|Guadalupe|San Miguel',
    county_weights: '{"35057": 87.92, "35019": 9.48, "35047": 2.6}',
    density: 0.2,
    imprecise: false,
    latitude: 34.76815,
    longitude: -105.45564,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88321',
  },
  {
    city: 'Glencoe',
    county_fips: 35027,
    county_fips_all: '35027',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"35027": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 33.38666,
    longitude: -105.47268,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88324',
  },
  {
    city: 'High Rolls Mountain Park',
    county_fips: 35035,
    county_fips_all: '35035',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"35035": 100}',
    density: 5,
    imprecise: false,
    latitude: 32.8529,
    longitude: -105.86027,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88325',
  },
  {
    city: 'Holloman Air Force Base',
    county_fips: 35035,
    county_fips_all: '35035',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"35035": 100}',
    density: 66.8,
    imprecise: false,
    latitude: 32.87046,
    longitude: -106.09951,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88330',
  },
  {
    city: 'Hondo',
    county_fips: 35027,
    county_fips_all: '35027',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"35027": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 33.31883,
    longitude: -105.28552,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88336',
  },
  {
    city: 'La Luz',
    county_fips: 35035,
    county_fips_all: '35035',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"35035": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 32.99141,
    longitude: -105.89025,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88337',
  },
  {
    city: 'Lincoln',
    county_fips: 35027,
    county_fips_all: '35027',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"35027": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 33.53723,
    longitude: -105.38468,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88338',
  },
  {
    city: 'Mayhill',
    county_fips: 35005,
    county_fips_all: '35005|35035',
    county: 'Chaves',
    county_names_all: 'Chaves|Otero',
    county_weights: '{"35005": 59.4, "35035": 40.6}',
    density: 0.7,
    imprecise: false,
    latitude: 32.9561,
    longitude: -105.32141,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88339',
  },
  {
    city: 'Mescalero',
    county_fips: 35035,
    county_fips_all: '35035',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"35035": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 33.17859,
    longitude: -105.61211,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88340',
  },
  {
    city: 'Nogal',
    county_fips: 35027,
    county_fips_all: '35027',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"35027": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 33.50811,
    longitude: -105.79161,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88341',
  },
  {
    city: 'Orogrande',
    county_fips: 35035,
    county_fips_all: '35035',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"35035": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 32.38926,
    longitude: -106.10469,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88342',
  },
  {
    city: 'Picacho',
    county_fips: 35027,
    county_fips_all: '35027',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"35027": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 33.23504,
    longitude: -105.06772,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88343',
  },
  {
    city: 'Pinon',
    county_fips: 35035,
    county_fips_all: '35035|35005',
    county: 'Otero',
    county_names_all: 'Otero|Chaves',
    county_weights: '{"35035": 69.87, "35005": 30.13}',
    density: 0,
    imprecise: false,
    latitude: 32.5105,
    longitude: -105.2235,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88344',
  },
  {
    city: 'Ruidoso',
    county_fips: 35027,
    county_fips_all: '35027',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"35027": 100}',
    density: 76.9,
    imprecise: false,
    latitude: 33.35127,
    longitude: -105.67092,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88345',
  },
  {
    city: 'Ruidoso Downs',
    county_fips: 35027,
    county_fips_all: '35027',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"35027": 100}',
    density: 23.6,
    imprecise: false,
    latitude: 33.34814,
    longitude: -105.54073,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88346',
  },
  {
    city: 'Sacramento',
    county_fips: 35035,
    county_fips_all: '35035',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"35035": 100}',
    density: 1,
    imprecise: false,
    latitude: 32.72757,
    longitude: -105.64704,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88347',
  },
  {
    city: 'San Patricio',
    county_fips: 35027,
    county_fips_all: '35027',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"35027": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 33.41675,
    longitude: -105.39858,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88348',
  },
  {
    city: 'Sunspot',
    county_fips: 35035,
    county_fips_all: '35035',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"35035": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.795,
    longitude: -105.80313,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88349',
  },
  {
    city: 'Tinnie',
    county_fips: 35027,
    county_fips_all: '35027',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"35027": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 33.47154,
    longitude: -105.09777,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88351',
  },
  {
    city: 'Tularosa',
    county_fips: 35035,
    county_fips_all: '35035',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"35035": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 33.18745,
    longitude: -106.00712,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 4124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88352',
  },
  {
    city: 'Vaughn',
    county_fips: 35019,
    county_fips_all: '35019',
    county: 'Guadalupe',
    county_names_all: 'Guadalupe',
    county_weights: '{"35019": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 34.49912,
    longitude: -105.1034,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88353',
  },
  {
    city: 'Weed',
    county_fips: 35035,
    county_fips_all: '35035',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"35035": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 32.73771,
    longitude: -105.49297,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88354',
  },
  {
    city: 'Ruidoso',
    county_fips: 35027,
    county_fips_all: '35027',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"35027": 100}',
    density: 521.2,
    imprecise: false,
    latitude: 33.36288,
    longitude: -105.6694,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88355',
  },
  {
    city: 'Tucumcari',
    county_fips: 35037,
    county_fips_all: '35037|35047',
    county: 'Quay',
    county_names_all: 'Quay|San Miguel',
    county_weights: '{"35037": 90.24, "35047": 9.76}',
    density: 2.7,
    imprecise: false,
    latitude: 35.08984,
    longitude: -103.80942,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88401',
  },
  {
    city: 'Amistad',
    county_fips: 35059,
    county_fips_all: '35059|35021',
    county: 'Union',
    county_names_all: 'Union|Harding',
    county_weights: '{"35059": 61.53, "35021": 38.47}',
    density: 0,
    imprecise: false,
    latitude: 35.90263,
    longitude: -103.30767,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88410',
  },
  {
    city: 'Bard',
    county_fips: 35037,
    county_fips_all: '35037',
    county: 'Quay',
    county_names_all: 'Quay',
    county_weights: '{"35037": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 35.23488,
    longitude: -103.16248,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88411',
  },
  {
    city: 'Capulin',
    county_fips: 35007,
    county_fips_all: '35007|35059',
    county: 'Colfax',
    county_names_all: 'Colfax|Union',
    county_weights: '{"35007": 67.36, "35059": 32.64}',
    density: 3,
    imprecise: false,
    latitude: 36.77484,
    longitude: -104.02073,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88414',
  },
  {
    city: 'Clayton',
    county_fips: 35059,
    county_fips_all: '35059|35021',
    county: 'Union',
    county_names_all: 'Union|Harding',
    county_weights: '{"35059": 84.34, "35021": 15.66}',
    density: 0.9,
    imprecise: false,
    latitude: 36.35171,
    longitude: -103.32643,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88415',
  },
  {
    city: 'Conchas Dam',
    county_fips: 35047,
    county_fips_all: '35047',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"35047": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 35.44255,
    longitude: -104.21511,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 282,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88416',
  },
  {
    city: 'Cuervo',
    county_fips: 35019,
    county_fips_all: '35019|35037',
    county: 'Guadalupe',
    county_names_all: 'Guadalupe|Quay',
    county_weights: '{"35019": 81.46, "35037": 18.54}',
    density: 0.1,
    imprecise: false,
    latitude: 34.93076,
    longitude: -104.25309,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88417',
  },
  {
    city: 'Des Moines',
    county_fips: 35059,
    county_fips_all: '35059',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"35059": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 36.74995,
    longitude: -103.63874,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88418',
  },
  {
    city: 'Folsom',
    county_fips: 35059,
    county_fips_all: '35059',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"35059": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.91839,
    longitude: -103.54734,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88419',
  },
  {
    city: 'Garita',
    county_fips: 35047,
    county_fips_all: '35047',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"35047": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.32691,
    longitude: -104.49731,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88421',
  },
  {
    city: 'Gladstone',
    county_fips: 35059,
    county_fips_all: '35059|35007',
    county: 'Union',
    county_names_all: 'Union|Colfax',
    county_weights: '{"35059": 64.48, "35007": 35.52}',
    density: 0.2,
    imprecise: false,
    latitude: 36.33791,
    longitude: -103.98655,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88422',
  },
  {
    city: 'Grenville',
    county_fips: 35059,
    county_fips_all: '35059',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"35059": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.43714,
    longitude: -103.6554,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88424',
  },
  {
    city: 'Logan',
    county_fips: 35021,
    county_fips_all: '35021|35037|35047',
    county: 'Harding',
    county_names_all: 'Harding|Quay|San Miguel',
    county_weights: '{"35021": 65.38, "35037": 31.51, "35047": 3.11}',
    density: 0.4,
    imprecise: false,
    latitude: 35.52366,
    longitude: -103.47607,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88426',
  },
  {
    city: 'Mcalister',
    county_fips: 35037,
    county_fips_all: '35037',
    county: 'Quay',
    county_names_all: 'Quay',
    county_weights: '{"35037": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 34.78172,
    longitude: -103.76417,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88427',
  },
  {
    city: 'Nara Visa',
    county_fips: 35037,
    county_fips_all: '35037|35059|48359',
    county: 'Quay',
    county_names_all: 'Quay|Union|Oldham',
    county_weights: '{"35037": 71.89, "35059": 25.48, "48359": 2.63}',
    density: 0.2,
    imprecise: false,
    latitude: 35.65348,
    longitude: -103.21357,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88430',
  },
  {
    city: 'Newkirk',
    county_fips: 35019,
    county_fips_all: '35019|35047',
    county: 'Guadalupe',
    county_names_all: 'Guadalupe|San Miguel',
    county_weights: '{"35019": 57.52, "35047": 42.48}',
    density: 0.4,
    imprecise: false,
    latitude: 35.21256,
    longitude: -104.33677,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88431',
  },
  {
    city: 'San Jon',
    county_fips: 35037,
    county_fips_all: '35037',
    county: 'Quay',
    county_names_all: 'Quay',
    county_weights: '{"35037": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 35.12367,
    longitude: -103.34013,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88434',
  },
  {
    city: 'Santa Rosa',
    county_fips: 35019,
    county_fips_all: '35019',
    county: 'Guadalupe',
    county_names_all: 'Guadalupe',
    county_weights: '{"35019": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 34.90262,
    longitude: -104.8133,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88435',
  },
  {
    city: 'Sedan',
    county_fips: 35059,
    county_fips_all: '35059',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"35059": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 36.14965,
    longitude: -103.13345,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 25,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88436',
  },
  {
    city: 'Trementina',
    county_fips: 35047,
    county_fips_all: '35047',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"35047": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.48908,
    longitude: -104.35627,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88439',
  },
  {
    city: 'Alamo',
    county_fips: 32017,
    county_fips_all: '32017',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"32017": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 37.40035,
    longitude: -115.39564,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89001',
  },
  {
    city: 'Henderson',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1675.6,
    imprecise: false,
    latitude: 35.99846,
    longitude: -114.96181,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89002',
  },
  {
    city: 'Beatty',
    county_fips: 32023,
    county_fips_all: '32023',
    county: 'Nye',
    county_names_all: 'Nye',
    county_weights: '{"32023": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 36.94925,
    longitude: -116.7331,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89003',
  },
  {
    city: 'Blue Diamond',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 20.6,
    imprecise: false,
    latitude: 36.04164,
    longitude: -115.41261,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89004',
  },
  {
    city: 'Boulder City',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 62.6,
    imprecise: false,
    latitude: 36.00875,
    longitude: -114.84805,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89005',
  },
  {
    city: 'Bunkerville',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 36.68605,
    longitude: -114.22915,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89007',
  },
  {
    city: 'Caliente',
    county_fips: 32017,
    county_fips_all: '32017',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"32017": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 37.26441,
    longitude: -114.50414,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89008',
  },
  {
    city: 'Dyer',
    county_fips: 32009,
    county_fips_all: '32009|32021|06051',
    county: 'Esmeralda',
    county_names_all: 'Esmeralda|Mineral|Mono',
    county_weights: '{"32009": 90.34, "32021": 5.9, "06051": 3.76}',
    density: 0.3,
    imprecise: false,
    latitude: 37.82511,
    longitude: -118.08079,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89010',
  },
  {
    city: 'Henderson',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 878.2,
    imprecise: false,
    latitude: 36.0848,
    longitude: -114.9651,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89011',
  },
  {
    city: 'Henderson',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1381.7,
    imprecise: false,
    latitude: 36.01192,
    longitude: -115.04314,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89012',
  },
  {
    city: 'Goldfield',
    county_fips: 32009,
    county_fips_all: '32009',
    county: 'Esmeralda',
    county_names_all: 'Esmeralda',
    county_weights: '{"32009": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 37.34574,
    longitude: -117.34393,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89013',
  },
  {
    city: 'Henderson',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2143.9,
    imprecise: false,
    latitude: 36.06153,
    longitude: -115.0577,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42439,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89014',
  },
  {
    city: 'Henderson',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 462.9,
    imprecise: false,
    latitude: 36.03887,
    longitude: -114.9282,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89015',
  },
  {
    city: 'Hiko',
    county_fips: 32017,
    county_fips_all: '32017',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"32017": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.70485,
    longitude: -115.30344,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89017',
  },
  {
    city: 'Indian Springs',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 258.7,
    imprecise: false,
    latitude: 36.57063,
    longitude: -115.66802,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89018',
  },
  {
    city: 'Jean',
    county_fips: 32003,
    county_fips_all: '32003|06071|06027',
    county: 'Clark',
    county_names_all: 'Clark|San Bernardino|Inyo',
    county_weights: '{"32003": 77.52, "06071": 21.56, "06027": 0.92}',
    density: 2,
    imprecise: false,
    latitude: 35.76949,
    longitude: -115.51606,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89019',
  },
  {
    city: 'Amargosa Valley',
    county_fips: 32023,
    county_fips_all: '32023',
    county: 'Nye',
    county_names_all: 'Nye',
    county_weights: '{"32023": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 36.56232,
    longitude: -116.42454,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89020',
  },
  {
    city: 'Logandale',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 36.6255,
    longitude: -114.47863,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89021',
  },
  {
    city: 'Manhattan',
    county_fips: 32023,
    county_fips_all: '32023',
    county: 'Nye',
    county_names_all: 'Nye',
    county_weights: '{"32023": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.51839,
    longitude: -117.01489,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89022',
  },
  {
    city: 'Moapa',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 36.71387,
    longitude: -114.74777,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89025',
  },
  {
    city: 'Mesquite',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 586.1,
    imprecise: false,
    latitude: 36.81374,
    longitude: -114.08857,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89027',
  },
  {
    city: 'Laughlin',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 37.4,
    imprecise: false,
    latitude: 35.12561,
    longitude: -114.68607,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89029',
  },
  {
    city: 'North Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2092.8,
    imprecise: false,
    latitude: 36.21235,
    longitude: -115.12313,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 51341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89030',
  },
  {
    city: 'North Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 3017.6,
    imprecise: false,
    latitude: 36.25846,
    longitude: -115.17075,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 77305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89031',
  },
  {
    city: 'North Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1912.9,
    imprecise: false,
    latitude: 36.22239,
    longitude: -115.17358,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89032',
  },
  {
    city: 'Mesquite',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 70,
    imprecise: false,
    latitude: 36.80924,
    longitude: -114.14978,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89034',
  },
  {
    city: 'Cal Nev Ari',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 35.26581,
    longitude: -114.8725,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89039',
  },
  {
    city: 'Overton',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 36.35322,
    longitude: -114.53541,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89040',
  },
  {
    city: 'Panaca',
    county_fips: 32017,
    county_fips_all: '32017',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"32017": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 37.79819,
    longitude: -114.35862,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89042',
  },
  {
    city: 'Pioche',
    county_fips: 32017,
    county_fips_all: '32017',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"32017": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 38.30434,
    longitude: -114.39018,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89043',
  },
  {
    city: 'Henderson',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 203.9,
    imprecise: false,
    latitude: 35.93986,
    longitude: -115.05632,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89044',
  },
  {
    city: 'Round Mountain',
    county_fips: 32023,
    county_fips_all: '32023',
    county: 'Nye',
    county_names_all: 'Nye',
    county_weights: '{"32023": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 38.85618,
    longitude: -117.06987,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89045',
  },
  {
    city: 'Searchlight',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 35.51207,
    longitude: -114.8338,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89046',
  },
  {
    city: 'Silverpeak',
    county_fips: 32009,
    county_fips_all: '32009',
    county: 'Esmeralda',
    county_names_all: 'Esmeralda',
    county_weights: '{"32009": 100}',
    density: 86.6,
    imprecise: false,
    latitude: 37.75776,
    longitude: -117.6386,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89047',
  },
  {
    city: 'Pahrump',
    county_fips: 32023,
    county_fips_all: '32023',
    county: 'Nye',
    county_names_all: 'Nye',
    county_weights: '{"32023": 100}',
    density: 119,
    imprecise: false,
    latitude: 36.16452,
    longitude: -115.98833,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89048',
  },
  {
    city: 'Tonopah',
    county_fips: 32023,
    county_fips_all: '32023|32009',
    county: 'Nye',
    county_names_all: 'Nye|Esmeralda',
    county_weights: '{"32023": 99.61, "32009": 0.39}',
    density: 0.4,
    imprecise: false,
    latitude: 38.37741,
    longitude: -116.41205,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89049',
  },
  {
    city: 'Henderson',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1442.6,
    imprecise: false,
    latitude: 35.97988,
    longitude: -115.10788,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 60888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89052',
  },
  {
    city: 'Sloan',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 24,
    imprecise: false,
    latitude: 35.92093,
    longitude: -115.19055,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89054',
  },
  {
    city: 'Pahrump',
    county_fips: 32023,
    county_fips_all: '32023|06027',
    county: 'Nye',
    county_names_all: 'Nye|Inyo',
    county_weights: '{"32023": 98.13, "06027": 1.87}',
    density: 11.1,
    imprecise: false,
    latitude: 36.38854,
    longitude: -116.05769,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89060',
  },
  {
    city: 'Pahrump',
    county_fips: 32023,
    county_fips_all: '32023|06027',
    county: 'Nye',
    county_names_all: 'Nye|Inyo',
    county_weights: '{"32023": 95.56, "06027": 4.44}',
    density: 49.1,
    imprecise: false,
    latitude: 36.07143,
    longitude: -115.89957,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89061',
  },
  {
    city: 'Henderson',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2229.8,
    imprecise: false,
    latitude: 36.03639,
    longitude: -115.08113,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89074',
  },
  {
    city: 'North Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2218.9,
    imprecise: false,
    latitude: 36.2586,
    longitude: -115.10703,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89081',
  },
  {
    city: 'North Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1043.9,
    imprecise: false,
    latitude: 36.29749,
    longitude: -115.1569,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89084',
  },
  {
    city: 'North Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 3763,
    imprecise: false,
    latitude: 36.30955,
    longitude: -115.19817,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89085',
  },
  {
    city: 'North Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1348.8,
    imprecise: false,
    latitude: 36.28361,
    longitude: -115.10997,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89086',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 3067.8,
    imprecise: false,
    latitude: 36.17279,
    longitude: -115.12234,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89101',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2663.9,
    imprecise: false,
    latitude: 36.1453,
    longitude: -115.18662,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89102',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2906,
    imprecise: false,
    latitude: 36.11236,
    longitude: -115.21215,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89103',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2691.1,
    imprecise: false,
    latitude: 36.15118,
    longitude: -115.10932,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89104',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2098.6,
    imprecise: false,
    latitude: 36.18207,
    longitude: -115.16253,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89106',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2541.5,
    imprecise: false,
    latitude: 36.17049,
    longitude: -115.209,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89107',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 3156.2,
    imprecise: false,
    latitude: 36.20508,
    longitude: -115.2237,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 72814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89108',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 608.8,
    imprecise: false,
    latitude: 36.12603,
    longitude: -115.16327,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89109',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2790.9,
    imprecise: false,
    latitude: 36.17367,
    longitude: -115.05549,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 69107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89110',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1365.5,
    imprecise: false,
    latitude: 36.06017,
    longitude: -115.26236,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89113',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1047.4,
    imprecise: false,
    latitude: 36.25374,
    longitude: -115.04285,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 67542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89115',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2440,
    imprecise: false,
    latitude: 36.14267,
    longitude: -115.28001,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 58082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89117',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 823.7,
    imprecise: false,
    latitude: 36.07778,
    longitude: -115.21306,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89118',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1502.1,
    imprecise: false,
    latitude: 36.08452,
    longitude: -115.14606,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89119',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1279.9,
    imprecise: false,
    latitude: 36.08065,
    longitude: -115.09585,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89120',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2877,
    imprecise: false,
    latitude: 36.12141,
    longitude: -115.09135,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 68406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89121',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2177.5,
    imprecise: false,
    latitude: 36.10399,
    longitude: -115.03783,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 53724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89122',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2169.7,
    imprecise: false,
    latitude: 36.0352,
    longitude: -115.14908,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 58205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89123',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 36.34074,
    longitude: -115.60096,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89124',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2582.2,
    imprecise: false,
    latitude: 36.19678,
    longitude: -115.26439,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89128',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2066.8,
    imprecise: false,
    latitude: 36.23325,
    longitude: -115.29025,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 53435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89129',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1834.3,
    imprecise: false,
    latitude: 36.25348,
    longitude: -115.22671,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89130',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1211.9,
    imprecise: false,
    latitude: 36.3064,
    longitude: -115.24256,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89131',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1393.8,
    imprecise: false,
    latitude: 36.20262,
    longitude: -115.3078,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89134',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 247.8,
    imprecise: false,
    latitude: 36.09531,
    longitude: -115.37163,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32524,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89135',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 571.8,
    imprecise: false,
    latitude: 36.20212,
    longitude: -115.36499,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89138',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1633.8,
    imprecise: false,
    latitude: 36.03429,
    longitude: -115.21117,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89139',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1595.4,
    imprecise: false,
    latitude: 35.98813,
    longitude: -115.2074,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89141',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2266.5,
    imprecise: false,
    latitude: 36.14812,
    longitude: -115.031,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89142',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1616.4,
    imprecise: false,
    latitude: 36.32168,
    longitude: -115.29288,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89143',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1681.2,
    imprecise: false,
    latitude: 36.17746,
    longitude: -115.31943,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89144',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2447.4,
    imprecise: false,
    latitude: 36.16748,
    longitude: -115.27618,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89145',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1781.2,
    imprecise: false,
    latitude: 36.14323,
    longitude: -115.22679,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89146',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2938,
    imprecise: false,
    latitude: 36.11289,
    longitude: -115.27985,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 55969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89147',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2559.9,
    imprecise: false,
    latitude: 36.06337,
    longitude: -115.29676,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 64426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89148',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1339.6,
    imprecise: false,
    latitude: 36.2708,
    longitude: -115.29462,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89149',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 259.9,
    imprecise: false,
    latitude: 36.15906,
    longitude: -114.98176,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89156',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 36.03552,
    longitude: -115.48284,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89161',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 70.9,
    imprecise: false,
    latitude: 36.33733,
    longitude: -115.4686,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89166',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2482.5,
    imprecise: false,
    latitude: 36.12405,
    longitude: -115.14184,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89169',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 755.1,
    imprecise: false,
    latitude: 35.98783,
    longitude: -115.29541,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89178',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 41.4,
    imprecise: false,
    latitude: 35.8916,
    longitude: -115.32794,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89179',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 2370.9,
    imprecise: false,
    latitude: 35.99619,
    longitude: -115.15799,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89183',
  },
  {
    city: 'Nellis Afb',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 36.2473,
    longitude: -115.00407,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89191',
  },
  {
    city: 'Ely',
    county_fips: 32033,
    county_fips_all: '32033',
    county: 'White Pine',
    county_names_all: 'White Pine',
    county_weights: '{"32033": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 39.52872,
    longitude: -114.76615,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89301',
  },
  {
    city: 'Austin',
    county_fips: 32015,
    county_fips_all: '32015|32023',
    county: 'Lander',
    county_names_all: 'Lander|Nye',
    county_weights: '{"32015": 94.43, "32023": 5.57}',
    density: 0,
    imprecise: false,
    latitude: 39.47836,
    longitude: -117.13758,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89310',
  },
  {
    city: 'Baker',
    county_fips: 32033,
    county_fips_all: '32033',
    county: 'White Pine',
    county_names_all: 'White Pine',
    county_weights: '{"32033": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 39.16715,
    longitude: -114.19288,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89311',
  },
  {
    city: 'Duckwater',
    county_fips: 32023,
    county_fips_all: '32023',
    county: 'Nye',
    county_names_all: 'Nye',
    county_weights: '{"32023": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 38.86222,
    longitude: -115.64186,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89314',
  },
  {
    city: 'Ely',
    county_fips: 32033,
    county_fips_all: '32033',
    county: 'White Pine',
    county_names_all: 'White Pine',
    county_weights: '{"32033": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 39.1855,
    longitude: -114.84489,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89315',
  },
  {
    city: 'Eureka',
    county_fips: 32011,
    county_fips_all: '32011|32033',
    county: 'Eureka',
    county_names_all: 'Eureka|White Pine',
    county_weights: '{"32011": 76.38, "32033": 23.62}',
    density: 0.2,
    imprecise: false,
    latitude: 39.67956,
    longitude: -116.01497,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89316',
  },
  {
    city: 'Lund',
    county_fips: 32033,
    county_fips_all: '32033',
    county: 'White Pine',
    county_names_all: 'White Pine',
    county_weights: '{"32033": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 38.87915,
    longitude: -115.08418,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89317',
  },
  {
    city: 'McGill',
    county_fips: 32033,
    county_fips_all: '32033',
    county: 'White Pine',
    county_names_all: 'White Pine',
    county_weights: '{"32033": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 39.43783,
    longitude: -114.8188,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89318',
  },
  {
    city: 'Ruth',
    county_fips: 32033,
    county_fips_all: '32033',
    county: 'White Pine',
    county_names_all: 'White Pine',
    county_weights: '{"32033": 100}',
    density: 312.3,
    imprecise: false,
    latitude: 39.27915,
    longitude: -114.98724,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89319',
  },
  {
    city: 'Crystal Bay',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 171.6,
    imprecise: false,
    latitude: 39.23075,
    longitude: -120.00259,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89402',
  },
  {
    city: 'Dayton',
    county_fips: 32019,
    county_fips_all: '32019|32029',
    county: 'Lyon',
    county_names_all: 'Lyon|Storey',
    county_weights: '{"32019": 80.41, "32029": 19.59}',
    density: 41.7,
    imprecise: false,
    latitude: 39.25838,
    longitude: -119.48633,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89403',
  },
  {
    city: 'Denio',
    county_fips: 32013,
    county_fips_all: '32013',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"32013": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.80704,
    longitude: -118.88807,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89404',
  },
  {
    city: 'Fallon',
    county_fips: 32001,
    county_fips_all: '32001|32019',
    county: 'Churchill',
    county_names_all: 'Churchill|Lyon',
    county_weights: '{"32001": 98.65, "32019": 1.35}',
    density: 5,
    imprecise: false,
    latitude: 39.46614,
    longitude: -118.27364,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89406',
  },
  {
    city: 'Fernley',
    county_fips: 32001,
    county_fips_all: '32001|32019',
    county: 'Churchill',
    county_names_all: 'Churchill|Lyon',
    county_weights: '{"32001": 77.66, "32019": 22.34}',
    density: 20.4,
    imprecise: false,
    latitude: 39.71675,
    longitude: -119.02706,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89408',
  },
  {
    city: 'Gabbs',
    county_fips: 32023,
    county_fips_all: '32023|32021',
    county: 'Nye',
    county_names_all: 'Nye|Mineral',
    county_weights: '{"32023": 68.09, "32021": 31.91}',
    density: 0.5,
    imprecise: false,
    latitude: 38.83828,
    longitude: -117.98088,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89409',
  },
  {
    city: 'Gardnerville',
    county_fips: 32005,
    county_fips_all: '32005',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"32005": 100}',
    density: 18.1,
    imprecise: false,
    latitude: 38.78368,
    longitude: -119.54802,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89410',
  },
  {
    city: 'Genoa',
    county_fips: 32005,
    county_fips_all: '32005',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"32005": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 39.01837,
    longitude: -119.85301,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89411',
  },
  {
    city: 'Gerlach',
    county_fips: 32031,
    county_fips_all: '32031|32013',
    county: 'Washoe',
    county_names_all: 'Washoe|Humboldt',
    county_weights: '{"32031": 91.78, "32013": 8.22}',
    density: 0,
    imprecise: false,
    latitude: 41.13904,
    longitude: -119.69501,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89412',
  },
  {
    city: 'Glenbrook',
    county_fips: 32005,
    county_fips_all: '32005',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"32005": 100}',
    density: 18,
    imprecise: false,
    latitude: 39.07389,
    longitude: -119.92095,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89413',
  },
  {
    city: 'Golconda',
    county_fips: 32013,
    county_fips_all: '32013|32007',
    county: 'Humboldt',
    county_names_all: 'Humboldt|Elko',
    county_weights: '{"32013": 73.77, "32007": 26.23}',
    density: 0.1,
    imprecise: false,
    latitude: 41.04934,
    longitude: -117.22765,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89414',
  },
  {
    city: 'Hawthorne',
    county_fips: 32021,
    county_fips_all: '32021',
    county: 'Mineral',
    county_names_all: 'Mineral',
    county_weights: '{"32021": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 38.50993,
    longitude: -118.77958,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89415',
  },
  {
    city: 'Imlay',
    county_fips: 32027,
    county_fips_all: '32027',
    county: 'Pershing',
    county_names_all: 'Pershing',
    county_weights: '{"32027": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 40.5669,
    longitude: -118.03851,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89418',
  },
  {
    city: 'Lovelock',
    county_fips: 32027,
    county_fips_all: '32027',
    county: 'Pershing',
    county_names_all: 'Pershing',
    county_weights: '{"32027": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 40.34309,
    longitude: -118.29831,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89419',
  },
  {
    city: 'Luning',
    county_fips: 32021,
    county_fips_all: '32021',
    county: 'Mineral',
    county_names_all: 'Mineral',
    county_weights: '{"32021": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 38.50802,
    longitude: -118.18051,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89420',
  },
  {
    city: 'McDermitt',
    county_fips: 41045,
    county_fips_all: '41045|32013',
    county: 'Malheur',
    county_names_all: 'Malheur|Humboldt',
    county_weights: '{"41045": 61.21, "32013": 38.79}',
    density: 0.1,
    imprecise: false,
    latitude: 42.04485,
    longitude: -117.94724,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89421',
  },
  {
    city: 'Mina',
    county_fips: 32021,
    county_fips_all: '32021',
    county: 'Mineral',
    county_names_all: 'Mineral',
    county_weights: '{"32021": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 38.42008,
    longitude: -118.17911,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89422',
  },
  {
    city: 'Minden',
    county_fips: 32005,
    county_fips_all: '32005',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"32005": 100}',
    density: 57.9,
    imprecise: false,
    latitude: 39.01561,
    longitude: -119.74636,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89423',
  },
  {
    city: 'Nixon',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 40.10964,
    longitude: -119.49396,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89424',
  },
  {
    city: 'Orovada',
    county_fips: 32013,
    county_fips_all: '32013',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"32013": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 41.65695,
    longitude: -117.88461,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89425',
  },
  {
    city: 'Paradise Valley',
    county_fips: 32013,
    county_fips_all: '32013',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"32013": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 41.45402,
    longitude: -117.59307,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89426',
  },
  {
    city: 'Schurz',
    county_fips: 32021,
    county_fips_all: '32021',
    county: 'Mineral',
    county_names_all: 'Mineral',
    county_weights: '{"32021": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 38.94556,
    longitude: -118.70553,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89427',
  },
  {
    city: 'Silver City',
    county_fips: 32019,
    county_fips_all: '32019',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"32019": 100}',
    density: 32.5,
    imprecise: false,
    latitude: 39.25691,
    longitude: -119.63099,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89428',
  },
  {
    city: 'Silver Springs',
    county_fips: 32019,
    county_fips_all: '32019',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"32019": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 39.36221,
    longitude: -119.29063,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89429',
  },
  {
    city: 'Smith',
    county_fips: 32019,
    county_fips_all: '32019',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"32019": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 38.79567,
    longitude: -119.31785,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89430',
  },
  {
    city: 'Sparks',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 1667.1,
    imprecise: false,
    latitude: 39.53865,
    longitude: -119.75005,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89431',
  },
  {
    city: 'Sun Valley',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 797.6,
    imprecise: false,
    latitude: 39.59758,
    longitude: -119.77817,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89433',
  },
  {
    city: 'Sparks',
    county_fips: 32029,
    county_fips_all: '32029|32031',
    county: 'Storey',
    county_names_all: 'Storey|Washoe',
    county_weights: '{"32029": 69.15, "32031": 30.85}',
    density: 86.1,
    imprecise: false,
    latitude: 39.54019,
    longitude: -119.53318,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89434',
  },
  {
    city: 'Sparks',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 450.2,
    imprecise: false,
    latitude: 39.61086,
    longitude: -119.69854,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49544,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89436',
  },
  {
    city: 'Valmy',
    county_fips: 32013,
    county_fips_all: '32013',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"32013": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.79671,
    longitude: -117.12004,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89438',
  },
  {
    city: 'Verdi',
    county_fips: 32031,
    county_fips_all: '32031|06091',
    county: 'Washoe',
    county_names_all: 'Washoe|Sierra',
    county_weights: '{"32031": 74.74, "06091": 25.26}',
    density: 60.1,
    imprecise: false,
    latitude: 39.52291,
    longitude: -119.99008,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89439',
  },
  {
    city: 'Virginia City',
    county_fips: 32029,
    county_fips_all: '32029',
    county: 'Storey',
    county_names_all: 'Storey',
    county_weights: '{"32029": 100}',
    density: 25.4,
    imprecise: false,
    latitude: 39.29597,
    longitude: -119.66212,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89440',
  },
  {
    city: 'Sparks',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 112.4,
    imprecise: false,
    latitude: 39.68131,
    longitude: -119.68755,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89441',
  },
  {
    city: 'Wadsworth',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 39.69511,
    longitude: -119.35082,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89442',
  },
  {
    city: 'Wellington',
    county_fips: 32019,
    county_fips_all: '32019|32005',
    county: 'Lyon',
    county_names_all: 'Lyon|Douglas',
    county_weights: '{"32019": 79.05, "32005": 20.95}',
    density: 6.1,
    imprecise: false,
    latitude: 38.72695,
    longitude: -119.35101,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89444',
  },
  {
    city: 'Winnemucca',
    county_fips: 32013,
    county_fips_all: '32013|32027',
    county: 'Humboldt',
    county_names_all: 'Humboldt|Pershing',
    county_weights: '{"32013": 73.98, "32027": 26.02}',
    density: 2.4,
    imprecise: false,
    latitude: 41.06767,
    longitude: -118.02515,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89445',
  },
  {
    city: 'Winnemucca',
    county_fips: 32013,
    county_fips_all: '32013',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"32013": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 40.87879,
    longitude: -117.9532,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89446',
  },
  {
    city: 'Yerington',
    county_fips: 32019,
    county_fips_all: '32019',
    county: 'Lyon',
    county_names_all: 'Lyon',
    county_weights: '{"32019": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 38.83148,
    longitude: -119.11712,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89447',
  },
  {
    city: 'Zephyr Cove',
    county_fips: 32005,
    county_fips_all: '32005',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"32005": 100}',
    density: 53.3,
    imprecise: false,
    latitude: 39.00789,
    longitude: -119.92412,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89448',
  },
  {
    city: 'Stateline',
    county_fips: 32005,
    county_fips_all: '32005',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"32005": 100}',
    density: 104.4,
    imprecise: false,
    latitude: 38.96433,
    longitude: -119.90688,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89449',
  },
  {
    city: 'Incline Village',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.24135,
    longitude: -119.93832,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89450',
  },
  {
    city: 'Incline Village',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 85,
    imprecise: false,
    latitude: 39.26775,
    longitude: -119.94534,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89451',
  },
  {
    city: 'Gardnerville',
    county_fips: 32005,
    county_fips_all: '32005',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"32005": 100}',
    density: 101.7,
    imprecise: false,
    latitude: 38.90136,
    longitude: -119.79085,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89460',
  },
  {
    city: 'Reno',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 2317.2,
    imprecise: false,
    latitude: 39.52602,
    longitude: -119.81262,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3507,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89501',
  },
  {
    city: 'Reno',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 840.1,
    imprecise: false,
    latitude: 39.49383,
    longitude: -119.74701,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46691,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89502',
  },
  {
    city: 'Reno',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 1891.4,
    imprecise: false,
    latitude: 39.54112,
    longitude: -119.83991,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89503',
  },
  {
    city: 'Reno',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 199.3,
    imprecise: false,
    latitude: 39.70084,
    longitude: -119.82646,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89506',
  },
  {
    city: 'Reno',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 38.2,
    imprecise: false,
    latitude: 39.78504,
    longitude: -119.92728,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89508',
  },
  {
    city: 'Reno',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 1559.2,
    imprecise: false,
    latitude: 39.49637,
    longitude: -119.8273,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89509',
  },
  {
    city: 'Reno',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 39.93619,
    longitude: -119.73734,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89510',
  },
  {
    city: 'Reno',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 90.8,
    imprecise: false,
    latitude: 39.40747,
    longitude: -119.88822,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89511',
  },
  {
    city: 'Reno',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 1744.3,
    imprecise: false,
    latitude: 39.55322,
    longitude: -119.80074,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28030,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89512',
  },
  {
    city: 'Reno',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 541.4,
    imprecise: false,
    latitude: 39.48518,
    longitude: -119.86003,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89519',
  },
  {
    city: 'Reno',
    county_fips: 32031,
    county_fips_all: '32031|32029',
    county: 'Washoe',
    county_names_all: 'Washoe|Storey',
    county_weights: '{"32031": 57.16, "32029": 42.84}',
    density: 173.8,
    imprecise: false,
    latitude: 39.37215,
    longitude: -119.67611,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89521',
  },
  {
    city: 'Reno',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 759.1,
    imprecise: false,
    latitude: 39.52387,
    longitude: -119.91309,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89523',
  },
  {
    city: 'Carson City',
    county_fips: 32510,
    county_fips_all: '32510',
    county: 'Carson City',
    county_names_all: 'Carson City',
    county_weights: '{"32510": 100}',
    density: 318.9,
    imprecise: false,
    latitude: 39.13944,
    longitude: -119.72087,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89701',
  },
  {
    city: 'Carson City',
    county_fips: 32510,
    county_fips_all: '32510|32031',
    county: 'Carson City',
    county_names_all: 'Carson City|Washoe',
    county_weights: '{"32510": 98.33, "32031": 1.67}',
    density: 93.7,
    imprecise: false,
    latitude: 39.15359,
    longitude: -119.8486,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89703',
  },
  {
    city: 'Washoe Valley',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 24.5,
    imprecise: false,
    latitude: 39.26789,
    longitude: -119.81712,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89704',
  },
  {
    city: 'Carson City',
    county_fips: 32005,
    county_fips_all: '32005|32510',
    county: 'Douglas',
    county_names_all: 'Douglas|Carson City',
    county_weights: '{"32005": 95.93, "32510": 4.07}',
    density: 82.1,
    imprecise: false,
    latitude: 39.09003,
    longitude: -119.83689,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89705',
  },
  {
    city: 'Carson City',
    county_fips: 32510,
    county_fips_all: '32510|32019',
    county: 'Carson City',
    county_names_all: 'Carson City|Lyon',
    county_weights: '{"32510": 52.64, "32019": 47.36}',
    density: 229.1,
    imprecise: false,
    latitude: 39.22002,
    longitude: -119.69974,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89706',
  },
  {
    city: 'Elko',
    county_fips: 32007,
    county_fips_all: '32007',
    county: 'Elko',
    county_names_all: 'Elko',
    county_weights: '{"32007": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 41.18096,
    longitude: -115.76076,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89801',
  },
  {
    city: 'Spring Creek',
    county_fips: 32007,
    county_fips_all: '32007',
    county: 'Elko',
    county_names_all: 'Elko',
    county_weights: '{"32007": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 40.56652,
    longitude: -115.59504,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89815',
  },
  {
    city: 'Battle Mountain',
    county_fips: 32015,
    county_fips_all: '32015|32011',
    county: 'Lander',
    county_names_all: 'Lander|Eureka',
    county_weights: '{"32015": 97.95, "32011": 2.05}',
    density: 1,
    imprecise: false,
    latitude: 40.43192,
    longitude: -116.97134,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89820',
  },
  {
    city: 'Crescent Valley',
    county_fips: 32011,
    county_fips_all: '32011',
    county: 'Eureka',
    county_names_all: 'Eureka',
    county_weights: '{"32011": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 40.55585,
    longitude: -116.41218,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89821',
  },
  {
    city: 'Carlin',
    county_fips: 32011,
    county_fips_all: '32011|32007',
    county: 'Eureka',
    county_names_all: 'Eureka|Elko',
    county_weights: '{"32011": 93.12, "32007": 6.88}',
    density: 3.2,
    imprecise: false,
    latitude: 40.49237,
    longitude: -116.189,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89822',
  },
  {
    city: 'Deeth',
    county_fips: 32007,
    county_fips_all: '32007',
    county: 'Elko',
    county_names_all: 'Elko',
    county_weights: '{"32007": 100}',
    density: 1,
    imprecise: false,
    latitude: 40.96431,
    longitude: -115.22821,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89823',
  },
  {
    city: 'Jackpot',
    county_fips: 32007,
    county_fips_all: '32007',
    county: 'Elko',
    county_names_all: 'Elko',
    county_weights: '{"32007": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 41.90422,
    longitude: -114.71103,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89825',
  },
  {
    city: 'Jarbidge',
    county_fips: 32007,
    county_fips_all: '32007',
    county: 'Elko',
    county_names_all: 'Elko',
    county_weights: '{"32007": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.93262,
    longitude: -115.41386,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89826',
  },
  {
    city: 'Lamoille',
    county_fips: 32007,
    county_fips_all: '32007',
    county: 'Elko',
    county_names_all: 'Elko',
    county_weights: '{"32007": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 40.77384,
    longitude: -115.36403,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89828',
  },
  {
    city: 'Montello',
    county_fips: 32007,
    county_fips_all: '32007',
    county: 'Elko',
    county_names_all: 'Elko',
    county_weights: '{"32007": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 41.32794,
    longitude: -114.22677,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89830',
  },
  {
    city: 'Mountain City',
    county_fips: 32007,
    county_fips_all: '32007',
    county: 'Elko',
    county_names_all: 'Elko',
    county_weights: '{"32007": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.75992,
    longitude: -116.03935,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89831',
  },
  {
    city: 'Owyhee',
    county_fips: 32007,
    county_fips_all: '32007|16073',
    county: 'Elko',
    county_names_all: 'Elko|Owyhee',
    county_weights: '{"32007": 66.92, "16073": 33.08}',
    density: 1.8,
    imprecise: false,
    latitude: 41.98001,
    longitude: -116.19537,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89832',
  },
  {
    city: 'Ruby Valley',
    county_fips: 32007,
    county_fips_all: '32007',
    county: 'Elko',
    county_names_all: 'Elko',
    county_weights: '{"32007": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 40.4692,
    longitude: -115.34201,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89833',
  },
  {
    city: 'Tuscarora',
    county_fips: 32007,
    county_fips_all: '32007',
    county: 'Elko',
    county_names_all: 'Elko',
    county_weights: '{"32007": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.42358,
    longitude: -116.24843,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89834',
  },
  {
    city: 'Wells',
    county_fips: 32007,
    county_fips_all: '32007',
    county: 'Elko',
    county_names_all: 'Elko',
    county_weights: '{"32007": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 41.2848,
    longitude: -114.87765,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89835',
  },
  {
    city: 'West Wendover',
    county_fips: 32007,
    county_fips_all: '32007',
    county: 'Elko',
    county_names_all: 'Elko',
    county_weights: '{"32007": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 40.84711,
    longitude: -114.18217,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89883',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6614,
    imprecise: false,
    latitude: 33.97365,
    longitude: -118.24904,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 56189,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90001',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6724.8,
    imprecise: false,
    latitude: 33.94906,
    longitude: -118.24679,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90002',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 7462.1,
    imprecise: false,
    latitude: 33.96409,
    longitude: -118.27368,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 70065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90003',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 7401.7,
    imprecise: false,
    latitude: 34.07624,
    longitude: -118.31101,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 58484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90004',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 12809.3,
    imprecise: false,
    latitude: 34.05939,
    longitude: -118.30909,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90005',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 11087.1,
    imprecise: false,
    latitude: 34.04807,
    longitude: -118.29411,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 55527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90006',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6151.1,
    imprecise: false,
    latitude: 34.02819,
    longitude: -118.28486,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90007',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4437.3,
    imprecise: false,
    latitude: 34.01037,
    longitude: -118.3428,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90008',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 9012.4,
    imprecise: false,
    latitude: 34.00689,
    longitude: -118.25861,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 100113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90011',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3962.6,
    imprecise: false,
    latitude: 34.06679,
    longitude: -118.23878,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90012',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 7859.4,
    imprecise: false,
    latitude: 34.04435,
    longitude: -118.24,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90013',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 13185.6,
    imprecise: false,
    latitude: 34.04302,
    longitude: -118.25182,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90014',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5633.1,
    imprecise: false,
    latitude: 34.03932,
    longitude: -118.26625,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90015',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4986.7,
    imprecise: false,
    latitude: 34.02881,
    longitude: -118.35436,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90016',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 16477.5,
    imprecise: false,
    latitude: 34.05306,
    longitude: -118.26447,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90017',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6271.9,
    imprecise: false,
    latitude: 34.0286,
    longitude: -118.31737,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90018',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5940,
    imprecise: false,
    latitude: 34.04861,
    longitude: -118.33874,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 59548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90019',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 13540.4,
    imprecise: false,
    latitude: 34.06638,
    longitude: -118.30986,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90020',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 565.8,
    imprecise: false,
    latitude: 34.02909,
    longitude: -118.23889,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90021',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5268.4,
    imprecise: false,
    latitude: 34.02455,
    longitude: -118.15608,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 60343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90022',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3922.1,
    imprecise: false,
    latitude: 34.02264,
    longitude: -118.19986,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90023',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6709,
    imprecise: false,
    latitude: 34.06565,
    longitude: -118.43521,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 51675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90024',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 7039.5,
    imprecise: false,
    latitude: 34.04551,
    longitude: -118.44583,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90025',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6006.7,
    imprecise: false,
    latitude: 34.07883,
    longitude: -118.2637,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 62692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90026',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2212.5,
    imprecise: false,
    latitude: 34.12515,
    longitude: -118.29049,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90027',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 8404.8,
    imprecise: false,
    latitude: 34.09982,
    longitude: -118.3268,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90028',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 9343.9,
    imprecise: false,
    latitude: 34.08983,
    longitude: -118.29467,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90029',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3985.8,
    imprecise: false,
    latitude: 34.08122,
    longitude: -118.21081,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90031',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3457.5,
    imprecise: false,
    latitude: 34.0793,
    longitude: -118.17835,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90032',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5379.7,
    imprecise: false,
    latitude: 34.05117,
    longitude: -118.21165,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90033',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 7106,
    imprecise: false,
    latitude: 34.03059,
    longitude: -118.39936,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90034',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4919.9,
    imprecise: false,
    latitude: 34.05139,
    longitude: -118.38577,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90035',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6175.5,
    imprecise: false,
    latitude: 34.07013,
    longitude: -118.34978,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90036',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 8755.6,
    imprecise: false,
    latitude: 34.00271,
    longitude: -118.28747,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 65482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90037',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6766.5,
    imprecise: false,
    latitude: 34.08882,
    longitude: -118.32671,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90038',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3064,
    imprecise: false,
    latitude: 34.11242,
    longitude: -118.26153,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90039',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 792.6,
    imprecise: false,
    latitude: 33.99318,
    longitude: -118.1489,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90040',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2999.5,
    imprecise: false,
    latitude: 34.13749,
    longitude: -118.20746,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90041',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4855.7,
    imprecise: false,
    latitude: 34.11475,
    longitude: -118.192,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 56835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90042',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3988.8,
    imprecise: false,
    latitude: 33.98876,
    longitude: -118.33519,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90043',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 7176.2,
    imprecise: false,
    latitude: 33.95253,
    longitude: -118.29194,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 94830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90044',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1499.5,
    imprecise: false,
    latitude: 33.95302,
    longitude: -118.40028,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90045',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3291.2,
    imprecise: false,
    latitude: 34.10752,
    longitude: -118.36575,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90046',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4181.5,
    imprecise: false,
    latitude: 33.95456,
    longitude: -118.30899,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90047',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4378.7,
    imprecise: false,
    latitude: 34.07293,
    longitude: -118.3727,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21476,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90048',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 957.3,
    imprecise: false,
    latitude: 34.08749,
    longitude: -118.48976,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90049',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1461,
    imprecise: false,
    latitude: 33.99361,
    longitude: -118.36884,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90056',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 20458.9,
    imprecise: false,
    latitude: 34.06205,
    longitude: -118.27704,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90057',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 239.2,
    imprecise: false,
    latitude: 34.00264,
    longitude: -118.21452,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90058',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4580.8,
    imprecise: false,
    latitude: 33.92709,
    longitude: -118.2491,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90059',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4276,
    imprecise: false,
    latitude: 33.92037,
    longitude: -118.27383,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90061',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6619.3,
    imprecise: false,
    latitude: 34.0035,
    longitude: -118.30904,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90062',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5688.7,
    imprecise: false,
    latitude: 34.0452,
    longitude: -118.18583,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90063',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2761.9,
    imprecise: false,
    latitude: 34.0358,
    longitude: -118.42653,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90064',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3140.6,
    imprecise: false,
    latitude: 34.10867,
    longitude: -118.22813,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90065',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4556.1,
    imprecise: false,
    latitude: 34.00166,
    longitude: -118.43104,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 56740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90066',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3478.1,
    imprecise: false,
    latitude: 34.0565,
    longitude: -118.41373,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90067',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1040.6,
    imprecise: false,
    latitude: 34.12794,
    longitude: -118.32914,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21572,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90068',
  },
  {
    city: 'West Hollywood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3761,
    imprecise: false,
    latitude: 34.09401,
    longitude: -118.38154,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90069',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1592.6,
    imprecise: false,
    latitude: 34.05239,
    longitude: -118.25518,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90071',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 776.6,
    imprecise: false,
    latitude: 34.05738,
    longitude: -118.45956,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90073',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 445.9,
    imprecise: false,
    latitude: 34.10536,
    longitude: -118.45591,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90077',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.04058,
    longitude: -118.25541,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90079',
  },
  {
    city: 'Playa Vista',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6357,
    imprecise: false,
    latitude: 33.97523,
    longitude: -118.41837,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90094',
  },
  {
    city: 'Bell Gardens',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5981.3,
    imprecise: false,
    latitude: 33.97113,
    longitude: -118.1709,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 92763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90201',
  },
  {
    city: 'Beverly Hills',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 683,
    imprecise: false,
    latitude: 34.10251,
    longitude: -118.41505,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90210',
  },
  {
    city: 'Beverly Hills',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5029.2,
    imprecise: false,
    latitude: 34.06498,
    longitude: -118.38293,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90211',
  },
  {
    city: 'Beverly Hills',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4375.5,
    imprecise: false,
    latitude: 34.06208,
    longitude: -118.40173,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90212',
  },
  {
    city: 'Compton',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2698.9,
    imprecise: false,
    latitude: 33.88058,
    longitude: -118.23591,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48354,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90220',
  },
  {
    city: 'Compton',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3634.4,
    imprecise: false,
    latitude: 33.88542,
    longitude: -118.20614,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90221',
  },
  {
    city: 'Compton',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4613.4,
    imprecise: false,
    latitude: 33.91213,
    longitude: -118.23721,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90222',
  },
  {
    city: 'Culver City',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2637.2,
    imprecise: false,
    latitude: 33.99691,
    longitude: -118.39487,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90230',
  },
  {
    city: 'Culver City',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2955.6,
    imprecise: false,
    latitude: 34.01859,
    longitude: -118.39157,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90232',
  },
  {
    city: 'Downey',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3188.7,
    imprecise: false,
    latitude: 33.9564,
    longitude: -118.11803,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90240',
  },
  {
    city: 'Downey',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3588.5,
    imprecise: false,
    latitude: 33.94076,
    longitude: -118.1295,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90241',
  },
  {
    city: 'Downey',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3485.4,
    imprecise: false,
    latitude: 33.92216,
    longitude: -118.14167,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90242',
  },
  {
    city: 'El Segundo',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1210.7,
    imprecise: false,
    latitude: 33.91709,
    longitude: -118.40161,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90245',
  },
  {
    city: 'Gardena',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4836.2,
    imprecise: false,
    latitude: 33.89159,
    longitude: -118.29735,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90247',
  },
  {
    city: 'Gardena',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 912.7,
    imprecise: false,
    latitude: 33.87689,
    longitude: -118.28362,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90248',
  },
  {
    city: 'Gardena',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3415.8,
    imprecise: false,
    latitude: 33.90152,
    longitude: -118.31707,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90249',
  },
  {
    city: 'Hawthorne',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5352.6,
    imprecise: false,
    latitude: 33.91383,
    longitude: -118.34996,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 93826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90250',
  },
  {
    city: 'Hermosa Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5149.1,
    imprecise: false,
    latitude: 33.86532,
    longitude: -118.39616,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19063,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90254',
  },
  {
    city: 'Huntington Park',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 7185.5,
    imprecise: false,
    latitude: 33.97697,
    longitude: -118.21725,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 69349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90255',
  },
  {
    city: 'Lawndale',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5012.9,
    imprecise: false,
    latitude: 33.88768,
    longitude: -118.34952,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90260',
  },
  {
    city: 'Lynwood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5197.1,
    imprecise: false,
    latitude: 33.92384,
    longitude: -118.20133,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 64235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90262',
  },
  {
    city: 'Malibu',
    county_fips: 6037,
    county_fips_all: '06037|06111',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles|Ventura',
    county_weights: '{"06037": 68.4, "06111": 31.6}',
    density: 55.4,
    imprecise: false,
    latitude: 34.07282,
    longitude: -118.84995,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90265',
  },
  {
    city: 'Manhattan Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3262.7,
    imprecise: false,
    latitude: 33.88968,
    longitude: -118.39705,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90266',
  },
  {
    city: 'Maywood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 7863,
    imprecise: false,
    latitude: 33.98856,
    longitude: -118.18774,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90270',
  },
  {
    city: 'Pacific Palisades',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 346.8,
    imprecise: false,
    latitude: 34.08066,
    longitude: -118.54459,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90272',
  },
  {
    city: 'Palos Verdes Peninsula',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 808.1,
    imprecise: false,
    latitude: 33.77732,
    longitude: -118.3684,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90274',
  },
  {
    city: 'Rancho Palos Verdes',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1168.2,
    imprecise: false,
    latitude: 33.7555,
    longitude: -118.36338,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90275',
  },
  {
    city: 'Redondo Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3758.8,
    imprecise: false,
    latitude: 33.83099,
    longitude: -118.38441,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90277',
  },
  {
    city: 'Redondo Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4461.9,
    imprecise: false,
    latitude: 33.87362,
    longitude: -118.37028,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90278',
  },
  {
    city: 'South Gate',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4780.3,
    imprecise: false,
    latitude: 33.94453,
    longitude: -118.19256,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 91365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90280',
  },
  {
    city: 'Topanga',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 130.2,
    imprecise: false,
    latitude: 34.09725,
    longitude: -118.6125,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90290',
  },
  {
    city: 'Venice',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4125.6,
    imprecise: false,
    latitude: 33.99447,
    longitude: -118.46315,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90291',
  },
  {
    city: 'Marina Del Rey',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4417.6,
    imprecise: false,
    latitude: 33.97865,
    longitude: -118.44707,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90292',
  },
  {
    city: 'Playa Del Rey',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1782.8,
    imprecise: false,
    latitude: 33.95071,
    longitude: -118.43745,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90293',
  },
  {
    city: 'Inglewood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5611.2,
    imprecise: false,
    latitude: 33.95647,
    longitude: -118.35863,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90301',
  },
  {
    city: 'Inglewood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5853,
    imprecise: false,
    latitude: 33.97472,
    longitude: -118.35565,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90302',
  },
  {
    city: 'Inglewood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4521.5,
    imprecise: false,
    latitude: 33.93601,
    longitude: -118.33112,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90303',
  },
  {
    city: 'Inglewood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5988.5,
    imprecise: false,
    latitude: 33.93736,
    longitude: -118.35879,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90304',
  },
  {
    city: 'Inglewood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2172.7,
    imprecise: false,
    latitude: 33.9583,
    longitude: -118.33113,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90305',
  },
  {
    city: 'Santa Monica',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4145.4,
    imprecise: false,
    latitude: 34.01584,
    longitude: -118.49251,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90401',
  },
  {
    city: 'Santa Monica',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2143.4,
    imprecise: false,
    latitude: 34.03598,
    longitude: -118.50391,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90402',
  },
  {
    city: 'Santa Monica',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6528,
    imprecise: false,
    latitude: 34.03164,
    longitude: -118.48975,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90403',
  },
  {
    city: 'Santa Monica',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4501.2,
    imprecise: false,
    latitude: 34.02665,
    longitude: -118.47381,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90404',
  },
  {
    city: 'Santa Monica',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3788.7,
    imprecise: false,
    latitude: 34.01208,
    longitude: -118.4679,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90405',
  },
  {
    city: 'Torrance',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2838,
    imprecise: false,
    latitude: 33.8336,
    longitude: -118.31419,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90501',
  },
  {
    city: 'Torrance',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3184.5,
    imprecise: false,
    latitude: 33.83497,
    longitude: -118.29291,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90502',
  },
  {
    city: 'Torrance',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3185.5,
    imprecise: false,
    latitude: 33.84089,
    longitude: -118.3538,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90503',
  },
  {
    city: 'Torrance',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2896.4,
    imprecise: false,
    latitude: 33.86693,
    longitude: -118.33135,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90504',
  },
  {
    city: 'Torrance',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2319.1,
    imprecise: false,
    latitude: 33.80904,
    longitude: -118.34775,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90505',
  },
  {
    city: 'Whittier',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1095.4,
    imprecise: false,
    latitude: 34.0078,
    longitude: -118.03287,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90601',
  },
  {
    city: 'Whittier',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2666.2,
    imprecise: false,
    latitude: 33.97317,
    longitude: -118.02341,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90602',
  },
  {
    city: 'Whittier',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2577.5,
    imprecise: false,
    latitude: 33.94487,
    longitude: -117.99239,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90603',
  },
  {
    city: 'Whittier',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3603,
    imprecise: false,
    latitude: 33.93012,
    longitude: -118.01226,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90604',
  },
  {
    city: 'Whittier',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2381.2,
    imprecise: false,
    latitude: 33.95209,
    longitude: -118.02085,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90605',
  },
  {
    city: 'Whittier',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3262.7,
    imprecise: false,
    latitude: 33.97742,
    longitude: -118.0661,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90606',
  },
  {
    city: 'Buena Park',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2825.2,
    imprecise: false,
    latitude: 33.84616,
    longitude: -118.01176,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90620',
  },
  {
    city: 'Buena Park',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 3314.8,
    imprecise: false,
    latitude: 33.87396,
    longitude: -117.99346,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90621',
  },
  {
    city: 'La Palma',
    county_fips: 6059,
    county_fips_all: '06059|06037',
    county: 'Orange',
    county_names_all: 'Orange|Los Angeles',
    county_weights: '{"06059": 97.92, "06037": 2.08}',
    density: 3308.5,
    imprecise: false,
    latitude: 33.85038,
    longitude: -118.04088,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90623',
  },
  {
    city: 'Cypress',
    county_fips: 6059,
    county_fips_all: '06059|06037',
    county: 'Orange',
    county_names_all: 'Orange|Los Angeles',
    county_weights: '{"06059": 99.23, "06037": 0.77}',
    density: 3096.2,
    imprecise: false,
    latitude: 33.81814,
    longitude: -118.03814,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49318,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90630',
  },
  {
    city: 'La Habra',
    county_fips: 6059,
    county_fips_all: '06059|06037',
    county: 'Orange',
    county_names_all: 'Orange|Los Angeles',
    county_weights: '{"06059": 54.32, "06037": 45.68}',
    density: 1887.3,
    imprecise: false,
    latitude: 33.94266,
    longitude: -117.95126,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 68309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90631',
  },
  {
    city: 'La Mirada',
    county_fips: 6037,
    county_fips_all: '06037|06059',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles|Orange',
    county_weights: '{"06037": 99.08, "06059": 0.92}',
    density: 2288.4,
    imprecise: false,
    latitude: 33.90236,
    longitude: -118.00907,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90638',
  },
  {
    city: 'Montebello',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2847.7,
    imprecise: false,
    latitude: 34.01506,
    longitude: -118.111,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 61382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90640',
  },
  {
    city: 'Norwalk',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3895.1,
    imprecise: false,
    latitude: 33.90703,
    longitude: -118.08249,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 99900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90650',
  },
  {
    city: 'Pico Rivera',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3002.5,
    imprecise: false,
    latitude: 33.98868,
    longitude: -118.09111,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 60272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90660',
  },
  {
    city: 'Santa Fe Springs',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 828.4,
    imprecise: false,
    latitude: 33.93279,
    longitude: -118.0626,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90670',
  },
  {
    city: 'Stanton',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 4839.7,
    imprecise: false,
    latitude: 33.80115,
    longitude: -117.99532,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90680',
  },
  {
    city: 'Artesia',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3767.3,
    imprecise: false,
    latitude: 33.8676,
    longitude: -118.08055,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90701',
  },
  {
    city: 'Cerritos',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2123.2,
    imprecise: false,
    latitude: 33.86797,
    longitude: -118.06874,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90703',
  },
  {
    city: 'Avalon',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 33.3765,
    longitude: -118.43678,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3421,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90704',
  },
  {
    city: 'Bellflower',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4858.1,
    imprecise: false,
    latitude: 33.88802,
    longitude: -118.12709,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 76819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90706',
  },
  {
    city: 'Harbor City',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4426.1,
    imprecise: false,
    latitude: 33.79806,
    longitude: -118.29918,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90710',
  },
  {
    city: 'Lakewood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2820.6,
    imprecise: false,
    latitude: 33.849,
    longitude: -118.14677,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90712',
  },
  {
    city: 'Lakewood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3142.1,
    imprecise: false,
    latitude: 33.84797,
    longitude: -118.11268,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90713',
  },
  {
    city: 'Lakewood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4598.2,
    imprecise: false,
    latitude: 33.84037,
    longitude: -118.07887,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90715',
  },
  {
    city: 'Hawaiian Gardens',
    county_fips: 6037,
    county_fips_all: '06037|06059',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles|Orange',
    county_weights: '{"06037": 99.79, "06059": 0.21}',
    density: 5699.3,
    imprecise: false,
    latitude: 33.8305,
    longitude: -118.07295,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90716',
  },
  {
    city: 'Lomita',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4140.8,
    imprecise: false,
    latitude: 33.79345,
    longitude: -118.31706,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90717',
  },
  {
    city: 'Los Alamitos',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1511.9,
    imprecise: false,
    latitude: 33.79573,
    longitude: -118.06342,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90720',
  },
  {
    city: 'Paramount',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4232.9,
    imprecise: false,
    latitude: 33.89768,
    longitude: -118.16508,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90723',
  },
  {
    city: 'San Pedro',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2584.9,
    imprecise: false,
    latitude: 33.7334,
    longitude: -118.27398,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 61944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90731',
  },
  {
    city: 'San Pedro',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2490.1,
    imprecise: false,
    latitude: 33.74319,
    longitude: -118.31048,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90732',
  },
  {
    city: 'Seal Beach',
    county_fips: 6059,
    county_fips_all: '06059|06037',
    county: 'Orange',
    county_names_all: 'Orange|Los Angeles',
    county_weights: '{"06059": 99.87, "06037": 0.13}',
    density: 846.8,
    imprecise: false,
    latitude: 33.75461,
    longitude: -118.07129,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90740',
  },
  {
    city: 'Sunset Beach',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 830.3,
    imprecise: false,
    latitude: 33.71834,
    longitude: -118.07174,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90742',
  },
  {
    city: 'Surfside',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1353.6,
    imprecise: false,
    latitude: 33.72963,
    longitude: -118.08594,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90743',
  },
  {
    city: 'Wilmington',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2294.1,
    imprecise: false,
    latitude: 33.77821,
    longitude: -118.26087,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90744',
  },
  {
    city: 'Carson',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2693.7,
    imprecise: false,
    latitude: 33.82117,
    longitude: -118.26458,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90745',
  },
  {
    city: 'Carson',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1808,
    imprecise: false,
    latitude: 33.85855,
    longitude: -118.25518,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90746',
  },
  {
    city: 'Signal Hill',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2047.3,
    imprecise: false,
    latitude: 33.80274,
    longitude: -118.16747,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90755',
  },
  {
    city: 'Long Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2390.5,
    imprecise: false,
    latitude: 33.75035,
    longitude: -118.21143,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90802',
  },
  {
    city: 'Long Beach',
    county_fips: 6037,
    county_fips_all: '06037|06059',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles|Orange',
    county_weights: '{"06037": 99.87, "06059": 0.13}',
    density: 2994.8,
    imprecise: false,
    latitude: 33.76162,
    longitude: -118.12178,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90803',
  },
  {
    city: 'Long Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6809.4,
    imprecise: false,
    latitude: 33.78223,
    longitude: -118.14917,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90804',
  },
  {
    city: 'Long Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4808.9,
    imprecise: false,
    latitude: 33.86494,
    longitude: -118.18051,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 92402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90805',
  },
  {
    city: 'Long Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3292,
    imprecise: false,
    latitude: 33.80819,
    longitude: -118.17797,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90806',
  },
  {
    city: 'Long Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2890.9,
    imprecise: false,
    latitude: 33.83098,
    longitude: -118.18113,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90807',
  },
  {
    city: 'Long Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2210.7,
    imprecise: false,
    latitude: 33.82406,
    longitude: -118.11236,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90808',
  },
  {
    city: 'Long Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2115.6,
    imprecise: false,
    latitude: 33.81912,
    longitude: -118.22096,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90810',
  },
  {
    city: 'Long Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6424.5,
    imprecise: false,
    latitude: 33.78237,
    longitude: -118.19656,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 51241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90813',
  },
  {
    city: 'Long Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5640.8,
    imprecise: false,
    latitude: 33.7716,
    longitude: -118.14351,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90814',
  },
  {
    city: 'Long Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2354.9,
    imprecise: false,
    latitude: 33.79572,
    longitude: -118.11592,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90815',
  },
  {
    city: 'Long Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.76824,
    longitude: -118.20055,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90831',
  },
  {
    city: 'Altadena',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1658.2,
    imprecise: false,
    latitude: 34.19522,
    longitude: -118.13866,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91001',
  },
  {
    city: 'Arcadia',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1896.5,
    imprecise: false,
    latitude: 34.1352,
    longitude: -118.02667,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91006',
  },
  {
    city: 'Arcadia',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2316.4,
    imprecise: false,
    latitude: 34.12842,
    longitude: -118.04818,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33029,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91007',
  },
  {
    city: 'Duarte',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 149,
    imprecise: false,
    latitude: 34.15363,
    longitude: -117.96862,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91008',
  },
  {
    city: 'Duarte',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1656.3,
    imprecise: false,
    latitude: 34.14114,
    longitude: -117.95918,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91010',
  },
  {
    city: 'La Canada Flintridge',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 683.5,
    imprecise: false,
    latitude: 34.21757,
    longitude: -118.20346,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91011',
  },
  {
    city: 'Monrovia',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1873.6,
    imprecise: false,
    latitude: 34.15246,
    longitude: -118.00065,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91016',
  },
  {
    city: 'Montrose',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4047.6,
    imprecise: false,
    latitude: 34.21144,
    longitude: -118.23065,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91020',
  },
  {
    city: 'Sierra Madre',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1208.7,
    imprecise: false,
    latitude: 34.17177,
    longitude: -118.04654,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91024',
  },
  {
    city: 'South Pasadena',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2933.1,
    imprecise: false,
    latitude: 34.11029,
    longitude: -118.15748,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26068,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91030',
  },
  {
    city: 'Sunland',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 966.2,
    imprecise: false,
    latitude: 34.25861,
    longitude: -118.33468,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91040',
  },
  {
    city: 'Tujunga',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 208.8,
    imprecise: false,
    latitude: 34.30687,
    longitude: -118.25701,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91042',
  },
  {
    city: 'Verdugo City',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 8751.2,
    imprecise: false,
    latitude: 34.2117,
    longitude: -118.24092,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91046',
  },
  {
    city: 'Pasadena',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6433.2,
    imprecise: false,
    latitude: 34.14671,
    longitude: -118.13895,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91101',
  },
  {
    city: 'Pasadena',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2115.2,
    imprecise: false,
    latitude: 34.16738,
    longitude: -118.16446,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91103',
  },
  {
    city: 'Pasadena',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3679.7,
    imprecise: false,
    latitude: 34.16766,
    longitude: -118.12341,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91104',
  },
  {
    city: 'Pasadena',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1153.1,
    imprecise: false,
    latitude: 34.14045,
    longitude: -118.16716,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91105',
  },
  {
    city: 'Pasadena',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3398,
    imprecise: false,
    latitude: 34.13861,
    longitude: -118.12825,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91106',
  },
  {
    city: 'Pasadena',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1475.2,
    imprecise: false,
    latitude: 34.15919,
    longitude: -118.08688,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91107',
  },
  {
    city: 'San Marino',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1263.7,
    imprecise: false,
    latitude: 34.12232,
    longitude: -118.11363,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91108',
  },
  {
    city: 'Glendale',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3628.1,
    imprecise: false,
    latitude: 34.17041,
    longitude: -118.28902,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91201',
  },
  {
    city: 'Glendale',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1765.5,
    imprecise: false,
    latitude: 34.18221,
    longitude: -118.26761,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91202',
  },
  {
    city: 'Glendale',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 7413.5,
    imprecise: false,
    latitude: 34.15287,
    longitude: -118.26355,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91203',
  },
  {
    city: 'Glendale',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6602.7,
    imprecise: false,
    latitude: 34.13554,
    longitude: -118.26093,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91204',
  },
  {
    city: 'Glendale',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6978.3,
    imprecise: false,
    latitude: 34.13679,
    longitude: -118.24339,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91205',
  },
  {
    city: 'Glendale',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2141.1,
    imprecise: false,
    latitude: 34.16076,
    longitude: -118.21311,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91206',
  },
  {
    city: 'Glendale',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2533.5,
    imprecise: false,
    latitude: 34.16872,
    longitude: -118.24477,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91207',
  },
  {
    city: 'Glendale',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 834.2,
    imprecise: false,
    latitude: 34.19333,
    longitude: -118.23839,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91208',
  },
  {
    city: 'Glendale',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1261.8,
    imprecise: false,
    latitude: 34.14468,
    longitude: -118.25809,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91210',
  },
  {
    city: 'La Crescenta',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1634.8,
    imprecise: false,
    latitude: 34.23759,
    longitude: -118.24778,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91214',
  },
  {
    city: 'Agoura Hills',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 278.4,
    imprecise: false,
    latitude: 34.12314,
    longitude: -118.75685,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91301',
  },
  {
    city: 'Calabasas',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 359.6,
    imprecise: false,
    latitude: 34.12295,
    longitude: -118.67193,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91302',
  },
  {
    city: 'Canoga Park',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5439.8,
    imprecise: false,
    latitude: 34.19784,
    longitude: -118.6017,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91303',
  },
  {
    city: 'Canoga Park',
    county_fips: 6037,
    county_fips_all: '06037|06111',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles|Ventura',
    county_weights: '{"06037": 85.99, "06111": 14.01}',
    density: 2083.8,
    imprecise: false,
    latitude: 34.22472,
    longitude: -118.63261,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91304',
  },
  {
    city: 'Winnetka',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4381.2,
    imprecise: false,
    latitude: 34.20926,
    longitude: -118.5755,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91306',
  },
  {
    city: 'West Hills',
    county_fips: 6037,
    county_fips_all: '06037|06111',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles|Ventura',
    county_weights: '{"06037": 55.18, "06111": 44.82}',
    density: 1260.7,
    imprecise: false,
    latitude: 34.20177,
    longitude: -118.66226,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91307',
  },
  {
    city: 'Chatsworth',
    county_fips: 6037,
    county_fips_all: '06037|06111',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles|Ventura',
    county_weights: '{"06037": 96.78, "06111": 3.22}',
    density: 484.9,
    imprecise: false,
    latitude: 34.29011,
    longitude: -118.60776,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91311',
  },
  {
    city: 'Encino',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2086.4,
    imprecise: false,
    latitude: 34.15836,
    longitude: -118.51658,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91316',
  },
  {
    city: 'Newbury Park',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 831.9,
    imprecise: false,
    latitude: 34.17339,
    longitude: -118.94795,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91320',
  },
  {
    city: 'Newhall',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 463.3,
    imprecise: false,
    latitude: 34.36479,
    longitude: -118.4922,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91321',
  },
  {
    city: 'Northridge',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2783.9,
    imprecise: false,
    latitude: 34.23855,
    longitude: -118.55015,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91324',
  },
  {
    city: 'Northridge',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2811.1,
    imprecise: false,
    latitude: 34.23636,
    longitude: -118.51777,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91325',
  },
  {
    city: 'Porter Ranch',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1831.9,
    imprecise: false,
    latitude: 34.28022,
    longitude: -118.5566,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91326',
  },
  {
    city: 'Pacoima',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4033,
    imprecise: false,
    latitude: 34.25602,
    longitude: -118.41939,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 97608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91331',
  },
  {
    city: 'Reseda',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4382.2,
    imprecise: false,
    latitude: 34.20107,
    longitude: -118.5407,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 74526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91335',
  },
  {
    city: 'San Fernando',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3761.3,
    imprecise: false,
    latitude: 34.28668,
    longitude: -118.43479,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91340',
  },
  {
    city: 'Sylmar',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 792.7,
    imprecise: false,
    latitude: 34.31778,
    longitude: -118.39207,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 93301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91342',
  },
  {
    city: 'North Hills',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3962.2,
    imprecise: false,
    latitude: 34.23837,
    longitude: -118.48076,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 60783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91343',
  },
  {
    city: 'Granada Hills',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1412,
    imprecise: false,
    latitude: 34.28991,
    longitude: -118.5047,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91344',
  },
  {
    city: 'Mission Hills',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2227.3,
    imprecise: false,
    latitude: 34.26591,
    longitude: -118.45948,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91345',
  },
  {
    city: 'Santa Clarita',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1070.1,
    imprecise: false,
    latitude: 34.43028,
    longitude: -118.50283,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43973,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91350',
  },
  {
    city: 'Canyon Country',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1473.8,
    imprecise: false,
    latitude: 34.43269,
    longitude: -118.46276,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91351',
  },
  {
    city: 'Sun Valley',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1561,
    imprecise: false,
    latitude: 34.23183,
    longitude: -118.36596,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91352',
  },
  {
    city: 'Valencia',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1789.3,
    imprecise: false,
    latitude: 34.46039,
    longitude: -118.5528,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91354',
  },
  {
    city: 'Valencia',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 854.8,
    imprecise: false,
    latitude: 34.42379,
    longitude: -118.58437,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91355',
  },
  {
    city: 'Tarzana',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1629.1,
    imprecise: false,
    latitude: 34.15504,
    longitude: -118.54757,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91356',
  },
  {
    city: 'Thousand Oaks',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 1061.5,
    imprecise: false,
    latitude: 34.21475,
    longitude: -118.87735,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91360',
  },
  {
    city: 'Westlake Village',
    county_fips: 6111,
    county_fips_all: '06111|06037',
    county: 'Ventura',
    county_names_all: 'Ventura|Los Angeles',
    county_weights: '{"06111": 81.98, "06037": 18.02}',
    density: 251.5,
    imprecise: false,
    latitude: 34.14016,
    longitude: -118.88398,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18802,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91361',
  },
  {
    city: 'Thousand Oaks',
    county_fips: 6111,
    county_fips_all: '06111|06037',
    county: 'Ventura',
    county_names_all: 'Ventura|Los Angeles',
    county_weights: '{"06111": 94.55, "06037": 5.45}',
    density: 731.9,
    imprecise: false,
    latitude: 34.19244,
    longitude: -118.81949,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35996,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91362',
  },
  {
    city: 'Woodland Hills',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1421,
    imprecise: false,
    latitude: 34.1548,
    longitude: -118.59492,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91364',
  },
  {
    city: 'Woodland Hills',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2366.3,
    imprecise: false,
    latitude: 34.17708,
    longitude: -118.61518,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91367',
  },
  {
    city: 'Oak Park',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 984.6,
    imprecise: false,
    latitude: 34.1847,
    longitude: -118.76652,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91377',
  },
  {
    city: 'Stevenson Ranch',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 220.6,
    imprecise: false,
    latitude: 34.3753,
    longitude: -118.60744,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91381',
  },
  {
    city: 'Castaic',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 98.7,
    imprecise: false,
    latitude: 34.51604,
    longitude: -118.67289,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91384',
  },
  {
    city: 'Canyon Country',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 338.7,
    imprecise: false,
    latitude: 34.39708,
    longitude: -118.3707,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91387',
  },
  {
    city: 'Santa Clarita',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 47.1,
    imprecise: false,
    latitude: 34.53159,
    longitude: -118.40668,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91390',
  },
  {
    city: 'Van Nuys',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4280.3,
    imprecise: false,
    latitude: 34.17801,
    longitude: -118.43183,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91401',
  },
  {
    city: 'Panorama City',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6813.5,
    imprecise: false,
    latitude: 34.22413,
    longitude: -118.4448,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 65754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91402',
  },
  {
    city: 'Sherman Oaks',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2776.2,
    imprecise: false,
    latitude: 34.14716,
    longitude: -118.46311,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91403',
  },
  {
    city: 'Van Nuys',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6366.2,
    imprecise: false,
    latitude: 34.20153,
    longitude: -118.44863,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 56033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91405',
  },
  {
    city: 'Van Nuys',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2489.1,
    imprecise: false,
    latitude: 34.19791,
    longitude: -118.48987,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 51953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91406',
  },
  {
    city: 'Van Nuys',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4586.7,
    imprecise: false,
    latitude: 34.17853,
    longitude: -118.45956,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91411',
  },
  {
    city: 'Sherman Oaks',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3072.7,
    imprecise: false,
    latitude: 34.14924,
    longitude: -118.43239,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91423',
  },
  {
    city: 'Encino',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1181,
    imprecise: false,
    latitude: 34.15219,
    longitude: -118.49053,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91436',
  },
  {
    city: 'Burbank',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2691.3,
    imprecise: false,
    latitude: 34.19469,
    longitude: -118.29431,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91501',
  },
  {
    city: 'Burbank',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3349.3,
    imprecise: false,
    latitude: 34.17684,
    longitude: -118.30936,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91502',
  },
  {
    city: 'Burbank',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1119,
    imprecise: false,
    latitude: 34.21349,
    longitude: -118.31478,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91504',
  },
  {
    city: 'Burbank',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2289.4,
    imprecise: false,
    latitude: 34.17583,
    longitude: -118.34692,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91505',
  },
  {
    city: 'Burbank',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2965.5,
    imprecise: false,
    latitude: 34.17134,
    longitude: -118.32384,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91506',
  },
  {
    city: 'North Hollywood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5417.1,
    imprecise: false,
    latitude: 34.16827,
    longitude: -118.37222,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91601',
  },
  {
    city: 'North Hollywood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3966,
    imprecise: false,
    latitude: 34.15078,
    longitude: -118.36633,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91602',
  },
  {
    city: 'Studio City',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2644.6,
    imprecise: false,
    latitude: 34.13985,
    longitude: -118.39435,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91604',
  },
  {
    city: 'North Hollywood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3585.5,
    imprecise: false,
    latitude: 34.20699,
    longitude: -118.40067,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91605',
  },
  {
    city: 'North Hollywood',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 5052,
    imprecise: false,
    latitude: 34.18655,
    longitude: -118.38867,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91606',
  },
  {
    city: 'Valley Village',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4989.2,
    imprecise: false,
    latitude: 34.16633,
    longitude: -118.39982,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91607',
  },
  {
    city: 'Universal City',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 24.8,
    imprecise: false,
    latitude: 34.13839,
    longitude: -118.35272,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91608',
  },
  {
    city: 'Rancho Cucamonga',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 2052.1,
    imprecise: false,
    latitude: 34.13784,
    longitude: -117.60028,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91701',
  },
  {
    city: 'Azusa',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 361.6,
    imprecise: false,
    latitude: 34.24129,
    longitude: -117.82614,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 60903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91702',
  },
  {
    city: 'Baldwin Park',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2028.5,
    imprecise: false,
    latitude: 34.09627,
    longitude: -117.96855,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 71082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91706',
  },
  {
    city: 'Chino',
    county_fips: 6071,
    county_fips_all: '06071|06065',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino|Riverside',
    county_weights: '{"06071": 99.86, "06065": 0.14}',
    density: 917.2,
    imprecise: false,
    latitude: 33.95141,
    longitude: -117.64506,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91708',
  },
  {
    city: 'Chino Hills',
    county_fips: 6071,
    county_fips_all: '06071|06037',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino|Los Angeles',
    county_weights: '{"06071": 99.65, "06037": 0.35}',
    density: 672.1,
    imprecise: false,
    latitude: 33.95105,
    longitude: -117.72549,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 78006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91709',
  },
  {
    city: 'Chino',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 1380.1,
    imprecise: false,
    latitude: 34.00507,
    longitude: -117.68249,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 78754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91710',
  },
  {
    city: 'Claremont',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 970.1,
    imprecise: false,
    latitude: 34.12836,
    longitude: -117.71523,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91711',
  },
  {
    city: 'Covina',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3285.6,
    imprecise: false,
    latitude: 34.09731,
    longitude: -117.90612,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91722',
  },
  {
    city: 'Covina',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2934.7,
    imprecise: false,
    latitude: 34.08495,
    longitude: -117.88652,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17733,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91723',
  },
  {
    city: 'Covina',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1755.5,
    imprecise: false,
    latitude: 34.0805,
    longitude: -117.85515,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91724',
  },
  {
    city: 'Rancho Cucamonga',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 2013.9,
    imprecise: false,
    latitude: 34.10023,
    longitude: -117.5811,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 71613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91730',
  },
  {
    city: 'El Monte',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2809.7,
    imprecise: false,
    latitude: 34.07914,
    longitude: -118.04047,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91731',
  },
  {
    city: 'El Monte',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4884.6,
    imprecise: false,
    latitude: 34.07239,
    longitude: -118.01455,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91732',
  },
  {
    city: 'South El Monte',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2361,
    imprecise: false,
    latitude: 34.0454,
    longitude: -118.05314,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91733',
  },
  {
    city: 'Rancho Cucamonga',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 878.8,
    imprecise: false,
    latitude: 34.15523,
    longitude: -117.57808,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91737',
  },
  {
    city: 'Rancho Cucamonga',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 566.1,
    imprecise: false,
    latitude: 34.1622,
    longitude: -117.51558,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91739',
  },
  {
    city: 'Glendora',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2016.9,
    imprecise: false,
    latitude: 34.11884,
    longitude: -117.8534,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91740',
  },
  {
    city: 'Glendora',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 494.2,
    imprecise: false,
    latitude: 34.1647,
    longitude: -117.83197,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91741',
  },
  {
    city: 'La Puente',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3417.8,
    imprecise: false,
    latitude: 34.02914,
    longitude: -117.93735,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 76942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91744',
  },
  {
    city: 'Hacienda Heights',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1620.4,
    imprecise: false,
    latitude: 33.99926,
    longitude: -117.97225,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91745',
  },
  {
    city: 'La Puente',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1886.8,
    imprecise: false,
    latitude: 34.04397,
    longitude: -117.98785,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91746',
  },
  {
    city: 'Rowland Heights',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1156.6,
    imprecise: false,
    latitude: 33.9769,
    longitude: -117.89924,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91748',
  },
  {
    city: 'La Verne',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 680.9,
    imprecise: false,
    latitude: 34.14927,
    longitude: -117.76647,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91750',
  },
  {
    city: 'Mira Loma',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 972.4,
    imprecise: false,
    latitude: 33.99575,
    longitude: -117.53399,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91752',
  },
  {
    city: 'Monterey Park',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2754.9,
    imprecise: false,
    latitude: 34.051,
    longitude: -118.14451,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91754',
  },
  {
    city: 'Monterey Park',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3285.7,
    imprecise: false,
    latitude: 34.04832,
    longitude: -118.11496,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91755',
  },
  {
    city: 'Mt Baldy',
    county_fips: 6037,
    county_fips_all: '06037|06071',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles|San Bernardino',
    county_weights: '{"06037": 79.33, "06071": 20.67}',
    density: 1.6,
    imprecise: false,
    latitude: 34.2541,
    longitude: -117.69194,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91759',
  },
  {
    city: 'Ontario',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 852.8,
    imprecise: false,
    latitude: 34.03541,
    longitude: -117.5915,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 62935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91761',
  },
  {
    city: 'Ontario',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 1735.6,
    imprecise: false,
    latitude: 34.02764,
    longitude: -117.64308,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 64235,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91762',
  },
  {
    city: 'Montclair',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 2746.3,
    imprecise: false,
    latitude: 34.07208,
    longitude: -117.69828,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37700,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91763',
  },
  {
    city: 'Ontario',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 2747.8,
    imprecise: false,
    latitude: 34.07533,
    longitude: -117.60164,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 56270,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91764',
  },
  {
    city: 'Diamond Bar',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 925.1,
    imprecise: false,
    latitude: 33.98725,
    longitude: -117.81473,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91765',
  },
  {
    city: 'Pomona',
    county_fips: 6037,
    county_fips_all: '06037|06071',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles|San Bernardino',
    county_weights: '{"06037": 95.85, "06071": 4.15}',
    density: 2650.6,
    imprecise: false,
    latitude: 34.04192,
    longitude: -117.75698,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 69327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91766',
  },
  {
    city: 'Pomona',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3338.4,
    imprecise: false,
    latitude: 34.08143,
    longitude: -117.73868,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91767',
  },
  {
    city: 'Pomona',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1610.3,
    imprecise: false,
    latitude: 34.06358,
    longitude: -117.78941,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91768',
  },
  {
    city: 'Rosemead',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3455,
    imprecise: false,
    latitude: 34.06395,
    longitude: -118.08361,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 58382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91770',
  },
  {
    city: 'San Dimas',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 866.2,
    imprecise: false,
    latitude: 34.1072,
    longitude: -117.80928,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91773',
  },
  {
    city: 'San Gabriel',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2948.9,
    imprecise: false,
    latitude: 34.11454,
    longitude: -118.08946,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91775',
  },
  {
    city: 'San Gabriel',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4270.6,
    imprecise: false,
    latitude: 34.08987,
    longitude: -118.09519,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91776',
  },
  {
    city: 'Temple City',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3573.3,
    imprecise: false,
    latitude: 34.10152,
    longitude: -118.05584,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91780',
  },
  {
    city: 'Upland',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 1135.7,
    imprecise: false,
    latitude: 34.14103,
    longitude: -117.65831,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26886,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91784',
  },
  {
    city: 'Upland',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 2410.3,
    imprecise: false,
    latitude: 34.10525,
    longitude: -117.66206,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 55829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91786',
  },
  {
    city: 'Walnut',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 980.6,
    imprecise: false,
    latitude: 34.01858,
    longitude: -117.85408,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91789',
  },
  {
    city: 'West Covina',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2999.3,
    imprecise: false,
    latitude: 34.06722,
    longitude: -117.93788,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91790',
  },
  {
    city: 'West Covina',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1919.9,
    imprecise: false,
    latitude: 34.06134,
    longitude: -117.89425,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91791',
  },
  {
    city: 'West Covina',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3078.4,
    imprecise: false,
    latitude: 34.02586,
    longitude: -117.89989,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91792',
  },
  {
    city: 'Alhambra',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4766.5,
    imprecise: false,
    latitude: 34.09093,
    longitude: -118.12776,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 53381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91801',
  },
  {
    city: 'Alhambra',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3282.6,
    imprecise: false,
    latitude: 34.0749,
    longitude: -118.14624,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91803',
  },
  {
    city: 'Alpine',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 90.2,
    imprecise: false,
    latitude: 32.81467,
    longitude: -116.71929,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91901',
  },
  {
    city: 'Bonita',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 609.2,
    imprecise: false,
    latitude: 32.67479,
    longitude: -117.00475,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91902',
  },
  {
    city: 'Boulevard',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 32.67773,
    longitude: -116.30734,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91905',
  },
  {
    city: 'Campo',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 12.2,
    imprecise: false,
    latitude: 32.66241,
    longitude: -116.47255,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91906',
  },
  {
    city: 'Chula Vista',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2365.8,
    imprecise: false,
    latitude: 32.63653,
    longitude: -117.06301,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 77123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91910',
  },
  {
    city: 'Chula Vista',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2595,
    imprecise: false,
    latitude: 32.60686,
    longitude: -117.04984,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 85542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91911',
  },
  {
    city: 'Chula Vista',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2450.2,
    imprecise: false,
    latitude: 32.62174,
    longitude: -116.98609,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91913',
  },
  {
    city: 'Chula Vista',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 980.8,
    imprecise: false,
    latitude: 32.66604,
    longitude: -116.95426,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16877,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91914',
  },
  {
    city: 'Chula Vista',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1764.5,
    imprecise: false,
    latitude: 32.62266,
    longitude: -116.95013,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91915',
  },
  {
    city: 'Descanso',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 32.91103,
    longitude: -116.63201,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91916',
  },
  {
    city: 'Dulzura',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 32.6267,
    longitude: -116.71894,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91917',
  },
  {
    city: 'Guatay',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 23.2,
    imprecise: false,
    latitude: 32.83758,
    longitude: -116.58029,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91931',
  },
  {
    city: 'Imperial Beach',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2323.9,
    imprecise: false,
    latitude: 32.56923,
    longitude: -117.11798,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91932',
  },
  {
    city: 'Jacumba',
    county_fips: 6073,
    county_fips_all: '06073|06025',
    county: 'San Diego',
    county_names_all: 'San Diego|Imperial',
    county_weights: '{"06073": 99.87, "06025": 0.13}',
    density: 9,
    imprecise: false,
    latitude: 32.66488,
    longitude: -116.16828,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91934',
  },
  {
    city: 'Jamul',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 33.4,
    imprecise: false,
    latitude: 32.70214,
    longitude: -116.78721,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91935',
  },
  {
    city: 'La Mesa',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1559.7,
    imprecise: false,
    latitude: 32.75964,
    longitude: -116.99253,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91941',
  },
  {
    city: 'La Mesa',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2771.8,
    imprecise: false,
    latitude: 32.77728,
    longitude: -117.02129,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91942',
  },
  {
    city: 'Lemon Grove',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2710,
    imprecise: false,
    latitude: 32.73315,
    longitude: -117.03402,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91945',
  },
  {
    city: 'Mount Laguna',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1,
    imprecise: false,
    latitude: 32.87509,
    longitude: -116.47076,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91948',
  },
  {
    city: 'National City',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 3151.5,
    imprecise: false,
    latitude: 32.66952,
    longitude: -117.09313,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 59891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91950',
  },
  {
    city: 'Pine Valley',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 32.79248,
    longitude: -116.48044,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91962',
  },
  {
    city: 'Potrero',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 32.64798,
    longitude: -116.5964,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91963',
  },
  {
    city: 'Spring Valley',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2377.2,
    imprecise: false,
    latitude: 32.72387,
    longitude: -116.99631,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 61064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91977',
  },
  {
    city: 'Spring Valley',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 323.8,
    imprecise: false,
    latitude: 32.71209,
    longitude: -116.94103,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91978',
  },
  {
    city: 'Tecate',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 32.58685,
    longitude: -116.61969,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91980',
  },
  {
    city: 'Bonsall',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 130.1,
    imprecise: false,
    latitude: 33.28701,
    longitude: -117.19977,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92003',
  },
  {
    city: 'Borrego Springs',
    county_fips: 6073,
    county_fips_all: '06073|06025',
    county: 'San Diego',
    county_names_all: 'San Diego|Imperial',
    county_weights: '{"06073": 58.05, "06025": 41.95}',
    density: 1.3,
    imprecise: false,
    latitude: 33.18481,
    longitude: -116.15688,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92004',
  },
  {
    city: 'Cardiff By The Sea',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1853.2,
    imprecise: false,
    latitude: 33.02216,
    longitude: -117.27389,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92007',
  },
  {
    city: 'Carlsbad',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1037.8,
    imprecise: false,
    latitude: 33.14564,
    longitude: -117.31691,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92008',
  },
  {
    city: 'Carlsbad',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1417.6,
    imprecise: false,
    latitude: 33.09535,
    longitude: -117.24574,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92009',
  },
  {
    city: 'Carlsbad',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 866.1,
    imprecise: false,
    latitude: 33.15676,
    longitude: -117.28423,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92010',
  },
  {
    city: 'Carlsbad',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1369.7,
    imprecise: false,
    latitude: 33.10698,
    longitude: -117.29507,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92011',
  },
  {
    city: 'Del Mar',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 802.5,
    imprecise: false,
    latitude: 32.96797,
    longitude: -117.24879,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92014',
  },
  {
    city: 'El Cajon',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 551.8,
    imprecise: false,
    latitude: 32.77886,
    longitude: -116.87142,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92019',
  },
  {
    city: 'El Cajon',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2009.1,
    imprecise: false,
    latitude: 32.79557,
    longitude: -116.9697,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92020',
  },
  {
    city: 'El Cajon',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 970.8,
    imprecise: false,
    latitude: 32.83514,
    longitude: -116.87462,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 70501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92021',
  },
  {
    city: 'Encinitas',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1084.2,
    imprecise: false,
    latitude: 33.05716,
    longitude: -117.25651,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92024',
  },
  {
    city: 'Escondido',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 862.7,
    imprecise: false,
    latitude: 33.08492,
    longitude: -117.02967,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92025',
  },
  {
    city: 'Escondido',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 568.3,
    imprecise: false,
    latitude: 33.2111,
    longitude: -117.11157,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 53075,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92026',
  },
  {
    city: 'Escondido',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 350.2,
    imprecise: false,
    latitude: 33.13263,
    longitude: -116.98335,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92027',
  },
  {
    city: 'Fallbrook',
    county_fips: 6073,
    county_fips_all: '06073|06065',
    county: 'San Diego',
    county_names_all: 'San Diego|Riverside',
    county_weights: '{"06073": 99.29, "06065": 0.71}',
    density: 172.8,
    imprecise: false,
    latitude: 33.38613,
    longitude: -117.22658,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92028',
  },
  {
    city: 'Escondido',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 354.7,
    imprecise: false,
    latitude: 33.08555,
    longitude: -117.12885,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92029',
  },
  {
    city: 'Julian',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 33.01137,
    longitude: -116.37672,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92036',
  },
  {
    city: 'La Jolla',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1305,
    imprecise: false,
    latitude: 32.85257,
    longitude: -117.25104,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92037',
  },
  {
    city: 'Lakeside',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 265.6,
    imprecise: false,
    latitude: 32.90665,
    longitude: -116.88875,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92040',
  },
  {
    city: 'Oceanside',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1985.1,
    imprecise: false,
    latitude: 33.19377,
    longitude: -117.35508,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92054',
  },
  {
    city: 'Oceanside',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1681.7,
    imprecise: false,
    latitude: 33.20197,
    longitude: -117.28939,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 53616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92056',
  },
  {
    city: 'Oceanside',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1466.5,
    imprecise: false,
    latitude: 33.25326,
    longitude: -117.28704,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 56835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92057',
  },
  {
    city: 'Oceanside',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 434.7,
    imprecise: false,
    latitude: 33.28379,
    longitude: -117.34182,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92058',
  },
  {
    city: 'Pala',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 19,
    imprecise: false,
    latitude: 33.38277,
    longitude: -117.05193,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92059',
  },
  {
    city: 'Palomar Mountain',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 33.35043,
    longitude: -116.86451,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92060',
  },
  {
    city: 'Pauma Valley',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 33.30036,
    longitude: -116.93048,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92061',
  },
  {
    city: 'Poway',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 444,
    imprecise: false,
    latitude: 32.98038,
    longitude: -117.01746,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92064',
  },
  {
    city: 'Ramona',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 83.8,
    imprecise: false,
    latitude: 33.04736,
    longitude: -116.84386,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92065',
  },
  {
    city: 'Ranchita',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 33.21541,
    longitude: -116.53583,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92066',
  },
  {
    city: 'Rancho Santa Fe',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 136.9,
    imprecise: false,
    latitude: 33.02087,
    longitude: -117.19209,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92067',
  },
  {
    city: 'San Marcos',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 989.5,
    imprecise: false,
    latitude: 33.17536,
    longitude: -117.15761,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92069',
  },
  {
    city: 'Santa Ysabel',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 33.18513,
    longitude: -116.74071,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92070',
  },
  {
    city: 'Santee',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1220.6,
    imprecise: false,
    latitude: 32.85045,
    longitude: -116.99479,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 59590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92071',
  },
  {
    city: 'Solana Beach',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1349,
    imprecise: false,
    latitude: 32.99735,
    longitude: -117.25875,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92075',
  },
  {
    city: 'San Marcos',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1239.3,
    imprecise: false,
    latitude: 33.11834,
    longitude: -117.18554,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 53605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92078',
  },
  {
    city: 'Vista',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1253.2,
    imprecise: false,
    latitude: 33.16451,
    longitude: -117.24056,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92081',
  },
  {
    city: 'Valley Center',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 66.7,
    imprecise: false,
    latitude: 33.2518,
    longitude: -117.00284,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92082',
  },
  {
    city: 'Vista',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2671.1,
    imprecise: false,
    latitude: 33.19808,
    longitude: -117.24844,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92083',
  },
  {
    city: 'Vista',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 677.4,
    imprecise: false,
    latitude: 33.22454,
    longitude: -117.20334,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92084',
  },
  {
    city: 'Warner Springs',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 33.29718,
    longitude: -116.64176,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92086',
  },
  {
    city: 'Rancho Santa Fe',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 290.9,
    imprecise: false,
    latitude: 33.03432,
    longitude: -117.19704,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92091',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 3715.3,
    imprecise: false,
    latitude: 32.7162,
    longitude: -117.18589,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 51805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92101',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 3344.6,
    imprecise: false,
    latitude: 32.71595,
    longitude: -117.11749,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92102',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 3650.2,
    imprecise: false,
    latitude: 32.74782,
    longitude: -117.16738,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92103',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 4954.6,
    imprecise: false,
    latitude: 32.74191,
    longitude: -117.12781,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92104',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 4790.5,
    imprecise: false,
    latitude: 32.73756,
    longitude: -117.09193,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 71411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92105',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1475.9,
    imprecise: false,
    latitude: 32.71334,
    longitude: -117.23617,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21651,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92106',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 3680.3,
    imprecise: false,
    latitude: 32.7402,
    longitude: -117.24357,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92107',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2346.5,
    imprecise: false,
    latitude: 32.77423,
    longitude: -117.14097,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26790,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92108',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2274.3,
    imprecise: false,
    latitude: 32.78699,
    longitude: -117.23273,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92109',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2383,
    imprecise: false,
    latitude: 32.76533,
    longitude: -117.19965,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92110',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2060.6,
    imprecise: false,
    latitude: 32.8065,
    longitude: -117.16897,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92111',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 4127.2,
    imprecise: false,
    latitude: 32.69591,
    longitude: -117.12012,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92113',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 3062.7,
    imprecise: false,
    latitude: 32.70778,
    longitude: -117.05529,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 65745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92114',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 4147,
    imprecise: false,
    latitude: 32.76154,
    longitude: -117.07187,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 66264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92115',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 3637.7,
    imprecise: false,
    latitude: 32.76484,
    longitude: -117.12303,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92116',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2319.2,
    imprecise: false,
    latitude: 32.82493,
    longitude: -117.19972,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92117',
  },
  {
    city: 'Coronado',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 950.4,
    imprecise: false,
    latitude: 32.67466,
    longitude: -117.16915,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92118',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1438.4,
    imprecise: false,
    latitude: 32.80896,
    longitude: -117.03232,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92119',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1604.4,
    imprecise: false,
    latitude: 32.79526,
    longitude: -117.07317,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92120',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 122.4,
    imprecise: false,
    latitude: 32.8973,
    longitude: -117.20231,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92121',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 3260.1,
    imprecise: false,
    latitude: 32.85681,
    longitude: -117.21017,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92122',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1481.4,
    imprecise: false,
    latitude: 32.80958,
    longitude: -117.13419,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92123',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1202.6,
    imprecise: false,
    latitude: 32.82823,
    longitude: -117.08528,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92124',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 2534.6,
    imprecise: false,
    latitude: 32.912,
    longitude: -117.14344,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 76059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92126',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 860.9,
    imprecise: false,
    latitude: 33.01913,
    longitude: -117.12339,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92127',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1616,
    imprecise: false,
    latitude: 32.99687,
    longitude: -117.07308,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92128',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1563,
    imprecise: false,
    latitude: 32.96354,
    longitude: -117.12622,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92129',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1263.9,
    imprecise: false,
    latitude: 32.94763,
    longitude: -117.20586,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 60768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92130',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 354.7,
    imprecise: false,
    latitude: 32.89604,
    longitude: -117.05737,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92131',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 3745.1,
    imprecise: false,
    latitude: 32.68006,
    longitude: -117.04889,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92139',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 605.4,
    imprecise: false,
    latitude: 32.578,
    longitude: -116.96621,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 80445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92154',
  },
  {
    city: 'San Ysidro',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 3701.5,
    imprecise: false,
    latitude: 32.55552,
    longitude: -117.05114,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92173',
  },
  {
    city: 'Indio',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 1567.6,
    imprecise: false,
    latitude: 33.70804,
    longitude: -116.23502,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 65825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92201',
  },
  {
    city: 'Indio',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 726.7,
    imprecise: false,
    latitude: 33.75159,
    longitude: -116.24139,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92203',
  },
  {
    city: 'Indian Wells',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 131.2,
    imprecise: false,
    latitude: 33.70357,
    longitude: -116.33953,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92210',
  },
  {
    city: 'Palm Desert',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 731.6,
    imprecise: false,
    latitude: 33.76593,
    longitude: -116.33241,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92211',
  },
  {
    city: 'Banning',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 92.2,
    imprecise: false,
    latitude: 33.93992,
    longitude: -116.83935,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92220',
  },
  {
    city: 'Bard',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.78346,
    longitude: -114.54965,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92222',
  },
  {
    city: 'Beaumont',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 547.8,
    imprecise: false,
    latitude: 33.9382,
    longitude: -116.98137,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 63833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92223',
  },
  {
    city: 'Blythe',
    county_fips: 6065,
    county_fips_all: '06065|06025',
    county: 'Riverside',
    county_names_all: 'Riverside|Imperial',
    county_weights: '{"06065": 99.52, "06025": 0.48}',
    density: 13.5,
    imprecise: false,
    latitude: 33.71642,
    longitude: -114.65606,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92225',
  },
  {
    city: 'Brawley',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 32.98677,
    longitude: -115.3341,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92227',
  },
  {
    city: 'Cabazon',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 62.4,
    imprecise: false,
    latitude: 33.9088,
    longitude: -116.76879,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92230',
  },
  {
    city: 'Calexico',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 217.5,
    imprecise: false,
    latitude: 32.68751,
    longitude: -115.56433,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92231',
  },
  {
    city: 'Calipatria',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 33.14736,
    longitude: -115.50686,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92233',
  },
  {
    city: 'Cathedral City',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 1366.9,
    imprecise: false,
    latitude: 33.81386,
    longitude: -116.46663,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92234',
  },
  {
    city: 'Coachella',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 272.4,
    imprecise: false,
    latitude: 33.70276,
    longitude: -116.07254,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43642,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92236',
  },
  {
    city: 'Desert Center',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 33.87424,
    longitude: -115.24396,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92239',
  },
  {
    city: 'Desert Hot Springs',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 450,
    imprecise: false,
    latitude: 33.95291,
    longitude: -116.5194,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92240',
  },
  {
    city: 'Desert Hot Springs',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 25.9,
    imprecise: false,
    latitude: 33.84634,
    longitude: -116.28342,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92241',
  },
  {
    city: 'Earp',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 34.19019,
    longitude: -114.30755,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92242',
  },
  {
    city: 'El Centro',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 167.2,
    imprecise: false,
    latitude: 32.77285,
    longitude: -115.60065,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49069,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92243',
  },
  {
    city: 'Heber',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 142.1,
    imprecise: false,
    latitude: 32.72606,
    longitude: -115.48218,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92249',
  },
  {
    city: 'Holtville',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 32.79188,
    longitude: -115.23454,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92250',
  },
  {
    city: 'Imperial',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 42.9,
    imprecise: false,
    latitude: 32.87129,
    longitude: -115.71804,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92251',
  },
  {
    city: 'Joshua Tree',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 25.9,
    imprecise: false,
    latitude: 34.14801,
    longitude: -116.28422,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92252',
  },
  {
    city: 'La Quinta',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 369.2,
    imprecise: false,
    latitude: 33.65562,
    longitude: -116.28785,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92253',
  },
  {
    city: 'Mecca',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 91.4,
    imprecise: false,
    latitude: 33.54371,
    longitude: -115.99995,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92254',
  },
  {
    city: 'Morongo Valley',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 34.07207,
    longitude: -116.61761,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92256',
  },
  {
    city: 'Niland',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 33.33976,
    longitude: -115.52814,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92257',
  },
  {
    city: 'North Palm Springs',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 33.91791,
    longitude: -116.56002,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92258',
  },
  {
    city: 'Ocotillo',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 32.73478,
    longitude: -115.94632,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92259',
  },
  {
    city: 'Palm Desert',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 376.2,
    imprecise: false,
    latitude: 33.69841,
    longitude: -116.40519,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92260',
  },
  {
    city: 'Palm Springs',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 295.7,
    imprecise: false,
    latitude: 33.86287,
    longitude: -116.55736,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92262',
  },
  {
    city: 'Palm Springs',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 150.9,
    imprecise: false,
    latitude: 33.73575,
    longitude: -116.50544,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92264',
  },
  {
    city: 'Palo Verde',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.17507,
    longitude: -114.92594,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92266',
  },
  {
    city: 'Parker Dam',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.29765,
    longitude: -114.20138,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92267',
  },
  {
    city: 'Pioneertown',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 34.16146,
    longitude: -116.55002,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 434,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92268',
  },
  {
    city: 'Rancho Mirage',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 264.6,
    imprecise: false,
    latitude: 33.76399,
    longitude: -116.42705,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17563,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92270',
  },
  {
    city: 'Seeley',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 130.2,
    imprecise: false,
    latitude: 32.80798,
    longitude: -115.69592,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92273',
  },
  {
    city: 'Thermal',
    county_fips: 6065,
    county_fips_all: '06065|06025',
    county: 'Riverside',
    county_names_all: 'Riverside|Imperial',
    county_weights: '{"06065": 66.12, "06025": 33.88}',
    density: 32.4,
    imprecise: false,
    latitude: 33.47031,
    longitude: -116.11387,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92274',
  },
  {
    city: 'Salton City',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 33.20783,
    longitude: -115.88084,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92275',
  },
  {
    city: 'Thousand Palms',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 80.5,
    imprecise: false,
    latitude: 33.83234,
    longitude: -116.38648,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7720,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92276',
  },
  {
    city: 'Twentynine Palms',
    county_fips: 6071,
    county_fips_all: '06071|06065',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino|Riverside',
    county_weights: '{"06071": 78.07, "06065": 21.93}',
    density: 6.3,
    imprecise: false,
    latitude: 34.11248,
    longitude: -115.68752,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92277',
  },
  {
    city: 'Twentynine Palms',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 3849.3,
    imprecise: false,
    latitude: 34.23505,
    longitude: -116.05825,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92278',
  },
  {
    city: 'Vidal',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.13963,
    longitude: -114.84652,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92280',
  },
  {
    city: 'Westmorland',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 60.9,
    imprecise: false,
    latitude: 33.05033,
    longitude: -115.61264,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92281',
  },
  {
    city: 'Whitewater',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 33.96253,
    longitude: -116.65829,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92282',
  },
  {
    city: 'Winterhaven',
    county_fips: 6025,
    county_fips_all: '06025',
    county: 'Imperial',
    county_names_all: 'Imperial',
    county_weights: '{"06025": 100}',
    density: 2,
    imprecise: false,
    latitude: 32.83741,
    longitude: -114.79462,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92283',
  },
  {
    city: 'Yucca Valley',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 77,
    imprecise: false,
    latitude: 34.16013,
    longitude: -116.42474,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92284',
  },
  {
    city: 'Landers',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 34.33762,
    longitude: -116.51364,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92285',
  },
  {
    city: 'Adelanto',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 66.3,
    imprecise: false,
    latitude: 34.65183,
    longitude: -117.52617,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92301',
  },
  {
    city: 'Amboy',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.53062,
    longitude: -115.65933,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92304',
  },
  {
    city: 'Angelus Oaks',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 34.17018,
    longitude: -116.83231,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92305',
  },
  {
    city: 'Apple Valley',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 84.8,
    imprecise: false,
    latitude: 34.59078,
    longitude: -117.14127,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92307',
  },
  {
    city: 'Apple Valley',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 159.7,
    imprecise: false,
    latitude: 34.42005,
    longitude: -117.15558,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42709,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92308',
  },
  {
    city: 'Baker',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 35.24942,
    longitude: -116.15578,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 343,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92309',
  },
  {
    city: 'Fort Irwin',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 39.3,
    imprecise: false,
    latitude: 35.33443,
    longitude: -116.76306,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92310',
  },
  {
    city: 'Barstow',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 30.9,
    imprecise: false,
    latitude: 34.97204,
    longitude: -117.0101,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92311',
  },
  {
    city: 'Grand Terrace',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 1396.9,
    imprecise: false,
    latitude: 34.03142,
    longitude: -117.31373,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92313',
  },
  {
    city: 'Big Bear City',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 98.4,
    imprecise: false,
    latitude: 34.2576,
    longitude: -116.80075,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92314',
  },
  {
    city: 'Big Bear Lake',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 68.5,
    imprecise: false,
    latitude: 34.22011,
    longitude: -116.95301,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92315',
  },
  {
    city: 'Bloomington',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 1098.7,
    imprecise: false,
    latitude: 34.0576,
    longitude: -117.39076,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92316',
  },
  {
    city: 'Blue Jay',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 220.2,
    imprecise: false,
    latitude: 34.24507,
    longitude: -117.20874,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 916,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92317',
  },
  {
    city: 'Calimesa',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 301.8,
    imprecise: false,
    latitude: 33.9874,
    longitude: -117.05024,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92320',
  },
  {
    city: 'Cedar Glen',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 39.2,
    imprecise: false,
    latitude: 34.24748,
    longitude: -117.14694,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92321',
  },
  {
    city: 'Cedarpines Park',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 90.4,
    imprecise: false,
    latitude: 34.25419,
    longitude: -117.32259,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92322',
  },
  {
    city: 'Colton',
    county_fips: 6071,
    county_fips_all: '06071|06065',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino|Riverside',
    county_weights: '{"06071": 68.44, "06065": 31.56}',
    density: 797.5,
    imprecise: false,
    latitude: 34.03398,
    longitude: -117.29008,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92324',
  },
  {
    city: 'Crestline',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 400.5,
    imprecise: false,
    latitude: 34.24554,
    longitude: -117.27506,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92325',
  },
  {
    city: 'Daggett',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 34.86632,
    longitude: -116.84347,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 576,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92327',
  },
  {
    city: 'Death Valley',
    county_fips: 6027,
    county_fips_all: '06027',
    county: 'Inyo',
    county_names_all: 'Inyo',
    county_weights: '{"06027": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 36.39482,
    longitude: -117.02718,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92328',
  },
  {
    city: 'Essex',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.90728,
    longitude: -115.36409,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92332',
  },
  {
    city: 'Fawnskin',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 34.26951,
    longitude: -116.96277,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92333',
  },
  {
    city: 'Fontana',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 2156.6,
    imprecise: false,
    latitude: 34.08733,
    longitude: -117.46519,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 97511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92335',
  },
  {
    city: 'Fontana',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 2048.8,
    imprecise: false,
    latitude: 34.13686,
    longitude: -117.46033,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 105517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92336',
  },
  {
    city: 'Fontana',
    county_fips: 6071,
    county_fips_all: '06071|06065',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino|Riverside',
    county_weights: '{"06071": 99.88, "06065": 0.12}',
    density: 1015.4,
    imprecise: false,
    latitude: 34.04967,
    longitude: -117.47145,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92337',
  },
  {
    city: 'Ludlow',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.78773,
    longitude: -116.25117,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92338',
  },
  {
    city: 'Forest Falls',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 34.08189,
    longitude: -116.83838,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92339',
  },
  {
    city: 'Green Valley Lake',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 34.24009,
    longitude: -117.06798,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92341',
  },
  {
    city: 'Helendale',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 34.76078,
    longitude: -117.33795,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92342',
  },
  {
    city: 'Hesperia',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 219.3,
    imprecise: false,
    latitude: 34.39176,
    longitude: -117.40657,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92344',
  },
  {
    city: 'Hesperia',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 346.4,
    imprecise: false,
    latitude: 34.36415,
    longitude: -117.30984,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 88706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92345',
  },
  {
    city: 'Highland',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 800,
    imprecise: false,
    latitude: 34.12629,
    longitude: -117.1792,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 56179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92346',
  },
  {
    city: 'Hinkley',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 34.95003,
    longitude: -117.25802,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92347',
  },
  {
    city: 'Lake Arrowhead',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 209.1,
    imprecise: false,
    latitude: 34.26824,
    longitude: -117.18486,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92352',
  },
  {
    city: 'Loma Linda',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 1709.8,
    imprecise: false,
    latitude: 34.04933,
    longitude: -117.25119,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92354',
  },
  {
    city: 'Lucerne Valley',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 34.49633,
    longitude: -116.89265,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6543,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92356',
  },
  {
    city: 'Lytle Creek',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 34.24624,
    longitude: -117.56762,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92358',
  },
  {
    city: 'Mentone',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 186.7,
    imprecise: false,
    latitude: 34.08296,
    longitude: -117.07026,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92359',
  },
  {
    city: 'Needles',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 34.70863,
    longitude: -114.57562,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92363',
  },
  {
    city: 'Nipton',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.35678,
    longitude: -115.43741,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92364',
  },
  {
    city: 'Newberry Springs',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 34.88843,
    longitude: -116.54129,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92365',
  },
  {
    city: 'Oro Grande',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 7,
    imprecise: false,
    latitude: 34.65508,
    longitude: -117.30893,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92368',
  },
  {
    city: 'Patton',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 2673.4,
    imprecise: false,
    latitude: 34.13941,
    longitude: -117.21966,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92369',
  },
  {
    city: 'Phelan',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 63.1,
    imprecise: false,
    latitude: 34.43837,
    longitude: -117.54266,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92371',
  },
  {
    city: 'Pinon Hills',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 77.3,
    imprecise: false,
    latitude: 34.45097,
    longitude: -117.62859,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92372',
  },
  {
    city: 'Redlands',
    county_fips: 6071,
    county_fips_all: '06071|06065',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino|Riverside',
    county_weights: '{"06071": 58.04, "06065": 41.96}',
    density: 341.7,
    imprecise: false,
    latitude: 34.00648,
    longitude: -117.15351,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92373',
  },
  {
    city: 'Redlands',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 973.7,
    imprecise: false,
    latitude: 34.06738,
    longitude: -117.17482,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92374',
  },
  {
    city: 'Rialto',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 2445.5,
    imprecise: false,
    latitude: 34.11053,
    longitude: -117.37997,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 84394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92376',
  },
  {
    city: 'Rialto',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 1117.1,
    imprecise: false,
    latitude: 34.15234,
    longitude: -117.40412,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92377',
  },
  {
    city: 'Rimforest',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 151.6,
    imprecise: false,
    latitude: 34.23206,
    longitude: -117.22483,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92378',
  },
  {
    city: 'Running Springs',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 98.6,
    imprecise: false,
    latitude: 34.20604,
    longitude: -117.11276,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92382',
  },
  {
    city: 'Shoshone',
    county_fips: 6027,
    county_fips_all: '06027',
    county: 'Inyo',
    county_names_all: 'Inyo',
    county_weights: '{"06027": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.98255,
    longitude: -116.1505,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92384',
  },
  {
    city: 'Skyforest',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 34.21345,
    longitude: -117.23057,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92385',
  },
  {
    city: 'Sugarloaf',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 343.3,
    imprecise: false,
    latitude: 34.23702,
    longitude: -116.82523,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92386',
  },
  {
    city: 'Tecopa',
    county_fips: 6027,
    county_fips_all: '06027',
    county: 'Inyo',
    county_names_all: 'Inyo',
    county_weights: '{"06027": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 35.82902,
    longitude: -116.24813,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92389',
  },
  {
    city: 'Twin Peaks',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 439.8,
    imprecise: false,
    latitude: 34.23958,
    longitude: -117.23665,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92391',
  },
  {
    city: 'Victorville',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 677.4,
    imprecise: false,
    latitude: 34.479,
    longitude: -117.40884,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 65429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92392',
  },
  {
    city: 'Victorville',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 501.5,
    imprecise: false,
    latitude: 34.563,
    longitude: -117.3542,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92394',
  },
  {
    city: 'Victorville',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 1082.9,
    imprecise: false,
    latitude: 34.50032,
    longitude: -117.29479,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92395',
  },
  {
    city: 'Wrightwood',
    county_fips: 6037,
    county_fips_all: '06037|06071',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles|San Bernardino',
    county_weights: '{"06037": 66.3, "06071": 33.7}',
    density: 47.5,
    imprecise: false,
    latitude: 34.36212,
    longitude: -117.69136,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92397',
  },
  {
    city: 'Yermo',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 10.1,
    imprecise: false,
    latitude: 34.97178,
    longitude: -116.83808,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92398',
  },
  {
    city: 'Yucaipa',
    county_fips: 6071,
    county_fips_all: '06071|06065',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino|Riverside',
    county_weights: '{"06071": 99.02, "06065": 0.98}',
    density: 398.6,
    imprecise: false,
    latitude: 34.04469,
    longitude: -117.004,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 55366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92399',
  },
  {
    city: 'San Bernardino',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 941.8,
    imprecise: false,
    latitude: 34.10586,
    longitude: -117.29188,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92401',
  },
  {
    city: 'San Bernardino',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 773,
    imprecise: false,
    latitude: 34.17862,
    longitude: -117.23891,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 63243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92404',
  },
  {
    city: 'San Bernardino',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 2405.6,
    imprecise: false,
    latitude: 34.14578,
    longitude: -117.30225,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92405',
  },
  {
    city: 'San Bernardino',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 339,
    imprecise: false,
    latitude: 34.22394,
    longitude: -117.38839,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 71711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92407',
  },
  {
    city: 'San Bernardino',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 527.7,
    imprecise: false,
    latitude: 34.0845,
    longitude: -117.2653,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92408',
  },
  {
    city: 'San Bernardino',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 2244.4,
    imprecise: false,
    latitude: 34.10655,
    longitude: -117.29574,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92410',
  },
  {
    city: 'San Bernardino',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 2235.9,
    imprecise: false,
    latitude: 34.12214,
    longitude: -117.32291,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92411',
  },
  {
    city: 'Riverside',
    county_fips: 6065,
    county_fips_all: '06065|06071',
    county: 'Riverside',
    county_names_all: 'Riverside|San Bernardino',
    county_weights: '{"06065": 99.79, "06071": 0.21}',
    density: 1570.4,
    imprecise: false,
    latitude: 33.99496,
    longitude: -117.37367,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92501',
  },
  {
    city: 'Riverside',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 994.2,
    imprecise: false,
    latitude: 33.88308,
    longitude: -117.45222,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 88395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92503',
  },
  {
    city: 'Riverside',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 972.6,
    imprecise: false,
    latitude: 33.90607,
    longitude: -117.39854,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92504',
  },
  {
    city: 'Riverside',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 2026.8,
    imprecise: false,
    latitude: 33.92663,
    longitude: -117.4928,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 53419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92505',
  },
  {
    city: 'Riverside',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 1074,
    imprecise: false,
    latitude: 33.93478,
    longitude: -117.36689,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92506',
  },
  {
    city: 'Riverside',
    county_fips: 6065,
    county_fips_all: '06065|06071',
    county: 'Riverside',
    county_names_all: 'Riverside|San Bernardino',
    county_weights: '{"06065": 99.75, "06071": 0.25}',
    density: 1154.4,
    imprecise: false,
    latitude: 33.97464,
    longitude: -117.32234,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 64015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92507',
  },
  {
    city: 'Riverside',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 1296.8,
    imprecise: false,
    latitude: 33.89039,
    longitude: -117.3282,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92508',
  },
  {
    city: 'Jurupa Valley',
    county_fips: 6065,
    county_fips_all: '06065|06071',
    county: 'Riverside',
    county_names_all: 'Riverside|San Bernardino',
    county_weights: '{"06065": 99.37, "06071": 0.63}',
    density: 1020.4,
    imprecise: false,
    latitude: 34.00293,
    longitude: -117.44547,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 81182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92509',
  },
  {
    city: 'March Air Reserve Base',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 62,
    imprecise: false,
    latitude: 33.89602,
    longitude: -117.27705,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92518',
  },
  {
    city: 'Lake Elsinore',
    county_fips: 6065,
    county_fips_all: '06065|06059',
    county: 'Riverside',
    county_names_all: 'Riverside|Orange',
    county_weights: '{"06065": 94.77, "06059": 5.23}',
    density: 309.3,
    imprecise: false,
    latitude: 33.63386,
    longitude: -117.37949,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 61768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92530',
  },
  {
    city: 'Lake Elsinore',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 710.6,
    imprecise: false,
    latitude: 33.69052,
    longitude: -117.30241,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92532',
  },
  {
    city: 'Aguanga',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 33.48791,
    longitude: -116.81528,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92536',
  },
  {
    city: 'Anza',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 33.51579,
    longitude: -116.64432,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92539',
  },
  {
    city: 'Hemet',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 805.5,
    imprecise: false,
    latitude: 33.69867,
    longitude: -116.97916,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92543',
  },
  {
    city: 'Hemet',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 117,
    imprecise: false,
    latitude: 33.64581,
    longitude: -116.86033,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 51751,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92544',
  },
  {
    city: 'Hemet',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 597.1,
    imprecise: false,
    latitude: 33.7311,
    longitude: -117.0359,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92545',
  },
  {
    city: 'Homeland',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 245.3,
    imprecise: false,
    latitude: 33.76392,
    longitude: -117.10907,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92548',
  },
  {
    city: 'Idyllwild',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 33.80886,
    longitude: -116.71212,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4016,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92549',
  },
  {
    city: 'Moreno Valley',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 2348.9,
    imprecise: false,
    latitude: 33.88148,
    longitude: -117.22521,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92551',
  },
  {
    city: 'Moreno Valley',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 2809.4,
    imprecise: false,
    latitude: 33.92335,
    longitude: -117.24532,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 74640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92553',
  },
  {
    city: 'Moreno Valley',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 269.9,
    imprecise: false,
    latitude: 33.9133,
    longitude: -117.10867,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92555',
  },
  {
    city: 'Moreno Valley',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 1174.7,
    imprecise: false,
    latitude: 33.96855,
    longitude: -117.25704,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92557',
  },
  {
    city: 'Mountain Center',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 33.63704,
    longitude: -116.57441,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92561',
  },
  {
    city: 'Murrieta',
    county_fips: 6065,
    county_fips_all: '06065|06073',
    county: 'Riverside',
    county_names_all: 'Riverside|San Diego',
    county_weights: '{"06065": 81.48, "06073": 18.52}',
    density: 226.7,
    imprecise: false,
    latitude: 33.53579,
    longitude: -117.35098,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 64781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92562',
  },
  {
    city: 'Murrieta',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 1371.3,
    imprecise: false,
    latitude: 33.58435,
    longitude: -117.14458,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 80379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92563',
  },
  {
    city: 'Nuevo',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 126.7,
    imprecise: false,
    latitude: 33.82378,
    longitude: -117.10305,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92567',
  },
  {
    city: 'Perris',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 211,
    imprecise: false,
    latitude: 33.78377,
    longitude: -117.31737,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 58082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92570',
  },
  {
    city: 'Perris',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 593.3,
    imprecise: false,
    latitude: 33.84182,
    longitude: -117.19522,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 60096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92571',
  },
  {
    city: 'San Jacinto',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 489.8,
    imprecise: false,
    latitude: 33.80489,
    longitude: -117.01873,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92582',
  },
  {
    city: 'San Jacinto',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 447.5,
    imprecise: false,
    latitude: 33.79662,
    longitude: -116.93188,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92583',
  },
  {
    city: 'Menifee',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 814.1,
    imprecise: false,
    latitude: 33.66167,
    longitude: -117.18079,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 61366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92584',
  },
  {
    city: 'Menifee',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 666.7,
    imprecise: false,
    latitude: 33.74217,
    longitude: -117.16723,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92585',
  },
  {
    city: 'Menifee',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 1243.2,
    imprecise: false,
    latitude: 33.70773,
    longitude: -117.20045,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92586',
  },
  {
    city: 'Menifee',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 983.3,
    imprecise: false,
    latitude: 33.69466,
    longitude: -117.25196,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92587',
  },
  {
    city: 'Temecula',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 33.48391,
    longitude: -117.22075,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92590',
  },
  {
    city: 'Temecula',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 940.4,
    imprecise: false,
    latitude: 33.53432,
    longitude: -117.1092,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92591',
  },
  {
    city: 'Temecula',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 280.5,
    imprecise: false,
    latitude: 33.511,
    longitude: -117.0242,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 80035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92592',
  },
  {
    city: 'Wildomar',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 617.6,
    imprecise: false,
    latitude: 33.61638,
    longitude: -117.26028,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92595',
  },
  {
    city: 'Winchester',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 259.8,
    imprecise: false,
    latitude: 33.64739,
    longitude: -117.07641,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92596',
  },
  {
    city: 'Irvine',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 722.3,
    imprecise: false,
    latitude: 33.72645,
    longitude: -117.7287,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92602',
  },
  {
    city: 'Irvine',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 710.9,
    imprecise: false,
    latitude: 33.62927,
    longitude: -117.79408,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92603',
  },
  {
    city: 'Irvine',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 3055.4,
    imprecise: false,
    latitude: 33.6879,
    longitude: -117.7889,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92604',
  },
  {
    city: 'Irvine',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2683.9,
    imprecise: false,
    latitude: 33.69849,
    longitude: -117.8123,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92606',
  },
  {
    city: 'Foothill Ranch',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1229.5,
    imprecise: false,
    latitude: 33.68336,
    longitude: -117.65404,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92610',
  },
  {
    city: 'Irvine',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2035.4,
    imprecise: false,
    latitude: 33.65984,
    longitude: -117.82457,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92612',
  },
  {
    city: 'Irvine',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2545.7,
    imprecise: false,
    latitude: 33.68173,
    longitude: -117.83316,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92614',
  },
  {
    city: 'Irvine',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 4151.4,
    imprecise: false,
    latitude: 33.64197,
    longitude: -117.84103,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92617',
  },
  {
    city: 'Irvine',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1233.9,
    imprecise: false,
    latitude: 33.66729,
    longitude: -117.73362,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 66126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92618',
  },
  {
    city: 'Irvine',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 4026.3,
    imprecise: false,
    latitude: 33.70661,
    longitude: -117.75695,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 61631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92620',
  },
  {
    city: 'Capistrano Beach',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1853,
    imprecise: false,
    latitude: 33.46082,
    longitude: -117.66656,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92624',
  },
  {
    city: 'Corona Del Mar',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1854.3,
    imprecise: false,
    latitude: 33.60229,
    longitude: -117.86551,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92625',
  },
  {
    city: 'Costa Mesa',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2017.6,
    imprecise: false,
    latitude: 33.67896,
    longitude: -117.90844,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92626',
  },
  {
    city: 'Costa Mesa',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 3644.4,
    imprecise: false,
    latitude: 33.64786,
    longitude: -117.9205,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 60393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92627',
  },
  {
    city: 'Dana Point',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1951.1,
    imprecise: false,
    latitude: 33.47678,
    longitude: -117.70459,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92629',
  },
  {
    city: 'Lake Forest',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2460.5,
    imprecise: false,
    latitude: 33.64709,
    longitude: -117.68428,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 67152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92630',
  },
  {
    city: 'Laguna Woods',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2251.6,
    imprecise: false,
    latitude: 33.60796,
    longitude: -117.72799,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92637',
  },
  {
    city: 'Huntington Beach',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2619.3,
    imprecise: false,
    latitude: 33.66525,
    longitude: -117.96755,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92646',
  },
  {
    city: 'Huntington Beach',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 3025.1,
    imprecise: false,
    latitude: 33.72395,
    longitude: -118.00685,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 59047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92647',
  },
  {
    city: 'Huntington Beach',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2198.8,
    imprecise: false,
    latitude: 33.68212,
    longitude: -118.0101,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92648',
  },
  {
    city: 'Huntington Beach',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2419.3,
    imprecise: false,
    latitude: 33.72037,
    longitude: -118.04423,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92649',
  },
  {
    city: 'Laguna Beach',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 412.4,
    imprecise: false,
    latitude: 33.56535,
    longitude: -117.77399,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92651',
  },
  {
    city: 'Laguna Hills',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1651.2,
    imprecise: false,
    latitude: 33.59276,
    longitude: -117.69994,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92653',
  },
  {
    city: 'Midway City',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 3431.4,
    imprecise: false,
    latitude: 33.74606,
    longitude: -117.98765,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92655',
  },
  {
    city: 'Aliso Viejo',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2521.2,
    imprecise: false,
    latitude: 33.57518,
    longitude: -117.73036,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92656',
  },
  {
    city: 'Newport Coast',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 461.5,
    imprecise: false,
    latitude: 33.59571,
    longitude: -117.83069,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92657',
  },
  {
    city: 'Newport Beach',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1402.3,
    imprecise: false,
    latitude: 33.63375,
    longitude: -117.87504,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92660',
  },
  {
    city: 'Newport Beach',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1826.1,
    imprecise: false,
    latitude: 33.60231,
    longitude: -117.89872,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92661',
  },
  {
    city: 'Newport Beach',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 4252.8,
    imprecise: false,
    latitude: 33.60547,
    longitude: -117.89218,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92662',
  },
  {
    city: 'Newport Beach',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2507,
    imprecise: false,
    latitude: 33.62328,
    longitude: -117.93022,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92663',
  },
  {
    city: 'San Clemente',
    county_fips: 6073,
    county_fips_all: '06073|06059',
    county: 'San Diego',
    county_names_all: 'San Diego|Orange',
    county_weights: '{"06073": 76.36, "06059": 23.64}',
    density: 401,
    imprecise: false,
    latitude: 33.3825,
    longitude: -117.5403,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92672',
  },
  {
    city: 'San Clemente',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1101.8,
    imprecise: false,
    latitude: 33.46611,
    longitude: -117.61204,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92673',
  },
  {
    city: 'San Juan Capistrano',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1012.3,
    imprecise: false,
    latitude: 33.49977,
    longitude: -117.65366,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35095,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92675',
  },
  {
    city: 'Silverado',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 33.75306,
    longitude: -117.63534,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92676',
  },
  {
    city: 'Laguna Niguel',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1505.8,
    imprecise: false,
    latitude: 33.52777,
    longitude: -117.70523,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 64139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92677',
  },
  {
    city: 'Trabuco Canyon',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 33.64627,
    longitude: -117.50662,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92678',
  },
  {
    city: 'Trabuco Canyon',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 472.6,
    imprecise: false,
    latitude: 33.65274,
    longitude: -117.56048,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92679',
  },
  {
    city: 'Westminster',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 3568.3,
    imprecise: false,
    latitude: 33.75242,
    longitude: -117.99383,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 89833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92683',
  },
  {
    city: 'Rancho Santa Margarita',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1265.2,
    imprecise: false,
    latitude: 33.61737,
    longitude: -117.61131,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92688',
  },
  {
    city: 'Mission Viejo',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2016.5,
    imprecise: false,
    latitude: 33.61051,
    longitude: -117.66627,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92691',
  },
  {
    city: 'Mission Viejo',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2112.5,
    imprecise: false,
    latitude: 33.60948,
    longitude: -117.64396,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92692',
  },
  {
    city: 'Ladera Ranch',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 343.9,
    imprecise: false,
    latitude: 33.51502,
    longitude: -117.58065,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92694',
  },
  {
    city: 'Santa Ana',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 5725.6,
    imprecise: false,
    latitude: 33.7486,
    longitude: -117.85877,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92701',
  },
  {
    city: 'Santa Ana',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 5683.9,
    imprecise: false,
    latitude: 33.74853,
    longitude: -117.90621,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 62447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92703',
  },
  {
    city: 'Santa Ana',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 4280.6,
    imprecise: false,
    latitude: 33.72038,
    longitude: -117.90807,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 82120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92704',
  },
  {
    city: 'Santa Ana',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1598,
    imprecise: false,
    latitude: 33.755,
    longitude: -117.81488,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92705',
  },
  {
    city: 'Santa Ana',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 4054.8,
    imprecise: false,
    latitude: 33.76602,
    longitude: -117.88174,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92706',
  },
  {
    city: 'Santa Ana',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 4337.3,
    imprecise: false,
    latitude: 33.70991,
    longitude: -117.87045,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 58695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92707',
  },
  {
    city: 'Fountain Valley',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2386.2,
    imprecise: false,
    latitude: 33.71046,
    longitude: -117.95132,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 56258,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92708',
  },
  {
    city: 'Tustin',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 3346,
    imprecise: false,
    latitude: 33.73685,
    longitude: -117.81968,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92780',
  },
  {
    city: 'Tustin',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2245.9,
    imprecise: false,
    latitude: 33.72833,
    longitude: -117.79753,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92782',
  },
  {
    city: 'Anaheim',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 3716.8,
    imprecise: false,
    latitude: 33.84441,
    longitude: -117.95175,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 60547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92801',
  },
  {
    city: 'Anaheim',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 3657.8,
    imprecise: false,
    latitude: 33.80831,
    longitude: -117.9237,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92802',
  },
  {
    city: 'Anaheim',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 4526.9,
    imprecise: false,
    latitude: 33.81801,
    longitude: -117.97517,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 83537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92804',
  },
  {
    city: 'Anaheim',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 4630.6,
    imprecise: false,
    latitude: 33.83003,
    longitude: -117.90568,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 74661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92805',
  },
  {
    city: 'Anaheim',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2060.5,
    imprecise: false,
    latitude: 33.83884,
    longitude: -117.87054,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92806',
  },
  {
    city: 'Anaheim',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1315.1,
    imprecise: false,
    latitude: 33.85001,
    longitude: -117.78946,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92807',
  },
  {
    city: 'Anaheim',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1663.2,
    imprecise: false,
    latitude: 33.85623,
    longitude: -117.74018,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92808',
  },
  {
    city: 'Brea',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1137.2,
    imprecise: false,
    latitude: 33.92997,
    longitude: -117.86986,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92821',
  },
  {
    city: 'Brea',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 302.7,
    imprecise: false,
    latitude: 33.92536,
    longitude: -117.80024,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92823',
  },
  {
    city: 'Fullerton',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2311.7,
    imprecise: false,
    latitude: 33.8795,
    longitude: -117.89607,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92831',
  },
  {
    city: 'Fullerton',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 3640.5,
    imprecise: false,
    latitude: 33.86871,
    longitude: -117.92914,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92832',
  },
  {
    city: 'Fullerton',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2610.7,
    imprecise: false,
    latitude: 33.88051,
    longitude: -117.96112,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 51842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92833',
  },
  {
    city: 'Fullerton',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1755,
    imprecise: false,
    latitude: 33.90171,
    longitude: -117.91529,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92835',
  },
  {
    city: 'Garden Grove',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 4089.3,
    imprecise: false,
    latitude: 33.78584,
    longitude: -117.93202,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92840',
  },
  {
    city: 'Garden Grove',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2813.2,
    imprecise: false,
    latitude: 33.7868,
    longitude: -117.98207,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92841',
  },
  {
    city: 'Garden Grove',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 4525.3,
    imprecise: false,
    latitude: 33.76399,
    longitude: -117.93153,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92843',
  },
  {
    city: 'Garden Grove',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 4263.8,
    imprecise: false,
    latitude: 33.76561,
    longitude: -117.96952,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92844',
  },
  {
    city: 'Garden Grove',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2797.5,
    imprecise: false,
    latitude: 33.78292,
    longitude: -118.0264,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92845',
  },
  {
    city: 'Norco',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 686.7,
    imprecise: false,
    latitude: 33.9262,
    longitude: -117.54913,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92860',
  },
  {
    city: 'Villa Park',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1061.5,
    imprecise: false,
    latitude: 33.81801,
    longitude: -117.81031,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92861',
  },
  {
    city: 'Orange',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2076.3,
    imprecise: false,
    latitude: 33.82887,
    longitude: -117.84925,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92865',
  },
  {
    city: 'Orange',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 3105.2,
    imprecise: false,
    latitude: 33.78453,
    longitude: -117.84479,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92866',
  },
  {
    city: 'Orange',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1438.8,
    imprecise: false,
    latitude: 33.81443,
    longitude: -117.79617,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92867',
  },
  {
    city: 'Orange',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 2961.4,
    imprecise: false,
    latitude: 33.78799,
    longitude: -117.87637,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92868',
  },
  {
    city: 'Orange',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1039.5,
    imprecise: false,
    latitude: 33.79479,
    longitude: -117.7621,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92869',
  },
  {
    city: 'Placentia',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 3031.4,
    imprecise: false,
    latitude: 33.88087,
    longitude: -117.85522,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92870',
  },
  {
    city: 'Corona',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 1937.6,
    imprecise: false,
    latitude: 33.87979,
    longitude: -117.5357,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92879',
  },
  {
    city: 'Eastvale',
    county_fips: 6065,
    county_fips_all: '06065|06071',
    county: 'Riverside',
    county_names_all: 'Riverside|San Bernardino',
    county_weights: '{"06065": 92.79, "06071": 7.21}',
    density: 1107.3,
    imprecise: false,
    latitude: 33.92096,
    longitude: -117.61052,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 75043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92880',
  },
  {
    city: 'Corona',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 361.2,
    imprecise: false,
    latitude: 33.82163,
    longitude: -117.56763,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92881',
  },
  {
    city: 'Corona',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 2257.5,
    imprecise: false,
    latitude: 33.86367,
    longitude: -117.59989,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 68715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92882',
  },
  {
    city: 'Corona',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 273.5,
    imprecise: false,
    latitude: 33.75994,
    longitude: -117.47827,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92883',
  },
  {
    city: 'Yorba Linda',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 1480.4,
    imprecise: false,
    latitude: 33.89517,
    longitude: -117.80154,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92886',
  },
  {
    city: 'Yorba Linda',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 674.8,
    imprecise: false,
    latitude: 33.88727,
    longitude: -117.73389,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92887',
  },
  {
    city: 'Ventura',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 128,
    imprecise: false,
    latitude: 34.35321,
    longitude: -119.31868,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93001',
  },
  {
    city: 'Ventura',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 982.8,
    imprecise: false,
    latitude: 34.28434,
    longitude: -119.22256,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93003',
  },
  {
    city: 'Ventura',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 1686.2,
    imprecise: false,
    latitude: 34.27901,
    longitude: -119.16537,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93004',
  },
  {
    city: 'Camarillo',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 821.5,
    imprecise: false,
    latitude: 34.23007,
    longitude: -119.07437,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93010',
  },
  {
    city: 'Camarillo',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 275.6,
    imprecise: false,
    latitude: 34.20518,
    longitude: -118.99309,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93012',
  },
  {
    city: 'Carpinteria',
    county_fips: 6083,
    county_fips_all: '06083|06111',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara|Ventura',
    county_weights: '{"06083": 74.7, "06111": 25.3}',
    density: 152.2,
    imprecise: false,
    latitude: 34.42697,
    longitude: -119.48032,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93013',
  },
  {
    city: 'Fillmore',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 79.9,
    imprecise: false,
    latitude: 34.40969,
    longitude: -118.87807,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93015',
  },
  {
    city: 'Moorpark',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 304.9,
    imprecise: false,
    latitude: 34.30417,
    longitude: -118.88274,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93021',
  },
  {
    city: 'Oak View',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 747.6,
    imprecise: false,
    latitude: 34.40324,
    longitude: -119.29836,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93022',
  },
  {
    city: 'Ojai',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 30.4,
    imprecise: false,
    latitude: 34.50372,
    longitude: -119.24856,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93023',
  },
  {
    city: 'Oxnard',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 1592,
    imprecise: false,
    latitude: 34.2051,
    longitude: -119.1753,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 58192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93030',
  },
  {
    city: 'Oxnard',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 944.2,
    imprecise: false,
    latitude: 34.15401,
    longitude: -119.12296,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 78737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93033',
  },
  {
    city: 'Oxnard',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 2061.7,
    imprecise: false,
    latitude: 34.19034,
    longitude: -119.22879,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93035',
  },
  {
    city: 'Oxnard',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 1071.5,
    imprecise: false,
    latitude: 34.24911,
    longitude: -119.15977,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93036',
  },
  {
    city: 'Piru',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 34.59337,
    longitude: -118.93657,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93040',
  },
  {
    city: 'Port Hueneme',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 1528.4,
    imprecise: false,
    latitude: 34.14956,
    longitude: -119.17458,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93041',
  },
  {
    city: 'Santa Paula',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 144.1,
    imprecise: false,
    latitude: 34.36543,
    longitude: -119.09563,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93060',
  },
  {
    city: 'Simi Valley',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 587.9,
    imprecise: false,
    latitude: 34.30922,
    longitude: -118.69041,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 55066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93063',
  },
  {
    city: 'Simi Valley',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 952.7,
    imprecise: false,
    latitude: 34.26206,
    longitude: -118.77151,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 73534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93065',
  },
  {
    city: 'Somis',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 26.6,
    imprecise: false,
    latitude: 34.28851,
    longitude: -119.02848,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93066',
  },
  {
    city: 'Summerland',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 732,
    imprecise: false,
    latitude: 34.42162,
    longitude: -119.59277,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93067',
  },
  {
    city: 'Santa Barbara',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 3804.4,
    imprecise: false,
    latitude: 34.41925,
    longitude: -119.70808,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93101',
  },
  {
    city: 'Santa Barbara',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 1363.2,
    imprecise: false,
    latitude: 34.43888,
    longitude: -119.68173,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93103',
  },
  {
    city: 'Santa Barbara',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 67.5,
    imprecise: false,
    latitude: 34.52702,
    longitude: -119.76082,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93105',
  },
  {
    city: 'Santa Barbara',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 159.7,
    imprecise: false,
    latitude: 34.44934,
    longitude: -119.60397,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93108',
  },
  {
    city: 'Santa Barbara',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 1227.6,
    imprecise: false,
    latitude: 34.40662,
    longitude: -119.72682,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93109',
  },
  {
    city: 'Santa Barbara',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 737.1,
    imprecise: false,
    latitude: 34.43913,
    longitude: -119.7666,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93110',
  },
  {
    city: 'Santa Barbara',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 867.3,
    imprecise: false,
    latitude: 34.44932,
    longitude: -119.80223,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93111',
  },
  {
    city: 'Goleta',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 121.6,
    imprecise: false,
    latitude: 34.49102,
    longitude: -120.08201,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93117',
  },
  {
    city: 'Alpaugh',
    county_fips: 6107,
    county_fips_all: '06107|06031',
    county: 'Tulare',
    county_names_all: 'Tulare|Kings',
    county_weights: '{"06107": 85.8, "06031": 14.2}',
    density: 6.1,
    imprecise: false,
    latitude: 35.8555,
    longitude: -119.48338,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93201',
  },
  {
    city: 'Armona',
    county_fips: 6031,
    county_fips_all: '06031',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"06031": 100}',
    density: 977.5,
    imprecise: false,
    latitude: 36.3187,
    longitude: -119.7076,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93202',
  },
  {
    city: 'Arvin',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 46.5,
    imprecise: false,
    latitude: 35.12158,
    longitude: -118.8468,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93203',
  },
  {
    city: 'Avenal',
    county_fips: 6031,
    county_fips_all: '06031',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"06031": 100}',
    density: 74.7,
    imprecise: false,
    latitude: 35.90819,
    longitude: -120.06776,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93204',
  },
  {
    city: 'Bodfish',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 28.4,
    imprecise: false,
    latitude: 35.5387,
    longitude: -118.45463,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93205',
  },
  {
    city: 'Buttonwillow',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 35.44402,
    longitude: -119.47578,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93206',
  },
  {
    city: 'California Hot Springs',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 2,
    imprecise: false,
    latitude: 35.88721,
    longitude: -118.63153,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93207',
  },
  {
    city: 'Coalinga',
    county_fips: 6019,
    county_fips_all: '06019|06053|06069',
    county: 'Fresno',
    county_names_all: 'Fresno|Monterey|San Benito',
    county_weights: '{"06019": 90.26, "06053": 6.38, "06069": 3.36}',
    density: 9.2,
    imprecise: false,
    latitude: 36.19519,
    longitude: -120.43245,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93210',
  },
  {
    city: 'Corcoran',
    county_fips: 6031,
    county_fips_all: '06031|06107',
    county: 'Kings',
    county_names_all: 'Kings|Tulare',
    county_weights: '{"06031": 60.72, "06107": 39.28}',
    density: 75.4,
    imprecise: false,
    latitude: 36.01649,
    longitude: -119.56937,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93212',
  },
  {
    city: 'Delano',
    county_fips: 6029,
    county_fips_all: '06029|06107',
    county: 'Kern',
    county_names_all: 'Kern|Tulare',
    county_weights: '{"06029": 59.64, "06107": 40.36}',
    density: 144.8,
    imprecise: false,
    latitude: 35.7764,
    longitude: -119.18835,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93215',
  },
  {
    city: 'Ducor',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 35.86194,
    longitude: -119.03822,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93218',
  },
  {
    city: 'Earlimart',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 34,
    imprecise: false,
    latitude: 35.87908,
    longitude: -119.28818,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9057,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93219',
  },
  {
    city: 'Edison',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.3705,
    longitude: -118.78369,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93220',
  },
  {
    city: 'Exeter',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 42.5,
    imprecise: false,
    latitude: 36.29637,
    longitude: -119.02992,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14538,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93221',
  },
  {
    city: 'Pine Mountain Club',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 34.89835,
    longitude: -119.25983,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93222',
  },
  {
    city: 'Farmersville',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 1294.7,
    imprecise: false,
    latitude: 36.30117,
    longitude: -119.20789,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93223',
  },
  {
    city: 'Fellows',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 35.21687,
    longitude: -119.58087,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93224',
  },
  {
    city: 'Frazier Park',
    county_fips: 6111,
    county_fips_all: '06111|06029',
    county: 'Ventura',
    county_names_all: 'Ventura|Kern',
    county_weights: '{"06111": 64.02, "06029": 35.98}',
    density: 16.1,
    imprecise: false,
    latitude: 34.78532,
    longitude: -119.04196,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93225',
  },
  {
    city: 'Glennville',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 35.7476,
    longitude: -118.73462,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 58,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93226',
  },
  {
    city: 'Goshen',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 909.3,
    imprecise: false,
    latitude: 36.34441,
    longitude: -119.41856,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93227',
  },
  {
    city: 'Hanford',
    county_fips: 6031,
    county_fips_all: '06031|06107',
    county: 'Kings',
    county_names_all: 'Kings|Tulare',
    county_weights: '{"06031": 99.62, "06107": 0.38}',
    density: 104.3,
    imprecise: false,
    latitude: 36.28967,
    longitude: -119.62514,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 69684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93230',
  },
  {
    city: 'Huron',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 36.19608,
    longitude: -120.08477,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93234',
  },
  {
    city: 'Ivanhoe',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 435.3,
    imprecise: false,
    latitude: 36.38507,
    longitude: -119.22314,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4678,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93235',
  },
  {
    city: 'Kaweah',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 36.47452,
    longitude: -118.90426,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93237',
  },
  {
    city: 'Kernville',
    county_fips: 6107,
    county_fips_all: '06107|06029',
    county: 'Tulare',
    county_names_all: 'Tulare|Kern',
    county_weights: '{"06107": 62.55, "06029": 37.45}',
    density: 3.1,
    imprecise: false,
    latitude: 35.82799,
    longitude: -118.47137,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93238',
  },
  {
    city: 'Kettleman City',
    county_fips: 6031,
    county_fips_all: '06031',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"06031": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 36.03293,
    longitude: -119.98645,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93239',
  },
  {
    city: 'Mountain Mesa',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 39.8,
    imprecise: false,
    latitude: 35.62425,
    longitude: -118.4645,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93240',
  },
  {
    city: 'Lamont',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 1166.4,
    imprecise: false,
    latitude: 35.24922,
    longitude: -118.91224,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15250,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93241',
  },
  {
    city: 'Laton',
    county_fips: 6019,
    county_fips_all: '06019|06031',
    county: 'Fresno',
    county_names_all: 'Fresno|Kings',
    county_weights: '{"06019": 83.05, "06031": 16.95}',
    density: 27.5,
    imprecise: false,
    latitude: 36.44115,
    longitude: -119.73024,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2904,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93242',
  },
  {
    city: 'Lebec',
    county_fips: 6029,
    county_fips_all: '06029|06037',
    county: 'Kern',
    county_names_all: 'Kern|Los Angeles',
    county_weights: '{"06029": 63.73, "06037": 36.27}',
    density: 2,
    imprecise: false,
    latitude: 34.84057,
    longitude: -118.81769,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93243',
  },
  {
    city: 'Lemon Cove',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 5.8,
    imprecise: false,
    latitude: 36.3908,
    longitude: -118.99733,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93244',
  },
  {
    city: 'Lemoore',
    county_fips: 6031,
    county_fips_all: '06031',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"06031": 100}',
    density: 123.3,
    imprecise: false,
    latitude: 36.28614,
    longitude: -119.83405,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93245',
  },
  {
    city: 'Lindsay',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 106.3,
    imprecise: false,
    latitude: 36.20234,
    longitude: -119.08277,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93247',
  },
  {
    city: 'Lost Hills',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 35.67033,
    longitude: -119.85814,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93249',
  },
  {
    city: 'McFarland',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 67.2,
    imprecise: false,
    latitude: 35.66456,
    longitude: -119.20278,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93250',
  },
  {
    city: 'McKittrick',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 1,
    imprecise: false,
    latitude: 35.37059,
    longitude: -119.69735,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93251',
  },
  {
    city: 'Maricopa',
    county_fips: 6111,
    county_fips_all: '06111|06029|06083|06079',
    county: 'Ventura',
    county_names_all: 'Ventura|Kern|Santa Barbara|San Luis Obispo',
    county_weights:
      '{"06111": 66.05, "06029": 18.03, "06083": 9.82, "06079": 6.1}',
    density: 1.1,
    imprecise: false,
    latitude: 34.80685,
    longitude: -119.34664,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93252',
  },
  {
    city: 'New Cuyama',
    county_fips: 6083,
    county_fips_all: '06083|06079',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara|San Luis Obispo',
    county_weights: '{"06083": 91.23, "06079": 8.77}',
    density: 1.4,
    imprecise: false,
    latitude: 34.92498,
    longitude: -119.74834,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93254',
  },
  {
    city: 'Onyx',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 35.68292,
    longitude: -118.0798,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93255',
  },
  {
    city: 'Pixley',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 28.9,
    imprecise: false,
    latitude: 35.96805,
    longitude: -119.31251,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93256',
  },
  {
    city: 'Porterville',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 82,
    imprecise: false,
    latitude: 35.98708,
    longitude: -118.89493,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 80467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93257',
  },
  {
    city: 'Porterville',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 553.4,
    imprecise: false,
    latitude: 36.05833,
    longitude: -119.15209,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93258',
  },
  {
    city: 'Posey',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 35.81909,
    longitude: -118.66116,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93260',
  },
  {
    city: 'Richgrove',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 134,
    imprecise: false,
    latitude: 35.81147,
    longitude: -119.11673,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93261',
  },
  {
    city: 'Sequoia National Park',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.50256,
    longitude: -118.68109,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93262',
  },
  {
    city: 'Shafter',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 100.6,
    imprecise: false,
    latitude: 35.48722,
    longitude: -119.27835,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93263',
  },
  {
    city: 'Springville',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 36.20713,
    longitude: -118.70876,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93265',
  },
  {
    city: 'Stratford',
    county_fips: 6031,
    county_fips_all: '06031',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"06031": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 36.17176,
    longitude: -119.85628,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1612,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93266',
  },
  {
    city: 'Strathmore',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 34.6,
    imprecise: false,
    latitude: 36.14279,
    longitude: -119.0742,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93267',
  },
  {
    city: 'Taft',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 96.1,
    imprecise: false,
    latitude: 35.16725,
    longitude: -119.40785,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93268',
  },
  {
    city: 'Terra Bella',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 31.4,
    imprecise: false,
    latitude: 35.94703,
    longitude: -119.05669,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93270',
  },
  {
    city: 'Three Rivers',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 36.43661,
    longitude: -118.86903,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93271',
  },
  {
    city: 'Tipton',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 36.04818,
    longitude: -119.34535,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93272',
  },
  {
    city: 'Tulare',
    county_fips: 6107,
    county_fips_all: '06107|06031',
    county: 'Tulare',
    county_names_all: 'Tulare|Kings',
    county_weights: '{"06107": 95.45, "06031": 4.55}',
    density: 140.9,
    imprecise: false,
    latitude: 36.17978,
    longitude: -119.37949,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 80026,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93274',
  },
  {
    city: 'Tupman',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 35.31756,
    longitude: -119.4092,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93276',
  },
  {
    city: 'Visalia',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 528.7,
    imprecise: false,
    latitude: 36.29963,
    longitude: -119.38139,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 53985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93277',
  },
  {
    city: 'Wasco',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 33.5,
    imprecise: false,
    latitude: 35.65204,
    longitude: -119.44716,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93280',
  },
  {
    city: 'Weldon',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 35.58478,
    longitude: -118.28854,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93283',
  },
  {
    city: 'Wofford Heights',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 20.7,
    imprecise: false,
    latitude: 35.72233,
    longitude: -118.50871,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93285',
  },
  {
    city: 'Woodlake',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 56.1,
    imprecise: false,
    latitude: 36.45149,
    longitude: -119.1079,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93286',
  },
  {
    city: 'Woody',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 35.72387,
    longitude: -118.91958,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 98,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93287',
  },
  {
    city: 'Visalia',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 291.5,
    imprecise: false,
    latitude: 36.38931,
    longitude: -119.36838,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 63568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93291',
  },
  {
    city: 'Visalia',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 154,
    imprecise: false,
    latitude: 36.3763,
    longitude: -119.22183,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93292',
  },
  {
    city: 'Bakersfield',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 1227.1,
    imprecise: false,
    latitude: 35.38428,
    longitude: -119.02057,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93301',
  },
  {
    city: 'Bakersfield',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 2636.6,
    imprecise: false,
    latitude: 35.33938,
    longitude: -119.02368,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 51037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93304',
  },
  {
    city: 'Bakersfield',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 2516.8,
    imprecise: false,
    latitude: 35.38989,
    longitude: -118.98515,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93305',
  },
  {
    city: 'Bakersfield',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 294,
    imprecise: false,
    latitude: 35.46595,
    longitude: -118.78445,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 74116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93306',
  },
  {
    city: 'Bakersfield',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 235,
    imprecise: false,
    latitude: 35.2487,
    longitude: -118.93253,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 85945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93307',
  },
  {
    city: 'Bakersfield',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 61.7,
    imprecise: false,
    latitude: 35.5498,
    longitude: -118.93389,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 55078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93308',
  },
  {
    city: 'Bakersfield',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 2335.3,
    imprecise: false,
    latitude: 35.34266,
    longitude: -119.06461,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 63217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93309',
  },
  {
    city: 'Bakersfield',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 100.7,
    imprecise: false,
    latitude: 35.15378,
    longitude: -119.16567,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 55555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93311',
  },
  {
    city: 'Bakersfield',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 1590.7,
    imprecise: false,
    latitude: 35.39186,
    longitude: -119.11954,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 58384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93312',
  },
  {
    city: 'Bakersfield',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 237.4,
    imprecise: false,
    latitude: 35.16363,
    longitude: -119.04715,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 61843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93313',
  },
  {
    city: 'Bakersfield',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 153.7,
    imprecise: false,
    latitude: 35.385,
    longitude: -119.23741,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35407,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93314',
  },
  {
    city: 'San Luis Obispo',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 175.7,
    imprecise: false,
    latitude: 35.23539,
    longitude: -120.61834,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93401',
  },
  {
    city: 'Los Osos',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 197.5,
    imprecise: false,
    latitude: 35.29082,
    longitude: -120.8392,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14197,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93402',
  },
  {
    city: 'San Luis Obispo',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 107.6,
    imprecise: false,
    latitude: 35.29672,
    longitude: -120.72618,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93405',
  },
  {
    city: 'Arroyo Grande',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 61.3,
    imprecise: false,
    latitude: 35.16682,
    longitude: -120.46617,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93420',
  },
  {
    city: 'Atascadero',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 185.2,
    imprecise: false,
    latitude: 35.4638,
    longitude: -120.69007,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93422',
  },
  {
    city: 'Avila Beach',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 35.20141,
    longitude: -120.78394,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 962,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93424',
  },
  {
    city: 'Bradley',
    county_fips: 6053,
    county_fips_all: '06053|06079',
    county: 'Monterey',
    county_names_all: 'Monterey|San Luis Obispo',
    county_weights: '{"06053": 81.29, "06079": 18.71}',
    density: 2.8,
    imprecise: false,
    latitude: 35.84682,
    longitude: -120.97233,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93426',
  },
  {
    city: 'Buellton',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 31.9,
    imprecise: false,
    latitude: 34.62724,
    longitude: -120.22465,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93427',
  },
  {
    city: 'Cambria',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 32,
    imprecise: false,
    latitude: 35.58995,
    longitude: -121.02943,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6399,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93428',
  },
  {
    city: 'Casmalia',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 34.86682,
    longitude: -120.53582,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93429',
  },
  {
    city: 'Cayucos',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 35.49214,
    longitude: -120.92422,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93430',
  },
  {
    city: 'Creston',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 35.47686,
    longitude: -120.47228,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93432',
  },
  {
    city: 'Grover Beach',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 2247.8,
    imprecise: false,
    latitude: 35.12045,
    longitude: -120.61894,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93433',
  },
  {
    city: 'Guadalupe',
    county_fips: 6083,
    county_fips_all: '06083|06079',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara|San Luis Obispo',
    county_weights: '{"06083": 98.79, "06079": 1.21}',
    density: 145.7,
    imprecise: false,
    latitude: 34.94086,
    longitude: -120.6113,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93434',
  },
  {
    city: 'Lompoc',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 94.5,
    imprecise: false,
    latitude: 34.60888,
    longitude: -120.4002,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 55820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93436',
  },
  {
    city: 'Lompoc',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 27.1,
    imprecise: false,
    latitude: 34.76049,
    longitude: -120.51102,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93437',
  },
  {
    city: 'Los Alamos',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 34.74606,
    longitude: -120.25292,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93440',
  },
  {
    city: 'Los Olivos',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 34.73296,
    longitude: -120.09721,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93441',
  },
  {
    city: 'Morro Bay',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 100.3,
    imprecise: false,
    latitude: 35.4,
    longitude: -120.80495,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93442',
  },
  {
    city: 'Nipomo',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 127.6,
    imprecise: false,
    latitude: 35.03553,
    longitude: -120.50293,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93444',
  },
  {
    city: 'Oceano',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 155.5,
    imprecise: false,
    latitude: 35.03319,
    longitude: -120.62002,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93445',
  },
  {
    city: 'Paso Robles',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 41.1,
    imprecise: false,
    latitude: 35.65861,
    longitude: -120.71888,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93446',
  },
  {
    city: 'Pismo Beach',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 312.3,
    imprecise: false,
    latitude: 35.15803,
    longitude: -120.6504,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93449',
  },
  {
    city: 'San Ardo',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 36.05791,
    longitude: -120.82894,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93450',
  },
  {
    city: 'San Miguel',
    county_fips: 6053,
    county_fips_all: '06053|06079',
    county: 'Monterey',
    county_names_all: 'Monterey|San Luis Obispo',
    county_weights: '{"06053": 84.85, "06079": 15.15}',
    density: 4.5,
    imprecise: false,
    latitude: 35.89398,
    longitude: -120.56733,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93451',
  },
  {
    city: 'San Simeon',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 35.71078,
    longitude: -121.20396,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93452',
  },
  {
    city: 'Santa Margarita',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 35.31339,
    longitude: -120.1655,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93453',
  },
  {
    city: 'Santa Maria',
    county_fips: 6083,
    county_fips_all: '06083|06079',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara|San Luis Obispo',
    county_weights: '{"06083": 71.83, "06079": 28.17}',
    density: 38.7,
    imprecise: false,
    latitude: 34.94834,
    longitude: -120.23425,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93454',
  },
  {
    city: 'Santa Maria',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 145.6,
    imprecise: false,
    latitude: 34.84195,
    longitude: -120.45522,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93455',
  },
  {
    city: 'Santa Maria',
    county_fips: 6083,
    county_fips_all: '06083|06079',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara|San Luis Obispo',
    county_weights: '{"06083": 99.84, "06079": 0.16}',
    density: 803.7,
    imprecise: false,
    latitude: 34.95477,
    longitude: -120.49042,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 59148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93458',
  },
  {
    city: 'Santa Ynez',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 34.66214,
    longitude: -119.90091,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93460',
  },
  {
    city: 'Shandon',
    county_fips: 6079,
    county_fips_all: '06079|06029',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo|Kern',
    county_weights: '{"06079": 90.85, "06029": 9.15}',
    density: 2,
    imprecise: false,
    latitude: 35.63519,
    longitude: -120.26951,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1548,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93461',
  },
  {
    city: 'Solvang',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 92.6,
    imprecise: false,
    latitude: 34.60688,
    longitude: -120.13495,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93463',
  },
  {
    city: 'Templeton',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 50.4,
    imprecise: false,
    latitude: 35.54267,
    longitude: -120.73417,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93465',
  },
  {
    city: 'Mojave',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 35.0411,
    longitude: -118.22922,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93501',
  },
  {
    city: 'California City',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 85.3,
    imprecise: false,
    latitude: 35.15708,
    longitude: -117.90934,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93505',
  },
  {
    city: 'Acton',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 37.5,
    imprecise: false,
    latitude: 34.45627,
    longitude: -118.2109,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93510',
  },
  {
    city: 'Benton',
    county_fips: 6051,
    county_fips_all: '06051',
    county: 'Mono',
    county_names_all: 'Mono',
    county_weights: '{"06051": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 37.87379,
    longitude: -118.53455,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93512',
  },
  {
    city: 'Big Pine',
    county_fips: 6027,
    county_fips_all: '06027',
    county: 'Inyo',
    county_names_all: 'Inyo',
    county_weights: '{"06027": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 37.18401,
    longitude: -118.17129,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93513',
  },
  {
    city: 'Bishop',
    county_fips: 6051,
    county_fips_all: '06051|06027',
    county: 'Mono',
    county_names_all: 'Mono|Inyo',
    county_weights: '{"06051": 56.23, "06027": 43.77}',
    density: 5.7,
    imprecise: false,
    latitude: 37.4947,
    longitude: -118.38514,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93514',
  },
  {
    city: 'Boron',
    county_fips: 6029,
    county_fips_all: '06029|06071',
    county: 'Kern',
    county_names_all: 'Kern|San Bernardino',
    county_weights: '{"06029": 52.03, "06071": 47.97}',
    density: 39,
    imprecise: false,
    latitude: 35.0081,
    longitude: -117.64268,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93516',
  },
  {
    city: 'Bridgeport',
    county_fips: 6051,
    county_fips_all: '06051',
    county: 'Mono',
    county_names_all: 'Mono',
    county_weights: '{"06051": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 38.27091,
    longitude: -119.27372,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93517',
  },
  {
    city: 'Caliente',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 35.37675,
    longitude: -118.47314,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93518',
  },
  {
    city: 'Cantil',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 35.3171,
    longitude: -117.95596,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93519',
  },
  {
    city: 'Darwin',
    county_fips: 6027,
    county_fips_all: '06027',
    county: 'Inyo',
    county_names_all: 'Inyo',
    county_weights: '{"06027": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 36.29836,
    longitude: -117.59681,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93522',
  },
  {
    city: 'Edwards',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 35.7,
    imprecise: false,
    latitude: 34.99788,
    longitude: -117.88308,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3502,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93523',
  },
  {
    city: 'Independence',
    county_fips: 6027,
    county_fips_all: '06027',
    county: 'Inyo',
    county_names_all: 'Inyo',
    county_weights: '{"06027": 100}',
    density: 6,
    imprecise: false,
    latitude: 36.85941,
    longitude: -118.25378,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93526',
  },
  {
    city: 'Inyokern',
    county_fips: 6107,
    county_fips_all: '06107|06029|06027',
    county: 'Tulare',
    county_names_all: 'Tulare|Kern|Inyo',
    county_weights: '{"06107": 50.78, "06029": 34.7, "06027": 14.52}',
    density: 2,
    imprecise: false,
    latitude: 35.80294,
    longitude: -117.98504,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93527',
  },
  {
    city: 'Johannesburg',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 35.37194,
    longitude: -117.64193,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 86,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93528',
  },
  {
    city: 'June Lake',
    county_fips: 6051,
    county_fips_all: '06051',
    county: 'Mono',
    county_names_all: 'Mono',
    county_weights: '{"06051": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 37.7832,
    longitude: -119.1375,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93529',
  },
  {
    city: 'Keeler',
    county_fips: 6027,
    county_fips_all: '06027',
    county: 'Inyo',
    county_names_all: 'Inyo',
    county_weights: '{"06027": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 36.48458,
    longitude: -117.87201,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93530',
  },
  {
    city: 'Keene',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 35.22937,
    longitude: -118.60781,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93531',
  },
  {
    city: 'Lake Hughes',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 34.68571,
    longitude: -118.55914,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93532',
  },
  {
    city: 'Lancaster',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 843.8,
    imprecise: false,
    latitude: 34.71759,
    longitude: -118.15079,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93534',
  },
  {
    city: 'Lancaster',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 128.3,
    imprecise: false,
    latitude: 34.69908,
    longitude: -117.89613,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 79409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93535',
  },
  {
    city: 'Lancaster',
    county_fips: 6037,
    county_fips_all: '06037|06029',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles|Kern',
    county_weights: '{"06037": 94.84, "06029": 5.16}',
    density: 111.4,
    imprecise: false,
    latitude: 34.75267,
    longitude: -118.3889,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 73412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93536',
  },
  {
    city: 'Lee Vining',
    county_fips: 6051,
    county_fips_all: '06051',
    county: 'Mono',
    county_names_all: 'Mono',
    county_weights: '{"06051": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 37.99678,
    longitude: -119.01847,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93541',
  },
  {
    city: 'Littlerock',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 70,
    imprecise: false,
    latitude: 34.47916,
    longitude: -117.97357,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93543',
  },
  {
    city: 'Llano',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 34.49063,
    longitude: -117.75505,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93544',
  },
  {
    city: 'Lone Pine',
    county_fips: 6027,
    county_fips_all: '06027',
    county: 'Inyo',
    county_names_all: 'Inyo',
    county_weights: '{"06027": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 36.6046,
    longitude: -118.02721,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93545',
  },
  {
    city: 'Mammoth Lakes',
    county_fips: 6051,
    county_fips_all: '06051',
    county: 'Mono',
    county_names_all: 'Mono',
    county_weights: '{"06051": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 37.60573,
    longitude: -118.85219,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93546',
  },
  {
    city: 'Olancha',
    county_fips: 6027,
    county_fips_all: '06027',
    county: 'Inyo',
    county_names_all: 'Inyo',
    county_weights: '{"06027": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 36.27728,
    longitude: -117.96016,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93549',
  },
  {
    city: 'Palmdale',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 120.1,
    imprecise: false,
    latitude: 34.38305,
    longitude: -118.04926,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 80645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93550',
  },
  {
    city: 'Palmdale',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 247.6,
    imprecise: false,
    latitude: 34.59404,
    longitude: -118.22634,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93551',
  },
  {
    city: 'Palmdale',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 428.3,
    imprecise: false,
    latitude: 34.58412,
    longitude: -118.02386,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93552',
  },
  {
    city: 'Pearblossom',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 8.9,
    imprecise: false,
    latitude: 34.44515,
    longitude: -117.89611,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93553',
  },
  {
    city: 'Ridgecrest',
    county_fips: 6029,
    county_fips_all: '06029|06071',
    county: 'Kern',
    county_names_all: 'Kern|San Bernardino',
    county_weights: '{"06029": 92.03, "06071": 7.97}',
    density: 167.3,
    imprecise: false,
    latitude: 35.58596,
    longitude: -117.68446,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93555',
  },
  {
    city: 'Red Mountain',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.33945,
    longitude: -117.58517,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93558',
  },
  {
    city: 'Rosamond',
    county_fips: 6029,
    county_fips_all: '06029|06037',
    county: 'Kern',
    county_names_all: 'Kern|Los Angeles',
    county_weights: '{"06029": 95.18, "06037": 4.82}',
    density: 50.9,
    imprecise: false,
    latitude: 34.87116,
    longitude: -118.32594,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93560',
  },
  {
    city: 'Tehachapi',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 39.9,
    imprecise: false,
    latitude: 35.10904,
    longitude: -118.52016,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93561',
  },
  {
    city: 'Trona',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 8,
    imprecise: false,
    latitude: 35.70667,
    longitude: -117.34263,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93562',
  },
  {
    city: 'Valyermo',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2,
    imprecise: false,
    latitude: 34.38662,
    longitude: -117.83646,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93563',
  },
  {
    city: 'Tehachapi',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 474.1,
    imprecise: false,
    latitude: 35.11288,
    longitude: -118.57035,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93581',
  },
  {
    city: 'Palmdale',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 36.6,
    imprecise: false,
    latitude: 34.59656,
    longitude: -117.80955,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93591',
  },
  {
    city: 'Ahwahnee',
    county_fips: 6039,
    county_fips_all: '06039|06043',
    county: 'Madera',
    county_names_all: 'Madera|Mariposa',
    county_weights: '{"06039": 63.75, "06043": 36.25}',
    density: 13.3,
    imprecise: false,
    latitude: 37.39395,
    longitude: -119.73702,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93601',
  },
  {
    city: 'Auberry',
    county_fips: 6019,
    county_fips_all: '06019|06039',
    county: 'Fresno',
    county_names_all: 'Fresno|Madera',
    county_weights: '{"06019": 95.46, "06039": 4.54}',
    density: 11.6,
    imprecise: false,
    latitude: 37.0644,
    longitude: -119.37484,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93602',
  },
  {
    city: 'Badger',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 36.55118,
    longitude: -118.99607,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93603',
  },
  {
    city: 'Bass Lake',
    county_fips: 6039,
    county_fips_all: '06039',
    county: 'Madera',
    county_names_all: 'Madera',
    county_weights: '{"06039": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 37.3717,
    longitude: -119.52215,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93604',
  },
  {
    city: 'Big Creek',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 37.17622,
    longitude: -119.24953,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93605',
  },
  {
    city: 'Biola',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 551.2,
    imprecise: false,
    latitude: 36.79871,
    longitude: -120.01625,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93606',
  },
  {
    city: 'Cantua Creek',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 36.5055,
    longitude: -120.3418,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93608',
  },
  {
    city: 'Caruthers',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 30,
    imprecise: false,
    latitude: 36.52616,
    longitude: -119.86388,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93609',
  },
  {
    city: 'Chowchilla',
    county_fips: 6039,
    county_fips_all: '06039|06047',
    county: 'Madera',
    county_names_all: 'Madera|Merced',
    county_weights: '{"06039": 85.12, "06047": 14.88}',
    density: 34.5,
    imprecise: false,
    latitude: 37.09047,
    longitude: -120.29036,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93610',
  },
  {
    city: 'Clovis',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 1747.2,
    imprecise: false,
    latitude: 36.82552,
    longitude: -119.68115,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93611',
  },
  {
    city: 'Clovis',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 2160.1,
    imprecise: false,
    latitude: 36.81548,
    longitude: -119.71076,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93612',
  },
  {
    city: 'Coarsegold',
    county_fips: 6039,
    county_fips_all: '06039',
    county: 'Madera',
    county_names_all: 'Madera',
    county_weights: '{"06039": 100}',
    density: 34.4,
    imprecise: false,
    latitude: 37.21282,
    longitude: -119.72659,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93614',
  },
  {
    city: 'Cutler',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 138.3,
    imprecise: false,
    latitude: 36.50374,
    longitude: -119.28385,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93615',
  },
  {
    city: 'Del Rey',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 67.3,
    imprecise: false,
    latitude: 36.65468,
    longitude: -119.59437,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93616',
  },
  {
    city: 'Dinuba',
    county_fips: 6107,
    county_fips_all: '06107|06019',
    county: 'Tulare',
    county_names_all: 'Tulare|Fresno',
    county_weights: '{"06107": 88.96, "06019": 11.04}',
    density: 186.2,
    imprecise: false,
    latitude: 36.52213,
    longitude: -119.38661,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93618',
  },
  {
    city: 'Clovis',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 115.1,
    imprecise: false,
    latitude: 36.91656,
    longitude: -119.57372,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 55610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93619',
  },
  {
    city: 'Dos Palos',
    county_fips: 6047,
    county_fips_all: '06047|06019|06039',
    county: 'Merced',
    county_names_all: 'Merced|Fresno|Madera',
    county_weights: '{"06047": 75.66, "06019": 24.09, "06039": 0.25}',
    density: 23.8,
    imprecise: false,
    latitude: 37.0448,
    longitude: -120.6223,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9927,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93620',
  },
  {
    city: 'Dunlap',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 36.8067,
    longitude: -119.13602,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93621',
  },
  {
    city: 'Firebaugh',
    county_fips: 6019,
    county_fips_all: '06019|06039|06047',
    county: 'Fresno',
    county_names_all: 'Fresno|Madera|Merced',
    county_weights: '{"06019": 83.44, "06039": 10.32, "06047": 6.24}',
    density: 7.7,
    imprecise: false,
    latitude: 36.79283,
    longitude: -120.62434,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9084,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93622',
  },
  {
    city: 'Fish Camp',
    county_fips: 6043,
    county_fips_all: '06043|06039',
    county: 'Mariposa',
    county_names_all: 'Mariposa|Madera',
    county_weights: '{"06043": 96.0, "06039": 4.0}',
    density: 0.1,
    imprecise: false,
    latitude: 37.47478,
    longitude: -119.66071,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93623',
  },
  {
    city: 'Five Points',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 2,
    imprecise: false,
    latitude: 36.37258,
    longitude: -120.12125,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93624',
  },
  {
    city: 'Fowler',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 141.4,
    imprecise: false,
    latitude: 36.62423,
    longitude: -119.67173,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93625',
  },
  {
    city: 'Friant',
    county_fips: 6039,
    county_fips_all: '06039|06019',
    county: 'Madera',
    county_names_all: 'Madera|Fresno',
    county_weights: '{"06039": 72.18, "06019": 27.82}',
    density: 12.8,
    imprecise: false,
    latitude: 37.03278,
    longitude: -119.68601,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93626',
  },
  {
    city: 'Helm',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 36.51568,
    longitude: -120.10635,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93627',
  },
  {
    city: 'Hume',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 36.78149,
    longitude: -118.83839,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93628',
  },
  {
    city: 'Kerman',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 50.7,
    imprecise: false,
    latitude: 36.71831,
    longitude: -120.12912,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21284,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93630',
  },
  {
    city: 'Kingsburg',
    county_fips: 6107,
    county_fips_all: '06107|06019|06031',
    county: 'Tulare',
    county_names_all: 'Tulare|Fresno|Kings',
    county_weights: '{"06107": 53.33, "06019": 25.96, "06031": 20.71}',
    density: 82.2,
    imprecise: false,
    latitude: 36.47653,
    longitude: -119.52131,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93631',
  },
  {
    city: 'Kings Canyon National Pk',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 36.72912,
    longitude: -118.95627,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93633',
  },
  {
    city: 'Lakeshore',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.20583,
    longitude: -118.93652,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93634',
  },
  {
    city: 'Los Banos',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 49.6,
    imprecise: false,
    latitude: 37.016,
    longitude: -120.88294,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93635',
  },
  {
    city: 'Madera',
    county_fips: 6039,
    county_fips_all: '06039|06019',
    county: 'Madera',
    county_names_all: 'Madera|Fresno',
    county_weights: '{"06039": 99.9, "06019": 0.1}',
    density: 29.9,
    imprecise: false,
    latitude: 36.98171,
    longitude: -119.87706,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93636',
  },
  {
    city: 'Madera',
    county_fips: 6039,
    county_fips_all: '06039',
    county: 'Madera',
    county_names_all: 'Madera',
    county_weights: '{"06039": 100}',
    density: 60.3,
    imprecise: false,
    latitude: 36.91099,
    longitude: -120.1922,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93637',
  },
  {
    city: 'Madera',
    county_fips: 6039,
    county_fips_all: '06039',
    county: 'Madera',
    county_names_all: 'Madera',
    county_weights: '{"06039": 100}',
    density: 216.3,
    imprecise: false,
    latitude: 37.0424,
    longitude: -120.03816,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93638',
  },
  {
    city: 'Mendota',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 35.8,
    imprecise: false,
    latitude: 36.67215,
    longitude: -120.43778,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93640',
  },
  {
    city: 'Miramonte',
    county_fips: 6019,
    county_fips_all: '06019|06107',
    county: 'Fresno',
    county_names_all: 'Fresno|Tulare',
    county_weights: '{"06019": 71.54, "06107": 28.46}',
    density: 2.8,
    imprecise: false,
    latitude: 36.70481,
    longitude: -119.02167,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93641',
  },
  {
    city: 'North Fork',
    county_fips: 6039,
    county_fips_all: '06039',
    county: 'Madera',
    county_names_all: 'Madera',
    county_weights: '{"06039": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 37.27155,
    longitude: -119.45004,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93643',
  },
  {
    city: 'Oakhurst',
    county_fips: 6039,
    county_fips_all: '06039',
    county: 'Madera',
    county_names_all: 'Madera',
    county_weights: '{"06039": 100}',
    density: 25.1,
    imprecise: false,
    latitude: 37.41245,
    longitude: -119.59431,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7614,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93644',
  },
  {
    city: "O'Neals",
    county_fips: 6039,
    county_fips_all: '06039',
    county: 'Madera',
    county_names_all: 'Madera',
    county_weights: '{"06039": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 37.1641,
    longitude: -119.61824,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 905,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93645',
  },
  {
    city: 'Orange Cove',
    county_fips: 6107,
    county_fips_all: '06107|06019',
    county: 'Tulare',
    county_names_all: 'Tulare|Fresno',
    county_weights: '{"06107": 58.27, "06019": 41.73}',
    density: 116.3,
    imprecise: false,
    latitude: 36.63218,
    longitude: -119.28938,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93646',
  },
  {
    city: 'Orosi',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 48.7,
    imprecise: false,
    latitude: 36.58449,
    longitude: -119.17773,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93647',
  },
  {
    city: 'Parlier',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 265.1,
    imprecise: false,
    latitude: 36.6206,
    longitude: -119.52062,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15184,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93648',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 2059.3,
    imprecise: false,
    latitude: 36.84026,
    longitude: -119.80038,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93650',
  },
  {
    city: 'Prather',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 35.3,
    imprecise: false,
    latitude: 37.00296,
    longitude: -119.521,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93651',
  },
  {
    city: 'Raisin City',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 40.4,
    imprecise: false,
    latitude: 36.59502,
    longitude: -119.90458,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93652',
  },
  {
    city: 'Raymond',
    county_fips: 6039,
    county_fips_all: '06039|06043',
    county: 'Madera',
    county_names_all: 'Madera|Mariposa',
    county_weights: '{"06039": 69.45, "06043": 30.55}',
    density: 2.3,
    imprecise: false,
    latitude: 37.24769,
    longitude: -119.91882,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93653',
  },
  {
    city: 'Reedley',
    county_fips: 6019,
    county_fips_all: '06019|06107',
    county: 'Fresno',
    county_names_all: 'Fresno|Tulare',
    county_weights: '{"06019": 90.88, "06107": 9.12}',
    density: 122.5,
    imprecise: false,
    latitude: 36.65747,
    longitude: -119.402,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31876,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93654',
  },
  {
    city: 'Riverdale',
    county_fips: 6019,
    county_fips_all: '06019|06031',
    county: 'Fresno',
    county_names_all: 'Fresno|Kings',
    county_weights: '{"06019": 90.74, "06031": 9.26}',
    density: 24.5,
    imprecise: false,
    latitude: 36.45173,
    longitude: -119.93615,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93656',
  },
  {
    city: 'Sanger',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 61.9,
    imprecise: false,
    latitude: 36.78853,
    longitude: -119.4378,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93657',
  },
  {
    city: 'San Joaquin',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 36.60932,
    longitude: -120.16514,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93660',
  },
  {
    city: 'Selma',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 145.9,
    imprecise: false,
    latitude: 36.53963,
    longitude: -119.64287,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93662',
  },
  {
    city: 'Shaver Lake',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 37.05671,
    longitude: -119.17981,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93664',
  },
  {
    city: 'South Dos Palos',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 84.1,
    imprecise: false,
    latitude: 36.96334,
    longitude: -120.65034,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93665',
  },
  {
    city: 'Sultana',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 1154.6,
    imprecise: false,
    latitude: 36.54623,
    longitude: -119.33629,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93666',
  },
  {
    city: 'Tollhouse',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 7.3,
    imprecise: false,
    latitude: 36.96585,
    longitude: -119.31511,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93667',
  },
  {
    city: 'Tranquillity',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 6,
    imprecise: false,
    latitude: 36.65663,
    longitude: -120.28997,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93668',
  },
  {
    city: 'Yettem',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.48564,
    longitude: -119.25442,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93670',
  },
  {
    city: 'Traver',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 172.5,
    imprecise: false,
    latitude: 36.45229,
    longitude: -119.48232,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93673',
  },
  {
    city: 'Squaw Valley',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 36.73251,
    longitude: -119.19285,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93675',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 2489.9,
    imprecise: false,
    latitude: 36.74955,
    longitude: -119.78772,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93701',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 3276.4,
    imprecise: false,
    latitude: 36.73942,
    longitude: -119.75422,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43875,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93702',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 2710.3,
    imprecise: false,
    latitude: 36.76884,
    longitude: -119.76249,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93703',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 2069.9,
    imprecise: false,
    latitude: 36.80012,
    longitude: -119.80202,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93704',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 3086.3,
    imprecise: false,
    latitude: 36.78667,
    longitude: -119.82851,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93705',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 99,
    imprecise: false,
    latitude: 36.65344,
    longitude: -119.90216,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93706',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 1980.9,
    imprecise: false,
    latitude: 36.82335,
    longitude: -119.76251,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93710',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019|06039',
    county: 'Fresno',
    county_names_all: 'Fresno|Madera',
    county_weights: '{"06019": 99.85, "06039": 0.15}',
    density: 1351,
    imprecise: false,
    latitude: 36.83508,
    longitude: -119.83309,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93711',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019|06039',
    county: 'Fresno',
    county_names_all: 'Fresno|Madera',
    county_weights: '{"06019": 97.78, "06039": 2.22}',
    density: 1852.2,
    imprecise: false,
    latitude: 36.8606,
    longitude: -119.76228,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93720',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 1366.8,
    imprecise: false,
    latitude: 36.73282,
    longitude: -119.78383,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93721',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 1722.7,
    imprecise: false,
    latitude: 36.80003,
    longitude: -119.87791,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 86110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93722',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 138.4,
    imprecise: false,
    latitude: 36.78693,
    longitude: -119.95271,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93723',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 141.6,
    imprecise: false,
    latitude: 36.62667,
    longitude: -119.73501,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93725',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 2694.1,
    imprecise: false,
    latitude: 36.79374,
    longitude: -119.76161,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93726',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 1477.6,
    imprecise: false,
    latitude: 36.75119,
    longitude: -119.69736,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 84107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93727',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 2324.2,
    imprecise: false,
    latitude: 36.75729,
    longitude: -119.81816,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93728',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 699.9,
    imprecise: false,
    latitude: 36.90354,
    longitude: -119.75512,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93730',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 287.9,
    imprecise: false,
    latitude: 36.75358,
    longitude: -119.6456,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93737',
  },
  {
    city: 'Salinas',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 1197.2,
    imprecise: false,
    latitude: 36.64794,
    longitude: -121.63044,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93901',
  },
  {
    city: 'Salinas',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 2670.1,
    imprecise: false,
    latitude: 36.6849,
    longitude: -121.60562,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 63898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93905',
  },
  {
    city: 'Salinas',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 1869.3,
    imprecise: false,
    latitude: 36.72258,
    longitude: -121.63218,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 64199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93906',
  },
  {
    city: 'Salinas',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 178.1,
    imprecise: false,
    latitude: 36.76643,
    longitude: -121.66816,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93907',
  },
  {
    city: 'Salinas',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 20,
    imprecise: false,
    latitude: 36.62153,
    longitude: -121.60048,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93908',
  },
  {
    city: 'Big Sur',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 36.03164,
    longitude: -121.52592,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93920',
  },
  {
    city: 'Carmel By The Sea',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 941.7,
    imprecise: false,
    latitude: 36.55359,
    longitude: -121.92259,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2322,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93921',
  },
  {
    city: 'Carmel',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 23.9,
    imprecise: false,
    latitude: 36.40394,
    longitude: -121.79867,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93923',
  },
  {
    city: 'Carmel Valley',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 13,
    imprecise: false,
    latitude: 36.39489,
    longitude: -121.63406,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93924',
  },
  {
    city: 'Chualar',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 36.60209,
    longitude: -121.42526,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93925',
  },
  {
    city: 'Gonzales',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 50.2,
    imprecise: false,
    latitude: 36.52567,
    longitude: -121.3991,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93926',
  },
  {
    city: 'Greenfield',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 36.26978,
    longitude: -121.38018,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93927',
  },
  {
    city: 'Jolon',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 36.06484,
    longitude: -121.38102,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93928',
  },
  {
    city: 'King City',
    county_fips: 6053,
    county_fips_all: '06053|06069',
    county: 'Monterey',
    county_names_all: 'Monterey|San Benito',
    county_weights: '{"06053": 81.1, "06069": 18.9}',
    density: 19.4,
    imprecise: false,
    latitude: 36.19924,
    longitude: -121.07282,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93930',
  },
  {
    city: 'Lockwood',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 36.00143,
    longitude: -121.05757,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93932',
  },
  {
    city: 'Marina',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 1017.2,
    imprecise: false,
    latitude: 36.67566,
    longitude: -121.78237,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93933',
  },
  {
    city: 'Monterey',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 336.3,
    imprecise: false,
    latitude: 36.45294,
    longitude: -121.8498,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93940',
  },
  {
    city: 'Monterey',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 3053.5,
    imprecise: false,
    latitude: 36.60058,
    longitude: -121.91858,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93944',
  },
  {
    city: 'Pacific Grove',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 2055.8,
    imprecise: false,
    latitude: 36.61899,
    longitude: -121.92575,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93950',
  },
  {
    city: 'Pebble Beach',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 172.2,
    imprecise: false,
    latitude: 36.58566,
    longitude: -121.94329,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93953',
  },
  {
    city: 'San Lucas',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 36.16434,
    longitude: -120.92441,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93954',
  },
  {
    city: 'Seaside',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 473.6,
    imprecise: false,
    latitude: 36.62153,
    longitude: -121.79562,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32266,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93955',
  },
  {
    city: 'Soledad',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 60.9,
    imprecise: false,
    latitude: 36.40489,
    longitude: -121.32121,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93960',
  },
  {
    city: 'Spreckels',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 550,
    imprecise: false,
    latitude: 36.62472,
    longitude: -121.64649,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93962',
  },
  {
    city: 'Belmont',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 1890.2,
    imprecise: false,
    latitude: 37.51366,
    longitude: -122.29853,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94002',
  },
  {
    city: 'Brisbane',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 395.5,
    imprecise: false,
    latitude: 37.6882,
    longitude: -122.40873,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94005',
  },
  {
    city: 'Burlingame',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 1098.9,
    imprecise: false,
    latitude: 37.57306,
    longitude: -122.37828,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94010',
  },
  {
    city: 'Daly City',
    county_fips: 6081,
    county_fips_all: '06081|06075',
    county: 'San Mateo',
    county_names_all: 'San Mateo|San Francisco',
    county_weights: '{"06081": 99.8, "06075": 0.2}',
    density: 2737.5,
    imprecise: false,
    latitude: 37.6907,
    longitude: -122.44769,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94014',
  },
  {
    city: 'Daly City',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 4375.5,
    imprecise: false,
    latitude: 37.68121,
    longitude: -122.48074,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 64091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94015',
  },
  {
    city: 'El Granada',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 2556.6,
    imprecise: false,
    latitude: 37.50603,
    longitude: -122.47321,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94018',
  },
  {
    city: 'Half Moon Bay',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 93.2,
    imprecise: false,
    latitude: 37.44826,
    longitude: -122.4023,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94019',
  },
  {
    city: 'La Honda',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 37.28473,
    longitude: -122.21969,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94020',
  },
  {
    city: 'Loma Mar',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 37.25028,
    longitude: -122.24958,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94021',
  },
  {
    city: 'Los Altos',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 436.4,
    imprecise: false,
    latitude: 37.35534,
    longitude: -122.14494,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20027,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94022',
  },
  {
    city: 'Los Altos',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 1075.8,
    imprecise: false,
    latitude: 37.35037,
    longitude: -122.09863,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23051,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94024',
  },
  {
    city: 'Menlo Park',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 1879.5,
    imprecise: false,
    latitude: 37.45087,
    longitude: -122.1829,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94025',
  },
  {
    city: 'Atherton',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 537.8,
    imprecise: false,
    latitude: 37.45399,
    longitude: -122.20313,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94027',
  },
  {
    city: 'Portola Valley',
    county_fips: 6081,
    county_fips_all: '06081|06085',
    county: 'San Mateo',
    county_names_all: 'San Mateo|Santa Clara',
    county_weights: '{"06081": 80.67, "06085": 19.33}',
    density: 145.6,
    imprecise: false,
    latitude: 37.37492,
    longitude: -122.21136,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94028',
  },
  {
    city: 'Millbrae',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 2596.2,
    imprecise: false,
    latitude: 37.59969,
    longitude: -122.40343,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94030',
  },
  {
    city: 'Montara',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 204.7,
    imprecise: false,
    latitude: 37.55327,
    longitude: -122.49584,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94037',
  },
  {
    city: 'Moss Beach',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 174.2,
    imprecise: false,
    latitude: 37.52946,
    longitude: -122.4849,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94038',
  },
  {
    city: 'Mountain View',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3758.9,
    imprecise: false,
    latitude: 37.38034,
    longitude: -122.08531,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94040',
  },
  {
    city: 'Mountain View',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3894.9,
    imprecise: false,
    latitude: 37.38822,
    longitude: -122.07529,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94041',
  },
  {
    city: 'Mountain View',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 1514.4,
    imprecise: false,
    latitude: 37.41188,
    longitude: -122.06892,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33176,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94043',
  },
  {
    city: 'Pacifica',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 953.9,
    imprecise: false,
    latitude: 37.60544,
    longitude: -122.47993,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94044',
  },
  {
    city: 'Pescadero',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 37.22297,
    longitude: -122.33572,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94060',
  },
  {
    city: 'Redwood City',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 3704.8,
    imprecise: false,
    latitude: 37.46136,
    longitude: -122.23731,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94061',
  },
  {
    city: 'Redwood City',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 153.8,
    imprecise: false,
    latitude: 37.42562,
    longitude: -122.29653,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94062',
  },
  {
    city: 'Redwood City',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 2044.6,
    imprecise: false,
    latitude: 37.49367,
    longitude: -122.20823,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94063',
  },
  {
    city: 'Redwood City',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 1965,
    imprecise: false,
    latitude: 37.53504,
    longitude: -122.24683,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11673,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94065',
  },
  {
    city: 'San Bruno',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 2722.2,
    imprecise: false,
    latitude: 37.62539,
    longitude: -122.43229,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94066',
  },
  {
    city: 'San Carlos',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 1920.5,
    imprecise: false,
    latitude: 37.49739,
    longitude: -122.27021,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94070',
  },
  {
    city: 'San Gregorio',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 37.32817,
    longitude: -122.34164,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 126,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94074',
  },
  {
    city: 'South San Francisco',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 2456.9,
    imprecise: false,
    latitude: 37.65541,
    longitude: -122.42083,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 64761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94080',
  },
  {
    city: 'Sunnyvale',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 2640.6,
    imprecise: false,
    latitude: 37.38862,
    longitude: -122.01793,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94085',
  },
  {
    city: 'Sunnyvale',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 4398.5,
    imprecise: false,
    latitude: 37.37164,
    longitude: -122.02316,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94086',
  },
  {
    city: 'Sunnyvale',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3384,
    imprecise: false,
    latitude: 37.35164,
    longitude: -122.03669,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94087',
  },
  {
    city: 'Sunnyvale',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 1440.3,
    imprecise: false,
    latitude: 37.41192,
    longitude: -122.01441,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94089',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 20998.3,
    imprecise: false,
    latitude: 37.77956,
    longitude: -122.41931,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94102',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 9826,
    imprecise: false,
    latitude: 37.77299,
    longitude: -122.41136,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94103',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 2479.4,
    imprecise: false,
    latitude: 37.79144,
    longitude: -122.40211,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94104',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 10607.6,
    imprecise: false,
    latitude: 37.79239,
    longitude: -122.39707,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94105',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 6621,
    imprecise: false,
    latitude: 37.76473,
    longitude: -122.39508,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94107',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 16919.8,
    imprecise: false,
    latitude: 37.79189,
    longitude: -122.40854,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94108',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 19526.7,
    imprecise: false,
    latitude: 37.79334,
    longitude: -122.42138,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94109',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 10802.7,
    imprecise: false,
    latitude: 37.74975,
    longitude: -122.41528,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 66865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94110',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 5299.5,
    imprecise: false,
    latitude: 37.79847,
    longitude: -122.3998,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94111',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075|06081',
    county: 'San Francisco',
    county_names_all: 'San Francisco|San Mateo',
    county_weights: '{"06075": 99.66, "06081": 0.34}',
    density: 9177,
    imprecise: false,
    latitude: 37.7206,
    longitude: -122.44311,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 79277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94112',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 9207.4,
    imprecise: false,
    latitude: 37.75814,
    longitude: -122.43547,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33020,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94114',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 11086.2,
    imprecise: false,
    latitude: 37.78608,
    longitude: -122.43742,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94115',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 6693.3,
    imprecise: false,
    latitude: 37.74457,
    longitude: -122.48611,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43791,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94116',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 10965.6,
    imprecise: false,
    latitude: 37.77002,
    longitude: -122.44425,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94117',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 7534.3,
    imprecise: false,
    latitude: 37.7801,
    longitude: -122.46185,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94118',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 6397.3,
    imprecise: false,
    latitude: 37.77849,
    longitude: -122.49548,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94121',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 6616.6,
    imprecise: false,
    latitude: 37.76113,
    longitude: -122.48433,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 55819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94122',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 8577.9,
    imprecise: false,
    latitude: 37.80112,
    longitude: -122.43645,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94123',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 2788.9,
    imprecise: false,
    latitude: 37.73204,
    longitude: -122.3858,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94124',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 4200.2,
    imprecise: false,
    latitude: 37.73642,
    longitude: -122.45961,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94127',
  },
  {
    city: 'San Francisco',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.62197,
    longitude: -122.38388,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94128',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 630.5,
    imprecise: false,
    latitude: 37.79743,
    longitude: -122.46662,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94129',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 1064.8,
    imprecise: false,
    latitude: 37.81975,
    longitude: -122.36898,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94130',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 5442.7,
    imprecise: false,
    latitude: 37.74569,
    longitude: -122.44243,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94131',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 3311.1,
    imprecise: false,
    latitude: 37.72219,
    longitude: -122.48475,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94132',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 13976.7,
    imprecise: false,
    latitude: 37.80193,
    longitude: -122.41092,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94133',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075|06081',
    county: 'San Francisco',
    county_names_all: 'San Francisco|San Mateo',
    county_weights: '{"06075": 99.44, "06081": 0.56}',
    density: 5829.2,
    imprecise: false,
    latitude: 37.71887,
    longitude: -122.41124,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94134',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 7150.9,
    imprecise: false,
    latitude: 37.77116,
    longitude: -122.39153,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94158',
  },
  {
    city: 'San Francisco',
    county_fips: 6075,
    county_fips_all: '06075',
    county: 'San Francisco',
    county_names_all: 'San Francisco',
    county_weights: '{"06075": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.7407,
    longitude: -122.38091,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94188',
  },
  {
    city: 'Palo Alto',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 2852,
    imprecise: false,
    latitude: 37.44424,
    longitude: -122.14992,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94301',
  },
  {
    city: 'Palo Alto',
    county_fips: 6085,
    county_fips_all: '06085|06081',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara|San Mateo',
    county_weights: '{"06085": 67.45, "06081": 32.55}',
    density: 2144.8,
    imprecise: false,
    latitude: 37.45064,
    longitude: -122.11928,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94303',
  },
  {
    city: 'Palo Alto',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 401.6,
    imprecise: false,
    latitude: 37.39744,
    longitude: -122.16699,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94304',
  },
  {
    city: 'Stanford',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 1495.2,
    imprecise: false,
    latitude: 37.41623,
    longitude: -122.17069,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94305',
  },
  {
    city: 'Palo Alto',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 2569,
    imprecise: false,
    latitude: 37.41627,
    longitude: -122.13088,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94306',
  },
  {
    city: 'San Mateo',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 4380.9,
    imprecise: false,
    latitude: 37.57445,
    longitude: -122.31942,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94401',
  },
  {
    city: 'San Mateo',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 1946.5,
    imprecise: false,
    latitude: 37.54035,
    longitude: -122.33388,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94402',
  },
  {
    city: 'San Mateo',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 2966.4,
    imprecise: false,
    latitude: 37.53844,
    longitude: -122.30454,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94403',
  },
  {
    city: 'San Mateo',
    county_fips: 6081,
    county_fips_all: '06081',
    county: 'San Mateo',
    county_names_all: 'San Mateo',
    county_weights: '{"06081": 100}',
    density: 3184.8,
    imprecise: false,
    latitude: 37.5562,
    longitude: -122.26905,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94404',
  },
  {
    city: 'Alameda',
    county_fips: 6001,
    county_fips_all: '06001|06075',
    county: 'Alameda',
    county_names_all: 'Alameda|San Francisco',
    county_weights: '{"06001": 99.58, "06075": 0.42}',
    density: 3089.9,
    imprecise: false,
    latitude: 37.77525,
    longitude: -122.27493,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 63808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94501',
  },
  {
    city: 'Alameda',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 2055.9,
    imprecise: false,
    latitude: 37.73686,
    longitude: -122.24114,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94502',
  },
  {
    city: 'American Canyon',
    county_fips: 6055,
    county_fips_all: '06055|06095',
    county: 'Napa',
    county_names_all: 'Napa|Solano',
    county_weights: '{"06055": 68.42, "06095": 31.58}',
    density: 311.9,
    imprecise: false,
    latitude: 38.19454,
    longitude: -122.23042,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94503',
  },
  {
    city: 'Discovery Bay',
    county_fips: 6013,
    county_fips_all: '06013|06001|06077',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa|Alameda|San Joaquin',
    county_weights: '{"06013": 96.44, "06001": 3.0, "06077": 0.56}',
    density: 346.7,
    imprecise: false,
    latitude: 37.86638,
    longitude: -121.5868,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94505',
  },
  {
    city: 'Danville',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 559.9,
    imprecise: false,
    latitude: 37.80862,
    longitude: -121.90498,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94506',
  },
  {
    city: 'Alamo',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 502.9,
    imprecise: false,
    latitude: 37.85429,
    longitude: -122.00664,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94507',
  },
  {
    city: 'Angwin',
    county_fips: 6055,
    county_fips_all: '06055',
    county: 'Napa',
    county_names_all: 'Napa',
    county_weights: '{"06055": 100}',
    density: 84.3,
    imprecise: false,
    latitude: 38.57909,
    longitude: -122.44451,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94508',
  },
  {
    city: 'Antioch',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 1551.4,
    imprecise: false,
    latitude: 37.99214,
    longitude: -121.8142,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 70090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94509',
  },
  {
    city: 'Benicia',
    county_fips: 6095,
    county_fips_all: '06095',
    county: 'Solano',
    county_names_all: 'Solano',
    county_weights: '{"06095": 100}',
    density: 354,
    imprecise: false,
    latitude: 38.09756,
    longitude: -122.13189,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94510',
  },
  {
    city: 'Bethel Island',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 137,
    imprecise: false,
    latitude: 38.02883,
    longitude: -121.64039,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94511',
  },
  {
    city: 'Birds Landing',
    county_fips: 6095,
    county_fips_all: '06095',
    county: 'Solano',
    county_names_all: 'Solano',
    county_weights: '{"06095": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 38.1263,
    longitude: -121.83793,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94512',
  },
  {
    city: 'Brentwood',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 341.5,
    imprecise: false,
    latitude: 37.92541,
    longitude: -121.68452,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 69755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94513',
  },
  {
    city: 'Byron',
    county_fips: 6013,
    county_fips_all: '06013|06001',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa|Alameda',
    county_weights: '{"06013": 82.38, "06001": 17.62}',
    density: 25.1,
    imprecise: false,
    latitude: 37.83071,
    longitude: -121.63392,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94514',
  },
  {
    city: 'Calistoga',
    county_fips: 6097,
    county_fips_all: '06097|06055',
    county: 'Sonoma',
    county_names_all: 'Sonoma|Napa',
    county_weights: '{"06097": 50.66, "06055": 49.34}',
    density: 23.2,
    imprecise: false,
    latitude: 38.62449,
    longitude: -122.62503,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94515',
  },
  {
    city: 'Canyon',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 37.82748,
    longitude: -122.16629,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94516',
  },
  {
    city: 'Clayton',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 99.6,
    imprecise: false,
    latitude: 37.8926,
    longitude: -121.88252,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94517',
  },
  {
    city: 'Concord',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 1905.5,
    imprecise: false,
    latitude: 37.95052,
    longitude: -122.02209,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94518',
  },
  {
    city: 'Concord',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 1622.2,
    imprecise: false,
    latitude: 37.98881,
    longitude: -122.01275,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94519',
  },
  {
    city: 'Concord',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 1462,
    imprecise: false,
    latitude: 37.99344,
    longitude: -122.03532,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37381,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94520',
  },
  {
    city: 'Concord',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 1671.1,
    imprecise: false,
    latitude: 37.95293,
    longitude: -121.96971,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41909,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94521',
  },
  {
    city: 'Pleasant Hill',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 1853.6,
    imprecise: false,
    latitude: 37.95403,
    longitude: -122.07608,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94523',
  },
  {
    city: 'Crockett',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 530.9,
    imprecise: false,
    latitude: 38.04811,
    longitude: -122.2292,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94525',
  },
  {
    city: 'Danville',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 955.2,
    imprecise: false,
    latitude: 37.81472,
    longitude: -121.98451,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94526',
  },
  {
    city: 'Diablo',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 351,
    imprecise: false,
    latitude: 37.84149,
    longitude: -121.95819,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94528',
  },
  {
    city: 'El Cerrito',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 2354,
    imprecise: false,
    latitude: 37.92076,
    longitude: -122.30068,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26401,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94530',
  },
  {
    city: 'Antioch',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 1276.8,
    imprecise: false,
    latitude: 37.95665,
    longitude: -121.77777,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94531',
  },
  {
    city: 'Fairfield',
    county_fips: 6095,
    county_fips_all: '06095',
    county: 'Solano',
    county_names_all: 'Solano',
    county_weights: '{"06095": 100}',
    density: 1350.7,
    imprecise: false,
    latitude: 38.28132,
    longitude: -122.00693,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 78805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94533',
  },
  {
    city: 'Fairfield',
    county_fips: 6095,
    county_fips_all: '06095|06055',
    county: 'Solano',
    county_names_all: 'Solano|Napa',
    county_weights: '{"06095": 99.85, "06055": 0.15}',
    density: 205.1,
    imprecise: false,
    latitude: 38.24112,
    longitude: -122.12142,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94534',
  },
  {
    city: 'Travis Afb',
    county_fips: 6095,
    county_fips_all: '06095',
    county: 'Solano',
    county_names_all: 'Solano',
    county_weights: '{"06095": 100}',
    density: 158.9,
    imprecise: false,
    latitude: 38.27048,
    longitude: -121.93851,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94535',
  },
  {
    city: 'Fremont',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 1936.9,
    imprecise: false,
    latitude: 37.57072,
    longitude: -121.98555,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 70619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94536',
  },
  {
    city: 'Fremont',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 1582.5,
    imprecise: false,
    latitude: 37.50653,
    longitude: -121.96361,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 67781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94538',
  },
  {
    city: 'Fremont',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 806.8,
    imprecise: false,
    latitude: 37.51635,
    longitude: -121.9119,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94539',
  },
  {
    city: 'Hayward',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 3477.5,
    imprecise: false,
    latitude: 37.67376,
    longitude: -122.08707,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 67139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94541',
  },
  {
    city: 'Hayward',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 663.5,
    imprecise: false,
    latitude: 37.6553,
    longitude: -122.02584,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94542',
  },
  {
    city: 'Hayward',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 2712.7,
    imprecise: false,
    latitude: 37.63352,
    longitude: -122.05678,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 76947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94544',
  },
  {
    city: 'Hayward',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 875.8,
    imprecise: false,
    latitude: 37.62957,
    longitude: -122.12048,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94545',
  },
  {
    city: 'Castro Valley',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 1085.3,
    imprecise: false,
    latitude: 37.73441,
    longitude: -122.09056,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94546',
  },
  {
    city: 'Hercules',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 1790.9,
    imprecise: false,
    latitude: 38.00637,
    longitude: -122.26117,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94547',
  },
  {
    city: 'Knightsen',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 139,
    imprecise: false,
    latitude: 37.97481,
    longitude: -121.65265,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94548',
  },
  {
    city: 'Lafayette',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 552.9,
    imprecise: false,
    latitude: 37.90133,
    longitude: -122.11933,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94549',
  },
  {
    city: 'Livermore',
    county_fips: 6001,
    county_fips_all: '06001|06085',
    county: 'Alameda',
    county_names_all: 'Alameda|Santa Clara',
    county_weights: '{"06001": 61.55, "06085": 38.45}',
    density: 70.8,
    imprecise: false,
    latitude: 37.51746,
    longitude: -121.59406,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94550',
  },
  {
    city: 'Livermore',
    county_fips: 6001,
    county_fips_all: '06001|06013',
    county: 'Alameda',
    county_names_all: 'Alameda|Contra Costa',
    county_weights: '{"06001": 63.12, "06013": 36.88}',
    density: 176.8,
    imprecise: false,
    latitude: 37.75902,
    longitude: -121.76026,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94551',
  },
  {
    city: 'Castro Valley',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 108.1,
    imprecise: false,
    latitude: 37.70456,
    longitude: -122.01359,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94552',
  },
  {
    city: 'Martinez',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 304.7,
    imprecise: false,
    latitude: 37.97999,
    longitude: -122.15368,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94553',
  },
  {
    city: 'Fremont',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 1045,
    imprecise: false,
    latitude: 37.55083,
    longitude: -122.08043,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94555',
  },
  {
    city: 'Moraga',
    county_fips: 6013,
    county_fips_all: '06013|06001',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa|Alameda',
    county_weights: '{"06013": 99.9, "06001": 0.1}',
    density: 320.4,
    imprecise: false,
    latitude: 37.83102,
    longitude: -122.10425,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94556',
  },
  {
    city: 'Napa',
    county_fips: 6055,
    county_fips_all: '06055',
    county: 'Napa',
    county_names_all: 'Napa',
    county_weights: '{"06055": 100}',
    density: 61.5,
    imprecise: false,
    latitude: 38.50846,
    longitude: -122.26497,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 63657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94558',
  },
  {
    city: 'Napa',
    county_fips: 6055,
    county_fips_all: '06055|06095',
    county: 'Napa',
    county_names_all: 'Napa|Solano',
    county_weights: '{"06055": 99.87, "06095": 0.13}',
    density: 258.7,
    imprecise: false,
    latitude: 38.25238,
    longitude: -122.29382,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94559',
  },
  {
    city: 'Newark',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 902,
    imprecise: false,
    latitude: 37.50771,
    longitude: -122.02523,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94560',
  },
  {
    city: 'Oakley',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 1032.5,
    imprecise: false,
    latitude: 37.99311,
    longitude: -121.69172,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94561',
  },
  {
    city: 'Oakville',
    county_fips: 6055,
    county_fips_all: '06055',
    county: 'Napa',
    county_names_all: 'Napa',
    county_weights: '{"06055": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.43071,
    longitude: -122.40874,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94562',
  },
  {
    city: 'Orinda',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 364.6,
    imprecise: false,
    latitude: 37.88196,
    longitude: -122.19419,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94563',
  },
  {
    city: 'Pinole',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 1060.7,
    imprecise: false,
    latitude: 37.98896,
    longitude: -122.27018,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94564',
  },
  {
    city: 'Pittsburg',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 856.6,
    imprecise: false,
    latitude: 38.00926,
    longitude: -121.92886,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 100488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94565',
  },
  {
    city: 'Pleasanton',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 840.2,
    imprecise: false,
    latitude: 37.65032,
    longitude: -121.85881,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94566',
  },
  {
    city: 'Pope Valley',
    county_fips: 6055,
    county_fips_all: '06055',
    county: 'Napa',
    county_names_all: 'Napa',
    county_weights: '{"06055": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 38.66342,
    longitude: -122.4349,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94567',
  },
  {
    city: 'Dublin',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 1657.4,
    imprecise: false,
    latitude: 37.71596,
    longitude: -121.90113,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 70803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94568',
  },
  {
    city: 'Port Costa',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 88.9,
    imprecise: false,
    latitude: 38.04411,
    longitude: -122.19201,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94569',
  },
  {
    city: 'Rio Vista',
    county_fips: 6095,
    county_fips_all: '06095|06067',
    county: 'Solano',
    county_names_all: 'Solano|Sacramento',
    county_weights: '{"06095": 78.06, "06067": 21.94}',
    density: 38.8,
    imprecise: false,
    latitude: 38.1566,
    longitude: -121.7482,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94571',
  },
  {
    city: 'Rodeo',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 377.1,
    imprecise: false,
    latitude: 38.02392,
    longitude: -122.23285,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94572',
  },
  {
    city: 'Rutherford',
    county_fips: 6055,
    county_fips_all: '06055',
    county: 'Napa',
    county_names_all: 'Napa',
    county_weights: '{"06055": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 38.45726,
    longitude: -122.42348,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94573',
  },
  {
    city: 'Saint Helena',
    county_fips: 6055,
    county_fips_all: '06055|06097',
    county: 'Napa',
    county_names_all: 'Napa|Sonoma',
    county_weights: '{"06055": 98.7, "06097": 1.3}',
    density: 23.2,
    imprecise: false,
    latitude: 38.52742,
    longitude: -122.39261,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94574',
  },
  {
    city: 'Deer Park',
    county_fips: 6055,
    county_fips_all: '06055',
    county: 'Napa',
    county_names_all: 'Napa',
    county_weights: '{"06055": 100}',
    density: 140,
    imprecise: false,
    latitude: 38.54932,
    longitude: -122.47581,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94576',
  },
  {
    city: 'San Leandro',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 2203.8,
    imprecise: false,
    latitude: 37.71595,
    longitude: -122.16615,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94577',
  },
  {
    city: 'San Leandro',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 3537.7,
    imprecise: false,
    latitude: 37.70675,
    longitude: -122.1256,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94578',
  },
  {
    city: 'San Leandro',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 2471.1,
    imprecise: false,
    latitude: 37.68656,
    longitude: -122.15709,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94579',
  },
  {
    city: 'San Lorenzo',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 3419,
    imprecise: false,
    latitude: 37.67803,
    longitude: -122.13334,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94580',
  },
  {
    city: 'San Ramon',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 1365.3,
    imprecise: false,
    latitude: 37.76357,
    longitude: -121.91469,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94582',
  },
  {
    city: 'San Ramon',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 719.7,
    imprecise: false,
    latitude: 37.77245,
    longitude: -121.99157,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94583',
  },
  {
    city: 'Suisun City',
    county_fips: 6095,
    county_fips_all: '06095',
    county: 'Solano',
    county_names_all: 'Solano',
    county_weights: '{"06095": 100}',
    density: 106.7,
    imprecise: false,
    latitude: 38.19061,
    longitude: -121.94216,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94585',
  },
  {
    city: 'Sunol',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 37.57327,
    longitude: -121.85472,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94586',
  },
  {
    city: 'Union City',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 1326.9,
    imprecise: false,
    latitude: 37.59142,
    longitude: -122.06993,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 67464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94587',
  },
  {
    city: 'Pleasanton',
    county_fips: 6001,
    county_fips_all: '06001|06013',
    county: 'Alameda',
    county_names_all: 'Alameda|Contra Costa',
    county_weights: '{"06001": 51.42, "06013": 48.58}',
    density: 404.8,
    imprecise: false,
    latitude: 37.73801,
    longitude: -121.88178,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94588',
  },
  {
    city: 'Vallejo',
    county_fips: 6095,
    county_fips_all: '06095',
    county: 'Solano',
    county_names_all: 'Solano',
    county_weights: '{"06095": 100}',
    density: 2044.1,
    imprecise: false,
    latitude: 38.14162,
    longitude: -122.24596,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29990,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94589',
  },
  {
    city: 'Vallejo',
    county_fips: 6095,
    county_fips_all: '06095',
    county: 'Solano',
    county_names_all: 'Solano',
    county_weights: '{"06095": 100}',
    density: 2184.4,
    imprecise: false,
    latitude: 38.09546,
    longitude: -122.24986,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94590',
  },
  {
    city: 'Vallejo',
    county_fips: 6095,
    county_fips_all: '06095|06055',
    county: 'Solano',
    county_names_all: 'Solano|Napa',
    county_weights: '{"06095": 96.95, "06055": 3.05}',
    density: 1065,
    imprecise: false,
    latitude: 38.12702,
    longitude: -122.19635,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 58193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94591',
  },
  {
    city: 'Vallejo',
    county_fips: 6095,
    county_fips_all: '06095',
    county: 'Solano',
    county_names_all: 'Solano',
    county_weights: '{"06095": 100}',
    density: 50.6,
    imprecise: false,
    latitude: 38.12009,
    longitude: -122.3117,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94592',
  },
  {
    city: 'Walnut Creek',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 1256.9,
    imprecise: false,
    latitude: 37.87206,
    longitude: -122.06892,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16988,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94595',
  },
  {
    city: 'Walnut Creek',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 1491.4,
    imprecise: false,
    latitude: 37.88902,
    longitude: -122.03676,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94596',
  },
  {
    city: 'Walnut Creek',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 2203.4,
    imprecise: false,
    latitude: 37.91768,
    longitude: -122.0718,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94597',
  },
  {
    city: 'Walnut Creek',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 509.6,
    imprecise: false,
    latitude: 37.89238,
    longitude: -121.98283,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94598',
  },
  {
    city: 'Yountville',
    county_fips: 6055,
    county_fips_all: '06055',
    county: 'Napa',
    county_names_all: 'Napa',
    county_weights: '{"06055": 100}',
    density: 162.7,
    imprecise: false,
    latitude: 38.41012,
    longitude: -122.37365,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94599',
  },
  {
    city: 'Oakland',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 6427.6,
    imprecise: false,
    latitude: 37.77684,
    longitude: -122.21822,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 53259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94601',
  },
  {
    city: 'Oakland',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 3371.1,
    imprecise: false,
    latitude: 37.80517,
    longitude: -122.20422,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94602',
  },
  {
    city: 'Oakland',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 5114.7,
    imprecise: false,
    latitude: 37.73923,
    longitude: -122.17554,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94603',
  },
  {
    city: 'Oakland',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 1928.5,
    imprecise: false,
    latitude: 37.76062,
    longitude: -122.14903,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94605',
  },
  {
    city: 'Oakland',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 6633.9,
    imprecise: false,
    latitude: 37.79179,
    longitude: -122.24455,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94606',
  },
  {
    city: 'Oakland',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 1887.7,
    imprecise: false,
    latitude: 37.80721,
    longitude: -122.30024,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94607',
  },
  {
    city: 'Emeryville',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 4826.1,
    imprecise: false,
    latitude: 37.83611,
    longitude: -122.28621,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94608',
  },
  {
    city: 'Oakland',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 5547.7,
    imprecise: false,
    latitude: 37.83476,
    longitude: -122.2642,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94609',
  },
  {
    city: 'Oakland',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 6023.7,
    imprecise: false,
    latitude: 37.81229,
    longitude: -122.24048,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94610',
  },
  {
    city: 'Oakland',
    county_fips: 6001,
    county_fips_all: '06001|06013',
    county: 'Alameda',
    county_names_all: 'Alameda|Contra Costa',
    county_weights: '{"06001": 94.89, "06013": 5.11}',
    density: 2121.8,
    imprecise: false,
    latitude: 37.83191,
    longitude: -122.21592,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94611',
  },
  {
    city: 'Oakland',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 7323.2,
    imprecise: false,
    latitude: 37.80789,
    longitude: -122.2662,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94612',
  },
  {
    city: 'Oakland',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 2702.2,
    imprecise: false,
    latitude: 37.8442,
    longitude: -122.23868,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94618',
  },
  {
    city: 'Oakland',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 1241.3,
    imprecise: false,
    latitude: 37.79262,
    longitude: -122.16001,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94619',
  },
  {
    city: 'Oakland',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 1534.7,
    imprecise: false,
    latitude: 37.7379,
    longitude: -122.20794,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94621',
  },
  {
    city: 'Berkeley',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 5311.3,
    imprecise: false,
    latitude: 37.86619,
    longitude: -122.28634,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94702',
  },
  {
    city: 'Berkeley',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 6276.9,
    imprecise: false,
    latitude: 37.86397,
    longitude: -122.27573,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94703',
  },
  {
    city: 'Berkeley',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 10792,
    imprecise: false,
    latitude: 37.8664,
    longitude: -122.26088,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23788,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94704',
  },
  {
    city: 'Berkeley',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 1597.9,
    imprecise: false,
    latitude: 37.86523,
    longitude: -122.2384,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13991,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94705',
  },
  {
    city: 'Albany',
    county_fips: 6001,
    county_fips_all: '06001|06013',
    county: 'Alameda',
    county_names_all: 'Alameda|Contra Costa',
    county_weights: '{"06001": 99.54, "06013": 0.46}',
    density: 5265.2,
    imprecise: false,
    latitude: 37.88969,
    longitude: -122.29581,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94706',
  },
  {
    city: 'Berkeley',
    county_fips: 6001,
    county_fips_all: '06001|06013',
    county: 'Alameda',
    county_names_all: 'Alameda|Contra Costa',
    county_weights: '{"06001": 64.47, "06013": 35.53}',
    density: 2807.1,
    imprecise: false,
    latitude: 37.89843,
    longitude: -122.27917,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94707',
  },
  {
    city: 'Berkeley',
    county_fips: 6013,
    county_fips_all: '06013|06001',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa|Alameda',
    county_weights: '{"06013": 58.54, "06001": 41.46}',
    density: 1385.2,
    imprecise: false,
    latitude: 37.90276,
    longitude: -122.26202,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94708',
  },
  {
    city: 'Berkeley',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 6941.4,
    imprecise: false,
    latitude: 37.87835,
    longitude: -122.26613,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12146,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94709',
  },
  {
    city: 'Berkeley',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 1498,
    imprecise: false,
    latitude: 37.86705,
    longitude: -122.303,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94710',
  },
  {
    city: 'Richmond',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 1125,
    imprecise: false,
    latitude: 37.95217,
    longitude: -122.38025,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94801',
  },
  {
    city: 'El Sobrante',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 833.1,
    imprecise: false,
    latitude: 37.95683,
    longitude: -122.28235,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94803',
  },
  {
    city: 'Richmond',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 2674.6,
    imprecise: false,
    latitude: 37.92074,
    longitude: -122.34204,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94804',
  },
  {
    city: 'Richmond',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 3036.6,
    imprecise: false,
    latitude: 37.94215,
    longitude: -122.32364,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94805',
  },
  {
    city: 'San Pablo',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 3075.6,
    imprecise: false,
    latitude: 37.97811,
    longitude: -122.33618,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 62546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94806',
  },
  {
    city: 'San Rafael',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 1217.3,
    imprecise: false,
    latitude: 37.98053,
    longitude: -122.50249,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94901',
  },
  {
    city: 'San Rafael',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 594.5,
    imprecise: false,
    latitude: 38.02485,
    longitude: -122.5522,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94903',
  },
  {
    city: 'Greenbrae',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 1000.2,
    imprecise: false,
    latitude: 37.94841,
    longitude: -122.55288,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94904',
  },
  {
    city: 'Belvedere Tiburon',
    county_fips: 6041,
    county_fips_all: '06041|06075',
    county: 'Marin',
    county_names_all: 'Marin|San Francisco',
    county_weights: '{"06041": 99.88, "06075": 0.12}',
    density: 747.8,
    imprecise: false,
    latitude: 37.88732,
    longitude: -122.46549,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94920',
  },
  {
    city: 'Bodega',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 38.35683,
    longitude: -122.95098,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94922',
  },
  {
    city: 'Bodega Bay',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 29.7,
    imprecise: false,
    latitude: 38.33588,
    longitude: -123.02647,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94923',
  },
  {
    city: 'Bolinas',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 37.95411,
    longitude: -122.73171,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1372,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94924',
  },
  {
    city: 'Corte Madera',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 1211.6,
    imprecise: false,
    latitude: 37.92386,
    longitude: -122.5132,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94925',
  },
  {
    city: 'Rohnert Park',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 2334.2,
    imprecise: false,
    latitude: 38.3459,
    longitude: -122.6935,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94928',
  },
  {
    city: 'Dillon Beach',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 119.7,
    imprecise: false,
    latitude: 38.25444,
    longitude: -122.96243,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94929',
  },
  {
    city: 'Fairfax',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 227.9,
    imprecise: false,
    latitude: 37.97048,
    longitude: -122.61108,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94930',
  },
  {
    city: 'Cotati',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 473.5,
    imprecise: false,
    latitude: 38.32229,
    longitude: -122.71497,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9487,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94931',
  },
  {
    city: 'Forest Knolls',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 124.2,
    imprecise: false,
    latitude: 38.01753,
    longitude: -122.68814,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94933',
  },
  {
    city: 'Inverness',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 38.09466,
    longitude: -122.92719,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94937',
  },
  {
    city: 'Lagunitas',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 17.8,
    imprecise: false,
    latitude: 38.03024,
    longitude: -122.72953,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94938',
  },
  {
    city: 'Larkspur',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 1196.8,
    imprecise: false,
    latitude: 37.93725,
    longitude: -122.53518,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94939',
  },
  {
    city: 'Marshall',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 38.15754,
    longitude: -122.86376,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94940',
  },
  {
    city: 'Mill Valley',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 334.9,
    imprecise: false,
    latitude: 37.92562,
    longitude: -122.60083,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94941',
  },
  {
    city: 'Novato',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 292.2,
    imprecise: false,
    latitude: 38.1258,
    longitude: -122.55443,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94945',
  },
  {
    city: 'Nicasio',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 7.4,
    imprecise: false,
    latitude: 38.07176,
    longitude: -122.68785,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94946',
  },
  {
    city: 'Novato',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 424.2,
    imprecise: false,
    latitude: 38.10705,
    longitude: -122.62813,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94947',
  },
  {
    city: 'Novato',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 511.6,
    imprecise: false,
    latitude: 38.06576,
    longitude: -122.53172,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94949',
  },
  {
    city: 'Olema',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 38.02122,
    longitude: -122.76187,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94950',
  },
  {
    city: 'Penngrove',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 98.9,
    imprecise: false,
    latitude: 38.32252,
    longitude: -122.64492,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94951',
  },
  {
    city: 'Petaluma',
    county_fips: 6041,
    county_fips_all: '06041|06097',
    county: 'Marin',
    county_names_all: 'Marin|Sonoma',
    county_weights: '{"06041": 51.34, "06097": 48.66}',
    density: 65.7,
    imprecise: false,
    latitude: 38.23007,
    longitude: -122.76338,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94952',
  },
  {
    city: 'Petaluma',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 233.3,
    imprecise: false,
    latitude: 38.24624,
    longitude: -122.56627,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94954',
  },
  {
    city: 'Point Reyes Station',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 12,
    imprecise: false,
    latitude: 38.0476,
    longitude: -122.81046,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94956',
  },
  {
    city: 'Ross',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 630.9,
    imprecise: false,
    latitude: 37.96343,
    longitude: -122.56174,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94957',
  },
  {
    city: 'San Anselmo',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 1066,
    imprecise: false,
    latitude: 37.99707,
    longitude: -122.57838,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94960',
  },
  {
    city: 'San Geronimo',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 178.7,
    imprecise: false,
    latitude: 38.00765,
    longitude: -122.66484,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94963',
  },
  {
    city: 'San Quentin',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 1982.7,
    imprecise: false,
    latitude: 37.94235,
    longitude: -122.49244,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94964',
  },
  {
    city: 'Sausalito',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 310.5,
    imprecise: false,
    latitude: 37.85263,
    longitude: -122.52699,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11724,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94965',
  },
  {
    city: 'Stinson Beach',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 13.6,
    imprecise: false,
    latitude: 37.91694,
    longitude: -122.65553,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94970',
  },
  {
    city: 'Tomales',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 38.23724,
    longitude: -122.89006,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 276,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94971',
  },
  {
    city: 'Valley Ford',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.33665,
    longitude: -122.93934,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94972',
  },
  {
    city: 'Woodacre',
    county_fips: 6041,
    county_fips_all: '06041',
    county: 'Marin',
    county_names_all: 'Marin',
    county_weights: '{"06041": 100}',
    density: 165.1,
    imprecise: false,
    latitude: 38.01259,
    longitude: -122.63947,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94973',
  },
  {
    city: 'Alviso',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 62.2,
    imprecise: false,
    latitude: 37.44075,
    longitude: -122.00047,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95002',
  },
  {
    city: 'Aptos',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 297.1,
    imprecise: false,
    latitude: 37.0089,
    longitude: -121.87775,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95003',
  },
  {
    city: 'Aromas',
    county_fips: 6053,
    county_fips_all: '06053|06069',
    county: 'Monterey',
    county_names_all: 'Monterey|San Benito',
    county_weights: '{"06053": 56.39, "06069": 43.61}',
    density: 76.7,
    imprecise: false,
    latitude: 36.86818,
    longitude: -121.63237,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95004',
  },
  {
    city: 'Ben Lomond',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 237.9,
    imprecise: false,
    latitude: 37.09835,
    longitude: -122.08931,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95005',
  },
  {
    city: 'Boulder Creek',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 52.9,
    imprecise: false,
    latitude: 37.17129,
    longitude: -122.151,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95006',
  },
  {
    city: 'Brookdale',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 96.4,
    imprecise: false,
    latitude: 37.11019,
    longitude: -122.11434,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95007',
  },
  {
    city: 'Campbell',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 2887.3,
    imprecise: false,
    latitude: 37.27977,
    longitude: -121.95481,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95008',
  },
  {
    city: 'Capitola',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 2431.2,
    imprecise: false,
    latitude: 36.97721,
    longitude: -121.95466,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95010',
  },
  {
    city: 'Castroville',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 323.3,
    imprecise: false,
    latitude: 36.78373,
    longitude: -121.74164,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95012',
  },
  {
    city: 'Coyote',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 37.21531,
    longitude: -121.73962,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95013',
  },
  {
    city: 'Cupertino',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 946.3,
    imprecise: false,
    latitude: 37.30827,
    longitude: -122.07981,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 60932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95014',
  },
  {
    city: 'Davenport',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 37.10529,
    longitude: -122.22913,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95017',
  },
  {
    city: 'Felton',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 145.9,
    imprecise: false,
    latitude: 37.08027,
    longitude: -122.05824,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95018',
  },
  {
    city: 'Freedom',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 2093.7,
    imprecise: false,
    latitude: 36.93575,
    longitude: -121.78458,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95019',
  },
  {
    city: 'Gilroy',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 170.9,
    imprecise: false,
    latitude: 37.01461,
    longitude: -121.55718,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 67181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95020',
  },
  {
    city: 'Hollister',
    county_fips: 6069,
    county_fips_all: '06069|06085',
    county: 'San Benito',
    county_names_all: 'San Benito|Santa Clara',
    county_weights: '{"06069": 63.42, "06085": 36.58}',
    density: 58.6,
    imprecise: false,
    latitude: 36.92113,
    longitude: -121.36117,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 59889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95023',
  },
  {
    city: 'Los Gatos',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 481.6,
    imprecise: false,
    latitude: 37.22168,
    longitude: -121.98326,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95030',
  },
  {
    city: 'Los Gatos',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 564.9,
    imprecise: false,
    latitude: 37.20859,
    longitude: -121.92359,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95032',
  },
  {
    city: 'Los Gatos',
    county_fips: 6087,
    county_fips_all: '06087|06085',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz|Santa Clara',
    county_weights: '{"06087": 52.16, "06085": 47.84}',
    density: 41.4,
    imprecise: false,
    latitude: 37.15701,
    longitude: -121.97771,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95033',
  },
  {
    city: 'Milpitas',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 1356.5,
    imprecise: false,
    latitude: 37.44319,
    longitude: -121.87632,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 78810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95035',
  },
  {
    city: 'Morgan Hill',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 167,
    imprecise: false,
    latitude: 37.13213,
    longitude: -121.67886,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 51943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95037',
  },
  {
    city: 'Moss Landing',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 36.81515,
    longitude: -121.7779,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 948,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95039',
  },
  {
    city: 'Mount Hermon',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 1243,
    imprecise: false,
    latitude: 37.05052,
    longitude: -122.05828,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95041',
  },
  {
    city: 'Paicines',
    county_fips: 6069,
    county_fips_all: '06069',
    county: 'San Benito',
    county_names_all: 'San Benito',
    county_weights: '{"06069": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 36.51652,
    longitude: -120.97677,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95043',
  },
  {
    city: 'San Juan Bautista',
    county_fips: 6069,
    county_fips_all: '06069',
    county: 'San Benito',
    county_names_all: 'San Benito',
    county_weights: '{"06069": 100}',
    density: 29.9,
    imprecise: false,
    latitude: 36.83281,
    longitude: -121.52576,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95045',
  },
  {
    city: 'San Martin',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 129.8,
    imprecise: false,
    latitude: 37.09576,
    longitude: -121.59649,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95046',
  },
  {
    city: 'Santa Clara',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 2819.3,
    imprecise: false,
    latitude: 37.3504,
    longitude: -121.95238,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95050',
  },
  {
    city: 'Santa Clara',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3635.1,
    imprecise: false,
    latitude: 37.3483,
    longitude: -121.98444,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 62054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95051',
  },
  {
    city: 'Santa Clara',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 1545.1,
    imprecise: false,
    latitude: 37.39308,
    longitude: -121.96483,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95054',
  },
  {
    city: 'Santa Cruz',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 327.5,
    imprecise: false,
    latitude: 37.01352,
    longitude: -122.10176,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95060',
  },
  {
    city: 'Santa Cruz',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 2720.9,
    imprecise: false,
    latitude: 36.97279,
    longitude: -121.99008,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95062',
  },
  {
    city: 'Santa Cruz',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 2306.8,
    imprecise: false,
    latitude: 36.99158,
    longitude: -122.05886,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95064',
  },
  {
    city: 'Santa Cruz',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 282.2,
    imprecise: false,
    latitude: 37.03229,
    longitude: -121.98444,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7997,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95065',
  },
  {
    city: 'Scotts Valley',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 312.1,
    imprecise: false,
    latitude: 37.0672,
    longitude: -122.01453,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95066',
  },
  {
    city: 'Saratoga',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 428.3,
    imprecise: false,
    latitude: 37.25624,
    longitude: -122.05151,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95070',
  },
  {
    city: 'Soquel',
    county_fips: 6087,
    county_fips_all: '06087',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz',
    county_weights: '{"06087": 100}',
    density: 196.2,
    imprecise: false,
    latitude: 37.04068,
    longitude: -121.93174,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95073',
  },
  {
    city: 'Tres Pinos',
    county_fips: 6069,
    county_fips_all: '06069',
    county: 'San Benito',
    county_names_all: 'San Benito',
    county_weights: '{"06069": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 36.80112,
    longitude: -121.19258,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95075',
  },
  {
    city: 'Watsonville',
    county_fips: 6087,
    county_fips_all: '06087|06053|06085',
    county: 'Santa Cruz',
    county_names_all: 'Santa Cruz|Monterey|Santa Clara',
    county_weights: '{"06087": 74.52, "06053": 22.64, "06085": 2.84}',
    density: 236.7,
    imprecise: false,
    latitude: 36.94029,
    longitude: -121.75089,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 82806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95076',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 1692.4,
    imprecise: false,
    latitude: 37.34656,
    longitude: -121.9097,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95110',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3804.4,
    imprecise: false,
    latitude: 37.28401,
    longitude: -121.82731,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95111',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3047.1,
    imprecise: false,
    latitude: 37.34461,
    longitude: -121.88346,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95112',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 2926.7,
    imprecise: false,
    latitude: 37.3339,
    longitude: -121.8905,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95113',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 5205.1,
    imprecise: false,
    latitude: 37.35043,
    longitude: -121.85255,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95116',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 4485.1,
    imprecise: false,
    latitude: 37.31008,
    longitude: -121.96225,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95117',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3040.2,
    imprecise: false,
    latitude: 37.25589,
    longitude: -121.88991,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95118',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 984.4,
    imprecise: false,
    latitude: 37.22756,
    longitude: -121.79077,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95119',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 363.2,
    imprecise: false,
    latitude: 37.18428,
    longitude: -121.83658,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36967,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95120',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3167.1,
    imprecise: false,
    latitude: 37.30463,
    longitude: -121.80981,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95121',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 4099.6,
    imprecise: false,
    latitude: 37.32925,
    longitude: -121.83481,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95122',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3439.3,
    imprecise: false,
    latitude: 37.24479,
    longitude: -121.83306,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 69677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95123',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3053,
    imprecise: false,
    latitude: 37.25684,
    longitude: -121.92286,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95124',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 2884.3,
    imprecise: false,
    latitude: 37.29554,
    longitude: -121.89408,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95125',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 4460.6,
    imprecise: false,
    latitude: 37.32687,
    longitude: -121.91677,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95126',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 1193.4,
    imprecise: false,
    latitude: 37.37453,
    longitude: -121.78733,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 58825,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95127',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3257.7,
    imprecise: false,
    latitude: 37.31579,
    longitude: -121.93647,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95128',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3496.3,
    imprecise: false,
    latitude: 37.30597,
    longitude: -122.00072,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41321,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95129',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3625.2,
    imprecise: false,
    latitude: 37.28803,
    longitude: -121.98146,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95130',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 2084.4,
    imprecise: false,
    latitude: 37.38729,
    longitude: -121.89793,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95131',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 569.3,
    imprecise: false,
    latitude: 37.41994,
    longitude: -121.79059,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95132',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3517.3,
    imprecise: false,
    latitude: 37.37171,
    longitude: -121.86057,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95133',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 1088.5,
    imprecise: false,
    latitude: 37.43003,
    longitude: -121.94528,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95134',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 60,
    imprecise: false,
    latitude: 37.22285,
    longitude: -121.55913,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95135',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 3565.9,
    imprecise: false,
    latitude: 37.27192,
    longitude: -121.85237,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95136',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 281.2,
    imprecise: false,
    latitude: 37.2462,
    longitude: -121.73287,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95138',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 2253.8,
    imprecise: false,
    latitude: 37.22489,
    longitude: -121.76393,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95139',
  },
  {
    city: 'Mount Hamilton',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 37.3483,
    longitude: -121.64085,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95140',
  },
  {
    city: 'San Jose',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 2203.9,
    imprecise: false,
    latitude: 37.33252,
    longitude: -121.78142,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95148',
  },
  {
    city: 'Stockton',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 2573.3,
    imprecise: false,
    latitude: 37.95968,
    longitude: -121.28772,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95202',
  },
  {
    city: 'Stockton',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 997.7,
    imprecise: false,
    latitude: 37.95237,
    longitude: -121.33098,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95203',
  },
  {
    city: 'Stockton',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 2260.1,
    imprecise: false,
    latitude: 37.97403,
    longitude: -121.31906,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95204',
  },
  {
    city: 'Stockton',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 1700.8,
    imprecise: false,
    latitude: 37.96425,
    longitude: -121.25955,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95205',
  },
  {
    city: 'Stockton',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 198.7,
    imprecise: false,
    latitude: 37.8961,
    longitude: -121.41051,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 68558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95206',
  },
  {
    city: 'Stockton',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 2792.9,
    imprecise: false,
    latitude: 38.00242,
    longitude: -121.325,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95207',
  },
  {
    city: 'Stockton',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 2222,
    imprecise: false,
    latitude: 38.04717,
    longitude: -121.35121,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95209',
  },
  {
    city: 'Stockton',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 2109.7,
    imprecise: false,
    latitude: 38.03215,
    longitude: -121.29782,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95210',
  },
  {
    city: 'Stockton',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 518.3,
    imprecise: false,
    latitude: 38.04897,
    longitude: -121.22684,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95212',
  },
  {
    city: 'Stockton',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 103.4,
    imprecise: false,
    latitude: 37.9444,
    longitude: -121.15276,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24847,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95215',
  },
  {
    city: 'Stockton',
    county_fips: 6077,
    county_fips_all: '06077|06013',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin|Contra Costa',
    county_weights: '{"06077": 80.4, "06013": 19.6}',
    density: 104.8,
    imprecise: false,
    latitude: 38.0207,
    longitude: -121.51584,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95219',
  },
  {
    city: 'Acampo',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 52.7,
    imprecise: false,
    latitude: 38.19779,
    longitude: -121.23603,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95220',
  },
  {
    city: 'Altaville',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 431.9,
    imprecise: false,
    latitude: 38.0724,
    longitude: -120.54852,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95221',
  },
  {
    city: 'Angels Camp',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 38.06127,
    longitude: -120.61791,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95222',
  },
  {
    city: 'Arnold',
    county_fips: 6003,
    county_fips_all: '06003|06009|06109',
    county: 'Alpine',
    county_names_all: 'Alpine|Calaveras|Tuolumne',
    county_weights: '{"06003": 80.95, "06009": 17.26, "06109": 1.79}',
    density: 2.8,
    imprecise: false,
    latitude: 38.4644,
    longitude: -119.85939,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95223',
  },
  {
    city: 'Avery',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 38.22706,
    longitude: -120.32562,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95224',
  },
  {
    city: 'Burson',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 64.1,
    imprecise: false,
    latitude: 38.20399,
    longitude: -120.86488,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95225',
  },
  {
    city: 'Campo Seco',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.23377,
    longitude: -120.86232,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95226',
  },
  {
    city: 'Clements',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 38.20678,
    longitude: -121.04615,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95227',
  },
  {
    city: 'Copperopolis',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 37.94669,
    longitude: -120.68067,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95228',
  },
  {
    city: 'Farmington',
    county_fips: 6099,
    county_fips_all: '06099|06009|06077',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus|Calaveras|San Joaquin',
    county_weights: '{"06099": 48.49, "06009": 30.08, "06077": 21.42}',
    density: 1.1,
    imprecise: false,
    latitude: 37.97361,
    longitude: -120.86492,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 403,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95230',
  },
  {
    city: 'French Camp',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 139.7,
    imprecise: false,
    latitude: 37.87331,
    longitude: -121.29272,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95231',
  },
  {
    city: 'Glencoe',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 38.36051,
    longitude: -120.57722,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95232',
  },
  {
    city: 'Hathaway Pines',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 32.1,
    imprecise: false,
    latitude: 38.18622,
    longitude: -120.36859,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95233',
  },
  {
    city: 'Linden',
    county_fips: 6077,
    county_fips_all: '06077|06009',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin|Calaveras',
    county_weights: '{"06077": 98.09, "06009": 1.91}',
    density: 13.6,
    imprecise: false,
    latitude: 38.04218,
    longitude: -121.03176,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4490,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95236',
  },
  {
    city: 'Lockeford',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 189.5,
    imprecise: false,
    latitude: 38.15953,
    longitude: -121.14845,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95237',
  },
  {
    city: 'Lodi',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 286,
    imprecise: false,
    latitude: 38.1177,
    longitude: -121.1627,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95240',
  },
  {
    city: 'Lodi',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 120.8,
    imprecise: false,
    latitude: 38.13204,
    longitude: -121.38875,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95242',
  },
  {
    city: 'Mokelumne Hill',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 38.30189,
    longitude: -120.61975,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2727,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95245',
  },
  {
    city: 'Mountain Ranch',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 38.23662,
    longitude: -120.49589,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95246',
  },
  {
    city: 'Murphys',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 31.7,
    imprecise: false,
    latitude: 38.14264,
    longitude: -120.44359,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95247',
  },
  {
    city: 'Rail Road Flat',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 38.32433,
    longitude: -120.46051,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95248',
  },
  {
    city: 'San Andreas',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 38.18986,
    longitude: -120.61784,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95249',
  },
  {
    city: 'Vallecito',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 22.2,
    imprecise: false,
    latitude: 38.08024,
    longitude: -120.45769,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95251',
  },
  {
    city: 'Valley Springs',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 48.3,
    imprecise: false,
    latitude: 38.15871,
    longitude: -120.84214,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95252',
  },
  {
    city: 'Victor',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 139.7,
    imprecise: false,
    latitude: 38.14725,
    longitude: -121.19525,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95253',
  },
  {
    city: 'Wallace',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 24.8,
    imprecise: false,
    latitude: 38.20323,
    longitude: -120.95857,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95254',
  },
  {
    city: 'West Point',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 38.42055,
    longitude: -120.47506,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95255',
  },
  {
    city: 'Wilseyville',
    county_fips: 6009,
    county_fips_all: '06009',
    county: 'Calaveras',
    county_names_all: 'Calaveras',
    county_weights: '{"06009": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 38.38068,
    longitude: -120.45255,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95257',
  },
  {
    city: 'Woodbridge',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 497.1,
    imprecise: false,
    latitude: 38.16811,
    longitude: -121.31011,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95258',
  },
  {
    city: 'Atwater',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 218.3,
    imprecise: false,
    latitude: 37.30634,
    longitude: -120.65119,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95301',
  },
  {
    city: 'Ballico',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 37.4714,
    longitude: -120.67744,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 784,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95303',
  },
  {
    city: 'Tracy',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 39.9,
    imprecise: false,
    latitude: 37.6773,
    longitude: -121.3948,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95304',
  },
  {
    city: 'Big Oak Flat',
    county_fips: 6109,
    county_fips_all: '06109',
    county: 'Tuolumne',
    county_names_all: 'Tuolumne',
    county_weights: '{"06109": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 37.8306,
    longitude: -120.34821,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95305',
  },
  {
    city: 'Catheys Valley',
    county_fips: 6043,
    county_fips_all: '06043',
    county: 'Mariposa',
    county_names_all: 'Mariposa',
    county_weights: '{"06043": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 37.36015,
    longitude: -120.11581,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95306',
  },
  {
    city: 'Ceres',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 544.6,
    imprecise: false,
    latitude: 37.55582,
    longitude: -120.95385,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95307',
  },
  {
    city: 'Chinese Camp',
    county_fips: 6109,
    county_fips_all: '06109',
    county: 'Tuolumne',
    county_names_all: 'Tuolumne',
    county_weights: '{"06109": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.87154,
    longitude: -120.43299,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95309',
  },
  {
    city: 'Columbia',
    county_fips: 6109,
    county_fips_all: '06109',
    county: 'Tuolumne',
    county_names_all: 'Tuolumne',
    county_weights: '{"06109": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 38.09944,
    longitude: -120.36171,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95310',
  },
  {
    city: 'Coulterville',
    county_fips: 6043,
    county_fips_all: '06043|06109',
    county: 'Mariposa',
    county_names_all: 'Mariposa|Tuolumne',
    county_weights: '{"06043": 97.87, "06109": 2.13}',
    density: 3.6,
    imprecise: false,
    latitude: 37.70443,
    longitude: -120.08344,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95311',
  },
  {
    city: 'Cressey',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 91.4,
    imprecise: false,
    latitude: 37.42107,
    longitude: -120.65295,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95312',
  },
  {
    city: 'Crows Landing',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 37.43511,
    longitude: -121.03769,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1119,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95313',
  },
  {
    city: 'Delhi',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 277.2,
    imprecise: false,
    latitude: 37.42243,
    longitude: -120.7733,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95315',
  },
  {
    city: 'Denair',
    county_fips: 6099,
    county_fips_all: '06099|06047',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus|Merced',
    county_weights: '{"06099": 76.77, "06047": 23.23}',
    density: 37.9,
    imprecise: false,
    latitude: 37.54613,
    longitude: -120.69212,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95316',
  },
  {
    city: 'El Nido',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 37.12947,
    longitude: -120.5074,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 827,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95317',
  },
  {
    city: 'El Portal',
    county_fips: 6043,
    county_fips_all: '06043',
    county: 'Mariposa',
    county_names_all: 'Mariposa',
    county_weights: '{"06043": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 37.66618,
    longitude: -119.8064,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95318',
  },
  {
    city: 'Empire',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 202.9,
    imprecise: false,
    latitude: 37.6309,
    longitude: -120.87728,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95319',
  },
  {
    city: 'Escalon',
    county_fips: 6077,
    county_fips_all: '06077|06099',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin|Stanislaus',
    county_weights: '{"06077": 99.84, "06099": 0.16}',
    density: 58.7,
    imprecise: false,
    latitude: 37.82453,
    longitude: -121.01545,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95320',
  },
  {
    city: 'Groveland',
    county_fips: 6109,
    county_fips_all: '06109|06043',
    county: 'Tuolumne',
    county_names_all: 'Tuolumne|Mariposa',
    county_weights: '{"06109": 98.06, "06043": 1.94}',
    density: 3,
    imprecise: false,
    latitude: 37.97719,
    longitude: -119.75012,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95321',
  },
  {
    city: 'Gustine',
    county_fips: 6047,
    county_fips_all: '06047|06099',
    county: 'Merced',
    county_names_all: 'Merced|Stanislaus',
    county_weights: '{"06047": 97.68, "06099": 2.32}',
    density: 21.7,
    imprecise: false,
    latitude: 37.17622,
    longitude: -121.01861,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95322',
  },
  {
    city: 'Hickman',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 20.3,
    imprecise: false,
    latitude: 37.60881,
    longitude: -120.68464,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95323',
  },
  {
    city: 'Hilmar',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 73.4,
    imprecise: false,
    latitude: 37.39452,
    longitude: -120.89605,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7636,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95324',
  },
  {
    city: 'Hornitos',
    county_fips: 6043,
    county_fips_all: '06043',
    county: 'Mariposa',
    county_names_all: 'Mariposa',
    county_weights: '{"06043": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.48058,
    longitude: -120.24208,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95325',
  },
  {
    city: 'Hughson',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 154.3,
    imprecise: false,
    latitude: 37.58998,
    longitude: -120.8531,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95326',
  },
  {
    city: 'Jamestown',
    county_fips: 6109,
    county_fips_all: '06109',
    county: 'Tuolumne',
    county_names_all: 'Tuolumne',
    county_weights: '{"06109": 100}',
    density: 21.3,
    imprecise: false,
    latitude: 37.84912,
    longitude: -120.4858,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95327',
  },
  {
    city: 'Keyes',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 1769.1,
    imprecise: false,
    latitude: 37.55797,
    longitude: -120.90932,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95328',
  },
  {
    city: 'La Grange',
    county_fips: 6109,
    county_fips_all: '06109|06099|06043',
    county: 'Tuolumne',
    county_names_all: 'Tuolumne|Stanislaus|Mariposa',
    county_weights: '{"06109": 48.33, "06099": 36.0, "06043": 15.66}',
    density: 9.8,
    imprecise: false,
    latitude: 37.67726,
    longitude: -120.41363,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95329',
  },
  {
    city: 'Lathrop',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 634.9,
    imprecise: false,
    latitude: 37.8117,
    longitude: -121.31331,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95330',
  },
  {
    city: 'Le Grand',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 37.2447,
    longitude: -120.24277,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95333',
  },
  {
    city: 'Livingston',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 118.7,
    imprecise: false,
    latitude: 37.34756,
    longitude: -120.74624,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95334',
  },
  {
    city: 'Long Barn',
    county_fips: 6109,
    county_fips_all: '06109',
    county: 'Tuolumne',
    county_names_all: 'Tuolumne',
    county_weights: '{"06109": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 38.11894,
    longitude: -120.09239,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95335',
  },
  {
    city: 'Manteca',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 505.4,
    imprecise: false,
    latitude: 37.83351,
    longitude: -121.1988,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95336',
  },
  {
    city: 'Manteca',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 414.2,
    imprecise: false,
    latitude: 37.74171,
    longitude: -121.23834,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48731,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95337',
  },
  {
    city: 'Mariposa',
    county_fips: 6043,
    county_fips_all: '06043',
    county: 'Mariposa',
    county_names_all: 'Mariposa',
    county_weights: '{"06043": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 37.50911,
    longitude: -119.98659,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95338',
  },
  {
    city: 'Merced',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 284.6,
    imprecise: false,
    latitude: 37.34128,
    longitude: -120.40658,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95340',
  },
  {
    city: 'Merced',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 95.7,
    imprecise: false,
    latitude: 37.23037,
    longitude: -120.50715,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95341',
  },
  {
    city: 'Midpines',
    county_fips: 6043,
    county_fips_all: '06043',
    county: 'Mariposa',
    county_names_all: 'Mariposa',
    county_weights: '{"06043": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 37.58784,
    longitude: -119.96408,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95345',
  },
  {
    city: 'Mi Wuk Village',
    county_fips: 6109,
    county_fips_all: '06109',
    county: 'Tuolumne',
    county_names_all: 'Tuolumne',
    county_weights: '{"06109": 100}',
    density: 69.8,
    imprecise: false,
    latitude: 38.07045,
    longitude: -120.17291,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95346',
  },
  {
    city: 'Merced',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 245.7,
    imprecise: false,
    latitude: 37.41525,
    longitude: -120.4979,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95348',
  },
  {
    city: 'Modesto',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 2496.7,
    imprecise: false,
    latitude: 37.67175,
    longitude: -121.00732,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95350',
  },
  {
    city: 'Modesto',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 2105.7,
    imprecise: false,
    latitude: 37.6236,
    longitude: -120.99828,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95351',
  },
  {
    city: 'Modesto',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 1295.6,
    imprecise: false,
    latitude: 37.63849,
    longitude: -120.96428,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95354',
  },
  {
    city: 'Modesto',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 2508,
    imprecise: false,
    latitude: 37.6727,
    longitude: -120.94717,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 60710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95355',
  },
  {
    city: 'Modesto',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 577.7,
    imprecise: false,
    latitude: 37.71945,
    longitude: -121.02786,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95356',
  },
  {
    city: 'Modesto',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 133.4,
    imprecise: false,
    latitude: 37.66985,
    longitude: -120.87924,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13599,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95357',
  },
  {
    city: 'Modesto',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 101.2,
    imprecise: false,
    latitude: 37.61578,
    longitude: -121.10059,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95358',
  },
  {
    city: 'Newman',
    county_fips: 6099,
    county_fips_all: '06099|06047',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus|Merced',
    county_weights: '{"06099": 74.95, "06047": 25.05}',
    density: 86.1,
    imprecise: false,
    latitude: 37.32918,
    longitude: -121.03827,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95360',
  },
  {
    city: 'Oakdale',
    county_fips: 6099,
    county_fips_all: '06099|06077',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus|San Joaquin',
    county_weights: '{"06099": 97.73, "06077": 2.27}',
    density: 61.8,
    imprecise: false,
    latitude: 37.79342,
    longitude: -120.77654,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95361',
  },
  {
    city: 'Patterson',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 24.8,
    imprecise: false,
    latitude: 37.37251,
    longitude: -121.27192,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95363',
  },
  {
    city: 'Pinecrest',
    county_fips: 6109,
    county_fips_all: '06109',
    county: 'Tuolumne',
    county_names_all: 'Tuolumne',
    county_weights: '{"06109": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.22908,
    longitude: -119.79174,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95364',
  },
  {
    city: 'Planada',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 417.4,
    imprecise: false,
    latitude: 37.3012,
    longitude: -120.33152,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95365',
  },
  {
    city: 'Ripon',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 213.2,
    imprecise: false,
    latitude: 37.76223,
    longitude: -121.12574,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95366',
  },
  {
    city: 'Riverbank',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 1881.4,
    imprecise: false,
    latitude: 37.73089,
    longitude: -120.94669,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95367',
  },
  {
    city: 'Salida',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 1753.5,
    imprecise: false,
    latitude: 37.71544,
    longitude: -121.09047,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13900,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95368',
  },
  {
    city: 'Snelling',
    county_fips: 6047,
    county_fips_all: '06047|06043',
    county: 'Merced',
    county_names_all: 'Merced|Mariposa',
    county_weights: '{"06047": 85.76, "06043": 14.24}',
    density: 1.8,
    imprecise: false,
    latitude: 37.52435,
    longitude: -120.41301,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 740,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95369',
  },
  {
    city: 'Sonora',
    county_fips: 6109,
    county_fips_all: '06109',
    county: 'Tuolumne',
    county_names_all: 'Tuolumne',
    county_weights: '{"06109": 100}',
    density: 106.2,
    imprecise: false,
    latitude: 37.98484,
    longitude: -120.34515,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95370',
  },
  {
    city: 'Soulsbyville',
    county_fips: 6109,
    county_fips_all: '06109',
    county: 'Tuolumne',
    county_names_all: 'Tuolumne',
    county_weights: '{"06109": 100}',
    density: 288.9,
    imprecise: false,
    latitude: 37.98927,
    longitude: -120.26272,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95372',
  },
  {
    city: 'Stevinson',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 37.31636,
    longitude: -120.85683,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95374',
  },
  {
    city: 'Tracy',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 2762.1,
    imprecise: false,
    latitude: 37.73678,
    longitude: -121.43404,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95376',
  },
  {
    city: 'Tracy',
    county_fips: 6077,
    county_fips_all: '06077|06001',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin|Alameda',
    county_weights: '{"06077": 89.32, "06001": 10.68}',
    density: 132.5,
    imprecise: false,
    latitude: 37.65293,
    longitude: -121.49598,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95377',
  },
  {
    city: 'Tuolumne',
    county_fips: 6109,
    county_fips_all: '06109',
    county: 'Tuolumne',
    county_names_all: 'Tuolumne',
    county_weights: '{"06109": 100}',
    density: 53.7,
    imprecise: false,
    latitude: 37.96174,
    longitude: -120.21635,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95379',
  },
  {
    city: 'Turlock',
    county_fips: 6099,
    county_fips_all: '06099|06047',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus|Merced',
    county_weights: '{"06099": 75.35, "06047": 24.65}',
    density: 220,
    imprecise: false,
    latitude: 37.47226,
    longitude: -120.86978,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95380',
  },
  {
    city: 'Turlock',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 1378.7,
    imprecise: false,
    latitude: 37.52831,
    longitude: -120.85214,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95382',
  },
  {
    city: 'Twain Harte',
    county_fips: 6109,
    county_fips_all: '06109',
    county: 'Tuolumne',
    county_names_all: 'Tuolumne',
    county_weights: '{"06109": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 38.09534,
    longitude: -120.22602,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95383',
  },
  {
    city: 'Vernalis',
    county_fips: 6099,
    county_fips_all: '06099|06077',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus|San Joaquin',
    county_weights: '{"06099": 97.99, "06077": 2.01}',
    density: 8.7,
    imprecise: false,
    latitude: 37.612,
    longitude: -121.24773,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 602,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95385',
  },
  {
    city: 'Waterford',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 43.5,
    imprecise: false,
    latitude: 37.67391,
    longitude: -120.63045,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95386',
  },
  {
    city: 'Westley',
    county_fips: 6099,
    county_fips_all: '06099',
    county: 'Stanislaus',
    county_names_all: 'Stanislaus',
    county_weights: '{"06099": 100}',
    density: 18.5,
    imprecise: false,
    latitude: 37.55429,
    longitude: -121.2451,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95387',
  },
  {
    city: 'Winton',
    county_fips: 6047,
    county_fips_all: '06047',
    county: 'Merced',
    county_names_all: 'Merced',
    county_weights: '{"06047": 100}',
    density: 136.4,
    imprecise: false,
    latitude: 37.42171,
    longitude: -120.59715,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95388',
  },
  {
    city: 'Yosemite National Park',
    county_fips: 6043,
    county_fips_all: '06043|06109',
    county: 'Mariposa',
    county_names_all: 'Mariposa|Tuolumne',
    county_weights: '{"06043": 81.66, "06109": 18.34}',
    density: 2.8,
    imprecise: false,
    latitude: 37.73784,
    longitude: -119.52556,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95389',
  },
  {
    city: 'Tracy',
    county_fips: 6001,
    county_fips_all: '06001|06077',
    county: 'Alameda',
    county_names_all: 'Alameda|San Joaquin',
    county_weights: '{"06001": 69.64, "06077": 30.36}',
    density: 367.7,
    imprecise: false,
    latitude: 37.76952,
    longitude: -121.5912,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95391',
  },
  {
    city: 'Santa Rosa',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 680.8,
    imprecise: false,
    latitude: 38.44922,
    longitude: -122.79307,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36861,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95401',
  },
  {
    city: 'Santa Rosa',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 821.1,
    imprecise: false,
    latitude: 38.50326,
    longitude: -122.75358,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45806,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95403',
  },
  {
    city: 'Santa Rosa',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 189.6,
    imprecise: false,
    latitude: 38.46488,
    longitude: -122.65709,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37011,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95404',
  },
  {
    city: 'Santa Rosa',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 1750.6,
    imprecise: false,
    latitude: 38.43926,
    longitude: -122.66908,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95405',
  },
  {
    city: 'Santa Rosa',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 751,
    imprecise: false,
    latitude: 38.39465,
    longitude: -122.74591,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95407',
  },
  {
    city: 'Santa Rosa',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 282.8,
    imprecise: false,
    latitude: 38.46116,
    longitude: -122.60425,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95409',
  },
  {
    city: 'Albion',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 39.21616,
    longitude: -123.70012,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95410',
  },
  {
    city: 'Annapolis',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 38.71168,
    longitude: -123.31967,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95412',
  },
  {
    city: 'Boonville',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 39.0205,
    longitude: -123.36751,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95415',
  },
  {
    city: 'Branscomb',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 39.68791,
    longitude: -123.65075,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 220,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95417',
  },
  {
    city: 'Camp Meeker',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 905.9,
    imprecise: false,
    latitude: 38.42336,
    longitude: -122.9582,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95419',
  },
  {
    city: 'Caspar',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 39.35638,
    longitude: -123.76832,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95420',
  },
  {
    city: 'Cazadero',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 38.58276,
    longitude: -123.18037,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95421',
  },
  {
    city: 'Clearlake',
    county_fips: 6033,
    county_fips_all: '06033',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"06033": 100}',
    density: 244.9,
    imprecise: false,
    latitude: 38.97829,
    longitude: -122.6423,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95422',
  },
  {
    city: 'Clearlake Oaks',
    county_fips: 6033,
    county_fips_all: '06033',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"06033": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 39.06749,
    longitude: -122.62753,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95423',
  },
  {
    city: 'Cloverdale',
    county_fips: 6097,
    county_fips_all: '06097|06045',
    county: 'Sonoma',
    county_names_all: 'Sonoma|Mendocino',
    county_weights: '{"06097": 68.16, "06045": 31.84}',
    density: 22.1,
    imprecise: false,
    latitude: 38.81792,
    longitude: -123.02566,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10978,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95425',
  },
  {
    city: 'Cobb',
    county_fips: 6033,
    county_fips_all: '06033',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"06033": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 38.83449,
    longitude: -122.7361,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95426',
  },
  {
    city: 'Comptche',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 39.25326,
    longitude: -123.56932,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 666,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95427',
  },
  {
    city: 'Covelo',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 39.82489,
    longitude: -123.18126,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95428',
  },
  {
    city: 'Dos Rios',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 39.73292,
    longitude: -123.34841,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95429',
  },
  {
    city: 'Duncans Mills',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.46279,
    longitude: -123.04476,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95430',
  },
  {
    city: 'Eldridge',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 137.9,
    imprecise: false,
    latitude: 38.34897,
    longitude: -122.51625,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95431',
  },
  {
    city: 'Elk',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 39.1083,
    longitude: -123.63829,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95432',
  },
  {
    city: 'Finley',
    county_fips: 6033,
    county_fips_all: '06033',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"06033": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.00315,
    longitude: -122.8748,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95435',
  },
  {
    city: 'Forestville',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 105.7,
    imprecise: false,
    latitude: 38.49108,
    longitude: -122.91425,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95436',
  },
  {
    city: 'Fort Bragg',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 32.6,
    imprecise: false,
    latitude: 39.44535,
    longitude: -123.69402,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95437',
  },
  {
    city: 'Fulton',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 70.4,
    imprecise: false,
    latitude: 38.49055,
    longitude: -122.77591,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95439',
  },
  {
    city: 'Geyserville',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 4,
    imprecise: false,
    latitude: 38.73775,
    longitude: -123.0354,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1648,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95441',
  },
  {
    city: 'Glen Ellen',
    county_fips: 6097,
    county_fips_all: '06097|06055',
    county: 'Sonoma',
    county_names_all: 'Sonoma|Napa',
    county_weights: '{"06097": 99.78, "06055": 0.22}',
    density: 53.3,
    imprecise: false,
    latitude: 38.3785,
    longitude: -122.51549,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95442',
  },
  {
    city: 'Glenhaven',
    county_fips: 6033,
    county_fips_all: '06033',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"06033": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 39.05013,
    longitude: -122.73962,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95443',
  },
  {
    city: 'Graton',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 769.7,
    imprecise: false,
    latitude: 38.43261,
    longitude: -122.86922,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95444',
  },
  {
    city: 'Gualala',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 12,
    imprecise: false,
    latitude: 38.83762,
    longitude: -123.49404,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95445',
  },
  {
    city: 'Guerneville',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 57.3,
    imprecise: false,
    latitude: 38.52525,
    longitude: -123.00423,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95446',
  },
  {
    city: 'Healdsburg',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 33.6,
    imprecise: false,
    latitude: 38.62309,
    longitude: -122.89089,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16077,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95448',
  },
  {
    city: 'Hopland',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 38.94331,
    longitude: -123.09653,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95449',
  },
  {
    city: 'Jenner',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 38.5229,
    longitude: -123.21508,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95450',
  },
  {
    city: 'Kelseyville',
    county_fips: 6033,
    county_fips_all: '06033',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"06033": 100}',
    density: 52.4,
    imprecise: false,
    latitude: 38.9388,
    longitude: -122.80484,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95451',
  },
  {
    city: 'Kenwood',
    county_fips: 6097,
    county_fips_all: '06097|06055',
    county: 'Sonoma',
    county_names_all: 'Sonoma|Napa',
    county_weights: '{"06097": 98.72, "06055": 1.28}',
    density: 41.1,
    imprecise: false,
    latitude: 38.42969,
    longitude: -122.5362,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1762,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95452',
  },
  {
    city: 'Lakeport',
    county_fips: 6033,
    county_fips_all: '06033',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"06033": 100}',
    density: 52.1,
    imprecise: false,
    latitude: 39.04346,
    longitude: -122.93918,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95453',
  },
  {
    city: 'Laytonville',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 39.78063,
    longitude: -123.51631,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95454',
  },
  {
    city: 'Little River',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 39.25851,
    longitude: -123.74585,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95456',
  },
  {
    city: 'Lower Lake',
    county_fips: 6033,
    county_fips_all: '06033|06055',
    county: 'Lake',
    county_names_all: 'Lake|Napa',
    county_weights: '{"06033": 99.88, "06055": 0.12}',
    density: 8.1,
    imprecise: false,
    latitude: 38.87967,
    longitude: -122.52753,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95457',
  },
  {
    city: 'Lucerne',
    county_fips: 6033,
    county_fips_all: '06033',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"06033": 100}',
    density: 40.3,
    imprecise: false,
    latitude: 39.11667,
    longitude: -122.78204,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95458',
  },
  {
    city: 'Manchester',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 5,
    imprecise: false,
    latitude: 38.99068,
    longitude: -123.62627,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95459',
  },
  {
    city: 'Mendocino',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 24.6,
    imprecise: false,
    latitude: 39.30386,
    longitude: -123.73737,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95460',
  },
  {
    city: 'Middletown',
    county_fips: 6033,
    county_fips_all: '06033|06055',
    county: 'Lake',
    county_names_all: 'Lake|Napa',
    county_weights: '{"06033": 98.92, "06055": 1.08}',
    density: 10.7,
    imprecise: false,
    latitude: 38.762,
    longitude: -122.59314,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95461',
  },
  {
    city: 'Monte Rio',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 113,
    imprecise: false,
    latitude: 38.47263,
    longitude: -123.02064,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95462',
  },
  {
    city: 'Navarro',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 39.18957,
    longitude: -123.58059,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95463',
  },
  {
    city: 'Nice',
    county_fips: 6033,
    county_fips_all: '06033',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"06033": 100}',
    density: 378.1,
    imprecise: false,
    latitude: 39.12736,
    longitude: -122.84733,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95464',
  },
  {
    city: 'Occidental',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 38.40556,
    longitude: -123.01963,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95465',
  },
  {
    city: 'Philo',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 39.08868,
    longitude: -123.51058,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 722,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95466',
  },
  {
    city: 'Hidden Valley Lake',
    county_fips: 6033,
    county_fips_all: '06033',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"06033": 100}',
    density: 303.3,
    imprecise: false,
    latitude: 38.80453,
    longitude: -122.54948,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5778,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95467',
  },
  {
    city: 'Point Arena',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 13,
    imprecise: false,
    latitude: 38.9094,
    longitude: -123.60372,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95468',
  },
  {
    city: 'Potter Valley',
    county_fips: 6045,
    county_fips_all: '06045|06033',
    county: 'Mendocino',
    county_names_all: 'Mendocino|Lake',
    county_weights: '{"06045": 62.1, "06033": 37.9}',
    density: 2.8,
    imprecise: false,
    latitude: 39.38853,
    longitude: -123.05972,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1315,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95469',
  },
  {
    city: 'Redwood Valley',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 34.6,
    imprecise: false,
    latitude: 39.30019,
    longitude: -123.22984,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95470',
  },
  {
    city: 'Rio Nido',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 42.9,
    imprecise: false,
    latitude: 38.53218,
    longitude: -122.97362,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95471',
  },
  {
    city: 'Sebastopol',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 158,
    imprecise: false,
    latitude: 38.39738,
    longitude: -122.86668,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95472',
  },
  {
    city: 'Sonoma',
    county_fips: 6097,
    county_fips_all: '06097|06055',
    county: 'Sonoma',
    county_names_all: 'Sonoma|Napa',
    county_weights: '{"06097": 97.3, "06055": 2.7}',
    density: 126,
    imprecise: false,
    latitude: 38.25531,
    longitude: -122.46055,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95476',
  },
  {
    city: 'Stewarts Point',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 38.68463,
    longitude: -123.36802,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95480',
  },
  {
    city: 'Ukiah',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 43.5,
    imprecise: false,
    latitude: 39.1618,
    longitude: -123.23925,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95482',
  },
  {
    city: 'Upper Lake',
    county_fips: 6033,
    county_fips_all: '06033',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"06033": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 39.20828,
    longitude: -122.9259,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95485',
  },
  {
    city: 'Villa Grande',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 338.9,
    imprecise: false,
    latitude: 38.4741,
    longitude: -123.02403,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95486',
  },
  {
    city: 'Westport',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 39.73679,
    longitude: -123.77199,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 226,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95488',
  },
  {
    city: 'Willits',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 39.4883,
    longitude: -123.34725,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95490',
  },
  {
    city: 'Windsor',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 535.2,
    imprecise: false,
    latitude: 38.53052,
    longitude: -122.81254,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95492',
  },
  {
    city: 'Witter Springs',
    county_fips: 6033,
    county_fips_all: '06033',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"06033": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 39.20241,
    longitude: -122.97948,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95493',
  },
  {
    city: 'Yorkville',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 38.89646,
    longitude: -123.34324,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95494',
  },
  {
    city: 'The Sea Ranch',
    county_fips: 6097,
    county_fips_all: '06097',
    county: 'Sonoma',
    county_names_all: 'Sonoma',
    county_weights: '{"06097": 100}',
    density: 32.3,
    imprecise: false,
    latitude: 38.71976,
    longitude: -123.45601,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1275,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95497',
  },
  {
    city: 'Eureka',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 1204.7,
    imprecise: false,
    latitude: 40.80435,
    longitude: -124.14034,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95501',
  },
  {
    city: 'Eureka',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 115.5,
    imprecise: false,
    latitude: 40.72406,
    longitude: -124.09178,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95503',
  },
  {
    city: 'Alderpoint',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 40.16975,
    longitude: -123.59539,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95511',
  },
  {
    city: 'Blocksburg',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 40.29151,
    longitude: -123.67119,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 85,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95514',
  },
  {
    city: 'Mckinleyville',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 134.5,
    imprecise: false,
    latitude: 40.95833,
    longitude: -124.04983,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18728,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95519',
  },
  {
    city: 'Arcata',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 140.6,
    imprecise: false,
    latitude: 40.84586,
    longitude: -124.04745,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95521',
  },
  {
    city: 'Bayside',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 77.6,
    imprecise: false,
    latitude: 40.82346,
    longitude: -124.05271,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95524',
  },
  {
    city: 'Blue Lake',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 6,
    imprecise: false,
    latitude: 40.94845,
    longitude: -123.82629,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95525',
  },
  {
    city: 'Bridgeville',
    county_fips: 6023,
    county_fips_all: '06023|06105',
    county: 'Humboldt',
    county_names_all: 'Humboldt|Trinity',
    county_weights: '{"06023": 86.09, "06105": 13.91}',
    density: 2.3,
    imprecise: false,
    latitude: 40.44705,
    longitude: -123.6628,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 745,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95526',
  },
  {
    city: 'Burnt Ranch',
    county_fips: 6105,
    county_fips_all: '06105',
    county: 'Trinity',
    county_names_all: 'Trinity',
    county_weights: '{"06105": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 40.93593,
    longitude: -123.41966,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 622,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95527',
  },
  {
    city: 'Carlotta',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 40.4936,
    longitude: -123.92393,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1286,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95528',
  },
  {
    city: 'Crescent City',
    county_fips: 6015,
    county_fips_all: '06015',
    county: 'Del Norte',
    county_names_all: 'Del Norte',
    county_weights: '{"06015": 100}',
    density: 45.4,
    imprecise: false,
    latitude: 41.79288,
    longitude: -124.00473,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22291,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95531',
  },
  {
    city: 'Ferndale',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 40.51069,
    longitude: -124.26547,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95536',
  },
  {
    city: 'Fields Landing',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 688.6,
    imprecise: false,
    latitude: 40.745,
    longitude: -124.21472,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 532,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95537',
  },
  {
    city: 'Fortuna',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 164,
    imprecise: false,
    latitude: 40.56671,
    longitude: -124.12651,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14469,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95540',
  },
  {
    city: 'Garberville',
    county_fips: 6023,
    county_fips_all: '06023|06045',
    county: 'Humboldt',
    county_names_all: 'Humboldt|Mendocino',
    county_weights: '{"06023": 97.21, "06045": 2.79}',
    density: 4.3,
    imprecise: false,
    latitude: 40.08074,
    longitude: -123.77369,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95542',
  },
  {
    city: 'Gasquet',
    county_fips: 6015,
    county_fips_all: '06015',
    county: 'Del Norte',
    county_names_all: 'Del Norte',
    county_weights: '{"06015": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 41.88847,
    longitude: -123.80238,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95543',
  },
  {
    city: 'Honeydew',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 40.26159,
    longitude: -124.08599,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95545',
  },
  {
    city: 'Hoopa',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 10.6,
    imprecise: false,
    latitude: 41.18777,
    longitude: -123.74535,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95546',
  },
  {
    city: 'Hydesville',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 46.9,
    imprecise: false,
    latitude: 40.56952,
    longitude: -124.07751,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95547',
  },
  {
    city: 'Klamath',
    county_fips: 6015,
    county_fips_all: '06015',
    county: 'Del Norte',
    county_names_all: 'Del Norte',
    county_weights: '{"06015": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 41.58633,
    longitude: -124.05859,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95548',
  },
  {
    city: 'Kneeland',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 40.65838,
    longitude: -123.89485,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1024,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95549',
  },
  {
    city: 'Korbel',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 40.77695,
    longitude: -123.82951,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95550',
  },
  {
    city: 'Loleta',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 40.66977,
    longitude: -124.21961,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1880,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95551',
  },
  {
    city: 'Mad River',
    county_fips: 6105,
    county_fips_all: '06105|06023',
    county: 'Trinity',
    county_names_all: 'Trinity|Humboldt',
    county_weights: '{"06105": 93.27, "06023": 6.73}',
    density: 1.7,
    imprecise: false,
    latitude: 40.34899,
    longitude: -123.42248,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95552',
  },
  {
    city: 'Miranda',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 40.22981,
    longitude: -123.87133,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 789,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95553',
  },
  {
    city: 'Myers Flat',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 40.27573,
    longitude: -123.78414,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95554',
  },
  {
    city: 'Orick',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 41.29519,
    longitude: -123.97774,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95555',
  },
  {
    city: 'Orleans',
    county_fips: 6023,
    county_fips_all: '06023|06093',
    county: 'Humboldt',
    county_names_all: 'Humboldt|Siskiyou',
    county_weights: '{"06023": 89.02, "06093": 10.98}',
    density: 2.2,
    imprecise: false,
    latitude: 41.31444,
    longitude: -123.59043,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95556',
  },
  {
    city: 'Petrolia',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 40.32673,
    longitude: -124.24017,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95558',
  },
  {
    city: 'Phillipsville',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 40.18977,
    longitude: -123.7512,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95559',
  },
  {
    city: 'Redway',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 28.1,
    imprecise: false,
    latitude: 40.14606,
    longitude: -123.83816,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95560',
  },
  {
    city: 'Rio Dell',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 79.7,
    imprecise: false,
    latitude: 40.45808,
    longitude: -124.1072,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95562',
  },
  {
    city: 'Salyer',
    county_fips: 6105,
    county_fips_all: '06105',
    county: 'Trinity',
    county_names_all: 'Trinity',
    county_weights: '{"06105": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 40.84248,
    longitude: -123.51225,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95563',
  },
  {
    city: 'Samoa',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 51.1,
    imprecise: false,
    latitude: 40.79023,
    longitude: -124.20312,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95564',
  },
  {
    city: 'Scotia',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 40.45723,
    longitude: -124.01099,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95565',
  },
  {
    city: 'Smith River',
    county_fips: 6015,
    county_fips_all: '06015',
    county: 'Del Norte',
    county_names_all: 'Del Norte',
    county_weights: '{"06015": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 41.9498,
    longitude: -124.1118,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95567',
  },
  {
    city: 'Somes Bar',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 41.48454,
    longitude: -123.48543,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95568',
  },
  {
    city: 'Redcrest',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 40.36078,
    longitude: -123.85818,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95569',
  },
  {
    city: 'Trinidad',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 41.11375,
    longitude: -124.08037,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2640,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95570',
  },
  {
    city: 'Weott',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 40.36495,
    longitude: -123.94157,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95571',
  },
  {
    city: 'Willow Creek',
    county_fips: 6023,
    county_fips_all: '06023',
    county: 'Humboldt',
    county_names_all: 'Humboldt',
    county_weights: '{"06023": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 40.89567,
    longitude: -123.65873,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95573',
  },
  {
    city: 'Leggett',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 39.85872,
    longitude: -123.66619,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95585',
  },
  {
    city: 'Piercy',
    county_fips: 6045,
    county_fips_all: '06045',
    county: 'Mendocino',
    county_names_all: 'Mendocino',
    county_weights: '{"06045": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.96969,
    longitude: -123.75537,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95587',
  },
  {
    city: 'Whitethorn',
    county_fips: 6023,
    county_fips_all: '06023|06045',
    county: 'Humboldt',
    county_names_all: 'Humboldt|Mendocino',
    county_weights: '{"06023": 78.68, "06045": 21.32}',
    density: 2.8,
    imprecise: false,
    latitude: 40.07927,
    longitude: -123.98596,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95589',
  },
  {
    city: 'Zenia',
    county_fips: 6105,
    county_fips_all: '06105',
    county: 'Trinity',
    county_names_all: 'Trinity',
    county_weights: '{"06105": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 40.11074,
    longitude: -123.26642,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95595',
  },
  {
    city: 'Amador City',
    county_fips: 6005,
    county_fips_all: '06005',
    county: 'Amador',
    county_names_all: 'Amador',
    county_weights: '{"06005": 100}',
    density: 55,
    imprecise: false,
    latitude: 38.42713,
    longitude: -120.82997,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 294,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95601',
  },
  {
    city: 'Auburn',
    county_fips: 6061,
    county_fips_all: '06061|06057',
    county: 'Placer',
    county_names_all: 'Placer|Nevada',
    county_weights: '{"06061": 78.02, "06057": 21.98}',
    density: 153.2,
    imprecise: false,
    latitude: 38.99039,
    longitude: -121.10991,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95602',
  },
  {
    city: 'Auburn',
    county_fips: 6061,
    county_fips_all: '06061|06017',
    county: 'Placer',
    county_names_all: 'Placer|El Dorado',
    county_weights: '{"06061": 99.6, "06017": 0.4}',
    density: 307,
    imprecise: false,
    latitude: 38.91167,
    longitude: -121.08559,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95603',
  },
  {
    city: 'Auburn',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 208.8,
    imprecise: false,
    latitude: 38.9112,
    longitude: -121.0982,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95604',
  },
  {
    city: 'West Sacramento',
    county_fips: 6113,
    county_fips_all: '06113',
    county: 'Yolo',
    county_names_all: 'Yolo',
    county_weights: '{"06113": 100}',
    density: 1475,
    imprecise: false,
    latitude: 38.59289,
    longitude: -121.53929,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95605',
  },
  {
    city: 'Brooks',
    county_fips: 6113,
    county_fips_all: '06113|06055',
    county: 'Yolo',
    county_names_all: 'Yolo|Napa',
    county_weights: '{"06113": 98.13, "06055": 1.87}',
    density: 2.4,
    imprecise: false,
    latitude: 38.75604,
    longitude: -122.19387,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95606',
  },
  {
    city: 'Carmichael',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1793.3,
    imprecise: false,
    latitude: 38.62611,
    longitude: -121.32886,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 61440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95608',
  },
  {
    city: 'Citrus Heights',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2285.4,
    imprecise: false,
    latitude: 38.69494,
    longitude: -121.27219,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95610',
  },
  {
    city: 'Clarksburg',
    county_fips: 6113,
    county_fips_all: '06113|06095',
    county: 'Yolo',
    county_names_all: 'Yolo|Solano',
    county_weights: '{"06113": 88.11, "06095": 11.89}',
    density: 11.3,
    imprecise: false,
    latitude: 38.38644,
    longitude: -121.58118,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95612',
  },
  {
    city: 'Coloma',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 38.81272,
    longitude: -120.89173,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95613',
  },
  {
    city: 'Cool',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 48.1,
    imprecise: false,
    latitude: 38.88649,
    longitude: -120.98896,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95614',
  },
  {
    city: 'Courtland',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 38.31113,
    longitude: -121.54595,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 918,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95615',
  },
  {
    city: 'Davis',
    county_fips: 6113,
    county_fips_all: '06113|06095',
    county: 'Yolo',
    county_names_all: 'Yolo|Solano',
    county_weights: '{"06113": 96.75, "06095": 3.25}',
    density: 693.6,
    imprecise: false,
    latitude: 38.55819,
    longitude: -121.80044,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 53630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95616',
  },
  {
    city: 'Davis',
    county_fips: 6113,
    county_fips_all: '06113|06095',
    county: 'Yolo',
    county_names_all: 'Yolo|Solano',
    county_weights: '{"06113": 77.29, "06095": 22.71}',
    density: 315.6,
    imprecise: false,
    latitude: 38.54348,
    longitude: -121.6917,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95618',
  },
  {
    city: 'Diamond Springs',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 323.5,
    imprecise: false,
    latitude: 38.68218,
    longitude: -120.81401,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95619',
  },
  {
    city: 'Dixon',
    county_fips: 6095,
    county_fips_all: '06095|06113',
    county: 'Solano',
    county_names_all: 'Solano|Yolo',
    county_weights: '{"06095": 75.99, "06113": 24.01}',
    density: 35.6,
    imprecise: false,
    latitude: 38.40599,
    longitude: -121.75689,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95620',
  },
  {
    city: 'Citrus Heights',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2454.8,
    imprecise: false,
    latitude: 38.69551,
    longitude: -121.30862,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95621',
  },
  {
    city: 'El Dorado',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 41.9,
    imprecise: false,
    latitude: 38.6075,
    longitude: -120.84873,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95623',
  },
  {
    city: 'Elk Grove',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 573.2,
    imprecise: false,
    latitude: 38.43203,
    longitude: -121.30506,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 67630,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95624',
  },
  {
    city: 'Elmira',
    county_fips: 6095,
    county_fips_all: '06095',
    county: 'Solano',
    county_names_all: 'Solano',
    county_weights: '{"06095": 100}',
    density: 133.7,
    imprecise: false,
    latitude: 38.35728,
    longitude: -121.90861,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95625',
  },
  {
    city: 'Elverta',
    county_fips: 6067,
    county_fips_all: '06067|06061|06101',
    county: 'Sacramento',
    county_names_all: 'Sacramento|Placer|Sutter',
    county_weights: '{"06067": 57.51, "06061": 25.62, "06101": 16.87}',
    density: 57.3,
    imprecise: false,
    latitude: 38.73378,
    longitude: -121.48898,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95626',
  },
  {
    city: 'Esparto',
    county_fips: 6113,
    county_fips_all: '06113',
    county: 'Yolo',
    county_names_all: 'Yolo',
    county_weights: '{"06113": 100}',
    density: 29.5,
    imprecise: false,
    latitude: 38.72936,
    longitude: -122.00959,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95627',
  },
  {
    city: 'Fair Oaks',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1343.4,
    imprecise: false,
    latitude: 38.65212,
    longitude: -121.2543,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95628',
  },
  {
    city: 'Fiddletown',
    county_fips: 6005,
    county_fips_all: '06005|06017',
    county: 'Amador',
    county_names_all: 'Amador|El Dorado',
    county_weights: '{"06005": 60.81, "06017": 39.19}',
    density: 5.5,
    imprecise: false,
    latitude: 38.51277,
    longitude: -120.6875,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95629',
  },
  {
    city: 'Folsom',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1171.7,
    imprecise: false,
    latitude: 38.66558,
    longitude: -121.141,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 79484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95630',
  },
  {
    city: 'Foresthill',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 15.4,
    imprecise: false,
    latitude: 39.05453,
    longitude: -120.75365,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6946,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95631',
  },
  {
    city: 'Galt',
    county_fips: 6067,
    county_fips_all: '06067|06077',
    county: 'Sacramento',
    county_names_all: 'Sacramento|San Joaquin',
    county_weights: '{"06067": 69.49, "06077": 30.51}',
    density: 110.8,
    imprecise: false,
    latitude: 38.27705,
    longitude: -121.26128,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95632',
  },
  {
    city: 'Garden Valley',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 26,
    imprecise: false,
    latitude: 38.84919,
    longitude: -120.82328,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2653,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95633',
  },
  {
    city: 'Georgetown',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 38.9123,
    longitude: -120.69443,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95634',
  },
  {
    city: 'Greenwood',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 17,
    imprecise: false,
    latitude: 38.91111,
    longitude: -120.90043,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95635',
  },
  {
    city: 'Grizzly Flats',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 47.5,
    imprecise: false,
    latitude: 38.6274,
    longitude: -120.51852,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95636',
  },
  {
    city: 'Guinda',
    county_fips: 6113,
    county_fips_all: '06113|06055',
    county: 'Yolo',
    county_names_all: 'Yolo|Napa',
    county_weights: '{"06113": 99.44, "06055": 0.56}',
    density: 3.7,
    imprecise: false,
    latitude: 38.85283,
    longitude: -122.2729,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 402,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95637',
  },
  {
    city: 'Herald',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 38.33969,
    longitude: -121.11481,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95638',
  },
  {
    city: 'Hood',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 38.39202,
    longitude: -121.49599,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95639',
  },
  {
    city: 'Ione',
    county_fips: 6005,
    county_fips_all: '06005|06067',
    county: 'Amador',
    county_names_all: 'Amador|Sacramento',
    county_weights: '{"06005": 99.69, "06067": 0.31}',
    density: 40.9,
    imprecise: false,
    latitude: 38.33922,
    longitude: -120.94024,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95640',
  },
  {
    city: 'Isleton',
    county_fips: 6067,
    county_fips_all: '06067|06077',
    county: 'Sacramento',
    county_names_all: 'Sacramento|San Joaquin',
    county_weights: '{"06067": 95.81, "06077": 4.19}',
    density: 20.4,
    imprecise: false,
    latitude: 38.15046,
    longitude: -121.60271,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95641',
  },
  {
    city: 'Jackson',
    county_fips: 6005,
    county_fips_all: '06005',
    county: 'Amador',
    county_names_all: 'Amador',
    county_weights: '{"06005": 100}',
    density: 41.4,
    imprecise: false,
    latitude: 38.3434,
    longitude: -120.76398,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95642',
  },
  {
    city: 'Knights Landing',
    county_fips: 6113,
    county_fips_all: '06113|06101|06011',
    county: 'Yolo',
    county_names_all: 'Yolo|Sutter|Colusa',
    county_weights: '{"06113": 39.21, "06101": 35.98, "06011": 24.82}',
    density: 4.1,
    imprecise: false,
    latitude: 38.89025,
    longitude: -121.79992,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95645',
  },
  {
    city: 'Kirkwood',
    county_fips: 6003,
    county_fips_all: '06003|06005',
    county: 'Alpine',
    county_names_all: 'Alpine|Amador',
    county_weights: '{"06003": 97.45, "06005": 2.55}',
    density: 1.6,
    imprecise: false,
    latitude: 38.63828,
    longitude: -120.01813,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 218,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95646',
  },
  {
    city: 'Lincoln',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 153.7,
    imprecise: false,
    latitude: 38.92643,
    longitude: -121.31101,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95648',
  },
  {
    city: 'Loomis',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 226.3,
    imprecise: false,
    latitude: 38.81339,
    longitude: -121.16831,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95650',
  },
  {
    city: 'Lotus',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 38.82088,
    longitude: -120.93515,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95651',
  },
  {
    city: 'Mcclellan',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 153.5,
    imprecise: false,
    latitude: 38.66265,
    longitude: -121.40079,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95652',
  },
  {
    city: 'Madison',
    county_fips: 6113,
    county_fips_all: '06113',
    county: 'Yolo',
    county_names_all: 'Yolo',
    county_weights: '{"06113": 100}',
    density: 56.6,
    imprecise: false,
    latitude: 38.69151,
    longitude: -121.97723,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95653',
  },
  {
    city: 'Mather',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 198.6,
    imprecise: false,
    latitude: 38.54976,
    longitude: -121.27898,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4901,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95655',
  },
  {
    city: 'Newcastle',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 97.7,
    imprecise: false,
    latitude: 38.87938,
    longitude: -121.15173,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5894,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95658',
  },
  {
    city: 'Nicolaus',
    county_fips: 6101,
    county_fips_all: '06101',
    county: 'Sutter',
    county_names_all: 'Sutter',
    county_weights: '{"06101": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 38.84594,
    longitude: -121.57679,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 617,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95659',
  },
  {
    city: 'North Highlands',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2154,
    imprecise: false,
    latitude: 38.67883,
    longitude: -121.3805,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95660',
  },
  {
    city: 'Roseville',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 1405.2,
    imprecise: false,
    latitude: 38.74129,
    longitude: -121.24925,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95661',
  },
  {
    city: 'Orangevale',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1164.8,
    imprecise: false,
    latitude: 38.68917,
    longitude: -121.21988,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95662',
  },
  {
    city: 'Penryn',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 137.1,
    imprecise: false,
    latitude: 38.85739,
    longitude: -121.18251,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95663',
  },
  {
    city: 'Pilot Hill',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 38.79755,
    longitude: -121.05136,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1341,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95664',
  },
  {
    city: 'Pine Grove',
    county_fips: 6005,
    county_fips_all: '06005',
    county: 'Amador',
    county_names_all: 'Amador',
    county_weights: '{"06005": 100}',
    density: 85.1,
    imprecise: false,
    latitude: 38.39587,
    longitude: -120.65238,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95665',
  },
  {
    city: 'Pioneer',
    county_fips: 6005,
    county_fips_all: '06005',
    county: 'Amador',
    county_names_all: 'Amador',
    county_weights: '{"06005": 100}',
    density: 27.6,
    imprecise: false,
    latitude: 38.54113,
    longitude: -120.33076,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95666',
  },
  {
    city: 'Placerville',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 84.1,
    imprecise: false,
    latitude: 38.73407,
    longitude: -120.79216,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95667',
  },
  {
    city: 'Pleasant Grove',
    county_fips: 6101,
    county_fips_all: '06101|06061',
    county: 'Sutter',
    county_names_all: 'Sutter|Placer',
    county_weights: '{"06101": 69.73, "06061": 30.27}',
    density: 3.1,
    imprecise: false,
    latitude: 38.82708,
    longitude: -121.49378,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95668',
  },
  {
    city: 'Plymouth',
    county_fips: 6005,
    county_fips_all: '06005',
    county: 'Amador',
    county_names_all: 'Amador',
    county_weights: '{"06005": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 38.49522,
    longitude: -120.89157,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95669',
  },
  {
    city: 'Rancho Cordova',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1758.1,
    imprecise: false,
    latitude: 38.60461,
    longitude: -121.27963,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 58819,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95670',
  },
  {
    city: 'Rescue',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 102.3,
    imprecise: false,
    latitude: 38.72664,
    longitude: -120.99638,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95672',
  },
  {
    city: 'Rio Linda',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 392.2,
    imprecise: false,
    latitude: 38.69029,
    longitude: -121.46603,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95673',
  },
  {
    city: 'Rio Oso',
    county_fips: 6101,
    county_fips_all: '06101',
    county: 'Sutter',
    county_names_all: 'Sutter',
    county_weights: '{"06101": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 38.95396,
    longitude: -121.48187,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95674',
  },
  {
    city: 'River Pines',
    county_fips: 6005,
    county_fips_all: '06005|06017',
    county: 'Amador',
    county_names_all: 'Amador|El Dorado',
    county_weights: '{"06005": 96.96, "06017": 3.04}',
    density: 713.2,
    imprecise: false,
    latitude: 38.54548,
    longitude: -120.74277,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 374,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95675',
  },
  {
    city: 'Robbins',
    county_fips: 6101,
    county_fips_all: '06101',
    county: 'Sutter',
    county_names_all: 'Sutter',
    county_weights: '{"06101": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 38.87224,
    longitude: -121.71664,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95676',
  },
  {
    city: 'Rocklin',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 1159.6,
    imprecise: false,
    latitude: 38.79298,
    longitude: -121.23133,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29206,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95677',
  },
  {
    city: 'Roseville',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 1532.5,
    imprecise: false,
    latitude: 38.76536,
    longitude: -121.28847,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95678',
  },
  {
    city: 'Rumsey',
    county_fips: 6113,
    county_fips_all: '06113',
    county: 'Yolo',
    county_names_all: 'Yolo',
    county_weights: '{"06113": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 38.90524,
    longitude: -122.26727,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95679',
  },
  {
    city: 'Ryde',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 38.24142,
    longitude: -121.57816,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95680',
  },
  {
    city: 'Sheridan',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 31.3,
    imprecise: false,
    latitude: 38.99809,
    longitude: -121.35422,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95681',
  },
  {
    city: 'Shingle Springs',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 129.1,
    imprecise: false,
    latitude: 38.60537,
    longitude: -120.96175,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30065,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95682',
  },
  {
    city: 'Sloughhouse',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 29.1,
    imprecise: false,
    latitude: 38.51018,
    longitude: -121.09894,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6515,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95683',
  },
  {
    city: 'Somerset',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 38.59098,
    longitude: -120.55066,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95684',
  },
  {
    city: 'Sutter Creek',
    county_fips: 6005,
    county_fips_all: '06005',
    county: 'Amador',
    county_names_all: 'Amador',
    county_weights: '{"06005": 100}',
    density: 45.3,
    imprecise: false,
    latitude: 38.42716,
    longitude: -120.76698,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95685',
  },
  {
    city: 'Thornton',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 14,
    imprecise: false,
    latitude: 38.19039,
    longitude: -121.48543,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95686',
  },
  {
    city: 'Vacaville',
    county_fips: 6095,
    county_fips_all: '06095',
    county: 'Solano',
    county_names_all: 'Solano',
    county_weights: '{"06095": 100}',
    density: 601.3,
    imprecise: false,
    latitude: 38.3344,
    longitude: -121.91765,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 69390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95687',
  },
  {
    city: 'Vacaville',
    county_fips: 6095,
    county_fips_all: '06095',
    county: 'Solano',
    county_names_all: 'Solano',
    county_weights: '{"06095": 100}',
    density: 168.8,
    imprecise: false,
    latitude: 38.41901,
    longitude: -122.02571,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95688',
  },
  {
    city: 'Volcano',
    county_fips: 6005,
    county_fips_all: '06005',
    county: 'Amador',
    county_names_all: 'Amador',
    county_weights: '{"06005": 100}',
    density: 21.8,
    imprecise: false,
    latitude: 38.47088,
    longitude: -120.61566,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95689',
  },
  {
    city: 'Walnut Grove',
    county_fips: 6067,
    county_fips_all: '06067|06095',
    county: 'Sacramento',
    county_names_all: 'Sacramento|Solano',
    county_weights: '{"06067": 64.07, "06095": 35.93}',
    density: 18.2,
    imprecise: false,
    latitude: 38.23429,
    longitude: -121.58672,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95690',
  },
  {
    city: 'West Sacramento',
    county_fips: 6113,
    county_fips_all: '06113',
    county: 'Yolo',
    county_names_all: 'Yolo',
    county_weights: '{"06113": 100}',
    density: 397.1,
    imprecise: false,
    latitude: 38.62394,
    longitude: -121.58272,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95691',
  },
  {
    city: 'Wheatland',
    county_fips: 6115,
    county_fips_all: '06115|06101',
    county: 'Yuba',
    county_names_all: 'Yuba|Sutter',
    county_weights: '{"06115": 97.73, "06101": 2.27}',
    density: 34,
    imprecise: false,
    latitude: 39.04699,
    longitude: -121.40471,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95692',
  },
  {
    city: 'Wilton',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 52.4,
    imprecise: false,
    latitude: 38.39851,
    longitude: -121.21956,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95693',
  },
  {
    city: 'Winters',
    county_fips: 6113,
    county_fips_all: '06113|06095|06055',
    county: 'Yolo',
    county_names_all: 'Yolo|Solano|Napa',
    county_weights: '{"06113": 79.51, "06095": 19.97, "06055": 0.52}',
    density: 31.2,
    imprecise: false,
    latitude: 38.56163,
    longitude: -122.00609,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95694',
  },
  {
    city: 'Woodland',
    county_fips: 6113,
    county_fips_all: '06113',
    county: 'Yolo',
    county_names_all: 'Yolo',
    county_weights: '{"06113": 100}',
    density: 100,
    imprecise: false,
    latitude: 38.68847,
    longitude: -121.85666,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95695',
  },
  {
    city: 'Yolo',
    county_fips: 6113,
    county_fips_all: '06113',
    county: 'Yolo',
    county_names_all: 'Yolo',
    county_weights: '{"06113": 100}',
    density: 1127.1,
    imprecise: false,
    latitude: 38.73284,
    longitude: -121.80701,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95697',
  },
  {
    city: 'Zamora',
    county_fips: 6113,
    county_fips_all: '06113',
    county: 'Yolo',
    county_names_all: 'Yolo',
    county_weights: '{"06113": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 38.8187,
    longitude: -121.91012,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95698',
  },
  {
    city: 'Drytown',
    county_fips: 6005,
    county_fips_all: '06005',
    county: 'Amador',
    county_names_all: 'Amador',
    county_weights: '{"06005": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 38.44074,
    longitude: -120.85702,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95699',
  },
  {
    city: 'Alta',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 12,
    imprecise: false,
    latitude: 39.22633,
    longitude: -120.76741,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95701',
  },
  {
    city: 'Applegate',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 112.6,
    imprecise: false,
    latitude: 38.99156,
    longitude: -120.9864,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2589,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95703',
  },
  {
    city: 'Camino',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 97.4,
    imprecise: false,
    latitude: 38.74886,
    longitude: -120.68134,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95709',
  },
  {
    city: 'Colfax',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 60,
    imprecise: false,
    latitude: 39.08477,
    longitude: -120.92788,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95713',
  },
  {
    city: 'Dutch Flat',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 42.3,
    imprecise: false,
    latitude: 39.2013,
    longitude: -120.83677,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95714',
  },
  {
    city: 'Emigrant Gap',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 39.27495,
    longitude: -120.64388,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95715',
  },
  {
    city: 'Gold Run',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 39.14258,
    longitude: -120.84268,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95717',
  },
  {
    city: 'Kyburz',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 38.84536,
    longitude: -120.26021,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95720',
  },
  {
    city: 'Echo Lake',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.82341,
    longitude: -120.09379,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95721',
  },
  {
    city: 'Meadow Vista',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 151.3,
    imprecise: false,
    latitude: 39.00467,
    longitude: -121.02891,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95722',
  },
  {
    city: 'Pollock Pines',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 38.75418,
    longitude: -120.41989,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95726',
  },
  {
    city: 'Soda Springs',
    county_fips: 6061,
    county_fips_all: '06061|06057',
    county: 'Placer',
    county_names_all: 'Placer|Nevada',
    county_weights: '{"06061": 76.85, "06057": 23.15}',
    density: 7.1,
    imprecise: false,
    latitude: 39.29673,
    longitude: -120.40358,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95728',
  },
  {
    city: 'Twin Bridges',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 38.82986,
    longitude: -120.17936,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95735',
  },
  {
    city: 'Weimar',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 552.7,
    imprecise: false,
    latitude: 39.03905,
    longitude: -120.97738,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95736',
  },
  {
    city: 'Rancho Cordova',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 136,
    imprecise: false,
    latitude: 38.5735,
    longitude: -121.19854,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95742',
  },
  {
    city: 'Granite Bay',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 482.3,
    imprecise: false,
    latitude: 38.75009,
    longitude: -121.16712,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95746',
  },
  {
    city: 'Roseville',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 769.2,
    imprecise: false,
    latitude: 38.77963,
    longitude: -121.36798,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 83902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95747',
  },
  {
    city: 'Elk Grove',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 339.8,
    imprecise: false,
    latitude: 38.33886,
    longitude: -121.43643,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 56764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95757',
  },
  {
    city: 'Elk Grove',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1862.7,
    imprecise: false,
    latitude: 38.42932,
    longitude: -121.44603,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 65725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95758',
  },
  {
    city: 'El Dorado Hills',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 442.5,
    imprecise: false,
    latitude: 38.67694,
    longitude: -121.05755,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95762',
  },
  {
    city: 'Rocklin',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 1352.7,
    imprecise: false,
    latitude: 38.81982,
    longitude: -121.27772,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95765',
  },
  {
    city: 'Woodland',
    county_fips: 6113,
    county_fips_all: '06113',
    county: 'Yolo',
    county_names_all: 'Yolo',
    county_weights: '{"06113": 100}',
    density: 125.7,
    imprecise: false,
    latitude: 38.68889,
    longitude: -121.70776,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95776',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1468.5,
    imprecise: false,
    latitude: 38.58761,
    longitude: -121.49077,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95811',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 3416.3,
    imprecise: false,
    latitude: 38.58064,
    longitude: -121.49488,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95814',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1344.9,
    imprecise: false,
    latitude: 38.60544,
    longitude: -121.44497,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95815',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2720.4,
    imprecise: false,
    latitude: 38.57555,
    longitude: -121.46543,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95816',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2423.9,
    imprecise: false,
    latitude: 38.55057,
    longitude: -121.45713,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95817',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2259.1,
    imprecise: false,
    latitude: 38.55579,
    longitude: -121.49669,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95818',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2113.2,
    imprecise: false,
    latitude: 38.56816,
    longitude: -121.43772,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95819',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2595.6,
    imprecise: false,
    latitude: 38.53491,
    longitude: -121.4442,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95820',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2081.1,
    imprecise: false,
    latitude: 38.62541,
    longitude: -121.38479,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38064,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95821',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2141.1,
    imprecise: false,
    latitude: 38.51273,
    longitude: -121.49556,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95822',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2812.2,
    imprecise: false,
    latitude: 38.47473,
    longitude: -121.44266,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 83607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95823',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 3203.1,
    imprecise: false,
    latitude: 38.51746,
    longitude: -121.44147,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95824',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2998.5,
    imprecise: false,
    latitude: 38.5901,
    longitude: -121.40644,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95825',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1471.6,
    imprecise: false,
    latitude: 38.54554,
    longitude: -121.37885,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95826',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 938.5,
    imprecise: false,
    latitude: 38.55151,
    longitude: -121.3253,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95827',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1920.3,
    imprecise: false,
    latitude: 38.48943,
    longitude: -121.39598,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 61686,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95828',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 605.8,
    imprecise: false,
    latitude: 38.48759,
    longitude: -121.33326,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95829',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 20.6,
    imprecise: false,
    latitude: 38.49415,
    longitude: -121.27229,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95830',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2403.5,
    imprecise: false,
    latitude: 38.49599,
    longitude: -121.52948,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95831',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 597,
    imprecise: false,
    latitude: 38.43979,
    longitude: -121.49888,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95832',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2017.4,
    imprecise: false,
    latitude: 38.61529,
    longitude: -121.51558,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95833',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1404.5,
    imprecise: false,
    latitude: 38.64207,
    longitude: -121.51967,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95834',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1826.5,
    imprecise: false,
    latitude: 38.67088,
    longitude: -121.52464,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42004,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95835',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067|06101',
    county: 'Sacramento',
    county_names_all: 'Sacramento|Sutter',
    county_weights: '{"06067": 91.86, "06101": 8.14}',
    density: 8.5,
    imprecise: false,
    latitude: 38.68925,
    longitude: -121.59537,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95837',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1706.2,
    imprecise: false,
    latitude: 38.64708,
    longitude: -121.44312,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95838',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2030.7,
    imprecise: false,
    latitude: 38.66031,
    longitude: -121.34812,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95841',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 3308.5,
    imprecise: false,
    latitude: 38.687,
    longitude: -121.34889,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34034,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95842',
  },
  {
    city: 'Antelope',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 2825.8,
    imprecise: false,
    latitude: 38.71532,
    longitude: -121.36366,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47695,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95843',
  },
  {
    city: 'Sacramento',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1567.8,
    imprecise: false,
    latitude: 38.58512,
    longitude: -121.37655,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95864',
  },
  {
    city: 'Marysville',
    county_fips: 6115,
    county_fips_all: '06115|06007',
    county: 'Yuba',
    county_names_all: 'Yuba|Butte',
    county_weights: '{"06115": 96.97, "06007": 3.03}',
    density: 72.8,
    imprecise: false,
    latitude: 39.2225,
    longitude: -121.48855,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37732,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95901',
  },
  {
    city: 'Beale Afb',
    county_fips: 6115,
    county_fips_all: '06115',
    county: 'Yuba',
    county_names_all: 'Yuba',
    county_weights: '{"06115": 100}',
    density: 42.3,
    imprecise: false,
    latitude: 39.11337,
    longitude: -121.37192,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95903',
  },
  {
    city: 'Alleghany',
    county_fips: 6091,
    county_fips_all: '06091',
    county: 'Sierra',
    county_names_all: 'Sierra',
    county_weights: '{"06091": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 39.46742,
    longitude: -120.83158,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95910',
  },
  {
    city: 'Arbuckle',
    county_fips: 6011,
    county_fips_all: '06011',
    county: 'Colusa',
    county_names_all: 'Colusa',
    county_weights: '{"06011": 100}',
    density: 12.3,
    imprecise: false,
    latitude: 39.0016,
    longitude: -122.07462,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95912',
  },
  {
    city: 'Artois',
    county_fips: 6021,
    county_fips_all: '06021',
    county: 'Glenn',
    county_names_all: 'Glenn',
    county_weights: '{"06021": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 39.62899,
    longitude: -122.19215,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95913',
  },
  {
    city: 'Bangor',
    county_fips: 6007,
    county_fips_all: '06007|06115',
    county: 'Butte',
    county_names_all: 'Butte|Yuba',
    county_weights: '{"06007": 88.09, "06115": 11.91}',
    density: 7.2,
    imprecise: false,
    latitude: 39.40756,
    longitude: -121.37878,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95914',
  },
  {
    city: 'Belden',
    county_fips: 6063,
    county_fips_all: '06063',
    county: 'Plumas',
    county_names_all: 'Plumas',
    county_weights: '{"06063": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.97926,
    longitude: -121.21492,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95915',
  },
  {
    city: 'Berry Creek',
    county_fips: 6007,
    county_fips_all: '06007',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"06007": 100}',
    density: 3,
    imprecise: false,
    latitude: 39.65945,
    longitude: -121.37375,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 667,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95916',
  },
  {
    city: 'Biggs',
    county_fips: 6007,
    county_fips_all: '06007',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"06007": 100}',
    density: 18,
    imprecise: false,
    latitude: 39.42392,
    longitude: -121.77178,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95917',
  },
  {
    city: 'Browns Valley',
    county_fips: 6115,
    county_fips_all: '06115',
    county: 'Yuba',
    county_names_all: 'Yuba',
    county_weights: '{"06115": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 39.301,
    longitude: -121.34547,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95918',
  },
  {
    city: 'Brownsville',
    county_fips: 6115,
    county_fips_all: '06115',
    county: 'Yuba',
    county_names_all: 'Yuba',
    county_weights: '{"06115": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 39.43445,
    longitude: -121.26554,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95919',
  },
  {
    city: 'Butte City',
    county_fips: 6021,
    county_fips_all: '06021',
    county: 'Glenn',
    county_names_all: 'Glenn',
    county_weights: '{"06021": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 39.46071,
    longitude: -121.93702,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95920',
  },
  {
    city: 'Camptonville',
    county_fips: 6115,
    county_fips_all: '06115|06091',
    county: 'Yuba',
    county_names_all: 'Yuba|Sierra',
    county_weights: '{"06115": 83.15, "06091": 16.85}',
    density: 3.2,
    imprecise: false,
    latitude: 39.47033,
    longitude: -121.07736,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95922',
  },
  {
    city: 'Canyon Dam',
    county_fips: 6063,
    county_fips_all: '06063',
    county: 'Plumas',
    county_names_all: 'Plumas',
    county_weights: '{"06063": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 40.18385,
    longitude: -121.13672,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 68,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95923',
  },
  {
    city: 'Challenge',
    county_fips: 6115,
    county_fips_all: '06115',
    county: 'Yuba',
    county_names_all: 'Yuba',
    county_weights: '{"06115": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 39.46798,
    longitude: -121.18006,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95925',
  },
  {
    city: 'Chico',
    county_fips: 6007,
    county_fips_all: '06007',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"06007": 100}',
    density: 2013.7,
    imprecise: false,
    latitude: 39.74573,
    longitude: -121.84396,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95926',
  },
  {
    city: 'Chico',
    county_fips: 6007,
    county_fips_all: '06007',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"06007": 100}',
    density: 99.3,
    imprecise: false,
    latitude: 39.68317,
    longitude: -121.83528,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95928',
  },
  {
    city: 'Clipper Mills',
    county_fips: 6007,
    county_fips_all: '06007|06115',
    county: 'Butte',
    county_names_all: 'Butte|Yuba',
    county_weights: '{"06007": 85.11, "06115": 14.89}',
    density: 23.8,
    imprecise: false,
    latitude: 39.54679,
    longitude: -121.1606,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95930',
  },
  {
    city: 'Colusa',
    county_fips: 6011,
    county_fips_all: '06011',
    county: 'Colusa',
    county_names_all: 'Colusa',
    county_weights: '{"06011": 100}',
    density: 20.8,
    imprecise: false,
    latitude: 39.26839,
    longitude: -122.00426,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95932',
  },
  {
    city: 'Crescent Mills',
    county_fips: 6063,
    county_fips_all: '06063',
    county: 'Plumas',
    county_names_all: 'Plumas',
    county_weights: '{"06063": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 40.07463,
    longitude: -120.93108,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95934',
  },
  {
    city: 'Dobbins',
    county_fips: 6115,
    county_fips_all: '06115',
    county: 'Yuba',
    county_names_all: 'Yuba',
    county_weights: '{"06115": 100}',
    density: 14,
    imprecise: false,
    latitude: 39.37369,
    longitude: -121.19615,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95935',
  },
  {
    city: 'Downieville',
    county_fips: 6091,
    county_fips_all: '06091',
    county: 'Sierra',
    county_names_all: 'Sierra',
    county_weights: '{"06091": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 39.56336,
    longitude: -120.79279,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 144,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95936',
  },
  {
    city: 'Dunnigan',
    county_fips: 6113,
    county_fips_all: '06113',
    county: 'Yolo',
    county_names_all: 'Yolo',
    county_weights: '{"06113": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 38.88403,
    longitude: -121.99847,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95937',
  },
  {
    city: 'Durham',
    county_fips: 6007,
    county_fips_all: '06007',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"06007": 100}',
    density: 22.3,
    imprecise: false,
    latitude: 39.60504,
    longitude: -121.79708,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95938',
  },
  {
    city: 'Elk Creek',
    county_fips: 6021,
    county_fips_all: '06021',
    county: 'Glenn',
    county_names_all: 'Glenn',
    county_weights: '{"06021": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 39.56755,
    longitude: -122.60224,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95939',
  },
  {
    city: 'Forbestown',
    county_fips: 6007,
    county_fips_all: '06007|06115',
    county: 'Butte',
    county_names_all: 'Butte|Yuba',
    county_weights: '{"06007": 85.29, "06115": 14.71}',
    density: 1.2,
    imprecise: false,
    latitude: 39.5588,
    longitude: -121.24157,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95941',
  },
  {
    city: 'Forest Ranch',
    county_fips: 6007,
    county_fips_all: '06007',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"06007": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 39.98954,
    longitude: -121.58872,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95942',
  },
  {
    city: 'Glenn',
    county_fips: 6021,
    county_fips_all: '06021',
    county: 'Glenn',
    county_names_all: 'Glenn',
    county_weights: '{"06021": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 39.57692,
    longitude: -122.0367,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95943',
  },
  {
    city: 'Goodyears Bar',
    county_fips: 6091,
    county_fips_all: '06091',
    county: 'Sierra',
    county_names_all: 'Sierra',
    county_weights: '{"06091": 100}',
    density: 5,
    imprecise: false,
    latitude: 39.53482,
    longitude: -120.86159,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95944',
  },
  {
    city: 'Grass Valley',
    county_fips: 6057,
    county_fips_all: '06057',
    county: 'Nevada',
    county_names_all: 'Nevada',
    county_weights: '{"06057": 100}',
    density: 173.5,
    imprecise: false,
    latitude: 39.19426,
    longitude: -120.98199,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95945',
  },
  {
    city: 'Penn Valley',
    county_fips: 6057,
    county_fips_all: '06057',
    county: 'Nevada',
    county_names_all: 'Nevada',
    county_weights: '{"06057": 100}',
    density: 86,
    imprecise: false,
    latitude: 39.21052,
    longitude: -121.20467,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9958,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95946',
  },
  {
    city: 'Greenville',
    county_fips: 6063,
    county_fips_all: '06063',
    county: 'Plumas',
    county_names_all: 'Plumas',
    county_weights: '{"06063": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 40.15942,
    longitude: -120.84409,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95947',
  },
  {
    city: 'Gridley',
    county_fips: 6007,
    county_fips_all: '06007|06101',
    county: 'Butte',
    county_names_all: 'Butte|Sutter',
    county_weights: '{"06007": 99.79, "06101": 0.21}',
    density: 57.2,
    imprecise: false,
    latitude: 39.34289,
    longitude: -121.75818,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95948',
  },
  {
    city: 'Grass Valley',
    county_fips: 6057,
    county_fips_all: '06057',
    county: 'Nevada',
    county_names_all: 'Nevada',
    county_weights: '{"06057": 100}',
    density: 57.9,
    imprecise: false,
    latitude: 39.102,
    longitude: -121.13343,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95949',
  },
  {
    city: 'Grimes',
    county_fips: 6011,
    county_fips_all: '06011',
    county: 'Colusa',
    county_names_all: 'Colusa',
    county_weights: '{"06011": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 39.05144,
    longitude: -121.92196,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95950',
  },
  {
    city: 'Hamilton City',
    county_fips: 6021,
    county_fips_all: '06021',
    county: 'Glenn',
    county_names_all: 'Glenn',
    county_weights: '{"06021": 100}',
    density: 53.2,
    imprecise: false,
    latitude: 39.71473,
    longitude: -122.00197,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95951',
  },
  {
    city: 'Live Oak',
    county_fips: 6101,
    county_fips_all: '06101',
    county: 'Sutter',
    county_names_all: 'Sutter',
    county_weights: '{"06101": 100}',
    density: 36.7,
    imprecise: false,
    latitude: 39.25018,
    longitude: -121.77309,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95953',
  },
  {
    city: 'Magalia',
    county_fips: 6007,
    county_fips_all: '06007',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"06007": 100}',
    density: 24.9,
    imprecise: false,
    latitude: 39.94916,
    longitude: -121.54088,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8165,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95954',
  },
  {
    city: 'Maxwell',
    county_fips: 6011,
    county_fips_all: '06011',
    county: 'Colusa',
    county_names_all: 'Colusa',
    county_weights: '{"06011": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 39.29657,
    longitude: -122.20454,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95955',
  },
  {
    city: 'Meadow Valley',
    county_fips: 6063,
    county_fips_all: '06063',
    county: 'Plumas',
    county_names_all: 'Plumas',
    county_weights: '{"06063": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 39.8751,
    longitude: -121.12209,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95956',
  },
  {
    city: 'Meridian',
    county_fips: 6101,
    county_fips_all: '06101|06011',
    county: 'Sutter',
    county_names_all: 'Sutter|Colusa',
    county_weights: '{"06101": 95.58, "06011": 4.42}',
    density: 2.8,
    imprecise: false,
    latitude: 39.05366,
    longitude: -121.82379,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95957',
  },
  {
    city: 'Nelson',
    county_fips: 6007,
    county_fips_all: '06007',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"06007": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.56417,
    longitude: -121.79804,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95958',
  },
  {
    city: 'Nevada City',
    county_fips: 6057,
    county_fips_all: '06057',
    county: 'Nevada',
    county_names_all: 'Nevada',
    county_weights: '{"06057": 100}',
    density: 21.9,
    imprecise: false,
    latitude: 39.34509,
    longitude: -120.86797,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95959',
  },
  {
    city: 'North San Juan',
    county_fips: 6091,
    county_fips_all: '06091|06057|06115',
    county: 'Sierra',
    county_names_all: 'Sierra|Nevada|Yuba',
    county_weights: '{"06091": 39.04, "06057": 37.19, "06115": 23.77}',
    density: 5,
    imprecise: false,
    latitude: 39.39121,
    longitude: -121.0583,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95960',
  },
  {
    city: 'Olivehurst',
    county_fips: 6115,
    county_fips_all: '06115',
    county: 'Yuba',
    county_names_all: 'Yuba',
    county_weights: '{"06115": 100}',
    density: 286.3,
    imprecise: false,
    latitude: 39.03343,
    longitude: -121.55754,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33999,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95961',
  },
  {
    city: 'Oregon House',
    county_fips: 6115,
    county_fips_all: '06115',
    county: 'Yuba',
    county_names_all: 'Yuba',
    county_weights: '{"06115": 100}',
    density: 11.3,
    imprecise: false,
    latitude: 39.32669,
    longitude: -121.26876,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95962',
  },
  {
    city: 'Orland',
    county_fips: 6021,
    county_fips_all: '06021|06103',
    county: 'Glenn',
    county_names_all: 'Glenn|Tehama',
    county_weights: '{"06021": 87.65, "06103": 12.35}',
    density: 19.1,
    imprecise: false,
    latitude: 39.73682,
    longitude: -122.30329,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95963',
  },
  {
    city: 'Oroville',
    county_fips: 6007,
    county_fips_all: '06007',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"06007": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 39.59169,
    longitude: -121.59034,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95965',
  },
  {
    city: 'Oroville',
    county_fips: 6007,
    county_fips_all: '06007|06115',
    county: 'Butte',
    county_names_all: 'Butte|Yuba',
    county_weights: '{"06007": 96.97, "06115": 3.03}',
    density: 64.7,
    imprecise: false,
    latitude: 39.47332,
    longitude: -121.43284,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95966',
  },
  {
    city: 'Palermo',
    county_fips: 6007,
    county_fips_all: '06007',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"06007": 100}',
    density: 292.9,
    imprecise: false,
    latitude: 39.43514,
    longitude: -121.55179,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1364,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95968',
  },
  {
    city: 'Paradise',
    county_fips: 6007,
    county_fips_all: '06007',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"06007": 100}',
    density: 63.5,
    imprecise: false,
    latitude: 39.72178,
    longitude: -121.63388,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95969',
  },
  {
    city: 'Princeton',
    county_fips: 6021,
    county_fips_all: '06021|06011',
    county: 'Glenn',
    county_names_all: 'Glenn|Colusa',
    county_weights: '{"06021": 50.06, "06011": 49.94}',
    density: 5.4,
    imprecise: false,
    latitude: 39.41159,
    longitude: -122.05176,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95970',
  },
  {
    city: 'Quincy',
    county_fips: 6063,
    county_fips_all: '06063',
    county: 'Plumas',
    county_names_all: 'Plumas',
    county_weights: '{"06063": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 39.92895,
    longitude: -120.91608,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95971',
  },
  {
    city: 'Rackerby',
    county_fips: 6115,
    county_fips_all: '06115',
    county: 'Yuba',
    county_names_all: 'Yuba',
    county_weights: '{"06115": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.42955,
    longitude: -121.33624,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95972',
  },
  {
    city: 'Chico',
    county_fips: 6007,
    county_fips_all: '06007|06103',
    county: 'Butte',
    county_names_all: 'Butte|Tehama',
    county_weights: '{"06007": 61.67, "06103": 38.33}',
    density: 50.2,
    imprecise: false,
    latitude: 39.88099,
    longitude: -121.8516,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39031,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95973',
  },
  {
    city: 'Richvale',
    county_fips: 6007,
    county_fips_all: '06007',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"06007": 100}',
    density: 90.8,
    imprecise: false,
    latitude: 39.4973,
    longitude: -121.75569,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 98,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95974',
  },
  {
    city: 'Rough And Ready',
    county_fips: 6057,
    county_fips_all: '06057',
    county: 'Nevada',
    county_names_all: 'Nevada',
    county_weights: '{"06057": 100}',
    density: 44.5,
    imprecise: false,
    latitude: 39.22436,
    longitude: -121.15367,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1088,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95975',
  },
  {
    city: 'Smartsville',
    county_fips: 6115,
    county_fips_all: '06115|06057',
    county: 'Yuba',
    county_names_all: 'Yuba|Nevada',
    county_weights: '{"06115": 61.21, "06057": 38.79}',
    density: 18.2,
    imprecise: false,
    latitude: 39.17967,
    longitude: -121.29007,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95977',
  },
  {
    city: 'Stirling City',
    county_fips: 6007,
    county_fips_all: '06007',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"06007": 100}',
    density: 1475.2,
    imprecise: false,
    latitude: 39.90826,
    longitude: -121.52941,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95978',
  },
  {
    city: 'Stonyford',
    county_fips: 6011,
    county_fips_all: '06011',
    county: 'Colusa',
    county_names_all: 'Colusa',
    county_weights: '{"06011": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 39.29771,
    longitude: -122.47913,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95979',
  },
  {
    city: 'Strawberry Valley',
    county_fips: 6063,
    county_fips_all: '06063|06115',
    county: 'Plumas',
    county_names_all: 'Plumas|Yuba',
    county_weights: '{"06063": 76.17, "06115": 23.83}',
    density: 0.7,
    imprecise: false,
    latitude: 39.65237,
    longitude: -121.03447,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95981',
  },
  {
    city: 'Sutter',
    county_fips: 6101,
    county_fips_all: '06101',
    county: 'Sutter',
    county_names_all: 'Sutter',
    county_weights: '{"06101": 100}',
    density: 25.3,
    imprecise: false,
    latitude: 39.18051,
    longitude: -121.80746,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95982',
  },
  {
    city: 'Taylorsville',
    county_fips: 6063,
    county_fips_all: '06063',
    county: 'Plumas',
    county_names_all: 'Plumas',
    county_weights: '{"06063": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 40.05827,
    longitude: -120.73897,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95983',
  },
  {
    city: 'Twain',
    county_fips: 6063,
    county_fips_all: '06063',
    county: 'Plumas',
    county_names_all: 'Plumas',
    county_weights: '{"06063": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 39.99654,
    longitude: -121.11951,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95984',
  },
  {
    city: 'Washington',
    county_fips: 6057,
    county_fips_all: '06057',
    county: 'Nevada',
    county_names_all: 'Nevada',
    county_weights: '{"06057": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 39.36149,
    longitude: -120.7652,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95986',
  },
  {
    city: 'Williams',
    county_fips: 6011,
    county_fips_all: '06011',
    county: 'Colusa',
    county_names_all: 'Colusa',
    county_weights: '{"06011": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 39.10299,
    longitude: -122.2726,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95987',
  },
  {
    city: 'Willows',
    county_fips: 6021,
    county_fips_all: '06021',
    county: 'Glenn',
    county_names_all: 'Glenn',
    county_weights: '{"06021": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 39.49825,
    longitude: -122.28698,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8808,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95988',
  },
  {
    city: 'Yuba City',
    county_fips: 6101,
    county_fips_all: '06101',
    county: 'Sutter',
    county_names_all: 'Sutter',
    county_weights: '{"06101": 100}',
    density: 399.8,
    imprecise: false,
    latitude: 39.02205,
    longitude: -121.61317,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95991',
  },
  {
    city: 'Yuba City',
    county_fips: 6101,
    county_fips_all: '06101',
    county: 'Sutter',
    county_names_all: 'Sutter',
    county_weights: '{"06101": 100}',
    density: 178.9,
    imprecise: false,
    latitude: 39.08171,
    longitude: -121.68798,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95993',
  },
  {
    city: 'Redding',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 180.3,
    imprecise: false,
    latitude: 40.57731,
    longitude: -122.45443,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96001',
  },
  {
    city: 'Redding',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 426.7,
    imprecise: false,
    latitude: 40.5299,
    longitude: -122.31679,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96002',
  },
  {
    city: 'Redding',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 156,
    imprecise: false,
    latitude: 40.66664,
    longitude: -122.31564,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96003',
  },
  {
    city: 'Adin',
    county_fips: 6035,
    county_fips_all: '06035|06049',
    county: 'Lassen',
    county_names_all: 'Lassen|Modoc',
    county_weights: '{"06035": 63.88, "06049": 36.12}',
    density: 1,
    imprecise: false,
    latitude: 41.15575,
    longitude: -120.83952,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96006',
  },
  {
    city: 'Anderson',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 78.1,
    imprecise: false,
    latitude: 40.45507,
    longitude: -122.30468,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96007',
  },
  {
    city: 'Bella Vista',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 40.73559,
    longitude: -122.11091,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96008',
  },
  {
    city: 'Bieber',
    county_fips: 6035,
    county_fips_all: '06035',
    county: 'Lassen',
    county_names_all: 'Lassen',
    county_weights: '{"06035": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 41.06183,
    longitude: -121.04434,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96009',
  },
  {
    city: 'Big Bar',
    county_fips: 6105,
    county_fips_all: '06105',
    county: 'Trinity',
    county_names_all: 'Trinity',
    county_weights: '{"06105": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 40.89735,
    longitude: -123.24365,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96010',
  },
  {
    city: 'Big Bend',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 41.05762,
    longitude: -121.89157,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 75,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96011',
  },
  {
    city: 'Burney',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 40.97495,
    longitude: -121.68316,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3779,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96013',
  },
  {
    city: 'Callahan',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 41.3579,
    longitude: -122.77305,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96014',
  },
  {
    city: 'Canby',
    county_fips: 6049,
    county_fips_all: '06049',
    county: 'Modoc',
    county_names_all: 'Modoc',
    county_weights: '{"06049": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 41.49672,
    longitude: -120.87162,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96015',
  },
  {
    city: 'Cassel',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 40.90675,
    longitude: -121.52032,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96016',
  },
  {
    city: 'Castella',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 41.10776,
    longitude: -122.30751,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96017',
  },
  {
    city: 'Shasta Lake',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 206.9,
    imprecise: false,
    latitude: 40.68729,
    longitude: -122.39927,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96019',
  },
  {
    city: 'Chester',
    county_fips: 6063,
    county_fips_all: '06063|06089',
    county: 'Plumas',
    county_names_all: 'Plumas|Shasta',
    county_weights: '{"06063": 99.85, "06089": 0.15}',
    density: 15.2,
    imprecise: false,
    latitude: 40.30089,
    longitude: -121.26286,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96020',
  },
  {
    city: 'Corning',
    county_fips: 6103,
    county_fips_all: '06103',
    county: 'Tehama',
    county_names_all: 'Tehama',
    county_weights: '{"06103": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 39.91871,
    longitude: -122.26813,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14812,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96021',
  },
  {
    city: 'Cottonwood',
    county_fips: 6103,
    county_fips_all: '06103|06089',
    county: 'Tehama',
    county_names_all: 'Tehama|Shasta',
    county_weights: '{"06103": 68.77, "06089": 31.23}',
    density: 26.5,
    imprecise: false,
    latitude: 40.34232,
    longitude: -122.44814,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17092,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96022',
  },
  {
    city: 'Dorris',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 41.92108,
    longitude: -121.97592,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96023',
  },
  {
    city: 'Douglas City',
    county_fips: 6105,
    county_fips_all: '06105',
    county: 'Trinity',
    county_names_all: 'Trinity',
    county_weights: '{"06105": 100}',
    density: 4,
    imprecise: false,
    latitude: 40.58767,
    longitude: -122.90143,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96024',
  },
  {
    city: 'Dunsmuir',
    county_fips: 6093,
    county_fips_all: '06093|06089',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou|Shasta',
    county_weights: '{"06093": 72.25, "06089": 27.75}',
    density: 7.1,
    imprecise: false,
    latitude: 41.20409,
    longitude: -122.32523,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96025',
  },
  {
    city: 'Etna',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 41.36558,
    longitude: -123.07799,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96027',
  },
  {
    city: 'Fall River Mills',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 41.00761,
    longitude: -121.45731,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96028',
  },
  {
    city: 'Flournoy',
    county_fips: 6103,
    county_fips_all: '06103',
    county: 'Tehama',
    county_names_all: 'Tehama',
    county_weights: '{"06103": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 39.94003,
    longitude: -122.48743,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96029',
  },
  {
    city: 'Forks Of Salmon',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 41.17262,
    longitude: -123.18029,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96031',
  },
  {
    city: 'Fort Jones',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 41.58503,
    longitude: -122.98291,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96032',
  },
  {
    city: 'French Gulch',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 40.75076,
    longitude: -122.60004,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96033',
  },
  {
    city: 'Gazelle',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 41.44177,
    longitude: -122.60772,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 332,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96034',
  },
  {
    city: 'Gerber',
    county_fips: 6103,
    county_fips_all: '06103',
    county: 'Tehama',
    county_names_all: 'Tehama',
    county_weights: '{"06103": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 40.04168,
    longitude: -122.18254,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96035',
  },
  {
    city: 'Greenview',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 23.7,
    imprecise: false,
    latitude: 41.54368,
    longitude: -122.93177,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96037',
  },
  {
    city: 'Grenada',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 41.60827,
    longitude: -122.54576,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 504,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96038',
  },
  {
    city: 'Happy Camp',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 41.66376,
    longitude: -123.37711,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96039',
  },
  {
    city: 'Hat Creek',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 40.79393,
    longitude: -121.47397,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96040',
  },
  {
    city: 'Hayfork',
    county_fips: 6105,
    county_fips_all: '06105',
    county: 'Trinity',
    county_names_all: 'Trinity',
    county_weights: '{"06105": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 40.52059,
    longitude: -123.19991,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96041',
  },
  {
    city: 'Hornbrook',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 2,
    imprecise: false,
    latitude: 41.95384,
    longitude: -122.64853,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96044',
  },
  {
    city: 'Hyampom',
    county_fips: 6105,
    county_fips_all: '06105',
    county: 'Trinity',
    county_names_all: 'Trinity',
    county_weights: '{"06105": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 40.61118,
    longitude: -123.43151,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96046',
  },
  {
    city: 'Igo',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 40.47695,
    longitude: -122.69889,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96047',
  },
  {
    city: 'Junction City',
    county_fips: 6105,
    county_fips_all: '06105',
    county: 'Trinity',
    county_names_all: 'Trinity',
    county_weights: '{"06105": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 40.82613,
    longitude: -123.05594,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96048',
  },
  {
    city: 'Klamath River',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 41.85389,
    longitude: -122.95689,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96050',
  },
  {
    city: 'Lakehead',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 40.90112,
    longitude: -122.35664,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1070,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96051',
  },
  {
    city: 'Lewiston',
    county_fips: 6105,
    county_fips_all: '06105',
    county: 'Trinity',
    county_names_all: 'Trinity',
    county_weights: '{"06105": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 40.68515,
    longitude: -122.80342,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96052',
  },
  {
    city: 'Lookout',
    county_fips: 6049,
    county_fips_all: '06049',
    county: 'Modoc',
    county_names_all: 'Modoc',
    county_weights: '{"06049": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 41.26665,
    longitude: -121.10633,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96054',
  },
  {
    city: 'Los Molinos',
    county_fips: 6103,
    county_fips_all: '06103',
    county: 'Tehama',
    county_names_all: 'Tehama',
    county_weights: '{"06103": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 40.10249,
    longitude: -122.03213,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96055',
  },
  {
    city: 'Mcarthur',
    county_fips: 6035,
    county_fips_all: '06035|06089|06049',
    county: 'Lassen',
    county_names_all: 'Lassen|Shasta|Modoc',
    county_weights: '{"06035": 53.13, "06089": 33.18, "06049": 13.69}',
    density: 2.8,
    imprecise: false,
    latitude: 41.07178,
    longitude: -121.32607,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96056',
  },
  {
    city: 'Mccloud',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 41.26144,
    longitude: -122.0118,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96057',
  },
  {
    city: 'Macdoel',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 41.74536,
    longitude: -121.9337,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96058',
  },
  {
    city: 'Manton',
    county_fips: 6103,
    county_fips_all: '06103|06089',
    county: 'Tehama',
    county_names_all: 'Tehama|Shasta',
    county_weights: '{"06103": 51.8, "06089": 48.2}',
    density: 5,
    imprecise: false,
    latitude: 40.42947,
    longitude: -121.83465,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96059',
  },
  {
    city: 'Mill Creek',
    county_fips: 6103,
    county_fips_all: '06103',
    county: 'Tehama',
    county_names_all: 'Tehama',
    county_weights: '{"06103": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 40.34407,
    longitude: -121.48767,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 59,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96061',
  },
  {
    city: 'Millville',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 40.56373,
    longitude: -122.06646,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96062',
  },
  {
    city: 'Mineral',
    county_fips: 6103,
    county_fips_all: '06103',
    county: 'Tehama',
    county_names_all: 'Tehama',
    county_weights: '{"06103": 100}',
    density: 4,
    imprecise: false,
    latitude: 40.35708,
    longitude: -121.60236,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96063',
  },
  {
    city: 'Montague',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 41.76371,
    longitude: -122.36433,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96064',
  },
  {
    city: 'Montgomery Creek',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 40.88056,
    longitude: -121.95433,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96065',
  },
  {
    city: 'Mount Shasta',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 39.6,
    imprecise: false,
    latitude: 41.31664,
    longitude: -122.31736,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96067',
  },
  {
    city: 'Nubieber',
    county_fips: 6035,
    county_fips_all: '06035',
    county: 'Lassen',
    county_names_all: 'Lassen',
    county_weights: '{"06035": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 41.10525,
    longitude: -121.20455,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96068',
  },
  {
    city: 'Oak Run',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 40.68226,
    longitude: -122.02341,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96069',
  },
  {
    city: 'Old Station',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 40.68134,
    longitude: -121.45275,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96071',
  },
  {
    city: 'Palo Cedro',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 49.1,
    imprecise: false,
    latitude: 40.59047,
    longitude: -122.20537,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96073',
  },
  {
    city: 'Paskenta',
    county_fips: 6103,
    county_fips_all: '06103',
    county: 'Tehama',
    county_names_all: 'Tehama',
    county_weights: '{"06103": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 39.87196,
    longitude: -122.58599,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96074',
  },
  {
    city: 'Paynes Creek',
    county_fips: 6103,
    county_fips_all: '06103|06089',
    county: 'Tehama',
    county_names_all: 'Tehama|Shasta',
    county_weights: '{"06103": 91.09, "06089": 8.91}',
    density: 0.9,
    imprecise: false,
    latitude: 40.35582,
    longitude: -121.87196,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96075',
  },
  {
    city: 'Platina',
    county_fips: 6105,
    county_fips_all: '06105|06103|06089',
    county: 'Trinity',
    county_names_all: 'Trinity|Tehama|Shasta',
    county_weights: '{"06105": 38.76, "06103": 33.63, "06089": 27.61}',
    density: 0.3,
    imprecise: false,
    latitude: 40.37547,
    longitude: -122.92996,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96076',
  },
  {
    city: 'Proberta',
    county_fips: 6103,
    county_fips_all: '06103',
    county: 'Tehama',
    county_names_all: 'Tehama',
    county_weights: '{"06103": 100}',
    density: 1450.2,
    imprecise: false,
    latitude: 40.08245,
    longitude: -122.17607,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96078',
  },
  {
    city: 'Red Bluff',
    county_fips: 6103,
    county_fips_all: '06103',
    county: 'Tehama',
    county_names_all: 'Tehama',
    county_weights: '{"06103": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 40.16386,
    longitude: -122.39171,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31554,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96080',
  },
  {
    city: 'Round Mountain',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 40.79395,
    longitude: -121.91519,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96084',
  },
  {
    city: 'Scott Bar',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 41.73245,
    longitude: -123.05145,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96085',
  },
  {
    city: 'Seiad Valley',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 41.87407,
    longitude: -123.23012,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96086',
  },
  {
    city: 'Shasta',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 40.63296,
    longitude: -122.58067,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96087',
  },
  {
    city: 'Shingletown',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 40.50983,
    longitude: -121.88848,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96088',
  },
  {
    city: 'Tehama',
    county_fips: 6103,
    county_fips_all: '06103',
    county: 'Tehama',
    county_names_all: 'Tehama',
    county_weights: '{"06103": 100}',
    density: 46.2,
    imprecise: false,
    latitude: 40.00681,
    longitude: -122.12142,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96090',
  },
  {
    city: 'Trinity Center',
    county_fips: 6105,
    county_fips_all: '06105',
    county: 'Trinity',
    county_names_all: 'Trinity',
    county_weights: '{"06105": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 41.04567,
    longitude: -122.78053,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96091',
  },
  {
    city: 'Vina',
    county_fips: 6103,
    county_fips_all: '06103',
    county: 'Tehama',
    county_names_all: 'Tehama',
    county_weights: '{"06103": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 39.97344,
    longitude: -121.97342,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96092',
  },
  {
    city: 'Weaverville',
    county_fips: 6105,
    county_fips_all: '06105',
    county: 'Trinity',
    county_names_all: 'Trinity',
    county_weights: '{"06105": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 40.77237,
    longitude: -122.94329,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96093',
  },
  {
    city: 'Weed',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 41.51214,
    longitude: -122.36253,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96094',
  },
  {
    city: 'Whitmore',
    county_fips: 6089,
    county_fips_all: '06089',
    county: 'Shasta',
    county_names_all: 'Shasta',
    county_weights: '{"06089": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 40.63738,
    longitude: -121.87552,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96096',
  },
  {
    city: 'Yreka',
    county_fips: 6093,
    county_fips_all: '06093',
    county: 'Siskiyou',
    county_names_all: 'Siskiyou',
    county_weights: '{"06093": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 41.76234,
    longitude: -122.65921,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96097',
  },
  {
    city: 'Alturas',
    county_fips: 6049,
    county_fips_all: '06049',
    county: 'Modoc',
    county_names_all: 'Modoc',
    county_weights: '{"06049": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 41.45803,
    longitude: -120.5043,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5142,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96101',
  },
  {
    city: 'Blairsden Graeagle',
    county_fips: 6063,
    county_fips_all: '06063',
    county: 'Plumas',
    county_names_all: 'Plumas',
    county_weights: '{"06063": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 39.78446,
    longitude: -120.66969,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96103',
  },
  {
    city: 'Cedarville',
    county_fips: 6049,
    county_fips_all: '06049',
    county: 'Modoc',
    county_names_all: 'Modoc',
    county_weights: '{"06049": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 41.48248,
    longitude: -120.12725,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96104',
  },
  {
    city: 'Chilcoot',
    county_fips: 6063,
    county_fips_all: '06063|06091|06035',
    county: 'Plumas',
    county_names_all: 'Plumas|Sierra|Lassen',
    county_weights: '{"06063": 59.92, "06091": 26.19, "06035": 13.89}',
    density: 1.2,
    imprecise: false,
    latitude: 39.82478,
    longitude: -120.1821,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96105',
  },
  {
    city: 'Clio',
    county_fips: 6063,
    county_fips_all: '06063',
    county: 'Plumas',
    county_names_all: 'Plumas',
    county_weights: '{"06063": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 39.73552,
    longitude: -120.54388,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96106',
  },
  {
    city: 'Coleville',
    county_fips: 6051,
    county_fips_all: '06051',
    county: 'Mono',
    county_names_all: 'Mono',
    county_weights: '{"06051": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 38.45215,
    longitude: -119.51421,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96107',
  },
  {
    city: 'Davis Creek',
    county_fips: 6049,
    county_fips_all: '06049',
    county: 'Modoc',
    county_names_all: 'Modoc',
    county_weights: '{"06049": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 41.77687,
    longitude: -120.42351,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96108',
  },
  {
    city: 'Doyle',
    county_fips: 6035,
    county_fips_all: '06035',
    county: 'Lassen',
    county_names_all: 'Lassen',
    county_weights: '{"06035": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 39.99747,
    longitude: -120.09521,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96109',
  },
  {
    city: 'Eagleville',
    county_fips: 6049,
    county_fips_all: '06049|06035',
    county: 'Modoc',
    county_names_all: 'Modoc|Lassen',
    county_weights: '{"06049": 96.22, "06035": 3.78}',
    density: 0.2,
    imprecise: false,
    latitude: 41.26637,
    longitude: -120.10763,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96110',
  },
  {
    city: 'Floriston',
    county_fips: 6057,
    county_fips_all: '06057',
    county: 'Nevada',
    county_names_all: 'Nevada',
    county_weights: '{"06057": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 39.41571,
    longitude: -120.01648,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96111',
  },
  {
    city: 'Fort Bidwell',
    county_fips: 6049,
    county_fips_all: '06049',
    county: 'Modoc',
    county_names_all: 'Modoc',
    county_weights: '{"06049": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 41.8372,
    longitude: -120.09403,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 193,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96112',
  },
  {
    city: 'Herlong',
    county_fips: 6035,
    county_fips_all: '06035',
    county: 'Lassen',
    county_names_all: 'Lassen',
    county_weights: '{"06035": 100}',
    density: 36,
    imprecise: false,
    latitude: 40.18577,
    longitude: -120.14609,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96113',
  },
  {
    city: 'Janesville',
    county_fips: 6035,
    county_fips_all: '06035',
    county: 'Lassen',
    county_names_all: 'Lassen',
    county_weights: '{"06035": 100}',
    density: 17.4,
    imprecise: false,
    latitude: 40.2945,
    longitude: -120.49359,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96114',
  },
  {
    city: 'Lake City',
    county_fips: 6049,
    county_fips_all: '06049',
    county: 'Modoc',
    county_names_all: 'Modoc',
    county_weights: '{"06049": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 41.70753,
    longitude: -120.14047,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96115',
  },
  {
    city: 'Likely',
    county_fips: 6049,
    county_fips_all: '06049',
    county: 'Modoc',
    county_names_all: 'Modoc',
    county_weights: '{"06049": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 41.2603,
    longitude: -120.44841,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96116',
  },
  {
    city: 'Litchfield',
    county_fips: 6035,
    county_fips_all: '06035',
    county: 'Lassen',
    county_names_all: 'Lassen',
    county_weights: '{"06035": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 40.54556,
    longitude: -120.23978,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96117',
  },
  {
    city: 'Loyalton',
    county_fips: 6091,
    county_fips_all: '06091|06063',
    county: 'Sierra',
    county_names_all: 'Sierra|Plumas',
    county_weights: '{"06091": 82.59, "06063": 17.41}',
    density: 3,
    imprecise: false,
    latitude: 39.64823,
    longitude: -120.25392,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96118',
  },
  {
    city: 'Madeline',
    county_fips: 6035,
    county_fips_all: '06035',
    county: 'Lassen',
    county_names_all: 'Lassen',
    county_weights: '{"06035": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.03353,
    longitude: -120.55264,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96119',
  },
  {
    city: 'Markleeville',
    county_fips: 6003,
    county_fips_all: '06003',
    county: 'Alpine',
    county_names_all: 'Alpine',
    county_weights: '{"06003": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 38.745,
    longitude: -119.82485,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96120',
  },
  {
    city: 'Milford',
    county_fips: 6035,
    county_fips_all: '06035',
    county: 'Lassen',
    county_names_all: 'Lassen',
    county_weights: '{"06035": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 40.16938,
    longitude: -120.37659,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96121',
  },
  {
    city: 'Portola',
    county_fips: 6063,
    county_fips_all: '06063',
    county: 'Plumas',
    county_names_all: 'Plumas',
    county_weights: '{"06063": 100}',
    density: 26.8,
    imprecise: false,
    latitude: 39.82082,
    longitude: -120.47652,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96122',
  },
  {
    city: 'Ravendale',
    county_fips: 6035,
    county_fips_all: '06035',
    county: 'Lassen',
    county_names_all: 'Lassen',
    county_weights: '{"06035": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 40.80392,
    longitude: -120.30799,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96123',
  },
  {
    city: 'Calpine',
    county_fips: 6091,
    county_fips_all: '06091',
    county: 'Sierra',
    county_names_all: 'Sierra',
    county_weights: '{"06091": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 39.63918,
    longitude: -120.46194,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96124',
  },
  {
    city: 'Sierra City',
    county_fips: 6091,
    county_fips_all: '06091',
    county: 'Sierra',
    county_names_all: 'Sierra',
    county_weights: '{"06091": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 39.61526,
    longitude: -120.60493,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 263,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96125',
  },
  {
    city: 'Sierraville',
    county_fips: 6091,
    county_fips_all: '06091',
    county: 'Sierra',
    county_names_all: 'Sierra',
    county_weights: '{"06091": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 39.54764,
    longitude: -120.38999,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96126',
  },
  {
    city: 'Standish',
    county_fips: 6035,
    county_fips_all: '06035',
    county: 'Lassen',
    county_names_all: 'Lassen',
    county_weights: '{"06035": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 40.34948,
    longitude: -120.40198,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96128',
  },
  {
    city: 'Susanville',
    county_fips: 6035,
    county_fips_all: '06035',
    county: 'Lassen',
    county_names_all: 'Lassen',
    county_weights: '{"06035": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 40.54992,
    longitude: -120.63064,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96130',
  },
  {
    city: 'Termo',
    county_fips: 6035,
    county_fips_all: '06035',
    county: 'Lassen',
    county_names_all: 'Lassen',
    county_weights: '{"06035": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 40.89371,
    longitude: -120.5389,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96132',
  },
  {
    city: 'Topaz',
    county_fips: 6051,
    county_fips_all: '06051',
    county: 'Mono',
    county_names_all: 'Mono',
    county_weights: '{"06051": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 38.63181,
    longitude: -119.50423,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96133',
  },
  {
    city: 'Tulelake',
    county_fips: 6049,
    county_fips_all: '06049|06093',
    county: 'Modoc',
    county_names_all: 'Modoc|Siskiyou',
    county_weights: '{"06049": 62.93, "06093": 37.07}',
    density: 2.7,
    imprecise: false,
    latitude: 41.8444,
    longitude: -121.41231,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96134',
  },
  {
    city: 'Vinton',
    county_fips: 6063,
    county_fips_all: '06063',
    county: 'Plumas',
    county_names_all: 'Plumas',
    county_weights: '{"06063": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.81303,
    longitude: -120.20927,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96135',
  },
  {
    city: 'Wendel',
    county_fips: 6035,
    county_fips_all: '06035',
    county: 'Lassen',
    county_names_all: 'Lassen',
    county_weights: '{"06035": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 40.31263,
    longitude: -120.12425,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96136',
  },
  {
    city: 'Westwood',
    county_fips: 6035,
    county_fips_all: '06035|06063',
    county: 'Lassen',
    county_names_all: 'Lassen|Plumas',
    county_weights: '{"06035": 59.78, "06063": 40.22}',
    density: 7.9,
    imprecise: false,
    latitude: 40.38554,
    longitude: -121.12478,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2923,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96137',
  },
  {
    city: 'Carnelian Bay',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 43.7,
    imprecise: false,
    latitude: 39.23244,
    longitude: -120.10364,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96140',
  },
  {
    city: 'Homewood',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 39.10297,
    longitude: -120.19872,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96141',
  },
  {
    city: 'Tahoma',
    county_fips: 6017,
    county_fips_all: '06017|06061',
    county: 'El Dorado',
    county_names_all: 'El Dorado|Placer',
    county_weights: '{"06017": 99.15, "06061": 0.85}',
    density: 17.5,
    imprecise: false,
    latitude: 39.0138,
    longitude: -120.09592,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96142',
  },
  {
    city: 'Kings Beach',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 134.8,
    imprecise: false,
    latitude: 39.26174,
    longitude: -120.02817,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96143',
  },
  {
    city: 'Tahoe City',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 75,
    imprecise: false,
    latitude: 39.18203,
    longitude: -120.15143,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96145',
  },
  {
    city: 'Olympic Valley',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 11,
    imprecise: false,
    latitude: 39.22556,
    longitude: -120.23681,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96146',
  },
  {
    city: 'Tahoe Vista',
    county_fips: 6061,
    county_fips_all: '06061',
    county: 'Placer',
    county_names_all: 'Placer',
    county_weights: '{"06061": 100}',
    density: 103.9,
    imprecise: false,
    latitude: 39.24978,
    longitude: -120.05767,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96148',
  },
  {
    city: 'South Lake Tahoe',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 70.1,
    imprecise: false,
    latitude: 38.88971,
    longitude: -120.04409,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96150',
  },
  {
    city: 'South Lake Tahoe',
    county_fips: 6017,
    county_fips_all: '06017',
    county: 'El Dorado',
    county_names_all: 'El Dorado',
    county_weights: '{"06017": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.75294,
    longitude: -120.09222,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96155',
  },
  {
    city: 'Truckee',
    county_fips: 6057,
    county_fips_all: '06057|06061',
    county: 'Nevada',
    county_names_all: 'Nevada|Placer',
    county_weights: '{"06057": 70.01, "06061": 29.99}',
    density: 28.9,
    imprecise: false,
    latitude: 39.34848,
    longitude: -120.22603,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96161',
  },
  {
    city: 'Aiea',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 598.9,
    imprecise: false,
    latitude: 21.40368,
    longitude: -157.89875,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 39200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96701',
  },
  {
    city: 'Anahola',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 40.1,
    imprecise: false,
    latitude: 22.1349,
    longitude: -159.37152,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 3366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96703',
  },
  {
    city: 'Captain Cook',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 11.4,
    imprecise: false,
    latitude: 19.30612,
    longitude: -155.83884,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 7261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96704',
  },
  {
    city: 'Eleele',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 289.2,
    imprecise: false,
    latitude: 21.89973,
    longitude: -159.56252,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 2522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96705',
  },
  {
    city: 'Ewa Beach',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 1893.5,
    imprecise: false,
    latitude: 21.34033,
    longitude: -158.01704,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 83692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96706',
  },
  {
    city: 'Kapolei',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 434.1,
    imprecise: false,
    latitude: 21.36455,
    longitude: -158.08141,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 48807,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96707',
  },
  {
    city: 'Haiku',
    county_fips: 15009,
    county_fips_all: '15009',
    county: 'Maui',
    county_names_all: 'Maui',
    county_weights: '{"15009": 100}',
    density: 72.3,
    imprecise: false,
    latitude: 20.88083,
    longitude: -156.23763,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 11152,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96708',
  },
  {
    city: 'Hakalau',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 19.85516,
    longitude: -155.21784,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96710',
  },
  {
    city: 'Haleiwa',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 75,
    imprecise: false,
    latitude: 21.626,
    longitude: -158.03534,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 8204,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96712',
  },
  {
    city: 'Hana',
    county_fips: 15009,
    county_fips_all: '15009',
    county: 'Maui',
    county_names_all: 'Maui',
    county_weights: '{"15009": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 20.73684,
    longitude: -156.1159,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 1023,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96713',
  },
  {
    city: 'Hanalei',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 22.15734,
    longitude: -159.54472,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 1592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96714',
  },
  {
    city: 'Hanapepe',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 263.7,
    imprecise: false,
    latitude: 21.91167,
    longitude: -159.60134,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 2650,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96716',
  },
  {
    city: 'Hauula',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 71.5,
    imprecise: false,
    latitude: 21.55556,
    longitude: -157.89605,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 4580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96717',
  },
  {
    city: 'Hawi',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 130.7,
    imprecise: false,
    latitude: 20.24005,
    longitude: -155.83344,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 1974,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96719',
  },
  {
    city: 'Hilo',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 71.1,
    imprecise: false,
    latitude: 19.67022,
    longitude: -155.21718,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 52979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96720',
  },
  {
    city: 'Princeville',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 56.6,
    imprecise: false,
    latitude: 22.16689,
    longitude: -159.45826,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 2377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96722',
  },
  {
    city: 'Holualoa',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 20.1,
    imprecise: false,
    latitude: 19.61243,
    longitude: -155.8824,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 5009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96725',
  },
  {
    city: 'Honaunau',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 2,
    imprecise: false,
    latitude: 19.42147,
    longitude: -155.81094,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96726',
  },
  {
    city: 'Honokaa',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 20.00803,
    longitude: -155.54842,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 4577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96727',
  },
  {
    city: 'Honomu',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 34.9,
    imprecise: false,
    latitude: 19.85991,
    longitude: -155.13339,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96728',
  },
  {
    city: 'Hoolehua',
    county_fips: 15009,
    county_fips_all: '15009',
    county: 'Maui',
    county_names_all: 'Maui',
    county_weights: '{"15009": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 21.17214,
    longitude: -157.11722,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 1670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96729',
  },
  {
    city: 'Kaaawa',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 537.8,
    imprecise: false,
    latitude: 21.54615,
    longitude: -157.85112,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 1478,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96730',
  },
  {
    city: 'Kahuku',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 110.6,
    imprecise: false,
    latitude: 21.68488,
    longitude: -157.96999,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 2782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96731',
  },
  {
    city: 'Kahului',
    county_fips: 15009,
    county_fips_all: '15009',
    county: 'Maui',
    county_names_all: 'Maui',
    county_weights: '{"15009": 100}',
    density: 892.6,
    imprecise: false,
    latitude: 20.87593,
    longitude: -156.46092,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 27444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96732',
  },
  {
    city: 'Kailua',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 900.4,
    imprecise: false,
    latitude: 21.39002,
    longitude: -157.75387,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 50670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96734',
  },
  {
    city: 'Ocean View',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 36.8,
    imprecise: false,
    latitude: 19.10735,
    longitude: -155.78062,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 4380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96737',
  },
  {
    city: 'Waikoloa',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 38,
    imprecise: false,
    latitude: 19.90341,
    longitude: -155.79392,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 7862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96738',
  },
  {
    city: 'Kailua Kona',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 62.7,
    imprecise: false,
    latitude: 19.74422,
    longitude: -155.89951,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 39338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96740',
  },
  {
    city: 'Kalaheo',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 74.9,
    imprecise: false,
    latitude: 21.94986,
    longitude: -159.51847,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 6183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96741',
  },
  {
    city: 'Kalaupapa',
    county_fips: 15005,
    county_fips_all: '15005',
    county: 'Kalawao',
    county_names_all: 'Kalawao',
    county_weights: '{"15005": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 21.17089,
    longitude: -156.94753,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 67,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96742',
  },
  {
    city: 'Kamuela',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 16.4,
    imprecise: false,
    latitude: 20.02619,
    longitude: -155.72266,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 12422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96743',
  },
  {
    city: 'Kaneohe',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 658.8,
    imprecise: false,
    latitude: 21.4427,
    longitude: -157.83328,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 57620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96744',
  },
  {
    city: 'Kapaa',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 250.2,
    imprecise: false,
    latitude: 22.09167,
    longitude: -159.34951,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 19329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96746',
  },
  {
    city: 'Kaumakani',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 708.1,
    imprecise: false,
    latitude: 21.9169,
    longitude: -159.62788,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 1012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96747',
  },
  {
    city: 'Kaunakakai',
    county_fips: 15009,
    county_fips_all: '15009',
    county: 'Maui',
    county_names_all: 'Maui',
    county_weights: '{"15009": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 21.1138,
    longitude: -156.8794,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 5609,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96748',
  },
  {
    city: 'Keaau',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 123.6,
    imprecise: false,
    latitude: 19.61031,
    longitude: -155.00281,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 19132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96749',
  },
  {
    city: 'Kealakekua',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 62.5,
    imprecise: false,
    latitude: 19.52404,
    longitude: -155.91463,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 3203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96750',
  },
  {
    city: 'Kekaha',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 34.5,
    imprecise: false,
    latitude: 22.07823,
    longitude: -159.72077,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 3809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96752',
  },
  {
    city: 'Kihei',
    county_fips: 15009,
    county_fips_all: '15009',
    county: 'Maui',
    county_names_all: 'Maui',
    county_weights: '{"15009": 100}',
    density: 297.3,
    imprecise: false,
    latitude: 20.7317,
    longitude: -156.43606,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 28003,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96753',
  },
  {
    city: 'Kilauea',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 55.6,
    imprecise: false,
    latitude: 22.18537,
    longitude: -159.40246,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 4272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96754',
  },
  {
    city: 'Kapaau',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 25,
    imprecise: false,
    latitude: 20.19602,
    longitude: -155.78158,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 3677,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96755',
  },
  {
    city: 'Koloa',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 102.2,
    imprecise: false,
    latitude: 21.9085,
    longitude: -159.45368,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 6448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96756',
  },
  {
    city: 'Kualapuu',
    county_fips: 15009,
    county_fips_all: '15009',
    county: 'Maui',
    county_names_all: 'Maui',
    county_weights: '{"15009": 100}',
    density: 22,
    imprecise: false,
    latitude: 21.15536,
    longitude: -156.99513,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96757',
  },
  {
    city: 'Kunia',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 0,
    imprecise: false,
    latitude: 21.46015,
    longitude: -158.05995,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96759',
  },
  {
    city: 'Kurtistown',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 82.3,
    imprecise: false,
    latitude: 19.55234,
    longitude: -155.05483,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 4261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96760',
  },
  {
    city: 'Lahaina',
    county_fips: 15009,
    county_fips_all: '15009',
    county: 'Maui',
    county_names_all: 'Maui',
    county_weights: '{"15009": 100}',
    density: 84.9,
    imprecise: false,
    latitude: 20.90961,
    longitude: -156.62226,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 20952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96761',
  },
  {
    city: 'Laie',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 177.9,
    imprecise: false,
    latitude: 21.62468,
    longitude: -157.94201,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 5710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96762',
  },
  {
    city: 'Lanai City',
    county_fips: 15009,
    county_fips_all: '15009',
    county: 'Maui',
    county_names_all: 'Maui',
    county_weights: '{"15009": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 20.83512,
    longitude: -156.92717,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 3443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96763',
  },
  {
    city: 'Laupahoehoe',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 82.1,
    imprecise: false,
    latitude: 19.97766,
    longitude: -155.23985,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96764',
  },
  {
    city: 'Lawai',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 311.5,
    imprecise: false,
    latitude: 21.92608,
    longitude: -159.49831,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96765',
  },
  {
    city: 'Lihue',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 72.2,
    imprecise: false,
    latitude: 22.00556,
    longitude: -159.41931,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 17526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96766',
  },
  {
    city: 'Makawao',
    county_fips: 15009,
    county_fips_all: '15009',
    county: 'Maui',
    county_names_all: 'Maui',
    county_weights: '{"15009": 100}',
    density: 165.6,
    imprecise: false,
    latitude: 20.83231,
    longitude: -156.29787,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 18569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96768',
  },
  {
    city: 'Makaweli',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 21.95501,
    longitude: -159.61655,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96769',
  },
  {
    city: 'Maunaloa',
    county_fips: 15009,
    county_fips_all: '15009',
    county: 'Maui',
    county_names_all: 'Maui',
    county_weights: '{"15009": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 21.13465,
    longitude: -157.20354,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96770',
  },
  {
    city: 'Mountain View',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 39.2,
    imprecise: false,
    latitude: 19.53348,
    longitude: -155.13573,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 7793,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96771',
  },
  {
    city: 'Naalehu',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 19.0683,
    longitude: -155.66077,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 2470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96772',
  },
  {
    city: 'Ninole',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 19.90677,
    longitude: -155.25218,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 95,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96773',
  },
  {
    city: 'Ookala',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 19.96871,
    longitude: -155.31503,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96774',
  },
  {
    city: 'Paauilo',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 20.00156,
    longitude: -155.38777,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 1355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96776',
  },
  {
    city: 'Pahala',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 19.23137,
    longitude: -155.4705,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 1822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96777',
  },
  {
    city: 'Pahoa',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 27.9,
    imprecise: false,
    latitude: 19.45221,
    longitude: -154.98624,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 15262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96778',
  },
  {
    city: 'Paia',
    county_fips: 15009,
    county_fips_all: '15009',
    county: 'Maui',
    county_names_all: 'Maui',
    county_weights: '{"15009": 100}',
    density: 92.2,
    imprecise: false,
    latitude: 20.90534,
    longitude: -156.38208,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 2780,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96779',
  },
  {
    city: 'Papaaloa',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 87.2,
    imprecise: false,
    latitude: 19.96592,
    longitude: -155.225,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 400,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96780',
  },
  {
    city: 'Papaikou',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 19.80066,
    longitude: -155.18194,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 2073,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96781',
  },
  {
    city: 'Pearl City',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 491.4,
    imprecise: false,
    latitude: 21.43471,
    longitude: -157.94694,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 37475,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96782',
  },
  {
    city: 'Pepeekeo',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 104.7,
    imprecise: false,
    latitude: 19.84293,
    longitude: -155.1074,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 2251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96783',
  },
  {
    city: 'Volcano',
    county_fips: 15001,
    county_fips_all: '15001',
    county: 'Hawaii',
    county_names_all: 'Hawaii',
    county_weights: '{"15001": 100}',
    density: 23.4,
    imprecise: false,
    latitude: 19.47818,
    longitude: -155.23017,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 4433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96785',
  },
  {
    city: 'Wahiawa',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 176,
    imprecise: false,
    latitude: 21.53733,
    longitude: -158.02331,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 40658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96786',
  },
  {
    city: 'Mililani',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 794.8,
    imprecise: false,
    latitude: 21.47823,
    longitude: -157.97264,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 54278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96789',
  },
  {
    city: 'Kula',
    county_fips: 15009,
    county_fips_all: '15009',
    county: 'Maui',
    county_names_all: 'Maui',
    county_weights: '{"15009": 100}',
    density: 18.6,
    imprecise: false,
    latitude: 20.6975,
    longitude: -156.31121,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 9756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96790',
  },
  {
    city: 'Waialua',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 67.4,
    imprecise: false,
    latitude: 21.55072,
    longitude: -158.15857,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 6377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96791',
  },
  {
    city: 'Waianae',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 313.8,
    imprecise: false,
    latitude: 21.46311,
    longitude: -158.16418,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 49618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96792',
  },
  {
    city: 'Wailuku',
    county_fips: 15009,
    county_fips_all: '15009',
    county: 'Maui',
    county_names_all: 'Maui',
    county_weights: '{"15009": 100}',
    density: 166.1,
    imprecise: false,
    latitude: 20.88998,
    longitude: -156.53215,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 32739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96793',
  },
  {
    city: 'Waimanalo',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 359.4,
    imprecise: false,
    latitude: 21.33934,
    longitude: -157.71643,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 10675,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96795',
  },
  {
    city: 'Waimea',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 380.2,
    imprecise: false,
    latitude: 21.96512,
    longitude: -159.66793,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 1840,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96796',
  },
  {
    city: 'Waipahu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 1452,
    imprecise: false,
    latitude: 21.40734,
    longitude: -158.01658,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 72435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96797',
  },
  {
    city: 'Pago Pago',
    county_fips: 60050,
    county_fips_all: '60050|60010|60020|60040',
    county: 'Western',
    county_names_all: "Western|Eastern|Manu'a|Swains Island",
    county_weights:
      '{"60050": 36.49, "60010": 32.58, "60020": 29.15, "60040": 1.78}',
    density: null,
    imprecise: false,
    latitude: -14.21984,
    longitude: -170.37005,
    militaryZip: false,
    timezone: 'Pacific/Pago_Pago',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AS',
    stateName: 'American Samoa',
    zip: '96799',
  },
  {
    city: 'Honolulu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 2908.6,
    imprecise: false,
    latitude: 21.31628,
    longitude: -157.84359,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 26766,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96813',
  },
  {
    city: 'Honolulu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 7821.9,
    imprecise: false,
    latitude: 21.29405,
    longitude: -157.84637,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 24689,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96814',
  },
  {
    city: 'Honolulu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 4836.7,
    imprecise: false,
    latitude: 21.27375,
    longitude: -157.82108,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 27530,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96815',
  },
  {
    city: 'Honolulu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 2053.5,
    imprecise: false,
    latitude: 21.29379,
    longitude: -157.79009,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 50883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96816',
  },
  {
    city: 'Honolulu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 2303.5,
    imprecise: false,
    latitude: 21.34016,
    longitude: -157.83749,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 55492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96817',
  },
  {
    city: 'Honolulu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 1961.2,
    imprecise: false,
    latitude: 21.34637,
    longitude: -157.93704,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 54822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96818',
  },
  {
    city: 'Honolulu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 889.7,
    imprecise: false,
    latitude: 21.34968,
    longitude: -157.87527,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 50345,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96819',
  },
  {
    city: 'Honolulu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 0,
    imprecise: false,
    latitude: 21.33633,
    longitude: -157.92071,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96820',
  },
  {
    city: 'Honolulu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 669.2,
    imprecise: false,
    latitude: 21.29952,
    longitude: -157.75004,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 20053,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96821',
  },
  {
    city: 'Honolulu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 2102.8,
    imprecise: false,
    latitude: 21.32046,
    longitude: -157.81037,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 43747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96822',
  },
  {
    city: 'Honolulu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 1096.2,
    imprecise: false,
    latitude: 21.29575,
    longitude: -157.69234,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 30913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96825',
  },
  {
    city: 'Honolulu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 10501.1,
    imprecise: false,
    latitude: 21.29171,
    longitude: -157.82698,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 29174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96826',
  },
  {
    city: 'Honolulu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 0,
    imprecise: false,
    latitude: 21.30385,
    longitude: -157.86258,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96850',
  },
  {
    city: 'Hagatna',
    county_fips: 66010,
    county_fips_all: '66010',
    county: 'Guam',
    county_names_all: 'Guam',
    county_weights: '{"66010": 100}',
    density: null,
    imprecise: false,
    latitude: 13.45472,
    longitude: 144.75128,
    militaryZip: false,
    timezone: 'Pacific/Guam',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GU',
    stateName: 'Guam',
    zip: '96910',
  },
  {
    city: 'Barrigada',
    county_fips: 66010,
    county_fips_all: '66010',
    county: 'Guam',
    county_names_all: 'Guam',
    county_weights: '{"66010": 100}',
    density: null,
    imprecise: false,
    latitude: 13.47825,
    longitude: 144.81519,
    militaryZip: false,
    timezone: 'Pacific/Guam',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GU',
    stateName: 'Guam',
    zip: '96913',
  },
  {
    city: 'Santa Rita',
    county_fips: 66010,
    county_fips_all: '66010',
    county: 'Guam',
    county_names_all: 'Guam',
    county_weights: '{"66010": 100}',
    density: null,
    imprecise: false,
    latitude: 13.37526,
    longitude: 144.70714,
    militaryZip: false,
    timezone: 'Pacific/Guam',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GU',
    stateName: 'Guam',
    zip: '96915',
  },
  {
    city: 'Merizo',
    county_fips: 66010,
    county_fips_all: '66010',
    county: 'Guam',
    county_names_all: 'Guam',
    county_weights: '{"66010": 100}',
    density: null,
    imprecise: false,
    latitude: 13.26593,
    longitude: 144.68915,
    militaryZip: false,
    timezone: 'Pacific/Guam',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GU',
    stateName: 'Guam',
    zip: '96916',
  },
  {
    city: 'Inarajan',
    county_fips: 66010,
    county_fips_all: '66010',
    county: 'Guam',
    county_names_all: 'Guam',
    county_weights: '{"66010": 100}',
    density: null,
    imprecise: false,
    latitude: 13.28469,
    longitude: 144.73991,
    militaryZip: false,
    timezone: 'Pacific/Guam',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GU',
    stateName: 'Guam',
    zip: '96917',
  },
  {
    city: 'Agat',
    county_fips: 66010,
    county_fips_all: '66010',
    county: 'Guam',
    county_names_all: 'Guam',
    county_weights: '{"66010": 100}',
    density: null,
    imprecise: false,
    latitude: 13.35626,
    longitude: 144.65731,
    militaryZip: false,
    timezone: 'Pacific/Guam',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GU',
    stateName: 'Guam',
    zip: '96928',
  },
  {
    city: 'Yigo',
    county_fips: 66010,
    county_fips_all: '66010',
    county: 'Guam',
    county_names_all: 'Guam',
    county_weights: '{"66010": 100}',
    density: null,
    imprecise: false,
    latitude: 13.56521,
    longitude: 144.87637,
    militaryZip: false,
    timezone: 'Pacific/Guam',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GU',
    stateName: 'Guam',
    zip: '96929',
  },
  {
    city: 'Saipan',
    county_fips: 69110,
    county_fips_all: '69110',
    county: 'Saipan',
    county_names_all: 'Saipan',
    county_weights: '{"69110": 100}',
    density: null,
    imprecise: false,
    latitude: 15.18888,
    longitude: 145.75349,
    militaryZip: false,
    timezone: 'Pacific/Saipan',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MP',
    stateName: 'Northern Mariana Islands',
    zip: '96950',
  },
  {
    city: 'Rota',
    county_fips: 69100,
    county_fips_all: '69100',
    county: 'Rota',
    county_names_all: 'Rota',
    county_weights: '{"69100": 100}',
    density: null,
    imprecise: false,
    latitude: 14.15733,
    longitude: 145.2145,
    militaryZip: false,
    timezone: 'Pacific/Saipan',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MP',
    stateName: 'Northern Mariana Islands',
    zip: '96951',
  },
  {
    city: 'Tinian',
    county_fips: 69120,
    county_fips_all: '69120',
    county: 'Tinian',
    county_names_all: 'Tinian',
    county_weights: '{"69120": 100}',
    density: null,
    imprecise: false,
    latitude: 15.01311,
    longitude: 145.63149,
    militaryZip: false,
    timezone: 'Pacific/Saipan',
    population: null,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MP',
    stateName: 'Northern Mariana Islands',
    zip: '96952',
  },
  {
    city: 'Antelope',
    county_fips: 41065,
    county_fips_all: '41065',
    county: 'Wasco',
    county_names_all: 'Wasco',
    county_weights: '{"41065": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 44.93328,
    longitude: -120.64169,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97001',
  },
  {
    city: 'Aurora',
    county_fips: 41047,
    county_fips_all: '41047|41005',
    county: 'Marion',
    county_names_all: 'Marion|Clackamas',
    county_weights: '{"41047": 70.85, "41005": 29.15}',
    density: 59.2,
    imprecise: false,
    latitude: 45.23774,
    longitude: -122.8003,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6358,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97002',
  },
  {
    city: 'Beaverton',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 2280.4,
    imprecise: false,
    latitude: 45.50372,
    longitude: -122.86482,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97003',
  },
  {
    city: 'Beavercreek',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 40.2,
    imprecise: false,
    latitude: 45.25068,
    longitude: -122.45399,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97004',
  },
  {
    city: 'Beaverton',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 2132.8,
    imprecise: false,
    latitude: 45.49144,
    longitude: -122.80397,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97005',
  },
  {
    city: 'Beaverton',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 2479.7,
    imprecise: false,
    latitude: 45.52598,
    longitude: -122.85591,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97006',
  },
  {
    city: 'Beaverton',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 990.3,
    imprecise: false,
    latitude: 45.44282,
    longitude: -122.87112,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97007',
  },
  {
    city: 'Beaverton',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 2085,
    imprecise: false,
    latitude: 45.46044,
    longitude: -122.80252,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97008',
  },
  {
    city: 'Boring',
    county_fips: 41005,
    county_fips_all: '41005|41051',
    county: 'Clackamas',
    county_names_all: 'Clackamas|Multnomah',
    county_weights: '{"41005": 97.14, "41051": 2.86}',
    density: 104.8,
    imprecise: false,
    latitude: 45.42409,
    longitude: -122.33962,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97009',
  },
  {
    city: 'Brightwood',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 52.3,
    imprecise: false,
    latitude: 45.38738,
    longitude: -122.03671,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97011',
  },
  {
    city: 'Canby',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 159.1,
    imprecise: false,
    latitude: 45.21799,
    longitude: -122.67277,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97013',
  },
  {
    city: 'Cascade Locks',
    county_fips: 41027,
    county_fips_all: '41027|41051',
    county: 'Hood River',
    county_names_all: 'Hood River|Multnomah',
    county_weights: '{"41027": 66.24, "41051": 33.76}',
    density: 3.9,
    imprecise: false,
    latitude: 45.61354,
    longitude: -121.87405,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1459,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97014',
  },
  {
    city: 'Clackamas',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 1068.2,
    imprecise: false,
    latitude: 45.41477,
    longitude: -122.53767,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97015',
  },
  {
    city: 'Clatskanie',
    county_fips: 41009,
    county_fips_all: '41009|41007',
    county: 'Columbia',
    county_names_all: 'Columbia|Clatsop',
    county_weights: '{"41009": 76.0, "41007": 24.0}',
    density: 11,
    imprecise: false,
    latitude: 46.05573,
    longitude: -123.27032,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97016',
  },
  {
    city: 'Colton',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 45.17017,
    longitude: -122.37676,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97017',
  },
  {
    city: 'Columbia City',
    county_fips: 41009,
    county_fips_all: '41009',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"41009": 100}',
    density: 940,
    imprecise: false,
    latitude: 45.8957,
    longitude: -122.81165,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97018',
  },
  {
    city: 'Corbett',
    county_fips: 41051,
    county_fips_all: '41051|41005',
    county: 'Multnomah',
    county_names_all: 'Multnomah|Clackamas',
    county_weights: '{"41051": 72.33, "41005": 27.67}',
    density: 15.8,
    imprecise: false,
    latitude: 45.494,
    longitude: -122.18885,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97019',
  },
  {
    city: 'Donald',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 1553.7,
    imprecise: false,
    latitude: 45.22267,
    longitude: -122.83887,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1133,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97020',
  },
  {
    city: 'Dufur',
    county_fips: 41065,
    county_fips_all: '41065',
    county: 'Wasco',
    county_names_all: 'Wasco',
    county_weights: '{"41065": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 45.39048,
    longitude: -121.13425,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97021',
  },
  {
    city: 'Eagle Creek',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 55.1,
    imprecise: false,
    latitude: 45.34562,
    longitude: -122.3306,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97022',
  },
  {
    city: 'Estacada',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 23.8,
    imprecise: false,
    latitude: 45.19147,
    longitude: -122.20501,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97023',
  },
  {
    city: 'Fairview',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 1344.8,
    imprecise: false,
    latitude: 45.54576,
    longitude: -122.44142,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97024',
  },
  {
    city: 'Gervais',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 45.2,
    imprecise: false,
    latitude: 45.10409,
    longitude: -122.94251,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3959,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97026',
  },
  {
    city: 'Gladstone',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 1900.3,
    imprecise: false,
    latitude: 45.38697,
    longitude: -122.59271,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97027',
  },
  {
    city: 'Government Camp',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 45.28225,
    longitude: -121.75274,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97028',
  },
  {
    city: 'Grass Valley',
    county_fips: 41055,
    county_fips_all: '41055',
    county: 'Sherman',
    county_names_all: 'Sherman',
    county_weights: '{"41055": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 45.29901,
    longitude: -120.81003,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97029',
  },
  {
    city: 'Gresham',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 1943.3,
    imprecise: false,
    latitude: 45.50896,
    longitude: -122.43135,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37708,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97030',
  },
  {
    city: 'Hood River',
    county_fips: 41027,
    county_fips_all: '41027',
    county: 'Hood River',
    county_names_all: 'Hood River',
    county_weights: '{"41027": 100}',
    density: 49.4,
    imprecise: false,
    latitude: 45.61193,
    longitude: -121.61094,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19138,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97031',
  },
  {
    city: 'Hubbard',
    county_fips: 41047,
    county_fips_all: '41047|41005',
    county: 'Marion',
    county_names_all: 'Marion|Clackamas',
    county_weights: '{"41047": 65.21, "41005": 34.79}',
    density: 108.9,
    imprecise: false,
    latitude: 45.17949,
    longitude: -122.78559,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97032',
  },
  {
    city: 'Kent',
    county_fips: 41055,
    county_fips_all: '41055',
    county: 'Sherman',
    county_names_all: 'Sherman',
    county_weights: '{"41055": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.23361,
    longitude: -120.5876,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 111,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97033',
  },
  {
    city: 'Lake Oswego',
    county_fips: 41005,
    county_fips_all: '41005|41051',
    county: 'Clackamas',
    county_names_all: 'Clackamas|Multnomah',
    county_weights: '{"41005": 96.63, "41051": 3.37}',
    density: 1063.8,
    imprecise: false,
    latitude: 45.4095,
    longitude: -122.68467,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21331,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97034',
  },
  {
    city: 'Lake Oswego',
    county_fips: 41005,
    county_fips_all: '41005|41051|41067',
    county: 'Clackamas',
    county_names_all: 'Clackamas|Multnomah|Washington',
    county_weights: '{"41005": 88.04, "41051": 9.91, "41067": 2.05}',
    density: 1720.1,
    imprecise: false,
    latitude: 45.41291,
    longitude: -122.72616,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97035',
  },
  {
    city: 'Maupin',
    county_fips: 41065,
    county_fips_all: '41065',
    county: 'Wasco',
    county_names_all: 'Wasco',
    county_weights: '{"41065": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 45.06567,
    longitude: -121.03141,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97037',
  },
  {
    city: 'Molalla',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 48.5,
    imprecise: false,
    latitude: 45.08575,
    longitude: -122.55288,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97038',
  },
  {
    city: 'Moro',
    county_fips: 41055,
    county_fips_all: '41055',
    county: 'Sherman',
    county_names_all: 'Sherman',
    county_weights: '{"41055": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 45.47226,
    longitude: -120.62428,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 413,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97039',
  },
  {
    city: 'Mosier',
    county_fips: 41065,
    county_fips_all: '41065|41027',
    county: 'Wasco',
    county_names_all: 'Wasco|Hood River',
    county_weights: '{"41065": 99.78, "41027": 0.22}',
    density: 13.4,
    imprecise: false,
    latitude: 45.62648,
    longitude: -121.38476,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97040',
  },
  {
    city: 'Mount Hood Parkdale',
    county_fips: 41027,
    county_fips_all: '41027',
    county: 'Hood River',
    county_names_all: 'Hood River',
    county_weights: '{"41027": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 45.41655,
    longitude: -121.59617,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97041',
  },
  {
    city: 'Mulino',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 54.6,
    imprecise: false,
    latitude: 45.20679,
    longitude: -122.53247,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97042',
  },
  {
    city: 'Oregon City',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 255.9,
    imprecise: false,
    latitude: 45.32834,
    longitude: -122.53058,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97045',
  },
  {
    city: 'Rainier',
    county_fips: 41009,
    county_fips_all: '41009',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"41009": 100}',
    density: 28,
    imprecise: false,
    latitude: 46.03905,
    longitude: -122.99483,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97048',
  },
  {
    city: 'Rhododendron',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 45.35931,
    longitude: -121.86829,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97049',
  },
  {
    city: 'Rufus',
    county_fips: 41055,
    county_fips_all: '41055',
    county: 'Sherman',
    county_names_all: 'Sherman',
    county_weights: '{"41055": 100}',
    density: 10,
    imprecise: false,
    latitude: 45.68256,
    longitude: -120.7727,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97050',
  },
  {
    city: 'Saint Helens',
    county_fips: 41009,
    county_fips_all: '41009',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"41009": 100}',
    density: 116.4,
    imprecise: false,
    latitude: 45.88902,
    longitude: -122.92011,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97051',
  },
  {
    city: 'Warren',
    county_fips: 41009,
    county_fips_all: '41009',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"41009": 100}',
    density: 109.6,
    imprecise: false,
    latitude: 45.82695,
    longitude: -122.88401,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97053',
  },
  {
    city: 'Deer Island',
    county_fips: 41009,
    county_fips_all: '41009',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"41009": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 45.95406,
    longitude: -122.92995,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97054',
  },
  {
    city: 'Sandy',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 67.8,
    imprecise: false,
    latitude: 45.35975,
    longitude: -122.15396,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97055',
  },
  {
    city: 'Scappoose',
    county_fips: 41009,
    county_fips_all: '41009|41067|41051',
    county: 'Columbia',
    county_names_all: 'Columbia|Washington|Multnomah',
    county_weights: '{"41009": 85.2, "41067": 10.6, "41051": 4.2}',
    density: 44.6,
    imprecise: false,
    latitude: 45.78935,
    longitude: -122.96941,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97056',
  },
  {
    city: 'Shaniko',
    county_fips: 41065,
    county_fips_all: '41065',
    county: 'Wasco',
    county_names_all: 'Wasco',
    county_weights: '{"41065": 100}',
    density: 12.4,
    imprecise: false,
    latitude: 45.00422,
    longitude: -120.7516,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97057',
  },
  {
    city: 'The Dalles',
    county_fips: 41065,
    county_fips_all: '41065',
    county: 'Wasco',
    county_names_all: 'Wasco',
    county_weights: '{"41065": 100}',
    density: 24.2,
    imprecise: false,
    latitude: 45.54239,
    longitude: -121.15447,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97058',
  },
  {
    city: 'Troutdale',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 477.9,
    imprecise: false,
    latitude: 45.5342,
    longitude: -122.36989,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21649,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97060',
  },
  {
    city: 'Tualatin',
    county_fips: 41067,
    county_fips_all: '41067|41005',
    county: 'Washington',
    county_names_all: 'Washington|Clackamas',
    county_weights: '{"41067": 72.62, "41005": 27.38}',
    density: 786.4,
    imprecise: false,
    latitude: 45.36821,
    longitude: -122.76169,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28930,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97062',
  },
  {
    city: 'Tygh Valley',
    county_fips: 41065,
    county_fips_all: '41065',
    county: 'Wasco',
    county_names_all: 'Wasco',
    county_weights: '{"41065": 100}',
    density: 3,
    imprecise: false,
    latitude: 45.22319,
    longitude: -121.28306,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1081,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97063',
  },
  {
    city: 'Vernonia',
    county_fips: 41009,
    county_fips_all: '41009|41067',
    county: 'Columbia',
    county_names_all: 'Columbia|Washington',
    county_weights: '{"41009": 93.11, "41067": 6.89}',
    density: 15.2,
    imprecise: false,
    latitude: 45.87276,
    longitude: -123.2309,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97064',
  },
  {
    city: 'Wasco',
    county_fips: 41055,
    county_fips_all: '41055',
    county: 'Sherman',
    county_names_all: 'Sherman',
    county_weights: '{"41055": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 45.59803,
    longitude: -120.65696,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97065',
  },
  {
    city: 'Welches',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 36.1,
    imprecise: false,
    latitude: 45.31302,
    longitude: -121.97733,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97067',
  },
  {
    city: 'West Linn',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 520.1,
    imprecise: false,
    latitude: 45.35195,
    longitude: -122.66876,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97068',
  },
  {
    city: 'Wilsonville',
    county_fips: 41005,
    county_fips_all: '41005|41067',
    county: 'Clackamas',
    county_names_all: 'Clackamas|Washington',
    county_weights: '{"41005": 96.58, "41067": 3.42}',
    density: 584.8,
    imprecise: false,
    latitude: 45.308,
    longitude: -122.77059,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26902,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97070',
  },
  {
    city: 'Woodburn',
    county_fips: 41047,
    county_fips_all: '41047|41005',
    county: 'Marion',
    county_names_all: 'Marion|Clackamas',
    county_weights: '{"41047": 74.03, "41005": 25.97}',
    density: 247.5,
    imprecise: false,
    latitude: 45.13588,
    longitude: -122.82344,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97071',
  },
  {
    city: 'Beaverton',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 1574.1,
    imprecise: false,
    latitude: 45.47628,
    longitude: -122.89088,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25662,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97078',
  },
  {
    city: 'Gresham',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 863.8,
    imprecise: false,
    latitude: 45.47848,
    longitude: -122.39001,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97080',
  },
  {
    city: 'Happy Valley',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 1273.9,
    imprecise: false,
    latitude: 45.44531,
    longitude: -122.52793,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97086',
  },
  {
    city: 'Damascus',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 269.7,
    imprecise: false,
    latitude: 45.4256,
    longitude: -122.44342,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97089',
  },
  {
    city: 'Amity',
    county_fips: 41071,
    county_fips_all: '41071|41053',
    county: 'Yamhill',
    county_names_all: 'Yamhill|Polk',
    county_weights: '{"41071": 64.32, "41053": 35.68}',
    density: 30.2,
    imprecise: false,
    latitude: 45.09225,
    longitude: -123.21557,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97101',
  },
  {
    city: 'Arch Cape',
    county_fips: 41007,
    county_fips_all: '41007|41057',
    county: 'Clatsop',
    county_names_all: 'Clatsop|Tillamook',
    county_weights: '{"41007": 62.04, "41057": 37.96}',
    density: 15,
    imprecise: false,
    latitude: 45.7934,
    longitude: -123.94793,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97102',
  },
  {
    city: 'Astoria',
    county_fips: 41007,
    county_fips_all: '41007',
    county: 'Clatsop',
    county_names_all: 'Clatsop',
    county_weights: '{"41007": 100}',
    density: 42.5,
    imprecise: false,
    latitude: 46.13327,
    longitude: -123.69648,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97103',
  },
  {
    city: 'Banks',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 42.6,
    imprecise: false,
    latitude: 45.65419,
    longitude: -123.13417,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4855,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97106',
  },
  {
    city: 'Bay City',
    county_fips: 41057,
    county_fips_all: '41057',
    county: 'Tillamook',
    county_names_all: 'Tillamook',
    county_weights: '{"41057": 100}',
    density: 47.3,
    imprecise: false,
    latitude: 45.56172,
    longitude: -123.88291,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97107',
  },
  {
    city: 'Beaver',
    county_fips: 41057,
    county_fips_all: '41057',
    county: 'Tillamook',
    county_names_all: 'Tillamook',
    county_weights: '{"41057": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 45.27423,
    longitude: -123.67544,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97108',
  },
  {
    city: 'Buxton',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 45.73777,
    longitude: -123.1946,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97109',
  },
  {
    city: 'Cannon Beach',
    county_fips: 41007,
    county_fips_all: '41007',
    county: 'Clatsop',
    county_names_all: 'Clatsop',
    county_weights: '{"41007": 100}',
    density: 71.5,
    imprecise: false,
    latitude: 45.89186,
    longitude: -123.95128,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97110',
  },
  {
    city: 'Carlton',
    county_fips: 41071,
    county_fips_all: '41071',
    county: 'Yamhill',
    county_names_all: 'Yamhill',
    county_weights: '{"41071": 100}',
    density: 49.7,
    imprecise: false,
    latitude: 45.29012,
    longitude: -123.19855,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97111',
  },
  {
    city: 'Cloverdale',
    county_fips: 41057,
    county_fips_all: '41057',
    county: 'Tillamook',
    county_names_all: 'Tillamook',
    county_weights: '{"41057": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 45.26218,
    longitude: -123.86629,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97112',
  },
  {
    city: 'Cornelius',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 179.8,
    imprecise: false,
    latitude: 45.50746,
    longitude: -123.04544,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16268,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97113',
  },
  {
    city: 'Dayton',
    county_fips: 41071,
    county_fips_all: '41071',
    county: 'Yamhill',
    county_names_all: 'Yamhill',
    county_weights: '{"41071": 100}',
    density: 32.5,
    imprecise: false,
    latitude: 45.18381,
    longitude: -123.07172,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5013,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97114',
  },
  {
    city: 'Dundee',
    county_fips: 41071,
    county_fips_all: '41071',
    county: 'Yamhill',
    county_names_all: 'Yamhill',
    county_weights: '{"41071": 100}',
    density: 140.8,
    imprecise: false,
    latitude: 45.27573,
    longitude: -123.02682,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3951,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97115',
  },
  {
    city: 'Forest Grove',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 140.2,
    imprecise: false,
    latitude: 45.59054,
    longitude: -123.18876,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97116',
  },
  {
    city: 'Gales Creek',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 9.6,
    imprecise: false,
    latitude: 45.62189,
    longitude: -123.31132,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97117',
  },
  {
    city: 'Garibaldi',
    county_fips: 41057,
    county_fips_all: '41057',
    county: 'Tillamook',
    county_names_all: 'Tillamook',
    county_weights: '{"41057": 100}',
    density: 331,
    imprecise: false,
    latitude: 45.55697,
    longitude: -123.91619,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97118',
  },
  {
    city: 'Gaston',
    county_fips: 41067,
    county_fips_all: '41067|41071',
    county: 'Washington',
    county_names_all: 'Washington|Yamhill',
    county_weights: '{"41067": 79.19, "41071": 20.81}',
    density: 21.4,
    imprecise: false,
    latitude: 45.4717,
    longitude: -123.20781,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97119',
  },
  {
    city: 'Hammond',
    county_fips: 41007,
    county_fips_all: '41007',
    county: 'Clatsop',
    county_names_all: 'Clatsop',
    county_weights: '{"41007": 100}',
    density: 73.8,
    imprecise: false,
    latitude: 46.19347,
    longitude: -123.97141,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1444,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97121',
  },
  {
    city: 'Hebo',
    county_fips: 41057,
    county_fips_all: '41057',
    county: 'Tillamook',
    county_names_all: 'Tillamook',
    county_weights: '{"41057": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 45.17331,
    longitude: -123.8164,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97122',
  },
  {
    city: 'Hillsboro',
    county_fips: 41067,
    county_fips_all: '41067|41071',
    county: 'Washington',
    county_names_all: 'Washington|Yamhill',
    county_weights: '{"41067": 89.49, "41071": 10.51}',
    density: 335.8,
    imprecise: false,
    latitude: 45.44353,
    longitude: -122.98048,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97123',
  },
  {
    city: 'Hillsboro',
    county_fips: 41067,
    county_fips_all: '41067|41051',
    county: 'Washington',
    county_names_all: 'Washington|Multnomah',
    county_weights: '{"41067": 97.87, "41051": 2.13}',
    density: 464.9,
    imprecise: false,
    latitude: 45.57088,
    longitude: -122.94584,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97124',
  },
  {
    city: 'Manning',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 18.7,
    imprecise: false,
    latitude: 45.66243,
    longitude: -123.21117,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97125',
  },
  {
    city: 'Lafayette',
    county_fips: 41071,
    county_fips_all: '41071',
    county: 'Yamhill',
    county_names_all: 'Yamhill',
    county_weights: '{"41071": 100}',
    density: 1964,
    imprecise: false,
    latitude: 45.24629,
    longitude: -123.11159,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97127',
  },
  {
    city: 'Mcminnville',
    county_fips: 41071,
    county_fips_all: '41071',
    county: 'Yamhill',
    county_names_all: 'Yamhill',
    county_weights: '{"41071": 100}',
    density: 133,
    imprecise: false,
    latitude: 45.19814,
    longitude: -123.25812,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38664,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97128',
  },
  {
    city: 'Manzanita',
    county_fips: 41057,
    county_fips_all: '41057',
    county: 'Tillamook',
    county_names_all: 'Tillamook',
    county_weights: '{"41057": 100}',
    density: 293.8,
    imprecise: false,
    latitude: 45.71592,
    longitude: -123.93318,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97130',
  },
  {
    city: 'Nehalem',
    county_fips: 41057,
    county_fips_all: '41057|41007',
    county: 'Tillamook',
    county_names_all: 'Tillamook|Clatsop',
    county_weights: '{"41057": 86.55, "41007": 13.45}',
    density: 6.6,
    imprecise: false,
    latitude: 45.71495,
    longitude: -123.8107,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97131',
  },
  {
    city: 'Newberg',
    county_fips: 41071,
    county_fips_all: '41071|41067|41005',
    county: 'Yamhill',
    county_names_all: 'Yamhill|Washington|Clackamas',
    county_weights: '{"41071": 92.37, "41067": 6.4, "41005": 1.23}',
    density: 200.2,
    imprecise: false,
    latitude: 45.32272,
    longitude: -122.98854,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97132',
  },
  {
    city: 'North Plains',
    county_fips: 41067,
    county_fips_all: '41067|41051',
    county: 'Washington',
    county_names_all: 'Washington|Multnomah',
    county_weights: '{"41067": 96.42, "41051": 3.58}',
    density: 27.2,
    imprecise: false,
    latitude: 45.68719,
    longitude: -123.02861,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97133',
  },
  {
    city: 'Oceanside',
    county_fips: 41057,
    county_fips_all: '41057',
    county: 'Tillamook',
    county_names_all: 'Tillamook',
    county_weights: '{"41057": 100}',
    density: 146.7,
    imprecise: false,
    latitude: 45.45587,
    longitude: -123.96513,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97134',
  },
  {
    city: 'Pacific City',
    county_fips: 41057,
    county_fips_all: '41057',
    county: 'Tillamook',
    county_names_all: 'Tillamook',
    county_weights: '{"41057": 100}',
    density: 133.8,
    imprecise: false,
    latitude: 45.18749,
    longitude: -123.95494,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97135',
  },
  {
    city: 'Rockaway Beach',
    county_fips: 41057,
    county_fips_all: '41057',
    county: 'Tillamook',
    county_names_all: 'Tillamook',
    county_weights: '{"41057": 100}',
    density: 45.5,
    imprecise: false,
    latitude: 45.6341,
    longitude: -123.91353,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97136',
  },
  {
    city: 'Saint Paul',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 8.5,
    imprecise: false,
    latitude: 45.21028,
    longitude: -122.9635,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 989,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97137',
  },
  {
    city: 'Seaside',
    county_fips: 41007,
    county_fips_all: '41007',
    county: 'Clatsop',
    county_names_all: 'Clatsop',
    county_weights: '{"41007": 100}',
    density: 29.2,
    imprecise: false,
    latitude: 45.90946,
    longitude: -123.70036,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11035,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97138',
  },
  {
    city: 'Sherwood',
    county_fips: 41067,
    county_fips_all: '41067|41005|41071',
    county: 'Washington',
    county_names_all: 'Washington|Clackamas|Yamhill',
    county_weights: '{"41067": 74.92, "41005": 22.7, "41071": 2.38}',
    density: 242,
    imprecise: false,
    latitude: 45.35359,
    longitude: -122.86339,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97140',
  },
  {
    city: 'Tillamook',
    county_fips: 41057,
    county_fips_all: '41057',
    county: 'Tillamook',
    county_names_all: 'Tillamook',
    county_weights: '{"41057": 100}',
    density: 19.5,
    imprecise: false,
    latitude: 45.47142,
    longitude: -123.73791,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13086,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97141',
  },
  {
    city: 'Timber',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 45.74349,
    longitude: -123.30305,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97144',
  },
  {
    city: 'Tolovana Park',
    county_fips: 41007,
    county_fips_all: '41007',
    county: 'Clatsop',
    county_names_all: 'Clatsop',
    county_weights: '{"41007": 100}',
    density: 55.6,
    imprecise: false,
    latitude: 45.84357,
    longitude: -123.9516,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97145',
  },
  {
    city: 'Warrenton',
    county_fips: 41007,
    county_fips_all: '41007',
    county: 'Clatsop',
    county_names_all: 'Clatsop',
    county_weights: '{"41007": 100}',
    density: 122,
    imprecise: false,
    latitude: 46.11849,
    longitude: -123.91399,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8099,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97146',
  },
  {
    city: 'Wheeler',
    county_fips: 41057,
    county_fips_all: '41057',
    county: 'Tillamook',
    county_names_all: 'Tillamook',
    county_weights: '{"41057": 100}',
    density: 337.1,
    imprecise: false,
    latitude: 45.6871,
    longitude: -123.8873,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97147',
  },
  {
    city: 'Yamhill',
    county_fips: 41071,
    county_fips_all: '41071',
    county: 'Yamhill',
    county_names_all: 'Yamhill',
    county_weights: '{"41071": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 45.35988,
    longitude: -123.26553,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97148',
  },
  {
    city: 'Neskowin',
    county_fips: 41057,
    county_fips_all: '41057',
    county: 'Tillamook',
    county_names_all: 'Tillamook',
    county_weights: '{"41057": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 45.09957,
    longitude: -123.94455,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97149',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 3408.2,
    imprecise: false,
    latitude: 45.50796,
    longitude: -122.68959,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16887,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97201',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051|41005',
    county: 'Multnomah',
    county_names_all: 'Multnomah|Clackamas',
    county_weights: '{"41051": 99.01, "41005": 0.99}',
    density: 2679.1,
    imprecise: false,
    latitude: 45.48232,
    longitude: -122.64365,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97202',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 1186.6,
    imprecise: false,
    latitude: 45.60764,
    longitude: -122.74923,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97203',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 1386.1,
    imprecise: false,
    latitude: 45.5183,
    longitude: -122.67378,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 885,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97204',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 3738.7,
    imprecise: false,
    latitude: 45.51924,
    longitude: -122.70127,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97205',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051|41005',
    county: 'Multnomah',
    county_names_all: 'Multnomah|Clackamas',
    county_weights: '{"41051": 91.87, "41005": 8.13}',
    density: 2985.6,
    imprecise: false,
    latitude: 45.48173,
    longitude: -122.5988,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97206',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 0,
    imprecise: false,
    latitude: 45.52866,
    longitude: -122.67898,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97208',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 8357.3,
    imprecise: false,
    latitude: 45.53093,
    longitude: -122.68429,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97209',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051|41067',
    county: 'Multnomah',
    county_names_all: 'Multnomah|Washington',
    county_weights: '{"41051": 99.81, "41067": 0.19}',
    density: 491.5,
    imprecise: false,
    latitude: 45.54954,
    longitude: -122.73549,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97210',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 1826.9,
    imprecise: false,
    latitude: 45.58174,
    longitude: -122.63548,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97211',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 3967.2,
    imprecise: false,
    latitude: 45.54428,
    longitude: -122.64322,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28042,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97212',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 3007.7,
    imprecise: false,
    latitude: 45.53776,
    longitude: -122.59957,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97213',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 3681.1,
    imprecise: false,
    latitude: 45.51395,
    longitude: -122.64424,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97214',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 2859.7,
    imprecise: false,
    latitude: 45.51436,
    longitude: -122.59923,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17296,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97215',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 2553.3,
    imprecise: false,
    latitude: 45.51393,
    longitude: -122.5585,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97216',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 1218.6,
    imprecise: false,
    latitude: 45.59686,
    longitude: -122.69717,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97217',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 894.8,
    imprecise: false,
    latitude: 45.5759,
    longitude: -122.60023,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15428,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97218',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051|41005',
    county: 'Multnomah',
    county_names_all: 'Multnomah|Clackamas',
    county_weights: '{"41051": 96.56, "41005": 3.44}',
    density: 1400.2,
    imprecise: false,
    latitude: 45.45413,
    longitude: -122.69972,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97219',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 1398.3,
    imprecise: false,
    latitude: 45.55107,
    longitude: -122.55915,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97220',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051|41067',
    county: 'Multnomah',
    county_names_all: 'Multnomah|Washington',
    county_weights: '{"41051": 99.76, "41067": 0.24}',
    density: 1131.9,
    imprecise: false,
    latitude: 45.49799,
    longitude: -122.72749,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97221',
  },
  {
    city: 'Portland',
    county_fips: 41005,
    county_fips_all: '41005|41051',
    county: 'Clackamas',
    county_names_all: 'Clackamas|Multnomah',
    county_weights: '{"41005": 99.02, "41051": 0.98}',
    density: 1624.9,
    imprecise: false,
    latitude: 45.44114,
    longitude: -122.61682,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97222',
  },
  {
    city: 'Portland',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 1763.3,
    imprecise: false,
    latitude: 45.44023,
    longitude: -122.77838,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97223',
  },
  {
    city: 'Portland',
    county_fips: 41067,
    county_fips_all: '41067',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"41067": 100}',
    density: 1560.4,
    imprecise: false,
    latitude: 45.40568,
    longitude: -122.7958,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97224',
  },
  {
    city: 'Portland',
    county_fips: 41067,
    county_fips_all: '41067|41051',
    county: 'Washington',
    county_names_all: 'Washington|Multnomah',
    county_weights: '{"41067": 99.26, "41051": 0.74}',
    density: 1499.9,
    imprecise: false,
    latitude: 45.502,
    longitude: -122.76994,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25869,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97225',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 1532.3,
    imprecise: false,
    latitude: 45.54432,
    longitude: -122.67721,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5665,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97227',
  },
  {
    city: 'Portland',
    county_fips: 41067,
    county_fips_all: '41067|41051',
    county: 'Washington',
    county_names_all: 'Washington|Multnomah',
    county_weights: '{"41067": 62.18, "41051": 37.82}',
    density: 1495.3,
    imprecise: false,
    latitude: 45.55032,
    longitude: -122.81026,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 76106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97229',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 1207.9,
    imprecise: false,
    latitude: 45.5582,
    longitude: -122.506,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43553,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97230',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051|41009|41067',
    county: 'Multnomah',
    county_names_all: 'Multnomah|Columbia|Washington',
    county_weights: '{"41051": 72.53, "41009": 25.36, "41067": 2.11}',
    density: 26.5,
    imprecise: false,
    latitude: 45.68197,
    longitude: -122.82687,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4308,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97231',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 3224.5,
    imprecise: false,
    latitude: 45.5292,
    longitude: -122.64376,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97232',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 3013,
    imprecise: false,
    latitude: 45.51391,
    longitude: -122.49887,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97233',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 1878.7,
    imprecise: false,
    latitude: 45.48474,
    longitude: -122.51055,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97236',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 1918.6,
    imprecise: false,
    latitude: 45.48893,
    longitude: -122.69053,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97239',
  },
  {
    city: 'Portland',
    county_fips: 41051,
    county_fips_all: '41051',
    county: 'Multnomah',
    county_names_all: 'Multnomah',
    county_weights: '{"41051": 100}',
    density: 2257.7,
    imprecise: false,
    latitude: 45.48268,
    longitude: -122.55838,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97266',
  },
  {
    city: 'Portland',
    county_fips: 41005,
    county_fips_all: '41005',
    county: 'Clackamas',
    county_names_all: 'Clackamas',
    county_weights: '{"41005": 100}',
    density: 1672.4,
    imprecise: false,
    latitude: 45.40744,
    longitude: -122.61472,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97267',
  },
  {
    city: 'Salem',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 1966.3,
    imprecise: false,
    latitude: 44.94948,
    longitude: -123.00439,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57574,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97301',
  },
  {
    city: 'Salem',
    county_fips: 41047,
    county_fips_all: '41047|41053',
    county: 'Marion',
    county_names_all: 'Marion|Polk',
    county_weights: '{"41047": 99.77, "41053": 0.23}',
    density: 671.7,
    imprecise: false,
    latitude: 44.90191,
    longitude: -123.06719,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40799,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97302',
  },
  {
    city: 'Salem',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 629.9,
    imprecise: false,
    latitude: 45.03036,
    longitude: -123.02449,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40659,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97303',
  },
  {
    city: 'Salem',
    county_fips: 41053,
    county_fips_all: '41053|41071',
    county: 'Polk',
    county_names_all: 'Polk|Yamhill',
    county_weights: '{"41053": 86.91, "41071": 13.09}',
    density: 237,
    imprecise: false,
    latitude: 45.0078,
    longitude: -123.1078,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97304',
  },
  {
    city: 'Salem',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 368.7,
    imprecise: false,
    latitude: 45.01573,
    longitude: -122.92909,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45083,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97305',
  },
  {
    city: 'Salem',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 409.7,
    imprecise: false,
    latitude: 44.84585,
    longitude: -123.07972,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97306',
  },
  {
    city: 'Salem',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 181.5,
    imprecise: false,
    latitude: 44.90242,
    longitude: -122.90628,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97317',
  },
  {
    city: 'Albany',
    county_fips: 41043,
    county_fips_all: '41043|41003',
    county: 'Linn',
    county_names_all: 'Linn|Benton',
    county_weights: '{"41043": 68.74, "41003": 31.26}',
    density: 171.3,
    imprecise: false,
    latitude: 44.64994,
    longitude: -123.13474,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30672,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97321',
  },
  {
    city: 'Albany',
    county_fips: 41043,
    county_fips_all: '41043',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"41043": 100}',
    density: 222.2,
    imprecise: false,
    latitude: 44.62524,
    longitude: -123.01975,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36408,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97322',
  },
  {
    city: 'Alsea',
    county_fips: 41003,
    county_fips_all: '41003|41039|41041',
    county: 'Benton',
    county_names_all: 'Benton|Lane|Lincoln',
    county_weights: '{"41003": 77.52, "41039": 13.49, "41041": 8.99}',
    density: 2.9,
    imprecise: false,
    latitude: 44.34345,
    longitude: -123.63042,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1470,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97324',
  },
  {
    city: 'Aumsville',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 92.7,
    imprecise: false,
    latitude: 44.83141,
    longitude: -122.85195,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97325',
  },
  {
    city: 'Blodgett',
    county_fips: 41041,
    county_fips_all: '41041|41003',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Benton',
    county_weights: '{"41041": 61.03, "41003": 38.97}',
    density: 2.5,
    imprecise: false,
    latitude: 44.62794,
    longitude: -123.61573,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97326',
  },
  {
    city: 'Brownsville',
    county_fips: 41043,
    county_fips_all: '41043',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"41043": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 44.37567,
    longitude: -122.94783,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97327',
  },
  {
    city: 'Cascadia',
    county_fips: 41043,
    county_fips_all: '41043',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"41043": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 44.3956,
    longitude: -122.33698,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97329',
  },
  {
    city: 'Corvallis',
    county_fips: 41003,
    county_fips_all: '41003',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"41003": 100}',
    density: 217.3,
    imprecise: false,
    latitude: 44.63796,
    longitude: -123.27814,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43878,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97330',
  },
  {
    city: 'Corvallis',
    county_fips: 41003,
    county_fips_all: '41003|41043',
    county: 'Benton',
    county_names_all: 'Benton|Linn',
    county_weights: '{"41003": 89.04, "41043": 10.96}',
    density: 82.5,
    imprecise: false,
    latitude: 44.4735,
    longitude: -123.3067,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97333',
  },
  {
    city: 'Crabtree',
    county_fips: 41043,
    county_fips_all: '41043',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"41043": 100}',
    density: 58.1,
    imprecise: false,
    latitude: 44.63776,
    longitude: -122.88045,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97335',
  },
  {
    city: 'Crawfordsville',
    county_fips: 41043,
    county_fips_all: '41043',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"41043": 100}',
    density: 87.6,
    imprecise: false,
    latitude: 44.35669,
    longitude: -122.85092,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 95,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97336',
  },
  {
    city: 'Dallas',
    county_fips: 41053,
    county_fips_all: '41053',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"41053": 100}',
    density: 72.4,
    imprecise: false,
    latitude: 44.93654,
    longitude: -123.33868,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97338',
  },
  {
    city: 'Depoe Bay',
    county_fips: 41041,
    county_fips_all: '41041',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"41041": 100}',
    density: 115.8,
    imprecise: false,
    latitude: 44.81525,
    longitude: -124.04513,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2972,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97341',
  },
  {
    city: 'Detroit',
    county_fips: 41047,
    county_fips_all: '41047|41043',
    county: 'Marion',
    county_names_all: 'Marion|Linn',
    county_weights: '{"41047": 99.74, "41043": 0.26}',
    density: 0.8,
    imprecise: false,
    latitude: 44.73382,
    longitude: -121.94524,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97342',
  },
  {
    city: 'Eddyville',
    county_fips: 41041,
    county_fips_all: '41041',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"41041": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 44.56934,
    longitude: -123.73091,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 484,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97343',
  },
  {
    city: 'Falls City',
    county_fips: 41053,
    county_fips_all: '41053',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"41053": 100}',
    density: 51.4,
    imprecise: false,
    latitude: 44.86887,
    longitude: -123.46596,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97344',
  },
  {
    city: 'Foster',
    county_fips: 41043,
    county_fips_all: '41043',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"41043": 100}',
    density: 3,
    imprecise: false,
    latitude: 44.4126,
    longitude: -122.57644,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97345',
  },
  {
    city: 'Gates',
    county_fips: 41047,
    county_fips_all: '41047|41043',
    county: 'Marion',
    county_names_all: 'Marion|Linn',
    county_weights: '{"41047": 73.18, "41043": 26.82}',
    density: 8.9,
    imprecise: false,
    latitude: 44.76948,
    longitude: -122.37857,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97346',
  },
  {
    city: 'Grand Ronde',
    county_fips: 41071,
    county_fips_all: '41071|41053|41057',
    county: 'Yamhill',
    county_names_all: 'Yamhill|Polk|Tillamook',
    county_weights: '{"41071": 51.1, "41053": 45.21, "41057": 3.69}',
    density: 12.9,
    imprecise: false,
    latitude: 45.07836,
    longitude: -123.65943,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97347',
  },
  {
    city: 'Halsey',
    county_fips: 41043,
    county_fips_all: '41043',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"41043": 100}',
    density: 12,
    imprecise: false,
    latitude: 44.38768,
    longitude: -123.12582,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97348',
  },
  {
    city: 'Idanha',
    county_fips: 41043,
    county_fips_all: '41043|41047',
    county: 'Linn',
    county_names_all: 'Linn|Marion',
    county_weights: '{"41043": 92.82, "41047": 7.18}',
    density: 0.8,
    imprecise: false,
    latitude: 44.64786,
    longitude: -121.96146,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97350',
  },
  {
    city: 'Independence',
    county_fips: 41053,
    county_fips_all: '41053',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"41053": 100}',
    density: 84.6,
    imprecise: false,
    latitude: 44.83857,
    longitude: -123.17449,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97351',
  },
  {
    city: 'Jefferson',
    county_fips: 41047,
    county_fips_all: '41047|41043',
    county: 'Marion',
    county_names_all: 'Marion|Linn',
    county_weights: '{"41047": 81.85, "41043": 18.15}',
    density: 51.6,
    imprecise: false,
    latitude: 44.75009,
    longitude: -123.02419,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97352',
  },
  {
    city: 'Lebanon',
    county_fips: 41043,
    county_fips_all: '41043',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"41043": 100}',
    density: 61.8,
    imprecise: false,
    latitude: 44.5315,
    longitude: -122.81701,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97355',
  },
  {
    city: 'Logsden',
    county_fips: 41041,
    county_fips_all: '41041',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"41041": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 44.73934,
    longitude: -123.81592,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97357',
  },
  {
    city: 'Lyons',
    county_fips: 41047,
    county_fips_all: '41047|41043',
    county: 'Marion',
    county_names_all: 'Marion|Linn',
    county_weights: '{"41047": 76.51, "41043": 23.49}',
    density: 10.3,
    imprecise: false,
    latitude: 44.80681,
    longitude: -122.40702,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97358',
  },
  {
    city: 'Mill City',
    county_fips: 41043,
    county_fips_all: '41043|41047',
    county: 'Linn',
    county_names_all: 'Linn|Marion',
    county_weights: '{"41043": 57.9, "41047": 42.1}',
    density: 58.3,
    imprecise: false,
    latitude: 44.7515,
    longitude: -122.48529,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2040,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97360',
  },
  {
    city: 'Monmouth',
    county_fips: 41053,
    county_fips_all: '41053|41003',
    county: 'Polk',
    county_names_all: 'Polk|Benton',
    county_weights: '{"41053": 89.2, "41003": 10.8}',
    density: 42.1,
    imprecise: false,
    latitude: 44.77251,
    longitude: -123.32999,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14488,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97361',
  },
  {
    city: 'Mount Angel',
    county_fips: 41047,
    county_fips_all: '41047|41005',
    county: 'Marion',
    county_names_all: 'Marion|Clackamas',
    county_weights: '{"41047": 89.19, "41005": 10.81}',
    density: 67.9,
    imprecise: false,
    latitude: 45.06903,
    longitude: -122.7692,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4110,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97362',
  },
  {
    city: 'Neotsu',
    county_fips: 41041,
    county_fips_all: '41041',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"41041": 100}',
    density: 948,
    imprecise: false,
    latitude: 44.99889,
    longitude: -123.98703,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 746,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97364',
  },
  {
    city: 'Newport',
    county_fips: 41041,
    county_fips_all: '41041',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"41041": 100}',
    density: 103,
    imprecise: false,
    latitude: 44.67113,
    longitude: -124.01825,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97365',
  },
  {
    city: 'South Beach',
    county_fips: 41041,
    county_fips_all: '41041',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"41041": 100}',
    density: 85.2,
    imprecise: false,
    latitude: 44.58288,
    longitude: -124.04748,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2356,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97366',
  },
  {
    city: 'Lincoln City',
    county_fips: 41041,
    county_fips_all: '41041',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"41041": 100}',
    density: 94.2,
    imprecise: false,
    latitude: 44.9122,
    longitude: -123.96914,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97367',
  },
  {
    city: 'Otis',
    county_fips: 41041,
    county_fips_all: '41041|41057',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Tillamook',
    county_weights: '{"41041": 92.74, "41057": 7.26}',
    density: 17.8,
    imprecise: false,
    latitude: 45.0073,
    longitude: -123.89155,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2803,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97368',
  },
  {
    city: 'Otter Rock',
    county_fips: 41041,
    county_fips_all: '41041',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"41041": 100}',
    density: 61,
    imprecise: false,
    latitude: 44.76015,
    longitude: -124.05676,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97369',
  },
  {
    city: 'Philomath',
    county_fips: 41003,
    county_fips_all: '41003|41053',
    county: 'Benton',
    county_names_all: 'Benton|Polk',
    county_weights: '{"41003": 93.65, "41053": 6.35}',
    density: 20.6,
    imprecise: false,
    latitude: 44.57901,
    longitude: -123.46907,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97370',
  },
  {
    city: 'Rickreall',
    county_fips: 41053,
    county_fips_all: '41053',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"41053": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 44.98985,
    longitude: -123.1994,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97371',
  },
  {
    city: 'Saint Benedict',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 1161.6,
    imprecise: false,
    latitude: 45.05819,
    longitude: -122.77677,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97373',
  },
  {
    city: 'Scio',
    county_fips: 41043,
    county_fips_all: '41043',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"41043": 100}',
    density: 14.5,
    imprecise: false,
    latitude: 44.69285,
    longitude: -122.77379,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4859,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97374',
  },
  {
    city: 'Scotts Mills',
    county_fips: 41047,
    county_fips_all: '41047|41005',
    county: 'Marion',
    county_names_all: 'Marion|Clackamas',
    county_weights: '{"41047": 78.51, "41005": 21.49}',
    density: 10.9,
    imprecise: false,
    latitude: 44.97922,
    longitude: -122.6021,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1346,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97375',
  },
  {
    city: 'Seal Rock',
    county_fips: 41041,
    county_fips_all: '41041',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"41041": 100}',
    density: 8.3,
    imprecise: false,
    latitude: 44.50854,
    longitude: -123.9768,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97376',
  },
  {
    city: 'Shedd',
    county_fips: 41043,
    county_fips_all: '41043',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"41043": 100}',
    density: 5,
    imprecise: false,
    latitude: 44.46403,
    longitude: -123.10156,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97377',
  },
  {
    city: 'Sheridan',
    county_fips: 41071,
    county_fips_all: '41071|41053',
    county: 'Yamhill',
    county_names_all: 'Yamhill|Polk',
    county_weights: '{"41071": 51.47, "41053": 48.53}',
    density: 30.4,
    imprecise: false,
    latitude: 45.08058,
    longitude: -123.43127,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97378',
  },
  {
    city: 'Siletz',
    county_fips: 41041,
    county_fips_all: '41041',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"41041": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 44.77268,
    longitude: -123.94202,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97380',
  },
  {
    city: 'Silverton',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 54.1,
    imprecise: false,
    latitude: 44.97014,
    longitude: -122.74749,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97381',
  },
  {
    city: 'Stayton',
    county_fips: 41047,
    county_fips_all: '41047|41043',
    county: 'Marion',
    county_names_all: 'Marion|Linn',
    county_weights: '{"41047": 69.87, "41043": 30.13}',
    density: 83.5,
    imprecise: false,
    latitude: 44.80014,
    longitude: -122.71836,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97383',
  },
  {
    city: 'Mehama',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.79109,
    longitude: -122.62007,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97384',
  },
  {
    city: 'Sublimity',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 41.6,
    imprecise: false,
    latitude: 44.86633,
    longitude: -122.72924,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97385',
  },
  {
    city: 'Sweet Home',
    county_fips: 41043,
    county_fips_all: '41043',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"41043": 100}',
    density: 46.7,
    imprecise: false,
    latitude: 44.36062,
    longitude: -122.75076,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97386',
  },
  {
    city: 'Gleneden Beach',
    county_fips: 41041,
    county_fips_all: '41041',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"41041": 100}',
    density: 54.9,
    imprecise: false,
    latitude: 44.87418,
    longitude: -124.01169,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97388',
  },
  {
    city: 'Tangent',
    county_fips: 41043,
    county_fips_all: '41043',
    county: 'Linn',
    county_names_all: 'Linn',
    county_weights: '{"41043": 100}',
    density: 19,
    imprecise: false,
    latitude: 44.53269,
    longitude: -123.09028,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97389',
  },
  {
    city: 'Tidewater',
    county_fips: 41041,
    county_fips_all: '41041|41039',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Lane',
    county_weights: '{"41041": 67.25, "41039": 32.75}',
    density: 2.5,
    imprecise: false,
    latitude: 44.33781,
    longitude: -123.85717,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97390',
  },
  {
    city: 'Toledo',
    county_fips: 41041,
    county_fips_all: '41041',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"41041": 100}',
    density: 18.5,
    imprecise: false,
    latitude: 44.59593,
    longitude: -123.8816,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97391',
  },
  {
    city: 'Turner',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 61.9,
    imprecise: false,
    latitude: 44.79096,
    longitude: -122.9413,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97392',
  },
  {
    city: 'Waldport',
    county_fips: 41041,
    county_fips_all: '41041',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"41041": 100}',
    density: 40.1,
    imprecise: false,
    latitude: 44.40607,
    longitude: -124.00258,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5363,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97394',
  },
  {
    city: 'Willamina',
    county_fips: 41071,
    county_fips_all: '41071|41053',
    county: 'Yamhill',
    county_names_all: 'Yamhill|Polk',
    county_weights: '{"41071": 75.5, "41053": 24.5}',
    density: 24.4,
    imprecise: false,
    latitude: 45.11528,
    longitude: -123.5275,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97396',
  },
  {
    city: 'Eugene',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 2057.5,
    imprecise: false,
    latitude: 44.06803,
    longitude: -123.08171,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97401',
  },
  {
    city: 'Eugene',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 302.8,
    imprecise: false,
    latitude: 44.05193,
    longitude: -123.23022,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 53823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97402',
  },
  {
    city: 'Eugene',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 1403.1,
    imprecise: false,
    latitude: 44.03541,
    longitude: -123.05247,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15355,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97403',
  },
  {
    city: 'Eugene',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 1374.9,
    imprecise: false,
    latitude: 44.10518,
    longitude: -123.13315,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97404',
  },
  {
    city: 'Eugene',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 140.3,
    imprecise: false,
    latitude: 43.95528,
    longitude: -123.167,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46933,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97405',
  },
  {
    city: 'Agness',
    county_fips: 41015,
    county_fips_all: '41015|41011',
    county: 'Curry',
    county_names_all: 'Curry|Coos',
    county_weights: '{"41015": 95.12, "41011": 4.88}',
    density: 0.8,
    imprecise: false,
    latitude: 42.62638,
    longitude: -123.99867,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 393,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97406',
  },
  {
    city: 'Eugene',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 119.7,
    imprecise: false,
    latitude: 44.14435,
    longitude: -123.05452,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97408',
  },
  {
    city: 'Azalea',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 42.80159,
    longitude: -123.11931,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97410',
  },
  {
    city: 'Bandon',
    county_fips: 41011,
    county_fips_all: '41011',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"41011": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 43.07557,
    longitude: -124.3624,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7699,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97411',
  },
  {
    city: 'Blachly',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 44.19625,
    longitude: -123.56106,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97412',
  },
  {
    city: 'Blue River',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 44.09633,
    longitude: -122.01513,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 818,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97413',
  },
  {
    city: 'Broadbent',
    county_fips: 41011,
    county_fips_all: '41011',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"41011": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 42.96653,
    longitude: -124.15026,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 415,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97414',
  },
  {
    city: 'Brookings',
    county_fips: 41015,
    county_fips_all: '41015',
    county: 'Curry',
    county_names_all: 'Curry',
    county_weights: '{"41015": 100}',
    density: 18.4,
    imprecise: false,
    latitude: 42.13977,
    longitude: -124.13506,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97415',
  },
  {
    city: 'Camas Valley',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 43.03524,
    longitude: -123.69123,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97416',
  },
  {
    city: 'Canyonville',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 31.5,
    imprecise: false,
    latitude: 42.94014,
    longitude: -123.21802,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97417',
  },
  {
    city: 'Cheshire',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 13.2,
    imprecise: false,
    latitude: 44.1793,
    longitude: -123.40719,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97419',
  },
  {
    city: 'Coos Bay',
    county_fips: 41011,
    county_fips_all: '41011',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"41011": 100}',
    density: 38.9,
    imprecise: false,
    latitude: 43.34839,
    longitude: -124.10825,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27621,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97420',
  },
  {
    city: 'Coquille',
    county_fips: 41011,
    county_fips_all: '41011',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"41011": 100}',
    density: 18.5,
    imprecise: false,
    latitude: 43.19137,
    longitude: -124.17177,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97423',
  },
  {
    city: 'Cottage Grove',
    county_fips: 41039,
    county_fips_all: '41039|41019',
    county: 'Lane',
    county_names_all: 'Lane|Douglas',
    county_weights: '{"41039": 88.51, "41019": 11.49}',
    density: 28.8,
    imprecise: false,
    latitude: 43.74712,
    longitude: -123.05496,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97424',
  },
  {
    city: 'Creswell',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 52.4,
    imprecise: false,
    latitude: 43.90313,
    longitude: -123.02781,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97426',
  },
  {
    city: 'Days Creek',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 42.96778,
    longitude: -123.05442,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97429',
  },
  {
    city: 'Deadwood',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 44.15507,
    longitude: -123.71175,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 367,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97430',
  },
  {
    city: 'Dexter',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 21.7,
    imprecise: false,
    latitude: 43.87135,
    longitude: -122.81576,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97431',
  },
  {
    city: 'Dillard',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 1914.5,
    imprecise: false,
    latitude: 43.10445,
    longitude: -123.4294,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97432',
  },
  {
    city: 'Dorena',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 43.66553,
    longitude: -122.78211,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97434',
  },
  {
    city: 'Drain',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 43.7016,
    longitude: -123.33839,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97435',
  },
  {
    city: 'Elkton',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 43.63958,
    longitude: -123.58256,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97436',
  },
  {
    city: 'Elmira',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 45.2,
    imprecise: false,
    latitude: 44.09734,
    longitude: -123.38731,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2632,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97437',
  },
  {
    city: 'Fall Creek',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 43.96068,
    longitude: -122.65546,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97438',
  },
  {
    city: 'Florence',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 36.8,
    imprecise: false,
    latitude: 44.06573,
    longitude: -124.03705,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16025,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97439',
  },
  {
    city: 'Gardiner',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 43.77659,
    longitude: -124.14414,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97441',
  },
  {
    city: 'Glendale',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 42.76982,
    longitude: -123.40365,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97442',
  },
  {
    city: 'Glide',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 14,
    imprecise: false,
    latitude: 43.25014,
    longitude: -123.00255,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97443',
  },
  {
    city: 'Gold Beach',
    county_fips: 41015,
    county_fips_all: '41015',
    county: 'Curry',
    county_names_all: 'Curry',
    county_weights: '{"41015": 100}',
    density: 12.8,
    imprecise: false,
    latitude: 42.44453,
    longitude: -124.33223,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97444',
  },
  {
    city: 'Harrisburg',
    county_fips: 41043,
    county_fips_all: '41043|41039',
    county: 'Linn',
    county_names_all: 'Linn|Lane',
    county_weights: '{"41043": 99.07, "41039": 0.93}',
    density: 17.1,
    imprecise: false,
    latitude: 44.26804,
    longitude: -123.05548,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97446',
  },
  {
    city: 'Idleyld Park',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 43.28409,
    longitude: -122.49807,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97447',
  },
  {
    city: 'Junction City',
    county_fips: 41039,
    county_fips_all: '41039|41003',
    county: 'Lane',
    county_names_all: 'Lane|Benton',
    county_weights: '{"41039": 94.43, "41003": 5.57}',
    density: 40.1,
    imprecise: false,
    latitude: 44.2105,
    longitude: -123.27882,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97448',
  },
  {
    city: 'Lakeside',
    county_fips: 41011,
    county_fips_all: '41011',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"41011": 100}',
    density: 18.9,
    imprecise: false,
    latitude: 43.57571,
    longitude: -124.08581,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2208,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97449',
  },
  {
    city: 'Langlois',
    county_fips: 41015,
    county_fips_all: '41015|41011',
    county: 'Curry',
    county_names_all: 'Curry|Coos',
    county_weights: '{"41015": 91.88, "41011": 8.12}',
    density: 4.1,
    imprecise: false,
    latitude: 42.91026,
    longitude: -124.37398,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97450',
  },
  {
    city: 'Lorane',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 43.83998,
    longitude: -123.31383,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97451',
  },
  {
    city: 'Lowell',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 25.9,
    imprecise: false,
    latitude: 43.88564,
    longitude: -122.72259,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1703,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97452',
  },
  {
    city: 'Mapleton',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 43.99422,
    longitude: -123.86344,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97453',
  },
  {
    city: 'Marcola',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 7.5,
    imprecise: false,
    latitude: 44.21806,
    longitude: -122.8191,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97454',
  },
  {
    city: 'Pleasant Hill',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 37,
    imprecise: false,
    latitude: 43.96212,
    longitude: -122.91493,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2461,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97455',
  },
  {
    city: 'Monroe',
    county_fips: 41003,
    county_fips_all: '41003|41039',
    county: 'Benton',
    county_names_all: 'Benton|Lane',
    county_weights: '{"41003": 96.9, "41039": 3.1}',
    density: 14.4,
    imprecise: false,
    latitude: 44.34036,
    longitude: -123.35893,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3422,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97456',
  },
  {
    city: 'Myrtle Creek',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 24.4,
    imprecise: false,
    latitude: 43.05484,
    longitude: -123.2229,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97457',
  },
  {
    city: 'Myrtle Point',
    county_fips: 41011,
    county_fips_all: '41011',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"41011": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 43.06372,
    longitude: -124.01287,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97458',
  },
  {
    city: 'North Bend',
    county_fips: 41011,
    county_fips_all: '41011|41019',
    county: 'Coos',
    county_names_all: 'Coos|Douglas',
    county_weights: '{"41011": 96.52, "41019": 3.48}',
    density: 52.4,
    imprecise: false,
    latitude: 43.47444,
    longitude: -124.18216,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97459',
  },
  {
    city: 'Noti',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 44.09789,
    longitude: -123.48993,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97461',
  },
  {
    city: 'Oakland',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 43.49047,
    longitude: -123.38828,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97462',
  },
  {
    city: 'Oakridge',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 28.9,
    imprecise: false,
    latitude: 43.73951,
    longitude: -122.40591,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97463',
  },
  {
    city: 'Port Orford',
    county_fips: 41015,
    county_fips_all: '41015',
    county: 'Curry',
    county_names_all: 'Curry',
    county_weights: '{"41015": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 42.7376,
    longitude: -124.3795,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1811,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97465',
  },
  {
    city: 'Powers',
    county_fips: 41011,
    county_fips_all: '41011|41015',
    county: 'Coos',
    county_names_all: 'Coos|Curry',
    county_weights: '{"41011": 85.12, "41015": 14.88}',
    density: 6.7,
    imprecise: false,
    latitude: 42.86459,
    longitude: -124.08632,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 842,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97466',
  },
  {
    city: 'Reedsport',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 43.73557,
    longitude: -123.90442,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5423,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97467',
  },
  {
    city: 'Riddle',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 14.8,
    imprecise: false,
    latitude: 42.91994,
    longitude: -123.41459,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97469',
  },
  {
    city: 'Roseburg',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 42.1,
    imprecise: false,
    latitude: 43.23288,
    longitude: -123.23111,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97470',
  },
  {
    city: 'Roseburg',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 68.6,
    imprecise: false,
    latitude: 43.22215,
    longitude: -123.47486,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97471',
  },
  {
    city: 'Scottsburg',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 43.6773,
    longitude: -123.8726,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97473',
  },
  {
    city: 'Sixes',
    county_fips: 41015,
    county_fips_all: '41015',
    county: 'Curry',
    county_names_all: 'Curry',
    county_weights: '{"41015": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 42.84075,
    longitude: -124.43806,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97476',
  },
  {
    city: 'Springfield',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 1166.7,
    imprecise: false,
    latitude: 44.05861,
    longitude: -123.01126,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97477',
  },
  {
    city: 'Springfield',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 90.3,
    imprecise: false,
    latitude: 44.08781,
    longitude: -122.84478,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97478',
  },
  {
    city: 'Sutherlin',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 59.8,
    imprecise: false,
    latitude: 43.40194,
    longitude: -123.19426,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97479',
  },
  {
    city: 'Swisshome',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 44.1303,
    longitude: -123.83213,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97480',
  },
  {
    city: 'Tenmile',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 30.5,
    imprecise: false,
    latitude: 43.11376,
    longitude: -123.55237,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 592,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97481',
  },
  {
    city: 'Tiller',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 42.93373,
    longitude: -122.84585,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 271,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97484',
  },
  {
    city: 'Umpqua',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 43.37778,
    longitude: -123.5351,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97486',
  },
  {
    city: 'Veneta',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 45.1,
    imprecise: false,
    latitude: 43.99441,
    longitude: -123.39303,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97487',
  },
  {
    city: 'Vida',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 44.13077,
    longitude: -122.41198,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97488',
  },
  {
    city: 'Walterville',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 44.10986,
    longitude: -122.61962,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97489',
  },
  {
    city: 'Walton',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 44.00795,
    longitude: -123.60522,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97490',
  },
  {
    city: 'Westfir',
    county_fips: 41039,
    county_fips_all: '41039',
    county: 'Lane',
    county_names_all: 'Lane',
    county_weights: '{"41039": 100}',
    density: 8.2,
    imprecise: false,
    latitude: 43.77168,
    longitude: -122.49868,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97492',
  },
  {
    city: 'Westlake',
    county_fips: 41039,
    county_fips_all: '41039|41019',
    county: 'Lane',
    county_names_all: 'Lane|Douglas',
    county_weights: '{"41039": 91.74, "41019": 8.26}',
    density: 3.6,
    imprecise: false,
    latitude: 43.90256,
    longitude: -124.01602,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97493',
  },
  {
    city: 'Wilbur',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.33059,
    longitude: -123.32779,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97494',
  },
  {
    city: 'Winchester',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 89.2,
    imprecise: false,
    latitude: 43.28765,
    longitude: -123.30463,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97495',
  },
  {
    city: 'Winston',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 34.1,
    imprecise: false,
    latitude: 43.05261,
    longitude: -123.49992,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97496',
  },
  {
    city: 'Wolf Creek',
    county_fips: 41033,
    county_fips_all: '41033|41029',
    county: 'Josephine',
    county_names_all: 'Josephine|Jackson',
    county_weights: '{"41033": 94.06, "41029": 5.94}',
    density: 2.7,
    imprecise: false,
    latitude: 42.66015,
    longitude: -123.40929,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97497',
  },
  {
    city: 'Yachats',
    county_fips: 41039,
    county_fips_all: '41039|41041',
    county: 'Lane',
    county_names_all: 'Lane|Lincoln',
    county_weights: '{"41039": 50.62, "41041": 49.38}',
    density: 7.3,
    imprecise: false,
    latitude: 44.27728,
    longitude: -124.01901,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97498',
  },
  {
    city: 'Yoncalla',
    county_fips: 41019,
    county_fips_all: '41019',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"41019": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 43.59495,
    longitude: -123.23356,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1828,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97499',
  },
  {
    city: 'Medford',
    county_fips: 41029,
    county_fips_all: '41029',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"41029": 100}',
    density: 380.4,
    imprecise: false,
    latitude: 42.2856,
    longitude: -122.89459,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44670,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97501',
  },
  {
    city: 'Central Point',
    county_fips: 41029,
    county_fips_all: '41029',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"41029": 100}',
    density: 136.8,
    imprecise: false,
    latitude: 42.40927,
    longitude: -122.94718,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97502',
  },
  {
    city: 'White City',
    county_fips: 41029,
    county_fips_all: '41029',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"41029": 100}',
    density: 65.9,
    imprecise: false,
    latitude: 42.5836,
    longitude: -122.92721,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13938,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97503',
  },
  {
    city: 'Medford',
    county_fips: 41029,
    county_fips_all: '41029',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"41029": 100}',
    density: 455.5,
    imprecise: false,
    latitude: 42.32757,
    longitude: -122.80068,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 51089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97504',
  },
  {
    city: 'Ashland',
    county_fips: 41029,
    county_fips_all: '41029',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"41029": 100}',
    density: 31.1,
    imprecise: false,
    latitude: 42.15472,
    longitude: -122.53168,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97520',
  },
  {
    city: 'Butte Falls',
    county_fips: 41029,
    county_fips_all: '41029',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"41029": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 42.56594,
    longitude: -122.46886,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97522',
  },
  {
    city: 'Cave Junction',
    county_fips: 41033,
    county_fips_all: '41033',
    county: 'Josephine',
    county_names_all: 'Josephine',
    county_weights: '{"41033": 100}',
    density: 11.1,
    imprecise: false,
    latitude: 42.11349,
    longitude: -123.62961,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97523',
  },
  {
    city: 'Eagle Point',
    county_fips: 41029,
    county_fips_all: '41029',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"41029": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 42.46271,
    longitude: -122.66327,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15078,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97524',
  },
  {
    city: 'Gold Hill',
    county_fips: 41029,
    county_fips_all: '41029',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"41029": 100}',
    density: 18.3,
    imprecise: false,
    latitude: 42.43557,
    longitude: -123.07606,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5129,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97525',
  },
  {
    city: 'Grants Pass',
    county_fips: 41033,
    county_fips_all: '41033|41029',
    county: 'Josephine',
    county_names_all: 'Josephine|Jackson',
    county_weights: '{"41033": 99.15, "41029": 0.85}',
    density: 98.9,
    imprecise: false,
    latitude: 42.51275,
    longitude: -123.33964,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36036,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97526',
  },
  {
    city: 'Grants Pass',
    county_fips: 41033,
    county_fips_all: '41033|41029',
    county: 'Josephine',
    county_names_all: 'Josephine|Jackson',
    county_weights: '{"41033": 86.86, "41029": 13.14}',
    density: 65.6,
    imprecise: false,
    latitude: 42.37615,
    longitude: -123.38288,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97527',
  },
  {
    city: 'Jacksonville',
    county_fips: 41029,
    county_fips_all: '41029|41033',
    county: 'Jackson',
    county_names_all: 'Jackson|Josephine',
    county_weights: '{"41029": 80.44, "41033": 19.56}',
    density: 7.4,
    imprecise: false,
    latitude: 42.13778,
    longitude: -123.10507,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97530',
  },
  {
    city: 'Kerby',
    county_fips: 41033,
    county_fips_all: '41033',
    county: 'Josephine',
    county_names_all: 'Josephine',
    county_weights: '{"41033": 100}',
    density: 19.4,
    imprecise: false,
    latitude: 42.20739,
    longitude: -123.64391,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97531',
  },
  {
    city: 'Merlin',
    county_fips: 41033,
    county_fips_all: '41033',
    county: 'Josephine',
    county_names_all: 'Josephine',
    county_weights: '{"41033": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 42.56142,
    longitude: -123.58586,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97532',
  },
  {
    city: "O'Brien",
    county_fips: 41033,
    county_fips_all: '41033',
    county: 'Josephine',
    county_names_all: 'Josephine',
    county_weights: '{"41033": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 42.03616,
    longitude: -123.71641,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97534',
  },
  {
    city: 'Phoenix',
    county_fips: 41029,
    county_fips_all: '41029',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"41029": 100}',
    density: 564.9,
    imprecise: false,
    latitude: 42.26799,
    longitude: -122.81238,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4804,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97535',
  },
  {
    city: 'Prospect',
    county_fips: 41029,
    county_fips_all: '41029',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"41029": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 42.78455,
    longitude: -122.50802,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1309,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97536',
  },
  {
    city: 'Rogue River',
    county_fips: 41029,
    county_fips_all: '41029',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"41029": 100}',
    density: 21.8,
    imprecise: false,
    latitude: 42.55041,
    longitude: -123.13357,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97537',
  },
  {
    city: 'Selma',
    county_fips: 41033,
    county_fips_all: '41033',
    county: 'Josephine',
    county_names_all: 'Josephine',
    county_weights: '{"41033": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 42.29623,
    longitude: -123.65723,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97538',
  },
  {
    city: 'Shady Cove',
    county_fips: 41029,
    county_fips_all: '41029',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"41029": 100}',
    density: 59.6,
    imprecise: false,
    latitude: 42.59999,
    longitude: -122.79024,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97539',
  },
  {
    city: 'Talent',
    county_fips: 41029,
    county_fips_all: '41029',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"41029": 100}',
    density: 71.5,
    imprecise: false,
    latitude: 42.18615,
    longitude: -122.80027,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97540',
  },
  {
    city: 'Trail',
    county_fips: 41029,
    county_fips_all: '41029',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"41029": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 42.72983,
    longitude: -122.75359,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97541',
  },
  {
    city: 'Wilderville',
    county_fips: 41033,
    county_fips_all: '41033',
    county: 'Josephine',
    county_names_all: 'Josephine',
    county_weights: '{"41033": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 42.37724,
    longitude: -123.56031,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97543',
  },
  {
    city: 'Williams',
    county_fips: 41033,
    county_fips_all: '41033',
    county: 'Josephine',
    county_names_all: 'Josephine',
    county_weights: '{"41033": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 42.207,
    longitude: -123.30006,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97544',
  },
  {
    city: 'Klamath Falls',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 42.44404,
    longitude: -122.06741,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97601',
  },
  {
    city: 'Klamath Falls',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 37.7,
    imprecise: false,
    latitude: 42.13704,
    longitude: -121.67766,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97603',
  },
  {
    city: 'Crater Lake',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.97778,
    longitude: -122.20674,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97604',
  },
  {
    city: 'Adel',
    county_fips: 41037,
    county_fips_all: '41037',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"41037": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 42.223,
    longitude: -119.89677,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97620',
  },
  {
    city: 'Beatty',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 42.51504,
    longitude: -121.2881,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 257,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97621',
  },
  {
    city: 'Bly',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 42.39667,
    longitude: -121.01032,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97622',
  },
  {
    city: 'Bonanza',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 3,
    imprecise: false,
    latitude: 42.19905,
    longitude: -121.31016,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2813,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97623',
  },
  {
    city: 'Chiloquin',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 42.72121,
    longitude: -121.69415,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97624',
  },
  {
    city: 'Dairy',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 1,
    imprecise: false,
    latitude: 42.31507,
    longitude: -121.58402,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97625',
  },
  {
    city: 'Fort Klamath',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 42.72488,
    longitude: -122.02011,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97626',
  },
  {
    city: 'Keno',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 42.08036,
    longitude: -122.05796,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97627',
  },
  {
    city: 'Lakeview',
    county_fips: 41037,
    county_fips_all: '41037',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"41037": 100}',
    density: 2,
    imprecise: false,
    latitude: 42.29832,
    longitude: -120.39166,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97630',
  },
  {
    city: 'Malin',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 9.7,
    imprecise: false,
    latitude: 42.04175,
    longitude: -121.40597,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1600,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97632',
  },
  {
    city: 'Merrill',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 16.9,
    imprecise: false,
    latitude: 42.03014,
    longitude: -121.56328,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97633',
  },
  {
    city: 'Midland',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 32.7,
    imprecise: false,
    latitude: 42.12747,
    longitude: -121.80348,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97634',
  },
  {
    city: 'New Pine Creek',
    county_fips: 6049,
    county_fips_all: '06049|41037',
    county: 'Modoc',
    county_names_all: 'Modoc|Lake',
    county_weights: '{"06049": 92.79, "41037": 7.21}',
    density: 1.8,
    imprecise: false,
    latitude: 41.93173,
    longitude: -120.29974,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97635',
  },
  {
    city: 'Paisley',
    county_fips: 41037,
    county_fips_all: '41037',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"41037": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 42.68775,
    longitude: -120.56746,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97636',
  },
  {
    city: 'Plush',
    county_fips: 41037,
    county_fips_all: '41037',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"41037": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 42.46142,
    longitude: -119.92486,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97637',
  },
  {
    city: 'Silver Lake',
    county_fips: 41037,
    county_fips_all: '41037',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"41037": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 43.1458,
    longitude: -121.01156,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 373,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97638',
  },
  {
    city: 'Sprague River',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 42.43435,
    longitude: -121.49845,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97639',
  },
  {
    city: 'Summer Lake',
    county_fips: 41037,
    county_fips_all: '41037',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"41037": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 42.90742,
    longitude: -120.65381,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97640',
  },
  {
    city: 'Christmas Valley',
    county_fips: 41037,
    county_fips_all: '41037',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"41037": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 43.28742,
    longitude: -120.53809,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97641',
  },
  {
    city: 'Bend',
    county_fips: 41017,
    county_fips_all: '41017|41013',
    county: 'Deschutes',
    county_names_all: 'Deschutes|Crook',
    county_weights: '{"41017": 92.44, "41013": 7.56}',
    density: 53.6,
    imprecise: false,
    latitude: 44.00065,
    longitude: -121.03289,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43293,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97701',
  },
  {
    city: 'Bend',
    county_fips: 41017,
    county_fips_all: '41017',
    county: 'Deschutes',
    county_names_all: 'Deschutes',
    county_weights: '{"41017": 100}',
    density: 203.9,
    imprecise: false,
    latitude: 43.98336,
    longitude: -121.21083,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54657,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97702',
  },
  {
    city: 'Bend',
    county_fips: 41017,
    county_fips_all: '41017',
    county: 'Deschutes',
    county_names_all: 'Deschutes',
    county_weights: '{"41017": 100}',
    density: 48.8,
    imprecise: false,
    latitude: 44.07281,
    longitude: -121.51971,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97703',
  },
  {
    city: 'Bend',
    county_fips: 41017,
    county_fips_all: '41017',
    county: 'Deschutes',
    county_names_all: 'Deschutes',
    county_weights: '{"41017": 100}',
    density: 41,
    imprecise: false,
    latitude: 43.83031,
    longitude: -121.49365,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6661,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97707',
  },
  {
    city: 'Bend',
    county_fips: 41017,
    county_fips_all: '41017',
    county: 'Deschutes',
    county_names_all: 'Deschutes',
    county_weights: '{"41017": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.89338,
    longitude: -121.85627,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97709',
  },
  {
    city: 'Fields',
    county_fips: 41025,
    county_fips_all: '41025',
    county: 'Harney',
    county_names_all: 'Harney',
    county_weights: '{"41025": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.15095,
    longitude: -118.53902,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97710',
  },
  {
    city: 'Ashwood',
    county_fips: 41031,
    county_fips_all: '41031',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"41031": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.7239,
    longitude: -120.63489,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97711',
  },
  {
    city: 'Brothers',
    county_fips: 41017,
    county_fips_all: '41017',
    county: 'Deschutes',
    county_names_all: 'Deschutes',
    county_weights: '{"41017": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 43.77825,
    longitude: -120.42866,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 60,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97712',
  },
  {
    city: 'Burns',
    county_fips: 41025,
    county_fips_all: '41025',
    county: 'Harney',
    county_names_all: 'Harney',
    county_weights: '{"41025": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 43.58799,
    longitude: -118.85806,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4397,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97720',
  },
  {
    city: 'Princeton',
    county_fips: 41025,
    county_fips_all: '41025',
    county: 'Harney',
    county_names_all: 'Harney',
    county_weights: '{"41025": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.88772,
    longitude: -118.52635,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 141,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97721',
  },
  {
    city: 'Diamond',
    county_fips: 41025,
    county_fips_all: '41025',
    county: 'Harney',
    county_names_all: 'Harney',
    county_weights: '{"41025": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 42.95733,
    longitude: -118.69241,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97722',
  },
  {
    city: 'Camp Sherman',
    county_fips: 41031,
    county_fips_all: '41031',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"41031": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 44.52265,
    longitude: -121.64535,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97730',
  },
  {
    city: 'Chemult',
    county_fips: 41035,
    county_fips_all: '41035|41019',
    county: 'Klamath',
    county_names_all: 'Klamath|Douglas',
    county_weights: '{"41035": 66.13, "41019": 33.87}',
    density: 0.7,
    imprecise: false,
    latitude: 43.1315,
    longitude: -121.92089,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97731',
  },
  {
    city: 'Crane',
    county_fips: 41025,
    county_fips_all: '41025',
    county: 'Harney',
    county_names_all: 'Harney',
    county_weights: '{"41025": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 43.41369,
    longitude: -118.40265,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97732',
  },
  {
    city: 'Crescent',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 43.38441,
    longitude: -121.94778,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 639,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97733',
  },
  {
    city: 'Culver',
    county_fips: 41031,
    county_fips_all: '41031',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"41031": 100}',
    density: 8.1,
    imprecise: false,
    latitude: 44.53502,
    longitude: -121.33395,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97734',
  },
  {
    city: 'Fort Rock',
    county_fips: 41037,
    county_fips_all: '41037',
    county: 'Lake',
    county_names_all: 'Lake',
    county_weights: '{"41037": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 43.39014,
    longitude: -120.99224,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97735',
  },
  {
    city: 'Frenchglen',
    county_fips: 41025,
    county_fips_all: '41025',
    county: 'Harney',
    county_names_all: 'Harney',
    county_weights: '{"41025": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.66655,
    longitude: -118.92058,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97736',
  },
  {
    city: 'Gilchrist',
    county_fips: 41035,
    county_fips_all: '41035',
    county: 'Klamath',
    county_names_all: 'Klamath',
    county_weights: '{"41035": 100}',
    density: 9.5,
    imprecise: false,
    latitude: 43.50897,
    longitude: -121.71917,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97737',
  },
  {
    city: 'Hines',
    county_fips: 41025,
    county_fips_all: '41025',
    county: 'Harney',
    county_names_all: 'Harney',
    county_weights: '{"41025": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 43.51218,
    longitude: -119.25078,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2236,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97738',
  },
  {
    city: 'La Pine',
    county_fips: 41017,
    county_fips_all: '41017|41035',
    county: 'Deschutes',
    county_names_all: 'Deschutes|Klamath',
    county_weights: '{"41017": 73.96, "41035": 26.04}',
    density: 16.7,
    imprecise: false,
    latitude: 43.67259,
    longitude: -121.48693,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13183,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97739',
  },
  {
    city: 'Madras',
    county_fips: 41031,
    county_fips_all: '41031|41065',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Wasco',
    county_weights: '{"41031": 96.09, "41065": 3.91}',
    density: 14.5,
    imprecise: false,
    latitude: 44.65771,
    longitude: -121.04291,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97741',
  },
  {
    city: 'Mitchell',
    county_fips: 41069,
    county_fips_all: '41069',
    county: 'Wheeler',
    county_names_all: 'Wheeler',
    county_weights: '{"41069": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 44.67037,
    longitude: -120.12704,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 416,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97750',
  },
  {
    city: 'Paulina',
    county_fips: 41013,
    county_fips_all: '41013',
    county: 'Crook',
    county_names_all: 'Crook',
    county_weights: '{"41013": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 44.14856,
    longitude: -119.81945,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97751',
  },
  {
    city: 'Post',
    county_fips: 41013,
    county_fips_all: '41013',
    county: 'Crook',
    county_names_all: 'Crook',
    county_weights: '{"41013": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.14094,
    longitude: -120.20584,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97752',
  },
  {
    city: 'Powell Butte',
    county_fips: 41013,
    county_fips_all: '41013',
    county: 'Crook',
    county_names_all: 'Crook',
    county_weights: '{"41013": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 44.22625,
    longitude: -120.99996,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97753',
  },
  {
    city: 'Prineville',
    county_fips: 41013,
    county_fips_all: '41013|41031|41025',
    county: 'Crook',
    county_names_all: 'Crook|Jefferson|Harney',
    county_weights: '{"41013": 97.08, "41031": 2.09, "41025": 0.83}',
    density: 6.5,
    imprecise: false,
    latitude: 44.13577,
    longitude: -120.52848,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97754',
  },
  {
    city: 'Redmond',
    county_fips: 41017,
    county_fips_all: '41017|41013',
    county: 'Deschutes',
    county_names_all: 'Deschutes|Crook',
    county_weights: '{"41017": 83.9, "41013": 16.1}',
    density: 137.3,
    imprecise: false,
    latitude: 44.28079,
    longitude: -121.19335,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44914,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97756',
  },
  {
    city: 'Riley',
    county_fips: 41025,
    county_fips_all: '41025|41037',
    county: 'Harney',
    county_names_all: 'Harney|Lake',
    county_weights: '{"41025": 75.54, "41037": 24.46}',
    density: 0.1,
    imprecise: false,
    latitude: 43.41449,
    longitude: -119.74859,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 91,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97758',
  },
  {
    city: 'Sisters',
    county_fips: 41043,
    county_fips_all: '41043|41031|41017',
    county: 'Linn',
    county_names_all: 'Linn|Jefferson|Deschutes',
    county_weights: '{"41043": 42.32, "41031": 31.0, "41017": 26.68}',
    density: 5.5,
    imprecise: false,
    latitude: 44.44428,
    longitude: -121.76823,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97759',
  },
  {
    city: 'Terrebonne',
    county_fips: 41017,
    county_fips_all: '41017|41031|41013',
    county: 'Deschutes',
    county_names_all: 'Deschutes|Jefferson|Crook',
    county_weights: '{"41017": 46.07, "41031": 37.1, "41013": 16.82}',
    density: 36.8,
    imprecise: false,
    latitude: 44.38662,
    longitude: -121.23323,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97760',
  },
  {
    city: 'Warm Springs',
    county_fips: 41065,
    county_fips_all: '41065|41031',
    county: 'Wasco',
    county_names_all: 'Wasco|Jefferson',
    county_weights: '{"41065": 61.4, "41031": 38.6}',
    density: 3.1,
    imprecise: false,
    latitude: 44.8433,
    longitude: -121.29807,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97761',
  },
  {
    city: 'Pendleton',
    county_fips: 41059,
    county_fips_all: '41059',
    county: 'Umatilla',
    county_names_all: 'Umatilla',
    county_weights: '{"41059": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 45.67317,
    longitude: -118.83362,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21575,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97801',
  },
  {
    city: 'Adams',
    county_fips: 41059,
    county_fips_all: '41059',
    county: 'Umatilla',
    county_names_all: 'Umatilla',
    county_weights: '{"41059": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 45.6725,
    longitude: -118.39642,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97810',
  },
  {
    city: 'Arlington',
    county_fips: 41021,
    county_fips_all: '41021',
    county: 'Gilliam',
    county_names_all: 'Gilliam',
    county_weights: '{"41021": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 45.58138,
    longitude: -120.21907,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97812',
  },
  {
    city: 'Athena',
    county_fips: 41059,
    county_fips_all: '41059',
    county: 'Umatilla',
    county_names_all: 'Umatilla',
    county_weights: '{"41059": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 45.85305,
    longitude: -118.52802,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97813',
  },
  {
    city: 'Baker City',
    county_fips: 41001,
    county_fips_all: '41001|41061',
    county: 'Baker',
    county_names_all: 'Baker|Union',
    county_weights: '{"41001": 94.87, "41061": 5.13}',
    density: 5.9,
    imprecise: false,
    latitude: 44.80075,
    longitude: -117.77034,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12590,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97814',
  },
  {
    city: 'Bates',
    county_fips: 41023,
    county_fips_all: '41023',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"41023": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.6555,
    longitude: -118.60816,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97817',
  },
  {
    city: 'Boardman',
    county_fips: 41049,
    county_fips_all: '41049',
    county: 'Morrow',
    county_names_all: 'Morrow',
    county_weights: '{"41049": 100}',
    density: 10.2,
    imprecise: false,
    latitude: 45.7567,
    longitude: -119.78444,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5610,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97818',
  },
  {
    city: 'Bridgeport',
    county_fips: 41001,
    county_fips_all: '41001',
    county: 'Baker',
    county_names_all: 'Baker',
    county_weights: '{"41001": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 44.48603,
    longitude: -117.76317,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97819',
  },
  {
    city: 'Canyon City',
    county_fips: 41023,
    county_fips_all: '41023',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"41023": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 44.16327,
    longitude: -119.21436,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97820',
  },
  {
    city: 'Condon',
    county_fips: 41021,
    county_fips_all: '41021|41069',
    county: 'Gilliam',
    county_names_all: 'Gilliam|Wheeler',
    county_weights: '{"41021": 98.22, "41069": 1.78}',
    density: 0.6,
    imprecise: false,
    latitude: 45.24334,
    longitude: -120.19097,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1014,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97823',
  },
  {
    city: 'Cove',
    county_fips: 41061,
    county_fips_all: '41061',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"41061": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 45.34992,
    longitude: -117.75506,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97824',
  },
  {
    city: 'Dayville',
    county_fips: 41023,
    county_fips_all: '41023',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"41023": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 44.38804,
    longitude: -119.51852,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97825',
  },
  {
    city: 'Echo',
    county_fips: 41059,
    county_fips_all: '41059|41049',
    county: 'Umatilla',
    county_names_all: 'Umatilla|Morrow',
    county_weights: '{"41059": 86.25, "41049": 13.75}',
    density: 1.4,
    imprecise: false,
    latitude: 45.65508,
    longitude: -119.22586,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97826',
  },
  {
    city: 'Elgin',
    county_fips: 41061,
    county_fips_all: '41061',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"41061": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 45.60854,
    longitude: -117.85886,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97827',
  },
  {
    city: 'Enterprise',
    county_fips: 41063,
    county_fips_all: '41063',
    county: 'Wallowa',
    county_names_all: 'Wallowa',
    county_weights: '{"41063": 100}',
    density: 2,
    imprecise: false,
    latitude: 45.71382,
    longitude: -117.25971,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97828',
  },
  {
    city: 'Fossil',
    county_fips: 41069,
    county_fips_all: '41069|41021',
    county: 'Wheeler',
    county_names_all: 'Wheeler|Gilliam',
    county_weights: '{"41069": 86.71, "41021": 13.29}',
    density: 0.7,
    imprecise: false,
    latitude: 44.9779,
    longitude: -120.17165,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97830',
  },
  {
    city: 'Haines',
    county_fips: 41001,
    county_fips_all: '41001',
    county: 'Baker',
    county_names_all: 'Baker',
    county_weights: '{"41001": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 44.93471,
    longitude: -118.05951,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 863,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97833',
  },
  {
    city: 'Halfway',
    county_fips: 41001,
    county_fips_all: '41001',
    county: 'Baker',
    county_names_all: 'Baker',
    county_weights: '{"41001": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 44.97251,
    longitude: -117.20509,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97834',
  },
  {
    city: 'Helix',
    county_fips: 41059,
    county_fips_all: '41059',
    county: 'Umatilla',
    county_names_all: 'Umatilla',
    county_weights: '{"41059": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 45.8992,
    longitude: -118.772,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97835',
  },
  {
    city: 'Heppner',
    county_fips: 41049,
    county_fips_all: '41049',
    county: 'Morrow',
    county_names_all: 'Morrow',
    county_weights: '{"41049": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 45.29166,
    longitude: -119.50144,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1998,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97836',
  },
  {
    city: 'Hereford',
    county_fips: 41001,
    county_fips_all: '41001',
    county: 'Baker',
    county_names_all: 'Baker',
    county_weights: '{"41001": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 44.51127,
    longitude: -118.0483,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 78,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97837',
  },
  {
    city: 'Hermiston',
    county_fips: 41059,
    county_fips_all: '41059|41049',
    county: 'Umatilla',
    county_names_all: 'Umatilla|Morrow',
    county_weights: '{"41059": 75.52, "41049": 24.48}',
    density: 54.4,
    imprecise: false,
    latitude: 45.85266,
    longitude: -119.28878,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97838',
  },
  {
    city: 'Lexington',
    county_fips: 41049,
    county_fips_all: '41049',
    county: 'Morrow',
    county_names_all: 'Morrow',
    county_weights: '{"41049": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 45.58272,
    longitude: -119.60005,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97839',
  },
  {
    city: 'Oxbow',
    county_fips: 41001,
    county_fips_all: '41001',
    county: 'Baker',
    county_names_all: 'Baker',
    county_weights: '{"41001": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 44.90218,
    longitude: -116.93608,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97840',
  },
  {
    city: 'Imbler',
    county_fips: 41061,
    county_fips_all: '41061',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"41061": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 45.46823,
    longitude: -117.94035,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97841',
  },
  {
    city: 'Imnaha',
    county_fips: 41063,
    county_fips_all: '41063',
    county: 'Wallowa',
    county_names_all: 'Wallowa',
    county_weights: '{"41063": 100}',
    density: 0,
    imprecise: false,
    latitude: 45.57223,
    longitude: -116.82384,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97842',
  },
  {
    city: 'Ione',
    county_fips: 41049,
    county_fips_all: '41049|41021',
    county: 'Morrow',
    county_names_all: 'Morrow|Gilliam',
    county_weights: '{"41049": 94.71, "41021": 5.29}',
    density: 0.8,
    imprecise: false,
    latitude: 45.50479,
    longitude: -119.88066,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 805,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97843',
  },
  {
    city: 'Irrigon',
    county_fips: 41049,
    county_fips_all: '41049',
    county: 'Morrow',
    county_names_all: 'Morrow',
    county_weights: '{"41049": 100}',
    density: 43.3,
    imprecise: false,
    latitude: 45.87867,
    longitude: -119.54676,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3701,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97844',
  },
  {
    city: 'John Day',
    county_fips: 41023,
    county_fips_all: '41023',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"41023": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 44.41445,
    longitude: -118.90372,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97845',
  },
  {
    city: 'Joseph',
    county_fips: 41063,
    county_fips_all: '41063',
    county: 'Wallowa',
    county_names_all: 'Wallowa',
    county_weights: '{"41063": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 45.27465,
    longitude: -117.10956,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97846',
  },
  {
    city: 'Kimberly',
    county_fips: 41023,
    county_fips_all: '41023|41069',
    county: 'Grant',
    county_names_all: 'Grant|Wheeler',
    county_weights: '{"41023": 99.17, "41069": 0.83}',
    density: 0.4,
    imprecise: false,
    latitude: 44.69761,
    longitude: -119.57336,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 217,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97848',
  },
  {
    city: 'La Grande',
    county_fips: 41061,
    county_fips_all: '41061',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"41061": 100}',
    density: 20.4,
    imprecise: false,
    latitude: 45.30689,
    longitude: -118.13265,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97850',
  },
  {
    city: 'Long Creek',
    county_fips: 41023,
    county_fips_all: '41023',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"41023": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 44.78426,
    longitude: -119.12976,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 485,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97856',
  },
  {
    city: 'Lostine',
    county_fips: 41063,
    county_fips_all: '41063',
    county: 'Wallowa',
    county_names_all: 'Wallowa',
    county_weights: '{"41063": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 45.37273,
    longitude: -117.50418,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 483,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97857',
  },
  {
    city: 'Meacham',
    county_fips: 41059,
    county_fips_all: '41059',
    county: 'Umatilla',
    county_names_all: 'Umatilla',
    county_weights: '{"41059": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 45.5258,
    longitude: -118.43209,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 95,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97859',
  },
  {
    city: 'Milton Freewater',
    county_fips: 41059,
    county_fips_all: '41059',
    county: 'Umatilla',
    county_names_all: 'Umatilla',
    county_weights: '{"41059": 100}',
    density: 16.2,
    imprecise: false,
    latitude: 45.92712,
    longitude: -118.31797,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97862',
  },
  {
    city: 'Monument',
    county_fips: 41023,
    county_fips_all: '41023',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"41023": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 44.83842,
    longitude: -119.45471,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97864',
  },
  {
    city: 'Mount Vernon',
    county_fips: 41023,
    county_fips_all: '41023',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"41023": 100}',
    density: 1,
    imprecise: false,
    latitude: 44.42949,
    longitude: -119.19192,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97865',
  },
  {
    city: 'North Powder',
    county_fips: 41061,
    county_fips_all: '41061|41001',
    county: 'Union',
    county_names_all: 'Union|Baker',
    county_weights: '{"41061": 74.26, "41001": 25.74}',
    density: 2.4,
    imprecise: false,
    latitude: 45.0627,
    longitude: -117.997,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 947,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97867',
  },
  {
    city: 'Pilot Rock',
    county_fips: 41059,
    county_fips_all: '41059',
    county: 'Umatilla',
    county_names_all: 'Umatilla',
    county_weights: '{"41059": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 45.40815,
    longitude: -118.86964,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1598,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97868',
  },
  {
    city: 'Prairie City',
    county_fips: 41023,
    county_fips_all: '41023|41001',
    county: 'Grant',
    county_names_all: 'Grant|Baker',
    county_weights: '{"41023": 92.15, "41001": 7.85}',
    density: 1.1,
    imprecise: false,
    latitude: 44.37993,
    longitude: -118.61425,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97869',
  },
  {
    city: 'Richland',
    county_fips: 41001,
    county_fips_all: '41001',
    county: 'Baker',
    county_names_all: 'Baker',
    county_weights: '{"41001": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 44.79434,
    longitude: -117.19033,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97870',
  },
  {
    city: 'Seneca',
    county_fips: 41023,
    county_fips_all: '41023',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"41023": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 44.12837,
    longitude: -118.99505,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97873',
  },
  {
    city: 'Spray',
    county_fips: 41069,
    county_fips_all: '41069',
    county: 'Wheeler',
    county_names_all: 'Wheeler',
    county_weights: '{"41069": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 44.75783,
    longitude: -119.84828,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97874',
  },
  {
    city: 'Stanfield',
    county_fips: 41059,
    county_fips_all: '41059',
    county: 'Umatilla',
    county_names_all: 'Umatilla',
    county_weights: '{"41059": 100}',
    density: 16,
    imprecise: false,
    latitude: 45.81481,
    longitude: -119.14898,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97875',
  },
  {
    city: 'Summerville',
    county_fips: 41061,
    county_fips_all: '41061',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"41061": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 45.52237,
    longitude: -118.02811,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97876',
  },
  {
    city: 'Sumpter',
    county_fips: 41023,
    county_fips_all: '41023|41001',
    county: 'Grant',
    county_names_all: 'Grant|Baker',
    county_weights: '{"41023": 65.85, "41001": 34.15}',
    density: 0.6,
    imprecise: false,
    latitude: 44.80662,
    longitude: -118.38766,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97877',
  },
  {
    city: 'Ukiah',
    county_fips: 41059,
    county_fips_all: '41059|41023',
    county: 'Umatilla',
    county_names_all: 'Umatilla|Grant',
    county_weights: '{"41059": 84.71, "41023": 15.29}',
    density: 0.3,
    imprecise: false,
    latitude: 45.08631,
    longitude: -118.89269,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 248,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97880',
  },
  {
    city: 'Umatilla',
    county_fips: 41059,
    county_fips_all: '41059',
    county: 'Umatilla',
    county_names_all: 'Umatilla',
    county_weights: '{"41059": 100}',
    density: 163.4,
    imprecise: false,
    latitude: 45.90741,
    longitude: -119.34944,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97882',
  },
  {
    city: 'Union',
    county_fips: 41061,
    county_fips_all: '41061',
    county: 'Union',
    county_names_all: 'Union',
    county_weights: '{"41061": 100}',
    density: 3,
    imprecise: false,
    latitude: 45.14264,
    longitude: -117.64047,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97883',
  },
  {
    city: 'Unity',
    county_fips: 41001,
    county_fips_all: '41001',
    county: 'Baker',
    county_names_all: 'Baker',
    county_weights: '{"41001": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 44.44975,
    longitude: -118.21895,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97884',
  },
  {
    city: 'Wallowa',
    county_fips: 41063,
    county_fips_all: '41063',
    county: 'Wallowa',
    county_names_all: 'Wallowa',
    county_weights: '{"41063": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 45.65073,
    longitude: -117.50972,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1365,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97885',
  },
  {
    city: 'Weston',
    county_fips: 41059,
    county_fips_all: '41059',
    county: 'Umatilla',
    county_names_all: 'Umatilla',
    county_weights: '{"41059": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 45.79604,
    longitude: -118.24924,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97886',
  },
  {
    city: 'Adrian',
    county_fips: 41045,
    county_fips_all: '41045',
    county: 'Malheur',
    county_names_all: 'Malheur',
    county_weights: '{"41045": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 43.5996,
    longitude: -117.09602,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 954,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97901',
  },
  {
    city: 'Arock',
    county_fips: 41045,
    county_fips_all: '41045',
    county: 'Malheur',
    county_names_all: 'Malheur',
    county_weights: '{"41045": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 42.91332,
    longitude: -117.49412,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97902',
  },
  {
    city: 'Brogan',
    county_fips: 41045,
    county_fips_all: '41045',
    county: 'Malheur',
    county_names_all: 'Malheur',
    county_weights: '{"41045": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 44.27772,
    longitude: -117.59775,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97903',
  },
  {
    city: 'Drewsey',
    county_fips: 41025,
    county_fips_all: '41025',
    county: 'Harney',
    county_names_all: 'Harney',
    county_weights: '{"41025": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 43.89136,
    longitude: -118.50581,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97904',
  },
  {
    city: 'Durkee',
    county_fips: 41001,
    county_fips_all: '41001',
    county: 'Baker',
    county_names_all: 'Baker',
    county_weights: '{"41001": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 44.58183,
    longitude: -117.4654,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97905',
  },
  {
    city: 'Harper',
    county_fips: 41045,
    county_fips_all: '41045',
    county: 'Malheur',
    county_names_all: 'Malheur',
    county_weights: '{"41045": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 43.46049,
    longitude: -117.81783,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 360,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97906',
  },
  {
    city: 'Huntington',
    county_fips: 41001,
    county_fips_all: '41001|41045',
    county: 'Baker',
    county_names_all: 'Baker|Malheur',
    county_weights: '{"41001": 73.77, "41045": 26.23}',
    density: 0.9,
    imprecise: false,
    latitude: 44.41893,
    longitude: -117.35568,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 821,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97907',
  },
  {
    city: 'Ironside',
    county_fips: 41045,
    county_fips_all: '41045',
    county: 'Malheur',
    county_names_all: 'Malheur',
    county_weights: '{"41045": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.25679,
    longitude: -117.94828,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 30,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97908',
  },
  {
    city: 'Jamieson',
    county_fips: 41045,
    county_fips_all: '41045',
    county: 'Malheur',
    county_names_all: 'Malheur',
    county_weights: '{"41045": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 44.21096,
    longitude: -117.37909,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 24,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97909',
  },
  {
    city: 'Jordan Valley',
    county_fips: 41045,
    county_fips_all: '41045|16073',
    county: 'Malheur',
    county_names_all: 'Malheur|Owyhee',
    county_weights: '{"41045": 92.39, "16073": 7.61}',
    density: 0.1,
    imprecise: false,
    latitude: 42.85733,
    longitude: -117.50909,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97910',
  },
  {
    city: 'Juntura',
    county_fips: 41045,
    county_fips_all: '41045',
    county: 'Malheur',
    county_names_all: 'Malheur',
    county_weights: '{"41045": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.85547,
    longitude: -118.02605,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97911',
  },
  {
    city: 'Nyssa',
    county_fips: 41045,
    county_fips_all: '41045|16075',
    county: 'Malheur',
    county_names_all: 'Malheur|Payette',
    county_weights: '{"41045": 99.86, "16075": 0.14}',
    density: 5.4,
    imprecise: false,
    latitude: 43.64688,
    longitude: -117.28131,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 5520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97913',
  },
  {
    city: 'Ontario',
    county_fips: 41045,
    county_fips_all: '41045',
    county: 'Malheur',
    county_names_all: 'Malheur',
    county_weights: '{"41045": 100}',
    density: 29.3,
    imprecise: false,
    latitude: 44.11085,
    longitude: -117.07383,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 19713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97914',
  },
  {
    city: 'Riverside',
    county_fips: 41045,
    county_fips_all: '41045',
    county: 'Malheur',
    county_names_all: 'Malheur',
    county_weights: '{"41045": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 43.5415,
    longitude: -118.11651,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 50,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97917',
  },
  {
    city: 'Vale',
    county_fips: 41045,
    county_fips_all: '41045',
    county: 'Malheur',
    county_names_all: 'Malheur',
    county_weights: '{"41045": 100}',
    density: 3,
    imprecise: false,
    latitude: 43.96255,
    longitude: -117.38073,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 4567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97918',
  },
  {
    city: 'Westfall',
    county_fips: 41045,
    county_fips_all: '41045',
    county: 'Malheur',
    county_names_all: 'Malheur',
    county_weights: '{"41045": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 44.06595,
    longitude: -117.75997,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97920',
  },
  {
    city: 'Auburn',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 776.1,
    imprecise: false,
    latitude: 47.30919,
    longitude: -122.26426,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98001',
  },
  {
    city: 'Auburn',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2021.6,
    imprecise: false,
    latitude: 47.3082,
    longitude: -122.21567,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98002',
  },
  {
    city: 'Federal Way',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1732.9,
    imprecise: false,
    latitude: 47.30596,
    longitude: -122.31465,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 51619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98003',
  },
  {
    city: 'Bellevue',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2118.9,
    imprecise: false,
    latitude: 47.61865,
    longitude: -122.20548,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98004',
  },
  {
    city: 'Bellevue',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1149.4,
    imprecise: false,
    latitude: 47.61494,
    longitude: -122.16814,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21846,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98005',
  },
  {
    city: 'Bellevue',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1374.4,
    imprecise: false,
    latitude: 47.55772,
    longitude: -122.14957,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98006',
  },
  {
    city: 'Bellevue',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2474.9,
    imprecise: false,
    latitude: 47.61392,
    longitude: -122.14378,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98007',
  },
  {
    city: 'Bellevue',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1892.2,
    imprecise: false,
    latitude: 47.60551,
    longitude: -122.11219,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98008',
  },
  {
    city: 'Black Diamond',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 178.1,
    imprecise: false,
    latitude: 47.31173,
    longitude: -122.00326,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98010',
  },
  {
    city: 'Bothell',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1585.1,
    imprecise: false,
    latitude: 47.75736,
    longitude: -122.19871,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98011',
  },
  {
    city: 'Bothell',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 1899.6,
    imprecise: false,
    latitude: 47.84205,
    longitude: -122.19813,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 77041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98012',
  },
  {
    city: 'Carnation',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 36.6,
    imprecise: false,
    latitude: 47.69664,
    longitude: -121.84024,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98014',
  },
  {
    city: 'Duvall',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 132.5,
    imprecise: false,
    latitude: 47.74083,
    longitude: -121.93494,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98019',
  },
  {
    city: 'Edmonds',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 1458.7,
    imprecise: false,
    latitude: 47.80015,
    longitude: -122.37267,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98020',
  },
  {
    city: 'Bothell',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 1356,
    imprecise: false,
    latitude: 47.79257,
    longitude: -122.20846,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98021',
  },
  {
    city: 'Enumclaw',
    county_fips: 53033,
    county_fips_all: '53033|53053',
    county: 'King',
    county_names_all: 'King|Pierce',
    county_weights: '{"53033": 61.65, "53053": 38.35}',
    density: 11.9,
    imprecise: false,
    latitude: 47.1714,
    longitude: -121.67958,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98022',
  },
  {
    city: 'Federal Way',
    county_fips: 53033,
    county_fips_all: '53033|53053',
    county: 'King',
    county_names_all: 'King|Pierce',
    county_weights: '{"53033": 99.85, "53053": 0.15}',
    density: 1897.5,
    imprecise: false,
    latitude: 47.30881,
    longitude: -122.36198,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98023',
  },
  {
    city: 'Fall City',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 68.3,
    imprecise: false,
    latitude: 47.57301,
    longitude: -121.90219,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3908,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98024',
  },
  {
    city: 'Hobart',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 47.43441,
    longitude: -121.9524,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98025',
  },
  {
    city: 'Edmonds',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 1604,
    imprecise: false,
    latitude: 47.83555,
    longitude: -122.3316,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98026',
  },
  {
    city: 'Issaquah',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 195.5,
    imprecise: false,
    latitude: 47.50387,
    longitude: -122.00176,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28955,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98027',
  },
  {
    city: 'Kenmore',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1491.1,
    imprecise: false,
    latitude: 47.75162,
    longitude: -122.24892,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23741,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98028',
  },
  {
    city: 'Issaquah',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1160.8,
    imprecise: false,
    latitude: 47.5576,
    longitude: -122.0091,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98029',
  },
  {
    city: 'Kent',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2068.8,
    imprecise: false,
    latitude: 47.36817,
    longitude: -122.19749,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98030',
  },
  {
    city: 'Kent',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2001.8,
    imprecise: false,
    latitude: 47.4055,
    longitude: -122.1943,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98031',
  },
  {
    city: 'Kent',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 930.2,
    imprecise: false,
    latitude: 47.3922,
    longitude: -122.25819,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98032',
  },
  {
    city: 'Kirkland',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1719.3,
    imprecise: false,
    latitude: 47.67616,
    longitude: -122.19267,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98033',
  },
  {
    city: 'Kirkland',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2066.9,
    imprecise: false,
    latitude: 47.71612,
    longitude: -122.21332,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98034',
  },
  {
    city: 'Lynnwood',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 1705.7,
    imprecise: false,
    latitude: 47.81094,
    longitude: -122.28155,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98036',
  },
  {
    city: 'Lynnwood',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 1984.8,
    imprecise: false,
    latitude: 47.83873,
    longitude: -122.28463,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98037',
  },
  {
    city: 'Maple Valley',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 219,
    imprecise: false,
    latitude: 47.41861,
    longitude: -121.95589,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98038',
  },
  {
    city: 'Medina',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 787.6,
    imprecise: false,
    latitude: 47.63308,
    longitude: -122.23963,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2928,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98039',
  },
  {
    city: 'Mercer Island',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1530.9,
    imprecise: false,
    latitude: 47.56611,
    longitude: -122.232,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98040',
  },
  {
    city: 'Kent',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 697.8,
    imprecise: false,
    latitude: 47.36508,
    longitude: -122.11623,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98042',
  },
  {
    city: 'Mountlake Terrace',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 2202,
    imprecise: false,
    latitude: 47.7921,
    longitude: -122.30758,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98043',
  },
  {
    city: 'North Bend',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 34.3,
    imprecise: false,
    latitude: 47.48276,
    longitude: -121.65678,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98045',
  },
  {
    city: 'Pacific',
    county_fips: 53033,
    county_fips_all: '53033|53053',
    county: 'King',
    county_names_all: 'King|Pierce',
    county_weights: '{"53033": 70.56, "53053": 29.44}',
    density: 1229.9,
    imprecise: false,
    latitude: 47.26079,
    longitude: -122.24822,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98047',
  },
  {
    city: 'Preston',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 47.54764,
    longitude: -121.93663,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98050',
  },
  {
    city: 'Ravensdale',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 24.6,
    imprecise: false,
    latitude: 47.3396,
    longitude: -121.89049,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98051',
  },
  {
    city: 'Redmond',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1538.3,
    imprecise: false,
    latitude: 47.68148,
    longitude: -122.1203,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 80717,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98052',
  },
  {
    city: 'Redmond',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 317.9,
    imprecise: false,
    latitude: 47.66491,
    longitude: -122.02071,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98053',
  },
  {
    city: 'Renton',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2134.5,
    imprecise: false,
    latitude: 47.44775,
    longitude: -122.20205,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24660,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98055',
  },
  {
    city: 'Renton',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1827.2,
    imprecise: false,
    latitude: 47.51281,
    longitude: -122.18923,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98056',
  },
  {
    city: 'Renton',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 796.4,
    imprecise: false,
    latitude: 47.47188,
    longitude: -122.21961,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12705,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98057',
  },
  {
    city: 'Renton',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 881.7,
    imprecise: false,
    latitude: 47.44082,
    longitude: -122.12503,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98058',
  },
  {
    city: 'Renton',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1012.7,
    imprecise: false,
    latitude: 47.49563,
    longitude: -122.12474,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42406,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98059',
  },
  {
    city: 'Snoqualmie',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 87.5,
    imprecise: false,
    latitude: 47.59234,
    longitude: -121.78931,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15944,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98065',
  },
  {
    city: 'Snoqualmie Pass',
    county_fips: 53037,
    county_fips_all: '53037|53033',
    county: 'Kittitas',
    county_names_all: 'Kittitas|King',
    county_weights: '{"53037": 54.95, "53033": 45.05}',
    density: 0.8,
    imprecise: false,
    latitude: 47.45154,
    longitude: -121.35795,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 482,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98068',
  },
  {
    city: 'Vashon',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 103.8,
    imprecise: false,
    latitude: 47.41219,
    longitude: -122.4726,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98070',
  },
  {
    city: 'Woodinville',
    county_fips: 53033,
    county_fips_all: '53033|53061',
    county: 'King',
    county_names_all: 'King|Snohomish',
    county_weights: '{"53033": 72.29, "53061": 27.71}',
    density: 524.7,
    imprecise: false,
    latitude: 47.76151,
    longitude: -122.13153,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24446,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98072',
  },
  {
    city: 'Sammamish',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1132.4,
    imprecise: false,
    latitude: 47.62206,
    longitude: -122.04437,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30761,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98074',
  },
  {
    city: 'Sammamish',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1021.8,
    imprecise: false,
    latitude: 47.58683,
    longitude: -122.03796,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98075',
  },
  {
    city: 'Woodinville',
    county_fips: 53033,
    county_fips_all: '53033|53061',
    county: 'King',
    county_names_all: 'King|Snohomish',
    county_weights: '{"53033": 85.05, "53061": 14.95}',
    density: 315.1,
    imprecise: false,
    latitude: 47.75263,
    longitude: -122.05754,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98077',
  },
  {
    city: 'Lynnwood',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 2807.6,
    imprecise: false,
    latitude: 47.8624,
    longitude: -122.2664,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98087',
  },
  {
    city: 'Auburn',
    county_fips: 53033,
    county_fips_all: '53033|53053',
    county: 'King',
    county_names_all: 'King|Pierce',
    county_weights: '{"53033": 96.59, "53053": 3.41}',
    density: 452,
    imprecise: false,
    latitude: 47.28851,
    longitude: -122.13123,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50224,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98092',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 12535.5,
    imprecise: false,
    latitude: 47.61119,
    longitude: -122.33454,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98101',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 8290.4,
    imprecise: false,
    latitude: 47.63627,
    longitude: -122.32337,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27333,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98102',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 4435.9,
    imprecise: false,
    latitude: 47.6732,
    longitude: -122.34258,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98103',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 6756.3,
    imprecise: false,
    latitude: 47.60044,
    longitude: -122.33004,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16542,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98104',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 5007.7,
    imprecise: false,
    latitude: 47.66094,
    longitude: -122.28321,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98105',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2016.8,
    imprecise: false,
    latitude: 47.54339,
    longitude: -122.35366,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98106',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 5113.8,
    imprecise: false,
    latitude: 47.66757,
    longitude: -122.37789,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98107',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1336.1,
    imprecise: false,
    latitude: 47.54113,
    longitude: -122.3126,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25529,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98108',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 6851,
    imprecise: false,
    latitude: 47.63128,
    longitude: -122.34486,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98109',
  },
  {
    city: 'Bainbridge Island',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 344.4,
    imprecise: false,
    latitude: 47.64389,
    longitude: -122.54335,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24631,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98110',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2882.6,
    imprecise: false,
    latitude: 47.63242,
    longitude: -122.28732,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98112',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 3200.8,
    imprecise: false,
    latitude: 47.68547,
    longitude: -122.28234,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 54349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98115',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 3693,
    imprecise: false,
    latitude: 47.57399,
    longitude: -122.39503,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98116',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 3560.1,
    imprecise: false,
    latitude: 47.6882,
    longitude: -122.38157,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35711,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98117',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 3124.3,
    imprecise: false,
    latitude: 47.54235,
    longitude: -122.26872,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98118',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 4312.5,
    imprecise: false,
    latitude: 47.63943,
    longitude: -122.36932,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98119',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 18426.7,
    imprecise: false,
    latitude: 47.61548,
    longitude: -122.34668,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98121',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 7145.6,
    imprecise: false,
    latitude: 47.60985,
    longitude: -122.29569,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98122',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 3168.4,
    imprecise: false,
    latitude: 47.71706,
    longitude: -122.29969,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98125',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2863.6,
    imprecise: false,
    latitude: 47.54732,
    longitude: -122.37454,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98126',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2884.3,
    imprecise: false,
    latitude: 47.7399,
    longitude: -122.34432,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 53249,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98133',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 75.1,
    imprecise: false,
    latitude: 47.57691,
    longitude: -122.33686,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98134',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2902.9,
    imprecise: false,
    latitude: 47.53686,
    longitude: -122.38992,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17252,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98136',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 3869.1,
    imprecise: false,
    latitude: 47.58582,
    longitude: -122.29205,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33787,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98144',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2387.3,
    imprecise: false,
    latitude: 47.50008,
    longitude: -122.35768,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98146',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1383.7,
    imprecise: false,
    latitude: 47.44494,
    longitude: -122.32587,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9715,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98148',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 0,
    imprecise: false,
    latitude: 47.60621,
    longitude: -122.33379,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98154',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1868.6,
    imprecise: false,
    latitude: 47.75609,
    longitude: -122.30039,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36511,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98155',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 0,
    imprecise: false,
    latitude: 47.45043,
    longitude: -122.30805,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98158',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 31860.3,
    imprecise: false,
    latitude: 47.60596,
    longitude: -122.33203,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 292,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98164',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1476,
    imprecise: false,
    latitude: 47.45256,
    longitude: -122.34978,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98166',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1566.8,
    imprecise: false,
    latitude: 47.48898,
    longitude: -122.30175,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98168',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 0,
    imprecise: false,
    latitude: 47.60477,
    longitude: -122.33528,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98174',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1444,
    imprecise: false,
    latitude: 47.74237,
    longitude: -122.37085,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21090,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98177',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2107.1,
    imprecise: false,
    latitude: 47.49921,
    longitude: -122.24735,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98178',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1307.2,
    imprecise: false,
    latitude: 47.44754,
    longitude: -122.27398,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98188',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2022.4,
    imprecise: false,
    latitude: 47.39469,
    longitude: -122.31111,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40463,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98198',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2048.3,
    imprecise: false,
    latitude: 47.65139,
    longitude: -122.40223,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98199',
  },
  {
    city: 'Everett',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 656.7,
    imprecise: false,
    latitude: 47.99373,
    longitude: -122.18563,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98201',
  },
  {
    city: 'Everett',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 1159.6,
    imprecise: false,
    latitude: 47.94236,
    longitude: -122.23651,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35517,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98203',
  },
  {
    city: 'Everett',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 2425.8,
    imprecise: false,
    latitude: 47.90105,
    longitude: -122.2586,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98204',
  },
  {
    city: 'Everett',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 1543.6,
    imprecise: false,
    latitude: 47.90072,
    longitude: -122.18852,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 60915,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98208',
  },
  {
    city: 'Acme',
    county_fips: 53073,
    county_fips_all: '53073',
    county: 'Whatcom',
    county_names_all: 'Whatcom',
    county_weights: '{"53073": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 48.68526,
    longitude: -122.19678,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98220',
  },
  {
    city: 'Anacortes',
    county_fips: 53057,
    county_fips_all: '53057|53055',
    county: 'Skagit',
    county_names_all: 'Skagit|San Juan',
    county_weights: '{"53057": 89.25, "53055": 10.75}',
    density: 175.2,
    imprecise: false,
    latitude: 48.50401,
    longitude: -122.65435,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98221',
  },
  {
    city: 'Blakely Island',
    county_fips: 53055,
    county_fips_all: '53055',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"53055": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 48.56085,
    longitude: -122.80263,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 121,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98222',
  },
  {
    city: 'Arlington',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 56.8,
    imprecise: false,
    latitude: 48.20994,
    longitude: -121.95081,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98223',
  },
  {
    city: 'Baring',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 47.7357,
    longitude: -121.56859,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98224',
  },
  {
    city: 'Bellingham',
    county_fips: 53073,
    county_fips_all: '53073',
    county: 'Whatcom',
    county_names_all: 'Whatcom',
    county_weights: '{"53073": 100}',
    density: 1542.4,
    imprecise: false,
    latitude: 48.75461,
    longitude: -122.50307,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98225',
  },
  {
    city: 'Bellingham',
    county_fips: 53073,
    county_fips_all: '53073',
    county: 'Whatcom',
    county_names_all: 'Whatcom',
    county_weights: '{"53073": 100}',
    density: 170.7,
    imprecise: false,
    latitude: 48.80064,
    longitude: -122.42299,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46782,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98226',
  },
  {
    city: 'Bellingham',
    county_fips: 53073,
    county_fips_all: '53073|53057',
    county: 'Whatcom',
    county_names_all: 'Whatcom|Skagit',
    county_weights: '{"53073": 95.34, "53057": 4.66}',
    density: 256.3,
    imprecise: false,
    latitude: 48.69615,
    longitude: -122.40979,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98229',
  },
  {
    city: 'Blaine',
    county_fips: 53073,
    county_fips_all: '53073',
    county: 'Whatcom',
    county_names_all: 'Whatcom',
    county_weights: '{"53073": 100}',
    density: 170.2,
    imprecise: false,
    latitude: 48.95688,
    longitude: -122.7084,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98230',
  },
  {
    city: 'Bow',
    county_fips: 53057,
    county_fips_all: '53057',
    county: 'Skagit',
    county_names_all: 'Skagit',
    county_weights: '{"53057": 100}',
    density: 29,
    imprecise: false,
    latitude: 48.56531,
    longitude: -122.41498,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4054,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98232',
  },
  {
    city: 'Burlington',
    county_fips: 53057,
    county_fips_all: '53057',
    county: 'Skagit',
    county_names_all: 'Skagit',
    county_weights: '{"53057": 100}',
    density: 207.9,
    imprecise: false,
    latitude: 48.50309,
    longitude: -122.35102,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98233',
  },
  {
    city: 'Clearlake',
    county_fips: 53057,
    county_fips_all: '53057',
    county: 'Skagit',
    county_names_all: 'Skagit',
    county_weights: '{"53057": 100}',
    density: 597.1,
    imprecise: false,
    latitude: 48.4602,
    longitude: -122.22846,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98235',
  },
  {
    city: 'Clinton',
    county_fips: 53029,
    county_fips_all: '53029',
    county: 'Island',
    county_names_all: 'Island',
    county_weights: '{"53029": 100}',
    density: 120.7,
    imprecise: false,
    latitude: 47.95804,
    longitude: -122.40468,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98236',
  },
  {
    city: 'Concrete',
    county_fips: 53057,
    county_fips_all: '53057|53073',
    county: 'Skagit',
    county_names_all: 'Skagit|Whatcom',
    county_weights: '{"53057": 83.35, "53073": 16.65}',
    density: 4.6,
    imprecise: false,
    latitude: 48.53272,
    longitude: -121.69748,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4956,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98237',
  },
  {
    city: 'Conway',
    county_fips: 53057,
    county_fips_all: '53057',
    county: 'Skagit',
    county_names_all: 'Skagit',
    county_weights: '{"53057": 100}',
    density: 78.9,
    imprecise: false,
    latitude: 48.33563,
    longitude: -122.34444,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98238',
  },
  {
    city: 'Coupeville',
    county_fips: 53029,
    county_fips_all: '53029',
    county: 'Island',
    county_names_all: 'Island',
    county_weights: '{"53029": 100}',
    density: 95.3,
    imprecise: false,
    latitude: 48.18926,
    longitude: -122.65756,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98239',
  },
  {
    city: 'Custer',
    county_fips: 53073,
    county_fips_all: '53073',
    county: 'Whatcom',
    county_names_all: 'Whatcom',
    county_weights: '{"53073": 100}',
    density: 62.3,
    imprecise: false,
    latitude: 48.94711,
    longitude: -122.62061,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3593,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98240',
  },
  {
    city: 'Darrington',
    county_fips: 53061,
    county_fips_all: '53061|53057',
    county: 'Snohomish',
    county_names_all: 'Snohomish|Skagit',
    county_weights: '{"53061": 91.93, "53057": 8.07}',
    density: 2.1,
    imprecise: false,
    latitude: 48.21425,
    longitude: -121.33219,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2339,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98241',
  },
  {
    city: 'Deer Harbor',
    county_fips: 53055,
    county_fips_all: '53055',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"53055": 100}',
    density: 41.6,
    imprecise: false,
    latitude: 48.61512,
    longitude: -122.99882,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98243',
  },
  {
    city: 'Deming',
    county_fips: 53073,
    county_fips_all: '53073',
    county: 'Whatcom',
    county_names_all: 'Whatcom',
    county_weights: '{"53073": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 48.79423,
    longitude: -121.93557,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98244',
  },
  {
    city: 'Eastsound',
    county_fips: 53055,
    county_fips_all: '53055',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"53055": 100}',
    density: 46.5,
    imprecise: false,
    latitude: 48.66241,
    longitude: -122.91616,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4265,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98245',
  },
  {
    city: 'Everson',
    county_fips: 53073,
    county_fips_all: '53073',
    county: 'Whatcom',
    county_names_all: 'Whatcom',
    county_weights: '{"53073": 100}',
    density: 52.7,
    imprecise: false,
    latitude: 48.90459,
    longitude: -122.31732,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98247',
  },
  {
    city: 'Ferndale',
    county_fips: 53073,
    county_fips_all: '53073',
    county: 'Whatcom',
    county_names_all: 'Whatcom',
    county_weights: '{"53073": 100}',
    density: 153.2,
    imprecise: false,
    latitude: 48.86494,
    longitude: -122.62211,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28498,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98248',
  },
  {
    city: 'Freeland',
    county_fips: 53029,
    county_fips_all: '53029',
    county: 'Island',
    county_names_all: 'Island',
    county_weights: '{"53029": 100}',
    density: 101.8,
    imprecise: false,
    latitude: 48.01888,
    longitude: -122.53947,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98249',
  },
  {
    city: 'Friday Harbor',
    county_fips: 53055,
    county_fips_all: '53055',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"53055": 100}',
    density: 58.5,
    imprecise: false,
    latitude: 48.55264,
    longitude: -123.09631,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9254,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98250',
  },
  {
    city: 'Gold Bar',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 47.89812,
    longitude: -121.55752,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4907,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98251',
  },
  {
    city: 'Granite Falls',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 16.8,
    imprecise: false,
    latitude: 48.06173,
    longitude: -121.70939,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98252',
  },
  {
    city: 'Greenbank',
    county_fips: 53029,
    county_fips_all: '53029',
    county: 'Island',
    county_names_all: 'Island',
    county_weights: '{"53029": 100}',
    density: 81.5,
    imprecise: false,
    latitude: 48.079,
    longitude: -122.57568,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98253',
  },
  {
    city: 'Hamilton',
    county_fips: 53057,
    county_fips_all: '53057',
    county: 'Skagit',
    county_names_all: 'Skagit',
    county_weights: '{"53057": 100}',
    density: 115.2,
    imprecise: false,
    latitude: 48.52353,
    longitude: -121.99203,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98255',
  },
  {
    city: 'Index',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 47.82883,
    longitude: -121.41464,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98256',
  },
  {
    city: 'La Conner',
    county_fips: 53057,
    county_fips_all: '53057',
    county: 'Skagit',
    county_names_all: 'Skagit',
    county_weights: '{"53057": 100}',
    density: 89.3,
    imprecise: false,
    latitude: 48.415,
    longitude: -122.50879,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98257',
  },
  {
    city: 'Lake Stevens',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 549.6,
    imprecise: false,
    latitude: 48.03252,
    longitude: -122.07762,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 52752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98258',
  },
  {
    city: 'Langley',
    county_fips: 53029,
    county_fips_all: '53029',
    county: 'Island',
    county_names_all: 'Island',
    county_weights: '{"53029": 100}',
    density: 78.3,
    imprecise: false,
    latitude: 48.03074,
    longitude: -122.45106,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98260',
  },
  {
    city: 'Lopez Island',
    county_fips: 53055,
    county_fips_all: '53055',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"53055": 100}',
    density: 38.6,
    imprecise: false,
    latitude: 48.48381,
    longitude: -122.88302,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98261',
  },
  {
    city: 'Lummi Island',
    county_fips: 53073,
    county_fips_all: '53073',
    county: 'Whatcom',
    county_names_all: 'Whatcom',
    county_weights: '{"53073": 100}',
    density: 40,
    imprecise: false,
    latitude: 48.69317,
    longitude: -122.66406,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98262',
  },
  {
    city: 'Lyman',
    county_fips: 53057,
    county_fips_all: '53057',
    county: 'Skagit',
    county_names_all: 'Skagit',
    county_weights: '{"53057": 100}',
    density: 316.1,
    imprecise: false,
    latitude: 48.52281,
    longitude: -122.0657,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 200,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98263',
  },
  {
    city: 'Lynden',
    county_fips: 53073,
    county_fips_all: '53073',
    county: 'Whatcom',
    county_names_all: 'Whatcom',
    county_weights: '{"53073": 100}',
    density: 156.2,
    imprecise: false,
    latitude: 48.94972,
    longitude: -122.45672,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23123,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98264',
  },
  {
    city: 'Maple Falls',
    county_fips: 53073,
    county_fips_all: '53073',
    county: 'Whatcom',
    county_names_all: 'Whatcom',
    county_weights: '{"53073": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 48.9576,
    longitude: -122.06189,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98266',
  },
  {
    city: 'Marblemount',
    county_fips: 53057,
    county_fips_all: '53057',
    county: 'Skagit',
    county_names_all: 'Skagit',
    county_weights: '{"53057": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 48.43756,
    longitude: -121.30841,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 314,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98267',
  },
  {
    city: 'Marysville',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 1490.4,
    imprecise: false,
    latitude: 48.05952,
    longitude: -122.1443,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 55049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98270',
  },
  {
    city: 'Marysville',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 262.8,
    imprecise: false,
    latitude: 48.09373,
    longitude: -122.23559,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30838,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98271',
  },
  {
    city: 'Monroe',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 114.2,
    imprecise: false,
    latitude: 47.85834,
    longitude: -121.88457,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31436,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98272',
  },
  {
    city: 'Mount Vernon',
    county_fips: 53057,
    county_fips_all: '53057',
    county: 'Skagit',
    county_names_all: 'Skagit',
    county_weights: '{"53057": 100}',
    density: 138,
    imprecise: false,
    latitude: 48.40522,
    longitude: -122.36841,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30001,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98273',
  },
  {
    city: 'Mount Vernon',
    county_fips: 53057,
    county_fips_all: '53057',
    county: 'Skagit',
    county_names_all: 'Skagit',
    county_weights: '{"53057": 100}',
    density: 50.9,
    imprecise: false,
    latitude: 48.36013,
    longitude: -122.14346,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18860,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98274',
  },
  {
    city: 'Mukilteo',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 1126,
    imprecise: false,
    latitude: 47.90994,
    longitude: -122.30113,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98275',
  },
  {
    city: 'Nooksack',
    county_fips: 53073,
    county_fips_all: '53073',
    county: 'Whatcom',
    county_names_all: 'Whatcom',
    county_weights: '{"53073": 100}',
    density: 979.2,
    imprecise: false,
    latitude: 48.92765,
    longitude: -122.32096,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98276',
  },
  {
    city: 'Oak Harbor',
    county_fips: 53029,
    county_fips_all: '53029',
    county: 'Island',
    county_names_all: 'Island',
    county_weights: '{"53029": 100}',
    density: 275.9,
    imprecise: false,
    latitude: 48.31688,
    longitude: -122.63152,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40917,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98277',
  },
  {
    city: 'Olga',
    county_fips: 53055,
    county_fips_all: '53055',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"53055": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 48.64474,
    longitude: -122.80602,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 680,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98279',
  },
  {
    city: 'Orcas',
    county_fips: 53055,
    county_fips_all: '53055',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"53055": 100}',
    density: 27.6,
    imprecise: false,
    latitude: 48.60866,
    longitude: -122.90554,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98280',
  },
  {
    city: 'Point Roberts',
    county_fips: 53073,
    county_fips_all: '53073',
    county: 'Whatcom',
    county_names_all: 'Whatcom',
    county_weights: '{"53073": 100}',
    density: 101.8,
    imprecise: false,
    latitude: 48.98817,
    longitude: -123.05767,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98281',
  },
  {
    city: 'Camano Island',
    county_fips: 53029,
    county_fips_all: '53029|53061',
    county: 'Island',
    county_names_all: 'Island|Snohomish',
    county_weights: '{"53029": 98.66, "53061": 1.34}',
    density: 165.5,
    imprecise: false,
    latitude: 48.18719,
    longitude: -122.46966,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17303,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98282',
  },
  {
    city: 'Rockport',
    county_fips: 53073,
    county_fips_all: '53073|53057',
    county: 'Whatcom',
    county_names_all: 'Whatcom|Skagit',
    county_weights: '{"53073": 95.75, "53057": 4.25}',
    density: 0.4,
    imprecise: false,
    latitude: 48.80137,
    longitude: -121.29997,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98283',
  },
  {
    city: 'Sedro Woolley',
    county_fips: 53057,
    county_fips_all: '53057|53073',
    county: 'Skagit',
    county_names_all: 'Skagit|Whatcom',
    county_weights: '{"53057": 91.88, "53073": 8.12}',
    density: 38.2,
    imprecise: false,
    latitude: 48.55211,
    longitude: -122.11763,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27835,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98284',
  },
  {
    city: 'Shaw Island',
    county_fips: 53055,
    county_fips_all: '53055',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"53055": 100}',
    density: 7.8,
    imprecise: false,
    latitude: 48.57262,
    longitude: -122.95712,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98286',
  },
  {
    city: 'Skykomish',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 47.65204,
    longitude: -121.3574,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98288',
  },
  {
    city: 'Snohomish',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 130.9,
    imprecise: false,
    latitude: 47.95141,
    longitude: -121.98421,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 39826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98290',
  },
  {
    city: 'Stanwood',
    county_fips: 53061,
    county_fips_all: '53061|53057',
    county: 'Snohomish',
    county_names_all: 'Snohomish|Skagit',
    county_weights: '{"53061": 98.96, "53057": 1.04}',
    density: 137.7,
    imprecise: false,
    latitude: 48.22455,
    longitude: -122.3032,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27389,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98292',
  },
  {
    city: 'Sultan',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 56.8,
    imprecise: false,
    latitude: 47.84431,
    longitude: -121.75822,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98294',
  },
  {
    city: 'Sumas',
    county_fips: 53073,
    county_fips_all: '53073',
    county: 'Whatcom',
    county_names_all: 'Whatcom',
    county_weights: '{"53073": 100}',
    density: 40.5,
    imprecise: false,
    latitude: 48.97163,
    longitude: -122.2213,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3279,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98295',
  },
  {
    city: 'Snohomish',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 312,
    imprecise: false,
    latitude: 47.84266,
    longitude: -122.10199,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27896,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98296',
  },
  {
    city: 'Waldron',
    county_fips: 53055,
    county_fips_all: '53055',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"53055": 100}',
    density: 4,
    imprecise: false,
    latitude: 48.7005,
    longitude: -123.02834,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 47,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98297',
  },
  {
    city: 'Anderson Island',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 70.5,
    imprecise: false,
    latitude: 47.15783,
    longitude: -122.70387,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98303',
  },
  {
    city: 'Ashford',
    county_fips: 53053,
    county_fips_all: '53053|53041',
    county: 'Pierce',
    county_names_all: 'Pierce|Lewis',
    county_weights: '{"53053": 98.31, "53041": 1.69}',
    density: 0.9,
    imprecise: false,
    latitude: 46.87036,
    longitude: -121.73985,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98304',
  },
  {
    city: 'Beaver',
    county_fips: 53009,
    county_fips_all: '53009',
    county: 'Clallam',
    county_names_all: 'Clallam',
    county_weights: '{"53009": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 48.03148,
    longitude: -124.22934,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98305',
  },
  {
    city: 'Bremerton',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 1588.6,
    imprecise: false,
    latitude: 47.58939,
    longitude: -122.6175,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98310',
  },
  {
    city: 'Bremerton',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 971.3,
    imprecise: false,
    latitude: 47.62829,
    longitude: -122.63793,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98311',
  },
  {
    city: 'Bremerton',
    county_fips: 53035,
    county_fips_all: '53035|53045',
    county: 'Kitsap',
    county_names_all: 'Kitsap|Mason',
    county_weights: '{"53035": 99.84, "53045": 0.16}',
    density: 213.2,
    imprecise: false,
    latitude: 47.56435,
    longitude: -122.75706,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98312',
  },
  {
    city: 'Silverdale',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 212.9,
    imprecise: false,
    latitude: 47.72263,
    longitude: -122.71444,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98315',
  },
  {
    city: 'Brinnon',
    county_fips: 53031,
    county_fips_all: '53031',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"53031": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 47.69861,
    longitude: -123.01742,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98320',
  },
  {
    city: 'Buckley',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 197.3,
    imprecise: false,
    latitude: 47.15564,
    longitude: -122.06576,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98321',
  },
  {
    city: 'Carbonado',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 3,
    imprecise: false,
    latitude: 46.98059,
    longitude: -122.006,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98323',
  },
  {
    city: 'Chimacum',
    county_fips: 53031,
    county_fips_all: '53031',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"53031": 100}',
    density: 24.8,
    imprecise: false,
    latitude: 47.96093,
    longitude: -122.77911,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98325',
  },
  {
    city: 'Clallam Bay',
    county_fips: 53009,
    county_fips_all: '53009',
    county: 'Clallam',
    county_names_all: 'Clallam',
    county_weights: '{"53009": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 48.17364,
    longitude: -124.45278,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98326',
  },
  {
    city: 'Dupont',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 561,
    imprecise: false,
    latitude: 47.10203,
    longitude: -122.66061,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98327',
  },
  {
    city: 'Eatonville',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 16.7,
    imprecise: false,
    latitude: 46.86055,
    longitude: -122.17227,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98328',
  },
  {
    city: 'Gig Harbor',
    county_fips: 53053,
    county_fips_all: '53053|53035',
    county: 'Pierce',
    county_names_all: 'Pierce|Kitsap',
    county_weights: '{"53053": 99.01, "53035": 0.99}',
    density: 171.6,
    imprecise: false,
    latitude: 47.37731,
    longitude: -122.72523,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11552,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98329',
  },
  {
    city: 'Elbe',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 17.6,
    imprecise: false,
    latitude: 46.75874,
    longitude: -122.15894,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98330',
  },
  {
    city: 'Forks',
    county_fips: 53031,
    county_fips_all: '53031|53009',
    county: 'Jefferson',
    county_names_all: 'Jefferson|Clallam',
    county_weights: '{"53031": 79.33, "53009": 20.67}',
    density: 2.4,
    imprecise: false,
    latitude: 47.77292,
    longitude: -124.1273,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98331',
  },
  {
    city: 'Gig Harbor',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 375,
    imprecise: false,
    latitude: 47.36514,
    longitude: -122.59858,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98332',
  },
  {
    city: 'Fox Island',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 253.8,
    imprecise: false,
    latitude: 47.24771,
    longitude: -122.62561,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3414,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98333',
  },
  {
    city: 'Gig Harbor',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 484.2,
    imprecise: false,
    latitude: 47.29909,
    longitude: -122.61911,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27773,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98335',
  },
  {
    city: 'Glenoma',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 46.56382,
    longitude: -122.10939,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98336',
  },
  {
    city: 'Bremerton',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 1922.8,
    imprecise: false,
    latitude: 47.56345,
    longitude: -122.63405,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7370,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98337',
  },
  {
    city: 'Graham',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 233.9,
    imprecise: false,
    latitude: 47.01927,
    longitude: -122.28347,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32687,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98338',
  },
  {
    city: 'Port Hadlock',
    county_fips: 53031,
    county_fips_all: '53031',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"53031": 100}',
    density: 116.5,
    imprecise: false,
    latitude: 48.02991,
    longitude: -122.74364,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3658,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98339',
  },
  {
    city: 'Hansville',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 140.5,
    imprecise: false,
    latitude: 47.90622,
    longitude: -122.56406,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98340',
  },
  {
    city: 'Indianola',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 190.3,
    imprecise: false,
    latitude: 47.75475,
    longitude: -122.51952,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98342',
  },
  {
    city: 'Keyport',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 170.7,
    imprecise: false,
    latitude: 47.69972,
    longitude: -122.62366,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98345',
  },
  {
    city: 'Kingston',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 131.6,
    imprecise: false,
    latitude: 47.82005,
    longitude: -122.53399,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98346',
  },
  {
    city: 'Lakebay',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 92.2,
    imprecise: false,
    latitude: 47.26583,
    longitude: -122.77366,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98349',
  },
  {
    city: 'La Push',
    county_fips: 53009,
    county_fips_all: '53009',
    county: 'Clallam',
    county_names_all: 'Clallam',
    county_weights: '{"53009": 100}',
    density: 87.5,
    imprecise: false,
    latitude: 47.90683,
    longitude: -124.62509,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98350',
  },
  {
    city: 'Longbranch',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 80.7,
    imprecise: false,
    latitude: 47.20353,
    longitude: -122.76773,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1891,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98351',
  },
  {
    city: 'Manchester',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 0,
    imprecise: false,
    latitude: 47.53885,
    longitude: -122.49294,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98353',
  },
  {
    city: 'Milton',
    county_fips: 53053,
    county_fips_all: '53053|53033',
    county: 'Pierce',
    county_names_all: 'Pierce|King',
    county_weights: '{"53053": 80.02, "53033": 19.98}',
    density: 1171.6,
    imprecise: false,
    latitude: 47.25113,
    longitude: -122.31557,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98354',
  },
  {
    city: 'Mineral',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 46.69179,
    longitude: -122.03978,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98355',
  },
  {
    city: 'Morton',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 46.57943,
    longitude: -122.26913,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2172,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98356',
  },
  {
    city: 'Neah Bay',
    county_fips: 53009,
    county_fips_all: '53009',
    county: 'Clallam',
    county_names_all: 'Clallam',
    county_weights: '{"53009": 100}',
    density: 13.8,
    imprecise: false,
    latitude: 48.33188,
    longitude: -124.62816,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1519,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98357',
  },
  {
    city: 'Nordland',
    county_fips: 53031,
    county_fips_all: '53031',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"53031": 100}',
    density: 71.1,
    imprecise: false,
    latitude: 48.05796,
    longitude: -122.70008,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98358',
  },
  {
    city: 'Olalla',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 127.4,
    imprecise: false,
    latitude: 47.43047,
    longitude: -122.57631,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98359',
  },
  {
    city: 'Orting',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 85.8,
    imprecise: false,
    latitude: 47.03246,
    longitude: -122.1575,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15045,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98360',
  },
  {
    city: 'Packwood',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 46.62786,
    longitude: -121.56385,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98361',
  },
  {
    city: 'Port Angeles',
    county_fips: 53009,
    county_fips_all: '53009',
    county: 'Clallam',
    county_names_all: 'Clallam',
    county_weights: '{"53009": 100}',
    density: 76.3,
    imprecise: false,
    latitude: 48.01639,
    longitude: -123.31951,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98362',
  },
  {
    city: 'Port Angeles',
    county_fips: 53009,
    county_fips_all: '53009',
    county: 'Clallam',
    county_names_all: 'Clallam',
    county_weights: '{"53009": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 48.03477,
    longitude: -123.76952,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98363',
  },
  {
    city: 'Port Gamble',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 0,
    imprecise: false,
    latitude: 47.85455,
    longitude: -122.58638,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98364',
  },
  {
    city: 'Port Ludlow',
    county_fips: 53031,
    county_fips_all: '53031',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"53031": 100}',
    density: 53.7,
    imprecise: false,
    latitude: 47.89545,
    longitude: -122.70271,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98365',
  },
  {
    city: 'Port Orchard',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 609.6,
    imprecise: false,
    latitude: 47.53732,
    longitude: -122.58647,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98366',
  },
  {
    city: 'Port Orchard',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 166.7,
    imprecise: false,
    latitude: 47.46141,
    longitude: -122.67662,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31756,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98367',
  },
  {
    city: 'Port Townsend',
    county_fips: 53031,
    county_fips_all: '53031',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"53031": 100}',
    density: 127.6,
    imprecise: false,
    latitude: 48.03879,
    longitude: -122.84406,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98368',
  },
  {
    city: 'Poulsbo',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 230.7,
    imprecise: false,
    latitude: 47.75114,
    longitude: -122.62373,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98370',
  },
  {
    city: 'Puyallup',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 805.2,
    imprecise: false,
    latitude: 47.19957,
    longitude: -122.32191,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24682,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98371',
  },
  {
    city: 'Puyallup',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 753.1,
    imprecise: false,
    latitude: 47.2064,
    longitude: -122.26689,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26012,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98372',
  },
  {
    city: 'Puyallup',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 1188.6,
    imprecise: false,
    latitude: 47.14761,
    longitude: -122.32506,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98373',
  },
  {
    city: 'Puyallup',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 1155.2,
    imprecise: false,
    latitude: 47.12904,
    longitude: -122.26156,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49007,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98374',
  },
  {
    city: 'Puyallup',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 1244.4,
    imprecise: false,
    latitude: 47.10394,
    longitude: -122.32383,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98375',
  },
  {
    city: 'Quilcene',
    county_fips: 53031,
    county_fips_all: '53031',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"53031": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 47.8455,
    longitude: -122.85916,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1982,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98376',
  },
  {
    city: 'Randle',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 3,
    imprecise: false,
    latitude: 46.50586,
    longitude: -121.81912,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98377',
  },
  {
    city: 'Seabeck',
    county_fips: 53035,
    county_fips_all: '53035|53045',
    county: 'Kitsap',
    county_names_all: 'Kitsap|Mason',
    county_weights: '{"53035": 93.68, "53045": 6.32}',
    density: 43.7,
    imprecise: false,
    latitude: 47.5743,
    longitude: -122.90287,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98380',
  },
  {
    city: 'Sekiu',
    county_fips: 53009,
    county_fips_all: '53009',
    county: 'Clallam',
    county_names_all: 'Clallam',
    county_weights: '{"53009": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 48.28863,
    longitude: -124.45681,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98381',
  },
  {
    city: 'Sequim',
    county_fips: 53009,
    county_fips_all: '53009|53031',
    county: 'Clallam',
    county_names_all: 'Clallam|Jefferson',
    county_weights: '{"53009": 93.37, "53031": 6.63}',
    density: 58,
    imprecise: false,
    latitude: 48.0131,
    longitude: -123.07437,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31052,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98382',
  },
  {
    city: 'Silverdale',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 480.8,
    imprecise: false,
    latitude: 47.66212,
    longitude: -122.71652,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98383',
  },
  {
    city: 'South Prairie',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 239.1,
    imprecise: false,
    latitude: 47.13791,
    longitude: -122.09469,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 457,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98385',
  },
  {
    city: 'Spanaway',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 736.8,
    imprecise: false,
    latitude: 47.0562,
    longitude: -122.39111,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98387',
  },
  {
    city: 'Steilacoom',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 307.8,
    imprecise: false,
    latitude: 47.19892,
    longitude: -122.66268,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7043,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98388',
  },
  {
    city: 'Sumner',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 485,
    imprecise: false,
    latitude: 47.21195,
    longitude: -122.22894,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98390',
  },
  {
    city: 'Bonney Lake',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 596.2,
    imprecise: false,
    latitude: 47.17654,
    longitude: -122.17362,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 59240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98391',
  },
  {
    city: 'Suquamish',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 645.2,
    imprecise: false,
    latitude: 47.73425,
    longitude: -122.5631,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2984,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98392',
  },
  {
    city: 'Vaughn',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 63.3,
    imprecise: false,
    latitude: 47.32011,
    longitude: -122.77791,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98394',
  },
  {
    city: 'Wilkeson',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 30.7,
    imprecise: false,
    latitude: 47.10669,
    longitude: -122.01052,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 844,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98396',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 2644.5,
    imprecise: false,
    latitude: 47.25021,
    longitude: -122.44056,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98402',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 3511.4,
    imprecise: false,
    latitude: 47.26581,
    longitude: -122.45921,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9097,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98403',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 1967,
    imprecise: false,
    latitude: 47.20927,
    longitude: -122.41139,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98404',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 2443.5,
    imprecise: false,
    latitude: 47.24599,
    longitude: -122.47222,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25939,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98405',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 2235.1,
    imprecise: false,
    latitude: 47.26283,
    longitude: -122.50857,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98406',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 1555.7,
    imprecise: false,
    latitude: 47.28889,
    longitude: -122.5111,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98407',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 2377.8,
    imprecise: false,
    latitude: 47.19811,
    longitude: -122.44638,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98408',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 1505.5,
    imprecise: false,
    latitude: 47.21084,
    longitude: -122.48197,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98409',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 2349.6,
    imprecise: false,
    latitude: 47.22325,
    longitude: -122.44642,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98418',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 25.2,
    imprecise: false,
    latitude: 47.25819,
    longitude: -122.40107,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98421',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053|53033',
    county: 'Pierce',
    county_names_all: 'Pierce|King',
    county_weights: '{"53053": 97.81, "53033": 2.19}',
    density: 1192.9,
    imprecise: false,
    latitude: 47.28907,
    longitude: -122.39123,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98422',
  },
  {
    city: 'Fife',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 724.6,
    imprecise: false,
    latitude: 47.2343,
    longitude: -122.3523,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98424',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 259.2,
    imprecise: false,
    latitude: 47.09121,
    longitude: -122.60772,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22493,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98433',
  },
  {
    city: 'Mcchord Afb',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 246.1,
    imprecise: false,
    latitude: 47.13514,
    longitude: -122.49211,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98438',
  },
  {
    city: 'Lakewood',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 402.3,
    imprecise: false,
    latitude: 47.13164,
    longitude: -122.49603,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98439',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 396.4,
    imprecise: false,
    latitude: 47.20522,
    longitude: -122.37592,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5558,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98443',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 1987.5,
    imprecise: false,
    latitude: 47.15228,
    longitude: -122.44887,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35754,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98444',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 1244.6,
    imprecise: false,
    latitude: 47.13985,
    longitude: -122.40965,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98445',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 518.9,
    imprecise: false,
    latitude: 47.12935,
    longitude: -122.37424,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14634,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98446',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 1712.3,
    imprecise: false,
    latitude: 47.24868,
    longitude: -122.53043,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98465',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 1882.8,
    imprecise: false,
    latitude: 47.22842,
    longitude: -122.53479,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98466',
  },
  {
    city: 'University Place',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 1244.1,
    imprecise: false,
    latitude: 47.2038,
    longitude: -122.5447,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15387,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98467',
  },
  {
    city: 'Lakewood',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 1134.1,
    imprecise: false,
    latitude: 47.16001,
    longitude: -122.55971,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29209,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98498',
  },
  {
    city: 'Lakewood',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 1417.3,
    imprecise: false,
    latitude: 47.16662,
    longitude: -122.50624,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32464,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98499',
  },
  {
    city: 'Olympia',
    county_fips: 53067,
    county_fips_all: '53067',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"53067": 100}',
    density: 531.7,
    imprecise: false,
    latitude: 46.9783,
    longitude: -122.86989,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48067,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98501',
  },
  {
    city: 'Olympia',
    county_fips: 53067,
    county_fips_all: '53067|53045',
    county: 'Thurston',
    county_names_all: 'Thurston|Mason',
    county_weights: '{"53067": 99.54, "53045": 0.46}',
    density: 215.5,
    imprecise: false,
    latitude: 47.08466,
    longitude: -123.02958,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98502',
  },
  {
    city: 'Lacey',
    county_fips: 53067,
    county_fips_all: '53067',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"53067": 100}',
    density: 1451.8,
    imprecise: false,
    latitude: 47.02528,
    longitude: -122.799,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98503',
  },
  {
    city: 'Olympia',
    county_fips: 53067,
    county_fips_all: '53067',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"53067": 100}',
    density: 318.2,
    imprecise: false,
    latitude: 47.10286,
    longitude: -122.87307,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98506',
  },
  {
    city: 'Olympia',
    county_fips: 53067,
    county_fips_all: '53067',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"53067": 100}',
    density: 88.7,
    imprecise: false,
    latitude: 46.95326,
    longitude: -123.04259,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98512',
  },
  {
    city: 'Olympia',
    county_fips: 53067,
    county_fips_all: '53067',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"53067": 100}',
    density: 294.3,
    imprecise: false,
    latitude: 46.99074,
    longitude: -122.73298,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38017,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98513',
  },
  {
    city: 'Olympia',
    county_fips: 53067,
    county_fips_all: '53067',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"53067": 100}',
    density: 390.9,
    imprecise: false,
    latitude: 47.09647,
    longitude: -122.78265,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98516',
  },
  {
    city: 'Aberdeen',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 44.2,
    imprecise: false,
    latitude: 46.99478,
    longitude: -123.81054,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24888,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98520',
  },
  {
    city: 'Allyn',
    county_fips: 53045,
    county_fips_all: '53045',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"53045": 100}',
    density: 202.6,
    imprecise: false,
    latitude: 47.36703,
    longitude: -122.84548,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98524',
  },
  {
    city: 'Amanda Park',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 47.47749,
    longitude: -123.99227,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 180,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98526',
  },
  {
    city: 'Bay Center',
    county_fips: 53049,
    county_fips_all: '53049',
    county: 'Pacific',
    county_names_all: 'Pacific',
    county_weights: '{"53049": 100}',
    density: 10.8,
    imprecise: false,
    latitude: 46.58917,
    longitude: -123.90939,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 273,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98527',
  },
  {
    city: 'Belfair',
    county_fips: 53045,
    county_fips_all: '53045',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"53045": 100}',
    density: 63.8,
    imprecise: false,
    latitude: 47.44605,
    longitude: -122.89618,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11940,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98528',
  },
  {
    city: 'Bucoda',
    county_fips: 53067,
    county_fips_all: '53067',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"53067": 100}',
    density: 88.9,
    imprecise: false,
    latitude: 46.80519,
    longitude: -122.86804,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 619,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98530',
  },
  {
    city: 'Centralia',
    county_fips: 53041,
    county_fips_all: '53041|53067',
    county: 'Lewis',
    county_names_all: 'Lewis|Thurston',
    county_weights: '{"53041": 78.96, "53067": 21.04}',
    density: 81.7,
    imprecise: false,
    latitude: 46.73646,
    longitude: -122.91364,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27337,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98531',
  },
  {
    city: 'Chehalis',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 33.6,
    imprecise: false,
    latitude: 46.63628,
    longitude: -123.03444,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 27135,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98532',
  },
  {
    city: 'Cinebar',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 46.67304,
    longitude: -122.43115,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 890,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98533',
  },
  {
    city: 'Copalis Beach',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 14,
    imprecise: false,
    latitude: 47.0994,
    longitude: -124.11973,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 726,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98535',
  },
  {
    city: 'Copalis Crossing',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 47.18939,
    longitude: -124.111,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98536',
  },
  {
    city: 'Cosmopolis',
    county_fips: 53027,
    county_fips_all: '53027|53049',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor|Pacific',
    county_weights: '{"53027": 66.86, "53049": 33.14}',
    density: 6.7,
    imprecise: false,
    latitude: 46.81719,
    longitude: -123.59768,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2820,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98537',
  },
  {
    city: 'Curtis',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 46.47422,
    longitude: -123.15884,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 460,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98538',
  },
  {
    city: 'Doty',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 110.4,
    imprecise: false,
    latitude: 46.63772,
    longitude: -123.27315,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 139,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98539',
  },
  {
    city: 'Elma',
    county_fips: 53027,
    county_fips_all: '53027|53045',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor|Mason',
    county_weights: '{"53027": 59.59, "53045": 40.41}',
    density: 21.3,
    imprecise: false,
    latitude: 47.06877,
    longitude: -123.40459,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98541',
  },
  {
    city: 'Ethel',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 22.1,
    imprecise: false,
    latitude: 46.5293,
    longitude: -122.73155,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 625,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98542',
  },
  {
    city: 'Galvin',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 0,
    imprecise: false,
    latitude: 46.73912,
    longitude: -123.02712,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98544',
  },
  {
    city: 'Grapeview',
    county_fips: 53045,
    county_fips_all: '53045',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"53045": 100}',
    density: 27.4,
    imprecise: false,
    latitude: 47.32439,
    longitude: -122.92362,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98546',
  },
  {
    city: 'Grayland',
    county_fips: 53049,
    county_fips_all: '53049|53027',
    county: 'Pacific',
    county_names_all: 'Pacific|Grays Harbor',
    county_weights: '{"53049": 59.6, "53027": 40.4}',
    density: 6.8,
    imprecise: false,
    latitude: 46.78622,
    longitude: -124.01956,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1080,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98547',
  },
  {
    city: 'Hoodsport',
    county_fips: 53045,
    county_fips_all: '53045|53027',
    county: 'Mason',
    county_names_all: 'Mason|Grays Harbor',
    county_weights: '{"53045": 99.88, "53027": 0.12}',
    density: 4.4,
    imprecise: false,
    latitude: 47.47064,
    longitude: -123.29273,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98548',
  },
  {
    city: 'Hoquiam',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 17.9,
    imprecise: false,
    latitude: 47.14081,
    longitude: -123.90122,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98550',
  },
  {
    city: 'Humptulips',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 47.3136,
    longitude: -123.9444,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 140,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98552',
  },
  {
    city: 'Lilliwaup',
    county_fips: 53045,
    county_fips_all: '53045',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"53045": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 47.54634,
    longitude: -123.06369,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98555',
  },
  {
    city: 'Littlerock',
    county_fips: 53067,
    county_fips_all: '53067',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"53067": 100}',
    density: 1131.8,
    imprecise: false,
    latitude: 46.88565,
    longitude: -123.1409,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98556',
  },
  {
    city: 'Mccleary',
    county_fips: 53027,
    county_fips_all: '53027|53045',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor|Mason',
    county_weights: '{"53027": 97.89, "53045": 2.11}',
    density: 44.4,
    imprecise: false,
    latitude: 47.04332,
    longitude: -123.2681,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4079,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98557',
  },
  {
    city: 'Mckenna',
    county_fips: 53053,
    county_fips_all: '53053|53067',
    county: 'Pierce',
    county_names_all: 'Pierce|Thurston',
    county_weights: '{"53053": 98.83, "53067": 1.17}',
    density: 364,
    imprecise: false,
    latitude: 46.93579,
    longitude: -122.55998,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98558',
  },
  {
    city: 'Malone',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 0,
    imprecise: false,
    latitude: 46.95884,
    longitude: -123.32749,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98559',
  },
  {
    city: 'Matlock',
    county_fips: 53045,
    county_fips_all: '53045',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"53045": 100}',
    density: 1,
    imprecise: false,
    latitude: 47.30577,
    longitude: -123.43948,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98560',
  },
  {
    city: 'Moclips',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 47.23877,
    longitude: -124.20336,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98562',
  },
  {
    city: 'Montesano',
    county_fips: 53027,
    county_fips_all: '53027|53045',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor|Mason',
    county_weights: '{"53027": 99.9, "53045": 0.1}',
    density: 7.1,
    imprecise: false,
    latitude: 47.2064,
    longitude: -123.60824,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7604,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98563',
  },
  {
    city: 'Mossyrock',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 9.1,
    imprecise: false,
    latitude: 46.45666,
    longitude: -122.43627,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3382,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98564',
  },
  {
    city: 'Napavine',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 945.3,
    imprecise: false,
    latitude: 46.57838,
    longitude: -122.90693,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98565',
  },
  {
    city: 'Neilton',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 47.39616,
    longitude: -123.95976,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 299,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98566',
  },
  {
    city: 'Oakville',
    county_fips: 53027,
    county_fips_all: '53027|53041',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor|Lewis',
    county_weights: '{"53027": 91.0, "53041": 9.0}',
    density: 6.9,
    imprecise: false,
    latitude: 46.86467,
    longitude: -123.30235,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3050,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98568',
  },
  {
    city: 'Ocean Shores',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 218.2,
    imprecise: false,
    latitude: 47.00206,
    longitude: -124.15479,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98569',
  },
  {
    city: 'Onalaska',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 16.3,
    imprecise: false,
    latitude: 46.63556,
    longitude: -122.63534,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98570',
  },
  {
    city: 'Pacific Beach',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 47.20356,
    longitude: -124.19532,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98571',
  },
  {
    city: 'Pe Ell',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 46.55256,
    longitude: -123.32429,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98572',
  },
  {
    city: 'Quinault',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 47.43607,
    longitude: -123.79848,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98575',
  },
  {
    city: 'Rainier',
    county_fips: 53067,
    county_fips_all: '53067',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"53067": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 46.84417,
    longitude: -122.64687,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4985,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98576',
  },
  {
    city: 'Raymond',
    county_fips: 53049,
    county_fips_all: '53049',
    county: 'Pacific',
    county_names_all: 'Pacific',
    county_weights: '{"53049": 100}',
    density: 8,
    imprecise: false,
    latitude: 46.6418,
    longitude: -123.60031,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7503,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98577',
  },
  {
    city: 'Rochester',
    county_fips: 53067,
    county_fips_all: '53067|53041|53027',
    county: 'Thurston',
    county_names_all: 'Thurston|Lewis|Grays Harbor',
    county_weights: '{"53067": 59.23, "53041": 40.3, "53027": 0.47}',
    density: 57.6,
    imprecise: false,
    latitude: 46.79406,
    longitude: -123.11952,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98579',
  },
  {
    city: 'Roy',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 33.9,
    imprecise: false,
    latitude: 46.9918,
    longitude: -122.50101,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11410,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98580',
  },
  {
    city: 'Ryderwood',
    county_fips: 53015,
    county_fips_all: '53015',
    county: 'Cowlitz',
    county_names_all: 'Cowlitz',
    county_weights: '{"53015": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 46.35875,
    longitude: -123.06865,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 419,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98581',
  },
  {
    city: 'Salkum',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 29,
    imprecise: false,
    latitude: 46.51686,
    longitude: -122.62693,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98582',
  },
  {
    city: 'Satsop',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 294.3,
    imprecise: false,
    latitude: 47.00122,
    longitude: -123.4875,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 79,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98583',
  },
  {
    city: 'Shelton',
    county_fips: 53045,
    county_fips_all: '53045',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"53045": 100}',
    density: 43.6,
    imprecise: false,
    latitude: 47.24608,
    longitude: -123.16209,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 40606,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98584',
  },
  {
    city: 'Silver Creek',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 8,
    imprecise: false,
    latitude: 46.55436,
    longitude: -122.5022,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98585',
  },
  {
    city: 'South Bend',
    county_fips: 53049,
    county_fips_all: '53049',
    county: 'Pacific',
    county_names_all: 'Pacific',
    county_weights: '{"53049": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 46.55909,
    longitude: -123.8391,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1801,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98586',
  },
  {
    city: 'Taholah',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 47.32039,
    longitude: -124.1562,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1072,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98587',
  },
  {
    city: 'Tahuya',
    county_fips: 53045,
    county_fips_all: '53045',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"53045": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 47.43555,
    longitude: -123.02261,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98588',
  },
  {
    city: 'Tenino',
    county_fips: 53067,
    county_fips_all: '53067',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"53067": 100}',
    density: 29.2,
    imprecise: false,
    latitude: 46.84133,
    longitude: -122.82087,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7010,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98589',
  },
  {
    city: 'Tokeland',
    county_fips: 53049,
    county_fips_all: '53049',
    county: 'Pacific',
    county_names_all: 'Pacific',
    county_weights: '{"53049": 100}',
    density: 65,
    imprecise: false,
    latitude: 46.71882,
    longitude: -124.00272,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98590',
  },
  {
    city: 'Toledo',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 46.44224,
    longitude: -122.74671,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3965,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98591',
  },
  {
    city: 'Union',
    county_fips: 53045,
    county_fips_all: '53045',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"53045": 100}',
    density: 45,
    imprecise: false,
    latitude: 47.32895,
    longitude: -123.07907,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2059,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98592',
  },
  {
    city: 'Vader',
    county_fips: 53041,
    county_fips_all: '53041|53015',
    county: 'Lewis',
    county_names_all: 'Lewis|Cowlitz',
    county_weights: '{"53041": 99.73, "53015": 0.27}',
    density: 41.6,
    imprecise: false,
    latitude: 46.40767,
    longitude: -123.00807,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1541,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98593',
  },
  {
    city: 'Westport',
    county_fips: 53027,
    county_fips_all: '53027',
    county: 'Grays Harbor',
    county_names_all: 'Grays Harbor',
    county_weights: '{"53027": 100}',
    density: 196.1,
    imprecise: false,
    latitude: 46.88302,
    longitude: -124.1088,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98595',
  },
  {
    city: 'Winlock',
    county_fips: 53041,
    county_fips_all: '53041',
    county: 'Lewis',
    county_names_all: 'Lewis',
    county_weights: '{"53041": 100}',
    density: 30.2,
    imprecise: false,
    latitude: 46.49556,
    longitude: -122.95364,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98596',
  },
  {
    city: 'Yelm',
    county_fips: 53067,
    county_fips_all: '53067',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"53067": 100}',
    density: 92.8,
    imprecise: false,
    latitude: 46.85241,
    longitude: -122.49212,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98597',
  },
  {
    city: 'Amboy',
    county_fips: 53011,
    county_fips_all: '53011|53015',
    county: 'Clark',
    county_names_all: 'Clark|Cowlitz',
    county_weights: '{"53011": 91.1, "53015": 8.9}',
    density: 32.1,
    imprecise: false,
    latitude: 45.93439,
    longitude: -122.43857,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98601',
  },
  {
    city: 'Appleton',
    county_fips: 53039,
    county_fips_all: '53039',
    county: 'Klickitat',
    county_names_all: 'Klickitat',
    county_weights: '{"53039": 100}',
    density: 2,
    imprecise: false,
    latitude: 45.8693,
    longitude: -121.27966,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98602',
  },
  {
    city: 'Ariel',
    county_fips: 53015,
    county_fips_all: '53015',
    county: 'Cowlitz',
    county_names_all: 'Cowlitz',
    county_weights: '{"53015": 100}',
    density: 4.3,
    imprecise: false,
    latitude: 46.04223,
    longitude: -122.42001,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1267,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98603',
  },
  {
    city: 'Battle Ground',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 208.1,
    imprecise: false,
    latitude: 45.80013,
    longitude: -122.5054,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38839,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98604',
  },
  {
    city: 'Bingen',
    county_fips: 53059,
    county_fips_all: '53059|53039',
    county: 'Skamania',
    county_names_all: 'Skamania|Klickitat',
    county_weights: '{"53059": 92.31, "53039": 7.69}',
    density: 10.8,
    imprecise: false,
    latitude: 45.77846,
    longitude: -121.6393,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1117,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98605',
  },
  {
    city: 'Brush Prairie',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 104,
    imprecise: false,
    latitude: 45.72921,
    longitude: -122.45615,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98606',
  },
  {
    city: 'Camas',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 290.8,
    imprecise: false,
    latitude: 45.64395,
    longitude: -122.38242,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 35867,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98607',
  },
  {
    city: 'Carrolls',
    county_fips: 53015,
    county_fips_all: '53015',
    county: 'Cowlitz',
    county_names_all: 'Cowlitz',
    county_weights: '{"53015": 100}',
    density: 0,
    imprecise: false,
    latitude: 46.0717,
    longitude: -122.86569,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98609',
  },
  {
    city: 'Carson',
    county_fips: 53059,
    county_fips_all: '53059',
    county: 'Skamania',
    county_names_all: 'Skamania',
    county_weights: '{"53059": 100}',
    density: 7.7,
    imprecise: false,
    latitude: 45.77765,
    longitude: -122.01401,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98610',
  },
  {
    city: 'Castle Rock',
    county_fips: 53015,
    county_fips_all: '53015',
    county: 'Cowlitz',
    county_names_all: 'Cowlitz',
    county_weights: '{"53015": 100}',
    density: 26.4,
    imprecise: false,
    latitude: 46.30642,
    longitude: -122.90479,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98611',
  },
  {
    city: 'Cathlamet',
    county_fips: 53069,
    county_fips_all: '53069',
    county: 'Wahkiakum',
    county_names_all: 'Wahkiakum',
    county_weights: '{"53069": 100}',
    density: 12.9,
    imprecise: false,
    latitude: 46.23462,
    longitude: -123.31194,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98612',
  },
  {
    city: 'Centerville',
    county_fips: 53039,
    county_fips_all: '53039',
    county: 'Klickitat',
    county_names_all: 'Klickitat',
    county_weights: '{"53039": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 45.7542,
    longitude: -120.97235,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98613',
  },
  {
    city: 'Chinook',
    county_fips: 53049,
    county_fips_all: '53049',
    county: 'Pacific',
    county_names_all: 'Pacific',
    county_weights: '{"53049": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 46.29459,
    longitude: -123.9034,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98614',
  },
  {
    city: 'Cougar',
    county_fips: 53059,
    county_fips_all: '53059|53015|53011',
    county: 'Skamania',
    county_names_all: 'Skamania|Cowlitz|Clark',
    county_weights: '{"53059": 95.73, "53015": 4.12, "53011": 0.15}',
    density: 0.7,
    imprecise: false,
    latitude: 46.06227,
    longitude: -122.14599,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 192,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98616',
  },
  {
    city: 'Dallesport',
    county_fips: 53039,
    county_fips_all: '53039',
    county: 'Klickitat',
    county_names_all: 'Klickitat',
    county_weights: '{"53039": 100}',
    density: 30.9,
    imprecise: false,
    latitude: 45.64283,
    longitude: -121.14229,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1380,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98617',
  },
  {
    city: 'Glenwood',
    county_fips: 53039,
    county_fips_all: '53039',
    county: 'Klickitat',
    county_names_all: 'Klickitat',
    county_weights: '{"53039": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 45.97693,
    longitude: -121.26568,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98619',
  },
  {
    city: 'Goldendale',
    county_fips: 53039,
    county_fips_all: '53039',
    county: 'Klickitat',
    county_names_all: 'Klickitat',
    county_weights: '{"53039": 100}',
    density: 6.5,
    imprecise: false,
    latitude: 45.87096,
    longitude: -120.77846,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7936,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98620',
  },
  {
    city: 'Grays River',
    county_fips: 53049,
    county_fips_all: '53049|53069',
    county: 'Pacific',
    county_names_all: 'Pacific|Wahkiakum',
    county_weights: '{"53049": 58.05, "53069": 41.95}',
    density: 1.5,
    imprecise: false,
    latitude: 46.4006,
    longitude: -123.54428,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98621',
  },
  {
    city: 'Husum',
    county_fips: 53039,
    county_fips_all: '53039',
    county: 'Klickitat',
    county_names_all: 'Klickitat',
    county_weights: '{"53039": 100}',
    density: 55.2,
    imprecise: false,
    latitude: 45.79956,
    longitude: -121.49347,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98623',
  },
  {
    city: 'Ilwaco',
    county_fips: 53049,
    county_fips_all: '53049',
    county: 'Pacific',
    county_names_all: 'Pacific',
    county_weights: '{"53049": 100}',
    density: 17.2,
    imprecise: false,
    latitude: 46.3578,
    longitude: -123.94094,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98624',
  },
  {
    city: 'Kalama',
    county_fips: 53015,
    county_fips_all: '53015',
    county: 'Cowlitz',
    county_names_all: 'Cowlitz',
    county_weights: '{"53015": 100}',
    density: 15.2,
    imprecise: false,
    latitude: 46.10871,
    longitude: -122.56093,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7655,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98625',
  },
  {
    city: 'Kelso',
    county_fips: 53015,
    county_fips_all: '53015',
    county: 'Cowlitz',
    county_names_all: 'Cowlitz',
    county_weights: '{"53015": 100}',
    density: 77.1,
    imprecise: false,
    latitude: 46.15317,
    longitude: -122.78564,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98626',
  },
  {
    city: 'Klickitat',
    county_fips: 53039,
    county_fips_all: '53039',
    county: 'Klickitat',
    county_names_all: 'Klickitat',
    county_weights: '{"53039": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 45.85015,
    longitude: -121.09887,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 577,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98628',
  },
  {
    city: 'La Center',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 92.7,
    imprecise: false,
    latitude: 45.88109,
    longitude: -122.6148,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98629',
  },
  {
    city: 'Long Beach',
    county_fips: 53049,
    county_fips_all: '53049',
    county: 'Pacific',
    county_names_all: 'Pacific',
    county_weights: '{"53049": 100}',
    density: 63.9,
    imprecise: false,
    latitude: 46.37988,
    longitude: -124.02241,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3759,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98631',
  },
  {
    city: 'Longview',
    county_fips: 53015,
    county_fips_all: '53015|53069',
    county: 'Cowlitz',
    county_names_all: 'Cowlitz|Wahkiakum',
    county_weights: '{"53015": 99.76, "53069": 0.24}',
    density: 161,
    imprecise: false,
    latitude: 46.21223,
    longitude: -123.06855,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50635,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98632',
  },
  {
    city: 'Lyle',
    county_fips: 53039,
    county_fips_all: '53039',
    county: 'Klickitat',
    county_names_all: 'Klickitat',
    county_weights: '{"53039": 100}',
    density: 5,
    imprecise: false,
    latitude: 45.74364,
    longitude: -121.20915,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1721,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98635',
  },
  {
    city: 'Naselle',
    county_fips: 53049,
    county_fips_all: '53049|53069',
    county: 'Pacific',
    county_names_all: 'Pacific|Wahkiakum',
    county_weights: '{"53049": 91.18, "53069": 8.82}',
    density: 3.3,
    imprecise: false,
    latitude: 46.4047,
    longitude: -123.73588,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98638',
  },
  {
    city: 'North Bonneville',
    county_fips: 53059,
    county_fips_all: '53059',
    county: 'Skamania',
    county_names_all: 'Skamania',
    county_weights: '{"53059": 100}',
    density: 151.7,
    imprecise: false,
    latitude: 45.64364,
    longitude: -121.96288,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1112,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98639',
  },
  {
    city: 'Ocean Park',
    county_fips: 53049,
    county_fips_all: '53049',
    county: 'Pacific',
    county_names_all: 'Pacific',
    county_weights: '{"53049": 100}',
    density: 147.7,
    imprecise: false,
    latitude: 46.5429,
    longitude: -124.04938,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98640',
  },
  {
    city: 'Oysterville',
    county_fips: 53049,
    county_fips_all: '53049',
    county: 'Pacific',
    county_names_all: 'Pacific',
    county_weights: '{"53049": 100}',
    density: 19.6,
    imprecise: false,
    latitude: 46.56484,
    longitude: -124.03932,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98641',
  },
  {
    city: 'Ridgefield',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 182.1,
    imprecise: false,
    latitude: 45.80262,
    longitude: -122.7019,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 26816,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98642',
  },
  {
    city: 'Rosburg',
    county_fips: 53069,
    county_fips_all: '53069',
    county: 'Wahkiakum',
    county_names_all: 'Wahkiakum',
    county_weights: '{"53069": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 46.30326,
    longitude: -123.62117,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 571,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98643',
  },
  {
    city: 'Seaview',
    county_fips: 53049,
    county_fips_all: '53049',
    county: 'Pacific',
    county_names_all: 'Pacific',
    county_weights: '{"53049": 100}',
    density: 62.3,
    imprecise: false,
    latitude: 46.32861,
    longitude: -124.04009,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98644',
  },
  {
    city: 'Silverlake',
    county_fips: 53015,
    county_fips_all: '53015',
    county: 'Cowlitz',
    county_names_all: 'Cowlitz',
    county_weights: '{"53015": 100}',
    density: 56.3,
    imprecise: false,
    latitude: 46.32509,
    longitude: -122.77993,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98645',
  },
  {
    city: 'Skamokawa',
    county_fips: 53069,
    county_fips_all: '53069',
    county: 'Wahkiakum',
    county_names_all: 'Wahkiakum',
    county_weights: '{"53069": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 46.32137,
    longitude: -123.4354,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98647',
  },
  {
    city: 'Stevenson',
    county_fips: 53059,
    county_fips_all: '53059',
    county: 'Skamania',
    county_names_all: 'Skamania',
    county_weights: '{"53059": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 45.70563,
    longitude: -121.9489,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98648',
  },
  {
    city: 'Toutle',
    county_fips: 53015,
    county_fips_all: '53015',
    county: 'Cowlitz',
    county_names_all: 'Cowlitz',
    county_weights: '{"53015": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 46.31504,
    longitude: -122.53415,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98649',
  },
  {
    city: 'Trout Lake',
    county_fips: 53039,
    county_fips_all: '53039',
    county: 'Klickitat',
    county_names_all: 'Klickitat',
    county_weights: '{"53039": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 45.97117,
    longitude: -121.52732,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98650',
  },
  {
    city: 'Underwood',
    county_fips: 53059,
    county_fips_all: '53059',
    county: 'Skamania',
    county_names_all: 'Skamania',
    county_weights: '{"53059": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 45.73419,
    longitude: -121.58718,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98651',
  },
  {
    city: 'Vancouver',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 334.3,
    imprecise: false,
    latitude: 45.6866,
    longitude: -122.73152,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13212,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98660',
  },
  {
    city: 'Vancouver',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 1797.3,
    imprecise: false,
    latitude: 45.63935,
    longitude: -122.62586,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50743,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98661',
  },
  {
    city: 'Vancouver',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 1123.1,
    imprecise: false,
    latitude: 45.68911,
    longitude: -122.57742,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98662',
  },
  {
    city: 'Vancouver',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 1519.1,
    imprecise: false,
    latitude: 45.65449,
    longitude: -122.66228,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98663',
  },
  {
    city: 'Vancouver',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 1777.7,
    imprecise: false,
    latitude: 45.61966,
    longitude: -122.57738,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 23845,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98664',
  },
  {
    city: 'Vancouver',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 1513.3,
    imprecise: false,
    latitude: 45.68155,
    longitude: -122.65417,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28910,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98665',
  },
  {
    city: 'Wahkiacus',
    county_fips: 53039,
    county_fips_all: '53039',
    county: 'Klickitat',
    county_names_all: 'Klickitat',
    county_weights: '{"53039": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 45.86372,
    longitude: -121.14599,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 68,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98670',
  },
  {
    city: 'Washougal',
    county_fips: 53011,
    county_fips_all: '53011|53059',
    county: 'Clark',
    county_names_all: 'Clark|Skamania',
    county_weights: '{"53011": 50.26, "53059": 49.74}',
    density: 118.4,
    imprecise: false,
    latitude: 45.61143,
    longitude: -122.24955,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98671',
  },
  {
    city: 'White Salmon',
    county_fips: 53039,
    county_fips_all: '53039|53059',
    county: 'Klickitat',
    county_names_all: 'Klickitat|Skamania',
    county_weights: '{"53039": 95.7, "53059": 4.3}',
    density: 20.6,
    imprecise: false,
    latitude: 45.81269,
    longitude: -121.47393,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98672',
  },
  {
    city: 'Wishram',
    county_fips: 53039,
    county_fips_all: '53039',
    county: 'Klickitat',
    county_names_all: 'Klickitat',
    county_weights: '{"53039": 100}',
    density: 9.3,
    imprecise: false,
    latitude: 45.67367,
    longitude: -120.98129,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 411,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98673',
  },
  {
    city: 'Woodland',
    county_fips: 53015,
    county_fips_all: '53015|53011',
    county: 'Cowlitz',
    county_names_all: 'Cowlitz|Clark',
    county_weights: '{"53015": 62.61, "53011": 37.39}',
    density: 78.2,
    imprecise: false,
    latitude: 45.94672,
    longitude: -122.65568,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17525,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98674',
  },
  {
    city: 'Yacolt',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 45.86349,
    longitude: -122.33104,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98675',
  },
  {
    city: 'Vancouver',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 924.9,
    imprecise: false,
    latitude: 45.67296,
    longitude: -122.48327,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 68305,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98682',
  },
  {
    city: 'Vancouver',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 1708.3,
    imprecise: false,
    latitude: 45.6027,
    longitude: -122.50984,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98683',
  },
  {
    city: 'Vancouver',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 2032.9,
    imprecise: false,
    latitude: 45.6308,
    longitude: -122.51615,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98684',
  },
  {
    city: 'Vancouver',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 1155.2,
    imprecise: false,
    latitude: 45.71596,
    longitude: -122.69105,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 30607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98685',
  },
  {
    city: 'Vancouver',
    county_fips: 53011,
    county_fips_all: '53011',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"53011": 100}',
    density: 703.8,
    imprecise: false,
    latitude: 45.7239,
    longitude: -122.62305,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98686',
  },
  {
    city: 'Wenatchee',
    county_fips: 53007,
    county_fips_all: '53007',
    county: 'Chelan',
    county_names_all: 'Chelan',
    county_weights: '{"53007": 100}',
    density: 114.2,
    imprecise: false,
    latitude: 47.43183,
    longitude: -120.34356,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 45426,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98801',
  },
  {
    city: 'East Wenatchee',
    county_fips: 53017,
    county_fips_all: '53017',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"53017": 100}',
    density: 71.8,
    imprecise: false,
    latitude: 47.49308,
    longitude: -120.16493,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98802',
  },
  {
    city: 'Ardenvoir',
    county_fips: 53007,
    county_fips_all: '53007',
    county: 'Chelan',
    county_names_all: 'Chelan',
    county_weights: '{"53007": 100}',
    density: 4.6,
    imprecise: false,
    latitude: 47.73425,
    longitude: -120.37379,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98811',
  },
  {
    city: 'Brewster',
    county_fips: 53047,
    county_fips_all: '53047|53017',
    county: 'Okanogan',
    county_names_all: 'Okanogan|Douglas',
    county_weights: '{"53047": 74.94, "53017": 25.06}',
    density: 9.6,
    imprecise: false,
    latitude: 48.13119,
    longitude: -119.80687,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98812',
  },
  {
    city: 'Bridgeport',
    county_fips: 53017,
    county_fips_all: '53017|53047',
    county: 'Douglas',
    county_names_all: 'Douglas|Okanogan',
    county_weights: '{"53017": 76.94, "53047": 23.06}',
    density: 10.9,
    imprecise: false,
    latitude: 48.01107,
    longitude: -119.61063,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98813',
  },
  {
    city: 'Carlton',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 48.21001,
    longitude: -120.22884,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 473,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98814',
  },
  {
    city: 'Cashmere',
    county_fips: 53007,
    county_fips_all: '53007',
    county: 'Chelan',
    county_names_all: 'Chelan',
    county_weights: '{"53007": 100}',
    density: 31.2,
    imprecise: false,
    latitude: 47.52893,
    longitude: -120.48459,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7830,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98815',
  },
  {
    city: 'Chelan',
    county_fips: 53007,
    county_fips_all: '53007|53047',
    county: 'Chelan',
    county_names_all: 'Chelan|Okanogan',
    county_weights: '{"53007": 98.63, "53047": 1.37}',
    density: 6.1,
    imprecise: false,
    latitude: 48.0229,
    longitude: -120.34361,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7752,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98816',
  },
  {
    city: 'Chelan Falls',
    county_fips: 53007,
    county_fips_all: '53007',
    county: 'Chelan',
    county_names_all: 'Chelan',
    county_weights: '{"53007": 100}',
    density: 97.3,
    imprecise: false,
    latitude: 47.79049,
    longitude: -119.99588,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 233,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98817',
  },
  {
    city: 'Conconully',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 48.59797,
    longitude: -119.82327,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98819',
  },
  {
    city: 'Dryden',
    county_fips: 53007,
    county_fips_all: '53007',
    county: 'Chelan',
    county_names_all: 'Chelan',
    county_weights: '{"53007": 100}',
    density: 297.9,
    imprecise: false,
    latitude: 47.55199,
    longitude: -120.56155,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98821',
  },
  {
    city: 'Entiat',
    county_fips: 53007,
    county_fips_all: '53007',
    county: 'Chelan',
    county_names_all: 'Chelan',
    county_weights: '{"53007": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 47.86509,
    longitude: -120.47694,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98822',
  },
  {
    city: 'Ephrata',
    county_fips: 53025,
    county_fips_all: '53025|53017',
    county: 'Grant',
    county_names_all: 'Grant|Douglas',
    county_weights: '{"53025": 73.22, "53017": 26.78}',
    density: 15.8,
    imprecise: false,
    latitude: 47.33853,
    longitude: -119.63536,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98823',
  },
  {
    city: 'George',
    county_fips: 53025,
    county_fips_all: '53025',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"53025": 100}',
    density: 59.5,
    imprecise: false,
    latitude: 47.06857,
    longitude: -119.86653,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98824',
  },
  {
    city: 'Leavenworth',
    county_fips: 53007,
    county_fips_all: '53007',
    county: 'Chelan',
    county_names_all: 'Chelan',
    county_weights: '{"53007": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 47.78772,
    longitude: -120.85454,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98826',
  },
  {
    city: 'Loomis',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 48.86359,
    longitude: -119.76726,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98827',
  },
  {
    city: 'Malaga',
    county_fips: 53007,
    county_fips_all: '53007|53037',
    county: 'Chelan',
    county_names_all: 'Chelan|Kittitas',
    county_weights: '{"53007": 91.37, "53037": 8.63}',
    density: 11.9,
    imprecise: false,
    latitude: 47.30741,
    longitude: -120.1833,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1898,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98828',
  },
  {
    city: 'Malott',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 2,
    imprecise: false,
    latitude: 48.31103,
    longitude: -119.80822,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98829',
  },
  {
    city: 'Mansfield',
    county_fips: 53017,
    county_fips_all: '53017',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"53017": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 47.88702,
    longitude: -119.52278,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98830',
  },
  {
    city: 'Manson',
    county_fips: 53007,
    county_fips_all: '53007',
    county: 'Chelan',
    county_names_all: 'Chelan',
    county_weights: '{"53007": 100}',
    density: 32.4,
    imprecise: false,
    latitude: 47.93451,
    longitude: -120.12998,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98831',
  },
  {
    city: 'Marlin',
    county_fips: 53025,
    county_fips_all: '53025|53043|53001',
    county: 'Grant',
    county_names_all: 'Grant|Lincoln|Adams',
    county_weights: '{"53025": 69.47, "53043": 29.5, "53001": 1.03}',
    density: 0.2,
    imprecise: false,
    latitude: 47.34669,
    longitude: -119.02033,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98832',
  },
  {
    city: 'Mazama',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.77199,
    longitude: -120.49447,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98833',
  },
  {
    city: 'Methow',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 48.11712,
    longitude: -120.08935,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98834',
  },
  {
    city: 'Monitor',
    county_fips: 53007,
    county_fips_all: '53007',
    county: 'Chelan',
    county_names_all: 'Chelan',
    county_weights: '{"53007": 100}',
    density: 23.1,
    imprecise: false,
    latitude: 47.47615,
    longitude: -120.42909,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98836',
  },
  {
    city: 'Moses Lake',
    county_fips: 53025,
    county_fips_all: '53025',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"53025": 100}',
    density: 39.3,
    imprecise: false,
    latitude: 47.14809,
    longitude: -119.3163,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 49455,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98837',
  },
  {
    city: 'Okanogan',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 48.27395,
    longitude: -119.51838,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4892,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98840',
  },
  {
    city: 'Omak',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 12.7,
    imprecise: false,
    latitude: 48.37602,
    longitude: -119.29817,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9737,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98841',
  },
  {
    city: 'Orondo',
    county_fips: 53017,
    county_fips_all: '53017',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"53017": 100}',
    density: 14.4,
    imprecise: false,
    latitude: 47.73688,
    longitude: -120.08618,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98843',
  },
  {
    city: 'Oroville',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 5.7,
    imprecise: false,
    latitude: 48.91618,
    longitude: -119.24767,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4873,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98844',
  },
  {
    city: 'Palisades',
    county_fips: 53017,
    county_fips_all: '53017',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"53017": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 47.43039,
    longitude: -119.90923,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98845',
  },
  {
    city: 'Pateros',
    county_fips: 53047,
    county_fips_all: '53047|53007',
    county: 'Okanogan',
    county_names_all: 'Okanogan|Chelan',
    county_weights: '{"53047": 95.43, "53007": 4.57}',
    density: 6.2,
    imprecise: false,
    latitude: 48.03481,
    longitude: -119.97528,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98846',
  },
  {
    city: 'Peshastin',
    county_fips: 53007,
    county_fips_all: '53007',
    county: 'Chelan',
    county_names_all: 'Chelan',
    county_weights: '{"53007": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 47.42236,
    longitude: -120.62152,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98847',
  },
  {
    city: 'Quincy',
    county_fips: 53025,
    county_fips_all: '53025|53017',
    county: 'Grant',
    county_names_all: 'Grant|Douglas',
    county_weights: '{"53025": 97.72, "53017": 2.28}',
    density: 10.9,
    imprecise: false,
    latitude: 47.17182,
    longitude: -119.84109,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12854,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98848',
  },
  {
    city: 'Riverside',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 48.54821,
    longitude: -119.40789,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98849',
  },
  {
    city: 'Rock Island',
    county_fips: 53017,
    county_fips_all: '53017',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"53017": 100}',
    density: 10.3,
    imprecise: false,
    latitude: 47.40048,
    longitude: -120.03459,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2032,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98850',
  },
  {
    city: 'Soap Lake',
    county_fips: 53025,
    county_fips_all: '53025',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"53025": 100}',
    density: 11.7,
    imprecise: false,
    latitude: 47.42002,
    longitude: -119.43462,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98851',
  },
  {
    city: 'Stehekin',
    county_fips: 53007,
    county_fips_all: '53007',
    county: 'Chelan',
    county_names_all: 'Chelan',
    county_weights: '{"53007": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 48.32169,
    longitude: -120.63881,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 44,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98852',
  },
  {
    city: 'Stratford',
    county_fips: 53025,
    county_fips_all: '53025',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"53025": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 47.44655,
    longitude: -119.28061,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98853',
  },
  {
    city: 'Tonasket',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 48.67641,
    longitude: -119.25634,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5857,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98855',
  },
  {
    city: 'Twisp',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 48.37065,
    longitude: -120.22762,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2920,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98856',
  },
  {
    city: 'Warden',
    county_fips: 53025,
    county_fips_all: '53025|53001',
    county: 'Grant',
    county_names_all: 'Grant|Adams',
    county_weights: '{"53025": 68.99, "53001": 31.01}',
    density: 9.4,
    imprecise: false,
    latitude: 46.98656,
    longitude: -119.03698,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4062,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98857',
  },
  {
    city: 'Waterville',
    county_fips: 53017,
    county_fips_all: '53017',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"53017": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 47.67938,
    longitude: -119.87974,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1783,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98858',
  },
  {
    city: 'Wauconda',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 48.81181,
    longitude: -118.90871,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98859',
  },
  {
    city: 'Wilson Creek',
    county_fips: 53025,
    county_fips_all: '53025',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"53025": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 47.46899,
    longitude: -119.12391,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 277,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98860',
  },
  {
    city: 'Winthrop',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 48.58491,
    longitude: -120.22792,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98862',
  },
  {
    city: 'Yakima',
    county_fips: 53077,
    county_fips_all: '53077|53037',
    county: 'Yakima',
    county_names_all: 'Yakima|Kittitas',
    county_weights: '{"53077": 91.25, "53037": 8.75}',
    density: 65.6,
    imprecise: false,
    latitude: 46.66935,
    longitude: -120.33816,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 31366,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98901',
  },
  {
    city: 'Yakima',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 1928.9,
    imprecise: false,
    latitude: 46.59778,
    longitude: -120.53393,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 46492,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98902',
  },
  {
    city: 'Yakima',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 39,
    imprecise: false,
    latitude: 46.54807,
    longitude: -120.90226,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98903',
  },
  {
    city: 'Yakima',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 139,
    imprecise: false,
    latitude: 46.62345,
    longitude: -120.70582,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 38060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98908',
  },
  {
    city: 'Buena',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 271.5,
    imprecise: false,
    latitude: 46.43082,
    longitude: -120.31719,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98921',
  },
  {
    city: 'Cle Elum',
    county_fips: 53037,
    county_fips_all: '53037',
    county: 'Kittitas',
    county_names_all: 'Kittitas',
    county_weights: '{"53037": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 47.25056,
    longitude: -120.8821,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98922',
  },
  {
    city: 'Cowiche',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 65.5,
    imprecise: false,
    latitude: 46.66608,
    longitude: -120.71723,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 994,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98923',
  },
  {
    city: 'Easton',
    county_fips: 53037,
    county_fips_all: '53037',
    county: 'Kittitas',
    county_names_all: 'Kittitas',
    county_weights: '{"53037": 100}',
    density: 2.6,
    imprecise: false,
    latitude: 47.28793,
    longitude: -121.28089,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98925',
  },
  {
    city: 'Ellensburg',
    county_fips: 53037,
    county_fips_all: '53037',
    county: 'Kittitas',
    county_names_all: 'Kittitas',
    county_weights: '{"53037": 100}',
    density: 14.1,
    imprecise: false,
    latitude: 46.99054,
    longitude: -120.34902,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34353,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98926',
  },
  {
    city: 'Grandview',
    county_fips: 53077,
    county_fips_all: '53077|53005',
    county: 'Yakima',
    county_names_all: 'Yakima|Benton',
    county_weights: '{"53077": 62.37, "53005": 37.63}',
    density: 135.4,
    imprecise: false,
    latitude: 46.26903,
    longitude: -119.8953,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98930',
  },
  {
    city: 'Granger',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 65,
    imprecise: false,
    latitude: 46.33217,
    longitude: -120.16091,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5742,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98932',
  },
  {
    city: 'Harrah',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 46.4029,
    longitude: -120.63756,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98933',
  },
  {
    city: 'Kittitas',
    county_fips: 53037,
    county_fips_all: '53037',
    county: 'Kittitas',
    county_names_all: 'Kittitas',
    county_weights: '{"53037": 100}',
    density: 262.8,
    imprecise: false,
    latitude: 46.98067,
    longitude: -120.41941,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 775,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98934',
  },
  {
    city: 'Mabton',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 46.13417,
    longitude: -120.06877,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98935',
  },
  {
    city: 'Moxee',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 24.4,
    imprecise: false,
    latitude: 46.53597,
    longitude: -120.15391,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8744,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98936',
  },
  {
    city: 'Naches',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 46.77523,
    longitude: -121.17808,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98937',
  },
  {
    city: 'Outlook',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 46.38842,
    longitude: -120.09662,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1591,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98938',
  },
  {
    city: 'Parker',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 72.9,
    imprecise: false,
    latitude: 46.50105,
    longitude: -120.47077,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98939',
  },
  {
    city: 'Ronald',
    county_fips: 53037,
    county_fips_all: '53037',
    county: 'Kittitas',
    county_names_all: 'Kittitas',
    county_weights: '{"53037": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 47.39682,
    longitude: -121.06683,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 858,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98940',
  },
  {
    city: 'Roslyn',
    county_fips: 53037,
    county_fips_all: '53037',
    county: 'Kittitas',
    county_names_all: 'Kittitas',
    county_weights: '{"53037": 100}',
    density: 262.1,
    imprecise: false,
    latitude: 47.22464,
    longitude: -121.00021,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1076,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98941',
  },
  {
    city: 'Selah',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 39.8,
    imprecise: false,
    latitude: 46.80322,
    longitude: -120.67454,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 18871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98942',
  },
  {
    city: 'South Cle Elum',
    county_fips: 53037,
    county_fips_all: '53037',
    county: 'Kittitas',
    county_names_all: 'Kittitas',
    county_weights: '{"53037": 100}',
    density: 268.5,
    imprecise: false,
    latitude: 47.18461,
    longitude: -120.96089,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98943',
  },
  {
    city: 'Sunnyside',
    county_fips: 53005,
    county_fips_all: '53005|53077',
    county: 'Benton',
    county_names_all: 'Benton|Yakima',
    county_weights: '{"53005": 73.37, "53077": 26.63}',
    density: 16.2,
    imprecise: false,
    latitude: 46.49998,
    longitude: -119.66533,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22817,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98944',
  },
  {
    city: 'Thorp',
    county_fips: 53037,
    county_fips_all: '53037',
    county: 'Kittitas',
    county_names_all: 'Kittitas',
    county_weights: '{"53037": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 47.06515,
    longitude: -120.76512,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98946',
  },
  {
    city: 'Tieton',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 27.4,
    imprecise: false,
    latitude: 46.68759,
    longitude: -120.80916,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98947',
  },
  {
    city: 'Toppenish',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 46.23067,
    longitude: -120.37168,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12638,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98948',
  },
  {
    city: 'Vantage',
    county_fips: 53037,
    county_fips_all: '53037',
    county: 'Kittitas',
    county_names_all: 'Kittitas',
    county_weights: '{"53037": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 46.84642,
    longitude: -119.9877,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98950',
  },
  {
    city: 'Wapato',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 32.6,
    imprecise: false,
    latitude: 46.46046,
    longitude: -120.51551,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98951',
  },
  {
    city: 'White Swan',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 2,
    imprecise: false,
    latitude: 46.34991,
    longitude: -120.81561,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98952',
  },
  {
    city: 'Zillah',
    county_fips: 53077,
    county_fips_all: '53077',
    county: 'Yakima',
    county_names_all: 'Yakima',
    county_weights: '{"53077": 100}',
    density: 45.7,
    imprecise: false,
    latitude: 46.44149,
    longitude: -120.23284,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98953',
  },
  {
    city: 'Airway Heights',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 458.4,
    imprecise: false,
    latitude: 47.63874,
    longitude: -117.58582,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99001',
  },
  {
    city: 'Chattaroy',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 24.4,
    imprecise: false,
    latitude: 47.91997,
    longitude: -117.27608,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4810,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99003',
  },
  {
    city: 'Cheney',
    county_fips: 53063,
    county_fips_all: '53063|53075',
    county: 'Spokane',
    county_names_all: 'Spokane|Whitman',
    county_weights: '{"53063": 96.27, "53075": 3.73}',
    density: 26.4,
    imprecise: false,
    latitude: 47.40869,
    longitude: -117.63575,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 22871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99004',
  },
  {
    city: 'Colbert',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 105.5,
    imprecise: false,
    latitude: 47.84405,
    longitude: -117.36346,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10815,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99005',
  },
  {
    city: 'Deer Park',
    county_fips: 53063,
    county_fips_all: '53063|53065|53051',
    county: 'Spokane',
    county_names_all: 'Spokane|Stevens|Pend Oreille',
    county_weights: '{"53063": 54.48, "53065": 40.71, "53051": 4.81}',
    density: 38.1,
    imprecise: false,
    latitude: 47.95208,
    longitude: -117.51016,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99006',
  },
  {
    city: 'Edwall',
    county_fips: 53043,
    county_fips_all: '53043|53063',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Spokane',
    county_weights: '{"53043": 94.64, "53063": 5.36}',
    density: 0.8,
    imprecise: false,
    latitude: 47.50449,
    longitude: -117.93533,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 317,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99008',
  },
  {
    city: 'Elk',
    county_fips: 53063,
    county_fips_all: '53063|53051',
    county: 'Spokane',
    county_names_all: 'Spokane|Pend Oreille',
    county_weights: '{"53063": 65.59, "53051": 34.41}',
    density: 21.5,
    imprecise: false,
    latitude: 48.0253,
    longitude: -117.24993,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99009',
  },
  {
    city: 'Fairchild Air Force Base',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 170.9,
    imprecise: false,
    latitude: 47.61867,
    longitude: -117.64839,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2931,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99011',
  },
  {
    city: 'Fairfield',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 47.38137,
    longitude: -117.19145,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99012',
  },
  {
    city: 'Ford',
    county_fips: 53065,
    county_fips_all: '53065|53063|53043',
    county: 'Stevens',
    county_names_all: 'Stevens|Spokane|Lincoln',
    county_weights: '{"53065": 70.19, "53063": 15.56, "53043": 14.25}',
    density: 7.1,
    imprecise: false,
    latitude: 47.88498,
    longitude: -117.83495,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99013',
  },
  {
    city: 'Four Lakes',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 63.8,
    imprecise: false,
    latitude: 47.56111,
    longitude: -117.59666,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99014',
  },
  {
    city: 'Greenacres',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 339.1,
    imprecise: false,
    latitude: 47.6217,
    longitude: -117.14623,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21615,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99016',
  },
  {
    city: 'Lamont',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 1,
    imprecise: false,
    latitude: 47.1829,
    longitude: -117.87611,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99017',
  },
  {
    city: 'Latah',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 47.2917,
    longitude: -117.15212,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99018',
  },
  {
    city: 'Liberty Lake',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 215.6,
    imprecise: false,
    latitude: 47.64222,
    longitude: -117.07688,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 12447,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99019',
  },
  {
    city: 'Marshall',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 143.8,
    imprecise: false,
    latitude: 47.56314,
    longitude: -117.49702,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99020',
  },
  {
    city: 'Mead',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 43,
    imprecise: false,
    latitude: 47.84951,
    longitude: -117.18721,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8942,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99021',
  },
  {
    city: 'Medical Lake',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 49.5,
    imprecise: false,
    latitude: 47.60084,
    longitude: -117.70869,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99022',
  },
  {
    city: 'Mica',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 17,
    imprecise: false,
    latitude: 47.56474,
    longitude: -117.14466,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 800,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99023',
  },
  {
    city: 'Newman Lake',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 47.8,
    imprecise: false,
    latitude: 47.78963,
    longitude: -117.08751,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99025',
  },
  {
    city: 'Nine Mile Falls',
    county_fips: 53063,
    county_fips_all: '53063|53065',
    county: 'Spokane',
    county_names_all: 'Spokane|Stevens',
    county_weights: '{"53063": 75.63, "53065": 24.37}',
    density: 57,
    imprecise: false,
    latitude: 47.80375,
    longitude: -117.625,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9320,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99026',
  },
  {
    city: 'Otis Orchards',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 149.5,
    imprecise: false,
    latitude: 47.71107,
    longitude: -117.12795,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99027',
  },
  {
    city: 'Reardan',
    county_fips: 53043,
    county_fips_all: '53043|53063',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Spokane',
    county_weights: '{"53043": 54.58, "53063": 45.42}',
    density: 7.4,
    imprecise: false,
    latitude: 47.70639,
    longitude: -117.82406,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99029',
  },
  {
    city: 'Rockford',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 47.47782,
    longitude: -117.11302,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99030',
  },
  {
    city: 'Spangle',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 6.3,
    imprecise: false,
    latitude: 47.41973,
    longitude: -117.35991,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99031',
  },
  {
    city: 'Sprague',
    county_fips: 53043,
    county_fips_all: '53043|53001|53063',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Adams|Spokane',
    county_weights: '{"53043": 85.86, "53001": 12.51, "53063": 1.63}',
    density: 1.6,
    imprecise: false,
    latitude: 47.32405,
    longitude: -118.04613,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1018,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99032',
  },
  {
    city: 'Tekoa',
    county_fips: 53075,
    county_fips_all: '53075|53063|16009',
    county: 'Whitman',
    county_names_all: 'Whitman|Spokane|Benewah',
    county_weights: '{"53075": 81.97, "53063": 16.13, "16009": 1.9}',
    density: 8.1,
    imprecise: false,
    latitude: 47.23061,
    longitude: -117.09782,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99033',
  },
  {
    city: 'Tumtum',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 47.8862,
    longitude: -117.76245,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99034',
  },
  {
    city: 'Valleyford',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 16,
    imprecise: false,
    latitude: 47.52005,
    longitude: -117.27197,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99036',
  },
  {
    city: 'Veradale',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 1014.3,
    imprecise: false,
    latitude: 47.63734,
    longitude: -117.19756,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99037',
  },
  {
    city: 'Waverly',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 156.8,
    imprecise: false,
    latitude: 47.33808,
    longitude: -117.23131,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 166,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99039',
  },
  {
    city: 'Wellpinit',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 47.90355,
    longitude: -117.99885,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 536,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99040',
  },
  {
    city: 'Addy',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 48.31889,
    longitude: -117.9483,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1690,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99101',
  },
  {
    city: 'Albion',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 560.8,
    imprecise: false,
    latitude: 46.79218,
    longitude: -117.25029,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99102',
  },
  {
    city: 'Almira',
    county_fips: 53043,
    county_fips_all: '53043|53025',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Grant',
    county_weights: '{"53043": 76.14, "53025": 23.86}',
    density: 0.9,
    imprecise: false,
    latitude: 47.73041,
    longitude: -118.93171,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99103',
  },
  {
    city: 'Benge',
    county_fips: 53001,
    county_fips_all: '53001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"53001": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 46.9213,
    longitude: -118.08264,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99105',
  },
  {
    city: 'Chewelah',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 6.2,
    imprecise: false,
    latitude: 48.29787,
    longitude: -117.69852,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4981,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99109',
  },
  {
    city: 'Clayton',
    county_fips: 53065,
    county_fips_all: '53065|53063',
    county: 'Stevens',
    county_names_all: 'Stevens|Spokane',
    county_weights: '{"53065": 92.99, "53063": 7.01}',
    density: 15,
    imprecise: false,
    latitude: 48.0083,
    longitude: -117.58112,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1505,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99110',
  },
  {
    city: 'Colfax',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 46.86281,
    longitude: -117.44132,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99111',
  },
  {
    city: 'Colton',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 46.58628,
    longitude: -117.1935,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 560,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99113',
  },
  {
    city: 'Colville',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 48.66067,
    longitude: -117.74333,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 13383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99114',
  },
  {
    city: 'Coulee City',
    county_fips: 53017,
    county_fips_all: '53017|53025',
    county: 'Douglas',
    county_names_all: 'Douglas|Grant',
    county_weights: '{"53017": 65.51, "53025": 34.49}',
    density: 1.3,
    imprecise: false,
    latitude: 47.67326,
    longitude: -119.38965,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1369,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99115',
  },
  {
    city: 'Coulee Dam',
    county_fips: 53047,
    county_fips_all: '53047|53025|53017',
    county: 'Okanogan',
    county_names_all: 'Okanogan|Grant|Douglas',
    county_weights: '{"53047": 96.94, "53025": 2.75, "53017": 0.31}',
    density: 14.6,
    imprecise: false,
    latitude: 48.01429,
    longitude: -118.93063,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99116',
  },
  {
    city: 'Creston',
    county_fips: 53043,
    county_fips_all: '53043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"53043": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 47.72818,
    longitude: -118.50108,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 556,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99117',
  },
  {
    city: 'Curlew',
    county_fips: 53019,
    county_fips_all: '53019',
    county: 'Ferry',
    county_names_all: 'Ferry',
    county_weights: '{"53019": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 48.89746,
    longitude: -118.63797,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99118',
  },
  {
    city: 'Cusick',
    county_fips: 53051,
    county_fips_all: '53051',
    county: 'Pend Oreille',
    county_names_all: 'Pend Oreille',
    county_weights: '{"53051": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 48.50946,
    longitude: -117.29994,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1549,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99119',
  },
  {
    city: 'Danville',
    county_fips: 53019,
    county_fips_all: '53019',
    county: 'Ferry',
    county_names_all: 'Ferry',
    county_weights: '{"53019": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 48.94382,
    longitude: -118.45568,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99121',
  },
  {
    city: 'Davenport',
    county_fips: 53043,
    county_fips_all: '53043|53065',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Stevens',
    county_weights: '{"53043": 98.25, "53065": 1.75}',
    density: 2.6,
    imprecise: false,
    latitude: 47.67615,
    longitude: -118.21774,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4046,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99122',
  },
  {
    city: 'Electric City',
    county_fips: 53025,
    county_fips_all: '53025',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"53025": 100}',
    density: 18.8,
    imprecise: false,
    latitude: 47.89738,
    longitude: -119.04017,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 977,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99123',
  },
  {
    city: 'Elmer City',
    county_fips: 53047,
    county_fips_all: '53047|53017',
    county: 'Okanogan',
    county_names_all: 'Okanogan|Douglas',
    county_weights: '{"53047": 99.89, "53017": 0.11}',
    density: 361.1,
    imprecise: false,
    latitude: 48.00284,
    longitude: -118.95243,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99124',
  },
  {
    city: 'Endicott',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 46.95223,
    longitude: -117.78556,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99125',
  },
  {
    city: 'Evans',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 48.73574,
    longitude: -117.97447,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 899,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99126',
  },
  {
    city: 'Farmington',
    county_fips: 53075,
    county_fips_all: '53075|16057',
    county: 'Whitman',
    county_names_all: 'Whitman|Latah',
    county_weights: '{"53075": 92.53, "16057": 7.47}',
    density: 1.7,
    imprecise: false,
    latitude: 47.10045,
    longitude: -117.08523,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99128',
  },
  {
    city: 'Fruitland',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 1.9,
    imprecise: false,
    latitude: 48.00281,
    longitude: -118.18342,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 725,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99129',
  },
  {
    city: 'Garfield',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 46.99917,
    longitude: -117.18556,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99130',
  },
  {
    city: 'Gifford',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 48.29511,
    longitude: -118.11731,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99131',
  },
  {
    city: 'Grand Coulee',
    county_fips: 53017,
    county_fips_all: '53017|53025|53043',
    county: 'Douglas',
    county_names_all: 'Douglas|Grant|Lincoln',
    county_weights: '{"53017": 74.52, "53025": 16.26, "53043": 9.22}',
    density: 2.4,
    imprecise: false,
    latitude: 48.0067,
    longitude: -119.10613,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99133',
  },
  {
    city: 'Harrington',
    county_fips: 53043,
    county_fips_all: '53043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"53043": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 47.43793,
    longitude: -118.32347,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99134',
  },
  {
    city: 'Hartline',
    county_fips: 53025,
    county_fips_all: '53025',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"53025": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 47.65658,
    longitude: -119.09608,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99135',
  },
  {
    city: 'Hay',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 46.6747,
    longitude: -117.94889,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99136',
  },
  {
    city: 'Hunters',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 48.1659,
    longitude: -118.09992,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99137',
  },
  {
    city: 'Inchelium',
    county_fips: 53019,
    county_fips_all: '53019',
    county: 'Ferry',
    county_names_all: 'Ferry',
    county_weights: '{"53019": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 48.23093,
    longitude: -118.38876,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99138',
  },
  {
    city: 'Ione',
    county_fips: 53051,
    county_fips_all: '53051',
    county: 'Pend Oreille',
    county_names_all: 'Pend Oreille',
    county_weights: '{"53051": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 48.73161,
    longitude: -117.31371,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99139',
  },
  {
    city: 'Keller',
    county_fips: 53019,
    county_fips_all: '53019',
    county: 'Ferry',
    county_names_all: 'Ferry',
    county_weights: '{"53019": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 48.135,
    longitude: -118.68722,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99140',
  },
  {
    city: 'Kettle Falls',
    county_fips: 53019,
    county_fips_all: '53019|53065',
    county: 'Ferry',
    county_names_all: 'Ferry|Stevens',
    county_weights: '{"53019": 51.91, "53065": 48.09}',
    density: 3.5,
    imprecise: false,
    latitude: 48.72571,
    longitude: -118.17509,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5626,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99141',
  },
  {
    city: 'Lacrosse',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 46.74627,
    longitude: -117.85869,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 585,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99143',
  },
  {
    city: 'Lamona',
    county_fips: 53043,
    county_fips_all: '53043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"53043": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 47.3681,
    longitude: -118.49041,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99144',
  },
  {
    city: 'Laurier',
    county_fips: 53019,
    county_fips_all: '53019',
    county: 'Ferry',
    county_names_all: 'Ferry',
    county_weights: '{"53019": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 48.95766,
    longitude: -118.29768,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99146',
  },
  {
    city: 'Lincoln',
    county_fips: 53043,
    county_fips_all: '53043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"53043": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 47.83604,
    longitude: -118.43675,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99147',
  },
  {
    city: 'Loon Lake',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 48.10874,
    longitude: -117.57514,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2794,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99148',
  },
  {
    city: 'Malden',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 20.1,
    imprecise: false,
    latitude: 47.225,
    longitude: -117.46794,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99149',
  },
  {
    city: 'Malo',
    county_fips: 53019,
    county_fips_all: '53019',
    county: 'Ferry',
    county_names_all: 'Ferry',
    county_weights: '{"53019": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 48.80622,
    longitude: -118.61071,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 351,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99150',
  },
  {
    city: 'Marcus',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 511.4,
    imprecise: false,
    latitude: 48.66443,
    longitude: -118.06125,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 242,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99151',
  },
  {
    city: 'Metaline',
    county_fips: 53051,
    county_fips_all: '53051',
    county: 'Pend Oreille',
    county_names_all: 'Pend Oreille',
    county_weights: '{"53051": 100}',
    density: 13.7,
    imprecise: false,
    latitude: 48.85066,
    longitude: -117.39748,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99152',
  },
  {
    city: 'Metaline Falls',
    county_fips: 53051,
    county_fips_all: '53051',
    county: 'Pend Oreille',
    county_names_all: 'Pend Oreille',
    county_weights: '{"53051": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 48.90951,
    longitude: -117.25229,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99153',
  },
  {
    city: 'Mohler',
    county_fips: 53043,
    county_fips_all: '53043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"53043": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 47.39132,
    longitude: -118.35576,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99154',
  },
  {
    city: 'Nespelem',
    county_fips: 53047,
    county_fips_all: '53047',
    county: 'Okanogan',
    county_names_all: 'Okanogan',
    county_weights: '{"53047": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 48.27737,
    longitude: -118.9618,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1009,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99155',
  },
  {
    city: 'Newport',
    county_fips: 53051,
    county_fips_all: '53051|53063',
    county: 'Pend Oreille',
    county_names_all: 'Pend Oreille|Spokane',
    county_weights: '{"53051": 89.64, "53063": 10.36}',
    density: 13,
    imprecise: false,
    latitude: 48.16211,
    longitude: -117.18826,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99156',
  },
  {
    city: 'Northport',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 48.93007,
    longitude: -117.81753,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 605,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99157',
  },
  {
    city: 'Oakesdale',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 47.13305,
    longitude: -117.24008,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 561,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99158',
  },
  {
    city: 'Odessa',
    county_fips: 53043,
    county_fips_all: '53043|53001',
    county: 'Lincoln',
    county_names_all: 'Lincoln|Adams',
    county_weights: '{"53043": 67.95, "53001": 32.05}',
    density: 1.1,
    imprecise: false,
    latitude: 47.32872,
    longitude: -118.74338,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99159',
  },
  {
    city: 'Orient',
    county_fips: 53019,
    county_fips_all: '53019',
    county: 'Ferry',
    county_names_all: 'Ferry',
    county_weights: '{"53019": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 48.86895,
    longitude: -118.30122,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99160',
  },
  {
    city: 'Palouse',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 7.2,
    imprecise: false,
    latitude: 46.89496,
    longitude: -117.13169,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1435,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99161',
  },
  {
    city: 'Pullman',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 62.3,
    imprecise: false,
    latitude: 46.72798,
    longitude: -117.21654,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 34022,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99163',
  },
  {
    city: 'Republic',
    county_fips: 53019,
    county_fips_all: '53019|53047',
    county: 'Ferry',
    county_names_all: 'Ferry|Okanogan',
    county_weights: '{"53019": 98.47, "53047": 1.53}',
    density: 2.4,
    imprecise: false,
    latitude: 48.61033,
    longitude: -118.6715,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99166',
  },
  {
    city: 'Rice',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 48.41307,
    longitude: -118.11733,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 871,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99167',
  },
  {
    city: 'Ritzville',
    county_fips: 53001,
    county_fips_all: '53001|53043',
    county: 'Adams',
    county_names_all: 'Adams|Lincoln',
    county_weights: '{"53001": 92.71, "53043": 7.29}',
    density: 1.4,
    imprecise: false,
    latitude: 47.11875,
    longitude: -118.37424,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2587,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99169',
  },
  {
    city: 'Rosalia',
    county_fips: 53075,
    county_fips_all: '53075|53063',
    county: 'Whitman',
    county_names_all: 'Whitman|Spokane',
    county_weights: '{"53075": 57.1, "53063": 42.9}',
    density: 2.1,
    imprecise: false,
    latitude: 47.25132,
    longitude: -117.40203,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 926,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99170',
  },
  {
    city: 'Saint John',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 47.10485,
    longitude: -117.6495,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 895,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99171',
  },
  {
    city: 'Springdale',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 48.03702,
    longitude: -117.85708,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1623,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99173',
  },
  {
    city: 'Steptoe',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 976.3,
    imprecise: false,
    latitude: 47.00719,
    longitude: -117.35682,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 69,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99174',
  },
  {
    city: 'Thornton',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 47.09221,
    longitude: -117.41224,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99176',
  },
  {
    city: 'Uniontown',
    county_fips: 53075,
    county_fips_all: '53075',
    county: 'Whitman',
    county_names_all: 'Whitman',
    county_weights: '{"53075": 100}',
    density: 3.8,
    imprecise: false,
    latitude: 46.49239,
    longitude: -117.10762,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 645,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99179',
  },
  {
    city: 'Usk',
    county_fips: 53051,
    county_fips_all: '53051',
    county: 'Pend Oreille',
    county_names_all: 'Pend Oreille',
    county_weights: '{"53051": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 48.30925,
    longitude: -117.30663,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99180',
  },
  {
    city: 'Valley',
    county_fips: 53065,
    county_fips_all: '53065',
    county: 'Stevens',
    county_names_all: 'Stevens',
    county_weights: '{"53065": 100}',
    density: 8.4,
    imprecise: false,
    latitude: 48.1456,
    longitude: -117.76526,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99181',
  },
  {
    city: 'Wilbur',
    county_fips: 53043,
    county_fips_all: '53043',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"53043": 100}',
    density: 2,
    imprecise: false,
    latitude: 47.74014,
    longitude: -118.71697,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1501,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99185',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 2057.8,
    imprecise: false,
    latitude: 47.66271,
    longitude: -117.43609,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 15829,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99201',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 1293.7,
    imprecise: false,
    latitude: 47.65709,
    longitude: -117.37854,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99202',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 1784,
    imprecise: false,
    latitude: 47.62945,
    longitude: -117.40291,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99203',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 2892.1,
    imprecise: false,
    latitude: 47.64726,
    longitude: -117.42665,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7643,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99204',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 1858.7,
    imprecise: false,
    latitude: 47.69657,
    longitude: -117.44609,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 43169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99205',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 679.3,
    imprecise: false,
    latitude: 47.62755,
    longitude: -117.25448,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 41089,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99206',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 2435.1,
    imprecise: false,
    latitude: 47.68941,
    longitude: -117.38911,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 32770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99207',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 464.8,
    imprecise: false,
    latitude: 47.78071,
    longitude: -117.46135,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 58669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99208',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 683.3,
    imprecise: false,
    latitude: 47.66504,
    longitude: -117.30914,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21707,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99212',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 775.2,
    imprecise: false,
    latitude: 47.68142,
    longitude: -117.20826,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 28578,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99216',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 161,
    imprecise: false,
    latitude: 47.7406,
    longitude: -117.26241,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 21441,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99217',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 960.7,
    imprecise: false,
    latitude: 47.75894,
    longitude: -117.4087,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 16897,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99218',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 434.6,
    imprecise: false,
    latitude: 47.58876,
    longitude: -117.334,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 36094,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99223',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 81,
    imprecise: false,
    latitude: 47.64729,
    longitude: -117.53552,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 24919,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99224',
  },
  {
    city: 'Pasco',
    county_fips: 53021,
    county_fips_all: '53021',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"53021": 100}',
    density: 69.1,
    imprecise: false,
    latitude: 46.39184,
    longitude: -118.93509,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 87044,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99301',
  },
  {
    city: 'Benton City',
    county_fips: 53005,
    county_fips_all: '53005',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"53005": 100}',
    density: 18.2,
    imprecise: false,
    latitude: 46.32706,
    longitude: -119.52483,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 9879,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99320',
  },
  {
    city: 'Beverly',
    county_fips: 53025,
    county_fips_all: '53025',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"53025": 100}',
    density: 11.5,
    imprecise: false,
    latitude: 46.86576,
    longitude: -119.88925,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1047,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99321',
  },
  {
    city: 'Bickleton',
    county_fips: 53039,
    county_fips_all: '53039',
    county: 'Klickitat',
    county_names_all: 'Klickitat',
    county_weights: '{"53039": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 45.93176,
    longitude: -120.14083,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99322',
  },
  {
    city: 'Burbank',
    county_fips: 53071,
    county_fips_all: '53071',
    county: 'Walla Walla',
    county_names_all: 'Walla Walla',
    county_weights: '{"53071": 100}',
    density: 11.9,
    imprecise: false,
    latitude: 46.18677,
    longitude: -118.85061,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99323',
  },
  {
    city: 'College Place',
    county_fips: 53071,
    county_fips_all: '53071',
    county: 'Walla Walla',
    county_names_all: 'Walla Walla',
    county_weights: '{"53071": 100}',
    density: 1412.5,
    imprecise: false,
    latitude: 46.04376,
    longitude: -118.38542,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99324',
  },
  {
    city: 'Connell',
    county_fips: 53021,
    county_fips_all: '53021|53001',
    county: 'Franklin',
    county_names_all: 'Franklin|Adams',
    county_weights: '{"53021": 87.98, "53001": 12.02}',
    density: 10.1,
    imprecise: false,
    latitude: 46.66705,
    longitude: -118.83769,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99326',
  },
  {
    city: 'Dayton',
    county_fips: 53013,
    county_fips_all: '53013',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"53013": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 46.26937,
    longitude: -117.87956,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3646,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99328',
  },
  {
    city: 'Dixie',
    county_fips: 53071,
    county_fips_all: '53071',
    county: 'Walla Walla',
    county_names_all: 'Walla Walla',
    county_weights: '{"53071": 100}',
    density: 96.2,
    imprecise: false,
    latitude: 46.13943,
    longitude: -118.14732,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 127,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99329',
  },
  {
    city: 'Eltopia',
    county_fips: 53021,
    county_fips_all: '53021',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"53021": 100}',
    density: 5.3,
    imprecise: false,
    latitude: 46.49447,
    longitude: -119.03021,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99330',
  },
  {
    city: 'Hooper',
    county_fips: 53075,
    county_fips_all: '53075|53001',
    county: 'Whitman',
    county_names_all: 'Whitman|Adams',
    county_weights: '{"53075": 88.93, "53001": 11.07}',
    density: 0.7,
    imprecise: false,
    latitude: 46.68112,
    longitude: -118.15262,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99333',
  },
  {
    city: 'Kahlotus',
    county_fips: 53021,
    county_fips_all: '53021',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"53021": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 46.65544,
    longitude: -118.47686,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99335',
  },
  {
    city: 'Kennewick',
    county_fips: 53005,
    county_fips_all: '53005',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"53005": 100}',
    density: 1462.3,
    imprecise: false,
    latitude: 46.21302,
    longitude: -119.17954,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 50735,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99336',
  },
  {
    city: 'Kennewick',
    county_fips: 53005,
    county_fips_all: '53005',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"53005": 100}',
    density: 77.5,
    imprecise: false,
    latitude: 46.06235,
    longitude: -119.09127,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 33287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99337',
  },
  {
    city: 'Kennewick',
    county_fips: 53005,
    county_fips_all: '53005',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"53005": 100}',
    density: 224.7,
    imprecise: false,
    latitude: 46.17362,
    longitude: -119.27403,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99338',
  },
  {
    city: 'Lind',
    county_fips: 53001,
    county_fips_all: '53001',
    county: 'Adams',
    county_names_all: 'Adams',
    county_weights: '{"53001": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 46.90663,
    longitude: -118.64224,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99341',
  },
  {
    city: 'Mesa',
    county_fips: 53021,
    county_fips_all: '53021',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"53021": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 46.59188,
    longitude: -119.17065,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99343',
  },
  {
    city: 'Othello',
    county_fips: 53001,
    county_fips_all: '53001|53025|53021',
    county: 'Adams',
    county_names_all: 'Adams|Grant|Franklin',
    county_weights: '{"53001": 64.63, "53025": 19.74, "53021": 15.63}',
    density: 15.5,
    imprecise: false,
    latitude: 46.82223,
    longitude: -119.17221,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19534,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99344',
  },
  {
    city: 'Paterson',
    county_fips: 53005,
    county_fips_all: '53005',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"53005": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 45.93623,
    longitude: -119.65919,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99345',
  },
  {
    city: 'Plymouth',
    county_fips: 53005,
    county_fips_all: '53005',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"53005": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 46.02685,
    longitude: -119.306,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 198,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99346',
  },
  {
    city: 'Pomeroy',
    county_fips: 53023,
    county_fips_all: '53023|53013|53075',
    county: 'Garfield',
    county_names_all: 'Garfield|Columbia|Whitman',
    county_weights: '{"53023": 88.12, "53013": 9.57, "53075": 2.31}',
    density: 1.3,
    imprecise: false,
    latitude: 46.42531,
    longitude: -117.57128,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99347',
  },
  {
    city: 'Prescott',
    county_fips: 53071,
    county_fips_all: '53071|53013',
    county: 'Walla Walla',
    county_names_all: 'Walla Walla|Columbia',
    county_weights: '{"53071": 95.91, "53013": 4.09}',
    density: 1.2,
    imprecise: false,
    latitude: 46.38681,
    longitude: -118.44731,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99348',
  },
  {
    city: 'Mattawa',
    county_fips: 53025,
    county_fips_all: '53025',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"53025": 100}',
    density: 11.8,
    imprecise: false,
    latitude: 46.73078,
    longitude: -119.6996,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 8143,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99349',
  },
  {
    city: 'Prosser',
    county_fips: 53005,
    county_fips_all: '53005|53039|53077',
    county: 'Benton',
    county_names_all: 'Benton|Klickitat|Yakima',
    county_weights: '{"53005": 86.55, "53039": 12.61, "53077": 0.84}',
    density: 9.5,
    imprecise: false,
    latitude: 46.14477,
    longitude: -119.70944,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 14837,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99350',
  },
  {
    city: 'Richland',
    county_fips: 53005,
    county_fips_all: '53005',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"53005": 100}',
    density: 602.3,
    imprecise: false,
    latitude: 46.24199,
    longitude: -119.29067,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 37430,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99352',
  },
  {
    city: 'West Richland',
    county_fips: 53005,
    county_fips_all: '53005',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"53005": 100}',
    density: 288,
    imprecise: false,
    latitude: 46.31747,
    longitude: -119.37942,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19251,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99353',
  },
  {
    city: 'Richland',
    county_fips: 53005,
    county_fips_all: '53005',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"53005": 100}',
    density: 412.3,
    imprecise: false,
    latitude: 46.33153,
    longitude: -119.30106,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 25559,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99354',
  },
  {
    city: 'Roosevelt',
    county_fips: 53039,
    county_fips_all: '53039',
    county: 'Klickitat',
    county_names_all: 'Klickitat',
    county_weights: '{"53039": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 45.83459,
    longitude: -120.36258,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99356',
  },
  {
    city: 'Royal City',
    county_fips: 53025,
    county_fips_all: '53025',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"53025": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 46.89295,
    longitude: -119.67902,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99357',
  },
  {
    city: 'Starbuck',
    county_fips: 53013,
    county_fips_all: '53013',
    county: 'Columbia',
    county_names_all: 'Columbia',
    county_weights: '{"53013": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 46.53325,
    longitude: -118.15697,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99359',
  },
  {
    city: 'Touchet',
    county_fips: 53071,
    county_fips_all: '53071',
    county: 'Walla Walla',
    county_names_all: 'Walla Walla',
    county_weights: '{"53071": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 46.09044,
    longitude: -118.66745,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99360',
  },
  {
    city: 'Waitsburg',
    county_fips: 53071,
    county_fips_all: '53071|53013',
    county: 'Walla Walla',
    county_names_all: 'Walla Walla|Columbia',
    county_weights: '{"53071": 67.65, "53013": 32.35}',
    density: 3.4,
    imprecise: false,
    latitude: 46.23691,
    longitude: -118.14333,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1992,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99361',
  },
  {
    city: 'Walla Walla',
    county_fips: 53071,
    county_fips_all: '53071|41059',
    county: 'Walla Walla',
    county_names_all: 'Walla Walla|Umatilla',
    county_weights: '{"53071": 91.58, "41059": 8.42}',
    density: 54.6,
    imprecise: false,
    latitude: 46.08727,
    longitude: -118.31269,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 42853,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99362',
  },
  {
    city: 'Wallula',
    county_fips: 53071,
    county_fips_all: '53071',
    county: 'Walla Walla',
    county_names_all: 'Walla Walla',
    county_weights: '{"53071": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 46.04821,
    longitude: -118.89575,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99363',
  },
  {
    city: 'Washtucna',
    county_fips: 53001,
    county_fips_all: '53001|53021',
    county: 'Adams',
    county_names_all: 'Adams|Franklin',
    county_weights: '{"53001": 78.86, "53021": 21.14}',
    density: 0.7,
    imprecise: false,
    latitude: 46.79144,
    longitude: -118.30614,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 394,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99371',
  },
  {
    city: 'Anatone',
    county_fips: 53003,
    county_fips_all: '53003',
    county: 'Asotin',
    county_names_all: 'Asotin',
    county_weights: '{"53003": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 46.09041,
    longitude: -117.27336,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99401',
  },
  {
    city: 'Asotin',
    county_fips: 53003,
    county_fips_all: '53003',
    county: 'Asotin',
    county_names_all: 'Asotin',
    county_weights: '{"53003": 100}',
    density: 1.8,
    imprecise: false,
    latitude: 46.1868,
    longitude: -117.14922,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1557,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99402',
  },
  {
    city: 'Clarkston',
    county_fips: 53003,
    county_fips_all: '53003|53023',
    county: 'Asotin',
    county_names_all: 'Asotin|Garfield',
    county_weights: '{"53003": 80.06, "53023": 19.94}',
    density: 55.9,
    imprecise: false,
    latitude: 46.38114,
    longitude: -117.25974,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 20760,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99403',
  },
  {
    city: 'Anchorage',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 938.9,
    imprecise: false,
    latitude: 61.22005,
    longitude: -149.85872,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 16175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99501',
  },
  {
    city: 'Anchorage',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 549.8,
    imprecise: false,
    latitude: 61.16323,
    longitude: -149.98644,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 25006,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99502',
  },
  {
    city: 'Anchorage',
    county_fips: 2050,
    county_fips_all: '02050|02020',
    county: 'Bethel',
    county_names_all: 'Bethel|Anchorage',
    county_weights: '{"02050": 84.02, "02020": 15.98}',
    density: 242.1,
    imprecise: false,
    latitude: 61.90744,
    longitude: -156.85203,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 12964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99503',
  },
  {
    city: 'Anchorage',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 441.4,
    imprecise: false,
    latitude: 61.19195,
    longitude: -149.64255,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 42093,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99504',
  },
  {
    city: 'Jber',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 46.4,
    imprecise: false,
    latitude: 61.27512,
    longitude: -149.65197,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 5015,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99505',
  },
  {
    city: 'Jber',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 132.5,
    imprecise: false,
    latitude: 61.26505,
    longitude: -149.80067,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 7028,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99506',
  },
  {
    city: 'Anchorage',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 304.6,
    imprecise: false,
    latitude: 61.13336,
    longitude: -149.69001,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 37301,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99507',
  },
  {
    city: 'Anchorage',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 1970.2,
    imprecise: false,
    latitude: 61.20145,
    longitude: -149.8146,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 36458,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99508',
  },
  {
    city: 'Anchorage',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 798.6,
    imprecise: false,
    latitude: 61.11733,
    longitude: -149.88894,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 21870,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99515',
  },
  {
    city: 'Anchorage',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 189.1,
    imprecise: false,
    latitude: 61.0726,
    longitude: -149.71812,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 21500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99516',
  },
  {
    city: 'Anchorage',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 1964.8,
    imprecise: false,
    latitude: 61.19018,
    longitude: -149.93676,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 16486,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99517',
  },
  {
    city: 'Anchorage',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 995.2,
    imprecise: false,
    latitude: 61.15949,
    longitude: -149.88479,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 9764,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99518',
  },
  {
    city: 'Anchorage',
    county_fips: 2185,
    county_fips_all: '02185',
    county: 'North Slope',
    county_names_all: 'North Slope',
    county_weights: '{"02185": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 70.1006,
    longitude: -150.00014,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 1297,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99519',
  },
  {
    city: 'Indian',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 61.01464,
    longitude: -149.36859,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99540',
  },
  {
    city: 'Adak',
    county_fips: 2016,
    county_fips_all: '02016',
    county: 'Aleutians West',
    county_names_all: 'Aleutians West',
    county_weights: '{"02016": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 51.88145,
    longitude: -176.62962,
    militaryZip: false,
    timezone: 'America/Adak',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99546',
  },
  {
    city: 'Atka',
    county_fips: 2016,
    county_fips_all: '02016',
    county: 'Aleutians West',
    county_names_all: 'Aleutians West',
    county_weights: '{"02016": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 52.22888,
    longitude: -174.20613,
    militaryZip: false,
    timezone: 'America/Adak',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99547',
  },
  {
    city: 'Chignik Lake',
    county_fips: 2164,
    county_fips_all: '02164',
    county: 'Lake and Peninsula',
    county_names_all: 'Lake and Peninsula',
    county_weights: '{"02164": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 56.25468,
    longitude: -158.76004,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99548',
  },
  {
    city: 'Port Heiden',
    county_fips: 2164,
    county_fips_all: '02164',
    county: 'Lake and Peninsula',
    county_names_all: 'Lake and Peninsula',
    county_weights: '{"02164": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 56.94253,
    longitude: -158.60474,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99549',
  },
  {
    city: 'Port Lions',
    county_fips: 2150,
    county_fips_all: '02150',
    county: 'Kodiak Island',
    county_names_all: 'Kodiak Island',
    county_weights: '{"02150": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 57.8758,
    longitude: -152.8737,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99550',
  },
  {
    city: 'Akiachak',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 40.5,
    imprecise: false,
    latitude: 60.92101,
    longitude: -161.40212,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 736,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99551',
  },
  {
    city: 'Akiak',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 77.1,
    imprecise: false,
    latitude: 60.90614,
    longitude: -161.21223,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99552',
  },
  {
    city: 'Akutan',
    county_fips: 2013,
    county_fips_all: '02013',
    county: 'Aleutians East',
    county_names_all: 'Aleutians East',
    county_weights: '{"02013": 100}',
    density: 6.9,
    imprecise: false,
    latitude: 54.1475,
    longitude: -165.83687,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 694,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99553',
  },
  {
    city: 'Alakanuk',
    county_fips: 2158,
    county_fips_all: '02158',
    county: 'Kusilvak',
    county_names_all: 'Kusilvak',
    county_weights: '{"02158": 100}',
    density: 10.4,
    imprecise: false,
    latitude: 62.69018,
    longitude: -164.63054,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 864,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99554',
  },
  {
    city: 'Aleknagik',
    county_fips: 2070,
    county_fips_all: '02070',
    county: 'Dillingham',
    county_names_all: 'Dillingham',
    county_weights: '{"02070": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 59.28859,
    longitude: -158.67996,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 92,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99555',
  },
  {
    city: 'Anchor Point',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 5.6,
    imprecise: false,
    latitude: 59.82955,
    longitude: -151.64298,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 2866,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99556',
  },
  {
    city: 'Aniak',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 0,
    imprecise: false,
    latitude: 61.44142,
    longitude: -155.90217,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 714,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99557',
  },
  {
    city: 'Anvik',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 3.2,
    imprecise: false,
    latitude: 62.65411,
    longitude: -160.21396,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 79,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99558',
  },
  {
    city: 'Bethel',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 49.5,
    imprecise: false,
    latitude: 60.76487,
    longitude: -161.90671,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 7241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99559',
  },
  {
    city: 'Chefornak',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 45.7,
    imprecise: false,
    latitude: 60.15504,
    longitude: -164.25495,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99561',
  },
  {
    city: 'Chevak',
    county_fips: 2158,
    county_fips_all: '02158',
    county: 'Kusilvak',
    county_names_all: 'Kusilvak',
    county_weights: '{"02158": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 61.55009,
    longitude: -165.35813,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 494,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99563',
  },
  {
    city: 'Chignik',
    county_fips: 2164,
    county_fips_all: '02164',
    county: 'Lake and Peninsula',
    county_names_all: 'Lake and Peninsula',
    county_weights: '{"02164": 100}',
    density: 1,
    imprecise: false,
    latitude: 56.30032,
    longitude: -158.41315,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99564',
  },
  {
    city: 'Chignik Lagoon',
    county_fips: 2164,
    county_fips_all: '02164',
    county: 'Lake and Peninsula',
    county_names_all: 'Lake and Peninsula',
    county_weights: '{"02164": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 56.30415,
    longitude: -158.50039,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99565',
  },
  {
    city: 'Chitina',
    county_fips: 2066,
    county_fips_all: '02066|02063',
    county: 'Copper River',
    county_names_all: 'Copper River|Chugach',
    county_weights: '{"02066": 99.45, "02063": 0.55}',
    density: 0,
    imprecise: false,
    latitude: 61.28176,
    longitude: -142.79338,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 130,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99566',
  },
  {
    city: 'Chugiak',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 3.7,
    imprecise: false,
    latitude: 61.26625,
    longitude: -148.86933,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 6452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99567',
  },
  {
    city: 'Clam Gulch',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 60.24952,
    longitude: -150.38501,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 465,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99568',
  },
  {
    city: 'Clarks Point',
    county_fips: 2070,
    county_fips_all: '02070',
    county: 'Dillingham',
    county_names_all: 'Dillingham',
    county_weights: '{"02070": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 58.81714,
    longitude: -158.52914,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99569',
  },
  {
    city: 'Cold Bay',
    county_fips: 2013,
    county_fips_all: '02013',
    county: 'Aleutians East',
    county_names_all: 'Aleutians East',
    county_weights: '{"02013": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 55.29661,
    longitude: -162.58634,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 223,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99571',
  },
  {
    city: 'Cooper Landing',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 60.49348,
    longitude: -150.0567,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99572',
  },
  {
    city: 'Copper Center',
    county_fips: 2066,
    county_fips_all: '02066',
    county: 'Copper River',
    county_names_all: 'Copper River',
    county_weights: '{"02066": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 61.60036,
    longitude: -145.92446,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 941,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99573',
  },
  {
    city: 'Cordova',
    county_fips: 2063,
    county_fips_all: '02063',
    county: 'Chugach',
    county_names_all: 'Chugach',
    county_weights: '{"02063": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 60.73927,
    longitude: -146.4061,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 2551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99574',
  },
  {
    city: 'Crooked Creek',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 61.84391,
    longitude: -158.10825,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99575',
  },
  {
    city: 'Dillingham',
    county_fips: 2070,
    county_fips_all: '02070',
    county: 'Dillingham',
    county_names_all: 'Dillingham',
    county_weights: '{"02070": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 59.77339,
    longitude: -158.69309,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 2454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99576',
  },
  {
    city: 'Eagle River',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 38.3,
    imprecise: false,
    latitude: 61.1824,
    longitude: -149.29229,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 28477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99577',
  },
  {
    city: 'Eek',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 103.7,
    imprecise: false,
    latitude: 60.21644,
    longitude: -162.03311,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 174,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99578',
  },
  {
    city: 'Egegik',
    county_fips: 2164,
    county_fips_all: '02164',
    county: 'Lake and Peninsula',
    county_names_all: 'Lake and Peninsula',
    county_weights: '{"02164": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 58.21813,
    longitude: -157.40364,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99579',
  },
  {
    city: 'Ekwok',
    county_fips: 2070,
    county_fips_all: '02070',
    county: 'Dillingham',
    county_names_all: 'Dillingham',
    county_weights: '{"02070": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 59.34619,
    longitude: -157.48607,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99580',
  },
  {
    city: 'Emmonak',
    county_fips: 2158,
    county_fips_all: '02158',
    county: 'Kusilvak',
    county_names_all: 'Kusilvak',
    county_weights: '{"02158": 100}',
    density: 6.4,
    imprecise: false,
    latitude: 62.82476,
    longitude: -164.68692,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 966,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99581',
  },
  {
    city: 'False Pass',
    county_fips: 2013,
    county_fips_all: '02013',
    county: 'Aleutians East',
    county_names_all: 'Aleutians East',
    county_weights: '{"02013": 100}',
    density: 4.7,
    imprecise: false,
    latitude: 54.84305,
    longitude: -163.39945,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99583',
  },
  {
    city: 'Marshall',
    county_fips: 2158,
    county_fips_all: '02158',
    county: 'Kusilvak',
    county_names_all: 'Kusilvak',
    county_weights: '{"02158": 100}',
    density: 36.7,
    imprecise: false,
    latitude: 61.87532,
    longitude: -162.04873,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 386,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99585',
  },
  {
    city: 'Gakona',
    county_fips: 2066,
    county_fips_all: '02066',
    county: 'Copper River',
    county_names_all: 'Copper River',
    county_weights: '{"02066": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 62.67463,
    longitude: -144.13884,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99586',
  },
  {
    city: 'Girdwood',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 60.9103,
    longitude: -148.84466,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 1949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99587',
  },
  {
    city: 'Glennallen',
    county_fips: 2066,
    county_fips_all: '02066|02170',
    county: 'Copper River',
    county_names_all: 'Copper River|Matanuska-Susitna',
    county_weights: '{"02066": 55.56, "02170": 44.44}',
    density: 0.1,
    imprecise: false,
    latitude: 62.42192,
    longitude: -146.4813,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 1037,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99588',
  },
  {
    city: 'Goodnews Bay',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 59.21186,
    longitude: -161.70123,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 115,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99589',
  },
  {
    city: 'Grayling',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 62.89978,
    longitude: -160.10782,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 173,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99590',
  },
  {
    city: 'Saint George Island',
    county_fips: 2016,
    county_fips_all: '02016',
    county: 'Aleutians West',
    county_names_all: 'Aleutians West',
    county_weights: '{"02016": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 56.58075,
    longitude: -169.61599,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 70,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99591',
  },
  {
    city: 'Holy Cross',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 62.1868,
    longitude: -159.8198,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99602',
  },
  {
    city: 'Homer',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 59.52364,
    longitude: -151.22855,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 11693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99603',
  },
  {
    city: 'Hooper Bay',
    county_fips: 2158,
    county_fips_all: '02158',
    county: 'Kusilvak',
    county_names_all: 'Kusilvak',
    county_weights: '{"02158": 100}',
    density: 46.5,
    imprecise: false,
    latitude: 61.52613,
    longitude: -166.11458,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 903,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99604',
  },
  {
    city: 'Hope',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 0,
    imprecise: false,
    latitude: 60.83286,
    longitude: -149.44797,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 23,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99605',
  },
  {
    city: 'Iliamna',
    county_fips: 2164,
    county_fips_all: '02164',
    county: 'Lake and Peninsula',
    county_names_all: 'Lake and Peninsula',
    county_weights: '{"02164": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 59.66803,
    longitude: -154.83362,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 231,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99606',
  },
  {
    city: 'Kalskag',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 26,
    imprecise: false,
    latitude: 61.5416,
    longitude: -160.3337,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99607',
  },
  {
    city: 'Karluk',
    county_fips: 2150,
    county_fips_all: '02150',
    county: 'Kodiak Island',
    county_names_all: 'Kodiak Island',
    county_weights: '{"02150": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 57.58454,
    longitude: -154.32545,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99608',
  },
  {
    city: 'Kasigluk',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 22.8,
    imprecise: false,
    latitude: 60.87848,
    longitude: -162.52725,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99609',
  },
  {
    city: 'Kasilof',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 9.9,
    imprecise: false,
    latitude: 60.29172,
    longitude: -151.27167,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 2222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99610',
  },
  {
    city: 'Kenai',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 60.74777,
    longitude: -150.89,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 16510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99611',
  },
  {
    city: 'King Cove',
    county_fips: 2013,
    county_fips_all: '02013',
    county: 'Aleutians East',
    county_names_all: 'Aleutians East',
    county_weights: '{"02013": 100}',
    density: 21.2,
    imprecise: false,
    latitude: 55.08587,
    longitude: -162.2978,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 1352,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99612',
  },
  {
    city: 'King Salmon',
    county_fips: 2164,
    county_fips_all: '02164|02060',
    county: 'Lake and Peninsula',
    county_names_all: 'Lake and Peninsula|Bristol Bay',
    county_weights: '{"02164": 81.64, "02060": 18.36}',
    density: 0.1,
    imprecise: false,
    latitude: 59.13496,
    longitude: -155.42696,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 376,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99613',
  },
  {
    city: 'Kipnuk',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 59.9373,
    longitude: -164.06158,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 706,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99614',
  },
  {
    city: 'Kodiak',
    county_fips: 2150,
    county_fips_all: '02150',
    county: 'Kodiak Island',
    county_names_all: 'Kodiak Island',
    county_weights: '{"02150": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 57.57705,
    longitude: -153.39119,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 12194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99615',
  },
  {
    city: 'Kotlik',
    county_fips: 2158,
    county_fips_all: '02158',
    county: 'Kusilvak',
    county_names_all: 'Kusilvak',
    county_weights: '{"02158": 100}',
    density: 125.9,
    imprecise: false,
    latitude: 63.03047,
    longitude: -163.553,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 976,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99620',
  },
  {
    city: 'Kwethluk',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 37,
    imprecise: false,
    latitude: 60.79781,
    longitude: -161.41469,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99621',
  },
  {
    city: 'Kwigillingok',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 59.87667,
    longitude: -163.17154,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 545,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99622',
  },
  {
    city: 'Wasilla',
    county_fips: 2170,
    county_fips_all: '02170',
    county: 'Matanuska-Susitna',
    county_names_all: 'Matanuska-Susitna',
    county_weights: '{"02170": 100}',
    density: 35,
    imprecise: false,
    latitude: 61.42919,
    longitude: -149.91226,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 23424,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99623',
  },
  {
    city: 'Larsen Bay',
    county_fips: 2150,
    county_fips_all: '02150',
    county: 'Kodiak Island',
    county_names_all: 'Kodiak Island',
    county_weights: '{"02150": 100}',
    density: 3.1,
    imprecise: false,
    latitude: 57.44866,
    longitude: -153.85811,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 145,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99624',
  },
  {
    city: 'Levelock',
    county_fips: 2164,
    county_fips_all: '02164',
    county: 'Lake and Peninsula',
    county_names_all: 'Lake and Peninsula',
    county_weights: '{"02164": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 59.0683,
    longitude: -156.90093,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 8,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99625',
  },
  {
    city: 'Lower Kalskag',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 74.2,
    imprecise: false,
    latitude: 61.51633,
    longitude: -160.35564,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 239,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99626',
  },
  {
    city: 'McGrath',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0,
    imprecise: false,
    latitude: 63.18657,
    longitude: -154.75609,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99627',
  },
  {
    city: 'Mekoryuk',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 15.7,
    imprecise: false,
    latitude: 60.37041,
    longitude: -166.2672,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99630',
  },
  {
    city: 'Moose Pass',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 60.60673,
    longitude: -149.58071,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99631',
  },
  {
    city: 'Mountain Village',
    county_fips: 2158,
    county_fips_all: '02158',
    county: 'Kusilvak',
    county_names_all: 'Kusilvak',
    county_weights: '{"02158": 100}',
    density: 14.6,
    imprecise: false,
    latitude: 62.11232,
    longitude: -163.66455,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 949,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99632',
  },
  {
    city: 'Naknek',
    county_fips: 2060,
    county_fips_all: '02060',
    county: 'Bristol Bay',
    county_names_all: 'Bristol Bay',
    county_weights: '{"02060": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 58.78297,
    longitude: -156.8984,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 522,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99633',
  },
  {
    city: 'Napakiak',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 54,
    imprecise: false,
    latitude: 60.68682,
    longitude: -162.00737,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99634',
  },
  {
    city: 'Nikiski',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 0,
    imprecise: false,
    latitude: 60.8062,
    longitude: -152.67734,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 100,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99635',
  },
  {
    city: 'New Stuyahok',
    county_fips: 2070,
    county_fips_all: '02070',
    county: 'Dillingham',
    county_names_all: 'Dillingham',
    county_weights: '{"02070": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 59.47618,
    longitude: -157.27099,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 474,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99636',
  },
  {
    city: 'Toksook Bay',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 11.2,
    imprecise: false,
    latitude: 60.5333,
    longitude: -165.1557,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99637',
  },
  {
    city: 'Ninilchik',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 59.99602,
    longitude: -151.36177,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 1175,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99639',
  },
  {
    city: 'Nondalton',
    county_fips: 2164,
    county_fips_all: '02164',
    county: 'Lake and Peninsula',
    county_names_all: 'Lake and Peninsula',
    county_weights: '{"02164": 100}',
    density: 0,
    imprecise: false,
    latitude: 60.29813,
    longitude: -155.40518,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99640',
  },
  {
    city: 'Nunapitchuk',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 34.1,
    imprecise: false,
    latitude: 60.87722,
    longitude: -162.46152,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 618,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99641',
  },
  {
    city: 'Old Harbor',
    county_fips: 2150,
    county_fips_all: '02150',
    county: 'Kodiak Island',
    county_names_all: 'Kodiak Island',
    county_weights: '{"02150": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 57.21669,
    longitude: -153.32658,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 162,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99643',
  },
  {
    city: 'Ouzinkie',
    county_fips: 2150,
    county_fips_all: '02150',
    county: 'Kodiak Island',
    county_names_all: 'Kodiak Island',
    county_weights: '{"02150": 100}',
    density: 2,
    imprecise: false,
    latitude: 57.92512,
    longitude: -152.4231,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 87,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99644',
  },
  {
    city: 'Palmer',
    county_fips: 2170,
    county_fips_all: '02170',
    county: 'Matanuska-Susitna',
    county_names_all: 'Matanuska-Susitna',
    county_weights: '{"02170": 100}',
    density: 21.1,
    imprecise: false,
    latitude: 61.60763,
    longitude: -148.90394,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 32103,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99645',
  },
  {
    city: 'Pedro Bay',
    county_fips: 2164,
    county_fips_all: '02164',
    county: 'Lake and Peninsula',
    county_names_all: 'Lake and Peninsula',
    county_weights: '{"02164": 100}',
    density: 0,
    imprecise: false,
    latitude: 59.86411,
    longitude: -154.01511,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99647',
  },
  {
    city: 'Perryville',
    county_fips: 2164,
    county_fips_all: '02164',
    county: 'Lake and Peninsula',
    county_names_all: 'Lake and Peninsula',
    county_weights: '{"02164": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 55.93137,
    longitude: -159.15598,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 82,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99648',
  },
  {
    city: 'Pilot Point',
    county_fips: 2164,
    county_fips_all: '02164',
    county: 'Lake and Peninsula',
    county_names_all: 'Lake and Peninsula',
    county_weights: '{"02164": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 57.51501,
    longitude: -157.31076,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 52,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99649',
  },
  {
    city: 'Pilot Station',
    county_fips: 2158,
    county_fips_all: '02158',
    county: 'Kusilvak',
    county_names_all: 'Kusilvak',
    county_weights: '{"02158": 100}',
    density: 171.4,
    imprecise: false,
    latitude: 61.94255,
    longitude: -162.88467,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 713,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99650',
  },
  {
    city: 'Big Lake',
    county_fips: 2170,
    county_fips_all: '02170',
    county: 'Matanuska-Susitna',
    county_names_all: 'Matanuska-Susitna',
    county_weights: '{"02170": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 61.52621,
    longitude: -149.9616,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 4313,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99652',
  },
  {
    city: 'Port Alsworth',
    county_fips: 2164,
    county_fips_all: '02164',
    county: 'Lake and Peninsula',
    county_names_all: 'Lake and Peninsula',
    county_weights: '{"02164": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 60.16884,
    longitude: -154.32328,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 199,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99653',
  },
  {
    city: 'Wasilla',
    county_fips: 2170,
    county_fips_all: '02170',
    county: 'Matanuska-Susitna',
    county_names_all: 'Matanuska-Susitna',
    county_weights: '{"02170": 100}',
    density: 151.7,
    imprecise: false,
    latitude: 61.607,
    longitude: -149.41443,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 44647,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99654',
  },
  {
    city: 'Red Devil',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 0,
    imprecise: false,
    latitude: 61.86309,
    longitude: -157.41759,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 3,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99656',
  },
  {
    city: 'Russian Mission',
    county_fips: 2158,
    county_fips_all: '02158',
    county: 'Kusilvak',
    county_names_all: 'Kusilvak',
    county_weights: '{"02158": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 61.78916,
    longitude: -161.42698,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99657',
  },
  {
    city: 'Saint Marys',
    county_fips: 2158,
    county_fips_all: '02158',
    county: 'Kusilvak',
    county_names_all: 'Kusilvak',
    county_weights: '{"02158": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 62.0761,
    longitude: -163.28111,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 979,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99658',
  },
  {
    city: 'Saint Michael',
    county_fips: 2180,
    county_fips_all: '02180',
    county: 'Nome',
    county_names_all: 'Nome',
    county_weights: '{"02180": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 63.4738,
    longitude: -162.12295,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 177,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99659',
  },
  {
    city: 'Saint Paul Island',
    county_fips: 2016,
    county_fips_all: '02016',
    county: 'Aleutians West',
    county_names_all: 'Aleutians West',
    county_weights: '{"02016": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 57.17993,
    longitude: -170.27914,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 378,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99660',
  },
  {
    city: 'Sand Point',
    county_fips: 2013,
    county_fips_all: '02013',
    county: 'Aleutians East',
    county_names_all: 'Aleutians East',
    county_weights: '{"02013": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 55.27131,
    longitude: -160.67431,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 1071,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99661',
  },
  {
    city: 'Scammon Bay',
    county_fips: 2158,
    county_fips_all: '02158',
    county: 'Kusilvak',
    county_names_all: 'Kusilvak',
    county_weights: '{"02158": 100}',
    density: 362.9,
    imprecise: false,
    latitude: 61.84197,
    longitude: -165.58329,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99662',
  },
  {
    city: 'Seldovia',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 59.39488,
    longitude: -151.62729,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 417,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99663',
  },
  {
    city: 'Seward',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 60.13714,
    longitude: -149.47123,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 4698,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99664',
  },
  {
    city: 'Nunam Iqua',
    county_fips: 2158,
    county_fips_all: '02158',
    county: 'Kusilvak',
    county_names_all: 'Kusilvak',
    county_weights: '{"02158": 100}',
    density: 0,
    imprecise: false,
    latitude: 62.45498,
    longitude: -165.09492,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99666',
  },
  {
    city: 'Skwentna',
    county_fips: 2170,
    county_fips_all: '02170',
    county: 'Matanuska-Susitna',
    county_names_all: 'Matanuska-Susitna',
    county_weights: '{"02170": 100}',
    density: 0,
    imprecise: false,
    latitude: 61.85447,
    longitude: -151.82056,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99667',
  },
  {
    city: 'Sleetmute',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 61.65158,
    longitude: -157.12508,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 48,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99668',
  },
  {
    city: 'Soldotna',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 24.3,
    imprecise: false,
    latitude: 60.41497,
    longitude: -151.00207,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 15395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99669',
  },
  {
    city: 'South Naknek',
    county_fips: 2060,
    county_fips_all: '02060',
    county: 'Bristol Bay',
    county_names_all: 'Bristol Bay',
    county_weights: '{"02060": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 58.66541,
    longitude: -156.98831,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99670',
  },
  {
    city: 'Stebbins',
    county_fips: 2180,
    county_fips_all: '02180',
    county: 'Nome',
    county_names_all: 'Nome',
    county_weights: '{"02180": 100}',
    density: 7.1,
    imprecise: false,
    latitude: 63.47048,
    longitude: -162.25993,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99671',
  },
  {
    city: 'Sterling',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 25,
    imprecise: false,
    latitude: 60.55026,
    longitude: -150.77907,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 4091,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99672',
  },
  {
    city: 'Sutton',
    county_fips: 2170,
    county_fips_all: '02170',
    county: 'Matanuska-Susitna',
    county_names_all: 'Matanuska-Susitna',
    county_weights: '{"02170": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 61.69166,
    longitude: -147.81997,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 1774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99674',
  },
  {
    city: 'Takotna',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 62.98268,
    longitude: -156.08383,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99675',
  },
  {
    city: 'Talkeetna',
    county_fips: 2170,
    county_fips_all: '02170',
    county: 'Matanuska-Susitna',
    county_names_all: 'Matanuska-Susitna',
    county_weights: '{"02170": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 62.49792,
    longitude: -149.65848,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 1628,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99676',
  },
  {
    city: 'Tatitlek',
    county_fips: 2063,
    county_fips_all: '02063',
    county: 'Chugach',
    county_names_all: 'Chugach',
    county_weights: '{"02063": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 60.89217,
    longitude: -146.67249,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99677',
  },
  {
    city: 'Togiak',
    county_fips: 2070,
    county_fips_all: '02070',
    county: 'Dillingham',
    county_names_all: 'Dillingham',
    county_weights: '{"02070": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 59.20738,
    longitude: -160.52622,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 963,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99678',
  },
  {
    city: 'Tuluksak',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 16,
    imprecise: false,
    latitude: 61.10509,
    longitude: -160.94865,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99679',
  },
  {
    city: 'Tuntutuliak',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 103.1,
    imprecise: false,
    latitude: 60.34447,
    longitude: -162.66367,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 514,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99680',
  },
  {
    city: 'Tyonek',
    county_fips: 2122,
    county_fips_all: '02122',
    county: 'Kenai Peninsula',
    county_names_all: 'Kenai Peninsula',
    county_weights: '{"02122": 100}',
    density: 1,
    imprecise: false,
    latitude: 61.17145,
    longitude: -151.16797,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 295,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99682',
  },
  {
    city: 'Trapper Creek',
    county_fips: 2170,
    county_fips_all: '02170',
    county: 'Matanuska-Susitna',
    county_names_all: 'Matanuska-Susitna',
    county_weights: '{"02170": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 62.45165,
    longitude: -150.425,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99683',
  },
  {
    city: 'Unalakleet',
    county_fips: 2180,
    county_fips_all: '02180',
    county: 'Nome',
    county_names_all: 'Nome',
    county_weights: '{"02180": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 64.09938,
    longitude: -160.32776,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 565,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99684',
  },
  {
    city: 'Unalaska',
    county_fips: 2016,
    county_fips_all: '02016',
    county: 'Aleutians West',
    county_names_all: 'Aleutians West',
    county_weights: '{"02016": 100}',
    density: 25.7,
    imprecise: false,
    latitude: 53.87869,
    longitude: -166.47125,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 3747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99685',
  },
  {
    city: 'Valdez',
    county_fips: 2063,
    county_fips_all: '02063|02066',
    county: 'Chugach',
    county_names_all: 'Chugach|Copper River',
    county_weights: '{"02063": 99.86, "02066": 0.14}',
    density: 1.1,
    imprecise: false,
    latitude: 61.04886,
    longitude: -146.19038,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 3862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99686',
  },
  {
    city: 'Willow',
    county_fips: 2170,
    county_fips_all: '02170',
    county: 'Matanuska-Susitna',
    county_names_all: 'Matanuska-Susitna',
    county_weights: '{"02170": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 61.89412,
    longitude: -150.04749,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 2739,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99688',
  },
  {
    city: 'Yakutat',
    county_fips: 2282,
    county_fips_all: '02282',
    county: 'Yakutat',
    county_names_all: 'Yakutat',
    county_weights: '{"02282": 100}',
    density: 1,
    imprecise: false,
    latitude: 59.51819,
    longitude: -139.4869,
    militaryZip: false,
    timezone: 'America/Yakutat',
    population: 527,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99689',
  },
  {
    city: 'Nightmute',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 60.48738,
    longitude: -164.81953,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99690',
  },
  {
    city: 'Nikolai',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0,
    imprecise: false,
    latitude: 62.74385,
    longitude: -153.84293,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99691',
  },
  {
    city: 'Dutch Harbor',
    county_fips: 2016,
    county_fips_all: '02016',
    county: 'Aleutians West',
    county_names_all: 'Aleutians West',
    county_weights: '{"02016": 100}',
    density: 940.9,
    imprecise: false,
    latitude: 53.88393,
    longitude: -166.54498,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99692',
  },
  {
    city: 'Whittier',
    county_fips: 2063,
    county_fips_all: '02063',
    county: 'Chugach',
    county_names_all: 'Chugach',
    county_weights: '{"02063": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 60.83738,
    longitude: -148.15024,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 429,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99693',
  },
  {
    city: 'Houston',
    county_fips: 2170,
    county_fips_all: '02170',
    county: 'Matanuska-Susitna',
    county_names_all: 'Matanuska-Susitna',
    county_weights: '{"02170": 100}',
    density: 21.8,
    imprecise: false,
    latitude: 61.61854,
    longitude: -149.8255,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 1516,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99694',
  },
  {
    city: 'Fairbanks',
    county_fips: 2290,
    county_fips_all: '02290|02090',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk|Fairbanks North Star',
    county_weights: '{"02290": 96.96, "02090": 3.04}',
    density: 12.8,
    imprecise: false,
    latitude: 67.25435,
    longitude: -149.87754,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 18061,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99701',
  },
  {
    city: 'Eielson Afb',
    county_fips: 2090,
    county_fips_all: '02090',
    county: 'Fairbanks North Star',
    county_names_all: 'Fairbanks North Star',
    county_weights: '{"02090": 100}',
    density: 59.7,
    imprecise: false,
    latitude: 64.64835,
    longitude: -147.03879,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 3260,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99702',
  },
  {
    city: 'Fort Wainwright',
    county_fips: 2090,
    county_fips_all: '02090',
    county: 'Fairbanks North Star',
    county_names_all: 'Fairbanks North Star',
    county_weights: '{"02090": 100}',
    density: 331.3,
    imprecise: false,
    latitude: 64.83542,
    longitude: -147.62612,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 8304,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99703',
  },
  {
    city: 'Clear',
    county_fips: 2068,
    county_fips_all: '02068',
    county: 'Denali',
    county_names_all: 'Denali',
    county_weights: '{"02068": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 64.29023,
    longitude: -149.20423,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99704',
  },
  {
    city: 'North Pole',
    county_fips: 2090,
    county_fips_all: '02090',
    county: 'Fairbanks North Star',
    county_names_all: 'Fairbanks North Star',
    county_weights: '{"02090": 100}',
    density: 58.8,
    imprecise: false,
    latitude: 64.77356,
    longitude: -147.27055,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 21769,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99705',
  },
  {
    city: 'Fairbanks',
    county_fips: 2240,
    county_fips_all: '02240',
    county: 'Southeast Fairbanks',
    county_names_all: 'Southeast Fairbanks',
    county_weights: '{"02240": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 64.0281,
    longitude: -144.6331,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 24,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99706',
  },
  {
    city: 'Fairbanks',
    county_fips: 2090,
    county_fips_all: '02090',
    county: 'Fairbanks North Star',
    county_names_all: 'Fairbanks North Star',
    county_weights: '{"02090": 100}',
    density: 0,
    imprecise: false,
    latitude: 65.1551,
    longitude: -146.25238,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99707',
  },
  {
    city: 'Fairbanks',
    county_fips: 2090,
    county_fips_all: '02090',
    county: 'Fairbanks North Star',
    county_names_all: 'Fairbanks North Star',
    county_weights: '{"02090": 100}',
    density: 22.4,
    imprecise: false,
    latitude: 64.87402,
    longitude: -148.22458,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 29551,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99709',
  },
  {
    city: 'Fairbanks',
    county_fips: 2090,
    county_fips_all: '02090',
    county: 'Fairbanks North Star',
    county_names_all: 'Fairbanks North Star',
    county_weights: '{"02090": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 64.98311,
    longitude: -146.13946,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 12477,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99712',
  },
  {
    city: 'Salcha',
    county_fips: 2090,
    county_fips_all: '02090',
    county: 'Fairbanks North Star',
    county_names_all: 'Fairbanks North Star',
    county_weights: '{"02090": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 64.4368,
    longitude: -146.69689,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 1106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99714',
  },
  {
    city: 'Allakaket',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 1.5,
    imprecise: false,
    latitude: 66.56395,
    longitude: -152.76395,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 178,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99720',
  },
  {
    city: 'Anaktuvuk Pass',
    county_fips: 2185,
    county_fips_all: '02185',
    county: 'North Slope',
    county_names_all: 'North Slope',
    county_weights: '{"02185": 100}',
    density: 24.5,
    imprecise: false,
    latitude: 68.14999,
    longitude: -151.71616,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 329,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99721',
  },
  {
    city: 'Arctic Village',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 1,
    imprecise: false,
    latitude: 68.14208,
    longitude: -145.49557,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 164,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99722',
  },
  {
    city: 'Barrow',
    county_fips: 2185,
    county_fips_all: '02185',
    county: 'North Slope',
    county_names_all: 'North Slope',
    county_weights: '{"02185": 100}',
    density: 97.9,
    imprecise: false,
    latitude: 71.27434,
    longitude: -156.75394,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 4785,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99723',
  },
  {
    city: 'Beaver',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0,
    imprecise: false,
    latitude: 66.32218,
    longitude: -146.96636,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 17,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99724',
  },
  {
    city: 'Ester',
    county_fips: 2090,
    county_fips_all: '02090',
    county: 'Fairbanks North Star',
    county_names_all: 'Fairbanks North Star',
    county_weights: '{"02090": 100}',
    density: 35.7,
    imprecise: false,
    latitude: 64.8612,
    longitude: -148.02387,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 448,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99725',
  },
  {
    city: 'Bettles Field',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0,
    imprecise: false,
    latitude: 66.73615,
    longitude: -151.47757,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99726',
  },
  {
    city: 'Buckland',
    county_fips: 2188,
    county_fips_all: '02188',
    county: 'Northwest Arctic',
    county_names_all: 'Northwest Arctic',
    county_weights: '{"02188": 100}',
    density: 391.7,
    imprecise: false,
    latitude: 65.97654,
    longitude: -161.13918,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99727',
  },
  {
    city: 'Cantwell',
    county_fips: 2170,
    county_fips_all: '02170|02068',
    county: 'Matanuska-Susitna',
    county_names_all: 'Matanuska-Susitna|Denali',
    county_weights: '{"02170": 89.4, "02068": 10.6}',
    density: 0,
    imprecise: false,
    latitude: 63.22686,
    longitude: -148.10122,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 128,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99729',
  },
  {
    city: 'Central',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0,
    imprecise: false,
    latitude: 65.67807,
    longitude: -145.54055,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99730',
  },
  {
    city: 'Chicken',
    county_fips: 2240,
    county_fips_all: '02240',
    county: 'Southeast Fairbanks',
    county_names_all: 'Southeast Fairbanks',
    county_weights: '{"02240": 100}',
    density: 0,
    imprecise: false,
    latitude: 64.07945,
    longitude: -141.97039,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99732',
  },
  {
    city: 'Circle',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 65.79284,
    longitude: -144.18282,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 54,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99733',
  },
  {
    city: 'Prudhoe Bay',
    county_fips: 2185,
    county_fips_all: '02185',
    county: 'North Slope',
    county_names_all: 'North Slope',
    county_weights: '{"02185": 100}',
    density: 2,
    imprecise: false,
    latitude: 70.36201,
    longitude: -149.0021,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 1203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99734',
  },
  {
    city: 'Deering',
    county_fips: 2188,
    county_fips_all: '02188',
    county: 'Northwest Arctic',
    county_names_all: 'Northwest Arctic',
    county_weights: '{"02188": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 66.07222,
    longitude: -162.74349,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 227,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99736',
  },
  {
    city: 'Delta Junction',
    county_fips: 2240,
    county_fips_all: '02240|02066',
    county: 'Southeast Fairbanks',
    county_names_all: 'Southeast Fairbanks|Copper River',
    county_weights: '{"02240": 76.8, "02066": 23.2}',
    density: 0.3,
    imprecise: false,
    latitude: 63.62717,
    longitude: -145.07539,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 4774,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99737',
  },
  {
    city: 'Eagle',
    county_fips: 2240,
    county_fips_all: '02240|02290',
    county: 'Southeast Fairbanks',
    county_names_all: 'Southeast Fairbanks|Yukon-Koyukuk',
    county_weights: '{"02240": 57.59, "02290": 42.41}',
    density: 0,
    imprecise: false,
    latitude: 65.14953,
    longitude: -142.43307,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99738',
  },
  {
    city: 'Elim',
    county_fips: 2180,
    county_fips_all: '02180',
    county: 'Nome',
    county_names_all: 'Nome',
    county_weights: '{"02180": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 64.97626,
    longitude: -162.8397,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99739',
  },
  {
    city: 'Fort Yukon',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0,
    imprecise: false,
    latitude: 67.70759,
    longitude: -143.95132,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 656,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99740',
  },
  {
    city: 'Galena',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 13.4,
    imprecise: false,
    latitude: 64.73808,
    longitude: -156.86351,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99741',
  },
  {
    city: 'Gambell',
    county_fips: 2180,
    county_fips_all: '02180',
    county: 'Nome',
    county_names_all: 'Nome',
    county_weights: '{"02180": 100}',
    density: 20.9,
    imprecise: false,
    latitude: 63.75375,
    longitude: -171.68811,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 569,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99742',
  },
  {
    city: 'Healy',
    county_fips: 2068,
    county_fips_all: '02068',
    county: 'Denali',
    county_names_all: 'Denali',
    county_weights: '{"02068": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 63.90955,
    longitude: -149.91736,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 652,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99743',
  },
  {
    city: 'Anderson',
    county_fips: 2068,
    county_fips_all: '02068',
    county: 'Denali',
    county_names_all: 'Denali',
    county_weights: '{"02068": 100}',
    density: 1.7,
    imprecise: false,
    latitude: 64.31361,
    longitude: -149.13217,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 120,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99744',
  },
  {
    city: 'Hughes',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 5.1,
    imprecise: false,
    latitude: 66.0472,
    longitude: -154.24096,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 40,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99745',
  },
  {
    city: 'Huslia',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 65.70013,
    longitude: -156.33856,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 51,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99746',
  },
  {
    city: 'Kaltag',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 64.32229,
    longitude: -158.74356,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 68,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99748',
  },
  {
    city: 'Kiana',
    county_fips: 2188,
    county_fips_all: '02188',
    county: 'Northwest Arctic',
    county_names_all: 'Northwest Arctic',
    county_weights: '{"02188": 100}',
    density: 156.9,
    imprecise: false,
    latitude: 66.9786,
    longitude: -160.43178,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 440,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99749',
  },
  {
    city: 'Kivalina',
    county_fips: 2188,
    county_fips_all: '02188',
    county: 'Northwest Arctic',
    county_names_all: 'Northwest Arctic',
    county_weights: '{"02188": 100}',
    density: 191.9,
    imprecise: false,
    latitude: 67.73299,
    longitude: -164.52122,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 809,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99750',
  },
  {
    city: 'Kobuk',
    county_fips: 2188,
    county_fips_all: '02188',
    county: 'Northwest Arctic',
    county_names_all: 'Northwest Arctic',
    county_weights: '{"02188": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 66.93103,
    longitude: -156.89386,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99751',
  },
  {
    city: 'Kotzebue',
    county_fips: 2188,
    county_fips_all: '02188',
    county: 'Northwest Arctic',
    county_names_all: 'Northwest Arctic',
    county_weights: '{"02188": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 67.29316,
    longitude: -161.91744,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 3056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99752',
  },
  {
    city: 'Koyuk',
    county_fips: 2180,
    county_fips_all: '02180',
    county: 'Nome',
    county_names_all: 'Nome',
    county_weights: '{"02180": 100}',
    density: 26.3,
    imprecise: false,
    latitude: 64.94112,
    longitude: -161.14536,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 348,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99753',
  },
  {
    city: 'Koyukuk',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 2,
    imprecise: false,
    latitude: 64.9008,
    longitude: -157.69462,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99754',
  },
  {
    city: 'Denali National Park',
    county_fips: 2068,
    county_fips_all: '02068',
    county: 'Denali',
    county_names_all: 'Denali',
    county_weights: '{"02068": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 63.68849,
    longitude: -148.88742,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 987,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99755',
  },
  {
    city: 'Manley Hot Springs',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0,
    imprecise: false,
    latitude: 64.93645,
    longitude: -150.66654,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 32,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99756',
  },
  {
    city: 'Lake Minchumina',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0,
    imprecise: false,
    latitude: 63.83208,
    longitude: -152.49481,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 7,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99757',
  },
  {
    city: 'Minto',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 27.3,
    imprecise: false,
    latitude: 65.15175,
    longitude: -149.3724,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99758',
  },
  {
    city: 'Point Lay',
    county_fips: 2185,
    county_fips_all: '02185',
    county: 'North Slope',
    county_names_all: 'North Slope',
    county_weights: '{"02185": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 69.73723,
    longitude: -162.83741,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 390,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99759',
  },
  {
    city: 'Nenana',
    county_fips: 2290,
    county_fips_all: '02290|02068|02090',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk|Denali|Fairbanks North Star',
    county_weights: '{"02290": 56.42, "02068": 42.47, "02090": 1.11}',
    density: 0.1,
    imprecise: false,
    latitude: 64.37035,
    longitude: -149.17513,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 833,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99760',
  },
  {
    city: 'Nome',
    county_fips: 2180,
    county_fips_all: '02180',
    county: 'Nome',
    county_names_all: 'Nome',
    county_weights: '{"02180": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 64.85078,
    longitude: -164.80261,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 4156,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99762',
  },
  {
    city: 'Noorvik',
    county_fips: 2188,
    county_fips_all: '02188',
    county: 'Northwest Arctic',
    county_names_all: 'Northwest Arctic',
    county_weights: '{"02188": 100}',
    density: 353.8,
    imprecise: false,
    latitude: 66.82801,
    longitude: -161.03735,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 748,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99763',
  },
  {
    city: 'Northway',
    county_fips: 2240,
    county_fips_all: '02240',
    county: 'Southeast Fairbanks',
    county_names_all: 'Southeast Fairbanks',
    county_weights: '{"02240": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 62.76664,
    longitude: -141.67447,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 195,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99764',
  },
  {
    city: 'Nulato',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 12.1,
    imprecise: false,
    latitude: 64.73066,
    longitude: -158.13108,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99765',
  },
  {
    city: 'Point Hope',
    county_fips: 2185,
    county_fips_all: '02185',
    county: 'North Slope',
    county_names_all: 'North Slope',
    county_weights: '{"02185": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 68.29104,
    longitude: -166.04257,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 832,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99766',
  },
  {
    city: 'Rampart',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0,
    imprecise: false,
    latitude: 65.49664,
    longitude: -150.14393,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99767',
  },
  {
    city: 'Ruby',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0,
    imprecise: false,
    latitude: 65.38635,
    longitude: -153.53826,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99768',
  },
  {
    city: 'Savoonga',
    county_fips: 2180,
    county_fips_all: '02180',
    county: 'Nome',
    county_names_all: 'Nome',
    county_weights: '{"02180": 100}',
    density: 57.1,
    imprecise: false,
    latitude: 63.67965,
    longitude: -170.48309,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 868,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99769',
  },
  {
    city: 'Selawik',
    county_fips: 2188,
    county_fips_all: '02188',
    county: 'Northwest Arctic',
    county_names_all: 'Northwest Arctic',
    county_weights: '{"02188": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 66.60708,
    longitude: -160.07136,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 412,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99770',
  },
  {
    city: 'Shaktoolik',
    county_fips: 2180,
    county_fips_all: '02180',
    county: 'Nome',
    county_names_all: 'Nome',
    county_weights: '{"02180": 100}',
    density: 104,
    imprecise: false,
    latitude: 64.35764,
    longitude: -161.1989,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 283,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99771',
  },
  {
    city: 'Shishmaref',
    county_fips: 2180,
    county_fips_all: '02180',
    county: 'Nome',
    county_names_all: 'Nome',
    county_weights: '{"02180": 100}',
    density: 0,
    imprecise: false,
    latitude: 65.94811,
    longitude: -165.80122,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 466,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99772',
  },
  {
    city: 'Shungnak',
    county_fips: 2188,
    county_fips_all: '02188',
    county: 'Northwest Arctic',
    county_names_all: 'Northwest Arctic',
    county_weights: '{"02188": 100}',
    density: 7,
    imprecise: false,
    latitude: 66.88053,
    longitude: -157.14993,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99773',
  },
  {
    city: 'Tanacross',
    county_fips: 2240,
    county_fips_all: '02240',
    county: 'Southeast Fairbanks',
    county_names_all: 'Southeast Fairbanks',
    county_weights: '{"02240": 100}',
    density: 0.8,
    imprecise: false,
    latitude: 63.35232,
    longitude: -143.43181,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99776',
  },
  {
    city: 'Tanana',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 15.3,
    imprecise: false,
    latitude: 65.18392,
    longitude: -152.06673,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99777',
  },
  {
    city: 'Teller',
    county_fips: 2180,
    county_fips_all: '02180',
    county: 'Nome',
    county_names_all: 'Nome',
    county_weights: '{"02180": 100}',
    density: 66,
    imprecise: false,
    latitude: 65.25309,
    longitude: -166.342,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99778',
  },
  {
    city: 'Tok',
    county_fips: 2240,
    county_fips_all: '02240|02066',
    county: 'Southeast Fairbanks',
    county_names_all: 'Southeast Fairbanks|Copper River',
    county_weights: '{"02240": 94.75, "02066": 5.25}',
    density: 0.1,
    imprecise: false,
    latitude: 63.46295,
    longitude: -142.1701,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 1884,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99780',
  },
  {
    city: 'Venetie',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0,
    imprecise: false,
    latitude: 67.32073,
    longitude: -145.98835,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99781',
  },
  {
    city: 'Wainwright',
    county_fips: 2185,
    county_fips_all: '02185',
    county: 'North Slope',
    county_names_all: 'North Slope',
    county_weights: '{"02185": 100}',
    density: 26.9,
    imprecise: false,
    latitude: 70.63804,
    longitude: -159.97121,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99782',
  },
  {
    city: 'Wales',
    county_fips: 2180,
    county_fips_all: '02180',
    county: 'Nome',
    county_names_all: 'Nome',
    county_weights: '{"02180": 100}',
    density: 39.9,
    imprecise: false,
    latitude: 65.61191,
    longitude: -168.07732,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99783',
  },
  {
    city: 'White Mountain',
    county_fips: 2180,
    county_fips_all: '02180',
    county: 'Nome',
    county_names_all: 'Nome',
    county_weights: '{"02180": 100}',
    density: 125.8,
    imprecise: false,
    latitude: 64.682,
    longitude: -163.4067,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 222,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99784',
  },
  {
    city: 'Brevig Mission',
    county_fips: 2180,
    county_fips_all: '02180',
    county: 'Nome',
    county_names_all: 'Nome',
    county_weights: '{"02180": 100}',
    density: 116.5,
    imprecise: false,
    latitude: 65.34151,
    longitude: -166.4942,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99785',
  },
  {
    city: 'Ambler',
    county_fips: 2188,
    county_fips_all: '02188',
    county: 'Northwest Arctic',
    county_names_all: 'Northwest Arctic',
    county_weights: '{"02188": 100}',
    density: 6.8,
    imprecise: false,
    latitude: 67.08971,
    longitude: -157.87253,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99786',
  },
  {
    city: 'Chalkyitsik',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 3.6,
    imprecise: false,
    latitude: 66.64629,
    longitude: -143.78137,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 80,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99788',
  },
  {
    city: 'Nuiqsut',
    county_fips: 2185,
    county_fips_all: '02185',
    county: 'North Slope',
    county_names_all: 'North Slope',
    county_weights: '{"02185": 100}',
    density: 26.8,
    imprecise: false,
    latitude: 70.21348,
    longitude: -150.98966,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99789',
  },
  {
    city: 'Atqasuk',
    county_fips: 2185,
    county_fips_all: '02185',
    county: 'North Slope',
    county_names_all: 'North Slope',
    county_weights: '{"02185": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 70.48101,
    longitude: -157.3835,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99791',
  },
  {
    city: 'Juneau',
    county_fips: 2110,
    county_fips_all: '02110',
    county: 'Juneau',
    county_names_all: 'Juneau',
    county_weights: '{"02110": 100}',
    density: 5.2,
    imprecise: false,
    latitude: 58.39785,
    longitude: -134.05472,
    militaryZip: false,
    timezone: 'America/Juneau',
    population: 29588,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99801',
  },
  {
    city: 'Angoon',
    county_fips: 2105,
    county_fips_all: '02105',
    county: 'Hoonah-Angoon',
    county_names_all: 'Hoonah-Angoon',
    county_weights: '{"02105": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 57.43552,
    longitude: -134.28926,
    militaryZip: false,
    timezone: 'America/Juneau',
    population: 480,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99820',
  },
  {
    city: 'Douglas',
    county_fips: 2110,
    county_fips_all: '02110',
    county: 'Juneau',
    county_names_all: 'Juneau',
    county_weights: '{"02110": 100}',
    density: 482.9,
    imprecise: false,
    latitude: 58.27234,
    longitude: -134.40082,
    militaryZip: false,
    timezone: 'America/Juneau',
    population: 2190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99824',
  },
  {
    city: 'Elfin Cove',
    county_fips: 2105,
    county_fips_all: '02105',
    county: 'Hoonah-Angoon',
    county_names_all: 'Hoonah-Angoon',
    county_weights: '{"02105": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 58.12864,
    longitude: -136.19507,
    militaryZip: false,
    timezone: 'America/Juneau',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99825',
  },
  {
    city: 'Gustavus',
    county_fips: 2105,
    county_fips_all: '02105',
    county: 'Hoonah-Angoon',
    county_names_all: 'Hoonah-Angoon',
    county_weights: '{"02105": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 58.39816,
    longitude: -135.83456,
    militaryZip: false,
    timezone: 'America/Juneau',
    population: 594,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99826',
  },
  {
    city: 'Haines',
    county_fips: 2100,
    county_fips_all: '02100|02105|02230',
    county: 'Haines',
    county_names_all: 'Haines|Hoonah-Angoon|Skagway',
    county_weights: '{"02100": 55.1, "02105": 44.72, "02230": 0.18}',
    density: 0.3,
    imprecise: false,
    latitude: 59.02659,
    longitude: -135.88483,
    militaryZip: false,
    timezone: 'America/Juneau',
    population: 2168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99827',
  },
  {
    city: 'Hoonah',
    county_fips: 2105,
    county_fips_all: '02105',
    county: 'Hoonah-Angoon',
    county_names_all: 'Hoonah-Angoon',
    county_weights: '{"02105": 100}',
    density: 3.5,
    imprecise: false,
    latitude: 58.03502,
    longitude: -135.33856,
    militaryZip: false,
    timezone: 'America/Juneau',
    population: 862,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99829',
  },
  {
    city: 'Kake',
    county_fips: 2198,
    county_fips_all: '02198',
    county: 'Prince of Wales-Hyder',
    county_names_all: 'Prince of Wales-Hyder',
    county_weights: '{"02198": 100}',
    density: 0.9,
    imprecise: false,
    latitude: 56.78305,
    longitude: -134.16688,
    militaryZip: false,
    timezone: 'America/Sitka',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99830',
  },
  {
    city: 'Pelican',
    county_fips: 2105,
    county_fips_all: '02105',
    county: 'Hoonah-Angoon',
    county_names_all: 'Hoonah-Angoon',
    county_weights: '{"02105": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 57.96611,
    longitude: -136.08265,
    militaryZip: false,
    timezone: 'America/Juneau',
    population: 102,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99832',
  },
  {
    city: 'Petersburg',
    county_fips: 2195,
    county_fips_all: '02195|02198',
    county: 'Petersburg',
    county_names_all: 'Petersburg|Prince of Wales-Hyder',
    county_weights: '{"02195": 64.99, "02198": 35.01}',
    density: 0.4,
    imprecise: false,
    latitude: 56.82952,
    longitude: -133.17986,
    militaryZip: false,
    timezone: 'America/Sitka',
    population: 3409,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99833',
  },
  {
    city: 'Sitka',
    county_fips: 2220,
    county_fips_all: '02220',
    county: 'Sitka',
    county_names_all: 'Sitka',
    county_weights: '{"02220": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 57.23891,
    longitude: -135.2633,
    militaryZip: false,
    timezone: 'America/Sitka',
    population: 8368,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99835',
  },
  {
    city: 'Port Alexander',
    county_fips: 2198,
    county_fips_all: '02198',
    county: 'Prince of Wales-Hyder',
    county_names_all: 'Prince of Wales-Hyder',
    county_weights: '{"02198": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 56.23558,
    longitude: -134.65333,
    militaryZip: false,
    timezone: 'America/Sitka',
    population: 50,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99836',
  },
  {
    city: 'Skagway',
    county_fips: 2230,
    county_fips_all: '02230',
    county: 'Skagway',
    county_names_all: 'Skagway',
    county_weights: '{"02230": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 59.56297,
    longitude: -135.33626,
    militaryZip: false,
    timezone: 'America/Juneau',
    population: 1244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99840',
  },
  {
    city: 'Tenakee Springs',
    county_fips: 2105,
    county_fips_all: '02105',
    county: 'Hoonah-Angoon',
    county_names_all: 'Hoonah-Angoon',
    county_weights: '{"02105": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 58.00866,
    longitude: -135.57397,
    militaryZip: false,
    timezone: 'America/Juneau',
    population: 163,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99841',
  },
  {
    city: 'Ketchikan',
    county_fips: 2130,
    county_fips_all: '02130|02198',
    county: 'Ketchikan Gateway',
    county_names_all: 'Ketchikan Gateway|Prince of Wales-Hyder',
    county_weights: '{"02130": 86.21, "02198": 13.79}',
    density: 2.7,
    imprecise: false,
    latitude: 55.6227,
    longitude: -131.67157,
    militaryZip: false,
    timezone: 'America/Sitka',
    population: 13768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99901',
  },
  {
    city: 'Coffman Cove',
    county_fips: 2198,
    county_fips_all: '02198',
    county: 'Prince of Wales-Hyder',
    county_names_all: 'Prince of Wales-Hyder',
    county_weights: '{"02198": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 55.94605,
    longitude: -132.74233,
    militaryZip: false,
    timezone: 'America/Sitka',
    population: 269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99918',
  },
  {
    city: 'Thorne Bay',
    county_fips: 2198,
    county_fips_all: '02198',
    county: 'Prince of Wales-Hyder',
    county_names_all: 'Prince of Wales-Hyder',
    county_weights: '{"02198": 100}',
    density: 4.5,
    imprecise: false,
    latitude: 55.64983,
    longitude: -132.50337,
    militaryZip: false,
    timezone: 'America/Sitka',
    population: 570,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99919',
  },
  {
    city: 'Craig',
    county_fips: 2198,
    county_fips_all: '02198',
    county: 'Prince of Wales-Hyder',
    county_names_all: 'Prince of Wales-Hyder',
    county_weights: '{"02198": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 55.51989,
    longitude: -132.81656,
    militaryZip: false,
    timezone: 'America/Sitka',
    population: 1596,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99921',
  },
  {
    city: 'Hydaburg',
    county_fips: 2198,
    county_fips_all: '02198',
    county: 'Prince of Wales-Hyder',
    county_names_all: 'Prince of Wales-Hyder',
    county_weights: '{"02198": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 55.30218,
    longitude: -133.03264,
    militaryZip: false,
    timezone: 'America/Sitka',
    population: 375,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99922',
  },
  {
    city: 'Hyder',
    county_fips: 2198,
    county_fips_all: '02198',
    county: 'Prince of Wales-Hyder',
    county_names_all: 'Prince of Wales-Hyder',
    county_weights: '{"02198": 100}',
    density: 0.5,
    imprecise: false,
    latitude: 55.98043,
    longitude: -130.03803,
    militaryZip: false,
    timezone: 'America/Sitka',
    population: 24,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99923',
  },
  {
    city: 'Klawock',
    county_fips: 2198,
    county_fips_all: '02198',
    county: 'Prince of Wales-Hyder',
    county_names_all: 'Prince of Wales-Hyder',
    county_weights: '{"02198": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 55.55398,
    longitude: -132.96276,
    militaryZip: false,
    timezone: 'America/Sitka',
    population: 841,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99925',
  },
  {
    city: 'Metlakatla',
    county_fips: 2198,
    county_fips_all: '02198',
    county: 'Prince of Wales-Hyder',
    county_names_all: 'Prince of Wales-Hyder',
    county_weights: '{"02198": 100}',
    density: 3.9,
    imprecise: false,
    latitude: 55.12617,
    longitude: -131.48928,
    militaryZip: false,
    timezone: 'America/Metlakatla',
    population: 1334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99926',
  },
  {
    city: 'Point Baker',
    county_fips: 2198,
    county_fips_all: '02198',
    county: 'Prince of Wales-Hyder',
    county_names_all: 'Prince of Wales-Hyder',
    county_weights: '{"02198": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 56.33305,
    longitude: -133.60044,
    militaryZip: false,
    timezone: 'America/Sitka',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99927',
  },
  {
    city: 'Wrangell',
    county_fips: 2275,
    county_fips_all: '02275',
    county: 'Wrangell',
    county_names_all: 'Wrangell',
    county_weights: '{"02275": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 56.36089,
    longitude: -132.00635,
    militaryZip: false,
    timezone: 'America/Sitka',
    population: 2087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99929',
  },
  {
    city: 'Suffield',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 4681.2,
    imprecise: false,
    latitude: 41.95044,
    longitude: -72.63519,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1616,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06080',
  },
  {
    city: 'Storrs Mansfield',
    county_fips: 9110,
    county_fips_all: '09110',
    county: 'Capitol',
    county_names_all: 'Capitol',
    county_weights: '{"09110": 100}',
    density: 2457.1,
    imprecise: false,
    latitude: 41.80998,
    longitude: -72.25283,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7970,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06269',
  },
  {
    city: 'Middletown',
    county_fips: 9130,
    county_fips_all: '09130',
    county: 'Lower Connecticut River Valley',
    county_names_all: 'Lower Connecticut River Valley',
    county_weights: '{"09130": 100}',
    density: 1437,
    imprecise: false,
    latitude: 41.5516,
    longitude: -72.66017,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1238,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06459',
  },
  {
    city: 'West Chester',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 6049.2,
    imprecise: false,
    latitude: 39.94303,
    longitude: -75.60155,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6537,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19383',
  },
  {
    city: 'Northampton',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 9926.9,
    imprecise: false,
    latitude: 42.31962,
    longitude: -72.63951,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01063',
  },
  {
    city: 'Bridgewater',
    county_fips: 25023,
    county_fips_all: '25023',
    county: 'Plymouth',
    county_names_all: 'Plymouth',
    county_weights: '{"25023": 100}',
    density: 3575.1,
    imprecise: false,
    latitude: 41.98875,
    longitude: -70.96449,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2822,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02325',
  },
  {
    city: 'North Easton',
    county_fips: 25005,
    county_fips_all: '25005',
    county: 'Bristol',
    county_names_all: 'Bristol',
    county_weights: '{"25005": 100}',
    density: 1557.4,
    imprecise: false,
    latitude: 42.06224,
    longitude: -71.07751,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1566,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '02357',
  },
  {
    city: 'Providence',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 9431.7,
    imprecise: false,
    latitude: 41.82783,
    longitude: -71.39959,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02912',
  },
  {
    city: 'Providence',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 7260.5,
    imprecise: false,
    latitude: 41.84386,
    longitude: -71.43499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02918',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 23484.9,
    imprecise: false,
    latitude: 38.89884,
    longitude: -77.04779,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2730,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20052',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 7971.5,
    imprecise: false,
    latitude: 38.90892,
    longitude: -77.07511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3229,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20057',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 4784.4,
    imprecise: false,
    latitude: 38.92247,
    longitude: -77.02003,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1338,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20059',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 2878.9,
    imprecise: false,
    latitude: 38.93637,
    longitude: -76.99924,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20064',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.88556,
    longitude: -77.01443,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20204',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.89713,
    longitude: -77.03436,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20220',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.89373,
    longitude: -77.03567,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20230',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.89446,
    longitude: -77.04261,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20240',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.89358,
    longitude: -77.04503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20245',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.88556,
    longitude: -77.03276,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20250',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 38.93645,
    longitude: -77.0128,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20317',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 64.6,
    imprecise: false,
    latitude: 38.86706,
    longitude: -77.01695,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 23,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20319',
  },
  {
    city: 'Naval Anacost Annex',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 293,
    imprecise: false,
    latitude: 38.85779,
    longitude: -77.01051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20373',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 22496.6,
    imprecise: false,
    latitude: 38.87902,
    longitude: -76.99375,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 246,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20390',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.89284,
    longitude: -77.02301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20408',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.89494,
    longitude: -77.0442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20415',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.8928,
    longitude: -77.04776,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20418',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 49.6,
    imprecise: false,
    latitude: 38.92714,
    longitude: -77.0103,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20422',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.90207,
    longitude: -77.04755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20427',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.89895,
    longitude: -77.04419,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20431',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.89278,
    longitude: -77.00689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20510',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.88681,
    longitude: -77.00901,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20515',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.8947,
    longitude: -77.04848,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20520',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.89313,
    longitude: -77.02503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20530',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.89514,
    longitude: -77.02493,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20535',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.88793,
    longitude: -77.00471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20540',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.94136,
    longitude: -77.02801,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20542',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.8928,
    longitude: -77.0458,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20551',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.8902,
    longitude: -77.02745,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20560',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.89007,
    longitude: -77.01955,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20565',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.89667,
    longitude: -77.05536,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20566',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.88695,
    longitude: -77.02297,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20591',
  },
  {
    city: 'College Park',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 5209,
    imprecise: false,
    latitude: 38.99422,
    longitude: -76.94347,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4350,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20742',
  },
  {
    city: 'Greenbelt',
    county_fips: 24033,
    county_fips_all: '24033',
    county: "Prince George's",
    county_names_all: "Prince George's",
    county_weights: '{"24033": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.00289,
    longitude: -76.85534,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20771',
  },
  {
    city: 'Bethesda',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 578.8,
    imprecise: false,
    latitude: 39.00193,
    longitude: -77.09038,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 584,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20889',
  },
  {
    city: 'Bethesda',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.0006,
    longitude: -77.10373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20892',
  },
  {
    city: 'Bethesda',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.99591,
    longitude: -77.10221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20894',
  },
  {
    city: 'Gaithersburg',
    county_fips: 24031,
    county_fips_all: '24031',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"24031": 100}',
    density: 207.6,
    imprecise: false,
    latitude: 39.14442,
    longitude: -77.21621,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20899',
  },
  {
    city: 'Baltimore',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 4465,
    imprecise: false,
    latitude: 39.25558,
    longitude: -76.71117,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2834,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21250',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 623.4,
    imprecise: false,
    latitude: 39.34993,
    longitude: -76.58027,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21251',
  },
  {
    city: 'Towson',
    county_fips: 24005,
    county_fips_all: '24005',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24005": 100}',
    density: 7556.8,
    imprecise: false,
    latitude: 39.39413,
    longitude: -76.61144,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21252',
  },
  {
    city: 'Hagerstown',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 3472.4,
    imprecise: false,
    latitude: 39.56591,
    longitude: -77.71409,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2361,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21746',
  },
  {
    city: 'Westover',
    county_fips: 24039,
    county_fips_all: '24039',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"24039": 100}',
    density: 3617.5,
    imprecise: false,
    latitude: 38.15673,
    longitude: -75.6998,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3289,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21890',
  },
  {
    city: 'Orono',
    county_fips: 23019,
    county_fips_all: '23019',
    county: 'Penobscot',
    county_names_all: 'Penobscot',
    county_weights: '{"23019": 100}',
    density: 1594.4,
    imprecise: false,
    latitude: 44.90251,
    longitude: -68.66624,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3531,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04469',
  },
  {
    city: 'White River Junction',
    county_fips: 50027,
    county_fips_all: '50027',
    county: 'Windsor',
    county_names_all: 'Windsor',
    county_weights: '{"50027": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.64769,
    longitude: -72.34395,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05009',
  },
  {
    city: 'Burlington',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 6133.6,
    imprecise: false,
    latitude: 44.47475,
    longitude: -73.19649,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05405',
  },
  {
    city: 'Colchester',
    county_fips: 50007,
    county_fips_all: '50007',
    county: 'Chittenden',
    county_names_all: 'Chittenden',
    county_weights: '{"50007": 100}',
    density: 3262.3,
    imprecise: false,
    latitude: 44.49573,
    longitude: -73.16524,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VT',
    stateName: 'Vermont',
    zip: '05439',
  },
  {
    city: 'Princeton',
    county_fips: 34021,
    county_fips_all: '34021',
    county: 'Mercer',
    county_names_all: 'Mercer',
    county_weights: '{"34021": 100}',
    density: 10197.5,
    imprecise: false,
    latitude: 40.34641,
    longitude: -74.65787,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4392,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '08544',
  },
  {
    city: 'Jamaica',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 5630.2,
    imprecise: false,
    latitude: 40.72195,
    longitude: -73.79455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2170,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11439',
  },
  {
    city: 'Jamaica',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.7012,
    longitude: -73.79579,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11451',
  },
  {
    city: 'Hempstead',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 3798.4,
    imprecise: false,
    latitude: 40.71896,
    longitude: -73.59973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11549',
  },
  {
    city: 'Stony Brook',
    county_fips: 36103,
    county_fips_all: '36103',
    county: 'Suffolk',
    county_names_all: 'Suffolk',
    county_weights: '{"36103": 100}',
    density: 1404.2,
    imprecise: false,
    latitude: 40.91915,
    longitude: -73.12475,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11794',
  },
  {
    city: 'Albany',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 3968.3,
    imprecise: false,
    latitude: 42.68637,
    longitude: -73.82656,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6889,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12222',
  },
  {
    city: 'Poughkeepsie',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 4769.5,
    imprecise: false,
    latitude: 41.68844,
    longitude: -73.89448,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12604',
  },
  {
    city: 'Auburn',
    county_fips: 36011,
    county_fips_all: '36011',
    county: 'Cayuga',
    county_names_all: 'Cayuga',
    county_weights: '{"36011": 100}',
    density: 11433.7,
    imprecise: false,
    latitude: 42.93453,
    longitude: -76.57424,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1230,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13024',
  },
  {
    city: 'Syracuse',
    county_fips: 36067,
    county_fips_all: '36067',
    county: 'Onondaga',
    county_names_all: 'Onondaga',
    county_weights: '{"36067": 100}',
    density: 5169.9,
    imprecise: false,
    latitude: 43.02318,
    longitude: -76.12329,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9683,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13244',
  },
  {
    city: 'Potsdam',
    county_fips: 36089,
    county_fips_all: '36089',
    county: 'St. Lawrence',
    county_names_all: 'St. Lawrence',
    county_weights: '{"36089": 100}',
    density: 3005.2,
    imprecise: false,
    latitude: 44.66372,
    longitude: -74.99851,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '13699',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 1441.7,
    imprecise: false,
    latitude: 43.00165,
    longitude: -78.79066,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 924,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14260',
  },
  {
    city: 'Buffalo',
    county_fips: 36029,
    county_fips_all: '36029',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"36029": 100}',
    density: 1761.1,
    imprecise: false,
    latitude: 43.00188,
    longitude: -78.7848,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5033,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14261',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.12281,
    longitude: -77.62508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14642',
  },
  {
    city: 'Winston Salem',
    county_fips: 37067,
    county_fips_all: '37067',
    county: 'Forsyth',
    county_names_all: 'Forsyth',
    county_weights: '{"37067": 100}',
    density: 4605.7,
    imprecise: false,
    latitude: 36.08919,
    longitude: -80.225,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27110',
  },
  {
    city: 'High Point',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 6041.1,
    imprecise: false,
    latitude: 35.97139,
    longitude: -79.99471,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1611,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27268',
  },
  {
    city: 'Greensboro',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 4084.1,
    imprecise: false,
    latitude: 36.07665,
    longitude: -79.77157,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1433,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27411',
  },
  {
    city: 'Greensboro',
    county_fips: 37081,
    county_fips_all: '37081',
    county: 'Guilford',
    county_names_all: 'Guilford',
    county_weights: '{"37081": 100}',
    density: 3970.4,
    imprecise: false,
    latitude: 36.06903,
    longitude: -79.81062,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27412',
  },
  {
    city: 'Chapel Hill',
    county_fips: 37135,
    county_fips_all: '37135',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"37135": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.90394,
    longitude: -79.05234,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27599',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 3037.6,
    imprecise: false,
    latitude: 35.78558,
    longitude: -78.679,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1993,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27695',
  },
  {
    city: 'Raleigh',
    county_fips: 37183,
    county_fips_all: '37183',
    county: 'Wake',
    county_names_all: 'Wake',
    county_weights: '{"37183": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.7788,
    longitude: -78.62297,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27697',
  },
  {
    city: 'Durham',
    county_fips: 37063,
    county_fips_all: '37063',
    county: 'Durham',
    county_names_all: 'Durham',
    county_weights: '{"37063": 100}',
    density: 2883.9,
    imprecise: false,
    latitude: 36.00009,
    longitude: -78.94305,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27708',
  },
  {
    city: 'Rocky Mount',
    county_fips: 37065,
    county_fips_all: '37065',
    county: 'Edgecombe',
    county_names_all: 'Edgecombe',
    county_weights: '{"37065": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.92473,
    longitude: -77.69304,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27815',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 2810.2,
    imprecise: false,
    latitude: 35.30824,
    longitude: -80.73282,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4953,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28223',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 4859.9,
    imprecise: false,
    latitude: 35.18909,
    longitude: -80.83384,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 747,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28274',
  },
  {
    city: 'Fort Bragg',
    county_fips: 37051,
    county_fips_all: '37051',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"37051": 100}',
    density: 84.9,
    imprecise: false,
    latitude: 35.12946,
    longitude: -79.0523,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9583,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28310',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 16645.4,
    imprecise: false,
    latitude: 40.43602,
    longitude: -79.99042,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5772,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15282',
  },
  {
    city: 'Somerset',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 4661.1,
    imprecise: false,
    latitude: 39.96435,
    longitude: -79.04009,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2118,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15510',
  },
  {
    city: 'Indiana',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 5380.1,
    imprecise: false,
    latitude: 40.61588,
    longitude: -79.15983,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15705',
  },
  {
    city: 'New Wilmington',
    county_fips: 42073,
    county_fips_all: '42073',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"42073": 100}',
    density: 4550.2,
    imprecise: false,
    latitude: 41.1177,
    longitude: -80.33105,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 983,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16172',
  },
  {
    city: 'Edinboro',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 1751.4,
    imprecise: false,
    latitude: 41.87071,
    longitude: -80.12175,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1190,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16444',
  },
  {
    city: 'Albion',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 1245.5,
    imprecise: false,
    latitude: 41.87645,
    longitude: -80.36107,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2194,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16475',
  },
  {
    city: 'Erie',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 3470.5,
    imprecise: false,
    latitude: 42.10389,
    longitude: -80.05338,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 929,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16546',
  },
  {
    city: 'Erie',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.13378,
    longitude: -80.08495,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16550',
  },
  {
    city: 'Erie',
    county_fips: 42049,
    county_fips_all: '42049',
    county: 'Erie',
    county_names_all: 'Erie',
    county_weights: '{"42049": 100}',
    density: 1418.4,
    imprecise: false,
    latitude: 42.11929,
    longitude: -79.98643,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1607,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16563',
  },
  {
    city: 'Huntingdon',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 11567.9,
    imprecise: false,
    latitude: 40.49189,
    longitude: -78.02854,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1906,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16654',
  },
  {
    city: 'Cresson',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.44736,
    longitude: -78.56054,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16699',
  },
  {
    city: 'Harrisburg',
    county_fips: 42043,
    county_fips_all: '42043',
    county: 'Dauphin',
    county_names_all: 'Dauphin',
    county_weights: '{"42043": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.26511,
    longitude: -76.88281,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17120',
  },
  {
    city: 'Danville',
    county_fips: 42093,
    county_fips_all: '42093',
    county: 'Montour',
    county_names_all: 'Montour',
    county_weights: '{"42093": 100}',
    density: 36.6,
    imprecise: false,
    latitude: 40.96861,
    longitude: -76.60365,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17822',
  },
  {
    city: 'Harrisonburg',
    county_fips: 51660,
    county_fips_all: '51660',
    county: 'Harrisonburg',
    county_names_all: 'Harrisonburg',
    county_weights: '{"51660": 100}',
    density: 3168.3,
    imprecise: false,
    latitude: 38.43495,
    longitude: -78.86736,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22807',
  },
  {
    city: 'Charlottesville',
    county_fips: 51540,
    county_fips_all: '51540',
    county: 'Charlottesville',
    county_names_all: 'Charlottesville',
    county_weights: '{"51540": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.03103,
    longitude: -78.49639,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22908',
  },
  {
    city: 'Richmond',
    county_fips: 51760,
    county_fips_all: '51760|51087',
    county: 'Richmond',
    county_names_all: 'Richmond|Henrico',
    county_weights: '{"51760": 99.22, "51087": 0.78}',
    density: 2486.5,
    imprecise: false,
    latitude: 37.57677,
    longitude: -77.54069,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2107,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23173',
  },
  {
    city: 'Norfolk',
    county_fips: 51710,
    county_fips_all: '51710',
    county: 'Norfolk',
    county_names_all: 'Norfolk',
    county_weights: '{"51710": 100}',
    density: 1351.5,
    imprecise: false,
    latitude: 36.92359,
    longitude: -76.29238,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23551',
  },
  {
    city: 'Hampton',
    county_fips: 51650,
    county_fips_all: '51650',
    county: 'Hampton',
    county_names_all: 'Hampton',
    county_weights: '{"51650": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.02081,
    longitude: -76.33093,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23667',
  },
  {
    city: 'Hampton',
    county_fips: 51650,
    county_fips_all: '51650',
    county: 'Hampton',
    county_names_all: 'Hampton',
    county_weights: '{"51650": 100}',
    density: 5757.3,
    imprecise: false,
    latitude: 37.02034,
    longitude: -76.33839,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 723,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23668',
  },
  {
    city: 'Hampton',
    county_fips: 51650,
    county_fips_all: '51650|51735',
    county: 'Hampton',
    county_names_all: 'Hampton|Poquoson',
    county_weights: '{"51650": 99.8, "51735": 0.2}',
    density: 0,
    imprecise: false,
    latitude: 37.09697,
    longitude: -76.38389,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23681',
  },
  {
    city: 'Jarratt',
    county_fips: 51081,
    county_fips_all: '51081',
    county: 'Greensville',
    county_names_all: 'Greensville',
    county_weights: '{"51081": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.75241,
    longitude: -77.50016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23870',
  },
  {
    city: 'Waverly',
    county_fips: 51183,
    county_fips_all: '51183',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"51183": 100}',
    density: 671.3,
    imprecise: false,
    latitude: 37.04752,
    longitude: -77.20367,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1449,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23891',
  },
  {
    city: 'Farmville',
    county_fips: 51147,
    county_fips_all: '51147',
    county: 'Prince Edward',
    county_names_all: 'Prince Edward',
    county_weights: '{"51147": 100}',
    density: 4508.5,
    imprecise: false,
    latitude: 37.29891,
    longitude: -78.39635,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1109,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23909',
  },
  {
    city: 'Blacksburg',
    county_fips: 51121,
    county_fips_all: '51121',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"51121": 100}',
    density: 3274.6,
    imprecise: false,
    latitude: 37.22539,
    longitude: -80.42658,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24061',
  },
  {
    city: 'Lynchburg',
    county_fips: 51680,
    county_fips_all: '51680|51031',
    county: 'Lynchburg',
    county_names_all: 'Lynchburg|Campbell',
    county_weights: '{"51680": 99.52, "51031": 0.48}',
    density: 3666,
    imprecise: false,
    latitude: 37.35261,
    longitude: -79.17827,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6391,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24515',
  },
  {
    city: 'Ames',
    county_fips: 19169,
    county_fips_all: '19169',
    county: 'Story',
    county_names_all: 'Story',
    county_weights: '{"19169": 100}',
    density: 2150.1,
    imprecise: false,
    latitude: 42.02904,
    longitude: -93.65086,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1913,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50012',
  },
  {
    city: 'Ames',
    county_fips: 19169,
    county_fips_all: '19169',
    county: 'Story',
    county_names_all: 'Story',
    county_weights: '{"19169": 100}',
    density: 2549.7,
    imprecise: false,
    latitude: 42.01732,
    longitude: -93.64809,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50013',
  },
  {
    city: 'Brookings',
    county_fips: 46011,
    county_fips_all: '46011',
    county: 'Brookings',
    county_names_all: 'Brookings',
    county_weights: '{"46011": 100}',
    density: 2765.2,
    imprecise: false,
    latitude: 44.31924,
    longitude: -96.78408,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2377,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57007',
  },
  {
    city: 'Sioux Falls',
    county_fips: 46099,
    county_fips_all: '46099',
    county: 'Minnehaha',
    county_names_all: 'Minnehaha',
    county_weights: '{"46099": 100}',
    density: 1784.8,
    imprecise: false,
    latitude: 43.52455,
    longitude: -96.73862,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 388,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57197',
  },
  {
    city: 'Spearfish',
    county_fips: 46081,
    county_fips_all: '46081',
    county: 'Lawrence',
    county_names_all: 'Lawrence',
    county_weights: '{"46081": 100}',
    density: 1165.5,
    imprecise: false,
    latitude: 44.49817,
    longitude: -103.87256,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SD',
    stateName: 'South Dakota',
    zip: '57799',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 3929.8,
    imprecise: false,
    latitude: 41.26535,
    longitude: -95.94535,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68178',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 1877.1,
    imprecise: false,
    latitude: 41.25775,
    longitude: -96.01072,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68182',
  },
  {
    city: 'Omaha',
    county_fips: 31055,
    county_fips_all: '31055',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"31055": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.25709,
    longitude: -95.93977,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68183',
  },
  {
    city: 'Kearney',
    county_fips: 31019,
    county_fips_all: '31019',
    county: 'Buffalo',
    county_names_all: 'Buffalo',
    county_weights: '{"31019": 100}',
    density: 2432.2,
    imprecise: false,
    latitude: 40.70148,
    longitude: -99.10082,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1385,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68849',
  },
  {
    city: 'Evanston',
    county_fips: 17031,
    county_fips_all: '17031',
    county: 'Cook',
    county_names_all: 'Cook',
    county_weights: '{"17031": 100}',
    density: 461.9,
    imprecise: false,
    latitude: 42.05457,
    longitude: -87.67412,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 255,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '60208',
  },
  {
    city: 'Peoria',
    county_fips: 17143,
    county_fips_all: '17143',
    county: 'Peoria',
    county_names_all: 'Peoria',
    county_weights: '{"17143": 100}',
    density: 2810.2,
    imprecise: false,
    latitude: 40.6978,
    longitude: -89.61455,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '61625',
  },
  {
    city: 'Edwardsville',
    county_fips: 17119,
    county_fips_all: '17119',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"17119": 100}',
    density: 299.9,
    imprecise: false,
    latitude: 38.79062,
    longitude: -90.00394,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 851,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62026',
  },
  {
    city: 'Springfield',
    county_fips: 17167,
    county_fips_all: '17167',
    county: 'Sangamon',
    county_names_all: 'Sangamon',
    county_weights: '{"17167": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.79789,
    longitude: -89.6554,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62706',
  },
  {
    city: 'Muncie',
    county_fips: 18035,
    county_fips_all: '18035',
    county: 'Delaware',
    county_names_all: 'Delaware',
    county_weights: '{"18035": 100}',
    density: 5541.9,
    imprecise: false,
    latitude: 40.20542,
    longitude: -85.40726,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3796,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47306',
  },
  {
    city: 'Terre Haute',
    county_fips: 18167,
    county_fips_all: '18167',
    county: 'Vigo',
    county_names_all: 'Vigo',
    county_weights: '{"18167": 100}',
    density: 3870.9,
    imprecise: false,
    latitude: 39.47136,
    longitude: -87.40986,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 1568,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47809',
  },
  {
    city: 'Lees Summit',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 75.1,
    imprecise: false,
    latitude: 38.95146,
    longitude: -94.40467,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 94,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64065',
  },
  {
    city: 'Columbia',
    county_fips: 29019,
    county_fips_all: '29019',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"29019": 100}',
    density: 2436.8,
    imprecise: false,
    latitude: 38.95171,
    longitude: -92.32043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 225,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65215',
  },
  {
    city: 'Columbia',
    county_fips: 29019,
    county_fips_all: '29019',
    county: 'Boone',
    county_names_all: 'Boone',
    county_weights: '{"29019": 100}',
    density: 2078.8,
    imprecise: false,
    latitude: 38.95818,
    longitude: -92.32629,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65216',
  },
  {
    city: 'Rolla',
    county_fips: 29161,
    county_fips_all: '29161',
    county: 'Phelps',
    county_names_all: 'Phelps',
    county_weights: '{"29161": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.95103,
    longitude: -91.77948,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65409',
  },
  {
    city: 'Springfield',
    county_fips: 29077,
    county_fips_all: '29077',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"29077": 100}',
    density: 3848.1,
    imprecise: false,
    latitude: 37.19985,
    longitude: -93.28055,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2613,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65897',
  },
  {
    city: 'Lawrence',
    county_fips: 20045,
    county_fips_all: '20045',
    county: 'Douglas',
    county_names_all: 'Douglas',
    county_weights: '{"20045": 100}',
    density: 666.2,
    imprecise: false,
    latitude: 38.95408,
    longitude: -95.26078,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1925,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66045',
  },
  {
    city: 'Kansas City',
    county_fips: 20209,
    county_fips_all: '20209',
    county: 'Wyandotte',
    county_names_all: 'Wyandotte',
    county_weights: '{"20209": 100}',
    density: 350.5,
    imprecise: false,
    latitude: 39.05576,
    longitude: -94.60963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 37,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66160',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 176.6,
    imprecise: false,
    latitude: 39.02631,
    longitude: -95.72231,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66622',
  },
  {
    city: 'Wichita',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 1012.7,
    imprecise: false,
    latitude: 37.71931,
    longitude: -97.2935,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 520,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67260',
  },
  {
    city: 'Mount Olive',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 105.8,
    imprecise: false,
    latitude: 38.22149,
    longitude: -81.23587,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25185',
  },
  {
    city: 'Huntington',
    county_fips: 54011,
    county_fips_all: '54011',
    county: 'Cabell',
    county_names_all: 'Cabell',
    county_weights: '{"54011": 100}',
    density: 7445.8,
    imprecise: false,
    latitude: 38.42359,
    longitude: -82.42796,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1644,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25755',
  },
  {
    city: 'Louisville',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 993.9,
    imprecise: false,
    latitude: 38.24764,
    longitude: -85.68704,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40280',
  },
  {
    city: 'Berea',
    county_fips: 21151,
    county_fips_all: '21151',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"21151": 100}',
    density: 2177,
    imprecise: false,
    latitude: 37.57311,
    longitude: -84.29037,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1114,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40404',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"21067": 100}',
    density: 15059,
    imprecise: false,
    latitude: 38.0297,
    longitude: -84.50153,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40526',
  },
  {
    city: 'Lexington',
    county_fips: 21067,
    county_fips_all: '21067',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"21067": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.02979,
    longitude: -84.50732,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40536',
  },
  {
    city: 'University Center',
    county_fips: 26017,
    county_fips_all: '26017',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"26017": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.55649,
    longitude: -83.98781,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48710',
  },
  {
    city: 'Mount Pleasant',
    county_fips: 26073,
    county_fips_all: '26073',
    county: 'Isabella',
    county_names_all: 'Isabella',
    county_weights: '{"26073": 100}',
    density: 4224.2,
    imprecise: false,
    latitude: 43.58632,
    longitude: -84.77341,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 2228,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48859',
  },
  {
    city: 'Berrien Springs',
    county_fips: 26021,
    county_fips_all: '26021',
    county: 'Berrien',
    county_names_all: 'Berrien',
    county_weights: '{"26021": 100}',
    density: 879.1,
    imprecise: false,
    latitude: 41.96348,
    longitude: -86.35877,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 383,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49104',
  },
  {
    city: 'Kincheloe',
    county_fips: 26033,
    county_fips_all: '26033',
    county: 'Chippewa',
    county_names_all: 'Chippewa',
    county_weights: '{"26033": 100}',
    density: 5185,
    imprecise: false,
    latitude: 46.2577,
    longitude: -84.45483,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 1814,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49784',
  },
  {
    city: 'Saint Paul',
    county_fips: 27123,
    county_fips_all: '27123',
    county: 'Ramsey',
    county_names_all: 'Ramsey',
    county_weights: '{"27123": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.95419,
    longitude: -93.09756,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55155',
  },
  {
    city: 'Rochester',
    county_fips: 27109,
    county_fips_all: '27109',
    county: 'Olmsted',
    county_names_all: 'Olmsted',
    county_weights: '{"27109": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.05595,
    longitude: -92.52589,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55905',
  },
  {
    city: 'Wahpeton',
    county_fips: 38077,
    county_fips_all: '38077',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"38077": 100}',
    density: 2278.2,
    imprecise: false,
    latitude: 46.27416,
    longitude: -96.60746,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58076',
  },
  {
    city: 'Jamestown',
    county_fips: 38093,
    county_fips_all: '38093',
    county: 'Stutsman',
    county_names_all: 'Stutsman',
    county_weights: '{"38093": 100}',
    density: 1678.3,
    imprecise: false,
    latitude: 46.91454,
    longitude: -98.69673,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 718,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58405',
  },
  {
    city: 'Minot',
    county_fips: 38101,
    county_fips_all: '38101',
    county: 'Ward',
    county_names_all: 'Ward',
    county_weights: '{"38101": 100}',
    density: 1688,
    imprecise: false,
    latitude: 48.24767,
    longitude: -101.30127,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 500,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58707',
  },
  {
    city: 'Bowling Green',
    county_fips: 39173,
    county_fips_all: '39173',
    county: 'Wood',
    county_names_all: 'Wood',
    county_weights: '{"39173": 100}',
    density: 5506.9,
    imprecise: false,
    latitude: 41.37784,
    longitude: -83.63653,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43403',
  },
  {
    city: 'Akron',
    county_fips: 39153,
    county_fips_all: '39153',
    county: 'Summit',
    county_names_all: 'Summit',
    county_weights: '{"39153": 100}',
    density: 1211.2,
    imprecise: false,
    latitude: 41.07605,
    longitude: -81.51221,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 911,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44325',
  },
  {
    city: 'Youngstown',
    county_fips: 39099,
    county_fips_all: '39099',
    county: 'Mahoning',
    county_names_all: 'Mahoning',
    county_weights: '{"39099": 100}',
    density: 692.5,
    imprecise: false,
    latitude: 41.10726,
    longitude: -80.64875,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44555',
  },
  {
    city: 'Cincinnati',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 17.5,
    imprecise: false,
    latitude: 39.13812,
    longitude: -84.5031,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45267',
  },
  {
    city: 'Dayton',
    county_fips: 39057,
    county_fips_all: '39057',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"39057": 100}',
    density: 292.4,
    imprecise: false,
    latitude: 39.78114,
    longitude: -84.06312,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 134,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45435',
  },
  {
    city: 'Dayton',
    county_fips: 39113,
    county_fips_all: '39113',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"39113": 100}',
    density: 3577.4,
    imprecise: false,
    latitude: 39.74033,
    longitude: -84.17911,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45469',
  },
  {
    city: 'Lucasville',
    county_fips: 39145,
    county_fips_all: '39145',
    county: 'Scioto',
    county_names_all: 'Scioto',
    county_weights: '{"39145": 100}',
    density: 1961.3,
    imprecise: false,
    latitude: 38.87414,
    longitude: -82.97045,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45699',
  },
  {
    city: 'Milwaukee',
    county_fips: 55079,
    county_fips_all: '55079',
    county: 'Milwaukee',
    county_names_all: 'Milwaukee',
    county_weights: '{"55079": 100}',
    density: 145.5,
    imprecise: false,
    latitude: 43.02222,
    longitude: -87.97665,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 90,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53295',
  },
  {
    city: 'Madison',
    county_fips: 55025,
    county_fips_all: '55025',
    county: 'Dane',
    county_names_all: 'Dane',
    county_weights: '{"55025": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.07711,
    longitude: -89.43044,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WI',
    stateName: 'Wisconsin',
    zip: '53792',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 4131.3,
    imprecise: false,
    latitude: 33.46434,
    longitude: -86.79399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2792,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35229',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 674.9,
    imprecise: false,
    latitude: 33.50657,
    longitude: -86.80316,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35249',
  },
  {
    city: 'Birmingham',
    county_fips: 1073,
    county_fips_all: '01073',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"01073": 100}',
    density: 6624.5,
    imprecise: false,
    latitude: 33.51375,
    longitude: -86.85282,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1749,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35254',
  },
  {
    city: 'Tuscaloosa',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 6216.7,
    imprecise: false,
    latitude: 33.21426,
    longitude: -87.54782,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1950,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35487',
  },
  {
    city: 'Florence',
    county_fips: 1077,
    county_fips_all: '01077',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale',
    county_weights: '{"01077": 100}',
    density: 5138.7,
    imprecise: false,
    latitude: 34.80763,
    longitude: -87.68043,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1132,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35632',
  },
  {
    city: 'Huntsville',
    county_fips: 1089,
    county_fips_all: '01089',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"01089": 100}',
    density: 536,
    imprecise: false,
    latitude: 34.75318,
    longitude: -86.65213,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 603,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35896',
  },
  {
    city: 'Troy',
    county_fips: 1109,
    county_fips_all: '01109',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"01109": 100}',
    density: 1080.6,
    imprecise: false,
    latitude: 31.80271,
    longitude: -85.95514,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1087,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36082',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.37778,
    longitude: -86.29926,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36130',
  },
  {
    city: 'Mobile',
    county_fips: 1097,
    county_fips_all: '01097',
    county: 'Mobile',
    county_names_all: 'Mobile',
    county_weights: '{"01097": 100}',
    density: 981.7,
    imprecise: false,
    latitude: 30.69559,
    longitude: -88.18783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36688',
  },
  {
    city: 'Auburn University',
    county_fips: 1081,
    county_fips_all: '01081',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"01081": 100}',
    density: 2729.9,
    imprecise: false,
    latitude: 32.59953,
    longitude: -85.48858,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5241,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36849',
  },
  {
    city: 'Clinton',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 2593.9,
    imprecise: false,
    latitude: 32.33571,
    longitude: -90.33143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39058',
  },
  {
    city: 'Jackson',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 1864.4,
    imprecise: false,
    latitude: 32.32255,
    longitude: -90.17997,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 712,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39210',
  },
  {
    city: 'Jackson',
    county_fips: 28049,
    county_fips_all: '28049',
    county: 'Hinds',
    county_names_all: 'Hinds',
    county_weights: '{"28049": 100}',
    density: 4389.1,
    imprecise: false,
    latitude: 32.29754,
    longitude: -90.20963,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2125,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39217',
  },
  {
    city: 'Meridian',
    county_fips: 28075,
    county_fips_all: '28075',
    county: 'Lauderdale',
    county_names_all: 'Lauderdale',
    county_weights: '{"28075": 100}',
    density: 13.5,
    imprecise: false,
    latitude: 32.55417,
    longitude: -88.57422,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 335,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39309',
  },
  {
    city: 'Hattiesburg',
    county_fips: 28035,
    county_fips_all: '28035',
    county: 'Forrest',
    county_names_all: 'Forrest',
    county_weights: '{"28035": 100}',
    density: 2196.6,
    imprecise: false,
    latitude: 31.32895,
    longitude: -89.33515,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1935,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39406',
  },
  {
    city: 'Stennis Space Center',
    county_fips: 28045,
    county_fips_all: '28045',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"28045": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.37734,
    longitude: -89.60211,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39529',
  },
  {
    city: 'Pascagoula',
    county_fips: 28059,
    county_fips_all: '28059',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"28059": 100}',
    density: 29,
    imprecise: false,
    latitude: 30.33448,
    longitude: -88.57587,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '39595',
  },
  {
    city: 'Arkadelphia',
    county_fips: 5019,
    county_fips_all: '05019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"05019": 100}',
    density: 3476.9,
    imprecise: false,
    latitude: 34.12609,
    longitude: -93.05275,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 669,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71998',
  },
  {
    city: 'Arkadelphia',
    county_fips: 5019,
    county_fips_all: '05019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"05019": 100}',
    density: 2565,
    imprecise: false,
    latitude: 34.12732,
    longitude: -93.05941,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 450,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '71999',
  },
  {
    city: 'Conway',
    county_fips: 5045,
    county_fips_all: '05045',
    county: 'Faulkner',
    county_names_all: 'Faulkner',
    county_weights: '{"05045": 100}',
    density: 5378.7,
    imprecise: false,
    latitude: 35.07902,
    longitude: -92.45829,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2151,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72035',
  },
  {
    city: 'Little Rock Air Force Base',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 202.1,
    imprecise: false,
    latitude: 34.90103,
    longitude: -92.15202,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 629,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72099',
  },
  {
    city: 'North Little Rock',
    county_fips: 5119,
    county_fips_all: '05119',
    county: 'Pulaski',
    county_names_all: 'Pulaski',
    county_weights: '{"05119": 100}',
    density: 2.2,
    imprecise: false,
    latitude: 34.82816,
    longitude: -92.28608,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72199',
  },
  {
    city: 'Fort Smith',
    county_fips: 5131,
    county_fips_all: '05131',
    county: 'Sebastian',
    county_names_all: 'Sebastian',
    county_weights: '{"05131": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.26004,
    longitude: -94.24265,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72905',
  },
  {
    city: 'Norman',
    county_fips: 40027,
    county_fips_all: '40027',
    county: 'Cleveland',
    county_names_all: 'Cleveland',
    county_weights: '{"40027": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.20681,
    longitude: -97.44213,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73019',
  },
  {
    city: 'Stillwater',
    county_fips: 40119,
    county_fips_all: '40119',
    county: 'Payne',
    county_names_all: 'Payne',
    county_weights: '{"40119": 100}',
    density: 2441.7,
    imprecise: false,
    latitude: 36.12398,
    longitude: -97.06901,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1755,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74077',
  },
  {
    city: 'Stillwater',
    county_fips: 40119,
    county_fips_all: '40119',
    county: 'Payne',
    county_names_all: 'Payne',
    county_weights: '{"40119": 100}',
    density: 1262.4,
    imprecise: false,
    latitude: 36.12528,
    longitude: -97.07969,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 451,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74078',
  },
  {
    city: 'Tulsa',
    county_fips: 40143,
    county_fips_all: '40143',
    county: 'Tulsa',
    county_names_all: 'Tulsa',
    county_weights: '{"40143": 100}',
    density: 2388.7,
    imprecise: false,
    latitude: 36.05064,
    longitude: -95.95253,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2207,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '74171',
  },
  {
    city: 'Jacksonville',
    county_fips: 12031,
    county_fips_all: '12031',
    county: 'Duval',
    county_names_all: 'Duval',
    county_weights: '{"12031": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.20749,
    longitude: -81.68334,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32214',
  },
  {
    city: 'Tallahassee',
    county_fips: 12073,
    county_fips_all: '12073',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"12073": 100}',
    density: 5642,
    imprecise: false,
    latitude: 30.44227,
    longitude: -84.29455,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1770,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32306',
  },
  {
    city: 'Tallahassee',
    county_fips: 12073,
    county_fips_all: '12073',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"12073": 100}',
    density: 1191,
    imprecise: false,
    latitude: 30.42173,
    longitude: -84.28686,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1300,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32307',
  },
  {
    city: 'Tallahassee',
    county_fips: 12073,
    county_fips_all: '12073',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"12073": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.44168,
    longitude: -84.30287,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32313',
  },
  {
    city: 'Tallahassee',
    county_fips: 12073,
    county_fips_all: '12073',
    county: 'Leon',
    county_names_all: 'Leon',
    county_weights: '{"12073": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.40162,
    longitude: -84.24426,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32399',
  },
  {
    city: 'Pensacola',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 101,
    imprecise: false,
    latitude: 30.47096,
    longitude: -87.34115,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 336,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32509',
  },
  {
    city: 'Pensacola',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 1719.8,
    imprecise: false,
    latitude: 30.4064,
    longitude: -87.29129,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32511',
  },
  {
    city: 'Pensacola',
    county_fips: 12033,
    county_fips_all: '12033',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"12033": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.399,
    longitude: -87.29925,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32512',
  },
  {
    city: 'Gainesville',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 64.6,
    imprecise: false,
    latitude: 29.64077,
    longitude: -82.34326,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32610',
  },
  {
    city: 'Gainesville',
    county_fips: 12001,
    county_fips_all: '12001',
    county: 'Alachua',
    county_names_all: 'Alachua',
    county_weights: '{"12001": 100}',
    density: 3759.3,
    imprecise: false,
    latitude: 29.64469,
    longitude: -82.35307,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 9157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32612',
  },
  {
    city: 'Deland',
    county_fips: 12127,
    county_fips_all: '12127',
    county: 'Volusia',
    county_names_all: 'Volusia',
    county_weights: '{"12127": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.03454,
    longitude: -81.30452,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32723',
  },
  {
    city: 'Orlando',
    county_fips: 12095,
    county_fips_all: '12095',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"12095": 100}',
    density: 2472.7,
    imprecise: false,
    latitude: 28.60075,
    longitude: -81.19511,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 12624,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32816',
  },
  {
    city: 'Orlando',
    county_fips: 12009,
    county_fips_all: '12009',
    county: 'Brevard',
    county_names_all: 'Brevard',
    county_weights: '{"12009": 100}',
    density: 0,
    imprecise: false,
    latitude: 28.58331,
    longitude: -80.63544,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32899',
  },
  {
    city: 'Tampa',
    county_fips: 12057,
    county_fips_all: '12057',
    county: 'Hillsborough',
    county_names_all: 'Hillsborough',
    county_weights: '{"12057": 100}',
    density: 3226.7,
    imprecise: false,
    latitude: 28.06112,
    longitude: -82.41172,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7298,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33620',
  },
  {
    city: 'Fort Myers',
    county_fips: 12071,
    county_fips_all: '12071',
    county: 'Lee',
    county_names_all: 'Lee',
    county_weights: '{"12071": 100}',
    density: 774.5,
    imprecise: false,
    latitude: 26.46126,
    longitude: -81.76862,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4836,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33965',
  },
  {
    city: 'Homestead',
    county_fips: 12086,
    county_fips_all: '12086',
    county: 'Miami-Dade',
    county_names_all: 'Miami-Dade',
    county_weights: '{"12086": 100}',
    density: 0,
    imprecise: false,
    latitude: 25.49796,
    longitude: -80.39818,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '33039',
  },
  {
    city: 'Carrollton',
    county_fips: 13045,
    county_fips_all: '13045',
    county: 'Carroll',
    county_names_all: 'Carroll',
    county_weights: '{"13045": 100}',
    density: 2758.6,
    imprecise: false,
    latitude: 33.57288,
    longitude: -85.09938,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30118',
  },
  {
    city: 'Atlanta',
    county_fips: 13089,
    county_fips_all: '13089',
    county: 'DeKalb',
    county_names_all: 'DeKalb',
    county_weights: '{"13089": 100}',
    density: 2070.4,
    imprecise: false,
    latitude: 33.7948,
    longitude: -84.32539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2521,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30322',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 11033.9,
    imprecise: false,
    latitude: 33.77757,
    longitude: -84.40429,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2567,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30332',
  },
  {
    city: 'Statesboro',
    county_fips: 13031,
    county_fips_all: '13031',
    county: 'Bulloch',
    county_names_all: 'Bulloch',
    county_weights: '{"13031": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.42718,
    longitude: -81.78272,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30460',
  },
  {
    city: 'Dahlonega',
    county_fips: 13187,
    county_fips_all: '13187',
    county: 'Lumpkin',
    county_names_all: 'Lumpkin',
    county_weights: '{"13187": 100}',
    density: 3599,
    imprecise: false,
    latitude: 34.52762,
    longitude: -83.98462,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1278,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30597',
  },
  {
    city: 'Athens',
    county_fips: 13059,
    county_fips_all: '13059',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"13059": 100}',
    density: 943.3,
    imprecise: false,
    latitude: 33.94252,
    longitude: -83.37256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30602',
  },
  {
    city: 'Athens',
    county_fips: 13059,
    county_fips_all: '13059',
    county: 'Clarke',
    county_names_all: 'Clarke',
    county_weights: '{"13059": 100}',
    density: 3395.3,
    imprecise: false,
    latitude: 33.93289,
    longitude: -83.37223,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30609',
  },
  {
    city: 'Augusta',
    county_fips: 13245,
    county_fips_all: '13245',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"13245": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.47021,
    longitude: -81.98789,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30912',
  },
  {
    city: 'Milledgeville',
    county_fips: 13009,
    county_fips_all: '13009',
    county: 'Baldwin',
    county_names_all: 'Baldwin',
    county_weights: '{"13009": 100}',
    density: 33.9,
    imprecise: false,
    latitude: 33.04336,
    longitude: -83.21563,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 27,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31062',
  },
  {
    city: 'Macon',
    county_fips: 13021,
    county_fips_all: '13021',
    county: 'Bibb',
    county_names_all: 'Bibb',
    county_weights: '{"13021": 100}',
    density: 2935.6,
    imprecise: false,
    latitude: 32.82859,
    longitude: -83.64928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31207',
  },
  {
    city: 'Macon',
    county_fips: 13021,
    county_fips_all: '13021',
    county: 'Bibb',
    county_names_all: 'Bibb',
    county_weights: '{"13021": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.84009,
    longitude: -83.63937,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31213',
  },
  {
    city: 'Brunswick',
    county_fips: 13127,
    county_fips_all: '13127',
    county: 'Glynn',
    county_names_all: 'Glynn',
    county_weights: '{"13127": 100}',
    density: 0,
    imprecise: false,
    latitude: 31.24098,
    longitude: -81.47449,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31524',
  },
  {
    city: 'Jesup',
    county_fips: 13305,
    county_fips_all: '13305',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"13305": 100}',
    density: 869.9,
    imprecise: false,
    latitude: 31.56333,
    longitude: -81.90271,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1058,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31599',
  },
  {
    city: 'Valdosta',
    county_fips: 13185,
    county_fips_all: '13185',
    county: 'Lowndes',
    county_names_all: 'Lowndes',
    county_weights: '{"13185": 100}',
    density: 2823.9,
    imprecise: false,
    latitude: 30.84749,
    longitude: -83.29051,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1096,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31698',
  },
  {
    city: 'Moody Afb',
    county_fips: 13185,
    county_fips_all: '13185',
    county: 'Lowndes',
    county_names_all: 'Lowndes',
    county_weights: '{"13185": 100}',
    density: 53.2,
    imprecise: false,
    latitude: 30.96666,
    longitude: -83.19237,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 620,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31699',
  },
  {
    city: 'Albany',
    county_fips: 13095,
    county_fips_all: '13095',
    county: 'Dougherty',
    county_names_all: 'Dougherty',
    county_weights: '{"13095": 100}',
    density: 156.3,
    imprecise: false,
    latitude: 31.551,
    longitude: -84.05634,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31704',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 270.4,
    imprecise: false,
    latitude: 30.0287,
    longitude: -90.06753,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 281,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70148',
  },
  {
    city: 'Thibodaux',
    county_fips: 22057,
    county_fips_all: '22057',
    county: 'Lafourche',
    county_names_all: 'Lafourche',
    county_weights: '{"22057": 100}',
    density: 669.6,
    imprecise: false,
    latitude: 29.79048,
    longitude: -90.80301,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 327,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70310',
  },
  {
    city: 'Hammond',
    county_fips: 22105,
    county_fips_all: '22105',
    county: 'Tangipahoa',
    county_names_all: 'Tangipahoa',
    county_weights: '{"22105": 100}',
    density: 5812.6,
    imprecise: false,
    latitude: 30.51652,
    longitude: -90.46932,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70402',
  },
  {
    city: 'Lake Charles',
    county_fips: 22019,
    county_fips_all: '22019',
    county: 'Calcasieu',
    county_names_all: 'Calcasieu',
    county_weights: '{"22019": 100}',
    density: 15343,
    imprecise: false,
    latitude: 30.17907,
    longitude: -93.21482,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 357,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70609',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 5905.2,
    imprecise: false,
    latitude: 30.41165,
    longitude: -91.17783,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3562,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70803',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 1265.1,
    imprecise: false,
    latitude: 30.52777,
    longitude: -91.19742,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1668,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70813',
  },
  {
    city: 'Monroe',
    county_fips: 22073,
    county_fips_all: '22073',
    county: 'Ouachita',
    county_names_all: 'Ouachita',
    county_weights: '{"22073": 100}',
    density: 9381.2,
    imprecise: false,
    latitude: 32.53036,
    longitude: -92.07206,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1264,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71209',
  },
  {
    city: 'Monroe',
    county_fips: 22073,
    county_fips_all: '22073',
    county: 'Ouachita',
    county_names_all: 'Ouachita',
    county_weights: '{"22073": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.52725,
    longitude: -92.0734,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71212',
  },
  {
    city: 'Ruston',
    county_fips: 22061,
    county_fips_all: '22061',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"22061": 100}',
    density: 2044.8,
    imprecise: false,
    latitude: 32.52928,
    longitude: -92.6517,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1969,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71272',
  },
  {
    city: 'Pineville',
    county_fips: 22079,
    county_fips_all: '22079',
    county: 'Rapides',
    county_names_all: 'Rapides',
    county_weights: '{"22079": 100}',
    density: 638.8,
    imprecise: false,
    latitude: 31.32468,
    longitude: -92.4264,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 219,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71359',
  },
  {
    city: 'Natchitoches',
    county_fips: 22069,
    county_fips_all: '22069',
    county: 'Natchitoches',
    county_names_all: 'Natchitoches',
    county_weights: '{"22069": 100}',
    density: 1600.8,
    imprecise: false,
    latitude: 31.74902,
    longitude: -93.09795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2074,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '71497',
  },
  {
    city: 'Orangeburg',
    county_fips: 45075,
    county_fips_all: '45075',
    county: 'Orangeburg',
    county_names_all: 'Orangeburg',
    county_weights: '{"45075": 100}',
    density: 2345.8,
    imprecise: false,
    latitude: 33.49828,
    longitude: -80.85,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 595,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29117',
  },
  {
    city: 'Columbia',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 6866.9,
    imprecise: false,
    latitude: 33.99751,
    longitude: -81.02681,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2445,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29208',
  },
  {
    city: 'Columbia',
    county_fips: 45079,
    county_fips_all: '45079',
    county: 'Richland',
    county_names_all: 'Richland',
    county_weights: '{"45079": 100}',
    density: 6272.2,
    imprecise: false,
    latitude: 33.99538,
    longitude: -81.03006,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 443,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29225',
  },
  {
    city: 'Charleston',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 5420.2,
    imprecise: false,
    latitude: 32.79662,
    longitude: -79.96072,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2056,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29409',
  },
  {
    city: 'Charleston',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 12603.6,
    imprecise: false,
    latitude: 32.78494,
    longitude: -79.93778,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29424',
  },
  {
    city: 'Charleston',
    county_fips: 45019,
    county_fips_all: '45019',
    county: 'Charleston',
    county_names_all: 'Charleston',
    county_weights: '{"45019": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.78516,
    longitude: -79.94828,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29425',
  },
  {
    city: 'Greenville',
    county_fips: 45045,
    county_fips_all: '45045',
    county: 'Greenville',
    county_names_all: 'Greenville',
    county_weights: '{"45045": 100}',
    density: 1443.6,
    imprecise: false,
    latitude: 34.9257,
    longitude: -82.4384,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2359,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29613',
  },
  {
    city: 'Greenville',
    county_fips: 45045,
    county_fips_all: '45045',
    county: 'Greenville',
    county_names_all: 'Greenville',
    county_weights: '{"45045": 100}',
    density: 3755,
    imprecise: false,
    latitude: 34.87386,
    longitude: -82.36302,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1848,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29614',
  },
  {
    city: 'Clemson',
    county_fips: 45077,
    county_fips_all: '45077|45073',
    county: 'Pickens',
    county_names_all: 'Pickens|Oconee',
    county_weights: '{"45077": 98.91, "45073": 1.09}',
    density: 1678.1,
    imprecise: false,
    latitude: 34.67517,
    longitude: -82.83978,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 6048,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29634',
  },
  {
    city: 'Rock Hill',
    county_fips: 45091,
    county_fips_all: '45091',
    county: 'York',
    county_names_all: 'York',
    county_weights: '{"45091": 100}',
    density: 4433.8,
    imprecise: false,
    latitude: 34.93945,
    longitude: -81.03173,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29733',
  },
  {
    city: 'McCormick',
    county_fips: 45065,
    county_fips_all: '45065',
    county: 'McCormick',
    county_names_all: 'McCormick',
    county_weights: '{"45065": 100}',
    density: 726.5,
    imprecise: false,
    latitude: 33.92801,
    longitude: -82.25064,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29899',
  },
  {
    city: 'Murfreesboro',
    county_fips: 47149,
    county_fips_all: '47149',
    county: 'Rutherford',
    county_names_all: 'Rutherford',
    county_weights: '{"47149": 100}',
    density: 1691.2,
    imprecise: false,
    latitude: 35.84873,
    longitude: -86.36284,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2704,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37132',
  },
  {
    city: 'Sewanee',
    county_fips: 47051,
    county_fips_all: '47051',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"47051": 100}',
    density: 908,
    imprecise: false,
    latitude: 35.20984,
    longitude: -85.91373,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37383',
  },
  {
    city: 'Memphis',
    county_fips: 47157,
    county_fips_all: '47157',
    county: 'Shelby',
    county_names_all: 'Shelby',
    county_weights: '{"47157": 100}',
    density: 1711.9,
    imprecise: false,
    latitude: 35.11843,
    longitude: -89.93743,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 438,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38152',
  },
  {
    city: 'Cookeville',
    county_fips: 47141,
    county_fips_all: '47141',
    county: 'Putnam',
    county_names_all: 'Putnam',
    county_weights: '{"47141": 100}',
    density: 7370.5,
    imprecise: false,
    latitude: 36.17316,
    longitude: -85.50559,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38505',
  },
  {
    city: 'Dallas',
    county_fips: 48113,
    county_fips_all: '48113',
    county: 'Dallas',
    county_names_all: 'Dallas',
    county_weights: '{"48113": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.814,
    longitude: -96.84283,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75390',
  },
  {
    city: 'Tennessee Colony',
    county_fips: 48001,
    county_fips_all: '48001',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"48001": 100}',
    density: 7805.2,
    imprecise: false,
    latitude: 31.78928,
    longitude: -95.89263,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2697,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75884',
  },
  {
    city: 'Tennessee Colony',
    county_fips: 48001,
    county_fips_all: '48001',
    county: 'Anderson',
    county_names_all: 'Anderson',
    county_weights: '{"48001": 100}',
    density: 192.9,
    imprecise: false,
    latitude: 31.78698,
    longitude: -95.91234,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2456,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75886',
  },
  {
    city: 'Nacogdoches',
    county_fips: 48347,
    county_fips_all: '48347',
    county: 'Nacogdoches',
    county_names_all: 'Nacogdoches',
    county_weights: '{"48347": 100}',
    density: 5976,
    imprecise: false,
    latitude: 31.61981,
    longitude: -94.6484,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75962',
  },
  {
    city: 'Fort Worth',
    county_fips: 48439,
    county_fips_all: '48439',
    county: 'Tarrant',
    county_names_all: 'Tarrant',
    county_weights: '{"48439": 100}',
    density: 7620.6,
    imprecise: false,
    latitude: 32.70934,
    longitude: -97.36255,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1641,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76129',
  },
  {
    city: 'Stephenville',
    county_fips: 48143,
    county_fips_all: '48143',
    county: 'Erath',
    county_names_all: 'Erath',
    county_weights: '{"48143": 100}',
    density: 10366.8,
    imprecise: false,
    latitude: 32.21728,
    longitude: -98.21702,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 750,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76402',
  },
  {
    city: 'Houston',
    county_fips: 48201,
    county_fips_all: '48201',
    county: 'Harris',
    county_names_all: 'Harris',
    county_weights: '{"48201": 100}',
    density: 3466.9,
    imprecise: false,
    latitude: 29.72168,
    longitude: -95.34356,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4579,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77204',
  },
  {
    city: 'Huntsville',
    county_fips: 48471,
    county_fips_all: '48471',
    county: 'Walker',
    county_names_all: 'Walker',
    county_weights: '{"48471": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.69818,
    longitude: -95.55886,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77341',
  },
  {
    city: 'Galveston',
    county_fips: 48167,
    county_fips_all: '48167',
    county: 'Galveston',
    county_names_all: 'Galveston',
    county_weights: '{"48167": 100}',
    density: 33.9,
    imprecise: false,
    latitude: 29.31082,
    longitude: -94.77641,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77555',
  },
  {
    city: 'College Station',
    county_fips: 48041,
    county_fips_all: '48041',
    county: 'Brazos',
    county_names_all: 'Brazos',
    county_weights: '{"48041": 100}',
    density: 8635.8,
    imprecise: false,
    latitude: 30.61527,
    longitude: -96.34027,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '77843',
  },
  {
    city: 'Gatesville',
    county_fips: 48099,
    county_fips_all: '48099',
    county: 'Coryell',
    county_names_all: 'Coryell',
    county_weights: '{"48099": 100}',
    density: 3023.6,
    imprecise: false,
    latitude: 31.47626,
    longitude: -97.72696,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1060,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76596',
  },
  {
    city: 'Gatesville',
    county_fips: 48099,
    county_fips_all: '48099',
    county: 'Coryell',
    county_names_all: 'Coryell',
    county_weights: '{"48099": 100}',
    density: 868.7,
    imprecise: false,
    latitude: 31.48446,
    longitude: -97.70983,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3005,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76597',
  },
  {
    city: 'Gatesville',
    county_fips: 48099,
    county_fips_all: '48099',
    county: 'Coryell',
    county_names_all: 'Coryell',
    county_weights: '{"48099": 100}',
    density: 6147,
    imprecise: false,
    latitude: 31.47543,
    longitude: -97.73488,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 491,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76598',
  },
  {
    city: 'Gatesville',
    county_fips: 48099,
    county_fips_all: '48099',
    county: 'Coryell',
    county_names_all: 'Coryell',
    county_weights: '{"48099": 100}',
    density: 994.9,
    imprecise: false,
    latitude: 31.47092,
    longitude: -97.73361,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1980,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76599',
  },
  {
    city: 'San Angelo',
    county_fips: 48451,
    county_fips_all: '48451',
    county: 'Tom Green',
    county_names_all: 'Tom Green',
    county_weights: '{"48451": 100}',
    density: 1540.5,
    imprecise: false,
    latitude: 31.44135,
    longitude: -100.46624,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76909',
  },
  {
    city: 'Canyon',
    county_fips: 48381,
    county_fips_all: '48381',
    county: 'Randall',
    county_names_all: 'Randall',
    county_weights: '{"48381": 100}',
    density: 4611.5,
    imprecise: false,
    latitude: 34.98338,
    longitude: -101.9148,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 310,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79016',
  },
  {
    city: 'Abilene',
    county_fips: 48441,
    county_fips_all: '48441',
    county: 'Taylor',
    county_names_all: 'Taylor',
    county_weights: '{"48441": 100}',
    density: 725.9,
    imprecise: false,
    latitude: 32.46221,
    longitude: -99.71502,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79699',
  },
  {
    city: 'Alpine',
    county_fips: 48043,
    county_fips_all: '48043',
    county: 'Brewster',
    county_names_all: 'Brewster',
    county_weights: '{"48043": 100}',
    density: 1028.5,
    imprecise: false,
    latitude: 30.36316,
    longitude: -103.64934,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79832',
  },
  {
    city: 'Fairbanks',
    county_fips: 2090,
    county_fips_all: '02090',
    county: 'Fairbanks North Star',
    county_names_all: 'Fairbanks North Star',
    county_weights: '{"02090": 100}',
    density: 663.2,
    imprecise: false,
    latitude: 64.85744,
    longitude: -147.83483,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 826,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99775',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.14136,
    longitude: -110.99008,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85709',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.23107,
    longitude: -110.94957,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85721',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 425.6,
    imprecise: false,
    latitude: 32.18189,
    longitude: -110.96496,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 244,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85723',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.24072,
    longitude: -110.94555,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85724',
  },
  {
    city: 'Flagstaff',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 12238.8,
    imprecise: false,
    latitude: 35.18953,
    longitude: -111.65469,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 4019,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86011',
  },
  {
    city: 'Kirtland Afb',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 34.99486,
    longitude: -106.51697,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 26,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87117',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 2026.5,
    imprecise: false,
    latitude: 35.00772,
    longitude: -106.86035,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1261,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87151',
  },
  {
    city: 'Hobbs',
    county_fips: 35025,
    county_fips_all: '35025',
    county: 'Lea',
    county_names_all: 'Lea',
    county_weights: '{"35025": 100}',
    density: 7941.1,
    imprecise: false,
    latitude: 32.76412,
    longitude: -103.22498,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1105,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88244',
  },
  {
    city: 'Santa Clara',
    county_fips: 6085,
    county_fips_all: '06085',
    county: 'Santa Clara',
    county_names_all: 'Santa Clara',
    county_weights: '{"06085": 100}',
    density: 8024.9,
    imprecise: false,
    latitude: 37.34848,
    longitude: -121.93737,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3049,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95053',
  },
  {
    city: 'Chico',
    county_fips: 6007,
    county_fips_all: '06007',
    county: 'Butte',
    county_names_all: 'Butte',
    county_weights: '{"06007": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.72578,
    longitude: -121.85022,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95929',
  },
  {
    city: 'Berkeley',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 3160.4,
    imprecise: false,
    latitude: 37.87185,
    longitude: -122.25226,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5763,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94720',
  },
  {
    city: 'Stockton',
    county_fips: 6077,
    county_fips_all: '06077',
    county: 'San Joaquin',
    county_names_all: 'San Joaquin',
    county_weights: '{"06077": 100}',
    density: 2993.7,
    imprecise: false,
    latitude: 37.98078,
    longitude: -121.31198,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 765,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95211',
  },
  {
    city: 'Represa',
    county_fips: 6067,
    county_fips_all: '06067',
    county: 'Sacramento',
    county_names_all: 'Sacramento',
    county_weights: '{"06067": 100}',
    density: 1158.7,
    imprecise: false,
    latitude: 38.69529,
    longitude: -121.15671,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4432,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95671',
  },
  {
    city: 'Northridge',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 1942.8,
    imprecise: false,
    latitude: 34.2446,
    longitude: -118.52669,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2512,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91330',
  },
  {
    city: 'Woodland Hills',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.18505,
    longitude: -118.57605,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91371',
  },
  {
    city: 'Point Mugu Nawc',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 33.24997,
    longitude: -119.50963,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 99,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93042',
  },
  {
    city: 'Port Hueneme Cbc Base',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 364.8,
    imprecise: false,
    latitude: 34.17001,
    longitude: -119.2026,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 468,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93043',
  },
  {
    city: 'Brandeis',
    county_fips: 6111,
    county_fips_all: '06111',
    county: 'Ventura',
    county_names_all: 'Ventura',
    county_weights: '{"06111": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.24527,
    longitude: -118.69984,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93064',
  },
  {
    city: 'Santa Barbara',
    county_fips: 6083,
    county_fips_all: '06083',
    county: 'Santa Barbara',
    county_names_all: 'Santa Barbara',
    county_weights: '{"06083": 100}',
    density: 3328.9,
    imprecise: false,
    latitude: 34.41719,
    longitude: -119.85111,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5418,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93106',
  },
  {
    city: 'Lemoore',
    county_fips: 6031,
    county_fips_all: '06031',
    county: 'Kings',
    county_names_all: 'Kings',
    county_weights: '{"06031": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 36.31921,
    longitude: -119.93135,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 852,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93246',
  },
  {
    city: 'San Luis Obispo',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 107.6,
    imprecise: false,
    latitude: 35.32117,
    longitude: -120.71889,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93408',
  },
  {
    city: 'San Luis Obispo',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 2852.3,
    imprecise: false,
    latitude: 35.32352,
    longitude: -120.69743,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2952,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93409',
  },
  {
    city: 'Edwards',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 0.3,
    imprecise: false,
    latitude: 34.90993,
    longitude: -117.85007,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 57,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93524',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 520.8,
    imprecise: false,
    latitude: 36.81638,
    longitude: -119.74613,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1179,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93740',
  },
  {
    city: 'Fresno',
    county_fips: 6019,
    county_fips_all: '06019',
    county: 'Fresno',
    county_names_all: 'Fresno',
    county_weights: '{"06019": 100}',
    density: 245.9,
    imprecise: false,
    latitude: 36.76742,
    longitude: -119.79602,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 73,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93741',
  },
  {
    city: 'Pasadena',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 2179,
    imprecise: false,
    latitude: 34.13772,
    longitude: -118.12492,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1000,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '91125',
  },
  {
    city: 'Irvine',
    county_fips: 6059,
    county_fips_all: '06059',
    county: 'Orange',
    county_names_all: 'Orange',
    county_weights: '{"06059": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.65061,
    longitude: -117.85091,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92697',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 6468.4,
    imprecise: false,
    latitude: 34.02158,
    longitude: -118.2856,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5462,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90089',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.07121,
    longitude: -118.44334,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90095',
  },
  {
    city: 'Malibu',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 3064.3,
    imprecise: false,
    latitude: 34.03919,
    longitude: -118.70809,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1856,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90263',
  },
  {
    city: 'La Mirada',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4592.8,
    imprecise: false,
    latitude: 33.90565,
    longitude: -118.01499,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1671,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90639',
  },
  {
    city: 'Carson',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 198.3,
    imprecise: false,
    latitude: 33.86372,
    longitude: -118.25142,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90747',
  },
  {
    city: 'Long Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.78449,
    longitude: -118.12133,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90840',
  },
  {
    city: 'La Jolla',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1529,
    imprecise: false,
    latitude: 32.87544,
    longitude: -117.23621,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92092',
  },
  {
    city: 'La Jolla',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 3112.7,
    imprecise: false,
    latitude: 32.88219,
    longitude: -117.23706,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92093',
  },
  {
    city: 'San Marcos',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.12819,
    longitude: -117.15631,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92096',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.71368,
    longitude: -117.17201,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92132',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1491.4,
    imprecise: false,
    latitude: 32.72512,
    longitude: -117.14541,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 290,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92134',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1854,
    imprecise: false,
    latitude: 32.68254,
    longitude: -117.12307,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92136',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 1470.4,
    imprecise: false,
    latitude: 32.74041,
    longitude: -117.1984,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2038,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92140',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 85.2,
    imprecise: false,
    latitude: 32.86292,
    longitude: -117.14579,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2349,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92145',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 656.5,
    imprecise: false,
    latitude: 32.72478,
    longitude: -117.21895,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92147',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 99.3,
    imprecise: false,
    latitude: 32.67148,
    longitude: -117.16714,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92155',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 127.6,
    imprecise: false,
    latitude: 32.8742,
    longitude: -117.23159,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 29,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92161',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.77498,
    longitude: -117.07424,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92182',
  },
  {
    city: 'Loma Linda',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 1990,
    imprecise: false,
    latitude: 34.05296,
    longitude: -117.2617,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 344,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92350',
  },
  {
    city: 'San Bernardino',
    county_fips: 6071,
    county_fips_all: '06071',
    county: 'San Bernardino',
    county_names_all: 'San Bernardino',
    county_weights: '{"06071": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.10506,
    longitude: -117.28685,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92415',
  },
  {
    city: 'Riverside',
    county_fips: 6065,
    county_fips_all: '06065',
    county: 'Riverside',
    county_names_all: 'Riverside',
    county_weights: '{"06065": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.96794,
    longitude: -117.32731,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92521',
  },
  {
    city: 'Boulder',
    county_fips: 8013,
    county_fips_all: '08013',
    county: 'Boulder',
    county_names_all: 'Boulder',
    county_weights: '{"08013": 100}',
    density: 5447,
    imprecise: false,
    latitude: 40.00465,
    longitude: -105.26254,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 7692,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80310',
  },
  {
    city: 'Golden',
    county_fips: 8059,
    county_fips_all: '08059',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"08059": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.7284,
    longitude: -105.20239,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80419',
  },
  {
    city: 'Limon',
    county_fips: 8073,
    county_fips_all: '08073',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"08073": 100}',
    density: 1489.7,
    imprecise: false,
    latitude: 39.21874,
    longitude: -103.69129,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 945,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80826',
  },
  {
    city: 'Honolulu',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 3130.4,
    imprecise: false,
    latitude: 21.30131,
    longitude: -157.81419,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 573,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96848',
  },
  {
    city: 'Helena',
    county_fips: 30049,
    county_fips_all: '30049',
    county: 'Lewis and Clark',
    county_names_all: 'Lewis and Clark',
    county_weights: '{"30049": 100}',
    density: 0,
    imprecise: false,
    latitude: 46.58991,
    longitude: -112.04068,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59623',
  },
  {
    city: 'Helena',
    county_fips: 30049,
    county_fips_all: '30049',
    county: 'Lewis and Clark',
    county_names_all: 'Lewis and Clark',
    county_weights: '{"30049": 100}',
    density: 2826.7,
    imprecise: false,
    latitude: 46.60135,
    longitude: -112.03891,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 663,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59625',
  },
  {
    city: 'Missoula',
    county_fips: 30063,
    county_fips_all: '30063',
    county: 'Missoula',
    county_names_all: 'Missoula',
    county_weights: '{"30063": 100}',
    density: 2124.9,
    imprecise: false,
    latitude: 46.86121,
    longitude: -113.98442,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1181,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MT',
    stateName: 'Montana',
    zip: '59812',
  },
  {
    city: 'Pocatello',
    county_fips: 16005,
    county_fips_all: '16005',
    county: 'Bannock',
    county_names_all: 'Bannock',
    county_weights: '{"16005": 100}',
    density: 540.1,
    imprecise: false,
    latitude: 42.85782,
    longitude: -112.42619,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 937,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83209',
  },
  {
    city: 'Rexburg',
    county_fips: 16065,
    county_fips_all: '16065',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"16065": 100}',
    density: 75.2,
    imprecise: false,
    latitude: 43.81639,
    longitude: -111.7826,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83460',
  },
  {
    city: 'Boise',
    county_fips: 16001,
    county_fips_all: '16001',
    county: 'Ada',
    county_names_all: 'Ada',
    county_weights: '{"16001": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.61771,
    longitude: -116.19973,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83720',
  },
  {
    city: 'Boise',
    county_fips: 16001,
    county_fips_all: '16001',
    county: 'Ada',
    county_names_all: 'Ada',
    county_weights: '{"16001": 100}',
    density: 0,
    imprecise: false,
    latitude: 43.60484,
    longitude: -116.20569,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83725',
  },
  {
    city: 'Moscow',
    county_fips: 16057,
    county_fips_all: '16057',
    county: 'Latah',
    county_names_all: 'Latah',
    county_weights: '{"16057": 100}',
    density: 1955.6,
    imprecise: false,
    latitude: 46.72823,
    longitude: -117.01946,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2971,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83844',
  },
  {
    city: 'Salem',
    county_fips: 41047,
    county_fips_all: '41047',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"41047": 100}',
    density: 3004.8,
    imprecise: false,
    latitude: 44.90048,
    longitude: -122.97436,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1379,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97310',
  },
  {
    city: 'Salt Lake City',
    county_fips: 49035,
    county_fips_all: '49035',
    county: 'Salt Lake',
    county_names_all: 'Salt Lake',
    county_weights: '{"49035": 100}',
    density: 51.8,
    imprecise: false,
    latitude: 40.77151,
    longitude: -111.89107,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84150',
  },
  {
    city: 'Logan',
    county_fips: 49005,
    county_fips_all: '49005',
    county: 'Cache',
    county_names_all: 'Cache',
    county_weights: '{"49005": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.75822,
    longitude: -111.81256,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84322',
  },
  {
    city: 'Ogden',
    county_fips: 49057,
    county_fips_all: '49057',
    county: 'Weber',
    county_names_all: 'Weber',
    county_weights: '{"49057": 100}',
    density: 185.9,
    imprecise: false,
    latitude: 41.19252,
    longitude: -111.93966,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 237,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84408',
  },
  {
    city: 'Indian Springs',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 75.8,
    imprecise: false,
    latitude: 36.50083,
    longitude: -115.63952,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 5187,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89070',
  },
  {
    city: 'Fallon',
    county_fips: 32001,
    county_fips_all: '32001',
    county: 'Churchill',
    county_names_all: 'Churchill',
    county_weights: '{"32001": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 39.19949,
    longitude: -118.57103,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89496',
  },
  {
    city: 'Reno',
    county_fips: 32031,
    county_fips_all: '32031',
    county: 'Washoe',
    county_names_all: 'Washoe',
    county_weights: '{"32031": 100}',
    density: 1008.9,
    imprecise: false,
    latitude: 39.54247,
    longitude: -119.81584,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 546,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89557',
  },
  {
    city: 'Seattle',
    county_fips: 53033,
    county_fips_all: '53033',
    county: 'King',
    county_names_all: 'King',
    county_weights: '{"53033": 100}',
    density: 2697.8,
    imprecise: false,
    latitude: 47.65466,
    longitude: -122.30752,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 2757,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98195',
  },
  {
    city: 'Everett',
    county_fips: 53061,
    county_fips_all: '53061',
    county: 'Snohomish',
    county_names_all: 'Snohomish',
    county_weights: '{"53061": 100}',
    density: 1290.8,
    imprecise: false,
    latitude: 47.98793,
    longitude: -122.2229,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 843,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98207',
  },
  {
    city: 'Oak Harbor',
    county_fips: 53029,
    county_fips_all: '53029',
    county: 'Island',
    county_names_all: 'Island',
    county_weights: '{"53029": 100}',
    density: 176.7,
    imprecise: false,
    latitude: 48.34388,
    longitude: -122.66491,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1932,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98278',
  },
  {
    city: 'Bremerton',
    county_fips: 53035,
    county_fips_all: '53035',
    county: 'Kitsap',
    county_names_all: 'Kitsap',
    county_weights: '{"53035": 100}',
    density: 3923.4,
    imprecise: false,
    latitude: 47.56243,
    longitude: -122.63893,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98314',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 4084.8,
    imprecise: false,
    latitude: 47.26271,
    longitude: -122.48196,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 934,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98416',
  },
  {
    city: 'Camp Murray',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 575.7,
    imprecise: false,
    latitude: 47.11733,
    longitude: -122.56896,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 582,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98430',
  },
  {
    city: 'Tacoma',
    county_fips: 53053,
    county_fips_all: '53053',
    county: 'Pierce',
    county_names_all: 'Pierce',
    county_weights: '{"53053": 100}',
    density: 3128.1,
    imprecise: false,
    latitude: 47.14531,
    longitude: -122.44392,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 921,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98447',
  },
  {
    city: 'Olympia',
    county_fips: 53067,
    county_fips_all: '53067',
    county: 'Thurston',
    county_names_all: 'Thurston',
    county_weights: '{"53067": 100}',
    density: 1180.5,
    imprecise: false,
    latitude: 47.07321,
    longitude: -122.97358,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 881,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '98505',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 2030.5,
    imprecise: false,
    latitude: 47.75385,
    longitude: -117.41797,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 964,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99251',
  },
  {
    city: 'Spokane',
    county_fips: 53063,
    county_fips_all: '53063',
    county: 'Spokane',
    county_names_all: 'Spokane',
    county_weights: '{"53063": 100}',
    density: 1120.5,
    imprecise: false,
    latitude: 47.66612,
    longitude: -117.40246,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 471,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WA',
    stateName: 'Washington',
    zip: '99258',
  },
  {
    city: 'San Juan',
    county_fips: 72127,
    county_fips_all: '72127',
    county: 'San Juan',
    county_names_all: 'San Juan',
    county_weights: '{"72127": 100}',
    density: 5941.6,
    imprecise: false,
    latitude: 18.46446,
    longitude: -66.09499,
    militaryZip: false,
    timezone: 'America/Puerto_Rico',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PR',
    stateName: 'Puerto Rico',
    zip: '00906',
  },
  {
    city: 'Amherst',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 6486.9,
    imprecise: false,
    latitude: 42.39135,
    longitude: -72.52327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 13510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01003',
  },
  {
    city: 'West Hatfield',
    county_fips: 25015,
    county_fips_all: '25015',
    county: 'Hampshire',
    county_names_all: 'Hampshire',
    county_weights: '{"25015": 100}',
    density: 51.6,
    imprecise: false,
    latitude: 42.38981,
    longitude: -72.6465,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 702,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01088',
  },
  {
    city: 'Springfield',
    county_fips: 25013,
    county_fips_all: '25013',
    county: 'Hampden',
    county_names_all: 'Hampden',
    county_weights: '{"25013": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.10189,
    longitude: -72.59091,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01144',
  },
  {
    city: 'Savoy',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 8.6,
    imprecise: false,
    latitude: 42.59627,
    longitude: -73.01958,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 795,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01256',
  },
  {
    city: 'Drury',
    county_fips: 25003,
    county_fips_all: '25003',
    county: 'Berkshire',
    county_names_all: 'Berkshire',
    county_weights: '{"25003": 100}',
    density: 4.9,
    imprecise: false,
    latitude: 42.66766,
    longitude: -72.98822,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 147,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01343',
  },
  {
    city: 'Monroe Bridge',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 42.72259,
    longitude: -72.98291,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01350',
  },
  {
    city: 'Warwick',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 8,
    imprecise: false,
    latitude: 42.67711,
    longitude: -72.34057,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 776,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01378',
  },
  {
    city: 'Wendell Depot',
    county_fips: 25011,
    county_fips_all: '25011',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"25011": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 42.58675,
    longitude: -72.40264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MA',
    stateName: 'Massachusetts',
    zip: '01380',
  },
  {
    city: 'Clayville',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 41.77723,
    longitude: -71.66177,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02815',
  },
  {
    city: 'Kenyon',
    county_fips: 44009,
    county_fips_all: '44009',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"44009": 100}',
    density: 142.5,
    imprecise: false,
    latitude: 41.45145,
    longitude: -71.62027,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02836',
  },
  {
    city: 'Oakland',
    county_fips: 44007,
    county_fips_all: '44007',
    county: 'Providence',
    county_names_all: 'Providence',
    county_weights: '{"44007": 100}',
    density: 460.9,
    imprecise: false,
    latitude: 41.96354,
    longitude: -71.64893,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 738,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'RI',
    stateName: 'Rhode Island',
    zip: '02858',
  },
  {
    city: 'Bretton Woods',
    county_fips: 33007,
    county_fips_all: '33007',
    county: 'Coos',
    county_names_all: 'Coos',
    county_weights: '{"33007": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 44.28946,
    longitude: -71.41722,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03575',
  },
  {
    city: 'North Walpole',
    county_fips: 33005,
    county_fips_all: '33005',
    county: 'Cheshire',
    county_names_all: 'Cheshire',
    county_weights: '{"33005": 100}',
    density: 224.9,
    imprecise: false,
    latitude: 43.1441,
    longitude: -72.44512,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 523,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NH',
    stateName: 'New Hampshire',
    zip: '03609',
  },
  {
    city: 'Portland',
    county_fips: 23005,
    county_fips_all: '23005',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"23005": 100}',
    density: 66.3,
    imprecise: false,
    latitude: 43.66732,
    longitude: -70.19984,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 213,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04109',
  },
  {
    city: 'Lambert Lake',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 45.5222,
    longitude: -67.52516,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 11,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04454',
  },
  {
    city: 'Shirley Mills',
    county_fips: 23021,
    county_fips_all: '23021',
    county: 'Piscataquis',
    county_names_all: 'Piscataquis',
    county_weights: '{"23021": 100}',
    density: 2.1,
    imprecise: false,
    latitude: 45.362,
    longitude: -69.61562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 234,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04485',
  },
  {
    city: 'Squirrel Island',
    county_fips: 23015,
    county_fips_all: '23015',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"23015": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 43.80844,
    longitude: -69.63088,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04570',
  },
  {
    city: 'Harborside',
    county_fips: 23009,
    county_fips_all: '23009',
    county: 'Hancock',
    county_names_all: 'Hancock',
    county_weights: '{"23009": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 44.33906,
    longitude: -68.79591,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 202,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04642',
  },
  {
    city: 'Wesley',
    county_fips: 23029,
    county_fips_all: '23029',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"23029": 100}',
    density: 1.1,
    imprecise: false,
    latitude: 44.98619,
    longitude: -67.69015,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 328,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04686',
  },
  {
    city: 'Clayton Lake',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 0,
    imprecise: false,
    latitude: 46.61641,
    longitude: -69.52178,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04737',
  },
  {
    city: 'Oxbow',
    county_fips: 23003,
    county_fips_all: '23003',
    county: 'Aroostook',
    county_names_all: 'Aroostook',
    county_weights: '{"23003": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 46.36843,
    longitude: -68.34229,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 88,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04764',
  },
  {
    city: 'Farmington Falls',
    county_fips: 23007,
    county_fips_all: '23007',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"23007": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.62018,
    longitude: -70.07508,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ME',
    stateName: 'Maine',
    zip: '04940',
  },
  {
    city: 'West Hartland',
    county_fips: 9160,
    county_fips_all: '09160',
    county: 'Northwest Hills',
    county_names_all: 'Northwest Hills',
    county_weights: '{"09160": 100}',
    density: 8.8,
    imprecise: false,
    latitude: 42.01419,
    longitude: -72.97423,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 253,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CT',
    stateName: 'Connecticut',
    zip: '06091',
  },
  {
    city: 'Fort Monmouth',
    county_fips: 34025,
    county_fips_all: '34025',
    county: 'Monmouth',
    county_names_all: 'Monmouth',
    county_weights: '{"34025": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.31411,
    longitude: -74.046,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07703',
  },
  {
    city: 'Wallpack Center',
    county_fips: 34037,
    county_fips_all: '34037',
    county: 'Sussex',
    county_names_all: 'Sussex',
    county_weights: '{"34037": 100}',
    density: 0.2,
    imprecise: false,
    latitude: 41.12213,
    longitude: -74.93249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 4,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NJ',
    stateName: 'New Jersey',
    zip: '07881',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.76078,
    longitude: -73.97767,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10103',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.7545,
    longitude: -73.98226,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10110',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.81085,
    longitude: -73.96374,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10115',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 563.5,
    imprecise: false,
    latitude: 40.75872,
    longitude: -73.9718,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 7,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10152',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75778,
    longitude: -73.97249,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10154',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75465,
    longitude: -73.97477,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10167',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.7559,
    longitude: -73.97386,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10171',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75527,
    longitude: -73.97431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10172',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75379,
    longitude: -73.97961,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10173',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75498,
    longitude: -73.97589,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10177',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.75138,
    longitude: -73.99715,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10199',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.70844,
    longitude: -74.01033,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10271',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.71513,
    longitude: -74.00373,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10278',
  },
  {
    city: 'New York',
    county_fips: 36061,
    county_fips_all: '36061',
    county: 'New York',
    county_names_all: 'New York',
    county_weights: '{"36061": 100}',
    density: 23970.4,
    imprecise: false,
    latitude: 40.71263,
    longitude: -74.00867,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 259,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10279',
  },
  {
    city: 'Staten Island',
    county_fips: 36085,
    county_fips_all: '36085',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"36085": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.60523,
    longitude: -74.17956,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '10311',
  },
  {
    city: 'Bayside',
    county_fips: 36081,
    county_fips_all: '36081',
    county: 'Queens',
    county_names_all: 'Queens',
    county_weights: '{"36081": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.79147,
    longitude: -73.77662,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11359',
  },
  {
    city: 'Uniondale',
    county_fips: 36059,
    county_fips_all: '36059',
    county: 'Nassau',
    county_names_all: 'Nassau',
    county_weights: '{"36059": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.71997,
    longitude: -73.58327,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '11556',
  },
  {
    city: 'Albany',
    county_fips: 36001,
    county_fips_all: '36001',
    county: 'Albany',
    county_names_all: 'Albany',
    county_weights: '{"36001": 100}',
    density: 0,
    imprecise: false,
    latitude: 42.67931,
    longitude: -73.80987,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12226',
  },
  {
    city: 'Annandale On Hudson',
    county_fips: 36027,
    county_fips_all: '36027',
    county: 'Dutchess',
    county_names_all: 'Dutchess',
    county_weights: '{"36027": 100}',
    density: 498.3,
    imprecise: false,
    latitude: 42.02342,
    longitude: -73.9094,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 961,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '12504',
  },
  {
    city: 'Rochester',
    county_fips: 36055,
    county_fips_all: '36055',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"36055": 100}',
    density: 6022.2,
    imprecise: false,
    latitude: 43.12931,
    longitude: -77.62912,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3159,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14627',
  },
  {
    city: 'Ithaca',
    county_fips: 36109,
    county_fips_all: '36109',
    county: 'Tompkins',
    county_names_all: 'Tompkins',
    county_weights: '{"36109": 100}',
    density: 2413,
    imprecise: false,
    latitude: 42.44727,
    longitude: -76.48149,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2405,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NY',
    stateName: 'New York',
    zip: '14853',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.4432,
    longitude: -79.95306,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15260',
  },
  {
    city: 'Pittsburgh',
    county_fips: 42003,
    county_fips_all: '42003',
    county: 'Allegheny',
    county_names_all: 'Allegheny',
    county_weights: '{"42003": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.45735,
    longitude: -80.01932,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15290',
  },
  {
    city: 'Jenners',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 203.7,
    imprecise: false,
    latitude: 40.13717,
    longitude: -79.04758,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 437,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15546',
  },
  {
    city: 'Wellersburg',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 61.1,
    imprecise: false,
    latitude: 39.72967,
    longitude: -78.84542,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 86,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15564',
  },
  {
    city: 'West Salisbury',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 11.6,
    imprecise: false,
    latitude: 39.75907,
    longitude: -79.11552,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15565',
  },
  {
    city: 'Josephine',
    county_fips: 42063,
    county_fips_all: '42063',
    county: 'Indiana',
    county_names_all: 'Indiana',
    county_weights: '{"42063": 100}',
    density: 192.6,
    imprecise: false,
    latitude: 40.48377,
    longitude: -79.18256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15750',
  },
  {
    city: 'Spangler',
    county_fips: 42021,
    county_fips_all: '42021',
    county: 'Cambria',
    county_names_all: 'Cambria',
    county_weights: '{"42021": 100}',
    density: 140.6,
    imprecise: false,
    latitude: 40.63488,
    longitude: -78.78405,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 513,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15775',
  },
  {
    city: 'Seanor',
    county_fips: 42111,
    county_fips_all: '42111',
    county: 'Somerset',
    county_names_all: 'Somerset',
    county_weights: '{"42111": 100}',
    density: 35.4,
    imprecise: false,
    latitude: 40.21113,
    longitude: -78.89049,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '15953',
  },
  {
    city: 'Entriken',
    county_fips: 42061,
    county_fips_all: '42061',
    county: 'Huntingdon',
    county_names_all: 'Huntingdon',
    county_weights: '{"42061": 100}',
    density: 24,
    imprecise: false,
    latitude: 40.33809,
    longitude: -78.2012,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 58,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16638',
  },
  {
    city: 'Queen',
    county_fips: 42009,
    county_fips_all: '42009',
    county: 'Bedford',
    county_names_all: 'Bedford',
    county_weights: '{"42009": 100}',
    density: 53.4,
    imprecise: false,
    latitude: 40.25828,
    longitude: -78.50556,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 89,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '16670',
  },
  {
    city: 'New Germantown',
    county_fips: 42099,
    county_fips_all: '42099',
    county: 'Perry',
    county_names_all: 'Perry',
    county_weights: '{"42099": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 40.30061,
    longitude: -77.58928,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 116,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17071',
  },
  {
    city: 'Summerdale',
    county_fips: 42041,
    county_fips_all: '42041',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"42041": 100}',
    density: 527.4,
    imprecise: false,
    latitude: 40.30998,
    longitude: -76.92817,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '17093',
  },
  {
    city: 'Gibson',
    county_fips: 42115,
    county_fips_all: '42115',
    county: 'Susquehanna',
    county_names_all: 'Susquehanna',
    county_weights: '{"42115": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 41.7779,
    longitude: -75.65029,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '18820',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 8988,
    imprecise: false,
    latitude: 39.95987,
    longitude: -75.16083,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 154,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19108',
  },
  {
    city: 'Philadelphia',
    county_fips: 42101,
    county_fips_all: '42101',
    county: 'Philadelphia',
    county_names_all: 'Philadelphia',
    county_weights: '{"42101": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.94958,
    longitude: -75.16387,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19109',
  },
  {
    city: 'Immaculata',
    county_fips: 42029,
    county_fips_all: '42029',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"42029": 100}',
    density: 826.6,
    imprecise: false,
    latitude: 40.02967,
    longitude: -75.56955,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 768,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'PA',
    stateName: 'Pennsylvania',
    zip: '19345',
  },
  {
    city: 'Newark',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.66779,
    longitude: -75.74595,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19716',
  },
  {
    city: 'Winterthur',
    county_fips: 10003,
    county_fips_all: '10003',
    county: 'New Castle',
    county_names_all: 'New Castle',
    county_weights: '{"10003": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.80666,
    longitude: -75.5973,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DE',
    stateName: 'Delaware',
    zip: '19735',
  },
  {
    city: 'Washington',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.88355,
    longitude: -77.02504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20260',
  },
  {
    city: 'Washington Navy Yard',
    county_fips: 11001,
    county_fips_all: '11001',
    county: 'District of Columbia',
    county_names_all: 'District of Columbia',
    county_weights: '{"11001": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.8718,
    longitude: -76.99481,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'DC',
    stateName: 'District of Columbia',
    zip: '20388',
  },
  {
    city: 'Dowell',
    county_fips: 24009,
    county_fips_all: '24009',
    county: 'Calvert',
    county_names_all: 'Calvert',
    county_weights: '{"24009": 100}',
    density: 529.3,
    imprecise: false,
    latitude: 38.33996,
    longitude: -76.45388,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '20629',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.29244,
    longitude: -76.60503,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21233',
  },
  {
    city: 'Baltimore',
    county_fips: 24510,
    county_fips_all: '24510',
    county: 'Baltimore',
    county_names_all: 'Baltimore',
    county_weights: '{"24510": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.29899,
    longitude: -76.58817,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21287',
  },
  {
    city: 'Annapolis',
    county_fips: 24003,
    county_fips_all: '24003',
    county: 'Anne Arundel',
    county_names_all: 'Anne Arundel',
    county_weights: '{"24003": 100}',
    density: 186.8,
    imprecise: false,
    latitude: 39.02996,
    longitude: -76.54971,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 495,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21405',
  },
  {
    city: 'Midland',
    county_fips: 24001,
    county_fips_all: '24001',
    county: 'Allegany',
    county_names_all: 'Allegany',
    county_weights: '{"24001": 100}',
    density: 1461.9,
    imprecise: false,
    latitude: 39.59114,
    longitude: -78.95087,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 84,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21542',
  },
  {
    city: 'Saint James',
    county_fips: 24043,
    county_fips_all: '24043',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"24043": 100}',
    density: 40.2,
    imprecise: false,
    latitude: 39.57123,
    longitude: -77.75981,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 25,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MD',
    stateName: 'Maryland',
    zip: '21781',
  },
  {
    city: 'Arlington',
    county_fips: 51013,
    county_fips_all: '51013',
    county: 'Arlington',
    county_names_all: 'Arlington',
    county_weights: '{"51013": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.87499,
    longitude: -77.06501,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22214',
  },
  {
    city: 'Viewtown',
    county_fips: 51047,
    county_fips_all: '51047',
    county: 'Culpeper',
    county_names_all: 'Culpeper',
    county_weights: '{"51047": 100}',
    density: 71.5,
    imprecise: false,
    latitude: 38.62922,
    longitude: -78.0195,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 539,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22746',
  },
  {
    city: 'Charlottesville',
    county_fips: 51003,
    county_fips_all: '51003|51540',
    county: 'Albemarle',
    county_names_all: 'Albemarle|Charlottesville',
    county_weights: '{"51003": 89.17, "51540": 10.83}',
    density: 8477.4,
    imprecise: false,
    latitude: 38.03492,
    longitude: -78.51161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5729,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22904',
  },
  {
    city: 'Woodberry Forest',
    county_fips: 51113,
    county_fips_all: '51113',
    county: 'Madison',
    county_names_all: 'Madison',
    county_weights: '{"51113": 100}',
    density: 10.9,
    imprecise: false,
    latitude: 38.29328,
    longitude: -78.11943,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '22989',
  },
  {
    city: 'Jamestown',
    county_fips: 51095,
    county_fips_all: '51095',
    county: 'James City',
    county_names_all: 'James City',
    county_weights: '{"51095": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.20758,
    longitude: -76.7617,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23081',
  },
  {
    city: 'State Farm',
    county_fips: 51145,
    county_fips_all: '51145|51075',
    county: 'Powhatan',
    county_names_all: 'Powhatan|Goochland',
    county_weights: '{"51145": 99.71, "51075": 0.29}',
    density: 264.9,
    imprecise: false,
    latitude: 37.62757,
    longitude: -77.84028,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1186,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23160',
  },
  {
    city: 'Richmond',
    county_fips: 51760,
    county_fips_all: '51760',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"51760": 100}',
    density: 7312.1,
    imprecise: false,
    latitude: 37.54759,
    longitude: -77.45273,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2362,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23284',
  },
  {
    city: 'Richmond',
    county_fips: 51760,
    county_fips_all: '51760',
    county: 'Richmond',
    county_names_all: 'Richmond',
    county_weights: '{"51760": 100}',
    density: 339.5,
    imprecise: false,
    latitude: 37.5416,
    longitude: -77.42954,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 98,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23298',
  },
  {
    city: 'Virginia Beach',
    county_fips: 51810,
    county_fips_all: '51810',
    county: 'Virginia Beach',
    county_names_all: 'Virginia Beach',
    county_weights: '{"51810": 100}',
    density: 305,
    imprecise: false,
    latitude: 36.91607,
    longitude: -76.17043,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1324,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23459',
  },
  {
    city: 'Virginia Beach',
    county_fips: 51810,
    county_fips_all: '51810',
    county: 'Virginia Beach',
    county_names_all: 'Virginia Beach',
    county_weights: '{"51810": 100}',
    density: 67.1,
    imprecise: false,
    latitude: 36.81848,
    longitude: -76.03161,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1041,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23460',
  },
  {
    city: 'Virginia Beach',
    county_fips: 51810,
    county_fips_all: '51810',
    county: 'Virginia Beach',
    county_names_all: 'Virginia Beach',
    county_weights: '{"51810": 100}',
    density: 289.5,
    imprecise: false,
    latitude: 36.77244,
    longitude: -75.96172,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 943,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23461',
  },
  {
    city: 'Portsmouth',
    county_fips: 51740,
    county_fips_all: '51740',
    county: 'Portsmouth',
    county_names_all: 'Portsmouth',
    county_weights: '{"51740": 100}',
    density: 600.6,
    imprecise: false,
    latitude: 36.84804,
    longitude: -76.30646,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 269,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23708',
  },
  {
    city: 'Portsmouth',
    county_fips: 51740,
    county_fips_all: '51740',
    county: 'Portsmouth',
    county_names_all: 'Portsmouth',
    county_weights: '{"51740": 100}',
    density: 313.1,
    imprecise: false,
    latitude: 36.81685,
    longitude: -76.29846,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 510,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23709',
  },
  {
    city: 'Hampden Sydney',
    county_fips: 51147,
    county_fips_all: '51147',
    county: 'Prince Edward',
    county_names_all: 'Prince Edward',
    county_weights: '{"51147": 100}',
    density: 1380.6,
    imprecise: false,
    latitude: 37.24181,
    longitude: -78.46041,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1066,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '23943',
  },
  {
    city: 'Radford',
    county_fips: 51750,
    county_fips_all: '51750',
    county: 'Radford',
    county_names_all: 'Radford',
    county_weights: '{"51750": 100}',
    density: 7461.2,
    imprecise: false,
    latitude: 37.13833,
    longitude: -80.55084,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2205,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'VA',
    stateName: 'Virginia',
    zip: '24142',
  },
  {
    city: 'Kyle',
    county_fips: 54047,
    county_fips_all: '54047',
    county: 'McDowell',
    county_names_all: 'McDowell',
    county_weights: '{"54047": 100}',
    density: 314,
    imprecise: false,
    latitude: 37.40882,
    longitude: -81.42499,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 39,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '24855',
  },
  {
    city: 'Page',
    county_fips: 54019,
    county_fips_all: '54019',
    county: 'Fayette',
    county_names_all: 'Fayette',
    county_weights: '{"54019": 100}',
    density: 15.1,
    imprecise: false,
    latitude: 38.0411,
    longitude: -81.24004,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25152',
  },
  {
    city: 'Saxon',
    county_fips: 54081,
    county_fips_all: '54081',
    county: 'Raleigh',
    county_names_all: 'Raleigh',
    county_weights: '{"54081": 100}',
    density: 19.3,
    imprecise: false,
    latitude: 37.78961,
    longitude: -81.43316,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 182,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25180',
  },
  {
    city: 'Southside',
    county_fips: 54053,
    county_fips_all: '54053',
    county: 'Mason',
    county_names_all: 'Mason',
    county_weights: '{"54053": 100}',
    density: 4.8,
    imprecise: false,
    latitude: 38.72617,
    longitude: -82.01878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 497,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25187',
  },
  {
    city: 'Given',
    county_fips: 54035,
    county_fips_all: '54035|54079',
    county: 'Jackson',
    county_names_all: 'Jackson|Putnam',
    county_weights: '{"54035": 84.89, "54079": 15.11}',
    density: 7.9,
    imprecise: false,
    latitude: 38.69916,
    longitude: -81.7393,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 684,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25245',
  },
  {
    city: 'Ravencliff',
    county_fips: 54109,
    county_fips_all: '54109',
    county: 'Wyoming',
    county_names_all: 'Wyoming',
    county_weights: '{"54109": 100}',
    density: 26.5,
    imprecise: false,
    latitude: 37.70781,
    longitude: -81.47301,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 137,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WV',
    stateName: 'West Virginia',
    zip: '25913',
  },
  {
    city: 'Winston Salem',
    county_fips: 37067,
    county_fips_all: '37067',
    county: 'Forsyth',
    county_names_all: 'Forsyth',
    county_weights: '{"37067": 100}',
    density: 3581.1,
    imprecise: false,
    latitude: 36.13371,
    longitude: -80.27539,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2823,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27109',
  },
  {
    city: 'Goldsboro',
    county_fips: 37191,
    county_fips_all: '37191',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"37191": 100}',
    density: 61.6,
    imprecise: false,
    latitude: 35.34362,
    longitude: -77.96743,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 555,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '27531',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.2246,
    longitude: -80.8431,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28244',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.22633,
    longitude: -80.84309,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28280',
  },
  {
    city: 'Charlotte',
    county_fips: 37119,
    county_fips_all: '37119',
    county: 'Mecklenburg',
    county_names_all: 'Mecklenburg',
    county_weights: '{"37119": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.22481,
    longitude: -80.84529,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28282',
  },
  {
    city: 'Pope Army Airfield',
    county_fips: 37051,
    county_fips_all: '37051',
    county: 'Cumberland',
    county_names_all: 'Cumberland',
    county_weights: '{"37051": 100}',
    density: 45.7,
    imprecise: false,
    latitude: 35.17206,
    longitude: -79.0149,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28308',
  },
  {
    city: 'Cherry Point',
    county_fips: 37049,
    county_fips_all: '37049',
    county: 'Craven',
    county_names_all: 'Craven',
    county_weights: '{"37049": 100}',
    density: 1354.3,
    imprecise: false,
    latitude: 34.90167,
    longitude: -76.89955,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2452,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28533',
  },
  {
    city: 'Camp Lejeune',
    county_fips: 37133,
    county_fips_all: '37133',
    county: 'Onslow',
    county_names_all: 'Onslow',
    county_weights: '{"37133": 100}',
    density: 850.6,
    imprecise: false,
    latitude: 34.72992,
    longitude: -77.46198,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 3508,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NC',
    stateName: 'North Carolina',
    zip: '28542',
  },
  {
    city: 'Lando',
    county_fips: 45023,
    county_fips_all: '45023',
    county: 'Chester',
    county_names_all: 'Chester',
    county_weights: '{"45023": 100}',
    density: 0,
    imprecise: false,
    latitude: 34.77503,
    longitude: -81.01248,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29724',
  },
  {
    city: 'Scotia',
    county_fips: 45049,
    county_fips_all: '45049',
    county: 'Hampton',
    county_names_all: 'Hampton',
    county_weights: '{"45049": 100}',
    density: 9.2,
    imprecise: false,
    latitude: 32.68127,
    longitude: -81.24538,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'SC',
    stateName: 'South Carolina',
    zip: '29939',
  },
  {
    city: 'Marietta',
    county_fips: 13067,
    county_fips_all: '13067',
    county: 'Cobb',
    county_names_all: 'Cobb',
    county_weights: '{"13067": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.953,
    longitude: -84.54837,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30090',
  },
  {
    city: 'Mount Berry',
    county_fips: 13115,
    county_fips_all: '13115',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"13115": 100}',
    density: 102.4,
    imprecise: false,
    latitude: 34.31107,
    longitude: -85.21691,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 1781,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30149',
  },
  {
    city: 'Atlanta',
    county_fips: 13121,
    county_fips_all: '13121',
    county: 'Fulton',
    county_names_all: 'Fulton',
    county_weights: '{"13121": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.74855,
    longitude: -84.38804,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30334',
  },
  {
    city: 'Toccoa Falls',
    county_fips: 13257,
    county_fips_all: '13257',
    county: 'Stephens',
    county_names_all: 'Stephens',
    county_weights: '{"13257": 100}',
    density: 432.1,
    imprecise: false,
    latitude: 34.59663,
    longitude: -83.35411,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 66,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '30598',
  },
  {
    city: 'Fort Stewart',
    county_fips: 13179,
    county_fips_all: '13179',
    county: 'Liberty',
    county_names_all: 'Liberty',
    county_weights: '{"13179": 100}',
    density: 17.1,
    imprecise: false,
    latitude: 31.90628,
    longitude: -81.61671,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2122,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31314',
  },
  {
    city: 'Savannah',
    county_fips: 13051,
    county_fips_all: '13051',
    county: 'Chatham',
    county_names_all: 'Chatham',
    county_weights: '{"13051": 100}',
    density: 4,
    imprecise: false,
    latitude: 32.08712,
    longitude: -81.08016,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'GA',
    stateName: 'Georgia',
    zip: '31421',
  },
  {
    city: 'Mexico Beach',
    county_fips: 12005,
    county_fips_all: '12005',
    county: 'Bay',
    county_names_all: 'Bay',
    county_weights: '{"12005": 100}',
    density: 136.1,
    imprecise: false,
    latitude: 29.94805,
    longitude: -85.41812,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 550,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'FL',
    stateName: 'Florida',
    zip: '32410',
  },
  {
    city: 'Cook Springs',
    county_fips: 1115,
    county_fips_all: '01115',
    county: 'St. Clair',
    county_names_all: 'St. Clair',
    county_weights: '{"01115": 100}',
    density: 220.5,
    imprecise: false,
    latitude: 33.59228,
    longitude: -86.40771,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 191,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35052',
  },
  {
    city: 'Echola',
    county_fips: 1125,
    county_fips_all: '01125',
    county: 'Tuscaloosa',
    county_names_all: 'Tuscaloosa',
    county_weights: '{"01125": 100}',
    density: 2.8,
    imprecise: false,
    latitude: 33.29891,
    longitude: -87.77229,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35457',
  },
  {
    city: 'Hollytree',
    county_fips: 1071,
    county_fips_all: '01071',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"01071": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 34.81066,
    longitude: -86.27931,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 215,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '35751',
  },
  {
    city: 'Hardaway',
    county_fips: 1087,
    county_fips_all: '01087',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"01087": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 32.28939,
    longitude: -85.82789,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 171,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36039',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 91.2,
    imprecise: false,
    latitude: 32.38343,
    longitude: -86.36,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 633,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36112',
  },
  {
    city: 'Montgomery',
    county_fips: 1101,
    county_fips_all: '01101',
    county: 'Montgomery',
    county_names_all: 'Montgomery',
    county_weights: '{"01101": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.40484,
    longitude: -86.24568,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36114',
  },
  {
    city: 'Atmore',
    county_fips: 1053,
    county_fips_all: '01053',
    county: 'Escambia',
    county_names_all: 'Escambia',
    county_weights: '{"01053": 100}',
    density: 11424.8,
    imprecise: false,
    latitude: 31.15674,
    longitude: -87.4654,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1002,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36503',
  },
  {
    city: 'Safford',
    county_fips: 1047,
    county_fips_all: '01047|01091',
    county: 'Dallas',
    county_names_all: 'Dallas|Marengo',
    county_weights: '{"01047": 89.41, "01091": 10.59}',
    density: 2.4,
    imprecise: false,
    latitude: 32.28252,
    longitude: -87.38607,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 427,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AL',
    stateName: 'Alabama',
    zip: '36773',
  },
  {
    city: 'Nashville',
    county_fips: 47037,
    county_fips_all: '47037',
    county: 'Davidson',
    county_names_all: 'Davidson',
    county_weights: '{"47037": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.1411,
    longitude: -86.8029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37232',
  },
  {
    city: 'Johnson City',
    county_fips: 47179,
    county_fips_all: '47179',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"47179": 100}',
    density: 2165.5,
    imprecise: false,
    latitude: 36.30097,
    longitude: -82.36741,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 2767,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37614',
  },
  {
    city: 'Rugby',
    county_fips: 47129,
    county_fips_all: '47129|47151',
    county: 'Morgan',
    county_names_all: 'Morgan|Scott',
    county_weights: '{"47129": 99.75, "47151": 0.25}',
    density: 0,
    imprecise: false,
    latitude: 36.35676,
    longitude: -84.69497,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37733',
  },
  {
    city: 'Pruden',
    county_fips: 47025,
    county_fips_all: '47025',
    county: 'Claiborne',
    county_names_all: 'Claiborne',
    county_weights: '{"47025": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.56558,
    longitude: -83.79244,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '37851',
  },
  {
    city: 'Samburg',
    county_fips: 47131,
    county_fips_all: '47131',
    county: 'Obion',
    county_names_all: 'Obion',
    county_weights: '{"47131": 100}',
    density: 0,
    imprecise: false,
    latitude: 36.37444,
    longitude: -89.34662,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TN',
    stateName: 'Tennessee',
    zip: '38254',
  },
  {
    city: 'Oxford',
    county_fips: 28071,
    county_fips_all: '28071',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"28071": 100}',
    density: 1759.4,
    imprecise: false,
    latitude: 34.36402,
    longitude: -89.53859,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 5395,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38677',
  },
  {
    city: 'Cleveland',
    county_fips: 28011,
    county_fips_all: '28011',
    county: 'Bolivar',
    county_names_all: 'Bolivar',
    county_weights: '{"28011": 100}',
    density: 212.6,
    imprecise: false,
    latitude: 33.74463,
    longitude: -90.73504,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 33,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38733',
  },
  {
    city: 'Banner',
    county_fips: 28013,
    county_fips_all: '28013|28071',
    county: 'Calhoun',
    county_names_all: 'Calhoun|Lafayette',
    county_weights: '{"28013": 97.5, "28071": 2.5}',
    density: 8.6,
    imprecise: false,
    latitude: 34.13774,
    longitude: -89.37836,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 509,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38913',
  },
  {
    city: 'Paris',
    county_fips: 28071,
    county_fips_all: '28071',
    county: 'Lafayette',
    county_names_all: 'Lafayette',
    county_weights: '{"28071": 100}',
    density: 9.8,
    imprecise: false,
    latitude: 34.18542,
    longitude: -89.4151,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 287,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MS',
    stateName: 'Mississippi',
    zip: '38949',
  },
  {
    city: 'Masonic Home',
    county_fips: 21111,
    county_fips_all: '21111',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"21111": 100}',
    density: 1674.6,
    imprecise: false,
    latitude: 38.25615,
    longitude: -85.66475,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 564,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40041',
  },
  {
    city: 'Nerinx',
    county_fips: 21155,
    county_fips_all: '21155',
    county: 'Marion',
    county_names_all: 'Marion',
    county_weights: '{"21155": 100}',
    density: 130.7,
    imprecise: false,
    latitude: 37.66442,
    longitude: -85.39724,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 108,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40049',
  },
  {
    city: 'Saint Catharine',
    county_fips: 21229,
    county_fips_all: '21229',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"21229": 100}',
    density: 529.1,
    imprecise: false,
    latitude: 37.70954,
    longitude: -85.26353,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 168,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40061',
  },
  {
    city: 'Union Star',
    county_fips: 21027,
    county_fips_all: '21027|21163',
    county: 'Breckinridge',
    county_names_all: 'Breckinridge|Meade',
    county_weights: '{"21027": 99.69, "21163": 0.31}',
    density: 5.2,
    imprecise: false,
    latitude: 37.96435,
    longitude: -86.43577,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 272,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40171',
  },
  {
    city: 'Chappell',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.00879,
    longitude: -83.3667,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40816',
  },
  {
    city: 'Coalgood',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 13.1,
    imprecise: false,
    latitude: 36.82003,
    longitude: -83.2442,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 148,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40818',
  },
  {
    city: 'Gulston',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 328.3,
    imprecise: false,
    latitude: 36.77644,
    longitude: -83.33114,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 312,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40830',
  },
  {
    city: 'Hulen',
    county_fips: 21013,
    county_fips_all: '21013',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"21013": 100}',
    density: 25.8,
    imprecise: false,
    latitude: 36.79899,
    longitude: -83.51755,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 580,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40845',
  },
  {
    city: 'Mozelle',
    county_fips: 21131,
    county_fips_all: '21131',
    county: 'Leslie',
    county_names_all: 'Leslie',
    county_weights: '{"21131": 100}',
    density: 10.5,
    imprecise: false,
    latitude: 37.01592,
    longitude: -83.40106,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 211,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40858',
  },
  {
    city: 'Green Road',
    county_fips: 21121,
    county_fips_all: '21121',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"21121": 100}',
    density: 6.7,
    imprecise: false,
    latitude: 36.95757,
    longitude: -83.82467,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40946',
  },
  {
    city: 'Hinkle',
    county_fips: 21121,
    county_fips_all: '21121',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"21121": 100}',
    density: 17.7,
    imprecise: false,
    latitude: 36.93771,
    longitude: -83.80163,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40953',
  },
  {
    city: 'Kettle Island',
    county_fips: 21013,
    county_fips_all: '21013',
    county: 'Bell',
    county_names_all: 'Bell',
    county_weights: '{"21013": 100}',
    density: 22.9,
    imprecise: false,
    latitude: 36.8088,
    longitude: -83.5878,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40958',
  },
  {
    city: 'Mary Alice',
    county_fips: 21095,
    county_fips_all: '21095',
    county: 'Harlan',
    county_names_all: 'Harlan',
    county_weights: '{"21095": 100}',
    density: 75.1,
    imprecise: false,
    latitude: 36.78264,
    longitude: -83.33763,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 101,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40964',
  },
  {
    city: 'Walker',
    county_fips: 21121,
    county_fips_all: '21121',
    county: 'Knox',
    county_names_all: 'Knox',
    county_weights: '{"21121": 100}',
    density: 6.1,
    imprecise: false,
    latitude: 36.88348,
    longitude: -83.67711,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 404,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '40997',
  },
  {
    city: 'Keaton',
    county_fips: 21115,
    county_fips_all: '21115|21127',
    county: 'Johnson',
    county_names_all: 'Johnson|Lawrence',
    county_weights: '{"21115": 99.73, "21127": 0.27}',
    density: 24.8,
    imprecise: false,
    latitude: 37.97853,
    longitude: -82.9562,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 398,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41226',
  },
  {
    city: 'Fords Branch',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.43372,
    longitude: -82.51256,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41526',
  },
  {
    city: 'Shelby Gap',
    county_fips: 21195,
    county_fips_all: '21195',
    county: 'Pike',
    county_names_all: 'Pike',
    county_weights: '{"21195": 100}',
    density: 24.4,
    imprecise: false,
    latitude: 37.22628,
    longitude: -82.53694,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 453,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41563',
  },
  {
    city: 'Bypro',
    county_fips: 21071,
    county_fips_all: '21071',
    county: 'Floyd',
    county_names_all: 'Floyd',
    county_weights: '{"21071": 100}',
    density: 70.9,
    imprecise: false,
    latitude: 37.35451,
    longitude: -82.72233,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 71,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41612',
  },
  {
    city: 'Dema',
    county_fips: 21119,
    county_fips_all: '21119|21071',
    county: 'Knott',
    county_names_all: 'Knott|Floyd',
    county_weights: '{"21119": 99.8, "21071": 0.2}',
    density: 13,
    imprecise: false,
    latitude: 37.39922,
    longitude: -82.77606,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 240,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41859',
  },
  {
    city: 'Raven',
    county_fips: 21119,
    county_fips_all: '21119',
    county: 'Knott',
    county_names_all: 'Knott',
    county_weights: '{"21119": 100}',
    density: 6.6,
    imprecise: false,
    latitude: 37.39002,
    longitude: -82.8264,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '41861',
  },
  {
    city: 'Beaumont',
    county_fips: 21169,
    county_fips_all: '21169',
    county: 'Metcalfe',
    county_names_all: 'Metcalfe',
    county_weights: '{"21169": 100}',
    density: 5.5,
    imprecise: false,
    latitude: 36.86534,
    longitude: -85.64817,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42124',
  },
  {
    city: 'Eighty Eight',
    county_fips: 21009,
    county_fips_all: '21009',
    county: 'Barren',
    county_names_all: 'Barren',
    county_weights: '{"21009": 100}',
    density: 15.5,
    imprecise: false,
    latitude: 36.9224,
    longitude: -85.77816,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42130',
  },
  {
    city: 'Hestand',
    county_fips: 21171,
    county_fips_all: '21171',
    county: 'Monroe',
    county_names_all: 'Monroe',
    county_weights: '{"21171": 100}',
    density: 2.7,
    imprecise: false,
    latitude: 36.64848,
    longitude: -85.56058,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42151',
  },
  {
    city: 'Olaton',
    county_fips: 21183,
    county_fips_all: '21183|21085',
    county: 'Ohio',
    county_names_all: 'Ohio|Grayson',
    county_weights: '{"21183": 69.27, "21085": 30.73}',
    density: 4.3,
    imprecise: false,
    latitude: 37.51791,
    longitude: -86.69183,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 425,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42361',
  },
  {
    city: 'Bethelridge',
    county_fips: 21045,
    county_fips_all: '21045',
    county: 'Casey',
    county_names_all: 'Casey',
    county_weights: '{"21045": 100}',
    density: 16.6,
    imprecise: false,
    latitude: 37.22247,
    longitude: -84.77881,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 540,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42516',
  },
  {
    city: 'Windsor',
    county_fips: 21045,
    county_fips_all: '21045|21207',
    county: 'Casey',
    county_names_all: 'Casey|Russell',
    county_weights: '{"21045": 99.3, "21207": 0.7}',
    density: 12.3,
    imprecise: false,
    latitude: 37.15008,
    longitude: -84.90086,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 758,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42565',
  },
  {
    city: 'Glens Fork',
    county_fips: 21001,
    county_fips_all: '21001|21207',
    county: 'Adair',
    county_names_all: 'Adair|Russell',
    county_weights: '{"21001": 98.33, "21207": 1.67}',
    density: 12.7,
    imprecise: false,
    latitude: 36.9888,
    longitude: -85.25183,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 420,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42741',
  },
  {
    city: 'Gradyville',
    county_fips: 21001,
    county_fips_all: '21001',
    county: 'Adair',
    county_names_all: 'Adair',
    county_weights: '{"21001": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 37.07774,
    longitude: -85.47888,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KY',
    stateName: 'Kentucky',
    zip: '42742',
  },
  {
    city: 'Homer',
    county_fips: 39089,
    county_fips_all: '39089',
    county: 'Licking',
    county_names_all: 'Licking',
    county_weights: '{"39089": 100}',
    density: 668.6,
    imprecise: false,
    latitude: 40.25375,
    longitude: -82.52253,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 185,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43027',
  },
  {
    city: 'Fairview',
    county_fips: 39059,
    county_fips_all: '39059',
    county: 'Guernsey',
    county_names_all: 'Guernsey',
    county_weights: '{"39059": 100}',
    density: 131.5,
    imprecise: false,
    latitude: 40.05755,
    longitude: -81.23689,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 14,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43736',
  },
  {
    city: 'Fultonham',
    county_fips: 39119,
    county_fips_all: '39119',
    county: 'Muskingum',
    county_names_all: 'Muskingum',
    county_weights: '{"39119": 100}',
    density: 655.5,
    imprecise: false,
    latitude: 39.8554,
    longitude: -82.14063,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 106,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '43738',
  },
  {
    city: 'Kent',
    county_fips: 39133,
    county_fips_all: '39133',
    county: 'Portage',
    county_names_all: 'Portage',
    county_weights: '{"39133": 100}',
    density: 4638.7,
    imprecise: false,
    latitude: 41.14793,
    longitude: -81.34046,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 5082,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '44243',
  },
  {
    city: 'Mount Saint Joseph',
    county_fips: 39061,
    county_fips_all: '39061',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"39061": 100}',
    density: 284.1,
    imprecise: false,
    latitude: 39.09983,
    longitude: -84.65504,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 334,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45051',
  },
  {
    city: 'Coal Run',
    county_fips: 39167,
    county_fips_all: '39167',
    county: 'Washington',
    county_names_all: 'Washington',
    county_weights: '{"39167": 100}',
    density: 187.1,
    imprecise: false,
    latitude: 39.56563,
    longitude: -81.58347,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 15,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45721',
  },
  {
    city: 'Elgin',
    county_fips: 39161,
    county_fips_all: '39161',
    county: 'Van Wert',
    county_names_all: 'Van Wert',
    county_weights: '{"39161": 100}',
    density: 352.6,
    imprecise: false,
    latitude: 40.74041,
    longitude: -84.47781,
    militaryZip: false,
    timezone: 'America/New_York',
    population: 72,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OH',
    stateName: 'Ohio',
    zip: '45838',
  },
  {
    city: 'Grissom Arb',
    county_fips: 18103,
    county_fips_all: '18103',
    county: 'Miami',
    county_names_all: 'Miami',
    county_weights: '{"18103": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.6606,
    longitude: -86.16168,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '46971',
  },
  {
    city: 'Bethlehem',
    county_fips: 18019,
    county_fips_all: '18019',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"18019": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 38.54568,
    longitude: -85.43665,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47104',
  },
  {
    city: 'New Middletown',
    county_fips: 18061,
    county_fips_all: '18061',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"18061": 100}',
    density: 50.4,
    imprecise: false,
    latitude: 38.14817,
    longitude: -86.04711,
    militaryZip: false,
    timezone: 'America/Kentucky/Louisville',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47160',
  },
  {
    city: 'Somerville',
    county_fips: 18051,
    county_fips_all: '18051',
    county: 'Gibson',
    county_names_all: 'Gibson',
    county_weights: '{"18051": 100}',
    density: 284.7,
    imprecise: false,
    latitude: 38.27696,
    longitude: -87.37744,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 53,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47683',
  },
  {
    city: 'Paxton',
    county_fips: 18153,
    county_fips_all: '18153',
    county: 'Sullivan',
    county_names_all: 'Sullivan',
    county_weights: '{"18153": 100}',
    density: 20.7,
    imprecise: false,
    latitude: 39.01908,
    longitude: -87.39259,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 3,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47865',
  },
  {
    city: 'West Lafayette',
    county_fips: 18157,
    county_fips_all: '18157',
    county: 'Tippecanoe',
    county_names_all: 'Tippecanoe',
    county_weights: '{"18157": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.42474,
    longitude: -86.91665,
    militaryZip: false,
    timezone: 'America/Indiana/Indianapolis',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IN',
    stateName: 'Indiana',
    zip: '47907',
  },
  {
    city: 'Detroit',
    county_fips: 26163,
    county_fips_all: '26163',
    county: 'Wayne',
    county_names_all: 'Wayne',
    county_weights: '{"26163": 100}',
    density: 721.9,
    imprecise: false,
    latitude: 42.32324,
    longitude: -83.06303,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 63,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '48233',
  },
  {
    city: 'Rumely',
    county_fips: 26003,
    county_fips_all: '26003',
    county: 'Alger',
    county_names_all: 'Alger',
    county_weights: '{"26003": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 46.32316,
    longitude: -87.04567,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 214,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49826',
  },
  {
    city: 'Kearsarge',
    county_fips: 26061,
    county_fips_all: '26061',
    county: 'Houghton',
    county_names_all: 'Houghton',
    county_weights: '{"26061": 100}',
    density: 38.8,
    imprecise: false,
    latitude: 47.26179,
    longitude: -88.4175,
    militaryZip: false,
    timezone: 'America/Detroit',
    population: 55,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MI',
    stateName: 'Michigan',
    zip: '49942',
  },
  {
    city: 'Des Moines',
    county_fips: 19153,
    county_fips_all: '19153',
    county: 'Polk',
    county_names_all: 'Polk',
    county_weights: '{"19153": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.59115,
    longitude: -93.60314,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50319',
  },
  {
    city: 'Burnside',
    county_fips: 19187,
    county_fips_all: '19187',
    county: 'Webster',
    county_names_all: 'Webster',
    county_weights: '{"19187": 100}',
    density: 14.2,
    imprecise: false,
    latitude: 42.3462,
    longitude: -94.10276,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50521',
  },
  {
    city: 'Knierim',
    county_fips: 19025,
    county_fips_all: '19025',
    county: 'Calhoun',
    county_names_all: 'Calhoun',
    county_weights: '{"19025": 100}',
    density: 58.7,
    imprecise: false,
    latitude: 42.45638,
    longitude: -94.46068,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 76,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '50552',
  },
  {
    city: 'Aspinwall',
    county_fips: 19047,
    county_fips_all: '19047',
    county: 'Crawford',
    county_names_all: 'Crawford',
    county_weights: '{"19047": 100}',
    density: 55.4,
    imprecise: false,
    latitude: 41.91009,
    longitude: -95.13795,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 45,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51432',
  },
  {
    city: 'Magnolia',
    county_fips: 19085,
    county_fips_all: '19085',
    county: 'Harrison',
    county_names_all: 'Harrison',
    county_weights: '{"19085": 100}',
    density: 120.4,
    imprecise: false,
    latitude: 41.69203,
    longitude: -95.87399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 169,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '51550',
  },
  {
    city: 'Iowa City',
    county_fips: 19103,
    county_fips_all: '19103',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"19103": 100}',
    density: 2529.1,
    imprecise: false,
    latitude: 41.66195,
    longitude: -91.54317,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 4688,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52242',
  },
  {
    city: 'Fairfield',
    county_fips: 19101,
    county_fips_all: '19101',
    county: 'Jefferson',
    county_names_all: 'Jefferson',
    county_weights: '{"19101": 100}',
    density: 989.7,
    imprecise: false,
    latitude: 41.02026,
    longitude: -91.96653,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 685,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IA',
    stateName: 'Iowa',
    zip: '52557',
  },
  {
    city: 'Duluth',
    county_fips: 27137,
    county_fips_all: '27137',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"27137": 100}',
    density: 1578,
    imprecise: false,
    latitude: 46.83519,
    longitude: -92.19716,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 319,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '55814',
  },
  {
    city: 'Ihlen',
    county_fips: 27117,
    county_fips_all: '27117',
    county: 'Pipestone',
    county_names_all: 'Pipestone',
    county_weights: '{"27117": 100}',
    density: 330.2,
    imprecise: false,
    latitude: 43.90959,
    longitude: -96.36703,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 81,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56140',
  },
  {
    city: 'Moorhead',
    county_fips: 27027,
    county_fips_all: '27027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"27027": 100}',
    density: 2971.8,
    imprecise: false,
    latitude: 46.86458,
    longitude: -96.77021,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 528,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56562',
  },
  {
    city: 'Moorhead',
    county_fips: 27027,
    county_fips_all: '27027',
    county: 'Clay',
    county_names_all: 'Clay',
    county_weights: '{"27027": 100}',
    density: 3195.5,
    imprecise: false,
    latitude: 46.8668,
    longitude: -96.75522,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1285,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MN',
    stateName: 'Minnesota',
    zip: '56563',
  },
  {
    city: 'Grand Forks',
    county_fips: 38035,
    county_fips_all: '38035',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks',
    county_weights: '{"38035": 100}',
    density: 2559.3,
    imprecise: false,
    latitude: 47.92224,
    longitude: -97.07435,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2865,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58202',
  },
  {
    city: 'Grand Forks Afb',
    county_fips: 38035,
    county_fips_all: '38035',
    county: 'Grand Forks',
    county_names_all: 'Grand Forks',
    county_weights: '{"38035": 100}',
    density: 9.4,
    imprecise: false,
    latitude: 47.95475,
    longitude: -97.39525,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 153,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58205',
  },
  {
    city: 'Bismarck',
    county_fips: 38015,
    county_fips_all: '38015',
    county: 'Burleigh',
    county_names_all: 'Burleigh',
    county_weights: '{"38015": 100}',
    density: 39.7,
    imprecise: false,
    latitude: 46.82035,
    longitude: -100.78106,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58505',
  },
  {
    city: 'Minot Afb',
    county_fips: 38101,
    county_fips_all: '38101',
    county: 'Ward',
    county_names_all: 'Ward',
    county_weights: '{"38101": 100}',
    density: 40.2,
    imprecise: false,
    latitude: 48.41608,
    longitude: -101.35182,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 262,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ND',
    stateName: 'North Dakota',
    zip: '58705',
  },
  {
    city: 'Wrights',
    county_fips: 17061,
    county_fips_all: '17061',
    county: 'Greene',
    county_names_all: 'Greene',
    county_weights: '{"17061": 100}',
    density: 7.6,
    imprecise: false,
    latitude: 39.38377,
    longitude: -90.29946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 104,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62098',
  },
  {
    city: 'Dale',
    county_fips: 17065,
    county_fips_all: '17065',
    county: 'Hamilton',
    county_names_all: 'Hamilton',
    county_weights: '{"17065": 100}',
    density: 8.7,
    imprecise: false,
    latitude: 37.99956,
    longitude: -88.49061,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 22,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'IL',
    stateName: 'Illinois',
    zip: '62829',
  },
  {
    city: 'Earth City',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.76863,
    longitude: -90.46556,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63045',
  },
  {
    city: 'Luebbering',
    county_fips: 29071,
    county_fips_all: '29071',
    county: 'Franklin',
    county_names_all: 'Franklin',
    county_weights: '{"29071": 100}',
    density: 19.9,
    imprecise: false,
    latitude: 38.2679,
    longitude: -90.81053,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 216,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63061',
  },
  {
    city: 'Saint Louis',
    county_fips: 29189,
    county_fips_all: '29189',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29189": 100}',
    density: 232,
    imprecise: false,
    latitude: 38.73929,
    longitude: -90.32399,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 316,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63140',
  },
  {
    city: 'Saint Louis',
    county_fips: 29510,
    county_fips_all: '29510',
    county: 'St. Louis',
    county_names_all: 'St. Louis',
    county_weights: '{"29510": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.62788,
    longitude: -90.20545,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63155',
  },
  {
    city: 'Anabel',
    county_fips: 29121,
    county_fips_all: '29121',
    county: 'Macon',
    county_names_all: 'Macon',
    county_weights: '{"29121": 100}',
    density: 4.4,
    imprecise: false,
    latitude: 39.74887,
    longitude: -92.32893,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 547,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63431',
  },
  {
    city: 'Commerce',
    county_fips: 29201,
    county_fips_all: '29201',
    county: 'Scott',
    county_names_all: 'Scott',
    county_weights: '{"29201": 100}',
    density: 71.4,
    imprecise: false,
    latitude: 37.1583,
    longitude: -89.44672,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 64,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63742',
  },
  {
    city: 'Dutchtown',
    county_fips: 29031,
    county_fips_all: '29031',
    county: 'Cape Girardeau',
    county_names_all: 'Cape Girardeau',
    county_weights: '{"29031": 100}',
    density: 161.1,
    imprecise: false,
    latitude: 37.25596,
    longitude: -89.65946,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 136,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '63745',
  },
  {
    city: 'Kansas City',
    county_fips: 29095,
    county_fips_all: '29095',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"29095": 100}',
    density: 192.4,
    imprecise: false,
    latitude: 39.10355,
    longitude: -94.60051,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 203,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64101',
  },
  {
    city: 'Lock Springs',
    county_fips: 29061,
    county_fips_all: '29061',
    county: 'Daviess',
    county_names_all: 'Daviess',
    county_weights: '{"29061": 100}',
    density: 195.4,
    imprecise: false,
    latitude: 39.84864,
    longitude: -93.77552,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 49,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '64654',
  },
  {
    city: 'Butterfield',
    county_fips: 29009,
    county_fips_all: '29009',
    county: 'Barry',
    county_names_all: 'Barry',
    county_weights: '{"29009": 100}',
    density: 546.2,
    imprecise: false,
    latitude: 36.7489,
    longitude: -93.90659,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'MO',
    stateName: 'Missouri',
    zip: '65623',
  },
  {
    city: 'Overland Park',
    county_fips: 20091,
    county_fips_all: '20091',
    county: 'Johnson',
    county_names_all: 'Johnson',
    county_weights: '{"20091": 100}',
    density: 15.6,
    imprecise: false,
    latitude: 38.91712,
    longitude: -94.65891,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 8,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66251',
  },
  {
    city: 'Manhattan',
    county_fips: 20161,
    county_fips_all: '20161',
    county: 'Riley',
    county_names_all: 'Riley',
    county_weights: '{"20161": 100}',
    density: 1721.6,
    imprecise: false,
    latitude: 39.19596,
    longitude: -96.58148,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 3155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66506',
  },
  {
    city: 'Topeka',
    county_fips: 20177,
    county_fips_all: '20177',
    county: 'Shawnee',
    county_names_all: 'Shawnee',
    county_weights: '{"20177": 100}',
    density: 845.6,
    imprecise: false,
    latitude: 39.03313,
    longitude: -95.70237,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 442,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66621',
  },
  {
    city: 'Treece',
    county_fips: 20021,
    county_fips_all: '20021',
    county: 'Cherokee',
    county_names_all: 'Cherokee',
    county_weights: '{"20021": 100}',
    density: 0,
    imprecise: false,
    latitude: 37.00048,
    longitude: -94.839,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '66778',
  },
  {
    city: 'Maple City',
    county_fips: 20035,
    county_fips_all: '20035',
    county: 'Cowley',
    county_names_all: 'Cowley',
    county_weights: '{"20035": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 37.03857,
    longitude: -96.78839,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 38,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67102',
  },
  {
    city: 'Mcconnell Afb',
    county_fips: 20173,
    county_fips_all: '20173',
    county: 'Sedgwick',
    county_names_all: 'Sedgwick',
    county_weights: '{"20173": 100}',
    density: 99.5,
    imprecise: false,
    latitude: 37.63544,
    longitude: -97.25819,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 325,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67221',
  },
  {
    city: 'Pierceville',
    county_fips: 20055,
    county_fips_all: '20055',
    county: 'Finney',
    county_names_all: 'Finney',
    county_weights: '{"20055": 100}',
    density: 1.2,
    imprecise: false,
    latitude: 37.82028,
    longitude: -100.71029,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 188,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'KS',
    stateName: 'Kansas',
    zip: '67868',
  },
  {
    city: 'St Columbans',
    county_fips: 31153,
    county_fips_all: '31153',
    county: 'Sarpy',
    county_names_all: 'Sarpy',
    county_weights: '{"31153": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.14123,
    longitude: -95.90438,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NE',
    stateName: 'Nebraska',
    zip: '68056',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.95023,
    longitude: -90.071,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70139',
  },
  {
    city: 'New Orleans',
    county_fips: 22071,
    county_fips_all: '22071',
    county: 'Orleans',
    county_names_all: 'Orleans',
    county_weights: '{"22071": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.94998,
    longitude: -90.07546,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70163',
  },
  {
    city: 'Donner',
    county_fips: 22109,
    county_fips_all: '22109',
    county: 'Terrebonne',
    county_names_all: 'Terrebonne',
    county_weights: '{"22109": 100}',
    density: 16.5,
    imprecise: false,
    latitude: 29.68561,
    longitude: -90.94486,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 167,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70352',
  },
  {
    city: 'Gheens',
    county_fips: 22057,
    county_fips_all: '22057',
    county: 'Lafourche',
    county_names_all: 'Lafourche',
    county_weights: '{"22057": 100}',
    density: 3.4,
    imprecise: false,
    latitude: 29.69491,
    longitude: -90.42916,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 957,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70355',
  },
  {
    city: 'Lake Charles',
    county_fips: 22019,
    county_fips_all: '22019',
    county: 'Calcasieu',
    county_names_all: 'Calcasieu',
    county_weights: '{"22019": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.23107,
    longitude: -93.21864,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70629',
  },
  {
    city: 'Baton Rouge',
    county_fips: 22033,
    county_fips_all: '22033',
    county: 'East Baton Rouge',
    county_names_all: 'East Baton Rouge',
    county_weights: '{"22033": 100}',
    density: 0,
    imprecise: false,
    latitude: 30.45197,
    longitude: -91.18776,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'LA',
    stateName: 'Louisiana',
    zip: '70825',
  },
  {
    city: 'Driver',
    county_fips: 5093,
    county_fips_all: '05093',
    county: 'Mississippi',
    county_names_all: 'Mississippi',
    county_weights: '{"05093": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.62386,
    longitude: -89.97143,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AR',
    stateName: 'Arkansas',
    zip: '72329',
  },
  {
    city: 'Altus Afb',
    county_fips: 40065,
    county_fips_all: '40065',
    county: 'Jackson',
    county_names_all: 'Jackson',
    county_weights: '{"40065": 100}',
    density: 338.6,
    imprecise: false,
    latitude: 34.65526,
    longitude: -99.28527,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 243,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OK',
    stateName: 'Oklahoma',
    zip: '73523',
  },
  {
    city: 'Easton',
    county_fips: 48401,
    county_fips_all: '48401|48183',
    county: 'Rusk',
    county_names_all: 'Rusk|Gregg',
    county_weights: '{"48401": 79.02, "48183": 20.98}',
    density: 19.1,
    imprecise: false,
    latitude: 32.3846,
    longitude: -94.5757,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 83,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '75641',
  },
  {
    city: 'Denton',
    county_fips: 48121,
    county_fips_all: '48121',
    county: 'Denton',
    county_names_all: 'Denton',
    county_weights: '{"48121": 100}',
    density: 44327.3,
    imprecise: false,
    latitude: 33.21213,
    longitude: -97.15181,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 1085,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76203',
  },
  {
    city: 'Waco',
    county_fips: 48309,
    county_fips_all: '48309',
    county: 'McLennan',
    county_names_all: 'McLennan',
    county_weights: '{"48309": 100}',
    density: 9565.4,
    imprecise: false,
    latitude: 31.54606,
    longitude: -97.12085,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 2883,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '76798',
  },
  {
    city: 'Artesia Wells',
    county_fips: 48283,
    county_fips_all: '48283',
    county: 'La Salle',
    county_names_all: 'La Salle',
    county_weights: '{"48283": 100}',
    density: 0,
    imprecise: false,
    latitude: 28.25327,
    longitude: -99.22731,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78001',
  },
  {
    city: 'Peggy',
    county_fips: 48013,
    county_fips_all: '48013',
    county: 'Atascosa',
    county_names_all: 'Atascosa',
    county_weights: '{"48013": 100}',
    density: 0,
    imprecise: false,
    latitude: 28.74599,
    longitude: -98.19711,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78062',
  },
  {
    city: 'Jbsa Randolph',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 0,
    imprecise: false,
    latitude: 29.5381,
    longitude: -98.2815,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78150',
  },
  {
    city: 'San Antonio',
    county_fips: 48029,
    county_fips_all: '48029',
    county: 'Bexar',
    county_names_all: 'Bexar',
    county_weights: '{"48029": 100}',
    density: 139.4,
    imprecise: false,
    latitude: 29.37213,
    longitude: -98.59349,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 232,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78243',
  },
  {
    city: 'Corpus Christi',
    county_fips: 48355,
    county_fips_all: '48355',
    county: 'Nueces',
    county_names_all: 'Nueces',
    county_weights: '{"48355": 100}',
    density: 368.3,
    imprecise: false,
    latitude: 27.69689,
    longitude: -97.26881,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78419',
  },
  {
    city: 'Port Mansfield',
    county_fips: 48489,
    county_fips_all: '48489',
    county: 'Willacy',
    county_names_all: 'Willacy',
    county_weights: '{"48489": 100}',
    density: 14.9,
    imprecise: false,
    latitude: 26.52363,
    longitude: -97.42327,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 245,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78598',
  },
  {
    city: 'Austin',
    county_fips: 48453,
    county_fips_all: '48453',
    county: 'Travis',
    county_names_all: 'Travis',
    county_weights: '{"48453": 100}',
    density: 136.2,
    imprecise: false,
    latitude: 30.28393,
    longitude: -97.73294,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 201,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78712',
  },
  {
    city: 'Catarina',
    county_fips: 48127,
    county_fips_all: '48127',
    county: 'Dimmit',
    county_names_all: 'Dimmit',
    county_weights: '{"48127": 100}',
    density: 0.7,
    imprecise: false,
    latitude: 28.32336,
    longitude: -99.64569,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 155,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78836',
  },
  {
    city: 'Laughlin Afb',
    county_fips: 48465,
    county_fips_all: '48465',
    county: 'Val Verde',
    county_names_all: 'Val Verde',
    county_weights: '{"48465": 100}',
    density: 67.2,
    imprecise: false,
    latitude: 29.34904,
    longitude: -100.79188,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 307,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '78843',
  },
  {
    city: 'Kerrick',
    county_fips: 48111,
    county_fips_all: '48111',
    county: 'Dallam',
    county_names_all: 'Dallam',
    county_weights: '{"48111": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 36.45421,
    longitude: -102.23423,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 9,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79051',
  },
  {
    city: 'Cee Vee',
    county_fips: 48101,
    county_fips_all: '48101',
    county: 'Cottle',
    county_names_all: 'Cottle',
    county_weights: '{"48101": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 34.2317,
    longitude: -100.48085,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 61,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79223',
  },
  {
    city: 'Lubbock',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.58124,
    longitude: -101.84201,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79402',
  },
  {
    city: 'Lubbock',
    county_fips: 48303,
    county_fips_all: '48303',
    county: 'Lubbock',
    county_names_all: 'Lubbock',
    county_weights: '{"48303": 100}',
    density: 3237.2,
    imprecise: false,
    latitude: 33.58336,
    longitude: -101.88082,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 7995,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79406',
  },
  {
    city: 'Fluvanna',
    county_fips: 48033,
    county_fips_all: '48033|48415',
    county: 'Borden',
    county_names_all: 'Borden|Scurry',
    county_weights: '{"48033": 73.06, "48415": 26.94}',
    density: 0.4,
    imprecise: false,
    latitude: 32.87754,
    longitude: -101.24144,
    militaryZip: false,
    timezone: 'America/Chicago',
    population: 210,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79517',
  },
  {
    city: 'Fort Bliss',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 97.8,
    imprecise: false,
    latitude: 31.86268,
    longitude: -106.38912,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 3055,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79916',
  },
  {
    city: 'Fort Bliss',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 13.9,
    imprecise: false,
    latitude: 31.84691,
    longitude: -106.36936,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 274,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79918',
  },
  {
    city: 'El Paso',
    county_fips: 48141,
    county_fips_all: '48141',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"48141": 100}',
    density: 78.6,
    imprecise: false,
    latitude: 31.82261,
    longitude: -106.46037,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 28,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'TX',
    stateName: 'Texas',
    zip: '79920',
  },
  {
    city: 'Denver',
    county_fips: 8031,
    county_fips_all: '08031',
    county: 'Denver',
    county_names_all: 'Denver',
    county_weights: '{"08031": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.79002,
    longitude: -104.90021,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80266',
  },
  {
    city: 'Colorado Springs',
    county_fips: 8041,
    county_fips_all: '08041',
    county: 'El Paso',
    county_names_all: 'El Paso',
    county_weights: '{"08041": 100}',
    density: 106.5,
    imprecise: false,
    latitude: 38.70005,
    longitude: -104.76268,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 6586,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '80913',
  },
  {
    city: 'Chama',
    county_fips: 8023,
    county_fips_all: '08023',
    county: 'Costilla',
    county_names_all: 'Costilla',
    county_weights: '{"08023": 100}',
    density: 19.6,
    imprecise: false,
    latitude: 37.16146,
    longitude: -105.34724,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 506,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81126',
  },
  {
    city: 'Monarch',
    county_fips: 8015,
    county_fips_all: '08015',
    county: 'Chaffee',
    county_names_all: 'Chaffee',
    county_weights: '{"08015": 100}',
    density: 96.6,
    imprecise: false,
    latitude: 38.54934,
    longitude: -106.29009,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81227',
  },
  {
    city: 'Hillside',
    county_fips: 8043,
    county_fips_all: '08043',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"08043": 100}',
    density: 0,
    imprecise: false,
    latitude: 38.27535,
    longitude: -105.60895,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81232',
  },
  {
    city: 'Dinosaur',
    county_fips: 8081,
    county_fips_all: '08081',
    county: 'Moffat',
    county_names_all: 'Moffat',
    county_weights: '{"08081": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.37644,
    longitude: -108.50983,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CO',
    stateName: 'Colorado',
    zip: '81633',
  },
  {
    city: 'Fe Warren Afb',
    county_fips: 56021,
    county_fips_all: '56021',
    county: 'Laramie',
    county_names_all: 'Laramie',
    county_weights: '{"56021": 100}',
    density: 67.7,
    imprecise: false,
    latitude: 41.14631,
    longitude: -104.86787,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 454,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82005',
  },
  {
    city: 'Horse Creek',
    county_fips: 56021,
    county_fips_all: '56021',
    county: 'Laramie',
    county_names_all: 'Laramie',
    county_weights: '{"56021": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.43791,
    longitude: -105.15495,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82061',
  },
  {
    city: 'Weston',
    county_fips: 56005,
    county_fips_all: '56005',
    county: 'Campbell',
    county_names_all: 'Campbell',
    county_weights: '{"56005": 100}',
    density: 0,
    imprecise: false,
    latitude: 44.80203,
    longitude: -105.23982,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 47,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82731',
  },
  {
    city: 'Little America',
    county_fips: 56037,
    county_fips_all: '56037',
    county: 'Sweetwater',
    county_names_all: 'Sweetwater',
    county_weights: '{"56037": 100}',
    density: 2.3,
    imprecise: false,
    latitude: 41.54765,
    longitude: -109.87134,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82929',
  },
  {
    city: 'McKinnon',
    county_fips: 56037,
    county_fips_all: '56037',
    county: 'Sweetwater',
    county_names_all: 'Sweetwater',
    county_weights: '{"56037": 100}',
    density: 0.6,
    imprecise: false,
    latitude: 41.09622,
    longitude: -109.73764,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 221,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '82938',
  },
  {
    city: 'Frontier',
    county_fips: 56023,
    county_fips_all: '56023',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"56023": 100}',
    density: 0,
    imprecise: false,
    latitude: 41.84982,
    longitude: -110.54023,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'WY',
    stateName: 'Wyoming',
    zip: '83121',
  },
  {
    city: 'Macks Inn',
    county_fips: 16043,
    county_fips_all: '16043',
    county: 'Fremont',
    county_names_all: 'Fremont',
    county_weights: '{"16043": 100}',
    density: 9,
    imprecise: false,
    latitude: 44.49284,
    longitude: -111.31788,
    militaryZip: false,
    timezone: 'America/Boise',
    population: 36,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'ID',
    stateName: 'Idaho',
    zip: '83433',
  },
  {
    city: 'Bonanza',
    county_fips: 49047,
    county_fips_all: '49047',
    county: 'Uintah',
    county_names_all: 'Uintah',
    county_weights: '{"49047": 100}',
    density: 0,
    imprecise: false,
    latitude: 40.03341,
    longitude: -109.19376,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84008',
  },
  {
    city: 'Provo',
    county_fips: 49049,
    county_fips_all: '49049',
    county: 'Utah',
    county_names_all: 'Utah',
    county_weights: '{"49049": 100}',
    density: 5143.3,
    imprecise: false,
    latitude: 40.25412,
    longitude: -111.65009,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2340,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'UT',
    stateName: 'Utah',
    zip: '84602',
  },
  {
    city: 'Phoenix',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.44891,
    longitude: -111.97356,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85026',
  },
  {
    city: 'Luke Air Force Base',
    county_fips: 4013,
    county_fips_all: '04013',
    county: 'Maricopa',
    county_names_all: 'Maricopa',
    county_weights: '{"04013": 100}',
    density: 103.7,
    imprecise: false,
    latitude: 33.53556,
    longitude: -112.37637,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 960,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85309',
  },
  {
    city: 'Eden',
    county_fips: 4009,
    county_fips_all: '04009',
    county: 'Graham',
    county_names_all: 'Graham',
    county_weights: '{"04009": 100}',
    density: 4.2,
    imprecise: false,
    latitude: 32.98583,
    longitude: -109.91284,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 42,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85535',
  },
  {
    city: 'Tucson',
    county_fips: 4019,
    county_fips_all: '04019',
    county: 'Pima',
    county_names_all: 'Pima',
    county_weights: '{"04019": 100}',
    density: 54.5,
    imprecise: false,
    latitude: 32.18022,
    longitude: -110.88966,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 581,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '85707',
  },
  {
    city: 'North Rim',
    county_fips: 4005,
    county_fips_all: '04005',
    county: 'Coconino',
    county_names_all: 'Coconino',
    county_weights: '{"04005": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 36.29112,
    longitude: -112.12543,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 161,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86052',
  },
  {
    city: 'Prescott',
    county_fips: 4025,
    county_fips_all: '04025',
    county: 'Yavapai',
    county_names_all: 'Yavapai',
    county_weights: '{"04025": 100}',
    density: 234.3,
    imprecise: false,
    latitude: 34.55416,
    longitude: -112.45288,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 149,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86313',
  },
  {
    city: 'Temple Bar Marina',
    county_fips: 4015,
    county_fips_all: '04015',
    county: 'Mohave',
    county_names_all: 'Mohave',
    county_weights: '{"04015": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.97186,
    longitude: -114.46386,
    militaryZip: false,
    timezone: 'America/Phoenix',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AZ',
    stateName: 'Arizona',
    zip: '86443',
  },
  {
    city: 'Clines Corners',
    county_fips: 35057,
    county_fips_all: '35057',
    county: 'Torrance',
    county_names_all: 'Torrance',
    county_weights: '{"35057": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.02255,
    longitude: -105.74037,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87070',
  },
  {
    city: 'Albuquerque',
    county_fips: 35001,
    county_fips_all: '35001',
    county: 'Bernalillo',
    county_names_all: 'Bernalillo',
    county_weights: '{"35001": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.09669,
    longitude: -106.64339,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87101',
  },
  {
    city: 'Mentmore',
    county_fips: 35031,
    county_fips_all: '35031',
    county: 'McKinley',
    county_names_all: 'McKinley',
    county_weights: '{"35031": 100}',
    density: 5.4,
    imprecise: false,
    latitude: 35.4769,
    longitude: -108.94232,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2496,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87319',
  },
  {
    city: 'Mexican Springs',
    county_fips: 35031,
    county_fips_all: '35031',
    county: 'McKinley',
    county_names_all: 'McKinley',
    county_weights: '{"35031": 100}',
    density: 2.5,
    imprecise: false,
    latitude: 35.80762,
    longitude: -108.87136,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 597,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87320',
  },
  {
    city: 'Vanderwagen',
    county_fips: 35031,
    county_fips_all: '35031',
    county: 'McKinley',
    county_names_all: 'McKinley',
    county_weights: '{"35031": 100}',
    density: 4.1,
    imprecise: false,
    latitude: 35.27223,
    longitude: -108.88765,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2489,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87326',
  },
  {
    city: 'Taos Ski Valley',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 36.5985,
    longitude: -105.49812,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 65,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87525',
  },
  {
    city: 'Ilfeld',
    county_fips: 35047,
    county_fips_all: '35047',
    county: 'San Miguel',
    county_names_all: 'San Miguel',
    county_weights: '{"35047": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 35.49323,
    longitude: -105.53767,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 467,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87538',
  },
  {
    city: 'Llano',
    county_fips: 35055,
    county_fips_all: '35055',
    county: 'Taos',
    county_names_all: 'Taos',
    county_weights: '{"35055": 100}',
    density: 5.9,
    imprecise: false,
    latitude: 36.10399,
    longitude: -105.65781,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 288,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87543',
  },
  {
    city: 'Tererro',
    county_fips: 35047,
    county_fips_all: '35047|35049',
    county: 'San Miguel',
    county_names_all: 'San Miguel|Santa Fe',
    county_weights: '{"35047": 59.03, "35049": 40.97}',
    density: 0.1,
    imprecise: false,
    latitude: 35.77176,
    longitude: -105.70715,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 18,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87573',
  },
  {
    city: 'Miami',
    county_fips: 35007,
    county_fips_all: '35007',
    county: 'Colfax',
    county_names_all: 'Colfax',
    county_weights: '{"35007": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 36.31405,
    longitude: -104.80642,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 96,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87729',
  },
  {
    city: 'Valmora',
    county_fips: 35033,
    county_fips_all: '35033',
    county: 'Mora',
    county_names_all: 'Mora',
    county_weights: '{"35033": 100}',
    density: 0,
    imprecise: false,
    latitude: 35.82498,
    longitude: -104.92704,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '87750',
  },
  {
    city: 'Playas',
    county_fips: 35023,
    county_fips_all: '35023',
    county: 'Hidalgo',
    county_names_all: 'Hidalgo',
    county_weights: '{"35023": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 31.91248,
    longitude: -108.53627,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88009',
  },
  {
    city: 'Arenas Valley',
    county_fips: 35017,
    county_fips_all: '35017',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"35017": 100}',
    density: 45.1,
    imprecise: false,
    latitude: 32.80238,
    longitude: -108.18766,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 1326,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88022',
  },
  {
    city: 'Berino',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 609.5,
    imprecise: false,
    latitude: 32.06539,
    longitude: -106.61803,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 431,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88024',
  },
  {
    city: 'Pinos Altos',
    county_fips: 35017,
    county_fips_all: '35017',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"35017": 100}',
    density: 2.9,
    imprecise: false,
    latitude: 32.89601,
    longitude: -108.21378,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 113,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88053',
  },
  {
    city: 'Redrock',
    county_fips: 35017,
    county_fips_all: '35017',
    county: 'Grant',
    county_names_all: 'Grant',
    county_weights: '{"35017": 100}',
    density: 0,
    imprecise: false,
    latitude: 32.7497,
    longitude: -108.73985,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88055',
  },
  {
    city: 'Vado',
    county_fips: 35013,
    county_fips_all: '35013',
    county: 'Doña Ana',
    county_names_all: 'Doña Ana',
    county_weights: '{"35013": 100}',
    density: 38.6,
    imprecise: false,
    latitude: 32.14242,
    longitude: -106.61329,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 2608,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88072',
  },
  {
    city: 'Cannon Afb',
    county_fips: 35009,
    county_fips_all: '35009',
    county: 'Curry',
    county_names_all: 'Curry',
    county_weights: '{"35009": 100}',
    density: 1.4,
    imprecise: false,
    latitude: 34.38418,
    longitude: -103.31551,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 16,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88103',
  },
  {
    city: 'Crossroads',
    county_fips: 35025,
    county_fips_all: '35025',
    county: 'Lea',
    county_names_all: 'Lea',
    county_weights: '{"35025": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.51026,
    longitude: -103.43052,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 12,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88114',
  },
  {
    city: 'Mcdonald',
    county_fips: 35025,
    county_fips_all: '35025',
    county: 'Lea',
    county_names_all: 'Lea',
    county_weights: '{"35025": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 33.12871,
    longitude: -103.40694,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 20,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88262',
  },
  {
    city: 'Fort Stanton',
    county_fips: 35027,
    county_fips_all: '35027',
    county: 'Lincoln',
    county_names_all: 'Lincoln',
    county_weights: '{"35027": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.48534,
    longitude: -105.56488,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88323',
  },
  {
    city: 'Timberon',
    county_fips: 35035,
    county_fips_all: '35035',
    county: 'Otero',
    county_names_all: 'Otero',
    county_weights: '{"35035": 100}',
    density: 4,
    imprecise: false,
    latitude: 32.6031,
    longitude: -105.67669,
    militaryZip: false,
    timezone: 'America/Denver',
    population: 479,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NM',
    stateName: 'New Mexico',
    zip: '88350',
  },
  {
    city: 'Las Vegas',
    county_fips: 32003,
    county_fips_all: '32003',
    county: 'Clark',
    county_names_all: 'Clark',
    county_weights: '{"32003": 100}',
    density: 894.3,
    imprecise: false,
    latitude: 36.10481,
    longitude: -115.17665,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 533,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89158',
  },
  {
    city: 'Sparks',
    county_fips: 32029,
    county_fips_all: '32029',
    county: 'Storey',
    county_names_all: 'Storey',
    county_weights: '{"32029": 100}',
    density: 0,
    imprecise: false,
    latitude: 39.50101,
    longitude: -119.46864,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'NV',
    stateName: 'Nevada',
    zip: '89437',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 4795.7,
    imprecise: false,
    latitude: 34.06209,
    longitude: -118.31262,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 4850,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90010',
  },
  {
    city: 'Los Angeles',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.9783,
    longitude: -118.25891,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90052',
  },
  {
    city: 'Torrance',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 0,
    imprecise: false,
    latitude: 33.88493,
    longitude: -118.33044,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90506',
  },
  {
    city: 'Long Beach',
    county_fips: 6037,
    county_fips_all: '06037',
    county: 'Los Angeles',
    county_names_all: 'Los Angeles',
    county_weights: '{"06037": 100}',
    density: 221,
    imprecise: false,
    latitude: 33.77825,
    longitude: -118.11871,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 93,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '90822',
  },
  {
    city: 'Camp Pendleton',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 32.2,
    imprecise: false,
    latitude: 33.38123,
    longitude: -117.42874,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10831,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92055',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 779.2,
    imprecise: false,
    latitude: 32.69487,
    longitude: -117.19461,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 849,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92135',
  },
  {
    city: 'San Diego',
    county_fips: 6073,
    county_fips_all: '06073',
    county: 'San Diego',
    county_names_all: 'San Diego',
    county_weights: '{"06073": 100}',
    density: 4862.5,
    imprecise: false,
    latitude: 32.58409,
    longitude: -116.93349,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3150,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '92179',
  },
  {
    city: 'Camp Nelson',
    county_fips: 6107,
    county_fips_all: '06107',
    county: 'Tulare',
    county_names_all: 'Tulare',
    county_weights: '{"06107": 100}',
    density: 7.9,
    imprecise: false,
    latitude: 36.1298,
    longitude: -118.63982,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 157,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93208',
  },
  {
    city: 'San Luis Obispo',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 157.4,
    imprecise: false,
    latitude: 35.30747,
    longitude: -120.66986,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 347,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93407',
  },
  {
    city: 'San Luis Obispo',
    county_fips: 6079,
    county_fips_all: '06079',
    county: 'San Luis Obispo',
    county_names_all: 'San Luis Obispo',
    county_weights: '{"06079": 100}',
    density: 6547.7,
    imprecise: false,
    latitude: 35.30428,
    longitude: -120.65683,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 7396,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93410',
  },
  {
    city: 'Randsburg',
    county_fips: 6029,
    county_fips_all: '06029',
    county: 'Kern',
    county_names_all: 'Kern',
    county_weights: '{"06029": 100}',
    density: 0.1,
    imprecise: false,
    latitude: 35.36914,
    longitude: -117.75876,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 19,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93554',
  },
  {
    city: 'Wishon',
    county_fips: 6039,
    county_fips_all: '06039',
    county: 'Madera',
    county_names_all: 'Madera',
    county_weights: '{"06039": 100}',
    density: 10.7,
    imprecise: false,
    latitude: 37.28334,
    longitude: -119.54297,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 196,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93669',
  },
  {
    city: 'Monterey',
    county_fips: 6053,
    county_fips_all: '06053',
    county: 'Monterey',
    county_names_all: 'Monterey',
    county_weights: '{"06053": 100}',
    density: 19,
    imprecise: false,
    latitude: 36.59736,
    longitude: -121.87332,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 10,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '93943',
  },
  {
    city: 'Moraga',
    county_fips: 6013,
    county_fips_all: '06013',
    county: 'Contra Costa',
    county_names_all: 'Contra Costa',
    county_weights: '{"06013": 100}',
    density: 2338.7,
    imprecise: false,
    latitude: 37.84235,
    longitude: -122.11012,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 975,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94575',
  },
  {
    city: 'Oakland',
    county_fips: 6001,
    county_fips_all: '06001',
    county: 'Alameda',
    county_names_all: 'Alameda',
    county_weights: '{"06001": 100}',
    density: 743.6,
    imprecise: false,
    latitude: 37.78075,
    longitude: -122.18308,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 472,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '94613',
  },
  {
    city: 'Strawberry',
    county_fips: 6109,
    county_fips_all: '06109',
    county: 'Tuolumne',
    county_names_all: 'Tuolumne',
    county_weights: '{"06109": 100}',
    density: 1.6,
    imprecise: false,
    latitude: 38.21493,
    longitude: -119.97031,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 56,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95375',
  },
  {
    city: 'Fort Dick',
    county_fips: 6015,
    county_fips_all: '06015',
    county: 'Del Norte',
    county_names_all: 'Del Norte',
    county_weights: '{"06015": 100}',
    density: 236.3,
    imprecise: false,
    latitude: 41.86833,
    longitude: -124.15433,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 1158,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95538',
  },
  {
    city: 'Capay',
    county_fips: 6113,
    county_fips_all: '06113|06055',
    county: 'Yolo',
    county_names_all: 'Yolo|Napa',
    county_weights: '{"06113": 99.87, "06055": 0.13}',
    density: 1,
    imprecise: false,
    latitude: 38.7899,
    longitude: -122.12585,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 330,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '95607',
  },
  {
    city: 'Beckwourth',
    county_fips: 6063,
    county_fips_all: '06063',
    county: 'Plumas',
    county_names_all: 'Plumas',
    county_weights: '{"06063": 100}',
    density: 1,
    imprecise: false,
    latitude: 39.81848,
    longitude: -120.35346,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 306,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'CA',
    stateName: 'California',
    zip: '96129',
  },
  {
    city: 'Kealia',
    county_fips: 15007,
    county_fips_all: '15007',
    county: 'Kauai',
    county_names_all: 'Kauai',
    county_weights: '{"15007": 100}',
    density: 0,
    imprecise: false,
    latitude: 22.10668,
    longitude: -159.30516,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96751',
  },
  {
    city: 'Jbphh',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 1287.6,
    imprecise: false,
    latitude: 21.335,
    longitude: -157.94032,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 526,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96853',
  },
  {
    city: 'Schofield Barracks',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 2947.4,
    imprecise: false,
    latitude: 21.48798,
    longitude: -158.05293,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 4039,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96857',
  },
  {
    city: 'Fort Shafter',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 7627.3,
    imprecise: false,
    latitude: 21.34459,
    longitude: -157.88342,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 323,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96858',
  },
  {
    city: 'Tripler Army Medical Center',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 0,
    imprecise: false,
    latitude: 21.35987,
    longitude: -157.88985,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96859',
  },
  {
    city: 'Jbphh',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 1947.6,
    imprecise: false,
    latitude: 21.35687,
    longitude: -157.94829,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 4710,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96860',
  },
  {
    city: 'Mcbh Kaneohe Bay',
    county_fips: 15003,
    county_fips_all: '15003',
    county: 'Honolulu',
    county_names_all: 'Honolulu',
    county_weights: '{"15003": 100}',
    density: 1183.2,
    imprecise: false,
    latitude: 21.4351,
    longitude: -157.75002,
    militaryZip: false,
    timezone: 'Pacific/Honolulu',
    population: 2302,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'HI',
    stateName: 'Hawaii',
    zip: '96863',
  },
  {
    city: 'Corvallis',
    county_fips: 41003,
    county_fips_all: '41003',
    county: 'Benton',
    county_names_all: 'Benton',
    county_weights: '{"41003": 100}',
    density: 2618,
    imprecise: false,
    latitude: 44.56343,
    longitude: -123.28113,
    militaryZip: false,
    timezone: 'America/Los_Angeles',
    population: 3693,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'OR',
    stateName: 'Oregon',
    zip: '97331',
  },
  {
    city: 'Anchorage',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 0,
    imprecise: false,
    latitude: 61.21477,
    longitude: -149.88566,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99513',
  },
  {
    city: 'Anchorage',
    county_fips: 2020,
    county_fips_all: '02020',
    county: 'Anchorage',
    county_names_all: 'Anchorage',
    county_weights: '{"02020": 100}',
    density: 0,
    imprecise: false,
    latitude: 61.18465,
    longitude: -149.98356,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99530',
  },
  {
    city: 'Manokotak',
    county_fips: 2070,
    county_fips_all: '02070',
    county: 'Dillingham',
    county_names_all: 'Dillingham',
    county_weights: '{"02070": 100}',
    density: 3.3,
    imprecise: false,
    latitude: 58.9033,
    longitude: -158.90867,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 679,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99628',
  },
  {
    city: 'Nikolski',
    county_fips: 2016,
    county_fips_all: '02016',
    county: 'Aleutians West',
    county_names_all: 'Aleutians West',
    county_weights: '{"02016": 100}',
    density: 0,
    imprecise: false,
    latitude: 53.01329,
    longitude: -168.75359,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 1,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99638',
  },
  {
    city: 'Platinum',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 0.4,
    imprecise: false,
    latitude: 58.97803,
    longitude: -161.71853,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 43,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99651',
  },
  {
    city: 'Quinhagak',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 156.1,
    imprecise: false,
    latitude: 59.74903,
    longitude: -161.89437,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 1311,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99655',
  },
  {
    city: 'Shageluk',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 1.3,
    imprecise: false,
    latitude: 62.66843,
    longitude: -159.56298,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 34,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99665',
  },
  {
    city: 'Tununak',
    county_fips: 2050,
    county_fips_all: '02050',
    county: 'Bethel',
    county_names_all: 'Bethel',
    county_weights: '{"02050": 100}',
    density: 2.4,
    imprecise: false,
    latitude: 60.57902,
    longitude: -165.20767,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 384,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99681',
  },
  {
    city: 'Anchorage',
    county_fips: 2164,
    county_fips_all: '02164',
    county: 'Lake and Peninsula',
    county_names_all: 'Lake and Peninsula',
    county_weights: '{"02164": 100}',
    density: 0,
    imprecise: false,
    latitude: 55.91828,
    longitude: -159.49335,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99695',
  },
  {
    city: 'Kaktovik',
    county_fips: 2185,
    county_fips_all: '02185',
    county: 'North Slope',
    county_names_all: 'North Slope',
    county_weights: '{"02185": 100}',
    density: 8,
    imprecise: false,
    latitude: 70.11882,
    longitude: -143.67029,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 124,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99747',
  },
  {
    city: 'Noatak',
    county_fips: 2188,
    county_fips_all: '02188',
    county: 'Northwest Arctic',
    county_names_all: 'Northwest Arctic',
    county_weights: '{"02188": 100}',
    density: 19.2,
    imprecise: false,
    latitude: 67.6004,
    longitude: -163.03459,
    militaryZip: false,
    timezone: 'America/Nome',
    population: 786,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99761',
  },
  {
    city: 'Stevens Village',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0,
    imprecise: false,
    latitude: 66.0232,
    longitude: -149.07982,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99774',
  },
  {
    city: 'Fairbanks',
    county_fips: 2290,
    county_fips_all: '02290',
    county: 'Yukon-Koyukuk',
    county_names_all: 'Yukon-Koyukuk',
    county_weights: '{"02290": 100}',
    density: 0,
    imprecise: false,
    latitude: 65.42642,
    longitude: -148.18738,
    militaryZip: false,
    timezone: 'America/Anchorage',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99790',
  },
  {
    city: 'Juneau',
    county_fips: 2100,
    county_fips_all: '02100',
    county: 'Haines',
    county_names_all: 'Haines',
    county_weights: '{"02100": 100}',
    density: 0,
    imprecise: false,
    latitude: 58.48821,
    longitude: -135.48432,
    militaryZip: false,
    timezone: 'America/Juneau',
    population: 0,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99850',
  },
  {
    city: 'Meyers Chuck',
    county_fips: 2275,
    county_fips_all: '02275',
    county: 'Wrangell',
    county_names_all: 'Wrangell',
    county_weights: '{"02275": 100}',
    density: 0,
    imprecise: false,
    latitude: 55.73414,
    longitude: -132.10669,
    militaryZip: false,
    timezone: 'America/Sitka',
    population: 1,
    parent_zcta: '',
    zcta: true,
    stateAbbreviation: 'AK',
    stateName: 'Alaska',
    zip: '99903',
  },
];
